
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc28"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc28"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("c62a8", function(module, exports) {
$parcel$export(module.exports, "PreviousInteractionLog", () => $b561ba63cad177b3$export$dbba6cdedab4e68b);
$parcel$export(module.exports, "postInteractionLog", () => $b561ba63cad177b3$export$d8f52e8f804021e8);
$parcel$export(module.exports, "interactionExtraMetrics", () => $b561ba63cad177b3$export$481f88116dc8b7ad);
$parcel$export(module.exports, "segmentUnmountCache", () => $b561ba63cad177b3$export$a2b14406ded37d60);
$parcel$export(module.exports, "getActiveInteraction", () => $b561ba63cad177b3$export$2b3954d2e8509985);
$parcel$export(module.exports, "remove", () => $b561ba63cad177b3$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "updatePageLoadInteractionName", () => $b561ba63cad177b3$export$f6f1cf5bedf83c71);
$parcel$export(module.exports, "addCustomData", () => $b561ba63cad177b3$export$e4380431c2bdabee);
$parcel$export(module.exports, "addSegmentExtraData", () => $b561ba63cad177b3$export$35723c3772fda7dd);
$parcel$export(module.exports, "addIframeSegmentData", () => $b561ba63cad177b3$export$c227d812a1e08d80);
$parcel$export(module.exports, "addCustomTiming", () => $b561ba63cad177b3$export$27cacb7d7f3fe20a);
$parcel$export(module.exports, "addMark", () => $b561ba63cad177b3$export$728e28c22a0fba4);
$parcel$export(module.exports, "markFirstSegmentLoad", () => $b561ba63cad177b3$export$85d1eb835f669bf);
$parcel$export(module.exports, "addSpan", () => $b561ba63cad177b3$export$2c1d6e17cfa9bbc7);
$parcel$export(module.exports, "addSpanToAll", () => $b561ba63cad177b3$export$943a8b2b5d6b1809);
$parcel$export(module.exports, "addHold", () => $b561ba63cad177b3$export$7606887303596f82);
$parcel$export(module.exports, "addHoldByID", () => $b561ba63cad177b3$export$10582acd678c213);
$parcel$export(module.exports, "addCompletedHold", () => $b561ba63cad177b3$export$d6cf9650acfb0dab);
$parcel$export(module.exports, "removeHoldByID", () => $b561ba63cad177b3$export$4983dfbbb996f7ae);
$parcel$export(module.exports, "getCurrentInteractionType", () => $b561ba63cad177b3$export$2df109852219d16e);
$parcel$export(module.exports, "addError", () => $b561ba63cad177b3$export$239c33984d9b1367);
$parcel$export(module.exports, "addErrorToAll", () => $b561ba63cad177b3$export$7379c15afd3840fa);
$parcel$export(module.exports, "addProfilerTimings", () => $b561ba63cad177b3$export$53d6f611de951a13);
$parcel$export(module.exports, "sinkInteractionHandler", () => $b561ba63cad177b3$export$9e614a29a1ac213e);
$parcel$export(module.exports, "sinkPostInteractionLogHandler", () => $b561ba63cad177b3$export$8a1ba7bef607358a);
$parcel$export(module.exports, "tryComplete", () => $b561ba63cad177b3$export$673be905888f8839);
$parcel$export(module.exports, "abort", () => $b561ba63cad177b3$export$5def58af4fd46132);
$parcel$export(module.exports, "abortByNewInteraction", () => $b561ba63cad177b3$export$c4a545284f55edf2);
$parcel$export(module.exports, "abortAll", () => $b561ba63cad177b3$export$614a7af2affc5dff);
$parcel$export(module.exports, "addOnCancelCallback", () => $b561ba63cad177b3$export$7b9261a96cfe427b);
$parcel$export(module.exports, "addNewInteraction", () => $b561ba63cad177b3$export$1a1ed1e1fdb2006b);
$parcel$export(module.exports, "addBrowserMetricEvent", () => $b561ba63cad177b3$export$4a759336b50e86e3);
$parcel$export(module.exports, "addApdex", () => $b561ba63cad177b3$export$35220fd6cdd1b731);
$parcel$export(module.exports, "addRequestInfo", () => $b561ba63cad177b3$export$57d55b4569823d8f);
$parcel$export(module.exports, "addSegment", () => $b561ba63cad177b3$export$1c43f9ac826b6462);
$parcel$export(module.exports, "removeSegment", () => $b561ba63cad177b3$export$d0365e48b58231c3);
$parcel$export(module.exports, "interactionSpans", () => $b561ba63cad177b3$export$6ce04c7ca6810a7e);
$parcel$export(module.exports, "addCustomSpans", () => $b561ba63cad177b3$export$5342dcad19138a1c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2OOKU = parcelRequire("2OOKU");

var $3H4LK = parcelRequire("3H4LK");

var $4Bdcb = parcelRequire("4Bdcb");

var $2zDxj = parcelRequire("2zDxj");

var $jFknK = parcelRequire("jFknK");

var $6FNES = parcelRequire("6FNES");

var $j58cX = parcelRequire("j58cX");

var $bqHVm = parcelRequire("bqHVm");

var $lLCH0 = parcelRequire("lLCH0");

var $87Bg8 = parcelRequire("87Bg8");

var $dlWlx = parcelRequire("dlWlx");

var $1h62Q = parcelRequire("1h62Q");

var $5XOna = parcelRequire("5XOna");

var $c96yR = parcelRequire("c96yR");

var $hGTo0 = parcelRequire("hGTo0");

var $jxNQh = parcelRequire("jxNQh");
const $b561ba63cad177b3$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
const $b561ba63cad177b3$export$d8f52e8f804021e8 = new (0, $jxNQh.default)();
const $b561ba63cad177b3$export$481f88116dc8b7ad = new (0, $hGTo0.default)();
const $b561ba63cad177b3$var$interactionQueue = [];
const $b561ba63cad177b3$var$segmentCache = new Map();
const $b561ba63cad177b3$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
let $b561ba63cad177b3$var$firstSegmentLoadMarked = false;
const $b561ba63cad177b3$var$segmentObservers = [];
function $b561ba63cad177b3$export$2b3954d2e8509985() {
    const interactionId = (0, $87Bg8.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $c96yR.interactions).get(interactionId.current);
}
function $b561ba63cad177b3$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $jFknK.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
let $b561ba63cad177b3$var$performanceEventObserver;
const $b561ba63cad177b3$export$17afbba0f16b4b19 = ()=>{
    $b561ba63cad177b3$var$performanceEventObserver = $b561ba63cad177b3$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $b561ba63cad177b3$export$e6be05b411ce21a6(entry);
    });
    return $b561ba63cad177b3$var$performanceEventObserver;
};
const $b561ba63cad177b3$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = $b561ba63cad177b3$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        const responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $b561ba63cad177b3$var$labelStackToString(labelStack, name) {
    var _stack$map;
    const stack = [
        ...labelStack ?? []
    ];
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map((l)=>l.name)) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
}
function $b561ba63cad177b3$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map((l)=>'segmentId' in l ? `${l.name}:${l.segmentId}` : `${l.name}`)) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
}
function $b561ba63cad177b3$var$addSegmentObserver(observer) {
    $b561ba63cad177b3$var$segmentObservers.push(observer);
    for (const segmentInfo of $b561ba63cad177b3$var$segmentCache.values())observer.onAdd(segmentInfo);
}
function $b561ba63cad177b3$var$removeSegmentObserver(observer) {
    const index = $b561ba63cad177b3$var$segmentObservers.findIndex((obs)=>obs === observer);
    if (index !== -1) $b561ba63cad177b3$var$segmentObservers.splice(index, 1);
}
function $b561ba63cad177b3$export$cd7f480d6b8286c3(interactionId) {
    (0, $c96yR.interactions).delete(interactionId);
}
function $b561ba63cad177b3$export$f6f1cf5bedf83c71(ufoName, routeName = ufoName) {
    const interaction = $b561ba63cad177b3$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $b561ba63cad177b3$export$12f2b6cb85d59904(interactionId, data) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((key)=>{
        interaction.metaData[key] = data[key];
    });
}
function $b561ba63cad177b3$export$e4380431c2bdabee(interactionId, labelStack, data) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach((i)=>{
        interaction.customData.push({
            labelStack: labelStack,
            data: {
                [i]: data[i]
            }
        });
    });
}
function $b561ba63cad177b3$export$35723c3772fda7dd(interactionId, segmentId, data) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        if (!interaction.segmentExtraData) interaction.segmentExtraData = {};
        interaction.segmentExtraData[segmentId] = {
            ...interaction.segmentExtraData[segmentId],
            ...data
        };
    }
}
/**
 * Builds a stable cross-segment dedup key for a segment3pTimings entry.
 *
 * For `resource-timing`, query-stripped backend labels + timing fields identify a request without
 * depending on query parameters. Shared CSS/JS asset timings dedupe across segments, but backend
 * fetch/XHR entries are scoped by `segmentId` because each iframe can make its own backend request
 * to the same URL.
 *
 * For all other labels the data objects are small (a handful of fields), so we use a full
 * JSON fingerprint which is cheap and collision-free.
 */ function $b561ba63cad177b3$var$buildCrossSegmentDedupKey(entry, segmentId) {
    if (entry.label === 'resource-timing') {
        const { label: resourceLabel, startTime: startTime, duration: duration, requestStart: requestStart, fetchStart: fetchStart, ttfb: ttfb, type: type } = entry.data;
        if ((0, $dlWlx.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(String(type))) // Backend calls are separate requests per segment; include extra timings and segment scope.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}|${fetchStart}|${requestStart}|${ttfb}|${segmentId}`;
        // Shared CSS/JS assets keep the original B3 key so they can dedupe across segments.
        return `resource-timing|${resourceLabel}|${startTime}|${duration}`;
    }
    return `${entry.label}|${JSON.stringify(entry.data)}`;
}
function $b561ba63cad177b3$export$c227d812a1e08d80(interactionId, segmentId, entry) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null && (0, $3H4LK.fg)('platform_ufo_3p_segment_timings')) {
        // B3: dedup by content — drops identical entries within and across iframes.
        // Abort markers are excluded so every segment's abort is recorded.
        if (entry.label !== 'segment-timing-abort') {
            if (!interaction.segment3pCrossSegmentSeen) interaction.segment3pCrossSegmentSeen = new Set();
            const key = $b561ba63cad177b3$var$buildCrossSegmentDedupKey(entry, segmentId);
            if (interaction.segment3pCrossSegmentSeen.has(key)) return;
            interaction.segment3pCrossSegmentSeen.add(key);
        }
        if (!interaction.segment3pTimings) interaction.segment3pTimings = {};
        if (!interaction.segment3pTimings[segmentId]) interaction.segment3pTimings[segmentId] = [];
        interaction.segment3pTimings[segmentId].push(entry);
    }
}
function $b561ba63cad177b3$export$20265b12c6625451(interactionId, key, value) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== 'number' && typeof value !== 'boolean' && typeof value !== 'string') return;
    // Validate string length (max 50 characters)
    if (typeof value === 'string' && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $b561ba63cad177b3$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        const sanitizedData = Object.fromEntries(Object.entries(data).map(([key, timingData])=>[
                (0, $2zDxj.sanitizeTimingName)(key),
                timingData
            ]));
        interaction.customTimings.push({
            labelStack: labelStack,
            data: sanitizedData
        });
        if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) for (const [key, timingData] of Object.entries(sanitizedData)){
            const { startTime: startTime, endTime: endTime } = timingData;
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack, key)} [custom_timing]`, {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
function $b561ba63cad177b3$export$728e28c22a0fba4(interactionId, type, name, labelStack, time = performance.now()) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b561ba63cad177b3$export$85d1eb835f669bf(interactionId, labelStack, time = performance.now()) {
    if (!(0, $3H4LK.fg)('platform_mark_ufo_segment_first_load')) return;
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null && !$b561ba63cad177b3$var$firstSegmentLoadMarked) {
        $b561ba63cad177b3$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: 'first_segment_load',
            name: 'first_segment_load',
            labelStack: labelStack,
            time: time
        });
    }
}
function $b561ba63cad177b3$export$c4b23cc624bd2fb(type, name, labelStack, time = performance.now()) {
    (0, $c96yR.interactions).forEach((interaction)=>{
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) performance.mark(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack, name)} [${type}]`, {
        startTime: time
    });
}
function $b561ba63cad177b3$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start, end = performance.now(), size) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack, name)} [${type}]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
}
function $b561ba63cad177b3$export$943a8b2b5d6b1809(type, name, labelStack, start, end = performance.now(), size = 0) {
    (0, $c96yR.interactions).forEach((interaction)=>{
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack, name)} [${type}]`, {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary'
                }
            }
        });
    } catch  {
    // do nothing
    }
}
function $b561ba63cad177b3$export$9e04fe1a58571ec(moduleId, timestamp) {
    $b561ba63cad177b3$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
}
function $b561ba63cad177b3$export$6f228d1fdc911d7(identifier, start, end) {
    $b561ba63cad177b3$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
}
const $b561ba63cad177b3$var$moduleLoadingRequests = {};
function $b561ba63cad177b3$export$f5a8f10de74904da(input) {
    let result = input ?? '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
}
function $b561ba63cad177b3$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $b561ba63cad177b3$var$labelStackToString(labelStack), name, startTime);
}
function $b561ba63cad177b3$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $b561ba63cad177b3$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $2OOKU.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $b561ba63cad177b3$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ($b561ba63cad177b3$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $b561ba63cad177b3$var$ensureExtendedHoldActive(interaction).set(id, {
            ...holdActive,
            start: start
        });
        else {
            interaction.holdActive.set(id, {
                ...holdActive,
                start: start
            });
            $b561ba63cad177b3$var$addHoldCriterion(id, labelStack, name, start);
        }
        return ()=>{
            const end = performance.now();
            if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack, name)} [hold]`, {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'secondary-light'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
            $b561ba63cad177b3$var$removeHoldCriterion(id);
            const currentInteraction = (0, $c96yR.interactions).get(interactionId);
            const currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push({
                        ...currentHold,
                        end: end
                    });
                    interaction.holdActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    const current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push({
                            ...current3pHold,
                            end: end
                        });
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return ()=>{};
}
function $b561ba63cad177b3$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        const start = performance.now();
        const holdActive = {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        };
        if ($b561ba63cad177b3$var$shouldMoveHoldToExtendedBucket(interaction, holdActive)) $b561ba63cad177b3$var$ensureExtendedHoldActive(interaction).set(id, holdActive);
        else {
            interaction.holdActive.set(id, holdActive);
            $b561ba63cad177b3$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return ()=>{};
}
function $b561ba63cad177b3$export$d6cf9650acfb0dab(interactionId, labelStack, name, start, end) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) $b561ba63cad177b3$var$ensureExtendedHoldInfo(interaction).push({
        labelStack: labelStack,
        name: name,
        start: start,
        end: end
    });
}
function $b561ba63cad177b3$export$4983dfbbb996f7ae(interactionId, id) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        const end = performance.now();
        const currentInteraction = (0, $c96yR.interactions).get(interactionId);
        const currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            if ($b561ba63cad177b3$var$shouldMoveHoldToExtendedBucket(currentInteraction, currentHold)) $b561ba63cad177b3$var$ensureExtendedHoldInfo(currentInteraction).push({
                ...currentHold,
                end: end
            });
            else currentInteraction.holdInfo.push({
                ...currentHold,
                end: end
            });
            interaction.holdActive.delete(id);
            $b561ba63cad177b3$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            const current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push({
                    ...current3pHold,
                    end: end
                });
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $b561ba63cad177b3$export$2df109852219d16e(interactionId) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
const $b561ba63cad177b3$export$9591b52b33ccc510 = {
    onPreload (moduleId, _priority) {
        $b561ba63cad177b3$export$9e04fe1a58571ec($b561ba63cad177b3$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart (info) {
        const timeoutId = setTimeout(()=>{
            delete $b561ba63cad177b3$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        const request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $b561ba63cad177b3$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete (info) {
        const request = $b561ba63cad177b3$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $b561ba63cad177b3$var$moduleLoadingRequests[info.identifier];
            $b561ba63cad177b3$export$6f228d1fdc911d7($b561ba63cad177b3$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted (id, moduleId) {
        const interactionId = (0, $87Bg8.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b561ba63cad177b3$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted (id) {
        const interactionId = (0, $87Bg8.getInteractionId)();
        const currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $b561ba63cad177b3$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $b561ba63cad177b3$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $b561ba63cad177b3$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $c96yR.interactions).forEach((interaction)=>{
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $b561ba63cad177b3$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack)} [react-profiler] ${type}`, {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: 'secondary-dark'
                }
            }
        });
    } catch  {
    // do nothing
    }
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $jFknK.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $b561ba63cad177b3$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $b561ba63cad177b3$var$pushToQueue(id, data) {
    $b561ba63cad177b3$var$interactionQueue.push({
        id: id,
        data: data
    });
}
let $b561ba63cad177b3$var$handleInteraction = $b561ba63cad177b3$var$pushToQueue;
function $b561ba63cad177b3$var$shouldMoveHoldToExtendedBucket(interaction, hold) {
    const isExplicitlyThirdParty = hold.labelStack.some((label)=>'type' in label && label.type === 'third-party');
    return isExplicitlyThirdParty || interaction.end !== 0 && hold.start > interaction.end && (0, $3H4LK.fg)('platform_ufo_metric_variants');
}
function $b561ba63cad177b3$var$ensureExtendedHoldActive(interaction) {
    interaction.hold3pActive = interaction.hold3pActive ?? new Map();
    return interaction.hold3pActive;
}
function $b561ba63cad177b3$var$ensureExtendedHoldInfo(interaction) {
    interaction.hold3pInfo = interaction.hold3pInfo ?? [];
    return interaction.hold3pInfo;
}
function $b561ba63cad177b3$var$moveLateActiveHoldsToExtendedBucket(interaction) {
    if (!(0, $3H4LK.fg)('platform_ufo_metric_variants') || interaction.end === 0) return;
    const holdsToMove = [
        ...interaction.holdActive.entries()
    ].filter(([, hold])=>$b561ba63cad177b3$var$shouldMoveHoldToExtendedBucket(interaction, hold));
    holdsToMove.forEach(([id, hold])=>{
        $b561ba63cad177b3$var$ensureExtendedHoldActive(interaction).set(id, hold);
        interaction.holdActive.delete(id);
    });
}
function $b561ba63cad177b3$var$ensureMetricWindows(interaction) {
    if (!(0, $3H4LK.fg)('platform_ufo_metric_variants')) return;
    if (interaction.end === 0) return;
    interaction.metricWindows = {
        ...interaction.metricWindows,
        standard: {
            start: interaction.start,
            end: interaction.end,
            includeCategories: [],
            excludeCategories: [
                'third-party'
            ]
        }
    };
    if (interaction.end3p !== undefined) interaction.metricWindows['include-third-party'] = {
        start: interaction.start,
        end: interaction.end3p,
        includeCategories: [
            'third-party'
        ],
        excludeCategories: []
    };
}
function $b561ba63cad177b3$var$addLifecycleObservation(interaction, observation) {
    if (!(0, $3H4LK.fg)('platform_ufo_metric_variants')) return;
    interaction.lifecycleObservations = interaction.lifecycleObservations ?? [];
    interaction.lifecycleObservations.push(observation);
}
function $b561ba63cad177b3$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach((cleanUpCallback)=>{
        cleanUpCallback();
    });
}
function $b561ba63cad177b3$var$finishInteraction(id, data, endTime = performance.now()) {
    data.end = endTime;
    $b561ba63cad177b3$var$ensureMetricWindows(data);
    try {
        // for Firefox 102 and older
        performance.measure(`\u{1F6F8} [${data.type}] ${data.ufoName} [ttai]`, {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: 'main metrics',
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: 'tertiary'
                }
            }
        });
        performance.mark(`TTAI`, {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: 'marker'
                }
            }
        });
    } catch  {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $lLCH0.currentFeatureFlagsAccessed));
    (0, $bqHVm.clearActiveTrace)();
    $b561ba63cad177b3$var$callCleanUpCallbacks(data);
    (0, $1h62Q.flushSsrRenderProfilerTraces)();
    if (data.type === 'page_load') data.hydration = (0, $jFknK.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    const sanitisedUfoName = (0, $j58cX.sanitizeUfoName)(data.ufoName);
    if (!(0, $4Bdcb.default)((0, $jFknK.getPostInteractionRate)(sanitisedUfoName, data.type))) $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
    if (!(0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$cd7f480d6b8286c3(id);
    else if (!(0, $4Bdcb.default)((0, $jFknK.getExtraInteractionRate)(sanitisedUfoName, data.type))) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) $b561ba63cad177b3$export$cd7f480d6b8286c3(id);
    $b561ba63cad177b3$export$dbba6cdedab4e68b.id = data.id;
    $b561ba63cad177b3$export$dbba6cdedab4e68b.type = data.type;
    $b561ba63cad177b3$export$dbba6cdedab4e68b.timestamp = data.end;
    $b561ba63cad177b3$export$dbba6cdedab4e68b.name = data.ufoName || 'unknown';
    $b561ba63cad177b3$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) {
        var _interactionExtraMetr;
        if (!(0, $jFknK.isInteractionExtraMetricsEnabled)() || ((_interactionExtraMetr = $b561ba63cad177b3$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr === void 0 ? void 0 : _interactionExtraMetr.id) !== id) // If this same interaction was not already handled, handle it
        $b561ba63cad177b3$var$handleInteraction(id, data);
    }
    if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) {
        const profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach((profilerTiming)=>{
            const labelStackId = $b561ba63cad177b3$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                const timing = profilerTimingMap.get(labelStackId) ?? {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < (timing.start ?? Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > (timing.end ?? Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            for (const [, { labelStack: labelStack, start: start, end: end }] of profilerTimingMap.entries())performance.measure(`\u{1F6F8} ${$b561ba63cad177b3$var$labelStackToString(labelStack)} [segment_ttai]`, {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: 'secondary-dark'
                    }
                }
            });
        } catch  {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch  {
    // do nothing
    }
}
function $b561ba63cad177b3$export$9e614a29a1ac213e(sinkFn) {
    if ($b561ba63cad177b3$var$handleInteraction === $b561ba63cad177b3$var$pushToQueue) {
        $b561ba63cad177b3$var$handleInteraction = sinkFn;
        $b561ba63cad177b3$var$interactionQueue.forEach((interaction)=>{
            sinkFn(interaction.id, interaction.data);
        });
        $b561ba63cad177b3$var$interactionQueue.length = 0;
    }
}
function $b561ba63cad177b3$export$8a1ba7bef607358a(sinkFn) {
    $b561ba63cad177b3$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
let $b561ba63cad177b3$var$activeSubmitted = false;
function $b561ba63cad177b3$export$673be905888f8839(interactionId, endTime) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc;
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const shouldUseRawDataThirdParty = (0, $jFknK.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const postInteraction = async ()=>{
            var _getConfig3;
            if ((_getConfig3 = (0, $jFknK.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $b561ba63cad177b3$export$d8f52e8f804021e8.onInteractionComplete(interaction);
            $b561ba63cad177b3$var$activeSubmitted = false;
        };
        const noMoreActive3pHolds = ((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.size) === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                $b561ba63cad177b3$var$moveLateActiveHoldsToExtendedBucket(interaction);
                $b561ba63cad177b3$var$ensureMetricWindows(interaction);
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!$b561ba63cad177b3$var$activeSubmitted) {
                    var _getConfig4, _getConfig5;
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    const currentTime = endTime ?? performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $b561ba63cad177b3$var$ensureMetricWindows(interaction);
                    $b561ba63cad177b3$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig4 = (0, $jFknK.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.extraSearchPageInteraction) !== null && _getConfig4 !== void 0 && _getConfig4.enabled && interaction.ufoName === ((_getConfig5 = (0, $jFknK.getConfig)()) === null || _getConfig5 === void 0 || (_getConfig5 = _getConfig5.extraSearchPageInteraction) === null || _getConfig5 === void 0 ? void 0 : _getConfig5.searchPageMetricName)) (0, $6FNES.onSearchPageInteractionComplete)(interactionId, interaction);
                    $b561ba63cad177b3$var$activeSubmitted = true;
                }
                postInteraction();
            }
            // Send separated third-party event when extra interaction metrics is enabled
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)() && noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime || interaction.end
                };
                $b561ba63cad177b3$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else {
            var _interactionExtraMetr2;
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && (!(0, $jFknK.isInteractionExtraMetricsEnabled)() || ((_interactionExtraMetr2 = $b561ba63cad177b3$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr2 === void 0 ? void 0 : _interactionExtraMetr2.id) !== interactionId)) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$b561ba63cad177b3$var$activeSubmitted) {
                    var _getConfig6, _getConfig7;
                    $b561ba63cad177b3$var$finishInteraction(interactionId, interaction, endTime);
                    if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig6 = (0, $jFknK.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.extraSearchPageInteraction) !== null && _getConfig6 !== void 0 && _getConfig6.enabled && interaction.ufoName === ((_getConfig7 = (0, $jFknK.getConfig)()) === null || _getConfig7 === void 0 || (_getConfig7 = _getConfig7.extraSearchPageInteraction) === null || _getConfig7 === void 0 ? void 0 : _getConfig7.searchPageMetricName)) (0, $6FNES.onSearchPageInteractionComplete)(interactionId, interaction);
                    $b561ba63cad177b3$var$activeSubmitted = true;
                }
                postInteraction();
            }
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)() && noMoreActiveHolds && noMoreActive3pHolds) {
                const data = {
                    ...interaction,
                    end: endTime
                };
                $b561ba63cad177b3$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        }
    }
}
function $b561ba63cad177b3$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach((cancelCallback)=>{
        cancelCallback();
    });
}
function $b561ba63cad177b3$export$5def58af4fd46132(interactionId, abortReason) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc3;
        const shouldUseRawDataThirdParty = (0, $jFknK.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var _interaction$hold3pAc2;
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $b561ba63cad177b3$var$addLifecycleObservation(interaction, {
                type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
                timestamp: interaction.end3p,
                activeHoldCount: ((_interaction$hold3pAc2 = interaction.hold3pActive) === null || _interaction$hold3pAc2 === void 0 ? void 0 : _interaction$hold3pAc2.size) ?? 0
            });
            $b561ba63cad177b3$var$ensureMetricWindows(interaction);
            $b561ba63cad177b3$var$finishInteraction(interactionId, interaction, endTime);
            $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
            $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(interactionId);
            return;
        }
        $b561ba63cad177b3$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $b561ba63cad177b3$var$addLifecycleObservation(interaction, {
            type: abortReason === 'timeout' ? 'timeout_expired' : 'page_unloaded',
            timestamp: performance.now(),
            activeHoldCount: interaction.holdActive.size + (((_interaction$hold3pAc3 = interaction.hold3pActive) === null || _interaction$hold3pAc3 === void 0 ? void 0 : _interaction$hold3pAc3.size) ?? 0)
        });
        $b561ba63cad177b3$var$finishInteraction(interactionId, interaction);
        $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
        $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(interactionId);
    }
}
function $b561ba63cad177b3$export$c4a545284f55edf2(interactionId, interactionName) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        const shouldUseRawDataThirdParty = (0, $jFknK.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $b561ba63cad177b3$var$addLifecycleObservation(interaction, {
                type: 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: interactionName
            });
            $b561ba63cad177b3$var$ensureMetricWindows(interaction);
            $b561ba63cad177b3$var$finishInteraction(interactionId, interaction, endTime);
            $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
            $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(interactionId);
            return;
        }
        $b561ba63cad177b3$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $b561ba63cad177b3$var$addLifecycleObservation(interaction, {
            type: 'new_interaction_started',
            timestamp: performance.now(),
            triggerName: interactionName
        });
        $b561ba63cad177b3$var$finishInteraction(interactionId, interaction);
        $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
        $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(interactionId);
    } else if ((0, $3H4LK.fg)('platform_reset_post_interaction_on_new_interaction')) {
        // post-interaction log is active after interaction is aborted by new one
        $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
        $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $b561ba63cad177b3$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    const activeInteraction = $b561ba63cad177b3$export$2b3954d2e8509985();
    const finishInteractions = (0, $jFknK.getFinishInteractionOnTransition)();
    (0, $c96yR.interactions).forEach((interaction, interactionId)=>{
        const isActiveInteraction = activeInteraction === interaction;
        let hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === 'transition' && interaction.type === 'press' && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        const shouldUseRawDataThirdParty = (0, $jFknK.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        const noMoreActiveHolds = interaction.holdActive.size === 0;
        const has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            const endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $b561ba63cad177b3$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: interaction.end3p,
                triggerName: abortedByInteractionName
            });
            $b561ba63cad177b3$var$ensureMetricWindows(interaction);
            $b561ba63cad177b3$var$finishInteraction(interactionId, interaction, endTime);
            $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
            $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(interactionId);
            return;
        }
        if (!hasFinished) {
            $b561ba63cad177b3$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
            $b561ba63cad177b3$var$addLifecycleObservation(interaction, {
                type: abortReason === 'transition' ? 'transition_started' : 'new_interaction_started',
                timestamp: performance.now(),
                triggerName: abortedByInteractionName
            });
        }
        $b561ba63cad177b3$var$finishInteraction(interactionId, interaction);
        $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
        $b561ba63cad177b3$export$d8f52e8f804021e8.stopVCObserver();
        if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.stopAll(interactionId);
    });
}
function $b561ba63cad177b3$export$7b9261a96cfe427b(id, cancelCallback) {
    const interaction = (0, $c96yR.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $b561ba63cad177b3$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName, trace = null) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.reset();
    $b561ba63cad177b3$export$d8f52e8f804021e8.reset();
    let vcObserver;
    let previousTime = startTime;
    let timeoutTime = (0, $jFknK.getInteractionTimeout)(ufoName);
    const timerID = setTimeout(()=>{
        $b561ba63cad177b3$export$5def58af4fd46132(interactionId, 'timeout');
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        const currentTime = performance.now();
        const timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        const newTimerID = setTimeout(()=>{
            $b561ba63cad177b3$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    const addFeatureFlagsToInteraction = (0, $4Bdcb.default)((0, $jFknK.getCapabilityRate)('feature_flag_access'));
    const config = (0, $jFknK.getConfig)();
    const searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $jFknK.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $5XOna.newVCObserver)(vcOptions);
    }
    const priorAccessedFg = type === 'press' ? {} : Object.fromEntries((0, $lLCH0.allFeatureFlagsAccessed));
    const metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $b561ba63cad177b3$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $b561ba63cad177b3$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName ?? ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $lLCH0.currentFeatureFlagsAccessed).clear();
    (0, $c96yR.interactions).set(interactionId, metrics);
    const segmentObserver = {
        onAdd (segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove () {}
    };
    $b561ba63cad177b3$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(()=>{
        $b561ba63cad177b3$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(()=>{
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(()=>{
        vcObserver.stop(ufoName);
    });
    const awaitBM3TTIList = (0, $jFknK.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $b561ba63cad177b3$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition' || type === 'page_load') {
        var _getConfig8;
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig8 = (0, $jFknK.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.postInteractionLog) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $b561ba63cad177b3$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) $b561ba63cad177b3$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === 'press') {
        // Use per-interaction VC observer if available, otherwise fall back to global
        const observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $b561ba63cad177b3$export$4a759336b50e86e3(event) {
    const interaction = $b561ba63cad177b3$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') $b561ba63cad177b3$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $b561ba63cad177b3$export$ad216cc25852d44b(apdex) {
    (0, $c96yR.interactions).forEach((interaction, key)=>{
        interaction.apdex.push(apdex);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdex.key} [bm3_tti]`, {
                start: apdex.startTime ?? interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $b561ba63cad177b3$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $b561ba63cad177b3$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            // for Firefox 102 and older
            performance.measure(`\u{1F6F8} ${apdexInfo.key} [bm3_tti]`, {
                start: apdexInfo.startTime ?? interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: 'main metrics',
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'primary-dark'
                    }
                }
            });
            performance.mark(`[bm3] TTI`, {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: 'marker'
                    }
                }
            });
        } catch  {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') $b561ba63cad177b3$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $b561ba63cad177b3$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push({
        labelStack: labelStack,
        ...requestInfo
    });
}
function $b561ba63cad177b3$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $b561ba63cad177b3$var$getSegmentCacheKey(labelStack) {
    return labelStack.map((l)=>{
        if ($b561ba63cad177b3$var$isSegmentLabel(l)) return `${l.name}_${l.segmentId}`;
        return l.name;
    }).join('|');
}
function $b561ba63cad177b3$export$1c43f9ac826b6462(labelStack) {
    const key = $b561ba63cad177b3$var$getSegmentCacheKey(labelStack);
    const existingSegment = $b561ba63cad177b3$var$segmentCache.get(key);
    if (!existingSegment) {
        const segmentInfo = {
            labelStack: labelStack
        };
        $b561ba63cad177b3$var$segmentCache.set(key, segmentInfo);
        $b561ba63cad177b3$var$segmentObservers.forEach((observer)=>{
            observer.onAdd(segmentInfo);
        });
    }
}
function $b561ba63cad177b3$export$d0365e48b58231c3(labelStack) {
    const key = $b561ba63cad177b3$var$getSegmentCacheKey(labelStack);
    const segmentInfo = $b561ba63cad177b3$var$segmentCache.get(key);
    if (segmentInfo) {
        $b561ba63cad177b3$var$segmentCache.delete(JSON.stringify(labelStack));
        const cacheKey = (0, $j58cX.stringifyLabelStackFully)(labelStack);
        $b561ba63cad177b3$export$a2b14406ded37d60.set(cacheKey, ($b561ba63cad177b3$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $b561ba63cad177b3$var$segmentObservers.forEach((observer)=>{
            observer.onRemove(segmentInfo);
        });
    }
}
function $b561ba63cad177b3$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    const interaction = (0, $c96yR.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($b561ba63cad177b3$var$isPerformanceTracingEnabled()) {
            const prevRedirect = interaction.redirects.at(-2);
            try {
                // for Firefox 102 and older
                performance.measure(`\u{1F6F8} ${nextUfoName} [redirect]`, {
                    start: (prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) ?? interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: 'tertiary'
                        }
                    }
                });
            } catch  {
            // do nothing
            }
        }
    }
}
const $b561ba63cad177b3$export$6ce04c7ca6810a7e = [];
const $b561ba63cad177b3$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
function $b561ba63cad177b3$export$5342dcad19138a1c(name, start, end = performance.now(), size = 0, labelStack = $b561ba63cad177b3$var$defaultLabelStack) {
    const customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $b561ba63cad177b3$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("2OOKU", function(module, exports) {

var $kwc2r = parcelRequire("kwc2r");

var $3izZW = parcelRequire("3izZW");
var $20d79f4b4e8699ea$var$uuid = $3izZW;
$20d79f4b4e8699ea$var$uuid.v1 = $kwc2r;
$20d79f4b4e8699ea$var$uuid.v4 = $3izZW;
module.exports = $20d79f4b4e8699ea$var$uuid;

});
parcelRegister("kwc2r", function(module, exports) {

var $hJb6S = parcelRequire("hJb6S");

var $acoE7 = parcelRequire("acoE7");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $ef00225c0bfb9712$var$_nodeId;
var $ef00225c0bfb9712$var$_clockseq;
// Previous uuid creation time
var $ef00225c0bfb9712$var$_lastMSecs = 0;
var $ef00225c0bfb9712$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $ef00225c0bfb9712$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $ef00225c0bfb9712$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $ef00225c0bfb9712$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $hJb6S();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $ef00225c0bfb9712$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $ef00225c0bfb9712$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $ef00225c0bfb9712$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $ef00225c0bfb9712$var$_lastMSecs + (nsecs - $ef00225c0bfb9712$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $ef00225c0bfb9712$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $ef00225c0bfb9712$var$_lastMSecs = msecs;
    $ef00225c0bfb9712$var$_lastNSecs = nsecs;
    $ef00225c0bfb9712$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $acoE7(b);
}
module.exports = $ef00225c0bfb9712$var$v1;

});
parcelRegister("hJb6S", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $ce7f41d78aefd93c$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($ce7f41d78aefd93c$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $ce7f41d78aefd93c$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $ce7f41d78aefd93c$var$getRandomValues($ce7f41d78aefd93c$var$rnds8);
        return $ce7f41d78aefd93c$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $ce7f41d78aefd93c$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $ce7f41d78aefd93c$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $ce7f41d78aefd93c$var$rnds;
    };
}

});

parcelRegister("acoE7", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $76ce2493542f60ce$var$byteToHex = [];
for(var $76ce2493542f60ce$var$i = 0; $76ce2493542f60ce$var$i < 256; ++$76ce2493542f60ce$var$i)$76ce2493542f60ce$var$byteToHex[$76ce2493542f60ce$var$i] = ($76ce2493542f60ce$var$i + 0x100).toString(16).substr(1);
function $76ce2493542f60ce$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $76ce2493542f60ce$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $76ce2493542f60ce$var$bytesToUuid;

});


parcelRegister("3izZW", function(module, exports) {

var $hJb6S = parcelRequire("hJb6S");

var $acoE7 = parcelRequire("acoE7");
function $266ef9fb2f2c18d7$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $hJb6S)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $acoE7(rnds);
}
module.exports = $266ef9fb2f2c18d7$var$v4;

});


parcelRegister("3H4LK", function(module, exports) {
$parcel$export(module.exports, "setBooleanFeatureFlagResolver", () => $81f531b4ba62cbce$export$ba05d765b8392e5e);
$parcel$export(module.exports, "fg", () => $81f531b4ba62cbce$export$b40ec24ac8275656);

var $fnd4D = parcelRequire("fnd4D");
function $81f531b4ba62cbce$export$ba05d765b8392e5e(flagResolver) {
    (0, $fnd4D.setBooleanResolver)(flagResolver);
}
function $81f531b4ba62cbce$export$470e5c2be1411c89(name) {
    return (0, $fnd4D.resolveBooleanFlag)(name);
}
function $81f531b4ba62cbce$export$b40ec24ac8275656(name) {
    return (0, $fnd4D.resolveBooleanFlag)(name);
}

});
parcelRegister("fnd4D", function(module, exports) {
$parcel$export(module.exports, "setBooleanResolver", () => $0be6cfe1754e570b$export$f2b591175b3e424c);
$parcel$export(module.exports, "resolveBooleanFlag", () => $0be6cfe1754e570b$export$6333b6aff9fc6275);

var $6bGmX = parcelRequire("6bGmX");

var $1H16G = parcelRequire("1H16G");

var $3TFEq = parcelRequire("3TFEq");
const $0be6cfe1754e570b$var$pkgName = '@atlaskit/platform-feature-flags';
const $0be6cfe1754e570b$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
const $0be6cfe1754e570b$var$hasProcessEnv = typeof $3TFEq !== 'undefined' && typeof $3TFEq.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
const $0be6cfe1754e570b$var$ENV_ENABLE_PLATFORM_FF = $0be6cfe1754e570b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
const $0be6cfe1754e570b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $0be6cfe1754e570b$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
const $0be6cfe1754e570b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $0be6cfe1754e570b$var$ENV_ENABLE_PLATFORM_FF || $0be6cfe1754e570b$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
const $0be6cfe1754e570b$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
const $0be6cfe1754e570b$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$0be6cfe1754e570b$var$globalVar[$0be6cfe1754e570b$export$7e41b1b2bdee3f98] = $0be6cfe1754e570b$var$globalVar[$0be6cfe1754e570b$export$7e41b1b2bdee3f98] || $0be6cfe1754e570b$var$DEFAULT_PFF_GLOBAL;
function $0be6cfe1754e570b$export$f2b591175b3e424c(resolver) {
    $0be6cfe1754e570b$var$globalVar[$0be6cfe1754e570b$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $0be6cfe1754e570b$export$6333b6aff9fc6275(flagKey) {
    if ($0be6cfe1754e570b$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $1H16G.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $0be6cfe1754e570b$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $0be6cfe1754e570b$var$globalVar[$0be6cfe1754e570b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $0be6cfe1754e570b$var$globalVar[$0be6cfe1754e570b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $6bGmX.default).checkGate(flagKey);
        const result = (_globalVar$PFF_GLOBAL3 = $0be6cfe1754e570b$var$globalVar[$0be6cfe1754e570b$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(`${flagKey} resolved to a non-boolean value, returning false for safety`);
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("6bGmX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f74e40ad226043af$export$2e2bcd8739ae039);

var $gbone = parcelRequire("gbone");

var $cbYMC = parcelRequire("cbYMC");



var $cRymc = parcelRequire("cRymc");
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ class $f74e40ad226043af$var$FeatureGates {
    static #_ = this.client = new (0, $gbone.Client)();
    static #_2 = this.hasCheckGateErrorOccurred = false;
    static #_3 = this.hasGetExperimentValueErrorOccurred = false;
    static #_4 = this.checkGate = (gateName, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
                // Attempt to retrieve an override value for the feature gate
                const overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                // If an override value is found, return it immediately
                if (overrideValue !== undefined) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$f74e40ad226043af$var$FeatureGates.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                $f74e40ad226043af$var$FeatureGates.hasCheckGateErrorOccurred = true;
            }
        }
        // Proceed with the main logic if no override is found
        return this.client.checkGate(gateName, options);
    };
    static isGateExists(gateName) {
        return this.client.isGateExist(gateName);
    }
    static isExperimentExists(experimentName) {
        return this.client.isExperimentExist(experimentName);
    }
    static #_5 = this.getExperimentValue = (experimentName, parameterName, defaultValue, options)=>{
        try {
            // Check if the CRITERION override mechanism is available
            if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
                const overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
            }
        } catch (error) {
            // Log the first occurrence of the error
            if (!$f74e40ad226043af$var$FeatureGates.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
        // Proceed with the main logic if no override is found
        return this.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
    };
    static #_6 = this.initializeCalled = this.client.initializeCalled.bind(this.client);
    static #_7 = this.initializeCompleted = this.client.initializeCompleted.bind(this.client);
    static #_8 = this.waitUntilInitializeCompleted = this.client.waitUntilInitializeCompleted.bind(this.client);
    static #_9 = this.initialize = this.client.initialize.bind(this.client);
    static #_10 = this.initializeWithProvider = this.client.initializeWithProvider.bind(this.client);
    static #_11 = this.initializeFromValues = this.client.initializeFromValues.bind(this.client);
    static #_12 = this.manuallyLogGateExposure = this.client.manuallyLogGateExposure.bind(this.client);
    static #_13 = this.getExperiment = this.client.getExperiment.bind(this.client);
    static #_14 = this.manuallyLogExperimentExposure = this.client.manuallyLogExperimentExposure.bind(this.client);
    static #_15 = this.manuallyLogLayerExposure = this.client.manuallyLogLayerExposure.bind(this.client);
    static #_16 = this.shutdownStatsig = this.client.shutdownStatsig.bind(this.client);
    static #_17 = this.overrideGate = this.client.overrideGate.bind(this.client);
    static #_18 = this.clearGateOverride = this.client.clearGateOverride.bind(this.client);
    static #_19 = this.overrideConfig = this.client.overrideConfig.bind(this.client);
    static #_20 = this.clearConfigOverride = this.client.clearConfigOverride.bind(this.client);
    static #_21 = this.setOverrides = this.client.setOverrides.bind(this.client);
    static #_22 = this.getOverrides = this.client.getOverrides.bind(this.client);
    static #_23 = this.clearAllOverrides = this.client.clearAllOverrides.bind(this.client);
    static #_24 = this.isCurrentUser = this.client.isCurrentUser.bind(this.client);
    static #_25 = this.onGateUpdated = this.client.onGateUpdated.bind(this.client);
    static #_26 = this.onExperimentValueUpdated = this.client.onExperimentValueUpdated.bind(this.client);
    static #_27 = this.onAnyUpdated = this.client.onAnyUpdated.bind(this.client);
    static #_28 = this.updateUser = this.client.updateUser.bind(this.client);
    static #_29 = this.updateUserWithProvider = this.client.updateUserWithProvider.bind(this.client);
    static #_30 = this.updateUserWithValues = this.client.updateUserWithValues.bind(this.client);
    static #_31 = this.getPackageVersion = this.client.getPackageVersion.bind(this.client);
    static #_32 = this.getTargetApp = this.client.getTargetApp.bind(this.client);
    static #_33 = this.getLayer = this.client.getLayer.bind(this.client);
    static #_34 = this.getLayerValue = this.client.getLayerValue.bind(this.client);
}
let $f74e40ad226043af$var$boundFGJS = $f74e40ad226043af$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $f74e40ad226043af$var$FeatureGates;
    else {
        var $f74e40ad226043af$var$_boundFGJS, $f74e40ad226043af$var$_boundFGJS$getPackage;
        $f74e40ad226043af$var$boundFGJS = window.__FEATUREGATES_JS__;
        const boundVersion = (($f74e40ad226043af$var$_boundFGJS = $f74e40ad226043af$var$boundFGJS) === null || $f74e40ad226043af$var$_boundFGJS === void 0 || ($f74e40ad226043af$var$_boundFGJS$getPackage = $f74e40ad226043af$var$_boundFGJS.getPackageVersion) === null || $f74e40ad226043af$var$_boundFGJS$getPackage === void 0 ? void 0 : $f74e40ad226043af$var$_boundFGJS$getPackage.call($f74e40ad226043af$var$_boundFGJS)) || '4.10.0 or earlier';
        if (boundVersion !== (0, $cbYMC.CLIENT_VERSION)) {
            const message = `Multiple versions of FeatureGateClients found on the current page.
      The currently bound version is ${boundVersion} when module version ${(0, $cbYMC.CLIENT_VERSION)} was loading.`;
            // eslint-disable-next-line no-console
            console.warn(message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $f74e40ad226043af$export$2e2bcd8739ae039 = $f74e40ad226043af$var$boundFGJS;

});
parcelRegister("gbone", function(module, exports) {
$parcel$export(module.exports, "Client", () => $4c52e45b735d4c52$export$1f2bb630327ac4b6);

var $8QPpE = parcelRequire("8QPpE");

var $cCLub = parcelRequire("cCLub");

var $2X0hi = parcelRequire("2X0hi");

var $h2XTF = parcelRequire("h2XTF");

var $8pk1w = parcelRequire("8pk1w");

var $jBevt = parcelRequire("jBevt");

var $eXiWc = parcelRequire("eXiWc");

var $2QFvP = parcelRequire("2QFvP");

var $cRymc = parcelRequire("cRymc");

var $4Ziou = parcelRequire("4Ziou");

var $cbYMC = parcelRequire("cbYMC");
const $4c52e45b735d4c52$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
const $4c52e45b735d4c52$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
class $4c52e45b735d4c52$export$1f2bb630327ac4b6 {
    constructor({ localStorageKey: localStorageKey = (0, $2QFvP.LOCAL_STORAGE_KEY), overrideAdapter: overrideAdapter } = {}){
        this.initPromise = null;
        /** True if an initialize method was called and completed successfully. */ this.initCompleted = false;
        /**
   * True if an initialize method was called and completed, meaning the client is now usable.
   * However if there was an error during initialization it may have initialized with default
   * values. Use {@link initCompleted} to check for this.
   */ this.initWithDefaults = false;
        this.hasCheckGateErrorOccurred = false;
        this.hasGetExperimentErrorOccurred = false;
        this.hasGetExperimentValueErrorOccurred = false;
        this.hasGetLayerErrorOccurred = false;
        this.hasGetLayerValueErrorOccurred = false;
        this.subscriptions = new (0, $cCLub.default)();
        this.dataAdapter = new (0, $eXiWc.NoFetchDataAdapter)();
        /**
   * Call this if modifying the values being served by the Statsig library since it has its own
   * memoization cache which will not be updated if the values are changed outside of the library.
   */ this.statsigValuesUpdated = ()=>{
            if (this.user) // Trigger a reset of the memoize cache
            this.statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
            this.subscriptions.anyUpdated();
        };
        this.overrideAdapter = overrideAdapter || new (0, $2QFvP.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initialize(clientOptions, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $4Ziou.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $4Ziou.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initialize', this.initCompleted, clientOptionsWithDefaults.apiKey);
        });
        return this.initPromise;
    }
    /**
   * @description
   * This method initializes the client using the provider given to call to fetch the bootstrap values.
   * If the client is initialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param provider {Provider}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ async initializeWithProvider(clientOptions, provider, identifiers, customAttributes) {
        const clientOptionsWithDefaults = (0, $4Ziou.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $4Ziou.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.provider = provider;
        this.provider.setClientVersion((0, $cbYMC.CLIENT_VERSION));
        if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
        this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeWithProvider', this.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
        });
        return this.initPromise;
    }
    applyUpdateCallback(experimentsResult) {
        try {
            if (this.initCompleted || this.initWithDefaults) {
                this.assertInitialized(this.statsigClient);
                this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                this.statsigValuesUpdated();
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn('Error when attempting to apply update', error);
        }
    }
    fireClientEvent(startTime, totalTime, action, success, apiKey) {
        var _analyticsWebClient;
        (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then((analyticsWebClient)=>{
            const attributes = {
                targetApp: this.initOptions.targetApp,
                clientVersion: (0, $cbYMC.CLIENT_VERSION),
                success: success,
                startTime: startTime,
                totalTime: totalTime,
                ...apiKey && {
                    apiKey: apiKey
                }
            };
            analyticsWebClient.sendOperationalEvent({
                action: action,
                actionSubject: 'featureGatesClient',
                attributes: attributes,
                tags: [
                    'measurement'
                ],
                source: '@atlaskit/feature-gate-js-client'
            });
        }).catch((err)=>{
            if (this.initOptions.environment !== (0, $cRymc.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
            console.error('Analytics web client promise did not resolve', err);
        });
    }
    async initializeFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        const clientOptionsWithDefaults = (0, $4Ziou.getOptionsWithDefaults)(clientOptions);
        if (this.initPromise) {
            if (!(0, $4Ziou.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
            console.warn('Feature Gates client already initialized with different options. New options were not applied.');
            return this.initPromise;
        }
        // This makes sure the new Statsig client behaves like the old when bootstrap data is
        // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
        if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
        const startTime = performance.now();
        this.initOptions = clientOptionsWithDefaults;
        this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(()=>{
            this.initCompleted = true;
            this.initWithDefaults = true;
        }).finally(()=>{
            const endTime = performance.now();
            const totalTime = endTime - startTime;
            this.fireClientEvent(startTime, totalTime, 'initializeFromValues', this.initCompleted);
        });
        return this.initPromise;
    }
    assertInitialized(statsigClient) {
        if (!statsigClient) throw new Error('Client must be initialized before using this method');
    }
    /**
   * This method updates the user using a network call to fetch the new set of values.
   * @param fetchOptions {FetcherOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUser(fetchOptions, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        const fetchOptionsWithDefaults = (0, $4Ziou.getOptionsWithDefaults)(fetchOptions);
        const initializeValuesProducer = ()=>(0, $jBevt.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(({ experimentValues: experimentValues, customAttributes: customAttributes })=>({
                    experimentValues: experimentValues,
                    customAttributesFromFetch: customAttributes
                }));
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    /**
   * This method updates the user using the provider given on initialisation to get the new set of
   * values.
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   */ async updateUserWithProvider(identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.provider) throw new Error('Cannot update user using provider as the client was not initialised with a provider');
        await this.provider.setProfile(this.initOptions, identifiers, customAttributes);
        await this.updateUserUsingInitializeValuesProducer(()=>this.provider.getExperimentValues(), identifiers, customAttributes);
    }
    /**
   * This method updates the user given a new set of bootstrap values obtained from one of the
   * server-side SDKs.
   *
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @param initializeValues {Record<string,unknown>}
   */ async updateUserWithValues(identifiers, customAttributes, initializeValues = {}) {
        this.assertInitialized(this.statsigClient);
        const initializeValuesProducer = ()=>Promise.resolve({
                experimentValues: initializeValues,
                customAttributesFromFetch: customAttributes
            });
        await this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
    }
    initializeCalled() {
        return this.initPromise != null;
    }
    initializeCompleted() {
        return this.initCompleted;
    }
    async waitUntilInitializeCompleted() {
        if (!this.initPromise) throw new Error('The client must be initialized before you can wait until initialized.');
        if (this.initCompleted) return;
        await this.initPromise;
    }
    /**
   * Returns the value for a feature gate. Returns false if there are errors.
   * @param {string} gateName - The name of the feature gate.
   * @param {Object} options
   * @param {boolean} options.fireGateExposure
   *        Whether or not to fire the exposure event for the gate. Defaults to true.
   *        To log an exposure event manually at a later time, use {@link Client.manuallyLogGateExposure}
   *        (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   */ checkGate(gateName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireGateExposure: fireGateExposure = true } = options;
            return this.statsigClient.checkGate(gateName, {
                disableExposureLog: !fireGateExposure
            });
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasCheckGateErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                    gateName: gateName,
                    error: error
                });
                this.hasCheckGateErrorOccurred = true;
            }
            return false;
        }
    }
    isGateExist(gateName) {
        try {
            this.assertInitialized(this.statsigClient);
            const gate = this.statsigClient.getFeatureGate(gateName, {
                disableExposureLog: true
            });
            return !gate.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check FeatureGate: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    isExperimentExist(experimentName) {
        try {
            this.assertInitialized(this.statsigClient);
            const config = this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: true
            });
            return !config.details.reason.includes('Unrecognized');
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to check Experiment: ${error}`);
            // in case of error report true to avoid false positives.
            return true;
        }
    }
    /**
   * Manually log a gate exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a gate earlier via {@link Client.checkGate} where
   * <code>options.fireGateExposure</code> is false.
   * @param gateName
   */ manuallyLogGateExposure(gateName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.checkGate(gateName);
    }
    /**
   * Returns the entire config for a given experiment.
   *
   * @param {string} experimentName - The name of the experiment
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns The config for an experiment
   * @example
   * ```ts
   * const experimentConfig = client.getExperiment('example-experiment-name');
   * const backgroundColor: string = experimentConfig.get('backgroundColor', 'yellow');
   * ```
   */ getExperiment(experimentName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            return (0, $2X0hi.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                disableExposureLog: !fireExperimentExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    error: error
                });
                this.hasGetExperimentErrorOccurred = true;
            }
            // Return a default value
            return new (0, $2X0hi.DynamicConfig)(experimentName, {}, '', {
                time: Date.now(),
                reason: (0, $8pk1w.EvaluationReason).Error
            });
        }
    }
    /**
   * Returns the value of a given parameter in an experiment config.
   *
   * @template T
   * @param {string} experimentName - The name of the experiment
   * @param {string} parameterName - The name of the parameter to fetch from the experiment config
   * @param {T} defaultValue - The value to serve if the experiment or parameter do not exist, or
   * if the returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireExperimentExposure - Whether or not to fire the exposure event
   * for the experiment. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogExperimentExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the
   * expected type. If this function returns false, then the default value will be returned
   * instead. This can be set to protect your code from unexpected values being set remotely. By
   * default, this will be done by asserting that the default value and value are the same primitive
   * type.
   * @returns The value of the parameter if the experiment and parameter both exist, otherwise the
   * default value.
   * @example
   ``` ts
   type ValidColor = 'blue' | 'red' | 'yellow';
   type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
  	 const isValidColor: ValidColorTypeCheck =
  		(value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
  	 const buttonColor: ValidColor = client.getExperimentValue(
  		'example-experiment-name',
  		'backgroundColor',
  		'yellow',
  		{
  				typeGuard: isValidColor
  		}
   );
   ```
  */ getExperimentValue(experimentName, parameterName, defaultValue, options = {}) {
        const experiment = this.getExperiment(experimentName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return experiment.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetExperimentValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                    experimentName: experimentName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetExperimentValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
    /**
   * Manually log an experiment exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated an experiment earlier via {@link Client.getExperimentValue} or
   * {@link Client.getExperiment} where <code>options.fireExperimentExposure</code> is false.
   * @param experimentName
   */ manuallyLogExperimentExposure(experimentName) {
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        this.statsigClient.getExperiment(experimentName);
    }
    /**
   * Manually log a layer exposure (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * This is useful if you have evaluated a layer earlier via {@link Client.getLayerValue} where <code>options.fireExperimentExposure</code> is false.
   * @param layerName
   * @param parameterName
   */ manuallyLogLayerExposure(layerName, parameterName) {
        var _this$statsigClient$g;
        this.assertInitialized(this.statsigClient);
        // This is the approach recommended in the docs
        // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
        (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
    }
    shutdownStatsig() {
        this.assertInitialized(this.statsigClient);
        this.statsigClient.shutdown();
    }
    /**
   * Adds a new override for the given gate.
   *
   * This method is additive, meaning you can call it multiple times with different gate names to
   * build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearGateOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} gateName
   * @param {boolean} value
   */ overrideGate(gateName, value) {
        this.overrideAdapter.overrideGate(gateName, value);
        // Trigger a reset of the memoized gate value
        if (this.user) {
            var _this$statsigClient;
            (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                disableBackgroundCacheRefresh: true
            });
        }
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given gate.
   */ clearGateOverride(gateName) {
        this.overrideAdapter.removeGateOverride(gateName);
        this.statsigValuesUpdated();
    }
    /**
   * Adds a new override for the given config (or experiment).
   *
   * This method is additive, meaning you can call it multiple times with different experiment
   * names to build your full set of overrides.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearConfigOverride} after your tests are completed to remove this
   * localStorage entry.
   *
   * @param {string} experimentName
   * @param {object} values
   */ overrideConfig(experimentName, values) {
        this.overrideAdapter.overrideDynamicConfig(experimentName, values);
        this.statsigValuesUpdated();
    }
    /**
   * Removes any overrides that have been set for the given experiment.
   * @param {string} experimentName
   */ clearConfigOverride(experimentName) {
        this.overrideAdapter.removeDynamicConfigOverride(experimentName);
        this.statsigValuesUpdated();
    }
    /**
   * Set overrides for gates, experiments and layers in batch.
   *
   * Note that these overrides are **not** additive and will completely replace any that have been
   * added via prior calls to {@link Client.overrideConfig} or
   * {@link Client.overrideGate}.
   *
   * Overrides are persisted to the `STATSIG_OVERRIDES` key in localStorage, so they
   * will continue to affect every client that is initialized on the same domain after this method
   * is called. If you are using this API for testing purposes, you should call
   * {@link Client.clearAllOverrides} after your tests are completed to remove this
   * localStorage entry.
   */ setOverrides(overrides) {
        this.overrideAdapter.setOverrides(overrides);
        this.statsigValuesUpdated();
    }
    /**
   * @returns The current overrides for gates, configs (including experiments) and layers.
   */ getOverrides() {
        return this.overrideAdapter.getOverrides();
    }
    /**
   * Clears overrides for all gates, configs (including experiments) and layers.
   */ clearAllOverrides() {
        this.overrideAdapter.removeAllOverrides();
        this.statsigValuesUpdated();
    }
    /**
   * Returns whether the given identifiers and customAttributes align with the current
   * set that is being used by the client.
   *
   * If this method returns false, then the {@link Client.updateUser},
   * {@link Client.updateUserWithValues} or {@link Client.updateUserWithProvider}
   * methods can be used to re-align these values.
   *
   * @param identifiers
   * @param customAttributes
   * @returns a flag indicating whether the clients current configuration aligns with the given values
   */ isCurrentUser(identifiers, customAttributes) {
        return (0, $4Ziou.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $4Ziou.shallowEquals)(this.currentAttributes, customAttributes);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current checkGate value
   * @param gateName
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onGateUpdated(gateName, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireGateExposure: fireGateExposure = true } = options;
            if (fireGateExposure) this.manuallyLogGateExposure(gateName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for gate ${gateName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
    }
    /**
   * Subscribe to updates where the given callback will be called with the current experiment value
   * @param experimentName
   * @param parameterName
   * @param defaultValue
   * @param callback
   * @param options
   * @returns off function to unsubscribe from updates
   */ onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, options = {}) {
        const wrapCallback = (value)=>{
            const { fireExperimentExposure: fireExperimentExposure = true } = options;
            if (fireExperimentExposure) this.manuallyLogExperimentExposure(experimentName);
            try {
                callback(value);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn(`Error calling callback for experiment ${experimentName} with value ${value}`, error);
            }
        };
        return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
    }
    /**
   * Subscribe so on any update the callback will be called.
   * NOTE: The callback will be called whenever the values are updated even if the values have not
   * changed.
   * @param callback
   * @returns off function to unsubscribe from updates
   */ onAnyUpdated(callback) {
        return this.subscriptions.onAnyUpdated(callback);
    }
    /**
   * This method initializes the client using a network call to fetch the bootstrap values for the
   * given user.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @private
   */ async init(clientOptions, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...clientOptions
        };
        if (clientOptions.localMode) {
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            return;
        }
        let experimentValues;
        let customAttributesFromResult;
        try {
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = (0, $jBevt.default).fetchClientSdk(clientOptions).then((value)=>fromValuesClientOptions.sdkKey = value.clientSdkKey);
            const experimentValuesPromise = (0, $jBevt.default).fetchExperimentValues(clientOptions, identifiers, customAttributes);
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributes;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    async initWithProvider(baseClientOptions, provider, identifiers, customAttributes) {
        const fromValuesClientOptions = {
            ...baseClientOptions,
            disableCurrentPageLogging: true
        };
        let experimentValues;
        let customAttributesFromResult;
        try {
            await provider.setProfile(baseClientOptions, identifiers, customAttributes);
            // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
            // the experiment values request to be settled, and it will fall back to use default values.
            const clientSdkKeyPromise = provider.getClientSdkKey().then((value)=>fromValuesClientOptions.sdkKey = value);
            const experimentValuesPromise = provider.getExperimentValues();
            // Only wait for the experiment values request to finish and try to initialise the client
            // with experiment values if both requests are successful. Else an error would be thrown and
            // handled by the catch
            const [, experimentValuesResult] = await Promise.all([
                clientSdkKeyPromise,
                experimentValuesPromise
            ]);
            experimentValues = experimentValuesResult.experimentValues;
            customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to fetch the Feature Gates client values, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client without values`);
            await this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
            throw error;
        }
        return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
    }
    /**
   * This method initializes the client using a set of boostrap values obtained from one of the
   * server-side SDKs.
   *
   * @param clientOptions
   * @param identifiers
   * @param customAttributes
   * @param initializeValues
   * @private
   */ async initFromValues(clientOptions, identifiers, customAttributes, initializeValues = {}) {
        var _newClientOptions$net;
        this.overrideAdapter.initFromStoredOverrides();
        this.currentIdentifiers = identifiers;
        this.currentAttributes = customAttributes;
        const newClientOptions = (0, $4Ziou.migrateInitializationOptions)(clientOptions);
        if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $4c52e45b735d4c52$var$DEFAULT_CLIENT_KEY;
        if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = {
            ...newClientOptions.networkConfig,
            logEventUrl: $4c52e45b735d4c52$var$DEFAULT_EVENT_LOGGING_API
        };
        if (newClientOptions.perimeter === (0, $cRymc.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
        newClientOptions.disableLogging = true;
        const { sdkKey: sdkKey, environment: environment, updateUserCompletionCallback: _updateUserCompletionCallback, perimeter: _perimeter, ...restClientOptions } = newClientOptions;
        const frontendUser = (0, $4Ziou.toStatsigUser)(identifiers, customAttributes);
        this.user = (0, $4Ziou.deepAssign)({}, initializeValues.user, frontendUser);
        const statsigOptions = {
            ...restClientOptions,
            environment: {
                tier: environment
            },
            includeCurrentPageUrlWithEvents: false,
            dataAdapter: this.dataAdapter,
            overrideAdapter: this.overrideAdapter,
            logEventCompressionMode: (0, $8QPpE.LogEventCompressionMode).Forced
        };
        // Statsig validates the provided stableId against their own cookie, so we either need
        // to update the cookie to match, or disable the validation completely.
        if (identifiers.stableId) (0, $8QPpE.StableID).setOverride(identifiers.stableId, sdkKey);
        else statsigOptions.disableStableID = true;
        try {
            this.statsigClient = new (0, $8QPpE.StatsigClient)(sdkKey, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData(initializeValues);
            await this.statsigClient.initializeAsync();
        } catch (error) {
            if (error instanceof Error) // eslint-disable-next-line no-console
            console.error(`Error occurred when trying to initialise the Statsig client, error: ${error === null || error === void 0 ? void 0 : error.message}`);
            // eslint-disable-next-line no-console
            console.warn(`Initialising Statsig client with default sdk key and without values`);
            this.statsigClient = new (0, $8QPpE.StatsigClient)($4c52e45b735d4c52$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
            this.dataAdapter.setBootstrapData();
            await this.statsigClient.initializeAsync();
            this.initWithDefaults = true;
            throw error;
        }
    }
    /**
   * This method updates the user for this client with the bootstrap values returned from a given
   * Promise.
   * It uses the customAttributes from fetching experiment values to update the Statsig user but
   * uses the customAttributes from given input to check if the user has changed.
   *
   * @param {Identifiers} identifiers
   * @param {CustomAttributes} customAttributes
   * @param {Promise<InitializeValues>} getInitializeValues
   * @private
   */ async updateUserUsingInitializeValuesProducer(getInitializeValues, identifiers, customAttributes) {
        this.assertInitialized(this.statsigClient);
        if (!this.initPromise) throw new Error('The client must be initialized before you can update the user.');
        // If the user isn't changing at all, then exit immediately
        if (this.isCurrentUser(identifiers, customAttributes)) return this.initPromise;
        // Wait for the current initialize/update to finish
        const originalInitPromise = this.initPromise;
        try {
            await this.initPromise;
        } catch (err) {
        // Proceed with the user update even if the init failed, since this update
        // may put the client back into a valid state.
        }
        const initializeValuesPromise = getInitializeValues();
        const updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes);
        // We replace the init promise here since we are essentially re-initializing the client at this
        // point. Any subsequent calls to await client.initialize() or client.updateUser()
        // will now also await this user update.
        this.initPromise = updateUserPromise.catch(async ()=>{
            // If the update failed then it changed nothing, so revert back to the original promise.
            this.initPromise = originalInitPromise;
            // Set the user profile again to revert back to the current user
            if (this.provider) await this.provider.setProfile(this.initOptions, this.currentIdentifiers, this.currentAttributes);
        });
        return updateUserPromise;
    }
    /**
   * This method updates the user on the nested Statsig client
   *
   * @param identifiers
   * @param customAttributes
   * @param initializeValuesPromise
   * @private
   */ async updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes) {
        var _this$initOptions, _this$initOptions$upd;
        this.assertInitialized(this.statsigClient);
        let initializeValues, user;
        try {
            initializeValues = await initializeValuesPromise;
            const frontendUser = (0, $4Ziou.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
            user = (0, $4Ziou.deepAssign)({}, initializeValues.experimentValues.user, frontendUser);
        } catch (err) {
            var _updateUserCompletion, _ref;
            // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
            // This is not necessary for the updateUserWithValues call, because the Statsig client will
            // already invoke the callback itself.
            const errMsg = err instanceof Error ? err.message : JSON.stringify(err);
            (_updateUserCompletion = (_ref = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref, false, errMsg);
            throw err;
        }
        let success = true;
        let errorMessage = null;
        try {
            this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
            this.user = user;
            if (this.user) await this.statsigClient.updateUserAsync(this.user);
        } catch (err) {
            success = false;
            errorMessage = String(err);
        }
        (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
        if (success) {
            this.currentIdentifiers = identifiers;
            this.currentAttributes = customAttributes;
            this.subscriptions.anyUpdated();
        } else throw new Error('Failed to update user. An unexpected error occured.');
    }
    /**
   * @returns string version of the current package in semver style.
   */ getPackageVersion() {
        return 0, $cbYMC.CLIENT_VERSION;
    }
    /**
   * Returns the `targetApp` value that was provided during client initialization.
   * This identifies the product/app context (e.g., `'confluence_web'`, `'jira_web'`).
   *
   * Returns `undefined` if `initialize` has never been called.
   *
   * @returns The targetApp string, or undefined if initialize has never been called.
   */ getTargetApp() {
        var _this$initOptions2;
        return (_this$initOptions2 = this.initOptions) === null || _this$initOptions2 === void 0 ? void 0 : _this$initOptions2.targetApp;
    }
    /**
   * Returns a specified layer otherwise returns an empty layer as a default value if the layer doesn't exist.
   *
   * @param {string} layerName - The name of the layer
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-)).
   * @returns A layer
   * @example
   * ```ts
   * const layer = client.getLayer('example-layer-name');
   * const exampletitle: string = layer.get("title", "Welcome to Statsig!");
   * ```
   */ getLayer(/** The name of the layer */ layerName, options = {}) {
        try {
            this.assertInitialized(this.statsigClient);
            const { fireLayerExposure: fireLayerExposure = true } = options;
            return (0, $h2XTF.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                disableExposureLog: !fireLayerExposure
            }));
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    error: error
                });
                this.hasGetLayerErrorOccurred = true;
            }
            // Return a default value
            return (0, $h2XTF.Layer).fromLayer((0, $8QPpE._makeLayer)(layerName, {
                reason: 'Error'
            }, null));
        }
    }
    /**
   * Returns the value of a given parameter in a layer config.
   *
   * @template T
   * @param {string} layerName - The name of the layer
   * @param {string} parameterName - The name of the parameter to fetch from the layer config
   * @param {T} defaultValue - The value to serve if the layer or parameter do not exist, or if the
   * returned value does not match the expected type.
   * @param {Object} options
   * @param {boolean} options.fireLayerExposure - Whether or not to fire the exposure event for the
   * layer. Defaults to true. To log an exposure event manually at a later time, use
   * {@link Client.manuallyLogLayerExposure} (see [Statsig docs about manually logging exposures](https://docs.statsig.com/client/jsClientSDK#manual-exposures-))
   * @param {function} options.typeGuard - A function that asserts that the return value has the expected type. If this function returns false, then the default value will be returned instead. This can be set to protect your code from unexpected values being set remotely. By default, this will be done by asserting that the default value and value are the same primitive type.
   * @returns The value of the parameter if the layer and parameter both exist, otherwise the default value.
   * @example
   * ``` ts
   * type ValidColor = 'blue' | 'red' | 'yellow';
   * type ValidColorTypeCheck = (value: unknown) => value is ValidColor;
   *
   * const isValidColor: ValidColorTypeCheck =
   *    (value: unknown) => typeof value === 'string' && ['blue', 'red', 'yellow'].includes(value);
   *
   * const buttonColor: ValidColor = client.getLayerValue(
   *    'example-layer-name',
   *    'backgroundColor',
   *    'yellow',
   *    {
   *        typeGuard: isValidColor
   *    }
   * );
   * ```
   */ getLayerValue(layerName, parameterName, defaultValue, options = {}) {
        const layer = this.getLayer(layerName, options);
        try {
            const { typeGuard: typeGuard } = options;
            return layer.get(parameterName, defaultValue, typeGuard);
        } catch (error) {
            // Log the first occurrence of the error
            if (!this.hasGetLayerValueErrorOccurred) {
                // eslint-disable-next-line no-console
                console.warn({
                    msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                    layerName: layerName,
                    defaultValue: defaultValue,
                    options: options,
                    error: error
                });
                this.hasGetLayerValueErrorOccurred = true;
            }
            return defaultValue;
        }
    }
}

});
parcelRegister("8QPpE", function(module, exports) {
"use strict";
var $671b0f89f2f3dae4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $671b0f89f2f3dae4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $671b0f89f2f3dae4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $cACtO = parcelRequire("cACtO");
module.exports.StatsigClient = $cACtO.default;

$671b0f89f2f3dae4$var$__exportStar((parcelRequire("dgxg2")), module.exports);
const $671b0f89f2f3dae4$var$__STATSIG__ = Object.assign((0, (parcelRequire("dgxg2"))._getStatsigGlobal)(), {
    StatsigClient: $cACtO.default
});
module.exports.default = $671b0f89f2f3dae4$var$__STATSIG__;

});
parcelRegister("dgxg2", function(module, exports) {
"use strict";
var $9a86913f7a93f48c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9a86913f7a93f48c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9a86913f7a93f48c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("fWajo")).Diagnostics;
    }
});

var $klYzh = parcelRequire("klYzh");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $klYzh.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("aDCKH")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("jFyos")).Storage;
    }
});

$9a86913f7a93f48c$var$__exportStar((parcelRequire("d0tJQ")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("fk15l")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("4OJyR")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("jTjAh")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("fWajo")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("guseT")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("2JAfF")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("RboiM")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("lTJxc")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("6aAMI")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("cT8YX")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("aDCKH")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("9yvJb")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("dHCaY")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("ePaIX")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("gafSq")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("dETAM")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("10v51")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("hfiUu")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("5ZiKt")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("b4hCf")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("crkkA")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("8ZT0R")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("K1v6N")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("iqUIx")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("4b2wf")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("3zGbi")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("3rozZ")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("5Jp4m")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("3rcug")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("d8cWz")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("295Rt")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("jFyos")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("4bOvf")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("9fOOb")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("a31ob")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("gz2mp")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("g3crm")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("3bTyo")), module.exports);

$9a86913f7a93f48c$var$__exportStar((parcelRequire("dVrSs")), module.exports);
Object.assign((0, (parcelRequire("d0tJQ"))._getStatsigGlobal)(), {
    Log: (parcelRequire("aDCKH")).Log,
    SDK_VERSION: (parcelRequire("3zGbi")).SDK_VERSION
});

});
parcelRegister("d0tJQ", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $978257e1a66c7c6a$var$_a, $978257e1a66c7c6a$var$_b, $978257e1a66c7c6a$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $aDCKH = parcelRequire("aDCKH");
const $978257e1a66c7c6a$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $978257e1a66c7c6a$var$statsigGlobal;
    } catch (e) {
        return $978257e1a66c7c6a$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $978257e1a66c7c6a$var$_getStatsigGlobal;
const $978257e1a66c7c6a$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $978257e1a66c7c6a$var$_getStatsigGlobalFlag;
const $978257e1a66c7c6a$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $aDCKH.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $978257e1a66c7c6a$var$_getInstance;
const $978257e1a66c7c6a$var$GLOBAL_KEY = '__STATSIG__';
const $978257e1a66c7c6a$var$_window = typeof window !== 'undefined' ? window : {};
const $978257e1a66c7c6a$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $978257e1a66c7c6a$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $978257e1a66c7c6a$var$statsigGlobal = ($978257e1a66c7c6a$var$_c = ($978257e1a66c7c6a$var$_b = ($978257e1a66c7c6a$var$_a = $978257e1a66c7c6a$var$_window[$978257e1a66c7c6a$var$GLOBAL_KEY]) !== null && $978257e1a66c7c6a$var$_a !== void 0 ? $978257e1a66c7c6a$var$_a : $978257e1a66c7c6a$var$_global[$978257e1a66c7c6a$var$GLOBAL_KEY]) !== null && $978257e1a66c7c6a$var$_b !== void 0 ? $978257e1a66c7c6a$var$_b : $978257e1a66c7c6a$var$_globalThis[$978257e1a66c7c6a$var$GLOBAL_KEY]) !== null && $978257e1a66c7c6a$var$_c !== void 0 ? $978257e1a66c7c6a$var$_c : {
    instance: module.exports._getInstance
};
$978257e1a66c7c6a$var$_window[$978257e1a66c7c6a$var$GLOBAL_KEY] = $978257e1a66c7c6a$var$statsigGlobal;
$978257e1a66c7c6a$var$_global[$978257e1a66c7c6a$var$GLOBAL_KEY] = $978257e1a66c7c6a$var$statsigGlobal;
$978257e1a66c7c6a$var$_globalThis[$978257e1a66c7c6a$var$GLOBAL_KEY] = $978257e1a66c7c6a$var$statsigGlobal;

});
parcelRegister("aDCKH", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $7beb9b4a0b5acd0c$var$DEBUG = ' DEBUG ';
const $7beb9b4a0b5acd0c$var$_INFO = '  INFO ';
const $7beb9b4a0b5acd0c$var$_WARN = '  WARN ';
const $7beb9b4a0b5acd0c$var$ERROR = ' ERROR ';
function $7beb9b4a0b5acd0c$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $7beb9b4a0b5acd0c$var$Log {
    static info(...args) {
        if ($7beb9b4a0b5acd0c$var$Log.level >= module.exports.LogLevel.Info) console.info($7beb9b4a0b5acd0c$var$_INFO, ...$7beb9b4a0b5acd0c$var$addTag(args));
    }
    static debug(...args) {
        if ($7beb9b4a0b5acd0c$var$Log.level >= module.exports.LogLevel.Debug) console.debug($7beb9b4a0b5acd0c$var$DEBUG, ...$7beb9b4a0b5acd0c$var$addTag(args));
    }
    static warn(...args) {
        if ($7beb9b4a0b5acd0c$var$Log.level >= module.exports.LogLevel.Warn) console.warn($7beb9b4a0b5acd0c$var$_WARN, ...$7beb9b4a0b5acd0c$var$addTag(args));
    }
    static error(...args) {
        if ($7beb9b4a0b5acd0c$var$Log.level >= module.exports.LogLevel.Error) console.error($7beb9b4a0b5acd0c$var$ERROR, ...$7beb9b4a0b5acd0c$var$addTag(args));
    }
}
module.exports.Log = $7beb9b4a0b5acd0c$var$Log;
$7beb9b4a0b5acd0c$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("fWajo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $b9a44586e0978ece$var$MARKER_MAP = new Map();
const $b9a44586e0978ece$var$ACT_START = 'start';
const $b9a44586e0978ece$var$ACT_END = 'end';
const $b9a44586e0978ece$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $b9a44586e0978ece$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $b9a44586e0978ece$var$_addMarker(sdkKey, $b9a44586e0978ece$var$_createMarker({}, $b9a44586e0978ece$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $b9a44586e0978ece$var$_addMarker(sdkKey, $b9a44586e0978ece$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $b9a44586e0978ece$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $b9a44586e0978ece$var$_addMarker(sdkKey, $b9a44586e0978ece$var$_createMarker(data, $b9a44586e0978ece$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $b9a44586e0978ece$var$_addMarker(sdkKey, $b9a44586e0978ece$var$_createMarker(data, $b9a44586e0978ece$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $b9a44586e0978ece$var$_addMarker(sdkKey, $b9a44586e0978ece$var$_createMarker({}, $b9a44586e0978ece$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $b9a44586e0978ece$var$_addMarker(sdkKey, $b9a44586e0978ece$var$_createMarker(data, $b9a44586e0978ece$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $b9a44586e0978ece$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $b9a44586e0978ece$var$_safeGetField(e, 'code'),
            name: $b9a44586e0978ece$var$_safeGetField(e, 'name'),
            message: $b9a44586e0978ece$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $b9a44586e0978ece$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $b9a44586e0978ece$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $b9a44586e0978ece$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $b9a44586e0978ece$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $b9a44586e0978ece$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $b9a44586e0978ece$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $b9a44586e0978ece$var$MARKER_MAP.set(sdkKey, markers);
}
function $b9a44586e0978ece$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("klYzh", function(module, exports) {
"use strict";
var $ed14c058f67c5f74$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $fk15l = parcelRequire("fk15l");

var $6aAMI = parcelRequire("6aAMI");

var $aDCKH = parcelRequire("aDCKH");

var $dHCaY = parcelRequire("dHCaY");

var $10v51 = parcelRequire("10v51");

var $4b2wf = parcelRequire("4b2wf");

var $3rozZ = parcelRequire("3rozZ");

var $jFyos = parcelRequire("jFyos");

var $a31ob = parcelRequire("a31ob");

var $g3crm = parcelRequire("g3crm");
const $ed14c058f67c5f74$var$DEFAULT_QUEUE_SIZE = 100;
const $ed14c058f67c5f74$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $ed14c058f67c5f74$var$MAX_DEDUPER_KEYS = 1000;
const $ed14c058f67c5f74$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $ed14c058f67c5f74$var$MAX_FAILED_LOGS = 500;
const $ed14c058f67c5f74$var$QUICK_FLUSH_WINDOW_MS = 200;
const $ed14c058f67c5f74$var$EVENT_LOGGER_MAP = {};
class $ed14c058f67c5f74$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $ed14c058f67c5f74$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $ed14c058f67c5f74$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $3rozZ.LoggingEnabledOption.disabled : $3rozZ.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $aDCKH.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $ed14c058f67c5f74$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $a31ob.UrlConfiguration($dHCaY.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $jFyos._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $jFyos.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $ed14c058f67c5f74$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $10v51._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $ed14c058f67c5f74$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $g3crm._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $ed14c058f67c5f74$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $ed14c058f67c5f74$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $ed14c058f67c5f74$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $ed14c058f67c5f74$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $ed14c058f67c5f74$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $ed14c058f67c5f74$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$ed14c058f67c5f74$var$EventLogger._safeFlushAndForget(this._sdkKey), $ed14c058f67c5f74$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $10v51._isServerEnv)()) return false;
        if (!(0, $4b2wf._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $fk15l._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $ed14c058f67c5f74$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $ed14c058f67c5f74$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $ed14c058f67c5f74$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $g3crm._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $aDCKH.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $aDCKH.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $ed14c058f67c5f74$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$dHCaY.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $ed14c058f67c5f74$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $jFyos._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $aDCKH.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $jFyos._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$ed14c058f67c5f74$var$__awaiter(this, void 0, void 0, function*() {
                if (!$jFyos.Storage.isReady()) yield $jFyos.Storage.isReadyResolver();
                const events = (0, $jFyos._getObjectFromStorage)(storageKey);
                if (!events) return;
                $jFyos.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $aDCKH.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $6aAMI._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $aDCKH.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $10v51._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $ed14c058f67c5f74$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $ed14c058f67c5f74$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $ed14c058f67c5f74$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $ed14c058f67c5f74$var$EventLogger;

});
parcelRegister("fk15l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $6aAMI = parcelRequire("6aAMI");
function $b27990c30995436f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $6aAMI._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $b27990c30995436f$var$_getUserStorageKey;
function $b27990c30995436f$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $b27990c30995436f$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $6aAMI._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $b27990c30995436f$var$_getStorageKey;

});
parcelRegister("6aAMI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9fOOb = parcelRequire("9fOOb");
const $47e035e7fcde14c6$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $47e035e7fcde14c6$var$_DJB2;
const $47e035e7fcde14c6$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $47e035e7fcde14c6$var$_DJB2Object;
const $47e035e7fcde14c6$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9fOOb._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $47e035e7fcde14c6$var$_getSortedObject;

});
parcelRegister("9fOOb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $6bcced4988bd8471$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $6bcced4988bd8471$var$_typeOf;
function $6bcced4988bd8471$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $6bcced4988bd8471$var$_isTypeMatch;

});



parcelRegister("dHCaY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("10v51", function(module, exports) {

var $3TFEq = parcelRequire("3TFEq");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $0bbde65f51dd0103$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $0bbde65f51dd0103$var$_getWindowSafe;
const $0bbde65f51dd0103$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $0bbde65f51dd0103$var$_getDocumentSafe;
const $0bbde65f51dd0103$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $3TFEq !== 'undefined' && $3TFEq.versions != null && $3TFEq.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $0bbde65f51dd0103$var$_isServerEnv;
const $0bbde65f51dd0103$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $0bbde65f51dd0103$var$_addWindowEventListenerSafe;
const $0bbde65f51dd0103$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $0bbde65f51dd0103$var$_addDocumentEventListenerSafe;
const $0bbde65f51dd0103$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $0bbde65f51dd0103$var$_getCurrentPageUrlSafe;
const $0bbde65f51dd0103$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $0bbde65f51dd0103$var$_getUnloadEvent;

});
parcelRegister("3TFEq", function(module, exports) {
// shim for using process in browser
var $2d66d126ec898355$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2d66d126ec898355$var$cachedSetTimeout;
var $2d66d126ec898355$var$cachedClearTimeout;
function $2d66d126ec898355$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2d66d126ec898355$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2d66d126ec898355$var$cachedSetTimeout = setTimeout;
        else $2d66d126ec898355$var$cachedSetTimeout = $2d66d126ec898355$var$defaultSetTimout;
    } catch (e) {
        $2d66d126ec898355$var$cachedSetTimeout = $2d66d126ec898355$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2d66d126ec898355$var$cachedClearTimeout = clearTimeout;
        else $2d66d126ec898355$var$cachedClearTimeout = $2d66d126ec898355$var$defaultClearTimeout;
    } catch (e) {
        $2d66d126ec898355$var$cachedClearTimeout = $2d66d126ec898355$var$defaultClearTimeout;
    }
})();
function $2d66d126ec898355$var$runTimeout(fun) {
    if ($2d66d126ec898355$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2d66d126ec898355$var$cachedSetTimeout === $2d66d126ec898355$var$defaultSetTimout || !$2d66d126ec898355$var$cachedSetTimeout) && setTimeout) {
        $2d66d126ec898355$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2d66d126ec898355$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2d66d126ec898355$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2d66d126ec898355$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2d66d126ec898355$var$runClearTimeout(marker) {
    if ($2d66d126ec898355$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2d66d126ec898355$var$cachedClearTimeout === $2d66d126ec898355$var$defaultClearTimeout || !$2d66d126ec898355$var$cachedClearTimeout) && clearTimeout) {
        $2d66d126ec898355$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2d66d126ec898355$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2d66d126ec898355$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2d66d126ec898355$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2d66d126ec898355$var$queue = [];
var $2d66d126ec898355$var$draining = false;
var $2d66d126ec898355$var$currentQueue;
var $2d66d126ec898355$var$queueIndex = -1;
function $2d66d126ec898355$var$cleanUpNextTick() {
    if (!$2d66d126ec898355$var$draining || !$2d66d126ec898355$var$currentQueue) return;
    $2d66d126ec898355$var$draining = false;
    if ($2d66d126ec898355$var$currentQueue.length) $2d66d126ec898355$var$queue = $2d66d126ec898355$var$currentQueue.concat($2d66d126ec898355$var$queue);
    else $2d66d126ec898355$var$queueIndex = -1;
    if ($2d66d126ec898355$var$queue.length) $2d66d126ec898355$var$drainQueue();
}
function $2d66d126ec898355$var$drainQueue() {
    if ($2d66d126ec898355$var$draining) return;
    var timeout = $2d66d126ec898355$var$runTimeout($2d66d126ec898355$var$cleanUpNextTick);
    $2d66d126ec898355$var$draining = true;
    var len = $2d66d126ec898355$var$queue.length;
    while(len){
        $2d66d126ec898355$var$currentQueue = $2d66d126ec898355$var$queue;
        $2d66d126ec898355$var$queue = [];
        while(++$2d66d126ec898355$var$queueIndex < len)if ($2d66d126ec898355$var$currentQueue) $2d66d126ec898355$var$currentQueue[$2d66d126ec898355$var$queueIndex].run();
        $2d66d126ec898355$var$queueIndex = -1;
        len = $2d66d126ec898355$var$queue.length;
    }
    $2d66d126ec898355$var$currentQueue = null;
    $2d66d126ec898355$var$draining = false;
    $2d66d126ec898355$var$runClearTimeout(timeout);
}
$2d66d126ec898355$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2d66d126ec898355$var$queue.push(new $2d66d126ec898355$var$Item(fun, args));
    if ($2d66d126ec898355$var$queue.length === 1 && !$2d66d126ec898355$var$draining) $2d66d126ec898355$var$runTimeout($2d66d126ec898355$var$drainQueue);
};
// v8 likes predictible objects
function $2d66d126ec898355$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2d66d126ec898355$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2d66d126ec898355$var$process.title = 'browser';
$2d66d126ec898355$var$process.browser = true;
$2d66d126ec898355$var$process.env = {};
$2d66d126ec898355$var$process.argv = [];
$2d66d126ec898355$var$process.version = ''; // empty string to avoid regexp issues
$2d66d126ec898355$var$process.versions = {};
function $2d66d126ec898355$var$noop() {}
$2d66d126ec898355$var$process.on = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.addListener = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.once = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.off = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.removeListener = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.removeAllListeners = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.emit = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.prependListener = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.prependOnceListener = $2d66d126ec898355$var$noop;
$2d66d126ec898355$var$process.listeners = function(name) {
    return [];
};
$2d66d126ec898355$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2d66d126ec898355$var$process.cwd = function() {
    return '/';
};
$2d66d126ec898355$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2d66d126ec898355$var$process.umask = function() {
    return 0;
};

});


parcelRegister("4b2wf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $30aa24c435783b21$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $30aa24c435783b21$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $30aa24c435783b21$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $30aa24c435783b21$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $30aa24c435783b21$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $30aa24c435783b21$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $30aa24c435783b21$var$GATE_EXPOSURE_NAME || eventName === $30aa24c435783b21$var$CONFIG_EXPOSURE_NAME || eventName === $30aa24c435783b21$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $30aa24c435783b21$var$_isExposureEvent;
const $30aa24c435783b21$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $30aa24c435783b21$var$_createExposure($30aa24c435783b21$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $30aa24c435783b21$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $30aa24c435783b21$var$_createGateExposure;
function $30aa24c435783b21$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $30aa24c435783b21$var$_mapExposures;
const $30aa24c435783b21$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $30aa24c435783b21$var$_createExposure($30aa24c435783b21$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $30aa24c435783b21$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $30aa24c435783b21$var$_createConfigExposure;
const $30aa24c435783b21$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $30aa24c435783b21$var$_createExposure($30aa24c435783b21$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $30aa24c435783b21$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $30aa24c435783b21$var$_createLayerParameterExposure;
const $30aa24c435783b21$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("3rozZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("jFyos", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $aDCKH = parcelRequire("aDCKH");

var $10v51 = parcelRequire("10v51");
const $e51c8676b0921305$var$inMemoryStore = {};
const $e51c8676b0921305$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$e51c8676b0921305$var$inMemoryStore[key] ? $e51c8676b0921305$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $e51c8676b0921305$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $e51c8676b0921305$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($e51c8676b0921305$var$inMemoryStore)
};
let $e51c8676b0921305$var$_localStorageProvider = null;
try {
    const win = (0, $10v51._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $e51c8676b0921305$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $aDCKH.Log.warn('Failed to setup localStorageProvider.');
}
let $e51c8676b0921305$var$_main = $e51c8676b0921305$var$_localStorageProvider !== null && $e51c8676b0921305$var$_localStorageProvider !== void 0 ? $e51c8676b0921305$var$_localStorageProvider : $e51c8676b0921305$var$_inMemoryProvider;
let $e51c8676b0921305$var$_current = $e51c8676b0921305$var$_main;
function $e51c8676b0921305$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($e51c8676b0921305$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$e51c8676b0921305$var$_current.isReady(),
    isReadyResolver: ()=>$e51c8676b0921305$var$_current.isReadyResolver(),
    getProviderName: ()=>$e51c8676b0921305$var$_current.getProviderName(),
    getItem: (key)=>$e51c8676b0921305$var$_inMemoryBreaker(()=>$e51c8676b0921305$var$_current.getItem(key)),
    setItem: (key, value)=>$e51c8676b0921305$var$_inMemoryBreaker(()=>$e51c8676b0921305$var$_current.setItem(key, value)),
    removeItem: (key)=>$e51c8676b0921305$var$_current.removeItem(key),
    getAllKeys: ()=>$e51c8676b0921305$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $e51c8676b0921305$var$_main = newProvider;
        $e51c8676b0921305$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $e51c8676b0921305$var$_current = $e51c8676b0921305$var$_inMemoryProvider;
        else $e51c8676b0921305$var$_current = $e51c8676b0921305$var$_main;
    }
};
function $e51c8676b0921305$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $aDCKH.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $e51c8676b0921305$var$_getObjectFromStorage;
function $e51c8676b0921305$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $e51c8676b0921305$var$_setObjectInStorage;

});

parcelRegister("a31ob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $6aAMI = parcelRequire("6aAMI");

var $dHCaY = parcelRequire("dHCaY");
const $750b430a134e0bd6$var$ENDPOINT_DNS_KEY_MAP = {
    [$dHCaY.Endpoint._initialize]: 'i',
    [$dHCaY.Endpoint._rgstr]: 'e',
    [$dHCaY.Endpoint._download_config_specs]: 'd'
};
class $750b430a134e0bd6$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $750b430a134e0bd6$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $dHCaY.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $6aAMI._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $750b430a134e0bd6$var$UrlConfiguration;

});

parcelRegister("g3crm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $10v51 = parcelRequire("10v51");
const $baf69388aec90693$var$FOREGROUND = 'foreground';
const $baf69388aec90693$var$BACKGROUND = 'background';
const $baf69388aec90693$var$LISTENERS = [];
let $baf69388aec90693$var$current = $baf69388aec90693$var$FOREGROUND;
let $baf69388aec90693$var$isUnloading = false;
const $baf69388aec90693$var$_isCurrentlyVisible = ()=>{
    return $baf69388aec90693$var$current === $baf69388aec90693$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $baf69388aec90693$var$_isCurrentlyVisible;
const $baf69388aec90693$var$_isUnloading = ()=>$baf69388aec90693$var$isUnloading;
module.exports._isUnloading = $baf69388aec90693$var$_isUnloading;
const $baf69388aec90693$var$_subscribeToVisiblityChanged = (listener)=>{
    $baf69388aec90693$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $baf69388aec90693$var$_subscribeToVisiblityChanged;
const $baf69388aec90693$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $baf69388aec90693$var$current) return;
    $baf69388aec90693$var$current = visibility;
    $baf69388aec90693$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $baf69388aec90693$var$_notifyVisibilityChanged;
(0, $10v51._addWindowEventListenerSafe)('focus', ()=>{
    $baf69388aec90693$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($baf69388aec90693$var$FOREGROUND);
});
(0, $10v51._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($baf69388aec90693$var$BACKGROUND));
(0, $10v51._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $baf69388aec90693$var$FOREGROUND : $baf69388aec90693$var$BACKGROUND);
});
(0, $10v51._addWindowEventListenerSafe)((0, $10v51._getUnloadEvent)(), ()=>{
    $baf69388aec90693$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($baf69388aec90693$var$BACKGROUND);
});

});


parcelRegister("3zGbi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $29a55c4f66a18f15$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$29a55c4f66a18f15$var$metadata,
    add: (additions)=>{
        $29a55c4f66a18f15$var$metadata = Object.assign(Object.assign({}, $29a55c4f66a18f15$var$metadata), additions);
    }
};

});

parcelRegister("4OJyR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jTjAh", function(module, exports) {
"use strict";
var $e7b2585db2f7e663$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $aDCKH = parcelRequire("aDCKH");

var $crkkA = parcelRequire("crkkA");

var $295Rt = parcelRequire("295Rt");

var $jFyos = parcelRequire("jFyos");

var $4bOvf = parcelRequire("4bOvf");
const $e7b2585db2f7e663$var$CACHE_LIMIT = 10;
const $e7b2585db2f7e663$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $e7b2585db2f7e663$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $e7b2585db2f7e663$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $e7b2585db2f7e663$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $295Rt._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $295Rt._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $e7b2585db2f7e663$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $crkkA.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $e7b2585db2f7e663$var$__awaiter(this, void 0, void 0, function*() {
            if (!$jFyos.Storage.isReady()) yield $jFyos.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $aDCKH.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $e7b2585db2f7e663$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $295Rt._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $e7b2585db2f7e663$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $aDCKH.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $4bOvf._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $crkkA.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $e7b2585db2f7e663$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $e7b2585db2f7e663$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $aDCKH.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $jFyos.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($jFyos.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $4bOvf._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $e7b2585db2f7e663$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $jFyos.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $jFyos._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $e7b2585db2f7e663$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $jFyos.Storage.removeItem(evictable);
        }
        (0, $jFyos._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $e7b2585db2f7e663$var$DataAdapterCore;
function $e7b2585db2f7e663$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $295Rt._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $e7b2585db2f7e663$var$_makeDataAdapterResult;
class $e7b2585db2f7e663$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $aDCKH.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $e7b2585db2f7e663$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $e7b2585db2f7e663$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("crkkA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $fk15l = parcelRequire("fk15l");

var $aDCKH = parcelRequire("aDCKH");

var $10v51 = parcelRequire("10v51");

var $jFyos = parcelRequire("jFyos");

var $gz2mp = parcelRequire("gz2mp");
const $90e7c6fee6091dc2$var$PROMISE_MAP = {};
const $90e7c6fee6091dc2$var$COOKIE_ENABLED_MAP = {};
const $90e7c6fee6091dc2$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($90e7c6fee6091dc2$var$DISABLED_MAP[sdkKey]) return null;
        if ($90e7c6fee6091dc2$var$PROMISE_MAP[sdkKey] != null) return $90e7c6fee6091dc2$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $90e7c6fee6091dc2$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $90e7c6fee6091dc2$var$PROMISE_MAP[sdkKey] = stableID;
            $90e7c6fee6091dc2$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $90e7c6fee6091dc2$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $gz2mp.getUUID)();
        $90e7c6fee6091dc2$var$_persistToStorage(stableID, sdkKey);
        $90e7c6fee6091dc2$var$_persistToCookie(stableID, sdkKey);
        $90e7c6fee6091dc2$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $90e7c6fee6091dc2$var$PROMISE_MAP[sdkKey] = override;
        $90e7c6fee6091dc2$var$_persistToStorage(override, sdkKey);
        $90e7c6fee6091dc2$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $90e7c6fee6091dc2$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $90e7c6fee6091dc2$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $90e7c6fee6091dc2$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $fk15l._getStorageKey)(sdkKey)}`;
}
function $90e7c6fee6091dc2$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $90e7c6fee6091dc2$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $jFyos._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $aDCKH.Log.warn('Failed to save StableID to storage');
    }
}
function $90e7c6fee6091dc2$var$_loadFromStorage(sdkKey) {
    const storageKey = $90e7c6fee6091dc2$var$_getStableIDStorageKey(sdkKey);
    return (0, $jFyos._getObjectFromStorage)(storageKey);
}
function $90e7c6fee6091dc2$var$_loadFromCookie(sdkKey) {
    if (!$90e7c6fee6091dc2$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $10v51._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $90e7c6fee6091dc2$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $90e7c6fee6091dc2$var$_persistToCookie(stableID, sdkKey) {
    if (!$90e7c6fee6091dc2$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $10v51._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$90e7c6fee6091dc2$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $90e7c6fee6091dc2$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $fk15l._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $90e7c6fee6091dc2$var$getCookieName;

});
parcelRegister("gz2mp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $c0f1bef0e673af0a$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $c0f1bef0e673af0a$var$getUUID;

});


parcelRegister("295Rt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $6aAMI = parcelRequire("6aAMI");

var $aDCKH = parcelRequire("aDCKH");
function $1900f8069460246f$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $aDCKH.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $1900f8069460246f$var$_normalizeUser;
function $1900f8069460246f$var$_getFullUserHash(user) {
    return user ? (0, $6aAMI._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $1900f8069460246f$var$_getFullUserHash;

});

parcelRegister("4bOvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $aDCKH = parcelRequire("aDCKH");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $30cf5d57065bf634$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $aDCKH.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $30cf5d57065bf634$var$_typedJsonParse;

});


parcelRegister("guseT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2JAfF", function(module, exports) {
"use strict";
var $1fdbe78ecdccfffd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $aDCKH = parcelRequire("aDCKH");

var $hfiUu = parcelRequire("hfiUu");

var $3zGbi = parcelRequire("3zGbi");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $1fdbe78ecdccfffd$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $1fdbe78ecdccfffd$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $1fdbe78ecdccfffd$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $1fdbe78ecdccfffd$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $aDCKH.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$1fdbe78ecdccfffd$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($1fdbe78ecdccfffd$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $1fdbe78ecdccfffd$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $hfiUu.SDKType._get(this._sdkKey);
                    const statsigMetadata = $3zGbi.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $1fdbe78ecdccfffd$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $1fdbe78ecdccfffd$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $1fdbe78ecdccfffd$var$ErrorBoundary;
function $1fdbe78ecdccfffd$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $1fdbe78ecdccfffd$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $1fdbe78ecdccfffd$var$UNKNOWN_ERROR;
    }
}
function $1fdbe78ecdccfffd$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $1fdbe78ecdccfffd$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("hfiUu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $c8e2818da28a7f90$var$SDK_CLIENT = {};
let $c8e2818da28a7f90$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $c8e2818da28a7f90$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($c8e2818da28a7f90$var$suffix !== null && $c8e2818da28a7f90$var$suffix !== void 0 ? $c8e2818da28a7f90$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $c8e2818da28a7f90$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$c8e2818da28a7f90$var$suffix || $c8e2818da28a7f90$var$suffix === '-react') $c8e2818da28a7f90$var$suffix = '-' + binding;
    }
};

});


parcelRegister("RboiM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lTJxc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cT8YX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9yvJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $6f4fe67f8b46ee8a$var$EXIST_KEYS = new Set([]);
const $6f4fe67f8b46ee8a$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $6f4fe67f8b46ee8a$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($6f4fe67f8b46ee8a$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($6f4fe67f8b46ee8a$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $6f4fe67f8b46ee8a$var$createMemoKey;

});

parcelRegister("ePaIX", function(module, exports) {
"use strict";
var $acae25b5ce46996d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $d0tJQ = parcelRequire("d0tJQ");

var $d0tJQ = parcelRequire("d0tJQ");

var $fWajo = parcelRequire("fWajo");

var $aDCKH = parcelRequire("aDCKH");

var $dHCaY = parcelRequire("dHCaY");

var $9tm44 = parcelRequire("9tm44");

var $dVrSs = parcelRequire("dVrSs");

var $hfiUu = parcelRequire("hfiUu");

var $10v51 = parcelRequire("10v51");

var $5ZiKt = parcelRequire("5ZiKt");

var $crkkA = parcelRequire("crkkA");

var $K1v6N = parcelRequire("K1v6N");

var $3zGbi = parcelRequire("3zGbi");

var $3rozZ = parcelRequire("3rozZ");

var $g3crm = parcelRequire("g3crm");
const $acae25b5ce46996d$var$DEFAULT_TIMEOUT_MS = 10000;
const $acae25b5ce46996d$var$BACKOFF_BASE_MS = 500;
const $acae25b5ce46996d$var$BACKOFF_MAX_MS = 30000;
const $acae25b5ce46996d$var$RATE_LIMIT_WINDOW_MS = 1000;
const $acae25b5ce46996d$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $acae25b5ce46996d$var$LEAK_RATE = $acae25b5ce46996d$var$RATE_LIMIT_MAX_REQ_COUNT / $acae25b5ce46996d$var$RATE_LIMIT_WINDOW_MS;
const $acae25b5ce46996d$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $acae25b5ce46996d$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $acae25b5ce46996d$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $9tm44.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$acae25b5ce46996d$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $acae25b5ce46996d$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $acae25b5ce46996d$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$acae25b5ce46996d$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $aDCKH.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $g3crm._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $acae25b5ce46996d$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $acae25b5ce46996d$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $acae25b5ce46996d$var$_getErrorMessage(error);
                const timedOut = $acae25b5ce46996d$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $acae25b5ce46996d$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$acae25b5ce46996d$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $K1v6N.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $aDCKH.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $acae25b5ce46996d$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $3rozZ.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $3rozZ.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $acae25b5ce46996d$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $acae25b5ce46996d$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $dHCaY.Endpoint._initialize || args.urlConfig.endpoint === $dHCaY.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$dHCaY.NetworkParam.SdkKey]: args.sdkKey,
            [$dHCaY.NetworkParam.SdkType]: $hfiUu.SDKType._get(args.sdkKey),
            [$dHCaY.NetworkParam.SdkVersion]: $3zGbi.SDK_VERSION,
            [$dHCaY.NetworkParam.Time]: String(Date.now()),
            [$dHCaY.NetworkParam.SessionID]: $5ZiKt.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $10v51._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $d0tJQ._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$dHCaY.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $aDCKH.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $acae25b5ce46996d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$acae25b5ce46996d$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($aDCKH.Log.error);
                writer.close().catch($aDCKH.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$dHCaY.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $aDCKH.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $acae25b5ce46996d$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $acae25b5ce46996d$var$NetworkCore;
const $acae25b5ce46996d$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $aDCKH.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $acae25b5ce46996d$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $crkkA.StableID.get(sdkKey);
    const sessionID = $5ZiKt.SessionID.get(sdkKey);
    const sdkType = $hfiUu.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $3zGbi.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $acae25b5ce46996d$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $d0tJQ._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $dVrSs.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $3rozZ.LogEventCompressionMode.Disabled:
            return false;
        case $3rozZ.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $3rozZ.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $acae25b5ce46996d$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $acae25b5ce46996d$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $acae25b5ce46996d$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $dHCaY.Endpoint._initialize) return;
    $fWajo.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $acae25b5ce46996d$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $dHCaY.Endpoint._initialize) return;
    $fWajo.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $fWajo.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $acae25b5ce46996d$var$_exponentialBackoff(attempt) {
    return $acae25b5ce46996d$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($acae25b5ce46996d$var$BACKOFF_BASE_MS * (attempt * attempt), $acae25b5ce46996d$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("9tm44", function(module, exports) {
"use strict";
var $6e57f01760709504$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $dYncZ = parcelRequire("dYncZ");

var $6aAMI = parcelRequire("6aAMI");

var $aDCKH = parcelRequire("aDCKH");

var $jFyos = parcelRequire("jFyos");
const $6e57f01760709504$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $6e57f01760709504$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $6e57f01760709504$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $6e57f01760709504$var$DEFAULT_TTL_MS;
        $6e57f01760709504$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $6e57f01760709504$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $6e57f01760709504$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $6e57f01760709504$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$6e57f01760709504$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $6e57f01760709504$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $6e57f01760709504$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $6e57f01760709504$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $6e57f01760709504$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $dYncZ._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $6e57f01760709504$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $6e57f01760709504$var$NetworkFallbackResolver;
function $6e57f01760709504$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $6e57f01760709504$var$_isDomainFailure;
function $6e57f01760709504$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $6aAMI._DJB2)(sdkKey)}`;
}
function $6e57f01760709504$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $6e57f01760709504$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $jFyos.Storage.removeItem(hashKey);
        return;
    }
    $jFyos.Storage.setItem(hashKey, JSON.stringify(info));
}
function $6e57f01760709504$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $6e57f01760709504$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $jFyos.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $aDCKH.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $6e57f01760709504$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("dYncZ", function(module, exports) {
"use strict";
var $a2c2e1abd9a45096$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $a2c2e1abd9a45096$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $a2c2e1abd9a45096$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $a2c2e1abd9a45096$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $a2c2e1abd9a45096$var$MAX_START_LOOKUP = 200;
function $a2c2e1abd9a45096$var$_fetchTxtRecords(networkFunc) {
    return $a2c2e1abd9a45096$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($a2c2e1abd9a45096$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $a2c2e1abd9a45096$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $a2c2e1abd9a45096$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $a2c2e1abd9a45096$var$_fetchTxtRecords;
function $a2c2e1abd9a45096$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $a2c2e1abd9a45096$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $a2c2e1abd9a45096$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("dVrSs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $a23639149300b38c$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $a23639149300b38c$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $a23639149300b38c$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("5ZiKt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $d0tJQ = parcelRequire("d0tJQ");

var $fk15l = parcelRequire("fk15l");

var $aDCKH = parcelRequire("aDCKH");

var $jFyos = parcelRequire("jFyos");

var $gz2mp = parcelRequire("gz2mp");
const $45c1315a9ec09a48$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $45c1315a9ec09a48$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $45c1315a9ec09a48$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($45c1315a9ec09a48$var$PROMISE_MAP[sdkKey] == null) $45c1315a9ec09a48$var$PROMISE_MAP[sdkKey] = $45c1315a9ec09a48$var$_loadSession(sdkKey);
        const session = $45c1315a9ec09a48$var$PROMISE_MAP[sdkKey];
        return $45c1315a9ec09a48$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $45c1315a9ec09a48$var$PROMISE_MAP[sdkKey] = $45c1315a9ec09a48$var$_overrideSessionId(override, sdkKey);
    }
};
function $45c1315a9ec09a48$var$_loadSession(sdkKey) {
    let data = $45c1315a9ec09a48$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $gz2mp.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $45c1315a9ec09a48$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $45c1315a9ec09a48$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($45c1315a9ec09a48$var$_isIdle(data) || $45c1315a9ec09a48$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $gz2mp.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $45c1315a9ec09a48$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $45c1315a9ec09a48$var$_createSessionTimeout(sdkKey, $45c1315a9ec09a48$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $45c1315a9ec09a48$var$_createSessionTimeout(sdkKey, $45c1315a9ec09a48$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $45c1315a9ec09a48$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $d0tJQ._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $45c1315a9ec09a48$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $45c1315a9ec09a48$var$MAX_SESSION_IDLE_TIME;
}
function $45c1315a9ec09a48$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $45c1315a9ec09a48$var$MAX_SESSION_AGE;
}
function $45c1315a9ec09a48$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $fk15l._getStorageKey)(sdkKey)}`;
}
function $45c1315a9ec09a48$var$_persistToStorage(session, sdkKey) {
    const storageKey = $45c1315a9ec09a48$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $jFyos._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $aDCKH.Log.warn('Failed to save SessionID');
    }
}
function $45c1315a9ec09a48$var$_loadFromStorage(sdkKey) {
    const storageKey = $45c1315a9ec09a48$var$_getSessionIDStorageKey(sdkKey);
    return (0, $jFyos._getObjectFromStorage)(storageKey);
}

});

parcelRegister("K1v6N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("gafSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dETAM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b4hCf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $80edbb9998ab3c2d$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $80edbb9998ab3c2d$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $80edbb9998ab3c2d$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $80edbb9998ab3c2d$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $80edbb9998ab3c2d$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $80edbb9998ab3c2d$var$_fastApproxSizeOf;

});

parcelRegister("8ZT0R", function(module, exports) {
"use strict";
var $68ceb1a6ba3fef29$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $d0tJQ = parcelRequire("d0tJQ");

var $d0tJQ = parcelRequire("d0tJQ");

var $2JAfF = parcelRequire("2JAfF");

var $klYzh = parcelRequire("klYzh");

var $aDCKH = parcelRequire("aDCKH");

var $9yvJb = parcelRequire("9yvJb");

var $10v51 = parcelRequire("10v51");

var $5ZiKt = parcelRequire("5ZiKt");

var $crkkA = parcelRequire("crkkA");

var $3rozZ = parcelRequire("3rozZ");

var $jFyos = parcelRequire("jFyos");
const $68ceb1a6ba3fef29$var$MAX_MEMO_CACHE_SIZE = 3000;
class $68ceb1a6ba3fef29$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($aDCKH.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $jFyos.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $5ZiKt.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $jFyos.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $crkkA.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $crkkA.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $klYzh.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $2JAfF.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $jFyos.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $68ceb1a6ba3fef29$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $jFyos.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $crkkA.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($3rozZ.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $68ceb1a6ba3fef29$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $aDCKH.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $9yvJb.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $68ceb1a6ba3fef29$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $68ceb1a6ba3fef29$var$StatsigClientBase;
function $68ceb1a6ba3fef29$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $10v51._isServerEnv)()) return;
    const statsigGlobal = (0, $d0tJQ._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $aDCKH.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("iqUIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("5Jp4m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3rcug", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $aDCKH = parcelRequire("aDCKH");

var $9fOOb = parcelRequire("9fOOb");
function $280d9466fe6814f0$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $280d9466fe6814f0$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $280d9466fe6814f0$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $280d9466fe6814f0$var$_makeFeatureGate;
function $280d9466fe6814f0$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $280d9466fe6814f0$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $280d9466fe6814f0$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $280d9466fe6814f0$var$_makeDynamicConfig;
function $280d9466fe6814f0$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $280d9466fe6814f0$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $280d9466fe6814f0$var$_makeExperiment;
function $280d9466fe6814f0$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $280d9466fe6814f0$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $280d9466fe6814f0$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $280d9466fe6814f0$var$_makeLayer;
function $280d9466fe6814f0$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $280d9466fe6814f0$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $280d9466fe6814f0$var$_mergeOverride;
function $280d9466fe6814f0$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9fOOb._isTypeMatch)(found, fallback)) {
            $aDCKH.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $280d9466fe6814f0$var$_makeTypedGet;

});

parcelRegister("d8cWz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3bTyo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $252d7e029439809e$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $252d7e029439809e$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("cACtO", function(module, exports) {
"use strict";
var $92a6b21b614e8823$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dgxg2 = parcelRequire("dgxg2");

var $1VOJb = parcelRequire("1VOJb");

var $9l2iT = parcelRequire("9l2iT");

var $2kZlK = parcelRequire("2kZlK");

var $Km5Ar = parcelRequire("Km5Ar");
class $92a6b21b614e8823$var$StatsigClient extends $dgxg2.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $dgxg2._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $92a6b21b614e8823$var$StatsigClient) return instance;
        $dgxg2.Log.warn((0, $dgxg2._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $92a6b21b614e8823$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $dgxg2.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $9l2iT.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $Km5Ar.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($dgxg2.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($dgxg2.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($dgxg2.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($dgxg2.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($dgxg2.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($dgxg2.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $1VOJb.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $dgxg2.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $dgxg2.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $92a6b21b614e8823$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $dgxg2.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $dgxg2.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $92a6b21b614e8823$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $92a6b21b614e8823$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $dgxg2.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $dgxg2.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $dgxg2.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $dgxg2.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($dgxg2.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $dgxg2.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $dgxg2.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $dgxg2.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $dgxg2.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $dgxg2.StatsigSession.get(this._sdkKey),
            stableID: $dgxg2.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $92a6b21b614e8823$var$__awaiter(this, void 0, void 0, function*() {
            if (!$dgxg2.Storage.isReady()) yield $dgxg2.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $dgxg2.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $dgxg2.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $dgxg2._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$dgxg2.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$dgxg2.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $dgxg2.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $dgxg2._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $dgxg2._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $dgxg2._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $dgxg2._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $dgxg2._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $dgxg2._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $dgxg2._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $dgxg2._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $dgxg2._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $dgxg2._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $2kZlK._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $2kZlK._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $92a6b21b614e8823$var$StatsigClient;

});
parcelRegister("1VOJb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dgxg2 = parcelRequire("dgxg2");

var $dPTBZ = parcelRequire("dPTBZ");

var $hn77n = parcelRequire("hn77n");
class $168276c98d8ba2c6$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $dgxg2._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $dgxg2._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $hn77n.V2InitializeContainer(values);
        else this._values = new $dPTBZ.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $dgxg2.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $dgxg2.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $dgxg2._getFullUserHash)(userForComparison) !== (0, $dgxg2._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $168276c98d8ba2c6$var$EvaluationStore;

});
parcelRegister("dPTBZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $dgxg2 = parcelRequire("dgxg2");
class $a12b2d1874f149ac$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dgxg2._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $a12b2d1874f149ac$var$V1InitializeContainer;

});

parcelRegister("hn77n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $dgxg2 = parcelRequire("dgxg2");
class $ca5a1b27909d850a$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $dgxg2._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $ca5a1b27909d850a$var$V2InitializeContainer;

});


parcelRegister("9l2iT", function(module, exports) {
"use strict";
var $6cc7dcb4a102f021$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dgxg2 = parcelRequire("dgxg2");

var $1ry9J = parcelRequire("1ry9J");
class $6cc7dcb4a102f021$var$StatsigNetwork extends $dgxg2.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $dgxg2.UrlConfiguration($dgxg2.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $6cc7dcb4a102f021$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $dgxg2._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $6cc7dcb4a102f021$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $1ry9J._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $6cc7dcb4a102f021$var$StatsigNetwork;

});
parcelRegister("1ry9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $dgxg2 = parcelRequire("dgxg2");
const $10d2ceb9b9ec5322$var$MAX_DELTAS_SORT_DEPTH = 2;
function $10d2ceb9b9ec5322$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $dgxg2._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $10d2ceb9b9ec5322$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $10d2ceb9b9ec5322$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $dgxg2._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $10d2ceb9b9ec5322$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $10d2ceb9b9ec5322$var$_resolveDeltasResponse;
function $10d2ceb9b9ec5322$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $10d2ceb9b9ec5322$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $10d2ceb9b9ec5322$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $10d2ceb9b9ec5322$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $10d2ceb9b9ec5322$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $10d2ceb9b9ec5322$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("2kZlK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $dgxg2 = parcelRequire("dgxg2");
const $1b3d09cbe3172fbb$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $1b3d09cbe3172fbb$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $1b3d09cbe3172fbb$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $dgxg2._isTypeMatch)(value, fallback);
}
function $1b3d09cbe3172fbb$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $1b3d09cbe3172fbb$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $1b3d09cbe3172fbb$var$_shouldLogExposure(options) ? undefined : $1b3d09cbe3172fbb$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $1b3d09cbe3172fbb$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $1b3d09cbe3172fbb$var$_shouldLogExposure(options) ? undefined : $1b3d09cbe3172fbb$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($1b3d09cbe3172fbb$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1b3d09cbe3172fbb$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $1b3d09cbe3172fbb$var$_shouldLogExposure(options) ? undefined : $1b3d09cbe3172fbb$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($1b3d09cbe3172fbb$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1b3d09cbe3172fbb$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $1b3d09cbe3172fbb$var$_shouldLogExposure(options) ? undefined : $1b3d09cbe3172fbb$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($1b3d09cbe3172fbb$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $1b3d09cbe3172fbb$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $dgxg2._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $1b3d09cbe3172fbb$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $1b3d09cbe3172fbb$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $1b3d09cbe3172fbb$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $1b3d09cbe3172fbb$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $1b3d09cbe3172fbb$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $1b3d09cbe3172fbb$var$_makeParamStoreGetter;

});

parcelRegister("Km5Ar", function(module, exports) {
"use strict";
var $08b56e6e00a381ca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $dgxg2 = parcelRequire("dgxg2");

var $9l2iT = parcelRequire("9l2iT");
class $08b56e6e00a381ca$var$StatsigEvaluationsDataAdapter extends $dgxg2.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $9l2iT.default) this._network = network;
        else this._network = new $9l2iT.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $dgxg2._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $dgxg2._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $dgxg2.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $08b56e6e00a381ca$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $dgxg2._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$dgxg2.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $dgxg2._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $08b56e6e00a381ca$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("cCLub", function(module, exports) {
$parcel$export(module.exports, "default", () => $5bcc78d955c375c8$export$2e2bcd8739ae039);

var $LbBeD = parcelRequire("LbBeD");
const $5bcc78d955c375c8$export$a66cbd9b2289cd78 = '@all-features';
class $5bcc78d955c375c8$export$2e2bcd8739ae039 {
    constructor(){
        this.eventToValue = new Map();
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($LbBeD)))();
    }
    onGateUpdated(gateName, callback, checkGate, options) {
        const value = checkGate(gateName, {
            ...options,
            fireGateExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = checkGate(gateName, {
                ...options,
                fireGateExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(gateName, wrapCallback);
        return ()=>{
            this.emitter.off(gateName, wrapCallback);
        };
    }
    onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
        const experimentEventName = `${experimentName}.${parameterName}`;
        const value = getExperimentValue(experimentName, parameterName, defaultValue, {
            ...options,
            fireExperimentExposure: false
        });
        if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
        const wrapCallback = ()=>{
            const value = getExperimentValue(experimentName, parameterName, defaultValue, {
                ...options,
                fireExperimentExposure: false
            });
            const existingValue = this.eventToValue.get(callback);
            if (existingValue !== value) {
                this.eventToValue.set(callback, value);
                callback(value);
            }
        };
        this.emitter.on(experimentEventName, wrapCallback);
        return ()=>{
            this.emitter.off(experimentEventName, wrapCallback);
        };
    }
    onAnyUpdated(callback) {
        this.emitter.on($5bcc78d955c375c8$export$a66cbd9b2289cd78, callback);
        return ()=>{
            this.emitter.off($5bcc78d955c375c8$export$a66cbd9b2289cd78, callback);
        };
    }
    anyUpdated() {
        this.emitter.emit($5bcc78d955c375c8$export$a66cbd9b2289cd78);
        this.emitter.eventNames().filter((name)=>name !== $5bcc78d955c375c8$export$a66cbd9b2289cd78).forEach((event)=>{
            this.emitter.emit(event);
        });
    }
}

});
parcelRegister("LbBeD", function(module, exports) {
'use strict';
var $08dd635550ab4152$var$has = Object.prototype.hasOwnProperty, $08dd635550ab4152$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $08dd635550ab4152$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $08dd635550ab4152$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $08dd635550ab4152$var$Events().__proto__) $08dd635550ab4152$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $08dd635550ab4152$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $08dd635550ab4152$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $08dd635550ab4152$var$EE(fn, context || emitter, once), evt = $08dd635550ab4152$var$prefix ? $08dd635550ab4152$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $08dd635550ab4152$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $08dd635550ab4152$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $08dd635550ab4152$var$EventEmitter() {
    this._events = new $08dd635550ab4152$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($08dd635550ab4152$var$has.call(events, name)) names.push($08dd635550ab4152$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $08dd635550ab4152$var$prefix ? $08dd635550ab4152$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $08dd635550ab4152$var$prefix ? $08dd635550ab4152$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $08dd635550ab4152$var$prefix ? $08dd635550ab4152$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $08dd635550ab4152$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $08dd635550ab4152$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $08dd635550ab4152$var$prefix ? $08dd635550ab4152$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $08dd635550ab4152$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $08dd635550ab4152$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $08dd635550ab4152$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $08dd635550ab4152$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $08dd635550ab4152$var$prefix ? $08dd635550ab4152$var$prefix + event : event;
        if (this._events[evt]) $08dd635550ab4152$var$clearEvent(this, evt);
    } else {
        this._events = new $08dd635550ab4152$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$08dd635550ab4152$var$EventEmitter.prototype.off = $08dd635550ab4152$var$EventEmitter.prototype.removeListener;
$08dd635550ab4152$var$EventEmitter.prototype.addListener = $08dd635550ab4152$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$08dd635550ab4152$var$EventEmitter.prefixed = $08dd635550ab4152$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$08dd635550ab4152$var$EventEmitter.EventEmitter = $08dd635550ab4152$var$EventEmitter;
module.exports = $08dd635550ab4152$var$EventEmitter;

});


parcelRegister("2X0hi", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", () => $0f9225d08d3b2a4f$export$6dc24881a3d96325);

var $4Ziou = parcelRequire("4Ziou");
class $0f9225d08d3b2a4f$export$6dc24881a3d96325 {
    static fromExperiment(experiment) {
        var _experiment$__evaluat;
        const config = new $0f9225d08d3b2a4f$export$6dc24881a3d96325(experiment.name, experiment.value, experiment.ruleID, (0, $4Ziou.migrateEvaluationDetails)(experiment.details), (0, $4Ziou.migrateSecondaryExposures)(((_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures) ?? []), experiment.groupName ?? undefined);
        config.experiment = experiment;
        return config;
    }
    constructor(configName, configValue, ruleID, evaluationDetails, secondaryExposures = [], allocatedExperimentName = '', onDefaultValueFallback = null){
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    get(key, defaultValue, typeGuard) {
        var _this$_onDefaultValue2;
        const val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        const expectedType = Array.isArray(defaultValue) ? 'array' : typeof defaultValue;
        const actualType = Array.isArray(val) ? 'array' : typeof val;
        if (typeGuard) {
            var _this$_onDefaultValue;
            if (typeGuard(val)) {
                this.fireExposure(key);
                return val;
            }
            (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) {
            this.fireExposure(key);
            return val;
        }
        (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
        return defaultValue;
    }
    getValue(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        this.fireExposure(key);
        return this.value[key];
    }
    fireExposure(key) {
        // Call the wrapped experiment's get method to fire exposure
        if (this.experiment) this.experiment.get(key);
    }
}

});
parcelRegister("4Ziou", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", () => $1cbcf68ad92d929c$export$d119b37e5f788b43);
$parcel$export(module.exports, "shallowEquals", () => $1cbcf68ad92d929c$export$fa1c2bbf4100b8bc);
$parcel$export(module.exports, "toStatsigUser", () => $1cbcf68ad92d929c$export$3dad1db244472f32);
$parcel$export(module.exports, "deepAssign", () => $1cbcf68ad92d929c$export$1148cb79ceecd5fa);
$parcel$export(module.exports, "migrateInitializationOptions", () => $1cbcf68ad92d929c$export$202946b690d26d22);
$parcel$export(module.exports, "migrateEvaluationDetails", () => $1cbcf68ad92d929c$export$18ad168d3dbac899);
$parcel$export(module.exports, "migrateSecondaryExposures", () => $1cbcf68ad92d929c$export$55fd683752d01e67);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dvNUn = parcelRequire("dvNUn");

var $8pk1w = parcelRequire("8pk1w");

var $cRymc = parcelRequire("cRymc");
const $1cbcf68ad92d929c$export$d119b37e5f788b43 = (options)=>({
        /**
   * If more federal PerimeterTypes are added in the future, this should be updated so
   * that isFedRamp() === true always returns the strictest perimeter.
   */ perimeter: (0, $dvNUn.isFedRamp)() ? (0, $cRymc.PerimeterType).FEDRAMP_MODERATE : (0, $cRymc.PerimeterType).COMMERCIAL,
        ...options
    });
const $1cbcf68ad92d929c$export$fa1c2bbf4100b8bc = (objectA, objectB)=>{
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    const aEntries = Object.entries(objectA);
    const bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    const ascendingKeyOrder = ([key1], [key2])=>key1.localeCompare(key2);
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(let i = 0; i < aEntries.length; i++){
        const [, aValue] = aEntries[i];
        const [, bValue] = bEntries[i];
        if (aValue !== bValue) return false;
    }
    return true;
};
const $1cbcf68ad92d929c$export$3dad1db244472f32 = (identifiers, customAttributes)=>{
    // Re-map `stableId` to `stableID` to match Statsig's native type.
    const { stableId: stableId, ...otherIdentifiers } = identifiers;
    const user = {
        customIDs: {
            ...otherIdentifiers,
            ...stableId !== undefined ? {
                stableID: stableId
            } : {}
        },
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
function $1cbcf68ad92d929c$export$1148cb79ceecd5fa(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if (source === undefined || source === null) return $1cbcf68ad92d929c$export$1148cb79ceecd5fa(target, ...sources);
    for (const [key, src] of Object.entries(source)){
        const dst = target[key];
        const srcIsObj = src && typeof src === 'object' && !Array.isArray(src);
        const dstIsObj = dst && typeof dst === 'object' && !Array.isArray(dst);
        if (srcIsObj && dstIsObj) target[key] = $1cbcf68ad92d929c$export$1148cb79ceecd5fa(dst, src);
        else target[key] = src;
    }
    return $1cbcf68ad92d929c$export$1148cb79ceecd5fa(target, ...sources);
}
const $1cbcf68ad92d929c$export$202946b690d26d22 = (options)=>{
    const { api: api, disableCurrentPageLogging: disableCurrentPageLogging, loggingIntervalMillis: loggingIntervalMillis, loggingBufferMaxSize: loggingBufferMaxSize, localMode: localMode, eventLoggingApi: eventLoggingApi, eventLoggingApiForRetries: eventLoggingApiForRetries, disableLocalStorage: disableLocalStorage, ignoreWindowUndefined: ignoreWindowUndefined, disableAllLogging: disableAllLogging, // No equivalent but is pointless anyway since our Statsig init is synchronous
    initTimeoutMs: _initTimeoutMs, // No equivalent in new client but probably not important?
    disableNetworkKeepalive: _disableNetworkKeepalive, // Needs to be implemented manually but unused according to zoekt
    overrideStableID: _overrideStableID, // No equivalent for these but can't see them actually used anywhere in old client?
    disableErrorLogging: _disableErrorLogging, disableAutoMetricsLogging: _disableAutoMetricsLogging, ...rest } = options;
    return {
        ...rest,
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    };
};
const $1cbcf68ad92d929c$var$evaluationReasonMappings = Object.entries((0, $8pk1w.EvaluationReason)).map(([key, value])=>[
        key.toLowerCase(),
        value
    ]);
const $1cbcf68ad92d929c$export$18ad168d3dbac899 = (details)=>{
    var _evaluationReasonMapp;
    const reasonLower = details.reason.toLowerCase();
    return {
        reason: ((_evaluationReasonMapp = $1cbcf68ad92d929c$var$evaluationReasonMappings.find(([key])=>reasonLower.includes(key))) === null || _evaluationReasonMapp === void 0 ? void 0 : _evaluationReasonMapp[1]) ?? (0, $8pk1w.EvaluationReason).Unknown,
        time: details.receivedAt ?? Date.now()
    };
};
const $1cbcf68ad92d929c$export$55fd683752d01e67 = (secondaryExposures)=>{
    return secondaryExposures.map((exposure)=>{
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("dvNUn", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $47741a7235f33562$export$64d6499adf9b2e51);

var $5cZjp = parcelRequire("5cZjp");
function $47741a7235f33562$export$64d6499adf9b2e51() {
    var _global$location;
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $5cZjp.FEDRAMP_MODERATE);
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("5cZjp", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $ac72e6ac400c91c0$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $ac72e6ac400c91c0$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "FEDRAMP_FEDEX", () => $ac72e6ac400c91c0$export$bd6b5a7802d76127);
$parcel$export(module.exports, "STAGING", () => $ac72e6ac400c91c0$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $ac72e6ac400c91c0$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $ac72e6ac400c91c0$export$404582bc18fe4d9e);
const $ac72e6ac400c91c0$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $ac72e6ac400c91c0$export$f005e2e9f707cb5f = 'commercial';
const $ac72e6ac400c91c0$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $ac72e6ac400c91c0$export$a739cd5aac835909 = 'stg';
const $ac72e6ac400c91c0$export$42dd0cdd351a4a9 = 'prod';
const $ac72e6ac400c91c0$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("8pk1w", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", () => $4a585cc88bbc323c$export$c62558b199e46828);
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
const $4a585cc88bbc323c$export$c62558b199e46828 = {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    Error: 'Error',
    LocalOverride: 'LocalOverride',
    Unrecognized: 'Unrecognized',
    Uninitialized: 'Uninitialized',
    NetworkNotModified: 'NetworkNotModified',
    Network: 'Network',
    InvalidBootstrap: 'InvalidBootstrap',
    Bootstrap: 'Bootstrap',
    Cache: 'Cache',
    // For when we could not migrate the reason from the new client
    Unknown: 'Unknown'
};

});

parcelRegister("cRymc", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", () => $77216008ececf1c8$export$479e7351a733299);
$parcel$export(module.exports, "PerimeterType", () => $77216008ececf1c8$export$c42b7bbc5e7ba555);
const $77216008ececf1c8$export$479e7351a733299 = {
    Development: 'development',
    Staging: 'staging',
    Production: 'production'
};
const $77216008ececf1c8$export$c42b7bbc5e7ba555 = {
    COMMERCIAL: 'commercial',
    FEDRAMP_MODERATE: 'fedramp-moderate'
};
const $77216008ececf1c8$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("h2XTF", function(module, exports) {
$parcel$export(module.exports, "Layer", () => $9cc59d1bc2bb6138$export$936d0764594b6eb3);

var $4Ziou = parcelRequire("4Ziou");
class $9cc59d1bc2bb6138$export$936d0764594b6eb3 {
    static fromLayer(layer) {
        var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
        const value = new $9cc59d1bc2bb6138$export$936d0764594b6eb3(layer.name, layer.__value, layer.ruleID, (0, $4Ziou.migrateEvaluationDetails)(layer.details), (_layer, parameterName)=>layer.get(parameterName), (0, $4Ziou.migrateSecondaryExposures)(((_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) ?? []), (0, $4Ziou.migrateSecondaryExposures)(((_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) ?? []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
        return value;
    }
    constructor(name, layerValue, ruleID, evaluationDetails, logParameterFunction = null, secondaryExposures = [], undelegatedSecondaryExposures = [], allocatedExperimentName = '', explicitParameters = []){
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue ?? {}));
        this._ruleID = ruleID ?? '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    get(key, defaultValue, typeGuard) {
        const val = this._value[key];
        if (val == null) return defaultValue;
        const logAndReturn = ()=>{
            this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    }
    getValue(key, defaultValue) {
        // eslint-disable-next-line eqeqeq
        if (defaultValue == undefined) defaultValue = null;
        const val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val ?? defaultValue;
    }
    _logLayerParameterExposure(parameterName) {
        var _this$_logParameterFu;
        (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
    }
}

});

parcelRegister("jBevt", function(module, exports) {
$parcel$export(module.exports, "default", () => $77ddea7612c83ef4$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cRymc = parcelRequire("cRymc");

var $cbYMC = parcelRequire("cbYMC");

var $kp1y4 = parcelRequire("kp1y4");
const $77ddea7612c83ef4$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
const $77ddea7612c83ef4$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
const $77ddea7612c83ef4$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
const $77ddea7612c83ef4$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
const $77ddea7612c83ef4$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $77ddea7612c83ef4$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
const $77ddea7612c83ef4$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
const $77ddea7612c83ef4$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
const $77ddea7612c83ef4$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
const $77ddea7612c83ef4$export$450bd8fb2a6d7ace = '/gateway/api/flags';
class $77ddea7612c83ef4$export$2e2bcd8739ae039 {
    static async fetchClientSdk(fetcherOptions) {
        const { targetApp: targetApp } = fetcherOptions;
        const url = `/api/v2/frontend/clientSdkKey/${targetApp}`;
        try {
            return await this.fetchRequest(url, 'GET', fetcherOptions);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve client sdk key');
        }
    }
    static async fetchExperimentValues(fetcherOptions, identifiers, customAttributes) {
        const requestBody = {
            identifiers: identifiers,
            customAttributes: customAttributes,
            targetApp: fetcherOptions.targetApp
        };
        try {
            return await this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
        } catch (error) {
            if (error instanceof Error) throw error;
            throw Error('Failed to retrieve experiment values');
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $kp1y4.ResponseError)(`Non 2xx response status received, status: ${response.status}, body: ${JSON.stringify(body)}`);
        }
        if (response.status === 204) throw new (0, $kp1y4.ResponseError)('Unexpected 204 response');
    }
    static async extractResponseBody(response) {
        const value = await response.text();
        return JSON.parse(value);
    }
    static getBaseUrl(serviceEnv, useGatewayUrl = false, perimeter, isolationContextId = null) {
        if (useGatewayUrl) return $77ddea7612c83ef4$export$450bd8fb2a6d7ace;
        if (perimeter === (0, $cRymc.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
            case (0, $cRymc.FeatureGateEnvironment).Production:
                return $77ddea7612c83ef4$export$18c93900db9358a4;
            case (0, $cRymc.FeatureGateEnvironment).Staging:
                return $77ddea7612c83ef4$export$1a401a0da8da3565;
            default:
                throw new Error(`Invalid environment "${serviceEnv}" for "${perimeter}" perimeter`);
        }
        else if (perimeter === (0, $cRymc.PerimeterType).COMMERCIAL) switch(serviceEnv){
            case (0, $cRymc.FeatureGateEnvironment).Development:
                return $77ddea7612c83ef4$export$f058dbf75c3bc647;
            case (0, $cRymc.FeatureGateEnvironment).Staging:
                const apiUrl = this.getApiUrl(isolationContextId);
                if (apiUrl !== null) return apiUrl;
                return $77ddea7612c83ef4$export$942ba04389b0d5a2;
            default:
                const prodApiUrl = this.getApiUrl(isolationContextId);
                if (prodApiUrl !== null) return prodApiUrl;
                return $77ddea7612c83ef4$export$250a58ecde616daa;
        }
        else throw new Error(`Invalid perimeter "${perimeter}"`);
    }
    static async fetchRequest(path, method, fetcherOptions, body) {
        const baseUrl = $77ddea7612c83ef4$export$2e2bcd8739ae039.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
        const fetchTimeout = fetcherOptions.fetchTimeoutMs || $77ddea7612c83ef4$var$DEFAULT_REQUEST_TIMEOUT_MS;
        let abortSignal;
        if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
        else if (AbortController) {
            const abortController = new AbortController();
            abortSignal = abortController.signal;
            setTimeout(()=>abortController.abort(), fetchTimeout);
        }
        const response = await fetch(`${baseUrl}${path}`, {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'X-Client-Name': 'feature-gate-js-client',
                'X-Client-Version': (0, $cbYMC.CLIENT_VERSION),
                'X-API-KEY': fetcherOptions.apiKey
            },
            signal: abortSignal,
            ...body && {
                body: JSON.stringify(body)
            }
        });
        await this.handleResponseError(response);
        return await this.extractResponseBody(response);
    }
    static getApiUrl(isolationContextId) {
        const window1 = this.getWindowLocation();
        if (window1 === undefined) {
            //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
            if (!isolationContextId) return null;
            return $77ddea7612c83ef4$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
        }
        const { protocol: protocol, hostname: hostname } = window1;
        // Match last subdomain fragment before oasis-stg.com
        const oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
        if (oasisMatch) return `${protocol}//api.${oasisMatch[1]}.${$77ddea7612c83ef4$export$cb3cd156f70d7e94}`;
        // Match last subdomain fragment before atlassian-isolated.net
        const isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
        if (isolatedMatch) return `${protocol}//api.${isolatedMatch[1]}.${$77ddea7612c83ef4$export$921fbc6cdfd4eee0}`;
        return null;
    }
    static getWindowLocation() {
        if (typeof window !== 'undefined' && window.location) return window.location;
        return undefined;
    }
}

});
parcelRegister("cbYMC", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", () => $ab2e64f07bba4587$export$a59f8d67326bd1cb);
/// <reference types="node" />
const $ab2e64f07bba4587$export$a59f8d67326bd1cb = undefined;

});

parcelRegister("kp1y4", function(module, exports) {
$parcel$export(module.exports, "ResponseError", () => $9329230e0b5d62dd$export$286baf652d0b1206);
class $9329230e0b5d62dd$export$286baf652d0b1206 extends Error {
    constructor(message){
        super(message);
    }
}

});


parcelRegister("eXiWc", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", () => $a16fbe10a9ca1377$export$55fffef3474104af);

var $8QPpE = parcelRequire("8QPpE");
class $a16fbe10a9ca1377$export$55fffef3474104af extends (0, $8QPpE.DataAdapterCore) {
    constructor(){
        super('NoFetchDataAdapter', 'nofetch'), this.bootstrapResult = null;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ setBootstrapData(data) {
        this.bootstrapResult = data ? {
            source: 'Bootstrap',
            data: JSON.stringify(data),
            receivedAt: Date.now(),
            stableID: (0, $8QPpE.StableID).get(this._getSdkKey()),
            fullUserHash: null
        } : null;
    }
    async prefetchData(_user, _options) {}
    async getDataAsync(_current, user, _options) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $8QPpE._getFullUserHash)(user)
        };
    }
    getDataSync(user) {
        return this.bootstrapResult && {
            ...this.bootstrapResult,
            fullUserHash: (0, $8QPpE._getFullUserHash)(user)
        };
    }
    async _fetchFromNetwork(_current, _user, _options) {
        return null;
    }
    _getCacheKey(user) {
        // Same logic as default data adapter
        // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
        const key = (0, $8QPpE._getStorageKey)(this._getSdkKey(), user);
        return `${0, $8QPpE.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(_result, _user) {
        return false;
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    // Do not stringify options property since that includes this adapter and will
    // cause a circular reference when Statsig sends diagnostic events and including
    // values is not necessary and makes the result huge
    toJSON() {
        const result = {
            ...this
        };
        delete result._options;
        delete result._inMemoryCache;
        delete result.bootstrapResult;
        return result;
    }
}

});

parcelRegister("2QFvP", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", () => $024daaca1a8d6c98$export$d8474cff104280f3);
$parcel$export(module.exports, "PersistentOverrideAdapter", () => $024daaca1a8d6c98$export$bcb28fbac1def494);

var $dgxg2 = parcelRequire("dgxg2");
const $024daaca1a8d6c98$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
const $024daaca1a8d6c98$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
const $024daaca1a8d6c98$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
const $024daaca1a8d6c98$var$makeEmptyStore = ()=>({
        gates: {},
        configs: {},
        layers: {}
    });
const $024daaca1a8d6c98$var$djb2MapKey = (hash, kind)=>kind + ':' + hash;
class $024daaca1a8d6c98$export$bcb28fbac1def494 {
    constructor(localStorageKey){
        this._overrides = $024daaca1a8d6c98$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    parseStoredOverrides(localStorageKey) {
        try {
            const json = window.localStorage.getItem(localStorageKey);
            if (!json) return $024daaca1a8d6c98$var$makeEmptyStore();
            return JSON.parse(json);
        } catch  {
            return $024daaca1a8d6c98$var$makeEmptyStore();
        }
    }
    mergeOverrides(...allOverrides) {
        const merged = $024daaca1a8d6c98$var$makeEmptyStore();
        for (const overrides of allOverrides){
            for (const [name, value] of Object.entries(overrides.gates ?? {}))merged.gates[name] = value;
            for (const [name, value] of Object.entries(overrides.configs ?? {}))merged.configs[name] = value;
            for (const [name, value] of Object.entries(overrides.layers ?? {}))merged.layers[name] = value;
        }
        return merged;
    }
    initFromStoredOverrides() {
        const storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($024daaca1a8d6c98$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
        // Clear data from legacy local storage key now we've read from it.
        // This prevents things being stuck in there that are always read but never written to.
        try {
            window.localStorage.removeItem($024daaca1a8d6c98$var$LEGACY_LOCAL_STORAGE_KEY);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
        // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
        // multiple hashes to continue being created. This code here removes these hashes since we've moved
        // to using a more reliable and easier to maintain map in `_djb2Map`.
        for (const container of Object.values(storedOverrides)){
            const allKeys = new Set(Object.keys(container));
            for (const name of allKeys){
                const hash = (0, $dgxg2._DJB2)(name);
                if (allKeys.has(hash)) delete container[hash];
            }
        }
        this.applyOverrides(storedOverrides);
    }
    saveOverrides() {
        try {
            window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getOverrides() {
        return this.mergeOverrides(this._overrides);
    }
    applyOverrides(overrides) {
        const newOverrides = {
            ...$024daaca1a8d6c98$var$makeEmptyStore(),
            ...overrides
        };
        this._djb2Map.clear();
        for (const [containerName, container] of Object.entries(newOverrides))for (const [name, value] of Object.entries(container))this._djb2Map.set($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), containerName), value);
        this._overrides = newOverrides;
    }
    setOverrides(overrides) {
        this.applyOverrides(overrides);
        this.saveOverrides();
    }
    overrideGate(name, value) {
        this._overrides.gates[name] = value;
        this._djb2Map.set($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'gates'), value);
        this.saveOverrides();
    }
    removeGateOverride(name) {
        delete this._overrides.gates[name];
        this._djb2Map.delete($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'gates'));
        this.saveOverrides();
    }
    getGateOverride(current, _user) {
        const overridden = this._overrides.gates[current.name] ?? this._djb2Map.get($024daaca1a8d6c98$var$djb2MapKey(current.name, 'gates'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            details: {
                ...current.details,
                reason: $024daaca1a8d6c98$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    overrideDynamicConfig(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeDynamicConfigOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getDynamicConfigOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideExperiment(name, value) {
        this._overrides.configs[name] = value;
        this._djb2Map.set($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'configs'), value);
        this.saveOverrides();
    }
    removeExperimentOverride(name) {
        delete this._overrides.configs[name];
        this._djb2Map.delete($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'configs'));
        this.saveOverrides();
    }
    getExperimentOverride(current, _user) {
        return this._getConfigOverride(current, this._overrides.configs);
    }
    overrideLayer(name, value) {
        this._overrides.layers[name] = value;
        this._djb2Map.set($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'layers'), value);
        this.saveOverrides();
    }
    removeLayerOverride(name) {
        delete this._overrides.layers[name];
        this._djb2Map.delete($024daaca1a8d6c98$var$djb2MapKey((0, $dgxg2._DJB2)(name), 'layers'));
        this.saveOverrides();
    }
    removeAllOverrides() {
        this._overrides = $024daaca1a8d6c98$var$makeEmptyStore();
        try {
            window.localStorage.removeItem(this._localStorageKey);
        } catch  {
        // ignored - window is not defined in non-browser environments, and we don't save things there
        // (things like SSR, etc)
        }
    }
    getLayerOverride(current, _user) {
        const overridden = this._overrides.layers[current.name] ?? this._djb2Map.get($024daaca1a8d6c98$var$djb2MapKey(current.name, 'layers'));
        if (overridden == null) return null;
        return {
            ...current,
            __value: overridden,
            get: (0, $dgxg2._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $024daaca1a8d6c98$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
    _getConfigOverride(current, lookup) {
        const overridden = lookup[current.name] ?? this._djb2Map.get($024daaca1a8d6c98$var$djb2MapKey(current.name, 'configs'));
        if (overridden == null) return null;
        return {
            ...current,
            value: overridden,
            get: (0, $dgxg2._makeTypedGet)(current.name, overridden),
            details: {
                ...current.details,
                reason: $024daaca1a8d6c98$var$LOCAL_OVERRIDE_REASON
            }
        };
    }
}

});



parcelRegister("1H16G", function(module, exports) {
$parcel$export(module.exports, "debug", () => $c4be9d41a8748e54$export$1c9f709888824e05);
var $c4be9d41a8748e54$var$_process, $c4be9d41a8748e54$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
const $c4be9d41a8748e54$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($c4be9d41a8748e54$var$_process = globalThis.process) === null || $c4be9d41a8748e54$var$_process === void 0 || ($c4be9d41a8748e54$var$_process = $c4be9d41a8748e54$var$_process.env) === null || $c4be9d41a8748e54$var$_process === void 0 ? void 0 : $c4be9d41a8748e54$var$_process.JEST_WORKER_ID) !== undefined;
const $c4be9d41a8748e54$var$DEBUG_MODE = !$c4be9d41a8748e54$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($c4be9d41a8748e54$var$_process2 = globalThis.process) === null || $c4be9d41a8748e54$var$_process2 === void 0 || ($c4be9d41a8748e54$var$_process2 = $c4be9d41a8748e54$var$_process2.env) === null || $c4be9d41a8748e54$var$_process2 === void 0 ? void 0 : $c4be9d41a8748e54$var$_process2.NODE_ENV) !== 'production';
const $c4be9d41a8748e54$export$1c9f709888824e05 = (...args)=>{
    if (!$c4be9d41a8748e54$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    console.debug(...args);
};

});



parcelRegister("4Bdcb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e408330aea26d5fa$export$2e2bcd8739ae039);
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $e408330aea26d5fa$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $e408330aea26d5fa$export$2e2bcd8739ae039 = $e408330aea26d5fa$var$coinflip;

});

parcelRegister("2zDxj", function(module, exports) {
$parcel$export(module.exports, "sanitizeTimingName", () => $40198db53c096909$export$23e69abaca7d0236);

var $3H4LK = parcelRequire("3H4LK");
const $40198db53c096909$export$4c07c8a3507ce307 = 255;
const $40198db53c096909$var$GQL_OPERATION_PARAMS = [
    'operation',
    'operationName',
    'q'
];
function $40198db53c096909$var$isGqlUrl(name) {
    try {
        const url = new URL(name);
        const searchParams = url.search ? new URLSearchParams(url.search) : null;
        return $40198db53c096909$var$GQL_OPERATION_PARAMS.some((param)=>Boolean(searchParams === null || searchParams === void 0 ? void 0 : searchParams.get(param)));
    } catch  {
        return false;
    }
}
function $40198db53c096909$export$23e69abaca7d0236(name) {
    if (name.length <= $40198db53c096909$export$4c07c8a3507ce307) return name;
    if ($40198db53c096909$var$isGqlUrl(name) && (0, $3H4LK.fg)('platform_ufo_exclude_gql_timings_from_length_trim')) return name;
    return name.slice(0, $40198db53c096909$export$4c07c8a3507ce307);
}

});

parcelRegister("jFknK", function(module, exports) {
$parcel$export(module.exports, "isFedrampOverrideActive", () => $fb44fa87aea127a1$export$1133b5e2873baa7a);
$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", () => $fb44fa87aea127a1$export$f9bb3bb330fb9609);
$parcel$export(module.exports, "setUFOConfig", () => $fb44fa87aea127a1$export$10d6139a8fb42158);
$parcel$export(module.exports, "getConfig", () => $fb44fa87aea127a1$export$44487a86467333c3);
$parcel$export(module.exports, "getSelectorConfig", () => $fb44fa87aea127a1$export$59e1f072477dfb48);
$parcel$export(module.exports, "isUFOEnabled", () => $fb44fa87aea127a1$export$74bdb753f1cf4860);
$parcel$export(module.exports, "isVCRevisionEnabled", () => $fb44fa87aea127a1$export$4babcefc81a3ef0b);
$parcel$export(module.exports, "getMostRecentVCRevision", () => $fb44fa87aea127a1$export$70184d6e2c753893);
$parcel$export(module.exports, "getReactHydrationStats", () => $fb44fa87aea127a1$export$2d8f8d64dc343d7b);
$parcel$export(module.exports, "getInteractionRate", () => $fb44fa87aea127a1$export$9466a8f085fa7d4e);
$parcel$export(module.exports, "getVCRawDataInteractionRate", () => $fb44fa87aea127a1$export$48f4e0d964030a96);
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", () => $fb44fa87aea127a1$export$9c69f5a724f05f38);
$parcel$export(module.exports, "getPostInteractionRate", () => $fb44fa87aea127a1$export$1d459f020c06ae34);
$parcel$export(module.exports, "getCapabilityRate", () => $fb44fa87aea127a1$export$29b9ffb14861a1d);
$parcel$export(module.exports, "isInteractionExtraMetricsEnabled", () => $fb44fa87aea127a1$export$6af5b3c526928d44);
$parcel$export(module.exports, "getExtraInteractionRate", () => $fb44fa87aea127a1$export$203bd06a99c66a0d);
$parcel$export(module.exports, "getAwaitBM3TTIList", () => $fb44fa87aea127a1$export$2d311b3fd18dcab1);
$parcel$export(module.exports, "getUfoNameOverrides", () => $fb44fa87aea127a1$export$4f4649ef27b6f5d6);
$parcel$export(module.exports, "getMinorInteractions", () => $fb44fa87aea127a1$export$b150ddad71c80d77);
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", () => $fb44fa87aea127a1$export$3c170167645a0eff);
$parcel$export(module.exports, "getDoNotAbortActivePressInteractionOnTransition", () => $fb44fa87aea127a1$export$d6dc9444bd15f70f);
$parcel$export(module.exports, "getFinishInteractionOnTransition", () => $fb44fa87aea127a1$export$20e8108b8ccdd0bd);
$parcel$export(module.exports, "getInteractionTimeout", () => $fb44fa87aea127a1$export$c681731847989445);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $gPrbw = parcelRequire("gPrbw");

var $3H4LK = parcelRequire("3H4LK");
let $fb44fa87aea127a1$var$config;
/**
 * Cached result of `isFedrampModerate()` so we don't re-parse cookies on
 * every selector lookup. Reset via `__resetFedrampOverrideCacheForTests` in
 * unit tests only.
 */ let $fb44fa87aea127a1$var$cachedIsFedrampModerate;
function $fb44fa87aea127a1$var$detectIsFedrampModerate() {
    if ($fb44fa87aea127a1$var$cachedIsFedrampModerate !== undefined) return $fb44fa87aea127a1$var$cachedIsFedrampModerate;
    try {
        $fb44fa87aea127a1$var$cachedIsFedrampModerate = (0, $gPrbw.isFedrampModerate)();
    } catch  {
        // Defensive default: if perimeter detection throws, treat as non-FedRAMP
        // so UFO behaviour is unchanged. Mirrors `analyticsWebClient` pattern.
        $fb44fa87aea127a1$var$cachedIsFedrampModerate = false;
    }
    return $fb44fa87aea127a1$var$cachedIsFedrampModerate;
}
function $fb44fa87aea127a1$export$89dc2b6be8cc261() {
    $fb44fa87aea127a1$var$cachedIsFedrampModerate = undefined;
}
function $fb44fa87aea127a1$export$1133b5e2873baa7a() {
    try {
        return $fb44fa87aea127a1$var$detectIsFedrampModerate();
    } catch  {
        return false;
    }
}
const $fb44fa87aea127a1$var$FEDRAMP_DISABLED_SELECTOR_CONFIG = Object.freeze({
    id: false,
    testId: false,
    role: false,
    className: false,
    dataVC: false
});
const $fb44fa87aea127a1$export$f9bb3bb330fb9609 = 'fy26.04';
function $fb44fa87aea127a1$export$2182e73d31080cbc() {
    return $fb44fa87aea127a1$export$f9bb3bb330fb9609;
}
const $fb44fa87aea127a1$export$d50dacda7fe6392b = 1000;
function $fb44fa87aea127a1$export$10d6139a8fb42158(newConfig) {
    // Handle edge cases with `enabledVCRevisions`
    const { enabledVCRevisions: enabledVCRevisions } = (newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) ?? {};
    if (enabledVCRevisions) {
        const byExperience = typeof (enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === 'object' ? enabledVCRevisions.byExperience : {};
        const allRevisions = [
            // Products control their own revisions.
            ...(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) ?? [],
            ...Object.values(byExperience).flat()
        ];
        $fb44fa87aea127a1$var$config = {
            ...newConfig,
            vc: {
                ...newConfig.vc,
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            }
        };
    } else $fb44fa87aea127a1$var$config = newConfig;
}
function $fb44fa87aea127a1$export$44487a86467333c3() {
    return $fb44fa87aea127a1$var$config;
}
function $fb44fa87aea127a1$export$59e1f072477dfb48(callerOverride, defaultConfig) {
    var _config;
    // 1. FedRAMP override always wins.
    if ($fb44fa87aea127a1$var$detectIsFedrampModerate()) return $fb44fa87aea127a1$var$FEDRAMP_DISABLED_SELECTOR_CONFIG;
    // 2. Then caller-provided.
    // 3. Then centrally configured.
    // 4. Then caller-provided default.
    return callerOverride ?? ((_config = $fb44fa87aea127a1$var$config) === null || _config === void 0 || (_config = _config.vc) === null || _config === void 0 ? void 0 : _config.selectorConfig) ?? defaultConfig;
}
function $fb44fa87aea127a1$export$74bdb753f1cf4860() {
    var _config2;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config2 = $fb44fa87aea127a1$var$config) === null || _config2 === void 0 ? void 0 : _config2.enabled) !== false;
}
const $fb44fa87aea127a1$var$isValidConfigArray = (array)=>{
    return Array.isArray(array) && array.length > 0;
};
function $fb44fa87aea127a1$export$87fbc8e01b137811(experienceKey = '') {
    try {
        var _config$vc;
        if (!$fb44fa87aea127a1$var$config) return [];
        if ((_config$vc = $fb44fa87aea127a1$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _enabledVCRevisions$b;
            const { enabledVCRevisions: enabledVCRevisions } = $fb44fa87aea127a1$var$config.vc ?? {};
            if ($fb44fa87aea127a1$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            // When the disable flag is on, treat an explicitly-set empty array as
            // "no client-side revisions" rather than falling back to the default revision.
            const allRevisions = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all;
            if (Array.isArray(allRevisions) && allRevisions.length === 0 && (0, $3H4LK.fg)('ufo_disable_ttvc_v4')) return allRevisions;
            if ($fb44fa87aea127a1$var$isValidConfigArray(allRevisions)) return allRevisions;
            return [
                $fb44fa87aea127a1$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch  {
        return [];
    }
}
function $fb44fa87aea127a1$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $fb44fa87aea127a1$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $fb44fa87aea127a1$export$70184d6e2c753893(experienceKey = '') {
    const enabledVCRevisions = $fb44fa87aea127a1$export$87fbc8e01b137811(experienceKey);
    if (enabledVCRevisions.length === 0) return $fb44fa87aea127a1$export$2182e73d31080cbc();
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $fb44fa87aea127a1$export$2d8f8d64dc343d7b() {
    if (!$fb44fa87aea127a1$var$config) return undefined;
    try {
        var _config3, _config3$getReactHydr;
        const stats = (_config3 = $fb44fa87aea127a1$var$config) === null || _config3 === void 0 || (_config3$getReactHydr = _config3.getReactHydrationStats) === null || _config3$getReactHydr === void 0 ? void 0 : _config3$getReactHydr.call(_config3);
        return stats ?? undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('getReactHydrationStats threw an error: ', e);
        return undefined;
    }
}
function $fb44fa87aea127a1$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$fb44fa87aea127a1$var$config) return 0;
        const { killswitch: killswitch, rates: rates, rules: rules, kind: kind, autoGeneratedRate: autoGeneratedRate } = $fb44fa87aea127a1$var$config;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        const isUnknown = name === 'unknown';
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $fb44fa87aea127a1$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(let i = 0; i < rules.length; i++){
            const rule = rules[i];
            const { test: test, rate: rate } = rule;
            if (test != null && rate != null) {
                const regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        const isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            const rate = autoGeneratedRate;
            if (rate != null) return rate;
        }
        if (kind != null) {
            const rate = kind[interactionKind];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        // Fallback
        return 0;
    }
}
function $fb44fa87aea127a1$export$48f4e0d964030a96(name, interactionType) {
    return $fb44fa87aea127a1$var$getConfigRate(name, interactionType, 'enableVCRawDataRates');
}
function $fb44fa87aea127a1$export$9c69f5a724f05f38(name, interactionType) {
    return $fb44fa87aea127a1$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $fb44fa87aea127a1$export$1d459f020c06ae34(name, interactionType) {
    return $fb44fa87aea127a1$var$getConfigRate(name, interactionType, 'postInteractionLog');
}
function $fb44fa87aea127a1$export$29b9ffb14861a1d(capability) {
    if ((0, $3H4LK.fg)('platform_ufo_remove_deprecated_config_fields')) return 1;
    try {
        if (!$fb44fa87aea127a1$var$config) return 0;
        const { capability: capabilityRate } = $fb44fa87aea127a1$var$config;
        if (capabilityRate != null) {
            const rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch  {
        return 0;
    }
}
function $fb44fa87aea127a1$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$fb44fa87aea127a1$var$config) return 0;
        const gotConfig = $fb44fa87aea127a1$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== 'page_load' && interactionType !== 'transition') return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === 'number') return gotConfig.rates[name];
        if ('kind' in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === 'number') return gotConfig.kind[interactionType];
        return 0;
    } catch  {
        return 0;
    }
}
function $fb44fa87aea127a1$export$6af5b3c526928d44() {
    var _config4;
    return Boolean((_config4 = $fb44fa87aea127a1$var$config) === null || _config4 === void 0 || (_config4 = _config4.extraInteractionMetrics) === null || _config4 === void 0 ? void 0 : _config4.enabled) && !(0, $3H4LK.fg)('platform_ufo_disable_interaction_extra_metrics');
}
function $fb44fa87aea127a1$export$203bd06a99c66a0d(name, interactionType) {
    if (!$fb44fa87aea127a1$export$6af5b3c526928d44()) return 0;
    return $fb44fa87aea127a1$var$getConfigRate(name, interactionType, 'extraInteractionMetrics');
}
const $fb44fa87aea127a1$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
function $fb44fa87aea127a1$export$7e32aae12bf9b50f() {
    const defaultMethod = 'timeout';
    try {
        if (!$fb44fa87aea127a1$var$config) return defaultMethod;
        const { typingMethod: typingMethod } = $fb44fa87aea127a1$var$config;
        if (typingMethod != null && $fb44fa87aea127a1$var$validTypingMethods.find((m)=>m === typingMethod)) return typingMethod;
        else return defaultMethod;
    } catch  {
        return defaultMethod;
    }
}
function $fb44fa87aea127a1$export$2d311b3fd18dcab1() {
    try {
        if (!$fb44fa87aea127a1$var$config) return [];
        const { awaitBM3TTI: awaitBM3TTI } = $fb44fa87aea127a1$var$config;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch  {
        return [];
    }
}
function $fb44fa87aea127a1$export$4f4649ef27b6f5d6() {
    try {
        if (!$fb44fa87aea127a1$var$config) return undefined;
        const { ufoNameOverrides: ufoNameOverrides } = $fb44fa87aea127a1$var$config;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch  {
        return undefined;
    }
}
function $fb44fa87aea127a1$export$b150ddad71c80d77() {
    try {
        if (!$fb44fa87aea127a1$var$config) return undefined;
        const { minorInteractions: minorInteractions } = $fb44fa87aea127a1$var$config;
        return minorInteractions;
    } catch  {
        return undefined;
    }
}
function $fb44fa87aea127a1$export$3c170167645a0eff() {
    try {
        if (!$fb44fa87aea127a1$var$config) return undefined;
        const { doNotAbortActivePressInteraction: doNotAbortActivePressInteraction } = $fb44fa87aea127a1$var$config;
        return doNotAbortActivePressInteraction;
    } catch  {
        return undefined;
    }
}
function $fb44fa87aea127a1$export$d6dc9444bd15f70f() {
    try {
        if (!$fb44fa87aea127a1$var$config) return undefined;
        const { doNotAbortActivePressInteractionOnTransition: doNotAbortActivePressInteractionOnTransition } = $fb44fa87aea127a1$var$config;
        return doNotAbortActivePressInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
function $fb44fa87aea127a1$export$20e8108b8ccdd0bd() {
    try {
        if (!$fb44fa87aea127a1$var$config) return undefined;
        const { finishInteractionOnTransition: finishInteractionOnTransition } = $fb44fa87aea127a1$var$config;
        return finishInteractionOnTransition;
    } catch  {
        return undefined;
    }
}
const $fb44fa87aea127a1$export$2a8604960d7d23d9 = 60000;
function $fb44fa87aea127a1$export$c681731847989445(ufoName) {
    try {
        if (!$fb44fa87aea127a1$var$config) return $fb44fa87aea127a1$export$2a8604960d7d23d9;
        const { interactionTimeout: interactionTimeout } = $fb44fa87aea127a1$var$config;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $fb44fa87aea127a1$export$2a8604960d7d23d9;
    } catch  {
        return $fb44fa87aea127a1$export$2a8604960d7d23d9;
    }
}

});
parcelRegister("gPrbw", function(module, exports) {
$parcel$export(module.exports, "isIsolatedCloud", () => $c0649015df8354ac$export$9186ccba8effc5de);
$parcel$export(module.exports, "isFedrampModerate", () => $c0649015df8354ac$export$104cb891a6e90b3a);
$parcel$export(module.exports, "isolatedCloudDomain", () => $c0649015df8354ac$export$80638ee198476daf);
$parcel$export(module.exports, "isolationContextId", () => $c0649015df8354ac$export$839b022803d38d4d);
$parcel$export(module.exports, "cloudEnvironment", () => $c0649015df8354ac$export$9e04105551ffc5c4);

var $2N0EL = parcelRequire("2N0EL");

var $fINdb = parcelRequire("fINdb");
function $c0649015df8354ac$export$9186ccba8effc5de() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex;
        // @ts-ignore
        return ((_globalThis$ssrContex = globalThis.ssrContext) === null || _globalThis$ssrContex === void 0 ? void 0 : _globalThis$ssrContex.isInIC) ?? false;
    }
    const atlCtxCookieValues = (0, $fINdb.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    // The icDomain check is needed for when federal perimeters are eventually added to Isolated Cloud as well
    return (0, $2N0EL.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
}
function $c0649015df8354ac$export$104cb891a6e90b3a() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex2;
        // @ts-ignore
        return ((_globalThis$ssrContex2 = globalThis.ssrContext) === null || _globalThis$ssrContex2 === void 0 ? void 0 : _globalThis$ssrContex2.isInFedramp) ?? false;
    }
    const atlCtxCookieValues = (0, $fINdb.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return false;
    return atlCtxCookieValues.perimeter === (0, $2N0EL.FEDRAMP_MODERATE);
}
function $c0649015df8354ac$export$80638ee198476daf() {
    if (typeof document === 'undefined') {
        var _globalThis$location;
        return (_globalThis$location = globalThis.location) === null || _globalThis$location === void 0 ? void 0 : _globalThis$location.hostname;
    }
    const atlCtxCookieValues = (0, $fINdb.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icDomain;
}
function $c0649015df8354ac$export$839b022803d38d4d() {
    if (typeof document === 'undefined') {
        var _globalThis$ssrContex3;
        // @ts-ignore
        return $c0649015df8354ac$export$9186ccba8effc5de() ? (_globalThis$ssrContex3 = globalThis.ssrContext) === null || _globalThis$ssrContex3 === void 0 ? void 0 : _globalThis$ssrContex3.icName : undefined;
    }
    const atlCtxCookieValues = (0, $fINdb.parseAtlCtxCookies)();
    return atlCtxCookieValues === null || atlCtxCookieValues === void 0 ? void 0 : atlCtxCookieValues.icId;
}
function $c0649015df8354ac$export$9e04105551ffc5c4() {
    if (typeof document === 'undefined') return $c0649015df8354ac$var$cloudEnvironmentSsrLookup();
    return $c0649015df8354ac$var$cloudEnvironmentCookieLookup();
}
function $c0649015df8354ac$var$cloudEnvironmentSsrLookup() {
    var _globalThis$ssrContex4, _globalThis$ssrContex5;
    // @ts-ignore
    if (((_globalThis$ssrContex4 = globalThis.ssrContext) === null || _globalThis$ssrContex4 === void 0 ? void 0 : _globalThis$ssrContex4.isInIC) === true) return {
        type: 'isolated-cloud',
        perimeter: (0, $2N0EL.COMMERCIAL)
    };
    // @ts-ignore
    if (((_globalThis$ssrContex5 = globalThis.ssrContext) === null || _globalThis$ssrContex5 === void 0 ? void 0 : _globalThis$ssrContex5.isInFedramp) === true) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $2N0EL.FEDRAMP_MODERATE)
    };
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $2N0EL.COMMERCIAL)
    };
}
function $c0649015df8354ac$var$cloudEnvironmentCookieLookup() {
    // Avoid calling isFedrampModerate() and isIsolatedCloud() here to avoid repeated cookie parsing
    const atlCtxCookieValues = (0, $fINdb.parseAtlCtxCookies)();
    if (!atlCtxCookieValues) // If the cookies are not set, the current perimeter is non-isolated commercial
    return {
        type: 'non-isolated-cloud',
        perimeter: (0, $2N0EL.COMMERCIAL)
    };
    const isIc = (0, $2N0EL.ISOLATED_CLOUD_PERIMETERS).includes(atlCtxCookieValues.perimeter) && atlCtxCookieValues.icDomain !== undefined;
    if (isIc) return {
        type: 'isolated-cloud',
        perimeter: (0, $2N0EL.COMMERCIAL)
    };
    if (atlCtxCookieValues.perimeter === (0, $2N0EL.FEDRAMP_MODERATE)) return {
        type: 'non-isolated-cloud',
        perimeter: (0, $2N0EL.FEDRAMP_MODERATE)
    };
    // If a new cloud environment has been created but not added to this library, return undefined
    return undefined;
}

});
parcelRegister("2N0EL", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", () => $37fca9d06151620b$export$ce553301d55c2fd8);
$parcel$export(module.exports, "COMMERCIAL", () => $37fca9d06151620b$export$f005e2e9f707cb5f);
$parcel$export(module.exports, "STAGING", () => $37fca9d06151620b$export$a739cd5aac835909);
$parcel$export(module.exports, "PRODUCTION", () => $37fca9d06151620b$export$42dd0cdd351a4a9);
$parcel$export(module.exports, "DEV", () => $37fca9d06151620b$export$404582bc18fe4d9e);
$parcel$export(module.exports, "ISOLATED_CLOUD_PERIMETERS", () => $37fca9d06151620b$export$d8347b4aae768c2d);
$parcel$export(module.exports, "ATL_CTX_PERIMETER", () => $37fca9d06151620b$export$87285944378c596);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_DOMAIN", () => $37fca9d06151620b$export$715603e81922c3ec);
$parcel$export(module.exports, "ATL_CTX_ISOLATION_CONTEXT_ID", () => $37fca9d06151620b$export$a0ffa0598c95dfb7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $37fca9d06151620b$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $37fca9d06151620b$export$f005e2e9f707cb5f = 'commercial';
const $37fca9d06151620b$export$17b81a3d6c98013c = 'isolated-cloud';
const $37fca9d06151620b$export$a739cd5aac835909 = 'staging';
const $37fca9d06151620b$export$42dd0cdd351a4a9 = 'prod';
const $37fca9d06151620b$export$404582bc18fe4d9e = 'dev';
const $37fca9d06151620b$export$d8347b4aae768c2d = [
    $37fca9d06151620b$export$f005e2e9f707cb5f
];
const $37fca9d06151620b$export$b1b1ccc8f3e7f954 = [
    $37fca9d06151620b$export$f005e2e9f707cb5f,
    $37fca9d06151620b$export$ce553301d55c2fd8
];
const $37fca9d06151620b$export$87285944378c596 = 'Atl-Ctx-Perimeter';
const $37fca9d06151620b$export$715603e81922c3ec = 'Atl-Ctx-Isolation-Context-Domain';
const $37fca9d06151620b$export$a0ffa0598c95dfb7 = 'Atl-Ctx-Isolation-Context-Id';
const $37fca9d06151620b$export$74814ca8786924c3 = 'Bifrost-Atl-Ctx-Cloud-Service-Provider';
const $37fca9d06151620b$export$b61e047ddcc35726 = 'GCP';
const $37fca9d06151620b$export$1baf17f3e645a2b2 = 'AWS';

});

parcelRegister("fINdb", function(module, exports) {
$parcel$export(module.exports, "parseAtlCtxCookies", () => $902d7388bf5c42a8$export$3fa7b7af96286cc9);

var $2N0EL = parcelRequire("2N0EL");

var $hM66U = parcelRequire("hM66U");
function $902d7388bf5c42a8$export$3fa7b7af96286cc9() {
    const global = globalThis;
    try {
        // HOT-118791: the code below doesn't work on the server, and creates log spam in the catch block - "Cannot read properties of undefined (reading 'cookie')"
        if (typeof globalThis.document === 'undefined') return undefined;
        const cookies = global.document.cookie;
        const perimeter = (0, $hM66U.getRawCookieValue)((0, $2N0EL.ATL_CTX_PERIMETER), cookies);
        if (!perimeter) // Indicative of non-isolated commercial perimeter
        return undefined;
        const icDomain = (0, $hM66U.getRawCookieValue)((0, $2N0EL.ATL_CTX_ISOLATION_CONTEXT_DOMAIN), cookies);
        const icId = (0, $hM66U.getRawCookieValue)((0, $2N0EL.ATL_CTX_ISOLATION_CONTEXT_ID), cookies);
        // The IC Domain and IC Id cookie values are empty strings for non Isolated Cloud
        const emptyIcDomain = !icDomain || icDomain.length === 0;
        const emptyIcId = !icId || icId.length === 0;
        return {
            perimeter: perimeter,
            icDomain: emptyIcDomain ? undefined : icDomain,
            icId: emptyIcId ? undefined : icId
        };
    } catch (e) {
        console.warn('Failed to parse atl-ctx cookies:', e);
        return undefined;
    }
}

});
parcelRegister("hM66U", function(module, exports) {
$parcel$export(module.exports, "getRawCookieValue", () => $11af73ef2931567c$export$aa09aab30a92256c);
function $11af73ef2931567c$export$aa09aab30a92256c(cookieName, cookieString) {
    if (!cookieString) return undefined;
    const cookies = cookieString.split(';');
    for (const cookie of cookies){
        const [name, value] = cookie.trim().split('=');
        if (name === cookieName) return value;
    }
    return undefined;
}

});




parcelRegister("6FNES", function(module, exports) {
$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", () => $a06cd6211f179a6a$export$e6a07a94f3e112d4);
$parcel$export(module.exports, "onSearchPageInteractionComplete", () => $a06cd6211f179a6a$export$74b9ce7e9d206a8);
const $a06cd6211f179a6a$var$interactionBuffer = [];
let $a06cd6211f179a6a$var$bufferInteractionData = (interactionId, data)=>{
    $a06cd6211f179a6a$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $a06cd6211f179a6a$var$clearInteractionBuffer() {
    $a06cd6211f179a6a$var$interactionBuffer.length = 0;
}
function $a06cd6211f179a6a$var$appendInteractionData(interactionId, data) {
    $a06cd6211f179a6a$var$bufferInteractionData(interactionId, data);
}
function $a06cd6211f179a6a$var$installInteractionSink(handler) {
    for (const { interactionId: interactionId, data: data } of $a06cd6211f179a6a$var$interactionBuffer)handler(interactionId, data);
    $a06cd6211f179a6a$var$clearInteractionBuffer();
    $a06cd6211f179a6a$var$bufferInteractionData = handler;
}
function $a06cd6211f179a6a$export$e6a07a94f3e112d4(sinkFn) {
    $a06cd6211f179a6a$var$installInteractionSink(sinkFn);
}
function $a06cd6211f179a6a$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $a06cd6211f179a6a$var$appendInteractionData(interactionId, data);
        $a06cd6211f179a6a$var$clearInteractionBuffer();
    }
}

});

parcelRegister("j58cX", function(module, exports) {
$parcel$export(module.exports, "sanitizeUfoName", () => $b886f83eda2550ea$export$e08487ea3ae92adb);
$parcel$export(module.exports, "sanitizeLabelStackName", () => $b886f83eda2550ea$export$3535cd9da4961282);
$parcel$export(module.exports, "isSegmentLabel", () => $b886f83eda2550ea$export$1adbaf5c2363e4ae);
$parcel$export(module.exports, "buildSegmentTree", () => $b886f83eda2550ea$export$1569bc0edeecbcd8);
$parcel$export(module.exports, "stringifyLabelStackFully", () => $b886f83eda2550ea$export$caeee352b541de1f);
$parcel$export(module.exports, "labelStackStartWith", () => $b886f83eda2550ea$export$1787b1cd413c7e2);
$parcel$export(module.exports, "optimizeLabelStack", () => $b886f83eda2550ea$export$a0cd72da07c76b4c);
$parcel$export(module.exports, "optimizeLabelStackWithRegistry", () => $b886f83eda2550ea$export$cb3145456a04e238);
$parcel$export(module.exports, "getOldSegmentsLabelStack", () => $b886f83eda2550ea$export$b70bcfd92c93435e);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $3H4LK = parcelRequire("3H4LK");

var $jFknK = parcelRequire("jFknK");
function $b886f83eda2550ea$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, '-');
}
function $b886f83eda2550ea$export$3535cd9da4961282(name) {
    if (name.startsWith('/')) name = name.replace(/^\/+/, '');
    if (name.endsWith('/') && (0, $3H4LK.fg)('platform_ufo_trim_labelstack_trailing_slashes')) name = name.replace(/\/+$/, '');
    return name;
}
function $b886f83eda2550ea$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
}
function $b886f83eda2550ea$export$1569bc0edeecbcd8(labelStacks) {
    const r = {
        n: 'segment-tree-root',
        c: {}
    };
    const config = (0, $jFknK.getConfig)();
    const segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    const addSegmentsMap = new Map();
    labelStacks.forEach((labelStack)=>{
        const stringifiedLabelStack = $b886f83eda2550ea$export$88f21baa687271f4(labelStack);
        let currentNode = r;
        for (const label of labelStack){
            const isSegment = $b886f83eda2550ea$export$1adbaf5c2363e4ae(label);
            const name = $b886f83eda2550ea$export$3535cd9da4961282(label.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            const id = isSegment ? label.segmentId : undefined;
            const key = id !== undefined ? id : name;
            const type = isSegment ? label.type : undefined;
            if (!currentNode.c) currentNode.c = {};
            if (!currentNode.c[key]) currentNode.c[key] = {
                n: name,
                ...type ? {
                    t: type
                } : {}
            };
            currentNode = currentNode.c[key];
        }
    });
    return {
        r: r
    };
}
function $b886f83eda2550ea$export$caeee352b541de1f(labelStack) {
    return labelStack.map((l)=>{
        const name = $b886f83eda2550ea$export$3535cd9da4961282(l.name);
        if ($b886f83eda2550ea$export$1adbaf5c2363e4ae(l)) return `${name}:${l.segmentId}`;
        return name;
    }).join('/');
}
function $b886f83eda2550ea$export$88f21baa687271f4(labelStack) {
    return labelStack.map((l)=>{
        const name = $b886f83eda2550ea$export$3535cd9da4961282(l.name);
        if ($b886f83eda2550ea$export$1adbaf5c2363e4ae(l)) return `${name}:segment`;
        return name;
    }).join('/');
}
function $b886f83eda2550ea$var$getLabelStackReference(labelStack) {
    return labelStack.map((l)=>$b886f83eda2550ea$export$1adbaf5c2363e4ae(l) ? l.segmentId : $b886f83eda2550ea$export$3535cd9da4961282(l.name)).join('/');
}
function $b886f83eda2550ea$export$1787b1cd413c7e2(labelStack, startWith) {
    return $b886f83eda2550ea$export$caeee352b541de1f(labelStack).startsWith($b886f83eda2550ea$export$caeee352b541de1f(startWith));
}
function $b886f83eda2550ea$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === '2.0.0' ? $b886f83eda2550ea$var$getLabelStackReference(labelStack) : labelStack.map((ls)=>({
            n: $b886f83eda2550ea$export$3535cd9da4961282(ls.name),
            ...ls.segmentId ? {
                s: ls.segmentId
            } : {},
            ...ls.type ? {
                t: ls.type
            } : {}
        }));
}
function $b886f83eda2550ea$export$cb3145456a04e238(labelStack, reactUFOVersion, registry) {
    if (registry && reactUFOVersion === '2.0.0') {
        const ref = $b886f83eda2550ea$var$getLabelStackReference(labelStack);
        return registry.register(ref);
    }
    return $b886f83eda2550ea$export$a0cd72da07c76b4c(labelStack, reactUFOVersion);
}
function $b886f83eda2550ea$export$b70bcfd92c93435e(segments, _interactionType) {
    const config = (0, $jFknK.getConfig)();
    const addSegmentsMap = new Map();
    const segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map(({ labelStack: labelStack, ...others })=>{
        const stringifiedLabelStack = $b886f83eda2550ea$export$88f21baa687271f4(labelStack);
        const segmentsInfo = [];
        for (const ls of labelStack){
            const isSegment = $b886f83eda2550ea$export$1adbaf5c2363e4ae(ls);
            const name = $b886f83eda2550ea$export$3535cd9da4961282(ls.name);
            if (isSegment && segmentThreshold && segmentThreshold[name]) {
                const threshold = segmentThreshold[name];
                const count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                else break;
            }
            segmentsInfo.push({
                n: name,
                ...ls.segmentId ? {
                    s: ls.segmentId
                } : {},
                ...ls.type ? {
                    t: ls.type
                } : {}
            });
        }
        return {
            ...others,
            labelStack: segmentsInfo
        };
    });
}

});

parcelRegister("bqHVm", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $74e4ee17f42124ed$export$f2e521e495a88544);
$parcel$export(module.exports, "setActiveTrace", () => $74e4ee17f42124ed$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $74e4ee17f42124ed$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $74e4ee17f42124ed$export$17ab21d7be720b);
$parcel$export(module.exports, "getActiveTraceHttpRequestHeaders", () => $74e4ee17f42124ed$export$6e17cce6446848f9);
parcelRequire("3ebz9");
var $2jsSR = parcelRequire("2jsSR");
var $8Wm1l = parcelRequire("8Wm1l");

var $3H4LK = parcelRequire("3H4LK");

var $he5a2 = parcelRequire("he5a2");

var $sRed8 = parcelRequire("sRed8");
const $74e4ee17f42124ed$var$state = {
    context: null
};
const $74e4ee17f42124ed$var$traceIdKey = (0, $8Wm1l.createContextKey)('traceId');
const $74e4ee17f42124ed$var$spanIdKey = (0, $8Wm1l.createContextKey)('spanId');
const $74e4ee17f42124ed$var$experienceTypeKey = (0, $8Wm1l.createContextKey)('type');
function $74e4ee17f42124ed$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $74e4ee17f42124ed$export$f2e521e495a88544(interactionId, experienceType) {
    $74e4ee17f42124ed$export$a1002be327997103(interactionId.replace(/-/g, ''), $74e4ee17f42124ed$export$295213bc4d0c54ad(), experienceType);
}
function $74e4ee17f42124ed$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $3H4LK.fg)('platform_ufo_enable_otel_context_manager')) {
        const activeTraceContext = (0, $8Wm1l.ROOT_CONTEXT).setValue($74e4ee17f42124ed$var$traceIdKey, traceId).setValue($74e4ee17f42124ed$var$spanIdKey, spanId).setValue($74e4ee17f42124ed$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $he5a2.getContextManager)() instanceof (0, $he5a2.UFOContextManager)) {
            let contextManager = (0, $he5a2.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $74e4ee17f42124ed$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $74e4ee17f42124ed$export$b6ac780db3a3cc77() {
    if ((0, $3H4LK.fg)('platform_ufo_enable_otel_context_manager')) {
        // Get trace context from active context
        const activeTraceContext = {
            traceId: String((0, $2jsSR.context).active().getValue($74e4ee17f42124ed$var$traceIdKey)),
            spanId: String((0, $2jsSR.context).active().getValue($74e4ee17f42124ed$var$spanIdKey)),
            type: String((0, $2jsSR.context).active().getValue($74e4ee17f42124ed$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== 'undefined' && activeTraceContext.spanId !== 'undefined' ? activeTraceContext : undefined;
    } else return $74e4ee17f42124ed$var$state.context || undefined;
}
function $74e4ee17f42124ed$export$17ab21d7be720b() {
    if ((0, $3H4LK.fg)('platform_ufo_enable_otel_context_manager')) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $he5a2.getContextManager)() instanceof (0, $he5a2.UFOContextManager)) {
            let contextManager = (0, $he5a2.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $8Wm1l.ROOT_CONTEXT));
        }
    } else $74e4ee17f42124ed$var$state.context = null;
}
function $74e4ee17f42124ed$export$6e17cce6446848f9(_url) {
    if ($74e4ee17f42124ed$export$b6ac780db3a3cc77() === undefined) return null;
    const { traceId: traceId, spanId: spanId } = $74e4ee17f42124ed$export$b6ac780db3a3cc77();
    return (0, $sRed8.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $74e4ee17f42124ed$export$a1e7396778592551(_url) {
    const traceHeaders = $74e4ee17f42124ed$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("3ebz9", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("2jsSR")).context);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $8Wm1l = parcelRequire("8Wm1l");















var $2jsSR = parcelRequire("2jsSR");

var $fjJSt = parcelRequire("fjJSt");

var $iX2Q0 = parcelRequire("iX2Q0");

var $2O2W0 = parcelRequire("2O2W0");

var $ic1HZ = parcelRequire("ic1HZ");
var // Default export.
$259ba6ae6e54c74f$export$2e2bcd8739ae039 = {
    context: (0, $2jsSR.context),
    diag: (0, $fjJSt.diag),
    metrics: (0, $iX2Q0.metrics),
    propagation: (0, $2O2W0.propagation),
    trace: (0, $ic1HZ.trace)
};

});
parcelRegister("8Wm1l", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $6824d2609a1403fd$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $6824d2609a1403fd$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $6824d2609a1403fd$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $6824d2609a1403fd$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $6824d2609a1403fd$export$78df28f9b2f9a7dc = new $6824d2609a1403fd$var$BaseContext();

});

parcelRegister("2jsSR", function(module, exports) {
$parcel$export(module.exports, "context", () => $1af3c2da889dbd86$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $8pheF = parcelRequire("8pheF");
var $1af3c2da889dbd86$export$a078c61943f9dbbe = (0, $8pheF.ContextAPI).getInstance();

});
parcelRegister("8pheF", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $61ee072865361ade$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2pDaG = parcelRequire("2pDaG");

var $6n8Ok = parcelRequire("6n8Ok");

var $I304m = parcelRequire("I304m");
var $61ee072865361ade$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $61ee072865361ade$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $61ee072865361ade$var$API_NAME = 'context';
var $61ee072865361ade$var$NOOP_CONTEXT_MANAGER = new (0, $2pDaG.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $61ee072865361ade$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $6n8Ok.registerGlobal)($61ee072865361ade$var$API_NAME, contextManager, (0, $I304m.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $61ee072865361ade$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $61ee072865361ade$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $6n8Ok.getGlobal)($61ee072865361ade$var$API_NAME) || $61ee072865361ade$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $6n8Ok.unregisterGlobal)($61ee072865361ade$var$API_NAME, (0, $I304m.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("2pDaG", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $1c1c4d30016a3e0a$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8Wm1l = parcelRequire("8Wm1l");
var $1c1c4d30016a3e0a$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $1c1c4d30016a3e0a$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $1c1c4d30016a3e0a$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $8Wm1l.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $1c1c4d30016a3e0a$var$__spreadArray([
            thisArg
        ], $1c1c4d30016a3e0a$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("6n8Ok", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $4a3bb9b4c1257dd7$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $4a3bb9b4c1257dd7$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $4a3bb9b4c1257dd7$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2Y2Q7 = parcelRequire("2Y2Q7");

var $2D1uO = parcelRequire("2D1uO");

var $cgHtj = parcelRequire("cgHtj");
var $4a3bb9b4c1257dd7$var$major = (0, $2D1uO.VERSION).split('.')[0];
var $4a3bb9b4c1257dd7$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $4a3bb9b4c1257dd7$var$major);
var $4a3bb9b4c1257dd7$var$_global = (0, $2Y2Q7._globalThis);
function $4a3bb9b4c1257dd7$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $4a3bb9b4c1257dd7$var$_global[$4a3bb9b4c1257dd7$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $4a3bb9b4c1257dd7$var$_global[$4a3bb9b4c1257dd7$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $2D1uO.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $2D1uO.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $2D1uO.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $2D1uO.VERSION) + ".");
    return true;
}
function $4a3bb9b4c1257dd7$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $4a3bb9b4c1257dd7$var$_global[$4a3bb9b4c1257dd7$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $cgHtj.isCompatible)(globalVersion)) return;
    return (_b = $4a3bb9b4c1257dd7$var$_global[$4a3bb9b4c1257dd7$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $4a3bb9b4c1257dd7$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $2D1uO.VERSION) + ".");
    var api = $4a3bb9b4c1257dd7$var$_global[$4a3bb9b4c1257dd7$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("2Y2Q7", function(module, exports) {
$parcel$export(module.exports, "_globalThis", () => $22936344187aaf66$export$5c524ddf7208c00c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $22936344187aaf66$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("2D1uO", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $1ea06257b0eb66d6$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $1ea06257b0eb66d6$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("cgHtj", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $8ee8b34288064538$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2D1uO = parcelRequire("2D1uO");
var $8ee8b34288064538$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $8ee8b34288064538$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($8ee8b34288064538$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($8ee8b34288064538$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $8ee8b34288064538$export$7fc0d8c3ab188c4c = $8ee8b34288064538$export$a5733a4d26a1ec61((0, $2D1uO.VERSION));

});


parcelRegister("I304m", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $08466fefb52cd1db$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jaE83 = parcelRequire("jaE83");

var $ujFvo = parcelRequire("ujFvo");

var $h2Ix0 = parcelRequire("h2Ix0");

var $6n8Ok = parcelRequire("6n8Ok");
var $08466fefb52cd1db$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $08466fefb52cd1db$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $08466fefb52cd1db$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $08466fefb52cd1db$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $6n8Ok.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $08466fefb52cd1db$var$__spreadArray([], $08466fefb52cd1db$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $h2Ix0.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $6n8Ok.getGlobal)('diag');
            var newLogger = (0, $ujFvo.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $h2Ix0.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $6n8Ok.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $6n8Ok.unregisterGlobal)($08466fefb52cd1db$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $jaE83.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("jaE83", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $df4e1445f04ecd48$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6n8Ok = parcelRequire("6n8Ok");
var $df4e1445f04ecd48$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $df4e1445f04ecd48$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $df4e1445f04ecd48$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $df4e1445f04ecd48$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $df4e1445f04ecd48$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $df4e1445f04ecd48$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $df4e1445f04ecd48$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $df4e1445f04ecd48$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $df4e1445f04ecd48$var$logProxy(funcName, namespace, args) {
    var logger = (0, $6n8Ok.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $df4e1445f04ecd48$var$__spreadArray([], $df4e1445f04ecd48$var$__read(args), false));
}

});

parcelRegister("ujFvo", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $05b20f32feea3508$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $h2Ix0 = parcelRequire("h2Ix0");
function $05b20f32feea3508$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $h2Ix0.DiagLogLevel).NONE) maxLevel = (0, $h2Ix0.DiagLogLevel).NONE;
    else if (maxLevel > (0, $h2Ix0.DiagLogLevel).ALL) maxLevel = (0, $h2Ix0.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $h2Ix0.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $h2Ix0.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $h2Ix0.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $h2Ix0.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $h2Ix0.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("h2Ix0", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $c6852a9639210020$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $c6852a9639210020$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($c6852a9639210020$export$b7d7b4c0f3c95263 || ($c6852a9639210020$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("fjJSt", function(module, exports) {
$parcel$export(module.exports, "diag", () => $b26c37aeb64fbe9d$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $I304m = parcelRequire("I304m");
var $b26c37aeb64fbe9d$export$c042e7c2f59bc046 = (0, $I304m.DiagAPI).instance();

});

parcelRegister("iX2Q0", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $dcbff03b70a3af10$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $jVZcb = parcelRequire("jVZcb");
var $dcbff03b70a3af10$export$b0c5c2fac8144e54 = (0, $jVZcb.MetricsAPI).getInstance();

});
parcelRegister("jVZcb", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $e832cf586bd30c39$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $glRsu = parcelRequire("glRsu");

var $6n8Ok = parcelRequire("6n8Ok");

var $I304m = parcelRequire("I304m");
var $e832cf586bd30c39$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $e832cf586bd30c39$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $6n8Ok.registerGlobal)($e832cf586bd30c39$var$API_NAME, provider, (0, $I304m.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $6n8Ok.getGlobal)($e832cf586bd30c39$var$API_NAME) || (0, $glRsu.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $6n8Ok.unregisterGlobal)($e832cf586bd30c39$var$API_NAME, (0, $I304m.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("glRsu", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $be781341bd8f4a10$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5Qqsl = parcelRequire("5Qqsl");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $be781341bd8f4a10$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $5Qqsl.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $be781341bd8f4a10$export$d21fe83355c56e18 = new $be781341bd8f4a10$export$51c513ea08316108();

});
parcelRegister("5Qqsl", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $441654be9c5b318b$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $441654be9c5b318b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $441654be9c5b318b$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $441654be9c5b318b$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $441654be9c5b318b$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $441654be9c5b318b$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $441654be9c5b318b$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $441654be9c5b318b$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $441654be9c5b318b$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $441654be9c5b318b$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $441654be9c5b318b$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $441654be9c5b318b$export$b556ba0f560c45b = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($441654be9c5b318b$export$834a616d1cf278b);
var $441654be9c5b318b$export$df09a35db160df98 = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($441654be9c5b318b$export$834a616d1cf278b);
var $441654be9c5b318b$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($441654be9c5b318b$export$834a616d1cf278b);
var $441654be9c5b318b$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($441654be9c5b318b$export$834a616d1cf278b);
var $441654be9c5b318b$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $441654be9c5b318b$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($441654be9c5b318b$export$a5a3e7829c289482);
var $441654be9c5b318b$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($441654be9c5b318b$export$a5a3e7829c289482);
var $441654be9c5b318b$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $441654be9c5b318b$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($441654be9c5b318b$export$a5a3e7829c289482);
var $441654be9c5b318b$export$65e277d35235a01f = new $441654be9c5b318b$export$c23c6f85dd4fc1e9();
var $441654be9c5b318b$export$e6d19fe5233efc54 = new $441654be9c5b318b$export$b556ba0f560c45b();
var $441654be9c5b318b$export$dd01300aacbcec1c = new $441654be9c5b318b$export$b7f4a3c7ea16c24();
var $441654be9c5b318b$export$689c32a6a552e1a6 = new $441654be9c5b318b$export$ef064c3e0426c607();
var $441654be9c5b318b$export$2f189cd99d2b7429 = new $441654be9c5b318b$export$df09a35db160df98();
var $441654be9c5b318b$export$163422b94c3edbcb = new $441654be9c5b318b$export$7a7e4b169d5c93a8();
var $441654be9c5b318b$export$ea67e3c6ff624776 = new $441654be9c5b318b$export$6990a2f90809ffc1();
var $441654be9c5b318b$export$5b8be9ab17b673b3 = new $441654be9c5b318b$export$3ec3555bc6f693a4();
function $441654be9c5b318b$export$bc3a498ccbb5c2b5() {
    return $441654be9c5b318b$export$65e277d35235a01f;
}

});




parcelRegister("2O2W0", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $20b287054bfe5581$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $gFfgA = parcelRequire("gFfgA");
var $20b287054bfe5581$export$3e49040daa9dba20 = (0, $gFfgA.PropagationAPI).getInstance();

});
parcelRegister("gFfgA", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $c21c514f1882aa30$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6n8Ok = parcelRequire("6n8Ok");

var $6mMbU = parcelRequire("6mMbU");

var $6hq51 = parcelRequire("6hq51");

var $4FciS = parcelRequire("4FciS");

var $khwOT = parcelRequire("khwOT");

var $I304m = parcelRequire("I304m");
var $c21c514f1882aa30$var$API_NAME = 'propagation';
var $c21c514f1882aa30$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $6mMbU.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $c21c514f1882aa30$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $khwOT.createBaggage);
        this.getBaggage = (0, $4FciS.getBaggage);
        this.getActiveBaggage = (0, $4FciS.getActiveBaggage);
        this.setBaggage = (0, $4FciS.setBaggage);
        this.deleteBaggage = (0, $4FciS.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $6n8Ok.registerGlobal)($c21c514f1882aa30$var$API_NAME, propagator, (0, $I304m.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $6hq51.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $6hq51.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $6n8Ok.unregisterGlobal)($c21c514f1882aa30$var$API_NAME, (0, $I304m.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $6n8Ok.getGlobal)($c21c514f1882aa30$var$API_NAME) || $c21c514f1882aa30$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("6mMbU", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $4a2a2de8d28c66bd$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $4a2a2de8d28c66bd$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("6hq51", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $49288f8a02c14f1f$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $49288f8a02c14f1f$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $49288f8a02c14f1f$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $49288f8a02c14f1f$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("4FciS", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $365488f53b2ca643$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $365488f53b2ca643$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $365488f53b2ca643$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $365488f53b2ca643$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8pheF = parcelRequire("8pheF");

var $8Wm1l = parcelRequire("8Wm1l");
/**
 * Baggage key
 */ var $365488f53b2ca643$var$BAGGAGE_KEY = (0, $8Wm1l.createContextKey)('OpenTelemetry Baggage Key');
function $365488f53b2ca643$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($365488f53b2ca643$var$BAGGAGE_KEY) || undefined;
}
function $365488f53b2ca643$export$120a1756099436ee() {
    return $365488f53b2ca643$export$f3bffa0b5dd10d1e((0, $8pheF.ContextAPI).getInstance().active());
}
function $365488f53b2ca643$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($365488f53b2ca643$var$BAGGAGE_KEY, baggage);
}
function $365488f53b2ca643$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($365488f53b2ca643$var$BAGGAGE_KEY);
}

});

parcelRegister("khwOT", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $ec3eda7e9cbb99ac$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $I304m = parcelRequire("I304m");

var $7wLp8 = parcelRequire("7wLp8");

var $5qif8 = parcelRequire("5qif8");
var $ec3eda7e9cbb99ac$var$diag = (0, $I304m.DiagAPI).instance();
function $ec3eda7e9cbb99ac$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $7wLp8.BaggageImpl)(new Map(Object.entries(entries)));
}
function $ec3eda7e9cbb99ac$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $ec3eda7e9cbb99ac$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $5qif8.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("7wLp8", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $57b04b1222bf0206$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $57b04b1222bf0206$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $57b04b1222bf0206$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $57b04b1222bf0206$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $57b04b1222bf0206$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $57b04b1222bf0206$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("5qif8", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $3f2d882ceba3815c$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $3f2d882ceba3815c$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("ic1HZ", function(module, exports) {
$parcel$export(module.exports, "trace", () => $d3eaac46dde2efdb$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $2ajJr = parcelRequire("2ajJr");
var $d3eaac46dde2efdb$export$357889f174732d38 = (0, $2ajJr.TraceAPI).getInstance();

});
parcelRegister("2ajJr", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $193bd24b9a694e17$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6n8Ok = parcelRequire("6n8Ok");

var $hJn3O = parcelRequire("hJn3O");

var $brnq9 = parcelRequire("brnq9");

var $i5Fxp = parcelRequire("i5Fxp");

var $I304m = parcelRequire("I304m");
var $193bd24b9a694e17$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $193bd24b9a694e17$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $hJn3O.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $brnq9.wrapSpanContext);
        this.isSpanContextValid = (0, $brnq9.isSpanContextValid);
        this.deleteSpan = (0, $i5Fxp.deleteSpan);
        this.getSpan = (0, $i5Fxp.getSpan);
        this.getActiveSpan = (0, $i5Fxp.getActiveSpan);
        this.getSpanContext = (0, $i5Fxp.getSpanContext);
        this.setSpan = (0, $i5Fxp.setSpan);
        this.setSpanContext = (0, $i5Fxp.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $6n8Ok.registerGlobal)($193bd24b9a694e17$var$API_NAME, this._proxyTracerProvider, (0, $I304m.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $6n8Ok.getGlobal)($193bd24b9a694e17$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $6n8Ok.unregisterGlobal)($193bd24b9a694e17$var$API_NAME, (0, $I304m.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $hJn3O.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("hJn3O", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $ce8886f6ea569bc1$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fOFSZ = parcelRequire("fOFSZ");

var $4Ue7y = parcelRequire("4Ue7y");
var $ce8886f6ea569bc1$var$NOOP_TRACER_PROVIDER = new (0, $4Ue7y.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $ce8886f6ea569bc1$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $fOFSZ.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $ce8886f6ea569bc1$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("fOFSZ", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $02f8b5becc132974$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $irWyl = parcelRequire("irWyl");
var $02f8b5becc132974$var$NOOP_TRACER = new (0, $irWyl.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $02f8b5becc132974$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $02f8b5becc132974$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("irWyl", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $d6e82afdc1db7ad6$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8pheF = parcelRequire("8pheF");

var $i5Fxp = parcelRequire("i5Fxp");

var $ghVST = parcelRequire("ghVST");

var $brnq9 = parcelRequire("brnq9");
var $d6e82afdc1db7ad6$var$contextApi = (0, $8pheF.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $d6e82afdc1db7ad6$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $d6e82afdc1db7ad6$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $ghVST.NonRecordingSpan)();
        var parentFromContext = context && (0, $i5Fxp.getSpanContext)(context);
        if ($d6e82afdc1db7ad6$var$isSpanContext(parentFromContext) && (0, $brnq9.isSpanContextValid)(parentFromContext)) return new (0, $ghVST.NonRecordingSpan)(parentFromContext);
        else return new (0, $ghVST.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $d6e82afdc1db7ad6$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $i5Fxp.setSpan)(parentContext, span);
        return $d6e82afdc1db7ad6$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $d6e82afdc1db7ad6$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("i5Fxp", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $d2b8ea2b0c78370f$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $d2b8ea2b0c78370f$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $d2b8ea2b0c78370f$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $d2b8ea2b0c78370f$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $d2b8ea2b0c78370f$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $d2b8ea2b0c78370f$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $8Wm1l = parcelRequire("8Wm1l");

var $ghVST = parcelRequire("ghVST");

var $8pheF = parcelRequire("8pheF");
/**
 * span key
 */ var $d2b8ea2b0c78370f$var$SPAN_KEY = (0, $8Wm1l.createContextKey)('OpenTelemetry Context Key SPAN');
function $d2b8ea2b0c78370f$export$246e04ba06066af1(context) {
    return context.getValue($d2b8ea2b0c78370f$var$SPAN_KEY) || undefined;
}
function $d2b8ea2b0c78370f$export$1be426a8e585c83e() {
    return $d2b8ea2b0c78370f$export$246e04ba06066af1((0, $8pheF.ContextAPI).getInstance().active());
}
function $d2b8ea2b0c78370f$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($d2b8ea2b0c78370f$var$SPAN_KEY, span);
}
function $d2b8ea2b0c78370f$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($d2b8ea2b0c78370f$var$SPAN_KEY);
}
function $d2b8ea2b0c78370f$export$c90bf5428c14cdb1(context, spanContext) {
    return $d2b8ea2b0c78370f$export$8ab2f2e6ee8ed0a8(context, new (0, $ghVST.NonRecordingSpan)(spanContext));
}
function $d2b8ea2b0c78370f$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $d2b8ea2b0c78370f$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("ghVST", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $bdbb227cae2df738$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9A3GD = parcelRequire("9A3GD");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $bdbb227cae2df738$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $9A3GD.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("9A3GD", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $6f9a55eaf09e98f6$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $6f9a55eaf09e98f6$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $6f9a55eaf09e98f6$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $h8max = parcelRequire("h8max");
var $6f9a55eaf09e98f6$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $6f9a55eaf09e98f6$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $6f9a55eaf09e98f6$export$8591e4c852b66703 = {
    traceId: $6f9a55eaf09e98f6$export$22be96e88d95e128,
    spanId: $6f9a55eaf09e98f6$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $h8max.TraceFlags).NONE
};

});
parcelRegister("h8max", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $c794614cf0f188a7$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $c794614cf0f188a7$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($c794614cf0f188a7$export$bf9049ad2b0883ff || ($c794614cf0f188a7$export$bf9049ad2b0883ff = {}));

});




parcelRegister("brnq9", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $85446231f4159a41$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $85446231f4159a41$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9A3GD = parcelRequire("9A3GD");

var $ghVST = parcelRequire("ghVST");
var $85446231f4159a41$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $85446231f4159a41$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $85446231f4159a41$export$29dd34cf1269f6da(traceId) {
    return $85446231f4159a41$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $9A3GD.INVALID_TRACEID);
}
function $85446231f4159a41$export$8e51c6d8f0586aff(spanId) {
    return $85446231f4159a41$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $9A3GD.INVALID_SPANID);
}
function $85446231f4159a41$export$e4373b9a2c09216c(spanContext) {
    return $85446231f4159a41$export$29dd34cf1269f6da(spanContext.traceId) && $85446231f4159a41$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $85446231f4159a41$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $ghVST.NonRecordingSpan)(spanContext);
}

});



parcelRegister("4Ue7y", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $392758776e0932a8$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $irWyl = parcelRequire("irWyl");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $392758776e0932a8$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $irWyl.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("he5a2", function(module, exports) {
$parcel$export(module.exports, "setContextManager", () => $ddb4e1c53c953830$export$4a00ab8a5dd9b5cf);
$parcel$export(module.exports, "getContextManager", () => $ddb4e1c53c953830$export$831109c9f7727010);
$parcel$export(module.exports, "UFOContextManager", () => $ddb4e1c53c953830$export$dd301b96c16f583d);

var $8Wm1l = parcelRequire("8Wm1l");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ let $ddb4e1c53c953830$var$contextManager;
function $ddb4e1c53c953830$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $ddb4e1c53c953830$var$contextManager = ctxMgr;
}
function $ddb4e1c53c953830$export$831109c9f7727010() {
    return $ddb4e1c53c953830$var$contextManager;
}
class $ddb4e1c53c953830$export$dd301b96c16f583d {
    /**
   *
   * @param context
   * @param target Function to be executed within the context
   */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $8Wm1l.ROOT_CONTEXT), target) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
   * Returns the active context
   */ active() {
        return this._currentContext;
    }
    /**
   * Binds a the certain context or the active one to the target function and then returns the target
   * @param context A context (span) to be bind to target
   * @param target a function or event emitter. When target or one of its callbacks is called,
   *  the provided context will be used as the active context for the duration of the call.
   */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
   * Disable the context manager (clears the current context)
   */ disable() {
        this._currentContext = (0, $8Wm1l.ROOT_CONTEXT);
        this._enabled = false;
        return this;
    }
    /**
   * Enables the context manager and creates a default(root) context
   */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $8Wm1l.ROOT_CONTEXT);
        return this;
    }
    /**
   * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
   * The context will be set as active
   * @param context
   * @param fn Callback function
   * @param thisArg optional receiver to be used for calling fn
   * @param args optional arguments forwarded to fn
   */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $8Wm1l.ROOT_CONTEXT);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
    /**
   * Sets the active context.
   * This function is an extension of the OTel spec, in order to facilitate the current API of React UFO trace context handling.
   * It doesn't keep track of any previously set active contexts, because it's assumed (for now) that only one trace context
   * will ever exist at a time.
   * The next step in the work to improve tracing in the FE will likely remove this function as we need to track the
   * hierarchy of contexts (likely using the `with()` function above).
   * @param context The context to be made the globally active one
   */ setActive(context) {
        if (this._enabled) this._currentContext = context;
    }
    constructor(){
        /**
   * whether the context manager is enabled or not
   */ this._enabled = false;
        /**
   * Keeps the reference to current context
   */ this._currentContext = (0, $8Wm1l.ROOT_CONTEXT);
    }
}

});

parcelRegister("sRed8", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpRequestHeaders", () => $f5d0b105bf680f8d$export$1115c5277eb10d5e);
function $f5d0b105bf680f8d$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("lLCH0", function(module, exports) {
$parcel$export(module.exports, "allFeatureFlagsAccessed", () => $7ea3dcc89133a643$export$5b78c989c8db2561);
$parcel$export(module.exports, "currentFeatureFlagsAccessed", () => $7ea3dcc89133a643$export$2a5c8df26bb89760);
$parcel$export(module.exports, "addFeatureFlagAccessed", () => $7ea3dcc89133a643$export$47fade9662f71000);

var $jf3qB = parcelRequire("jf3qB");
const $7ea3dcc89133a643$export$5b78c989c8db2561 = new Map();
const $7ea3dcc89133a643$export$2a5c8df26bb89760 = new Map();
function $7ea3dcc89133a643$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    const value = (0, $jf3qB.redactValue)(featureFlagValue);
    $7ea3dcc89133a643$export$5b78c989c8db2561.set(featureFlagName, value);
    $7ea3dcc89133a643$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("jf3qB", function(module, exports) {
$parcel$export(module.exports, "redactValue", () => $c5fb59b1dbbde332$export$fcc03ee4c944962f);

var $haSRd = parcelRequire("haSRd");
function $c5fb59b1dbbde332$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch  {
        return false;
    }
    return false;
}
function $c5fb59b1dbbde332$var$isObject(value) {
    return value && typeof value === 'object' && value.constructor === Object;
}
function $c5fb59b1dbbde332$var$isString(input) {
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch  {
        // swallow any errors
        result = false;
    }
    return result;
}
function $c5fb59b1dbbde332$export$7b4abba432e57989(value) {
    return $c5fb59b1dbbde332$var$isString(value) && $c5fb59b1dbbde332$var$startsAsObject(value) || $c5fb59b1dbbde332$var$isObject(value);
}
function $c5fb59b1dbbde332$export$fcc03ee4c944962f(featureFlagValue) {
    return $c5fb59b1dbbde332$export$7b4abba432e57989(featureFlagValue) ? (0, $haSRd.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("haSRd", function(module, exports) {
$parcel$export(module.exports, "NON_BOOLEAN_VALUE", () => $5acb61e02717b827$export$42f4885608027d0c);
const $5acb61e02717b827$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("87Bg8", function(module, exports) {
$parcel$export(module.exports, "DefaultInteractionID", () => $5327c15ad072efe7$export$3109542b68df9ba1);
$parcel$export(module.exports, "subscribeToInteractionIdChanges", () => $5327c15ad072efe7$export$3e0c3023952f6774);
$parcel$export(module.exports, "default", () => $5327c15ad072efe7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInteractionId", () => $5327c15ad072efe7$export$37bca3107733ac1e);

var $4fqPo = parcelRequire("4fqPo");
const $5327c15ad072efe7$var$listeners = new Set();
// Observable interaction ID implementation
class $5327c15ad072efe7$var$ObservableInteractionID {
    get current() {
        return this._current;
    }
    set current(newId) {
        const oldId = this._current;
        this._current = newId;
        // Notify all listeners if the ID actually changed
        if (oldId !== newId) $5327c15ad072efe7$var$listeners.forEach((listener)=>listener(newId));
    }
    constructor(){
        this._current = null;
    }
}
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
const $5327c15ad072efe7$var$initializeGlobalDefaultInteractionID = ()=>{
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    const instance = new $5327c15ad072efe7$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
const $5327c15ad072efe7$export$3109542b68df9ba1 = $5327c15ad072efe7$var$initializeGlobalDefaultInteractionID();
const $5327c15ad072efe7$export$3e0c3023952f6774 = (listener)=>{
    $5327c15ad072efe7$var$listeners.add(listener);
    return ()=>{
        $5327c15ad072efe7$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
const $5327c15ad072efe7$var$interactionContext = (0, $4fqPo.createContext)($5327c15ad072efe7$export$3109542b68df9ba1);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$5327c15ad072efe7$export$2e2bcd8739ae039 = $5327c15ad072efe7$var$interactionContext;
const $5327c15ad072efe7$export$37bca3107733ac1e = ()=>$5327c15ad072efe7$export$3109542b68df9ba1;
const $5327c15ad072efe7$export$9f6000531b78127e = ()=>$5327c15ad072efe7$export$3109542b68df9ba1;

});
parcelRegister("4fqPo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2vBOA"));

});
parcelRegister("2vBOA", function(module, exports) {
$parcel$export(module.exports, "Children", () => $1d3bcf4a5246743f$export$dca3b0875bd9a954, (v) => $1d3bcf4a5246743f$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1d3bcf4a5246743f$export$16fa2f45be04daa8, (v) => $1d3bcf4a5246743f$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1d3bcf4a5246743f$export$ffb0004e005737fa, (v) => $1d3bcf4a5246743f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1d3bcf4a5246743f$export$e2c29f18771995cb, (v) => $1d3bcf4a5246743f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1d3bcf4a5246743f$export$221d75b3f55bb0bd, (v) => $1d3bcf4a5246743f$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1d3bcf4a5246743f$export$5f8d39834fd61797, (v) => $1d3bcf4a5246743f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1d3bcf4a5246743f$export$74bf444e3cd11ea5, (v) => $1d3bcf4a5246743f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1d3bcf4a5246743f$export$ae55be85d98224ed, (v) => $1d3bcf4a5246743f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1d3bcf4a5246743f$export$3ba232387fd5d6dd, (v) => $1d3bcf4a5246743f$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1d3bcf4a5246743f$export$e530037191fcd5d7, (v) => $1d3bcf4a5246743f$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1d3bcf4a5246743f$export$fd42f52fd3ae1109, (v) => $1d3bcf4a5246743f$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1d3bcf4a5246743f$export$c8a8987d4410bf2d, (v) => $1d3bcf4a5246743f$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1d3bcf4a5246743f$export$d38cd72104c1f0e9, (v) => $1d3bcf4a5246743f$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1d3bcf4a5246743f$export$7d1e3a5e95ceca43, (v) => $1d3bcf4a5246743f$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1d3bcf4a5246743f$export$257a8862b851cb5b, (v) => $1d3bcf4a5246743f$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1d3bcf4a5246743f$export$a8257692ac88316c, (v) => $1d3bcf4a5246743f$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1d3bcf4a5246743f$export$488013bae63b21da, (v) => $1d3bcf4a5246743f$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1d3bcf4a5246743f$export$7c73462e0d25e514, (v) => $1d3bcf4a5246743f$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1d3bcf4a5246743f$export$7568632d0d33d16d, (v) => $1d3bcf4a5246743f$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1d3bcf4a5246743f$export$88948ce120ea2619, (v) => $1d3bcf4a5246743f$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1d3bcf4a5246743f$export$35808ee640e87ca7, (v) => $1d3bcf4a5246743f$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1d3bcf4a5246743f$export$fae74005e78b1a27, (v) => $1d3bcf4a5246743f$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1d3bcf4a5246743f$export$dc8fbce3eb94dc1e, (v) => $1d3bcf4a5246743f$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1d3bcf4a5246743f$export$6a7bc4e911dc01cf, (v) => $1d3bcf4a5246743f$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1d3bcf4a5246743f$export$6d9c69b0de29b591, (v) => $1d3bcf4a5246743f$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1d3bcf4a5246743f$export$f680877a34711e37, (v) => $1d3bcf4a5246743f$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1d3bcf4a5246743f$export$d5a552a76deda3c2, (v) => $1d3bcf4a5246743f$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1d3bcf4a5246743f$export$aaabe4eda9ed9969, (v) => $1d3bcf4a5246743f$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1d3bcf4a5246743f$export$e5c5a5f917a5871c, (v) => $1d3bcf4a5246743f$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1d3bcf4a5246743f$export$1538c33de8887b59, (v) => $1d3bcf4a5246743f$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1d3bcf4a5246743f$export$13e3392192263954, (v) => $1d3bcf4a5246743f$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1d3bcf4a5246743f$export$b8f5890fc79d6aca, (v) => $1d3bcf4a5246743f$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1d3bcf4a5246743f$export$60241385465d0a34, (v) => $1d3bcf4a5246743f$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1d3bcf4a5246743f$export$306c0aa65ff9ec16, (v) => $1d3bcf4a5246743f$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1d3bcf4a5246743f$export$7b286972b8d8ccbf, (v) => $1d3bcf4a5246743f$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1d3bcf4a5246743f$export$83d89fbfd8236492, (v) => $1d3bcf4a5246743f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1d3bcf4a5246743f$export$dca3b0875bd9a954;
var $1d3bcf4a5246743f$export$16fa2f45be04daa8;
var $1d3bcf4a5246743f$export$ffb0004e005737fa;
var $1d3bcf4a5246743f$export$e2c29f18771995cb;
var $1d3bcf4a5246743f$export$221d75b3f55bb0bd;
var $1d3bcf4a5246743f$export$5f8d39834fd61797;
var $1d3bcf4a5246743f$export$74bf444e3cd11ea5;
var $1d3bcf4a5246743f$export$ae55be85d98224ed;
var $1d3bcf4a5246743f$export$3ba232387fd5d6dd;
var $1d3bcf4a5246743f$export$e530037191fcd5d7;
var $1d3bcf4a5246743f$export$fd42f52fd3ae1109;
var $1d3bcf4a5246743f$export$c8a8987d4410bf2d;
var $1d3bcf4a5246743f$export$d38cd72104c1f0e9;
var $1d3bcf4a5246743f$export$7d1e3a5e95ceca43;
var $1d3bcf4a5246743f$export$257a8862b851cb5b;
var $1d3bcf4a5246743f$export$a8257692ac88316c;
var $1d3bcf4a5246743f$export$488013bae63b21da;
var $1d3bcf4a5246743f$export$7c73462e0d25e514;
var $1d3bcf4a5246743f$export$7568632d0d33d16d;
var $1d3bcf4a5246743f$export$88948ce120ea2619;
var $1d3bcf4a5246743f$export$35808ee640e87ca7;
var $1d3bcf4a5246743f$export$fae74005e78b1a27;
var $1d3bcf4a5246743f$export$dc8fbce3eb94dc1e;
var $1d3bcf4a5246743f$export$6a7bc4e911dc01cf;
var $1d3bcf4a5246743f$export$6d9c69b0de29b591;
var $1d3bcf4a5246743f$export$f680877a34711e37;
var $1d3bcf4a5246743f$export$d5a552a76deda3c2;
var $1d3bcf4a5246743f$export$aaabe4eda9ed9969;
var $1d3bcf4a5246743f$export$e5c5a5f917a5871c;
var $1d3bcf4a5246743f$export$1538c33de8887b59;
var $1d3bcf4a5246743f$export$13e3392192263954;
var $1d3bcf4a5246743f$export$b8f5890fc79d6aca;
var $1d3bcf4a5246743f$export$60241385465d0a34;
var $1d3bcf4a5246743f$export$306c0aa65ff9ec16;
var $1d3bcf4a5246743f$export$7b286972b8d8ccbf;
var $1d3bcf4a5246743f$export$83d89fbfd8236492;
'use strict';
var $1d3bcf4a5246743f$var$l = Symbol.for("react.element"), $1d3bcf4a5246743f$var$n = Symbol.for("react.portal"), $1d3bcf4a5246743f$var$p = Symbol.for("react.fragment"), $1d3bcf4a5246743f$var$q = Symbol.for("react.strict_mode"), $1d3bcf4a5246743f$var$r = Symbol.for("react.profiler"), $1d3bcf4a5246743f$var$t = Symbol.for("react.provider"), $1d3bcf4a5246743f$var$u = Symbol.for("react.context"), $1d3bcf4a5246743f$var$v = Symbol.for("react.forward_ref"), $1d3bcf4a5246743f$var$w = Symbol.for("react.suspense"), $1d3bcf4a5246743f$var$x = Symbol.for("react.memo"), $1d3bcf4a5246743f$var$y = Symbol.for("react.lazy"), $1d3bcf4a5246743f$var$z = Symbol.iterator;
function $1d3bcf4a5246743f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1d3bcf4a5246743f$var$z && a[$1d3bcf4a5246743f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1d3bcf4a5246743f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1d3bcf4a5246743f$var$C = Object.assign, $1d3bcf4a5246743f$var$D = {};
function $1d3bcf4a5246743f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1d3bcf4a5246743f$var$D;
    this.updater = e || $1d3bcf4a5246743f$var$B;
}
$1d3bcf4a5246743f$var$E.prototype.isReactComponent = {};
$1d3bcf4a5246743f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1d3bcf4a5246743f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1d3bcf4a5246743f$var$F() {}
$1d3bcf4a5246743f$var$F.prototype = $1d3bcf4a5246743f$var$E.prototype;
function $1d3bcf4a5246743f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1d3bcf4a5246743f$var$D;
    this.updater = e || $1d3bcf4a5246743f$var$B;
}
var $1d3bcf4a5246743f$var$H = $1d3bcf4a5246743f$var$G.prototype = new $1d3bcf4a5246743f$var$F;
$1d3bcf4a5246743f$var$H.constructor = $1d3bcf4a5246743f$var$G;
$1d3bcf4a5246743f$var$C($1d3bcf4a5246743f$var$H, $1d3bcf4a5246743f$var$E.prototype);
$1d3bcf4a5246743f$var$H.isPureReactComponent = !0;
var $1d3bcf4a5246743f$var$I = Array.isArray, $1d3bcf4a5246743f$var$J = Object.prototype.hasOwnProperty, $1d3bcf4a5246743f$var$K = {
    current: null
}, $1d3bcf4a5246743f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1d3bcf4a5246743f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1d3bcf4a5246743f$var$J.call(b, d) && !$1d3bcf4a5246743f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1d3bcf4a5246743f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1d3bcf4a5246743f$var$K.current
    };
}
function $1d3bcf4a5246743f$var$N(a, b) {
    return {
        $$typeof: $1d3bcf4a5246743f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1d3bcf4a5246743f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1d3bcf4a5246743f$var$l;
}
function $1d3bcf4a5246743f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1d3bcf4a5246743f$var$P = /\/+/g;
function $1d3bcf4a5246743f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1d3bcf4a5246743f$var$escape("" + a.key) : b.toString(36);
}
function $1d3bcf4a5246743f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1d3bcf4a5246743f$var$l:
                case $1d3bcf4a5246743f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1d3bcf4a5246743f$var$Q(h, 0) : d, $1d3bcf4a5246743f$var$I(c) ? (e = "", null != a && (e = a.replace($1d3bcf4a5246743f$var$P, "$&/") + "/"), $1d3bcf4a5246743f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1d3bcf4a5246743f$var$O(c) && (c = $1d3bcf4a5246743f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1d3bcf4a5246743f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1d3bcf4a5246743f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1d3bcf4a5246743f$var$Q(k, g);
        h += $1d3bcf4a5246743f$var$R(k, b, e, f, c);
    }
    else if (f = $1d3bcf4a5246743f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1d3bcf4a5246743f$var$Q(k, g++), h += $1d3bcf4a5246743f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1d3bcf4a5246743f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1d3bcf4a5246743f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1d3bcf4a5246743f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1d3bcf4a5246743f$var$U = {
    current: null
}, $1d3bcf4a5246743f$var$V = {
    transition: null
}, $1d3bcf4a5246743f$var$W = {
    ReactCurrentDispatcher: $1d3bcf4a5246743f$var$U,
    ReactCurrentBatchConfig: $1d3bcf4a5246743f$var$V,
    ReactCurrentOwner: $1d3bcf4a5246743f$var$K
};
function $1d3bcf4a5246743f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1d3bcf4a5246743f$export$dca3b0875bd9a954 = {
    map: $1d3bcf4a5246743f$var$S,
    forEach: function(a, b, e) {
        $1d3bcf4a5246743f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1d3bcf4a5246743f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1d3bcf4a5246743f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1d3bcf4a5246743f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1d3bcf4a5246743f$export$16fa2f45be04daa8 = $1d3bcf4a5246743f$var$E;
$1d3bcf4a5246743f$export$ffb0004e005737fa = $1d3bcf4a5246743f$var$p;
$1d3bcf4a5246743f$export$e2c29f18771995cb = $1d3bcf4a5246743f$var$r;
$1d3bcf4a5246743f$export$221d75b3f55bb0bd = $1d3bcf4a5246743f$var$G;
$1d3bcf4a5246743f$export$5f8d39834fd61797 = $1d3bcf4a5246743f$var$q;
$1d3bcf4a5246743f$export$74bf444e3cd11ea5 = $1d3bcf4a5246743f$var$w;
$1d3bcf4a5246743f$export$ae55be85d98224ed = $1d3bcf4a5246743f$var$W;
$1d3bcf4a5246743f$export$3ba232387fd5d6dd = $1d3bcf4a5246743f$var$X;
$1d3bcf4a5246743f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1d3bcf4a5246743f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1d3bcf4a5246743f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1d3bcf4a5246743f$var$J.call(b, f) && !$1d3bcf4a5246743f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1d3bcf4a5246743f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1d3bcf4a5246743f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1d3bcf4a5246743f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1d3bcf4a5246743f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1d3bcf4a5246743f$export$c8a8987d4410bf2d = $1d3bcf4a5246743f$var$M;
$1d3bcf4a5246743f$export$d38cd72104c1f0e9 = function(a) {
    var b = $1d3bcf4a5246743f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1d3bcf4a5246743f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1d3bcf4a5246743f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1d3bcf4a5246743f$var$v,
        render: a
    };
};
$1d3bcf4a5246743f$export$a8257692ac88316c = $1d3bcf4a5246743f$var$O;
$1d3bcf4a5246743f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1d3bcf4a5246743f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1d3bcf4a5246743f$var$T
    };
};
$1d3bcf4a5246743f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1d3bcf4a5246743f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1d3bcf4a5246743f$export$7568632d0d33d16d = function(a) {
    var b = $1d3bcf4a5246743f$var$V.transition;
    $1d3bcf4a5246743f$var$V.transition = {};
    try {
        a();
    } finally{
        $1d3bcf4a5246743f$var$V.transition = b;
    }
};
$1d3bcf4a5246743f$export$88948ce120ea2619 = $1d3bcf4a5246743f$var$X;
$1d3bcf4a5246743f$export$35808ee640e87ca7 = function(a, b) {
    return $1d3bcf4a5246743f$var$U.current.useCallback(a, b);
};
$1d3bcf4a5246743f$export$fae74005e78b1a27 = function(a) {
    return $1d3bcf4a5246743f$var$U.current.useContext(a);
};
$1d3bcf4a5246743f$export$dc8fbce3eb94dc1e = function() {};
$1d3bcf4a5246743f$export$6a7bc4e911dc01cf = function(a) {
    return $1d3bcf4a5246743f$var$U.current.useDeferredValue(a);
};
$1d3bcf4a5246743f$export$6d9c69b0de29b591 = function(a, b) {
    return $1d3bcf4a5246743f$var$U.current.useEffect(a, b);
};
$1d3bcf4a5246743f$export$f680877a34711e37 = function() {
    return $1d3bcf4a5246743f$var$U.current.useId();
};
$1d3bcf4a5246743f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1d3bcf4a5246743f$var$U.current.useImperativeHandle(a, b, e);
};
$1d3bcf4a5246743f$export$aaabe4eda9ed9969 = function(a, b) {
    return $1d3bcf4a5246743f$var$U.current.useInsertionEffect(a, b);
};
$1d3bcf4a5246743f$export$e5c5a5f917a5871c = function(a, b) {
    return $1d3bcf4a5246743f$var$U.current.useLayoutEffect(a, b);
};
$1d3bcf4a5246743f$export$1538c33de8887b59 = function(a, b) {
    return $1d3bcf4a5246743f$var$U.current.useMemo(a, b);
};
$1d3bcf4a5246743f$export$13e3392192263954 = function(a, b, e) {
    return $1d3bcf4a5246743f$var$U.current.useReducer(a, b, e);
};
$1d3bcf4a5246743f$export$b8f5890fc79d6aca = function(a) {
    return $1d3bcf4a5246743f$var$U.current.useRef(a);
};
$1d3bcf4a5246743f$export$60241385465d0a34 = function(a) {
    return $1d3bcf4a5246743f$var$U.current.useState(a);
};
$1d3bcf4a5246743f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1d3bcf4a5246743f$var$U.current.useSyncExternalStore(a, b, e);
};
$1d3bcf4a5246743f$export$7b286972b8d8ccbf = function() {
    return $1d3bcf4a5246743f$var$U.current.useTransition();
};
$1d3bcf4a5246743f$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("dlWlx", function(module, exports) {
$parcel$export(module.exports, "BACKEND_RESOURCE_TIMING_INITIATOR_TYPES", () => $b7a4557c7574495b$export$c3b002e13fbb9ef2);
const $b7a4557c7574495b$export$c3b002e13fbb9ef2 = new Set([
    'fetch',
    'xmlhttprequest'
]);

});

parcelRegister("1h62Q", function(module, exports) {
$parcel$export(module.exports, "flushSsrRenderProfilerTraces", () => $878e02a49f8a0d9a$export$c8760e11c713fafc);
$parcel$export(module.exports, "default", () => $878e02a49f8a0d9a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $jFknK = parcelRequire("jFknK");

var $j58cX = parcelRequire("j58cX");

var $c62a8 = parcelRequire("c62a8");

var $3TFEq = parcelRequire("3TFEq");
var $878e02a49f8a0d9a$var$_process;
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
const $878e02a49f8a0d9a$var$startTimes = new Map();
const $878e02a49f8a0d9a$var$spanStates = new Map();
const $878e02a49f8a0d9a$export$cf4e4023c0a34c8d = ()=>{
    $878e02a49f8a0d9a$var$startTimes.clear();
    $878e02a49f8a0d9a$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
let $878e02a49f8a0d9a$var$lastActiveInteraction;
function $878e02a49f8a0d9a$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    const activeInteractionId = (_getActiveInteraction = (0, $c62a8.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!$878e02a49f8a0d9a$var$lastActiveInteraction && $878e02a49f8a0d9a$var$lastActiveInteraction !== activeInteractionId) $878e02a49f8a0d9a$export$cf4e4023c0a34c8d();
    $878e02a49f8a0d9a$var$lastActiveInteraction = activeInteractionId;
}
const $878e02a49f8a0d9a$var$getIsNativeTracingEnabled = ()=>{
    var _getConfig;
    return ((_getConfig = (0, $jFknK.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) ?? false;
};
const $878e02a49f8a0d9a$var$onStartRender = (id, currentSegmentName, parentContext)=>{
    var _startTimes$get, _vm_internals__;
    if (!$878e02a49f8a0d9a$var$startTimes.has(id)) $878e02a49f8a0d9a$var$startTimes.set(id, []);
    (_startTimes$get = $878e02a49f8a0d9a$var$startTimes.get(id)) === null || _startTimes$get === void 0 || _startTimes$get.push(performance.now());
    if (!$878e02a49f8a0d9a$var$getIsNativeTracingEnabled()) return null;
    const startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    let spanState = $878e02a49f8a0d9a$var$spanStates.get(id) ?? null;
    if (!spanState && startSpan) {
        const span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        $878e02a49f8a0d9a$var$spanStates.set(id, spanState);
    }
    return spanState;
};
const $878e02a49f8a0d9a$var$isInSSR = typeof __SERVER__ !== 'undefined' && __SERVER__ || typeof $3TFEq !== 'undefined' && Boolean((($878e02a49f8a0d9a$var$_process = $3TFEq) === null || $878e02a49f8a0d9a$var$_process === void 0 || ($878e02a49f8a0d9a$var$_process = $878e02a49f8a0d9a$var$_process.env) === null || $878e02a49f8a0d9a$var$_process === void 0 ? void 0 : $878e02a49f8a0d9a$var$_process.REACT_SSR) || false);
const $878e02a49f8a0d9a$var$ProfilerMarker = ({ onRender: onRender })=>{
    onRender === null || onRender === void 0 || onRender();
    return null;
};
const $878e02a49f8a0d9a$var$ParentSpanContext = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $878e02a49f8a0d9a$export$c8760e11c713fafc = ()=>{
    $878e02a49f8a0d9a$var$spanStates.forEach((spanState)=>{
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $878e02a49f8a0d9a$var$spanStates.clear();
};
const $878e02a49f8a0d9a$export$b8bd105b650b1c1e = ({ children: children, labelStack: labelStack, onRender: onRender })=>{
    const reactProfilerId = (0, $4fqPo.useMemo)(()=>labelStack.map((l)=>(0, $j58cX.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    $878e02a49f8a0d9a$var$checkActiveInteractionAndResetStartMarksIfSet();
    const parentSpan = (0, $4fqPo.useContext)($878e02a49f8a0d9a$var$ParentSpanContext);
    const currentSpanState = $878e02a49f8a0d9a$var$onStartRender(reactProfilerId, (0, $j58cX.sanitizeLabelStackName)(labelStack[labelStack.length - 1].name), parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($878e02a49f8a0d9a$var$ParentSpanContext.Provider, {
        value: (currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) ?? null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($878e02a49f8a0d9a$var$ProfilerMarker, {
        onRender: ()=>{
            const startTimesForId = $878e02a49f8a0d9a$var$startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                const endTime = performance.now();
                const firstStartTime = startTimesForId[0];
                const lastStartTime = startTimesForId[startTimesForId.length - 1];
                const baseDuration = endTime - lastStartTime;
                const actualDuration = endTime - firstStartTime;
                onRender('mount', // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, endTime);
            }
            const spanState = $878e02a49f8a0d9a$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
const $878e02a49f8a0d9a$var$SsrRenderProfiler = (props)=>{
    if ($878e02a49f8a0d9a$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($878e02a49f8a0d9a$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($878e02a49f8a0d9a$var$ProfilerMarker, null), props.children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$878e02a49f8a0d9a$export$2e2bcd8739ae039 = $878e02a49f8a0d9a$var$SsrRenderProfiler;

});

parcelRegister("5XOna", function(module, exports) {
$parcel$export(module.exports, "VCObserverWrapper", () => $09ccf3ecc8c45054$export$4a1fe1ab3c13bbf5);
$parcel$export(module.exports, "newVCObserver", () => $09ccf3ecc8c45054$export$c69731bddfc24d85);

var $jFknK = parcelRequire("jFknK");

var $cA7l2 = parcelRequire("cA7l2");

var $7rJy8 = parcelRequire("7rJy8");

var $2C85b = parcelRequire("2C85b");

var $6gTcj = parcelRequire("6gTcj");

var $lXOR9 = parcelRequire("lXOR9");

var $3TFEq = parcelRequire("3TFEq");
var $09ccf3ecc8c45054$var$_process;
class $09ccf3ecc8c45054$export$4a1fe1ab3c13bbf5 {
    constructor(opts = {}){
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $lXOR9.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
        });
        this.newVCObserver = new (0, $2C85b.default)({
            selectorConfig: opts.selectorConfig,
            isPostInteraction: opts.isPostInteraction,
            SSRConfig: {
                enablePageLayoutPlaceholder: opts.ssrEnablePageLayoutPlaceholder ?? false
            },
            ssrPlaceholderHandler: this.ssrPlaceholderHandler,
            trackLayoutShiftOffenders: opts.trackLayoutShiftOffenders ?? false,
            searchPageConfig: opts.searchPageConfig
        });
        if ((0, $jFknK.isVCRevisionEnabled)('fy25.01') || (0, $jFknK.isVCRevisionEnabled)('fy25.02')) this.oldVCObserver = new (0, $7rJy8.VCObserver)({
            ...opts,
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        });
    }
    // Helper method to process SSR abort listeners
    processSsrAbortListeners() {
        var _window;
        // Process any SSR abort listeners that remain
        if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
            // Clean up any event listeners that may have been registered during SSR
            // This is centralized here so only the wrapper handles unbinding, not individual observers
            if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach((unbind)=>{
                if (typeof unbind === 'function') unbind();
            });
            // After all observers had a chance to process abort events,
            // we can safely delete the SSR_ABORT_LISTENERS object
            delete window.__SSR_ABORT_LISTENERS__;
        }
    }
    start({ startTime: startTime, experienceKey: experienceKey }) {
        var _this$newVCObserver;
        if ((0, $jFknK.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $jFknK.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver;
            (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                startTime: startTime
            });
        }
        (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
            startTime: startTime
        });
        // Clean up any remaining SSR abort listeners after all observers have been started
        this.processSsrAbortListeners();
    }
    stop(experienceKey) {
        var _this$newVCObserver2;
        if ((0, $jFknK.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $jFknK.isVCRevisionEnabled)('fy25.02', experienceKey)) {
            var _this$oldVCObserver2;
            (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
        }
        (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
        (0, $6gTcj.RLLPlaceholderHandlers).getInstance().reset();
        // Clear shared SSR placeholder handler
        this.ssrPlaceholderHandler.clear();
    }
    getVCRawData() {
        var _this$oldVCObserver3;
        return ((_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) ?? null;
    }
    async getVCResult(param) {
        var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$;
        const { experienceKey: experienceKey, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, includeRawData: includeRawData } = param;
        const v1v2Result = (0, $jFknK.isVCRevisionEnabled)('fy25.01', experienceKey) || (0, $jFknK.isVCRevisionEnabled)('fy25.02', experienceKey) ? await ((_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param)) : {};
        const v3v4Result = await ((_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
            start: param.start,
            stop: param.stop,
            interactionId: param.interactionId,
            ssr: param.ssr,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            interactionType: param.interactionType,
            isPageVisible: param.isPageVisible,
            interactionAbortReason: param.interactionAbortReason,
            includeRawData: includeRawData,
            includeSSRInV3: param.includeSSRInV3,
            rawDataStopTime: param.rawDataStopTime,
            reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
        }));
        if (!v3v4Result || v3v4Result.length === 0) return v1v2Result ?? {};
        const ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
        return {
            ...includeSSRRatio && ssrRatio !== undefined ? {
                'ufo:vc:ssrRatio': ssrRatio
            } : {},
            ...v1v2Result,
            'ufo:vc:rev': [
                ...(v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result['ufo:vc:rev']) ?? [],
                ...v3v4Result ?? []
            ]
        };
    }
    setSSRElement(element) {
        var _this$oldVCObserver5, _this$newVCObserver4;
        (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
        (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime) {
        var _this$oldVCObserver6, _this$newVCObserver5;
        (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
        (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
    }
    setReactRootRenderStop(stopTime) {
        var _this$oldVCObserver7, _this$newVCObserver6;
        (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
        (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
    }
    collectSSRPlaceholders() {
        this.ssrPlaceholderHandler.collectExistingPlaceholders();
    }
}
// Some products set this variable to indicate it is running in SSR
let $09ccf3ecc8c45054$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
let $09ccf3ecc8c45054$var$isReactSSR = typeof $3TFEq !== 'undefined' && Boolean((($09ccf3ecc8c45054$var$_process = $3TFEq) === null || $09ccf3ecc8c45054$var$_process === void 0 || ($09ccf3ecc8c45054$var$_process = $09ccf3ecc8c45054$var$_process.env) === null || $09ccf3ecc8c45054$var$_process === void 0 ? void 0 : $09ccf3ecc8c45054$var$_process.REACT_SSR) || false);
function $09ccf3ecc8c45054$export$68d57b133e88584d() {
    // SSR environment aren't supported
    if ($09ccf3ecc8c45054$var$isReactSSR || $09ccf3ecc8c45054$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}
function $09ccf3ecc8c45054$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !$09ccf3ecc8c45054$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $cA7l2.VCObserverNOOP)() : new $09ccf3ecc8c45054$export$4a1fe1ab3c13bbf5(opts);
    }
    return globalThis.__vcObserver;
}
function $09ccf3ecc8c45054$export$c69731bddfc24d85(opts = {}) {
    const shouldMockVCObserver = !$09ccf3ecc8c45054$export$68d57b133e88584d();
    const observer = shouldMockVCObserver ? new (0, $cA7l2.VCObserverNOOP)() : new $09ccf3ecc8c45054$export$4a1fe1ab3c13bbf5(opts);
    return observer;
}

});
parcelRegister("cA7l2", function(module, exports) {
$parcel$export(module.exports, "VCObserverNOOP", () => $fcd428104a6fd8f4$export$24d07287b49da906);
class $fcd428104a6fd8f4$export$24d07287b49da906 {
    start(_) {}
    stop() {}
    getVCRawData() {
        return null;
    }
    getVCResult(_) {
        return Promise.resolve({
            'ufo:vc:noop': true
        });
    }
    setSSRElement(_) {}
    setReactRootRenderStart(_) {}
    setReactRootRenderStop(_) {}
}

});

parcelRegister("7rJy8", function(module, exports) {
$parcel$export(module.exports, "VCObserver", () => $9f86b0a4977f5fad$export$1f70d263701b1d01);

var $3H4LK = parcelRequire("3H4LK");

var $jFknK = parcelRequire("jFknK");

var $c62a8 = parcelRequire("c62a8");

var $9mAAI = parcelRequire("9mAAI");

var $fP5nl = parcelRequire("fP5nl");

var $tGTfO = parcelRequire("tGTfO");

var $ae6DC = parcelRequire("ae6DC");

var $8ScZV = parcelRequire("8ScZV");
const $9f86b0a4977f5fad$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
const $9f86b0a4977f5fad$var$UNUSED_SECTOR = 0;
function $9f86b0a4977f5fad$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(([timestamp, entries])=>[
            Number(timestamp),
            entries.map((entry)=>{
                const { __debug__element: __debug__element, ...rest } = entry;
                return rest;
            })
        ]));
}
class $9f86b0a4977f5fad$export$1f70d263701b1d01 {
    static #_ = /** config * */ this.VCParts = [
        '25',
        '50',
        '75',
        '80',
        '85',
        '90',
        '95',
        '98',
        '99'
    ];
    constructor(options){
        /* abort logic */ this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.outOfBoundaryInfo = '';
        this.viewport = {
            w: 0,
            h: 0
        };
        /* heatmap */ this.arraySize = 0;
        this.componentsLog = {};
        this.vcRatios = {};
        this.active = false;
        this.totalTime = 0;
        this.startTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            reactRendered: -1
        };
        this.unbind = [];
        this.getAbortReasonInfo = ()=>{
            if (this.abortReason.reason === null) return null;
            const info = this.abortReason.info !== '' ? ` ${this.abortReason.info}` : '';
            return `${this.abortReason.reason}${info}`;
        };
        this.getVCRawData = ()=>{
            this.measureStart();
            if (!this.active) {
                this.measureStop();
                return null;
            }
            this.stop();
            const abortReasonInfo = this.getAbortReasonInfo();
            this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: {
                    ...this.abortReason
                },
                heatmap: this.heatmap,
                heatmapNext: this.heatmapNext,
                outOfBoundaryInfo: this.outOfBoundaryInfo,
                totalTime: Math.round(this.totalTime + this.observers.getTotalTime()),
                componentsLog: {
                    ...this.componentsLog
                },
                viewport: {
                    ...this.viewport
                },
                oldDomUpdatesEnabled: this.oldDomUpdatesEnabled,
                devToolsEnabled: this.devToolsEnabled,
                ratios: this.vcRatios
            };
        };
        this.getVCResult = async ({ start: start, stop: stop, tti: tti, prefix: prefix, ssr: ssr, vc: vc, isEventAborted: isEventAborted, experienceKey: experienceKey, interactionId: interactionId, includeSSRRatio: includeSSRRatio })=>{
            const startTime = performance.now();
            // add local measurement
            const fullPrefix = prefix !== undefined && prefix !== '' ? `${prefix}:` : '';
            const rawData = vc !== undefined ? vc : this.getVCRawData();
            if (rawData === null) return {};
            const { abortReason: abortReason, abortReasonInfo: abortReasonInfo, heatmap: heatmap, heatmapNext: heatmapNext, outOfBoundaryInfo: outOfBoundaryInfo, totalTime: totalTime, componentsLog: componentsLog, viewport: viewport, devToolsEnabled: devToolsEnabled, ratios: ratios } = rawData;
            const isTTVCv1Disabled = !(0, $jFknK.isVCRevisionEnabled)('fy25.01', experienceKey);
            if (abortReasonInfo !== null) {
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch  {}
                const vcAbortedResultWithRevisions = {
                    [`${fullPrefix}vc:rev`]: [
                        {
                            revision: 'fy25.02',
                            clean: false,
                            'metric:vc90': null,
                            abortReason: abortReason.reason,
                            abortTimestamp: Math.round(abortReason.timestamp)
                        }
                    ]
                };
                if (!isTTVCv1Disabled) vcAbortedResultWithRevisions[`${fullPrefix}vc:rev`].push({
                    revision: 'fy25.01',
                    clean: false,
                    'metric:vc90': null,
                    abortReason: abortReason.reason,
                    abortTimestamp: Math.round(abortReason.timestamp)
                });
                return vcAbortedResultWithRevisions;
            }
            const ttvcV1Result = isTTVCv1Disabled ? {
                VC: {},
                VCBox: {},
                VCEntries: {
                    abs: [],
                    rel: [],
                    speedIndex: -1
                },
                totalPainted: -1
            } : $9f86b0a4977f5fad$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: {
                    ...componentsLog
                },
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const { VC: VC, VCBox: VCBox, VCEntries: VCEntries, totalPainted: totalPainted } = ttvcV1Result;
            const _componentsLog = {};
            Object.entries(this.componentsLog).forEach(([_timestamp, value])=>{
                const timestamp = Number(_timestamp);
                if (stop > timestamp) _componentsLog[timestamp] = value;
            });
            const vcNext = $9f86b0a4977f5fad$export$1f70d263701b1d01.calculateVC({
                heatmap: heatmapNext,
                ssr: ssr,
                componentsLog: _componentsLog,
                viewport: viewport,
                fixSSRAttribution: includeSSRRatio
            });
            const outOfBoundary = outOfBoundaryInfo ? {
                [`${fullPrefix}vc:oob`]: outOfBoundaryInfo
            } : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
            const stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!this.isPostInteraction && devToolsEnabled) {
                    const ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': VC['75'],
                            '80': VC['80'],
                            '85': VC['85'],
                            '90': VC['90'],
                            '95': VC['95'],
                            '98': VC['98'],
                            '99': VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    const ttvcV2DevToolInfo = {
                        entries: vcNext.VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            '75': vcNext.VC['75'],
                            '80': vcNext.VC['80'],
                            '85': vcNext.VC['85'],
                            '90': vcNext.VC['90'],
                            '95': vcNext.VC['95'],
                            '98': vcNext.VC['98'],
                            '99': vcNext.VC['99'],
                            tti: tti,
                            ttai: stop - start
                        },
                        start: start,
                        stop: stop,
                        heatmap: heatmapNext,
                        ratios: ratios
                    };
                    if (isTTVCv1Disabled) {
                        window.__vc = ttvcV2DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    } else {
                        window.__vc = ttvcV1DevToolInfo;
                        window.__vcNext = ttvcV2DevToolInfo;
                    }
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent('vcReady', {
                        detail: {
                            log: $9f86b0a4977f5fad$var$filterComponentsLog(componentsLog),
                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                        }
                    }));
                }
                if (!this.isPostInteraction) {
                    // Only create revision debug details if callbacks exist
                    const shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === 'function' || typeof window.__on_ufo_vc_debug_data_ready === 'function';
                    if (shouldCreateDebugDetails) {
                        const v1RevisionDebugDetails = (0, $fP5nl.getVCRevisionDebugDetails)({
                            revision: 'fy25.01',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        const v2RevisionDebugDetails = (0, $fP5nl.getVCRevisionDebugDetails)({
                            revision: 'fy25.02',
                            isClean: !abortReasonInfo,
                            abortReason: abortReason.reason,
                            VCEntries: vcNext.VCEntries.rel,
                            componentsLog: componentsLog,
                            interactionId: interactionId
                        });
                        // Add devtool callback for both v1 and v2
                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === 'function') {
                            var _window$__ufo_devtool2, _window2;
                            // Handle v1 if not disabled
                            if (!isTTVCv1Disabled) {
                                var _window$__ufo_devtool, _window;
                                (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                            }
                            // Handle v2
                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                        }
                        if (typeof window.__on_ufo_vc_debug_data_ready === 'function') {
                            var _window$__on_ufo_vc_d2, _window4;
                            if (!isTTVCv1Disabled) {
                                var _window$__on_ufo_vc_d, _window3;
                                (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                            }
                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                        }
                    }
                }
            } catch  {
            /*  do nothing */ }
            const isVCClean = !abortReasonInfo;
            const revisionsData = (0, $tGTfO.getVCRevisionsData)({
                fullPrefix: fullPrefix,
                interaction: {
                    start: start,
                    end: stop
                },
                isVCClean: isVCClean,
                calculatedVC: {
                    VC: VC,
                    VCBox: VCBox
                },
                calculatedVCNext: {
                    VC: vcNext.VC,
                    VCBox: vcNext.VCBox
                },
                isEventAborted: isEventAborted,
                experienceKey: experienceKey,
                ratios: ratios
            });
            const speedIndex = {
                [`ufo:speedIndex`]: isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex,
                [`ufo:next:speedIndex`]: vcNext.VCEntries.speedIndex
            };
            const SSRRatio = $9f86b0a4977f5fad$export$1f70d263701b1d01.getSSRRatio(VCEntries.rel, ssr);
            const SSRRatioNext = $9f86b0a4977f5fad$export$1f70d263701b1d01.getSSRRatio(vcNext.VCEntries.rel, ssr);
            const SSRRatioPayload = includeSSRRatio ? {
                [`${fullPrefix}vc:ssrRatio`]: isTTVCv1Disabled ? SSRRatioNext : SSRRatio,
                [`${fullPrefix}vc:next:ssrRatio`]: SSRRatioNext
            } : {};
            if (isTTVCv1Disabled) return {
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:ratios`]: ratios,
                ...outOfBoundary,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatioNext,
                ...revisionsData,
                ...speedIndex
            };
            const isTTVCv3Enabled = (0, $jFknK.isVCRevisionEnabled)('fy25.03', experienceKey);
            return {
                'metrics:vc': VC,
                [`${fullPrefix}vc:state`]: true,
                [`${fullPrefix}vc:clean`]: isVCClean,
                [`${fullPrefix}vc:dom`]: VCBox,
                [`${fullPrefix}vc:updates`]: isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:size`]: viewport,
                [`${fullPrefix}vc:time`]: Math.round(totalTime + (stopTime - startTime)),
                [`${fullPrefix}vc:total`]: totalPainted,
                [`${fullPrefix}vc:ratios`]: ratios,
                [`${fullPrefix}vc:ssrRatio`]: SSRRatio,
                ...outOfBoundary,
                [`${fullPrefix}vc:next`]: vcNext.VC,
                [`${fullPrefix}vc:next:updates`]: isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50),
                // max 50
                [`${fullPrefix}vc:next:dom`]: vcNext.VCBox,
                ...SSRRatioPayload,
                [`${fullPrefix}vc:ignored`]: this.getIgnoredElements(componentsLog),
                ...revisionsData,
                ...speedIndex
            };
        };
        this.handleUpdate = (rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue)=>{
            if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                const time = Math.round(rawTime - this.startTime);
                const mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                this.vcRatios[targetName] = this.getElementRatio(mappedValues);
                if (!ignoreReason) this.applyChangesToHeatMap(mappedValues, time, this.heatmapNext);
                const interaction = (0, $c62a8.getActiveInteraction)();
                const isTTVCv1Disabled = !(0, $jFknK.isVCRevisionEnabled)('fy25.01', interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') this.applyChangesToHeatMap(mappedValues, time, this.heatmap);
                if (!this.componentsLog[time]) this.componentsLog[time] = [];
                this.componentsLog[time].push({
                    __debug__element: this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        };
        this.mapPixelsToHeatmap = (left, top, width, height)=>{
            const { w: w, h: h } = this.viewport;
            const l = Math.floor(left / w * this.arraySize);
            const t = Math.floor(top / h * this.arraySize);
            const r = Math.ceil((left + width) / w * this.arraySize);
            const b = Math.ceil((top + height) / h * this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (this.outOfBoundaryInfo === '') {
                let outOfBoundaryInfo = '';
                if (r > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${left} ${width}`;
                if (b > this.arraySize) outOfBoundaryInfo += ` r ${r} ! ${top} ${height}`;
                this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            const result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(this.arraySize, r),
                b: Math.min(this.arraySize, b)
            };
            return result;
        };
        this.getElementRatio = (mappedValues)=>{
            const { r: r, l: l, b: b, t: t } = mappedValues;
            return (r - l) * (b - t) / (this.arraySize * this.arraySize);
        };
        this.abortReasonCallback = (key, time)=>{
            switch(key){
                case 'wheel':
                    this.setAbortReason($9f86b0a4977f5fad$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $3H4LK.fg)('platform_ufo_keypress_interaction_abort')) {
                        const interaction = (0, $c62a8.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') break;
                    }
                    this.setAbortReason($9f86b0a4977f5fad$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    this.setAbortReason($9f86b0a4977f5fad$var$abortReason.resize, time);
                    break;
            }
        };
        this.attachAbortListeners = ()=>{
            var _window5;
            this.detachAbortListeners();
            let unbinds = (0, $9mAAI.attachAbortListeners)(window, this.viewport, this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(([key, time])=>{
                if (time) this.abortReasonCallback(key, time);
            });
            this.unbind = unbinds;
        };
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        const { ssrEnablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler: ssrPlaceholderHandler } = options;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It enforces FedRAMP-override > caller-override >
        // centrally configured > caller default. When `getSelectorConfig()`
        // returns `undefined` we fall back to the legacy hard-coded default
        // to preserve pre-existing behaviour for callers that don't pass an
        // explicit `selectorConfig`.
        const LEGACY_DEFAULT_SELECTOR_CONFIG = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.observers = new (0, $8ScZV.Observers)({
            selectorConfig: (0, $jFknK.getSelectorConfig)(options.selectorConfig, LEGACY_DEFAULT_SELECTOR_CONFIG) || options.selectorConfig || LEGACY_DEFAULT_SELECTOR_CONFIG,
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $jFknK.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    start({ startTime: startTime }) {
        this.active = true;
        if (this.observers.isBrowserSupported()) {
            this.setViewportSize();
            this.resetState();
            this.startTime = startTime;
            this.attachAbortListeners();
            this.observers.subscribeResults(this.handleUpdate);
            this.observers.observe();
        } else this.setAbortReason('not-supported', startTime);
    }
    stop() {
        this.observers.disconnect();
        this.detachAbortListeners();
    }
    getIgnoredElements(componentsLog) {
        return Object.values(componentsLog).flat().filter(({ ignoreReason: ignoreReason })=>Boolean(ignoreReason)).map(({ targetName: targetName, ignoreReason: ignoreReason })=>({
                targetName: targetName,
                ignoreReason: ignoreReason
            }));
    }
    static getSSRRatio(entries, ssr) {
        if (ssr === undefined || entries.length === 0) return undefined;
        const maybeSSR = entries[0];
        if (maybeSSR.elements[0] === 'SSR') return maybeSSR.vc;
        return 0;
    }
    static calculateVC({ heatmap: heatmap, ssr: ssr = $9f86b0a4977f5fad$var$UNUSED_SECTOR, componentsLog: componentsLog, viewport: viewport, fixSSRAttribution: fixSSRAttribution }) {
        const lastUpdate = {};
        let totalPainted = 0;
        const ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
        if (ssrTime !== $9f86b0a4977f5fad$var$UNUSED_SECTOR) {
            var _window$document;
            const element = {
                __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                intersectionRect: {
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    x: 0,
                    y: 0,
                    width: viewport.w,
                    height: viewport.h,
                    toJSON () {
                        return {};
                    }
                },
                targetName: 'SSR'
            };
            if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
            componentsLog[ssrTime].push(element);
        }
        heatmap.forEach((line)=>{
            line.forEach((entry)=>{
                const rounded = Math.floor(entry === $9f86b0a4977f5fad$var$UNUSED_SECTOR && ssrTime !== $9f86b0a4977f5fad$var$UNUSED_SECTOR ? ssrTime : entry);
                totalPainted += rounded !== $9f86b0a4977f5fad$var$UNUSED_SECTOR ? 1 : 0;
                if (rounded !== $9f86b0a4977f5fad$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
            });
        });
        const entries = Object.entries(lastUpdate).map((a)=>[
                parseInt(a[0], 10),
                a[1]
            ]).sort((a, b)=>a[0] > b[0] ? 1 : -1);
        const VC = $9f86b0a4977f5fad$export$1f70d263701b1d01.makeVCReturnObj();
        const VCBox = $9f86b0a4977f5fad$export$1f70d263701b1d01.makeVCReturnObj();
        entries.reduce((acc = 0, v)=>{
            const currRatio = v[1] / totalPainted;
            let VCRatio = currRatio + acc;
            const preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
            const preciseAccRatio = Math.round(acc * 100);
            VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
            const time = v[0];
            $9f86b0a4977f5fad$export$1f70d263701b1d01.VCParts.forEach((key)=>{
                const value = parseInt(key, 10);
                if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                    var _componentsLog$time;
                    VC[key] = time;
                    VCBox[key] = [
                        ...new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
                    ];
                }
            });
            return VCRatio;
        }, 0);
        const VCEntries = entries.reduce((acc, [timestamp, entryPainted], i)=>{
            var _acc$abs, _componentsLog$timest, _acc$rel;
            const currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
            const currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
            const logEntry = [
                ...new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter((v)=>!v.ignoreReason).map((v)=>v.targetName))
            ];
            const ratioDelta = (currentlyPaintedRatio - (((_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) ?? 0)) / 100;
            const speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
            acc.abs.push([
                timestamp,
                currentlyPainted
            ]);
            acc.rel.push({
                time: timestamp,
                vc: currentlyPaintedRatio,
                elements: logEntry
            });
            return acc;
        }, {
            abs: [],
            rel: [],
            speedIndex: 0
        });
        VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
        return {
            VC: VC,
            VCBox: VCBox,
            VCEntries: VCEntries,
            totalPainted: totalPainted
        };
    }
    setSSRElement(element) {
        this.observers.setReactRootElement(element);
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.observers.setReactRootRenderStart(startTime);
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.observers.setReactRootRenderStop(stopTime);
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    setAbortReason(abort, timestamp, info = '') {
        if (this.abortReason.reason === null || this.abortReason.blocking === false) {
            this.abortReason.reason = abort;
            this.abortReason.info = info;
            this.abortReason.timestamp = timestamp;
            this.abortReason.blocking = abort !== $9f86b0a4977f5fad$var$abortReason.scroll;
            if (this.abortReason.blocking) this.detachAbortListeners();
        }
    }
    resetState() {
        this.abortReason = {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        };
        this.detachAbortListeners();
        this.heatmap = !(0, $jFknK.isVCRevisionEnabled)('fy25.01') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.totalTime = 0;
        this.componentsLog = {};
        this.vcRatios = {};
    }
    getCleanHeatmap() {
        return Array(this.arraySize).fill('').map(()=>Array(this.arraySize).fill($9f86b0a4977f5fad$var$UNUSED_SECTOR));
    }
    setViewportSize() {
        this.viewport.w = (0, $ae6DC.getViewportWidth)();
        this.viewport.h = (0, $ae6DC.getViewportHeight)();
    }
    applyChangesToHeatMap(a, time, heatmap) {
        const { l: l, t: t, r: r, b: b } = a;
        const localHeatmap = heatmap;
        for(let row = t; row < b; row++){
            for(let col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                try {
                    this.setAbortReason($9f86b0a4977f5fad$var$abortReason.error, time, `index - ${row}`);
                } catch  {
                    this.setAbortReason($9f86b0a4977f5fad$var$abortReason.error, time, 'row error');
                }
                return;
            } else localHeatmap[row][col] = time;
        }
    }
    static makeVCReturnObj() {
        const vc = {};
        $9f86b0a4977f5fad$export$1f70d263701b1d01.VCParts.forEach((v)=>{
            vc[v] = null;
        });
        return vc;
    }
    detachAbortListeners() {
        if (this.unbind) {
            const { unbind: unbind } = this;
            for(let i = 0; i < unbind.length; i++)unbind[i]();
            this.unbind.length = 0;
        }
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("9mAAI", function(module, exports) {
$parcel$export(module.exports, "attachAbortListeners", () => $a4fde6d8aba78492$export$9010aa71841a6887);

var $lMcEJ = parcelRequire("lMcEJ");

var $ettAM = parcelRequire("ettAM");

var $ae6DC = parcelRequire("ae6DC");
function $a4fde6d8aba78492$export$9010aa71841a6887(window, initialViewPort, callback) {
    const unbindWheel = (0, $lMcEJ.bind)(window, {
        type: (0, $ettAM.AbortEvent).wheel,
        listener: (e)=>{
            callback((0, $ettAM.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    const unbindKeydown = (0, $lMcEJ.bind)(window, {
        type: (0, $ettAM.AbortEvent).keydown,
        listener: (e)=>{
            callback((0, $ettAM.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    const unbindResize = (0, $lMcEJ.bind)(window, {
        type: (0, $ettAM.AbortEvent).resize,
        listener: (e)=>{
            if ((0, $ae6DC.getViewportWidth)() !== initialViewPort.w || (0, $ae6DC.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $ettAM.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("lMcEJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $3kMbe = parcelRequire("3kMbe");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $3kMbe.bind;
    }
});

var $1zOCR = parcelRequire("1zOCR");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $1zOCR.bindAll;
    }
});

});
parcelRegister("3kMbe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $26d89cf0a35f59ce$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $26d89cf0a35f59ce$var$bind;

});

parcelRegister("1zOCR", function(module, exports) {
"use strict";
var $1260548f5e56a035$var$__assign = module.exports && module.exports.__assign || function() {
    $1260548f5e56a035$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1260548f5e56a035$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $3kMbe = parcelRequire("3kMbe");
function $1260548f5e56a035$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $1260548f5e56a035$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $1260548f5e56a035$var$__assign($1260548f5e56a035$var$__assign({}, original), {
        options: $1260548f5e56a035$var$__assign($1260548f5e56a035$var$__assign({}, $1260548f5e56a035$var$toOptions(sharedOptions)), $1260548f5e56a035$var$toOptions(original.options))
    });
    return binding;
}
function $1260548f5e56a035$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $1260548f5e56a035$var$getBinding(original, sharedOptions);
        return (0, $3kMbe.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $1260548f5e56a035$var$bindAll;

});


parcelRegister("ettAM", function(module, exports) {
$parcel$export(module.exports, "AbortEvent", () => $3155ec4f4a0337f6$export$199edc0307b5587f);
const $3155ec4f4a0337f6$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("ae6DC", function(module, exports) {
$parcel$export(module.exports, "getViewportWidth", () => $bab645fc9e5fbd64$export$a497a1dcb4408212);
$parcel$export(module.exports, "getViewportHeight", () => $bab645fc9e5fbd64$export$4f01c15d21ef9cc6);
function $bab645fc9e5fbd64$export$a497a1dcb4408212(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $bab645fc9e5fbd64$export$4f01c15d21ef9cc6(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("fP5nl", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionDebugDetails", () => $ad0397cf8dd570ce$export$72e6dda9d5859230);
function $ad0397cf8dd570ce$export$72e6dda9d5859230({ revision: revision, isClean: isClean, abortReason: abortReason, VCEntries: VCEntries, componentsLog: componentsLog, interactionId: interactionId }) {
    // Pre-sort VCEntries by time for efficient lookups
    const sortedVCEntries = [
        ...VCEntries
    ].sort((a, b)=>a.time - b.time);
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    const maxViewportPercentageAtTime = new Map();
    let maxSoFar = 0;
    for (const entry of sortedVCEntries){
        maxSoFar = Math.max(maxSoFar, entry.vc);
        maxViewportPercentageAtTime.set(entry.time, maxSoFar);
    }
    // Helper function to find the biggest previous viewport percentage
    const getBiggestPreviousViewportPercentage = (targetTime)=>{
        // Binary search for the largest time <= targetTime
        let left = 0;
        let right = sortedVCEntries.length - 1;
        let result = -1;
        while(left <= right){
            const mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    const allVcLogs = [];
    // Add regular VC entries
    for (const entry of VCEntries){
        const timeLogEntries = componentsLog[entry.time];
        allVcLogs.push({
            time: entry.time,
            viewportPercentage: entry.vc,
            entries: entry.elements.map((element)=>{
                const logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find((log)=>log.targetName === element);
                return {
                    elementName: element,
                    type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                    rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                    visible: true,
                    attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                    oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                    newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                    ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                };
            })
        });
    }
    // Add ignored elements - only process timestamps that have ignored elements
    for (const [timestamp, timeLogEntries] of Object.entries(componentsLog)){
        const ignoredElements = timeLogEntries.filter((log)=>log.ignoreReason);
        if (ignoredElements.length === 0) continue;
        const time = Number(timestamp);
        const viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map((logEntry)=>({
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                }))
        });
    }
    // Sort once at the end
    allVcLogs.sort((a, b)=>a.time - b.time);
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("tGTfO", function(module, exports) {
$parcel$export(module.exports, "getVCRevisionsData", () => $5f1e780324c7c98f$export$5c86a34c9becd6d0);

var $jFknK = parcelRequire("jFknK");

var $kEbbM = parcelRequire("kEbbM");
const $5f1e780324c7c98f$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
const $5f1e780324c7c98f$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $5f1e780324c7c98f$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    const details = {};
    const { VC: VC, VCBox: VCBox } = calculatedVC; // Destructure once to avoid repeated property access
    for (const key of $5f1e780324c7c98f$var$VCParts)details[key] = {
        t: VC[key] || -1,
        e: VCBox[key] || $5f1e780324c7c98f$var$READONLY_EMPTY_ARRAY
    };
    return details;
}
function $5f1e780324c7c98f$export$5c86a34c9becd6d0({ fullPrefix: fullPrefix, interaction: interaction, isVCClean: isVCClean, isEventAborted: isEventAborted, calculatedVC: calculatedVC, calculatedVCNext: calculatedVCNext, experienceKey: experienceKey, ratios: ratios }) {
    const pageVisibilityUpToTTAI = (0, $kEbbM.getPageVisibilityState)(interaction.start, interaction.end);
    const isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    const shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    const availableVCRevisionPayloads = [];
    if ((0, $jFknK.isVCRevisionEnabled)('fy25.01', experienceKey)) {
        const revision = {
            revision: 'fy25.01',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
            vcDetails: $5f1e780324c7c98f$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $jFknK.isVCRevisionEnabled)('fy25.02', experienceKey)) {
        const revision = {
            revision: 'fy25.02',
            clean: isVCClean,
            'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
            vcDetails: $5f1e780324c7c98f$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    return {
        [`${fullPrefix}vc:rev`]: availableVCRevisionPayloads
    };
}

});
parcelRegister("kEbbM", function(module, exports) {
$parcel$export(module.exports, "getEarliestHiddenTiming", () => $5a06fc7c03a524a0$export$754443ce7c615bd7);
$parcel$export(module.exports, "isOpenedInBackground", () => $5a06fc7c03a524a0$export$21a1a62a307062f1);
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", () => $5a06fc7c03a524a0$export$95f048bd8bcdda23);
$parcel$export(module.exports, "setupHiddenTimingCapture", () => $5a06fc7c03a524a0$export$554cefe0f0373da4);
$parcel$export(module.exports, "getPageVisibilityState", () => $5a06fc7c03a524a0$export$768b2008623433e1);
$parcel$export(module.exports, "setupThrottleDetection", () => $5a06fc7c03a524a0$export$fa0d29a9c87052da);
$parcel$export(module.exports, "isTabThrottled", () => $5a06fc7c03a524a0$export$62a28c860277b3bf);
$parcel$export(module.exports, "getPageVisibilityTimeline", () => $5a06fc7c03a524a0$export$5a06b84e47ad70d9);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $lMcEJ = parcelRequire("lMcEJ");

var $3H4LK = parcelRequire("3H4LK");
const $5a06fc7c03a524a0$var$timings = [];
let $5a06fc7c03a524a0$var$wasHiddenFlag;
let $5a06fc7c03a524a0$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
const $5a06fc7c03a524a0$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
let $5a06fc7c03a524a0$var$openedInBackground = null;
function $5a06fc7c03a524a0$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
const $5a06fc7c03a524a0$var$SIZE = 50;
let $5a06fc7c03a524a0$var$insertIndex = 0;
function $5a06fc7c03a524a0$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    const earliestHiddenTiming = (_timings$find = $5a06fc7c03a524a0$var$timings.find(({ hidden: hidden, time: time })=>hidden && time > 0 && time >= startTime && time <= endTime)) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === 'number') return Math.round(earliestHiddenTiming - startTime);
}
function $5a06fc7c03a524a0$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== 'page_load') return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        const entries = performance.getEntriesByType('visibility-state');
        if (entries.length > 0) return entries.some((entry)=>entry.name === 'hidden' && entry.startTime <= $5a06fc7c03a524a0$var$OPENED_IN_BACKGROUND_THRESHOLD_MS);
    } catch  {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $5a06fc7c03a524a0$var$openedInBackground === true;
}
function $5a06fc7c03a524a0$var$pushHidden(isPageHiddenFlag, time) {
    $5a06fc7c03a524a0$var$timings[$5a06fc7c03a524a0$var$insertIndex] = {
        time: time ?? performance.now(),
        hidden: isPageHiddenFlag
    };
    $5a06fc7c03a524a0$var$insertIndex = ($5a06fc7c03a524a0$var$insertIndex + 1) % $5a06fc7c03a524a0$var$SIZE;
    $5a06fc7c03a524a0$var$wasHiddenFlag = isPageHiddenFlag;
}
function $5a06fc7c03a524a0$var$handleChange() {
    const isPageHiddenFlag = $5a06fc7c03a524a0$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$5a06fc7c03a524a0$var$wasHiddenFlag) $5a06fc7c03a524a0$var$pushHidden(isPageHiddenFlag);
        $5a06fc7c03a524a0$var$wasHiddenFlag = true;
    } else {
        if ($5a06fc7c03a524a0$var$wasHiddenFlag) $5a06fc7c03a524a0$var$pushHidden(isPageHiddenFlag);
        $5a06fc7c03a524a0$var$wasHiddenFlag = false;
    }
}
let $5a06fc7c03a524a0$var$hasHiddenTimingBeforeSetup = false;
function $5a06fc7c03a524a0$export$95f048bd8bcdda23() {
    return $5a06fc7c03a524a0$var$hasHiddenTimingBeforeSetup;
}
function $5a06fc7c03a524a0$var$setup() {
    try {
        const results = performance.getEntriesByType('visibility-state');
        results === null || results === void 0 || results.forEach((result)=>{
            if ((0, $3H4LK.fg)('platform_ufo_use_native_page_visibility_api')) $5a06fc7c03a524a0$var$pushHidden(result.name === 'hidden', result.startTime);
            if (result.name === 'hidden') $5a06fc7c03a524a0$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch  {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $lMcEJ.bind)(window, {
        type: 'pageshow',
        listener: $5a06fc7c03a524a0$var$handleChange
    });
    (0, $lMcEJ.bind)(window, {
        type: 'pagehide',
        listener: $5a06fc7c03a524a0$var$handleChange
    });
    (0, $lMcEJ.bind)(document, {
        type: 'visibilitychange',
        listener: $5a06fc7c03a524a0$var$handleChange
    });
}
function $5a06fc7c03a524a0$export$554cefe0f0373da4() {
    if (!$5a06fc7c03a524a0$var$setupFlag) {
        const isPageHiddenFlag = $5a06fc7c03a524a0$var$isPageHidden();
        const setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($5a06fc7c03a524a0$var$openedInBackground === null) $5a06fc7c03a524a0$var$openedInBackground = isPageHiddenFlag && setupTime < $5a06fc7c03a524a0$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $5a06fc7c03a524a0$var$pushHidden(isPageHiddenFlag, 0);
        $5a06fc7c03a524a0$var$setup();
        $5a06fc7c03a524a0$var$setupFlag = true;
    }
}
function $5a06fc7c03a524a0$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return 'visible';
    // Desirable default value is visible
    if ($5a06fc7c03a524a0$var$timings.length === 0) return 'visible';
    const currentSize = $5a06fc7c03a524a0$var$timings.length;
    let hiddenState = 'mixed';
    let startIdx = $5a06fc7c03a524a0$var$insertIndex;
    let endIdx = $5a06fc7c03a524a0$var$insertIndex;
    // currentSize is capped at SIZE.
    for(let i = 0; i < currentSize; i++){
        const tmpIdx = ($5a06fc7c03a524a0$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($5a06fc7c03a524a0$var$timings[tmpIdx] && $5a06fc7c03a524a0$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($5a06fc7c03a524a0$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $5a06fc7c03a524a0$var$timings[startIdx]) hiddenState = $5a06fc7c03a524a0$var$timings[startIdx].hidden ? 'hidden' : 'visible';
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
const $5a06fc7c03a524a0$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
const $5a06fc7c03a524a0$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
const $5a06fc7c03a524a0$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
const $5a06fc7c03a524a0$var$throttleMeasurements = [];
let $5a06fc7c03a524a0$var$throttleInsertIndex = 0;
let $5a06fc7c03a524a0$var$throttleIntervalId = null;
let $5a06fc7c03a524a0$var$lastThrottleCheckTime = null;
let $5a06fc7c03a524a0$var$throttleSetupDone = false;
function $5a06fc7c03a524a0$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    const isThrottled = actualElapsed > expectedElapsed * $5a06fc7c03a524a0$var$THROTTLE_DRIFT_THRESHOLD;
    $5a06fc7c03a524a0$var$throttleMeasurements[$5a06fc7c03a524a0$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $5a06fc7c03a524a0$var$throttleInsertIndex = ($5a06fc7c03a524a0$var$throttleInsertIndex + 1) % $5a06fc7c03a524a0$var$THROTTLE_BUFFER_SIZE;
}
function $5a06fc7c03a524a0$var$throttleCheckCallback() {
    const currentTime = performance.now();
    if ($5a06fc7c03a524a0$var$lastThrottleCheckTime !== null) {
        const actualElapsed = currentTime - $5a06fc7c03a524a0$var$lastThrottleCheckTime;
        $5a06fc7c03a524a0$var$recordThrottleMeasurement($5a06fc7c03a524a0$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $5a06fc7c03a524a0$var$lastThrottleCheckTime = currentTime;
}
function $5a06fc7c03a524a0$export$fa0d29a9c87052da() {
    if ($5a06fc7c03a524a0$var$throttleSetupDone) return;
    $5a06fc7c03a524a0$var$throttleSetupDone = true;
    // Record the initial timestamp
    $5a06fc7c03a524a0$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $5a06fc7c03a524a0$var$throttleIntervalId = setInterval($5a06fc7c03a524a0$var$throttleCheckCallback, $5a06fc7c03a524a0$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $5a06fc7c03a524a0$export$3279694d66e4a1() {
    if ($5a06fc7c03a524a0$var$throttleIntervalId !== null) {
        clearInterval($5a06fc7c03a524a0$var$throttleIntervalId);
        $5a06fc7c03a524a0$var$throttleIntervalId = null;
    }
    $5a06fc7c03a524a0$var$lastThrottleCheckTime = null;
    $5a06fc7c03a524a0$var$throttleSetupDone = false;
    $5a06fc7c03a524a0$var$throttleMeasurements.length = 0;
    $5a06fc7c03a524a0$var$throttleInsertIndex = 0;
}
function $5a06fc7c03a524a0$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($5a06fc7c03a524a0$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(let i = 0; i < $5a06fc7c03a524a0$var$throttleMeasurements.length; i++){
        const measurement = $5a06fc7c03a524a0$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $5a06fc7c03a524a0$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $5a06fc7c03a524a0$var$throttleMeasurements.filter((measurement)=>measurement && measurement.time >= startTime && measurement.time <= endTime);
}
function $5a06fc7c03a524a0$export$9332de935653b687(measurement) {
    $5a06fc7c03a524a0$var$throttleMeasurements[$5a06fc7c03a524a0$var$throttleInsertIndex] = measurement;
    $5a06fc7c03a524a0$var$throttleInsertIndex = ($5a06fc7c03a524a0$var$throttleInsertIndex + 1) % $5a06fc7c03a524a0$var$THROTTLE_BUFFER_SIZE;
}
function $5a06fc7c03a524a0$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($5a06fc7c03a524a0$var$timings.length === 0) return [];
    const result = [];
    // Find the most recent entry at or before startTime to establish initial state
    let initialEntry;
    const currentSize = $5a06fc7c03a524a0$var$timings.length;
    for(let i = 0; i < currentSize; i++){
        const idx = ($5a06fc7c03a524a0$var$insertIndex + i) % currentSize;
        const entry = $5a06fc7c03a524a0$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(let i = 0; i < currentSize; i++){
        const idx = ($5a06fc7c03a524a0$var$insertIndex + i) % currentSize;
        const entry = $5a06fc7c03a524a0$var$timings[idx];
        if (entry && entry.time > startTime && entry.time <= endTime) result.push({
            time: Math.round(entry.time - startTime),
            hidden: entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== 'undefined') window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $5a06fc7c03a524a0$export$9332de935653b687
};

});


parcelRegister("8ScZV", function(module, exports) {
$parcel$export(module.exports, "Observers", () => $48436c32593a32c9$export$b65d046240060e78);

var $jFknK = parcelRequire("jFknK");

var $aeOqv = parcelRequire("aeOqv");

var $iuKXX = parcelRequire("iuKXX");

var $6gTcj = parcelRequire("6gTcj");

var $lXOR9 = parcelRequire("lXOR9");
const $48436c32593a32c9$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $48436c32593a32c9$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    const isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
class $48436c32593a32c9$export$b65d046240060e78 {
    constructor(opts){
        this.observedMutations = new WeakMap();
        this.elementsInView = new Set();
        this.callbacks = new Set();
        this.totalTime = 0;
        this._startMeasureTimestamp = -1;
        this.ssr = {
            state: $48436c32593a32c9$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.selectorConfig = {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        };
        this.subscribeResults = (cb)=>{
            this.callbacks.add(cb);
        };
        this.observeElement = (node, mutation, type, ignoreReason, attributeName, oldValue = null, newValue = null)=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(node);
            this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        };
        // Selector-config resolution is centralised in `getSelectorConfig()`.
        // It enforces FedRAMP-override > caller-override > centrally
        // configured > caller default.
        const resolved = (0, $jFknK.getSelectorConfig)(opts.selectorConfig, this.selectorConfig);
        this.selectorConfig = resolved ?? {
            ...this.selectorConfig,
            ...opts.selectorConfig
        };
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $lXOR9.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    isBrowserSupported() {
        return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
    }
    observe() {
        var _this$mutationObserve;
        this.totalTime = 0;
        this.ssr = {
            state: $48436c32593a32c9$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeFilter: [
                'hidden',
                'style',
                'src',
                'class'
            ],
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
    }
    disconnect() {
        var _this$mutationObserve2, _this$intersectionObs;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.disconnect();
        this.observedMutations = new WeakMap();
        this.elementsInView.clear();
        this.callbacks.clear();
        this.ssr.reactRootElement = null;
        this.ssrPlaceholderHandler.clear();
    }
    getTotalTime() {
        return this.totalTime;
    }
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $48436c32593a32c9$var$state.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    getMutationObserver() {
        if (!this.isBrowserSupported()) return null;
        return new MutationObserver((mutations)=>{
            this.measureStart();
            mutations.forEach((mutation)=>{
                // patching element if timestamp not automatically added
                // eslint-disable-next-line no-param-reassign
                mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                let ignoreReason = '';
                if (this.ssr.state === $48436c32593a32c9$var$state.waitingForFirstRender && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    this.ssr.state = $48436c32593a32c9$var$state.ignoring;
                    if (this.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                    this.ssr.renderStop = mutation.timestamp + 500;
                    ignoreReason = 'ssr-hydration';
                }
                if (this.ssr.state === $48436c32593a32c9$var$state.ignoring && mutation.timestamp > this.ssr.renderStart && mutation.target === this.ssr.reactRootElement) {
                    if (mutation.timestamp <= this.ssr.renderStop) ignoreReason = 'ssr-hydration';
                    else this.ssr.state = $48436c32593a32c9$var$state.normal;
                }
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node)=>{
                        if ((0, $aeOqv.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                        if (node instanceof HTMLElement) {
                            if (this.ssrPlaceholderHandler.isPlaceholder(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            if (this.ssrPlaceholderHandler.isPlaceholderReplacement(node) || this.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                this.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then((result)=>{
                                    if (result === false) this.observeElement(node, mutation, 'html', ignoreReason);
                                });
                                return;
                            }
                            this.observeElement(node, mutation, 'html', ignoreReason);
                        }
                        if (node instanceof Text && node.parentElement != null) this.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                    });
                    mutation.removedNodes.forEach((node)=>{
                        if (node instanceof Element) {
                            var _this$intersectionObs3;
                            this.elementsInView.delete(node);
                            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.unobserve(node);
                        }
                    });
                } else if (mutation.type === 'attributes') {
                    if (mutation.target instanceof HTMLElement) {
                        const attributeName = mutation.attributeName;
                        /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ const oldValue = mutation.oldValue ?? undefined;
                        const newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                        if (oldValue !== newValue) {
                            if ((0, $iuKXX.default)(mutation)) ignoreReason = 'non-visual-style';
                            if ((0, $aeOqv.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                            this.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                        }
                    }
                }
            });
        });
    }
    getElementName(element) {
        try {
            const tagName = element.localName;
            const dataVCAttr = element.getAttribute('data-vc');
            const dataVC = this.selectorConfig.dataVC && dataVCAttr ? `[data-vc="${dataVCAttr}"]` : '';
            const id = this.selectorConfig.id && element.id ? `#${element.id}` : '';
            let testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
            testId = testId ? `[testid=${testId}]` : '';
            let role = this.selectorConfig.role ? element.getAttribute('role') : '';
            role = role ? `[role=${role}]` : '';
            let classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
            classList = classList === '' ? '' : `.${classList}`;
            const attrs = dataVC ? dataVC : [
                id,
                testId,
                role
            ].join('');
            let idString = '';
            if (attrs === '' && classList === '') {
                const parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                idString = `${parent} > ${tagName}`;
            } else idString = [
                tagName,
                attrs || classList
            ].join('');
            return idString;
        } catch  {
            return 'error';
        }
    }
    getIntersectionObserver() {
        if (!this.isBrowserSupported()) return null;
        return new IntersectionObserver((entries)=>{
            this.measureStart();
            entries.forEach(({ isIntersecting: isIntersecting, intersectionRect: ir, target: target })=>{
                const data = this.observedMutations.get(target);
                this.observedMutations.delete(target);
                if (isIntersecting && ir.width > 0 && ir.height > 0) {
                    if (!(target instanceof HTMLElement)) return;
                    if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                    return;
                    if (!$48436c32593a32c9$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                    if ((0, $6gTcj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = 'rll-placeholder';
                    this.callbacks.forEach((callback)=>{
                        let elementName;
                        try {
                            elementName = this.getElementName(target);
                        } catch  {
                            elementName = 'error';
                        }
                        callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                    });
                    this.elementsInView.add(target);
                } else this.elementsInView.delete(target);
            });
            this.measureStop();
        });
    }
    measureStart() {
        this._startMeasureTimestamp = performance.now();
    }
    measureStop() {
        if (this._startMeasureTimestamp === -1) return;
        this.totalTime += performance.now() - this._startMeasureTimestamp;
        this._startMeasureTimestamp = -1;
    }
}

});
parcelRegister("aeOqv", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinMediaWrapper", () => $12ed63a8c7abd9cb$export$f61fbc3b9c4a9019);

var $2iIlH = parcelRequire("2iIlH");
function $12ed63a8c7abd9cb$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $2iIlH.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("2iIlH", function(module, exports) {
$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", () => $6056f350ef2a04cd$export$7674290405cc25b0);
$parcel$export(module.exports, "VcMediaWrapperProps", () => $6056f350ef2a04cd$export$7028e9efe569888c);

var $4fqPo = parcelRequire("4fqPo");
const $6056f350ef2a04cd$export$7674290405cc25b0 = 'data-media-vc-wrapper';
const $6056f350ef2a04cd$export$7028e9efe569888c = {
    [$6056f350ef2a04cd$export$7674290405cc25b0]: true
};
function $6056f350ef2a04cd$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", $6056f350ef2a04cd$export$7028e9efe569888c, children);
}

});


parcelRegister("iuKXX", function(module, exports) {
$parcel$export(module.exports, "default", () => $54491bf390e03317$export$2e2bcd8739ae039);
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $54491bf390e03317$var$isNonVisualStyleMutation({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}
var $54491bf390e03317$export$2e2bcd8739ae039 = $54491bf390e03317$var$isNonVisualStyleMutation;

});

parcelRegister("6gTcj", function(module, exports) {
$parcel$export(module.exports, "RLLPlaceholderHandlers", () => $6f73eb6dcb9c08d5$export$166779fc0f49d4df);
const $6f73eb6dcb9c08d5$var$GLOBAL_RLL_HANDLERS_KEY = '__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__';
class $6f73eb6dcb9c08d5$export$166779fc0f49d4df {
    constructor(){
        this.placeholders = [];
        if (typeof window !== 'undefined' && typeof document !== 'undefined' && typeof window.document !== 'undefined') this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ static getInstance() {
        if (typeof globalThis !== 'undefined') {
            if (!globalThis[$6f73eb6dcb9c08d5$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$6f73eb6dcb9c08d5$var$GLOBAL_RLL_HANDLERS_KEY] = new $6f73eb6dcb9c08d5$export$166779fc0f49d4df();
            return globalThis[$6f73eb6dcb9c08d5$var$GLOBAL_RLL_HANDLERS_KEY];
        }
        // Fallback for environments without globalThis (should be rare)
        return new $6f73eb6dcb9c08d5$export$166779fc0f49d4df();
    }
    reset() {
        this.placeholders = [];
    }
    /**
   * Collects all React Loosely Lazy (RLL) placeholders from the DOM and caches their viewport intersecting rectangles.
   * RLL placeholders are marked with data-lazy-begin and data-lazy-end attributes on hidden input elements.
   * Performance optimized to batch getBoundingClientRect calls and minimize layout thrashing.
   * Only stores the intersecting portions of rectangles that are currently visible in the viewport.
   */ collectRLLPlaceholders() {
        if (typeof window === 'undefined' || typeof document === 'undefined' || typeof window.document === 'undefined') return;
        const beginElements = document.querySelectorAll('input[data-lazy-begin]');
        const beginCount = beginElements.length;
        if (beginCount === 0) return;
        // Performance optimization: pre-allocate array with estimated size
        const allElements = [];
        // Performance optimization: use traditional for loop instead of forEach
        for(let i = 0; i < beginCount; i++){
            const beginEl = beginElements[i];
            const id = beginEl.getAttribute('data-lazy-begin');
            if (!id) continue;
            const elements = this.refElements(beginEl, id);
            if (elements.length > 0) allElements.push(...elements);
        }
        // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
        const allElementsLength = allElements.length;
        if (allElementsLength > 0) {
            // Performance optimization: pre-allocate array with exact size
            const intersectingRects = [];
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            for(let i = 0; i < allElementsLength; i++){
                const rect = allElements[i].getBoundingClientRect();
                // Performance optimization: inline intersection calculation to avoid function call overhead
                const left = Math.max(rect.left, 0);
                const top = Math.max(rect.top, 0);
                const right = Math.min(rect.right, windowWidth);
                const bottom = Math.min(rect.bottom, windowHeight);
                // Check if there's a valid intersection with non-zero width and height
                if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
            }
            this.placeholders = intersectingRects;
        }
    }
    /**
   * Traverses DOM siblings to find all elements between RLL begin and end markers.
   * Based on the refElements pattern from react-loosely-lazy's platform/packages/async/react-loosely-lazy/src/collect/hydrate.ts
   * Performance optimized to minimize iterations and early exit conditions.
   *
   * @param fromEl - The input element with data-lazy-begin attribute
   * @param id - The placeholder ID to match against data-lazy-end
   * @returns Array of DOM elements between the begin/end markers
   */ refElements(fromEl, id) {
        const result = [];
        let el = fromEl.nextSibling;
        // Performance optimization: use while loop instead of recursive calls
        while(el){
            var _el$dataset;
            if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
            if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
            el = el.nextSibling;
        }
        return result;
    }
    /**
   * Returns the cached intersecting viewport rectangles for all RLL placeholder elements.
   * @returns Array of DOMRect objects representing the intersecting portions of placeholders within the viewport
   */ getPlaceholders() {
        return this.placeholders;
    }
    /**
   * Checks if the given intersecting rectangle matches any of the cached RLL placeholder intersecting rectangles.
   * This is designed to be called from IntersectionObserver with the intersectionRect.
   * Performance optimized with early exits and minimal calculations.
   * @param intersectingRect - The intersecting rectangle from IntersectionObserver
   * @returns true if the intersecting rectangle matches a cached placeholder rectangle and hasn't exceeded match limit, false otherwise
   */ isRLLPlaceholderHydration(intersectingRect) {
        const placeholdersLength = this.placeholders.length;
        if (placeholdersLength === 0) return false;
        // Performance optimization: cache array length and use traditional for loop
        for(let i = 0; i < placeholdersLength; i++){
            const placeholderRect = this.placeholders[i];
            if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
        }
        return false;
    }
    /**
   * Compares two DOMRect objects for equality with ±1 pixel tolerance.
   * Performance optimized to minimize calculations and early exit on major differences.
   * @param rect1 - First rectangle to compare
   * @param rect2 - Second rectangle to compare
   * @returns true if rectangles are within 1 pixel tolerance for all properties
   */ areRectsEqual(rect1, rect2) {
        // Early exit for exact matches (most common case)
        if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
        // Performance optimization: check largest differences first for early exit
        const leftDiff = rect1.left - rect2.left;
        if (leftDiff > 1 || leftDiff < -1) return false;
        const rightDiff = rect1.right - rect2.right;
        if (rightDiff > 1 || rightDiff < -1) return false;
        const topDiff = rect1.top - rect2.top;
        if (topDiff > 1 || topDiff < -1) return false;
        const bottomDiff = rect1.bottom - rect2.bottom;
        if (bottomDiff > 1 || bottomDiff < -1) return false;
        return true;
    }
}

});

parcelRegister("lXOR9", function(module, exports) {
$parcel$export(module.exports, "SSRPlaceholderHandlers", () => $8cec366ad7d96308$export$c0102f1a1198d10f);
const $8cec366ad7d96308$var$ANCESTOR_LOOKUP_LIMIT = 10;
const $8cec366ad7d96308$var$PAGE_LAYOUT_ID = 'page-layout.root';
class $8cec366ad7d96308$export$c0102f1a1198d10f {
    constructor({ enablePageLayoutPlaceholder: enablePageLayoutPlaceholder = false }){
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
        this.EQUALITY_THRESHOLD = 1;
        this.getPlaceholderId = (el)=>{
            var _el$dataset;
            const ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $8cec366ad7d96308$var$PAGE_LAYOUT_ID) return $8cec366ad7d96308$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.getPlaceholderReplacementId = (el)=>{
            var _el$dataset2;
            const ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $8cec366ad7d96308$var$PAGE_LAYOUT_ID) return $8cec366ad7d96308$var$PAGE_LAYOUT_ID;
            return '';
        };
        this.intersectionObserverCallback = ({ target: target, boundingClientRect: boundingClientRect })=>{
            var _this$intersectionObs5;
            (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            const staticKey = this.getPlaceholderId(target);
            if (staticKey) {
                if (this.staticPlaceholders.has(staticKey) && this.callbacks.has(staticKey)) {
                    // validation
                    const resolve = this.callbacks.get(staticKey);
                    if (!resolve) return;
                    const rect = this.staticPlaceholders.get(staticKey);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                    else requestAnimationFrame(()=>{
                        const targetRect = this.getEffectiveBoundingRect(target);
                        const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                        resolve(hasSameSizePosition);
                    });
                    this.callbacks.delete(staticKey);
                }
            } else {
                const key = this.getPlaceholderReplacementId(target);
                const resolve = this.reactValidateCallbacks.get(key);
                if (!resolve) return;
                const rect = this.staticPlaceholders.get(key);
                const hasSameSizePosition = this.hasSameSizePosition(rect, boundingClientRect);
                if (hasSameSizePosition || this.isDummyRect(rect)) resolve(hasSameSizePosition);
                else requestAnimationFrame(()=>{
                    const targetRect = this.getEffectiveBoundingRect(target);
                    const hasSameSizePosition = this.hasSameSizePosition(rect, targetRect);
                    resolve(hasSameSizePosition);
                });
                this.staticPlaceholders.delete(staticKey);
                this.reactValidateCallbacks.delete(staticKey);
            }
        };
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver((entries)=>entries.filter((entry)=>entry.intersectionRatio > 0).forEach(this.intersectionObserverCallback));
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch  {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    clear() {
        this.staticPlaceholders = new Map();
        this.callbacks = new Map();
        this.getSizeCallbacks = new Map();
        this.reactValidateCallbacks = new Map();
    }
    collectPlaceholdersInternal() {
        const selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : '[data-ssr-placeholder]';
        const existingElements = document.querySelectorAll(selector);
        existingElements.forEach((el)=>{
            const placeholderId = el instanceof HTMLElement && this.getPlaceholderId(el);
            if (placeholderId && !this.staticPlaceholders.has(placeholderId)) {
                var _window$__SSR_PLACEHO, _this$intersectionObs;
                let width = -1;
                let height = -1;
                let x = -1;
                let y = -1;
                // Use SSR dimensions from window global if available
                const boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                if (boundingClientRect) {
                    width = boundingClientRect.width;
                    height = boundingClientRect.height;
                    x = boundingClientRect.x;
                    y = boundingClientRect.y;
                } else {
                    // Fallback to current bounding rect if SSR dimensions not available
                    const rect = el.getBoundingClientRect();
                    width = rect.width;
                    height = rect.height;
                    x = rect.x;
                    y = rect.y;
                }
                this.staticPlaceholders.set(placeholderId, {
                    width: width,
                    height: height,
                    x: x,
                    y: y
                });
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(el);
            }
        });
    }
    /**
   * Added this method to be utilised for testing purposes.
   * In production it collection placeholder should only happens on constructor
   */ collectExistingPlaceholders() {
        if (!window.document) return;
        try {
            // Collect placeholders using SSR dimensions or fallback to live dimensions
            this.collectPlaceholdersInternal();
        } catch  {
        // Silently fail if there are any issues
        } finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    isPlaceholder(element) {
        return Boolean(this.getPlaceholderId(element));
    }
    isPlaceholderReplacement(element) {
        return Boolean(this.getPlaceholderReplacementId(element));
    }
    isPlaceholderIgnored(element) {
        // data-ssr-placeholder-ignored doesn't have a value.
        return 'ssrPlaceholderIgnored' in element.dataset;
    }
    isPlaceholderV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $8cec366ad7d96308$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    isPlaceholderReplacementV4(element) {
        let currentElement = element;
        let i = 0;
        while(currentElement && i < $8cec366ad7d96308$var$ANCESTOR_LOOKUP_LIMIT){
            if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
            currentElement = currentElement.parentElement;
            i++;
        }
        return false;
    }
    findNearestPlaceholderContainerIfIgnored(element) {
        if (!this.isPlaceholderIgnored(element)) return element;
        let ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < $8cec366ad7d96308$var$ANCESTOR_LOOKUP_LIMIT){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            ancestor = ancestor.parentElement;
            i++;
        }
        return element;
    }
    findNearestPlaceholderOrContainer(element, limit = $8cec366ad7d96308$var$ANCESTOR_LOOKUP_LIMIT) {
        let ancestor = element;
        if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
        let i = 0;
        while(ancestor && i < limit){
            if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
            if (ancestor.parentElement) {
                ancestor = ancestor.parentElement;
                i++;
            } else break;
        }
        return element;
    }
    // Validates placeholder match using asynchronous observation and resolves with the result
    checkIfExistedAndSizeMatching(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs2;
                this.callbacks.set(id, resolve);
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
            }
        });
    }
    // Validates placeholder match synchronously using stored SSR dimensions and current bounds
    checkIfExistedAndSizeMatchingV3(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderId(el);
        const placeholderRects = this.staticPlaceholders.get(id);
        if (!placeholderRects) return false;
        return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
    }
    getSize(el) {
        return new Promise((resolve)=>{
            var _this$intersectionObs3;
            this.getSizeCallbacks.set(this.getPlaceholderId(el), resolve);
            (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.observe(el);
        });
    }
    validateReactComponentMatchToPlaceholder(el) {
        el = this.findNearestPlaceholderContainerIfIgnored(el);
        const id = this.getPlaceholderReplacementId(el);
        return new Promise((resolve)=>{
            if (!this.staticPlaceholders.has(id)) {
                resolve(false);
                return;
            } else {
                var _this$intersectionObs4;
                this.reactValidateCallbacks.set(id, resolve);
                (_this$intersectionObs4 = this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.observe(el);
            }
        });
    }
    validateReactComponentMatchToPlaceholderV4(el) {
        el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
        const id = this.getPlaceholderReplacementId(el);
        return this.staticPlaceholders.has(id);
    }
    hasSameSizePosition(rect, boundingClientRect) {
        if (!rect) return false;
        const horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
        const verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
        return horizontalCheck && verticalCheck || false;
    }
    /**
   * Gets the effective bounding rectangle for an element, handling display: contents elements
   * by collecting dimensions from their children instead
   */ getEffectiveBoundingRect(el) {
        const computedStyle = window.getComputedStyle(el);
        // If element has display: contents, collect bounding rect from children
        if (computedStyle.display === 'contents') {
            const children = Array.from(el.children);
            if (children.length === 0) // No children, return zero rect
            return new DOMRect(0, 0, 0, 0);
            // Calculate union of all children's bounding rects
            let minX = Infinity;
            let minY = Infinity;
            let maxX = -Infinity;
            let maxY = -Infinity;
            children.forEach((child)=>{
                const childRect = child.getBoundingClientRect();
                // Skip children with zero dimensions (likely also display: contents)
                if (childRect.width > 0 || childRect.height > 0) {
                    minX = Math.min(minX, childRect.left);
                    minY = Math.min(minY, childRect.top);
                    maxX = Math.max(maxX, childRect.right);
                    maxY = Math.max(maxY, childRect.bottom);
                }
            });
            // If no children with dimensions found, return zero rect
            if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
            return new DOMRect(minX, minY, maxX - minX, maxY - minY);
        }
        // Normal element, return its bounding rect
        return el.getBoundingClientRect();
    }
    isDummyRect(rect) {
        return rect && rect.width < 0 && rect.height < 0 || false;
    }
}

});



parcelRegister("2C85b", function(module, exports) {
$parcel$export(module.exports, "getHasAbortingEventDuringSSR", () => $c2b74a542ec8c24e$export$88af4849fcc5bbc9);
$parcel$export(module.exports, "default", () => $c2b74a542ec8c24e$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $jFknK = parcelRequire("jFknK");

var $j58cX = parcelRequire("j58cX");

var $c62a8 = parcelRequire("c62a8");

var $lXOR9 = parcelRequire("lXOR9");

var $jEsas = parcelRequire("jEsas");

var $6en3q = parcelRequire("6en3q");

var $76wur = parcelRequire("76wur");

var $hqxyF = parcelRequire("hqxyF");

var $jC6Iz = parcelRequire("jC6Iz");

var $gbhDC = parcelRequire("gbhDC");

var $gJIpU = parcelRequire("gJIpU");

var $fpYEQ = parcelRequire("fpYEQ");

var $26bSW = parcelRequire("26bSW");

var $h0Opq = parcelRequire("h0Opq");
const $c2b74a542ec8c24e$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
const $c2b74a542ec8c24e$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
let $c2b74a542ec8c24e$var$hasAbortingEventDuringSSR = false;
function $c2b74a542ec8c24e$export$88af4849fcc5bbc9() {
    return $c2b74a542ec8c24e$var$hasAbortingEventDuringSSR;
}
class $c2b74a542ec8c24e$export$2e2bcd8739ae039 {
    constructor(config){
        this.viewportObserver = null;
        this.windowEventObserver = null;
        // SSR related properties
        this.ssrPlaceholderHandler = null;
        this.ssr = {
            state: $c2b74a542ec8c24e$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        };
        this.entriesTimeline = new (0, $jEsas.default)();
        this.isPostInteraction = config.isPostInteraction ?? false;
        // Selector-config resolution is centralised in `getSelectorConfig()`
        // (`../../config`). It applies the FedRAMP all-`false` override when
        // `isFedrampModerate()` is true; otherwise it returns `caller-override
        // → setUFOConfig value → historical default`.
        this.selectorConfig = (0, $jFknK.getSelectorConfig)(config.selectorConfig, $c2b74a542ec8c24e$var$DEFAULT_SELECTOR_CONFIG) ?? config.selectorConfig ?? $c2b74a542ec8c24e$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $lXOR9.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: ((_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) ?? false
            });
        }
        this.trackLayoutShiftOffenders = config.trackLayoutShiftOffenders ?? false;
        this.viewportObserver = new (0, $26bSW.default)({
            onChange: (onChangeArg)=>{
                const { time: time, type: type, elementRef: elementRef, visible: visible, rect: rect, previousRect: previousRect, mutationData: mutationData } = onChangeArg;
                let elementName = 'unknown';
                const element = elementRef.deref();
                if (element) elementName = this.getElementName(element);
                const data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    const labelStacks = $c2b74a542ec8c24e$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: ()=>this.getSSRState(),
            getSSRPlaceholderHandler: ()=>this.getSSRPlaceholderHandler(),
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $h0Opq.default)({
            onEvent: ({ time: time, type: type, event: event })=>{
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === 'keydown' && (0, $3H4LK.fg)('platform_ufo_keypress_interaction_abort')) {
                    const interaction = (0, $c62a8.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') return;
                }
                const abortEventTargetElement = $c2b74a542ec8c24e$var$isAbortEventTargetSupported(type) && event ? $c2b74a542ec8c24e$var$getAbortEventTargetElement(event.target) : null;
                const elementName = abortEventTargetElement ? this.getElementName(abortEventTargetElement) : undefined;
                this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: 'window:event',
                        eventType: type,
                        ...elementName ? {
                            elementName: elementName
                        } : {}
                    }
                });
            }
        });
    }
    start(_) {
        var _this$viewportObserve;
        // Reset SSR state on start (matches old VCObserver behavior)
        this.ssr = {
            state: $c2b74a542ec8c24e$var$SSRState.normal,
            reactRootElement: null,
            // Reset to null (matches old VCObserver)
            renderStart: -1,
            renderStop: -1
        };
        (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
        if ((0, $3H4LK.fg)('ufo_fix_aborting_interaction_detection_during_ssr')) {
            var _window, _this$windowEventObse;
            this.entriesTimeline.clear();
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') this.entriesTimeline.push({
                        time: time,
                        data: {
                            type: 'window:event',
                            eventType: key
                        }
                    });
                });
            }
            (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
        } else {
            var _window2, _this$windowEventObse2;
            if ((_window2 = window) !== null && _window2 !== void 0 && _window2.__SSR_ABORT_LISTENERS__) {
                const abortListeners = window.__SSR_ABORT_LISTENERS__;
                const aborts = abortListeners.aborts;
                if (aborts && typeof aborts === 'object') Object.entries(aborts).forEach(([key, time])=>{
                    if (typeof time === 'number') {
                        this.entriesTimeline.push({
                            time: time,
                            data: {
                                type: 'window:event',
                                eventType: key
                            }
                        });
                        if ((0, $3H4LK.fg)('ufo_detect_aborting_interaction_during_ssr')) $c2b74a542ec8c24e$var$hasAbortingEventDuringSSR = true;
                    }
                });
            }
            (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.start();
            this.entriesTimeline.clear();
        }
    }
    stop() {
        var _this$viewportObserve2, _this$windowEventObse3;
        (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
        (_this$windowEventObse3 = this.windowEventObserver) === null || _this$windowEventObse3 === void 0 || _this$windowEventObse3.stop();
        // Clear SSR state on stop (matches old VCObserver behavior)
        this.ssr.reactRootElement = null;
    }
    // SSR related methods
    setReactRootElement(element) {
        this.ssr.reactRootElement = element;
    }
    setReactRootRenderStart(startTime = performance.now()) {
        this.ssr.renderStart = startTime;
        this.ssr.state = $c2b74a542ec8c24e$var$SSRState.waitingForFirstRender;
    }
    setReactRootRenderStop(stopTime = performance.now()) {
        this.ssr.renderStop = stopTime;
    }
    collectSSRPlaceholders() {
    // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
    // Individual observers don't need to implement this
    }
    // Internal methods for ViewportObserver to access SSR state
    getSSRState() {
        return this.ssr;
    }
    getSSRPlaceholderHandler() {
        return this.ssrPlaceholderHandler;
    }
    addSSR(ssr) {
        this.entriesTimeline.push({
            time: ssr,
            data: {
                elementName: 'SSR',
                type: 'mutation:element',
                rect: {
                    height: (0, $jC6Iz.default)(),
                    width: (0, $gbhDC.default)(),
                    left: 0,
                    top: 0,
                    x: 0,
                    y: 0,
                    bottom: (0, $jC6Iz.default)(),
                    right: (0, $gbhDC.default)(),
                    toJSON () {
                        return null;
                    }
                },
                visible: true
            }
        });
    }
    async getVCResult(param) {
        const { start: start, stop: stop, interactionId: interactionId, interactionType: interactionType, interactionAbortReason: interactionAbortReason, isPageVisible: isPageVisible, include3p: include3p, includeSSRRatio: includeSSRRatio, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeRawData: includeRawData, rawDataStopTime: rawDataStopTime } = param;
        const results = [];
        this.addStartEntry(start);
        const feVCCalculationStartTime = performance.now();
        const calculator_fy25_03 = new (0, $76wur.default)();
        if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
        const orderedEntries = this.entriesTimeline.getOrderedEntries({
            start: start,
            stop: stop
        });
        const fy25_03 = (0, $jFknK.isVCRevisionEnabled)('fy25.03') ? await calculator_fy25_03.calculate({
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        }) : null;
        if (fy25_03) results.push(fy25_03);
        // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
        if (param.ssr) this.addSSR(param.ssr);
        const calculator_fy26_04 = new (0, $hqxyF.default)();
        const calculator_next = new (0, $gJIpU.default)();
        const calculatorParams = {
            orderedEntries: orderedEntries,
            startTime: start,
            stopTime: stop,
            interactionId: interactionId,
            interactionType: interactionType,
            isPostInteraction: this.isPostInteraction,
            include3p: include3p,
            excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
            includeSSRRatio: includeSSRRatio,
            isPageVisible: isPageVisible,
            interactionAbortReason: interactionAbortReason,
            reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
        };
        const isFy2604Enabled = (0, $jFknK.isVCRevisionEnabled)('fy26.04');
        const [fy26_04, vcNext] = await Promise.all([
            isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
            (0, $jFknK.isVCRevisionEnabled)('next') ? calculator_next.calculate(calculatorParams) : null
        ]);
        if (fy26_04) results.push(fy26_04);
        if (vcNext) results.push(vcNext);
        const feVCCalculationEndTime = performance.now();
        // Always include raw data when fy26.04 is not in the client config so the server
        // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
        const shouldIncludeRawData = includeRawData || !isFy2604Enabled || (0, $3H4LK.fg)('platform_ufo_always_emit_raw_handler');
        if (shouldIncludeRawData) {
            const rawVCCalculationStartTime = performance.now();
            const rawHandler = new (0, $fpYEQ.default)();
            // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
            const rawStopTime = rawDataStopTime ?? stop;
            const rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                start: start,
                stop: rawStopTime
            }) : orderedEntries;
            const raw = await rawHandler.getRawData({
                entries: rawOrderedEntries,
                startTime: start,
                stopTime: rawStopTime,
                isPageVisible: isPageVisible
            });
            results.forEach((result)=>{
                delete result.vcDetails;
                delete result.ratios;
            });
            if (raw) {
                raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                results.push(raw);
            }
        }
        return results;
    }
    addStartEntry(startTime) {
        this.entriesTimeline.push({
            time: startTime,
            data: {
                type: 'mutation:element',
                elementName: 'START',
                visible: true,
                rect: {
                    x: 0,
                    y: 0,
                    width: window.innerWidth,
                    height: window.innerHeight,
                    top: 0,
                    left: 0,
                    bottom: window.innerHeight,
                    right: window.innerWidth,
                    toJSON: function() {
                        return {
                            x: this.x,
                            y: this.y,
                            width: this.width,
                            height: this.height,
                            top: this.top,
                            left: this.left,
                            bottom: this.bottom,
                            right: this.right
                        };
                    }
                }
            }
        });
    }
    getElementName(element) {
        return (0, $6en3q.default)(this.selectorConfig, element);
    }
}
function $c2b74a542ec8c24e$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    const value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $c2b74a542ec8c24e$var$labelStackToString(labelStack) {
    return labelStack.map((label)=>(0, $j58cX.sanitizeLabelStackName)(label.name)).join('/');
}
function $c2b74a542ec8c24e$var$labelStackToSegment(labelStack) {
    let segmentIndex = -1;
    for(let i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map((label)=>(0, $j58cX.sanitizeLabelStackName)(label.name)).join('/');
}
function $c2b74a542ec8c24e$var$traverseFiber(fiber) {
    let segment = 'unknown';
    let labelStackString = 'unknown';
    let currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            const componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === 'UFOSegment' || componentName === 'UFOLabel') {
                const labelStack = $c2b74a542ec8c24e$var$labelStackFromFiber(currentFiber);
                labelStackString = $c2b74a542ec8c24e$var$labelStackToString(labelStack) || 'unknown';
                segment = $c2b74a542ec8c24e$var$labelStackToSegment(labelStack) || 'unknown';
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $c2b74a542ec8c24e$var$getLabelStacks(element) {
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (!reactFiberKey) return null;
    const fiber = element[reactFiberKey];
    return fiber ? $c2b74a542ec8c24e$var$traverseFiber(fiber) : null;
}
const $c2b74a542ec8c24e$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES = new Set([
    'scroll-container',
    'scroll',
    'wheel'
]);
function $c2b74a542ec8c24e$var$isAbortEventTargetSupported(type) {
    return $c2b74a542ec8c24e$var$SUPPORTED_ABORT_EVENT_TARGET_TYPES.has(type);
}
function $c2b74a542ec8c24e$var$getAbortEventTargetElement(target) {
    if (target instanceof HTMLElement) return target;
    if (target instanceof Document) {
        const scrollingElement = target.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.documentElement ?? null;
    }
    if (target instanceof Window) {
        const scrollingElement = target.document.scrollingElement;
        if (scrollingElement instanceof HTMLElement) return scrollingElement;
        return target.document.documentElement ?? null;
    }
    if (target instanceof Node) return target.parentElement;
    return null;
}

});
parcelRegister("jEsas", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f773b9b8b559606$export$2e2bcd8739ae039);
class $9f773b9b8b559606$export$2e2bcd8739ae039 {
    constructor(){
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    push(entry) {
        this.unorderedEntries.push(entry);
        this.sortedEntriesCache.clear();
    }
    getCacheKey(start, stop) {
        return `${start ?? 'null'}_${stop ?? 'null'}`;
    }
    getOrderedEntries({ start: start, stop: stop }) {
        var _this$sortedEntriesCa;
        const cacheKey = this.getCacheKey(start, stop);
        const cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
        if (cachedSortedEntries) return cachedSortedEntries;
        const filteredEntries = this.unorderedEntries.filter((e)=>e.time >= (start ?? 0) && e.time <= (stop ?? performance.now()));
        const sortedEntries = filteredEntries.sort((a, b)=>a.time - b.time);
        this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
        return sortedEntries;
    }
    clear() {
        this.unorderedEntries = [];
        this.sortedEntriesCache.clear();
    }
}

});

parcelRegister("6en3q", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4065cce887102f2$export$2e2bcd8739ae039);
const $f4065cce887102f2$var$nameCache = new WeakMap();
function $f4065cce887102f2$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        let elementInstance = 'Unknown';
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = 'Text';
        else if (element instanceof DocumentFragment) elementInstance = 'DocumentFragment';
        else if (element instanceof Document) elementInstance = 'Document';
        else if (element instanceof Comment) elementInstance = 'Comment';
        else if (element instanceof ProcessingInstruction) elementInstance = 'ProcessingInstruction';
        else if (element instanceof Attr) elementInstance = 'Attr';
        else if (element instanceof CDATASection) elementInstance = 'CDATASection';
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            const parentElementSelector = $f4065cce887102f2$var$getElementName(selectorConfig, element.parentElement);
            return `${parentElementSelector} > ${elementInstance}`;
        } else return elementInstance;
    }
    const cachedName = $f4065cce887102f2$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    const tagName = element.localName;
    const encodeValue = (s)=>{
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch  {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    const getAttributeSelector = (attributeName, prefix = '')=>{
        if (element && typeof element.getAttribute !== 'function') return '';
        const attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        const encondedAttrValue = encodeValue(attrValue);
        return `${prefix}[${attributeName}="${encondedAttrValue}"]`;
    };
    // Construct the data-vc attribute selector if specified in the config.
    const dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    const id = selectorConfig.id && element.id ? `#${encodeValue(element.id)}` : '';
    // Construct the test ID selector if specified in the config.
    const testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    const role = selectorConfig.role ? getAttributeSelector('role') : '';
    const classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    const classList = selectorConfig.className && classNames ? `.${classNames}` : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    const primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    const attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        const parentName = element.parentElement ? $f4065cce887102f2$var$getElementName(selectorConfig, element.parentElement) : 'unknown';
        return `${parentName} > ${tagName}`;
    }
    // Return the final constructed name: tagName + attributes or classList.
    const name = `${tagName}${attributes || classList}`;
    $f4065cce887102f2$var$nameCache.set(element, name);
    return name;
}
var $f4065cce887102f2$export$2e2bcd8739ae039 = $f4065cce887102f2$var$getElementName;

});

parcelRegister("76wur", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e4ba6dcc805c0bf$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $8UPEN = parcelRequire("8UPEN");

var $gJOko = parcelRequire("gJOko");

var $6Eqsa = parcelRequire("6Eqsa");

var $51hFz = parcelRequire("51hFz");

var $kXxl4 = parcelRequire("kXxl4");
const $8e4ba6dcc805c0bf$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $8e4ba6dcc805c0bf$var$REVISION_NO = 'fy25.03';
const $8e4ba6dcc805c0bf$var$getConsideredEntryTypes = (include3p, excludeSmartAnswersInSearch)=>{
    const entryTypes = [
        'mutation:child-element',
        'mutation:element',
        'mutation:attribute',
        'layout-shift',
        'layout-shift:same-rect',
        'window:event'
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push('mutation:third-party-element');
        entryTypes.push('mutation:third-party-attribute');
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push('mutation:smart-answers-element');
        entryTypes.push('mutation:smart-answers-attribute');
    }
    entryTypes.push('mutation:media');
    // Still included as part of TTVC v3
    entryTypes.push('mutation:attribute:non-visual-input-name');
    return entryTypes;
};
class $8e4ba6dcc805c0bf$export$2e2bcd8739ae039 extends (0, $6Eqsa.default) {
    constructor(revisionNo){
        super(revisionNo ?? $8e4ba6dcc805c0bf$var$REVISION_NO);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        if (!$8e4ba6dcc805c0bf$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
        if (entry.data.type === 'mutation:attribute:framework-routing') return false;
        if (entry.data.type === 'mutation:media' && (0, $3H4LK.fg)('media-perf-uplift-mutation-fix')) {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === 'data-cursor' || attributeName === 'alt' || (attributeName === 'localid' || attributeName === 'contenteditable' || attributeName === 'anchor-name') && (0, $8UPEN.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false))) return false;
            // special case for style attribute to ignore only anchor-name changes
            if ((0, $8UPEN.expVal)('platform_editor_media_vc_fixes', 'isEnabled', false)) {
                if ((0, $gJOko.containsDnDMutationInStyle)({
                    attributeName: entryData.attributeName,
                    oldValue: entryData.oldValue,
                    newValue: entryData.newValue
                })) return false;
            }
        }
        if (entry.data.type === 'mutation:attribute') {
            const entryData = entry.data;
            const attributeName = entryData.attributeName;
            if (!attributeName || (0, $51hFz.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName)) return false;
            if (attributeName.startsWith('data-test') || (0, $51hFz.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || (0, $51hFz.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $3H4LK.fg)('platform_ufo_exclude_3p_extensions_from_ttvc') || (0, $51hFz.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $3H4LK.fg)('platform_ufo_exclude_dark_reader_extension') || (0, $51hFz.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(attributeName) && (0, $3H4LK.fg)('platform_ufo_exclude_fdprocessedid_attribute')) return false;
            return true;
        }
        if ((0, $kXxl4.default)(entry.data) && !entry.data.visible) return false;
        return true;
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($8e4ba6dcc805c0bf$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});
parcelRegister("8UPEN", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $f0f8a0055ca13c90$export$9db1624a8af791a4);

var $6bGmX = parcelRequire("6bGmX");

var $lLCH0 = parcelRequire("lLCH0");
const $f0f8a0055ca13c90$export$9db1624a8af791a4 = (experimentName, experimentParam, defaultValue)=>{
    // If client is not initialized, we return the default value
    if (!(0, $6bGmX.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $6bGmX.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $lLCH0.addFeatureFlagAccessed)(`${experimentName}:${experimentParam}`, experimentValue);
    return experimentValue;
};

});

parcelRegister("gJOko", function(module, exports) {
$parcel$export(module.exports, "containsDnDMutationInStyle", () => $9bc71d43cbfc72c4$export$7867ddcf372cd2bf);
$parcel$export(module.exports, "default", () => $9bc71d43cbfc72c4$export$2e2bcd8739ae039);
const $9bc71d43cbfc72c4$var$isDnDStyleChange = (style)=>{
    return style.startsWith('anchor-name: --node-anchor');
};
const $9bc71d43cbfc72c4$var$parseStyleSet = (style)=>{
    if (!style) return null;
    const set = new Set();
    for (const part of style.split(';')){
        const t = part.trim();
        if (t) set.add(t);
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $9bc71d43cbfc72c4$export$e20e7bf2c822f3df({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (!(target instanceof Element)) return false;
    return $9bc71d43cbfc72c4$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $9bc71d43cbfc72c4$export$7867ddcf372cd2bf({ attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    if (attributeName !== 'style') return false;
    const oldStyles = $9bc71d43cbfc72c4$var$parseStyleSet(oldValue);
    const newStyles = $9bc71d43cbfc72c4$var$parseStyleSet(newValue);
    let isDnDMutation = false;
    for (const s of oldStyles ?? [])if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
        if (!$9bc71d43cbfc72c4$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    for (const s of newStyles ?? [])if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(s))) {
        if (!$9bc71d43cbfc72c4$var$isDnDStyleChange(s)) return false;
        isDnDMutation = true;
    }
    return isDnDMutation;
}
var $9bc71d43cbfc72c4$export$2e2bcd8739ae039 = $9bc71d43cbfc72c4$export$e20e7bf2c822f3df;

});

parcelRegister("6Eqsa", function(module, exports) {
$parcel$export(module.exports, "default", () => $59ccbd5e3062e6c7$export$2e2bcd8739ae039);

var $1hsv0 = parcelRequire("1hsv0");

var $2qVO5 = parcelRequire("2qVO5");

var $jC6Iz = parcelRequire("jC6Iz");

var $gbhDC = parcelRequire("gbhDC");

var $kXxl4 = parcelRequire("kXxl4");
// Helper function for reporting ratios
function $59ccbd5e3062e6c7$var$roundDecimal(value, decimals = 3) {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
class $59ccbd5e3062e6c7$export$2e2bcd8739ae039 {
    constructor(revisionNo){
        this.revisionNo = revisionNo;
    }
    filterViewportEntries(entries) {
        return entries.filter((entry)=>{
            return 'rect' in entry.data;
        });
    }
    /**
   * Calculate ratios for each element based on their viewport coverage.
   */ calculateRatios(filteredEntries) {
        const ratios = {};
        const viewportWidth = (0, $gbhDC.default)();
        const viewportHeight = (0, $jC6Iz.default)();
        const totalViewportArea = viewportWidth * viewportHeight;
        if (totalViewportArea === 0) return ratios;
        const elementRects = new Map();
        for (const entry of filteredEntries)if ('rect' in entry.data) {
            const viewportEntry = entry.data;
            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
        }
        for (const [elementName, rect] of elementRects){
            const elementArea = rect.width * rect.height;
            ratios[elementName] = $59ccbd5e3062e6c7$var$roundDecimal(elementArea / totalViewportArea);
        }
        return ratios;
    }
    getLabelStacks(filteredEntries, isPostInteraction) {
        const labelStacks = {};
        for (const entry of filteredEntries)if ((0, $kXxl4.default)(entry.data) && entry.data.labelStacks) {
            if (isPostInteraction) labelStacks[entry.data.elementName] = {
                segment: entry.data.labelStacks.segment,
                labelStack: entry.data.labelStacks.labelStack
            };
            else labelStacks[entry.data.elementName] = entry.data.labelStacks.labelStack;
        }
        return labelStacks;
    }
    async calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
        var _window, _window2, _window3, _window4, _window6;
        const percentiles = [
            25,
            50,
            75,
            80,
            85,
            90,
            95,
            98,
            99,
            100
        ];
        const viewportEntries = this.filterViewportEntries(filteredEntries);
        const { entries: vcLogs, speedIndex: speedIndex } = await (0, $1hsv0.calculateTTVCPercentilesWithDebugInfo)({
            viewport: {
                width: (0, $gbhDC.default)(),
                height: (0, $jC6Iz.default)()
            },
            startTime: startTime,
            stopTime: stopTime,
            orderedEntries: viewportEntries
        });
        const vcDetails = {};
        let percentileIndex = 0;
        const entryDataBuffer = new Set();
        let ssrRatio = -1;
        let layoutShiftInsights = null;
        let previousViewportPercentage = 0;
        if (vcLogs) for (const entry of vcLogs){
            const { time: time, viewportPercentage: viewportPercentage, entries: entries } = entry;
            if (includeSSRRatio && ssrRatio === -1 && entries.some((e)=>e.elementName === 'SSR')) ssrRatio = viewportPercentage;
            // Only process entries if we haven't reached all percentiles
            if (percentileIndex >= percentiles.length) break;
            // Check if this entry matches any checkpoint percentiles
            if (viewportPercentage >= percentiles[percentileIndex]) {
                const elementNames = [
                    ...new Set(entries.map((e)=>e.elementName))
                ];
                // Process all matching percentiles in one go
                while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                    vcDetails[`${percentiles[percentileIndex]}`] = {
                        t: Math.round(time),
                        e: elementNames
                    };
                    if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some((e)=>e.type === 'layout-shift')) {
                        const layoutShiftEntries = entries.filter((e)=>e.type === 'layout-shift');
                        layoutShiftInsights = {
                            layoutShiftOffendersResult: (0, $2qVO5.detectLayoutShiftCause)({
                                viewportEntries: viewportEntries,
                                layoutShiftEntries: layoutShiftEntries,
                                time: time,
                                startTime: startTime
                            }),
                            layoutShiftEntriesCount: layoutShiftEntries.length,
                            layoutShiftImpact: viewportPercentage - previousViewportPercentage
                        };
                    }
                    percentileIndex++;
                }
                // Clear buffer after processing all matching percentiles
                entryDataBuffer.clear();
            } else // Only add to buffer if we haven't reached all percentiles
            entries.forEach((e)=>entryDataBuffer.add(e));
            previousViewportPercentage = viewportPercentage;
        }
        // Fill in any missing percentiles with the last known values
        let previousResult = {
            t: 0,
            e: []
        };
        for(let i = 0; i < percentiles.length; i++){
            const percentile = percentiles[i];
            if (!(percentile in vcDetails)) vcDetails[`${percentile}`] = previousResult;
            else previousResult = vcDetails[`${percentile}`];
        }
        let enhancedVcLogs = vcLogs ? vcLogs.map((log)=>({
                ...log,
                entries: log.entries.map((entry)=>{
                    var _entry$rect, _entry$previousRect;
                    return {
                        ...entry,
                        rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                        previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                    };
                }),
                viewportPercentage: log.viewportPercentage
            })) : [];
        // If 3p metric enabled - calculate the debug details
        const shouldCalculate3p = include3p;
        // Only calculate enhanced debug details if devtool callbacks exist
        const shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === 'function' || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === 'function' || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === 'function');
        if (shouldCalculateDebugDetails && allEntries && vcLogs) {
            // Pre-sort vcLogs by time for efficient lookups
            const sortedVcLogs = [
                ...vcLogs
            ].sort((a, b)=>a.time - b.time);
            // Pre-calculate max viewport percentage up to each time for efficient lookups
            const maxViewportPercentageAtTime = new Map();
            let maxSoFar = 0;
            for (const log of sortedVcLogs)if (log.viewportPercentage !== null) {
                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                maxViewportPercentageAtTime.set(log.time, maxSoFar);
            }
            // Helper function to find the biggest previous viewport percentage
            const getBiggestPreviousViewportPercentage = (targetTime)=>{
                // Binary search for the largest time <= targetTime
                let left = 0;
                let right = sortedVcLogs.length - 1;
                let result = -1;
                while(left <= right){
                    const mid = Math.floor((left + right) / 2);
                    if (sortedVcLogs[mid].time <= targetTime) {
                        result = mid;
                        left = mid + 1;
                    } else right = mid - 1;
                }
                return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
            };
            // Group ignored entries by timestamp
            const ignoredEntriesByTime = new Map();
            for (const entry of allEntries)if ('rect' in entry.data && !this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch)) {
                var _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou;
                const viewportData = entry.data;
                const timestamp = Math.round(entry.time);
                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push({
                    ...viewportData,
                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                    ignoreReason: viewportData.visible ? viewportData.type : 'not-visible'
                });
            }
            // Add ignored entries to vcLogs
            const additionalVcLogs = [];
            for (const [timestamp, ignoredEntries] of ignoredEntriesByTime)if (ignoredEntries.length > 0) {
                const viewportPercentage = getBiggestPreviousViewportPercentage(timestamp);
                additionalVcLogs.push({
                    time: timestamp,
                    viewportPercentage: viewportPercentage,
                    entries: ignoredEntries
                });
            }
            // Combine and sort all vcLogs
            enhancedVcLogs = [
                ...enhancedVcLogs,
                ...additionalVcLogs
            ].sort((a, b)=>a.time - b.time);
        }
        // Only create debug details if callbacks exist
        let v3RevisionDebugDetails = null;
        if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
            revision: this.revisionNo,
            isClean: isVCClean && !interactionAbortReason && isPageVisible,
            abortReason: !isPageVisible ? 'browser_backgrounded' : dirtyReason ?? interactionAbortReason,
            vcLogs: enhancedVcLogs,
            interactionId: interactionId,
            interactionType: interactionType
        };
        // Handle devtool callback
        if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === 'function' && !include3p) try {
            var _window5, _window5$__ufo_devtoo;
            (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
        } catch (e) {
            // if any error communicating with devtool, we don't want to break the app
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === 'function' && !include3p) try {
            var _window7, _window7$__on_ufo_vc_;
            (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in onVCRevisionReady', e);
        }
        if (v3RevisionDebugDetails && shouldCalculate3p) try {
            // Log vc details with 3p for debugging
            window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error in 3pDebugData', e);
        }
        return {
            vcDetails: vcDetails,
            ssrRatio: ssrRatio,
            speedIndex: speedIndex,
            VC90layoutShiftInsights: layoutShiftInsights
        };
    }
    async calculate({ startTime: startTime, stopTime: stopTime, orderedEntries: orderedEntries, interactionId: interactionId, isPostInteraction: isPostInteraction, include3p: include3p, excludeSmartAnswersInSearch: excludeSmartAnswersInSearch, includeSSRRatio: includeSSRRatio, interactionType: interactionType, isPageVisible: isPageVisible, interactionAbortReason: interactionAbortReason, reportLayoutShiftOffenders: reportLayoutShiftOffenders }) {
        var _vcDetails$;
        const filteredEntries = orderedEntries.filter((entry)=>{
            return this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        });
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isVCClean) return {
            revision: this.revisionNo,
            'metric:vc90': null,
            clean: false,
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp
        };
        const { vcDetails: vcDetails, ssrRatio: ssrRatio, speedIndex: speedIndex, VC90layoutShiftInsights: VC90layoutShiftInsights } = await this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
        let layoutShiftInsightsPayload;
        if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
            const { layoutShiftOffendersResult: layoutShiftOffendersResult, layoutShiftEntriesCount: layoutShiftEntriesCount, layoutShiftImpact: layoutShiftImpact } = VC90layoutShiftInsights;
            layoutShiftInsightsPayload = {
                impact: layoutShiftImpact,
                sources: layoutShiftEntriesCount ?? 0,
                same: {
                    dir: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) ?? false,
                    dist: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) ?? false
                },
                total_mut: (layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) ?? 0,
                mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort((a, b)=>Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS)).slice(0, 5).map((offender)=>({
                        e: offender.offender,
                        size: -1,
                        // @todo: calculate size
                        attr: {
                            t_before: offender.happenedBefore,
                            t_distance: offender.distanceToLS,
                            p_above: offender.isAbove,
                            p_left: offender.isLeft,
                            p_right: offender.isRight,
                            p_h_overlap: offender.hasHorizontalOverlap,
                            p_v_overlap: offender.hasVerticalOverlap,
                            p_same_offset: offender.matchesLayoutShiftDelta ? 'all' : 'none'
                        }
                    }))
            };
        }
        const result = {
            revision: this.revisionNo,
            clean: true,
            'metric:vc90': (vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) ?? null,
            vcDetails: vcDetails ?? undefined,
            'vc90:ls': layoutShiftInsightsPayload ?? undefined
        };
        result.ratios = this.calculateRatios(filteredEntries);
        if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
        // speedIndex is only included in the result when it has a meaningful value (> 0)
        if (speedIndex > 0) result.speedIndex = speedIndex;
        result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
        return result;
    }
}

});
parcelRegister("1hsv0", function(module, exports) {
$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", () => $a0f6b015f9272a88$export$96ea73435089b05a);

var $3H4LK = parcelRequire("3H4LK");

var $dVXPS = parcelRequire("dVXPS");
async function $a0f6b015f9272a88$var$calculateTTVCPercentiles({ viewport: viewport, orderedEntries: orderedEntries, percentiles: percentiles, startTime: startTime }) {
    const canvas = new (0, $dVXPS.ViewportCanvas)(viewport, (0, $3H4LK.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        const elementName = entry.data.elementName;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
        elementMap.get(entry.time).add(elementName);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimenstions = canvas.getScaledDimensions();
    const totalPixels = canvasDimenstions.width * canvasDimenstions.height;
    return $a0f6b015f9272a88$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime);
}
async function $a0f6b015f9272a88$export$96ea73435089b05a({ viewport: viewport, orderedEntries: orderedEntries, startTime: startTime }) {
    const canvas = new (0, $dVXPS.ViewportCanvas)(viewport, (0, $3H4LK.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
    const elementMap = new Map();
    for (const entry of orderedEntries){
        if (!('rect' in entry.data)) continue;
        const rect = entry.data.rect;
        canvas.drawRect(rect, entry.time);
        if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
        elementMap.get(entry.time).push(entry.data);
    }
    // Get pixel counts
    const timePixelCounts = await canvas.getPixelCounts();
    const canvasDimensions = canvas.getScaledDimensions();
    const totalPixels = canvasDimensions.width * canvasDimensions.height;
    return $a0f6b015f9272a88$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime);
}
var $a0f6b015f9272a88$export$2e2bcd8739ae039 = $a0f6b015f9272a88$var$calculateTTVCPercentiles;
function $a0f6b015f9272a88$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    const results = {};
    let cumulativePixels = 0;
    const percentiles = unorderedPercentiles.sort((a, b)=>a - b);
    // Sort entries by timestamp for consistent processing
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    let percentileIndex = 0;
    let domElementsBuffer = new Set();
    for (const [time, pixelCount] of sortedEntries){
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const elementNames = elementMap.get(time) || new Set();
        elementNames.forEach((elName)=>domElementsBuffer.add(elName));
        let matchesAnyCheckpoints = false;
        while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
            results[`${percentiles[percentileIndex]}`] = {
                t: Math.round(Number(time - startTime)),
                e: Array.from(domElementsBuffer)
            };
            percentileIndex++;
            matchesAnyCheckpoints = true;
        }
        if (matchesAnyCheckpoints) domElementsBuffer.clear();
        if (percentileIndex >= percentiles.length) break;
    }
    let previousResult = {
        t: 0,
        e: []
    };
    for(let i = 0; i < percentiles.length; i++){
        const percentile = percentiles[i];
        if (!(percentile in results)) results[`${percentile}`] = previousResult;
        previousResult = results[`${percentile}`];
    }
    return results;
}
function $a0f6b015f9272a88$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    const entries = new Array(elementMap.size);
    let cumulativePixels = 0;
    let speedIndex = 0;
    let previousPercentCovered = 0;
    const sortedEntries = Array.from(timePixelCounts.entries()).sort(([timeA], [timeB])=>Number(timeA) - Number(timeB));
    for(let i = 0; i < sortedEntries.length; i++){
        const [time, pixelCount] = sortedEntries[i];
        cumulativePixels += pixelCount;
        const percentCovered = cumulativePixels / totalPixels * 100;
        const entryDatas = elementMap.get(time) || [];
        const relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        const ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});
parcelRegister("dVXPS", function(module, exports) {
$parcel$export(module.exports, "ViewportCanvas", () => $333996b6d8d49fc4$export$3e59ac9de7402fb1);

var $S8YJG = parcelRequire("S8YJG");
class $333996b6d8d49fc4$export$3e59ac9de7402fb1 {
    /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ constructor(viewport, scaleFactor = 1){
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        const safeViewportWidth = Math.max(viewport.width, 1);
        const safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        const ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ createCanvas(width, height) {
        if (typeof OffscreenCanvas !== 'undefined') return new OffscreenCanvas(width, height);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    getScaledDimensions() {
        return {
            width: this.scaledWidth,
            height: this.scaledHeight
        };
    }
    /**
   * Clears the entire canvas by removing all drawn content.
   * @private
   */ clear() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    /**
   * Generates a unique RGB color from an incrementing counter.
   * Uses a 24-bit color space (16,777,216 possible colors).
   *
   * @private
   * @returns A unique RGB color string
   *
   * @example
   * // Example bit operations for color 0x00FF8040:
   * // Red:   (0x00FF8040 >> 16) & 0xFF = 0xFF = 255
   * // Green: (0x00FF8040 >> 8) & 0xFF  = 0x80 = 128
   * // Blue:   0x00FF8040 & 0xFF        = 0x40 = 64
   */ generateColor() {
        // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
        const rgbColor = this.colorCounter++ % 0x00ffffff;
        return $333996b6d8d49fc4$export$54591583ed0b20ce(rgbColor);
    }
    /**
   * Draws a rectangle on the canvas with a unique color and associates it with a timestamp.
   * Each drawn rectangle gets a unique color which is mapped to the provided timestamp.
   *
   * @param rect - The rectangle dimensions to draw
   * @param timestamp - The timestamp to associate with this drawing operation
   */ drawRect(rect, timestamp) {
        const color = this.generateColor();
        this.colorTimeMap.set(color, timestamp);
        this.ctx.fillStyle = color;
        if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
        const scaledX = rect.x * this.scaleX;
        const scaledY = rect.y * this.scaleY;
        const scaledWidth = rect.width * this.scaleX;
        const scaledHeight = rect.height * this.scaleY;
        this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
    }
    /**
   * Calculates the number of pixels drawn for each timestamp.
   * This method:
   * 1. Reads the pixel data from the canvas
   * 2. Counts pixels of each unique color
   * 3. Maps colors back to their timestamps
   * 4. Adjusts counts based on the scale factor
   *
   * @returns A Map containing timestamp to pixel count mappings
   */ async getPixelCounts() {
        const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
        const timestampsAmount = this.colorTimeMap.size;
        const pixelCounts = await $333996b6d8d49fc4$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
        // Convert color counts to timestamp counts
        const timePixelCounts = new Map();
        for(let i = 0; i < pixelCounts.length; i++){
            const count = pixelCounts[i];
            if (typeof count !== 'number') continue;
            const color = i + 1;
            const rgbColor = $333996b6d8d49fc4$export$54591583ed0b20ce(color);
            const timestamp = this.colorTimeMap.get(rgbColor);
            if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
        }
        return timePixelCounts;
    }
}
function $333996b6d8d49fc4$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    const blue = n & 0xff;
    // Extract green component (bits 8-15)
    const green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    const red = n >> 16 & 0xff;
    return `rgb(${red}, ${green}, ${blue})`;
}
async function $333996b6d8d49fc4$export$fafc9be44839f9c8(imageData, _, arraySize) {
    const data = imageData.data;
    const arr = new Uint32Array(arraySize);
    for(let i = 0; i < data.length; i += 4){
        // Check alpha
        if (data[i + 3] !== 0) {
            // Combine RGB components into a single 24-bit color value:
            // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
            // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
            // data[i + 2]       - Blue component stays as is         (bits 0-7)
            // The | operator combines all bits together
            const color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
            const colorIndex = color - 1;
            arr[colorIndex] = (arr[colorIndex] || 0) + 1;
        }
        if (i % 10000 === 0) await (0, $S8YJG.default)();
    }
    return arr;
}

});
parcelRegister("S8YJG", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c26dc1e6a7ffb9$export$2e2bcd8739ae039);
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
async function $23c26dc1e6a7ffb9$var$taskYield() {
    // This is using globalThis to allow the yield task to be used outside of a browser env
    if ('scheduler' in globalThis && // @ts-ignore
    'yield' in globalThis.scheduler) {
        // @ts-ignore
        await scheduler.yield();
        return;
    }
    let resolve = ()=>{};
    const p = new Promise((a)=>{
        resolve = a;
    });
    setTimeout(resolve, 0);
    await p;
}
var $23c26dc1e6a7ffb9$export$2e2bcd8739ae039 = $23c26dc1e6a7ffb9$var$taskYield;

});



parcelRegister("2qVO5", function(module, exports) {
$parcel$export(module.exports, "detectLayoutShiftCause", () => $2fcdd1a0376aa3ac$export$93ce39b765ea2cd3);
const $2fcdd1a0376aa3ac$var$calculateOffenderState = (current, matchesCurrentEntry)=>{
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === 'some') return 'some';
    const entryState = matchesCurrentEntry ? 'all' : 'none';
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return 'some';
    return current;
};
const $2fcdd1a0376aa3ac$var$calculateLayoutShiftMovement = (layoutShiftEntries)=>{
    const movements = layoutShiftEntries.map((lsEntry)=>{
        const rect = lsEntry.rect;
        const previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        const dx = rect.x - previousRect.x;
        const dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    const hasMovement = (m)=>m !== null;
    const validMovements = movements.filter(hasMovement);
    const allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    const first = validMovements[0];
    const allMovedSameWay = validMovements.every((m)=>m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY);
    const allMovedSameAmount = allMovedSameWay && validMovements.every((m)=>m.absDx === first.absDx && m.absDy === first.absDy);
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
const $2fcdd1a0376aa3ac$export$93ce39b765ea2cd3 = ({ viewportEntries: viewportEntries, layoutShiftEntries: layoutShiftEntries, time: time, startTime: startTime, offenderWindowMs: offenderWindowMs = 250 })=>{
    const checkpointTimestamp = startTime + time;
    const filteredLSPotentialOffenders = viewportEntries.filter((viewportEntry)=>(viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== 'layout-shift');
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    const layoutShiftVariables = $2fcdd1a0376aa3ac$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    const layoutShiftOffenders = filteredLSPotentialOffenders.reduce((acc, offender)=>{
        const offenderData = offender.data;
        const offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        const offenderTimestamp = offenderData.originalMutationTimestamp ?? offender.time;
        const happenedBefore = offenderTimestamp <= checkpointTimestamp;
        const offenderLeft = offenderRect.x;
        const offenderRight = offenderRect.x + offenderRect.width;
        const offenderTop = offenderRect.y;
        const offenderBottom = offenderRect.y + offenderRect.height;
        const shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && 'deltaX' in layoutShiftVariables && 'deltaY' in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        let isAbove = null;
        let isLeft = null;
        let isRight = null;
        let hasHorizontalOverlap = null;
        let hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) for (const lsEntry of layoutShiftEntries){
            const lsRect = lsEntry.rect;
            if (!lsRect) continue;
            const lsLeft = lsRect.x;
            const lsRight = lsRect.x + lsRect.width;
            const lsTop = lsRect.y;
            const lsBottom = lsRect.y + lsRect.height;
            isAbove = $2fcdd1a0376aa3ac$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
            isLeft = $2fcdd1a0376aa3ac$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
            isRight = $2fcdd1a0376aa3ac$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
            hasHorizontalOverlap = $2fcdd1a0376aa3ac$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
            hasVerticalOverlap = $2fcdd1a0376aa3ac$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
        }
        let matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            const dx = offenderRect.x - offenderData.previousRect.x;
            const dy = offenderRect.y - offenderData.previousRect.y;
            const isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            const isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove ?? 'none',
            isLeft: isLeft ?? 'none',
            isRight: isRight ?? 'none',
            hasHorizontalOverlap: hasHorizontalOverlap ?? 'none',
            hasVerticalOverlap: hasVerticalOverlap ?? 'none',
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("jC6Iz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0239e6db1bbd6192$export$2e2bcd8739ae039);
function $0239e6db1bbd6192$var$getViewportHeight(document = window.document) {
    let documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch  {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $0239e6db1bbd6192$export$2e2bcd8739ae039 = $0239e6db1bbd6192$var$getViewportHeight;

});

parcelRegister("gbhDC", function(module, exports) {
$parcel$export(module.exports, "default", () => $514fbc2f5150fe76$export$2e2bcd8739ae039);
function $514fbc2f5150fe76$var$getViewportWidth(document = window.document) {
    let documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch  {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $514fbc2f5150fe76$export$2e2bcd8739ae039 = $514fbc2f5150fe76$var$getViewportWidth;

});

parcelRegister("kXxl4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ea0cb3dccaf385b$export$2e2bcd8739ae039);
function $4ea0cb3dccaf385b$var$isViewportEntryData(data) {
    if (data) {
        const hasElementName = typeof data.elementName === 'string';
        const hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $4ea0cb3dccaf385b$export$2e2bcd8739ae039 = $4ea0cb3dccaf385b$var$isViewportEntryData;

});


parcelRegister("51hFz", function(module, exports) {
$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", () => $278c5df884e61659$export$98812f4e79596e2b);
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", () => $278c5df884e61659$export$44331555a87fcd9e);
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", () => $278c5df884e61659$export$c4351da6279bef53);
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", () => $278c5df884e61659$export$2492353b2cc31cc0);
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", () => $278c5df884e61659$export$5a7b359ee5e32a5b);
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
const $278c5df884e61659$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'data-drop-target-for-external',
    'draggable',
    'data-is-observed',
    'data-aui-version',
    'data-testid',
    'data-vc',
    'data-ssr-placeholder',
    'data-ssr-placeholder-replace',
    'data-vc-nvs',
    'data-media-vc-wrapper',
    'data-renderer-start-pos',
    'data-table-local-id',
    'spellcheck',
    'data-auto-scrollable',
    'id',
    'tabindex',
    'data-is-ttvc-ready',
    'contenteditable',
    'data-has-collab-initialised',
    'translate',
    'data-comment-id',
    'data-access-level'
];
const $278c5df884e61659$export$44331555a87fcd9e = [
    'aria-label',
    'aria-labelledby',
    'aria-describedby',
    'aria-hidden',
    'aria-expanded',
    'aria-controls',
    'aria-selected',
    'aria-checked',
    'aria-disabled',
    'aria-required',
    'aria-current',
    'aria-haspopup',
    'aria-pressed',
    'aria-atomic',
    'aria-live'
];
const $278c5df884e61659$export$c4351da6279bef53 = [
    'bis_skin_checked',
    'cz-shortcut-listen',
    'monica-version',
    'data-gr-ext-installed',
    'data-dashlane-rid',
    'sapling-installed',
    'data-gptw',
    // grammarly extensions
    'data-new-gr-c-s-loaded',
    'data-gr-aaa-notch-connection-id',
    'data-gr-aaa-loaded'
];
const $278c5df884e61659$export$2492353b2cc31cc0 = [
    'fdprocessedid',
    'data-dashlane-classification'
];
const $278c5df884e61659$export$5a7b359ee5e32a5b = [
    // dark reader extension
    'data-darkreader-inline-bgcolor',
    'data-darkreader-inline-bgimage',
    'data-darkreader-inline-border',
    'data-darkreader-inline-border-bottom',
    'data-darkreader-inline-border-left',
    'data-darkreader-inline-border-right',
    'data-darkreader-inline-border-top',
    'data-darkreader-inline-boxshadow',
    'data-darkreader-inline-color',
    'data-darkreader-inline-fill',
    'data-darkreader-inline-stroke',
    'data-darkreader-inline-outline',
    'data-darkreader-inline-stopcolor',
    'data-darkreader-inline-bg',
    'data-darkreader-inline-border-short',
    'data-darkreader-inline-border-bottom-short',
    'data-darkreader-inline-border-left-short',
    'data-darkreader-inline-border-right-short',
    'data-darkreader-inline-border-top-short'
];

});


parcelRegister("hqxyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $efe029fcf2b1e8dc$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $76wur = parcelRequire("76wur");

var $51hFz = parcelRequire("51hFz");
const $efe029fcf2b1e8dc$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [
        'mutation:display-contents-children-element'
    ];
    consideredEntryTypes.push('mutation:display-contents-children-attribute');
    return consideredEntryTypes;
};
const $efe029fcf2b1e8dc$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [
        'layout-shift:same-rect',
        'mutation:attribute:non-visual-input-name'
    ];
    return excludedEntryTypes;
};
const $efe029fcf2b1e8dc$var$fy26_04_excluded_attributes = [
    'data-is-hovered' // non-visual attribute
];
class $efe029fcf2b1e8dc$export$2e2bcd8739ae039 extends (0, $76wur.default) {
    constructor(revisionNo = 'fy26.04'){
        super(revisionNo);
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const extra_fy26_04_excluded_attributes = [
            'data-fabric-mode'
        ];
        const entryData = entry.data;
        const { attributeName: attributeName } = entryData;
        if (entry.data.type === 'mutation:attribute' && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
        const isEntryIncludedInV3 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV3 && !$efe029fcf2b1e8dc$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        if (entry.data.type === 'mutation:attribute' && (!attributeName || $efe029fcf2b1e8dc$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $3H4LK.fg)('platform_ufo_data-is-hovered-v4-exclusion'))) return false;
        const thirdPartyAttributes = [
            ...(0, $51hFz.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES),
            ...(0, $3H4LK.fg)('platform_ufo_exclude_dark_reader_extension') ? (0, $51hFz.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : [],
            ...(0, $3H4LK.fg)('platform_ufo_exclude_fdprocessedid_attribute') ? (0, $51hFz.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []
        ];
        if (entryData.type === 'mutation:display-contents-children-attribute') {
            if (!attributeName || attributeName.startsWith('data-test') || (0, $51hFz.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $51hFz.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
            return true;
        }
        return $efe029fcf2b1e8dc$var$getConsideredEntryTypes().includes(entry.data.type);
    }
}

});

parcelRegister("gJIpU", function(module, exports) {
$parcel$export(module.exports, "default", () => $73dd4e7931f48fbe$export$2e2bcd8739ae039);

var $hqxyF = parcelRequire("hqxyF");
const $73dd4e7931f48fbe$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize',
    'scroll-container'
];
const $73dd4e7931f48fbe$var$getConsideredEntryTypes = ()=>{
    const consideredEntryTypes = [];
    return consideredEntryTypes;
};
const $73dd4e7931f48fbe$var$getExcludedEntryTypes = ()=>{
    const excludedEntryTypes = [];
    return excludedEntryTypes;
};
class $73dd4e7931f48fbe$export$2e2bcd8739ae039 extends (0, $hqxyF.default) {
    constructor(){
        super('next');
    }
    isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
        const isEntryIncludedInV4 = super.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
        if (isEntryIncludedInV4 && !$73dd4e7931f48fbe$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
        return $73dd4e7931f48fbe$var$getConsideredEntryTypes().includes(entry.data.type);
    }
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($73dd4e7931f48fbe$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    if (eventType === 'keydown') dirtyReason = 'keypress';
                    else if (eventType === 'scroll-container') dirtyReason = 'scroll';
                    else dirtyReason = eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
}

});

parcelRegister("fpYEQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9784dec75ccdfd3$export$2e2bcd8739ae039);

var $jFknK = parcelRequire("jFknK");

var $kEbbM = parcelRequire("kEbbM");

var $jC6Iz = parcelRequire("jC6Iz");

var $gbhDC = parcelRequire("gbhDC");
const $a9784dec75ccdfd3$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
const $a9784dec75ccdfd3$var$MAX_OBSERVATIONS = 200;
const $a9784dec75ccdfd3$var$encodeRect = (rect)=>[
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
const $a9784dec75ccdfd3$var$areRectsEqual = (left, right)=>left.every((value, index)=>value === right[index]);
function $a9784dec75ccdfd3$var$isWindowEventEntryData(data) {
    return data.type === 'window:event' && 'eventType' in data;
}
class $a9784dec75ccdfd3$export$2e2bcd8739ae039 {
    getVCCleanStatus(filteredEntries) {
        let dirtyReason = '';
        let abortTimestamp = -1;
        const hasAbortEvent = filteredEntries.some((entry)=>{
            if (entry.data.type === 'window:event') {
                const data = entry.data;
                const eventType = data.eventType;
                if ($a9784dec75ccdfd3$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                    dirtyReason = eventType === 'keydown' ? 'keypress' : eventType;
                    abortTimestamp = Math.round(entry.time);
                    return true;
                }
            }
            return false;
        });
        if (hasAbortEvent && dirtyReason) return {
            isVCClean: false,
            dirtyReason: dirtyReason,
            abortTimestamp: abortTimestamp
        };
        return {
            isVCClean: true
        };
    }
    async getRawData({ entries: entries, startTime: startTime, stopTime: stopTime, isPageVisible: isPageVisible }) {
        let isVCClean;
        let dirtyReason;
        const getVCCleanStatusResult = this.getVCCleanStatus(entries);
        isVCClean = getVCCleanStatusResult.isVCClean;
        dirtyReason = getVCCleanStatusResult.dirtyReason;
        if (!isPageVisible) return {
            revision: this.revisionNo,
            clean: false,
            'metric:vc90': null,
            abortReason: 'browser_backgrounded',
            abortTimestamp: (0, $kEbbM.getEarliestHiddenTiming)(startTime, stopTime) ?? -1,
            viewport: {
                w: (0, $gbhDC.default)(),
                h: (0, $jC6Iz.default)()
            }
        };
        const viewportEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
        });
        const windowEventEntries = entries.filter((entry)=>{
            return entry.time >= startTime && entry.time <= stopTime && entry.data && $a9784dec75ccdfd3$var$isWindowEventEntryData(entry.data);
        });
        const targetNameToIdMap = new Map();
        const elementMapEntriesMap = {};
        let nextElementId = 1;
        const typeMap = new Map();
        const typeMapEntriesMap = {};
        let nextTypeId = 1;
        const attributeMap = new Map();
        const attributeEntriesMap = {};
        let nextAttributeId = 1;
        const eventTypeMap = new Map();
        const eventTypeMapEntriesMap = {};
        let nextEventTypeId = 1;
        const labelStacksMap = {};
        let rawObservations = viewportEntries.map((entry)=>{
            const viewportEntry = entry.data;
            const targetName = viewportEntry.elementName || '';
            const type = viewportEntry.type || '';
            const rect = viewportEntry.rect;
            const attributeName = viewportEntry.attributeName || '';
            let eid = targetNameToIdMap.get(viewportEntry.elementName || '') || 0;
            if (eid === 0) {
                eid = nextElementId;
                nextElementId += 1;
                targetNameToIdMap.set(targetName, eid);
                elementMapEntriesMap[eid] = targetName;
            }
            // Capture labelStacks per element (only stored once per unique element)
            if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                const labelInfo = {
                    s: viewportEntry.labelStacks.segment,
                    l: viewportEntry.labelStacks.labelStack
                };
                const shouldCompactImplicitUnknown = labelInfo.s === 'unknown' && labelInfo.l === 'unknown';
                labelStacksMap[eid] = shouldCompactImplicitUnknown ? 'u' : labelInfo;
            }
            let chg = typeMap.get(type || '') || 0;
            if (chg === 0) {
                chg = nextTypeId;
                nextTypeId += 1;
                typeMap.set(type, chg);
                typeMapEntriesMap[chg] = type;
            }
            let att = 0;
            if (attributeName) {
                att = attributeMap.get(attributeName) || 0;
                if (att === 0) {
                    att = nextAttributeId;
                    nextAttributeId += 1;
                    attributeMap.set(attributeName, att);
                    attributeEntriesMap[att] = attributeName;
                }
            }
            const encodedRect = $a9784dec75ccdfd3$var$encodeRect(rect);
            const encodedPreviousRect = viewportEntry.previousRect ? $a9784dec75ccdfd3$var$encodeRect(viewportEntry.previousRect) : null;
            const shouldIncludePreviousRect = encodedPreviousRect === null || !$a9784dec75ccdfd3$var$areRectsEqual(encodedRect, encodedPreviousRect);
            const observation = {
                t: Math.round(entry.time - startTime),
                r: encodedRect,
                ...shouldIncludePreviousRect ? {
                    pr: encodedPreviousRect
                } : {},
                chg: chg,
                eid: eid || 0,
                ...att > 0 ? {
                    att: att
                } : {}
            };
            return observation;
        });
        let rawEventObservations = windowEventEntries.map((entry)=>{
            const windowEventEntry = entry.data;
            const eventType = windowEventEntry.eventType;
            let evtId = eventTypeMap.get(eventType) || 0;
            if (evtId === 0) {
                evtId = nextEventTypeId;
                nextEventTypeId += 1;
                eventTypeMap.set(eventType, evtId);
                eventTypeMapEntriesMap[evtId] = eventType;
            }
            let eventTargetId = 0;
            const eventTargetName = windowEventEntry.elementName || '';
            if (eventTargetName) {
                eventTargetId = targetNameToIdMap.get(eventTargetName) || 0;
                if (eventTargetId === 0) {
                    eventTargetId = nextElementId;
                    nextElementId += 1;
                    targetNameToIdMap.set(eventTargetName, eventTargetId);
                    elementMapEntriesMap[eventTargetId] = eventTargetName;
                }
            }
            const eventObservation = {
                t: Math.round(entry.time - startTime),
                evt: evtId,
                ...eventTargetId > 0 ? {
                    eid: eventTargetId
                } : {}
            };
            return eventObservation;
        });
        const shouldTrimEventObservations = rawEventObservations.length > $a9784dec75ccdfd3$var$MAX_OBSERVATIONS;
        const shouldTrimViewportObservations = rawObservations.length > $a9784dec75ccdfd3$var$MAX_OBSERVATIONS;
        // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
        // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
        if (shouldTrimEventObservations) {
            const firstEventObservation = rawEventObservations[0];
            const lastEventObservations = rawEventObservations.slice(-$a9784dec75ccdfd3$var$MAX_OBSERVATIONS);
            rawEventObservations = [
                firstEventObservation,
                ...lastEventObservations
            ];
        }
        // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
        // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
        if (shouldTrimViewportObservations) {
            const firstObservation = rawObservations[0];
            const lastObservations = rawObservations.slice(-$a9784dec75ccdfd3$var$MAX_OBSERVATIONS);
            // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
            const ssrEid = targetNameToIdMap.get('SSR');
            const ssrObservation = ssrEid ? rawObservations.find((obs)=>obs.eid === ssrEid && obs !== firstObservation) : undefined;
            // Include SSR observation if it exists and is not already in the kept observations
            const ssrAlreadyIncluded = ssrObservation && lastObservations.some((obs)=>obs === ssrObservation);
            rawObservations = [
                firstObservation,
                ...ssrObservation && !ssrAlreadyIncluded ? [
                    ssrObservation
                ] : [],
                ...lastObservations
            ];
        }
        if (shouldTrimViewportObservations || shouldTrimEventObservations) {
            // Collect referenced IDs from final retained observations. Keep this inside the trim
            // guard so the common untrimmed path avoids extra Set allocations and scans.
            const referencedEids = new Set();
            const referencedChgs = new Set();
            const referencedAtts = new Set();
            const referencedEvts = new Set();
            const referencedEventTargetEids = new Set();
            for (const observation of rawObservations){
                if (observation.eid > 0) referencedEids.add(observation.eid);
                if (typeof observation.chg === 'number' && observation.chg > 0) referencedChgs.add(observation.chg);
                if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
            }
            for (const observation of rawEventObservations){
                if (observation.evt > 0) referencedEvts.add(observation.evt);
                if (observation.eid !== undefined && observation.eid > 0) referencedEventTargetEids.add(observation.eid);
            }
            for (const eid of Object.keys(elementMapEntriesMap).map(Number))if (!referencedEids.has(eid) && !referencedEventTargetEids.has(eid)) {
                delete elementMapEntriesMap[eid];
                delete labelStacksMap[eid];
            }
            if (shouldTrimViewportObservations) {
                for (const chg of Object.keys(typeMapEntriesMap).map(Number))if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                for (const att of Object.keys(attributeEntriesMap).map(Number))if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
            }
            if (shouldTrimEventObservations) {
                // Event type map cleanup is only needed when event observations were trimmed.
                // If only viewport observations were trimmed, all event observations remain and
                // therefore every event type ID in the map is still referenced.
                for (const evt of Object.keys(eventTypeMapEntriesMap).map(Number))if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
            }
        }
        // FedRAMP-Moderate scrubbing.
        //
        // In commercial environments the raw-handler payload includes:
        //   - `rawData.att` / `obs[].att`  → DOM attribute names from
        //     `MutationRecord.attributeName`. These are *names* (not values),
        //     but custom product attributes can in principle embed
        //     identifiers (e.g. `data-user-{id}-state`).
        //   - `rawData.lbl`                → UFO labelStacks. Generally
        //     curated product paths but in poorly-instrumented call sites
        //     could embed dynamic identifiers.
        //
        // Server-side TTVC reconstruction does not require these fields
        // (it is driven by timestamps, rectangles, and mutation kind),
        // so dropping them in FedRAMP is safe and removes residual PII risk.
        const isFedrampScrubbed = (0, $jFknK.isFedrampOverrideActive)();
        const scrubbedObservations = isFedrampScrubbed ? rawObservations.map(({ att: _att, ...rest })=>rest) : rawObservations;
        const result = {
            revision: this.revisionNo,
            clean: isVCClean,
            'metric:vc90': null,
            rawData: {
                obs: scrubbedObservations ?? undefined,
                eid: elementMapEntriesMap ?? undefined,
                chg: typeMapEntriesMap ?? undefined,
                att: isFedrampScrubbed ? undefined : attributeEntriesMap ?? undefined,
                evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                lbl: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                lblMode: isFedrampScrubbed ? undefined : Object.keys(labelStacksMap).length > 0 ? 'sentinel-v1' : undefined
            },
            abortReason: dirtyReason,
            abortTimestamp: getVCCleanStatusResult.abortTimestamp,
            viewport: {
                w: (0, $gbhDC.default)(),
                h: (0, $jC6Iz.default)()
            }
        };
        return result;
    }
    constructor(){
        this.revisionNo = 'raw-handler';
    }
}

});

parcelRegister("26bSW", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa47cd25de98d359$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $aeOqv = parcelRequire("aeOqv");

var $gJOko = parcelRequire("gJOko");

var $iuKXX = parcelRequire("iuKXX");

var $bIpmx = parcelRequire("bIpmx");

var $6gTcj = parcelRequire("6gTcj");

var $1vHz5 = parcelRequire("1vHz5");

var $ildAB = parcelRequire("ildAB");

var $esIvG = parcelRequire("esIvG");

var $gVSjN = parcelRequire("gVSjN");

var $eB5Ca = parcelRequire("eB5Ca");

var $c44Zi = parcelRequire("c44Zi");

var $fqrdg = parcelRequire("fqrdg");

var $gN6Re = parcelRequire("gN6Re");

var $4f3Zv = parcelRequire("4f3Zv");

var $6iQT4 = parcelRequire("6iQT4");
const $fa47cd25de98d359$var$createElementMutationsWatcher = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return 'ssr-hydration';
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return 'ssr-hydration';
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return 'mutation:ssr-placeholder';
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return 'mutation:ssr-placeholder';
            }
        }
        if (hasSameDeletedNode && (0, $fqrdg.default)(target)) return 'mutation:remount';
        if ((0, $aeOqv.isContainedWithinMediaWrapper)(target)) return 'mutation:media';
        if (isWithinThirdPartySegment) return 'mutation:third-party-element';
        if (isWithinSmartAnswersSegment) return 'mutation:smart-answers-element';
        const isInIgnoreLsMarker = (0, $fqrdg.default)(target);
        if (!isInIgnoreLsMarker) return 'mutation:element';
        const isRLLPlaceholder = (0, $6gTcj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return 'mutation:rll-placeholder';
        const wasDeleted = removedNodeRects.some((nr)=>(0, $4f3Zv.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return 'mutation:element-replacement';
        return 'mutation:element';
    };
const $fa47cd25de98d359$var$createElementMutationsWatcherNew = (removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler)=>({ target: target, rect: rect })=>{
        if (getSSRState) {
            const ssrState = getSSRState();
            const SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: 'ssr-hydration',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            const ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: 'mutation:ssr-placeholder',
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $fqrdg.default)(target)) return {
            type: 'mutation:remount',
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $aeOqv.isContainedWithinMediaWrapper)(target)) return {
            type: 'mutation:media',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: 'mutation:third-party-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: 'mutation:smart-answers-element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isInIgnoreLsMarker = (0, $fqrdg.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
        const isRLLPlaceholder = (0, $6gTcj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: 'mutation:rll-placeholder',
            mutationData: {
                timestamp: timestamp
            }
        };
        const wasDeleted = removedNodeRects.some((nr)=>(0, $4f3Zv.isSameRectDimensions)(nr, rect));
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: 'mutation:element-replacement',
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: 'mutation:element',
            mutationData: {
                timestamp: timestamp
            }
        };
    };
class $fa47cd25de98d359$export$2e2bcd8739ae039 {
    constructor({ onChange: onChange, getSSRState: getSSRState, getSSRPlaceholderHandler: getSSRPlaceholderHandler, trackLayoutShiftOffenders: trackLayoutShiftOffenders = false, searchPageConfig: searchPageConfig }){
        this.handleIntersectionEntry = ({ target: target, rect: rect, time: time, type: type, mutationData: mutationData })=>{
            if (!target) return;
            const visible = (0, $c44Zi.isElementVisible)(target);
            const lastElementRect = this.mapVisibleNodeRects.get(target);
            this.mapVisibleNodeRects.set(target, rect);
            this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        };
        this.handleChildListMutation = async ({ target: target, addedNodes: addedNodes, removedNodes: removedNodes, timestamp: timestamp })=>{
            const removedNodeRects = removedNodes.map((ref)=>{
                const n = ref.deref();
                if (!n) return;
                return this.mapVisibleNodeRects.get(n);
            });
            const targetNode = target.deref();
            for (const addedNodeRef of addedNodes){
                var _this$getSSRState, _this$intersectionObs;
                const addedNode = addedNodeRef.deref();
                if (!addedNode) continue;
                const hasSameDeletedNode = removedNodes.find((ref)=>{
                    const n = ref.deref();
                    if (!n || !addedNode) return false;
                    return n.isEqualNode(addedNode);
                });
                const { isWithin: isWithinThirdPartySegment } = (0, $gVSjN.default)(addedNode, 'UFOThirdPartySegment', this.mapIs3pResult);
                const isWithinSmartAnswersSegment = Boolean(this.shouldCheckSmartAnswersMutations() && (0, $eB5Ca.isContainedWithinSmartAnswers)(addedNode));
                const isTargetReactRoot = targetNode === ((_this$getSSRState = this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                (_this$intersectionObs = this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (this.trackLayoutShiftOffenders ? $fa47cd25de98d359$var$createElementMutationsWatcherNew : $fa47cd25de98d359$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, this.getSSRState, this.getSSRPlaceholderHandler));
            }
        };
        this.handleAttributeMutation = ({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue, timestamp: timestamp })=>{
            var _this$intersectionObs2;
            (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, ({ target: target, rect: rect })=>{
                if ((0, $aeOqv.isContainedWithinMediaWrapper)(target)) return {
                    type: 'mutation:media',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const { isWithin: isWithinThirdPartySegment } = (0, $gVSjN.default)(target, 'UFOThirdPartySegment', this.mapIs3pResult);
                if (isWithinThirdPartySegment) return {
                    type: 'mutation:third-party-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (this.shouldCheckSmartAnswersMutations() && (0, $eB5Ca.isContainedWithinSmartAnswers)(target)) return {
                    type: 'mutation:smart-answers-attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $gJOko.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $iuKXX.default)({
                    target: target,
                    attributeName: attributeName,
                    type: 'attributes'
                })) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                // Pragmatic Drag and Drop attributes added during post-paint
                // registration; do not affect layout or paint.
                if ((0, $bIpmx.default)({
                    target: target,
                    attributeName: attributeName
                }) && (0, $3H4LK.fg)('platform_ufo_exclude_pdnd_attributes_from_vc')) return {
                    type: 'mutation:attribute:non-visual-style',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $gN6Re.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: 'mutation:attribute:non-visual-input-name',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const isRLLPlaceholder = (0, $6gTcj.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: 'mutation:rll-placeholder',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                const lastElementRect = this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $6iQT4.isSameRectSize)(rect, lastElementRect)) return {
                    type: 'mutation:attribute:no-layout-shift',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: 'mutation:attribute',
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        };
        this.handleLayoutShift = ({ time: time, changedRects: changedRects })=>{
            for (const changedRect of changedRects){
                const target = changedRect.node;
                if (target) {
                    const isSameCurrentAndPreviousRects = (0, $4f3Zv.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                    this.onChange({
                        time: time,
                        elementRef: new WeakRef(target),
                        visible: true,
                        rect: changedRect.rect,
                        previousRect: changedRect.previousRect,
                        type: isSameCurrentAndPreviousRects ? 'layout-shift:same-rect' : 'layout-shift'
                    });
                }
            }
        };
        this.shouldCheckSmartAnswersMutations = ()=>{
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === this.searchPageConfig.searchPageRoute;
        };
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    initializeObservers() {
        if (this.isStarted) return;
        this.intersectionObserver = (0, $1vHz5.createIntersectionObserver)({
            onEntry: this.handleIntersectionEntry
        });
        this.mutationObserver = (0, $ildAB.default)({
            onChildListMutation: this.handleChildListMutation,
            onAttributeMutation: this.handleAttributeMutation
        });
        this.performanceObserver = (0, $esIvG.default)({
            onLayoutShift: this.handleLayoutShift
        });
    }
    start() {
        var _this$mutationObserve, _this$performanceObse;
        if (this.isStarted) return;
        this.initializeObservers();
        (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
            attributeOldValue: true,
            attributes: true,
            childList: true,
            subtree: true
        });
        (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
            type: 'layout-shift',
            buffered: true,
            // @ts-ignore -error
            durationThreshold: 30
        });
        this.isStarted = true;
    }
    stop() {
        var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
        if (!this.isStarted) return;
        (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
        (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
        (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
        this.isStarted = false;
        // Clean up caches when stopping
        (0, $gVSjN.cleanupCaches)(this.mapIs3pResult);
    }
}

});
parcelRegister("bIpmx", function(module, exports) {
$parcel$export(module.exports, "default", () => $92701dff1c9f673d$export$2e2bcd8739ae039);
/**
 * Attributes that Pragmatic Drag and Drop adds via `setAttribute` during its
 * post-paint registration step. They are used purely for hit testing and
 * registration bookkeeping, and do not affect layout, paint, or visible
 * styling, so they are safe to ignore for VC measurement.
 *
 * Drop target attributes follow `data-drop-target-for-<typeKey>` and are
 * handled by the prefix below (covers shipped and custom adapters).
 */ const $92701dff1c9f673d$export$bcd335ae574a0717 = new Set([
    // @atlaskit/pragmatic-drag-and-drop (core)
    'draggable',
    // Honey pot lives on a transient element; included for completeness.
    'data-pdnd-honey-pot',
    // @atlaskit/pragmatic-drag-and-drop-auto-scroll
    'data-auto-scrollable',
    // @atlaskit/pragmatic-drag-and-drop/react-beautiful-dnd-migration
    'data-rbd-draggable-droppable-id',
    'data-rbd-draggable-index',
    'data-rbd-droppable-type',
    'data-rbd-droppable-direction',
    'data-rbd-droppable-id',
    'data-rbd-droppable-context-id',
    'data-rbd-style-context-id'
]);
const $92701dff1c9f673d$export$846396c2d8be3710 = 'data-drop-target-for-';
function $92701dff1c9f673d$export$2e2bcd8739ae039({ target: target, attributeName: attributeName }) {
    if (!(target instanceof Element)) return false;
    if (!attributeName) return false;
    if ($92701dff1c9f673d$export$bcd335ae574a0717.has(attributeName)) return true;
    if (attributeName.startsWith($92701dff1c9f673d$export$846396c2d8be3710)) return true;
    return false;
}

});

parcelRegister("1vHz5", function(module, exports) {
$parcel$export(module.exports, "createIntersectionObserver", () => $b3d1b32c669929b4$export$c3799d33e0ae80a5);

var $gU6F3 = parcelRequire("gU6F3");
function $b3d1b32c669929b4$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $b3d1b32c669929b4$export$c3799d33e0ae80a5({ onEntry: onEntry, onObserved: onObserved }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const callbacksPerElement = new WeakMap();
    const intersectionObserverCallback = (entries)=>{
        const validEntries = [];
        const startTime = performance.now();
        entries.forEach((entry)=>{
            if (!(entry.target instanceof HTMLElement)) return;
            const tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $gU6F3.isZeroDimensionRectangle)(entry.intersectionRect)) {
                const zeroDimensionRectangleTagCallback = (props)=>{
                    const tagOrCallbackResult = typeof tagOrCallback === 'function' ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === 'mutation:element') return 'mutation:display-contents-children-element';
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== 'string' && tagOrCallbackResult.type === 'mutation:attribute' && 'oldValue' in tagOrCallbackResult.mutationData) {
                        const { attributeName: attributeName, oldValue: oldValue, newValue: newValue } = tagOrCallbackResult.mutationData;
                        const isRoutingMutation = attributeName === 'style' && (!oldValue && newValue === 'display: none !important;' || oldValue === 'display: none !important;' && !newValue);
                        if (isRoutingMutation) return {
                            type: 'mutation:attribute:framework-routing',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: 'mutation:display-contents-children-attribute',
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                for (const child of Array.from(entry.target.children)){
                    observer.observe(child);
                    callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                }
                return;
            }
            if (!$b3d1b32c669929b4$var$isValidEntry(entry)) return;
            let mutationTag = null;
            let mutationData = null;
            if (typeof tagOrCallback === 'function') {
                const tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag ?? 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    const observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: ()=>{
            observer.disconnect();
        },
        unobserve: (target)=>{
            observer.unobserve(target);
        },
        watchAndTag: (target, tagOrCallback)=>{
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("gU6F3", function(module, exports) {
$parcel$export(module.exports, "isZeroDimensionRectangle", () => $c4dfdc73f9902870$export$80d6b07c2266a1c6);
function $c4dfdc73f9902870$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("ildAB", function(module, exports) {
$parcel$export(module.exports, "default", () => $4245ce06cccfd863$export$2e2bcd8739ae039);

var $8UPEN = parcelRequire("8UPEN");
function $4245ce06cccfd863$var$createMutationObserver({ onAttributeMutation: onAttributeMutation, onChildListMutation: onChildListMutation, onMutationFinished: onMutationFinished }) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    const mutationObserverCallback = (mutations)=>{
        const targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        const batchedMutations = new Map();
        for (const mut of mutations){
            if (!(mut.target instanceof HTMLElement)) continue;
            if ((0, $8UPEN.expVal)('cc_editor_vc_exclude_flags', 'isEnabled', false)) {
                // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                // Currently being tested in Confluence
                // Skip elements with data-vc-oob attribute
                if (mut.target.dataset.vcOob) return;
            }
            if (mut.type === 'attributes') {
                /*
        	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
        	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
        	Conceptually there is after all a mutation: there is an old value replaced with a new one,
        	and whether or not they are the same doesn't really matter.
        	And Custom elements should work the same way as MutationObserver."
        	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
        */ const oldValue = mut.oldValue ?? undefined;
                const newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                if (oldValue !== newValue) onAttributeMutation({
                    target: mut.target,
                    attributeName: mut.attributeName ?? 'unknown',
                    oldValue: oldValue,
                    newValue: newValue,
                    timestamp: mut.timestamp || performance.now()
                });
                continue;
            } else if (mut.type === 'childList') {
                // In chromium browser MutationRecord has timestamp field, which we should use.
                const timestamp = Math.round(mut.timestamp || performance.now());
                // Get or create timestamp bucket
                let timestampBucket = batchedMutations.get(timestamp);
                if (!timestampBucket) {
                    timestampBucket = new Map();
                    batchedMutations.set(timestamp, timestampBucket);
                }
                // Get or create target batch within timestamp bucket
                let batch = timestampBucket.get(mut.target);
                if (!batch) {
                    batch = {
                        target: new WeakRef(mut.target),
                        addedNodes: [],
                        removedNodes: [],
                        timestamp: timestamp
                    };
                    timestampBucket.set(mut.target, batch);
                }
                // Accumulate added nodes
                (mut.addedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                });
                // Accumulate removed nodes
                (mut.removedNodes ?? []).forEach((node)=>{
                    if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                });
            }
            targets.push(mut.target);
        }
        // Process all batched childList mutations
        for (const timestampBucket of batchedMutations.values())for (const batch of timestampBucket.values())onChildListMutation({
            target: batch.target,
            addedNodes: batch.addedNodes,
            removedNodes: batch.removedNodes,
            timestamp: batch.timestamp
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    const observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $4245ce06cccfd863$export$2e2bcd8739ae039 = $4245ce06cccfd863$var$createMutationObserver;

});

parcelRegister("esIvG", function(module, exports) {
$parcel$export(module.exports, "default", () => $58a5ae797d8c9aa4$export$2e2bcd8739ae039);
// The LayoutShiftAttribution API is returning the numbers on physical dimension
function $58a5ae797d8c9aa4$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $58a5ae797d8c9aa4$var$createPerformanceObserver({ onLayoutShift: onLayoutShift }) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    const performanceObserverCallback = (entries)=>{
        for (const entry of entries.getEntries())if (entry.entryType === 'layout-shift' && 'sources' in entry) {
            // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
            const changedRects = entry.sources.reduceRight((acc, attr)=>{
                acc.push({
                    rect: $58a5ae797d8c9aa4$export$5e3f54cad8cb65e2(attr.currentRect),
                    previousRect: $58a5ae797d8c9aa4$export$5e3f54cad8cb65e2(attr.previousRect),
                    node: attr.node
                });
                return acc;
            }, []);
            onLayoutShift({
                time: entry.startTime,
                changedRects: changedRects
            });
        }
    };
    const observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$58a5ae797d8c9aa4$export$2e2bcd8739ae039 = $58a5ae797d8c9aa4$var$createPerformanceObserver;

});

parcelRegister("gVSjN", function(module, exports) {
$parcel$export(module.exports, "cleanupCaches", () => $cffd322b479d6019$export$6a35c3789c327630);
$parcel$export(module.exports, "default", () => $cffd322b479d6019$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $4Bdcb = parcelRequire("4Bdcb");

var $vmLCM = parcelRequire("vmLCM");

var $1KDVb = parcelRequire("1KDVb");
const $cffd322b479d6019$var$OLD_DOM_WALK_MAX_LEVEL = 40;
const $cffd322b479d6019$var$OLD_FIBER_WALK_MAX_LEVEL = 40;
const $cffd322b479d6019$var$NEW_DOM_WALK_MAX_LEVEL = 400;
const $cffd322b479d6019$var$NEW_FIBER_WALK_MAX_LEVEL = 400;
// Cache cleanup
let $cffd322b479d6019$var$callCount = 0;
const $cffd322b479d6019$var$CLEANUP_THRESHOLD = 50;
function $cffd322b479d6019$var$maybeCleanup(resultCache) {
    $cffd322b479d6019$var$callCount++;
    if ($cffd322b479d6019$var$callCount >= $cffd322b479d6019$var$CLEANUP_THRESHOLD && (0, $4Bdcb.default)(0.3)) $cffd322b479d6019$export$6a35c3789c327630(resultCache);
}
function $cffd322b479d6019$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $cffd322b479d6019$var$callCount = 0;
    return resultCache;
}
function $cffd322b479d6019$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $cffd322b479d6019$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) return {
        isWithin: resultCache.get(node) ?? false
    };
    const checkedNodes = [];
    const shouldUseBumpedWalkLevels = (0, $3H4LK.fg)('ufo-bump-walk-levels');
    const DOM_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $cffd322b479d6019$var$NEW_DOM_WALK_MAX_LEVEL : $cffd322b479d6019$var$OLD_DOM_WALK_MAX_LEVEL;
    const FIBER_WALK_MAX_LEVEL = shouldUseBumpedWalkLevels ? $cffd322b479d6019$var$NEW_FIBER_WALK_MAX_LEVEL : $cffd322b479d6019$var$OLD_FIBER_WALK_MAX_LEVEL;
    // Always use cached fiber strategy to handle non-React elements reliably
    const { fiber: fiber, cachedResult: cachedResult } = (0, $1KDVb.default)(node, DOM_WALK_MAX_LEVEL, checkedNodes, shouldUseBumpedWalkLevels ? resultCache : undefined);
    if (cachedResult !== undefined) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, cachedResult);
        });
        return {
            isWithin: cachedResult
        };
    }
    if (!fiber) {
        checkedNodes.forEach((checkedNode)=>{
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    const isWithin = (0, $vmLCM.default)(fiber, targetComponentName, FIBER_WALK_MAX_LEVEL);
    checkedNodes.forEach((checkedNode)=>{
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("vmLCM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e893effe03cd6951$export$2e2bcd8739ae039);

var $zr7ud = parcelRequire("zr7ud");
function $e893effe03cd6951$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    const componentName = (0, $zr7ud.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $e893effe03cd6951$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("zr7ud", function(module, exports) {
$parcel$export(module.exports, "default", () => $4036a567a8633504$export$2e2bcd8739ae039);
// Helper function to extract component name from fiber
function $4036a567a8633504$export$2e2bcd8739ae039(fiber) {
    const type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === 'function' || typeof type === 'object') return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("1KDVb", function(module, exports) {
$parcel$export(module.exports, "default", () => $041368c5f15dad15$export$2e2bcd8739ae039);

var $bgHNL = parcelRequire("bgHNL");
function $041368c5f15dad15$export$2e2bcd8739ae039(element, maxLevel, checkedNodes, resultCache) {
    let currentElement = element;
    let remainingLevels = maxLevel;
    while(currentElement && remainingLevels > 0){
        const cachedResult = resultCache === null || resultCache === void 0 ? void 0 : resultCache.get(currentElement);
        if (cachedResult !== undefined) return {
            fiber: null,
            cachedResult: cachedResult
        };
        checkedNodes.push(currentElement);
        const fiber = (0, $bgHNL.default)(currentElement);
        if (fiber) return {
            fiber: fiber
        };
        currentElement = currentElement.parentElement;
        remainingLevels--;
    }
    return {
        fiber: null
    };
}

});
parcelRegister("bgHNL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d44fc61d5bc0006a$export$2e2bcd8739ae039);
// Helper function to find React fiber on an element
function $d44fc61d5bc0006a$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(const key in element){
        if (key.startsWith('__reactFiber$') || key.startsWith('__reactInternalInstance$')) return element[key];
    }
    return null;
}

});



parcelRegister("eB5Ca", function(module, exports) {
$parcel$export(module.exports, "isContainedWithinSmartAnswers", () => $0c750d4cbda43b10$export$16c2770458939f21);

var $564zZ = parcelRequire("564zZ");
function $0c750d4cbda43b10$export$16c2770458939f21(node) {
    const doc = (0, $564zZ.getDocument)();
    if (!doc) return false;
    const smartAnswersElement = doc.getElementById('search-page-smart-answers');
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("564zZ", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $0e3c700d17bcda13$export$f65ca476c09acec0);
const $0e3c700d17bcda13$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("c44Zi", function(module, exports) {
$parcel$export(module.exports, "isElementVisible", () => $63952116fdaaaac2$export$e989c0fffaa6b27a);
function $63952116fdaaaac2$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        const visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch  {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("fqrdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $5897b73615a3aaf0$export$2e2bcd8739ae039);
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $5897b73615a3aaf0$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute('data-vc-ignore-if-no-layout-shift') === 'true' || $5897b73615a3aaf0$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("gN6Re", function(module, exports) {
$parcel$export(module.exports, "isInputNameMutation", () => $700440557d789c13$export$80a5724ceedcfd3d);
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $700440557d789c13$export$80a5724ceedcfd3d({ target: target, attributeName: attributeName, oldValue: oldValue, newValue: newValue }) {
    return target instanceof HTMLInputElement && attributeName === 'name' && (oldValue === '' || newValue === '');
}

});

parcelRegister("4f3Zv", function(module, exports) {
$parcel$export(module.exports, "isSameRectDimensions", () => $71d624f5e4e84c0d$export$fde63bc968551821);
const $71d624f5e4e84c0d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $71d624f5e4e84c0d$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $71d624f5e4e84c0d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $71d624f5e4e84c0d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $71d624f5e4e84c0d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $71d624f5e4e84c0d$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("6iQT4", function(module, exports) {
$parcel$export(module.exports, "isSameRectSize", () => $0631b6187674a090$export$597b41700f7dcd36);
const $0631b6187674a090$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $0631b6187674a090$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $0631b6187674a090$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $0631b6187674a090$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("h0Opq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c31fecd0bde203d9$export$2e2bcd8739ae039);

var $lMcEJ = parcelRequire("lMcEJ");
class $c31fecd0bde203d9$export$2e2bcd8739ae039 {
    constructor(opts){
        this.unbindFns = [];
        this.onEvent = opts.onEvent;
    }
    bindEvent(type) {
        const unbindCallback = (0, $lMcEJ.bind)(window, {
            type: type,
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: type,
                    event: event
                });
            },
            options: {
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    /**
   * Binds a scroll listener on `document` using the capture phase.
   * The `scroll` event does not bubble, so listening on `window` only catches
   * document-level scrolls. By using `{ capture: true }` on `document`, we can
   * detect scroll events from any element in the DOM tree, including inner
   * scrollable containers (e.g. when the user drags a scrollbar).
   */ bindCaptureScrollEvent() {
        const unbindCallback = (0, $lMcEJ.bind)(document, {
            type: 'scroll',
            listener: (event)=>{
                if (!event.isTrusted) return;
                this.onEvent({
                    time: event.timeStamp,
                    type: 'scroll-container',
                    event: event
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        this.unbindFns.push(unbindCallback);
    }
    start() {
        this.bindEvent('wheel');
        this.bindEvent('scroll');
        this.bindEvent('keydown');
        this.bindEvent('resize');
        this.bindCaptureScrollEvent();
    }
    stop() {
        this.unbindFns.forEach((cb)=>{
            cb();
        });
        this.unbindFns = [];
    }
}

});



parcelRegister("c96yR", function(module, exports) {
$parcel$export(module.exports, "interactions", () => $fc26a225d04e55fc$export$cc97b17ef9aeb088);
const $fc26a225d04e55fc$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("hGTo0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7075764eb489d827$export$2e2bcd8739ae039);

var $5XOna = parcelRequire("5XOna");

var $c96yR = parcelRequire("c96yR");

var $c62a8 = parcelRequire("c62a8");
class $7075764eb489d827$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $5XOna.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }, interactionId) {
        if (this.eligibleToMeasure(interactionId)) {
            var _this$vcObserver;
            (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                startTime: startTime
            });
        }
    }
    stopVCObserver() {
        var _this$vcObserver2;
        (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }
    // Check if the current interaction is eligible for measurement
    eligibleToMeasure(interactionId) {
        const interaction = (0, $c96yR.interactions).get(interactionId);
        return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition';
    }
    updateFinishedInteraction(interaction) {
        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'page_load' || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'transition') this.finishedInteraction = interaction;
    }
    setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    sinkHandler(fn) {
        this.sinkHandlerFn = fn;
    }
    onInteractionComplete(id, data) {
        if (data.ufoName) {
            const updatedData = {
                ...data,
                vcObserver: this.vcObserver ?? undefined
            };
            this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
        }
        this.stopVCObserver();
        (0, $c62a8.remove)(id);
        this.reset();
    }
    reset() {
        var _this$finishedInterac;
        this.stopVCObserver();
        if ((_this$finishedInterac = this.finishedInteraction) !== null && _this$finishedInterac !== void 0 && _this$finishedInterac.id) (0, $c62a8.remove)(this.finishedInteraction.id);
        this.finishedInteraction = null;
        this.lastInteractionFinishVCResult = undefined;
    }
    stopAll(id) {
        (0, $c62a8.remove)(id);
        this.reset();
    }
    constructor(){
        // Store the finished interaction (as non-3p interaction)
        this.finishedInteraction = null;
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        this.vcObserver = null;
        this.sinkHandlerFn = ()=>{};
    }
}

});

parcelRegister("jxNQh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d07a7fcfa297c734$export$2e2bcd8739ae039);

var $jFknK = parcelRequire("jFknK");

var $kEbbM = parcelRequire("kEbbM");

var $5XOna = parcelRequire("5XOna");
const $d07a7fcfa297c734$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
class $d07a7fcfa297c734$export$2e2bcd8739ae039 {
    initializeVCObserver(options) {
        this.vcObserver = new (0, $5XOna.VCObserverWrapper)({
            ...options,
            isPostInteraction: true
        });
    }
    startVCObserver({ startTime: startTime }) {
        var _this$vcObserver;
        (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
            startTime: startTime
        });
    }
    stopVCObserver() {
        var _this$vcObserver2;
        (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
    }
    setVCObserverSSRConfig(vcObserverSSRConfig) {
        this.vcObserverSSRConfig = vcObserverSSRConfig;
    }
    /**
   * Set the VC result as per the last interaction
   * Used to compare diffs of VC updates vs post interaction VC observer
   * @param result - VC result as calculated by UFO create payload
   */ setLastInteractionFinishVCResult(result) {
        this.lastInteractionFinishVCResult = result;
    }
    /**
   * Set the fn that would be invoked to process / send the observation data
   */ sinkHandler(sinkHandlerFn) {
        this.sinkHandlerFn = sinkHandlerFn;
    }
    /**
   * Reset state of the log
   */ reset() {
        this.lastInteractionFinish = null;
        this.reactProfilerTimings = [];
        this.holdInfo = [];
        if (this.sinkTimeoutId != null) {
            clearTimeout(this.sinkTimeoutId);
            this.sinkTimeoutId = null;
        }
        this.setVCObserverSSRConfig(null);
    }
    /**
   * Check if there is data in the log
   */ hasData() {
        var _this$reactProfilerTi;
        return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
    }
    /**
   * Send the log if there is data
   */ async sendPostInteractionLog() {
        var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
        if (!this.lastInteractionFinish || !this.sinkHandlerFn) {
            var _this$vcObserver3;
            this.reset();
            (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
            return;
        }
        const pageVisibilityState = (0, $kEbbM.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
        const isPageVisible = pageVisibilityState === 'visible';
        const config = (0, $jFknK.getConfig)();
        const postInteractionFinishVCResult = await ((_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult({
            start: this.lastInteractionFinish.start,
            stop: performance.now(),
            tti: -1,
            // no need for TTI value here
            isEventAborted: !!this.lastInteractionFinish.abortReason,
            prefix: 'ufo',
            experienceKey: this.lastInteractionFinish.ufoName,
            interactionId: this.lastInteractionFinish.id,
            includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
            includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio,
            ...this.vcObserverSSRConfig,
            interactionType: this.lastInteractionFinish.type,
            isPageVisible: isPageVisible,
            interactionAbortReason: this.lastInteractionFinish.abortReason
        }));
        (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
        this.sinkHandlerFn({
            lastInteractionFinish: this.lastInteractionFinish,
            reactProfilerTimings: this.reactProfilerTimings,
            postInteractionFinishVCResult: postInteractionFinishVCResult,
            lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
            postInteractionHoldInfo: this.holdInfo
        });
        this.reset();
    }
    /**
   * This fn should be invoked when an interaction has finished
   * Basic details about the finished interaction will be recorded
   * A timeout will be setup to send the post interaction observation after some time.
   */ onInteractionComplete({ ufoName: ufoName, start: start, end: end, id: id, abortReason: abortReason, abortedByInteractionName: abortedByInteractionName, routeName: routeName, type: type, errors: errors }) {
        var _getConfig;
        this.lastInteractionFinish = {
            ufoName: ufoName,
            start: start,
            end: end,
            id: id,
            abortReason: abortReason,
            abortedByInteractionName: abortedByInteractionName,
            routeName: routeName,
            type: type,
            errors: errors
        };
        const timeout = ((_getConfig = (0, $jFknK.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $d07a7fcfa297c734$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
        this.sinkTimeoutId = window.setTimeout(async ()=>{
            await this.sendPostInteractionLog();
        }, timeout);
    }
    /**
   * This fn should be invoked when a React render happens after interaction has finished
   */ addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
        if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
            type: type,
            actualDuration: actualDuration,
            baseDuration: baseDuration,
            startTime: startTime,
            commitTime: commitTime,
            labelStack: labelStack
        });
    }
    addHoldInfo(labelStack, name, start) {
        this.holdInfo.push({
            name: name,
            labelStack: labelStack,
            start: start
        });
    }
    constructor(){
        /**
   * Basic info about interaction that has just finished
   */ this.lastInteractionFinish = null;
        /**
   * Array of observed react render timings
   */ this.reactProfilerTimings = [];
        /**
   * Store the scheduled sink timeout Id so that it can be cancelled when needed
   */ this.sinkTimeoutId = null;
        this.holdInfo = [];
        /**
   * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
   */ this.vcObserver = null;
        this.vcObserverSSRConfig = null;
        /**
   * Handler function to process / send the observation data
   */ this.sinkHandlerFn = ()=>{};
    }
}

});


parcelRegister("6mmHn", function(module, exports) {
$parcel$export(module.exports, "getMetaData", () => $89a90dfb163b8ebe$export$929b5cc2a4ac0922);
$parcel$export(module.exports, "getMeta", () => $89a90dfb163b8ebe$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getMetaFromHTML", () => $89a90dfb163b8ebe$export$5a64793485e318f6);
$parcel$export(module.exports, "setHTMLMeta", () => $89a90dfb163b8ebe$export$11f8d00783d7fcf3);
$parcel$export(module.exports, "getCloudId", () => $89a90dfb163b8ebe$export$fdd2c0ba94025c3c);
$parcel$export(module.exports, "getActivationId", () => $89a90dfb163b8ebe$export$3ad4bb31a1816ff6);
$parcel$export(module.exports, "getHelpCenterAri", () => $89a90dfb163b8ebe$export$5b6c1ffe6316b179);
$parcel$export(module.exports, "getWorkspaceAri", () => $89a90dfb163b8ebe$export$8e2de40963827c80);
$parcel$export(module.exports, "getLayoutAri", () => $89a90dfb163b8ebe$export$b6b5277467022679);
$parcel$export(module.exports, "isValidLayoutAriPresent", () => $89a90dfb163b8ebe$export$7a9c037572667aa1);
$parcel$export(module.exports, "addMetaToHead", () => $89a90dfb163b8ebe$export$9e7e16a3dbced495);

var $1CB66 = parcelRequire("1CB66");
// oxlint-disable-next-line no-shadow
var $89a90dfb163b8ebe$var$EnvType = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}($89a90dfb163b8ebe$var$EnvType || {});
const $89a90dfb163b8ebe$var$requiredMetaTags = {
    'account-id': 'accountId',
    'ajs-user-locale': 'userLocale',
    'ajs-account-type': 'accountType',
    'ajs-sdPluginVersion': 'sdPluginVersion',
    'ajs-context-path': 'contextPath',
    environment: 'environment',
    'tenant-id': 'tenantId',
    'activation-id': 'activationId',
    'help-center-ari': 'helpCenterARI',
    'home-page-layout-ari': 'homePageLayoutARI'
};
const $89a90dfb163b8ebe$export$929b5cc2a4ac0922 = ()=>{
    const metaData = {};
    Object.entries($89a90dfb163b8ebe$var$requiredMetaTags).forEach(([key, name])=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        metaData[name] = $89a90dfb163b8ebe$export$c47913ca32a5c6f7(key);
    });
    return Object.freeze(metaData);
};
function $89a90dfb163b8ebe$export$5a64793485e318f6(name) {
    const metaElement = (0, $1CB66.default).querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}
function $89a90dfb163b8ebe$export$c47913ca32a5c6f7(name) {
    return $89a90dfb163b8ebe$export$5a64793485e318f6(name);
}
const $89a90dfb163b8ebe$export$11f8d00783d7fcf3 = (name, value)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let node = document.querySelector(`meta[name="${name}"]`);
    if (!node) {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        node = document.createElement('meta');
        node.setAttribute('name', name);
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.head.appendChild(node);
    }
    node.setAttribute('content', value);
};
const $89a90dfb163b8ebe$export$fdd2c0ba94025c3c = ()=>{
    return $89a90dfb163b8ebe$export$c47913ca32a5c6f7('tenant-id') || '';
};
const $89a90dfb163b8ebe$export$3ad4bb31a1816ff6 = ()=>$89a90dfb163b8ebe$export$c47913ca32a5c6f7('activation-id') ?? '';
const $89a90dfb163b8ebe$export$5b6c1ffe6316b179 = ()=>{
    return $89a90dfb163b8ebe$export$c47913ca32a5c6f7('help-center-ari') || '';
};
const $89a90dfb163b8ebe$export$8e2de40963827c80 = ()=>{
    return $89a90dfb163b8ebe$export$c47913ca32a5c6f7('jira-workspace-ari') || '';
};
const $89a90dfb163b8ebe$export$b6b5277467022679 = ()=>{
    return $89a90dfb163b8ebe$export$c47913ca32a5c6f7('home-page-layout-ari') || '';
};
const $89a90dfb163b8ebe$export$7a9c037572667aa1 = ()=>{
    const layoutAri = $89a90dfb163b8ebe$export$b6b5277467022679();
    return layoutAri !== '' && layoutAri !== 'null';
};
const $89a90dfb163b8ebe$export$9e7e16a3dbced495 = (name, value)=>{
    var _document$head;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const existingMetaTag = document.querySelector(`meta[name="${name}"]`);
    if ((existingMetaTag === null || existingMetaTag === void 0 ? void 0 : existingMetaTag.getAttribute('content')) === value) return;
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const metaTag = existingMetaTag || document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', value);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (_document$head = document.head) === null || _document$head === void 0 || _document$head.insertBefore(metaTag, document.head.childNodes[0]);
};

});
parcelRegister("1CB66", function(module, exports) {
$parcel$export(module.exports, "default", () => $382956e3ee725067$export$2e2bcd8739ae039);
class $382956e3ee725067$export$6e283cdda5461374 {
    constructor(){
        this.store = {
            elements: {}
        };
        this.parsedHTML = null;
    }
    startup(parsedHTML) {
        this.parsedHTML = parsedHTML;
    }
    isRunningInSnapvmRuntime() {
        return typeof window === 'undefined';
    }
    getDataRef() {
        if (this.isRunningInSnapvmRuntime()) return this.parsedHTML;
        // Set to document when not in SnapVM runtime (Classic and Client side render cases)
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        return document;
    }
    getElementById(elementId) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementById(elementId);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementById');
        return null;
    }
    querySelector(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelector(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelector');
        return null;
    }
    querySelectorAll(selector) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.querySelectorAll(selector);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in querySelectorAll');
        return [];
    }
    getElementsByTagName(tagName) {
        const documentRef = this.getDataRef();
        if (documentRef) return documentRef.getElementsByTagName(tagName);
        // oxlint-disable-next-line no-console
        console.warn('documentRef is null in getElementsByTagName');
        return [];
    }
    addClassName(elementName, className) {
        if (this.isRunningInSnapvmRuntime()) {
            if (!this.store.elements[elementName]) this.store.elements[elementName] = {
                classList: []
            };
            this.store.elements[elementName].classList.push(className);
            return;
        }
        if (elementName === 'body') {
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            document.body.classList.add(className);
            return;
        }
        // oxlint-disable-next-line no-console
        console.warn('invalid elementName sent to addClassName. elementName: ', elementName);
    }
    getStore() {
        return this.store;
    }
}
const $382956e3ee725067$var$clientServerBridge = new $382956e3ee725067$export$6e283cdda5461374();
var $382956e3ee725067$export$2e2bcd8739ae039 = $382956e3ee725067$var$clientServerBridge;

});


parcelRegister("dvfsR", function(module, exports) {
$parcel$export(module.exports, "startLighthouseObserver", () => $0c5423a6539c1a1d$export$5ecf2aafafee3e0);
$parcel$export(module.exports, "getLighthouseMetrics", () => $0c5423a6539c1a1d$export$b46cecdf698e4bb5);

var $eXUUC = parcelRequire("eXUUC");

var $6I5KV = parcelRequire("6I5KV");

var $7VLBq = parcelRequire("7VLBq");

var $l4RMg = parcelRequire("l4RMg");

var $tuvsX = parcelRequire("tuvsX");
function $0c5423a6539c1a1d$export$5ecf2aafafee3e0() {
    (0, $tuvsX.startLSObserver)();
    (0, $tuvsX.startLTObserver)();
}
function $0c5423a6539c1a1d$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $7VLBq.getTBT)(start, stop, (0, $l4RMg.EntriesBuffer)[(0, $6I5KV.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $eXUUC.getCLS)(start, stop, (0, $l4RMg.EntriesBuffer)[(0, $6I5KV.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}

});
parcelRegister("eXUUC", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $d07bd716fb91438a$export$fc6227831ee7c7);

var $3H4LK = parcelRequire("3H4LK");
function $d07bd716fb91438a$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $d07bd716fb91438a$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $3H4LK.fg)('platform_ufo_filter_cls_logs_same_rects_positions')) {
            var _entry$sources;
            const allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(({ previousRect: previousRect, currentRect: currentRect })=>$d07bd716fb91438a$var$isSameRects(previousRect, currentRect));
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("6I5KV", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $dcefc6cd09a94af4$export$a4def92db6fc8e17);
const $dcefc6cd09a94af4$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("7VLBq", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $59279cedc5525854$export$2d6e933b35bd3407);
const $59279cedc5525854$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $59279cedc5525854$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $59279cedc5525854$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $59279cedc5525854$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $59279cedc5525854$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("l4RMg", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $fd3a46886a44a9e5$export$f7dc16cbd16f7bbe);

var $6I5KV = parcelRequire("6I5KV");
class $fd3a46886a44a9e5$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $fd3a46886a44a9e5$export$f7dc16cbd16f7bbe = {
    [(0, $6I5KV.PerformanceObserverEntryTypes).LongTask]: new $fd3a46886a44a9e5$export$2c6e86519c9e8188(),
    [(0, $6I5KV.PerformanceObserverEntryTypes).LayoutShift]: new $fd3a46886a44a9e5$export$2c6e86519c9e8188()
};

});

parcelRegister("tuvsX", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $47680077ce4b0046$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $47680077ce4b0046$export$54fb8b6aaf70ec9c);

var $6I5KV = parcelRequire("6I5KV");

var $l4RMg = parcelRequire("l4RMg");
let $47680077ce4b0046$var$pe = null;
function $47680077ce4b0046$var$getObserver() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($47680077ce4b0046$var$pe !== null) return $47680077ce4b0046$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $6I5KV.PerformanceObserverEntryTypes).LayoutShift) (0, $l4RMg.EntriesBuffer)[(0, $6I5KV.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $6I5KV.PerformanceObserverEntryTypes).LongTask) (0, $l4RMg.EntriesBuffer)[(0, $6I5KV.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $47680077ce4b0046$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $47680077ce4b0046$var$pe;
}
function $47680077ce4b0046$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = $47680077ce4b0046$var$getObserver()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $6I5KV.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $47680077ce4b0046$export$54fb8b6aaf70ec9c() {
    var _getObserver2;
    (_getObserver2 = $47680077ce4b0046$var$getObserver()) === null || _getObserver2 === void 0 || _getObserver2.observe({
        type: (0, $6I5KV.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("2udYR", function(module, exports) {
$parcel$export(module.exports, "createPressureStateReport", () => $8541dcb384b61a54$export$1f0ff35da084986e);
$parcel$export(module.exports, "createMemoryStateReport", () => $8541dcb384b61a54$export$3b47ebb9832b4e24);
$parcel$export(module.exports, "initialisePressureObserver", () => $8541dcb384b61a54$export$117ebc554c6e9f2f);
$parcel$export(module.exports, "initialiseMemoryObserver", () => $8541dcb384b61a54$export$a3271f53e91faab7);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $8541dcb384b61a54$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $8541dcb384b61a54$var$pressureRecordBuffer = [];
let $8541dcb384b61a54$var$pressureObserver = null;
let $8541dcb384b61a54$var$memoryRecordBuffer = [];
let $8541dcb384b61a54$var$memoryInterval;
function $8541dcb384b61a54$export$6c1060bed5fea050() {
    $8541dcb384b61a54$var$pressureRecordBuffer.length = 0;
}
function $8541dcb384b61a54$export$aa672c7221b183b0() {
    $8541dcb384b61a54$var$memoryRecordBuffer.length = 0;
}
function $8541dcb384b61a54$export$ec86686c1d2e65bc(filter) {
    $8541dcb384b61a54$var$pressureRecordBuffer = $8541dcb384b61a54$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $8541dcb384b61a54$export$c0142ac82f5d0c28(filter) {
    $8541dcb384b61a54$var$memoryRecordBuffer = $8541dcb384b61a54$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $8541dcb384b61a54$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $8541dcb384b61a54$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $8541dcb384b61a54$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $8541dcb384b61a54$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $8541dcb384b61a54$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $8541dcb384b61a54$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $8541dcb384b61a54$var$convertBytesToMegabytes($8541dcb384b61a54$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $8541dcb384b61a54$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $8541dcb384b61a54$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $8541dcb384b61a54$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $8541dcb384b61a54$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $8541dcb384b61a54$var$pressureObserver = new PressureObserver((records)=>{
                if ($8541dcb384b61a54$var$pressureRecordBuffer.length + records.length <= $8541dcb384b61a54$var$BUFFER_MAX_LENGTH) $8541dcb384b61a54$var$pressureRecordBuffer.push(...records);
            });
            $8541dcb384b61a54$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $8541dcb384b61a54$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $8541dcb384b61a54$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($8541dcb384b61a54$var$memoryRecordBuffer.length <= $8541dcb384b61a54$var$BUFFER_MAX_LENGTH) $8541dcb384b61a54$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $8541dcb384b61a54$export$10899ada382f2ae3() {
    clearInterval($8541dcb384b61a54$var$memoryInterval);
}
function $8541dcb384b61a54$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $8541dcb384b61a54$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("gE3od", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7963958116ac52$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useInteractionContext", () => $cb7963958116ac52$export$11bcb6e9af2aca35);

var $4fqPo = parcelRequire("4fqPo");

var $9XaAY = parcelRequire("9XaAY");
var $cb7963958116ac52$export$2e2bcd8739ae039 = (0, $9XaAY.default);
function $cb7963958116ac52$export$11bcb6e9af2aca35() {
    return (0, $4fqPo.useContext)((0, $9XaAY.default));
}

});
parcelRegister("9XaAY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b67105eade9d4a0$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $4b67105eade9d4a0$var$interactionContext = (0, $4fqPo.createContext)(null);
var $4b67105eade9d4a0$export$2e2bcd8739ae039 = $4b67105eade9d4a0$var$interactionContext;

});


parcelRegister("eFsN4", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ef8a00eb90de789$export$2e2bcd8739ae039);
// The UFORouteName object is a global singleton
const $9ef8a00eb90de789$var$UFORouteName = {
    current: null
};
var $9ef8a00eb90de789$export$2e2bcd8739ae039 = $9ef8a00eb90de789$var$UFORouteName;

});

parcelRegister("9VBt1", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $73a6801a2da536a4$export$c4744153514ff05d, (v) => $73a6801a2da536a4$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $73a6801a2da536a4$export$3e506c1ccc9cc1a7, (v) => $73a6801a2da536a4$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $73a6801a2da536a4$export$e26fe2ed2fa76875, (v) => $73a6801a2da536a4$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $73a6801a2da536a4$export$502329bbf4b505b1, (v) => $73a6801a2da536a4$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $73a6801a2da536a4$export$6e3807111c4874c4, (v) => $73a6801a2da536a4$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $73a6801a2da536a4$export$c27134553091fb3a, (v) => $73a6801a2da536a4$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $73a6801a2da536a4$export$33ee1acdc04fd2a2, (v) => $73a6801a2da536a4$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $73a6801a2da536a4$export$b00a404bbd5edef2, (v) => $73a6801a2da536a4$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $73a6801a2da536a4$export$8352ce38b91d0c62, (v) => $73a6801a2da536a4$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $73a6801a2da536a4$export$d66a1c1c77bd778b, (v) => $73a6801a2da536a4$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $73a6801a2da536a4$export$d3dfb8e4810cb555, (v) => $73a6801a2da536a4$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $73a6801a2da536a4$export$839f9183b0465a69, (v) => $73a6801a2da536a4$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $73a6801a2da536a4$export$72fdf0e06517287b, (v) => $73a6801a2da536a4$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $73a6801a2da536a4$export$4b844e58a3e414b4, (v) => $73a6801a2da536a4$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $73a6801a2da536a4$export$816d2913ae6b83b1, (v) => $73a6801a2da536a4$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $73a6801a2da536a4$export$61bcfe829111a1d0, (v) => $73a6801a2da536a4$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $73a6801a2da536a4$export$7ee8c9beb337bc3f, (v) => $73a6801a2da536a4$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $73a6801a2da536a4$export$b5836b71941fa3ed, (v) => $73a6801a2da536a4$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $73a6801a2da536a4$export$cf845f2c119da08a, (v) => $73a6801a2da536a4$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $73a6801a2da536a4$export$c4744153514ff05d;
var $73a6801a2da536a4$export$3e506c1ccc9cc1a7;
var $73a6801a2da536a4$export$e26fe2ed2fa76875;
var $73a6801a2da536a4$export$502329bbf4b505b1;
var $73a6801a2da536a4$export$6e3807111c4874c4;
var $73a6801a2da536a4$export$c27134553091fb3a;
var $73a6801a2da536a4$export$33ee1acdc04fd2a2;
var $73a6801a2da536a4$export$b00a404bbd5edef2;
var $73a6801a2da536a4$export$8352ce38b91d0c62;
var $73a6801a2da536a4$export$d66a1c1c77bd778b;
var $73a6801a2da536a4$export$d3dfb8e4810cb555;
var $73a6801a2da536a4$export$839f9183b0465a69;
var $73a6801a2da536a4$export$72fdf0e06517287b;
var $73a6801a2da536a4$export$4b844e58a3e414b4;
var $73a6801a2da536a4$export$816d2913ae6b83b1;
var $73a6801a2da536a4$export$61bcfe829111a1d0;
var $73a6801a2da536a4$export$7ee8c9beb337bc3f;
var $73a6801a2da536a4$export$b5836b71941fa3ed;
var $73a6801a2da536a4$export$cf845f2c119da08a;
'use strict';
function $73a6801a2da536a4$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $73a6801a2da536a4$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $73a6801a2da536a4$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $73a6801a2da536a4$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $73a6801a2da536a4$var$g(C, c)) n < e && 0 > $73a6801a2da536a4$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $73a6801a2da536a4$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $73a6801a2da536a4$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $73a6801a2da536a4$var$l = performance;
    $73a6801a2da536a4$export$c4744153514ff05d = function() {
        return $73a6801a2da536a4$var$l.now();
    };
} else {
    var $73a6801a2da536a4$var$p = Date, $73a6801a2da536a4$var$q = $73a6801a2da536a4$var$p.now();
    $73a6801a2da536a4$export$c4744153514ff05d = function() {
        return $73a6801a2da536a4$var$p.now() - $73a6801a2da536a4$var$q;
    };
}
var $73a6801a2da536a4$var$r = [], $73a6801a2da536a4$var$t = [], $73a6801a2da536a4$var$u = 1, $73a6801a2da536a4$var$v = null, $73a6801a2da536a4$var$y = 3, $73a6801a2da536a4$var$z = !1, $73a6801a2da536a4$var$A = !1, $73a6801a2da536a4$var$B = !1, $73a6801a2da536a4$var$D = "function" === typeof setTimeout ? setTimeout : null, $73a6801a2da536a4$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $73a6801a2da536a4$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $73a6801a2da536a4$var$G(a) {
    for(var b = $73a6801a2da536a4$var$h($73a6801a2da536a4$var$t); null !== b;){
        if (null === b.callback) $73a6801a2da536a4$var$k($73a6801a2da536a4$var$t);
        else if (b.startTime <= a) $73a6801a2da536a4$var$k($73a6801a2da536a4$var$t), b.sortIndex = b.expirationTime, $73a6801a2da536a4$var$f($73a6801a2da536a4$var$r, b);
        else break;
        b = $73a6801a2da536a4$var$h($73a6801a2da536a4$var$t);
    }
}
function $73a6801a2da536a4$var$H(a) {
    $73a6801a2da536a4$var$B = !1;
    $73a6801a2da536a4$var$G(a);
    if (!$73a6801a2da536a4$var$A) {
        if (null !== $73a6801a2da536a4$var$h($73a6801a2da536a4$var$r)) $73a6801a2da536a4$var$A = !0, $73a6801a2da536a4$var$I($73a6801a2da536a4$var$J);
        else {
            var b = $73a6801a2da536a4$var$h($73a6801a2da536a4$var$t);
            null !== b && $73a6801a2da536a4$var$K($73a6801a2da536a4$var$H, b.startTime - a);
        }
    }
}
function $73a6801a2da536a4$var$J(a, b) {
    $73a6801a2da536a4$var$A = !1;
    $73a6801a2da536a4$var$B && ($73a6801a2da536a4$var$B = !1, $73a6801a2da536a4$var$E($73a6801a2da536a4$var$L), $73a6801a2da536a4$var$L = -1);
    $73a6801a2da536a4$var$z = !0;
    var c = $73a6801a2da536a4$var$y;
    try {
        $73a6801a2da536a4$var$G(b);
        for($73a6801a2da536a4$var$v = $73a6801a2da536a4$var$h($73a6801a2da536a4$var$r); null !== $73a6801a2da536a4$var$v && (!($73a6801a2da536a4$var$v.expirationTime > b) || a && !$73a6801a2da536a4$var$M());){
            var d = $73a6801a2da536a4$var$v.callback;
            if ("function" === typeof d) {
                $73a6801a2da536a4$var$v.callback = null;
                $73a6801a2da536a4$var$y = $73a6801a2da536a4$var$v.priorityLevel;
                var e = d($73a6801a2da536a4$var$v.expirationTime <= b);
                b = $73a6801a2da536a4$export$c4744153514ff05d();
                "function" === typeof e ? $73a6801a2da536a4$var$v.callback = e : $73a6801a2da536a4$var$v === $73a6801a2da536a4$var$h($73a6801a2da536a4$var$r) && $73a6801a2da536a4$var$k($73a6801a2da536a4$var$r);
                $73a6801a2da536a4$var$G(b);
            } else $73a6801a2da536a4$var$k($73a6801a2da536a4$var$r);
            $73a6801a2da536a4$var$v = $73a6801a2da536a4$var$h($73a6801a2da536a4$var$r);
        }
        if (null !== $73a6801a2da536a4$var$v) var w = !0;
        else {
            var m = $73a6801a2da536a4$var$h($73a6801a2da536a4$var$t);
            null !== m && $73a6801a2da536a4$var$K($73a6801a2da536a4$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $73a6801a2da536a4$var$v = null, $73a6801a2da536a4$var$y = c, $73a6801a2da536a4$var$z = !1;
    }
}
var $73a6801a2da536a4$var$N = !1, $73a6801a2da536a4$var$O = null, $73a6801a2da536a4$var$L = -1, $73a6801a2da536a4$var$P = 5, $73a6801a2da536a4$var$Q = -1;
function $73a6801a2da536a4$var$M() {
    return $73a6801a2da536a4$export$c4744153514ff05d() - $73a6801a2da536a4$var$Q < $73a6801a2da536a4$var$P ? !1 : !0;
}
function $73a6801a2da536a4$var$R() {
    if (null !== $73a6801a2da536a4$var$O) {
        var a = $73a6801a2da536a4$export$c4744153514ff05d();
        $73a6801a2da536a4$var$Q = a;
        var b = !0;
        try {
            b = $73a6801a2da536a4$var$O(!0, a);
        } finally{
            b ? $73a6801a2da536a4$var$S() : ($73a6801a2da536a4$var$N = !1, $73a6801a2da536a4$var$O = null);
        }
    } else $73a6801a2da536a4$var$N = !1;
}
var $73a6801a2da536a4$var$S;
if ("function" === typeof $73a6801a2da536a4$var$F) $73a6801a2da536a4$var$S = function() {
    $73a6801a2da536a4$var$F($73a6801a2da536a4$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $73a6801a2da536a4$var$T = new MessageChannel, $73a6801a2da536a4$var$U = $73a6801a2da536a4$var$T.port2;
    $73a6801a2da536a4$var$T.port1.onmessage = $73a6801a2da536a4$var$R;
    $73a6801a2da536a4$var$S = function() {
        $73a6801a2da536a4$var$U.postMessage(null);
    };
} else $73a6801a2da536a4$var$S = function() {
    $73a6801a2da536a4$var$D($73a6801a2da536a4$var$R, 0);
};
function $73a6801a2da536a4$var$I(a) {
    $73a6801a2da536a4$var$O = a;
    $73a6801a2da536a4$var$N || ($73a6801a2da536a4$var$N = !0, $73a6801a2da536a4$var$S());
}
function $73a6801a2da536a4$var$K(a, b) {
    $73a6801a2da536a4$var$L = $73a6801a2da536a4$var$D(function() {
        a($73a6801a2da536a4$export$c4744153514ff05d());
    }, b);
}
$73a6801a2da536a4$export$3e506c1ccc9cc1a7 = 5;
$73a6801a2da536a4$export$e26fe2ed2fa76875 = 1;
$73a6801a2da536a4$export$502329bbf4b505b1 = 4;
$73a6801a2da536a4$export$6e3807111c4874c4 = 3;
$73a6801a2da536a4$export$c27134553091fb3a = null;
$73a6801a2da536a4$export$33ee1acdc04fd2a2 = 2;
$73a6801a2da536a4$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$73a6801a2da536a4$export$8352ce38b91d0c62 = function() {
    $73a6801a2da536a4$var$A || $73a6801a2da536a4$var$z || ($73a6801a2da536a4$var$A = !0, $73a6801a2da536a4$var$I($73a6801a2da536a4$var$J));
};
$73a6801a2da536a4$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $73a6801a2da536a4$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$73a6801a2da536a4$export$d3dfb8e4810cb555 = function() {
    return $73a6801a2da536a4$var$y;
};
$73a6801a2da536a4$export$839f9183b0465a69 = function() {
    return $73a6801a2da536a4$var$h($73a6801a2da536a4$var$r);
};
$73a6801a2da536a4$export$72fdf0e06517287b = function(a) {
    switch($73a6801a2da536a4$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $73a6801a2da536a4$var$y;
    }
    var c = $73a6801a2da536a4$var$y;
    $73a6801a2da536a4$var$y = b;
    try {
        return a();
    } finally{
        $73a6801a2da536a4$var$y = c;
    }
};
$73a6801a2da536a4$export$4b844e58a3e414b4 = function() {};
$73a6801a2da536a4$export$816d2913ae6b83b1 = function() {};
$73a6801a2da536a4$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $73a6801a2da536a4$var$y;
    $73a6801a2da536a4$var$y = a;
    try {
        return b();
    } finally{
        $73a6801a2da536a4$var$y = c;
    }
};
$73a6801a2da536a4$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $73a6801a2da536a4$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $73a6801a2da536a4$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $73a6801a2da536a4$var$f($73a6801a2da536a4$var$t, a), null === $73a6801a2da536a4$var$h($73a6801a2da536a4$var$r) && a === $73a6801a2da536a4$var$h($73a6801a2da536a4$var$t) && ($73a6801a2da536a4$var$B ? ($73a6801a2da536a4$var$E($73a6801a2da536a4$var$L), $73a6801a2da536a4$var$L = -1) : $73a6801a2da536a4$var$B = !0, $73a6801a2da536a4$var$K($73a6801a2da536a4$var$H, c - d))) : (a.sortIndex = e, $73a6801a2da536a4$var$f($73a6801a2da536a4$var$r, a), $73a6801a2da536a4$var$A || $73a6801a2da536a4$var$z || ($73a6801a2da536a4$var$A = !0, $73a6801a2da536a4$var$I($73a6801a2da536a4$var$J)));
    return a;
};
$73a6801a2da536a4$export$b5836b71941fa3ed = $73a6801a2da536a4$var$M;
$73a6801a2da536a4$export$cf845f2c119da08a = function(a) {
    var b = $73a6801a2da536a4$var$y;
    return function() {
        var c = $73a6801a2da536a4$var$y;
        $73a6801a2da536a4$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $73a6801a2da536a4$var$y = c;
        }
    };
};

});

parcelRegister("3yJoB", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bE3AB").then(()=>parcelRequire('h8Sny'));

});
parcelRegister("e46AW", function(module, exports) {
"use strict";

function $a3d68dff7e3bb355$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("evuSz")).resolve(id));
}
module.exports = $a3d68dff7e3bb355$var$load;

});
parcelRegister("evuSz", function(module, exports) {
$parcel$export(module.exports, "register", () => $a8fbe9e15ffade8c$export$6503ec6e8aabbaf, (v) => $a8fbe9e15ffade8c$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $a8fbe9e15ffade8c$export$f7ad0328861e2f03, (v) => $a8fbe9e15ffade8c$export$f7ad0328861e2f03 = v);
var $a8fbe9e15ffade8c$export$6503ec6e8aabbaf;
var $a8fbe9e15ffade8c$export$f7ad0328861e2f03;
"use strict";
var $a8fbe9e15ffade8c$var$mapping = new Map();
function $a8fbe9e15ffade8c$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a8fbe9e15ffade8c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a8fbe9e15ffade8c$var$resolve(id) {
    var resolved = $a8fbe9e15ffade8c$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a8fbe9e15ffade8c$export$6503ec6e8aabbaf = $a8fbe9e15ffade8c$var$register;
$a8fbe9e15ffade8c$export$f7ad0328861e2f03 = $a8fbe9e15ffade8c$var$resolve;

});



parcelRegister("dcniM", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("c4tXq").then(()=>parcelRequire('3jT8d'));

});

parcelRegister("iDJRy", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("eIpGK").then(()=>parcelRequire('dZydc'));

});

parcelRegister("36c4E", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bt6QL").then(()=>parcelRequire('frl17'));

});

parcelRegister("bW6Qo", function(module, exports) {
$parcel$export(module.exports, "configure", () => $799a046cf11897ff$export$8d21e34596265fa2);
$parcel$export(module.exports, "getConfig", () => $799a046cf11897ff$export$44487a86467333c3);

var $jFknK = parcelRequire("jFknK");
const $799a046cf11897ff$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $799a046cf11897ff$var$getAllowedParams() {
    const config = (0, $jFknK.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $799a046cf11897ff$var$defaultAllowedParams;
}
function $799a046cf11897ff$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $799a046cf11897ff$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $799a046cf11897ff$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $799a046cf11897ff$var$handleQueryParams(url);
    }
};
function $799a046cf11897ff$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $799a046cf11897ff$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $799a046cf11897ff$var$config = newConfig;
}
function $799a046cf11897ff$export$44487a86467333c3() {
    return $799a046cf11897ff$var$config;
}

});

parcelRegister("4o3R3", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $4dbbbcb142e097ee$export$bea963256235a63e);
$parcel$export(module.exports, "filterResourceTimings", () => $4dbbbcb142e097ee$export$4138a729ef1db028);

var $j0l14 = parcelRequire("j0l14");
const $4dbbbcb142e097ee$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $4dbbbcb142e097ee$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $4dbbbcb142e097ee$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        const duration = (0, $j0l14.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find((timing)=>timing.name === 'atl-edge')) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi'));
        const serverTime = totalBackendTimeEntry ? (0, $j0l14.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $j0l14.roundEpsilon)(entry.startTime),
            duration: (0, $j0l14.roundEpsilon)(entry.duration),
            fetchStart: (0, $j0l14.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $j0l14.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $j0l14.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $j0l14.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $j0l14.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $j0l14.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        var _performance$getEntri;
        const performance = $4dbbbcb142e097ee$var$getPerformanceObject();
        const PerformanceObserver = $4dbbbcb142e097ee$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($4dbbbcb142e097ee$export$bea963256235a63e.observer) return;
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $4dbbbcb142e097ee$export$bea963256235a63e.timings = resources.map((resource)=>$4dbbbcb142e097ee$export$bea963256235a63e.transformResource(resource));
        $4dbbbcb142e097ee$export$bea963256235a63e.observer = new PerformanceObserver($4dbbbcb142e097ee$export$bea963256235a63e.addTimings);
        $4dbbbcb142e097ee$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($4dbbbcb142e097ee$export$bea963256235a63e.observer) {
            $4dbbbcb142e097ee$export$bea963256235a63e.observer.disconnect();
            $4dbbbcb142e097ee$export$bea963256235a63e.observer = null;
        }
        $4dbbbcb142e097ee$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$4dbbbcb142e097ee$export$bea963256235a63e.transformResource(entry));
        const overflow = $4dbbbcb142e097ee$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $4dbbbcb142e097ee$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $4dbbbcb142e097ee$export$bea963256235a63e.maxSize;
            $4dbbbcb142e097ee$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $4dbbbcb142e097ee$export$bea963256235a63e.timings.push(...entries);
    }
};
function $4dbbbcb142e097ee$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $4dbbbcb142e097ee$export$4138a729ef1db028(startTime, endTime) {
    const performance = $4dbbbcb142e097ee$var$getPerformanceObject();
    const PerformanceObserver = $4dbbbcb142e097ee$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$4dbbbcb142e097ee$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$4dbbbcb142e097ee$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $4dbbbcb142e097ee$export$bea963256235a63e.timings.filter((timing)=>$4dbbbcb142e097ee$var$isValidTiming(timing, startTime, endTime));
}

});
parcelRegister("j0l14", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", () => $cb5dcefb7fd242e1$export$56014375de40214b);
function $cb5dcefb7fd242e1$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("gYF1N", function(module, exports) {
$parcel$export(module.exports, "configure", () => $58d3414f1653e0e1$export$8d21e34596265fa2);
$parcel$export(module.exports, "getSSRTimings", () => $58d3414f1653e0e1$export$bf7408e83532dcd0);
$parcel$export(module.exports, "getSSRSuccess", () => $58d3414f1653e0e1$export$c7ad864055e75537);
$parcel$export(module.exports, "getSSRPhaseSuccess", () => $58d3414f1653e0e1$export$5eade9354185583d);
$parcel$export(module.exports, "getSSRDoneTime", () => $58d3414f1653e0e1$export$3def7672244bab0c);
$parcel$export(module.exports, "getSSRFeatureFlags", () => $58d3414f1653e0e1$export$1c4a9b5e6e22393d);
const $58d3414f1653e0e1$var$NESTED_METRIC_SEPARATOR = '/';
function $58d3414f1653e0e1$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $58d3414f1653e0e1$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $58d3414f1653e0e1$var$SSR_PREFIX = 'ssr';
function $58d3414f1653e0e1$var$mapKey(key) {
    if (key === 'total') return $58d3414f1653e0e1$var$SSR_PREFIX;
    return `${$58d3414f1653e0e1$var$SSR_PREFIX}${$58d3414f1653e0e1$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $58d3414f1653e0e1$var$config;
function $58d3414f1653e0e1$export$8d21e34596265fa2(ssrConfig) {
    $58d3414f1653e0e1$var$config = ssrConfig;
}
function $58d3414f1653e0e1$var$getPerformanceNavigationTiming() {
    var _performance$getEntri;
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (_performance$getEntri = performance.getEntriesByType('navigation')) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri[0];
}
function $58d3414f1653e0e1$var$getServerTimingsByName() {
    var _getPerformanceNaviga;
    const serverTimingsByName = Object.fromEntries(((_getPerformanceNaviga = $58d3414f1653e0e1$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga === void 0 || (_getPerformanceNaviga = _getPerformanceNaviga.serverTiming) === null || _getPerformanceNaviga === void 0 ? void 0 : _getPerformanceNaviga.map((timing)=>[
            timing.name,
            timing
        ])) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $58d3414f1653e0e1$var$getEdgeOffset(edgeTtfb) {
    var _getPerformanceNaviga2;
    const clientTtfb = (_getPerformanceNaviga2 = $58d3414f1653e0e1$var$getPerformanceNavigationTiming()) === null || _getPerformanceNaviga2 === void 0 ? void 0 : _getPerformanceNaviga2.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $58d3414f1653e0e1$export$5300d1b82e594615() {
    var _serverTimingsByName$, _serverTimingsByName$2, _serverTimingsByName$3, _serverTimingsByName$4, _serverTimingsByName$5, _serverTimingsByName$6, _serverTimingsByName$7, _serverTimingsByName$8;
    const serverTimingsByName = $58d3414f1653e0e1$var$getServerTimingsByName();
    const edgeTotalDuration = ((_serverTimingsByName$ = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$ === void 0 ? void 0 : _serverTimingsByName$.duration) ?? ((_serverTimingsByName$2 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$2 === void 0 ? void 0 : _serverTimingsByName$2.duration);
    if (!edgeTotalDuration) return null;
    const edgeOffset = $58d3414f1653e0e1$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (((_serverTimingsByName$3 = serverTimingsByName['cdn-upstream-dns']) === null || _serverTimingsByName$3 === void 0 ? void 0 : _serverTimingsByName$3.duration) || 0) + (((_serverTimingsByName$4 = serverTimingsByName['cdn-upstream-connect']) === null || _serverTimingsByName$4 === void 0 ? void 0 : _serverTimingsByName$4.duration) || 0);
    const cfUpstreamDuration = (((_serverTimingsByName$5 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$5 === void 0 ? void 0 : _serverTimingsByName$5.duration) || 0) - cfInternalDuration;
    const cfDownstreamDuration = (((_serverTimingsByName$6 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$6 === void 0 ? void 0 : _serverTimingsByName$6.duration) || 0) - (((_serverTimingsByName$7 = serverTimingsByName['cdn-upstream-fbl']) === null || _serverTimingsByName$7 === void 0 ? void 0 : _serverTimingsByName$7.duration) || 0);
    const atlEdgeDuration = (_serverTimingsByName$8 = serverTimingsByName['atl-edge']) === null || _serverTimingsByName$8 === void 0 ? void 0 : _serverTimingsByName$8.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        var _serverTimingsByName$9;
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: (_serverTimingsByName$9 = serverTimingsByName['cdn-downstream-fbl']) === null || _serverTimingsByName$9 === void 0 ? void 0 : _serverTimingsByName$9.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        var _serverTimingsByName$0;
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: (_serverTimingsByName$0 = serverTimingsByName['atl-edge-internal']) === null || _serverTimingsByName$0 === void 0 ? void 0 : _serverTimingsByName$0.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    (edgeTimings === null || edgeTimings === void 0 ? void 0 : edgeTimings.edge) && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $58d3414f1653e0e1$export$bf7408e83532dcd0() {
    var _config;
    const defaultSSRTimings = $58d3414f1653e0e1$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof ((_config = $58d3414f1653e0e1$var$config) === null || _config === void 0 ? void 0 : _config.getTimings) === 'function') configTimings = $58d3414f1653e0e1$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($58d3414f1653e0e1$var$filterEntry(entry[1])) acc[$58d3414f1653e0e1$var$mapKey(entry[0])] = $58d3414f1653e0e1$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $58d3414f1653e0e1$export$c7ad864055e75537() {
    var _config2;
    return !!((_config2 = $58d3414f1653e0e1$var$config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
function $58d3414f1653e0e1$export$5eade9354185583d() {
    var _config3, _config3$getSsrPhaseS;
    return (_config3 = $58d3414f1653e0e1$var$config) === null || _config3 === void 0 || (_config3$getSsrPhaseS = _config3.getSsrPhaseSuccess) === null || _config3$getSsrPhaseS === void 0 ? void 0 : _config3$getSsrPhaseS.call(_config3);
}
function $58d3414f1653e0e1$export$3def7672244bab0c() {
    var _config4;
    return ((_config4 = $58d3414f1653e0e1$var$config) === null || _config4 === void 0 ? void 0 : _config4.getDoneMark()) ?? undefined;
}
function $58d3414f1653e0e1$export$1c4a9b5e6e22393d() {
    var _config5;
    if (!((_config5 = $58d3414f1653e0e1$var$config) !== null && _config5 !== void 0 && _config5.getFeatureFlags)) return undefined;
    try {
        return $58d3414f1653e0e1$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}

});

parcelRegister("ebpTf", function(module, exports) {
$parcel$export(module.exports, "EnvType", () => $b39688ea656a27a4$export$76f4b1ef26f59baf);
$parcel$export(module.exports, "getEnv", () => $b39688ea656a27a4$export$4bd44a2aa29d3d6e);
$parcel$export(module.exports, "getIsPageServerSideRendered", () => $b39688ea656a27a4$export$11bdeb36ea0511ca);
$parcel$export(module.exports, "getIsMultiHCEnabled", () => $b39688ea656a27a4$export$ae0e930c2df55631);
$parcel$export(module.exports, "getIsHCCustomizationEnabled", () => $b39688ea656a27a4$export$efe1682951193de4);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $b39688ea656a27a4$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $b39688ea656a27a4$export$9679fa5312e1354b);
$parcel$export(module.exports, "getHoistedProjectKey", () => $b39688ea656a27a4$export$3b0fd0e16a94f75);

var $1CB66 = parcelRequire("1CB66");

var $6mmHn = parcelRequire("6mmHn");
var $b39688ea656a27a4$export$76f4b1ef26f59baf = /*#__PURE__*/ function(EnvType) {
    EnvType["LOCAL"] = "local";
    EnvType["DEV"] = "dev";
    EnvType["STAGING"] = "staging";
    EnvType["PROD"] = "prod";
    return EnvType;
}({});
function $b39688ea656a27a4$var$parseEnvironment() {
    const env = (0, $6mmHn.getMeta)('environment');
    if (env === 'prod') return "prod";
    if (env === 'staging') return "staging";
    return "dev";
}
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @typescript-eslint/no-unsafe-return
const $b39688ea656a27a4$var$parseJson = (content)=>content ? JSON.parse(content) : {};
const $b39688ea656a27a4$var$envElement = (0, $1CB66.default).getElementById('envJson');
let $b39688ea656a27a4$var$envData;
const $b39688ea656a27a4$export$4bd44a2aa29d3d6e = ()=>{
    if ($b39688ea656a27a4$var$envData) return $b39688ea656a27a4$var$envData;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $b39688ea656a27a4$var$envData = Object.freeze({
        ...$b39688ea656a27a4$var$parseJson($b39688ea656a27a4$var$envElement && $b39688ea656a27a4$var$envElement.textContent),
        environment: $b39688ea656a27a4$var$parseEnvironment()
    });
    return $b39688ea656a27a4$var$envData;
};
const $b39688ea656a27a4$export$11bdeb36ea0511ca = ()=>{
    // @ts-ignore - TS2339: Property '__IS_PAGE_SERVER_SIDE_RENDERED__' does not exist on type 'Window & typeof globalThis'.
    // This was added when adding project references to help center.
    return window.__IS_PAGE_SERVER_SIDE_RENDERED__;
};
const $b39688ea656a27a4$export$ae0e930c2df55631 = ()=>{
    var _getEnv$featuredValue;
    return (_getEnv$featuredValue = $b39688ea656a27a4$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue === void 0 ? void 0 : _getEnv$featuredValue.multiHelpCenterEnabled;
};
const $b39688ea656a27a4$export$efe1682951193de4 = ()=>{
    var _getEnv$featuredValue2;
    return (_getEnv$featuredValue2 = $b39688ea656a27a4$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue2 === void 0 ? void 0 : _getEnv$featuredValue2.helpCenterCustomizationEnabled;
};
const $b39688ea656a27a4$export$a90992f5204fc247 = ()=>{
    var _getEnv$featuredValue3;
    return ((_getEnv$featuredValue3 = $b39688ea656a27a4$export$4bd44a2aa29d3d6e().featuredValues) === null || _getEnv$featuredValue3 === void 0 ? void 0 : _getEnv$featuredValue3.jsmAiConfigEnabled) ?? false;
};
const $b39688ea656a27a4$export$9679fa5312e1354b = ()=>{
    return $b39688ea656a27a4$export$4bd44a2aa29d3d6e().jiraDisplayUrl;
};
const $b39688ea656a27a4$export$3b0fd0e16a94f75 = ()=>{
    return $b39688ea656a27a4$export$4bd44a2aa29d3d6e().hoistedProjectKey;
};
const $b39688ea656a27a4$export$e567920edc63a849 = ()=>{
    return $b39688ea656a27a4$export$4bd44a2aa29d3d6e().relativeBaseUrl;
};

});

parcelRegister("fJQMR", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $3194d26274471849$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "updateUserInfo", () => $3194d26274471849$export$c305be0ec5c00f16);
$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $3194d26274471849$export$799525ac94ca811d);

var $Idrdz = parcelRequire("Idrdz");
var $jgvOT = parcelRequire("jgvOT");

var $6mmHn = parcelRequire("6mmHn");

var $63sfu = parcelRequire("63sfu");

var $6bGmX = parcelRequire("6bGmX");

var $gHT3x = parcelRequire("gHT3x");
var $eeiwC = parcelRequire("eeiwC");

var $54jwS = parcelRequire("54jwS");

var $gPrbw = parcelRequire("gPrbw");

var $eSL4S = parcelRequire("eSL4S");

var $29xKq = parcelRequire("29xKq");

var $ebpTf = parcelRequire("ebpTf");

var $dlnz8 = parcelRequire("dlnz8");

var $aP0jL = parcelRequire("aP0jL");

/**
 * Feature flag: analytics_client_is_synthetic
 *
 * Enables passing the isSynthetic flag to analytics client to identify
 * synthetic/automated traffic in analytics data.
 */ const $3194d26274471849$var$ANALYTICS_CLIENT_IS_SYNTHETIC = 'analytics_client_is_synthetic';
const $3194d26274471849$var$isAnalyticsClientIsSyntheticEnabled = ()=>(0, $6bGmX.default).checkGate($3194d26274471849$var$ANALYTICS_CLIENT_IS_SYNTHETIC);
const $3194d26274471849$var$GAS_V3_ROUTE = 'gateway/api/gasv3/api/v1';
class $3194d26274471849$export$208d0eb1d9fc833e {
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, product: product, environment: environment, locale: locale, callback: callback, version: version, shouldTriggerUIViewed: shouldTriggerUIViewed = true }) {
        this.analyticsClient = new (0, $Idrdz.default)({
            product: product,
            locale: locale,
            env: environment,
            version: version || '1.0.0',
            origin: (0, $jgvOT.originType).WEB,
            ...(0, $gPrbw.isIsolatedCloud)() ? {
                ic: (0, $gPrbw.isolationContextId)()
            } : undefined
        }, {
            disableCookiePersistence: true,
            ...$3194d26274471849$var$isAnalyticsClientIsSyntheticEnabled() ? {
                isSynthetic: (0, $6mmHn.getMeta)('ajs-is-synthetic') === 'true'
            } : undefined,
            ...(0, $gPrbw.isIsolatedCloud)() ? {
                apiHost: `${window.location.hostname}/${$3194d26274471849$var$GAS_V3_ROUTE}`
            } : undefined
        });
        this.bootstrapEventPayloadOverride();
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $jgvOT.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $jgvOT.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, $63sfu.noop);
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        return true;
    }
    addCommonHelpCenterData(event) {
        if (typeof event === 'object') event.attributes = {
            ...event.attributes,
            ...(0, $aP0jL.getHelpCenterAnalyticsData)(),
            ...(0, $dlnz8.getApplicationType)()
        };
        return event;
    }
    bootstrapEventPayloadOverride() {
        const sendUIEvent = this.analyticsClient.sendUIEvent;
        const sendTrackEvent = this.analyticsClient.sendTrackEvent;
        const sendOperationalEvent = this.analyticsClient.sendOperationalEvent;
        const sendScreenEvent = this.analyticsClient.sendScreenEvent;
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendUIEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendUIEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendTrackEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendTrackEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendOperationalEvent = (event, callback)=>{
            this.addCommonHelpCenterData(event);
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendOperationalEvent.call(this.analyticsClient, event, callback);
        };
        //eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.analyticsClient.sendScreenEvent = (event, callback, attributes)=>{
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const existingAttrs = typeof attributes === 'object' ? attributes : {
                //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                value: attributes // non object vales are directly assigned as attributes accept `any`
            };
            //eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const updatedAttrs = {
                ...existingAttrs,
                ...(0, $aP0jL.getHelpCenterAnalyticsData)(),
                ...(0, $dlnz8.getApplicationType)()
            };
            //eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return sendScreenEvent.call(this.analyticsClient, event, callback, updatedAttrs);
        };
    }
    getDataFromEvent(event, channel) {
        if (channel === (0, $gHT3x.ANALYTICS_BRIDGE_CHANNEL)) return (0, $eeiwC.extractAWCDataFromEvent)(event);
        return (0, $54jwS.getEvent)(event);
    }
    sendEvent(event, channel) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { type: type, payload: payload } = this.getDataFromEvent(event, channel);
        try {
            switch(type){
                case 0, $54jwS.UI_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $54jwS.TRACK_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $54jwS.OPERATIONAL_EVENT_TYPE:
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $54jwS.SCREEN_EVENT_TYPE:
                    // Disabling existing violations, should be fixed when revisited.
                    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-floating-promises
                    this.analyticsClient.sendScreenEvent(payload.name, null, payload.attributes);
                    break;
                default:
                    (0, $29xKq.devLog)(`An event was blackholed because it was of an invalid analyticsType: ${// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                    event.payload.analyticsType}.\nMake sure analyticsType is specified in the event's payload and is one of ${[
                        (0, $54jwS.UI_EVENT_TYPE),
                        (0, $54jwS.TRACK_EVENT_TYPE),
                        (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                        (0, $54jwS.SCREEN_EVENT_TYPE)
                    ].join(', ')}.`);
            }
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('Failed to send analytic data. It may be malformed, or sessionStorage may be disabled.', err);
        }
    }
    getInstance() {
        return this.analyticsClient;
    }
    updateUserInfo(accountId) {
        this.analyticsClient.setUserInfo((0, $jgvOT.userType).ATLASSIAN_ACCOUNT, accountId);
    }
}
let $3194d26274471849$var$analyticsWebClient;
const $3194d26274471849$export$e9ba7ef9458d1a4a = ()=>{
    if ($3194d26274471849$var$analyticsWebClient) return $3194d26274471849$var$analyticsWebClient;
    const locale = (0, $6mmHn.getMeta)('ajs-user-locale') || (0, $6mmHn.getMeta)('user-locale') || '';
    const tenantId = (0, $6mmHn.getMeta)('tenant-id') || '';
    const accountId = (0, $6mmHn.getMeta)('account-id') || '';
    const version = window.BUILD_KEY;
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const environment = (0, $ebpTf.getEnv)().environment;
    $3194d26274471849$var$analyticsWebClient = new $3194d26274471849$export$208d0eb1d9fc833e();
    $3194d26274471849$var$analyticsWebClient.init({
        tenantId: tenantId,
        environment: environment,
        locale: locale,
        version: version,
        subProduct: isCSM ? 'customer-service' : 'serviceDesk',
        userId: accountId,
        product: 'jira',
        shouldTriggerUIViewed: false
    });
    return $3194d26274471849$var$analyticsWebClient;
};
const $3194d26274471849$export$c305be0ec5c00f16 = (accountId)=>{
    $3194d26274471849$var$analyticsWebClient.updateUserInfo(accountId);
};
const $3194d26274471849$export$799525ac94ca811d = ()=>Promise.resolve($3194d26274471849$export$e9ba7ef9458d1a4a());
const $3194d26274471849$export$474e180ec53844ef = ()=>{
    $3194d26274471849$var$analyticsWebClient = undefined;
};

});
parcelRegister("Idrdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a02e48f50cd3318$export$2e2bcd8739ae039);

var $gPrbw = parcelRequire("gPrbw");

var $jgvOT = parcelRequire("jgvOT");

var $8kAD0 = parcelRequire("8kAD0");

var $g6SWB = parcelRequire("g6SWB");

var $lrROm = parcelRequire("lrROm");

var $dppwe = parcelRequire("dppwe");

var $jIhZ8 = parcelRequire("jIhZ8");

var $hxQP5 = parcelRequire("hxQP5");

var $u00Sd = parcelRequire("u00Sd");

var $7EHuW = parcelRequire("7EHuW");

var $bhX2c = parcelRequire("bhX2c");

var $2bzrL = parcelRequire("2bzrL");

var $6BgH1 = parcelRequire("6BgH1");

var $bkJYN = parcelRequire("bkJYN");

var $biXHd = parcelRequire("biXHd");

var $7cqEO = parcelRequire("7cqEO");

var $yBFix = parcelRequire("yBFix");

var $b4WC1 = parcelRequire("b4WC1");

var $2i1By = parcelRequire("2i1By");

var $k3zDq = parcelRequire("k3zDq");

var $iDoWE = parcelRequire("iDoWE");

var $id4Xm = parcelRequire("id4Xm");

var $btxai = parcelRequire("btxai");

var $2MMDr = parcelRequire("2MMDr");

var $gR6XY = parcelRequire("gR6XY");
const $0a02e48f50cd3318$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $0a02e48f50cd3318$export$48361b6ed38f1b0 {
    static getCallback(logger) {
        logger = logger || console;
        return (response)=>{
            $0a02e48f50cd3318$export$48361b6ed38f1b0.callback(response, logger);
        };
    }
    static callback(response, logger) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) response.getEventResponseList().forEach((eventResponse)=>{
            logger.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
        });
        else if (statusCode === 400 || statusCode === 404) {
            logger.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                logger.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            logger.log('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                logger.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $0a02e48f50cd3318$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        this._useStargate = (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        };
        this._changeInternalUserId = (userId, anonymousId)=>{
            this._eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this._eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this._eventProcessor.getUser().setAnonymousId(anonymousId);
        };
        this._createSubproductGetter = (subproduct)=>(0, $g6SWB.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.');
        this._createEmbeddedProductGetter = (embeddedProduct)=>(0, $g6SWB.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.');
        this._getLastScreenEvent = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($0a02e48f50cd3318$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch  {
                this._safeSessionStorage.removeItem($0a02e48f50cd3318$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        };
        this._setLastScreenEvent = (event)=>{
            this._safeSessionStorage.setItem($0a02e48f50cd3318$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        };
        this._shouldEventBeDelayed = (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this._eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        };
        this._fireEvent = (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $jgvOT.eventType).UI:
                case (0, $jgvOT.eventType).OPERATIONAL:
                case (0, $jgvOT.eventType).TRACK:
                    return this._eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $jgvOT.eventType).SCREEN:
                    return this._eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $jgvOT.eventType).IDENTIFY:
                    return this._eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        };
        this._fireDelayedEvent = (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        };
        this._delayEvent = (identifier, builtEvent, context, userInfo, callback)=>{
            this._eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        };
        this._processEvent = (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        };
        this.setEmbeddedProduct = (embeddedProduct)=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        };
        this.clearEmbeddedProduct = ()=>{
            this._internalProductInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        };
        this.setSubproduct = (subproduct)=>{
            this._internalProductInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        };
        /**
    * Calling this function in the intialisation of the client in product
    * captures specified 'origin tracing' URL params and fires a single origin landed event
    * <p>
    * This function expects a mapping between the keys for any URL parameters
    *  that should be captured and removed for origin tracing
    * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
    * Each handler function should return an object with two items
    * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
    * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
    *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
    * </p>
    * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
    * e.g. from a share or email
    *
    * An example calling this function using an external decoding library, with taskSessionId specified to persist
    * analyticsWebClient.setOriginTracingHandlers({
         atlOrigin: encodedOrigin => {
             const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
             return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
         },
     });
    *
    * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
    * @this {AnalyticsWebClient}
    */ this.setOriginTracingHandlers = (originParamHandlerMapping)=>{
            const capturedOriginTraces = this._originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            const keys = Object.keys(capturedOriginTraces);
            keys.forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this._task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            keys.forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (keys.length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        };
        this.setTenantInfo = (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $jgvOT.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $jgvOT.isType)((0, $jgvOT.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $jgvOT.objectValues)((0, $jgvOT.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearTenantInfo = ()=>{
            this._tenantInfo = {};
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setOrgInfo = (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        };
        this.clearOrgInfo = ()=>{
            this._orgInfo = {};
        };
        this.setWorkspaceInfo = (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        };
        this.clearWorkspaceInfo = ()=>{
            this._workspaceInfo = {};
        };
        this.setCollaborationContextInfo = (collaborationContextAri)=>{
            if (!collaborationContextAri) throw new Error('Missing collaborationContextAri');
            this._collaborationContextInfo = {
                collaborationContextAri: collaborationContextAri
            };
        };
        this.clearCollaborationContextInfo = ()=>{
            this._collaborationContextInfo = {};
        };
        this.setUserInfo = (userIdType, userId)=>{
            (0, $u00Sd.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.clearUserInfo = ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this._eventProcessor.getUser().getAnonymousId()
            };
            this._eventProcessor.refreshMetadata(this._userInfo, this._tenantInfo);
        };
        this.setAlias = (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $jgvOT.isType)((0, $jgvOT.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $jgvOT.objectValues)((0, $jgvOT.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        };
        this.clearAlias = ()=>{
            this._aliases = {};
        };
        this.setGroup = (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $jgvOT.isType)((0, $jgvOT.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $jgvOT.objectValues)((0, $jgvOT.groupType))}]`);
            this._groups[groupsKeyType] = group;
        };
        this.clearGroup = ()=>{
            this._groups = {};
        };
        this.getAnonymousId = ()=>this._userInfo.anonymousId;
        this.getCurrentSessionId = ()=>this._sessionTracking.getCurrentSessionId();
        this.setUIViewedAttributes = (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = {
                ...uiViewedAttributes
            };
        };
        this.getUIViewedAttributes = ()=>{
            return this._uiViewedAttributes;
        };
        this.clearUIViewedAttributes = ()=>{
            this._uiViewedAttributes = {};
        };
        this.appendUIViewedAttributes = (attributes)=>{
            if (!this._uiViewedAttributes) this._uiViewedAttributes = attributes;
            else this._uiViewedAttributes = {
                ...this._uiViewedAttributes,
                ...attributes
            };
        };
        this.sendIdentifyEvent = (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $jgvOT.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        };
        /**
   * @deprecated
   * please use {@link sendScreenEvent instead)
   */ this.sendPageEvent = (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        };
        /**
   * send screen event
   * @param event The event / For retrocompatibility event name is still supported here.
   * @param callback
   * @param attributes. Deprecated, will get ignored if using an event object as first param.
   */ this.sendScreenEvent = (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $u00Sd.validateScreenEvent)(screenName);
            (0, $u00Sd.validateContainers)(screenContainers);
            const builtEvent = (0, $jIhZ8.buildScreenEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = {
                name: screenName,
                ...builtEvent
            };
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $2MMDr.default)(callback, builtEventWithName));
        };
        this.sendTrackEvent = (event, callback)=>{
            (0, $u00Sd.validateTrackEvent)(event);
            const builtEvent = (0, $jIhZ8.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $jgvOT.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $jIhZ8.buildActionName)(event), builtEvent, this._context, (0, $2MMDr.default)(callback, builtEvent));
        };
        this.sendUIEvent = (event, callback)=>{
            (0, $u00Sd.validateUIEvent)(event);
            const builtEvent = (0, $jIhZ8.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $jgvOT.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $jIhZ8.buildActionName)(event), builtEvent, this._context, (0, $2MMDr.default)(callback, builtEvent));
        };
        this.sendOperationalEvent = (event, callback)=>{
            (0, $u00Sd.validateOperationalEvent)(event);
            const builtEvent = (0, $jIhZ8.buildActionEvent)(this._internalProductInfo, this._tenantInfo, this._userInfo, event, (0, $jgvOT.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this._task.getAllTaskSessions(), this._crossProductInteractionTracking.getInteractionSession(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._collaborationContextInfo, this._aliases, this._groups);
            return this._processEvent((0, $jIhZ8.buildActionName)(event), builtEvent, this._context, (0, $2MMDr.default)(callback, builtEvent));
        };
        this.startUIViewedEvent = (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = this.createUIViewedEvent(callback);
            this._uiViewedEvent.start();
        };
        this.stopUIViewedEvent = ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        };
        this.resetUIViewedTimers = ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        };
        this.signalUserActive = ()=>{
            let uiViewedEvent = this._uiViewedEvent || this.createUIViewedEvent(null);
            uiViewedEvent.signalUserActive();
        };
        this.createUIViewedEvent = (callback)=>{
            return new (0, $k3zDq.default)(this._internalProductInfo, ()=>({
                    embeddedProduct: this._internalProductInfo.embeddedProduct(),
                    subproduct: this._internalProductInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
        };
        this.startApdexEvent = (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        };
        this.getApdexStart = (apdexEvent)=>this._apdexEvent.getStart(apdexEvent);
        this.stopApdexEvent = (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        };
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        this.startLowPriorityEventDelay = (timeout, callback)=>{
            this._eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        };
        this.stopLowPriorityEventDelay = ()=>{
            this._eventDelayQueue.stopLowPriorityEventDelay();
        };
        this.onEvent = (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $jgvOT.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $jgvOT.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $jgvOT.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $jgvOT.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $jgvOT.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $jgvOT.objectValues)((0, $jgvOT.eventType))}]`);
        };
        this.setResponseCallback = (responseCallback)=>{
            this._eventProcessor.setResponseCallback(responseCallback);
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $jgvOT.isType)((0, $jgvOT.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $jgvOT.objectValues)((0, $jgvOT.envType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $jgvOT.originType).WEB;
        else if (!(0, $jgvOT.isType)((0, $jgvOT.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $jgvOT.objectValues)((0, $jgvOT.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $jgvOT.originType).WEB ? (0, $jgvOT.platformType).WEB : (0, $jgvOT.platformType).DESKTOP;
        else (0, $u00Sd.validatePlatform)(productInfo);
        this._logger = settings.logger || console;
        // Auto-detect Oasis perimeter (e.g. FedRAMP Moderate) when the consumer hasn't explicitly provided a perimeter.
        if (!productInfo.perimeter) try {
            if ((0, $gPrbw.isFedrampModerate)()) productInfo.perimeter = (0, $jgvOT.perimeterType).FEDRAMP_MODERATE;
        } catch (e) {
            this._logger.warn('Failed to auto-detect perimeter: %s', e instanceof Error ? e.message : String(e));
        }
        // Default to commercial perimeter if not explicitly provided and not auto-detected.
        if (!productInfo.perimeter) productInfo.perimeter = (0, $jgvOT.perimeterType).COMMERCIAL;
        if (!(0, $jgvOT.isType)((0, $jgvOT.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be a perimeterType: [${(0, $jgvOT.objectValues)((0, $jgvOT.perimeterType))}]`);
        // Auto-detect Oasis Isolated Cloud (IC) environment when the consumer hasn't explicitly provided an `ic` value.
        if (!productInfo.ic) try {
            const icId = (0, $gPrbw.isolationContextId)();
            if (icId && icId.length > 0) productInfo.ic = icId;
        } catch (e) {
            this._logger.warn('Failed to auto-detect isolation context: %s', e instanceof Error ? e.message : String(e));
        }
        this._internalProductInfo = {
            ...productInfo,
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        };
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $dppwe.isFirstParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromProduct: this._embeddedContext['embeddedFromProduct'],
                embeddedFromSubproduct: this._embeddedContext['embeddedFromSubproduct'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
            if ((0, $dppwe.isThirdParty)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext['embeddedType'],
                embeddedFromTopLevelDomain: this._embeddedContext['embeddedFromTopLevelDomain']
            });
        }
        this._context = (0, $jIhZ8.buildContext)(this._internalProductInfo);
        this._safeSessionStorage = new (0, $7cqEO.default)();
        const useStargate = this._useStargate(settings.useStargate);
        const apiHost = (0, $bkJYN.selectHost)({
            useStargate: useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            ic: productInfo.ic,
            envOverride: productInfo.envOverride,
            apiHost: settings.apiHost
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const maxAttempts = settings.maxRetryAttempts !== undefined && Number.isInteger(settings.maxRetryAttempts) && settings.maxRetryAttempts >= 0 ? settings.maxRetryAttempts + 1 : undefined;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload,
            maxAttempts: maxAttempts,
            maxQueueSize: settings.maxQueueSize
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $gR6XY.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        const metadataClientFactory = settings.metadataClientFactory || (0, $bhX2c.MetadataClient).Factory;
        const metadataClient = metadataClientFactory(apiHostProtocol, apiHost, productInfo.product);
        this._eventProcessor = new (0, $7EHuW.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this._logger,
            metadataClient: metadataClient,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $0a02e48f50cd3318$export$48361b6ed38f1b0.getCallback(this._logger),
            env: productInfo.env,
            perimeter: productInfo.perimeter,
            enableMetadataCalls: this.metadataCallsEnabled(settings),
            enableEventCalls: this.eventCallsEnabled(settings)
        });
        this._userInfo = {
            anonymousId: this._eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $6BgH1.default)();
        this._tabTracking = new (0, $yBFix.default)();
        this._sessionTracking = new (0, $biXHd.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this._task = new (0, $b4WC1.default)();
        this._originTracing = new (0, $2bzrL.default)();
        this._eventProcessor.setOriginTracingClient(this._originTracing);
        // Init Apdex
        this._apdexEvent = new (0, $8kAD0.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $iDoWE.defaultHistoryReplaceFn);
        this._eventDelayQueue = new (0, $hxQP5.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $2i1By.default)(settings.isSynthetic, settings.enableTestingCache);
        this._pageLoadId = (0, $btxai.default)();
        this._workspaceInfo = {};
        this._collaborationContextInfo = {};
        this._aliases = {};
        this._groups = {};
        this._crossProductInteractionTracking = new (0, $lrROm.default)({
            perimeter: productInfo.perimeter,
            product: productInfo.product,
            sendEventCallback: this.sendOperationalEvent,
            historyReplaceFn: this._historyReplaceFn
        });
        this._crossProductInteractionTracking.validateInteractionSession();
    }
    metadataCallsEnabled(settings) {
        if (typeof settings.disableMetadataCalls === 'boolean') return !settings.disableMetadataCalls;
        return !(0, $id4Xm.TestSupport).isGeminiVREnvironment() && !(0, $id4Xm.TestSupport).areFetchCallsDisabled();
    }
    eventCallsEnabled(settings) {
        if (typeof settings.disableEventCalls === 'boolean') return !settings.disableEventCalls;
        return !(0, $id4Xm.TestSupport).isGeminiVREnvironment() && !(0, $id4Xm.TestSupport).areFetchCallsDisabled();
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties. They are not part of the public
   * API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get task() {
        return this._task;
    }
    /**
   * @private
   * @deprecated
   * Please avoid using internal properties.
   * They are not part of the public API and may change without notice.
   *
   * This property has been exposed for backward compatibility with existing
   * tests in external code
   */ get _productInfo() {
        return this._internalProductInfo;
    }
}

});
parcelRegister("jgvOT", function(module, exports) {
$parcel$export(module.exports, "envType", () => $badd423719035c76$export$56ac8ebc9870b1b9);
$parcel$export(module.exports, "eventType", () => $badd423719035c76$export$4c045e605d532c98);
$parcel$export(module.exports, "platformType", () => $badd423719035c76$export$6b4f396210e539f3);
$parcel$export(module.exports, "originType", () => $badd423719035c76$export$f73e9fcd368bb695);
$parcel$export(module.exports, "tenantType", () => $badd423719035c76$export$496f06ac2a964da2);
$parcel$export(module.exports, "productEmbedType", () => $badd423719035c76$export$f49776dca27a2e7c);
$parcel$export(module.exports, "userType", () => $badd423719035c76$export$1827adfd178b4870);
$parcel$export(module.exports, "apdexType", () => $badd423719035c76$export$99b37380a464d794);
$parcel$export(module.exports, "desktopPlatforms", () => $badd423719035c76$export$809831be6c4c6227);
$parcel$export(module.exports, "webPlatforms", () => $badd423719035c76$export$19c579398ad213e7);
$parcel$export(module.exports, "originTracingType", () => $badd423719035c76$export$62a500c02dc63ee);
$parcel$export(module.exports, "objectValues", () => $badd423719035c76$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "isType", () => $badd423719035c76$export$26b9f946b448f23e);
$parcel$export(module.exports, "perimeterType", () => $badd423719035c76$export$bdd41749d2096e4b);
$parcel$export(module.exports, "aliasType", () => $badd423719035c76$export$a8c99e46b781d936);
$parcel$export(module.exports, "groupType", () => $badd423719035c76$export$e73680b18d9b7c6e);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
var $badd423719035c76$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
var $badd423719035c76$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
var $badd423719035c76$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    /**
   *  @deprecated desktop is here for retrocompatibility, please select one of the above OS instead.
   */ platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
var $badd423719035c76$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
var $badd423719035c76$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["STUDIO_WORKSPACE_ID"] = "studioWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
var $badd423719035c76$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
var $badd423719035c76$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $badd423719035c76$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $badd423719035c76$export$809831be6c4c6227 = Object.freeze([
    "desktop",
    "mac",
    "linux",
    "windows"
]);
const $badd423719035c76$export$19c579398ad213e7 = Object.freeze([
    "web",
    "mobileWeb"
]);
var $badd423719035c76$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $badd423719035c76$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $badd423719035c76$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
var $badd423719035c76$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
var $badd423719035c76$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
var $badd423719035c76$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
var $badd423719035c76$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("8kAD0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d37a925a38631792$export$2e2bcd8739ae039);

var $jgvOT = parcelRequire("jgvOT");

var $6BgH1 = parcelRequire("6BgH1");

var $cmXhn = parcelRequire("cmXhn");
class $d37a925a38631792$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        this._getEventKey = ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task;
        this._getEventTimingByName = (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        };
        this._getApdexFields = (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return {
                ...apdexTimings,
                apdex: apdexScore
            };
        };
        this._getApdexTimings = (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        };
        this._getStartTime = (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $jgvOT.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        };
        this._getStopTime = ()=>this._performance.getTimeOrigin() + this._performance.now();
        this._cleanApdexState = (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        };
        this._getVisibilityFields = (event)=>{
            let isActiveTab;
            /**
     * For initialLoad type:
     * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
     *
     * For transition type:
     * 1. active status is tracked in active events map (_isActiveEvents)
     *
     * For any type, if startTime or stopTime is specified:
     * 1. If currently active (!_isHidden)
     */ if (event.type === (0, $jgvOT.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $jgvOT.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        };
        this._calculateApdex = ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        };
        this._validateStartEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        };
        this._validateStopEvent = (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $jgvOT.isType)((0, $jgvOT.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
     * For a transition, if the startTime was not specified,
     * the start event should have been present.
     */ if (!event.startTime && event.type === (0, $jgvOT.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        };
        this._shouldSendEvent = (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        };
        this._sendEvent = (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: {
                    ...event.additionalAttributes,
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                }
            }, callback);
        };
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $6BgH1.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $cmXhn.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent({
            ...event,
            ...apdexFields,
            ...visibilityFields
        }, callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}

});
parcelRegister("6BgH1", function(module, exports) {
$parcel$export(module.exports, "default", () => $436303a7d0482d5d$export$2e2bcd8739ae039);
class $436303a7d0482d5d$export$2e2bcd8739ae039 {
    constructor(){
        this._bindEventListeners = ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        };
        this._handleVisibilityChange = ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        };
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}

});

parcelRegister("cmXhn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8f724754d7e014e$export$2e2bcd8739ae039);
class $e8f724754d7e014e$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}

});


parcelRegister("g6SWB", function(module, exports) {
$parcel$export(module.exports, "default", () => $82515f96a691f512$export$2e2bcd8739ae039);
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $82515f96a691f512$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $82515f96a691f512$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($82515f96a691f512$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("lrROm", function(module, exports) {
$parcel$export(module.exports, "default", () => $651510a4c207013a$export$2e2bcd8739ae039);

var $4RcVs = parcelRequire("4RcVs");
var $9tRdt = parcelRequire("9tRdt");
var $5iYB7 = parcelRequire("5iYB7");

var $jgvOT = parcelRequire("jgvOT");

var $iDoWE = parcelRequire("iDoWE");
const $651510a4c207013a$var$isCrossProductInteractionAttribute = (_, paramName)=>{
    return paramName === (0, $9tRdt.URL_QUERY_PARAM_INTERACTION_SESSION);
};
class $651510a4c207013a$export$2e2bcd8739ae039 {
    constructor(options){
        this.validProduct = false;
        this.isEnabled = options.perimeter !== (0, $jgvOT.perimeterType).FEDRAMP_MODERATE;
        this.urlValidation = {
            result: true,
            url: ''
        };
        this.sendEventCallback = options.sendEventCallback;
        if (this.isEnabled) {
            let bridge;
            let interactionSessionId;
            let interactionSource;
            let interactionSessionOptions;
            this.urlValidation.url = window.location.href;
            // Validate product
            //
            // Various UI components in the page might initialize their own AWC instances but some of those
            // instances might be associated with subordinate products that are of no interest to XPC tracking. We
            // want to avoid XPC meta analytics being fired against uninteresting products.
            //
            // Some products (e.g. Confluence) also have custom URL replace functions passed into AWC settings,
            // and we need to use those to ensure our query parameter is correctly processed.
            //
            // TODO - this is currently the best way we can try and guarantee that the most relevant product's AWC
            // is passing in the options. Down the line we ideally want the relevant products themselves to opt-in
            // to initialising cross product tracking via a flag in their AWC init options.
            this.validProduct = (0, $5iYB7.validProducts).includes(options.product);
            if (this.validProduct) {
                // Only parse URL parameters if we are in a valid product
                const crossProductUrlPramater = (0, $iDoWE.default)($651510a4c207013a$var$isCrossProductInteractionAttribute, options.historyReplaceFn);
                const interactionSessionBlob = (0, $9tRdt.URL_QUERY_PARAM_INTERACTION_SESSION) in crossProductUrlPramater ? crossProductUrlPramater[0, $9tRdt.URL_QUERY_PARAM_INTERACTION_SESSION] : null;
                if (interactionSessionBlob) try {
                    const interactionSession = JSON.parse(atob(interactionSessionBlob));
                    if (interactionSession.bridge && interactionSession.id && interactionSession.source) {
                        // All 3 fields must be present from a valid query param
                        bridge = interactionSession.bridge;
                        interactionSessionId = interactionSession.id;
                        interactionSource = interactionSession.source;
                    } else this.urlValidation.result = false;
                } catch  {
                    // Gracefully fail through if parameter has been corrupted
                    this.urlValidation.result = false;
                }
                interactionSessionOptions = {
                    analyticsEventCallback: this.sendEventCallback,
                    persistedSessionId: interactionSessionId
                };
            }
            // Initialise interaction session client with parsed values if they exist
            this.analyticsCrossProductInteractionClient = new (0, $4RcVs.default)(interactionSessionOptions, bridge, interactionSource);
        }
    }
    getInteractionSession() {
        if (this.isEnabled && this.analyticsCrossProductInteractionClient) return {
            bridge: this.analyticsCrossProductInteractionClient.getBridge(),
            id: this.analyticsCrossProductInteractionClient.getCurrentInteractionSessionId(),
            prevId: this.analyticsCrossProductInteractionClient.getPreviousInteractionSessionId(),
            source: this.analyticsCrossProductInteractionClient.getInteractionSource()
        };
        else return {
            bridge: null,
            id: null,
            prevId: null,
            source: null
        };
    }
    /**
   * Validates the cross product interaction session parameters parsed from the URL (if present)
   * If the Base64-encoded URL does not decode into a valid JSON object
   *
   * This method must be called out of the constructor, as the sendEventCallback we expect here
   * depends on crossProductInteractionTracking.getInteractionSession() so the class must be initialised
   */ validateInteractionSession() {
        if (!this.urlValidation.result) this.sendEventCallback({
            action: 'corrupted',
            actionSubject: 'interactionSession',
            attributes: {
                url: this.urlValidation.url
            },
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("4RcVs", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a3d909120c1efe7$export$2e2bcd8739ae039);

var $6uA6H = parcelRequire("6uA6H");

var $gPrbw = parcelRequire("gPrbw");

var $3H4LK = parcelRequire("3H4LK");

var $hO75d = parcelRequire("hO75d");

var $gAl2r = parcelRequire("gAl2r");
const $3a3d909120c1efe7$export$b9dd752fb13352ce = 'interactionSession.source';
const $3a3d909120c1efe7$export$e04e3c50573f9af7 = 'interactionSession.bridge';
class $3a3d909120c1efe7$export$2e2bcd8739ae039 {
    constructor(interactionSessionOptions, bridge, interactionSource){
        this.getCurrentInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getCurrentInteractionSessionId() : null;
        this.getPreviousInteractionSessionId = ()=>this.isEnabled && this.interactionSessionTracking ? this.interactionSessionTracking.getPreviousInteractionSessionId() : null;
        this.getBridge = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($3a3d909120c1efe7$export$e04e3c50573f9af7) : null;
        this.getInteractionSource = ()=>this.isEnabled && this.safeSessionStorage ? this.safeSessionStorage.getItem($3a3d909120c1efe7$export$b9dd752fb13352ce) : null;
        const shouldDisable = (0, $3H4LK.fg)('use_frontend_feature_encoding_sdk_platform') ? !(0, $6uA6H.isFeatureEnabled)('atlassian-analytics', 'atlassian-analytics-cross-product-interaction-client') : (0, $gPrbw.isFedrampModerate)();
        this.isEnabled = !shouldDisable;
        if (this.isEnabled) {
            // Get singleton interaction session tracking instance
            this.interactionSessionTracking = (0, $hO75d.default).getInstance();
            let isValidPersistedId = false;
            if (this.interactionSessionTracking) {
                if (interactionSessionOptions) {
                    this.interactionSessionTracking.setAnalyticsCallback(interactionSessionOptions.analyticsEventCallback);
                    isValidPersistedId = this.interactionSessionTracking.setInteractionSessionId(interactionSessionOptions.persistedSessionId);
                }
            }
            this.safeSessionStorage = new (0, $gAl2r.default)();
            // Store other interaction session parameters directly in session storage if ID has been validated
            if (isValidPersistedId) {
                bridge && this.safeSessionStorage.setItem($3a3d909120c1efe7$export$e04e3c50573f9af7, bridge);
                interactionSource && this.safeSessionStorage.setItem($3a3d909120c1efe7$export$b9dd752fb13352ce, interactionSource);
            }
        }
    }
}

});
parcelRegister("6uA6H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $g9JDQ = parcelRequire("g9JDQ");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabled", {
    enumerable: true,
    get: function() {
        return $g9JDQ.isEnvironmentBlockEnabled;
    }
});
Object.defineProperty(module.exports, "isFeatureEnabled", {
    enumerable: true,
    get: function() {
        return $g9JDQ.isFeatureEnabled;
    }
});

});
parcelRegister("g9JDQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAuditState = module.exports.configureAuditState = module.exports.shouldEnableForAudit = module.exports.isFeatureEnabled = module.exports.isEnvironmentBlockEnabled = void 0;

var $gPrbw = parcelRequire("gPrbw");

var $7wBG1 = parcelRequire("7wBG1");

var $5DVOd = parcelRequire("5DVOd");

var $alRlw = parcelRequire("alRlw");
const $bc30e415d2ce650c$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX = "aem-audit";
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @returns if the environment block is available in the current cloud environment
 */ function $bc30e415d2ce650c$var$isEnvironmentBlockEnabled(environmentBlockName) {
    const boundaryKey = $bc30e415d2ce650c$var$getBoundaryKey();
    return (0, $7wBG1.isEnvironmentBlockEnabledForBoundary)(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabled = $bc30e415d2ce650c$var$isEnvironmentBlockEnabled;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param offeringPredicates Optional map of boundary keys to predicate functions. When a predicate
 *   is provided for the current boundary, the feature is only considered enabled if both
 *   the AEM state and the predicate return true.
 * @returns if the feature is available in the current cloud environment
 */ function $bc30e415d2ce650c$var$isFeatureEnabled(environmentBlockName, featureName, offeringPredicates) {
    const override = (0, $5DVOd.getFeatureOverride)(environmentBlockName, featureName);
    if (override !== null) return override;
    const boundaryKey = $bc30e415d2ce650c$var$getBoundaryKey();
    const aemResult = (0, $7wBG1.isFeatureEnabledForBoundary)(environmentBlockName, featureName, boundaryKey);
    if (!aemResult) {
        if ((0, $alRlw.isSSR)()) return false; // SSR: fallback to standard AEM resolution
        const metadata = (0, $7wBG1.getFeatureAvailabilityMetadataForBoundary)(environmentBlockName, featureName, boundaryKey);
        if (metadata && metadata.auditPhase) return $bc30e415d2ce650c$var$shouldEnableForAudit(metadata.auditPhase, environmentBlockName, featureName);
        return false; // fallback to default behavior when not in audit state
    }
    const predicate = offeringPredicates ? offeringPredicates[boundaryKey] : undefined;
    return predicate ? predicate() : true;
}
module.exports.isFeatureEnabled = $bc30e415d2ce650c$var$isFeatureEnabled;
/**
 * Determines whether a feature that is not enabled via standard AEM resolution
 * should be enabled due to an active audit phase.
 *
 * This function should only be called for excluded features in browser contexts that have an active
 * audit phase. It applies the following rules:
 *
 * | Phase            | Environment | localStorage key set? | Result  |
 * | ---------------- | ----------- | --------------------- | ------- |
 * | internal-audit   | non-prod    | any                   | true    |
 * | internal-audit   | prod        | any                   | false   |
 * | external-audit   | non-prod    | any                   | true    |
 * | external-audit   | prod        | yes ("true")          | true    |
 * | external-audit   | prod        | no                    | false   |
 *
 * In SSR contexts (no window/localStorage), this falls back to false
 * for any case that would require a localStorage check.
 */ function $bc30e415d2ce650c$var$shouldEnableForAudit(auditPhase, environmentBlockName, featureName) {
    const envType = (0, $alRlw.getEnvironmentType)();
    if (envType === "non-prod") return true;
    if (auditPhase === $7wBG1.UnderAuditPhase.EXTERNAL_AUDIT && !(0, $alRlw.isSSR)() && localStorage.getItem(`${$bc30e415d2ce650c$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`) === "true") return true;
    return false;
}
module.exports.shouldEnableForAudit = $bc30e415d2ce650c$var$shouldEnableForAudit;
function $bc30e415d2ce650c$var$getBoundaryKey() {
    if ((0, $gPrbw.isFedrampModerate)()) return $7wBG1.FED_MOD_KEY;
    if ((0, $gPrbw.isIsolatedCloud)()) return $7wBG1.ISOLATED_CLOUD_COMMERCIAL_KEY;
    return $7wBG1.COMMERCIAL_KEY;
}
function $bc30e415d2ce650c$var$configureAuditState(environmentBlockName, featureName, value) {
    localStorage.setItem(`${$bc30e415d2ce650c$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`, value);
}
module.exports.configureAuditState = $bc30e415d2ce650c$var$configureAuditState;
function $bc30e415d2ce650c$var$clearAuditState(environmentBlockName, featureName) {
    localStorage.removeItem(`${$bc30e415d2ce650c$var$AEM_AUDIT_LOCAL_STORAGE_PREFIX}::${environmentBlockName}::${featureName}`);
}
module.exports.clearAuditState = $bc30e415d2ce650c$var$clearAuditState;
// Register global API on window for browser dev tools usage
if (typeof window !== "undefined") window.__AEM_FEATURE_JS__ = {
    checkFeature: $bc30e415d2ce650c$var$isFeatureEnabled,
    overrideFeature: $5DVOd.overrideFeature,
    clearFeatureOverride: $5DVOd.clearFeatureOverride,
    clearAllOverrides: $5DVOd.clearAllOverrides,
    configureAuditState: $bc30e415d2ce650c$var$configureAuditState,
    clearAuditState: $bc30e415d2ce650c$var$clearAuditState
};

});
parcelRegister("7wBG1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

var $j2dLi = parcelRequire("j2dLi");
Object.defineProperty(module.exports, "isEnvironmentBlockEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $j2dLi.isEnvironmentBlockEnabledForBoundary;
    }
});

var $j2dLi = parcelRequire("j2dLi");
Object.defineProperty(module.exports, "isFeatureEnabledForBoundary", {
    enumerable: true,
    get: function() {
        return $j2dLi.isFeatureEnabledForBoundary;
    }
});

var $j2dLi = parcelRequire("j2dLi");
Object.defineProperty(module.exports, "getFeatureAvailabilityMetadataForBoundary", {
    enumerable: true,
    get: function() {
        return $j2dLi.getFeatureAvailabilityMetadataForBoundary;
    }
});

var $1EtA1 = parcelRequire("1EtA1");
Object.defineProperty(module.exports, "BOUNDARY_KEYS_LIST", {
    enumerable: true,
    get: function() {
        return $1EtA1.BOUNDARY_KEYS_LIST;
    }
});
Object.defineProperty(module.exports, "UnderAuditPhase", {
    enumerable: true,
    get: function() {
        return $1EtA1.UnderAuditPhase;
    }
});
Object.defineProperty(module.exports, "COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $1EtA1.COMMERCIAL_KEY;
    }
});
Object.defineProperty(module.exports, "FED_MOD_KEY", {
    enumerable: true,
    get: function() {
        return $1EtA1.FED_MOD_KEY;
    }
});
Object.defineProperty(module.exports, "ISOLATED_CLOUD_COMMERCIAL_KEY", {
    enumerable: true,
    get: function() {
        return $1EtA1.ISOLATED_CLOUD_COMMERCIAL_KEY;
    }
});

});
parcelRegister("j2dLi", function(module, exports) {
"use strict";
var $ddb8e1072f4f1d9d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeatureAvailabilityMetadataForBoundary = module.exports.isFeatureEnabledForBoundary = module.exports.isEnvironmentBlockEnabledForBoundary = void 0;

const $ddb8e1072f4f1d9d$var$sdk_data_json_1 = $ddb8e1072f4f1d9d$var$__importDefault((parcelRequire("c4Css")));
const $ddb8e1072f4f1d9d$var$aemEnvironmentBlockData = $ddb8e1072f4f1d9d$var$sdk_data_json_1.default;
// Build reverse map: offeringId -> offeringShortKeyId, derived from compositionKeyMap (offeringShortKeyId -> offeringId)
const $ddb8e1072f4f1d9d$var$offeringToOfferingShortKeyId = Object.fromEntries(Object.entries($ddb8e1072f4f1d9d$var$aemEnvironmentBlockData.compositionKeyMap).map(([offeringShortKeyId, offeringId])=>[
        offeringId,
        offeringShortKeyId
    ]));
/**
 * Translates a full offering ID (BoundaryKey) to its short SDK key name.
 * Falls back to the original key if no mapping exists.
 */ function $ddb8e1072f4f1d9d$var$toofferingShortKeyId(boundaryKey) {
    const mapped = $ddb8e1072f4f1d9d$var$offeringToOfferingShortKeyId[boundaryKey];
    return mapped !== undefined && mapped !== null ? mapped : boundaryKey;
}
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM
 * @param boundaryKey The boundary to evaluate for.
 *
 * @returns if the environment block is available in the current cloud environment
 */ function $ddb8e1072f4f1d9d$var$isEnvironmentBlockEnabledForBoundary(environmentBlockName, boundaryKey) {
    return $ddb8e1072f4f1d9d$var$environmentBlockInBoundary(environmentBlockName, boundaryKey);
}
module.exports.isEnvironmentBlockEnabledForBoundary = $ddb8e1072f4f1d9d$var$isEnvironmentBlockEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns if the feature is available in the current cloud environment
 */ function $ddb8e1072f4f1d9d$var$isFeatureEnabledForBoundary(environmentBlockName, featureName, boundaryKey) {
    if ($ddb8e1072f4f1d9d$var$environmentBlockInBoundary(environmentBlockName, boundaryKey)) {
        const environmentBlockData = $ddb8e1072f4f1d9d$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
        const feature = environmentBlockData.features[featureName];
        if (!feature) return false;
        return feature.compositions[$ddb8e1072f4f1d9d$var$toofferingShortKeyId(boundaryKey)] === true;
    }
    return false;
}
module.exports.isFeatureEnabledForBoundary = $ddb8e1072f4f1d9d$var$isFeatureEnabledForBoundary;
/**
 *
 * @param environmentBlockName Name of environment block as encoded in AEM (the environment block that the feature belongs to)
 * @param featureName Name of feature as encoded in AEM
 * @param boundaryKey The boundary to evaluate for
 *
 * @returns the availability metadata for the feature in the given boundary, or undefined if none
 */ function $ddb8e1072f4f1d9d$var$getFeatureAvailabilityMetadataForBoundary(environmentBlockName, featureName, boundaryKey) {
    const block = $ddb8e1072f4f1d9d$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return undefined;
    const feature = block.features[featureName];
    if (!feature) return undefined;
    return feature.availabilityMetadata && feature.availabilityMetadata[$ddb8e1072f4f1d9d$var$toofferingShortKeyId(boundaryKey)];
}
module.exports.getFeatureAvailabilityMetadataForBoundary = $ddb8e1072f4f1d9d$var$getFeatureAvailabilityMetadataForBoundary;
function $ddb8e1072f4f1d9d$var$environmentBlockInBoundary(environmentBlockName, boundaryKey) {
    const block = $ddb8e1072f4f1d9d$var$aemEnvironmentBlockData.environmentBlocks[environmentBlockName];
    if (!block) return false;
    return block.compositions[$ddb8e1072f4f1d9d$var$toofferingShortKeyId(boundaryKey)] === true;
}

});
parcelRegister("c4Css", function(module, exports) {
module.exports = JSON.parse("{\"compositionKeyMap\":{\"ic\":\"isolated-cloud-commercial\",\"cc\":\"commercial-cloud\",\"fm\":\"fedramp-moderate\"},\"environmentBlocks\":{\"adminhub\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"adminhub-access-requests\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-add-app-beta-grid\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-add-app-collections-grid\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-add-app-discover-grid\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-add-app-enterprise-grid\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-add-app-standalone-apps-grid\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-add-product\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-admin-insights\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-ai-enabled-apps\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-api-token-controls\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-app-requests\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-app-updates\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-application-tunnels\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-apps-discovery\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-atlassian-intelligence\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-audit-log\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-authentication-policies\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-automations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-backup-and-restore\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-billing-console\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-byok\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-cart\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-cmk-encryption\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-code-intelligence\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-connected-emoji\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-connected-sources\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-connector-protection\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-contacts\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-custom-domain-email-notification\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-custom-domains\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-data-classifications\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-data-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-data-residency\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-data-security-policies\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-data-transfer\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-delta-migrations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-discover-apps-shadow-it\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-discover-new-products\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-enable-user-merge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-encryption\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-environments\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-experiment-controls\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-external-user-security\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-footprint\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-freeze-windows\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-guard-detect-alerts\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-guard-detect-detections\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-help\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-hippa-compliance\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-jsm-scim\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-link-bitbucket\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-llm\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-login-customisation\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-managed-accounts-export\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-marketplace-apps\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-mcp-settings\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-mobile-app-policy\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-nested-side-navigation\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"adminhub-org-audit-logs\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-org-create\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-org-deletion\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-org-transfer\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-performance-monitoring\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-platform-usage\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-policies\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-product-insights-workflow-discovery\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-product-insights\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-product-links\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-product-recommendation\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-product-urls\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-release-tracks\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-revamped-organization-overview\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-rovo-access\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-rovo-chat-protection\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-rovo-insights\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-rovo-mcp-server\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-rovo-settings\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-saml-sso\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-sandbox\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-security-checklist\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-sensitive-data-policies\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-signup\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-site-rename\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-site-transfer\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-system-health\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-team-site-assignment\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-teams\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-teamwork-graph-cli\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-units\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-use-available-apps\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-user-access-invites\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"adminhub-user-access-settings\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-user-connected-apps\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-user-counts\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"adminhub-user-last-active-timestamp\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"adminhub-workspaces-table-plans\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"core-adminhub\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"assets\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{\"assets-data-manager\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"assets-recent-items\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"assets-reports\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"assets-rovo-search\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"core-assets\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}}}},\"atlassian-analytics\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{\"atlassian-analytics-3p-data-source-connections\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"atlassian-analytics-chart-dashboard-pdf-png-exports\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"atlassian-analytics-chart-templates\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-charts\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-comments\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-commerce-sentry\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"atlassian-analytics-cross-product-interaction-client\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"atlassian-analytics-dashboard-subscriptions\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-dashboard-templates\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-dashboards\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-data-lake-connections\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"atlassian-analytics-data-shares\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"atlassian-analytics-jira-align-enterprise-insights-connections\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"core-atlassian-analytics\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"bitbucket\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{\"bitbucket-slack-app\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"pipelines\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}}}},\"chat\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{}},\"compass\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"confluence\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"ccma\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-ai\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"confluence-anonymous-access\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-comment-and-header-links\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-company-hub\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-content-archiving\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-content-manager\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-databases\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-editing-experience\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-editor-offline-storage\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-employee-directory\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-forge-apps-sidebar\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"confluence-inline-comments-in-edit-mode\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-inspect-permissions\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-invitations\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"confluence-loom-integration\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"confluence-mission-control\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-mobile-app\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-ms-teams-integration\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"confluence-page-analytics\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-pages-blogs-folders\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-presenter-mode\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-public-links\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-questions-native-experience\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-questions\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-search\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-server\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-share-to-slack-button\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"confluence-single-space-guests\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-slack-integration\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-slides\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"confluence-smart-links\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-space-analytics\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-team-calendars\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"confluence-update-page-owners\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"confluence-whiteboards\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"core-confluence\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"customer-service-management\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"dx\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"focus\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"goals\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{}},\"guard-premium\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"home\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{\"home-org-chart-analytics-pipeline\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"home-status-backend\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}}}},\"jira\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-jira\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jcma-x2c\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jcma\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-admin-oauth-credentials\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-ai-upsell-in-editor-free\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-apps-menu\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jira-atlassian-intelligence\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-atlassian-vs-code-extension\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-audit-log\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-backlogs\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-boards-and-views\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-calendar-view\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-company-managed-projects\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-components\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jira-dashboard-public-sharing\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-development-tab-druid-metric-cards\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jira-development-tab\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jira-devinfo-async-pull-request-icon\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-devops-toolchain\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jira-edition-awareness\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-forms\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-github-for-jira\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jira-github-workflows\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jira-import-work-sidebar\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-in-product-help\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-insights\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-issue\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-jpd-nav-recommendations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-jpd-roadmap-on-timeline-cross-sell\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-loom-banner\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jira-marketplace-sidebar-recommendations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-mobile-app\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-next-best-task\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-oasis-reports\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jira-opsgenie\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-plans\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-project-archiving\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-project-issue-navigator\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-project-templates\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-project-theme-unsplash\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-quickstart-pages\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jira-releases\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-roadmap-in-nav\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-share\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-site-optimiser\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-slack\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-smart-links\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-smart-related-issues\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-software-devops\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-software-reports-cycle-time\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-software-reports-deployment-frequency\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-team-managed-projects\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-unsplash\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-whiteboards-backlog-experiment\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jira-work-item-archiving\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-work-suggestions\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jira-workflow-configuration\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-your-work-dashboard\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"jira-align\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"jira-product-discovery\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"jira-service-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-jira-service-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jira-service-management-help-center\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-ai-ops\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-ai-services\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-alert-notifications\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-approvals\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-automation-playbook\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-boysenberry\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-canned-responses\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-change-ai-risk-assessment\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-change-calendar\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-change-management-deployment-vendors\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-change-management\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jsm-change-risk-assessment\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-change-risk-reporter-configuration\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-chat-ops\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-chat\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-cloud-megatron\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-csat\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-csm-functionality\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-customer-access-internal-account\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-customer-notifications\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-customer-service-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-deployment-gating\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-deployment-tracking\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jsm-developer-escalations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-email-requests\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-embeddable-widget\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-entity-migration\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-err-governance-api\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-external-customer-accounts\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-external-customer-single-sign-on\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-external-customer-user-provisioning\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-forms\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-help-center-change-password\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-help-center-password-login\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-help-center-rovo-agent\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-help-center-virtual-agent\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-help-center\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-incident-conference-calls\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-incident-management-integration\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-issue\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-journey-builder\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-knowledge-base\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-multi-language-support\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-on-call-schedule\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-ops-genie-reporting\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-opsgenie-devops\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-portal-only-account-scim\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-post-incident-reviews\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-queues\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-related-issues\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"jsm-reports-operations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"jsm-request-intake\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-services\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-shield\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-sla-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-status-page-integration\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-surveys\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"jsm-templates-and-views\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"jsm-virtual-service-agent\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"opsgenie\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"loom\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"projects\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{}},\"rovo\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{\"rovo-ai-app-availability\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-ai-atlassian-intelligence-app-availability\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-ai-generative-ai-editor\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-ai-machine-learning\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-ai-natural-language-in-automation-rule-creation\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-ai-projects\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-ai-smart-features-based-on-machine-learning-tecton-ai\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"rovo-editor-ai-panels\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}}}},\"rovo-dev\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"statuspage\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"studio\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"talent\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"teams\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"teams-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"teams-profile-media-token-fetch\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"teams-third-party-invites\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"user-provided-banners-on-profile-pictures\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}}}},\"trello\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"anti-abuse-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{\"core-anti-abuse-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"application-tunnels\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{\"core-application-tunnels\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}}}},\"atlassian-cli\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"atlassian-visualization-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{\"atlassian-visualization-platform-kamino\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"atlassian-visualization-platform-manifold\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}}}},\"central-ai\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{\"ai-3p-connections\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"ai-managed-objects\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"ai-safety\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"collaboration-graph\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"gen-ai\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"knowledge-ai\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"knowledge-discovery\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"machine-learning-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}}}},\"collaboration-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-collaboration-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"commerce-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"commerce-platform-pls-changes-for-hams-cofs-in-boundary-deployment\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"commerce-platform-self-serve\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"core-commerce-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"customer-data-lake\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-customer-data-lake\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"customer-support-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{}},\"ecosystem-forge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-ecosystem-forge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"ecosystem-oauth\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"forge-cli\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"forge-remote-capabilities\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"forge-storage-service-rockmelon\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"forge-system-apps\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"forge-ui-ic-cdn-auth\":{\"compositions\":{\"ic\":true,\"cc\":false,\"fm\":false}}}},\"editor-collaboration-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"block-service\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"core-editor-collaboration-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"real-time-presence\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"experience-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{\"core-experience-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"gasv3\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-gasv3\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"growth-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"bxp-signup\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"core-growth-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"identity\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-identity\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"identity-mail-proxy\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"identity-virality\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"marketplace\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"marketplace-app-discovery\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"marketplace-app-migrations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"marketplace-atlassian-labs\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"marketplace-audit-logs\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"marketplace-self-service-purchase-provision-install\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"migrations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"agc-migrations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"commercial-cloud-to-agc\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"data-center-to-agc\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"migration-link-fixing\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"migrations-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"brie\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"core-migrations-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"media-migration\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"navigation\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-navigation\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"navigation-home-entry-mode\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"navigation-identity-ic-routing\":{\"compositions\":{\"ic\":true,\"cc\":false,\"fm\":false}},\"navigation-switcher-discovery\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"navigation-switcher-rovo-scas-visibility\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}}}},\"notification-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-notification-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"notifications-fpn-link\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"post-office\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-post-office\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"product-integrations-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-product-integrations-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"search\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-search\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"search-townsquare-tab\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}}}},\"smartlinks\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-smartlinks\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"user-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-user-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"user-recommendations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-user-recommendations\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"atlassian-graphql-gateway\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-atlassian-graphql-gateway\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"atlassian-platform-deployer\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"automation-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"automation-platform-actions\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"automation-platform-automation-templates\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"automation-platform-branches\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"automation-platform-conditions\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"automation-platform-event-processing\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"automation-platform-frontend\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"automation-platform-natural-language-rule-builder\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"automation-platform-rule-builder\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"automation-platform-templates\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"automation-platform-triggers\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false}},\"core-automation-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"bifrost\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-bifrost\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"build-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"cell-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{}},\"cloud-management\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"cloud-security\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"compliance-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"consent-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"consenthub\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}}}},\"core-network-automation\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-core-network-automation\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"core-network-automation-cna-theia\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-core-network-automation-cna-theia\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"cross-gateway\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-cross-gateway\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-access-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-data-access-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-classification-governance-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-data-classification-governance-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-depot-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-data-depot-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-exchange-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"aqui\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false}},\"eureka\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"kamino\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"shipyard\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"topic-osb\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-management-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-data-management-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"ers-import\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"ers\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"sql\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-platform-services\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-data-platform-services\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-store-gateway\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-data-store-gateway\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"data-telemetry-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{\"core-data-telemetry-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"decisions-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-decisions-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"detection-and-response-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"disaster-recovery\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"edge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-edge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"edge-cloudfront\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"encryption-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"cryptor\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"environment-management-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"flight-deck-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"golden-ami\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"incident-management-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"infrastructure\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-infrastructure\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"internal-data-lake\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"internal-edge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-internal-edge\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"internal-edge-httpbin\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-internal-edge-httpbin\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"job-execution-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-job-execution-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"kitt-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"kitt-fleet\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"media-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-media-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}},\"media-cdn-delivery\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"messaging-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"micros-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"network-fabric\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-network-fabric\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"observability-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"pollinator\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-pollinator\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"provisioning\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-provisioning\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"rate-limiting-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-rate-limiting-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"resiliency-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"secrets\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":false},\"features\":{}},\"security-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"service-to-service-fabric\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"sliver\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":false},\"features\":{}},\"staff-authentication-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}},\"streamhub\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-streamhub\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"targeting-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-targeting-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"teamwork-graph-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-teamwork-graph-platform\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}},\"flock\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"tenant-catalogue-service-record\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-tenant-catalogue-service-record\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"tenant-context\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-tenant-context\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true}}}},\"tenant-lifecycle\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{\"core-tenant-platform\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true}}}},\"vdi\":{\"compositions\":{\"ic\":false,\"cc\":true,\"fm\":true},\"features\":{}},\"workplace-technology-solutions\":{\"compositions\":{\"ic\":true,\"cc\":true,\"fm\":true},\"features\":{}}}}");

});


parcelRegister("1EtA1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnderAuditPhase = module.exports.BOUNDARY_KEYS_LIST = module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = module.exports.FED_MOD_KEY = module.exports.COMMERCIAL_KEY = void 0;
// Each BoundaryKey is a key in the sdk data
module.exports.COMMERCIAL_KEY = "commercial-cloud";
module.exports.FED_MOD_KEY = "fedramp-moderate";
module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY = "isolated-cloud-commercial";
module.exports.BOUNDARY_KEYS_LIST = [
    module.exports.COMMERCIAL_KEY,
    module.exports.FED_MOD_KEY,
    module.exports.ISOLATED_CLOUD_COMMERCIAL_KEY
];
var $134078d55fb9c555$var$UnderAuditPhase;
(function(UnderAuditPhase) {
    UnderAuditPhase["INTERNAL_AUDIT"] = "internal-audit";
    UnderAuditPhase["EXTERNAL_AUDIT"] = "external-audit";
})($134078d55fb9c555$var$UnderAuditPhase || (module.exports.UnderAuditPhase = $134078d55fb9c555$var$UnderAuditPhase = {}));

});


parcelRegister("5DVOd", function(module, exports) {
"use strict";
/**
 * Manages feature overrides stored in browser localStorage.
 * No-ops when not in a browser context.
 *
 * localStorage key: "AEM_FEATURE_OVERRIDES"
 * localStorage value: JSON-encoded string mapping "{environmentBlockName}::{featureName}" to boolean
 *
 * Example:
 *   "AEM_FEATURE_OVERRIDES": "{\"confluence::my_feature\":true,\"jira::other_feature\":false}"
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearAllOverrides = module.exports.clearFeatureOverride = module.exports.overrideFeature = module.exports.getFeatureOverride = module.exports.STORAGE_KEY = void 0;
module.exports.STORAGE_KEY = "AEM_FEATURE_OVERRIDES";
function $41bd6fe81994255f$var$buildKey(environmentBlockName, featureName) {
    return `${environmentBlockName}::${featureName}`;
}
function $41bd6fe81994255f$var$isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}
function $41bd6fe81994255f$var$getOverridesMap() {
    const featureOverrideValue = window.localStorage.getItem(module.exports.STORAGE_KEY);
    if (featureOverrideValue) try {
        return JSON.parse(featureOverrideValue);
    } catch (e) {
        console.warn("Failed to parse AEM_FEATURE_OVERRIDES from localStorage", e);
    }
    return {};
}
function $41bd6fe81994255f$var$setOverridesMap(map) {
    window.localStorage.setItem(module.exports.STORAGE_KEY, JSON.stringify(map));
}
/**
 * Returns the override value for a feature if one exists, or null if no override is set.
 * Returns null in non-browser environments.
 */ function $41bd6fe81994255f$var$getFeatureOverride(environmentBlockName, featureName) {
    if (!$41bd6fe81994255f$var$isBrowserEnvironment()) return null;
    const map = $41bd6fe81994255f$var$getOverridesMap();
    const key = $41bd6fe81994255f$var$buildKey(environmentBlockName, featureName);
    if (key in map) return map[key];
    return null;
}
module.exports.getFeatureOverride = $41bd6fe81994255f$var$getFeatureOverride;
/**
 * Sets a feature override in localStorage.
 */ function $41bd6fe81994255f$var$overrideFeature(environmentBlockName, featureName, value) {
    if (!$41bd6fe81994255f$var$isBrowserEnvironment()) return;
    const map = $41bd6fe81994255f$var$getOverridesMap();
    map[$41bd6fe81994255f$var$buildKey(environmentBlockName, featureName)] = value;
    $41bd6fe81994255f$var$setOverridesMap(map);
}
module.exports.overrideFeature = $41bd6fe81994255f$var$overrideFeature;
/**
 * Removes a single feature override from localStorage. Removes the key entirely if no overrides are left.
 */ function $41bd6fe81994255f$var$clearFeatureOverride(environmentBlockName, featureName) {
    if (!$41bd6fe81994255f$var$isBrowserEnvironment()) return;
    const map = $41bd6fe81994255f$var$getOverridesMap();
    delete map[$41bd6fe81994255f$var$buildKey(environmentBlockName, featureName)];
    if (Object.keys(map).length === 0) window.localStorage.removeItem(module.exports.STORAGE_KEY);
    else $41bd6fe81994255f$var$setOverridesMap(map);
}
module.exports.clearFeatureOverride = $41bd6fe81994255f$var$clearFeatureOverride;
/**
 * Clears all feature overrides from localStorage.
 */ function $41bd6fe81994255f$var$clearAllOverrides() {
    if (!$41bd6fe81994255f$var$isBrowserEnvironment()) return;
    window.localStorage.removeItem(module.exports.STORAGE_KEY);
}
module.exports.clearAllOverrides = $41bd6fe81994255f$var$clearAllOverrides;

});

parcelRegister("alRlw", function(module, exports) {

var $3TFEq = parcelRequire("3TFEq");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEnvironmentType = module.exports.isSSR = void 0;
/** Returns true when running in a server-side rendering context (no browser window). */ function $78953efcc1dd4b1c$var$isSSR() {
    return typeof window === "undefined" || typeof document === "undefined" || Boolean(typeof $3TFEq !== "undefined" && $3TFEq && $3TFEq.env && undefined); // see https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/7377575ff0ec8a6f78257788b224e37c2bae8f66/platform/packages/editor/editor-common/src/core-utils/is-ssr.ts#lines-6
}
module.exports.isSSR = $78953efcc1dd4b1c$var$isSSR;
/**
 * Returns the current environment type.
 * Defaults to "prod" in unknown cases.
 *
 * In SSR contexts, reads from globalThis.ssrContext.environmentType.
 * In browser contexts, infers from window.location.hostname.
 */ function $78953efcc1dd4b1c$var$getEnvironmentType() {
    // 1. SSR: Use ssrContext if available
    if (typeof window === "undefined") {
        // @ts-expect-error — ssrContext in globalThis type
        const ssrContext = globalThis.ssrContext;
        if (ssrContext && ssrContext.environmentType) {
            const type = ssrContext.environmentType;
            if (type === "dev") return "non-prod";
            if (type === "staging") return "non-prod";
            if (type === "prod") return "prod";
        }
        return "prod";
    }
    // 2. Browser: Use hostname-based detection with all patterns
    const host = window.location.hostname.toLowerCase();
    if (!host) // default to prod if no location available
    return "prod";
    // Exact matches
    if (host === "localhost" || host === "127.0.0.1") return "non-prod";
    // Staging patterns
    if (host.endsWith(".jira-dev.com") || host.includes(".stg.") || host.includes(".staging.")) return "non-prod";
    // Development patterns
    if (host.includes(".dev.") || host.includes(".ddev.")) return "non-prod";
    if (host.endsWith(".atlassian.net") || host.endsWith(".atlassian-us-gov-mod.com") || host.endsWith(".atlassian.com")) return "prod";
    return "prod";
}
module.exports.getEnvironmentType = $78953efcc1dd4b1c$var$getEnvironmentType;

});



parcelRegister("hO75d", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ee4cfea9ac193df$export$2e2bcd8739ae039);

var $kSLAZ = parcelRequire("kSLAZ");
const $1ee4cfea9ac193df$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $1ee4cfea9ac193df$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($1ee4cfea9ac193df$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$1ee4cfea9ac193df$export$7bc189309d2ad463];
            else {
                // Initialise InteractionSessionTracking on global window object
                window[$1ee4cfea9ac193df$export$7bc189309d2ad463] = new (0, $kSLAZ.default)();
                interactionSessionTracking = window[$1ee4cfea9ac193df$export$7bc189309d2ad463];
            }
        } catch (error) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});
parcelRegister("kSLAZ", function(module, exports) {
$parcel$export(module.exports, "INTERACTION_SESSION_ID_UPDATED_EVENT", () => $813fe11f28be1b73$export$5d4c4eab0863aae3);
$parcel$export(module.exports, "default", () => $813fe11f28be1b73$export$2e2bcd8739ae039);

var $gAl2r = parcelRequire("gAl2r");
const $813fe11f28be1b73$var$INTERACTION_SESSION_ID_STORAGE_KEY = 'interactionSession.id';
const $813fe11f28be1b73$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY = 'interactionSession.id.prev';
const $813fe11f28be1b73$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY = 'interactionSession.expiry';
const $813fe11f28be1b73$export$285f6bddd927a06d = 1800000; // 30 minutes
const $813fe11f28be1b73$export$d050a4cab1b9f734 = 86400000; // 24 hours
const $813fe11f28be1b73$export$a92e915d70316eb2 = 5000; // 5 seconds
const $813fe11f28be1b73$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $813fe11f28be1b73$var$INTEGER_REGEX = /^\d+$/;
const $813fe11f28be1b73$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
class $813fe11f28be1b73$export$2e2bcd8739ae039 {
    constructor(){
        this.analyticsReady = false;
        this.generateNewSessionId = ()=>{
            if (!this.analyticsReady) return null;
            const currentSessionId = this.safeSessionStorage.getItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            const newSessionId = Date.now().toString();
            this.safeSessionStorage.setItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_STORAGE_KEY, newSessionId);
            const { isValidSession: isValidSession } = this.getCurrentSessionParams();
            if (!isValidSession) // If session is not valid at this point, something has gone wrong with Session Storage access
            // Calling sendInteractionSessionEvent now would result in an infinite loop, so we terminate
            return null;
            if (currentSessionId) {
                // Store a copy of the current session ID so we can link sessions if needed
                this.safeSessionStorage.setItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY, currentSessionId);
                this.sendInteractionSessionEvent('renewed');
            } else this.sendInteractionSessionEvent('started');
            // Event listener is in useCrossProductUrl.tsx to update URL query params
            document.dispatchEvent(new Event($813fe11f28be1b73$export$5d4c4eab0863aae3));
            return newSessionId;
        };
        this.updateSessionExpiry = ()=>{
            const expiry = Date.now() + this.sessionExpiryTime;
            this.safeSessionStorage.setItem($813fe11f28be1b73$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this.debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { updateSessionExpiry: updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this.sessionExpiryDebounceThresholdPercentage * this.sessionExpiryTime) updateSessionExpiry();
            else {
                if (this.sessionExpiryDebounceTimer) clearTimeout(this.sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this.sessionExpiryDebounceTimer = setTimeout(()=>{
                    updateSessionExpiry();
                }, this.sessionExpiryDebounce);
            }
        };
        this.sessionExpiryTime = $813fe11f28be1b73$export$285f6bddd927a06d;
        this.sessionExpiryDebounce = $813fe11f28be1b73$export$a92e915d70316eb2;
        this.sessionExpiryDebounceThresholdPercentage = $813fe11f28be1b73$export$de43760b2dc10c19;
        this.safeSessionStorage = new (0, $gAl2r.default)();
    }
    getCurrentInteractionSessionId() {
        try {
            const { isValidSession: isValidSession, sessionExpiry: sessionExpiry, sessionId: sessionId } = this.getCurrentSessionParams();
            // If we have an existing valid session we can return the sessionId straight away
            if (isValidSession) {
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return sessionId;
            }
            // To generate a new session ID we must ensure analytics is ready
            if (this.analyticsReady) {
                // Session expiry update must occur before generateNewSessionId. Otherwise we were running
                // into issues of calls attempting to read the session ID before a valid expiry had been set
                this.debouncedUpdateSessionExpiry(sessionExpiry);
                return this.generateNewSessionId();
            }
        } catch (err) {
        // Silently swallow exception
        }
        return null;
    }
    getPreviousInteractionSessionId() {
        return this.safeSessionStorage.getItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
    }
    setInteractionSessionId(persistedSessionId) {
        if (this.validateSessionId(persistedSessionId)) {
            const currentSessionId = this.safeSessionStorage.getItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_STORAGE_KEY);
            // If we are already on the required session ID, just return true and make no changes
            // This can happen if the persisted session ID in options is the same as the current session ID
            // We noticed this happening in some cases where Confluence's own URL redirect logic was causing
            // race conditions with our URL stripping, resulting in the same query parameter being processed multiple times
            if (currentSessionId === persistedSessionId) return false;
            // Session expiry update must occur before we fire off the dispatchEvent. Otherwise we were running
            // into issues of the event consumer attempting to read the session ID before a valid expiry had been set
            this.debouncedUpdateSessionExpiry(0);
            this.safeSessionStorage.setItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_STORAGE_KEY, persistedSessionId);
            this.safeSessionStorage.removeItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_PREV_STORAGE_KEY);
            document.dispatchEvent(new Event($813fe11f28be1b73$export$5d4c4eab0863aae3));
            return true;
        }
        return false;
    }
    // Must be called with a valid sendEvent function for other methods to work
    setAnalyticsCallback(sendEventCallback) {
        if (this.analyticsReady) // If we already have a valid callback, don't over-write it
        return;
        if (sendEventCallback && typeof sendEventCallback === 'function') {
            this.sendEventCallback = sendEventCallback;
            this.analyticsReady = true;
        } else this.analyticsReady = false;
    }
    validateSessionId(sessionId) {
        // Check if persisted session ID can parse as valid Unix timestamp
        if (sessionId && $813fe11f28be1b73$var$INTEGER_REGEX.test(sessionId)) {
            const sessionAge = Date.now() - parseInt(sessionId, 10);
            // Validate that timestamp is not a future time, and is also within the TTL
            if (sessionAge >= 0 && sessionAge <= $813fe11f28be1b73$export$d050a4cab1b9f734) return true;
        }
        return false;
    }
    /*
   * This function retrieves the current session ID and expiry from SessionStorage
   * It runs the necessary checks to ensure the session ID is valid and within expiry
   *
   * It returns the values along with a `validSession` boolean
   */ getCurrentSessionParams() {
        const sessionId = this.safeSessionStorage.getItem($813fe11f28be1b73$var$INTERACTION_SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this.safeSessionStorage.getItem($813fe11f28be1b73$var$INTERACTION_SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        if (sessionId && !Number.isNaN(sessionExpiry) && sessionExpiry > Date.now()) return {
            isValidSession: true,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
        return {
            isValidSession: false,
            sessionExpiry: sessionExpiry,
            sessionId: sessionId
        };
    }
    /*
   * This function sends a GASv3 analytics event indicating the interaction session has started or renewed
   * It requires this.sendEventCallback to be set via Analytics Web Client to a valid operational event sender function
   *
   * Note that Analytics Web Client's callback function will make its own call to getCurrentInteractionSessionId to retrieve the session ID
   * to attach to the event, so a valid session ID/expiry must be retrievable from SessionStorage before this function is called to avoid infinite loops.
   *
   * This is not an ideal solution but it works with the current architecture of Analytics Web Client.
   */ sendInteractionSessionEvent(action) {
        this.sendEventCallback && this.sendEventCallback({
            action: action,
            actionSubject: 'interactionSession',
            source: 'interactionComponent',
            tags: [
                'navigationExperiences'
            ] // InteractionSession events will be registered under this platform product
        });
    }
}

});
parcelRegister("gAl2r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9f17e773115b517$export$2e2bcd8739ae039);

var $heM7R = parcelRequire("heM7R");

var $9kaRS = parcelRequire("9kaRS");
class $a9f17e773115b517$export$2e2bcd8739ae039 extends (0, $9kaRS.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $heM7R.default);
        } catch (err) {
            storageToUse = (0, $heM7R.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("heM7R", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7a7aa4aa5c1ccd7$export$2e2bcd8739ae039);
class $e7a7aa4aa5c1ccd7$export$90e3e001bcac59c7 {
    constructor(){
        this.data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this.data[key] = value;
            this.length = Object.keys(this.data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this.data) return this.data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this.data) delete this.data[key];
            this.length = Object.keys(this.data).length;
            return null;
        };
        this.clear = ()=>{
            this.data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this.data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $e7a7aa4aa5c1ccd7$var$inmemorystorage = new $e7a7aa4aa5c1ccd7$export$90e3e001bcac59c7();
var $e7a7aa4aa5c1ccd7$export$2e2bcd8739ae039 = $e7a7aa4aa5c1ccd7$var$inmemorystorage;

});

parcelRegister("9kaRS", function(module, exports) {
$parcel$export(module.exports, "default", () => $bef1a115e698b03c$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $heM7R = parcelRequire("heM7R");
const $bef1a115e698b03c$export$41c06fdd37b7e9a5 = 'awc';
const $bef1a115e698b03c$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
var $bef1a115e698b03c$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["DEV"] = "dev";
    envType["LOCAL"] = "local";
    envType["PROD"] = "prod";
    envType["STAGING"] = "staging";
    return envType;
}({});
function $bef1a115e698b03c$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $bef1a115e698b03c$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this.store;
        this.getItem = (key)=>this.store.getItem(this.createKey(key));
        this.removeItem = (key)=>this.store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this.store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this.store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this.store === (0, $heM7R.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this.store || {});
            let inMemoryStorage;
            if ($bef1a115e698b03c$export$48c17662a6902497(window[$bef1a115e698b03c$export$770aa8bc07b3de03])) inMemoryStorage = window[$bef1a115e698b03c$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $heM7R.default);
                if (!window[$bef1a115e698b03c$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$bef1a115e698b03c$export$770aa8bc07b3de03] = (0, $heM7R.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this.store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this.store = inMemoryStorage;
        };
        this.clear = ()=>this.store.clear();
        this.key = (index)=>this.store.key(index);
        this.getPrefix = ()=>this.prefix;
        this.createKey = (key)=>{
            if (this.prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($bef1a115e698b03c$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== "prod") prefixes.push(options.envPrefix);
        this.prefix = prefixes.join('-');
        if ($bef1a115e698b03c$export$48c17662a6902497(storageToUse)) this.store = storageToUse;
        else this.swapToInMemory();
    }
}

});





parcelRegister("9tRdt", function(module, exports) {
$parcel$export(module.exports, "URL_QUERY_PARAM_INTERACTION_SESSION", () => $e83d299fa2b8ba79$export$81d16f1428ce0486);
$parcel$export(module.exports, "generateUrlWithParams", () => $e83d299fa2b8ba79$export$2e3999ec51334ffe);
const $e83d299fa2b8ba79$export$81d16f1428ce0486 = 'xpis';
const $e83d299fa2b8ba79$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($e83d299fa2b8ba79$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("5iYB7", function(module, exports) {
$parcel$export(module.exports, "validProducts", () => $4618ada893c4c2fc$export$b1e8b4360a046e61);
// Add products that will participate in cross-product interaction tracking here
// TODO: Down the line this should ideally be synced with ECS product list but that
// will take significant engineering effort
const $4618ada893c4c2fc$export$b1e8b4360a046e61 = [
    'jira',
    'confluence',
    'townsquare',
    'loom'
];

});

parcelRegister("iDoWE", function(module, exports) {
$parcel$export(module.exports, "defaultHistoryReplaceFn", () => $f9b2640b573d1c59$export$600dd5bf1b049f11);
$parcel$export(module.exports, "default", () => $f9b2640b573d1c59$export$2e2bcd8739ae039);

var $4eI0d = parcelRequire("4eI0d");

var $h1cme = parcelRequire("h1cme");
const $f9b2640b573d1c59$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $f9b2640b573d1c59$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $f9b2640b573d1c59$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $4eI0d.parseUrl)(removedFragmentURL);
    const captureParams = (0, $h1cme.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $h1cme.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $4eI0d.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$f9b2640b573d1c59$export$2e2bcd8739ae039 = $f9b2640b573d1c59$var$urlParamExtractor;

});
parcelRegister("4eI0d", function(module, exports) {
$parcel$export(module.exports, "extract", () => $315a9a2e8e0b3c6a$export$f9380c9a627682d3, (v) => $315a9a2e8e0b3c6a$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $315a9a2e8e0b3c6a$export$98e6a39c04603d36, (v) => $315a9a2e8e0b3c6a$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $315a9a2e8e0b3c6a$export$fac44ee5b035f737, (v) => $315a9a2e8e0b3c6a$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $315a9a2e8e0b3c6a$export$7a5253c0f62e0150, (v) => $315a9a2e8e0b3c6a$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $315a9a2e8e0b3c6a$export$a8c1621ea79325d3, (v) => $315a9a2e8e0b3c6a$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $315a9a2e8e0b3c6a$export$357523c63a2253b9, (v) => $315a9a2e8e0b3c6a$export$357523c63a2253b9 = v);
var $315a9a2e8e0b3c6a$export$f9380c9a627682d3;
var $315a9a2e8e0b3c6a$export$98e6a39c04603d36;
var $315a9a2e8e0b3c6a$export$fac44ee5b035f737;
var $315a9a2e8e0b3c6a$export$7a5253c0f62e0150;
var $315a9a2e8e0b3c6a$export$a8c1621ea79325d3;
var $315a9a2e8e0b3c6a$export$357523c63a2253b9;
var $315a9a2e8e0b3c6a$export$44c361b8ec72ef7f;
'use strict';

var $dQJfb = parcelRequire("dQJfb");

var $bCuqp = parcelRequire("bCuqp");

var $hrhRj = parcelRequire("hrhRj");

var $75EYe = parcelRequire("75EYe");
const $315a9a2e8e0b3c6a$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $315a9a2e8e0b3c6a$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $315a9a2e8e0b3c6a$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            '[',
                            $315a9a2e8e0b3c6a$var$encode(index, options),
                            ']=',
                            $315a9a2e8e0b3c6a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            '[]=',
                            $315a9a2e8e0b3c6a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            ':list=',
                            $315a9a2e8e0b3c6a$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $315a9a2e8e0b3c6a$var$encode(key, options),
                                keyValueSep,
                                $315a9a2e8e0b3c6a$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $315a9a2e8e0b3c6a$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $315a9a2e8e0b3c6a$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $315a9a2e8e0b3c6a$var$encode(key, options),
                            '=',
                            $315a9a2e8e0b3c6a$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $315a9a2e8e0b3c6a$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $315a9a2e8e0b3c6a$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $315a9a2e8e0b3c6a$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$315a9a2e8e0b3c6a$var$decode(item, options)) : value === null ? value : $315a9a2e8e0b3c6a$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $315a9a2e8e0b3c6a$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$315a9a2e8e0b3c6a$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $315a9a2e8e0b3c6a$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $315a9a2e8e0b3c6a$var$encode(value, options) {
    if (options.encode) return options.strict ? $dQJfb(value) : encodeURIComponent(value);
    return value;
}
function $315a9a2e8e0b3c6a$var$decode(value, options) {
    if (options.decode) return $bCuqp(value);
    return value;
}
function $315a9a2e8e0b3c6a$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $315a9a2e8e0b3c6a$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $315a9a2e8e0b3c6a$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $315a9a2e8e0b3c6a$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $315a9a2e8e0b3c6a$var$extract(input) {
    input = $315a9a2e8e0b3c6a$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $315a9a2e8e0b3c6a$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $315a9a2e8e0b3c6a$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $315a9a2e8e0b3c6a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $315a9a2e8e0b3c6a$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $hrhRj(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $315a9a2e8e0b3c6a$var$decode(value, options);
        formatter($315a9a2e8e0b3c6a$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $315a9a2e8e0b3c6a$var$parseValue(value[k], options);
        else ret[key] = $315a9a2e8e0b3c6a$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $315a9a2e8e0b3c6a$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$315a9a2e8e0b3c6a$export$f9380c9a627682d3 = $315a9a2e8e0b3c6a$var$extract;
$315a9a2e8e0b3c6a$export$98e6a39c04603d36 = $315a9a2e8e0b3c6a$var$parse;
$315a9a2e8e0b3c6a$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $315a9a2e8e0b3c6a$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $315a9a2e8e0b3c6a$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $315a9a2e8e0b3c6a$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $315a9a2e8e0b3c6a$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $315a9a2e8e0b3c6a$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $315a9a2e8e0b3c6a$var$encode(key, options) + '=' + $315a9a2e8e0b3c6a$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$315a9a2e8e0b3c6a$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $hrhRj(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $315a9a2e8e0b3c6a$var$parse($315a9a2e8e0b3c6a$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $315a9a2e8e0b3c6a$var$decode(hash, options)
    } : {});
};
$315a9a2e8e0b3c6a$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$315a9a2e8e0b3c6a$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $315a9a2e8e0b3c6a$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $315a9a2e8e0b3c6a$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $315a9a2e8e0b3c6a$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $315a9a2e8e0b3c6a$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $315a9a2e8e0b3c6a$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$315a9a2e8e0b3c6a$var$encodeFragmentIdentifier] ? $315a9a2e8e0b3c6a$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$315a9a2e8e0b3c6a$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$315a9a2e8e0b3c6a$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $315a9a2e8e0b3c6a$export$7a5253c0f62e0150(input, options);
    return $315a9a2e8e0b3c6a$export$a8c1621ea79325d3({
        url: url,
        query: $75EYe(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$315a9a2e8e0b3c6a$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $315a9a2e8e0b3c6a$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("dQJfb", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("bCuqp", function(module, exports) {
'use strict';
var $875ad812cf6a8c24$var$token = '%[a-f0-9]{2}';
var $875ad812cf6a8c24$var$singleMatcher = new RegExp('(' + $875ad812cf6a8c24$var$token + ')|([^%]+?)', 'gi');
var $875ad812cf6a8c24$var$multiMatcher = new RegExp('(' + $875ad812cf6a8c24$var$token + ')+', 'gi');
function $875ad812cf6a8c24$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $875ad812cf6a8c24$var$decodeComponents(left), $875ad812cf6a8c24$var$decodeComponents(right));
}
function $875ad812cf6a8c24$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($875ad812cf6a8c24$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $875ad812cf6a8c24$var$decodeComponents(tokens, i).join('');
            tokens = input.match($875ad812cf6a8c24$var$singleMatcher) || [];
        }
        return input;
    }
}
function $875ad812cf6a8c24$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $875ad812cf6a8c24$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $875ad812cf6a8c24$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $875ad812cf6a8c24$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $875ad812cf6a8c24$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("hrhRj", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("75EYe", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});


parcelRegister("h1cme", function(module, exports) {
$parcel$export(module.exports, "mapKeys", () => $3083c6978c767aac$export$781522908e4e76a1);
$parcel$export(module.exports, "pick", () => $3083c6978c767aac$export$357523c63a2253b9);
$parcel$export(module.exports, "omitBy", () => $3083c6978c767aac$export$d7a617dda645b4e3);
$parcel$export(module.exports, "pickBy", () => $3083c6978c767aac$export$b460b275d6c6aa0);
$parcel$export(module.exports, "omit", () => $3083c6978c767aac$export$30a06c8d3562193f);
$parcel$export(module.exports, "equals", () => $3083c6978c767aac$export$e9bab7fafb253603);
$parcel$export(module.exports, "partition", () => $3083c6978c767aac$export$b29f828819edca8d);
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $3083c6978c767aac$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $3083c6978c767aac$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $3083c6978c767aac$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $3083c6978c767aac$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $3083c6978c767aac$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $3083c6978c767aac$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$3083c6978c767aac$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $3083c6978c767aac$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});



parcelRegister("dppwe", function(module, exports) {
$parcel$export(module.exports, "isFirstParty", () => $8cbb1faf61e37fb8$export$f56713ced121eb91);
$parcel$export(module.exports, "isThirdParty", () => $8cbb1faf61e37fb8$export$ab34f90cc32c8960);

var $jgvOT = parcelRequire("jgvOT");
const $8cbb1faf61e37fb8$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $jgvOT.productEmbedType).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $8cbb1faf61e37fb8$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $jgvOT.productEmbedType).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};

});

parcelRegister("jIhZ8", function(module, exports) {
$parcel$export(module.exports, "buildActionFields", () => $1a9f5c1826e17b46$export$655ecf7241feac42);
$parcel$export(module.exports, "buildScreenEvent", () => $1a9f5c1826e17b46$export$c7d9a5f56acc4b19);
$parcel$export(module.exports, "buildActionName", () => $1a9f5c1826e17b46$export$9c5623a792efc9b0);
$parcel$export(module.exports, "buildContext", () => $1a9f5c1826e17b46$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "buildActionEvent", () => $1a9f5c1826e17b46$export$7bf451af4a8e3dd9);

var $jgvOT = parcelRequire("jgvOT");

var $7DGHv = parcelRequire("7DGHv");
const $1a9f5c1826e17b46$var$libraryVersion = undefined;
function $1a9f5c1826e17b46$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $1a9f5c1826e17b46$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $1a9f5c1826e17b46$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $1a9f5c1826e17b46$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $1a9f5c1826e17b46$var$buildCollaborationContextFields(collaborationContextInfo) {
    return {
        collaborationContextAri: collaborationContextInfo.collaborationContextAri
    };
}
function $1a9f5c1826e17b46$var$buildAliases(aliases) {
    if ($1a9f5c1826e17b46$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $1a9f5c1826e17b46$var$buildGroups(groups) {
    if ($1a9f5c1826e17b46$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $1a9f5c1826e17b46$var$buildEventOverrides(event) {
    let result = {};
    if (event.anonymousId) result.anonymousId = event.anonymousId;
    if (event.excludedProperties) result.excludedProperties = event.excludedProperties;
    if (event.userConsents) result.userConsents = event.userConsents;
    return result;
}
function $1a9f5c1826e17b46$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $1a9f5c1826e17b46$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $1a9f5c1826e17b46$var$getProductField(productInfo.env, overrides.env);
    const product = $1a9f5c1826e17b46$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $1a9f5c1826e17b46$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $1a9f5c1826e17b46$var$getProductField(productInfo.version, overrides.version);
    const origin = $1a9f5c1826e17b46$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $1a9f5c1826e17b46$var$getProductField(productInfo.platform, overrides.platform);
    const ic = productInfo.ic; // ic should not be overriden once set
    const cdp = productInfo.cdp;
    const csp = productInfo.csp;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform,
        ic: ic,
        cdp: cdp,
        csp: csp
    };
}
function $1a9f5c1826e17b46$var$isNotEmptyObject(obj) {
    return (0, $7DGHv.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $1a9f5c1826e17b46$var$buildAttributesWithName(name, attrObject) {
    return $1a9f5c1826e17b46$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $1a9f5c1826e17b46$var$buildAttributes(attributes) {
    return $1a9f5c1826e17b46$var$buildAttributesWithName('attributes', attributes);
}
function $1a9f5c1826e17b46$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $1a9f5c1826e17b46$export$f045f238d77c002a(containers) {
    if ($1a9f5c1826e17b46$var$isNotEmptyObject(containers)) {
        const validContainers = $1a9f5c1826e17b46$export$3f5115a568819c1a(containers);
        return $1a9f5c1826e17b46$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $1a9f5c1826e17b46$export$655ecf7241feac42(event, actionEventType) {
    return {
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType,
        ...$1a9f5c1826e17b46$export$f045f238d77c002a(event.containers)
    };
}
function $1a9f5c1826e17b46$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $1a9f5c1826e17b46$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $1a9f5c1826e17b46$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, event, containers, aliases, groups) {
    const productFields = $1a9f5c1826e17b46$var$buildProductFields(productInfo);
    const tenantFields = $1a9f5c1826e17b46$var$buildTenantFields(tenantInfo);
    const userFields = $1a9f5c1826e17b46$var$buildUserFields(userInfo);
    const orgFields = $1a9f5c1826e17b46$var$buildOrgFields(orgInfo);
    const workspaceFields = $1a9f5c1826e17b46$var$buildWorkspaceFields(workspaceInfo);
    const collaborationContextFields = $1a9f5c1826e17b46$var$buildCollaborationContextFields(collaborationContextInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $jgvOT.eventType).SCREEN
    };
    return {
        ...productFields,
        ...tenantFields,
        ...userFields,
        ...orgFields,
        ...overrides,
        ...$1a9f5c1826e17b46$var$buildAttributes(attributes),
        ...$1a9f5c1826e17b46$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes),
        ...$1a9f5c1826e17b46$export$f045f238d77c002a(containers),
        ...$1a9f5c1826e17b46$var$buildEventOverrides(event),
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...$1a9f5c1826e17b46$var$buildAliases(aliases),
        ...$1a9f5c1826e17b46$var$buildGroups(groups)
    };
}
function $1a9f5c1826e17b46$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
var $1a9f5c1826e17b46$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $1a9f5c1826e17b46$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return "quiet";
    if (environment.includes('prod')) return "quiet";
    return "complete";
}
function $1a9f5c1826e17b46$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $1a9f5c1826e17b46$var$libraryVersion
            },
            validationMode: $1a9f5c1826e17b46$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $1a9f5c1826e17b46$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $1a9f5c1826e17b46$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, interactionSession, orgInfo, pageLoadId, workspaceInfo, collaborationContextInfo, aliases, groups) {
    const productFields = $1a9f5c1826e17b46$var$buildProductFields(productInfo, $1a9f5c1826e17b46$export$e3d99b4bfec06f6e(event));
    const tenantFields = $1a9f5c1826e17b46$var$buildTenantFields(tenantInfo);
    const orgFields = $1a9f5c1826e17b46$var$buildOrgFields(orgInfo);
    const workspaceFields = $1a9f5c1826e17b46$var$buildWorkspaceFields(workspaceInfo);
    const collaborationContextFields = $1a9f5c1826e17b46$var$buildCollaborationContextFields(collaborationContextInfo);
    const userFields = $1a9f5c1826e17b46$var$buildUserFields(userInfo);
    const actionFields = $1a9f5c1826e17b46$export$655ecf7241feac42(event, actionEventType);
    return {
        ...productFields,
        ...tenantFields,
        ...orgFields,
        ...userFields,
        ...actionFields,
        ...$1a9f5c1826e17b46$var$buildEventOverrides(event),
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        interactionSession: interactionSession,
        pageLoadId: pageLoadId,
        ...workspaceFields,
        ...collaborationContextFields,
        ...$1a9f5c1826e17b46$var$buildAliases(aliases),
        ...$1a9f5c1826e17b46$var$buildGroups(groups)
    };
}

});
parcelRegister("7DGHv", function(module, exports) {
$parcel$export(module.exports, "isPlainObject", () => $2c4ecbfd086d9442$export$53b83ca8eaab0383);
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $2c4ecbfd086d9442$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $2c4ecbfd086d9442$var$isObjectObject(o) {
    return $2c4ecbfd086d9442$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $2c4ecbfd086d9442$export$53b83ca8eaab0383(o) {
    if ($2c4ecbfd086d9442$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($2c4ecbfd086d9442$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("hxQP5", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcfa6fce0d2d317d$export$2e2bcd8739ae039);

var $1BNmo = parcelRequire("1BNmo");

var $jTwxQ = parcelRequire("jTwxQ");

var $khsnI = parcelRequire("khsnI");
class $bcfa6fce0d2d317d$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        };
        this.startLowPriorityEventDelay = (timeout = (0, $1BNmo.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $1BNmo.MAX_DELAY_TIMEOUT)) : (0, $1BNmo.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $khsnI.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        };
        this.stopLowPriorityEventDelay = (reason = (0, $khsnI.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        };
        this.isDelayingLowPriorityEvents = ()=>this.isDelaying;
        this.isDelaying = false;
        this.delayQueue = new (0, $jTwxQ.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("1BNmo", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", () => $305800ec5422ad48$export$cf090d5281b5ae06);
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", () => $305800ec5422ad48$export$8575e30be0feb909);
const $305800ec5422ad48$export$cf090d5281b5ae06 = 10000;
const $305800ec5422ad48$export$8575e30be0feb909 = 30000;

});

parcelRegister("jTwxQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a11682b3f3a85ee$export$2e2bcd8739ae039);

var $jIhZ8 = parcelRequire("jIhZ8");

var $h1cme = parcelRequire("h1cme");

var $gUqK6 = parcelRequire("gUqK6");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $3a11682b3f3a85ee$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $3a11682b3f3a85ee$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $3a11682b3f3a85ee$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        this.push = (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        };
        this.size = ()=>this.eventArgs.length;
        this.startFlush = ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        };
        this.cancelFlush = ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        };
        this.flushNextBatch = ()=>{
            const batch = this.eventArgs.splice(0, $3a11682b3f3a85ee$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $3a11682b3f3a85ee$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        };
        this.compressEventArgs = (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $h1cme.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $h1cme.equals)(group.userInfo, args.userInfo) && (0, $h1cme.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $jIhZ8.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        };
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $gUqK6.default)(compressionRules);
    }
}

});
parcelRegister("gUqK6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a7b8c4917a0ae58$export$2e2bcd8739ae039);
/* eslint-disable implicit-arrow-linebreak */ /* eslint-disable max-classes-per-file */ 
var $jIhZ8 = parcelRequire("jIhZ8");

var $h1cme = parcelRequire("h1cme");

var $aAzir = parcelRequire("aAzir");
class $7a7b8c4917a0ae58$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        this.canCompress = (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event));
        this.compress = (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        };
        this.createGroups = (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $jIhZ8.buildActionFields)(event, event.eventType);
                    contextFields = (0, $h1cme.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $h1cme.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []);
        this.compressGroup = (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>({
                        ...actionFields,
                        ...group.contextFields
                    }));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                // console.warn(
                // 	'Failed to compress some analytics events. ' +
                // 		`Error: ${(e as Error).message}. Sending ${
                // 			group.events.length
                // 		} uncompressed events instead`,
                // );
                return group.events;
            }
        };
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $aAzir.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("aAzir", function(module, exports) {
$parcel$export(module.exports, "CompressionRule", () => $fb506e72bdfde74b$export$89b3253ddfd2e6e8);

var $u00Sd = parcelRequire("u00Sd");

var $h1cme = parcelRequire("h1cme");
class $fb506e72bdfde74b$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
   * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
   * @param event
   * @returns {boolean}
   */ this.canCompress = (event)=>{
            try {
                return event && (0, $u00Sd.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        };
        /**
   * This function compresses as many events in the given collection as possible.<p>
   * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
   * appended to the end of the resulting array.
   *
   * @param events A collection of analytic events to compress
   * @returns {Array.<Object>} The action fields for the resulting compressed events
   */ this.compress = (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $h1cme.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $u00Sd.validateActionEventType)(event.eventType);
                (0, $u00Sd.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        };
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("u00Sd", function(module, exports) {
$parcel$export(module.exports, "validateContainers", () => $322c627b2fc992b0$export$e63ea5d8477971d3);
$parcel$export(module.exports, "isActionEventType", () => $322c627b2fc992b0$export$d19cebda16f7579a);
$parcel$export(module.exports, "validateActionEventType", () => $322c627b2fc992b0$export$4a8d7476662aebcc);
$parcel$export(module.exports, "validateActionEvent", () => $322c627b2fc992b0$export$e0c121325c66ed4c);
$parcel$export(module.exports, "validateScreenEvent", () => $322c627b2fc992b0$export$dc993432a592dc27);
$parcel$export(module.exports, "validateTrackEvent", () => $322c627b2fc992b0$export$8c014fd74b0c8b99);
$parcel$export(module.exports, "validateUIEvent", () => $322c627b2fc992b0$export$e5bac0930c812e90);
$parcel$export(module.exports, "validateOperationalEvent", () => $322c627b2fc992b0$export$1e561554275607ef);
$parcel$export(module.exports, "validateIdentifyEvent", () => $322c627b2fc992b0$export$c16a4e16aa4026c0);
$parcel$export(module.exports, "validatePlatform", () => $322c627b2fc992b0$export$801b46c35394d316);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $jgvOT = parcelRequire("jgvOT");

var $7DGHv = parcelRequire("7DGHv");
const $322c627b2fc992b0$var$actionEventTypes = Object.freeze([
    (0, $jgvOT.eventType).OPERATIONAL,
    (0, $jgvOT.eventType).TRACK,
    (0, $jgvOT.eventType).UI
]);
function $322c627b2fc992b0$export$df8ff30e3c960006(container) {
    if (!(0, $7DGHv.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $322c627b2fc992b0$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$322c627b2fc992b0$export$df8ff30e3c960006(container));
}
function $322c627b2fc992b0$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $jgvOT.eventType).OPERATIONAL:
        case (0, $jgvOT.eventType).TRACK:
        case (0, $jgvOT.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $322c627b2fc992b0$export$4a8d7476662aebcc(type) {
    if (!$322c627b2fc992b0$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$322c627b2fc992b0$var$actionEventTypes}]`);
    return true;
}
function $322c627b2fc992b0$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $322c627b2fc992b0$export$e63ea5d8477971d3(event.containers);
}
function $322c627b2fc992b0$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $322c627b2fc992b0$export$8c014fd74b0c8b99(event) {
    $322c627b2fc992b0$export$e0c121325c66ed4c(event);
}
function $322c627b2fc992b0$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $322c627b2fc992b0$export$e5bac0930c812e90(event) {
    $322c627b2fc992b0$export$e0c121325c66ed4c(event);
}
function $322c627b2fc992b0$export$1e561554275607ef(event) {
    $322c627b2fc992b0$export$e0c121325c66ed4c(event);
}
function $322c627b2fc992b0$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $jgvOT.isType)((0, $jgvOT.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $jgvOT.objectValues)((0, $jgvOT.userType))}]`);
}
function $322c627b2fc992b0$export$801b46c35394d316(productInfo) {
    if (!(0, $jgvOT.isType)((0, $jgvOT.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $jgvOT.objectValues)((0, $jgvOT.platformType))}]`);
    if (productInfo.origin === (0, $jgvOT.originType).DESKTOP && !(0, $jgvOT.isType)((0, $jgvOT.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $jgvOT.originType).WEB && !(0, $jgvOT.isType)((0, $jgvOT.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("khsnI", function(module, exports) {
$parcel$export(module.exports, "StopLowPriorityEventDelayReason", () => $d349f05f447bb552$export$fa6e3729c21cb8f);
var $d349f05f447bb552$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("7EHuW", function(module, exports) {
$parcel$export(module.exports, "default", () => $018bdfaf40b44597$export$2e2bcd8739ae039);

var $gv9yA = parcelRequire("gv9yA");

var $fNYmy = parcelRequire("fNYmy");

var $btxai = parcelRequire("btxai");

var $jjxvX = parcelRequire("jjxvX");

var $aS3sl = parcelRequire("aS3sl");

var $eK0i6 = parcelRequire("eK0i6");

var $ct1Xw = parcelRequire("ct1Xw");

var $e9CqI = parcelRequire("e9CqI");

var $lxuL3 = parcelRequire("lxuL3");

var $iIOQe = parcelRequire("iIOQe");
class $018bdfaf40b44597$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports === undefined ? null : this.validationReports;
    }
}
class $018bdfaf40b44597$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $018bdfaf40b44597$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $018bdfaf40b44597$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $018bdfaf40b44597$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $018bdfaf40b44597$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $018bdfaf40b44597$export$2e2bcd8739ae039 {
    constructor(options){
        this.originTracingClient = null;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        this.sendEvents = async (items, callback)=>{
            var _this$lastSendEventsE, _this$metadataClient;
            if (this.options.enableEventCalls === false) return;
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const metadataInfo = await this.metadataClient.getMetadataAsync();
            const [eventUrl, isFallbackUrl] = this.getEventUrl(metadataInfo);
            const metadata = {
                ...metricsPayload,
                httpRetryCount: httpRetryCount,
                lastSendEventsErrorReason: ((_this$lastSendEventsE = this.lastSendEventsError) === null || _this$lastSendEventsE === void 0 ? void 0 : _this$lastSendEventsE.message) || null,
                // Temporary back-compat
                lastSendEventsError: this.lastSendEventsError,
                lastUrlFallbackError: this.lastUrlFallbackError,
                isUsingFallbackUrl: isFallbackUrl,
                props: (metadataInfo === null || metadataInfo === void 0 ? void 0 : metadataInfo.props) || null,
                metadataClientMetrics: ((_this$metadataClient = this.metadataClient) === null || _this$metadataClient === void 0 ? void 0 : _this$metadataClient.metrics) || null
            };
            // Remove default values from metadata to save space
            this.cleanLibraryMetadata(metadata);
            const unpackagedEvents = eventsWithXID.map((item)=>{
                this.applyExclusions(item);
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                var _this$originTracingCl;
                const response = await (0, $ct1Xw.sendEvents)({
                    url: eventUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.lastSendEventsError = null;
                this.lastUrlFallbackError = null;
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                (_this$originTracingCl = this.originTracingClient) === null || _this$originTracingCl === void 0 || _this$originTracingCl.cleanupOriginParameters(items);
                await this.invokeLocalResponseCallbackAsync(items, response, null);
            } catch (error) {
                // If there's an error, other than one which indicates a temporary problem with the service,
                // we'll stop using the URL from the metadata and fall back to the default URL. After a time
                // we'll fall forward again in case the problem has been resolved.
                if (error instanceof (0, $e9CqI.FetchError) && [
                    429,
                    503
                ].includes(error.statusCode)) // Ignore 429 and 503 errors since they're considered to indicate a temporary
                // issue with the service, rather than a network failure due to blocked requests.
                this.lastSendEventsError = new (0, $e9CqI.LastError)('ServerBusyError', error);
                else {
                    const errorName = error instanceof Error && (0, $e9CqI.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
                    this.lastSendEventsError = new (0, $e9CqI.LastError)(errorName, error);
                    // Handle falling back to the default URL if we're using the metadata URL.
                    this.useUrlFromMetadata = false;
                    // If we're now using the fallback URL, and the last attempt wasn't,
                    // we'll record this as the error that triggered the fallback.
                    const [_, willUseFallbackUrl] = this.getEventUrl(metadataInfo);
                    if (willUseFallbackUrl && willUseFallbackUrl !== isFallbackUrl) this.lastUrlFallbackError = this.lastSendEventsError;
                }
                callback(error, null);
                await this.invokeLocalResponseCallbackAsync(items, null, error);
            }
        };
        var _this$options;
        this.options = {
            ...options,
            requestTimeout: options.requestTimeout || (0, $aS3sl.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false,
            env: options.env,
            perimeter: options.perimeter || '',
            enableMetadataCalls: typeof options.enableMetadataCalls === 'boolean' ? options.enableMetadataCalls : true,
            enableEventCalls: typeof options.enableEventCalls === 'boolean' ? options.enableEventCalls : true
        };
        this.user = new (0, $lxuL3.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $fNYmy.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $gv9yA.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.metadataClient = options.metadataClient;
        this.useUrlFromMetadata = true;
        this.lastSendEventsError = null;
        this.lastUrlFallbackError = null;
        setInterval(()=>{
            this.useUrlFromMetadata = true;
        }, 600000);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $e9CqI.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $e9CqI.SegmentEventTypes).TRACK,
            properties: (0, $iIOQe.prepareEventProperties)(builtEvent),
            event: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $e9CqI.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $e9CqI.SegmentEventTypes).PAGE,
            properties: (0, $iIOQe.prepareEventProperties)(builtEvent),
            name: eventName
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $e9CqI.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = {
            ...baseEvent,
            type: (0, $e9CqI.SegmentEventTypes).IDENTIFY,
            traits: (0, $iIOQe.prepareEventProperties)(builtEvent)
        };
        const event = {
            ...eventWithoutMessageId,
            messageId: this.createMessageId()
        };
        const packagedEvent = this.packageEvent(event);
        await this.enqueueEvent(packagedEvent);
        if (callback) callback();
    }
    async enqueueEvent(packagedEvent) {
        if (this.options.enableMetadataCalls) this.metadataClient.start(false); // Start the metadata client if needed
        await this.resilienceQueue.addItem(packagedEvent);
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $iIOQe.prepareEventContext)(context);
        const segmentContext = (0, $iIOQe.buildContext)(clonedContext, overrides);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, $btxai.default)()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    applyExclusions(item) {
        var _msg$context;
        const msg = item.msg;
        const properties = msg.properties;
        const traits = msg.traits;
        const excluded = (_msg$context = msg.context) === null || _msg$context === void 0 ? void 0 : _msg$context.excludedProperties;
        if (!excluded) return;
        if (excluded.anonymousId === true) msg.anonymousId = undefined;
        if (excluded.interactionSession === true) {
            if (properties) properties.interactionSession = undefined;
        }
        if (excluded.sessionId === true) {
            if (properties) properties.sessionId = undefined;
        }
        if (excluded.pageLoadId === true) {
            if (properties) properties.pageLoadId = undefined;
        }
        if (excluded.tabId === true) {
            if (properties) properties.tabId = undefined;
        }
        if (excluded.taskSessions === true) {
            if (properties) properties.taskSessions = undefined;
        }
        if (excluded.userId === true) {
            msg.userId = undefined;
            if (properties) properties.userIdType = undefined;
        }
        if (excluded.xid === true) {
            if (properties) properties.xid = undefined;
            if (traits) traits.xid = undefined;
        }
    }
    getEventUrl(metadataInfo) {
        const preferredBatchUrl = metadataInfo !== null && metadataInfo !== void 0 && metadataInfo.url ? metadataInfo.url : this.gasv3BatchUrl;
        const finalBatchUrl = this.useUrlFromMetadata ? preferredBatchUrl : this.gasv3BatchUrl;
        const isFallbackUrl = preferredBatchUrl === this.gasv3BatchUrl ? null : finalBatchUrl !== preferredBatchUrl;
        return [
            finalBatchUrl,
            isFallbackUrl
        ];
    }
    cleanLibraryMetadata(obj) {
        // skip if the parameter is not an object
        if (obj === null || typeof obj !== 'object') return;
        for(const key in obj){
            // Skip cleaning up props object and its keys
            // to avoid having to check the existence of the fields in props object
            // and manipulate them to calculate metadata signature in analytics service
            if (key === 'props') continue;
            let value = obj[key];
            // Remove null or undefined values
            if (value === null || value === undefined) delete obj[key];
            else if (typeof value === 'number' && value === 0) delete obj[key];
            else if (Array.isArray(value)) {
                if (value.length === 0) delete obj[key];
                else value.forEach((item)=>{
                    this.cleanLibraryMetadata(item);
                });
            } else if (typeof value === 'object') this.cleanLibraryMetadata(obj[key]);
        }
    }
    async invokeLocalResponseCallbackAsync(items, response, error) {
        const localResponseCallback = this.responseCallback;
        if (localResponseCallback) {
            // If we have a response, we'll parse it and create an AnalyticsAPIResponse from it.
            let analyticsAPIResponse = null;
            if (response) {
                var _responseObject$messa;
                let responseObject;
                try {
                    responseObject = await response.clone().json();
                } catch  {
                // Ignore errors parsing the response, we can't do anything about them
                }
                // Ensure we've got a valid object to work with, filling in any missing
                // properties as best we can.
                responseObject = responseObject || {};
                responseObject.code = Number.parseInt(responseObject.code) > 0 ? Number.parseInt(responseObject.code) : response.status;
                responseObject.success = responseObject.success || responseObject.code >= 200 && responseObject.code <= 299;
                analyticsAPIResponse = new $018bdfaf40b44597$var$AnalyticsAPIResponse(responseObject.success, responseObject.validationErrors || new Map(), new $018bdfaf40b44597$var$Message(((_responseObject$messa = responseObject.message) === null || _responseObject$messa === void 0 ? void 0 : _responseObject$messa.error) || ''), responseObject.code, responseObject.validationReports || null);
            }
            // If we have an error, but it's not an instance of Error (e.g. it's a string), we'll convert it to an Error object.
            if (error && !(error instanceof Error)) error = new Error(String(error));
            const analyticsResponse = $018bdfaf40b44597$var$BatchInterceptor.toAnalyticsResponse(items || [], error || null, // In case 'error' were to be undefined we'll convert it to null.
            analyticsAPIResponse);
            localResponseCallback(analyticsResponse);
        }
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $jjxvX.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    /** @internal Used by AnalyticsWebClient to wire up origin tracing cleanup. */ setOriginTracingClient(client) {
        this.originTracingClient = client;
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    refreshMetadata(userInfo, tenantInfo) {
        this.metadataClient.userInfo = userInfo;
        this.metadataClient.tenantInfo = tenantInfo;
    }
}
class $018bdfaf40b44597$var$BatchInterceptor {
    static #_ = this.http_error_regex = /HTTP Error\s([0-9]{3})\s\((.+)\)/;
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $018bdfaf40b44597$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $018bdfaf40b44597$export$133650fcdde1b226(success, statusCode, (0, $eK0i6.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $eK0i6.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $eK0i6.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $eK0i6.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $018bdfaf40b44597$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $018bdfaf40b44597$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error !== void 0 && error.message) {
            const match = error.message.match($018bdfaf40b44597$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $018bdfaf40b44597$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $018bdfaf40b44597$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $018bdfaf40b44597$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $018bdfaf40b44597$export$133650fcdde1b226(false, -1, (0, $eK0i6.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}

});
parcelRegister("gv9yA", function(module, exports) {
$parcel$export(module.exports, "default", () => $39ebf44219278105$export$2e2bcd8739ae039);

var $l08MF = parcelRequire("l08MF");

var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$39ebf44219278105$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $l08MF.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("l08MF", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_POLLING_OPTIONS", () => $8d6a74693fd11cc2$export$d219df4fe04c04a7);
$parcel$export(module.exports, "default", () => $8d6a74693fd11cc2$export$2e2bcd8739ae039);

var $jNrPa = parcelRequire("jNrPa");
var $gTbsn = parcelRequire("gTbsn");

var $buqsA = parcelRequire("buqsA");
var $eltRl = parcelRequire("eltRl");
var $5A0Gp = parcelRequire("5A0Gp");

var $fNYmy = parcelRequire("fNYmy");

var $87oxp = parcelRequire("87oxp");

var $1iJ8Z = parcelRequire("1iJ8Z");
var $2LX4q = parcelRequire("2LX4q");

var $jwyxW = parcelRequire("jwyxW");
const $8d6a74693fd11cc2$var$ONE_MINUTE = 60000;
const $8d6a74693fd11cc2$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $8d6a74693fd11cc2$var$ONE_MINUTE,
    minRetryDelay: $8d6a74693fd11cc2$var$ONE_MINUTE,
    maxRetryDelay: $8d6a74693fd11cc2$var$ONE_MINUTE
};
const $8d6a74693fd11cc2$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // The maximum number of events that can be stored in the resilience queue (IndexedDB/memory).
    // This limit is per product and is enforced by the EventCountGuard in the resilience layer.
    maxQueueSize: 8000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $8d6a74693fd11cc2$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $eltRl.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.maxQueueSize
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $1iJ8Z.default)({
            ...this.options,
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }, this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $1iJ8Z.default)({
            ...$8d6a74693fd11cc2$var$LONG_POLLING_OPTIONS,
            waitInterval: $8d6a74693fd11cc2$var$LONG_POLLING_OPTIONS.flushWaitMs
        }, this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $fNYmy.default)();
        this.networkStatus = new (0, $87oxp.default)((status)=>{
            if (status === (0, $jwyxW.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $5A0Gp.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $jwyxW.NetworkStatusEnum).OFFLINE) {
            done((0, $2LX4q.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $buqsA.CallbackProcessingErrorName)) {
                done((0, $2LX4q.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $jNrPa.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $gTbsn.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $5A0Gp.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $2LX4q.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $2LX4q.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $2LX4q.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $8d6a74693fd11cc2$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.flushWaitMs,
            maxQueueSize: (options === null || options === void 0 ? void 0 : options.maxQueueSize) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.maxQueueSize,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $8d6a74693fd11cc2$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}

});
parcelRegister("jNrPa", function(module, exports) {
$parcel$export(module.exports, "default", () => $1095de92a240e192$export$2e2bcd8739ae039);

var $f6bEN = parcelRequire("f6bEN");

var $kvHQI = parcelRequire("kvHQI");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $1095de92a240e192$var$validSuffixs = Object.values((0, $f6bEN.LocalStorageKeySuffix));
var $1095de92a240e192$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $1095de92a240e192$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $f6bEN.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $kvHQI.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("f6bEN", function(module, exports) {
$parcel$export(module.exports, "LocalStorageKeySuffix", () => $d561c69981be7a3e$export$ecfa71cbc9b28241);
$parcel$export(module.exports, "Timers", () => $d561c69981be7a3e$export$8bb2c1fb2b1765a9);
var $d561c69981be7a3e$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
var $d561c69981be7a3e$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("kvHQI", function(module, exports) {
$parcel$export(module.exports, "createLocalStorageKeys", () => $1e258dc3ffc3a600$export$8433d54f767cbec5);

var $f6bEN = parcelRequire("f6bEN");
const $1e258dc3ffc3a600$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $f6bEN.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $f6bEN.LocalStorageKeySuffix).ACK}`,
        [(0, $f6bEN.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $f6bEN.LocalStorageKeySuffix).QUEUE}`,
        [(0, $f6bEN.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $f6bEN.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $f6bEN.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $f6bEN.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $f6bEN.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $f6bEN.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("gTbsn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4163f9e22472c37$export$2e2bcd8739ae039);

var $btxai = parcelRequire("btxai");

var $f6bEN = parcelRequire("f6bEN");

var $kvHQI = parcelRequire("kvHQI");
const $e4163f9e22472c37$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $e4163f9e22472c37$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $f6bEN.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $f6bEN.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch  {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch  {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $e4163f9e22472c37$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $e4163f9e22472c37$var$promisedSetTimeout((0, $f6bEN.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $f6bEN.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $e4163f9e22472c37$var$promisedSetTimeout((0, $f6bEN.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $f6bEN.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $e4163f9e22472c37$var$reclaim(options, callback);
};
const $e4163f9e22472c37$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = {
            ...item,
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        };
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $e4163f9e22472c37$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $e4163f9e22472c37$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $e4163f9e22472c37$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $e4163f9e22472c37$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, $btxai.default)();
    const queuesToReclaim = $e4163f9e22472c37$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$e4163f9e22472c37$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $kvHQI.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});
parcelRegister("btxai", function(module, exports) {
$parcel$export(module.exports, "default", () => $59a8c32bda112b45$export$2e2bcd8739ae039);
// UUID v4 generator with fallback for non-secure contexts
function $59a8c32bda112b45$export$2e2bcd8739ae039() {
    const g = globalThis;
    try {
        if (g.crypto && typeof g.crypto.randomUUID === 'function') return g.crypto.randomUUID();
    } catch  {
    // ignore and fallback
    }
    // Fallback to Math.random-based v4 UUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.floor(Math.random() * 16);
        const v = c === 'x' ? r : r & 0x3 | 0x8; // x => random hex digit; y => set RFC 4122 variant bits (10xx), yielding 8, 9, a, or b
        return v.toString(16);
    });
}

});


parcelRegister("buqsA", function(module, exports) {
$parcel$export(module.exports, "CallbackProcessingErrorName", () => $9eacf8fc7120ac2b$export$a409c8de90e11e14);
$parcel$export(module.exports, "default", () => $9eacf8fc7120ac2b$export$2e2bcd8739ae039);
const $9eacf8fc7120ac2b$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $9eacf8fc7120ac2b$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $9eacf8fc7120ac2b$export$2e2bcd8739ae039.prototype);
        this.name = $9eacf8fc7120ac2b$export$a409c8de90e11e14;
    }
}

});

parcelRegister("eltRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dfb77921df5ce0d$export$2e2bcd8739ae039);

var $8FagS = parcelRequire("8FagS");

var $5A0Gp = parcelRequire("5A0Gp");

var $buqsA = parcelRequire("buqsA");
var $1dfb77921df5ce0d$export$2e2bcd8739ae039 = (0, $8FagS.default);

});
parcelRegister("8FagS", function(module, exports) {
$parcel$export(module.exports, "default", () => $62f42d5bad8ed109$export$2e2bcd8739ae039);

var $5A0Gp = parcelRequire("5A0Gp");

var $9AUmM = parcelRequire("9AUmM");
var $80bfs = parcelRequire("80bfs");

var $4OcC4 = parcelRequire("4OcC4");

var $l3bAc = parcelRequire("l3bAc");

var $acXZx = parcelRequire("acXZx");
class $62f42d5bad8ed109$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $acXZx.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $4OcC4.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $9AUmM.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $l3bAc.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $5A0Gp.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $5A0Gp.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $80bfs.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $5A0Gp.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $l3bAc.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $5A0Gp.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
}

});
parcelRegister("5A0Gp", function(module, exports) {
$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", () => $b4ea62edd8f09532$export$d21fbb25eb37b5bf);
$parcel$export(module.exports, "RESILIENCE_DB_NAME", () => $b4ea62edd8f09532$export$8cad224051643259);
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", () => $b4ea62edd8f09532$export$3d8420be07b276ab);
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", () => $b4ea62edd8f09532$export$a512a65455fce2a6);
$parcel$export(module.exports, "TIME_ADDED_INDEX", () => $b4ea62edd8f09532$export$89d9c1ff8ac91862);
$parcel$export(module.exports, "RETRY_INDEX", () => $b4ea62edd8f09532$export$a37d385bcd713809);
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", () => $b4ea62edd8f09532$export$6d8635fed0e4b14d);
$parcel$export(module.exports, "StoreType", () => $b4ea62edd8f09532$export$39337ab5872e9457);
$parcel$export(module.exports, "GuardPolicy", () => $b4ea62edd8f09532$export$7710d69e6f450f20);
const $b4ea62edd8f09532$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $b4ea62edd8f09532$export$8cad224051643259 = 'analytics-web-client';
const $b4ea62edd8f09532$export$3d8420be07b276ab = 'analytics-resilience';
const $b4ea62edd8f09532$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $b4ea62edd8f09532$export$89d9c1ff8ac91862 = 'timeAdded';
const $b4ea62edd8f09532$export$a37d385bcd713809 = 'retryAttempts';
const $b4ea62edd8f09532$export$6d8635fed0e4b14d = 15000;
var $b4ea62edd8f09532$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
var $b4ea62edd8f09532$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    // Adds as many items as possible and IGONRES the rest.
    // Only to be used with BulkAdd
    GuardPolicy["IGNORE"] = "ignore";
    // ABANDON the request if not all items can be added.
    GuardPolicy["ABANDON"] = "abandon";
    // EVICT old items to make room for new items if space is tight.
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("9AUmM", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd9ca31513ce8276$export$2e2bcd8739ae039);
const $dd9ca31513ce8276$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $dd9ca31513ce8276$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $dd9ca31513ce8276$export$2e2bcd8739ae039.prototype);
        this.name = $dd9ca31513ce8276$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("80bfs", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreResilienceDbError", () => $046f03719a6c1a9c$export$74101021e0969375);

var $9pqne = parcelRequire("9pqne");

var $buqsA = parcelRequire("buqsA");

var $dZYCK = parcelRequire("dZYCK");
const $046f03719a6c1a9c$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $9pqne.AbandonWriteErrorName) || errorWithName.name === (0, $buqsA.CallbackProcessingErrorName) || errorWithName.name === (0, $dZYCK.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("9pqne", function(module, exports) {
$parcel$export(module.exports, "AbandonWriteErrorName", () => $0e78a4ef2ce07902$export$ba95206613c96b28);
$parcel$export(module.exports, "default", () => $0e78a4ef2ce07902$export$2e2bcd8739ae039);
const $0e78a4ef2ce07902$export$ba95206613c96b28 = 'AbandonWriteError';
class $0e78a4ef2ce07902$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0e78a4ef2ce07902$export$2e2bcd8739ae039.prototype);
        this.name = $0e78a4ef2ce07902$export$ba95206613c96b28;
    }
}

});

parcelRegister("dZYCK", function(module, exports) {
$parcel$export(module.exports, "InvalidPolicyErrorName", () => $a382ff02abd514b7$export$7e7aee9a953465ec);
$parcel$export(module.exports, "default", () => $a382ff02abd514b7$export$2e2bcd8739ae039);
const $a382ff02abd514b7$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $a382ff02abd514b7$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $a382ff02abd514b7$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("4OcC4", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8b940176e269e0b$export$2e2bcd8739ae039);

var $5A0Gp = parcelRequire("5A0Gp");

var $8qT5Y = parcelRequire("8qT5Y");

var $buqsA = parcelRequire("buqsA");
var $dZYCK = parcelRequire("dZYCK");
var $9AUmM = parcelRequire("9AUmM");
var $80bfs = parcelRequire("80bfs");

var $bHbtI = parcelRequire("bHbtI");

var $acXZx = parcelRequire("acXZx");
class $e8b940176e269e0b$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.startDB = async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $9AUmM.default)());
                    }, (0, $5A0Gp.INDEXEDDB_TIMEOUT));
                    /*
         * The database version number can never change.
         * An upgrade transaction is limited to only one connection to the database.
         * Once this is done, we cannot open any connections with older versions of the schema.
         * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
         *
         * Due to the nature of how AWC is used (multiple tabs that are very long lived),
         * we will not be able to run version upgrades via indexeddb.
         *
         * This does not mean we cant change what is stored in the tables,
         * this limitation just prevents us from:
         *   - Creating new ObjectStores in this database connection, and
         *   - Creating new indexes on our ObjectStores
         *
         * Any upgrades we wish to run in the future will have to create a new database,
         * and migrate all the data from older databases.
         *
         * This also means any migrations we make will have to be supported until we have evidence
         * that no events are coming from old versions of the database.
         * This may take a long time.
         */ const request = window.indexedDB.open((0, $5A0Gp.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $5A0Gp.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $5A0Gp.TIME_TO_PROCESS_AFTER_INDEX), (0, $5A0Gp.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $5A0Gp.RETRY_INDEX), (0, $5A0Gp.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $5A0Gp.TIME_ADDED_INDEX), (0, $5A0Gp.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $5A0Gp.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $9AUmM.default)());
                    };
                    try {
                        await (0, $acXZx.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $9AUmM.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $9AUmM.default)());
                }
            });
        };
        this.addItem = async (item, options = {}, policy = (0, $5A0Gp.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $acXZx.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $5A0Gp.GuardPolicy).IGNORE) throw new (0, $dZYCK.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $80bfs.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.bulkAddItem = async (itemOptions, policy = (0, $5A0Gp.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map(({ item: item, ...options })=>(0, $acXZx.convertToItemWrapper)(item, namespace, options));
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $80bfs.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        };
        this.getItems = async (count = (0, $8qT5Y.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $8qT5Y.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $5A0Gp.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = {
                            ...cursor.value
                        };
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $8qT5Y.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $acXZx.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $acXZx.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $acXZx.commitTransaction)(transaction, this.logger);
            return getResult;
        };
        this.deleteItems = async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $acXZx.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        this.getItemCount = async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $5A0Gp.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $acXZx.requestToPromise)(request);
            await (0, $acXZx.commitTransaction)(transaction, this.logger);
            return event.target.result;
        };
        this.processItems = async (processFn, count = (0, $8qT5Y.GET_ITEM_COUNT))=>{
            const { items: items, ...partialResult } = await this.getItems(count);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $buqsA.default)(error);
            }
        };
        this.deleteItem = async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $acXZx.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        };
        this.getObjectStoreAndTransaction = async (mode)=>{
            const transaction = (await this.db).transaction((0, $5A0Gp.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $5A0Gp.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        };
        this.options = (0, $acXZx.createOptionsWithDefaults)(options);
        this.namespace = namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $9AUmM.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $bHbtI.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $5A0Gp.StoreType).INDEXEDDB;
    }
}

});
parcelRegister("8qT5Y", function(module, exports) {
$parcel$export(module.exports, "GET_ITEM_COUNT", () => $9588a1f821bbf090$export$b6df3d334cec060f);
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", () => $9588a1f821bbf090$export$14ef152a03a4b6ee);
$parcel$export(module.exports, "MAX_ATTEMPTS", () => $9588a1f821bbf090$export$da9ab7b2fd5998e8);
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", () => $9588a1f821bbf090$export$1188664dfff364c8);
const $9588a1f821bbf090$export$b6df3d334cec060f = 7;
const $9588a1f821bbf090$export$14ef152a03a4b6ee = 60000;
const $9588a1f821bbf090$export$da9ab7b2fd5998e8 = 10;
const $9588a1f821bbf090$export$1188664dfff364c8 = 8000;

});

parcelRegister("bHbtI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f695f7ac266700c$export$2e2bcd8739ae039);

var $5A0Gp = parcelRequire("5A0Gp");

var $9pqne = parcelRequire("9pqne");

var $acXZx = parcelRequire("acXZx");
class $1f695f7ac266700c$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
   * This query fetches the oldest events currently stored in AWC IndexedDb object store
   * and deletes them sequentially
   */ this.deleteOldestNEvents = async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $5A0Gp.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $acXZx.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $5A0Gp.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $5A0Gp.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $5A0Gp.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $5A0Gp.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $acXZx.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $acXZx.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $9pqne.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $5A0Gp.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $acXZx.requestToPromise)(request);
        return event.target.result;
    }
}

});
parcelRegister("acXZx", function(module, exports) {
$parcel$export(module.exports, "convertToItemWrapper", () => $ba156d5934223134$export$aec476f33d77be11);
$parcel$export(module.exports, "createOptionsWithDefaults", () => $ba156d5934223134$export$ddc6718318090f71);
$parcel$export(module.exports, "requestToPromise", () => $ba156d5934223134$export$85ceed0783e42041);
$parcel$export(module.exports, "commitTransaction", () => $ba156d5934223134$export$feab8418f018df89);
$parcel$export(module.exports, "monitorErrorsOnRequest", () => $ba156d5934223134$export$342d941b6f724995);

var $btxai = parcelRequire("btxai");

var $8qT5Y = parcelRequire("8qT5Y");
const $ba156d5934223134$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, $btxai.default)(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $ba156d5934223134$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $8qT5Y.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $8qT5Y.EVENT_COUNT_LIMIT)
    });
const $ba156d5934223134$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $ba156d5934223134$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $ba156d5934223134$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $ba156d5934223134$export$2a5213bce1720b42(transaction);
};
const $ba156d5934223134$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("l3bAc", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a4d8de9f59278e8$export$2e2bcd8739ae039);

var $5A0Gp = parcelRequire("5A0Gp");

var $8qT5Y = parcelRequire("8qT5Y");

var $buqsA = parcelRequire("buqsA");
var $dZYCK = parcelRequire("dZYCK");

var $9HKRl = parcelRequire("9HKRl");

var $acXZx = parcelRequire("acXZx");
class $4a4d8de9f59278e8$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $acXZx.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $9HKRl.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $5A0Gp.GuardPolicy).ABANDON) {
        if (policy === (0, $5A0Gp.GuardPolicy).IGNORE) throw new (0, $dZYCK.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $acXZx.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $5A0Gp.GuardPolicy).ABANDON) {
        const items = itemOptions.map(({ item: item, ...addOptions })=>(0, $acXZx.convertToItemWrapper)(item, this.namespace, addOptions));
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $5A0Gp.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $8qT5Y.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $8qT5Y.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $8qT5Y.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push({
                    ...wrappedItem
                });
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $8qT5Y.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const { items: items, ...partialGetResult } = this.synchronousGetItems(count);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $buqsA.default)(error);
        }
    }
    storeType() {
        return (0, $5A0Gp.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}

});
parcelRegister("9HKRl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbea88e35417aa35$export$2e2bcd8739ae039);

var $5A0Gp = parcelRequire("5A0Gp");

var $9pqne = parcelRequire("9pqne");
class $fbea88e35417aa35$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
   * Unlike IndexedDb, we cannot take advantage of any index. So we are,
   * treating the memory store as a sorted set when adding items.
   */ this.insertItemsToMemoryStore = (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $5A0Gp.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $5A0Gp.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $5A0Gp.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        };
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $9pqne.default)((0, $5A0Gp.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}

});




parcelRegister("fNYmy", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0b9269f4c8f9abe$export$2e2bcd8739ae039);

var $jwyxW = parcelRequire("jwyxW");
class $d0b9269f4c8f9abe$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        this.itemsDiscardedByRetry = 0;
        // Number of events created by the product in current tab.
        this.eventCount = 0;
        // Number of events discarded due to reaching queue max size.
        this.itemsDiscardedByOverflow = 0;
        // Will be used in the future when we get more resilience mechanisms
        this.resilienceMechanism = (0, $jwyxW.ResilienceMechanism).INDEXEDDB;
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        this.localstorageNumberOfQueuesPurged = 0;
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        this.localstorageNumberOfFullReclaims = 0;
        // Queue was found but not all events were able to be put into resilienceDb.
        this.localstorageNumberOfPartialReclaims = 0;
        // Reclaim failed for a queue and reclaim was abandonded.
        this.localstorageNumberOfFailedReclaims = 0;
    }
}
let $d0b9269f4c8f9abe$var$cachedMetricsClient = null;
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d0b9269f4c8f9abe$export$2e2bcd8739ae039 = ()=>{
    if (!$d0b9269f4c8f9abe$var$cachedMetricsClient) $d0b9269f4c8f9abe$var$cachedMetricsClient = new $d0b9269f4c8f9abe$export$4b62ee5120ab50a8();
    return $d0b9269f4c8f9abe$var$cachedMetricsClient;
};

});
parcelRegister("jwyxW", function(module, exports) {
$parcel$export(module.exports, "ResilienceMechanism", () => $d3a96312199f72d5$export$c75161629e3ec34e);
$parcel$export(module.exports, "NetworkStatusEnum", () => $d3a96312199f72d5$export$ee138fa712d11b84);
var $d3a96312199f72d5$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
var $d3a96312199f72d5$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("87oxp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a279684bf26e0688$export$2e2bcd8739ae039);

var $jwyxW = parcelRequire("jwyxW");
class $a279684bf26e0688$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        this._networkChangeCallback = networkChangeCallback;
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $jwyxW.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $jwyxW.NetworkStatusEnum).ONLINE));
        }
    }
    removeListeners() {
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>this._networkChangeCallback((0, $jwyxW.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>this._networkChangeCallback((0, $jwyxW.NetworkStatusEnum).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $jwyxW.NetworkStatusEnum).ONLINE;
        return (0, $jwyxW.NetworkStatusEnum).OFFLINE;
    }
}

});

parcelRegister("1iJ8Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $75c8212111d2e16a$export$2e2bcd8739ae039);

var $2Xly9 = parcelRequire("2Xly9");

var $2LX4q = parcelRequire("2LX4q");
const $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
var $75c8212111d2e16a$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $75c8212111d2e16a$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        this.schedule = ({ immediate: immediate } = {})=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = 1;
                else if (this.queuedSchedule !== 1) this.queuedSchedule = 2;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Calculate backoff for normal or failure scenario
            } else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
        };
        this.stop = ()=>{
            this.clearTimeout();
            this.queuedSchedule = 0;
        };
        this.getFailureCount = ()=>this.failureCount;
        this.getCallbackStatus = ()=>{
            return this.callbackTimer.getCallbackStatus();
        };
        this.clearTimeout = ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        };
        this.run = ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $2LX4q.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        };
        this.done = (state)=>{
            this.operationInFlight = false;
            if (state === (0, $2LX4q.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $2Xly9.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $2LX4q.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        };
        this.processQueuedSchedule = ()=>{
            if (this.queuedSchedule !== 0) {
                const immediate = this.queuedSchedule === 1;
                this.queuedSchedule = 0;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        };
        this.calculateBackoff = ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage, waitInterval: waitInterval } = this.options;
            // Helper for deviation based on a single random sample
            const jitter = (base, symmetric)=>{
                if (!backoffJitterPercentage || base <= 0) return 0;
                const r = (Math.random() - 0.5) * 2;
                const frac = symmetric ? r : Math.abs(r);
                return Math.floor(frac * backoffJitterPercentage * base);
            };
            // No failures: wait interval with positive-only jitter
            if (this.failureCount === 0) return waitInterval + jitter(waitInterval, false);
            // Failures: exponential backoff with symmetric jitter
            const base = Math.min(minRetryDelay * backoffFactor ** this.failureCount, maxRetryDelay);
            const withJitter = base + jitter(base, true);
            return Math.max(minRetryDelay, Math.min(withJitter, maxRetryDelay));
        };
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $75c8212111d2e16a$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = 0;
        this.callbackTimer = new (0, $2Xly9.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("2Xly9", function(module, exports) {
$parcel$export(module.exports, "CallbackStatus", () => $ca4a1769c81ee684$export$ef3353088fca369c);
$parcel$export(module.exports, "CallbackWithTimeout", () => $ca4a1769c81ee684$export$590a718599f8f8b3);
var $ca4a1769c81ee684$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
var $ca4a1769c81ee684$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $ca4a1769c81ee684$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Tracks the settimeout; so that we can clear the timeout
        this.timeoutHandle = undefined;
        this.callbackStatus = "idle";
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case "idle":
            case "timedOut":
            case "completed":
                if (event === "execute") this.callbackStatus = "running";
                break;
            case "running":
                switch(event){
                    case "complete":
                        this.callbackStatus = "completed";
                        break;
                    case "timeout":
                        this.callbackStatus = "timedOut";
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, "execute");
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, "timeout");
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== "timedOut") {
                this.transitionCallbackStatus(this.callbackStatus, "complete");
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}

});

parcelRegister("2LX4q", function(module, exports) {
$parcel$export(module.exports, "DoneState", () => $5e3c811cd853cc5d$export$f93c40fda808dd0c);
// Clients can optionally provide the callbackTimeoutPeriod parameter
var $5e3c811cd853cc5d$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("jjxvX", function(module, exports) {
$parcel$export(module.exports, "attachXidToMultipleEvents", () => $4de9dcc462f5f3b4$export$c21270cab66ab290);

var $e9CqI = parcelRequire("e9CqI");
function $4de9dcc462f5f3b4$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $e9CqI.SegmentEventTypes).PAGE || item.msg.type === (0, $e9CqI.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = {
            ...item.msg.properties,
            xid: xid
        };
    } else if (item.msg.traits && item.msg.type === (0, $e9CqI.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = {
            ...item.msg.traits,
            xid: xid
        };
    }
    return item;
}
async function $4de9dcc462f5f3b4$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$4de9dcc462f5f3b4$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("e9CqI", function(module, exports) {
$parcel$export(module.exports, "LastError", () => $9f24c01f62610345$export$a63e16b3351b8c36);
$parcel$export(module.exports, "FetchError", () => $9f24c01f62610345$export$26e841bcf1aeb894);
$parcel$export(module.exports, "SegmentEventTypes", () => $9f24c01f62610345$export$ddf929981dc6feb3);
$parcel$export(module.exports, "MetadataResponse", () => $9f24c01f62610345$export$4b1a5e5486cc0d80);
$parcel$export(module.exports, "ALLOW_LISTED_FETCH_ERROR_NAMES", () => $9f24c01f62610345$export$96f086dcf574a9e2);
class $9f24c01f62610345$export$a63e16b3351b8c36 {
    constructor(reason, error){
        this.reason = reason;
        this.message = error instanceof Error ? error.message : null;
        this.statusCode = error instanceof $9f24c01f62610345$export$26e841bcf1aeb894 ? error.statusCode : null;
    }
}
var $9f24c01f62610345$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    // Dont need Screen as page and screen are the same and we only use page
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
var $9f24c01f62610345$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
var $9f24c01f62610345$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});
class $9f24c01f62610345$export$4b1a5e5486cc0d80 {
    constructor(props, url){
        this.props = props;
        this.url = url;
    }
    static fromJson(json) {
        let isString = (value)=>typeof value === 'string' || value instanceof String;
        const url = isString(json === null || json === void 0 ? void 0 : json.url) ? json.url.trim() : '';
        return new $9f24c01f62610345$export$4b1a5e5486cc0d80((json === null || json === void 0 ? void 0 : json.props) || null, url.startsWith('http') ? url : null);
    }
}
class $9f24c01f62610345$export$26e841bcf1aeb894 extends Error {
    constructor(message, statusCode, statusText){
        super(message);
        this.statusCode = statusCode;
        this.statusText = statusText;
    }
}
const $9f24c01f62610345$export$96f086dcf574a9e2 = [
    'FetchError',
    'AbortError',
    'TypeError'
];

});


parcelRegister("aS3sl", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", () => $86e4360f84e8f8f5$export$9175ce0e1c95daf2);
$parcel$export(module.exports, "DEFAULT_METADATA_REQUEST_TIMEOUT", () => $86e4360f84e8f8f5$export$8fddcd1eff390364);
$parcel$export(module.exports, "DEFAULT_METADATA_REFRESH_INTERVAL", () => $86e4360f84e8f8f5$export$92ed669a3d41dad3);
$parcel$export(module.exports, "DEFAULT_METADATA_MIN_RETRY_DELAY", () => $86e4360f84e8f8f5$export$6649d5c857717efe);
$parcel$export(module.exports, "DEFAULT_METADATA_MAX_RETRY_DELAY", () => $86e4360f84e8f8f5$export$33e7628d3b2c0e2);
$parcel$export(module.exports, "DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL", () => $86e4360f84e8f8f5$export$6f1c008dd0c3b67e);
const $86e4360f84e8f8f5$export$9175ce0e1c95daf2 = 10000; // 10 seconds
const $86e4360f84e8f8f5$export$8fddcd1eff390364 = 60000; // 60 seconds
const $86e4360f84e8f8f5$export$92ed669a3d41dad3 = 600000; // 10 minutes
const $86e4360f84e8f8f5$export$6649d5c857717efe = 5000; // 5 seconds
const $86e4360f84e8f8f5$export$33e7628d3b2c0e2 = 3600000; // 60 minutes
const $86e4360f84e8f8f5$export$6f1c008dd0c3b67e = 10; // 10 milliseconds

});

parcelRegister("eK0i6", function(module, exports) {
$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", () => $49fb00a149d4b6ab$export$ba118f9de1e5ac63);
const $49fb00a149d4b6ab$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("ct1Xw", function(module, exports) {
$parcel$export(module.exports, "sendEvents", () => $f5c3faa1865a58cf$export$8e8f0180c1b41fad);

var $jE04u = parcelRequire("jE04u");

var $e9CqI = parcelRequire("e9CqI");
const $f5c3faa1865a58cf$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $f5c3faa1865a58cf$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $f5c3faa1865a58cf$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, {
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal,
        ...corsOptions
    });
    if (response.status !== 200) throw new (0, $e9CqI.FetchError)(`HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    try {
        let responseBody = await response.clone().json();
        if (responseBody.success === true) return response;
    } catch  {}
    throw new (0, $e9CqI.FetchError)('Invalid HTTP Response (Invalid response body)', 200, 'Invalid response body');
};
const $f5c3faa1865a58cf$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
    return undefined;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $f5c3faa1865a58cf$var$getCorsForUrl = (0, $jE04u.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("jE04u", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4d1ceec87dc8416$export$2e2bcd8739ae039);
var $e4d1ceec87dc8416$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $e4d1ceec87dc8416$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e4d1ceec87dc8416$var$safeIsNaN(first) && $e4d1ceec87dc8416$var$safeIsNaN(second)) return true;
    return false;
}
function $e4d1ceec87dc8416$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e4d1ceec87dc8416$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e4d1ceec87dc8416$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e4d1ceec87dc8416$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("lxuL3", function(module, exports) {
$parcel$export(module.exports, "default", () => $65916aed8759178c$export$2e2bcd8739ae039);

var $6iaF5 = parcelRequire("6iaF5");

var $f1no8 = parcelRequire("f1no8");
var $hthb7 = parcelRequire("hthb7");

var $lBgkY = parcelRequire("lBgkY");

var $btxai = parcelRequire("btxai");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $65916aed8759178c$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $65916aed8759178c$var$SAFE = 'SAFE';
const $65916aed8759178c$var$UNSAFE = 'UNSAFE';
const $65916aed8759178c$var$NOT_FOUND = 'NOT_FOUND';
const $65916aed8759178c$var$COOKIE = 'COOKIE';
const $65916aed8759178c$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $65916aed8759178c$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $lBgkY.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $hthb7.default)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $f1no8.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $f1no8.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $65916aed8759178c$var$LOCAL_STORAGE ? this.store.getItem((0, $f1no8.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $f1no8.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $65916aed8759178c$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $65916aed8759178c$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch  {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $65916aed8759178c$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($65916aed8759178c$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $6iaF5.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $65916aed8759178c$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $65916aed8759178c$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $65916aed8759178c$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $65916aed8759178c$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($65916aed8759178c$var$COOKIE);
        switch(cookieValue.type){
            case $65916aed8759178c$var$SAFE:
            case $65916aed8759178c$var$UNSAFE:
                this.store.setItem((0, $f1no8.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $65916aed8759178c$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator) {
        const generator = typeof customAnonymousIdGenerator === 'function' ? customAnonymousIdGenerator : ()=>{
            return (0, $btxai.default)();
        };
        const newAnonId = generator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}

});
parcelRegister("6iaF5", function(module, exports) {
$parcel$export(module.exports, "default", () => $494cb1bafd9f2037$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $fHnZt = parcelRequire("fHnZt");

var $9hhlF = parcelRequire("9hhlF");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $494cb1bafd9f2037$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $494cb1bafd9f2037$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $9hhlF.default)(2, arguments);
    var dateLeft = (0, $2L8Oe.default)(dirtyDateLeft);
    var dateRight = (0, $2L8Oe.default)(dirtyDateRight);
    var sign = $494cb1bafd9f2037$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $fHnZt.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($494cb1bafd9f2037$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("2L8Oe", function(module, exports) {
$parcel$export(module.exports, "default", () => $2026cddceb2d1439$export$2e2bcd8739ae039);

var $5WRll = parcelRequire("5WRll");

var $9hhlF = parcelRequire("9hhlF");
function $2026cddceb2d1439$export$2e2bcd8739ae039(argument) {
    (0, $9hhlF.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $5WRll.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("5WRll", function(module, exports) {
$parcel$export(module.exports, "default", () => $454bbf678e5d4bf7$export$2e2bcd8739ae039);
function $454bbf678e5d4bf7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $454bbf678e5d4bf7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $454bbf678e5d4bf7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9hhlF", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c1328a88d2e5b7f$export$2e2bcd8739ae039);
function $6c1328a88d2e5b7f$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("fHnZt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6dd7b2f66a50a8f$export$2e2bcd8739ae039);

var $cfem5 = parcelRequire("cfem5");

var $k3AL6 = parcelRequire("k3AL6");

var $9hhlF = parcelRequire("9hhlF");
var $b6dd7b2f66a50a8f$var$MILLISECONDS_IN_DAY = 86400000;
function $b6dd7b2f66a50a8f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $9hhlF.default)(2, arguments);
    var startOfDayLeft = (0, $k3AL6.default)(dirtyDateLeft);
    var startOfDayRight = (0, $k3AL6.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $cfem5.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $cfem5.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b6dd7b2f66a50a8f$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("cfem5", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ea205671aa962aa$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $8ea205671aa962aa$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("k3AL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9a09a001e8068ba$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");
function $e9a09a001e8068ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("f1no8", function(module, exports) {
$parcel$export(module.exports, "AWCCookiesKeys", () => $e54cd9b03cef1dee$export$202d555a5dbfd90c);
$parcel$export(module.exports, "AllAnalyticsCookies", () => $e54cd9b03cef1dee$export$d4cb17942ea57c95);
var $e54cd9b03cef1dee$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $e54cd9b03cef1dee$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $e54cd9b03cef1dee$var$isSecure = ()=>{
    try {
        return globalThis && globalThis.location && globalThis.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $e54cd9b03cef1dee$export$d4cb17942ea57c95 = {
    ["AWC_TLD_TEST"]: new $e54cd9b03cef1dee$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $e54cd9b03cef1dee$var$isSecure(),
        path: '/'
    }),
    ["AWC_ANALYTICS_DEBUG"]: new $e54cd9b03cef1dee$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $e54cd9b03cef1dee$var$isSecure(),
        path: '/'
    }),
    ["AJS_ANONYMOUS_ID"]: new $e54cd9b03cef1dee$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $e54cd9b03cef1dee$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("hthb7", function(module, exports) {
$parcel$export(module.exports, "default", () => $51a3538f13f3a281$export$2e2bcd8739ae039);

var $fJXyP = parcelRequire("fJXyP");

var $f1no8 = parcelRequire("f1no8");

var $8anrA = parcelRequire("8anrA");

var $axtgt = parcelRequire("axtgt");
class $51a3538f13f3a281$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $axtgt.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))) : new (0, $8anrA.default)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $f1no8.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $f1no8.AllAnalyticsCookies)[name].getKey(), value, {
            ...(0, $f1no8.AllAnalyticsCookies)[name].getAttributes(),
            // Function is memoized so we only calculate this once per page load
            domain: (0, $axtgt.getTld)(),
            ...options
        });
    }
    get(name) {
        if (!(0, $f1no8.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $f1no8.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $f1no8.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $f1no8.AllAnalyticsCookies)[name].getKey(), {
            ...options
        });
    }
}

});
parcelRegister("fJXyP", function(module, exports) {
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */ (function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("8anrA", function(module, exports) {
$parcel$export(module.exports, "default", () => $33ade653663d5904$export$2e2bcd8739ae039);

var $lBgkY = parcelRequire("lBgkY");
class $33ade653663d5904$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $lBgkY.default)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}

});
parcelRegister("lBgkY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3efc7102d821cf9c$export$2e2bcd8739ae039);

var $kjNYX = parcelRequire("kjNYX");

var $ieyh0 = parcelRequire("ieyh0");
class $3efc7102d821cf9c$export$2e2bcd8739ae039 extends (0, $ieyh0.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.localStorage || (0, $kjNYX.default);
        } catch (err) {
            storageToUse = (0, $kjNYX.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("kjNYX", function(module, exports) {
$parcel$export(module.exports, "default", () => $704b87acd9940022$export$2e2bcd8739ae039);
class $704b87acd9940022$export$90e3e001bcac59c7 {
    constructor(){
        this._data = {};
        this.length = 0;
        this.setItem = (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        };
        this.getItem = (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        };
        this.removeItem = (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        };
        this.clear = ()=>{
            this._data = {};
            this.length = 0;
        };
        this.key = (index)=>Object.keys(this._data)[index];
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
const $704b87acd9940022$var$inmemorystorage = new $704b87acd9940022$export$90e3e001bcac59c7();
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$704b87acd9940022$export$2e2bcd8739ae039 = $704b87acd9940022$var$inmemorystorage;

});

parcelRegister("ieyh0", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe7ccd0b55659d37$export$2e2bcd8739ae039);
/*
 * Code heavily influenced by Segment's Store https://github.com/segmentio/localstorage-retry/blob/master/lib/store.js
 * and Engine https://github.com/segmentio/localstorage-retry/blob/master/lib/engine.js
 * But is not used because it's not public API and is too restrictive in the way it sets keys and does JSON parsing and stringify
 */ 
var $jgvOT = parcelRequire("jgvOT");

var $kjNYX = parcelRequire("kjNYX");
const $fe7ccd0b55659d37$export$41c06fdd37b7e9a5 = 'awc';
const $fe7ccd0b55659d37$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $fe7ccd0b55659d37$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
class $fe7ccd0b55659d37$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        this.getStore = ()=>this._store;
        this.getItem = (key)=>this._store.getItem(this.createKey(key));
        this.removeItem = (key)=>this._store.removeItem(this.createKey(key));
        this.setItem = (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                // Theoretically should only be QuotaExceededError, but keeping 'err' generic
                // https://developer.mozilla.org/en-US/docs/Web/API/Storage/setItem
                this.swapToInMemory();
                this._store.setItem(this.createKey(key), value);
            }
        };
        this.swapToInMemory = ()=>{
            if (this._store === (0, $kjNYX.default) || typeof globalThis === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($fe7ccd0b55659d37$export$48c17662a6902497(globalThis[$fe7ccd0b55659d37$export$770aa8bc07b3de03])) inMemoryStorage = globalThis[$fe7ccd0b55659d37$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $kjNYX.default);
                if (!globalThis[$fe7ccd0b55659d37$export$770aa8bc07b3de03]) // If not already attached to globalThis then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                globalThis[$fe7ccd0b55659d37$export$770aa8bc07b3de03] = (0, $kjNYX.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        };
        this.clear = ()=>this._store.clear();
        this.key = (index)=>this._store.key(index);
        this.getPrefix = ()=>this._prefix;
        this.createKey = (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        };
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($fe7ccd0b55659d37$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $jgvOT.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($fe7ccd0b55659d37$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("axtgt", function(module, exports) {
$parcel$export(module.exports, "canUseCookie", () => $e740397ea0ffb819$export$a9330601ee8f4d95);
$parcel$export(module.exports, "getTld", () => $e740397ea0ffb819$export$de6821eed3d5f32d);

var $fJXyP = parcelRequire("fJXyP");

var $jE04u = parcelRequire("jE04u");

var $f1no8 = parcelRequire("f1no8");
const $e740397ea0ffb819$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $e740397ea0ffb819$export$eb80e1beaa8dacf8 = (0, $f1no8.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $e740397ea0ffb819$export$19164982d36535d8 = 'tld_test';
const $e740397ea0ffb819$export$de6821eed3d5f32d = (0, $jE04u.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).set($e740397ea0ffb819$export$eb80e1beaa8dacf8, $e740397ea0ffb819$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get($e740397ea0ffb819$export$eb80e1beaa8dacf8) === $e740397ea0ffb819$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).remove($e740397ea0ffb819$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("iIOQe", function(module, exports) {
$parcel$export(module.exports, "buildContext", () => $0f7914349dd96741$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "prepareEventContext", () => $0f7914349dd96741$export$6b26e26d40264200);
$parcel$export(module.exports, "prepareEventProperties", () => $0f7914349dd96741$export$44d22e5fb02cc68e);
// @ts-ignore

var $4AczR = parcelRequire("4AczR");
const $0f7914349dd96741$export$3a7fe28f9bf4f3d9 = (context, overrides)=>{
    const result = {
        ...context.context,
        userAgent: navigator.userAgent
    };
    // use nestedRemoveUndefinedValues to strip undefined properties before
    // spreading the override object since we want properties that explicitly
    // set to 'undefined' to not overwrite any values, just like properties
    // that are 'undefined' because they're not set at all will.
    if (overrides !== null && overrides !== void 0 && overrides.excludedProperties) result.excludedProperties = {
        ...result.excludedProperties,
        ...$0f7914349dd96741$var$nestedRemoveUndefinedValues(overrides.excludedProperties, '$.excludedProperties')
    };
    if (overrides !== null && overrides !== void 0 && overrides.userConsents) result.userConsents = {
        ...result.userConsents,
        ...$0f7914349dd96741$var$nestedRemoveUndefinedValues(overrides.userConsents, '$.userConsents')
    };
    // Remove any falsey properties since we only want to have exclusions
    // that were explicitly declared as excluded.
    if (result.excludedProperties) result.excludedProperties = $0f7914349dd96741$var$removeFalseyProperties(result.excludedProperties);
    return result;
};
const $0f7914349dd96741$export$6b26e26d40264200 = (context)=>{
    const propertiesWithoutUndefined = $0f7914349dd96741$var$nestedRemoveUndefinedValues(context, '$.context');
    return (0, (/*@__PURE__*/$parcel$interopDefault($4AczR)))(propertiesWithoutUndefined);
};
const $0f7914349dd96741$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $0f7914349dd96741$var$nestedRemoveUndefinedValues(properties, '$.properties');
    // Remove any override properties that shouldn't be included in the event body
    delete propertiesWithoutUndefined.excludedProperties;
    delete propertiesWithoutUndefined.userConsents;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4AczR)))(propertiesWithoutUndefined);
};
// Shallow removal of all falsey properties from an object, returning a new object.
const $0f7914349dd96741$var$removeFalseyProperties = (obj)=>{
    const result = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) // If the value is not strictly true, map it to undefined
        {
            if (obj[key]) result[key] = obj[key];
        }
    }
    return result;
};
// This function will essentially deepClone as well
const $0f7914349dd96741$var$nestedRemoveUndefinedValues = (obj, path)=>{
    const recursionDepthLimit = 512;
    const nestedRemoveUndefinedValuesImpl = (source, processedReferences, path, depth)=>{
        if (source === null || typeof source !== 'object') return source;
        // If the level of nesting is egregiously excessive we'll stop processing any further to
        // avoid crashing due to stack exhaustion, instead we return a note object.
        if (depth > recursionDepthLimit) return {
            _depthLimitExceeded: true,
            message: `Object nesting depth limit exceeded at path '${path}' with depth '${depth}'`
        };
        // If this object has already been seen then processing it would create a circular reference,
        // instead we return a note object.
        if (processedReferences.has(source)) {
            const originalPath = processedReferences.get(source);
            return {
                _circularReference: true,
                message: `Circular reference to object at original path '${originalPath}' detected at path '${path}'`,
                originalPath: originalPath
            };
        }
        processedReferences.set(source, path);
        const clone = {};
        Object.keys(source).forEach((key)=>{
            const value = source[key];
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    const newArray = [];
                    value.forEach((v, i)=>{
                        const newValue = nestedRemoveUndefinedValuesImpl(v, processedReferences, `${path}.${key}[${i}]`, depth + 1);
                        if (newValue !== undefined) newArray.push(newValue);
                    });
                    clone[key] = newArray;
                } else {
                    const newValue = nestedRemoveUndefinedValuesImpl(value, processedReferences, `${path}.${key}`, depth + 1);
                    if (newValue !== undefined) clone[key] = newValue;
                }
            }
        });
        processedReferences.delete(source);
        return clone;
    };
    return nestedRemoveUndefinedValuesImpl(obj, new Map(), path, 0);
};

});
parcelRegister("4AczR", function(module, exports) {
'use strict';

var $7HwcC = parcelRequire("7HwcC");
/**
 * Expose `traverse`.
 */ module.exports = $356447d479b93cd2$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $356447d479b93cd2$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $356447d479b93cd2$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $356447d479b93cd2$var$traverseArray(input, strict);
    else if ($7HwcC.is(input, strict)) return $7HwcC.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $356447d479b93cd2$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $356447d479b93cd2$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $356447d479b93cd2$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $356447d479b93cd2$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("7HwcC", function(module, exports) {
$parcel$export(module.exports, "parse", () => $59b5874b18843b8b$export$98e6a39c04603d36, (v) => $59b5874b18843b8b$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $59b5874b18843b8b$export$226b3eccf92c9ed9, (v) => $59b5874b18843b8b$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $59b5874b18843b8b$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $59b5874b18843b8b$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $59b5874b18843b8b$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$59b5874b18843b8b$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $59b5874b18843b8b$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$59b5874b18843b8b$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $59b5874b18843b8b$var$matcher.test(string);
};

});




parcelRegister("bhX2c", function(module, exports) {
$parcel$export(module.exports, "MetadataClient", () => $f25316cb1d19ed0a$export$1ac223ae496131c9);

var $87oxp = parcelRequire("87oxp");

var $l08MF = parcelRequire("l08MF");

var $1iJ8Z = parcelRequire("1iJ8Z");
var $2LX4q = parcelRequire("2LX4q");

var $jwyxW = parcelRequire("jwyxW");

var $bkJYN = parcelRequire("bkJYN");

var $id4Xm = parcelRequire("id4Xm");

var $aS3sl = parcelRequire("aS3sl");

var $29erQ = parcelRequire("29erQ");

var $e9CqI = parcelRequire("e9CqI");
class $f25316cb1d19ed0a$export$1ac223ae496131c9 {
    static #_ = this.INITIAL_REFRESH_DELAY = 1;
    static #_2 = this.Factory = (apiHostProtocol, apiHost, product)=>{
        return new $f25316cb1d19ed0a$export$1ac223ae496131c9(apiHostProtocol, apiHost, product);
    };
    constructor(apiHostProtocol, apiHost, product){
        this._userInfo = {
            anonymousId: ''
        };
        this._tenantInfo = {};
        this._url = `${apiHostProtocol}://${apiHost}/metadata`;
        this._product = product;
        this._metadataInfo = null;
        this._requestStatus = 'PENDING';
        this._lastFetchRequestCount = 0;
        this._lastErrorReason = null;
        this._fetchAbortController = null;
        this._hasBeenStopped = false;
        this._isEnabled = false;
        this._propertyChangeRefreshTimeout = null;
        const isStargateProxy = (0, $bkJYN.isStargateProxyPath)({
            apiHost: apiHost
        });
        this._metadataHost = isStargateProxy ? 'PRODUCT_HOST' : apiHost;
        this._options = this.buildOptions({
            backoffFactor: 2,
            backoffJitterPercentage: 0.8,
            flushBeforeUnload: false,
            flushWaitMs: 500,
            maxAttempts: 10,
            minRetryDelay: (0, $aS3sl.DEFAULT_METADATA_MIN_RETRY_DELAY),
            maxRetryDelay: (0, $aS3sl.DEFAULT_METADATA_MAX_RETRY_DELAY)
        });
        this._scheduler = new (0, $1iJ8Z.default)({
            ...this._options,
            waitInterval: (0, $aS3sl.DEFAULT_METADATA_REFRESH_INTERVAL)
        }, this.scheduleCallback.bind(this));
        this._networkStatus = null;
    }
    /**
   * Starts the metadata client. This will start the scheduler and begin
   * fetching metadata.
   *
   * @param allowRestart - If false, the client will not be restarted if it has already been stopped
   *						 by a call to stop().
   */ start(allowRestart) {
        if (this._isEnabled || this._hasBeenStopped && !allowRestart) return;
        this._isEnabled = true;
        this.startNetworkStatusMonitor();
        setTimeout(()=>{
            this._scheduler.schedule({
                immediate: true
            });
        }, $f25316cb1d19ed0a$export$1ac223ae496131c9.INITIAL_REFRESH_DELAY);
    }
    stop() {
        var _this$_fetchAbortCont;
        if (!this._isEnabled) return;
        this._hasBeenStopped = true;
        this._isEnabled = false;
        this.stopNetworkStatusMonitor();
        this._scheduler.stop();
        (_this$_fetchAbortCont = this._fetchAbortController) === null || _this$_fetchAbortCont === void 0 || _this$_fetchAbortCont.abort();
        this.resetPropertyChangeRefresh();
    }
    startNetworkStatusMonitor() {
        if (this._networkStatus) return;
        this._networkStatus = new (0, $87oxp.default)((status)=>{
            if (status === (0, $jwyxW.NetworkStatusEnum).OFFLINE) this._scheduler.stop();
            else if (this._isEnabled) this._scheduler.schedule({
                immediate: this._metadataInfo === null
            });
        });
    }
    stopNetworkStatusMonitor() {
        if (this._networkStatus) {
            this._networkStatus.removeListeners();
            this._networkStatus = null;
        }
    }
    async refreshMetadataAsync() {
        var _this$_fetchAbortCont2;
        if ((0, $id4Xm.TestSupport).areFetchCallsDisabled() || !this._isEnabled) return Promise.resolve();
        (_this$_fetchAbortCont2 = this._fetchAbortController) === null || _this$_fetchAbortCont2 === void 0 || _this$_fetchAbortCont2.abort();
        this._fetchAbortController = new AbortController();
        const fetchAbortSignal = this._fetchAbortController.signal;
        this._lastFetchRequestCount = this._scheduler.getFailureCount();
        await (0, $29erQ.fetchMetadata)(this._url, {
            product: this._product,
            userInfo: this._userInfo,
            tenantInfo: this._tenantInfo
        }, (0, $aS3sl.DEFAULT_METADATA_REQUEST_TIMEOUT), fetchAbortSignal).then(async (response)=>{
            const metadata = await response.json();
            this._metadataInfo = (0, $e9CqI.MetadataResponse).fromJson(metadata);
            this._lastFetchRequestCount++;
            this._requestStatus = 'FETCHED';
            this._lastErrorReason = null;
        }).catch((error)=>{
            if (fetchAbortSignal.aborted) // This request was aborted, so we don't need to handle it.
            return;
            this._requestStatus = 'FAILED';
            if (error instanceof (0, $e9CqI.FetchError) && [
                429,
                503
            ].includes(error.statusCode)) this._lastErrorReason = 'ServerBusyError';
            else this._lastErrorReason = error instanceof Error && (0, $e9CqI.ALLOW_LISTED_FETCH_ERROR_NAMES).includes(error.name) ? error.name : 'Unknown';
            throw error;
        });
    }
    getMetadataAsync() {
        return Promise.resolve(this._metadataInfo);
    }
    get status() {
        return this._requestStatus;
    }
    get lastErrorReason() {
        return this._lastErrorReason;
    }
    get lastFetchRequestCount() {
        return this._lastFetchRequestCount;
    }
    get userInfo() {
        return this._userInfo;
    }
    set userInfo(userInfo) {
        var _this$_userInfo, _this$_userInfo2;
        if (((_this$_userInfo = this._userInfo) === null || _this$_userInfo === void 0 ? void 0 : _this$_userInfo.userId) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId) && ((_this$_userInfo2 = this._userInfo) === null || _this$_userInfo2 === void 0 ? void 0 : _this$_userInfo2.userIdType) === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType)) return;
        this._userInfo = userInfo;
        this.schedulePropertyChangeRefresh();
    }
    get tenantInfo() {
        return this._tenantInfo;
    }
    set tenantInfo(tenantInfo) {
        var _this$_tenantInfo, _this$_tenantInfo2;
        if (((_this$_tenantInfo = this._tenantInfo) === null || _this$_tenantInfo === void 0 ? void 0 : _this$_tenantInfo.tenantId) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantId) && ((_this$_tenantInfo2 = this._tenantInfo) === null || _this$_tenantInfo2 === void 0 ? void 0 : _this$_tenantInfo2.tenantIdType) === (tenantInfo === null || tenantInfo === void 0 ? void 0 : tenantInfo.tenantIdType)) return;
        this._tenantInfo = tenantInfo;
        this.schedulePropertyChangeRefresh();
    }
    get metrics() {
        return {
            host: this._metadataHost,
            status: this.status,
            lastErrorReason: this.lastErrorReason,
            lastRefreshRequestCount: this.lastFetchRequestCount
        };
    }
    async scheduleCallback(done) {
        var _this$_networkStatus;
        if (((_this$_networkStatus = this._networkStatus) === null || _this$_networkStatus === void 0 ? void 0 : _this$_networkStatus.getNetworkStatus()) === (0, $jwyxW.NetworkStatusEnum).OFFLINE) {
            done((0, $2LX4q.DoneState).NOOP);
            return;
        }
        try {
            await this.refreshMetadataAsync();
            done((0, $2LX4q.DoneState).SUCCESS);
            this._scheduler.schedule();
        } catch  {
            done((0, $2LX4q.DoneState).ERROR);
        }
    }
    /**
   * Schedules a refresh of the metadata when the user or tenant info changes. There is
   * a short delay to allow for multiple changes to be batched together, such as when the
   * callers sets the user info and tenant info in quick succession.
   */ schedulePropertyChangeRefresh() {
        if (!this._isEnabled) return;
        this.resetPropertyChangeRefresh();
        this._propertyChangeRefreshTimeout = setTimeout(()=>{
            this.resetPropertyChangeRefresh();
            this._scheduler.schedule({
                immediate: true
            });
        }, (0, $aS3sl.DEFAULT_METADATA_PROPERTY_CHANGE_REFRESH_INTERVAL));
    }
    resetPropertyChangeRefresh() {
        if (this._propertyChangeRefreshTimeout) {
            clearTimeout(this._propertyChangeRefreshTimeout);
            this._propertyChangeRefreshTimeout = null;
        }
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || (0, $l08MF.DEFAULT_POLLING_OPTIONS).backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : (0, $l08MF.DEFAULT_POLLING_OPTIONS).backoffJitterPercentage,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || (0, $l08MF.DEFAULT_POLLING_OPTIONS).maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || (0, $l08MF.DEFAULT_POLLING_OPTIONS).minRetryDelay
        };
    }
}

});
parcelRegister("bkJYN", function(module, exports) {
$parcel$export(module.exports, "selectHost", () => $8e3846a2e3e5f116$export$18c0b81944902eae);
$parcel$export(module.exports, "isStargateProxyPath", () => $8e3846a2e3e5f116$export$83a9dd8d74be72c);

var $jgvOT = parcelRequire("jgvOT");
const $8e3846a2e3e5f116$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $8e3846a2e3e5f116$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $8e3846a2e3e5f116$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $8e3846a2e3e5f116$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $8e3846a2e3e5f116$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $8e3846a2e3e5f116$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $8e3846a2e3e5f116$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $8e3846a2e3e5f116$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $8e3846a2e3e5f116$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
/**
 * Returns the full Stargate proxy URL (host + proxy path) for the current host.
 *
 * This is the default endpoint for Commercial, FedRAMP Moderate (with Stargate),
 * and Oasis IC environments. Using the first-party proxy works around browser
 * restrictions with third-party cookies.
 *
 * In non-browser environments (e.g. SSR) where `window` is not defined, the host
 * portion is omitted and the function returns only `STARGATE_PROXY_PATH`
 * (i.e. `/gateway/api/gasv3/api/v1`).
 */ function $8e3846a2e3e5f116$var$stargateProxyUrl() {
    return (typeof window !== 'undefined' ? window.location.host : '') + $8e3846a2e3e5f116$export$5df9262e102d0c32;
}
const $8e3846a2e3e5f116$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $jgvOT.envType).LOCAL || env === (0, $jgvOT.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $jgvOT.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $jgvOT.envType).PROD ? $8e3846a2e3e5f116$var$FEDRAMP_PROD_HOST : $8e3846a2e3e5f116$var$FEDRAMP_STAGING_HOST;
    if (useLegacyUrl) return env === (0, $jgvOT.envType).PROD ? $8e3846a2e3e5f116$var$STARGATE_FEDRAMP_PROD_HOST : $8e3846a2e3e5f116$var$STARGATE_FEDRAMP_STAGING_HOST;
    return $8e3846a2e3e5f116$var$stargateProxyUrl();
};
const $8e3846a2e3e5f116$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $jgvOT.envType).PROD ? $8e3846a2e3e5f116$var$PROD_HOST : $8e3846a2e3e5f116$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $jgvOT.envType).PROD ? $8e3846a2e3e5f116$var$STARGATE_PROD_HOST : $8e3846a2e3e5f116$var$STARGATE_STAGING_HOST;
    return $8e3846a2e3e5f116$var$stargateProxyUrl();
};
function $8e3846a2e3e5f116$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, ic: ic, envOverride: envOverride, apiHost: apiHost }) {
    // If the caller has explicitly set an apiHost, use it as the endpoint.
    if (apiHost) return apiHost;
    // When running inside an IC, events are routed through the Stargate proxy.
    if (ic) {
        if (useLegacyUrl) throw Error('IC is set but useLegacyUrl is true. Legacy URLs are not supported in IC environments.');
        return $8e3846a2e3e5f116$var$stargateProxyUrl();
    }
    if (perimeter === (0, $jgvOT.perimeterType).FEDRAMP_MODERATE) return $8e3846a2e3e5f116$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $8e3846a2e3e5f116$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}
function $8e3846a2e3e5f116$export$83a9dd8d74be72c({ apiHost: apiHost }) {
    return apiHost === $8e3846a2e3e5f116$var$stargateProxyUrl();
}

});

parcelRegister("id4Xm", function(module, exports) {
$parcel$export(module.exports, "TestSupport", () => $7503065f108ab8a0$export$44b578549c42d779);
class $7503065f108ab8a0$export$44b578549c42d779 {
    static #_ = this.DISABLE_METADATA_CALLS_PROPERTY = '__awc_disable_metadata_calls__';
    static #_2 = this.DISABLE_EVENT_CALLS_PROPERTY = '__awc_disable_event_calls__';
    static #_3 = this.DISABLE_FETCH_CALLS_PROPERTY = '__awc_disable_fetch_calls__';
    static #_4 = this.SYNTHETIC_FLAG_OVERRIDE_PROPERTY = '__awc_synthetic_flag_override__';
    static isGeminiVREnvironment() {
        try {
            for(const k in globalThis){
                if (k.startsWith('__gemini_') && k.endsWith('__')) return true;
            }
        } catch (e) {
        // ignore
        }
        return false;
    }
    static areMetadataCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($7503065f108ab8a0$export$44b578549c42d779.DISABLE_METADATA_CALLS_PROPERTY);
    }
    static areEventCallsDisabled() {
        return this.areFetchCallsDisabled() || this.getGlobalBooleanProperty($7503065f108ab8a0$export$44b578549c42d779.DISABLE_EVENT_CALLS_PROPERTY);
    }
    static areFetchCallsDisabled() {
        return this.getGlobalBooleanProperty($7503065f108ab8a0$export$44b578549c42d779.DISABLE_FETCH_CALLS_PROPERTY);
    }
    static getSyntheticFlagOverride() {
        return this.getGlobalTriStateProperty($7503065f108ab8a0$export$44b578549c42d779.SYNTHETIC_FLAG_OVERRIDE_PROPERTY);
    }
    static getGlobalBooleanProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) return globalThis[propertyName] === true;
        return false;
    }
    static getGlobalTriStateProperty(propertyName) {
        if (globalThis && globalThis.hasOwnProperty(propertyName)) {
            const value = globalThis[propertyName];
            if (typeof value === 'boolean') return value;
        }
        return undefined;
    }
}

});

parcelRegister("29erQ", function(module, exports) {
$parcel$export(module.exports, "fetchMetadata", () => $7680b4054463006a$export$55b0d0261469055);

var $jE04u = parcelRequire("jE04u");

var $e9CqI = parcelRequire("e9CqI");
const $7680b4054463006a$export$55b0d0261469055 = async (url, params, timeout, signal)=>{
    var _params$userInfo, _params$userInfo2, _params$tenantInfo, _params$tenantInfo2;
    const requestAbortController = $7680b4054463006a$var$createRequestAbortController(timeout, signal);
    const corsOptions = $7680b4054463006a$var$getCorsForUrl(url);
    const metadataUrl = url + '?' + new URLSearchParams({
        product: `${params.product}`,
        userId: `${((_params$userInfo = params.userInfo) === null || _params$userInfo === void 0 ? void 0 : _params$userInfo.userId) || ''}`,
        userIdType: `${((_params$userInfo2 = params.userInfo) === null || _params$userInfo2 === void 0 ? void 0 : _params$userInfo2.userIdType) || ''}`,
        tenantId: `${((_params$tenantInfo = params.tenantInfo) === null || _params$tenantInfo === void 0 ? void 0 : _params$tenantInfo.tenantId) || ''}`,
        tenantIdType: `${((_params$tenantInfo2 = params.tenantInfo) === null || _params$tenantInfo2 === void 0 ? void 0 : _params$tenantInfo2.tenantIdType) || ''}`
    }).toString();
    const response = await fetch(metadataUrl, {
        method: 'GET',
        signal: requestAbortController.signal,
        ...corsOptions
    });
    // Response must be a 200 (we expect a JSON response, so 204 is not valid for instance)
    if (response.status !== 200) throw new (0, $e9CqI.FetchError)(`Metadata: HTTP Error ${response.status} (${response.statusText})`, response.status, response.statusText);
    return response;
};
const $7680b4054463006a$var$createRequestAbortController = (timeout, signal)=>{
    const abortController = new AbortController();
    setTimeout(()=>{
        abortController.abort();
    }, timeout || 30000);
    signal === null || signal === void 0 || signal.addEventListener('abort', ()=>{
        abortController.abort();
    });
    return abortController;
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $7680b4054463006a$var$getCorsForUrl = (0, $jE04u.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});


parcelRegister("2bzrL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c80b64411054bb92$export$2e2bcd8739ae039);

var $jgvOT = parcelRequire("jgvOT");

var $iDoWE = parcelRequire("iDoWE");
class $c80b64411054bb92$export$2e2bcd8739ae039 {
    static #_ = this.messageEvent = 'origin landed';
    constructor(){
        this.pendingCleanup = null;
        this.handleOriginParameters = (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $jgvOT.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture params WITHOUT removing from URL (explicit no-op required because
            // urlParamExtractor defaults to calling history.replaceState if omitted)
            const paramExtractorReplace = ()=>{};
            const capturedURLParams = (0, $iDoWE.default)(isCaptureParam, paramExtractorReplace);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const capturedOriginTraces = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            if (Object.keys(capturedOriginTraces).length > 0) this.pendingCleanup = ()=>{
                (0, $iDoWE.default)(isCaptureParam, historyReplaceFn);
            };
            return capturedOriginTraces;
        };
        this._originStore = {};
    }
    /** Executes and clears any pending origin param cleanup. No-op if nothing is pending. */ _cleanupOriginParams() {
        if (this.pendingCleanup) {
            const cleanup = this.pendingCleanup;
            this.pendingCleanup = null;
            cleanup();
        }
    }
    /**
   * Designed to be invoked after a successful flush with the batch of flushed events.
   */ cleanupOriginParameters(events) {
        try {
            if (this.pendingCleanup) {
                const hasOriginLanded = events.some((item)=>'event' in item.msg && item.msg.event === $c80b64411054bb92$export$2e2bcd8739ae039.messageEvent);
                if (hasOriginLanded) this._cleanupOriginParams();
            }
        } catch  {
        // Silently ignore cleanup errors to avoid disrupting the flush cycle
        }
    }
}

});

parcelRegister("biXHd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bc54235faacbc04$export$2e2bcd8739ae039);

var $lBgkY = parcelRequire("lBgkY");
// WARNING: The value of SESSION_ID_STORAGE_KEY is relied upon by other Platform packages
// (eg. search-page, product-search-dialog). If you need to change this key, you MUST
// notify the dependant Platform teams and update all dependent packages accordingly.
const $3bc54235faacbc04$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $3bc54235faacbc04$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $3bc54235faacbc04$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $3bc54235faacbc04$export$285f6bddd927a06d = 1800000; // 30 minutes
const $3bc54235faacbc04$export$a92e915d70316eb2 = 5000; // 5 seconds
const $3bc54235faacbc04$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $3bc54235faacbc04$export$5702a91a6f42969f = ()=>{};
class $3bc54235faacbc04$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this._generateNewSessionId = ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($3bc54235faacbc04$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        };
        this._updateSessionExpiry = ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($3bc54235faacbc04$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        };
        this._debouncedUpdateSessionExpiry = (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        };
        this._sessionExpiryTime = options.sessionExpiryTime || $3bc54235faacbc04$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $3bc54235faacbc04$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $3bc54235faacbc04$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $3bc54235faacbc04$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $lBgkY.default)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($3bc54235faacbc04$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($3bc54235faacbc04$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$3bc54235faacbc04$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}

});

parcelRegister("7cqEO", function(module, exports) {
$parcel$export(module.exports, "default", () => $314ab80f79cb700a$export$2e2bcd8739ae039);

var $kjNYX = parcelRequire("kjNYX");

var $ieyh0 = parcelRequire("ieyh0");
class $314ab80f79cb700a$export$2e2bcd8739ae039 extends (0, $ieyh0.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = globalThis.sessionStorage || (0, $kjNYX.default);
        } catch (err) {
            storageToUse = (0, $kjNYX.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("yBFix", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f3f8025824308a8$export$2e2bcd8739ae039);

var $7cqEO = parcelRequire("7cqEO");

var $btxai = parcelRequire("btxai");
const $5f3f8025824308a8$var$STORAGE_KEY = 'tab.id';
class $5f3f8025824308a8$export$2e2bcd8739ae039 {
    constructor(){
        this._generateNewTabId = ()=>{
            const newTabId = (0, $btxai.default)();
            this._safeSessionStorage.setItem($5f3f8025824308a8$var$STORAGE_KEY, newTabId);
            return newTabId;
        };
        this._safeSessionStorage = new (0, $7cqEO.default)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($5f3f8025824308a8$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}

});

parcelRegister("b4WC1", function(module, exports) {
$parcel$export(module.exports, "default", () => $63cedfeb6e3de221$export$2e2bcd8739ae039);

var $4eI0d = parcelRequire("4eI0d");

var $jgvOT = parcelRequire("jgvOT");

var $h1cme = parcelRequire("h1cme");

var $7cqEO = parcelRequire("7cqEO");

var $iDoWE = parcelRequire("iDoWE");

var $btxai = parcelRequire("btxai");
const $63cedfeb6e3de221$var$STORAGE_KEY = 'taskSessions';
const $63cedfeb6e3de221$var$INIT_KEY = 'taskSessionsInit';
const $63cedfeb6e3de221$var$AWC_PARAM_PREFIX = 'awc.';
const $63cedfeb6e3de221$var$TASK_SESSION_RELOAD_TIME = 3000;
class $63cedfeb6e3de221$export$2e2bcd8739ae039 {
    constructor(){
        this._taskSessionsNotRecentlyInitialised = (currentTimestamp)=>this._safeSessionStorage.getItem($63cedfeb6e3de221$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($63cedfeb6e3de221$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($63cedfeb6e3de221$var$INIT_KEY) || '0', 10) < currentTimestamp - $63cedfeb6e3de221$var$TASK_SESSION_RELOAD_TIME;
        this._removeTaskSessionPrefix = (_, taskSessionName)=>taskSessionName.split($63cedfeb6e3de221$var$AWC_PARAM_PREFIX)[1];
        this._isTaskSessionQueryParam = (_, taskSessionName)=>taskSessionName.startsWith($63cedfeb6e3de221$var$AWC_PARAM_PREFIX);
        this.getAllTaskSessions = ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($63cedfeb6e3de221$var$STORAGE_KEY) || '');
            } catch  {
                return {};
            }
        };
        this._writeToSessionStorage = (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($63cedfeb6e3de221$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch  {}
        };
        this._appendTaskSessions = (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        };
        this._safelyRemoveKey = (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        };
        this.createTaskSession = (taskSessionName)=>{
            const taskSessionId = (0, $btxai.default)();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        };
        this.createTaskSessionWithProvidedId = (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        };
        this.completeTaskSession = (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        };
        this.formatTaskSessionQueryString = ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $4eI0d.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $h1cme.pick)(currentState, includedTaskSessions) : (0, $h1cme.omit)(currentState, Object.values((0, $jgvOT.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = {
                ...(0, $h1cme.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$63cedfeb6e3de221$var$AWC_PARAM_PREFIX + taskSessionName),
                ...query
            };
            return `${url}?${(0, $4eI0d.stringify)(queryWithTaskSessions)}`;
        };
        this.stripQueryParameters = ()=>{
            const extractedTaskSessions = (0, $h1cme.mapKeys)((0, $iDoWE.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        };
        const currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $7cqEO.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($63cedfeb6e3de221$var$INIT_KEY, currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch  {}
    }
}

});

parcelRegister("2i1By", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ac980efe46049e$export$2e2bcd8739ae039);

var $fJXyP = parcelRequire("fJXyP");

var $f1no8 = parcelRequire("f1no8");

var $id4Xm = parcelRequire("id4Xm");
const $14ac980efe46049e$var$MAX_CACHE_SIZE = 100;
const $14ac980efe46049e$var$COOKIE_NAME = (0, $f1no8.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $14ac980efe46049e$var$DEBUG_TAG = 'synthetic';
class $14ac980efe46049e$var$TestingCache {
    constructor(syntheticFlagOverride, enableTestingCache){
        this._syntheticFlagOverride = typeof syntheticFlagOverride === 'boolean' ? syntheticFlagOverride : undefined;
        this._enableTestingCache = typeof enableTestingCache === 'boolean' ? enableTestingCache : undefined;
        this._isDebugCookieEnabled = $14ac980efe46049e$var$TestingCache.getDebugCookie();
        this.bind();
    }
    saveEvent(event) {
        try {
            if (!event) return;
            this.bind();
            this.addSyntheticTag(event);
            this.cache(event);
        } catch  {
        // Ignore errors from testing cache.
        }
    }
    bind() {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || window.testAnalytics) return;
        window.testAnalytics = {
            eventCache: [],
            events: ()=>window.testAnalytics.eventCache,
            clear: ()=>{
                window.testAnalytics.eventCache = [];
                try {
                    localStorage.removeItem('awc.ui.viewed.last.sent');
                    localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                    localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                    localStorage.removeItem('awc-local.ui.viewed.last.sent');
                } catch  {
                // Ignore errors from localStorage.
                }
            }
        };
    }
    cache(event) {
        if (!this.shouldCacheEvent() || typeof window === 'undefined' || !window.testAnalytics) return;
        if (window.testAnalytics.eventCache.length >= $14ac980efe46049e$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
        window.testAnalytics.eventCache.push(event);
    }
    addSyntheticTag(event) {
        if (!this.shouldSetSyntheticFlag()) return;
        if (event.tags instanceof Array) {
            if (!event.tags.includes($14ac980efe46049e$var$DEBUG_TAG)) event.tags.push($14ac980efe46049e$var$DEBUG_TAG);
        } else event.tags = [
            $14ac980efe46049e$var$DEBUG_TAG
        ];
    }
    shouldCacheEvent() {
        return this._enableTestingCache ? this._enableTestingCache : this._isDebugCookieEnabled;
    }
    shouldSetSyntheticFlag() {
        if (this._syntheticFlagOverride !== undefined) return this._syntheticFlagOverride;
        const globalSyntheticOverride = (0, $id4Xm.TestSupport).getSyntheticFlagOverride();
        if (globalSyntheticOverride !== undefined) return globalSyntheticOverride;
        return this.shouldCacheEvent();
    }
    static getDebugCookie() {
        try {
            return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get($14ac980efe46049e$var$COOKIE_NAME) || 'false') === true;
        } catch  {
            (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).remove($14ac980efe46049e$var$COOKIE_NAME);
        }
        return false;
    }
}
var $14ac980efe46049e$export$2e2bcd8739ae039 = $14ac980efe46049e$var$TestingCache;

});

parcelRegister("k3zDq", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4fb6119e0d701bb$export$2e2bcd8739ae039);

var $jgvOT = parcelRequire("jgvOT");

var $5OLQZ = parcelRequire("5OLQZ");

var $lBgkY = parcelRequire("lBgkY");
const $c4fb6119e0d701bb$var$DEFAULT_DELAY = 2000; // 2 seconds
const $c4fb6119e0d701bb$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $c4fb6119e0d701bb$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
const $c4fb6119e0d701bb$var$DEFAULT_MALFORMED_UIVIEWED_EVENT = 'malformed.uiviewed.last.sent';
var $c4fb6119e0d701bb$var$SendEventDecision = /*#__PURE__*/ function(SendEventDecision) {
    SendEventDecision[SendEventDecision["FocusLost"] = 0] = "FocusLost";
    SendEventDecision[SendEventDecision["UserOrTenantIncomplete"] = 1] = "UserOrTenantIncomplete";
    SendEventDecision[SendEventDecision["MalformedUiViewedRateLimited"] = 2] = "MalformedUiViewedRateLimited";
    SendEventDecision[SendEventDecision["EligibleToSend"] = 3] = "EligibleToSend";
    SendEventDecision[SendEventDecision["UiViewedRateLimited"] = 4] = "UiViewedRateLimited";
    return SendEventDecision;
}($c4fb6119e0d701bb$var$SendEventDecision || {});
class $c4fb6119e0d701bb$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        this.start = ()=>{
            this._startInterval();
            this._bindEventListeners();
        };
        this.stop = ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        };
        this.resetTimers = ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        };
        this.signalUserActive = ()=>{
            this._sendUserActiveEvents();
        };
        this._bindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        };
        this._unbindEventListeners = ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        };
        this._startInterval = ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleDwellTimerTriggered, this._delay);
        };
        this._stopInterval = ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        };
        this._getProductKey = (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        };
        this._getLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._parseLocalStorageData = (key)=>{
            const data = this._safeLocalStorage.getItem(key);
            try {
                return JSON.parse(data || '');
            } catch  {
                this._safeLocalStorage.removeItem(key);
                return null;
            }
        };
        this._getMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            const p = t[productKey] || null;
            return p;
        };
        this._setLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._storageKey) || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        };
        this._setMalformedLastSentTimestamp = (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData(this._malformedEventStorageKey) || {};
            const finalUserId = userId || 'NOT_SET';
            const finalTenantId = tenantId || 'NOT_SET';
            const u = json[finalUserId] || {};
            const t = u[finalTenantId] || {};
            t[productKey] = Date.now();
            u[finalTenantId] = t;
            json[finalUserId] = u;
            this._safeLocalStorage.setItem(this._malformedEventStorageKey, JSON.stringify(json));
        };
        this._handleDwellTimerTriggered = ()=>{
            const document = (0, $5OLQZ.getDocument)();
            if (document && !document.hasFocus()) return;
            this._sendUserActiveEvents();
        };
        this._sendUserActiveEvents = ()=>{
            const { embeddedProduct: embeddedProduct, ...context } = this._getContext();
            this._sendEvent(this._product, context, false);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        };
        this._sendEvent = (product, context, isEmbeddedProduct)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            const sendEventDecision = this._shouldSendEvent(productKey, tenantIdType, tenantId, userId);
            switch(sendEventDecision){
                case 3:
                    this._setLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'ui', 'viewed'));
                    break;
                case 1:
                    this._setMalformedLastSentTimestamp(productKey, tenantId, userId);
                    this._onEvent(this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes, 'malformed', 'uiviewed'));
                    break;
                default:
                    break;
            }
        };
        this._shouldSendEvent = (productKey, tenantIdType, tenantId, userId)=>{
            // TENANT OR USER ID NOT SET
            if (tenantIdType !== (0, $jgvOT.tenantType).NONE && !tenantId || !userId) {
                const sinceLastSent = Date.now() - this._getMalformedLastSentTimestamp(productKey, tenantId, userId);
                if (sinceLastSent === null || sinceLastSent > this._throttle) return 1;
                return 2;
            }
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            if (sinceLastSent === null || sinceLastSent > this._throttle) return 3;
            return 4;
        };
        this._createEvent = (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes, actionSubject, action)=>{
            const event = {
                product: product,
                source: 'ui',
                action: action,
                actionSubject: actionSubject,
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = {
                    ...event.attributes,
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                };
            }
            if (lastScreenEvent) event.attributes = {
                ...event.attributes,
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            };
            return event;
        };
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $c4fb6119e0d701bb$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $c4fb6119e0d701bb$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $c4fb6119e0d701bb$var$DEFAULT_STORAGE_KEY;
        this._malformedEventStorageKey = settings.malformedStorageKey || $c4fb6119e0d701bb$var$DEFAULT_MALFORMED_UIVIEWED_EVENT;
        this._safeLocalStorage = new (0, $lBgkY.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});
parcelRegister("5OLQZ", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $d6dd58fd31105d5b$export$f65ca476c09acec0);
const $d6dd58fd31105d5b$export$f65ca476c09acec0 = ()=>{
    if (typeof document !== 'undefined') return document;
    return null;
};

});


parcelRegister("2MMDr", function(module, exports) {
$parcel$export(module.exports, "default", () => $501d20bc29122625$export$2e2bcd8739ae039);
function $501d20bc29122625$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("gR6XY", function(module, exports) {
$parcel$export(module.exports, "XIDPromise", () => $8b2b3c12fba95dc9$export$fbe53bbbe682bcdd);

var $lf6vr = parcelRequire("lf6vr");
const $8b2b3c12fba95dc9$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $lf6vr.createTimeoutXid)()), (0, $lf6vr.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $lf6vr.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("lf6vr", function(module, exports) {
$parcel$export(module.exports, "XID_TIMEOUT", () => $5f174b17709d1e04$export$545bcbd53afabfa3);
$parcel$export(module.exports, "createTimeoutXid", () => $5f174b17709d1e04$export$af4087e36d63846);
$parcel$export(module.exports, "createUnknownXid", () => $5f174b17709d1e04$export$fa341d0c750d705b);

var $axNLp = parcelRequire("axNLp");
const $5f174b17709d1e04$export$545bcbd53afabfa3 = 5000;
const $5f174b17709d1e04$export$af4087e36d63846 = ()=>[
        {
            type: (0, $axNLp.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $axNLp.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $5f174b17709d1e04$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $axNLp.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $axNLp.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("axNLp", function(module, exports) {
$parcel$export(module.exports, "XIDItemType", () => $d963cffb466044a2$export$92ca0438bcb0d396);
var $d963cffb466044a2$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
var $d963cffb466044a2$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("63sfu", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("gHT3x", function(module, exports) {
$parcel$export(module.exports, "SCREEN", () => $41101d3b981b813e$export$f636b5b56f1d624a);
$parcel$export(module.exports, "MODAL", () => $41101d3b981b813e$export$1171103ea9083ffa);
$parcel$export(module.exports, "INLINE_DIALOG", () => $41101d3b981b813e$export$cae2783c9279926);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $41101d3b981b813e$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $41101d3b981b813e$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $41101d3b981b813e$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $41101d3b981b813e$export$12346a674644c156);
$parcel$export(module.exports, "ANALYTICS_BRIDGE_CHANNEL", () => $41101d3b981b813e$export$2ceccf177fae277c);
const $41101d3b981b813e$export$f636b5b56f1d624a = 'Screen';
const $41101d3b981b813e$export$9d2de6eebf7462b5 = 'Drawer';
const $41101d3b981b813e$export$1171103ea9083ffa = 'Modal';
const $41101d3b981b813e$export$cae2783c9279926 = 'InlineDialog';
const $41101d3b981b813e$export$d1123261ca8831d2 = 'Dropdown';
const $41101d3b981b813e$export$a1562d08625f5d7e = 'UI';
const $41101d3b981b813e$export$947dac6c72b26f81 = 'TRACK';
const $41101d3b981b813e$export$f1d537d508d2945a = 'SCREEN';
const $41101d3b981b813e$export$12346a674644c156 = 'OPERATIONAL';
const $41101d3b981b813e$export$2ceccf177fae277c = 'analyticsBridge';

});

parcelRegister("eeiwC", function(module, exports) {
$parcel$export(module.exports, "extractAWCDataFromEvent", () => $fe5211434075c1ca$export$1c850cf68c053906);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $esuIC = parcelRequire("esuIC");

var $4CTsu = parcelRequire("4CTsu");

var $gHT3x = parcelRequire("gHT3x");

var $cd0y6 = parcelRequire("cd0y6");
const $fe5211434075c1ca$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $cd0y6.getAnalyticsType)(castedEvent);
    const attributes = (0, $cd0y6.getAttributes)(castedEvent);
    const source = (0, $cd0y6.getSource)(castedEvent);
    const actionSubject = (0, $cd0y6.getActionSubject)(castedEvent);
    if (analyticsType === (0, $gHT3x.SCREEN_EVENT_TYPE)) return {
        type: (0, $gHT3x.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $gHT3x.UI_EVENT_TYPE:
        case 0, $gHT3x.TRACK_EVENT_TYPE:
        case 0, $gHT3x.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $cd0y6.getAction)(castedEvent);
                const actionSubjectId = (0, $cd0y6.getActionSubjectId)(castedEvent);
                const containerId = (0, $cd0y6.getContainerId)(castedEvent);
                const containerType = (0, $cd0y6.getContainerType)(castedEvent);
                const objectId = (0, $cd0y6.getObjectId)(castedEvent);
                const objectType = (0, $cd0y6.getObjectType)(castedEvent);
                const tags = (0, $cd0y6.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($4CTsu)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($esuIC))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("esuIC", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a86b824cb64f5dda$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a86b824cb64f5dda$var$isUndefined;

});

parcelRegister("4CTsu", function(module, exports) {

var $kUeJo = parcelRequire("kUeJo");

var $aETF3 = parcelRequire("aETF3");

var $1rRYH = parcelRequire("1rRYH");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $35e5baf390845de2$var$omitBy(object, predicate) {
    return $1rRYH(object, $aETF3($kUeJo(predicate)));
}
module.exports = $35e5baf390845de2$var$omitBy;

});
parcelRegister("kUeJo", function(module, exports) {

var $axrdM = parcelRequire("axrdM");

var $fUXsj = parcelRequire("fUXsj");

var $h9L3N = parcelRequire("h9L3N");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $hJEKE = parcelRequire("hJEKE");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $f38476ecb63b7f17$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $h9L3N;
    if (typeof value == 'object') return $3Tp9Q(value) ? $fUXsj(value[0], value[1]) : $axrdM(value);
    return $hJEKE(value);
}
module.exports = $f38476ecb63b7f17$var$baseIteratee;

});
parcelRegister("axrdM", function(module, exports) {

var $8VDwo = parcelRequire("8VDwo");

var $gmYCm = parcelRequire("gmYCm");

var $2rTJf = parcelRequire("2rTJf");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $7ac21a0c73f8a7f7$var$baseMatches(source) {
    var matchData = $gmYCm(source);
    if (matchData.length == 1 && matchData[0][2]) return $2rTJf(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $8VDwo(object, source, matchData);
    };
}
module.exports = $7ac21a0c73f8a7f7$var$baseMatches;

});
parcelRegister("8VDwo", function(module, exports) {

var $cPeOR = parcelRequire("cPeOR");

var $h4aRS = parcelRequire("h4aRS");
/** Used to compose bitmasks for value comparisons. */ var $68024dc1bb0b7275$var$COMPARE_PARTIAL_FLAG = 1, $68024dc1bb0b7275$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $68024dc1bb0b7275$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $cPeOR;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $h4aRS(srcValue, objValue, $68024dc1bb0b7275$var$COMPARE_PARTIAL_FLAG | $68024dc1bb0b7275$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $68024dc1bb0b7275$var$baseIsMatch;

});
parcelRegister("cPeOR", function(module, exports) {

var $hXJ4F = parcelRequire("hXJ4F");

var $8DUlV = parcelRequire("8DUlV");

var $dbPRP = parcelRequire("dbPRP");

var $73TpK = parcelRequire("73TpK");

var $9xtLs = parcelRequire("9xtLs");

var $a4Vf6 = parcelRequire("a4Vf6");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9565be471bd0503e$var$Stack(entries) {
    var data = this.__data__ = new $hXJ4F(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$9565be471bd0503e$var$Stack.prototype.clear = $8DUlV;
$9565be471bd0503e$var$Stack.prototype['delete'] = $dbPRP;
$9565be471bd0503e$var$Stack.prototype.get = $73TpK;
$9565be471bd0503e$var$Stack.prototype.has = $9xtLs;
$9565be471bd0503e$var$Stack.prototype.set = $a4Vf6;
module.exports = $9565be471bd0503e$var$Stack;

});
parcelRegister("hXJ4F", function(module, exports) {

var $8tw6T = parcelRequire("8tw6T");

var $2KZKP = parcelRequire("2KZKP");

var $bwoAP = parcelRequire("bwoAP");

var $d5gVq = parcelRequire("d5gVq");

var $kiRHT = parcelRequire("kiRHT");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d13ae92fc1782529$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$d13ae92fc1782529$var$ListCache.prototype.clear = $8tw6T;
$d13ae92fc1782529$var$ListCache.prototype['delete'] = $2KZKP;
$d13ae92fc1782529$var$ListCache.prototype.get = $bwoAP;
$d13ae92fc1782529$var$ListCache.prototype.has = $d5gVq;
$d13ae92fc1782529$var$ListCache.prototype.set = $kiRHT;
module.exports = $d13ae92fc1782529$var$ListCache;

});
parcelRegister("8tw6T", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $62b9f09614eaadf8$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $62b9f09614eaadf8$var$listCacheClear;

});

parcelRegister("2KZKP", function(module, exports) {

var $ieUEM = parcelRequire("ieUEM");
/** Used for built-in method references. */ var $201fc7c23b91a79f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $201fc7c23b91a79f$var$splice = $201fc7c23b91a79f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $201fc7c23b91a79f$var$listCacheDelete(key) {
    var data = this.__data__, index = $ieUEM(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $201fc7c23b91a79f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $201fc7c23b91a79f$var$listCacheDelete;

});
parcelRegister("ieUEM", function(module, exports) {

var $jXvqA = parcelRequire("jXvqA");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d4757ba7ab1ca49b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($jXvqA(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $d4757ba7ab1ca49b$var$assocIndexOf;

});
parcelRegister("jXvqA", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e87be7e8d3fb3e9e$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $e87be7e8d3fb3e9e$var$eq;

});



parcelRegister("bwoAP", function(module, exports) {

var $ieUEM = parcelRequire("ieUEM");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8635c28bc790f6b9$var$listCacheGet(key) {
    var data = this.__data__, index = $ieUEM(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $8635c28bc790f6b9$var$listCacheGet;

});

parcelRegister("d5gVq", function(module, exports) {

var $ieUEM = parcelRequire("ieUEM");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9868defc724ce658$var$listCacheHas(key) {
    return $ieUEM(this.__data__, key) > -1;
}
module.exports = $9868defc724ce658$var$listCacheHas;

});

parcelRegister("kiRHT", function(module, exports) {

var $ieUEM = parcelRequire("ieUEM");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ec7f262c4fdeceff$var$listCacheSet(key, value) {
    var data = this.__data__, index = $ieUEM(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ec7f262c4fdeceff$var$listCacheSet;

});


parcelRegister("8DUlV", function(module, exports) {

var $hXJ4F = parcelRequire("hXJ4F");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $64adadbb482dc3c8$var$stackClear() {
    this.__data__ = new $hXJ4F;
    this.size = 0;
}
module.exports = $64adadbb482dc3c8$var$stackClear;

});

parcelRegister("dbPRP", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $99a48929dfd19491$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $99a48929dfd19491$var$stackDelete;

});

parcelRegister("73TpK", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5243cc53448d90f8$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $5243cc53448d90f8$var$stackGet;

});

parcelRegister("9xtLs", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6f1e48b8f8f6206e$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $6f1e48b8f8f6206e$var$stackHas;

});

parcelRegister("a4Vf6", function(module, exports) {

var $hXJ4F = parcelRequire("hXJ4F");

var $6KMix = parcelRequire("6KMix");

var $e1aJR = parcelRequire("e1aJR");
/** Used as the size to enable large array optimizations. */ var $7566ae479436175c$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $7566ae479436175c$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $hXJ4F) {
        var pairs = data.__data__;
        if (!$6KMix || pairs.length < $7566ae479436175c$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $e1aJR(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $7566ae479436175c$var$stackSet;

});
parcelRegister("6KMix", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");

var $8EUJq = parcelRequire("8EUJq");
/* Built-in method references that are verified to be native. */ var $4eac80f402a0e498$var$Map = $dQQVk($8EUJq, 'Map');
module.exports = $4eac80f402a0e498$var$Map;

});
parcelRegister("dQQVk", function(module, exports) {

var $64rr2 = parcelRequire("64rr2");

var $bWll9 = parcelRequire("bWll9");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $a1592f38797f8968$var$getNative(object, key) {
    var value = $bWll9(object, key);
    return $64rr2(value) ? value : undefined;
}
module.exports = $a1592f38797f8968$var$getNative;

});
parcelRegister("64rr2", function(module, exports) {

var $iwbTU = parcelRequire("iwbTU");

var $9Fmxo = parcelRequire("9Fmxo");

var $p4u5f = parcelRequire("p4u5f");

var $aMscu = parcelRequire("aMscu");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $46b865d706ab640d$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $46b865d706ab640d$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $46b865d706ab640d$var$funcProto = Function.prototype, $46b865d706ab640d$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $46b865d706ab640d$var$funcToString = $46b865d706ab640d$var$funcProto.toString;
/** Used to check objects for own properties. */ var $46b865d706ab640d$var$hasOwnProperty = $46b865d706ab640d$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $46b865d706ab640d$var$reIsNative = RegExp('^' + $46b865d706ab640d$var$funcToString.call($46b865d706ab640d$var$hasOwnProperty).replace($46b865d706ab640d$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $46b865d706ab640d$var$baseIsNative(value) {
    if (!$p4u5f(value) || $9Fmxo(value)) return false;
    var pattern = $iwbTU(value) ? $46b865d706ab640d$var$reIsNative : $46b865d706ab640d$var$reIsHostCtor;
    return pattern.test($aMscu(value));
}
module.exports = $46b865d706ab640d$var$baseIsNative;

});
parcelRegister("iwbTU", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $p4u5f = parcelRequire("p4u5f");
/** `Object#toString` result references. */ var $d7b472637b662725$var$asyncTag = '[object AsyncFunction]', $d7b472637b662725$var$funcTag = '[object Function]', $d7b472637b662725$var$genTag = '[object GeneratorFunction]', $d7b472637b662725$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $d7b472637b662725$var$isFunction(value) {
    if (!$p4u5f(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $AxfGO(value);
    return tag == $d7b472637b662725$var$funcTag || tag == $d7b472637b662725$var$genTag || tag == $d7b472637b662725$var$asyncTag || tag == $d7b472637b662725$var$proxyTag;
}
module.exports = $d7b472637b662725$var$isFunction;

});
parcelRegister("AxfGO", function(module, exports) {

var $aizG2 = parcelRequire("aizG2");

var $38hzm = parcelRequire("38hzm");

var $cvNer = parcelRequire("cvNer");
/** `Object#toString` result references. */ var $06dd2812c3ba874d$var$nullTag = '[object Null]', $06dd2812c3ba874d$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $06dd2812c3ba874d$var$symToStringTag = $aizG2 ? $aizG2.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $06dd2812c3ba874d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $06dd2812c3ba874d$var$undefinedTag : $06dd2812c3ba874d$var$nullTag;
    return $06dd2812c3ba874d$var$symToStringTag && $06dd2812c3ba874d$var$symToStringTag in Object(value) ? $38hzm(value) : $cvNer(value);
}
module.exports = $06dd2812c3ba874d$var$baseGetTag;

});
parcelRegister("aizG2", function(module, exports) {

var $8EUJq = parcelRequire("8EUJq");
/** Built-in value references. */ var $77f7428953c50470$var$Symbol = $8EUJq.Symbol;
module.exports = $77f7428953c50470$var$Symbol;

});
parcelRegister("8EUJq", function(module, exports) {

var $lzrsY = parcelRequire("lzrsY");
/** Detect free variable `self`. */ var $64de10de2421c4ad$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $64de10de2421c4ad$var$root = $lzrsY || $64de10de2421c4ad$var$freeSelf || Function('return this')();
module.exports = $64de10de2421c4ad$var$root;

});
parcelRegister("lzrsY", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $fb422c17c553d6bc$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $fb422c17c553d6bc$var$freeGlobal;

});



parcelRegister("38hzm", function(module, exports) {

var $aizG2 = parcelRequire("aizG2");
/** Used for built-in method references. */ var $247fbf551721665e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $247fbf551721665e$var$hasOwnProperty = $247fbf551721665e$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $247fbf551721665e$var$nativeObjectToString = $247fbf551721665e$var$objectProto.toString;
/** Built-in value references. */ var $247fbf551721665e$var$symToStringTag = $aizG2 ? $aizG2.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $247fbf551721665e$var$getRawTag(value) {
    var isOwn = $247fbf551721665e$var$hasOwnProperty.call(value, $247fbf551721665e$var$symToStringTag), tag = value[$247fbf551721665e$var$symToStringTag];
    try {
        value[$247fbf551721665e$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $247fbf551721665e$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$247fbf551721665e$var$symToStringTag] = tag;
        else delete value[$247fbf551721665e$var$symToStringTag];
    }
    return result;
}
module.exports = $247fbf551721665e$var$getRawTag;

});

parcelRegister("cvNer", function(module, exports) {
/** Used for built-in method references. */ var $91be91bad11c7e58$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $91be91bad11c7e58$var$nativeObjectToString = $91be91bad11c7e58$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $91be91bad11c7e58$var$objectToString(value) {
    return $91be91bad11c7e58$var$nativeObjectToString.call(value);
}
module.exports = $91be91bad11c7e58$var$objectToString;

});


parcelRegister("p4u5f", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $04b5d0631e80dc4c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $04b5d0631e80dc4c$var$isObject;

});


parcelRegister("9Fmxo", function(module, exports) {

var $bWeiY = parcelRequire("bWeiY");
/** Used to detect methods masquerading as native. */ var $70996ce5f17bcec1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($bWeiY && $bWeiY.keys && $bWeiY.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $70996ce5f17bcec1$var$isMasked(func) {
    return !!$70996ce5f17bcec1$var$maskSrcKey && $70996ce5f17bcec1$var$maskSrcKey in func;
}
module.exports = $70996ce5f17bcec1$var$isMasked;

});
parcelRegister("bWeiY", function(module, exports) {

var $8EUJq = parcelRequire("8EUJq");
/** Used to detect overreaching core-js shims. */ var $8b10352daa942067$var$coreJsData = $8EUJq["__core-js_shared__"];
module.exports = $8b10352daa942067$var$coreJsData;

});


parcelRegister("aMscu", function(module, exports) {
/** Used for built-in method references. */ var $7d9443147156527d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $7d9443147156527d$var$funcToString = $7d9443147156527d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $7d9443147156527d$var$toSource(func) {
    if (func != null) {
        try {
            return $7d9443147156527d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $7d9443147156527d$var$toSource;

});


parcelRegister("bWll9", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8b15aa2c180cbe06$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $8b15aa2c180cbe06$var$getValue;

});



parcelRegister("e1aJR", function(module, exports) {

var $gG0jo = parcelRequire("gG0jo");

var $e9Fzy = parcelRequire("e9Fzy");

var $b3VNd = parcelRequire("b3VNd");

var $iGkIZ = parcelRequire("iGkIZ");

var $5Obsk = parcelRequire("5Obsk");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a3497d291f6fde3f$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a3497d291f6fde3f$var$MapCache.prototype.clear = $gG0jo;
$a3497d291f6fde3f$var$MapCache.prototype['delete'] = $e9Fzy;
$a3497d291f6fde3f$var$MapCache.prototype.get = $b3VNd;
$a3497d291f6fde3f$var$MapCache.prototype.has = $iGkIZ;
$a3497d291f6fde3f$var$MapCache.prototype.set = $5Obsk;
module.exports = $a3497d291f6fde3f$var$MapCache;

});
parcelRegister("gG0jo", function(module, exports) {

var $dvNKq = parcelRequire("dvNKq");

var $hXJ4F = parcelRequire("hXJ4F");

var $6KMix = parcelRequire("6KMix");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c240cf7ae8300ba3$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $dvNKq,
        'map': new ($6KMix || $hXJ4F),
        'string': new $dvNKq
    };
}
module.exports = $c240cf7ae8300ba3$var$mapCacheClear;

});
parcelRegister("dvNKq", function(module, exports) {

var $fPsI4 = parcelRequire("fPsI4");

var $lVjE2 = parcelRequire("lVjE2");

var $8Bx5o = parcelRequire("8Bx5o");

var $es7kr = parcelRequire("es7kr");

var $lEc9J = parcelRequire("lEc9J");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9d64c27c5974cba9$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$9d64c27c5974cba9$var$Hash.prototype.clear = $fPsI4;
$9d64c27c5974cba9$var$Hash.prototype['delete'] = $lVjE2;
$9d64c27c5974cba9$var$Hash.prototype.get = $8Bx5o;
$9d64c27c5974cba9$var$Hash.prototype.has = $es7kr;
$9d64c27c5974cba9$var$Hash.prototype.set = $lEc9J;
module.exports = $9d64c27c5974cba9$var$Hash;

});
parcelRegister("fPsI4", function(module, exports) {

var $hhEed = parcelRequire("hhEed");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b861e39d7f205e22$var$hashClear() {
    this.__data__ = $hhEed ? $hhEed(null) : {};
    this.size = 0;
}
module.exports = $b861e39d7f205e22$var$hashClear;

});
parcelRegister("hhEed", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");
/* Built-in method references that are verified to be native. */ var $c9533aaded7a382d$var$nativeCreate = $dQQVk(Object, 'create');
module.exports = $c9533aaded7a382d$var$nativeCreate;

});


parcelRegister("lVjE2", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff5e28e795c9a6d6$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $ff5e28e795c9a6d6$var$hashDelete;

});

parcelRegister("8Bx5o", function(module, exports) {

var $hhEed = parcelRequire("hhEed");
/** Used to stand-in for `undefined` hash values. */ var $643b71a1b8d95f4b$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $643b71a1b8d95f4b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $643b71a1b8d95f4b$var$hasOwnProperty = $643b71a1b8d95f4b$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $643b71a1b8d95f4b$var$hashGet(key) {
    var data = this.__data__;
    if ($hhEed) {
        var result = data[key];
        return result === $643b71a1b8d95f4b$var$HASH_UNDEFINED ? undefined : result;
    }
    return $643b71a1b8d95f4b$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $643b71a1b8d95f4b$var$hashGet;

});

parcelRegister("es7kr", function(module, exports) {

var $hhEed = parcelRequire("hhEed");
/** Used for built-in method references. */ var $a8595d8fa18307c5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a8595d8fa18307c5$var$hasOwnProperty = $a8595d8fa18307c5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a8595d8fa18307c5$var$hashHas(key) {
    var data = this.__data__;
    return $hhEed ? data[key] !== undefined : $a8595d8fa18307c5$var$hasOwnProperty.call(data, key);
}
module.exports = $a8595d8fa18307c5$var$hashHas;

});

parcelRegister("lEc9J", function(module, exports) {

var $hhEed = parcelRequire("hhEed");
/** Used to stand-in for `undefined` hash values. */ var $fc26c351229173dd$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $fc26c351229173dd$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $hhEed && value === undefined ? $fc26c351229173dd$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $fc26c351229173dd$var$hashSet;

});



parcelRegister("e9Fzy", function(module, exports) {

var $eZB5c = parcelRequire("eZB5c");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a4e22760b52949e5$var$mapCacheDelete(key) {
    var result = $eZB5c(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $a4e22760b52949e5$var$mapCacheDelete;

});
parcelRegister("eZB5c", function(module, exports) {

var $7ybv2 = parcelRequire("7ybv2");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $aea387115f13dd86$var$getMapData(map, key) {
    var data = map.__data__;
    return $7ybv2(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $aea387115f13dd86$var$getMapData;

});
parcelRegister("7ybv2", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $57f4a0fab2d0eb4e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $57f4a0fab2d0eb4e$var$isKeyable;

});



parcelRegister("b3VNd", function(module, exports) {

var $eZB5c = parcelRequire("eZB5c");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80dccdf2dd0f681e$var$mapCacheGet(key) {
    return $eZB5c(this, key).get(key);
}
module.exports = $80dccdf2dd0f681e$var$mapCacheGet;

});

parcelRegister("iGkIZ", function(module, exports) {

var $eZB5c = parcelRequire("eZB5c");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d99c39b2968bc06d$var$mapCacheHas(key) {
    return $eZB5c(this, key).has(key);
}
module.exports = $d99c39b2968bc06d$var$mapCacheHas;

});

parcelRegister("5Obsk", function(module, exports) {

var $eZB5c = parcelRequire("eZB5c");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $43aa822fb83cdb32$var$mapCacheSet(key, value) {
    var data = $eZB5c(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $43aa822fb83cdb32$var$mapCacheSet;

});




parcelRegister("h4aRS", function(module, exports) {

var $2gkwY = parcelRequire("2gkwY");

var $5eSIk = parcelRequire("5eSIk");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $c6cb3d84efdbec42$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$5eSIk(value) && !$5eSIk(other)) return value !== value && other !== other;
    return $2gkwY(value, other, bitmask, customizer, $c6cb3d84efdbec42$var$baseIsEqual, stack);
}
module.exports = $c6cb3d84efdbec42$var$baseIsEqual;

});
parcelRegister("2gkwY", function(module, exports) {

var $cPeOR = parcelRequire("cPeOR");

var $8jq9w = parcelRequire("8jq9w");

var $9COWe = parcelRequire("9COWe");

var $4iK00 = parcelRequire("4iK00");

var $4L1Ez = parcelRequire("4L1Ez");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $gJsvo = parcelRequire("gJsvo");

var $bGgiZ = parcelRequire("bGgiZ");
/** Used to compose bitmasks for value comparisons. */ var $1a5d0060f5b8183d$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $1a5d0060f5b8183d$var$argsTag = '[object Arguments]', $1a5d0060f5b8183d$var$arrayTag = '[object Array]', $1a5d0060f5b8183d$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $1a5d0060f5b8183d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1a5d0060f5b8183d$var$hasOwnProperty = $1a5d0060f5b8183d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1a5d0060f5b8183d$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $3Tp9Q(object), othIsArr = $3Tp9Q(other), objTag = objIsArr ? $1a5d0060f5b8183d$var$arrayTag : $4L1Ez(object), othTag = othIsArr ? $1a5d0060f5b8183d$var$arrayTag : $4L1Ez(other);
    objTag = objTag == $1a5d0060f5b8183d$var$argsTag ? $1a5d0060f5b8183d$var$objectTag : objTag;
    othTag = othTag == $1a5d0060f5b8183d$var$argsTag ? $1a5d0060f5b8183d$var$objectTag : othTag;
    var objIsObj = objTag == $1a5d0060f5b8183d$var$objectTag, othIsObj = othTag == $1a5d0060f5b8183d$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $gJsvo(object)) {
        if (!$gJsvo(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $cPeOR);
        return objIsArr || $bGgiZ(object) ? $8jq9w(object, other, bitmask, customizer, equalFunc, stack) : $9COWe(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $1a5d0060f5b8183d$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $1a5d0060f5b8183d$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $1a5d0060f5b8183d$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $cPeOR);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $cPeOR);
    return $4iK00(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $1a5d0060f5b8183d$var$baseIsEqualDeep;

});
parcelRegister("8jq9w", function(module, exports) {

var $2QZKx = parcelRequire("2QZKx");

var $1E6sy = parcelRequire("1E6sy");

var $a1q04 = parcelRequire("a1q04");
/** Used to compose bitmasks for value comparisons. */ var $60d4626b3f95e9df$var$COMPARE_PARTIAL_FLAG = 1, $60d4626b3f95e9df$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $60d4626b3f95e9df$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $60d4626b3f95e9df$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $60d4626b3f95e9df$var$COMPARE_UNORDERED_FLAG ? new $2QZKx : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$1E6sy(other, function(othValue, othIndex) {
                if (!$a1q04(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $60d4626b3f95e9df$var$equalArrays;

});
parcelRegister("2QZKx", function(module, exports) {

var $e1aJR = parcelRequire("e1aJR");

var $8aEKl = parcelRequire("8aEKl");

var $4HTbT = parcelRequire("4HTbT");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $2140564c4a2eef09$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $e1aJR;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$2140564c4a2eef09$var$SetCache.prototype.add = $2140564c4a2eef09$var$SetCache.prototype.push = $8aEKl;
$2140564c4a2eef09$var$SetCache.prototype.has = $4HTbT;
module.exports = $2140564c4a2eef09$var$SetCache;

});
parcelRegister("8aEKl", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $5f2edd552ec41367$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $5f2edd552ec41367$var$setCacheAdd(value) {
    this.__data__.set(value, $5f2edd552ec41367$var$HASH_UNDEFINED);
    return this;
}
module.exports = $5f2edd552ec41367$var$setCacheAdd;

});

parcelRegister("4HTbT", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $36d5fd5141c22e62$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $36d5fd5141c22e62$var$setCacheHas;

});


parcelRegister("1E6sy", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $132e89969957d4b9$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $132e89969957d4b9$var$arraySome;

});

parcelRegister("a1q04", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $74be2a770df122af$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $74be2a770df122af$var$cacheHas;

});


parcelRegister("9COWe", function(module, exports) {

var $aizG2 = parcelRequire("aizG2");

var $67I8M = parcelRequire("67I8M");

var $jXvqA = parcelRequire("jXvqA");

var $8jq9w = parcelRequire("8jq9w");

var $bcdei = parcelRequire("bcdei");

var $ab9Mx = parcelRequire("ab9Mx");
/** Used to compose bitmasks for value comparisons. */ var $701f2cecda9217b8$var$COMPARE_PARTIAL_FLAG = 1, $701f2cecda9217b8$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $701f2cecda9217b8$var$boolTag = '[object Boolean]', $701f2cecda9217b8$var$dateTag = '[object Date]', $701f2cecda9217b8$var$errorTag = '[object Error]', $701f2cecda9217b8$var$mapTag = '[object Map]', $701f2cecda9217b8$var$numberTag = '[object Number]', $701f2cecda9217b8$var$regexpTag = '[object RegExp]', $701f2cecda9217b8$var$setTag = '[object Set]', $701f2cecda9217b8$var$stringTag = '[object String]', $701f2cecda9217b8$var$symbolTag = '[object Symbol]';
var $701f2cecda9217b8$var$arrayBufferTag = '[object ArrayBuffer]', $701f2cecda9217b8$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $701f2cecda9217b8$var$symbolProto = $aizG2 ? $aizG2.prototype : undefined, $701f2cecda9217b8$var$symbolValueOf = $701f2cecda9217b8$var$symbolProto ? $701f2cecda9217b8$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $701f2cecda9217b8$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $701f2cecda9217b8$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $701f2cecda9217b8$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $67I8M(object), new $67I8M(other))) return false;
            return true;
        case $701f2cecda9217b8$var$boolTag:
        case $701f2cecda9217b8$var$dateTag:
        case $701f2cecda9217b8$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $jXvqA(+object, +other);
        case $701f2cecda9217b8$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $701f2cecda9217b8$var$regexpTag:
        case $701f2cecda9217b8$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $701f2cecda9217b8$var$mapTag:
            var convert = $bcdei;
        case $701f2cecda9217b8$var$setTag:
            var isPartial = bitmask & $701f2cecda9217b8$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $ab9Mx);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $701f2cecda9217b8$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $8jq9w(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $701f2cecda9217b8$var$symbolTag:
            if ($701f2cecda9217b8$var$symbolValueOf) return $701f2cecda9217b8$var$symbolValueOf.call(object) == $701f2cecda9217b8$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $701f2cecda9217b8$var$equalByTag;

});
parcelRegister("67I8M", function(module, exports) {

var $8EUJq = parcelRequire("8EUJq");
/** Built-in value references. */ var $4755a2f2df9405e0$var$Uint8Array = $8EUJq.Uint8Array;
module.exports = $4755a2f2df9405e0$var$Uint8Array;

});

parcelRegister("bcdei", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $826b13cb30d370ee$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $826b13cb30d370ee$var$mapToArray;

});

parcelRegister("ab9Mx", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $769284f5737e9e57$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $769284f5737e9e57$var$setToArray;

});


parcelRegister("4iK00", function(module, exports) {

var $abLGa = parcelRequire("abLGa");
/** Used to compose bitmasks for value comparisons. */ var $321c864e8c80c1c5$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $321c864e8c80c1c5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $321c864e8c80c1c5$var$hasOwnProperty = $321c864e8c80c1c5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $321c864e8c80c1c5$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $321c864e8c80c1c5$var$COMPARE_PARTIAL_FLAG, objProps = $abLGa(object), objLength = objProps.length, othProps = $abLGa(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $321c864e8c80c1c5$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $321c864e8c80c1c5$var$equalObjects;

});
parcelRegister("abLGa", function(module, exports) {

var $7au7R = parcelRequire("7au7R");

var $e8E0v = parcelRequire("e8E0v");

var $ggedu = parcelRequire("ggedu");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $76afea888791cfe9$var$getAllKeys(object) {
    return $7au7R(object, $ggedu, $e8E0v);
}
module.exports = $76afea888791cfe9$var$getAllKeys;

});
parcelRegister("7au7R", function(module, exports) {

var $ewyyG = parcelRequire("ewyyG");

var $3Tp9Q = parcelRequire("3Tp9Q");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5380d5f1628af138$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $3Tp9Q(object) ? result : $ewyyG(result, symbolsFunc(object));
}
module.exports = $5380d5f1628af138$var$baseGetAllKeys;

});
parcelRegister("ewyyG", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a92edc69a70ab4c3$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $a92edc69a70ab4c3$var$arrayPush;

});

parcelRegister("3Tp9Q", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $2d5a05f0bf2c1bfe$var$isArray = Array.isArray;
module.exports = $2d5a05f0bf2c1bfe$var$isArray;

});


parcelRegister("e8E0v", function(module, exports) {

var $fDqm1 = parcelRequire("fDqm1");

var $4f8vh = parcelRequire("4f8vh");
/** Used for built-in method references. */ var $02a8037e77e370a7$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02a8037e77e370a7$var$propertyIsEnumerable = $02a8037e77e370a7$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02a8037e77e370a7$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02a8037e77e370a7$var$getSymbols = !$02a8037e77e370a7$var$nativeGetSymbols ? $4f8vh : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $fDqm1($02a8037e77e370a7$var$nativeGetSymbols(object), function(symbol) {
        return $02a8037e77e370a7$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $02a8037e77e370a7$var$getSymbols;

});
parcelRegister("fDqm1", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $b61ef0eed4bd618b$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $b61ef0eed4bd618b$var$arrayFilter;

});

parcelRegister("4f8vh", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $316f28c58cb11ad2$var$stubArray() {
    return [];
}
module.exports = $316f28c58cb11ad2$var$stubArray;

});


parcelRegister("ggedu", function(module, exports) {

var $gOKIu = parcelRequire("gOKIu");

var $lmpdm = parcelRequire("lmpdm");

var $l6LA7 = parcelRequire("l6LA7");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $bd692b0e9dac935f$var$keys(object) {
    return $l6LA7(object) ? $gOKIu(object) : $lmpdm(object);
}
module.exports = $bd692b0e9dac935f$var$keys;

});
parcelRegister("gOKIu", function(module, exports) {

var $6yZc3 = parcelRequire("6yZc3");

var $8v2QX = parcelRequire("8v2QX");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $gJsvo = parcelRequire("gJsvo");

var $iR1SP = parcelRequire("iR1SP");

var $bGgiZ = parcelRequire("bGgiZ");
/** Used for built-in method references. */ var $c3e58dcc696e72fb$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c3e58dcc696e72fb$var$hasOwnProperty = $c3e58dcc696e72fb$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $c3e58dcc696e72fb$var$arrayLikeKeys(value, inherited) {
    var isArr = $3Tp9Q(value), isArg = !isArr && $8v2QX(value), isBuff = !isArr && !isArg && $gJsvo(value), isType = !isArr && !isArg && !isBuff && $bGgiZ(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $6yZc3(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $c3e58dcc696e72fb$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iR1SP(key, length)))) result.push(key);
    return result;
}
module.exports = $c3e58dcc696e72fb$var$arrayLikeKeys;

});
parcelRegister("6yZc3", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $013bb3245478320e$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $013bb3245478320e$var$baseTimes;

});

parcelRegister("8v2QX", function(module, exports) {

var $cBH9e = parcelRequire("cBH9e");

var $5eSIk = parcelRequire("5eSIk");
/** Used for built-in method references. */ var $63036e92e3d9849c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $63036e92e3d9849c$var$hasOwnProperty = $63036e92e3d9849c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $63036e92e3d9849c$var$propertyIsEnumerable = $63036e92e3d9849c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $63036e92e3d9849c$var$isArguments = $cBH9e(function() {
    return arguments;
}()) ? $cBH9e : function(value) {
    return $5eSIk(value) && $63036e92e3d9849c$var$hasOwnProperty.call(value, 'callee') && !$63036e92e3d9849c$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $63036e92e3d9849c$var$isArguments;

});
parcelRegister("cBH9e", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $92da690291a71c87$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $92da690291a71c87$var$baseIsArguments(value) {
    return $5eSIk(value) && $AxfGO(value) == $92da690291a71c87$var$argsTag;
}
module.exports = $92da690291a71c87$var$baseIsArguments;

});
parcelRegister("5eSIk", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3d08b39a267bc1de$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $3d08b39a267bc1de$var$isObjectLike;

});



parcelRegister("gJsvo", function(module, exports) {

var $8EUJq = parcelRequire("8EUJq");

var $gecGB = parcelRequire("gecGB");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8EUJq.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $gecGB;
module.exports = isBuffer;

});
parcelRegister("gecGB", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $bd07cb596c2abdac$var$stubFalse() {
    return false;
}
module.exports = $bd07cb596c2abdac$var$stubFalse;

});


parcelRegister("iR1SP", function(module, exports) {
/** Used as references for various `Number` constants. */ var $db9ea339226e4638$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $db9ea339226e4638$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $db9ea339226e4638$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $db9ea339226e4638$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $db9ea339226e4638$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $db9ea339226e4638$var$isIndex;

});

parcelRegister("bGgiZ", function(module, exports) {

var $88mmh = parcelRequire("88mmh");

var $gujh9 = parcelRequire("gujh9");

var $8WiT0 = parcelRequire("8WiT0");
/* Node.js helper references. */ var $881043d315526965$var$nodeIsTypedArray = $8WiT0 && $8WiT0.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $881043d315526965$var$isTypedArray = $881043d315526965$var$nodeIsTypedArray ? $gujh9($881043d315526965$var$nodeIsTypedArray) : $88mmh;
module.exports = $881043d315526965$var$isTypedArray;

});
parcelRegister("88mmh", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $7vrs5 = parcelRequire("7vrs5");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $5ec069fb58782be0$var$argsTag = '[object Arguments]', $5ec069fb58782be0$var$arrayTag = '[object Array]', $5ec069fb58782be0$var$boolTag = '[object Boolean]', $5ec069fb58782be0$var$dateTag = '[object Date]', $5ec069fb58782be0$var$errorTag = '[object Error]', $5ec069fb58782be0$var$funcTag = '[object Function]', $5ec069fb58782be0$var$mapTag = '[object Map]', $5ec069fb58782be0$var$numberTag = '[object Number]', $5ec069fb58782be0$var$objectTag = '[object Object]', $5ec069fb58782be0$var$regexpTag = '[object RegExp]', $5ec069fb58782be0$var$setTag = '[object Set]', $5ec069fb58782be0$var$stringTag = '[object String]', $5ec069fb58782be0$var$weakMapTag = '[object WeakMap]';
var $5ec069fb58782be0$var$arrayBufferTag = '[object ArrayBuffer]', $5ec069fb58782be0$var$dataViewTag = '[object DataView]', $5ec069fb58782be0$var$float32Tag = '[object Float32Array]', $5ec069fb58782be0$var$float64Tag = '[object Float64Array]', $5ec069fb58782be0$var$int8Tag = '[object Int8Array]', $5ec069fb58782be0$var$int16Tag = '[object Int16Array]', $5ec069fb58782be0$var$int32Tag = '[object Int32Array]', $5ec069fb58782be0$var$uint8Tag = '[object Uint8Array]', $5ec069fb58782be0$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5ec069fb58782be0$var$uint16Tag = '[object Uint16Array]', $5ec069fb58782be0$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $5ec069fb58782be0$var$typedArrayTags = {};
$5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$float32Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$float64Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$int8Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$int16Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$int32Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$uint8Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$uint8ClampedTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$uint16Tag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$uint32Tag] = true;
$5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$argsTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$arrayTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$arrayBufferTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$boolTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$dataViewTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$dateTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$errorTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$funcTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$mapTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$numberTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$objectTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$regexpTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$setTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$stringTag] = $5ec069fb58782be0$var$typedArrayTags[$5ec069fb58782be0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $5ec069fb58782be0$var$baseIsTypedArray(value) {
    return $5eSIk(value) && $7vrs5(value.length) && !!$5ec069fb58782be0$var$typedArrayTags[$AxfGO(value)];
}
module.exports = $5ec069fb58782be0$var$baseIsTypedArray;

});
parcelRegister("7vrs5", function(module, exports) {
/** Used as references for various `Number` constants. */ var $5770b90eccf77589$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $5770b90eccf77589$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $5770b90eccf77589$var$MAX_SAFE_INTEGER;
}
module.exports = $5770b90eccf77589$var$isLength;

});


parcelRegister("gujh9", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $031901a6d43271cf$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $031901a6d43271cf$var$baseUnary;

});

parcelRegister("8WiT0", function(module, exports) {

var $lzrsY = parcelRequire("lzrsY");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $lzrsY.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("lmpdm", function(module, exports) {

var $4hd8j = parcelRequire("4hd8j");

var $9Pe7u = parcelRequire("9Pe7u");
/** Used for built-in method references. */ var $f8cf36189d91bcda$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f8cf36189d91bcda$var$hasOwnProperty = $f8cf36189d91bcda$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f8cf36189d91bcda$var$baseKeys(object) {
    if (!$4hd8j(object)) return $9Pe7u(object);
    var result = [];
    for(var key in Object(object))if ($f8cf36189d91bcda$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $f8cf36189d91bcda$var$baseKeys;

});
parcelRegister("4hd8j", function(module, exports) {
/** Used for built-in method references. */ var $31d2efe929cfc57e$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $31d2efe929cfc57e$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $31d2efe929cfc57e$var$objectProto;
    return value === proto;
}
module.exports = $31d2efe929cfc57e$var$isPrototype;

});

parcelRegister("9Pe7u", function(module, exports) {

var $hvZ3l = parcelRequire("hvZ3l");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7273d45acbf1af00$var$nativeKeys = $hvZ3l(Object.keys, Object);
module.exports = $7273d45acbf1af00$var$nativeKeys;

});
parcelRegister("hvZ3l", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $cc04b0c026c4e707$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $cc04b0c026c4e707$var$overArg;

});



parcelRegister("l6LA7", function(module, exports) {

var $iwbTU = parcelRequire("iwbTU");

var $7vrs5 = parcelRequire("7vrs5");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $f5df1134611536a1$var$isArrayLike(value) {
    return value != null && $7vrs5(value.length) && !$iwbTU(value);
}
module.exports = $f5df1134611536a1$var$isArrayLike;

});




parcelRegister("4L1Ez", function(module, exports) {

var $axOeW = parcelRequire("axOeW");

var $6KMix = parcelRequire("6KMix");

var $7YNA6 = parcelRequire("7YNA6");

var $9y4oV = parcelRequire("9y4oV");

var $7rYDd = parcelRequire("7rYDd");

var $AxfGO = parcelRequire("AxfGO");

var $aMscu = parcelRequire("aMscu");
/** `Object#toString` result references. */ var $376cd583e0ae39c6$var$mapTag = '[object Map]', $376cd583e0ae39c6$var$objectTag = '[object Object]', $376cd583e0ae39c6$var$promiseTag = '[object Promise]', $376cd583e0ae39c6$var$setTag = '[object Set]', $376cd583e0ae39c6$var$weakMapTag = '[object WeakMap]';
var $376cd583e0ae39c6$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $376cd583e0ae39c6$var$dataViewCtorString = $aMscu($axOeW), $376cd583e0ae39c6$var$mapCtorString = $aMscu($6KMix), $376cd583e0ae39c6$var$promiseCtorString = $aMscu($7YNA6), $376cd583e0ae39c6$var$setCtorString = $aMscu($9y4oV), $376cd583e0ae39c6$var$weakMapCtorString = $aMscu($7rYDd);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $376cd583e0ae39c6$var$getTag = $AxfGO;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($axOeW && $376cd583e0ae39c6$var$getTag(new $axOeW(new ArrayBuffer(1))) != $376cd583e0ae39c6$var$dataViewTag || $6KMix && $376cd583e0ae39c6$var$getTag(new $6KMix) != $376cd583e0ae39c6$var$mapTag || $7YNA6 && $376cd583e0ae39c6$var$getTag($7YNA6.resolve()) != $376cd583e0ae39c6$var$promiseTag || $9y4oV && $376cd583e0ae39c6$var$getTag(new $9y4oV) != $376cd583e0ae39c6$var$setTag || $7rYDd && $376cd583e0ae39c6$var$getTag(new $7rYDd) != $376cd583e0ae39c6$var$weakMapTag) $376cd583e0ae39c6$var$getTag = function(value) {
    var result = $AxfGO(value), Ctor = result == $376cd583e0ae39c6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $aMscu(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $376cd583e0ae39c6$var$dataViewCtorString:
            return $376cd583e0ae39c6$var$dataViewTag;
        case $376cd583e0ae39c6$var$mapCtorString:
            return $376cd583e0ae39c6$var$mapTag;
        case $376cd583e0ae39c6$var$promiseCtorString:
            return $376cd583e0ae39c6$var$promiseTag;
        case $376cd583e0ae39c6$var$setCtorString:
            return $376cd583e0ae39c6$var$setTag;
        case $376cd583e0ae39c6$var$weakMapCtorString:
            return $376cd583e0ae39c6$var$weakMapTag;
    }
    return result;
};
module.exports = $376cd583e0ae39c6$var$getTag;

});
parcelRegister("axOeW", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");

var $8EUJq = parcelRequire("8EUJq");
/* Built-in method references that are verified to be native. */ var $7ad3f5121d181109$var$DataView = $dQQVk($8EUJq, 'DataView');
module.exports = $7ad3f5121d181109$var$DataView;

});

parcelRegister("7YNA6", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");

var $8EUJq = parcelRequire("8EUJq");
/* Built-in method references that are verified to be native. */ var $5cf498ca5720ca1f$var$Promise = $dQQVk($8EUJq, 'Promise');
module.exports = $5cf498ca5720ca1f$var$Promise;

});

parcelRegister("9y4oV", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");

var $8EUJq = parcelRequire("8EUJq");
/* Built-in method references that are verified to be native. */ var $6f3ab3f8b85a6456$var$Set = $dQQVk($8EUJq, 'Set');
module.exports = $6f3ab3f8b85a6456$var$Set;

});

parcelRegister("7rYDd", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");

var $8EUJq = parcelRequire("8EUJq");
/* Built-in method references that are verified to be native. */ var $56ca162cf175f6ab$var$WeakMap = $dQQVk($8EUJq, 'WeakMap');
module.exports = $56ca162cf175f6ab$var$WeakMap;

});





parcelRegister("gmYCm", function(module, exports) {

var $9HE7T = parcelRequire("9HE7T");

var $ggedu = parcelRequire("ggedu");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $beadb8ced053cf9c$var$getMatchData(object) {
    var result = $ggedu(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9HE7T(value)
        ];
    }
    return result;
}
module.exports = $beadb8ced053cf9c$var$getMatchData;

});
parcelRegister("9HE7T", function(module, exports) {

var $p4u5f = parcelRequire("p4u5f");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $71074174b9c50e64$var$isStrictComparable(value) {
    return value === value && !$p4u5f(value);
}
module.exports = $71074174b9c50e64$var$isStrictComparable;

});


parcelRegister("2rTJf", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1c8954f29636c7ce$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1c8954f29636c7ce$var$matchesStrictComparable;

});


parcelRegister("fUXsj", function(module, exports) {

var $h4aRS = parcelRequire("h4aRS");

var $arVBy = parcelRequire("arVBy");

var $jmoYv = parcelRequire("jmoYv");

var $lgSgk = parcelRequire("lgSgk");

var $9HE7T = parcelRequire("9HE7T");

var $2rTJf = parcelRequire("2rTJf");

var $fOiJD = parcelRequire("fOiJD");
/** Used to compose bitmasks for value comparisons. */ var $b96a34a14c9c3428$var$COMPARE_PARTIAL_FLAG = 1, $b96a34a14c9c3428$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b96a34a14c9c3428$var$baseMatchesProperty(path, srcValue) {
    if ($lgSgk(path) && $9HE7T(srcValue)) return $2rTJf($fOiJD(path), srcValue);
    return function(object) {
        var objValue = $arVBy(object, path);
        return objValue === undefined && objValue === srcValue ? $jmoYv(object, path) : $h4aRS(srcValue, objValue, $b96a34a14c9c3428$var$COMPARE_PARTIAL_FLAG | $b96a34a14c9c3428$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $b96a34a14c9c3428$var$baseMatchesProperty;

});
parcelRegister("arVBy", function(module, exports) {

var $goyLi = parcelRequire("goyLi");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $79b91c1d0f48c317$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $goyLi(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $79b91c1d0f48c317$var$get;

});
parcelRegister("goyLi", function(module, exports) {

var $4RdXx = parcelRequire("4RdXx");

var $fOiJD = parcelRequire("fOiJD");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $bef9da31b5ae806b$var$baseGet(object, path) {
    path = $4RdXx(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$fOiJD(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $bef9da31b5ae806b$var$baseGet;

});
parcelRegister("4RdXx", function(module, exports) {

var $3Tp9Q = parcelRequire("3Tp9Q");

var $lgSgk = parcelRequire("lgSgk");

var $dJNir = parcelRequire("dJNir");

var $lOV73 = parcelRequire("lOV73");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $3896f0ae40c4a9c4$var$castPath(value, object) {
    if ($3Tp9Q(value)) return value;
    return $lgSgk(value, object) ? [
        value
    ] : $dJNir($lOV73(value));
}
module.exports = $3896f0ae40c4a9c4$var$castPath;

});
parcelRegister("lgSgk", function(module, exports) {

var $3Tp9Q = parcelRequire("3Tp9Q");

var $cTEyW = parcelRequire("cTEyW");
/** Used to match property names within property paths. */ var $f7c52ef2d63f6e7b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $f7c52ef2d63f6e7b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $f7c52ef2d63f6e7b$var$isKey(value, object) {
    if ($3Tp9Q(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $cTEyW(value)) return true;
    return $f7c52ef2d63f6e7b$var$reIsPlainProp.test(value) || !$f7c52ef2d63f6e7b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $f7c52ef2d63f6e7b$var$isKey;

});
parcelRegister("cTEyW", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $963a15f9c69d315a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $963a15f9c69d315a$var$isSymbol(value) {
    return typeof value == 'symbol' || $5eSIk(value) && $AxfGO(value) == $963a15f9c69d315a$var$symbolTag;
}
module.exports = $963a15f9c69d315a$var$isSymbol;

});


parcelRegister("dJNir", function(module, exports) {

var $cJJ38 = parcelRequire("cJJ38");
/** Used to match property names within property paths. */ var $a005b796ab5b793e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $a005b796ab5b793e$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $a005b796ab5b793e$var$stringToPath = $cJJ38(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($a005b796ab5b793e$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($a005b796ab5b793e$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $a005b796ab5b793e$var$stringToPath;

});
parcelRegister("cJJ38", function(module, exports) {

var $gOwLM = parcelRequire("gOwLM");
/** Used as the maximum memoize cache size. */ var $945ca1eb304cc2a0$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $945ca1eb304cc2a0$var$memoizeCapped(func) {
    var result = $gOwLM(func, function(key) {
        if (cache.size === $945ca1eb304cc2a0$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $945ca1eb304cc2a0$var$memoizeCapped;

});
parcelRegister("gOwLM", function(module, exports) {

var $e1aJR = parcelRequire("e1aJR");
/** Error message constants. */ var $c3dabc3c157634d4$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c3dabc3c157634d4$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c3dabc3c157634d4$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c3dabc3c157634d4$var$memoize.Cache || $e1aJR);
    return memoized;
}
// Expose `MapCache`.
$c3dabc3c157634d4$var$memoize.Cache = $e1aJR;
module.exports = $c3dabc3c157634d4$var$memoize;

});



parcelRegister("lOV73", function(module, exports) {

var $7zNqN = parcelRequire("7zNqN");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $fe2a91e0d3c5028e$var$toString(value) {
    return value == null ? '' : $7zNqN(value);
}
module.exports = $fe2a91e0d3c5028e$var$toString;

});
parcelRegister("7zNqN", function(module, exports) {

var $aizG2 = parcelRequire("aizG2");

var $6NHeY = parcelRequire("6NHeY");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $cTEyW = parcelRequire("cTEyW");
/** Used as references for various `Number` constants. */ var $5842254968636635$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $5842254968636635$var$symbolProto = $aizG2 ? $aizG2.prototype : undefined, $5842254968636635$var$symbolToString = $5842254968636635$var$symbolProto ? $5842254968636635$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $5842254968636635$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($3Tp9Q(value)) // Recursively convert values (susceptible to call stack limits).
    return $6NHeY(value, $5842254968636635$var$baseToString) + '';
    if ($cTEyW(value)) return $5842254968636635$var$symbolToString ? $5842254968636635$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$5842254968636635$var$INFINITY ? '-0' : result;
}
module.exports = $5842254968636635$var$baseToString;

});
parcelRegister("6NHeY", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $4f38dc5d086483b6$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $4f38dc5d086483b6$var$arrayMap;

});




parcelRegister("fOiJD", function(module, exports) {

var $cTEyW = parcelRequire("cTEyW");
/** Used as references for various `Number` constants. */ var $b82a0ee8e5b05f00$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b82a0ee8e5b05f00$var$toKey(value) {
    if (typeof value == 'string' || $cTEyW(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$b82a0ee8e5b05f00$var$INFINITY ? '-0' : result;
}
module.exports = $b82a0ee8e5b05f00$var$toKey;

});



parcelRegister("jmoYv", function(module, exports) {

var $epBBe = parcelRequire("epBBe");

var $4tNyC = parcelRequire("4tNyC");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e18371e2793305f3$var$hasIn(object, path) {
    return object != null && $4tNyC(object, path, $epBBe);
}
module.exports = $e18371e2793305f3$var$hasIn;

});
parcelRegister("epBBe", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $a7e090f466927b38$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $a7e090f466927b38$var$baseHasIn;

});

parcelRegister("4tNyC", function(module, exports) {

var $4RdXx = parcelRequire("4RdXx");

var $8v2QX = parcelRequire("8v2QX");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $iR1SP = parcelRequire("iR1SP");

var $7vrs5 = parcelRequire("7vrs5");

var $fOiJD = parcelRequire("fOiJD");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $34304fe85c80a67a$var$hasPath(object, path, hasFunc) {
    path = $4RdXx(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $fOiJD(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $7vrs5(length) && $iR1SP(key, length) && ($3Tp9Q(object) || $8v2QX(object));
}
module.exports = $34304fe85c80a67a$var$hasPath;

});



parcelRegister("h9L3N", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $c7d7c81a534255d0$var$identity(value) {
    return value;
}
module.exports = $c7d7c81a534255d0$var$identity;

});

parcelRegister("hJEKE", function(module, exports) {

var $fzKO9 = parcelRequire("fzKO9");

var $6m82u = parcelRequire("6m82u");

var $lgSgk = parcelRequire("lgSgk");

var $fOiJD = parcelRequire("fOiJD");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $ce964007eff9eac6$var$property(path) {
    return $lgSgk(path) ? $fzKO9($fOiJD(path)) : $6m82u(path);
}
module.exports = $ce964007eff9eac6$var$property;

});
parcelRegister("fzKO9", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b56e6efa1a3aa51b$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $b56e6efa1a3aa51b$var$baseProperty;

});

parcelRegister("6m82u", function(module, exports) {

var $goyLi = parcelRequire("goyLi");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4a0b088c6ecf03f9$var$basePropertyDeep(path) {
    return function(object) {
        return $goyLi(object, path);
    };
}
module.exports = $4a0b088c6ecf03f9$var$basePropertyDeep;

});



parcelRegister("aETF3", function(module, exports) {
/** Error message constants. */ var $7c28d0f4605bf381$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $7c28d0f4605bf381$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($7c28d0f4605bf381$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $7c28d0f4605bf381$var$negate;

});

parcelRegister("1rRYH", function(module, exports) {

var $6NHeY = parcelRequire("6NHeY");

var $kUeJo = parcelRequire("kUeJo");

var $93B5u = parcelRequire("93B5u");

var $bA7AA = parcelRequire("bA7AA");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $10e22efbc34fc798$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $6NHeY($bA7AA(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $kUeJo(predicate);
    return $93B5u(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $10e22efbc34fc798$var$pickBy;

});
parcelRegister("93B5u", function(module, exports) {

var $goyLi = parcelRequire("goyLi");

var $1MhNy = parcelRequire("1MhNy");

var $4RdXx = parcelRequire("4RdXx");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $698129ac26b9f739$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $goyLi(object, path);
        if (predicate(value, path)) $1MhNy(result, $4RdXx(path, object), value);
    }
    return result;
}
module.exports = $698129ac26b9f739$var$basePickBy;

});
parcelRegister("1MhNy", function(module, exports) {

var $3gXGs = parcelRequire("3gXGs");

var $4RdXx = parcelRequire("4RdXx");

var $iR1SP = parcelRequire("iR1SP");

var $p4u5f = parcelRequire("p4u5f");

var $fOiJD = parcelRequire("fOiJD");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $14b8147d05de0f88$var$baseSet(object, path, value, customizer) {
    if (!$p4u5f(object)) return object;
    path = $4RdXx(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $fOiJD(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $p4u5f(objValue) ? objValue : $iR1SP(path[index + 1]) ? [] : {};
        }
        $3gXGs(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $14b8147d05de0f88$var$baseSet;

});
parcelRegister("3gXGs", function(module, exports) {

var $7HHlO = parcelRequire("7HHlO");

var $jXvqA = parcelRequire("jXvqA");
/** Used for built-in method references. */ var $262129acc3ded101$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $262129acc3ded101$var$hasOwnProperty = $262129acc3ded101$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $262129acc3ded101$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($262129acc3ded101$var$hasOwnProperty.call(object, key) && $jXvqA(objValue, value)) || value === undefined && !(key in object)) $7HHlO(object, key, value);
}
module.exports = $262129acc3ded101$var$assignValue;

});
parcelRegister("7HHlO", function(module, exports) {

var $hh0Sa = parcelRequire("hh0Sa");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $59be2d1aac78853b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $hh0Sa) $hh0Sa(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $59be2d1aac78853b$var$baseAssignValue;

});
parcelRegister("hh0Sa", function(module, exports) {

var $dQQVk = parcelRequire("dQQVk");
var $c934b37a3bce59fb$var$defineProperty = function() {
    try {
        var func = $dQQVk(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $c934b37a3bce59fb$var$defineProperty;

});





parcelRegister("bA7AA", function(module, exports) {

var $7au7R = parcelRequire("7au7R");

var $2CpCu = parcelRequire("2CpCu");

var $f9RRo = parcelRequire("f9RRo");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $86e8f18b43dd011f$var$getAllKeysIn(object) {
    return $7au7R(object, $f9RRo, $2CpCu);
}
module.exports = $86e8f18b43dd011f$var$getAllKeysIn;

});
parcelRegister("2CpCu", function(module, exports) {

var $ewyyG = parcelRequire("ewyyG");

var $9sZx7 = parcelRequire("9sZx7");

var $e8E0v = parcelRequire("e8E0v");

var $4f8vh = parcelRequire("4f8vh");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1e8300f7396d919d$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1e8300f7396d919d$var$getSymbolsIn = !$1e8300f7396d919d$var$nativeGetSymbols ? $4f8vh : function(object) {
    var result = [];
    while(object){
        $ewyyG(result, $e8E0v(object));
        object = $9sZx7(object);
    }
    return result;
};
module.exports = $1e8300f7396d919d$var$getSymbolsIn;

});
parcelRegister("9sZx7", function(module, exports) {

var $hvZ3l = parcelRequire("hvZ3l");
/** Built-in value references. */ var $6e4675ce5ba2f185$var$getPrototype = $hvZ3l(Object.getPrototypeOf, Object);
module.exports = $6e4675ce5ba2f185$var$getPrototype;

});


parcelRegister("f9RRo", function(module, exports) {

var $gOKIu = parcelRequire("gOKIu");

var $ferYm = parcelRequire("ferYm");

var $l6LA7 = parcelRequire("l6LA7");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $b09179c960478997$var$keysIn(object) {
    return $l6LA7(object) ? $gOKIu(object, true) : $ferYm(object);
}
module.exports = $b09179c960478997$var$keysIn;

});
parcelRegister("ferYm", function(module, exports) {

var $p4u5f = parcelRequire("p4u5f");

var $4hd8j = parcelRequire("4hd8j");

var $l1EOb = parcelRequire("l1EOb");
/** Used for built-in method references. */ var $b16ddc9511e2ece4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b16ddc9511e2ece4$var$hasOwnProperty = $b16ddc9511e2ece4$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $b16ddc9511e2ece4$var$baseKeysIn(object) {
    if (!$p4u5f(object)) return $l1EOb(object);
    var isProto = $4hd8j(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$b16ddc9511e2ece4$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $b16ddc9511e2ece4$var$baseKeysIn;

});
parcelRegister("l1EOb", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f4e958a623c22455$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $f4e958a623c22455$var$nativeKeysIn;

});






parcelRegister("cd0y6", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsType", () => $d6aa5d8b92693a33$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $d6aa5d8b92693a33$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $d6aa5d8b92693a33$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $d6aa5d8b92693a33$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $d6aa5d8b92693a33$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $d6aa5d8b92693a33$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $d6aa5d8b92693a33$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $d6aa5d8b92693a33$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $d6aa5d8b92693a33$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $d6aa5d8b92693a33$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $d6aa5d8b92693a33$export$af63d7414243dad3);

var $gB8hB = parcelRequire("gB8hB");

var $esuIC = parcelRequire("esuIC");

var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $4CTsu = parcelRequire("4CTsu");

var $1qNjk = parcelRequire("1qNjk");
const $d6aa5d8b92693a33$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $d6aa5d8b92693a33$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $d6aa5d8b92693a33$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $d6aa5d8b92693a33$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $d6aa5d8b92693a33$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CTsu)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($esuIC))));
};
const $d6aa5d8b92693a33$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'source').filter(Boolean));
const $d6aa5d8b92693a33$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $d6aa5d8b92693a33$export$6ca3170acb89054 = (event)=>event.payload.action;
const $d6aa5d8b92693a33$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $d6aa5d8b92693a33$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'containerId').filter(Boolean));
const $d6aa5d8b92693a33$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'containerType').filter(Boolean));
const $d6aa5d8b92693a33$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'objectId').filter(Boolean));
const $d6aa5d8b92693a33$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))($d6aa5d8b92693a33$var$extractFromContext(event, 'objectType').filter(Boolean));
const $d6aa5d8b92693a33$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($1qNjk)))((0, (/*@__PURE__*/$parcel$interopDefault($gB8hB)))($d6aa5d8b92693a33$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});
parcelRegister("gB8hB", function(module, exports) {

var $6h4BD = parcelRequire("6h4BD");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $c15686dfc63b92a9$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $6h4BD(array, 1) : [];
}
module.exports = $c15686dfc63b92a9$var$flatten;

});
parcelRegister("6h4BD", function(module, exports) {

var $ewyyG = parcelRequire("ewyyG");

var $eRaLJ = parcelRequire("eRaLJ");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $4917e748146041f1$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eRaLJ);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $4917e748146041f1$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $ewyyG(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $4917e748146041f1$var$baseFlatten;

});
parcelRegister("eRaLJ", function(module, exports) {

var $aizG2 = parcelRequire("aizG2");

var $8v2QX = parcelRequire("8v2QX");

var $3Tp9Q = parcelRequire("3Tp9Q");
/** Built-in value references. */ var $ad0e5e63e9ddc232$var$spreadableSymbol = $aizG2 ? $aizG2.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $ad0e5e63e9ddc232$var$isFlattenable(value) {
    return $3Tp9Q(value) || $8v2QX(value) || !!($ad0e5e63e9ddc232$var$spreadableSymbol && value && value[$ad0e5e63e9ddc232$var$spreadableSymbol]);
}
module.exports = $ad0e5e63e9ddc232$var$isFlattenable;

});



parcelRegister("dZ56i", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $a2e4edb858e559a1$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $a2e4edb858e559a1$var$last;

});

parcelRegister("lc40q", function(module, exports) {

var $1iSPc = parcelRequire("1iSPc");

var $jQNuE = parcelRequire("jQNuE");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $f6ddd3749da7e0b1$var$merge = $jQNuE(function(object, source, srcIndex) {
    $1iSPc(object, source, srcIndex);
});
module.exports = $f6ddd3749da7e0b1$var$merge;

});
parcelRegister("1iSPc", function(module, exports) {

var $cPeOR = parcelRequire("cPeOR");

var $klLbb = parcelRequire("klLbb");

var $ebii4 = parcelRequire("ebii4");

var $52Kp8 = parcelRequire("52Kp8");

var $p4u5f = parcelRequire("p4u5f");

var $f9RRo = parcelRequire("f9RRo");

var $d68Sx = parcelRequire("d68Sx");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $0f31fff61be5720a$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $ebii4(source, function(srcValue, key) {
        stack || (stack = new $cPeOR);
        if ($p4u5f(srcValue)) $52Kp8(object, source, key, srcIndex, $0f31fff61be5720a$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($d68Sx(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $klLbb(object, key, newValue);
        }
    }, $f9RRo);
}
module.exports = $0f31fff61be5720a$var$baseMerge;

});
parcelRegister("klLbb", function(module, exports) {

var $7HHlO = parcelRequire("7HHlO");

var $jXvqA = parcelRequire("jXvqA");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $ed0a5dabda7a2a7e$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$jXvqA(object[key], value) || value === undefined && !(key in object)) $7HHlO(object, key, value);
}
module.exports = $ed0a5dabda7a2a7e$var$assignMergeValue;

});

parcelRegister("ebii4", function(module, exports) {

var $4RoHS = parcelRequire("4RoHS");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a53047e37e35cfbc$var$baseFor = $4RoHS();
module.exports = $a53047e37e35cfbc$var$baseFor;

});
parcelRegister("4RoHS", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $389f46e94a53bdac$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $389f46e94a53bdac$var$createBaseFor;

});


parcelRegister("52Kp8", function(module, exports) {

var $klLbb = parcelRequire("klLbb");

var $jULUM = parcelRequire("jULUM");

var $VUNjX = parcelRequire("VUNjX");

var $1ae9m = parcelRequire("1ae9m");

var $iFB7V = parcelRequire("iFB7V");

var $8v2QX = parcelRequire("8v2QX");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $fw4D7 = parcelRequire("fw4D7");

var $gJsvo = parcelRequire("gJsvo");

var $iwbTU = parcelRequire("iwbTU");

var $p4u5f = parcelRequire("p4u5f");

var $hUF1A = parcelRequire("hUF1A");

var $bGgiZ = parcelRequire("bGgiZ");

var $d68Sx = parcelRequire("d68Sx");

var $6qHHQ = parcelRequire("6qHHQ");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $3ac12295b9b59b99$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $d68Sx(object, key), srcValue = $d68Sx(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $klLbb(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $3Tp9Q(srcValue), isBuff = !isArr && $gJsvo(srcValue), isTyped = !isArr && !isBuff && $bGgiZ(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($3Tp9Q(objValue)) newValue = objValue;
            else if ($fw4D7(objValue)) newValue = $1ae9m(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $jULUM(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $VUNjX(srcValue, true);
            } else newValue = [];
        } else if ($hUF1A(srcValue) || $8v2QX(srcValue)) {
            newValue = objValue;
            if ($8v2QX(objValue)) newValue = $6qHHQ(objValue);
            else if (!$p4u5f(objValue) || $iwbTU(objValue)) newValue = $iFB7V(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $klLbb(object, key, newValue);
}
module.exports = $3ac12295b9b59b99$var$baseMergeDeep;

});
parcelRegister("jULUM", function(module, exports) {

var $8EUJq = parcelRequire("8EUJq");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $8EUJq.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("VUNjX", function(module, exports) {

var $hE540 = parcelRequire("hE540");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $0ae16130a31357cc$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $hE540(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $0ae16130a31357cc$var$cloneTypedArray;

});
parcelRegister("hE540", function(module, exports) {

var $67I8M = parcelRequire("67I8M");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $cd8a19a1df86a7f3$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $67I8M(result).set(new $67I8M(arrayBuffer));
    return result;
}
module.exports = $cd8a19a1df86a7f3$var$cloneArrayBuffer;

});


parcelRegister("1ae9m", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $0d91b37e42950a73$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $0d91b37e42950a73$var$copyArray;

});

parcelRegister("iFB7V", function(module, exports) {

var $47rAk = parcelRequire("47rAk");

var $9sZx7 = parcelRequire("9sZx7");

var $4hd8j = parcelRequire("4hd8j");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d978daebbf93ff84$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$4hd8j(object) ? $47rAk($9sZx7(object)) : {};
}
module.exports = $d978daebbf93ff84$var$initCloneObject;

});
parcelRegister("47rAk", function(module, exports) {

var $p4u5f = parcelRequire("p4u5f");
/** Built-in value references. */ var $2ffd36ae0f78a1f6$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $2ffd36ae0f78a1f6$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$p4u5f(proto)) return {};
        if ($2ffd36ae0f78a1f6$var$objectCreate) return $2ffd36ae0f78a1f6$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $2ffd36ae0f78a1f6$var$baseCreate;

});


parcelRegister("fw4D7", function(module, exports) {

var $l6LA7 = parcelRequire("l6LA7");

var $5eSIk = parcelRequire("5eSIk");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $b4bd6f9bad7230ed$var$isArrayLikeObject(value) {
    return $5eSIk(value) && $l6LA7(value);
}
module.exports = $b4bd6f9bad7230ed$var$isArrayLikeObject;

});

parcelRegister("hUF1A", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $9sZx7 = parcelRequire("9sZx7");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $d0a77d3eef3d146a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $d0a77d3eef3d146a$var$funcProto = Function.prototype, $d0a77d3eef3d146a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $d0a77d3eef3d146a$var$funcToString = $d0a77d3eef3d146a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $d0a77d3eef3d146a$var$hasOwnProperty = $d0a77d3eef3d146a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $d0a77d3eef3d146a$var$objectCtorString = $d0a77d3eef3d146a$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $d0a77d3eef3d146a$var$isPlainObject(value) {
    if (!$5eSIk(value) || $AxfGO(value) != $d0a77d3eef3d146a$var$objectTag) return false;
    var proto = $9sZx7(value);
    if (proto === null) return true;
    var Ctor = $d0a77d3eef3d146a$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $d0a77d3eef3d146a$var$funcToString.call(Ctor) == $d0a77d3eef3d146a$var$objectCtorString;
}
module.exports = $d0a77d3eef3d146a$var$isPlainObject;

});

parcelRegister("d68Sx", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $9892b908d81951b2$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $9892b908d81951b2$var$safeGet;

});

parcelRegister("6qHHQ", function(module, exports) {

var $9rlIO = parcelRequire("9rlIO");

var $f9RRo = parcelRequire("f9RRo");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $4ae712eae4c21573$var$toPlainObject(value) {
    return $9rlIO(value, $f9RRo(value));
}
module.exports = $4ae712eae4c21573$var$toPlainObject;

});
parcelRegister("9rlIO", function(module, exports) {

var $3gXGs = parcelRequire("3gXGs");

var $7HHlO = parcelRequire("7HHlO");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $6df77c2ea0ff9da9$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $7HHlO(object, key, newValue);
        else $3gXGs(object, key, newValue);
    }
    return object;
}
module.exports = $6df77c2ea0ff9da9$var$copyObject;

});




parcelRegister("jQNuE", function(module, exports) {

var $5wqj6 = parcelRequire("5wqj6");

var $i0jmw = parcelRequire("i0jmw");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $e73943fc7eda9ebe$var$createAssigner(assigner) {
    return $5wqj6(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $i0jmw(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $e73943fc7eda9ebe$var$createAssigner;

});
parcelRegister("5wqj6", function(module, exports) {

var $h9L3N = parcelRequire("h9L3N");

var $5JCo3 = parcelRequire("5JCo3");

var $epdYk = parcelRequire("epdYk");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $405458f1a022b05a$var$baseRest(func, start) {
    return $epdYk($5JCo3(func, start, $h9L3N), func + '');
}
module.exports = $405458f1a022b05a$var$baseRest;

});
parcelRegister("5JCo3", function(module, exports) {

var $bf4mq = parcelRequire("bf4mq");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $42ceee974424c200$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $42ceee974424c200$var$overRest(func, start, transform) {
    start = $42ceee974424c200$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $42ceee974424c200$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $bf4mq(func, this, otherArgs);
    };
}
module.exports = $42ceee974424c200$var$overRest;

});
parcelRegister("bf4mq", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $82f47a580c2ee11c$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $82f47a580c2ee11c$var$apply;

});


parcelRegister("epdYk", function(module, exports) {

var $2ujEP = parcelRequire("2ujEP");

var $igN9W = parcelRequire("igN9W");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $a7ce3d0bed1ed676$var$setToString = $igN9W($2ujEP);
module.exports = $a7ce3d0bed1ed676$var$setToString;

});
parcelRegister("2ujEP", function(module, exports) {

var $bwZgA = parcelRequire("bwZgA");

var $hh0Sa = parcelRequire("hh0Sa");

var $h9L3N = parcelRequire("h9L3N");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1cfda1b3a5f42874$var$baseSetToString = !$hh0Sa ? $h9L3N : function(func, string) {
    return $hh0Sa(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $bwZgA(string),
        'writable': true
    });
};
module.exports = $1cfda1b3a5f42874$var$baseSetToString;

});
parcelRegister("bwZgA", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $8652351de2148e9e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $8652351de2148e9e$var$constant;

});


parcelRegister("igN9W", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d4cfdaa3f5d6e727$var$HOT_COUNT = 800, $d4cfdaa3f5d6e727$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d4cfdaa3f5d6e727$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d4cfdaa3f5d6e727$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d4cfdaa3f5d6e727$var$nativeNow(), remaining = $d4cfdaa3f5d6e727$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d4cfdaa3f5d6e727$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $d4cfdaa3f5d6e727$var$shortOut;

});



parcelRegister("i0jmw", function(module, exports) {

var $jXvqA = parcelRequire("jXvqA");

var $l6LA7 = parcelRequire("l6LA7");

var $iR1SP = parcelRequire("iR1SP");

var $p4u5f = parcelRequire("p4u5f");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $d1b73f04697d0f37$var$isIterateeCall(value, index, object) {
    if (!$p4u5f(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $l6LA7(object) && $iR1SP(index, object.length) : type == 'string' && index in object) return $jXvqA(object[index], value);
    return false;
}
module.exports = $d1b73f04697d0f37$var$isIterateeCall;

});



parcelRegister("1qNjk", function(module, exports) {

var $ffi5e = parcelRequire("ffi5e");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $10ae783d8a98bd14$var$uniq(array) {
    return array && array.length ? $ffi5e(array) : [];
}
module.exports = $10ae783d8a98bd14$var$uniq;

});
parcelRegister("ffi5e", function(module, exports) {

var $2QZKx = parcelRequire("2QZKx");

var $9F02t = parcelRequire("9F02t");

var $9E4uy = parcelRequire("9E4uy");

var $a1q04 = parcelRequire("a1q04");

var $lOT5y = parcelRequire("lOT5y");

var $ab9Mx = parcelRequire("ab9Mx");
/** Used as the size to enable large array optimizations. */ var $b19648b102d345f7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $b19648b102d345f7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $9F02t, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $9E4uy;
    } else if (length >= $b19648b102d345f7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $lOT5y(array);
        if (set) return $ab9Mx(set);
        isCommon = false;
        includes = $a1q04;
        seen = new $2QZKx;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $b19648b102d345f7$var$baseUniq;

});
parcelRegister("9F02t", function(module, exports) {

var $3MSxm = parcelRequire("3MSxm");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $7087f9218cb9818a$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $3MSxm(array, value, 0) > -1;
}
module.exports = $7087f9218cb9818a$var$arrayIncludes;

});
parcelRegister("3MSxm", function(module, exports) {

var $aVpwI = parcelRequire("aVpwI");

var $gsLRV = parcelRequire("gsLRV");

var $8sy5Z = parcelRequire("8sy5Z");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2c2028be2ffbf059$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $8sy5Z(array, value, fromIndex) : $aVpwI(array, $gsLRV, fromIndex);
}
module.exports = $2c2028be2ffbf059$var$baseIndexOf;

});
parcelRegister("aVpwI", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7f43074e54f12b65$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $7f43074e54f12b65$var$baseFindIndex;

});

parcelRegister("gsLRV", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $bfc46499927fa5d6$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $bfc46499927fa5d6$var$baseIsNaN;

});

parcelRegister("8sy5Z", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $628b62f359fed600$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $628b62f359fed600$var$strictIndexOf;

});



parcelRegister("9E4uy", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $705b55789a390f42$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $705b55789a390f42$var$arrayIncludesWith;

});

parcelRegister("lOT5y", function(module, exports) {

var $9y4oV = parcelRequire("9y4oV");

var $1nPqj = parcelRequire("1nPqj");

var $ab9Mx = parcelRequire("ab9Mx");
/** Used as references for various `Number` constants. */ var $fe28ffebaef3dcf5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $fe28ffebaef3dcf5$var$createSet = !($9y4oV && 1 / $ab9Mx(new $9y4oV([
    ,
    -0
]))[1] == $fe28ffebaef3dcf5$var$INFINITY) ? $1nPqj : function(values) {
    return new $9y4oV(values);
};
module.exports = $fe28ffebaef3dcf5$var$createSet;

});
parcelRegister("1nPqj", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $101fd40651d89774$var$noop() {
// No operation performed.
}
module.exports = $101fd40651d89774$var$noop;

});






parcelRegister("54jwS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = module.exports.OPERATIONAL_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = module.exports.UI_EVENT_TYPE = module.exports.getEvent = module.exports.MountEvent = module.exports.fireAnalyticsEvent = module.exports.withAnalyticsContext = module.exports.AnalyticsContext = module.exports.EventTypes = module.exports.ScreenTypes = undefined;

var $9CTAW = parcelRequire("9CTAW");
Object.defineProperty(module.exports, 'ScreenTypes', {
    enumerable: true,
    get: function get() {
        return $9CTAW.ScreenTypes;
    }
});
Object.defineProperty(module.exports, 'EventTypes', {
    enumerable: true,
    get: function get() {
        return $9CTAW.EventTypes;
    }
});
Object.defineProperty(module.exports, 'UI_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9CTAW.UI_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'TRACK_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9CTAW.TRACK_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'SCREEN_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9CTAW.SCREEN_EVENT_TYPE;
    }
});
Object.defineProperty(module.exports, 'OPERATIONAL_EVENT_TYPE', {
    enumerable: true,
    get: function get() {
        return $9CTAW.OPERATIONAL_EVENT_TYPE;
    }
});

var $8tl6M = parcelRequire("8tl6M");
Object.defineProperty(module.exports, 'createTestEvent', {
    enumerable: true,
    get: function get() {
        return $8tl6M.createTestEvent;
    }
});

var $5yyGE = parcelRequire("5yyGE");
var $3b0c799536765cac$var$_analyticsContext2 = $3b0c799536765cac$var$_interopRequireDefault($5yyGE);

var $iWHc8 = parcelRequire("iWHc8");
var $3b0c799536765cac$var$_mountEvent2 = $3b0c799536765cac$var$_interopRequireDefault($iWHc8);

var $3LUyF = parcelRequire("3LUyF");
var $3b0c799536765cac$var$_withAnalyticsContext2 = $3b0c799536765cac$var$_interopRequireDefault($3LUyF);

var $dNBGl = parcelRequire("dNBGl");
var $3b0c799536765cac$var$_fireAnalyticsEvent2 = $3b0c799536765cac$var$_interopRequireDefault($dNBGl);

var $aybJE = parcelRequire("aybJE");
var $3b0c799536765cac$var$_getEventForWebClient2 = $3b0c799536765cac$var$_interopRequireDefault($aybJE);
function $3b0c799536765cac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.AnalyticsContext = $3b0c799536765cac$var$_analyticsContext2.default;
module.exports.withAnalyticsContext = $3b0c799536765cac$var$_withAnalyticsContext2.default;
module.exports.fireAnalyticsEvent = $3b0c799536765cac$var$_fireAnalyticsEvent2.default;
module.exports.MountEvent = $3b0c799536765cac$var$_mountEvent2.default;
module.exports.getEvent = $3b0c799536765cac$var$_getEventForWebClient2.default;

});
parcelRegister("9CTAW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ var $7022c9a520c9b9b4$var$UI_EVENT_TYPE = module.exports.UI_EVENT_TYPE = 'UI';
var $7022c9a520c9b9b4$var$TRACK_EVENT_TYPE = module.exports.TRACK_EVENT_TYPE = 'TRACK';
var $7022c9a520c9b9b4$var$SCREEN_EVENT_TYPE = module.exports.SCREEN_EVENT_TYPE = 'SCREEN';
var $7022c9a520c9b9b4$var$OPERATIONAL_EVENT_TYPE = module.exports.OPERATIONAL_EVENT_TYPE = 'OPERATIONAL';
/**
 * END ANALYTICS WEB CLIENT EVENTS
 */ var $7022c9a520c9b9b4$var$PAGE_EVENT_ACTION = module.exports.PAGE_EVENT_ACTION = 'page-view';
var $7022c9a520c9b9b4$var$SCREEN = module.exports.SCREEN = 'Screen';
var $7022c9a520c9b9b4$var$DRAWER = module.exports.DRAWER = 'Drawer';
var $7022c9a520c9b9b4$var$MODAL = module.exports.MODAL = 'Modal';
var $7022c9a520c9b9b4$var$INLINE_DIALOG = module.exports.INLINE_DIALOG = 'InlineDialog';
var $7022c9a520c9b9b4$var$DROPDOWN = module.exports.DROPDOWN = 'Dropdown';
var $7022c9a520c9b9b4$var$ScreenTypes = module.exports.ScreenTypes = {
    SCREEN: $7022c9a520c9b9b4$var$SCREEN,
    MODAL: $7022c9a520c9b9b4$var$MODAL,
    DRAWER: $7022c9a520c9b9b4$var$DRAWER,
    INLINE_DIALOG: $7022c9a520c9b9b4$var$INLINE_DIALOG,
    DROPDOWN: $7022c9a520c9b9b4$var$DROPDOWN
};
var $7022c9a520c9b9b4$var$EventTypes = module.exports.EventTypes = {
    UI: $7022c9a520c9b9b4$var$UI_EVENT_TYPE,
    TRACK: $7022c9a520c9b9b4$var$TRACK_EVENT_TYPE,
    SCREEN: $7022c9a520c9b9b4$var$SCREEN_EVENT_TYPE,
    OPERATIONAL: $7022c9a520c9b9b4$var$OPERATIONAL_EVENT_TYPE
};

});

parcelRegister("8tl6M", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTestEvent = undefined;

var $l2sHq = parcelRequire("l2sHq");
var $62b167d3e50d7f0d$var$createTestEvent = module.exports.createTestEvent = function createTestEvent() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        payload: {
            action: 'thisIsADumyAction'
        }
    };
    return new $l2sHq.default(payload);
};

});
parcelRegister("l2sHq", function(module, exports) {
$parcel$export(module.exports, "isUIAnalyticsEvent", () => $59ef057f6b3e215e$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $59ef057f6b3e215e$export$2e2bcd8739ae039);
/// <reference types="node" />

var $kvj1k = parcelRequire("kvj1k");
const $59ef057f6b3e215e$export$35f8383928ba8d7 = (obj)=>{
    var _obj$constructor;
    return obj instanceof $59ef057f6b3e215e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
class $59ef057f6b3e215e$export$2e2bcd8739ae039 extends (0, $kvj1k.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
     * A hacky "deep clone" of the object. This is limited in that it wont
     * support functions, regexs, Maps, Sets, etc, but none of those need to
     * be represented in our payload.
     */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $59ef057f6b3e215e$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>{
                try {
                    handler(this, channel);
                } catch (e) {}
            });
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("kvj1k", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $91713549525a8937$export$ad4be5c2ec28cecf);
$parcel$export(module.exports, "default", () => $91713549525a8937$export$2e2bcd8739ae039);
const $91713549525a8937$export$ad4be5c2ec28cecf = (obj)=>{
    var _obj$constructor;
    return obj instanceof $91713549525a8937$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
class $91713549525a8937$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $91713549525a8937$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});



parcelRegister("5yyGE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2VLnC = parcelRequire("2VLnC");
var $40bb08d8e9cd83c1$var$_getPrototypeOf2 = $40bb08d8e9cd83c1$var$_interopRequireDefault($2VLnC);

var $kN9tm = parcelRequire("kN9tm");
var $40bb08d8e9cd83c1$var$_classCallCheck3 = $40bb08d8e9cd83c1$var$_interopRequireDefault($kN9tm);

var $ggEdg = parcelRequire("ggEdg");
var $40bb08d8e9cd83c1$var$_createClass3 = $40bb08d8e9cd83c1$var$_interopRequireDefault($ggEdg);

var $dzjK4 = parcelRequire("dzjK4");
var $40bb08d8e9cd83c1$var$_possibleConstructorReturn3 = $40bb08d8e9cd83c1$var$_interopRequireDefault($dzjK4);

var $7OPta = parcelRequire("7OPta");
var $40bb08d8e9cd83c1$var$_inherits3 = $40bb08d8e9cd83c1$var$_interopRequireDefault($7OPta);

var $4fqPo = parcelRequire("4fqPo");
var $40bb08d8e9cd83c1$var$_react2 = $40bb08d8e9cd83c1$var$_interopRequireDefault($4fqPo);

var $fFB0R = parcelRequire("fFB0R");

var $c1nbQ = parcelRequire("c1nbQ");
var $40bb08d8e9cd83c1$var$_createContextData2 = $40bb08d8e9cd83c1$var$_interopRequireDefault($c1nbQ);
function $40bb08d8e9cd83c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $40bb08d8e9cd83c1$var$AnalyticsContextWrapper = function(_Component) {
    (0, $40bb08d8e9cd83c1$var$_inherits3.default)(AnalyticsContextWrapper, _Component);
    function AnalyticsContextWrapper() {
        (0, $40bb08d8e9cd83c1$var$_classCallCheck3.default)(this, AnalyticsContextWrapper);
        return (0, $40bb08d8e9cd83c1$var$_possibleConstructorReturn3.default)(this, (AnalyticsContextWrapper.__proto__ || (0, $40bb08d8e9cd83c1$var$_getPrototypeOf2.default)(AnalyticsContextWrapper)).apply(this, arguments));
    }
    (0, $40bb08d8e9cd83c1$var$_createClass3.default)(AnalyticsContextWrapper, [
        {
            key: 'render',
            value: function render() {
                var data = (0, $40bb08d8e9cd83c1$var$_createContextData2.default)(this.props);
                return $40bb08d8e9cd83c1$var$_react2.default.createElement($fFB0R.default, {
                    data: data
                }, this.props.children);
            }
        }
    ]);
    return AnalyticsContextWrapper;
}($4fqPo.Component);
module.exports.default = $40bb08d8e9cd83c1$var$AnalyticsContextWrapper;

});
parcelRegister("2VLnC", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kUrRK")),
    __esModule: true
};

});
parcelRegister("kUrRK", function(module, exports) {
parcelRequire("4mAF8");

module.exports = (parcelRequire("icdey")).Object.getPrototypeOf;

});
parcelRegister("4mAF8", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $3tt4T = parcelRequire("3tt4T");

var $jkk9m = parcelRequire("jkk9m");

(parcelRequire("afszB"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $jkk9m($3tt4T(it));
    };
});

});
parcelRegister("3tt4T", function(module, exports) {
// 7.1.13 ToObject(argument)

var $45Wqt = parcelRequire("45Wqt");
module.exports = function(it) {
    return Object($45Wqt(it));
};

});
parcelRegister("45Wqt", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("jkk9m", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $dYQNR = parcelRequire("dYQNR");

var $3tt4T = parcelRequire("3tt4T");

var $e11f83f0d94c753a$var$IE_PROTO = (parcelRequire("4imqq"))('IE_PROTO');
var $e11f83f0d94c753a$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $3tt4T(O);
    if ($dYQNR(O, $e11f83f0d94c753a$var$IE_PROTO)) return O[$e11f83f0d94c753a$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $e11f83f0d94c753a$var$ObjectProto : null;
};

});
parcelRegister("dYQNR", function(module, exports) {
var $a2d9d6988b15e165$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $a2d9d6988b15e165$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("4imqq", function(module, exports) {

var $320a3d0aebc71d96$var$shared = (parcelRequire("b3Xz1"))('keys');

var $2vhZ3 = parcelRequire("2vhZ3");
module.exports = function(key) {
    return $320a3d0aebc71d96$var$shared[key] || ($320a3d0aebc71d96$var$shared[key] = $2vhZ3(key));
};

});
parcelRegister("b3Xz1", function(module, exports) {

var $icdey = parcelRequire("icdey");

var $f0Thp = parcelRequire("f0Thp");
var $80de2da5b9539808$var$SHARED = '__core-js_shared__';
var $80de2da5b9539808$var$store = $f0Thp[$80de2da5b9539808$var$SHARED] || ($f0Thp[$80de2da5b9539808$var$SHARED] = {});

(module.exports = function(key, value) {
    return $80de2da5b9539808$var$store[key] || ($80de2da5b9539808$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $icdey.version,
    mode: (parcelRequire("5HKNa")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("icdey", function(module, exports) {
var $d3f39cecafdb5069$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $d3f39cecafdb5069$var$core; // eslint-disable-line no-undef

});

parcelRegister("f0Thp", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $aee1bc85cc04a1dc$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $aee1bc85cc04a1dc$var$global; // eslint-disable-line no-undef

});

parcelRegister("5HKNa", function(module, exports) {
module.exports = true;

});


parcelRegister("2vhZ3", function(module, exports) {
var $1d2c6d3ba4255746$var$id = 0;
var $1d2c6d3ba4255746$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$1d2c6d3ba4255746$var$id + $1d2c6d3ba4255746$var$px).toString(36));
};

});



parcelRegister("afszB", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $2e5Oc = parcelRequire("2e5Oc");

var $icdey = parcelRequire("icdey");

var $7pQEr = parcelRequire("7pQEr");
module.exports = function(KEY, exec) {
    var fn = ($icdey.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $2e5Oc($2e5Oc.S + $2e5Oc.F * $7pQEr(function() {
        fn(1);
    }), 'Object', exp);
};

});
parcelRegister("2e5Oc", function(module, exports) {

var $f0Thp = parcelRequire("f0Thp");

var $icdey = parcelRequire("icdey");

var $ldaps = parcelRequire("ldaps");

var $iwVCE = parcelRequire("iwVCE");

var $dYQNR = parcelRequire("dYQNR");
var $19f165099b6fce5b$var$PROTOTYPE = 'prototype';
var $19f165099b6fce5b$var$$export = function(type, name, source) {
    var IS_FORCED = type & $19f165099b6fce5b$var$$export.F;
    var IS_GLOBAL = type & $19f165099b6fce5b$var$$export.G;
    var IS_STATIC = type & $19f165099b6fce5b$var$$export.S;
    var IS_PROTO = type & $19f165099b6fce5b$var$$export.P;
    var IS_BIND = type & $19f165099b6fce5b$var$$export.B;
    var IS_WRAP = type & $19f165099b6fce5b$var$$export.W;
    var exports = IS_GLOBAL ? $icdey : $icdey[name] || ($icdey[name] = {});
    var expProto = exports[$19f165099b6fce5b$var$PROTOTYPE];
    var target = IS_GLOBAL ? $f0Thp : IS_STATIC ? $f0Thp[name] : ($f0Thp[name] || {})[$19f165099b6fce5b$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $dYQNR(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $ldaps(out, $f0Thp) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$19f165099b6fce5b$var$PROTOTYPE] = C[$19f165099b6fce5b$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $ldaps(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $19f165099b6fce5b$var$$export.R && expProto && !expProto[key]) $iwVCE(expProto, key, out);
        }
    }
};
// type bitmap
$19f165099b6fce5b$var$$export.F = 1; // forced
$19f165099b6fce5b$var$$export.G = 2; // global
$19f165099b6fce5b$var$$export.S = 4; // static
$19f165099b6fce5b$var$$export.P = 8; // proto
$19f165099b6fce5b$var$$export.B = 16; // bind
$19f165099b6fce5b$var$$export.W = 32; // wrap
$19f165099b6fce5b$var$$export.U = 64; // safe
$19f165099b6fce5b$var$$export.R = 128; // real proto method for `library`
module.exports = $19f165099b6fce5b$var$$export;

});
parcelRegister("ldaps", function(module, exports) {
// optional / simple context binding

var $cAHJg = parcelRequire("cAHJg");
module.exports = function(fn, that, length) {
    $cAHJg(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("cAHJg", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("iwVCE", function(module, exports) {

var $79N74 = parcelRequire("79N74");

var $4m6vB = parcelRequire("4m6vB");

module.exports = (parcelRequire("5pTJH")) ? function(object, key, value) {
    return $79N74.f(object, key, $4m6vB(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("79N74", function(module, exports) {
$parcel$export(module.exports, "f", () => $535f7880bb63c6d1$export$2d1720544b23b823, (v) => $535f7880bb63c6d1$export$2d1720544b23b823 = v);
var $535f7880bb63c6d1$export$2d1720544b23b823;

var $czIx9 = parcelRequire("czIx9");

var $k1R2M = parcelRequire("k1R2M");

var $voqYd = parcelRequire("voqYd");
var $535f7880bb63c6d1$var$dP = Object.defineProperty;

$535f7880bb63c6d1$export$2d1720544b23b823 = (parcelRequire("5pTJH")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $czIx9(O);
    P = $voqYd(P, true);
    $czIx9(Attributes);
    if ($k1R2M) try {
        return $535f7880bb63c6d1$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("czIx9", function(module, exports) {

var $gF7vj = parcelRequire("gF7vj");
module.exports = function(it) {
    if (!$gF7vj(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("gF7vj", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("k1R2M", function(module, exports) {



module.exports = !(parcelRequire("5pTJH")) && !(parcelRequire("7pQEr"))(function() {
    return Object.defineProperty((parcelRequire("aIjTf"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("5pTJH", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("7pQEr"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("7pQEr", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("aIjTf", function(module, exports) {

var $gF7vj = parcelRequire("gF7vj");

var $f0Thp = parcelRequire("f0Thp");
var $7ccd712fdcd64a39$require$document = $f0Thp.document;
// typeof document.createElement is 'object' in old IE
var $7ccd712fdcd64a39$var$is = $gF7vj($7ccd712fdcd64a39$require$document) && $gF7vj($7ccd712fdcd64a39$require$document.createElement);
module.exports = function(it) {
    return $7ccd712fdcd64a39$var$is ? $7ccd712fdcd64a39$require$document.createElement(it) : {};
};

});


parcelRegister("voqYd", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $gF7vj = parcelRequire("gF7vj");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$gF7vj(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$gF7vj(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$gF7vj(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$gF7vj(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("4m6vB", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("kN9tm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $f22fbb4bfe331795$export$1e511d4a378977f5, (v) => $f22fbb4bfe331795$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $f22fbb4bfe331795$export$2e2bcd8739ae039, (v) => $f22fbb4bfe331795$export$2e2bcd8739ae039 = v);
var $f22fbb4bfe331795$export$1e511d4a378977f5;
var $f22fbb4bfe331795$export$2e2bcd8739ae039;
"use strict";
$f22fbb4bfe331795$export$1e511d4a378977f5 = true;
$f22fbb4bfe331795$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("ggEdg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $bd7d556560c29942$export$1e511d4a378977f5, (v) => $bd7d556560c29942$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $bd7d556560c29942$export$2e2bcd8739ae039, (v) => $bd7d556560c29942$export$2e2bcd8739ae039 = v);
var $bd7d556560c29942$export$1e511d4a378977f5;
var $bd7d556560c29942$export$2e2bcd8739ae039;
"use strict";
$bd7d556560c29942$export$1e511d4a378977f5 = true;

var $b1m8D = parcelRequire("b1m8D");
var $bd7d556560c29942$var$_defineProperty2 = $bd7d556560c29942$var$_interopRequireDefault($b1m8D);
function $bd7d556560c29942$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$bd7d556560c29942$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $bd7d556560c29942$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("b1m8D", function(module, exports) {

module.exports = {
    "default": (parcelRequire("eGwDF")),
    __esModule: true
};

});
parcelRegister("eGwDF", function(module, exports) {
parcelRequire("gjvUt");

var $icdey = parcelRequire("icdey");
var $ab0e4e563e9c4d0d$require$$Object = $icdey.Object;
module.exports = function defineProperty(it, key, desc) {
    return $ab0e4e563e9c4d0d$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("gjvUt", function(module, exports) {

var $2e5Oc = parcelRequire("2e5Oc");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$2e5Oc($2e5Oc.S + $2e5Oc.F * !(parcelRequire("5pTJH")), 'Object', {
    defineProperty: (parcelRequire("79N74")).f
});

});




parcelRegister("dzjK4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $9e0ddb9715d4d7ac$export$1e511d4a378977f5, (v) => $9e0ddb9715d4d7ac$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $9e0ddb9715d4d7ac$export$2e2bcd8739ae039, (v) => $9e0ddb9715d4d7ac$export$2e2bcd8739ae039 = v);
var $9e0ddb9715d4d7ac$export$1e511d4a378977f5;
var $9e0ddb9715d4d7ac$export$2e2bcd8739ae039;
"use strict";
$9e0ddb9715d4d7ac$export$1e511d4a378977f5 = true;

var $eOQST = parcelRequire("eOQST");
var $9e0ddb9715d4d7ac$var$_typeof3 = $9e0ddb9715d4d7ac$var$_interopRequireDefault($eOQST);
function $9e0ddb9715d4d7ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$9e0ddb9715d4d7ac$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $9e0ddb9715d4d7ac$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("eOQST", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $ac9ec1ebbc2bcfac$export$1e511d4a378977f5, (v) => $ac9ec1ebbc2bcfac$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ac9ec1ebbc2bcfac$export$2e2bcd8739ae039, (v) => $ac9ec1ebbc2bcfac$export$2e2bcd8739ae039 = v);
var $ac9ec1ebbc2bcfac$export$1e511d4a378977f5;
var $ac9ec1ebbc2bcfac$export$2e2bcd8739ae039;
"use strict";
$ac9ec1ebbc2bcfac$export$1e511d4a378977f5 = true;

var $fhNIa = parcelRequire("fhNIa");
var $ac9ec1ebbc2bcfac$var$_iterator2 = $ac9ec1ebbc2bcfac$var$_interopRequireDefault($fhNIa);

var $5Vpyy = parcelRequire("5Vpyy");
var $ac9ec1ebbc2bcfac$var$_symbol2 = $ac9ec1ebbc2bcfac$var$_interopRequireDefault($5Vpyy);
var $ac9ec1ebbc2bcfac$var$_typeof = typeof $ac9ec1ebbc2bcfac$var$_symbol2.default === "function" && typeof $ac9ec1ebbc2bcfac$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $ac9ec1ebbc2bcfac$var$_symbol2.default === "function" && obj.constructor === $ac9ec1ebbc2bcfac$var$_symbol2.default && obj !== $ac9ec1ebbc2bcfac$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $ac9ec1ebbc2bcfac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$ac9ec1ebbc2bcfac$export$2e2bcd8739ae039 = typeof $ac9ec1ebbc2bcfac$var$_symbol2.default === "function" && $ac9ec1ebbc2bcfac$var$_typeof($ac9ec1ebbc2bcfac$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $ac9ec1ebbc2bcfac$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $ac9ec1ebbc2bcfac$var$_symbol2.default === "function" && obj.constructor === $ac9ec1ebbc2bcfac$var$_symbol2.default && obj !== $ac9ec1ebbc2bcfac$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $ac9ec1ebbc2bcfac$var$_typeof(obj);
};

});
parcelRegister("fhNIa", function(module, exports) {

module.exports = {
    "default": (parcelRequire("hm0o2")),
    __esModule: true
};

});
parcelRegister("hm0o2", function(module, exports) {
parcelRequire("94XbZ");
parcelRequire("f1NGt");

module.exports = (parcelRequire("ZukKo")).f('iterator');

});
parcelRegister("94XbZ", function(module, exports) {
'use strict';

var $69c2672d155b72de$var$$at = (parcelRequire("ipEbE"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("3tBzo"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $69c2672d155b72de$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("ipEbE", function(module, exports) {

var $c3bwm = parcelRequire("c3bwm");

var $45Wqt = parcelRequire("45Wqt");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($45Wqt(that));
        var i = $c3bwm(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});
parcelRegister("c3bwm", function(module, exports) {
// 7.1.4 ToInteger
var $8c5eb3aeec2b8deb$var$ceil = Math.ceil;
var $8c5eb3aeec2b8deb$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $8c5eb3aeec2b8deb$var$floor : $8c5eb3aeec2b8deb$var$ceil)(it);
};

});


parcelRegister("3tBzo", function(module, exports) {
'use strict';

var $5HKNa = parcelRequire("5HKNa");

var $2e5Oc = parcelRequire("2e5Oc");

var $juVHn = parcelRequire("juVHn");

var $iwVCE = parcelRequire("iwVCE");

var $2I9a7 = parcelRequire("2I9a7");

var $r9P31 = parcelRequire("r9P31");

var $j5BTH = parcelRequire("j5BTH");

var $jkk9m = parcelRequire("jkk9m");

var $2881392302970487$var$ITERATOR = (parcelRequire("alhyY"))('iterator');
var $2881392302970487$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $2881392302970487$var$FF_ITERATOR = '@@iterator';
var $2881392302970487$var$KEYS = 'keys';
var $2881392302970487$var$VALUES = 'values';
var $2881392302970487$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $r9P31(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$2881392302970487$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $2881392302970487$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $2881392302970487$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $2881392302970487$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$2881392302970487$var$ITERATOR] || proto[$2881392302970487$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $jkk9m($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $j5BTH(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$5HKNa && typeof IteratorPrototype[$2881392302970487$var$ITERATOR] != 'function') $iwVCE(IteratorPrototype, $2881392302970487$var$ITERATOR, $2881392302970487$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $2881392302970487$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$5HKNa || FORCED) && ($2881392302970487$var$BUGGY || VALUES_BUG || !proto[$2881392302970487$var$ITERATOR])) $iwVCE(proto, $2881392302970487$var$ITERATOR, $default);
    // Plug for library
    $2I9a7[NAME] = $default;
    $2I9a7[TAG] = $2881392302970487$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($2881392302970487$var$VALUES),
            keys: IS_SET ? $default : getMethod($2881392302970487$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $juVHn(proto, key, methods[key]);
        } else $2e5Oc($2e5Oc.P + $2e5Oc.F * ($2881392302970487$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("juVHn", function(module, exports) {

module.exports = (parcelRequire("iwVCE"));

});

parcelRegister("2I9a7", function(module, exports) {
module.exports = {};

});

parcelRegister("r9P31", function(module, exports) {
'use strict';

var $ceeR3 = parcelRequire("ceeR3");

var $4m6vB = parcelRequire("4m6vB");

var $j5BTH = parcelRequire("j5BTH");
var $051a243ecc33dc0e$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("iwVCE"))($051a243ecc33dc0e$var$IteratorPrototype, (parcelRequire("alhyY"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $ceeR3($051a243ecc33dc0e$var$IteratorPrototype, {
        next: $4m6vB(1, next)
    });
    $j5BTH(Constructor, NAME + ' Iterator');
};

});
parcelRegister("ceeR3", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $czIx9 = parcelRequire("czIx9");

var $8vVbu = parcelRequire("8vVbu");

var $btYgL = parcelRequire("btYgL");

var $8e7250ac7c2584d9$var$IE_PROTO = (parcelRequire("4imqq"))('IE_PROTO');
var $8e7250ac7c2584d9$var$Empty = function() {};
var $8e7250ac7c2584d9$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $8e7250ac7c2584d9$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("aIjTf"))('iframe');
    var i = $btYgL.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("6KLDI")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $8e7250ac7c2584d9$var$createDict = iframeDocument.F;
    while(i--)delete $8e7250ac7c2584d9$var$createDict[$8e7250ac7c2584d9$var$PROTOTYPE][$btYgL[i]];
    return $8e7250ac7c2584d9$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $8e7250ac7c2584d9$var$Empty[$8e7250ac7c2584d9$var$PROTOTYPE] = $czIx9(O);
        result = new $8e7250ac7c2584d9$var$Empty();
        $8e7250ac7c2584d9$var$Empty[$8e7250ac7c2584d9$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$8e7250ac7c2584d9$var$IE_PROTO] = O;
    } else result = $8e7250ac7c2584d9$var$createDict();
    return Properties === undefined ? result : $8vVbu(result, Properties);
};

});
parcelRegister("8vVbu", function(module, exports) {

var $79N74 = parcelRequire("79N74");

var $czIx9 = parcelRequire("czIx9");

var $7HYVW = parcelRequire("7HYVW");

module.exports = (parcelRequire("5pTJH")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $czIx9(O);
    var keys = $7HYVW(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$79N74.f(O, P = keys[i++], Properties[P]);
    return O;
};

});
parcelRegister("7HYVW", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $48Zq2 = parcelRequire("48Zq2");

var $btYgL = parcelRequire("btYgL");
module.exports = Object.keys || function keys(O) {
    return $48Zq2(O, $btYgL);
};

});
parcelRegister("48Zq2", function(module, exports) {

var $dYQNR = parcelRequire("dYQNR");

var $aih2D = parcelRequire("aih2D");

var $30478d4cc54fd166$var$arrayIndexOf = (parcelRequire("luzMR"))(false);

var $30478d4cc54fd166$var$IE_PROTO = (parcelRequire("4imqq"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $aih2D(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $30478d4cc54fd166$var$IE_PROTO) $dYQNR(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($dYQNR(O, key = names[i++])) ~$30478d4cc54fd166$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("aih2D", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $8HXod = parcelRequire("8HXod");

var $45Wqt = parcelRequire("45Wqt");
module.exports = function(it) {
    return $8HXod($45Wqt(it));
};

});
parcelRegister("8HXod", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $6jleO = parcelRequire("6jleO");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $6jleO(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("6jleO", function(module, exports) {
var $4984fdd5578ec82a$var$toString = {}.toString;
module.exports = function(it) {
    return $4984fdd5578ec82a$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("luzMR", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $aih2D = parcelRequire("aih2D");

var $4c9ye = parcelRequire("4c9ye");

var $lcxa3 = parcelRequire("lcxa3");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $aih2D($this);
        var length = $4c9ye(O.length);
        var index = $lcxa3(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("4c9ye", function(module, exports) {
// 7.1.15 ToLength

var $c3bwm = parcelRequire("c3bwm");
var $30dfb10afff37c28$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $30dfb10afff37c28$var$min($c3bwm(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});

parcelRegister("lcxa3", function(module, exports) {

var $c3bwm = parcelRequire("c3bwm");
var $f6f47111848831b4$var$max = Math.max;
var $f6f47111848831b4$var$min = Math.min;
module.exports = function(index, length) {
    index = $c3bwm(index);
    return index < 0 ? $f6f47111848831b4$var$max(index + length, 0) : $f6f47111848831b4$var$min(index, length);
};

});



parcelRegister("btYgL", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});



parcelRegister("6KLDI", function(module, exports) {

var $f0Thp = parcelRequire("f0Thp");
var $4eabfe31ea01e7fd$require$document = $f0Thp.document;
module.exports = $4eabfe31ea01e7fd$require$document && $4eabfe31ea01e7fd$require$document.documentElement;

});


parcelRegister("j5BTH", function(module, exports) {

var $79N74 = parcelRequire("79N74");
var $de5be1934d8153a6$require$def = $79N74.f;

var $dYQNR = parcelRequire("dYQNR");

var $de5be1934d8153a6$var$TAG = (parcelRequire("alhyY"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$dYQNR(it = stat ? it : it.prototype, $de5be1934d8153a6$var$TAG)) $de5be1934d8153a6$require$def(it, $de5be1934d8153a6$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("alhyY", function(module, exports) {

var $78797d3b069e24b6$var$store = (parcelRequire("b3Xz1"))('wks');

var $2vhZ3 = parcelRequire("2vhZ3");

var $f0Thp = parcelRequire("f0Thp");
var $78797d3b069e24b6$require$Symbol = $f0Thp.Symbol;
var $78797d3b069e24b6$var$USE_SYMBOL = typeof $78797d3b069e24b6$require$Symbol == 'function';
var $78797d3b069e24b6$var$$exports = module.exports = function(name) {
    return $78797d3b069e24b6$var$store[name] || ($78797d3b069e24b6$var$store[name] = $78797d3b069e24b6$var$USE_SYMBOL && $78797d3b069e24b6$require$Symbol[name] || ($78797d3b069e24b6$var$USE_SYMBOL ? $78797d3b069e24b6$require$Symbol : $2vhZ3)('Symbol.' + name));
};
$78797d3b069e24b6$var$$exports.store = $78797d3b069e24b6$var$store;

});





parcelRegister("f1NGt", function(module, exports) {
parcelRequire("69H1a");

var $f0Thp = parcelRequire("f0Thp");

var $iwVCE = parcelRequire("iwVCE");

var $2I9a7 = parcelRequire("2I9a7");

var $af0d7d370627ab83$var$TO_STRING_TAG = (parcelRequire("alhyY"))('toStringTag');
var $af0d7d370627ab83$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $af0d7d370627ab83$var$i = 0; $af0d7d370627ab83$var$i < $af0d7d370627ab83$var$DOMIterables.length; $af0d7d370627ab83$var$i++){
    var $af0d7d370627ab83$var$NAME = $af0d7d370627ab83$var$DOMIterables[$af0d7d370627ab83$var$i];
    var $af0d7d370627ab83$var$Collection = $f0Thp[$af0d7d370627ab83$var$NAME];
    var $af0d7d370627ab83$var$proto = $af0d7d370627ab83$var$Collection && $af0d7d370627ab83$var$Collection.prototype;
    if ($af0d7d370627ab83$var$proto && !$af0d7d370627ab83$var$proto[$af0d7d370627ab83$var$TO_STRING_TAG]) $iwVCE($af0d7d370627ab83$var$proto, $af0d7d370627ab83$var$TO_STRING_TAG, $af0d7d370627ab83$var$NAME);
    $2I9a7[$af0d7d370627ab83$var$NAME] = $2I9a7.Array;
}

});
parcelRegister("69H1a", function(module, exports) {
'use strict';

var $g1yg7 = parcelRequire("g1yg7");

var $3SCsa = parcelRequire("3SCsa");

var $2I9a7 = parcelRequire("2I9a7");

var $aih2D = parcelRequire("aih2D");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("3tBzo"))(Array, 'Array', function(iterated, kind) {
    this._t = $aih2D(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $3SCsa(1);
    }
    if (kind == 'keys') return $3SCsa(0, index);
    if (kind == 'values') return $3SCsa(0, O[index]);
    return $3SCsa(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$2I9a7.Arguments = $2I9a7.Array;
$g1yg7('keys');
$g1yg7('values');
$g1yg7('entries');

});
parcelRegister("g1yg7", function(module, exports) {
module.exports = function() {};

});

parcelRegister("3SCsa", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("ZukKo", function(module, exports) {
$parcel$export(module.exports, "f", () => $0b8d3a3f50aeafcc$export$2d1720544b23b823, (v) => $0b8d3a3f50aeafcc$export$2d1720544b23b823 = v);
var $0b8d3a3f50aeafcc$export$2d1720544b23b823;

$0b8d3a3f50aeafcc$export$2d1720544b23b823 = (parcelRequire("alhyY"));

});



parcelRegister("5Vpyy", function(module, exports) {

module.exports = {
    "default": (parcelRequire("faIxm")),
    __esModule: true
};

});
parcelRegister("faIxm", function(module, exports) {
parcelRequire("5laTT");
parcelRequire("c2YKQ");
parcelRequire("agL5L");
parcelRequire("bFI6n");

module.exports = (parcelRequire("icdey")).Symbol;

});
parcelRegister("5laTT", function(module, exports) {
'use strict';

var $f0Thp = parcelRequire("f0Thp");

var $dYQNR = parcelRequire("dYQNR");

var $5pTJH = parcelRequire("5pTJH");

var $2e5Oc = parcelRequire("2e5Oc");

var $juVHn = parcelRequire("juVHn");

var $kfSQ4 = parcelRequire("kfSQ4");
var $3e375e832e943d66$require$META = $kfSQ4.KEY;

var $7pQEr = parcelRequire("7pQEr");

var $b3Xz1 = parcelRequire("b3Xz1");

var $j5BTH = parcelRequire("j5BTH");

var $2vhZ3 = parcelRequire("2vhZ3");

var $alhyY = parcelRequire("alhyY");

var $ZukKo = parcelRequire("ZukKo");

var $bhYsQ = parcelRequire("bhYsQ");

var $gtsZC = parcelRequire("gtsZC");

var $fndvt = parcelRequire("fndvt");

var $czIx9 = parcelRequire("czIx9");

var $gF7vj = parcelRequire("gF7vj");

var $3tt4T = parcelRequire("3tt4T");

var $aih2D = parcelRequire("aih2D");

var $voqYd = parcelRequire("voqYd");

var $4m6vB = parcelRequire("4m6vB");

var $ceeR3 = parcelRequire("ceeR3");

var $9yXPV = parcelRequire("9yXPV");

var $aLp7V = parcelRequire("aLp7V");

var $a2ys4 = parcelRequire("a2ys4");

var $79N74 = parcelRequire("79N74");

var $7HYVW = parcelRequire("7HYVW");
var $3e375e832e943d66$var$gOPD = $aLp7V.f;
var $3e375e832e943d66$var$dP = $79N74.f;
var $3e375e832e943d66$var$gOPN = $9yXPV.f;
var $3e375e832e943d66$var$$Symbol = $f0Thp.Symbol;
var $3e375e832e943d66$var$$JSON = $f0Thp.JSON;
var $3e375e832e943d66$var$_stringify = $3e375e832e943d66$var$$JSON && $3e375e832e943d66$var$$JSON.stringify;
var $3e375e832e943d66$var$PROTOTYPE = 'prototype';
var $3e375e832e943d66$var$HIDDEN = $alhyY('_hidden');
var $3e375e832e943d66$var$TO_PRIMITIVE = $alhyY('toPrimitive');
var $3e375e832e943d66$var$isEnum = {}.propertyIsEnumerable;
var $3e375e832e943d66$var$SymbolRegistry = $b3Xz1('symbol-registry');
var $3e375e832e943d66$var$AllSymbols = $b3Xz1('symbols');
var $3e375e832e943d66$var$OPSymbols = $b3Xz1('op-symbols');
var $3e375e832e943d66$var$ObjectProto = Object[$3e375e832e943d66$var$PROTOTYPE];
var $3e375e832e943d66$var$USE_NATIVE = typeof $3e375e832e943d66$var$$Symbol == 'function' && !!$a2ys4.f;
var $3e375e832e943d66$var$QObject = $f0Thp.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $3e375e832e943d66$var$setter = !$3e375e832e943d66$var$QObject || !$3e375e832e943d66$var$QObject[$3e375e832e943d66$var$PROTOTYPE] || !$3e375e832e943d66$var$QObject[$3e375e832e943d66$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $3e375e832e943d66$var$setSymbolDesc = $5pTJH && $7pQEr(function() {
    return $ceeR3($3e375e832e943d66$var$dP({}, 'a', {
        get: function() {
            return $3e375e832e943d66$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $3e375e832e943d66$var$gOPD($3e375e832e943d66$var$ObjectProto, key);
    if (protoDesc) delete $3e375e832e943d66$var$ObjectProto[key];
    $3e375e832e943d66$var$dP(it, key, D);
    if (protoDesc && it !== $3e375e832e943d66$var$ObjectProto) $3e375e832e943d66$var$dP($3e375e832e943d66$var$ObjectProto, key, protoDesc);
} : $3e375e832e943d66$var$dP;
var $3e375e832e943d66$var$wrap = function(tag) {
    var sym = $3e375e832e943d66$var$AllSymbols[tag] = $ceeR3($3e375e832e943d66$var$$Symbol[$3e375e832e943d66$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $3e375e832e943d66$var$isSymbol = $3e375e832e943d66$var$USE_NATIVE && typeof $3e375e832e943d66$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $3e375e832e943d66$var$$Symbol;
};
var $3e375e832e943d66$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $3e375e832e943d66$var$ObjectProto) $3e375e832e943d66$var$$defineProperty($3e375e832e943d66$var$OPSymbols, key, D);
    $czIx9(it);
    key = $voqYd(key, true);
    $czIx9(D);
    if ($dYQNR($3e375e832e943d66$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$dYQNR(it, $3e375e832e943d66$var$HIDDEN)) $3e375e832e943d66$var$dP(it, $3e375e832e943d66$var$HIDDEN, $4m6vB(1, {}));
            it[$3e375e832e943d66$var$HIDDEN][key] = true;
        } else {
            if ($dYQNR(it, $3e375e832e943d66$var$HIDDEN) && it[$3e375e832e943d66$var$HIDDEN][key]) it[$3e375e832e943d66$var$HIDDEN][key] = false;
            D = $ceeR3(D, {
                enumerable: $4m6vB(0, false)
            });
        }
        return $3e375e832e943d66$var$setSymbolDesc(it, key, D);
    }
    return $3e375e832e943d66$var$dP(it, key, D);
};
var $3e375e832e943d66$var$$defineProperties = function defineProperties(it, P) {
    $czIx9(it);
    var keys = $gtsZC(P = $aih2D(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$3e375e832e943d66$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $3e375e832e943d66$var$$create = function create(it, P) {
    return P === undefined ? $ceeR3(it) : $3e375e832e943d66$var$$defineProperties($ceeR3(it), P);
};
var $3e375e832e943d66$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $3e375e832e943d66$var$isEnum.call(this, key = $voqYd(key, true));
    if (this === $3e375e832e943d66$var$ObjectProto && $dYQNR($3e375e832e943d66$var$AllSymbols, key) && !$dYQNR($3e375e832e943d66$var$OPSymbols, key)) return false;
    return E || !$dYQNR(this, key) || !$dYQNR($3e375e832e943d66$var$AllSymbols, key) || $dYQNR(this, $3e375e832e943d66$var$HIDDEN) && this[$3e375e832e943d66$var$HIDDEN][key] ? E : true;
};
var $3e375e832e943d66$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $aih2D(it);
    key = $voqYd(key, true);
    if (it === $3e375e832e943d66$var$ObjectProto && $dYQNR($3e375e832e943d66$var$AllSymbols, key) && !$dYQNR($3e375e832e943d66$var$OPSymbols, key)) return;
    var D = $3e375e832e943d66$var$gOPD(it, key);
    if (D && $dYQNR($3e375e832e943d66$var$AllSymbols, key) && !($dYQNR(it, $3e375e832e943d66$var$HIDDEN) && it[$3e375e832e943d66$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $3e375e832e943d66$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $3e375e832e943d66$var$gOPN($aih2D(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$dYQNR($3e375e832e943d66$var$AllSymbols, key = names[i++]) && key != $3e375e832e943d66$var$HIDDEN && key != $3e375e832e943d66$require$META) result.push(key);
    return result;
};
var $3e375e832e943d66$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $3e375e832e943d66$var$ObjectProto;
    var names = $3e375e832e943d66$var$gOPN(IS_OP ? $3e375e832e943d66$var$OPSymbols : $aih2D(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($dYQNR($3e375e832e943d66$var$AllSymbols, key = names[i++]) && (IS_OP ? $dYQNR($3e375e832e943d66$var$ObjectProto, key) : true)) result.push($3e375e832e943d66$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$3e375e832e943d66$var$USE_NATIVE) {
    $3e375e832e943d66$var$$Symbol = function Symbol() {
        if (this instanceof $3e375e832e943d66$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $2vhZ3(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $3e375e832e943d66$var$ObjectProto) $set.call($3e375e832e943d66$var$OPSymbols, value);
            if ($dYQNR(this, $3e375e832e943d66$var$HIDDEN) && $dYQNR(this[$3e375e832e943d66$var$HIDDEN], tag)) this[$3e375e832e943d66$var$HIDDEN][tag] = false;
            $3e375e832e943d66$var$setSymbolDesc(this, tag, $4m6vB(1, value));
        };
        if ($5pTJH && $3e375e832e943d66$var$setter) $3e375e832e943d66$var$setSymbolDesc($3e375e832e943d66$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $3e375e832e943d66$var$wrap(tag);
    };
    $juVHn($3e375e832e943d66$var$$Symbol[$3e375e832e943d66$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $aLp7V.f = $3e375e832e943d66$var$$getOwnPropertyDescriptor;
    $79N74.f = $3e375e832e943d66$var$$defineProperty;
    (parcelRequire("2koGI")).f = $9yXPV.f = $3e375e832e943d66$var$$getOwnPropertyNames;
    (parcelRequire("l4nsr")).f = $3e375e832e943d66$var$$propertyIsEnumerable;
    $a2ys4.f = $3e375e832e943d66$var$$getOwnPropertySymbols;
    if ($5pTJH && !(parcelRequire("5HKNa"))) $juVHn($3e375e832e943d66$var$ObjectProto, 'propertyIsEnumerable', $3e375e832e943d66$var$$propertyIsEnumerable, true);
    $ZukKo.f = function(name) {
        return $3e375e832e943d66$var$wrap($alhyY(name));
    };
}
$2e5Oc($2e5Oc.G + $2e5Oc.W + $2e5Oc.F * !$3e375e832e943d66$var$USE_NATIVE, {
    Symbol: $3e375e832e943d66$var$$Symbol
});
for(var $3e375e832e943d66$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $3e375e832e943d66$var$j = 0; $3e375e832e943d66$var$es6Symbols.length > $3e375e832e943d66$var$j;)$alhyY($3e375e832e943d66$var$es6Symbols[$3e375e832e943d66$var$j++]);
for(var $3e375e832e943d66$var$wellKnownSymbols = $7HYVW($alhyY.store), $3e375e832e943d66$var$k = 0; $3e375e832e943d66$var$wellKnownSymbols.length > $3e375e832e943d66$var$k;)$bhYsQ($3e375e832e943d66$var$wellKnownSymbols[$3e375e832e943d66$var$k++]);
$2e5Oc($2e5Oc.S + $2e5Oc.F * !$3e375e832e943d66$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $dYQNR($3e375e832e943d66$var$SymbolRegistry, key += '') ? $3e375e832e943d66$var$SymbolRegistry[key] : $3e375e832e943d66$var$SymbolRegistry[key] = $3e375e832e943d66$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$3e375e832e943d66$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $3e375e832e943d66$var$SymbolRegistry)if ($3e375e832e943d66$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $3e375e832e943d66$var$setter = true;
    },
    useSimple: function() {
        $3e375e832e943d66$var$setter = false;
    }
});
$2e5Oc($2e5Oc.S + $2e5Oc.F * !$3e375e832e943d66$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $3e375e832e943d66$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $3e375e832e943d66$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $3e375e832e943d66$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $3e375e832e943d66$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $3e375e832e943d66$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $3e375e832e943d66$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $3e375e832e943d66$var$FAILS_ON_PRIMITIVES = $7pQEr(function() {
    $a2ys4.f(1);
});
$2e5Oc($2e5Oc.S + $2e5Oc.F * $3e375e832e943d66$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $a2ys4.f($3tt4T(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$3e375e832e943d66$var$$JSON && $2e5Oc($2e5Oc.S + $2e5Oc.F * (!$3e375e832e943d66$var$USE_NATIVE || $7pQEr(function() {
    var S = $3e375e832e943d66$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $3e375e832e943d66$var$_stringify([
        S
    ]) != '[null]' || $3e375e832e943d66$var$_stringify({
        a: S
    }) != '{}' || $3e375e832e943d66$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$gF7vj(replacer) && it === undefined || $3e375e832e943d66$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$fndvt(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$3e375e832e943d66$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $3e375e832e943d66$var$_stringify.apply($3e375e832e943d66$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$3e375e832e943d66$var$$Symbol[$3e375e832e943d66$var$PROTOTYPE][$3e375e832e943d66$var$TO_PRIMITIVE] || (parcelRequire("iwVCE"))($3e375e832e943d66$var$$Symbol[$3e375e832e943d66$var$PROTOTYPE], $3e375e832e943d66$var$TO_PRIMITIVE, $3e375e832e943d66$var$$Symbol[$3e375e832e943d66$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$j5BTH($3e375e832e943d66$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$j5BTH(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$j5BTH($f0Thp.JSON, 'JSON', true);

});
parcelRegister("kfSQ4", function(module, exports) {

var $ebefbf3047f556e4$var$META = (parcelRequire("2vhZ3"))('meta');

var $gF7vj = parcelRequire("gF7vj");

var $dYQNR = parcelRequire("dYQNR");

var $79N74 = parcelRequire("79N74");
var $ebefbf3047f556e4$require$setDesc = $79N74.f;
var $ebefbf3047f556e4$var$id = 0;
var $ebefbf3047f556e4$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $ebefbf3047f556e4$var$FREEZE = !(parcelRequire("7pQEr"))(function() {
    return $ebefbf3047f556e4$var$isExtensible(Object.preventExtensions({}));
});
var $ebefbf3047f556e4$var$setMeta = function(it) {
    $ebefbf3047f556e4$require$setDesc(it, $ebefbf3047f556e4$var$META, {
        value: {
            i: 'O' + ++$ebefbf3047f556e4$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $ebefbf3047f556e4$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$gF7vj(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$dYQNR(it, $ebefbf3047f556e4$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$ebefbf3047f556e4$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $ebefbf3047f556e4$var$setMeta(it);
    // return object ID
    }
    return it[$ebefbf3047f556e4$var$META].i;
};
var $ebefbf3047f556e4$var$getWeak = function(it, create) {
    if (!$dYQNR(it, $ebefbf3047f556e4$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$ebefbf3047f556e4$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $ebefbf3047f556e4$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$ebefbf3047f556e4$var$META].w;
};
// add metadata on freeze-family methods calling
var $ebefbf3047f556e4$var$onFreeze = function(it) {
    if ($ebefbf3047f556e4$var$FREEZE && $ebefbf3047f556e4$var$meta.NEED && $ebefbf3047f556e4$var$isExtensible(it) && !$dYQNR(it, $ebefbf3047f556e4$var$META)) $ebefbf3047f556e4$var$setMeta(it);
    return it;
};
var $ebefbf3047f556e4$var$meta = module.exports = {
    KEY: $ebefbf3047f556e4$var$META,
    NEED: false,
    fastKey: $ebefbf3047f556e4$var$fastKey,
    getWeak: $ebefbf3047f556e4$var$getWeak,
    onFreeze: $ebefbf3047f556e4$var$onFreeze
};

});

parcelRegister("bhYsQ", function(module, exports) {

var $f0Thp = parcelRequire("f0Thp");

var $icdey = parcelRequire("icdey");

var $5HKNa = parcelRequire("5HKNa");

var $ZukKo = parcelRequire("ZukKo");

var $79N74 = parcelRequire("79N74");
var $83802f2af9633190$require$defineProperty = $79N74.f;
module.exports = function(name) {
    var $Symbol = $icdey.Symbol || ($icdey.Symbol = $5HKNa ? {} : $f0Thp.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $83802f2af9633190$require$defineProperty($Symbol, name, {
        value: $ZukKo.f(name)
    });
};

});

parcelRegister("gtsZC", function(module, exports) {
// all enumerable object keys, includes symbols

var $7HYVW = parcelRequire("7HYVW");

var $a2ys4 = parcelRequire("a2ys4");

var $l4nsr = parcelRequire("l4nsr");
module.exports = function(it) {
    var result = $7HYVW(it);
    var getSymbols = $a2ys4.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $l4nsr.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("a2ys4", function(module, exports) {
$parcel$export(module.exports, "f", () => $74f4d0ad73386aca$export$2d1720544b23b823, (v) => $74f4d0ad73386aca$export$2d1720544b23b823 = v);
var $74f4d0ad73386aca$export$2d1720544b23b823;
$74f4d0ad73386aca$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("l4nsr", function(module, exports) {
$parcel$export(module.exports, "f", () => $f56c2ae7297c17d4$export$2d1720544b23b823, (v) => $f56c2ae7297c17d4$export$2d1720544b23b823 = v);
var $f56c2ae7297c17d4$export$2d1720544b23b823;
$f56c2ae7297c17d4$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("fndvt", function(module, exports) {
// 7.2.2 IsArray(argument)

var $6jleO = parcelRequire("6jleO");
module.exports = Array.isArray || function isArray(arg) {
    return $6jleO(arg) == 'Array';
};

});

parcelRegister("9yXPV", function(module, exports) {
$parcel$export(module.exports, "f", () => $6f65b44d7b4f0f6c$export$2d1720544b23b823, (v) => $6f65b44d7b4f0f6c$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $6f65b44d7b4f0f6c$export$2d1720544b23b823;

var $aih2D = parcelRequire("aih2D");

var $2koGI = parcelRequire("2koGI");
var $6f65b44d7b4f0f6c$require$gOPN = $2koGI.f;
var $6f65b44d7b4f0f6c$var$toString = {}.toString;
var $6f65b44d7b4f0f6c$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $6f65b44d7b4f0f6c$var$getWindowNames = function(it) {
    try {
        return $6f65b44d7b4f0f6c$require$gOPN(it);
    } catch (e) {
        return $6f65b44d7b4f0f6c$var$windowNames.slice();
    }
};
$6f65b44d7b4f0f6c$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $6f65b44d7b4f0f6c$var$windowNames && $6f65b44d7b4f0f6c$var$toString.call(it) == '[object Window]' ? $6f65b44d7b4f0f6c$var$getWindowNames(it) : $6f65b44d7b4f0f6c$require$gOPN($aih2D(it));
};

});
parcelRegister("2koGI", function(module, exports) {
$parcel$export(module.exports, "f", () => $1b20998f7eab4834$export$2d1720544b23b823, (v) => $1b20998f7eab4834$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $1b20998f7eab4834$export$2d1720544b23b823;

var $48Zq2 = parcelRequire("48Zq2");

var $1b20998f7eab4834$var$hiddenKeys = (parcelRequire("btYgL")).concat('length', 'prototype');
$1b20998f7eab4834$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $48Zq2(O, $1b20998f7eab4834$var$hiddenKeys);
};

});


parcelRegister("aLp7V", function(module, exports) {
$parcel$export(module.exports, "f", () => $7d61c8d4be939c9a$export$2d1720544b23b823, (v) => $7d61c8d4be939c9a$export$2d1720544b23b823 = v);
var $7d61c8d4be939c9a$export$2d1720544b23b823;

var $l4nsr = parcelRequire("l4nsr");

var $4m6vB = parcelRequire("4m6vB");

var $aih2D = parcelRequire("aih2D");

var $voqYd = parcelRequire("voqYd");

var $dYQNR = parcelRequire("dYQNR");

var $k1R2M = parcelRequire("k1R2M");
var $7d61c8d4be939c9a$var$gOPD = Object.getOwnPropertyDescriptor;

$7d61c8d4be939c9a$export$2d1720544b23b823 = (parcelRequire("5pTJH")) ? $7d61c8d4be939c9a$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $aih2D(O);
    P = $voqYd(P, true);
    if ($k1R2M) try {
        return $7d61c8d4be939c9a$var$gOPD(O, P);
    } catch (e) {}
    if ($dYQNR(O, P)) return $4m6vB(!$l4nsr.f.call(O, P), O[P]);
};

});


parcelRegister("c2YKQ", function(module, exports) {

});

parcelRegister("agL5L", function(module, exports) {

(parcelRequire("bhYsQ"))('asyncIterator');

});

parcelRegister("bFI6n", function(module, exports) {

(parcelRequire("bhYsQ"))('observable');

});





parcelRegister("7OPta", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $5b1520adc3178235$export$1e511d4a378977f5, (v) => $5b1520adc3178235$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $5b1520adc3178235$export$2e2bcd8739ae039, (v) => $5b1520adc3178235$export$2e2bcd8739ae039 = v);
var $5b1520adc3178235$export$1e511d4a378977f5;
var $5b1520adc3178235$export$2e2bcd8739ae039;
"use strict";
$5b1520adc3178235$export$1e511d4a378977f5 = true;

var $kcfNu = parcelRequire("kcfNu");
var $5b1520adc3178235$var$_setPrototypeOf2 = $5b1520adc3178235$var$_interopRequireDefault($kcfNu);

var $il1ZC = parcelRequire("il1ZC");
var $5b1520adc3178235$var$_create2 = $5b1520adc3178235$var$_interopRequireDefault($il1ZC);

var $eOQST = parcelRequire("eOQST");
var $5b1520adc3178235$var$_typeof3 = $5b1520adc3178235$var$_interopRequireDefault($eOQST);
function $5b1520adc3178235$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$5b1520adc3178235$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $5b1520adc3178235$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $5b1520adc3178235$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5b1520adc3178235$var$_setPrototypeOf2.default ? (0, $5b1520adc3178235$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("kcfNu", function(module, exports) {

module.exports = {
    "default": (parcelRequire("i8jfO")),
    __esModule: true
};

});
parcelRegister("i8jfO", function(module, exports) {
parcelRequire("4oA6K");

module.exports = (parcelRequire("icdey")).Object.setPrototypeOf;

});
parcelRegister("4oA6K", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $2e5Oc = parcelRequire("2e5Oc");

$2e5Oc($2e5Oc.S, 'Object', {
    setPrototypeOf: (parcelRequire("ggEne")).set
});

});
parcelRegister("ggEne", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $gF7vj = parcelRequire("gF7vj");

var $czIx9 = parcelRequire("czIx9");
var $bd7d755900de941f$var$check = function(O, proto) {
    $czIx9(O);
    if (!$gF7vj(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("ldaps"))(Function.call, (parcelRequire("aLp7V")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $bd7d755900de941f$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $bd7d755900de941f$var$check
};

});




parcelRegister("il1ZC", function(module, exports) {

module.exports = {
    "default": (parcelRequire("4wVgz")),
    __esModule: true
};

});
parcelRegister("4wVgz", function(module, exports) {
parcelRequire("hxHY6");

var $icdey = parcelRequire("icdey");
var $34c6927340cd3380$require$$Object = $icdey.Object;
module.exports = function create(P, D) {
    return $34c6927340cd3380$require$$Object.create(P, D);
};

});
parcelRegister("hxHY6", function(module, exports) {

var $2e5Oc = parcelRequire("2e5Oc");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$2e5Oc($2e5Oc.S, 'Object', {
    create: (parcelRequire("ceeR3"))
});

});




parcelRegister("fFB0R", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dce2d2ff342e8e8$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $3OcdS = parcelRequire("3OcdS");

var $fWNWx = parcelRequire("fWNWx");

var $evTrT = parcelRequire("evTrT");
const $1dce2d2ff342e8e8$var$AnalyticsContext = (props)=>{
    const isModernContext = (0, $3OcdS.default) || (0, $3H4LK.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $evTrT.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fWNWx.default), props);
};
var $1dce2d2ff342e8e8$export$2e2bcd8739ae039 = $1dce2d2ff342e8e8$var$AnalyticsContext;

});
parcelRegister("3OcdS", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9ff85fe73e29bd6$export$2e2bcd8739ae039);

var $3TFEq = parcelRequire("3TFEq");
var $c9ff85fe73e29bd6$var$_process$env;
/// <reference types="node" />
const $c9ff85fe73e29bd6$var$_default_1 = typeof $3TFEq !== 'undefined' && $3TFEq !== null && (($c9ff85fe73e29bd6$var$_process$env = {}, $c9ff85fe73e29bd6$var$_process$env === void 0) ? void 0 : $c9ff85fe73e29bd6$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
var $c9ff85fe73e29bd6$export$2e2bcd8739ae039 = $c9ff85fe73e29bd6$var$_default_1;

});

parcelRegister("fWNWx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4d2e507a5b74c3a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $PqAiz = parcelRequire("PqAiz");
const $f4d2e507a5b74c3a$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
};
const $f4d2e507a5b74c3a$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $f4d2e507a5b74c3a$var$AnalyticsContext extends (0, $4fqPo.Component) {
    static #_ = this.contextTypes = $f4d2e507a5b74c3a$var$ContextTypes;
    static #_2 = this.childContextTypes = $f4d2e507a5b74c3a$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $f4d2e507a5b74c3a$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $f4d2e507a5b74c3a$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $PqAiz.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $f4d2e507a5b74c3a$export$2e2bcd8739ae039 = $f4d2e507a5b74c3a$var$AnalyticsContext;

});
parcelRegister("4S7MC", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38c23e23da5545fd$var$ReactIs, $38c23e23da5545fd$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("k0kTt"))();

});
parcelRegister("k0kTt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $60HUN = parcelRequire("60HUN");
function $e90403d0ea1d30aa$var$emptyFunction() {}
function $e90403d0ea1d30aa$var$emptyFunctionWithReset() {}
$e90403d0ea1d30aa$var$emptyFunctionWithReset.resetWarningCache = $e90403d0ea1d30aa$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $60HUN) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e90403d0ea1d30aa$var$emptyFunctionWithReset,
        resetWarningCache: $e90403d0ea1d30aa$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("60HUN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $4604cec9dcd4695d$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $4604cec9dcd4695d$var$ReactPropTypesSecret;

});



parcelRegister("PqAiz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $09a962a7a3d2bc39$export$2e2bcd8739ae039);

var $8zrV5 = parcelRequire("8zrV5");
var $09a962a7a3d2bc39$export$2e2bcd8739ae039 = (0, $8zrV5.default);

});
parcelRegister("8zrV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $63d73fe657d62a58$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
var $63d73fe657d62a58$var$AnalyticsNextContext = (0, $4fqPo.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $63d73fe657d62a58$export$2e2bcd8739ae039 = $63d73fe657d62a58$var$AnalyticsNextContext;

});



parcelRegister("evTrT", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c3f6da03b29a55c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $PqAiz = parcelRequire("PqAiz");

var $kXYs1 = parcelRequire("kXYs1");

var $kjnaA = parcelRequire("kjnaA");
const $2c3f6da03b29a55c$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $kjnaA.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $kXYs1.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $4fqPo.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $4fqPo.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $PqAiz.default).Provider, {
        value: value
    }, children);
};
var $2c3f6da03b29a55c$export$2e2bcd8739ae039 = $2c3f6da03b29a55c$var$AnalyticsContext;

});
parcelRegister("kXYs1", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsContext", () => $dba496ec081a7c59$export$d1f587f82ad51c4);

var $4fqPo = parcelRequire("4fqPo");

var $PqAiz = parcelRequire("PqAiz");
const $dba496ec081a7c59$export$d1f587f82ad51c4 = ()=>{
    return (0, $4fqPo.useContext)((0, $PqAiz.default));
};

});

parcelRegister("kjnaA", function(module, exports) {
$parcel$export(module.exports, "useTrackedRef", () => $0b3fb2d03c1b84de$export$1d27a74659855e44);

var $4fqPo = parcelRequire("4fqPo");
const $0b3fb2d03c1b84de$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $4fqPo.useRef)(value);
    ref.current = value;
    return ref;
};

});



parcelRegister("c1nbQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $blaEq = parcelRequire("blaEq");
var $8c07911cc17807f6$var$_extends3 = $8c07911cc17807f6$var$_interopRequireDefault($blaEq);

var $9pJh6 = parcelRequire("9pJh6");
var $8c07911cc17807f6$var$_objectWithoutProperties3 = $8c07911cc17807f6$var$_interopRequireDefault($9pJh6);

var $4tbnU = parcelRequire("4tbnU");
var $8c07911cc17807f6$var$_isUndefined2 = $8c07911cc17807f6$var$_interopRequireDefault($4tbnU);

var $hp9va = parcelRequire("hp9va");
var $8c07911cc17807f6$var$_omitBy2 = $8c07911cc17807f6$var$_interopRequireDefault($hp9va);

var $l7NiK = parcelRequire("l7NiK");
var $8c07911cc17807f6$var$_mapDataPayloadToContextPayload2 = $8c07911cc17807f6$var$_interopRequireDefault($l7NiK);
function $8c07911cc17807f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(props) {
    var sourceName = props.sourceName, sourceType = props.sourceType, componentName = props.componentName, other = (0, $8c07911cc17807f6$var$_objectWithoutProperties3.default)(props, [
        'sourceName',
        'sourceType',
        'componentName'
    ]);
    var validProps = (0, $8c07911cc17807f6$var$_mapDataPayloadToContextPayload2.default)(other);
    var source = sourceName && sourceType ? '' + sourceName + sourceType : undefined;
    return (0, $8c07911cc17807f6$var$_omitBy2.default)((0, $8c07911cc17807f6$var$_extends3.default)({
        componentName: componentName,
        source: source
    }, validProps), $8c07911cc17807f6$var$_isUndefined2.default);
};

});
parcelRegister("blaEq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $8419eaf4c51957fa$export$1e511d4a378977f5, (v) => $8419eaf4c51957fa$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $8419eaf4c51957fa$export$2e2bcd8739ae039, (v) => $8419eaf4c51957fa$export$2e2bcd8739ae039 = v);
var $8419eaf4c51957fa$export$1e511d4a378977f5;
var $8419eaf4c51957fa$export$2e2bcd8739ae039;
"use strict";
$8419eaf4c51957fa$export$1e511d4a378977f5 = true;

var $loq8h = parcelRequire("loq8h");
var $8419eaf4c51957fa$var$_assign2 = $8419eaf4c51957fa$var$_interopRequireDefault($loq8h);
function $8419eaf4c51957fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$8419eaf4c51957fa$export$2e2bcd8739ae039 = $8419eaf4c51957fa$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("loq8h", function(module, exports) {

module.exports = {
    "default": (parcelRequire("bt1Es")),
    __esModule: true
};

});
parcelRegister("bt1Es", function(module, exports) {
parcelRequire("fPELy");

module.exports = (parcelRequire("icdey")).Object.assign;

});
parcelRegister("fPELy", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $2e5Oc = parcelRequire("2e5Oc");

$2e5Oc($2e5Oc.S + $2e5Oc.F, 'Object', {
    assign: (parcelRequire("63gwO"))
});

});
parcelRegister("63gwO", function(module, exports) {
'use strict';

var $5pTJH = parcelRequire("5pTJH");

var $7HYVW = parcelRequire("7HYVW");

var $a2ys4 = parcelRequire("a2ys4");

var $l4nsr = parcelRequire("l4nsr");

var $3tt4T = parcelRequire("3tt4T");

var $8HXod = parcelRequire("8HXod");
var $467fd80b6b9abe1d$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$467fd80b6b9abe1d$var$$assign || (parcelRequire("7pQEr"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $467fd80b6b9abe1d$var$$assign({}, A)[S] != 7 || Object.keys($467fd80b6b9abe1d$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $3tt4T(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $a2ys4.f;
    var isEnum = $l4nsr.f;
    while(aLen > index){
        var S = $8HXod(arguments[index++]);
        var keys = getSymbols ? $7HYVW(S).concat(getSymbols(S)) : $7HYVW(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$5pTJH || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $467fd80b6b9abe1d$var$$assign;

});





parcelRegister("9pJh6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $6da991809ad3b0fb$export$1e511d4a378977f5, (v) => $6da991809ad3b0fb$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $6da991809ad3b0fb$export$2e2bcd8739ae039, (v) => $6da991809ad3b0fb$export$2e2bcd8739ae039 = v);
var $6da991809ad3b0fb$export$1e511d4a378977f5;
var $6da991809ad3b0fb$export$2e2bcd8739ae039;
"use strict";
$6da991809ad3b0fb$export$1e511d4a378977f5 = true;
$6da991809ad3b0fb$export$2e2bcd8739ae039 = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};

});

parcelRegister("4tbnU", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $3412b39a01818010$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $3412b39a01818010$var$isUndefined;

});

parcelRegister("hp9va", function(module, exports) {

var $khbZD = parcelRequire("khbZD");

var $9X2f1 = parcelRequire("9X2f1");

var $7KoBv = parcelRequire("7KoBv");
/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */ function $cabc244dfe1f5de1$var$omitBy(object, predicate) {
    return $7KoBv(object, $9X2f1($khbZD(predicate)));
}
module.exports = $cabc244dfe1f5de1$var$omitBy;

});
parcelRegister("khbZD", function(module, exports) {

var $86OR9 = parcelRequire("86OR9");

var $iQf90 = parcelRequire("iQf90");

var $lY3H7 = parcelRequire("lY3H7");

var $7uRO6 = parcelRequire("7uRO6");

var $geAZG = parcelRequire("geAZG");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $ec2eb2c528d83ac9$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $lY3H7;
    if (typeof value == 'object') return $7uRO6(value) ? $iQf90(value[0], value[1]) : $86OR9(value);
    return $geAZG(value);
}
module.exports = $ec2eb2c528d83ac9$var$baseIteratee;

});
parcelRegister("86OR9", function(module, exports) {

var $PMszE = parcelRequire("PMszE");

var $6bDby = parcelRequire("6bDby");

var $dsftA = parcelRequire("dsftA");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $5e765541257f2f5e$var$baseMatches(source) {
    var matchData = $6bDby(source);
    if (matchData.length == 1 && matchData[0][2]) return $dsftA(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $PMszE(object, source, matchData);
    };
}
module.exports = $5e765541257f2f5e$var$baseMatches;

});
parcelRegister("PMszE", function(module, exports) {

var $jFnky = parcelRequire("jFnky");

var $1obfm = parcelRequire("1obfm");
/** Used to compose bitmasks for value comparisons. */ var $09ba5aa7d346b1dc$var$COMPARE_PARTIAL_FLAG = 1, $09ba5aa7d346b1dc$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $09ba5aa7d346b1dc$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $jFnky;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $1obfm(srcValue, objValue, $09ba5aa7d346b1dc$var$COMPARE_PARTIAL_FLAG | $09ba5aa7d346b1dc$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $09ba5aa7d346b1dc$var$baseIsMatch;

});
parcelRegister("jFnky", function(module, exports) {

var $367jv = parcelRequire("367jv");

var $8vOAG = parcelRequire("8vOAG");

var $3OiOX = parcelRequire("3OiOX");

var $hZFSK = parcelRequire("hZFSK");

var $2VGhf = parcelRequire("2VGhf");

var $c2JEn = parcelRequire("c2JEn");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e513f1a02569e6f6$var$Stack(entries) {
    var data = this.__data__ = new $367jv(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$e513f1a02569e6f6$var$Stack.prototype.clear = $8vOAG;
$e513f1a02569e6f6$var$Stack.prototype['delete'] = $3OiOX;
$e513f1a02569e6f6$var$Stack.prototype.get = $hZFSK;
$e513f1a02569e6f6$var$Stack.prototype.has = $2VGhf;
$e513f1a02569e6f6$var$Stack.prototype.set = $c2JEn;
module.exports = $e513f1a02569e6f6$var$Stack;

});
parcelRegister("367jv", function(module, exports) {

var $aHyw8 = parcelRequire("aHyw8");

var $5wj2I = parcelRequire("5wj2I");

var $emLCX = parcelRequire("emLCX");

var $4C68C = parcelRequire("4C68C");

var $eDi4I = parcelRequire("eDi4I");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $24179af72eed118d$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$24179af72eed118d$var$ListCache.prototype.clear = $aHyw8;
$24179af72eed118d$var$ListCache.prototype['delete'] = $5wj2I;
$24179af72eed118d$var$ListCache.prototype.get = $emLCX;
$24179af72eed118d$var$ListCache.prototype.has = $4C68C;
$24179af72eed118d$var$ListCache.prototype.set = $eDi4I;
module.exports = $24179af72eed118d$var$ListCache;

});
parcelRegister("aHyw8", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $7ca8b1f14f8763f1$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $7ca8b1f14f8763f1$var$listCacheClear;

});

parcelRegister("5wj2I", function(module, exports) {

var $li84b = parcelRequire("li84b");
/** Used for built-in method references. */ var $404eb66ab1d6518c$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $404eb66ab1d6518c$var$splice = $404eb66ab1d6518c$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $404eb66ab1d6518c$var$listCacheDelete(key) {
    var data = this.__data__, index = $li84b(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $404eb66ab1d6518c$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $404eb66ab1d6518c$var$listCacheDelete;

});
parcelRegister("li84b", function(module, exports) {

var $6WCaJ = parcelRequire("6WCaJ");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f8018943a2b911fb$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6WCaJ(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $f8018943a2b911fb$var$assocIndexOf;

});
parcelRegister("6WCaJ", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50e5c50bcce06c13$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50e5c50bcce06c13$var$eq;

});



parcelRegister("emLCX", function(module, exports) {

var $li84b = parcelRequire("li84b");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a758108b7e4a3950$var$listCacheGet(key) {
    var data = this.__data__, index = $li84b(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $a758108b7e4a3950$var$listCacheGet;

});

parcelRegister("4C68C", function(module, exports) {

var $li84b = parcelRequire("li84b");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $35bf78e8b9df85d2$var$listCacheHas(key) {
    return $li84b(this.__data__, key) > -1;
}
module.exports = $35bf78e8b9df85d2$var$listCacheHas;

});

parcelRegister("eDi4I", function(module, exports) {

var $li84b = parcelRequire("li84b");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $aa72ba8474189795$var$listCacheSet(key, value) {
    var data = this.__data__, index = $li84b(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $aa72ba8474189795$var$listCacheSet;

});


parcelRegister("8vOAG", function(module, exports) {

var $367jv = parcelRequire("367jv");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $6328763734df8796$var$stackClear() {
    this.__data__ = new $367jv;
    this.size = 0;
}
module.exports = $6328763734df8796$var$stackClear;

});

parcelRegister("3OiOX", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c64a40ce05e9c16$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $2c64a40ce05e9c16$var$stackDelete;

});

parcelRegister("hZFSK", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d1989f162cc69852$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $d1989f162cc69852$var$stackGet;

});

parcelRegister("2VGhf", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2221b305bc6fc2c5$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $2221b305bc6fc2c5$var$stackHas;

});

parcelRegister("c2JEn", function(module, exports) {

var $367jv = parcelRequire("367jv");

var $2HMc6 = parcelRequire("2HMc6");

var $94Qnc = parcelRequire("94Qnc");
/** Used as the size to enable large array optimizations. */ var $8c49151a91afe66b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $8c49151a91afe66b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $367jv) {
        var pairs = data.__data__;
        if (!$2HMc6 || pairs.length < $8c49151a91afe66b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $94Qnc(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $8c49151a91afe66b$var$stackSet;

});
parcelRegister("2HMc6", function(module, exports) {

var $llsjU = parcelRequire("llsjU");

var $fW2G9 = parcelRequire("fW2G9");
/* Built-in method references that are verified to be native. */ var $1f84fb4b6d183b00$var$Map = $llsjU($fW2G9, 'Map');
module.exports = $1f84fb4b6d183b00$var$Map;

});
parcelRegister("llsjU", function(module, exports) {

var $aVvVT = parcelRequire("aVvVT");

var $arS9X = parcelRequire("arS9X");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $f8a186f0f50e9142$var$getNative(object, key) {
    var value = $arS9X(object, key);
    return $aVvVT(value) ? value : undefined;
}
module.exports = $f8a186f0f50e9142$var$getNative;

});
parcelRegister("aVvVT", function(module, exports) {

var $hbSPS = parcelRequire("hbSPS");

var $dt0ec = parcelRequire("dt0ec");

var $8dkUG = parcelRequire("8dkUG");

var $kxjlE = parcelRequire("kxjlE");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $7f47ff6e4c84df14$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $7f47ff6e4c84df14$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $7f47ff6e4c84df14$var$funcProto = Function.prototype, $7f47ff6e4c84df14$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7f47ff6e4c84df14$var$funcToString = $7f47ff6e4c84df14$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7f47ff6e4c84df14$var$hasOwnProperty = $7f47ff6e4c84df14$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $7f47ff6e4c84df14$var$reIsNative = RegExp('^' + $7f47ff6e4c84df14$var$funcToString.call($7f47ff6e4c84df14$var$hasOwnProperty).replace($7f47ff6e4c84df14$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $7f47ff6e4c84df14$var$baseIsNative(value) {
    if (!$8dkUG(value) || $dt0ec(value)) return false;
    var pattern = $hbSPS(value) ? $7f47ff6e4c84df14$var$reIsNative : $7f47ff6e4c84df14$var$reIsHostCtor;
    return pattern.test($kxjlE(value));
}
module.exports = $7f47ff6e4c84df14$var$baseIsNative;

});
parcelRegister("hbSPS", function(module, exports) {

var $emSWi = parcelRequire("emSWi");

var $8dkUG = parcelRequire("8dkUG");
/** `Object#toString` result references. */ var $c83dfffb2478b487$var$asyncTag = '[object AsyncFunction]', $c83dfffb2478b487$var$funcTag = '[object Function]', $c83dfffb2478b487$var$genTag = '[object GeneratorFunction]', $c83dfffb2478b487$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $c83dfffb2478b487$var$isFunction(value) {
    if (!$8dkUG(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $emSWi(value);
    return tag == $c83dfffb2478b487$var$funcTag || tag == $c83dfffb2478b487$var$genTag || tag == $c83dfffb2478b487$var$asyncTag || tag == $c83dfffb2478b487$var$proxyTag;
}
module.exports = $c83dfffb2478b487$var$isFunction;

});
parcelRegister("emSWi", function(module, exports) {

var $h6RF6 = parcelRequire("h6RF6");

var $2LLgb = parcelRequire("2LLgb");

var $eunBU = parcelRequire("eunBU");
/** `Object#toString` result references. */ var $a75dbc94d685b8c6$var$nullTag = '[object Null]', $a75dbc94d685b8c6$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a75dbc94d685b8c6$var$symToStringTag = $h6RF6 ? $h6RF6.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a75dbc94d685b8c6$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a75dbc94d685b8c6$var$undefinedTag : $a75dbc94d685b8c6$var$nullTag;
    return $a75dbc94d685b8c6$var$symToStringTag && $a75dbc94d685b8c6$var$symToStringTag in Object(value) ? $2LLgb(value) : $eunBU(value);
}
module.exports = $a75dbc94d685b8c6$var$baseGetTag;

});
parcelRegister("h6RF6", function(module, exports) {

var $fW2G9 = parcelRequire("fW2G9");
/** Built-in value references. */ var $c74c9f5d188fef96$var$Symbol = $fW2G9.Symbol;
module.exports = $c74c9f5d188fef96$var$Symbol;

});
parcelRegister("fW2G9", function(module, exports) {

var $7OF7u = parcelRequire("7OF7u");
/** Detect free variable `self`. */ var $b99e59c3eac0026a$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b99e59c3eac0026a$var$root = $7OF7u || $b99e59c3eac0026a$var$freeSelf || Function('return this')();
module.exports = $b99e59c3eac0026a$var$root;

});
parcelRegister("7OF7u", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $5b0d1975396da61d$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $5b0d1975396da61d$var$freeGlobal;

});



parcelRegister("2LLgb", function(module, exports) {

var $h6RF6 = parcelRequire("h6RF6");
/** Used for built-in method references. */ var $2044a16b8a6bc139$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2044a16b8a6bc139$var$hasOwnProperty = $2044a16b8a6bc139$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2044a16b8a6bc139$var$nativeObjectToString = $2044a16b8a6bc139$var$objectProto.toString;
/** Built-in value references. */ var $2044a16b8a6bc139$var$symToStringTag = $h6RF6 ? $h6RF6.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $2044a16b8a6bc139$var$getRawTag(value) {
    var isOwn = $2044a16b8a6bc139$var$hasOwnProperty.call(value, $2044a16b8a6bc139$var$symToStringTag), tag = value[$2044a16b8a6bc139$var$symToStringTag];
    try {
        value[$2044a16b8a6bc139$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $2044a16b8a6bc139$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$2044a16b8a6bc139$var$symToStringTag] = tag;
        else delete value[$2044a16b8a6bc139$var$symToStringTag];
    }
    return result;
}
module.exports = $2044a16b8a6bc139$var$getRawTag;

});

parcelRegister("eunBU", function(module, exports) {
/** Used for built-in method references. */ var $a8c62e95cec7fea8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a8c62e95cec7fea8$var$nativeObjectToString = $a8c62e95cec7fea8$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a8c62e95cec7fea8$var$objectToString(value) {
    return $a8c62e95cec7fea8$var$nativeObjectToString.call(value);
}
module.exports = $a8c62e95cec7fea8$var$objectToString;

});


parcelRegister("8dkUG", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5fafc28b185291a1$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $5fafc28b185291a1$var$isObject;

});


parcelRegister("dt0ec", function(module, exports) {

var $kf7qS = parcelRequire("kf7qS");
/** Used to detect methods masquerading as native. */ var $9cde29125820eaf2$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($kf7qS && $kf7qS.keys && $kf7qS.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $9cde29125820eaf2$var$isMasked(func) {
    return !!$9cde29125820eaf2$var$maskSrcKey && $9cde29125820eaf2$var$maskSrcKey in func;
}
module.exports = $9cde29125820eaf2$var$isMasked;

});
parcelRegister("kf7qS", function(module, exports) {

var $fW2G9 = parcelRequire("fW2G9");
/** Used to detect overreaching core-js shims. */ var $ebcaf94c26b88f16$var$coreJsData = $fW2G9["__core-js_shared__"];
module.exports = $ebcaf94c26b88f16$var$coreJsData;

});


parcelRegister("kxjlE", function(module, exports) {
/** Used for built-in method references. */ var $ef35e5e0d3113b62$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ef35e5e0d3113b62$var$funcToString = $ef35e5e0d3113b62$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ef35e5e0d3113b62$var$toSource(func) {
    if (func != null) {
        try {
            return $ef35e5e0d3113b62$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $ef35e5e0d3113b62$var$toSource;

});


parcelRegister("arS9X", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $79b66ff74de6440c$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $79b66ff74de6440c$var$getValue;

});



parcelRegister("94Qnc", function(module, exports) {

var $i0kPo = parcelRequire("i0kPo");

var $dt5Rd = parcelRequire("dt5Rd");

var $fFdeS = parcelRequire("fFdeS");

var $3Ov2C = parcelRequire("3Ov2C");

var $f3rZx = parcelRequire("f3rZx");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $69bd1cfa13b9162e$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$69bd1cfa13b9162e$var$MapCache.prototype.clear = $i0kPo;
$69bd1cfa13b9162e$var$MapCache.prototype['delete'] = $dt5Rd;
$69bd1cfa13b9162e$var$MapCache.prototype.get = $fFdeS;
$69bd1cfa13b9162e$var$MapCache.prototype.has = $3Ov2C;
$69bd1cfa13b9162e$var$MapCache.prototype.set = $f3rZx;
module.exports = $69bd1cfa13b9162e$var$MapCache;

});
parcelRegister("i0kPo", function(module, exports) {

var $5Av7c = parcelRequire("5Av7c");

var $367jv = parcelRequire("367jv");

var $2HMc6 = parcelRequire("2HMc6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d1b8620edc96834c$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $5Av7c,
        'map': new ($2HMc6 || $367jv),
        'string': new $5Av7c
    };
}
module.exports = $d1b8620edc96834c$var$mapCacheClear;

});
parcelRegister("5Av7c", function(module, exports) {

var $ejjCT = parcelRequire("ejjCT");

var $5bAnv = parcelRequire("5bAnv");

var $2RZFM = parcelRequire("2RZFM");

var $5Xin2 = parcelRequire("5Xin2");

var $lHGnt = parcelRequire("lHGnt");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $41187360c7b1e953$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$41187360c7b1e953$var$Hash.prototype.clear = $ejjCT;
$41187360c7b1e953$var$Hash.prototype['delete'] = $5bAnv;
$41187360c7b1e953$var$Hash.prototype.get = $2RZFM;
$41187360c7b1e953$var$Hash.prototype.has = $5Xin2;
$41187360c7b1e953$var$Hash.prototype.set = $lHGnt;
module.exports = $41187360c7b1e953$var$Hash;

});
parcelRegister("ejjCT", function(module, exports) {

var $jymOz = parcelRequire("jymOz");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a6b2106587e6d22f$var$hashClear() {
    this.__data__ = $jymOz ? $jymOz(null) : {};
    this.size = 0;
}
module.exports = $a6b2106587e6d22f$var$hashClear;

});
parcelRegister("jymOz", function(module, exports) {

var $llsjU = parcelRequire("llsjU");
/* Built-in method references that are verified to be native. */ var $e3c2e3cbb532b3af$var$nativeCreate = $llsjU(Object, 'create');
module.exports = $e3c2e3cbb532b3af$var$nativeCreate;

});


parcelRegister("5bAnv", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3c6a32ca3839d34d$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $3c6a32ca3839d34d$var$hashDelete;

});

parcelRegister("2RZFM", function(module, exports) {

var $jymOz = parcelRequire("jymOz");
/** Used to stand-in for `undefined` hash values. */ var $21705efb46d93bf8$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $21705efb46d93bf8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $21705efb46d93bf8$var$hasOwnProperty = $21705efb46d93bf8$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $21705efb46d93bf8$var$hashGet(key) {
    var data = this.__data__;
    if ($jymOz) {
        var result = data[key];
        return result === $21705efb46d93bf8$var$HASH_UNDEFINED ? undefined : result;
    }
    return $21705efb46d93bf8$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $21705efb46d93bf8$var$hashGet;

});

parcelRegister("5Xin2", function(module, exports) {

var $jymOz = parcelRequire("jymOz");
/** Used for built-in method references. */ var $4560b66f783a6a73$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4560b66f783a6a73$var$hasOwnProperty = $4560b66f783a6a73$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4560b66f783a6a73$var$hashHas(key) {
    var data = this.__data__;
    return $jymOz ? data[key] !== undefined : $4560b66f783a6a73$var$hasOwnProperty.call(data, key);
}
module.exports = $4560b66f783a6a73$var$hashHas;

});

parcelRegister("lHGnt", function(module, exports) {

var $jymOz = parcelRequire("jymOz");
/** Used to stand-in for `undefined` hash values. */ var $fcce7c731622a568$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $fcce7c731622a568$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $jymOz && value === undefined ? $fcce7c731622a568$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $fcce7c731622a568$var$hashSet;

});



parcelRegister("dt5Rd", function(module, exports) {

var $hwrFL = parcelRequire("hwrFL");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9ce286f469448a43$var$mapCacheDelete(key) {
    var result = $hwrFL(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $9ce286f469448a43$var$mapCacheDelete;

});
parcelRegister("hwrFL", function(module, exports) {

var $734NZ = parcelRequire("734NZ");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $cc1ae40796601d03$var$getMapData(map, key) {
    var data = map.__data__;
    return $734NZ(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $cc1ae40796601d03$var$getMapData;

});
parcelRegister("734NZ", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $521c8a7685b23343$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $521c8a7685b23343$var$isKeyable;

});



parcelRegister("fFdeS", function(module, exports) {

var $hwrFL = parcelRequire("hwrFL");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b674f4524085f928$var$mapCacheGet(key) {
    return $hwrFL(this, key).get(key);
}
module.exports = $b674f4524085f928$var$mapCacheGet;

});

parcelRegister("3Ov2C", function(module, exports) {

var $hwrFL = parcelRequire("hwrFL");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2c6e1ec4e2a71530$var$mapCacheHas(key) {
    return $hwrFL(this, key).has(key);
}
module.exports = $2c6e1ec4e2a71530$var$mapCacheHas;

});

parcelRegister("f3rZx", function(module, exports) {

var $hwrFL = parcelRequire("hwrFL");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $af5cd95d015f42ca$var$mapCacheSet(key, value) {
    var data = $hwrFL(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $af5cd95d015f42ca$var$mapCacheSet;

});




parcelRegister("1obfm", function(module, exports) {

var $aIf2z = parcelRequire("aIf2z");

var $cwqTh = parcelRequire("cwqTh");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $1030c1bacf389347$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$cwqTh(value) && !$cwqTh(other)) return value !== value && other !== other;
    return $aIf2z(value, other, bitmask, customizer, $1030c1bacf389347$var$baseIsEqual, stack);
}
module.exports = $1030c1bacf389347$var$baseIsEqual;

});
parcelRegister("aIf2z", function(module, exports) {

var $jFnky = parcelRequire("jFnky");

var $cUaT5 = parcelRequire("cUaT5");

var $hmpLa = parcelRequire("hmpLa");

var $lI4l1 = parcelRequire("lI4l1");

var $5rGCe = parcelRequire("5rGCe");

var $7uRO6 = parcelRequire("7uRO6");

var $eWbuf = parcelRequire("eWbuf");

var $aWiKZ = parcelRequire("aWiKZ");
/** Used to compose bitmasks for value comparisons. */ var $7cc9ae2e0258c99a$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $7cc9ae2e0258c99a$var$argsTag = '[object Arguments]', $7cc9ae2e0258c99a$var$arrayTag = '[object Array]', $7cc9ae2e0258c99a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $7cc9ae2e0258c99a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7cc9ae2e0258c99a$var$hasOwnProperty = $7cc9ae2e0258c99a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $7cc9ae2e0258c99a$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $7uRO6(object), othIsArr = $7uRO6(other), objTag = objIsArr ? $7cc9ae2e0258c99a$var$arrayTag : $5rGCe(object), othTag = othIsArr ? $7cc9ae2e0258c99a$var$arrayTag : $5rGCe(other);
    objTag = objTag == $7cc9ae2e0258c99a$var$argsTag ? $7cc9ae2e0258c99a$var$objectTag : objTag;
    othTag = othTag == $7cc9ae2e0258c99a$var$argsTag ? $7cc9ae2e0258c99a$var$objectTag : othTag;
    var objIsObj = objTag == $7cc9ae2e0258c99a$var$objectTag, othIsObj = othTag == $7cc9ae2e0258c99a$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $eWbuf(object)) {
        if (!$eWbuf(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $jFnky);
        return objIsArr || $aWiKZ(object) ? $cUaT5(object, other, bitmask, customizer, equalFunc, stack) : $hmpLa(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $7cc9ae2e0258c99a$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $7cc9ae2e0258c99a$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $7cc9ae2e0258c99a$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $jFnky);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $jFnky);
    return $lI4l1(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $7cc9ae2e0258c99a$var$baseIsEqualDeep;

});
parcelRegister("cUaT5", function(module, exports) {

var $efeLL = parcelRequire("efeLL");

var $iNSnw = parcelRequire("iNSnw");

var $9bLcY = parcelRequire("9bLcY");
/** Used to compose bitmasks for value comparisons. */ var $9653290ab7df89b4$var$COMPARE_PARTIAL_FLAG = 1, $9653290ab7df89b4$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $9653290ab7df89b4$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $9653290ab7df89b4$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $9653290ab7df89b4$var$COMPARE_UNORDERED_FLAG ? new $efeLL : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$iNSnw(other, function(othValue, othIndex) {
                if (!$9bLcY(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $9653290ab7df89b4$var$equalArrays;

});
parcelRegister("efeLL", function(module, exports) {

var $94Qnc = parcelRequire("94Qnc");

var $3FfVZ = parcelRequire("3FfVZ");

var $fRIPG = parcelRequire("fRIPG");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a5edec496ef083a9$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $94Qnc;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a5edec496ef083a9$var$SetCache.prototype.add = $a5edec496ef083a9$var$SetCache.prototype.push = $3FfVZ;
$a5edec496ef083a9$var$SetCache.prototype.has = $fRIPG;
module.exports = $a5edec496ef083a9$var$SetCache;

});
parcelRegister("3FfVZ", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $2ab18fa2f87bdc8f$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $2ab18fa2f87bdc8f$var$setCacheAdd(value) {
    this.__data__.set(value, $2ab18fa2f87bdc8f$var$HASH_UNDEFINED);
    return this;
}
module.exports = $2ab18fa2f87bdc8f$var$setCacheAdd;

});

parcelRegister("fRIPG", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $b8ce950efd7bfba2$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $b8ce950efd7bfba2$var$setCacheHas;

});


parcelRegister("iNSnw", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $db06fc05975d5337$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $db06fc05975d5337$var$arraySome;

});

parcelRegister("9bLcY", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $6b09c2b8cb8538a9$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $6b09c2b8cb8538a9$var$cacheHas;

});


parcelRegister("hmpLa", function(module, exports) {

var $h6RF6 = parcelRequire("h6RF6");

var $hJoE9 = parcelRequire("hJoE9");

var $6WCaJ = parcelRequire("6WCaJ");

var $cUaT5 = parcelRequire("cUaT5");

var $4euV8 = parcelRequire("4euV8");

var $9QMT7 = parcelRequire("9QMT7");
/** Used to compose bitmasks for value comparisons. */ var $ca387914d4319865$var$COMPARE_PARTIAL_FLAG = 1, $ca387914d4319865$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $ca387914d4319865$var$boolTag = '[object Boolean]', $ca387914d4319865$var$dateTag = '[object Date]', $ca387914d4319865$var$errorTag = '[object Error]', $ca387914d4319865$var$mapTag = '[object Map]', $ca387914d4319865$var$numberTag = '[object Number]', $ca387914d4319865$var$regexpTag = '[object RegExp]', $ca387914d4319865$var$setTag = '[object Set]', $ca387914d4319865$var$stringTag = '[object String]', $ca387914d4319865$var$symbolTag = '[object Symbol]';
var $ca387914d4319865$var$arrayBufferTag = '[object ArrayBuffer]', $ca387914d4319865$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $ca387914d4319865$var$symbolProto = $h6RF6 ? $h6RF6.prototype : undefined, $ca387914d4319865$var$symbolValueOf = $ca387914d4319865$var$symbolProto ? $ca387914d4319865$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ca387914d4319865$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $ca387914d4319865$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $ca387914d4319865$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $hJoE9(object), new $hJoE9(other))) return false;
            return true;
        case $ca387914d4319865$var$boolTag:
        case $ca387914d4319865$var$dateTag:
        case $ca387914d4319865$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6WCaJ(+object, +other);
        case $ca387914d4319865$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $ca387914d4319865$var$regexpTag:
        case $ca387914d4319865$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $ca387914d4319865$var$mapTag:
            var convert = $4euV8;
        case $ca387914d4319865$var$setTag:
            var isPartial = bitmask & $ca387914d4319865$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $9QMT7);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $ca387914d4319865$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $cUaT5(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $ca387914d4319865$var$symbolTag:
            if ($ca387914d4319865$var$symbolValueOf) return $ca387914d4319865$var$symbolValueOf.call(object) == $ca387914d4319865$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $ca387914d4319865$var$equalByTag;

});
parcelRegister("hJoE9", function(module, exports) {

var $fW2G9 = parcelRequire("fW2G9");
/** Built-in value references. */ var $ce89c1f4c3844824$var$Uint8Array = $fW2G9.Uint8Array;
module.exports = $ce89c1f4c3844824$var$Uint8Array;

});

parcelRegister("4euV8", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $3150746c2946e271$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $3150746c2946e271$var$mapToArray;

});

parcelRegister("9QMT7", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $72bee485470baa2a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $72bee485470baa2a$var$setToArray;

});


parcelRegister("lI4l1", function(module, exports) {

var $lMjII = parcelRequire("lMjII");
/** Used to compose bitmasks for value comparisons. */ var $fce112800b853437$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $fce112800b853437$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fce112800b853437$var$hasOwnProperty = $fce112800b853437$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $fce112800b853437$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $fce112800b853437$var$COMPARE_PARTIAL_FLAG, objProps = $lMjII(object), objLength = objProps.length, othProps = $lMjII(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $fce112800b853437$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $fce112800b853437$var$equalObjects;

});
parcelRegister("lMjII", function(module, exports) {

var $jXCiP = parcelRequire("jXCiP");

var $5IlTC = parcelRequire("5IlTC");

var $f3Sxg = parcelRequire("f3Sxg");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $fdad60b65d139370$var$getAllKeys(object) {
    return $jXCiP(object, $f3Sxg, $5IlTC);
}
module.exports = $fdad60b65d139370$var$getAllKeys;

});
parcelRegister("jXCiP", function(module, exports) {

var $70SdF = parcelRequire("70SdF");

var $7uRO6 = parcelRequire("7uRO6");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e8813d21287bf023$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $7uRO6(object) ? result : $70SdF(result, symbolsFunc(object));
}
module.exports = $e8813d21287bf023$var$baseGetAllKeys;

});
parcelRegister("70SdF", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $51b2975464f6ee8f$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $51b2975464f6ee8f$var$arrayPush;

});

parcelRegister("7uRO6", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $575512bcd148dbdc$var$isArray = Array.isArray;
module.exports = $575512bcd148dbdc$var$isArray;

});


parcelRegister("5IlTC", function(module, exports) {

var $2ffJZ = parcelRequire("2ffJZ");

var $5EG04 = parcelRequire("5EG04");
/** Used for built-in method references. */ var $42920be5d084756b$var$objectProto = Object.prototype;
/** Built-in value references. */ var $42920be5d084756b$var$propertyIsEnumerable = $42920be5d084756b$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $42920be5d084756b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $42920be5d084756b$var$getSymbols = !$42920be5d084756b$var$nativeGetSymbols ? $5EG04 : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $2ffJZ($42920be5d084756b$var$nativeGetSymbols(object), function(symbol) {
        return $42920be5d084756b$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $42920be5d084756b$var$getSymbols;

});
parcelRegister("2ffJZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $1a293149872add5f$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $1a293149872add5f$var$arrayFilter;

});

parcelRegister("5EG04", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $41e1448dc13da4c1$var$stubArray() {
    return [];
}
module.exports = $41e1448dc13da4c1$var$stubArray;

});


parcelRegister("f3Sxg", function(module, exports) {

var $2u6DL = parcelRequire("2u6DL");

var $jwur8 = parcelRequire("jwur8");

var $k40ty = parcelRequire("k40ty");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $af717075c36ee90a$var$keys(object) {
    return $k40ty(object) ? $2u6DL(object) : $jwur8(object);
}
module.exports = $af717075c36ee90a$var$keys;

});
parcelRegister("2u6DL", function(module, exports) {

var $lMnR4 = parcelRequire("lMnR4");

var $5cq8f = parcelRequire("5cq8f");

var $7uRO6 = parcelRequire("7uRO6");

var $eWbuf = parcelRequire("eWbuf");

var $7z1jr = parcelRequire("7z1jr");

var $aWiKZ = parcelRequire("aWiKZ");
/** Used for built-in method references. */ var $1cf388bd994cca65$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1cf388bd994cca65$var$hasOwnProperty = $1cf388bd994cca65$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1cf388bd994cca65$var$arrayLikeKeys(value, inherited) {
    var isArr = $7uRO6(value), isArg = !isArr && $5cq8f(value), isBuff = !isArr && !isArg && $eWbuf(value), isType = !isArr && !isArg && !isBuff && $aWiKZ(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $lMnR4(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1cf388bd994cca65$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $7z1jr(key, length)))) result.push(key);
    return result;
}
module.exports = $1cf388bd994cca65$var$arrayLikeKeys;

});
parcelRegister("lMnR4", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $fdb095c00b1935b9$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $fdb095c00b1935b9$var$baseTimes;

});

parcelRegister("5cq8f", function(module, exports) {

var $knly9 = parcelRequire("knly9");

var $cwqTh = parcelRequire("cwqTh");
/** Used for built-in method references. */ var $3c9258093cc9affc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c9258093cc9affc$var$hasOwnProperty = $3c9258093cc9affc$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $3c9258093cc9affc$var$propertyIsEnumerable = $3c9258093cc9affc$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $3c9258093cc9affc$var$isArguments = $knly9(function() {
    return arguments;
}()) ? $knly9 : function(value) {
    return $cwqTh(value) && $3c9258093cc9affc$var$hasOwnProperty.call(value, 'callee') && !$3c9258093cc9affc$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $3c9258093cc9affc$var$isArguments;

});
parcelRegister("knly9", function(module, exports) {

var $emSWi = parcelRequire("emSWi");

var $cwqTh = parcelRequire("cwqTh");
/** `Object#toString` result references. */ var $ed56abfa3edf7eb9$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ed56abfa3edf7eb9$var$baseIsArguments(value) {
    return $cwqTh(value) && $emSWi(value) == $ed56abfa3edf7eb9$var$argsTag;
}
module.exports = $ed56abfa3edf7eb9$var$baseIsArguments;

});
parcelRegister("cwqTh", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $91dd551e21e87533$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $91dd551e21e87533$var$isObjectLike;

});



parcelRegister("eWbuf", function(module, exports) {

var $fW2G9 = parcelRequire("fW2G9");

var $8mO40 = parcelRequire("8mO40");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fW2G9.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $8mO40;
module.exports = isBuffer;

});
parcelRegister("8mO40", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $61773665723f8adb$var$stubFalse() {
    return false;
}
module.exports = $61773665723f8adb$var$stubFalse;

});


parcelRegister("7z1jr", function(module, exports) {
/** Used as references for various `Number` constants. */ var $581cd1f14037dcd2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $581cd1f14037dcd2$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $581cd1f14037dcd2$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $581cd1f14037dcd2$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $581cd1f14037dcd2$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $581cd1f14037dcd2$var$isIndex;

});

parcelRegister("aWiKZ", function(module, exports) {

var $i4ZBt = parcelRequire("i4ZBt");

var $eEhQV = parcelRequire("eEhQV");

var $287TP = parcelRequire("287TP");
/* Node.js helper references. */ var $7f6ddee8acd3db26$var$nodeIsTypedArray = $287TP && $287TP.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $7f6ddee8acd3db26$var$isTypedArray = $7f6ddee8acd3db26$var$nodeIsTypedArray ? $eEhQV($7f6ddee8acd3db26$var$nodeIsTypedArray) : $i4ZBt;
module.exports = $7f6ddee8acd3db26$var$isTypedArray;

});
parcelRegister("i4ZBt", function(module, exports) {

var $emSWi = parcelRequire("emSWi");

var $jtkST = parcelRequire("jtkST");

var $cwqTh = parcelRequire("cwqTh");
/** `Object#toString` result references. */ var $03658dfb49c26830$var$argsTag = '[object Arguments]', $03658dfb49c26830$var$arrayTag = '[object Array]', $03658dfb49c26830$var$boolTag = '[object Boolean]', $03658dfb49c26830$var$dateTag = '[object Date]', $03658dfb49c26830$var$errorTag = '[object Error]', $03658dfb49c26830$var$funcTag = '[object Function]', $03658dfb49c26830$var$mapTag = '[object Map]', $03658dfb49c26830$var$numberTag = '[object Number]', $03658dfb49c26830$var$objectTag = '[object Object]', $03658dfb49c26830$var$regexpTag = '[object RegExp]', $03658dfb49c26830$var$setTag = '[object Set]', $03658dfb49c26830$var$stringTag = '[object String]', $03658dfb49c26830$var$weakMapTag = '[object WeakMap]';
var $03658dfb49c26830$var$arrayBufferTag = '[object ArrayBuffer]', $03658dfb49c26830$var$dataViewTag = '[object DataView]', $03658dfb49c26830$var$float32Tag = '[object Float32Array]', $03658dfb49c26830$var$float64Tag = '[object Float64Array]', $03658dfb49c26830$var$int8Tag = '[object Int8Array]', $03658dfb49c26830$var$int16Tag = '[object Int16Array]', $03658dfb49c26830$var$int32Tag = '[object Int32Array]', $03658dfb49c26830$var$uint8Tag = '[object Uint8Array]', $03658dfb49c26830$var$uint8ClampedTag = '[object Uint8ClampedArray]', $03658dfb49c26830$var$uint16Tag = '[object Uint16Array]', $03658dfb49c26830$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $03658dfb49c26830$var$typedArrayTags = {};
$03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$float32Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$float64Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$int8Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$int16Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$int32Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$uint8Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$uint8ClampedTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$uint16Tag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$uint32Tag] = true;
$03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$argsTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$arrayTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$arrayBufferTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$boolTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$dataViewTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$dateTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$errorTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$funcTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$mapTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$numberTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$objectTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$regexpTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$setTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$stringTag] = $03658dfb49c26830$var$typedArrayTags[$03658dfb49c26830$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $03658dfb49c26830$var$baseIsTypedArray(value) {
    return $cwqTh(value) && $jtkST(value.length) && !!$03658dfb49c26830$var$typedArrayTags[$emSWi(value)];
}
module.exports = $03658dfb49c26830$var$baseIsTypedArray;

});
parcelRegister("jtkST", function(module, exports) {
/** Used as references for various `Number` constants. */ var $e2d0ecf2af41c2e3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $e2d0ecf2af41c2e3$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $e2d0ecf2af41c2e3$var$MAX_SAFE_INTEGER;
}
module.exports = $e2d0ecf2af41c2e3$var$isLength;

});


parcelRegister("eEhQV", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $aaa2a64758b26a71$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $aaa2a64758b26a71$var$baseUnary;

});

parcelRegister("287TP", function(module, exports) {

var $7OF7u = parcelRequire("7OF7u");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $7OF7u.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jwur8", function(module, exports) {

var $igick = parcelRequire("igick");

var $kR2wP = parcelRequire("kR2wP");
/** Used for built-in method references. */ var $e3689d8d5cd9cf6d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e3689d8d5cd9cf6d$var$hasOwnProperty = $e3689d8d5cd9cf6d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e3689d8d5cd9cf6d$var$baseKeys(object) {
    if (!$igick(object)) return $kR2wP(object);
    var result = [];
    for(var key in Object(object))if ($e3689d8d5cd9cf6d$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e3689d8d5cd9cf6d$var$baseKeys;

});
parcelRegister("igick", function(module, exports) {
/** Used for built-in method references. */ var $d4b7d654bee1f065$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $d4b7d654bee1f065$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $d4b7d654bee1f065$var$objectProto;
    return value === proto;
}
module.exports = $d4b7d654bee1f065$var$isPrototype;

});

parcelRegister("kR2wP", function(module, exports) {

var $1wHHu = parcelRequire("1wHHu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f2eab7f7aba5a430$var$nativeKeys = $1wHHu(Object.keys, Object);
module.exports = $f2eab7f7aba5a430$var$nativeKeys;

});
parcelRegister("1wHHu", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $11caad9fb86360ff$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $11caad9fb86360ff$var$overArg;

});



parcelRegister("k40ty", function(module, exports) {

var $hbSPS = parcelRequire("hbSPS");

var $jtkST = parcelRequire("jtkST");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $e9b48ccf1b632d50$var$isArrayLike(value) {
    return value != null && $jtkST(value.length) && !$hbSPS(value);
}
module.exports = $e9b48ccf1b632d50$var$isArrayLike;

});




parcelRegister("5rGCe", function(module, exports) {

var $3BYoM = parcelRequire("3BYoM");

var $2HMc6 = parcelRequire("2HMc6");

var $1IHPU = parcelRequire("1IHPU");

var $fzh8A = parcelRequire("fzh8A");

var $iblQO = parcelRequire("iblQO");

var $emSWi = parcelRequire("emSWi");

var $kxjlE = parcelRequire("kxjlE");
/** `Object#toString` result references. */ var $3f7087ed9b96ac96$var$mapTag = '[object Map]', $3f7087ed9b96ac96$var$objectTag = '[object Object]', $3f7087ed9b96ac96$var$promiseTag = '[object Promise]', $3f7087ed9b96ac96$var$setTag = '[object Set]', $3f7087ed9b96ac96$var$weakMapTag = '[object WeakMap]';
var $3f7087ed9b96ac96$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $3f7087ed9b96ac96$var$dataViewCtorString = $kxjlE($3BYoM), $3f7087ed9b96ac96$var$mapCtorString = $kxjlE($2HMc6), $3f7087ed9b96ac96$var$promiseCtorString = $kxjlE($1IHPU), $3f7087ed9b96ac96$var$setCtorString = $kxjlE($fzh8A), $3f7087ed9b96ac96$var$weakMapCtorString = $kxjlE($iblQO);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $3f7087ed9b96ac96$var$getTag = $emSWi;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($3BYoM && $3f7087ed9b96ac96$var$getTag(new $3BYoM(new ArrayBuffer(1))) != $3f7087ed9b96ac96$var$dataViewTag || $2HMc6 && $3f7087ed9b96ac96$var$getTag(new $2HMc6) != $3f7087ed9b96ac96$var$mapTag || $1IHPU && $3f7087ed9b96ac96$var$getTag($1IHPU.resolve()) != $3f7087ed9b96ac96$var$promiseTag || $fzh8A && $3f7087ed9b96ac96$var$getTag(new $fzh8A) != $3f7087ed9b96ac96$var$setTag || $iblQO && $3f7087ed9b96ac96$var$getTag(new $iblQO) != $3f7087ed9b96ac96$var$weakMapTag) $3f7087ed9b96ac96$var$getTag = function(value) {
    var result = $emSWi(value), Ctor = result == $3f7087ed9b96ac96$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $kxjlE(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $3f7087ed9b96ac96$var$dataViewCtorString:
            return $3f7087ed9b96ac96$var$dataViewTag;
        case $3f7087ed9b96ac96$var$mapCtorString:
            return $3f7087ed9b96ac96$var$mapTag;
        case $3f7087ed9b96ac96$var$promiseCtorString:
            return $3f7087ed9b96ac96$var$promiseTag;
        case $3f7087ed9b96ac96$var$setCtorString:
            return $3f7087ed9b96ac96$var$setTag;
        case $3f7087ed9b96ac96$var$weakMapCtorString:
            return $3f7087ed9b96ac96$var$weakMapTag;
    }
    return result;
};
module.exports = $3f7087ed9b96ac96$var$getTag;

});
parcelRegister("3BYoM", function(module, exports) {

var $llsjU = parcelRequire("llsjU");

var $fW2G9 = parcelRequire("fW2G9");
/* Built-in method references that are verified to be native. */ var $2a13adb5920a1d7d$var$DataView = $llsjU($fW2G9, 'DataView');
module.exports = $2a13adb5920a1d7d$var$DataView;

});

parcelRegister("1IHPU", function(module, exports) {

var $llsjU = parcelRequire("llsjU");

var $fW2G9 = parcelRequire("fW2G9");
/* Built-in method references that are verified to be native. */ var $140be775ccff2957$var$Promise = $llsjU($fW2G9, 'Promise');
module.exports = $140be775ccff2957$var$Promise;

});

parcelRegister("fzh8A", function(module, exports) {

var $llsjU = parcelRequire("llsjU");

var $fW2G9 = parcelRequire("fW2G9");
/* Built-in method references that are verified to be native. */ var $b5576b11311f2747$var$Set = $llsjU($fW2G9, 'Set');
module.exports = $b5576b11311f2747$var$Set;

});

parcelRegister("iblQO", function(module, exports) {

var $llsjU = parcelRequire("llsjU");

var $fW2G9 = parcelRequire("fW2G9");
/* Built-in method references that are verified to be native. */ var $d3ca342d51a918bc$var$WeakMap = $llsjU($fW2G9, 'WeakMap');
module.exports = $d3ca342d51a918bc$var$WeakMap;

});





parcelRegister("6bDby", function(module, exports) {

var $9o4Vg = parcelRequire("9o4Vg");

var $f3Sxg = parcelRequire("f3Sxg");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $48122a8f6650f74f$var$getMatchData(object) {
    var result = $f3Sxg(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9o4Vg(value)
        ];
    }
    return result;
}
module.exports = $48122a8f6650f74f$var$getMatchData;

});
parcelRegister("9o4Vg", function(module, exports) {

var $8dkUG = parcelRequire("8dkUG");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $6d5a2c77efa10d1b$var$isStrictComparable(value) {
    return value === value && !$8dkUG(value);
}
module.exports = $6d5a2c77efa10d1b$var$isStrictComparable;

});


parcelRegister("dsftA", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $9cb9e527d15b91af$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $9cb9e527d15b91af$var$matchesStrictComparable;

});


parcelRegister("iQf90", function(module, exports) {

var $1obfm = parcelRequire("1obfm");

var $1BFjM = parcelRequire("1BFjM");

var $dVI3Z = parcelRequire("dVI3Z");

var $5bW3I = parcelRequire("5bW3I");

var $9o4Vg = parcelRequire("9o4Vg");

var $dsftA = parcelRequire("dsftA");

var $jGYoI = parcelRequire("jGYoI");
/** Used to compose bitmasks for value comparisons. */ var $db78d4a2a6d62db6$var$COMPARE_PARTIAL_FLAG = 1, $db78d4a2a6d62db6$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $db78d4a2a6d62db6$var$baseMatchesProperty(path, srcValue) {
    if ($5bW3I(path) && $9o4Vg(srcValue)) return $dsftA($jGYoI(path), srcValue);
    return function(object) {
        var objValue = $1BFjM(object, path);
        return objValue === undefined && objValue === srcValue ? $dVI3Z(object, path) : $1obfm(srcValue, objValue, $db78d4a2a6d62db6$var$COMPARE_PARTIAL_FLAG | $db78d4a2a6d62db6$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $db78d4a2a6d62db6$var$baseMatchesProperty;

});
parcelRegister("1BFjM", function(module, exports) {

var $dyRiX = parcelRequire("dyRiX");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $12b94c0e3f94c972$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $dyRiX(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $12b94c0e3f94c972$var$get;

});
parcelRegister("dyRiX", function(module, exports) {

var $kIcbL = parcelRequire("kIcbL");

var $jGYoI = parcelRequire("jGYoI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $9df7cc94596e901a$var$baseGet(object, path) {
    path = $kIcbL(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$jGYoI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $9df7cc94596e901a$var$baseGet;

});
parcelRegister("kIcbL", function(module, exports) {

var $7uRO6 = parcelRequire("7uRO6");

var $5bW3I = parcelRequire("5bW3I");

var $GWY7V = parcelRequire("GWY7V");

var $4K0Gp = parcelRequire("4K0Gp");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $f1415f1ed8f02010$var$castPath(value, object) {
    if ($7uRO6(value)) return value;
    return $5bW3I(value, object) ? [
        value
    ] : $GWY7V($4K0Gp(value));
}
module.exports = $f1415f1ed8f02010$var$castPath;

});
parcelRegister("5bW3I", function(module, exports) {

var $7uRO6 = parcelRequire("7uRO6");

var $5p6zD = parcelRequire("5p6zD");
/** Used to match property names within property paths. */ var $3c7b0419754dc4db$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $3c7b0419754dc4db$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $3c7b0419754dc4db$var$isKey(value, object) {
    if ($7uRO6(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $5p6zD(value)) return true;
    return $3c7b0419754dc4db$var$reIsPlainProp.test(value) || !$3c7b0419754dc4db$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $3c7b0419754dc4db$var$isKey;

});
parcelRegister("5p6zD", function(module, exports) {

var $emSWi = parcelRequire("emSWi");

var $cwqTh = parcelRequire("cwqTh");
/** `Object#toString` result references. */ var $3ef462f8719a0c0b$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $3ef462f8719a0c0b$var$isSymbol(value) {
    return typeof value == 'symbol' || $cwqTh(value) && $emSWi(value) == $3ef462f8719a0c0b$var$symbolTag;
}
module.exports = $3ef462f8719a0c0b$var$isSymbol;

});


parcelRegister("GWY7V", function(module, exports) {

var $lBpUi = parcelRequire("lBpUi");
/** Used to match property names within property paths. */ var $0811aa54db1b769d$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $0811aa54db1b769d$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $0811aa54db1b769d$var$stringToPath = $lBpUi(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($0811aa54db1b769d$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($0811aa54db1b769d$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $0811aa54db1b769d$var$stringToPath;

});
parcelRegister("lBpUi", function(module, exports) {

var $8ftWS = parcelRequire("8ftWS");
/** Used as the maximum memoize cache size. */ var $fba126463c27e462$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $fba126463c27e462$var$memoizeCapped(func) {
    var result = $8ftWS(func, function(key) {
        if (cache.size === $fba126463c27e462$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $fba126463c27e462$var$memoizeCapped;

});
parcelRegister("8ftWS", function(module, exports) {

var $94Qnc = parcelRequire("94Qnc");
/** Error message constants. */ var $6016f4a1e0fba462$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $6016f4a1e0fba462$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($6016f4a1e0fba462$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($6016f4a1e0fba462$var$memoize.Cache || $94Qnc);
    return memoized;
}
// Expose `MapCache`.
$6016f4a1e0fba462$var$memoize.Cache = $94Qnc;
module.exports = $6016f4a1e0fba462$var$memoize;

});



parcelRegister("4K0Gp", function(module, exports) {

var $8XNpq = parcelRequire("8XNpq");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $373bfcecd2f21bdf$var$toString(value) {
    return value == null ? '' : $8XNpq(value);
}
module.exports = $373bfcecd2f21bdf$var$toString;

});
parcelRegister("8XNpq", function(module, exports) {

var $h6RF6 = parcelRequire("h6RF6");

var $8iRxr = parcelRequire("8iRxr");

var $7uRO6 = parcelRequire("7uRO6");

var $5p6zD = parcelRequire("5p6zD");
/** Used as references for various `Number` constants. */ var $686a29085a14fe6c$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $686a29085a14fe6c$var$symbolProto = $h6RF6 ? $h6RF6.prototype : undefined, $686a29085a14fe6c$var$symbolToString = $686a29085a14fe6c$var$symbolProto ? $686a29085a14fe6c$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $686a29085a14fe6c$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($7uRO6(value)) // Recursively convert values (susceptible to call stack limits).
    return $8iRxr(value, $686a29085a14fe6c$var$baseToString) + '';
    if ($5p6zD(value)) return $686a29085a14fe6c$var$symbolToString ? $686a29085a14fe6c$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$686a29085a14fe6c$var$INFINITY ? '-0' : result;
}
module.exports = $686a29085a14fe6c$var$baseToString;

});
parcelRegister("8iRxr", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $60b988cd3ee30660$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $60b988cd3ee30660$var$arrayMap;

});




parcelRegister("jGYoI", function(module, exports) {

var $5p6zD = parcelRequire("5p6zD");
/** Used as references for various `Number` constants. */ var $e560ca4781dd37a7$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e560ca4781dd37a7$var$toKey(value) {
    if (typeof value == 'string' || $5p6zD(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$e560ca4781dd37a7$var$INFINITY ? '-0' : result;
}
module.exports = $e560ca4781dd37a7$var$toKey;

});



parcelRegister("dVI3Z", function(module, exports) {

var $iM1yZ = parcelRequire("iM1yZ");

var $a25WC = parcelRequire("a25WC");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a242c7504a72da3e$var$hasIn(object, path) {
    return object != null && $a25WC(object, path, $iM1yZ);
}
module.exports = $a242c7504a72da3e$var$hasIn;

});
parcelRegister("iM1yZ", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $daadec25d205cc7f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $daadec25d205cc7f$var$baseHasIn;

});

parcelRegister("a25WC", function(module, exports) {

var $kIcbL = parcelRequire("kIcbL");

var $5cq8f = parcelRequire("5cq8f");

var $7uRO6 = parcelRequire("7uRO6");

var $7z1jr = parcelRequire("7z1jr");

var $jtkST = parcelRequire("jtkST");

var $jGYoI = parcelRequire("jGYoI");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $74deb3b623528e46$var$hasPath(object, path, hasFunc) {
    path = $kIcbL(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $jGYoI(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $jtkST(length) && $7z1jr(key, length) && ($7uRO6(object) || $5cq8f(object));
}
module.exports = $74deb3b623528e46$var$hasPath;

});



parcelRegister("lY3H7", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $ffe2113491c2aff4$var$identity(value) {
    return value;
}
module.exports = $ffe2113491c2aff4$var$identity;

});

parcelRegister("geAZG", function(module, exports) {

var $j3HE2 = parcelRequire("j3HE2");

var $lJf6k = parcelRequire("lJf6k");

var $5bW3I = parcelRequire("5bW3I");

var $jGYoI = parcelRequire("jGYoI");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $bd1aa65f8889e579$var$property(path) {
    return $5bW3I(path) ? $j3HE2($jGYoI(path)) : $lJf6k(path);
}
module.exports = $bd1aa65f8889e579$var$property;

});
parcelRegister("j3HE2", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $de0027191ac8721c$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $de0027191ac8721c$var$baseProperty;

});

parcelRegister("lJf6k", function(module, exports) {

var $dyRiX = parcelRequire("dyRiX");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $fd1983b4123b317a$var$basePropertyDeep(path) {
    return function(object) {
        return $dyRiX(object, path);
    };
}
module.exports = $fd1983b4123b317a$var$basePropertyDeep;

});



parcelRegister("9X2f1", function(module, exports) {
/** Error message constants. */ var $73eb5ccce85df257$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $73eb5ccce85df257$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($73eb5ccce85df257$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $73eb5ccce85df257$var$negate;

});

parcelRegister("7KoBv", function(module, exports) {

var $8iRxr = parcelRequire("8iRxr");

var $khbZD = parcelRequire("khbZD");

var $6c7UK = parcelRequire("6c7UK");

var $ebdkb = parcelRequire("ebdkb");
/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */ function $5a3fea1730adeda7$var$pickBy(object, predicate) {
    if (object == null) return {};
    var props = $8iRxr($ebdkb(object), function(prop) {
        return [
            prop
        ];
    });
    predicate = $khbZD(predicate);
    return $6c7UK(object, props, function(value, path) {
        return predicate(value, path[0]);
    });
}
module.exports = $5a3fea1730adeda7$var$pickBy;

});
parcelRegister("6c7UK", function(module, exports) {

var $dyRiX = parcelRequire("dyRiX");

var $e6xZO = parcelRequire("e6xZO");

var $kIcbL = parcelRequire("kIcbL");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $482a00b1f60b594e$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $dyRiX(object, path);
        if (predicate(value, path)) $e6xZO(result, $kIcbL(path, object), value);
    }
    return result;
}
module.exports = $482a00b1f60b594e$var$basePickBy;

});
parcelRegister("e6xZO", function(module, exports) {

var $66nrm = parcelRequire("66nrm");

var $kIcbL = parcelRequire("kIcbL");

var $7z1jr = parcelRequire("7z1jr");

var $8dkUG = parcelRequire("8dkUG");

var $jGYoI = parcelRequire("jGYoI");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $a44bff1fe33eca80$var$baseSet(object, path, value, customizer) {
    if (!$8dkUG(object)) return object;
    path = $kIcbL(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $jGYoI(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $8dkUG(objValue) ? objValue : $7z1jr(path[index + 1]) ? [] : {};
        }
        $66nrm(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $a44bff1fe33eca80$var$baseSet;

});
parcelRegister("66nrm", function(module, exports) {

var $eiHfi = parcelRequire("eiHfi");

var $6WCaJ = parcelRequire("6WCaJ");
/** Used for built-in method references. */ var $47157c651fc344fe$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $47157c651fc344fe$var$hasOwnProperty = $47157c651fc344fe$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $47157c651fc344fe$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($47157c651fc344fe$var$hasOwnProperty.call(object, key) && $6WCaJ(objValue, value)) || value === undefined && !(key in object)) $eiHfi(object, key, value);
}
module.exports = $47157c651fc344fe$var$assignValue;

});
parcelRegister("eiHfi", function(module, exports) {

var $loxHe = parcelRequire("loxHe");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a6944acea90f9e7b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $loxHe) $loxHe(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $a6944acea90f9e7b$var$baseAssignValue;

});
parcelRegister("loxHe", function(module, exports) {

var $llsjU = parcelRequire("llsjU");
var $f935fa44c0491ee4$var$defineProperty = function() {
    try {
        var func = $llsjU(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $f935fa44c0491ee4$var$defineProperty;

});





parcelRegister("ebdkb", function(module, exports) {

var $jXCiP = parcelRequire("jXCiP");

var $e6KZN = parcelRequire("e6KZN");

var $iHEq4 = parcelRequire("iHEq4");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $a52c6dbe5c61915f$var$getAllKeysIn(object) {
    return $jXCiP(object, $iHEq4, $e6KZN);
}
module.exports = $a52c6dbe5c61915f$var$getAllKeysIn;

});
parcelRegister("e6KZN", function(module, exports) {

var $70SdF = parcelRequire("70SdF");

var $5keTh = parcelRequire("5keTh");

var $5IlTC = parcelRequire("5IlTC");

var $5EG04 = parcelRequire("5EG04");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a45614995b4169c5$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $a45614995b4169c5$var$getSymbolsIn = !$a45614995b4169c5$var$nativeGetSymbols ? $5EG04 : function(object) {
    var result = [];
    while(object){
        $70SdF(result, $5IlTC(object));
        object = $5keTh(object);
    }
    return result;
};
module.exports = $a45614995b4169c5$var$getSymbolsIn;

});
parcelRegister("5keTh", function(module, exports) {

var $1wHHu = parcelRequire("1wHHu");
/** Built-in value references. */ var $3e0a5ef72fc96f9d$var$getPrototype = $1wHHu(Object.getPrototypeOf, Object);
module.exports = $3e0a5ef72fc96f9d$var$getPrototype;

});


parcelRegister("iHEq4", function(module, exports) {

var $2u6DL = parcelRequire("2u6DL");

var $edvrK = parcelRequire("edvrK");

var $k40ty = parcelRequire("k40ty");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d9db989df605040c$var$keysIn(object) {
    return $k40ty(object) ? $2u6DL(object, true) : $edvrK(object);
}
module.exports = $d9db989df605040c$var$keysIn;

});
parcelRegister("edvrK", function(module, exports) {

var $8dkUG = parcelRequire("8dkUG");

var $igick = parcelRequire("igick");

var $Lkdnj = parcelRequire("Lkdnj");
/** Used for built-in method references. */ var $a59aac34360cf15c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a59aac34360cf15c$var$hasOwnProperty = $a59aac34360cf15c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $a59aac34360cf15c$var$baseKeysIn(object) {
    if (!$8dkUG(object)) return $Lkdnj(object);
    var isProto = $igick(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$a59aac34360cf15c$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $a59aac34360cf15c$var$baseKeysIn;

});
parcelRegister("Lkdnj", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $08e4121fc418ce70$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $08e4121fc418ce70$var$nativeKeysIn;

});






parcelRegister("l7NiK", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(payload) {
    var tags = payload.tags, containerId = payload.containerId, containerType = payload.containerType, objectId = payload.objectId, objectType = payload.objectType, attributes = payload.attributes;
    return {
        tags: tags,
        containerId: containerId,
        containerType: containerType,
        objectId: objectId,
        objectType: objectType,
        attributes: attributes
    };
};

});



parcelRegister("iWHc8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2VLnC = parcelRequire("2VLnC");
var $dcaf265b029b0bbd$var$_getPrototypeOf2 = $dcaf265b029b0bbd$var$_interopRequireDefault($2VLnC);

var $kN9tm = parcelRequire("kN9tm");
var $dcaf265b029b0bbd$var$_classCallCheck3 = $dcaf265b029b0bbd$var$_interopRequireDefault($kN9tm);

var $ggEdg = parcelRequire("ggEdg");
var $dcaf265b029b0bbd$var$_createClass3 = $dcaf265b029b0bbd$var$_interopRequireDefault($ggEdg);

var $dzjK4 = parcelRequire("dzjK4");
var $dcaf265b029b0bbd$var$_possibleConstructorReturn3 = $dcaf265b029b0bbd$var$_interopRequireDefault($dzjK4);

var $7OPta = parcelRequire("7OPta");
var $dcaf265b029b0bbd$var$_inherits3 = $dcaf265b029b0bbd$var$_interopRequireDefault($7OPta);

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");
function $dcaf265b029b0bbd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dcaf265b029b0bbd$var$MountTracker = function(_Component) {
    (0, $dcaf265b029b0bbd$var$_inherits3.default)(MountTracker, _Component);
    function MountTracker() {
        (0, $dcaf265b029b0bbd$var$_classCallCheck3.default)(this, MountTracker);
        return (0, $dcaf265b029b0bbd$var$_possibleConstructorReturn3.default)(this, (MountTracker.__proto__ || (0, $dcaf265b029b0bbd$var$_getPrototypeOf2.default)(MountTracker)).apply(this, arguments));
    }
    (0, $dcaf265b029b0bbd$var$_createClass3.default)(MountTracker, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                // $FlowFixMe
                this.props.onMount();
            }
        },
        {
            key: 'render',
            value: function render() {
                return null;
            }
        }
    ]);
    return MountTracker;
}($4fqPo.Component);
module.exports.default = (0, $as4kh.default)({
    onMount: {
        action: 'viewed'
    }
})($dcaf265b029b0bbd$var$MountTracker);

});
parcelRegister("as4kh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c4e6ca01b57dbd6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $h0wOr = parcelRequire("h0wOr");
const $6c4e6ca01b57dbd6$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
            const { patchedEventProps: patchedEventProps } = (0, $h0wOr.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $6c4e6ca01b57dbd6$export$2e2bcd8739ae039 = $6c4e6ca01b57dbd6$var$withAnalyticsEvents;

});
parcelRegister("ew3Bn", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $1c657879b80864da$export$5bf35293e545f20c);

var $14Egk = parcelRequire("14Egk");

var $l2sHq = parcelRequire("l2sHq");

var $kXYs1 = parcelRequire("kXYs1");
function $1c657879b80864da$export$5bf35293e545f20c() {
    const analyticsContext = (0, $kXYs1.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $14Egk.useCallbackOne)((payload)=>{
        return new (0, $l2sHq.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("14Egk", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $0c85657429b85ccc$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $0c85657429b85ccc$export$33752cf3ee811995);

var $4fqPo = parcelRequire("4fqPo");
function $0c85657429b85ccc$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $0c85657429b85ccc$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $4fqPo.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $4fqPo.useRef)(true);
    var committed = (0, $4fqPo.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $0c85657429b85ccc$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $4fqPo.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $0c85657429b85ccc$export$33752cf3ee811995(callback, inputs) {
    return $0c85657429b85ccc$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $0c85657429b85ccc$export$1538c33de8887b59 = $0c85657429b85ccc$export$b6feb8998cd9b342;
var $0c85657429b85ccc$export$35808ee640e87ca7 = $0c85657429b85ccc$export$33752cf3ee811995;

});


parcelRegister("h0wOr", function(module, exports) {
$parcel$export(module.exports, "usePatchedProps", () => $04b87d67f3359cea$export$9ebb5a84d17e5d18);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");
function $04b87d67f3359cea$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const handlerCache = (0, $4fqPo.useRef)({});
    const patchedProps = (0, $4fqPo.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});



parcelRegister("3LUyF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2VLnC = parcelRequire("2VLnC");
var $2bf1a22b1a1d7b37$var$_getPrototypeOf2 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($2VLnC);

var $kN9tm = parcelRequire("kN9tm");
var $2bf1a22b1a1d7b37$var$_classCallCheck3 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($kN9tm);

var $ggEdg = parcelRequire("ggEdg");
var $2bf1a22b1a1d7b37$var$_createClass3 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($ggEdg);

var $dzjK4 = parcelRequire("dzjK4");
var $2bf1a22b1a1d7b37$var$_possibleConstructorReturn3 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($dzjK4);

var $7OPta = parcelRequire("7OPta");
var $2bf1a22b1a1d7b37$var$_inherits3 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($7OPta);

var $4fqPo = parcelRequire("4fqPo");
var $2bf1a22b1a1d7b37$var$_react2 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($4fqPo);

var $5yyGE = parcelRequire("5yyGE");
var $2bf1a22b1a1d7b37$var$_analyticsContext2 = $2bf1a22b1a1d7b37$var$_interopRequireDefault($5yyGE);
function $2bf1a22b1a1d7b37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Props) {
    return function(WrappedComponent) {
        return function(_Component) {
            (0, $2bf1a22b1a1d7b37$var$_inherits3.default)(WithAnalyticsContext, _Component);
            function WithAnalyticsContext() {
                (0, $2bf1a22b1a1d7b37$var$_classCallCheck3.default)(this, WithAnalyticsContext);
                return (0, $2bf1a22b1a1d7b37$var$_possibleConstructorReturn3.default)(this, (WithAnalyticsContext.__proto__ || (0, $2bf1a22b1a1d7b37$var$_getPrototypeOf2.default)(WithAnalyticsContext)).apply(this, arguments));
            }
            (0, $2bf1a22b1a1d7b37$var$_createClass3.default)(WithAnalyticsContext, [
                {
                    key: 'render',
                    value: function render() {
                        return $2bf1a22b1a1d7b37$var$_react2.default.createElement($2bf1a22b1a1d7b37$var$_analyticsContext2.default, Props, $2bf1a22b1a1d7b37$var$_react2.default.createElement(WrappedComponent, this.props));
                    }
                }
            ]);
            return WithAnalyticsContext;
        }($4fqPo.Component);
    };
};

});

parcelRegister("dNBGl", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9CTAW = parcelRequire("9CTAW");

var $6P2pt = parcelRequire("6P2pt");

var $aE6F4 = parcelRequire("aE6F4");

var $afsZB = parcelRequire("afsZB");

var $hQySt = parcelRequire("hQySt");
// data.type necessary cause of flow
module.exports.default = function(data) {
    if (!data) throw new Error('No event data passed in');
    if (data.client && data.type !== $9CTAW.OPERATIONAL_EVENT_TYPE) throw new Error('Sending events via client is not supported in non Operational events');
    if (data.type === $9CTAW.UI_EVENT_TYPE) (0, $hQySt.fireAnalyticsUiEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $9CTAW.TRACK_EVENT_TYPE) (0, $afsZB.fireAnalyticsTrackEvent)(data.analyticsEvent, data.payload);
    else if (data.type === $9CTAW.OPERATIONAL_EVENT_TYPE) (0, $6P2pt.fireAnalyticsOperationalEvent)(data);
    else if (data.type === $9CTAW.SCREEN_EVENT_TYPE) (0, $aE6F4.fireAnalyticsScreenEvent)(data.analyticsEvent, data.payload);
    else throw new Error('Event type not supported: ' + data.type);
};

});
parcelRegister("6P2pt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationEventWithEvent = undefined;

var $blaEq = parcelRequire("blaEq");
var $4f796012614cc9f6$var$_extends3 = $4f796012614cc9f6$var$_interopRequireDefault($blaEq);

var $4tbnU = parcelRequire("4tbnU");
var $4f796012614cc9f6$var$_isUndefined2 = $4f796012614cc9f6$var$_interopRequireDefault($4tbnU);

var $7KoBv = parcelRequire("7KoBv");
var $4f796012614cc9f6$var$_pickBy2 = $4f796012614cc9f6$var$_interopRequireDefault($7KoBv);

var $9CTAW = parcelRequire("9CTAW");

var $l7NiK = parcelRequire("l7NiK");
var $4f796012614cc9f6$var$_mapDataPayloadToContextPayload2 = $4f796012614cc9f6$var$_interopRequireDefault($l7NiK);
function $4f796012614cc9f6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $4f796012614cc9f6$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $4f796012614cc9f6$var$_isUndefined2.default)(a);
};
var $4f796012614cc9f6$var$mapOperationalPayload = function mapOperationalPayload(payload) {
    var context = (0, $4f796012614cc9f6$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $4f796012614cc9f6$var$_pickBy2.default)((0, $4f796012614cc9f6$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $4f796012614cc9f6$var$isNotUndefined);
};
var $4f796012614cc9f6$var$mapOperationalPayloadToClient = function mapOperationalPayloadToClient(payload) {
    var context = (0, $4f796012614cc9f6$var$_mapDataPayloadToContextPayload2.default)(payload);
    var sourceName = payload.sourceName, sourceType = payload.sourceType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    if (!action || !actionSubject || !sourceName || !sourceType) return false;
    var source = sourceName + sourceType;
    return (0, $4f796012614cc9f6$var$_pickBy2.default)((0, $4f796012614cc9f6$var$_extends3.default)({}, context, {
        source: source,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $4f796012614cc9f6$var$isNotUndefined);
};
var $4f796012614cc9f6$var$fireAnalyticsOperationEventWithEvent = module.exports.fireAnalyticsOperationEventWithEvent = function fireAnalyticsOperationEventWithEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $4f796012614cc9f6$var$_extends3.default)({}, $4f796012614cc9f6$var$mapOperationalPayload(payload), {
        analyticsType: $9CTAW.OPERATIONAL_EVENT_TYPE
    })).fire();
};
var $4f796012614cc9f6$var$fireAnalyticsOperationalEventWithClient = module.exports.fireAnalyticsOperationalEventWithClient = function fireAnalyticsOperationalEventWithClient(client, payload) {
    if (!client.sendOperationalEvent) throw new Error('No Operational event fired, sendOperationEvent doesnt exist');
    if (!(typeof client.sendOperationalEvent === 'function')) throw new Error('No Operational event fired, sendOperationEvent is not a function');
    var mappedPayload = $4f796012614cc9f6$var$mapOperationalPayloadToClient(payload);
    if (!mappedPayload) throw new Error('No Operational event fired, missing payload attributes. Operational events require an action, actionSubject, sourceName and sourceType');
    return client.sendOperationalEvent(mappedPayload);
};
var $4f796012614cc9f6$var$fireAnalyticsOperationalEvent = module.exports.fireAnalyticsOperationalEvent = function fireAnalyticsOperationalEvent(data) {
    if (data.client) return $4f796012614cc9f6$var$fireAnalyticsOperationalEventWithClient(data.client, data.payload);
    return $4f796012614cc9f6$var$fireAnalyticsOperationEventWithEvent(data.analyticsEvent, data.payload);
};

});

parcelRegister("aE6F4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsScreenEvent = undefined;

var $blaEq = parcelRequire("blaEq");
var $7c02cea2709d4a25$var$_extends3 = $7c02cea2709d4a25$var$_interopRequireDefault($blaEq);

var $4tbnU = parcelRequire("4tbnU");
var $7c02cea2709d4a25$var$_isUndefined2 = $7c02cea2709d4a25$var$_interopRequireDefault($4tbnU);

var $7KoBv = parcelRequire("7KoBv");
var $7c02cea2709d4a25$var$_pickBy2 = $7c02cea2709d4a25$var$_interopRequireDefault($7KoBv);

var $9CTAW = parcelRequire("9CTAW");
function $7c02cea2709d4a25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7c02cea2709d4a25$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $7c02cea2709d4a25$var$_isUndefined2.default)(a);
};
var $7c02cea2709d4a25$var$mapPayload = function mapPayload(payload) {
    return (0, $7c02cea2709d4a25$var$_pickBy2.default)((0, $7c02cea2709d4a25$var$_extends3.default)({}, payload, payload.attributes, {
        attributes: undefined
    }), $7c02cea2709d4a25$var$isNotUndefined);
};
var $7c02cea2709d4a25$var$fireAnalyticsScreenEvent = module.exports.fireAnalyticsScreenEvent = function fireAnalyticsScreenEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $7c02cea2709d4a25$var$_extends3.default)({}, $7c02cea2709d4a25$var$mapPayload(payload || {}), {
        analyticsType: $9CTAW.SCREEN_EVENT_TYPE
    })).fire();
};

});

parcelRegister("afsZB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsTrackEvent = undefined;

var $blaEq = parcelRequire("blaEq");
var $7761cb719bda15cd$var$_extends3 = $7761cb719bda15cd$var$_interopRequireDefault($blaEq);

var $4tbnU = parcelRequire("4tbnU");
var $7761cb719bda15cd$var$_isUndefined2 = $7761cb719bda15cd$var$_interopRequireDefault($4tbnU);

var $7KoBv = parcelRequire("7KoBv");
var $7761cb719bda15cd$var$_pickBy2 = $7761cb719bda15cd$var$_interopRequireDefault($7KoBv);

var $9CTAW = parcelRequire("9CTAW");

var $l7NiK = parcelRequire("l7NiK");
var $7761cb719bda15cd$var$_mapDataPayloadToContextPayload2 = $7761cb719bda15cd$var$_interopRequireDefault($l7NiK);
function $7761cb719bda15cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7761cb719bda15cd$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $7761cb719bda15cd$var$_isUndefined2.default)(a);
};
var $7761cb719bda15cd$var$mapPayload = function mapPayload(payload) {
    var context = (0, $7761cb719bda15cd$var$_mapDataPayloadToContextPayload2.default)(payload);
    var action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId;
    return (0, $7761cb719bda15cd$var$_pickBy2.default)((0, $7761cb719bda15cd$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), $7761cb719bda15cd$var$isNotUndefined);
};
var $7761cb719bda15cd$var$fireAnalyticsTrackEvent = module.exports.fireAnalyticsTrackEvent = function fireAnalyticsTrackEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $7761cb719bda15cd$var$_extends3.default)({}, $7761cb719bda15cd$var$mapPayload(payload), {
        analyticsType: $9CTAW.TRACK_EVENT_TYPE
    })).fire();
};

});

parcelRegister("hQySt", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fireAnalyticsUiEvent = undefined;

var $blaEq = parcelRequire("blaEq");
var $cfe258f432062daf$var$_extends3 = $cfe258f432062daf$var$_interopRequireDefault($blaEq);

var $4tbnU = parcelRequire("4tbnU");
var $cfe258f432062daf$var$_isUndefined2 = $cfe258f432062daf$var$_interopRequireDefault($4tbnU);

var $7KoBv = parcelRequire("7KoBv");
var $cfe258f432062daf$var$_pickBy2 = $cfe258f432062daf$var$_interopRequireDefault($7KoBv);

var $9CTAW = parcelRequire("9CTAW");

var $l7NiK = parcelRequire("l7NiK");
var $cfe258f432062daf$var$_mapDataPayloadToContextPayload2 = $cfe258f432062daf$var$_interopRequireDefault($l7NiK);
function $cfe258f432062daf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cfe258f432062daf$var$isNotUndefined = function isNotUndefined(a) {
    return !(0, $cfe258f432062daf$var$_isUndefined2.default)(a);
};
/**
 * Analytics web react 2.0
 */ var $cfe258f432062daf$var$mapUiPayload = function mapUiPayload(payload) {
    var context = (0, $cfe258f432062daf$var$_mapDataPayloadToContextPayload2.default)(payload);
    var actionSubjectId = payload.actionSubjectId;
    return (0, $cfe258f432062daf$var$_pickBy2.default)((0, $cfe258f432062daf$var$_extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        actionSubjectId: actionSubjectId
    }), $cfe258f432062daf$var$isNotUndefined);
};
var $cfe258f432062daf$var$fireAnalyticsUiEvent = module.exports.fireAnalyticsUiEvent = function fireAnalyticsUiEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, $cfe258f432062daf$var$_extends3.default)({}, $cfe258f432062daf$var$mapUiPayload(payload), {
        analyticsType: $9CTAW.UI_EVENT_TYPE
    })).fire();
};

});


parcelRegister("aybJE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $blaEq = parcelRequire("blaEq");
var $7ae62ebf7d128777$var$_extends3 = $7ae62ebf7d128777$var$_interopRequireDefault($blaEq);

var $4tbnU = parcelRequire("4tbnU");
var $7ae62ebf7d128777$var$_isUndefined2 = $7ae62ebf7d128777$var$_interopRequireDefault($4tbnU);

var $8g70n = parcelRequire("8g70n");
var $7ae62ebf7d128777$var$_last2 = $7ae62ebf7d128777$var$_interopRequireDefault($8g70n);

var $hp9va = parcelRequire("hp9va");
var $7ae62ebf7d128777$var$_omitBy2 = $7ae62ebf7d128777$var$_interopRequireDefault($hp9va);

var $9CTAW = parcelRequire("9CTAW");

var $aepKc = parcelRequire("aepKc");
function $7ae62ebf7d128777$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7ae62ebf7d128777$var$getActionSubjectForEventType = function getActionSubjectForEventType(event, analyticsType) {
    if (analyticsType === $9CTAW.TRACK_EVENT_TYPE) return (0, $aepKc.getActionSubject)(event);
    return (0, $7ae62ebf7d128777$var$_last2.default)((0, $aepKc.getComponents)(event));
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * AtlasKit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ module.exports.default = function(event) {
    var sources = (0, $aepKc.getSources)(event);
    var analyticsType = (0, $aepKc.getAnalyticsType)(event);
    var actionSubject = $7ae62ebf7d128777$var$getActionSubjectForEventType(event, analyticsType);
    var source = (0, $7ae62ebf7d128777$var$_last2.default)(sources);
    var action = (0, $aepKc.getAction)(event);
    var attributes = (0, $7ae62ebf7d128777$var$_extends3.default)({}, (0, $aepKc.getAttributes)(event), {
        namespaces: sources.join('.')
    });
    if (action === $9CTAW.PAGE_EVENT_ACTION || analyticsType === $9CTAW.SCREEN_EVENT_TYPE) return {
        type: $9CTAW.SCREEN_EVENT_TYPE,
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case $9CTAW.UI_EVENT_TYPE:
        case $9CTAW.TRACK_EVENT_TYPE:
        case $9CTAW.OPERATIONAL_EVENT_TYPE:
            var actionSubjectId = (0, $aepKc.getActionSubjectId)(event);
            var containerId = (0, $7ae62ebf7d128777$var$_last2.default)((0, $aepKc.getContainerIds)(event));
            var containerType = (0, $7ae62ebf7d128777$var$_last2.default)((0, $aepKc.getContainerTypes)(event));
            var objectId = (0, $7ae62ebf7d128777$var$_last2.default)((0, $aepKc.getObjectIds)(event));
            var objectType = (0, $7ae62ebf7d128777$var$_last2.default)((0, $aepKc.getObjectTypes)(event));
            var tags = (0, $aepKc.getTags)(event);
            return {
                type: analyticsType,
                payload: (0, $7ae62ebf7d128777$var$_omitBy2.default)({
                    action: action,
                    actionSubject: actionSubject,
                    actionSubjectId: actionSubjectId,
                    source: source,
                    tags: tags,
                    containerType: containerType,
                    containerId: containerId,
                    objectType: objectType,
                    objectId: objectId,
                    attributes: attributes
                }, $7ae62ebf7d128777$var$_isUndefined2.default)
            };
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("8g70n", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $6035406f4818c0b7$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $6035406f4818c0b7$var$last;

});

parcelRegister("aepKc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAction = module.exports.getAnalyticsType = module.exports.getActionSubjectId = module.exports.getObjectIds = module.exports.getObjectTypes = module.exports.getContainerIds = module.exports.getContainerTypes = module.exports.getTags = module.exports.getAttributes = module.exports.getSources = module.exports.getActionSubject = module.exports.getComponents = undefined;

var $9pJh6 = parcelRequire("9pJh6");
var $772f2e6d9be61c9c$var$_objectWithoutProperties3 = $772f2e6d9be61c9c$var$_interopRequireDefault($9pJh6);

var $38YHl = parcelRequire("38YHl");
var $772f2e6d9be61c9c$var$_merge2 = $772f2e6d9be61c9c$var$_interopRequireDefault($38YHl);

var $jiAEJ = parcelRequire("jiAEJ");
var $772f2e6d9be61c9c$var$_uniq2 = $772f2e6d9be61c9c$var$_interopRequireDefault($jiAEJ);
function $772f2e6d9be61c9c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $772f2e6d9be61c9c$var$extractFromEventContext = function extractFromEventContext(propertyNames, event) {
    return event.context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $772f2e6d9be61c9c$var$extractFromEventPayload = function extractFromEventPayload(propertyName, event) {
    return event.payload[propertyName];
};
var $772f2e6d9be61c9c$var$extractFromPayloadOrContext = function extractFromPayloadOrContext(propertyName, event) {
    var payloadProp = $772f2e6d9be61c9c$var$extractFromEventPayload(propertyName, event);
    var contextProps = $772f2e6d9be61c9c$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
var $772f2e6d9be61c9c$var$extractPayloadAttributes = function extractPayloadAttributes(event) {
    var _event$payload = event.payload, tags = _event$payload.tags, actionSubjectId = _event$payload.actionSubjectId, containerType = _event$payload.containerType, containerId = _event$payload.containerId, objectType = _event$payload.objectType, objectId = _event$payload.objectId, analyticsType = _event$payload.analyticsType, name = _event$payload.name, action = _event$payload.action, actionSubject = _event$payload.actionSubject, attributes = (0, $772f2e6d9be61c9c$var$_objectWithoutProperties3.default)(_event$payload, [
        'tags',
        'actionSubjectId',
        'containerType',
        'containerId',
        'objectType',
        'objectId',
        'analyticsType',
        'name',
        'action',
        'actionSubject'
    ]);
    return attributes;
};
var $772f2e6d9be61c9c$var$getComponents = module.exports.getComponents = function getComponents(event) {
    return $772f2e6d9be61c9c$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
};
var $772f2e6d9be61c9c$var$getActionSubject = module.exports.getActionSubject = function getActionSubject(event) {
    return $772f2e6d9be61c9c$var$extractFromEventPayload('actionSubject', event);
};
var $772f2e6d9be61c9c$var$getSources = module.exports.getSources = function getSources(event) {
    return $772f2e6d9be61c9c$var$extractFromEventContext([
        'source'
    ], event);
};
var $772f2e6d9be61c9c$var$getAttributes = module.exports.getAttributes = function getAttributes(event) {
    return (0, $772f2e6d9be61c9c$var$_merge2.default)($772f2e6d9be61c9c$var$extractFromEventContext([
        'attributes'
    ], event).reduce(function(result, extraAttributes) {
        return (0, $772f2e6d9be61c9c$var$_merge2.default)(result, extraAttributes);
    }, {}), $772f2e6d9be61c9c$var$extractPayloadAttributes(event));
};
var $772f2e6d9be61c9c$var$getTags = module.exports.getTags = function getTags(event) {
    var tags = (0, $772f2e6d9be61c9c$var$_uniq2.default)($772f2e6d9be61c9c$var$extractFromEventContext([
        'tags'
    ], event).reduce(function(result, extraTags) {
        return result.concat(extraTags);
    }, []).concat($772f2e6d9be61c9c$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
var $772f2e6d9be61c9c$var$getContainerTypes = module.exports.getContainerTypes = function getContainerTypes(event) {
    return $772f2e6d9be61c9c$var$extractFromPayloadOrContext('containerType', event);
};
var $772f2e6d9be61c9c$var$getContainerIds = module.exports.getContainerIds = function getContainerIds(event) {
    return $772f2e6d9be61c9c$var$extractFromPayloadOrContext('containerId', event);
};
var $772f2e6d9be61c9c$var$getObjectTypes = module.exports.getObjectTypes = function getObjectTypes(event) {
    return $772f2e6d9be61c9c$var$extractFromPayloadOrContext('objectType', event);
};
var $772f2e6d9be61c9c$var$getObjectIds = module.exports.getObjectIds = function getObjectIds(event) {
    return $772f2e6d9be61c9c$var$extractFromPayloadOrContext('objectId', event);
};
// singluar extractors
var $772f2e6d9be61c9c$var$getActionSubjectId = module.exports.getActionSubjectId = function getActionSubjectId(event) {
    return $772f2e6d9be61c9c$var$extractFromEventPayload('actionSubjectId', event);
};
var $772f2e6d9be61c9c$var$getAnalyticsType = module.exports.getAnalyticsType = function getAnalyticsType(event) {
    return $772f2e6d9be61c9c$var$extractFromEventPayload('analyticsType', event);
};
var $772f2e6d9be61c9c$var$getAction = module.exports.getAction = function getAction(event) {
    return $772f2e6d9be61c9c$var$extractFromEventPayload('action', event);
};

});
parcelRegister("38YHl", function(module, exports) {

var $7oAwA = parcelRequire("7oAwA");

var $7lMJv = parcelRequire("7lMJv");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $24a133d76d0812c0$var$merge = $7lMJv(function(object, source, srcIndex) {
    $7oAwA(object, source, srcIndex);
});
module.exports = $24a133d76d0812c0$var$merge;

});
parcelRegister("7oAwA", function(module, exports) {

var $jFnky = parcelRequire("jFnky");

var $2hf9l = parcelRequire("2hf9l");

var $cXdPf = parcelRequire("cXdPf");

var $e1RAU = parcelRequire("e1RAU");

var $8dkUG = parcelRequire("8dkUG");

var $iHEq4 = parcelRequire("iHEq4");

var $9RRlF = parcelRequire("9RRlF");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $56271b528fdc361a$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $cXdPf(source, function(srcValue, key) {
        stack || (stack = new $jFnky);
        if ($8dkUG(srcValue)) $e1RAU(object, source, key, srcIndex, $56271b528fdc361a$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($9RRlF(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $2hf9l(object, key, newValue);
        }
    }, $iHEq4);
}
module.exports = $56271b528fdc361a$var$baseMerge;

});
parcelRegister("2hf9l", function(module, exports) {

var $eiHfi = parcelRequire("eiHfi");

var $6WCaJ = parcelRequire("6WCaJ");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1a88ebb4d2c6e1b1$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6WCaJ(object[key], value) || value === undefined && !(key in object)) $eiHfi(object, key, value);
}
module.exports = $1a88ebb4d2c6e1b1$var$assignMergeValue;

});

parcelRegister("cXdPf", function(module, exports) {

var $aDIo7 = parcelRequire("aDIo7");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $96e5b82bf2f69e5a$var$baseFor = $aDIo7();
module.exports = $96e5b82bf2f69e5a$var$baseFor;

});
parcelRegister("aDIo7", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $7beffa7410dc42c2$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $7beffa7410dc42c2$var$createBaseFor;

});


parcelRegister("e1RAU", function(module, exports) {

var $2hf9l = parcelRequire("2hf9l");

var $7SuvP = parcelRequire("7SuvP");

var $eXG6k = parcelRequire("eXG6k");

var $8N2c9 = parcelRequire("8N2c9");

var $fFAnp = parcelRequire("fFAnp");

var $5cq8f = parcelRequire("5cq8f");

var $7uRO6 = parcelRequire("7uRO6");

var $3rOwq = parcelRequire("3rOwq");

var $eWbuf = parcelRequire("eWbuf");

var $hbSPS = parcelRequire("hbSPS");

var $8dkUG = parcelRequire("8dkUG");

var $8mCLS = parcelRequire("8mCLS");

var $aWiKZ = parcelRequire("aWiKZ");

var $9RRlF = parcelRequire("9RRlF");

var $ae2pC = parcelRequire("ae2pC");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $a36abb601ce1a9d7$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $9RRlF(object, key), srcValue = $9RRlF(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $2hf9l(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $7uRO6(srcValue), isBuff = !isArr && $eWbuf(srcValue), isTyped = !isArr && !isBuff && $aWiKZ(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($7uRO6(objValue)) newValue = objValue;
            else if ($3rOwq(objValue)) newValue = $8N2c9(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $7SuvP(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $eXG6k(srcValue, true);
            } else newValue = [];
        } else if ($8mCLS(srcValue) || $5cq8f(srcValue)) {
            newValue = objValue;
            if ($5cq8f(objValue)) newValue = $ae2pC(objValue);
            else if (!$8dkUG(objValue) || $hbSPS(objValue)) newValue = $fFAnp(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $2hf9l(object, key, newValue);
}
module.exports = $a36abb601ce1a9d7$var$baseMergeDeep;

});
parcelRegister("7SuvP", function(module, exports) {

var $fW2G9 = parcelRequire("fW2G9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $fW2G9.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("eXG6k", function(module, exports) {

var $hPGzZ = parcelRequire("hPGzZ");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $ae473bc36e4b97b3$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $hPGzZ(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $ae473bc36e4b97b3$var$cloneTypedArray;

});
parcelRegister("hPGzZ", function(module, exports) {

var $hJoE9 = parcelRequire("hJoE9");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $cfb83a7c61763bc9$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $hJoE9(result).set(new $hJoE9(arrayBuffer));
    return result;
}
module.exports = $cfb83a7c61763bc9$var$cloneArrayBuffer;

});


parcelRegister("8N2c9", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $66649a319c07332a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $66649a319c07332a$var$copyArray;

});

parcelRegister("fFAnp", function(module, exports) {

var $izXYp = parcelRequire("izXYp");

var $5keTh = parcelRequire("5keTh");

var $igick = parcelRequire("igick");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $b686e6fa87f4c456$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$igick(object) ? $izXYp($5keTh(object)) : {};
}
module.exports = $b686e6fa87f4c456$var$initCloneObject;

});
parcelRegister("izXYp", function(module, exports) {

var $8dkUG = parcelRequire("8dkUG");
/** Built-in value references. */ var $d86a04576bb44fdf$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $d86a04576bb44fdf$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$8dkUG(proto)) return {};
        if ($d86a04576bb44fdf$var$objectCreate) return $d86a04576bb44fdf$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $d86a04576bb44fdf$var$baseCreate;

});


parcelRegister("3rOwq", function(module, exports) {

var $k40ty = parcelRequire("k40ty");

var $cwqTh = parcelRequire("cwqTh");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $282b1556759404cf$var$isArrayLikeObject(value) {
    return $cwqTh(value) && $k40ty(value);
}
module.exports = $282b1556759404cf$var$isArrayLikeObject;

});

parcelRegister("8mCLS", function(module, exports) {

var $emSWi = parcelRequire("emSWi");

var $5keTh = parcelRequire("5keTh");

var $cwqTh = parcelRequire("cwqTh");
/** `Object#toString` result references. */ var $616e73f143a0ba75$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $616e73f143a0ba75$var$funcProto = Function.prototype, $616e73f143a0ba75$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $616e73f143a0ba75$var$funcToString = $616e73f143a0ba75$var$funcProto.toString;
/** Used to check objects for own properties. */ var $616e73f143a0ba75$var$hasOwnProperty = $616e73f143a0ba75$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $616e73f143a0ba75$var$objectCtorString = $616e73f143a0ba75$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $616e73f143a0ba75$var$isPlainObject(value) {
    if (!$cwqTh(value) || $emSWi(value) != $616e73f143a0ba75$var$objectTag) return false;
    var proto = $5keTh(value);
    if (proto === null) return true;
    var Ctor = $616e73f143a0ba75$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $616e73f143a0ba75$var$funcToString.call(Ctor) == $616e73f143a0ba75$var$objectCtorString;
}
module.exports = $616e73f143a0ba75$var$isPlainObject;

});

parcelRegister("9RRlF", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $72f2722ebe533409$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $72f2722ebe533409$var$safeGet;

});

parcelRegister("ae2pC", function(module, exports) {

var $4iW15 = parcelRequire("4iW15");

var $iHEq4 = parcelRequire("iHEq4");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $771d153716e42afb$var$toPlainObject(value) {
    return $4iW15(value, $iHEq4(value));
}
module.exports = $771d153716e42afb$var$toPlainObject;

});
parcelRegister("4iW15", function(module, exports) {

var $66nrm = parcelRequire("66nrm");

var $eiHfi = parcelRequire("eiHfi");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $3225d8bec35b25f3$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $eiHfi(object, key, newValue);
        else $66nrm(object, key, newValue);
    }
    return object;
}
module.exports = $3225d8bec35b25f3$var$copyObject;

});




parcelRegister("7lMJv", function(module, exports) {

var $bED1p = parcelRequire("bED1p");

var $je4d0 = parcelRequire("je4d0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $55a04be94c1db1f9$var$createAssigner(assigner) {
    return $bED1p(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $je4d0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $55a04be94c1db1f9$var$createAssigner;

});
parcelRegister("bED1p", function(module, exports) {

var $lY3H7 = parcelRequire("lY3H7");

var $3wf0P = parcelRequire("3wf0P");

var $cery1 = parcelRequire("cery1");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $87c1b30b53016f6f$var$baseRest(func, start) {
    return $cery1($3wf0P(func, start, $lY3H7), func + '');
}
module.exports = $87c1b30b53016f6f$var$baseRest;

});
parcelRegister("3wf0P", function(module, exports) {

var $2qZGx = parcelRequire("2qZGx");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2900016cbf950c29$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $2900016cbf950c29$var$overRest(func, start, transform) {
    start = $2900016cbf950c29$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $2900016cbf950c29$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $2qZGx(func, this, otherArgs);
    };
}
module.exports = $2900016cbf950c29$var$overRest;

});
parcelRegister("2qZGx", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $1c5ddbdd198ff0a5$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $1c5ddbdd198ff0a5$var$apply;

});


parcelRegister("cery1", function(module, exports) {

var $jFv0I = parcelRequire("jFv0I");

var $6HLIS = parcelRequire("6HLIS");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $8e7c293f4fccbaf0$var$setToString = $6HLIS($jFv0I);
module.exports = $8e7c293f4fccbaf0$var$setToString;

});
parcelRegister("jFv0I", function(module, exports) {

var $lW3s5 = parcelRequire("lW3s5");

var $loxHe = parcelRequire("loxHe");

var $lY3H7 = parcelRequire("lY3H7");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e519e6b352c9ae74$var$baseSetToString = !$loxHe ? $lY3H7 : function(func, string) {
    return $loxHe(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $lW3s5(string),
        'writable': true
    });
};
module.exports = $e519e6b352c9ae74$var$baseSetToString;

});
parcelRegister("lW3s5", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $ff81b13d35793d73$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $ff81b13d35793d73$var$constant;

});


parcelRegister("6HLIS", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $4e1bc6f9342cb5b9$var$HOT_COUNT = 800, $4e1bc6f9342cb5b9$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4e1bc6f9342cb5b9$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $4e1bc6f9342cb5b9$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $4e1bc6f9342cb5b9$var$nativeNow(), remaining = $4e1bc6f9342cb5b9$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $4e1bc6f9342cb5b9$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $4e1bc6f9342cb5b9$var$shortOut;

});



parcelRegister("je4d0", function(module, exports) {

var $6WCaJ = parcelRequire("6WCaJ");

var $k40ty = parcelRequire("k40ty");

var $7z1jr = parcelRequire("7z1jr");

var $8dkUG = parcelRequire("8dkUG");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $dff296ed3c3197b0$var$isIterateeCall(value, index, object) {
    if (!$8dkUG(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $k40ty(object) && $7z1jr(index, object.length) : type == 'string' && index in object) return $6WCaJ(object[index], value);
    return false;
}
module.exports = $dff296ed3c3197b0$var$isIterateeCall;

});



parcelRegister("jiAEJ", function(module, exports) {

var $lw1Oa = parcelRequire("lw1Oa");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $e0cc21db1e6cff64$var$uniq(array) {
    return array && array.length ? $lw1Oa(array) : [];
}
module.exports = $e0cc21db1e6cff64$var$uniq;

});
parcelRegister("lw1Oa", function(module, exports) {

var $efeLL = parcelRequire("efeLL");

var $4rV24 = parcelRequire("4rV24");

var $TWAC8 = parcelRequire("TWAC8");

var $9bLcY = parcelRequire("9bLcY");

var $b6tGH = parcelRequire("b6tGH");

var $9QMT7 = parcelRequire("9QMT7");
/** Used as the size to enable large array optimizations. */ var $fa9dfd2f86f059bb$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $fa9dfd2f86f059bb$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $4rV24, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $TWAC8;
    } else if (length >= $fa9dfd2f86f059bb$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $b6tGH(array);
        if (set) return $9QMT7(set);
        isCommon = false;
        includes = $9bLcY;
        seen = new $efeLL;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $fa9dfd2f86f059bb$var$baseUniq;

});
parcelRegister("4rV24", function(module, exports) {

var $7H4pl = parcelRequire("7H4pl");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $33d5ec7b1803ba2e$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7H4pl(array, value, 0) > -1;
}
module.exports = $33d5ec7b1803ba2e$var$arrayIncludes;

});
parcelRegister("7H4pl", function(module, exports) {

var $esqvl = parcelRequire("esqvl");

var $5lBZ0 = parcelRequire("5lBZ0");

var $iO6tV = parcelRequire("iO6tV");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $599ff7dc9e0d5d54$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $iO6tV(array, value, fromIndex) : $esqvl(array, $5lBZ0, fromIndex);
}
module.exports = $599ff7dc9e0d5d54$var$baseIndexOf;

});
parcelRegister("esqvl", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a8683d74059ec392$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a8683d74059ec392$var$baseFindIndex;

});

parcelRegister("5lBZ0", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3e4c6089f111a80e$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3e4c6089f111a80e$var$baseIsNaN;

});

parcelRegister("iO6tV", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $db11eca4d73c8254$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $db11eca4d73c8254$var$strictIndexOf;

});



parcelRegister("TWAC8", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $0a8295d53fd955bc$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $0a8295d53fd955bc$var$arrayIncludesWith;

});

parcelRegister("b6tGH", function(module, exports) {

var $fzh8A = parcelRequire("fzh8A");

var $4GM1f = parcelRequire("4GM1f");

var $9QMT7 = parcelRequire("9QMT7");
/** Used as references for various `Number` constants. */ var $8157489668b14c42$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $8157489668b14c42$var$createSet = !($fzh8A && 1 / $9QMT7(new $fzh8A([
    ,
    -0
]))[1] == $8157489668b14c42$var$INFINITY) ? $4GM1f : function(values) {
    return new $fzh8A(values);
};
module.exports = $8157489668b14c42$var$createSet;

});
parcelRegister("4GM1f", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $36a0553dd5056994$var$noop() {
// No operation performed.
}
module.exports = $36a0553dd5056994$var$noop;

});







parcelRegister("eSL4S", function(module, exports) {
$parcel$export(module.exports, "isAdvancedHelpCenter", () => $8d2641f0f23e6a9e$export$a8032b4abe96a350);
$parcel$export(module.exports, "isUnifiedHelpHelpCenter", () => $8d2641f0f23e6a9e$export$35fba107189c9761);
$parcel$export(module.exports, "isFlexiHCEnabledInDefaultHC", () => $8d2641f0f23e6a9e$export$64db2d25a762d602);
$parcel$export(module.exports, "isDefaultHelpCenter", () => $8d2641f0f23e6a9e$export$6770869865ec8ff4);
$parcel$export(module.exports, "isKoshEnabledForDefaultHelpCenter", () => $8d2641f0f23e6a9e$export$f8bf208a2ec06357);
$parcel$export(module.exports, "isHelpCentersManagement", () => $8d2641f0f23e6a9e$export$f20af57447c92bed);
$parcel$export(module.exports, "isCSMHelpCenter", () => $8d2641f0f23e6a9e$export$3eacdddcf63bcdf9);
$parcel$export(module.exports, "getIsHelpHub", () => $8d2641f0f23e6a9e$export$b4319ea987d17576);
$parcel$export(module.exports, "isJcsOnlyRestrictedRoute", () => $8d2641f0f23e6a9e$export$ab40e3484f545b4f);
$parcel$export(module.exports, "getSlugForAdvancedHCFromArticleView", () => $8d2641f0f23e6a9e$export$6287fcdbdaf12366);
$parcel$export(module.exports, "getSlugForHelpCenter", () => $8d2641f0f23e6a9e$export$1487e10d6956fe03);

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $3wR8f = parcelRequire("3wR8f");

var $ebpTf = parcelRequire("ebpTf");
const $8d2641f0f23e6a9e$export$a8032b4abe96a350 = ()=>{
    return (0, $3wR8f.getRelativeBasePath)().startsWith('/helpcenter') && !$8d2641f0f23e6a9e$export$35fba107189c9761();
};
const $8d2641f0f23e6a9e$export$64db2d25a762d602 = ()=>{
    return $8d2641f0f23e6a9e$export$6770869865ec8ff4();
};
const $8d2641f0f23e6a9e$export$6770869865ec8ff4 = ()=>{
    return (0, $3wR8f.getRelativeBasePath)().startsWith('/servicedesk/customer');
};
const $8d2641f0f23e6a9e$export$f8bf208a2ec06357 = ()=>{
    if ((0, $bG6ob.isDefaultHCCallsJiraEnabled)() && $8d2641f0f23e6a9e$export$6770869865ec8ff4()) return false;
    return true;
};
const $8d2641f0f23e6a9e$export$35fba107189c9761 = ()=>{
    return (0, $3wR8f.getRelativeBasePath)() === (0, $748yq.UNIFIED_HELP_CENTER_BASE_PATH);
};
const $8d2641f0f23e6a9e$export$f20af57447c92bed = ()=>{
    return (0, $3wR8f.getRelativeBasePath)() === (0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH);
};
const $8d2641f0f23e6a9e$export$3eacdddcf63bcdf9 = (helpCenterType)=>{
    return (0, $bG6ob.isJsmCsMasterFlagEnabled)() && helpCenterType === 'CUSTOMER_SERVICE';
};
const $8d2641f0f23e6a9e$export$b4319ea987d17576 = ()=>{
    return (0, $ebpTf.getEnv)().helpCenterType === 'HELP_HUB';
};
const $8d2641f0f23e6a9e$export$ab40e3484f545b4f = (customerAccountAvailability)=>{
    return $8d2641f0f23e6a9e$export$6770869865ec8ff4() && customerAccountAvailability === 'JCS_ONLY' && (0, $bG6ob.isCsmAccessControlSplitEnabled)();
};
const $8d2641f0f23e6a9e$export$6287fcdbdaf12366 = (url)=>{
    const pattern = $8d2641f0f23e6a9e$export$3eacdddcf63bcdf9((0, $ebpTf.getEnv)().helpCenterType) ? /https:\/\/.*?\/helpcenter\/([^/]+)\// : /https:\/\/.*?\/helpcenter\/([^/]+)\/portal\//;
    const match = url.match(pattern);
    return match && match[1] ? match[1] : undefined;
};
const $8d2641f0f23e6a9e$export$1487e10d6956fe03 = ()=>{
    const pattern = /\/helpcenter\/([^/?]*)/;
    const match = (0, $3wR8f.getRelativeBasePath)().match(pattern);
    return match && match[1] ? match[1] : undefined;
};

});
parcelRegister("748yq", function(module, exports) {
$parcel$export(module.exports, "USER_TYPING_DEBOUNCE_TIME", () => $41b7d3c8e8b81625$export$c5b77883736a2a29);
$parcel$export(module.exports, "SELECTED_SECTION_BORDER_WIDTH", () => $41b7d3c8e8b81625$export$57e6e5c7bcaced24);
$parcel$export(module.exports, "HTTP", () => $41b7d3c8e8b81625$export$ee9d07cf1658f1a7);
$parcel$export(module.exports, "SPINNER_DELAY", () => $41b7d3c8e8b81625$export$fb1d6648e4d00b79);
$parcel$export(module.exports, "ScreenName", () => $41b7d3c8e8b81625$export$acfa120f168ab3f8);
$parcel$export(module.exports, "RouteName", () => $41b7d3c8e8b81625$export$bfbea4d618559e4a);
$parcel$export(module.exports, "RoutePath", () => $41b7d3c8e8b81625$export$1b64c75ea7ed0865);
$parcel$export(module.exports, "ExperienceName", () => $41b7d3c8e8b81625$export$b881bd9f00ed8ed1);
$parcel$export(module.exports, "BrowserMetricViewName", () => $41b7d3c8e8b81625$export$d28ca3cbca982562);
$parcel$export(module.exports, "EngagementMessages", () => $41b7d3c8e8b81625$export$a0841dbe900de5cb);
$parcel$export(module.exports, "EngagementMessagesTarget", () => $41b7d3c8e8b81625$export$e396ee6d05cbdca4);
$parcel$export(module.exports, "PORTAL_PARENT_PRODUCT", () => $41b7d3c8e8b81625$export$218d9cffbbd32919);
$parcel$export(module.exports, "EMBEDDED_CONFLUENCE_SHIM_URL", () => $41b7d3c8e8b81625$export$4ef7b134a809306c);
$parcel$export(module.exports, "UNIFIED_HELP_CENTER_BASE_PATH", () => $41b7d3c8e8b81625$export$edfbc36787ce1acb);
$parcel$export(module.exports, "HELP_CENTERS_MANAGEMENT_BASE_PATH", () => $41b7d3c8e8b81625$export$f9a9f80d0023ea53);
$parcel$export(module.exports, "VA_ON_HC_CONVERSATION_PATH", () => $41b7d3c8e8b81625$export$640d6db9adfb1ee9);
$parcel$export(module.exports, "VA_ON_PORTAL_CONVERSATION_PATH", () => $41b7d3c8e8b81625$export$ea450ea04b439b84);
$parcel$export(module.exports, "DEFAULT_HELP_CENTER_TYPE", () => $41b7d3c8e8b81625$export$e2ce1da1cf52c1f4);
$parcel$export(module.exports, "DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY", () => $41b7d3c8e8b81625$export$c7ac69203430ee56);
// This file contains re-used UI view related constants
/* The amount of time to wait before doing some work that is triggered by user typing */ const $41b7d3c8e8b81625$export$c5b77883736a2a29 = 500;
const $41b7d3c8e8b81625$export$57e6e5c7bcaced24 = 1.5;
const $41b7d3c8e8b81625$export$ee9d07cf1658f1a7 = {
    BAD_REQUEST: 400,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    OFFLINE: 0,
    SERVER: 500,
    UNAUTHORIZED: 401
};
const $41b7d3c8e8b81625$export$fb1d6648e4d00b79 = 300;
var $41b7d3c8e8b81625$export$acfa120f168ab3f8 = /*#__PURE__*/ function(ScreenName) {
    ScreenName["HELP_CENTER"] = "portalHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_SIDEBAR"] = "portalCustomizeHelpCenter";
    ScreenName["HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeHelpCenterAnnouncement";
    ScreenName["HELP_CENTER_VSA_CHAT_SIDEBAR"] = "portalCustomizeHelpCenterVsaChatSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOOK_AND_FEEL_SIDEBAR"] = "portalCustomizeLookAndFeelSidebar";
    ScreenName["HELP_CENTER_CUSTOMIZE_LOGIN_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeLoginAnnouncementSidebar";
    ScreenName["HELP_CENTERS_MANAGEMENT"] = "helpCentersManagement";
    ScreenName["HELP_HUBS_MANAGEMENT"] = "helpHubsManagement";
    ScreenName["EDIT_HELP_CENTER"] = "helpCenterEditDetails";
    ScreenName["MANAGE_PROJECTS"] = "helpCenterManageProjects";
    ScreenName["MANAGE_PAGES"] = "helpCenterManagePages";
    ScreenName["FEEDBACK"] = "portalRequestFeedback";
    ScreenName["FEEDBACK_SUBMITTED"] = "portalRequestFeedbackCommentSubmitted";
    ScreenName["LOGIN"] = "portalLogin";
    ScreenName["LOGIN_PASSWORD"] = "portalLoginPassword";
    ScreenName["LOGIN_FORGOT_PASSWORD_CONFIRMATION"] = "portalLoginForgotPasswordConfirmation";
    ScreenName["LOGIN_SINGLE_SIGN_ON"] = "portalLoginSingleSignOn";
    ScreenName["LOGIN_SINGLE_SIGN_ON_CUSTOMER"] = "portalLoginSingleSignOnCustomer";
    ScreenName["LOGIN_ACTION"] = "portalLoginAction";
    ScreenName["LOGIN_ANNOUNCEMENT_CARD"] = "portalLoginAnnouncementCard";
    ScreenName["LOGIN_SSO_TEST_MODE_ERROR"] = "portalLoginSsoTestModeError";
    ScreenName["RESET_PASSWORD"] = "portalResetPassword";
    ScreenName["UNSUBSCRIBE"] = "portalUnsubscribeConfirmation";
    ScreenName["REQUEST_CREATE"] = "portalRequestCreate";
    ScreenName["REQUEST_DETAILS"] = "portalRequestDetails";
    ScreenName["REQUEST_LIST"] = "portalRequests";
    ScreenName["APPROVAL_LIST"] = "portalApprovals";
    ScreenName["KNOWLEDGE_CATEGORY"] = "categoryPage";
    ScreenName["REQUEST_CREATE_ANONYMOUS_SUCCESS"] = "requestCreateAnonymousSuccess";
    ScreenName["PORTAL_HOME"] = "singlePortal";
    ScreenName["REQUEST_GROUP_LIST"] = "requestGroupList";
    ScreenName["REQUEST_GROUP"] = "requestGroup";
    ScreenName["SIGNUP"] = "portalSignup";
    ScreenName["INVITED_SIGNUP"] = "portalAcceptInvite";
    ScreenName["COMPLETE_SIGNUP"] = "portalCompleteSignup";
    ScreenName["VERIFY_EMAIL"] = "portalVerifyEmail";
    ScreenName["COMPLETE_SIGNUP_TOKEN_EXPIRED"] = "portalCompleteSignupTokenExpired";
    ScreenName["COMPLETE_SIGNUP_TOKEN_INVALID"] = "portalCompleteSignupTokenInvalid";
    ScreenName["CHECK_EMAIL"] = "portalValidateEmail";
    ScreenName["KNOWLEDGE_ARTICLE"] = "knowledgeArticle";
    ScreenName["KNOWLEDGE_ALL_SEARCH_RESULTS"] = "knowledgeAllSearchResults";
    ScreenName["USER_PROFILE"] = "portalProfile";
    ScreenName["ADD_ANNOUNCEMENT_SIDEBAR"] = "addAnnouncementSidebar";
    ScreenName["REQUEST_LIST_CUSTOMIZE_SIDEBAR"] = "requestListCustomizeSidebar";
    ScreenName["REQUEST_APPROVAL"] = "requestApproval";
    ScreenName["PORTAL_REORDER_SETTINGS"] = "portalReorderSettings";
    ScreenName["ERROR_NOT_FOUND"] = "errorNotFound";
    ScreenName["PORTAL_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR"] = "portalCustomizeAnnouncementSidebar";
    ScreenName["VIEW_TOPIC"] = "viewTopic";
    ScreenName["VIEW_CUSTOM_PAGE"] = "viewCustomPage";
    ScreenName["EDIT_CUSTOM_PAGE"] = "editCustomPage";
    ScreenName["EDIT_TOPICS_LAYOUT"] = "editTopicsLayout";
    ScreenName["EDIT_TOPIC"] = "editTopic";
    ScreenName["PORTAL_ACCESS_FORBIDDEN"] = "PortalAccessForbidden";
    ScreenName["EMBED_REQUEST_CREATE"] = "embedRequestCreate";
    ScreenName["EMBED_LOGIN_SUCCESS"] = "embedLoginSuccess";
    ScreenName["EMBED_SINGLE_PORTAL"] = "embedSinglePortal";
    ScreenName["EMBED_KB_ARTICLE"] = "embedKBArticle";
    ScreenName["VIEW_HOMEPAGE"] = "portalHelpCenter";
    ScreenName["EDIT_HOMEPAGE"] = "editHomepage";
    ScreenName["EDIT_NEW_HELP_CENTER"] = "editNewHelpCenter";
    ScreenName["HELP_DESK_REPORTING"] = "helpDeskReporting";
    ScreenName["UNIFIED_HELP_HOME_PAGE"] = "unifiedHelpHomePage";
    ScreenName["UNIFIED_HELP_TEST_HARNESS"] = "unifiedHelpTestHarness";
    ScreenName["ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES"] = "addHelpContentKnowledgeResources";
    ScreenName["ADD_HELP_CONTENT_EXTERNAL_LINKS"] = "addHelpContentExternalLinks";
    ScreenName["HELP_CENTER_SEARCH"] = "PortalSearch";
    ScreenName["CONVERSATION_PAGE"] = "conversationPage";
    ScreenName["CONSENT_FORM_PAGE"] = "consentFormPage";
    ScreenName["AI_ANSWER"] = "aiAnswer";
    ScreenName["CSM_CONTACT_US"] = "csmContactUs";
    ScreenName["CSM_FOLDER"] = "csmFolder";
    ScreenName["CSM_REQUESTS_LIST"] = "csmRequestsList";
    ScreenName["CSM_REQUEST_DETAILS"] = "csmRequestDetails";
    ScreenName["CSM_VIEW_HOMEPAGE"] = "csmViewHomepage";
    ScreenName["EMBED_FEATURED_PORTALS"] = "embedFeaturedPortals";
    ScreenName["VIRTUAL_SERVICE_AGENT_HEADER"] = "virtualServiceAgentHeader";
    ScreenName["TOPIC_ITEM_HOMEPAGE"] = "topicItemHomepage";
    ScreenName["TOPIC_ITEM"] = "topicItem";
    ScreenName["OMNICHANNEL_CONVERSATION_SOURCES"] = "omnichannelConversationSources";
    ScreenName["SURVEY"] = "survey";
    return ScreenName;
}({});
var $41b7d3c8e8b81625$export$bfbea4d618559e4a = /*#__PURE__*/ function(RouteName) {
    RouteName["VIEW_CUSTOM_PAGE"] = "view-custom-page";
    RouteName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    RouteName["CSM_CONTACT_US_PAGE"] = "contact-us";
    RouteName["CSM_FOLDER_PAGE"] = "csm-folder";
    RouteName["CSM_REQUESTS_LIST_PAGE"] = "csm-requests-list";
    RouteName["CSM_REQUEST_DETAILS_PAGE"] = "csm-request-details";
    return RouteName;
}({});
var $41b7d3c8e8b81625$export$1b64c75ea7ed0865 = /*#__PURE__*/ function(RoutePath) {
    RoutePath["VIEW_CUSTOM_PAGE"] = "/page/:id/:title?";
    RoutePath["EDIT_CUSTOM_PAGE"] = "/page/edit/:id/:title?";
    RoutePath["CSM_CONTACT_US_PATH"] = "/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?";
    RoutePath["CSM_FOLDER_PATH"] = "/folder/:folderId";
    RoutePath["CSM_REQUESTS_LIST_PATH"] = "/user/requests";
    RoutePath["CSM_REQUEST_DETAILS_PATH"] = "/user/requests/:requestKey";
    return RoutePath;
}({});
var $41b7d3c8e8b81625$export$b881bd9f00ed8ed1 = /*#__PURE__*/ function(ExperienceName) {
    ExperienceName["REQUEST_CREATE"] = "request-create";
    ExperienceName["REQUEST_CREATE_CSM"] = "request-create-csm";
    ExperienceName["HELP_CENTER"] = "view-help-center";
    ExperienceName["CUSTOM_PAGE"] = "view-custom-page";
    ExperienceName["EDIT_CUSTOM_PAGE"] = "edit-custom-page";
    ExperienceName["HELP_CENTER_CSM"] = "view-help-center-csm";
    ExperienceName["FEATURED_AND_SORTED_PORTALS"] = "featured-and-sorted-portals";
    return ExperienceName;
}({});
var $41b7d3c8e8b81625$export$d28ca3cbca982562 = /*#__PURE__*/ function(BrowserMetricViewName) {
    BrowserMetricViewName["REQUEST_DETAIL_VIEW"] = "request-detail";
    BrowserMetricViewName["COMMENT_EDITOR_VIEW"] = "comment-editor";
    return BrowserMetricViewName;
}({});
var $41b7d3c8e8b81625$export$a0841dbe900de5cb = /*#__PURE__*/ function(EngagementMessages) {
    EngagementMessages["SIDEBAR_REFACTOR"] = "jsm-portal-sidebar-refactor";
    EngagementMessages["PORTAL_REORDER_EXPERIENCE"] = "jsm-portal-reordering-change-boarding";
    EngagementMessages["TOPICS"] = "jsm-customer-portal-topics";
    EngagementMessages["EXTERNAL_RESOURCES_IN_TOPICS"] = "external-resources-in-topics-pill";
    EngagementMessages["TOPICS_FOR_ALL"] = "topics-for-all-customisation";
    EngagementMessages["CHANGE_BOARD_CUSTOMISE_BUTTON"] = "jsm_admins_customization_with_button";
    EngagementMessages["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "jsm_admins_help_center_settings_button";
    EngagementMessages["CHANGE_BOARD_ADMINS_FREE_AND_STANDARD_EDITION"] = "changeboarding_jsm_admins_home_free_std";
    EngagementMessages["CHANGE_BOARD_ADMINS_SINGLE_PORTAL_SCREEN"] = "changeboarding_jsm_admins_singleportal";
    EngagementMessages["CHANGE_BOARD_ADMINS_PREMIUM_ENTERPRISE"] = "changeboarding_jsm_admins_premium_entr";
    EngagementMessages["ONBOARD_VA_REPORTING"] = "va-reporting-changeboarding-message";
    EngagementMessages["ONBOARD_VA_ON_HC"] = "va-on-hc-onboarding-message";
    EngagementMessages["CHANGE_BOARD_VISUAL_REFRESH"] = "jsm-visual-refresh-changeboarding";
    EngagementMessages["INCREASED_FLEXIBILITY_CHANGEBOARDING"] = "jsm-increased-flexibility-changeboarding";
    return EngagementMessages;
}({});
var $41b7d3c8e8b81625$export$e396ee6d05cbdca4 = /*#__PURE__*/ function(EngagementMessagesTarget) {
    EngagementMessagesTarget["CHANGE_BOARDING_SPOTLIGHT"] = "changeBoardingSpotLight";
    EngagementMessagesTarget["CHANGE_BOARDING_CUSTOMISE_BUTTON_SPOTLIGHT"] = "changeBoardingCustomiseButtonSpotLight";
    EngagementMessagesTarget["CHANGE_BOARD_HELP_CENTER_SETTINGS_BUTTON"] = "changeBoardHelpCenterSettingsButton";
    EngagementMessagesTarget["MUTLI_HC_CHANGE_BOARDING_SPOTLIGHT"] = "multihcDropdownChangeBoardingSpotlight";
    EngagementMessagesTarget["REPORTING_ONBOARDING_SPOTLIGHT"] = "reportingOnboardingSpotlight";
    EngagementMessagesTarget["VISUAL_REFRESH_CHANGEBOARDING_SPOTLIGHT"] = "visualRefreshChangeboardingSpotlight";
    return EngagementMessagesTarget;
}({});
const $41b7d3c8e8b81625$export$218d9cffbbd32919 = 'JSM-Portal';
const $41b7d3c8e8b81625$export$4ef7b134a809306c = '/plugins/servlet/servicedesk/customer/confluence/shim/';
const $41b7d3c8e8b81625$export$edfbc36787ce1acb = '/helpcenter/unified';
const $41b7d3c8e8b81625$export$f9a9f80d0023ea53 = '/helpcenter-management';
const $41b7d3c8e8b81625$export$640d6db9adfb1ee9 = '/conversation';
const $41b7d3c8e8b81625$export$ea450ea04b439b84 = '/portal/:portalId/conversation';
const $41b7d3c8e8b81625$export$e2ce1da1cf52c1f4 = 'BASIC';
const $41b7d3c8e8b81625$export$c7ac69203430ee56 = 'JSM_AND_JCS';

});

parcelRegister("bG6ob", function(module, exports) {
$parcel$export(module.exports, "RICH_TEXT_AREA_FIELD", () => $4c27b63f9754a045$export$706f525b497c4077);
$parcel$export(module.exports, "ENHANCED_RENDER_EXPERIENCE_FOR_KNOWLEDGE_ARTICLES", () => $4c27b63f9754a045$export$75614d0a3eb5eb71);
$parcel$export(module.exports, "REDIRECT_TO_LOGIN_PAGE_ON_INVALID_TOKEN_FOR_HOME_PAGE", () => $4c27b63f9754a045$export$a7cb1f93b93ef093);
$parcel$export(module.exports, "UNIFIED_HELP_REPORTING_PAGE", () => $4c27b63f9754a045$export$4111277bf9799237);
$parcel$export(module.exports, "UNIFIED_HELP_ADD_FILTER_FOR_CUSTOMER_ACCOUNTS", () => $4c27b63f9754a045$export$a1c6198e9bfea49a);
$parcel$export(module.exports, "BASIC_HC_CALLS_JIRA", () => $4c27b63f9754a045$export$bed2f83bab9fefc1);
$parcel$export(module.exports, "JSM_VIRTUAL_AGENT_ANONYMOUS_ACCESS", () => $4c27b63f9754a045$export$56132373c73141db);
$parcel$export(module.exports, "ENABLE_REACT_18_CREATEROOT", () => $4c27b63f9754a045$export$c59907e47c96b562);
$parcel$export(module.exports, "DONT_USE_HYDRATE_SSR", () => $4c27b63f9754a045$export$f1de11b7a101becf);
$parcel$export(module.exports, "HELP_CENTER_REFRESH_FLAG", () => $4c27b63f9754a045$export$cb73a351cc03929f);
$parcel$export(module.exports, "EMAIL_VERIFIED_SIGNAL_ON_CUSTOMERS_PAGE", () => $4c27b63f9754a045$export$660d24662c32371a);
$parcel$export(module.exports, "ENABLE_INCREASED_FLEXIBILITY", () => $4c27b63f9754a045$export$13d57865c16811e5);
$parcel$export(module.exports, "ENABLE_FOLLOWUP_QUESTIONS_ON_PORTAL", () => $4c27b63f9754a045$export$40e944519b773806);
$parcel$export(module.exports, "PROFORMA_ADVANCED_CONDITIONS_MAPPING", () => $4c27b63f9754a045$export$a9a13faf0986d8b5);
$parcel$export(module.exports, "PROFORMA_LOCAL_CONSUMPTION_PORTAL_CREATE", () => $4c27b63f9754a045$export$11856bc97b04d562);
$parcel$export(module.exports, "isEmailVerifiedSignalEnabled", () => $4c27b63f9754a045$export$d418c5a93f5a612e);
$parcel$export(module.exports, "isWrmOptimizationsEnabled", () => $4c27b63f9754a045$export$9d40c615991b681d);
$parcel$export(module.exports, "isRichTextAreaEnabled", () => $4c27b63f9754a045$export$ed104cfad45df81c);
$parcel$export(module.exports, "isEnhanceRenderExperienceForKnowledgeArticlesEnabled", () => $4c27b63f9754a045$export$787ffd123ce73274);
$parcel$export(module.exports, "isRedirectToLoginPageOnInvalidTokenForHomePage", () => $4c27b63f9754a045$export$98cff3536fe06a4);
$parcel$export(module.exports, "islooselyLazyJsErrorsToSentryEnabled", () => $4c27b63f9754a045$export$bf2b9f47d2bc9d17);
$parcel$export(module.exports, "isCustomThemingEnabled", () => $4c27b63f9754a045$export$dbb8ae3ec0512e12);
$parcel$export(module.exports, "isUnifiedHelpReportingPageEnabled", () => $4c27b63f9754a045$export$6c48cb93a07ea1fe);
$parcel$export(module.exports, "isProjectMappingInHelpCenterEnabled", () => $4c27b63f9754a045$export$6abd2200cda9c9c3);
$parcel$export(module.exports, "isUnifiedHelpAddFilterForCustomerAccounts", () => $4c27b63f9754a045$export$4fd1074ca1df827a);
$parcel$export(module.exports, "isFixRelayIdConflictInHelpCenter", () => $4c27b63f9754a045$export$65c1b2a8a68046aa);
$parcel$export(module.exports, "isFixRelayIdConflictForHelpObjectStoreEnabled", () => $4c27b63f9754a045$export$73a498f76aad8d2);
$parcel$export(module.exports, "isJsmCsMasterFlagEnabled", () => $4c27b63f9754a045$export$fd486b6069ca6b2);
$parcel$export(module.exports, "isSendRawHelpCenterTypeInAnalyticsEnabled", () => $4c27b63f9754a045$export$5dccb020251579a1);
$parcel$export(module.exports, "isCsmAccessControlSplitEnabled", () => $4c27b63f9754a045$export$27c460ed295f06bd);
$parcel$export(module.exports, "isAiWidgetTeam25Enabled", () => $4c27b63f9754a045$export$4b18120aa62097f1);
$parcel$export(module.exports, "isCsmPremiumSlaDisabledFlagEnabled", () => $4c27b63f9754a045$export$5f0f83b8f3fb9683);
$parcel$export(module.exports, "isUpdateArticlesLinkCsmEnabled", () => $4c27b63f9754a045$export$19229ae1da4441b0);
$parcel$export(module.exports, "isJcsprojectTypeM3Enabled", () => $4c27b63f9754a045$export$84646dccbb096e42);
$parcel$export(module.exports, "isCsmContactUsSectionEnabled", () => $4c27b63f9754a045$export$2ccd8035d1dcad87);
$parcel$export(module.exports, "isDefaultHCCallsJiraEnabled", () => $4c27b63f9754a045$export$5dea29067755e1b0);
$parcel$export(module.exports, "isCrossSiteConnieConnectionEnabled", () => $4c27b63f9754a045$export$8cfd0c7691c6e406);
$parcel$export(module.exports, "isKbArticlesSameTabRedirectionEnabled", () => $4c27b63f9754a045$export$6bf26299f5ce3574);
$parcel$export(module.exports, "isAdvancedCustomizationEditPageEnabled", () => $4c27b63f9754a045$export$3cf244665c3df4c1);
$parcel$export(module.exports, "isUseReact18CreateRootEnabled", () => $4c27b63f9754a045$export$34d3b9372e9be463);
$parcel$export(module.exports, "isReactHydrateDisabledInSSR", () => $4c27b63f9754a045$export$73e675d1db50bd4a);
$parcel$export(module.exports, "isVirtualAgentHeaderButtonEnabled", () => $4c27b63f9754a045$export$ae66df261c55d7b5);
$parcel$export(module.exports, "isCustomiseDropDownChangeBoardingEnabled", () => $4c27b63f9754a045$export$48982649dd732b1e);
$parcel$export(module.exports, "isFilterNullTraceIdFromGraphqlCallsEnabled", () => $4c27b63f9754a045$export$32ff46784ecd3055);
$parcel$export(module.exports, "isPremiumSLAErrorFilterEnabled", () => $4c27b63f9754a045$export$c7b4663aa3b178c3);
$parcel$export(module.exports, "isRetryMechanismTuningEnabled", () => $4c27b63f9754a045$export$484a220addce746c);
$parcel$export(module.exports, "isUseNewEditorCardProviderEnabled", () => $4c27b63f9754a045$export$f4ef25b2974427ab);
$parcel$export(module.exports, "isProformaTTVCUpdateMeasureEnabled", () => $4c27b63f9754a045$export$f1047a0c2946b9);
$parcel$export(module.exports, "isRemoveRedundantModelsCreateRequest", () => $4c27b63f9754a045$export$3e14f092c6d5897c);
$parcel$export(module.exports, "isVAOnHelpCenterGAEnabled", () => $4c27b63f9754a045$export$34d4b53afdfa223d);
$parcel$export(module.exports, "isConsumeLooselyLazyManifestInSSREnabled", () => $4c27b63f9754a045$export$a9795343511ea5c1);
$parcel$export(module.exports, "isMigrateToAnalyticsBridgeEnabled", () => $4c27b63f9754a045$export$6ef513d6f7be5888);
$parcel$export(module.exports, "isDefaultHCUsingGqlBrandingCalls", () => $4c27b63f9754a045$export$d10ba47ac271b5fb);
$parcel$export(module.exports, "isProjectMappingChangeBoardingEnabled", () => $4c27b63f9754a045$export$d0f3905affab5e5b);
$parcel$export(module.exports, "isUseHelpCenterRefresh", () => $4c27b63f9754a045$export$6c961d647d8a8d16);
$parcel$export(module.exports, "isDraftArticleSuggestionsEnabled", () => $4c27b63f9754a045$export$edadb203ac2a6c5c);
$parcel$export(module.exports, "isForgeCustomFieldsOnPortalViewEnabled", () => $4c27b63f9754a045$export$5998e12cd61e03e4);
$parcel$export(module.exports, "isOverridingFragmentsAnalyticsPropEnabled", () => $4c27b63f9754a045$export$f68ee857fdba507f);
$parcel$export(module.exports, "isForgeAppsInJSMPhase1Enabled", () => $4c27b63f9754a045$export$5c862b9f85068bd7);
$parcel$export(module.exports, "isUiModificationsSupportEnabled", () => $4c27b63f9754a045$export$2b4c3a76f069fbf5);
$parcel$export(module.exports, "isTextFieldSupportEnabled", () => $4c27b63f9754a045$export$97cf619b5c503901);
$parcel$export(module.exports, "isNumberFieldSupportEnabled", () => $4c27b63f9754a045$export$5377338157c93a4a);
$parcel$export(module.exports, "isDateTimeSupportEnabled", () => $4c27b63f9754a045$export$a3127feadc5f63ef);
$parcel$export(module.exports, "isDueDateSupportEnabled", () => $4c27b63f9754a045$export$ca4e8050793caa6);
$parcel$export(module.exports, "isTextAreaSupportEnabled", () => $4c27b63f9754a045$export$682d85ee096f07a9);
$parcel$export(module.exports, "isCascadingSelectSupportEnabled", () => $4c27b63f9754a045$export$b738c6acf33d051a);
$parcel$export(module.exports, "isLabelsSupportEnabled", () => $4c27b63f9754a045$export$fe4ccb1b2f4366aa);
$parcel$export(module.exports, "isUserPickerSupportEnabled", () => $4c27b63f9754a045$export$d16c700a701ab994);
$parcel$export(module.exports, "cascadingSelectDefaultValueSupportEnabled", () => $4c27b63f9754a045$export$5621e5c6b3b162df);
$parcel$export(module.exports, "isFollowupEnabledForPortal", () => $4c27b63f9754a045$export$cd1b5399e7ea70f2);
$parcel$export(module.exports, "isAiAnswer24HourTimeoutEnabled", () => $4c27b63f9754a045$export$6d74bd5fbad4512e);
$parcel$export(module.exports, "isSummaryFieldDebounced", () => $4c27b63f9754a045$export$e3771f1bb7cb73b4);
$parcel$export(module.exports, "isCustomPagesUiEnabled", () => $4c27b63f9754a045$export$7dd0505e68d032aa);
$parcel$export(module.exports, "isJiraFieldHandlingEnabled", () => $4c27b63f9754a045$export$7769d816882d3d99);
$parcel$export(module.exports, "isIncreasedFlexibilityEnabled", () => $4c27b63f9754a045$export$81ac031d5c9eadb5);
$parcel$export(module.exports, "isElementRendererSplitEnabled", () => $4c27b63f9754a045$export$6a665c3fef32cc75);
$parcel$export(module.exports, "isOmnichannelEnabledForHC", () => $4c27b63f9754a045$export$c008df611f489124);
$parcel$export(module.exports, "isOmnichannelCombinedAPIEnabledForHC", () => $4c27b63f9754a045$export$8eb90609f6b1f9d4);
$parcel$export(module.exports, "isClearRequestFormOnUnmount", () => $4c27b63f9754a045$export$e37eef2ad9537fcf);
$parcel$export(module.exports, "isItsmIssueRenamingEnabled", () => $4c27b63f9754a045$export$54d7baed1ffc6f83);
$parcel$export(module.exports, "isItsmProjectRenamingEnabled", () => $4c27b63f9754a045$export$bd371ef032bb50b4);
$parcel$export(module.exports, "isOmnichannelGreetingAPIEnabled", () => $4c27b63f9754a045$export$59c4c8d95bf1eefc);
$parcel$export(module.exports, "isIsomorphicDompurifyLibUsed", () => $4c27b63f9754a045$export$c5fadf0a3c794577);
$parcel$export(module.exports, "isOmnichannelSubscriptionErrorpageEnabled", () => $4c27b63f9754a045$export$492c9921026864bb);
$parcel$export(module.exports, "isOmnichannelAccessibilityFixesEnabled", () => $4c27b63f9754a045$export$ab4b6faa68780074);
$parcel$export(module.exports, "isThemeStatePassed", () => $4c27b63f9754a045$export$6587e77243044aac);
$parcel$export(module.exports, "isRequestCreateSkipDropdownInitialOptionsCallEnabled", () => $4c27b63f9754a045$export$4c0bb2a2e82edb28);
$parcel$export(module.exports, "isHideKbColumnEnabled", () => $4c27b63f9754a045$export$787e10895d9b5b56);
$parcel$export(module.exports, "isVsaSettingsPerformanceImprovementsEnabled", () => $4c27b63f9754a045$export$2803857b1fa00ccb);
$parcel$export(module.exports, "isTotalArticleCountEnabled", () => $4c27b63f9754a045$export$dbf6a8ec8de99792);
$parcel$export(module.exports, "isHideVsaEndpointsEnabled", () => $4c27b63f9754a045$export$5ee14c6848af11b8);
$parcel$export(module.exports, "isVsaAdoptionHeaderChatButtonEnabled", () => $4c27b63f9754a045$export$3c09ad5d9c354810);
$parcel$export(module.exports, "isColorDesignTokenEnabled", () => $4c27b63f9754a045$export$c7b1d6ed7aedb077);
$parcel$export(module.exports, "isVsaAdoptionPortalChatSideBarEnabled", () => $4c27b63f9754a045$export$4e32738a2a810c82);
$parcel$export(module.exports, "isJcsTwgEntitlementsIdToAriEnabled", () => $4c27b63f9754a045$export$5950094230c8f65b);
$parcel$export(module.exports, "isHubsEnabledInHelpCenter", () => $4c27b63f9754a045$export$b03e57f56b691f9d);
$parcel$export(module.exports, "isMultiSelectEnabled", () => $4c27b63f9754a045$export$3d9060e51ab7079e);
$parcel$export(module.exports, "isCortopv2ExperimentTGEnabled", () => $4c27b63f9754a045$export$334ea9c48e4dea3f);
$parcel$export(module.exports, "isCortopv2ExperimentEnabledWithExposure", () => $4c27b63f9754a045$export$dc2e212d295f2e92);
$parcel$export(module.exports, "isJsmSurveysCoreFeatureEnabled", () => $4c27b63f9754a045$export$a953b7b444ffe51e);
$parcel$export(module.exports, "isSurveyResponseBugFixEnabled", () => $4c27b63f9754a045$export$852def56fb1bd005);
$parcel$export(module.exports, "isJsmSurveysAdsBorderRadiusEnabled", () => $4c27b63f9754a045$export$e00bdec0f96534dd);
$parcel$export(module.exports, "isForgeFixUndefinedExtensionErrorEnalbled", () => $4c27b63f9754a045$export$1511e4c6da7511fd);
$parcel$export(module.exports, "isJsmPortalRovoIntegrationEnabled", () => $4c27b63f9754a045$export$c2b1b7c65c5a4a75);
$parcel$export(module.exports, "isDatePickerSupportEnabled", () => $4c27b63f9754a045$export$1df7079ae40c80e4);
$parcel$export(module.exports, "isSurveysRouteEnabled", () => $4c27b63f9754a045$export$3c40ce1901660201);
$parcel$export(module.exports, "isJsmPortalKeepRedirectionDestinationEnabled", () => $4c27b63f9754a045$export$3c14e337595a4049);
$parcel$export(module.exports, "isProformaAdvancedConditionsMappingEnabled", () => $4c27b63f9754a045$export$63bb23d2425a5457);
$parcel$export(module.exports, "isProformaLocalConsumptionPortalCreateEnabled", () => $4c27b63f9754a045$export$aaddf89a6dc7a70e);
$parcel$export(module.exports, "isRovoAgentsToolsConfigM2Enabled", () => $4c27b63f9754a045$export$ea979393725a029);
$parcel$export(module.exports, "ROVO_SERVICE_AGENT_PUBLISH_ON_CREATE", () => $4c27b63f9754a045$export$139a8bd6c6c64097);
$parcel$export(module.exports, "isRovoServiceAgentPublishOnCreateEnabled", () => $4c27b63f9754a045$export$1106ac1af51b69ff);
$parcel$export(module.exports, "isStudioGsnAndScenarioRefreshEnabled", () => $4c27b63f9754a045$export$a111e2ff03776b7c);
$parcel$export(module.exports, "isRequestListInfiniteScrollEnabled", () => $4c27b63f9754a045$export$46753c7d3f251473);
$parcel$export(module.exports, "isEmptyStringFilterOnFirstReqListLoadEnabled", () => $4c27b63f9754a045$export$71262ddd43589494);
$parcel$export(module.exports, "isApprovalListInfiniteScrollEnabled", () => $4c27b63f9754a045$export$e86f67505602f2f);
$parcel$export(module.exports, "isFooterInlineSvgIconEnabled", () => $4c27b63f9754a045$export$ca26eabf79297fb3);
$parcel$export(module.exports, "isFixFormrendererDatetimepickerLocaleEnabled", () => $4c27b63f9754a045$export$fece3aef911e6cf5);
$parcel$export(module.exports, "isJsdFooterOutsideMainLandmarkEnabled", () => $4c27b63f9754a045$export$30c480313fbada45);
/**
 * Define feature flag here as constants.
 *
 * export const KB_ENHANCEMENTS = 'jsd.px.kb-enhancements';
 *
 * Use them in react components.
 * import { KB_ENHANCEMENTS } from '@helpcenter/feature-flags';
 * import { FeatureFlag } from 'view/common/feature-flag';
 *
 * <FeatureFlag name={KB_ENHANCEMENTS}>
 *  I will be shown in true :-)
 * </FeatureFlag>
 *
 * ========== NOTE ===================
 * BE CAREFUL ADDING FEATURE FLAGS, IF YOU RENAME THEM IT WILL CHANGE THE ANALYTIC CONTEXT
 * NAME AND NO LONGER SEND THE SAME CONTEXT ATTRIBUTE NAME.
 * ===================================
 */ 
var $6bGmX = parcelRequire("6bGmX");
const $4c27b63f9754a045$export$706f525b497c4077 = 'jsd-use-adf-default-value-for-textarea';
const $4c27b63f9754a045$export$75614d0a3eb5eb71 = 'jsm-enhanced-render-exp-for-knowledge-articles';
const $4c27b63f9754a045$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB = 'make-kb-articles-open-in-same-tab';
const $4c27b63f9754a045$export$a7cb1f93b93ef093 = 'redirect_to_login_for_hc_home_page_un_authorized';
const $4c27b63f9754a045$export$4111277bf9799237 = 'help_center_reporting_route';
const $4c27b63f9754a045$export$a1c6198e9bfea49a = 'unified-help-add-filter-for-customer-accounts';
const $4c27b63f9754a045$export$bed2f83bab9fefc1 = 'basic_hc_calls_jira';
const $4c27b63f9754a045$var$JCSM_CS_MASTER_FLAG = 'jcs_master_flag';
const $4c27b63f9754a045$var$CSM_ACCESS_CONTROL_SPLIT = 'csm_access_control_split_take2';
const $4c27b63f9754a045$var$CSM_PREMIUM_SLA_DISABLED_FLAG = 'jsm_csm_premium_sla_config';
const $4c27b63f9754a045$var$AI_WIDGET_TEAM25 = 'berry-5094-ai-widget-support-website-team25';
const $4c27b63f9754a045$var$CSM_CONTACT_US_SECTION = 'jcs_contact_us_section';
const $4c27b63f9754a045$var$SEND_RAW_HELP_CENTER_TYPE_IN_ANALYTICS = 'help-center-fix-type-in-analytics';
const $4c27b63f9754a045$export$56132373c73141db = 'anonymous_virtual_agent_access';
const $4c27b63f9754a045$export$c59907e47c96b562 = 'enable_react-18';
const $4c27b63f9754a045$export$f1de11b7a101becf = 'dont_use_hydrate_in_portal_ssr';
const $4c27b63f9754a045$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER = 'fix_relay_id_conflict_in_help_center';
const $4c27b63f9754a045$var$FIX_RELAY_ID_CONFLICT_FOR_HELP_OBJECT_STORE = 'fix_relay_id_conflict_for_help_object_store';
const $4c27b63f9754a045$var$ADVANCED_HELP_CENTER_CUSTOMIZATION_EDIT_PAGE = 'advanced_help_center_customization_edit_page';
const $4c27b63f9754a045$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT = 'tuning_model_retries';
const $4c27b63f9754a045$var$FILTER_PREMIUM_SLA_ERRORS = 'filter_premium_sla_errors';
const $4c27b63f9754a045$var$CUSTOMISATION_BUTTON_CHANGE_BOARDING = 'enable_customisation_button_change_boarding';
const $4c27b63f9754a045$var$PROJECT_MAPPING_ENABLED_IN_MULTI_HC = 'enable_project_mapping_for_help_center';
const $4c27b63f9754a045$var$FILTER_NULL_TRACE_ID_FROM_GRAPHQL_CALLS = 'filter_null_trace_id_from_graphql_calls';
const $4c27b63f9754a045$var$USE_NEW_EDITOR_CARD_PROVIDER = 'use_new_editor_card_provider';
const $4c27b63f9754a045$var$ENABLE_CROSS_SITE_CONFLUENCE = 'enable-cross-site-confluence';
const $4c27b63f9754a045$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED = 'measure_proforma_ttvc_impact';
const $4c27b63f9754a045$var$REMOVE_CREATE_REQUEST_REDUNDANT_MODELS = 'jsm-create-request-redundant-models-fe';
const $4c27b63f9754a045$var$CONSUME_LOOSELY_LAZY_MANIFEST_IN_SSR = 'consume_loosely_lazy_manifest_in_ssr';
const $4c27b63f9754a045$var$DEFAULT_HC_USING_GQL_BRANDING = 'default_hc_using_gql_branding';
const $4c27b63f9754a045$var$PROJECT_MAPPING_CHANGE_BOARDING = 'project_mapping_change_boarding';
const $4c27b63f9754a045$export$cb73a351cc03929f = 'enable_increased_flexibility'; // TODO: using same key as increased flexibility for bundle release
const $4c27b63f9754a045$var$ENABLE_FORGE_APPS_IN_JSM_PHASE_1 = 'enable_forge_apps_in_jsm_layout_builder_phase_1';
const $4c27b63f9754a045$export$660d24662c32371a = 'sptn-1697-email-verified-signal-on-customers-page';
const $4c27b63f9754a045$var$SUMMARY_FIELD_DEBOUNCED = 'summary-field-debounced';
const $4c27b63f9754a045$var$HELP_CENTER_CUSTOM_PAGES = 'help_center_custom_pages_ui';
const $4c27b63f9754a045$export$13d57865c16811e5 = 'enable_increased_flexibility';
const $4c27b63f9754a045$export$40e944519b773806 = 'enable_followup_questions_on_omni_channel_portal';
const $4c27b63f9754a045$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL = 'request_create_dropdown_initial_options_call';
const $4c27b63f9754a045$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN = 'hc_vsa_settings_hide_kb_article_column';
const $4c27b63f9754a045$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS = 'hc_vsa_settings_performance_improvements';
const $4c27b63f9754a045$var$COLOR_DESIGN_TOKEN_ADOPTION = 'add_color_design_token_support_into_help_center';
const $4c27b63f9754a045$var$TOTAL_ARTICLE_COUNT = 'hc_show_kb_total_article_count';
const $4c27b63f9754a045$var$VSA_ADOPTION_TOUCHPOINT_HELP_CENTER = 'vsa-adoption-touchpoint-help-center';
const $4c27b63f9754a045$var$HIDE_VSA_ENDPOINTS = 'hide_vsa_endpoints';
const $4c27b63f9754a045$var$VSA_ADOPTION_HEADER_CHAT_BUTTON = 'vsa-adoption-header-chat-button';
const $4c27b63f9754a045$var$ENABLE_JIRA_FIELD_HANDLING = 'enable_jira_field_handling_in_omnichannel';
const $4c27b63f9754a045$var$VSA_ADOPTION_CHAT_SIDE_BAR = 'vsa-adoption-portal-chat-side-bar';
const $4c27b63f9754a045$var$ENABLE_HUBS_IN_HELP_CENTER = 'enable-hubs-in-help-center';
const $4c27b63f9754a045$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT = 'ditto_uim_jsm_multi_select_support';
const $4c27b63f9754a045$var$CORTOPV2_EXPERIMENT = 'jsmgrowth-177_jsm_cortopv2';
const $4c27b63f9754a045$var$CORTOPV2_EXPERIMENT_TG = 'jsmgrowth-177_jsm_cortopv2_tg';
const $4c27b63f9754a045$var$JSM_FORGE_PORTAL_FIX_UNDEFINED_EXTENSION_ERROR = 'jsm_forge_portal_fix_undefined_extension_error';
const $4c27b63f9754a045$var$JSM_PORTAL_ROVO_INTEGRATION = 'jsm_portal_rovo_integration';
const $4c27b63f9754a045$var$JSM_DATEPICKER_FIELD_SUPPORT = 'ditto_uim_jsm_datepicker_field_support';
const $4c27b63f9754a045$var$JSM_SURVEYS_GATE = 'jsm_surveys_gate';
const $4c27b63f9754a045$export$a9a13faf0986d8b5 = 'proforma_advanced_conditions_mapping';
const $4c27b63f9754a045$export$11856bc97b04d562 = 'proforma_local_consumption_portal_create';
const $4c27b63f9754a045$var$JSM_PORTAL_KEEP_REDIRECTION_DESTINATION = 'jsdcloud_15510_portal_keep_redirection_destination';
const $4c27b63f9754a045$var$JSM_SURVEYS_CORE_FEATURE = 'jsm_surveys_core_feature';
const $4c27b63f9754a045$var$JSM_SURVEYS_REMOVE_HIDDEN_SECTION_RESPONSES = 'phx-3898_remove_hidden_section_responses';
const $4c27b63f9754a045$var$JSM_SURVEYS_ADS_BORDER_RADIUS = 'phx_3949_ads_border_radius_update';
const $4c27b63f9754a045$var$ROVO_AGENTS_TOOLS_CONFIG_M2 = 'rovo_agents_tools_config_m2';
const $4c27b63f9754a045$var$REQUEST_LIST_INFINITE_SCROLL = 'portal-6922-request-list-jsis-pagination';
const $4c27b63f9754a045$var$APPROVAL_LIST_INFINITE_SCROLL = 'portal-approval-list-jsis-pagination';
const $4c27b63f9754a045$var$EMPTY_STRING_FILTER_ON_FIRST_REQ_LIST_LOAD = 'empty_string_filter_on_first_req_list_load';
const $4c27b63f9754a045$var$FIX_FORMRENDERER_DATETIMEPICKER_LOCALE = 'fix_formrenderer_datetimepicker_locale';
const $4c27b63f9754a045$export$d418c5a93f5a612e = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$660d24662c32371a);
};
const $4c27b63f9754a045$export$9d40c615991b681d = ()=>true;
const $4c27b63f9754a045$export$ed104cfad45df81c = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$export$706f525b497c4077);
const $4c27b63f9754a045$export$787ffd123ce73274 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$export$75614d0a3eb5eb71);
const $4c27b63f9754a045$export$98cff3536fe06a4 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$export$a7cb1f93b93ef093);
const $4c27b63f9754a045$export$bf2b9f47d2bc9d17 = ()=>(0, $6bGmX.default).checkGate('throw_lazy_error_boundary_js_errors_to_sentry');
const $4c27b63f9754a045$export$dbb8ae3ec0512e12 = ()=>false;
const $4c27b63f9754a045$export$6c48cb93a07ea1fe = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$4111277bf9799237);
};
const $4c27b63f9754a045$export$6abd2200cda9c9c3 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$PROJECT_MAPPING_ENABLED_IN_MULTI_HC);
};
const $4c27b63f9754a045$export$4fd1074ca1df827a = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$a1c6198e9bfea49a);
};
const $4c27b63f9754a045$export$65c1b2a8a68046aa = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$FIX_RELAY_ID_CONFLICT_IN_HELP_CENTER);
};
const $4c27b63f9754a045$export$73a498f76aad8d2 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$FIX_RELAY_ID_CONFLICT_FOR_HELP_OBJECT_STORE);
};
const $4c27b63f9754a045$export$fd486b6069ca6b2 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JCSM_CS_MASTER_FLAG);
};
const $4c27b63f9754a045$export$5dccb020251579a1 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$SEND_RAW_HELP_CENTER_TYPE_IN_ANALYTICS);
};
const $4c27b63f9754a045$export$27c460ed295f06bd = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$CSM_ACCESS_CONTROL_SPLIT);
};
const $4c27b63f9754a045$export$4b18120aa62097f1 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$AI_WIDGET_TEAM25);
};
const $4c27b63f9754a045$export$5f0f83b8f3fb9683 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$CSM_PREMIUM_SLA_DISABLED_FLAG);
};
const $4c27b63f9754a045$export$19229ae1da4441b0 = ()=>{
    return (0, $6bGmX.default).checkGate('update_articles_links_csm');
};
const $4c27b63f9754a045$export$84646dccbb096e42 = ()=>{
    return (0, $6bGmX.default).checkGate('jcs_project_type_m3');
};
const $4c27b63f9754a045$export$2ccd8035d1dcad87 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$CSM_CONTACT_US_SECTION);
};
const $4c27b63f9754a045$export$5dea29067755e1b0 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$bed2f83bab9fefc1);
};
const $4c27b63f9754a045$export$8cfd0c7691c6e406 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ENABLE_CROSS_SITE_CONFLUENCE);
};
const $4c27b63f9754a045$export$6bf26299f5ce3574 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ENABLE_KB_ARTICLES_OPEN_IN_SAME_TAB);
};
const $4c27b63f9754a045$export$3cf244665c3df4c1 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ADVANCED_HELP_CENTER_CUSTOMIZATION_EDIT_PAGE);
};
const $4c27b63f9754a045$export$34d3b9372e9be463 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$c59907e47c96b562);
};
const $4c27b63f9754a045$export$73e675d1db50bd4a = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$f1de11b7a101becf);
};
const $4c27b63f9754a045$export$ae66df261c55d7b5 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$VSA_ADOPTION_TOUCHPOINT_HELP_CENTER);
};
const $4c27b63f9754a045$export$48982649dd732b1e = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$CUSTOMISATION_BUTTON_CHANGE_BOARDING);
};
const $4c27b63f9754a045$export$32ff46784ecd3055 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$FILTER_NULL_TRACE_ID_FROM_GRAPHQL_CALLS);
};
const $4c27b63f9754a045$export$c7b4663aa3b178c3 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$FILTER_PREMIUM_SLA_ERRORS);
};
const $4c27b63f9754a045$export$484a220addce746c = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$TUNING_RETRY_MECHANISM_FOR_MODELS_ENDPOINT);
};
const $4c27b63f9754a045$export$f4ef25b2974427ab = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$USE_NEW_EDITOR_CARD_PROVIDER);
};
const $4c27b63f9754a045$export$f1047a0c2946b9 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$PROFORMA_TTVC_UPDATE_PACKAGE_ENABLED);
};
const $4c27b63f9754a045$export$3e14f092c6d5897c = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$REMOVE_CREATE_REQUEST_REDUNDANT_MODELS);
};
const $4c27b63f9754a045$export$34d4b53afdfa223d = ()=>{
    return (0, $6bGmX.default).checkGate('va_on_help_center_ga');
};
const $4c27b63f9754a045$export$a9795343511ea5c1 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$CONSUME_LOOSELY_LAZY_MANIFEST_IN_SSR);
};
const $4c27b63f9754a045$export$6ef513d6f7be5888 = ()=>{
    return (0, $6bGmX.default).checkGate('jsm-portal-migrate-to-analytics-bridge');
};
const $4c27b63f9754a045$export$d10ba47ac271b5fb = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$DEFAULT_HC_USING_GQL_BRANDING);
};
const $4c27b63f9754a045$export$d0f3905affab5e5b = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$PROJECT_MAPPING_CHANGE_BOARDING);
};
const $4c27b63f9754a045$export$6c961d647d8a8d16 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$cb73a351cc03929f);
};
const $4c27b63f9754a045$export$edadb203ac2a6c5c = ()=>{
    return (0, $6bGmX.default).checkGate('ai-answer-using-draft-article');
};
const $4c27b63f9754a045$export$5998e12cd61e03e4 = ()=>(0, $6bGmX.default).checkGate('forge_custom_fields_on_jsm_portal_view');
const $4c27b63f9754a045$export$f68ee857fdba507f = ()=>(0, $6bGmX.default).checkGate('is_overriding_fragments_analytics_prop');
const $4c27b63f9754a045$export$5c862b9f85068bd7 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ENABLE_FORGE_APPS_IN_JSM_PHASE_1);
const $4c27b63f9754a045$export$2b4c3a76f069fbf5 = ()=>(0, $6bGmX.default).checkGate('ditto_uim_-_jsm_support_main');
const $4c27b63f9754a045$export$97cf619b5c503901 = ()=>{
    return (0, $6bGmX.default).checkGate('uim_jsm_textfield_support');
};
const $4c27b63f9754a045$export$5377338157c93a4a = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_number_field_support');
};
const $4c27b63f9754a045$export$a3127feadc5f63ef = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_datetime_field_support');
};
const $4c27b63f9754a045$export$ca4e8050793caa6 = ()=>{
    return (0, $6bGmX.default).checkGate('uim_jsm_duedate_support');
};
const $4c27b63f9754a045$export$682d85ee096f07a9 = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_textarea_support');
};
const $4c27b63f9754a045$export$b738c6acf33d051a = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_cascading_select_support');
};
const $4c27b63f9754a045$export$fe4ccb1b2f4366aa = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_labels_support');
};
const $4c27b63f9754a045$export$d16c700a701ab994 = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_user_picker_support');
};
const $4c27b63f9754a045$export$5621e5c6b3b162df = ()=>{
    return (0, $6bGmX.default).checkGate('ditto_uim_jsm_cascading_default_value_support');
};
const $4c27b63f9754a045$export$cd1b5399e7ea70f2 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$40e944519b773806);
};
const $4c27b63f9754a045$export$6d74bd5fbad4512e = ()=>{
    return (0, $6bGmX.default).checkGate('ai_answer_default_timeout_to_24_hours');
};
const $4c27b63f9754a045$export$e3771f1bb7cb73b4 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$SUMMARY_FIELD_DEBOUNCED);
};
const $4c27b63f9754a045$export$7dd0505e68d032aa = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$HELP_CENTER_CUSTOM_PAGES);
};
const $4c27b63f9754a045$export$7769d816882d3d99 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ENABLE_JIRA_FIELD_HANDLING);
};
const $4c27b63f9754a045$export$81ac031d5c9eadb5 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$13d57865c16811e5);
};
const $4c27b63f9754a045$export$6a665c3fef32cc75 = ()=>{
    return (0, $6bGmX.default).checkGate('enable_element_renderer_split');
};
const $4c27b63f9754a045$export$c008df611f489124 = ()=>{
    return (0, $6bGmX.default).checkGate('enable_omni_channel_for_helpcenter');
};
const $4c27b63f9754a045$export$8eb90609f6b1f9d4 = ()=>{
    return (0, $6bGmX.default).checkGate('enable_combinedapi_flow_in_helpcenter');
};
const $4c27b63f9754a045$export$e37eef2ad9537fcf = ()=>{
    return (0, $6bGmX.default).checkGate('clear_request_form_on_unmount');
};
const $4c27b63f9754a045$export$54d7baed1ffc6f83 = ()=>{
    return (0, $6bGmX.default).checkGate('itsm-issue-renaming');
};
const $4c27b63f9754a045$export$bd371ef032bb50b4 = ()=>{
    return (0, $6bGmX.default).checkGate('itsm-project-renaming');
};
const $4c27b63f9754a045$export$59c4c8d95bf1eefc = ()=>{
    return (0, $6bGmX.default).checkGate('jsm_chat_orchestrator_greeting_api_enabled');
};
const $4c27b63f9754a045$export$c5fadf0a3c794577 = ()=>{
    return (0, $6bGmX.default).checkGate('isomorphic-dompurify-enabled');
};
const $4c27b63f9754a045$export$492c9921026864bb = ()=>{
    return (0, $6bGmX.default).checkGate('enable_omnichannel_subscription_error_page');
};
const $4c27b63f9754a045$export$ab4b6faa68780074 = ()=>{
    return (0, $6bGmX.default).checkGate('helpcenter_omnichannel_accessibility_fixes');
};
const $4c27b63f9754a045$export$6587e77243044aac = ()=>{
    return (0, $6bGmX.default).checkGate('pass-theme-state-in-ep');
};
const $4c27b63f9754a045$export$4c0bb2a2e82edb28 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$REQUEST_CREATE_DROPDOWN_INITIAL_OPTIONS_CALL);
};
const $4c27b63f9754a045$export$787e10895d9b5b56 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$HIDE_KB_COLUMN_PROJECT_BREAKDOWN);
};
const $4c27b63f9754a045$export$2803857b1fa00ccb = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$VSA_SETTINGS_PERFORMANCE_IMPROVEMENTS);
};
const $4c27b63f9754a045$export$dbf6a8ec8de99792 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$TOTAL_ARTICLE_COUNT);
};
const $4c27b63f9754a045$export$5ee14c6848af11b8 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$HIDE_VSA_ENDPOINTS);
};
const $4c27b63f9754a045$export$3c09ad5d9c354810 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$VSA_ADOPTION_HEADER_CHAT_BUTTON);
};
const $4c27b63f9754a045$export$c7b1d6ed7aedb077 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$COLOR_DESIGN_TOKEN_ADOPTION);
};
const $4c27b63f9754a045$export$4e32738a2a810c82 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$VSA_ADOPTION_CHAT_SIDE_BAR);
};
const $4c27b63f9754a045$export$5950094230c8f65b = ()=>{
    return (0, $6bGmX.default).checkGate('jcs_twg_entitlements_id_to_ari');
};
const $4c27b63f9754a045$export$b03e57f56b691f9d = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ENABLE_HUBS_IN_HELP_CENTER);
};
const $4c27b63f9754a045$export$3d9060e51ab7079e = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ENABLE_MULTI_SELECT_CF_UIM_SUPPORT);
};
const $4c27b63f9754a045$export$334ea9c48e4dea3f = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$CORTOPV2_EXPERIMENT_TG);
};
const $4c27b63f9754a045$export$dc2e212d295f2e92 = (fireGateExposure = false)=>{
    return (0, $6bGmX.default).getExperimentValue($4c27b63f9754a045$var$CORTOPV2_EXPERIMENT, 'isEnabled', false, {
        fireExperimentExposure: fireGateExposure
    });
};
const $4c27b63f9754a045$export$a953b7b444ffe51e = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_SURVEYS_CORE_FEATURE);
};
const $4c27b63f9754a045$export$852def56fb1bd005 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_SURVEYS_REMOVE_HIDDEN_SECTION_RESPONSES);
};
const $4c27b63f9754a045$export$e00bdec0f96534dd = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_SURVEYS_ADS_BORDER_RADIUS);
};
const $4c27b63f9754a045$export$1511e4c6da7511fd = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_FORGE_PORTAL_FIX_UNDEFINED_EXTENSION_ERROR);
};
const $4c27b63f9754a045$export$c2b1b7c65c5a4a75 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_PORTAL_ROVO_INTEGRATION);
};
const $4c27b63f9754a045$export$1df7079ae40c80e4 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_DATEPICKER_FIELD_SUPPORT);
};
const $4c27b63f9754a045$export$3c40ce1901660201 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_SURVEYS_GATE);
const $4c27b63f9754a045$export$3c14e337595a4049 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSM_PORTAL_KEEP_REDIRECTION_DESTINATION);
};
const $4c27b63f9754a045$export$63bb23d2425a5457 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$a9a13faf0986d8b5);
};
const $4c27b63f9754a045$export$aaddf89a6dc7a70e = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$11856bc97b04d562);
};
const $4c27b63f9754a045$export$ea979393725a029 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$ROVO_AGENTS_TOOLS_CONFIG_M2);
};
const $4c27b63f9754a045$export$139a8bd6c6c64097 = 'rovo-service-agent-publish-on-create';
const $4c27b63f9754a045$export$1106ac1af51b69ff = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$export$139a8bd6c6c64097);
};
const $4c27b63f9754a045$export$a111e2ff03776b7c = ()=>{
    return (0, $6bGmX.default).checkGate('studio-gsn-and-scenario-refresh');
};
const $4c27b63f9754a045$export$46753c7d3f251473 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$REQUEST_LIST_INFINITE_SCROLL);
};
const $4c27b63f9754a045$export$71262ddd43589494 = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$EMPTY_STRING_FILTER_ON_FIRST_REQ_LIST_LOAD);
};
const $4c27b63f9754a045$export$e86f67505602f2f = ()=>{
    return (0, $6bGmX.default).checkGate($4c27b63f9754a045$var$APPROVAL_LIST_INFINITE_SCROLL);
};
const $4c27b63f9754a045$var$FOOTER_INLINE_SVG_ICON = 'jsd-footer-inline-svg-icon';
const $4c27b63f9754a045$export$ca26eabf79297fb3 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$var$FOOTER_INLINE_SVG_ICON);
const $4c27b63f9754a045$export$fece3aef911e6cf5 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$var$FIX_FORMRENDERER_DATETIMEPICKER_LOCALE);
const $4c27b63f9754a045$var$JSD_FOOTER_OUTSIDE_MAIN_LANDMARK = 'jsd_footer_outside_main_landmark';
const $4c27b63f9754a045$export$30c480313fbada45 = ()=>(0, $6bGmX.default).checkGate($4c27b63f9754a045$var$JSD_FOOTER_OUTSIDE_MAIN_LANDMARK);

});

parcelRegister("3wR8f", function(module, exports) {
$parcel$export(module.exports, "contextPath", () => $94aaf7bb6cef3dd3$export$bcb673b8a0b7ff6e);
$parcel$export(module.exports, "getRelativeBasePath", () => $94aaf7bb6cef3dd3$export$8bbd42317ee66540);
$parcel$export(module.exports, "getBasePath", () => $94aaf7bb6cef3dd3$export$9099264ed9b1c55a);
$parcel$export(module.exports, "getBaseName", () => $94aaf7bb6cef3dd3$export$a8b0425edf52c70e);
$parcel$export(module.exports, "historyObservable", () => $94aaf7bb6cef3dd3$export$a43a1132874d88e3);
$parcel$export(module.exports, "default", () => $94aaf7bb6cef3dd3$export$2e2bcd8739ae039);

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("l8iRu");
var $g2zI4 = parcelRequire("g2zI4");

var $bRLBS = parcelRequire("bRLBS");

var $1CB66 = parcelRequire("1CB66");

var $ebpTf = parcelRequire("ebpTf");
const $94aaf7bb6cef3dd3$export$bcb673b8a0b7ff6e = $bRLBS.getMeta('context-path') || '';
const $94aaf7bb6cef3dd3$export$8bbd42317ee66540 = ()=>{
    if ((0, $ebpTf.getEnv)().hasOwnProperty('relativeBaseUrl')) return (0, $ebpTf.getEnv)().relativeBaseUrl;
    return '/servicedesk/customer';
};
const $94aaf7bb6cef3dd3$export$9099264ed9b1c55a = ()=>{
    if ((0, $ebpTf.getEnv)().hasOwnProperty('baseUrl')) return (0, $ebpTf.getEnv)().baseUrl;
    return `${$94aaf7bb6cef3dd3$export$bcb673b8a0b7ff6e}${$94aaf7bb6cef3dd3$export$8bbd42317ee66540()}`;
};
const $94aaf7bb6cef3dd3$export$e75259171a9ba0d5 = (url)=>{
    return url.replace('/servicedesk/customer', (0, $ebpTf.getEnv)().relativeBaseUrl);
};
const $94aaf7bb6cef3dd3$export$c4e6c35f2dffd087 = (url)=>{
    return url.replace((0, $ebpTf.getEnv)().relativeBaseUrl, '/servicedesk/customer');
};
const $94aaf7bb6cef3dd3$export$a8b0425edf52c70e = ()=>`${$94aaf7bb6cef3dd3$export$bcb673b8a0b7ff6e}${$94aaf7bb6cef3dd3$export$8bbd42317ee66540()}`;
const $94aaf7bb6cef3dd3$var$history = (0, $1CB66.default).isRunningInSnapvmRuntime() ? (0, $g2zI4.createMemoryHistory)({
    initialEntries: [
        $94aaf7bb6cef3dd3$export$a8b0425edf52c70e()
    ]
}) : (0, $g2zI4.createBrowserHistory)({
    basename: $94aaf7bb6cef3dd3$export$a8b0425edf52c70e()
});
const $94aaf7bb6cef3dd3$export$a43a1132874d88e3 = (0, $b0T1M.Observable).create((observer)=>{
    $94aaf7bb6cef3dd3$var$history.listen((location, action)=>observer.next({
            location: location,
            action: action
        }));
});
var $94aaf7bb6cef3dd3$export$2e2bcd8739ae039 = $94aaf7bb6cef3dd3$var$history;

});
parcelRegister("b0T1M", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $804a6121fbca4501$export$77cea355fa80b5f4, (v) => $804a6121fbca4501$export$77cea355fa80b5f4 = v);
var $804a6121fbca4501$export$77cea355fa80b5f4;
"use strict";

var $jYFjc = parcelRequire("jYFjc");

var $1AYVx = parcelRequire("1AYVx");

var $jkDT5 = parcelRequire("jkDT5");

var $aXt93 = parcelRequire("aXt93");
/**
 * A representation of any set of values over any amount of time. This is the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */ var $804a6121fbca4501$var$Observable = function() {
    /**
     * @constructor
     * @param {Function} subscribe the function that is called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */ function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */ Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    /**
     * Invokes an execution of an Observable and registers Observer handlers for notifications it will emit.
     *
     * <span class="informal">Use it when you have all these Observables, but still nothing is happening.</span>
     *
     * `subscribe` is not a regular operator, but a method that calls Observable's internal `subscribe` function. It
     * might be for example a function that you passed to a {@link create} static factory, but most of the time it is
     * a library implementation, which defines what and when will be emitted by an Observable. This means that calling
     * `subscribe` is actually the moment when Observable starts its work, not when it is created, as it is often
     * thought.
     *
     * Apart from starting the execution of an Observable, this method allows you to listen for values
     * that an Observable emits, as well as for when it completes or errors. You can achieve this in two
     * following ways.
     *
     * The first way is creating an object that implements {@link Observer} interface. It should have methods
     * defined by that interface, but note that it should be just a regular JavaScript object, which you can create
     * yourself in any way you want (ES6 class, classic function constructor, object literal etc.). In particular do
     * not attempt to use any RxJS implementation details to create Observers - you don't need them. Remember also
     * that your object does not have to implement all methods. If you find yourself creating a method that doesn't
     * do anything, you can simply omit it. Note however, that if `error` method is not provided, all errors will
     * be left uncaught.
     *
     * The second way is to give up on Observer object altogether and simply provide callback functions in place of its methods.
     * This means you can provide three functions as arguments to `subscribe`, where first function is equivalent
     * of a `next` method, second of an `error` method and third of a `complete` method. Just as in case of Observer,
     * if you do not need to listen for something, you can omit a function, preferably by passing `undefined` or `null`,
     * since `subscribe` recognizes these functions by where they were placed in function call. When it comes
     * to `error` function, just as before, if not provided, errors emitted by an Observable will be thrown.
     *
     * Whatever style of calling `subscribe` you use, in both cases it returns a Subscription object.
     * This object allows you to call `unsubscribe` on it, which in turn will stop work that an Observable does and will clean
     * up all resources that an Observable used. Note that cancelling a subscription will not call `complete` callback
     * provided to `subscribe` function, which is reserved for a regular completion signal that comes from an Observable.
     *
     * Remember that callbacks provided to `subscribe` are not guaranteed to be called asynchronously.
     * It is an Observable itself that decides when these functions will be called. For example {@link of}
     * by default emits all its values synchronously. Always check documentation for how given Observable
     * will behave when subscribed and if its default behavior can be modified with a {@link Scheduler}.
     *
     * @example <caption>Subscribe with an Observer</caption>
     * const sumObserver = {
     *   sum: 0,
     *   next(value) {
     *     console.log('Adding: ' + value);
     *     this.sum = this.sum + value;
     *   },
     *   error() { // We actually could just remove this method,
     *   },        // since we do not really care about errors right now.
     *   complete() {
     *     console.log('Sum equals: ' + this.sum);
     *   }
     * };
     *
     * Rx.Observable.of(1, 2, 3) // Synchronously emits 1, 2, 3 and then completes.
     * .subscribe(sumObserver);
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Subscribe with functions</caption>
     * let sum = 0;
     *
     * Rx.Observable.of(1, 2, 3)
     * .subscribe(
     *   function(value) {
     *     console.log('Adding: ' + value);
     *     sum = sum + value;
     *   },
     *   undefined,
     *   function() {
     *     console.log('Sum equals: ' + sum);
     *   }
     * );
     *
     * // Logs:
     * // "Adding: 1"
     * // "Adding: 2"
     * // "Adding: 3"
     * // "Sum equals: 6"
     *
     *
     * @example <caption>Cancel a subscription</caption>
     * const subscription = Rx.Observable.interval(1000).subscribe(
     *   num => console.log(num),
     *   undefined,
     *   () => console.log('completed!') // Will not be called, even
     * );                                // when cancelling subscription
     *
     *
     * setTimeout(() => {
     *   subscription.unsubscribe();
     *   console.log('unsubscribed!');
     * }, 2500);
     *
     * // Logs:
     * // 0 after 1s
     * // 1 after 2s
     * // "unsubscribed!" after 2.5s
     *
     *
     * @param {Observer|Function} observerOrNext (optional) Either an observer with methods to be called,
     *  or the first of three possible handlers, which is the handler for each value emitted from the subscribed
     *  Observable.
     * @param {Function} error (optional) A handler for a terminal event resulting from an error. If no error handler is provided,
     *  the error will be thrown as unhandled.
     * @param {Function} complete (optional) A handler for a terminal event resulting from successful completion.
     * @return {ISubscription} a subscription reference to the registered handlers
     * @method subscribe
     */ Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = $1AYVx.toSubscriber(observerOrNext, error, complete);
        if (operator) operator.call(sink, this.source);
        else sink.add(this.source || !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) throw sink.syncErrorValue;
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */ Observable.prototype.forEach = function(next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($jYFjc.root.Rx && $jYFjc.root.Rx.config && $jYFjc.root.Rx.config.Promise) PromiseCtor = $jYFjc.root.Rx.config.Promise;
            else if ($jYFjc.root.Promise) PromiseCtor = $jYFjc.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function(value) {
                if (subscription) // if there is a subscription, then we can surmise
                // the next handling is asynchronous. Any errors thrown
                // need to be rejected explicitly and unsubscribe must be
                // called manually
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    subscription.unsubscribe();
                }
                else // if there is NO subscription, then we're getting a nexted
                // value synchronously during subscription. We can just call it.
                // If it errors, Observable's `subscribe` will ensure the
                // unsubscription logic is called, then synchronously rethrow the error.
                // After that, Promise will trap the error and send it
                // down the rejection path.
                next(value);
            }, reject, resolve);
        });
    };
    /** @deprecated internal use only */ Observable.prototype._subscribe = function(subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */ Observable.prototype[$jkDT5.observable] = function() {
        return this;
    };
    /* tslint:enable:max-line-length */ /**
     * Used to stitch together functional operators into a chain.
     * @method pipe
     * @return {Observable} the Observable result of all of the operators having
     * been called in the order they were passed in.
     *
     * @example
     *
     * import { map, filter, scan } from 'rxjs/operators';
     *
     * Rx.Observable.interval(1000)
     *   .pipe(
     *     filter(x => x % 2 === 0),
     *     map(x => x + x),
     *     scan((acc, x) => acc + x)
     *   )
     *   .subscribe(x => console.log(x))
     */ Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i - 0] = arguments[_i];
        if (operations.length === 0) return this;
        return $aXt93.pipeFromArray(operations)(this);
    };
    /* tslint:enable:max-line-length */ Observable.prototype.toPromise = function(PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if ($jYFjc.root.Rx && $jYFjc.root.Rx.config && $jYFjc.root.Rx.config.Promise) PromiseCtor = $jYFjc.root.Rx.config.Promise;
            else if ($jYFjc.root.Promise) PromiseCtor = $jYFjc.root.Promise;
        }
        if (!PromiseCtor) throw new Error('no Promise impl found');
        return new PromiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */ Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
$804a6121fbca4501$export$77cea355fa80b5f4 = $804a6121fbca4501$var$Observable;

});
parcelRegister("jYFjc", function(module, exports) {
$parcel$export(module.exports, "root", () => $e8b3a9fbf585bd33$export$e8e78c978b129247, (v) => $e8b3a9fbf585bd33$export$e8e78c978b129247 = v);
var $e8b3a9fbf585bd33$export$e8e78c978b129247;
"use strict";
// CommonJS / Node have global context exposed as "global" variable.
// We don't want to include the whole node.d.ts this this compilation unit so we'll just fake
// the global "global" var for now.
var $e8b3a9fbf585bd33$var$__window = typeof window !== 'undefined' && window;
var $e8b3a9fbf585bd33$var$__self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && self;
var $e8b3a9fbf585bd33$var$__global = typeof $parcel$global !== 'undefined' && $parcel$global;
var $e8b3a9fbf585bd33$var$_root = $e8b3a9fbf585bd33$var$__window || $e8b3a9fbf585bd33$var$__global || $e8b3a9fbf585bd33$var$__self;
$e8b3a9fbf585bd33$export$e8e78c978b129247 = $e8b3a9fbf585bd33$var$_root;
// Workaround Closure Compiler restriction: The body of a goog.module cannot use throw.
// This is needed when used with angular/tsickle which inserts a goog.module statement.
// Wrap in IIFE
(function() {
    if (!$e8b3a9fbf585bd33$var$_root) throw new Error('RxJS could not find any global context (window, self, global)');
})();

});

parcelRegister("1AYVx", function(module, exports) {
$parcel$export(module.exports, "toSubscriber", () => $12986a13c9d7eaa2$export$2a12c2cebbfd1087, (v) => $12986a13c9d7eaa2$export$2a12c2cebbfd1087 = v);
var $12986a13c9d7eaa2$export$2a12c2cebbfd1087;
"use strict";

var $kVbBc = parcelRequire("kVbBc");

var $2xP00 = parcelRequire("2xP00");

var $ewWuq = parcelRequire("ewWuq");
function $12986a13c9d7eaa2$var$toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof $kVbBc.Subscriber) return nextOrObserver;
        if (nextOrObserver[$2xP00.rxSubscriber]) return nextOrObserver[$2xP00.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new $kVbBc.Subscriber($ewWuq.empty);
    return new $kVbBc.Subscriber(nextOrObserver, error, complete);
}
$12986a13c9d7eaa2$export$2a12c2cebbfd1087 = $12986a13c9d7eaa2$var$toSubscriber;

});
parcelRegister("kVbBc", function(module, exports) {
"use strict";
var $f3b220da10468302$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $02vJ2 = parcelRequire("02vJ2");

var $cGvOX = parcelRequire("cGvOX");

var $ewWuq = parcelRequire("ewWuq");

var $2xP00 = parcelRequire("2xP00");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */ var $f3b220da10468302$var$Subscriber = function(_super) {
    $f3b220da10468302$var$__extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */ function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch(arguments.length){
            case 0:
                this.destination = $ewWuq.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = $ewWuq.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    // HACK(benlesh): To resolve an issue where Node users may have multiple
                    // copies of rxjs in their node_modules directory.
                    if ($f3b220da10468302$var$isTrustedSubscriber(destinationOrNext)) {
                        var trustedSubscriber = destinationOrNext[$2xP00.rxSubscriber]();
                        this.syncErrorThrowable = trustedSubscriber.syncErrorThrowable;
                        this.destination = trustedSubscriber;
                        trustedSubscriber.add(this);
                    } else {
                        this.syncErrorThrowable = true;
                        this.destination = new $f3b220da10468302$var$SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new $f3b220da10468302$var$SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[$2xP00.rxSubscriber] = function() {
        return this;
    };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */ Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */ Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */ Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */ Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    /** @deprecated internal use only */ Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}($cGvOX.Subscription);
module.exports.Subscriber = $f3b220da10468302$var$Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f3b220da10468302$var$SafeSubscriber = function(_super) {
    $f3b220da10468302$var$__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if ($02vJ2.isFunction(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== $ewWuq.empty) {
                context = Object.create(observerOrNext);
                if ($02vJ2.isFunction(context.unsubscribe)) this.add(context.unsubscribe.bind(context));
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            } else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    /** @deprecated internal use only */ SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($f3b220da10468302$var$Subscriber);
function $f3b220da10468302$var$isTrustedSubscriber(obj) {
    return obj instanceof $f3b220da10468302$var$Subscriber || 'syncErrorThrowable' in obj && obj[$2xP00.rxSubscriber];
}

});
parcelRegister("02vJ2", function(module, exports) {
$parcel$export(module.exports, "isFunction", () => $0078cc0affb4a7a2$export$f6e2535fb5126e54, (v) => $0078cc0affb4a7a2$export$f6e2535fb5126e54 = v);
var $0078cc0affb4a7a2$export$f6e2535fb5126e54;
"use strict";
function $0078cc0affb4a7a2$var$isFunction(x) {
    return typeof x === 'function';
}
$0078cc0affb4a7a2$export$f6e2535fb5126e54 = $0078cc0affb4a7a2$var$isFunction;

});

parcelRegister("cGvOX", function(module, exports) {
$parcel$export(module.exports, "Subscription", () => $93c217399c72d4e4$export$f55210826850c514, (v) => $93c217399c72d4e4$export$f55210826850c514 = v);
var $93c217399c72d4e4$export$f55210826850c514;
"use strict";

var $8SQia = parcelRequire("8SQia");

var $a2cZP = parcelRequire("a2cZP");

var $02vJ2 = parcelRequire("02vJ2");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $2LnVI = parcelRequire("2LnVI");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */ var $93c217399c72d4e4$var$Subscription = function() {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */ function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */ this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) this._unsubscribe = unsubscribe;
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */ Subscription.prototype.unsubscribe = function() {
        var hasErrors = false;
        var errors;
        if (this.closed) return;
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while(_parent){
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if ($02vJ2.isFunction(_unsubscribe)) {
            var trial = $3kkLM.tryCatch(_unsubscribe).call(this);
            if (trial === $geExo.errorObject) {
                hasErrors = true;
                errors = errors || ($geExo.errorObject.e instanceof $2LnVI.UnsubscriptionError ? $93c217399c72d4e4$var$flattenUnsubscriptionErrors($geExo.errorObject.e.errors) : [
                    $geExo.errorObject.e
                ]);
            }
        }
        if ($8SQia.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ($a2cZP.isObject(sub)) {
                    var trial = $3kkLM.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === $geExo.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = $geExo.errorObject.e;
                        if (err instanceof $2LnVI.UnsubscriptionError) errors = errors.concat($93c217399c72d4e4$var$flattenUnsubscriptionErrors(err.errors));
                        else errors.push(err);
                    }
                }
            }
        }
        if (hasErrors) throw new $2LnVI.UnsubscriptionError(errors);
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */ Subscription.prototype.add = function(teardown) {
        if (!teardown || teardown === Subscription.EMPTY) return Subscription.EMPTY;
        if (teardown === this) return this;
        var subscription = teardown;
        switch(typeof teardown){
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (typeof subscription._addParent !== 'function' /* quack quack */ ) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */ Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.prototype._addParent = function(parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) // If we don't have a parent, or the new parent is the same as the
        // current parent, then set this._parent to the new parent.
        this._parent = parent;
        else if (!_parents) // If there's already one parent, but not multiple, allocate an Array to
        // store the rest of the parent Subscriptions.
        this._parents = [
            parent
        ];
        else if (_parents.indexOf(parent) === -1) // Only add the new parent to the _parents list if it's not already there.
        _parents.push(parent);
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
$93c217399c72d4e4$export$f55210826850c514 = $93c217399c72d4e4$var$Subscription;
function $93c217399c72d4e4$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof $2LnVI.UnsubscriptionError ? err.errors : err);
    }, []);
}

});
parcelRegister("8SQia", function(module, exports) {
$parcel$export(module.exports, "isArray", () => $677bedf6b7b321fc$export$43bee75e5e14138e, (v) => $677bedf6b7b321fc$export$43bee75e5e14138e = v);
var $677bedf6b7b321fc$export$43bee75e5e14138e;
"use strict";
$677bedf6b7b321fc$export$43bee75e5e14138e = Array.isArray || function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("a2cZP", function(module, exports) {
$parcel$export(module.exports, "isObject", () => $74e42c10f7db0188$export$a6cdc56e425d0d0a, (v) => $74e42c10f7db0188$export$a6cdc56e425d0d0a = v);
var $74e42c10f7db0188$export$a6cdc56e425d0d0a;
"use strict";
function $74e42c10f7db0188$var$isObject(x) {
    return x != null && typeof x === 'object';
}
$74e42c10f7db0188$export$a6cdc56e425d0d0a = $74e42c10f7db0188$var$isObject;

});

parcelRegister("3kkLM", function(module, exports) {
$parcel$export(module.exports, "tryCatch", () => $26c359c095bd126c$export$d234c058d1d4e435, (v) => $26c359c095bd126c$export$d234c058d1d4e435 = v);
var $26c359c095bd126c$export$d234c058d1d4e435;
"use strict";

var $geExo = parcelRequire("geExo");
var $26c359c095bd126c$var$tryCatchTarget;
function $26c359c095bd126c$var$tryCatcher() {
    try {
        return $26c359c095bd126c$var$tryCatchTarget.apply(this, arguments);
    } catch (e) {
        $geExo.errorObject.e = e;
        return $geExo.errorObject;
    }
}
function $26c359c095bd126c$var$tryCatch(fn) {
    $26c359c095bd126c$var$tryCatchTarget = fn;
    return $26c359c095bd126c$var$tryCatcher;
}
$26c359c095bd126c$export$d234c058d1d4e435 = $26c359c095bd126c$var$tryCatch;

});
parcelRegister("geExo", function(module, exports) {
$parcel$export(module.exports, "errorObject", () => $bd1d66149db68546$export$fc504b39d7c1176, (v) => $bd1d66149db68546$export$fc504b39d7c1176 = v);
// typeof any so that it we don't have to cast when comparing a result to the error object
var $bd1d66149db68546$export$fc504b39d7c1176;
"use strict";
$bd1d66149db68546$export$fc504b39d7c1176 = {
    e: {}
};

});


parcelRegister("2LnVI", function(module, exports) {
"use strict";
var $2032888ade4d5b21$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */ var $2032888ade4d5b21$var$UnsubscriptionError = function(_super) {
    $2032888ade4d5b21$var$__extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error);
module.exports.UnsubscriptionError = $2032888ade4d5b21$var$UnsubscriptionError;

});


parcelRegister("ewWuq", function(module, exports) {
$parcel$export(module.exports, "empty", () => $a9416cb0bf9ad16a$export$6e22c362a0406a2c, (v) => $a9416cb0bf9ad16a$export$6e22c362a0406a2c = v);
var $a9416cb0bf9ad16a$export$6e22c362a0406a2c;
"use strict";
$a9416cb0bf9ad16a$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        throw err;
    },
    complete: function() {}
};

});

parcelRegister("2xP00", function(module, exports) {
$parcel$export(module.exports, "rxSubscriber", () => $1da639304b6641dc$export$77f77496d7cade10, (v) => $1da639304b6641dc$export$77f77496d7cade10 = v);
var $1da639304b6641dc$export$77f77496d7cade10;
/**
 * @deprecated use rxSubscriber instead
 */ var $1da639304b6641dc$export$4a2e07ff24d010f0;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
var $1da639304b6641dc$var$Symbol = $jYFjc.root.Symbol;
$1da639304b6641dc$export$77f77496d7cade10 = typeof $1da639304b6641dc$var$Symbol === 'function' && typeof $1da639304b6641dc$var$Symbol.for === 'function' ? $1da639304b6641dc$var$Symbol.for('rxSubscriber') : '@@rxSubscriber';
$1da639304b6641dc$export$4a2e07ff24d010f0 = $1da639304b6641dc$export$77f77496d7cade10;

});



parcelRegister("jkDT5", function(module, exports) {
$parcel$export(module.exports, "observable", () => $e12ed36cb34b2ad4$export$5ab46cbf6120b33a, (v) => $e12ed36cb34b2ad4$export$5ab46cbf6120b33a = v);
var $e12ed36cb34b2ad4$export$7e68bb2e8ecea8fe;
var $e12ed36cb34b2ad4$export$5ab46cbf6120b33a;
/**
 * @deprecated use observable instead
 */ var $e12ed36cb34b2ad4$export$a7c40509ff863847;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
function $e12ed36cb34b2ad4$var$getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) $$observable = Symbol.observable;
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    } else $$observable = '@@observable';
    return $$observable;
}
$e12ed36cb34b2ad4$export$7e68bb2e8ecea8fe = $e12ed36cb34b2ad4$var$getSymbolObservable;
$e12ed36cb34b2ad4$export$5ab46cbf6120b33a = $e12ed36cb34b2ad4$var$getSymbolObservable($jYFjc.root);
$e12ed36cb34b2ad4$export$a7c40509ff863847 = $e12ed36cb34b2ad4$export$5ab46cbf6120b33a;

});

parcelRegister("aXt93", function(module, exports) {
$parcel$export(module.exports, "pipe", () => $7fa605a700188ba1$export$a4627e546088548d, (v) => $7fa605a700188ba1$export$a4627e546088548d = v);
$parcel$export(module.exports, "pipeFromArray", () => $7fa605a700188ba1$export$71f88a61afaa14d7, (v) => $7fa605a700188ba1$export$71f88a61afaa14d7 = v);
var $7fa605a700188ba1$export$a4627e546088548d;
var $7fa605a700188ba1$export$71f88a61afaa14d7;
"use strict";

var $kjljt = parcelRequire("kjljt");
/* tslint:enable:max-line-length */ function $7fa605a700188ba1$var$pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i - 0] = arguments[_i];
    return $7fa605a700188ba1$var$pipeFromArray(fns);
}
$7fa605a700188ba1$export$a4627e546088548d = $7fa605a700188ba1$var$pipe;
/* @internal */ function $7fa605a700188ba1$var$pipeFromArray(fns) {
    if (!fns) return $kjljt.noop;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}
$7fa605a700188ba1$export$71f88a61afaa14d7 = $7fa605a700188ba1$var$pipeFromArray;

});
parcelRegister("kjljt", function(module, exports) {
$parcel$export(module.exports, "noop", () => $ec961d519ed73cf1$export$8793edee2d425525, (v) => $ec961d519ed73cf1$export$8793edee2d425525 = v);
var $ec961d519ed73cf1$export$8793edee2d425525;
"use strict";
/* tslint:disable:no-empty */ function $ec961d519ed73cf1$var$noop() {}
$ec961d519ed73cf1$export$8793edee2d425525 = $ec961d519ed73cf1$var$noop;

});



parcelRegister("l8iRu", function(module, exports) {
$parcel$export(module.exports, "createBrowserHistory", () => (parcelRequire("g2zI4")).createBrowserHistory);
$parcel$export(module.exports, "createMemoryHistory", () => (parcelRequire("g2zI4")).createMemoryHistory);
$parcel$export(module.exports, "Redirect", () => (parcelRequire("1UKKy")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("8NB5B")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("dCuc5")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("eDygx")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("4g7Uv")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hfD9S")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("1wDzz")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("lM7Z9")).withRouter);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("7H5nz")).RouteComponent);
$parcel$export(module.exports, "Link", () => (parcelRequire("bdubZ")).default);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("4fMuX")).generatePath);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("3CTUc")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("3CTUc")).useRouterStoreActions);
$parcel$export(module.exports, "createResource", () => (parcelRequire("f03OU")).createResource);
$parcel$export(module.exports, "useResource", () => (parcelRequire("cpzpY")).useResource);

var $g2zI4 = parcelRequire("g2zI4");
parcelRequire("kcMae");
var $1UKKy = parcelRequire("1UKKy");
var $8NB5B = parcelRequire("8NB5B");
var $dCuc5 = parcelRequire("dCuc5");
var $eDygx = parcelRequire("eDygx");
var $4g7Uv = parcelRequire("4g7Uv");
var $hfD9S = parcelRequire("hfD9S");
var $1wDzz = parcelRequire("1wDzz");
var $lM7Z9 = parcelRequire("lM7Z9");
parcelRequire("i9DZX");
var $bdubZ = parcelRequire("bdubZ");
var $7H5nz = parcelRequire("7H5nz");
parcelRequire("gkkih");
var $4fMuX = parcelRequire("4fMuX");

var $bwvJd = parcelRequire("bwvJd");

var $3CTUc = parcelRequire("3CTUc");

var $lTyDU = parcelRequire("lTyDU");
parcelRequire("8yaBI");
var $f03OU = parcelRequire("f03OU");
var $cpzpY = parcelRequire("cpzpY");

});
parcelRegister("g2zI4", function(module, exports) {
$parcel$export(module.exports, "parsePath", () => $bad888799b45d659$export$8ccf933b0513f8d0);
$parcel$export(module.exports, "createPath", () => $bad888799b45d659$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $bad888799b45d659$export$90c043f1c57770b8);
$parcel$export(module.exports, "createBrowserHistory", () => $bad888799b45d659$export$719fc203c4e16dee);
$parcel$export(module.exports, "createMemoryHistory", () => $bad888799b45d659$export$2b76ad033c6e6d08);

var $ichJ5 = parcelRequire("ichJ5");

var $fq7ec = parcelRequire("fq7ec");

var $esUKY = parcelRequire("esUKY");


var $yLYo1 = parcelRequire("yLYo1");
function $bad888799b45d659$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $bad888799b45d659$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $bad888799b45d659$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $bad888799b45d659$var$stripBasename(path, prefix) {
    return $bad888799b45d659$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $bad888799b45d659$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $bad888799b45d659$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $bad888799b45d659$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $bad888799b45d659$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $bad888799b45d659$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $ichJ5.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $fq7ec.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $bad888799b45d659$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $esUKY.default)(a.state, b.state);
}
function $bad888799b45d659$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $bad888799b45d659$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $bad888799b45d659$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $bad888799b45d659$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $bad888799b45d659$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $bad888799b45d659$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $bad888799b45d659$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $bad888799b45d659$var$PopStateEvent = 'popstate';
var $bad888799b45d659$var$HashChangeEvent = 'hashchange';
function $bad888799b45d659$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $bad888799b45d659$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$bad888799b45d659$var$canUseDOM && (0, $yLYo1.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $bad888799b45d659$var$supportsHistory();
    var needsHashChangeListener = !$bad888799b45d659$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $bad888799b45d659$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $bad888799b45d659$var$stripTrailingSlash($bad888799b45d659$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $bad888799b45d659$var$stripBasename(path, basename);
        return $bad888799b45d659$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $bad888799b45d659$var$createTransitionManager();
    function setState(nextState) {
        (0, $ichJ5.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($bad888799b45d659$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($bad888799b45d659$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($bad888799b45d659$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $bad888799b45d659$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $bad888799b45d659$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $bad888799b45d659$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($bad888799b45d659$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($bad888799b45d659$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($bad888799b45d659$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($bad888799b45d659$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $bad888799b45d659$var$HashChangeEvent$1 = 'hashchange';
var $bad888799b45d659$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $bad888799b45d659$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $bad888799b45d659$var$stripLeadingSlash,
        decodePath: $bad888799b45d659$var$addLeadingSlash
    },
    slash: {
        encodePath: $bad888799b45d659$var$addLeadingSlash,
        decodePath: $bad888799b45d659$var$addLeadingSlash
    }
};
function $bad888799b45d659$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $bad888799b45d659$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $bad888799b45d659$var$pushHashPath(path) {
    window.location.hash = path;
}
function $bad888799b45d659$var$replaceHashPath(path) {
    window.location.replace($bad888799b45d659$var$stripHash(window.location.href) + '#' + path);
}
function $bad888799b45d659$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$bad888799b45d659$var$canUseDOM && (0, $yLYo1.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $bad888799b45d659$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $bad888799b45d659$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $bad888799b45d659$var$stripTrailingSlash($bad888799b45d659$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $bad888799b45d659$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($bad888799b45d659$var$getHashPath());
        if (basename) path = $bad888799b45d659$var$stripBasename(path, basename);
        return $bad888799b45d659$export$90c043f1c57770b8(path);
    }
    var transitionManager = $bad888799b45d659$var$createTransitionManager();
    function setState(nextState) {
        (0, $ichJ5.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $bad888799b45d659$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $bad888799b45d659$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $bad888799b45d659$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($bad888799b45d659$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($bad888799b45d659$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $bad888799b45d659$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $bad888799b45d659$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $bad888799b45d659$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $bad888799b45d659$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $bad888799b45d659$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $bad888799b45d659$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $bad888799b45d659$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $bad888799b45d659$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $bad888799b45d659$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($bad888799b45d659$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $bad888799b45d659$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $bad888799b45d659$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $bad888799b45d659$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $bad888799b45d659$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($bad888799b45d659$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($bad888799b45d659$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($bad888799b45d659$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $bad888799b45d659$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $bad888799b45d659$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $bad888799b45d659$var$createTransitionManager();
    function setState(nextState) {
        (0, $ichJ5.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $bad888799b45d659$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $bad888799b45d659$export$90c043f1c57770b8(entry, undefined, createKey()) : $bad888799b45d659$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $bad888799b45d659$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $bad888799b45d659$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $bad888799b45d659$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $bad888799b45d659$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("ichJ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3f71910184ef54e$export$2e2bcd8739ae039);
function $d3f71910184ef54e$export$2e2bcd8739ae039() {
    return $d3f71910184ef54e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d3f71910184ef54e$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("fq7ec", function(module, exports) {
$parcel$export(module.exports, "default", () => $b39ee4087612934e$export$2e2bcd8739ae039);
function $b39ee4087612934e$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $b39ee4087612934e$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $b39ee4087612934e$var$resolvePathname(to, from) {
    if (from === undefined) from = '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $b39ee4087612934e$var$isAbsolute(to);
    var isFromAbs = from && $b39ee4087612934e$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $b39ee4087612934e$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $b39ee4087612934e$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $b39ee4087612934e$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $b39ee4087612934e$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$b39ee4087612934e$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $b39ee4087612934e$export$2e2bcd8739ae039 = $b39ee4087612934e$var$resolvePathname;

});

parcelRegister("esUKY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a87fb4e9c3b9ae1f$export$2e2bcd8739ae039);
function $a87fb4e9c3b9ae1f$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $a87fb4e9c3b9ae1f$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $a87fb4e9c3b9ae1f$var$valueEqual(item, b[index]);
    });
    if (typeof a === 'object' || typeof b === 'object') {
        var aValue = $a87fb4e9c3b9ae1f$var$valueOf(a);
        var bValue = $a87fb4e9c3b9ae1f$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $a87fb4e9c3b9ae1f$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $a87fb4e9c3b9ae1f$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $a87fb4e9c3b9ae1f$export$2e2bcd8739ae039 = $a87fb4e9c3b9ae1f$var$valueEqual;

});

parcelRegister("yLYo1", function(module, exports) {
$parcel$export(module.exports, "default", () => $06886386342eb0f6$export$2e2bcd8739ae039);
var $06886386342eb0f6$var$isProduction = true;
var $06886386342eb0f6$var$prefix = 'Invariant failed';
function $06886386342eb0f6$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($06886386342eb0f6$var$isProduction) throw new Error($06886386342eb0f6$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($06886386342eb0f6$var$prefix, ": ").concat(provided) : $06886386342eb0f6$var$prefix;
    throw new Error(value);
}

});


parcelRegister("kcMae", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => (parcelRequire("1UKKy")).Redirect);
$parcel$export(module.exports, "Router", () => (parcelRequire("8NB5B")).Router);
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("dCuc5")).RouterSubscriber);
$parcel$export(module.exports, "usePathParam", () => (parcelRequire("eDygx")).usePathParam);
$parcel$export(module.exports, "useQueryParam", () => (parcelRequire("4g7Uv")).useQueryParam);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("hfD9S")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("1wDzz")).useRouterActions);
$parcel$export(module.exports, "withRouter", () => (parcelRequire("lM7Z9")).withRouter);

var $1UKKy = parcelRequire("1UKKy");

var $8NB5B = parcelRequire("8NB5B");

var $kywst = parcelRequire("kywst");

var $dCuc5 = parcelRequire("dCuc5");

var $3CTUc = parcelRequire("3CTUc");

var $eDygx = parcelRequire("eDygx");

var $4g7Uv = parcelRequire("4g7Uv");

var $hfD9S = parcelRequire("hfD9S");

var $1wDzz = parcelRequire("1wDzz");

var $lM7Z9 = parcelRequire("lM7Z9");

});
parcelRegister("1UKKy", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $164f48f52da44f8c$export$2d8d895a0a0f636e);

var $ichJ5 = parcelRequire("ichJ5");

var $6YQ3e = parcelRequire("6YQ3e");

var $g2zI4 = parcelRequire("g2zI4");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("gkkih");
var $1pcyW = parcelRequire("1pcyW");

var $hfD9S = parcelRequire("hfD9S");
class $164f48f52da44f8c$var$Redirector extends (0, $4fqPo.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $g2zI4.createPath)((0, $1pcyW.generateLocationFromPath)(to.path, routeAttributes)) : (0, $g2zI4.createPath)(to) : to;
        const currentPath = (0, $g2zI4.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $6YQ3e.default)($164f48f52da44f8c$var$Redirector, "defaultProps", {
    push: false
});
const $164f48f52da44f8c$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $hfD9S.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($164f48f52da44f8c$var$Redirector, (0, $ichJ5.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("6YQ3e", function(module, exports) {
$parcel$export(module.exports, "default", () => $5150b8f31eda9ba1$export$2e2bcd8739ae039);

var $92oSb = parcelRequire("92oSb");
function $5150b8f31eda9ba1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $92oSb.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("92oSb", function(module, exports) {
$parcel$export(module.exports, "default", () => $69479839ab53ff45$export$2e2bcd8739ae039);

var $5WRll = parcelRequire("5WRll");

var $c1yAg = parcelRequire("c1yAg");
function $69479839ab53ff45$export$2e2bcd8739ae039(t) {
    var i = (0, $c1yAg.default)(t, "string");
    return "symbol" == (0, $5WRll.default)(i) ? i : i + "";
}

});
parcelRegister("c1yAg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c1067aac40d36df$export$2e2bcd8739ae039);

var $5WRll = parcelRequire("5WRll");
function $8c1067aac40d36df$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5WRll.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5WRll.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("gkkih", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("1pcyW")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("4fMuX")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("9L4D5")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("gveRg")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("4HiQA")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("4HiQA")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("e6Cwx")).isSameRouteMatch);

var $9fhTl = parcelRequire("9fhTl");

var $1pcyW = parcelRequire("1pcyW");

var $4fMuX = parcelRequire("4fMuX");

var $9L4D5 = parcelRequire("9L4D5");

var $gveRg = parcelRequire("gveRg");

var $4HiQA = parcelRequire("4HiQA");

var $e6Cwx = parcelRequire("e6Cwx");

});
parcelRegister("9fhTl", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $6bb364b0f6882cdd$export$883c3f3b6c000133);

var $ichJ5 = parcelRequire("ichJ5");

var $g2zI4 = parcelRequire("g2zI4");

var $9ptG5 = parcelRequire("9ptG5");

var $8y4Rw = parcelRequire("8y4Rw");
const $6bb364b0f6882cdd$var$hasWindow = ()=>typeof window !== 'undefined';
const $6bb364b0f6882cdd$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw)))
};
const $6bb364b0f6882cdd$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $6bb364b0f6882cdd$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $6bb364b0f6882cdd$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($9ptG5)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $6bb364b0f6882cdd$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $6bb364b0f6882cdd$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $6bb364b0f6882cdd$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $ichJ5.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $6bb364b0f6882cdd$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $6bb364b0f6882cdd$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $g2zI4.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $g2zI4.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $6bb364b0f6882cdd$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
        createHref: (location)=>(0, $g2zI4.createPath)(location)
    } : $6bb364b0f6882cdd$var$methodsPlaceholders);
};

});
parcelRegister("9ptG5", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $6d9d78415239e95f$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $6d9d78415239e95f$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $6d9d78415239e95f$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $6d9d78415239e95f$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $6d9d78415239e95f$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $6d9d78415239e95f$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $6d9d78415239e95f$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $6d9d78415239e95f$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $6d9d78415239e95f$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $6d9d78415239e95f$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6d9d78415239e95f$var$root = $6d9d78415239e95f$var$freeGlobal || $6d9d78415239e95f$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $6d9d78415239e95f$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $6d9d78415239e95f$var$objectToString = $6d9d78415239e95f$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6d9d78415239e95f$var$nativeMax = Math.max, $6d9d78415239e95f$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d9d78415239e95f$var$now = function() {
    return $6d9d78415239e95f$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $6d9d78415239e95f$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($6d9d78415239e95f$var$FUNC_ERROR_TEXT);
    wait = $6d9d78415239e95f$var$toNumber(wait) || 0;
    if ($6d9d78415239e95f$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $6d9d78415239e95f$var$nativeMax($6d9d78415239e95f$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $6d9d78415239e95f$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $6d9d78415239e95f$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($6d9d78415239e95f$var$now());
    }
    function debounced() {
        var time = $6d9d78415239e95f$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6d9d78415239e95f$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $6d9d78415239e95f$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6d9d78415239e95f$var$isSymbol(value) {
    return typeof value == 'symbol' || $6d9d78415239e95f$var$isObjectLike(value) && $6d9d78415239e95f$var$objectToString.call(value) == $6d9d78415239e95f$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $6d9d78415239e95f$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($6d9d78415239e95f$var$isSymbol(value)) return $6d9d78415239e95f$var$NAN;
    if ($6d9d78415239e95f$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $6d9d78415239e95f$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($6d9d78415239e95f$var$reTrim, '');
    var isBinary = $6d9d78415239e95f$var$reIsBinary.test(value);
    return isBinary || $6d9d78415239e95f$var$reIsOctal.test(value) ? $6d9d78415239e95f$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $6d9d78415239e95f$var$reIsBadHex.test(value) ? $6d9d78415239e95f$var$NAN : +value;
}
module.exports = $6d9d78415239e95f$var$debounce;

});

parcelRegister("8y4Rw", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $63954541c4641f75$var$noop() {
// No operation performed.
}
module.exports = $63954541c4641f75$var$noop;

});


parcelRegister("1pcyW", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $1061deed714d40de$export$37e0729cc751960b);

var $62VY5 = parcelRequire("62VY5");

var $2Q7mc = parcelRequire("2Q7mc");
function $1061deed714d40de$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $2Q7mc.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $62VY5.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("62VY5", function(module, exports) {
$parcel$export(module.exports, "compile", () => $466fe541b1e402e6$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $466fe541b1e402e6$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $466fe541b1e402e6$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $466fe541b1e402e6$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $466fe541b1e402e6$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($466fe541b1e402e6$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($466fe541b1e402e6$var$escapeString(prevText), ")[^").concat($466fe541b1e402e6$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $466fe541b1e402e6$export$ef7acd7185315e22(str, options) {
    return $466fe541b1e402e6$export$5b9bad9e403cf3d9($466fe541b1e402e6$export$98e6a39c04603d36(str, options), options);
}
function $466fe541b1e402e6$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $466fe541b1e402e6$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $466fe541b1e402e6$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $466fe541b1e402e6$export$71304158c7e35877(str, keys, options);
    return $466fe541b1e402e6$export$968e97c88708237a(re, keys, options);
}
function $466fe541b1e402e6$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $466fe541b1e402e6$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $466fe541b1e402e6$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $466fe541b1e402e6$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $466fe541b1e402e6$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $466fe541b1e402e6$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $466fe541b1e402e6$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $466fe541b1e402e6$var$stringToRegexp(path, keys, options) {
    return $466fe541b1e402e6$export$9a9303716def6456($466fe541b1e402e6$export$98e6a39c04603d36(path, options), keys, options);
}
function $466fe541b1e402e6$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($466fe541b1e402e6$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($466fe541b1e402e6$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $466fe541b1e402e6$var$escapeString(encode(token));
        else {
            var prefix = $466fe541b1e402e6$var$escapeString(encode(token.prefix));
            var suffix = $466fe541b1e402e6$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $466fe541b1e402e6$var$flags(options));
}
function $466fe541b1e402e6$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $466fe541b1e402e6$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $466fe541b1e402e6$var$arrayToRegexp(path, keys, options);
    return $466fe541b1e402e6$var$stringToRegexp(path, keys, options);
}

});

parcelRegister("2Q7mc", function(module, exports) {
'use strict';

var $VqRna = parcelRequire("VqRna");

var $fVsA0 = parcelRequire("fVsA0");
var $2116250b04d82bb7$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $2116250b04d82bb7$var$CRHTLF = /[\n\r\t]/g, $2116250b04d82bb7$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $2116250b04d82bb7$var$port = /:\d+$/, $2116250b04d82bb7$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $2116250b04d82bb7$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $2116250b04d82bb7$var$trimLeft(str) {
    return (str ? str : '').toString().replace($2116250b04d82bb7$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $2116250b04d82bb7$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $2116250b04d82bb7$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $2116250b04d82bb7$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $2116250b04d82bb7$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $2116250b04d82bb7$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $2116250b04d82bb7$var$Url(loc, {});
        for(key in $2116250b04d82bb7$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $2116250b04d82bb7$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $2116250b04d82bb7$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $2116250b04d82bb7$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $2116250b04d82bb7$var$extractProtocol(address, location) {
    address = $2116250b04d82bb7$var$trimLeft(address);
    address = address.replace($2116250b04d82bb7$var$CRHTLF, '');
    location = location || {};
    var match = $2116250b04d82bb7$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($2116250b04d82bb7$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $2116250b04d82bb7$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $2116250b04d82bb7$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $2116250b04d82bb7$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $2116250b04d82bb7$var$Url(address, location, parser) {
    address = $2116250b04d82bb7$var$trimLeft(address);
    address = address.replace($2116250b04d82bb7$var$CRHTLF, '');
    if (!(this instanceof $2116250b04d82bb7$var$Url)) return new $2116250b04d82bb7$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $2116250b04d82bb7$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $fVsA0.parse;
    location = $2116250b04d82bb7$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $2116250b04d82bb7$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $2116250b04d82bb7$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$2116250b04d82bb7$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $2116250b04d82bb7$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $2116250b04d82bb7$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$VqRna(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $2116250b04d82bb7$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $2116250b04d82bb7$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $fVsA0.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$VqRna(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($2116250b04d82bb7$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $2116250b04d82bb7$var$rules.length; i++){
        var ins = $2116250b04d82bb7$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $2116250b04d82bb7$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $2116250b04d82bb7$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $fVsA0.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $2116250b04d82bb7$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $2116250b04d82bb7$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $2116250b04d82bb7$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$2116250b04d82bb7$var$Url.prototype = {
    set: $2116250b04d82bb7$var$set,
    toString: $2116250b04d82bb7$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$2116250b04d82bb7$var$Url.extractProtocol = $2116250b04d82bb7$var$extractProtocol;
$2116250b04d82bb7$var$Url.location = $2116250b04d82bb7$var$lolcation;
$2116250b04d82bb7$var$Url.trimLeft = $2116250b04d82bb7$var$trimLeft;
$2116250b04d82bb7$var$Url.qs = $fVsA0;
module.exports = $2116250b04d82bb7$var$Url;

});
parcelRegister("VqRna", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("fVsA0", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $b9825934f635d379$export$fac44ee5b035f737, (v) => $b9825934f635d379$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $b9825934f635d379$export$98e6a39c04603d36, (v) => $b9825934f635d379$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $b9825934f635d379$export$fac44ee5b035f737;
var $b9825934f635d379$export$98e6a39c04603d36;
'use strict';
var $b9825934f635d379$var$has = Object.prototype.hasOwnProperty, $b9825934f635d379$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $b9825934f635d379$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $b9825934f635d379$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $b9825934f635d379$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $b9825934f635d379$var$decode(part[1]), value = $b9825934f635d379$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $b9825934f635d379$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($b9825934f635d379$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $b9825934f635d379$var$undef || isNaN(value))) value = '';
        key = $b9825934f635d379$var$encode(key);
        value = $b9825934f635d379$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$b9825934f635d379$export$fac44ee5b035f737 = $b9825934f635d379$var$querystringify;
$b9825934f635d379$export$98e6a39c04603d36 = $b9825934f635d379$var$querystring;

});



parcelRegister("4fMuX", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $318e2eea6b96769d$export$82476f982757e71e);

var $62VY5 = parcelRequire("62VY5");
const $318e2eea6b96769d$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $62VY5.compile)(pattern)(params);

});

parcelRegister("9L4D5", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $71ac182a840dde3e$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3TFEq = parcelRequire("3TFEq");
const $71ac182a840dde3e$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $71ac182a840dde3e$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3TFEq !== 'undefined' && $3TFEq.versions != null && $3TFEq.versions.node != null) return true;
    if ($71ac182a840dde3e$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("gveRg", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $c03b11134476d954$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $c03b11134476d954$export$2e2bcd8739ae039);

var $2Q7mc = parcelRequire("2Q7mc");

var $i4CIz = parcelRequire("i4CIz");

var $hBmK6 = parcelRequire("hBmK6");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $c03b11134476d954$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $2Q7mc.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $hBmK6.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $i4CIz.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $hBmK6.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $c03b11134476d954$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$c03b11134476d954$var$matchRoute(routes, pathname, queryParams, basePath);
const $c03b11134476d954$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $c03b11134476d954$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $c03b11134476d954$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$c03b11134476d954$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("i4CIz", function(module, exports) {
$parcel$export(module.exports, "default", () => $d286a24df55cff4c$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $lJ2yV = parcelRequire("lJ2yV");

var $lA9cj = parcelRequire("lA9cj");
/* This should match what react-router does to compute a root match. */ const $d286a24df55cff4c$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $d286a24df55cff4c$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $lJ2yV.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $d286a24df55cff4c$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $lA9cj.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $ichJ5.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $d286a24df55cff4c$export$2e2bcd8739ae039 = $d286a24df55cff4c$var$execRouteMatching;

});
parcelRegister("lJ2yV", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd0fc9c5b0eac1b5$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $62VY5 = parcelRequire("62VY5");
const $fd0fc9c5b0eac1b5$var$cache = {};
const $fd0fc9c5b0eac1b5$var$cacheLimit = 10000;
let $fd0fc9c5b0eac1b5$var$cacheCount = 0;
function $fd0fc9c5b0eac1b5$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $fd0fc9c5b0eac1b5$var$cache[cacheKey] || ($fd0fc9c5b0eac1b5$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $62VY5.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($fd0fc9c5b0eac1b5$var$cacheCount < $fd0fc9c5b0eac1b5$var$cacheLimit) {
        pathCache[path] = result;
        $fd0fc9c5b0eac1b5$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $fd0fc9c5b0eac1b5$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $fd0fc9c5b0eac1b5$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $fd0fc9c5b0eac1b5$export$2e2bcd8739ae039 = $fd0fc9c5b0eac1b5$var$matchPath;

});

parcelRegister("lA9cj", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb64183cd06ae4d0$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $fb64183cd06ae4d0$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $ichJ5.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $fb64183cd06ae4d0$export$2e2bcd8739ae039 = $fb64183cd06ae4d0$var$matchQuery;

});


parcelRegister("hBmK6", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $cd07888e6a7597da$export$f594abf16a5ad948);
const $cd07888e6a7597da$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $cd07888e6a7597da$var$MAX_CACHE_SIZE = 1000;
function $cd07888e6a7597da$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$cd07888e6a7597da$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $cd07888e6a7597da$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($cd07888e6a7597da$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $cd07888e6a7597da$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $cd07888e6a7597da$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("4HiQA", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $36b9cc3d4b09b710$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $36b9cc3d4b09b710$export$a0bd0313cbeabd49);

var $2Q7mc = parcelRequire("2Q7mc");

var $lTyDU = parcelRequire("lTyDU");

var $4fMuX = parcelRequire("4fMuX");

var $gveRg = parcelRequire("gveRg");
const $36b9cc3d4b09b710$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $4fMuX.generatePath)(route.path, params);
    const matchedRoute = (0, $gveRg.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $lTyDU.DEFAULT_MATCH),
        query: query
    };
};
const $36b9cc3d4b09b710$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $2Q7mc.qs).parse(search);
    const matchedRoute = (0, $gveRg.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $lTyDU.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $lTyDU.DEFAULT_MATCH)
    };
};

});
parcelRegister("lTyDU", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $ff099b5731a45a2c$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $ff099b5731a45a2c$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $ff099b5731a45a2c$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $ff099b5731a45a2c$export$fa440ddf675c8a93);

var $8y4Rw = parcelRequire("8y4Rw");

var $9fhTl = parcelRequire("9fhTl");
const $ff099b5731a45a2c$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $ff099b5731a45a2c$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $ff099b5731a45a2c$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $ff099b5731a45a2c$export$39607c9878cf5148 = (0, $9fhTl.createLegacyHistory)();
const $ff099b5731a45a2c$export$1515254c8c90bebb = {
    location: $ff099b5731a45a2c$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw)))
};
const $ff099b5731a45a2c$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("e6Cwx", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $a44f823bf1d0a9ec$export$5997e70fc4543270);
const $a44f823bf1d0a9ec$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $a44f823bf1d0a9ec$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $a44f823bf1d0a9ec$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $a44f823bf1d0a9ec$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("hfD9S", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $c8f23669b7e75da2$export$9a302a45f65d0572);

var $3CTUc = parcelRequire("3CTUc");
const $c8f23669b7e75da2$export$9a302a45f65d0572 = (0, $3CTUc.useRouterStore);

});
parcelRegister("3CTUc", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $2a40495b390796f6$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $2a40495b390796f6$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $2a40495b390796f6$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $2a40495b390796f6$export$ada49399abf7a3a1);

var $ichJ5 = parcelRequire("ichJ5");

var $g2zI4 = parcelRequire("g2zI4");

var $3Rlvb = parcelRequire("3Rlvb");
var $iouul = parcelRequire("iouul");
var $4CywU = parcelRequire("4CywU");
var $2RDzF = parcelRequire("2RDzF");
var $7luw1 = parcelRequire("7luw1");

var $lTyDU = parcelRequire("lTyDU");
parcelRequire("gkkih");
var $4HiQA = parcelRequire("4HiQA");
var $1pcyW = parcelRequire("1pcyW");
var $4fMuX = parcelRequire("4fMuX");
var $9L4D5 = parcelRequire("9L4D5");
var $gveRg = parcelRequire("gveRg");

var $g9ysg = parcelRequire("g9ysg");
const $2a40495b390796f6$export$36d128238e6b60f5 = {
    action: (0, $lTyDU.DEFAULT_ACTION),
    basePath: '',
    location: (0, $lTyDU.DEFAULT_HISTORY).location,
    history: (0, $lTyDU.DEFAULT_HISTORY),
    match: (0, $lTyDU.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $lTyDU.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $2a40495b390796f6$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $4HiQA.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $ichJ5.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $9L4D5.isServerEnvironment)()) dispatch($2a40495b390796f6$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $4HiQA.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $g9ysg.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $3Rlvb.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $ichJ5.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $g9ysg.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $g9ysg.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $1pcyW.generateLocationFromPath)(route.path, (0, $ichJ5.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $gveRg.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $g9ysg.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $g9ysg.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $1pcyW.generateLocationFromPath)(route.path, (0, $ichJ5.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $gveRg.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $ichJ5.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $g9ysg.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $g9ysg.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $ichJ5.default)({}, existingPathParams, params);
            const updatedPath = (0, $4fMuX.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $ichJ5.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $g9ysg.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $g9ysg.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $2a40495b390796f6$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $g9ysg.isExternalAbsolutePath)(path)) {
                const location = (0, $g2zI4.parsePath)((0, $g9ysg.getRelativePath)(path, basePath));
                nextContext = (0, $4HiQA.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $3Rlvb.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $2a40495b390796f6$export$1cf0ecab63b1963c = (0, $2RDzF.createStore)({
    initialState: $2a40495b390796f6$export$36d128238e6b60f5,
    actions: $2a40495b390796f6$var$actions,
    name: 'router'
});
const $2a40495b390796f6$export$d6b817abe7a77ea5 = (0, $4CywU.createContainer)($2a40495b390796f6$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($2a40495b390796f6$var$actions.bootstrapStore(props));
            !(0, $9L4D5.isServerEnvironment)() && dispatch($2a40495b390796f6$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $9L4D5.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $2a40495b390796f6$export$9569010eab09ae9e = (0, $iouul.createHook)($2a40495b390796f6$export$1cf0ecab63b1963c);
const $2a40495b390796f6$export$ada49399abf7a3a1 = (0, $iouul.createActionsHook)($2a40495b390796f6$export$1cf0ecab63b1963c);
function $2a40495b390796f6$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $iouul.createHook)($2a40495b390796f6$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $2a40495b390796f6$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $7luw1.defaultRegistry).getStore($2a40495b390796f6$export$1cf0ecab63b1963c);
const $2a40495b390796f6$export$ebf37f7e180b13a9 = ()=>$2a40495b390796f6$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("3Rlvb", function(module, exports) {
$parcel$export(module.exports, "batch", () => $2cf70033803b9d33$export$712ea50be43a7858);
/* eslint-disable import/no-unresolved */ 
var $b2Ka1 = parcelRequire("b2Ka1");

var $iHSFb = parcelRequire("iHSFb");

var $nljJW = parcelRequire("nljJW");

var $5BJjl = parcelRequire("5BJjl");
let $2cf70033803b9d33$var$isInsideBatchedSchedule = false;
function $2cf70033803b9d33$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $nljJW.default).batchUpdates || !(0, $5BJjl.default).scheduling() || $2cf70033803b9d33$var$isInsideBatchedSchedule) return (0, $b2Ka1.unstable_batchedUpdates)(fn);
    $2cf70033803b9d33$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $iHSFb.unstable_scheduleCallback)((0, $iHSFb.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $b2Ka1.unstable_batchedUpdates)(fn);
        $2cf70033803b9d33$var$isInsideBatchedSchedule = false;
    });
}

});
parcelRegister("b2Ka1", function(module, exports) {
'use strict';
function $80a3b02a4885ee89$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($80a3b02a4885ee89$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$80a3b02a4885ee89$var$checkDCE();

module.exports = (parcelRequire("fw5os"));

});
parcelRegister("fw5os", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $b4be07302e235326$export$ae55be85d98224ed, (v) => $b4be07302e235326$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $b4be07302e235326$export$d39a5bbd09211389, (v) => $b4be07302e235326$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $b4be07302e235326$export$882461b6382ed46c, (v) => $b4be07302e235326$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $b4be07302e235326$export$466bfc07425424d5, (v) => $b4be07302e235326$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $b4be07302e235326$export$cd75ccfd720a3cd4, (v) => $b4be07302e235326$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $b4be07302e235326$export$fa8d919ba61d84db, (v) => $b4be07302e235326$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $b4be07302e235326$export$757ceba2d55c277e, (v) => $b4be07302e235326$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $b4be07302e235326$export$b3890eb0ae9dca99, (v) => $b4be07302e235326$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $b4be07302e235326$export$502457920280e6be, (v) => $b4be07302e235326$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $b4be07302e235326$export$c78a37762a8d58e1, (v) => $b4be07302e235326$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $b4be07302e235326$export$dc54d992c10e8a18, (v) => $b4be07302e235326$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $b4be07302e235326$export$83d89fbfd8236492, (v) => $b4be07302e235326$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b4be07302e235326$export$ae55be85d98224ed;
var $b4be07302e235326$export$d39a5bbd09211389;
var $b4be07302e235326$export$882461b6382ed46c;
var $b4be07302e235326$export$466bfc07425424d5;
var $b4be07302e235326$export$cd75ccfd720a3cd4;
var $b4be07302e235326$export$fa8d919ba61d84db;
var $b4be07302e235326$export$757ceba2d55c277e;
var $b4be07302e235326$export$b3890eb0ae9dca99;
var $b4be07302e235326$export$502457920280e6be;
var $b4be07302e235326$export$c78a37762a8d58e1;
var $b4be07302e235326$export$dc54d992c10e8a18;
var $b4be07302e235326$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $4fqPo = parcelRequire("4fqPo");

var $iHSFb = parcelRequire("iHSFb");
function $b4be07302e235326$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b4be07302e235326$var$da = new Set, $b4be07302e235326$var$ea = {};
function $b4be07302e235326$var$fa(a, b) {
    $b4be07302e235326$var$ha(a, b);
    $b4be07302e235326$var$ha(a + "Capture", b);
}
function $b4be07302e235326$var$ha(a, b) {
    $b4be07302e235326$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b4be07302e235326$var$da.add(b[a]);
}
var $b4be07302e235326$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b4be07302e235326$var$ja = Object.prototype.hasOwnProperty, $b4be07302e235326$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b4be07302e235326$var$la = {}, $b4be07302e235326$var$ma = {};
function $b4be07302e235326$var$na(a) {
    if ($b4be07302e235326$var$ja.call($b4be07302e235326$var$ma, a)) return !0;
    if ($b4be07302e235326$var$ja.call($b4be07302e235326$var$la, a)) return !1;
    if ($b4be07302e235326$var$ka.test(a)) return $b4be07302e235326$var$ma[a] = !0;
    $b4be07302e235326$var$la[a] = !0;
    return !1;
}
function $b4be07302e235326$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b4be07302e235326$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b4be07302e235326$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b4be07302e235326$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b4be07302e235326$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b4be07302e235326$var$t[b] = new $b4be07302e235326$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b4be07302e235326$var$ra = /[\-:]([a-z])/g;
function $b4be07302e235326$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b4be07302e235326$var$ra, $b4be07302e235326$var$ta);
    $b4be07302e235326$var$t[b] = new $b4be07302e235326$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b4be07302e235326$var$ra, $b4be07302e235326$var$ta);
    $b4be07302e235326$var$t[b] = new $b4be07302e235326$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b4be07302e235326$var$ra, $b4be07302e235326$var$ta);
    $b4be07302e235326$var$t[b] = new $b4be07302e235326$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b4be07302e235326$var$t.xlinkHref = new $b4be07302e235326$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b4be07302e235326$var$t[a] = new $b4be07302e235326$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b4be07302e235326$var$ua(a, b, c, d) {
    var e = $b4be07302e235326$var$t.hasOwnProperty(b) ? $b4be07302e235326$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b4be07302e235326$var$pa(b, c, e, d) && (c = null), d || null === e ? $b4be07302e235326$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b4be07302e235326$var$va = $4fqPo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b4be07302e235326$var$wa = Symbol.for("react.element"), $b4be07302e235326$var$xa = Symbol.for("react.portal"), $b4be07302e235326$var$ya = Symbol.for("react.fragment"), $b4be07302e235326$var$za = Symbol.for("react.strict_mode"), $b4be07302e235326$var$Aa = Symbol.for("react.profiler"), $b4be07302e235326$var$Ba = Symbol.for("react.provider"), $b4be07302e235326$var$Ca = Symbol.for("react.context"), $b4be07302e235326$var$Da = Symbol.for("react.forward_ref"), $b4be07302e235326$var$Ea = Symbol.for("react.suspense"), $b4be07302e235326$var$Fa = Symbol.for("react.suspense_list"), $b4be07302e235326$var$Ga = Symbol.for("react.memo"), $b4be07302e235326$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b4be07302e235326$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b4be07302e235326$var$Ja = Symbol.iterator;
function $b4be07302e235326$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b4be07302e235326$var$Ja && a[$b4be07302e235326$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b4be07302e235326$var$u = Object.assign, $b4be07302e235326$var$La;
function $b4be07302e235326$var$Ma(a) {
    if (void 0 === $b4be07302e235326$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b4be07302e235326$var$La = b && b[1] || "";
    }
    return "\n" + $b4be07302e235326$var$La + a;
}
var $b4be07302e235326$var$Na = !1;
function $b4be07302e235326$var$Oa(a, b) {
    if (!a || $b4be07302e235326$var$Na) return "";
    $b4be07302e235326$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b4be07302e235326$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b4be07302e235326$var$Ma(a) : "";
}
function $b4be07302e235326$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b4be07302e235326$var$Ma(a.type);
        case 16:
            return $b4be07302e235326$var$Ma("Lazy");
        case 13:
            return $b4be07302e235326$var$Ma("Suspense");
        case 19:
            return $b4be07302e235326$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b4be07302e235326$var$Oa(a.type, !1), a;
        case 11:
            return a = $b4be07302e235326$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b4be07302e235326$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b4be07302e235326$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b4be07302e235326$var$ya:
            return "Fragment";
        case $b4be07302e235326$var$xa:
            return "Portal";
        case $b4be07302e235326$var$Aa:
            return "Profiler";
        case $b4be07302e235326$var$za:
            return "StrictMode";
        case $b4be07302e235326$var$Ea:
            return "Suspense";
        case $b4be07302e235326$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b4be07302e235326$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b4be07302e235326$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b4be07302e235326$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b4be07302e235326$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b4be07302e235326$var$Qa(a.type) || "Memo";
        case $b4be07302e235326$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b4be07302e235326$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b4be07302e235326$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b4be07302e235326$var$Qa(b);
        case 8:
            return b === $b4be07302e235326$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b4be07302e235326$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b4be07302e235326$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b4be07302e235326$var$Ua(a) {
    var b = $b4be07302e235326$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b4be07302e235326$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b4be07302e235326$var$Ua(a));
}
function $b4be07302e235326$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b4be07302e235326$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b4be07302e235326$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b4be07302e235326$var$Ya(a, b) {
    var c = b.checked;
    return $b4be07302e235326$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b4be07302e235326$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b4be07302e235326$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b4be07302e235326$var$$a(a, b) {
    b = b.checked;
    null != b && $b4be07302e235326$var$ua(a, "checked", b, !1);
}
function $b4be07302e235326$var$ab(a, b) {
    $b4be07302e235326$var$$a(a, b);
    var c = $b4be07302e235326$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b4be07302e235326$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b4be07302e235326$var$bb(a, b.type, $b4be07302e235326$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b4be07302e235326$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b4be07302e235326$var$bb(a, b, c) {
    if ("number" !== b || $b4be07302e235326$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b4be07302e235326$var$db = Array.isArray;
function $b4be07302e235326$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b4be07302e235326$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b4be07302e235326$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b4be07302e235326$var$p(91));
    return $b4be07302e235326$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b4be07302e235326$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b4be07302e235326$var$p(92));
            if ($b4be07302e235326$var$db(c)) {
                if (1 < c.length) throw Error($b4be07302e235326$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b4be07302e235326$var$Sa(c)
    };
}
function $b4be07302e235326$var$hb(a, b) {
    var c = $b4be07302e235326$var$Sa(b.value), d = $b4be07302e235326$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b4be07302e235326$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b4be07302e235326$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b4be07302e235326$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b4be07302e235326$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b4be07302e235326$var$mb, $b4be07302e235326$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b4be07302e235326$var$mb = $b4be07302e235326$var$mb || document.createElement("div");
        $b4be07302e235326$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b4be07302e235326$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b4be07302e235326$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b4be07302e235326$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b4be07302e235326$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b4be07302e235326$var$pb).forEach(function(a) {
    $b4be07302e235326$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b4be07302e235326$var$pb[b] = $b4be07302e235326$var$pb[a];
    });
});
function $b4be07302e235326$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b4be07302e235326$var$pb.hasOwnProperty(a) && $b4be07302e235326$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b4be07302e235326$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b4be07302e235326$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b4be07302e235326$var$tb = $b4be07302e235326$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b4be07302e235326$var$ub(a, b) {
    if (b) {
        if ($b4be07302e235326$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b4be07302e235326$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b4be07302e235326$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b4be07302e235326$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b4be07302e235326$var$p(62));
    }
}
function $b4be07302e235326$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b4be07302e235326$var$wb = null;
function $b4be07302e235326$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b4be07302e235326$var$yb = null, $b4be07302e235326$var$zb = null, $b4be07302e235326$var$Ab = null;
function $b4be07302e235326$var$Bb(a) {
    if (a = $b4be07302e235326$var$Cb(a)) {
        if ("function" !== typeof $b4be07302e235326$var$yb) throw Error($b4be07302e235326$var$p(280));
        var b = a.stateNode;
        b && (b = $b4be07302e235326$var$Db(b), $b4be07302e235326$var$yb(a.stateNode, a.type, b));
    }
}
function $b4be07302e235326$var$Eb(a) {
    $b4be07302e235326$var$zb ? $b4be07302e235326$var$Ab ? $b4be07302e235326$var$Ab.push(a) : $b4be07302e235326$var$Ab = [
        a
    ] : $b4be07302e235326$var$zb = a;
}
function $b4be07302e235326$var$Fb() {
    if ($b4be07302e235326$var$zb) {
        var a = $b4be07302e235326$var$zb, b = $b4be07302e235326$var$Ab;
        $b4be07302e235326$var$Ab = $b4be07302e235326$var$zb = null;
        $b4be07302e235326$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b4be07302e235326$var$Bb(b[a]);
    }
}
function $b4be07302e235326$var$Gb(a, b) {
    return a(b);
}
function $b4be07302e235326$var$Hb() {}
var $b4be07302e235326$var$Ib = !1;
function $b4be07302e235326$var$Jb(a, b, c) {
    if ($b4be07302e235326$var$Ib) return a(b, c);
    $b4be07302e235326$var$Ib = !0;
    try {
        return $b4be07302e235326$var$Gb(a, b, c);
    } finally{
        if ($b4be07302e235326$var$Ib = !1, null !== $b4be07302e235326$var$zb || null !== $b4be07302e235326$var$Ab) $b4be07302e235326$var$Hb(), $b4be07302e235326$var$Fb();
    }
}
function $b4be07302e235326$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b4be07302e235326$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b4be07302e235326$var$p(231, b, typeof c));
    return c;
}
var $b4be07302e235326$var$Lb = !1;
if ($b4be07302e235326$var$ia) try {
    var $b4be07302e235326$var$Mb = {};
    Object.defineProperty($b4be07302e235326$var$Mb, "passive", {
        get: function() {
            $b4be07302e235326$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b4be07302e235326$var$Mb, $b4be07302e235326$var$Mb);
    window.removeEventListener("test", $b4be07302e235326$var$Mb, $b4be07302e235326$var$Mb);
} catch (a) {
    $b4be07302e235326$var$Lb = !1;
}
function $b4be07302e235326$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $b4be07302e235326$var$Ob = !1, $b4be07302e235326$var$Pb = null, $b4be07302e235326$var$Qb = !1, $b4be07302e235326$var$Rb = null, $b4be07302e235326$var$Sb = {
    onError: function(a) {
        $b4be07302e235326$var$Ob = !0;
        $b4be07302e235326$var$Pb = a;
    }
};
function $b4be07302e235326$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b4be07302e235326$var$Ob = !1;
    $b4be07302e235326$var$Pb = null;
    $b4be07302e235326$var$Nb.apply($b4be07302e235326$var$Sb, arguments);
}
function $b4be07302e235326$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b4be07302e235326$var$Tb.apply(this, arguments);
    if ($b4be07302e235326$var$Ob) {
        if ($b4be07302e235326$var$Ob) {
            var l = $b4be07302e235326$var$Pb;
            $b4be07302e235326$var$Ob = !1;
            $b4be07302e235326$var$Pb = null;
        } else throw Error($b4be07302e235326$var$p(198));
        $b4be07302e235326$var$Qb || ($b4be07302e235326$var$Qb = !0, $b4be07302e235326$var$Rb = l);
    }
}
function $b4be07302e235326$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b4be07302e235326$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b4be07302e235326$var$Xb(a) {
    if ($b4be07302e235326$var$Vb(a) !== a) throw Error($b4be07302e235326$var$p(188));
}
function $b4be07302e235326$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b4be07302e235326$var$Vb(a);
        if (null === b) throw Error($b4be07302e235326$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b4be07302e235326$var$Xb(e), a;
                if (f === d) return $b4be07302e235326$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b4be07302e235326$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b4be07302e235326$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b4be07302e235326$var$p(190));
    }
    if (3 !== c.tag) throw Error($b4be07302e235326$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b4be07302e235326$var$Zb(a) {
    a = $b4be07302e235326$var$Yb(a);
    return null !== a ? $b4be07302e235326$var$$b(a) : null;
}
function $b4be07302e235326$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b4be07302e235326$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b4be07302e235326$var$ac = $iHSFb.unstable_scheduleCallback, $b4be07302e235326$var$bc = $iHSFb.unstable_cancelCallback, $b4be07302e235326$var$cc = $iHSFb.unstable_shouldYield, $b4be07302e235326$var$dc = $iHSFb.unstable_requestPaint, $b4be07302e235326$var$A = $iHSFb.unstable_now, $b4be07302e235326$var$ec = $iHSFb.unstable_getCurrentPriorityLevel, $b4be07302e235326$var$fc = $iHSFb.unstable_ImmediatePriority, $b4be07302e235326$var$gc = $iHSFb.unstable_UserBlockingPriority, $b4be07302e235326$var$hc = $iHSFb.unstable_NormalPriority, $b4be07302e235326$var$ic = $iHSFb.unstable_LowPriority, $b4be07302e235326$var$jc = $iHSFb.unstable_IdlePriority, $b4be07302e235326$var$kc = null, $b4be07302e235326$var$lc = null, $b4be07302e235326$var$B = null, $b4be07302e235326$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $b4be07302e235326$var$nc(a, b) {
    if ($b4be07302e235326$var$lc && "function" === typeof $b4be07302e235326$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $b4be07302e235326$var$fc;
                break;
            case 4:
                d = $b4be07302e235326$var$gc;
                break;
            case 16:
                d = $b4be07302e235326$var$hc;
                break;
            case 536870912:
                d = $b4be07302e235326$var$jc;
                break;
            default:
                d = $b4be07302e235326$var$hc;
        }
        $b4be07302e235326$var$lc.onCommitFiberRoot($b4be07302e235326$var$kc, a, d, c);
    } catch (e) {}
}
function $b4be07302e235326$var$oc(a) {
    $b4be07302e235326$var$B = a;
}
function $b4be07302e235326$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $b4be07302e235326$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $b4be07302e235326$var$rc() {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markCommitStopped && $b4be07302e235326$var$B.markCommitStopped();
}
function $b4be07302e235326$var$sc(a) {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentRenderStarted && $b4be07302e235326$var$B.markComponentRenderStarted(a);
}
function $b4be07302e235326$var$tc() {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentRenderStopped && $b4be07302e235326$var$B.markComponentRenderStopped();
}
function $b4be07302e235326$var$uc(a) {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentLayoutEffectUnmountStarted && $b4be07302e235326$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $b4be07302e235326$var$vc() {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentLayoutEffectUnmountStopped && $b4be07302e235326$var$B.markComponentLayoutEffectUnmountStopped();
}
function $b4be07302e235326$var$wc(a) {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markRenderStarted && $b4be07302e235326$var$B.markRenderStarted(a);
}
function $b4be07302e235326$var$xc() {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markRenderStopped && $b4be07302e235326$var$B.markRenderStopped();
}
function $b4be07302e235326$var$yc(a, b) {
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markStateUpdateScheduled && $b4be07302e235326$var$B.markStateUpdateScheduled(a, b);
}
var $b4be07302e235326$var$Ac = Math.clz32 ? Math.clz32 : $b4be07302e235326$var$zc, $b4be07302e235326$var$Bc = Math.log, $b4be07302e235326$var$Cc = Math.LN2;
function $b4be07302e235326$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b4be07302e235326$var$Bc(a) / $b4be07302e235326$var$Cc | 0) | 0;
}
function $b4be07302e235326$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $b4be07302e235326$var$Dc = 64, $b4be07302e235326$var$Ec = 4194304;
function $b4be07302e235326$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b4be07302e235326$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b4be07302e235326$var$Fc(h) : (f &= g, 0 !== f && (d = $b4be07302e235326$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $b4be07302e235326$var$Fc(g) : 0 !== f && (d = $b4be07302e235326$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b4be07302e235326$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b4be07302e235326$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b4be07302e235326$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b4be07302e235326$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b4be07302e235326$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b4be07302e235326$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b4be07302e235326$var$Kc() {
    var a = $b4be07302e235326$var$Dc;
    $b4be07302e235326$var$Dc <<= 1;
    0 === ($b4be07302e235326$var$Dc & 4194240) && ($b4be07302e235326$var$Dc = 64);
    return a;
}
function $b4be07302e235326$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b4be07302e235326$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b4be07302e235326$var$Ac(b);
    a[b] = c;
}
function $b4be07302e235326$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b4be07302e235326$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b4be07302e235326$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b4be07302e235326$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $b4be07302e235326$var$Pc(a, b, c) {
    if ($b4be07302e235326$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $b4be07302e235326$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $b4be07302e235326$var$Qc(a, b) {
    if ($b4be07302e235326$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $b4be07302e235326$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $b4be07302e235326$var$E = 0;
function $b4be07302e235326$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b4be07302e235326$var$Sc, $b4be07302e235326$var$Tc, $b4be07302e235326$var$Uc, $b4be07302e235326$var$Vc, $b4be07302e235326$var$Wc, $b4be07302e235326$var$Xc = !1, $b4be07302e235326$var$Yc = [], $b4be07302e235326$var$Zc = null, $b4be07302e235326$var$$c = null, $b4be07302e235326$var$ad = null, $b4be07302e235326$var$bd = new Map, $b4be07302e235326$var$cd = new Map, $b4be07302e235326$var$dd = [], $b4be07302e235326$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b4be07302e235326$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b4be07302e235326$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b4be07302e235326$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $b4be07302e235326$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $b4be07302e235326$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b4be07302e235326$var$cd.delete(b.pointerId);
    }
}
function $b4be07302e235326$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b4be07302e235326$var$Cb(b), null !== b && $b4be07302e235326$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b4be07302e235326$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b4be07302e235326$var$Zc = $b4be07302e235326$var$gd($b4be07302e235326$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $b4be07302e235326$var$$c = $b4be07302e235326$var$gd($b4be07302e235326$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $b4be07302e235326$var$ad = $b4be07302e235326$var$gd($b4be07302e235326$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b4be07302e235326$var$bd.set(f, $b4be07302e235326$var$gd($b4be07302e235326$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b4be07302e235326$var$cd.set(f, $b4be07302e235326$var$gd($b4be07302e235326$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b4be07302e235326$var$id(a) {
    var b = $b4be07302e235326$var$jd(a.target);
    if (null !== b) {
        var c = $b4be07302e235326$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b4be07302e235326$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b4be07302e235326$var$Wc(a.priority, function() {
                        $b4be07302e235326$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b4be07302e235326$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b4be07302e235326$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b4be07302e235326$var$wb = d;
            c.target.dispatchEvent(d);
            $b4be07302e235326$var$wb = null;
        } else return b = $b4be07302e235326$var$Cb(c), null !== b && $b4be07302e235326$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b4be07302e235326$var$md(a, b, c) {
    $b4be07302e235326$var$kd(a) && c.delete(b);
}
function $b4be07302e235326$var$nd() {
    $b4be07302e235326$var$Xc = !1;
    null !== $b4be07302e235326$var$Zc && $b4be07302e235326$var$kd($b4be07302e235326$var$Zc) && ($b4be07302e235326$var$Zc = null);
    null !== $b4be07302e235326$var$$c && $b4be07302e235326$var$kd($b4be07302e235326$var$$c) && ($b4be07302e235326$var$$c = null);
    null !== $b4be07302e235326$var$ad && $b4be07302e235326$var$kd($b4be07302e235326$var$ad) && ($b4be07302e235326$var$ad = null);
    $b4be07302e235326$var$bd.forEach($b4be07302e235326$var$md);
    $b4be07302e235326$var$cd.forEach($b4be07302e235326$var$md);
}
function $b4be07302e235326$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b4be07302e235326$var$Xc || ($b4be07302e235326$var$Xc = !0, $iHSFb.unstable_scheduleCallback($iHSFb.unstable_NormalPriority, $b4be07302e235326$var$nd)));
}
function $b4be07302e235326$var$pd(a) {
    function b(b) {
        return $b4be07302e235326$var$od(b, a);
    }
    if (0 < $b4be07302e235326$var$Yc.length) {
        $b4be07302e235326$var$od($b4be07302e235326$var$Yc[0], a);
        for(var c = 1; c < $b4be07302e235326$var$Yc.length; c++){
            var d = $b4be07302e235326$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b4be07302e235326$var$Zc && $b4be07302e235326$var$od($b4be07302e235326$var$Zc, a);
    null !== $b4be07302e235326$var$$c && $b4be07302e235326$var$od($b4be07302e235326$var$$c, a);
    null !== $b4be07302e235326$var$ad && $b4be07302e235326$var$od($b4be07302e235326$var$ad, a);
    $b4be07302e235326$var$bd.forEach(b);
    $b4be07302e235326$var$cd.forEach(b);
    for(c = 0; c < $b4be07302e235326$var$dd.length; c++)d = $b4be07302e235326$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b4be07302e235326$var$dd.length && (c = $b4be07302e235326$var$dd[0], null === c.blockedOn);)$b4be07302e235326$var$id(c), null === c.blockedOn && $b4be07302e235326$var$dd.shift();
}
var $b4be07302e235326$var$qd = $b4be07302e235326$var$va.ReactCurrentBatchConfig, $b4be07302e235326$var$rd = !0;
function $b4be07302e235326$var$sd(a, b, c, d) {
    var e = $b4be07302e235326$var$E, f = $b4be07302e235326$var$qd.transition;
    $b4be07302e235326$var$qd.transition = null;
    try {
        $b4be07302e235326$var$E = 1, $b4be07302e235326$var$td(a, b, c, d);
    } finally{
        $b4be07302e235326$var$E = e, $b4be07302e235326$var$qd.transition = f;
    }
}
function $b4be07302e235326$var$ud(a, b, c, d) {
    var e = $b4be07302e235326$var$E, f = $b4be07302e235326$var$qd.transition;
    $b4be07302e235326$var$qd.transition = null;
    try {
        $b4be07302e235326$var$E = 4, $b4be07302e235326$var$td(a, b, c, d);
    } finally{
        $b4be07302e235326$var$E = e, $b4be07302e235326$var$qd.transition = f;
    }
}
function $b4be07302e235326$var$td(a, b, c, d) {
    if ($b4be07302e235326$var$rd) {
        var e = $b4be07302e235326$var$ld(a, b, c, d);
        if (null === e) $b4be07302e235326$var$vd(a, b, d, $b4be07302e235326$var$wd, c), $b4be07302e235326$var$fd(a, d);
        else if ($b4be07302e235326$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($b4be07302e235326$var$fd(a, d), b & 4 && -1 < $b4be07302e235326$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $b4be07302e235326$var$Cb(e);
                null !== f && $b4be07302e235326$var$Sc(f);
                f = $b4be07302e235326$var$ld(a, b, c, d);
                null === f && $b4be07302e235326$var$vd(a, b, d, $b4be07302e235326$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b4be07302e235326$var$vd(a, b, d, null, c);
    }
}
var $b4be07302e235326$var$wd = null;
function $b4be07302e235326$var$ld(a, b, c, d) {
    $b4be07302e235326$var$wd = null;
    a = $b4be07302e235326$var$xb(d);
    a = $b4be07302e235326$var$jd(a);
    if (null !== a) {
        if (b = $b4be07302e235326$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b4be07302e235326$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b4be07302e235326$var$wd = a;
    return null;
}
function $b4be07302e235326$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b4be07302e235326$var$ec()){
                case $b4be07302e235326$var$fc:
                    return 1;
                case $b4be07302e235326$var$gc:
                    return 4;
                case $b4be07302e235326$var$hc:
                case $b4be07302e235326$var$ic:
                    return 16;
                case $b4be07302e235326$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b4be07302e235326$var$yd = null, $b4be07302e235326$var$zd = null, $b4be07302e235326$var$Ad = null;
function $b4be07302e235326$var$Bd() {
    if ($b4be07302e235326$var$Ad) return $b4be07302e235326$var$Ad;
    var a, b = $b4be07302e235326$var$zd, c = b.length, d, e = "value" in $b4be07302e235326$var$yd ? $b4be07302e235326$var$yd.value : $b4be07302e235326$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b4be07302e235326$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b4be07302e235326$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b4be07302e235326$var$Dd() {
    return !0;
}
function $b4be07302e235326$var$Ed() {
    return !1;
}
function $b4be07302e235326$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b4be07302e235326$var$Dd : $b4be07302e235326$var$Ed;
        this.isPropagationStopped = $b4be07302e235326$var$Ed;
        return this;
    }
    $b4be07302e235326$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b4be07302e235326$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b4be07302e235326$var$Dd);
        },
        persist: function() {},
        isPersistent: $b4be07302e235326$var$Dd
    });
    return b;
}
var $b4be07302e235326$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b4be07302e235326$var$Hd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Gd), $b4be07302e235326$var$Id = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Gd, {
    view: 0,
    detail: 0
}), $b4be07302e235326$var$Jd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Id), $b4be07302e235326$var$Kd, $b4be07302e235326$var$Ld, $b4be07302e235326$var$Md, $b4be07302e235326$var$Od = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b4be07302e235326$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b4be07302e235326$var$Md && ($b4be07302e235326$var$Md && "mousemove" === a.type ? ($b4be07302e235326$var$Kd = a.screenX - $b4be07302e235326$var$Md.screenX, $b4be07302e235326$var$Ld = a.screenY - $b4be07302e235326$var$Md.screenY) : $b4be07302e235326$var$Ld = $b4be07302e235326$var$Kd = 0, $b4be07302e235326$var$Md = a);
        return $b4be07302e235326$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b4be07302e235326$var$Ld;
    }
}), $b4be07302e235326$var$Pd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Od), $b4be07302e235326$var$Qd = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Od, {
    dataTransfer: 0
}), $b4be07302e235326$var$Rd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Qd), $b4be07302e235326$var$Sd = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Id, {
    relatedTarget: 0
}), $b4be07302e235326$var$Td = $b4be07302e235326$var$Fd($b4be07302e235326$var$Sd), $b4be07302e235326$var$Ud = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b4be07302e235326$var$Vd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Ud), $b4be07302e235326$var$Wd = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b4be07302e235326$var$Xd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Wd), $b4be07302e235326$var$Yd = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Gd, {
    data: 0
}), $b4be07302e235326$var$Zd = $b4be07302e235326$var$Fd($b4be07302e235326$var$Yd), $b4be07302e235326$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b4be07302e235326$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b4be07302e235326$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b4be07302e235326$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b4be07302e235326$var$be[a]) ? !!b[a] : !1;
}
function $b4be07302e235326$var$Nd() {
    return $b4be07302e235326$var$ce;
}
var $b4be07302e235326$var$de = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $b4be07302e235326$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b4be07302e235326$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b4be07302e235326$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b4be07302e235326$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $b4be07302e235326$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b4be07302e235326$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b4be07302e235326$var$ee = $b4be07302e235326$var$Fd($b4be07302e235326$var$de), $b4be07302e235326$var$fe = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b4be07302e235326$var$ge = $b4be07302e235326$var$Fd($b4be07302e235326$var$fe), $b4be07302e235326$var$he = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b4be07302e235326$var$Nd
}), $b4be07302e235326$var$ie = $b4be07302e235326$var$Fd($b4be07302e235326$var$he), $b4be07302e235326$var$je = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b4be07302e235326$var$ke = $b4be07302e235326$var$Fd($b4be07302e235326$var$je), $b4be07302e235326$var$le = $b4be07302e235326$var$u({}, $b4be07302e235326$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b4be07302e235326$var$me = $b4be07302e235326$var$Fd($b4be07302e235326$var$le), $b4be07302e235326$var$ne = [
    9,
    13,
    27,
    32
], $b4be07302e235326$var$oe = $b4be07302e235326$var$ia && "CompositionEvent" in window, $b4be07302e235326$var$pe = null;
$b4be07302e235326$var$ia && "documentMode" in document && ($b4be07302e235326$var$pe = document.documentMode);
var $b4be07302e235326$var$qe = $b4be07302e235326$var$ia && "TextEvent" in window && !$b4be07302e235326$var$pe, $b4be07302e235326$var$re = $b4be07302e235326$var$ia && (!$b4be07302e235326$var$oe || $b4be07302e235326$var$pe && 8 < $b4be07302e235326$var$pe && 11 >= $b4be07302e235326$var$pe), $b4be07302e235326$var$se = String.fromCharCode(32), $b4be07302e235326$var$te = !1;
function $b4be07302e235326$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b4be07302e235326$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b4be07302e235326$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b4be07302e235326$var$we = !1;
function $b4be07302e235326$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $b4be07302e235326$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b4be07302e235326$var$te = !0;
            return $b4be07302e235326$var$se;
        case "textInput":
            return a = b.data, a === $b4be07302e235326$var$se && $b4be07302e235326$var$te ? null : a;
        default:
            return null;
    }
}
function $b4be07302e235326$var$ye(a, b) {
    if ($b4be07302e235326$var$we) return "compositionend" === a || !$b4be07302e235326$var$oe && $b4be07302e235326$var$ue(a, b) ? (a = $b4be07302e235326$var$Bd(), $b4be07302e235326$var$Ad = $b4be07302e235326$var$zd = $b4be07302e235326$var$yd = null, $b4be07302e235326$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b4be07302e235326$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b4be07302e235326$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b4be07302e235326$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b4be07302e235326$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $b4be07302e235326$var$Be(a, b, c, d) {
    $b4be07302e235326$var$Eb(d);
    b = $b4be07302e235326$var$Ce(b, "onChange");
    0 < b.length && (c = new $b4be07302e235326$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b4be07302e235326$var$De = null, $b4be07302e235326$var$Ee = null;
function $b4be07302e235326$var$Fe(a) {
    $b4be07302e235326$var$Ge(a, 0);
}
function $b4be07302e235326$var$He(a) {
    var b = $b4be07302e235326$var$Ie(a);
    if ($b4be07302e235326$var$Wa(b)) return a;
}
function $b4be07302e235326$var$Je(a, b) {
    if ("change" === a) return b;
}
var $b4be07302e235326$var$Ke = !1;
if ($b4be07302e235326$var$ia) {
    var $b4be07302e235326$var$Le;
    if ($b4be07302e235326$var$ia) {
        var $b4be07302e235326$var$Me = "oninput" in document;
        if (!$b4be07302e235326$var$Me) {
            var $b4be07302e235326$var$Ne = document.createElement("div");
            $b4be07302e235326$var$Ne.setAttribute("oninput", "return;");
            $b4be07302e235326$var$Me = "function" === typeof $b4be07302e235326$var$Ne.oninput;
        }
        $b4be07302e235326$var$Le = $b4be07302e235326$var$Me;
    } else $b4be07302e235326$var$Le = !1;
    $b4be07302e235326$var$Ke = $b4be07302e235326$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $b4be07302e235326$var$Oe() {
    $b4be07302e235326$var$De && ($b4be07302e235326$var$De.detachEvent("onpropertychange", $b4be07302e235326$var$Pe), $b4be07302e235326$var$Ee = $b4be07302e235326$var$De = null);
}
function $b4be07302e235326$var$Pe(a) {
    if ("value" === a.propertyName && $b4be07302e235326$var$He($b4be07302e235326$var$Ee)) {
        var b = [];
        $b4be07302e235326$var$Be(b, $b4be07302e235326$var$Ee, a, $b4be07302e235326$var$xb(a));
        $b4be07302e235326$var$Jb($b4be07302e235326$var$Fe, b);
    }
}
function $b4be07302e235326$var$Qe(a, b, c) {
    "focusin" === a ? ($b4be07302e235326$var$Oe(), $b4be07302e235326$var$De = b, $b4be07302e235326$var$Ee = c, $b4be07302e235326$var$De.attachEvent("onpropertychange", $b4be07302e235326$var$Pe)) : "focusout" === a && $b4be07302e235326$var$Oe();
}
function $b4be07302e235326$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b4be07302e235326$var$He($b4be07302e235326$var$Ee);
}
function $b4be07302e235326$var$Se(a, b) {
    if ("click" === a) return $b4be07302e235326$var$He(b);
}
function $b4be07302e235326$var$Te(a, b) {
    if ("input" === a || "change" === a) return $b4be07302e235326$var$He(b);
}
function $b4be07302e235326$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b4be07302e235326$var$Ve = "function" === typeof Object.is ? Object.is : $b4be07302e235326$var$Ue;
function $b4be07302e235326$var$We(a, b) {
    if ($b4be07302e235326$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b4be07302e235326$var$ja.call(b, e) || !$b4be07302e235326$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $b4be07302e235326$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b4be07302e235326$var$Ye(a, b) {
    var c = $b4be07302e235326$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b4be07302e235326$var$Xe(c);
    }
}
function $b4be07302e235326$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b4be07302e235326$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b4be07302e235326$var$$e() {
    for(var a = window, b = $b4be07302e235326$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b4be07302e235326$var$Xa(a.document);
    }
    return b;
}
function $b4be07302e235326$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b4be07302e235326$var$bf(a) {
    var b = $b4be07302e235326$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b4be07302e235326$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b4be07302e235326$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b4be07302e235326$var$Ye(c, f);
                var g = $b4be07302e235326$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b4be07302e235326$var$cf = $b4be07302e235326$var$ia && "documentMode" in document && 11 >= document.documentMode, $b4be07302e235326$var$df = null, $b4be07302e235326$var$ef = null, $b4be07302e235326$var$ff = null, $b4be07302e235326$var$gf = !1;
function $b4be07302e235326$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b4be07302e235326$var$gf || null == $b4be07302e235326$var$df || $b4be07302e235326$var$df !== $b4be07302e235326$var$Xa(d) || (d = $b4be07302e235326$var$df, "selectionStart" in d && $b4be07302e235326$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b4be07302e235326$var$ff && $b4be07302e235326$var$We($b4be07302e235326$var$ff, d) || ($b4be07302e235326$var$ff = d, d = $b4be07302e235326$var$Ce($b4be07302e235326$var$ef, "onSelect"), 0 < d.length && (b = new $b4be07302e235326$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b4be07302e235326$var$df)));
}
function $b4be07302e235326$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b4be07302e235326$var$kf = {
    animationend: $b4be07302e235326$var$jf("Animation", "AnimationEnd"),
    animationiteration: $b4be07302e235326$var$jf("Animation", "AnimationIteration"),
    animationstart: $b4be07302e235326$var$jf("Animation", "AnimationStart"),
    transitionend: $b4be07302e235326$var$jf("Transition", "TransitionEnd")
}, $b4be07302e235326$var$lf = {}, $b4be07302e235326$var$mf = {};
$b4be07302e235326$var$ia && ($b4be07302e235326$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $b4be07302e235326$var$kf.animationend.animation, delete $b4be07302e235326$var$kf.animationiteration.animation, delete $b4be07302e235326$var$kf.animationstart.animation), "TransitionEvent" in window || delete $b4be07302e235326$var$kf.transitionend.transition);
function $b4be07302e235326$var$nf(a) {
    if ($b4be07302e235326$var$lf[a]) return $b4be07302e235326$var$lf[a];
    if (!$b4be07302e235326$var$kf[a]) return a;
    var b = $b4be07302e235326$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b4be07302e235326$var$mf) return $b4be07302e235326$var$lf[a] = b[c];
    return a;
}
var $b4be07302e235326$var$of = $b4be07302e235326$var$nf("animationend"), $b4be07302e235326$var$pf = $b4be07302e235326$var$nf("animationiteration"), $b4be07302e235326$var$qf = $b4be07302e235326$var$nf("animationstart"), $b4be07302e235326$var$rf = $b4be07302e235326$var$nf("transitionend"), $b4be07302e235326$var$sf = new Map, $b4be07302e235326$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b4be07302e235326$var$uf(a, b) {
    $b4be07302e235326$var$sf.set(a, b);
    $b4be07302e235326$var$fa(b, [
        a
    ]);
}
for(var $b4be07302e235326$var$vf = 0; $b4be07302e235326$var$vf < $b4be07302e235326$var$tf.length; $b4be07302e235326$var$vf++){
    var $b4be07302e235326$var$wf = $b4be07302e235326$var$tf[$b4be07302e235326$var$vf], $b4be07302e235326$var$xf = $b4be07302e235326$var$wf.toLowerCase(), $b4be07302e235326$var$yf = $b4be07302e235326$var$wf[0].toUpperCase() + $b4be07302e235326$var$wf.slice(1);
    $b4be07302e235326$var$uf($b4be07302e235326$var$xf, "on" + $b4be07302e235326$var$yf);
}
$b4be07302e235326$var$uf($b4be07302e235326$var$of, "onAnimationEnd");
$b4be07302e235326$var$uf($b4be07302e235326$var$pf, "onAnimationIteration");
$b4be07302e235326$var$uf($b4be07302e235326$var$qf, "onAnimationStart");
$b4be07302e235326$var$uf("dblclick", "onDoubleClick");
$b4be07302e235326$var$uf("focusin", "onFocus");
$b4be07302e235326$var$uf("focusout", "onBlur");
$b4be07302e235326$var$uf($b4be07302e235326$var$rf, "onTransitionEnd");
$b4be07302e235326$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b4be07302e235326$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b4be07302e235326$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b4be07302e235326$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b4be07302e235326$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b4be07302e235326$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b4be07302e235326$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b4be07302e235326$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b4be07302e235326$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b4be07302e235326$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b4be07302e235326$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b4be07302e235326$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($b4be07302e235326$var$zf));
function $b4be07302e235326$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b4be07302e235326$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b4be07302e235326$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b4be07302e235326$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b4be07302e235326$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($b4be07302e235326$var$Qb) throw a = $b4be07302e235326$var$Rb, $b4be07302e235326$var$Qb = !1, $b4be07302e235326$var$Rb = null, a;
}
function $b4be07302e235326$var$F(a, b) {
    var c = b[$b4be07302e235326$var$Cf];
    void 0 === c && (c = b[$b4be07302e235326$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b4be07302e235326$var$Df(b, a, 2, !1), c.add(d));
}
function $b4be07302e235326$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b4be07302e235326$var$Df(c, a, d, b);
}
var $b4be07302e235326$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $b4be07302e235326$var$Gf(a) {
    if (!a[$b4be07302e235326$var$Ff]) {
        a[$b4be07302e235326$var$Ff] = !0;
        $b4be07302e235326$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b4be07302e235326$var$Af.has(b) || $b4be07302e235326$var$Ef(b, !1, a), $b4be07302e235326$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b4be07302e235326$var$Ff] || (b[$b4be07302e235326$var$Ff] = !0, $b4be07302e235326$var$Ef("selectionchange", !1, b));
    }
}
function $b4be07302e235326$var$Df(a, b, c, d) {
    switch($b4be07302e235326$var$xd(b)){
        case 1:
            var e = $b4be07302e235326$var$sd;
            break;
        case 4:
            e = $b4be07302e235326$var$ud;
            break;
        default:
            e = $b4be07302e235326$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b4be07302e235326$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b4be07302e235326$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b4be07302e235326$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b4be07302e235326$var$Jb(function() {
        var d = f, e = $b4be07302e235326$var$xb(c), g = [];
        a: {
            var h = $b4be07302e235326$var$sf.get(a);
            if (void 0 !== h) {
                var k = $b4be07302e235326$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $b4be07302e235326$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b4be07302e235326$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $b4be07302e235326$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $b4be07302e235326$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b4be07302e235326$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b4be07302e235326$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b4be07302e235326$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b4be07302e235326$var$ie;
                        break;
                    case $b4be07302e235326$var$of:
                    case $b4be07302e235326$var$pf:
                    case $b4be07302e235326$var$qf:
                        k = $b4be07302e235326$var$Vd;
                        break;
                    case $b4be07302e235326$var$rf:
                        k = $b4be07302e235326$var$ke;
                        break;
                    case "scroll":
                        k = $b4be07302e235326$var$Jd;
                        break;
                    case "wheel":
                        k = $b4be07302e235326$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b4be07302e235326$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b4be07302e235326$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $b4be07302e235326$var$Kb(y, x), null != D && w.push($b4be07302e235326$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b4be07302e235326$var$wb && (m = c.relatedTarget || c.fromElement) && ($b4be07302e235326$var$jd(m) || m[$b4be07302e235326$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $b4be07302e235326$var$jd(m) : null, null !== m && (C = $b4be07302e235326$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $b4be07302e235326$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $b4be07302e235326$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $b4be07302e235326$var$Ie(k);
                        v = null == m ? h : $b4be07302e235326$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $b4be07302e235326$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $b4be07302e235326$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $b4be07302e235326$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $b4be07302e235326$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $b4be07302e235326$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $b4be07302e235326$var$Jf(w);
                                x = $b4be07302e235326$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $b4be07302e235326$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $b4be07302e235326$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $b4be07302e235326$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $b4be07302e235326$var$Je;
                else if ($b4be07302e235326$var$Ae(h)) {
                    if ($b4be07302e235326$var$Ke) ca = $b4be07302e235326$var$Te;
                    else {
                        ca = $b4be07302e235326$var$Re;
                        var R = $b4be07302e235326$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $b4be07302e235326$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $b4be07302e235326$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $b4be07302e235326$var$bb(h, "number", h.value);
            }
            R = d ? $b4be07302e235326$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($b4be07302e235326$var$Ae(R) || "true" === R.contentEditable) $b4be07302e235326$var$df = R, $b4be07302e235326$var$ef = d, $b4be07302e235326$var$ff = null;
                    break;
                case "focusout":
                    $b4be07302e235326$var$ff = $b4be07302e235326$var$ef = $b4be07302e235326$var$df = null;
                    break;
                case "mousedown":
                    $b4be07302e235326$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b4be07302e235326$var$gf = !1;
                    $b4be07302e235326$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($b4be07302e235326$var$cf) break;
                case "keydown":
                case "keyup":
                    $b4be07302e235326$var$hf(g, c, e);
            }
            var sa;
            if ($b4be07302e235326$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $b4be07302e235326$var$we ? $b4be07302e235326$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($b4be07302e235326$var$re && "ko" !== c.locale && ($b4be07302e235326$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $b4be07302e235326$var$we && (sa = $b4be07302e235326$var$Bd()) : ($b4be07302e235326$var$yd = e, $b4be07302e235326$var$zd = "value" in $b4be07302e235326$var$yd ? $b4be07302e235326$var$yd.value : $b4be07302e235326$var$yd.textContent, $b4be07302e235326$var$we = !0)), R = $b4be07302e235326$var$Ce(d, V), 0 < R.length && (V = new $b4be07302e235326$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $b4be07302e235326$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $b4be07302e235326$var$qe ? $b4be07302e235326$var$xe(a, c) : $b4be07302e235326$var$ye(a, c)) d = $b4be07302e235326$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $b4be07302e235326$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $b4be07302e235326$var$Ge(g, b);
    });
}
function $b4be07302e235326$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b4be07302e235326$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b4be07302e235326$var$Kb(a, c), null != f && d.unshift($b4be07302e235326$var$Hf(a, f, e)), f = $b4be07302e235326$var$Kb(a, b), null != f && d.push($b4be07302e235326$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b4be07302e235326$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b4be07302e235326$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b4be07302e235326$var$Kb(c, f), null != k && g.unshift($b4be07302e235326$var$Hf(c, k, h))) : e || (k = $b4be07302e235326$var$Kb(c, f), null != k && g.push($b4be07302e235326$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b4be07302e235326$var$Lf = /\r\n?/g, $b4be07302e235326$var$Mf = /\u0000|\uFFFD/g;
function $b4be07302e235326$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b4be07302e235326$var$Lf, "\n").replace($b4be07302e235326$var$Mf, "");
}
function $b4be07302e235326$var$Of(a, b, c) {
    b = $b4be07302e235326$var$Nf(b);
    if ($b4be07302e235326$var$Nf(a) !== b && c) throw Error($b4be07302e235326$var$p(425));
}
function $b4be07302e235326$var$Pf() {}
var $b4be07302e235326$var$Qf = null, $b4be07302e235326$var$Rf = null;
function $b4be07302e235326$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b4be07302e235326$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $b4be07302e235326$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b4be07302e235326$var$Vf = "function" === typeof Promise ? Promise : void 0, $b4be07302e235326$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b4be07302e235326$var$Vf ? function(a) {
    return $b4be07302e235326$var$Vf.resolve(null).then(a).catch($b4be07302e235326$var$Wf);
} : $b4be07302e235326$var$Tf;
function $b4be07302e235326$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b4be07302e235326$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b4be07302e235326$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b4be07302e235326$var$pd(b);
}
function $b4be07302e235326$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b4be07302e235326$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b4be07302e235326$var$ag = Math.random().toString(36).slice(2), $b4be07302e235326$var$bg = "__reactFiber$" + $b4be07302e235326$var$ag, $b4be07302e235326$var$cg = "__reactProps$" + $b4be07302e235326$var$ag, $b4be07302e235326$var$If = "__reactContainer$" + $b4be07302e235326$var$ag, $b4be07302e235326$var$Cf = "__reactEvents$" + $b4be07302e235326$var$ag, $b4be07302e235326$var$dg = "__reactListeners$" + $b4be07302e235326$var$ag, $b4be07302e235326$var$eg = "__reactHandles$" + $b4be07302e235326$var$ag;
function $b4be07302e235326$var$jd(a) {
    var b = a[$b4be07302e235326$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b4be07302e235326$var$If] || c[$b4be07302e235326$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b4be07302e235326$var$$f(a); null !== a;){
                if (c = a[$b4be07302e235326$var$bg]) return c;
                a = $b4be07302e235326$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b4be07302e235326$var$Cb(a) {
    a = a[$b4be07302e235326$var$bg] || a[$b4be07302e235326$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b4be07302e235326$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b4be07302e235326$var$p(33));
}
function $b4be07302e235326$var$Db(a) {
    return a[$b4be07302e235326$var$cg] || null;
}
var $b4be07302e235326$var$fg = [], $b4be07302e235326$var$gg = -1;
function $b4be07302e235326$var$hg(a) {
    return {
        current: a
    };
}
function $b4be07302e235326$var$G(a) {
    0 > $b4be07302e235326$var$gg || (a.current = $b4be07302e235326$var$fg[$b4be07302e235326$var$gg], $b4be07302e235326$var$fg[$b4be07302e235326$var$gg] = null, $b4be07302e235326$var$gg--);
}
function $b4be07302e235326$var$H(a, b) {
    $b4be07302e235326$var$gg++;
    $b4be07302e235326$var$fg[$b4be07302e235326$var$gg] = a.current;
    a.current = b;
}
var $b4be07302e235326$var$ig = {}, $b4be07302e235326$var$I = $b4be07302e235326$var$hg($b4be07302e235326$var$ig), $b4be07302e235326$var$jg = $b4be07302e235326$var$hg(!1), $b4be07302e235326$var$kg = $b4be07302e235326$var$ig;
function $b4be07302e235326$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b4be07302e235326$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b4be07302e235326$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b4be07302e235326$var$ng() {
    $b4be07302e235326$var$G($b4be07302e235326$var$jg);
    $b4be07302e235326$var$G($b4be07302e235326$var$I);
}
function $b4be07302e235326$var$og(a, b, c) {
    if ($b4be07302e235326$var$I.current !== $b4be07302e235326$var$ig) throw Error($b4be07302e235326$var$p(168));
    $b4be07302e235326$var$H($b4be07302e235326$var$I, b);
    $b4be07302e235326$var$H($b4be07302e235326$var$jg, c);
}
function $b4be07302e235326$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b4be07302e235326$var$p(108, $b4be07302e235326$var$Ra(a) || "Unknown", e));
    return $b4be07302e235326$var$u({}, c, d);
}
function $b4be07302e235326$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b4be07302e235326$var$ig;
    $b4be07302e235326$var$kg = $b4be07302e235326$var$I.current;
    $b4be07302e235326$var$H($b4be07302e235326$var$I, a);
    $b4be07302e235326$var$H($b4be07302e235326$var$jg, $b4be07302e235326$var$jg.current);
    return !0;
}
function $b4be07302e235326$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b4be07302e235326$var$p(169));
    c ? (a = $b4be07302e235326$var$pg(a, b, $b4be07302e235326$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $b4be07302e235326$var$G($b4be07302e235326$var$jg), $b4be07302e235326$var$G($b4be07302e235326$var$I), $b4be07302e235326$var$H($b4be07302e235326$var$I, a)) : $b4be07302e235326$var$G($b4be07302e235326$var$jg);
    $b4be07302e235326$var$H($b4be07302e235326$var$jg, c);
}
var $b4be07302e235326$var$sg = null, $b4be07302e235326$var$tg = !1, $b4be07302e235326$var$ug = !1;
function $b4be07302e235326$var$vg(a) {
    null === $b4be07302e235326$var$sg ? $b4be07302e235326$var$sg = [
        a
    ] : $b4be07302e235326$var$sg.push(a);
}
function $b4be07302e235326$var$wg(a) {
    $b4be07302e235326$var$tg = !0;
    $b4be07302e235326$var$vg(a);
}
function $b4be07302e235326$var$xg() {
    if (!$b4be07302e235326$var$ug && null !== $b4be07302e235326$var$sg) {
        $b4be07302e235326$var$ug = !0;
        var a = 0, b = $b4be07302e235326$var$E;
        try {
            var c = $b4be07302e235326$var$sg;
            for($b4be07302e235326$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b4be07302e235326$var$sg = null;
            $b4be07302e235326$var$tg = !1;
        } catch (e) {
            throw null !== $b4be07302e235326$var$sg && ($b4be07302e235326$var$sg = $b4be07302e235326$var$sg.slice(a + 1)), $b4be07302e235326$var$ac($b4be07302e235326$var$fc, $b4be07302e235326$var$xg), e;
        } finally{
            $b4be07302e235326$var$E = b, $b4be07302e235326$var$ug = !1;
        }
    }
    return null;
}
var $b4be07302e235326$var$yg = [], $b4be07302e235326$var$zg = 0, $b4be07302e235326$var$Ag = null, $b4be07302e235326$var$Bg = 0, $b4be07302e235326$var$Cg = [], $b4be07302e235326$var$Dg = 0, $b4be07302e235326$var$Eg = null, $b4be07302e235326$var$Fg = 1, $b4be07302e235326$var$Gg = "";
function $b4be07302e235326$var$Hg(a, b) {
    $b4be07302e235326$var$yg[$b4be07302e235326$var$zg++] = $b4be07302e235326$var$Bg;
    $b4be07302e235326$var$yg[$b4be07302e235326$var$zg++] = $b4be07302e235326$var$Ag;
    $b4be07302e235326$var$Ag = a;
    $b4be07302e235326$var$Bg = b;
}
function $b4be07302e235326$var$Ig(a, b, c) {
    $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg++] = $b4be07302e235326$var$Fg;
    $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg++] = $b4be07302e235326$var$Gg;
    $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg++] = $b4be07302e235326$var$Eg;
    $b4be07302e235326$var$Eg = a;
    var d = $b4be07302e235326$var$Fg;
    a = $b4be07302e235326$var$Gg;
    var e = 32 - $b4be07302e235326$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b4be07302e235326$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b4be07302e235326$var$Fg = 1 << 32 - $b4be07302e235326$var$Ac(b) + e | c << e | d;
        $b4be07302e235326$var$Gg = f + a;
    } else $b4be07302e235326$var$Fg = 1 << f | c << e | d, $b4be07302e235326$var$Gg = a;
}
function $b4be07302e235326$var$Jg(a) {
    null !== a.return && ($b4be07302e235326$var$Hg(a, 1), $b4be07302e235326$var$Ig(a, 1, 0));
}
function $b4be07302e235326$var$Kg(a) {
    for(; a === $b4be07302e235326$var$Ag;)$b4be07302e235326$var$Ag = $b4be07302e235326$var$yg[--$b4be07302e235326$var$zg], $b4be07302e235326$var$yg[$b4be07302e235326$var$zg] = null, $b4be07302e235326$var$Bg = $b4be07302e235326$var$yg[--$b4be07302e235326$var$zg], $b4be07302e235326$var$yg[$b4be07302e235326$var$zg] = null;
    for(; a === $b4be07302e235326$var$Eg;)$b4be07302e235326$var$Eg = $b4be07302e235326$var$Cg[--$b4be07302e235326$var$Dg], $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg] = null, $b4be07302e235326$var$Gg = $b4be07302e235326$var$Cg[--$b4be07302e235326$var$Dg], $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg] = null, $b4be07302e235326$var$Fg = $b4be07302e235326$var$Cg[--$b4be07302e235326$var$Dg], $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg] = null;
}
var $b4be07302e235326$var$Lg = null, $b4be07302e235326$var$Mg = null, $b4be07302e235326$var$J = !1, $b4be07302e235326$var$Ng = null;
function $b4be07302e235326$var$Og(a, b) {
    var c = $b4be07302e235326$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b4be07302e235326$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b4be07302e235326$var$Lg = a, $b4be07302e235326$var$Mg = $b4be07302e235326$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b4be07302e235326$var$Lg = a, $b4be07302e235326$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b4be07302e235326$var$Eg ? {
                id: $b4be07302e235326$var$Fg,
                overflow: $b4be07302e235326$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b4be07302e235326$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b4be07302e235326$var$Lg = a, $b4be07302e235326$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b4be07302e235326$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b4be07302e235326$var$Sg(a) {
    if ($b4be07302e235326$var$J) {
        var b = $b4be07302e235326$var$Mg;
        if (b) {
            var c = b;
            if (!$b4be07302e235326$var$Qg(a, b)) {
                if ($b4be07302e235326$var$Rg(a)) throw Error($b4be07302e235326$var$p(418));
                b = $b4be07302e235326$var$Zf(c.nextSibling);
                var d = $b4be07302e235326$var$Lg;
                b && $b4be07302e235326$var$Qg(a, b) ? $b4be07302e235326$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $b4be07302e235326$var$J = !1, $b4be07302e235326$var$Lg = a);
            }
        } else {
            if ($b4be07302e235326$var$Rg(a)) throw Error($b4be07302e235326$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b4be07302e235326$var$J = !1;
            $b4be07302e235326$var$Lg = a;
        }
    }
}
function $b4be07302e235326$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b4be07302e235326$var$Lg = a;
}
function $b4be07302e235326$var$Ug(a) {
    if (a !== $b4be07302e235326$var$Lg) return !1;
    if (!$b4be07302e235326$var$J) return $b4be07302e235326$var$Tg(a), $b4be07302e235326$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b4be07302e235326$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $b4be07302e235326$var$Mg)) {
        if ($b4be07302e235326$var$Rg(a)) throw $b4be07302e235326$var$Vg(), Error($b4be07302e235326$var$p(418));
        for(; b;)$b4be07302e235326$var$Og(a, b), b = $b4be07302e235326$var$Zf(b.nextSibling);
    }
    $b4be07302e235326$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b4be07302e235326$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b4be07302e235326$var$Mg = $b4be07302e235326$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b4be07302e235326$var$Mg = null;
        }
    } else $b4be07302e235326$var$Mg = $b4be07302e235326$var$Lg ? $b4be07302e235326$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b4be07302e235326$var$Vg() {
    for(var a = $b4be07302e235326$var$Mg; a;)a = $b4be07302e235326$var$Zf(a.nextSibling);
}
function $b4be07302e235326$var$Wg() {
    $b4be07302e235326$var$Mg = $b4be07302e235326$var$Lg = null;
    $b4be07302e235326$var$J = !1;
}
function $b4be07302e235326$var$Xg(a) {
    null === $b4be07302e235326$var$Ng ? $b4be07302e235326$var$Ng = [
        a
    ] : $b4be07302e235326$var$Ng.push(a);
}
var $b4be07302e235326$var$Yg = $b4be07302e235326$var$va.ReactCurrentBatchConfig;
function $b4be07302e235326$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b4be07302e235326$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b4be07302e235326$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b4be07302e235326$var$p(284));
        if (!c._owner) throw Error($b4be07302e235326$var$p(290, a));
    }
    return a;
}
function $b4be07302e235326$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b4be07302e235326$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b4be07302e235326$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $b4be07302e235326$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b4be07302e235326$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b4be07302e235326$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b4be07302e235326$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b4be07302e235326$var$Ha && $b4be07302e235326$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $b4be07302e235326$var$Zg(a, b, c), d.return = a, d;
        d = $b4be07302e235326$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b4be07302e235326$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b4be07302e235326$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b4be07302e235326$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b4be07302e235326$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b4be07302e235326$var$wa:
                    return c = $b4be07302e235326$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b4be07302e235326$var$Zg(a, null, b), c.return = a, c;
                case $b4be07302e235326$var$xa:
                    return b = $b4be07302e235326$var$fh(b, a.mode, c), b.return = a, b;
                case $b4be07302e235326$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b4be07302e235326$var$db(b) || $b4be07302e235326$var$Ka(b)) return b = $b4be07302e235326$var$gh(b, a.mode, c, null), b.return = a, b;
            $b4be07302e235326$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b4be07302e235326$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b4be07302e235326$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b4be07302e235326$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b4be07302e235326$var$db(c) || $b4be07302e235326$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $b4be07302e235326$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b4be07302e235326$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b4be07302e235326$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b4be07302e235326$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($b4be07302e235326$var$db(d) || $b4be07302e235326$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $b4be07302e235326$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $b4be07302e235326$var$J && $b4be07302e235326$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $b4be07302e235326$var$J && $b4be07302e235326$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $b4be07302e235326$var$J && $b4be07302e235326$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $b4be07302e235326$var$Ka(h);
        if ("function" !== typeof l) throw Error($b4be07302e235326$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b4be07302e235326$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $b4be07302e235326$var$J && $b4be07302e235326$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $b4be07302e235326$var$J && $b4be07302e235326$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b4be07302e235326$var$J && $b4be07302e235326$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b4be07302e235326$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b4be07302e235326$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b4be07302e235326$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b4be07302e235326$var$Ha && $b4be07302e235326$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b4be07302e235326$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b4be07302e235326$var$ya ? (d = $b4be07302e235326$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b4be07302e235326$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b4be07302e235326$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b4be07302e235326$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b4be07302e235326$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b4be07302e235326$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($b4be07302e235326$var$db(f)) return m(a, d, f, h);
            if ($b4be07302e235326$var$Ka(f)) return w(a, d, f, h);
            $b4be07302e235326$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b4be07302e235326$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $b4be07302e235326$var$hh = $b4be07302e235326$var$bh(!0), $b4be07302e235326$var$ih = $b4be07302e235326$var$bh(!1), $b4be07302e235326$var$jh = $b4be07302e235326$var$hg(null), $b4be07302e235326$var$kh = null, $b4be07302e235326$var$lh = null, $b4be07302e235326$var$mh = null;
function $b4be07302e235326$var$nh() {
    $b4be07302e235326$var$mh = $b4be07302e235326$var$lh = $b4be07302e235326$var$kh = null;
}
function $b4be07302e235326$var$oh(a) {
    var b = $b4be07302e235326$var$jh.current;
    $b4be07302e235326$var$G($b4be07302e235326$var$jh);
    a._currentValue = b;
}
function $b4be07302e235326$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b4be07302e235326$var$qh(a, b) {
    $b4be07302e235326$var$kh = a;
    $b4be07302e235326$var$mh = $b4be07302e235326$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b4be07302e235326$var$rh = !0), a.firstContext = null);
}
function $b4be07302e235326$var$sh(a) {
    var b = a._currentValue;
    if ($b4be07302e235326$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b4be07302e235326$var$lh) {
            if (null === $b4be07302e235326$var$kh) throw Error($b4be07302e235326$var$p(308));
            $b4be07302e235326$var$lh = a;
            $b4be07302e235326$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b4be07302e235326$var$lh = $b4be07302e235326$var$lh.next = a;
    }
    return b;
}
var $b4be07302e235326$var$th = null;
function $b4be07302e235326$var$uh(a) {
    null === $b4be07302e235326$var$th ? $b4be07302e235326$var$th = [
        a
    ] : $b4be07302e235326$var$th.push(a);
}
function $b4be07302e235326$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b4be07302e235326$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b4be07302e235326$var$wh(a, d);
}
function $b4be07302e235326$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b4be07302e235326$var$xh = !1;
function $b4be07302e235326$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b4be07302e235326$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b4be07302e235326$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b4be07302e235326$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b4be07302e235326$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b4be07302e235326$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b4be07302e235326$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b4be07302e235326$var$wh(a, c);
}
function $b4be07302e235326$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b4be07302e235326$var$Oc(a, c);
    }
}
function $b4be07302e235326$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b4be07302e235326$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $b4be07302e235326$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $b4be07302e235326$var$u({}, q, r);
                            break a;
                        case 2:
                            $b4be07302e235326$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b4be07302e235326$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b4be07302e235326$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b4be07302e235326$var$p(191, e));
            e.call(d);
        }
    }
}
var $b4be07302e235326$var$Hh = {}, $b4be07302e235326$var$Ih = $b4be07302e235326$var$hg($b4be07302e235326$var$Hh), $b4be07302e235326$var$Jh = $b4be07302e235326$var$hg($b4be07302e235326$var$Hh), $b4be07302e235326$var$Kh = $b4be07302e235326$var$hg($b4be07302e235326$var$Hh);
function $b4be07302e235326$var$Lh(a) {
    if (a === $b4be07302e235326$var$Hh) throw Error($b4be07302e235326$var$p(174));
    return a;
}
function $b4be07302e235326$var$Mh(a, b) {
    $b4be07302e235326$var$H($b4be07302e235326$var$Kh, b);
    $b4be07302e235326$var$H($b4be07302e235326$var$Jh, a);
    $b4be07302e235326$var$H($b4be07302e235326$var$Ih, $b4be07302e235326$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b4be07302e235326$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b4be07302e235326$var$kb(b, a);
    }
    $b4be07302e235326$var$G($b4be07302e235326$var$Ih);
    $b4be07302e235326$var$H($b4be07302e235326$var$Ih, b);
}
function $b4be07302e235326$var$Nh() {
    $b4be07302e235326$var$G($b4be07302e235326$var$Ih);
    $b4be07302e235326$var$G($b4be07302e235326$var$Jh);
    $b4be07302e235326$var$G($b4be07302e235326$var$Kh);
}
function $b4be07302e235326$var$Oh(a) {
    $b4be07302e235326$var$Lh($b4be07302e235326$var$Kh.current);
    var b = $b4be07302e235326$var$Lh($b4be07302e235326$var$Ih.current);
    var c = $b4be07302e235326$var$kb(b, a.type);
    b !== c && ($b4be07302e235326$var$H($b4be07302e235326$var$Jh, a), $b4be07302e235326$var$H($b4be07302e235326$var$Ih, c));
}
function $b4be07302e235326$var$Ph(a) {
    $b4be07302e235326$var$Jh.current === a && ($b4be07302e235326$var$G($b4be07302e235326$var$Ih), $b4be07302e235326$var$G($b4be07302e235326$var$Jh));
}
var $b4be07302e235326$var$L = $b4be07302e235326$var$hg(0);
function $b4be07302e235326$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b4be07302e235326$var$Rh = [];
function $b4be07302e235326$var$Sh() {
    for(var a = 0; a < $b4be07302e235326$var$Rh.length; a++)$b4be07302e235326$var$Rh[a]._workInProgressVersionPrimary = null;
    $b4be07302e235326$var$Rh.length = 0;
}
var $b4be07302e235326$var$Th = $b4be07302e235326$var$va.ReactCurrentDispatcher, $b4be07302e235326$var$Uh = $b4be07302e235326$var$va.ReactCurrentBatchConfig, $b4be07302e235326$var$Vh = 0, $b4be07302e235326$var$M = null, $b4be07302e235326$var$N = null, $b4be07302e235326$var$O = null, $b4be07302e235326$var$Wh = !1, $b4be07302e235326$var$Xh = !1, $b4be07302e235326$var$Yh = 0, $b4be07302e235326$var$Zh = 0;
function $b4be07302e235326$var$P() {
    throw Error($b4be07302e235326$var$p(321));
}
function $b4be07302e235326$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b4be07302e235326$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $b4be07302e235326$var$ai(a, b, c, d, e, f) {
    $b4be07302e235326$var$Vh = f;
    $b4be07302e235326$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b4be07302e235326$var$Th.current = null === a || null === a.memoizedState ? $b4be07302e235326$var$bi : $b4be07302e235326$var$ci;
    a = c(d, e);
    if ($b4be07302e235326$var$Xh) {
        f = 0;
        do {
            $b4be07302e235326$var$Xh = !1;
            $b4be07302e235326$var$Yh = 0;
            if (25 <= f) throw Error($b4be07302e235326$var$p(301));
            f += 1;
            $b4be07302e235326$var$O = $b4be07302e235326$var$N = null;
            b.updateQueue = null;
            $b4be07302e235326$var$Th.current = $b4be07302e235326$var$di;
            a = c(d, e);
        }while ($b4be07302e235326$var$Xh);
    }
    $b4be07302e235326$var$Th.current = $b4be07302e235326$var$ei;
    b = null !== $b4be07302e235326$var$N && null !== $b4be07302e235326$var$N.next;
    $b4be07302e235326$var$Vh = 0;
    $b4be07302e235326$var$O = $b4be07302e235326$var$N = $b4be07302e235326$var$M = null;
    $b4be07302e235326$var$Wh = !1;
    if (b) throw Error($b4be07302e235326$var$p(300));
    return a;
}
function $b4be07302e235326$var$fi() {
    var a = 0 !== $b4be07302e235326$var$Yh;
    $b4be07302e235326$var$Yh = 0;
    return a;
}
function $b4be07302e235326$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b4be07302e235326$var$O ? $b4be07302e235326$var$M.memoizedState = $b4be07302e235326$var$O = a : $b4be07302e235326$var$O = $b4be07302e235326$var$O.next = a;
    return $b4be07302e235326$var$O;
}
function $b4be07302e235326$var$hi() {
    if (null === $b4be07302e235326$var$N) {
        var a = $b4be07302e235326$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b4be07302e235326$var$N.next;
    var b = null === $b4be07302e235326$var$O ? $b4be07302e235326$var$M.memoizedState : $b4be07302e235326$var$O.next;
    if (null !== b) $b4be07302e235326$var$O = b, $b4be07302e235326$var$N = a;
    else {
        if (null === a) throw Error($b4be07302e235326$var$p(310));
        $b4be07302e235326$var$N = a;
        a = {
            memoizedState: $b4be07302e235326$var$N.memoizedState,
            baseState: $b4be07302e235326$var$N.baseState,
            baseQueue: $b4be07302e235326$var$N.baseQueue,
            queue: $b4be07302e235326$var$N.queue,
            next: null
        };
        null === $b4be07302e235326$var$O ? $b4be07302e235326$var$M.memoizedState = $b4be07302e235326$var$O = a : $b4be07302e235326$var$O = $b4be07302e235326$var$O.next = a;
    }
    return $b4be07302e235326$var$O;
}
function $b4be07302e235326$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b4be07302e235326$var$ji(a) {
    var b = $b4be07302e235326$var$hi(), c = b.queue;
    if (null === c) throw Error($b4be07302e235326$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b4be07302e235326$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($b4be07302e235326$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b4be07302e235326$var$M.lanes |= n;
                $b4be07302e235326$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b4be07302e235326$var$Ve(d, b.memoizedState) || ($b4be07302e235326$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b4be07302e235326$var$M.lanes |= f, $b4be07302e235326$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b4be07302e235326$var$ki(a) {
    var b = $b4be07302e235326$var$hi(), c = b.queue;
    if (null === c) throw Error($b4be07302e235326$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b4be07302e235326$var$Ve(f, b.memoizedState) || ($b4be07302e235326$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b4be07302e235326$var$li() {}
function $b4be07302e235326$var$mi(a, b) {
    var c = $b4be07302e235326$var$M, d = $b4be07302e235326$var$hi(), e = b(), f = !$b4be07302e235326$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $b4be07302e235326$var$rh = !0);
    d = d.queue;
    $b4be07302e235326$var$ni($b4be07302e235326$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b4be07302e235326$var$O && $b4be07302e235326$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b4be07302e235326$var$pi(9, $b4be07302e235326$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $b4be07302e235326$var$Q) throw Error($b4be07302e235326$var$p(349));
        0 !== ($b4be07302e235326$var$Vh & 30) || $b4be07302e235326$var$ri(c, b, e);
    }
    return e;
}
function $b4be07302e235326$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b4be07302e235326$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b4be07302e235326$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b4be07302e235326$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b4be07302e235326$var$si(b) && $b4be07302e235326$var$ti(a);
}
function $b4be07302e235326$var$oi(a, b, c) {
    return c(function() {
        $b4be07302e235326$var$si(b) && $b4be07302e235326$var$ti(a);
    });
}
function $b4be07302e235326$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b4be07302e235326$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $b4be07302e235326$var$ti(a) {
    var b = $b4be07302e235326$var$wh(a, 1);
    null !== b && $b4be07302e235326$var$ui(b, a, 1, -1);
}
function $b4be07302e235326$var$vi(a) {
    var b = $b4be07302e235326$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b4be07302e235326$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b4be07302e235326$var$wi.bind(null, $b4be07302e235326$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b4be07302e235326$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b4be07302e235326$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b4be07302e235326$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b4be07302e235326$var$xi() {
    return $b4be07302e235326$var$hi().memoizedState;
}
function $b4be07302e235326$var$Ai(a, b, c, d) {
    var e = $b4be07302e235326$var$gi();
    $b4be07302e235326$var$M.flags |= a;
    e.memoizedState = $b4be07302e235326$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b4be07302e235326$var$Bi(a, b, c, d) {
    var e = $b4be07302e235326$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b4be07302e235326$var$N) {
        var g = $b4be07302e235326$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b4be07302e235326$var$$h(d, g.deps)) {
            e.memoizedState = $b4be07302e235326$var$pi(b, c, f, d);
            return;
        }
    }
    $b4be07302e235326$var$M.flags |= a;
    e.memoizedState = $b4be07302e235326$var$pi(1 | b, c, f, d);
}
function $b4be07302e235326$var$Ci(a, b) {
    return $b4be07302e235326$var$Ai(8390656, 8, a, b);
}
function $b4be07302e235326$var$ni(a, b) {
    return $b4be07302e235326$var$Bi(2048, 8, a, b);
}
function $b4be07302e235326$var$Di(a, b) {
    return $b4be07302e235326$var$Bi(4, 2, a, b);
}
function $b4be07302e235326$var$Ei(a, b) {
    return $b4be07302e235326$var$Bi(4, 4, a, b);
}
function $b4be07302e235326$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b4be07302e235326$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b4be07302e235326$var$Bi(4, 4, $b4be07302e235326$var$Fi.bind(null, b, a), c);
}
function $b4be07302e235326$var$Hi() {}
function $b4be07302e235326$var$Ii(a, b) {
    var c = $b4be07302e235326$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b4be07302e235326$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b4be07302e235326$var$Ji(a, b) {
    var c = $b4be07302e235326$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b4be07302e235326$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b4be07302e235326$var$Ki(a, b, c) {
    if (0 === ($b4be07302e235326$var$Vh & 21)) return a.baseState && (a.baseState = !1, $b4be07302e235326$var$rh = !0), a.memoizedState = c;
    $b4be07302e235326$var$Ve(c, b) || (c = $b4be07302e235326$var$Kc(), $b4be07302e235326$var$M.lanes |= c, $b4be07302e235326$var$Fh |= c, a.baseState = !0);
    return b;
}
function $b4be07302e235326$var$Li(a, b) {
    var c = $b4be07302e235326$var$E;
    $b4be07302e235326$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b4be07302e235326$var$Uh.transition;
    $b4be07302e235326$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b4be07302e235326$var$E = c, $b4be07302e235326$var$Uh.transition = d;
    }
}
function $b4be07302e235326$var$Mi() {
    return $b4be07302e235326$var$hi().memoizedState;
}
function $b4be07302e235326$var$Ni(a, b, c) {
    var d = $b4be07302e235326$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b4be07302e235326$var$Pi(a)) $b4be07302e235326$var$Qi(b, c);
    else if (c = $b4be07302e235326$var$vh(a, b, c, d), null !== c) {
        var e = $b4be07302e235326$var$Ri();
        $b4be07302e235326$var$ui(c, a, d, e);
        $b4be07302e235326$var$Si(c, b, d);
    }
    $b4be07302e235326$var$yc(a, d);
}
function $b4be07302e235326$var$wi(a, b, c) {
    var d = $b4be07302e235326$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b4be07302e235326$var$Pi(a)) $b4be07302e235326$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b4be07302e235326$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b4be07302e235326$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b4be07302e235326$var$vh(a, b, e, d);
        null !== c && (e = $b4be07302e235326$var$Ri(), $b4be07302e235326$var$ui(c, a, d, e), $b4be07302e235326$var$Si(c, b, d));
    }
    $b4be07302e235326$var$yc(a, d);
}
function $b4be07302e235326$var$Pi(a) {
    var b = a.alternate;
    return a === $b4be07302e235326$var$M || null !== b && b === $b4be07302e235326$var$M;
}
function $b4be07302e235326$var$Qi(a, b) {
    $b4be07302e235326$var$Xh = $b4be07302e235326$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b4be07302e235326$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b4be07302e235326$var$Oc(a, c);
    }
}
var $b4be07302e235326$var$ei = {
    readContext: $b4be07302e235326$var$sh,
    useCallback: $b4be07302e235326$var$P,
    useContext: $b4be07302e235326$var$P,
    useEffect: $b4be07302e235326$var$P,
    useImperativeHandle: $b4be07302e235326$var$P,
    useInsertionEffect: $b4be07302e235326$var$P,
    useLayoutEffect: $b4be07302e235326$var$P,
    useMemo: $b4be07302e235326$var$P,
    useReducer: $b4be07302e235326$var$P,
    useRef: $b4be07302e235326$var$P,
    useState: $b4be07302e235326$var$P,
    useDebugValue: $b4be07302e235326$var$P,
    useDeferredValue: $b4be07302e235326$var$P,
    useTransition: $b4be07302e235326$var$P,
    useMutableSource: $b4be07302e235326$var$P,
    useSyncExternalStore: $b4be07302e235326$var$P,
    useId: $b4be07302e235326$var$P,
    unstable_isNewReconciler: !1
}, $b4be07302e235326$var$bi = {
    readContext: $b4be07302e235326$var$sh,
    useCallback: function(a, b) {
        $b4be07302e235326$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b4be07302e235326$var$sh,
    useEffect: $b4be07302e235326$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b4be07302e235326$var$Ai(4194308, 4, $b4be07302e235326$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b4be07302e235326$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b4be07302e235326$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b4be07302e235326$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b4be07302e235326$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b4be07302e235326$var$Ni.bind(null, $b4be07302e235326$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b4be07302e235326$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b4be07302e235326$var$vi,
    useDebugValue: $b4be07302e235326$var$Hi,
    useDeferredValue: function(a) {
        return $b4be07302e235326$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $b4be07302e235326$var$vi(!1), b = a[0];
        a = $b4be07302e235326$var$Li.bind(null, a[1]);
        $b4be07302e235326$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b4be07302e235326$var$M, e = $b4be07302e235326$var$gi();
        if ($b4be07302e235326$var$J) {
            if (void 0 === c) throw Error($b4be07302e235326$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b4be07302e235326$var$Q) throw Error($b4be07302e235326$var$p(349));
            0 !== ($b4be07302e235326$var$Vh & 30) || $b4be07302e235326$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b4be07302e235326$var$Ci($b4be07302e235326$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b4be07302e235326$var$pi(9, $b4be07302e235326$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b4be07302e235326$var$gi(), b = $b4be07302e235326$var$Q.identifierPrefix;
        if ($b4be07302e235326$var$J) {
            var c = $b4be07302e235326$var$Gg;
            var d = $b4be07302e235326$var$Fg;
            c = (d & ~(1 << 32 - $b4be07302e235326$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b4be07302e235326$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b4be07302e235326$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b4be07302e235326$var$ci = {
    readContext: $b4be07302e235326$var$sh,
    useCallback: $b4be07302e235326$var$Ii,
    useContext: $b4be07302e235326$var$sh,
    useEffect: $b4be07302e235326$var$ni,
    useImperativeHandle: $b4be07302e235326$var$Gi,
    useInsertionEffect: $b4be07302e235326$var$Di,
    useLayoutEffect: $b4be07302e235326$var$Ei,
    useMemo: $b4be07302e235326$var$Ji,
    useReducer: $b4be07302e235326$var$ji,
    useRef: $b4be07302e235326$var$xi,
    useState: function() {
        return $b4be07302e235326$var$ji($b4be07302e235326$var$ii);
    },
    useDebugValue: $b4be07302e235326$var$Hi,
    useDeferredValue: function(a) {
        var b = $b4be07302e235326$var$hi();
        return $b4be07302e235326$var$Ki(b, $b4be07302e235326$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b4be07302e235326$var$ji($b4be07302e235326$var$ii)[0], b = $b4be07302e235326$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b4be07302e235326$var$li,
    useSyncExternalStore: $b4be07302e235326$var$mi,
    useId: $b4be07302e235326$var$Mi,
    unstable_isNewReconciler: !1
}, $b4be07302e235326$var$di = {
    readContext: $b4be07302e235326$var$sh,
    useCallback: $b4be07302e235326$var$Ii,
    useContext: $b4be07302e235326$var$sh,
    useEffect: $b4be07302e235326$var$ni,
    useImperativeHandle: $b4be07302e235326$var$Gi,
    useInsertionEffect: $b4be07302e235326$var$Di,
    useLayoutEffect: $b4be07302e235326$var$Ei,
    useMemo: $b4be07302e235326$var$Ji,
    useReducer: $b4be07302e235326$var$ki,
    useRef: $b4be07302e235326$var$xi,
    useState: function() {
        return $b4be07302e235326$var$ki($b4be07302e235326$var$ii);
    },
    useDebugValue: $b4be07302e235326$var$Hi,
    useDeferredValue: function(a) {
        var b = $b4be07302e235326$var$hi();
        return null === $b4be07302e235326$var$N ? b.memoizedState = a : $b4be07302e235326$var$Ki(b, $b4be07302e235326$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b4be07302e235326$var$ki($b4be07302e235326$var$ii)[0], b = $b4be07302e235326$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b4be07302e235326$var$li,
    useSyncExternalStore: $b4be07302e235326$var$mi,
    useId: $b4be07302e235326$var$Mi,
    unstable_isNewReconciler: !1
}, $b4be07302e235326$var$Ti = $iHSFb.unstable_now, $b4be07302e235326$var$Ui = 0, $b4be07302e235326$var$Vi = -1, $b4be07302e235326$var$Wi = -1, $b4be07302e235326$var$Xi = -1, $b4be07302e235326$var$Yi = !1, $b4be07302e235326$var$Zi = !1;
function $b4be07302e235326$var$$i(a, b) {
    if (0 <= $b4be07302e235326$var$Wi) {
        var c = $b4be07302e235326$var$Ti() - $b4be07302e235326$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $b4be07302e235326$var$Wi = -1;
    }
}
function $b4be07302e235326$var$aj(a) {
    if (0 <= $b4be07302e235326$var$Vi) {
        var b = $b4be07302e235326$var$Ti() - $b4be07302e235326$var$Vi;
        $b4be07302e235326$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $b4be07302e235326$var$bj(a) {
    if (0 <= $b4be07302e235326$var$Xi) {
        var b = $b4be07302e235326$var$Ti() - $b4be07302e235326$var$Xi;
        $b4be07302e235326$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $b4be07302e235326$var$cj() {
    $b4be07302e235326$var$Vi = $b4be07302e235326$var$Ti();
}
function $b4be07302e235326$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $b4be07302e235326$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $b4be07302e235326$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b4be07302e235326$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b4be07302e235326$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b4be07302e235326$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b4be07302e235326$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b4be07302e235326$var$Ri(), e = $b4be07302e235326$var$Oi(a), f = $b4be07302e235326$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b4be07302e235326$var$Bh(a, f, e);
        null !== b && ($b4be07302e235326$var$ui(b, a, e, d), $b4be07302e235326$var$Ch(b, a, e));
        $b4be07302e235326$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b4be07302e235326$var$Ri(), e = $b4be07302e235326$var$Oi(a), f = $b4be07302e235326$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b4be07302e235326$var$Bh(a, f, e);
        null !== b && ($b4be07302e235326$var$ui(b, a, e, d), $b4be07302e235326$var$Ch(b, a, e));
        $b4be07302e235326$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b4be07302e235326$var$Ri(), d = $b4be07302e235326$var$Oi(a), e = $b4be07302e235326$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b4be07302e235326$var$Bh(a, e, d);
        null !== b && ($b4be07302e235326$var$ui(b, a, d, c), $b4be07302e235326$var$Ch(b, a, d));
        null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markForceUpdateScheduled && $b4be07302e235326$var$B.markForceUpdateScheduled(a, d);
    }
};
function $b4be07302e235326$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b4be07302e235326$var$We(c, d) || !$b4be07302e235326$var$We(e, f) : !0;
}
function $b4be07302e235326$var$ij(a, b, c) {
    var d = !1, e = $b4be07302e235326$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b4be07302e235326$var$sh(f) : (e = $b4be07302e235326$var$mg(b) ? $b4be07302e235326$var$kg : $b4be07302e235326$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b4be07302e235326$var$lg(a, e) : $b4be07302e235326$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b4be07302e235326$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b4be07302e235326$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b4be07302e235326$var$gj.enqueueReplaceState(b, b.state, null);
}
function $b4be07302e235326$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b4be07302e235326$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b4be07302e235326$var$sh(f) : (f = $b4be07302e235326$var$mg(b) ? $b4be07302e235326$var$kg : $b4be07302e235326$var$I.current, e.context = $b4be07302e235326$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b4be07302e235326$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b4be07302e235326$var$gj.enqueueReplaceState(e, e.state, null), $b4be07302e235326$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b4be07302e235326$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $b4be07302e235326$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b4be07302e235326$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b4be07302e235326$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b4be07302e235326$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $b4be07302e235326$var$pj(a, b, c) {
    c = $b4be07302e235326$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b4be07302e235326$var$qj || ($b4be07302e235326$var$qj = !0, $b4be07302e235326$var$rj = d);
        $b4be07302e235326$var$nj(a, b);
    };
    return c;
}
function $b4be07302e235326$var$sj(a, b, c) {
    c = $b4be07302e235326$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b4be07302e235326$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b4be07302e235326$var$nj(a, b);
        "function" !== typeof d && (null === $b4be07302e235326$var$tj ? $b4be07302e235326$var$tj = new Set([
            this
        ]) : $b4be07302e235326$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b4be07302e235326$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b4be07302e235326$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $b4be07302e235326$var$vj.bind(null, a, b, c), $b4be07302e235326$var$mc && $b4be07302e235326$var$wj(a, c), b.then(d, d));
}
function $b4be07302e235326$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b4be07302e235326$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b4be07302e235326$var$Ah(-1, 1), b.tag = 2, $b4be07302e235326$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b4be07302e235326$var$zj = $b4be07302e235326$var$va.ReactCurrentOwner, $b4be07302e235326$var$rh = !1;
function $b4be07302e235326$var$Aj(a, b, c, d) {
    b.child = null === a ? $b4be07302e235326$var$ih(b, null, c, d) : $b4be07302e235326$var$hh(b, a.child, c, d);
}
function $b4be07302e235326$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b4be07302e235326$var$qh(b, e);
    $b4be07302e235326$var$sc(b);
    d = $b4be07302e235326$var$ai(a, b, c, d, f, e);
    c = $b4be07302e235326$var$fi();
    $b4be07302e235326$var$tc();
    if (null !== a && !$b4be07302e235326$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b4be07302e235326$var$Cj(a, b, e);
    $b4be07302e235326$var$J && c && $b4be07302e235326$var$Jg(b);
    b.flags |= 1;
    $b4be07302e235326$var$Aj(a, b, d, e);
    return b.child;
}
function $b4be07302e235326$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b4be07302e235326$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b4be07302e235326$var$Fj(a, b, f, d, e);
        a = $b4be07302e235326$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b4be07302e235326$var$We;
        if (c(g, d) && a.ref === b.ref) return $b4be07302e235326$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $b4be07302e235326$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b4be07302e235326$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b4be07302e235326$var$We(f, d) && a.ref === b.ref) {
            if ($b4be07302e235326$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b4be07302e235326$var$rh = !0);
            else return b.lanes = a.lanes, $b4be07302e235326$var$Cj(a, b, e);
        }
    }
    return $b4be07302e235326$var$Gj(a, b, c, d, e);
}
function $b4be07302e235326$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b4be07302e235326$var$H($b4be07302e235326$var$Ij, $b4be07302e235326$var$Jj), $b4be07302e235326$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b4be07302e235326$var$H($b4be07302e235326$var$Ij, $b4be07302e235326$var$Jj), $b4be07302e235326$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b4be07302e235326$var$H($b4be07302e235326$var$Ij, $b4be07302e235326$var$Jj);
            $b4be07302e235326$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b4be07302e235326$var$H($b4be07302e235326$var$Ij, $b4be07302e235326$var$Jj), $b4be07302e235326$var$Jj |= d;
    $b4be07302e235326$var$Aj(a, b, e, c);
    return b.child;
}
function $b4be07302e235326$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b4be07302e235326$var$Gj(a, b, c, d, e) {
    var f = $b4be07302e235326$var$mg(c) ? $b4be07302e235326$var$kg : $b4be07302e235326$var$I.current;
    f = $b4be07302e235326$var$lg(b, f);
    $b4be07302e235326$var$qh(b, e);
    $b4be07302e235326$var$sc(b);
    c = $b4be07302e235326$var$ai(a, b, c, d, f, e);
    d = $b4be07302e235326$var$fi();
    $b4be07302e235326$var$tc();
    if (null !== a && !$b4be07302e235326$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b4be07302e235326$var$Cj(a, b, e);
    $b4be07302e235326$var$J && d && $b4be07302e235326$var$Jg(b);
    b.flags |= 1;
    $b4be07302e235326$var$Aj(a, b, c, e);
    return b.child;
}
function $b4be07302e235326$var$Lj(a, b, c, d, e) {
    if ($b4be07302e235326$var$mg(c)) {
        var f = !0;
        $b4be07302e235326$var$qg(b);
    } else f = !1;
    $b4be07302e235326$var$qh(b, e);
    if (null === b.stateNode) $b4be07302e235326$var$Mj(a, b), $b4be07302e235326$var$ij(b, c, d), $b4be07302e235326$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b4be07302e235326$var$sh(l) : (l = $b4be07302e235326$var$mg(c) ? $b4be07302e235326$var$kg : $b4be07302e235326$var$I.current, l = $b4be07302e235326$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b4be07302e235326$var$jj(b, g, d, l);
        $b4be07302e235326$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b4be07302e235326$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b4be07302e235326$var$jg.current || $b4be07302e235326$var$xh ? ("function" === typeof n && ($b4be07302e235326$var$fj(b, c, n, d), k = b.memoizedState), (h = $b4be07302e235326$var$xh || $b4be07302e235326$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b4be07302e235326$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b4be07302e235326$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b4be07302e235326$var$sh(k) : (k = $b4be07302e235326$var$mg(c) ? $b4be07302e235326$var$kg : $b4be07302e235326$var$I.current, k = $b4be07302e235326$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b4be07302e235326$var$jj(b, g, d, k);
        $b4be07302e235326$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $b4be07302e235326$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $b4be07302e235326$var$jg.current || $b4be07302e235326$var$xh ? ("function" === typeof z && ($b4be07302e235326$var$fj(b, c, z, d), m = b.memoizedState), (l = $b4be07302e235326$var$xh || $b4be07302e235326$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b4be07302e235326$var$Nj(a, b, c, d, f, e);
}
function $b4be07302e235326$var$Nj(a, b, c, d, e, f) {
    $b4be07302e235326$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b4be07302e235326$var$rg(b, c, !1), $b4be07302e235326$var$Cj(a, b, f);
    d = b.stateNode;
    $b4be07302e235326$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $b4be07302e235326$var$Wi = -1;
    } else $b4be07302e235326$var$sc(b), h = d.render(), $b4be07302e235326$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $b4be07302e235326$var$hh(b, a.child, null, f), b.child = $b4be07302e235326$var$hh(b, null, g, f)) : $b4be07302e235326$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $b4be07302e235326$var$rg(b, c, !0);
    return b.child;
}
function $b4be07302e235326$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b4be07302e235326$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b4be07302e235326$var$og(a, b.context, !1);
    $b4be07302e235326$var$Mh(a, b.containerInfo);
}
function $b4be07302e235326$var$Rj(a, b, c, d, e) {
    $b4be07302e235326$var$Wg();
    $b4be07302e235326$var$Xg(e);
    b.flags |= 256;
    $b4be07302e235326$var$Aj(a, b, c, d);
    return b.child;
}
var $b4be07302e235326$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b4be07302e235326$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b4be07302e235326$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $b4be07302e235326$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b4be07302e235326$var$H($b4be07302e235326$var$L, e & 1);
    if (null === a) {
        $b4be07302e235326$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $b4be07302e235326$var$Vj(g, d, 0, null), a = $b4be07302e235326$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b4be07302e235326$var$Tj(c), b.memoizedState = $b4be07302e235326$var$Sj, a) : $b4be07302e235326$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b4be07302e235326$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $b4be07302e235326$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b4be07302e235326$var$ch(h, f) : (f = $b4be07302e235326$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b4be07302e235326$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b4be07302e235326$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b4be07302e235326$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b4be07302e235326$var$Wj(a, b) {
    b = $b4be07302e235326$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b4be07302e235326$var$Yj(a, b, c, d) {
    null !== d && $b4be07302e235326$var$Xg(d);
    $b4be07302e235326$var$hh(b, a.child, null, c);
    a = $b4be07302e235326$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b4be07302e235326$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b4be07302e235326$var$mj(Error($b4be07302e235326$var$p(422))), $b4be07302e235326$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b4be07302e235326$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b4be07302e235326$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b4be07302e235326$var$hh(b, a.child, null, g);
        b.child.memoizedState = $b4be07302e235326$var$Tj(g);
        b.memoizedState = $b4be07302e235326$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b4be07302e235326$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b4be07302e235326$var$p(419));
        d = $b4be07302e235326$var$mj(f, d, void 0);
        return $b4be07302e235326$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b4be07302e235326$var$rh || h) {
        d = $b4be07302e235326$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b4be07302e235326$var$wh(a, e), $b4be07302e235326$var$ui(d, a, e, -1));
        }
        $b4be07302e235326$var$Zj();
        d = $b4be07302e235326$var$mj(Error($b4be07302e235326$var$p(421)));
        return $b4be07302e235326$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b4be07302e235326$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b4be07302e235326$var$Mg = $b4be07302e235326$var$Zf(e.nextSibling);
    $b4be07302e235326$var$Lg = b;
    $b4be07302e235326$var$J = !0;
    $b4be07302e235326$var$Ng = null;
    null !== a && ($b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg++] = $b4be07302e235326$var$Fg, $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg++] = $b4be07302e235326$var$Gg, $b4be07302e235326$var$Cg[$b4be07302e235326$var$Dg++] = $b4be07302e235326$var$Eg, $b4be07302e235326$var$Fg = a.id, $b4be07302e235326$var$Gg = a.overflow, $b4be07302e235326$var$Eg = b);
    b = $b4be07302e235326$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b4be07302e235326$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b4be07302e235326$var$ph(a.return, b, c);
}
function $b4be07302e235326$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b4be07302e235326$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b4be07302e235326$var$Aj(a, b, d.children, c);
    d = $b4be07302e235326$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b4be07302e235326$var$bk(a, c, b);
            else if (19 === a.tag) $b4be07302e235326$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b4be07302e235326$var$H($b4be07302e235326$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b4be07302e235326$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b4be07302e235326$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b4be07302e235326$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b4be07302e235326$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $b4be07302e235326$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b4be07302e235326$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b4be07302e235326$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b4be07302e235326$var$Wi = -1;
    $b4be07302e235326$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b4be07302e235326$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b4be07302e235326$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b4be07302e235326$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b4be07302e235326$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $b4be07302e235326$var$Oj(b);
            $b4be07302e235326$var$Wg();
            break;
        case 5:
            $b4be07302e235326$var$Oh(b);
            break;
        case 1:
            $b4be07302e235326$var$mg(b.type) && $b4be07302e235326$var$qg(b);
            break;
        case 4:
            $b4be07302e235326$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b4be07302e235326$var$H($b4be07302e235326$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b4be07302e235326$var$H($b4be07302e235326$var$L, $b4be07302e235326$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b4be07302e235326$var$Uj(a, b, c);
                $b4be07302e235326$var$H($b4be07302e235326$var$L, $b4be07302e235326$var$L.current & 1);
                a = $b4be07302e235326$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b4be07302e235326$var$H($b4be07302e235326$var$L, $b4be07302e235326$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b4be07302e235326$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b4be07302e235326$var$H($b4be07302e235326$var$L, $b4be07302e235326$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b4be07302e235326$var$Hj(a, b, c);
    }
    return $b4be07302e235326$var$Cj(a, b, c);
}
var $b4be07302e235326$var$fk, $b4be07302e235326$var$gk, $b4be07302e235326$var$hk, $b4be07302e235326$var$ik;
$b4be07302e235326$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b4be07302e235326$var$gk = function() {};
$b4be07302e235326$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b4be07302e235326$var$Lh($b4be07302e235326$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $b4be07302e235326$var$Ya(a, e);
                d = $b4be07302e235326$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b4be07302e235326$var$u({}, e, {
                    value: void 0
                });
                d = $b4be07302e235326$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b4be07302e235326$var$fb(a, e);
                d = $b4be07302e235326$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b4be07302e235326$var$Pf);
        }
        $b4be07302e235326$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b4be07302e235326$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b4be07302e235326$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b4be07302e235326$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b4be07302e235326$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b4be07302e235326$var$jk(a, b) {
    if (!$b4be07302e235326$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b4be07302e235326$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b4be07302e235326$var$kk(a, b, c) {
    var d = b.pendingProps;
    $b4be07302e235326$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b4be07302e235326$var$S(b), null;
        case 1:
            return $b4be07302e235326$var$mg(b.type) && $b4be07302e235326$var$ng(), $b4be07302e235326$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b4be07302e235326$var$Nh();
            $b4be07302e235326$var$G($b4be07302e235326$var$jg);
            $b4be07302e235326$var$G($b4be07302e235326$var$I);
            $b4be07302e235326$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b4be07302e235326$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b4be07302e235326$var$Ng && ($b4be07302e235326$var$lk($b4be07302e235326$var$Ng), $b4be07302e235326$var$Ng = null));
            $b4be07302e235326$var$gk(a, b);
            $b4be07302e235326$var$S(b);
            return null;
        case 5:
            $b4be07302e235326$var$Ph(b);
            var e = $b4be07302e235326$var$Lh($b4be07302e235326$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b4be07302e235326$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b4be07302e235326$var$p(166));
                    $b4be07302e235326$var$S(b);
                    return null;
                }
                a = $b4be07302e235326$var$Lh($b4be07302e235326$var$Ih.current);
                if ($b4be07302e235326$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$b4be07302e235326$var$bg] = b;
                    d[$b4be07302e235326$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $b4be07302e235326$var$F("cancel", d);
                            $b4be07302e235326$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b4be07302e235326$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b4be07302e235326$var$zf.length; e++)$b4be07302e235326$var$F($b4be07302e235326$var$zf[e], d);
                            break;
                        case "source":
                            $b4be07302e235326$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b4be07302e235326$var$F("error", d);
                            $b4be07302e235326$var$F("load", d);
                            break;
                        case "details":
                            $b4be07302e235326$var$F("toggle", d);
                            break;
                        case "input":
                            $b4be07302e235326$var$Za(d, c);
                            $b4be07302e235326$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $b4be07302e235326$var$F("invalid", d);
                            break;
                        case "textarea":
                            $b4be07302e235326$var$gb(d, c), $b4be07302e235326$var$F("invalid", d);
                    }
                    $b4be07302e235326$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $b4be07302e235326$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $b4be07302e235326$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $b4be07302e235326$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b4be07302e235326$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $b4be07302e235326$var$Va(d);
                            $b4be07302e235326$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $b4be07302e235326$var$Va(d);
                            $b4be07302e235326$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $b4be07302e235326$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b4be07302e235326$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b4be07302e235326$var$bg] = b;
                    a[$b4be07302e235326$var$cg] = d;
                    $b4be07302e235326$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b4be07302e235326$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b4be07302e235326$var$F("cancel", a);
                                $b4be07302e235326$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b4be07302e235326$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b4be07302e235326$var$zf.length; e++)$b4be07302e235326$var$F($b4be07302e235326$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b4be07302e235326$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b4be07302e235326$var$F("error", a);
                                $b4be07302e235326$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $b4be07302e235326$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b4be07302e235326$var$Za(a, d);
                                e = $b4be07302e235326$var$Ya(a, d);
                                $b4be07302e235326$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b4be07302e235326$var$u({}, d, {
                                    value: void 0
                                });
                                $b4be07302e235326$var$F("invalid", a);
                                break;
                            case "textarea":
                                $b4be07302e235326$var$gb(a, d);
                                e = $b4be07302e235326$var$fb(a, d);
                                $b4be07302e235326$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b4be07302e235326$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b4be07302e235326$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b4be07302e235326$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b4be07302e235326$var$ob(a, k) : "number" === typeof k && $b4be07302e235326$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b4be07302e235326$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b4be07302e235326$var$F("scroll", a) : null != k && $b4be07302e235326$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b4be07302e235326$var$Va(a);
                                $b4be07302e235326$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $b4be07302e235326$var$Va(a);
                                $b4be07302e235326$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b4be07302e235326$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b4be07302e235326$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b4be07302e235326$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b4be07302e235326$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b4be07302e235326$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b4be07302e235326$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b4be07302e235326$var$p(166));
                a = $b4be07302e235326$var$Lh($b4be07302e235326$var$Kh.current);
                $b4be07302e235326$var$Lh($b4be07302e235326$var$Ih.current);
                if ($b4be07302e235326$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$b4be07302e235326$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $b4be07302e235326$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $b4be07302e235326$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $b4be07302e235326$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$b4be07302e235326$var$bg] = b, b.stateNode = d;
            }
            $b4be07302e235326$var$S(b);
            return null;
        case 13:
            $b4be07302e235326$var$G($b4be07302e235326$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b4be07302e235326$var$J && null !== $b4be07302e235326$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b4be07302e235326$var$Vg(), $b4be07302e235326$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $b4be07302e235326$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b4be07302e235326$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b4be07302e235326$var$p(317));
                        f[$b4be07302e235326$var$bg] = b;
                        $b4be07302e235326$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $b4be07302e235326$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $b4be07302e235326$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $b4be07302e235326$var$Ng && ($b4be07302e235326$var$lk($b4be07302e235326$var$Ng), $b4be07302e235326$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $b4be07302e235326$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b4be07302e235326$var$L.current & 1) ? 0 === $b4be07302e235326$var$T && ($b4be07302e235326$var$T = 3) : $b4be07302e235326$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b4be07302e235326$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $b4be07302e235326$var$Nh(), $b4be07302e235326$var$gk(a, b), null === a && $b4be07302e235326$var$Gf(b.stateNode.containerInfo), $b4be07302e235326$var$S(b), null;
        case 10:
            return $b4be07302e235326$var$oh(b.type._context), $b4be07302e235326$var$S(b), null;
        case 17:
            return $b4be07302e235326$var$mg(b.type) && $b4be07302e235326$var$ng(), $b4be07302e235326$var$S(b), null;
        case 19:
            $b4be07302e235326$var$G($b4be07302e235326$var$L);
            f = b.memoizedState;
            if (null === f) return $b4be07302e235326$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b4be07302e235326$var$jk(f, !1);
                else {
                    if (0 !== $b4be07302e235326$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b4be07302e235326$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b4be07302e235326$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $b4be07302e235326$var$H($b4be07302e235326$var$L, $b4be07302e235326$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b4be07302e235326$var$A() > $b4be07302e235326$var$mk && (b.flags |= 128, d = !0, $b4be07302e235326$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b4be07302e235326$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $b4be07302e235326$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b4be07302e235326$var$J) return $b4be07302e235326$var$S(b), null;
                    } else 2 * $b4be07302e235326$var$A() - f.renderingStartTime > $b4be07302e235326$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $b4be07302e235326$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b4be07302e235326$var$A(), b.sibling = null, a = $b4be07302e235326$var$L.current, $b4be07302e235326$var$H($b4be07302e235326$var$L, d ? a & 1 | 2 : a & 1), b;
            $b4be07302e235326$var$S(b);
            return null;
        case 22:
        case 23:
            return $b4be07302e235326$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b4be07302e235326$var$Jj & 1073741824) && ($b4be07302e235326$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b4be07302e235326$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b4be07302e235326$var$p(156, b.tag));
}
function $b4be07302e235326$var$ok(a, b) {
    $b4be07302e235326$var$Kg(b);
    switch(b.tag){
        case 1:
            return $b4be07302e235326$var$mg(b.type) && $b4be07302e235326$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $b4be07302e235326$var$dj(b), b) : null;
        case 3:
            return $b4be07302e235326$var$Nh(), $b4be07302e235326$var$G($b4be07302e235326$var$jg), $b4be07302e235326$var$G($b4be07302e235326$var$I), $b4be07302e235326$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b4be07302e235326$var$Ph(b), null;
        case 13:
            $b4be07302e235326$var$G($b4be07302e235326$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b4be07302e235326$var$p(340));
                $b4be07302e235326$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $b4be07302e235326$var$dj(b), b) : null;
        case 19:
            return $b4be07302e235326$var$G($b4be07302e235326$var$L), null;
        case 4:
            return $b4be07302e235326$var$Nh(), null;
        case 10:
            return $b4be07302e235326$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $b4be07302e235326$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b4be07302e235326$var$pk = !1, $b4be07302e235326$var$qk = !1, $b4be07302e235326$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $b4be07302e235326$var$U = null, $b4be07302e235326$var$sk = null, $b4be07302e235326$var$tk = null;
function $b4be07302e235326$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $b4be07302e235326$var$cj(), b.componentWillUnmount();
    } finally{
        $b4be07302e235326$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $b4be07302e235326$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $b4be07302e235326$var$cj(), c(null);
            } finally{
                $b4be07302e235326$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $b4be07302e235326$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b4be07302e235326$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $b4be07302e235326$var$W(a, b, d);
    }
}
var $b4be07302e235326$var$xk = !1;
function $b4be07302e235326$var$yk(a, b) {
    $b4be07302e235326$var$Qf = $b4be07302e235326$var$rd;
    a = $b4be07302e235326$var$$e();
    if ($b4be07302e235326$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b4be07302e235326$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $b4be07302e235326$var$rd = !1;
    for($b4be07302e235326$var$U = b; null !== $b4be07302e235326$var$U;)if (b = $b4be07302e235326$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b4be07302e235326$var$U = a;
    else for(; null !== $b4be07302e235326$var$U;){
        b = $b4be07302e235326$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $b4be07302e235326$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b4be07302e235326$var$p(163));
            }
        } catch (D) {
            $b4be07302e235326$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b4be07302e235326$var$U = a;
            break;
        }
        $b4be07302e235326$var$U = b.return;
    }
    m = $b4be07302e235326$var$xk;
    $b4be07302e235326$var$xk = !1;
    return m;
}
function $b4be07302e235326$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentPassiveEffectUnmountStarted && $b4be07302e235326$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $b4be07302e235326$var$uc(b), $b4be07302e235326$var$wk(b, c, f), 0 !== (a & 8) ? null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentPassiveEffectUnmountStopped && $b4be07302e235326$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $b4be07302e235326$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b4be07302e235326$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentPassiveEffectMountStarted && $b4be07302e235326$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentLayoutEffectMountStarted && $b4be07302e235326$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentPassiveEffectMountStopped && $b4be07302e235326$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentLayoutEffectMountStopped && $b4be07302e235326$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $b4be07302e235326$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $b4be07302e235326$var$cj(), b(c);
            } finally{
                $b4be07302e235326$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $b4be07302e235326$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b4be07302e235326$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b4be07302e235326$var$bg], delete b[$b4be07302e235326$var$cg], delete b[$b4be07302e235326$var$Cf], delete b[$b4be07302e235326$var$dg], delete b[$b4be07302e235326$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b4be07302e235326$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b4be07302e235326$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b4be07302e235326$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b4be07302e235326$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b4be07302e235326$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($b4be07302e235326$var$Fk(a, b, c), a = a.sibling; null !== a;)$b4be07302e235326$var$Fk(a, b, c), a = a.sibling;
}
function $b4be07302e235326$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b4be07302e235326$var$Gk(a, b, c), a = a.sibling; null !== a;)$b4be07302e235326$var$Gk(a, b, c), a = a.sibling;
}
var $b4be07302e235326$var$X = null, $b4be07302e235326$var$Hk = !1;
function $b4be07302e235326$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$b4be07302e235326$var$Jk(a, b, c), c = c.sibling;
}
function $b4be07302e235326$var$Jk(a, b, c) {
    if ($b4be07302e235326$var$lc && "function" === typeof $b4be07302e235326$var$lc.onCommitFiberUnmount) try {
        $b4be07302e235326$var$lc.onCommitFiberUnmount($b4be07302e235326$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b4be07302e235326$var$qk || $b4be07302e235326$var$vk(c, b);
        case 6:
            var d = $b4be07302e235326$var$X, e = $b4be07302e235326$var$Hk;
            $b4be07302e235326$var$X = null;
            $b4be07302e235326$var$Ik(a, b, c);
            $b4be07302e235326$var$X = d;
            $b4be07302e235326$var$Hk = e;
            null !== $b4be07302e235326$var$X && ($b4be07302e235326$var$Hk ? (a = $b4be07302e235326$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b4be07302e235326$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b4be07302e235326$var$X && ($b4be07302e235326$var$Hk ? (a = $b4be07302e235326$var$X, c = c.stateNode, 8 === a.nodeType ? $b4be07302e235326$var$Yf(a.parentNode, c) : 1 === a.nodeType && $b4be07302e235326$var$Yf(a, c), $b4be07302e235326$var$pd(a)) : $b4be07302e235326$var$Yf($b4be07302e235326$var$X, c.stateNode));
            break;
        case 4:
            d = $b4be07302e235326$var$X;
            e = $b4be07302e235326$var$Hk;
            $b4be07302e235326$var$X = c.stateNode.containerInfo;
            $b4be07302e235326$var$Hk = !0;
            $b4be07302e235326$var$Ik(a, b, c);
            $b4be07302e235326$var$X = d;
            $b4be07302e235326$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b4be07302e235326$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b4be07302e235326$var$wk(c, b, g) : 0 !== (f & 4) && ($b4be07302e235326$var$uc(c), c.mode & 2 ? ($b4be07302e235326$var$cj(), $b4be07302e235326$var$wk(c, b, g), $b4be07302e235326$var$aj(c)) : $b4be07302e235326$var$wk(c, b, g), $b4be07302e235326$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $b4be07302e235326$var$Ik(a, b, c);
            break;
        case 1:
            if (!$b4be07302e235326$var$qk && ($b4be07302e235326$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $b4be07302e235326$var$uk(c, d);
            } catch (h) {
                $b4be07302e235326$var$W(c, b, h);
            }
            $b4be07302e235326$var$Ik(a, b, c);
            break;
        case 21:
            $b4be07302e235326$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b4be07302e235326$var$qk = (d = $b4be07302e235326$var$qk) || null !== c.memoizedState, $b4be07302e235326$var$Ik(a, b, c), $b4be07302e235326$var$qk = d) : $b4be07302e235326$var$Ik(a, b, c);
            break;
        default:
            $b4be07302e235326$var$Ik(a, b, c);
    }
}
function $b4be07302e235326$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b4be07302e235326$var$rk);
        b.forEach(function(b) {
            var d = $b4be07302e235326$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($b4be07302e235326$var$mc) {
                    if (null !== $b4be07302e235326$var$sk && null !== $b4be07302e235326$var$tk) $b4be07302e235326$var$wj($b4be07302e235326$var$tk, $b4be07302e235326$var$sk);
                    else throw Error($b4be07302e235326$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $b4be07302e235326$var$Mk(a, b, c) {
    $b4be07302e235326$var$sk = c;
    $b4be07302e235326$var$tk = a;
    $b4be07302e235326$var$Nk(b, a);
    $b4be07302e235326$var$tk = $b4be07302e235326$var$sk = null;
}
function $b4be07302e235326$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b4be07302e235326$var$X = h.stateNode;
                        $b4be07302e235326$var$Hk = !1;
                        break a;
                    case 3:
                        $b4be07302e235326$var$X = h.stateNode.containerInfo;
                        $b4be07302e235326$var$Hk = !0;
                        break a;
                    case 4:
                        $b4be07302e235326$var$X = h.stateNode.containerInfo;
                        $b4be07302e235326$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b4be07302e235326$var$X) throw Error($b4be07302e235326$var$p(160));
            $b4be07302e235326$var$Jk(f, g, e);
            $b4be07302e235326$var$X = null;
            $b4be07302e235326$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b4be07302e235326$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b4be07302e235326$var$Nk(b, a), b = b.sibling;
}
function $b4be07302e235326$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            if (d & 4) {
                try {
                    $b4be07302e235326$var$zk(3, a, a.return), $b4be07302e235326$var$Ak(3, a);
                } catch (m) {
                    $b4be07302e235326$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $b4be07302e235326$var$cj(), $b4be07302e235326$var$zk(5, a, a.return);
                    } catch (m) {
                        $b4be07302e235326$var$W(a, a.return, m);
                    }
                    $b4be07302e235326$var$aj(a);
                } else try {
                    $b4be07302e235326$var$zk(5, a, a.return);
                } catch (m) {
                    $b4be07302e235326$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            d & 512 && null !== c && $b4be07302e235326$var$vk(c, c.return);
            break;
        case 5:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            d & 512 && null !== c && $b4be07302e235326$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b4be07302e235326$var$ob(e, "");
                } catch (m) {
                    $b4be07302e235326$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b4be07302e235326$var$$a(e, f);
                    $b4be07302e235326$var$vb(h, g);
                    var l = $b4be07302e235326$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $b4be07302e235326$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $b4be07302e235326$var$nb(e, q) : "children" === n ? $b4be07302e235326$var$ob(e, q) : $b4be07302e235326$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $b4be07302e235326$var$ab(e, f);
                            break;
                        case "textarea":
                            $b4be07302e235326$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $b4be07302e235326$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b4be07302e235326$var$eb(e, !!f.multiple, f.defaultValue, !0) : $b4be07302e235326$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b4be07302e235326$var$cg] = f;
                } catch (m) {
                    $b4be07302e235326$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b4be07302e235326$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $b4be07302e235326$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b4be07302e235326$var$pd(b.containerInfo);
            } catch (m) {
                $b4be07302e235326$var$W(a, a.return, m);
            }
            break;
        case 4:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            break;
        case 13:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b4be07302e235326$var$Qk = $b4be07302e235326$var$A()));
            d & 4 && $b4be07302e235326$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b4be07302e235326$var$qk = (l = $b4be07302e235326$var$qk) || n, $b4be07302e235326$var$Ok(b, a), $b4be07302e235326$var$qk = l) : $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($b4be07302e235326$var$U = a, n = a.child; null !== n;){
                    for(q = $b4be07302e235326$var$U = n; null !== $b4be07302e235326$var$U;){
                        r = $b4be07302e235326$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $b4be07302e235326$var$cj(), $b4be07302e235326$var$zk(4, r, r.return);
                                } finally{
                                    $b4be07302e235326$var$aj(r);
                                }
                                else $b4be07302e235326$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $b4be07302e235326$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $b4be07302e235326$var$uk(c, d);
                                    } catch (m) {
                                        $b4be07302e235326$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $b4be07302e235326$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b4be07302e235326$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $b4be07302e235326$var$U = z) : $b4be07302e235326$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b4be07302e235326$var$rb("display", g));
                            } catch (m) {
                                $b4be07302e235326$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $b4be07302e235326$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b4be07302e235326$var$Ok(b, a);
            $b4be07302e235326$var$Pk(a);
            d & 4 && $b4be07302e235326$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $b4be07302e235326$var$Ok(b, a), $b4be07302e235326$var$Pk(a);
    }
}
function $b4be07302e235326$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b4be07302e235326$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b4be07302e235326$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b4be07302e235326$var$ob(e, ""), d.flags &= -33);
                    var f = $b4be07302e235326$var$Ek(a);
                    $b4be07302e235326$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b4be07302e235326$var$Ek(a);
                    $b4be07302e235326$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($b4be07302e235326$var$p(161));
            }
        } catch (k) {
            $b4be07302e235326$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b4be07302e235326$var$Sk(a, b, c) {
    $b4be07302e235326$var$sk = c;
    $b4be07302e235326$var$tk = b;
    $b4be07302e235326$var$U = a;
    $b4be07302e235326$var$Tk(a, b, c);
    $b4be07302e235326$var$tk = $b4be07302e235326$var$sk = null;
}
function $b4be07302e235326$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b4be07302e235326$var$U;){
        var e = $b4be07302e235326$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b4be07302e235326$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b4be07302e235326$var$qk;
                h = $b4be07302e235326$var$pk;
                var l = $b4be07302e235326$var$qk;
                $b4be07302e235326$var$pk = g;
                if (($b4be07302e235326$var$qk = k) && !l) for($b4be07302e235326$var$U = e; null !== $b4be07302e235326$var$U;)g = $b4be07302e235326$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b4be07302e235326$var$Uk(e) : null !== k ? (k.return = g, $b4be07302e235326$var$U = k) : $b4be07302e235326$var$Uk(e);
                for(; null !== f;)$b4be07302e235326$var$U = f, $b4be07302e235326$var$Tk(f, b, c), f = f.sibling;
                $b4be07302e235326$var$U = e;
                $b4be07302e235326$var$pk = h;
                $b4be07302e235326$var$qk = l;
            }
            $b4be07302e235326$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b4be07302e235326$var$U = f) : $b4be07302e235326$var$Vk(a, b, c);
    }
}
function $b4be07302e235326$var$Vk(a) {
    for(; null !== $b4be07302e235326$var$U;){
        var b = $b4be07302e235326$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$b4be07302e235326$var$qk) {
                            if (b.mode & 2) try {
                                $b4be07302e235326$var$cj(), $b4be07302e235326$var$Ak(5, b);
                            } finally{
                                $b4be07302e235326$var$aj(b);
                            }
                            else $b4be07302e235326$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b4be07302e235326$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $b4be07302e235326$var$cj(), d.componentDidMount();
                                } finally{
                                    $b4be07302e235326$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b4be07302e235326$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $b4be07302e235326$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $b4be07302e235326$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $b4be07302e235326$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $b4be07302e235326$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $b4be07302e235326$var$Ui;
                        c = null === c ? "mount" : "update";
                        $b4be07302e235326$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $b4be07302e235326$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $b4be07302e235326$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b4be07302e235326$var$p(163));
                }
                $b4be07302e235326$var$qk || b.flags & 512 && $b4be07302e235326$var$Bk(b);
            } catch (v) {
                $b4be07302e235326$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $b4be07302e235326$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $b4be07302e235326$var$U = k;
            break;
        }
        $b4be07302e235326$var$U = b.return;
    }
}
function $b4be07302e235326$var$Rk(a) {
    for(; null !== $b4be07302e235326$var$U;){
        var b = $b4be07302e235326$var$U;
        if (b === a) {
            $b4be07302e235326$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b4be07302e235326$var$U = c;
            break;
        }
        $b4be07302e235326$var$U = b.return;
    }
}
function $b4be07302e235326$var$Uk(a) {
    for(; null !== $b4be07302e235326$var$U;){
        var b = $b4be07302e235326$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $b4be07302e235326$var$cj();
                        var c = b.return;
                        try {
                            $b4be07302e235326$var$Ak(4, b);
                        } catch (l) {
                            $b4be07302e235326$var$W(b, c, l);
                        }
                    } finally{
                        $b4be07302e235326$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $b4be07302e235326$var$Ak(4, b);
                        } catch (l) {
                            $b4be07302e235326$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $b4be07302e235326$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $b4be07302e235326$var$Bk(b);
                    } catch (l) {
                        $b4be07302e235326$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $b4be07302e235326$var$Bk(b);
                    } catch (l) {
                        $b4be07302e235326$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $b4be07302e235326$var$W(b, b.return, l);
        }
        if (b === a) {
            $b4be07302e235326$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $b4be07302e235326$var$U = k;
            break;
        }
        $b4be07302e235326$var$U = b.return;
    }
}
var $b4be07302e235326$var$Xk = Math.ceil, $b4be07302e235326$var$Yk = $b4be07302e235326$var$va.ReactCurrentDispatcher, $b4be07302e235326$var$Zk = $b4be07302e235326$var$va.ReactCurrentOwner, $b4be07302e235326$var$$k = $b4be07302e235326$var$va.ReactCurrentBatchConfig, $b4be07302e235326$var$K = 0, $b4be07302e235326$var$Q = null, $b4be07302e235326$var$Y = null, $b4be07302e235326$var$Z = 0, $b4be07302e235326$var$Jj = 0, $b4be07302e235326$var$Ij = $b4be07302e235326$var$hg(0), $b4be07302e235326$var$T = 0, $b4be07302e235326$var$al = null, $b4be07302e235326$var$Fh = 0, $b4be07302e235326$var$bl = 0, $b4be07302e235326$var$cl = 0, $b4be07302e235326$var$dl = null, $b4be07302e235326$var$el = null, $b4be07302e235326$var$Qk = 0, $b4be07302e235326$var$mk = Infinity, $b4be07302e235326$var$fl = null, $b4be07302e235326$var$qj = !1, $b4be07302e235326$var$rj = null, $b4be07302e235326$var$tj = null, $b4be07302e235326$var$gl = !1, $b4be07302e235326$var$hl = null, $b4be07302e235326$var$il = 0, $b4be07302e235326$var$jl = [], $b4be07302e235326$var$kl = 0, $b4be07302e235326$var$ll = null, $b4be07302e235326$var$ml = -1, $b4be07302e235326$var$nl = 0;
function $b4be07302e235326$var$Ri() {
    return 0 !== ($b4be07302e235326$var$K & 6) ? $b4be07302e235326$var$A() : -1 !== $b4be07302e235326$var$ml ? $b4be07302e235326$var$ml : $b4be07302e235326$var$ml = $b4be07302e235326$var$A();
}
function $b4be07302e235326$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b4be07302e235326$var$K & 2) && 0 !== $b4be07302e235326$var$Z) return $b4be07302e235326$var$Z & -$b4be07302e235326$var$Z;
    if (null !== $b4be07302e235326$var$Yg.transition) return 0 === $b4be07302e235326$var$nl && ($b4be07302e235326$var$nl = $b4be07302e235326$var$Kc()), $b4be07302e235326$var$nl;
    a = $b4be07302e235326$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b4be07302e235326$var$xd(a.type);
    return a;
}
function $b4be07302e235326$var$ui(a, b, c, d) {
    if (50 < $b4be07302e235326$var$kl) throw $b4be07302e235326$var$kl = 0, $b4be07302e235326$var$ll = null, Error($b4be07302e235326$var$p(185));
    $b4be07302e235326$var$Mc(a, c, d);
    if (0 === ($b4be07302e235326$var$K & 2) || a !== $b4be07302e235326$var$Q) $b4be07302e235326$var$mc && $b4be07302e235326$var$Pc(a, b, c), a === $b4be07302e235326$var$Q && (0 === ($b4be07302e235326$var$K & 2) && ($b4be07302e235326$var$bl |= c), 4 === $b4be07302e235326$var$T && $b4be07302e235326$var$ol(a, $b4be07302e235326$var$Z)), $b4be07302e235326$var$pl(a, d), 1 === c && 0 === $b4be07302e235326$var$K && 0 === (b.mode & 1) && ($b4be07302e235326$var$mk = $b4be07302e235326$var$A() + 500, $b4be07302e235326$var$tg && $b4be07302e235326$var$xg());
}
function $b4be07302e235326$var$pl(a, b) {
    var c = a.callbackNode;
    $b4be07302e235326$var$Ic(a, b);
    var d = $b4be07302e235326$var$Gc(a, a === $b4be07302e235326$var$Q ? $b4be07302e235326$var$Z : 0);
    if (0 === d) null !== c && $b4be07302e235326$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b4be07302e235326$var$bc(c);
        if (1 === b) 0 === a.tag ? $b4be07302e235326$var$wg($b4be07302e235326$var$ql.bind(null, a)) : $b4be07302e235326$var$vg($b4be07302e235326$var$ql.bind(null, a)), $b4be07302e235326$var$Xf(function() {
            0 === ($b4be07302e235326$var$K & 6) && $b4be07302e235326$var$xg();
        }), c = null;
        else {
            switch($b4be07302e235326$var$Rc(d)){
                case 1:
                    c = $b4be07302e235326$var$fc;
                    break;
                case 4:
                    c = $b4be07302e235326$var$gc;
                    break;
                case 16:
                    c = $b4be07302e235326$var$hc;
                    break;
                case 536870912:
                    c = $b4be07302e235326$var$jc;
                    break;
                default:
                    c = $b4be07302e235326$var$hc;
            }
            c = $b4be07302e235326$var$rl(c, $b4be07302e235326$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b4be07302e235326$var$sl(a, b) {
    $b4be07302e235326$var$Zi = $b4be07302e235326$var$Yi = !1;
    $b4be07302e235326$var$ml = -1;
    $b4be07302e235326$var$nl = 0;
    if (0 !== ($b4be07302e235326$var$K & 6)) throw Error($b4be07302e235326$var$p(327));
    var c = a.callbackNode;
    if ($b4be07302e235326$var$tl() && a.callbackNode !== c) return null;
    var d = $b4be07302e235326$var$Gc(a, a === $b4be07302e235326$var$Q ? $b4be07302e235326$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b4be07302e235326$var$ul(a, d);
    else {
        b = d;
        var e = $b4be07302e235326$var$K;
        $b4be07302e235326$var$K |= 2;
        var f = $b4be07302e235326$var$vl();
        if ($b4be07302e235326$var$Q !== a || $b4be07302e235326$var$Z !== b) {
            if ($b4be07302e235326$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($b4be07302e235326$var$wj(a, $b4be07302e235326$var$Z), g.clear());
                $b4be07302e235326$var$Qc(a, b);
            }
            $b4be07302e235326$var$fl = null;
            $b4be07302e235326$var$mk = $b4be07302e235326$var$A() + 500;
            $b4be07302e235326$var$wl(a, b);
        }
        $b4be07302e235326$var$wc(b);
        for(;;)try {
            $b4be07302e235326$var$xl();
            break;
        } catch (h) {
            $b4be07302e235326$var$yl(a, h);
        }
        $b4be07302e235326$var$nh();
        $b4be07302e235326$var$Yk.current = f;
        $b4be07302e235326$var$K = e;
        null !== $b4be07302e235326$var$Y ? (null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markRenderYielded && $b4be07302e235326$var$B.markRenderYielded(), b = 0) : ($b4be07302e235326$var$xc(), $b4be07302e235326$var$Q = null, $b4be07302e235326$var$Z = 0, b = $b4be07302e235326$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b4be07302e235326$var$Jc(a), 0 !== e && (d = e, b = $b4be07302e235326$var$zl(a, e)));
        if (1 === b) throw c = $b4be07302e235326$var$al, $b4be07302e235326$var$wl(a, 0), $b4be07302e235326$var$ol(a, d), $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A()), c;
        if (6 === b) $b4be07302e235326$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b4be07302e235326$var$Al(e) && (b = $b4be07302e235326$var$ul(a, d), 2 === b && (f = $b4be07302e235326$var$Jc(a), 0 !== f && (d = f, b = $b4be07302e235326$var$zl(a, f))), 1 === b)) throw c = $b4be07302e235326$var$al, $b4be07302e235326$var$wl(a, 0), $b4be07302e235326$var$ol(a, d), $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b4be07302e235326$var$p(345));
                case 2:
                    $b4be07302e235326$var$Cl(a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl);
                    break;
                case 3:
                    $b4be07302e235326$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $b4be07302e235326$var$Qk + 500 - $b4be07302e235326$var$A(), 10 < b)) {
                        if (0 !== $b4be07302e235326$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b4be07302e235326$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b4be07302e235326$var$Tf($b4be07302e235326$var$Cl.bind(null, a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl), b);
                        break;
                    }
                    $b4be07302e235326$var$Cl(a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl);
                    break;
                case 4:
                    $b4be07302e235326$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $b4be07302e235326$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $b4be07302e235326$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b4be07302e235326$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b4be07302e235326$var$Tf($b4be07302e235326$var$Cl.bind(null, a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl), d);
                        break;
                    }
                    $b4be07302e235326$var$Cl(a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl);
                    break;
                case 5:
                    $b4be07302e235326$var$Cl(a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl);
                    break;
                default:
                    throw Error($b4be07302e235326$var$p(329));
            }
        }
    }
    $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A());
    return a.callbackNode === c ? $b4be07302e235326$var$sl.bind(null, a) : null;
}
function $b4be07302e235326$var$zl(a, b) {
    var c = $b4be07302e235326$var$dl;
    a.current.memoizedState.isDehydrated && ($b4be07302e235326$var$wl(a, b).flags |= 256);
    a = $b4be07302e235326$var$ul(a, b);
    2 !== a && (b = $b4be07302e235326$var$el, $b4be07302e235326$var$el = c, null !== b && $b4be07302e235326$var$lk(b));
    return a;
}
function $b4be07302e235326$var$lk(a) {
    null === $b4be07302e235326$var$el ? $b4be07302e235326$var$el = a : $b4be07302e235326$var$el.push.apply($b4be07302e235326$var$el, a);
}
function $b4be07302e235326$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b4be07302e235326$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b4be07302e235326$var$ol(a, b) {
    b &= ~$b4be07302e235326$var$cl;
    b &= ~$b4be07302e235326$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b4be07302e235326$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b4be07302e235326$var$ql(a) {
    $b4be07302e235326$var$Yi = $b4be07302e235326$var$Zi;
    $b4be07302e235326$var$Zi = !1;
    if (0 !== ($b4be07302e235326$var$K & 6)) throw Error($b4be07302e235326$var$p(327));
    $b4be07302e235326$var$tl();
    var b = $b4be07302e235326$var$Gc(a, 0);
    if (0 === (b & 1)) return $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A()), null;
    var c = $b4be07302e235326$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b4be07302e235326$var$Jc(a);
        0 !== d && (b = d, c = $b4be07302e235326$var$zl(a, d));
    }
    if (1 === c) throw c = $b4be07302e235326$var$al, $b4be07302e235326$var$wl(a, 0), $b4be07302e235326$var$ol(a, b), $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A()), c;
    if (6 === c) throw Error($b4be07302e235326$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b4be07302e235326$var$Cl(a, $b4be07302e235326$var$el, $b4be07302e235326$var$fl);
    $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A());
    return null;
}
function $b4be07302e235326$var$Dl(a, b) {
    var c = $b4be07302e235326$var$K;
    $b4be07302e235326$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b4be07302e235326$var$K = c, 0 === $b4be07302e235326$var$K && ($b4be07302e235326$var$mk = $b4be07302e235326$var$A() + 500, $b4be07302e235326$var$tg && $b4be07302e235326$var$xg());
    }
}
function $b4be07302e235326$var$El(a) {
    null !== $b4be07302e235326$var$hl && 0 === $b4be07302e235326$var$hl.tag && 0 === ($b4be07302e235326$var$K & 6) && $b4be07302e235326$var$tl();
    var b = $b4be07302e235326$var$K;
    $b4be07302e235326$var$K |= 1;
    var c = $b4be07302e235326$var$$k.transition, d = $b4be07302e235326$var$E;
    try {
        if ($b4be07302e235326$var$$k.transition = null, $b4be07302e235326$var$E = 1, a) return a();
    } finally{
        $b4be07302e235326$var$E = d, $b4be07302e235326$var$$k.transition = c, $b4be07302e235326$var$K = b, 0 === ($b4be07302e235326$var$K & 6) && $b4be07302e235326$var$xg();
    }
}
function $b4be07302e235326$var$nk() {
    $b4be07302e235326$var$Jj = $b4be07302e235326$var$Ij.current;
    $b4be07302e235326$var$G($b4be07302e235326$var$Ij);
}
function $b4be07302e235326$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b4be07302e235326$var$Uf(c));
    if (null !== $b4be07302e235326$var$Y) for(c = $b4be07302e235326$var$Y.return; null !== c;){
        var d = c;
        $b4be07302e235326$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b4be07302e235326$var$ng();
                break;
            case 3:
                $b4be07302e235326$var$Nh();
                $b4be07302e235326$var$G($b4be07302e235326$var$jg);
                $b4be07302e235326$var$G($b4be07302e235326$var$I);
                $b4be07302e235326$var$Sh();
                break;
            case 5:
                $b4be07302e235326$var$Ph(d);
                break;
            case 4:
                $b4be07302e235326$var$Nh();
                break;
            case 13:
                $b4be07302e235326$var$G($b4be07302e235326$var$L);
                break;
            case 19:
                $b4be07302e235326$var$G($b4be07302e235326$var$L);
                break;
            case 10:
                $b4be07302e235326$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $b4be07302e235326$var$nk();
        }
        c = c.return;
    }
    $b4be07302e235326$var$Q = a;
    $b4be07302e235326$var$Y = a = $b4be07302e235326$var$ch(a.current, null);
    $b4be07302e235326$var$Z = $b4be07302e235326$var$Jj = b;
    $b4be07302e235326$var$T = 0;
    $b4be07302e235326$var$al = null;
    $b4be07302e235326$var$cl = $b4be07302e235326$var$bl = $b4be07302e235326$var$Fh = 0;
    $b4be07302e235326$var$el = $b4be07302e235326$var$dl = null;
    if (null !== $b4be07302e235326$var$th) {
        for(b = 0; b < $b4be07302e235326$var$th.length; b++)if (c = $b4be07302e235326$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b4be07302e235326$var$th = null;
    }
    return a;
}
function $b4be07302e235326$var$yl(a, b) {
    do {
        var c = $b4be07302e235326$var$Y;
        try {
            $b4be07302e235326$var$nh();
            $b4be07302e235326$var$Th.current = $b4be07302e235326$var$ei;
            if ($b4be07302e235326$var$Wh) {
                for(var d = $b4be07302e235326$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b4be07302e235326$var$Wh = !1;
            }
            $b4be07302e235326$var$Vh = 0;
            $b4be07302e235326$var$O = $b4be07302e235326$var$N = $b4be07302e235326$var$M = null;
            $b4be07302e235326$var$Xh = !1;
            $b4be07302e235326$var$Yh = 0;
            $b4be07302e235326$var$Zk.current = null;
            if (null === c || null === c.return) {
                $b4be07302e235326$var$T = 1;
                $b4be07302e235326$var$al = b;
                $b4be07302e235326$var$Y = null;
                break;
            }
            c.mode & 2 && $b4be07302e235326$var$$i(c, !0);
            $b4be07302e235326$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentSuspended && $b4be07302e235326$var$B.markComponentSuspended(c, f, $b4be07302e235326$var$Z);
            } else null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markComponentErrored && $b4be07302e235326$var$B.markComponentErrored(c, b, $b4be07302e235326$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $b4be07302e235326$var$Z;
                k.flags |= 32768;
                $b4be07302e235326$var$mc && $b4be07302e235326$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $b4be07302e235326$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $b4be07302e235326$var$yj(z, h, k, g, b);
                        z.mode & 1 && $b4be07302e235326$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b4be07302e235326$var$uj(g, l, b);
                            $b4be07302e235326$var$Zj();
                            break a;
                        }
                        f = Error($b4be07302e235326$var$p(426));
                    }
                } else if ($b4be07302e235326$var$J && k.mode & 1) {
                    var C = $b4be07302e235326$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $b4be07302e235326$var$yj(C, h, k, g, b);
                        $b4be07302e235326$var$Xg($b4be07302e235326$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $b4be07302e235326$var$lj(f, k);
                4 !== $b4be07302e235326$var$T && ($b4be07302e235326$var$T = 2);
                null === $b4be07302e235326$var$dl ? $b4be07302e235326$var$dl = [
                    g
                ] : $b4be07302e235326$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $b4be07302e235326$var$pj(g, f, b);
                            $b4be07302e235326$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $b4be07302e235326$var$tj || !$b4be07302e235326$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $b4be07302e235326$var$sj(g, k, b);
                                $b4be07302e235326$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $b4be07302e235326$var$Fl(c);
        } catch (ca) {
            b = ca;
            $b4be07302e235326$var$Y === c && null !== c && ($b4be07302e235326$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b4be07302e235326$var$vl() {
    var a = $b4be07302e235326$var$Yk.current;
    $b4be07302e235326$var$Yk.current = $b4be07302e235326$var$ei;
    return null === a ? $b4be07302e235326$var$ei : a;
}
function $b4be07302e235326$var$Zj() {
    if (0 === $b4be07302e235326$var$T || 3 === $b4be07302e235326$var$T || 2 === $b4be07302e235326$var$T) $b4be07302e235326$var$T = 4;
    null === $b4be07302e235326$var$Q || 0 === ($b4be07302e235326$var$Fh & 268435455) && 0 === ($b4be07302e235326$var$bl & 268435455) || $b4be07302e235326$var$ol($b4be07302e235326$var$Q, $b4be07302e235326$var$Z);
}
function $b4be07302e235326$var$ul(a, b) {
    var c = $b4be07302e235326$var$K;
    $b4be07302e235326$var$K |= 2;
    var d = $b4be07302e235326$var$vl();
    if ($b4be07302e235326$var$Q !== a || $b4be07302e235326$var$Z !== b) {
        if ($b4be07302e235326$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($b4be07302e235326$var$wj(a, $b4be07302e235326$var$Z), e.clear());
            $b4be07302e235326$var$Qc(a, b);
        }
        $b4be07302e235326$var$fl = null;
        $b4be07302e235326$var$wl(a, b);
    }
    $b4be07302e235326$var$wc(b);
    for(;;)try {
        $b4be07302e235326$var$Gl();
        break;
    } catch (f) {
        $b4be07302e235326$var$yl(a, f);
    }
    $b4be07302e235326$var$nh();
    $b4be07302e235326$var$K = c;
    $b4be07302e235326$var$Yk.current = d;
    if (null !== $b4be07302e235326$var$Y) throw Error($b4be07302e235326$var$p(261));
    $b4be07302e235326$var$xc();
    $b4be07302e235326$var$Q = null;
    $b4be07302e235326$var$Z = 0;
    return $b4be07302e235326$var$T;
}
function $b4be07302e235326$var$Gl() {
    for(; null !== $b4be07302e235326$var$Y;)$b4be07302e235326$var$Hl($b4be07302e235326$var$Y);
}
function $b4be07302e235326$var$xl() {
    for(; null !== $b4be07302e235326$var$Y && !$b4be07302e235326$var$cc();)$b4be07302e235326$var$Hl($b4be07302e235326$var$Y);
}
function $b4be07302e235326$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($b4be07302e235326$var$Wi = $b4be07302e235326$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $b4be07302e235326$var$Ti()), b = $b4be07302e235326$var$Il(b, a, $b4be07302e235326$var$Jj), $b4be07302e235326$var$$i(a, !0)) : b = $b4be07302e235326$var$Il(b, a, $b4be07302e235326$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b4be07302e235326$var$Fl(a) : $b4be07302e235326$var$Y = b;
    $b4be07302e235326$var$Zk.current = null;
}
function $b4be07302e235326$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $b4be07302e235326$var$kk(c, b, $b4be07302e235326$var$Jj);
            else {
                var d = b;
                $b4be07302e235326$var$Wi = $b4be07302e235326$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $b4be07302e235326$var$Ti());
                c = $b4be07302e235326$var$kk(c, b, $b4be07302e235326$var$Jj);
                $b4be07302e235326$var$$i(b, !1);
            }
            if (null !== c) {
                $b4be07302e235326$var$Y = c;
                return;
            }
        } else {
            c = $b4be07302e235326$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b4be07302e235326$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $b4be07302e235326$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b4be07302e235326$var$T = 6;
                $b4be07302e235326$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b4be07302e235326$var$Y = b;
            return;
        }
        $b4be07302e235326$var$Y = b = a;
    }while (null !== b);
    0 === $b4be07302e235326$var$T && ($b4be07302e235326$var$T = 5);
}
function $b4be07302e235326$var$Cl(a, b, c) {
    var d = $b4be07302e235326$var$E, e = $b4be07302e235326$var$$k.transition;
    try {
        $b4be07302e235326$var$$k.transition = null, $b4be07302e235326$var$E = 1, $b4be07302e235326$var$Jl(a, b, c, d);
    } finally{
        $b4be07302e235326$var$$k.transition = e, $b4be07302e235326$var$E = d;
    }
    return null;
}
function $b4be07302e235326$var$Jl(a, b, c, d) {
    do $b4be07302e235326$var$tl();
    while (null !== $b4be07302e235326$var$hl);
    if (0 !== ($b4be07302e235326$var$K & 6)) throw Error($b4be07302e235326$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markCommitStarted && $b4be07302e235326$var$B.markCommitStarted(e);
    if (null === c) return $b4be07302e235326$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b4be07302e235326$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b4be07302e235326$var$Nc(a, f);
    a === $b4be07302e235326$var$Q && ($b4be07302e235326$var$Y = $b4be07302e235326$var$Q = null, $b4be07302e235326$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b4be07302e235326$var$gl || ($b4be07302e235326$var$gl = !0, $b4be07302e235326$var$rl($b4be07302e235326$var$hc, function() {
        $b4be07302e235326$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b4be07302e235326$var$$k.transition;
        $b4be07302e235326$var$$k.transition = null;
        var g = $b4be07302e235326$var$E;
        $b4be07302e235326$var$E = 1;
        var h = $b4be07302e235326$var$K;
        $b4be07302e235326$var$K |= 4;
        $b4be07302e235326$var$Zk.current = null;
        $b4be07302e235326$var$yk(a, c);
        $b4be07302e235326$var$Ui = $b4be07302e235326$var$Ti();
        $b4be07302e235326$var$Mk(a, c, e);
        $b4be07302e235326$var$bf($b4be07302e235326$var$Rf);
        $b4be07302e235326$var$rd = !!$b4be07302e235326$var$Qf;
        $b4be07302e235326$var$Rf = $b4be07302e235326$var$Qf = null;
        a.current = c;
        null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markLayoutEffectsStarted && $b4be07302e235326$var$B.markLayoutEffectsStarted(e);
        $b4be07302e235326$var$Sk(c, a, e);
        null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markLayoutEffectsStopped && $b4be07302e235326$var$B.markLayoutEffectsStopped();
        $b4be07302e235326$var$dc();
        $b4be07302e235326$var$K = h;
        $b4be07302e235326$var$E = g;
        $b4be07302e235326$var$$k.transition = f;
    } else a.current = c, $b4be07302e235326$var$Ui = $b4be07302e235326$var$Ti();
    $b4be07302e235326$var$gl && ($b4be07302e235326$var$gl = !1, $b4be07302e235326$var$hl = a, $b4be07302e235326$var$il = e);
    f = a.pendingLanes;
    0 === f && ($b4be07302e235326$var$tj = null);
    $b4be07302e235326$var$nc(c.stateNode, d);
    $b4be07302e235326$var$mc && a.memoizedUpdaters.clear();
    $b4be07302e235326$var$pl(a, $b4be07302e235326$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b4be07302e235326$var$qj) throw $b4be07302e235326$var$qj = !1, a = $b4be07302e235326$var$rj, $b4be07302e235326$var$rj = null, a;
    0 !== ($b4be07302e235326$var$il & 1) && 0 !== a.tag && $b4be07302e235326$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($b4be07302e235326$var$Zi = !0, a === $b4be07302e235326$var$ll ? $b4be07302e235326$var$kl++ : ($b4be07302e235326$var$kl = 0, $b4be07302e235326$var$ll = a)) : $b4be07302e235326$var$kl = 0;
    $b4be07302e235326$var$xg();
    $b4be07302e235326$var$rc();
    return null;
}
function $b4be07302e235326$var$tl() {
    if (null !== $b4be07302e235326$var$hl) {
        var a = $b4be07302e235326$var$Rc($b4be07302e235326$var$il), b = $b4be07302e235326$var$$k.transition, c = $b4be07302e235326$var$E;
        try {
            $b4be07302e235326$var$$k.transition = null;
            $b4be07302e235326$var$E = 16 > a ? 16 : a;
            if (null === $b4be07302e235326$var$hl) var d = !1;
            else {
                a = $b4be07302e235326$var$hl;
                var e = $b4be07302e235326$var$il;
                $b4be07302e235326$var$hl = null;
                $b4be07302e235326$var$il = 0;
                if (0 !== ($b4be07302e235326$var$K & 6)) throw Error($b4be07302e235326$var$p(331));
                null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markPassiveEffectsStarted && $b4be07302e235326$var$B.markPassiveEffectsStarted(e);
                e = $b4be07302e235326$var$K;
                $b4be07302e235326$var$K |= 4;
                for($b4be07302e235326$var$U = a.current; null !== $b4be07302e235326$var$U;){
                    var f = $b4be07302e235326$var$U, g = f.child;
                    if (0 !== ($b4be07302e235326$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b4be07302e235326$var$U = l; null !== $b4be07302e235326$var$U;){
                                    var n = $b4be07302e235326$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($b4be07302e235326$var$Xi = $b4be07302e235326$var$Ti(), $b4be07302e235326$var$zk(8, q, f), $b4be07302e235326$var$bj(q)) : $b4be07302e235326$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $b4be07302e235326$var$U = r;
                                    else for(; null !== $b4be07302e235326$var$U;){
                                        n = $b4be07302e235326$var$U;
                                        var z = n.sibling, m = n.return;
                                        $b4be07302e235326$var$Ck(n);
                                        if (n === l) {
                                            $b4be07302e235326$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $b4be07302e235326$var$U = z;
                                            break;
                                        }
                                        $b4be07302e235326$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $b4be07302e235326$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b4be07302e235326$var$U = g;
                    else b: for(; null !== $b4be07302e235326$var$U;){
                        f = $b4be07302e235326$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($b4be07302e235326$var$Xi = $b4be07302e235326$var$Ti(), $b4be07302e235326$var$zk(9, k, k.return), $b4be07302e235326$var$bj(k)) : $b4be07302e235326$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $b4be07302e235326$var$U = y;
                            break b;
                        }
                        $b4be07302e235326$var$U = f.return;
                    }
                }
                var v = a.current;
                for($b4be07302e235326$var$U = v; null !== $b4be07302e235326$var$U;){
                    g = $b4be07302e235326$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $b4be07302e235326$var$U = D;
                    else b: for(g = v; null !== $b4be07302e235326$var$U;){
                        h = $b4be07302e235326$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $b4be07302e235326$var$Xi = $b4be07302e235326$var$Ti();
                                        try {
                                            $b4be07302e235326$var$Ak(9, l);
                                        } finally{
                                            $b4be07302e235326$var$bj(l);
                                        }
                                    } else $b4be07302e235326$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $b4be07302e235326$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $b4be07302e235326$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $b4be07302e235326$var$U = ca;
                            break b;
                        }
                        $b4be07302e235326$var$U = h.return;
                    }
                }
                v = $b4be07302e235326$var$jl;
                $b4be07302e235326$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $b4be07302e235326$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $b4be07302e235326$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markPassiveEffectsStopped && $b4be07302e235326$var$B.markPassiveEffectsStopped();
                $b4be07302e235326$var$K = e;
                $b4be07302e235326$var$xg();
                if ($b4be07302e235326$var$lc && "function" === typeof $b4be07302e235326$var$lc.onPostCommitFiberRoot) try {
                    $b4be07302e235326$var$lc.onPostCommitFiberRoot($b4be07302e235326$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $b4be07302e235326$var$E = c, $b4be07302e235326$var$$k.transition = b;
        }
    }
    return !1;
}
function $b4be07302e235326$var$Wk(a) {
    $b4be07302e235326$var$jl.push(a);
    $b4be07302e235326$var$gl || ($b4be07302e235326$var$gl = !0, $b4be07302e235326$var$rl($b4be07302e235326$var$hc, function() {
        $b4be07302e235326$var$tl();
        return null;
    }));
}
function $b4be07302e235326$var$Kl(a, b, c) {
    b = $b4be07302e235326$var$lj(c, b);
    b = $b4be07302e235326$var$pj(a, b, 1);
    a = $b4be07302e235326$var$Bh(a, b, 1);
    b = $b4be07302e235326$var$Ri();
    null !== a && ($b4be07302e235326$var$Mc(a, 1, b), $b4be07302e235326$var$pl(a, b));
}
function $b4be07302e235326$var$W(a, b, c) {
    if (3 === a.tag) $b4be07302e235326$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b4be07302e235326$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b4be07302e235326$var$tj || !$b4be07302e235326$var$tj.has(d))) {
                a = $b4be07302e235326$var$lj(c, a);
                a = $b4be07302e235326$var$sj(b, a, 1);
                b = $b4be07302e235326$var$Bh(b, a, 1);
                a = $b4be07302e235326$var$Ri();
                null !== b && ($b4be07302e235326$var$Mc(b, 1, a), $b4be07302e235326$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b4be07302e235326$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b4be07302e235326$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $b4be07302e235326$var$Q === a && ($b4be07302e235326$var$Z & c) === c && (4 === $b4be07302e235326$var$T || 3 === $b4be07302e235326$var$T && ($b4be07302e235326$var$Z & 130023424) === $b4be07302e235326$var$Z && 500 > $b4be07302e235326$var$A() - $b4be07302e235326$var$Qk ? $b4be07302e235326$var$wl(a, 0) : $b4be07302e235326$var$cl |= c);
    $b4be07302e235326$var$pl(a, b);
}
function $b4be07302e235326$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b4be07302e235326$var$Ec, $b4be07302e235326$var$Ec <<= 1, 0 === ($b4be07302e235326$var$Ec & 130023424) && ($b4be07302e235326$var$Ec = 4194304)));
    var c = $b4be07302e235326$var$Ri();
    a = $b4be07302e235326$var$wh(a, b);
    null !== a && ($b4be07302e235326$var$Mc(a, b, c), $b4be07302e235326$var$pl(a, c));
}
function $b4be07302e235326$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b4be07302e235326$var$Ll(a, c);
}
function $b4be07302e235326$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b4be07302e235326$var$p(314));
    }
    null !== d && d.delete(b);
    $b4be07302e235326$var$Ll(a, c);
}
var $b4be07302e235326$var$Il;
$b4be07302e235326$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b4be07302e235326$var$jg.current) $b4be07302e235326$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b4be07302e235326$var$rh = !1, $b4be07302e235326$var$ek(a, b, c);
            $b4be07302e235326$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b4be07302e235326$var$rh = !1, $b4be07302e235326$var$J && 0 !== (b.flags & 1048576) && $b4be07302e235326$var$Ig(b, $b4be07302e235326$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b4be07302e235326$var$Mj(a, b);
            a = b.pendingProps;
            var e = $b4be07302e235326$var$lg(b, $b4be07302e235326$var$I.current);
            $b4be07302e235326$var$qh(b, c);
            $b4be07302e235326$var$sc(b);
            e = $b4be07302e235326$var$ai(null, b, d, a, e, c);
            var f = $b4be07302e235326$var$fi();
            $b4be07302e235326$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b4be07302e235326$var$mg(d) ? (f = !0, $b4be07302e235326$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b4be07302e235326$var$yh(b), e.updater = $b4be07302e235326$var$gj, b.stateNode = e, e._reactInternals = b, $b4be07302e235326$var$kj(b, d, a, c), b = $b4be07302e235326$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $b4be07302e235326$var$J && f && $b4be07302e235326$var$Jg(b), $b4be07302e235326$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b4be07302e235326$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b4be07302e235326$var$Ml(d);
                a = $b4be07302e235326$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $b4be07302e235326$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b4be07302e235326$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b4be07302e235326$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b4be07302e235326$var$Dj(null, b, d, $b4be07302e235326$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($b4be07302e235326$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b4be07302e235326$var$ej(d, e), $b4be07302e235326$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b4be07302e235326$var$ej(d, e), $b4be07302e235326$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $b4be07302e235326$var$Oj(b);
                if (null === a) throw Error($b4be07302e235326$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b4be07302e235326$var$zh(a, b);
                $b4be07302e235326$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b4be07302e235326$var$lj(Error($b4be07302e235326$var$p(423)), b);
                        b = $b4be07302e235326$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b4be07302e235326$var$lj(Error($b4be07302e235326$var$p(424)), b);
                        b = $b4be07302e235326$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($b4be07302e235326$var$Mg = $b4be07302e235326$var$Zf(b.stateNode.containerInfo.firstChild), $b4be07302e235326$var$Lg = b, $b4be07302e235326$var$J = !0, $b4be07302e235326$var$Ng = null, c = $b4be07302e235326$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b4be07302e235326$var$Wg();
                    if (d === e) {
                        b = $b4be07302e235326$var$Cj(a, b, c);
                        break a;
                    }
                    $b4be07302e235326$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b4be07302e235326$var$Oh(b), null === a && $b4be07302e235326$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b4be07302e235326$var$Sf(d, e) ? g = null : null !== f && $b4be07302e235326$var$Sf(d, f) && (b.flags |= 32), $b4be07302e235326$var$Kj(a, b), $b4be07302e235326$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $b4be07302e235326$var$Sg(b), null;
        case 13:
            return $b4be07302e235326$var$Uj(a, b, c);
        case 4:
            return $b4be07302e235326$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b4be07302e235326$var$hh(b, null, d, c) : $b4be07302e235326$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b4be07302e235326$var$ej(d, e), $b4be07302e235326$var$Bj(a, b, d, e, c);
        case 7:
            return $b4be07302e235326$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b4be07302e235326$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $b4be07302e235326$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b4be07302e235326$var$H($b4be07302e235326$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b4be07302e235326$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$b4be07302e235326$var$jg.current) {
                            b = $b4be07302e235326$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b4be07302e235326$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b4be07302e235326$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b4be07302e235326$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b4be07302e235326$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b4be07302e235326$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b4be07302e235326$var$qh(b, c), e = $b4be07302e235326$var$sh(e), $b4be07302e235326$var$sc(b), d = d(e), $b4be07302e235326$var$tc(), b.flags |= 1, $b4be07302e235326$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b4be07302e235326$var$ej(d, b.pendingProps), e = $b4be07302e235326$var$ej(d.type, e), $b4be07302e235326$var$Dj(a, b, d, e, c);
        case 15:
            return $b4be07302e235326$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b4be07302e235326$var$ej(d, e), $b4be07302e235326$var$Mj(a, b), b.tag = 1, $b4be07302e235326$var$mg(d) ? (a = !0, $b4be07302e235326$var$qg(b)) : a = !1, $b4be07302e235326$var$qh(b, c), $b4be07302e235326$var$ij(b, d, e), $b4be07302e235326$var$kj(b, d, e, c), $b4be07302e235326$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $b4be07302e235326$var$dk(a, b, c);
        case 22:
            return $b4be07302e235326$var$Hj(a, b, c);
    }
    throw Error($b4be07302e235326$var$p(156, b.tag));
};
function $b4be07302e235326$var$wj(a, b) {
    $b4be07302e235326$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $b4be07302e235326$var$Pc(a, c, b);
    });
}
function $b4be07302e235326$var$rl(a, b) {
    return $b4be07302e235326$var$ac(a, b);
}
function $b4be07302e235326$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $b4be07302e235326$var$Pg(a, b, c, d) {
    return new $b4be07302e235326$var$Nl(a, b, c, d);
}
function $b4be07302e235326$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b4be07302e235326$var$Ml(a) {
    if ("function" === typeof a) return $b4be07302e235326$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b4be07302e235326$var$Da) return 11;
        if (a === $b4be07302e235326$var$Ga) return 14;
    }
    return 2;
}
function $b4be07302e235326$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $b4be07302e235326$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $b4be07302e235326$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b4be07302e235326$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b4be07302e235326$var$ya:
            return $b4be07302e235326$var$gh(c.children, e, f, b);
        case $b4be07302e235326$var$za:
            g = 8;
            e |= 8;
            break;
        case $b4be07302e235326$var$Aa:
            return a = $b4be07302e235326$var$Pg(12, c, b, e | 2), a.elementType = $b4be07302e235326$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $b4be07302e235326$var$Ea:
            return a = $b4be07302e235326$var$Pg(13, c, b, e), a.elementType = $b4be07302e235326$var$Ea, a.lanes = f, a;
        case $b4be07302e235326$var$Fa:
            return a = $b4be07302e235326$var$Pg(19, c, b, e), a.elementType = $b4be07302e235326$var$Fa, a.lanes = f, a;
        case $b4be07302e235326$var$Ia:
            return $b4be07302e235326$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b4be07302e235326$var$Ba:
                    g = 10;
                    break a;
                case $b4be07302e235326$var$Ca:
                    g = 9;
                    break a;
                case $b4be07302e235326$var$Da:
                    g = 11;
                    break a;
                case $b4be07302e235326$var$Ga:
                    g = 14;
                    break a;
                case $b4be07302e235326$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b4be07302e235326$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b4be07302e235326$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b4be07302e235326$var$gh(a, b, c, d) {
    a = $b4be07302e235326$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b4be07302e235326$var$Vj(a, b, c, d) {
    a = $b4be07302e235326$var$Pg(22, a, d, b);
    a.elementType = $b4be07302e235326$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b4be07302e235326$var$dh(a, b, c) {
    a = $b4be07302e235326$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b4be07302e235326$var$fh(a, b, c) {
    b = $b4be07302e235326$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b4be07302e235326$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b4be07302e235326$var$Lc(0);
    this.expirationTimes = $b4be07302e235326$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b4be07302e235326$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $b4be07302e235326$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $b4be07302e235326$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $b4be07302e235326$var$mc && (b |= 2);
    f = $b4be07302e235326$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b4be07302e235326$var$yh(f);
    return a;
}
function $b4be07302e235326$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b4be07302e235326$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b4be07302e235326$var$Rl(a) {
    if (!a) return $b4be07302e235326$var$ig;
    a = a._reactInternals;
    a: {
        if ($b4be07302e235326$var$Vb(a) !== a || 1 !== a.tag) throw Error($b4be07302e235326$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b4be07302e235326$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b4be07302e235326$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b4be07302e235326$var$mg(c)) return $b4be07302e235326$var$pg(a, c, b);
    }
    return b;
}
function $b4be07302e235326$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $b4be07302e235326$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $b4be07302e235326$var$Rl(null);
    c = a.current;
    d = $b4be07302e235326$var$Ri();
    e = $b4be07302e235326$var$Oi(c);
    f = $b4be07302e235326$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b4be07302e235326$var$Bh(c, f, e);
    a.current.lanes = e;
    $b4be07302e235326$var$Mc(a, e, d);
    $b4be07302e235326$var$pl(a, d);
    return a;
}
function $b4be07302e235326$var$Tl(a, b, c, d) {
    var e = b.current, f = $b4be07302e235326$var$Ri(), g = $b4be07302e235326$var$Oi(e);
    null !== $b4be07302e235326$var$B && "function" === typeof $b4be07302e235326$var$B.markRenderScheduled && $b4be07302e235326$var$B.markRenderScheduled(g);
    c = $b4be07302e235326$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b4be07302e235326$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b4be07302e235326$var$Bh(e, b, g);
    null !== a && ($b4be07302e235326$var$ui(a, e, g, f), $b4be07302e235326$var$Ch(a, e, g));
    return g;
}
function $b4be07302e235326$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b4be07302e235326$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b4be07302e235326$var$Wl(a, b) {
    $b4be07302e235326$var$Vl(a, b);
    (a = a.alternate) && $b4be07302e235326$var$Vl(a, b);
}
function $b4be07302e235326$var$Xl() {
    return null;
}
var $b4be07302e235326$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b4be07302e235326$var$Zl(a) {
    this._internalRoot = a;
}
$b4be07302e235326$var$$l.prototype.render = $b4be07302e235326$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b4be07302e235326$var$p(409));
    $b4be07302e235326$var$Tl(a, b, null, null);
};
$b4be07302e235326$var$$l.prototype.unmount = $b4be07302e235326$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b4be07302e235326$var$El(function() {
            $b4be07302e235326$var$Tl(null, a, null, null);
        });
        b[$b4be07302e235326$var$If] = null;
    }
};
function $b4be07302e235326$var$$l(a) {
    this._internalRoot = a;
}
$b4be07302e235326$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b4be07302e235326$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b4be07302e235326$var$dd.length && 0 !== b && b < $b4be07302e235326$var$dd[c].priority; c++);
        $b4be07302e235326$var$dd.splice(c, 0, a);
        0 === c && $b4be07302e235326$var$id(a);
    }
};
function $b4be07302e235326$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b4be07302e235326$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b4be07302e235326$var$cm() {}
function $b4be07302e235326$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b4be07302e235326$var$Ul(g);
                f.call(a);
            };
        }
        var g = $b4be07302e235326$var$Sl(b, d, a, 0, null, !1, !1, "", $b4be07302e235326$var$cm);
        a._reactRootContainer = g;
        a[$b4be07302e235326$var$If] = g.current;
        $b4be07302e235326$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $b4be07302e235326$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b4be07302e235326$var$Ul(k);
            h.call(a);
        };
    }
    var k = $b4be07302e235326$var$Pl(a, 0, !1, null, null, !1, !1, "", $b4be07302e235326$var$cm);
    a._reactRootContainer = k;
    a[$b4be07302e235326$var$If] = k.current;
    $b4be07302e235326$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $b4be07302e235326$var$El(function() {
        $b4be07302e235326$var$Tl(b, k, c, d);
    });
    return k;
}
function $b4be07302e235326$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b4be07302e235326$var$Ul(g);
                h.call(a);
            };
        }
        $b4be07302e235326$var$Tl(b, g, a, e);
    } else g = $b4be07302e235326$var$dm(c, b, a, e, d);
    return $b4be07302e235326$var$Ul(g);
}
$b4be07302e235326$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b4be07302e235326$var$Fc(b.pendingLanes);
                0 !== c && ($b4be07302e235326$var$Oc(b, c | 1), $b4be07302e235326$var$pl(b, $b4be07302e235326$var$A()), 0 === ($b4be07302e235326$var$K & 6) && ($b4be07302e235326$var$mk = $b4be07302e235326$var$A() + 500, $b4be07302e235326$var$xg()));
            }
            break;
        case 13:
            $b4be07302e235326$var$El(function() {
                var b = $b4be07302e235326$var$wh(a, 1);
                if (null !== b) {
                    var c = $b4be07302e235326$var$Ri();
                    $b4be07302e235326$var$ui(b, a, 1, c);
                }
            }), $b4be07302e235326$var$Wl(a, 1);
    }
};
$b4be07302e235326$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $b4be07302e235326$var$wh(a, 134217728);
        if (null !== b) {
            var c = $b4be07302e235326$var$Ri();
            $b4be07302e235326$var$ui(b, a, 134217728, c);
        }
        $b4be07302e235326$var$Wl(a, 134217728);
    }
};
$b4be07302e235326$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $b4be07302e235326$var$Oi(a), c = $b4be07302e235326$var$wh(a, b);
        if (null !== c) {
            var d = $b4be07302e235326$var$Ri();
            $b4be07302e235326$var$ui(c, a, b, d);
        }
        $b4be07302e235326$var$Wl(a, b);
    }
};
$b4be07302e235326$var$Vc = function() {
    return $b4be07302e235326$var$E;
};
$b4be07302e235326$var$Wc = function(a, b) {
    var c = $b4be07302e235326$var$E;
    try {
        return $b4be07302e235326$var$E = a, b();
    } finally{
        $b4be07302e235326$var$E = c;
    }
};
$b4be07302e235326$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b4be07302e235326$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b4be07302e235326$var$Db(d);
                        if (!e) throw Error($b4be07302e235326$var$p(90));
                        $b4be07302e235326$var$Wa(d);
                        $b4be07302e235326$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b4be07302e235326$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $b4be07302e235326$var$eb(a, !!c.multiple, b, !1);
    }
};
$b4be07302e235326$var$Gb = $b4be07302e235326$var$Dl;
$b4be07302e235326$var$Hb = $b4be07302e235326$var$El;
var $b4be07302e235326$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $b4be07302e235326$var$Cb,
        $b4be07302e235326$var$Ie,
        $b4be07302e235326$var$Db,
        $b4be07302e235326$var$Eb,
        $b4be07302e235326$var$Fb,
        $b4be07302e235326$var$Dl
    ]
}, $b4be07302e235326$var$gm = {
    findFiberByHostInstance: $b4be07302e235326$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $b4be07302e235326$var$u({}, a, {
            getLaneLabelMap: $b4be07302e235326$var$pc,
            injectProfilingHooks: $b4be07302e235326$var$oc
        }), $b4be07302e235326$var$kc = b.inject(a), $b4be07302e235326$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $b4be07302e235326$var$gm.bundleType,
    version: $b4be07302e235326$var$gm.version,
    rendererPackageName: $b4be07302e235326$var$gm.rendererPackageName,
    rendererConfig: $b4be07302e235326$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b4be07302e235326$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b4be07302e235326$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b4be07302e235326$var$gm.findFiberByHostInstance || $b4be07302e235326$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$b4be07302e235326$export$ae55be85d98224ed = $b4be07302e235326$var$fm;
$b4be07302e235326$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b4be07302e235326$var$am(b)) throw Error($b4be07302e235326$var$p(200));
    return $b4be07302e235326$var$Ql(a, b, null, c);
};
$b4be07302e235326$export$882461b6382ed46c = function(a, b) {
    if (!$b4be07302e235326$var$am(a)) throw Error($b4be07302e235326$var$p(299));
    var c = !1, d = "", e = $b4be07302e235326$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b4be07302e235326$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$b4be07302e235326$var$If] = b.current;
    $b4be07302e235326$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $b4be07302e235326$var$Zl(b);
};
$b4be07302e235326$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b4be07302e235326$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b4be07302e235326$var$p(268, a));
    }
    a = $b4be07302e235326$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b4be07302e235326$export$cd75ccfd720a3cd4 = function(a) {
    return $b4be07302e235326$var$El(a);
};
$b4be07302e235326$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b4be07302e235326$var$bm(b)) throw Error($b4be07302e235326$var$p(200));
    return $b4be07302e235326$var$em(null, a, b, !0, c);
};
$b4be07302e235326$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b4be07302e235326$var$am(a)) throw Error($b4be07302e235326$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b4be07302e235326$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b4be07302e235326$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b4be07302e235326$var$If] = b.current;
    $b4be07302e235326$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b4be07302e235326$var$$l(b);
};
$b4be07302e235326$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b4be07302e235326$var$bm(b)) throw Error($b4be07302e235326$var$p(200));
    return $b4be07302e235326$var$em(null, a, b, !1, c);
};
$b4be07302e235326$export$502457920280e6be = function(a) {
    if (!$b4be07302e235326$var$bm(a)) throw Error($b4be07302e235326$var$p(40));
    return a._reactRootContainer ? ($b4be07302e235326$var$El(function() {
        $b4be07302e235326$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b4be07302e235326$var$If] = null;
        });
    }), !0) : !1;
};
$b4be07302e235326$export$c78a37762a8d58e1 = $b4be07302e235326$var$Dl;
$b4be07302e235326$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b4be07302e235326$var$bm(c)) throw Error($b4be07302e235326$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b4be07302e235326$var$p(38));
    return $b4be07302e235326$var$em(a, b, c, !1, d);
};
$b4be07302e235326$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("iHSFb", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9VBt1"));

});



parcelRegister("nljJW", function(module, exports) {
$parcel$export(module.exports, "default", () => $0462af493cc98e35$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $0462af493cc98e35$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $0462af493cc98e35$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))),
    devtools: false,
    middlewares: new Set(),
    mutator: $0462af493cc98e35$var$defaultMutator
};
var $0462af493cc98e35$export$2e2bcd8739ae039 = $0462af493cc98e35$var$defaults;

});

parcelRegister("5BJjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $41538e490a8f9346$export$2e2bcd8739ae039);
const $41538e490a8f9346$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $41538e490a8f9346$export$2e2bcd8739ae039 = $41538e490a8f9346$var$supports;

});


parcelRegister("iouul", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $d6421e40567bf09b$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createActionsHook", () => $d6421e40567bf09b$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $d6421e40567bf09b$export$6e4e5611de132e85);

var $4fqPo = parcelRequire("4fqPo");

var $2eXBd = parcelRequire("2eXBd");

var $WZYzT = parcelRequire("WZYzT");

var $6VEbB = parcelRequire("6VEbB");
const $d6421e40567bf09b$var$EMPTY_SELECTOR = ()=>undefined;
const $d6421e40567bf09b$var$DEFAULT_SELECTOR = (state)=>state;
function $d6421e40567bf09b$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $4fqPo.useContext)((0, $WZYzT.Context));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $4fqPo.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $4fqPo.useMemo)(()=>selector ? (0, $6VEbB.getSelectorInstance)(selector, storeState, hasPropsArg) : selector === null ? $d6421e40567bf09b$var$EMPTY_SELECTOR : $d6421e40567bf09b$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $4fqPo.useState)({})[1];
        const getSnapshot = (0, $4fqPo.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $2eXBd.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $d6421e40567bf09b$export$7c643e1d6648e418(Store) {
    const useHook = $d6421e40567bf09b$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $d6421e40567bf09b$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $d6421e40567bf09b$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("2eXBd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("lv8ZW"));

});
parcelRegister("lv8ZW", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $fa737908b3fbf13e$export$306c0aa65ff9ec16, (v) => $fa737908b3fbf13e$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa737908b3fbf13e$export$306c0aa65ff9ec16;
"use strict";

var $4fqPo = parcelRequire("4fqPo");
function $fa737908b3fbf13e$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $fa737908b3fbf13e$var$objectIs = "function" === typeof Object.is ? Object.is : $fa737908b3fbf13e$var$is, $fa737908b3fbf13e$var$useState = $4fqPo.useState, $fa737908b3fbf13e$var$useEffect = $4fqPo.useEffect, $fa737908b3fbf13e$var$useLayoutEffect = $4fqPo.useLayoutEffect, $fa737908b3fbf13e$var$useDebugValue = $4fqPo.useDebugValue;
function $fa737908b3fbf13e$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $fa737908b3fbf13e$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $fa737908b3fbf13e$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $fa737908b3fbf13e$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $fa737908b3fbf13e$var$useEffect(function() {
        $fa737908b3fbf13e$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $fa737908b3fbf13e$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $fa737908b3fbf13e$var$useDebugValue(value);
    return value;
}
function $fa737908b3fbf13e$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$fa737908b3fbf13e$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $fa737908b3fbf13e$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $fa737908b3fbf13e$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $fa737908b3fbf13e$var$useSyncExternalStore$1 : $fa737908b3fbf13e$var$useSyncExternalStore$2;
$fa737908b3fbf13e$export$306c0aa65ff9ec16 = void 0 !== $4fqPo.useSyncExternalStore ? $4fqPo.useSyncExternalStore : $fa737908b3fbf13e$var$shim;

});


parcelRegister("WZYzT", function(module, exports) {
$parcel$export(module.exports, "Context", () => $0b157e0ca0b785e7$export$841858b892ce1f4c);

var $4fqPo = parcelRequire("4fqPo");

var $7luw1 = parcelRequire("7luw1");
const $0b157e0ca0b785e7$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext({
    globalRegistry: (0, $7luw1.defaultRegistry),
    retrieveStore: (Store)=>(0, $7luw1.defaultRegistry).getStore(Store)
}, ()=>0);

});
parcelRegister("7luw1", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $55922a4e8654b370$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $55922a4e8654b370$export$9d726ae4880b1060);

var $5BJjl = parcelRequire("5BJjl");

var $c2wAA = parcelRequire("c2wAA");

var $gHG5U = parcelRequire("gHG5U");
const $55922a4e8654b370$export$e4d628ba0054221b = '__global__';
class $55922a4e8654b370$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $55922a4e8654b370$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $5BJjl.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $gHG5U.default)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $c2wAA.bindActions)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $55922a4e8654b370$export$9d726ae4880b1060 = new $55922a4e8654b370$export$acb47f32da33501e();

});
parcelRegister("c2wAA", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $8c3ef379055db5fe$export$5ee1d46cd0883a22);

var $nljJW = parcelRequire("nljJW");
const $8c3ef379055db5fe$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $8c3ef379055db5fe$var$warnings = new WeakMap();
const $8c3ef379055db5fe$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $nljJW.default).devtools ? $8c3ef379055db5fe$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$8c3ef379055db5fe$var$warnings.has(actionFn)) $8c3ef379055db5fe$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $8c3ef379055db5fe$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $8c3ef379055db5fe$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};

});

parcelRegister("gHG5U", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2915088f7fc2030$export$2e2bcd8739ae039);

var $lT1aL = parcelRequire("lT1aL");

var $lS7qT = parcelRequire("lS7qT");

var $nljJW = parcelRequire("nljJW");

var $eUsEs = parcelRequire("eUsEs");
function $c2915088f7fc2030$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $eUsEs.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $lT1aL.default)(storeState, (0, $nljJW.default).middlewares);
    return storeState;
}
var $c2915088f7fc2030$export$2e2bcd8739ae039 = (0, $lS7qT.default)($c2915088f7fc2030$var$createStoreState);

});
parcelRegister("lT1aL", function(module, exports) {
$parcel$export(module.exports, "default", () => $feefa4e23946e1e7$export$2e2bcd8739ae039);

var $nljJW = parcelRequire("nljJW");

var $dSCRU = parcelRequire("dSCRU");
const $feefa4e23946e1e7$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $dSCRU.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $nljJW.default).mutator);
var $feefa4e23946e1e7$export$2e2bcd8739ae039 = $feefa4e23946e1e7$var$applyMiddleware;

});
parcelRegister("dSCRU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1ae7801af0112d9$export$2e2bcd8739ae039);

var $4qEq9 = parcelRequire("4qEq9");
const $a1ae7801af0112d9$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $4qEq9.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $a1ae7801af0112d9$export$2e2bcd8739ae039 = $a1ae7801af0112d9$var$updateMiddleware;

});
parcelRegister("4qEq9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3398f1d89a78cf5c$export$2e2bcd8739ae039);
// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $3398f1d89a78cf5c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $3398f1d89a78cf5c$var$CACHE = new WeakMap();
function $3398f1d89a78cf5c$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($3398f1d89a78cf5c$var$CACHE.has(objA)) keysA = $3398f1d89a78cf5c$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $3398f1d89a78cf5c$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($3398f1d89a78cf5c$var$CACHE.has(objB)) keysB = $3398f1d89a78cf5c$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $3398f1d89a78cf5c$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$3398f1d89a78cf5c$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}

});



parcelRegister("lS7qT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fec4681bbbd0d7ac$export$2e2bcd8739ae039);

var $nljJW = parcelRequire("nljJW");
const $fec4681bbbd0d7ac$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $fec4681bbbd0d7ac$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $nljJW.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $nljJW.default).devtools === 'function' ? (0, $nljJW.default).devtools(storeState) : {};
                        devTools = $fec4681bbbd0d7ac$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $fec4681bbbd0d7ac$export$2e2bcd8739ae039 = $fec4681bbbd0d7ac$var$withDevtools;

});

parcelRegister("eUsEs", function(module, exports) {
$parcel$export(module.exports, "default", () => $adac853fd0d5dc56$export$2e2bcd8739ae039);

var $nljJW = parcelRequire("nljJW");

var $3Rlvb = parcelRequire("3Rlvb");

var $5BJjl = parcelRequire("5BJjl");
const $adac853fd0d5dc56$var$QUEUE = [];
let $adac853fd0d5dc56$var$scheduled;
function $adac853fd0d5dc56$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $nljJW.default).batchUpdates || !(0, $5BJjl.default).scheduling()) return (0, $3Rlvb.batch)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$adac853fd0d5dc56$var$QUEUE.includes(fn)) $adac853fd0d5dc56$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($adac853fd0d5dc56$var$scheduled) return;
    $adac853fd0d5dc56$var$scheduled = (0, $3Rlvb.batch)(()=>{
        let queueFn;
        while(queueFn = $adac853fd0d5dc56$var$QUEUE.shift())queueFn();
        $adac853fd0d5dc56$var$scheduled = null;
    });
}

});




parcelRegister("6VEbB", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $50b73d14d8269ad0$export$595d22ed68ca2841);
$parcel$export(module.exports, "getSelectorInstance", () => $50b73d14d8269ad0$export$38d24f3c60944dd5);

var $kvCju = parcelRequire("kvCju");
function $50b73d14d8269ad0$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $kvCju.default)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $kvCju.default)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $50b73d14d8269ad0$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $50b73d14d8269ad0$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $50b73d14d8269ad0$var$cache = new WeakMap();
function $50b73d14d8269ad0$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$50b73d14d8269ad0$var$cache.has(storeState)) $50b73d14d8269ad0$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $50b73d14d8269ad0$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $50b73d14d8269ad0$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $50b73d14d8269ad0$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("kvCju", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee46c200c2302f5$export$2e2bcd8739ae039);

var $4qEq9 = parcelRequire("4qEq9");
function $eee46c200c2302f5$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $eee46c200c2302f5$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $4qEq9.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$eee46c200c2302f5$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $eee46c200c2302f5$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $eee46c200c2302f5$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $4qEq9.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}

});



parcelRegister("4CywU", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $35d57ee94e76ba1e$export$26ae5ca175b4ec5a);

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $WZYzT = parcelRequire("WZYzT");

var $c2wAA = parcelRequire("c2wAA");
var $7luw1 = parcelRequire("7luw1");

var $4qEq9 = parcelRequire("4qEq9");
const $35d57ee94e76ba1e$var$_excluded = [
    "children"
], $35d57ee94e76ba1e$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $35d57ee94e76ba1e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $35d57ee94e76ba1e$var$noop = ()=>()=>{};
function $35d57ee94e76ba1e$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $35d57ee94e76ba1e$var$noop, onUpdate: onUpdate = $35d57ee94e76ba1e$var$noop, onCleanup: onCleanup = $35d57ee94e76ba1e$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $35d57ee94e76ba1e$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $35d57ee94e76ba1e$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $35d57ee94e76ba1e$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $35d57ee94e76ba1e$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $35d57ee94e76ba1e$var$createFunctionContainer(StoreOrOptions);
}
function $35d57ee94e76ba1e$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $4fqPo.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $7luw1.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $35d57ee94e76ba1e$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $4fqPo.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $4fqPo.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $c2wAA.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $c2wAA.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $35d57ee94e76ba1e$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $4fqPo.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $4fqPo.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $35d57ee94e76ba1e$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $35d57ee94e76ba1e$var$_objectWithoutPropertiesLoose(props, $35d57ee94e76ba1e$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $35d57ee94e76ba1e$var$_objectWithoutPropertiesLoose(restProps, $35d57ee94e76ba1e$var$_excluded2);
        const ctx = (0, $4fqPo.useContext)((0, $WZYzT.Context));
        const registry = $35d57ee94e76ba1e$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $4fqPo.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $35d57ee94e76ba1e$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $35d57ee94e76ba1e$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $4qEq9.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $4fqPo.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $4fqPo.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WZYzT.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).bool
    };
    return FunctionContainer;
}

});

parcelRegister("2RDzF", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $215f3a9e48264d46$export$f51a9068ac82ea43);

var $3ejXM = parcelRequire("3ejXM");
function $215f3a9e48264d46$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $3ejXM.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $215f3a9e48264d46$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $215f3a9e48264d46$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}

});
parcelRegister("3ejXM", function(module, exports) {
$parcel$export(module.exports, "default", () => $25a22a3233d70ab9$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $25a22a3233d70ab9$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});


parcelRegister("g9ysg", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $bc28369c24972fa2$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $bc28369c24972fa2$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $bc28369c24972fa2$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $bc28369c24972fa2$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $bc28369c24972fa2$export$c9237620ff7fdf7c);

var $2Q7mc = parcelRequire("2Q7mc");
parcelRequire("gkkih");
var $e6Cwx = parcelRequire("e6Cwx");
const $bc28369c24972fa2$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $bc28369c24972fa2$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $bc28369c24972fa2$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $bc28369c24972fa2$var$stripTrailingSlash(prefix);
        prefix = $bc28369c24972fa2$var$addLeadingSlash(prefix);
        path = $bc28369c24972fa2$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $bc28369c24972fa2$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $bc28369c24972fa2$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$bc28369c24972fa2$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($2Q7mc)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($2Q7mc)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $bc28369c24972fa2$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$bc28369c24972fa2$export$e83e3719fc818ee5(path)) {
        path = $bc28369c24972fa2$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($2Q7mc)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $bc28369c24972fa2$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $2Q7mc.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $bc28369c24972fa2$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $bc28369c24972fa2$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $e6Cwx.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("8NB5B", function(module, exports) {
$parcel$export(module.exports, "Router", () => $667fab81beea77d0$export$55185c17a0fcbe46);

var $ichJ5 = parcelRequire("ichJ5");

var $g2zI4 = parcelRequire("g2zI4");

var $4fqPo = parcelRequire("4fqPo");

var $3CTUc = parcelRequire("3CTUc");
const $667fab81beea77d0$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3CTUc.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $667fab81beea77d0$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $4fqPo.useMemo)(()=>(0, $g2zI4.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($667fab81beea77d0$export$55185c17a0fcbe46, (0, $ichJ5.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("kywst", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $1wDzz = parcelRequire("1wDzz");
const $ef702929d1ee4e39$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $1wDzz.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(actions));
};
$ef702929d1ee4e39$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("1wDzz", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $11c779e9e3e6ffae$export$402e82ff1b20594b);

var $3CTUc = parcelRequire("3CTUc");
const $11c779e9e3e6ffae$export$402e82ff1b20594b = (0, $3CTUc.useRouterStoreActions);

});


parcelRegister("dCuc5", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => $9ea63edb4d067c7f$export$672d721d310ff5f0);

var $gMtYT = parcelRequire("gMtYT");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("gkkih");
var $9L4D5 = parcelRequire("9L4D5");

var $3CTUc = parcelRequire("3CTUc");
const $9ea63edb4d067c7f$var$_excluded = [
    "listen"
];
const $9ea63edb4d067c7f$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $3CTUc.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $gMtYT.default)(_ref, $9ea63edb4d067c7f$var$_excluded);
    if (!state.unlisten && !(0, $9L4D5.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(state, actions));
};

});
parcelRegister("gMtYT", function(module, exports) {
$parcel$export(module.exports, "default", () => $c37862ab9e9b4c99$export$2e2bcd8739ae039);
function $c37862ab9e9b4c99$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("eDygx", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $aa7f49aa64681451$export$8c8591dcd57728e6);

var $4fqPo = parcelRequire("4fqPo");

var $iouul = parcelRequire("iouul");

var $3CTUc = parcelRequire("3CTUc");
const $aa7f49aa64681451$var$createPathParamHook = (0, $iouul.createHook)((0, $3CTUc.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $aa7f49aa64681451$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $aa7f49aa64681451$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $4fqPo.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("4g7Uv", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $319ecade94d01967$export$ae316f0eeb712a36);

var $4fqPo = parcelRequire("4fqPo");

var $iouul = parcelRequire("iouul");

var $3CTUc = parcelRequire("3CTUc");
const $319ecade94d01967$var$createQueryParamHook = (0, $iouul.createHook)((0, $3CTUc.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $319ecade94d01967$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $319ecade94d01967$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $4fqPo.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("lM7Z9", function(module, exports) {
$parcel$export(module.exports, "withRouter", () => $fda4466872c08949$export$369b6b2b30582e8e);

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");

var $3CTUc = parcelRequire("3CTUc");
const $fda4466872c08949$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $fda4466872c08949$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $fda4466872c08949$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $3CTUc.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, (0, $ichJ5.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("i9DZX", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("bdubZ")).default);
$parcel$export(module.exports, "RouteComponent", () => (parcelRequire("7H5nz")).RouteComponent);

var $bdubZ = parcelRequire("bdubZ");

var $7H5nz = parcelRequire("7H5nz");

});
parcelRegister("bdubZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $82a8542b5884fdfa$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");

var $g2zI4 = parcelRequire("g2zI4");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("gkkih");
var $4HiQA = parcelRequire("4HiQA");
var $1pcyW = parcelRequire("1pcyW");

var $3CTUc = parcelRequire("3CTUc");

var $gpjvj = parcelRequire("gpjvj");
parcelRequire("hKswe");
var $dkjtu = parcelRequire("dkjtu");
var $8m7G3 = parcelRequire("8m7G3");
const $82a8542b5884fdfa$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $82a8542b5884fdfa$var$PREFETCH_DELAY = 225;
const $82a8542b5884fdfa$var$Link = /*#__PURE__*/ (0, $4fqPo.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $gMtYT.default)(_ref, $82a8542b5884fdfa$var$_excluded);
    const routerActions = (0, $3CTUc.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $gpjvj.useTimeout)($82a8542b5884fdfa$var$PREFETCH_DELAY);
    const validLinkType = (0, $dkjtu.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $4fqPo.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $g2zI4.createPath)((0, $1pcyW.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $4fqPo.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $4HiQA.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $8m7G3.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $4fqPo.createElement)(validLinkType, (0, $ichJ5.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$82a8542b5884fdfa$var$Link.displayName = 'Link';
var $82a8542b5884fdfa$export$2e2bcd8739ae039 = $82a8542b5884fdfa$var$Link;

});
parcelRegister("gpjvj", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $bf1e1c405584ebdd$export$d8e6abf214c9ec0f);

var $4fqPo = parcelRequire("4fqPo");
const $bf1e1c405584ebdd$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $4fqPo.useRef)();
    const schedule = (0, $4fqPo.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $4fqPo.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("hKswe", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("dkjtu")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("8m7G3")).handleNavigation);

var $dkjtu = parcelRequire("dkjtu");

var $8m7G3 = parcelRequire("8m7G3");

});
parcelRegister("dkjtu", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $9b3c3fe0d6201dcd$export$855ece989b15eb57);
const $9b3c3fe0d6201dcd$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $9b3c3fe0d6201dcd$export$855ece989b15eb57 = (type)=>$9b3c3fe0d6201dcd$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("8m7G3", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $61565555caa90ace$export$706ad1af8096e280);

var $87zGX = parcelRequire("87zGX");
const $61565555caa90ace$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $87zGX.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $87zGX.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $87zGX.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("87zGX", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $5e9aa9dc244188a5$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $5e9aa9dc244188a5$export$130b789831072f4c);
const $5e9aa9dc244188a5$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $5e9aa9dc244188a5$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("7H5nz", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $59a0b8c1cadb4b7e$export$7903e4b73fc7d6c3);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("kcMae");
var $hfD9S = parcelRequire("hfD9S");
const $59a0b8c1cadb4b7e$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $hfD9S.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("bwvJd", function(module, exports) {
parcelRequire("gkkih");
var $4HiQA = parcelRequire("4HiQA");
const $863b4b6d580fea1f$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $4HiQA.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("8yaBI", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => (parcelRequire("dwE13")).createResourcesPlugin);
$parcel$export(module.exports, "useResource", () => (parcelRequire("cpzpY")).useResource);
$parcel$export(module.exports, "createResource", () => (parcelRequire("f03OU")).createResource);

var $dwE13 = parcelRequire("dwE13");

var $aVLY6 = parcelRequire("aVLY6");

var $cpzpY = parcelRequire("cpzpY");

var $iaBMK = parcelRequire("iaBMK");
parcelRequire("lY9go");
var $f03OU = parcelRequire("f03OU");

var $dwE13 = parcelRequire("dwE13");

var $knIpy = parcelRequire("knIpy");

});
parcelRegister("dwE13", function(module, exports) {
$parcel$export(module.exports, "createResourcesPlugin", () => $9d8d4de1256ad88a$export$23ed892c481a96fe);

var $lY9go = parcelRequire("lY9go");
parcelRequire("kxBiE");
var $7mU6M = parcelRequire("7mU6M");
const $9d8d4de1256ad88a$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $9d8d4de1256ad88a$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $lY9go.getResourceStore)().actions;
    const nextResources = (0, $7mU6M.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $9d8d4de1256ad88a$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $lY9go.getResourceStore)().actions;
    const nextResources = (0, $7mU6M.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $9d8d4de1256ad88a$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $lY9go.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $9d8d4de1256ad88a$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $9d8d4de1256ad88a$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $9d8d4de1256ad88a$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $lY9go.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $lY9go.getResourceStore)().actions;
            const nextResources = (0, $7mU6M.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $lY9go.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("lY9go", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $ffe663190cf4d61c$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $ffe663190cf4d61c$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $ffe663190cf4d61c$export$98e41a62c9bef75e);
$parcel$export(module.exports, "createResource", () => (parcelRequire("f03OU")).createResource);

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");

var $iouul = parcelRequire("iouul");
var $4CywU = parcelRequire("4CywU");
var $2RDzF = parcelRequire("2RDzF");
var $3y3sY = parcelRequire("3y3sY");
var $7luw1 = parcelRequire("7luw1");
parcelRequire("gkkih");
var $9L4D5 = parcelRequire("9L4D5");

var $5wDBT = parcelRequire("5wDBT");
parcelRequire("kxBiE");
var $8Z16o = parcelRequire("8Z16o");
var $4NGEb = parcelRequire("4NGEb");
var $f03OU = parcelRequire("f03OU");
var $aksSm = parcelRequire("aksSm");
var $jdrRk = parcelRequire("jdrRk");
var $a8B7U = parcelRequire("a8B7U");
var $4cEkD = parcelRequire("4cEkD");
var $1u032 = parcelRequire("1u032");
var $bS6ZJ = parcelRequire("bS6ZJ");
var $1SGf6 = parcelRequire("1SGf6");
var $80Lct = parcelRequire("80Lct");
var $kVD2G = parcelRequire("kVD2G");
var $jezMn = parcelRequire("jezMn");
const $ffe663190cf4d61c$var$_excluded = [
    "context"
], $ffe663190cf4d61c$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $ffe663190cf4d61c$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $aksSm.deleteResourceState)(type, key));
                dispatch((0, $8Z16o.executeForDependents)(resource, (dependentResource)=>$ffe663190cf4d61c$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $aksSm.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $gMtYT.default)(_getState, $ffe663190cf4d61c$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $5wDBT.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $ichJ5.default)({}, prevSlice, changes, {
                expiresAt: (0, $1u032.getExpiresAt)(maxAge),
                accessedAt: (0, $a8B7U.getAccessedAt)()
            });
            dispatch((0, $aksSm.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $8Z16o.executeForDependents)(resource, (dependentResource)=>$ffe663190cf4d61c$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $aksSm.getResourceState)(type, key));
            if (cached && (0, $bS6ZJ.shouldUseCache)(cached)) {
                if ((0, $bS6ZJ.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $1SGf6.setSsrDataPromise)(cached);
                    cached = (0, $1u032.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $a8B7U.getAccessedAt)();
                dispatch((0, $aksSm.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($ffe663190cf4d61c$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $aksSm.getResourceState)(type, key)) || (0, $4cEkD.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $jezMn.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $aksSm.getPrefetchSlice)(type, key)) || (0, $4NGEb.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8Z16o.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $aksSm.setResourceState)(type, key, (0, $ichJ5.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $a8B7U.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $8Z16o.executeForDependents)(resource, (dependentResource)=>$ffe663190cf4d61c$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $80Lct.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $aksSm.getResourceState)(type, key));
            const finalSlice = (0, $ichJ5.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $a8B7U.getAccessedAt)(),
                expiresAt: (0, $1u032.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $aksSm.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $aksSm.getPrefetchSlice)(type, key)) || (0, $4NGEb.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8Z16o.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $aksSm.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $8Z16o.executeForDependents)(resource, (dependentResource)=>$ffe663190cf4d61c$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $ffe663190cf4d61c$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $8Z16o.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $ffe663190cf4d61c$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $8Z16o.actionWithDependencies)(routerStoreContext.route.resources, resource, $ffe663190cf4d61c$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $8Z16o.actionWithDependencies)(routerStoreContext.route.resources, resource, $ffe663190cf4d61c$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $8Z16o.actionWithDependencies)(routerStoreContext.route.resources, resource, $ffe663190cf4d61c$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($ffe663190cf4d61c$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $aksSm.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $aksSm.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $9L4D5.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $8Z16o.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$ffe663190cf4d61c$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $8Z16o.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$ffe663190cf4d61c$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $ichJ5.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $kVD2G.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $gMtYT.default)(_ref, $ffe663190cf4d61c$var$_excluded2);
                const deserializedError = !error ? null : (0, $jdrRk.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $ichJ5.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $kVD2G.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $jdrRk.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $80Lct.TimeoutError) ? loading : false
                }))
};
const $ffe663190cf4d61c$export$94f50dade551bd01 = (0, $2RDzF.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $ffe663190cf4d61c$export$e324594224ef24da,
    name: 'router-resources'
});
const $ffe663190cf4d61c$export$cc90fb9c37c5589d = (0, $4CywU.createContainer)($ffe663190cf4d61c$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $ffe663190cf4d61c$export$fee1a6213543bd78 = (0, $3y3sY.createSubscriber)($ffe663190cf4d61c$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $5wDBT.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $ffe663190cf4d61c$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $7luw1.defaultRegistry).getStore($ffe663190cf4d61c$export$94f50dade551bd01);
const $ffe663190cf4d61c$export$ac3608e0bb357c7 = (0, $iouul.createHook)($ffe663190cf4d61c$export$94f50dade551bd01, {
    selector: (0, $5wDBT.getSliceForResource)
});
const $ffe663190cf4d61c$export$98e41a62c9bef75e = (0, $iouul.createActionsHook)($ffe663190cf4d61c$export$94f50dade551bd01);
const $ffe663190cf4d61c$export$e59f52df235ac7b3 = (0, $iouul.createHook)($ffe663190cf4d61c$export$94f50dade551bd01, {
    selector: (0, $5wDBT.getResourceStoreContext)
});

});
parcelRegister("3y3sY", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $29573c66ad80dfea$export$48f338a7e080595c);

var $iouul = parcelRequire("iouul");
const $29573c66ad80dfea$var$_excluded = [
    "children"
];
function $29573c66ad80dfea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $29573c66ad80dfea$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $29573c66ad80dfea$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $iouul.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $29573c66ad80dfea$var$_objectWithoutPropertiesLoose(_ref, $29573c66ad80dfea$var$_excluded);
        const api = useStore($29573c66ad80dfea$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("5wDBT", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $405eaaa6060ddd97$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $405eaaa6060ddd97$export$6a0b1779210de0ee);

var $ichJ5 = parcelRequire("ichJ5");
parcelRequire("kxBiE");
var $4cEkD = parcelRequire("4cEkD");
const $405eaaa6060ddd97$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $ichJ5.default)({}, slice) : (0, $4cEkD.getDefaultStateSlice)();
};
const $405eaaa6060ddd97$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("kxBiE", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("a8B7U")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("4NGEb")).createLoadingSlice);
$parcel$export(module.exports, "createResource", () => (parcelRequire("f03OU")).createResource);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("8Z16o")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("8Z16o")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("8Z16o")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("8Z16o")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("1u032")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("1u032")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("4cEkD")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("7mU6M")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("jezMn")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("aksSm")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("aksSm")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("aksSm")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("aksSm")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("aksSm")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("jdrRk")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("jdrRk")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("bS6ZJ")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("bS6ZJ")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("1SGf6")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("80Lct")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("kVD2G")).transformData);

var $a8B7U = parcelRequire("a8B7U");

var $4NGEb = parcelRequire("4NGEb");

var $f03OU = parcelRequire("f03OU");

var $8Z16o = parcelRequire("8Z16o");

var $1u032 = parcelRequire("1u032");

var $esHVb = parcelRequire("esHVb");

var $4cEkD = parcelRequire("4cEkD");

var $kNnXn = parcelRequire("kNnXn");

var $7mU6M = parcelRequire("7mU6M");

var $jezMn = parcelRequire("jezMn");

var $aksSm = parcelRequire("aksSm");

var $g5ePw = parcelRequire("g5ePw");

var $jdrRk = parcelRequire("jdrRk");

var $bS6ZJ = parcelRequire("bS6ZJ");

var $1SGf6 = parcelRequire("1SGf6");

var $80Lct = parcelRequire("80Lct");

var $kVD2G = parcelRequire("kVD2G");

});
parcelRegister("a8B7U", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $76177347ee39b1d3$export$9ccb639b7a119f61);
const $76177347ee39b1d3$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("4NGEb", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $37ecd1dbfbc0e70b$export$dc62515c8f0b52dd);

var $ichJ5 = parcelRequire("ichJ5");

var $iQ554 = parcelRequire("iQ554");

var $1u032 = parcelRequire("1u032");

var $esHVb = parcelRequire("esHVb");

var $80Lct = parcelRequire("80Lct");

var $b6eUG = parcelRequire("b6eUG");
function $37ecd1dbfbc0e70b$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $ichJ5.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $esHVb.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $80Lct.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $1u032.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $iQ554.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $1u032.getExpiresAt)((0, $b6eUG.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("iQ554", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $db710648572c809c$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $db710648572c809c$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $db710648572c809c$export$12c1dc38ea1692da);
const $db710648572c809c$export$881d135f98d8d7d0 = 100;
const $db710648572c809c$export$9ab5bdcb8a1d6c34 = false;
const $db710648572c809c$export$12c1dc38ea1692da = 0;

});

parcelRegister("1u032", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $1148a153510a08e4$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $1148a153510a08e4$export$18d1d420fd588368);

var $ichJ5 = parcelRequire("ichJ5");
const $1148a153510a08e4$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $1148a153510a08e4$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $ichJ5.default)({}, slice, {
        expiresAt: $1148a153510a08e4$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("esHVb", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $a875c011a371f9f0$export$58634b3a58ae66b7);
const $a875c011a371f9f0$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("80Lct", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $5d52efcbc66e0931$export$66d311bf29d5c89c);
class $5d52efcbc66e0931$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("b6eUG", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $814bd2b76611f75a$export$37d3126be6549b13);
const $814bd2b76611f75a$export$37d3126be6549b13 = 10000;

});


parcelRegister("f03OU", function(module, exports) {
$parcel$export(module.exports, "createResource", () => $aeb9d1ac6e72e8be$export$edd172c6c83c39cc);

var $iQ554 = parcelRequire("iQ554");
/**
 * Utility method to created async versions of getData functions
 */ const $aeb9d1ac6e72e8be$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $aeb9d1ac6e72e8be$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $aeb9d1ac6e72e8be$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $iQ554.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $iQ554.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $iQ554.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("8Z16o", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $68a4e01da82df809$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $68a4e01da82df809$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $68a4e01da82df809$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $68a4e01da82df809$export$75915f81f2a6540a);

var $ichJ5 = parcelRequire("ichJ5");

var $4cEkD = parcelRequire("4cEkD");

var $aksSm = parcelRequire("aksSm");
var $68a4e01da82df809$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $68a4e01da82df809$var$fromEntries = ($68a4e01da82df809$var$_Object$fromEntries = Object.fromEntries) != null ? $68a4e01da82df809$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $68a4e01da82df809$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $68a4e01da82df809$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $68a4e01da82df809$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($68a4e01da82df809$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($68a4e01da82df809$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($68a4e01da82df809$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $68a4e01da82df809$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($68a4e01da82df809$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $68a4e01da82df809$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$68a4e01da82df809$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $68a4e01da82df809$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($68a4e01da82df809$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $68a4e01da82df809$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($68a4e01da82df809$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $68a4e01da82df809$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($68a4e01da82df809$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $68a4e01da82df809$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $68a4e01da82df809$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $68a4e01da82df809$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $aksSm.getResourceState)(dependencyType, key)) || (0, $4cEkD.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $aksSm.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $ichJ5.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("4cEkD", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $30f79172bd539947$export$fa8e33c3301e2e94);

var $ichJ5 = parcelRequire("ichJ5");

var $a8B7U = parcelRequire("a8B7U");

var $iQ554 = parcelRequire("iQ554");

var $1u032 = parcelRequire("1u032");

var $3FpXb = parcelRequire("3FpXb");
const $30f79172bd539947$export$fa8e33c3301e2e94 = ()=>(0, $ichJ5.default)({}, (0, $3FpXb.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $1u032.getExpiresAt)((0, $iQ554.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $a8B7U.getAccessedAt)()
    });

});
parcelRegister("3FpXb", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $2ab95541d97b4a22$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $2ab95541d97b4a22$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("aksSm", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $78522bc26c1db77f$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $78522bc26c1db77f$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $78522bc26c1db77f$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $78522bc26c1db77f$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $78522bc26c1db77f$export$d40f35dc5952864b);

var $gMtYT = parcelRequire("gMtYT");

var $ichJ5 = parcelRequire("ichJ5");
function $78522bc26c1db77f$var$_toPropertyKey(t) {
    var i = $78522bc26c1db77f$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $78522bc26c1db77f$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $78522bc26c1db77f$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $78522bc26c1db77f$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $ichJ5.default)({}, prefetching, {
                [type]: (0, $ichJ5.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $78522bc26c1db77f$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($78522bc26c1db77f$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $ichJ5.default)({}, data, {
                [type]: (0, $ichJ5.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $78522bc26c1db77f$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $78522bc26c1db77f$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $gMtYT.default)(data, [
            type
        ].map($78522bc26c1db77f$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $gMtYT.default)(resourceForType, [
                key
            ].map($78522bc26c1db77f$var$_toPropertyKey));
            setState({
                data: (0, $ichJ5.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("kNnXn", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $f23af78cc94b5a08$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $f23af78cc94b5a08$export$cd7fbe7e979df558);
const $f23af78cc94b5a08$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $f23af78cc94b5a08$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$f23af78cc94b5a08$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("7mU6M", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $55d61c6c2cf9cff8$export$7cbbc763e2f3d65d);

var $kNnXn = parcelRequire("kNnXn");

var $g5ePw = parcelRequire("g5ePw");
const $55d61c6c2cf9cff8$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $g5ePw.routeHasResources)(nextRoute)) return [];
    if ((0, $g5ePw.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $kNnXn.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $kNnXn.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("g5ePw", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $bb589de4f5435e10$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $bb589de4f5435e10$export$221027ff1aa38f82);
const $bb589de4f5435e10$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $bb589de4f5435e10$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("jezMn", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $e00b141f589a7709$export$89440b7623c2c75c);

var $aksSm = parcelRequire("aksSm");
const $e00b141f589a7709$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $e00b141f589a7709$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $e00b141f589a7709$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $e00b141f589a7709$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $e00b141f589a7709$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $aksSm.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("jdrRk", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $dfd4d77bbce21964$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $dfd4d77bbce21964$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $dfd4d77bbce21964$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $dfd4d77bbce21964$var$NonError);
    }
}
const $dfd4d77bbce21964$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $dfd4d77bbce21964$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $dfd4d77bbce21964$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $dfd4d77bbce21964$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $dfd4d77bbce21964$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $dfd4d77bbce21964$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $dfd4d77bbce21964$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $dfd4d77bbce21964$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $dfd4d77bbce21964$var$NonError(value);
};

});

parcelRegister("bS6ZJ", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $8a4a29dd64cabe69$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $8a4a29dd64cabe69$export$399de8c43d0ece3c);
const $8a4a29dd64cabe69$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $8a4a29dd64cabe69$var$isFresh = (resource)=>{
    if ($8a4a29dd64cabe69$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $8a4a29dd64cabe69$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($8a4a29dd64cabe69$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("1SGf6", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $15eb9a1c0cb20d5e$export$2e4da1b414980956);

var $ichJ5 = parcelRequire("ichJ5");
const $15eb9a1c0cb20d5e$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $ichJ5.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("kVD2G", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $f3c76a854cf72305$export$3ceb62baab058c6b);
const $f3c76a854cf72305$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("aVLY6", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $cpzpY = parcelRequire("cpzpY");
const $7f546fc986c244f2$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $cpzpY.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(result));
};

});
parcelRegister("cpzpY", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $90934b1dfe58bc75$export$9f6abfd74295843b);

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");

var $iouul = parcelRequire("iouul");
parcelRequire("l8iRu");
var $3CTUc = parcelRequire("3CTUc");

var $lY9go = parcelRequire("lY9go");
const $90934b1dfe58bc75$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $lY9go.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $3CTUc.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $4fqPo.useMemo)(()=>(0, $iouul.createHook)((0, $3CTUc.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $lY9go.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $4fqPo.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $4fqPo.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $4fqPo.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $4fqPo.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $4fqPo.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $ichJ5.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("iaBMK", function(module, exports) {

var $lY9go = parcelRequire("lY9go");
const $d3a6788ad38c9298$export$dee7bf9fc0ff48c3 = (fn)=>(0, $lY9go.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("knIpy", function(module, exports) {
const $ed6867bd2b85cb5d$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("bRLBS", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $1cb2631d7988fa78$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "getEventQueue", () => $1cb2631d7988fa78$export$584d8b0a0989eefd);
/**
 * Wrapper around AJS
 */ 
var $63sfu = parcelRequire("63sfu");

var $6mmHn = parcelRequire("6mmHn");
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $1cb2631d7988fa78$var$ajs = window.AJS;
const $1cb2631d7988fa78$export$c47913ca32a5c6f7 = (key)=>{
    if ($1cb2631d7988fa78$var$ajs && $1cb2631d7988fa78$var$ajs.Meta) return $1cb2631d7988fa78$var$ajs.Meta.get(key);
    /** When jsd-dw-portal-wrm-optimisations is on we fallback to a native version of getMeta that doesn't rely on AJS being loaded on the page via WRM */ const value = (0, $6mmHn.getMetaFromHTML)(key);
    return (0, $63sfu.isNil)(value) ? undefined : value;
};
const $1cb2631d7988fa78$export$584d8b0a0989eefd = ()=>{
    return $1cb2631d7988fa78$var$ajs === undefined ? undefined : $1cb2631d7988fa78$var$ajs.EventQueue;
};

});



parcelRegister("29xKq", function(module, exports) {
$parcel$export(module.exports, "devLog", () => $169e6e47a44ca897$export$c45ebb6cef9d5b7b);

var $ebpTf = parcelRequire("ebpTf");
function $169e6e47a44ca897$export$c45ebb6cef9d5b7b(message, ...optionalParams) {
    const env = (0, $ebpTf.getEnv)();
    // eslint-disable-next-line no-console
    env.environment !== (0, $ebpTf.EnvType).PROD && console.log(message, ...optionalParams);
}

});

parcelRegister("dlnz8", function(module, exports) {
$parcel$export(module.exports, "getApplicationType", () => $2aaed14c00f9a1c2$export$4f7ec84576d049fa);

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");
const $2aaed14c00f9a1c2$export$4f7ec84576d049fa = ()=>{
    return {
        applicationType: (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) ? 'jcs' : 'jsm'
    };
};

});

parcelRegister("aP0jL", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterAnalyticsData", () => $85011cde12fda5af$export$bd448d1bc798d83d);

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");
const $85011cde12fda5af$export$bd448d1bc798d83d = ()=>{
    if ((0, $eSL4S.isHelpCentersManagement)()) return undefined;
    return {
        helpCenterType: (0, $eSL4S.isAdvancedHelpCenter)() ? 'custom' : 'default',
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
        ...(0, $bG6ob.isSendRawHelpCenterTypeInAnalyticsEnabled)() ? {
            helpCenterCategory: (0, $ebpTf.getEnv)().helpCenterType
        } : {}
    };
};

});


parcelRegister("91yYl", function(module, exports) {
$parcel$export(module.exports, "sentryQueue", () => $a9e2c588ccc5db39$export$4bff35a64b482759);

var $fVwZr = parcelRequire("fVwZr");
const $a9e2c588ccc5db39$export$4bff35a64b482759 = {
    pushError (err) {
        if ((0, $fVwZr.isSentryEnabled)()) {
            if (!window.JSM_EXCEPTION_QUEUE) window.JSM_EXCEPTION_QUEUE = [
                err
            ];
            else window.JSM_EXCEPTION_QUEUE.push(err);
        }
    },
    flushErrors () {
        var _window$JSM_EXCEPTION;
        (_window$JSM_EXCEPTION = window.JSM_EXCEPTION_QUEUE) === null || _window$JSM_EXCEPTION === void 0 || _window$JSM_EXCEPTION.forEach((err)=>(0, $fVwZr.reportError)(err));
        delete window.JSM_EXCEPTION_QUEUE;
    }
};

});
parcelRegister("fVwZr", function(module, exports) {
$parcel$export(module.exports, "isSentryEnabled", () => $a30ef9753c8842b1$export$ec3dcf0ab235344b);
$parcel$export(module.exports, "reportError", () => $a30ef9753c8842b1$export$b33b857ad1d9900e);

var $ePuex = parcelRequire("ePuex");

var $2poHG = parcelRequire("2poHG");

var $63sfu = parcelRequire("63sfu");

var $ebpTf = parcelRequire("ebpTf");
const $a30ef9753c8842b1$export$ec3dcf0ab235344b = ()=>{
    const env = (0, $ebpTf.getEnv)();
    if (env.environment === (0, $ebpTf.EnvType).STAGING) return true;
    return env.environment === (0, $ebpTf.EnvType).PROD;
};
const $a30ef9753c8842b1$export$b33b857ad1d9900e = (exception, additionalErrorData)=>{
    // eslint-disable-next-line no-console
    console.error('reportError', exception, additionalErrorData);
    if ($a30ef9753c8842b1$export$ec3dcf0ab235344b()) {
        if (additionalErrorData && (0, $63sfu.isNil)(additionalErrorData.message) && exception instanceof Error) $ePuex.withScope((scope)=>{
            const { teamName: teamName, errorBoundaryId: errorBoundaryId, errorBoundaryPackageName: packageName } = additionalErrorData;
            if (errorBoundaryId) scope.setTag('errorBoundaryId', errorBoundaryId);
            if (packageName) scope.setTag('packageName', packageName);
            if (teamName) scope.setTag('teamName', teamName);
            const event = (0, $2poHG.eventFromUnknownInput)(exception);
            $ePuex.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        });
        else {
            const event = (0, $2poHG.eventFromUnknownInput)(exception);
            $ePuex.captureEvent({
                ...event,
                message: (additionalErrorData === null || additionalErrorData === void 0 ? void 0 : additionalErrorData.message) || event.message
            });
        }
    }
};

});
parcelRegister("ePuex", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $acbd47de8eb43519$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $acbd47de8eb43519$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $acbd47de8eb43519$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $acbd47de8eb43519$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $acbd47de8eb43519$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $acbd47de8eb43519$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $acbd47de8eb43519$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $acbd47de8eb43519$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $acbd47de8eb43519$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $acbd47de8eb43519$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $acbd47de8eb43519$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $acbd47de8eb43519$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $acbd47de8eb43519$export$e262da7ae6480481);

var $d8KcD = parcelRequire("d8KcD");

var $KhyL6 = parcelRequire("KhyL6");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $acbd47de8eb43519$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $KhyL6.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $d8KcD.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $acbd47de8eb43519$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $acbd47de8eb43519$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $acbd47de8eb43519$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $acbd47de8eb43519$var$callOnHub('captureMessage', message, level, (0, $d8KcD.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $acbd47de8eb43519$export$1462b974fdcf6ba2(event) {
    return $acbd47de8eb43519$var$callOnHub('captureEvent', event);
}
function $acbd47de8eb43519$export$99d44f04437e9cb8(callback) {
    $acbd47de8eb43519$var$callOnHub('configureScope', callback);
}
function $acbd47de8eb43519$export$efda9a273d7a036d(breadcrumb) {
    $acbd47de8eb43519$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $acbd47de8eb43519$export$2f04de43fe27971a(name, context) {
    $acbd47de8eb43519$var$callOnHub('setContext', name, context);
}
function $acbd47de8eb43519$export$bb4922da0dd51b92(extras) {
    $acbd47de8eb43519$var$callOnHub('setExtras', extras);
}
function $acbd47de8eb43519$export$74a8fb34822092e6(tags) {
    $acbd47de8eb43519$var$callOnHub('setTags', tags);
}
function $acbd47de8eb43519$export$8e8e7789d42ed61d(key, extra) {
    $acbd47de8eb43519$var$callOnHub('setExtra', key, extra);
}
function $acbd47de8eb43519$export$a37d07ee78eb4569(key, value) {
    $acbd47de8eb43519$var$callOnHub('setTag', key, value);
}
function $acbd47de8eb43519$export$8b6bb3dd62a01be2(user) {
    $acbd47de8eb43519$var$callOnHub('setUser', user);
}
function $acbd47de8eb43519$export$ec58d9285c204497(callback) {
    $acbd47de8eb43519$var$callOnHub('withScope', callback);
}
function $acbd47de8eb43519$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $acbd47de8eb43519$var$callOnHub.apply(void 0, (0, $d8KcD.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $acbd47de8eb43519$export$e262da7ae6480481(context, customSamplingContext) {
    return $acbd47de8eb43519$var$callOnHub('startTransaction', (0, $d8KcD.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("d8KcD", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $990fdc9d0b8ef141$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $990fdc9d0b8ef141$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $990fdc9d0b8ef141$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $990fdc9d0b8ef141$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $990fdc9d0b8ef141$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $990fdc9d0b8ef141$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $990fdc9d0b8ef141$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $990fdc9d0b8ef141$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $990fdc9d0b8ef141$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $990fdc9d0b8ef141$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $990fdc9d0b8ef141$export$1216008129fb82ed);
$parcel$export(module.exports, "__importDefault", () => $990fdc9d0b8ef141$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $990fdc9d0b8ef141$var$extendStatics = function(d, b) {
    $990fdc9d0b8ef141$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $990fdc9d0b8ef141$var$extendStatics(d, b);
};
function $990fdc9d0b8ef141$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $990fdc9d0b8ef141$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $990fdc9d0b8ef141$export$18ce0697a983be9b = function() {
    $990fdc9d0b8ef141$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $990fdc9d0b8ef141$export$18ce0697a983be9b.apply(this, arguments);
};
function $990fdc9d0b8ef141$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $990fdc9d0b8ef141$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $990fdc9d0b8ef141$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $990fdc9d0b8ef141$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $990fdc9d0b8ef141$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $990fdc9d0b8ef141$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $990fdc9d0b8ef141$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $990fdc9d0b8ef141$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $990fdc9d0b8ef141$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $990fdc9d0b8ef141$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $990fdc9d0b8ef141$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $990fdc9d0b8ef141$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $990fdc9d0b8ef141$export$45d3717a4c69092e(o, m, p);
}
function $990fdc9d0b8ef141$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $990fdc9d0b8ef141$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $990fdc9d0b8ef141$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($990fdc9d0b8ef141$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $990fdc9d0b8ef141$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $990fdc9d0b8ef141$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $990fdc9d0b8ef141$export$10c90e4f7922046c(v) {
    return this instanceof $990fdc9d0b8ef141$export$10c90e4f7922046c ? (this.v = v, this) : new $990fdc9d0b8ef141$export$10c90e4f7922046c(v);
}
function $990fdc9d0b8ef141$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $990fdc9d0b8ef141$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $990fdc9d0b8ef141$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $990fdc9d0b8ef141$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $990fdc9d0b8ef141$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $990fdc9d0b8ef141$export$19a8beecd37a4c45 === "function" ? $990fdc9d0b8ef141$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $990fdc9d0b8ef141$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $990fdc9d0b8ef141$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $990fdc9d0b8ef141$var$ownKeys = function(o) {
    $990fdc9d0b8ef141$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $990fdc9d0b8ef141$var$ownKeys(o);
};
function $990fdc9d0b8ef141$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $990fdc9d0b8ef141$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $990fdc9d0b8ef141$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $990fdc9d0b8ef141$var$__setModuleDefault(result, mod);
    return result;
}
function $990fdc9d0b8ef141$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $990fdc9d0b8ef141$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $990fdc9d0b8ef141$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $990fdc9d0b8ef141$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $990fdc9d0b8ef141$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $990fdc9d0b8ef141$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $990fdc9d0b8ef141$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $990fdc9d0b8ef141$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $990fdc9d0b8ef141$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $990fdc9d0b8ef141$export$2e2bcd8739ae039 = {
    __extends: $990fdc9d0b8ef141$export$a8ba968b8961cb8a,
    __assign: $990fdc9d0b8ef141$export$18ce0697a983be9b,
    __rest: $990fdc9d0b8ef141$export$3c9a16f847548506,
    __decorate: $990fdc9d0b8ef141$export$29e00dfd3077644b,
    __param: $990fdc9d0b8ef141$export$d5ad3fd78186038f,
    __esDecorate: $990fdc9d0b8ef141$export$3a84e1ae4e97e9b0,
    __runInitializers: $990fdc9d0b8ef141$export$d831c04e792af3d,
    __propKey: $990fdc9d0b8ef141$export$6a2a36740a146cb8,
    __setFunctionName: $990fdc9d0b8ef141$export$d1a06452d3489bc7,
    __metadata: $990fdc9d0b8ef141$export$f1db080c865becb9,
    __awaiter: $990fdc9d0b8ef141$export$1050f835b63b671e,
    __generator: $990fdc9d0b8ef141$export$67ebef60e6f28a6,
    __createBinding: $990fdc9d0b8ef141$export$45d3717a4c69092e,
    __exportStar: $990fdc9d0b8ef141$export$f33643c0debef087,
    __values: $990fdc9d0b8ef141$export$19a8beecd37a4c45,
    __read: $990fdc9d0b8ef141$export$8d051b38c9118094,
    __spread: $990fdc9d0b8ef141$export$afc72e2116322959,
    __spreadArrays: $990fdc9d0b8ef141$export$6388937ca91ccae8,
    __spreadArray: $990fdc9d0b8ef141$export$1216008129fb82ed,
    __await: $990fdc9d0b8ef141$export$10c90e4f7922046c,
    __asyncGenerator: $990fdc9d0b8ef141$export$e427f37a30a4de9b,
    __asyncDelegator: $990fdc9d0b8ef141$export$bbd80228419bb833,
    __asyncValues: $990fdc9d0b8ef141$export$e3b29a3d6162315f,
    __makeTemplateObject: $990fdc9d0b8ef141$export$4fb47efe1390b86f,
    __importStar: $990fdc9d0b8ef141$export$c21735bcef00d192,
    __importDefault: $990fdc9d0b8ef141$export$da59b14a69baef04,
    __classPrivateFieldGet: $990fdc9d0b8ef141$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $990fdc9d0b8ef141$export$d40a35129aaff81f,
    __classPrivateFieldIn: $990fdc9d0b8ef141$export$81fdc39f203e4e04,
    __addDisposableResource: $990fdc9d0b8ef141$export$88ac25d8e944e405,
    __disposeResources: $990fdc9d0b8ef141$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $990fdc9d0b8ef141$export$889dfb5d17574b0b
};

});

parcelRegister("KhyL6", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $08b1eaf7e8db9fe0$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $08b1eaf7e8db9fe0$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $08b1eaf7e8db9fe0$export$a07cdf6544bbd7c);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("gYyhc");
var $fAIrM = parcelRequire("fAIrM");
var $X01oz = parcelRequire("X01oz");
var $fm43g = parcelRequire("fm43g");
var $d6QtP = parcelRequire("d6QtP");
var $80kSI = parcelRequire("80kSI");

var $620lR = parcelRequire("620lR");

var $1Isls = parcelRequire("1Isls");

var $c8vCZ = parcelRequire("c8vCZ");
var $08b1eaf7e8db9fe0$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $08b1eaf7e8db9fe0$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $08b1eaf7e8db9fe0$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $1Isls.Scope)();
        if (_version === void 0) _version = $08b1eaf7e8db9fe0$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $1Isls.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $80kSI.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $80kSI.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $80kSI.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $08b1eaf7e8db9fe0$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $X01oz.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $d8KcD.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $fAIrM.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $08b1eaf7e8db9fe0$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $08b1eaf7e8db9fe0$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $620lR.IS_DEBUG_BUILD) && (0, $fAIrM.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $fm43g.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $c8vCZ.Session)((0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $d8KcD.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $08b1eaf7e8db9fe0$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $620lR.IS_DEBUG_BUILD) && (0, $fAIrM.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $08b1eaf7e8db9fe0$export$19eade501500c6c1() {
    var carrier = (0, $fm43g.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $08b1eaf7e8db9fe0$export$4188a14ad302d1bc(hub) {
    var registry = $08b1eaf7e8db9fe0$export$19eade501500c6c1();
    var oldHub = $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(registry);
    $08b1eaf7e8db9fe0$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $08b1eaf7e8db9fe0$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $08b1eaf7e8db9fe0$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$08b1eaf7e8db9fe0$var$hasHubOnCarrier(registry) || $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(registry).isOlderThan($08b1eaf7e8db9fe0$export$24a86ef7798177e4)) $08b1eaf7e8db9fe0$export$849f05434e95d2f2(registry, new $08b1eaf7e8db9fe0$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $d6QtP.isNodeEnv)()) return $08b1eaf7e8db9fe0$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(registry);
}
function $08b1eaf7e8db9fe0$export$1c4d656130202699() {
    (0, $620lR.IS_DEBUG_BUILD) && (0, $fAIrM.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $08b1eaf7e8db9fe0$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $08b1eaf7e8db9fe0$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $08b1eaf7e8db9fe0$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$08b1eaf7e8db9fe0$var$hasHubOnCarrier(activeDomain) || $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(activeDomain).isOlderThan($08b1eaf7e8db9fe0$export$24a86ef7798177e4)) {
            var registryHubTopStack = $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(registry).getStackTop();
            $08b1eaf7e8db9fe0$export$849f05434e95d2f2(activeDomain, new $08b1eaf7e8db9fe0$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $1Isls.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $08b1eaf7e8db9fe0$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $08b1eaf7e8db9fe0$export$bfa8a924a84a76b7(carrier) {
    return (0, $fm43g.getGlobalSingleton)('hub', function() {
        return new $08b1eaf7e8db9fe0$export$8c41bb232f1008b1();
    }, carrier);
}
function $08b1eaf7e8db9fe0$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("gYyhc", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("fm43g")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("fm43g")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("2Rl6j")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("2Rl6j")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("fAIrM")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("fAIrM")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("80kSI")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("6tcWt")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("kvDUX")).SyncPromise);





parcelRequire("fm43g");

parcelRequire("2Rl6j");
parcelRequire("fAIrM");

parcelRequire("80kSI");

var $d6QtP = parcelRequire("d6QtP");

parcelRequire("6tcWt");







parcelRequire("kvDUX");

var $X01oz = parcelRequire("X01oz");





$parcel$exportWildcard(module.exports, $d6QtP);
$parcel$exportWildcard(module.exports, $X01oz);

});
parcelRegister("fm43g", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $b2dc0dac8b8f0cb9$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $b2dc0dac8b8f0cb9$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $d6QtP = parcelRequire("d6QtP");
var $b2dc0dac8b8f0cb9$var$fallbackGlobalObject = {};
function $b2dc0dac8b8f0cb9$export$256479dc0cea61c4() {
    return (0, $d6QtP.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $b2dc0dac8b8f0cb9$var$fallbackGlobalObject;
}
function $b2dc0dac8b8f0cb9$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $b2dc0dac8b8f0cb9$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("d6QtP", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $6aflc = parcelRequire("6aflc");

var $3TFEq = parcelRequire("3TFEq");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $6aflc.isBrowserBundle)() && Object.prototype.toString.call(typeof $3TFEq !== 'undefined' ? $3TFEq : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("6aflc", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $47cf93a15fd7e4b4$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $47cf93a15fd7e4b4$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("2Rl6j", function(module, exports) {
$parcel$export(module.exports, "isError", () => $2150e635f83b5331$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $2150e635f83b5331$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $2150e635f83b5331$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $2150e635f83b5331$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $2150e635f83b5331$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $2150e635f83b5331$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $2150e635f83b5331$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $2150e635f83b5331$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $2150e635f83b5331$export$f5b060c2914b97c8);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $2150e635f83b5331$var$objectToString = Object.prototype.toString;
function $2150e635f83b5331$export$e6127cc7fe7395c3(wat) {
    switch($2150e635f83b5331$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $2150e635f83b5331$export$49034edbe6b62415(wat, Error);
    }
}
function $2150e635f83b5331$var$isBuiltin(wat, ty) {
    return $2150e635f83b5331$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $2150e635f83b5331$export$9f9636d330b71954(wat) {
    return $2150e635f83b5331$var$isBuiltin(wat, 'ErrorEvent');
}
function $2150e635f83b5331$export$ef9e2056653f0c8e(wat) {
    return $2150e635f83b5331$var$isBuiltin(wat, 'DOMError');
}
function $2150e635f83b5331$export$12e869b2a583f783(wat) {
    return $2150e635f83b5331$var$isBuiltin(wat, 'DOMException');
}
function $2150e635f83b5331$export$844ec244b1367d54(wat) {
    return $2150e635f83b5331$var$isBuiltin(wat, 'String');
}
function $2150e635f83b5331$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $2150e635f83b5331$export$53b83ca8eaab0383(wat) {
    return $2150e635f83b5331$var$isBuiltin(wat, 'Object');
}
function $2150e635f83b5331$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $2150e635f83b5331$export$49034edbe6b62415(wat, Event);
}
function $2150e635f83b5331$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $2150e635f83b5331$export$49034edbe6b62415(wat, Element);
}
function $2150e635f83b5331$export$49841c62b9eff15(wat) {
    return $2150e635f83b5331$var$isBuiltin(wat, 'RegExp');
}
function $2150e635f83b5331$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $2150e635f83b5331$export$bc2894c7158efbac(wat) {
    return $2150e635f83b5331$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $2150e635f83b5331$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $2150e635f83b5331$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("fAIrM", function(module, exports) {
$parcel$export(module.exports, "consoleSandbox", () => $b59cb211dcb6f13e$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $b59cb211dcb6f13e$export$af88d00dbe7f521);

var $d8KcD = parcelRequire("d8KcD");

var $fWG7u = parcelRequire("fWG7u");

var $fm43g = parcelRequire("fm43g");
// TODO: Implement different loggers for different environments
var $b59cb211dcb6f13e$var$global = (0, $fm43g.getGlobalObject)();
/** Prefix for logging strings */ var $b59cb211dcb6f13e$var$PREFIX = 'Sentry Logger ';
var $b59cb211dcb6f13e$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $b59cb211dcb6f13e$export$cda52e2a8927a2ca(callback) {
    var global = (0, $fm43g.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $b59cb211dcb6f13e$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $b59cb211dcb6f13e$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $fWG7u.IS_DEBUG_BUILD) $b59cb211dcb6f13e$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $b59cb211dcb6f13e$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $b59cb211dcb6f13e$var$global.console)[name].apply(_a, (0, $d8KcD.__spread)([
                    $b59cb211dcb6f13e$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $b59cb211dcb6f13e$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $b59cb211dcb6f13e$export$af88d00dbe7f521;
if (0, $fWG7u.IS_DEBUG_BUILD) $b59cb211dcb6f13e$export$af88d00dbe7f521 = (0, $fm43g.getGlobalSingleton)('logger', $b59cb211dcb6f13e$var$makeLogger);
else $b59cb211dcb6f13e$export$af88d00dbe7f521 = $b59cb211dcb6f13e$var$makeLogger();

});
parcelRegister("fWG7u", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $b9bcf1ed395a31dd$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $b9bcf1ed395a31dd$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("80kSI", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $5d3e85708c796b15$export$19f53698e68b2496);

var $d8KcD = parcelRequire("d8KcD");

var $fm43g = parcelRequire("fm43g");

var $6tcWt = parcelRequire("6tcWt");

var $2yO2W = parcelRequire("2yO2W");
function $5d3e85708c796b15$export$19f53698e68b2496() {
    var global = (0, $fm43g.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $5d3e85708c796b15$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $5d3e85708c796b15$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $5d3e85708c796b15$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $5d3e85708c796b15$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $5d3e85708c796b15$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $5d3e85708c796b15$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $5d3e85708c796b15$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $5d3e85708c796b15$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $5d3e85708c796b15$export$d364f2020ab30578(input) {
    var match = input.match($5d3e85708c796b15$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $5d3e85708c796b15$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $2yO2W.snipLine)(line, 0);
    });
    frame.context_line = (0, $2yO2W.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $2yO2W.snipLine)(line, 0);
    });
}
function $5d3e85708c796b15$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $5d3e85708c796b15$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $6tcWt.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("6tcWt", function(module, exports) {
$parcel$export(module.exports, "addNonEnumerableProperty", () => $4b5f7d89f0455f31$export$e73679ffaf56810e);
$parcel$export(module.exports, "dropUndefinedKeys", () => $4b5f7d89f0455f31$export$d25f2688db1bb433);

var $d8KcD = parcelRequire("d8KcD");

var $aoWgl = parcelRequire("aoWgl");

var $2Rl6j = parcelRequire("2Rl6j");

var $2yO2W = parcelRequire("2yO2W");
function $4b5f7d89f0455f31$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $4b5f7d89f0455f31$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $4b5f7d89f0455f31$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $4b5f7d89f0455f31$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $4b5f7d89f0455f31$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $4b5f7d89f0455f31$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $4b5f7d89f0455f31$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $4b5f7d89f0455f31$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $2Rl6j.isError)(value)) newObj = (0, $d8KcD.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $4b5f7d89f0455f31$var$getOwnProperties(value));
    else if ((0, $2Rl6j.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $d8KcD.__assign)({
            type: event_1.type,
            target: $4b5f7d89f0455f31$var$serializeEventTarget(event_1.target),
            currentTarget: $4b5f7d89f0455f31$var$serializeEventTarget(event_1.currentTarget)
        }, $4b5f7d89f0455f31$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $2Rl6j.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $4b5f7d89f0455f31$var$serializeEventTarget(target) {
    try {
        return (0, $2Rl6j.isElement)(target) ? (0, $aoWgl.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $4b5f7d89f0455f31$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $4b5f7d89f0455f31$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($4b5f7d89f0455f31$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $2yO2W.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $2yO2W.truncate)(serialized, maxLength);
    }
    return '';
}
function $4b5f7d89f0455f31$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $2Rl6j.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $d8KcD.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $4b5f7d89f0455f31$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($4b5f7d89f0455f31$export$d25f2688db1bb433);
    return val;
}
function $4b5f7d89f0455f31$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $2Rl6j.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("aoWgl", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $79295708f59b047f$export$5647df6b7814ac86);

var $fm43g = parcelRequire("fm43g");

var $2Rl6j = parcelRequire("2Rl6j");
function $79295708f59b047f$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $79295708f59b047f$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $79295708f59b047f$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $2Rl6j.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $79295708f59b047f$export$1cfafeee2987818b() {
    var global = (0, $fm43g.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("2yO2W", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $1dd593ee8633562c$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $1dd593ee8633562c$export$4215662d762d6f9d);

var $2Rl6j = parcelRequire("2Rl6j");
function $1dd593ee8633562c$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $1dd593ee8633562c$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $1dd593ee8633562c$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $1dd593ee8633562c$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $2Rl6j.isString)(value)) return false;
    if ((0, $2Rl6j.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $1dd593ee8633562c$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("kvDUX", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $eee5aab544a56725$export$6f292d4960313241);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $2Rl6j = parcelRequire("2Rl6j");
function $eee5aab544a56725$export$1fda8aa4d135f8aa(value) {
    return new $eee5aab544a56725$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $eee5aab544a56725$export$78e43115b553f358(reason) {
    return new $eee5aab544a56725$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $eee5aab544a56725$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $2Rl6j.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("X01oz", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $fm43g = parcelRequire("fm43g");

var $d6QtP = parcelRequire("d6QtP");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $fm43g.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $d6QtP.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $d6QtP.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $fm43g.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});


parcelRegister("620lR", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $464333cdf1e6d1fa$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $464333cdf1e6d1fa$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("1Isls", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $13ffe33e7bd43c6c$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $13ffe33e7bd43c6c$export$8e4e25f54d456511);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("gYyhc");
var $X01oz = parcelRequire("X01oz");
var $fm43g = parcelRequire("fm43g");
var $2Rl6j = parcelRequire("2Rl6j");
var $kvDUX = parcelRequire("kvDUX");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $13ffe33e7bd43c6c$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $13ffe33e7bd43c6c$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $d8KcD.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $d8KcD.__assign)({}, scope._tags);
            newScope._extra = (0, $d8KcD.__assign)({}, scope._extra);
            newScope._contexts = (0, $d8KcD.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $d8KcD.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $2Rl6j.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $13ffe33e7bd43c6c$var$MAX_BREADCRUMBS) : $13ffe33e7bd43c6c$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $d8KcD.__assign)({
            timestamp: (0, $X01oz.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $d8KcD.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $d8KcD.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $d8KcD.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $d8KcD.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $d8KcD.__spread)($13ffe33e7bd43c6c$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $kvDUX.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $d8KcD.__assign)({}, event), hint);
                if ((0, $2Rl6j.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $13ffe33e7bd43c6c$var$getGlobalEventProcessors() {
    return (0, $fm43g.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $13ffe33e7bd43c6c$export$8e4e25f54d456511(callback) {
    $13ffe33e7bd43c6c$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("c8vCZ", function(module, exports) {
$parcel$export(module.exports, "Session", () => $8d5ec40c72ebb7cf$export$1fb4852a55678982);
parcelRequire("gYyhc");
var $6tcWt = parcelRequire("6tcWt");
var $X01oz = parcelRequire("X01oz");
var $80kSI = parcelRequire("80kSI");
/**
 * @inheritdoc
 */ var $8d5ec40c72ebb7cf$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $80kSI.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $X01oz.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $X01oz.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $80kSI.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $6tcWt.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});



parcelRegister("2poHG", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d8KcD = parcelRequire("d8KcD");

var $ahlU2 = parcelRequire("ahlU2");
parcelRequire("kzlYU");
var $1WJpp = parcelRequire("1WJpp");
var $bSrCK = parcelRequire("bSrCK");
var $1Haiv = parcelRequire("1Haiv");
var $gzHhz = parcelRequire("gzHhz");
var $fzdxc = parcelRequire("fzdxc");
var $8pMAa = parcelRequire("8pMAa");

var $21R5E = parcelRequire("21R5E");
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */ function $1c111435930f6cff$var$exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $1c111435930f6cff$var$parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: $1c111435930f6cff$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
module.exports.exceptionFromError = $1c111435930f6cff$var$exceptionFromError;
/**
 * @hidden
 */ function $1c111435930f6cff$var$eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: $gzHhz.isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + $1Haiv.extractExceptionKeysForMessage(exception)
                }
            ]
        },
        extra: {
            __serialized__: $fzdxc.normalizeToSize(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $1c111435930f6cff$var$parseStackFrames(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
module.exports.eventFromPlainObject = $1c111435930f6cff$var$eventFromPlainObject;
/**
 * @hidden
 */ function $1c111435930f6cff$var$eventFromError(ex) {
    return {
        exception: {
            values: [
                $1c111435930f6cff$var$exceptionFromError(ex)
            ]
        }
    };
}
module.exports.eventFromError = $1c111435930f6cff$var$eventFromError;
/** Parses stack frames from an error */ function $1c111435930f6cff$var$parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $1c111435930f6cff$var$getPopSize(ex);
    try {
        return $bSrCK.createStackParser($21R5E.opera10StackParser, $21R5E.opera11StackParser, $21R5E.chromeStackParser, $21R5E.winjsStackParser, $21R5E.geckoStackParser)(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
module.exports.parseStackFrames = $1c111435930f6cff$var$parseStackFrames;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $1c111435930f6cff$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $1c111435930f6cff$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($1c111435930f6cff$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $1c111435930f6cff$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $1c111435930f6cff$var$eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $1c111435930f6cff$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    $1WJpp.addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = $ahlU2.Severity.Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $8pMAa.resolvedSyncPromise(event);
}
module.exports.eventFromException = $1c111435930f6cff$var$eventFromException;
/**
 * Builds and Event from a Message
 * @hidden
 */ function $1c111435930f6cff$var$eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) level = $ahlU2.Severity.Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $1c111435930f6cff$var$eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return $8pMAa.resolvedSyncPromise(event);
}
module.exports.eventFromMessage = $1c111435930f6cff$var$eventFromMessage;
/**
 * @hidden
 */ function $1c111435930f6cff$var$eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ($gzHhz.isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $1c111435930f6cff$var$eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ($gzHhz.isDOMError(exception) || $gzHhz.isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $1c111435930f6cff$var$eventFromError(exception);
        else {
            var name_1 = domException.name || ($gzHhz.isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $1c111435930f6cff$var$eventFromString(message, syntheticException, attachStacktrace);
            $1WJpp.addExceptionTypeValue(event, message);
        }
        if ('code' in domException) event.tags = $d8KcD.__assign($d8KcD.__assign({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ($gzHhz.isError(exception)) // we have a real Error object, do nothing
    return $1c111435930f6cff$var$eventFromError(exception);
    if ($gzHhz.isPlainObject(exception) || $gzHhz.isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $1c111435930f6cff$var$eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        $1WJpp.addExceptionMechanism(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $1c111435930f6cff$var$eventFromString(exception, syntheticException, attachStacktrace);
    $1WJpp.addExceptionTypeValue(event, "" + exception, undefined);
    $1WJpp.addExceptionMechanism(event, {
        synthetic: true
    });
    return event;
}
module.exports.eventFromUnknownInput = $1c111435930f6cff$var$eventFromUnknownInput;
/**
 * @hidden
 */ function $1c111435930f6cff$var$eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $1c111435930f6cff$var$parseStackFrames(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}
module.exports.eventFromString = $1c111435930f6cff$var$eventFromString;

});
parcelRegister("ahlU2", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $77bc7b60233cf68e$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $77bc7b60233cf68e$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($77bc7b60233cf68e$export$918a9776c0a3cf27 || ($77bc7b60233cf68e$export$918a9776c0a3cf27 = {}));
var $77bc7b60233cf68e$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("kzlYU", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("giojG")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("5ruYt")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("5ruYt")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("12JF9")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("12JF9")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("7Uuus")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("gLjeB")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("hlQcu")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("gzHhz")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("gzHhz")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("gzHhz")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("gzHhz")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("gzHhz")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("gzHhz")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("gzHhz")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("gzHhz")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("gzHhz")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("gzHhz")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("6rwao")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("1WJpp")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("1WJpp")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("1WJpp")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("1WJpp")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("1WJpp")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("1WJpp")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("fzdxc")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("fzdxc")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("1Haiv")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("1Haiv")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("1Haiv")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("1Haiv")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("1Haiv")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("1Haiv")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("9HvcJ")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("4rAdB")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("bSrCK")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("bSrCK")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("2kC7D")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("caql8")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("caql8")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("caql8")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("lCv2K")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("lCv2K")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("lCv2K")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("8pMAa")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("8pMAa")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("8pMAa")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("i6KQw")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("i6KQw")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("i6KQw")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("cWrcf")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("iGPXA")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("iGPXA")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("iGPXA")).updateRateLimits);
parcelRequire("giojG");
parcelRequire("5ruYt");
parcelRequire("12JF9");

parcelRequire("7Uuus");
parcelRequire("gLjeB");
parcelRequire("hlQcu");
parcelRequire("gzHhz");
parcelRequire("6rwao");

parcelRequire("1WJpp");

var $9ZTUD = parcelRequire("9ZTUD");
parcelRequire("fzdxc");
parcelRequire("1Haiv");

parcelRequire("9HvcJ");
parcelRequire("4rAdB");
parcelRequire("bSrCK");
parcelRequire("2kC7D");
parcelRequire("caql8");
parcelRequire("lCv2K");
parcelRequire("8pMAa");

var $7V4My = parcelRequire("7V4My");


parcelRequire("i6KQw");
parcelRequire("cWrcf");
parcelRequire("iGPXA");
$parcel$exportWildcard(module.exports, $9ZTUD);
$parcel$exportWildcard(module.exports, $7V4My);

});
parcelRegister("giojG", function(module, exports) {
$parcel$export(module.exports, "forget", () => $bdd1308ade8d2e1d$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $bdd1308ade8d2e1d$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("5ruYt", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $3f6780418858a5f4$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $3f6780418858a5f4$export$1cfafeee2987818b);

var $gLjeB = parcelRequire("gLjeB");

var $gzHhz = parcelRequire("gzHhz");
function $3f6780418858a5f4$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $3f6780418858a5f4$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $3f6780418858a5f4$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $gzHhz.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $3f6780418858a5f4$export$1cfafeee2987818b() {
    var global = (0, $gLjeB.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});
parcelRegister("gLjeB", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $c33ff4b52dd0fbb7$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $c33ff4b52dd0fbb7$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9ZTUD = parcelRequire("9ZTUD");
var $c33ff4b52dd0fbb7$var$fallbackGlobalObject = {};
function $c33ff4b52dd0fbb7$export$256479dc0cea61c4() {
    return (0, $9ZTUD.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $c33ff4b52dd0fbb7$var$fallbackGlobalObject;
}
function $c33ff4b52dd0fbb7$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $c33ff4b52dd0fbb7$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("9ZTUD", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $4WzkX = parcelRequire("4WzkX");

var $3TFEq = parcelRequire("3TFEq");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $4WzkX.isBrowserBundle)() && Object.prototype.toString.call(typeof $3TFEq !== 'undefined' ? $3TFEq : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("4WzkX", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $3997fd6b6e53fed4$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3997fd6b6e53fed4$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("gzHhz", function(module, exports) {
$parcel$export(module.exports, "isError", () => $c1117d314fffe286$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $c1117d314fffe286$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $c1117d314fffe286$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $c1117d314fffe286$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $c1117d314fffe286$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $c1117d314fffe286$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $c1117d314fffe286$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $c1117d314fffe286$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $c1117d314fffe286$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $c1117d314fffe286$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $c1117d314fffe286$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $c1117d314fffe286$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $c1117d314fffe286$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $c1117d314fffe286$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c1117d314fffe286$var$objectToString = Object.prototype.toString;
function $c1117d314fffe286$export$e6127cc7fe7395c3(wat) {
    switch($c1117d314fffe286$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c1117d314fffe286$export$49034edbe6b62415(wat, Error);
    }
}
function $c1117d314fffe286$var$isBuiltin(wat, ty) {
    return $c1117d314fffe286$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c1117d314fffe286$export$9f9636d330b71954(wat) {
    return $c1117d314fffe286$var$isBuiltin(wat, 'ErrorEvent');
}
function $c1117d314fffe286$export$ef9e2056653f0c8e(wat) {
    return $c1117d314fffe286$var$isBuiltin(wat, 'DOMError');
}
function $c1117d314fffe286$export$12e869b2a583f783(wat) {
    return $c1117d314fffe286$var$isBuiltin(wat, 'DOMException');
}
function $c1117d314fffe286$export$844ec244b1367d54(wat) {
    return $c1117d314fffe286$var$isBuiltin(wat, 'String');
}
function $c1117d314fffe286$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c1117d314fffe286$export$53b83ca8eaab0383(wat) {
    return $c1117d314fffe286$var$isBuiltin(wat, 'Object');
}
function $c1117d314fffe286$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c1117d314fffe286$export$49034edbe6b62415(wat, Event);
}
function $c1117d314fffe286$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c1117d314fffe286$export$49034edbe6b62415(wat, Element);
}
function $c1117d314fffe286$export$49841c62b9eff15(wat) {
    return $c1117d314fffe286$var$isBuiltin(wat, 'RegExp');
}
function $c1117d314fffe286$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c1117d314fffe286$export$bc2894c7158efbac(wat) {
    return $c1117d314fffe286$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c1117d314fffe286$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c1117d314fffe286$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});


parcelRegister("12JF9", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $0c296607da6ce257$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $0c296607da6ce257$export$128827c3562ec0cb);

var $d8KcD = parcelRequire("d8KcD");

var $7Uuus = parcelRequire("7Uuus");

var $bkczQ = parcelRequire("bkczQ");
/** Regular expression used to parse a Dsn. */ var $0c296607da6ce257$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $0c296607da6ce257$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $0c296607da6ce257$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $0c296607da6ce257$var$dsnFromString(str) {
    var match = $0c296607da6ce257$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $7Uuus.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $d8KcD.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $0c296607da6ce257$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $0c296607da6ce257$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $0c296607da6ce257$var$validateDsn(dsn) {
    if (!(0, $bkczQ.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $7Uuus.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $7Uuus.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$0c296607da6ce257$var$isValidProtocol(protocol)) throw new (0, $7Uuus.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $7Uuus.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $0c296607da6ce257$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $0c296607da6ce257$var$dsnFromString(from) : $0c296607da6ce257$var$dsnFromComponents(from);
    $0c296607da6ce257$var$validateDsn(components);
    return components;
}

});
parcelRegister("7Uuus", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $5c256a174db179f1$export$5949942ba2a7c0e2);

var $d8KcD = parcelRequire("d8KcD");

var $dGqQQ = parcelRequire("dGqQQ");
/** An error emitted by Sentry SDKs and related utilities. */ var $5c256a174db179f1$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $dGqQQ.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("dGqQQ", function(module, exports) {
$parcel$export(module.exports, "setPrototypeOf", () => $9f6406b8abf8b032$export$1cb0d91350beb6cc);
var $9f6406b8abf8b032$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $9f6406b8abf8b032$var$setProtoOf : $9f6406b8abf8b032$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9f6406b8abf8b032$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $9f6406b8abf8b032$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});


parcelRegister("bkczQ", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $83eb5186efab096b$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $83eb5186efab096b$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("hlQcu", function(module, exports) {
$parcel$export(module.exports, "addInstrumentationHandler", () => $ca1ce3c217f9004f$export$285b9172a3741fb7);

var $d8KcD = parcelRequire("d8KcD");

var $bkczQ = parcelRequire("bkczQ");

var $gLjeB = parcelRequire("gLjeB");

var $gzHhz = parcelRequire("gzHhz");

var $6rwao = parcelRequire("6rwao");

var $1Haiv = parcelRequire("1Haiv");

var $bSrCK = parcelRequire("bSrCK");

var $lCv2K = parcelRequire("lCv2K");
var $ca1ce3c217f9004f$var$global = (0, $gLjeB.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $ca1ce3c217f9004f$var$handlers = {};
var $ca1ce3c217f9004f$var$instrumented = {};
/** Instruments given API */ function $ca1ce3c217f9004f$var$instrument(type) {
    if ($ca1ce3c217f9004f$var$instrumented[type]) return;
    $ca1ce3c217f9004f$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $ca1ce3c217f9004f$var$instrumentConsole();
            break;
        case 'dom':
            $ca1ce3c217f9004f$var$instrumentDOM();
            break;
        case 'xhr':
            $ca1ce3c217f9004f$var$instrumentXHR();
            break;
        case 'fetch':
            $ca1ce3c217f9004f$var$instrumentFetch();
            break;
        case 'history':
            $ca1ce3c217f9004f$var$instrumentHistory();
            break;
        case 'error':
            $ca1ce3c217f9004f$var$instrumentError();
            break;
        case 'unhandledrejection':
            $ca1ce3c217f9004f$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $bkczQ.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $ca1ce3c217f9004f$export$285b9172a3741fb7(type, callback) {
    $ca1ce3c217f9004f$var$handlers[type] = $ca1ce3c217f9004f$var$handlers[type] || [];
    $ca1ce3c217f9004f$var$handlers[type].push(callback);
    $ca1ce3c217f9004f$var$instrument(type);
}
/** JSDoc */ function $ca1ce3c217f9004f$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$ca1ce3c217f9004f$var$handlers[type]) return;
    try {
        for(var _b = (0, $d8KcD.__values)($ca1ce3c217f9004f$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $bkczQ.IS_DEBUG_BUILD) && (0, $6rwao.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $bSrCK.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $ca1ce3c217f9004f$var$instrumentConsole() {
    if (!('console' in $ca1ce3c217f9004f$var$global)) return;
    (0, $6rwao.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $ca1ce3c217f9004f$var$global.console)) return;
        (0, $1Haiv.fill)($ca1ce3c217f9004f$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $ca1ce3c217f9004f$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($ca1ce3c217f9004f$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $ca1ce3c217f9004f$var$instrumentFetch() {
    if (!(0, $lCv2K.supportsNativeFetch)()) return;
    (0, $1Haiv.fill)($ca1ce3c217f9004f$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $ca1ce3c217f9004f$var$getFetchMethod(args),
                    url: $ca1ce3c217f9004f$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $ca1ce3c217f9004f$var$triggerHandlers('fetch', (0, $d8KcD.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($ca1ce3c217f9004f$var$global, args).then(function(response) {
                $ca1ce3c217f9004f$var$triggerHandlers('fetch', (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $ca1ce3c217f9004f$var$triggerHandlers('fetch', (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $ca1ce3c217f9004f$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $ca1ce3c217f9004f$var$global && (0, $gzHhz.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $ca1ce3c217f9004f$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $ca1ce3c217f9004f$var$global && (0, $gzHhz.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $ca1ce3c217f9004f$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $ca1ce3c217f9004f$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $1Haiv.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $gzHhz.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $gzHhz.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $ca1ce3c217f9004f$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $1Haiv.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $1Haiv.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $ca1ce3c217f9004f$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $ca1ce3c217f9004f$var$lastHref;
/** JSDoc */ function $ca1ce3c217f9004f$var$instrumentHistory() {
    if (!(0, $lCv2K.supportsHistory)()) return;
    var oldOnPopState = $ca1ce3c217f9004f$var$global.onpopstate;
    $ca1ce3c217f9004f$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $ca1ce3c217f9004f$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $ca1ce3c217f9004f$var$lastHref;
        $ca1ce3c217f9004f$var$lastHref = to;
        $ca1ce3c217f9004f$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $ca1ce3c217f9004f$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ca1ce3c217f9004f$var$lastHref = to;
                $ca1ce3c217f9004f$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $1Haiv.fill)($ca1ce3c217f9004f$var$global.history, 'pushState', historyReplacementFunction);
    (0, $1Haiv.fill)($ca1ce3c217f9004f$var$global.history, 'replaceState', historyReplacementFunction);
}
var $ca1ce3c217f9004f$var$debounceDuration = 1000;
var $ca1ce3c217f9004f$var$debounceTimerID;
var $ca1ce3c217f9004f$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $ca1ce3c217f9004f$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $ca1ce3c217f9004f$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $ca1ce3c217f9004f$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $ca1ce3c217f9004f$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($ca1ce3c217f9004f$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($ca1ce3c217f9004f$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $ca1ce3c217f9004f$var$lastCapturedEvent = event;
        } else if ($ca1ce3c217f9004f$var$shouldShortcircuitPreviousDebounce($ca1ce3c217f9004f$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $ca1ce3c217f9004f$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($ca1ce3c217f9004f$var$debounceTimerID);
        $ca1ce3c217f9004f$var$debounceTimerID = $ca1ce3c217f9004f$var$global.setTimeout(function() {
            $ca1ce3c217f9004f$var$debounceTimerID = undefined;
        }, $ca1ce3c217f9004f$var$debounceDuration);
    };
}
/** JSDoc */ function $ca1ce3c217f9004f$var$instrumentDOM() {
    if (!('document' in $ca1ce3c217f9004f$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $ca1ce3c217f9004f$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $ca1ce3c217f9004f$var$makeDOMEventHandler(triggerDOMHandler, true);
    $ca1ce3c217f9004f$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $ca1ce3c217f9004f$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $ca1ce3c217f9004f$var$global[target] && $ca1ce3c217f9004f$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $1Haiv.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $ca1ce3c217f9004f$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $1Haiv.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $ca1ce3c217f9004f$var$_oldOnErrorHandler = null;
/** JSDoc */ function $ca1ce3c217f9004f$var$instrumentError() {
    $ca1ce3c217f9004f$var$_oldOnErrorHandler = $ca1ce3c217f9004f$var$global.onerror;
    $ca1ce3c217f9004f$var$global.onerror = function(msg, url, line, column, error) {
        $ca1ce3c217f9004f$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($ca1ce3c217f9004f$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $ca1ce3c217f9004f$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $ca1ce3c217f9004f$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $ca1ce3c217f9004f$var$instrumentUnhandledRejection() {
    $ca1ce3c217f9004f$var$_oldOnUnhandledRejectionHandler = $ca1ce3c217f9004f$var$global.onunhandledrejection;
    $ca1ce3c217f9004f$var$global.onunhandledrejection = function(e) {
        $ca1ce3c217f9004f$var$triggerHandlers('unhandledrejection', e);
        if ($ca1ce3c217f9004f$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $ca1ce3c217f9004f$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("6rwao", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $4b0e374bbb086208$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $4b0e374bbb086208$export$af88d00dbe7f521);

var $d8KcD = parcelRequire("d8KcD");

var $bkczQ = parcelRequire("bkczQ");

var $gLjeB = parcelRequire("gLjeB");
// TODO: Implement different loggers for different environments
var $4b0e374bbb086208$var$global = (0, $gLjeB.getGlobalObject)();
/** Prefix for logging strings */ var $4b0e374bbb086208$var$PREFIX = 'Sentry Logger ';
var $4b0e374bbb086208$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $4b0e374bbb086208$export$cda52e2a8927a2ca(callback) {
    var global = (0, $gLjeB.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $4b0e374bbb086208$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $4b0e374bbb086208$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $bkczQ.IS_DEBUG_BUILD) $4b0e374bbb086208$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $4b0e374bbb086208$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $4b0e374bbb086208$var$global.console)[name].apply(_a, (0, $d8KcD.__spread)([
                    $4b0e374bbb086208$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $4b0e374bbb086208$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $4b0e374bbb086208$export$af88d00dbe7f521;
if (0, $bkczQ.IS_DEBUG_BUILD) $4b0e374bbb086208$export$af88d00dbe7f521 = (0, $gLjeB.getGlobalSingleton)('logger', $4b0e374bbb086208$var$makeLogger);
else $4b0e374bbb086208$export$af88d00dbe7f521 = $4b0e374bbb086208$var$makeLogger();

});

parcelRegister("1Haiv", function(module, exports) {
$parcel$export(module.exports, "fill", () => $13c1cb727ab7dfbf$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $13c1cb727ab7dfbf$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $13c1cb727ab7dfbf$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $13c1cb727ab7dfbf$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $13c1cb727ab7dfbf$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $13c1cb727ab7dfbf$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $13c1cb727ab7dfbf$export$b0244d5063c0b61b);

var $d8KcD = parcelRequire("d8KcD");

var $5ruYt = parcelRequire("5ruYt");

var $gzHhz = parcelRequire("gzHhz");

var $caql8 = parcelRequire("caql8");
function $13c1cb727ab7dfbf$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $13c1cb727ab7dfbf$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $13c1cb727ab7dfbf$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $13c1cb727ab7dfbf$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $13c1cb727ab7dfbf$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $13c1cb727ab7dfbf$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $13c1cb727ab7dfbf$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $13c1cb727ab7dfbf$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $gzHhz.isError)(value)) newObj = (0, $d8KcD.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $13c1cb727ab7dfbf$var$getOwnProperties(value));
    else if ((0, $gzHhz.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $d8KcD.__assign)({
            type: event_1.type,
            target: $13c1cb727ab7dfbf$var$serializeEventTarget(event_1.target),
            currentTarget: $13c1cb727ab7dfbf$var$serializeEventTarget(event_1.currentTarget)
        }, $13c1cb727ab7dfbf$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $gzHhz.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $13c1cb727ab7dfbf$var$serializeEventTarget(target) {
    try {
        return (0, $gzHhz.isElement)(target) ? (0, $5ruYt.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $13c1cb727ab7dfbf$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $13c1cb727ab7dfbf$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($13c1cb727ab7dfbf$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $caql8.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $caql8.truncate)(serialized, maxLength);
    }
    return '';
}
function $13c1cb727ab7dfbf$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $gzHhz.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $d8KcD.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $13c1cb727ab7dfbf$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($13c1cb727ab7dfbf$export$d25f2688db1bb433);
    return val;
}
function $13c1cb727ab7dfbf$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $gzHhz.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("caql8", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $8dbad9bc5132d480$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $8dbad9bc5132d480$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $8dbad9bc5132d480$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $8dbad9bc5132d480$export$cdded5b28a5f8c6d);

var $gzHhz = parcelRequire("gzHhz");
function $8dbad9bc5132d480$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $8dbad9bc5132d480$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $8dbad9bc5132d480$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $8dbad9bc5132d480$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $gzHhz.isString)(value)) return false;
    if ((0, $gzHhz.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $8dbad9bc5132d480$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("bSrCK", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $8a5a2a66515c351f$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $8a5a2a66515c351f$export$aad197c7121a6651);

var $d8KcD = parcelRequire("d8KcD");
var $8a5a2a66515c351f$var$STACKTRACE_LIMIT = 50;
function $8a5a2a66515c351f$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $d8KcD.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $d8KcD.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $8a5a2a66515c351f$export$c55c24c0eeba0205(frames);
    };
}
function $8a5a2a66515c351f$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $8a5a2a66515c351f$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $8a5a2a66515c351f$var$defaultFunctionName = '<anonymous>';
function $8a5a2a66515c351f$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $8a5a2a66515c351f$var$defaultFunctionName;
        return fn.name || $8a5a2a66515c351f$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $8a5a2a66515c351f$var$defaultFunctionName;
    }
}

});

parcelRegister("lCv2K", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $040fd384aa05e367$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $040fd384aa05e367$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $040fd384aa05e367$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $040fd384aa05e367$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $040fd384aa05e367$export$67fc34576016d6ec);

var $bkczQ = parcelRequire("bkczQ");

var $gLjeB = parcelRequire("gLjeB");

var $6rwao = parcelRequire("6rwao");
function $040fd384aa05e367$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $040fd384aa05e367$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $040fd384aa05e367$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $040fd384aa05e367$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $gLjeB.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $040fd384aa05e367$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $040fd384aa05e367$export$c82d238e23c40b21() {
    if (!$040fd384aa05e367$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $gLjeB.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($040fd384aa05e367$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $040fd384aa05e367$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $bkczQ.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $040fd384aa05e367$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $gLjeB.getGlobalObject)();
}
function $040fd384aa05e367$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$040fd384aa05e367$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $040fd384aa05e367$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $gLjeB.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("1WJpp", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $16ae6e7748c01915$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $16ae6e7748c01915$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $16ae6e7748c01915$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $16ae6e7748c01915$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $16ae6e7748c01915$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $16ae6e7748c01915$export$6de4ffac6a2f1098);

var $d8KcD = parcelRequire("d8KcD");

var $gLjeB = parcelRequire("gLjeB");

var $1Haiv = parcelRequire("1Haiv");

var $caql8 = parcelRequire("caql8");
function $16ae6e7748c01915$export$19f53698e68b2496() {
    var global = (0, $gLjeB.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $16ae6e7748c01915$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $16ae6e7748c01915$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $16ae6e7748c01915$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $16ae6e7748c01915$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $16ae6e7748c01915$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $16ae6e7748c01915$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $16ae6e7748c01915$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $16ae6e7748c01915$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $16ae6e7748c01915$export$d364f2020ab30578(input) {
    var match = input.match($16ae6e7748c01915$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $16ae6e7748c01915$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $caql8.snipLine)(line, 0);
    });
    frame.context_line = (0, $caql8.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $caql8.snipLine)(line, 0);
    });
}
function $16ae6e7748c01915$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $16ae6e7748c01915$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $1Haiv.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});

parcelRegister("fzdxc", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $b5549f958fdeb59b$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $b5549f958fdeb59b$export$23fbbb20bed71033);

var $d8KcD = parcelRequire("d8KcD");

var $gzHhz = parcelRequire("gzHhz");

var $bCDHT = parcelRequire("bCDHT");

var $1Haiv = parcelRequire("1Haiv");

var $bSrCK = parcelRequire("bSrCK");
function $b5549f958fdeb59b$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $b5549f958fdeb59b$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $b5549f958fdeb59b$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $b5549f958fdeb59b$export$a3295358bff77e(object, depth);
    if ($b5549f958fdeb59b$var$jsonSize(normalized) > maxSize) return $b5549f958fdeb59b$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $b5549f958fdeb59b$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $bCDHT.memoBuilder)();
    var _a = (0, $d8KcD.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $gzHhz.isNaN)(value)) return value;
    var stringified = $b5549f958fdeb59b$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $gzHhz.isError)(value) || (0, $gzHhz.isEvent)(value) ? (0, $1Haiv.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $b5549f958fdeb59b$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $b5549f958fdeb59b$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $gzHhz.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $bSrCK.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $b5549f958fdeb59b$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $b5549f958fdeb59b$var$jsonSize(value) {
    return $b5549f958fdeb59b$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("bCDHT", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $87620b44aafb7214$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $87620b44aafb7214$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("9HvcJ", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $710055c28eefd5fe$export$85a4f67f852183e6);

var $7Uuus = parcelRequire("7Uuus");

var $8pMAa = parcelRequire("8pMAa");
function $710055c28eefd5fe$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $8pMAa.rejectedSyncPromise)(new (0, $7Uuus.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $8pMAa.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $8pMAa.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});
parcelRegister("8pMAa", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $620657fc88f0e0ad$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $620657fc88f0e0ad$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $620657fc88f0e0ad$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $gzHhz = parcelRequire("gzHhz");
function $620657fc88f0e0ad$export$1fda8aa4d135f8aa(value) {
    return new $620657fc88f0e0ad$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $620657fc88f0e0ad$export$78e43115b553f358(reason) {
    return new $620657fc88f0e0ad$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $620657fc88f0e0ad$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $gzHhz.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});


parcelRegister("4rAdB", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $33c5c7491baf0c57$export$e01cef29b4327697);

var $ahlU2 = parcelRequire("ahlU2");

var $5c3uU = parcelRequire("5c3uU");
function $33c5c7491baf0c57$var$isSupportedSeverity(level) {
    return (0, $5c3uU.SeverityLevels).indexOf(level) !== -1;
}
function $33c5c7491baf0c57$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $ahlU2.Severity).Warning;
    if ($33c5c7491baf0c57$var$isSupportedSeverity(level)) return level;
    return (0, $ahlU2.Severity).Log;
}

});
parcelRegister("5c3uU", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $3c80c94b9d4c6a97$export$484b1ea9aec914c);
var $3c80c94b9d4c6a97$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("2kC7D", function(module, exports) {
$parcel$export(module.exports, "eventStatusFromHttpCode", () => $1b2b0546c9d780e2$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $1b2b0546c9d780e2$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("7V4My", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);

var $gLjeB = parcelRequire("gLjeB");

var $9ZTUD = parcelRequire("9ZTUD");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $gLjeB.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $9ZTUD.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $9ZTUD.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $gLjeB.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("i6KQw", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $d2ed202cffa67f53$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $d2ed202cffa67f53$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $d2ed202cffa67f53$export$32f9b428425aac85);

var $d8KcD = parcelRequire("d8KcD");

var $gzHhz = parcelRequire("gzHhz");
function $d2ed202cffa67f53$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $d2ed202cffa67f53$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $d8KcD.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $d8KcD.__spread)(items, [
            newItem
        ])
    ];
}
function $d2ed202cffa67f53$export$d84939284bbafcd4(envelope) {
    var _a = (0, $d8KcD.__read)(envelope, 2), _b = (0, $d8KcD.__read)(_a[1], 1), _c = (0, $d8KcD.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $d2ed202cffa67f53$export$32f9b428425aac85(envelope) {
    var _a = (0, $d8KcD.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $d8KcD.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $gzHhz.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("cWrcf", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $96bfff7af2391e3e$export$f3b9ed77c03eeb00);

var $i6KQw = parcelRequire("i6KQw");

var $7V4My = parcelRequire("7V4My");
function $96bfff7af2391e3e$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $7V4My.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $i6KQw.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("iGPXA", function(module, exports) {
$parcel$export(module.exports, "disabledUntil", () => $d9b4746eedaf1273$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $d9b4746eedaf1273$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $d9b4746eedaf1273$export$699aff705e0d49d4);

var $d8KcD = parcelRequire("d8KcD");
var $d9b4746eedaf1273$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $d9b4746eedaf1273$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $d9b4746eedaf1273$export$b09ce39faaeb1e7c;
}
function $d9b4746eedaf1273$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $d9b4746eedaf1273$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $d9b4746eedaf1273$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $d9b4746eedaf1273$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $d8KcD.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $d8KcD.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $d8KcD.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $d9b4746eedaf1273$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("21R5E", function(module, exports) {
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d8KcD = parcelRequire("d8KcD");
// global reference to slice
var $17a4db582505223f$var$UNKNOWN_FUNCTION = '?';
var $17a4db582505223f$var$OPERA10_PRIORITY = 10;
var $17a4db582505223f$var$OPERA11_PRIORITY = 20;
var $17a4db582505223f$var$CHROME_PRIORITY = 30;
var $17a4db582505223f$var$WINJS_PRIORITY = 40;
var $17a4db582505223f$var$GECKO_PRIORITY = 50;
function $17a4db582505223f$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $17a4db582505223f$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $17a4db582505223f$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $17a4db582505223f$var$chrome = function(line) {
    var parts = $17a4db582505223f$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $17a4db582505223f$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = $d8KcD.__read($17a4db582505223f$var$extractSafariExtensionDetails(parts[1] || $17a4db582505223f$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $17a4db582505223f$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
module.exports.chromeStackParser = [
    $17a4db582505223f$var$CHROME_PRIORITY,
    $17a4db582505223f$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $17a4db582505223f$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $17a4db582505223f$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $17a4db582505223f$var$gecko = function(line) {
    var _a;
    var parts = $17a4db582505223f$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $17a4db582505223f$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $17a4db582505223f$var$UNKNOWN_FUNCTION;
        _a = $d8KcD.__read($17a4db582505223f$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $17a4db582505223f$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
module.exports.geckoStackParser = [
    $17a4db582505223f$var$GECKO_PRIORITY,
    $17a4db582505223f$var$gecko
];
var $17a4db582505223f$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $17a4db582505223f$var$winjs = function(line) {
    var parts = $17a4db582505223f$var$winjsRegex.exec(line);
    return parts ? $17a4db582505223f$var$createFrame(parts[2], parts[1] || $17a4db582505223f$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
module.exports.winjsStackParser = [
    $17a4db582505223f$var$WINJS_PRIORITY,
    $17a4db582505223f$var$winjs
];
var $17a4db582505223f$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $17a4db582505223f$var$opera10 = function(line) {
    var parts = $17a4db582505223f$var$opera10Regex.exec(line);
    return parts ? $17a4db582505223f$var$createFrame(parts[2], parts[3] || $17a4db582505223f$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
module.exports.opera10StackParser = [
    $17a4db582505223f$var$OPERA10_PRIORITY,
    $17a4db582505223f$var$opera10
];
var $17a4db582505223f$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $17a4db582505223f$var$opera11 = function(line) {
    var parts = $17a4db582505223f$var$opera11Regex.exec(line);
    return parts ? $17a4db582505223f$var$createFrame(parts[5], parts[3] || parts[4] || $17a4db582505223f$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
module.exports.opera11StackParser = [
    $17a4db582505223f$var$OPERA11_PRIORITY,
    $17a4db582505223f$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $17a4db582505223f$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $17a4db582505223f$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});




parcelRegister("4SGOi", function(module, exports) {
$parcel$export(module.exports, "getApplication", () => $1ae76329d4fcbe5c$export$205bc258834dc08);
$parcel$export(module.exports, "bootstrap", () => $1ae76329d4fcbe5c$export$36aff1fbb4f5dfc6);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $63sfu = parcelRequire("63sfu");

var $5F0K9 = parcelRequire("5F0K9");
parcelRequire("aPBSl");
var $iF3ru = parcelRequire("iF3ru");

var $6UDG7 = parcelRequire("6UDG7");

var $lNZDv = parcelRequire("lNZDv");

var $dNVFO = parcelRequire("dNVFO");

var $2dPNI = parcelRequire("2dPNI");

var $9VfQ7 = parcelRequire("9VfQ7");

var $ebpTf = parcelRequire("ebpTf");

var $d30rG = parcelRequire("d30rG");

var $2XL92 = parcelRequire("2XL92");

var $aJIdj = parcelRequire("aJIdj");
const $1ae76329d4fcbe5c$var$initialiseAppUtilities = (0, $63sfu.once)(()=>{
    (0, $d30rG.initialisePlatformFeatureFlags)();
    (0, $9VfQ7.initialiseConnectAndSentryAndCleanUrl)();
    (0, $dNVFO.install)();
    (0, $2dPNI.initBrowserMetricsV3)();
});
const $1ae76329d4fcbe5c$export$205bc258834dc08 = ()=>{
    const atlassianHelpConfig = {
        ...(0, $ebpTf.getEnv)(),
        ...(0, $6mmHn.getMetaData)()
    };
    (0, $6UDG7.ModelsCache).getInstance().initFromInitialJsonPayload();
    $1ae76329d4fcbe5c$var$initialiseAppUtilities();
    return /*#__PURE__*/ $4fqPo.createElement((0, $lNZDv.default), {
        name: "help-center-root"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $aJIdj.AtlassianHelp), {
        config: atlassianHelpConfig
    }));
};
const $1ae76329d4fcbe5c$export$36aff1fbb4f5dfc6 = ()=>{
    (0, $iF3ru.LooselyLazy).init({
        retry: 3
    });
    const rootId = 'root';
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    let container = document.getElementById(rootId);
    if (!container) {
        // If there is no root element available yet, add one.
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        container = document.createElement('span');
        container.id = rootId;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.body.appendChild(container);
    }
    // Invalid report.
    // eslint-disable-next-line testing-library/render-result-naming-convention
    const isPageServerSideRendered = (0, $ebpTf.getIsPageServerSideRendered)();
    // Workaround for this google translate problem https://github.com/facebook/react/issues/11538#issuecomment-417504600
    // which is causing this issue https://hello.jira.atlassian.cloud/browse/PORTAL-5241, affecting view page reliability
    (0, $2XL92.handleDOMGoogleTranslateIssues)();
    if ((0, $bG6ob.isUseReact18CreateRootEnabled)()) {
        if (isPageServerSideRendered && !(0, $bG6ob.isReactHydrateDisabledInSSR)()) (0, $5F0K9.hydrateRoot)(container, $1ae76329d4fcbe5c$export$205bc258834dc08());
        else (0, $5F0K9.createRoot)(container).render($1ae76329d4fcbe5c$export$205bc258834dc08());
    } else if (isPageServerSideRendered && !(0, $bG6ob.isReactHydrateDisabledInSSR)()) (0, $b2Ka1.hydrate)($1ae76329d4fcbe5c$export$205bc258834dc08(), container);
    else (0, $b2Ka1.render)($1ae76329d4fcbe5c$export$205bc258834dc08(), container);
};

});
parcelRegister("5F0K9", function(module, exports) {
$parcel$export(module.exports, "createRoot", () => $41f15bb79d8282cb$export$882461b6382ed46c, (v) => $41f15bb79d8282cb$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $41f15bb79d8282cb$export$757ceba2d55c277e, (v) => $41f15bb79d8282cb$export$757ceba2d55c277e = v);
var $41f15bb79d8282cb$export$882461b6382ed46c;
var $41f15bb79d8282cb$export$757ceba2d55c277e;
'use strict';

var $b2Ka1 = parcelRequire("b2Ka1");
var $41f15bb79d8282cb$var$i;
$41f15bb79d8282cb$export$882461b6382ed46c = $b2Ka1.createRoot;
$41f15bb79d8282cb$export$757ceba2d55c277e = $b2Ka1.hydrateRoot;

});

parcelRegister("aPBSl", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("iF3ru")).LooselyLazy);
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("60vf0")).lazyForPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("60vf0")).lazy);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("krkMu")).LazyWait);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("lnVYE")).LazySuspense);
parcelRequire("4rsdf");
var $7DIFb = parcelRequire("7DIFb");

var $iF3ru = parcelRequire("iF3ru");

var $60vf0 = parcelRequire("60vf0");
parcelRequire("1jZ0n");
var $krkMu = parcelRequire("krkMu");
parcelRequire("hURLi");
var $lnVYE = parcelRequire("lnVYE");

var $9CX8v = parcelRequire("9CX8v");

var $a7Frm = parcelRequire("a7Frm");

});
parcelRegister("4rsdf", function(module, exports) {
$parcel$export(module.exports, "getConfig", () => $33bf917dafcb8865$export$44487a86467333c3);
$parcel$export(module.exports, "setConfig", () => $33bf917dafcb8865$export$940a7873bb071df8);
$parcel$export(module.exports, "MODE", () => (parcelRequire("7DIFb")).MODE);

var $7DIFb = parcelRequire("7DIFb");
const $33bf917dafcb8865$var$DEFAULT_CROSS_ORIGIN = undefined;
const $33bf917dafcb8865$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $33bf917dafcb8865$var$DEFAULT_MODE = (0, $7DIFb.MODE).HYDRATE;
const $33bf917dafcb8865$var$DEFAULT_RETRY = 2;
const $33bf917dafcb8865$var$config = {
    crossOrigin: $33bf917dafcb8865$var$DEFAULT_CROSS_ORIGIN,
    manifest: $33bf917dafcb8865$var$DEFAULT_MANIFEST,
    mode: $33bf917dafcb8865$var$DEFAULT_MODE,
    retry: $33bf917dafcb8865$var$DEFAULT_RETRY
};
const $33bf917dafcb8865$export$44487a86467333c3 = ()=>$33bf917dafcb8865$var$config;
const $33bf917dafcb8865$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $33bf917dafcb8865$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $33bf917dafcb8865$var$DEFAULT_CROSS_ORIGIN;
    $33bf917dafcb8865$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $33bf917dafcb8865$var$DEFAULT_MANIFEST;
    $33bf917dafcb8865$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $33bf917dafcb8865$var$DEFAULT_MODE;
    $33bf917dafcb8865$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $33bf917dafcb8865$var$DEFAULT_RETRY;
};

});
parcelRegister("7DIFb", function(module, exports) {
$parcel$export(module.exports, "MODE", () => $58fed219bf3918f1$export$e48589d9e4824227);
const $58fed219bf3918f1$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};

});


parcelRegister("iF3ru", function(module, exports) {
$parcel$export(module.exports, "LooselyLazy", () => $d95eb9f06b33c612$export$33c5f161e1d4706);

var $8cTu7 = parcelRequire("8cTu7");

var $4rsdf = parcelRequire("4rsdf");
parcelRequire("9CX8v");
var $fEW4A = parcelRequire("fEW4A");
var $qFQSF = parcelRequire("qFQSF");

var $4SMyj = parcelRequire("4SMyj");
const $d95eb9f06b33c612$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $4rsdf.setConfig)(config);
        (0, $fEW4A.LISTENERS).length = 0;
        (0, $qFQSF.setCurrent)(0);
        if (!(0, $4SMyj.isNodeEnvironment)()) (0, $8cTu7.collect)();
    }
};

});
parcelRegister("8cTu7", function(module, exports) {
$parcel$export(module.exports, "collect", () => $5f9a7bd8fea52e06$export$bb44f104e3c54dae);

var $4rsdf = parcelRequire("4rsdf");
var $7DIFb = parcelRequire("7DIFb");

var $1rCFW = parcelRequire("1rCFW");

var $bQLcl = parcelRequire("bQLcl");

var $cpS2J = parcelRequire("cpS2J");
const $5f9a7bd8fea52e06$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $4rsdf.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $7DIFb.MODE).RENDER ? (0, $bQLcl.cloneElements)(markers[i], lazyBegin) : (0, $cpS2J.refElements)(markers[i], lazyBegin);
        if ((0, $1rCFW.COLLECTED).has(lazyBegin)) (0, $1rCFW.COLLECTED).get(lazyBegin).push(value);
        else (0, $1rCFW.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};

});
parcelRegister("1rCFW", function(module, exports) {
$parcel$export(module.exports, "PHASE", () => $10d650354049c51e$export$2cc7a2eaaea7809f);
$parcel$export(module.exports, "COLLECTED", () => $10d650354049c51e$export$4831ef3968ea94ef);
const $10d650354049c51e$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $10d650354049c51e$export$4831ef3968ea94ef = new Map();

});

parcelRegister("bQLcl", function(module, exports) {
$parcel$export(module.exports, "cloneElements", () => $8a09299b2c5e1834$export$c42217d53a7ebafb);
const $8a09299b2c5e1834$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};

});

parcelRegister("cpS2J", function(module, exports) {
$parcel$export(module.exports, "refElements", () => $90a1bda61063bb41$export$c69443129766a7fc);
const $90a1bda61063bb41$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};

});


parcelRegister("9CX8v", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("qFQSF")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("qFQSF")).setCurrent);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("fEW4A")).LISTENERS);

var $qFQSF = parcelRequire("qFQSF");

var $fEW4A = parcelRequire("fEW4A");

var $7mNmq = parcelRequire("7mNmq");

});
parcelRegister("qFQSF", function(module, exports) {
$parcel$export(module.exports, "setCurrent", () => $0502e4bdc8647786$export$5f80f094fd31fffd);
$parcel$export(module.exports, "LazyPhaseContext", () => $0502e4bdc8647786$export$5a25eca35e5debcb);

var $4fqPo = parcelRequire("4fqPo");

var $1rCFW = parcelRequire("1rCFW");

var $fEW4A = parcelRequire("fEW4A");

var $7mNmq = parcelRequire("7mNmq");
let $0502e4bdc8647786$var$CURRENT_PHASE = (0, $1rCFW.PHASE).PAINT;
const $0502e4bdc8647786$export$5f80f094fd31fffd = (phase)=>{
    $0502e4bdc8647786$var$CURRENT_PHASE = phase;
    (0, $fEW4A.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $0502e4bdc8647786$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $4fqPo.createContext)({
    subscribe: (0, $7mNmq.createSubscribe)((0, $fEW4A.LISTENERS)),
    currentValue: ()=>$0502e4bdc8647786$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $0502e4bdc8647786$export$5f80f094fd31fffd((0, $1rCFW.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$0502e4bdc8647786$export$5f80f094fd31fffd((0, $1rCFW.PHASE).PAINT)
    }
});
const $0502e4bdc8647786$export$1dc361b277327f88 = ()=>{
    const v = (0, $4fqPo.useContext)($0502e4bdc8647786$export$5a25eca35e5debcb);
    return v.api;
};

});
parcelRegister("fEW4A", function(module, exports) {
$parcel$export(module.exports, "LISTENERS", () => $b667a38456c98607$export$81b9c458a026d68f);
const $b667a38456c98607$export$81b9c458a026d68f = [];

});

parcelRegister("7mNmq", function(module, exports) {
$parcel$export(module.exports, "createSubscribe", () => $55d0e08127ed7361$export$364097d812234b3f);
const $55d0e08127ed7361$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };

});



parcelRegister("4SMyj", function(module, exports) {
$parcel$export(module.exports, "getExport", () => $38e1de12ef5e1442$export$d4c07b1daf44a7f);
$parcel$export(module.exports, "displayNameFromId", () => $38e1de12ef5e1442$export$4429f98ef60d2d87);
$parcel$export(module.exports, "isNodeEnvironment", () => $38e1de12ef5e1442$export$283635c04a02cc36);
$parcel$export(module.exports, "attrToProp", () => $38e1de12ef5e1442$export$62bf630d0de3d781);
$parcel$export(module.exports, "hash", () => (parcelRequire("lotrE")).default);

var $lotrE = parcelRequire("lotrE");
const $38e1de12ef5e1442$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $38e1de12ef5e1442$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $38e1de12ef5e1442$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $38e1de12ef5e1442$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}

});
parcelRegister("lotrE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f932ae0be825704c$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $f932ae0be825704c$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});



parcelRegister("60vf0", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => $45faf9fb3b549e41$export$c952e5f94576010e);
$parcel$export(module.exports, "lazy", () => $45faf9fb3b549e41$export$488013bae63b21da);

var $2pngk = parcelRequire("2pngk");

var $4rsdf = parcelRequire("4rsdf");

var $1rCFW = parcelRequire("1rCFW");

var $4SMyj = parcelRequire("4SMyj");
var $lotrE = parcelRequire("lotrE");

var $74Trx = parcelRequire("74Trx");

var $2ivHY = parcelRequire("2ivHY");

var $5E5wn = parcelRequire("5E5wn");

var $bNacT = parcelRequire("bNacT");

var $3G08f = parcelRequire("3G08f");

var $4WRdh = parcelRequire("4WRdh");

var $lxeQq = parcelRequire("lxeQq");
function $45faf9fb3b549e41$var$_extends() {
    $45faf9fb3b549e41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45faf9fb3b549e41$var$_extends.apply(this, arguments);
}
function $45faf9fb3b549e41$var$lazyProxy(_loader, { defer: defer = (0, $1rCFW.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $4SMyj.isNodeEnvironment)();
    const dataLazyId = (0, $lotrE.default)(moduleId);
    const LazyInternal = isServer ? (0, $5E5wn.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $2ivHY.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $bNacT.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $4rsdf.getConfig)();
                return (0, $4WRdh.retry)(_loader, {
                    delay: (0, $74Trx.RETRY_DELAY),
                    factor: (0, $74Trx.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $4SMyj.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $4rsdf.getConfig)();
        return (0, $2pngk.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $1rCFW.PHASE).PAINT ? (0, $74Trx.PRIORITY).HIGH : (0, $74Trx.PRIORITY).LOW;
        return (0, $3G08f.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $45faf9fb3b549e41$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $1rCFW.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $1rCFW.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $1rCFW.PHASE).LAZY
    }
};
function $45faf9fb3b549e41$export$c952e5f94576010e(loader, opts) {
    return $45faf9fb3b549e41$var$lazyProxy(loader, $45faf9fb3b549e41$var$_extends({}, $45faf9fb3b549e41$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $45faf9fb3b549e41$export$291dd592399bdafa(loader, opts) {
    return $45faf9fb3b549e41$var$lazyProxy(loader, $45faf9fb3b549e41$var$_extends({}, $45faf9fb3b549e41$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $45faf9fb3b549e41$export$488013bae63b21da(loader, opts) {
    return $45faf9fb3b549e41$var$lazyProxy(loader, $45faf9fb3b549e41$var$_extends({}, $45faf9fb3b549e41$export$93ca5d3f8675ae4c.lazy, opts || {}));
}

});
parcelRegister("2pngk", function(module, exports) {
$parcel$export(module.exports, "getAssetUrlsFromId", () => $1c0ff5fbfa562430$export$303f43e55cf1ef2f);
const $1c0ff5fbfa562430$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};

});

parcelRegister("74Trx", function(module, exports) {
$parcel$export(module.exports, "PRIORITY", () => $5273e9fdbeb620fe$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "RETRY_DELAY", () => $5273e9fdbeb620fe$export$a339266ad71b2447);
$parcel$export(module.exports, "RETRY_FACTOR", () => $5273e9fdbeb620fe$export$ba64c908e55507fe);
const $5273e9fdbeb620fe$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $5273e9fdbeb620fe$export$a339266ad71b2447 = 300;
const $5273e9fdbeb620fe$export$ba64c908e55507fe = 1;

});

parcelRegister("2ivHY", function(module, exports) {
$parcel$export(module.exports, "createComponentClient", () => $1ac5dbd3af1ac9f9$export$6898b5504b58699a);

var $4fqPo = parcelRequire("4fqPo");

var $4rsdf = parcelRequire("4rsdf");
var $7DIFb = parcelRequire("7DIFb");

var $1rCFW = parcelRequire("1rCFW");
parcelRequire("1jZ0n");
var $8QOBb = parcelRequire("8QOBb");
parcelRequire("9CX8v");
var $qFQSF = parcelRequire("qFQSF");
parcelRequire("hURLi");
var $89WsA = parcelRequire("89WsA");

var $74Trx = parcelRequire("74Trx");

var $lxeQq = parcelRequire("lxeQq");

var $9fAG7 = parcelRequire("9fAG7");

var $kwelk = parcelRequire("kwelk");

var $3G08f = parcelRequire("3G08f");

var $a7Frm = parcelRequire("a7Frm");

var $kEN37 = parcelRequire("kEN37");
function $1ac5dbd3af1ac9f9$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $4fqPo.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $4fqPo.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $1rCFW.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $1rCFW.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $4fqPo.useContext)((0, $a7Frm.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $lxeQq.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $kEN37.useSubscription)({
            context: (0, $8QOBb.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $1rCFW.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $kEN37.useSubscription)({
                context: (0, $qFQSF.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $4fqPo.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $3G08f.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $74Trx.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $4fqPo.useContext)((0, $89WsA.LazySuspenseContext));
        (0, $4fqPo.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $1rCFW.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $4rsdf.getConfig)().mode === (0, $7DIFb.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fAG7.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kwelk.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ResolvedLazy, props);
    };
}

});
parcelRegister("1jZ0n", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("8QOBb")).WaitContext);
$parcel$export(module.exports, "LazyWait", () => (parcelRequire("krkMu")).LazyWait);

var $8QOBb = parcelRequire("8QOBb");

var $krkMu = parcelRequire("krkMu");

});
parcelRegister("8QOBb", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $671a6de947ba4944$export$9ba3fe09d15de47b);

var $4fqPo = parcelRequire("4fqPo");

var $7dpVU = parcelRequire("7dpVU");
const $671a6de947ba4944$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $4fqPo.createContext)({
    subscribe: ()=>(0, $7dpVU.noopCleanup),
    currentValue: ()=>1
});

});
parcelRegister("7dpVU", function(module, exports) {
$parcel$export(module.exports, "noopCleanup", () => $540ddd0ff60f8215$export$276c7dbda7675aec);
const $540ddd0ff60f8215$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};

});


parcelRegister("krkMu", function(module, exports) {
$parcel$export(module.exports, "LazyWait", () => $ee1672f31e6e6ce2$export$7bf6cf03fd32cddb);

var $4fqPo = parcelRequire("4fqPo");

var $8QOBb = parcelRequire("8QOBb");
const $ee1672f31e6e6ce2$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $4fqPo.useContext)((0, $8QOBb.WaitContext));
    const value = (0, $4fqPo.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $4fqPo.useRef)(new Set());
    const api = (0, $4fqPo.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $4fqPo.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8QOBb.WaitContext).Provider, {
        value: api.current
    }, children);
};

});


parcelRegister("hURLi", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("lnVYE")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("89WsA")).LazySuspenseContext);

var $lnVYE = parcelRequire("lnVYE");

var $89WsA = parcelRequire("89WsA");

});
parcelRegister("lnVYE", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $f918b807f4729054$export$256c542058532d6f);

var $4fqPo = parcelRequire("4fqPo");

var $4SMyj = parcelRequire("4SMyj");

var $89WsA = parcelRequire("89WsA");
class $f918b807f4729054$export$256c542058532d6f extends (0, $4fqPo.Component) {
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $4fqPo.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $89WsA.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $89WsA.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $4SMyj.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
}

});
parcelRegister("89WsA", function(module, exports) {
$parcel$export(module.exports, "LazySuspenseContext", () => $5f0c82ecbd0be9dd$export$c33990e84065970c);

var $4fqPo = parcelRequire("4fqPo");
const $5f0c82ecbd0be9dd$export$c33990e84065970c = /*#__PURE__*/ (0, $4fqPo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});

});



parcelRegister("lxeQq", function(module, exports) {
$parcel$export(module.exports, "createLoaderError", () => $fad831d997f4e16a$export$c73a6a6f0bf7d425);
const $fad831d997f4e16a$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $fad831d997f4e16a$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$fad831d997f4e16a$export$6aa69c1258005366]: true
    });
    return error;
};
const $fad831d997f4e16a$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($fad831d997f4e16a$export$6aa69c1258005366);

});

parcelRegister("9fAG7", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackRender", () => $6bc1f74dc3b5ca3d$export$d55db778a3e1446b);

var $4fqPo = parcelRequire("4fqPo");
function $6bc1f74dc3b5ca3d$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $6bc1f74dc3b5ca3d$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $4fqPo.useRef)(null);
    const { current: ssrDomNodes } = (0, $4fqPo.useRef)(content || []);
    (0, $4fqPo.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($6bc1f74dc3b5ca3d$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $6bc1f74dc3b5ca3d$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $6bc1f74dc3b5ca3d$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};

});

parcelRegister("kwelk", function(module, exports) {
$parcel$export(module.exports, "PlaceholderFallbackHydrate", () => $ef01ec0223556209$export$ca5b8fbc835d95e4);

var $4fqPo = parcelRequire("4fqPo");

var $4SMyj = parcelRequire("4SMyj");
function $ef01ec0223556209$var$_extends() {
    $ef01ec0223556209$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef01ec0223556209$var$_extends.apply(this, arguments);
}
const $ef01ec0223556209$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $4SMyj.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $4fqPo.createElement)((0, $4fqPo.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $4fqPo.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $4fqPo.createElement)(tagName.toLowerCase(), $ef01ec0223556209$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};

});

parcelRegister("3G08f", function(module, exports) {
$parcel$export(module.exports, "preloadAsset", () => $2ad5658d0c4af0c6$export$25bad4aa00c45355);

var $2pngk = parcelRequire("2pngk");

var $7dpVU = parcelRequire("7dpVU");

var $4rsdf = parcelRequire("4rsdf");

var $4SMyj = parcelRequire("4SMyj");

var $74Trx = parcelRequire("74Trx");

var $gOpbE = parcelRequire("gOpbE");

var $a7Frm = parcelRequire("a7Frm");
function $2ad5658d0c4af0c6$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $4rsdf.getConfig)();
    const assets = (0, $2pngk.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $gOpbE.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $2ad5658d0c4af0c6$var$fakePromise = {
    then: ()=>$2ad5658d0c4af0c6$var$fakePromise,
    catch: ()=>$2ad5658d0c4af0c6$var$fakePromise,
    finally: ()=>$2ad5658d0c4af0c6$var$fakePromise
};
function $2ad5658d0c4af0c6$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $gOpbE.insertLinkTag)(href, rel));
        return $2ad5658d0c4af0c6$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $2ad5658d0c4af0c6$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $7dpVU.noopCleanup;
}
function $2ad5658d0c4af0c6$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $4SMyj.isNodeEnvironment)()) return 0, $7dpVU.noopCleanup;
    (_GlobalReactLooselyLa = (0, $a7Frm.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $74Trx.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $2ad5658d0c4af0c6$export$3af04dbcb01bad4d,
        $2ad5658d0c4af0c6$export$1046fd6a49d5e7a,
        $2ad5658d0c4af0c6$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $7dpVU.noopCleanup;
}

});
parcelRegister("gOpbE", function(module, exports) {
$parcel$export(module.exports, "insertLinkTag", () => $c3d4da78deca8f98$export$6610512821c8a4ce);

var $a7Frm = parcelRequire("a7Frm");

var $7dpVU = parcelRequire("7dpVU");

var $4rsdf = parcelRequire("4rsdf");
function $c3d4da78deca8f98$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $7dpVU.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $4rsdf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $a7Frm.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}

});
parcelRegister("a7Frm", function(module, exports) {
$parcel$export(module.exports, "GlobalReactLooselyLazyProfiler", () => $75eab407deac9fad$export$e2d53c0cbedd2710);
$parcel$export(module.exports, "ProfilerContext", () => $75eab407deac9fad$export$8146ab57a3f7a7cb);

var $4fqPo = parcelRequire("4fqPo");
const $75eab407deac9fad$export$e2d53c0cbedd2710 = {
    current: null
};
const $75eab407deac9fad$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $4fqPo.createContext)($75eab407deac9fad$export$e2d53c0cbedd2710);

});



parcelRegister("kEN37", function(module, exports) {
$parcel$export(module.exports, "useSubscription", () => $f09d973e9a45ccd2$export$368b4214baeb914c);

var $4fqPo = parcelRequire("4fqPo");
function $f09d973e9a45ccd2$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $4fqPo.useContext)(context);
    (0, $4fqPo.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

});


parcelRegister("5E5wn", function(module, exports) {
$parcel$export(module.exports, "createComponentServer", () => $41c4f8922f90c652$export$eb2e4b04351cdd9e);

var $2pngk = parcelRequire("2pngk");

var $4fqPo = parcelRequire("4fqPo");

var $4rsdf = parcelRequire("4rsdf");

var $1rCFW = parcelRequire("1rCFW");
parcelRequire("hURLi");
var $89WsA = parcelRequire("89WsA");

var $4SMyj = parcelRequire("4SMyj");

var $lxeQq = parcelRequire("lxeQq");
function $41c4f8922f90c652$var$load(moduleId, loader) {
    try {
        return (0, $4SMyj.getExport)(loader());
    } catch (err) {
        throw (0, $lxeQq.createLoaderError)(err);
    }
}
function $41c4f8922f90c652$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $41c4f8922f90c652$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $4fqPo.useContext)((0, $89WsA.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $4rsdf.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $1rCFW.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $2pngk.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("link", {
                key: url,
                rel: defer === (0, $1rCFW.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}

});

parcelRegister("bNacT", function(module, exports) {
$parcel$export(module.exports, "createDeferred", () => $895c3036f2698218$export$e673efccd97e4223);
const $895c3036f2698218$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};

});

parcelRegister("4WRdh", function(module, exports) {
$parcel$export(module.exports, "retry", () => $39a5db3f0472cc5a$export$9369b12211e1fce4);
const $39a5db3f0472cc5a$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $39a5db3f0472cc5a$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $39a5db3f0472cc5a$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $39a5db3f0472cc5a$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $39a5db3f0472cc5a$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $39a5db3f0472cc5a$var$calculateDelay(context, policy);
        if (delay) await $39a5db3f0472cc5a$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}

});



parcelRegister("6UDG7", function(module, exports) {
$parcel$export(module.exports, "ModelsCache", () => $f133f9bca26e2032$export$6525a85e50433f6b);

var $63sfu = parcelRequire("63sfu");

var $618GC = parcelRequire("618GC");

var $kXlzl = parcelRequire("kXlzl");

var $9mQxZ = parcelRequire("9mQxZ");
const $f133f9bca26e2032$var$TEN_MINUTE_TIMEOUT = 600;
const $f133f9bca26e2032$var$createCacheOperationalPayload = (modelType, cacheEventType)=>{
    return {
        action: cacheEventType,
        actionSubject: 'model-caches',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $f133f9bca26e2032$var$fireCacheMissOperationalEvent = (modelType)=>{
    (0, $kXlzl.operationalEvent)($f133f9bca26e2032$var$createCacheOperationalPayload(modelType, 'cache-missed'));
};
const $f133f9bca26e2032$var$fireCacheHitOperationalEvent = (modelType)=>{
    (0, $kXlzl.operationalEvent)($f133f9bca26e2032$var$createCacheOperationalPayload(modelType, 'cache-hit'));
};
class $f133f9bca26e2032$export$6525a85e50433f6b {
    constructor(){
        /**
   * We will cache the user model later after splitting it into two; a static component and one for dynamic data such
   * as counts.
   */ this.toCacheModels = [
            'helpCenterBranding',
            'suggestedRequestTypes',
            'organisations',
            'portalsAndRequestTypes',
            ...this.addNewModelsToCache()
        ];
        const cacheTTL = $f133f9bca26e2032$var$TEN_MINUTE_TIMEOUT;
        this.cache = new (0, (/*@__PURE__*/$parcel$interopDefault($618GC)))({
            stdTTL: cacheTTL,
            checkperiod: cacheTTL * 0.5,
            useClones: false
        });
    }
    static getInstance() {
        if (!$f133f9bca26e2032$export$6525a85e50433f6b.instance) $f133f9bca26e2032$export$6525a85e50433f6b.instance = new $f133f9bca26e2032$export$6525a85e50433f6b();
        return $f133f9bca26e2032$export$6525a85e50433f6b.instance;
    }
    shouldCache(modelType) {
        return this.toCacheModels.includes(modelType);
    }
    getFromCache(request) {
        const cachedResult = this.getFromCacheInternal(request);
        if (cachedResult !== undefined) $f133f9bca26e2032$var$fireCacheHitOperationalEvent(request.type);
        else $f133f9bca26e2032$var$fireCacheMissOperationalEvent(request.type);
        return cachedResult;
    }
    getFromCacheInternal(request) {
        const requestCacheEntries = this.cache.get(request.type) || [];
        return requestCacheEntries.find((cacheEntry)=>(0, $63sfu.isEqual)(cacheEntry.request, request));
    }
    putToCache(request, modelsResponse) {
        const fromCache = this.getFromCacheInternal(request);
        if (fromCache === undefined) {
            const requests = this.cache.get(request.type) || [];
            requests.push({
                request: request,
                response: modelsResponse
            });
            this.cache.set(request.type, requests);
        }
    }
    del(modelType) {
        this.cache.del(modelType);
    }
    /**
   * Initialise model cache with models contained in jsonPayload div.
   * This avoids loading them again during app init.
   *
   * Note that this implementation assumes model requests during initial page loads don't contain any parameters
   * other than the modelType.
   */ initFromInitialJsonPayload() {
        const initialModelState = (0, $9mQxZ.default)();
        for (const modelTypeStr of Object.keys(initialModelState)){
            const modelType = modelTypeStr;
            if ($f133f9bca26e2032$export$6525a85e50433f6b.getInstance().shouldCache(modelType)) $f133f9bca26e2032$export$6525a85e50433f6b.getInstance().putToCache({
                type: modelType,
                params: {}
            }, // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            {
                [modelType]: initialModelState[modelType]
            });
        }
    }
    addNewModelsToCache() {
        return [
            'portal',
            'branding',
            'portalWebFragments',
            'user'
        ];
    }
}

});
parcelRegister("618GC", function(module, exports) {

/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var exports;
    exports = module.exports = (parcelRequire("6Syhb"));
    exports.version = '5.1.2';
}).call(module.exports);

});
parcelRegister("6Syhb", function(module, exports) {

var $b10r2 = parcelRequire("b10r2");
var $50225fbf3074266d$require$Buffer = $b10r2.Buffer;


/*
 * node-cache 5.1.2 ( 2020-07-01 )
 * https://github.com/node-cache/node-cache
 *
 * Released under the MIT license
 * https://github.com/node-cache/node-cache/blob/master/LICENSE
 *
 * Maintained by  (  )
*/ (function() {
    var EventEmitter, NodeCache, clone, splice = [].splice, boundMethodCheck = function(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new Error('Bound instance method accessed before binding');
    }, indexOf = [].indexOf;
    clone = (parcelRequire("eDnSr"));
    EventEmitter = (parcelRequire("fRMcu")).EventEmitter;
    // generate superclass
    module.exports = NodeCache = (function() {
        class NodeCache extends EventEmitter {
            constructor(options = {}){
                super();
                // ## get
                // get a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.get "myKey", ( err, val )
                this.get = this.get.bind(this);
                // ## mget
                // get multiple cached keys at once and change the stats
                // **Parameters:**
                // * `keys` ( String|Number[] ): an array of keys
                // **Example:**
                //	myCache.mget [ "foo", "bar" ]
                this.mget = this.mget.bind(this);
                // ## set
                // set a cached key and change the stats
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // * `value` ( Any ): A element to cache. If the option `option.forceString` is `true` the module trys to translate it to a serialized JSON
                // * `[ ttl ]` ( Number | String ): ( optional ) The time to live in seconds.
                // **Example:**
                //	myCache.set "myKey", "my_String Value"
                //	myCache.set "myKey", "my_String Value", 10
                this.set = this.set.bind(this);
                // ## mset
                // set multiple keys at once
                // **Parameters:**
                // * `keyValueSet` ( Object[] ): an array of object which includes key,value and ttl
                // **Example:**
                //	myCache.mset(
                //		[
                //			{
                //				key: "myKey",
                //				val: "myValue",
                //				ttl: [ttl in seconds]
                //			}
                //		])
                this.mset = this.mset.bind(this);
                // ## del
                // remove keys
                // **Parameters:**
                // * `keys` ( String | Number | String|Number[] ): cache key to delete or a array of cache keys
                // **Return**
                // ( Number ): Number of deleted keys
                // **Example:**
                //	myCache.del( "myKey" )
                this.del = this.del.bind(this);
                // ## take
                // get the cached value and remove the key from the cache.
                // Equivalent to calling `get(key)` + `del(key)`.
                // Useful for implementing `single use` mechanism such as OTP, where once a value is read it will become obsolete.
                // **Parameters:**
                // * `key` ( String | Number ): cache key
                // **Example:**
                //	myCache.take "myKey", ( err, val )
                this.take = this.take.bind(this);
                // ## ttl
                // reset or redefine the ttl of a key. `ttl` = 0 means infinite lifetime.
                // If `ttl` is not passed the default ttl is used.
                // If `ttl` < 0 the key will be deleted.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to reset the ttl value
                // * `ttl` ( Number ): ( optional -> options.stdTTL || 0 ) The time to live in seconds
                // **Return**
                // ( Boolen ): key found and ttl set
                // **Example:**
                //	myCache.ttl( "myKey" ) // will set ttl to default ttl
                //	myCache.ttl( "myKey", 1000 )
                this.ttl = this.ttl.bind(this);
                // ## getTtl
                // receive the ttl of a key.
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Number|undefined ): The timestamp in ms when the key will expire, 0 if it will never expire or undefined if it not exists
                // **Example:**
                //	myCache.getTtl( "myKey" )
                this.getTtl = this.getTtl.bind(this);
                // ## keys
                // list all keys within this cache
                // **Return**
                // ( Array ): An array of all keys
                // **Example:**
                //     _keys = myCache.keys()
                //     # [ "foo", "bar", "fizz", "buzz", "anotherKeys" ]
                this.keys = this.keys.bind(this);
                // ## has
                // Check if a key is cached
                // **Parameters:**
                // * `key` ( String | Number ): cache key to check the ttl value
                // **Return**
                // ( Boolean ): A boolean that indicates if the key is cached
                // **Example:**
                //     _exists = myCache.has('myKey')
                //     # true
                this.has = this.has.bind(this);
                // ## getStats
                // get the stats
                // **Parameters:**
                // -
                // **Return**
                // ( Object ): Stats data
                // **Example:**
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.getStats = this.getStats.bind(this);
                // ## flushAll
                // flush the whole data and reset the stats
                // **Example:**
                //     myCache.flushAll()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushAll = this.flushAll.bind(this);
                // ## flushStats
                // flush the stats and reset all counters to 0
                // **Example:**
                //     myCache.flushStats()
                //     myCache.getStats()
                //     # {
                //     # hits: 0,
                //     # misses: 0,
                //     # keys: 0,
                //     # ksize: 0,
                //     # vsize: 0
                //     # }
                this.flushStats = this.flushStats.bind(this);
                // ## close
                // This will clear the interval timeout which is set on checkperiod option.
                // **Example:**
                //     myCache.close()
                this.close = this.close.bind(this);
                // ## _checkData
                // internal housekeeping method.
                // Check all the cached data and delete the invalid values
                this._checkData = this._checkData.bind(this);
                // ## _check
                // internal method the check the value. If it's not valid any more delete it
                this._check = this._check.bind(this);
                // ## _isInvalidKey
                // internal method to check if the type of a key is either `number` or `string`
                this._isInvalidKey = this._isInvalidKey.bind(this);
                // ## _wrap
                // internal method to wrap a value in an object with some metadata
                this._wrap = this._wrap.bind(this);
                // ## _getValLength
                // internal method to calculate the value length
                this._getValLength = this._getValLength.bind(this);
                // ## _error
                // internal method to handle an error message
                this._error = this._error.bind(this);
                // ## _initErrors
                // internal method to generate error message templates
                this._initErrors = this._initErrors.bind(this);
                this.options = options;
                this._initErrors();
                // container for cached data
                this.data = {};
                // module options
                this.options = Object.assign({
                    // convert all elements to string
                    forceString: false,
                    // used standard size for calculating value size
                    objectValueSize: 80,
                    promiseValueSize: 80,
                    arrayValueSize: 40,
                    // standard time to live in seconds. 0 = infinity;
                    stdTTL: 0,
                    // time in seconds to check all data and delete expired keys
                    checkperiod: 600,
                    // en/disable cloning of variables. If `true` you'll get a copy of the cached variable. If `false` you'll save and get just the reference
                    useClones: true,
                    // whether values should be deleted automatically at expiration
                    deleteOnExpire: true,
                    // enable legacy callbacks
                    enableLegacyCallbacks: false,
                    // max amount of keys that are being stored
                    maxKeys: -1
                }, this.options);
                // generate functions with callbacks (legacy)
                if (this.options.enableLegacyCallbacks) {
                    console.warn("WARNING! node-cache legacy callback support will drop in v6.x");
                    [
                        "get",
                        "mget",
                        "set",
                        "del",
                        "ttl",
                        "getTtl",
                        "keys",
                        "has"
                    ].forEach((methodKey)=>{
                        var oldMethod;
                        // reference real function
                        oldMethod = this[methodKey];
                        this[methodKey] = function(...args) {
                            var cb, err, ref, res;
                            ref = args, [...args] = ref, [cb] = splice.call(args, -1);
                            // return a callback if cb is defined and a function
                            if (typeof cb === "function") try {
                                res = oldMethod(...args);
                                cb(null, res);
                            } catch (error1) {
                                err = error1;
                                cb(err);
                            }
                            else return oldMethod(...args, cb);
                        };
                    });
                }
                // statistics container
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // pre allocate valid keytypes array
                this.validKeyTypes = [
                    "string",
                    "number"
                ];
                // initalize checking period
                this._checkData();
                return;
            }
            get(key) {
                var _ret, err;
                boundMethodCheck(this, NodeCache);
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // get data and incremet stats
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    this.stats.hits++;
                    _ret = this._unwrap(this.data[key]);
                    // return data
                    return _ret;
                } else {
                    // if not found return undefined
                    this.stats.misses++;
                    return void 0;
                }
            }
            mget(keys) {
                var _err, err, i, key, len, oRet;
                boundMethodCheck(this, NodeCache);
                // convert a string to an array of one key
                if (!Array.isArray(keys)) {
                    _err = this._error("EKEYSTYPE");
                    throw _err;
                }
                // define return
                oRet = {};
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // get data and increment stats
                    if (this.data[key] != null && this._check(key, this.data[key])) {
                        this.stats.hits++;
                        oRet[key] = this._unwrap(this.data[key]);
                    } else // if not found return a error
                    this.stats.misses++;
                }
                // return all found keys
                return oRet;
            }
            set(key, value, ttl) {
                var _err, err, existent;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // force the data to string
                this.options.forceString;
                // set default ttl if not passed
                if (ttl == null) ttl = this.options.stdTTL;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // internal helper variables
                existent = false;
                // remove existing data from stats
                if (this.data[key]) {
                    existent = true;
                    this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                }
                // set the value
                this.data[key] = this._wrap(value, ttl);
                this.stats.vsize += this._getValLength(value);
                // only add the keys and key-size if the key is new
                if (!existent) {
                    this.stats.ksize += this._getKeyLength(key);
                    this.stats.keys++;
                }
                this.emit("set", key, value);
                // return true
                return true;
            }
            mset(keyValueSet) {
                var _err, err, i, j, key, keyValuePair, len, len1, ttl, val;
                boundMethodCheck(this, NodeCache);
                // check if cache is overflowing
                if (this.options.maxKeys > -1 && this.stats.keys + keyValueSet.length >= this.options.maxKeys) {
                    _err = this._error("ECACHEFULL");
                    throw _err;
                }
                // loop over keyValueSet to validate key and ttl
                for(i = 0, len = keyValueSet.length; i < len; i++){
                    keyValuePair = keyValueSet[i];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    // check if there is ttl and it's a number
                    if (ttl && typeof ttl !== "number") {
                        _err = this._error("ETTLTYPE");
                        throw _err;
                    }
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                }
                for(j = 0, len1 = keyValueSet.length; j < len1; j++){
                    keyValuePair = keyValueSet[j];
                    ({ key: key, val: val, ttl: ttl } = keyValuePair);
                    this.set(key, val, ttl);
                }
                return true;
            }
            del(keys) {
                var delCount, err, i, key, len, oldVal;
                boundMethodCheck(this, NodeCache);
                // convert keys to an array of itself
                if (!Array.isArray(keys)) keys = [
                    keys
                ];
                delCount = 0;
                for(i = 0, len = keys.length; i < len; i++){
                    key = keys[i];
                    // handle invalid key types
                    if ((err = this._isInvalidKey(key)) != null) throw err;
                    // only delete if existent
                    if (this.data[key] != null) {
                        // calc the stats
                        this.stats.vsize -= this._getValLength(this._unwrap(this.data[key], false));
                        this.stats.ksize -= this._getKeyLength(key);
                        this.stats.keys--;
                        delCount++;
                        // delete the value
                        oldVal = this.data[key];
                        delete this.data[key];
                        // return true
                        this.emit("del", key, oldVal.v);
                    }
                }
                return delCount;
            }
            take(key) {
                var _ret;
                boundMethodCheck(this, NodeCache);
                _ret = this.get(key);
                if (_ret != null) this.del(key);
                return _ret;
            }
            ttl(key, ttl) {
                var err;
                boundMethodCheck(this, NodeCache);
                ttl || (ttl = this.options.stdTTL);
                if (!key) return false;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existent data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    // if ttl < 0 delete the key. otherwise reset the value
                    if (ttl >= 0) this.data[key] = this._wrap(this.data[key].v, ttl, false);
                    else this.del(key);
                    return true;
                } else // return false if key has not been found
                return false;
            }
            getTtl(key) {
                var _ttl, err;
                boundMethodCheck(this, NodeCache);
                if (!key) return void 0;
                // handle invalid key types
                if ((err = this._isInvalidKey(key)) != null) throw err;
                // check for existant data and update the ttl value
                if (this.data[key] != null && this._check(key, this.data[key])) {
                    _ttl = this.data[key].t;
                    return _ttl;
                } else // return undefined if key has not been found
                return void 0;
            }
            keys() {
                var _keys;
                boundMethodCheck(this, NodeCache);
                _keys = Object.keys(this.data);
                return _keys;
            }
            has(key) {
                var _exists;
                boundMethodCheck(this, NodeCache);
                _exists = this.data[key] != null && this._check(key, this.data[key]);
                return _exists;
            }
            getStats() {
                boundMethodCheck(this, NodeCache);
                return this.stats;
            }
            flushAll(_startPeriod = true) {
                boundMethodCheck(this, NodeCache);
                // parameter just for testing
                // set data empty
                this.data = {};
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                // reset check period
                this._killCheckPeriod();
                this._checkData(_startPeriod);
                this.emit("flush");
            }
            flushStats() {
                boundMethodCheck(this, NodeCache);
                // reset stats
                this.stats = {
                    hits: 0,
                    misses: 0,
                    keys: 0,
                    ksize: 0,
                    vsize: 0
                };
                this.emit("flush_stats");
            }
            close() {
                boundMethodCheck(this, NodeCache);
                this._killCheckPeriod();
            }
            _checkData(startPeriod = true) {
                var key, ref, value;
                boundMethodCheck(this, NodeCache);
                ref = this.data;
                // run the housekeeping method
                for(key in ref){
                    value = ref[key];
                    this._check(key, value);
                }
                if (startPeriod && this.options.checkperiod > 0) {
                    this.checkTimeout = setTimeout(this._checkData, this.options.checkperiod * 1000, startPeriod);
                    if (this.checkTimeout != null && this.checkTimeout.unref != null) this.checkTimeout.unref();
                }
            }
            // ## _killCheckPeriod
            // stop the checkdata period. Only needed to abort the script in testing mode.
            _killCheckPeriod() {
                if (this.checkTimeout != null) return clearTimeout(this.checkTimeout);
            }
            _check(key, data) {
                var _retval;
                boundMethodCheck(this, NodeCache);
                _retval = true;
                // data is invalid if the ttl is too old and is not 0
                // console.log data.t < Date.now(), data.t, Date.now()
                if (data.t !== 0 && data.t < Date.now()) {
                    if (this.options.deleteOnExpire) {
                        _retval = false;
                        this.del(key);
                    }
                    this.emit("expired", key, this._unwrap(data));
                }
                return _retval;
            }
            _isInvalidKey(key) {
                var ref;
                boundMethodCheck(this, NodeCache);
                if (ref = typeof key, indexOf.call(this.validKeyTypes, ref) < 0) return this._error("EKEYTYPE", {
                    type: typeof key
                });
            }
            _wrap(value, ttl, asClone = true) {
                var livetime, now, oReturn, ttlMultiplicator;
                boundMethodCheck(this, NodeCache);
                if (!this.options.useClones) asClone = false;
                // define the time to live
                now = Date.now();
                livetime = 0;
                ttlMultiplicator = 1000;
                // use given ttl
                if (ttl === 0) livetime = 0;
                else if (ttl) livetime = now + ttl * ttlMultiplicator;
                else // use standard ttl
                if (this.options.stdTTL === 0) livetime = this.options.stdTTL;
                else livetime = now + this.options.stdTTL * ttlMultiplicator;
                // return the wrapped value
                return oReturn = {
                    t: livetime,
                    v: asClone ? clone(value) : value
                };
            }
            // ## _unwrap
            // internal method to extract get the value out of the wrapped value
            _unwrap(value, asClone = true) {
                if (!this.options.useClones) asClone = false;
                if (value.v != null) {
                    if (asClone) return clone(value.v);
                    else return value.v;
                }
                return null;
            }
            // ## _getKeyLength
            // internal method the calculate the key length
            _getKeyLength(key) {
                return key.toString().length;
            }
            _getValLength(value) {
                boundMethodCheck(this, NodeCache);
                if (typeof value === "string") // if the value is a String get the real length
                return value.length;
                else if (this.options.forceString) // force string if it's defined and not passed
                return JSON.stringify(value).length;
                else if (Array.isArray(value)) // if the data is an Array multiply each element with a defined default length
                return this.options.arrayValueSize * value.length;
                else if (typeof value === "number") return 8;
                else if (typeof (value != null ? value.then : void 0) === "function") // if the data is a Promise, use defined default
                // (can't calculate actual/resolved value size synchronously)
                return this.options.promiseValueSize;
                else if (typeof $50225fbf3074266d$require$Buffer !== "undefined" && $50225fbf3074266d$require$Buffer !== null ? $50225fbf3074266d$require$Buffer.isBuffer(value) : void 0) return value.length;
                else if (value != null && typeof value === "object") // if the data is an Object multiply each element with a defined default length
                return this.options.objectValueSize * Object.keys(value).length;
                else if (typeof value === "boolean") return 8;
                else // default fallback
                return 0;
            }
            _error(type, data = {}) {
                var error;
                boundMethodCheck(this, NodeCache);
                // generate the error object
                error = new Error();
                error.name = type;
                error.errorcode = type;
                error.message = this.ERRORS[type] != null ? this.ERRORS[type](data) : "-";
                error.data = data;
                // return the error object
                return error;
            }
            _initErrors() {
                var _errMsg, _errT, ref;
                boundMethodCheck(this, NodeCache);
                this.ERRORS = {};
                ref = this._ERRORS;
                for(_errT in ref){
                    _errMsg = ref[_errT];
                    this.ERRORS[_errT] = this.createErrorMessage(_errMsg);
                }
            }
            createErrorMessage(errMsg) {
                return function(args) {
                    return errMsg.replace("__key", args.type);
                };
            }
        }
        NodeCache.prototype._ERRORS = {
            "ENOTFOUND": "Key `__key` not found",
            "ECACHEFULL": "Cache max keys amount exceeded",
            "EKEYTYPE": "The key argument has to be of type `string` or `number`. Found: `__key`",
            "EKEYSTYPE": "The keys argument has to be an array.",
            "ETTLTYPE": "The ttl argument has to be a number."
        };
        return NodeCache;
    }).call(this);
}).call(module.exports);

});
parcelRegister("b10r2", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $8050201cc17cdd8b$export$a143d493d941bafc, (v) => $8050201cc17cdd8b$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $8050201cc17cdd8b$export$e4cf37d7f6fb9e0a, (v) => $8050201cc17cdd8b$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $8050201cc17cdd8b$export$f99ded8fe4b79145, (v) => $8050201cc17cdd8b$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $8050201cc17cdd8b$export$599f31c3813fae4d, (v) => $8050201cc17cdd8b$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8050201cc17cdd8b$export$a143d493d941bafc;
var $8050201cc17cdd8b$export$e4cf37d7f6fb9e0a;
var $8050201cc17cdd8b$export$f99ded8fe4b79145;
var $8050201cc17cdd8b$export$599f31c3813fae4d;
'use strict';

var $b69l3 = parcelRequire("b69l3");

var $dLYGs = parcelRequire("dLYGs");
var $8050201cc17cdd8b$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8050201cc17cdd8b$export$a143d493d941bafc = $8050201cc17cdd8b$var$Buffer;
$8050201cc17cdd8b$export$e4cf37d7f6fb9e0a = $8050201cc17cdd8b$var$SlowBuffer;
$8050201cc17cdd8b$export$f99ded8fe4b79145 = 50;
var $8050201cc17cdd8b$var$K_MAX_LENGTH = 0x7fffffff;
$8050201cc17cdd8b$export$599f31c3813fae4d = $8050201cc17cdd8b$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8050201cc17cdd8b$var$Buffer.TYPED_ARRAY_SUPPORT = $8050201cc17cdd8b$var$typedArraySupport();
if (!$8050201cc17cdd8b$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8050201cc17cdd8b$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8050201cc17cdd8b$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8050201cc17cdd8b$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8050201cc17cdd8b$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8050201cc17cdd8b$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8050201cc17cdd8b$var$createBuffer(length) {
    if (length > $8050201cc17cdd8b$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8050201cc17cdd8b$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8050201cc17cdd8b$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8050201cc17cdd8b$var$allocUnsafe(arg);
    }
    return $8050201cc17cdd8b$var$from(arg, encodingOrOffset, length);
}
$8050201cc17cdd8b$var$Buffer.poolSize = 8192; // not used by this implementation
function $8050201cc17cdd8b$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8050201cc17cdd8b$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8050201cc17cdd8b$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8050201cc17cdd8b$var$isInstance(value, ArrayBuffer) || value && $8050201cc17cdd8b$var$isInstance(value.buffer, ArrayBuffer)) return $8050201cc17cdd8b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8050201cc17cdd8b$var$isInstance(value, SharedArrayBuffer) || value && $8050201cc17cdd8b$var$isInstance(value.buffer, SharedArrayBuffer))) return $8050201cc17cdd8b$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8050201cc17cdd8b$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $8050201cc17cdd8b$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8050201cc17cdd8b$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8050201cc17cdd8b$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8050201cc17cdd8b$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8050201cc17cdd8b$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8050201cc17cdd8b$var$Buffer, Uint8Array);
function $8050201cc17cdd8b$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8050201cc17cdd8b$var$alloc(size, fill, encoding) {
    $8050201cc17cdd8b$var$assertSize(size);
    if (size <= 0) return $8050201cc17cdd8b$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8050201cc17cdd8b$var$createBuffer(size).fill(fill, encoding) : $8050201cc17cdd8b$var$createBuffer(size).fill(fill);
    return $8050201cc17cdd8b$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8050201cc17cdd8b$var$Buffer.alloc = function(size, fill, encoding) {
    return $8050201cc17cdd8b$var$alloc(size, fill, encoding);
};
function $8050201cc17cdd8b$var$allocUnsafe(size) {
    $8050201cc17cdd8b$var$assertSize(size);
    return $8050201cc17cdd8b$var$createBuffer(size < 0 ? 0 : $8050201cc17cdd8b$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8050201cc17cdd8b$var$Buffer.allocUnsafe = function(size) {
    return $8050201cc17cdd8b$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8050201cc17cdd8b$var$Buffer.allocUnsafeSlow = function(size) {
    return $8050201cc17cdd8b$var$allocUnsafe(size);
};
function $8050201cc17cdd8b$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8050201cc17cdd8b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $8050201cc17cdd8b$var$byteLength(string, encoding) | 0;
    var buf = $8050201cc17cdd8b$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8050201cc17cdd8b$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $8050201cc17cdd8b$var$checked(array.length) | 0;
    var buf = $8050201cc17cdd8b$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8050201cc17cdd8b$var$fromArrayView(arrayView) {
    if ($8050201cc17cdd8b$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $8050201cc17cdd8b$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8050201cc17cdd8b$var$fromArrayLike(arrayView);
}
function $8050201cc17cdd8b$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8050201cc17cdd8b$var$Buffer.prototype);
    return buf;
}
function $8050201cc17cdd8b$var$fromObject(obj) {
    if ($8050201cc17cdd8b$var$Buffer.isBuffer(obj)) {
        var len = $8050201cc17cdd8b$var$checked(obj.length) | 0;
        var buf = $8050201cc17cdd8b$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8050201cc17cdd8b$var$numberIsNaN(obj.length)) return $8050201cc17cdd8b$var$createBuffer(0);
        return $8050201cc17cdd8b$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8050201cc17cdd8b$var$fromArrayLike(obj.data);
}
function $8050201cc17cdd8b$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8050201cc17cdd8b$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8050201cc17cdd8b$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8050201cc17cdd8b$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8050201cc17cdd8b$var$Buffer.alloc(+length);
}
$8050201cc17cdd8b$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8050201cc17cdd8b$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8050201cc17cdd8b$var$Buffer.compare = function compare(a, b) {
    if ($8050201cc17cdd8b$var$isInstance(a, Uint8Array)) a = $8050201cc17cdd8b$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8050201cc17cdd8b$var$isInstance(b, Uint8Array)) b = $8050201cc17cdd8b$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8050201cc17cdd8b$var$Buffer.isBuffer(a) || !$8050201cc17cdd8b$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8050201cc17cdd8b$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8050201cc17cdd8b$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8050201cc17cdd8b$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $8050201cc17cdd8b$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($8050201cc17cdd8b$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $8050201cc17cdd8b$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8050201cc17cdd8b$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8050201cc17cdd8b$var$byteLength(string, encoding) {
    if ($8050201cc17cdd8b$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8050201cc17cdd8b$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8050201cc17cdd8b$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8050201cc17cdd8b$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8050201cc17cdd8b$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8050201cc17cdd8b$var$Buffer.byteLength = $8050201cc17cdd8b$var$byteLength;
function $8050201cc17cdd8b$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8050201cc17cdd8b$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8050201cc17cdd8b$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8050201cc17cdd8b$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8050201cc17cdd8b$var$latin1Slice(this, start, end);
        case 'base64':
            return $8050201cc17cdd8b$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8050201cc17cdd8b$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8050201cc17cdd8b$var$Buffer.prototype._isBuffer = true;
function $8050201cc17cdd8b$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8050201cc17cdd8b$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$8050201cc17cdd8b$var$swap(this, i, i + 1);
    return this;
};
$8050201cc17cdd8b$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $8050201cc17cdd8b$var$swap(this, i, i + 3);
        $8050201cc17cdd8b$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8050201cc17cdd8b$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $8050201cc17cdd8b$var$swap(this, i, i + 7);
        $8050201cc17cdd8b$var$swap(this, i + 1, i + 6);
        $8050201cc17cdd8b$var$swap(this, i + 2, i + 5);
        $8050201cc17cdd8b$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8050201cc17cdd8b$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8050201cc17cdd8b$var$utf8Slice(this, 0, length);
    return $8050201cc17cdd8b$var$slowToString.apply(this, arguments);
};
$8050201cc17cdd8b$var$Buffer.prototype.toLocaleString = $8050201cc17cdd8b$var$Buffer.prototype.toString;
$8050201cc17cdd8b$var$Buffer.prototype.equals = function equals(b) {
    if (!$8050201cc17cdd8b$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8050201cc17cdd8b$var$Buffer.compare(this, b) === 0;
};
$8050201cc17cdd8b$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $8050201cc17cdd8b$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8050201cc17cdd8b$var$customInspectSymbol) $8050201cc17cdd8b$var$Buffer.prototype[$8050201cc17cdd8b$var$customInspectSymbol] = $8050201cc17cdd8b$var$Buffer.prototype.inspect;
$8050201cc17cdd8b$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8050201cc17cdd8b$var$isInstance(target, Uint8Array)) target = $8050201cc17cdd8b$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8050201cc17cdd8b$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8050201cc17cdd8b$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($8050201cc17cdd8b$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8050201cc17cdd8b$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8050201cc17cdd8b$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8050201cc17cdd8b$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8050201cc17cdd8b$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8050201cc17cdd8b$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8050201cc17cdd8b$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8050201cc17cdd8b$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8050201cc17cdd8b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8050201cc17cdd8b$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8050201cc17cdd8b$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8050201cc17cdd8b$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8050201cc17cdd8b$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8050201cc17cdd8b$var$utf8Write(buf, string, offset, length) {
    return $8050201cc17cdd8b$var$blitBuffer($8050201cc17cdd8b$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8050201cc17cdd8b$var$asciiWrite(buf, string, offset, length) {
    return $8050201cc17cdd8b$var$blitBuffer($8050201cc17cdd8b$var$asciiToBytes(string), buf, offset, length);
}
function $8050201cc17cdd8b$var$base64Write(buf, string, offset, length) {
    return $8050201cc17cdd8b$var$blitBuffer($8050201cc17cdd8b$var$base64ToBytes(string), buf, offset, length);
}
function $8050201cc17cdd8b$var$ucs2Write(buf, string, offset, length) {
    return $8050201cc17cdd8b$var$blitBuffer($8050201cc17cdd8b$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8050201cc17cdd8b$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8050201cc17cdd8b$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8050201cc17cdd8b$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8050201cc17cdd8b$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8050201cc17cdd8b$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8050201cc17cdd8b$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8050201cc17cdd8b$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8050201cc17cdd8b$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $b69l3.fromByteArray(buf);
    else return $b69l3.fromByteArray(buf.slice(start, end));
}
function $8050201cc17cdd8b$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8050201cc17cdd8b$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $8050201cc17cdd8b$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8050201cc17cdd8b$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $8050201cc17cdd8b$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8050201cc17cdd8b$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8050201cc17cdd8b$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8050201cc17cdd8b$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8050201cc17cdd8b$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $8050201cc17cdd8b$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8050201cc17cdd8b$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8050201cc17cdd8b$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8050201cc17cdd8b$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8050201cc17cdd8b$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8050201cc17cdd8b$var$Buffer.prototype.readUintLE = $8050201cc17cdd8b$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8050201cc17cdd8b$var$Buffer.prototype.readUintBE = $8050201cc17cdd8b$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8050201cc17cdd8b$var$Buffer.prototype.readUint8 = $8050201cc17cdd8b$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8050201cc17cdd8b$var$Buffer.prototype.readUint16LE = $8050201cc17cdd8b$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8050201cc17cdd8b$var$Buffer.prototype.readUint16BE = $8050201cc17cdd8b$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8050201cc17cdd8b$var$Buffer.prototype.readUint32LE = $8050201cc17cdd8b$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8050201cc17cdd8b$var$Buffer.prototype.readUint32BE = $8050201cc17cdd8b$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8050201cc17cdd8b$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8050201cc17cdd8b$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8050201cc17cdd8b$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8050201cc17cdd8b$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8050201cc17cdd8b$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8050201cc17cdd8b$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8050201cc17cdd8b$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8050201cc17cdd8b$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 4, this.length);
    return $dLYGs.read(this, offset, true, 23, 4);
};
$8050201cc17cdd8b$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 4, this.length);
    return $dLYGs.read(this, offset, false, 23, 4);
};
$8050201cc17cdd8b$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 8, this.length);
    return $dLYGs.read(this, offset, true, 52, 8);
};
$8050201cc17cdd8b$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkOffset(offset, 8, this.length);
    return $dLYGs.read(this, offset, false, 52, 8);
};
function $8050201cc17cdd8b$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8050201cc17cdd8b$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8050201cc17cdd8b$var$Buffer.prototype.writeUintLE = $8050201cc17cdd8b$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8050201cc17cdd8b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeUintBE = $8050201cc17cdd8b$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8050201cc17cdd8b$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeUint8 = $8050201cc17cdd8b$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeUint16LE = $8050201cc17cdd8b$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeUint16BE = $8050201cc17cdd8b$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeUint32LE = $8050201cc17cdd8b$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeUint32BE = $8050201cc17cdd8b$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8050201cc17cdd8b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8050201cc17cdd8b$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8050201cc17cdd8b$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8050201cc17cdd8b$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8050201cc17cdd8b$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $dLYGs.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8050201cc17cdd8b$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8050201cc17cdd8b$var$writeFloat(this, value, offset, true, noAssert);
};
$8050201cc17cdd8b$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8050201cc17cdd8b$var$writeFloat(this, value, offset, false, noAssert);
};
function $8050201cc17cdd8b$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8050201cc17cdd8b$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $dLYGs.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8050201cc17cdd8b$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8050201cc17cdd8b$var$writeDouble(this, value, offset, true, noAssert);
};
$8050201cc17cdd8b$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8050201cc17cdd8b$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8050201cc17cdd8b$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8050201cc17cdd8b$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8050201cc17cdd8b$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8050201cc17cdd8b$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $8050201cc17cdd8b$var$Buffer.isBuffer(val) ? val : $8050201cc17cdd8b$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $8050201cc17cdd8b$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8050201cc17cdd8b$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8050201cc17cdd8b$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8050201cc17cdd8b$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8050201cc17cdd8b$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8050201cc17cdd8b$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8050201cc17cdd8b$var$base64ToBytes(str) {
    return $b69l3.toByteArray($8050201cc17cdd8b$var$base64clean(str));
}
function $8050201cc17cdd8b$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8050201cc17cdd8b$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8050201cc17cdd8b$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $8050201cc17cdd8b$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("b69l3", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $81477fb6060b8239$export$d622b2ad8d90c771, (v) => $81477fb6060b8239$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $81477fb6060b8239$export$6100ba28696e12de, (v) => $81477fb6060b8239$export$6100ba28696e12de = v);
var $81477fb6060b8239$export$a48f0734ac7c2329;
var $81477fb6060b8239$export$d622b2ad8d90c771;
var $81477fb6060b8239$export$6100ba28696e12de;
'use strict';
$81477fb6060b8239$export$a48f0734ac7c2329 = $81477fb6060b8239$var$byteLength;
$81477fb6060b8239$export$d622b2ad8d90c771 = $81477fb6060b8239$var$toByteArray;
$81477fb6060b8239$export$6100ba28696e12de = $81477fb6060b8239$var$fromByteArray;
var $81477fb6060b8239$var$lookup = [];
var $81477fb6060b8239$var$revLookup = [];
var $81477fb6060b8239$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $81477fb6060b8239$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $81477fb6060b8239$var$i = 0, $81477fb6060b8239$var$len = $81477fb6060b8239$var$code.length; $81477fb6060b8239$var$i < $81477fb6060b8239$var$len; ++$81477fb6060b8239$var$i){
    $81477fb6060b8239$var$lookup[$81477fb6060b8239$var$i] = $81477fb6060b8239$var$code[$81477fb6060b8239$var$i];
    $81477fb6060b8239$var$revLookup[$81477fb6060b8239$var$code.charCodeAt($81477fb6060b8239$var$i)] = $81477fb6060b8239$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$81477fb6060b8239$var$revLookup['-'.charCodeAt(0)] = 62;
$81477fb6060b8239$var$revLookup['_'.charCodeAt(0)] = 63;
function $81477fb6060b8239$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $81477fb6060b8239$var$byteLength(b64) {
    var lens = $81477fb6060b8239$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $81477fb6060b8239$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $81477fb6060b8239$var$toByteArray(b64) {
    var tmp;
    var lens = $81477fb6060b8239$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $81477fb6060b8239$var$Arr($81477fb6060b8239$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $81477fb6060b8239$var$revLookup[b64.charCodeAt(i)] << 18 | $81477fb6060b8239$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $81477fb6060b8239$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $81477fb6060b8239$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $81477fb6060b8239$var$revLookup[b64.charCodeAt(i)] << 2 | $81477fb6060b8239$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $81477fb6060b8239$var$revLookup[b64.charCodeAt(i)] << 10 | $81477fb6060b8239$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $81477fb6060b8239$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $81477fb6060b8239$var$tripletToBase64(num) {
    return $81477fb6060b8239$var$lookup[num >> 18 & 0x3F] + $81477fb6060b8239$var$lookup[num >> 12 & 0x3F] + $81477fb6060b8239$var$lookup[num >> 6 & 0x3F] + $81477fb6060b8239$var$lookup[num & 0x3F];
}
function $81477fb6060b8239$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($81477fb6060b8239$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $81477fb6060b8239$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($81477fb6060b8239$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($81477fb6060b8239$var$lookup[tmp >> 2] + $81477fb6060b8239$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($81477fb6060b8239$var$lookup[tmp >> 10] + $81477fb6060b8239$var$lookup[tmp >> 4 & 0x3F] + $81477fb6060b8239$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("dLYGs", function(module, exports) {
$parcel$export(module.exports, "read", () => $a06ebca9791214c9$export$aafa59e2e03f2942, (v) => $a06ebca9791214c9$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $a06ebca9791214c9$export$68d8715fc104d294, (v) => $a06ebca9791214c9$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a06ebca9791214c9$export$aafa59e2e03f2942;
var $a06ebca9791214c9$export$68d8715fc104d294;
$a06ebca9791214c9$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a06ebca9791214c9$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("eDnSr", function(module, exports) {

var $b10r2 = parcelRequire("b10r2");
var $aa773ab41545cf51$require$Buffer = $b10r2.Buffer;
var $aa773ab41545cf51$var$clone = function() {
    'use strict';
    function _instanceof(obj, type) {
        return type != null && obj instanceof type;
    }
    var nativeMap;
    try {
        nativeMap = Map;
    } catch (_) {
        // maybe a reference error because no `Map`. Give it a dummy value that no
        // value will ever be an instanceof.
        nativeMap = function() {};
    }
    var nativeSet;
    try {
        nativeSet = Set;
    } catch (_) {
        nativeSet = function() {};
    }
    var nativePromise;
    try {
        nativePromise = Promise;
    } catch (_) {
        nativePromise = function() {};
    }
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/ function clone(parent, circular, depth, prototype, includeNonEnumerable) {
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof $aa773ab41545cf51$require$Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth === 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (_instanceof(parent, nativeMap)) child = new nativeMap();
            else if (_instanceof(parent, nativeSet)) child = new nativeSet();
            else if (_instanceof(parent, nativePromise)) child = new nativePromise(function(resolve, reject) {
                parent.then(function(value) {
                    resolve(_clone(value, depth - 1));
                }, function(err) {
                    reject(_clone(err, depth - 1));
                });
            });
            else if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && $aa773ab41545cf51$require$Buffer.isBuffer(parent)) {
                if ($aa773ab41545cf51$require$Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = $aa773ab41545cf51$require$Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new $aa773ab41545cf51$require$Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (_instanceof(parent, Error)) child = Object.create(parent);
            else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            if (_instanceof(parent, nativeMap)) parent.forEach(function(value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
            });
            if (_instanceof(parent, nativeSet)) parent.forEach(function(value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
            });
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(parent);
                for(var i = 0; i < symbols.length; i++){
                    // Don't need to worry about cloning a symbol because it is a primitive,
                    // like a number or string.
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) continue;
                    child[symbol] = _clone(parent[symbol], depth - 1);
                    if (!descriptor.enumerable) Object.defineProperty(child, symbol, {
                        enumerable: false
                    });
                }
            }
            if (includeNonEnumerable) {
                var allPropertyNames = Object.getOwnPropertyNames(parent);
                for(var i = 0; i < allPropertyNames.length; i++){
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                    if (descriptor && descriptor.enumerable) continue;
                    child[propertyName] = _clone(parent[propertyName], depth - 1);
                    Object.defineProperty(child, propertyName, {
                        enumerable: false
                    });
                }
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (module.exports) module.exports = $aa773ab41545cf51$var$clone;

});

parcelRegister("fRMcu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b8d131dd2e99af53$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b8d131dd2e99af53$var$ReflectApply = $b8d131dd2e99af53$var$R && typeof $b8d131dd2e99af53$var$R.apply === 'function' ? $b8d131dd2e99af53$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b8d131dd2e99af53$var$ReflectOwnKeys;
if ($b8d131dd2e99af53$var$R && typeof $b8d131dd2e99af53$var$R.ownKeys === 'function') $b8d131dd2e99af53$var$ReflectOwnKeys = $b8d131dd2e99af53$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b8d131dd2e99af53$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b8d131dd2e99af53$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b8d131dd2e99af53$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b8d131dd2e99af53$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b8d131dd2e99af53$var$EventEmitter() {
    $b8d131dd2e99af53$var$EventEmitter.init.call(this);
}
module.exports = $b8d131dd2e99af53$var$EventEmitter;
module.exports.once = $b8d131dd2e99af53$var$once;
// Backwards-compat with node 0.10.x
$b8d131dd2e99af53$var$EventEmitter.EventEmitter = $b8d131dd2e99af53$var$EventEmitter;
$b8d131dd2e99af53$var$EventEmitter.prototype._events = undefined;
$b8d131dd2e99af53$var$EventEmitter.prototype._eventsCount = 0;
$b8d131dd2e99af53$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b8d131dd2e99af53$var$defaultMaxListeners = 10;
function $b8d131dd2e99af53$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b8d131dd2e99af53$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b8d131dd2e99af53$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b8d131dd2e99af53$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b8d131dd2e99af53$var$defaultMaxListeners = arg;
    }
});
$b8d131dd2e99af53$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b8d131dd2e99af53$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b8d131dd2e99af53$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b8d131dd2e99af53$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b8d131dd2e99af53$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b8d131dd2e99af53$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b8d131dd2e99af53$var$_getMaxListeners(this);
};
$b8d131dd2e99af53$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b8d131dd2e99af53$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b8d131dd2e99af53$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b8d131dd2e99af53$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b8d131dd2e99af53$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b8d131dd2e99af53$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b8d131dd2e99af53$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b8d131dd2e99af53$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b8d131dd2e99af53$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b8d131dd2e99af53$var$_addListener(this, type, listener, false);
};
$b8d131dd2e99af53$var$EventEmitter.prototype.on = $b8d131dd2e99af53$var$EventEmitter.prototype.addListener;
$b8d131dd2e99af53$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b8d131dd2e99af53$var$_addListener(this, type, listener, true);
};
function $b8d131dd2e99af53$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b8d131dd2e99af53$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b8d131dd2e99af53$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b8d131dd2e99af53$var$EventEmitter.prototype.once = function once(type, listener) {
    $b8d131dd2e99af53$var$checkListener(listener);
    this.on(type, $b8d131dd2e99af53$var$_onceWrap(this, type, listener));
    return this;
};
$b8d131dd2e99af53$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b8d131dd2e99af53$var$checkListener(listener);
    this.prependListener(type, $b8d131dd2e99af53$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b8d131dd2e99af53$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b8d131dd2e99af53$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b8d131dd2e99af53$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b8d131dd2e99af53$var$EventEmitter.prototype.off = $b8d131dd2e99af53$var$EventEmitter.prototype.removeListener;
$b8d131dd2e99af53$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b8d131dd2e99af53$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b8d131dd2e99af53$var$unwrapListeners(evlistener) : $b8d131dd2e99af53$var$arrayClone(evlistener, evlistener.length);
}
$b8d131dd2e99af53$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b8d131dd2e99af53$var$_listeners(this, type, true);
};
$b8d131dd2e99af53$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b8d131dd2e99af53$var$_listeners(this, type, false);
};
$b8d131dd2e99af53$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b8d131dd2e99af53$var$listenerCount.call(emitter, type);
};
$b8d131dd2e99af53$var$EventEmitter.prototype.listenerCount = $b8d131dd2e99af53$var$listenerCount;
function $b8d131dd2e99af53$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b8d131dd2e99af53$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b8d131dd2e99af53$var$ReflectOwnKeys(this._events) : [];
};
function $b8d131dd2e99af53$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b8d131dd2e99af53$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b8d131dd2e99af53$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b8d131dd2e99af53$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b8d131dd2e99af53$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b8d131dd2e99af53$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b8d131dd2e99af53$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b8d131dd2e99af53$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b8d131dd2e99af53$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("kXlzl", function(module, exports) {
$parcel$export(module.exports, "AnalyticsActionSubjects", () => $efc8b31b88a000ee$export$5378e27bf4bd9964);
$parcel$export(module.exports, "AnalyticsTrackActions", () => $efc8b31b88a000ee$export$66cb7b42e8abaf2a);
$parcel$export(module.exports, "trackIssueEvent", () => $efc8b31b88a000ee$export$a5fa4cf2c5c28270);
$parcel$export(module.exports, "trackIssueEventNext", () => $efc8b31b88a000ee$export$3967c914d9a6a7eb);
$parcel$export(module.exports, "trackRequestCreateNonGenericErrors", () => $efc8b31b88a000ee$export$6d75dc6487ba0729);
$parcel$export(module.exports, "firstInteraction", () => $efc8b31b88a000ee$export$f90e311dc845e78d);
$parcel$export(module.exports, "operationalEvent", () => $efc8b31b88a000ee$export$396108a0e963cc78);
$parcel$export(module.exports, "ConnectRequestCreateEventType", () => $efc8b31b88a000ee$export$814045484cc5c60c);
$parcel$export(module.exports, "sendConnectTimeoutEventForRequestCreation", () => $efc8b31b88a000ee$export$bd82f0e8f384bdee);
$parcel$export(module.exports, "composeAnalyticsEvent", () => $efc8b31b88a000ee$export$812115af7f978952);

var $63sfu = parcelRequire("63sfu");

var $54jwS = parcelRequire("54jwS");

var $748yq = parcelRequire("748yq");

var $fVwZr = parcelRequire("fVwZr");

var $fJQMR = parcelRequire("fJQMR");
var $efc8b31b88a000ee$export$5378e27bf4bd9964 = /*#__PURE__*/ function(AnalyticsActionSubjects) {
    AnalyticsActionSubjects["ISSUE"] = "issue";
    AnalyticsActionSubjects["FORM"] = "form";
    AnalyticsActionSubjects["COMMENT"] = "comment";
    AnalyticsActionSubjects["REQUEST_TYPE"] = "issueType";
    AnalyticsActionSubjects["REQUEST_TYPE_GROUP"] = "requestTypeGroup";
    return AnalyticsActionSubjects;
}({});
var $efc8b31b88a000ee$export$66cb7b42e8abaf2a = /*#__PURE__*/ function(AnalyticsTrackActions) {
    AnalyticsTrackActions["CREATED"] = "created";
    AnalyticsTrackActions["DELETED"] = "deleted";
    AnalyticsTrackActions["UPDATED"] = "updated";
    AnalyticsTrackActions["VIEWED"] = "viewed";
    AnalyticsTrackActions["FETCHED"] = "fetched";
    AnalyticsTrackActions["CREATED_FAILURE"] = "created_failure";
    AnalyticsTrackActions["DELETED_FAILURE"] = "deleted_failure";
    AnalyticsTrackActions["UPDATED_FAILURE"] = "updated_failure";
    AnalyticsTrackActions["FETCHED_FAILURE"] = "fetched_failure";
    return AnalyticsTrackActions;
}({});
var $efc8b31b88a000ee$export$3b99c8679ca910fe = /*#__PURE__*/ function(AnalyticsUIActions) {
    AnalyticsUIActions["CLICKED"] = "clicked";
    return AnalyticsUIActions;
}({});
const $efc8b31b88a000ee$var$defaultTrackData = {
    source: 'portalScreen'
};
const $efc8b31b88a000ee$var$issueTrackData = {
    ...$efc8b31b88a000ee$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "issue"
};
function $efc8b31b88a000ee$var$getUserRole(user, portal) {
    if (user.getAccountId()) {
        if (portal && portal.getPortalAnnouncement().getCanAdministerProject()) return 'agent-project-admin';
        if (user.getAgentForPortal()) return 'agent';
        return 'customer';
    }
    return 'anonymous';
}
const $efc8b31b88a000ee$var$getDefaultAttributes = (user, portal)=>({
        attributes: {
            jsdRole: $efc8b31b88a000ee$var$getUserRole(user, portal),
            projectType: 'serviceDesk'
        }
    });
function $efc8b31b88a000ee$export$a5fa4cf2c5c28270(data, user, portal) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $63sfu.defaultsDeep)($efc8b31b88a000ee$var$getDefaultAttributes(user, portal), $efc8b31b88a000ee$var$issueTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackIssueEvent: failed to send analytics data', err);
        }
    }
}
function $efc8b31b88a000ee$export$3967c914d9a6a7eb(data, user, createAnalyticsEvent, portal) {
    try {
        const trackData = {
            analyticsType: 'TRACK',
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            ...$efc8b31b88a000ee$var$issueTrackData,
            ...$efc8b31b88a000ee$var$getDefaultAttributes(user, portal).attributes,
            ...data.attributes
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.fire();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('trackIssueEventNext: failed to send analytics data', err);
    }
}
function $efc8b31b88a000ee$export$6d75dc6487ba0729(errors, createAnalyticsEvent) {
    if (!createAnalyticsEvent) return;
    try {
        // Refrain from passing error messages from fieldError and submissionError to avoid PII logging
        const { errorReasonKey: errorReasonKey, traceId: traceId, fieldErrors: fieldErrors = {}, submissionError: submissionError = {} } = errors;
        const trackData = {
            errorReasonKey: errorReasonKey,
            traceId: traceId,
            hasSubmissionErrors: Object.keys(submissionError).length > 0,
            hasFieldErrors: Object.keys(fieldErrors).length > 0,
            analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
            action: 'failed',
            actionSubject: 'requestCreateNonGenericError'
        };
        const analyticsEvent = createAnalyticsEvent(trackData);
        analyticsEvent.context.push({
            componentName: 'requestCreateNonGenericError'
        });
        analyticsEvent.fire();
    } catch (err) {
        (0, $fVwZr.reportError)(err, {
            message: 'trackRequestCreateNonGenericErrors: failed to send analytics data'
        });
    }
}
let $efc8b31b88a000ee$var$firstInteractionTracked = false;
function $efc8b31b88a000ee$export$f90e311dc845e78d(data) {
    // In the interest of not spamming the analytics server, we try to limit this request to one per tab.
    // This does not guarantee that there is only 1 event fired per interaction as the user can start interaction on a separate tab
    if (!$efc8b31b88a000ee$var$firstInteractionTracked) {
        $efc8b31b88a000ee$var$firstInteractionTracked = true;
        const combinedData = {
            action: 'firstPortalMeaningfulInteraction',
            actionSubject: data.actionSubject,
            source: data.source,
            attributes: {
                isNewPortal: String(!!data.isNewPortal)
            }
        };
        $efc8b31b88a000ee$export$62d6d0288077e3fc(combinedData);
    }
}
function $efc8b31b88a000ee$export$62d6d0288077e3fc(data) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $63sfu.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendUIEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('uiEvent: failed to send analytics data', err);
        }
    }
}
function $efc8b31b88a000ee$export$396108a0e963cc78(data) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        const baseAttributes = {
            attributes: {
                projectType: 'servicedesk'
            }
        };
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $63sfu.defaultsDeep)(baseAttributes, data);
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendOperationalEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('operationalEvent: failed to send analytics data', err);
        }
    }
}
const $efc8b31b88a000ee$var$commentTrackData = {
    ...$efc8b31b88a000ee$var$defaultTrackData,
    containerType: 'project',
    objectType: 'issue',
    actionSubject: "comment"
};
function $efc8b31b88a000ee$export$ef4b02ed2d124f10(data, user, portal) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const trackData = (0, $63sfu.defaultsDeep)($efc8b31b88a000ee$var$getDefaultAttributes(user, portal), $efc8b31b88a000ee$var$commentTrackData, {
            action: data.action,
            containerId: data.projectId,
            objectId: data.issueId,
            actionSubjectId: data.commentId,
            attributes: data.attributes
        });
        try {
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsWebClient.getInstance().sendTrackEvent(trackData);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('trackCommentEvent: failed to send analytics data', err);
        }
    }
}
var $efc8b31b88a000ee$export$814045484cc5c60c = /*#__PURE__*/ function(ConnectRequestCreateEventType) {
    ConnectRequestCreateEventType["VALIDATE"] = "connectValidationTimedOut";
    ConnectRequestCreateEventType["SERIALIZE"] = "connectSerializationTimedOut";
    ConnectRequestCreateEventType["LEGACY"] = "connectValidationOrSerializationTimedOut";
    return ConnectRequestCreateEventType;
}({});
function $efc8b31b88a000ee$export$bd82f0e8f384bdee(eventType, connectKey, requestTypeId) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) try {
        const event = {
            actionSubject: 'connectKey.requestType',
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            actionSubjectId: `${connectKey}.${requestTypeId}`
        };
        if (eventType === "connectValidationOrSerializationTimedOut") {
            event.actionSubject = 'requestType';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            event.actionSubjectId = `${requestTypeId}`;
        }
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsWebClient.getInstance().sendOperationalEvent({
            action: eventType,
            actionSubject: event.actionSubject,
            actionSubjectId: event.actionSubjectId,
            source: (0, $748yq.ScreenName).REQUEST_CREATE
        });
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('sendConnectTimeoutEventForRequestCreation: failed to send analytics data', err);
    }
}
const $efc8b31b88a000ee$export$812115af7f978952 = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent) return createAnalyticsEvent({
            analyticsType: payload.analyticsType,
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: payload.actionSubjectId,
            ...payload.attributes
        });
        return undefined;
    };

});

parcelRegister("9mQxZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $357d5b47a8efb2a2$export$2e2bcd8739ae039);
/**
 * Util to help pre-fetching of initial model data
 */ 
var $1CB66 = parcelRequire("1CB66");

var $6mmHn = parcelRequire("6mmHn");

var $f2UoR = parcelRequire("f2UoR");

var $6bGmX = parcelRequire("6bGmX");

var $eSL4S = parcelRequire("eSL4S");

var $95JF0 = parcelRequire("95JF0");

var $8t8PZ = parcelRequire("8t8PZ");

var $l5Ezo = parcelRequire("l5Ezo");
let $357d5b47a8efb2a2$var$cachedObject;
let $357d5b47a8efb2a2$var$ssrBrandingResponse = undefined;
var $357d5b47a8efb2a2$export$2e2bcd8739ae039 = ()=>{
    const jsonPayload = (0, $1CB66.default).getElementById('jsonPayload');
    if (!$357d5b47a8efb2a2$var$cachedObject) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    $357d5b47a8efb2a2$var$cachedObject = jsonPayload && jsonPayload.textContent && JSON.parse(jsonPayload.textContent) || {};
    if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)()) {
        delete $357d5b47a8efb2a2$var$cachedObject.helpCenterBranding;
        delete $357d5b47a8efb2a2$var$cachedObject.featuredAndSortedPortals;
        delete $357d5b47a8efb2a2$var$cachedObject.loginAnnouncements;
        /**
     * If we're on the client and we have a cached response from SSR query cache, use it right away.
     */ if ((0, $6bGmX.default).checkGate('hydrate_jsm_ssr_branding') && true) {
            if ($357d5b47a8efb2a2$var$ssrBrandingResponse === undefined) {
                const ssrCache = (0, $l5Ezo.QueryResponseCache);
                const reqId = (0, $f2UoR.getRequest)((0, $8t8PZ.default)).params.id;
                const resp = reqId && ssrCache.get(reqId, {
                    cloudId: (0, $6mmHn.getCloudId)(),
                    helpCenterAri: (0, $6mmHn.getHelpCenterAri)()
                });
                if (resp !== null) // @ts-ignore
                $357d5b47a8efb2a2$var$ssrBrandingResponse = (0, $95JF0.convertToHCBrandingResponse)(resp.data);
                else $357d5b47a8efb2a2$var$ssrBrandingResponse = null;
            }
            if ($357d5b47a8efb2a2$var$ssrBrandingResponse !== null && $357d5b47a8efb2a2$var$ssrBrandingResponse !== undefined) $357d5b47a8efb2a2$var$cachedObject.helpCenterBranding = $357d5b47a8efb2a2$var$ssrBrandingResponse;
        }
    }
    return $357d5b47a8efb2a2$var$cachedObject;
};
const $357d5b47a8efb2a2$export$246d7bb795c4c0e = ()=>{
    $357d5b47a8efb2a2$var$cachedObject = undefined;
    $357d5b47a8efb2a2$var$ssrBrandingResponse = undefined;
};

});
parcelRegister("f2UoR", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("2ZBVU"));

});
parcelRegister("2ZBVU", function(module, exports) {
'use strict';

var $jXht9 = parcelRequire("jXht9");
var $22deb3f9ad559e11$var$isErrorResult = $jXht9.isErrorResult, $22deb3f9ad559e11$var$isValueResult = $jXht9.isValueResult;

var $WUQwO = parcelRequire("WUQwO");

var $1Ypmr = parcelRequire("1Ypmr");

var $3kSkJ = parcelRequire("3kSkJ");

var $4x8K6 = parcelRequire("4x8K6");

var $aZ6ei = parcelRequire("aZ6ei");

var $8WCRC = parcelRequire("8WCRC");

var $bYcsU = parcelRequire("bYcsU");

var $kZr0r = parcelRequire("kZr0r");

var $qb2Bd = parcelRequire("qb2Bd");

var $8qLJU = parcelRequire("8qLJU");

var $li5ej = parcelRequire("li5ej");

var $fSEi0 = parcelRequire("fSEi0");

var $d3LHy = parcelRequire("d3LHy");

var $7eWMn = parcelRequire("7eWMn");

var $gTVNa = parcelRequire("gTVNa");

var $e5BNa = parcelRequire("e5BNa");

var $h2cEo = parcelRequire("h2cEo");
var $22deb3f9ad559e11$var$generateClientID = $h2cEo.generateClientID, $22deb3f9ad559e11$var$generateUniqueClientID = $h2cEo.generateUniqueClientID, $22deb3f9ad559e11$var$isClientID = $h2cEo.isClientID;

var $56tfg = parcelRequire("56tfg");

var $liuDR = parcelRequire("liuDR");

var $4uMpX = parcelRequire("4uMpX");

var $aLFet = parcelRequire("aLFet");

var $crk1n = parcelRequire("crk1n");
var $22deb3f9ad559e11$var$isSuspenseSentinel = $crk1n.isSuspenseSentinel, $22deb3f9ad559e11$var$suspenseSentinel = $crk1n.suspenseSentinel;

var $5gu4J = parcelRequire("5gu4J");

var $4h0dI = parcelRequire("4h0dI");

var $8DIRW = parcelRequire("8DIRW");

var $7Np1T = parcelRequire("7Np1T");

var $aMn0M = parcelRequire("aMn0M");

var $euPdh = parcelRequire("euPdh");

var $jvXON = parcelRequire("jvXON");

var $56dkm = parcelRequire("56dkm");

var $iA9kA = parcelRequire("iA9kA");

var $a6Cv6 = parcelRequire("a6Cv6");

var $lkenx = parcelRequire("lkenx");

var $imSuX = parcelRequire("imSuX");

var $2vrix = parcelRequire("2vrix");

var $dPhxy = parcelRequire("dPhxy");

var $2deOb = parcelRequire("2deOb");

var $1RL2Z = parcelRequire("1RL2Z");

var $fzp6q = parcelRequire("fzp6q");

var $4A9VA = parcelRequire("4A9VA");

var $e3ZLe = parcelRequire("e3ZLe");

var $gTWb3 = parcelRequire("gTWb3");

var $jvKQd = parcelRequire("jvKQd");

var $058gC = parcelRequire("058gC");

var $aeQIj = parcelRequire("aeQIj");

var $bmFCC = parcelRequire("bmFCC");

var $dfZPJ = parcelRequire("dfZPJ");
var $22deb3f9ad559e11$var$handlePotentialSnapshotErrors = $dfZPJ.handlePotentialSnapshotErrors;

var $iuCqw = parcelRequire("iuCqw");

var $ly05A = parcelRequire("ly05A");

var $dJL9K = parcelRequire("dJL9K");

var $eTaxe = parcelRequire("eTaxe");

var $bbT5D = parcelRequire("bbT5D");

var $5WkP1 = parcelRequire("5WkP1");

var $66wAr = parcelRequire("66wAr");

var $4T9RZ = parcelRequire("4T9RZ");

var $eAV2Z = parcelRequire("eAV2Z");

var $6XY91 = parcelRequire("6XY91");
var $22deb3f9ad559e11$var$hasCycle = $6XY91.hasCycle, $22deb3f9ad559e11$var$stableCopy = $6XY91.stableCopy;

var $czDw1 = parcelRequire("czDw1");
var $22deb3f9ad559e11$var$mapStr, $22deb3f9ad559e11$var$setStr, $22deb3f9ad559e11$var$promiseStr, $22deb3f9ad559e11$var$objStr;
module.exports = {
    Environment: $7Np1T,
    Network: $qb2Bd,
    Observable: $8qLJU,
    QueryResponseCache: $li5ej,
    RecordSource: $a6Cv6,
    Record: $euPdh,
    ReplaySubject: $eAV2Z,
    Store: $56dkm,
    areEqualSelectors: $jvXON.areEqualSelectors,
    createFragmentSpecResolver: $56tfg,
    createNormalizationSelector: $jvXON.createNormalizationSelector,
    createOperationDescriptor: $aMn0M.createOperationDescriptor,
    createReaderSelector: $jvXON.createReaderSelector,
    createRequestDescriptor: $aMn0M.createRequestDescriptor,
    getArgumentValues: $lkenx.getArgumentValues,
    getDataIDsFromFragment: $jvXON.getDataIDsFromFragment,
    getDataIDsFromObject: $jvXON.getDataIDsFromObject,
    getNode: $gTVNa.getNode,
    getFragment: $gTVNa.getFragment,
    getInlineDataFragment: $gTVNa.getInlineDataFragment,
    getModuleComponentKey: $lkenx.getModuleComponentKey,
    getModuleOperationKey: $lkenx.getModuleOperationKey,
    getPaginationFragment: $gTVNa.getPaginationFragment,
    getPluralSelector: $jvXON.getPluralSelector,
    getRefetchableFragment: $gTVNa.getRefetchableFragment,
    getRequest: $gTVNa.getRequest,
    getRequestIdentifier: $aeQIj,
    getSelector: $jvXON.getSelector,
    getSelectorsFromObject: $jvXON.getSelectorsFromObject,
    getSingularSelector: $jvXON.getSingularSelector,
    getStorageKey: $lkenx.getStorageKey,
    getVariablesFromFragment: $jvXON.getVariablesFromFragment,
    getVariablesFromObject: $jvXON.getVariablesFromObject,
    getVariablesFromPluralFragment: $jvXON.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $jvXON.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $22deb3f9ad559e11$var$handlePotentialSnapshotErrors,
    graphql: $gTVNa.graphql,
    isErrorResult: $22deb3f9ad559e11$var$isErrorResult,
    isValueResult: $22deb3f9ad559e11$var$isValueResult,
    isFragment: $gTVNa.isFragment,
    isInlineDataFragment: $gTVNa.isInlineDataFragment,
    isSuspenseSentinel: $22deb3f9ad559e11$var$isSuspenseSentinel,
    suspenseSentinel: $22deb3f9ad559e11$var$suspenseSentinel,
    isRequest: $gTVNa.isRequest,
    readInlineData: $4h0dI,
    readFragment: $imSuX.readFragment,
    MutationTypes: $kZr0r.MutationTypes,
    RangeOperations: $kZr0r.RangeOperations,
    DefaultHandlerProvider: $4x8K6,
    ConnectionHandler: $WUQwO,
    MutationHandlers: $3kSkJ,
    VIEWER_ID: $2vrix.VIEWER_ID,
    VIEWER_TYPE: $2vrix.VIEWER_TYPE,
    applyOptimisticMutation: $aZ6ei,
    commitLocalUpdate: $8WCRC,
    commitMutation: $bYcsU,
    fetchQuery: $fSEi0,
    fetchQuery_DEPRECATED: $d3LHy,
    isRelayModernEnvironment: $aLFet,
    requestSubscription: $dPhxy,
    ConnectionInterface: $1Ypmr,
    PreloadableQueryRegistry: $e5BNa,
    RelayProfiler: $4T9RZ,
    createPayloadFor3DField: $2deOb,
    RelayConcreteNode: $eTaxe,
    RelayError: $5WkP1,
    RelayFeatureFlags: $66wAr,
    DEFAULT_HANDLE_KEY: $bbT5D.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $lkenx.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $lkenx.FRAGMENT_OWNER_KEY,
    ID_KEY: $lkenx.ID_KEY,
    REF_KEY: $lkenx.REF_KEY,
    REFS_KEY: $lkenx.REFS_KEY,
    ROOT_ID: $lkenx.ROOT_ID,
    ROOT_TYPE: $lkenx.ROOT_TYPE,
    TYPENAME_KEY: $lkenx.TYPENAME_KEY,
    deepFreeze: $1RL2Z,
    generateClientID: $22deb3f9ad559e11$var$generateClientID,
    generateUniqueClientID: $22deb3f9ad559e11$var$generateUniqueClientID,
    getRelayHandleKey: $058gC,
    isClientID: $22deb3f9ad559e11$var$isClientID,
    isPromise: $iuCqw,
    isScalarAndEqual: $ly05A,
    recycleNodesInto: $dJL9K,
    stableCopy: $22deb3f9ad559e11$var$stableCopy,
    hasCycle: $22deb3f9ad559e11$var$hasCycle,
    getFragmentIdentifier: $fzp6q,
    getRefetchMetadata: $jvKQd,
    getPaginationMetadata: $4A9VA,
    getPaginationVariables: $e3ZLe,
    getPendingOperationsForFragment: $gTWb3,
    getValueAtPath: $bmFCC,
    __internal: {
        ResolverFragments: $imSuX,
        OperationTracker: $iA9kA,
        createRelayContext: $liuDR,
        createRelayLoggingContext: $4uMpX,
        getOperationVariables: $8DIRW.getOperationVariables,
        getLocalVariables: $8DIRW.getLocalVariables,
        fetchQuery: $7eWMn.fetchQuery,
        fetchQueryDeduped: $7eWMn.fetchQueryDeduped,
        getPromiseForActiveRequest: $7eWMn.getPromiseForActiveRequest,
        getObservableForActiveRequest: $7eWMn.getObservableForActiveRequest,
        normalizeResponse: $5gu4J,
        withProvidedVariables: $czDw1
    }
};

});
parcelRegister("jXht9", function(module, exports) {
'use strict';

var $g6Q4D = parcelRequire("g6Q4D");

var $apDNl = parcelRequire("apDNl");
var $e8711405daf4d62c$var$observeFragment = $apDNl.observeFragment;

var $gEelt = parcelRequire("gEelt");
var $e8711405daf4d62c$var$observeQuery = $gEelt.observeQuery;

var $aeXeT = parcelRequire("aeXeT");
var $e8711405daf4d62c$var$waitForFragmentData = $aeXeT.waitForFragmentData;
function $e8711405daf4d62c$var$isValueResult(input) {
    return input.ok === true;
}
function $e8711405daf4d62c$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $g6Q4D,
    isValueResult: $e8711405daf4d62c$var$isValueResult,
    isErrorResult: $e8711405daf4d62c$var$isErrorResult,
    observeQuery: $e8711405daf4d62c$var$observeQuery,
    observeFragment: $e8711405daf4d62c$var$observeFragment,
    waitForFragmentData: $e8711405daf4d62c$var$waitForFragmentData
};

});
parcelRegister("g6Q4D", function(module, exports) {
'use strict';

var $imSuX = parcelRequire("imSuX");
var $bba599a7fe75eba9$var$readFragment = $imSuX.readFragment;

var $1K7ys = parcelRequire("1K7ys");
function $bba599a7fe75eba9$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $bba599a7fe75eba9$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $1K7ys(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $1K7ys(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $1K7ys(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $bba599a7fe75eba9$var$resolverDataInjector;

});
parcelRegister("imSuX", function(module, exports) {
'use strict';

var $gTVNa = parcelRequire("gTVNa");
var $d5f48e514f34ff16$var$getFragment = $gTVNa.getFragment;

var $dfZPJ = parcelRequire("dfZPJ");
var $d5f48e514f34ff16$var$eventShouldThrow = $dfZPJ.eventShouldThrow;

var $jvXON = parcelRequire("jvXON");
var $d5f48e514f34ff16$var$getSelector = $jvXON.getSelector;

var $1K7ys = parcelRequire("1K7ys");
var $d5f48e514f34ff16$var$contextStack = [];
function $d5f48e514f34ff16$var$withResolverContext(context, cb) {
    $d5f48e514f34ff16$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $d5f48e514f34ff16$var$contextStack.pop();
    }
}
function $d5f48e514f34ff16$var$readFragment(fragmentInput, fragmentKey) {
    if (!$d5f48e514f34ff16$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $d5f48e514f34ff16$var$contextStack[$d5f48e514f34ff16$var$contextStack.length - 1];
    var fragmentNode = $d5f48e514f34ff16$var$getFragment(fragmentInput);
    var fragmentSelector = $d5f48e514f34ff16$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $1K7ys(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $1K7ys(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($d5f48e514f34ff16$var$eventShouldThrow)) throw $d5f48e514f34ff16$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $d5f48e514f34ff16$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $d5f48e514f34ff16$var$readFragment,
    withResolverContext: $d5f48e514f34ff16$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $d5f48e514f34ff16$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("gTVNa", function(module, exports) {
'use strict';

var $eTaxe = parcelRequire("eTaxe");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $c4de9cadebd25952$var$graphql(strings) {
    $1K7ys(false);
}
function $c4de9cadebd25952$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $c4de9cadebd25952$var$isFragment(node) {
    var fragment = $c4de9cadebd25952$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $eTaxe.FRAGMENT;
}
function $c4de9cadebd25952$var$isRequest(node) {
    var request = $c4de9cadebd25952$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $eTaxe.REQUEST;
}
function $c4de9cadebd25952$var$isUpdatableQuery(node) {
    var updatableQuery = $c4de9cadebd25952$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $eTaxe.UPDATABLE_QUERY;
}
function $c4de9cadebd25952$var$isInlineDataFragment(node) {
    var fragment = $c4de9cadebd25952$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $eTaxe.INLINE_DATA_FRAGMENT;
}
function $c4de9cadebd25952$var$getFragment(taggedNode) {
    var fragment = $c4de9cadebd25952$var$getNode(taggedNode);
    !$c4de9cadebd25952$var$isFragment(fragment) && $1K7ys(false);
    return fragment;
}
function $c4de9cadebd25952$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $c4de9cadebd25952$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $c4de9cadebd25952$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $c4de9cadebd25952$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $c4de9cadebd25952$var$getRequest(taggedNode) {
    var request = $c4de9cadebd25952$var$getNode(taggedNode);
    !$c4de9cadebd25952$var$isRequest(request) && $1K7ys(false);
    return request;
}
function $c4de9cadebd25952$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $c4de9cadebd25952$var$getNode(taggedNode);
    !$c4de9cadebd25952$var$isUpdatableQuery(updatableQuery) && $1K7ys(false);
    return updatableQuery;
}
function $c4de9cadebd25952$var$getInlineDataFragment(taggedNode) {
    var fragment = $c4de9cadebd25952$var$getNode(taggedNode);
    !$c4de9cadebd25952$var$isInlineDataFragment(fragment) && $1K7ys(false);
    return fragment;
}
module.exports = {
    getFragment: $c4de9cadebd25952$var$getFragment,
    getNode: $c4de9cadebd25952$var$getNode,
    getPaginationFragment: $c4de9cadebd25952$var$getPaginationFragment,
    getRefetchableFragment: $c4de9cadebd25952$var$getRefetchableFragment,
    getRequest: $c4de9cadebd25952$var$getRequest,
    getUpdatableQuery: $c4de9cadebd25952$var$getUpdatableQuery,
    getInlineDataFragment: $c4de9cadebd25952$var$getInlineDataFragment,
    graphql: $c4de9cadebd25952$var$graphql,
    isFragment: $c4de9cadebd25952$var$isFragment,
    isRequest: $c4de9cadebd25952$var$isRequest,
    isUpdatableQuery: $c4de9cadebd25952$var$isUpdatableQuery,
    isInlineDataFragment: $c4de9cadebd25952$var$isInlineDataFragment
};

});
parcelRegister("eTaxe", function(module, exports) {
'use strict';
var $ad6e5fcb419eb6f0$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $ad6e5fcb419eb6f0$var$RelayConcreteNode;

});

parcelRegister("1K7ys", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $144ff28dd94f7618$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $144ff28dd94f7618$var$invariant;

});

parcelRegister("cfakl", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $eIK5n = parcelRequire("eIK5n");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $8e9ee57f84c56c8a$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $8e9ee57f84c56c8a$var$warning = $eIK5n;
module.exports = $8e9ee57f84c56c8a$var$warning;

});
parcelRegister("eIK5n", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $ab78ec64063a100a$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $ab78ec64063a100a$var$emptyFunction = function emptyFunction() {};
$ab78ec64063a100a$var$emptyFunction.thatReturns = $ab78ec64063a100a$var$makeEmptyFunction;
$ab78ec64063a100a$var$emptyFunction.thatReturnsFalse = $ab78ec64063a100a$var$makeEmptyFunction(false);
$ab78ec64063a100a$var$emptyFunction.thatReturnsTrue = $ab78ec64063a100a$var$makeEmptyFunction(true);
$ab78ec64063a100a$var$emptyFunction.thatReturnsNull = $ab78ec64063a100a$var$makeEmptyFunction(null);
$ab78ec64063a100a$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$ab78ec64063a100a$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $ab78ec64063a100a$var$emptyFunction;

});



parcelRegister("dfZPJ", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $027d9f8bfb64c728$var$_interopRequireDefault = $5gh7j.default;

var $027d9f8bfb64c728$var$_objectSpread2 = $027d9f8bfb64c728$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $027d9f8bfb64c728$var$_createForOfIteratorHelper2 = $027d9f8bfb64c728$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $1K7ys = parcelRequire("1K7ys");
function $027d9f8bfb64c728$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $027d9f8bfb64c728$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $027d9f8bfb64c728$var$_objectSpread2["default"])((0, $027d9f8bfb64c728$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $027d9f8bfb64c728$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($027d9f8bfb64c728$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $1K7ys(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $027d9f8bfb64c728$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $027d9f8bfb64c728$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $027d9f8bfb64c728$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: $027d9f8bfb64c728$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $027d9f8bfb64c728$var$eventShouldThrow
};

});
parcelRegister("5gh7j", function(module, exports) {
function $3d4bb972bfea3d03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $3d4bb972bfea3d03$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kV9I3", function(module, exports) {

var $dS6Sc = parcelRequire("dS6Sc");
function $f3b0a9a5b707772d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f3b0a9a5b707772d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f3b0a9a5b707772d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dS6Sc(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f3b0a9a5b707772d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $f3b0a9a5b707772d$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dS6Sc", function(module, exports) {

var $cYwRP = parcelRequire("cYwRP");
function $a195a666c1075390$var$_defineProperty(e, r, t) {
    return (r = $cYwRP(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $a195a666c1075390$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cYwRP", function(module, exports) {

var $2OGX7 = parcelRequire("2OGX7");
var $9724955d52c32eff$var$_typeof = $2OGX7.default;

var $05h9E = parcelRequire("05h9E");
function $9724955d52c32eff$var$toPropertyKey(t) {
    var i = $05h9E(t, "string");
    return "symbol" == $9724955d52c32eff$var$_typeof(i) ? i : i + "";
}
module.exports = $9724955d52c32eff$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2OGX7", function(module, exports) {
function $20d191c417f472b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $20d191c417f472b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $20d191c417f472b9$var$_typeof(o);
}
module.exports = $20d191c417f472b9$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("05h9E", function(module, exports) {

var $2OGX7 = parcelRequire("2OGX7");
var $00fdc647ef018a00$var$_typeof = $2OGX7.default;
function $00fdc647ef018a00$var$toPrimitive(t, r) {
    if ("object" != $00fdc647ef018a00$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $00fdc647ef018a00$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $00fdc647ef018a00$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("7Sq6l", function(module, exports) {

var $cDlId = parcelRequire("cDlId");
function $5bc1d2bfb7bb2b15$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cDlId(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $5bc1d2bfb7bb2b15$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cDlId", function(module, exports) {

var $8a2nD = parcelRequire("8a2nD");
function $9329f81d10522834$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8a2nD(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8a2nD(r, a) : void 0;
    }
}
module.exports = $9329f81d10522834$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8a2nD", function(module, exports) {
function $5f111a8e74c9c376$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $5f111a8e74c9c376$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("jvXON", function(module, exports) {
'use strict';

var $8DIRW = parcelRequire("8DIRW");
var $e34f503bf86144b3$var$getFragmentVariables = $8DIRW.getFragmentVariables;

var $lkenx = parcelRequire("lkenx");
var $e34f503bf86144b3$var$CLIENT_EDGE_TRAVERSAL_PATH = $lkenx.CLIENT_EDGE_TRAVERSAL_PATH, $e34f503bf86144b3$var$FRAGMENT_OWNER_KEY = $lkenx.FRAGMENT_OWNER_KEY, $e34f503bf86144b3$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $lkenx.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $e34f503bf86144b3$var$FRAGMENTS_KEY = $lkenx.FRAGMENTS_KEY, $e34f503bf86144b3$var$ID_KEY = $lkenx.ID_KEY;

var $aAp8o = parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $e34f503bf86144b3$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $1K7ys(false);
    var dataID = item[$e34f503bf86144b3$var$ID_KEY];
    var fragments = item[$e34f503bf86144b3$var$FRAGMENTS_KEY];
    var mixedOwner = item[$e34f503bf86144b3$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$e34f503bf86144b3$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $e34f503bf86144b3$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$e34f503bf86144b3$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $e34f503bf86144b3$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $e34f503bf86144b3$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $e34f503bf86144b3$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $e34f503bf86144b3$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $1K7ys(false);
        return $e34f503bf86144b3$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $1K7ys(false);
        return $e34f503bf86144b3$var$getSingularSelector(fragment, item);
    }
}
function $e34f503bf86144b3$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $e34f503bf86144b3$var$getSelector(fragment, item);
    }
    return selectors;
}
function $e34f503bf86144b3$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $e34f503bf86144b3$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $e34f503bf86144b3$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $1K7ys(false);
        return $e34f503bf86144b3$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $1K7ys(false);
        return $e34f503bf86144b3$var$getDataID(fragment, item);
    }
}
function $e34f503bf86144b3$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $e34f503bf86144b3$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $e34f503bf86144b3$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $1K7ys(false);
    var dataID = item[$e34f503bf86144b3$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $e34f503bf86144b3$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $e34f503bf86144b3$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $e34f503bf86144b3$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $1K7ys(false);
        return $e34f503bf86144b3$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $1K7ys(false);
        return $e34f503bf86144b3$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $e34f503bf86144b3$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $e34f503bf86144b3$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $e34f503bf86144b3$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $e34f503bf86144b3$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $e34f503bf86144b3$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $aAp8o(thisSelector.variables, thatSelector.variables) && $e34f503bf86144b3$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $e34f503bf86144b3$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $e34f503bf86144b3$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $aAp8o(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $e34f503bf86144b3$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $e34f503bf86144b3$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $e34f503bf86144b3$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $e34f503bf86144b3$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $e34f503bf86144b3$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $e34f503bf86144b3$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $e34f503bf86144b3$var$areEqualSelectors,
    createReaderSelector: $e34f503bf86144b3$var$createReaderSelector,
    createNormalizationSelector: $e34f503bf86144b3$var$createNormalizationSelector,
    getDataIDsFromFragment: $e34f503bf86144b3$var$getDataIDsFromFragment,
    getDataIDsFromObject: $e34f503bf86144b3$var$getDataIDsFromObject,
    getSingularSelector: $e34f503bf86144b3$var$getSingularSelector,
    getPluralSelector: $e34f503bf86144b3$var$getPluralSelector,
    getSelector: $e34f503bf86144b3$var$getSelector,
    getSelectorsFromObject: $e34f503bf86144b3$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $e34f503bf86144b3$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $e34f503bf86144b3$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $e34f503bf86144b3$var$getVariablesFromFragment,
    getVariablesFromObject: $e34f503bf86144b3$var$getVariablesFromObject
};

});
parcelRegister("8DIRW", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $64a4c549deed9b3a$var$_interopRequireDefault = $5gh7j.default;

var $64a4c549deed9b3a$var$_objectSpread2 = $64a4c549deed9b3a$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $lkenx = parcelRequire("lkenx");
var $64a4c549deed9b3a$var$getArgumentValues = $lkenx.getArgumentValues;

var $1K7ys = parcelRequire("1K7ys");
function $64a4c549deed9b3a$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $64a4c549deed9b3a$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $1K7ys(false);
        }
    });
    return variables || argumentVariables;
}
function $64a4c549deed9b3a$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $64a4c549deed9b3a$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $64a4c549deed9b3a$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $64a4c549deed9b3a$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $64a4c549deed9b3a$var$getLocalVariables,
    getFragmentVariables: $64a4c549deed9b3a$var$getFragmentVariables,
    getOperationVariables: $64a4c549deed9b3a$var$getOperationVariables
};

});
parcelRegister("lkenx", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $f8669e88ee783355$var$_interopRequireDefault = $5gh7j.default;

var $f8669e88ee783355$var$_toConsumableArray2 = $f8669e88ee783355$var$_interopRequireDefault((parcelRequire("bmnrf")));

var $058gC = parcelRequire("058gC");

var $eTaxe = parcelRequire("eTaxe");

var $66wAr = parcelRequire("66wAr");

var $6XY91 = parcelRequire("6XY91");
var $f8669e88ee783355$var$stableCopy = $6XY91.stableCopy;

var $1K7ys = parcelRequire("1K7ys");
var $f8669e88ee783355$var$VARIABLE = $eTaxe.VARIABLE, $f8669e88ee783355$var$LITERAL = $eTaxe.LITERAL, $f8669e88ee783355$var$OBJECT_VALUE = $eTaxe.OBJECT_VALUE, $f8669e88ee783355$var$LIST_VALUE = $eTaxe.LIST_VALUE;
var $f8669e88ee783355$var$ERRORS_KEY = '__errors';
var $f8669e88ee783355$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $f8669e88ee783355$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $f8669e88ee783355$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $f8669e88ee783355$var$getArgumentValue(arg, variables) {
    if (arg.kind === $f8669e88ee783355$var$VARIABLE) return $f8669e88ee783355$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $f8669e88ee783355$var$LITERAL) return arg.value;
    else if (arg.kind === $f8669e88ee783355$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $f8669e88ee783355$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $f8669e88ee783355$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($f8669e88ee783355$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $f8669e88ee783355$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$f8669e88ee783355$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $f8669e88ee783355$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $f8669e88ee783355$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $058gC(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $f8669e88ee783355$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $f8669e88ee783355$var$formatStorageKey(handleName, $f8669e88ee783355$var$getArgumentValues(filterArgs, variables));
}
function $f8669e88ee783355$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $f8669e88ee783355$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $f8669e88ee783355$var$formatStorageKey(name, $f8669e88ee783355$var$getArgumentValues(args, variables)) : name;
}
function $f8669e88ee783355$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $f8669e88ee783355$var$getStorageKey(field, variables);
    return $66wAr.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $f8669e88ee783355$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $f8669e88ee783355$var$getStableStorageKey(name, args) {
    return $f8669e88ee783355$var$formatStorageKey(name, $f8669e88ee783355$var$stableCopy(args));
}
function $f8669e88ee783355$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $f8669e88ee783355$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $1K7ys(false);
    return $f8669e88ee783355$var$stableCopy(variables[name]);
}
function $f8669e88ee783355$var$getModuleComponentKey(documentName) {
    return "".concat($f8669e88ee783355$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $f8669e88ee783355$var$getModuleOperationKey(documentName) {
    return "".concat($f8669e88ee783355$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $f8669e88ee783355$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $f8669e88ee783355$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $f8669e88ee783355$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $f8669e88ee783355$var$formatStorageKey,
    getArgumentValue: $f8669e88ee783355$var$getArgumentValue,
    getArgumentValues: $f8669e88ee783355$var$getArgumentValues,
    getHandleStorageKey: $f8669e88ee783355$var$getHandleStorageKey,
    getStorageKey: $f8669e88ee783355$var$getStorageKey,
    getReadTimeResolverStorageKey: $f8669e88ee783355$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $f8669e88ee783355$var$getStableStorageKey,
    getModuleComponentKey: $f8669e88ee783355$var$getModuleComponentKey,
    getModuleOperationKey: $f8669e88ee783355$var$getModuleOperationKey
};
module.exports = $f8669e88ee783355$var$RelayStoreUtils;

});
parcelRegister("bmnrf", function(module, exports) {

var $iRecr = parcelRequire("iRecr");

var $2KLrq = parcelRequire("2KLrq");

var $cDlId = parcelRequire("cDlId");

var $gwoKn = parcelRequire("gwoKn");
function $8453ee300fb05f4e$var$_toConsumableArray(r) {
    return $iRecr(r) || $2KLrq(r) || $cDlId(r) || $gwoKn();
}
module.exports = $8453ee300fb05f4e$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("iRecr", function(module, exports) {

var $8a2nD = parcelRequire("8a2nD");
function $dba830fadf402a63$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $8a2nD(r);
}
module.exports = $dba830fadf402a63$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2KLrq", function(module, exports) {
function $2014ad841e3462e3$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $2014ad841e3462e3$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gwoKn", function(module, exports) {
function $c072d4bd0b7c1faf$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $c072d4bd0b7c1faf$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("058gC", function(module, exports) {
'use strict';

var $bbT5D = parcelRequire("bbT5D");
var $00f6e16b0fc4750f$var$DEFAULT_HANDLE_KEY = $bbT5D.DEFAULT_HANDLE_KEY;

var $1K7ys = parcelRequire("1K7ys");
function $00f6e16b0fc4750f$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $00f6e16b0fc4750f$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $1K7ys(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $00f6e16b0fc4750f$var$getRelayHandleKey;

});
parcelRegister("bbT5D", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("66wAr", function(module, exports) {
'use strict';
var $471c94a4a9a4f9dc$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = $471c94a4a9a4f9dc$var$RelayFeatureFlags;

});

parcelRegister("6XY91", function(module, exports) {
'use strict';
function $5126e8393b20d0ac$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($5126e8393b20d0ac$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $5126e8393b20d0ac$var$stableCopy(value[keys[i]]);
    return stable;
}
function $5126e8393b20d0ac$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $5126e8393b20d0ac$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $5126e8393b20d0ac$var$stableCopy,
    hasCycle: $5126e8393b20d0ac$var$hasCycle
};

});



parcelRegister("aAp8o", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $7b50c350049ac194$var$aStackPool = [];
var $7b50c350049ac194$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $7b50c350049ac194$var$areEqual(a, b) {
    var aStack = $7b50c350049ac194$var$aStackPool.length ? $7b50c350049ac194$var$aStackPool.pop() : [];
    var bStack = $7b50c350049ac194$var$bStackPool.length ? $7b50c350049ac194$var$bStackPool.pop() : [];
    var result = $7b50c350049ac194$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $7b50c350049ac194$var$aStackPool.push(aStack);
    $7b50c350049ac194$var$bStackPool.push(bStack);
    return result;
}
function $7b50c350049ac194$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$7b50c350049ac194$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$7b50c350049ac194$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $7b50c350049ac194$var$areEqual;

});




parcelRegister("apDNl", function(module, exports) {
"use strict";

var $5gh7j = parcelRequire("5gh7j");
var $794b1ba3cf5250b7$var$_interopRequireDefault = $5gh7j.default;

var $7TJN7 = parcelRequire("7TJN7");
var $794b1ba3cf5250b7$require$_asyncToGenerator = $7TJN7.default;

var $794b1ba3cf5250b7$var$_createForOfIteratorHelper2 = $794b1ba3cf5250b7$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $8qLJU = parcelRequire("8qLJU");

var $7eWMn = parcelRequire("7eWMn");
var $794b1ba3cf5250b7$var$getObservableForActiveRequest = $7eWMn.getObservableForActiveRequest;

var $gTVNa = parcelRequire("gTVNa");
var $794b1ba3cf5250b7$var$getFragment = $gTVNa.getFragment;

var $dfZPJ = parcelRequire("dfZPJ");
var $794b1ba3cf5250b7$var$handlePotentialSnapshotErrors = $dfZPJ.handlePotentialSnapshotErrors;

var $jvXON = parcelRequire("jvXON");
var $794b1ba3cf5250b7$var$getSelector = $jvXON.getSelector;

var $1K7ys = parcelRequire("1K7ys");
function $794b1ba3cf5250b7$var$waitForFragmentData(_x, _x2, _x3) {
    return $794b1ba3cf5250b7$var$_waitForFragmentData.apply(this, arguments);
}
function $794b1ba3cf5250b7$var$_waitForFragmentData() {
    $794b1ba3cf5250b7$var$_waitForFragmentData = $794b1ba3cf5250b7$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $794b1ba3cf5250b7$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $794b1ba3cf5250b7$var$_waitForFragmentData.apply(this, arguments);
}
function $794b1ba3cf5250b7$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $794b1ba3cf5250b7$var$getFragment(fragment);
    var fragmentSelector = $794b1ba3cf5250b7$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $1K7ys(false);
    !(fragmentSelector != null) && $1K7ys(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $794b1ba3cf5250b7$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $794b1ba3cf5250b7$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $1K7ys(false);
}
function $794b1ba3cf5250b7$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $8qLJU.create(function(sink) {
        sink.next($794b1ba3cf5250b7$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($794b1ba3cf5250b7$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $794b1ba3cf5250b7$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $8qLJU.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $794b1ba3cf5250b7$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($794b1ba3cf5250b7$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $794b1ba3cf5250b7$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($794b1ba3cf5250b7$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $794b1ba3cf5250b7$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($794b1ba3cf5250b7$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $794b1ba3cf5250b7$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $1K7ys(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $794b1ba3cf5250b7$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $794b1ba3cf5250b7$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $794b1ba3cf5250b7$var$observeFragment,
    waitForFragmentData: $794b1ba3cf5250b7$var$waitForFragmentData
};

});
parcelRegister("7TJN7", function(module, exports) {
function $5c0130aad4cc2ad6$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $5c0130aad4cc2ad6$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $5c0130aad4cc2ad6$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $5c0130aad4cc2ad6$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $5c0130aad4cc2ad6$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8qLJU", function(module, exports) {
'use strict';

var $iuCqw = parcelRequire("iuCqw");
var $6235c885b6e95de4$var$hostReportError = $6235c885b6e95de4$var$swallowError;
var $6235c885b6e95de4$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $6235c885b6e95de4$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $6235c885b6e95de4$var$isObservable(obj) ? $6235c885b6e95de4$var$fromObservable(obj) : $iuCqw(obj) ? $6235c885b6e95de4$var$fromPromise(obj) : $6235c885b6e95de4$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $6235c885b6e95de4$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $6235c885b6e95de4$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $6235c885b6e95de4$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $6235c885b6e95de4$var$fromObservable(obj) {
    return obj instanceof $6235c885b6e95de4$var$RelayObservable ? obj : $6235c885b6e95de4$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $6235c885b6e95de4$var$fromPromise(promise) {
    return $6235c885b6e95de4$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $6235c885b6e95de4$var$fromValue(value) {
    return $6235c885b6e95de4$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $6235c885b6e95de4$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $6235c885b6e95de4$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $6235c885b6e95de4$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $6235c885b6e95de4$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $6235c885b6e95de4$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $6235c885b6e95de4$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $6235c885b6e95de4$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $6235c885b6e95de4$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $6235c885b6e95de4$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $6235c885b6e95de4$var$RelayObservable;

});
parcelRegister("iuCqw", function(module, exports) {
'use strict';
function $d768d61e541cf3ae$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $d768d61e541cf3ae$var$isPromise;

});


parcelRegister("7eWMn", function(module, exports) {
'use strict';

var $8qLJU = parcelRequire("8qLJU");

var $eAV2Z = parcelRequire("eAV2Z");

var $1K7ys = parcelRequire("1K7ys");
var $54576f89fcd9bfdb$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $54576f89fcd9bfdb$var$requestCachesByEnvironment = $54576f89fcd9bfdb$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $54576f89fcd9bfdb$var$fetchQuery(environment, operation) {
    return $54576f89fcd9bfdb$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $54576f89fcd9bfdb$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $8qLJU.create(function(sink) {
        var requestCache = $54576f89fcd9bfdb$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $eAV2Z(),
                    subjectForInFlightStatus: new $eAV2Z(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $54576f89fcd9bfdb$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $54576f89fcd9bfdb$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $54576f89fcd9bfdb$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $54576f89fcd9bfdb$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $1K7ys(false);
        return $54576f89fcd9bfdb$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $54576f89fcd9bfdb$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $8qLJU.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $54576f89fcd9bfdb$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $8qLJU.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $54576f89fcd9bfdb$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $54576f89fcd9bfdb$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $54576f89fcd9bfdb$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $54576f89fcd9bfdb$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $54576f89fcd9bfdb$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $54576f89fcd9bfdb$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $54576f89fcd9bfdb$var$getRequestCache(environment) {
    var cached = $54576f89fcd9bfdb$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $54576f89fcd9bfdb$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $54576f89fcd9bfdb$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $1K7ys(false);
    return cached;
}
module.exports = {
    fetchQuery: $54576f89fcd9bfdb$var$fetchQuery,
    fetchQueryDeduped: $54576f89fcd9bfdb$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $54576f89fcd9bfdb$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $54576f89fcd9bfdb$var$getObservableForActiveRequest
};

});
parcelRegister("eAV2Z", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $aa00addb59ad29f5$var$_interopRequireDefault = $5gh7j.default;

var $aa00addb59ad29f5$var$_createForOfIteratorHelper2 = $aa00addb59ad29f5$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $aa00addb59ad29f5$var$_defineProperty2 = $aa00addb59ad29f5$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $8qLJU = parcelRequire("8qLJU");

var $1K7ys = parcelRequire("1K7ys");
var $aa00addb59ad29f5$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $aa00addb59ad29f5$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $aa00addb59ad29f5$var$_defineProperty2["default"])(this, "_events", []);
        (0, $aa00addb59ad29f5$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $aa00addb59ad29f5$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $8qLJU.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $1K7ys(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $aa00addb59ad29f5$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $aa00addb59ad29f5$var$RelayReplaySubject;

});



parcelRegister("gEelt", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $c1eb8277ef1380d3$var$_interopRequireDefault = $5gh7j.default;

var $c1eb8277ef1380d3$var$_defineProperty2 = $c1eb8277ef1380d3$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $apDNl = parcelRequire("apDNl");
var $c1eb8277ef1380d3$var$observeFragment = $apDNl.observeFragment;

var $aMn0M = parcelRequire("aMn0M");
var $c1eb8277ef1380d3$var$createOperationDescriptor = $aMn0M.createOperationDescriptor;
function $c1eb8277ef1380d3$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $c1eb8277ef1380d3$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $c1eb8277ef1380d3$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return $c1eb8277ef1380d3$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $c1eb8277ef1380d3$var$observeQuery
};

});
parcelRegister("aMn0M", function(module, exports) {
'use strict';
parcelRequire("1RL2Z");

var $aeQIj = parcelRequire("aeQIj");

var $66wAr = parcelRequire("66wAr");

var $6XY91 = parcelRequire("6XY91");
var $7d903cb405ba06c5$var$hasCycle = $6XY91.hasCycle;

var $8DIRW = parcelRequire("8DIRW");
var $7d903cb405ba06c5$var$getOperationVariables = $8DIRW.getOperationVariables;

var $jvXON = parcelRequire("jvXON");
var $7d903cb405ba06c5$var$createNormalizationSelector = $jvXON.createNormalizationSelector, $7d903cb405ba06c5$var$createReaderSelector = $jvXON.createReaderSelector;

var $lkenx = parcelRequire("lkenx");
var $7d903cb405ba06c5$var$ROOT_ID = $lkenx.ROOT_ID;

var $1K7ys = parcelRequire("1K7ys");
function $7d903cb405ba06c5$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $7d903cb405ba06c5$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $7d903cb405ba06c5$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($66wAr.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$7d903cb405ba06c5$var$hasCycle(operationVariables) && $1K7ys(false);
    var requestDescriptor = $7d903cb405ba06c5$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $7d903cb405ba06c5$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $7d903cb405ba06c5$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $7d903cb405ba06c5$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $aeQIj(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $7d903cb405ba06c5$var$createOperationDescriptor,
    createRequestDescriptor: $7d903cb405ba06c5$var$createRequestDescriptor
};

});
parcelRegister("1RL2Z", function(module, exports) {
'use strict';
function $15bf3c4a824fce0b$var$deepFreeze(object) {
    if (!$15bf3c4a824fce0b$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $15bf3c4a824fce0b$var$deepFreeze(property);
    });
    return object;
}
function $15bf3c4a824fce0b$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $15bf3c4a824fce0b$var$deepFreeze;

});

parcelRegister("aeQIj", function(module, exports) {
'use strict';

var $6XY91 = parcelRequire("6XY91");
var $77441a0cd1f1f6e6$var$stableCopy = $6XY91.stableCopy;

var $1K7ys = parcelRequire("1K7ys");
function $77441a0cd1f1f6e6$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $1K7ys(false);
    return requestID + JSON.stringify($77441a0cd1f1f6e6$var$stableCopy(variables));
}
module.exports = $77441a0cd1f1f6e6$var$getRequestIdentifier;

});



parcelRegister("aeXeT", function(module, exports) {
"use strict";

var $7TJN7 = parcelRequire("7TJN7");
var $774929d97060c9c5$require$_asyncToGenerator = $7TJN7.default;

var $apDNl = parcelRequire("apDNl");
var $774929d97060c9c5$var$observeFragment = $apDNl.observeFragment;
function $774929d97060c9c5$var$waitForFragmentData(_x, _x2, _x3) {
    return $774929d97060c9c5$var$_waitForFragmentData.apply(this, arguments);
}
function $774929d97060c9c5$var$_waitForFragmentData() {
    $774929d97060c9c5$var$_waitForFragmentData = $774929d97060c9c5$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $774929d97060c9c5$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $774929d97060c9c5$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $774929d97060c9c5$var$waitForFragmentData
};

});


parcelRegister("WUQwO", function(module, exports) {
'use strict';

var $h2cEo = parcelRequire("h2cEo");
var $0b11835f115e405c$var$generateClientID = $h2cEo.generateClientID;

var $lkenx = parcelRequire("lkenx");
var $0b11835f115e405c$var$getStableStorageKey = $lkenx.getStableStorageKey;

var $058gC = parcelRequire("058gC");

var $1Ypmr = parcelRequire("1Ypmr");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
var $0b11835f115e405c$var$CONNECTION = 'connection';
var $0b11835f115e405c$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $0b11835f115e405c$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $1Ypmr.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $0b11835f115e405c$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $0b11835f115e405c$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $0b11835f115e405c$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($0b11835f115e405c$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $0b11835f115e405c$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $0b11835f115e405c$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $0b11835f115e405c$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $0b11835f115e405c$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $0b11835f115e405c$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $0b11835f115e405c$var$getConnection(record, key, filters) {
    var handleKey = $058gC($0b11835f115e405c$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $0b11835f115e405c$var$getConnectionID(recordID, key, filters) {
    var handleKey = $058gC($0b11835f115e405c$var$CONNECTION, key, null);
    var storageKey = $0b11835f115e405c$var$getStableStorageKey(handleKey, filters);
    return $0b11835f115e405c$var$generateClientID(recordID, storageKey);
}
function $0b11835f115e405c$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $1Ypmr.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $0b11835f115e405c$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $1Ypmr.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $0b11835f115e405c$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $0b11835f115e405c$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $1Ypmr.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $0b11835f115e405c$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $1Ypmr.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $0b11835f115e405c$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $1Ypmr.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($0b11835f115e405c$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $1K7ys(false);
    var edgeID = $0b11835f115e405c$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $0b11835f115e405c$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $0b11835f115e405c$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $1Ypmr.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $0b11835f115e405c$var$buildConnectionEdge,
    createEdge: $0b11835f115e405c$var$createEdge,
    deleteNode: $0b11835f115e405c$var$deleteNode,
    getConnection: $0b11835f115e405c$var$getConnection,
    getConnectionID: $0b11835f115e405c$var$getConnectionID,
    insertEdgeAfter: $0b11835f115e405c$var$insertEdgeAfter,
    insertEdgeBefore: $0b11835f115e405c$var$insertEdgeBefore,
    update: $0b11835f115e405c$var$update
};

});
parcelRegister("h2cEo", function(module, exports) {
'use strict';

var $66wAr = parcelRequire("66wAr");

var $7lmyq = parcelRequire("7lmyq");
var $c66c6fb7fc83e446$var$intern = $7lmyq.intern;
var $c66c6fb7fc83e446$var$PREFIX = 'client:';
function $c66c6fb7fc83e446$var$generateClientID(id, storageKey, index) {
    var internedId = $66wAr.STRING_INTERN_LEVEL <= 0 ? id : $c66c6fb7fc83e446$var$intern(id, $66wAr.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($c66c6fb7fc83e446$var$PREFIX) !== 0) key = $c66c6fb7fc83e446$var$PREFIX + key;
    return key;
}
function $c66c6fb7fc83e446$var$isClientID(id) {
    return id.indexOf($c66c6fb7fc83e446$var$PREFIX) === 0;
}
var $c66c6fb7fc83e446$var$localID = 0;
function $c66c6fb7fc83e446$var$generateUniqueClientID() {
    return "".concat($c66c6fb7fc83e446$var$PREFIX, "local:").concat($c66c6fb7fc83e446$var$localID++);
}
function $c66c6fb7fc83e446$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($c66c6fb7fc83e446$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $c66c6fb7fc83e446$var$generateClientID,
    generateClientObjectClientID: $c66c6fb7fc83e446$var$generateClientObjectClientID,
    generateUniqueClientID: $c66c6fb7fc83e446$var$generateUniqueClientID,
    isClientID: $c66c6fb7fc83e446$var$isClientID
};

});
parcelRegister("7lmyq", function(module, exports) {
'use strict';
var $558bfd5afd50e268$var$internTable = new Map();
var $558bfd5afd50e268$var$nextIndex = 1;
var $558bfd5afd50e268$var$digits = $558bfd5afd50e268$var$initDigitTable();
var $558bfd5afd50e268$var$INTERN_PREFIX = '\t';
var $558bfd5afd50e268$var$ESCAPE_PREFIX = '\v';
function $558bfd5afd50e268$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $558bfd5afd50e268$var$escape(str) {
    if (str[0] === $558bfd5afd50e268$var$INTERN_PREFIX && $558bfd5afd50e268$var$digits.has(str[1]) || str[0] === $558bfd5afd50e268$var$ESCAPE_PREFIX) return $558bfd5afd50e268$var$ESCAPE_PREFIX + str;
    return str;
}
function $558bfd5afd50e268$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $558bfd5afd50e268$var$escape(str);
    var internedString = $558bfd5afd50e268$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $558bfd5afd50e268$var$INTERN_PREFIX + $558bfd5afd50e268$var$nextIndex++;
    $558bfd5afd50e268$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $558bfd5afd50e268$var$intern
};

});


parcelRegister("1Ypmr", function(module, exports) {
'use strict';
var $16ff113706c65d03$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $16ff113706c65d03$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $16ff113706c65d03$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $16ff113706c65d03$var$config = newConfig;
    },
    get: function get() {
        return $16ff113706c65d03$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $16ff113706c65d03$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $16ff113706c65d03$var$ConnectionInterface;

});


parcelRegister("3kSkJ", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $26dd62d86446f2d3$var$_interopRequireDefault = $5gh7j.default;

var $26dd62d86446f2d3$var$_createForOfIteratorHelper2 = $26dd62d86446f2d3$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $WUQwO = parcelRequire("WUQwO");

var $1Ypmr = parcelRequire("1Ypmr");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
var $26dd62d86446f2d3$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $26dd62d86446f2d3$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $1K7ys(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $26dd62d86446f2d3$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $WUQwO.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $26dd62d86446f2d3$var$AppendEdgeHandler = {
    update: $26dd62d86446f2d3$var$edgeUpdater($WUQwO.insertEdgeAfter)
};
var $26dd62d86446f2d3$var$PrependEdgeHandler = {
    update: $26dd62d86446f2d3$var$edgeUpdater($WUQwO.insertEdgeBefore)
};
var $26dd62d86446f2d3$var$AppendNodeHandler = {
    update: $26dd62d86446f2d3$var$nodeUpdater($WUQwO.insertEdgeAfter)
};
var $26dd62d86446f2d3$var$PrependNodeHandler = {
    update: $26dd62d86446f2d3$var$nodeUpdater($WUQwO.insertEdgeBefore)
};
function $26dd62d86446f2d3$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $1K7ys(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $1Ypmr.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $26dd62d86446f2d3$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $26dd62d86446f2d3$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $WUQwO.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $1K7ys(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $26dd62d86446f2d3$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $1K7ys(false);
        !(edgeTypeName != null) && $1K7ys(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $1Ypmr.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $26dd62d86446f2d3$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $26dd62d86446f2d3$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $WUQwO.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $1K7ys(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $26dd62d86446f2d3$var$AppendEdgeHandler,
    DeleteRecordHandler: $26dd62d86446f2d3$var$DeleteRecordHandler,
    PrependEdgeHandler: $26dd62d86446f2d3$var$PrependEdgeHandler,
    AppendNodeHandler: $26dd62d86446f2d3$var$AppendNodeHandler,
    PrependNodeHandler: $26dd62d86446f2d3$var$PrependNodeHandler,
    DeleteEdgeHandler: $26dd62d86446f2d3$var$DeleteEdgeHandler
};

});

parcelRegister("4x8K6", function(module, exports) {
'use strict';

var $WUQwO = parcelRequire("WUQwO");

var $3kSkJ = parcelRequire("3kSkJ");

var $1K7ys = parcelRequire("1K7ys");
function $34d10698cae1f0c9$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $WUQwO;
        case 'deleteRecord':
            return $3kSkJ.DeleteRecordHandler;
        case 'deleteEdge':
            return $3kSkJ.DeleteEdgeHandler;
        case 'appendEdge':
            return $3kSkJ.AppendEdgeHandler;
        case 'prependEdge':
            return $3kSkJ.PrependEdgeHandler;
        case 'appendNode':
            return $3kSkJ.AppendNodeHandler;
        case 'prependNode':
            return $3kSkJ.PrependNodeHandler;
    }
    $1K7ys(false);
}
module.exports = $34d10698cae1f0c9$var$RelayDefaultHandlerProvider;

});

parcelRegister("aZ6ei", function(module, exports) {
'use strict';

var $gTVNa = parcelRequire("gTVNa");
var $7ff46efa3dec17df$var$getRequest = $gTVNa.getRequest;

var $aLFet = parcelRequire("aLFet");

var $aMn0M = parcelRequire("aMn0M");
var $7ff46efa3dec17df$var$createOperationDescriptor = $aMn0M.createOperationDescriptor;

var $kZr0r = parcelRequire("kZr0r");

var $1K7ys = parcelRequire("1K7ys");
function $7ff46efa3dec17df$var$applyOptimisticMutation(environment, config) {
    !$aLFet(environment) && $1K7ys(false);
    var mutation = $7ff46efa3dec17df$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $7ff46efa3dec17df$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $kZr0r.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $7ff46efa3dec17df$var$applyOptimisticMutation;

});
parcelRegister("aLFet", function(module, exports) {
'use strict';
function $7d6e47148372fb4a$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $7d6e47148372fb4a$var$isRelayModernEnvironment;

});

parcelRegister("kZr0r", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $03f186000603a3d2$var$_interopRequireDefault = $5gh7j.default;

var $03f186000603a3d2$var$_createForOfIteratorHelper2 = $03f186000603a3d2$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $WUQwO = parcelRequire("WUQwO");
parcelRequire("cfakl");
var $03f186000603a3d2$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $03f186000603a3d2$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $03f186000603a3d2$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $03f186000603a3d2$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $03f186000603a3d2$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $03f186000603a3d2$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $03f186000603a3d2$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $03f186000603a3d2$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $03f186000603a3d2$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $03f186000603a3d2$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $03f186000603a3d2$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $WUQwO.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $WUQwO.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $WUQwO.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $WUQwO.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $03f186000603a3d2$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $03f186000603a3d2$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $03f186000603a3d2$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $03f186000603a3d2$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $03f186000603a3d2$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $03f186000603a3d2$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $WUQwO.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $WUQwO.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $03f186000603a3d2$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $03f186000603a3d2$var$MutationTypes,
    RangeOperations: $03f186000603a3d2$var$RangeOperations,
    convert: $03f186000603a3d2$var$convert
};

});


parcelRegister("8WCRC", function(module, exports) {
'use strict';
function $6831e30d45252f13$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $6831e30d45252f13$var$commitLocalUpdate;

});

parcelRegister("bYcsU", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $8b6ef7a107fe01d3$var$_interopRequireDefault = $5gh7j.default;

var $8b6ef7a107fe01d3$var$_toConsumableArray2 = $8b6ef7a107fe01d3$var$_interopRequireDefault((parcelRequire("bmnrf")));

var $gTVNa = parcelRequire("gTVNa");
var $8b6ef7a107fe01d3$var$getRequest = $gTVNa.getRequest;

var $h2cEo = parcelRequire("h2cEo");
var $8b6ef7a107fe01d3$var$generateUniqueClientID = $h2cEo.generateUniqueClientID;

var $aLFet = parcelRequire("aLFet");

var $aMn0M = parcelRequire("aMn0M");
var $8b6ef7a107fe01d3$var$createOperationDescriptor = $aMn0M.createOperationDescriptor;

var $kZr0r = parcelRequire("kZr0r");
parcelRequire("bzZQr");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $8b6ef7a107fe01d3$var$commitMutation(environment, config) {
    !$aLFet(environment) && $1K7ys(false);
    var mutation = $8b6ef7a107fe01d3$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $8b6ef7a107fe01d3$var$createOperationDescriptor(mutation, variables, cacheConfig, $8b6ef7a107fe01d3$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $kZr0r.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $8b6ef7a107fe01d3$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $8b6ef7a107fe01d3$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $8b6ef7a107fe01d3$var$commitMutation;

});
parcelRegister("bzZQr", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $86e2efb4618c3bca$var$_interopRequireDefault = $5gh7j.default;

var $86e2efb4618c3bca$var$_objectSpread2 = $86e2efb4618c3bca$var$_interopRequireDefault((parcelRequire("kV9I3")));
parcelRequire("cfakl");
var $86e2efb4618c3bca$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $86e2efb4618c3bca$var$validateMutation = function validateMutation() {};
var $86e2efb4618c3bca$var$addFieldToDiff, $86e2efb4618c3bca$var$validateSelections, $86e2efb4618c3bca$var$validateSelection, $86e2efb4618c3bca$var$validateModuleImport, $86e2efb4618c3bca$var$validateAbstractKey, $86e2efb4618c3bca$var$validateField, $86e2efb4618c3bca$var$validateOptimisticResponse;
module.exports = $86e2efb4618c3bca$var$validateMutation;

});


parcelRegister("qb2Bd", function(module, exports) {
'use strict';

var $czDw1 = parcelRequire("czDw1");

var $gpGOt = parcelRequire("gpGOt");
var $04eafe51f00c71d9$var$convertFetch = $gpGOt.convertFetch;

var $1K7ys = parcelRequire("1K7ys");
function $04eafe51f00c71d9$var$create(fetchFn, subscribe) {
    var observeFetch = $04eafe51f00c71d9$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $czDw1(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $1K7ys(false);
            !!uploadables && $1K7ys(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $1K7ys(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $04eafe51f00c71d9$var$create
};

});
parcelRegister("czDw1", function(module, exports) {
'use strict';
parcelRequire("aAp8o");
parcelRequire("cfakl");
var $927767e37ec7485a$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $927767e37ec7485a$var$debugCache = $927767e37ec7485a$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $927767e37ec7485a$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$927767e37ec7485a$var$debugCache.has(providerFunction)) {
                $927767e37ec7485a$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $927767e37ec7485a$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$927767e37ec7485a$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $927767e37ec7485a$var$withProvidedVariables;

});

parcelRegister("gpGOt", function(module, exports) {
'use strict';

var $8qLJU = parcelRequire("8qLJU");
function $bf3030ec60f0e3c6$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $8qLJU.create(function(sink) {
            return sink.error(result);
        });
        return $8qLJU.from(result);
    };
}
module.exports = {
    convertFetch: $bf3030ec60f0e3c6$var$convertFetch
};

});


parcelRegister("li5ej", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $03fffd41cfeab641$var$_interopRequireDefault = $5gh7j.default;

var $03fffd41cfeab641$var$_objectSpread2 = $03fffd41cfeab641$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $6XY91 = parcelRequire("6XY91");
var $03fffd41cfeab641$var$stableCopy = $6XY91.stableCopy;

var $1K7ys = parcelRequire("1K7ys");
var $03fffd41cfeab641$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $1K7ys(false);
        !(ttl > 0) && $1K7ys(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $03fffd41cfeab641$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$03fffd41cfeab641$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $03fffd41cfeab641$var$_objectSpread2["default"])((0, $03fffd41cfeab641$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $03fffd41cfeab641$var$_objectSpread2["default"])((0, $03fffd41cfeab641$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $03fffd41cfeab641$var$_objectSpread2["default"])((0, $03fffd41cfeab641$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $03fffd41cfeab641$var$_objectSpread2["default"])((0, $03fffd41cfeab641$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $03fffd41cfeab641$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $03fffd41cfeab641$var$getCacheKey(queryID, variables) {
    return JSON.stringify($03fffd41cfeab641$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $03fffd41cfeab641$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $03fffd41cfeab641$var$RelayQueryResponseCache;

});

parcelRegister("fSEi0", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $b8fb26c7e2e419e5$var$_interopRequireDefault = $5gh7j.default;

var $b8fb26c7e2e419e5$var$_objectSpread2 = $b8fb26c7e2e419e5$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $8qLJU = parcelRequire("8qLJU");

var $aMn0M = parcelRequire("aMn0M");
var $b8fb26c7e2e419e5$var$createOperationDescriptor = $aMn0M.createOperationDescriptor;

var $dfZPJ = parcelRequire("dfZPJ");
var $b8fb26c7e2e419e5$var$handlePotentialSnapshotErrors = $dfZPJ.handlePotentialSnapshotErrors;

var $7eWMn = parcelRequire("7eWMn");

var $gTVNa = parcelRequire("gTVNa");
var $b8fb26c7e2e419e5$var$getRequest = $gTVNa.getRequest;

var $1K7ys = parcelRequire("1K7ys");
function $b8fb26c7e2e419e5$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $b8fb26c7e2e419e5$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $1K7ys(false);
    var networkCacheConfig = (0, $b8fb26c7e2e419e5$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $b8fb26c7e2e419e5$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $b8fb26c7e2e419e5$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $b8fb26c7e2e419e5$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $8qLJU.from(environment.lookup(operation.fragment)).map(readData);
            return $b8fb26c7e2e419e5$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $b8fb26c7e2e419e5$var$getNetworkObservable(environment, operation) {
    return $7eWMn.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $b8fb26c7e2e419e5$var$fetchQuery;

});

parcelRegister("d3LHy", function(module, exports) {
'use strict';

var $aMn0M = parcelRequire("aMn0M");
var $98208eb1d2d98f01$var$createOperationDescriptor = $aMn0M.createOperationDescriptor;

var $gTVNa = parcelRequire("gTVNa");
var $98208eb1d2d98f01$var$getRequest = $gTVNa.getRequest;
function $98208eb1d2d98f01$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $98208eb1d2d98f01$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $98208eb1d2d98f01$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $98208eb1d2d98f01$var$fetchQuery_DEPRECATED;

});

parcelRegister("e5BNa", function(module, exports) {
'use strict';
var $a41ed903d6716ca6$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $a41ed903d6716ca6$var$preloadableQueryRegistry = new $a41ed903d6716ca6$var$PreloadableQueryRegistry();
module.exports = $a41ed903d6716ca6$var$preloadableQueryRegistry;

});

parcelRegister("56tfg", function(module, exports) {
'use strict';

var $5Pudx = parcelRequire("5Pudx");
parcelRequire("cfakl");
function $3b7432c409c1c52f$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $5Pudx(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $3b7432c409c1c52f$var$createFragmentSpecResolver;

});
parcelRegister("5Pudx", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $43e927b973d8fc91$var$_interopRequireDefault = $5gh7j.default;

var $43e927b973d8fc91$var$_objectSpread2 = $43e927b973d8fc91$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $43e927b973d8fc91$var$_defineProperty2 = $43e927b973d8fc91$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $gTWb3 = parcelRequire("gTWb3");

var $dfZPJ = parcelRequire("dfZPJ");
var $43e927b973d8fc91$var$handlePotentialSnapshotErrors = $dfZPJ.handlePotentialSnapshotErrors;

var $ly05A = parcelRequire("ly05A");

var $dJL9K = parcelRequire("dJL9K");

var $66wAr = parcelRequire("66wAr");

var $aMn0M = parcelRequire("aMn0M");
var $43e927b973d8fc91$var$createRequestDescriptor = $aMn0M.createRequestDescriptor;

var $jvXON = parcelRequire("jvXON");
var $43e927b973d8fc91$var$areEqualSelectors = $jvXON.areEqualSelectors, $43e927b973d8fc91$var$createReaderSelector = $jvXON.createReaderSelector, $43e927b973d8fc91$var$getSelectorsFromObject = $jvXON.getSelectorsFromObject;

var $aAp8o = parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
var $43e927b973d8fc91$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $43e927b973d8fc91$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $43e927b973d8fc91$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $43e927b973d8fc91$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$ly05A(_nextItem, prevItem)) {
                        nextData = nextData || (0, $43e927b973d8fc91$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($66wAr.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $43e927b973d8fc91$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $43e927b973d8fc91$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $43e927b973d8fc91$var$SelectorListResolver) && $1K7ys(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $43e927b973d8fc91$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $43e927b973d8fc91$var$SelectorResolver) && $1K7ys(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $43e927b973d8fc91$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $43e927b973d8fc91$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($66wAr.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $gTWb3(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $43e927b973d8fc91$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $43e927b973d8fc91$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $dJL9K(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($aAp8o(variables, this._selector.variables)) return;
        var requestDescriptor = $43e927b973d8fc91$var$createRequestDescriptor(request, variables);
        var selector = $43e927b973d8fc91$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $43e927b973d8fc91$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $43e927b973d8fc91$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($43e927b973d8fc91$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $43e927b973d8fc91$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $43e927b973d8fc91$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $43e927b973d8fc91$var$RelayModernFragmentSpecResolver;

});
parcelRegister("gTWb3", function(module, exports) {
'use strict';

var $7eWMn = parcelRequire("7eWMn");
var $c4dee934e78440a4$var$getPromiseForActiveRequest = $7eWMn.getPromiseForActiveRequest;
function $c4dee934e78440a4$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $c4dee934e78440a4$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $c4dee934e78440a4$var$getPendingOperationsForFragment;

});

parcelRegister("ly05A", function(module, exports) {
'use strict';
function $fafcd7a3f7602425$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $fafcd7a3f7602425$var$isScalarAndEqual;

});

parcelRegister("dJL9K", function(module, exports) {
'use strict';
function $a0040e8e9691419f$var$recycleNodesInto(prevData, nextData) {
    return $a0040e8e9691419f$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $a0040e8e9691419f$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $a0040e8e9691419f$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $a0040e8e9691419f$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $a0040e8e9691419f$var$recycleNodesInto;

});



parcelRegister("liuDR", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");
var $f8130c46e53cc62e$var$relayContext;
var $f8130c46e53cc62e$var$firstReact;
function $f8130c46e53cc62e$var$createRelayContext(react) {
    if (!$f8130c46e53cc62e$var$relayContext) {
        $f8130c46e53cc62e$var$relayContext = react.createContext(null);
        $f8130c46e53cc62e$var$firstReact = react;
    }
    !(react === $f8130c46e53cc62e$var$firstReact) && $1K7ys(false);
    return $f8130c46e53cc62e$var$relayContext;
}
module.exports = $f8130c46e53cc62e$var$createRelayContext;

});

parcelRegister("4uMpX", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");
var $345f857b5714fcb1$var$relayLoggingContext;
var $345f857b5714fcb1$var$firstReact;
function $345f857b5714fcb1$var$createRelayLoggingContext(react) {
    if (!$345f857b5714fcb1$var$relayLoggingContext) {
        $345f857b5714fcb1$var$relayLoggingContext = react.createContext(null);
        $345f857b5714fcb1$var$firstReact = react;
    }
    !(react === $345f857b5714fcb1$var$firstReact) && $1K7ys(false);
    return $345f857b5714fcb1$var$relayLoggingContext;
}
module.exports = $345f857b5714fcb1$var$createRelayLoggingContext;

});

parcelRegister("crk1n", function(module, exports) {
'use strict';
var $90e78971c5b812c2$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $90e78971c5b812c2$var$suspenseSentinel() {
    return $90e78971c5b812c2$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $90e78971c5b812c2$var$isSuspenseSentinel(value) {
    return value === $90e78971c5b812c2$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $90e78971c5b812c2$var$isSuspenseSentinel,
    suspenseSentinel: $90e78971c5b812c2$var$suspenseSentinel
};

});

parcelRegister("5gu4J", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $3d55c6b45a90bdd4$var$_interopRequireDefault = $5gh7j.default;

var $3d55c6b45a90bdd4$var$_objectSpread2 = $3d55c6b45a90bdd4$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $3d55c6b45a90bdd4$var$_RelayModernRecord = $3d55c6b45a90bdd4$var$_interopRequireDefault((parcelRequire("euPdh")));

var $3d55c6b45a90bdd4$var$_RelayRecordSource = $3d55c6b45a90bdd4$var$_interopRequireDefault((parcelRequire("a6Cv6")));

var $3d55c6b45a90bdd4$var$_RelayResponseNormalizer = $3d55c6b45a90bdd4$var$_interopRequireDefault((parcelRequire("acjea")));
function $3d55c6b45a90bdd4$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $3d55c6b45a90bdd4$var$_RelayRecordSource["default"].create();
    var record = $3d55c6b45a90bdd4$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $3d55c6b45a90bdd4$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $3d55c6b45a90bdd4$var$_objectSpread2["default"])((0, $3d55c6b45a90bdd4$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $3d55c6b45a90bdd4$var$normalizeResponse;

});
parcelRegister("euPdh", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $a8db97ecd716eed9$var$_interopRequireDefault = $5gh7j.default;

var $a8db97ecd716eed9$var$_defineProperty2 = $a8db97ecd716eed9$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $a8db97ecd716eed9$var$_objectWithoutPropertiesLoose2 = $a8db97ecd716eed9$var$_interopRequireDefault((parcelRequire("f75CH")));

var $a8db97ecd716eed9$var$_toPropertyKey2 = $a8db97ecd716eed9$var$_interopRequireDefault((parcelRequire("cYwRP")));

var $a8db97ecd716eed9$var$_objectSpread2 = $a8db97ecd716eed9$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $1RL2Z = parcelRequire("1RL2Z");

var $h2cEo = parcelRequire("h2cEo");
var $a8db97ecd716eed9$var$generateClientObjectClientID = $h2cEo.generateClientObjectClientID, $a8db97ecd716eed9$var$isClientID = $h2cEo.isClientID;

var $crk1n = parcelRequire("crk1n");
var $a8db97ecd716eed9$var$isSuspenseSentinel = $crk1n.isSuspenseSentinel;

var $lkenx = parcelRequire("lkenx");
var $a8db97ecd716eed9$var$ACTOR_IDENTIFIER_KEY = $lkenx.ACTOR_IDENTIFIER_KEY, $a8db97ecd716eed9$var$ERRORS_KEY = $lkenx.ERRORS_KEY, $a8db97ecd716eed9$var$ID_KEY = $lkenx.ID_KEY, $a8db97ecd716eed9$var$INVALIDATED_AT_KEY = $lkenx.INVALIDATED_AT_KEY, $a8db97ecd716eed9$var$REF_KEY = $lkenx.REF_KEY, $a8db97ecd716eed9$var$REFS_KEY = $lkenx.REFS_KEY, $a8db97ecd716eed9$var$RELAY_RESOLVER_VALUE_KEY = $lkenx.RELAY_RESOLVER_VALUE_KEY, $a8db97ecd716eed9$var$ROOT_ID = $lkenx.ROOT_ID, $a8db97ecd716eed9$var$TYPENAME_KEY = $lkenx.TYPENAME_KEY;

var $aAp8o = parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $a8db97ecd716eed9$var$clone(record) {
    return (0, $a8db97ecd716eed9$var$_objectSpread2["default"])({}, record);
}
function $a8db97ecd716eed9$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $a8db97ecd716eed9$var$ID_KEY && key !== $a8db97ecd716eed9$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $a8db97ecd716eed9$var$create(dataID, typeName) {
    var record = {};
    record[$a8db97ecd716eed9$var$ID_KEY] = dataID;
    record[$a8db97ecd716eed9$var$TYPENAME_KEY] = typeName;
    return record;
}
function $a8db97ecd716eed9$var$fromObject(json) {
    return json;
}
function $a8db97ecd716eed9$var$getDataID(record) {
    return record[$a8db97ecd716eed9$var$ID_KEY];
}
function $a8db97ecd716eed9$var$getFields(record) {
    if ($a8db97ecd716eed9$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $a8db97ecd716eed9$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $a8db97ecd716eed9$var$getType(record) {
    return record[$a8db97ecd716eed9$var$TYPENAME_KEY];
}
function $a8db97ecd716eed9$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$a8db97ecd716eed9$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $a8db97ecd716eed9$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($a8db97ecd716eed9$var$REF_KEY) && !value.hasOwnProperty($a8db97ecd716eed9$var$REFS_KEY)) && $1K7ys(false);
    return value;
}
function $a8db97ecd716eed9$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $a8db97ecd716eed9$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$a8db97ecd716eed9$var$REF_KEY] === 'string') && $1K7ys(false);
    return link[$a8db97ecd716eed9$var$REF_KEY];
}
function $a8db97ecd716eed9$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$a8db97ecd716eed9$var$REF_KEY] === 'string';
}
function $a8db97ecd716eed9$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$a8db97ecd716eed9$var$REFS_KEY])) && $1K7ys(false);
    return links[$a8db97ecd716eed9$var$REFS_KEY];
}
function $a8db97ecd716eed9$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$a8db97ecd716eed9$var$REFS_KEY]) && links[$a8db97ecd716eed9$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $a8db97ecd716eed9$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$a8db97ecd716eed9$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $a8db97ecd716eed9$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$a8db97ecd716eed9$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$a8db97ecd716eed9$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$aAp8o(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $a8db97ecd716eed9$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $a8db97ecd716eed9$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($aAp8o(prevValue, nextValue) && $aAp8o(prevErrors, nextErrors)) continue;
            updated = (0, $a8db97ecd716eed9$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$a8db97ecd716eed9$var$ERRORS_KEY] = (0, $a8db97ecd716eed9$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $a8db97ecd716eed9$var$setValue(updated, _storageKey2, nextValue);
        $a8db97ecd716eed9$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $a8db97ecd716eed9$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($a8db97ecd716eed9$var$ERRORS_KEY in record1 || $a8db97ecd716eed9$var$ERRORS_KEY in record2) {
        var errors1 = record1[$a8db97ecd716eed9$var$ERRORS_KEY], fields1 = (0, $a8db97ecd716eed9$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $a8db97ecd716eed9$var$ERRORS_KEY
        ].map($a8db97ecd716eed9$var$_toPropertyKey2["default"]));
        var errors2 = record2[$a8db97ecd716eed9$var$ERRORS_KEY], fields2 = (0, $a8db97ecd716eed9$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $a8db97ecd716eed9$var$ERRORS_KEY
        ].map($a8db97ecd716eed9$var$_toPropertyKey2["default"]));
        var updated = (0, $a8db97ecd716eed9$var$_objectSpread2["default"])((0, $a8db97ecd716eed9$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$a8db97ecd716eed9$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $a8db97ecd716eed9$var$_objectSpread2["default"])((0, $a8db97ecd716eed9$var$_objectSpread2["default"])({}, record1), record2);
}
function $a8db97ecd716eed9$var$freeze(record) {
    $1RL2Z(record);
}
function $a8db97ecd716eed9$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$a8db97ecd716eed9$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$a8db97ecd716eed9$var$ERRORS_KEY] = (0, $a8db97ecd716eed9$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$a8db97ecd716eed9$var$ERRORS_KEY];
        }
    }
}
function $a8db97ecd716eed9$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $a8db97ecd716eed9$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$a8db97ecd716eed9$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $a8db97ecd716eed9$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$a8db97ecd716eed9$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $a8db97ecd716eed9$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$a8db97ecd716eed9$var$REF_KEY] = linkedID;
    link[$a8db97ecd716eed9$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $a8db97ecd716eed9$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$a8db97ecd716eed9$var$REF_KEY] === 'string' && link[$a8db97ecd716eed9$var$ACTOR_IDENTIFIER_KEY] != null) && $1K7ys(false);
    return [
        link[$a8db97ecd716eed9$var$ACTOR_IDENTIFIER_KEY],
        link[$a8db97ecd716eed9$var$REF_KEY]
    ];
}
function $a8db97ecd716eed9$var$getResolverLinkedRecordID(record, typeName) {
    var id = $a8db97ecd716eed9$var$getValue(record, $a8db97ecd716eed9$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $a8db97ecd716eed9$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $1K7ys(false);
    return $a8db97ecd716eed9$var$generateClientObjectClientID(typeName, id);
}
function $a8db97ecd716eed9$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $a8db97ecd716eed9$var$getValue(record, $a8db97ecd716eed9$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $a8db97ecd716eed9$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $1K7ys(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $1K7ys(false);
        return $a8db97ecd716eed9$var$generateClientObjectClientID(typeName, id);
    });
}
function $a8db97ecd716eed9$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $a8db97ecd716eed9$var$clone,
    copyFields: $a8db97ecd716eed9$var$copyFields,
    create: $a8db97ecd716eed9$var$create,
    freeze: $a8db97ecd716eed9$var$freeze,
    fromObject: $a8db97ecd716eed9$var$fromObject,
    getDataID: $a8db97ecd716eed9$var$getDataID,
    getErrors: $a8db97ecd716eed9$var$getErrors,
    getFields: $a8db97ecd716eed9$var$getFields,
    getInvalidationEpoch: $a8db97ecd716eed9$var$getInvalidationEpoch,
    getLinkedRecordID: $a8db97ecd716eed9$var$getLinkedRecordID,
    getLinkedRecordIDs: $a8db97ecd716eed9$var$getLinkedRecordIDs,
    getType: $a8db97ecd716eed9$var$getType,
    getValue: $a8db97ecd716eed9$var$getValue,
    hasValue: $a8db97ecd716eed9$var$hasValue,
    hasLinkedRecordID: $a8db97ecd716eed9$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $a8db97ecd716eed9$var$hasLinkedRecordIDs,
    merge: $a8db97ecd716eed9$var$merge,
    setErrors: $a8db97ecd716eed9$var$setErrors,
    setValue: $a8db97ecd716eed9$var$setValue,
    setLinkedRecordID: $a8db97ecd716eed9$var$setLinkedRecordID,
    setLinkedRecordIDs: $a8db97ecd716eed9$var$setLinkedRecordIDs,
    update: $a8db97ecd716eed9$var$update,
    getActorLinkedRecordID: $a8db97ecd716eed9$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $a8db97ecd716eed9$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $a8db97ecd716eed9$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $a8db97ecd716eed9$var$getResolverLinkedRecordIDs,
    toJSON: $a8db97ecd716eed9$var$toJSON
};

});
parcelRegister("f75CH", function(module, exports) {
function $b00bdf1fcefc6de7$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $b00bdf1fcefc6de7$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("a6Cv6", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $75b8545fafc8fc5c$var$_interopRequireDefault = $5gh7j.default;

var $75b8545fafc8fc5c$var$_createForOfIteratorHelper2 = $75b8545fafc8fc5c$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $euPdh = parcelRequire("euPdh");

var $027x8 = parcelRequire("027x8");
var $75b8545fafc8fc5c$var$EXISTENT = $027x8.EXISTENT, $75b8545fafc8fc5c$var$NONEXISTENT = $027x8.NONEXISTENT, $75b8545fafc8fc5c$var$UNKNOWN = $027x8.UNKNOWN;
var $75b8545fafc8fc5c$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $euPdh.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $75b8545fafc8fc5c$var$UNKNOWN;
        return this._records.get(dataID) == null ? $75b8545fafc8fc5c$var$NONEXISTENT : $75b8545fafc8fc5c$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $75b8545fafc8fc5c$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $euPdh.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $75b8545fafc8fc5c$var$RelayRecordSource;

});
parcelRegister("027x8", function(module, exports) {
'use strict';
var $006607fb98a534eb$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $006607fb98a534eb$var$RelayRecordState;

});


parcelRegister("acjea", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $76c9f08c3006cd94$var$_interopRequireDefault = $5gh7j.default;

var $76c9f08c3006cd94$var$_createForOfIteratorHelper2 = $76c9f08c3006cd94$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $76c9f08c3006cd94$var$_toConsumableArray2 = $76c9f08c3006cd94$var$_interopRequireDefault((parcelRequire("bmnrf")));

var $goils = parcelRequire("goils");
var $76c9f08c3006cd94$var$ACTOR_IDENTIFIER_FIELD_NAME = $goils.ACTOR_IDENTIFIER_FIELD_NAME, $76c9f08c3006cd94$var$getActorIdentifierFromPayload = $goils.getActorIdentifierFromPayload;

var $66wAr = parcelRequire("66wAr");

var $h2cEo = parcelRequire("h2cEo");
var $76c9f08c3006cd94$var$generateClientID = $h2cEo.generateClientID, $76c9f08c3006cd94$var$isClientID = $h2cEo.isClientID;

var $8DIRW = parcelRequire("8DIRW");
var $76c9f08c3006cd94$var$getLocalVariables = $8DIRW.getLocalVariables;

var $kOiTv = parcelRequire("kOiTv");
var $76c9f08c3006cd94$var$buildErrorTrie = $kOiTv.buildErrorTrie, $76c9f08c3006cd94$var$getErrorsByKey = $kOiTv.getErrorsByKey, $76c9f08c3006cd94$var$getNestedErrorTrieByKey = $kOiTv.getNestedErrorTrieByKey;

var $euPdh = parcelRequire("euPdh");

var $jvXON = parcelRequire("jvXON");
var $76c9f08c3006cd94$var$createNormalizationSelector = $jvXON.createNormalizationSelector;

var $lkenx = parcelRequire("lkenx");
var $76c9f08c3006cd94$var$ROOT_ID = $lkenx.ROOT_ID, $76c9f08c3006cd94$var$TYPENAME_KEY = $lkenx.TYPENAME_KEY, $76c9f08c3006cd94$var$getArgumentValues = $lkenx.getArgumentValues, $76c9f08c3006cd94$var$getHandleStorageKey = $lkenx.getHandleStorageKey, $76c9f08c3006cd94$var$getModuleComponentKey = $lkenx.getModuleComponentKey, $76c9f08c3006cd94$var$getModuleOperationKey = $lkenx.getModuleOperationKey, $76c9f08c3006cd94$var$getStorageKey = $lkenx.getStorageKey;

var $jYfKW = parcelRequire("jYfKW");
var $76c9f08c3006cd94$var$TYPE_SCHEMA_TYPE = $jYfKW.TYPE_SCHEMA_TYPE, $76c9f08c3006cd94$var$generateTypeID = $jYfKW.generateTypeID;
parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $76c9f08c3006cd94$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $76c9f08c3006cd94$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $76c9f08c3006cd94$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $76c9f08c3006cd94$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $1K7ys(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $76c9f08c3006cd94$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $76c9f08c3006cd94$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $76c9f08c3006cd94$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $euPdh.create(typeID, $76c9f08c3006cd94$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $euPdh.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1K7ys(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$76c9f08c3006cd94$var$TYPENAME_KEY];
        !(typeName != null) && $1K7ys(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $76c9f08c3006cd94$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $euPdh.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = $euPdh.getType(record);
                        var typeID = $76c9f08c3006cd94$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $euPdh.create(typeID, $76c9f08c3006cd94$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $euPdh.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = $euPdh.getType(record);
                    var _typeID = $76c9f08c3006cd94$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $euPdh.create(_typeID, $76c9f08c3006cd94$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $euPdh.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $76c9f08c3006cd94$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $76c9f08c3006cd94$var$getStorageKey(selection, this._variables);
                    var handleKey = $76c9f08c3006cd94$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $euPdh.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $76c9f08c3006cd94$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $1K7ys(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $76c9f08c3006cd94$var$_toConsumableArray2["default"])(this._path),
            selector: $76c9f08c3006cd94$var$createNormalizationSelector(defer, $euPdh.getDataID(record), this._variables),
            typeName: $euPdh.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $76c9f08c3006cd94$var$_toConsumableArray2["default"])(this._path),
            parentID: $euPdh.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $1K7ys(false);
        var typeName = $euPdh.getType(record);
        var componentKey = $76c9f08c3006cd94$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $euPdh.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $76c9f08c3006cd94$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $euPdh.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $euPdh.getDataID(record),
            operationReference: operationReference,
            path: (0, $76c9f08c3006cd94$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $1K7ys(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $76c9f08c3006cd94$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $66wAr.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $euPdh.setLinkedRecordIDs(record, storageKey, []);
                else $euPdh.setValue(record, storageKey, []);
            } else $euPdh.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $76c9f08c3006cd94$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $euPdh.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $euPdh.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $76c9f08c3006cd94$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $1K7ys(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $1K7ys(false);
        var responseKey = field.alias || field.name;
        var storageKey = $76c9f08c3006cd94$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $euPdh.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $76c9f08c3006cd94$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $euPdh.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $euPdh.getLinkedRecordID(record, storageKey) || $76c9f08c3006cd94$var$generateClientID($euPdh.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $1K7ys(false);
        $euPdh.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $76c9f08c3006cd94$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $1K7ys(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $euPdh.getLinkedRecordID(record, storageKey) || $76c9f08c3006cd94$var$generateClientID($euPdh.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $1K7ys(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($euPdh.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $euPdh.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $euPdh.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $1K7ys(false);
        var prevIDs = $euPdh.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $76c9f08c3006cd94$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $1K7ys(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $76c9f08c3006cd94$var$generateClientID($euPdh.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $1K7ys(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $euPdh.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $euPdh.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($66wAr.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $euPdh.getDataID(record);
            var expected = $76c9f08c3006cd94$var$isClientID(dataID) && dataID !== $76c9f08c3006cd94$var$ROOT_ID || $euPdh.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: $euPdh.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $76c9f08c3006cd94$var$normalize
};

});
parcelRegister("goils", function(module, exports) {
'use strict';
var $beed1e2ee0119080$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $8KirE = parcelRequire("8KirE");
var $beed1e2ee0119080$var$getActorIdentifier = $8KirE.getActorIdentifier;
function $beed1e2ee0119080$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$beed1e2ee0119080$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $beed1e2ee0119080$var$getActorIdentifier(payload[$beed1e2ee0119080$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $beed1e2ee0119080$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $beed1e2ee0119080$var$getActorIdentifierFromPayload
};

});
parcelRegister("8KirE", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");
var $65e0ed6bb5c05273$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $65e0ed6bb5c05273$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $65e0ed6bb5c05273$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $1K7ys(false);
}
module.exports = {
    assertInternalActorIdentifier: $65e0ed6bb5c05273$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $65e0ed6bb5c05273$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("kOiTv", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $f26722243cba65d4$var$_interopRequireDefault = $5gh7j.default;

var $f26722243cba65d4$var$_objectSpread2 = $f26722243cba65d4$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $f26722243cba65d4$var$_objectWithoutPropertiesLoose2 = $f26722243cba65d4$var$_interopRequireDefault((parcelRequire("f75CH")));

var $f26722243cba65d4$var$_createForOfIteratorHelper2 = $f26722243cba65d4$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $f26722243cba65d4$var$_toConsumableArray2 = $f26722243cba65d4$var$_interopRequireDefault((parcelRequire("bmnrf")));
var $f26722243cba65d4$var$_excluded = [
    "path",
    "locations"
];
var $f26722243cba65d4$var$SELF = Symbol('$SELF');
function $f26722243cba65d4$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $f26722243cba65d4$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $f26722243cba65d4$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $f26722243cba65d4$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($f26722243cba65d4$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $f26722243cba65d4$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $f26722243cba65d4$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $f26722243cba65d4$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $f26722243cba65d4$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $f26722243cba65d4$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $f26722243cba65d4$var$_toConsumableArray2["default"])(value));
            else $f26722243cba65d4$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $f26722243cba65d4$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $f26722243cba65d4$var$_objectSpread2["default"])((0, $f26722243cba65d4$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $f26722243cba65d4$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $f26722243cba65d4$var$SELF,
    buildErrorTrie: $f26722243cba65d4$var$buildErrorTrie,
    getNestedErrorTrieByKey: $f26722243cba65d4$var$getNestedErrorTrieByKey,
    getErrorsByKey: $f26722243cba65d4$var$getErrorsByKey
};

});

parcelRegister("jYfKW", function(module, exports) {
'use strict';
var $e89fd7c08677c9fe$var$PREFIX = 'client:__type:';
var $e89fd7c08677c9fe$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $e89fd7c08677c9fe$var$generateTypeID(typeName) {
    return $e89fd7c08677c9fe$var$PREFIX + typeName;
}
function $e89fd7c08677c9fe$var$isTypeID(id) {
    return id.indexOf($e89fd7c08677c9fe$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $e89fd7c08677c9fe$var$generateTypeID,
    isTypeID: $e89fd7c08677c9fe$var$isTypeID,
    TYPE_SCHEMA_TYPE: $e89fd7c08677c9fe$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("4h0dI", function(module, exports) {
'use strict';

var $gTVNa = parcelRequire("gTVNa");
var $31c8ebb1afa10007$var$getInlineDataFragment = $gTVNa.getInlineDataFragment;

var $lkenx = parcelRequire("lkenx");
var $31c8ebb1afa10007$var$FRAGMENTS_KEY = $lkenx.FRAGMENTS_KEY;

var $1K7ys = parcelRequire("1K7ys");
function $31c8ebb1afa10007$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $31c8ebb1afa10007$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $1K7ys(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$31c8ebb1afa10007$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $1K7ys(false);
    return inlineData;
}
module.exports = $31c8ebb1afa10007$var$readInlineData;

});

parcelRegister("7Np1T", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $0176f9e8a4a9799a$var$_interopRequireDefault = $5gh7j.default;

var $0176f9e8a4a9799a$var$_objectSpread2 = $0176f9e8a4a9799a$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $4x8K6 = parcelRequire("4x8K6");

var $8KirE = parcelRequire("8KirE");
var $0176f9e8a4a9799a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $8KirE.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $0176f9e8a4a9799a$var$assertInternalActorIdentifier = $8KirE.assertInternalActorIdentifier;

var $8qLJU = parcelRequire("8qLJU");

var $j1jqY = parcelRequire("j1jqY");

var $iA9kA = parcelRequire("iA9kA");

var $lFvKd = parcelRequire("lFvKd");

var $MFLXc = parcelRequire("MFLXc");

var $gQy26 = parcelRequire("gQy26");

var $5gu4J = parcelRequire("5gu4J");

var $4mC2h = parcelRequire("4mC2h");

var $56dkm = parcelRequire("56dkm");

var $jjgVg = parcelRequire("jjgVg");

var $a6Cv6 = parcelRequire("a6Cv6");
parcelRequire("1K7ys");
var $0176f9e8a4a9799a$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $56dkm(new $a6Cv6(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $0176f9e8a4a9799a$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $gQy26;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $j1jqY(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $MFLXc;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $jjgVg(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $4x8K6, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $5gu4J;
        this.__setNet = function(newNet) {
            return _this._network = $j1jqY(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $iA9kA();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $lFvKd(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $8qLJU.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$0176f9e8a4a9799a$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $8qLJU.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $a6Cv6.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $0176f9e8a4a9799a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $0176f9e8a4a9799a$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $0176f9e8a4a9799a$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $0176f9e8a4a9799a$var$_objectSpread2["default"])((0, $0176f9e8a4a9799a$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $8qLJU.create(function(sink) {
            var executor = $4mC2h.execute({
                actorIdentifier: $0176f9e8a4a9799a$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $0176f9e8a4a9799a$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $0176f9e8a4a9799a$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $0176f9e8a4a9799a$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$0176f9e8a4a9799a$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $0176f9e8a4a9799a$var$emptyFunction() {}
module.exports = $0176f9e8a4a9799a$var$RelayModernEnvironment;

});
parcelRegister("j1jqY", function(module, exports) {
'use strict';

var $g9zZI = parcelRequire("g9zZI");
function $dd8d2f873c48b344$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $g9zZI();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $dd8d2f873c48b344$var$wrapNetworkWithLogObserver;

});
parcelRegister("g9zZI", function(module, exports) {
'use strict';
var $bc29685af023eca7$var$id = 100000;
function $bc29685af023eca7$var$generateID() {
    return $bc29685af023eca7$var$id++;
}
module.exports = $bc29685af023eca7$var$generateID;

});


parcelRegister("iA9kA", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $d872d3b9278e54ec$var$_interopRequireDefault = $5gh7j.default;

var $d872d3b9278e54ec$var$_createForOfIteratorHelper2 = $d872d3b9278e54ec$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $1K7ys = parcelRequire("1K7ys");
var $d872d3b9278e54ec$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $d872d3b9278e54ec$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $d872d3b9278e54ec$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $d872d3b9278e54ec$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $d872d3b9278e54ec$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $d872d3b9278e54ec$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $1K7ys(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $d872d3b9278e54ec$var$RelayOperationTracker;

});

parcelRegister("lFvKd", function(module, exports) {
'use strict';
function $fc660d110274b5d1$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $fc660d110274b5d1$var$registerEnvironmentWithDevTools;

});

parcelRegister("MFLXc", function(module, exports) {
'use strict';

var $2vrix = parcelRequire("2vrix");
var $0924e2f29130ff78$var$VIEWER_ID = $2vrix.VIEWER_ID, $0924e2f29130ff78$var$VIEWER_TYPE = $2vrix.VIEWER_TYPE;
function $0924e2f29130ff78$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $0924e2f29130ff78$var$VIEWER_TYPE) return fieldValue.id == null ? $0924e2f29130ff78$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $0924e2f29130ff78$var$defaultGetDataID;

});
parcelRegister("2vrix", function(module, exports) {
'use strict';

var $h2cEo = parcelRequire("h2cEo");
var $1d33a6d3bf879527$var$generateClientID = $h2cEo.generateClientID;

var $lkenx = parcelRequire("lkenx");
var $1d33a6d3bf879527$var$ROOT_ID = $lkenx.ROOT_ID;
var $1d33a6d3bf879527$var$VIEWER_ID = $1d33a6d3bf879527$var$generateClientID($1d33a6d3bf879527$var$ROOT_ID, 'viewer');
var $1d33a6d3bf879527$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $1d33a6d3bf879527$var$VIEWER_ID,
    VIEWER_TYPE: $1d33a6d3bf879527$var$VIEWER_TYPE
};

});


parcelRegister("gQy26", function(module, exports) {
'use strict';
var $c43be6e4ff2e5a70$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $c43be6e4ff2e5a70$var$defaultRelayFieldLogger;

});

parcelRegister("4mC2h", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $32d6b89c4b56cc89$var$_interopRequireDefault = $5gh7j.default;

var $32d6b89c4b56cc89$var$_createForOfIteratorHelper2 = $32d6b89c4b56cc89$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $32d6b89c4b56cc89$var$_toConsumableArray2 = $32d6b89c4b56cc89$var$_interopRequireDefault((parcelRequire("bmnrf")));

var $8qLJU = parcelRequire("8qLJU");

var $g9zZI = parcelRequire("g9zZI");

var $jSfhA = parcelRequire("jSfhA");

var $5WkP1 = parcelRequire("5WkP1");

var $66wAr = parcelRequire("66wAr");

var $6XY91 = parcelRequire("6XY91");
var $32d6b89c4b56cc89$var$stableCopy = $6XY91.stableCopy;

var $h7gGr = parcelRequire("h7gGr");

var $h2cEo = parcelRequire("h2cEo");
var $32d6b89c4b56cc89$var$generateClientID = $h2cEo.generateClientID, $32d6b89c4b56cc89$var$generateUniqueClientID = $h2cEo.generateUniqueClientID;

var $8DIRW = parcelRequire("8DIRW");
var $32d6b89c4b56cc89$var$getLocalVariables = $8DIRW.getLocalVariables;

var $euPdh = parcelRequire("euPdh");

var $jvXON = parcelRequire("jvXON");
var $32d6b89c4b56cc89$var$createNormalizationSelector = $jvXON.createNormalizationSelector, $32d6b89c4b56cc89$var$createReaderSelector = $jvXON.createReaderSelector;

var $a6Cv6 = parcelRequire("a6Cv6");

var $lkenx = parcelRequire("lkenx");
var $32d6b89c4b56cc89$var$ROOT_TYPE = $lkenx.ROOT_TYPE, $32d6b89c4b56cc89$var$TYPENAME_KEY = $lkenx.TYPENAME_KEY, $32d6b89c4b56cc89$var$getStorageKey = $lkenx.getStorageKey;

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $32d6b89c4b56cc89$var$execute(config) {
    return new $32d6b89c4b56cc89$var$Executor(config);
}
var $32d6b89c4b56cc89$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $g9zZI();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($66wAr.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!$66wAr.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $1K7ys(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $8qLJU.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $5WkP1.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $1K7ys(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $1K7ys(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $32d6b89c4b56cc89$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $32d6b89c4b56cc89$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $32d6b89c4b56cc89$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $32d6b89c4b56cc89$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new $a6Cv6(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $1K7ys(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $32d6b89c4b56cc89$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $32d6b89c4b56cc89$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $a6Cv6.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($66wAr.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $32d6b89c4b56cc89$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $32d6b89c4b56cc89$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $1K7ys(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $32d6b89c4b56cc89$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $32d6b89c4b56cc89$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $jSfhA(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $32d6b89c4b56cc89$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $32d6b89c4b56cc89$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $32d6b89c4b56cc89$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $jSfhA(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $8qLJU.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $8qLJU.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $jSfhA(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $66wAr.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $h7gGr(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $1K7ys(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $1K7ys(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $32d6b89c4b56cc89$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $1K7ys(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $euPdh.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $32d6b89c4b56cc89$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $1K7ys(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $1K7ys(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $1K7ys(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $a6Cv6.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $1K7ys(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $32d6b89c4b56cc89$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $a6Cv6.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $1K7ys(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $32d6b89c4b56cc89$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $1K7ys(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $euPdh.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $1K7ys(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $1K7ys(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$32d6b89c4b56cc89$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $1K7ys(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $32d6b89c4b56cc89$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $1K7ys(false);
        var selector = $32d6b89c4b56cc89$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $euPdh.clone(parentRecord);
        var nextIDs = (0, $32d6b89c4b56cc89$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $euPdh.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $32d6b89c4b56cc89$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $32d6b89c4b56cc89$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $32d6b89c4b56cc89$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $32d6b89c4b56cc89$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $32d6b89c4b56cc89$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $1K7ys(false);
        return operationLoader;
    };
    return Executor;
}();
function $32d6b89c4b56cc89$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $1K7ys(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $32d6b89c4b56cc89$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($32d6b89c4b56cc89$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $32d6b89c4b56cc89$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $1K7ys(false);
}
module.exports = {
    execute: $32d6b89c4b56cc89$var$execute
};

});
parcelRegister("jSfhA", function(module, exports) {
'use strict';

var $eTaxe = parcelRequire("eTaxe");
var $e77eea49923cd9f9$var$REQUEST = $eTaxe.REQUEST, $e77eea49923cd9f9$var$SPLIT_OPERATION = $eTaxe.SPLIT_OPERATION;
function $e77eea49923cd9f9$var$getOperation(node) {
    switch(node.kind){
        case $e77eea49923cd9f9$var$REQUEST:
            return node.operation;
        case $e77eea49923cd9f9$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $e77eea49923cd9f9$var$getOperation;

});

parcelRegister("5WkP1", function(module, exports) {
'use strict';
function $453285545a3b4437$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $453285545a3b4437$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $453285545a3b4437$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("h7gGr", function(module, exports) {
'use strict';
var $c760081d1530f668$var$_window, $c760081d1530f668$var$_window$performance;
var $c760081d1530f668$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($c760081d1530f668$var$_window = window) === null || $c760081d1530f668$var$_window === void 0 ? void 0 : ($c760081d1530f668$var$_window$performance = $c760081d1530f668$var$_window.performance) === null || $c760081d1530f668$var$_window$performance === void 0 ? void 0 : $c760081d1530f668$var$_window$performance.now) === 'function';
function $c760081d1530f668$var$currentTimestamp() {
    if ($c760081d1530f668$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $c760081d1530f668$var$withStartAndDuration(cb) {
    var startTime = $c760081d1530f668$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $c760081d1530f668$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $c760081d1530f668$var$withStartAndDuration;

});


parcelRegister("56dkm", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $3b67d9d706f201ef$var$_interopRequireDefault = $5gh7j.default;

var $3b67d9d706f201ef$var$_createForOfIteratorHelper2 = $3b67d9d706f201ef$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $3b67d9d706f201ef$var$_defineProperty2 = $3b67d9d706f201ef$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $8KirE = parcelRequire("8KirE");
var $3b67d9d706f201ef$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $8KirE.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $3b67d9d706f201ef$var$assertInternalActorIdentifier = $8KirE.assertInternalActorIdentifier;
parcelRequire("1RL2Z");

var $3fwrw = parcelRequire("3fwrw");

var $iN4WI = parcelRequire("iN4WI");

var $MFLXc = parcelRequire("MFLXc");

var $jnDOH = parcelRequire("jnDOH");
var $3b67d9d706f201ef$var$LiveResolverCache = $jnDOH.LiveResolverCache, $3b67d9d706f201ef$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $jnDOH.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $3b67d9d706f201ef$var$getUpdatedDataIDs = $jnDOH.getUpdatedDataIDs;

var $euPdh = parcelRequire("euPdh");

var $iMfD6 = parcelRequire("iMfD6");

var $lNZkG = parcelRequire("lNZkG");

var $Ki1pp = parcelRequire("Ki1pp");

var $jQCJW = parcelRequire("jQCJW");

var $lkenx = parcelRequire("lkenx");

var $lkenx = parcelRequire("lkenx");
var $3b67d9d706f201ef$var$ROOT_ID = $lkenx.ROOT_ID, $3b67d9d706f201ef$var$ROOT_TYPE = $lkenx.ROOT_TYPE;

var $1K7ys = parcelRequire("1K7ys");
var $3b67d9d706f201ef$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $3b67d9d706f201ef$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $3b67d9d706f201ef$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $3b67d9d706f201ef$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $3fwrw;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $MFLXc;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $3b67d9d706f201ef$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $jQCJW(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $3b67d9d706f201ef$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $3b67d9d706f201ef$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $3b67d9d706f201ef$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $iN4WI.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $3b67d9d706f201ef$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $3b67d9d706f201ef$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $lNZkG.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $3b67d9d706f201ef$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $euPdh.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $3b67d9d706f201ef$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $1K7ys(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $iMfD6.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $1K7ys(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $iMfD6.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $3b67d9d706f201ef$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $1K7ys(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $Ki1pp.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $euPdh.getValue(record, $3b67d9d706f201ef$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $3b67d9d706f201ef$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $3b67d9d706f201ef$var$initializeRecordSource(target) {
    if (!target.has($3b67d9d706f201ef$var$ROOT_ID)) {
        var rootRecord = $euPdh.create($3b67d9d706f201ef$var$ROOT_ID, $3b67d9d706f201ef$var$ROOT_TYPE);
        target.set($3b67d9d706f201ef$var$ROOT_ID, rootRecord);
    }
}
function $3b67d9d706f201ef$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $euPdh.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $euPdh.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $euPdh.setValue(nextRecord, $lkenx.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $euPdh.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $3b67d9d706f201ef$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $3b67d9d706f201ef$var$RelayModernStore;

});
parcelRegister("3fwrw", function(module, exports) {
'use strict';
var $25dbf04cdbac4da2$var$resolvedPromise = Promise.resolve();
function $25dbf04cdbac4da2$var$resolveImmediate(callback) {
    $25dbf04cdbac4da2$var$resolvedPromise.then(callback)["catch"]($25dbf04cdbac4da2$var$throwNext);
}
function $25dbf04cdbac4da2$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $25dbf04cdbac4da2$var$resolveImmediate;

});

parcelRegister("iN4WI", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $dae0a3c7e6db9330$var$_interopRequireDefault = $5gh7j.default;

var $dae0a3c7e6db9330$var$_createForOfIteratorHelper2 = $dae0a3c7e6db9330$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $lGKdT = parcelRequire("lGKdT");

var $19baH = parcelRequire("19baH");

var $jSfhA = parcelRequire("jSfhA");

var $h2cEo = parcelRequire("h2cEo");
var $dae0a3c7e6db9330$var$isClientID = $h2cEo.isClientID;

var $c9nvR = parcelRequire("c9nvR");

var $5kSwK = parcelRequire("5kSwK");

var $8DIRW = parcelRequire("8DIRW");
var $dae0a3c7e6db9330$var$getLocalVariables = $8DIRW.getLocalVariables;

var $euPdh = parcelRequire("euPdh");

var $027x8 = parcelRequire("027x8");
var $dae0a3c7e6db9330$var$EXISTENT = $027x8.EXISTENT, $dae0a3c7e6db9330$var$UNKNOWN = $027x8.UNKNOWN;

var $lkenx = parcelRequire("lkenx");

var $jYfKW = parcelRequire("jYfKW");
var $dae0a3c7e6db9330$var$TYPE_SCHEMA_TYPE = $jYfKW.TYPE_SCHEMA_TYPE, $dae0a3c7e6db9330$var$generateTypeID = $jYfKW.generateTypeID;

var $1K7ys = parcelRequire("1K7ys");
var $dae0a3c7e6db9330$var$getModuleOperationKey = $lkenx.getModuleOperationKey, $dae0a3c7e6db9330$var$getStorageKey = $lkenx.getStorageKey, $dae0a3c7e6db9330$var$getArgumentValues = $lkenx.getArgumentValues;
function $dae0a3c7e6db9330$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $dae0a3c7e6db9330$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $dae0a3c7e6db9330$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $lGKdT(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $19baH(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1K7ys(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $dae0a3c7e6db9330$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $dae0a3c7e6db9330$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $dae0a3c7e6db9330$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $dae0a3c7e6db9330$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $dae0a3c7e6db9330$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $dae0a3c7e6db9330$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $dae0a3c7e6db9330$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $dae0a3c7e6db9330$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $dae0a3c7e6db9330$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $dae0a3c7e6db9330$var$UNKNOWN) this._handleMissing();
        if (status === $dae0a3c7e6db9330$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $euPdh.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $1K7ys(false);
                        var _typeID = $dae0a3c7e6db9330$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $c9nvR(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $5kSwK(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $dae0a3c7e6db9330$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $1K7ys(false);
                    var typeID = $dae0a3c7e6db9330$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $1K7ys(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $1K7ys(false);
        var operationKey = $dae0a3c7e6db9330$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $jSfhA(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $dae0a3c7e6db9330$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $dae0a3c7e6db9330$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $dae0a3c7e6db9330$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $dae0a3c7e6db9330$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $dae0a3c7e6db9330$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $euPdh.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $dae0a3c7e6db9330$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $dae0a3c7e6db9330$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $dae0a3c7e6db9330$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $dae0a3c7e6db9330$var$check
};

});
parcelRegister("lGKdT", function(module, exports) {
'use strict';

var $euPdh = parcelRequire("euPdh");

var $027x8 = parcelRequire("027x8");
var $fca16023411c73f7$var$EXISTENT = $027x8.EXISTENT;

var $1K7ys = parcelRequire("1K7ys");
var $fca16023411c73f7$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $euPdh.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $euPdh.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $euPdh.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $1K7ys(false);
            sinkRecord = $euPdh.create(dataID, $euPdh.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $1K7ys(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $euPdh.copyFields(baseSource, sink);
        if (sinkSource) $euPdh.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $euPdh.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $fca16023411c73f7$var$EXISTENT && this._sink.getStatus(dataID) !== $fca16023411c73f7$var$EXISTENT) && $1K7ys(false);
        var record = $euPdh.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $euPdh.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $euPdh.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $euPdh.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $euPdh.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $euPdh.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $euPdh.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $euPdh.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $euPdh.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $euPdh.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $fca16023411c73f7$var$RelayRecordSourceMutator;

});

parcelRegister("19baH", function(module, exports) {
'use strict';

var $euPdh = parcelRequire("euPdh");

var $027x8 = parcelRequire("027x8");
var $0d5f4c24e6c1a1b7$var$EXISTENT = $027x8.EXISTENT, $0d5f4c24e6c1a1b7$var$NONEXISTENT = $027x8.NONEXISTENT;

var $lkenx = parcelRequire("lkenx");
var $0d5f4c24e6c1a1b7$var$ROOT_ID = $lkenx.ROOT_ID, $0d5f4c24e6c1a1b7$var$ROOT_TYPE = $lkenx.ROOT_TYPE;

var $cq1kq = parcelRequire("cq1kq");
var $0d5f4c24e6c1a1b7$var$_readUpdatableFragment = $cq1kq.readUpdatableFragment;

var $f9Urh = parcelRequire("f9Urh");
var $0d5f4c24e6c1a1b7$var$_readUpdatableQuery = $f9Urh.readUpdatableQuery;

var $cXASv = parcelRequire("cXASv");

var $1K7ys = parcelRequire("1K7ys");
var $0d5f4c24e6c1a1b7$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $0d5f4c24e6c1a1b7$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $0d5f4c24e6c1a1b7$var$EXISTENT) _this.create(dataID, $euPdh.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $0d5f4c24e6c1a1b7$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $1K7ys(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $1K7ys(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $0d5f4c24e6c1a1b7$var$ROOT_ID) && $1K7ys(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $0d5f4c24e6c1a1b7$var$EXISTENT) this._proxies[dataID] = new $cXASv(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $0d5f4c24e6c1a1b7$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($0d5f4c24e6c1a1b7$var$ROOT_ID);
        if (!root) root = this.create($0d5f4c24e6c1a1b7$var$ROOT_ID, $0d5f4c24e6c1a1b7$var$ROOT_TYPE);
        !(root && root.getType() === $0d5f4c24e6c1a1b7$var$ROOT_TYPE) && $1K7ys(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $0d5f4c24e6c1a1b7$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $0d5f4c24e6c1a1b7$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $0d5f4c24e6c1a1b7$var$RelayRecordSourceProxy;

});
parcelRegister("cq1kq", function(module, exports) {
'use strict';

var $gTVNa = parcelRequire("gTVNa");
var $90a8f191bb9e7b7e$var$getFragment = $gTVNa.getFragment;

var $jvXON = parcelRequire("jvXON");
var $90a8f191bb9e7b7e$var$getVariablesFromFragment = $jvXON.getVariablesFromFragment;

var $lkenx = parcelRequire("lkenx");
var $90a8f191bb9e7b7e$var$ID_KEY = $lkenx.ID_KEY;

var $4Z3k6 = parcelRequire("4Z3k6");
var $90a8f191bb9e7b7e$var$createUpdatableProxy = $4Z3k6.createUpdatableProxy;

var $1K7ys = parcelRequire("1K7ys");
function $90a8f191bb9e7b7e$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $90a8f191bb9e7b7e$var$getFragment(fragment);
    var fragmentVariables = $90a8f191bb9e7b7e$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$90a8f191bb9e7b7e$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $1K7ys(false);
    return {
        updatableData: $90a8f191bb9e7b7e$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $90a8f191bb9e7b7e$var$readUpdatableFragment
};

});
parcelRegister("4Z3k6", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $3a0f6fdfcd9aa2d1$var$_interopRequireDefault = $5gh7j.default;

var $3a0f6fdfcd9aa2d1$var$_createForOfIteratorHelper2 = $3a0f6fdfcd9aa2d1$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $lkenx = parcelRequire("lkenx");
var $3a0f6fdfcd9aa2d1$var$getArgumentValues = $lkenx.getArgumentValues;
var $3a0f6fdfcd9aa2d1$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $3a0f6fdfcd9aa2d1$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $3a0f6fdfcd9aa2d1$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $3a0f6fdfcd9aa2d1$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $3a0f6fdfcd9aa2d1$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $3a0f6fdfcd9aa2d1$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $3a0f6fdfcd9aa2d1$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $3a0f6fdfcd9aa2d1$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $3a0f6fdfcd9aa2d1$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $3a0f6fdfcd9aa2d1$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $3a0f6fdfcd9aa2d1$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $3a0f6fdfcd9aa2d1$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $3a0f6fdfcd9aa2d1$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $3a0f6fdfcd9aa2d1$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $3a0f6fdfcd9aa2d1$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $3a0f6fdfcd9aa2d1$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $3a0f6fdfcd9aa2d1$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $3a0f6fdfcd9aa2d1$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $3a0f6fdfcd9aa2d1$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $3a0f6fdfcd9aa2d1$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $3a0f6fdfcd9aa2d1$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $3a0f6fdfcd9aa2d1$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $3a0f6fdfcd9aa2d1$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $3a0f6fdfcd9aa2d1$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $3a0f6fdfcd9aa2d1$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $3a0f6fdfcd9aa2d1$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $3a0f6fdfcd9aa2d1$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $3a0f6fdfcd9aa2d1$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $3a0f6fdfcd9aa2d1$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $3a0f6fdfcd9aa2d1$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $3a0f6fdfcd9aa2d1$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $3a0f6fdfcd9aa2d1$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $3a0f6fdfcd9aa2d1$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $3a0f6fdfcd9aa2d1$var$createUpdatableProxy
};

});


parcelRegister("f9Urh", function(module, exports) {
'use strict';

var $gTVNa = parcelRequire("gTVNa");
var $b09379dd03555e3c$var$getUpdatableQuery = $gTVNa.getUpdatableQuery;

var $4Z3k6 = parcelRequire("4Z3k6");
var $b09379dd03555e3c$var$createUpdatableProxy = $4Z3k6.createUpdatableProxy;
function $b09379dd03555e3c$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $b09379dd03555e3c$var$getUpdatableQuery(query);
    return {
        updatableData: $b09379dd03555e3c$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $b09379dd03555e3c$var$readUpdatableQuery
};

});

parcelRegister("cXASv", function(module, exports) {
'use strict';

var $h2cEo = parcelRequire("h2cEo");
var $96f799f436dae49a$var$generateClientID = $h2cEo.generateClientID;

var $lkenx = parcelRequire("lkenx");
var $96f799f436dae49a$var$getStableStorageKey = $lkenx.getStableStorageKey;

var $1K7ys = parcelRequire("1K7ys");
var $96f799f436dae49a$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $1K7ys(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$96f799f436dae49a$var$isValidLeafValue(value) && $1K7ys(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $1K7ys(false);
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
            var clientID = $96f799f436dae49a$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $1K7ys(false);
        var storageKey = $96f799f436dae49a$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $96f799f436dae49a$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($96f799f436dae49a$var$isValidLeafValue);
}
module.exports = $96f799f436dae49a$var$RelayRecordProxy;

});


parcelRegister("c9nvR", function(module, exports) {
'use strict';

var $eTaxe = parcelRequire("eTaxe");
var $8d8890766f280d03$var$LINKED_FIELD = $eTaxe.LINKED_FIELD;

var $lkenx = parcelRequire("lkenx");
var $8d8890766f280d03$var$getHandleStorageKey = $lkenx.getHandleStorageKey;

var $aAp8o = parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");
function $8d8890766f280d03$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $8d8890766f280d03$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $aAp8o(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $8d8890766f280d03$var$LINKED_FIELD) && $1K7ys(false);
    var handleKey = $8d8890766f280d03$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $8d8890766f280d03$var$cloneRelayHandleSourceField;

});

parcelRegister("5kSwK", function(module, exports) {
'use strict';

var $eTaxe = parcelRequire("eTaxe");
var $3e291dfcc7829921$var$SCALAR_FIELD = $eTaxe.SCALAR_FIELD;

var $lkenx = parcelRequire("lkenx");
var $3e291dfcc7829921$var$getHandleStorageKey = $lkenx.getHandleStorageKey;

var $aAp8o = parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");
function $3e291dfcc7829921$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $3e291dfcc7829921$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $aAp8o(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $3e291dfcc7829921$var$SCALAR_FIELD) && $1K7ys(false);
    var handleKey = $3e291dfcc7829921$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $3e291dfcc7829921$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("jnDOH", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $e1bf0d10e717790a$var$_interopRequireDefault = $5gh7j.default;

var $e1bf0d10e717790a$var$_createForOfIteratorHelper2 = $e1bf0d10e717790a$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $dJL9K = parcelRequire("dJL9K");

var $eTaxe = parcelRequire("eTaxe");
var $e1bf0d10e717790a$var$RELAY_LIVE_RESOLVER = $eTaxe.RELAY_LIVE_RESOLVER;

var $66wAr = parcelRequire("66wAr");

var $jpxIF = parcelRequire("jpxIF");

var $h2cEo = parcelRequire("h2cEo");
var $e1bf0d10e717790a$var$generateClientID = $h2cEo.generateClientID, $e1bf0d10e717790a$var$generateClientObjectClientID = $h2cEo.generateClientObjectClientID;

var $euPdh = parcelRequire("euPdh");

var $jvXON = parcelRequire("jvXON");
var $e1bf0d10e717790a$var$createNormalizationSelector = $jvXON.createNormalizationSelector;

var $a6Cv6 = parcelRequire("a6Cv6");

var $acjea = parcelRequire("acjea");
var $e1bf0d10e717790a$var$normalize = $acjea.normalize;

var $lkenx = parcelRequire("lkenx");
var $e1bf0d10e717790a$var$RELAY_RESOLVER_ERROR_KEY = $lkenx.RELAY_RESOLVER_ERROR_KEY, $e1bf0d10e717790a$var$RELAY_RESOLVER_INVALIDATION_KEY = $lkenx.RELAY_RESOLVER_INVALIDATION_KEY, $e1bf0d10e717790a$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $lkenx.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $e1bf0d10e717790a$var$RELAY_RESOLVER_SNAPSHOT_KEY = $lkenx.RELAY_RESOLVER_SNAPSHOT_KEY, $e1bf0d10e717790a$var$RELAY_RESOLVER_VALUE_KEY = $lkenx.RELAY_RESOLVER_VALUE_KEY, $e1bf0d10e717790a$var$getReadTimeResolverStorageKey = $lkenx.getReadTimeResolverStorageKey, $e1bf0d10e717790a$var$getStorageKey = $lkenx.getStorageKey;

var $01odE = parcelRequire("01odE");

var $lPoEK = parcelRequire("lPoEK");

var $crk1n = parcelRequire("crk1n");
var $e1bf0d10e717790a$var$isSuspenseSentinel = $crk1n.isSuspenseSentinel;

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
var $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $e1bf0d10e717790a$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $e1bf0d10e717790a$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $e1bf0d10e717790a$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $e1bf0d10e717790a$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $e1bf0d10e717790a$var$expectRecord(recordSource, recordID);
        var storageKey = $e1bf0d10e717790a$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $euPdh.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $e1bf0d10e717790a$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $e1bf0d10e717790a$var$generateClientID(recordID, storageKey);
            linkedRecord = $euPdh.create(linkedID, $e1bf0d10e717790a$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $euPdh.setValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $euPdh.setValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $e1bf0d10e717790a$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $1K7ys(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $e1bf0d10e717790a$var$expectRecord(recordSource, recordID);
            var nextRecord = $euPdh.clone(currentRecord);
            $euPdh.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $e1bf0d10e717790a$var$getStorageKey(field.fragment, variables);
                var resolverID = $e1bf0d10e717790a$var$generateClientID(recordID, fragmentStorageKey);
                $e1bf0d10e717790a$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $e1bf0d10e717790a$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $e1bf0d10e717790a$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $e1bf0d10e717790a$var$RELAY_LIVE_RESOLVER && $euPdh.getValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $e1bf0d10e717790a$var$generateClientID(recordID, storageKey);
            linkedRecord = $euPdh.clone(linkedRecord);
            var _liveState = $euPdh.getValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$lPoEK(_liveState)) $1K7ys(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $euPdh.setValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $euPdh.getValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $euPdh.getValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($e1bf0d10e717790a$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $e1bf0d10e717790a$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $1K7ys(false);
        var liveState = $euPdh.getValue(liveStateRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $euPdh.setValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $euPdh.setValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $euPdh.setValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$euPdh.hasValue(currentRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $euPdh.clone(currentRecord);
            $euPdh.setValue(nextRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $a6Cv6.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $a6Cv6.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $1K7ys(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $euPdh.setValue(resolverRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$e1bf0d10e717790a$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $01odE(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $1K7ys(false);
                resolverValue = [];
                var nextSource = $a6Cv6.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $1K7ys(false);
                    var typename = $e1bf0d10e717790a$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $e1bf0d10e717790a$var$generateClientObjectClientID(typename, $euPdh.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $e1bf0d10e717790a$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $e1bf0d10e717790a$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $1K7ys(false);
                var _typename = $e1bf0d10e717790a$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $e1bf0d10e717790a$var$generateClientObjectClientID(_typename, $euPdh.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $e1bf0d10e717790a$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $euPdh.setValue(resolverRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $jpxIF(resolverValue);
            $euPdh.setValue(resolverRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $jpxIF(value);
            $euPdh.setValue(resolverRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $euPdh.getValue(resolverRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $e1bf0d10e717790a$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$euPdh.getValue(record, $e1bf0d10e717790a$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $euPdh.getValue(record, $e1bf0d10e717790a$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $dJL9K(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($66wAr.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $euPdh.clone(record);
            $euPdh.setValue(nextRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($euPdh.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $a6Cv6.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $euPdh.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $e1bf0d10e717790a$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $e1bf0d10e717790a$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $euPdh.create(outputTypeDataID, typename);
                $euPdh.setValue(_record, $e1bf0d10e717790a$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $1K7ys(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $e1bf0d10e717790a$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $euPdh.create(key, typeName);
            $euPdh.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $e1bf0d10e717790a$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $e1bf0d10e717790a$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $e1bf0d10e717790a$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $e1bf0d10e717790a$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $e1bf0d10e717790a$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $euPdh.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $e1bf0d10e717790a$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $e1bf0d10e717790a$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $euPdh.getFields(record).forEach(function(field) {
        if ($euPdh.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $euPdh.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($euPdh.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $euPdh.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $e1bf0d10e717790a$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $euPdh.clone(record);
    $euPdh.setValue(nextRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $e1bf0d10e717790a$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $e1bf0d10e717790a$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $e1bf0d10e717790a$var$isResolverRecord(_record2)) $e1bf0d10e717790a$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $e1bf0d10e717790a$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $e1bf0d10e717790a$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $e1bf0d10e717790a$var$isResolverRecord(record)) $e1bf0d10e717790a$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $e1bf0d10e717790a$var$isResolverRecord(record) {
    return $euPdh.getType(record) === $e1bf0d10e717790a$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $e1bf0d10e717790a$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $euPdh.getValue(linkedRecord, $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $e1bf0d10e717790a$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $1K7ys(false);
    return record;
}
function $e1bf0d10e717790a$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $e1bf0d10e717790a$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $1K7ys(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $e1bf0d10e717790a$var$LiveResolverCache,
    getUpdatedDataIDs: $e1bf0d10e717790a$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $e1bf0d10e717790a$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("jpxIF", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("01odE", function(module, exports) {
'use strict';

var $euPdh = parcelRequire("euPdh");

var $lkenx = parcelRequire("lkenx");
var $0042e1880119622f$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $lkenx.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $1K7ys = parcelRequire("1K7ys");
function $0042e1880119622f$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $euPdh.getValue(record, $0042e1880119622f$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $1K7ys(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $0042e1880119622f$var$getOutputTypeRecordIDs;

});

parcelRegister("lPoEK", function(module, exports) {
'use strict';
function $fe417c9be95f15ce$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $fe417c9be95f15ce$var$isLiveStateValue;

});


parcelRegister("iMfD6", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $dab8d56acdc38532$var$_interopRequireDefault = $5gh7j.default;

var $dab8d56acdc38532$var$_objectSpread2 = $dab8d56acdc38532$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $euPdh = parcelRequire("euPdh");

var $a6Cv6 = parcelRequire("a6Cv6");

var $1K7ys = parcelRequire("1K7ys");
var $dab8d56acdc38532$var$UNPUBLISH_RECORD_SENTINEL = $euPdh.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $dab8d56acdc38532$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $a6Cv6.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $dab8d56acdc38532$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $dab8d56acdc38532$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $a6Cv6.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $dab8d56acdc38532$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $dab8d56acdc38532$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $euPdh.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $dab8d56acdc38532$var$create(base) {
    return new $dab8d56acdc38532$var$RelayOptimisticRecordSource(base);
}
function $dab8d56acdc38532$var$getOptimisticRecordIDs(source) {
    !(source instanceof $dab8d56acdc38532$var$RelayOptimisticRecordSource) && $1K7ys(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $dab8d56acdc38532$var$create,
    getOptimisticRecordIDs: $dab8d56acdc38532$var$getOptimisticRecordIDs
};

});

parcelRegister("lNZkG", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $fdfdbff86785fba7$var$_interopRequireDefault = $5gh7j.default;

var $fdfdbff86785fba7$var$_objectSpread2 = $fdfdbff86785fba7$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $fdfdbff86785fba7$var$_defineProperty2 = $fdfdbff86785fba7$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $fdfdbff86785fba7$var$_objectWithoutPropertiesLoose2 = $fdfdbff86785fba7$var$_interopRequireDefault((parcelRequire("f75CH")));

var $fdfdbff86785fba7$var$_toConsumableArray2 = $fdfdbff86785fba7$var$_interopRequireDefault((parcelRequire("bmnrf")));
var $fdfdbff86785fba7$var$_excluded = [
    "message"
];

var $66wAr = parcelRequire("66wAr");

var $crk1n = parcelRequire("crk1n");
var $fdfdbff86785fba7$var$isSuspenseSentinel = $crk1n.isSuspenseSentinel;

var $8DIRW = parcelRequire("8DIRW");

var $euPdh = parcelRequire("euPdh");

var $lkenx = parcelRequire("lkenx");
var $fdfdbff86785fba7$var$CLIENT_EDGE_TRAVERSAL_PATH = $lkenx.CLIENT_EDGE_TRAVERSAL_PATH, $fdfdbff86785fba7$var$FRAGMENT_OWNER_KEY = $lkenx.FRAGMENT_OWNER_KEY, $fdfdbff86785fba7$var$FRAGMENT_PROP_NAME_KEY = $lkenx.FRAGMENT_PROP_NAME_KEY, $fdfdbff86785fba7$var$FRAGMENTS_KEY = $lkenx.FRAGMENTS_KEY, $fdfdbff86785fba7$var$ID_KEY = $lkenx.ID_KEY, $fdfdbff86785fba7$var$MODULE_COMPONENT_KEY = $lkenx.MODULE_COMPONENT_KEY, $fdfdbff86785fba7$var$ROOT_ID = $lkenx.ROOT_ID, $fdfdbff86785fba7$var$getArgumentValues = $lkenx.getArgumentValues, $fdfdbff86785fba7$var$getModuleComponentKey = $lkenx.getModuleComponentKey, $fdfdbff86785fba7$var$getStorageKey = $lkenx.getStorageKey;

var $5KJYn = parcelRequire("5KJYn");
var $fdfdbff86785fba7$var$NoopResolverCache = $5KJYn.NoopResolverCache;

var $imSuX = parcelRequire("imSuX");
var $fdfdbff86785fba7$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $imSuX.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $fdfdbff86785fba7$var$withResolverContext = $imSuX.withResolverContext;

var $jYfKW = parcelRequire("jYfKW");
var $fdfdbff86785fba7$var$generateTypeID = $jYfKW.generateTypeID;

var $1K7ys = parcelRequire("1K7ys");
function $fdfdbff86785fba7$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $fdfdbff86785fba7$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $fdfdbff86785fba7$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $fdfdbff86785fba7$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $fdfdbff86785fba7$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $euPdh.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1K7ys(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($fdfdbff86785fba7$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $fdfdbff86785fba7$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $fdfdbff86785fba7$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $1K7ys(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $1K7ys(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $1K7ys(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $1K7ys(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $euPdh.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = $fdfdbff86785fba7$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $fdfdbff86785fba7$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $fdfdbff86785fba7$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$fdfdbff86785fba7$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $fdfdbff86785fba7$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $fdfdbff86785fba7$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $fdfdbff86785fba7$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $fdfdbff86785fba7$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($fdfdbff86785fba7$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $1K7ys(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $fdfdbff86785fba7$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $1K7ys(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $1K7ys(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $1K7ys(false);
                var localId = $fdfdbff86785fba7$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $1K7ys(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $fdfdbff86785fba7$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $fdfdbff86785fba7$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $1K7ys(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $1K7ys(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $1K7ys(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $1K7ys(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $fdfdbff86785fba7$var$getStorageKey(field, this._variables);
        var value = $euPdh.getValue(record, storageKey);
        if (value === null || $66wAr.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $fdfdbff86785fba7$var$getStorageKey(field, this._variables);
        var linkedID = $euPdh.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $1K7ys(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $fdfdbff86785fba7$var$getStorageKey(field, this._variables);
        var externalRef = $euPdh.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $euPdh.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $fdfdbff86785fba7$var$getStorageKey(field, this._variables);
        var linkedIDs = $euPdh.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $66wAr.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $1K7ys(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $1K7ys(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $fdfdbff86785fba7$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $euPdh.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$fdfdbff86785fba7$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$fdfdbff86785fba7$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $euPdh.getType(record);
        return typeName != null && typeName === type || $euPdh.getDataID(record) === $fdfdbff86785fba7$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$fdfdbff86785fba7$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$fdfdbff86785fba7$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $1K7ys(false);
        if (data[$fdfdbff86785fba7$var$ID_KEY] == null) data[$fdfdbff86785fba7$var$ID_KEY] = $euPdh.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $fdfdbff86785fba7$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$fdfdbff86785fba7$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$fdfdbff86785fba7$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $fdfdbff86785fba7$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$fdfdbff86785fba7$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$fdfdbff86785fba7$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $1K7ys(false);
        if (data[$fdfdbff86785fba7$var$ID_KEY] == null) data[$fdfdbff86785fba7$var$ID_KEY] = $euPdh.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $fdfdbff86785fba7$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $8DIRW.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $euPdh.getType(record);
        var typeRecord = this._recordSource.get($fdfdbff86785fba7$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $euPdh.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $fdfdbff86785fba7$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $fdfdbff86785fba7$var$_objectSpread2["default"])((0, $fdfdbff86785fba7$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $1K7ys(false);
    }
}
function $fdfdbff86785fba7$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $fdfdbff86785fba7$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $fdfdbff86785fba7$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $fdfdbff86785fba7$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $1K7ys(false);
}
module.exports = {
    read: $fdfdbff86785fba7$var$read
};

});
parcelRegister("5KJYn", function(module, exports) {
'use strict';

var $eTaxe = parcelRequire("eTaxe");
var $4304e8dff9e4d071$var$RELAY_LIVE_RESOLVER = $eTaxe.RELAY_LIVE_RESOLVER;

var $1K7ys = parcelRequire("1K7ys");
var $4304e8dff9e4d071$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $4304e8dff9e4d071$var$RELAY_LIVE_RESOLVER) && $1K7ys(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $1K7ys(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $4304e8dff9e4d071$var$NoopResolverCache
};

});


parcelRegister("Ki1pp", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $08b246bb28148bde$var$_interopRequireDefault = $5gh7j.default;

var $08b246bb28148bde$var$_createForOfIteratorHelper2 = $08b246bb28148bde$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $jSfhA = parcelRequire("jSfhA");

var $c9nvR = parcelRequire("c9nvR");

var $01odE = parcelRequire("01odE");

var $8DIRW = parcelRequire("8DIRW");
var $08b246bb28148bde$var$getLocalVariables = $8DIRW.getLocalVariables;

var $euPdh = parcelRequire("euPdh");

var $lkenx = parcelRequire("lkenx");

var $jYfKW = parcelRequire("jYfKW");
var $08b246bb28148bde$var$generateTypeID = $jYfKW.generateTypeID;

var $1K7ys = parcelRequire("1K7ys");
var $08b246bb28148bde$var$getReadTimeResolverStorageKey = $lkenx.getReadTimeResolverStorageKey, $08b246bb28148bde$var$getStorageKey = $lkenx.getStorageKey, $08b246bb28148bde$var$getModuleOperationKey = $lkenx.getModuleOperationKey;
function $08b246bb28148bde$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $08b246bb28148bde$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $08b246bb28148bde$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $1K7ys(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $euPdh.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $lkenx.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $euPdh.getType(record);
                        var typeID = $08b246bb28148bde$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $08b246bb28148bde$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $c9nvR(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $euPdh.getType(record);
                    var _typeID = $08b246bb28148bde$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $1K7ys(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $01odE(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $08b246bb28148bde$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $euPdh.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $08b246bb28148bde$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $euPdh.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $08b246bb28148bde$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $euPdh.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $1K7ys(false);
        var operationKey = $08b246bb28148bde$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $euPdh.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $jSfhA(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $08b246bb28148bde$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $08b246bb28148bde$var$getStorageKey(field, this._variables);
        var linkedID = $euPdh.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $08b246bb28148bde$var$getStorageKey(field, this._variables);
        var linkedIDs = $euPdh.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $08b246bb28148bde$var$mark
};

});

parcelRegister("jQCJW", function(module, exports) {
'use strict';
parcelRequire("1RL2Z");

var $dJL9K = parcelRequire("dJL9K");

var $66wAr = parcelRequire("66wAr");

var $8thcB = parcelRequire("8thcB");

var $69CCc = parcelRequire("69CCc");

var $lNZkG = parcelRequire("lNZkG");
var $e730ec9ea95f5ea9$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $lNZkG.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $dJL9K(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $8thcB(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $lNZkG.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $dJL9K(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $66wAr.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($66wAr.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $69CCc(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $e730ec9ea95f5ea9$var$RelayStoreSubscriptions;

});
parcelRegister("8thcB", function(module, exports) {
'use strict';
var $62ae602ac85df998$var$ITERATOR_KEY = Symbol.iterator;
function $62ae602ac85df998$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$62ae602ac85df998$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $62ae602ac85df998$var$hasOverlappingIDs;

});

parcelRegister("69CCc", function(module, exports) {
'use strict';

var $lkenx = parcelRequire("lkenx");
var $47b189805327deda$var$ROOT_ID = $lkenx.ROOT_ID;

var $2vrix = parcelRequire("2vrix");
var $47b189805327deda$var$VIEWER_ID = $2vrix.VIEWER_ID;
var $47b189805327deda$var$ITERATOR_KEY = Symbol.iterator;
function $47b189805327deda$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$47b189805327deda$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $47b189805327deda$var$ROOT_ID && key !== $47b189805327deda$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $47b189805327deda$var$hasSignificantOverlappingIDs;

});



parcelRegister("jjgVg", function(module, exports) {
'use strict';
var $e0eceb296dab1612$var$_global$ErrorUtils$ap, $e0eceb296dab1612$var$_global$ErrorUtils;

var $lGKdT = parcelRequire("lGKdT");

var $19baH = parcelRequire("19baH");

var $8Dynt = parcelRequire("8Dynt");

var $66wAr = parcelRequire("66wAr");

var $lNZkG = parcelRequire("lNZkG");

var $a6Cv6 = parcelRequire("a6Cv6");

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
var $e0eceb296dab1612$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $e0eceb296dab1612$var$applyWithGuard = ($e0eceb296dab1612$var$_global$ErrorUtils$ap = $e0eceb296dab1612$var$_global === null || $e0eceb296dab1612$var$_global === void 0 ? void 0 : ($e0eceb296dab1612$var$_global$ErrorUtils = $e0eceb296dab1612$var$_global.ErrorUtils) === null || $e0eceb296dab1612$var$_global$ErrorUtils === void 0 ? void 0 : $e0eceb296dab1612$var$_global$ErrorUtils.applyWithGuard) !== null && $e0eceb296dab1612$var$_global$ErrorUtils$ap !== void 0 ? $e0eceb296dab1612$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $e0eceb296dab1612$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $1K7ys(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $66wAr.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $1K7ys(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $lGKdT(this._store.getSource(), source);
        var recordSourceProxy = new $19baH(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $1K7ys(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $1K7ys(false);
            var recordSourceSelectorProxy = new $8Dynt(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $e0eceb296dab1612$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $a6Cv6.create();
                var mutator = new $lGKdT(_this2._store.getSource(), sink);
                var recordSourceProxy = new $19baH(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $e0eceb296dab1612$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $a6Cv6.create();
        var mutator = new $lGKdT(this._store.getSource(), sink);
        var recordSourceProxy = new $19baH(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $e0eceb296dab1612$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $e0eceb296dab1612$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $8Dynt(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $e0eceb296dab1612$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $e0eceb296dab1612$var$lookupSelector(source, selector) {
    var selectorData = $lNZkG.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $e0eceb296dab1612$var$RelayPublishQueue;

});
parcelRegister("8Dynt", function(module, exports) {
'use strict';

var $lkenx = parcelRequire("lkenx");
var $649ca1e64fa99117$var$ROOT_TYPE = $lkenx.ROOT_TYPE, $649ca1e64fa99117$var$getStorageKey = $lkenx.getStorageKey;

var $cq1kq = parcelRequire("cq1kq");
var $649ca1e64fa99117$var$_readUpdatableFragment = $cq1kq.readUpdatableFragment;

var $f9Urh = parcelRequire("f9Urh");
var $649ca1e64fa99117$var$_readUpdatableQuery = $f9Urh.readUpdatableQuery;

var $1K7ys = parcelRequire("1K7ys");
var $649ca1e64fa99117$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $649ca1e64fa99117$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $1K7ys(false);
        !(field.plural === plural) && $1K7ys(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $649ca1e64fa99117$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $649ca1e64fa99117$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $649ca1e64fa99117$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $649ca1e64fa99117$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $649ca1e64fa99117$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("dPhxy", function(module, exports) {
'use strict';

var $kZr0r = parcelRequire("kZr0r");

var $gTVNa = parcelRequire("gTVNa");
var $a10da4e2ede27364$var$getRequest = $gTVNa.getRequest;

var $aMn0M = parcelRequire("aMn0M");
var $a10da4e2ede27364$var$createOperationDescriptor = $aMn0M.createOperationDescriptor;

var $jvXON = parcelRequire("jvXON");
var $a10da4e2ede27364$var$createReaderSelector = $jvXON.createReaderSelector;
parcelRequire("cfakl");
function $a10da4e2ede27364$var$requestSubscription(environment, config) {
    var subscription = $a10da4e2ede27364$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $a10da4e2ede27364$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $kZr0r.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $a10da4e2ede27364$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $a10da4e2ede27364$var$requestSubscription;

});

parcelRegister("2deOb", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $19c84850d850eb2c$var$_interopRequireDefault = $5gh7j.default;

var $19c84850d850eb2c$var$_objectSpread2 = $19c84850d850eb2c$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $lkenx = parcelRequire("lkenx");
var $19c84850d850eb2c$var$getModuleComponentKey = $lkenx.getModuleComponentKey, $19c84850d850eb2c$var$getModuleOperationKey = $lkenx.getModuleOperationKey;
function $19c84850d850eb2c$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $19c84850d850eb2c$var$_objectSpread2["default"])({}, response);
    data[$19c84850d850eb2c$var$getModuleComponentKey(name)] = component;
    data[$19c84850d850eb2c$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $19c84850d850eb2c$var$createPayloadFor3DField;

});

parcelRegister("fzp6q", function(module, exports) {
'use strict';

var $jvXON = parcelRequire("jvXON");
var $b55d98bcceaaa478$var$getDataIDsFromFragment = $jvXON.getDataIDsFromFragment, $b55d98bcceaaa478$var$getSelector = $jvXON.getSelector, $b55d98bcceaaa478$var$getVariablesFromFragment = $jvXON.getVariablesFromFragment;

var $1n4cI = parcelRequire("1n4cI");

var $66wAr = parcelRequire("66wAr");

var $6XY91 = parcelRequire("6XY91");
var $b55d98bcceaaa478$var$stableCopy = $6XY91.stableCopy;

var $7lmyq = parcelRequire("7lmyq");
var $b55d98bcceaaa478$var$intern = $7lmyq.intern;
function $b55d98bcceaaa478$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $b55d98bcceaaa478$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $b55d98bcceaaa478$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $b55d98bcceaaa478$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($66wAr.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $66wAr.STRING_INTERN_LEVEL <= 1 ? ids : $b55d98bcceaaa478$var$intern(ids, $66wAr.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $1n4cI(fragmentVariables) ? '{}' : JSON.stringify($b55d98bcceaaa478$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $66wAr.STRING_INTERN_LEVEL <= 1 ? _ids : $b55d98bcceaaa478$var$intern(_ids, $66wAr.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($b55d98bcceaaa478$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $b55d98bcceaaa478$var$getFragmentIdentifier;

});
parcelRegister("1n4cI", function(module, exports) {
'use strict';
var $0ffb33492aa6ffd7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ffb33492aa6ffd7$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($0ffb33492aa6ffd7$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $0ffb33492aa6ffd7$var$isEmptyObject;

});


parcelRegister("4A9VA", function(module, exports) {
'use strict';

var $jvKQd = parcelRequire("jvKQd");

var $1K7ys = parcelRequire("1K7ys");
function $356239aa92024ca1$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $jvKQd(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $1K7ys(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $1K7ys(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $1K7ys(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $356239aa92024ca1$var$getPaginationMetadata;

});
parcelRegister("jvKQd", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");
function $e3453f3bf6d27683$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $1K7ys(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $1K7ys(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $1K7ys(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $1K7ys(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $1K7ys(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $e3453f3bf6d27683$var$getRefetchMetadata;

});


parcelRegister("e3ZLe", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $a3d140ee2665e8ad$var$_interopRequireDefault = $5gh7j.default;

var $a3d140ee2665e8ad$var$_defineProperty2 = $a3d140ee2665e8ad$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $a3d140ee2665e8ad$var$_objectSpread4 = $a3d140ee2665e8ad$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $1K7ys = parcelRequire("1K7ys");
parcelRequire("cfakl");
function $a3d140ee2665e8ad$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $1K7ys(false);
        var _paginationVariables = (0, $a3d140ee2665e8ad$var$_objectSpread4["default"])((0, $a3d140ee2665e8ad$var$_objectSpread4["default"])((0, $a3d140ee2665e8ad$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $a3d140ee2665e8ad$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $a3d140ee2665e8ad$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $1K7ys(false);
    var paginationVariables = (0, $a3d140ee2665e8ad$var$_objectSpread4["default"])((0, $a3d140ee2665e8ad$var$_objectSpread4["default"])((0, $a3d140ee2665e8ad$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $a3d140ee2665e8ad$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $a3d140ee2665e8ad$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $a3d140ee2665e8ad$var$getPaginationVariables;

});

parcelRegister("bmFCC", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $84620908a993293c$var$_interopRequireDefault = $5gh7j.default;

var $84620908a993293c$var$_createForOfIteratorHelper2 = $84620908a993293c$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $1K7ys = parcelRequire("1K7ys");
function $84620908a993293c$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $84620908a993293c$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $1K7ys(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $1K7ys(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $84620908a993293c$var$getValueAtPath;

});

parcelRegister("4T9RZ", function(module, exports) {
'use strict';
var $38f3f46b9731b080$var$profileHandlersByName = {};
var $38f3f46b9731b080$var$defaultProfiler = {
    stop: function stop() {}
};
var $38f3f46b9731b080$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $38f3f46b9731b080$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $38f3f46b9731b080$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$38f3f46b9731b080$var$profileHandlersByName.hasOwnProperty(name)) $38f3f46b9731b080$var$profileHandlersByName[name] = [];
        $38f3f46b9731b080$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($38f3f46b9731b080$var$profileHandlersByName.hasOwnProperty(name)) $38f3f46b9731b080$var$removeFromArray($38f3f46b9731b080$var$profileHandlersByName[name], handler);
    }
};
function $38f3f46b9731b080$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $38f3f46b9731b080$var$RelayProfiler;

});



parcelRegister("95JF0", function(module, exports) {
$parcel$export(module.exports, "fetchBrandingData", () => $c10197a888ef796c$export$7bfdb01d731b8001);
$parcel$export(module.exports, "convertToHCBrandingResponse", () => $c10197a888ef796c$export$4560b37f8fc33ae3);

var $8t8PZ = parcelRequire("8t8PZ");

var $6mmHn = parcelRequire("6mmHn");

var $f2UoR = parcelRequire("f2UoR");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $4Ysr0 = parcelRequire("4Ysr0");
const $c10197a888ef796c$export$7bfdb01d731b8001 = ()=>{
    return (0, $f2UoR.fetchQuery)((0, $4Ysr0.getRelayEnvironment)(), (0, $8t8PZ.default), {
        cloudId: (0, $6mmHn.getCloudId)(),
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)()
    }, {
        fetchPolicy: 'store-or-network'
    });
};
const $c10197a888ef796c$var$mapTranslations = (translations, fieldName, acc)=>{
    translations === null || translations === void 0 || translations.forEach((translation)=>{
        if (translation && acc[translation === null || translation === void 0 ? void 0 : translation.locale] !== undefined) acc[translation.locale][fieldName] = translation.value;
        else if (translation) acc[translation === null || translation === void 0 ? void 0 : translation.locale] = {
            [fieldName]: translation.value,
            localeDisplayName: translation.localeDisplayName
        };
    });
};
const $c10197a888ef796c$export$4560b37f8fc33ae3 = (response)=>{
    var _response$helpCenter;
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        var _homePageAnnouncement, _homePageAnnouncement2;
        const branding = data.helpCenterBranding;
        const announcements = data.announcements;
        const sharedPortalName = data.name;
        const { homePageAnnouncements: homePageAnnouncements } = announcements || {};
        const { logo: logo, banner: banner, homePageTitle: homePageTitle, colors: colors, hasTopBarBeenSplit: hasTopBarBeenSplit } = branding;
        const initialTranslation = {};
        let translations = {};
        if (homePageAnnouncements) translations = homePageAnnouncements === null || homePageAnnouncements === void 0 ? void 0 : homePageAnnouncements.filter((announcement)=>!!announcement).reduce((acc, announcement)=>{
            const { nameTranslationsRaw: nameTranslationsRaw, descriptionTranslationsRaw: descriptionTranslationsRaw } = announcement;
            $c10197a888ef796c$var$mapTranslations(nameTranslationsRaw, 'announcementHeader', acc);
            $c10197a888ef796c$var$mapTranslations(descriptionTranslationsRaw, 'announcementMessage', acc);
            return acc;
        }, initialTranslation);
        $c10197a888ef796c$var$mapTranslations(sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.translations, 'sharedPortalName', translations);
        $c10197a888ef796c$var$mapTranslations(homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.translations, 'helpCenterTitle', translations);
        const getDefaultTitle = ()=>{
            if (isCSM) return 'How can we help?';
            return 'Welcome to the Help Center';
        };
        const portalThemeColor = (colors === null || colors === void 0 ? void 0 : colors.primary) || '#0074e0';
        const helpCenterTitleColor = (colors === null || colors === void 0 ? void 0 : colors.bannerTextColor) || '#ffffff';
        return {
            translations: translations,
            portalThemeColor: portalThemeColor,
            helpCenterTitleColor: helpCenterTitleColor,
            logoUrl: (logo === null || logo === void 0 ? void 0 : logo.url) || '',
            logoId: (logo === null || logo === void 0 ? void 0 : logo.fileId) || '',
            bannerMediaApiFileId: (banner === null || banner === void 0 ? void 0 : banner.fileId) || '',
            bannerMediaApiUrl: (banner === null || banner === void 0 ? void 0 : banner.url) || '',
            helpCenterTitle: (homePageTitle === null || homePageTitle === void 0 ? void 0 : homePageTitle.default) || getDefaultTitle(),
            canEditAnnouncement: !!(announcements !== null && announcements !== void 0 && announcements.canEditHomePageAnnouncement),
            userInitialAnnouncementHeader: homePageAnnouncements && ((_homePageAnnouncement = homePageAnnouncements[0]) === null || _homePageAnnouncement === void 0 ? void 0 : _homePageAnnouncement.name) || '',
            userInitialAnnouncementMessageWiki: homePageAnnouncements && ((_homePageAnnouncement2 = homePageAnnouncements[0]) === null || _homePageAnnouncement2 === void 0 ? void 0 : _homePageAnnouncement2.description) || '',
            sharedPortalName: isCSM ? '' : (sharedPortalName === null || sharedPortalName === void 0 ? void 0 : sharedPortalName.default) || '',
            siteDefaultLanguageTag: data.siteDefaultLanguageTag || 'en-US',
            userLanguageTag: data.userLanguageTag || 'en-US',
            topBarColor: (colors === null || colors === void 0 ? void 0 : colors.topBarColor) || portalThemeColor,
            topBarTextColor: (colors === null || colors === void 0 ? void 0 : colors.topBarTextColor) || helpCenterTitleColor,
            hasTopBarBeenSplit: hasTopBarBeenSplit ?? false,
            isBannerAvailable: !!branding.isBannerAvailable,
            useDefaultBanner: !!branding.useDefaultBanner,
            isLogoAvailable: !!branding.isLogoAvailable
        };
    }
    return null;
};

});
parcelRegister("8t8PZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $624ff9d65694ee8b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<762b42f3490374656d56e2bee709a301>>
 * @relayHash d9e8688fd258712e7252323bfaac25bd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6
const $624ff9d65694ee8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "default"
        },
        {
            "concreteType": "HelpCenterTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": true,
            "selections": v4 /*: any*/ 
        }
    ], v6 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "fileId"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v8 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterHomePageTitle",
                "kind": "LinkedField",
                "name": "homePageTitle",
                "plural": false,
                "selections": v5 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": v7 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "bannerTextColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarColor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "topBarTextColor"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "isBannerAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "isLogoAvailable"
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            },
            {
                "kind": "ScalarField",
                "name": "hasTopBarBeenSplit"
            }
        ]
    }, v9 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "canEditHomePageAnnouncement"
            },
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "homePageAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v4 /*: any*/ 
                    }
                ]
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v11 = {
        "kind": "ScalarField",
        "name": "userLanguageTag"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "helpCenter.helpCenterById.helpCenterBranding"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterBrandingQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4022d9416d0f15d10e96cf464eb40e25456a447dd4ffcf15934193900d7b3bf6",
            "metadata": {},
            "name": "helpCenterBrandingQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$624ff9d65694ee8b$var$node.hash = "4d4bfd3b05fd09feee5f588ec411df08";
var $624ff9d65694ee8b$export$2e2bcd8739ae039 = $624ff9d65694ee8b$var$node;

});

parcelRegister("4Ysr0", function(module, exports) {
$parcel$export(module.exports, "getRelayEnvironment", () => $86fa5992c460d391$export$ffa93f1e5be01566);

var $bG6ob = parcelRequire("bG6ob");

var $3H4LK = parcelRequire("3H4LK");

var $f8vTV = parcelRequire("f8vTV");

var $72gtd = parcelRequire("72gtd");

var $6gWsU = parcelRequire("6gWsU");

var $l5Ezo = parcelRequire("l5Ezo");

var $aGOTZ = parcelRequire("aGOTZ");

var $43OzE = parcelRequire("43OzE");
const $86fa5992c460d391$var$sharedRelayEnvironment = (0, $f8vTV.createRelayEnvironment)({
    ...!(0, $bG6ob.isFixRelayIdConflictInHelpCenter)() ? {
        getDataID: undefined
    } : {},
    networkOptions: {
        setEndpoint: (0, $6gWsU.default).setEndpoint,
        getHeaders: (0, $6gWsU.default).getHeaders,
        isServer: false,
        subscribeExtensions: (0, $aGOTZ.subscribeOptions).extensions,
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onSubscribeError: (0, $aGOTZ.subscribeOptions).onError,
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onSubscribeTrigger: (0, $aGOTZ.subscribeOptions).onTrigger,
        queryResponseCache: (0, $l5Ezo.QueryResponseCache),
        validateResponse: (0, $6gWsU.default).validateResponse,
        onFetchError: (0, $6gWsU.default).onFetchError
    }
});
const $86fa5992c460d391$export$ffa93f1e5be01566 = ()=>{
    if ((0, $3H4LK.fg)('platform_relay_use_shared_relay_env_help_center')) return $86fa5992c460d391$var$sharedRelayEnvironment;
    return 0, $72gtd.default;
};

});
parcelRegister("f8vTV", function(module, exports) {
$parcel$export(module.exports, "createRelayEnvironment", () => $d8e7868562a1ca55$export$7afaa9c867644497);

var $f2UoR = parcelRequire("f2UoR");

var $bj5uT = parcelRequire("bj5uT");

var $yLYo1 = parcelRequire("yLYo1");

var $krMLN = parcelRequire("krMLN");

var $96dA5 = parcelRequire("96dA5");

var $bSFad = parcelRequire("bSFad");

var $jDa5Y = parcelRequire("jDa5Y");

var $dBHZ4 = parcelRequire("dBHZ4");

var $3yVtV = parcelRequire("3yVtV");
// Enable Relay Resolvers globally for this module
(0, $f2UoR.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $d8e7868562a1ca55$var$createNetwork(networkOptions) {
    return (0, $f2UoR.Network).create((request, variables, cacheConfig)=>(0, $bSFad.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, $3yVtV.createSubscribeFn)(networkOptions) : undefined);
}
const $d8e7868562a1ca55$var$createStore = (source, options)=>{
    return new (0, (/*@__PURE__*/$parcel$interopDefault($bj5uT)))(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $d8e7868562a1ca55$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $f2UoR.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $d8e7868562a1ca55$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $yLYo1.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $krMLN.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $d8e7868562a1ca55$var$deleteNode(connection, id);
            }
        });
    }
};
function $d8e7868562a1ca55$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $d8e7868562a1ca55$var$DeleteEdgeHandler;
        default:
            return (0, $f2UoR.DefaultHandlerProvider)(handle);
    }
}
function $d8e7868562a1ca55$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID }) {
    return new (0, $f2UoR.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: $d8e7868562a1ca55$var$createNetwork(networkOptions || {
            isServer: false
        }),
        store: $d8e7868562a1ca55$var$createStore(new (0, $f2UoR.RecordSource)(), {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $96dA5.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $96dA5.default),
        scheduler: (0, $dBHZ4.default),
        missingFieldHandlers: (0, $jDa5Y.default),
        handlerProvider: $d8e7868562a1ca55$var$HandlerProvider
    });
}

});
parcelRegister("bj5uT", function(module, exports) {
'use strict';

var $56dkm = parcelRequire("56dkm");
module.exports = $56dkm;

});

parcelRegister("krMLN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee2c28ef93eb18ef$export$2e2bcd8739ae039);
var $ee2c28ef93eb18ef$var$isProduction = true;
function $ee2c28ef93eb18ef$var$warning(condition, message) {
    if (!$ee2c28ef93eb18ef$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $ee2c28ef93eb18ef$export$2e2bcd8739ae039 = $ee2c28ef93eb18ef$var$warning;

});

parcelRegister("96dA5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4daa2448f8e68902$export$2e2bcd8739ae039);
function $4daa2448f8e68902$export$2e2bcd8739ae039(fieldValue, typeName) {
    const { id: id } = fieldValue;
    if (id == null) return undefined;
    return `${String(id)}:::::${typeName}`;
}

});

parcelRegister("bSFad", function(module, exports) {
$parcel$export(module.exports, "fetch", () => $259e08a24532719c$export$e7aa7bc5c1b3cfb3);

var $5j9vJ = parcelRequire("5j9vJ");

var $f2UoR = parcelRequire("f2UoR");

var $3H4LK = parcelRequire("3H4LK");

var $cnj30 = parcelRequire("cnj30");

var $8tbBZ = parcelRequire("8tbBZ");

var $cCnqw = parcelRequire("cCnqw");

var $cK5Pl = parcelRequire("cK5Pl");

var $1TIqB = parcelRequire("1TIqB");

var $cyzNI = parcelRequire("cyzNI");

var $la1ty = parcelRequire("la1ty");

var $at6Ca = parcelRequire("at6Ca");

var $ac9TD = parcelRequire("ac9TD");
const $259e08a24532719c$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $259e08a24532719c$var$moduleID = 'relay-fetch';
const $259e08a24532719c$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    var _dependencies$getLogg;
    if ((0, $3H4LK.fg)('nike_redirect-logic-jira')) {
        var _dependencies$didPref;
        if ((dependencies === null || dependencies === void 0 || (_dependencies$didPref = dependencies.didPreflightAuthenticationCheckTriggerRedirect) === null || _dependencies$didPref === void 0 ? void 0 : _dependencies$didPref.call(dependencies, request, variables, cacheConfig)) === true) // Jira's preflight check starts login navigation as a side effect. Keep Relay pending
        // while the redirect takes over instead of starting a fetch with a stale auth state.
        return (0, $f2UoR.Observable).from(new Promise(()=>{}));
    }
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies === null || dependencies === void 0 || (_dependencies$getLogg = dependencies.getLoggingAndMetricsHelper) === null || _dependencies$getLogg === void 0 ? void 0 : _dependencies$getLogg.call(dependencies, loggingMetadata);
    function augmentResponse(response) {
        (0, $cK5Pl.addTraceId)(queryName, (0, $ac9TD.getTraceIdFromExtensions)(response));
        (0, $cnj30.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && // DO NOT ADD TO THIS CONDITION.
        // Doing so can make service timeouts in non-critical dependencies result in a complete breakage of experiences.
        // If requesting a namespaced field, flatten it - e.g. "query { foo { bar {" should become "query { foo_bar {".
        // See https://atlassian.slack.com/archives/C01E2MPPLE4/p1780367270438419.
        (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $f2UoR.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$259e08a24532719c$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                var _dependencies$earlySc;
                const endpoint = (0, $8tbBZ.getAggEndpoint)(request, cacheConfig);
                const body = (0, $8tbBZ.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies !== null && dependencies !== void 0 && dependencies.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies !== null && dependencies !== void 0 && dependencies.getAbortSignal) options.signal = dependencies === null || dependencies === void 0 ? void 0 : dependencies.getAbortSignal();
                const fetchOverNetwork = (0, $la1ty.buildGraphqlSmartFetch)({
                    url: dependencies !== null && dependencies !== void 0 && dependencies.setEndpoint ? dependencies === null || dependencies === void 0 ? void 0 : dependencies.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: (dependencies === null || dependencies === void 0 ? void 0 : dependencies.isServer) || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies === null || dependencies === void 0 || (_dependencies$earlySc = dependencies.earlyScriptPromise) === null || _dependencies$earlySc === void 0 ? void 0 : _dependencies$earlySc.call(dependencies, request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies !== null && dependencies !== void 0 && dependencies.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $la1ty.processMultipartPromise)(()=>(0, $at6Ca.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $at6Ca.shouldRetry),
                        retryAttempts: (0, $at6Ca.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics === null || loggingAndMetrics === void 0 ? void 0 : loggingAndMetrics.logErrorRetry
                    }), dependencies === null || dependencies === void 0 ? void 0 : dependencies.onFetchError);
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $259e08a24532719c$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $cCnqw.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $cCnqw.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $cCnqw.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $259e08a24532719c$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $cyzNI.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (dependencies !== null && dependencies !== void 0 && dependencies.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                var _dependencies$onInval;
                                dependencies === null || dependencies === void 0 || (_dependencies$onInval = dependencies.onInvalidResponse) === null || _dependencies$onInval === void 0 || _dependencies$onInval.call(dependencies, request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $3H4LK.fg)('platform_relay_use_new_non_nullability')) response = $259e08a24532719c$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && requestID != null && typeof (dependencies === null || dependencies === void 0 ? void 0 : dependencies.queryResponseCache) !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies !== null && dependencies !== void 0 && dependencies.isServer && $259e08a24532719c$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!(dependencies !== null && dependencies !== void 0 && dependencies.isServer) && requestID != null) {
                var _dependencies$queryRe;
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies === null || dependencies === void 0 || (_dependencies$queryRe = dependencies.queryResponseCache) === null || _dependencies$queryRe === void 0 ? void 0 : _dependencies$queryRe.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($5j9vJ)))(ssrCache)) {
                    var _dependencies$queryRe2;
                    dependencies === null || dependencies === void 0 || (_dependencies$queryRe2 = dependencies.queryResponseCache) === null || _dependencies$queryRe2 === void 0 || _dependencies$queryRe2.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($259e08a24532719c$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $1TIqB.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $1TIqB.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                var _dependencies$handleA;
                                dependencies === null || dependencies === void 0 || (_dependencies$handleA = dependencies.handleAbort) === null || _dependencies$handleA === void 0 || _dependencies$handleA.call(dependencies, request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics === null || loggingAndMetrics === void 0 || loggingAndMetrics.logError(error);
            sink.error(error);
        }
    });
};
function $259e08a24532719c$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}

});
parcelRegister("5j9vJ", function(module, exports) {
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $3dd61abb5f33f371$var$isNil(value) {
    return value == null;
}
module.exports = $3dd61abb5f33f371$var$isNil;

});

parcelRegister("cnj30", function(module, exports) {
$parcel$export(module.exports, "putExtensions", () => $421f65809078dd8c$export$17dc47fdf278de21);
const $421f65809078dd8c$var$OperationExtensionsMap = {};
const $421f65809078dd8c$export$8656ba3981c6f6c1 = (operationName)=>{
    $421f65809078dd8c$var$OperationExtensionsMap[operationName] = $421f65809078dd8c$var$OperationExtensionsMap[operationName] || [];
};
const $421f65809078dd8c$export$f16fa6040161f056 = (operationName)=>{
    $421f65809078dd8c$var$OperationExtensionsMap[operationName] = undefined;
};
const $421f65809078dd8c$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $421f65809078dd8c$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $421f65809078dd8c$export$7c6ea4184129ef74 = (operationName)=>$421f65809078dd8c$var$OperationExtensionsMap[operationName] || [];

});

parcelRegister("8tbBZ", function(module, exports) {
$parcel$export(module.exports, "getAggEndpoint", () => $b7b1bf7901fdb495$export$fd126d8de571b77d);
$parcel$export(module.exports, "getRequestBody", () => $b7b1bf7901fdb495$export$55bce18df99af758);

var $3TFEq = parcelRequire("3TFEq");
const $b7b1bf7901fdb495$var$branchSlug = typeof $3TFEq !== 'undefined' && $3TFEq.env ? undefined : undefined;
// Pre-encoded value passed through verbatim as the `serviceOverride` query param.
const $b7b1bf7901fdb495$var$serviceOverrides = typeof $3TFEq !== 'undefined' && $3TFEq.env ? undefined : undefined;
const $b7b1bf7901fdb495$export$8f8c52ac77845a86 = `/gateway/api/graphql${$b7b1bf7901fdb495$var$branchSlug ? `/${$b7b1bf7901fdb495$var$branchSlug}/graphql` : ''}`;
const $b7b1bf7901fdb495$export$fd126d8de571b77d = (request, cacheConfig = {})=>{
    var _cacheConfig$metadata;
    let endpoint = $b7b1bf7901fdb495$export$8f8c52ac77845a86;
    if ((_cacheConfig$metadata = cacheConfig.metadata) !== null && _cacheConfig$metadata !== void 0 && _cacheConfig$metadata.META_SLOW_ENDPOINT) endpoint = `${endpoint}/slow`;
    if (request.id != null) endpoint = `${endpoint}/pq/${request.id}`;
    let url = `${endpoint}?operation=${request.name}`;
    if ($b7b1bf7901fdb495$var$serviceOverrides) url = `${url}&serviceOverride=${$b7b1bf7901fdb495$var$serviceOverrides}`;
    return url;
};
const $b7b1bf7901fdb495$export$55bce18df99af758 = (request, variables)=>{
    const requestBody = {
        operationName: request.name,
        variables: variables
    };
    return JSON.stringify(requestBody);
};

});

parcelRegister("cCnqw", function(module, exports) {
$parcel$export(module.exports, "QueryPromisesMap", () => $0d50c20086090e56$export$607b80f5bc6e396d);
$parcel$export(module.exports, "CompletedQueryPromisesMap", () => $0d50c20086090e56$export$cdadce6ed6361a2c);
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $0d50c20086090e56$export$607b80f5bc6e396d = new Map();
const $0d50c20086090e56$export$cdadce6ed6361a2c = new Map();

});

parcelRegister("cK5Pl", function(module, exports) {
$parcel$export(module.exports, "startCapturingTraceIds", () => $0304dd470df58baf$export$a2bcb2fac360646c);
$parcel$export(module.exports, "addTraceId", () => $0304dd470df58baf$export$fcaa732775f12226);
$parcel$export(module.exports, "getTraceIds", () => $0304dd470df58baf$export$5113e470f5c95670);
const $0304dd470df58baf$var$OperationTraceIdMap = {};
const $0304dd470df58baf$export$a2bcb2fac360646c = (operationName)=>{
    $0304dd470df58baf$var$OperationTraceIdMap[operationName] = $0304dd470df58baf$var$OperationTraceIdMap[operationName] || [];
};
const $0304dd470df58baf$export$559128bdc4352001 = (operationName)=>{
    $0304dd470df58baf$var$OperationTraceIdMap[operationName] = undefined;
};
const $0304dd470df58baf$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $0304dd470df58baf$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $0304dd470df58baf$export$5113e470f5c95670 = (operationName)=>$0304dd470df58baf$var$OperationTraceIdMap[operationName] || [];

});

parcelRegister("1TIqB", function(module, exports) {
$parcel$export(module.exports, "getClientDispatcher", () => $bacefbc18f5ead93$export$5bb012cf9b3a5452);

var $ly0Ck = parcelRequire("ly0Ck");
const $bacefbc18f5ead93$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $bacefbc18f5ead93$var$dispatcher;
const $bacefbc18f5ead93$export$5bb012cf9b3a5452 = ()=>{
    if (!$bacefbc18f5ead93$var$dispatcher) {
        $bacefbc18f5ead93$var$dispatcher = new (0, $ly0Ck.ClientDispatcher)();
        // Handle the server hangup scenarios
        $bacefbc18f5ead93$var$dispatcher.register($bacefbc18f5ead93$export$eb5d9c90d65c7fea, $bacefbc18f5ead93$var$dispatcher._abort.bind($bacefbc18f5ead93$var$dispatcher));
    }
    return $bacefbc18f5ead93$var$dispatcher;
};

});
parcelRegister("ly0Ck", function(module, exports) {
$parcel$export(module.exports, "ClientDispatcher", () => $08db96cc569405d3$export$3f5ba18eb97af725);
class $08db96cc569405d3$export$3f5ba18eb97af725 {
    constructor(){
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
}

});


parcelRegister("cyzNI", function(module, exports) {
$parcel$export(module.exports, "registerEvent", () => $80e1b9ebb8108400$export$bd50bc4cd3c601ee);
const $80e1b9ebb8108400$var$events = [];
const $80e1b9ebb8108400$export$bd50bc4cd3c601ee = (event)=>{
    $80e1b9ebb8108400$var$events.push(event);
};
const $80e1b9ebb8108400$export$3c7145db84d4587c = ()=>{
    return $80e1b9ebb8108400$var$events.splice(0, $80e1b9ebb8108400$var$events.length);
};

});

parcelRegister("la1ty", function(module, exports) {
$parcel$export(module.exports, "processMultipartPromise", () => $9e4a0e826e567155$export$f76505a7f2969e4e);
$parcel$export(module.exports, "buildGraphqlSmartFetch", () => $9e4a0e826e567155$export$33c9c992c7855d86);
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $lc40q = parcelRequire("lc40q");

var $f2UoR = parcelRequire("f2UoR");

var $3H4LK = parcelRequire("3H4LK");

var $7gZKB = parcelRequire("7gZKB");
const $9e4a0e826e567155$var$NO_CONTENT = 204;
function $9e4a0e826e567155$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $9e4a0e826e567155$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $9e4a0e826e567155$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $9e4a0e826e567155$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $9e4a0e826e567155$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
/**
 * Forward `error` to `observer.error`, giving the product-provided
 * `onFetchError` (if any) a chance to transform it first.
 */ function $9e4a0e826e567155$var$emitError(observer, error, response, onFetchError) {
    const transformed = onFetchError ? onFetchError(error, response) : error;
    // `Sink.error` accepts `Error` per its type, but in practice relay
    // forwards whatever it receives to consumers. Cast to keep the existing
    // signature while allowing products to return any error-like value.
    observer.error(transformed);
}
function $9e4a0e826e567155$var$handleMultipartResponse(response, observer, onFetchError) {
    const contentType = response.headers.get('content-type');
    const boundary = $9e4a0e826e567155$var$getBoundary(contentType || '');
    if (!boundary) {
        $9e4a0e826e567155$var$emitError(observer, new Error('Invalid multipart boundary'), response, onFetchError);
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $9e4a0e826e567155$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>$9e4a0e826e567155$var$emitError(observer, error, response, onFetchError));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        $9e4a0e826e567155$var$emitError(observer, error, response, onFetchError);
    }
}
function $9e4a0e826e567155$var$handleJsonResponse(response, observer, onFetchError) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>$9e4a0e826e567155$var$emitError(observer, error, response, onFetchError)).finally(()=>observer.complete());
}
function $9e4a0e826e567155$var$handleTextResponse(response, observer, onFetchError) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((responseError)=>{
        var _response$headers;
        let traceId = '';
        if ((0, $3H4LK.fg)('platform_relay_use_shared_relay_env_help_center')) traceId = `(trace-id: ${response.headers.get('atl-traceid')}) `;
        const error = new Error(`Error while parsing text response ${traceId}(Content-Type: ${response === null || response === void 0 || (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('content-type')}): ${responseError instanceof Error ? responseError.message : String(responseError)}`);
        $9e4a0e826e567155$var$emitError(observer, error, response, onFetchError);
    });
}
function $9e4a0e826e567155$export$f76505a7f2969e4e(source, onFetchError) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $f2UoR.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $9e4a0e826e567155$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $9e4a0e826e567155$var$handleJsonResponse(response, observer, onFetchError);
            else if (contentType.includes('text/plain')) $9e4a0e826e567155$var$handleTextResponse(response, observer, onFetchError);
            else if (contentType.includes('multipart/mixed')) $9e4a0e826e567155$var$handleMultipartResponse(response, observer, onFetchError);
            else $9e4a0e826e567155$var$handleTextResponse(response, observer, onFetchError);
        })// Pre-response failure (network error, AbortController, etc.) — no
        // Response object is in scope, so pass `undefined`.
        .catch((error)=>$9e4a0e826e567155$var$emitError(observer, error, undefined, onFetchError));
    });
}
const $9e4a0e826e567155$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $9e4a0e826e567155$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $9e4a0e826e567155$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $9e4a0e826e567155$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $9e4a0e826e567155$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
function $9e4a0e826e567155$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if ((0, $3H4LK.fg)('hot-302159-relay-get-killswitch')) return {
        isGetRequest: false,
        reason: 'Killswitch is on'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = $9e4a0e826e567155$export$28ae0033b80c6303(baseUrl, variables).length;
    const headersSize = $9e4a0e826e567155$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $9e4a0e826e567155$var$MAX_QUERY_LENGTH && headersSize <= $9e4a0e826e567155$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $9e4a0e826e567155$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    var _cacheConfig$metadata;
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $9e4a0e826e567155$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $7gZKB.getRelayExperimentalApis)().join(','),
        ...(cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.headers) || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = $9e4a0e826e567155$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = $9e4a0e826e567155$export$28ae0033b80c6303(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}

});
parcelRegister("7gZKB", function(module, exports) {
$parcel$export(module.exports, "getRelayExperimentalApis", () => $1f7faf7e51ef2565$export$2cb71284f72ca45b);
// Please add your Experimental API name below
// You do not need to wait for approval to add to this list
const $1f7faf7e51ef2565$export$ebe3a775ce3053a5 = [
    'ariGraph',
    'boardCardMove',
    'deleteCard',
    'JiraJqlBuilder',
    'SoftwareCardTypeTransitions',
    'jira-releases-v0',
    'JiraDevOps',
    'JiraDevOpsProviders',
    'createCustomFilter',
    'updateCustomFilter',
    'deleteCustomFilter',
    'customFilters',
    'PermissionScheme',
    'JiraIssue',
    'projectStyle',
    'startSprintPrototype',
    'AddIssuesToFixVersion',
    'JiraVersionResult',
    'JiraIssueConnectionJql',
    'JiraFieldOptionSearching',
    'JiraIssueFieldMutations',
    'JiraIssueDevInfoDetails',
    'JiraIssueDevSummaryCache',
    'JiraVersionWarningConfig',
    'JiraReleaseNotesConfiguration',
    'JiraUpdateReleaseNotesConfiguration',
    'ReleaseNotes',
    'ReleaseNotesOptions',
    'DeploymentsFeaturePrecondition',
    'UpdateVersionWarningConfig',
    'UpdateVersionName',
    'UpdateVersionDescription',
    'UpdateVersionStartDate',
    'UpdateVersionReleaseDate',
    'VersionsForProject',
    'RelatedWork',
    'SuggestedRelatedWorkCategories',
    'setIssueMediaVisibility',
    'toggleBoardFeature',
    'DevOpsProvider',
    'DevOpsSummarisedDeployments',
    'JiraProject',
    'DevOpsSummarisedEntities',
    'RoadmapsMutation',
    'RoadmapsQuery',
    'JiraApplicationProperties',
    'JiraIssueSearch',
    'JiraFilter',
    'featureGroups',
    'setBoardEstimationType',
    'devOps',
    'softwareBoards',
    'name',
    'AddRelatedWorkToVersion',
    'RemoveRelatedWorkFromVersion',
    'admins',
    'canAdministerBoard',
    'jql',
    'globalCardCreateAdditionalFields',
    'GlobalTimeTrackingSettings',
    'ReleaseNotesOptions',
    'search-experience',
    'MoveOrRemoveIssuesToFixVersion',
    'compass-beta',
    'JiraIssueSearchStatus',
    'Townsquare',
    'JiraNavigationItems',
    'JiraVersionsForProjects',
    'columnConfigs',
    'help-object-store-agg-beta',
    'HelpCenterReorderTopics',
    'polaris-v0'
];
const $1f7faf7e51ef2565$export$2cb71284f72ca45b = ()=>$1f7faf7e51ef2565$export$ebe3a775ce3053a5;

});


parcelRegister("at6Ca", function(module, exports) {
$parcel$export(module.exports, "retryOnError", () => $4e0672504f0beb5e$export$f859c88bfac2cf2c);
$parcel$export(module.exports, "shouldRetry", () => $4e0672504f0beb5e$export$7bfea3c3d460ecd8);
$parcel$export(module.exports, "getRetryAttemptsForQuery", () => $4e0672504f0beb5e$export$9dec0f42cc67f6ab);
const $4e0672504f0beb5e$export$81189edc9b923717 = 1;
const $4e0672504f0beb5e$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $4e0672504f0beb5e$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $4e0672504f0beb5e$export$81189edc9b923717 ? $4e0672504f0beb5e$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $4e0672504f0beb5e$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $4e0672504f0beb5e$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $4e0672504f0beb5e$export$81189edc9b923717;
    return 0;
};

});

parcelRegister("ac9TD", function(module, exports) {
$parcel$export(module.exports, "getTraceIdFromExtensions", () => $46381d23daa79338$export$eefb7f54c3b07211);

var $3H4LK = parcelRequire("3H4LK");
const $46381d23daa79338$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions === undefined || extensions.gateway === undefined || extensions.gateway === null) return undefined;
    if ((0, $3H4LK.fg)('platform_relay_fetch_use_tid_property')) {
        if (typeof extensions.gateway.tId === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.tId;
    } else {
        if (typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return extensions.gateway.trace_id;
    }
    return undefined;
};

});


parcelRegister("jDa5Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bd40169e6bd666c$export$2e2bcd8739ae039);

var $e6fd1 = parcelRequire("e6fd1");

var $96dA5 = parcelRequire("96dA5");
const $6bd40169e6bd666c$var$isCustomFilter = (filterId)=>/^\d+$/.test(filterId);
const $6bd40169e6bd666c$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
const $6bd40169e6bd666c$export$77232ec02db7a24a = {
    handle: (field, record, argValues)=>{
        // https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
        // This lets relay know that a query of
        // JiraQuery.filter(id: ID!)
        // can return:
        //   - a JiraCustomFilter object
        //   - a JiraSystemFilter object
        // determined by the type encoded within the id field (which is an ARI type).
        // By providing the id that relay would refer to those objects by, it is able to check it's
        // store to see if they are already fetched, and avoid refetching them if it is unnecessary
        if (record != null && record.getType() === 'JiraQuery' && field.name === 'filter' && argValues.id != null) {
            const { id: id } = argValues;
            const filterId = (0, $e6fd1.JiraFilterAri).parse(id).filterId;
            if ($6bd40169e6bd666c$var$isCustomFilter(filterId)) return (0, $96dA5.default)({
                id: id
            }, 'JiraCustomFilter');
            if ($6bd40169e6bd666c$var$isSystemFilter(filterId)) return (0, $96dA5.default)({
                id: id
            }, 'JiraSystemFilter');
            return undefined;
        }
        return undefined;
    },
    kind: 'linked'
};
const $6bd40169e6bd666c$var$MissingFieldHandlers = [
    $6bd40169e6bd666c$export$77232ec02db7a24a
];
var $6bd40169e6bd666c$export$2e2bcd8739ae039 = $6bd40169e6bd666c$var$MissingFieldHandlers;

});
parcelRegister("e6fd1", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAri", () => $a43d6c6fbce32344$export$3cfb6cc809e835bd);

var $54UJK = parcelRequire("54UJK");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/jira/filter/manifest.ts
var $a43d6c6fbce32344$var$jiraFilterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $54UJK.JiraFilterAriResourceOwner),
    resourceType: (0, $54UJK.JiraFilterAriResourceType),
    resourceIdSlug: "activation/{activationId}/{filterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        filterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/filter/index.ts
var $a43d6c6fbce32344$export$3cfb6cc809e835bd = class _JiraFilterAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._filterId = opts.resourceIdSegmentValues.filterId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get filterId() {
        return this._filterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a43d6c6fbce32344$var$jiraFilterAriStaticOpts.qualifier,
            platformQualifier: $a43d6c6fbce32344$var$jiraFilterAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a43d6c6fbce32344$var$jiraFilterAriStaticOpts.resourceOwner,
            resourceType: $a43d6c6fbce32344$var$jiraFilterAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.filterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                filterId: opts.filterId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $a43d6c6fbce32344$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $a43d6c6fbce32344$var$jiraFilterAriStaticOpts);
        return new _JiraFilterAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            filterId: this.filterId
        };
    }
};

});
parcelRegister("54UJK", function(module, exports) {
$parcel$export(module.exports, "JiraFilterAriResourceOwner", () => $3b29563d9f6bbece$export$e6199848f52f1119);
$parcel$export(module.exports, "JiraFilterAriResourceType", () => $3b29563d9f6bbece$export$3c64de4ae038e3ae);
// src/jira/filter/types.ts
var $3b29563d9f6bbece$export$e6199848f52f1119 = "jira", $3b29563d9f6bbece$export$3c64de4ae038e3ae = "filter";

});

parcelRegister("7NdII", function(module, exports) {
$parcel$export(module.exports, "RegisteredAri", () => $5ac7c08e4dbef35f$export$579ee78b1dcf0a11);

var $lRMM1 = parcelRequire("lRMM1");
// src/core/registered-ari.ts
var $5ac7c08e4dbef35f$export$579ee78b1dcf0a11 = class extends (0, $lRMM1.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $lRMM1.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("lRMM1", function(module, exports) {
$parcel$export(module.exports, "Ari", () => $feb461a064c7f568$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $feb461a064c7f568$export$44a7af7122933d6b);

var $bwYEm = parcelRequire("bwYEm");
// src/core/ari.ts
var $feb461a064c7f568$export$3a4885701291260b = class {
    constructor(opts){
        this._ati = (0, $bwYEm.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
};
// src/any-ari.ts
var $feb461a064c7f568$export$44a7af7122933d6b = class _AnyAri extends $feb461a064c7f568$export$3a4885701291260b {
    constructor(opts){
        super(opts);
    }
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $bwYEm.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $bwYEm.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
};

});
parcelRegister("bwYEm", function(module, exports) {
$parcel$export(module.exports, "AriParser", () => $8651bab0cff816b5$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $8651bab0cff816b5$export$ab4b293d0121b8ee);

var $USxzU = parcelRequire("USxzU");

var $bMIm8 = parcelRequire("bMIm8");
// src/core/rules/cloud-id.ts
function $8651bab0cff816b5$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $bMIm8.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $8651bab0cff816b5$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:;{}=]+(/[!a-zA-Z0-9\\-_.~@:;{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $bMIm8.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $8651bab0cff816b5$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $8651bab0cff816b5$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $8651bab0cff816b5$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $bMIm8.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $8651bab0cff816b5$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $bMIm8.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $8651bab0cff816b5$var$NUMBER_OF_ARI_SEGMENTS = 5, $8651bab0cff816b5$export$4c3a8cde7a55740b = class extends (0, $USxzU.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $8651bab0cff816b5$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $USxzU.validateAriQualifier)(qualifier), (0, $USxzU.validatePlatformQualifier)(platformQualifier), $8651bab0cff816b5$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $8651bab0cff816b5$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $8651bab0cff816b5$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $8651bab0cff816b5$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $bMIm8.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $bMIm8.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $8651bab0cff816b5$var$NUMBER_OF_ATI_SEGMENTS = 4, $8651bab0cff816b5$var$AtiParser = class extends (0, $USxzU.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $8651bab0cff816b5$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $USxzU.validateAtiQualifier)(qualifier), (0, $USxzU.validatePlatformQualifier)(platformQualifier), $8651bab0cff816b5$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $8651bab0cff816b5$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $USxzU.validateAtiQualifier)(qualifier), (0, $USxzU.validatePlatformQualifier)(platformQualifier), $8651bab0cff816b5$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $8651bab0cff816b5$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $8651bab0cff816b5$export$ab4b293d0121b8ee = class _Ati {
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $8651bab0cff816b5$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
};

});
parcelRegister("USxzU", function(module, exports) {
$parcel$export(module.exports, "validatePlatformQualifier", () => $0aaf89b3796c0b06$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $0aaf89b3796c0b06$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $0aaf89b3796c0b06$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $0aaf89b3796c0b06$export$3d09a5c28ff3e040);

var $bMIm8 = parcelRequire("bMIm8");
// src/core/rules/platform-qualifier.ts
function $0aaf89b3796c0b06$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $bMIm8.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $0aaf89b3796c0b06$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $bMIm8.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $0aaf89b3796c0b06$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $bMIm8.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $0aaf89b3796c0b06$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $bMIm8.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $0aaf89b3796c0b06$var$NUMBER_OF_BASE_SEGMENTS = 5, $0aaf89b3796c0b06$var$SEGMENT_SEPARATOR = ":", $0aaf89b3796c0b06$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($0aaf89b3796c0b06$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $bMIm8.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $0aaf89b3796c0b06$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($0aaf89b3796c0b06$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($0aaf89b3796c0b06$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("bMIm8", function(module, exports) {
$parcel$export(module.exports, "ValidationError", () => $8946959bc810d260$export$2191b9da168c6cf0);
// src/errors.ts
var $8946959bc810d260$export$2191b9da168c6cf0 = class extends Error {
};

});







parcelRegister("dBHZ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $087e556a79484b9f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$087e556a79484b9f$export$2e2bcd8739ae039 = {
    cancel: ()=>{},
    schedule: (fn)=>{
        // react 16.x
        if (// `unstable_batchedUpdates` is defined in all currently supported versions
        // but could be removed in the future.
        // This check is defensive and not currently necessary.
        typeof (0, (/*@__PURE__*/$parcel$interopDefault($b2Ka1))).unstable_batchedUpdates === 'function' && // The version export was only introduced in `react-dom@16.13.0`
        // but we need to support `react-dom@^16.8.0`
        // so we need to handle when the version is `undefined`
        (typeof (0, $b2Ka1.version) === 'undefined' || (0, $b2Ka1.version).startsWith('16'))) (0, (/*@__PURE__*/$parcel$interopDefault($b2Ka1))).unstable_batchedUpdates(()=>{
            fn();
        });
        else if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).startTransition === 'function') // @ts-ignore -error React.startTransition does not exist in react-16
        (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).startTransition(()=>{
            fn();
        });
        else fn();
        return '';
    }
};

});

parcelRegister("3yVtV", function(module, exports) {
$parcel$export(module.exports, "createSubscribeFn", () => $54bc885027ce8c85$export$10f5a0700f263f11);

var $f2UoR = parcelRequire("f2UoR");

var $3H4LK = parcelRequire("3H4LK");

var $aFADe = parcelRequire("aFADe");
var $iaLgo = parcelRequire("iaLgo");
let $54bc885027ce8c85$var$cachedDefaultSubscribe;
function $54bc885027ce8c85$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $54bc885027ce8c85$var$cachedDefaultSubscribe !== 'undefined') return $54bc885027ce8c85$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $f2UoR.Observable).create((sink)=>{
            var _cacheConfig$metadata, _subscribeOptions$onS;
            const client = (0, $aFADe.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = (cacheConfig === null || cacheConfig === void 0 || (_cacheConfig$metadata = cacheConfig.metadata) === null || _cacheConfig$metadata === void 0 ? void 0 : _cacheConfig$metadata.replay) || undefined;
            // When the fix gate is ON and the caller supplies a `command` key inside
            // replayConfig, hoist it to extensions.command (flat) to match AGG's
            // expected wire shape. AGG reads extensions["command"] directly; the
            // previous extensions.replay.command nesting was silently dropped and no
            // Replay ChannelCommand was ever issued. See CRCS-3291.
            // When the gate is OFF the old extensions.replay: {...} shape is preserved,
            // which is the broken-but-stable status-quo for consumers not using replay.
            const replayCommand = replayConfig !== null && typeof replayConfig === 'object' && 'command' in replayConfig ? replayConfig.command : undefined;
            const replayExtensions = replayCommand && (0, $3H4LK.fg)('platform_relay_subscription_fix_replay_command') ? {
                command: replayCommand
            } : replayConfig ? {
                replay: replayConfig
            } : {};
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...(subscribeOptions === null || subscribeOptions === void 0 ? void 0 : subscribeOptions.subscribeExtensions) || {},
                    ...replayExtensions
                }
            };
            let requestId = null;
            subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS = subscribeOptions.onSubscribeTrigger) === null || _subscribeOptions$onS === void 0 || _subscribeOptions$onS.call(subscribeOptions, payload);
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    var _value$extensions;
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                    requestId = aggRequestId ?? requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (sinkError)=>{
                    var _subscribeOptions$onS2;
                    const errorInfo = (0, $iaLgo.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions === null || subscribeOptions === void 0 || (_subscribeOptions$onS2 = subscribeOptions.onSubscribeError) === null || _subscribeOptions$onS2 === void 0 || _subscribeOptions$onS2.call(subscribeOptions, {
                        ...payload,
                        requestId: requestId
                    });
                }
            });
        });
    if (typeof subscribeOptions === 'undefined') $54bc885027ce8c85$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $54bc885027ce8c85$export$ec068583843480e7 = $54bc885027ce8c85$export$10f5a0700f263f11();

});
parcelRegister("aFADe", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $23cf7fa28624c586$export$6bb76d6eba7e258c);

var $4MJ9c = parcelRequire("4MJ9c");

var $7gZKB = parcelRequire("7gZKB");

var $f1WXE = parcelRequire("f1WXE");

var $d6QWl = parcelRequire("d6QWl");
let $23cf7fa28624c586$var$client;
const $23cf7fa28624c586$export$6bb76d6eba7e258c = ()=>{
    if ((0, $d6QWl.isSSR)()) return null;
    if (!$23cf7fa28624c586$var$client) {
        var _window, _window2;
        $23cf7fa28624c586$var$client = (0, $4MJ9c.createClient)({
            url: (0, $d6QWl.getAggSubscriptionEndpoint)(),
            lazy: true,
            keepAlive: (0, $f1WXE.WS_CLIENT_KEEP_ALIVE),
            retryAttempts: (0, $f1WXE.WS_CLIENT_RETRIES),
            connectionParams: {
                'atl-client-name': 'jira-frontend',
                'atl-client-version': `${((_window = window) === null || _window === void 0 ? void 0 : _window.BUILD_KEY) ?? ''}::${((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.SSR_BUILD_KEY) ?? ''}`,
                'X-ExperimentalApi': (0, $7gZKB.getRelayExperimentalApis)().join(',')
            }
        });
    }
    return $23cf7fa28624c586$var$client;
};
const $23cf7fa28624c586$export$2f0afd443356d36f = ()=>{
    $23cf7fa28624c586$var$client = null;
};

});
parcelRegister("4MJ9c", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $37beaa7214795953$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $CYYjA = parcelRequire("CYYjA");

var $gZ1bJ = parcelRequire("gZ1bJ");
var $37beaa7214795953$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $37beaa7214795953$var$__await ? (this.v = v, this) : new $37beaa7214795953$var$__await(v);
};
var $37beaa7214795953$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $37beaa7214795953$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $37beaa7214795953$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $37beaa7214795953$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$37beaa7214795953$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $CYYjA.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $CYYjA.stringifyMessage)({
                                    type: (0, $CYYjA.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $37beaa7214795953$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $CYYjA.stringifyMessage)(payload ? {
                            type: (0, $CYYjA.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $CYYjA.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $CYYjA.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $CYYjA.CloseCode).InternalClientError, (0, $gZ1bJ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $CYYjA.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $CYYjA.stringifyMessage)(message.payload ? {
                                    type: (0, $CYYjA.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $CYYjA.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $CYYjA.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $CYYjA.CloseCode).BadResponse, (0, $gZ1bJ.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($37beaa7214795953$var$isLikeCloseEvent(errOrCloseEvent) && ($37beaa7214795953$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $CYYjA.CloseCode).InternalServerError,
            (0, $CYYjA.CloseCode).InternalClientError,
            (0, $CYYjA.CloseCode).BadRequest,
            (0, $CYYjA.CloseCode).BadResponse,
            (0, $CYYjA.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $CYYjA.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $CYYjA.CloseCode).SubscriberAlreadyExists,
            (0, $CYYjA.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($37beaa7214795953$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $CYYjA.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $CYYjA.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $CYYjA.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $CYYjA.stringifyMessage)({
                    id: id,
                    type: (0, $CYYjA.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $CYYjA.stringifyMessage)({
                        id: id,
                        type: (0, $CYYjA.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $37beaa7214795953$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $37beaa7214795953$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $37beaa7214795953$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $37beaa7214795953$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $37beaa7214795953$export$f5b1bfead8e118a7());
        }
    };
}
class $37beaa7214795953$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $37beaa7214795953$var$isLikeCloseEvent(val) {
    return (0, $gZ1bJ.isObject)(val) && 'code' in val && 'reason' in val;
}
function $37beaa7214795953$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $37beaa7214795953$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});
parcelRegister("CYYjA", function(module, exports) {
$parcel$export(module.exports, "GRAPHQL_TRANSPORT_WS_PROTOCOL", () => $0752d87531703fb9$export$5c0a4edfedc7c457);
$parcel$export(module.exports, "CloseCode", () => $0752d87531703fb9$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $0752d87531703fb9$export$80edbf15fa61a4db);
$parcel$export(module.exports, "parseMessage", () => $0752d87531703fb9$export$f2f615077a189f21);
$parcel$export(module.exports, "stringifyMessage", () => $0752d87531703fb9$export$77896e5b47bfd50b);
/**
 *
 * common
 *
 */ 
var $gZ1bJ = parcelRequire("gZ1bJ");
const $0752d87531703fb9$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $0752d87531703fb9$export$ec743af8bb66f3be = 'graphql-ws';
var $0752d87531703fb9$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($0752d87531703fb9$export$777128f41f6616ec || ($0752d87531703fb9$export$777128f41f6616ec = {}));
var $0752d87531703fb9$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($0752d87531703fb9$export$80edbf15fa61a4db || ($0752d87531703fb9$export$80edbf15fa61a4db = {}));
function $0752d87531703fb9$export$c17861b159b1b673(val) {
    if (!(0, $gZ1bJ.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $gZ1bJ.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $gZ1bJ.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $0752d87531703fb9$export$80edbf15fa61a4db.ConnectionInit:
        case $0752d87531703fb9$export$80edbf15fa61a4db.ConnectionAck:
        case $0752d87531703fb9$export$80edbf15fa61a4db.Ping:
        case $0752d87531703fb9$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $gZ1bJ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $0752d87531703fb9$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $gZ1bJ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $gZ1bJ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $gZ1bJ.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $gZ1bJ.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $gZ1bJ.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $gZ1bJ.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $gZ1bJ.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $gZ1bJ.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $gZ1bJ.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $gZ1bJ.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $0752d87531703fb9$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $gZ1bJ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $gZ1bJ.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $gZ1bJ.extendedTypeof)(val.payload)}`);
            break;
        case $0752d87531703fb9$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $gZ1bJ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $gZ1bJ.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $0752d87531703fb9$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $gZ1bJ.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $0752d87531703fb9$export$9e0e49e75fa7d548(val) {
    try {
        $0752d87531703fb9$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $0752d87531703fb9$export$f2f615077a189f21(data, reviver) {
    return $0752d87531703fb9$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $0752d87531703fb9$export$77896e5b47bfd50b(msg, replacer) {
    $0752d87531703fb9$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}

});
parcelRegister("gZ1bJ", function(module, exports) {
$parcel$export(module.exports, "extendedTypeof", () => $c5d343c946cecf2a$export$573326049e1b1c6b);
$parcel$export(module.exports, "isObject", () => $c5d343c946cecf2a$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "areGraphQLErrors", () => $c5d343c946cecf2a$export$e6262fbc2e92290);
$parcel$export(module.exports, "limitCloseReason", () => $c5d343c946cecf2a$export$2937fa0c8dddae54);
/** @private */ function $c5d343c946cecf2a$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $c5d343c946cecf2a$export$a6cdc56e425d0d0a(val) {
    return $c5d343c946cecf2a$export$573326049e1b1c6b(val) === 'object';
}
function $c5d343c946cecf2a$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $c5d343c946cecf2a$export$92bd080471bc30f1(val) {
    return $c5d343c946cecf2a$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $c5d343c946cecf2a$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $c5d343c946cecf2a$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}

});



parcelRegister("f1WXE", function(module, exports) {
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $f0c8c538ea31fbed$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $f0c8c538ea31fbed$export$bf6cd96e19b2987f);
const $f0c8c538ea31fbed$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $f0c8c538ea31fbed$export$bf6cd96e19b2987f = 100;
const $f0c8c538ea31fbed$export$1ad8434180c5936c = 300000; // 5m

});

parcelRegister("d6QWl", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $4f60fc4da09e6cac$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $4f60fc4da09e6cac$export$29a72e89601dfc59);
const $4f60fc4da09e6cac$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $4f60fc4da09e6cac$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;

});


parcelRegister("iaLgo", function(module, exports) {
$parcel$export(module.exports, "getSinkError", () => $451c12ea05304a4a$export$ece4736473c28965);
const $451c12ea05304a4a$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};

});



parcelRegister("72gtd", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb393a0bad826215$export$2e2bcd8739ae039);

var $bG6ob = parcelRequire("bG6ob");

var $f2UoR = parcelRequire("f2UoR");

var $ebpTf = parcelRequire("ebpTf");

var $96dA5 = parcelRequire("96dA5");

var $frhNm = parcelRequire("frhNm");

var $6KruH = parcelRequire("6KruH");

var $aGOTZ = parcelRequire("aGOTZ");

var $gOVer = parcelRequire("gOVer");
const $bb393a0bad826215$var$fetchRelay = (params, variables, cacheConfig, uploadables)=>{
    const fetcher = (0, $ebpTf.getIsPageServerSideRendered)() ? (0, $6KruH.default) : (0, $frhNm.default);
    return fetcher(params, variables, cacheConfig, uploadables);
};
const $bb393a0bad826215$var$getNetWork = ()=>{
    if ((0, $gOVer.isSSR)()) return (0, $f2UoR.Network).create($bb393a0bad826215$var$fetchRelay);
    return (0, $f2UoR.Network).create($bb393a0bad826215$var$fetchRelay, (0, $aGOTZ.subscribe));
};
const $bb393a0bad826215$export$215146372577871a = new Set([
    'HelpObjectStoreEntityData',
    'JiraServiceManagementRequestType',
    'HelpObjectStorePortalGroup',
    'HelpObjectStoreKbCategories',
    'HelpObjectStoreRequestForm',
    'HelpObjectStoreHelpObject',
    'HelpObjectStorePortalGroupRequestForm'
]);
const $bb393a0bad826215$var$getHelpObjectStoreDataID = (fieldValue, typeName)=>{
    if ($bb393a0bad826215$export$215146372577871a.has(typeName)) return (0, $96dA5.default)(fieldValue, typeName);
    // Mirror Relay's default id derivation for all other types. Copied the implementation from RelayDataID.
    const { id: id } = fieldValue;
    return id == null ? undefined : String(id);
};
const $bb393a0bad826215$var$resolveGetDataID = ()=>{
    if ((0, $bG6ob.isFixRelayIdConflictForHelpObjectStoreEnabled)()) return $bb393a0bad826215$var$getHelpObjectStoreDataID;
    if ((0, $bG6ob.isFixRelayIdConflictInHelpCenter)()) return 0, $96dA5.default;
    return undefined;
};
const $bb393a0bad826215$var$getDataID = $bb393a0bad826215$var$resolveGetDataID();
var // Export a singleton instance of Relay Environment configured with our network function:
$bb393a0bad826215$export$2e2bcd8739ae039 = new (0, $f2UoR.Environment)({
    network: $bb393a0bad826215$var$getNetWork(),
    store: new (0, $f2UoR.Store)(new (0, $f2UoR.RecordSource)()),
    ...$bb393a0bad826215$var$getDataID ? {
        getDataID: $bb393a0bad826215$var$getDataID
    } : {}
});

});
parcelRegister("frhNm", function(module, exports) {
$parcel$export(module.exports, "default", () => $b42afdeed6361a77$export$2e2bcd8739ae039);

var $6bGmX = parcelRequire("6bGmX");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");

var $fTHFO = parcelRequire("fTHFO");
const $b42afdeed6361a77$var$fetchQuery = ({ operationKind: operationKind, id: id, name: name }, variables)=>{
    const isJsmScaleTestAggCheckEnabled = (0, $6bGmX.default).checkGate('jsm_scale_60k_testing_in_help_center');
    const isAggAttributionHeadersEnabled = (0, $6bGmX.default).checkGate('jsm-help-center-agg-attribution-headers');
    const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
    let AGG_PATH = AGG_BASE_PATH;
    if (isJsmScaleTestAggCheckEnabled && (0, $ebpTf.getEnv)().environment !== (0, $ebpTf.EnvType).PROD) {
        const AGG_BRANCH_SLUG = 'branch-issue-remove-rate-limit';
        AGG_PATH = id ? `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql/pq/${id}` : `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql`;
    }
    const body = JSON.stringify({
        variables: variables,
        operationName: name
    });
    return (0, $hZWMk.fetchJson)(AGG_PATH, {
        body: body,
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            ...operationKind === 'mutation' && {
                'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
            },
            ...isAggAttributionHeadersEnabled && (0, $fTHFO.getAggHeaders)()
        }
    });
};
var $b42afdeed6361a77$export$2e2bcd8739ae039 = $b42afdeed6361a77$var$fetchQuery;

});
parcelRegister("hZWMk", function(module, exports) {
$parcel$export(module.exports, "FetchError", () => $6f5de6e73fb6cdf5$export$26e841bcf1aeb894);
$parcel$export(module.exports, "fetchJson", () => $6f5de6e73fb6cdf5$export$6d71b655afe1638d);
$parcel$export(module.exports, "handleGraphQlErrors", () => $6f5de6e73fb6cdf5$export$e7e6c134f67b83b7);
$parcel$export(module.exports, "isFetchNetworkOrClientError", () => $6f5de6e73fb6cdf5$export$68d314c2a361832e);

var $bG6ob = parcelRequire("bG6ob");

var $63sfu = parcelRequire("63sfu");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");
const $6f5de6e73fb6cdf5$var$NO_CONTENT = 204;
const $6f5de6e73fb6cdf5$var$NETWORK_ERROR_MESSAGE = 'Failed to fetch';
const $6f5de6e73fb6cdf5$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $6f5de6e73fb6cdf5$var$NETWORK_ERROR_CODE = 0;
class $6f5de6e73fb6cdf5$export$26e841bcf1aeb894 extends Error {
    constructor(message, status, filterFromSentry){
        super(message);
        this.status = status;
        this.filterFromSentry = filterFromSentry;
    }
}
const $6f5de6e73fb6cdf5$export$6d71b655afe1638d = (url, params)=>{
    return fetch(url, params).then($6f5de6e73fb6cdf5$var$handleErrors).then($6f5de6e73fb6cdf5$var$processResponseFromServer).then($6f5de6e73fb6cdf5$export$e7e6c134f67b83b7).catch($6f5de6e73fb6cdf5$var$handleNetworkErrors);
};
const $6f5de6e73fb6cdf5$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new $6f5de6e73fb6cdf5$export$26e841bcf1aeb894($6f5de6e73fb6cdf5$var$NETWORK_ERROR_MESSAGE, $6f5de6e73fb6cdf5$var$NETWORK_ERROR_CODE);
    throw err;
};
const $6f5de6e73fb6cdf5$var$handleErrors = (response)=>{
    if (!response.ok) {
        const traceId = response.headers.get('atl-traceid');
        // If the traceId is null, it indicates that the request never reached the Atlassian network. In such cases, we should not throw an error. This situation may occur if the request has been intercepted by a firewall or another proxy server. For more details, refer to the discussion in the following Slack thread: https://atlassian.slack.com/archives/C06Q6AC22MV/p1711342785804189?thread_ts=1711335142.173669&cid=C06Q6AC22MV
        if ((0, $bG6ob.isFilterNullTraceIdFromGraphqlCallsEnabled)() && !traceId) // If the request does not have a traceId we treat it as a network error.
        throw new $6f5de6e73fb6cdf5$export$26e841bcf1aeb894($6f5de6e73fb6cdf5$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $6f5de6e73fb6cdf5$var$NETWORK_ERROR_CODE);
        if (traceId) // We filter out network errors with traceId from Sentry as they are not actionable and can be investigated from Splunk.
        throw new $6f5de6e73fb6cdf5$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: ${traceId}`, response.status, true);
        throw new $6f5de6e73fb6cdf5$export$26e841bcf1aeb894(`ErrorCode: ${response.status}, traceId: null`, response.status);
    }
    return response;
};
const $6f5de6e73fb6cdf5$var$processResponseFromServer = (response)=>{
    if (response.status === $6f5de6e73fb6cdf5$var$NO_CONTENT) return Promise.resolve(null);
    return response.json();
};
const $6f5de6e73fb6cdf5$export$e7e6c134f67b83b7 = (response)=>{
    const dataEmptyCheck = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && response && typeof response === 'object' && 'data' in response ? (0, $63sfu.isEmpty)(response.data) : true;
    if (response && typeof response === 'object' && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('errors') && // @ts-ignore TS(2339) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Property 'hasOwnProperty' does not exist on type '... Remove this comment to see the full error message
    response.hasOwnProperty('extensions') && dataEmptyCheck) {
        var _graphQlResponse$exte, _graphQlResponse$erro3, _graphQlResponse$erro4;
        // throw error from graphql API
        const graphQlResponse = response;
        const traceId = (_graphQlResponse$exte = graphQlResponse.extensions) === null || _graphQlResponse$exte === void 0 || (_graphQlResponse$exte = _graphQlResponse$exte.gateway) === null || _graphQlResponse$exte === void 0 ? void 0 : _graphQlResponse$exte.request_id;
        if (traceId) {
            var _graphQlResponse$erro, _graphQlResponse$erro2;
            throw new $6f5de6e73fb6cdf5$export$26e841bcf1aeb894(`ErrorCode: ${(_graphQlResponse$erro = graphQlResponse.errors) === null || _graphQlResponse$erro === void 0 || (_graphQlResponse$erro = _graphQlResponse$erro[0]) === null || _graphQlResponse$erro === void 0 ? void 0 : _graphQlResponse$erro.message}, traceId: ${traceId}`, Number((_graphQlResponse$erro2 = graphQlResponse.errors) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2[0]) === null || _graphQlResponse$erro2 === void 0 || (_graphQlResponse$erro2 = _graphQlResponse$erro2.extensions) === null || _graphQlResponse$erro2 === void 0 ? void 0 : _graphQlResponse$erro2.statusCode) || 500, true);
        }
        throw new $6f5de6e73fb6cdf5$export$26e841bcf1aeb894(`Error: ${(_graphQlResponse$erro3 = graphQlResponse.errors) === null || _graphQlResponse$erro3 === void 0 || (_graphQlResponse$erro3 = _graphQlResponse$erro3[0]) === null || _graphQlResponse$erro3 === void 0 ? void 0 : _graphQlResponse$erro3.message}, traceId: null`, Number((_graphQlResponse$erro4 = graphQlResponse.errors) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4[0]) === null || _graphQlResponse$erro4 === void 0 || (_graphQlResponse$erro4 = _graphQlResponse$erro4.extensions) === null || _graphQlResponse$erro4 === void 0 ? void 0 : _graphQlResponse$erro4.statusCode) || 500);
    }
    return response;
};
const $6f5de6e73fb6cdf5$export$ad8c5cf7dd4c3caf = (err)=>{
    return err.status === $6f5de6e73fb6cdf5$var$NETWORK_ERROR_CODE;
};
const $6f5de6e73fb6cdf5$export$fa5c2d120eda5e1c = (err)=>{
    if ((0, $bG6ob.isPremiumSLAErrorFilterEnabled)()) return err.status < 500;
    return err.status >= 400 && err.status < 500;
};
const $6f5de6e73fb6cdf5$export$68d314c2a361832e = (err)=>{
    return $6f5de6e73fb6cdf5$export$ad8c5cf7dd4c3caf(err) || $6f5de6e73fb6cdf5$export$fa5c2d120eda5e1c(err);
};

});

parcelRegister("fTHFO", function(module, exports) {
$parcel$export(module.exports, "getAggHeaders", () => $860ddf8fb4fd9cac$export$3818fdda9ab5fc7e);

var $6mmHn = parcelRequire("6mmHn");
const $860ddf8fb4fd9cac$export$3818fdda9ab5fc7e = ()=>({
        'X-B3-TraceId': (0, $6mmHn.getMeta)('X-B3-TraceId') || '',
        'atl-attribution': JSON.stringify({
            atlWorkspaceId: (0, $6mmHn.getWorkspaceAri)(),
            tenantId: (0, $6mmHn.getCloudId)(),
            product: 'Jira',
            service: 'jsm-help-center-ui'
        })
    });

});


parcelRegister("6KruH", function(module, exports) {
$parcel$export(module.exports, "default", () => $06bc31f6bb99828d$export$2e2bcd8739ae039);

var $63sfu = parcelRequire("63sfu");

var $f2UoR = parcelRequire("f2UoR");

var $6bGmX = parcelRequire("6bGmX");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");

var $fTHFO = parcelRequire("fTHFO");

var $l5Ezo = parcelRequire("l5Ezo");
const $06bc31f6bb99828d$export$aa8bf897e49821c3 = new Set();
const $06bc31f6bb99828d$var$fetchQuery = (request, variables)=>{
    const isJsmScaleTestAggCheckEnabled = (0, $6bGmX.default).checkGate('jsm_scale_60k_testing_in_help_center');
    const isAggAttributionHeadersEnabled = (0, $6bGmX.default).checkGate('jsm-help-center-agg-attribution-headers');
    return (0, $f2UoR.Observable).create((sink)=>{
        const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
        const cachedResponse = requestID ? (0, $l5Ezo.QueryResponseCache).get(requestID, variables) : undefined;
        /**
     * If we're on the client and we have a cached response, return it immediately.
     */ if (!(0, $63sfu.isNil)(cachedResponse)) {
            if (requestID != null) (0, $l5Ezo.QueryResponseCache).delete(requestID, variables);
            sink.next(cachedResponse);
            sink.complete();
            return;
        }
        const { id: id, operationKind: operationKind, name: queryName } = request;
        const metaData = {
            queryName: queryName,
            operationKind: operationKind
        };
        const AGG_BASE_PATH = id ? `/gateway/api/graphql/pq/${id}` : '/gateway/api/graphql';
        let AGG_PATH = AGG_BASE_PATH;
        if (isJsmScaleTestAggCheckEnabled && (0, $ebpTf.getEnv)().environment !== (0, $ebpTf.EnvType).PROD) {
            const AGG_BRANCH_SLUG = 'branch-issue-remove-rate-limit';
            AGG_PATH = id ? `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql/pq/${id}` : `/gateway/api/graphql/${AGG_BRANCH_SLUG}/graphql`;
        }
        const body = JSON.stringify({
            variables: variables
        });
        const promise = (0, $hZWMk.fetchJson)(`${AGG_PATH}`, {
            body: body,
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                ...operationKind === 'mutation' && {
                    'X-ExperimentalApi': 'help-object-store-agg-beta, HelpCenterReorderTopics'
                },
                ...isAggAttributionHeadersEnabled && (0, $fTHFO.getAggHeaders)()
            }
        });
        promise.then((response)=>{
            sink.next(response);
            sink.complete();
            return response;
        }).catch((error)=>{
            sink.error(error);
        });
    });
};
var $06bc31f6bb99828d$export$2e2bcd8739ae039 = $06bc31f6bb99828d$var$fetchQuery;

});
parcelRegister("l5Ezo", function(module, exports) {
$parcel$export(module.exports, "QueryResponseCache", () => $0c6c9632eab214b1$export$688bd21be71b9e5d);
/**
 * This implementation is copied from Jira frontend.
 */ 
var $f2UoR = parcelRequire("f2UoR");

var $fVwZr = parcelRequire("fVwZr");
const $0c6c9632eab214b1$var$CACHE_NAME = 'RELAY_SSR_CACHE';
const $0c6c9632eab214b1$export$611736262b635f8d = (queryID, variables)=>JSON.stringify((0, $f2UoR.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
const $0c6c9632eab214b1$export$1e65e863cf3a0f21 = (cacheKey)=>JSON.parse(cacheKey).queryID;
class $0c6c9632eab214b1$export$be21c283b097d175 extends (0, $f2UoR.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl }){
        super({
            size: size,
            ttl: ttl
        });
        // Load cached data from the server, if available
        let spaState = {};
        {
            var _document$getElementB;
            const spaStateFromServer = (_document$getElementB = document.getElementById('spa-state')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.getAttribute('data-state');
            try {
                spaState = spaStateFromServer ? JSON.parse(decodeURIComponent(spaStateFromServer)) : {};
            } catch (err) {
                (0, $fVwZr.reportError)(err);
            }
        }
        const cachedData = spaState[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(undefined);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        setTimeout(()=>{
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $0c6c9632eab214b1$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
                responses: Array.from(this._responses.entries())
            }
        };
    }
}
const $0c6c9632eab214b1$export$688bd21be71b9e5d = new $0c6c9632eab214b1$export$be21c283b097d175({
    cacheName: $0c6c9632eab214b1$var$CACHE_NAME,
    size: Infinity,
    ttl: Infinity
});
const $0c6c9632eab214b1$export$de9cebd147177ad2 = ()=>$0c6c9632eab214b1$export$688bd21be71b9e5d.serialize();

});


parcelRegister("aGOTZ", function(module, exports) {
$parcel$export(module.exports, "subscribeOptions", () => $73b471673ebea239$export$9bdaf447ae2b3b45);
$parcel$export(module.exports, "subscribe", () => $73b471673ebea239$export$ec068583843480e7);

var $f2UoR = parcelRequire("f2UoR");

var $fJQMR = parcelRequire("fJQMR");

var $7KV97 = parcelRequire("7KV97");
const $73b471673ebea239$export$9bdaf447ae2b3b45 = {
    extensions: {},
    onTrigger: (payload)=>(0, $fJQMR.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'triggered',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                ...payload
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        }),
    onError: (payload)=>(0, $fJQMR.getAnalyticsWebClientPromise)().then((analyticsClient)=>{
            const analyticsPayload = {
                action: 'failed',
                actionSubject: 'relaySubscription',
                source: 'portal-frontend',
                operationName: payload.operationName,
                requestId: payload.requestId
            };
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.getInstance().sendOperationalEvent(analyticsPayload);
        })
};
const $73b471673ebea239$export$ec068583843480e7 = ({ id: id, name: operationName }, variables)=>(0, $f2UoR.Observable).create((sink)=>{
        const client = (0, $7KV97.getClient)();
        if (!client) return sink.error(new Error('Unable to create subscription client'));
        const payload = {
            operationName: operationName,
            variables: variables,
            query: '',
            extensions: {
                pq: id,
                ...$73b471673ebea239$export$9bdaf447ae2b3b45.extensions
            }
        };
        let requestId;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $73b471673ebea239$export$9bdaf447ae2b3b45.onTrigger(payload);
        return client.subscribe(payload, {
            ...sink,
            next: (value)=>{
                var _value$extensions;
                const aggRequestId = value === null || value === void 0 || (_value$extensions = value.extensions) === null || _value$extensions === void 0 || (_value$extensions = _value$extensions.gateway) === null || _value$extensions === void 0 ? void 0 : _value$extensions.request_id;
                requestId = aggRequestId ?? requestId;
                sink.next(value);
            },
            error: (sinkError)=>{
                const errorInfo = $73b471673ebea239$export$ece4736473c28965(sinkError);
                sink.error(errorInfo);
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                $73b471673ebea239$export$9bdaf447ae2b3b45.onError({
                    operationName: operationName,
                    requestId: requestId
                });
            }
        });
    });
const $73b471673ebea239$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (error instanceof Event) errorInfo = new Error(`Event: ${error.type}`);
    else // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    errorInfo = new Error(`Unknown sink error: ${error}`);
    return errorInfo;
};

});
parcelRegister("7KV97", function(module, exports) {
$parcel$export(module.exports, "getClient", () => $852919ba4399ea19$export$6bb76d6eba7e258c);

var $4MJ9c = parcelRequire("4MJ9c");

var $gOVer = parcelRequire("gOVer");
let $852919ba4399ea19$var$client = null;
const $852919ba4399ea19$export$6bb76d6eba7e258c = ()=>{
    if ((0, $gOVer.isSSR)()) return null;
    if ($852919ba4399ea19$var$client == null) $852919ba4399ea19$var$client = (0, $4MJ9c.createClient)({
        url: (0, $gOVer.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $gOVer.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $gOVer.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend'
        }
    });
    return $852919ba4399ea19$var$client;
};
const $852919ba4399ea19$export$2f0afd443356d36f = ()=>{
    $852919ba4399ea19$var$client = null;
};

});
parcelRegister("gOVer", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $63633c7851946f6b$export$48d7c418edadb60c);
$parcel$export(module.exports, "getAggSubscriptionEndpoint", () => $63633c7851946f6b$export$29a72e89601dfc59);
$parcel$export(module.exports, "WS_CLIENT_KEEP_ALIVE", () => $63633c7851946f6b$export$8b012b965402e06a);
$parcel$export(module.exports, "WS_CLIENT_RETRIES", () => $63633c7851946f6b$export$bf6cd96e19b2987f);
const $63633c7851946f6b$export$48d7c418edadb60c = ()=>false ?? false;
const $63633c7851946f6b$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
const $63633c7851946f6b$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $63633c7851946f6b$export$bf6cd96e19b2987f = 100;

});




parcelRegister("6gWsU", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbc2932f2f7f03be$export$2e2bcd8739ae039);

var $hZWMk = parcelRequire("hZWMk");

var $6bGmX = parcelRequire("6bGmX");

var $bG6ob = parcelRequire("bG6ob");

var $ebpTf = parcelRequire("ebpTf");

var $fTHFO = parcelRequire("fTHFO");
const $fbc2932f2f7f03be$var$setEndpoint = (endpoint)=>{
    const isJsmScaleTestAggCheckEnabled = (0, $6bGmX.default).checkGate('jsm_scale_60k_testing_in_help_center');
    isJsmScaleTestAggCheckEnabled && ((0, $ebpTf.getEnv)().environment, (0, $ebpTf.EnvType).PROD);
    return endpoint;
};
const $fbc2932f2f7f03be$var$getHeaders = ()=>{
    if (!(0, $6bGmX.default).checkGate('jsm-help-center-agg-attribution-headers')) return {};
    return (0, $fTHFO.getAggHeaders)();
};
// Refactored from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/92866a25d86943454624c5ac4fe38a59a17ed7d1/help-center/packages/util/fetch/fetch.tsx#fetch.tsx-51:66
const $fbc2932f2f7f03be$var$NETWORK_ERROR_CODE = 0;
const $fbc2932f2f7f03be$var$EMPTY_TRACE_ID_ERROR_MESSAGE = 'Failed to fetch got empty traceId';
const $fbc2932f2f7f03be$var$validateResponse = (_request, gqlData)=>{
    if (typeof gqlData === 'object' && typeof gqlData.data === 'undefined') {
        var _gqlData$extensions;
        const traceId = (_gqlData$extensions = gqlData.extensions) === null || _gqlData$extensions === void 0 || (_gqlData$extensions = _gqlData$extensions.gateway) === null || _gqlData$extensions === void 0 ? void 0 : _gqlData$extensions.request_id;
        const statusCode = $fbc2932f2f7f03be$var$getErrorStatusCode('errors' in gqlData && gqlData.errors || []);
        if (typeof traceId === 'undefined' && (0, $bG6ob.isFilterNullTraceIdFromGraphqlCallsEnabled)()) throw new (0, $hZWMk.FetchError)($fbc2932f2f7f03be$var$EMPTY_TRACE_ID_ERROR_MESSAGE, $fbc2932f2f7f03be$var$NETWORK_ERROR_CODE);
        if (traceId) throw new (0, $hZWMk.FetchError)(`ErrorCode: ${statusCode}, traceId: ${traceId}`, statusCode, true);
    }
    // This function returns the response but this unused.
    // All that we rely upon is thrown errors to ensure that there aren't any problems with the response.
    (0, $hZWMk.handleGraphQlErrors)(gqlData);
    // This returns true as the response will be valid if an error is not thrown above.
    return true;
};
function $fbc2932f2f7f03be$var$errorHasAggErrorExtension(err) {
    if (typeof err !== 'object' || err === null) return false;
    if ('extensions' in err === false || typeof err !== 'object' || err === null) return false;
    if (typeof err.extensions !== 'object' || err.extensions === null || 'statusCode' in err.extensions === false) return false;
    return typeof err.extensions.statusCode === 'number';
}
function $fbc2932f2f7f03be$var$getErrorStatusCode(errors) {
    var _errorExtension$exten;
    if (Array.isArray(errors) === false) return 200;
    const errorExtension = errors.find($fbc2932f2f7f03be$var$errorHasAggErrorExtension);
    if (typeof (errorExtension === null || errorExtension === void 0 || (_errorExtension$exten = errorExtension.extensions) === null || _errorExtension$exten === void 0 ? void 0 : _errorExtension$exten.statusCode) !== 'number') return 500;
    return errorExtension.extensions.statusCode;
}
/**
 * Product hook for `ExternalDependencies['onFetchError']` in `platform/packages/relay/relay-fetch/src/multi-fetch.ts`.
 * Called whenever the relay fetch pipeline is about to surface an error to Relay.
 *
 * Help-center's error filtering (see `help-center/packages/util/fetch/fetch.tsx`:
 * `isFetchClientError`/`isFetchNetworkOrClientError`) keys off `FetchError.status`. Errors emitted from the platform
 * `handleTextResponse` /`handleJsonResponse` catch blocks are plain `Error`s with no `status` attached, which means
 * downstream filtering treats them as unclassified server errors and incorrectly fails the view-help-center SLO for
 * upstream proxy/CDN responses (e.g. an HTML `405 Method Not Allowed` page).
 *
 * We wrap any non-`FetchError` error into a `FetchError` so the existing classification pipeline applies.
 *
 * Errors surfaced before an HTTP `Response` was received (e.g. network failure) have `response === undefined` — we
 * leave the original error unchanged so `handleNetworkErrors` can convert it into a `FetchError(NETWORK_ERROR_MESSAGE,
 * NETWORK_ERROR_CODE)` via the usual `fetchJson` path.
 */ const $fbc2932f2f7f03be$var$onFetchError = (error, response)=>{
    if (!response) return error;
    if (error instanceof (0, $hZWMk.FetchError)) return error;
    const message = error instanceof Error ? error.message : String(error);
    const filterFromSentry = Boolean(response.headers.get('atl-traceid'));
    return new (0, $hZWMk.FetchError)(message, response.status, filterFromSentry);
};
var $fbc2932f2f7f03be$export$2e2bcd8739ae039 = {
    setEndpoint: $fbc2932f2f7f03be$var$setEndpoint,
    getHeaders: $fbc2932f2f7f03be$var$getHeaders,
    validateResponse: $fbc2932f2f7f03be$var$validateResponse,
    onFetchError: $fbc2932f2f7f03be$var$onFetchError,
    getErrorStatusCode: $fbc2932f2f7f03be$var$getErrorStatusCode,
    errorHasAggErrorExtension: $fbc2932f2f7f03be$var$errorHasAggErrorExtension
};

});

parcelRegister("43OzE", function(module, exports) {
$parcel$export(module.exports, "getRelayDataId", () => $a91b289d7386a419$export$944f9dc3d03637c3);

var $bG6ob = parcelRequire("bG6ob");

var $96dA5 = parcelRequire("96dA5");
const $a91b289d7386a419$export$944f9dc3d03637c3 = (id, typeName)=>{
    if ((0, $bG6ob.isFixRelayIdConflictInHelpCenter)()) return (0, $96dA5.default)({
        id: id
    }, typeName);
    return id;
};

});





parcelRegister("lNZDv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a36760c228952de$export$2e2bcd8739ae039);

var $eDxKC = parcelRequire("eDxKC");

var $5bghW = parcelRequire("5bghW");

var $7a36760c228952de$export$2e2bcd8739ae039 = (0, $eDxKC.default);

});
parcelRegister("eDxKC", function(module, exports) {
$parcel$export(module.exports, "default", () => $db080471bea321bb$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $iHSFb = parcelRequire("iHSFb");

var $2OOKU = parcelRequire("2OOKU");

var $4Bdcb = parcelRequire("4Bdcb");

var $jFknK = parcelRequire("jFknK");

var $j58cX = parcelRequire("j58cX");

var $bqHVm = parcelRequire("bqHVm");

var $gE3od = parcelRequire("gE3od");

var $87Bg8 = parcelRequire("87Bg8");

var $c62a8 = parcelRequire("c62a8");

var $eFsN4 = parcelRequire("eFsN4");

var $aONLx = parcelRequire("aONLx");

var $8AHBO = parcelRequire("8AHBO");

var $1h62Q = parcelRequire("1h62Q");
let $db080471bea321bb$var$tryCompleteHandle;
let $db080471bea321bb$var$hasMarkedFirstSegmentLoad = false;
/** A portion of the page we apply measurement to */ const $db080471bea321bb$var$UFOSegment = ({ name: segmentName, children: children, mode: mode = 'single', type: type = 'first-party' })=>{
    // If UFO is disabled, render children without any tracking overhead
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $jFknK.isUFOEnabled)();
    const parentContext = (0, $4fqPo.useContext)((0, $gE3od.default));
    const segmentIdMap = (0, $4fqPo.useMemo)(()=>{
        if (!(parentContext !== null && parentContext !== void 0 && parentContext.segmentIdMap)) return new Map();
        return parentContext.segmentIdMap;
    }, [
        parentContext
    ]);
    const segmentId = (0, $4fqPo.useMemo)(()=>{
        if (mode === 'single') return (0, $aONLx.default)();
        if (segmentIdMap.has(segmentName)) return segmentIdMap.get(segmentName);
        const newSegmentId = (0, $aONLx.default)();
        segmentIdMap.set(segmentName, newSegmentId);
        return newSegmentId;
    }, [
        mode,
        segmentName,
        segmentIdMap
    ]);
    const labelStack = (0, $4fqPo.useMemo)(()=>parentContext !== null && parentContext !== void 0 && parentContext.labelStack ? [
            ...parentContext.labelStack,
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            } // Only pass non-default types (not 'first-party') in payload to reduce size
        ] : [
            {
                name: segmentName,
                segmentId: segmentId,
                ...type !== 'first-party' ? {
                    type: type
                } : {}
            }
        ], [
        parentContext,
        segmentName,
        segmentId,
        type
    ]);
    const interactionId = (0, $4fqPo.useContext)((0, $87Bg8.default));
    if (interactionId.current != null && !$db080471bea321bb$var$hasMarkedFirstSegmentLoad) {
        (0, $c62a8.markFirstSegmentLoad)(interactionId.current, labelStack, performance.now());
        $db080471bea321bb$var$hasMarkedFirstSegmentLoad = true;
    }
    const interactionContext = (0, $4fqPo.useMemo)(()=>{
        let lastCompleteEndTime = 0;
        function complete(endTime = performance.now()) {
            if (interactionId.current) {
                if (parentContext) parentContext.complete();
                else {
                    const capturedInteractionId = interactionId.current;
                    if (endTime > lastCompleteEndTime) lastCompleteEndTime = endTime;
                    if ($db080471bea321bb$var$tryCompleteHandle) {
                        var _cancelAnimationFrame;
                        (_cancelAnimationFrame = cancelAnimationFrame) === null || _cancelAnimationFrame === void 0 || _cancelAnimationFrame($db080471bea321bb$var$tryCompleteHandle);
                    }
                    const onComplete = ()=>{
                        if (capturedInteractionId === interactionId.current) {
                            var _globalThis$document;
                            const isPageVisible = (globalThis === null || globalThis === void 0 || (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) === 'visible';
                            const canDoRAF = typeof requestAnimationFrame !== 'undefined';
                            if (isPageVisible && canDoRAF) $db080471bea321bb$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                $db080471bea321bb$var$tryCompleteHandle = requestAnimationFrame(()=>{
                                    if (capturedInteractionId === interactionId.current) (0, $c62a8.tryComplete)(interactionId.current, lastCompleteEndTime);
                                });
                            });
                            else (0, $c62a8.tryComplete)(interactionId.current, lastCompleteEndTime);
                        }
                    };
                    (0, $iHSFb.unstable_scheduleCallback)((0, $iHSFb.unstable_NormalPriority), onComplete);
                }
            }
        }
        function _internalHold(labelStack, name) {
            if (interactionId.current != null) {
                if (parentContext) return parentContext._internalHold(labelStack, name);
                else {
                    const capturedInteractionId = interactionId.current;
                    const disposeHold = (0, $c62a8.addHold)(interactionId.current, labelStack, name, false);
                    return ()=>{
                        if (capturedInteractionId === interactionId.current) disposeHold();
                    };
                }
            }
        }
        function _internalHoldByID(labelStack, id, name, remove) {
            if (interactionId.current != null) {
                if (parentContext) {
                    parentContext._internalHoldByID(labelStack, name, id, remove);
                    return;
                }
                if (!remove) (0, $c62a8.addHoldByID)(interactionId.current, labelStack, name, id);
                else (0, $c62a8.removeHoldByID)(interactionId.current, id);
            }
        }
        if (parentContext) return {
            ...parentContext,
            labelStack: labelStack,
            complete: complete
        };
        return {
            labelStack: labelStack,
            segmentIdMap: segmentIdMap,
            hold (name = 'unknown') {
                return this._internalHold(this.labelStack, name);
            },
            addHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, false);
            },
            removeHoldByID (labelStack, id, name = 'unknown') {
                this._internalHoldByID(labelStack, id, name, true);
            },
            tracePress (name = 'unknown', timestamp) {
                const minorInteractions = [
                    ...(0, $jFknK.getDoNotAbortActivePressInteraction)() ?? [],
                    ...(0, $jFknK.getMinorInteractions)() ?? []
                ];
                if (minorInteractions.includes(name)) {
                    var _activeInteraction$mi;
                    const activeInteraction = (0, $c62a8.getActiveInteraction)();
                    activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
                        name: name,
                        startTime: timestamp ?? performance.now()
                    });
                    return;
                } else if (interactionId.current != null) (0, $c62a8.abortByNewInteraction)(interactionId.current, name);
                const rate = (0, $jFknK.getInteractionRate)(name, 'press');
                if ((0, $4Bdcb.default)(rate)) {
                    const startTimestamp = timestamp ?? performance.now();
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    const newId = (0, $2OOKU.v4)();
                    interactionId.current = newId;
                    // covered experiences with tracing instrumentation:
                    // inline-result.global-issue.create-modal.submit
                    // inline-result.global-issue.create-modal-subsequent
                    (0, $bqHVm.setInteractionActiveTrace)(newId, 'press');
                    (0, $c62a8.addNewInteraction)(newId, name, 'press', startTimestamp, rate, this.labelStack, (0, $eFsN4.default).current, (0, $bqHVm.getActiveTrace)());
                }
            },
            retainQuery (info) {
                if (interactionId.current != null) (0, $c62a8.addRequestInfo)(interactionId.current, this.labelStack, info);
            },
            addPreload (moduleId, timestamp) {
                if (interactionId.current != null) (0, $c62a8.addMark)(interactionId.current, 'bundle_preload', moduleId, this.labelStack, timestamp);
            },
            addLoad (identifier, start, end) {
                if (interactionId.current != null) {
                    const { labelStack: labelStack = [] } = this;
                    (0, $c62a8.addSpan)(interactionId.current, 'bundle_load', identifier, labelStack, start, end);
                }
            },
            addMark (name, timestamp) {
                if (interactionId.current != null) {
                    const time = timestamp ?? performance.now();
                    (0, $c62a8.addMark)(interactionId.current, 'custom', name, this.labelStack, time);
                }
            },
            addCustomData (customData) {
                if (interactionId.current != null) (0, $c62a8.addCustomData)(interactionId.current, this.labelStack, customData);
            },
            addCustomTimings (customTimings) {
                if (interactionId.current != null) (0, $c62a8.addCustomTiming)(interactionId.current, this.labelStack, customTimings);
            },
            addApdex (apdexInfo) {
                if (interactionId.current != null) {
                    const { key: key, stopTime: stopTime, startTime: startTime } = apdexInfo;
                    (0, $c62a8.addApdex)(interactionId.current, {
                        key: key,
                        stopTime: stopTime,
                        startTime: startTime,
                        labelStack: this.labelStack
                    });
                }
            },
            onRender (phase, actualDuration, baseDuration, startTime, commitTime) {
                if (interactionId.current !== null) {
                    (0, $c62a8.addProfilerTimings)(interactionId.current, this.labelStack, phase, actualDuration, baseDuration, startTime, commitTime);
                    (0, $8AHBO.default)(()=>{
                        const paintedTime = performance.now();
                        this.complete(paintedTime);
                    });
                }
            },
            _internalHold: _internalHold,
            _internalHoldByID: _internalHoldByID,
            complete: complete
        };
    }, [
        parentContext,
        labelStack,
        segmentIdMap,
        interactionId
    ]);
    const hasMounted = (0, $4fqPo.useRef)(false);
    const onRender = (0, $4fqPo.useCallback)((_id, phase, actualDuration, baseDuration, startTime, commitTime)=>{
        var _getConfig;
        // Manually keep track of mount-phase, and ensure that every segment is always mounted at least once
        if ((_getConfig = (0, $jFknK.getConfig)()) !== null && _getConfig !== void 0 && _getConfig.manuallyTrackReactProfilerMounts && !hasMounted.current) {
            interactionContext.onRender('mount', actualDuration, baseDuration, startTime, commitTime);
            hasMounted.current = true;
        } else interactionContext.onRender(phase, actualDuration, baseDuration, startTime, commitTime);
    }, [
        interactionContext
    ]);
    (0, $4fqPo.useEffect)(()=>{
        (0, $c62a8.addSegment)(labelStack);
        return ()=>{
            (0, $c62a8.removeSegment)(labelStack);
        };
    }, [
        interactionId,
        parentContext,
        interactionContext,
        labelStack
    ]);
    const reactProfilerId = (0, $4fqPo.useMemo)(()=>labelStack.map((l)=>(0, $j58cX.sanitizeLabelStackName)(l.name)).join('/'), [
        labelStack
    ]);
    // If UFO is disabled, just render children without tracking overhead
    if (!ufoEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children);
    const ufoSegment = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gE3od.default).Provider, {
        value: interactionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Profiler), {
        id: reactProfilerId,
        onRender: onRender
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1h62Q.default), {
        labelStack: labelStack,
        onRender: (...args)=>interactionContext.onRender.apply(interactionContext, args)
    }, ufoSegment);
};
$db080471bea321bb$var$UFOSegment.displayName = 'UFOSegment';
var $db080471bea321bb$export$2e2bcd8739ae039 = $db080471bea321bb$var$UFOSegment;

});
parcelRegister("aONLx", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe9bff54036b1124$export$2e2bcd8739ae039);
function $fe9bff54036b1124$var$generateId(length = 7) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for(let i = 0; i < length; i++)result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
}
var $fe9bff54036b1124$export$2e2bcd8739ae039 = $fe9bff54036b1124$var$generateId;

});

parcelRegister("8AHBO", function(module, exports) {
$parcel$export(module.exports, "default", () => $87434ec12adde79c$export$2e2bcd8739ae039);

var $3TFEq = parcelRequire("3TFEq");
function $87434ec12adde79c$var$scheduleOnPaint(callback) {
    var _process, _globalThis$document;
    const isSSR = typeof window === 'undefined' || Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__) || typeof $3TFEq !== 'undefined' && Boolean((_process = $3TFEq) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR);
    if (isSSR) {
        // In SSR, execute callback immediately (no paint event exists)
        callback();
        return;
    }
    if (((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== 'visible') {
        // last resort fallback
        setTimeout(callback, 100);
        return;
    }
    // Check if the Scheduler API is available
    if (typeof window.scheduler !== 'undefined' && typeof window.scheduler.postTask === 'function') // Use scheduler.postTask if available
    // https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
    // Make sure we are scheduling this task before the browser paint the next frame
    requestAnimationFrame(()=>{
        window.scheduler.postTask(callback, {
            priority: 'user-visible'
        });
    });
    else if (typeof requestAnimationFrame !== 'undefined') // Fallback to using double requestAnimationFrame
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            callback();
        });
    });
}
var $87434ec12adde79c$export$2e2bcd8739ae039 = $87434ec12adde79c$var$scheduleOnPaint;

});


parcelRegister("5bghW", function(module, exports) {
$parcel$export(module.exports, "UFOThirdPartySegment", () => $fea9c6855f93a518$export$5f6fe75c46d0124e);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $gE3od = parcelRequire("gE3od");

var $87Bg8 = parcelRequire("87Bg8");

var $c62a8 = parcelRequire("c62a8");

var $eBxLu = parcelRequire("eBxLu");

var $54X0l = parcelRequire("54X0l");

var $eDxKC = parcelRequire("eDxKC");

var $fw8uM = parcelRequire("fw8uM");
const $fea9c6855f93a518$var$FORGE_TTAI_EVENT_PREFIX = 'ufo-forge';
// Early-signal event emitted by the iframe bridge as soon as it wires up its
// UFO observers. Receiving this within ABORT_TIMEOUT_INITIAL_MS tells us the
// iframe is on the new rollout cohort and will send data events.
const $fea9c6855f93a518$var$FORGE_INIT_EVENT = 'ufo-forge-init';
// Grace period (ms) after the navigation hold releases before finalising.
const $fea9c6855f93a518$var$GRACE_PERIOD_MS = 2000;
// Initial abort timeout (ms from mount). If no recognised iframe event arrives within
// this window, the hold is force-released and an abort marker is logged. This protects
// metric quality during progressive rollouts where old-cohort iframes never emit events.
const $fea9c6855f93a518$var$ABORT_TIMEOUT_INITIAL_MS = 6000;
// Per-segment cap on the number of `resized` entries forwarded to addIframeSegmentData.
// useResizeAnalytics already limits emissions to a 10s tracking window, but a chatty
// app could still produce dozens of resizes; combined with many Forge apps on one
// page this could push segment3pData toward the 60 KB soft limit. The cap provides
// defence-in-depth without affecting realistic apps (typical <20 resizes per segment).
const $fea9c6855f93a518$var$MAX_RESIZED_ENTRIES_PER_SEGMENT = 50;
// Extended abort timeout (ms from mount). Once any recognised iframe event is received
// we know the iframe is on the new rollout cohort and actively sending data, so we extend
// the window to accommodate legitimately slow-loading Forge apps.
const $fea9c6855f93a518$var$ABORT_TIMEOUT_EXTENDED_MS = 30000;
// Events logged via addIframeSegmentData as they arrive.
const $fea9c6855f93a518$var$IFRAME_SEGMENT_DATA_SUFFIXES = [
    'resource-timing',
    'paint-timing',
    'largest-contentful-paint',
    'layout-shift',
    'dom-mutations',
    'navigation-timing'
];
// Events that extend the forge-ui-requests corrected end-time during grace.
const $fea9c6855f93a518$var$NAV_HOLD_GRACE_SUFFIXES = new Set([
    'navigation-timing',
    'resource-timing'
]);
/** Reads segmentId from UFOInteractionContext and stores it in a ref. */ function $fea9c6855f93a518$var$IframeSegmentIdReader({ segmentIdRef: segmentIdRef }) {
    const context = (0, $4fqPo.useContext)((0, $gE3od.default));
    const labelStack = context === null || context === void 0 ? void 0 : context.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    if (segmentId && segmentIdRef.current !== segmentId) segmentIdRef.current = segmentId;
    return null;
}
/** Subscribes to iframe performance events and records them as segment3pTimings. */ function $fea9c6855f93a518$var$IframeSegment({ onRegisterIframeEventListener: onRegisterIframeEventListener, appType: appType }) {
    const interactionId = (0, $4fqPo.useContext)((0, $87Bg8.default));
    const interactionContext = (0, $4fqPo.useContext)((0, $gE3od.default));
    const segmentIdRef = (0, $4fqPo.useRef)(undefined);
    // Per-segment counter for `resized` entries (defence-in-depth payload cap).
    // Tracks both the count AND the segmentId it was last incremented under, so
    // SPA navigations that swap segmentId reset the budget for the new segment.
    const resizedCountRef = (0, $4fqPo.useRef)(0);
    const resizedCounterSegmentIdRef = (0, $4fqPo.useRef)(undefined);
    const isUiKit = appType === 'UIKit';
    // Released on the first navigation-timing event from the iframe.
    const [navigationHold, setNavigationHold] = (0, $4fqPo.useState)('holding');
    // UIKit: wrap onRender to account for React Profiler timings
    // Accumulates profiler timing bounds so we emit one aggregated entry at cleanup.
    const profilerAccRef = (0, $4fqPo.useRef)(null);
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (!isUiKit || !interactionContext || !interactionContext.onRender) return;
        const originalOnRender = interactionContext.onRender.bind(interactionContext);
        interactionContext.onRender = function(phase, actualDuration, baseDuration, startTime, commitTime) {
            originalOnRender(phase, actualDuration, baseDuration, startTime, commitTime);
            // Accumulate timing bounds into a single entry.
            const start = Math.round(startTime);
            const end = Math.round(commitTime);
            if (profilerAccRef.current === null) profilerAccRef.current = {
                startTime: start,
                endTime: end
            };
            else {
                if (start < profilerAccRef.current.startTime) profilerAccRef.current.startTime = start;
                if (end > profilerAccRef.current.endTime) profilerAccRef.current.endTime = end;
            }
        };
        return ()=>{
            interactionContext.onRender = originalOnRender;
        };
    }, [
        isUiKit,
        interactionContext,
        interactionId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        let navigationHoldReleased = false;
        let lastNavEventTime = null;
        let gracePeriodTimer = null;
        // Tracks whether any recognised iframe event has been received, which tells us
        // the iframe is on the new rollout cohort and actively sending data.
        let iframeEventsReceived = false;
        let abortTimer;
        const mountTime = performance.now();
        const fireAbort = (abortAfterMs)=>{
            // Cancel any pending grace period so it doesn't also fire.
            if (gracePeriodTimer !== null) {
                clearTimeout(gracePeriodTimer);
                gracePeriodTimer = null;
            }
            // Force-release the hold if still active at abort time.
            if (!navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
            }
            // Record the abort marker so downstream analytics can detect it.
            if (interactionId.current && segmentIdRef.current) (0, $c62a8.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                label: 'segment-timing-abort',
                data: {
                    reason: 'timeout',
                    abortAfterMs: abortAfterMs
                }
            });
        };
        // Start with the short initial timeout. If no ufo-forge-init signal arrives
        // within this window, the iframe is likely an old-cohort app that will never
        // send events — abort early to avoid blocking the interaction indefinitely.
        abortTimer = setTimeout(()=>{
            if (!iframeEventsReceived) fireAbort($fea9c6855f93a518$var$ABORT_TIMEOUT_INITIAL_MS);
        }, $fea9c6855f93a518$var$ABORT_TIMEOUT_INITIAL_MS);
        const finaliseHolds = ()=>{
            const iid = interactionId.current;
            const lStack = interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack;
            if (iid && lStack) {
                if (lastNavEventTime !== null) (0, $c62a8.addCompletedHold)(iid, lStack, 'forge-ui-requests', mountTime, lastNavEventTime);
            }
        };
        const scheduleGracePeriodExpiry = ()=>{
            // Reset the 2s countdown each time a new event arrives during the grace period.
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
            gracePeriodTimer = setTimeout(()=>{
                clearTimeout(abortTimer);
                finaliseHolds();
            }, $fea9c6855f93a518$var$GRACE_PERIOD_MS);
        };
        const maybeStartGracePeriod = ()=>{
            if (navigationHoldReleased && gracePeriodTimer === null) scheduleGracePeriodExpiry();
        };
        const handleEvent = (event)=>{
            // Host-side `resized` events come from useResizeAnalytics (forge-ui).
            // They are emitted whenever the iframe container height changes during
            // the 10s tracking window after mount. We forward only the reliable
            // fields (height, elapsed). The `measuredHeight` and `viewportHeight`
            // fields are intentionally excluded because they require a vendor
            // config that is rarely populated in practice (almost always null).
            if (event.type === 'resized') {
                // Gated by feature flag. When OFF, host-side `resized` events are
                // ignored entirely so segment3pData and the abort timer behave as if
                // this code path did not exist.
                if (!(0, $3H4LK.fg)('platform_ufo_3p_segment_resize_event')) return;
                // Guard against malformed payloads (height is required and must be
                // a non-negative number; useResizeAnalytics emits Math.trunc'd ints).
                // `IframeSegmentEvent` already declares `[key: string]: unknown`, so
                // no `as` cast is needed — the typeof guards handle runtime safety.
                const { height: height, elapsed: elapsed } = event;
                // Reset the per-segment counter when the active segmentId changes
                // (SPA navigations swap segments; each gets a fresh budget).
                if (segmentIdRef.current && segmentIdRef.current !== resizedCounterSegmentIdRef.current) {
                    resizedCountRef.current = 0;
                    resizedCounterSegmentIdRef.current = segmentIdRef.current;
                }
                if (typeof height === 'number' && Number.isFinite(height) && height >= 0 && typeof elapsed === 'number' && Number.isFinite(elapsed) && elapsed >= 0 && resizedCountRef.current < $fea9c6855f93a518$var$MAX_RESIZED_ENTRIES_PER_SEGMENT && interactionId.current && segmentIdRef.current) {
                    resizedCountRef.current += 1;
                    (0, $c62a8.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                        label: 'resized',
                        data: {
                            height: height,
                            elapsed: elapsed
                        }
                    });
                }
                // NOTE: we deliberately do NOT set iframeEventsReceived = true here.
                // The 6s abort timer exists to detect old-cohort iframes that won't
                // emit bridge events. `resized` is a host-side signal (forge-ui's
                // ResizeObserver) and fires regardless of which bridge version the
                // iframe is serving, so it cannot confirm new-cohort membership.
                // Only bridge-emitted `ufo-forge-*` events (esp. `ufo-forge-init`)
                // are valid proof, and they extend the abort timeout below.
                return;
            }
            if (event.type !== 'ufo-event' || typeof event.name !== 'string' || !event.name.startsWith($fea9c6855f93a518$var$FORGE_TTAI_EVENT_PREFIX)) return;
            const eventName = event.name;
            const suffix = $fea9c6855f93a518$var$IFRAME_SEGMENT_DATA_SUFFIXES.find((s)=>eventName.endsWith(`-${s}`));
            if (suffix && interactionId.current && segmentIdRef.current) {
                const { type: type, ...rest } = event;
                const restData = rest;
                let data;
                if (suffix === 'resource-timing') data = (0, $54X0l.shapeResourceTimingData)(restData);
                else if (suffix === 'navigation-timing') data = (0, $54X0l.shapeNavigationTimingData)(restData);
                else if (suffix === 'paint-timing') data = (0, $fw8uM.shapePaintTimingData)(restData);
                else if (suffix === 'largest-contentful-paint') data = (0, $fw8uM.shapeLargestContentfulPaintData)(restData);
                else if (suffix === 'layout-shift') data = (0, $fw8uM.shapeLayoutShiftData)(restData);
                else if (suffix === 'dom-mutations') {
                    // Skip intermediate batches — only record the final summary batch.
                    if (!(0, $fw8uM.isDomMutationsFinalBatch)(restData)) return;
                    data = (0, $fw8uM.shapeDomMutationsData)(restData);
                } else data = restData;
                if (data !== undefined) (0, $c62a8.addIframeSegmentData)(interactionId.current, segmentIdRef.current, {
                    label: suffix,
                    data: data
                });
            }
            // ufo-forge-init confirms the iframe is on the new rollout cohort — extend the abort window.
            if (eventName === $fea9c6855f93a518$var$FORGE_INIT_EVENT && !iframeEventsReceived) {
                iframeEventsReceived = true;
                clearTimeout(abortTimer);
                const remainingMs = Math.max($fea9c6855f93a518$var$ABORT_TIMEOUT_EXTENDED_MS - (performance.now() - mountTime), 0);
                abortTimer = setTimeout(()=>{
                    fireAbort($fea9c6855f93a518$var$ABORT_TIMEOUT_EXTENDED_MS);
                }, remainingMs);
            }
            if (eventName.endsWith('-navigation-timing') && !navigationHoldReleased) {
                navigationHoldReleased = true;
                setNavigationHold('released');
                maybeStartGracePeriod();
            }
            if (navigationHoldReleased) {
                const now = performance.now();
                if (suffix && $fea9c6855f93a518$var$NAV_HOLD_GRACE_SUFFIXES.has(suffix)) {
                    lastNavEventTime = now;
                    scheduleGracePeriodExpiry();
                }
            }
        };
        const unregister = onRegisterIframeEventListener(handleEvent);
        // Emit react-profiler-timing for UI kit
        const activeInteraction = (0, $c62a8.getActiveInteraction)();
        let isUnmounted = false;
        if (activeInteraction) activeInteraction.cleanupCallbacks.push(()=>{
            if (isUnmounted) return;
            const iid = interactionId.current;
            const sid = segmentIdRef.current;
            if (iid && sid && profilerAccRef.current !== null) {
                (0, $c62a8.addIframeSegmentData)(iid, sid, {
                    label: 'react-profiler-timing',
                    data: {
                        ...profilerAccRef.current
                    }
                });
                profilerAccRef.current = null;
            }
        });
        return ()=>{
            isUnmounted = true;
            unregister();
            clearTimeout(abortTimer);
            if (gracePeriodTimer !== null) clearTimeout(gracePeriodTimer);
        };
    }, [
        onRegisterIframeEventListener,
        interactionId,
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eBxLu.default), {
        name: "forge-ui-requests",
        hold: navigationHold === 'holding'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($fea9c6855f93a518$var$IframeSegmentIdReader, {
        segmentIdRef: segmentIdRef
    }));
}
/** Writes per-segment extraData via addSegmentExtraData. */ function $fea9c6855f93a518$var$SegmentExtraDataWriter({ extraData: extraData }) {
    const interactionContext = (0, $4fqPo.useContext)((0, $gE3od.default));
    const interactionId = (0, $4fqPo.useContext)((0, $87Bg8.default));
    const labelStack = interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack;
    const segmentId = labelStack && labelStack.length > 0 ? labelStack[labelStack.length - 1].segmentId : undefined;
    (0, $4fqPo.useEffect)(()=>{
        const currentInteractionId = interactionId.current;
        if (segmentId && currentInteractionId) (0, $c62a8.addSegmentExtraData)(currentInteractionId, segmentId, extraData);
    }, [
        extraData,
        segmentId,
        interactionId
    ]);
    return null;
}
const $fea9c6855f93a518$export$5f6fe75c46d0124e = (props)=>{
    const { children: children, onRegisterIframeEventListener: onRegisterIframeEventListener, extraData: extraData, ...otherProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eDxKC.default), {
        type: "third-party",
        ...otherProps
    }, onRegisterIframeEventListener && extraData && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($fea9c6855f93a518$var$IframeSegment, {
        onRegisterIframeEventListener: onRegisterIframeEventListener,
        appType: extraData.appType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($fea9c6855f93a518$var$SegmentExtraDataWriter, {
        extraData: extraData
    })), children);
};
$fea9c6855f93a518$export$5f6fe75c46d0124e.displayName = 'UFOThirdPartySegment';

});
parcelRegister("eBxLu", function(module, exports) {
$parcel$export(module.exports, "default", () => $377d7474147ef94b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $jFknK = parcelRequire("jFknK");

var $gE3od = parcelRequire("gE3od");

var $87Bg8 = parcelRequire("87Bg8");
const $377d7474147ef94b$var$useLayoutEffectSAFE = typeof window === 'undefined' ? (0, $4fqPo.useEffect) : (0, $4fqPo.useLayoutEffect);
/**
 * Custom hook to track changes to the interaction ID.
 * Uses a subscription system to automatically update when the interaction ID changes.
 */ function $377d7474147ef94b$var$useInteractionIdValue() {
    const interactionId = (0, $4fqPo.useContext)((0, $87Bg8.default));
    const [currentId, setCurrentId] = (0, $4fqPo.useState)((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
    $377d7474147ef94b$var$useLayoutEffectSAFE(()=>{
        setCurrentId((interactionId === null || interactionId === void 0 ? void 0 : interactionId.current) || null);
        const unsubscribe = (0, $87Bg8.subscribeToInteractionIdChanges)((newId)=>{
            setCurrentId(newId);
        });
        return unsubscribe;
    }, [
        interactionId
    ]);
    return currentId;
}
function $377d7474147ef94b$export$2e2bcd8739ae039({ children: children, name: name, hold: hold = true }) {
    // Check if UFO is enabled
    // Note: isUFOEnabled() returns a stable value based on config, so it's safe to call before hooks
    const ufoEnabled = (0, $jFknK.isUFOEnabled)();
    const currentInteractionId = $377d7474147ef94b$var$useInteractionIdValue();
    // react-18: useId instead
    const context = (0, $4fqPo.useContext)((0, $gE3od.default));
    $377d7474147ef94b$var$useLayoutEffectSAFE(()=>{
        // Skip hold registration if UFO is disabled
        if (!ufoEnabled) return;
        if (hold && context != null) return context.hold(name);
    }, [
        hold,
        context,
        name,
        currentInteractionId,
        ufoEnabled
    ]);
    // react-18: can return children directly
    return children != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children) : null;
}

});

parcelRegister("54X0l", function(module, exports) {
$parcel$export(module.exports, "shapeNavigationTimingData", () => $81bdebf224841517$export$545c2c69328f5019);
$parcel$export(module.exports, "shapeResourceTimingData", () => $81bdebf224841517$export$58bcddf582fad063);

var $3H4LK = parcelRequire("3H4LK");

var $dlWlx = parcelRequire("dlWlx");

var $al1KN = parcelRequire("al1KN");
const $81bdebf224841517$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
// Accepted source values from forge-cdn bridge:
//   - 'forge-framework' (PR #775+) — Forge runtime assets (bridge.js, iframeResizer*, etc.)
//   - 'forge-app'       (PR #775+) — app-author assets on installation-scoped subdomain
//   - 'external'        (both schemes) — anything outside Atlassian-controlled domains
//   - 'internal'        (PR #769 only, LEGACY) — bridges still emit this until PR #775
//                       rolls out everywhere; safe to remove from this allowlist after
//                       the rollout has been stable for a release cycle. Do NOT remove
//                       'external' during that cleanup — it's a first-class value in
//                       both the old and new schemes.
const $81bdebf224841517$var$ACCEPTED_SOURCES = [
    'forge-framework',
    'forge-app',
    'external',
    'internal'
];
const $81bdebf224841517$var$ASSET_RESOURCE_TYPES = new Set([
    'script',
    'link',
    'css'
]);
const $81bdebf224841517$var$OTHER_JS_RESOURCE_TYPE = 'other';
const $81bdebf224841517$var$SCRIPT_EXTENSIONS = [
    '.js',
    '.mjs',
    '.cjs'
];
const $81bdebf224841517$var$STYLESHEET_EXTENSIONS = [
    '.css'
];
const $81bdebf224841517$var$ASSET_EXTENSIONS = [
    ...$81bdebf224841517$var$SCRIPT_EXTENSIONS,
    ...$81bdebf224841517$var$STYLESHEET_EXTENSIONS
];
const $81bdebf224841517$var$FILE_OR_MEDIA_EXTENSIONS = [
    '.pdf',
    '.doc',
    '.docx',
    '.xls',
    '.xlsx',
    '.ppt',
    '.pptx',
    '.csv',
    '.zip',
    '.heic',
    '.mov',
    '.mp4',
    '.mp3',
    '.wav',
    '.woff',
    '.woff2',
    '.ttf',
    '.otf'
];
const $81bdebf224841517$var$IMAGE_EXTENSIONS = [
    '.png',
    '.jpg',
    '.jpeg',
    '.gif',
    '.webp',
    '.svg',
    '.ico'
];
const $81bdebf224841517$var$IMAGE_RESOURCE_LABEL = '<image-resource>';
const $81bdebf224841517$var$FILE_RESOURCE_LABEL = '<file-resource>';
const $81bdebf224841517$var$AVATAR_RESOURCE_LABEL = '<avatar-resource>';
const $81bdebf224841517$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS = [
    /(?:^|\/)secure\/attachment(?:\/|$)/,
    /(?:^|\/)download\/attachments(?:\/|$)/,
    /(?:^|\/)wiki\/download(?:\/|$)/,
    /(?:^|\/)child\/attachment(?:\/|$)/,
    /(?:^|\/)attachment(?:\/|$)/
];
function $81bdebf224841517$var$stripQueryAndHash(value) {
    return value.split(/[?#]/, 1)[0] ?? '';
}
function $81bdebf224841517$var$getLegacyLastPathSegment(value) {
    return value.includes('/') ? value.split('/').filter(Boolean).pop() ?? value : value;
}
function $81bdebf224841517$var$getSanitizedLastPathSegment(value) {
    const trimmedValue = $81bdebf224841517$var$stripQueryAndHash(value).replace(/\/+$/, '');
    if (!trimmedValue.includes('/')) return trimmedValue;
    return trimmedValue.split('/').filter(Boolean).pop() ?? trimmedValue;
}
function $81bdebf224841517$var$hasExtension(value, extensions) {
    const path = $81bdebf224841517$var$stripQueryAndHash(value).toLowerCase();
    return extensions.some((extension)=>path.endsWith(extension));
}
function $81bdebf224841517$var$hasAttachmentOrDownloadPath(value) {
    return $81bdebf224841517$var$ATTACHMENT_OR_DOWNLOAD_PATH_PATTERNS.some((pattern)=>pattern.test(value));
}
function $81bdebf224841517$var$isAvatarResource(value) {
    return value.includes('avatar-management') || value.includes('/initials/') || value.includes('%2finitials%2f') || value.includes('viewavatar');
}
function $81bdebf224841517$var$getSanitizedBackendResourceLabel(rawName) {
    const querylessName = $81bdebf224841517$var$stripQueryAndHash(rawName);
    const normalizedRawName = rawName.toLowerCase();
    const normalizedQuerylessName = querylessName.toLowerCase();
    if ($81bdebf224841517$var$isAvatarResource(normalizedRawName)) return $81bdebf224841517$var$AVATAR_RESOURCE_LABEL;
    if ($81bdebf224841517$var$hasExtension(normalizedQuerylessName, $81bdebf224841517$var$IMAGE_EXTENSIONS)) return $81bdebf224841517$var$IMAGE_RESOURCE_LABEL;
    if ($81bdebf224841517$var$hasAttachmentOrDownloadPath(normalizedQuerylessName) || $81bdebf224841517$var$hasExtension(normalizedQuerylessName, $81bdebf224841517$var$FILE_OR_MEDIA_EXTENSIONS)) return $81bdebf224841517$var$FILE_RESOURCE_LABEL;
    return querylessName;
}
function $81bdebf224841517$var$isBackendResourceTiming(initiatorType) {
    return (0, $dlWlx.BACKEND_RESOURCE_TIMING_INITIATOR_TYPES).has(initiatorType);
}
function $81bdebf224841517$var$isScriptOrStylesheetResource(rawName, initiatorType) {
    if (initiatorType === $81bdebf224841517$var$OTHER_JS_RESOURCE_TYPE) return $81bdebf224841517$var$hasExtension(rawName, $81bdebf224841517$var$ASSET_EXTENSIONS);
    if (!$81bdebf224841517$var$ASSET_RESOURCE_TYPES.has(initiatorType)) return false;
    return $81bdebf224841517$var$hasExtension(rawName, $81bdebf224841517$var$ASSET_EXTENSIONS);
}
function $81bdebf224841517$export$545c2c69328f5019(data) {
    const payload = (data === null || data === void 0 ? void 0 : data.payload) || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = (payload === null || payload === void 0 ? void 0 : payload.timing) || payload;
    // Trim long URLs to just the last path segment to keep payload size manageable.
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const label = rawName.includes('/') ? rawName.split('/').filter(Boolean).pop() ?? rawName : rawName;
    return {
        label: label,
        // From Resource Timing spec
        redirectStart: $81bdebf224841517$var$num(timing.redirectStart),
        redirectEnd: $81bdebf224841517$var$num(timing.redirectEnd),
        fetchStart: $81bdebf224841517$var$num(timing.fetchStart),
        domainLookupStart: $81bdebf224841517$var$num(timing.domainLookupStart),
        domainLookupEnd: $81bdebf224841517$var$num(timing.domainLookupEnd),
        connectStart: $81bdebf224841517$var$num(timing.connectStart),
        connectEnd: $81bdebf224841517$var$num(timing.connectEnd),
        secureConnectionStart: $81bdebf224841517$var$num(timing.secureConnectionStart),
        requestStart: $81bdebf224841517$var$num(timing.requestStart),
        responseStart: $81bdebf224841517$var$num(timing.responseStart),
        responseEnd: $81bdebf224841517$var$num(timing.responseEnd),
        // Added in PR #769 — present in new flat shape, absent in old nested shape (defaults to 0)
        encodedBodySize: $81bdebf224841517$var$num(timing.encodedBodySize),
        decodedBodySize: $81bdebf224841517$var$num(timing.decodedBodySize),
        transferSize: $81bdebf224841517$var$num(timing.transferSize),
        // From Navigation Timing 2 spec
        redirectCount: $81bdebf224841517$var$num(payload.redirectCount),
        type: typeof payload.type === 'string' ? payload.type : undefined,
        unloadEventStart: $81bdebf224841517$var$num(timing.unloadEventStart),
        unloadEventEnd: $81bdebf224841517$var$num(timing.unloadEventEnd),
        workerStart: $81bdebf224841517$var$num(timing.workerStart),
        nextHopProtocol: typeof timing.nextHopProtocol === 'string' ? timing.nextHopProtocol : undefined
    };
}
function $81bdebf224841517$export$58bcddf582fad063(data) {
    const payload = (data === null || data === void 0 ? void 0 : data.payload) || {};
    // payload.timing.* to payload.* directly. Support both shapes during rollout.
    const timing = (payload === null || payload === void 0 ? void 0 : payload.timing) || payload;
    const rawName = typeof payload.name === 'string' ? payload.name : '';
    const initiatorType = typeof payload.initiatorType === 'string' ? payload.initiatorType : 'other';
    const isFilteredModeEnabled = (0, $3H4LK.fg)('platform_ufo_3p_segment_timings');
    const isBackendTiming = $81bdebf224841517$var$isBackendResourceTiming(initiatorType);
    if (isFilteredModeEnabled && !isBackendTiming && !$81bdebf224841517$var$isScriptOrStylesheetResource(rawName, initiatorType)) return undefined;
    const name = isFilteredModeEnabled ? isBackendTiming ? $81bdebf224841517$var$getSanitizedBackendResourceLabel(rawName) : $81bdebf224841517$var$getSanitizedLastPathSegment(rawName) : $81bdebf224841517$var$getLegacyLastPathSegment(rawName);
    const startTime = $81bdebf224841517$var$num(payload.startTime);
    const duration = $81bdebf224841517$var$num(payload.duration);
    const fetchStart = $81bdebf224841517$var$num(timing.fetchStart);
    const workerStart = $81bdebf224841517$var$num(timing.workerStart);
    const responseStart = $81bdebf224841517$var$num(timing.responseStart);
    const requestStart = $81bdebf224841517$var$num(timing.requestStart);
    const transferSize = typeof payload.transferSize === 'number' ? payload.transferSize : undefined;
    const encodedSize = typeof payload.encodedBodySize === 'number' ? payload.encodedBodySize : undefined;
    const decodedSize = typeof payload.decodedBodySize === 'number' ? payload.decodedBodySize : undefined;
    // serverTime / networkTime are not in the current iframe payload but kept for forward-compat
    const serverTime = typeof payload.serverTime === 'number' ? payload.serverTime : undefined;
    const networkTime = typeof payload.networkTime === 'number' ? payload.networkTime : undefined;
    const source = $81bdebf224841517$var$ACCEPTED_SOURCES.includes(payload.source) ? payload.source : undefined;
    // Base fields — always present (times are relative to interaction start from the iframe)
    const shaped = {
        label: name,
        startTime: startTime,
        duration: duration,
        workerStart: Math.max(workerStart, 0),
        fetchStart: Math.max(fetchStart, 0),
        type: initiatorType,
        ...source !== undefined ? {
            source: source
        } : {}
    };
    const cacheable = (0, $al1KN.isCacheableType)(rawName, initiatorType);
    shaped.ttfb = responseStart;
    if (serverTime !== undefined) shaped.serverTime = serverTime;
    if (networkTime !== undefined) shaped.networkTime = networkTime;
    if (transferSize !== undefined) shaped.size = transferSize;
    // Flag entries where timing-allow-origin headers are missing:
    // duration > 0 but all size fields are 0 means the browser withheld size data.
    if (duration > 0 && transferSize === 0 && encodedSize === 0) shaped.noTA = true;
    if (cacheable) {
        // CacheableResourceTiming — calculateTransferType is only meaningful for cacheable resources
        const transferType = (0, $al1KN.calculateTransferType)(rawName, initiatorType, duration, transferSize);
        if (transferType !== null) shaped.transferType = transferType;
        if (encodedSize !== undefined) shaped.encodedSize = encodedSize;
        if (decodedSize !== undefined) shaped.decodedSize = decodedSize;
    } else // NonCacheableResourceTiming (fetch, xmlhttprequest, etc.)
    shaped.requestStart = requestStart;
    return shaped;
}

});
parcelRegister("al1KN", function(module, exports) {
$parcel$export(module.exports, "isCacheableType", () => $cd535d7607ebb41d$export$86a03f39f85a653c);
$parcel$export(module.exports, "calculateTransferType", () => $cd535d7607ebb41d$export$82deef6698791e4e);
const $cd535d7607ebb41d$var$alwaysCacheableTypes = [
    'script',
    'link'
];
const $cd535d7607ebb41d$var$CACHE_NETWORK = 'network';
const $cd535d7607ebb41d$var$CACHE_MEMORY = 'memory';
const $cd535d7607ebb41d$var$CACHE_DISK = 'disk';
function $cd535d7607ebb41d$export$86a03f39f85a653c(url, type) {
    if ($cd535d7607ebb41d$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
function $cd535d7607ebb41d$export$82deef6698791e4e(name, type, duration, size) {
    if (!$cd535d7607ebb41d$export$86a03f39f85a653c(name, type)) return $cd535d7607ebb41d$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $cd535d7607ebb41d$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $cd535d7607ebb41d$var$CACHE_DISK;
    if (size === undefined) return null;
    return $cd535d7607ebb41d$var$CACHE_NETWORK;
}

});


parcelRegister("fw8uM", function(module, exports) {
$parcel$export(module.exports, "shapePaintTimingData", () => $6220bfbc3233c87a$export$eb873803b57f13dd);
$parcel$export(module.exports, "shapeLargestContentfulPaintData", () => $6220bfbc3233c87a$export$249cfe420379ce6a);
$parcel$export(module.exports, "shapeLayoutShiftData", () => $6220bfbc3233c87a$export$13eca0f9ce301e95);
$parcel$export(module.exports, "isDomMutationsFinalBatch", () => $6220bfbc3233c87a$export$e8c5a8531f7dfa04);
$parcel$export(module.exports, "shapeDomMutationsData", () => $6220bfbc3233c87a$export$6954fd19623912a2);
/**
 * Iframe event shaping helpers
 *
 * These functions normalise raw Forge bridge event data into compact, consistent
 * shapes before storing in segment3pTimings, reducing payload size and aligning
 * with the equivalent host-page metrics where applicable.
 *
 * Each function receives the full raw event object (minus `type`) and returns
 * only the fields worth retaining in the analytics payload.
 */ const $6220bfbc3233c87a$var$num = (v)=>typeof v === 'number' ? Math.round(v) : 0;
function $6220bfbc3233c87a$var$extractPayload(data) {
    return data.payload !== null && typeof data.payload === 'object' ? data.payload : {};
}
function $6220bfbc3233c87a$export$eb873803b57f13dd(data) {
    const payload = $6220bfbc3233c87a$var$extractPayload(data);
    return {
        name: typeof payload.name === 'string' ? payload.name : '',
        startTime: $6220bfbc3233c87a$var$num(payload.startTime)
    };
}
function $6220bfbc3233c87a$export$249cfe420379ce6a(data) {
    const payload = $6220bfbc3233c87a$var$extractPayload(data);
    return {
        startTime: $6220bfbc3233c87a$var$num(payload.startTime),
        size: $6220bfbc3233c87a$var$num(payload.size)
    };
}
function $6220bfbc3233c87a$export$13eca0f9ce301e95(data) {
    const payload = $6220bfbc3233c87a$var$extractPayload(data);
    const rawSources = Array.isArray(payload.sources) ? payload.sources : [];
    const sources = rawSources.map((source)=>{
        const s = source !== null && typeof source === 'object' ? source : {};
        return {
            node: typeof s.node === 'string' ? s.node : 'unknown'
        };
    });
    return {
        value: typeof payload.value === 'number' ? payload.value : 0,
        startTime: $6220bfbc3233c87a$var$num(payload.startTime),
        cumulativeScore: typeof payload.cumulativeScore === 'number' ? payload.cumulativeScore : 0,
        sessionValue: typeof payload.sessionValue === 'number' ? payload.sessionValue : 0,
        sources: sources
    };
}
function $6220bfbc3233c87a$export$e8c5a8531f7dfa04(data) {
    const payload = $6220bfbc3233c87a$var$extractPayload(data);
    return payload.isFinalBatch === true;
}
function $6220bfbc3233c87a$export$6954fd19623912a2(data) {
    const payload = $6220bfbc3233c87a$var$extractPayload(data);
    return {
        totalMutations: typeof payload.totalMutations === 'number' ? payload.totalMutations : 0,
        observationDurationMs: $6220bfbc3233c87a$var$num(payload.observationDurationMs),
        stopReason: typeof payload.stopReason === 'string' ? payload.stopReason : null
    };
}

});



parcelRegister("dNVFO", function(module, exports) {
$parcel$export(module.exports, "install", () => $ab4c8d329dc6909a$export$4b3e715f166fdd78);

var $63sfu = parcelRequire("63sfu");
parcelRequire("5xNvQ");
var $dGueR = parcelRequire("dGueR");
parcelRequire("7kcrn");
var $g8oau = parcelRequire("g8oau");
const $ab4c8d329dc6909a$export$4b3e715f166fdd78 = (0, $63sfu.once)(()=>{
    // asset-field-value is rendered on Request Details; it displays the names of assets linked to the request
    if (typeof window !== 'undefined' && window.customElements) {
        customElements.define('asset-field-value', (0, $dGueR.getAssetFieldValueElementClass)());
        customElements.define('cmdb-field-value', (0, $g8oau.getCmdbFieldValueElement)());
    }
});

});
parcelRegister("5xNvQ", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => (parcelRequire("dGueR")).getAssetFieldValueElementClass);

var $dGueR = parcelRequire("dGueR");

});
parcelRegister("dGueR", function(module, exports) {
$parcel$export(module.exports, "getAssetFieldValueElementClass", () => $4d21b04f69def2bb$export$586e8886906ef36f);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $5F0K9 = parcelRequire("5F0K9");

var $3SIyc = parcelRequire("3SIyc");

var $lDY9g = parcelRequire("lDY9g");

var $gcTFJ = parcelRequire("gcTFJ");

var $fVwZr = parcelRequire("fVwZr");

var $lF29w = parcelRequire("lF29w");
const $4d21b04f69def2bb$var$onIntlError = (intlError)=>{
    try {
        $fVwZr.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $4d21b04f69def2bb$export$3bcefabe8b04378c = (intlError)=>{
    $4d21b04f69def2bb$var$onIntlError(intlError.message);
};
const $4d21b04f69def2bb$export$586e8886906ef36f = ()=>{
    class AssetFieldValueElement extends HTMLElement {
        connectedCallback() {
            // create a Shadow DOM (i.e. the contents of this web component)
            const shadow = this.attachShadow({
                mode: 'open'
            });
            // Jira passes the asset's origin as a data-origin attribute
            const origin = this.getAttribute('data-origin');
            if ((0, $bG6ob.isUseReact18CreateRootEnabled)()) {
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const container = document.createElement('span');
                const root = (0, $5F0K9.createRoot)(container);
                root.render(/*#__PURE__*/ $4fqPo.createElement((0, $3SIyc.default), {
                    messages: (0, $lDY9g.default)(),
                    locale: (0, $gcTFJ.getLanguageFromLocale)((0, $6mmHn.getMetaData)().userLocale),
                    onError: $4d21b04f69def2bb$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $4fqPo.createElement((0, $lF29w.default), {
                    origin: origin
                })));
                shadow.appendChild(container);
            } else {
                // render the component with its props, and add to the Shadow DOM
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const root = document.createElement('span');
                // eslint-disable-next-line react/no-deprecated
                $b2Ka1.render(/*#__PURE__*/ $4fqPo.createElement((0, $3SIyc.default), {
                    messages: (0, $lDY9g.default)(),
                    locale: (0, $gcTFJ.getLanguageFromLocale)((0, $6mmHn.getMetaData)().userLocale),
                    onError: $4d21b04f69def2bb$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $4fqPo.createElement((0, $lF29w.default), {
                    origin: origin
                })), root);
                shadow.appendChild(root);
            }
        }
    }
    return AssetFieldValueElement;
};

});
parcelRegister("3SIyc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d38f9130d21d1cc$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d8KcD = parcelRequire("d8KcD");

var $cGJIN = parcelRequire("cGJIN");

var $4fqPo = parcelRequire("4fqPo");

var $3QJ2d = parcelRequire("3QJ2d");

var $bRPIJ = parcelRequire("bRPIJ");

var $efDRU = parcelRequire("efDRU");
function $2d38f9130d21d1cc$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $2d38f9130d21d1cc$var$IntlProvider = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $cGJIN.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $bRPIJ.createIntl)($2d38f9130d21d1cc$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $2d38f9130d21d1cc$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $2d38f9130d21d1cc$var$processIntlConfig(props);
        if (!(0, $3QJ2d.shallowEqual)(prevConfig, config)) return {
            intl: (0, $bRPIJ.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $3QJ2d.invariantIntlContext)(this.state.intl);
        return $4fqPo.createElement((0, $efDRU.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $3QJ2d.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($4fqPo.PureComponent);
var $2d38f9130d21d1cc$export$2e2bcd8739ae039 = $2d38f9130d21d1cc$var$IntlProvider;

});
parcelRegister("cGJIN", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $93ccdfa2b5bba2e6$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $93ccdfa2b5bba2e6$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $93ccdfa2b5bba2e6$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $93ccdfa2b5bba2e6$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $93ccdfa2b5bba2e6$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $93ccdfa2b5bba2e6$export$4ee1db8ce44a209b);

var $d8KcD = parcelRequire("d8KcD");

var $dUdAV = parcelRequire("dUdAV");
parcelRequire("a2Lmk");
var $NzqPW = parcelRequire("NzqPW");

var $dwV5a = parcelRequire("dwV5a");
function $93ccdfa2b5bba2e6$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $93ccdfa2b5bba2e6$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $93ccdfa2b5bba2e6$var$defaultErrorHandler = function(error) {};
var $93ccdfa2b5bba2e6$var$defaultWarnHandler = function(warning) {};
var $93ccdfa2b5bba2e6$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $93ccdfa2b5bba2e6$var$defaultErrorHandler,
    onWarn: $93ccdfa2b5bba2e6$var$defaultWarnHandler
};
function $93ccdfa2b5bba2e6$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $93ccdfa2b5bba2e6$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $93ccdfa2b5bba2e6$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $93ccdfa2b5bba2e6$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $dUdAV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $dUdAV.strategies).variadic
    });
    var getNumberFormat = (0, $dUdAV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.number),
        strategy: (0, $dUdAV.strategies).variadic
    });
    var getPluralRules = (0, $dUdAV.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d8KcD.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $dUdAV.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $dUdAV.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $NzqPW.IntlMessageFormat)(message, locales, overrideFormats, (0, $d8KcD.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.message),
            strategy: (0, $dUdAV.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $dUdAV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $dUdAV.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $dUdAV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.list),
            strategy: (0, $dUdAV.strategies).variadic
        }),
        getDisplayNames: (0, $dUdAV.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $93ccdfa2b5bba2e6$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $dUdAV.strategies).variadic
        })
    };
}
function $93ccdfa2b5bba2e6$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $dwV5a.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("dUdAV", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $a1fb0cf1ff70a86f$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $a1fb0cf1ff70a86f$export$c5491a8691a23b9e);
//
// Main
//
function $a1fb0cf1ff70a86f$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $a1fb0cf1ff70a86f$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $a1fb0cf1ff70a86f$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $a1fb0cf1ff70a86f$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $a1fb0cf1ff70a86f$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $a1fb0cf1ff70a86f$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $a1fb0cf1ff70a86f$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $a1fb0cf1ff70a86f$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $a1fb0cf1ff70a86f$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $a1fb0cf1ff70a86f$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $a1fb0cf1ff70a86f$var$monadic : $a1fb0cf1ff70a86f$var$variadic;
    return $a1fb0cf1ff70a86f$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $a1fb0cf1ff70a86f$var$strategyVariadic(fn, options) {
    return $a1fb0cf1ff70a86f$var$assemble(fn, this, $a1fb0cf1ff70a86f$var$variadic, options.cache.create(), options.serializer);
}
function $a1fb0cf1ff70a86f$var$strategyMonadic(fn, options) {
    return $a1fb0cf1ff70a86f$var$assemble(fn, this, $a1fb0cf1ff70a86f$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $a1fb0cf1ff70a86f$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $a1fb0cf1ff70a86f$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $a1fb0cf1ff70a86f$var$cacheDefault = {
    create: function create() {
        return new $a1fb0cf1ff70a86f$var$ObjectWithoutPrototypeCache();
    }
};
var $a1fb0cf1ff70a86f$export$c5491a8691a23b9e = {
    variadic: $a1fb0cf1ff70a86f$var$strategyVariadic,
    monadic: $a1fb0cf1ff70a86f$var$strategyMonadic
};

});

parcelRegister("a2Lmk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("3V9m4")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("3V9m4")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("3VPtv")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("NzqPW")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $NzqPW = parcelRequire("NzqPW");
parcelRequire("3V9m4");
parcelRequire("3VPtv");
var $74fed3d7fce79db2$export$2e2bcd8739ae039 = (0, $NzqPW.IntlMessageFormat);

});
parcelRegister("NzqPW", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $09500fbebe6dd726$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $d8KcD = parcelRequire("d8KcD");

var $dUdAV = parcelRequire("dUdAV");

var $hsf6q = parcelRequire("hsf6q");

var $3VPtv = parcelRequire("3VPtv");
// -- MessageFormat --------------------------------------------------------
function $09500fbebe6dd726$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $09500fbebe6dd726$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $09500fbebe6dd726$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $d8KcD.__assign)({}, defaultConfig));
}
function $09500fbebe6dd726$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $09500fbebe6dd726$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $dUdAV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $09500fbebe6dd726$var$createFastMemoizeCache(cache.number),
            strategy: (0, $dUdAV.strategies).variadic
        }),
        getDateTimeFormat: (0, $dUdAV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $09500fbebe6dd726$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $dUdAV.strategies).variadic
        }),
        getPluralRules: (0, $dUdAV.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $09500fbebe6dd726$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $dUdAV.strategies).variadic
        })
    };
}
var $09500fbebe6dd726$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $3VPtv.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $3VPtv.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $d8KcD.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $09500fbebe6dd726$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $09500fbebe6dd726$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $hsf6q.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("hsf6q", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("3cn4C")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("3cn4C")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("3cn4C")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("3cn4C")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("3cn4C")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("3cn4C")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("3cn4C")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("3cn4C")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("3cn4C")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("3cn4C")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("3cn4C")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("3cn4C")).TYPE);
$parcel$export(module.exports, "parse", () => $cb50c43d7bb67acf$export$98e6a39c04603d36);

var $d8KcD = parcelRequire("d8KcD");

var $8TboB = parcelRequire("8TboB");

var $5lYMF = parcelRequire("5lYMF");

var $3cn4C = parcelRequire("3cn4C");

var $5OHBf = parcelRequire("5OHBf");
function $cb50c43d7bb67acf$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $3cn4C.isSelectElement)(el) || (0, $3cn4C.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $cb50c43d7bb67acf$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $3cn4C.isNumberElement)(el) && (0, $3cn4C.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $3cn4C.isDateElement)(el) || (0, $3cn4C.isTimeElement)(el)) && (0, $3cn4C.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $3cn4C.isTagElement)(el)) $cb50c43d7bb67acf$var$pruneLocation(el.children);
    });
}
function $cb50c43d7bb67acf$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $d8KcD.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5lYMF.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $8TboB.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $cb50c43d7bb67acf$var$pruneLocation(result.val);
    return result.val;
}
var $cb50c43d7bb67acf$export$d3c1bfa0f7d806e9 = (0, $5lYMF.Parser);

});
parcelRegister("8TboB", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $678c4cbc6d973a1d$export$896afd8541959ee5);
var $678c4cbc6d973a1d$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($678c4cbc6d973a1d$export$896afd8541959ee5 || ($678c4cbc6d973a1d$export$896afd8541959ee5 = {}));

});

parcelRegister("5lYMF", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $3e5e105847f3d789$export$7acfa6ed01010e37);

var $d8KcD = parcelRequire("d8KcD");

var $8TboB = parcelRequire("8TboB");

var $3cn4C = parcelRequire("3cn4C");

var $7IlCV = parcelRequire("7IlCV");
parcelRequire("jVVY0");
var $5FuHb = parcelRequire("5FuHb");
var $4zi0T = parcelRequire("4zi0T");

var $eYL5x = parcelRequire("eYL5x");
var $3e5e105847f3d789$var$_a;
var $3e5e105847f3d789$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $7IlCV.SPACE_SEPARATOR_REGEX).source, "*"));
var $3e5e105847f3d789$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $7IlCV.SPACE_SEPARATOR_REGEX).source, "*$"));
function $3e5e105847f3d789$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $3e5e105847f3d789$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $3e5e105847f3d789$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $3e5e105847f3d789$var$hasNativeFromEntries = !!Object.fromEntries;
var $3e5e105847f3d789$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $3e5e105847f3d789$var$hasTrimStart = !!String.prototype.trimStart;
var $3e5e105847f3d789$var$hasTrimEnd = !!String.prototype.trimEnd;
var $3e5e105847f3d789$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $3e5e105847f3d789$var$isSafeInteger = $3e5e105847f3d789$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $3e5e105847f3d789$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $3e5e105847f3d789$var$re = $3e5e105847f3d789$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $3e5e105847f3d789$var$REGEX_SUPPORTS_U_AND_Y = (($3e5e105847f3d789$var$_a = $3e5e105847f3d789$var$re.exec('a')) === null || $3e5e105847f3d789$var$_a === void 0 ? void 0 : $3e5e105847f3d789$var$_a[0]) === 'a';
} catch (_) {
    $3e5e105847f3d789$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $3e5e105847f3d789$var$startsWith = $3e5e105847f3d789$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $3e5e105847f3d789$var$fromCodePoint = $3e5e105847f3d789$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $3e5e105847f3d789$var$fromEntries = // native
$3e5e105847f3d789$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $3e5e105847f3d789$var$codePointAt = $3e5e105847f3d789$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $3e5e105847f3d789$var$trimStart = $3e5e105847f3d789$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($3e5e105847f3d789$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $3e5e105847f3d789$var$trimEnd = $3e5e105847f3d789$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($3e5e105847f3d789$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $3e5e105847f3d789$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $3e5e105847f3d789$var$matchIdentifierAtIndex;
if ($3e5e105847f3d789$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $3e5e105847f3d789$var$IDENTIFIER_PREFIX_RE_1 = $3e5e105847f3d789$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $3e5e105847f3d789$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $3e5e105847f3d789$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $3e5e105847f3d789$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$3e5e105847f3d789$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $3e5e105847f3d789$var$codePointAt(s, index);
        if (c === undefined || $3e5e105847f3d789$var$_isWhiteSpace(c) || $3e5e105847f3d789$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $3e5e105847f3d789$var$fromCodePoint.apply(void 0, match);
};
var $3e5e105847f3d789$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $3cn4C.TYPE).pound,
                    location: $3e5e105847f3d789$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $8TboB.ErrorKind).UNMATCHED_CLOSING_TAG, $3e5e105847f3d789$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $3e5e105847f3d789$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $3cn4C.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $3e5e105847f3d789$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$3e5e105847f3d789$var$_isAlpha(this.char())) return this.error((0, $8TboB.ErrorKind).INVALID_TAG, $3e5e105847f3d789$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $8TboB.ErrorKind).UNMATCHED_CLOSING_TAG, $3e5e105847f3d789$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $8TboB.ErrorKind).INVALID_TAG, $3e5e105847f3d789$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $3cn4C.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $3e5e105847f3d789$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $8TboB.ErrorKind).UNCLOSED_TAG, $3e5e105847f3d789$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $8TboB.ErrorKind).INVALID_TAG, $3e5e105847f3d789$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $3e5e105847f3d789$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $3e5e105847f3d789$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $3cn4C.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$3e5e105847f3d789$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $3e5e105847f3d789$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $3e5e105847f3d789$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $8TboB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $8TboB.ErrorKind).EMPTY_ARGUMENT, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $8TboB.ErrorKind).MALFORMED_ARGUMENT, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $8TboB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $3cn4C.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $8TboB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $8TboB.ErrorKind).MALFORMED_ARGUMENT, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $3e5e105847f3d789$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $3e5e105847f3d789$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $8TboB.ErrorKind).EXPECT_ARGUMENT_TYPE, $3e5e105847f3d789$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $3e5e105847f3d789$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $8TboB.ErrorKind).EXPECT_ARGUMENT_STYLE, $3e5e105847f3d789$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $3e5e105847f3d789$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $3e5e105847f3d789$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $3e5e105847f3d789$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $3cn4C.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $8TboB.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $eYL5x.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $3cn4C.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $5FuHb.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $3cn4C.TYPE).date : (0, $3cn4C.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $3cn4C.TYPE).number : argType === 'date' ? (0, $3cn4C.TYPE).date : (0, $3cn4C.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $8TboB.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $3e5e105847f3d789$var$createLocation(typeEndPosition_1, (0, $d8KcD.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $8TboB.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $3e5e105847f3d789$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $8TboB.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $8TboB.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $3cn4C.TYPE).select,
                        value: value,
                        options: $3e5e105847f3d789$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $3cn4C.TYPE).plural,
                        value: value,
                        options: $3e5e105847f3d789$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $8TboB.ErrorKind).INVALID_ARGUMENT_TYPE, $3e5e105847f3d789$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $8TboB.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $8TboB.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $3e5e105847f3d789$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $4zi0T.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $8TboB.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $3cn4C.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $4zi0T.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $8TboB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $8TboB.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $3e5e105847f3d789$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $8TboB.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $8TboB.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $8TboB.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $8TboB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $3e5e105847f3d789$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $3e5e105847f3d789$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $8TboB.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $8TboB.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $3e5e105847f3d789$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $8TboB.ErrorKind).MISSING_OTHER_CLAUSE, $3e5e105847f3d789$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $3e5e105847f3d789$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$3e5e105847f3d789$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $3e5e105847f3d789$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($3e5e105847f3d789$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $3e5e105847f3d789$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $3e5e105847f3d789$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $3e5e105847f3d789$var$_isAlphaOrSlash(codepoint) {
    return $3e5e105847f3d789$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $3e5e105847f3d789$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3e5e105847f3d789$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3e5e105847f3d789$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("3cn4C", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $254463fe38c1ce62$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $254463fe38c1ce62$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $254463fe38c1ce62$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $254463fe38c1ce62$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $254463fe38c1ce62$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $254463fe38c1ce62$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $254463fe38c1ce62$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $254463fe38c1ce62$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $254463fe38c1ce62$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $254463fe38c1ce62$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $254463fe38c1ce62$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $254463fe38c1ce62$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $254463fe38c1ce62$export$7680c41f1a55f4cf);
var $254463fe38c1ce62$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($254463fe38c1ce62$export$b87f371cbc396fcf || ($254463fe38c1ce62$export$b87f371cbc396fcf = {}));
var $254463fe38c1ce62$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($254463fe38c1ce62$export$906452485466fa53 || ($254463fe38c1ce62$export$906452485466fa53 = {}));
function $254463fe38c1ce62$export$cfa10c5697238752(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.literal;
}
function $254463fe38c1ce62$export$4f55724281bdfaf9(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.argument;
}
function $254463fe38c1ce62$export$e11187b219e191e1(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.number;
}
function $254463fe38c1ce62$export$32d811605da75f40(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.date;
}
function $254463fe38c1ce62$export$34ec46f596b1702f(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.time;
}
function $254463fe38c1ce62$export$dcfe1c11d168b5a1(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.select;
}
function $254463fe38c1ce62$export$6c796d116f0a4fbc(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.plural;
}
function $254463fe38c1ce62$export$c0ece297bdd0c082(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.pound;
}
function $254463fe38c1ce62$export$5c83de34745812b(el) {
    return el.type === $254463fe38c1ce62$export$b87f371cbc396fcf.tag;
}
function $254463fe38c1ce62$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $254463fe38c1ce62$export$906452485466fa53.number);
}
function $254463fe38c1ce62$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $254463fe38c1ce62$export$906452485466fa53.dateTime);
}
function $254463fe38c1ce62$export$f0ac572c1121c662(value) {
    return {
        type: $254463fe38c1ce62$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $254463fe38c1ce62$export$425e864b0ba114f1(value, style) {
    return {
        type: $254463fe38c1ce62$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("7IlCV", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $59dd6b1bc681ee9d$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $59dd6b1bc681ee9d$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $59dd6b1bc681ee9d$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("jVVY0", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("5FuHb")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("4zi0T")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("4zi0T")).parseNumberSkeletonFromString);
parcelRequire("5FuHb");
parcelRequire("4zi0T");

});
parcelRegister("5FuHb", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $420897946f27dc44$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $420897946f27dc44$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $420897946f27dc44$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($420897946f27dc44$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("4zi0T", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $3538676872b2cf4e$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $3538676872b2cf4e$export$47c6f8480bda3e11);

var $d8KcD = parcelRequire("d8KcD");

var $geEHV = parcelRequire("geEHV");
function $3538676872b2cf4e$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $geEHV.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $3538676872b2cf4e$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $3538676872b2cf4e$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $3538676872b2cf4e$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $3538676872b2cf4e$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $3538676872b2cf4e$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $3538676872b2cf4e$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($3538676872b2cf4e$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $3538676872b2cf4e$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $3538676872b2cf4e$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$3538676872b2cf4e$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $3538676872b2cf4e$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $3538676872b2cf4e$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $3538676872b2cf4e$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $3538676872b2cf4e$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, all), $3538676872b2cf4e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, all), $3538676872b2cf4e$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($3538676872b2cf4e$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($3538676872b2cf4e$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($3538676872b2cf4e$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($3538676872b2cf4e$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), $3538676872b2cf4e$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($3538676872b2cf4e$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), $3538676872b2cf4e$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $3538676872b2cf4e$var$parseSign(token.stem);
        if (signOpts) result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $3538676872b2cf4e$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("geEHV", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $bd1d87cf9043b4c9$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $bd1d87cf9043b4c9$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("eYL5x", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $ae7b320bc3ef4e2f$export$29c5368be8904d27);

var $2tteN = parcelRequire("2tteN");
function $ae7b320bc3ef4e2f$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $ae7b320bc3ef4e2f$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $ae7b320bc3ef4e2f$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $2tteN.timeData)[regionTag || ''] || (0, $2tteN.timeData)[languageTag || ''] || (0, $2tteN.timeData)["".concat(languageTag, "-001")] || (0, $2tteN.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("2tteN", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $1cd4f82bd879ee31$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $1cd4f82bd879ee31$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("5OHBf", function(module, exports) {

var $d8KcD = parcelRequire("d8KcD");

var $3cn4C = parcelRequire("3cn4C");
function $43c37144782d3330$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $d8KcD.__spreadArray)([], obj.map($43c37144782d3330$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $43c37144782d3330$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $43c37144782d3330$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $43c37144782d3330$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $43c37144782d3330$export$be5687ba8bbdf416((0, $d8KcD.__spreadArray)((0, $d8KcD.__spreadArray)((0, $d8KcD.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $43c37144782d3330$var$isPluralOrSelectElement(el) {
    return (0, $3cn4C.isPluralElement)(el) || (0, $3cn4C.isSelectElement)(el);
}
function $43c37144782d3330$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($43c37144782d3330$var$isPluralOrSelectElement(el)) return true;
        if ((0, $3cn4C.isTagElement)(el)) return $43c37144782d3330$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $43c37144782d3330$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($43c37144782d3330$var$isPluralOrSelectElement(el)) return [
            $43c37144782d3330$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $3cn4C.isTagElement)(el) && $43c37144782d3330$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $43c37144782d3330$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $3cn4C.isArgumentElement)(el) || (0, $3cn4C.isDateElement)(el) || (0, $3cn4C.isTimeElement)(el) || (0, $3cn4C.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $3cn4C.isPluralElement)(el) || (0, $3cn4C.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $43c37144782d3330$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $3cn4C.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $43c37144782d3330$var$collectVariables(el.children, vars);
        }
    });
}
function $43c37144782d3330$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $43c37144782d3330$var$collectVariables(a, aVars);
    $43c37144782d3330$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $3cn4C.TYPE)[type], " vs ").concat((0, $3cn4C.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("3VPtv", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $2dce9fcc96de5ace$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $2dce9fcc96de5ace$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $2dce9fcc96de5ace$export$275d4a3bb5f66fda);
parcelRequire("hsf6q");
var $3cn4C = parcelRequire("3cn4C");

var $3V9m4 = parcelRequire("3V9m4");
var $2dce9fcc96de5ace$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($2dce9fcc96de5ace$export$49694c2877b44c57 || ($2dce9fcc96de5ace$export$49694c2877b44c57 = {}));
function $2dce9fcc96de5ace$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $2dce9fcc96de5ace$export$49694c2877b44c57.literal || part.type !== $2dce9fcc96de5ace$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $2dce9fcc96de5ace$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $2dce9fcc96de5ace$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $3cn4C.isLiteralElement)(els[0])) return [
        {
            type: $2dce9fcc96de5ace$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $3cn4C.isLiteralElement)(el)) {
            result.push({
                type: $2dce9fcc96de5ace$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $3cn4C.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $2dce9fcc96de5ace$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $3V9m4.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $3cn4C.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $2dce9fcc96de5ace$export$49694c2877b44c57.literal : $2dce9fcc96de5ace$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $3cn4C.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $3cn4C.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $2dce9fcc96de5ace$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3cn4C.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $3cn4C.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $2dce9fcc96de5ace$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3cn4C.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $3cn4C.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $2dce9fcc96de5ace$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3cn4C.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$2dce9fcc96de5ace$export$df0c12a2d414a163(formatFn)) throw new (0, $3V9m4.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $2dce9fcc96de5ace$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $2dce9fcc96de5ace$export$49694c2877b44c57.literal : $2dce9fcc96de5ace$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $3cn4C.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $3V9m4.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $2dce9fcc96de5ace$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $3cn4C.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $3V9m4.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $3V9m4.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $3V9m4.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $2dce9fcc96de5ace$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $2dce9fcc96de5ace$var$mergeLiteral(result);
}

});
parcelRegister("3V9m4", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $2dadf3ac72831cb3$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $2dadf3ac72831cb3$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $2dadf3ac72831cb3$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $2dadf3ac72831cb3$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $2dadf3ac72831cb3$export$8bfc137e4d23fdf0);

var $d8KcD = parcelRequire("d8KcD");
var $2dadf3ac72831cb3$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($2dadf3ac72831cb3$export$d4e71bc0b80dc0fb || ($2dadf3ac72831cb3$export$d4e71bc0b80dc0fb = {}));
var $2dadf3ac72831cb3$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $2dadf3ac72831cb3$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $2dadf3ac72831cb3$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($2dadf3ac72831cb3$export$7369836851cc1329);
var $2dadf3ac72831cb3$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $2dadf3ac72831cb3$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($2dadf3ac72831cb3$export$7369836851cc1329);
var $2dadf3ac72831cb3$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $2dadf3ac72831cb3$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($2dadf3ac72831cb3$export$7369836851cc1329);

});




parcelRegister("dwV5a", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $9d9a8adf32d43982$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $9d9a8adf32d43982$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $9d9a8adf32d43982$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $9d9a8adf32d43982$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $9d9a8adf32d43982$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $9d9a8adf32d43982$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $9d9a8adf32d43982$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $9d9a8adf32d43982$export$2ddcb436d0aa3688);

var $d8KcD = parcelRequire("d8KcD");
var $9d9a8adf32d43982$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($9d9a8adf32d43982$export$557d6acb76e8a244 || ($9d9a8adf32d43982$export$557d6acb76e8a244 = {}));
var $9d9a8adf32d43982$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $9d9a8adf32d43982$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $9d9a8adf32d43982$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($9d9a8adf32d43982$export$c016d36112f6ddf8);
var $9d9a8adf32d43982$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $9d9a8adf32d43982$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($9d9a8adf32d43982$export$c016d36112f6ddf8);
var $9d9a8adf32d43982$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $9d9a8adf32d43982$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($9d9a8adf32d43982$export$c016d36112f6ddf8);
var $9d9a8adf32d43982$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $9d9a8adf32d43982$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($9d9a8adf32d43982$export$c016d36112f6ddf8);
var $9d9a8adf32d43982$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($9d9a8adf32d43982$export$e3b7eee1dbc44895);
var $9d9a8adf32d43982$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $9d9a8adf32d43982$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($9d9a8adf32d43982$export$c016d36112f6ddf8);

});


parcelRegister("3QJ2d", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $2cd92964b12db5b1$export$f5708dca728d7177);
$parcel$export(module.exports, "invariantIntlContext", () => $2cd92964b12db5b1$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $2cd92964b12db5b1$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "toKeyedReactNodeArray", () => $2cd92964b12db5b1$export$d2fd241e0b53c057);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $2cd92964b12db5b1$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $2cd92964b12db5b1$export$d36bdfa510afb180);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $cGJIN = parcelRequire("cGJIN");
function $2cd92964b12db5b1$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $2cd92964b12db5b1$export$45c4bbf6e55bba1f(intl) {
    $2cd92964b12db5b1$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $2cd92964b12db5b1$export$b52f8d6fc0d47415 = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, (0, $cGJIN.DEFAULT_INTL_CONFIG)), {
    textComponent: $4fqPo.Fragment
});
var $2cd92964b12db5b1$var$toKeyedReactNode = function(reactNode, key) {
    return $4fqPo.isValidElement(reactNode) ? $4fqPo.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $2cd92964b12db5b1$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $4fqPo.Children.map(children, $2cd92964b12db5b1$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $2cd92964b12db5b1$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($2cd92964b12db5b1$export$d2fd241e0b53c057(parts));
    };
}
function $2cd92964b12db5b1$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});

parcelRegister("bRPIJ", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $8a3cc39203563033$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d8KcD = parcelRequire("d8KcD");

var $5UAfF = parcelRequire("5UAfF");
var $cFFys = parcelRequire("cFFys");

var $3VPtv = parcelRequire("3VPtv");

var $3QJ2d = parcelRequire("3QJ2d");
function $8a3cc39203563033$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $3VPtv.isFormatXMLElementFn)(v) ? (0, $3QJ2d.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $8a3cc39203563033$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $8a3cc39203563033$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $cFFys.formatMessage).apply(void 0, (0, $d8KcD.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $3QJ2d.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $8a3cc39203563033$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $d8KcD.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $8a3cc39203563033$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $5UAfF.createIntl)((0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, (0, $3QJ2d.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, coreIntl), {
        formatMessage: $8a3cc39203563033$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $8a3cc39203563033$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("5UAfF", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $44de4d886c1bc82f$export$7e4cbedfdd7b4c0d);

var $d8KcD = parcelRequire("d8KcD");

var $kLDcF = parcelRequire("kLDcF");

var $33G9F = parcelRequire("33G9F");

var $dwV5a = parcelRequire("dwV5a");

var $Fo2sp = parcelRequire("Fo2sp");

var $cFFys = parcelRequire("cFFys");

var $3eZBG = parcelRequire("3eZBG");

var $hhMhL = parcelRequire("hhMhL");

var $k4sFM = parcelRequire("k4sFM");

var $cGJIN = parcelRequire("cGJIN");
function $44de4d886c1bc82f$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $44de4d886c1bc82f$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $44de4d886c1bc82f$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $44de4d886c1bc82f$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $cGJIN.createFormatters)(cache);
    var resolvedConfig = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, (0, $cGJIN.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $dwV5a.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $dwV5a.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $dwV5a.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $44de4d886c1bc82f$var$verifyConfigMessages(resolvedConfig);
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $3eZBG.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $3eZBG.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $k4sFM.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $kLDcF.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $kLDcF.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $kLDcF.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $kLDcF.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $kLDcF.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $hhMhL.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $cFFys.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $cFFys.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $Fo2sp.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $Fo2sp.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $33G9F.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("kLDcF", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $03e6d0f555de36e3$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $03e6d0f555de36e3$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $03e6d0f555de36e3$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $03e6d0f555de36e3$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $03e6d0f555de36e3$export$af6e5d7a5c73edeb);

var $d8KcD = parcelRequire("d8KcD");

var $dwV5a = parcelRequire("dwV5a");

var $cGJIN = parcelRequire("cGJIN");
var $03e6d0f555de36e3$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $03e6d0f555de36e3$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $cGJIN.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $cGJIN.filterProps)(options, $03e6d0f555de36e3$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $03e6d0f555de36e3$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $03e6d0f555de36e3$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $03e6d0f555de36e3$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $03e6d0f555de36e3$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $03e6d0f555de36e3$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $03e6d0f555de36e3$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $03e6d0f555de36e3$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $03e6d0f555de36e3$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $03e6d0f555de36e3$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $03e6d0f555de36e3$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("33G9F", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $23a259fbe349f78a$export$62fe1a4d9e891fa2);

var $cGJIN = parcelRequire("cGJIN");

var $3V9m4 = parcelRequire("3V9m4");

var $dwV5a = parcelRequire("dwV5a");
var $23a259fbe349f78a$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $23a259fbe349f78a$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $3V9m4.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $3V9m4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $cGJIN.filterProps)(options, $23a259fbe349f78a$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $dwV5a.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("Fo2sp", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $07c67a05a3b49228$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $07c67a05a3b49228$export$6f284aad1934db69);

var $d8KcD = parcelRequire("d8KcD");

var $3V9m4 = parcelRequire("3V9m4");

var $dwV5a = parcelRequire("dwV5a");

var $cGJIN = parcelRequire("cGJIN");
var $07c67a05a3b49228$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $07c67a05a3b49228$var$now = Date.now();
function $07c67a05a3b49228$var$generateToken(i) {
    return "".concat($07c67a05a3b49228$var$now, "_").concat(i, "_").concat($07c67a05a3b49228$var$now);
}
function $07c67a05a3b49228$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $07c67a05a3b49228$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $07c67a05a3b49228$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $3V9m4.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $3V9m4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $cGJIN.filterProps)(options, $07c67a05a3b49228$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $07c67a05a3b49228$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $dwV5a.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("cFFys", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $93998c4b39894bd4$export$25868d1e8e76735f);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("hsf6q");
var $3cn4C = parcelRequire("3cn4C");
parcelRequire("a2Lmk");
var $NzqPW = parcelRequire("NzqPW");

var $dwV5a = parcelRequire("dwV5a");

var $cGJIN = parcelRequire("cGJIN");
function $93998c4b39894bd4$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $d8KcD.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $93998c4b39894bd4$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $93998c4b39894bd4$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $NzqPW.IntlMessageFormat).formats;
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, mfFormats), f1), {
        date: $93998c4b39894bd4$var$deepMergeOptions($93998c4b39894bd4$var$setTimeZoneInOptions(mfFormats.date, timeZone), $93998c4b39894bd4$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $93998c4b39894bd4$var$deepMergeOptions($93998c4b39894bd4$var$setTimeZoneInOptions(mfFormats.time, timeZone), $93998c4b39894bd4$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $93998c4b39894bd4$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $cGJIN.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $3cn4C.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, defaultRichTextElements), values || {});
    formats = $93998c4b39894bd4$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $93998c4b39894bd4$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $dwV5a.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $dwV5a.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $d8KcD.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $dwV5a.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $dwV5a.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("3eZBG", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $25c277bd2931533a$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $25c277bd2931533a$export$6871080848f10b2f);

var $dwV5a = parcelRequire("dwV5a");

var $cGJIN = parcelRequire("cGJIN");
var $25c277bd2931533a$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $25c277bd2931533a$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $cGJIN.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $cGJIN.filterProps)(options, $25c277bd2931533a$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $25c277bd2931533a$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $25c277bd2931533a$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $25c277bd2931533a$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $25c277bd2931533a$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("hhMhL", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $c9597ab71294107d$export$bbbd05c900f3568d);

var $3V9m4 = parcelRequire("3V9m4");

var $dwV5a = parcelRequire("dwV5a");

var $cGJIN = parcelRequire("cGJIN");
var $c9597ab71294107d$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $c9597ab71294107d$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $3V9m4.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $3V9m4.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $cGJIN.filterProps)(options, $c9597ab71294107d$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $dwV5a.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("k4sFM", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $e9ca6c2ebab98a86$export$b4ea3b48dcf921f6);

var $cGJIN = parcelRequire("cGJIN");

var $3V9m4 = parcelRequire("3V9m4");

var $dwV5a = parcelRequire("dwV5a");
var $e9ca6c2ebab98a86$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $e9ca6c2ebab98a86$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $cGJIN.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $cGJIN.filterProps)(options, $e9ca6c2ebab98a86$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $e9ca6c2ebab98a86$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $3V9m4.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $3V9m4.ErrorCode).MISSING_INTL_API));
    try {
        return $e9ca6c2ebab98a86$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $dwV5a.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});



parcelRegister("efDRU", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $a601647747dda3b0$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $a601647747dda3b0$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $a601647747dda3b0$export$2e2bcd8739ae039);

var $d8KcD = parcelRequire("d8KcD");

var $cpFTT = parcelRequire("cpFTT");

var $4fqPo = parcelRequire("4fqPo");

var $3QJ2d = parcelRequire("3QJ2d");
function $a601647747dda3b0$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $a601647747dda3b0$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $4fqPo.createContext(null)) : $4fqPo.createContext(null);
var $a601647747dda3b0$var$IntlConsumer = $a601647747dda3b0$var$IntlContext.Consumer, $a601647747dda3b0$var$IntlProvider = $a601647747dda3b0$var$IntlContext.Provider;
var $a601647747dda3b0$export$2881499e37b75b9a = $a601647747dda3b0$var$IntlProvider;
var $a601647747dda3b0$export$841858b892ce1f4c = $a601647747dda3b0$var$IntlContext;
function $a601647747dda3b0$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $4fqPo.createElement($a601647747dda3b0$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $3QJ2d.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $4fqPo.createElement(WrappedComponent, (0, $d8KcD.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($a601647747dda3b0$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(// @ts-expect-error
    $4fqPo.forwardRef(function(props, ref) {
        return $4fqPo.createElement(WithIntl, (0, $d8KcD.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(WithIntl, WrappedComponent);
}

});
parcelRegister("cpFTT", function(module, exports) {
'use strict';

var $8KJmM = parcelRequire("8KJmM");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $9098526323a502a7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $9098526323a502a7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $9098526323a502a7$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $9098526323a502a7$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $9098526323a502a7$var$TYPE_STATICS = {};
$9098526323a502a7$var$TYPE_STATICS[$8KJmM.ForwardRef] = $9098526323a502a7$var$FORWARD_REF_STATICS;
$9098526323a502a7$var$TYPE_STATICS[$8KJmM.Memo] = $9098526323a502a7$var$MEMO_STATICS;
function $9098526323a502a7$var$getStatics(component) {
    // React v16.11 and below
    if ($8KJmM.isMemo(component)) return $9098526323a502a7$var$MEMO_STATICS;
     // React v16.12 and above
    return $9098526323a502a7$var$TYPE_STATICS[component['$$typeof']] || $9098526323a502a7$var$REACT_STATICS;
}
var $9098526323a502a7$var$defineProperty = Object.defineProperty;
var $9098526323a502a7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $9098526323a502a7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $9098526323a502a7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $9098526323a502a7$var$getPrototypeOf = Object.getPrototypeOf;
var $9098526323a502a7$var$objectPrototype = Object.prototype;
function $9098526323a502a7$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($9098526323a502a7$var$objectPrototype) {
            var inheritedComponent = $9098526323a502a7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $9098526323a502a7$var$objectPrototype) $9098526323a502a7$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $9098526323a502a7$var$getOwnPropertyNames(sourceComponent);
        if ($9098526323a502a7$var$getOwnPropertySymbols) keys = keys.concat($9098526323a502a7$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $9098526323a502a7$var$getStatics(targetComponent);
        var sourceStatics = $9098526323a502a7$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$9098526323a502a7$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $9098526323a502a7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $9098526323a502a7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $9098526323a502a7$var$hoistNonReactStatics;

});
parcelRegister("8KJmM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("nkPgB"));

});
parcelRegister("nkPgB", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $04624daefcd065d5$export$2b8d127b894957b9, (v) => $04624daefcd065d5$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $04624daefcd065d5$export$cea3a54a6425200c, (v) => $04624daefcd065d5$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $04624daefcd065d5$export$a7c73072b1a182ae, (v) => $04624daefcd065d5$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $04624daefcd065d5$export$9f27bc3417b4524d, (v) => $04624daefcd065d5$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $04624daefcd065d5$export$db77ccec0bb4ccac, (v) => $04624daefcd065d5$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $04624daefcd065d5$export$8392c0c9d3dcbd35, (v) => $04624daefcd065d5$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $04624daefcd065d5$export$ffb0004e005737fa, (v) => $04624daefcd065d5$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $04624daefcd065d5$export$b624eff549462981, (v) => $04624daefcd065d5$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $04624daefcd065d5$export$7897aa7841a5380c, (v) => $04624daefcd065d5$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $04624daefcd065d5$export$602eac185826482c, (v) => $04624daefcd065d5$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $04624daefcd065d5$export$e2c29f18771995cb, (v) => $04624daefcd065d5$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $04624daefcd065d5$export$5f8d39834fd61797, (v) => $04624daefcd065d5$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $04624daefcd065d5$export$74bf444e3cd11ea5, (v) => $04624daefcd065d5$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $04624daefcd065d5$export$92387174baf9b227, (v) => $04624daefcd065d5$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $04624daefcd065d5$export$ec112efeb987d9c6, (v) => $04624daefcd065d5$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $04624daefcd065d5$export$b706b080d889d2c9, (v) => $04624daefcd065d5$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $04624daefcd065d5$export$5be5a87408f70ddc, (v) => $04624daefcd065d5$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $04624daefcd065d5$export$45a5e7f76e0caa8d, (v) => $04624daefcd065d5$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $04624daefcd065d5$export$455c2e768291efa6, (v) => $04624daefcd065d5$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $04624daefcd065d5$export$9522e17588c12572, (v) => $04624daefcd065d5$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $04624daefcd065d5$export$2110ac352bb060b9, (v) => $04624daefcd065d5$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $04624daefcd065d5$export$56885ab8b9c456ab, (v) => $04624daefcd065d5$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $04624daefcd065d5$export$d927fcb6adf8f9de, (v) => $04624daefcd065d5$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $04624daefcd065d5$export$b82d16f27459e05a, (v) => $04624daefcd065d5$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $04624daefcd065d5$export$522c17b4f5e123e8, (v) => $04624daefcd065d5$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $04624daefcd065d5$export$1aabd8a0274ecfd6, (v) => $04624daefcd065d5$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $04624daefcd065d5$export$9b621391a187a31a, (v) => $04624daefcd065d5$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $04624daefcd065d5$export$f5bbd400c2f4426f, (v) => $04624daefcd065d5$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04624daefcd065d5$export$2b8d127b894957b9;
var $04624daefcd065d5$export$cea3a54a6425200c;
var $04624daefcd065d5$export$a7c73072b1a182ae;
var $04624daefcd065d5$export$9f27bc3417b4524d;
var $04624daefcd065d5$export$db77ccec0bb4ccac;
var $04624daefcd065d5$export$8392c0c9d3dcbd35;
var $04624daefcd065d5$export$ffb0004e005737fa;
var $04624daefcd065d5$export$b624eff549462981;
var $04624daefcd065d5$export$7897aa7841a5380c;
var $04624daefcd065d5$export$602eac185826482c;
var $04624daefcd065d5$export$e2c29f18771995cb;
var $04624daefcd065d5$export$5f8d39834fd61797;
var $04624daefcd065d5$export$74bf444e3cd11ea5;
var $04624daefcd065d5$export$92387174baf9b227;
var $04624daefcd065d5$export$ec112efeb987d9c6;
var $04624daefcd065d5$export$b706b080d889d2c9;
var $04624daefcd065d5$export$5be5a87408f70ddc;
var $04624daefcd065d5$export$45a5e7f76e0caa8d;
var $04624daefcd065d5$export$455c2e768291efa6;
var $04624daefcd065d5$export$9522e17588c12572;
var $04624daefcd065d5$export$2110ac352bb060b9;
var $04624daefcd065d5$export$56885ab8b9c456ab;
var $04624daefcd065d5$export$d927fcb6adf8f9de;
var $04624daefcd065d5$export$b82d16f27459e05a;
var $04624daefcd065d5$export$522c17b4f5e123e8;
var $04624daefcd065d5$export$1aabd8a0274ecfd6;
var $04624daefcd065d5$export$9b621391a187a31a;
var $04624daefcd065d5$export$f5bbd400c2f4426f;
'use strict';
var $04624daefcd065d5$var$b = "function" === typeof Symbol && Symbol.for, $04624daefcd065d5$var$c = $04624daefcd065d5$var$b ? Symbol.for("react.element") : 60103, $04624daefcd065d5$var$d = $04624daefcd065d5$var$b ? Symbol.for("react.portal") : 60106, $04624daefcd065d5$var$e = $04624daefcd065d5$var$b ? Symbol.for("react.fragment") : 60107, $04624daefcd065d5$var$f = $04624daefcd065d5$var$b ? Symbol.for("react.strict_mode") : 60108, $04624daefcd065d5$var$g = $04624daefcd065d5$var$b ? Symbol.for("react.profiler") : 60114, $04624daefcd065d5$var$h = $04624daefcd065d5$var$b ? Symbol.for("react.provider") : 60109, $04624daefcd065d5$var$k = $04624daefcd065d5$var$b ? Symbol.for("react.context") : 60110, $04624daefcd065d5$var$l = $04624daefcd065d5$var$b ? Symbol.for("react.async_mode") : 60111, $04624daefcd065d5$var$m = $04624daefcd065d5$var$b ? Symbol.for("react.concurrent_mode") : 60111, $04624daefcd065d5$var$n = $04624daefcd065d5$var$b ? Symbol.for("react.forward_ref") : 60112, $04624daefcd065d5$var$p = $04624daefcd065d5$var$b ? Symbol.for("react.suspense") : 60113, $04624daefcd065d5$var$q = $04624daefcd065d5$var$b ? Symbol.for("react.suspense_list") : 60120, $04624daefcd065d5$var$r = $04624daefcd065d5$var$b ? Symbol.for("react.memo") : 60115, $04624daefcd065d5$var$t = $04624daefcd065d5$var$b ? Symbol.for("react.lazy") : 60116, $04624daefcd065d5$var$v = $04624daefcd065d5$var$b ? Symbol.for("react.block") : 60121, $04624daefcd065d5$var$w = $04624daefcd065d5$var$b ? Symbol.for("react.fundamental") : 60117, $04624daefcd065d5$var$x = $04624daefcd065d5$var$b ? Symbol.for("react.responder") : 60118, $04624daefcd065d5$var$y = $04624daefcd065d5$var$b ? Symbol.for("react.scope") : 60119;
function $04624daefcd065d5$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $04624daefcd065d5$var$c:
                switch(a = a.type, a){
                    case $04624daefcd065d5$var$l:
                    case $04624daefcd065d5$var$m:
                    case $04624daefcd065d5$var$e:
                    case $04624daefcd065d5$var$g:
                    case $04624daefcd065d5$var$f:
                    case $04624daefcd065d5$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $04624daefcd065d5$var$k:
                            case $04624daefcd065d5$var$n:
                            case $04624daefcd065d5$var$t:
                            case $04624daefcd065d5$var$r:
                            case $04624daefcd065d5$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $04624daefcd065d5$var$d:
                return u;
        }
    }
}
function $04624daefcd065d5$var$A(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$m;
}
$04624daefcd065d5$export$2b8d127b894957b9 = $04624daefcd065d5$var$l;
$04624daefcd065d5$export$cea3a54a6425200c = $04624daefcd065d5$var$m;
$04624daefcd065d5$export$a7c73072b1a182ae = $04624daefcd065d5$var$k;
$04624daefcd065d5$export$9f27bc3417b4524d = $04624daefcd065d5$var$h;
$04624daefcd065d5$export$db77ccec0bb4ccac = $04624daefcd065d5$var$c;
$04624daefcd065d5$export$8392c0c9d3dcbd35 = $04624daefcd065d5$var$n;
$04624daefcd065d5$export$ffb0004e005737fa = $04624daefcd065d5$var$e;
$04624daefcd065d5$export$b624eff549462981 = $04624daefcd065d5$var$t;
$04624daefcd065d5$export$7897aa7841a5380c = $04624daefcd065d5$var$r;
$04624daefcd065d5$export$602eac185826482c = $04624daefcd065d5$var$d;
$04624daefcd065d5$export$e2c29f18771995cb = $04624daefcd065d5$var$g;
$04624daefcd065d5$export$5f8d39834fd61797 = $04624daefcd065d5$var$f;
$04624daefcd065d5$export$74bf444e3cd11ea5 = $04624daefcd065d5$var$p;
$04624daefcd065d5$export$92387174baf9b227 = function(a) {
    return $04624daefcd065d5$var$A(a) || $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$l;
};
$04624daefcd065d5$export$ec112efeb987d9c6 = $04624daefcd065d5$var$A;
$04624daefcd065d5$export$b706b080d889d2c9 = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$k;
};
$04624daefcd065d5$export$5be5a87408f70ddc = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$h;
};
$04624daefcd065d5$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $04624daefcd065d5$var$c;
};
$04624daefcd065d5$export$455c2e768291efa6 = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$n;
};
$04624daefcd065d5$export$9522e17588c12572 = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$e;
};
$04624daefcd065d5$export$2110ac352bb060b9 = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$t;
};
$04624daefcd065d5$export$56885ab8b9c456ab = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$r;
};
$04624daefcd065d5$export$d927fcb6adf8f9de = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$d;
};
$04624daefcd065d5$export$b82d16f27459e05a = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$g;
};
$04624daefcd065d5$export$522c17b4f5e123e8 = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$f;
};
$04624daefcd065d5$export$1aabd8a0274ecfd6 = function(a) {
    return $04624daefcd065d5$var$z(a) === $04624daefcd065d5$var$p;
};
$04624daefcd065d5$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $04624daefcd065d5$var$e || a === $04624daefcd065d5$var$m || a === $04624daefcd065d5$var$g || a === $04624daefcd065d5$var$f || a === $04624daefcd065d5$var$p || a === $04624daefcd065d5$var$q || "object" === typeof a && null !== a && (a.$$typeof === $04624daefcd065d5$var$t || a.$$typeof === $04624daefcd065d5$var$r || a.$$typeof === $04624daefcd065d5$var$h || a.$$typeof === $04624daefcd065d5$var$k || a.$$typeof === $04624daefcd065d5$var$n || a.$$typeof === $04624daefcd065d5$var$w || a.$$typeof === $04624daefcd065d5$var$x || a.$$typeof === $04624daefcd065d5$var$y || a.$$typeof === $04624daefcd065d5$var$v);
};
$04624daefcd065d5$export$f5bbd400c2f4426f = $04624daefcd065d5$var$z;

});





parcelRegister("lDY9g", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f27319731614a9a$export$2e2bcd8739ae039);
function $5f27319731614a9a$export$2e2bcd8739ae039() {
    window.__JSD_I18N_MESSAGES = window.__JSD_I18N_MESSAGES || {};
    return window.__JSD_I18N_MESSAGES;
}

});

parcelRegister("gcTFJ", function(module, exports) {
$parcel$export(module.exports, "getLanguageFromLocale", () => $73fbe7e74faf6cc8$export$e085862dfb8d71);
// get language from locale for usage with react-intl. For eg: en_US => en
const $73fbe7e74faf6cc8$export$e085862dfb8d71 = (locale)=>{
    if (locale && locale.trim()) {
        if (locale === 'pt_BR' || locale === 'pt-BR') return 'pt-BR';
        return locale.split('_')[0].split('-')[0].trim();
    }
    // default to 'en'
    return 'en';
};

});

parcelRegister("lF29w", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bac92e96253be83$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lVFX8 = parcelRequire("lVFX8");

var $efDRU = parcelRequire("efDRU");

var $3wR8f = parcelRequire("3wR8f");

var $kUs2e = parcelRequire("kUs2e");
class $6bac92e96253be83$export$1e0c5ecf7bd99e3 extends $4fqPo.Component {
    componentDidMount() {
        const { origin: origin } = this.props;
        if (origin === null) return;
        (0, $lVFX8.get)(`${(0, $3wR8f.contextPath)}/rest/assetapi/asset/${origin}`)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response)// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        .map((asset)=>this.setState({
                value: asset.label.value
            })).subscribe({
            error: ()=>this.setState({
                    isErrored: true
                })
        });
    }
    render() {
        const { intl: intl, origin: origin } = this.props;
        const { value: value, isErrored: isErrored } = this.state;
        if (isErrored || origin === null) return intl.formatMessage((0, $kUs2e.default).unknown);
        if (value === undefined) return intl.formatMessage((0, $kUs2e.default).loading);
        return value;
    }
    constructor(...args){
        super(...args), this.state = {};
    }
}
var $6bac92e96253be83$export$2e2bcd8739ae039 = (0, $efDRU.default)($6bac92e96253be83$export$1e0c5ecf7bd99e3);

});
parcelRegister("lVFX8", function(module, exports) {
$parcel$export(module.exports, "get", () => $ca1314f904e12a59$export$3988ae62b71be9a3);
$parcel$export(module.exports, "post", () => $ca1314f904e12a59$export$299ba2dee77727e9);
$parcel$export(module.exports, "put", () => $ca1314f904e12a59$export$327f7b26ebf455db);
$parcel$export(module.exports, "doDelete", () => $ca1314f904e12a59$export$3450a603e4796ceb);

var $b0T1M = parcelRequire("b0T1M");

var $hMoVo = parcelRequire("hMoVo");
const $ca1314f904e12a59$export$e68fce4c5f453854 = (0, $b0T1M.Observable).ajax;
const $ca1314f904e12a59$export$3988ae62b71be9a3 = (0, $hMoVo.traceableAjaxGet);
const $ca1314f904e12a59$export$299ba2dee77727e9 = (0, $hMoVo.traceableAjaxPost);
const $ca1314f904e12a59$export$327f7b26ebf455db = (0, $hMoVo.traceableAjaxPut);
const $ca1314f904e12a59$export$3450a603e4796ceb = (0, $hMoVo.traceableAjaxDelete);

});
parcelRegister("hMoVo", function(module, exports) {
$parcel$export(module.exports, "traceableAjaxGet", () => $9f960a88be6213bf$export$9b2538eb22ed41e3);
$parcel$export(module.exports, "traceableAjaxPost", () => $9f960a88be6213bf$export$9f4e186c104ab31a);
$parcel$export(module.exports, "traceableAjaxPut", () => $9f960a88be6213bf$export$54de09e82d9434c3);
$parcel$export(module.exports, "traceableAjaxDelete", () => $9f960a88be6213bf$export$d507aea434380fd4);

var $b0T1M = parcelRequire("b0T1M");

var $bqHVm = parcelRequire("bqHVm");
const $9f960a88be6213bf$var$extendHeadersWithTracing = (url, originalHeaders = {})=>({
        ...originalHeaders,
        ...(0, $bqHVm.getActiveTraceHttpRequestHeaders)(url)
    });
const $9f960a88be6213bf$export$9b2538eb22ed41e3 = (url, headers)=>{
    return (0, $b0T1M.Observable).ajax.get(url, $9f960a88be6213bf$var$extendHeadersWithTracing(url, headers));
};
const $9f960a88be6213bf$export$9f4e186c104ab31a = (url, body, headers)=>{
    return (0, $b0T1M.Observable).ajax.post(url, body, $9f960a88be6213bf$var$extendHeadersWithTracing(url, headers));
};
const $9f960a88be6213bf$export$54de09e82d9434c3 = (url, body, headers)=>{
    return (0, $b0T1M.Observable).ajax.put(url, body, $9f960a88be6213bf$var$extendHeadersWithTracing(url, headers));
};
const $9f960a88be6213bf$export$d507aea434380fd4 = (url, headers)=>{
    return (0, $b0T1M.Observable).ajax.delete(url, $9f960a88be6213bf$var$extendHeadersWithTracing(url, headers));
};

});


parcelRegister("kUs2e", function(module, exports) {
$parcel$export(module.exports, "default", () => $52ed94f2d6ff46b8$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $52ed94f2d6ff46b8$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    loading: {
        id: 'asset.tracking.field.loading.asset',
        defaultMessage: 'Loading asset...',
        description: 'Displayed when asset label is being loaded from saffron (asset microservice)'
    },
    unknown: {
        id: 'asset.tracking.field.unknown.asset',
        defaultMessage: 'Unknown asset',
        description: 'Displayed when a value for an asset field is not known (eg: it has been deleted)'
    }
});

});
parcelRegister("jalUJ", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $df3ff32825a62fb7$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $df3ff32825a62fb7$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $df3ff32825a62fb7$export$40ae3194919d16b);

var $5OxSI = parcelRequire("5OxSI");

var $bRPIJ = parcelRequire("bRPIJ");

var $6K5p4 = parcelRequire("6K5p4");

var $efDRU = parcelRequire("efDRU");

var $5Uaxl = parcelRequire("5Uaxl");

var $htW2E = parcelRequire("htW2E");

var $3SIyc = parcelRequire("3SIyc");

var $5Xp5q = parcelRequire("5Xp5q");

var $dQegt = parcelRequire("dQegt");

var $cGJIN = parcelRequire("cGJIN");
var $dwV5a = parcelRequire("dwV5a");
function $df3ff32825a62fb7$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $df3ff32825a62fb7$export$747d244ee58120dd(msg) {
    return msg;
}
var $df3ff32825a62fb7$export$40ae3194919d16b = (0, $5OxSI.createFormattedComponent)('formatDate');
var $df3ff32825a62fb7$export$5b390a54f8a846f7 = (0, $5OxSI.createFormattedComponent)('formatTime');
var $df3ff32825a62fb7$export$db80edc1e6b2f63d = (0, $5OxSI.createFormattedComponent)('formatNumber');
var $df3ff32825a62fb7$export$f52b44e459e6e71d = (0, $5OxSI.createFormattedComponent)('formatList');
var $df3ff32825a62fb7$export$c2336ea5aaab92fa = (0, $5OxSI.createFormattedComponent)('formatDisplayName');
var $df3ff32825a62fb7$export$7fdc7d2c91ce149b = (0, $5OxSI.createFormattedDateTimePartsComponent)('formatDate');
var $df3ff32825a62fb7$export$ec35873761676c2a = (0, $5OxSI.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("5OxSI", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $43bbe76651b327a8$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $43bbe76651b327a8$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $43bbe76651b327a8$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $43bbe76651b327a8$export$b37e14176d001dec);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
var $43bbe76651b327a8$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($43bbe76651b327a8$var$DisplayName || ($43bbe76651b327a8$var$DisplayName = {}));
var $43bbe76651b327a8$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($43bbe76651b327a8$var$DisplayNameParts || ($43bbe76651b327a8$var$DisplayNameParts = {}));
var $43bbe76651b327a8$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $dQegt.default)();
    var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$43bbe76651b327a8$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $43bbe76651b327a8$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $dQegt.default)();
    var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$43bbe76651b327a8$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $43bbe76651b327a8$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $dQegt.default)();
        var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $43bbe76651b327a8$var$DisplayNameParts[name];
    return ComponentParts;
}
function $43bbe76651b327a8$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $dQegt.default)();
        var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $4fqPo.Fragment;
        return $4fqPo.createElement(Text, null, formattedValue);
    };
    Component.displayName = $43bbe76651b327a8$var$DisplayName[name];
    return Component;
}

});
parcelRegister("dQegt", function(module, exports) {
$parcel$export(module.exports, "default", () => $a13b325c1513903b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3QJ2d = parcelRequire("3QJ2d");

var $efDRU = parcelRequire("efDRU");
function $a13b325c1513903b$export$2e2bcd8739ae039() {
    var intl = $4fqPo.useContext((0, $efDRU.Context));
    (0, $3QJ2d.invariantIntlContext)(intl);
    return intl;
}

});


parcelRegister("6K5p4", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e8b3aeddb03e52f$export$2e2bcd8739ae039);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
var $4e8b3aeddb03e52f$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $dQegt.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $4fqPo.Fragment;
    return $4fqPo.createElement(Text, null, formattedValue);
};
$4e8b3aeddb03e52f$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $4e8b3aeddb03e52f$export$2e2bcd8739ae039 = $4e8b3aeddb03e52f$var$FormattedDateTimeRange;

});

parcelRegister("5Uaxl", function(module, exports) {
$parcel$export(module.exports, "default", () => $44ca5b15aa3fb8c5$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $3QJ2d = parcelRequire("3QJ2d");

var $dQegt = parcelRequire("dQegt");
function $44ca5b15aa3fb8c5$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $d8KcD.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $d8KcD.__rest)(nextProps, [
        "values"
    ]);
    return (0, $3QJ2d.shallowEqual)(nextValues, values) && (0, $3QJ2d.shallowEqual)(otherProps, nextOtherProps);
}
function $44ca5b15aa3fb8c5$var$FormattedMessage(props) {
    var intl = (0, $dQegt.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $4fqPo.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $4fqPo.createElement(Component, null, nodes);
    return $4fqPo.createElement($4fqPo.Fragment, null, nodes);
}
$44ca5b15aa3fb8c5$var$FormattedMessage.displayName = 'FormattedMessage';
var $44ca5b15aa3fb8c5$var$MemoizedFormattedMessage = $4fqPo.memo($44ca5b15aa3fb8c5$var$FormattedMessage, $44ca5b15aa3fb8c5$var$areEqual);
$44ca5b15aa3fb8c5$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $44ca5b15aa3fb8c5$export$2e2bcd8739ae039 = $44ca5b15aa3fb8c5$var$MemoizedFormattedMessage;

});

parcelRegister("htW2E", function(module, exports) {
$parcel$export(module.exports, "default", () => $cba22afd2ea340a7$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
var $cba22afd2ea340a7$var$FormattedPlural = function(props) {
    var _a = (0, $dQegt.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $4fqPo.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$cba22afd2ea340a7$var$FormattedPlural.displayName = 'FormattedPlural';
var $cba22afd2ea340a7$export$2e2bcd8739ae039 = $cba22afd2ea340a7$var$FormattedPlural;

});

parcelRegister("5Xp5q", function(module, exports) {
$parcel$export(module.exports, "default", () => $4565ec1341779ae2$export$2e2bcd8739ae039);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $3QJ2d = parcelRequire("3QJ2d");

var $dQegt = parcelRequire("dQegt");
var $4565ec1341779ae2$var$MINUTE = 60;
var $4565ec1341779ae2$var$HOUR = 3600;
var $4565ec1341779ae2$var$DAY = 86400;
function $4565ec1341779ae2$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $4565ec1341779ae2$var$MINUTE) return 'second';
    if (absValue < $4565ec1341779ae2$var$HOUR) return 'minute';
    if (absValue < $4565ec1341779ae2$var$DAY) return 'hour';
    return 'day';
}
function $4565ec1341779ae2$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $4565ec1341779ae2$var$MINUTE;
        case 'hour':
            return $4565ec1341779ae2$var$HOUR;
        default:
            return $4565ec1341779ae2$var$DAY;
    }
}
function $4565ec1341779ae2$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $4565ec1341779ae2$var$MINUTE;
        default:
            return value * $4565ec1341779ae2$var$HOUR;
    }
}
var $4565ec1341779ae2$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $4565ec1341779ae2$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $4565ec1341779ae2$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $4565ec1341779ae2$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $dQegt.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $d8KcD.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $4fqPo.createElement(Text, null, formattedRelativeTime);
    return $4fqPo.createElement($4fqPo.Fragment, null, formattedRelativeTime);
};
var $4565ec1341779ae2$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $d8KcD.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $3QJ2d.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $4565ec1341779ae2$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $4fqPo.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $4fqPo.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $4fqPo.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($4565ec1341779ae2$var$canIncrement(unit) ? $4565ec1341779ae2$var$valueToSeconds(value, unit) : 0);
    }
    $4fqPo.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$4565ec1341779ae2$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $4565ec1341779ae2$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $4565ec1341779ae2$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($4565ec1341779ae2$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $4565ec1341779ae2$var$selectUnit(currentValueInSeconds);
        var unitDuration = $4565ec1341779ae2$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $4fqPo.createElement($4565ec1341779ae2$var$SimpleFormattedRelativeTime, (0, $d8KcD.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$4565ec1341779ae2$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $4565ec1341779ae2$export$2e2bcd8739ae039 = $4565ec1341779ae2$var$FormattedRelativeTime;

});






parcelRegister("7kcrn", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => (parcelRequire("g8oau")).getCmdbFieldValueElement);

var $g8oau = parcelRequire("g8oau");

});
parcelRegister("g8oau", function(module, exports) {
$parcel$export(module.exports, "getCmdbFieldValueElement", () => $159585686c52045c$export$ce19e854d193d5b3);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $5F0K9 = parcelRequire("5F0K9");

var $3SIyc = parcelRequire("3SIyc");

var $73FZL = parcelRequire("73FZL");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");

var $lDY9g = parcelRequire("lDY9g");

var $gcTFJ = parcelRequire("gcTFJ");

var $fVwZr = parcelRequire("fVwZr");
parcelRequire("5zxTk");
var $dGaXc = parcelRequire("dGaXc");
const $159585686c52045c$var$onIntlError = (intlError)=>{
    try {
        $fVwZr.reportError(intlError);
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $159585686c52045c$export$3bcefabe8b04378c = (intlError)=>{
    $159585686c52045c$var$onIntlError(intlError.message);
};
const $159585686c52045c$export$3c09dff16567da2f = (base64String)=>{
    try {
        // Decode base64 string while preserving Unicode characters
        const binaryString = atob(base64String || '');
        const bytes = new Uint8Array(binaryString.length);
        for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
        const decoder = new TextDecoder('utf-8');
        const decodedString = decoder.decode(bytes);
        return JSON.parse(decodedString);
    } catch (e) {
        return null;
    }
};
const $159585686c52045c$export$ce19e854d193d5b3 = ()=>{
    class CmdbFieldValueElement extends HTMLElement {
        connectedCallback() {
            // Jira passes the cmdb object data as a data-object-details-base64 attribute
            const objectDetailsBase64 = this.getAttribute('data-object-details-base64');
            const parsedObjectDetails = $159585686c52045c$export$3c09dff16567da2f(objectDetailsBase64);
            if (!parsedObjectDetails) return;
            if ((0, $bG6ob.isUseReact18CreateRootEnabled)()) {
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const container = document.createElement('span');
                const root = (0, $5F0K9.createRoot)(container);
                root.render(/*#__PURE__*/ $4fqPo.createElement((0, $3SIyc.default), {
                    messages: (0, $lDY9g.default)(),
                    locale: (0, $gcTFJ.getLanguageFromLocale)((0, $6mmHn.getMetaData)().userLocale),
                    onError: $159585686c52045c$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $4fqPo.createElement((0, $73FZL.default), {
                    onEvent: (0, $keOG0.legacySendEvent)
                }, /*#__PURE__*/ $4fqPo.createElement((0, $54jwS.AnalyticsContext), {
                    sourceName: "portalUnknown",
                    sourceType: (0, $54jwS.ScreenTypes).SCREEN,
                    attributes: {
                        context: 'Portal'
                    }
                }, /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
                    packageName: "cmdbFieldValueWebComponent",
                    id: "cmdb-object-card",
                    renderError: ()=>null
                }, /*#__PURE__*/ $4fqPo.createElement((0, $dGaXc.default), {
                    cmdbObject: parsedObjectDetails
                }))))));
                this.appendChild(container);
            } else {
                // render the component with its props, and add to the Shadow DOM
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                const root = document.createElement('span');
                // eslint-disable-next-line react/no-deprecated
                $b2Ka1.render(/*#__PURE__*/ $4fqPo.createElement((0, $3SIyc.default), {
                    messages: (0, $lDY9g.default)(),
                    locale: (0, $gcTFJ.getLanguageFromLocale)((0, $6mmHn.getMetaData)().userLocale),
                    onError: $159585686c52045c$export$3bcefabe8b04378c
                }, /*#__PURE__*/ $4fqPo.createElement((0, $73FZL.default), {
                    onEvent: (0, $keOG0.legacySendEvent)
                }, /*#__PURE__*/ $4fqPo.createElement((0, $54jwS.AnalyticsContext), {
                    sourceName: "portalUnknown",
                    sourceType: (0, $54jwS.ScreenTypes).SCREEN,
                    attributes: {
                        context: 'Portal'
                    }
                }, /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
                    packageName: "cmdbFieldValueWebComponent",
                    id: "cmdb-object-card",
                    renderError: ()=>null
                }, /*#__PURE__*/ $4fqPo.createElement((0, $dGaXc.default), {
                    cmdbObject: parsedObjectDetails
                }))))), root);
                this.appendChild(root);
            }
        }
    }
    return CmdbFieldValueElement;
};

});
parcelRegister("gMSZD", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b41a978505a2f51$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");

var $keOG0 = parcelRequire("keOG0");
const $3b41a978505a2f51$var$SENTRY_EXCLUDED_STATUS_CODES = [
    429
];
class $3b41a978505a2f51$export$e926676385687eaf extends $4fqPo.Component {
    componentDidCatch(error) {
        const { id: id, createAnalyticsEvent: createAnalyticsEvent, analyticsAttributes: analyticsAttributes, packageName: packageName, onError: onError } = this.props;
        this.setState({
            error: error
        });
        const data = {};
        if (id) data.errorBoundaryId = id;
        if (packageName) data.errorBoundaryPackageName = packageName;
        const shouldExclude = error && error.hasOwnProperty('status') && $3b41a978505a2f51$var$SENTRY_EXCLUDED_STATUS_CODES.includes(error.status);
        if (!shouldExclude) (0, $keOG0.trackError)('app.boundary.uncaught.error', data, error);
        if (createAnalyticsEvent !== undefined) {
            const analyticsEvent = createAnalyticsEvent({
                ...analyticsAttributes,
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                errorMessage: (0, $keOG0.getErrorData)(error)
            });
            // TODO: FSD-4121 switch to using '@atlassian/error-handling'
            // Note that `componentName` is used as `actionSubject` in gasV3 operational events, and takes this form as described at
            // https://hello.atlassian.net/wiki/spaces/ALBS/pages/589347147/Jira+monitoring+frontend+errors#Step-2%3A-register-events
            const finalId = id || 'unknownErrorBoundary';
            const finalPackage = packageName || 'unknownPackage';
            const actionSubject = `${finalPackage}.${finalId}`;
            analyticsEvent.context.push({
                componentName: actionSubject
            });
            analyticsEvent.fire();
        }
        if (onError) onError(error);
    }
    render() {
        const { children: children, renderError: renderError } = this.props;
        const { error: error } = this.state;
        if (error) return renderError ? renderError(error) : null;
        return children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
var $3b41a978505a2f51$export$2e2bcd8739ae039 = (0, $apbG6.default)()((0, $as4kh.default)()($3b41a978505a2f51$export$e926676385687eaf));

});
parcelRegister("apbG6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e14d5371e470e194$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");
const $e14d5371e470e194$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $4fqPo.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $e14d5371e470e194$export$2e2bcd8739ae039 = $e14d5371e470e194$var$withAnalyticsContext;

});

parcelRegister("keOG0", function(module, exports) {
$parcel$export(module.exports, "legacySendEvent", () => $acdd44bb7b5f6718$export$31613c62bfdc6a53);
$parcel$export(module.exports, "sendEventFromAnalyticsBridge", () => $acdd44bb7b5f6718$export$80c476f25a50624a);
$parcel$export(module.exports, "sendAtlaskitUIEvent", () => $acdd44bb7b5f6718$export$8c604b65319094be);
$parcel$export(module.exports, "legacyTrackEvent", () => $acdd44bb7b5f6718$export$d34aefccac2c4e2b);
$parcel$export(module.exports, "getErrorData", () => $acdd44bb7b5f6718$export$6fd42d413c537998);
$parcel$export(module.exports, "trackError", () => $acdd44bb7b5f6718$export$5a6ec5e5079bbe35);

var $bG6ob = parcelRequire("bG6ob");

var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");

var $kXlzl = parcelRequire("kXlzl");

var $c5t3p = parcelRequire("c5t3p");

var $fVwZr = parcelRequire("fVwZr");

var $9Cn4J = parcelRequire("9Cn4J");

var $fJQMR = parcelRequire("fJQMR");

var $2w7fz = parcelRequire("2w7fz");
const $acdd44bb7b5f6718$var$getMeta = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,  @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    const buildVersion = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION;
    return {
        sessionId: $2w7fz.sessionId,
        context: window.location.pathname,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        version: buildVersion ? buildVersion.buildKey : 'JPF-STORYBOOK-000'
    };
};
function $acdd44bb7b5f6718$export$31613c62bfdc6a53(event) {
    $acdd44bb7b5f6718$var$sendEvent(event);
}
function $acdd44bb7b5f6718$export$80c476f25a50624a(event) {
    $acdd44bb7b5f6718$var$sendEvent(event, (0, $gHT3x.ANALYTICS_BRIDGE_CHANNEL));
}
function $acdd44bb7b5f6718$var$sendEvent(event, channel) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) analyticsWebClient.sendEvent(event, channel);
    (0, $9Cn4J.reportAnalyticsEvent)(event);
}
const $acdd44bb7b5f6718$var$extractFromEventContext = (propertyNames, event)=>// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    event.context// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    .reduceRight((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
function $acdd44bb7b5f6718$export$8c604b65319094be(event) {
    const analyticsWebClient = (0, $fJQMR.getAnalyticsWebClient)();
    if (analyticsWebClient) {
        event.update({
            // Don't override analyticsType if it already exists.
            // Else set it to UI_EVENT_TYPE.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            analyticsType: event.payload.analyticsType || (0, $54jwS.UI_EVENT_TYPE),
            // Extract actionSubjectId from context.
            // Analytics web react enforces it must be defined here - else it won't pick it up.
            // See: https://bitbucket.org/atlassian/analytics-web-react/src/master/src/utils/extract-data-from-event.js?at=master#lines-89
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            actionSubjectId: $acdd44bb7b5f6718$var$extractFromEventContext([
                'actionSubjectId'
            ], event)[0]
        });
        analyticsWebClient.sendEvent(event);
    }
}
function $acdd44bb7b5f6718$export$d34aefccac2c4e2b(eventName, data) {
    const mergedData = {
        ...data,
        ...$acdd44bb7b5f6718$var$getMeta()
    };
    (0, $c5t3p.trackLegacyEvent)(eventName, mergedData);
}
function $acdd44bb7b5f6718$var$truncateMessage(message, length = 25) {
    if (message === null || message === undefined) return 'null';
    return message.slice(0, length);
}
function $acdd44bb7b5f6718$var$sendErrorToSentry(error, additionalErrorData) {
    try {
        // log to sentry
        (0, $fVwZr.reportError)(error, additionalErrorData);
    } catch (ex) {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access ,@typescript-eslint/no-unsafe-assignment
        const errorMessage = JSON.stringify({
            name: ex.name,
            msg: ex.message
        });
        $acdd44bb7b5f6718$export$d34aefccac2c4e2b('sentry.error.tracking.failed', {
            error: errorMessage
        });
        (0, $kXlzl.operationalEvent)({
            action: 'failed',
            actionSubjectId: 'SentryErrorTracking',
            attributes: {
                error: errorMessage,
                ...additionalErrorData
            },
            source: 'unknownSource'
        });
    }
}
/**
 * this error tracking event is to send the caught sentry error to the newer GASv3 analytics as an
 * operational event
 */ function $acdd44bb7b5f6718$var$sendOperationalErrorEvent(eventName, error, additionalAttribute) {
    (0, $kXlzl.operationalEvent)({
        action: 'failed',
        actionSubjectId: 'SentryErrorTracking',
        actionSubject: 'sentryError',
        source: 'unknownSource',
        attributes: {
            ...additionalAttribute,
            error: error,
            eventName: eventName
        }
    });
}
function $acdd44bb7b5f6718$export$6fd42d413c537998(error) {
    let errorData = '';
    if (!error) // undefined error
    errorData = JSON.stringify({
        msg: 'null'
    });
    else if (!!error.xhr) {
        // ajax error
        const ajaxError = error;
        const xhr = ajaxError.xhr;
        errorData = JSON.stringify({
            name: 'AjaxError',
            // we can hard code this here because we know it's an ajax error
            stat: xhr.status,
            msg: $acdd44bb7b5f6718$var$truncateMessage(ajaxError.message)
        });
    } else if (typeof error === 'string') // error as string
    errorData = JSON.stringify({
        msg: error
    });
    else {
        // generic js error
        const jsError = error;
        errorData = JSON.stringify({
            name: $acdd44bb7b5f6718$var$truncateMessage(jsError.name),
            msg: $acdd44bb7b5f6718$var$truncateMessage(jsError.message, 100)
        });
    }
    return errorData;
}
function $acdd44bb7b5f6718$export$5a6ec5e5079bbe35(eventName, data, error) {
    const errorData = $acdd44bb7b5f6718$export$6fd42d413c537998(error);
    // Skip sending to Sentry if it's an AjaxError or if filterFromSentry is true
    if (error && !error.xhr && !error.filterFromSentry) {
        if (typeof error === 'string') $acdd44bb7b5f6718$var$sendErrorToSentry(new Error(error), data);
        else {
            // generic js error
            const jsError = error;
            $acdd44bb7b5f6718$var$sendErrorToSentry(jsError, data);
        }
    }
    /**  behind the WRM optimisation feature flag and do not fire
   *  operational event for errors caught by error boundary
   */ if ((0, $bG6ob.isWrmOptimizationsEnabled)() && !(data && data.errorBoundaryId)) $acdd44bb7b5f6718$var$sendOperationalErrorEvent(eventName, errorData, data);
    const eventData = {
        ...data,
        error: errorData
    };
    return $acdd44bb7b5f6718$export$d34aefccac2c4e2b(eventName, eventData);
}

});
parcelRegister("c5t3p", function(module, exports) {
$parcel$export(module.exports, "trackLegacyEvent", () => $f57885ab8ce72a08$export$655ee831d8b45890);

var $bG6ob = parcelRequire("bG6ob");

var $bRLBS = parcelRequire("bRLBS");

var $2w7fz = parcelRequire("2w7fz");

var $gouHa = parcelRequire("gouHa");

var $hDDhv = parcelRequire("hDDhv");

var $7WCq4 = parcelRequire("7WCq4");
const $f57885ab8ce72a08$var$sanitizeAnalyticEvent = (eventName, eventProperties)=>{
    // for any new events which have been added to portal frontend whitelist
    // we will add a prefix to the eventname and sanitize its properties
    if ((0, $gouHa.isWhiteListEvent)(eventName)) return {
        name: `jsd.portal.frontend.${eventName}`,
        properties: (0, $gouHa.sanitizeEventProperties)(eventName, eventProperties)
    };
    // if events not in whitelist, we will let cloud analytic plugin handle it instead
    return {
        name: eventName,
        properties: eventProperties
    };
};
const $f57885ab8ce72a08$export$655ee831d8b45890 = (name, data)=>{
    const props = {
        ...data,
        sessionId: $2w7fz.sessionId
    };
    props.sdVersion = (0, $hDDhv.getPluginVersion)() || props.sdVersion || 'unknown';
    props.portalFrontendBuildKey = (0, $hDDhv.getCustomerPortalFrontendBuildKey)() || props.portalFrontendBuildKey || 'unknown';
    const safeEventObject = $f57885ab8ce72a08$var$sanitizeAnalyticEvent(name, props);
    // TODO: replace with fireLegacyEvent(safeEventObject) from src/rest/legacy-event
    // the reason now here is to cater for the https://jdog.jira-dev.com/browse/JSDKB-1468 task which
    // still consumes the GASv2 events, this following code should be removed once the above task is fixed
    if ((0, $bG6ob.isWrmOptimizationsEnabled)()) {
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $7WCq4.fireLegacyEvent)(safeEventObject);
        return;
    }
    const eventQueue = (0, $bRLBS.getEventQueue)();
    eventQueue && eventQueue.push(safeEventObject);
};

});
parcelRegister("2w7fz", function(module, exports) {
$parcel$export(module.exports, "sessionId", () => $accb43a7ded668a4$export$f1faf18bafef2950);

var $ih6F6 = parcelRequire("ih6F6");
const $accb43a7ded668a4$export$f1faf18bafef2950 = (0, $ih6F6.default)();

});
parcelRegister("ih6F6", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bdcfb2d75fff090$export$2e2bcd8739ae039);

var $7Kbae = parcelRequire("7Kbae");
const $9bdcfb2d75fff090$var$s4 = ()=>(0, $7Kbae.default).floor((1 + (0, $7Kbae.default).random()) * 0x10000).toString(16).substring(1);
function $9bdcfb2d75fff090$export$2e2bcd8739ae039() {
    return `${$9bdcfb2d75fff090$var$s4()}${$9bdcfb2d75fff090$var$s4()}-${$9bdcfb2d75fff090$var$s4()}-${$9bdcfb2d75fff090$var$s4()}-${$9bdcfb2d75fff090$var$s4()}-${$9bdcfb2d75fff090$var$s4()}${$9bdcfb2d75fff090$var$s4()}${$9bdcfb2d75fff090$var$s4()}`;
}

});
parcelRegister("7Kbae", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d129a124dd50f36$export$2e2bcd8739ae039);
// This exists so we can have an easier time stubbing it out in tests.
var $2d129a124dd50f36$export$2e2bcd8739ae039 = Math;

});



parcelRegister("gouHa", function(module, exports) {
$parcel$export(module.exports, "isWhiteListEvent", () => $7d512b800d15b625$export$364166d55b6d152b);
$parcel$export(module.exports, "sanitizeEventProperties", () => $7d512b800d15b625$export$fc45a7cd0562e9ff);

var $63sfu = parcelRequire("63sfu");

var $6vu12 = parcelRequire("6vu12");
const $7d512b800d15b625$var$WHITELIST_KEYS = Object.keys($6vu12);
const $7d512b800d15b625$export$364166d55b6d152b = (eventName)=>(0, $63sfu.includes)($7d512b800d15b625$var$WHITELIST_KEYS, eventName);
const $7d512b800d15b625$export$fc45a7cd0562e9ff = (eventName, eventProperties)=>{
    return (0, $63sfu.pick)(eventProperties, $6vu12[eventName]);
};

});
parcelRegister("6vu12", function(module, exports) {
module.exports = JSON.parse("{\"footer.waclink.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"search.overlay.button.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"session.logout.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"header.avatar.menu.opened\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.profile.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.logout.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.all.requests.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.pending.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.my.approval.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.organisation.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"header.avatar.menu.spotlight.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"kbPortalView.not.helpful.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"request.change.spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"search.result.kb.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.portal.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"search.result.request.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"hash\",\"q_len\",\"total_idx\",\"total_count\",\"category_idx\",\"category_count\"],\"sentry.error.tracking.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"helpcenter.search.textbox.focused\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"helpcenter.search.textbox.submit\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.dismiss.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"portal.search.onboarding.target.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"spotlight.dismiss.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"spotlightKey\",\"error\"],\"servicedesk.customerview.smartportal.browse.popular.portals.portal.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"portalFrontendBuildKey\"],\"servicedesk.customerview.smartportal.browse.popular.portals.browse.all.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\"],\"organisation.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"kbsuggestions.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"findlabel.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"finduser.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"servicedesk.customerview.smartportal.browse.recent.requesttypes.requesttype.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.save.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"add.announcement.sidebar.content.cancel.clicked\":[\"index\",\"sdVersion\",\"sessionId\",\"version\"],\"async.loader.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"error\"],\"portal.home.announcement.banner.collapse.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"portal.home.announcement.banner.expand.clicked\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"categories.fetch.all.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"category.articles.fetch.failed\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"],\"raise.request.cta.button\":[\"sdVersion\",\"sessionId\",\"version\",\"context\",\"portalFrontendBuildKey\"]}");

});


parcelRegister("hDDhv", function(module, exports) {
$parcel$export(module.exports, "getPluginVersion", () => $c35e058ad7c72b72$export$face9f52d66c8c0f);
$parcel$export(module.exports, "getCustomerPortalFrontendBuildKey", () => $c35e058ad7c72b72$export$d9a9dd9e37b497b6);

var $bRLBS = parcelRequire("bRLBS");
const $c35e058ad7c72b72$export$face9f52d66c8c0f = ()=>{
    return (0, $bRLBS.getMeta) && (0, $bRLBS.getMeta)('sdPluginVersion');
};
const $c35e058ad7c72b72$export$d9a9dd9e37b497b6 = ()=>{
    if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    return undefined;
};

});

parcelRegister("7WCq4", function(module, exports) {
$parcel$export(module.exports, "fireLegacyEvent", () => $2ffbcfffd9ff9850$export$88121588a617f5f9);

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $2ffbcfffd9ff9850$export$88121588a617f5f9 = (event, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/analytics/1.0/publish/bulk`;
    const body = [
        event
    ];
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise();
};

});


parcelRegister("9Cn4J", function(module, exports) {
$parcel$export(module.exports, "reportAnalyticsEvent", () => $b066b92f892b2c23$export$4d9f272573494add);

var $ePuex = parcelRequire("ePuex");
var $ahlU2 = parcelRequire("ahlU2");

var $54jwS = parcelRequire("54jwS");

var $29xKq = parcelRequire("29xKq");
const $b066b92f892b2c23$export$4d9f272573494add = (event)=>{
    try {
        const { analyticsType: analyticsType, action: action, componentName: componentName, actionSubjectId: actionSubjectId, source: source } = [
            ...event.context || [],
            event.payload
        ].reduce((acc, curr)=>({
                ...acc,
                ...curr
            }), {
            eventType: undefined,
            action: undefined,
            componentName: undefined,
            actionSubjectId: undefined,
            source: undefined
        });
        // for screen events, source has the name of the screen
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/restrict-template-expressions
        const actionSubject = analyticsType === (0, $54jwS.SCREEN_EVENT_TYPE) ? `screen<${source}>` : componentName;
        if (analyticsType && action && actionSubject) {
            if (analyticsType !== (0, $54jwS.UI_EVENT_TYPE) && analyticsType !== (0, $54jwS.TRACK_EVENT_TYPE) && analyticsType !== (0, $54jwS.OPERATIONAL_EVENT_TYPE) && analyticsType !== (0, $54jwS.SCREEN_EVENT_TYPE)) {
                (0, $29xKq.devLog)(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                `An event was left out of Sentry breadcrumbs because it had an invalid analyticsType: ${analyticsType}.\nAllowed types: ${[
                    (0, $54jwS.UI_EVENT_TYPE),
                    (0, $54jwS.TRACK_EVENT_TYPE),
                    (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                    (0, $54jwS.SCREEN_EVENT_TYPE)
                ].join(', ')}`);
                return;
            }
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            const eventDescription = `${analyticsType} ${action} ${actionSubject}`;
            const eventDescriptionWithId = actionSubjectId ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescription}<${actionSubjectId}>` : eventDescription;
            // omit source for screen events because it's already about them!
            const eventMessage = source && analyticsType !== (0, $54jwS.SCREEN_EVENT_TYPE) ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `${eventDescriptionWithId} from source<${source}>` : eventDescriptionWithId;
            // Scenario: a user clicks on a button with ID myButton on a screen with ID myScreen
            // Here's what's sent as a breadcrumb: ui clicked button<myButton> from source<myScreen>
            // When some data is missing, it's omitted, so we still get a good idea of what was going on.
            $ePuex.addBreadcrumb({
                category: 'analytics',
                message: eventMessage,
                level: $ahlU2.Severity.Info
            });
        }
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.error('Error capturing analytics event as Sentry breadcrumb', exception);
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        $ePuex.captureEvent({
            exception: exception,
            message: 'Error capturing analytics event as Sentry breadcrumb'
        });
    }
};

});



parcelRegister("73FZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f119bfee6247e9df$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $3OcdS = parcelRequire("3OcdS");

var $jEnNQ = parcelRequire("jEnNQ");

var $2y5tr = parcelRequire("2y5tr");
const $f119bfee6247e9df$var$AnalyticsListener = (props)=>{
    const isModernContext = (0, $3OcdS.default) || (0, $3H4LK.fg)('analytics-next-use-legacy-context') === false;
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2y5tr.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEnNQ.default), props);
};
var $f119bfee6247e9df$export$2e2bcd8739ae039 = $f119bfee6247e9df$var$AnalyticsListener;

});
parcelRegister("jEnNQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b720843c2dd91943$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $PqAiz = parcelRequire("PqAiz");
const $b720843c2dd91943$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
};
const $b720843c2dd91943$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b720843c2dd91943$var$AnalyticsListener extends (0, $4fqPo.Component) {
    static #_ = this.contextTypes = $b720843c2dd91943$var$ContextTypes;
    static #_2 = this.childContextTypes = $b720843c2dd91943$var$ContextTypes;
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $b720843c2dd91943$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $b720843c2dd91943$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $PqAiz.default).Provider, {
            value: this.contextValue
        }, children);
    }
}
var $b720843c2dd91943$export$2e2bcd8739ae039 = $b720843c2dd91943$var$AnalyticsListener;

});

parcelRegister("2y5tr", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a02ef48d907f4fe$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $PqAiz = parcelRequire("PqAiz");

var $kXYs1 = parcelRequire("kXYs1");

var $kjnaA = parcelRequire("kjnaA");
const $6a02ef48d907f4fe$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $kXYs1.useAnalyticsContext)();
    const onEventRef = (0, $kjnaA.useTrackedRef)(onEvent);
    const channelRef = (0, $kjnaA.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $4fqPo.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $4fqPo.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $PqAiz.default).Provider, {
        value: value
    }, children);
};
var $6a02ef48d907f4fe$export$2e2bcd8739ae039 = $6a02ef48d907f4fe$var$AnalyticsListener;

});


parcelRegister("5zxTk", function(module, exports) {
$parcel$export(module.exports, "CmdbObjectCard", () => (parcelRequire("dGaXc")).default);

var $dGaXc = parcelRequire("dGaXc");

});
parcelRegister("dGaXc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2938fbd32414f5b4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1CB66 = parcelRequire("1CB66");

var $efDRU = parcelRequire("efDRU");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");

var $kXlzl = parcelRequire("kXlzl");
parcelRequire("jSEtp");
var $pNj51 = parcelRequire("pNj51");
parcelRequire("8bB6H");
var $eeLh2 = parcelRequire("eeLh2");
parcelRequire("h36Wp");
var $FS1jX = parcelRequire("FS1jX");

var $YfxLb = parcelRequire("YfxLb");
const $2938fbd32414f5b4$var$CmdbObjectCard = ({ intl: intl, cmdbObject: cmdbObject })=>{
    var _clientServerBridge$q;
    const [expanded, setExpanded] = (0, $4fqPo.useState)(false);
    const timezoneId = // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    typeof document !== 'undefined' ? (_clientServerBridge$q = (0, $1CB66.default).querySelector('meta[name="user-timezone"]')) === null || _clientServerBridge$q === void 0 ? void 0 : _clientServerBridge$q.getAttribute('content') : undefined;
    (0, $4fqPo.useEffect)(()=>{
        // Fire an event when the component is rendered, to measure successful renders
        if (cmdbObject !== null) (0, $kXlzl.operationalEvent)({
            action: 'rendered',
            actionSubject: 'cmdbObjectCard',
            source: 'cmdbObjectCard'
        });
    }, [
        cmdbObject
    ]);
    if (cmdbObject === null) return intl.formatMessage((0, $YfxLb.default).error);
    const renderChevronButton = ()=>{
        if (cmdbObject.attributes.length === 0) return null;
        const buttonLabel = intl.formatMessage(expanded ? (0, $YfxLb.default).collapseLabel : (0, $YfxLb.default).expandLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $FS1jX.ExpandCollapseToggle), {
            isExpanded: expanded,
            label: buttonLabel,
            onClick: ()=>setExpanded(!expanded),
            testId: "cmdb-object-card-expand-collapse-toggle"
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $2938fbd32414f5b4$var$containerStyles,
        testId: "cmdb-object-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $pNj51.MemoizedInsightIcon), cmdbObject.avatar.mediaClientConfig), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $2938fbd32414f5b4$var$labelStyles
    }, cmdbObject.label), renderChevronButton()), expanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $2938fbd32414f5b4$var$attributesListContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eeLh2.AttributeList), {
        attributes: cmdbObject.attributes,
        timezoneId: timezoneId
    })));
};
var $2938fbd32414f5b4$export$2e2bcd8739ae039 = (0, $efDRU.default)($2938fbd32414f5b4$var$CmdbObjectCard);
const $2938fbd32414f5b4$var$containerStyles = (0, $2m8U6.xcss)({
    position: 'relative',
    width: '100%',
    maxWidth: '600px',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    marginBottom: 'space.100',
    padding: 'space.100',
    boxSizing: 'border-box'
});
const $2938fbd32414f5b4$var$labelStyles = (0, $2m8U6.xcss)({
    font: 'font.heading.xsmall',
    color: 'color.text.subtle',
    margin: 'space.0',
    paddingLeft: 'space.100',
    flexGrow: 1,
    minWidth: 'space.0',
    overflowWrap: 'break-word'
});
const $2938fbd32414f5b4$var$attributesListContainerStyles = (0, $2m8U6.xcss)({
    marginTop: 'space.200'
});

});
parcelRegister("7TPEx", function(module, exports) {
$parcel$export(module.exports, "Box", () => $9c1e4e58b61c1cf6$export$e71c4d32a2263218);
$parcel$export(module.exports, "default", () => $9c1e4e58b61c1cf6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $28VoU = parcelRequire("28VoU");

var $fJeCl = parcelRequire("fJeCl");

var $2m8U6 = parcelRequire("2m8U6");
function $9c1e4e58b61c1cf6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9c1e4e58b61c1cf6$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2m8U6.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $lqVX7.jsx)(Component, {
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $9c1e4e58b61c1cf6$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fJeCl.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $fJeCl.isSurfaceColorToken)(backgroundColor) && (0, $fJeCl.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fJeCl.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fJeCl.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fJeCl.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fJeCl.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fJeCl.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fJeCl.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fJeCl.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $lqVX7.jsx)((0, $28VoU.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9c1e4e58b61c1cf6$export$2e2bcd8739ae039 = $9c1e4e58b61c1cf6$export$e71c4d32a2263218;
const $9c1e4e58b61c1cf6$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};

});
parcelRegister("lqVX7", function(module, exports) {
$parcel$export(module.exports, "Global", () => $f9a8fad9894c88cc$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $f9a8fad9894c88cc$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $f9a8fad9894c88cc$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $f9a8fad9894c88cc$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $f9a8fad9894c88cc$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("gOfqU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("gOfqU")).w);

var $gOfqU = parcelRequire("gOfqU");

var $4fqPo = parcelRequire("4fqPo");

var $7sVuQ = parcelRequire("7sVuQ");

var $8BqaN = parcelRequire("8BqaN");

var $lylKc = parcelRequire("lylKc");
parcelRequire("lTqn1");
parcelRequire("ichJ5");
parcelRequire("e8kkA");

parcelRequire("cpFTT");
var $f9a8fad9894c88cc$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $f9a8fad9894c88cc$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $gOfqU.h).call(props, 'css')) // $FlowFixMe
    return $4fqPo.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $gOfqU.E);
    createElementArgArray[1] = (0, $gOfqU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $4fqPo.createElement.apply(null, createElementArgArray);
};
var $f9a8fad9894c88cc$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $f9a8fad9894c88cc$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $gOfqU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $lylKc.serializeStyles)([
        styles
    ], undefined, $4fqPo.useContext((0, $gOfqU.T)));
    if (!(0, $gOfqU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $4fqPo.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $4fqPo.useRef();
    (0, $8BqaN.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $8BqaN.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7sVuQ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $f9a8fad9894c88cc$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $lylKc.serializeStyles)(args);
}
var $f9a8fad9894c88cc$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $f9a8fad9894c88cc$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $f9a8fad9894c88cc$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $f9a8fad9894c88cc$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7sVuQ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $f9a8fad9894c88cc$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $8BqaN.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7sVuQ.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $f9a8fad9894c88cc$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $gOfqU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $lylKc.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7sVuQ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $f9a8fad9894c88cc$var$merge(cache.registered, css, $f9a8fad9894c88cc$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $4fqPo.useContext((0, $gOfqU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($f9a8fad9894c88cc$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $f9a8fad9894c88cc$var$isBrowser, $f9a8fad9894c88cc$var$isTestEnv, $f9a8fad9894c88cc$var$globalContext, $f9a8fad9894c88cc$var$globalKey;

});
parcelRegister("gOfqU", function(module, exports) {
$parcel$export(module.exports, "i", () => $c3cd498484caefb9$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $c3cd498484caefb9$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "C", () => $c3cd498484caefb9$export$e7094788287c5e9b);
$parcel$export(module.exports, "_", () => $c3cd498484caefb9$export$71511d61b312f219);
$parcel$export(module.exports, "w", () => $c3cd498484caefb9$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $c3cd498484caefb9$export$971d5caa766a69d7);
$parcel$export(module.exports, "u", () => $c3cd498484caefb9$export$3b14a55fb2447963);
$parcel$export(module.exports, "a", () => $c3cd498484caefb9$export$407448d2b89b1813);
$parcel$export(module.exports, "b", () => $c3cd498484caefb9$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "c", () => $c3cd498484caefb9$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $c3cd498484caefb9$export$a9c23c6ac3fc3eca);

var $4fqPo = parcelRequire("4fqPo");

var $lTqn1 = parcelRequire("lTqn1");

var $ichJ5 = parcelRequire("ichJ5");

var $e8kkA = parcelRequire("e8kkA");

var $jTKxb = parcelRequire("jTKxb");

var $7sVuQ = parcelRequire("7sVuQ");

var $lylKc = parcelRequire("lylKc");

var $8BqaN = parcelRequire("8BqaN");
var $c3cd498484caefb9$export$23f2a1d2818174ef = true;
var $c3cd498484caefb9$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $c3cd498484caefb9$var$EmotionCacheContext = /* #__PURE__ */ $4fqPo.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $lTqn1.default)({
    key: 'css'
}) : null);
var $c3cd498484caefb9$export$e7094788287c5e9b = $c3cd498484caefb9$var$EmotionCacheContext.Provider;
var $c3cd498484caefb9$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $4fqPo.useContext)($c3cd498484caefb9$var$EmotionCacheContext);
};
var $c3cd498484caefb9$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $4fqPo.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $4fqPo.useContext)($c3cd498484caefb9$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$c3cd498484caefb9$export$23f2a1d2818174ef) $c3cd498484caefb9$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $4fqPo.useContext)($c3cd498484caefb9$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $lTqn1.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $4fqPo.createElement($c3cd498484caefb9$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $c3cd498484caefb9$export$971d5caa766a69d7 = /* #__PURE__ */ $4fqPo.createContext({});
var $c3cd498484caefb9$export$3b14a55fb2447963 = function useTheme() {
    return $4fqPo.useContext($c3cd498484caefb9$export$971d5caa766a69d7);
};
var $c3cd498484caefb9$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $ichJ5.default)({}, outerTheme, theme);
};
var $c3cd498484caefb9$var$createCacheWithTheme = /* #__PURE__ */ (0, $e8kkA.default)(function(outerTheme) {
    return (0, $e8kkA.default)(function(theme) {
        return $c3cd498484caefb9$var$getTheme(outerTheme, theme);
    });
});
var $c3cd498484caefb9$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $4fqPo.useContext($c3cd498484caefb9$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $c3cd498484caefb9$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $4fqPo.createElement($c3cd498484caefb9$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $c3cd498484caefb9$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $4fqPo.useContext($c3cd498484caefb9$export$971d5caa766a69d7);
        return /*#__PURE__*/ $4fqPo.createElement(Component, (0, $ichJ5.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $4fqPo.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $jTKxb.default)(WithTheme, Component);
}
var $c3cd498484caefb9$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $c3cd498484caefb9$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $c3cd498484caefb9$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $c3cd498484caefb9$var$getLastPart(match[1]);
    return undefined;
};
var $c3cd498484caefb9$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $c3cd498484caefb9$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $c3cd498484caefb9$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $c3cd498484caefb9$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($c3cd498484caefb9$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $c3cd498484caefb9$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $c3cd498484caefb9$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $c3cd498484caefb9$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $c3cd498484caefb9$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($c3cd498484caefb9$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$c3cd498484caefb9$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $c3cd498484caefb9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7sVuQ.registerStyles)(cache, serialized, isStringTag);
    (0, $8BqaN.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7sVuQ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $c3cd498484caefb9$var$Emotion = /* #__PURE__ */ $c3cd498484caefb9$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$c3cd498484caefb9$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $7sVuQ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $lylKc.serializeStyles)(registeredStyles, undefined, $4fqPo.useContext($c3cd498484caefb9$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($c3cd498484caefb9$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $c3cd498484caefb9$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($c3cd498484caefb9$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, newProps));
});
var $c3cd498484caefb9$export$a9c23c6ac3fc3eca = $c3cd498484caefb9$var$Emotion;

});
parcelRegister("lTqn1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff0330a185240df1$export$2e2bcd8739ae039);

var $aXcX7 = parcelRequire("aXcX7");

var $8dgBX = parcelRequire("8dgBX");
var $kfMGE = parcelRequire("kfMGE");
var $ST2R7 = parcelRequire("ST2R7");
var $kiHVR = parcelRequire("kiHVR");
var $eEp2x = parcelRequire("eEp2x");
var $ecoNh = parcelRequire("ecoNh");
parcelRequire("e8kkA");
parcelRequire("5wNlI");
var $ff0330a185240df1$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $8dgBX.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $8dgBX.token)(character)) break;
        (0, $8dgBX.next)();
    }
    return (0, $8dgBX.slice)(begin, (0, $8dgBX.position));
};
var $ff0330a185240df1$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $8dgBX.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $8dgBX.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $ff0330a185240df1$var$identifierWithPointTracking((0, $8dgBX.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $8dgBX.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $8dgBX.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $kfMGE.from)(character);
    }
    while (character = (0, $8dgBX.next)());
    return parsed;
};
var $ff0330a185240df1$var$getRules = function getRules(value, points) {
    return (0, $8dgBX.dealloc)($ff0330a185240df1$var$toRules((0, $8dgBX.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $ff0330a185240df1$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $ff0330a185240df1$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$ff0330a185240df1$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $ff0330a185240df1$var$fixedElements.set(element, true);
    var points = [];
    var rules = $ff0330a185240df1$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $ff0330a185240df1$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $ff0330a185240df1$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $ff0330a185240df1$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($ff0330a185240df1$var$ignoreFlag) > -1;
};
var $ff0330a185240df1$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($ff0330a185240df1$var$isIgnoringComment(node)) return;
                    break;
                }
            }
        }
    };
};
var $ff0330a185240df1$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $ff0330a185240df1$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$ff0330a185240df1$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $ff0330a185240df1$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $ff0330a185240df1$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$ff0330a185240df1$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $ff0330a185240df1$var$nullifyElement(element);
    } else if ($ff0330a185240df1$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $ff0330a185240df1$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $ff0330a185240df1$var$prefix(value, length) {
    switch((0, $kfMGE.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $kiHVR.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $kiHVR.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MOZ) + value + (0, $kiHVR.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + value + value;
        // order
        case 6165:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $kiHVR.WEBKIT) + value + (0, $kfMGE.replace)(value, /(\w+).+(:[^]+)/, (0, $kiHVR.WEBKIT) + 'box-$1$2' + (0, $kiHVR.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + 'flex-item-' + (0, $kfMGE.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + 'flex-line-pack' + (0, $kfMGE.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $kiHVR.WEBKIT) + 'box-' + (0, $kfMGE.replace)(value, '-grow', '') + (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $kiHVR.WEBKIT) + (0, $kfMGE.replace)(value, /([^-])(transform)/g, '$1' + (0, $kiHVR.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $kfMGE.replace)((0, $kfMGE.replace)((0, $kfMGE.replace)(value, /(zoom-|grab)/, (0, $kiHVR.WEBKIT) + '$1'), /(image-set)/, (0, $kiHVR.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $kfMGE.replace)(value, /(image-set\([^]*)/, (0, $kiHVR.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $kfMGE.replace)((0, $kfMGE.replace)(value, /(.+:)(flex-)?(.*)/, (0, $kiHVR.WEBKIT) + 'box-pack:$3' + (0, $kiHVR.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $kiHVR.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $kfMGE.replace)(value, /(.+)-inline(.+)/, (0, $kiHVR.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $kfMGE.strlen)(value) - 1 - length > 6) switch((0, $kfMGE.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $kfMGE.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $kfMGE.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $kiHVR.WEBKIT) + '$2-$3' + '$1' + (0, $kiHVR.MOZ) + ((0, $kfMGE.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $kfMGE.indexof)(value, 'stretch') ? $ff0330a185240df1$var$prefix((0, $kfMGE.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $kfMGE.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $kfMGE.charat)(value, (0, $kfMGE.strlen)(value) - 3 - (~(0, $kfMGE.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $kfMGE.replace)(value, ':', ':' + (0, $kiHVR.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $kfMGE.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $kiHVR.WEBKIT) + ((0, $kfMGE.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $kiHVR.WEBKIT) + '$2$3' + '$1' + (0, $kiHVR.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $kfMGE.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + value + value;
    }
    return value;
}
var $ff0330a185240df1$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $kiHVR.DECLARATION:
                element["return"] = $ff0330a185240df1$var$prefix(element.value, element.length);
                break;
            case 0, $kiHVR.KEYFRAMES:
                return (0, $ecoNh.serialize)([
                    (0, $8dgBX.copy)(element, {
                        value: (0, $kfMGE.replace)(element.value, '@', '@' + (0, $kiHVR.WEBKIT))
                    })
                ], callback);
            case 0, $kiHVR.RULESET:
                if (element.length) return (0, $kfMGE.combine)(element.props, function(value) {
                    switch((0, $kfMGE.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $ecoNh.serialize)([
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(read-\w+)/, ':' + (0, $kiHVR.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $ecoNh.serialize)([
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(plac\w+)/, ':' + (0, $kiHVR.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(plac\w+)/, ':' + (0, $kiHVR.MOZ) + '$1')
                                    ]
                                }),
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(plac\w+)/, (0, $kiHVR.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $ff0330a185240df1$var$defaultStylisPlugins = [
    $ff0330a185240df1$var$prefixer
];
var $ff0330a185240df1$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $ff0330a185240df1$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $ff0330a185240df1$var$compat,
        $ff0330a185240df1$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $ecoNh.stringify),
        (0, $eEp2x.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $eEp2x.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $ecoNh.serialize)((0, $ST2R7.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $aXcX7.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("aXcX7", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $7f997631172624c4$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $7f997631172624c4$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $7f997631172624c4$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $7f997631172624c4$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($7f997631172624c4$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $7f997631172624c4$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("8dgBX", function(module, exports) {
$parcel$export(module.exports, "position", () => $5fac6c4a05fe17ab$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $5fac6c4a05fe17ab$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $5fac6c4a05fe17ab$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $5fac6c4a05fe17ab$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $5fac6c4a05fe17ab$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $5fac6c4a05fe17ab$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $5fac6c4a05fe17ab$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $5fac6c4a05fe17ab$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $5fac6c4a05fe17ab$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $5fac6c4a05fe17ab$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $5fac6c4a05fe17ab$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $5fac6c4a05fe17ab$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $5fac6c4a05fe17ab$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $5fac6c4a05fe17ab$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $5fac6c4a05fe17ab$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $5fac6c4a05fe17ab$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $5fac6c4a05fe17ab$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $5fac6c4a05fe17ab$export$4254d4e2b3745c4c);

var $kfMGE = parcelRequire("kfMGE");
var $5fac6c4a05fe17ab$export$53f1d5ea8de3d7c = 1;
var $5fac6c4a05fe17ab$export$4e0c71f277ca26b3 = 1;
var $5fac6c4a05fe17ab$export$f24224f1c91d8156 = 0;
var $5fac6c4a05fe17ab$export$5880b8b5730aff45 = 0;
var $5fac6c4a05fe17ab$export$c0306caf338ac095 = 0;
var $5fac6c4a05fe17ab$export$30a86d91af8ff6e6 = '';
function $5fac6c4a05fe17ab$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $5fac6c4a05fe17ab$export$53f1d5ea8de3d7c,
        column: $5fac6c4a05fe17ab$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $5fac6c4a05fe17ab$export$784d13d8ee351f07(root, props) {
    return (0, $kfMGE.assign)($5fac6c4a05fe17ab$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $5fac6c4a05fe17ab$export$eba6f6f03b0a92e7() {
    return $5fac6c4a05fe17ab$export$c0306caf338ac095;
}
function $5fac6c4a05fe17ab$export$232faf9add678146() {
    $5fac6c4a05fe17ab$export$c0306caf338ac095 = $5fac6c4a05fe17ab$export$5880b8b5730aff45 > 0 ? (0, $kfMGE.charat)($5fac6c4a05fe17ab$export$30a86d91af8ff6e6, --$5fac6c4a05fe17ab$export$5880b8b5730aff45) : 0;
    if ($5fac6c4a05fe17ab$export$4e0c71f277ca26b3--, $5fac6c4a05fe17ab$export$c0306caf338ac095 === 10) $5fac6c4a05fe17ab$export$4e0c71f277ca26b3 = 1, $5fac6c4a05fe17ab$export$53f1d5ea8de3d7c--;
    return $5fac6c4a05fe17ab$export$c0306caf338ac095;
}
function $5fac6c4a05fe17ab$export$48cfd1e771a65c4f() {
    $5fac6c4a05fe17ab$export$c0306caf338ac095 = $5fac6c4a05fe17ab$export$5880b8b5730aff45 < $5fac6c4a05fe17ab$export$f24224f1c91d8156 ? (0, $kfMGE.charat)($5fac6c4a05fe17ab$export$30a86d91af8ff6e6, $5fac6c4a05fe17ab$export$5880b8b5730aff45++) : 0;
    if ($5fac6c4a05fe17ab$export$4e0c71f277ca26b3++, $5fac6c4a05fe17ab$export$c0306caf338ac095 === 10) $5fac6c4a05fe17ab$export$4e0c71f277ca26b3 = 1, $5fac6c4a05fe17ab$export$53f1d5ea8de3d7c++;
    return $5fac6c4a05fe17ab$export$c0306caf338ac095;
}
function $5fac6c4a05fe17ab$export$4d3fb11e950abb9e() {
    return (0, $kfMGE.charat)($5fac6c4a05fe17ab$export$30a86d91af8ff6e6, $5fac6c4a05fe17ab$export$5880b8b5730aff45);
}
function $5fac6c4a05fe17ab$export$e88cb2efb12ae807() {
    return $5fac6c4a05fe17ab$export$5880b8b5730aff45;
}
function $5fac6c4a05fe17ab$export$58adb3bec8346d0f(begin, end) {
    return (0, $kfMGE.substr)($5fac6c4a05fe17ab$export$30a86d91af8ff6e6, begin, end);
}
function $5fac6c4a05fe17ab$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $5fac6c4a05fe17ab$export$2de70f21292aac9e(value) {
    return $5fac6c4a05fe17ab$export$53f1d5ea8de3d7c = $5fac6c4a05fe17ab$export$4e0c71f277ca26b3 = 1, $5fac6c4a05fe17ab$export$f24224f1c91d8156 = (0, $kfMGE.strlen)($5fac6c4a05fe17ab$export$30a86d91af8ff6e6 = value), $5fac6c4a05fe17ab$export$5880b8b5730aff45 = 0, [];
}
function $5fac6c4a05fe17ab$export$45918ac1574455b1(value) {
    return $5fac6c4a05fe17ab$export$30a86d91af8ff6e6 = '', value;
}
function $5fac6c4a05fe17ab$export$410ac95b9ec204b8(type) {
    return (0, $kfMGE.trim)($5fac6c4a05fe17ab$export$58adb3bec8346d0f($5fac6c4a05fe17ab$export$5880b8b5730aff45 - 1, $5fac6c4a05fe17ab$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $5fac6c4a05fe17ab$export$660b2ee2d4fb4eff(value) {
    return $5fac6c4a05fe17ab$export$45918ac1574455b1($5fac6c4a05fe17ab$export$5f8c09e3ae6f64e1($5fac6c4a05fe17ab$export$2de70f21292aac9e(value)));
}
function $5fac6c4a05fe17ab$export$7af1228ff777d175(type) {
    while($5fac6c4a05fe17ab$export$c0306caf338ac095 = $5fac6c4a05fe17ab$export$4d3fb11e950abb9e())if ($5fac6c4a05fe17ab$export$c0306caf338ac095 < 33) $5fac6c4a05fe17ab$export$48cfd1e771a65c4f();
    else break;
    return $5fac6c4a05fe17ab$export$9e1725a4cfeada27(type) > 2 || $5fac6c4a05fe17ab$export$9e1725a4cfeada27($5fac6c4a05fe17ab$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $5fac6c4a05fe17ab$export$5f8c09e3ae6f64e1(children) {
    while($5fac6c4a05fe17ab$export$48cfd1e771a65c4f())switch($5fac6c4a05fe17ab$export$9e1725a4cfeada27($5fac6c4a05fe17ab$export$c0306caf338ac095)){
        case 0:
            (0, $kfMGE.append)($5fac6c4a05fe17ab$export$c2ab62c7bf24634($5fac6c4a05fe17ab$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $kfMGE.append)($5fac6c4a05fe17ab$export$410ac95b9ec204b8($5fac6c4a05fe17ab$export$c0306caf338ac095), children);
            break;
        default:
            (0, $kfMGE.append)((0, $kfMGE.from)($5fac6c4a05fe17ab$export$c0306caf338ac095), children);
    }
    return children;
}
function $5fac6c4a05fe17ab$export$955ba06d119e085e(index, count) {
    while(--count && $5fac6c4a05fe17ab$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($5fac6c4a05fe17ab$export$c0306caf338ac095 < 48 || $5fac6c4a05fe17ab$export$c0306caf338ac095 > 102 || $5fac6c4a05fe17ab$export$c0306caf338ac095 > 57 && $5fac6c4a05fe17ab$export$c0306caf338ac095 < 65 || $5fac6c4a05fe17ab$export$c0306caf338ac095 > 70 && $5fac6c4a05fe17ab$export$c0306caf338ac095 < 97) break;
    return $5fac6c4a05fe17ab$export$58adb3bec8346d0f(index, $5fac6c4a05fe17ab$export$e88cb2efb12ae807() + (count < 6 && $5fac6c4a05fe17ab$export$4d3fb11e950abb9e() == 32 && $5fac6c4a05fe17ab$export$48cfd1e771a65c4f() == 32));
}
function $5fac6c4a05fe17ab$export$c889f2fcc19dbf12(type) {
    while($5fac6c4a05fe17ab$export$48cfd1e771a65c4f())switch($5fac6c4a05fe17ab$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $5fac6c4a05fe17ab$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $5fac6c4a05fe17ab$export$c889f2fcc19dbf12($5fac6c4a05fe17ab$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $5fac6c4a05fe17ab$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $5fac6c4a05fe17ab$export$48cfd1e771a65c4f();
            break;
    }
    return $5fac6c4a05fe17ab$export$5880b8b5730aff45;
}
function $5fac6c4a05fe17ab$export$4254d4e2b3745c4c(type, index) {
    while($5fac6c4a05fe17ab$export$48cfd1e771a65c4f())// //
    if (type + $5fac6c4a05fe17ab$export$c0306caf338ac095 === 57) break;
    else if (type + $5fac6c4a05fe17ab$export$c0306caf338ac095 === 84 && $5fac6c4a05fe17ab$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $5fac6c4a05fe17ab$export$58adb3bec8346d0f(index, $5fac6c4a05fe17ab$export$5880b8b5730aff45 - 1) + '*' + (0, $kfMGE.from)(type === 47 ? type : $5fac6c4a05fe17ab$export$48cfd1e771a65c4f());
}
function $5fac6c4a05fe17ab$export$c2ab62c7bf24634(index) {
    while(!$5fac6c4a05fe17ab$export$9e1725a4cfeada27($5fac6c4a05fe17ab$export$4d3fb11e950abb9e()))$5fac6c4a05fe17ab$export$48cfd1e771a65c4f();
    return $5fac6c4a05fe17ab$export$58adb3bec8346d0f(index, $5fac6c4a05fe17ab$export$5880b8b5730aff45);
}

});
parcelRegister("kfMGE", function(module, exports) {
$parcel$export(module.exports, "abs", () => $ebeaf994a303e62d$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $ebeaf994a303e62d$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $ebeaf994a303e62d$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $ebeaf994a303e62d$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $ebeaf994a303e62d$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $ebeaf994a303e62d$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $ebeaf994a303e62d$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $ebeaf994a303e62d$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $ebeaf994a303e62d$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $ebeaf994a303e62d$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $ebeaf994a303e62d$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $ebeaf994a303e62d$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $ebeaf994a303e62d$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $ebeaf994a303e62d$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $ebeaf994a303e62d$export$2335f513bbd82c6d = Math.abs;
var $ebeaf994a303e62d$export$6788812c4e6611e6 = String.fromCharCode;
var $ebeaf994a303e62d$export$e6e34fd1f2686227 = Object.assign;
function $ebeaf994a303e62d$export$d6af199866bfb566(value, length) {
    return $ebeaf994a303e62d$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $ebeaf994a303e62d$export$a9db5e087081082d(value, 0)) << 2 ^ $ebeaf994a303e62d$export$a9db5e087081082d(value, 1)) << 2 ^ $ebeaf994a303e62d$export$a9db5e087081082d(value, 2)) << 2 ^ $ebeaf994a303e62d$export$a9db5e087081082d(value, 3) : 0;
}
function $ebeaf994a303e62d$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $ebeaf994a303e62d$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $ebeaf994a303e62d$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $ebeaf994a303e62d$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $ebeaf994a303e62d$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $ebeaf994a303e62d$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $ebeaf994a303e62d$export$36776f635604f274(value) {
    return value.length;
}
function $ebeaf994a303e62d$export$f9084667e487ed46(value) {
    return value.length;
}
function $ebeaf994a303e62d$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $ebeaf994a303e62d$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("ST2R7", function(module, exports) {
$parcel$export(module.exports, "compile", () => $0a4fbe102bba0328$export$ef7acd7185315e22);

var $kiHVR = parcelRequire("kiHVR");

var $kfMGE = parcelRequire("kfMGE");

var $8dgBX = parcelRequire("8dgBX");
function $0a4fbe102bba0328$export$ef7acd7185315e22(value) {
    return (0, $8dgBX.dealloc)($0a4fbe102bba0328$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $8dgBX.alloc)(value), 0, [
        0
    ], value));
}
function $0a4fbe102bba0328$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $8dgBX.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $kfMGE.charat)(characters, length - 1) == 58) {
                if ((0, $kfMGE.indexof)(characters += (0, $kfMGE.replace)((0, $8dgBX.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $8dgBX.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $8dgBX.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $8dgBX.escaping)((0, $8dgBX.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $8dgBX.peek)()){
                case 42:
                case 47:
                    (0, $kfMGE.append)($0a4fbe102bba0328$export$4a34f930e789283c((0, $8dgBX.commenter)((0, $8dgBX.next)(), (0, $8dgBX.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $kfMGE.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $kfMGE.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $kfMGE.strlen)(characters) - length) (0, $kfMGE.append)(property > 32 ? $0a4fbe102bba0328$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $0a4fbe102bba0328$export$f8483753829ec8f3((0, $kfMGE.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $kfMGE.append)(reference = $0a4fbe102bba0328$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $0a4fbe102bba0328$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $kfMGE.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $0a4fbe102bba0328$export$98e6a39c04603d36(value, reference, reference, rule && (0, $kfMGE.append)($0a4fbe102bba0328$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $0a4fbe102bba0328$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $kfMGE.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $8dgBX.prev)() == 125) continue;
            }
            switch(characters += (0, $kfMGE.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $kfMGE.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $8dgBX.peek)() === 45) characters += (0, $8dgBX.delimit)((0, $8dgBX.next)());
                    atrule = (0, $8dgBX.peek)(), offset = length = (0, $kfMGE.strlen)(type = characters += (0, $8dgBX.identifier)((0, $8dgBX.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $kfMGE.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $0a4fbe102bba0328$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $kfMGE.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $kfMGE.substr)(value, post + 1, post = (0, $kfMGE.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $kfMGE.trim)(j > 0 ? rule[x] + ' ' + y : (0, $kfMGE.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $8dgBX.node)(value, root, parent, offset === 0 ? (0, $kiHVR.RULESET) : type, props, children, length);
}
function $0a4fbe102bba0328$export$4a34f930e789283c(value, root, parent) {
    return (0, $8dgBX.node)(value, root, parent, (0, $kiHVR.COMMENT), (0, $kfMGE.from)((0, $8dgBX.char)()), (0, $kfMGE.substr)(value, 2, -2), 0);
}
function $0a4fbe102bba0328$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $8dgBX.node)(value, root, parent, (0, $kiHVR.DECLARATION), (0, $kfMGE.substr)(value, 0, length), (0, $kfMGE.substr)(value, length + 1, -1), length);
}

});
parcelRegister("kiHVR", function(module, exports) {
$parcel$export(module.exports, "MS", () => $ec7791207fef2851$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $ec7791207fef2851$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $ec7791207fef2851$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $ec7791207fef2851$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $ec7791207fef2851$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $ec7791207fef2851$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $ec7791207fef2851$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $ec7791207fef2851$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $ec7791207fef2851$export$d773506282b3cfe6);
var $ec7791207fef2851$export$71ad59f2e432cfe8 = '-ms-';
var $ec7791207fef2851$export$2c0f367103c8d01c = '-moz-';
var $ec7791207fef2851$export$39dfd62a25e0fe93 = '-webkit-';
var $ec7791207fef2851$export$a29989082612d0d9 = 'comm';
var $ec7791207fef2851$export$aa3a2e812ca8570d = 'rule';
var $ec7791207fef2851$export$527d108ccf083c2b = 'decl';
var $ec7791207fef2851$export$d3d35020fa5b54f0 = '@page';
var $ec7791207fef2851$export$500415a86c544f73 = '@media';
var $ec7791207fef2851$export$a763edbf796b780a = '@import';
var $ec7791207fef2851$export$2790aeb8b4e5c826 = '@charset';
var $ec7791207fef2851$export$1cc683e23b84b133 = '@viewport';
var $ec7791207fef2851$export$9447a5efea57e862 = '@supports';
var $ec7791207fef2851$export$ef011b4e114b1fba = '@document';
var $ec7791207fef2851$export$6aad947bda0f3f46 = '@namespace';
var $ec7791207fef2851$export$b44a8529a35fcb60 = '@keyframes';
var $ec7791207fef2851$export$2c16de31893252e6 = '@font-face';
var $ec7791207fef2851$export$3d846dd52e150c6f = '@counter-style';
var $ec7791207fef2851$export$22314bfbb57653fe = '@font-feature-values';
var $ec7791207fef2851$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("eEp2x", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $aaa83986b3e74945$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $aaa83986b3e74945$export$38bcb760f1d4871c);

var $kiHVR = parcelRequire("kiHVR");

var $kfMGE = parcelRequire("kfMGE");

var $8dgBX = parcelRequire("8dgBX");

var $ecoNh = parcelRequire("ecoNh");

var $batBI = parcelRequire("batBI");
function $aaa83986b3e74945$export$5a7767152ae0305f(collection) {
    var length = (0, $kfMGE.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $aaa83986b3e74945$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $aaa83986b3e74945$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $kiHVR.DECLARATION:
                element.return = (0, $batBI.prefix)(element.value, element.length, children);
                return;
            case 0, $kiHVR.KEYFRAMES:
                return (0, $ecoNh.serialize)([
                    (0, $8dgBX.copy)(element, {
                        value: (0, $kfMGE.replace)(element.value, '@', '@' + (0, $kiHVR.WEBKIT))
                    })
                ], callback);
            case 0, $kiHVR.RULESET:
                if (element.length) return (0, $kfMGE.combine)(element.props, function(value) {
                    switch((0, $kfMGE.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $ecoNh.serialize)([
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(read-\w+)/, ':' + (0, $kiHVR.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $ecoNh.serialize)([
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(plac\w+)/, ':' + (0, $kiHVR.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(plac\w+)/, ':' + (0, $kiHVR.MOZ) + '$1')
                                    ]
                                }),
                                (0, $8dgBX.copy)(element, {
                                    props: [
                                        (0, $kfMGE.replace)(value, /:(plac\w+)/, (0, $kiHVR.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $aaa83986b3e74945$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $kiHVR.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $kfMGE.combine)((0, $8dgBX.tokenize)(value), function(value, index, children) {
                    switch((0, $kfMGE.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $kfMGE.substr)(value, 1, (0, $kfMGE.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $kfMGE.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $kfMGE.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $kfMGE.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("ecoNh", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $a5656b37fde2f163$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $a5656b37fde2f163$export$fac44ee5b035f737);

var $kiHVR = parcelRequire("kiHVR");

var $kfMGE = parcelRequire("kfMGE");
function $a5656b37fde2f163$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $kfMGE.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $a5656b37fde2f163$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $kiHVR.LAYER:
            if (element.children.length) break;
        case 0, $kiHVR.IMPORT:
        case 0, $kiHVR.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $kiHVR.COMMENT:
            return '';
        case 0, $kiHVR.KEYFRAMES:
            return element.return = element.value + '{' + $a5656b37fde2f163$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $kiHVR.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $kfMGE.strlen)(children = $a5656b37fde2f163$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("batBI", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $8217984959adfb30$export$82e9f45cca5ba907);

var $kiHVR = parcelRequire("kiHVR");

var $kfMGE = parcelRequire("kfMGE");
function $8217984959adfb30$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $kfMGE.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $kiHVR.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $kiHVR.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $kiHVR.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MOZ) + value + (0, $kiHVR.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $kfMGE.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + value + value;
        // order
        case 6165:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $kiHVR.WEBKIT) + value + (0, $kfMGE.replace)(value, /(\w+).+(:[^]+)/, (0, $kiHVR.WEBKIT) + 'box-$1$2' + (0, $kiHVR.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + 'flex-item-' + (0, $kfMGE.replace)(value, /flex-|-self/g, '') + (!(0, $kfMGE.match)(value, /flex-|baseline/) ? (0, $kiHVR.MS) + 'grid-row-' + (0, $kfMGE.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + 'flex-line-pack' + (0, $kfMGE.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $kiHVR.WEBKIT) + 'box-' + (0, $kfMGE.replace)(value, '-grow', '') + (0, $kiHVR.WEBKIT) + value + (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $kiHVR.WEBKIT) + (0, $kfMGE.replace)(value, /([^-])(transform)/g, '$1' + (0, $kiHVR.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $kfMGE.replace)((0, $kfMGE.replace)((0, $kfMGE.replace)(value, /(zoom-|grab)/, (0, $kiHVR.WEBKIT) + '$1'), /(image-set)/, (0, $kiHVR.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $kfMGE.replace)(value, /(image-set\([^]*)/, (0, $kiHVR.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $kfMGE.replace)((0, $kfMGE.replace)(value, /(.+:)(flex-)?(.*)/, (0, $kiHVR.WEBKIT) + 'box-pack:$3' + (0, $kiHVR.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $kiHVR.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $kfMGE.match)(value, /flex-|baseline/)) return (0, $kiHVR.MS) + 'grid-column-align' + (0, $kfMGE.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $kfMGE.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $kfMGE.indexof)(value + (children = children[length].value), 'span') ? value : (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, '-start', '') + value + (0, $kiHVR.MS) + 'grid-row-span:' + (~(0, $kfMGE.indexof)(children, 'span') ? (0, $kfMGE.match)(children, /\d+/) : +(0, $kfMGE.match)(children, /\d+/) - +(0, $kfMGE.match)(value, /\d+/)) + ';';
            return (0, $kiHVR.MS) + (0, $kfMGE.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $kfMGE.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $kiHVR.MS) + (0, $kfMGE.replace)((0, $kfMGE.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $kfMGE.replace)(value, /(.+)-inline(.+)/, (0, $kiHVR.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $kfMGE.strlen)(value) - 1 - length > 6) switch((0, $kfMGE.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $kfMGE.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $kfMGE.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $kiHVR.WEBKIT) + '$2-$3' + '$1' + (0, $kiHVR.MOZ) + ((0, $kfMGE.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $kfMGE.indexof)(value, 'stretch') ? $8217984959adfb30$export$82e9f45cca5ba907((0, $kfMGE.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $kfMGE.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $kiHVR.MS) + a + ':' + b + f + (c ? (0, $kiHVR.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $kfMGE.charat)(value, length + 6) === 121) return (0, $kfMGE.replace)(value, ':', ':' + (0, $kiHVR.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $kfMGE.charat)(value, (0, $kfMGE.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $kfMGE.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $kiHVR.WEBKIT) + ((0, $kfMGE.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $kiHVR.WEBKIT) + '$2$3' + '$1' + (0, $kiHVR.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $kfMGE.replace)(value, ':', ':' + (0, $kiHVR.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $kfMGE.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("e8kkA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4a1956265d51907$export$2e2bcd8739ae039);
var $a4a1956265d51907$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("5wNlI", function(module, exports) {
function $4066389ea260bad7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("jTKxb", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7c74018ec5a0368$export$2e2bcd8739ae039);

var $cpFTT = parcelRequire("cpFTT");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $e7c74018ec5a0368$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(targetComponent, sourceComponent);
};

});

parcelRegister("7sVuQ", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $56f7bf8f0d50eb4e$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $56f7bf8f0d50eb4e$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $56f7bf8f0d50eb4e$export$6f077d94b33a01aa);
var $56f7bf8f0d50eb4e$var$isBrowser = true;
function $56f7bf8f0d50eb4e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $56f7bf8f0d50eb4e$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $56f7bf8f0d50eb4e$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $56f7bf8f0d50eb4e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $56f7bf8f0d50eb4e$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("lylKc", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $040c9b6ad2bd1129$export$6321afa313b251b5);

var $9JXhg = parcelRequire("9JXhg");

var $bmxsC = parcelRequire("bmxsC");

var $2VB3l = parcelRequire("2VB3l");
var $040c9b6ad2bd1129$var$isDevelopment = false;
var $040c9b6ad2bd1129$var$hyphenateRegex = /[A-Z]|^ms/g;
var $040c9b6ad2bd1129$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $040c9b6ad2bd1129$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $040c9b6ad2bd1129$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $040c9b6ad2bd1129$var$processStyleName = /* #__PURE__ */ (0, $2VB3l.default)(function(styleName) {
    return $040c9b6ad2bd1129$var$isCustomProperty(styleName) ? styleName : styleName.replace($040c9b6ad2bd1129$var$hyphenateRegex, '-$&').toLowerCase();
});
var $040c9b6ad2bd1129$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($040c9b6ad2bd1129$var$animationRegex, function(match, p1, p2) {
                $040c9b6ad2bd1129$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $040c9b6ad2bd1129$var$cursor
                };
                return p1;
            });
    }
    if ((0, $bmxsC.default)[key] !== 1 && !$040c9b6ad2bd1129$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $040c9b6ad2bd1129$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $040c9b6ad2bd1129$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $040c9b6ad2bd1129$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $040c9b6ad2bd1129$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $040c9b6ad2bd1129$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $040c9b6ad2bd1129$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $040c9b6ad2bd1129$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $040c9b6ad2bd1129$var$cursor;
                var result = interpolation(mergedProps);
                $040c9b6ad2bd1129$var$cursor = previousCursor;
                return $040c9b6ad2bd1129$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $040c9b6ad2bd1129$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $040c9b6ad2bd1129$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($040c9b6ad2bd1129$var$isProcessableValue(asString)) string += $040c9b6ad2bd1129$var$processStyleName(key) + ":" + $040c9b6ad2bd1129$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $040c9b6ad2bd1129$var$isDevelopment) throw new Error($040c9b6ad2bd1129$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($040c9b6ad2bd1129$var$isProcessableValue(value[_i])) string += $040c9b6ad2bd1129$var$processStyleName(key) + ":" + $040c9b6ad2bd1129$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $040c9b6ad2bd1129$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $040c9b6ad2bd1129$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $040c9b6ad2bd1129$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $040c9b6ad2bd1129$var$cursor;
function $040c9b6ad2bd1129$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $040c9b6ad2bd1129$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $040c9b6ad2bd1129$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $040c9b6ad2bd1129$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $040c9b6ad2bd1129$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $040c9b6ad2bd1129$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $9JXhg.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $040c9b6ad2bd1129$var$cursor
    };
}

});
parcelRegister("9JXhg", function(module, exports) {
$parcel$export(module.exports, "default", () => $71764c44e99d7358$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $71764c44e99d7358$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("bmxsC", function(module, exports) {
$parcel$export(module.exports, "default", () => $845bb45ce69cdd2c$export$2e2bcd8739ae039);
var $845bb45ce69cdd2c$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("2VB3l", function(module, exports) {
$parcel$export(module.exports, "default", () => $221da598cc266263$export$2e2bcd8739ae039);
function $221da598cc266263$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8BqaN", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $643614dc76895de2$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $643614dc76895de2$export$811a713a7276cb9d);

var $4fqPo = parcelRequire("4fqPo");
var $643614dc76895de2$var$syncFallback = function syncFallback(create) {
    return create();
};
var $643614dc76895de2$var$useInsertionEffect = false;
var $643614dc76895de2$export$db21c7ffa21794e7 = $643614dc76895de2$var$useInsertionEffect || $643614dc76895de2$var$syncFallback;
var $643614dc76895de2$export$811a713a7276cb9d = $643614dc76895de2$var$useInsertionEffect || $4fqPo.useLayoutEffect;

});



parcelRegister("28VoU", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", () => $0d1fbf377d81372a$export$1ca2a26fecb070ae);

var $4fqPo = parcelRequire("4fqPo");
const $0d1fbf377d81372a$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $4fqPo.createContext)('elevation.surface');

});

parcelRegister("fJeCl", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", () => $c8c43bf2df2fb070$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $c8c43bf2df2fb070$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $c8c43bf2df2fb070$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $c8c43bf2df2fb070$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $c8c43bf2df2fb070$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $c8c43bf2df2fb070$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $c8c43bf2df2fb070$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $c8c43bf2df2fb070$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $c8c43bf2df2fb070$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $c8c43bf2df2fb070$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $c8c43bf2df2fb070$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $c8c43bf2df2fb070$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $c8c43bf2df2fb070$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $c8c43bf2df2fb070$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $c8c43bf2df2fb070$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $c8c43bf2df2fb070$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $c8c43bf2df2fb070$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $c8c43bf2df2fb070$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $c8c43bf2df2fb070$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $c8c43bf2df2fb070$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $c8c43bf2df2fb070$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $c8c43bf2df2fb070$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $c8c43bf2df2fb070$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $awajr = parcelRequire("awajr");
const $c8c43bf2df2fb070$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $c8c43bf2df2fb070$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $c8c43bf2df2fb070$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $c8c43bf2df2fb070$export$632685d741f3dbbf = {
    ...$c8c43bf2df2fb070$export$958d0ae7f2977ae4,
    ...$c8c43bf2df2fb070$export$d2dc61f58390201c
};
const $c8c43bf2df2fb070$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse',
    'color.rovo.background.brand.bold': 'color.text.inverse',
    'color.rovo.background.brand.bold.hovered': 'color.text.inverse',
    'color.rovo.background.brand.bold.pressed': 'color.text.inverse'
};
const $c8c43bf2df2fb070$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $c8c43bf2df2fb070$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F21, 0px 0px 1px #1E1F21)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F21, 0px 0px 1px #1E1F21)"
};
const $c8c43bf2df2fb070$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #F0F1F2)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
const $c8c43bf2df2fb070$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.lime.subtle': "var(--ds-border-accent-lime-subtle, #B3DF72)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.red.subtle': "var(--ds-border-accent-red-subtle, #FD9891)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.orange.subtle': "var(--ds-border-accent-orange-subtle, #FBC828)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.yellow.subtle': "var(--ds-border-accent-yellow-subtle, #EED12B)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.green.subtle': "var(--ds-border-accent-green-subtle, #7EE2B8)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.teal.subtle': "var(--ds-border-accent-teal-subtle, #9DD9EE)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.blue.subtle': "var(--ds-border-accent-blue-subtle, #8FB8F6)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.purple.subtle': "var(--ds-border-accent-purple-subtle, #D8A0F7)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.magenta.subtle': "var(--ds-border-accent-magenta-subtle, #F797D2)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.accent.gray.subtle': "var(--ds-border-accent-gray-subtle, #B7B9BE)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.danger.subtle': "var(--ds-border-danger-subtle, #FD9891)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.warning.subtle': "var(--ds-border-warning-subtle, #FBC828)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.success.subtle': "var(--ds-border-success-subtle, #B3DF72)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.discovery.subtle': "var(--ds-border-discovery-subtle, #D8A0F7)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.information.subtle': "var(--ds-border-information-subtle, #8FB8F6)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
const $c8c43bf2df2fb070$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #0515240F)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.subtle': "var(--ds-background-danger-subtle, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.subtle': "var(--ds-background-warning-subtle, #FBD779)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.subtle': "var(--ds-background-success-subtle, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.subtle': "var(--ds-background-discovery-subtle, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.subtle': "var(--ds-background-information-subtle, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.rovo.background.brand.bold': "var(--ds-rovo-background-brand-bold, #000000)",
    'color.rovo.background.brand.bold.hovered': "var(--ds-rovo-background-brand-bold-hovered, #1E1F21)",
    'color.rovo.background.brand.bold.pressed': "var(--ds-rovo-background-brand-bold-pressed, #292A2E)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.container': "var(--ds-surface-container, #F0F1F2)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $c8c43bf2df2fb070$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
const $c8c43bf2df2fb070$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
const $c8c43bf2df2fb070$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $c8c43bf2df2fb070$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $c8c43bf2df2fb070$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $c8c43bf2df2fb070$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 653 20px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 653 32px/36px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 653 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $c8c43bf2df2fb070$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $c8c43bf2df2fb070$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $c8c43bf2df2fb070$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $c8c43bf2df2fb070$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $c8c43bf2df2fb070$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $c8c43bf2df2fb070$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $c8c43bf2df2fb070$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $lqVX7.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $c8c43bf2df2fb070$export$e615f061ca585a6c = $c8c43bf2df2fb070$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7(spacingProperty, $c8c43bf2df2fb070$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $c8c43bf2df2fb070$export$bf46c3f9eeafc71f = $c8c43bf2df2fb070$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7(spacingProperty, $c8c43bf2df2fb070$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $c8c43bf2df2fb070$export$e7af83bafe7f9e63 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('backgroundColor', $c8c43bf2df2fb070$export$d1d79bf68ac056bd);
const $c8c43bf2df2fb070$export$3a1bcba60b23d7f0 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('color', $c8c43bf2df2fb070$export$8473307aa00d6ea1);
const $c8c43bf2df2fb070$export$45f3f4fe16f9f7d5 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('fontWeight', $c8c43bf2df2fb070$export$303e322c6b1ed114);
const $c8c43bf2df2fb070$export$68cc305da27dbaa4 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('fontFamily', $c8c43bf2df2fb070$export$3c7e9587132614b4);
const $c8c43bf2df2fb070$export$128f10c238242f83 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('font', $c8c43bf2df2fb070$export$6ffa317d5e70375);
const $c8c43bf2df2fb070$export$219d364c0da35ae4 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('font', $c8c43bf2df2fb070$export$236bfe3a33ef1292);
const $c8c43bf2df2fb070$export$38845ca010b93505 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('fontWeight', $c8c43bf2df2fb070$export$855cfd311192d666);
const $c8c43bf2df2fb070$export$ff257d957d48c421 = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7((0, $awajr.CURRENT_SURFACE_CSS_VAR), $c8c43bf2df2fb070$export$41a358c9c2356760);
const $c8c43bf2df2fb070$export$5e65a44e5b6ecadb = (color)=>$c8c43bf2df2fb070$export$41a358c9c2356760[color] !== undefined;
const $c8c43bf2df2fb070$export$7001ce64d9ff7c7f = $c8c43bf2df2fb070$export$ca0f9c2de39ffed7('font', $c8c43bf2df2fb070$export$b805719bc8cb376);

});
parcelRegister("awajr", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $10ac000af6c409cb$export$4ef52930e33717cd);
$parcel$export(module.exports, "SUBTREE_THEME_ATTRIBUTE", () => $10ac000af6c409cb$export$cb374d25ded7f6ab);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $10ac000af6c409cb$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $10ac000af6c409cb$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $10ac000af6c409cb$export$352e418ed5b6193a);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $10ac000af6c409cb$export$9d7b58831ae93caa);
const $10ac000af6c409cb$export$4ef52930e33717cd = 'data-theme';
const $10ac000af6c409cb$export$cb374d25ded7f6ab = 'data-subtree-theme';
const $10ac000af6c409cb$export$a00eac3f8684bcd0 = 'data-color-mode';
const $10ac000af6c409cb$export$2112803007239c61 = 'data-contrast-mode';
const $10ac000af6c409cb$export$352e418ed5b6193a = 'data-custom-theme';
const $10ac000af6c409cb$export$6f0c6fb8c80fcc92 = 'ds';
const $10ac000af6c409cb$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
const $10ac000af6c409cb$export$dddac1532e822863 = `--${$10ac000af6c409cb$export$6f0c6fb8c80fcc92}-token-not-found`;
const $10ac000af6c409cb$export$9d7b58831ae93caa = `--${$10ac000af6c409cb$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("2m8U6", function(module, exports) {
$parcel$export(module.exports, "parseXcss", () => $71b2989d6e5e436e$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $71b2989d6e5e436e$export$f6c783d06584602c);
/* xcss.tsx generated by @compiled/babel-plugin v0.37.1 */ /* xcss.tsx generated by @compiled/babel-plugin v0.37.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $fJeCl = parcelRequire("fJeCl");

var $3TFEq = parcelRequire("3TFEq");
const $71b2989d6e5e436e$export$9a199fbafee0014e = {
    backgroundColor: (0, $fJeCl.backgroundColorMap),
    blockSize: (0, $fJeCl.dimensionMap),
    borderBlockColor: (0, $fJeCl.borderColorMap),
    borderBlockEndColor: (0, $fJeCl.borderColorMap),
    borderBlockEndWidth: (0, $fJeCl.borderWidthMap),
    borderBlockStartColor: (0, $fJeCl.borderColorMap),
    borderBlockStartWidth: (0, $fJeCl.borderWidthMap),
    borderBlockWidth: (0, $fJeCl.borderWidthMap),
    borderBottomColor: (0, $fJeCl.borderColorMap),
    borderBottomLeftRadius: (0, $fJeCl.borderRadiusMap),
    borderBottomRightRadius: (0, $fJeCl.borderRadiusMap),
    borderBottomWidth: (0, $fJeCl.borderWidthMap),
    borderColor: (0, $fJeCl.borderColorMap),
    borderEndEndRadius: (0, $fJeCl.borderRadiusMap),
    borderEndStartRadius: (0, $fJeCl.borderRadiusMap),
    borderInlineColor: (0, $fJeCl.borderColorMap),
    borderInlineEndColor: (0, $fJeCl.borderColorMap),
    borderInlineEndWidth: (0, $fJeCl.borderWidthMap),
    borderInlineStartColor: (0, $fJeCl.borderColorMap),
    borderInlineStartWidth: (0, $fJeCl.borderWidthMap),
    borderInlineWidth: (0, $fJeCl.borderWidthMap),
    borderLeftColor: (0, $fJeCl.borderColorMap),
    borderLeftWidth: (0, $fJeCl.borderWidthMap),
    borderRadius: (0, $fJeCl.borderRadiusMap),
    borderRightColor: (0, $fJeCl.borderColorMap),
    borderRightWidth: (0, $fJeCl.borderWidthMap),
    borderStartEndRadius: (0, $fJeCl.borderRadiusMap),
    borderStartStartRadius: (0, $fJeCl.borderRadiusMap),
    borderTopColor: (0, $fJeCl.borderColorMap),
    borderTopLeftRadius: (0, $fJeCl.borderRadiusMap),
    borderTopRightRadius: (0, $fJeCl.borderRadiusMap),
    borderTopWidth: (0, $fJeCl.borderWidthMap),
    borderWidth: (0, $fJeCl.borderWidthMap),
    bottom: (0, $fJeCl.allSpaceMap),
    boxShadow: (0, $fJeCl.shadowMap),
    color: (0, $fJeCl.textColorMap),
    columnGap: (0, $fJeCl.positiveSpaceMap),
    font: (0, $fJeCl.fontMap),
    fontFamily: (0, $fJeCl.fontFamilyMap),
    fontWeight: (0, $fJeCl.fontWeightMap),
    gap: (0, $fJeCl.positiveSpaceMap),
    height: (0, $fJeCl.dimensionMap),
    inlineSize: (0, $fJeCl.dimensionMap),
    inset: (0, $fJeCl.allSpaceMap),
    insetBlock: (0, $fJeCl.allSpaceMap),
    insetBlockEnd: (0, $fJeCl.allSpaceMap),
    insetBlockStart: (0, $fJeCl.allSpaceMap),
    insetInline: (0, $fJeCl.allSpaceMap),
    insetInlineEnd: (0, $fJeCl.allSpaceMap),
    insetInlineStart: (0, $fJeCl.allSpaceMap),
    left: (0, $fJeCl.allSpaceMap),
    margin: (0, $fJeCl.allSpaceMap),
    marginBlock: (0, $fJeCl.allSpaceMap),
    marginBlockEnd: (0, $fJeCl.allSpaceMap),
    marginBlockStart: (0, $fJeCl.allSpaceMap),
    marginBottom: (0, $fJeCl.allSpaceMap),
    marginInline: (0, $fJeCl.allSpaceMap),
    marginInlineEnd: (0, $fJeCl.allSpaceMap),
    marginInlineStart: (0, $fJeCl.allSpaceMap),
    marginLeft: (0, $fJeCl.allSpaceMap),
    marginRight: (0, $fJeCl.allSpaceMap),
    marginTop: (0, $fJeCl.allSpaceMap),
    maxBlockSize: (0, $fJeCl.dimensionMap),
    maxHeight: (0, $fJeCl.dimensionMap),
    maxInlineSize: (0, $fJeCl.dimensionMap),
    maxWidth: (0, $fJeCl.dimensionMap),
    minBlockSize: (0, $fJeCl.dimensionMap),
    minHeight: (0, $fJeCl.dimensionMap),
    minInlineSize: (0, $fJeCl.dimensionMap),
    minWidth: (0, $fJeCl.dimensionMap),
    opacity: (0, $fJeCl.opacityMap),
    outlineColor: (0, $fJeCl.borderColorMap),
    outlineOffset: (0, $fJeCl.allSpaceMap),
    outlineWidth: (0, $fJeCl.borderWidthMap),
    padding: (0, $fJeCl.positiveSpaceMap),
    paddingBlock: (0, $fJeCl.positiveSpaceMap),
    paddingBlockEnd: (0, $fJeCl.positiveSpaceMap),
    paddingBlockStart: (0, $fJeCl.positiveSpaceMap),
    paddingBottom: (0, $fJeCl.positiveSpaceMap),
    paddingInline: (0, $fJeCl.positiveSpaceMap),
    paddingInlineEnd: (0, $fJeCl.positiveSpaceMap),
    paddingInlineStart: (0, $fJeCl.positiveSpaceMap),
    paddingLeft: (0, $fJeCl.positiveSpaceMap),
    paddingRight: (0, $fJeCl.positiveSpaceMap),
    paddingTop: (0, $fJeCl.positiveSpaceMap),
    right: (0, $fJeCl.allSpaceMap),
    rowGap: (0, $fJeCl.positiveSpaceMap),
    top: (0, $fJeCl.allSpaceMap),
    width: (0, $fJeCl.dimensionMap),
    zIndex: (0, $fJeCl.layerMap)
};
const $71b2989d6e5e436e$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $71b2989d6e5e436e$var$isSafeEnvToThrow = ()=>typeof $3TFEq === 'object' && typeof $3TFEq.env === 'object' && false;
const $71b2989d6e5e436e$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $71b2989d6e5e436e$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $71b2989d6e5e436e$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($71b2989d6e5e436e$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $71b2989d6e5e436e$var$safeSelectors.test(key)) {
            styleObj[key] = $71b2989d6e5e436e$var$transformStyles(value);
            return;
        }
        if ($71b2989d6e5e436e$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($71b2989d6e5e436e$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $71b2989d6e5e436e$export$9a199fbafee0014e)) return;
        const tokenValue = $71b2989d6e5e436e$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $71b2989d6e5e436e$var$baseXcss = (style)=>{
    const transformedStyles = $71b2989d6e5e436e$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$71b2989d6e5e436e$var$uniqueSymbol]: /*#__PURE__*/ (0, $lqVX7.css)(transformedStyles)
    };
};
const $71b2989d6e5e436e$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $71b2989d6e5e436e$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$71b2989d6e5e436e$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $71b2989d6e5e436e$export$f6c783d06584602c(style) {
    return $71b2989d6e5e436e$var$baseXcss(style);
}

});


parcelRegister("dEWOM", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd2a95d895bd0c1f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $2m8U6 = parcelRequire("2m8U6");

var $9Ix81 = parcelRequire("9Ix81");
const $fd2a95d895bd0c1f$var$flexGrowMap = {
    hug: (0, $2m8U6.xcss)({
        flexGrow: 0
    }),
    fill: (0, $2m8U6.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $fd2a95d895bd0c1f$var$separatorStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $fd2a95d895bd0c1f$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        css: $fd2a95d895bd0c1f$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $fd2a95d895bd0c1f$var$Inline = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $lqVX7.jsx)($fd2a95d895bd0c1f$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $4fqPo.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $fd2a95d895bd0c1f$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $9Ix81.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$fd2a95d895bd0c1f$var$Inline.displayName = 'Inline';
var $fd2a95d895bd0c1f$export$2e2bcd8739ae039 = $fd2a95d895bd0c1f$var$Inline;

});
parcelRegister("9Ix81", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e45acf533e2d17e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $fJeCl = parcelRequire("fJeCl");

var $2m8U6 = parcelRequire("2m8U6");
function $7e45acf533e2d17e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7e45acf533e2d17e$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $7e45acf533e2d17e$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $7e45acf533e2d17e$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $7e45acf533e2d17e$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $7e45acf533e2d17e$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $7e45acf533e2d17e$var$Flex = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $2m8U6.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lqVX7.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7e45acf533e2d17e$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $fJeCl.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $fJeCl.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $fJeCl.spaceStylesMap).rowGap[rowGap],
            alignItems && $7e45acf533e2d17e$var$alignItemsMap[alignItems],
            direction && $7e45acf533e2d17e$var$flexDirectionMap[direction],
            justifyContent && $7e45acf533e2d17e$var$justifyContentMap[justifyContent],
            wrap && $7e45acf533e2d17e$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$7e45acf533e2d17e$var$Flex.displayName = 'Flex';
var $7e45acf533e2d17e$export$2e2bcd8739ae039 = $7e45acf533e2d17e$var$Flex;

});


parcelRegister("jSEtp", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => (parcelRequire("pNj51")).MemoizedInsightIcon);

var $pNj51 = parcelRequire("pNj51");

});
parcelRegister("pNj51", function(module, exports) {
$parcel$export(module.exports, "MemoizedInsightIcon", () => $74ed057cd72da0f1$export$55641517b59933d7);

var $4fqPo = parcelRequire("4fqPo");

var $3KfT5 = parcelRequire("3KfT5");
var $aHUNw = parcelRequire("aHUNw");
var $5yLXq = parcelRequire("5yLXq");

var $hiZmN = parcelRequire("hiZmN");
const $74ed057cd72da0f1$var$ICON_SIZE = 'small';
const $74ed057cd72da0f1$var$sizeInPx = (0, $3KfT5.AVATAR_SIZES)[$74ed057cd72da0f1$var$ICON_SIZE];
// We want to reuse mediaClientConfigs across all InsightIcons to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $74ed057cd72da0f1$var$mediaClientConfigs = new Map();
const $74ed057cd72da0f1$var$getMediaClientConfig = ({ mediaJwtToken: mediaJwtToken, clientId: clientId, mediaBaseUrl: mediaBaseUrl })=>{
    const key = `${mediaJwtToken}:${clientId}:${mediaBaseUrl}`;
    if ($74ed057cd72da0f1$var$mediaClientConfigs.has(key)) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return $74ed057cd72da0f1$var$mediaClientConfigs.get(key);
    const mediaClientConfig = {
        authProvider: ()=>Promise.resolve({
                clientId: clientId,
                token: mediaJwtToken,
                baseUrl: mediaBaseUrl
            }),
        useSha256ForUploads: true
    };
    $74ed057cd72da0f1$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $74ed057cd72da0f1$var$hasAuth = ({ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, clientId: clientId })=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(clientId) && Boolean(fileId);
const $74ed057cd72da0f1$var$DefaultIcon = ()=>/*#__PURE__*/ $4fqPo.createElement((0, $aHUNw.default), {
        appearance: "square",
        size: "small"
    });
// Mimics logic from jira/src/packages/servicedesk/insight-common/insight-icon/src/ui/index.tsx
const $74ed057cd72da0f1$var$renderAvatar = (src)=>/*#__PURE__*/ $4fqPo.createElement("img", {
        loading: "lazy",
        src: src,
        width: $74ed057cd72da0f1$var$sizeInPx,
        height: $74ed057cd72da0f1$var$sizeInPx,
        alt: ""
    });
const $74ed057cd72da0f1$export$4f72cced31fa9b94 = (props)=>{
    const { fileId: fileId, iconUrl: iconUrl, MediaImage: MediaImage = (0, $hiZmN.MediaImageWithErrorBoundary) } = props;
    if (!$74ed057cd72da0f1$var$hasAuth({
        ...props
    }) || !MediaImage) {
        if (iconUrl) return $74ed057cd72da0f1$var$renderAvatar(iconUrl);
        return /*#__PURE__*/ $4fqPo.createElement($74ed057cd72da0f1$var$DefaultIcon, null);
    }
    const fileIdentifier = {
        id: fileId,
        mediaItemType: 'file'
    };
    const imageSize = {
        width: 24,
        height: 24
    };
    return /*#__PURE__*/ $4fqPo.createElement("div", null, /*#__PURE__*/ $4fqPo.createElement(MediaImage, {
        identifier: fileIdentifier,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        mediaClientConfig: $74ed057cd72da0f1$var$getMediaClientConfig(props),
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ $4fqPo.createElement((0, $5yLXq.default), {
            appearance: "square",
            size: "small"
        });
        if (error) return /*#__PURE__*/ $4fqPo.createElement($74ed057cd72da0f1$var$DefaultIcon, null);
        if (!data) return /*#__PURE__*/ $4fqPo.createElement($74ed057cd72da0f1$var$DefaultIcon, null);
        return /*#__PURE__*/ $4fqPo.createElement((0, $aHUNw.default), {
            src: data.src,
            appearance: "square",
            size: "small"
        });
    }));
};
const $74ed057cd72da0f1$export$55641517b59933d7 = /*#__PURE__*/ $4fqPo.memo($74ed057cd72da0f1$export$4f72cced31fa9b94);

});
parcelRegister("3KfT5", function(module, exports) {
$parcel$export(module.exports, "AVATAR_SIZES", () => $b64c5d0b05870b1c$export$9a270941bcff7e77);
const $b64c5d0b05870b1c$export$9a270941bcff7e77 = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};

});

parcelRegister("aHUNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe3203da68bdd9a5$export$2e2bcd8739ae039);
/* avatar.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $ew3Bn = parcelRequire("ew3Bn");

var $a4Rr2 = parcelRequire("a4Rr2");

var $91VkO = parcelRequire("91VkO");

var $hBlRJ = parcelRequire("hBlRJ");

var $5PUrk = parcelRequire("5PUrk");

var $lR2AF = parcelRequire("lR2AF");

var $gjf7e = parcelRequire("gjf7e");

var $lthL5 = parcelRequire("lthL5");

var $6Iy9U = parcelRequire("6Iy9U");

var $6L2se = parcelRequire("6L2se");
const $fe3203da68bdd9a5$var$packageName = undefined;
const $fe3203da68bdd9a5$var$packageVersion = undefined;
const $fe3203da68bdd9a5$var$containerStyles = null;
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ const $fe3203da68bdd9a5$var$Avatar = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ analyticsContext: analyticsContext, appearance: appearance = 'circle', label: label, borderColor: borderColor, children: children, href: href, isDisabled: isDisabled, name: name, onClick: onClick, presence: presence, size: sizeProp, src: src, stackIndex: stackIndex, status: status, target: target, testId: testId, as: AvatarContainer = 'div', isDecorative: isDecorative = false, imgLoading: imgLoading, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const context = (0, $6L2se.useAvatarContext)();
    const size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    const customPresenceNode = /*#__PURE__*/ (0, $4fqPo.isValidElement)(presence) ? presence : null;
    const customStatusNode = /*#__PURE__*/ (0, $4fqPo.isValidElement)(status) ? status : null;
    const isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    const lastAnalytics = (0, $4fqPo.useRef)(analyticsContext);
    const labelId = (0, $a4Rr2.useId)();
    (0, $4fqPo.useEffect)(()=>{
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    const onClickHandler = (0, $4fqPo.useCallback)((event)=>{
        if (isDisabled || typeof onClick !== 'function') return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $fe3203da68bdd9a5$var$packageName,
                packageVersion: $fe3203da68bdd9a5$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ const context = {
            componentName: 'avatar',
            packageName: $fe3203da68bdd9a5$var$packageName,
            packageVersion: $fe3203da68bdd9a5$var$packageVersion,
            ...lastAnalytics.current
        };
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    const isPresence = isValidIconSize && presence && !status;
    const isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    const defaultLabel = [
        name,
        isStatus && !customStatusNode && `(${status})`,
        isPresence && !customPresenceNode && `(${presence})`
    ].filter(Boolean).join(' ');
    const isInteractive = onClick || href || isDisabled || ariaHasPopup;
    const containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $4fqPo.createElement((0, $lR2AF.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $4fqPo.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $ltgDR.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5PUrk.AvatarContentContext).Provider, {
        value: {
            as: (0, $gjf7e.default)(isDisabled, href, onClick, ariaHasPopup),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? `${testId}--inner` : undefined,
            'aria-controls': ariaControls,
            'aria-expanded': ariaExpanded,
            'aria-haspopup': ariaHasPopup,
            avatarImage: /*#__PURE__*/ $4fqPo.createElement((0, $hBlRJ.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $4fqPo.createElement((0, $91VkO.AvatarContent), null)), isPresence && /*#__PURE__*/ $4fqPo.createElement((0, $lthL5.default), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $4fqPo.createElement((0, $6Iy9U.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId && `${testId}--label`,
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$fe3203da68bdd9a5$var$Avatar.displayName = 'Avatar';
var $fe3203da68bdd9a5$export$2e2bcd8739ae039 = $fe3203da68bdd9a5$var$Avatar;

});
parcelRegister("ltgDR", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa193724795b1382$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $fa193724795b1382$var$ATOMIC_GROUP_LENGTH = 5;
function $fa193724795b1382$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $fa193724795b1382$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("a4Rr2", function(module, exports) {
$parcel$export(module.exports, "useId", () => $6ff7c5dc97f82e3b$export$f680877a34711e37);

var $4fqPo = parcelRequire("4fqPo");
function $6ff7c5dc97f82e3b$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useId().replace(/[:«»]/g, '_');
}

});

parcelRegister("91VkO", function(module, exports) {
$parcel$export(module.exports, "AvatarContent", () => $c7953d1e7e8fa4f9$export$47fbc0b44cae5559);
/* avatar-content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3H4LK = parcelRequire("3H4LK");

var $5PUrk = parcelRequire("5PUrk");

var $ht9LU = parcelRequire("ht9LU");
const $c7953d1e7e8fa4f9$var$boxShadowCssVar = '--avatar-box-shadow';
const $c7953d1e7e8fa4f9$var$bgColorCssVar = '--avatar-bg-color';
const $c7953d1e7e8fa4f9$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    square: "_2rkol0p1",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $c7953d1e7e8fa4f9$var$unboundStyles = {
    rootCustomBorder: "_11q7cxp3",
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    hexagonFocusContainer: "_1rjc1wgn _18zr1dm9 _1mou5h37 _195g1ksc _bfhk1j28 _mkrz1k6g _1o9o1v1w",
    hexagonBorderContainerCustomBorder: "_11q7cxp3",
    hexagonBorderContainer: "_1rjcf6hp _18zruxly _1mou18m8 _195gzwb8 _bfhkcxp3 _mkrz1kw7 _1o9ovuon",
    hexagon: "_2rkoidpf _mkrz1kw7 _16qsn7od _14mjidpf _1ejjn7od _128midpf _4davidpf",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y",
    interactiveMotion: "_v5641krm _1llweo6y"
};
const $c7953d1e7e8fa4f9$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $c7953d1e7e8fa4f9$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children }, ref)=>{
    (0, $ht9LU.useEnsureIsInsideAvatar)();
    const { as: Container, appearance: appearance, avatarImage: avatarImage, borderColor: borderColor = "var(--ds-surface, #FFFFFF)", href: href, isDisabled: isDisabled, label: label, onClick: onClick, ref: contextRef, tabIndex: tabIndex, target: target, testId: testId, size: size, stackIndex: stackIndex, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup } = (0, $4fqPo.useContext)((0, $5PUrk.AvatarContentContext));
    const isInteractive = Boolean(onClick || href || isDisabled || ariaHasPopup);
    const renderedContent = /*#__PURE__*/ $4fqPo.createElement(Container, {
        style: {
            [$c7953d1e7e8fa4f9$var$bgColorCssVar]: borderColor,
            [$c7953d1e7e8fa4f9$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined,
        ...href && {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined
        },
        className: (0, $ltgDR.default)([
            $c7953d1e7e8fa4f9$var$unboundStyles.root,
            (0, $3H4LK.fg)('avatar-custom-border') && $c7953d1e7e8fa4f9$var$unboundStyles.rootCustomBorder,
            $c7953d1e7e8fa4f9$var$styles.root,
            appearance === 'square' && $c7953d1e7e8fa4f9$var$styles.square,
            appearance === 'circle' && $c7953d1e7e8fa4f9$var$styles.circle,
            appearance === 'hexagon' && $c7953d1e7e8fa4f9$var$unboundStyles.hexagon,
            $c7953d1e7e8fa4f9$var$widthHeightMap[size],
            stackIndex !== undefined && $c7953d1e7e8fa4f9$var$styles.positionRelative,
            isInteractive && !isDisabled && $c7953d1e7e8fa4f9$var$unboundStyles.interactive,
            isInteractive && !isDisabled && appearance !== 'hexagon' && (0, $3H4LK.fg)('platform-dst-motion-uplift') && $c7953d1e7e8fa4f9$var$unboundStyles.interactiveMotion,
            isDisabled && $c7953d1e7e8fa4f9$var$styles.disabled
        ])
    }, children || avatarImage);
    if (appearance !== 'hexagon') return renderedContent;
    // For a Hexagon Avatar in order to have hexagonal "border" and "outline", we have to
    // layer multiple elements and use their background colors to create the different layers.
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        style: {
            [$c7953d1e7e8fa4f9$var$bgColorCssVar]: borderColor,
            [$c7953d1e7e8fa4f9$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        "data-testid": testId ? `${testId}-hexagon-focus-container` : 'hexagon-focus-container',
        className: (0, $ltgDR.default)([
            $c7953d1e7e8fa4f9$var$unboundStyles.hexagonFocusContainer,
            isInteractive && !isDisabled && (0, $3H4LK.fg)('platform-dst-motion-uplift') && $c7953d1e7e8fa4f9$var$unboundStyles.interactiveMotion
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId ? `${testId}-hexagon-border-container` : 'hexagon-border-container',
        className: (0, $ltgDR.default)([
            $c7953d1e7e8fa4f9$var$unboundStyles.hexagonBorderContainer,
            (0, $3H4LK.fg)('avatar-custom-border') && $c7953d1e7e8fa4f9$var$unboundStyles.hexagonBorderContainerCustomBorder
        ])
    }, renderedContent));
});

});
parcelRegister("5PUrk", function(module, exports) {
$parcel$export(module.exports, "AvatarContentContext", () => $d4370bc8c511fc9d$export$b983474ddd0b6d28);

var $4fqPo = parcelRequire("4fqPo");
const $d4370bc8c511fc9d$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
const $d4370bc8c511fc9d$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $4fqPo.createContext)($d4370bc8c511fc9d$var$defaultAvatarContentProps);

});

parcelRegister("ht9LU", function(module, exports) {
$parcel$export(module.exports, "useEnsureIsInsideAvatar", () => $230f5b1945143e44$export$7db5c57474082dd9);

var $4fqPo = parcelRequire("4fqPo");

var $lR2AF = parcelRequire("lR2AF");
const $230f5b1945143e44$export$7db5c57474082dd9 = ()=>{
    const context = (0, $4fqPo.useContext)((0, $lR2AF.EnsureIsInsideAvatarContext));
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});
parcelRegister("lR2AF", function(module, exports) {
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", () => $5fbb7ea6a91d9ed8$export$6b4cbd90d24955ad);

var $4fqPo = parcelRequire("4fqPo");
const $5fbb7ea6a91d9ed8$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $4fqPo.createContext)(false);

});



parcelRegister("hBlRJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1dea42a4ed2f6f49$export$2e2bcd8739ae039);
/* avatar-image.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $7Guod = parcelRequire("7Guod");

var $e4a3t = parcelRequire("e4a3t");

var $1zza5 = parcelRequire("1zza5");
const $1dea42a4ed2f6f49$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq _bfhk7qp0",
    circle: "_2rko1rr0",
    hexagon: "_mkrz1k6g"
};
const $1dea42a4ed2f6f49$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rko12b0",
    large: "_2rko12b0",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
const $1dea42a4ed2f6f49$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ const $1dea42a4ed2f6f49$var$AvatarImage = ({ alt: alt = '', src: src, appearance: appearance, size: size, testId: testId, imgLoading: imgLoading })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $4fqPo.useState)(false);
    // If src changes, reset state
    (0, $4fqPo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) {
        let renderedIcon;
        switch(appearance){
            case 'circle':
                renderedIcon = /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($e4a3t))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--person`,
                    spacing: "spacious"
                });
                break;
            case 'hexagon':
                renderedIcon = /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Guod))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--agent`,
                    spacing: "spacious"
                });
                break;
            default:
            case 'square':
                renderedIcon = /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1zza5))), {
                    label: alt,
                    color: "var(--ds-icon-subtle, #505258)",
                    testId: testId && `${testId}--ship`,
                    spacing: "spacious"
                });
                break;
        }
        return /*#__PURE__*/ $4fqPo.createElement("span", {
            className: (0, $ltgDR.default)([
                $1dea42a4ed2f6f49$var$styles.icon,
                $1dea42a4ed2f6f49$var$nestedSvgStylesMap[size]
            ])
        }, renderedIcon);
    }
    return /*#__PURE__*/ $4fqPo.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? `${testId}--image` : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $ltgDR.default)([
            $1dea42a4ed2f6f49$var$styles.image,
            $1dea42a4ed2f6f49$var$borderRadiusMap[size],
            appearance === 'circle' && $1dea42a4ed2f6f49$var$styles.circle,
            appearance === 'hexagon' && $1dea42a4ed2f6f49$var$styles.hexagon
        ])
    });
};
var $1dea42a4ed2f6f49$export$2e2bcd8739ae039 = $1dea42a4ed2f6f49$var$AvatarImage;

});
parcelRegister("7Guod", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e079be55658218810235742dfafa5bd4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $59840768017261eb$var$_react = $59840768017261eb$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $59840768017261eb$var$_baseNew = $59840768017261eb$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $59840768017261eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiAgent".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Agent.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $59840768017261eb$var$AiAgentIcon = (props)=>/*#__PURE__*/ $59840768017261eb$var$_react.default.createElement($59840768017261eb$var$_baseNew.default, Object.assign({
        name: "AiAgentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.971.493a2 2 0 0 1 2.058 0l5 3A2 2 0 0 1 15 5.208v5.584a2 2 0 0 1-.971 1.715l-5 3a2 2 0 0 1-2.058 0l-5-3A2 2 0 0 1 1 10.792V5.208a2 2 0 0 1 .971-1.715zm1.286 1.286a.5.5 0 0 0-.514 0l-5 3a.5.5 0 0 0-.243.429v5.584a.5.5 0 0 0 .243.429l1.098.66a4.25 4.25 0 1 1 8.318 0l1.098-.66a.5.5 0 0 0 .243-.429V5.208a.5.5 0 0 0-.243-.429zM8 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5" clip-rule="evenodd"/>`
    }, props));
$59840768017261eb$var$AiAgentIcon.displayName = 'AiAgentIcon';
var $59840768017261eb$var$_default = module.exports.default = $59840768017261eb$var$AiAgentIcon;

});
parcelRegister("4yxM4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => (parcelRequire("1yi8B")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("1yi8B")).Icon);

var $1yi8B = parcelRequire("1yi8B");

});
parcelRegister("1yi8B", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $539147ef59d1f150$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $539147ef59d1f150$export$2e2bcd8739ae039);
/* icon-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $539147ef59d1f150$var$svgStyles = null;
const $539147ef59d1f150$var$iconStyles = null;
const $539147ef59d1f150$var$smallIconStyles = null;
const $539147ef59d1f150$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ const $539147ef59d1f150$var$baseHcmStyles = null;
const $539147ef59d1f150$var$scaleSize = null;
const $539147ef59d1f150$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $539147ef59d1f150$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
const $539147ef59d1f150$var$paddingMap = {
    medium: {
        none: 0,
        compact: 4,
        spacious: 4
    },
    small: {
        none: 0,
        compact: 2.66,
        spacious: 8
    }
};
const $539147ef59d1f150$export$f04a61298a47a40f = /*#__PURE__*/ (0, $4fqPo.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, spacing: spacing = 'none', name: name } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    let size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            const newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    const baseSize = 16;
    const viewBoxPadding = $539147ef59d1f150$var$paddingMap[size][spacing];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $ltgDR.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            size === 'small' && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $ltgDR.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : size === 'small' ? $539147ef59d1f150$var$coreSizeSmall[spacing] : $539147ef59d1f150$var$coreSizeMedium[spacing]
        ])
    }));
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$539147ef59d1f150$export$2e2bcd8739ae039 = $539147ef59d1f150$export$f04a61298a47a40f;

});



parcelRegister("e4a3t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a3d93d2103ec9f3a$var$_react = $a3d93d2103ec9f3a$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $a3d93d2103ec9f3a$var$_baseNew = $a3d93d2103ec9f3a$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $a3d93d2103ec9f3a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a3d93d2103ec9f3a$var$PersonIcon = (props)=>/*#__PURE__*/ $a3d93d2103ec9f3a$var$_react.default.createElement($a3d93d2103ec9f3a$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$a3d93d2103ec9f3a$var$PersonIcon.displayName = 'PersonIcon';
var $a3d93d2103ec9f3a$var$_default = module.exports.default = $a3d93d2103ec9f3a$var$PersonIcon;

});

parcelRegister("1zza5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $125455b0c612c112$var$_react = $125455b0c612c112$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $125455b0c612c112$var$_baseNew = $125455b0c612c112$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $125455b0c612c112$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $125455b0c612c112$var$ReleaseIcon = (props)=>/*#__PURE__*/ $125455b0c612c112$var$_react.default.createElement($125455b0c612c112$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$125455b0c612c112$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $125455b0c612c112$var$_default = module.exports.default = $125455b0c612c112$var$ReleaseIcon;

});


parcelRegister("gjf7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e767f1a33c528e$export$2e2bcd8739ae039);
const $30e767f1a33c528e$var$getCustomElement = (isDisabled, href, onClick, ariaHasPopup)=>{
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled || ariaHasPopup) return 'button';
    return 'span';
};
var $30e767f1a33c528e$export$2e2bcd8739ae039 = $30e767f1a33c528e$var$getCustomElement;

});

parcelRegister("lthL5", function(module, exports) {
$parcel$export(module.exports, "default", () => $72e994b41148b23b$export$2e2bcd8739ae039);
/* presence-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $ji4ji = parcelRequire("ji4ji");
const $72e994b41148b23b$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
const $72e994b41148b23b$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $72e994b41148b23b$var$circleIconOffsetMap = {
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
const $72e994b41148b23b$var$squareIconOffsetMap = {
    root: "_94n5myb0 _1xi2myb0"
};
const $72e994b41148b23b$var$hexagonIconOffsetMap = {
    small: "_94n51n1a _1xi21n1a",
    medium: "_94n51n1a _1xi21n1a",
    large: "_94n51y44 _1xi2myb0",
    xlarge: "_94n5l52n _1xi21lpd"
};
/**
 * __Presence wrapper__
 *
 * A presence wrapper is used internally to position presence ontop of the avatar.
 */ const $72e994b41148b23b$var$PresenceWrapper = ({ size: size, appearance: appearance, children: children, borderColor: borderColor, presence: presence, testId: testId })=>{
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--presence`,
        className: (0, $ltgDR.default)([
            $72e994b41148b23b$var$styles.root,
            $72e994b41148b23b$var$iconSizeMap[size],
            $72e994b41148b23b$var$circleIconOffsetMap[size],
            appearance === 'square' && $72e994b41148b23b$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $72e994b41148b23b$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ji4ji.default), {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};
var $72e994b41148b23b$export$2e2bcd8739ae039 = $72e994b41148b23b$var$PresenceWrapper;

});
parcelRegister("ji4ji", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ad52983f771504$export$2e2bcd8739ae039);
/* presence.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $g02lL = parcelRequire("g02lL");
const $e0ad52983f771504$var$BusyIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
const $e0ad52983f771504$var$FocusIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-icon-discovery, #AF59E1)",
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
const $e0ad52983f771504$var$OfflineIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
const $e0ad52983f771504$var$OnlineIndicator = /*#__PURE__*/ $4fqPo.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
});
function $e0ad52983f771504$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $e0ad52983f771504$var$BusyIndicator;
        case 'focus':
            return $e0ad52983f771504$var$FocusIndicator;
        case 'offline':
            return $e0ad52983f771504$var$OfflineIndicator;
        case 'online':
            return $e0ad52983f771504$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ const $e0ad52983f771504$var$AvatarPresence = ({ borderColor: borderColor, children: children, presence: presence })=>/*#__PURE__*/ $4fqPo.createElement((0, $g02lL.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $4fqPo.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e0ad52983f771504$var$getPresence(presence)) : children);
var $e0ad52983f771504$export$2e2bcd8739ae039 = $e0ad52983f771504$var$AvatarPresence;

});
parcelRegister("g02lL", function(module, exports) {
$parcel$export(module.exports, "default", () => $94cd0b1cbed9ca2d$export$2e2bcd8739ae039);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $94cd0b1cbed9ca2d$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1dm9 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
const $94cd0b1cbed9ca2d$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ const $94cd0b1cbed9ca2d$var$IconWrapper = ({ bgColor: bgColor, children: children })=>/*#__PURE__*/ $4fqPo.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $ltgDR.default)([
            $94cd0b1cbed9ca2d$var$styles.root,
            $94cd0b1cbed9ca2d$var$unboundStyles.root
        ])
    }, children);
var $94cd0b1cbed9ca2d$export$2e2bcd8739ae039 = $94cd0b1cbed9ca2d$var$IconWrapper;

});



parcelRegister("6Iy9U", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c27197c25de781a$export$2e2bcd8739ae039);
/* status-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $355d4 = parcelRequire("355d4");
const $1c27197c25de781a$var$styles = {
    root: "_kqswstnw"
};
const $1c27197c25de781a$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
const $1c27197c25de781a$var$circleIconOffsetMap = {
    small: "_rjxpidpf _152tidpf",
    medium: "_rjxpidpf _152tidpf",
    large: "_rjxpt94y _152tt94y",
    xlarge: "_rjxp1v6z _152t1v6z"
};
const $1c27197c25de781a$var$squareIconOffsetMap = {
    root: "_rjxpidpf _152tidpf"
};
const $1c27197c25de781a$var$hexagonIconOffsetMap = {
    small: "_rjxp1n1a _152t1n1a",
    medium: "_rjxp1n1a _152t1n1a",
    large: "_rjxpmyb0 _152t1y44",
    xlarge: "_rjxp1lpd _152tl52n"
};
/**
 * __Status wrapper__
 *
 * A status wrapper is used internally to position status on top of the avatar.
 */ const $1c27197c25de781a$var$StatusWrapper = ({ size: size, status: status, appearance: appearance, borderColor: borderColor, children: children, testId: testId })=>{
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && `${testId}--status`,
        className: (0, $ltgDR.default)([
            $1c27197c25de781a$var$styles.root,
            $1c27197c25de781a$var$iconSizeMap[size],
            $1c27197c25de781a$var$circleIconOffsetMap[size],
            appearance === 'square' && $1c27197c25de781a$var$squareIconOffsetMap.root,
            appearance === 'hexagon' && $1c27197c25de781a$var$hexagonIconOffsetMap[size]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $355d4.default), {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};
var $1c27197c25de781a$export$2e2bcd8739ae039 = $1c27197c25de781a$var$StatusWrapper;

});
parcelRegister("355d4", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d3f208c276b2296$export$2e2bcd8739ae039);
/* status.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $g02lL = parcelRequire("g02lL");
const $8d3f208c276b2296$var$ApprovedIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("circle", {
    fill: "var(--ds-icon-success, #6A9A23)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
const $8d3f208c276b2296$var$DeclinedIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("circle", {
    fill: "var(--ds-icon-danger, #C9372C)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
const $8d3f208c276b2296$var$LockedIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("circle", {
    fill: "var(--ds-text-subtlest, #6B6E76)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
const $8d3f208c276b2296$var$WarningIndicator = /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("circle", {
    fill: "var(--ds-icon-warning, #E06C00)",
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $4fqPo.createElement("path", {
    fill: "var(--ds-surface-overlay, #FFFFFF)",
    d: "M4,1.33333333 C4.36918944,1.33333333 4.66666667,1.63081056 4.66666667,2 L4.66666667,4 C4.66666667,4.36918944 4.36918944,4.66666667 4,4.66666667 C3.63081056,4.66666667 3.33333333,4.36918944 3.33333333,4 L3.33333333,2 C3.33333333,1.63081056 3.63081056,1.33333333 4,1.33333333 Z M4,5.33333333 C4.36918944,5.33333333 4.66666667,5.63081056 4.66666667,6 C4.66666667,6.36918944 4.36918944,6.66666667 4,6.66666667 C3.63081056,6.66666667 3.33333333,6.36918944 3.33333333,6 C3.33333333,5.63081056 3.63081056,5.33333333 4,5.33333333 Z"
}));
function $8d3f208c276b2296$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $8d3f208c276b2296$var$ApprovedIndicator;
        case 'declined':
            return $8d3f208c276b2296$var$DeclinedIndicator;
        case 'locked':
            return $8d3f208c276b2296$var$LockedIndicator;
        case 'warning':
            return $8d3f208c276b2296$var$WarningIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ const $8d3f208c276b2296$var$AvatarStatus = ({ borderColor: borderColor, children: children, status: status })=>/*#__PURE__*/ $4fqPo.createElement((0, $g02lL.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $4fqPo.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $8d3f208c276b2296$var$getStatus(status)) : children);
var $8d3f208c276b2296$export$2e2bcd8739ae039 = $8d3f208c276b2296$var$AvatarStatus;

});


parcelRegister("6L2se", function(module, exports) {
$parcel$export(module.exports, "useAvatarContext", () => $b8b51b6165e72154$export$b50b87a1c4086b23);

var $4fqPo = parcelRequire("4fqPo");

var $3i5Qc = parcelRequire("3i5Qc");
const $b8b51b6165e72154$export$b50b87a1c4086b23 = ()=>(0, $4fqPo.useContext)((0, $3i5Qc.AvatarContext));

});
parcelRegister("3i5Qc", function(module, exports) {
$parcel$export(module.exports, "AvatarContext", () => $4bce2a03f52af783$export$a20dad690e1279e2);

var $4fqPo = parcelRequire("4fqPo");
const $4bce2a03f52af783$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});



parcelRegister("5yLXq", function(module, exports) {
$parcel$export(module.exports, "default", () => $835494caef538ba9$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $835494caef538ba9$var$bgColorCssVar = '--avatar-skeleton-background-color';
const $835494caef538ba9$var$styles = {
    root: "_2rko1qll _189e1dm9 _1dqonqa1 _1h6d1j28 _1e0c1o8l _bfhk1r8p _tzy4nh7s",
    square: "_2rkol0p1",
    hexagon: "_mkrz1k6g",
    strongOpacity: "_tzy4clii"
};
const $835494caef538ba9$var$sizeStyles = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $835494caef538ba9$var$Skeleton = ({ size: size, appearance: appearance = 'circle', color: color, weight: weight })=>{
    const avatarSize = size ?? 'medium';
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        style: {
            [$835494caef538ba9$var$bgColorCssVar]: color ?? 'currentColor'
        },
        className: (0, $ltgDR.default)([
            $835494caef538ba9$var$styles.root,
            $835494caef538ba9$var$sizeStyles[avatarSize],
            appearance === 'square' && $835494caef538ba9$var$styles.square,
            appearance === 'hexagon' && $835494caef538ba9$var$styles.hexagon,
            weight === 'strong' && $835494caef538ba9$var$styles.strongOpacity
        ])
    });
};
var $835494caef538ba9$export$2e2bcd8739ae039 = $835494caef538ba9$var$Skeleton;

});

parcelRegister("hiZmN", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $9a277e7fea473c4f$export$758a2fef95a29ad0);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $f3wob = parcelRequire("f3wob");
const $9a277e7fea473c4f$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BYXH4.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, props.children({
            loading: false,
            error: true
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f3wob.MediaImageWithMediaClient), props));

});
parcelRegister("BYXH4", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $0722be8f42cb0c84$export$e926676385687eaf);
$parcel$export(module.exports, "withErrorBoundary", () => $0722be8f42cb0c84$export$f0c7a449e0cfaec7);

var $4fqPo = parcelRequire("4fqPo");
'use client';
const $0722be8f42cb0c84$export$b16d9fb1a22de840 = (0, $4fqPo.createContext)(null);
const $0722be8f42cb0c84$var$initialState = {
    didCatch: false,
    error: null
};
class $0722be8f42cb0c84$export$e926676385687eaf extends (0, $4fqPo.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $0722be8f42cb0c84$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($0722be8f42cb0c84$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $0722be8f42cb0c84$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($0722be8f42cb0c84$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $4fqPo.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $4fqPo.createElement)($0722be8f42cb0c84$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $0722be8f42cb0c84$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $0722be8f42cb0c84$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $0722be8f42cb0c84$export$c052f6604b7d51fe() {
    const context = (0, $4fqPo.useContext)($0722be8f42cb0c84$export$b16d9fb1a22de840);
    $0722be8f42cb0c84$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $4fqPo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $4fqPo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $0722be8f42cb0c84$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $4fqPo.forwardRef)((props, ref)=>(0, $4fqPo.createElement)($0722be8f42cb0c84$export$e926676385687eaf, errorBoundaryProps, (0, $4fqPo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}

});

parcelRegister("f3wob", function(module, exports) {
$parcel$export(module.exports, "MediaImageWithMediaClient", () => $cb6ccdd02c3168e5$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $jQcpc = parcelRequire("jQcpc");

var $fFjZu = parcelRequire("fFjZu");

var $3H4LK = parcelRequire("3H4LK");
const $cb6ccdd02c3168e5$var$copyDivStyles = null;
const $cb6ccdd02c3168e5$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $fFjZu.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview !== null && preview !== void 0 && preview.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview === null || preview === void 0 ? void 0 : preview.dataURI
        } : undefined
    }), (0, $3H4LK.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ $4fqPo.createElement("div", {
        ref: copyNodeRef,
        className: (0, $ltgDR.default)([
            "_1e0cglyw"
        ])
    }), getSsrScriptProps && /*#__PURE__*/ $4fqPo.createElement("script", getSsrScriptProps()));
};
const $cb6ccdd02c3168e5$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $4fqPo.useMemo)(()=>(0, $jQcpc.withMediaClient)($cb6ccdd02c3168e5$var$MediaImageBase), []);
    return /*#__PURE__*/ $4fqPo.createElement(MediaImageComponent, props);
};

});
parcelRegister("jQcpc", function(module, exports) {
$parcel$export(module.exports, "withMediaClient", () => $30a17c454ba4104a$export$9f7977d4a2561bee);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $2TUMI = parcelRequire("2TUMI");

var $dZ5TE = parcelRequire("dZ5TE");

var $glWLN = parcelRequire("glWLN");
const $30a17c454ba4104a$export$9f7977d4a2561bee = (Component)=>(0, $2TUMI.componentWithCondition)(()=>(0, $3H4LK.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $4fqPo.useContext)((0, $glWLN.MediaClientContext));
        const mediaClient = (0, $4fqPo.useMemo)(()=>existingMediaClient ?? (0, $dZ5TE.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $glWLN.MediaClientContext).Provider, {
            value: mediaClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
            ...otherProps,
            mediaClient: mediaClient
        }));
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $glWLN.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $glWLN.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $glWLN.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                })))));

});
parcelRegister("2TUMI", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $c25f6ae467698eeb$export$6e8ea24b15199873);

var $4fqPo = parcelRequire("4fqPo");
function $c25f6ae467698eeb$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});

parcelRegister("dZ5TE", function(module, exports) {
$parcel$export(module.exports, "getMediaClient", () => $cde9724ff39c464c$export$c9ecbc1b719fd417);

var $93MIR = parcelRequire("93MIR");
const $cde9724ff39c464c$export$f92e83e86b03c398 = new Map();
const $cde9724ff39c464c$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $93MIR.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $cde9724ff39c464c$export$f92e83e86b03c398.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $93MIR.MediaClient)(mediaClientConfig);
        $cde9724ff39c464c$export$f92e83e86b03c398.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};

});
parcelRegister("93MIR", function(module, exports) {
$parcel$export(module.exports, "MediaClient", () => $7b9b354ea33f524a$export$fba8b4ca6d386aec);

var $5bUc4 = parcelRequire("5bUc4");
parcelRequire("23MeP");
var $aSrSH = parcelRequire("aSrSH");

var $bXDb1 = parcelRequire("bXDb1");

var $furwc = parcelRequire("furwc");

var $cmgGQ = parcelRequire("cmgGQ");
parcelRequire("g2ABH");
var $4bbpy = parcelRequire("4bbpy");

class $7b9b354ea33f524a$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $4bbpy.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $bXDb1.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: (0, $aSrSH.ChunkHashAlgorithm).Sha256,
            authProviderTimeout: mediaClientConfig.authProviderTimeoutMs
        });
        this.config = mediaClientConfig;
        this.file = new (0, $furwc.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $5bUc4.EventEmitter2)();
        this.stargate = new (0, $cmgGQ.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
   * @internal
   */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getClientId(collectionName) {
        return this.mediaStore.getClientId(collectionName);
    }
    getClientIdSync() {
        return this.mediaStore.getClientIdSync();
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("P448X"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("5bUc4", function(module, exports) {
/*!
 * EventEmitter2
 * https://github.com/hij1nx/EventEmitter2
 *
 * Copyright (c) 2013 hij1nx
 * Licensed under the MIT license.
 */ 
var $3TFEq = parcelRequire("3TFEq");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $3TFEq !== 'undefined' && $3TFEq.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $3TFEq.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("23MeP", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => (parcelRequire("dgiEF")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("l5dca")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("l5dca")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("aSrSH")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $dgiEF = parcelRequire("dgiEF");

var $l5dca = parcelRequire("l5dca");

var $aSrSH = parcelRequire("aSrSH");

});
parcelRegister("dgiEF", function(module, exports) {
$parcel$export(module.exports, "mediaState", () => $aa345d0013ea0a92$export$8cef61637918b288);

var $5bUc4 = parcelRequire("5bUc4");

var $kU2in = parcelRequire("kU2in");
const $aa345d0013ea0a92$export$8cef61637918b288 = {
    streams: new (0, $kU2in.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $5bUc4.EventEmitter2)()
};

});
parcelRegister("kU2in", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("l5dca", function(module, exports) {
$parcel$export(module.exports, "isClientBasedAuth", () => $bac40099bd87554f$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $bac40099bd87554f$export$17f6055767a8d96a);
function $bac40099bd87554f$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $bac40099bd87554f$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $bac40099bd87554f$export$17f6055767a8d96a = (auth)=>{
    if ($bac40099bd87554f$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("aSrSH", function(module, exports) {
$parcel$export(module.exports, "ChunkHashAlgorithm", () => $9323d20b33626ed3$export$d3e73a50cc549c2e);
var $9323d20b33626ed3$export$d3e73a50cc549c2e = /*#__PURE__*/ function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha256"] = "sha256";
    return ChunkHashAlgorithm;
}({});

});


parcelRegister("bXDb1", function(module, exports) {
$parcel$export(module.exports, "MediaStore", () => $b56857c47681c19b$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $b56857c47681c19b$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $b56857c47681c19b$export$20f9315304dd6726);
parcelRequire("23MeP");
var $aSrSH = parcelRequire("aSrSH");
var $l5dca = parcelRequire("l5dca");

var $eb801 = parcelRequire("eb801");

var $53qET = parcelRequire("53qET");

var $6kTGv = parcelRequire("6kTGv");
var $dKFLb = parcelRequire("dKFLb");

var $j9DaD = parcelRequire("j9DaD");

var $a0l6w = parcelRequire("a0l6w");

var $dPMyc = parcelRequire("dPMyc");

var $igkDs = parcelRequire("igkDs");

var $5eZtk = parcelRequire("5eZtk");

var $3H4LK = parcelRequire("3H4LK");
const $b56857c47681c19b$var$MEDIA_API_REGION = 'media-api-region';
const $b56857c47681c19b$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $b56857c47681c19b$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': (params === null || params === void 0 ? void 0 : params['max-age']) ?? (0, $eb801.FILE_CACHE_MAX_AGE),
        allowAnimated: (params === null || params === void 0 ? void 0 : params.allowAnimated) ?? true,
        mode: (params === null || params === void 0 ? void 0 : params.mode) ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $eb801.MAX_RESOLUTION),
            height: (0, $eb801.MAX_RESOLUTION)
        } : {}
    };
};
const $b56857c47681c19b$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $b56857c47681c19b$var$cdnFeatureFlag = (endpoint)=>{
    let result = endpoint;
    if ((0, $a0l6w.isCDNEnabled)()) result += '/cdn';
    return result;
};
const $b56857c47681c19b$var$decodeJwtToken = (token)=>{
    return JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
};
class $b56857c47681c19b$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.getArtifactBinary = async (artifacts, artifactName, { collectionName: collectionName, abortController: abortController, maxAge: maxAge = (0, $eb801.FILE_CACHE_MAX_AGE), traceContext: traceContext })=>{
            const metadata = {
                method: 'GET',
                endpoint: `artifact-cdn-url`
            };
            const extendedTraceContext = (0, $j9DaD.extendTraceContext)(traceContext);
            const options = {
                ...metadata,
                traceContext: extendedTraceContext
            };
            const artifactUrl = await this.getArtifactURL(artifacts, artifactName, collectionName, maxAge);
            return (0, $dKFLb.request)(artifactUrl, options, abortController).then((0, $j9DaD.createMapResponseToBlob)(metadata));
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const metadata = {
                method: 'POST',
                endpoint: '/file/{fileId}/artifact/binary'
            };
            const headers = {
                Accept: 'application/json',
                'Content-Type': file.type
            };
            const extendedParams = {
                ...params,
                name: file.name,
                collection: collectionName
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                headers: headers,
                params: extendedParams,
                body: file,
                traceContext: traceContext
            };
            return this.request(`/file/${id}/artifact/binary`, options).then((0, $j9DaD.createMapResponseToJson)(metadata));
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            const metadata = {
                method: 'DELETE',
                endpoint: '/file/{fileId}/artifact/{artifactName}'
            };
            const authContext = {
                collectionName: collectionName,
                access: [
                    {
                        type: 'file',
                        id: id,
                        actions: [
                            'update'
                        ]
                    }
                ]
            };
            const options = {
                ...metadata,
                authContext: authContext,
                traceContext: traceContext,
                params: {
                    collection: collectionName
                }
            };
            await this.request(`/file/${id}/artifact/${artifactName}`, options);
        };
        this.resolveAuth = (authContext)=>(0, $dPMyc.resolveAuth)(this.config.authProvider, authContext, this.config.authProviderTimeout);
        this.resolveInitialAuth = ()=>(0, $dPMyc.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $aSrSH.ChunkHashAlgorithm).Sha256;
    }
    async getClientId(collectionName) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return $b56857c47681c19b$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
    }
    getClientIdSync() {
        try {
            const auth = this.resolveInitialAuth();
            return $b56857c47681c19b$export$572b8a2a9fd7cbba.extractClientIdFromAuth(auth);
        } catch  {
            // initialAuth may not be available, return undefined
            return undefined;
        }
    }
    static extractClientIdFromAuth(auth) {
        if ((0, $l5dca.isClientBasedAuth)(auth)) return auth.clientId;
        // decode JWT token and get clientId (or iss) from payload
        try {
            const jwtPayload = $b56857c47681c19b$var$decodeJwtToken(auth.token);
            return jwtPayload.clientId;
        } catch  {
        // leave clientId as undefined
        }
        return undefined;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const headers = {
            ...$b56857c47681c19b$var$jsonHeaders
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $3H4LK.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', requestOptions).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext, options) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const headers = {
            ...$b56857c47681c19b$var$jsonHeaders
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $3H4LK.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', requestOptions).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const wmv = (0, $3H4LK.fg)('confluence_watermark_admin_ui') ? (0, $5eZtk.getWatermarkVersionFromToken)(auth.token) : undefined;
        const options = {
            params: {
                ...$b56857c47681c19b$var$extendImageParams(params),
                ...wmv ? {
                    wmv: wmv
                } : {}
            },
            auth: auth
        };
        const imageEndpoint = $b56857c47681c19b$var$cdnFeatureFlag('image');
        if ((0, $igkDs.isPathBasedEnabled)()) return (0, $igkDs.mapToPathBasedUrl)((0, $j9DaD.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options));
        return (0, $a0l6w.mapToMediaCdnUrl)((0, $j9DaD.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options), auth.token);
    }
    async getFileBinary(id, collectionName, abortController, maxAge = (0, $eb801.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = $b56857c47681c19b$var$cdnFeatureFlag('binary');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options, abortController, true).then((0, $j9DaD.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $eb801.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = $b56857c47681c19b$var$cdnFeatureFlag('binary');
        if ((0, $igkDs.isPathBasedEnabled)()) return (0, $igkDs.mapToPathBasedUrl)((0, $j9DaD.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options));
        return (0, $a0l6w.mapToMediaCdnUrl)((0, $j9DaD.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options), auth.token);
    }
    async getArtifactURL(artifacts, artifactName, collectionName, maxAge = (0, $eb801.FILE_CACHE_MAX_AGE)) {
        // ----- WARNING ----------
        // DO NOT USE!!!!!
        // artifact.cdnUrl fails in Jira.
        // ----------------------------------
        // getArtifactURL returns a constructed url PATH, not the full Media/CDN Url.
        // We use the provided cdnUrl from metadata first.
        /* if (isCommercial() && fg('platform_media_cdn_delivery')) {
    	const cdnUrl = artifacts[artifactName]?.cdnUrl;
    	if (cdnUrl) {
    		return cdnUrl;
    	}
    } */ const artifactUrl = (0, $53qET.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const url = (0, $a0l6w.mapToMediaCdnUrl)((0, $j9DaD.createUrl)(`${auth.baseUrl}${artifactUrl}`, options), auth.token);
        if ((0, $igkDs.isPathBasedEnabled)()) return (0, $igkDs.mapToPathBasedUrl)(url);
        return url;
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = $b56857c47681c19b$var$cdnFeatureFlag('image');
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        let wmvParams = {};
        let authOptions = {
            authContext: {
                collectionName: params && params.collection
            }
        };
        if ((0, $3H4LK.fg)('confluence_watermark_admin_ui')) {
            const auth = await this.resolveAuth(authOptions.authContext);
            const wmv = (0, $5eZtk.getWatermarkVersionFromToken)(auth.token);
            if (wmv) wmvParams = {
                wmv: wmv
            };
            authOptions = {
                resolvedAuth: auth
            };
        }
        const options = {
            ...metadata,
            ...authOptions,
            params: {
                ...$b56857c47681c19b$var$extendImageParams(params, fetchMaxRes),
                ...wmvParams
            },
            headers: headers,
            traceContext: traceContext,
            addMediaClientParam: true
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller, true).then((0, $j9DaD.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext, includeHashForDuplicateFiles) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $b56857c47681c19b$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors,
                includeHashForDuplicateFiles: includeHashForDuplicateFiles
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    async getDocumentContent(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $b56857c47681c19b$var$cdnFeatureFlag('contents') : 'contents';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                pageStart: options.pageStart,
                pageEnd: options.pageEnd,
                'max-age': shouldCache ? (0, $eb801.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    async getDocumentPageImage(id, options, traceContext) {
        // when requesting for password protected document don't use CDN as it won't forward headers
        // this is deliberate to avoid caching Password protected files
        // Note: this should be removed once endpoint implements server side Cache-Control headers
        const shouldCache = !options.password;
        const endpoint = shouldCache ? $b56857c47681c19b$var$cdnFeatureFlag('page') : 'page';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/document/${endpoint}`
        };
        const headers = options.password ? {
            'x-document-authorization': `Basic ${options.password}`
        } : {};
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: options.collectionName
            },
            headers: headers,
            params: {
                collection: options.collectionName,
                page: options.page,
                zoom: options.zoom,
                'max-age': shouldCache ? (0, $eb801.FILE_CACHE_MAX_AGE) : 0
            },
            traceContext: traceContext
        };
        return this.request(`/file/${id}/document/${endpoint}`, requestOptions).then((0, $j9DaD.createMapResponseToBlob)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext, options) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const headers = {
            ...$b56857c47681c19b$var$jsonHeaders
        };
        if ((options === null || options === void 0 ? void 0 : options.expectedFileSize) !== undefined && (0, $3H4LK.fg)('platform_media_upload_expected_size_header')) headers['x-expected-size'] = options.expectedFileSize.toString();
        const requestOptions = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, requestOptions);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: // Contains collection name to write to
            params,
            // Contains collection name to write to
            headers: $b56857c47681c19b$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: // Contains collection name to read from
            traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    copyFile(id, params, traceContext, clientId) {
        const metadata = {
            method: 'POST',
            endpoint: '/v2/file/copy'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $b56857c47681c19b$var$jsonHeaders,
            body: JSON.stringify({
                id: id,
                clientId: clientId
            }),
            traceContext: traceContext,
            clientOptions: {
                retryOptions: {
                    shouldRetryError: (err)=>{
                        var _err$metadata;
                        return (0, $j9DaD.defaultShouldRetryError)(err) || (0, $6kTGv.isRequestError)(err) && (err === null || err === void 0 || (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode) === 401;
                    }
                }
            }
        };
        return this.request('/v2/file/copy', options).then((0, $j9DaD.createMapResponseToJson)(metadata));
    }
    async registerCopyIntents(files, traceContext, resolvedAuth) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/intents'
        };
        const options = {
            ...metadata,
            headers: $b56857c47681c19b$var$jsonHeaders,
            body: JSON.stringify({
                files: files
            }),
            traceContext: traceContext,
            resolvedAuth: resolvedAuth
        };
        await this.request('/file/copy/intents', options);
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller, useMediaCdn) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext, addMediaClientParam: addMediaClientParam, resolvedAuth: resolvedAuth } = options;
        const auth = resolvedAuth ?? await this.resolveAuth(authContext);
        const clientId = (0, $l5dca.isClientBasedAuth)(auth) ? auth.clientId : undefined;
        const extendedTraceContext = (0, $j9DaD.extendTraceContext)(traceContext);
        const extendedParams = addMediaClientParam ? {
            ...params,
            clientId: clientId
        } : params;
        let url = `${auth.baseUrl}${path}`;
        if (useMediaCdn) url = (0, $a0l6w.mapToMediaCdnUrl)(url, auth.token);
        if ((0, $igkDs.isPathBasedEnabled)()) url = (0, $igkDs.mapToPathBasedUrl)(url);
        const response = await (0, $dKFLb.request)(url, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: extendedParams,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $b56857c47681c19b$var$setKeyValueInSessionStorage($b56857c47681c19b$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $b56857c47681c19b$var$setKeyValueInSessionStorage($b56857c47681c19b$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    async testUrl(url, options = {}) {
        const { traceContext: traceContext } = options;
        await (0, $dKFLb.request)(url, {
            method: 'HEAD',
            traceContext: (0, $j9DaD.extendTraceContext)(traceContext),
            clientOptions: {
                retryOptions: {
                    maxAttempts: 1
                }
            }
        });
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $b56857c47681c19b$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $b56857c47681c19b$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $b56857c47681c19b$export$c8b741e18397852a = ()=>{
    return $b56857c47681c19b$var$getValueFromSessionStorage($b56857c47681c19b$var$MEDIA_API_ENVIRONMENT);
};
const $b56857c47681c19b$export$20f9315304dd6726 = ()=>{
    return $b56857c47681c19b$var$getValueFromSessionStorage($b56857c47681c19b$var$MEDIA_API_REGION);
};

});
parcelRegister("eb801", function(module, exports) {
$parcel$export(module.exports, "RECENTS_COLLECTION", () => $2df472c8316d0e4b$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $2df472c8316d0e4b$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $2df472c8316d0e4b$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $2df472c8316d0e4b$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $2df472c8316d0e4b$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $2df472c8316d0e4b$export$f14f521f3d306044);

var $8g3hT = parcelRequire("8g3hT");
const $2df472c8316d0e4b$export$860a16125e30000b = 'recents';
const $2df472c8316d0e4b$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $2df472c8316d0e4b$export$6e70f30e392bc53f = 4096;
const $2df472c8316d0e4b$export$c1abb8bab1e615cd = 5 * (0, $8g3hT.DATA_UNIT).MB;
const $2df472c8316d0e4b$export$3d5157f0def70e54 = 1000;
const $2df472c8316d0e4b$export$f14f521f3d306044 = 2 * (0, $8g3hT.DATA_UNIT).TB;

});
parcelRegister("8g3hT", function(module, exports) {
$parcel$export(module.exports, "isNotFoundMediaItemDetails", () => $bf70e2efc15feffa$export$fd27d7abbc4a746d);
$parcel$export(module.exports, "DATA_UNIT", () => $bf70e2efc15feffa$export$76cfea4c354af843);
const $bf70e2efc15feffa$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
const $bf70e2efc15feffa$export$fd27d7abbc4a746d = (itemDetails)=>{
    return 'type' in itemDetails && itemDetails.type === 'not-found';
};
var $bf70e2efc15feffa$export$76cfea4c354af843 = /*#__PURE__*/ function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
    return DATA_UNIT;
}({});

});


parcelRegister("53qET", function(module, exports) {
$parcel$export(module.exports, "getArtifactUrl", () => $7d6c8bb2e1b9e257$export$1cc24defa44e7f84);

var $a0l6w = parcelRequire("a0l6w");
const $7d6c8bb2e1b9e257$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    var _artifacts$prop, _artifacts$prop3;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if ((0, $a0l6w.isCDNEnabled)() && (_artifacts$prop = artifacts[prop]) !== null && _artifacts$prop !== void 0 && _artifacts$prop.url) {
        var _artifacts$prop2;
        return `${(_artifacts$prop2 = artifacts[prop]) === null || _artifacts$prop2 === void 0 ? void 0 : _artifacts$prop2.url}/cdn`;
    }
    return (_artifacts$prop3 = artifacts[prop]) === null || _artifacts$prop3 === void 0 ? void 0 : _artifacts$prop3.url;
};

});
parcelRegister("a0l6w", function(module, exports) {
$parcel$export(module.exports, "isCDNEnabled", () => $35e751220b7fed81$export$3e47d0e609e44278);
$parcel$export(module.exports, "mapToMediaCdnUrl", () => $35e751220b7fed81$export$fb88a576cf28364d);

var $3H4LK = parcelRequire("3H4LK");

var $2NvSC = parcelRequire("2NvSC");

var $gPrbw = parcelRequire("gPrbw");

var $gIyz6 = parcelRequire("gIyz6");

var $igkDs = parcelRequire("igkDs");
const $35e751220b7fed81$export$8a9b6ab3569a543a = {
    'api.media.atlassian.com': 'media-cdn.atlassian.com',
    'media.staging.atl-paas.net': 'media-cdn.stg.atlassian.com'
};
// Cloudfront has a hard limit of 8,192 bytes
// https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/cloudfront-limits.html
// Assuming other parts of the URL make up a max of ~1000 (in reality it's lower), the token can be ~7000
const $35e751220b7fed81$var$MEDIA_TOKEN_LENGTH_LIMIT = 7000;
function $35e751220b7fed81$export$3e47d0e609e44278() {
    return (0, $2NvSC.isCommercial)() && !(0, $gPrbw.isIsolatedCloud)() && !(0, $gIyz6.isGCPtenant)() && (0, $3H4LK.fg)('platform_media_cdn_delivery') && !(0, $igkDs.isPathBasedEnabled)();
}
function $35e751220b7fed81$export$fb88a576cf28364d(url, token) {
    const tokenLength = (token === null || token === void 0 ? void 0 : token.length) ?? 0;
    if (!$35e751220b7fed81$export$3e47d0e609e44278() || tokenLength > $35e751220b7fed81$var$MEDIA_TOKEN_LENGTH_LIMIT) return url;
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    if (!(0, $gIyz6.isGCPtenant)() && (0, $3H4LK.fg)('platform_media_cdn_delivery') && (0, $3H4LK.fg)('platform_media_cdn_single_host')) try {
        const parsedUrl = new URL(url);
        const cdnHost = $35e751220b7fed81$export$8a9b6ab3569a543a[parsedUrl.host];
        // If no mapping is found, return the original URL
        if (!cdnHost) return url;
        // Replace the host with the CDN host in the original URL
        parsedUrl.host = cdnHost;
        return parsedUrl.toString();
    } catch (error) {
        return url;
    }
    return url;
}

});
parcelRegister("2NvSC", function(module, exports) {
$parcel$export(module.exports, "isCommercial", () => $a0628d1f0ae75760$export$df69ff6733e73e50);
function $a0628d1f0ae75760$export$df69ff6733e73e50() {
    var _global$location;
    const global = globalThis;
    const perimeter = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (perimeter) // Note: reference to MICROS_PERIMETER can be found in: https://hello.atlassian.net/wiki/spaces/MICROS/pages/167212650/Runtime+configuration+environment+variables+and+adding+secrets#Micros-provided-variables
    return perimeter === 'commercial';
    // Return true if the current hostname does NOT match any of the forbidden patterns.
    return !((_global$location = global.location) !== null && _global$location !== void 0 && (_global$location = _global$location.hostname) !== null && _global$location !== void 0 && _global$location.match(/(atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net))/));
}

});

parcelRegister("gIyz6", function(module, exports) {
$parcel$export(module.exports, "isGCPtenant", () => $1e187f80a0b3c8e3$export$1e98abd71682b665);
/**
 * Returns true if the current hostname matches the GCP tenant pattern.
 * GCP tenants follow the pattern: <name>-cdp-<cdp-id>.jira-dev.com
 *
 * CDN (CloudFront) is an AWS service and is not available on GCP tenants.
 * This function is used to gate CDN delivery, mirroring the isIsolatedCloud() pattern.
 *
 * @param hostname - Optional hostname override (defaults to globalThis.location?.hostname). Used for testing.
 */ function $1e187f80a0b3c8e3$export$1e98abd71682b665(hostname) {
    var _location;
    const host = hostname ?? (typeof globalThis !== 'undefined' ? (_location = globalThis.location) === null || _location === void 0 ? void 0 : _location.hostname : undefined);
    if (!host) return false;
    const gcpTenantPattern = /^.*-cdp-\w+\.jira-dev\.com$/;
    return gcpTenantPattern.test(host);
}

});

parcelRegister("igkDs", function(module, exports) {
$parcel$export(module.exports, "isPathBasedEnabled", () => $b49ed0638fd0312f$export$6de3392754e98e65);
$parcel$export(module.exports, "mapToPathBasedUrl", () => $b49ed0638fd0312f$export$774e2add1fbe26aa);
$parcel$export(module.exports, "mapRetryUrlToPathBasedUrl", () => $b49ed0638fd0312f$export$e71b0af0000b3cfa);

var $3H4LK = parcelRequire("3H4LK");

var $8hqz7 = parcelRequire("8hqz7");
const $b49ed0638fd0312f$var$mediaApiPathPrefix = '/media-api';
function $b49ed0638fd0312f$var$getRelativeUrl(absoluteUrl) {
    const url = new URL(absoluteUrl);
    return `${url.pathname}${url.search}${url.hash}`;
}
function $b49ed0638fd0312f$export$6de3392754e98e65() {
    var _getDocument;
    const isLocalhost = ((_getDocument = (0, $8hqz7.default)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.location) === null || _getDocument === void 0 ? void 0 : _getDocument.hostname) === 'localhost';
    return (0, $3H4LK.fg)('platform_media_path_based_route') && !isLocalhost;
}
function $b49ed0638fd0312f$export$774e2add1fbe26aa(url) {
    if ($b49ed0638fd0312f$export$6de3392754e98e65()) {
        var _getDocument2;
        const parsedUrl = new URL(url);
        if (!parsedUrl.pathname.startsWith($b49ed0638fd0312f$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$b49ed0638fd0312f$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
        const location = (_getDocument2 = (0, $8hqz7.default)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.location;
        // in this case we are most likely in SSR / a non browser environment so just return a relative URL
        if (!location) return $b49ed0638fd0312f$var$getRelativeUrl(parsedUrl.toString());
        parsedUrl.host = location.host;
        return parsedUrl.toString();
    }
    return url;
}
function $b49ed0638fd0312f$export$e71b0af0000b3cfa(url) {
    var _getDocument3;
    const parsedUrl = new URL(url);
    parsedUrl.host = ((_getDocument3 = (0, $8hqz7.default)()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.location.host) ?? '';
    // remove CDN from the URL for retry if it exists
    const pathname = parsedUrl.pathname;
    if (pathname.endsWith('/cdn')) parsedUrl.pathname = pathname.replace('/cdn', '');
    if (!parsedUrl.pathname.startsWith($b49ed0638fd0312f$var$mediaApiPathPrefix)) parsedUrl.pathname = `${$b49ed0638fd0312f$var$mediaApiPathPrefix}${parsedUrl.pathname}`;
    return parsedUrl;
}

});
parcelRegister("8hqz7", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e47e1feca2c329$export$2e2bcd8739ae039);
var $68e47e1feca2c329$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});




parcelRegister("6kTGv", function(module, exports) {
$parcel$export(module.exports, "RequestError", () => $19cbca5cd11e758d$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $19cbca5cd11e758d$export$3717b1ffef4428ea);

var $5OUhX = parcelRequire("5OUhX");
class $19cbca5cd11e758d$export$43ee7d0e4f429743 extends (0, $5OUhX.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode, traceContext: traceContext } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            metadata: {
                traceContext: traceContext
            },
            innerError: innerError
        };
    }
}
function $19cbca5cd11e758d$export$3717b1ffef4428ea(err) {
    return err instanceof $19cbca5cd11e758d$export$43ee7d0e4f429743;
}

});
parcelRegister("5OUhX", function(module, exports) {
$parcel$export(module.exports, "BaseMediaClientError", () => $6f521121cd3c79ac$export$2b0aca14d61c3190);
$parcel$export(module.exports, "CommonMediaClientError", () => $6f521121cd3c79ac$export$e574d1724215079f);
$parcel$export(module.exports, "isCommonMediaClientError", () => $6f521121cd3c79ac$export$881f0f9bc813e1f3);
$parcel$export(module.exports, "toCommonMediaClientError", () => $6f521121cd3c79ac$export$a5db89cfc88eff9);
$parcel$export(module.exports, "fromCommonMediaClientError", () => $6f521121cd3c79ac$export$c2b89b9a32286816);

var $2iTAA = parcelRequire("2iTAA");
class $6f521121cd3c79ac$export$2b0aca14d61c3190 extends Error {
    constructor(reason, metadata, innerError){
        super(reason), this.reason = reason, this.metadata = metadata, this.innerError = innerError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $6f521121cd3c79ac$export$e574d1724215079f extends $6f521121cd3c79ac$export$2b0aca14d61c3190 {
    constructor(reason, metadata, innerError){
        super(reason, metadata, innerError);
    }
    get attributes() {
        return {
            reason: this.reason
        };
    }
}
function $6f521121cd3c79ac$export$881f0f9bc813e1f3(error) {
    if (!error) return false;
    // Check if the error is an instance of Error
    if (error instanceof $6f521121cd3c79ac$export$e574d1724215079f) return true;
    return typeof error.reason === 'string' && ('metadata' in error || error.metadata === undefined) && ('innerError' in error || error.innerError === undefined);
}
const $6f521121cd3c79ac$export$a5db89cfc88eff9 = (errorFileState)=>{
    var _errorFileState$detai;
    const error = (_errorFileState$detai = errorFileState.details) === null || _errorFileState$detai === void 0 ? void 0 : _errorFileState$detai.error;
    return new $6f521121cd3c79ac$export$e574d1724215079f((error === null || error === void 0 ? void 0 : error.reason) || 'unknown-reason', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
};
const $6f521121cd3c79ac$export$c2b89b9a32286816 = (id, occurrenceKey, error)=>{
    return {
        status: 'error',
        id: id,
        occurrenceKey: occurrenceKey,
        reason: error.reason,
        details: {
            /** Use this attr to translate back into CommonMediaClientError (toCommonMediaClientError) */ error: {
                reason: error === null || error === void 0 ? void 0 : error.reason,
                metadata: error === null || error === void 0 ? void 0 : error.metadata,
                innerError: error === null || error === void 0 ? void 0 : error.innerError
            },
            // Legacy details
            ...error === null || error === void 0 ? void 0 : error.attributes
        },
        message: error === null || error === void 0 ? void 0 : error.message
    };
};

});
parcelRegister("2iTAA", function(module, exports) {
$parcel$export(module.exports, "getMediaClientErrorReason", () => $f1fed6b23d03a8b3$export$c15d72765ee2baa4);
function $f1fed6b23d03a8b3$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $f1fed6b23d03a8b3$export$c15d72765ee2baa4(err) {
    return $f1fed6b23d03a8b3$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("dKFLb", function(module, exports) {
$parcel$export(module.exports, "request", () => $77d00d4c22722b6c$export$b5fe3f66a567bec0);

var $6kTGv = parcelRequire("6kTGv");

var $j9DaD = parcelRequire("j9DaD");

var $3H4LK = parcelRequire("3H4LK");

var $igkDs = parcelRequire("igkDs");

var $hJepC = parcelRequire("hJepC");
async function $77d00d4c22722b6c$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $j9DaD.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $j9DaD.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $j9DaD.createProcessFetchResponse)(metadata));
    if ((0, $3H4LK.fg)('platform_media_retry_edge_error')) {
        const shouldRetryError = (err)=>{
            var _getNavigator;
            if ((0, $j9DaD.isFetchNetworkError)(err) && (_getNavigator = (0, $hJepC.default)()) !== null && _getNavigator !== void 0 && _getNavigator.userAgent.includes('Edg/')) return false;
            return (0, $j9DaD.defaultShouldRetryError)(err);
        };
        try {
            return await (0, $j9DaD.fetchRetry)(doFetch, metadata, {
                ...retryOptions,
                shouldRetryError: shouldRetryError
            });
        } catch (error) {
            var _getNavigator2;
            if ((0, $j9DaD.isFetchNetworkError)(error) && (_getNavigator2 = (0, $hJepC.default)()) !== null && _getNavigator2 !== void 0 && _getNavigator2.userAgent.includes('Edg/')) {
                const doFetchWithPathBasedUrl = ()=>fetch((0, $j9DaD.createUrl)((0, $igkDs.mapRetryUrlToPathBasedUrl)(url).toString(), {
                        params: params
                    }), {
                        method: method,
                        body: body,
                        headers: (0, $j9DaD.extendHeaders)(headers, auth, traceContext),
                        signal: controller && controller.signal
                    }).then((0, $j9DaD.createProcessFetchResponse)(metadata));
                return (0, $j9DaD.fetchRetry)(doFetchWithPathBasedUrl, metadata, retryOptions);
            }
            throw error;
        }
    }
    return (0, $j9DaD.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("j9DaD", function(module, exports) {
$parcel$export(module.exports, "isFetchNetworkError", () => $0f1162b0657deaa7$export$ad8c5cf7dd4c3caf);
$parcel$export(module.exports, "extendTraceContext", () => $0f1162b0657deaa7$export$ee24a95986dfd173);
$parcel$export(module.exports, "createUrl", () => $0f1162b0657deaa7$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $0f1162b0657deaa7$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $0f1162b0657deaa7$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $0f1162b0657deaa7$export$5cc7b0795397da86);
$parcel$export(module.exports, "defaultShouldRetryError", () => $0f1162b0657deaa7$export$fee2242cbb339663);
$parcel$export(module.exports, "fetchRetry", () => $0f1162b0657deaa7$export$782df2acbe10b22c);
$parcel$export(module.exports, "createProcessFetchResponse", () => $0f1162b0657deaa7$export$6e2e477edb7d6032);
parcelRequire("23MeP");
var $l5dca = parcelRequire("l5dca");

var $50oso = parcelRequire("50oso");

var $2Zqgx = parcelRequire("2Zqgx");

var $6kTGv = parcelRequire("6kTGv");
const $0f1162b0657deaa7$var$getStatusCode = (error)=>{
    var _error$metadata;
    return (0, $6kTGv.isRequestError)(error) && ((_error$metadata = error.metadata) === null || _error$metadata === void 0 ? void 0 : _error$metadata.statusCode) && error.metadata.statusCode;
};
function $0f1162b0657deaa7$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $0f1162b0657deaa7$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $0f1162b0657deaa7$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $0f1162b0657deaa7$export$bc96a6a479480590(error) {
    const statusCode = error && $0f1162b0657deaa7$var$getStatusCode(error);
    return statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $0f1162b0657deaa7$export$ee24a95986dfd173 = (traceContext)=>traceContext ? {
        ...traceContext,
        spanId: (traceContext === null || traceContext === void 0 ? void 0 : traceContext.spanId) || (0, $50oso.getRandomTelemetryId)()
    } : undefined;
const $0f1162b0657deaa7$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $0f1162b0657deaa7$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$0f1162b0657deaa7$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$0f1162b0657deaa7$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $0f1162b0657deaa7$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $l5dca.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $0f1162b0657deaa7$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth === null || auth === void 0 ? void 0 : auth.baseUrl);
    const authParams = auth && (0, $2Zqgx.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.set(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $0f1162b0657deaa7$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$0f1162b0657deaa7$export$eaf4479116d2f925(auth),
        ...$0f1162b0657deaa7$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $0f1162b0657deaa7$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $6kTGv.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$0f1162b0657deaa7$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $0f1162b0657deaa7$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $6kTGv.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$0f1162b0657deaa7$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $0f1162b0657deaa7$export$fee2242cbb339663 = (err)=>{
    const statusCode = $0f1162b0657deaa7$var$getStatusCode(err);
    return $0f1162b0657deaa7$export$ad8c5cf7dd4c3caf(err) || (statusCode ? statusCode >= 500 : false);
};
const $0f1162b0657deaa7$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    // 1 second is generally a good timeout to start
    maxAttempts: 5,
    // Current test delay is 60s, so retries should finish before if a promise takes < 1s
    factor: 2 // Good for polling, which is out main use case
};
function $0f1162b0657deaa7$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $6kTGv.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $0f1162b0657deaa7$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$0f1162b0657deaa7$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor, shouldRetryError: shouldRetryError = $0f1162b0657deaa7$export$fee2242cbb339663 } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $0f1162b0657deaa7$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($0f1162b0657deaa7$export$de0b576cf7ce4a53(err)) throw new (0, $6kTGv.RequestError)('clientAbortedRequest', metadata, err);
        if (!shouldRetryError(err)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $6kTGv.isRequestError)(lastError)) throw $0f1162b0657deaa7$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $6kTGv.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $0f1162b0657deaa7$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 422:
            return 'serverUnprocessableEntity';
        case 423:
            return 'serverEntityLocked';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $0f1162b0657deaa7$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $0f1162b0657deaa7$export$6397609af718d008(statusCode);
    return new (0, $6kTGv.RequestError)(reason, {
        ...metadata,
        ...$0f1162b0657deaa7$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $0f1162b0657deaa7$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $0f1162b0657deaa7$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $0f1162b0657deaa7$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("50oso", function(module, exports) {
$parcel$export(module.exports, "isUndefined", () => $8ce9a55addfe9323$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $8ce9a55addfe9323$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $8ce9a55addfe9323$export$456b25e3a9b4a843);
$parcel$export(module.exports, "getRandomTelemetryId", () => $8ce9a55addfe9323$export$2e36de8639bad0ad);
const $8ce9a55addfe9323$export$fce6876652108ab = (value)=>value === undefined;
const $8ce9a55addfe9323$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $8ce9a55addfe9323$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $8ce9a55addfe9323$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $8ce9a55addfe9323$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $8ce9a55addfe9323$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $8ce9a55addfe9323$export$456b25e3a9b4a843(byte) {
    var _window;
    let randomHex;
    if ((_window = window) !== null && _window !== void 0 && _window.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $8ce9a55addfe9323$var$getRandomHexValues(byte);
    }
    else randomHex = $8ce9a55addfe9323$var$getRandomHexValues(byte);
    return randomHex;
}
function $8ce9a55addfe9323$export$2e36de8639bad0ad() {
    return $8ce9a55addfe9323$export$456b25e3a9b4a843(8);
}

});

parcelRegister("2Zqgx", function(module, exports) {
$parcel$export(module.exports, "mapAuthToQueryParameters", () => $09c1f2090d373ce9$export$6833b130611df767);
parcelRequire("23MeP");
var $l5dca = parcelRequire("l5dca");
function $09c1f2090d373ce9$export$6833b130611df767(auth) {
    if ((0, $l5dca.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});


parcelRegister("hJepC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e01fac909b722a18$export$2e2bcd8739ae039);
var $e01fac909b722a18$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.navigator === 'undefined') return;
    return window.navigator;
};

});


parcelRegister("dPMyc", function(module, exports) {
$parcel$export(module.exports, "resolveAuth", () => $9793eba4531653c6$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $9793eba4531653c6$export$5211e1371264aec3);

var $3H4LK = parcelRequire("3H4LK");

var $PE2aV = parcelRequire("PE2aV");

var $cJ21E = parcelRequire("cJ21E");

var $4lhjs = parcelRequire("4lhjs");
const $9793eba4531653c6$export$560085fe411c0660 = 10000;
const $9793eba4531653c6$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $9793eba4531653c6$export$560085fe411c0660)=>{
    const startTime = performance.now();
    let eventEmitted = false;
    // Feature flag: wrap authProvider with analytics event emission
    const authProviderPromise = (0, $3H4LK.fg)('platform_media_auth_provider_analytics') ? authProvider(authContext).then((result)=>{
        const durationMs = performance.now() - startTime;
        if (!eventEmitted) {
            eventEmitted = true;
            (0, $4lhjs.globalMediaEventEmitter).emit('auth-provider-succeeded', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext
            });
        } else {
            // Timeout already fired - auth arrived too late
            const timeoutError = new (0, $PE2aV.MediaStoreError)('authProviderTimedOut');
            (0, $4lhjs.globalMediaEventEmitter).emit('auth-provider-failed', {
                durationMs: durationMs,
                timeoutMs: authProviderTimeout,
                authContext: authContext,
                error: timeoutError
            });
        }
        return result;
    }).catch((error)=>{
        const durationMs = performance.now() - startTime;
        eventEmitted = true;
        (0, $4lhjs.globalMediaEventEmitter).emit('auth-provider-failed', {
            durationMs: durationMs,
            timeoutMs: authProviderTimeout,
            authContext: authContext,
            error: error
        });
        throw error;
    }) : authProvider(authContext); // Original behavior when FG off
    let auth;
    try {
        auth = await Promise.race([
            authProviderPromise,
            (0, $cJ21E.rejectTimeout)(authProviderTimeout, new (0, $PE2aV.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        // Mark as emitted so late arrivals are handled correctly by .then()/.catch()
        if (!eventEmitted && (0, $3H4LK.fg)('platform_media_auth_provider_analytics')) eventEmitted = true;
        // PRESERVE ORIGINAL ERROR HANDLING
        if (err instanceof (0, $PE2aV.MediaStoreError)) throw err;
        throw new (0, $PE2aV.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $PE2aV.MediaStoreError)('emptyAuth');
    /*
     We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
     Token expiration check in the frontend is a bad idea. Don't do it!
     More info:
     https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
     https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
   */ return auth;
};
const $9793eba4531653c6$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $PE2aV.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("PE2aV", function(module, exports) {
$parcel$export(module.exports, "MediaStoreError", () => $82c01a3af3534ad6$export$b78480bd311630bc);

var $5OUhX = parcelRequire("5OUhX");
class $82c01a3af3534ad6$export$b78480bd311630bc extends (0, $5OUhX.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason, undefined, innerError);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $82c01a3af3534ad6$export$8d2a9b675b2ce37a(err) {
    return err instanceof $82c01a3af3534ad6$export$b78480bd311630bc;
}

});

parcelRegister("cJ21E", function(module, exports) {
$parcel$export(module.exports, "rejectTimeout", () => $e616bd3c45129190$export$cf2d2a1124beacb2);
const $e616bd3c45129190$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e616bd3c45129190$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});

parcelRegister("4lhjs", function(module, exports) {
$parcel$export(module.exports, "globalMediaEventEmitter", () => $05faaf45ef07dba8$export$68d003d3105952ad);
parcelRequire("23MeP");
var $dgiEF = parcelRequire("dgiEF");
const $05faaf45ef07dba8$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $dgiEF.mediaState).eventEmitter) (0, $dgiEF.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $dgiEF.mediaState).eventEmitter) (0, $dgiEF.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $dgiEF.mediaState).eventEmitter) return (0, $dgiEF.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});


parcelRegister("5eZtk", function(module, exports) {
$parcel$export(module.exports, "getWatermarkVersionFromToken", () => $a492f7d01797db29$export$5296269cf74e58e);
function $a492f7d01797db29$export$5296269cf74e58e(token) {
    try {
        const parts = token.split('.');
        if (parts.length < 2) return undefined;
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.watermark) return undefined;
        const watermarkData = JSON.parse(payload.watermark);
        return watermarkData.v;
    } catch  {
        return undefined;
    }
}

});


parcelRegister("furwc", function(module, exports) {
$parcel$export(module.exports, "FileFetcherImpl", () => $8c0dd04dce40a039$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("glsOf")).FileFetcherError);

var $cGvOX = parcelRequire("cGvOX");

var $bWhgb = parcelRequire("bWhgb");

var $3izZW = parcelRequire("3izZW");
parcelRequire("23MeP");
var $l5dca = parcelRequire("l5dca");

var $3H4LK = parcelRequire("3H4LK");

var $a33RS = parcelRequire("a33RS");

var $bWMi4 = parcelRequire("bWMi4");

var $bXDb1 = parcelRequire("bXDb1");

var $lNtM5 = parcelRequire("lNtM5");

var $8g3hT = parcelRequire("8g3hT");

var $glsOf = parcelRequire("glsOf");

var $Q0N63 = parcelRequire("Q0N63");

var $lyZqA = parcelRequire("lyZqA");

var $4lhjs = parcelRequire("4lhjs");

var $eb801 = parcelRequire("eb801");

var $aS18s = parcelRequire("aS18s");

var $iy59X = parcelRequire("iy59X");

var $lbOv5 = parcelRequire("lbOv5");

var $dHXyx = parcelRequire("dHXyx");

var $b5l4D = parcelRequire("b5l4D");
var $jrXo2 = parcelRequire("jrXo2");

var $8sffc = parcelRequire("8sffc");

var $75NCN = parcelRequire("75NCN");

var $lGDUe = parcelRequire("lGDUe");

var $HK4A7 = parcelRequire("HK4A7");

var $aTvJC = parcelRequire("aTvJC");

var $2rTxf = parcelRequire("2rTxf");
parcelRequire("g2ABH");
var $4bbpy = parcelRequire("4bbpy");

var $ghScr = parcelRequire("ghScr");

var $j9DaD = parcelRequire("j9DaD");

var $5OUhX = parcelRequire("5OUhX");
const $8c0dd04dce40a039$var$isCopySourceFileWithToken = (token)=>!!token.authProvider;
const $8c0dd04dce40a039$var$isCopyDestinationWithToken = (token)=>!!token.authProvider;
class $8c0dd04dce40a039$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $4bbpy.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>{
            if ((0, $5OUhX.isCommonMediaClientError)(error)) return (0, $5OUhX.fromCommonMediaClientError)(id, occurrenceKey, error);
            // ________________________________________________
            // Legacy serializers
            // We need to revisit all the incoming error types and ensure all the "reason" values are known
            // We need to change the input error: any for a known type.
            if (typeof error === 'string') {
                const err = new (0, $5OUhX.CommonMediaClientError)(error);
                return (0, $5OUhX.fromCommonMediaClientError)(id, occurrenceKey, err);
            } else {
                const err = new (0, $5OUhX.CommonMediaClientError)((error === null || error === void 0 ? void 0 : error.reason) || 'unknown', error === null || error === void 0 ? void 0 : error.metadata, error === null || error === void 0 ? void 0 : error.innerError);
                return (0, $5OUhX.fromCommonMediaClientError)(id, occurrenceKey, err);
            }
        };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        // TODO: ----- ADD TICKET TO PASS TRACE ID to this.dataloader.load
        this.createDownloadFileStream = (id, collectionName, occurrenceKey, includeHashForDuplicateFiles, forceRefresh, initialFileState)=>{
            const subject = (0, $75NCN.createMediaSubject)(initialFileState);
            const poll = new (0, $aTvJC.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                if (!forceRefresh && (initialFileState === null || initialFileState === void 0 ? void 0 : initialFileState.status) === 'processed') {
                    subject.complete();
                    return;
                }
                if (forceRefresh) this.dataloader.clear({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName,
                    includeHashForDuplicateFiles: includeHashForDuplicateFiles
                });
                if ((0, $8g3hT.isNotFoundMediaItemDetails)(response)) throw new (0, $glsOf.FileFetcherError)('emptyItems', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                if ((0, $2rTxf.isEmptyFile)(response)) throw new (0, $glsOf.FileFetcherError)('zeroVersionFile', {
                    id: id,
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey,
                    traceContext: response.metadataTraceContext
                });
                const fileState = (0, $lNtM5.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $dHXyx.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' // name property is not available in base64 image
             } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $iy59X.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.uploadArtifact = async (id, file, params, collectionName, traceContext)=>{
            const { data: data } = await this.mediaApi.uploadArtifact(id, file, params, collectionName, traceContext);
            /* TEMPORARYLY PULLING NEW METADATA till the endpoint is fixed */ const { data: altData } = await this.mediaApi.getItems([
                id
            ], collectionName, traceContext);
            const itemDetails = altData.items[0].details;
            // ------------------------------------------------------------
            this.setFileState(id, (0, $lNtM5.mapMediaItemToFileState)(id, itemDetails));
            return data;
        };
        this.deleteArtifact = async (id, artifactName, collectionName, traceContext)=>{
            await this.mediaApi.deleteArtifact(id, artifactName, collectionName, traceContext);
            // Manually remove the artifact from file state instead of re-requesting the entire payload.
            const file = this.store.getState().files[id];
            if (file && file.status === 'processed' && file.artifacts) {
                const updatedArtifacts = {
                    ...file.artifacts
                };
                delete updatedArtifacts[artifactName];
                const updatedFileState = {
                    ...file,
                    artifacts: updatedArtifacts
                };
                this.setFileState(id, updatedFileState);
            }
        };
        this.getOrFetchFileState = async (id, collectionName)=>{
            let fileState = this.store.getState().files[id];
            return fileState ?? await this.getCurrentState(id, {
                collectionName: collectionName
            });
        };
        this.getDurationOfVideo = async (id, collectionName)=>{
            var _fileState$mediaMetad;
            const fileState = await this.getOrFetchFileState(id, collectionName);
            if (fileState.status !== 'processed' || fileState.mediaType !== 'video' || !fileState.artifacts['video.mp4']) throw new Error('File is not a video');
            if ('mediaMetadata' in fileState && (_fileState$mediaMetad = fileState.mediaMetadata) !== null && _fileState$mediaMetad !== void 0 && _fileState$mediaMetad.duration) return fileState.mediaMetadata.duration;
            // If the duration is not present, we need to fetch it from the artifact
            const artifactUrlString = await this.getArtifactURL(fileState.artifacts, 'video.mp4', collectionName);
            const artifactUrl = new URL(artifactUrlString);
            const artifactPath = `${artifactUrl.pathname}${artifactUrl.search}`;
            const res = await this.mediaApi.request(artifactPath, {
                headers: {
                    Range: 'bytes=0-199'
                }
            });
            // Get the response as ArrayBuffer
            const arrayBuffer = await res.arrayBuffer();
            const uint8Array = new Uint8Array(arrayBuffer);
            const mvhdBytes = new Uint8Array([
                109,
                118,
                104,
                100
            ]); // "mvhd" in ASCII
            let mvhdIndex = -1;
            for(let i = 0; i <= uint8Array.length - mvhdBytes.length; i++){
                mvhdIndex = i;
                for(let j = 0; j < mvhdBytes.length; j++)if (uint8Array[i + j] !== mvhdBytes[j]) {
                    mvhdIndex = -1;
                    break;
                }
                if (mvhdIndex !== -1) break;
            }
            if (mvhdIndex === -1) throw new Error('Unable to find mvhd bytes');
            // Create DataView for reading big-endian integers
            const dataView = new DataView(arrayBuffer);
            const start = mvhdIndex + 16; // Skip atom header and version/flags
            // Check if we have enough bytes to read timescale and duration
            if (start + 8 > arrayBuffer.byteLength) return 0;
            // flase as second parameter indicates big-endian 32-bit integers
            const timeScale = dataView.getUint32(start, false);
            const duration = dataView.getUint32(start + 4, false);
            if (timeScale === 0) throw new Error('Timescale is invalid');
            // get the video length in seconds
            const videoLength = Math.floor(duration / timeScale);
            return videoLength;
        };
        this.getVideoDurations = async (files)=>{
            // get all the duration promises
            const promises = files.map(async ({ id: id, collectionName: collectionName })=>{
                try {
                    return await this.getDurationOfVideo(id, collectionName);
                } catch  {
                    return -1;
                }
            });
            const durations = await Promise.all(promises);
            // only return the durations that are present;
            return durations.reduce((acc, curr, i)=>{
                if (curr !== -1) {
                    const id = files[i].id;
                    acc[id] = curr;
                }
                return acc;
            }, {});
        };
        this.dataloader = (0, $aS18s.createFileDataloader)(mediaApi);
        this.copyIntentRegisterationBatcher = (0, $ghScr.createCopyIntentRegisterationBatcher)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey, includeHashForDuplicateFiles: includeHashForDuplicateFiles, forceRefresh: forceRefresh, initialFileState: initialFileState } = options;
        if (!(0, $a33RS.isValidUuid)(id)) {
            // Do NOT pass initialFileState here — for an invalid UUID the SSR seed
            // is meaningless and would cause subscribers to briefly see a
            // valid-looking file state before the error is emitted.
            const subject = (0, $75NCN.createMediaSubject)();
            const err = new (0, $glsOf.FileFetcherError)('invalidFileId', {
                id: id,
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $b5l4D.fromObservable)(subject);
        }
        if (forceRefresh) (0, $lyZqA.getFileStreamsCache)().remove(id);
        return (0, $b5l4D.fromObservable)((0, $lyZqA.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName, undefined, includeHashForDuplicateFiles, forceRefresh, initialFileState);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $jrXo2.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext, expectedFileSize) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext, {
            expectedFileSize: expectedFileSize
        }).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext, expectedFileSize) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($3izZW)))();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($3izZW)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext, expectedFileSize).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext, anonymizeFilename) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $75NCN.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = anonymizeFilename && (0, $3H4LK.fg)('platform_media_upload_external_anonymize_filename') ? crypto.randomUUID() : url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $lyZqA.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $lGDUe.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $8sffc.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                mimeType: type,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext, file.size);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $75NCN.createMediaSubject)();
        (0, $lyZqA.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $cGvOX.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $bWhgb.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $lbOv5.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $Q0N63.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller === null || controller === void 0 || controller.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $b5l4D.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName, traceContext) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $bWMi4.downloadUrl)(url, {
            name: name
        });
        (0, $4lhjs.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $eb801.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
        // Test the download after initiated the Browser process to catch any potential errors.
        await this.mediaApi.testUrl(url, {
            traceContext: traceContext
        });
    }
    async registerCopyIntent(id, collectionName) {
        // pre-resolving auth to add it to the key
        const auth = await this.mediaApi.resolveAuth({
            collectionName: collectionName
        });
        const key = {
            id: id,
            collectionName: collectionName,
            resolvedAuth: auth
        };
        const error = await this.copyIntentRegisterationBatcher.load(key);
        if (error) {
            // if the error is retryable then it should not be cached
            if ((0, $j9DaD.defaultShouldRetryError)(error)) this.copyIntentRegisterationBatcher.clear(key);
            throw error;
        }
    }
    async copyFileWithToken(source, destination, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const mediaStore = destination.mediaStore || new (0, $bXDb1.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $l5dca.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const { data: data } = await mediaStore.copyFileWithToken(body, params, traceContext);
        return data;
    }
    async copyFileWithIntent(source, destination, traceContext) {
        const res = await this.mediaApi.copyFile(source.id, {
            sourceCollection: source.collection,
            collection: destination.collection,
            replaceFileId: destination.replaceFileId
        }, traceContext, source.clientId);
        const { data: data } = res;
        return data;
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { id: id } = source;
        const { collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const cache = (0, $lyZqA.getFileStreamsCache)();
        let processingSubscription;
        try {
            let copiedFile;
            if ($8c0dd04dce40a039$var$isCopySourceFileWithToken(source) && $8c0dd04dce40a039$var$isCopyDestinationWithToken(destination)) copiedFile = await this.copyFileWithToken(source, destination, traceContext);
            else copiedFile = await this.copyFileWithIntent(source, destination, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $lGDUe.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $lNtM5.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $75NCN.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $lNtM5.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $lNtM5.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $HK4A7.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $lbOv5.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $lbOv5.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $lNtM5.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $lNtM5.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $lNtM5.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $lyZqA.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $75NCN.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("bWhgb", function(module, exports) {
"use strict";
var $8b127ff63cef8734$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $8b127ff63cef8734$var$map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        return source.lift(new $8b127ff63cef8734$var$MapOperator(project, thisArg));
    };
}
module.exports.map = $8b127ff63cef8734$var$map;
var $8b127ff63cef8734$var$MapOperator = function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8b127ff63cef8734$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
module.exports.MapOperator = $8b127ff63cef8734$var$MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8b127ff63cef8734$var$MapSubscriber = function(_super) {
    $8b127ff63cef8734$var$__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}($kVbBc.Subscriber);

});

parcelRegister("a33RS", function(module, exports) {
$parcel$export(module.exports, "isValidUuid", () => $ae2a03a5f5fc18ab$export$6ad459db9a6bcc76);
const $ae2a03a5f5fc18ab$var$BASIC_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const $ae2a03a5f5fc18ab$export$6ad459db9a6bcc76 = (value)=>{
    if (typeof value !== 'string') return false;
    const normalizedValue = value.toLowerCase();
    if (!$ae2a03a5f5fc18ab$var$BASIC_UUID_REGEX.test(normalizedValue)) return false;
    const version = normalizedValue[14];
    if (version === '1' || version === '2') return true;
    if (version === '3' || version === '4' || version === '5') {
        const variant = normalizedValue[19];
        return variant === '8' || variant === '9' || variant === 'a' || variant === 'b';
    }
    return false;
};

});

parcelRegister("bWMi4", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $21406b97324cb58d$export$8a96edb1c96563f4);
const $21406b97324cb58d$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("lNtM5", function(module, exports) {
$parcel$export(module.exports, "isUploadingFileState", () => $16579a7db6372a3c$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $16579a7db6372a3c$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $16579a7db6372a3c$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $16579a7db6372a3c$export$f863e1e09c8a926);
$parcel$export(module.exports, "isFinalFileState", () => $16579a7db6372a3c$export$270b3fc27120edd0);
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $16579a7db6372a3c$export$8f33148a37b0c72f);
$parcel$export(module.exports, "hasArtifacts", () => $16579a7db6372a3c$export$ecdf3dee1d148302);
$parcel$export(module.exports, "isImageRepresentationReady", () => $16579a7db6372a3c$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $16579a7db6372a3c$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $16579a7db6372a3c$export$ea3730792e8bebfb);
const $16579a7db6372a3c$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $16579a7db6372a3c$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $16579a7db6372a3c$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $16579a7db6372a3c$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $16579a7db6372a3c$export$92dd692b31e42e64 = (fileState)=>!$16579a7db6372a3c$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $16579a7db6372a3c$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $16579a7db6372a3c$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);
const $16579a7db6372a3c$export$ecdf3dee1d148302 = (fileState)=>'artifacts' in fileState && fileState.artifacts !== undefined;
const $16579a7db6372a3c$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $16579a7db6372a3c$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext, hash: hash, abuseClassification: abuseClassification, mediaMetadata: mediaMetadata, failReason: failReason, previewCdnUrl: previewCdnUrl } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        hash: hash,
        metadataTraceContext: metadataTraceContext,
        abuseClassification: abuseClassification,
        mediaMetadata: mediaMetadata,
        previewCdnUrl: previewCdnUrl
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing',
                failReason: failReason
            };
    }
};
const $16579a7db6372a3c$export$ea3730792e8bebfb = (id, item)=>{
    return $16579a7db6372a3c$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("glsOf", function(module, exports) {
$parcel$export(module.exports, "FileFetcherError", () => $b9319914b2b195e0$export$e3e60f0dab8641de);

var $5OUhX = parcelRequire("5OUhX");
class $b9319914b2b195e0$export$e3e60f0dab8641de extends (0, $5OUhX.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey, traceContext: traceContext } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            ...traceContext && {
                metadata: {
                    traceContext: traceContext
                }
            }
        };
    }
}
function $b9319914b2b195e0$export$5c3435f75ce0ce70(err) {
    return err instanceof $b9319914b2b195e0$export$e3e60f0dab8641de;
}

});

parcelRegister("Q0N63", function(module, exports) {
$parcel$export(module.exports, "uploadFile", () => $fa34252f751d43e1$export$a5575dbeeffdad98);

var $BiKkb = parcelRequire("BiKkb");

var $5wVlw = parcelRequire("5wVlw");

var $1PoKX = parcelRequire("1PoKX");

var $lXc1j = parcelRequire("lXc1j");

var $3tJ5e = parcelRequire("3tJ5e");

var $eb801 = parcelRequire("eb801");

var $isG6a = parcelRequire("isG6a");
const $fa34252f751d43e1$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $lXc1j.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $fa34252f751d43e1$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $fa34252f751d43e1$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext, size)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $fa34252f751d43e1$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext, {
            expectedFileSize: size
        });
        offset += chunks.length;
    };
};
const $fa34252f751d43e1$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext, {
        expectedFileSize: file.size
    });
};
const $fa34252f751d43e1$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $eb801.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $isG6a.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $isG6a.fileSizeError)) callbacks === null || callbacks === void 0 || callbacks.onUploadFinish(new (0, $3tJ5e.UploaderError)(err.message, {
            id: id,
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks === null || callbacks === void 0 || callbacks.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $BiKkb.chunkinator)(content, {
        hashingFunction: (blob)=>$fa34252f751d43e1$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $fa34252f751d43e1$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $eb801.PROCESSING_BATCH_SIZE),
        processingFunction: $fa34252f751d43e1$var$createProcessingFunction(store, deferredUploadId, collection, traceContext, file.size)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $5wVlw.from)(deferredUploadId).pipe((0, $1PoKX.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $1PoKX.concatMap)(()=>(0, $5wVlw.from)($fa34252f751d43e1$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $fa34252f751d43e1$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("BiKkb", function(module, exports) {
$parcel$export(module.exports, "chunkinator", () => $563249ea56b742e4$export$9ab6bef3838698f8);

var $kcvp1 = parcelRequire("kcvp1");

var $1PoKX = parcelRequire("1PoKX");

var $5zaNb = parcelRequire("5zaNb");

var $440xD = parcelRequire("440xD");

var $4z3FW = parcelRequire("4z3FW");

var $7UyFi = parcelRequire("7UyFi");

var $2O6pQ = parcelRequire("2O6pQ");

var $lXGe8 = parcelRequire("lXGe8");

var $5XMn4 = parcelRequire("5XMn4");

var $5wVlw = parcelRequire("5wVlw");
const $563249ea56b742e4$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $440xD.fromPromise)((0, $5XMn4.fetchBlob)(file)).pipe((0, $1PoKX.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $4z3FW.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $7UyFi.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $2O6pQ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $kcvp1.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $lXGe8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $1PoKX.concatMap)((batchedChunks)=>{
            return (0, $5wVlw.from)(batchedChunks);
        }), (0, $5zaNb.bufferCount)(totalChunks));
    }));
const $563249ea56b742e4$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $563249ea56b742e4$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("kcvp1", function(module, exports) {
"use strict";
var $eb4d498842f2572d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @name tap
 */ function $eb4d498842f2572d$var$tap(nextOrObserver, error, complete) {
    return function tapOperatorFunction(source) {
        return source.lift(new $eb4d498842f2572d$var$DoOperator(nextOrObserver, error, complete));
    };
}
module.exports.tap = $eb4d498842f2572d$var$tap;
var $eb4d498842f2572d$var$DoOperator = function() {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $eb4d498842f2572d$var$DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $eb4d498842f2572d$var$DoSubscriber = function(_super) {
    $eb4d498842f2572d$var$__extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new $kVbBc.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function(value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.next(value);
    };
    DoSubscriber.prototype._error = function(err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.error(err);
    };
    DoSubscriber.prototype._complete = function() {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) this.destination.error(safeSubscriber.syncErrorValue);
        else this.destination.complete();
    };
    return DoSubscriber;
}($kVbBc.Subscriber);

});

parcelRegister("1PoKX", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $154dc1fd9e2bbda5$export$c28c8388be0ab31a, (v) => $154dc1fd9e2bbda5$export$c28c8388be0ab31a = v);
var $154dc1fd9e2bbda5$export$c28c8388be0ab31a;
"use strict";

var $fcKxV = parcelRequire("fcKxV");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $154dc1fd9e2bbda5$var$concatMap(project, resultSelector) {
    return $fcKxV.mergeMap(project, resultSelector, 1);
}
$154dc1fd9e2bbda5$export$c28c8388be0ab31a = $154dc1fd9e2bbda5$var$concatMap;

});
parcelRegister("fcKxV", function(module, exports) {
"use strict";
var $b11c151f86a68828$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $b11c151f86a68828$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function mergeMapOperatorFunction(source) {
        if (typeof resultSelector === 'number') {
            concurrent = resultSelector;
            resultSelector = null;
        }
        return source.lift(new $b11c151f86a68828$var$MergeMapOperator(project, resultSelector, concurrent));
    };
}
module.exports.mergeMap = $b11c151f86a68828$var$mergeMap;
var $b11c151f86a68828$var$MergeMapOperator = function() {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $b11c151f86a68828$var$MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}();
module.exports.MergeMapOperator = $b11c151f86a68828$var$MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b11c151f86a68828$var$MergeMapSubscriber = function(_super) {
    $b11c151f86a68828$var$__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($d3klE.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.MergeMapSubscriber = $b11c151f86a68828$var$MergeMapSubscriber;

});
parcelRegister("d3klE", function(module, exports) {
$parcel$export(module.exports, "subscribeToResult", () => $980b56e488e2d1f6$export$d0604af3321cfb1b, (v) => $980b56e488e2d1f6$export$d0604af3321cfb1b = v);
var $980b56e488e2d1f6$export$d0604af3321cfb1b;
"use strict";

var $jYFjc = parcelRequire("jYFjc");

var $dDpFJ = parcelRequire("dDpFJ");

var $12qxP = parcelRequire("12qxP");

var $a2cZP = parcelRequire("a2cZP");

var $b0T1M = parcelRequire("b0T1M");

var $aT16R = parcelRequire("aT16R");

var $euNU8 = parcelRequire("euNU8");

var $jkDT5 = parcelRequire("jkDT5");
function $980b56e488e2d1f6$var$subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new $euNU8.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) return null;
    if (result instanceof $b0T1M.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        } else {
            destination.syncErrorThrowable = true;
            return result.subscribe(destination);
        }
    } else if ($dDpFJ.isArrayLike(result)) {
        for(var i = 0, len = result.length; i < len && !destination.closed; i++)destination.next(result[i]);
        if (!destination.closed) destination.complete();
    } else if ($12qxP.isPromise(result)) {
        result.then(function(value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function(err) {
            return destination.error(err);
        }).then(null, function(err) {
            // Escaping the Promise trap: globally throw unhandled errors
            $jYFjc.root.setTimeout(function() {
                throw err;
            });
        });
        return destination;
    } else if (result && typeof result[$aT16R.iterator] === 'function') {
        var iterator = result[$aT16R.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) break;
        }while (true);
    } else if (result && typeof result[$jkDT5.observable] === 'function') {
        var obs = result[$jkDT5.observable]();
        if (typeof obs.subscribe !== 'function') destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        else return obs.subscribe(new $euNU8.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
    } else {
        var value = $a2cZP.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
$980b56e488e2d1f6$export$d0604af3321cfb1b = $980b56e488e2d1f6$var$subscribeToResult;

});
parcelRegister("dDpFJ", function(module, exports) {
$parcel$export(module.exports, "isArrayLike", () => $9ed2d4d41f077ac5$export$1e2f57719e155213, (v) => $9ed2d4d41f077ac5$export$1e2f57719e155213 = v);
var $9ed2d4d41f077ac5$export$1e2f57719e155213;
"use strict";
$9ed2d4d41f077ac5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number';
};

});

parcelRegister("12qxP", function(module, exports) {
$parcel$export(module.exports, "isPromise", () => $0c1a918bf69c54dd$export$4369c812aac99591, (v) => $0c1a918bf69c54dd$export$4369c812aac99591 = v);
var $0c1a918bf69c54dd$export$4369c812aac99591;
"use strict";
function $0c1a918bf69c54dd$var$isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
$0c1a918bf69c54dd$export$4369c812aac99591 = $0c1a918bf69c54dd$var$isPromise;

});

parcelRegister("aT16R", function(module, exports) {
$parcel$export(module.exports, "iterator", () => $7ecfe6c72360098d$export$6f58e2338da23f4d, (v) => $7ecfe6c72360098d$export$6f58e2338da23f4d = v);
var $7ecfe6c72360098d$export$77b88d321d1c84c6;
var $7ecfe6c72360098d$export$6f58e2338da23f4d;
/**
 * @deprecated use iterator instead
 */ var $7ecfe6c72360098d$export$9785f547d3164dac;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
function $7ecfe6c72360098d$var$symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) Symbol.iterator = Symbol('iterator polyfill');
        return Symbol.iterator;
    } else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') return '@@iterator';
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for(var i = 0; i < keys.length; ++i){
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) return key;
            }
        }
        return '@@iterator';
    }
}
$7ecfe6c72360098d$export$77b88d321d1c84c6 = $7ecfe6c72360098d$var$symbolIteratorPonyfill;
$7ecfe6c72360098d$export$6f58e2338da23f4d = $7ecfe6c72360098d$var$symbolIteratorPonyfill($jYFjc.root);
$7ecfe6c72360098d$export$9785f547d3164dac = $7ecfe6c72360098d$export$6f58e2338da23f4d;

});

parcelRegister("euNU8", function(module, exports) {
"use strict";
var $a8da94051557a274$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a8da94051557a274$var$InnerSubscriber = function(_super) {
    $a8da94051557a274$var$__extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}($kVbBc.Subscriber);
module.exports.InnerSubscriber = $a8da94051557a274$var$InnerSubscriber;

});


parcelRegister("5XpGv", function(module, exports) {
"use strict";
var $456662da12faef18$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $456662da12faef18$var$OuterSubscriber = function(_super) {
    $456662da12faef18$var$__extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function(error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function(innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}($kVbBc.Subscriber);
module.exports.OuterSubscriber = $456662da12faef18$var$OuterSubscriber;

});



parcelRegister("5zaNb", function(module, exports) {
"use strict";
var $40d897c7d41fbff6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $40d897c7d41fbff6$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return function bufferCountOperatorFunction(source) {
        return source.lift(new $40d897c7d41fbff6$var$BufferCountOperator(bufferSize, startBufferEvery));
    };
}
module.exports.bufferCount = $40d897c7d41fbff6$var$bufferCount;
var $40d897c7d41fbff6$var$BufferCountOperator = function() {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) this.subscriberClass = $40d897c7d41fbff6$var$BufferCountSubscriber;
        else this.subscriberClass = $40d897c7d41fbff6$var$BufferSkipCountSubscriber;
    }
    BufferCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $40d897c7d41fbff6$var$BufferCountSubscriber = function(_super) {
    $40d897c7d41fbff6$var$__extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function(value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer.length > 0) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}($kVbBc.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $40d897c7d41fbff6$var$BufferSkipCountSubscriber = function(_super) {
    $40d897c7d41fbff6$var$__extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function(value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) buffers.push([]);
        for(var i = buffers.length; i--;){
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function() {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while(buffers.length > 0){
            var buffer = buffers.shift();
            if (buffer.length > 0) destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}($kVbBc.Subscriber);

});

parcelRegister("440xD", function(module, exports) {
$parcel$export(module.exports, "fromPromise", () => $2f57f4b2e90a23eb$export$60f45028237c39d1, (v) => $2f57f4b2e90a23eb$export$60f45028237c39d1 = v);
var $2f57f4b2e90a23eb$export$60f45028237c39d1;
"use strict";

var $a25wF = parcelRequire("a25wF");
$2f57f4b2e90a23eb$export$60f45028237c39d1 = $a25wF.PromiseObservable.create;

});
parcelRegister("a25wF", function(module, exports) {
"use strict";
var $74de60a3ac82616a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jYFjc = parcelRequire("jYFjc");

var $b0T1M = parcelRequire("b0T1M");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $74de60a3ac82616a$var$PromiseObservable = function(_super) {
    $74de60a3ac82616a$var$__extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {PromiseLike<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */ PromiseObservable.create = function(promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    /** @deprecated internal use only */ PromiseObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            } else promise.then(function(value) {
                _this.value = value;
                _this._isScalar = true;
                if (!subscriber.closed) {
                    subscriber.next(value);
                    subscriber.complete();
                }
            }, function(err) {
                if (!subscriber.closed) subscriber.error(err);
            }).then(null, function(err) {
                // escape the promise trap, throw unhandled errors
                $jYFjc.root.setTimeout(function() {
                    throw err;
                });
            });
        } else if (this._isScalar) {
            if (!subscriber.closed) return scheduler.schedule($74de60a3ac82616a$var$dispatchNext, 0, {
                value: this.value,
                subscriber: subscriber
            });
        } else promise.then(function(value) {
            _this.value = value;
            _this._isScalar = true;
            if (!subscriber.closed) subscriber.add(scheduler.schedule($74de60a3ac82616a$var$dispatchNext, 0, {
                value: value,
                subscriber: subscriber
            }));
        }, function(err) {
            if (!subscriber.closed) subscriber.add(scheduler.schedule($74de60a3ac82616a$var$dispatchError, 0, {
                err: err,
                subscriber: subscriber
            }));
        }).then(null, function(err) {
            // escape the promise trap, throw unhandled errors
            $jYFjc.root.setTimeout(function() {
                throw err;
            });
        });
    };
    return PromiseObservable;
}($b0T1M.Observable);
module.exports.PromiseObservable = $74de60a3ac82616a$var$PromiseObservable;
function $74de60a3ac82616a$var$dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function $74de60a3ac82616a$var$dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) subscriber.error(err);
}

});


parcelRegister("4z3FW", function(module, exports) {
$parcel$export(module.exports, "slicenator", () => $62b1480cbcf2c192$export$5b92d769f2f57509);

var $3ARJI = parcelRequire("3ARJI");

var $bWhgb = parcelRequire("bWhgb");
const $62b1480cbcf2c192$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3ARJI.range)(0, totalChunks).pipe((0, $bWhgb.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});
parcelRegister("3ARJI", function(module, exports) {
$parcel$export(module.exports, "range", () => $29de6ace6d4e8156$export$d02631cccf789723, (v) => $29de6ace6d4e8156$export$d02631cccf789723 = v);
var $29de6ace6d4e8156$export$d02631cccf789723;
"use strict";

var $k8dNa = parcelRequire("k8dNa");
$29de6ace6d4e8156$export$d02631cccf789723 = $k8dNa.RangeObservable.create;

});
parcelRegister("k8dNa", function(module, exports) {
"use strict";
var $ea7f40c9fba22526$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $ea7f40c9fba22526$var$RangeObservable = function(_super) {
    $ea7f40c9fba22526$var$__extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */ RangeObservable.create = function(start, count, scheduler) {
        if (start === void 0) start = 0;
        if (count === void 0) count = 0;
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function(state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) return;
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ RangeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(RangeObservable.dispatch, 0, {
            index: index,
            count: count,
            start: start,
            subscriber: subscriber
        });
        else do {
            if (index++ >= count) {
                subscriber.complete();
                break;
            }
            subscriber.next(start++);
            if (subscriber.closed) break;
        }while (true);
    };
    return RangeObservable;
}($b0T1M.Observable);
module.exports.RangeObservable = $ea7f40c9fba22526$var$RangeObservable;

});



parcelRegister("7UyFi", function(module, exports) {
$parcel$export(module.exports, "hashinator", () => $6e900c2eea46a89b$export$d5f5a550a38ec367);

var $5XMn4 = parcelRequire("5XMn4");
const $6e900c2eea46a89b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $6e900c2eea46a89b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $5XMn4.asyncMap)($6e900c2eea46a89b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("5XMn4", function(module, exports) {
$parcel$export(module.exports, "fetchBlob", () => $a55382122f44249f$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $a55382122f44249f$export$707ee4c4c95d39e3);

var $b0T1M = parcelRequire("b0T1M");

var $fcKxV = parcelRequire("fcKxV");
async function $a55382122f44249f$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $a55382122f44249f$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $a55382122f44249f$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $b0T1M.Observable)((sub)=>{
            notifiers.push($a55382122f44249f$var$notify(project(value), sub, onReady));
        });
};
const $a55382122f44249f$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $fcKxV.mergeMap)($a55382122f44249f$var$mapper(project), concurrent);

});


parcelRegister("2O6pQ", function(module, exports) {
$parcel$export(module.exports, "uploadinator", () => $86f748bf1f998be8$export$94ce0f3fcf999415);

var $5XMn4 = parcelRequire("5XMn4");
const $86f748bf1f998be8$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $5XMn4.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("lXGe8", function(module, exports) {
$parcel$export(module.exports, "processinator", () => $358d04d515014883$export$2f21790600302ed);

var $5zaNb = parcelRequire("5zaNb");

var $1PoKX = parcelRequire("1PoKX");
const $358d04d515014883$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $5zaNb.bufferCount)(options.batchSize)).pipe((0, $1PoKX.concatMap)(process));
};

});

parcelRegister("5wVlw", function(module, exports) {
$parcel$export(module.exports, "from", () => $406c6cabd6c8ec52$export$6788812c4e6611e6, (v) => $406c6cabd6c8ec52$export$6788812c4e6611e6 = v);
var $406c6cabd6c8ec52$export$6788812c4e6611e6;
"use strict";

var $7wGfx = parcelRequire("7wGfx");
$406c6cabd6c8ec52$export$6788812c4e6611e6 = $7wGfx.FromObservable.create;

});
parcelRegister("7wGfx", function(module, exports) {
"use strict";
var $57ac4b6eb1b36034$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8SQia = parcelRequire("8SQia");

var $dDpFJ = parcelRequire("dDpFJ");

var $12qxP = parcelRequire("12qxP");

var $a25wF = parcelRequire("a25wF");

var $2LHNV = parcelRequire("2LHNV");

var $fS4Qr = parcelRequire("fS4Qr");

var $bskLZ = parcelRequire("bskLZ");

var $aT16R = parcelRequire("aT16R");

var $b0T1M = parcelRequire("b0T1M");

var $kpNTS = parcelRequire("kpNTS");

var $jkDT5 = parcelRequire("jkDT5");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $57ac4b6eb1b36034$var$FromObservable = function(_super) {
    $57ac4b6eb1b36034$var$__extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */ FromObservable.create = function(ish, scheduler) {
        if (ish != null) {
            if (typeof ish[$jkDT5.observable] === 'function') {
                if (ish instanceof $b0T1M.Observable && !scheduler) return ish;
                return new FromObservable(ish, scheduler);
            } else if ($8SQia.isArray(ish)) return new $fS4Qr.ArrayObservable(ish, scheduler);
            else if ($12qxP.isPromise(ish)) return new $a25wF.PromiseObservable(ish, scheduler);
            else if (typeof ish[$aT16R.iterator] === 'function' || typeof ish === 'string') return new $2LHNV.IteratorObservable(ish, scheduler);
            else if ($dDpFJ.isArrayLike(ish)) return new $bskLZ.ArrayLikeObservable(ish, scheduler);
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    /** @deprecated internal use only */ FromObservable.prototype._subscribe = function(subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) return ish[$jkDT5.observable]().subscribe(subscriber);
        else return ish[$jkDT5.observable]().subscribe(new $kpNTS.ObserveOnSubscriber(subscriber, scheduler, 0));
    };
    return FromObservable;
}($b0T1M.Observable);
module.exports.FromObservable = $57ac4b6eb1b36034$var$FromObservable;

});
parcelRegister("2LHNV", function(module, exports) {
"use strict";
var $2041f32908d55eda$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jYFjc = parcelRequire("jYFjc");

var $b0T1M = parcelRequire("b0T1M");

var $aT16R = parcelRequire("aT16R");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $2041f32908d55eda$var$IteratorObservable = function(_super) {
    $2041f32908d55eda$var$__extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) throw new Error('iterator cannot be null.');
        this.iterator = $2041f32908d55eda$var$getIterator(iterator);
    }
    IteratorObservable.create = function(iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function(state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') iterator.return();
            return;
        }
        this.schedule(state);
    };
    /** @deprecated internal use only */ IteratorObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) return scheduler.schedule(IteratorObservable.dispatch, 0, {
            index: index,
            iterator: iterator,
            subscriber: subscriber
        });
        else do {
            var result = iterator.next();
            if (result.done) {
                subscriber.complete();
                break;
            } else subscriber.next(result.value);
            if (subscriber.closed) {
                if (typeof iterator.return === 'function') iterator.return();
                break;
            }
        }while (true);
    };
    return IteratorObservable;
}($b0T1M.Observable);
module.exports.IteratorObservable = $2041f32908d55eda$var$IteratorObservable;
var $2041f32908d55eda$var$StringIterator = function() {
    function StringIterator(str, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = str.length;
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[$aT16R.iterator] = function() {
        return this;
    };
    StringIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}();
var $2041f32908d55eda$var$ArrayIterator = function() {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) idx = 0;
        if (len === void 0) len = $2041f32908d55eda$var$toLength(arr);
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[$aT16R.iterator] = function() {
        return this;
    };
    ArrayIterator.prototype.next = function() {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}();
function $2041f32908d55eda$var$getIterator(obj) {
    var i = obj[$aT16R.iterator];
    if (!i && typeof obj === 'string') return new $2041f32908d55eda$var$StringIterator(obj);
    if (!i && obj.length !== undefined) return new $2041f32908d55eda$var$ArrayIterator(obj);
    if (!i) throw new TypeError('object is not iterable');
    return obj[$aT16R.iterator]();
}
var $2041f32908d55eda$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $2041f32908d55eda$var$toLength(o) {
    var len = +o.length;
    if (isNaN(len)) return 0;
    if (len === 0 || !$2041f32908d55eda$var$numberIsFinite(len)) return len;
    len = $2041f32908d55eda$var$sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) return 0;
    if (len > $2041f32908d55eda$var$maxSafeInteger) return $2041f32908d55eda$var$maxSafeInteger;
    return len;
}
function $2041f32908d55eda$var$numberIsFinite(value) {
    return typeof value === 'number' && $jYFjc.root.isFinite(value);
}
function $2041f32908d55eda$var$sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) return valueAsNumber;
    if (isNaN(valueAsNumber)) return valueAsNumber;
    return valueAsNumber < 0 ? -1 : 1;
}

});

parcelRegister("fS4Qr", function(module, exports) {
"use strict";
var $b8dfa84087d918d4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $28a5P = parcelRequire("28a5P");

var $lmQ1o = parcelRequire("lmQ1o");

var $6eaCl = parcelRequire("6eaCl");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $b8dfa84087d918d4$var$ArrayObservable = function(_super) {
    $b8dfa84087d918d4$var$__extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function(array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */ ArrayObservable.of = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
        var scheduler = array[array.length - 1];
        if ($6eaCl.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len > 1) return new ArrayObservable(array, scheduler);
        else if (len === 1) return new $28a5P.ScalarObservable(array[0], scheduler);
        else return new $lmQ1o.EmptyObservable(scheduler);
    };
    ArrayObservable.dispatch = function(state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) return;
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ArrayObservable.dispatch, 0, {
            array: array,
            index: index,
            count: count,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < count && !subscriber.closed; i++)subscriber.next(array[i]);
            subscriber.complete();
        }
    };
    return ArrayObservable;
}($b0T1M.Observable);
module.exports.ArrayObservable = $b8dfa84087d918d4$var$ArrayObservable;

});
parcelRegister("28a5P", function(module, exports) {
"use strict";
var $18d42868c158cd17$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $18d42868c158cd17$var$ScalarObservable = function(_super) {
    $18d42868c158cd17$var$__extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) this._isScalar = false;
    }
    ScalarObservable.create = function(value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function(state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) return;
        state.done = true;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ScalarObservable.prototype._subscribe = function(subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(ScalarObservable.dispatch, 0, {
            done: false,
            value: value,
            subscriber: subscriber
        });
        else {
            subscriber.next(value);
            if (!subscriber.closed) subscriber.complete();
        }
    };
    return ScalarObservable;
}($b0T1M.Observable);
module.exports.ScalarObservable = $18d42868c158cd17$var$ScalarObservable;

});

parcelRegister("lmQ1o", function(module, exports) {
"use strict";
var $f8e4016c5fc226dc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $f8e4016c5fc226dc$var$EmptyObservable = function(_super) {
    $f8e4016c5fc226dc$var$__extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */ EmptyObservable.create = function(scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function(arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    /** @deprecated internal use only */ EmptyObservable.prototype._subscribe = function(subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) return scheduler.schedule(EmptyObservable.dispatch, 0, {
            subscriber: subscriber
        });
        else subscriber.complete();
    };
    return EmptyObservable;
}($b0T1M.Observable);
module.exports.EmptyObservable = $f8e4016c5fc226dc$var$EmptyObservable;

});

parcelRegister("6eaCl", function(module, exports) {
$parcel$export(module.exports, "isScheduler", () => $488c494c2af10c60$export$187e35932e88c15c, (v) => $488c494c2af10c60$export$187e35932e88c15c = v);
var $488c494c2af10c60$export$187e35932e88c15c;
"use strict";
function $488c494c2af10c60$var$isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
$488c494c2af10c60$export$187e35932e88c15c = $488c494c2af10c60$var$isScheduler;

});


parcelRegister("bskLZ", function(module, exports) {
"use strict";
var $85726c4fc048440b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $28a5P = parcelRequire("28a5P");

var $lmQ1o = parcelRequire("lmQ1o");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $85726c4fc048440b$var$ArrayLikeObservable = function(_super) {
    $85726c4fc048440b$var$__extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function(arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) return new $lmQ1o.EmptyObservable();
        else if (length === 1) return new $28a5P.ScalarObservable(arrayLike[0], scheduler);
        else return new ArrayLikeObservable(arrayLike, scheduler);
    };
    ArrayLikeObservable.dispatch = function(state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) return;
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    /** @deprecated internal use only */ ArrayLikeObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
            arrayLike: arrayLike,
            index: index,
            length: length,
            subscriber: subscriber
        });
        else {
            for(var i = 0; i < length && !subscriber.closed; i++)subscriber.next(arrayLike[i]);
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}($b0T1M.Observable);
module.exports.ArrayLikeObservable = $85726c4fc048440b$var$ArrayLikeObservable;

});

parcelRegister("kpNTS", function(module, exports) {
"use strict";
var $edccd99ee913aebc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $lnB2i = parcelRequire("lnB2i");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $edccd99ee913aebc$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function observeOnOperatorFunction(source) {
        return source.lift(new $edccd99ee913aebc$var$ObserveOnOperator(scheduler, delay));
    };
}
module.exports.observeOn = $edccd99ee913aebc$var$observeOn;
var $edccd99ee913aebc$var$ObserveOnOperator = function() {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) delay = 0;
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $edccd99ee913aebc$var$ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}();
module.exports.ObserveOnOperator = $edccd99ee913aebc$var$ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $edccd99ee913aebc$var$ObserveOnSubscriber = function(_super) {
    $edccd99ee913aebc$var$__extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) delay = 0;
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function(arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function(notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new $edccd99ee913aebc$var$ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function(value) {
        this.scheduleMessage($lnB2i.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function(err) {
        this.scheduleMessage($lnB2i.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function() {
        this.scheduleMessage($lnB2i.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}($kVbBc.Subscriber);
module.exports.ObserveOnSubscriber = $edccd99ee913aebc$var$ObserveOnSubscriber;
var $edccd99ee913aebc$var$ObserveOnMessage = function() {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}();
module.exports.ObserveOnMessage = $edccd99ee913aebc$var$ObserveOnMessage;

});
parcelRegister("lnB2i", function(module, exports) {
$parcel$export(module.exports, "Notification", () => $f9087984103009ca$export$14834abbfce3b8cd, (v) => $f9087984103009ca$export$14834abbfce3b8cd = v);
var $f9087984103009ca$export$14834abbfce3b8cd;
"use strict";

var $b0T1M = parcelRequire("b0T1M");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */ var $f9087984103009ca$var$Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */ Notification.prototype.observe = function(observer) {
        switch(this.kind){
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.do = function(next, error, complete) {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */ Notification.prototype.accept = function(nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') return this.observe(nextOrObserver);
        else return this.do(nextOrObserver, error, complete);
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */ Notification.prototype.toObservable = function() {
        var kind = this.kind;
        switch(kind){
            case 'N':
                return $b0T1M.Observable.of(this.value);
            case 'E':
                return $b0T1M.Observable.throw(this.error);
            case 'C':
                return $b0T1M.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */ Notification.createNext = function(value) {
        if (typeof value !== 'undefined') return new Notification('N', value);
        return Notification.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */ Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */ Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}();
$f9087984103009ca$export$14834abbfce3b8cd = $f9087984103009ca$var$Notification;

});





parcelRegister("lXc1j", function(module, exports) {
$parcel$export(module.exports, "createHasher", () => $fc9f461e8fda709b$export$14b114effbc08b6b);
parcelRequire("23MeP");
var $aSrSH = parcelRequire("aSrSH");
let $fc9f461e8fda709b$var$hasher = null;
let $fc9f461e8fda709b$var$sha256Hasher = null;
const $fc9f461e8fda709b$export$d9c9d11cd648a505 = ()=>{
    $fc9f461e8fda709b$var$hasher = null;
    $fc9f461e8fda709b$var$sha256Hasher = null;
};


const $fc9f461e8fda709b$export$14b114effbc08b6b = async (algorithm)=>{
    try {
        if (algorithm === (0, $aSrSH.ChunkHashAlgorithm).Sha256) {
            if (!$fc9f461e8fda709b$var$sha256Hasher) {
                // TODO this needs to support worker sha256 hasher as well
                const { SimpleHasher: SimpleHasher } = await (parcelRequire("bz6bw"));
                $fc9f461e8fda709b$var$sha256Hasher = new SimpleHasher();
            }
            return $fc9f461e8fda709b$var$sha256Hasher;
        }
    } catch (error) {}
    const { SimpleHasher: SimpleHasher } = await (parcelRequire("cwQVQ"));
    $fc9f461e8fda709b$var$hasher = new SimpleHasher();
    return $fc9f461e8fda709b$var$hasher;
};

});
parcelRegister("bz6bw", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("dggW8").then(()=>parcelRequire('hidJi'));

});

parcelRegister("cwQVQ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("2piZ6"),
    $e46AW("4fTmV")
]).then(()=>parcelRequire('cNcF6'));

});


parcelRegister("3tJ5e", function(module, exports) {
$parcel$export(module.exports, "UploaderError", () => $2f0945bc3acc4778$export$515240c3f059c807);

var $5OUhX = parcelRequire("5OUhX");
class $2f0945bc3acc4778$export$515240c3f059c807 extends (0, $5OUhX.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
        this.id = metadata.id;
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { id: id, collectionName: collectionName, occurrenceKey: occurrenceKey } } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $2f0945bc3acc4778$export$80ee180172bc336(err) {
    return err instanceof $2f0945bc3acc4778$export$515240c3f059c807;
}

});

parcelRegister("isG6a", function(module, exports) {
$parcel$export(module.exports, "fileSizeError", () => $dc8e1ba9c20769d4$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $dc8e1ba9c20769d4$export$71f452e02035c1e2);

var $8g3hT = parcelRequire("8g3hT");

var $eb801 = parcelRequire("eb801");
const $dc8e1ba9c20769d4$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $dc8e1ba9c20769d4$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $eb801.MAX_UPLOAD_FILE_SIZE)) throw new Error($dc8e1ba9c20769d4$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $8g3hT.DATA_UNIT).GB) return 5 * (0, $8g3hT.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $8g3hT.DATA_UNIT).GB && fileSize <= 50 * (0, $8g3hT.DATA_UNIT).GB) return 50 * (0, $8g3hT.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $8g3hT.DATA_UNIT).GB && fileSize <= 0.95 * (0, $8g3hT.DATA_UNIT).TB) return 100 * (0, $8g3hT.DATA_UNIT).MB;
    return 210 * (0, $8g3hT.DATA_UNIT).MB;
};

});


parcelRegister("lyZqA", function(module, exports) {
$parcel$export(module.exports, "getFileStreamsCache", () => $698489aee9719d7c$export$f2f061938c1e6810);
class $698489aee9719d7c$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $698489aee9719d7c$var$streamCache;

const $698489aee9719d7c$export$f2f061938c1e6810 = ()=>{
    if (!$698489aee9719d7c$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("dgiEF")).mediaState;
        $698489aee9719d7c$var$streamCache = new $698489aee9719d7c$export$4293896e79732236(mediaState.streams);
    }
    return $698489aee9719d7c$var$streamCache;
};

});

parcelRegister("aS18s", function(module, exports) {
$parcel$export(module.exports, "createFileDataloader", () => $0baff2e7ed695a57$export$ae188fee39529b82);

var $dasBT = parcelRequire("dasBT");

var $50oso = parcelRequire("50oso");
const $0baff2e7ed695a57$export$b79d95ee17a87a = 100;
const $0baff2e7ed695a57$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $0baff2e7ed695a57$var$isResponseFileItem = (fileItem)=>{
    return 'details' in fileItem;
};
const $0baff2e7ed695a57$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $0baff2e7ed695a57$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $0baff2e7ed695a57$var$makeCacheKey(id, collection);
        if ($0baff2e7ed695a57$var$isBatchLoadingErrorResult(fileItem)) prev[key] = fileItem.error;
        else if ($0baff2e7ed695a57$var$isResponseFileItem(fileItem)) prev[key] = {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        else prev[key] = {
            id: id,
            collection: collection,
            type: 'not-found',
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $0baff2e7ed695a57$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || {
            id: id,
            type: 'not-found'
        };
    });
};
function $0baff2e7ed695a57$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const includeHashByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            if (key.includeHashForDuplicateFiles) acc[collectionName] = key.includeHashForDuplicateFiles;
            return acc;
        }, {});
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $50oso.getRandomTelemetryId)(),
                spanId: (0, $50oso.getRandomTelemetryId)()
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const includeHashForDuplicateFiles = includeHashByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext, includeHashForDuplicateFiles);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
                // add EmptyResponseFileItem for each file ID not included in /items response
                const itemsIds = itemsWithMetadataTraceContext.map((item)=>item.id);
                const fileIdsNotFound = fileIds.filter((id)=>!itemsIds.includes(id));
                fileIdsNotFound.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        type: 'not-found',
                        metadataTraceContext: metadataTraceContext
                    });
                });
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $0baff2e7ed695a57$export$71cd2e8f8162d47b(keys, items);
    };
}
function $0baff2e7ed695a57$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($dasBT)))($0baff2e7ed695a57$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $0baff2e7ed695a57$export$b79d95ee17a87a
    });
}

});
parcelRegister("dasBT", function(module, exports) {

var $3TFEq = parcelRequire("3TFEq");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $996266ea20078de0$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $996266ea20078de0$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $996266ea20078de0$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $996266ea20078de0$var$getValidCacheKeyFn(options);
        this._cacheMap = $996266ea20078de0$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $996266ea20078de0$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $996266ea20078de0$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$996266ea20078de0$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $996266ea20078de0$var$enqueuePostPromiseJob = typeof $3TFEq === 'object' && typeof $3TFEq.nextTick === 'function' ? function(fn) {
    if (!$996266ea20078de0$var$resolvedPromise) $996266ea20078de0$var$resolvedPromise = Promise.resolve();
    $996266ea20078de0$var$resolvedPromise.then(function() {
        $3TFEq.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $996266ea20078de0$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $996266ea20078de0$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $996266ea20078de0$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $996266ea20078de0$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $996266ea20078de0$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $996266ea20078de0$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $996266ea20078de0$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$996266ea20078de0$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $996266ea20078de0$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $996266ea20078de0$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $996266ea20078de0$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $996266ea20078de0$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $996266ea20078de0$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $996266ea20078de0$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $996266ea20078de0$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $996266ea20078de0$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $996266ea20078de0$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $996266ea20078de0$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $996266ea20078de0$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $996266ea20078de0$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $996266ea20078de0$var$DataLoader;

});


parcelRegister("iy59X", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $fb31d121c097bac4$export$ac3214931ffd82af);

var $lGDUe = parcelRequire("lGDUe");
const $fb31d121c097bac4$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $lGDUe.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("lGDUe", function(module, exports) {
$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $0bc4540343f750bc$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("a1rbz")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("a1rbz")).isVideoMimeTypeSupportedByBrowser);

var $bQpuh = parcelRequire("bQpuh");

var $a1rbz = parcelRequire("a1rbz");

var $11LSU = parcelRequire("11LSU");

var $gfzzW = parcelRequire("gfzzW");
const $0bc4540343f750bc$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $bQpuh.isArchive)(mimeType)) return 'archive';
    if ((0, $a1rbz.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $11LSU.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $a1rbz.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $11LSU.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $a1rbz.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $11LSU.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $a1rbz.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $11LSU.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("bQpuh", function(module, exports) {
$parcel$export(module.exports, "isArchive", () => $608292954ff4a821$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $608292954ff4a821$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("a1rbz", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $5d73f473e09b47b0$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $5d73f473e09b47b0$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $5d73f473e09b47b0$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $5d73f473e09b47b0$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $5d73f473e09b47b0$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $5d73f473e09b47b0$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $5d73f473e09b47b0$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $5d73f473e09b47b0$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $5d73f473e09b47b0$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $5d73f473e09b47b0$export$55ca6cdaf6093034 = (mimeType)=>$5d73f473e09b47b0$export$74325e3c843a9555(mimeType) || $5d73f473e09b47b0$export$c021f2623a75015f(mimeType) || $5d73f473e09b47b0$export$ff36075ea755a717(mimeType) || $5d73f473e09b47b0$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("11LSU", function(module, exports) {
$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $c039d5913ef91690$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $c039d5913ef91690$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $c039d5913ef91690$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $c039d5913ef91690$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $c039d5913ef91690$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $c039d5913ef91690$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c039d5913ef91690$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c039d5913ef91690$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c039d5913ef91690$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c039d5913ef91690$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $c039d5913ef91690$export$548d9148a80556a3 = (mimeType)=>$c039d5913ef91690$export$e9a065a80f76311e(mimeType) || $c039d5913ef91690$export$86baad7a89d908e9(mimeType) || $c039d5913ef91690$export$8cba23825d020bbb(mimeType) || $c039d5913ef91690$export$9c2b4de5fdca2ce3(mimeType) || $c039d5913ef91690$export$94e1479e01d2af53(mimeType);

});

parcelRegister("gfzzW", function(module, exports) {
$parcel$export(module.exports, "isExcelFile", () => $85e6f2a77c6fe0a3$export$e5fbc944c6f94589);
// MS Excel MIME types — covers all native Microsoft spreadsheet formats.
// Stored in their canonical form (RFC 4288 mimetypes are case-sensitive;
// the media backend always sends them in this exact casing).
const $85e6f2a77c6fe0a3$var$EXCEL_MIME_TYPES = new Set([
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    'application/vnd.ms-excel.sheet.macroEnabled.12'
]);
const $85e6f2a77c6fe0a3$export$e5fbc944c6f94589 = (mimeType)=>$85e6f2a77c6fe0a3$var$EXCEL_MIME_TYPES.has(mimeType);

});



parcelRegister("lbOv5", function(module, exports) {
$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $f4e0e48c43f571c0$export$89097c0ec1e0dee1);

var $lNtM5 = parcelRequire("lNtM5");
const $f4e0e48c43f571c0$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $lNtM5.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("dHXyx", function(module, exports) {
$parcel$export(module.exports, "convertBase64ToBlob", () => $ed0b85f6e0f8dfaa$export$ed17558b11b88056);
const $ed0b85f6e0f8dfaa$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("b5l4D", function(module, exports) {
$parcel$export(module.exports, "fromObservable", () => $135c62850d77249b$export$4b2432e2d8723823);

var $75NCN = parcelRequire("75NCN");
function $135c62850d77249b$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $135c62850d77249b$export$8659d1f07d151381(item) {
    return $135c62850d77249b$export$4b2432e2d8723823((0, $75NCN.createMediaSubject)(item));
}

});
parcelRegister("75NCN", function(module, exports) {
$parcel$export(module.exports, "createMediaSubject", () => $06dc4bc798536602$export$bc76d51553fa5e35);

var $gNLuz = parcelRequire("gNLuz");
function $06dc4bc798536602$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $gNLuz.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});
parcelRegister("gNLuz", function(module, exports) {
"use strict";
var $c3b60fe71203554f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $5uXxO = parcelRequire("5uXxO");

var $cGvOX = parcelRequire("cGvOX");

var $kpNTS = parcelRequire("kpNTS");

var $1QtXt = parcelRequire("1QtXt");

var $5JRt0 = parcelRequire("5JRt0");
/**
 * @class ReplaySubject<T>
 */ var $c3b60fe71203554f$var$ReplaySubject = function(_super) {
    $c3b60fe71203554f$var$__extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) bufferSize = Number.POSITIVE_INFINITY;
        if (windowTime === void 0) windowTime = Number.POSITIVE_INFINITY;
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function(value) {
        var now = this._getNow();
        this._events.push(new $c3b60fe71203554f$var$ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    /** @deprecated internal use only */ ReplaySubject.prototype._subscribe = function(subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        else if (this.hasError) subscription = $cGvOX.Subscription.EMPTY;
        else if (this.isStopped) subscription = $cGvOX.Subscription.EMPTY;
        else {
            this.observers.push(subscriber);
            subscription = new $5JRt0.SubjectSubscription(this, subscriber);
        }
        if (scheduler) subscriber.add(subscriber = new $kpNTS.ObserveOnSubscriber(subscriber, scheduler));
        var len = _events.length;
        for(var i = 0; i < len && !subscriber.closed; i++)subscriber.next(_events[i].value);
        if (this.hasError) subscriber.error(this.thrownError);
        else if (this.isStopped) subscriber.complete();
        return subscription;
    };
    ReplaySubject.prototype._getNow = function() {
        return (this.scheduler || $5uXxO.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function() {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while(spliceCount < eventsCount){
            if (now - _events[spliceCount].time < _windowTime) break;
            spliceCount++;
        }
        if (eventsCount > _bufferSize) spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        if (spliceCount > 0) _events.splice(0, spliceCount);
        return _events;
    };
    return ReplaySubject;
}($hJCZY.Subject);
module.exports.ReplaySubject = $c3b60fe71203554f$var$ReplaySubject;
var $c3b60fe71203554f$var$ReplayEvent = function() {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}();

});
parcelRegister("hJCZY", function(module, exports) {
"use strict";
var $ce94e3f674b6852c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $kVbBc = parcelRequire("kVbBc");

var $cGvOX = parcelRequire("cGvOX");

var $1QtXt = parcelRequire("1QtXt");

var $5JRt0 = parcelRequire("5JRt0");

var $2xP00 = parcelRequire("2xP00");
/**
 * @class SubjectSubscriber<T>
 */ var $ce94e3f674b6852c$var$SubjectSubscriber = function(_super) {
    $ce94e3f674b6852c$var$__extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}($kVbBc.Subscriber);
module.exports.SubjectSubscriber = $ce94e3f674b6852c$var$SubjectSubscriber;
/**
 * @class Subject<T>
 */ var $ce94e3f674b6852c$var$Subject = function(_super) {
    $ce94e3f674b6852c$var$__extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[$2xP00.rxSubscriber] = function() {
        return new $ce94e3f674b6852c$var$SubjectSubscriber(this);
    };
    Subject.prototype.lift = function(operator) {
        var subject = new $ce94e3f674b6852c$var$AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function(value) {
        if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for(var i = 0; i < len; i++)copy[i].next(value);
        }
    };
    Subject.prototype.error = function(err) {
        if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].error(err);
        this.observers.length = 0;
    };
    Subject.prototype.complete = function() {
        if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for(var i = 0; i < len; i++)copy[i].complete();
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function(subscriber) {
        if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        else return _super.prototype._trySubscribe.call(this, subscriber);
    };
    /** @deprecated internal use only */ Subject.prototype._subscribe = function(subscriber) {
        if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return $cGvOX.Subscription.EMPTY;
        } else if (this.isStopped) {
            subscriber.complete();
            return $cGvOX.Subscription.EMPTY;
        } else {
            this.observers.push(subscriber);
            return new $5JRt0.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function() {
        var observable = new $b0T1M.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $ce94e3f674b6852c$var$AnonymousSubject(destination, source);
    };
    return Subject;
}($b0T1M.Observable);
module.exports.Subject = $ce94e3f674b6852c$var$Subject;
/**
 * @class AnonymousSubject<T>
 */ var $ce94e3f674b6852c$var$AnonymousSubject = function(_super) {
    $ce94e3f674b6852c$var$__extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function(value) {
        var destination = this.destination;
        if (destination && destination.next) destination.next(value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var destination = this.destination;
        if (destination && destination.error) this.destination.error(err);
    };
    AnonymousSubject.prototype.complete = function() {
        var destination = this.destination;
        if (destination && destination.complete) this.destination.complete();
    };
    /** @deprecated internal use only */ AnonymousSubject.prototype._subscribe = function(subscriber) {
        var source = this.source;
        if (source) return this.source.subscribe(subscriber);
        else return $cGvOX.Subscription.EMPTY;
    };
    return AnonymousSubject;
}($ce94e3f674b6852c$var$Subject);
module.exports.AnonymousSubject = $ce94e3f674b6852c$var$AnonymousSubject;

});
parcelRegister("1QtXt", function(module, exports) {
"use strict";
var $1581e2e18ecb0f4d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */ var $1581e2e18ecb0f4d$var$ObjectUnsubscribedError = function(_super) {
    $1581e2e18ecb0f4d$var$__extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error);
module.exports.ObjectUnsubscribedError = $1581e2e18ecb0f4d$var$ObjectUnsubscribedError;

});

parcelRegister("5JRt0", function(module, exports) {
"use strict";
var $42daa1190b606bfc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cGvOX = parcelRequire("cGvOX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $42daa1190b606bfc$var$SubjectSubscription = function(_super) {
    $42daa1190b606bfc$var$__extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) return;
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) observers.splice(subscriberIndex, 1);
    };
    return SubjectSubscription;
}($cGvOX.Subscription);
module.exports.SubjectSubscription = $42daa1190b606bfc$var$SubjectSubscription;

});


parcelRegister("5uXxO", function(module, exports) {
$parcel$export(module.exports, "queue", () => $400df1561df51afe$export$4f7fa46ff53e516f, (v) => $400df1561df51afe$export$4f7fa46ff53e516f = v);
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */ var $400df1561df51afe$export$4f7fa46ff53e516f;
"use strict";

var $g4RyZ = parcelRequire("g4RyZ");

var $cwpng = parcelRequire("cwpng");
$400df1561df51afe$export$4f7fa46ff53e516f = new $cwpng.QueueScheduler($g4RyZ.QueueAction);

});
parcelRegister("g4RyZ", function(module, exports) {
"use strict";
var $bb4691a1da604955$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jvUn0 = parcelRequire("jvUn0");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bb4691a1da604955$var$QueueAction = function(_super) {
    $bb4691a1da604955$var$__extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}($jvUn0.AsyncAction);
module.exports.QueueAction = $bb4691a1da604955$var$QueueAction;

});
parcelRegister("jvUn0", function(module, exports) {
"use strict";
var $e34ca379d553a5ae$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jYFjc = parcelRequire("jYFjc");

var $k1aDk = parcelRequire("k1aDk");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e34ca379d553a5ae$var$AsyncAction = function(_super) {
    $e34ca379d553a5ae$var$__extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.pending = false;
        this.work = work;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return $jYFjc.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay && this.pending === false) return id;
        // Otherwise, if the action's delay time is different from the current delay,
        // or the action has been rescheduled before it's executed, clear the interval id
        return $jYFjc.root.clearInterval(id) && undefined, undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */ AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) // Dequeue if the action didn't reschedule itself. Don't call
        // unsubscribe(), because the action could reschedule later.
        // For example:
        // ```
        // scheduler.schedule(function doWork(counter) {
        //   /* ... I'm a busy worker bee ... */
        //   var originalAction = this;
        //   /* wait 100ms before rescheduling the action */
        //   setTimeout(function () {
        //     originalAction.schedule(counter + 1);
        //   }, 100);
        // }, 1000);
        // ```
        this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    /** @deprecated internal use only */ AsyncAction.prototype._unsubscribe = function() {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) actions.splice(index, 1);
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
        this.delay = null;
    };
    return AsyncAction;
}($k1aDk.Action);
module.exports.AsyncAction = $e34ca379d553a5ae$var$AsyncAction;

});
parcelRegister("k1aDk", function(module, exports) {
"use strict";
var $e92c2635b6b15cd8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cGvOX = parcelRequire("cGvOX");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */ var $e92c2635b6b15cd8$var$Action = function(_super) {
    $e92c2635b6b15cd8$var$__extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */ Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}($cGvOX.Subscription);
module.exports.Action = $e92c2635b6b15cd8$var$Action;

});



parcelRegister("cwpng", function(module, exports) {
"use strict";
var $91dc27fad02d16a4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $63qby = parcelRequire("63qby");
var $91dc27fad02d16a4$var$QueueScheduler = function(_super) {
    $91dc27fad02d16a4$var$__extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}($63qby.AsyncScheduler);
module.exports.QueueScheduler = $91dc27fad02d16a4$var$QueueScheduler;

});
parcelRegister("63qby", function(module, exports) {
"use strict";
var $468755bc847dbc56$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $lykOY = parcelRequire("lykOY");
var $468755bc847dbc56$var$AsyncScheduler = function(_super) {
    $468755bc847dbc56$var$__extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */ this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */ this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}($lykOY.Scheduler);
module.exports.AsyncScheduler = $468755bc847dbc56$var$AsyncScheduler;

});
parcelRegister("lykOY", function(module, exports) {
$parcel$export(module.exports, "Scheduler", () => $fb0cec9450cb5b4b$export$d3e54bb8584cda7c, (v) => $fb0cec9450cb5b4b$export$d3e54bb8584cda7c = v);
var $fb0cec9450cb5b4b$export$d3e54bb8584cda7c;
"use strict";
/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */ var $fb0cec9450cb5b4b$var$Scheduler = function() {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) now = Scheduler.now;
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */ Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function() {
        return +new Date();
    };
    return Scheduler;
}();
$fb0cec9450cb5b4b$export$d3e54bb8584cda7c = $fb0cec9450cb5b4b$var$Scheduler;

});







parcelRegister("jrXo2", function(module, exports) {
$parcel$export(module.exports, "toPromise", () => $c1b93e19244679c7$export$4dbaaf6c79705e6c);

var $cGvOX = parcelRequire("cGvOX");
const $c1b93e19244679c7$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $cGvOX.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("8sffc", function(module, exports) {
$parcel$export(module.exports, "getDimensionsFromBlob", () => $3a74e97bba21d9a4$export$71797c284d89a3e1);

var $1XBUQ = parcelRequire("1XBUQ");

var $86U4v = parcelRequire("86U4v");
const $3a74e97bba21d9a4$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $1XBUQ.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $86U4v.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("1XBUQ", function(module, exports) {
$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $b584fd49bb9eda65$export$a1c3205f28a20414);
const $b584fd49bb9eda65$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("86U4v", function(module, exports) {
$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $2dc114343ce797c6$export$62aabd5ff85d0451);
const $2dc114343ce797c6$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("HK4A7", function(module, exports) {
$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $48a0f82f49a6639e$export$2ccdd6f9a9eba6a);

var $a1rbz = parcelRequire("a1rbz");
var $11LSU = parcelRequire("11LSU");

var $86U4v = parcelRequire("86U4v");
async function $48a0f82f49a6639e$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $a1rbz.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $11LSU.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $86U4v.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("aTvJC", function(module, exports) {
$parcel$export(module.exports, "PollingFunction", () => $ed634ea07e1cdcbd$export$4c54d536f8e37dc2);

var $2SsCB = parcelRequire("2SsCB");
const $ed634ea07e1cdcbd$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $ed634ea07e1cdcbd$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$ed634ea07e1cdcbd$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $2SsCB.PollingError)('pollingMaxAttemptsExceeded', {
            attempts: this.attempt
        }));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $2SsCB.PollingError)('pollingMaxAttemptsExceeded', {
                attempts: this.attempt
            }));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("2SsCB", function(module, exports) {
$parcel$export(module.exports, "PollingError", () => $2f7dba9317ff8064$export$c3748c310e92340a);

var $5OUhX = parcelRequire("5OUhX");
class $2f7dba9317ff8064$export$c3748c310e92340a extends (0, $5OUhX.BaseMediaClientError) {
    constructor(reason, metadata){
        super(reason, metadata, undefined);
    }
    // TODO: Deprecate this getter https://product-fabric.atlassian.net/browse/CXP-4665
    /** Will be deprecated. Use the properties `reason` and `metadata` instead */ get attributes() {
        const { reason: reason, metadata: { attempts: attempts } } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $2f7dba9317ff8064$export$541e3e52eea6fece(err) {
    return err instanceof $2f7dba9317ff8064$export$c3748c310e92340a;
}

});


parcelRegister("2rTxf", function(module, exports) {
$parcel$export(module.exports, "isEmptyFile", () => $15970f595a7b7228$export$728192ce8dd94659);
const $15970f595a7b7228$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $15970f595a7b7228$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $15970f595a7b7228$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("g2ABH", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => (parcelRequire("4bbpy")).mediaStore);

var $4bbpy = parcelRequire("4bbpy");

});
parcelRegister("4bbpy", function(module, exports) {
$parcel$export(module.exports, "mediaStore", () => $02ffb86a5c7d183c$export$5785580dea19518d);

var $gfGec = parcelRequire("gfGec");

var $i670z = parcelRequire("i670z");

var $5CQB5 = parcelRequire("5CQB5");
const $02ffb86a5c7d183c$var$mediaStoreWithoutDevtools = (0, $5CQB5.createStore)()((0, $gfGec.subscribeWithSelector)((0, $i670z.immer)(()=>({
        files: {}
    }))));
const $02ffb86a5c7d183c$var$mediaStoreWithDevtools = (0, $5CQB5.createStore)()((0, $gfGec.devtools)((0, $gfGec.subscribeWithSelector)((0, $i670z.immer)(()=>({
        files: {}
    })))));
const $02ffb86a5c7d183c$export$5785580dea19518d = $02ffb86a5c7d183c$var$mediaStoreWithoutDevtools;
const $02ffb86a5c7d183c$export$503459913a0dc356 = (initialStore)=>{
    return (0, $5CQB5.createStore)()((0, $gfGec.subscribeWithSelector)((0, $i670z.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("gfGec", function(module, exports) {
$parcel$export(module.exports, "devtools", () => $bd4ecdae1fafc56d$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $bd4ecdae1fafc56d$export$5c593627aef9f076);
var $bd4ecdae1fafc56d$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/middleware.mjs"
});
const $bd4ecdae1fafc56d$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $bd4ecdae1fafc56d$export$4feba8a1bc8e9afd = $bd4ecdae1fafc56d$var$reduxImpl;
const $bd4ecdae1fafc56d$var$trackedConnections = /* @__PURE__ */ new Map();
const $bd4ecdae1fafc56d$var$getTrackedConnectionState = (name)=>{
    const api = $bd4ecdae1fafc56d$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $bd4ecdae1fafc56d$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $bd4ecdae1fafc56d$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $bd4ecdae1fafc56d$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $bd4ecdae1fafc56d$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($bd4ecdae1fafc56d$import_meta.env ? $bd4ecdae1fafc56d$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (_e) {}
        if (!extensionConnector) {
            if (($bd4ecdae1fafc56d$import_meta.env ? $bd4ecdae1fafc56d$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $bd4ecdae1fafc56d$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$bd4ecdae1fafc56d$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($bd4ecdae1fafc56d$import_meta.env ? $bd4ecdae1fafc56d$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $bd4ecdae1fafc56d$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($bd4ecdae1fafc56d$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($bd4ecdae1fafc56d$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $bd4ecdae1fafc56d$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($bd4ecdae1fafc56d$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $bd4ecdae1fafc56d$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $bd4ecdae1fafc56d$export$6922d3b3a607469e = $bd4ecdae1fafc56d$var$devtoolsImpl;
const $bd4ecdae1fafc56d$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $bd4ecdae1fafc56d$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $bd4ecdae1fafc56d$export$5c593627aef9f076 = $bd4ecdae1fafc56d$var$subscribeWithSelectorImpl;
const $bd4ecdae1fafc56d$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $bd4ecdae1fafc56d$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (_e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $bd4ecdae1fafc56d$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $bd4ecdae1fafc56d$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $bd4ecdae1fafc56d$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $bd4ecdae1fafc56d$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (_e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $bd4ecdae1fafc56d$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $bd4ecdae1fafc56d$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $bd4ecdae1fafc56d$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $bd4ecdae1fafc56d$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $bd4ecdae1fafc56d$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return [
                            true,
                            options.migrate(deserializedStorageValue.state, deserializedStorageValue.version)
                        ];
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $bd4ecdae1fafc56d$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($bd4ecdae1fafc56d$import_meta.env ? $bd4ecdae1fafc56d$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $bd4ecdae1fafc56d$var$oldImpl(config, baseOptions);
    }
    return $bd4ecdae1fafc56d$var$newImpl(config, baseOptions);
};
const $bd4ecdae1fafc56d$export$9a6132153fba2e0 = $bd4ecdae1fafc56d$var$persistImpl;

});

parcelRegister("i670z", function(module, exports) {
$parcel$export(module.exports, "immer", () => $d2ce393ce9d0c683$export$428de7ec69ac95c);

var $94gya = parcelRequire("94gya");
const $d2ce393ce9d0c683$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $94gya.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $d2ce393ce9d0c683$export$428de7ec69ac95c = $d2ce393ce9d0c683$var$immerImpl;

});
parcelRegister("94gya", function(module, exports) {
$parcel$export(module.exports, "produce", () => $69a1534911f46864$export$b46cabe22e78bc00);
// src/utils/env.ts
var $69a1534911f46864$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $69a1534911f46864$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $69a1534911f46864$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $69a1534911f46864$var$errors = [];
function $69a1534911f46864$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $69a1534911f46864$var$O = Object;
var $69a1534911f46864$var$getPrototypeOf = $69a1534911f46864$var$O.getPrototypeOf;
var $69a1534911f46864$var$CONSTRUCTOR = "constructor";
var $69a1534911f46864$var$PROTOTYPE = "prototype";
var $69a1534911f46864$var$CONFIGURABLE = "configurable";
var $69a1534911f46864$var$ENUMERABLE = "enumerable";
var $69a1534911f46864$var$WRITABLE = "writable";
var $69a1534911f46864$var$VALUE = "value";
var $69a1534911f46864$export$541ac630993a4c84 = (value)=>!!value && !!value[$69a1534911f46864$var$DRAFT_STATE];
function $69a1534911f46864$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $69a1534911f46864$var$isPlainObject(value) || $69a1534911f46864$var$isArray(value) || !!value[$69a1534911f46864$export$6ee2082928bcb0ee] || !!value[$69a1534911f46864$var$CONSTRUCTOR]?.[$69a1534911f46864$export$6ee2082928bcb0ee] || $69a1534911f46864$var$isMap(value) || $69a1534911f46864$var$isSet(value);
}
var $69a1534911f46864$var$objectCtorString = $69a1534911f46864$var$O[$69a1534911f46864$var$PROTOTYPE][$69a1534911f46864$var$CONSTRUCTOR].toString();
var $69a1534911f46864$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $69a1534911f46864$var$isPlainObject(value) {
    if (!value || !$69a1534911f46864$var$isObjectish(value)) return false;
    const proto = $69a1534911f46864$var$getPrototypeOf(value);
    if (proto === null || proto === $69a1534911f46864$var$O[$69a1534911f46864$var$PROTOTYPE]) return true;
    const Ctor = $69a1534911f46864$var$O.hasOwnProperty.call(proto, $69a1534911f46864$var$CONSTRUCTOR) && proto[$69a1534911f46864$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$69a1534911f46864$var$isFunction(Ctor)) return false;
    let ctorString = $69a1534911f46864$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $69a1534911f46864$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $69a1534911f46864$var$objectCtorString;
}
function $69a1534911f46864$export$22e8af3f75a010e3(value) {
    if (!$69a1534911f46864$export$541ac630993a4c84(value)) $69a1534911f46864$var$die(15, value);
    return value[$69a1534911f46864$var$DRAFT_STATE].base_;
}
function $69a1534911f46864$var$each(obj, iter, strict = true) {
    if ($69a1534911f46864$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $69a1534911f46864$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $69a1534911f46864$var$getArchtype(thing) {
    const state = thing[$69a1534911f46864$var$DRAFT_STATE];
    return state ? state.type_ : $69a1534911f46864$var$isArray(thing) ? 1 /* Array */  : $69a1534911f46864$var$isMap(thing) ? 2 /* Map */  : $69a1534911f46864$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $69a1534911f46864$var$has = (thing, prop, type = $69a1534911f46864$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $69a1534911f46864$var$O[$69a1534911f46864$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $69a1534911f46864$var$get = (thing, prop, type = $69a1534911f46864$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $69a1534911f46864$var$set = (thing, propOrOldValue, value, type = $69a1534911f46864$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $69a1534911f46864$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $69a1534911f46864$var$isArray = Array.isArray;
var $69a1534911f46864$var$isMap = (target)=>target instanceof Map;
var $69a1534911f46864$var$isSet = (target)=>target instanceof Set;
var $69a1534911f46864$var$isObjectish = (target)=>typeof target === "object";
var $69a1534911f46864$var$isFunction = (target)=>typeof target === "function";
var $69a1534911f46864$var$isBoolean = (target)=>typeof target === "boolean";
function $69a1534911f46864$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $69a1534911f46864$var$getProxyDraft = (value)=>{
    if (!$69a1534911f46864$var$isObjectish(value)) return null;
    return value?.[$69a1534911f46864$var$DRAFT_STATE];
};
var $69a1534911f46864$var$latest = (state)=>state.copy_ || state.base_;
var $69a1534911f46864$var$getValue = (value)=>{
    const proxyDraft = $69a1534911f46864$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $69a1534911f46864$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $69a1534911f46864$var$shallowCopy(base, strict) {
    if ($69a1534911f46864$var$isMap(base)) return new Map(base);
    if ($69a1534911f46864$var$isSet(base)) return new Set(base);
    if ($69a1534911f46864$var$isArray(base)) return Array[$69a1534911f46864$var$PROTOTYPE].slice.call(base);
    const isPlain = $69a1534911f46864$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $69a1534911f46864$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$69a1534911f46864$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$69a1534911f46864$var$WRITABLE] === false) {
                desc[$69a1534911f46864$var$WRITABLE] = true;
                desc[$69a1534911f46864$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$69a1534911f46864$var$CONFIGURABLE]: true,
                [$69a1534911f46864$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$69a1534911f46864$var$ENUMERABLE]: desc[$69a1534911f46864$var$ENUMERABLE],
                [$69a1534911f46864$var$VALUE]: base[key]
            };
        }
        return $69a1534911f46864$var$O.create($69a1534911f46864$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $69a1534911f46864$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $69a1534911f46864$var$O.create(proto);
        return $69a1534911f46864$var$O.assign(obj, base);
    }
}
function $69a1534911f46864$export$792f3d81ea979f55(obj, deep = false) {
    if ($69a1534911f46864$var$isFrozen(obj) || $69a1534911f46864$export$541ac630993a4c84(obj) || !$69a1534911f46864$export$16e3aed3edb85946(obj)) return obj;
    if ($69a1534911f46864$var$getArchtype(obj) > 1) $69a1534911f46864$var$O.defineProperties(obj, {
        set: $69a1534911f46864$var$dontMutateMethodOverride,
        add: $69a1534911f46864$var$dontMutateMethodOverride,
        clear: $69a1534911f46864$var$dontMutateMethodOverride,
        delete: $69a1534911f46864$var$dontMutateMethodOverride
    });
    $69a1534911f46864$var$O.freeze(obj);
    if (deep) $69a1534911f46864$var$each(obj, (_key, value)=>{
        $69a1534911f46864$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $69a1534911f46864$var$dontMutateFrozenCollections() {
    $69a1534911f46864$var$die(2);
}
var $69a1534911f46864$var$dontMutateMethodOverride = {
    [$69a1534911f46864$var$VALUE]: $69a1534911f46864$var$dontMutateFrozenCollections
};
function $69a1534911f46864$var$isFrozen(obj) {
    if (obj === null || !$69a1534911f46864$var$isObjectish(obj)) return true;
    return $69a1534911f46864$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $69a1534911f46864$var$PluginMapSet = "MapSet";
var $69a1534911f46864$var$PluginPatches = "Patches";
var $69a1534911f46864$var$PluginArrayMethods = "ArrayMethods";
var $69a1534911f46864$var$plugins = {};
function $69a1534911f46864$var$getPlugin(pluginKey) {
    const plugin = $69a1534911f46864$var$plugins[pluginKey];
    if (!plugin) $69a1534911f46864$var$die(0, pluginKey);
    return plugin;
}
var $69a1534911f46864$var$isPluginLoaded = (pluginKey)=>!!$69a1534911f46864$var$plugins[pluginKey];
function $69a1534911f46864$var$loadPlugin(pluginKey, implementation) {
    if (!$69a1534911f46864$var$plugins[pluginKey]) $69a1534911f46864$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $69a1534911f46864$var$currentScope;
var $69a1534911f46864$var$getCurrentScope = ()=>$69a1534911f46864$var$currentScope;
var $69a1534911f46864$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $69a1534911f46864$var$isPluginLoaded($69a1534911f46864$var$PluginMapSet) ? $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $69a1534911f46864$var$isPluginLoaded($69a1534911f46864$var$PluginArrayMethods) ? $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginArrayMethods) : void 0
    });
function $69a1534911f46864$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $69a1534911f46864$var$revokeScope(scope) {
    $69a1534911f46864$var$leaveScope(scope);
    scope.drafts_.forEach($69a1534911f46864$var$revokeDraft);
    scope.drafts_ = null;
}
function $69a1534911f46864$var$leaveScope(scope) {
    if (scope === $69a1534911f46864$var$currentScope) $69a1534911f46864$var$currentScope = scope.parent_;
}
var $69a1534911f46864$var$enterScope = (immer2)=>$69a1534911f46864$var$currentScope = $69a1534911f46864$var$createScope($69a1534911f46864$var$currentScope, immer2);
function $69a1534911f46864$var$revokeDraft(draft) {
    const state = draft[$69a1534911f46864$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $69a1534911f46864$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$69a1534911f46864$var$DRAFT_STATE].modified_) {
            $69a1534911f46864$var$revokeScope(scope);
            $69a1534911f46864$var$die(4);
        }
        if ($69a1534911f46864$export$16e3aed3edb85946(result)) result = $69a1534911f46864$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$69a1534911f46864$var$DRAFT_STATE].base_, result, scope);
    } else result = $69a1534911f46864$var$finalize(scope, baseDraft);
    $69a1534911f46864$var$maybeFreeze(scope, result, true);
    $69a1534911f46864$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $69a1534911f46864$export$45b790e32b2810ee ? result : void 0;
}
function $69a1534911f46864$var$finalize(rootScope, value) {
    if ($69a1534911f46864$var$isFrozen(value)) return value;
    const state = value[$69a1534911f46864$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $69a1534911f46864$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$69a1534911f46864$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $69a1534911f46864$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $69a1534911f46864$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $69a1534911f46864$export$792f3d81ea979f55(value, deep);
}
function $69a1534911f46864$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $69a1534911f46864$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $69a1534911f46864$var$EMPTY_LOCATIONS_RESULT = [];
function $69a1534911f46864$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $69a1534911f46864$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $69a1534911f46864$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $69a1534911f46864$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $69a1534911f46864$var$each(parentCopy, (key, value)=>{
            if ($69a1534911f46864$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $69a1534911f46864$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$69a1534911f46864$var$set(parentCopy, location, finalizedValue, parentType);
}
function $69a1534911f46864$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$69a1534911f46864$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $69a1534911f46864$var$getFinalValue(state);
        $69a1534911f46864$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $69a1534911f46864$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $69a1534911f46864$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $69a1534911f46864$var$markStateFinalized(state);
    }
}
function $69a1534911f46864$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($69a1534911f46864$export$541ac630993a4c84(value)) {
        const state = value[$69a1534911f46864$var$DRAFT_STATE];
        if ($69a1534911f46864$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $69a1534911f46864$var$prepareCopy(target);
            const finalizedValue = $69a1534911f46864$var$getFinalValue(state);
            $69a1534911f46864$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($69a1534911f46864$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $69a1534911f46864$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $69a1534911f46864$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($69a1534911f46864$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $69a1534911f46864$var$handleValue($69a1534911f46864$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $69a1534911f46864$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($69a1534911f46864$export$541ac630993a4c84(target) || handledSet.has(target) || !$69a1534911f46864$export$16e3aed3edb85946(target) || $69a1534911f46864$var$isFrozen(target)) return target;
    handledSet.add(target);
    $69a1534911f46864$var$each(target, (key, value)=>{
        if ($69a1534911f46864$export$541ac630993a4c84(value)) {
            const state = value[$69a1534911f46864$var$DRAFT_STATE];
            if ($69a1534911f46864$var$isSameScope(state, rootScope)) {
                const updatedValue = $69a1534911f46864$var$getFinalValue(state);
                $69a1534911f46864$var$set(target, key, updatedValue, target.type_);
                $69a1534911f46864$var$markStateFinalized(state);
            }
        } else if ($69a1534911f46864$export$16e3aed3edb85946(value)) $69a1534911f46864$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $69a1534911f46864$var$createProxyProxy(base, parent) {
    const baseIsArray = $69a1534911f46864$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $69a1534911f46864$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $69a1534911f46864$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $69a1534911f46864$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $69a1534911f46864$var$objectTraps = {
    get (state, prop) {
        if (prop === $69a1534911f46864$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $69a1534911f46864$var$latest(state);
        if (!$69a1534911f46864$var$has(source, prop, state.type_)) return $69a1534911f46864$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$69a1534911f46864$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $69a1534911f46864$var$isArrayIndex(prop)) return value;
        if (value === $69a1534911f46864$var$peek(state.base_, prop)) {
            $69a1534911f46864$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $69a1534911f46864$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $69a1534911f46864$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($69a1534911f46864$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $69a1534911f46864$var$getDescriptorFromProto($69a1534911f46864$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $69a1534911f46864$var$peek($69a1534911f46864$var$latest(state), prop);
            const currentState = current2?.[$69a1534911f46864$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($69a1534911f46864$var$is(value, current2) && (value !== void 0 || $69a1534911f46864$var$has(state.base_, prop, state.type_))) return true;
            $69a1534911f46864$var$prepareCopy(state);
            $69a1534911f46864$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $69a1534911f46864$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $69a1534911f46864$var$prepareCopy(state);
        if ($69a1534911f46864$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $69a1534911f46864$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $69a1534911f46864$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$69a1534911f46864$var$WRITABLE]: true,
            [$69a1534911f46864$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$69a1534911f46864$var$ENUMERABLE]: desc[$69a1534911f46864$var$ENUMERABLE],
            [$69a1534911f46864$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $69a1534911f46864$var$die(11);
    },
    getPrototypeOf (state) {
        return $69a1534911f46864$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $69a1534911f46864$var$die(12);
    }
};
var $69a1534911f46864$var$arrayTraps = {};
for(let key in $69a1534911f46864$var$objectTraps){
    let fn = $69a1534911f46864$var$objectTraps[key];
    $69a1534911f46864$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$69a1534911f46864$var$arrayTraps.deleteProperty = function(state, prop) {
    return $69a1534911f46864$var$arrayTraps.set.call(this, state, prop, void 0);
};
$69a1534911f46864$var$arrayTraps.set = function(state, prop, value) {
    return $69a1534911f46864$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $69a1534911f46864$var$peek(draft, prop) {
    const state = draft[$69a1534911f46864$var$DRAFT_STATE];
    const source = state ? $69a1534911f46864$var$latest(state) : draft;
    return source[prop];
}
function $69a1534911f46864$var$readPropFromProto(state, source, prop) {
    const desc = $69a1534911f46864$var$getDescriptorFromProto(source, prop);
    return desc ? $69a1534911f46864$var$VALUE in desc ? desc[$69a1534911f46864$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $69a1534911f46864$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $69a1534911f46864$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $69a1534911f46864$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $69a1534911f46864$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $69a1534911f46864$var$markChanged(state.parent_);
    }
}
function $69a1534911f46864$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $69a1534911f46864$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $69a1534911f46864$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($69a1534911f46864$var$isFunction(base) && !$69a1534911f46864$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$69a1534911f46864$var$isFunction(recipe)) $69a1534911f46864$var$die(6);
            if (patchListener !== void 0 && !$69a1534911f46864$var$isFunction(patchListener)) $69a1534911f46864$var$die(7);
            let result;
            if ($69a1534911f46864$export$16e3aed3edb85946(base)) {
                const scope = $69a1534911f46864$var$enterScope(this);
                const proxy = $69a1534911f46864$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $69a1534911f46864$var$revokeScope(scope);
                    else $69a1534911f46864$var$leaveScope(scope);
                }
                $69a1534911f46864$var$usePatchesInScope(scope, patchListener);
                return $69a1534911f46864$var$processResult(result, scope);
            } else if (!base || !$69a1534911f46864$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $69a1534911f46864$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $69a1534911f46864$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $69a1534911f46864$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($69a1534911f46864$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($69a1534911f46864$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($69a1534911f46864$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($69a1534911f46864$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$69a1534911f46864$export$16e3aed3edb85946(base)) $69a1534911f46864$var$die(8);
        if ($69a1534911f46864$export$541ac630993a4c84(base)) base = $69a1534911f46864$export$97aac956da55dae9(base);
        const scope = $69a1534911f46864$var$enterScope(this);
        const proxy = $69a1534911f46864$var$createProxy(scope, base, void 0);
        proxy[$69a1534911f46864$var$DRAFT_STATE].isManual_ = true;
        $69a1534911f46864$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$69a1534911f46864$var$DRAFT_STATE];
        if (!state || !state.isManual_) $69a1534911f46864$var$die(9);
        const { scope_: scope } = state;
        $69a1534911f46864$var$usePatchesInScope(scope, patchListener);
        return $69a1534911f46864$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginPatches).applyPatches_;
        if ($69a1534911f46864$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $69a1534911f46864$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $69a1534911f46864$var$isMap(value) ? $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginMapSet).proxyMap_(value, parent) : $69a1534911f46864$var$isSet(value) ? $69a1534911f46864$var$getPlugin($69a1534911f46864$var$PluginMapSet).proxySet_(value, parent) : $69a1534911f46864$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $69a1534911f46864$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $69a1534911f46864$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $69a1534911f46864$export$97aac956da55dae9(value) {
    if (!$69a1534911f46864$export$541ac630993a4c84(value)) $69a1534911f46864$var$die(10, value);
    return $69a1534911f46864$var$currentImpl(value);
}
function $69a1534911f46864$var$currentImpl(value) {
    if (!$69a1534911f46864$export$16e3aed3edb85946(value) || $69a1534911f46864$var$isFrozen(value)) return value;
    const state = value[$69a1534911f46864$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $69a1534911f46864$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $69a1534911f46864$var$shallowCopy(value, true);
    $69a1534911f46864$var$each(copy, (key, childValue)=>{
        $69a1534911f46864$var$set(copy, key, $69a1534911f46864$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $69a1534911f46864$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $69a1534911f46864$var$getProxyDraft($69a1534911f46864$var$get(parentCopy, state.key_));
            const valueAtKey = $69a1534911f46864$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $69a1534911f46864$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $69a1534911f46864$var$get(current2, key);
            if (!$69a1534911f46864$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$69a1534911f46864$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $69a1534911f46864$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $69a1534911f46864$var$get(base_, key, type_);
            const value = $69a1534911f46864$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $69a1534911f46864$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $69a1534911f46864$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $69a1534911f46864$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $69a1534911f46864$var$CONSTRUCTOR)) $69a1534911f46864$var$die(errorOffset + 3);
                if ($69a1534911f46864$var$isFunction(base) && p === $69a1534911f46864$var$PROTOTYPE) $69a1534911f46864$var$die(errorOffset + 3);
                base = $69a1534911f46864$var$get(base, p);
                if (!$69a1534911f46864$var$isObjectish(base)) $69a1534911f46864$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $69a1534911f46864$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $69a1534911f46864$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $69a1534911f46864$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$69a1534911f46864$export$16e3aed3edb85946(obj)) return obj;
        if ($69a1534911f46864$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($69a1534911f46864$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($69a1534911f46864$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($69a1534911f46864$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($69a1534911f46864$var$has(obj, $69a1534911f46864$export$6ee2082928bcb0ee)) cloned[$69a1534911f46864$export$6ee2082928bcb0ee] = obj[$69a1534911f46864$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($69a1534911f46864$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $69a1534911f46864$var$loadPlugin($69a1534911f46864$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $69a1534911f46864$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$69a1534911f46864$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $69a1534911f46864$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $69a1534911f46864$var$latest(this[$69a1534911f46864$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $69a1534911f46864$var$latest(this[$69a1534911f46864$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$69a1534911f46864$var$latest(state).has(key) || $69a1534911f46864$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $69a1534911f46864$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $69a1534911f46864$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $69a1534911f46864$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($69a1534911f46864$var$latest(state).size) {
                prepareMapCopy(state);
                $69a1534911f46864$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $69a1534911f46864$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            $69a1534911f46864$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $69a1534911f46864$var$latest(state).get(key);
            if (state.finalized_ || !$69a1534911f46864$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $69a1534911f46864$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $69a1534911f46864$var$latest(this[$69a1534911f46864$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($69a1534911f46864$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$69a1534911f46864$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$69a1534911f46864$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $69a1534911f46864$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $69a1534911f46864$var$latest(this[$69a1534911f46864$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $69a1534911f46864$var$markChanged(state);
                state.copy_.add(value);
                $69a1534911f46864$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $69a1534911f46864$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($69a1534911f46864$var$latest(state).size) {
                prepareSetCopy(state);
                $69a1534911f46864$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$69a1534911f46864$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($69a1534911f46864$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$69a1534911f46864$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($69a1534911f46864$export$16e3aed3edb85946(value)) {
                    const draft = $69a1534911f46864$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $69a1534911f46864$var$die(3, JSON.stringify($69a1534911f46864$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($69a1534911f46864$var$getValue(value));
            });
        }
    }
    $69a1534911f46864$var$loadPlugin($69a1534911f46864$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $69a1534911f46864$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $69a1534911f46864$var$prepareCopy(state);
        const result = operation();
        $69a1534911f46864$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $69a1534911f46864$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $69a1534911f46864$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $69a1534911f46864$var$loadPlugin($69a1534911f46864$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $69a1534911f46864$var$immer = new $69a1534911f46864$export$aaadc6ff0f822719();
var $69a1534911f46864$export$b46cabe22e78bc00 = $69a1534911f46864$var$immer.produce;
var $69a1534911f46864$export$4da66d41c9492c78 = /* @__PURE__ */ $69a1534911f46864$var$immer.produceWithPatches.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$573f26f60825c493 = /* @__PURE__ */ $69a1534911f46864$var$immer.setAutoFreeze.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$333ce65961cbe047 = /* @__PURE__ */ $69a1534911f46864$var$immer.setUseStrictShallowCopy.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$1045b3be3904c489 = /* @__PURE__ */ $69a1534911f46864$var$immer.setUseStrictIteration.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $69a1534911f46864$var$immer.applyPatches.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$3c3214997190395f = /* @__PURE__ */ $69a1534911f46864$var$immer.createDraft.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$c60f5e69c521b528 = /* @__PURE__ */ $69a1534911f46864$var$immer.finishDraft.bind($69a1534911f46864$var$immer);
var $69a1534911f46864$export$c05b21e3257751e5 = (value)=>value;
var $69a1534911f46864$export$20f911b3f8cf0b74 = (value)=>value;

});


parcelRegister("5CQB5", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $41894d1226762e12$export$f51a9068ac82ea43);
var $41894d1226762e12$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/vanilla.mjs"
});
const $41894d1226762e12$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($41894d1226762e12$import_meta.env ? $41894d1226762e12$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $41894d1226762e12$export$f51a9068ac82ea43 = (createState)=>createState ? $41894d1226762e12$var$createStoreImpl(createState) : $41894d1226762e12$var$createStoreImpl;
var $41894d1226762e12$export$2e2bcd8739ae039 = (createState)=>{
    if (($41894d1226762e12$import_meta.env ? $41894d1226762e12$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $41894d1226762e12$export$f51a9068ac82ea43(createState);
};

});



parcelRegister("ghScr", function(module, exports) {
$parcel$export(module.exports, "createCopyIntentRegisterationBatcher", () => $3539bf03103166b3$export$57945b6819e39246);

var $dasBT = parcelRequire("dasBT");

var $50oso = parcelRequire("50oso");
const $3539bf03103166b3$export$b79d95ee17a87a = 100;
/**
 * Returns a function that, given Array<DataloaderKey>, resolves to an array of same length containing either DataloaderResult or Error.
 * Such contract is formalised by Dataloader 1.0, @see https://github.com/graphql/dataloader
 *
 * If an Error is resolved in the results, it must be at same position then their corresponding key:
 * - Dataloader will re-throw that Error when accessing/loading that particular key
 *
 * @param mediaStore instance of MediaStore
 */ function $3539bf03103166b3$var$createBatchCopyIntentRegisterationFunc(mediaStore) {
    return async (keys)=>{
        const keysByToken = keys.reduce((acc, key)=>{
            const token = key.resolvedAuth.token;
            acc[token] = acc[token] || [];
            // de-duplicate ids in collection
            const hasDuplicates = acc[token].some(({ id: id, collectionName: collectionName })=>key.id === id && collectionName === key.collectionName);
            if (!hasDuplicates) acc[token].push(key);
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(keysByToken).map(async (batchKey)=>{
            const metadataTraceContext = {
                traceId: (0, $50oso.getRandomTelemetryId)(),
                spanId: (0, $50oso.getRandomTelemetryId)()
            };
            const files = keysByToken[batchKey].map((key)=>({
                    id: key.id,
                    collection: key.collectionName
                }));
            // given these are batched by the token the assumption is that they have the same details.
            const resolvedAuth = keysByToken[batchKey][0].resolvedAuth;
            try {
                await mediaStore.registerCopyIntents(files, metadataTraceContext, resolvedAuth);
            } catch (error) {
                files.forEach(({ id: id, collection: collection })=>{
                    items.push({
                        id: id,
                        collection: collection,
                        error: error
                    });
                });
            }
        }));
        return keys.map(({ id: id, collectionName: collectionName })=>{
            var _items$find;
            return (_items$find = items.find((item)=>item.id === id && item.collection === collectionName)) === null || _items$find === void 0 ? void 0 : _items$find.error;
        });
    };
}
function $3539bf03103166b3$export$57945b6819e39246(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($dasBT)))($3539bf03103166b3$var$createBatchCopyIntentRegisterationFunc(mediaStore), {
        maxBatchSize: $3539bf03103166b3$export$b79d95ee17a87a,
        cacheKeyFn: ({ id: id, collectionName: collectionName = 'default', resolvedAuth: resolvedAuth })=>`${id}-${collectionName}-${resolvedAuth.token}`
    });
}

});


parcelRegister("cmgGQ", function(module, exports) {
$parcel$export(module.exports, "StargateClient", () => $859eeb280ed32430$export$c66ca190f89caaac);
class $859eeb280ed32430$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("P448X", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("5UylG").then(()=>parcelRequire('6v1UN'));

});



parcelRegister("glWLN", function(module, exports) {
$parcel$export(module.exports, "MediaClientContext", () => $d6775f2e1ca43923$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $d6775f2e1ca43923$export$5bff351c86f56d97);

var $4fqPo = parcelRequire("4fqPo");

var $dZ5TE = parcelRequire("dZ5TE");
const $d6775f2e1ca43923$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(undefined);
const $d6775f2e1ca43923$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $4fqPo.useMemo)(()=>(0, $dZ5TE.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($d6775f2e1ca43923$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};

});


parcelRegister("fFjZu", function(module, exports) {
$parcel$export(module.exports, "useFilePreview", () => $06876f230243be0a$export$4eaebdef02112fe4);

var $4fqPo = parcelRequire("4fqPo");

var $lNtM5 = parcelRequire("lNtM5");
var $5OUhX = parcelRequire("5OUhX");

var $gYgOI = parcelRequire("gYgOI");
var $2OJ0O = parcelRequire("2OJ0O");
var $SrmYg = parcelRequire("SrmYg");

var $a1rbz = parcelRequire("a1rbz");

var $3H4LK = parcelRequire("3H4LK");

var $gE3od = parcelRequire("gE3od");

var $fRrk1 = parcelRequire("fRrk1");

var $2GV52 = parcelRequire("2GV52");

var $dEYmx = parcelRequire("dEYmx");
var $1Q8uH = parcelRequire("1Q8uH");
var $2vWpE = parcelRequire("2vWpE");

var $exGjH = parcelRequire("exGjH");
var $c24a6 = parcelRequire("c24a6");

var $kcniu = parcelRequire("kcniu");
// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $06876f230243be0a$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $06876f230243be0a$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: // TODO: mediaBlobUrlAttrs can be missing several values contained in the file details. The preview hook is not updating the params in the preview after the file details are available.
allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source, initialFileState: initialFileState })=>{
    const mediaClient = (0, $SrmYg.useMediaClient)();
    const [status, setStatus] = (0, $4fqPo.useState)('loading');
    const [error, setError] = (0, $4fqPo.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $4fqPo.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $4fqPo.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $4fqPo.useState)('not-resolved');
    const ssrReliabilityRef = (0, $4fqPo.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $gE3od.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $4fqPo.useState)(false);
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (isLoading && (0, $3H4LK.fg)('platform_close_image_blindspot_2')) return ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $4fqPo.useMemo)(()=>dimensions ? (0, $kcniu.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $kcniu.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $2vWpE.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $c24a6.getSSRData)(identifier, resizeMode);
            if (ssrData !== null && ssrData !== void 0 && ssrData.error) ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                server: {
                    status: 'fail',
                    ...ssrData.error
                }
            };
            if (!(ssrData !== null && ssrData !== void 0 && ssrData.dataURI)) {
                // Only attempt SSR preview generation if:
                // 1. We're on the server (ssr='server'), OR
                // 2. We're on the client AND there is SSR data (meaning SSR actually happened)
                // If ssr='client' but there's no SSR data, it means this is a client-side navigation
                // where no SSR occurred, so we should skip SSR preview generation entirely.
                if (ssr === 'server' || ssrData) try {
                    // When the relay/SSR-seed path provided a pre-signed CDN URL,
                    // overlay its CDN-signing query params on the URL produced by
                    // getImageUrlSync. This makes the SSR-rendered HTML use the
                    // cdn-signed URL directly (no auth-token -> cdn-signed swap on
                    // hydration) and the 'ssr-data' rehydration path inherits it
                    // automatically via globalScope.
                    const seededCdnUrl = initialFileState && initialFileState.status !== 'error' ? initialFileState.previewCdnUrl : undefined;
                    const cdnSigningParams = seededCdnUrl && (0, $3H4LK.fg)('platform_media_ssr_data_seed') ? (0, $dEYmx.extractCdnSigningParams)(seededCdnUrl) : undefined;
                    return (0, $dEYmx.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs, cdnSigningParams);
                } catch (e) {
                    ssrReliabilityRef.current = {
                        ...ssrReliabilityRef.current,
                        [ssr]: {
                            status: 'fail',
                            ...(0, $fRrk1.extractErrorInfo)(e, traceContext)
                        }
                    };
                }
            } else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet, loading: loading } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet,
                    lazy: loading === 'lazy'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $4fqPo.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $2OJ0O.useFileState)(identifier.id, {
        initialFileState: initialFileState,
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $lNtM5.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && (fileState === null || fileState === void 0 ? void 0 : fileState.status) !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $4fqPo.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $2GV52.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && (fileState === null || fileState === void 0 ? void 0 : fileState.status) === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $2GV52.MediaFilePreviewError)('metadata-fetch', (0, $5OUhX.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // SSR Loading
    //----------------------------------------------------------------
    (0, $4fqPo.useEffect)(()=>{
        var _getSSRData;
        if (!(0, $3H4LK.fg)('media-perf-uplift-mutation-fix')) return;
        const loadPromise = (_getSSRData = (0, $c24a6.getSSRData)(identifier, resizeMode)) === null || _getSSRData === void 0 ? void 0 : _getSSRData.loadPromise;
        if (preview && (0, $dEYmx.isSSRDataPreview)(preview) && loadPromise) loadPromise.then(()=>{
            setStatus('complete');
        }).catch(()=>{
            setPreview(undefined);
        });
    }, [
        preview,
        identifier,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $kcniu.useCurrentValueRef)(()=>{
        return (0, $dEYmx.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $4fqPo.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $kcniu.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $kcniu.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $4fqPo.useEffect)(()=>{
        const cachedPreview = (0, $2vWpE.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $kcniu.isBigger)(cachedPreview === null || cachedPreview === void 0 ? void 0 : cachedPreview.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $1Q8uH.isSupportedLocalPreview)(mediaType) && (0, $a1rbz.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $dEYmx.getAndCacheLocalPreview)(mediaClient, identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current, identifier.collectionName).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $kcniu.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $dEYmx.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR, we can skip the refetch as it will be handled by the global scope promise
            // If the preview is not wider than the requested dimensions, we can skip the refetch
            if (preview && (0, $dEYmx.isSSRPreview)(preview) && !(0, $kcniu.isWider)(preview.dimensions, dimensions) && (0, $3H4LK.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $2GV52.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        identifier.collectionName,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        mediaClient,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus,
        dimensions
    ]);
    //----------------------------------------------------------------
    // Cache ref tracking — prevent blob URL eviction while mounted
    //----------------------------------------------------------------
    (0, $4fqPo.useEffect)(()=>{
        (0, $2vWpE.mediaFilePreviewCache).acquire(identifier.id, resizeMode);
        return ()=>{
            (0, $2vWpE.mediaFilePreviewCache).release(identifier.id, resizeMode);
        };
    }, [
        identifier.id,
        resizeMode
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $4fqPo.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $dEYmx.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current = {
            ...ssrReliabilityRef.current,
            client: (0, $fRrk1.createFailedSSRObject)(failedPreview, traceContext)
        };
        const isSSR = (0, $dEYmx.isSSRDataPreview)(failedPreview) || (0, $dEYmx.isSSRClientPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) ssrReliabilityRef.current = {
            server: (0, $fRrk1.createFailedSSRObject)(failedPreview, traceContext),
            client: (0, $fRrk1.createFailedSSRObject)(failedPreview, traceContext)
        };
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
        const isLocal = (0, $dEYmx.isLocalPreview)(failedPreview);
        const isRemote = (0, $dEYmx.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $2GV52.ImageLoadError)(failedPreview === null || failedPreview === void 0 ? void 0 : failedPreview.source);
            (0, $2vWpE.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview === null || preview === void 0 ? void 0 : preview.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $4fqPo.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $dEYmx.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current = {
                ...ssrReliabilityRef.current,
                client: {
                    status: 'success'
                }
            };
            /*
          If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
        */ if ((0, $dEYmx.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
            /*
      Handle 'ssr-server' source which is used when:
      1. ssr='server' is passed to getSSRPreview (server-side rendering)
      2. DEFAULT_SSR_PREVIEW is used (placeholder during SSR)
      This ensures ssrReliability is updated to 'success' when the server-rendered image loads.
      */ if (newPreview.source === 'ssr-server' && ssrReliabilityRef.current.server.status === 'unknown') ssrReliabilityRef.current = {
                server: {
                    status: 'success'
                },
                client: {
                    status: 'success'
                }
            };
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if ((newPreview === null || newPreview === void 0 ? void 0 : newPreview.dataURI) !== (preview === null || preview === void 0 ? void 0 : preview.dataURI)) return;
    }, [
        preview === null || preview === void 0 ? void 0 : preview.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>{
        var _ssrReliabilityRef$cu;
        return (0, $exGjH.generateScriptProps)(identifier, preview === null || preview === void 0 ? void 0 : preview.dataURI, resizeMode, preview === null || preview === void 0 ? void 0 : preview.srcSet, requestDimensions, ((_ssrReliabilityRef$cu = ssrReliabilityRef.current.server) === null || _ssrReliabilityRef$cu === void 0 ? void 0 : _ssrReliabilityRef$cu.status) === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $3H4LK.fg)('media-perf-uplift-mutation-fix'),
            'media-perf-lazy-loading-optimisation': (0, $3H4LK.fg)('media-perf-lazy-loading-optimisation')
        });
    } : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $gYgOI.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $3H4LK.fg)('media-perf-uplift-mutation-fix') ? $06876f230243be0a$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("gYgOI", function(module, exports) {
$parcel$export(module.exports, "useCopyIntent", () => $904bfa1fd4282790$export$46fd859414de9d62);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $3H4LK = parcelRequire("3H4LK");

var $SrmYg = parcelRequire("SrmYg");

var $g1kkN = parcelRequire("g1kkN");

var $3rm4r = parcelRequire("3rm4r");
function $904bfa1fd4282790$var$useCurrentValueRef(value) {
    const ref = (0, $4fqPo.useRef)(value);
    ref.current = value;
    return ref;
}
const $904bfa1fd4282790$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $SrmYg.useMediaClient)();
    const innerRef = (0, $4fqPo.useRef)(null);
    const clientIdRef = (0, $4fqPo.useRef)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    // Pre-fetch clientId so it's available synchronously during copy event
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $3H4LK.fg)('platform_media_cross_client_copy_with_auth')) mediaClient.getClientId(options.collectionName).then((clientId)=>{
            clientIdRef.current = clientId;
        }).catch(()=>{
        // Silently handle - product might not have authProvider configured
        });
    }, [
        mediaClient,
        options.collectionName
    ]);
    const registerCopyIntentRef = $904bfa1fd4282790$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $g1kkN.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $g1kkN.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $4fqPo.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $3H4LK.fg)('platform_media_cross_client_copy')) elem === null || elem === void 0 || elem.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $4fqPo.useCallback)((event)=>{
        var _getSelection;
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && ((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.containsNode(currentCopyTarget, true));
        if (currentSelectionContainsNode) {
            registerCopyIntentRef.current();
            // Add clientId to the copied HTML (must be synchronous)
            if ((0, $3H4LK.fg)('platform_media_cross_client_copy_with_auth')) {
                var _event$clipboardData;
                const clientId = clientIdRef.current;
                const html = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/html');
                // Look for media nodes by data-node-type which is always present
                if (html && html.includes('data-node-type="media') && clientId) {
                    var _event$clipboardData2;
                    // Insert data-client-id after data-node-type="media" or data-node-type="mediaInline"
                    const modifiedHtml = html.replace(/(<[^>]*data-node-type="media(?:Inline)?")([^>]*>)/g, `$1 data-client-id="${clientId}"$2`);
                    (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 || _event$clipboardData2.setData('text/html', modifiedHtml);
                }
            }
        }
    }, [
        registerCopyIntentRef
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $3H4LK.fg)('platform_media_cross_client_copy')) {
            var _getDocument;
            (_getDocument = (0, $3rm4r.getDocument)()) === null || _getDocument === void 0 || _getDocument.addEventListener('copy', onGlobalCopy);
        }
        return ()=>{
            var _getDocument2;
            return (_getDocument2 = (0, $3rm4r.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.removeEventListener('copy', onGlobalCopy);
        };
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("SrmYg", function(module, exports) {
$parcel$export(module.exports, "useMediaClient", () => $ff5dc7313005130d$export$8b3e87ea56c3a345);

var $4fqPo = parcelRequire("4fqPo");

var $glWLN = parcelRequire("glWLN");

var $iMfVH = parcelRequire("iMfVH");
const $ff5dc7313005130d$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext((0, $glWLN.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext((0, $iMfVH.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("iMfVH", function(module, exports) {
$parcel$export(module.exports, "MediaContext", () => $62a490bc2356ab61$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $62a490bc2356ab61$export$57164260bc1f1218);

var $4fqPo = parcelRequire("4fqPo");

var $dZ5TE = parcelRequire("dZ5TE");

var $jgfN0 = parcelRequire("jgfN0");
const $62a490bc2356ab61$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(undefined);
const $62a490bc2356ab61$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $4fqPo.useMemo)(()=>(0, $dZ5TE.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $jgfN0.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($62a490bc2356ab61$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};

});
parcelRegister("jgfN0", function(module, exports) {
$parcel$export(module.exports, "useMediaParsedSettings", () => $68ffc6e3493838a7$export$d54af28440a5efc0);

var $4fqPo = parcelRequire("4fqPo");

var $7KIgy = parcelRequire("7KIgy");
const $68ffc6e3493838a7$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $4fqPo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $7KIgy.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("7KIgy", function(module, exports) {
$parcel$export(module.exports, "defaultMediaUserPreferences", () => $39dbd3980dde793e$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $39dbd3980dde793e$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $39dbd3980dde793e$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($39dbd3980dde793e$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $39dbd3980dde793e$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $39dbd3980dde793e$export$2d23ed2854ac1650 = $39dbd3980dde793e$export$7e209e67b965bc63($39dbd3980dde793e$var$defaultUserPreferences);

});




parcelRegister("g1kkN", function(module, exports) {
$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $10ae5b391b3da4fb$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $10ae5b391b3da4fb$export$aacb463551da2e8f);

var $6kTGv = parcelRequire("6kTGv");
const $10ae5b391b3da4fb$var$getRequestErrorDetails = (err)=>{
    if ((0, $6kTGv.isRequestError)(err)) {
        var _err$metadata, _err$metadata2, _err$metadata3, _err$metadata4;
        return {
            request: {
                statusCode: (_err$metadata = err.metadata) === null || _err$metadata === void 0 ? void 0 : _err$metadata.statusCode,
                traceContext: (_err$metadata2 = err.metadata) === null || _err$metadata2 === void 0 ? void 0 : _err$metadata2.traceContext,
                mediaEnv: (_err$metadata3 = err.metadata) === null || _err$metadata3 === void 0 ? void 0 : _err$metadata3.mediaEnv,
                mediaRegion: (_err$metadata4 = err.metadata) === null || _err$metadata4 === void 0 ? void 0 : _err$metadata4.mediaRegion
            }
        };
    }
    return undefined;
};
const $10ae5b391b3da4fb$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $6kTGv.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$10ae5b391b3da4fb$var$getRequestErrorDetails(error)
        }
    };
};
const $10ae5b391b3da4fb$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("3rm4r", function(module, exports) {
$parcel$export(module.exports, "getDocument", () => $8c88115ec90078a6$export$f65ca476c09acec0);
const $8c88115ec90078a6$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("2OJ0O", function(module, exports) {
$parcel$export(module.exports, "useFileState", () => $b35ab84bbf1f6254$export$90ff537b0999afb);

var $4fqPo = parcelRequire("4fqPo");

var $SrmYg = parcelRequire("SrmYg");

var $1l8R7 = parcelRequire("1l8R7");
function $b35ab84bbf1f6254$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles, initialFileState: initialFileState } = options;
    const mediaClient = (0, $SrmYg.useMediaClient)();
    const fileState = (0, $1l8R7.useMediaStore)((state)=>state.files[id]);
    // Capture initialFileState as a ref so it's a stable one-time SSR seed that
    // doesn't affect the useEffect dependency array. Including it directly would
    // cause repeated unsubscribe/resubscribe cycles whenever the caller passes a
    // new (unstabilized) object reference — each cycle fires getFileState before
    // the store is populated.
    const initialFileStateRef = (0, $4fqPo.useRef)(initialFileState);
    (0, $4fqPo.useEffect)(()=>{
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            initialFileState: initialFileStateRef.current,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState ?? initialFileState
    };
}

});
parcelRegister("1l8R7", function(module, exports) {
$parcel$export(module.exports, "useMediaStore", () => $c1ebac8d47f007d3$export$8a9cc8c330400af8);

var $ltSFx = parcelRequire("ltSFx");

var $SrmYg = parcelRequire("SrmYg");
const $c1ebac8d47f007d3$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $ltSFx.useStore)(store, selector, equals);
function $c1ebac8d47f007d3$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $SrmYg.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $c1ebac8d47f007d3$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("ltSFx", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $fa36b6888f8151ad$export$6ccbb43953eebf8);

var $5CQB5 = parcelRequire("5CQB5");

var $4fqPo = parcelRequire("4fqPo");

var $gCoJE = parcelRequire("gCoJE");
var $fa36b6888f8151ad$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $fa36b6888f8151ad$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo)));
const { useSyncExternalStoreWithSelector: $fa36b6888f8151ad$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($gCoJE)));
let $fa36b6888f8151ad$var$didWarnAboutEqualityFn = false;
const $fa36b6888f8151ad$var$identity = (arg)=>arg;
function $fa36b6888f8151ad$export$6ccbb43953eebf8(api, selector = $fa36b6888f8151ad$var$identity, equalityFn) {
    if (($fa36b6888f8151ad$import_meta.env ? $fa36b6888f8151ad$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$fa36b6888f8151ad$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $fa36b6888f8151ad$var$didWarnAboutEqualityFn = true;
    }
    const slice = $fa36b6888f8151ad$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $fa36b6888f8151ad$var$useDebugValue(slice);
    return slice;
}
const $fa36b6888f8151ad$var$createImpl = (createState)=>{
    if (($fa36b6888f8151ad$import_meta.env ? $fa36b6888f8151ad$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $5CQB5.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$fa36b6888f8151ad$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $fa36b6888f8151ad$export$185802fd694ee1f5 = (createState)=>createState ? $fa36b6888f8151ad$var$createImpl(createState) : $fa36b6888f8151ad$var$createImpl;
var $fa36b6888f8151ad$export$2e2bcd8739ae039 = (createState)=>{
    if (($fa36b6888f8151ad$import_meta.env ? $fa36b6888f8151ad$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $fa36b6888f8151ad$export$185802fd694ee1f5(createState);
};

});
parcelRegister("gCoJE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bOsIc"));

});
parcelRegister("bOsIc", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $899aa2c98f8347dc$export$bf730a2d8bf68b42, (v) => $899aa2c98f8347dc$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $899aa2c98f8347dc$export$bf730a2d8bf68b42;
"use strict";

var $4fqPo = parcelRequire("4fqPo");

var $2eXBd = parcelRequire("2eXBd");
function $899aa2c98f8347dc$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $899aa2c98f8347dc$var$objectIs = "function" === typeof Object.is ? Object.is : $899aa2c98f8347dc$var$is, $899aa2c98f8347dc$var$useSyncExternalStore = $2eXBd.useSyncExternalStore, $899aa2c98f8347dc$var$useRef = $4fqPo.useRef, $899aa2c98f8347dc$var$useEffect = $4fqPo.useEffect, $899aa2c98f8347dc$var$useMemo = $4fqPo.useMemo, $899aa2c98f8347dc$var$useDebugValue = $4fqPo.useDebugValue;
$899aa2c98f8347dc$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $899aa2c98f8347dc$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $899aa2c98f8347dc$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($899aa2c98f8347dc$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $899aa2c98f8347dc$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $899aa2c98f8347dc$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $899aa2c98f8347dc$var$useDebugValue(value);
    return value;
};

});





parcelRegister("fRrk1", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $4aac60d6d663740a$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $4aac60d6d663740a$export$768c370ed0dbaeb3);

var $5OUhX = parcelRequire("5OUhX");

var $2GV52 = parcelRequire("2GV52");
const $4aac60d6d663740a$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $5OUhX.isCommonMediaClientError)(secondaryError)) {
        var _secondaryError$metad;
        return (_secondaryError$metad = secondaryError.metadata) === null || _secondaryError$metad === void 0 ? void 0 : _secondaryError$metad.traceContext;
    }
};
const $4aac60d6d663740a$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $4aac60d6d663740a$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $5OUhX.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $4aac60d6d663740a$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $5OUhX.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $4aac60d6d663740a$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $4aac60d6d663740a$export$4af9d71992e89714(error),
        error: $4aac60d6d663740a$export$88c61dcad53762da(error),
        errorDetail: $4aac60d6d663740a$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $4aac60d6d663740a$export$29aa614726672b2e(error)
    };
};
const $4aac60d6d663740a$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$4aac60d6d663740a$export$74aaf4784c2edb2c(new (0, $2GV52.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("2GV52", function(module, exports) {
$parcel$export(module.exports, "MediaFilePreviewError", () => $517f3eb95bca177e$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $517f3eb95bca177e$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $517f3eb95bca177e$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $517f3eb95bca177e$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $517f3eb95bca177e$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $517f3eb95bca177e$export$7156ce7b78b49bd7);
class $517f3eb95bca177e$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $517f3eb95bca177e$export$2c035820a31723e extends $517f3eb95bca177e$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $517f3eb95bca177e$export$10ab445310d30114 extends $517f3eb95bca177e$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $517f3eb95bca177e$export$18e89b7e50818288 extends $517f3eb95bca177e$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $517f3eb95bca177e$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $517f3eb95bca177e$export$d0a45ab59b4606b extends $517f3eb95bca177e$export$96e559194c287cf4 {
    constructor(source){
        super($517f3eb95bca177e$var$getImageLoadPrimaryReason(source));
    }
}
function $517f3eb95bca177e$export$553696a6e769784c(err) {
    return err instanceof $517f3eb95bca177e$export$96e559194c287cf4;
}
const $517f3eb95bca177e$export$b380593ba3516c6f = (err)=>err instanceof $517f3eb95bca177e$export$2c035820a31723e;
const $517f3eb95bca177e$export$e1d87830b3784f94 = (err)=>err instanceof $517f3eb95bca177e$export$10ab445310d30114;
const $517f3eb95bca177e$export$443aeb298d35d79d = (err)=>$517f3eb95bca177e$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $517f3eb95bca177e$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($517f3eb95bca177e$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $517f3eb95bca177e$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $517f3eb95bca177e$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("dEYmx", function(module, exports) {
$parcel$export(module.exports, "extractCdnSigningParams", () => $6b23ba3285433517$export$8b90d6fc9c946379);
$parcel$export(module.exports, "getSSRPreview", () => $6b23ba3285433517$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $6b23ba3285433517$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $6b23ba3285433517$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $6b23ba3285433517$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $6b23ba3285433517$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $6b23ba3285433517$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $6b23ba3285433517$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $6b23ba3285433517$export$98e935d981c884d);

var $j2YpO = parcelRequire("j2YpO");

var $3H4LK = parcelRequire("3H4LK");

var $2GV52 = parcelRequire("2GV52");

var $2vWpE = parcelRequire("2vWpE");

var $1Q8uH = parcelRequire("1Q8uH");
const $6b23ba3285433517$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $j2YpO.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $2vWpE.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
/**
 * Allowlist of CDN signing query-param names that we propagate from a
 * pre-signed `previewCdnUrl` onto the URL produced by `getImageUrlSync`.
 * These are the standard CloudFront signed-URL params; if the upstream
 * adds a new one, this list needs updating.
 */ const $6b23ba3285433517$var$SIGNING_PARAM_NAMES = [
    'token',
    'Policy',
    'Key-Pair-Id',
    'Signature',
    'Expires'
];
const $6b23ba3285433517$export$8b90d6fc9c946379 = (cdnUrl)=>{
    try {
        const url = new URL(cdnUrl);
        const out = {};
        for (const name of $6b23ba3285433517$var$SIGNING_PARAM_NAMES){
            const value = url.searchParams.get(name);
            if (value !== null) out[name] = value;
        }
        return out;
    } catch  {
        return {};
    }
};
const $6b23ba3285433517$var$applyCdnSigningParams = (url, cdnSigningParams)=>{
    if (!cdnSigningParams || Object.keys(cdnSigningParams).length === 0) return url;
    try {
        const parsed = new URL(url);
        Object.entries(cdnSigningParams).forEach(([key, value])=>{
            parsed.searchParams.set(key, value);
        });
        return parsed.toString();
    } catch  {
        return url;
    }
};
const $6b23ba3285433517$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs, cdnSigningParams)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    const signedDataURI = $6b23ba3285433517$var$applyCdnSigningParams(rawDataURI, cdnSigningParams);
    return mediaBlobUrlAttrs ? (0, $j2YpO.addFileAttrsToUrl)(signedDataURI, mediaBlobUrlAttrs) : signedDataURI;
};
/**
 * Merges a clientId into mediaBlobUrlAttrs for cross-client copy support.
 * Returns the original attrs unchanged if clientId is not available or the feature flag is off.
 */ const $6b23ba3285433517$var$mergeClientIdIntoAttrs = (clientId, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!clientId) return mediaBlobUrlAttrs;
    if (mediaBlobUrlAttrs) return {
        ...mediaBlobUrlAttrs,
        clientId: clientId
    };
    // Construct minimal attrs when none provided
    return {
        id: id,
        clientId: clientId,
        contextId: collectionName || '',
        collection: collectionName
    };
};
const $6b23ba3285433517$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs, cdnSigningParams)=>{
    try {
        // Synchronously extract clientId from initialAuth and merge into blob URL attrs
        const clientId = (0, $3H4LK.fg)('platform_media_cross_client_copy_with_auth') ? mediaClient.getClientIdSync() : undefined;
        const attrsWithClientId = $6b23ba3285433517$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, params.collection);
        const dataURI = $6b23ba3285433517$var$getDataUri(mediaClient, id, params, attrsWithClientId, cdnSigningParams);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $6b23ba3285433517$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2,
                height: params.height && params.height * 2
            }, attrsWithClientId, cdnSigningParams);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $2GV52.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $6b23ba3285433517$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $6b23ba3285433517$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $6b23ba3285433517$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $6b23ba3285433517$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $6b23ba3285433517$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
/**
 * Resolves clientId (sync first, async fallback) and enriches mediaBlobUrlAttrs
 * with it for cross-client copy support.
 */ const $6b23ba3285433517$var$enrichAttrsWithClientId = async (mediaClient, id, mediaBlobUrlAttrs, collectionName)=>{
    if (!(0, $3H4LK.fg)('platform_media_cross_client_copy_with_auth')) return mediaBlobUrlAttrs;
    // Try sync first, then async fallback
    let clientId = mediaClient.getClientIdSync();
    if (!clientId) try {
        clientId = await mediaClient.getClientId(collectionName);
    } catch  {
    // clientId is optional, silently fail
    }
    return $6b23ba3285433517$var$mergeClientIdIntoAttrs(clientId, id, mediaBlobUrlAttrs, collectionName);
};
const $6b23ba3285433517$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const [remotePreview, enrichedAttrs] = await Promise.all([
        (0, $1Q8uH.getRemotePreview)(mediaClient, id, params, traceContext),
        $6b23ba3285433517$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, params.collection)
    ]);
    return $6b23ba3285433517$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, enrichedAttrs);
};
const $6b23ba3285433517$export$98e935d981c884d = async (mediaClient, id, filePreview, dimensions, mode, mediaBlobUrlAttrs, collectionName)=>{
    const [localPreview, enrichedAttrs] = await Promise.all([
        (0, $1Q8uH.getLocalPreview)(filePreview),
        $6b23ba3285433517$var$enrichAttrsWithClientId(mediaClient, id, mediaBlobUrlAttrs, collectionName)
    ]);
    return $6b23ba3285433517$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, enrichedAttrs);
};

});
parcelRegister("j2YpO", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrl", () => $580ea7196fa9e6cf$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $580ea7196fa9e6cf$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $580ea7196fa9e6cf$export$e51a8146182600b8);
const $580ea7196fa9e6cf$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $580ea7196fa9e6cf$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$580ea7196fa9e6cf$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $580ea7196fa9e6cf$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $580ea7196fa9e6cf$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $580ea7196fa9e6cf$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    const clientId = params.get('clientId');
    // check if we have the required params (clientId is optional for backwards compatibility)
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        clientId: clientId || undefined,
        collection: $580ea7196fa9e6cf$var$getStringFromParams(params, 'collection'),
        alt: $580ea7196fa9e6cf$var$getStringFromParams(params, 'alt'),
        height: $580ea7196fa9e6cf$var$getNumberFromParams(params, 'height'),
        width: $580ea7196fa9e6cf$var$getNumberFromParams(params, 'width'),
        size: $580ea7196fa9e6cf$var$getNumberFromParams(params, 'size'),
        name: $580ea7196fa9e6cf$var$getStringFromParams(params, 'name'),
        mimeType: $580ea7196fa9e6cf$var$getStringFromParams(params, 'mimeType')
    };
};
const $580ea7196fa9e6cf$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $580ea7196fa9e6cf$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$580ea7196fa9e6cf$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $580ea7196fa9e6cf$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("2vWpE", function(module, exports) {
$parcel$export(module.exports, "mediaFilePreviewCache", () => $dd20c138815c380a$export$b7e8ee3f7a41459);

var $hdMUD = parcelRequire("hdMUD");
const $dd20c138815c380a$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $dd20c138815c380a$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $dd20c138815c380a$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $dd20c138815c380a$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $dd20c138815c380a$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
        this.acquire = (id, mode)=>{
            const cacheKey = $dd20c138815c380a$export$611736262b635f8d(id, mode);
            this.previewCache.acquire(cacheKey);
        };
        this.release = (id, mode)=>{
            const cacheKey = $dd20c138815c380a$export$611736262b635f8d(id, mode);
            this.previewCache.release(cacheKey);
        };
    }
}
const $dd20c138815c380a$export$b7e8ee3f7a41459 = new $dd20c138815c380a$export$7b50526c091bb915((0, $hdMUD.createObjectURLCache)());

});
parcelRegister("hdMUD", function(module, exports) {
$parcel$export(module.exports, "createObjectURLCache", () => $18c9990d4d3f6739$export$ba71be67d5c32535);

var $kU2in = parcelRequire("kU2in");

var $3H4LK = parcelRequire("3H4LK");
const $18c9990d4d3f6739$export$36d0f9859761643d = 50;
/**
 * LRU cache that checks whether the oldest entry should be evicted
 * this means that the cache can grow past the softLimit if `shouldEvict` returns false.
 *
 * When `platform_media_safe_blob_url_eviction` is ON the oldest
 * entry is kept if `shouldEvict` returns false.
 * When the flag is OFF the oldest entry is always evicted.
 */ class $18c9990d4d3f6739$var$EvictionLRUCache extends (0, $kU2in.LRUMap) {
    constructor(softLimit, options){
        super(softLimit);
        this.shouldEvict = options === null || options === void 0 ? void 0 : options.shouldEvict;
        this.onEvict = options === null || options === void 0 ? void 0 : options.onEvict;
    }
    shift() {
        if ((0, $3H4LK.fg)('platform_media_safe_blob_url_eviction')) {
            const oldest = this.oldest;
            if (oldest && this.shouldEvict && !this.shouldEvict([
                oldest.key,
                oldest.value
            ])) return undefined;
        }
        const entry = super.shift();
        if (entry && this.onEvict) this.onEvict(entry);
        return entry;
    }
}
class $18c9990d4d3f6739$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.activeRefs = new Map();
        this.cache = new $18c9990d4d3f6739$var$EvictionLRUCache(size, {
            shouldEvict: (entry)=>!this.isInUse(entry[0]),
            onEvict: (entry)=>{
                if (entry[1].dataURI) {
                    const dataURI = (0, $3H4LK.fg)('platform_media_safe_blob_url_eviction') ? entry[1].dataURI.split('#')[0] : entry[1].dataURI;
                    if (dataURI) URL.revokeObjectURL(dataURI);
                }
            }
        });
    }
    /**
   * Marks a cache key as actively in use by a consumer.
   * Multiple consumers can acquire the same key; eviction is
   * blocked until all consumers have released it.
   */ acquire(key) {
        this.activeRefs.set(key, (this.activeRefs.get(key) ?? 0) + 1);
    }
    release(key) {
        const count = this.activeRefs.get(key) ?? 0;
        if (count <= 1) this.activeRefs.delete(key);
        else this.activeRefs.set(key, count - 1);
    }
    isInUse(key) {
        return (this.activeRefs.get(key) ?? 0) > 0;
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        this.activeRefs.delete(key);
        const dataURI = (0, $3H4LK.fg)('platform_media_safe_blob_url_eviction') ? removed === null || removed === void 0 ? void 0 : removed.dataURI.split('#')[0] : removed === null || removed === void 0 ? void 0 : removed.dataURI;
        dataURI && URL.revokeObjectURL(dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $18c9990d4d3f6739$export$ba71be67d5c32535 = ()=>new $18c9990d4d3f6739$export$75d1c8c9ba1d0773($18c9990d4d3f6739$export$36d0f9859761643d);

});


parcelRegister("1Q8uH", function(module, exports) {
$parcel$export(module.exports, "isSupportedLocalPreview", () => $6b6db4351ff001ae$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $6b6db4351ff001ae$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $6b6db4351ff001ae$export$bfe20bd01db02b3);

var $lGDUe = parcelRequire("lGDUe");

var $3pKgQ = parcelRequire("3pKgQ");

var $2GV52 = parcelRequire("2GV52");

var $bzi7Q = parcelRequire("bzi7Q");
const $6b6db4351ff001ae$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $6b6db4351ff001ae$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $3pKgQ.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $2GV52.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $6b6db4351ff001ae$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $bzi7Q.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $2GV52.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $6b6db4351ff001ae$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $2GV52.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $lGDUe.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $6b6db4351ff001ae$var$getImageLocalPreview(value);
            case 'video':
                return $6b6db4351ff001ae$var$getVideoLocalPreview(value);
            default:
                throw new (0, $2GV52.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $2GV52.LocalPreviewError)('local-preview-unsupported');
};
const $6b6db4351ff001ae$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $2GV52.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("3pKgQ", function(module, exports) {
$parcel$export(module.exports, "getImageInfo", () => $e1f3d20a13a4b07e$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $e1f3d20a13a4b07e$export$67689507e8404821);

var $4oex8 = parcelRequire("4oex8");

var $jMUVd = parcelRequire("jMUVd");

var $ZZhkQ = parcelRequire("ZZhkQ");

var $2W40f = parcelRequire("2W40f");
const { Orientation: $e1f3d20a13a4b07e$var$Orientation, XResolution: $e1f3d20a13a4b07e$var$XResolution } = (0, $4oex8.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $e1f3d20a13a4b07e$var$DPI_WEB_BASELINE = 72;
async function $e1f3d20a13a4b07e$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $e1f3d20a13a4b07e$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $e1f3d20a13a4b07e$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $e1f3d20a13a4b07e$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $e1f3d20a13a4b07e$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
     * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
     * So we are only relying on X axis.
     */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $e1f3d20a13a4b07e$var$DPI_WEB_BASELINE;
        else return $e1f3d20a13a4b07e$export$268f92356524130b(tags, $e1f3d20a13a4b07e$var$XResolution, $e1f3d20a13a4b07e$var$DPI_WEB_BASELINE) / $e1f3d20a13a4b07e$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $e1f3d20a13a4b07e$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$e1f3d20a13a4b07e$var$Orientation]) {
        const tagValue = tags[$e1f3d20a13a4b07e$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $4oex8.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $e1f3d20a13a4b07e$export$67689507e8404821(file) {
    const tags = await (0, $jMUVd.readImageMetaTags)(file);
    return $e1f3d20a13a4b07e$var$getOrientationFromTags(tags);
}
function $e1f3d20a13a4b07e$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $e1f3d20a13a4b07e$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $e1f3d20a13a4b07e$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $jMUVd.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $e1f3d20a13a4b07e$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $e1f3d20a13a4b07e$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
   * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
   * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
   * We've also received JAC tickets reporting incorrect dimensions because of this
   * https://jira.atlassian.com/browse/CONFCLOUD-78275
   * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
   */ try {
        const img = await (0, $ZZhkQ.loadImage)(src);
        const { width: width, height: height } = (0, $ZZhkQ.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("4oex8", function(module, exports) {
$parcel$export(module.exports, "ImageType", () => $53917d1a0a65b7a1$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $53917d1a0a65b7a1$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $53917d1a0a65b7a1$export$f6ea0c89fd7d156);
var $53917d1a0a65b7a1$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $53917d1a0a65b7a1$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $53917d1a0a65b7a1$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    // none
    'top-right': 2,
    // flip horizontal
    'bottom-right': 3,
    // rotate 180
    'bottom-left': 4,
    // flip vertical
    'left-top': 5,
    // transpose
    'right-top': 6,
    // rotate 90
    'right-bottom': 7,
    // transverse
    'left-bottom': 8 // rotate 270
};

});

parcelRegister("jMUVd", function(module, exports) {
$parcel$export(module.exports, "readImageMetaTags", () => $8d78c670dba46f6c$export$41982b5c7acb23c4);

var $4oex8 = parcelRequire("4oex8");

var $91Sth = parcelRequire("91Sth");

var $GPP0O = parcelRequire("GPP0O");

var $9aMjh = parcelRequire("9aMjh");
async function $8d78c670dba46f6c$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $4oex8.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $GPP0O.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $9aMjh.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $4oex8.ImageType).JPEG) return await (0, $91Sth.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("91Sth", function(module, exports) {
$parcel$export(module.exports, "readJPEGExifMetaData", () => $17b31b512c30f854$export$556b2ccec62d7f2a);

var $4oex8 = parcelRequire("4oex8");
const { XResolution: $17b31b512c30f854$var$XResolution, YResolution: $17b31b512c30f854$var$YResolution } = (0, $4oex8.SupportedImageMetaTag);
let $17b31b512c30f854$var$loadImage;

function $17b31b512c30f854$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$17b31b512c30f854$var$loadImage) {
            const module = await (parcelRequire("ig0O2"));
            $17b31b512c30f854$var$loadImage = module.default || module;
        }
        $17b31b512c30f854$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $17b31b512c30f854$var$XResolution || key === $17b31b512c30f854$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("ig0O2", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9Cv2e").then(()=>parcelRequire('aTByj'));

});


parcelRegister("GPP0O", function(module, exports) {
$parcel$export(module.exports, "readPNGXMPMetaData", () => $bb8f85660cf3b9ee$export$5fb37736440fca6f);

var $ZZhkQ = parcelRequire("ZZhkQ");
let $bb8f85660cf3b9ee$var$pngChunksExtract;

async function $bb8f85660cf3b9ee$export$5fb37736440fca6f(file) {
    if (!$bb8f85660cf3b9ee$var$pngChunksExtract) {
        const module = await (parcelRequire("kKBxy"));
        $bb8f85660cf3b9ee$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $ZZhkQ.fileToArrayBuffer)(file);
    const chunks = $bb8f85660cf3b9ee$var$pngChunksExtract(buffer);
    return await $bb8f85660cf3b9ee$export$9185743fdd58ce45(chunks);
}
async function $bb8f85660cf3b9ee$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
   * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
   * Order of every chunk is not guaranteed.
   * And both iTXt and pHYs are Ancillary chunks.
   */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
     * iTXt contains the useful XMP/XML string data of meta tags
     */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
     * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
     * Pixels per unit, X axis: 4 bytes (unsigned integer)
     * Pixels per unit, Y axis: 4 bytes (unsigned integer)
     * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
     */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("ZZhkQ", function(module, exports) {
$parcel$export(module.exports, "getFileInfo", () => $282b7f54eee40ece$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $282b7f54eee40ece$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $282b7f54eee40ece$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $282b7f54eee40ece$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $282b7f54eee40ece$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $282b7f54eee40ece$export$61a1de0822e2820);

var $iud6e = parcelRequire("iud6e");

var $b65bV = parcelRequire("b65bV");

var $iy9ZB = parcelRequire("iy9ZB");

var $cKwxD = parcelRequire("cKwxD");

var $aHBFf = parcelRequire("aHBFf");

var $bFz1q = parcelRequire("bFz1q");

var $cgueQ = parcelRequire("cgueQ");

var $45le2 = parcelRequire("45le2");

var $26k2s = parcelRequire("26k2s");

var $3Gf6m = parcelRequire("3Gf6m");

var $1e2Z3 = parcelRequire("1e2Z3");

var $sUYLF = parcelRequire("sUYLF");

var $4jeOd = parcelRequire("4jeOd");

var $9cD8S = parcelRequire("9cD8S");

var $bjqdm = parcelRequire("bjqdm");

var $hcr1B = parcelRequire("hcr1B");
function $282b7f54eee40ece$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $282b7f54eee40ece$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $282b7f54eee40ece$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $282b7f54eee40ece$export$849633012686f7ee(file)
    };
}
async function $282b7f54eee40ece$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $282b7f54eee40ece$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $282b7f54eee40ece$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $282b7f54eee40ece$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $282b7f54eee40ece$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $282b7f54eee40ece$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $282b7f54eee40ece$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iud6e)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($26k2s)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1e2Z3)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($26k2s)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Gf6m)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($45le2)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cKwxD)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9cD8S)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iy9ZB)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b65bV)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4jeOd)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($sUYLF)))
    }
];
function $282b7f54eee40ece$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $282b7f54eee40ece$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $hcr1B.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bjqdm)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aHBFf)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFz1q)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cgueQ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("iud6e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d75530a3a88c418b$var$_react = $d75530a3a88c418b$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $d75530a3a88c418b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d75530a3a88c418b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $d75530a3a88c418b$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d75530a3a88c418b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $d75530a3a88c418b$var$_default = module.exports.default = $d75530a3a88c418b$var$PdfDocument24Icon;

});
parcelRegister("eD4lh", function(module, exports) {
$parcel$export(module.exports, "Icon", () => $4beb9a0d27f34695$export$f04a61298a47a40f);
/* icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $4beb9a0d27f34695$var$iconStyles = null;
const $4beb9a0d27f34695$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ const $4beb9a0d27f34695$var$baseHcmStyles = null;
const $4beb9a0d27f34695$var$primaryEqualsSecondaryHcmStyles = null;
const $4beb9a0d27f34695$var$secondaryTransparentHcmStyles = null;
const $4beb9a0d27f34695$export$f04a61298a47a40f = /*#__PURE__*/ (0, $4fqPo.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $4fqPo.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $ltgDR.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $4beb9a0d27f34695$var$sizeStyles[size]
        ])
    });
});
var $4beb9a0d27f34695$export$2e2bcd8739ae039 = $4beb9a0d27f34695$export$f04a61298a47a40f;

});


parcelRegister("b65bV", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $81444826f96dc94e$var$_react = $81444826f96dc94e$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $81444826f96dc94e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $81444826f96dc94e$var$Gif24Icon = (props)=>/*#__PURE__*/ $81444826f96dc94e$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$81444826f96dc94e$var$Gif24Icon.displayName = 'Gif24Icon';
var $81444826f96dc94e$var$_default = module.exports.default = $81444826f96dc94e$var$Gif24Icon;

});

parcelRegister("iy9ZB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d813275099a20829$var$_react = $d813275099a20829$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $d813275099a20829$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d813275099a20829$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $d813275099a20829$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d813275099a20829$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $d813275099a20829$var$_default = module.exports.default = $d813275099a20829$var$PowerpointPresentation24Icon;

});

parcelRegister("cKwxD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $948305f4082a95c6$var$_react = $948305f4082a95c6$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $948305f4082a95c6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $948305f4082a95c6$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $948305f4082a95c6$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$948305f4082a95c6$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $948305f4082a95c6$var$_default = module.exports.default = $948305f4082a95c6$var$WordDocument24Icon;

});

parcelRegister("aHBFf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $7cab22dc084067f9$var$_react = $7cab22dc084067f9$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $7cab22dc084067f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7cab22dc084067f9$var$Sketch24Icon = (props)=>/*#__PURE__*/ $7cab22dc084067f9$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$7cab22dc084067f9$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $7cab22dc084067f9$var$_default = module.exports.default = $7cab22dc084067f9$var$Sketch24Icon;

});

parcelRegister("bFz1q", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $87eeb0adaba96623$var$_react = $87eeb0adaba96623$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $87eeb0adaba96623$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $87eeb0adaba96623$var$Figma24Icon = (props)=>/*#__PURE__*/ $87eeb0adaba96623$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$87eeb0adaba96623$var$Figma24Icon.displayName = 'Figma24Icon';
var $87eeb0adaba96623$var$_default = module.exports.default = $87eeb0adaba96623$var$Figma24Icon;

});

parcelRegister("cgueQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8ede6f63b07f45f1$var$_react = $8ede6f63b07f45f1$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $8ede6f63b07f45f1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8ede6f63b07f45f1$var$Executable24Icon = (props)=>/*#__PURE__*/ $8ede6f63b07f45f1$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8ede6f63b07f45f1$var$Executable24Icon.displayName = 'Executable24Icon';
var $8ede6f63b07f45f1$var$_default = module.exports.default = $8ede6f63b07f45f1$var$Executable24Icon;

});

parcelRegister("45le2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2f9817ff7996cb92$var$_react = $2f9817ff7996cb92$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $2f9817ff7996cb92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f9817ff7996cb92$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $2f9817ff7996cb92$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2f9817ff7996cb92$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $2f9817ff7996cb92$var$_default = module.exports.default = $2f9817ff7996cb92$var$GoogleDoc24Icon;

});

parcelRegister("26k2s", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $187baf9516ced96a$var$_react = $187baf9516ced96a$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $187baf9516ced96a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $187baf9516ced96a$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $187baf9516ced96a$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$187baf9516ced96a$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $187baf9516ced96a$var$_default = module.exports.default = $187baf9516ced96a$var$GoogleForm24Icon;

});

parcelRegister("3Gf6m", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ae102379a8dad75$var$_react = $2ae102379a8dad75$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $2ae102379a8dad75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ae102379a8dad75$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $2ae102379a8dad75$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2ae102379a8dad75$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $2ae102379a8dad75$var$_default = module.exports.default = $2ae102379a8dad75$var$GoogleSheet24Icon;

});

parcelRegister("1e2Z3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0e4969bdf9bdc810$var$_react = $0e4969bdf9bdc810$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $0e4969bdf9bdc810$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0e4969bdf9bdc810$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $0e4969bdf9bdc810$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0e4969bdf9bdc810$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $0e4969bdf9bdc810$var$_default = module.exports.default = $0e4969bdf9bdc810$var$GoogleSlide24Icon;

});

parcelRegister("sUYLF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $056ed081d58e2b84$var$_react = $056ed081d58e2b84$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $056ed081d58e2b84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $056ed081d58e2b84$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $056ed081d58e2b84$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$056ed081d58e2b84$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $056ed081d58e2b84$var$_default = module.exports.default = $056ed081d58e2b84$var$ExcelSpreadsheet24Icon;

});

parcelRegister("4jeOd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $32346c8119813f61$var$_react = $32346c8119813f61$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $32346c8119813f61$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32346c8119813f61$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $32346c8119813f61$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$32346c8119813f61$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $32346c8119813f61$var$_default = module.exports.default = $32346c8119813f61$var$Spreadsheet24Icon;

});

parcelRegister("9cD8S", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6b3398e3051d119e$var$_react = $6b3398e3051d119e$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $6b3398e3051d119e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6b3398e3051d119e$var$Presentation24Icon = (props)=>/*#__PURE__*/ $6b3398e3051d119e$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6b3398e3051d119e$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $6b3398e3051d119e$var$_default = module.exports.default = $6b3398e3051d119e$var$Presentation24Icon;

});

parcelRegister("bjqdm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $83c5cdb5e68e496c$var$_react = $83c5cdb5e68e496c$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $eD4lh = parcelRequire("eD4lh");
function $83c5cdb5e68e496c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $83c5cdb5e68e496c$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $83c5cdb5e68e496c$var$_react.default.createElement($eD4lh.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$83c5cdb5e68e496c$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $83c5cdb5e68e496c$var$_default = module.exports.default = $83c5cdb5e68e496c$var$SourceCode24Icon;

});

parcelRegister("hcr1B", function(module, exports) {
$parcel$export(module.exports, "getExtension", () => $2e946f964849cc22$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $2e946f964849cc22$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $2e946f964849cc22$export$ba4368c844580f9e);
function $2e946f964849cc22$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $2e946f964849cc22$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $2e946f964849cc22$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $2e946f964849cc22$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $2e946f964849cc22$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $2e946f964849cc22$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $2e946f964849cc22$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain') return 'text';
            return null;
    }
}

});


parcelRegister("kKBxy", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("dvHtY").then(()=>parcelRequire('8hy38'));

});


parcelRegister("9aMjh", function(module, exports) {
$parcel$export(module.exports, "parseXMPMetaData", () => $2bac7021d755f1bd$export$55c3bc9841b19de2);
function $2bac7021d755f1bd$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("2W40f", function(module, exports) {
$parcel$export(module.exports, "isRotated", () => $b885c57aa1956b06$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $b885c57aa1956b06$export$43142f95b8de7a91);
const $b885c57aa1956b06$var$ORIENT_TRANSFORMS = {
    1: 'none',
    // Horizontal (normal)
    2: 'rotateY(180deg)',
    // Mirror horizontal
    3: 'rotate(180deg)',
    // Rotate 180
    4: 'rotate(180deg) rotateY(180deg)',
    // Mirror vertical
    5: 'rotate(270deg) rotateY(180deg)',
    // Mirror horizontal and rotate 270 CW
    6: 'rotate(90deg)',
    // Rotate 90 CW
    7: 'rotate(90deg) rotateY(180deg)',
    // Mirror horizontal and rotate 90 CW
    8: 'rotate(270deg)' // Rotate 270 CW
};
const $b885c57aa1956b06$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $b885c57aa1956b06$export$43142f95b8de7a91 = (orientation)=>{
    return $b885c57aa1956b06$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("bzi7Q", function(module, exports) {
$parcel$export(module.exports, "takeSnapshot", () => $48adb2f753745504$export$4269d30173168e5c);
const $48adb2f753745504$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("exGjH", function(module, exports) {
$parcel$export(module.exports, "getMediaCardSSR", () => $8e53f2e4ea956113$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $8e53f2e4ea956113$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $8e53f2e4ea956113$export$de7c49925e44d75d);
const $8e53f2e4ea956113$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $8e53f2e4ea956113$export$d26005e8749921c9 = 'mediaCountSsr';
const $8e53f2e4ea956113$export$7aeb4eab53a57df7 = 'performanceEntries';
const $8e53f2e4ea956113$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
const $8e53f2e4ea956113$var$MAX_EAGER_LOAD_COUNT = 6;
function $8e53f2e4ea956113$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $8e53f2e4ea956113$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $8e53f2e4ea956113$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $8e53f2e4ea956113$var$dashed = (param)=>param ? `-${param}` : '';
const $8e53f2e4ea956113$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey }, resizeMode)=>`${id}${$8e53f2e4ea956113$var$dashed(collectionName)}${$8e53f2e4ea956113$var$dashed(occurrenceKey)}${$8e53f2e4ea956113$var$dashed(resizeMode)}`;
const $8e53f2e4ea956113$var$generateScript = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>{
    const key = $8e53f2e4ea956113$export$a47fb462a08de82f(identifier, mode);
    // Serialize the parameters for injection into the script
    const params = {
        key: key,
        dataURI: dataURI,
        mode: mode,
        srcSet: srcSet,
        dimensions: dimensions,
        error: error,
        featureFlags: featureFlags,
        maxEagerLoadCount: $8e53f2e4ea956113$var$MAX_EAGER_LOAD_COUNT
    };
    // Read originalScriptCode.ts before making changes
    return `!function(e){var r=document.currentScript,i=window.__MEDIA_INTERNAL=window.__MEDIA_INTERNAL||{},n=i.mediaCardSsr=i.mediaCardSsr||{},o=e.key,t=e.dataURI,d=e.mode,a=e.srcSet,s=e.dimensions,m=e.error,l=e.featureFlags;if(l["media-perf-uplift-mutation-fix"]){var u,c,f=n[o],v=f&&f.mode===d&&(null===(u=f.dimensions)||void 0===u?void 0:u.width)&&(null==s?void 0:s.width)&&f.dimensions.width>s.width,E=v?f.srcSet:a,p=v?f.dataURI:t,w={dataURI:p,dimensions:s,error:m,srcSet:E,loading:"lazy",loadPromise:void 0,mode:d},S=null==r||null===(c=r.parentElement)||void 0===c?void 0:c.querySelector("img");if(i.mediaCountSsr=i.mediaCountSsr||0,S){if(l["media-perf-lazy-loading-optimisation"]&&i.mediaCountSsr<e.maxEagerLoadCount){i.mediaCountSsr++,S.removeAttribute("loading"),w.loading="";var g=new PerformanceObserver((function(e){e.getEntries().forEach((function(e){E.includes(e.name)&&(i.performanceEntries=i.performanceEntries||[],i.performanceEntries.push(e),g.disconnect())}))}));g.observe({type:"resource"})}p&&(S.src=p),E&&(S.srcset=E),w.loadPromise=new Promise((function(e,r){S.addEventListener("load",(function(){return e()})),S.addEventListener("error",(function(){return r(new Error("Failed to load image"))}))}))}n[o]=v?f:w}else n[o]={dataURI:t,dimensions:s,error:m};null==r||r.remove()}({replace:""});`.replace('{replace:""}', JSON.stringify(params));
};
const $8e53f2e4ea956113$export$de7c49925e44d75d = (identifier, dataURI, mode, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $8e53f2e4ea956113$var$generateScript(identifier, dataURI, mode, srcSet, dimensions, error, featureFlags)
        }
    });

});

parcelRegister("c24a6", function(module, exports) {
$parcel$export(module.exports, "getSSRData", () => $578ef594668b5914$export$d3a890b0f7844b6f);

var $exGjH = parcelRequire("exGjH");
const $578ef594668b5914$export$d3a890b0f7844b6f = (identifier, resizeMode)=>{
    const mediaCardSsr = (0, $exGjH.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $exGjH.getKey)(identifier, resizeMode)];
};

});

parcelRegister("kcniu", function(module, exports) {
$parcel$export(module.exports, "isBigger", () => $8e35c936a8a20617$export$912a00e9a5470d9a);
$parcel$export(module.exports, "isWider", () => $8e35c936a8a20617$export$ae6224430098bc5f);
$parcel$export(module.exports, "createRequestDimensions", () => $8e35c936a8a20617$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $8e35c936a8a20617$export$b3e10e1f0fbb71db);

var $4fqPo = parcelRequire("4fqPo");
const $8e35c936a8a20617$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
const $8e35c936a8a20617$export$ae6224430098bc5f = (current, next)=>{
    if (current === undefined && next !== undefined) return true;
    const currentWidth = (current === null || current === void 0 ? void 0 : current.width) || 0;
    const nextWidth = (next === null || next === void 0 ? void 0 : next.width) || 0;
    return currentWidth < nextWidth;
};
/** Verifies if the current screen is retina display */ function $8e35c936a8a20617$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $8e35c936a8a20617$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $8e35c936a8a20617$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $8e35c936a8a20617$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $4fqPo.useRef)(value);
    ref.current = value;
    return ref;
}

});






parcelRegister("8bB6H", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => (parcelRequire("eeLh2")).AttributeList);

var $eeLh2 = parcelRequire("eeLh2");

});
parcelRegister("eeLh2", function(module, exports) {
$parcel$export(module.exports, "AttributeList", () => $8889e047e70791ca$export$f632a70b7942a9ca);

var $4fqPo = parcelRequire("4fqPo");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $kMB2e = parcelRequire("kMB2e");
const $8889e047e70791ca$export$f632a70b7942a9ca = ({ attributes: attributes, timezoneId: timezoneId })=>{
    const objectAttributeValuesAreNotEmpty = (values)=>{
        return values.every((value)=>Object.keys(value).length > 0);
    };
    const renderAttribute = (attribute)=>{
        var _attribute$objectType;
        if (((_attribute$objectType = attribute.objectTypeAttribute.defaultType) === null || _attribute$objectType === void 0 ? void 0 : _attribute$objectType.name) === 'DateTime' && timezoneId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            const displayValue = value.value ? (0, $kMB2e.convertToTimezone)(value.value, timezoneId) : value.displayValue;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
                key: index
            }, displayValue);
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, attribute.objectAttributeValues.map((value, index)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
                key: index
            }, value.displayValue);
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $8889e047e70791ca$var$ListWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        as: "dl",
        xcss: $8889e047e70791ca$var$ListStyles
    }, attributes.map((attribute)=>objectAttributeValuesAreNotEmpty(attribute.objectAttributeValues) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            key: attribute.id,
            xcss: $8889e047e70791ca$var$AttributeWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "dt",
            xcss: $8889e047e70791ca$var$AttributeLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
            size: "xsmall",
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "span",
            xcss: $8889e047e70791ca$var$attributeLabelStyles
        }, attribute.objectTypeAttribute.name))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "dd",
            xcss: $8889e047e70791ca$var$AttributeValueStyles
        }, renderAttribute(attribute))))));
};
const $8889e047e70791ca$var$ListStyles = (0, $2m8U6.xcss)({
    paddingLeft: 'space.0'
});
const $8889e047e70791ca$var$ListWrapperStyles = (0, $2m8U6.xcss)({
    /* Offset the outside padding from children */ // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.negative.050',
    marginRight: 'space.negative.150',
    marginBottom: 'space.negative.050',
    marginLeft: 'space.negative.150'
});
const $8889e047e70791ca$var$attributeLabelStyles = (0, $2m8U6.xcss)({
    color: 'color.text.subtle'
});
const $8889e047e70791ca$var$AttributeLabelWrapperStyles = (0, $2m8U6.xcss)({
    marginBlock: 'space.050',
    marginInline: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '112px',
    flexGrow: 1
});
const $8889e047e70791ca$var$AttributeValueStyles = (0, $2m8U6.xcss)({
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    color: 'color.text',
    // Half vertical space between each attribute, half horizontal space between label & value
    marginTop: 'space.050',
    marginRight: 'space.150',
    marginBottom: 'space.050',
    marginLeft: 'space.150',
    minHeight: 'space.300',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.300',
    flexBasis: '224px',
    flexGrow: 1
});
const $8889e047e70791ca$var$AttributeWrapperStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row'
});

});
parcelRegister("2eKV2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a524f69de0466d7c$export$2e2bcd8739ae039);
/* heading.tsx generated by @compiled/babel-plugin v0.37.1 */ /* heading.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fJeCl = parcelRequire("fJeCl");

var $5IVQv = parcelRequire("5IVQv");

var $iELEr = parcelRequire("iELEr");

var $3TFEq = parcelRequire("3TFEq");
const $a524f69de0466d7c$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $a524f69de0466d7c$var$styles = {
    reset: "_dxsyidpf _1i144jg8 _nmk4glyw"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $a524f69de0466d7c$var$headingColorStyles = {
    'color.text': "_1w90i7uo",
    'color.text.inverse': "_1w9015cr",
    'color.text.warning.inverse': "_1w901yd3"
};
/**
 * Using '&&' here to increase specificity of Heading styles such that app styles like ".wiki-content h4" cannot override this component.
 */ const $a524f69de0466d7c$var$headingSizeStyles = {
    xxlarge: "_fqox1iff",
    xlarge: "_fqox12ln",
    large: "_fqox10sd",
    medium: "_fqox1af2",
    small: "_fqox1e3o",
    xsmall: "_fqox1qyo",
    xxsmall: "_fqoxi4vh"
};
/**
 * @codegenEnd
 */ const $a524f69de0466d7c$var$useColor = (colorProp)=>{
    const surface = (0, $5IVQv.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $fJeCl.inverseColorMap).hasOwnProperty(surface)) return (0, $fJeCl.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $a524f69de0466d7c$var$Heading = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $3TFEq;
    const [hLevel, inferredElement] = (0, $iELEr.useHeading)($a524f69de0466d7c$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $a524f69de0466d7c$var$useColor(colorProp);
    return /*#__PURE__*/ $4fqPo.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $ltgDR.default)([
            $a524f69de0466d7c$var$styles.reset,
            $a524f69de0466d7c$var$headingSizeStyles[size],
            $a524f69de0466d7c$var$headingColorStyles[color]
        ])
    }, children);
});
var $a524f69de0466d7c$export$2e2bcd8739ae039 = $a524f69de0466d7c$var$Heading;

});
parcelRegister("5IVQv", function(module, exports) {
$parcel$export(module.exports, "useSurface", () => $5be76850a8a7efb4$export$1aeb4f6b93c4540d);
$parcel$export(module.exports, "SurfaceContext", () => (parcelRequire("28VoU")).SurfaceContext);

var $4fqPo = parcelRequire("4fqPo");

var $28VoU = parcelRequire("28VoU");
const $5be76850a8a7efb4$export$1aeb4f6b93c4540d = ()=>{
    return (0, $4fqPo.useContext)((0, $28VoU.SurfaceContext));
};
(0, $28VoU.SurfaceContext).displayName = 'SurfaceProvider';

});

parcelRegister("iELEr", function(module, exports) {
$parcel$export(module.exports, "useHeading", () => $4647beb2594c33a4$export$97a37b1befbbf9b1);

var $2cKMs = parcelRequire("2cKMs");
const $4647beb2594c33a4$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = (0, $2cKMs.useHeadingLevel)();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};

});
parcelRegister("2cKMs", function(module, exports) {
$parcel$export(module.exports, "useHeadingLevel", () => $9438dce46f7c08b9$export$6a64a1e2d0bbbf75);

var $4fqPo = parcelRequire("4fqPo");

var $hcqrC = parcelRequire("hcqrC");
const $9438dce46f7c08b9$export$6a64a1e2d0bbbf75 = ()=>{
    return (0, $4fqPo.useContext)((0, $hcqrC.HeadingLevelContext));
};

});
parcelRegister("hcqrC", function(module, exports) {
$parcel$export(module.exports, "HeadingLevelContext", () => $ef48cb9cf8ad1858$export$d1fa8a19e192bc63);

var $4fqPo = parcelRequire("4fqPo");
const $ef48cb9cf8ad1858$export$d1fa8a19e192bc63 = /*#__PURE__*/ (0, $4fqPo.createContext)(0);

});




parcelRegister("kMB2e", function(module, exports) {
$parcel$export(module.exports, "convertToTimezone", () => $8b262698e08c6a02$export$4d189baac548427);
const $8b262698e08c6a02$export$4d189baac548427 = (dateString, timezoneId)=>{
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: timezoneId
    }).format(date);
};

});



parcelRegister("h36Wp", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => (parcelRequire("FS1jX")).ExpandCollapseToggle);

var $FS1jX = parcelRequire("FS1jX");

});
parcelRegister("FS1jX", function(module, exports) {
$parcel$export(module.exports, "ExpandCollapseToggle", () => $50a94826b3c5e83c$export$170fda29b81e014c);

var $4fqPo = parcelRequire("4fqPo");

var $lszf6 = parcelRequire("lszf6");

var $cTq8x = parcelRequire("cTq8x");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $8Mj6h = parcelRequire("8Mj6h");
const $50a94826b3c5e83c$export$170fda29b81e014c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        appearance: "subtle",
        onClick: props.onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: [
                $50a94826b3c5e83c$var$animatedRotationStyles,
                props.isExpanded && $50a94826b3c5e83c$var$animatedRotationStylesInverted
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
            spacing: "spacious",
            label: props.label,
            size: "small"
        })),
        testId: props.testId
    }));
};
const $50a94826b3c5e83c$var$animatedRotationStyles = (0, $2m8U6.xcss)({
    transition: '200ms ease all',
    transform: 'rotate(0deg)'
});
const $50a94826b3c5e83c$var$animatedRotationStylesInverted = (0, $2m8U6.xcss)({
    transform: 'rotate(180deg)'
});

});
parcelRegister("lszf6", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e34db3d74caf1c6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");

var $cgBrh = parcelRequire("cgBrh");

var $bnkkA = parcelRequire("bnkkA");

var $4hzy3 = parcelRequire("4hzy3");
const $0e34db3d74caf1c6$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $0e34db3d74caf1c6$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $c1tmZ.default), onMouseUp: providedOnMouseUp = (0, $c1tmZ.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const isOnlySingleIcon = (0, $4hzy3.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $4fqPo.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    // in Firefox
    const onMouseDown = (0, $4fqPo.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($0e34db3d74caf1c6$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $4fqPo.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($0e34db3d74caf1c6$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $4fqPo.useMemo)(()=>(0, $bnkkA.getCss)({
            appearance: appearance,
            spacing: spacing,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cgBrh.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        // manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$0e34db3d74caf1c6$var$Button.displayName = 'Button';
var $0e34db3d74caf1c6$export$2e2bcd8739ae039 = $0e34db3d74caf1c6$var$Button;

});
parcelRegister("c1tmZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4034ed67f396f267$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $4034ed67f396f267$export$2e2bcd8739ae039() {}

});

parcelRegister("cgBrh", function(module, exports) {
$parcel$export(module.exports, "default", () => $89e7cbfac67074f4$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");

var $jNU2T = parcelRequire("jNU2T");

var $hLMDx = parcelRequire("hLMDx");

var $9XaAY = parcelRequire("9XaAY");

var $9HmQQ = parcelRequire("9HmQQ");

var $cErh4 = parcelRequire("cErh4");

var $6m0ot = parcelRequire("6m0ot");

var $eGxKs = parcelRequire("eGxKs");

var $39QYu = parcelRequire("39QYu");

var $dN9vV = parcelRequire("dN9vV");
function $89e7cbfac67074f4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $89e7cbfac67074f4$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $89e7cbfac67074f4$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $89e7cbfac67074f4$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $89e7cbfac67074f4$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $39QYu.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $89e7cbfac67074f4$var$getChildren = (children, childrenStyles)=>{
    if ((0, $39QYu.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $89e7cbfac67074f4$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $c1tmZ.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $c1tmZ.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $4fqPo.useRef)();
    const setRef = (0, $4fqPo.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $jNU2T.default)(ourRef, autoFocus);
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $4fqPo.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $4fqPo.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $lqVX7.css)((0, $6m0ot.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $hLMDx.default), null, /*#__PURE__*/ (0, $lqVX7.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $89e7cbfac67074f4$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $9HmQQ.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $eGxKs.getIconStyle)({
                spacing: spacing
            }),
            $89e7cbfac67074f4$var$getSpacingFix(children, $89e7cbfac67074f4$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $89e7cbfac67074f4$var$getChildren(children, [
        fadeStyles,
        (0, $cErh4.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $eGxKs.getIconStyle)({
                spacing: spacing
            }),
            $89e7cbfac67074f4$var$getSpacingFix(children, $89e7cbfac67074f4$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        css: [
            (0, $dN9vV.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$89e7cbfac67074f4$export$2e2bcd8739ae039 = $89e7cbfac67074f4$var$ButtonBase;

});
parcelRegister("4EOcq", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $83393130621e763c$export$a4687b0234b40e28);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $kjnaA = parcelRequire("kjnaA");
function $83393130621e763c$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $kjnaA.useTrackedRef)(analyticsData);
    const fnRef = (0, $kjnaA.useTrackedRef)(fn);
    const handler = (0, $4fqPo.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("jNU2T", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8be15b390af0cfe$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $f8be15b390af0cfe$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $4fqPo.useRef)(true);
    (0, $4fqPo.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("hLMDx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5ec8d3fae96f0b3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");
const $a5ec8d3fae96f0b3$var$BORDER_WIDTH = 2;
const $a5ec8d3fae96f0b3$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
    outlineOffset: $a5ec8d3fae96f0b3$var$BORDER_WIDTH
});
const $a5ec8d3fae96f0b3$var$baseInsetStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    outlineColor: "var(--ds-border-focused, #4688EC)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$a5ec8d3fae96f0b3$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-focused, 2px)"
});
const $a5ec8d3fae96f0b3$var$focusRingStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $a5ec8d3fae96f0b3$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $a5ec8d3fae96f0b3$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`
        }
    }
});
const $a5ec8d3fae96f0b3$var$insetFocusRingStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $a5ec8d3fae96f0b3$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $a5ec8d3fae96f0b3$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: `${"var(--ds-border-width, 1px)"} solid`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $a5ec8d3fae96f0b3$var$FocusRing = /*#__PURE__*/ (0, $4fqPo.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $a5ec8d3fae96f0b3$var$baseInsetStyles : $a5ec8d3fae96f0b3$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $a5ec8d3fae96f0b3$var$insetFocusRingStyles : $a5ec8d3fae96f0b3$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $lqVX7.ClassNames), null, ({ css: css, cx: cx })=>(0, $4fqPo.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $4fqPo.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$a5ec8d3fae96f0b3$var$FocusRing.displayName = 'FocusRing';
var $a5ec8d3fae96f0b3$export$2e2bcd8739ae039 = $a5ec8d3fae96f0b3$var$FocusRing;

});

parcelRegister("9HmQQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd77164611e0eea6$export$2e2bcd8739ae039);
function $fd77164611e0eea6$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $fd77164611e0eea6$var$tabKeyCode = 9;
function $fd77164611e0eea6$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $fd77164611e0eea6$var$tabKeyCode) return;
    $fd77164611e0eea6$var$abort(event);
}
const $fd77164611e0eea6$var$block = {
    onMouseDownCapture: $fd77164611e0eea6$var$abort,
    onMouseUpCapture: $fd77164611e0eea6$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $fd77164611e0eea6$var$onKey,
    onKeyUpCapture: $fd77164611e0eea6$var$onKey,
    onTouchStartCapture: $fd77164611e0eea6$var$abort,
    onTouchEndCapture: $fd77164611e0eea6$var$abort,
    onPointerDownCapture: $fd77164611e0eea6$var$abort,
    onPointerUpCapture: $fd77164611e0eea6$var$abort,
    onClickCapture: $fd77164611e0eea6$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $fd77164611e0eea6$var$abort
};
const $fd77164611e0eea6$var$doNotBlock = {};
function $fd77164611e0eea6$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $fd77164611e0eea6$var$doNotBlock : $fd77164611e0eea6$var$block;
}

});

parcelRegister("cErh4", function(module, exports) {
$parcel$export(module.exports, "getContentStyle", () => $a2a22ff0c20f0207$export$7ad0316cc0dd65a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");
function $a2a22ff0c20f0207$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $lqVX7.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : '0 2px',
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}

});

parcelRegister("6m0ot", function(module, exports) {
$parcel$export(module.exports, "getFadingCss", () => $88fbab6c90ee5ba6$export$1b5827d324e945b1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");
function $88fbab6c90ee5ba6$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $lqVX7.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}

});

parcelRegister("eGxKs", function(module, exports) {
$parcel$export(module.exports, "getIconStyle", () => $dc8034699adf4f2d$export$864eea3f4ec3368f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");
function $dc8034699adf4f2d$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $lqVX7.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : `0 2px`,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}

});

parcelRegister("39QYu", function(module, exports) {
$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $848596032d1904b8$export$20bbd2efb0d734c4);

var $4fqPo = parcelRequire("4fqPo");

var $gFdUI = parcelRequire("gFdUI");
const $848596032d1904b8$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $4fqPo.isValidElement)(children) && children.type === (0, $gFdUI.default);
};

});
parcelRegister("gFdUI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d146fd96d6dc1e2d$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $d146fd96d6dc1e2d$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $d146fd96d6dc1e2d$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
$d146fd96d6dc1e2d$var$VisuallyHidden.displayName = 'VisuallyHidden';
var $d146fd96d6dc1e2d$export$2e2bcd8739ae039 = $d146fd96d6dc1e2d$var$VisuallyHidden;

});


parcelRegister("dN9vV", function(module, exports) {
$parcel$export(module.exports, "overlayCss", () => $79ab10369e1b7673$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $79ab10369e1b7673$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});


parcelRegister("bnkkA", function(module, exports) {
$parcel$export(module.exports, "getCss", () => $8e3ea5d3f36c9ae7$export$955358618f994a11);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3H4LK = parcelRequire("3H4LK");
const $8e3ea5d3f36c9ae7$var$gridSize = 8;
const $8e3ea5d3f36c9ae7$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
const $8e3ea5d3f36c9ae7$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $8e3ea5d3f36c9ae7$var$lineHeights = {
    default: $8e3ea5d3f36c9ae7$var$heights.default,
    compact: $8e3ea5d3f36c9ae7$var$heights.compact,
    none: 'inherit'
};
const $8e3ea5d3f36c9ae7$var$padding = {
    // 10px gutter
    default: `0 ${$8e3ea5d3f36c9ae7$var$gridSize + $8e3ea5d3f36c9ae7$var$gridSize / 4}px`,
    compact: `0 ${$8e3ea5d3f36c9ae7$var$gridSize + $8e3ea5d3f36c9ae7$var$gridSize / 4}px`,
    none: '0'
};
const $8e3ea5d3f36c9ae7$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$8e3ea5d3f36c9ae7$var$gridSize / 4}px`,
    default: `0 ${$8e3ea5d3f36c9ae7$var$gridSize / 4}px`,
    none: '0'
};
const $8e3ea5d3f36c9ae7$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $8e3ea5d3f36c9ae7$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $8e3ea5d3f36c9ae7$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$8e3ea5d3f36c9ae7$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $8e3ea5d3f36c9ae7$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $8e3ea5d3f36c9ae7$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $8e3ea5d3f36c9ae7$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $8e3ea5d3f36c9ae7$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $8e3ea5d3f36c9ae7$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $8e3ea5d3f36c9ae7$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $8e3ea5d3f36c9ae7$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$8e3ea5d3f36c9ae7$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $8e3ea5d3f36c9ae7$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $8e3ea5d3f36c9ae7$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $3H4LK.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $8e3ea5d3f36c9ae7$var$heights[spacing],
        lineHeight: $8e3ea5d3f36c9ae7$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $8e3ea5d3f36c9ae7$var$singleIconPadding[spacing] : $8e3ea5d3f36c9ae7$var$padding[spacing],
        verticalAlign: $8e3ea5d3f36c9ae7$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $8e3ea5d3f36c9ae7$var$selectedStyles : {
            ...appearance === 'default' && $8e3ea5d3f36c9ae7$var$defaultStyles,
            ...appearance === 'primary' && $8e3ea5d3f36c9ae7$var$primaryStyles,
            ...appearance === 'link' && $8e3ea5d3f36c9ae7$var$linkStyles,
            ...appearance === 'subtle' && $8e3ea5d3f36c9ae7$var$subtleStyles,
            ...appearance === 'subtle-link' && $8e3ea5d3f36c9ae7$var$subtleLinkStyles,
            ...appearance === 'warning' && $8e3ea5d3f36c9ae7$var$warningStyles,
            ...appearance === 'danger' && $8e3ea5d3f36c9ae7$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $8e3ea5d3f36c9ae7$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $8e3ea5d3f36c9ae7$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $8e3ea5d3f36c9ae7$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #0515240F)" : 'transparent'
                }
            },
            ...$8e3ea5d3f36c9ae7$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}

});

parcelRegister("4hzy3", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b516b102f719bd7$export$2e2bcd8739ae039);

var $39QYu = parcelRequire("39QYu");
function $4b516b102f719bd7$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $39QYu.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("cTq8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $962ee5497d96532b$var$_react = $962ee5497d96532b$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $962ee5497d96532b$var$_baseNew = $962ee5497d96532b$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $962ee5497d96532b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $962ee5497d96532b$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $962ee5497d96532b$var$_react.default.createElement($962ee5497d96532b$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$962ee5497d96532b$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $962ee5497d96532b$var$_default = module.exports.default = $962ee5497d96532b$var$ChevronDownIcon;

});

parcelRegister("8Mj6h", function(module, exports) {
$parcel$export(module.exports, "default", () => $17ec01127aa09934$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $7iFze = parcelRequire("7iFze");

var $c1tmZ = parcelRequire("c1tmZ");

var $1zqWh = parcelRequire("1zqWh");

var $19zT2 = parcelRequire("19zT2");

var $1AxDb = parcelRequire("1AxDb");

var $eO5yD = parcelRequire("eO5yD");
var $93stz = parcelRequire("93stz");

var $3H4LK = parcelRequire("3H4LK");

var $iWcAk = parcelRequire("iWcAk");

var $7biT4 = parcelRequire("7biT4");

var $2vWb1 = parcelRequire("2vWb1");

var $R17QT = parcelRequire("R17QT");

var $9VLm8 = parcelRequire("9VLm8");

var $1v8Ej = parcelRequire("1v8Ej");

var $jC6gp = parcelRequire("jC6gp");

var $2J0Cu = parcelRequire("2J0Cu");

var $l9AV9 = parcelRequire("l9AV9");

var $lxTej = parcelRequire("lxTej");

var $4giFx = parcelRequire("4giFx");

var $a9jLr = parcelRequire("a9jLr");

var $gDq4a = parcelRequire("gDq4a");

var $3fdjx = parcelRequire("3fdjx");
const $17ec01127aa09934$var$tooltipZIndex = (0, $2vWb1.layers).tooltip();
const $17ec01127aa09934$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: undefined,
    packageVersion: undefined
};
// Inverts motion direction
const $17ec01127aa09934$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ const $17ec01127aa09934$var$getDirectionFromPlacement = (placement)=>placement.split('-')[0];
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $17ec01127aa09934$var$Tooltip({ children: children, position: position = 'bottom', mousePosition: mousePosition = 'bottom', content: content, truncate: truncate = false, // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
component: Container = (0, $3fdjx.default), tag: TargetContainer = 'div', testId: testId, delay: delay = 300, onShow: onShow = (0, $c1tmZ.default), onHide: onHide = (0, $c1tmZ.default), canAppear: canAppear, hideTooltipOnClick: hideTooltipOnClick = false, hideTooltipOnMouseDown: hideTooltipOnMouseDown = false, analyticsContext: analyticsContext, strategy: strategy = 'fixed', ignoreTooltipPointerEvents: ignoreTooltipPointerEvents = false, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = false, shortcut: shortcut, shouldAlwaysFadeIn: shouldAlwaysFadeIn = false, shouldRenderToParent: shouldRenderToParent = false }) {
    // Not using a gate for this check. When the gate is disabled `mouse-y` and `mouse-x` are treated as `mouse`.
    const isMousePosition = position === 'mouse' || position === 'mouse-y' || position === 'mouse-x';
    const tooltipPosition = isMousePosition ? mousePosition : position;
    const onShowHandler = (0, $7iFze.usePlatformLeafSyntheticEventHandler)({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext,
        ...$17ec01127aa09934$var$analyticsAttributes
    });
    const onHideHandler = (0, $7iFze.usePlatformLeafSyntheticEventHandler)({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext,
        ...$17ec01127aa09934$var$analyticsAttributes
    });
    const apiRef = (0, $4fqPo.useRef)(null);
    const [state, setState] = (0, $4fqPo.useState)('hide');
    const targetRef = (0, $4fqPo.useRef)(null);
    const containerRef = (0, $4fqPo.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    const setImplicitRefFromChildren = (node)=>{
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    const setDirectRef = (0, $4fqPo.useCallback)((node)=>{
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    const stableState = (0, $19zT2.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    const onShowHandlerStable = (0, $19zT2.default)(onShowHandler);
    const onHideHandlerStable = (0, $19zT2.default)(onHideHandler);
    const delayStable = (0, $19zT2.default)(delay);
    const canAppearStable = (0, $19zT2.default)(canAppear);
    const hasCalledShowHandler = (0, $4fqPo.useRef)(false);
    const shouldAlwaysFadeInStable = (0, $19zT2.default)(shouldAlwaysFadeIn);
    const start = (0, $4fqPo.useCallback)((api)=>{
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    const done = (0, $4fqPo.useCallback)(()=>{
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    const abort = (0, $4fqPo.useCallback)(()=>{
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $4fqPo.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    const isDraggingRef = (0, $4fqPo.useRef)(false);
    (0, $4fqPo.useEffect)(()=>{
        return (0, $l9AV9.register)({
            onRegister ({ isDragging: isDragging }) {
                isDraggingRef.current = isDragging;
            },
            onDragStart () {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd () {
                isDraggingRef.current = false;
            }
        });
    }, []);
    const tryShowTooltip = (0, $4fqPo.useCallback)((source)=>{
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        const entry = {
            source: source,
            delay: delayStable.current,
            show: ({ isImmediate: isImmediate })=>{
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(!isImmediate ? 'fade-in' : 'show-immediate');
            },
            hide: ({ isImmediate: isImmediate })=>{
                if (isImmediate) setState('hide');
                else if ((0, $3H4LK.fg)('platform-dst-top-layer')) // Top-layer path: set state to 'top-layer-exit'. The component
                // stays mounted and Popover's isOpen prop transitions to
                // false, triggering the CSS exit animation internally.
                // finishHideAnimation is called after a brief delay matching
                // the CSS exit animation duration.
                setState('top-layer-exit');
                else setState('before-fade-out');
            },
            done: done,
            shouldAlwaysFadeIn: shouldAlwaysFadeInStable.current
        };
        const api = (0, $a9jLr.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable,
        shouldAlwaysFadeInStable
    ]);
    const hideTooltipOnEsc = (0, $4fqPo.useCallback)(()=>{
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    // When using top-layer, popover="auto" handles Escape natively
    (0, $1zqWh.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out' || state === 'top-layer-exit' || (0, $3H4LK.fg)('platform-dst-top-layer')
    });
    // ── Top-layer exit animation lifecycle ──
    // When state is 'top-layer-exit', Popover's isOpen transitions to false and
    // the CSS exit animation plays. The Popover's built-in `transitionend`
    // detection (with timeout fallback) calls `onExitFinish` when the exit
    // animation completes, which triggers the tooltip-manager lifecycle
    // (finishHideAnimation → done → onHide, setState('hide'), cleanup).
    const handleExitFinish = (0, $4fqPo.useCallback)(()=>{
        var _apiRef$current3;
        (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || _apiRef$current3.finishHideAnimation();
    }, []);
    (0, $4fqPo.useEffect)(()=>{
        if (state === 'hide') return 0, $c1tmZ.default;
        if (state === 'before-fade-out') setState('fade-out');
        const unbind = (0, $lMcEJ.bind)(window, {
            type: 'scroll',
            listener: ()=>{
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    const onMouseDown = (0, $4fqPo.useCallback)(()=>{
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    const onClick = (0, $4fqPo.useCallback)(()=>{
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOver = (0, $4fqPo.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        const source = isMousePosition ? {
            type: 'mouse',
            clientX: event.clientX,
            clientY: event.clientY
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        isMousePosition,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    const onMouseOut = (0, $4fqPo.useCallback)((event)=>{
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onMouseMove = isMousePosition ? (event)=>{
        var _apiRef$current4;
        if ((_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.isActive()) apiRef.current.mousePos = {
            clientX: event.clientX,
            clientY: event.clientY
        };
    } : undefined;
    const onMouseOverTooltip = (0, $4fqPo.useCallback)(()=>{
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    const onFocus = (0, $4fqPo.useCallback)((e)=>{
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible')) return;
        } catch  {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    const onBlur = (0, $4fqPo.useCallback)(()=>{
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    const onAnimationFinished = (0, $4fqPo.useCallback)((transition)=>{
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    const shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    const shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    const shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out' && state !== 'top-layer-exit';
    const handleOpenLayerObserverCloseSignal = (0, $4fqPo.useCallback)(()=>{
        var _apiRef$current5;
        (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 || _apiRef$current5.requestHide({
            isImmediate: true
        });
    }, []);
    // On the top-layer path, the Popover primitive (used by TopLayerTooltipPopup)
    // registers with the observer directly, so we skip registration here to
    // avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $3H4LK.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
       * We don't strictly need to provide an onClose callback at this time, as there is
       * already code that handles hiding the tooltip when a drag is started (and the only
       * usage right now is closing all layers when the user resizes the side nav).
       *
       * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
       * whenever the open layer observer requests a close.
       */ onClose: handleOpenLayerObserverCloseSignal
    });
    const getReferenceElement = ()=>{
        var _apiRef$current6;
        if (isMousePosition && (_apiRef$current6 = apiRef.current) !== null && _apiRef$current6 !== void 0 && _apiRef$current6.mousePos && targetRef.current) return (0, $4giFx.getVirtualElementFromMousePos)(apiRef.current.mousePos, {
            targetElement: targetRef.current,
            tooltipPosition: position
        });
        return targetRef.current || undefined;
    };
    const tooltipIdForHiddenContent = (0, $gDq4a.default)('tooltip', shouldRenderHiddenContent);
    const tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    const isChildrenAFunction = typeof children === 'function';
    (0, $4fqPo.useEffect)(()=>{
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        const target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return ()=>target.removeAttribute('aria-describedby');
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    const hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        "data-testid": testId ? `${testId}-hidden` : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    const PopperWrapper = shouldRenderToParent ? (0, $4fqPo.Fragment) : $17ec01127aa09934$var$TooltipPortal;
    const trigger = typeof children === 'function' ? // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children({
        ...tooltipTriggerProps,
        // `testId` propagates to the trigger element so `data-testid` lands in the
        // rendered DOM. Required because `@atlaskit/button/new` (and other Pressable-
        // backed primitives) overwrite `data-testid` from spread; passing a typed
        // `testId` lets their own destructure pick it up directly.
        ...testId ? {
            testId: `${testId}--container`
        } : {},
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    }), hiddenContent) : // @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(CastTargetContainer, {
        ...tooltipTriggerProps,
        ...testId ? {
            'data-testid': `${testId}--container`
        } : undefined,
        ref: setImplicitRefFromChildren,
        /**
   * TODO: Why is role="presentation" added?
   * - Is it only to "remove" the `Container` from screen readers?
   * - Why is it added only to the `Container` but not to `tooltipTriggerProps`?
   * - Should `role="presentation"` only be used if `shouldRenderHiddenContent == false`?
   */ role: "presentation"
    }, children, hiddenContent);
    if ((0, $3H4LK.fg)('platform-dst-top-layer')) {
        var _apiRef$current7;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($17ec01127aa09934$var$TopLayerTooltipPopup, {
            targetRef: targetRef,
            tooltipPosition: tooltipPosition,
            mousePos: ((_apiRef$current7 = apiRef.current) === null || _apiRef$current7 === void 0 ? void 0 : _apiRef$current7.mousePos) ?? undefined,
            position: position,
            onMouseOut: onMouseOut,
            onMouseOverTooltip: onMouseOverTooltip,
            ignoreTooltipPointerEvents: ignoreTooltipPointerEvents,
            truncate: truncate,
            testId: testId,
            shortcut: shortcut,
            content: content,
            Container: Container,
            onClose: ()=>{
                var _apiRef$current8;
                return (_apiRef$current8 = apiRef.current) === null || _apiRef$current8 === void 0 ? void 0 : _apiRef$current8.requestHide({
                    isImmediate: true
                });
            },
            onExitFinish: handleExitFinish,
            isOpen: state !== 'hide' && state !== 'top-layer-exit'
        }) : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, trigger, shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(PopperWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iWcAk.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, ({ ref: ref, style: style, update: update, placement: placement })=>{
        const direction = isMousePosition ? undefined : $17ec01127aa09934$var$invertedDirection[$17ec01127aa09934$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eO5yD.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93stz.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, ({ className: className })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Container, {
                ref: ref,
                /**
               * "Tooltip" classname is a hook used by tests to manipulate
               * and hide tooltips, including in VR snapshots
               */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: `Tooltip ${className}`,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...style,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    ...ignoreTooltipPointerEvents && {
                        pointerEvents: 'none'
                    }
                },
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && `${testId}--unresolved`,
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip,
                shortcut: shortcut
            }, typeof content === 'function' ? content({
                update: update
            }) : content)));
    })) : null);
}
var $17ec01127aa09934$export$2e2bcd8739ae039 = $17ec01127aa09934$var$Tooltip;
const $17ec01127aa09934$var$TooltipPortal = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7biT4.default), {
        zIndex: $17ec01127aa09934$var$tooltipZIndex
    }, children);
};
// Module-level preset instance, stable reference, no re-allocation per render.
// Non-mouse tooltips slide in from the direction of the trigger — slide + fade.
const $17ec01127aa09934$var$tooltipAnimation = (0, $R17QT.slideAndFade)();
// Mouse-position tooltips follow the cursor and have no fixed direction — fade only.
const $17ec01127aa09934$var$tooltipMouseAnimation = (0, $R17QT.fade)();
/**
 * Top-layer tooltip popup component.
 *
 * Composes `Popover` (top-layer visibility + animation) with one of two
 * positioning hooks:
 *
 *   - `useAnchorPositionAtPoint` — for cursor-tracking positions
 *     (`mouse`, `mouse-x`, `mouse-y`) when a cursor position is
 *     available (i.e. the popup was activated by a pointer). Positions
 *     the popover relative to a hidden synthetic anchor that follows
 *     the cursor according to the `position` / `mousePosition`
 *     semantics. The synthetic anchor element is rendered as a sibling
 *     of the popover.
 *   - `useAnchorPosition` directly — for non-cursor positions, AND
 *     for cursor positions activated via keyboard focus (where there
 *     is no cursor to track). Anchoring directly to the trigger keeps
 *     keyboard-activated tooltips correctly placed next to the target
 *     instead of rendering in the top-left of the viewport.
 *
 * Exactly one positioning strategy is active at a time: `useAnchorPosition`
 * is wired to the trigger only when the mouse strategy is inactive, and
 * `useAnchorPositionAtPoint` is told `isActive: false` when the direct
 * anchor strategy is active. The other hook is still called (Rules of
 * Hooks) but does no work.
 *
 * Exit animation is handled by `Popover`'s `isOpen` prop. When `isOpen`
 * transitions to `false`, the primitive calls `hidePopover()` internally and
 * the CSS exit animation plays via `allow-discrete`. No glue code needed.
 */ function $17ec01127aa09934$var$TopLayerTooltipPopup({ targetRef: targetRef, tooltipPosition: tooltipPosition, mousePos: mousePos, position: position, onMouseOut: onMouseOut, onMouseOverTooltip: onMouseOverTooltip, ignoreTooltipPointerEvents: ignoreTooltipPointerEvents, truncate: truncate, testId: testId, shortcut: shortcut, content: content, Container: Container, onClose: onClose, onExitFinish: onExitFinish, isOpen: isOpen }) {
    const popoverRef = (0, $4fqPo.useRef)(null);
    // Translate the legacy Popper-style placement string ("right",
    // "bottom-start", etc.) once and pass the same object to both hooks.
    const placement = (0, $9VLm8.fromLegacyPlacement)({
        legacy: tooltipPosition
    });
    const isMousePosition = position === 'mouse' || position === 'mouse-x' || position === 'mouse-y';
    const isMouseStrategyActive = isMousePosition && Boolean(mousePos);
    // Direct anchor strategy: anchors to the trigger element.
    // Disabled when the mouse strategy is active — both hooks writing
    // to the same popover would fight for positioning ownership.
    (0, $jC6gp.useAnchorPosition)({
        anchorRef: targetRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: !isMouseStrategyActive,
        isOpen: isOpen
    });
    // Mouse anchor strategy: the hook calls `getPoint()` exactly once
    // per activation and latches the resulting coordinate. The latch is
    // per-show because `TopLayerTooltipPopup` mounts fresh on every
    // show.
    //
    // `getPoint()` returns `null` for keyboard-activated shows (where
    // `mousePos` is undefined) or before the trigger has mounted —
    // leaving the direct strategy above to own positioning.
    //
    // SSR note: `getBoundingClientRect()` is only called here because
    // `TopLayerTooltipPopup` is gated behind client-only state
    // transitions.
    (0, $2J0Cu.useAnchorPositionAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isMouseStrategyActive,
        isOpen: isOpen,
        getPoint: ()=>{
            if (!mousePos || !targetRef.current || !isMousePosition) return null;
            return (0, $lxTej.getAnchorPoint)({
                cursor: mousePos,
                triggerRect: targetRef.current.getBoundingClientRect(),
                tooltipPosition: position,
                placement: placement
            });
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1v8Ej.Popover), {
        ref: popoverRef,
        role: "tooltip",
        mode: "hint",
        isOpen: isOpen,
        onClose: onClose,
        onExitFinish: onExitFinish,
        testId: testId ? `${testId}--popover` : undefined,
        // Override directional slide: mouse positions should fade only
        animate: isMouseStrategyActive ? $17ec01127aa09934$var$tooltipMouseAnimation : $17ec01127aa09934$var$tooltipAnimation,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Container, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- top-layer spike
        className: "Tooltip",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- top-layer spike
        style: ignoreTooltipPointerEvents ? {
            pointerEvents: 'none'
        } : undefined,
        truncate: truncate,
        placement: tooltipPosition,
        testId: testId,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOverTooltip,
        shortcut: shortcut,
        role: "presentation"
    }, typeof content === 'function' ? content({
        update: (0, $c1tmZ.default)
    }) : content));
}

});
parcelRegister("7iFze", function(module, exports) {
$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $d010c8d4aa660d2d$export$1a04351537078b55);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $kjnaA = parcelRequire("kjnaA");
function $d010c8d4aa660d2d$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $kjnaA.useTrackedRef)(analyticsData);
    const fnRef = (0, $kjnaA.useTrackedRef)(fn);
    const handler = (0, $4fqPo.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("1zqWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9d3369c4620d4ad$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $hXq6r = parcelRequire("hXq6r");
function $e9d3369c4620d4ad$export$2e2bcd8739ae039({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $4fqPo.useRef)(false);
    const onKeyDown = (0, $4fqPo.useCallback)((e)=>{
        if (isDisabled || escapePressed.current || e.key !== (0, $hXq6r.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    const onKeyUp = (0, $4fqPo.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $4fqPo.useEffect)(()=>{
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled) return;
        return (0, $lMcEJ.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("hXq6r", function(module, exports) {
$parcel$export(module.exports, "KEY_UP", () => $8c6b6ec77118114b$export$390330c10ff2b9a1);
$parcel$export(module.exports, "KEY_DOWN", () => $8c6b6ec77118114b$export$a80636c6f41931fe);
$parcel$export(module.exports, "KEY_LEFT", () => $8c6b6ec77118114b$export$fc4577f2a2af0ae3);
$parcel$export(module.exports, "KEY_RIGHT", () => $8c6b6ec77118114b$export$c40f9845adc73fb5);
$parcel$export(module.exports, "KEY_HOME", () => $8c6b6ec77118114b$export$4af703091671bc);
$parcel$export(module.exports, "KEY_END", () => $8c6b6ec77118114b$export$e2bc30913faa5db7);
$parcel$export(module.exports, "KEY_TAB", () => $8c6b6ec77118114b$export$10f6869ed0a7d75b);
$parcel$export(module.exports, "KEY_ENTER", () => $8c6b6ec77118114b$export$8152f929a25a0ff4);
$parcel$export(module.exports, "KEY_SPACE", () => $8c6b6ec77118114b$export$e51a3576c045c8d5);
$parcel$export(module.exports, "ESCAPE", () => $8c6b6ec77118114b$export$2bb790b9008907b4);
/**
 * Character key codes which can be used in keyboard events.
 */ const $8c6b6ec77118114b$export$390330c10ff2b9a1 = 'ArrowUp';
const $8c6b6ec77118114b$export$a80636c6f41931fe = 'ArrowDown';
const $8c6b6ec77118114b$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $8c6b6ec77118114b$export$c40f9845adc73fb5 = 'ArrowRight';
const $8c6b6ec77118114b$export$4af703091671bc = 'Home';
const $8c6b6ec77118114b$export$e2bc30913faa5db7 = 'End';
const $8c6b6ec77118114b$export$10f6869ed0a7d75b = 'Tab';
const $8c6b6ec77118114b$export$8152f929a25a0ff4 = 'Enter';
const $8c6b6ec77118114b$export$e51a3576c045c8d5 = 'Space';
const $8c6b6ec77118114b$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("19zT2", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba0f0b9db76967e8$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $ba0f0b9db76967e8$export$2e2bcd8739ae039(value) {
    const ref = (0, $4fqPo.useRef)(value);
    (0, $4fqPo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("1AxDb", function(module, exports) {
$parcel$export(module.exports, "useNotifyOpenLayerObserver", () => $e7f5830811997ef8$export$469bb693f11edc7f);

var $4fqPo = parcelRequire("4fqPo");

var $gwe2v = parcelRequire("gwe2v");

var $l0KFc = parcelRequire("l0KFc");
function $e7f5830811997ef8$export$469bb693f11edc7f({ isOpen: isOpen, type: type, onClose: onClose }) {
    const context = (0, $4fqPo.useContext)((0, $gwe2v.OpenLayerObserverContext));
    const namespace = (0, $l0KFc.useOpenLayerObserverNamespace)();
    (0, $4fqPo.useEffect)(()=>{
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace,
            type: type
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose,
        type
    ]);
}

});
parcelRegister("gwe2v", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverContext", () => $645c01a8a54bcde7$export$5fbf4d7fae6cdc00);

var $4fqPo = parcelRequire("4fqPo");
const $645c01a8a54bcde7$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);

});

parcelRegister("l0KFc", function(module, exports) {
$parcel$export(module.exports, "useOpenLayerObserverNamespace", () => $368c7b56bb4215ba$export$1d57e79091cc3046);

var $4fqPo = parcelRequire("4fqPo");

var $4cjL4 = parcelRequire("4cjL4");
function $368c7b56bb4215ba$export$1d57e79091cc3046() {
    const namespace = (0, $4fqPo.useContext)((0, $4cjL4.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("4cjL4", function(module, exports) {
$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", () => $b0a6c152442a8306$export$644a49f3b8c50fcd);

var $4fqPo = parcelRequire("4fqPo");
const $b0a6c152442a8306$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $4fqPo.createContext)(null);

});



parcelRegister("eO5yD", function(module, exports) {
$parcel$export(module.exports, "useExitingPersistence", () => $b418c0cd03468d28$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $b418c0cd03468d28$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
// We define empty context here so the object doesn't change.
const $b418c0cd03468d28$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $b418c0cd03468d28$var$ExitingContext = /*#__PURE__*/ (0, $4fqPo.createContext)($b418c0cd03468d28$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $b418c0cd03468d28$var$wrapChildWithContextProvider = (child, value = $b418c0cd03468d28$var$emptyContext)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b418c0cd03468d28$var$ExitingContext.Provider, {
        key: `${child.key}-provider`,
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $b418c0cd03468d28$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $4fqPo.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $b418c0cd03468d28$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $b418c0cd03468d28$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $b418c0cd03468d28$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $b418c0cd03468d28$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $b418c0cd03468d28$var$ExitingPersistence = /*#__PURE__*/ (0, $4fqPo.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $4fqPo.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $4fqPo.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $4fqPo.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $4fqPo.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $b418c0cd03468d28$var$childrenToArray(previousChildren);
    const current = $b418c0cd03468d28$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const nextChildren = currentChildren !== children ? $b418c0cd03468d28$var$childrenToArray(children) : current;
    const missingKeys = $b418c0cd03468d28$var$getMissingKeys(nextChildren, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = !isSomeChildRemoved && currentChildren !== children ? nextChildren : current;
    if (isSomeChildRemoved) visibleChildren = $b418c0cd03468d28$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = (0, $3H4LK.fg)('platform-dst-motion-uplift') ? previous : exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $b418c0cd03468d28$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$b418c0cd03468d28$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $b418c0cd03468d28$export$3b6f38abbdcbd000 = ()=>{
    return (0, $4fqPo.useContext)($b418c0cd03468d28$var$ExitingContext);
};
$b418c0cd03468d28$var$ExitingPersistence.displayName = 'ExitingPersistence';
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b418c0cd03468d28$export$2e2bcd8739ae039 = $b418c0cd03468d28$var$ExitingPersistence;

});

parcelRegister("93stz", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc97daddcf8f5b33$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bUO1m = parcelRequire("bUO1m");
const $dc97daddcf8f5b33$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $dc97daddcf8f5b33$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $dc97daddcf8f5b33$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bUO1m.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $dc97daddcf8f5b33$export$2e2bcd8739ae039 = $dc97daddcf8f5b33$var$FadeIn;

});
parcelRegister("bUO1m", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c6135f4f30be9e4$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $cR2qL = parcelRequire("cR2qL");

var $2dtXE = parcelRequire("2dtXE");

var $1dGol = parcelRequire("1dGol");

var $4Hk21 = parcelRequire("4Hk21");

var $eO5yD = parcelRequire("eO5yD");

var $ko2Wp = parcelRequire("ko2Wp");
const $8c6135f4f30be9e4$var$zoomIn = null;
const $8c6135f4f30be9e4$var$zoomOut = null;
const $8c6135f4f30be9e4$var$fadeIn = null;
const $8c6135f4f30be9e4$var$fadeOut = null;
const $8c6135f4f30be9e4$var$fadeInFromTop = null;
const $8c6135f4f30be9e4$var$fadeOutFromTop = null;
const $8c6135f4f30be9e4$var$fadeInFromLeft = null;
const $8c6135f4f30be9e4$var$fadeOutFromLeft = null;
const $8c6135f4f30be9e4$var$fadeInFromBottom = null;
const $8c6135f4f30be9e4$var$fadeOutFromBottom = null;
const $8c6135f4f30be9e4$var$fadeInFromRight = null;
const $8c6135f4f30be9e4$var$fadeOutFromRight = null;
const $8c6135f4f30be9e4$var$fadeInFromTopConstant = null;
const $8c6135f4f30be9e4$var$fadeOutFromTopConstant = null;
const $8c6135f4f30be9e4$var$fadeInFromLeftConstant = null;
const $8c6135f4f30be9e4$var$fadeOutFromLeftConstant = null;
const $8c6135f4f30be9e4$var$fadeInFromBottomConstant = null;
const $8c6135f4f30be9e4$var$fadeOutFromBottomConstant = null;
const $8c6135f4f30be9e4$var$fadeInFromRightConstant = null;
const $8c6135f4f30be9e4$var$fadeOutFromRightConstant = null;
const $8c6135f4f30be9e4$var$slideInFromTop = null;
const $8c6135f4f30be9e4$var$slideOutFromTop = null;
const $8c6135f4f30be9e4$var$slideInFromRight = null;
const $8c6135f4f30be9e4$var$slideOutFromRight = null;
const $8c6135f4f30be9e4$var$slideInFromBottom = null;
const $8c6135f4f30be9e4$var$slideOutFromBottom = null;
const $8c6135f4f30be9e4$var$slideInFromLeft = null;
const $8c6135f4f30be9e4$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $8c6135f4f30be9e4$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $ko2Wp.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $eO5yD.useExitingPersistence)();
    const setTimeout = (0, $4Hk21.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $4fqPo.useState)(appear);
    (0, $4fqPo.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $1dGol.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $2dtXE.exitingDurations)[duration] : (0, $cR2qL.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $ltgDR.default)([
            (0, $ltgDR.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $ltgDR.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $ltgDR.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $ltgDR.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $ltgDR.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $ltgDR.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $ltgDR.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $ltgDR.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $ltgDR.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $ltgDR.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $ltgDR.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $ltgDR.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $ltgDR.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $ltgDR.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $ltgDR.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $ltgDR.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $ltgDR.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $ltgDR.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $ltgDR.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $ltgDR.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $ltgDR.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $ltgDR.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $ltgDR.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $ltgDR.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $ltgDR.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $ltgDR.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $ltgDR.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $ltgDR.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $ltgDR.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $ltgDR.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $ltgDR.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $ltgDR.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $ltgDR.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $ltgDR.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $ltgDR.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $ltgDR.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $ltgDR.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $ltgDR.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $ltgDR.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $ltgDR.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $ltgDR.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $ltgDR.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $ltgDR.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $ltgDR.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $ltgDR.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $ltgDR.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $ltgDR.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $ltgDR.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $ltgDR.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $ltgDR.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $ltgDR.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $8c6135f4f30be9e4$export$2e2bcd8739ae039 = $8c6135f4f30be9e4$var$EnteringMotion;

});
parcelRegister("cR2qL", function(module, exports) {
$parcel$export(module.exports, "durations", () => $80b59ff2384073fb$export$38b928a7167ce124);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $80b59ff2384073fb$export$368bacef0dacbe05 = 25;
const $80b59ff2384073fb$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};

});

parcelRegister("2dtXE", function(module, exports) {
$parcel$export(module.exports, "exitingDurations", () => $ae5472911e25ba92$export$30fa1a2e62ae150c);

var $cR2qL = parcelRequire("cR2qL");
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $ae5472911e25ba92$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $ae5472911e25ba92$export$30fa1a2e62ae150c = {
    none: (0, $cR2qL.durations).none,
    small: (0, $cR2qL.durations).small * $ae5472911e25ba92$var$EXITING_MOTION_MULTIPLIER,
    medium: (0, $cR2qL.durations).medium * $ae5472911e25ba92$var$EXITING_MOTION_MULTIPLIER,
    large: (0, $cR2qL.durations).large * $ae5472911e25ba92$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("1dGol", function(module, exports) {
$parcel$export(module.exports, "isReducedMotion", () => $0f127c0630dfe0ae$export$b7baf7667a68d87c);

var $fgJEV = parcelRequire("fgJEV");
const $0f127c0630dfe0ae$export$b7baf7667a68d87c = ()=>{
    if (!(0, $fgJEV.isMatchMediaAvailable)()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};

});
parcelRegister("fgJEV", function(module, exports) {
$parcel$export(module.exports, "isMatchMediaAvailable", () => $ed5f6beb9e77535b$export$c5406bd59b374abd);
const $ed5f6beb9e77535b$export$c5406bd59b374abd = ()=>typeof window !== 'undefined' && 'matchMedia' in window;

});


parcelRegister("4Hk21", function(module, exports) {
$parcel$export(module.exports, "useSetTimeout", () => $0993b8b94237dc49$export$4f34107a2b00f39c);

var $4fqPo = parcelRequire("4fqPo");
const $0993b8b94237dc49$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $0993b8b94237dc49$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $4fqPo.useRef)([]);
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $0993b8b94237dc49$var$getHookDeps(opts));
    return (0, $4fqPo.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("ko2Wp", function(module, exports) {
$parcel$export(module.exports, "useStaggeredEntrance", () => $3da34f04894cdb2e$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $3da34f04894cdb2e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");

var $lK4C3 = parcelRequire("lK4C3");

var $7aLDb = parcelRequire("7aLDb");
const $3da34f04894cdb2e$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $4fqPo.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $c1tmZ.default)
    }));
const $3da34f04894cdb2e$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $7aLDb.useUniqueId)();
    const context = (0, $4fqPo.useContext)($3da34f04894cdb2e$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $3da34f04894cdb2e$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $4fqPo.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $4fqPo.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $lK4C3.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3da34f04894cdb2e$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3da34f04894cdb2e$export$2e2bcd8739ae039 = $3da34f04894cdb2e$var$StaggeredEntrance;

});
parcelRegister("lK4C3", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $500eb06e27c7eb24$export$e5c5a5f917a5871c);

var $4fqPo = parcelRequire("4fqPo");
const $500eb06e27c7eb24$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $4fqPo.useEffect) : (0, $4fqPo.useLayoutEffect);

});

parcelRegister("7aLDb", function(module, exports) {
$parcel$export(module.exports, "useUniqueId", () => $d5213288ae57cdaa$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $4fqPo = parcelRequire("4fqPo");
function $d5213288ae57cdaa$export$c485849f2e393253() {
    const identifier = (0, $4fqPo.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("iWcAk", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $aa43633f81e7830e$export$badac9ada3a0bdf9);

var $4fqPo = parcelRequire("4fqPo");

var $4MhKo = parcelRequire("4MhKo");

var $25rZF = parcelRequire("25rZF");

const $aa43633f81e7830e$var$viewportPadding = 5;
const $aa43633f81e7830e$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $aa43633f81e7830e$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $aa43633f81e7830e$var$defaultChildrenFn() {
    return null;
}
const $aa43633f81e7830e$var$defaultOffset = [
    0,
    8
];
function $aa43633f81e7830e$export$badac9ada3a0bdf9({ children: children = $aa43633f81e7830e$var$defaultChildrenFn, offset: offset = $aa43633f81e7830e$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $4fqPo.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $aa43633f81e7830e$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $25rZF.getMaxSizeModifiers)({
            viewportPadding: $aa43633f81e7830e$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$aa43633f81e7830e$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $4fqPo.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4MhKo.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("4MhKo", function(module, exports) {
$parcel$export(module.exports, "Popper", () => $37a96961c04607e5$export$badac9ada3a0bdf9);

var $4fqPo = parcelRequire("4fqPo");

var $7DOtr = parcelRequire("7DOtr");

var $5Epqn = parcelRequire("5Epqn");

var $4fGiW = parcelRequire("4fGiW");
var $37a96961c04607e5$var$NOOP = function NOOP() {
    return void 0;
};
var $37a96961c04607e5$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $37a96961c04607e5$var$EMPTY_MODIFIERS = [];
function $37a96961c04607e5$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $37a96961c04607e5$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $4fqPo.useContext((0, $7DOtr.ManagerReferenceNodeContext));
    var _React$useState = $4fqPo.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $4fqPo.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $4fqPo.useEffect(function() {
        (0, $5Epqn.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $4fqPo.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $4fGiW.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $4fqPo.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $37a96961c04607e5$var$NOOP,
            update: update || $37a96961c04607e5$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $5Epqn.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("7DOtr", function(module, exports) {
$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $590353f6fb6eb0a8$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $590353f6fb6eb0a8$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $590353f6fb6eb0a8$export$d0d38e7dec7a1a61);

var $4fqPo = parcelRequire("4fqPo");
var $590353f6fb6eb0a8$export$3dbd3405086fec7b = $4fqPo.createContext();
var $590353f6fb6eb0a8$export$cbabb21c2529b130 = $4fqPo.createContext();
function $590353f6fb6eb0a8$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $4fqPo.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $4fqPo.useRef(false);
    $4fqPo.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $4fqPo.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $4fqPo.createElement($590353f6fb6eb0a8$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $4fqPo.createElement($590353f6fb6eb0a8$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("5Epqn", function(module, exports) {
$parcel$export(module.exports, "unwrapArray", () => $41d468ebf04d6ecb$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $41d468ebf04d6ecb$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $41d468ebf04d6ecb$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $41d468ebf04d6ecb$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $41d468ebf04d6ecb$export$700979bc83e7db82);

var $4fqPo = parcelRequire("4fqPo");
var $41d468ebf04d6ecb$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $41d468ebf04d6ecb$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $41d468ebf04d6ecb$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $41d468ebf04d6ecb$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $41d468ebf04d6ecb$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $41d468ebf04d6ecb$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $4fqPo.useLayoutEffect : $4fqPo.useEffect;

});

parcelRegister("4fGiW", function(module, exports) {
$parcel$export(module.exports, "usePopper", () => $318960ed6f59b53f$export$f4d5bf230a36dd6e);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $jN9Po = parcelRequire("jN9Po");

var $eoKRC = parcelRequire("eoKRC");

var $5Epqn = parcelRequire("5Epqn");
var $318960ed6f59b53f$var$EMPTY_MODIFIERS = [];
var $318960ed6f59b53f$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $4fqPo.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $318960ed6f59b53f$var$EMPTY_MODIFIERS
    };
    var _React$useState = $4fqPo.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $4fqPo.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $b2Ka1.flushSync(function() {
                    setState({
                        styles: (0, $5Epqn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $5Epqn.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $4fqPo.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eoKRC)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $4fqPo.useRef();
    (0, $5Epqn.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $5Epqn.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $jN9Po.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("jN9Po", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $e68a37877cbc417a$export$8f7491d57c8f97a9);

var $jBm1E = parcelRequire("jBm1E");

var $34TWH = parcelRequire("34TWH");

var $em07b = parcelRequire("em07b");

var $iJOZP = parcelRequire("iJOZP");

var $fmJKq = parcelRequire("fmJKq");

var $8pZHs = parcelRequire("8pZHs");

var $8RIXG = parcelRequire("8RIXG");

var $d64zN = parcelRequire("d64zN");

var $eDu4Q = parcelRequire("eDu4Q");

var $lt3Q3 = parcelRequire("lt3Q3");


var $e68a37877cbc417a$export$d34966752335dd47 = [
    (0, $34TWH.default),
    (0, $em07b.default),
    (0, $iJOZP.default),
    (0, $fmJKq.default),
    (0, $8pZHs.default),
    (0, $8RIXG.default),
    (0, $d64zN.default),
    (0, $eDu4Q.default),
    (0, $lt3Q3.default)
];
var $e68a37877cbc417a$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $jBm1E.popperGenerator)({
    defaultModifiers: $e68a37877cbc417a$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("jBm1E", function(module, exports) {
$parcel$export(module.exports, "popperGenerator", () => $e4528ee03bfd5e6e$export$ed5e13716264f202);

var $hYlFK = parcelRequire("hYlFK");

var $7nHLi = parcelRequire("7nHLi");

var $5bXkf = parcelRequire("5bXkf");

var $hYGzR = parcelRequire("hYGzR");

var $cI48b = parcelRequire("cI48b");

var $3uRvf = parcelRequire("3uRvf");

var $6WBom = parcelRequire("6WBom");


var $jeP6i = parcelRequire("jeP6i");
var $e4528ee03bfd5e6e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $e4528ee03bfd5e6e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $e4528ee03bfd5e6e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $e4528ee03bfd5e6e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $e4528ee03bfd5e6e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jeP6i.isElement)(reference) ? (0, $5bXkf.default)(reference) : reference.contextElement ? (0, $5bXkf.default)(reference.contextElement) : [],
                    popper: (0, $5bXkf.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $cI48b.default)((0, $6WBom.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$e4528ee03bfd5e6e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $hYlFK.default)(reference, (0, $hYGzR.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $7nHLi.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3uRvf.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$e4528ee03bfd5e6e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $e4528ee03bfd5e6e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $e4528ee03bfd5e6e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("hYlFK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d158d9f193025818$export$2e2bcd8739ae039);

var $3oU6P = parcelRequire("3oU6P");

var $6nERK = parcelRequire("6nERK");

var $cz4Eb = parcelRequire("cz4Eb");

var $jeP6i = parcelRequire("jeP6i");

var $744NN = parcelRequire("744NN");

var $C4vFj = parcelRequire("C4vFj");

var $hF1fp = parcelRequire("hF1fp");

var $fxWJm = parcelRequire("fxWJm");
function $d158d9f193025818$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $fxWJm.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $fxWJm.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $d158d9f193025818$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jeP6i.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jeP6i.isHTMLElement)(offsetParent) && $d158d9f193025818$var$isElementScaled(offsetParent);
    var documentElement = (0, $C4vFj.default)(offsetParent);
    var rect = (0, $3oU6P.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $cz4Eb.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $hF1fp.default)(documentElement)) scroll = (0, $6nERK.default)(offsetParent);
        if ((0, $jeP6i.isHTMLElement)(offsetParent)) {
            offsets = (0, $3oU6P.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $744NN.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("3oU6P", function(module, exports) {
$parcel$export(module.exports, "default", () => $279f23169522966f$export$2e2bcd8739ae039);

var $jeP6i = parcelRequire("jeP6i");

var $fxWJm = parcelRequire("fxWJm");

var $h0YDy = parcelRequire("h0YDy");

var $kAoni = parcelRequire("kAoni");
function $279f23169522966f$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jeP6i.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $fxWJm.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $fxWJm.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jeP6i.isElement)(element) ? (0, $h0YDy.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $kAoni.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jeP6i", function(module, exports) {
$parcel$export(module.exports, "isElement", () => $e016f69ce095eba5$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e016f69ce095eba5$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e016f69ce095eba5$export$af51f0f06c0f328a);

var $h0YDy = parcelRequire("h0YDy");
function $e016f69ce095eba5$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $h0YDy.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e016f69ce095eba5$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $h0YDy.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e016f69ce095eba5$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $h0YDy.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("h0YDy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c63179031cc1e85f$export$2e2bcd8739ae039);
function $c63179031cc1e85f$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("fxWJm", function(module, exports) {
$parcel$export(module.exports, "max", () => $b5177ebd4f9e6cb6$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $b5177ebd4f9e6cb6$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $b5177ebd4f9e6cb6$export$2077e0241d6afd3c);
var $b5177ebd4f9e6cb6$export$8960430cfd85939f = Math.max;
var $b5177ebd4f9e6cb6$export$96ec731ed4dcb222 = Math.min;
var $b5177ebd4f9e6cb6$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("kAoni", function(module, exports) {
$parcel$export(module.exports, "default", () => $efca13bd07ce8142$export$2e2bcd8739ae039);

var $9EhnE = parcelRequire("9EhnE");
function $efca13bd07ce8142$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9EhnE.default)());
}

});
parcelRegister("9EhnE", function(module, exports) {
$parcel$export(module.exports, "default", () => $706554dd43cbf159$export$2e2bcd8739ae039);
function $706554dd43cbf159$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("6nERK", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a54972fd5f1a072$export$2e2bcd8739ae039);

var $eCIAW = parcelRequire("eCIAW");

var $h0YDy = parcelRequire("h0YDy");

var $jeP6i = parcelRequire("jeP6i");

var $fVBd0 = parcelRequire("fVBd0");
function $4a54972fd5f1a072$export$2e2bcd8739ae039(node) {
    if (node === (0, $h0YDy.default)(node) || !(0, $jeP6i.isHTMLElement)(node)) return (0, $eCIAW.default)(node);
    else return (0, $fVBd0.default)(node);
}

});
parcelRegister("eCIAW", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa5734e19fa042e7$export$2e2bcd8739ae039);

var $h0YDy = parcelRequire("h0YDy");
function $aa5734e19fa042e7$export$2e2bcd8739ae039(node) {
    var win = (0, $h0YDy.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("fVBd0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9890ac85c7dd1ec$export$2e2bcd8739ae039);
function $b9890ac85c7dd1ec$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("cz4Eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $925c5bbd51df3a5b$export$2e2bcd8739ae039);
function $925c5bbd51df3a5b$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("744NN", function(module, exports) {
$parcel$export(module.exports, "default", () => $524ca1bfaecb1b64$export$2e2bcd8739ae039);

var $3oU6P = parcelRequire("3oU6P");

var $C4vFj = parcelRequire("C4vFj");

var $eCIAW = parcelRequire("eCIAW");
function $524ca1bfaecb1b64$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3oU6P.default)((0, $C4vFj.default)(element)).left + (0, $eCIAW.default)(element).scrollLeft;
}

});
parcelRegister("C4vFj", function(module, exports) {
$parcel$export(module.exports, "default", () => $07270c43583a58b1$export$2e2bcd8739ae039);

var $jeP6i = parcelRequire("jeP6i");
function $07270c43583a58b1$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jeP6i.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("hF1fp", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdb73bb7dcdeb9d4$export$2e2bcd8739ae039);

var $nIObY = parcelRequire("nIObY");
function $cdb73bb7dcdeb9d4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $nIObY.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("nIObY", function(module, exports) {
$parcel$export(module.exports, "default", () => $0474e8244fa18402$export$2e2bcd8739ae039);

var $h0YDy = parcelRequire("h0YDy");
function $0474e8244fa18402$export$2e2bcd8739ae039(element) {
    return (0, $h0YDy.default)(element).getComputedStyle(element);
}

});



parcelRegister("7nHLi", function(module, exports) {
$parcel$export(module.exports, "default", () => $55fca09841d2f9ab$export$2e2bcd8739ae039);

var $3oU6P = parcelRequire("3oU6P");
function $55fca09841d2f9ab$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $3oU6P.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("5bXkf", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c7bffab6bf61d23$export$2e2bcd8739ae039);

var $kDPAF = parcelRequire("kDPAF");

var $41w3X = parcelRequire("41w3X");

var $h0YDy = parcelRequire("h0YDy");

var $hF1fp = parcelRequire("hF1fp");
function $3c7bffab6bf61d23$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $kDPAF.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $h0YDy.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $hF1fp.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($3c7bffab6bf61d23$export$2e2bcd8739ae039((0, $41w3X.default)(target)));
}

});
parcelRegister("kDPAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $f06f77ecfb9c6758$export$2e2bcd8739ae039);

var $41w3X = parcelRequire("41w3X");

var $hF1fp = parcelRequire("hF1fp");

var $cz4Eb = parcelRequire("cz4Eb");

var $jeP6i = parcelRequire("jeP6i");
function $f06f77ecfb9c6758$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $cz4Eb.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jeP6i.isHTMLElement)(node) && (0, $hF1fp.default)(node)) return node;
    return $f06f77ecfb9c6758$export$2e2bcd8739ae039((0, $41w3X.default)(node));
}

});
parcelRegister("41w3X", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ee0206f6ec9e116$export$2e2bcd8739ae039);

var $cz4Eb = parcelRequire("cz4Eb");

var $C4vFj = parcelRequire("C4vFj");

var $jeP6i = parcelRequire("jeP6i");
function $2ee0206f6ec9e116$export$2e2bcd8739ae039(element) {
    if ((0, $cz4Eb.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jeP6i.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $C4vFj.default)(element) // fallback
    );
}

});



parcelRegister("hYGzR", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1691144d71462be$export$2e2bcd8739ae039);

var $h0YDy = parcelRequire("h0YDy");

var $cz4Eb = parcelRequire("cz4Eb");

var $nIObY = parcelRequire("nIObY");

var $jeP6i = parcelRequire("jeP6i");

var $d1RmW = parcelRequire("d1RmW");

var $41w3X = parcelRequire("41w3X");

var $9EhnE = parcelRequire("9EhnE");
function $d1691144d71462be$var$getTrueOffsetParent(element) {
    if (!(0, $jeP6i.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $nIObY.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $d1691144d71462be$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9EhnE.default)());
    var isIE = /Trident/i.test((0, $9EhnE.default)());
    if (isIE && (0, $jeP6i.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $nIObY.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $41w3X.default)(element);
    if ((0, $jeP6i.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jeP6i.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $cz4Eb.default)(currentNode)) < 0){
        var css = (0, $nIObY.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $d1691144d71462be$export$2e2bcd8739ae039(element) {
    var window = (0, $h0YDy.default)(element);
    var offsetParent = $d1691144d71462be$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d1RmW.default)(offsetParent) && (0, $nIObY.default)(offsetParent).position === 'static')offsetParent = $d1691144d71462be$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $cz4Eb.default)(offsetParent) === 'html' || (0, $cz4Eb.default)(offsetParent) === 'body' && (0, $nIObY.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $d1691144d71462be$var$getContainingBlock(element) || window;
}

});
parcelRegister("d1RmW", function(module, exports) {
$parcel$export(module.exports, "default", () => $97c4c455826f98a1$export$2e2bcd8739ae039);

var $cz4Eb = parcelRequire("cz4Eb");
function $97c4c455826f98a1$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $cz4Eb.default)(element)) >= 0;
}

});


parcelRegister("cI48b", function(module, exports) {
$parcel$export(module.exports, "default", () => $940ccc6d793eea50$export$2e2bcd8739ae039);

var $f4N5i = parcelRequire("f4N5i");
function $940ccc6d793eea50$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $940ccc6d793eea50$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $940ccc6d793eea50$var$order(modifiers); // order based on phase
    return (0, $f4N5i.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("f4N5i", function(module, exports) {
$parcel$export(module.exports, "top", () => $af9d4de35f68280f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $af9d4de35f68280f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $af9d4de35f68280f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $af9d4de35f68280f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $af9d4de35f68280f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $af9d4de35f68280f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $af9d4de35f68280f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $af9d4de35f68280f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $af9d4de35f68280f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $af9d4de35f68280f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $af9d4de35f68280f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $af9d4de35f68280f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $af9d4de35f68280f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $af9d4de35f68280f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $af9d4de35f68280f$export$d087d3878fdf71d5);
var $af9d4de35f68280f$export$1e95b668f3b82d = 'top';
var $af9d4de35f68280f$export$40e543e69a8b3fbb = 'bottom';
var $af9d4de35f68280f$export$79ffe56a765070d2 = 'right';
var $af9d4de35f68280f$export$eabcd2c8791e7bf4 = 'left';
var $af9d4de35f68280f$export$dfb5619354ba860 = 'auto';
var $af9d4de35f68280f$export$aec2ce47c367b8c3 = [
    $af9d4de35f68280f$export$1e95b668f3b82d,
    $af9d4de35f68280f$export$40e543e69a8b3fbb,
    $af9d4de35f68280f$export$79ffe56a765070d2,
    $af9d4de35f68280f$export$eabcd2c8791e7bf4
];
var $af9d4de35f68280f$export$b3571188c770cc5a = 'start';
var $af9d4de35f68280f$export$bd5df0f255a350f8 = 'end';
var $af9d4de35f68280f$export$390fd549c5303b4d = 'clippingParents';
var $af9d4de35f68280f$export$d7b7311ec04a3e8f = 'viewport';
var $af9d4de35f68280f$export$ae5ab1c730825774 = 'popper';
var $af9d4de35f68280f$export$ca50aac9f3ba507f = 'reference';
var $af9d4de35f68280f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $af9d4de35f68280f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $af9d4de35f68280f$export$b3571188c770cc5a,
        placement + "-" + $af9d4de35f68280f$export$bd5df0f255a350f8
    ]);
}, []);
var $af9d4de35f68280f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($af9d4de35f68280f$export$aec2ce47c367b8c3, [
    $af9d4de35f68280f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $af9d4de35f68280f$export$b3571188c770cc5a,
        placement + "-" + $af9d4de35f68280f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $af9d4de35f68280f$export$421679a7c3d56e = 'beforeRead';
var $af9d4de35f68280f$export$aafa59e2e03f2942 = 'read';
var $af9d4de35f68280f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $af9d4de35f68280f$export$c65e99957a05207c = 'beforeMain';
var $af9d4de35f68280f$export$f22da7240b7add18 = 'main';
var $af9d4de35f68280f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $af9d4de35f68280f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $af9d4de35f68280f$export$68d8715fc104d294 = 'write';
var $af9d4de35f68280f$export$70a6e5159acce2e6 = 'afterWrite';
var $af9d4de35f68280f$export$d087d3878fdf71d5 = [
    $af9d4de35f68280f$export$421679a7c3d56e,
    $af9d4de35f68280f$export$aafa59e2e03f2942,
    $af9d4de35f68280f$export$6964f6c886723980,
    $af9d4de35f68280f$export$c65e99957a05207c,
    $af9d4de35f68280f$export$f22da7240b7add18,
    $af9d4de35f68280f$export$bab79516f2d662fe,
    $af9d4de35f68280f$export$8d4d2d70e7d46032,
    $af9d4de35f68280f$export$68d8715fc104d294,
    $af9d4de35f68280f$export$70a6e5159acce2e6
];

});


parcelRegister("3uRvf", function(module, exports) {
$parcel$export(module.exports, "default", () => $28bdad06d54dc0d0$export$2e2bcd8739ae039);
function $28bdad06d54dc0d0$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("6WBom", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e52a1ac2f8d162$export$2e2bcd8739ae039);
function $50e52a1ac2f8d162$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("34TWH", function(module, exports) {
$parcel$export(module.exports, "default", () => $23dd247e19d7b357$export$2e2bcd8739ae039);

var $h0YDy = parcelRequire("h0YDy");
var $23dd247e19d7b357$var$passive = {
    passive: true
};
function $23dd247e19d7b357$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $h0YDy.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $23dd247e19d7b357$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $23dd247e19d7b357$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $23dd247e19d7b357$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $23dd247e19d7b357$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $23dd247e19d7b357$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $23dd247e19d7b357$var$effect,
    data: {}
};

});

parcelRegister("em07b", function(module, exports) {
$parcel$export(module.exports, "default", () => $a73335952d521a15$export$2e2bcd8739ae039);

var $1LQjq = parcelRequire("1LQjq");
function $a73335952d521a15$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $1LQjq.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $a73335952d521a15$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $a73335952d521a15$var$popperOffsets,
    data: {}
};

});
parcelRegister("1LQjq", function(module, exports) {
$parcel$export(module.exports, "default", () => $14a2c25db80175a4$export$2e2bcd8739ae039);

var $ihuQl = parcelRequire("ihuQl");

var $29fQF = parcelRequire("29fQF");

var $52ykO = parcelRequire("52ykO");

var $f4N5i = parcelRequire("f4N5i");
function $14a2c25db80175a4$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $ihuQl.default)(placement) : null;
    var variation = placement ? (0, $29fQF.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f4N5i.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f4N5i.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f4N5i.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f4N5i.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $52ykO.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f4N5i.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f4N5i.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("ihuQl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4f1bd5de9a77f31$export$2e2bcd8739ae039);

function $d4f1bd5de9a77f31$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("29fQF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1908b73585fe0093$export$2e2bcd8739ae039);
function $1908b73585fe0093$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("52ykO", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ab7c5cb8a295aed$export$2e2bcd8739ae039);
function $3ab7c5cb8a295aed$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("iJOZP", function(module, exports) {
$parcel$export(module.exports, "default", () => $da43fcc00d223b10$export$2e2bcd8739ae039);

var $f4N5i = parcelRequire("f4N5i");

var $hYGzR = parcelRequire("hYGzR");

var $h0YDy = parcelRequire("h0YDy");

var $C4vFj = parcelRequire("C4vFj");

var $nIObY = parcelRequire("nIObY");

var $ihuQl = parcelRequire("ihuQl");

var $29fQF = parcelRequire("29fQF");

var $fxWJm = parcelRequire("fxWJm");
var $da43fcc00d223b10$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $da43fcc00d223b10$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $fxWJm.round)(x * dpr) / dpr || 0,
        y: (0, $fxWJm.round)(y * dpr) / dpr || 0
    };
}
function $da43fcc00d223b10$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f4N5i.left);
    var sideY = (0, $f4N5i.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $hYGzR.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $h0YDy.default)(popper)) {
            offsetParent = (0, $C4vFj.default)(popper);
            if ((0, $nIObY.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f4N5i.top) || (placement === (0, $f4N5i.left) || placement === (0, $f4N5i.right)) && variation === (0, $f4N5i.end)) {
            sideY = (0, $f4N5i.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f4N5i.left) || (placement === (0, $f4N5i.top) || placement === (0, $f4N5i.bottom)) && variation === (0, $f4N5i.end)) {
            sideX = (0, $f4N5i.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $da43fcc00d223b10$var$unsetSides);
    var _ref4 = roundOffsets === true ? $da43fcc00d223b10$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $h0YDy.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $da43fcc00d223b10$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $ihuQl.default)(state.placement),
        variation: (0, $29fQF.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $da43fcc00d223b10$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $da43fcc00d223b10$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $da43fcc00d223b10$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $da43fcc00d223b10$var$computeStyles,
    data: {}
};

});

parcelRegister("fmJKq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2fc65ac6cef2a90$export$2e2bcd8739ae039);

var $cz4Eb = parcelRequire("cz4Eb");

var $jeP6i = parcelRequire("jeP6i");
// and applies them to the HTMLElements such as popper and arrow
function $b2fc65ac6cef2a90$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jeP6i.isHTMLElement)(element) || !(0, $cz4Eb.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $b2fc65ac6cef2a90$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jeP6i.isHTMLElement)(element) || !(0, $cz4Eb.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $b2fc65ac6cef2a90$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $b2fc65ac6cef2a90$var$applyStyles,
    effect: $b2fc65ac6cef2a90$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("8pZHs", function(module, exports) {
$parcel$export(module.exports, "default", () => $621084d5d837507b$export$2e2bcd8739ae039);

var $ihuQl = parcelRequire("ihuQl");

var $f4N5i = parcelRequire("f4N5i");
function $621084d5d837507b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $ihuQl.default)(placement);
    var invertDistance = [
        (0, $f4N5i.left),
        (0, $f4N5i.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f4N5i.left),
        (0, $f4N5i.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $621084d5d837507b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f4N5i.placements).reduce(function(acc, placement) {
        acc[placement] = $621084d5d837507b$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $621084d5d837507b$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $621084d5d837507b$var$offset
};

});

parcelRegister("8RIXG", function(module, exports) {
$parcel$export(module.exports, "default", () => $674626641ed68228$export$2e2bcd8739ae039);

var $avNKL = parcelRequire("avNKL");

var $ihuQl = parcelRequire("ihuQl");

var $8ph5Y = parcelRequire("8ph5Y");

var $ieE68 = parcelRequire("ieE68");

var $3NcOm = parcelRequire("3NcOm");

var $f4N5i = parcelRequire("f4N5i");

var $29fQF = parcelRequire("29fQF");
function $674626641ed68228$var$getExpandedFallbackPlacements(placement) {
    if ((0, $ihuQl.default)(placement) === (0, $f4N5i.auto)) return [];
    var oppositePlacement = (0, $avNKL.default)(placement);
    return [
        (0, $8ph5Y.default)(placement),
        oppositePlacement,
        (0, $8ph5Y.default)(oppositePlacement)
    ];
}
function $674626641ed68228$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $ihuQl.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $avNKL.default)(preferredPlacement)
    ] : $674626641ed68228$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $ihuQl.default)(placement) === (0, $f4N5i.auto) ? (0, $3NcOm.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $ihuQl.default)(placement);
        var isStartVariation = (0, $29fQF.default)(placement) === (0, $f4N5i.start);
        var isVertical = [
            (0, $f4N5i.top),
            (0, $f4N5i.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $ieE68.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f4N5i.right) : (0, $f4N5i.left) : isStartVariation ? (0, $f4N5i.bottom) : (0, $f4N5i.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $avNKL.default)(mainVariationSide);
        var altVariationSide = (0, $avNKL.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $674626641ed68228$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $674626641ed68228$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("avNKL", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a73649a5bd9a6b9$export$2e2bcd8739ae039);
var $7a73649a5bd9a6b9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7a73649a5bd9a6b9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7a73649a5bd9a6b9$var$hash[matched];
    });
}

});

parcelRegister("8ph5Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $61edeb4b4fc97b47$export$2e2bcd8739ae039);
var $61edeb4b4fc97b47$var$hash = {
    start: 'end',
    end: 'start'
};
function $61edeb4b4fc97b47$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $61edeb4b4fc97b47$var$hash[matched];
    });
}

});

parcelRegister("ieE68", function(module, exports) {
$parcel$export(module.exports, "default", () => $d468a36c168dcb6d$export$2e2bcd8739ae039);

var $iB1B5 = parcelRequire("iB1B5");

var $C4vFj = parcelRequire("C4vFj");

var $3oU6P = parcelRequire("3oU6P");

var $1LQjq = parcelRequire("1LQjq");

var $gLU9b = parcelRequire("gLU9b");

var $f4N5i = parcelRequire("f4N5i");

var $jeP6i = parcelRequire("jeP6i");

var $9kucs = parcelRequire("9kucs");

var $byzIk = parcelRequire("byzIk");
function $d468a36c168dcb6d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f4N5i.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f4N5i.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f4N5i.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $9kucs.default)(typeof padding !== 'number' ? padding : (0, $byzIk.default)(padding, (0, $f4N5i.basePlacements)));
    var altContext = elementContext === (0, $f4N5i.popper) ? (0, $f4N5i.reference) : (0, $f4N5i.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $iB1B5.default)((0, $jeP6i.isElement)(element) ? element : element.contextElement || (0, $C4vFj.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $3oU6P.default)(state.elements.reference);
    var popperOffsets = (0, $1LQjq.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $gLU9b.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f4N5i.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f4N5i.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f4N5i.right),
                (0, $f4N5i.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f4N5i.top),
                (0, $f4N5i.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("iB1B5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d89cebde1c1a90eb$export$2e2bcd8739ae039);

var $f4N5i = parcelRequire("f4N5i");

var $2zrpF = parcelRequire("2zrpF");

var $1q6LG = parcelRequire("1q6LG");

var $5bXkf = parcelRequire("5bXkf");

var $hYGzR = parcelRequire("hYGzR");

var $C4vFj = parcelRequire("C4vFj");

var $nIObY = parcelRequire("nIObY");

var $jeP6i = parcelRequire("jeP6i");

var $3oU6P = parcelRequire("3oU6P");

var $41w3X = parcelRequire("41w3X");

var $4QbxG = parcelRequire("4QbxG");

var $cz4Eb = parcelRequire("cz4Eb");

var $gLU9b = parcelRequire("gLU9b");

var $fxWJm = parcelRequire("fxWJm");
function $d89cebde1c1a90eb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $3oU6P.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d89cebde1c1a90eb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f4N5i.viewport) ? (0, $gLU9b.default)((0, $2zrpF.default)(element, strategy)) : (0, $jeP6i.isElement)(clippingParent) ? $d89cebde1c1a90eb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $gLU9b.default)((0, $1q6LG.default)((0, $C4vFj.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d89cebde1c1a90eb$var$getClippingParents(element) {
    var clippingParents = (0, $5bXkf.default)((0, $41w3X.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $nIObY.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jeP6i.isHTMLElement)(element) ? (0, $hYGzR.default)(element) : element;
    if (!(0, $jeP6i.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jeP6i.isElement)(clippingParent) && (0, $4QbxG.default)(clippingParent, clipperElement) && (0, $cz4Eb.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d89cebde1c1a90eb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $d89cebde1c1a90eb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d89cebde1c1a90eb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $fxWJm.max)(rect.top, accRect.top);
        accRect.right = (0, $fxWJm.min)(rect.right, accRect.right);
        accRect.bottom = (0, $fxWJm.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $fxWJm.max)(rect.left, accRect.left);
        return accRect;
    }, $d89cebde1c1a90eb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("2zrpF", function(module, exports) {
$parcel$export(module.exports, "default", () => $1df41d4bd2a504ab$export$2e2bcd8739ae039);

var $h0YDy = parcelRequire("h0YDy");

var $C4vFj = parcelRequire("C4vFj");

var $744NN = parcelRequire("744NN");

var $kAoni = parcelRequire("kAoni");
function $1df41d4bd2a504ab$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $h0YDy.default)(element);
    var html = (0, $C4vFj.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $kAoni.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $744NN.default)(element),
        y: y
    };
}

});

parcelRegister("1q6LG", function(module, exports) {
$parcel$export(module.exports, "default", () => $108d782d90ca1b03$export$2e2bcd8739ae039);

var $C4vFj = parcelRequire("C4vFj");

var $nIObY = parcelRequire("nIObY");

var $744NN = parcelRequire("744NN");

var $eCIAW = parcelRequire("eCIAW");

var $fxWJm = parcelRequire("fxWJm");
function $108d782d90ca1b03$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $C4vFj.default)(element);
    var winScroll = (0, $eCIAW.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $fxWJm.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $fxWJm.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $744NN.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $nIObY.default)(body || html).direction === 'rtl') x += (0, $fxWJm.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("4QbxG", function(module, exports) {
$parcel$export(module.exports, "default", () => $3864f8cf4ca151ae$export$2e2bcd8739ae039);

var $jeP6i = parcelRequire("jeP6i");
function $3864f8cf4ca151ae$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jeP6i.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("gLU9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $c35c96c2f8798a4f$export$2e2bcd8739ae039);
function $c35c96c2f8798a4f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("9kucs", function(module, exports) {
$parcel$export(module.exports, "default", () => $6cad685f307ba104$export$2e2bcd8739ae039);

var $jMBhN = parcelRequire("jMBhN");
function $6cad685f307ba104$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $jMBhN.default)(), paddingObject);
}

});
parcelRegister("jMBhN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e66f6c40fa30a168$export$2e2bcd8739ae039);
function $e66f6c40fa30a168$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("byzIk", function(module, exports) {
$parcel$export(module.exports, "default", () => $869e92bee4e3e907$export$2e2bcd8739ae039);
function $869e92bee4e3e907$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("3NcOm", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c2fe2ba85cb5d75$export$2e2bcd8739ae039);

var $29fQF = parcelRequire("29fQF");

var $f4N5i = parcelRequire("f4N5i");

var $ieE68 = parcelRequire("ieE68");

var $ihuQl = parcelRequire("ihuQl");
function $2c2fe2ba85cb5d75$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f4N5i.placements) : _options$allowedAutoP;
    var variation = (0, $29fQF.default)(placement);
    var placements = variation ? flipVariations ? (0, $f4N5i.variationPlacements) : (0, $f4N5i.variationPlacements).filter(function(placement) {
        return (0, $29fQF.default)(placement) === variation;
    }) : (0, $f4N5i.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ieE68.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $ihuQl.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("d64zN", function(module, exports) {
$parcel$export(module.exports, "default", () => $988f62a98609ad56$export$2e2bcd8739ae039);

var $f4N5i = parcelRequire("f4N5i");

var $ihuQl = parcelRequire("ihuQl");

var $52ykO = parcelRequire("52ykO");

var $1gID0 = parcelRequire("1gID0");

var $6k1oS = parcelRequire("6k1oS");

var $7nHLi = parcelRequire("7nHLi");

var $hYGzR = parcelRequire("hYGzR");

var $ieE68 = parcelRequire("ieE68");

var $29fQF = parcelRequire("29fQF");

var $jMBhN = parcelRequire("jMBhN");

var $fxWJm = parcelRequire("fxWJm");
function $988f62a98609ad56$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ieE68.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $ihuQl.default)(state.placement);
    var variation = (0, $29fQF.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $52ykO.default)(basePlacement);
    var altAxis = (0, $1gID0.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f4N5i.top) : (0, $f4N5i.left);
        var altSide = mainAxis === 'y' ? (0, $f4N5i.bottom) : (0, $f4N5i.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f4N5i.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f4N5i.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7nHLi.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $jMBhN.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $6k1oS.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $hYGzR.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $6k1oS.within)(tether ? (0, $fxWJm.min)(min, tetherMin) : min, offset, tether ? (0, $fxWJm.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f4N5i.top) : (0, $f4N5i.left);
        var _altSide = mainAxis === 'x' ? (0, $f4N5i.bottom) : (0, $f4N5i.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f4N5i.top),
            (0, $f4N5i.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $6k1oS.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $6k1oS.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $988f62a98609ad56$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $988f62a98609ad56$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("1gID0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ec9e74d70229e8a$export$2e2bcd8739ae039);
function $0ec9e74d70229e8a$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("6k1oS", function(module, exports) {
$parcel$export(module.exports, "within", () => $49a5b2653bd1e9a7$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $49a5b2653bd1e9a7$export$86c8af6d3ef0b4a);

var $fxWJm = parcelRequire("fxWJm");
function $49a5b2653bd1e9a7$export$f28d906d67a997f3(min, value, max) {
    return (0, $fxWJm.max)(min, (0, $fxWJm.min)(value, max));
}
function $49a5b2653bd1e9a7$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $49a5b2653bd1e9a7$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("eDu4Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa7c09e9c90d6e15$export$2e2bcd8739ae039);

var $ihuQl = parcelRequire("ihuQl");

var $7nHLi = parcelRequire("7nHLi");

var $4QbxG = parcelRequire("4QbxG");

var $hYGzR = parcelRequire("hYGzR");

var $52ykO = parcelRequire("52ykO");

var $6k1oS = parcelRequire("6k1oS");

var $9kucs = parcelRequire("9kucs");

var $byzIk = parcelRequire("byzIk");

var $f4N5i = parcelRequire("f4N5i");
var $aa7c09e9c90d6e15$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $9kucs.default)(typeof padding !== 'number' ? padding : (0, $byzIk.default)(padding, (0, $f4N5i.basePlacements)));
};
function $aa7c09e9c90d6e15$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $ihuQl.default)(state.placement);
    var axis = (0, $52ykO.default)(basePlacement);
    var isVertical = [
        (0, $f4N5i.left),
        (0, $f4N5i.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $aa7c09e9c90d6e15$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7nHLi.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $f4N5i.top) : (0, $f4N5i.left);
    var maxProp = axis === 'y' ? (0, $f4N5i.bottom) : (0, $f4N5i.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $hYGzR.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $6k1oS.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $aa7c09e9c90d6e15$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4QbxG.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $aa7c09e9c90d6e15$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $aa7c09e9c90d6e15$var$arrow,
    effect: $aa7c09e9c90d6e15$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("lt3Q3", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa0f48a64eb0278e$export$2e2bcd8739ae039);

var $f4N5i = parcelRequire("f4N5i");

var $ieE68 = parcelRequire("ieE68");
function $fa0f48a64eb0278e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $fa0f48a64eb0278e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f4N5i.top),
        (0, $f4N5i.right),
        (0, $f4N5i.bottom),
        (0, $f4N5i.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $fa0f48a64eb0278e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ieE68.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $ieE68.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $fa0f48a64eb0278e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $fa0f48a64eb0278e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $fa0f48a64eb0278e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $fa0f48a64eb0278e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $fa0f48a64eb0278e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $fa0f48a64eb0278e$var$hide
};

});


parcelRegister("eoKRC", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a7b7a8c50de03f3f$var$hasElementType = typeof Element !== 'undefined';
var $a7b7a8c50de03f3f$var$hasMap = typeof Map === 'function';
var $a7b7a8c50de03f3f$var$hasSet = typeof Set === 'function';
var $a7b7a8c50de03f3f$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a7b7a8c50de03f3f$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a7b7a8c50de03f3f$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a7b7a8c50de03f3f$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a7b7a8c50de03f3f$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a7b7a8c50de03f3f$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a7b7a8c50de03f3f$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a7b7a8c50de03f3f$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a7b7a8c50de03f3f$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $a7b7a8c50de03f3f$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("25rZF", function(module, exports) {
$parcel$export(module.exports, "getMaxSizeModifiers", () => $e5878d90bf1015bc$export$6d8c2b45c99d6e3f);
function $e5878d90bf1015bc$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                var _data$viewport, _data$viewport2, _state$modifiersData;
                const data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = ((_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("7biT4", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf7287a5c0ba32e0$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $499eN = parcelRequire("499eN");

var $hVvla = parcelRequire("hVvla");

var $4yN23 = parcelRequire("4yN23");

var $3YPqr = parcelRequire("3YPqr");
function $bf7287a5c0ba32e0$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect', isClosed: isClosed = false }) {
    const isSubsequentRender = (0, $4yN23.default)(mountStrategy);
    (0, $3YPqr.default)(zIndex);
    return !(0, $3H4LK.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $499eN.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hVvla.default), {
        zIndex: zIndex,
        isClosed: isClosed
    }, children);
}

});
parcelRegister("499eN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7ed66365d7d2a4b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $7N9xJ = parcelRequire("7N9xJ");
var $2gjoE = parcelRequire("2gjoE");

var $9nlzW = parcelRequire("9nlzW");

var $3H4LK = parcelRequire("3H4LK");

var $18bhn = parcelRequire("18bhn");

var $bDxI3 = parcelRequire("bDxI3");

var $5NLXn = parcelRequire("5NLXn");
function $e7ed66365d7d2a4b$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed = false } = props;
    const container = (0, $4fqPo.useMemo)(()=>(0, $bDxI3.createContainer)(zIndex), [
        zIndex
    ]);
    const colorMode = (0, $2gjoE.useColorMode)();
    const isInsideThemeProvider = (0, $9nlzW.useIsInsideThemeProvider)();
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $18bhn.appendPortalContainerIfNotAppended)(container);
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $3H4LK.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (isClosed) (0, $5NLXn.removePortalContainer)(container);
        }
    }, [
        isClosed,
        container
    ]);
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            (0, $5NLXn.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $b2Ka1.createPortal)(isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7N9xJ.default), {
        defaultColorMode: colorMode
    }, children) : children, container);
}

});
parcelRegister("7N9xJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f57e6bc63f04cae0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $77YkH = parcelRequire("77YkH");
var $6iapo = parcelRequire("6iapo");
var $awajr = parcelRequire("awajr");

var $82P09 = parcelRequire("82P09");

var $9yc6l = parcelRequire("9yc6l");

var $j3uIY = parcelRequire("j3uIY");

var $7cplC = parcelRequire("7cplC");

var $8T0Zi = parcelRequire("8T0Zi");

var $bmcdU = parcelRequire("bmcdU");

var $9nlzW = parcelRequire("9nlzW");

var $5WYma = parcelRequire("5WYma");
const $f57e6bc63f04cae0$var$defaultThemeSettings = {
    dark: 'dark',
    light: 'light',
    spacing: 'spacing',
    typography: 'typography'
};
const $f57e6bc63f04cae0$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
const $f57e6bc63f04cae0$var$prefersDarkModeMql = $f57e6bc63f04cae0$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $f57e6bc63f04cae0$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $f57e6bc63f04cae0$var$prefersDarkModeMql !== null && $f57e6bc63f04cae0$var$prefersDarkModeMql !== void 0 && $f57e6bc63f04cae0$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
const $f57e6bc63f04cae0$var$contentStyles = {
    body: "_1e0c1bgi"
};
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 */ function $f57e6bc63f04cae0$var$ThemeProvider({ children: children, defaultColorMode: defaultColorMode = 'auto', defaultTheme: defaultTheme }) {
    const [chosenColorMode, setChosenColorMode] = (0, $4fqPo.useState)(defaultColorMode);
    const [reconciledColorMode, setReconciledColorMode] = (0, $4fqPo.useState)($f57e6bc63f04cae0$var$getReconciledColorMode(defaultColorMode));
    const [theme, setTheme] = (0, $4fqPo.useState)(()=>({
            ...$f57e6bc63f04cae0$var$defaultThemeSettings,
            ...defaultTheme
        }));
    const setColorMode = (0, $4fqPo.useCallback)((colorMode)=>{
        setChosenColorMode(colorMode);
        setReconciledColorMode($f57e6bc63f04cae0$var$getReconciledColorMode(colorMode));
    }, []);
    const setPartialTheme = (0, $4fqPo.useCallback)((nextTheme)=>{
        setTheme((theme)=>({
                ...theme,
                ...nextTheme
            }));
    }, []);
    const lastSetGlobalThemePromiseRef = (0, $4fqPo.useRef)(null);
    const isInsideAppProvider = (0, $9yc6l.useIsInsideAppProvider)();
    const isAppProviderThemingEnabled = (0, $82P09.useIsAppProviderThemingEnabled)();
    const isInsideThemeProvider = (0, $9nlzW.useIsInsideThemeProvider)();
    /**
   * A top-level ThemeProvider is detected by being the first ThemeProvider inside an AppProvider.
   *
   * This will not use sub-tree theming but instead set the global theme state using the
   * `@atlaskit/tokens` APIs, as it's required for styling root `html` and `body` elements
   * for compatibility with `@atlaskit/css-reset`.
   *
   * In the future we could consider moving away from DOM mutations and require AppProvider to wrap
   * `html` in order to apply global theme state, which would allow a more consistent approach to
   * theme loading.
   */ const isRootThemeProvider = isInsideAppProvider && !isInsideThemeProvider && isAppProviderThemingEnabled;
    (0, $4fqPo.useEffect)(()=>{
        if (isRootThemeProvider) {
            /**
       * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
       * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
       * `data-color-mode` attribute on the root element).
       *
       * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
       * applying the new theme.
       *
       * Without this, we can end up in the following scenario:
       * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
       * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
       * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
       * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
       */ const cleanupLastFnCall = async ()=>{
                if (lastSetGlobalThemePromiseRef.current) {
                    const unbindFn = await lastSetGlobalThemePromiseRef.current;
                    unbindFn();
                    lastSetGlobalThemePromiseRef.current = null;
                }
            };
            const safelySetGlobalTheme = async ()=>{
                await cleanupLastFnCall();
                const promise = (0, $6iapo.default)({
                    ...theme,
                    colorMode: reconciledColorMode
                });
                lastSetGlobalThemePromiseRef.current = promise;
            };
            safelySetGlobalTheme();
            return function cleanup() {
                cleanupLastFnCall();
            };
        } else // For other theme providers (whether outside AppProvider or nested inside a ThemeProvider),
        // we treat them as sub-tree themes that do not load global theme state.
        (0, $5WYma.loadAndMountThemes)(theme);
    }, [
        isInsideAppProvider,
        isInsideThemeProvider,
        isRootThemeProvider,
        reconciledColorMode,
        theme
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!$f57e6bc63f04cae0$var$prefersDarkModeMql) return;
        const unbindListener = (0, $lMcEJ.bind)($f57e6bc63f04cae0$var$prefersDarkModeMql, {
            type: 'change',
            listener: (event)=>{
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    const attrs = {
        ...(0, $77YkH.default)({
            ...theme,
            colorMode: reconciledColorMode
        }),
        [(0, $awajr.SUBTREE_THEME_ATTRIBUTE)]: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7cplC.InsideThemeProviderContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j3uIY.ColorModeContext).Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8T0Zi.SetColorModeContext).Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bmcdU.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bmcdU.SetThemeContext).Provider, {
        value: setPartialTheme
    }, !isRootThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ...attrs,
        className: (0, $ltgDR.default)([
            $f57e6bc63f04cae0$var$contentStyles.body
        ])
    }, children) : children)))));
}
var $f57e6bc63f04cae0$export$2e2bcd8739ae039 = $f57e6bc63f04cae0$var$ThemeProvider;

});
parcelRegister("77YkH", function(module, exports) {
$parcel$export(module.exports, "default", () => $7df838ca065b1002$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $awajr = parcelRequire("awajr");

var $ddktr = parcelRequire("ddktr");

var $19LYE = parcelRequire("19LYE");

var $8H9o9 = parcelRequire("8H9o9");

var $ju2x3 = parcelRequire("ju2x3");
const $7df838ca065b1002$var$defaultColorMode = 'light';
const $7df838ca065b1002$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ const $7df838ca065b1002$var$getThemeHtmlAttrs = ({ colorMode: colorMode = (0, $ddktr.themeStateDefaults)['colorMode'], dark: dark = (0, $ddktr.themeStateDefaults)['dark'], light: light = (0, $ddktr.themeStateDefaults)['light'], contrastMode: contrastMode = (0, $ddktr.themeStateDefaults)['contrastMode'], motion: motion = (0, $ddktr.themeStateDefaults)['motion'](), shape: shape = (0, $ddktr.themeStateDefaults)['shape'](), spacing: spacing = (0, $ddktr.themeStateDefaults)['spacing'], typography: typography = (0, $ddktr.themeStateDefaults)['typography'], UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $ddktr.themeStateDefaults)['UNSAFE_themeOptions'] } = {})=>{
    const themeAttribute = (0, $19LYE.themeObjectToString)({
        dark: dark,
        light: light,
        motion: motion,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    let result = {
        [(0, $awajr.THEME_DATA_ATTRIBUTE)]: themeAttribute,
        [(0, $awajr.COLOR_MODE_ATTRIBUTE)]: colorMode === 'auto' ? $7df838ca065b1002$var$defaultColorMode : colorMode
    };
    if ((0, $3H4LK.fg)('platform_increased-contrast-themes')) result = {
        ...result,
        // CLEANUP: Move this to the initial `result` assignment above
        [(0, $awajr.CONTRAST_MODE_ATTRIBUTE)]: contrastMode === 'auto' ? $7df838ca065b1002$var$defaultContrastMode : contrastMode
    };
    if (UNSAFE_themeOptions && (0, $ju2x3.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        const optionString = JSON.stringify(UNSAFE_themeOptions);
        const uniqueId = (0, $8H9o9.hash)(optionString);
        result[0, $awajr.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $7df838ca065b1002$export$2e2bcd8739ae039 = $7df838ca065b1002$var$getThemeHtmlAttrs;

});
parcelRegister("ddktr", function(module, exports) {
$parcel$export(module.exports, "themeStateDefaults", () => $4d555df1228e20b1$export$9aedcfa7336a207);

var $3H4LK = parcelRequire("3H4LK");
function $4d555df1228e20b1$var$getShapeDefault() {
    if ((0, $3H4LK.fg)('platform-dst-shape-theme-default')) return 'shape';
    return undefined;
}
function $4d555df1228e20b1$var$getMotionDefault() {
    if ((0, $3H4LK.fg)('platform-dst-motion-theme-default')) return 'motion';
    return undefined;
}
const $4d555df1228e20b1$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: $4d555df1228e20b1$var$getShapeDefault,
    spacing: 'spacing',
    typography: 'typography',
    motion: $4d555df1228e20b1$var$getMotionDefault,
    UNSAFE_themeOptions: undefined
};

});

parcelRegister("19LYE", function(module, exports) {
$parcel$export(module.exports, "themeObjectToString", () => $19fc10e22b0cd44b$export$62c37ab81302621a);

var $h8Njt = parcelRequire("h8Njt");

var $iJQM6 = parcelRequire("iJQM6");

var $5Ra27 = parcelRequire("5Ra27");
const $19fc10e22b0cd44b$var$customThemeOptions = 'UNSAFE_themeOptions';
const $19fc10e22b0cd44b$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && (0, $h8Njt.isColorMode)(id) || // custom theme state
        kind === $19fc10e22b0cd44b$var$customThemeOptions && typeof id === 'object' || // other theme states
        (0, $5Ra27.isThemeKind)(kind) && typeof id === 'string' && (0, $iJQM6.isThemeIds)(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});
parcelRegister("h8Njt", function(module, exports) {
$parcel$export(module.exports, "isColorMode", () => $8c514c396a9305d6$export$4a14e169b1de4ee7);
const $8c514c396a9305d6$export$4a14e169b1de4ee7 = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};

});

parcelRegister("iJQM6", function(module, exports) {
$parcel$export(module.exports, "isThemeIds", () => $9ccc09fc798280f3$export$ea35b8958c39dd07);

var $4bwKd = parcelRequire("4bwKd");
const $9ccc09fc798280f3$export$ea35b8958c39dd07 = (themeId)=>{
    return (0, $4bwKd.themeIds).find((id)=>id === themeId) !== undefined;
};

});
parcelRegister("4bwKd", function(module, exports) {
$parcel$export(module.exports, "themeIds", () => $ca53f5ebcdcc2b89$export$7d43e72a58e3283f);
const $ca53f5ebcdcc2b89$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'spacing',
    'shape',
    'typography',
    'motion'
];

});


parcelRegister("5Ra27", function(module, exports) {
$parcel$export(module.exports, "isThemeKind", () => $15f246606fa851f6$export$958fa026be3a263e);
const $15f246606fa851f6$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape',
    'motion'
];
const $15f246606fa851f6$export$958fa026be3a263e = (themeKind)=>{
    return $15f246606fa851f6$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};

});


parcelRegister("8H9o9", function(module, exports) {
$parcel$export(module.exports, "hash", () => $da397fdd60566240$export$d6af199866bfb566);
const $da397fdd60566240$export$d6af199866bfb566 = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("ju2x3", function(module, exports) {
$parcel$export(module.exports, "isValidBrandHex", () => $52327892b8dc20f4$export$53031ac1ecb71f44);
const $52327892b8dc20f4$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);

});


parcelRegister("6iapo", function(module, exports) {
$parcel$export(module.exports, "default", () => $890d7f80e69f8cd9$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $kdx0d = parcelRequire("kdx0d");

var $ddktr = parcelRequire("ddktr");

var $bO9Wm = parcelRequire("bO9Wm");

var $gXN5c = parcelRequire("gXN5c");

var $6dibU = parcelRequire("6dibU");

var $eXiv5 = parcelRequire("eXiv5");

var $ju2x3 = parcelRequire("ju2x3");

var $eg5tg = parcelRequire("eg5tg");

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ const $890d7f80e69f8cd9$var$setGlobalTheme = async (nextThemeState = {}, themeLoader)=>{
    let { colorMode: colorMode = (0, $ddktr.themeStateDefaults)['colorMode'], contrastMode: contrastMode = (0, $ddktr.themeStateDefaults)['contrastMode'], dark: dark = (0, $ddktr.themeStateDefaults)['dark'], light: light = (0, $ddktr.themeStateDefaults)['light'], shape: shape = (0, $ddktr.themeStateDefaults)['shape'](), spacing: spacing = (0, $ddktr.themeStateDefaults)['spacing'], typography: typography = (0, $ddktr.themeStateDefaults)['typography'], motion: motion = (0, $ddktr.themeStateDefaults)['motion'](), UNSAFE_themeOptions: UNSAFE_themeOptions = (0, $ddktr.themeStateDefaults)['UNSAFE_themeOptions'] } = typeof nextThemeState === 'function' ? nextThemeState({
        ...(0, $ddktr.themeStateDefaults),
        typography: (0, $ddktr.themeStateDefaults)['typography'],
        shape: (0, $ddktr.themeStateDefaults)['shape'](),
        motion: (0, $ddktr.themeStateDefaults)['motion'](),
        ...(0, $kdx0d.default)()
    }) : nextThemeState;
    // CLEANUP: Remove. This blocks application of increased contrast themes
    // without the feature flag enabled.
    if (!(0, $3H4LK.fg)('platform_increased-contrast-themes')) {
        if (light === 'light-increased-contrast') light = 'light';
        if (dark === 'dark-increased-contrast') dark = 'dark';
    }
    const themeState = {
        colorMode: colorMode,
        contrastMode: contrastMode,
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography,
        motion: motion,
        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
    };
    // Determine what to load and loading strategy
    let themePreferences = (0, $eXiv5.getThemePreferences)(themeState);
    const loadingStrategy = themeLoader ? themeLoader : (0, $eg5tg.loadAndAppendThemeCss);
    // Load standard themes
    const loadingTasks = themePreferences.map(async (themeId)=>await loadingStrategy(themeId));
    // Load custom themes if needed
    if (!themeLoader && UNSAFE_themeOptions && (0, $ju2x3.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
        const mode = colorMode || (0, $ddktr.themeStateDefaults)['colorMode'];
        const attrOfMissingCustomStyles = (0, $gXN5c.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
        loadingTasks.push((async ()=>{
            const { loadAndAppendCustomThemeCss: loadAndAppendCustomThemeCss } = await (parcelRequire("iUTA2"));
            loadAndAppendCustomThemeCss({
                colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                attrOfMissingCustomStyles[0],
                UNSAFE_themeOptions: UNSAFE_themeOptions
            });
        })());
    }
    await Promise.all(loadingTasks);
    // Load override themes after standard themes
    const themeOverridePreferences = (0, $6dibU.getThemeOverridePreferences)(themeState);
    for (const themeId of themeOverridePreferences)await loadingStrategy(themeId);
    const autoUnbind = (0, $bO9Wm.default)(themeState);
    return autoUnbind;
};
var $890d7f80e69f8cd9$export$2e2bcd8739ae039 = $890d7f80e69f8cd9$var$setGlobalTheme;

});
parcelRegister("kdx0d", function(module, exports) {
$parcel$export(module.exports, "default", () => $ecd0bfe3a54074d2$export$2e2bcd8739ae039);

var $awajr = parcelRequire("awajr");

var $ggzUi = parcelRequire("ggzUi");

var $9uQPa = parcelRequire("9uQPa");
const $ecd0bfe3a54074d2$var$isThemeColorMode = (colorMode)=>{
    return (0, $ggzUi.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $ecd0bfe3a54074d2$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $awajr.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $awajr.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $9uQPa.themeStringToObject)(theme),
        ...$ecd0bfe3a54074d2$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $ecd0bfe3a54074d2$export$2e2bcd8739ae039 = $ecd0bfe3a54074d2$var$getGlobalTheme;

});
parcelRegister("ggzUi", function(module, exports) {
$parcel$export(module.exports, "themeColorModes", () => $5151890b21770038$export$83993de8eb66733);
/**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $5151890b21770038$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];

});

parcelRegister("9uQPa", function(module, exports) {
$parcel$export(module.exports, "themeStringToObject", () => $5a26f68bef2efd08$export$f19b488f7c0547ee);

var $h8Njt = parcelRequire("h8Njt");

var $iJQM6 = parcelRequire("iJQM6");

var $5Ra27 = parcelRequire("5Ra27");
const $5a26f68bef2efd08$var$customThemeOptions = 'UNSAFE_themeOptions';
const $5a26f68bef2efd08$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && (0, $h8Njt.isColorMode)(id)) themeObject[kind] = id;
        if ((0, $5Ra27.isThemeKind)(kind) && (0, $iJQM6.isThemeIds)(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $5a26f68bef2efd08$var$customThemeOptions) try {
            themeObject[$5a26f68bef2efd08$var$customThemeOptions] = JSON.parse(id);
        } catch  {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};

});


parcelRegister("bO9Wm", function(module, exports) {
$parcel$export(module.exports, "default", () => $204a7c94e9ed26ec$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $77YkH = parcelRequire("77YkH");

var $b3G9f = parcelRequire("b3G9f");

var $79Y46 = parcelRequire("79Y46");
function $204a7c94e9ed26ec$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $b3G9f.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $b3G9f.default).bind();
    } else (0, $b3G9f.default).unbind();
    if ((0, $3H4LK.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $79Y46.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $79Y46.default).bind();
        } else (0, $79Y46.default).unbind();
    }
    const themeAttributes = (0, $77YkH.default)(themeState);
    Object.entries(themeAttributes).forEach(([key, value])=>{
        document.documentElement.setAttribute(key, value);
    });
    return ()=>{
        (0, $b3G9f.default).unbind();
        if ((0, $3H4LK.fg)('platform_increased-contrast-themes')) (0, $79Y46.default).unbind();
    };
}

});
parcelRegister("b3G9f", function(module, exports) {
$parcel$export(module.exports, "default", () => $5680e29dbc4c98d2$export$2e2bcd8739ae039);

var $lMcEJ = parcelRequire("lMcEJ");

var $awajr = parcelRequire("awajr");

var $eg5tg = parcelRequire("eg5tg");
const $5680e29dbc4c98d2$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $5680e29dbc4c98d2$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $awajr.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
const $5680e29dbc4c98d2$var$darkModeMql = $5680e29dbc4c98d2$var$isMatchMediaAvailable && window.matchMedia((0, $eg5tg.darkModeMediaQuery));
class $5680e29dbc4c98d2$var$ColorModeObserver {
    getColorMode() {
        if (!$5680e29dbc4c98d2$var$darkModeMql) return 'light';
        return $5680e29dbc4c98d2$var$darkModeMql !== null && $5680e29dbc4c98d2$var$darkModeMql !== void 0 && $5680e29dbc4c98d2$var$darkModeMql.matches ? 'dark' : 'light';
    }
    bind() {
        if ($5680e29dbc4c98d2$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $lMcEJ.bind)($5680e29dbc4c98d2$var$darkModeMql, {
            type: 'change',
            listener: $5680e29dbc4c98d2$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindThemeChangeListener) {
            this.unbindThemeChangeListener();
            this.unbindThemeChangeListener = null;
        }
    }
    constructor(){
        this.unbindThemeChangeListener = null;
    }
}
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $5680e29dbc4c98d2$var$SingletonColorModeObserver = new $5680e29dbc4c98d2$var$ColorModeObserver();
var $5680e29dbc4c98d2$export$2e2bcd8739ae039 = $5680e29dbc4c98d2$var$SingletonColorModeObserver;

});
parcelRegister("eg5tg", function(module, exports) {
$parcel$export(module.exports, "loadAndAppendThemeCss", () => $9194af0217a0bfda$export$26cd7ae85c7144e5);
$parcel$export(module.exports, "darkModeMediaQuery", () => $9194af0217a0bfda$export$bb1e815119d30f8b);
$parcel$export(module.exports, "moreContrastMediaQuery", () => $9194af0217a0bfda$export$8662df6937d86fcb);

var $awajr = parcelRequire("awajr");

var $48UmD = parcelRequire("48UmD");
const $9194af0217a0bfda$export$26cd7ae85c7144e5 = async (themeId)=>{
    if (document.head.querySelector(`style[${(0, $awajr.THEME_DATA_ATTRIBUTE)}="${themeId}"]:not([${(0, $awajr.CUSTOM_THEME_ATTRIBUTE)}])`)) return;
    // Gracefully handles falsy values like `null` and `undefined` when maker ignore TS
    // to avoid loading default themes.
    if (!themeId) return;
    const themeCss = await (0, $48UmD.loadThemeCss)(themeId);
    const style = document.createElement('style');
    style.textContent = themeCss;
    style.dataset.theme = themeId;
    document.head.appendChild(style);
};
const $9194af0217a0bfda$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
const $9194af0217a0bfda$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("48UmD", function(module, exports) {
$parcel$export(module.exports, "loadThemeCss", () => $ec7144d8cba994a3$export$8a48286ed7df6720);

var $lOTlT = parcelRequire("lOTlT");
const $ec7144d8cba994a3$export$8a48286ed7df6720 = async (themeId)=>{
    const { default: themeCss } = await (0, $lOTlT.default)[themeId]();
    return themeCss;
};

});
parcelRegister("lOTlT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e83e2258ddbe1307$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::a20c72d683b08b594c5be4160eec5f78>>
 * @codegenCommand yarn build tokens
 */ 









const $e83e2258ddbe1307$var$themeImportsMap = {
    'light': ()=>(parcelRequire("QMFsO")),
    'light-future': ()=>(parcelRequire("j6a4t")),
    'light-increased-contrast': ()=>(parcelRequire("5vyha")),
    'dark': ()=>(parcelRequire("bQJXw")),
    'dark-future': ()=>(parcelRequire("fA33P")),
    'dark-increased-contrast': ()=>(parcelRequire("4JGKi")),
    'spacing': ()=>(parcelRequire("i5E3g")),
    'typography': ()=>(parcelRequire("dKbxS")),
    'shape': ()=>(parcelRequire("is1tk")),
    'motion': ()=>(parcelRequire("jgdvS"))
};
var $e83e2258ddbe1307$export$2e2bcd8739ae039 = $e83e2258ddbe1307$var$themeImportsMap;

});
parcelRegister("QMFsO", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("jvD1e").then(()=>parcelRequire('7atup'));

});

parcelRegister("j6a4t", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8rusH").then(()=>parcelRequire('70CQr'));

});

parcelRegister("5vyha", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("3vEyJ").then(()=>parcelRequire('1FilK'));

});

parcelRegister("bQJXw", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fZgIx").then(()=>parcelRequire('kaOgq'));

});

parcelRegister("fA33P", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("18YMf").then(()=>parcelRequire('8msqw'));

});

parcelRegister("4JGKi", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7td4W").then(()=>parcelRequire('lu6Ll'));

});

parcelRegister("i5E3g", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("hRUcX").then(()=>parcelRequire('14mxj'));

});

parcelRegister("dKbxS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fNBuH").then(()=>parcelRequire('aZ14p'));

});

parcelRegister("is1tk", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9Iq4V").then(()=>parcelRequire('9JztX'));

});

parcelRegister("jgdvS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gNqOS").then(()=>parcelRequire('huJQB'));

});





parcelRegister("79Y46", function(module, exports) {
$parcel$export(module.exports, "default", () => $23d248160cad8318$export$2e2bcd8739ae039);

var $lMcEJ = parcelRequire("lMcEJ");

var $awajr = parcelRequire("awajr");

var $eg5tg = parcelRequire("eg5tg");
const $23d248160cad8318$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $23d248160cad8318$var$checkNativeListener(e) {
    const element = document.documentElement;
    element.setAttribute((0, $awajr.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
const $23d248160cad8318$var$contrastModeMql = $23d248160cad8318$var$isMatchMediaAvailable && window.matchMedia((0, $eg5tg.moreContrastMediaQuery));
class $23d248160cad8318$var$ContrastModeObserver {
    getContrastMode() {
        if (!$23d248160cad8318$var$contrastModeMql) return 'no-preference';
        return $23d248160cad8318$var$contrastModeMql !== null && $23d248160cad8318$var$contrastModeMql !== void 0 && $23d248160cad8318$var$contrastModeMql.matches ? 'more' : 'no-preference';
    }
    bind() {
        if ($23d248160cad8318$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $lMcEJ.bind)($23d248160cad8318$var$contrastModeMql, {
            type: 'change',
            listener: $23d248160cad8318$var$checkNativeListener
        });
    }
    unbind() {
        if (this.unbindContrastChangeListener) {
            this.unbindContrastChangeListener();
            this.unbindContrastChangeListener = null;
        }
    }
    constructor(){
        this.unbindContrastChangeListener = null;
    }
}
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ const $23d248160cad8318$var$SingletonContrastModeObserver = new $23d248160cad8318$var$ContrastModeObserver();
var $23d248160cad8318$export$2e2bcd8739ae039 = $23d248160cad8318$var$SingletonContrastModeObserver;

});


parcelRegister("gXN5c", function(module, exports) {
$parcel$export(module.exports, "findMissingCustomStyleElements", () => $33342a598881dd4a$export$bd1ac9300b0e885a);

var $awajr = parcelRequire("awajr");

var $8H9o9 = parcelRequire("8H9o9");
function $33342a598881dd4a$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    const optionString = JSON.stringify(UNSAFE_themeOptions);
    const uniqueId = (0, $8H9o9.hash)(optionString);
    const attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach((themeId)=>{
        const element = document.head.querySelector(`style[${(0, $awajr.CUSTOM_THEME_ATTRIBUTE)}="${uniqueId}"][${(0, $awajr.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}

});

parcelRegister("6dibU", function(module, exports) {
$parcel$export(module.exports, "getThemeOverridePreferences", () => $a755414e7881b5ff$export$5d76d7014f4a5d08);
const $a755414e7881b5ff$export$5d76d7014f4a5d08 = (_themeState)=>{
    const themeOverridePreferences = [];
    return [
        ...new Set(themeOverridePreferences)
    ];
};

});

parcelRegister("eXiv5", function(module, exports) {
$parcel$export(module.exports, "getThemePreferences", () => $43d044ffa89504b1$export$dd6aeb7c823fc03d);

var $3H4LK = parcelRequire("3H4LK");

var $k6ThW = parcelRequire("k6ThW");

const $43d044ffa89504b1$export$dd6aeb7c823fc03d = (themeState)=>{
    const { colorMode: colorMode, contrastMode: contrastMode, dark: dark, light: light, shape: shape, spacing: spacing, typography: typography, motion: motion } = themeState;
    const autoColorModeThemes = [
        light,
        dark
    ];
    const themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $3H4LK.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach((normalTheme)=>{
            const increasedContrastTheme = (0, $k6ThW.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push(...autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $3H4LK.fg)('platform_increased-contrast-themes')) {
            const increasedContrastTheme = (0, $k6ThW.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography,
        motion
    ].forEach((themeId)=>{
        if (themeId) themePreferences.push(themeId);
    });
    return [
        ...new Set(themePreferences)
    ];
};

});
parcelRegister("k6ThW", function(module, exports) {
$parcel$export(module.exports, "default", () => $3434b499e5afd651$export$2e2bcd8739ae039);

var $4iNyp = parcelRequire("4iNyp");
function $3434b499e5afd651$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $4iNyp.default)).find(([, { increasesContrastFor: increasesContrastFor }])=>{
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});
parcelRegister("4iNyp", function(module, exports) {
$parcel$export(module.exports, "themeIdsWithOverrides", () => $ce6944d85aac0d30$export$92ba366331403db2);
$parcel$export(module.exports, "default", () => $ce6944d85aac0d30$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ 
var $4bwKd = parcelRequire("4bwKd");


var $ddktr = parcelRequire("ddktr");
/**
 * Contrast preferences: The system contrast preference
 */ const $ce6944d85aac0d30$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ const $ce6944d85aac0d30$var$themeOverrideIds = [];
const $ce6944d85aac0d30$export$92ba366331403db2 = [
    ...(0, $4bwKd.themeIds),
    ...$ce6944d85aac0d30$var$themeOverrideIds
];
const $ce6944d85aac0d30$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-motion': {
        id: 'motion',
        displayName: 'Motion',
        palette: 'motionPalette',
        attributes: {
            type: 'motion'
        }
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$ce6944d85aac0d30$export$2e2bcd8739ae039 = $ce6944d85aac0d30$var$themeConfig;

});



parcelRegister("iUTA2", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bZn8f").then(()=>parcelRequire('h7xQu'));

});


parcelRegister("82P09", function(module, exports) {
$parcel$export(module.exports, "useIsAppProviderThemingEnabled", () => $bc845f48a91174f6$export$a782702263f77544);

var $4fqPo = parcelRequire("4fqPo");

var $gt3rg = parcelRequire("gt3rg");
const $bc845f48a91174f6$export$a782702263f77544 = ()=>{
    return (0, $4fqPo.useContext)((0, $gt3rg.AppProviderThemingEnabledContext));
};

});
parcelRegister("gt3rg", function(module, exports) {
$parcel$export(module.exports, "AppProviderThemingEnabledContext", () => $960a1866843fd252$export$d2def9838ca456c0);

var $4fqPo = parcelRequire("4fqPo");
const $960a1866843fd252$export$d2def9838ca456c0 = /*#__PURE__*/ (0, $4fqPo.createContext)(false);

});


parcelRegister("9yc6l", function(module, exports) {
$parcel$export(module.exports, "useIsInsideAppProvider", () => $bfe1ffb2f3994561$export$26aa23367bfbab0e);

var $4fqPo = parcelRequire("4fqPo");

var $gIxDT = parcelRequire("gIxDT");
const $bfe1ffb2f3994561$export$26aa23367bfbab0e = ()=>{
    return (0, $4fqPo.useContext)((0, $gIxDT.InsideAppProviderContext));
};

});
parcelRegister("gIxDT", function(module, exports) {
$parcel$export(module.exports, "InsideAppProviderContext", () => $c1493562563122cc$export$7981b2444296e410);

var $4fqPo = parcelRequire("4fqPo");
const $c1493562563122cc$export$7981b2444296e410 = /*#__PURE__*/ (0, $4fqPo.createContext)(false);

});


parcelRegister("j3uIY", function(module, exports) {
$parcel$export(module.exports, "ColorModeContext", () => $4f3c3f702f7a6e27$export$49ddd74a6729fdb0);

var $4fqPo = parcelRequire("4fqPo");
const $4f3c3f702f7a6e27$export$49ddd74a6729fdb0 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});

parcelRegister("7cplC", function(module, exports) {
$parcel$export(module.exports, "InsideThemeProviderContext", () => $f1b420abed02394a$export$332347eeb335453c);

var $4fqPo = parcelRequire("4fqPo");
const $f1b420abed02394a$export$332347eeb335453c = /*#__PURE__*/ (0, $4fqPo.createContext)(false);

});

parcelRegister("8T0Zi", function(module, exports) {
$parcel$export(module.exports, "SetColorModeContext", () => $72c6fddc712c78c2$export$b06130bad0bbc70f);

var $4fqPo = parcelRequire("4fqPo");
const $72c6fddc712c78c2$export$b06130bad0bbc70f = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});

parcelRegister("bmcdU", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $650f201c9cfa3c87$export$2c657da244d00bd6);
$parcel$export(module.exports, "SetThemeContext", () => $650f201c9cfa3c87$export$f7a97b47760e2a13);

var $4fqPo = parcelRequire("4fqPo");
const $650f201c9cfa3c87$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);
const $650f201c9cfa3c87$export$f7a97b47760e2a13 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});

parcelRegister("9nlzW", function(module, exports) {
$parcel$export(module.exports, "useIsInsideThemeProvider", () => $5bb2398698fe3e0d$export$7ca11437599d653d);

var $4fqPo = parcelRequire("4fqPo");

var $7cplC = parcelRequire("7cplC");
const $5bb2398698fe3e0d$export$7ca11437599d653d = ()=>{
    return (0, $4fqPo.useContext)((0, $7cplC.InsideThemeProviderContext)) ?? false;
};

});

parcelRegister("5WYma", function(module, exports) {
$parcel$export(module.exports, "loadAndMountThemes", () => $e04fedd44f51b02b$export$7d4a7e812d176b24);

var $564zZ = parcelRequire("564zZ");

var $lOTlT = parcelRequire("lOTlT");

var $80M9d = parcelRequire("80M9d");
const $e04fedd44f51b02b$var$loadThemeCss = async (themeId)=>{
    // Prevent duplicate loading of themes
    if ((0, $80M9d.isThemeMounted)(themeId)) return;
    // Gracefully handles falsy values like `null` and `undefined` when makers ignore
    // TS to avoid loading default themes.
    if (!themeId) return;
    const { default: themeCss } = await (0, $lOTlT.default)[themeId]();
    return themeCss;
};
const $e04fedd44f51b02b$var$mountThemeCss = async (css, themeId)=>{
    // SSR-safe: Only mount on client side
    const doc = (0, $564zZ.getDocument)();
    if (!doc) return;
    const style = doc.createElement('style');
    style.textContent = css;
    style.dataset.theme = themeId;
    // Prevent duplicate mounting of themes.
    // It's possible the theme was already being loaded elsewhere.
    if ((0, $80M9d.isThemeMounted)(themeId)) return;
    doc.head.appendChild(style);
};
const $e04fedd44f51b02b$var$loadAndMountThemeCss = async (themeId)=>{
    const themeCss = await $e04fedd44f51b02b$var$loadThemeCss(themeId);
    if (!themeCss) return;
    $e04fedd44f51b02b$var$mountThemeCss(themeCss, themeId);
};
const $e04fedd44f51b02b$export$7d4a7e812d176b24 = async (theme)=>{
    const themesToLoad = Object.values(theme).filter((themeId)=>!!themeId);
    themesToLoad.forEach($e04fedd44f51b02b$var$loadAndMountThemeCss);
};

});
parcelRegister("80M9d", function(module, exports) {
$parcel$export(module.exports, "isThemeMounted", () => $c9da51c4b0178345$export$835a0dc855d02822);

var $564zZ = parcelRequire("564zZ");

var $awajr = parcelRequire("awajr");
function $c9da51c4b0178345$export$835a0dc855d02822(themeId) {
    const doc = (0, $564zZ.getDocument)();
    if (!doc) return false;
    return doc.head.querySelector(`style[${(0, $awajr.THEME_DATA_ATTRIBUTE)}="${themeId}"]`);
}

});



parcelRegister("2gjoE", function(module, exports) {
$parcel$export(module.exports, "useColorMode", () => $b2569d3b64fa1876$export$20f3076712c8dfa);

var $4fqPo = parcelRequire("4fqPo");

var $kdx0d = parcelRequire("kdx0d");
var $lfKTU = parcelRequire("lfKTU");

var $j3uIY = parcelRequire("j3uIY");
function $b2569d3b64fa1876$export$20f3076712c8dfa() {
    const value = (0, $4fqPo.useContext)((0, $j3uIY.ColorModeContext));
    // TODO: This will only return 'light' or 'dark' but never 'auto', which in some cases
    // may be desirable. We should consider returning both the reconciled color mode (e.g. 'light' or 'dark') and the selected color mode ("auto").
    const theme = (0, $kdx0d.default)();
    const [resolvedColorMode, setResolvedColorMode] = (0, $4fqPo.useState)((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
    (0, $4fqPo.useEffect)(()=>{
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        const observer = new (0, $lfKTU.default)((theme)=>{
            setResolvedColorMode((theme === null || theme === void 0 ? void 0 : theme.colorMode) || 'light');
        });
        observer.observe();
        return ()=>observer.disconnect();
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}

});
parcelRegister("lfKTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a84234491569bd8$export$2e2bcd8739ae039);

var $awajr = parcelRequire("awajr");

var $kdx0d = parcelRequire("kdx0d");
class $9a84234491569bd8$export$2e2bcd8739ae039 {
    static #_ = this.observer = null;
    static #_2 = this.callbacks = new Set();
    constructor(callback){
        this.legacyObserver = null;
        this.callback = callback;
        $9a84234491569bd8$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$9a84234491569bd8$export$2e2bcd8739ae039.observer) {
            $9a84234491569bd8$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $kdx0d.default)();
                $9a84234491569bd8$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $9a84234491569bd8$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $awajr.THEME_DATA_ATTRIBUTE),
                    (0, $awajr.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $9a84234491569bd8$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($9a84234491569bd8$export$2e2bcd8739ae039.callbacks.size === 0 && $9a84234491569bd8$export$2e2bcd8739ae039.observer) {
            $9a84234491569bd8$export$2e2bcd8739ae039.observer.disconnect();
            $9a84234491569bd8$export$2e2bcd8739ae039.observer = null;
        }
    }
}

});


parcelRegister("18bhn", function(module, exports) {
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $7a929c0366570018$export$c582005add11e141);

var $b30P4 = parcelRequire("b30P4");

var $FL2bE = parcelRequire("FL2bE");
const $7a929c0366570018$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $b30P4.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $b30P4.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $FL2bE.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $7a929c0366570018$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $7a929c0366570018$var$getPortalParent().appendChild(container);
};

});
parcelRegister("b30P4", function(module, exports) {
$parcel$export(module.exports, "portalParentClassName", () => $ebdd536353e7f294$export$e4c79eb95c23a0da);
$parcel$export(module.exports, "portalParentSelector", () => $ebdd536353e7f294$export$72f415121273627e);
$parcel$export(module.exports, "portalClassName", () => $ebdd536353e7f294$export$13f57c02915787b3);
const $ebdd536353e7f294$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $ebdd536353e7f294$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $ebdd536353e7f294$export$13f57c02915787b3 = 'atlaskit-portal';

});

parcelRegister("FL2bE", function(module, exports) {
$parcel$export(module.exports, "getBody", () => $ea29e00cf139ed6e$export$135b49d4bc2964c6);
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $ea29e00cf139ed6e$export$135b49d4bc2964c6 = ()=>{
    return document.body;
};

});


parcelRegister("bDxI3", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $ea440ae7a0918fa2$export$26ae5ca175b4ec5a);

var $b30P4 = parcelRequire("b30P4");
const $ea440ae7a0918fa2$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $b30P4.portalClassName);
    container.style.zIndex = `${zIndex}`;
    return container;
};

});

parcelRegister("5NLXn", function(module, exports) {
$parcel$export(module.exports, "removePortalContainer", () => $9c3f76ed05cb65c0$export$da99f98bf3fe55b3);

var $b30P4 = parcelRequire("b30P4");

var $FL2bE = parcelRequire("FL2bE");
const $9c3f76ed05cb65c0$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $b30P4.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        const parent = document.createElement('div');
        parent.className = (0, $b30P4.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = (0, $FL2bE.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $9c3f76ed05cb65c0$export$da99f98bf3fe55b3 = (container)=>{
    const parent = $9c3f76ed05cb65c0$var$getPortalParent();
    if (parent.contains(container)) parent.removeChild(container);
};

});


parcelRegister("hVvla", function(module, exports) {
$parcel$export(module.exports, "default", () => $9762523bcd06de57$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $7N9xJ = parcelRequire("7N9xJ");
var $2gjoE = parcelRequire("2gjoE");

var $9nlzW = parcelRequire("9nlzW");

var $3H4LK = parcelRequire("3H4LK");

var $cliX6 = parcelRequire("cliX6");

var $fGCX1 = parcelRequire("fGCX1");

var $jBs3o = parcelRequire("jBs3o");

var $9i0cw = parcelRequire("9i0cw");
function $9762523bcd06de57$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children, isClosed: isClosed } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $4fqPo.useState)(null);
    const colorMode = (0, $2gjoE.useColorMode)();
    const isInsideThemeProvider = (0, $9nlzW.useIsInsideThemeProvider)();
    (0, $cliX6.useIsomorphicLayoutEffect)(()=>{
        if ((0, $3H4LK.fg)('import_into_jsm_in_template_gallery_killswitch')) {
            if (!isClosed) {
                let tempPortalContainer = (0, $fGCX1.createAtlaskitPortal)(zIndex);
                setAtlaskitPortal(tempPortalContainer);
                const portalParent = (0, $jBs3o.createPortalParent)();
                if (!tempPortalContainer || !portalParent) return;
                portalParent.appendChild(tempPortalContainer);
                return ()=>{
                    if (portalParent) {
                        portalParent.removeChild(tempPortalContainer);
                        !portalParent.hasChildNodes() && (0, $9i0cw.removePortalParent)(portalParent);
                    }
                    setAtlaskitPortal(null);
                };
            }
        } else {
            const tempPortalContainer = (0, $fGCX1.createAtlaskitPortal)(zIndex);
            setAtlaskitPortal(tempPortalContainer);
            const portalParent = (0, $jBs3o.createPortalParent)();
            if (!tempPortalContainer || !portalParent) return;
            portalParent.appendChild(tempPortalContainer);
            return ()=>{
                if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
                setAtlaskitPortal(null);
            };
        }
    }, [
        zIndex,
        isClosed,
        (0, $3H4LK.fg)
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ const suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: null
    }, isInsideThemeProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7N9xJ.default), {
        defaultColorMode: colorMode
    }, children) : children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $b2Ka1.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("cliX6", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $bc25a5130f151fcf$export$700979bc83e7db82);

var $4fqPo = parcelRequire("4fqPo");
const $bc25a5130f151fcf$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $4fqPo.useLayoutEffect) : (0, $4fqPo.useEffect);

});

parcelRegister("fGCX1", function(module, exports) {
$parcel$export(module.exports, "createAtlaskitPortal", () => $d957f709aab43fc2$export$fef014d7cef9e543);

var $b30P4 = parcelRequire("b30P4");
const $d957f709aab43fc2$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $d957f709aab43fc2$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($d957f709aab43fc2$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $b30P4.portalClassName);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
    return;
};

});

parcelRegister("jBs3o", function(module, exports) {
$parcel$export(module.exports, "createPortalParent", () => $2ecb190f95b7a21a$export$95029ca7aca2989e);

var $b30P4 = parcelRequire("b30P4");

var $FL2bE = parcelRequire("FL2bE");
const $2ecb190f95b7a21a$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $2ecb190f95b7a21a$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($2ecb190f95b7a21a$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $b30P4.portalParentSelector));
        if (!parentElement) {
            var _getBody;
            const parent = document.createElement('div');
            parent.className = (0, $b30P4.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody = (0, $FL2bE.getBody)()) === null || _getBody === void 0 || _getBody.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
    return;
};

});

parcelRegister("9i0cw", function(module, exports) {
$parcel$export(module.exports, "removePortalParent", () => $08620eb3b17e7a65$export$7b20876b2769b301);

var $FL2bE = parcelRequire("FL2bE");
const $08620eb3b17e7a65$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $08620eb3b17e7a65$export$7b20876b2769b301 = (parentElement)=>{
    if ($08620eb3b17e7a65$var$isDocumentDefined()) {
        if (parentElement) {
            var _getBody;
            (_getBody = (0, $FL2bE.getBody)()) === null || _getBody === void 0 || _getBody.removeChild(parentElement);
        }
    }
};

});


parcelRegister("4yN23", function(module, exports) {
$parcel$export(module.exports, "default", () => $c85884a407d62001$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $cliX6 = parcelRequire("cliX6");
const $c85884a407d62001$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $4fqPo.useState)(false);
    const [useMountEffect] = (0, $4fqPo.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $cliX6.useIsomorphicLayoutEffect) : (0, $4fqPo.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $c85884a407d62001$export$2e2bcd8739ae039 = $c85884a407d62001$var$useIsSubsequentRender;

});

parcelRegister("3YPqr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5018e6b9078e301$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4YDWA = parcelRequire("4YDWA");

var $7jpT8 = parcelRequire("7jpT8");
const $a5018e6b9078e301$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $4fqPo.useEffect)(()=>{
        (0, $7jpT8.default)((0, $4YDWA.PORTAL_MOUNT_EVENT), zIndexNumber);
        return ()=>{
            (0, $7jpT8.default)((0, $4YDWA.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $a5018e6b9078e301$export$2e2bcd8739ae039 = $a5018e6b9078e301$var$useFirePortalEvent;

});
parcelRegister("4YDWA", function(module, exports) {
$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", () => $b623b87c8c301a8b$export$ed5835cc67e87f72);
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", () => $b623b87c8c301a8b$export$80816bd900e5bd00);
const $b623b87c8c301a8b$export$ed5835cc67e87f72 = 'akPortalMount';
const $b623b87c8c301a8b$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("7jpT8", function(module, exports) {
$parcel$export(module.exports, "default", () => $d345ab011312caf4$export$2e2bcd8739ae039);
const $d345ab011312caf4$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $d345ab011312caf4$var$getLayerName = (zIndex)=>{
    return $d345ab011312caf4$var$zIndexToName.hasOwnProperty(zIndex) ? $d345ab011312caf4$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $d345ab011312caf4$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $d345ab011312caf4$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $d345ab011312caf4$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $d345ab011312caf4$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("2vWb1", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $hDp3n = parcelRequire("hDp3n");
module.exports = Object.assign({}, $hDp3n, {
    gridSize: ()=>8,
    borderRadius: ()=>3,
    fontSize: ()=>14,
    fontSizeSmall: ()=>11
});
if ($hDp3n.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("hDp3n", function(module, exports) {
$parcel$export(module.exports, "CHANNEL", () => $44f07be3fd3f880e$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $44f07be3fd3f880e$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $44f07be3fd3f880e$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "focusRing", () => $44f07be3fd3f880e$export$8e24544ddba725ee);
$parcel$export(module.exports, "noFocusRing", () => $44f07be3fd3f880e$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $44f07be3fd3f880e$export$7be255094ccdc533);
$parcel$export(module.exports, "visuallyHidden", () => $44f07be3fd3f880e$export$a1b3edb637fb4f35);
$parcel$export(module.exports, "assistive", () => $44f07be3fd3f880e$export$ba1d834b86d72a09);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $kSCQH = parcelRequire("kSCQH");
const $44f07be3fd3f880e$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $44f07be3fd3f880e$export$c93026a968943f95 = 'light';
const $44f07be3fd3f880e$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $44f07be3fd3f880e$export$8e24544ddba725ee = (color = "var(--ds-border-focused, #4688EC)", outlineWidth = 2)=>{
    (0, $kSCQH.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $44f07be3fd3f880e$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $44f07be3fd3f880e$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $44f07be3fd3f880e$export$a1b3edb637fb4f35 = ()=>{
    (0, $kSCQH.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $44f07be3fd3f880e$export$ba1d834b86d72a09 = $44f07be3fd3f880e$export$a1b3edb637fb4f35;

});
parcelRegister("kSCQH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb176f4fe84f068$export$2e2bcd8739ae039);

var $kMpvw = parcelRequire("kMpvw");
function $bfb176f4fe84f068$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $kMpvw.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}

});
parcelRegister("kMpvw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e2a090a79d8f9e7$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $9e2a090a79d8f9e7$var$printed = {};
function $9e2a090a79d8f9e7$export$2e2bcd8739ae039(message) {
    if ($9e2a090a79d8f9e7$var$printed[message]) return;
    $9e2a090a79d8f9e7$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});




parcelRegister("R17QT", function(module, exports) {
$parcel$export(module.exports, "popupMotion", () => $e24b1b657d24d311$export$da1762badbfc80a0);
$parcel$export(module.exports, "slideAndFade", () => $e24b1b657d24d311$export$635cc6747ac6ffe0);
$parcel$export(module.exports, "fade", () => $e24b1b657d24d311$export$cbea29d068a2e18f);
$parcel$export(module.exports, "dialogMotion", () => $e24b1b657d24d311$export$cbf542c04ce9dc36);

var $cDI63 = parcelRequire("cDI63");
// ══════════════════════════════════════════════════════════════════════════════
// Popover presets
// ══════════════════════════════════════════════════════════════════════════════
// ── popupMotion ──
const $e24b1b657d24d311$var$POPUP_MOTION_CSS = `
  [data-ds-popover-popup-motion] {
    animation: var(--ds-popover-motion-exit);
    animation-fill-mode: forwards;
    transition:
      overlay 150ms allow-discrete,
      display 150ms allow-discrete;
  }

  [data-ds-popover-popup-motion]:popover-open {
    animation: var(--ds-popover-motion-enter);
    animation-fill-mode: backwards;
  }

  @media (prefers-reduced-motion: reduce) {
    [data-ds-popover-popup-motion],
    [data-ds-popover-popup-motion]:popover-open {
      animation: none;
      transition-duration: 0s;
    }
  }
`;
function $e24b1b657d24d311$var$getPopupMotionProperties({ placement: placement }) {
    const { axis: axis, edge: edge } = (0, $cDI63.getPlacement)({
        placement: placement
    });
    if (axis === 'block' && edge === 'start') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    if (axis === 'inline' && edge === 'start') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    if (axis === 'inline' && edge === 'end') return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
    // Default: block/end (popover below trigger)
    return {
        '--ds-popover-motion-enter': "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        '--ds-popover-motion-exit': "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    };
}
function $e24b1b657d24d311$export$da1762badbfc80a0() {
    return {
        name: 'popup-motion',
        css: $e24b1b657d24d311$var$POPUP_MOTION_CSS,
        enterDurationMs: 150,
        exitDurationMs: 100,
        getProperties: ({ placement: placement })=>$e24b1b657d24d311$var$getPopupMotionProperties({
                placement: placement
            })
    };
}
function $e24b1b657d24d311$var$getSlideAndFadeProperties({ placement: placement, distance: distance }) {
    const pos = `${distance}px`;
    const neg = `-${distance}px`;
    const { axis: axis, edge: edge } = (0, $cDI63.getPlacement)({
        placement: placement
    });
    if (axis === 'block' && edge === 'start') return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': pos
    };
    if (axis === 'block' && edge === 'end') return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': neg
    };
    if (axis === 'inline' && edge === 'start') return {
        '--ds-popover-tx': pos,
        '--ds-popover-ty': '0'
    };
    if (axis === 'inline' && edge === 'end') return {
        '--ds-popover-tx': neg,
        '--ds-popover-ty': '0'
    };
    return {
        '--ds-popover-tx': '0',
        '--ds-popover-ty': neg
    };
}
// ℹ️ Note: The `transform` x value is flipped in right-to-left mode using the `[dir='rtl']` selector.
const $e24b1b657d24d311$var$SLIDE_AND_FADE_CSS = `
[data-ds-popover-slide-and-fade] {
  opacity: 0;
  transform: translate(var(--ds-popover-tx, 0), var(--ds-popover-ty, 0));
  transition:
    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),
    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[dir='rtl'] [data-ds-popover-slide-and-fade] {
  transform: translate(calc(-1 * var(--ds-popover-tx, 0)), var(--ds-popover-ty, 0));
}

[data-ds-popover-slide-and-fade]:popover-open {
  opacity: 1;
  transform: none;
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-popover-slide-and-fade]:popover-open {
    opacity: 0;
    transform: translate(var(--ds-popover-tx, 0), var(--ds-popover-ty, 0));
  }
}

@starting-style {
  [dir='rtl'] [data-ds-popover-slide-and-fade]:popover-open {
    transform: translate(calc(-1 * var(--ds-popover-tx, 0)), var(--ds-popover-ty, 0));
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-ds-popover-slide-and-fade],
  [data-ds-popover-slide-and-fade]:popover-open {
    transition-duration: 0s;
  }
}
`;
function $e24b1b657d24d311$export$635cc6747ac6ffe0(options) {
    const distance = (options === null || options === void 0 ? void 0 : options.distance) ?? 4;
    return {
        name: 'slide-and-fade',
        css: $e24b1b657d24d311$var$SLIDE_AND_FADE_CSS,
        getProperties: ({ placement: placement })=>$e24b1b657d24d311$var$getSlideAndFadeProperties({
                placement: placement,
                distance: distance
            }),
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// fade
const $e24b1b657d24d311$var$FADE_CSS = `
[data-ds-popover-fade] {
  opacity: 0;
  transition:
    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[data-ds-popover-fade]:popover-open {
  opacity: 1;
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-popover-fade]:popover-open {
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-ds-popover-fade],
  [data-ds-popover-fade]:popover-open {
    transition-duration: 0s;
  }
}
`;
function $e24b1b657d24d311$export$cbea29d068a2e18f() {
    return {
        name: 'fade',
        css: $e24b1b657d24d311$var$FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// scaleAndFade
const $e24b1b657d24d311$var$SCALE_AND_FADE_CSS = `
[data-ds-popover-scale-and-fade] {
  opacity: 0;
  transform: scale(0.95);
  transition:
    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),
    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[data-ds-popover-scale-and-fade]:popover-open {
  opacity: 1;
  transform: none;
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-popover-scale-and-fade]:popover-open {
    opacity: 0;
    transform: scale(0.95);
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-ds-popover-scale-and-fade],
  [data-ds-popover-scale-and-fade]:popover-open {
    transition-duration: 0s;
  }
}
`;
function $e24b1b657d24d311$export$d506ab6b7532b83c() {
    return {
        name: 'scale-and-fade',
        css: $e24b1b657d24d311$var$SCALE_AND_FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// ══════════════════════════════════════════════════════════════════════════════
// Dialog presets
// ══════════════════════════════════════════════════════════════════════════════
// ── dialogMotion ──
const $e24b1b657d24d311$var$DIALOG_MOTION_CSS = `
  [data-ds-dialog-motion] {
    animation: ${"var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)"};
    animation-fill-mode: forwards;
    transition:
      overlay 200ms allow-discrete,
      display 200ms allow-discrete;
  }

  [data-ds-dialog-motion][open] {
    animation: ${"var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)"};
    animation-fill-mode: backwards;
  }

  [data-ds-dialog-motion]::backdrop {
    animation: ${"var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"};
    animation-fill-mode: forwards;
    background-color: var(--ds-blanket, #050C1F75);
    transition:
      overlay 200ms allow-discrete,
      display 200ms allow-discrete;
  }

  [data-ds-dialog-motion][open]::backdrop {
    animation: ${"var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)"};
    animation-fill-mode: backwards;
  }

  @media (prefers-reduced-motion: reduce) {
    [data-ds-dialog-motion],
    [data-ds-dialog-motion][open],
    [data-ds-dialog-motion]::backdrop,
    [data-ds-dialog-motion][open]::backdrop {
      animation: none;
      transition-duration: 0s;
    }
  }
`;
function $e24b1b657d24d311$export$cbf542c04ce9dc36() {
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: 'motion',
        css: $e24b1b657d24d311$var$DIALOG_MOTION_CSS,
        enterDurationMs: 250,
        exitDurationMs: 200
    };
}
const $e24b1b657d24d311$var$DIALOG_SLIDE_UP_AND_FADE_CSS = `
[data-ds-dialog-slide-up-and-fade] {
  opacity: 0;
  transform: translateY(calc(-1 * var(--ds-dialog-ty, 12px)));
  transition:
    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),
    transform 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[data-ds-dialog-slide-up-and-fade][open] {
  opacity: 1;
  transform: none;
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-dialog-slide-up-and-fade][open] {
    opacity: 0;
    transform: translateY(var(--ds-dialog-ty, 12px));
  }
}

[data-ds-dialog-slide-up-and-fade]::backdrop {
  background-color: transparent;
  transition:
    background-color 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[data-ds-dialog-slide-up-and-fade][open]::backdrop {
  background-color: var(--ds-blanket, #050C1F75);
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-dialog-slide-up-and-fade][open]::backdrop {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-ds-dialog-slide-up-and-fade],
  [data-ds-dialog-slide-up-and-fade][open],
  [data-ds-dialog-slide-up-and-fade]::backdrop,
  [data-ds-dialog-slide-up-and-fade][open]::backdrop {
    transition-duration: 0s;
  }
}
`;
function $e24b1b657d24d311$export$97a5dd1c12355679(options) {
    const distance = (options === null || options === void 0 ? void 0 : options.distance) ?? 12;
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: distance === 12 ? 'slide-up-and-fade' : `slide-up-and-fade-${distance}`,
        css: distance === 12 ? $e24b1b657d24d311$var$DIALOG_SLIDE_UP_AND_FADE_CSS : $e24b1b657d24d311$var$DIALOG_SLIDE_UP_AND_FADE_CSS.replace(/12px/g, `${distance}px`),
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}
// dialogFade
const $e24b1b657d24d311$var$DIALOG_FADE_CSS = `
[data-ds-dialog-fade] {
  opacity: 0;
  transition:
    opacity 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[data-ds-dialog-fade][open] {
  opacity: 1;
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-dialog-fade][open] {
    opacity: 0;
  }
}

[data-ds-dialog-fade]::backdrop {
  background-color: transparent;
  transition:
    background-color 175ms cubic-bezier(0.15, 1, 0.3, 1),
    overlay 175ms allow-discrete,
    display 175ms allow-discrete;
}

[data-ds-dialog-fade][open]::backdrop {
  background-color: var(--ds-blanket, #050C1F75);
  transition-duration: 350ms;
}

@starting-style {
  [data-ds-dialog-fade][open]::backdrop {
    background-color: transparent;
  }
}

@media (prefers-reduced-motion: reduce) {
  [data-ds-dialog-fade],
  [data-ds-dialog-fade][open],
  [data-ds-dialog-fade]::backdrop,
  [data-ds-dialog-fade][open]::backdrop {
    transition-duration: 0s;
  }
}
`;
function $e24b1b657d24d311$export$bef0e169dcd0522a() {
    // Bare preset name; `Dialog` prefixes it via `data-ds-dialog-{name}`.
    return {
        name: 'fade',
        css: $e24b1b657d24d311$var$DIALOG_FADE_CSS,
        enterDurationMs: 350,
        exitDurationMs: 175
    };
}

});
parcelRegister("cDI63", function(module, exports) {
$parcel$export(module.exports, "getPlacement", () => $029f7c56a43caede$export$a9fe23cfa43a7b55);

var $dJanf = parcelRequire("dJanf");
/**
 * Default gap between trigger and popover. Resolves to a design
 * token (`space.100`) so the value follows the design system's spacing
 * scale. Used when `placement.offset.gap` is not provided.
 */ const $029f7c56a43caede$var$DEFAULT_GAP = "var(--ds-space-100, 8px)";
function $029f7c56a43caede$export$a9fe23cfa43a7b55({ placement: placement }) {
    var _placement$offset, _placement$offset2, _placement$offset3;
    const consumerGap = (_placement$offset = placement.offset) === null || _placement$offset === void 0 ? void 0 : _placement$offset.gap;
    return {
        axis: placement.axis ?? 'block',
        edge: placement.edge ?? 'end',
        align: placement.align ?? 'center',
        offset: {
            gap: consumerGap === undefined ? $029f7c56a43caede$var$DEFAULT_GAP : (0, $dJanf.toCssLengthString)({
                value: consumerGap
            }),
            crossAxisShift: {
                value: (0, $dJanf.toCssLengthString)({
                    value: ((_placement$offset2 = placement.offset) === null || _placement$offset2 === void 0 || (_placement$offset2 = _placement$offset2.crossAxisShift) === null || _placement$offset2 === void 0 ? void 0 : _placement$offset2.value) ?? 0
                }),
                direction: ((_placement$offset3 = placement.offset) === null || _placement$offset3 === void 0 || (_placement$offset3 = _placement$offset3.crossAxisShift) === null || _placement$offset3 === void 0 ? void 0 : _placement$offset3.direction) ?? 'forwards'
            }
        }
    };
}

});
parcelRegister("dJanf", function(module, exports) {
$parcel$export(module.exports, "toCssLengthString", () => $aca54fa4832d8f4f$export$63b6b0ff65d84d47);
/**
 * Normalizes an offset to a CSS length string. Numbers become `${n}px`;
 * strings pass through. Apply at the API boundary so internal code only
 * deals with strings.
 */ function $aca54fa4832d8f4f$export$63b6b0ff65d84d47({ value: value }) {
    if (typeof value === 'number') return `${value}px`;
    return value;
}

});



parcelRegister("9VLm8", function(module, exports) {
$parcel$export(module.exports, "fromLegacyPlacement", () => $4c36ea874d1260e7$export$69e99ed50b2534c9);

var $iCMKu = parcelRequire("iCMKu");
function $4c36ea874d1260e7$export$69e99ed50b2534c9({ legacy: legacy, offset: offset }) {
    const basePlacement = (0, $iCMKu.placementMapping)[legacy];
    if (!offset) return basePlacement;
    const [along, away] = offset;
    return {
        ...basePlacement,
        offset: {
            gap: away,
            crossAxisShift: {
                // Sign is captured in `direction`; `value` is the magnitude.
                value: Math.abs(along),
                direction: along >= 0 ? 'forwards' : 'backwards'
            }
        }
    };
}

});
parcelRegister("iCMKu", function(module, exports) {
$parcel$export(module.exports, "placementMapping", () => $d040e899a57a9714$export$27df359c528b7120);
const $d040e899a57a9714$export$27df359c528b7120 = {
    top: {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-start': {
        axis: 'block',
        edge: 'start',
        align: 'start'
    },
    'top-center': {
        axis: 'block',
        edge: 'start',
        align: 'center'
    },
    'top-end': {
        axis: 'block',
        edge: 'start',
        align: 'end'
    },
    bottom: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'bottom-center': {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'bottom-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    },
    right: {
        axis: 'inline',
        edge: 'end',
        align: 'center'
    },
    'right-start': {
        axis: 'inline',
        edge: 'end',
        align: 'start'
    },
    'right-end': {
        axis: 'inline',
        edge: 'end',
        align: 'end'
    },
    left: {
        axis: 'inline',
        edge: 'start',
        align: 'center'
    },
    'left-start': {
        axis: 'inline',
        edge: 'start',
        align: 'start'
    },
    'left-end': {
        axis: 'inline',
        edge: 'start',
        align: 'end'
    },
    auto: {
        axis: 'block',
        edge: 'end',
        align: 'center'
    },
    'auto-start': {
        axis: 'block',
        edge: 'end',
        align: 'start'
    },
    'auto-end': {
        axis: 'block',
        edge: 'end',
        align: 'end'
    }
};

});


parcelRegister("1v8Ej", function(module, exports) {
$parcel$export(module.exports, "Popover", () => $ed5eb89199577fa2$export$5b6b19405a83ff9d);
/* popover.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");

var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $5wgou = parcelRequire("5wgou");

var $esKl8 = parcelRequire("esKl8");

var $1AxDb = parcelRequire("1AxDb");

var $49e4p = parcelRequire("49e4p");

var $77T25 = parcelRequire("77T25");

var $5kEJF = parcelRequire("5kEJF");

var $cfvrc = parcelRequire("cfvrc");
/**
 * Detects `popover="hint"` support via DOM reflection. SSR-safe, cached.
 */ const $ed5eb89199577fa2$var$supportsPopoverHint = (0, $esKl8.default)(()=>{
    if (typeof document === 'undefined') return false;
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- feature detection
    const element = document.createElement('div');
    element.setAttribute('popover', 'hint');
    return element.popover === 'hint';
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- popover UA reset requires values not in cssMap's type union
const $ed5eb89199577fa2$var$styles = {
    root: "_19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1r041wug _1reoewfl _18m9ewfl _bfhk1j28"
};
/**
 * Roles registered with the open layer observer as `popup`, so `closeLayers()`
 * dismisses them. `modal` comes from Dialog only; other layer types are unused.
 */ const $ed5eb89199577fa2$var$POPUP_ROLES = new Set([
    'menu',
    'listbox',
    'dialog',
    'alertdialog',
    'tree',
    'grid'
]);
const $ed5eb89199577fa2$export$5b6b19405a83ff9d = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function Popover({ children: children, mode: modeProp = 'auto', onClose: onClose, onOpenChange: onOpenChange, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish, animate: animate, placement: placement, testId: testId, isOpen: isOpen, xcss: xcssFromProps, role: // ARIA
role, label: label, labelledBy: labelledBy, id: idProp }, ref) {
    const autoId = (0, $4fqPo.useId)();
    const ownRef = (0, $4fqPo.useRef)(null);
    const combinedRef = (0, $5wgou.default)([
        ownRef,
        ref
    ].filter(Boolean));
    // `useId()` colons are invalid in CSS selectors and popover target attributes.
    const popoverId = idProp ?? `popover-${autoId.replace(/:/g, '')}`;
    const { phase: phase, preset: preset } = (0, $77T25.useAnimatedVisibility)({
        isOpen: isOpen,
        animate: animate,
        elementRef: ownRef,
        onEnterFinish: onEnterFinish,
        onExitFinish: onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Focus management: initial focus on entry (role-dependent), Tab cycling
    // for dialog roles. Restoration is native for outermost popovers; nested
    // focus-capturing roles are handled below via the `beforetoggle` snapshot.
    // Passing `phase` keeps `useFocusWrap` attached through the animated-exit
    // window (WCAG 2.4.3 guard). See notes/architecture/focus-restoration.md.
    (0, $5kEJF.useFocusWrap)({
        elementRef: ownRef,
        role: role,
        phase: phase
    });
    (0, $cfvrc.useInitialFocus)({
        elementRef: ownRef,
        phase: phase,
        role: role
    });
    // Register with open layer observer so `closeLayers()` and open-count
    // subscriptions work. Only popup-like roles register as `popup`; passive
    // roles (tooltip, status, etc.) leave `type` undefined.
    const handleObserverClose = (0, $4fqPo.useCallback)(()=>{
        onClose === null || onClose === void 0 || onClose({
            reason: 'programmatic'
        });
    }, [
        onClose
    ]);
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        type: role && $ed5eb89199577fa2$var$POPUP_ROLES.has(role) ? 'popup' : undefined,
        isOpen: isOpen,
        onClose: handleObserverClose
    });
    // `hint` falls back to `auto` when unsupported: closest behavior (light
    // dismiss works), but `auto` participates in the auto-dismiss stack so it
    // will close other `auto` popovers when opened. Acceptable trade-off given
    // shrinking browser set without `hint` support.
    const mode = modeProp === 'hint' && !$ed5eb89199577fa2$var$supportsPopoverHint() ? 'auto' : modeProp;
    // Prevents toggle handler from calling onClose for our own hidePopover() calls.
    const programmaticCloseRef = (0, $4fqPo.useRef)(false);
    // Set in capture-phase keydown so the toggle handler knows close reason.
    const closeReasonRef = (0, $4fqPo.useRef)('light-dismiss');
    // Snapshot of pre-open focus, used to restore focus for nested popovers
    // with focus-capturing roles (browser only restores the outermost).
    const previouslyFocusedElementRef = (0, $4fqPo.useRef)(null);
    const handleBeforeToggle = (0, $4fqPo.useCallback)((event)=>{
        if (event.newState !== 'open') return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- need active element snapshot
        const active = document.activeElement;
        previouslyFocusedElementRef.current = active instanceof HTMLElement ? active : null;
    }, []);
    const handleToggle = (0, $4fqPo.useCallback)((event)=>{
        const element = ownRef.current;
        if (event.newState === 'open') {
            if (element) onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                isOpen: true,
                element: element
            });
            return;
        }
        if (event.newState === 'closed') {
            if (element) {
                onOpenChange === null || onOpenChange === void 0 || onOpenChange({
                    isOpen: false,
                    element: element
                });
                // Nested-popover focus restoration fallback (browser only
                // restores outermost; Firefox skips nested entirely).
                // Restore only when the role moved focus in on open AND the
                // close was Escape/programmatic. For light dismiss, the
                // click target keeps focus per HTML spec
                // (`focusPreviousElement=false`).
                const previouslyFocused = previouslyFocusedElementRef.current;
                const reason = closeReasonRef.current;
                const isProgrammatic = programmaticCloseRef.current;
                const shouldRestore = previouslyFocused !== null && previouslyFocused.isConnected && (0, $49e4p.shouldFocusIntoPopover)({
                    role: role
                }) && (reason === 'escape' || isProgrammatic);
                if (shouldRestore && previouslyFocused) previouslyFocused.focus({
                    preventScroll: true
                });
                previouslyFocusedElementRef.current = null;
            }
            // Programmatic close: consumer already knows.
            if (programmaticCloseRef.current) {
                // Reset reason so a stale 'escape' from a race with Escape keydown
                // does not corrupt the next browser-dismiss cycle.
                closeReasonRef.current = 'light-dismiss';
                return;
            }
            // Browser dismiss (Escape/click-outside).
            const reason = closeReasonRef.current;
            closeReasonRef.current = 'light-dismiss';
            // Optional: `manual` mode has no `onClose` in the forwarded type.
            onClose === null || onClose === void 0 || onClose({
                reason: reason
            });
        }
    }, [
        onClose,
        onOpenChange,
        role
    ]);
    // Bind via `useLayoutEffect`, and BEFORE the show/hide layout effect
    // below, so listeners are attached when `showPopover()` synchronously
    // dispatches `beforetoggle`. A regular `useEffect` would miss that
    // first dispatch, dropping the `previouslyFocusedElementRef` snapshot
    // and breaking nested-popover focus restoration on close. React runs
    // layout effects in source order on the same commit.
    (0, $4fqPo.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        // Tag Escape before the browser processes light dismiss.
        const unbindEscape = (0, $lMcEJ.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key === 'Escape') closeReasonRef.current = 'escape';
            },
            options: {
                capture: true
            }
        });
        const unbindToggle = (0, $lMcEJ.bind)(element, {
            type: 'toggle',
            listener: handleToggle
        });
        // Snapshot `document.activeElement` before `useInitialFocus` moves it.
        const unbindBeforeToggle = (0, $lMcEJ.bind)(element, {
            type: 'beforetoggle',
            listener: handleBeforeToggle
        });
        return ()=>{
            unbindEscape();
            unbindToggle();
            unbindBeforeToggle();
        };
    }, [
        handleToggle,
        handleBeforeToggle,
        isVisible
    ]);
    // Placement-dependent animation CSS vars. Kept separate from show/hide
    // so preset reference changes do not re-trigger visibility.
    (0, $4fqPo.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element || !(preset !== null && preset !== void 0 && preset.getProperties) || !placement) return;
        const props = preset.getProperties({
            placement: placement
        });
        Object.entries(props).forEach(([key, value])=>{
            element.style.setProperty(key, String(value));
        });
    }, [
        preset,
        placement,
        isVisible
    ]);
    // Show/hide based on isOpen. `showPopover`/`hidePopover` are no-ops when
    // already in the target state. Try/catch guards `InvalidStateError` on
    // disconnected elements (StrictMode/concurrent/unmount edge cases).
    (0, $4fqPo.useLayoutEffect)(()=>{
        const element = ownRef.current;
        if (!element) return;
        if (isOpen) {
            programmaticCloseRef.current = false;
            // Clear stale 'escape' from a prior cycle: the ref outlives
            // the host element, and the no-animation path unmounts before
            // `handleToggle` can reset it.
            closeReasonRef.current = 'light-dismiss';
            try {
                element.showPopover();
            } catch  {}
            return ()=>{
                programmaticCloseRef.current = true;
                try {
                    element.hidePopover();
                } catch  {}
            };
        }
        programmaticCloseRef.current = true;
        try {
            element.hidePopover();
        } catch  {}
    }, [
        isOpen
    ]);
    // Unmount the host once exit completes so it does not leave an empty
    // `role`/`popover` element in the accessibility tree. The element
    // remounts on the next open; the `popoverId` is stable across opens.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
        ref: combinedRef,
        id: popoverId,
        // @ts-expect-error -- popover attribute not yet in React types
        // eslint-disable-next-line react/no-unknown-property -- popover attribute not yet in React types
        popover: mode,
        role: role,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        "data-testid": testId,
        ...preset ? {
            [`data-ds-popover-${preset.name}`]: ''
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- xcss prop passes compiled atomic class names
        className: (0, $ltgDR.default)([
            $ed5eb89199577fa2$var$styles.root,
            xcssFromProps
        ]),
        children: children
    });
});

});
parcelRegister("lhXNe", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hi9ES"));

});
parcelRegister("hi9ES", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $c96b9c111a62ff45$export$ffb0004e005737fa, (v) => $c96b9c111a62ff45$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $c96b9c111a62ff45$export$34b9dba7ce09269b, (v) => $c96b9c111a62ff45$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $c96b9c111a62ff45$export$25062201e9e25d76, (v) => $c96b9c111a62ff45$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c96b9c111a62ff45$export$ffb0004e005737fa;
var $c96b9c111a62ff45$export$34b9dba7ce09269b;
var $c96b9c111a62ff45$export$25062201e9e25d76;
'use strict';

var $4fqPo = parcelRequire("4fqPo");
var $c96b9c111a62ff45$var$k = Symbol.for("react.element"), $c96b9c111a62ff45$var$l = Symbol.for("react.fragment"), $c96b9c111a62ff45$var$m = Object.prototype.hasOwnProperty, $c96b9c111a62ff45$var$n = $4fqPo.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $c96b9c111a62ff45$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c96b9c111a62ff45$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$c96b9c111a62ff45$var$m.call(a, b) && !$c96b9c111a62ff45$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $c96b9c111a62ff45$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $c96b9c111a62ff45$var$n.current
    };
}
$c96b9c111a62ff45$export$ffb0004e005737fa = $c96b9c111a62ff45$var$l;
$c96b9c111a62ff45$export$34b9dba7ce09269b = $c96b9c111a62ff45$var$q;
$c96b9c111a62ff45$export$25062201e9e25d76 = $c96b9c111a62ff45$var$q;

});


parcelRegister("5wgou", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff6a5e653b752bb4$export$2e2bcd8739ae039);
function $ff6a5e653b752bb4$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && typeof ref === 'object') ref.current = value;
        });
    };
}

});

parcelRegister("esKl8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6f7c779963b7d57$export$2e2bcd8739ae039);
function $b6f7c779963b7d57$export$2e2bcd8739ae039(fn) {
    let cache = null;
    return function result(...args) {
        if (!cache) cache = {
            value: fn.call(this, ...args)
        };
        /**
     * Intentionally not adding `.clear()` function property
     *
     * - We currently have no need for it
     * - We don't want to add a `.clear()` to functions that should never be called twice,
     *   for example: `cleanup` functions.
     * - We can add a `onceWithCleanup` variant as a separate export from ds-lib if the
     *   need arises 🧘
     */ return cache.value;
    };
}

});

parcelRegister("49e4p", function(module, exports) {
$parcel$export(module.exports, "shouldFocusIntoPopover", () => $34fb767b2e58b57f$export$b12adccf56228c71);
/**
 * Valid values for the `aria-haspopup` attribute.
 *
 * Derived from the HTML spec - maps popover roles to what the trigger
 * announces. `undefined` means the attribute is omitted entirely (used for
 * non-popup roles like `tooltip`/`status`/`alert`/`note`/`log` where
 * `aria-haspopup` would be misleading).
 *
 * `true` is intentionally NOT in the union - the runtime only ever produces
 * the explicit string forms, so widening the type would invite consumers to
 * pass `true` and get an `aria-haspopup="true"` serialisation that the
 * runtime no longer emits.
 */ const $34fb767b2e58b57f$var$rolesThatMoveFocus = new Set([
    'dialog',
    'alertdialog',
    'menu',
    'listbox',
    'tree',
    'grid'
]);
function $34fb767b2e58b57f$export$b12adccf56228c71({ role: role }) {
    if (!role) return false;
    return $34fb767b2e58b57f$var$rolesThatMoveFocus.has(role);
}

});

parcelRegister("77T25", function(module, exports) {
$parcel$export(module.exports, "useAnimatedVisibility", () => $a6c2e63e67fb70ce$export$1bccb45daf07907f);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $eJRng = parcelRequire("eJRng");

var $4u1E3 = parcelRequire("4u1E3");
/**
 * Fires `onSettled` once when `transitionend` fires on `element`, or after
 * `safetyNetMs` if the event is swallowed (mid-transition unmount, CSS
 * mismatch, browser quirks). Returns a cleanup that cancels both paths.
 */ function $a6c2e63e67fb70ce$var$runOnTransitionEndOrTimeout({ element: element, safetyNetMs: safetyNetMs, onSettled: onSettled }) {
    const state = {
        isSettled: false
    };
    function teardown() {
        state.isSettled = true;
        clearTimeout(safetyNetId);
        unbind();
    }
    function settle() {
        if (state.isSettled) return;
        teardown();
        onSettled();
    }
    const unbind = (0, $lMcEJ.bind)(element, {
        type: 'transitionend',
        listener: settle,
        options: {
            once: true
        }
    });
    const safetyNetId = setTimeout(settle, safetyNetMs);
    return teardown;
}
function $a6c2e63e67fb70ce$export$1bccb45daf07907f({ isOpen: isOpen, animate: animate, elementRef: elementRef, onEnterFinish: onEnterFinish, onExitFinish: onExitFinish }) {
    const preset = (0, $4u1E3.usePresetStyles)({
        preset: animate
    });
    // False when there is no preset or `prefers-reduced-motion` is set.
    const willAnimate = Boolean(animate) && !(0, $eJRng.prefersReducedMotion)();
    // Promote `closed → entering`/`closed → open` synchronously during
    // render so the host element mounts in the same commit as the open
    // intent. All other transitions are driven by phase-specific effects.
    const [phase, setPhase] = (0, $4fqPo.useState)(()=>{
        if (!isOpen) return 'closed';
        return willAnimate ? 'entering' : 'open';
    });
    if (isOpen && phase === 'closed') setPhase(willAnimate ? 'entering' : 'open');
    if (!isOpen && (phase === 'open' || phase === 'entering')) // Close intent. Move to `exiting` to gate the unmount on either
    // the exit transition (animated) or the toggle/close event
    // (non-animated). Includes interrupted entry (`entering → exiting`).
    setPhase('exiting');
    if (isOpen && phase === 'exiting') // Reopen mid-exit. With animation, jump back to `entering` and let
    // the entry transition restart from current visual state. Without
    // animation, jump straight to `open` (the handshake we were waiting
    // for is no longer relevant; the consumer wants the host visible
    // again synchronously).
    setPhase(willAnimate ? 'entering' : 'open');
    // Keep stable refs to the latest callbacks so effects and timeout closures
    // always call the current callback without needing them in dependency arrays.
    const onEnterFinishRef = (0, $4fqPo.useRef)(onEnterFinish);
    onEnterFinishRef.current = onEnterFinish;
    const onExitFinishRef = (0, $4fqPo.useRef)(onExitFinish);
    onExitFinishRef.current = onExitFinish;
    // Animated entry: wait for `transitionend` (or a safety-net timeout) and
    // move to `open`. The fallback guarantees settle on swallowed events
    // (zero-duration, browser quirk, mid-transition unmount).
    (0, $4fqPo.useEffect)(()=>{
        if (phase !== 'entering') return;
        const element = elementRef.current;
        if (!element) return;
        return $a6c2e63e67fb70ce$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: ((preset === null || preset === void 0 ? void 0 : preset.enterDurationMs) ?? 0) + 50,
            onSettled: ()=>{
                var _onEnterFinishRef$cur;
                // Fire the consumer callback before transitioning phase so any
                // state the consumer reads (refs, DOM nodes) is still attached
                // in the same synchronous tick, regardless of React batching
                // semantics.
                (_onEnterFinishRef$cur = onEnterFinishRef.current) === null || _onEnterFinishRef$cur === void 0 || _onEnterFinishRef$cur.call(onEnterFinishRef);
                setPhase((current)=>current === 'entering' ? 'open' : current);
            }
        });
    }, [
        phase,
        preset === null || preset === void 0 ? void 0 : preset.enterDurationMs,
        elementRef
    ]);
    // Non-animated entry callback. The lifecycle goes `closed → open`
    // directly with no `entering` phase; fire `onEnterFinish` on that jump.
    // A previous-phase ref avoids double-firing on the animated path.
    const prevPhaseForEntryRef = (0, $4fqPo.useRef)('closed');
    (0, $4fqPo.useEffect)(()=>{
        const prevPhase = prevPhaseForEntryRef.current;
        prevPhaseForEntryRef.current = phase;
        // Animated entry settle goes through `entering` and already fired
        // onEnterFinish above; only handle the non-animated direct jumps.
        if (prevPhase !== 'open' && phase === 'open' && prevPhase !== 'entering') {
            var _onEnterFinishRef$cur2;
            (_onEnterFinishRef$cur2 = onEnterFinishRef.current) === null || _onEnterFinishRef$cur2 === void 0 || _onEnterFinishRef$cur2.call(onEnterFinishRef);
        }
    }, [
        phase
    ]);
    // Animated exit: wait for `transitionend` (or a safety-net timeout),
    // fire `onExitFinish`, then move to `closed` to unmount the host.
    (0, $4fqPo.useEffect)(()=>{
        if (phase !== 'exiting' || !willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        return $a6c2e63e67fb70ce$var$runOnTransitionEndOrTimeout({
            element: element,
            safetyNetMs: ((preset === null || preset === void 0 ? void 0 : preset.exitDurationMs) ?? 0) + 50,
            onSettled: ()=>{
                var _onExitFinishRef$curr;
                // Fire the consumer callback before transitioning phase to
                // `closed`. The phase change drives the host element unmount,
                // and consumers expect to be able to read the element (or a
                // forwarded ref to it) inside `onExitFinish`. Doing this in
                // the safe order avoids relying on React's automatic batching
                // to keep the element attached across the callback.
                (_onExitFinishRef$curr = onExitFinishRef.current) === null || _onExitFinishRef$curr === void 0 || _onExitFinishRef$curr.call(onExitFinishRef);
                setPhase((current)=>current === 'exiting' ? 'closed' : current);
            }
        });
    }, [
        phase,
        willAnimate,
        preset === null || preset === void 0 ? void 0 : preset.exitDurationMs,
        elementRef
    ]);
    // Non-animated exit: wait for the browser's `toggle` (closed) or
    // `close` event before unmounting, so the consumer's listener (close
    // reason, nested focus restoration, `onClose`) and the browser's
    // native focus restoration both run against the still-attached
    // element. A naive `setTimeout(0)` occasionally beats the `toggle`
    // task in Chromium and drops focus restoration.
    //
    // `useLayoutEffect` so the listener binds in the same commit as the
    // show/hide layout effect that calls `hidePopover()` / `dialog.close()`.
    // The toggle/close event is queued as a task and cannot run until the
    // frame completes. SSR-safe: `phase` starts at `'closed'`.
    //
    // `onExitFinish` is fired separately (see effect below) so consumers
    // observe it the moment `isOpen` flips to `false`.
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (phase !== 'exiting' || willAnimate) return;
        const element = elementRef.current;
        if (!element) return;
        function unmount() {
            setPhase((current)=>current === 'exiting' ? 'closed' : current);
        }
        return (0, $lMcEJ.bindAll)(element, [
            {
                type: 'toggle',
                listener: (event)=>{
                    if (event.newState === 'closed') unmount();
                }
            },
            {
                type: 'close',
                listener: unmount
            }
        ]);
    }, [
        phase,
        willAnimate,
        elementRef
    ]);
    // Non-animated exit callback. No `transitionend` to wait for, so fire
    // `onExitFinish` on the transition into `exiting` (the unmount itself
    // is gated by the toggle/close handshake above).
    const prevPhaseForExitRef = (0, $4fqPo.useRef)('closed');
    (0, $4fqPo.useEffect)(()=>{
        const prevPhase = prevPhaseForExitRef.current;
        prevPhaseForExitRef.current = phase;
        // Only fire on the non-animated transition into `exiting`. The
        // animated path's `exiting → closed` settle already fires
        // `onExitFinish` from `runOnTransitionEndOrTimeout`.
        if (prevPhase !== 'exiting' && phase === 'exiting' && !willAnimate) {
            var _onExitFinishRef$curr2;
            (_onExitFinishRef$curr2 = onExitFinishRef.current) === null || _onExitFinishRef$curr2 === void 0 || _onExitFinishRef$curr2.call(onExitFinishRef);
        }
    }, [
        phase,
        willAnimate
    ]);
    return {
        phase: phase,
        preset: preset
    };
}

});
parcelRegister("eJRng", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $1d6b7862bf919fea$export$ff7706047246b98b);

var $esKl8 = parcelRequire("esKl8");
const $1d6b7862bf919fea$export$ff7706047246b98b = (0, $esKl8.default)(()=>{
    if (typeof window === 'undefined' || !('matchMedia' in window)) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
});

});

parcelRegister("4u1E3", function(module, exports) {
$parcel$export(module.exports, "usePresetStyles", () => $447cf5f62d937d01$export$f09337c691384fe1);

var $4fqPo = parcelRequire("4fqPo");

var $7UG6j = parcelRequire("7UG6j");
function $447cf5f62d937d01$export$f09337c691384fe1({ preset: preset }) {
    const resolved = preset != null && preset !== false ? preset : null;
    (0, $4fqPo.useInsertionEffect)(()=>{
        if (resolved) (0, $7UG6j.ensurePresetStyles)({
            preset: resolved
        });
    }, [
        resolved
    ]);
    return resolved;
}

});
parcelRegister("7UG6j", function(module, exports) {
$parcel$export(module.exports, "ensurePresetStyles", () => $71fda39695184159$export$9515fe8c2ae33fb5);
/**
 * Per-preset CSS injection.
 *
 * Each preset's CSS is injected at most once into `<head>`.
 * Shared by both PopoverContent and DialogContent.
 *
 * Note: injected `<style>` elements and the tracking Set are append-only -
 * they are never removed. This is intentional: the number of distinct
 * presets is bounded (handful of animation presets), so the
 * memory footprint is negligible. Removing styles would risk breaking
 * other instances of the same preset that are still mounted.
 *
 * Decision (2026-03-17 audit): Accepted as a non-issue. The bounded
 * preset count (~5 presets) makes cleanup unnecessary. We plan to move
 * to a Compiled-based solution which will handle style injection and
 * deduplication natively.
 */ const $71fda39695184159$var$injectedPresets = new Set();
function $71fda39695184159$export$9515fe8c2ae33fb5({ preset: preset }) {
    if ($71fda39695184159$var$injectedPresets.has(preset.name) || typeof document === 'undefined') return;
    $71fda39695184159$var$injectedPresets.add(preset.name);
    const style = document.createElement('style');
    style.textContent = preset.css;
    document.head.appendChild(style);
}

});



parcelRegister("5kEJF", function(module, exports) {
$parcel$export(module.exports, "useFocusWrap", () => $41f9aa94990bd673$export$4f6462e86a70abe5);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $5ax9w = parcelRequire("5ax9w");

var $l3xB8 = parcelRequire("l3xB8");

var $eW0Yp = parcelRequire("eW0Yp");

var $2MZm0 = parcelRequire("2MZm0");
/**
 * Roles that require focus wrapping per WAI-ARIA APG.
 *
 * - `dialog`: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/
 * - `alertdialog`: same keyboard pattern as dialog
 *
 * `menu` is intentionally excluded. Menus are composite widgets
 * (https://www.w3.org/WAI/ARIA/apg/practices/keyboard-interface/#kbd_general_within)
 * that manage their own internal keyboard navigation via arrow keys,
 * not Tab. Tab/Shift+Tab should move focus OUT of a menu entirely.
 *
 * Menu keyboard behavior (arrow keys, Home/End, type-ahead, Enter/Space)
 * is context-dependent. It varies by orientation, nesting depth, item
 * type, and control pattern (menu button vs menubar). This makes it
 * impossible to implement generically here. The consumer component
 * (e.g. `dropdown-menu`) owns all menu keyboard navigation.
 *
 * See: notes/outputs/menu-keyboard-decision.md
 */ function $41f9aa94990bd673$var$roleRequiresFocusWrap(role) {
    return role === 'dialog' || role === 'alertdialog';
}
function $41f9aa94990bd673$export$4f6462e86a70abe5({ elementRef: elementRef, role: role, phase: phase }) {
    const isVisible = phase !== 'closed';
    (0, $4fqPo.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !$41f9aa94990bd673$var$roleRequiresFocusWrap(role) || !isVisible) return;
        const unbind = (0, $lMcEJ.bind)(element, {
            type: 'keydown',
            listener: (event)=>{
                if (event.key !== 'Tab') return;
                // If focus is already in a nested layer, then
                // we continue to let that nested layer own focus
                if ((0, $2MZm0.isNestedLayerFocused)({
                    container: element
                })) return;
                // Prevent the browser giving focus to where it wants to
                // (we will be handling it, including with wrapping)
                event.preventDefault();
                const direction = event.shiftKey ? 'backwards' : 'forwards';
                // Try to move to the next/previous focusable element relative
                // to the currently focused element within the container.
                const next = (0, $eW0Yp.getNextFocusable)({
                    container: element,
                    direction: direction
                });
                if (next) {
                    next.focus();
                    return;
                }
                // Nothing is currently focused inside the container (or the
                // focused element is not in the focusable list). Fall back to
                // the first or last focusable element depending on direction.
                const fallback = direction === 'forwards' ? (0, $5ax9w.getFirstFocusable)({
                    container: element
                }) : (0, $l3xB8.getLastFocusable)({
                    container: element
                });
                if (fallback) fallback.focus();
            },
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        elementRef,
        role,
        isVisible
    ]);
}

});
parcelRegister("5ax9w", function(module, exports) {
$parcel$export(module.exports, "getFirstFocusable", () => $15fe379a1ad31f3b$export$748138f04a69bf21);

var $37ndm = parcelRequire("37ndm");
function $15fe379a1ad31f3b$export$748138f04a69bf21({ container: container, filter: filter }) {
    const items = (0, $37ndm.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[0] : null;
}

});
parcelRegister("37ndm", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $3cca224772f06a1a$export$f6768025e418420e);

var $3j1iT = parcelRequire("3j1iT");

var $3EEXe = parcelRequire("3EEXe");
function $3cca224772f06a1a$export$f6768025e418420e({ container: container, filter: filter }) {
    return Array.from(container.querySelectorAll((0, $3EEXe.selectors).focusable)).filter((element)=>element instanceof HTMLElement).filter((element)=>(0, $3j1iT.isInSameLayer)({
            element: element,
            container: container
        })).filter((element)=>!filter || filter(element, container));
}

});
parcelRegister("3j1iT", function(module, exports) {
$parcel$export(module.exports, "isInSameLayer", () => $d1eafdadd913364a$export$df8c72c64edc7260);
const $d1eafdadd913364a$var$topLayerSelector = '[popover], dialog, [role="dialog"], [role="alertdialog"]';
function $d1eafdadd913364a$export$df8c72c64edc7260({ element: element, container: container }) {
    const elementLayer = element.closest($d1eafdadd913364a$var$topLayerSelector);
    const containerLayer = container.closest($d1eafdadd913364a$var$topLayerSelector);
    // Both elements are in the "document" layer
    if (!elementLayer && !containerLayer) return true;
    return elementLayer === containerLayer;
}

});

parcelRegister("3EEXe", function(module, exports) {
$parcel$export(module.exports, "selectors", () => $784cb320e9660ca2$export$e1252723db1c541);
const $784cb320e9660ca2$export$e1252723db1c541 = (()=>{
    // Common exclusion filter applied to every selector.
    const not = ':not([tabindex="-1"]):not([aria-disabled="true"]):not([aria-hidden="true"])';
    const notDisabled = `:not([disabled])${not}`;
    const focusable = [
        `a[href]${not}`,
        `area[href]${not}`,
        `input${notDisabled}:not([type="hidden"])`,
        `select${notDisabled}`,
        `textarea${notDisabled}`,
        `button${notDisabled}`,
        `iframe${not}`,
        `audio[controls]${not}`,
        `video[controls]${not}`,
        `[contenteditable]:not([contenteditable="false"])${not}`,
        `[tabindex]${notDisabled}${not}`
    ];
    return {
        focusable: focusable.join(','),
        // Build the `:focus` selector
        focused: focusable.map((selector)=>`${selector}:focus`).join(',')
    };
})();

});



parcelRegister("l3xB8", function(module, exports) {
$parcel$export(module.exports, "getLastFocusable", () => $b9af830fa71995e8$export$73e81fa65335a75b);

var $37ndm = parcelRequire("37ndm");
function $b9af830fa71995e8$export$73e81fa65335a75b({ container: container, filter: filter }) {
    const items = (0, $37ndm.getFocusables)({
        container: container,
        filter: filter
    });
    return items.length > 0 ? items[items.length - 1] : null;
}

});

parcelRegister("eW0Yp", function(module, exports) {
$parcel$export(module.exports, "getNextFocusable", () => $3821af986713a6bc$export$a7db88e6d491b450);
/**
 * Returns the next focusable element in the given direction relative to the
 * currently focused element within the container. Wraps around at both ends.
 *
 * Returns `null` if there is no focused element within the container or if
 * the focused element is not in the list of focusable elements.
 */ 
var $37ndm = parcelRequire("37ndm");

var $3EEXe = parcelRequire("3EEXe");
function $3821af986713a6bc$export$a7db88e6d491b450({ container: container, direction: direction, filter: filter }) {
    const all = (0, $37ndm.getFocusables)({
        container: container,
        filter: filter
    });
    const current = container.querySelector((0, $3EEXe.selectors).focused);
    if (!(current instanceof HTMLElement)) return null;
    const index = all.indexOf(current);
    if (index === -1) return null;
    const nextIndex = (()=>{
        if (direction === 'forwards') return (index + 1) % all.length;
        const proposed = index - 1;
        // if going into negative numbers, loop back to the last item
        return proposed < 0 ? all.length - 1 : proposed;
    })();
    return all[nextIndex] ?? null;
}

});

parcelRegister("2MZm0", function(module, exports) {
$parcel$export(module.exports, "isNestedLayerFocused", () => $8b2f2a1131571a1b$export$b9590fdfeb5f722f);

var $564zZ = parcelRequire("564zZ");

var $3j1iT = parcelRequire("3j1iT");
function $8b2f2a1131571a1b$export$b9590fdfeb5f722f({ container: container }) {
    var _getDocument;
    const focused = (_getDocument = (0, $564zZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
    if (!(focused instanceof HTMLElement)) return false;
    // Cannot be in a nested layer if it is not in the container
    if (!container.contains(focused)) return false;
    // If not in the same layer, must be in a nested layer
    return !(0, $3j1iT.isInSameLayer)({
        element: focused,
        container: container
    });
}

});


parcelRegister("cfvrc", function(module, exports) {
$parcel$export(module.exports, "useInitialFocus", () => $39400219030c4e9f$export$e992c40175757a22);

var $4fqPo = parcelRequire("4fqPo");

var $5ax9w = parcelRequire("5ax9w");
/**
 * Determines the correct element to receive initial focus within a popover,
 * based on its ARIA role.
 *
 * Focus rules by role (per WAI-ARIA APG):
 * - `dialog` / `alertdialog`: first element with `[autofocus]`, or first focusable element
 * - `menu`: first menu item (`[role="menuitem|menuitemcheckbox|menuitemradio"]`)
 * - `listbox`: first selected option (`[aria-selected="true"]`), or first option (`[role="option"]`)
 * - `tooltip`: no focus movement (tooltips are informational)
 * - no role / other roles: no focus movement
 *
 * Note: React 18's `autoFocus` JSX prop does NOT set the HTML `autofocus`
 * attribute - it only calls `.focus()` imperatively during commit, which
 * has no effect on hidden popover content. Consumers must set the native
 * attribute via a ref callback (e.g. `node.setAttribute('autofocus', '')`).
 * React 19+ reflects the JSX prop as the HTML attribute automatically.
 *
 * Combobox pattern exception: if the popup is controlled by a focused
 * combobox-like trigger (its `aria-controls` references this popup),
 * focus stays on the textbox regardless of role. See
 * `isComboboxControllingPopup`.
 */ /**
 * WAI-ARIA APG Combobox Pattern: when a combobox controls a popup (listbox,
 * grid, tree, or menu), DOM focus must remain on the textbox. Subsequent
 * navigation through popup items uses `aria-activedescendant` (or proxied
 * keyboard events), never DOM focus movement.
 *
 * Detects both variants in a single pass:
 * - In-popup combobox: the textbox lives inside the popup `container`
 *   (the popup is rendered as a child of the combobox wrapper).
 * - External combobox: the textbox is rendered OUTSIDE the popup
 *   (`react-select` pattern, where the listbox is portalled separately
 *   from the textbox).
 *
 * Acceptance criteria for the active element:
 * - Role / element-type filter: `role="combobox"`, `role="textbox"`,
 *   `TEXTAREA`, `contentEditable`, or `INPUT` of text-like type
 *   (`text`, `search`, `email`, `url`, `tel`, `password`, or
 *   unspecified). Non-text input types (`button`, `checkbox`, etc.)
 *   are rejected.
 * - Reference filter: `aria-controls` (or legacy `aria-owns`) IDREFS
 *   must resolve to an element that IS or CONTAINS the popup container.
 *
 * See: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/
 */ // `<input>` types treated as text-like for combobox detection.
// Non-text input types (`button`, `checkbox`, `submit`, etc.) are rejected.
// A missing `type` attribute defaults to `text` per the HTML spec, so we
// normalize that case before lookup rather than including an empty string here.
const $39400219030c4e9f$var$TEXT_LIKE_INPUT_TYPES = new Set([
    'text',
    'search',
    'email',
    'url',
    'tel',
    'password'
]);
function $39400219030c4e9f$var$isTextboxLikeElement(element) {
    const role = element.getAttribute('role');
    if (role === 'combobox' || role === 'textbox') return true;
    // `tagName` is uppercase for HTML elements but can be mixed-case for
    // XML/SVG. Normalize once so downstream comparisons stay lowercase.
    const tag = element.tagName.toLowerCase();
    if (tag === 'textarea') return true;
    if (element.isContentEditable) return true;
    if (tag === 'input') {
        const type = (element.getAttribute('type') ?? 'text').toLowerCase();
        return $39400219030c4e9f$var$TEXT_LIKE_INPUT_TYPES.has(type);
    }
    return false;
}
function $39400219030c4e9f$var$isComboboxControllingPopup({ container: container }) {
    const ownerDocument = container.ownerDocument;
    const active = ownerDocument.activeElement;
    if (!(active instanceof HTMLElement)) return false;
    if (!$39400219030c4e9f$var$isTextboxLikeElement(active)) return false;
    // Accept legacy `aria-owns` in addition to `aria-controls`.
    // `aria-controls` / `aria-owns` are IDREFS (space-separated list of IDs)
    // per the WAI-ARIA spec, so we must split and check membership rather
    // than comparing with strict equality. A combobox that controls both
    // this popup and another element (e.g. a results status region) must
    // still be recognised as controlling this popup.
    const idRefs = active.getAttribute('aria-controls') ?? active.getAttribute('aria-owns');
    if (!idRefs) return false;
    // Match if any referenced element IS, CONTAINS, or IS CONTAINED BY the
    // popup container. The "contained by" case covers wrapper-style adopters
    // like react-select, where the combobox input's `aria-controls` points at
    // a listbox element that is a descendant of the Popover host (the
    // listbox role lives on a child the wrapped library owns, not on the
    // host we render).
    const referencedIds = idRefs.split(/\s+/).filter((id)=>id !== '');
    return referencedIds.some((id)=>{
        const referenced = ownerDocument.getElementById(id);
        if (!referenced) return false;
        return referenced === container || referenced.contains(container) || container.contains(referenced);
    });
}
function $39400219030c4e9f$var$getInitialFocusTarget({ container: container, role: role }) {
    if (role === 'dialog' || role === 'alertdialog') {
        // Prefer element with the native HTML autofocus attribute.
        const autofocusEl = container.querySelector('[autofocus]');
        if (autofocusEl) return autofocusEl;
        // Fall back to first focusable element
        return (0, $5ax9w.getFirstFocusable)({
            container: container
        });
    }
    // The combobox carve-out is kept role-specific (menu / listbox) rather
    // than hoisted. Hoisting it over-matched on dialog popups that contain
    // a nested combobox (e.g. datetime-picker's dialog hosts a react-select),
    // where the active combobox's `aria-controls` falsely matched the
    // container and suppressed the dialog's own focus contract.
    if (role === 'menu') {
        if ($39400219030c4e9f$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Initial focus placement is the extent of what top-layer provides
        // for menus. All subsequent keyboard navigation (arrow keys, Home/End,
        // type-ahead, Enter/Space, submenu coordination) is the responsibility
        // of the consumer component (e.g. dropdown-menu), because menu keyboard
        // behavior varies by context (orientation, nesting, item type, control
        // pattern). See: notes/outputs/menu-keyboard-decision.md
        return (0, $5ax9w.getFirstFocusable)({
            container: container
        });
    }
    if (role === 'listbox') {
        // ARIA Combobox Pattern: if a combobox-like textbox owns the popup
        // (in-popup or external e.g. react-select), leave focus on the
        // textbox - navigation is proxied through it.
        if ($39400219030c4e9f$var$isComboboxControllingPopup({
            container: container
        })) return null;
        // Prefer the selected option, then fall back to the first option.
        // We intentionally match by `[role="option"]` rather than by
        // `getFirstFocusable`. The standard WAI-ARIA APG listbox pattern
        // renders options with `tabindex="-1"` (managed via roving
        // tabindex); `getFirstFocusable` excludes `tabindex="-1"` elements
        // and would silently lose initial focus for spec-conformant
        // listboxes. Options remain programmatically focusable.
        const selectedOption = container.querySelector('[role="option"][aria-selected="true"]');
        if (selectedOption) return selectedOption;
        const firstOption = container.querySelector('[role="option"]');
        if (firstOption) return firstOption;
        // Last resort for non-standard listboxes that render no options
        // but do contain a focusable element (e.g. an empty-state action).
        return (0, $5ax9w.getFirstFocusable)({
            container: container
        });
    }
    // tooltip, no role, or other roles: no focus movement
    return null;
}
function $39400219030c4e9f$export$e992c40175757a22({ elementRef: elementRef, phase: phase, role: role }) {
    // Track the previous phase so we only focus on transitions into a
    // visible phase from either `'closed'` (fresh mount) or `'exiting'`
    // (mid-exit reopen where the browser has already restored focus to
    // the trigger). Pure `entering → exiting → entering` stutters where
    // the consumer toggles in the same frame are still collapsed.
    const prevPhaseRef = (0, $4fqPo.useRef)('closed');
    (0, $4fqPo.useEffect)(()=>{
        var _getInitialFocusTarge;
        const prevPhase = prevPhaseRef.current;
        prevPhaseRef.current = phase;
        // Only focus on transitions into a visible phase from `'closed'`
        // (fresh open) or `'exiting'` (mid-exit reopen).
        if (phase === 'closed') return;
        if (prevPhase !== 'closed' && prevPhase !== 'exiting') return;
        const element = elementRef.current;
        if (!element) return;
        (_getInitialFocusTarge = $39400219030c4e9f$var$getInitialFocusTarget({
            container: element,
            role: role
        })) === null || _getInitialFocusTarge === void 0 || _getInitialFocusTarge.focus();
    }, [
        elementRef,
        phase,
        role
    ]);
}

});


parcelRegister("jC6gp", function(module, exports) {
$parcel$export(module.exports, "useAnchorPosition", () => $7929679938b34898$export$56b02a1e583f953c);
/**
 * Anchor positioning for top-layer popovers. See
 * `notes/architecture/positioning.md` for the full model.
 *
 * Two runtime paths: CSS Anchor Positioning (modern browsers) and a JS
 * fallback that measures the trigger and writes `top`/`left`.
 *
 * Both paths honour `offset.gap` and `offset.crossAxisShift`. The
 * CSS path passes the values through as strings; the JS fallback resolves
 * them to pixels via a hidden DOM probe (see `resolveCssLengthToPixels`)
 * so tokens, `calc()`, `var()`, etc all work. The JS fallback hides the
 * popover with `opacity: 0` until the first measurement completes, so it
 * is never painted at the wrong location.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $c1P93 = parcelRequire("c1P93");

var $esKl8 = parcelRequire("esKl8");

var $hwCmR = parcelRequire("hwCmR");

var $fMmTU = parcelRequire("fMmTU");

var $1JQEr = parcelRequire("1JQEr");

var $6eyns = parcelRequire("6eyns");

var $688Rd = parcelRequire("688Rd");

var $cDI63 = parcelRequire("cDI63");

var $gNpuf = parcelRequire("gNpuf");
// `getPlacement` is intentionally NOT re-exported here - import it directly
// from `./resolve-placement` so search-and-jump lands at the source of truth.
/**
 * Module-scope no-op `ResizeObserver` used in non-DOM jest environments where
 * `ResizeObserver` is `undefined`. Hoisted out of the effect to avoid
 * allocating a new class declaration on every run.
 */ const $7929679938b34898$var$NoopResizeObserver = class {
    observe() {}
    unobserve() {}
    disconnect() {}
};
/**
 * Returns true when the popover is currently open. Wrapped because the
 * `:popover-open` pseudo-class is not implemented in some test environments
 * (e.g. jsdom), where `matches` throws on unknown selectors.
 */ function $7929679938b34898$var$isPopoverOpen(popover) {
    try {
        return popover.matches(':popover-open');
    } catch  {
        return false;
    }
}
/**
 * Detects whether the browser supports CSS Anchor Positioning.
 * Uses `once()` for lazy evaluation: safe for SSR and avoids hydration mismatches.
 */ const $7929679938b34898$var$supportsAnchorPositioning = (0, $esKl8.default)(()=>{
    if (typeof window === 'undefined' || typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return false;
    return CSS.supports('anchor-name', '--a');
});
/**
 * Returns the CSS margin declaration that creates a gap between the
 * popover and its trigger on the side facing the anchor.
 *
 * For example, a `block-end` placement (popover below) gets
 * `margin-block-start: 8px` to push it away from the trigger's bottom edge.
 */ function $7929679938b34898$var$edgeMargin({ placement: placement, offset: offset }) {
    const { axis: axis, edge: edge } = placement;
    const value = offset;
    if (axis === 'block' && edge === 'end') return {
        property: 'margin-block-start',
        value: value
    };
    if (axis === 'block' && edge === 'start') return {
        property: 'margin-block-end',
        value: value
    };
    if (axis === 'inline' && edge === 'end') return {
        property: 'margin-inline-start',
        value: value
    };
    if (axis === 'inline' && edge === 'start') return {
        property: 'margin-inline-end',
        value: value
    };
    return {
        property: 'margin-block-start',
        value: value
    };
}
/**
 * Cross-axis shift margin. Margin side matches the popover's anchored
 * cross-axis edge: `align: 'start'` uses the START margin, `align: 'end'`
 * uses the END margin with the sign inverted (so `forwards` is always
 * positive), `align: 'center'` uses START. Margin on the un-anchored side
 * has no effect under CSS Anchor Positioning.
 */ function $7929679938b34898$var$crossAxisShiftMargin({ placement: placement, crossAxisShiftCssValue: crossAxisShiftCssValue, direction: direction }) {
    const { axis: axis, align: align } = placement;
    const directionSign = direction === 'forwards' ? 1 : -1;
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const useEndSide = align === 'end';
    const side = useEndSide ? 'end' : 'start';
    const sideSign = useEndSide ? -1 : 1;
    const finalSign = directionSign * sideSign;
    // Wrap any string in calc() with the sign factor. CSS handles the math.
    const value = finalSign === 1 ? crossAxisShiftCssValue : `calc(-1 * ${crossAxisShiftCssValue})`;
    return {
        property: `margin-${crossAxis}-${side}`,
        value: value
    };
}
/**
 * Returns a referentially-stable, fully-resolved `TPlacement`. The memo is
 * keyed on the resolved primitive fields so a fresh inline `placement` object
 * (or undefined fields vs explicit defaults) does not produce a fresh result.
 */ function $7929679938b34898$var$useStablePlacement(placement) {
    const resolved = (0, $cDI63.getPlacement)({
        placement: placement
    });
    const axis = resolved.axis;
    const edge = resolved.edge;
    const align = resolved.align;
    const gap = resolved.offset.gap;
    const shiftValue = resolved.offset.crossAxisShift.value;
    const shiftDirection = resolved.offset.crossAxisShift.direction;
    // Rebuild inside the memo from primitive deps so the factory does not
    // close over the outer `resolved` reference and exhaustive-deps can verify.
    return (0, $4fqPo.useMemo)(()=>({
            axis: axis,
            edge: edge,
            align: align,
            offset: {
                gap: gap,
                crossAxisShift: {
                    value: shiftValue,
                    direction: shiftDirection
                }
            }
        }), [
        axis,
        edge,
        align,
        gap,
        shiftValue,
        shiftDirection
    ]);
}
function $7929679938b34898$export$56b02a1e583f953c({ anchorRef: anchorRef, popoverRef: popoverRef, placement: placement = {}, forceFallbackPositioning: forceFallbackPositioning = false, isEnabled: isEnabled = true, isOpen: isOpen }) {
    const id = (0, $4fqPo.useId)();
    const stablePlacement = $7929679938b34898$var$useStablePlacement(placement);
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const trigger = anchorRef.current;
        const popover = popoverRef.current;
        if (!trigger || !popover) return;
        const gapCssValue = stablePlacement.offset.gap;
        const crossAxisShiftCssValue = stablePlacement.offset.crossAxisShift.value;
        const shouldForceFallback = Boolean(forceFallbackPositioning);
        if ($7929679938b34898$var$supportsAnchorPositioning() && !shouldForceFallback) {
            // Reuse an existing `anchor-name` if the element already has one.
            // Another popover might already be anchored to the old name.
            const anchorName = trigger.style.getPropertyValue('anchor-name') || `--anchor-${id.replace(/:/g, '')}`;
            const gap = $7929679938b34898$var$edgeMargin({
                placement: stablePlacement,
                offset: gapCssValue
            });
            // Computed once; reused below to populate the active
            // `--ds-cross-axis-shift-margin-*` custom property for the
            // named arrow @position-try rules.
            const crossAxisShift = $7929679938b34898$var$crossAxisShiftMargin({
                placement: stablePlacement,
                crossAxisShiftCssValue: crossAxisShiftCssValue,
                direction: stablePlacement.offset.crossAxisShift.direction
            });
            const popoverStyles = [
                {
                    property: 'position-anchor',
                    value: anchorName
                },
                {
                    property: 'position-area',
                    value: (0, $1JQEr.placementToPositionArea)({
                        placement: stablePlacement
                    })
                },
                {
                    property: 'position-try-fallbacks',
                    value: (0, $6eyns.placementToTryFallbacks)({
                        placement: stablePlacement
                    })
                },
                // Reset browser default popover positioning that conflicts
                // with anchor positioning (UA: `inset: 0; margin: auto;`)
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                },
                {
                    property: gap.property,
                    value: gap.value
                },
                {
                    property: crossAxisShift.property,
                    value: crossAxisShift.value
                }
            ];
            // Expose the active cross-axis shift via custom properties so each
            // named arrow @position-try rule can re-apply it after a flip.
            // One of the four (cross-axis, side) properties is non-zero at a time.
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-end',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-start',
                value: '0px'
            });
            popoverStyles.push({
                property: '--ds-cross-axis-shift-margin-block-end',
                value: '0px'
            });
            // `crossAxisShift` IS the active margin; reuse instead of recomputing.
            const crossAxisShiftActive = crossAxisShift;
            const customPropertyByMarginProperty = {
                'margin-inline-start': '--ds-cross-axis-shift-margin-start',
                'margin-inline-end': '--ds-cross-axis-shift-margin-end',
                'margin-block-start': '--ds-cross-axis-shift-margin-block-start',
                'margin-block-end': '--ds-cross-axis-shift-margin-block-end'
            };
            const crossAxisShiftCustomProperty = customPropertyByMarginProperty[crossAxisShiftActive.property];
            if (crossAxisShiftCustomProperty) popoverStyles.push({
                property: crossAxisShiftCustomProperty,
                value: crossAxisShiftActive.value
            });
            /**
       * **We are never cleaning up anchor names**
       *
       * _Rationale_
       *
       * - Multiple popovers can share the same anchor element.
       * - Sometimes the `useAnchorPosition` hook and `Popover`
       *   are not in the same component.
       * - There can be times when, even with reference counting, we
       *   could remove the anchor-name while it is still being used
       *   by something else - especially with async react updates
       *   which can cause tearing
       *
       * _More_
       *
       * See `notes/decisions/anchor-name-lifetime.md`
       */ trigger.style.setProperty('anchor-name', anchorName);
            const undoPositioning = (0, $fMmTU.combine)((0, $gNpuf.setStyle)({
                element: popover,
                styles: popoverStyles
            }));
            return undoPositioning;
        }
        // JS fallback. The popover is already in the top layer via
        // popover="auto", so we only reset UA defaults and set top/left
        // based on measurements.
        const cleanupBaseStyles = (0, $gNpuf.setStyle)({
            element: popover,
            styles: [
                {
                    property: 'margin',
                    value: '0'
                },
                {
                    property: 'inset',
                    value: 'auto'
                }
            ]
        });
        function update() {
            if (!trigger || !popover) return;
            const triggerRect = trigger.getBoundingClientRect();
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };
            // Resolve consumer-supplied CSS length strings (tokens, calc, var,
            // px, rem, etc) to pixels. The probe is mounted INSIDE the popover
            // itself so the resolved length matches the scope a token would
            // resolve against from inside the popover content. (The popover
            // lives in the top layer, not the trigger's DOM tree, so probing
            // at `popover.parentElement` would resolve in a different scope
            // than the consumer's token authoring expects.)
            const gapPx = (0, $688Rd.resolveCssLengthToPixels)({
                value: gapCssValue,
                container: popover
            });
            const crossAxisShiftPx = (0, $688Rd.resolveCssLengthToPixels)({
                value: crossAxisShiftCssValue,
                container: popover
            });
            const { top: top, left: left } = (0, $hwCmR.computeFallbackPosition)({
                triggerRect: triggerRect,
                popoverEl: popover,
                placement: stablePlacement,
                viewport: viewport,
                gap: gapPx,
                crossAxisShift: {
                    value: crossAxisShiftPx,
                    direction: stablePlacement.offset.crossAxisShift.direction
                }
            });
            popover.style.setProperty('top', `${top}px`);
            popover.style.setProperty('left', `${left}px`);
            // Reveal the popover only after it has been positioned.
            // See the toggle listener below for why we hide on open.
            popover.style.removeProperty('opacity');
        }
        // Throttle scroll/resize updates to one per animation frame
        const scheduledUpdate = (0, $c1P93.default)(update);
        // Wait for the FIRST valid layout before measuring: the popover
        // is `display: none` until `showPopover()`, and some browsers
        // fire `toggle` before layout, so RAF-after-toggle is unreliable.
        // ResizeObserver fires once the browser has real dimensions.
        // Self-disconnects after one valid measurement; ongoing
        // scroll/resize is handled by the window listeners below.
        // `ResizeObserver` is missing in some non-DOM jest environments
        // (e.g. post-office's `node` environment). Fall back to a no-op
        // observer there. The scroll/resize listeners below still keep
        // the popover positioned in the rare case the consumer also
        // polyfilled `showPopover` but not `ResizeObserver`. Real
        // browsers always have it. The `NoopResizeObserver` class is
        // hoisted to module scope (see top of file) so we do not allocate
        // a new constructor on every effect run.
        const ResizeObserverImpl = typeof ResizeObserver !== 'undefined' ? ResizeObserver : $7929679938b34898$var$NoopResizeObserver;
        const resizeObserver = new ResizeObserverImpl(()=>{
            if (popover.offsetWidth > 0 && popover.offsetHeight > 0) {
                update();
                resizeObserver.disconnect();
            }
        });
        // If the popover is already open by the time this effect runs (for
        // example, the parent `useAnchorPosition` effect runs after the child
        // `Popover` effect that called `showPopover()`), the initial `toggle`
        // event has already fired and our listener below would miss it. Start
        // observing immediately so the first measurement still happens.
        if ($7929679938b34898$var$isPopoverOpen(popover)) {
            popover.style.setProperty('opacity', '0');
            resizeObserver.observe(popover);
        }
        const undoPositioning = (0, $fMmTU.combine)(cleanupBaseStyles, // On every open: hide synchronously so the user never sees
        // the UA-default position, then re-observe for a fresh
        // measurement. We use `opacity: 0` rather than
        // `visibility: hidden` because Firefox skips visibility-hidden
        // elements during `<dialog>` initial-focus traversal. See
        // `form-in-popup.spec.tsx` on `desktop-firefox`.
        (0, $lMcEJ.bind)(popover, {
            type: 'toggle',
            listener: (event)=>{
                const toggleEvent = event;
                if (toggleEvent.newState === 'open') {
                    popover.style.setProperty('opacity', '0');
                    resizeObserver.observe(popover);
                }
            }
        }), ()=>resizeObserver.disconnect(), (0, $lMcEJ.bind)(window, {
            type: 'scroll',
            listener: scheduledUpdate,
            options: {
                capture: true,
                passive: true
            }
        }), (0, $lMcEJ.bind)(window, {
            type: 'resize',
            listener: scheduledUpdate,
            options: {
                passive: true
            }
        }), ()=>{
            scheduledUpdate.cancel();
            popover.style.removeProperty('top');
            popover.style.removeProperty('left');
            popover.style.removeProperty('opacity');
        });
        return undoPositioning;
    }, [
        anchorRef,
        popoverRef,
        stablePlacement,
        forceFallbackPositioning,
        isEnabled,
        id,
        isOpen
    ]);
}

});
parcelRegister("c1P93", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c1d4060b07e0e41$export$2e2bcd8739ae039);
var $8c1d4060b07e0e41$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $8c1d4060b07e0e41$export$2e2bcd8739ae039 = $8c1d4060b07e0e41$var$rafSchd;

});

parcelRegister("hwCmR", function(module, exports) {
$parcel$export(module.exports, "computeFallbackPosition", () => $2e52fccd6e80b022$export$d5ef1dac02135664);
/**
 * JS fallback positioning math. Used only when the browser does not
 * support CSS Anchor Positioning (less than 6% of users).
 *
 * Consumer-supplied `offset.gap` and `offset.crossAxisShift` are
 * honored: the caller (`useAnchorPosition`) resolves CSS length strings
 * (tokens, calc, var, etc) to pixels via a DOM probe before passing them
 * in. The caller also keeps the popover hidden (`opacity: 0`) until the
 * first measurement completes, so the popover never paints at the wrong
 * position.
 */ /**
 * Computes the base {top, left} position based on the primary edge,
 * flipping to the opposite side when there is not enough space.
 *
 * `gap` is applied along the main axis between trigger and popover.
 */ function $2e52fccd6e80b022$var$computeEdgePosition({ axis: axis, edge: edge, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight, viewport: viewport, gap: gap }) {
    if (axis === 'block' && edge === 'end') {
        // Below trigger
        const spaceBelow = viewport.height - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        const fitsBelow = spaceBelow >= popoverHeight + gap;
        const useBelow = fitsBelow || spaceBelow >= spaceAbove;
        return {
            top: useBelow ? triggerRect.bottom + gap : triggerRect.top - popoverHeight - gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'block' && edge === 'start') {
        // Above trigger
        const spaceAbove = triggerRect.top;
        const spaceBelow = viewport.height - triggerRect.bottom;
        const fitsAbove = spaceAbove >= popoverHeight + gap;
        const useAbove = fitsAbove || spaceAbove >= spaceBelow;
        return {
            top: useAbove ? triggerRect.top - popoverHeight - gap : triggerRect.bottom + gap,
            left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
        };
    }
    if (axis === 'inline' && edge === 'end') {
        // Right of trigger
        const spaceRight = viewport.width - triggerRect.right;
        const spaceLeft = triggerRect.left;
        const fitsRight = spaceRight >= popoverWidth + gap;
        const useRight = fitsRight || spaceRight >= spaceLeft;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useRight ? triggerRect.right + gap : triggerRect.left - popoverWidth - gap
        };
    }
    if (axis === 'inline' && edge === 'start') {
        // Left of trigger
        const spaceLeft = triggerRect.left;
        const spaceRight = viewport.width - triggerRect.right;
        const fitsLeft = spaceLeft >= popoverWidth + gap;
        const useLeft = fitsLeft || spaceLeft >= spaceRight;
        return {
            top: triggerRect.top + triggerRect.height / 2 - popoverHeight / 2,
            left: useLeft ? triggerRect.left - popoverWidth - gap : triggerRect.right + gap
        };
    }
    // Unreachable for valid placements; defaults to below trigger
    return {
        top: triggerRect.bottom + gap,
        left: triggerRect.left + triggerRect.width / 2 - popoverWidth / 2
    };
}
/**
 * Adjusts the base (centered) position for non-center alignments.
 *
 * `align: 'start'` → popover start edge at trigger start edge
 * `align: 'end'`   → popover end edge at trigger end edge
 */ function $2e52fccd6e80b022$var$applyAlignment({ position: position, axis: axis, align: align, triggerRect: triggerRect, popoverWidth: popoverWidth, popoverHeight: popoverHeight }) {
    if (align === 'center') return position;
    if (axis === 'block') {
        // Block-axis placement → cross-axis is inline (left/right)
        if (align === 'start') return {
            ...position,
            left: triggerRect.left
        };
        // align === 'end'
        return {
            ...position,
            left: triggerRect.right - popoverWidth
        };
    }
    // Inline-axis placement → cross-axis is block (top/bottom)
    if (align === 'start') return {
        ...position,
        top: triggerRect.top
    };
    // align === 'end'
    return {
        ...position,
        top: triggerRect.bottom - popoverHeight
    };
}
/**
 * Applies the cross-axis shift offset.
 *
 * The sign mirrors the CSS path (see `crossAxisShiftMargin` in
 * `use-anchor-position.tsx`):
 *   - `align: 'start' | 'center'` + `forwards`  → push toward end (positive)
 *   - `align: 'end'`              + `forwards`  → push toward start (negative)
 *   - `backwards` flips the sign in both cases.
 */ function $2e52fccd6e80b022$var$applyCrossAxisShift({ position: position, axis: axis, align: align, crossAxisShift: crossAxisShift }) {
    if (crossAxisShift.value === 0) return position;
    const directionSign = crossAxisShift.direction === 'forwards' ? 1 : -1;
    const sideSign = align === 'end' ? -1 : 1;
    const delta = crossAxisShift.value * directionSign * sideSign;
    // Cross-axis is the OPPOSITE of the placement axis.
    if (axis === 'block') return {
        ...position,
        left: position.left + delta
    };
    return {
        ...position,
        top: position.top + delta
    };
}
function $2e52fccd6e80b022$export$d5ef1dac02135664({ triggerRect: triggerRect, popoverEl: popoverEl, placement: placement, viewport: viewport, gap: gap, crossAxisShift: crossAxisShift }) {
    const { axis: axis, edge: edge, align: align } = placement;
    // Measure popover dimensions. Callers must ensure the popover has
    // laid out before calling this (it should not be `display: none`).
    const popoverWidth = popoverEl.offsetWidth;
    const popoverHeight = popoverEl.offsetHeight;
    const basePosition = $2e52fccd6e80b022$var$computeEdgePosition({
        axis: axis,
        edge: edge,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight,
        viewport: viewport,
        gap: gap
    });
    const alignedPosition = $2e52fccd6e80b022$var$applyAlignment({
        position: basePosition,
        axis: axis,
        align: align,
        triggerRect: triggerRect,
        popoverWidth: popoverWidth,
        popoverHeight: popoverHeight
    });
    const shiftedPosition = $2e52fccd6e80b022$var$applyCrossAxisShift({
        position: alignedPosition,
        axis: axis,
        align: align,
        crossAxisShift: crossAxisShift
    });
    // Clamp to viewport so the popover is never offscreen
    return {
        top: Math.max(0, Math.min(shiftedPosition.top, viewport.height - popoverHeight)),
        left: Math.max(0, Math.min(shiftedPosition.left, viewport.width - popoverWidth))
    };
}

});

parcelRegister("fMmTU", function(module, exports) {
$parcel$export(module.exports, "combine", () => $29f837530584603e$export$1be1fc439b849fdf);
/**
 * Combine multiple cleanup functions into a single cleanup function.
 *
 * @example
 * ```ts
 * useEffect(() => {
 *   return combine(
 *     bind(window, { type: 'resize', listener: onResize }),
 *     bind(window, { type: 'scroll', listener: onScroll, options: { capture: true } }),
 *   );
 * }, []);
 * ```
 */ function $29f837530584603e$export$1be1fc439b849fdf(...cleanupFns) {
    return function cleanup() {
        cleanupFns.forEach((callback)=>callback === null || callback === void 0 ? void 0 : callback());
    };
}

});

parcelRegister("1JQEr", function(module, exports) {
$parcel$export(module.exports, "placementToPositionArea", () => $8f6dc6d62448c42f$export$de49b61f233ddeb9);

var $cDI63 = parcelRequire("cDI63");
function $8f6dc6d62448c42f$export$de49b61f233ddeb9({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = (0, $cDI63.getPlacement)({
        placement: placement
    });
    const edgeValue = `${axis}-${edge}`;
    if (align === 'center') return edgeValue;
    // Cross-axis name: block ↔ inline
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    // Invert align → CSS span direction: visual 'start' → span toward 'end'
    const spanDir = align === 'start' ? 'end' : 'start';
    return `${edgeValue} span-${crossAxis}-${spanDir}`;
}

});

parcelRegister("6eyns", function(module, exports) {
$parcel$export(module.exports, "placementToTryFallbacks", () => $4f6e3bead2cb047d$export$c4e16947a95d61f1);

var $cDI63 = parcelRequire("cDI63");
function $4f6e3bead2cb047d$export$c4e16947a95d61f1({ placement: placement }) {
    const { axis: axis, edge: edge, align: align } = (0, $cDI63.getPlacement)({
        placement: placement
    });
    const crossAxis = axis === 'block' ? 'inline' : 'block';
    const flippedEdge = edge === 'start' ? 'end' : 'start';
    const sameEdge = `${axis}-${edge}`;
    const oppositeEdge = `${axis}-${flippedEdge}`;
    const flipKeyword = axis === 'block' ? 'flip-block' : 'flip-inline';
    const flipCrossKeyword = axis === 'block' ? 'flip-inline' : 'flip-block';
    // Single algorithm: produce the shift list against any base alignment.
    // For `align: 'start'` the "near" shift expands toward `end`; for
    // `align: 'end'` it expands toward `start`; for `align: 'center'`
    // either order is symmetric (we use end-then-start to match the
    // historical fallback list).
    function shifts(baseAlign, edgeKey) {
        if (baseAlign === 'center') return [
            `${edgeKey} span-${crossAxis}-end`,
            `${edgeKey} span-${crossAxis}-start`
        ];
        const near = baseAlign === 'start' ? 'end' : 'start';
        const far = baseAlign === 'start' ? 'start' : 'end';
        return [
            `${edgeKey} span-${crossAxis}-${near}`,
            edgeKey,
            `${edgeKey} span-${crossAxis}-${far}`
        ];
    }
    if (align !== 'center') // Aligned (start/end): try same-edge shifts, then single-axis flip,
    // then diagonal flip for corner overflow, then opposite-edge shifts.
    // Legacy Popper fallback ordering for e.g. bottom-start:
    // [bottom, bottom-end, top-start, top, top-end, auto].
    return [
        ...shifts(align, sameEdge),
        flipKeyword,
        `${flipKeyword} ${flipCrossKeyword}`,
        ...shifts(align, oppositeEdge)
    ].join(', ');
    // Centered: same-edge shifts, single-axis flip, opposite-edge shifts.
    // Diagonal flip is unnecessary because centered placements expand
    // equally in both cross-axis directions.
    return [
        ...shifts('center', sameEdge),
        flipKeyword,
        ...shifts('center', oppositeEdge)
    ].join(', ');
}

});

parcelRegister("688Rd", function(module, exports) {
$parcel$export(module.exports, "resolveCssLengthToPixels", () => $654331fa0b84a469$export$98721546d2816d9e);
const $654331fa0b84a469$var$elementCaches = new WeakMap();
function $654331fa0b84a469$var$canCacheResolvedLength(value) {
    // Custom-property values can be retargeted by inline overrides on the
    // consumer's wrapper, so we cannot prove a cached pixel value is still valid.
    return !value.includes('var(');
}
function $654331fa0b84a469$var$getCachedResolvedLength({ element: element, value: value }) {
    if (!$654331fa0b84a469$var$canCacheResolvedLength(value)) return null;
    const cacheForElement = $654331fa0b84a469$var$elementCaches.get(element);
    return (cacheForElement === null || cacheForElement === void 0 ? void 0 : cacheForElement.get(value)) ?? null;
}
function $654331fa0b84a469$var$cacheResolvedLength({ element: element, value: value, result: result }) {
    if (!$654331fa0b84a469$var$canCacheResolvedLength(value)) return;
    const cacheForElement = $654331fa0b84a469$var$elementCaches.get(element) ?? new Map();
    cacheForElement.set(value, result);
    $654331fa0b84a469$var$elementCaches.set(element, cacheForElement);
}
function $654331fa0b84a469$export$98721546d2816d9e({ value: value, container: container }) {
    if (typeof value === 'number') return value;
    // Fast path: unitless zero is universally zero pixels - accept `'0'` and
    // `'-0'` without a probe. (Consumers occasionally pass `'0'` instead of
    // the number `0`.)
    if (value === '0' || value === '-0') return 0;
    // Fast path: bare `${n}px` strings come from the consumer normalisation
    // in `getPlacement`. Avoid a reflow when we can.
    const pxMatch = value.match(/^(-?\d+(?:\.\d+)?)px$/);
    if (pxMatch) return Number(pxMatch[1]);
    const cached = $654331fa0b84a469$var$getCachedResolvedLength({
        element: container,
        value: value
    });
    if (cached !== null) return cached;
    const probe = container.ownerDocument.createElement('div');
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';
    probe.style.height = '0';
    probe.style.padding = '0';
    probe.style.border = '0';
    // `width` clamps negatives to 0; use `margin-left` instead so signs are
    // preserved. `getComputedStyle` returns the resolved pixel value for
    // margin-* properties even when the source was a token / calc / var.
    probe.style.marginLeft = value;
    // Hide the probe from assistive tech and event targeting; defensive
    // against `getElementsByTagName('div')` walks in consumer code.
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('inert', '');
    container.appendChild(probe);
    const resolved = parseFloat(getComputedStyle(probe).marginLeft);
    container.removeChild(probe);
    const result = Number.isFinite(resolved) ? resolved : 0;
    $654331fa0b84a469$var$cacheResolvedLength({
        element: container,
        value: value,
        result: result
    });
    return result;
}

});

parcelRegister("gNpuf", function(module, exports) {
$parcel$export(module.exports, "setStyle", () => $463385d43098f5d4$export$37a5fde709c1db82);
/**
 * Sets inline styles on an element and returns a cleanup function that
 * restores the prior inline values (so we do not stomp consumer styles).
 */ function $463385d43098f5d4$export$37a5fde709c1db82({ element: element, styles: styles }) {
    // Snapshot the prior inline value (NOT the computed style - we only want
    // to restore values that the consumer/our previous run inlined). An empty
    // string means "no inline value", in which case cleanup uses removeProperty.
    const priorValues = styles.map(({ property: property })=>({
            property: property,
            value: element.style.getPropertyValue(property)
        }));
    styles.forEach(({ property: property, value: value })=>{
        element.style.setProperty(property, value);
    });
    return function cleanup() {
        priorValues.forEach(({ property: property, value: value })=>{
            if (value === '') {
                element.style.removeProperty(property);
                return;
            }
            element.style.setProperty(property, value);
        });
    };
}

});


parcelRegister("2J0Cu", function(module, exports) {
$parcel$export(module.exports, "useAnchorPositionAtPoint", () => $8b8aa5ee3b9d9930$export$6f230729189a5b8a);

var $4fqPo = parcelRequire("4fqPo");

var $jC6gp = parcelRequire("jC6gp");
/**
 * Styles the synthetic anchor as an invisible, zero-size point.
 * Dynamic `inset-*` overrides are written by the positioning effect.
 *
 * Uses `Object.assign` rather than Compiled CSS (element is outside the React tree)
 * or the internal `setStyle` helper (we own this element entirely - it is created
 * and removed by this hook - so the snapshot/restore semantics `setStyle`
 * provides for caller-owned elements would be dead work here).
 */ function $8b8aa5ee3b9d9930$var$applyStaticAnchorStyles(element) {
    Object.assign(element.style, {
        position: 'fixed',
        // `top`/`left` rather than `inset-block-start`/`inset-inline-start`
        // for consistency with the dynamic positioning effect below, which
        // uses physical properties (see comment there for the rationale).
        top: '0',
        left: '0',
        // Zero size - placement decides which side the popover sits on.
        width: '0',
        height: '0',
        // Prevent the overlay from intercepting pointer events.
        pointerEvents: 'none'
    });
}
function $8b8aa5ee3b9d9930$export$6f230729189a5b8a({ popoverRef: popoverRef, placement: placement, getPoint: getPoint, isEnabled: isEnabled = true, isOpen: isOpen }) {
    const syntheticAnchorRef = (0, $4fqPo.useRef)(null);
    // `getPoint` is kept in a ref so the layout effect can call the
    // latest version without listing it as a dep - that would re-fire
    // on every render and re-latch the point.
    const getPointRef = (0, $4fqPo.useRef)(getPoint);
    getPointRef.current = getPoint;
    // Lazy element creation: the `<div>` is only created when both
    // `isEnabled` is true AND `getPoint()` returns a non-null point.
    // `useLayoutEffect` ensures the element exists before the inner
    // `useAnchorPosition` (also a layout effect) reads the ref.
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (!isEnabled) return;
        const point = getPointRef.current();
        if (!point) return;
        const anchor = document.createElement('div');
        anchor.setAttribute('aria-hidden', 'true');
        $8b8aa5ee3b9d9930$var$applyStaticAnchorStyles(anchor);
        // `point.x`/`y` are physical viewport coordinates (from
        // `MouseEvent.clientX/Y`), so map directly onto physical
        // `left`/`top`. This is RTL-safe: `position: fixed` + physical
        // insets is direction-independent. Using logical
        // `inset-inline-start` would need `viewportWidth - point.x` in
        // RTL to land at the same physical pixel.
        anchor.style.top = `${point.y}px`;
        anchor.style.left = `${point.x}px`;
        document.body.appendChild(anchor);
        syntheticAnchorRef.current = anchor;
        return function cleanup() {
            anchor.remove();
            syntheticAnchorRef.current = null;
        };
    }, [
        isEnabled
    ]);
    // Mirror `isEnabled` so both hooks stay in sync - when disabled,
    // neither this hook nor the inner one touches the popover, leaving
    // any other positioning the consumer has set up free to take effect.
    (0, $jC6gp.useAnchorPosition)({
        anchorRef: syntheticAnchorRef,
        popoverRef: popoverRef,
        placement: placement,
        isEnabled: isEnabled,
        isOpen: isOpen
    });
}

});

parcelRegister("l9AV9", function(module, exports) {
$parcel$export(module.exports, "register", () => $c0315562097d4f38$export$6503ec6e8aabbaf);
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $lMcEJ = parcelRequire("lMcEJ");
const $c0315562097d4f38$var$registrations = new Set();
let $c0315562097d4f38$var$cleanupEndEventListeners = null;
function $c0315562097d4f38$var$onDragStart() {
    if ($c0315562097d4f38$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $c0315562097d4f38$var$cleanupEndEventListeners = (0, $lMcEJ.bindAll)(window, [
        {
            type: 'dragend',
            listener: $c0315562097d4f38$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $c0315562097d4f38$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $c0315562097d4f38$var$onDragEnd();
                };
            })()
        }
    ]);
    const clone = Array.from($c0315562097d4f38$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragStart();
    });
}
function $c0315562097d4f38$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $c0315562097d4f38$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $c0315562097d4f38$var$cleanupEndEventListeners = null;
    const clone = Array.from($c0315562097d4f38$var$registrations);
    clone.forEach((subscriber)=>{
        subscriber.onDragEnd();
    });
}
function $c0315562097d4f38$var$bindStartEvents() {
    return (0, $lMcEJ.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $c0315562097d4f38$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $c0315562097d4f38$var$onDragStart
        }
    ]);
}
let $c0315562097d4f38$var$cleanupStartEventListeners = null;
function $c0315562097d4f38$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$c0315562097d4f38$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $c0315562097d4f38$var$cleanupStartEventListeners = $c0315562097d4f38$var$bindStartEvents();
    $c0315562097d4f38$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $c0315562097d4f38$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $c0315562097d4f38$var$registrations.delete(registration);
        if ($c0315562097d4f38$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $c0315562097d4f38$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $c0315562097d4f38$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("lxTej", function(module, exports) {
$parcel$export(module.exports, "getAnchorPoint", () => $db03a4f5f16fde90$export$d26fd3d066ede49);
/**
 * Returns the trigger's X edge for inline-axis placements, or the
 * trigger's horizontal center for block-axis placements.
 *
 * Note: does not account for RTL writing modes.
 */ function $db03a4f5f16fde90$var$getTriggerEdgeX({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'inline') return placement.edge === 'start' ? triggerRect.left : triggerRect.right;
    return triggerRect.left + triggerRect.width / 2;
}
/**
 * Returns the trigger's Y edge for block-axis placements, or the
 * trigger's vertical center for inline-axis placements.
 */ function $db03a4f5f16fde90$var$getTriggerEdgeY({ triggerRect: triggerRect, placement: placement }) {
    if (placement.axis === 'block') return placement.edge === 'start' ? triggerRect.top : triggerRect.bottom;
    return triggerRect.top + triggerRect.height / 2;
}
function $db03a4f5f16fde90$export$d26fd3d066ede49({ cursor: cursor, triggerRect: triggerRect, tooltipPosition: tooltipPosition, placement: placement }) {
    if (tooltipPosition === 'mouse-y') return {
        x: $db03a4f5f16fde90$var$getTriggerEdgeX({
            triggerRect: triggerRect,
            placement: placement
        }),
        y: cursor.clientY
    };
    if (tooltipPosition === 'mouse-x') return {
        x: cursor.clientX,
        y: $db03a4f5f16fde90$var$getTriggerEdgeY({
            triggerRect: triggerRect,
            placement: placement
        })
    };
    // tooltipPosition === 'mouse'
    return {
        x: cursor.clientX,
        y: cursor.clientY
    };
}

});

parcelRegister("4giFx", function(module, exports) {
$parcel$export(module.exports, "getVirtualElementFromMousePos", () => $c4250614e277c32c$export$2e68479e0a5d8746);
function $c4250614e277c32c$export$2e68479e0a5d8746(mousePos, { targetElement: targetElement, tooltipPosition: tooltipPosition }) {
    if (tooltipPosition === 'mouse') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: mousePos.clientY,
                width: 0,
                height: 0
            })
    };
    const targetRect = targetElement.getBoundingClientRect();
    if (tooltipPosition === 'mouse-x') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: mousePos.clientX,
                y: targetRect.top,
                width: 0,
                height: targetRect.height
            })
    };
    if (tooltipPosition === 'mouse-y') return {
        getBoundingClientRect: ()=>DOMRect.fromRect({
                x: targetRect.left,
                y: mousePos.clientY,
                width: targetRect.width,
                height: 0
            })
    };
    throw new Error(`Invalid tooltip position for virtual element: ${tooltipPosition}`);
}

});

parcelRegister("a9jLr", function(module, exports) {
$parcel$export(module.exports, "show", () => $00f08c084a56470f$export$57bf213be019eeb0);

var $3H4LK = parcelRequire("3H4LK");
let $00f08c084a56470f$var$delayId = null;
function $00f08c084a56470f$var$clearScheduled() {
    if ($00f08c084a56470f$var$delayId != null) {
        window.clearTimeout($00f08c084a56470f$var$delayId);
        $00f08c084a56470f$var$delayId = null;
    }
}
function $00f08c084a56470f$var$scheduleTimeout(fn, delay) {
    $00f08c084a56470f$var$clearScheduled();
    $00f08c084a56470f$var$delayId = window.setTimeout(()=>{
        $00f08c084a56470f$var$delayId = null;
        fn();
    }, delay);
}
let $00f08c084a56470f$var$active = null;
function $00f08c084a56470f$export$57bf213be019eeb0(entry) {
    let phase = 'waiting-to-show';
    function isActive() {
        return Boolean($00f08c084a56470f$var$active && $00f08c084a56470f$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            $00f08c084a56470f$var$clearScheduled();
            $00f08c084a56470f$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            $00f08c084a56470f$var$clearScheduled();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            $00f08c084a56470f$var$clearScheduled();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide({ isImmediate: isImmediate }) {
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        // Bug in legacy path: isImmediate hide requests are ignored during waiting-to-hide,
        // meaning Escape/scroll won't instantly dismiss a tooltip that's already fading out.
        // Gated fix: only apply the immediate-hide behavior under the top-layer flag for now.
        if (phase === 'waiting-to-hide') {
            if (isImmediate && (0, $3H4LK.fg)('platform-dst-top-layer')) immediatelyHideAndDone();
            return;
        }
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        $00f08c084a56470f$var$scheduleTimeout(()=>{
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function start() {
        const shouldAlwaysFadeIn = entry.shouldAlwaysFadeIn;
        const showImmediately = Boolean($00f08c084a56470f$var$active && $00f08c084a56470f$var$active.isVisible()) && !shouldAlwaysFadeIn;
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($00f08c084a56470f$var$active) {
            $00f08c084a56470f$var$clearScheduled();
            $00f08c084a56470f$var$active.entry.hide({
                isImmediate: true
            });
            $00f08c084a56470f$var$active.entry.done();
            $00f08c084a56470f$var$active = null;
        }
        // this tooltip is now the active tooltip
        $00f08c084a56470f$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        $00f08c084a56470f$var$scheduleTimeout(show, entry.delay);
    }
    // let's get started!
    start();
    const result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePos: entry.source.type === 'mouse' ? {
            clientX: entry.source.clientX,
            clientY: entry.source.clientY
        } : null
    };
    return result;
}

});

parcelRegister("gDq4a", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1947257e7cb0ac3$export$2e2bcd8739ae039);

var $2EbMo = parcelRequire("2EbMo");
function $c1947257e7cb0ac3$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    const seed = (0, $2EbMo.useIdSeed)();
    return shouldRenderId ? `${seed(prefix)}` : undefined;
}

});
parcelRegister("2EbMo", function(module, exports) {
$parcel$export(module.exports, "useIdSeed", () => $895c480f5ebf6da6$export$6ee17796e3d70de2);

var $a4Rr2 = parcelRequire("a4Rr2");
function $895c480f5ebf6da6$export$6ee17796e3d70de2() {
    const uid = (0, $a4Rr2.useId)();
    return (id)=>`${uid}-${id.toString()}`;
}

});


parcelRegister("3fdjx", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b56ab562ac8a252$export$2e2bcd8739ae039);
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $8O3qU = parcelRequire("8O3qU");
const $9b56ab562ac8a252$var$styles = {
    base: "_2rkofajl _11c8wadc _vchhusvi _p12fp3fh _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _1q511b66 _85i51b66 _y4ti12x7 _bozg12x7 _slp31hna",
    truncate: "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c"
};
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ const $9b56ab562ac8a252$var$TooltipContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function TooltipContainer({ style: style, className: className, children: children, truncate: truncate, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role }, ref) {
    return /*#__PURE__*/ $4fqPo.createElement((0, $8O3qU.default), {
        ref: ref,
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            $9b56ab562ac8a252$var$styles.base,
            truncate && $9b56ab562ac8a252$var$styles.truncate,
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        shortcut: shortcut,
        role: role
    }, children);
});
$9b56ab562ac8a252$var$TooltipContainer.displayName = 'TooltipContainer';
var $9b56ab562ac8a252$export$2e2bcd8739ae039 = $9b56ab562ac8a252$var$TooltipContainer;

});
parcelRegister("8O3qU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e94352fcffdaec4e$export$2e2bcd8739ae039);
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $c6usJ = parcelRequire("c6usJ");
const $e94352fcffdaec4e$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ const $e94352fcffdaec4e$var$TooltipPrimitive = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function TooltipPrimitive({ style: style, className: className, children: children, placement: placement, testId: testId, onMouseOut: onMouseOut, onMouseOver: onMouseOver, id: id, shortcut: shortcut, role: role = 'tooltip' }, ref) {
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? `${testId}--wrapper` : undefined
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            "_80om73ad",
            className
        ]),
        // Because the tooltip should not be focusable, there is no reason to have key events.
        /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOut: onMouseOut,
        /* eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events */ onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children, shortcut && /*#__PURE__*/ $4fqPo.createElement((0, $c6usJ.TooltipShortcut), {
        shortcut: shortcut
    })));
});
$e94352fcffdaec4e$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $e94352fcffdaec4e$export$2e2bcd8739ae039 = $e94352fcffdaec4e$var$TooltipPrimitive;

});
parcelRegister("c6usJ", function(module, exports) {
$parcel$export(module.exports, "TooltipShortcut", () => $293dc441ce18a3d3$export$5bcbc43c84236222);
/* tooltip-shortcut.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $293dc441ce18a3d3$var$styles = {
    shortcutSegmentsContainer: "_zulpv77o _1e0c1txw _1q511b66 _85i5v77o",
    shortcutSegment: "_11c8wadc _2rkolb4i _1dqonqa1 _189ee4h9 _1h6d1ihb _1e0c1txw _4cvr1h6o _4t3i1k92 _vchhusvi _1q51v77o _85i5v77o _bozg12x7 _y4ti12x7 _16qsn7od _1254n7od _cgnln7od _syazn7od _ahbqn7od _12l2n7od _1pfhn7od _6rthn7od _1ul9n7od _w19jn7od _bfhk261p"
};
const $293dc441ce18a3d3$export$5bcbc43c84236222 = ({ shortcut: shortcut })=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $293dc441ce18a3d3$var$styles.shortcutSegmentsContainer
        ])
    }, shortcut.map((segment, index)=>/*#__PURE__*/ $4fqPo.createElement("kbd", {
            key: `${segment}-${index}`,
            className: (0, $ltgDR.default)([
                $293dc441ce18a3d3$var$styles.shortcutSegment
            ])
        }, segment)));
};

});






parcelRegister("YfxLb", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb45384f636bd8f9$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $fb45384f636bd8f9$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    error: {
        id: 'cmdb.object.card.error.loading.object',
        defaultMessage: 'Error occured loading object',
        description: 'Displayed when a value for a CMDB Assets field does not load'
    },
    expandLabel: {
        id: 'cmdb.object.card.expand.label',
        defaultMessage: 'Expand object details',
        description: 'Label for the expand button on the CMDB object field'
    },
    collapseLabel: {
        id: 'cmdb.object.card.collapse.label',
        defaultMessage: 'Collapse object details',
        description: 'Label for the collapse button on the CMDB object field'
    }
});

});






parcelRegister("2dPNI", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetricsV3", () => $d9e0232063598f7c$export$229e3124c8dc9ca9);
$parcel$export(module.exports, "startPageLoad", () => $d9e0232063598f7c$export$5244fe38dccf2e1d);
$parcel$export(module.exports, "perfMark", () => $d9e0232063598f7c$export$61a691dabeb80f51);

var $4fqPo = parcelRequire("4fqPo");

var $cRymc = parcelRequire("cRymc");

var $dvNUn = parcelRequire("dvNUn");

var $2QwCo = parcelRequire("2QwCo");

var $5MMPz = parcelRequire("5MMPz");

var $fJQMR = parcelRequire("fJQMR");

var $hCyqP = parcelRequire("hCyqP");

var $29xKq = parcelRequire("29xKq");

var $6mmHn = parcelRequire("6mmHn");

var $e5QQn = parcelRequire("e5QQn");

var $2Z0VB = parcelRequire("2Z0VB");
var $5bPKk = parcelRequire("5bPKk");
const $d9e0232063598f7c$var$PERFORMANCE_MARK_PREFIX = 'jsd.performance.profile.customer.portal';
/**
 * List of feature flags whose value has to be sent along with Browser metrics.
 */ const $d9e0232063598f7c$var$FEATURE_FLAGS_TO_REPORT = [];
const $d9e0232063598f7c$export$229e3124c8dc9ca9 = ()=>{
    var _window$JSD_CUSTOMER_;
    if (typeof window === 'undefined') return;
    /**
   * tenant and region information for UFO
   */ const region = (0, $6mmHn.getMeta)('ajs-region');
    const tenantType = (0, $6mmHn.getMeta)('ajs-is-synthetic') === 'true' ? (0, $5bPKk.TenantType).Synthetic : (0, $5bPKk.TenantType).RealUser;
    /**
   * Framework and Product Info
   */ const perimeter = (0, $dvNUn.isFedRamp)() ? (0, $cRymc.PerimeterType).FEDRAMP_MODERATE : (0, $cRymc.PerimeterType).COMMERCIAL;
    const info = {
        perimeter: perimeter,
        product: 'jira',
        app: {
            version: {
                web: ((_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || _window$JSD_CUSTOMER_ === void 0 ? void 0 : _window$JSD_CUSTOMER_.buildKey) || 'local'
            },
            framework: {
                version: $4fqPo.version,
                name: 'react'
            }
        },
        region: region !== null ? region : 'none'
    };
    /**
   * eventPipelineClient expects pre configured `analytics-web-client` promise.
   */ const endpoints = {
        eventPipelineClient: (0, $fJQMR.getAnalyticsWebClientPromise)().then((client)=>{
            return client.getInstance();
        })
    };
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (0, $fJQMR.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $2Z0VB.payloadPublisher).setup({
            product: info.product,
            app: info.app,
            region: region || info.region,
            gasv3: client.getInstance(),
            resourceTimings: (0, $5MMPz.resourceTimingsPlugin),
            featureFlags: $d9e0232063598f7c$var$FEATURE_FLAGS_TO_REPORT,
            ...tenantType && {
                tenantType: tenantType
            }
        });
    });
    (0, $2QwCo.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: {
            featureFlags: (0, $5MMPz.featureFlagsPlugin),
            resourceTimings: (0, $5MMPz.resourceTimingsPlugin)
        },
        events: {
            all: {
                featureFlags: $d9e0232063598f7c$var$FEATURE_FLAGS_TO_REPORT,
                plugins: [
                    (0, $5MMPz.customPerfMarks)
                ]
            }
        },
        ssr: {
            getDoneMark: ()=>{
                var _getMark;
                return ((_getMark = (0, $e5QQn.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) || null;
            }
        }
    });
};
let $d9e0232063598f7c$var$isInitialPageLoadTracked = false;
const $d9e0232063598f7c$export$5244fe38dccf2e1d = (screenName)=>{
    if (typeof window === 'undefined') return;
    if ((0, $hCyqP.isPageLoadInstrumented)(screenName)) {
        (0, $29xKq.devLog)('Browser metrics v3: startPageLoad() fired');
        (0, $2QwCo.browserMetrics).startPageLoad({
            isInitial: !$d9e0232063598f7c$var$isInitialPageLoadTracked
        });
    }
    if (!$d9e0232063598f7c$var$isInitialPageLoadTracked) $d9e0232063598f7c$var$isInitialPageLoadTracked = true;
};
function $d9e0232063598f7c$export$61a691dabeb80f51(shortKey) {
    let key = shortKey.trim();
    if (!key.startsWith($d9e0232063598f7c$var$PERFORMANCE_MARK_PREFIX)) key = `${$d9e0232063598f7c$var$PERFORMANCE_MARK_PREFIX}.${shortKey}`;
    window.performance && window.performance.mark && window.performance.mark(key);
}

});
parcelRegister("2QwCo", function(module, exports) {
$parcel$export(module.exports, "browserMetrics", () => $9a4e00ce51064a9e$export$c08e7affcf78b064);

var $96dcU = parcelRequire("96dcU");

var $7VGNa = parcelRequire("7VGNa");

var $gb1pK = parcelRequire("gb1pK");

var $jaz8P = parcelRequire("jaz8P");

var $1cdQf = parcelRequire("1cdQf");

var $2lYVa = parcelRequire("2lYVa");

var $gbY6t = parcelRequire("gbY6t");

var $ls3p0 = parcelRequire("ls3p0");
const $9a4e00ce51064a9e$var$makeBrowserMetrics = ()=>{
    const bm = {
        init (config) {
            var _config$events$BMEven, _config$ssr;
            (0, $jaz8P.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $ls3p0.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $1cdQf.webVitalsObserver).start();
            if (config.debug) {
                (0, $7VGNa.logger).enable();
                (0, $gbY6t.submitter).setDebug(true);
                (0, $gb1pK.pageLoadMetaMetric).setDebug(true);
            }
            (0, $gbY6t.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $96dcU.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute (newRoute) {
            (0, $2lYVa.Route).setRoute(newRoute);
        },
        startPageLoad (params) {
            (0, $gb1pK.pageLoadMetaMetric).startPageLoad({
                isInitial: false,
                cancelStarted: true,
                ...params
            });
        },
        getPageLoadMetric () {
            return 0, $gb1pK.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks (name, startMark, stopMark, initialOnly = true) {
            if (initialOnly && !(0, $gb1pK.pageLoadMetaMetric).isInitialLoad()) return;
            const start = performance.getEntriesByName(startMark);
            const stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $gb1pK.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                const pageLoadData = (0, $gb1pK.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    const startMark = start[start.length - 1];
                    const timing = {
                        startTime: Math.round(startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - startMark.startTime)
                    };
                    (0, $gb1pK.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
const $9a4e00ce51064a9e$export$c08e7affcf78b064 = $9a4e00ce51064a9e$var$makeBrowserMetrics();

});
parcelRegister("96dcU", function(module, exports) {
$parcel$export(module.exports, "SSRGetDoneMark", () => $afd0c22f6df1c66c$export$9e87a201397ac0a9);
const $afd0c22f6df1c66c$export$9e87a201397ac0a9 = {
    getDoneMark: ()=>null,
    setGetDoneMark: (fn)=>{
        $afd0c22f6df1c66c$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("7VGNa", function(module, exports) {
$parcel$export(module.exports, "logger", () => $cd1d699d01848893$export$af88d00dbe7f521);
const $cd1d699d01848893$export$af88d00dbe7f521 = {
    enabled: false,
    enable () {
        this.enabled = true;
    },
    log (...args) {
        if (this.enabled) // eslint-disable-next-line no-console
        console.log('BM log: ', ...args);
    },
    logCond (condition, ...args) {
        if (this.enabled && condition && args.length > 1) this.log(...args);
    }
};

});

parcelRegister("gb1pK", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetaMetric", () => $473a72254e7c5bc2$export$24b7a1a311eb05dc);

var $ls3p0 = parcelRequire("ls3p0");

var $9QQSZ = parcelRequire("9QQSZ");

var $3NQBM = parcelRequire("3NQBM");
class $473a72254e7c5bc2$export$9609608c00ea5077 extends (0, $3NQBM.BasePageLoadMetric) {
    startPageLoad({ cancelStarted: cancelStarted, ...startPageLoadParams } = {
        isInitial: false,
        cancelStarted: false
    }) {
        if (cancelStarted || this.state !== (0, $9QQSZ.MetricState).STARTED) super.startPageLoad(startPageLoadParams);
    }
    setActive(metric) {
        this.activePageLoadMetric = metric;
    }
    setDebug(debug) {
        this.config.debug = debug;
    }
    isDebugMode() {
        return this.config.debug;
    }
    isInitialLoad() {
        return this.isInitial;
    }
    clear() {
        this.activePageLoadMetric && this.activePageLoadMetric.cancel();
        super.clear();
    }
    include(metric) {
        if (!this.config.include) this.config.include = [
            metric
        ];
        else this.config.include.push(metric);
    }
    experimental__addExplicitTiming(name, timing) {
        if (this.explicitTimings === null) this.explicitTimings = {};
        this.explicitTimings[name] = timing;
    }
    constructor(...args){
        super(...args), this.activePageLoadMetric = null;
    }
}
const $473a72254e7c5bc2$export$24b7a1a311eb05dc = new $473a72254e7c5bc2$export$9609608c00ea5077({
    type: (0, $ls3p0.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("ls3p0", function(module, exports) {
$parcel$export(module.exports, "BMEventsType", () => $711ef7a23f7b77e3$export$9c73e297d4be9159);
$parcel$export(module.exports, "StorableBMEventsType", () => $711ef7a23f7b77e3$export$9b7037ec30489597);
$parcel$export(module.exports, "BMPageLoadMetrics", () => $711ef7a23f7b77e3$export$74c1fb0997d51e2a);
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", () => $711ef7a23f7b77e3$export$88195ac8200d03a6);
$parcel$export(module.exports, "BMInteractionMetrics", () => $711ef7a23f7b77e3$export$6e28252a002afdb2);
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", () => $711ef7a23f7b77e3$export$474154836bfd8dd9);
$parcel$export(module.exports, "PageVisibleFields", () => $711ef7a23f7b77e3$export$e89802082dab5633);
$parcel$export(module.exports, "PageVisibleValueOrigin", () => $711ef7a23f7b77e3$export$983b017156c2aee2);
$parcel$export(module.exports, "isDetailedPageLoadSlo", () => $711ef7a23f7b77e3$export$5866f95702a15142);
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", () => $711ef7a23f7b77e3$export$f087a59bd717e49d);
$parcel$export(module.exports, "isInteractionMetricsSlo", () => $711ef7a23f7b77e3$export$b10c1d9a7db7765b);
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", () => $711ef7a23f7b77e3$export$60c0193054fc3040);

var $9QQSZ = parcelRequire("9QQSZ");
var $711ef7a23f7b77e3$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $711ef7a23f7b77e3$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $711ef7a23f7b77e3$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $711ef7a23f7b77e3$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $711ef7a23f7b77e3$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $711ef7a23f7b77e3$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $711ef7a23f7b77e3$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $711ef7a23f7b77e3$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
const $711ef7a23f7b77e3$export$5866f95702a15142 = (data)=>{
    return Boolean(data.initial);
};
const $711ef7a23f7b77e3$export$f087a59bd717e49d = (data)=>{
    return Boolean(data.initial);
};
const $711ef7a23f7b77e3$export$153c4c72fa5eeece = (data)=>{
    const obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
const $711ef7a23f7b77e3$export$b10c1d9a7db7765b = (data)=>{
    const obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $711ef7a23f7b77e3$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("9QQSZ", function(module, exports) {
$parcel$export(module.exports, "MetricState", () => $4fe368424ccd055b$export$1e458f18c0c7bfe3);
$parcel$export(module.exports, "PageVisibleState", () => $4fe368424ccd055b$export$a12c67b37a306b13);
$parcel$export(module.exports, "BaseMetric", () => $4fe368424ccd055b$export$2bce4ffdd840e878);

var $3H4LK = parcelRequire("3H4LK");

var $9w9No = parcelRequire("9w9No");

var $d560n = parcelRequire("d560n");

var $7VGNa = parcelRequire("7VGNa");

var $jaz8P = parcelRequire("jaz8P");

var $6hYNG = parcelRequire("6hYNG");
var $4fe368424ccd055b$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $4fe368424ccd055b$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $4fe368424ccd055b$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? "visible" : "hidden";
}
class $4fe368424ccd055b$export$2bce4ffdd840e878 {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.onStopCallbacks = [];
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.untilOnStopCallback = null;
        this.pageVisibleState = $4fe368424ccd055b$var$getPageVisibleState();
        this.traceContext = null;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = "mixed";
        };
        var _this$config$timings;
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach((entry)=>{
            if ((0, $d560n.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn(`Entry ${entry.key} is restricted and has been renamed to custom__${entry.key}`);
                entry.key = `custom__${entry.key}`;
            }
        });
    }
    get untilMetrics() {
        const { until: until } = this.config;
        if (!until) return [];
        else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
        return this.getConfiguredUntilMetricArray([
            until
        ]);
    }
    start({ startTime: startTime = window.performance.now() } = {}) {
        this.clear();
        (0, $7VGNa.logger).logCond(!!this.config.debug, this.key, startTime);
        this.state = "started";
        this.startTime = startTime;
        this.pageVisibleState = $4fe368424ccd055b$var$getPageVisibleState();
        (0, $jaz8P.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
        this.watchUntil();
        this.startTrace(this.key);
    }
    stop(stopArguments = {}) {
        const { stopTime: stopTime = window.performance.now() } = stopArguments;
        if (this.state !== "started" || this.startTime === null) {
            (0, $7VGNa.logger).log(`metric ${this.config.key} has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopTime < this.startTime) {
            (0, $7VGNa.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${this.startTime}; stopTime: ${stopTime}`);
            return false;
        }
        this.stopTime = stopTime;
        this.state = "finished";
        this.handleStop(stopArguments);
        (0, $jaz8P.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        this.stopTrace();
        return true;
    }
    startTrace(metricKey) {
        if ((0, $3H4LK.fg)('uip_bm3_tracing')) {
            let traceContext = (0, $9w9No.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $9w9No.generateTraceId)(),
                    spanId: (0, $9w9No.generateSpanId)()
                };
                (0, $9w9No.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'bm3.' + metricKey);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $3H4LK.fg)('uip_bm3_tracing')) (0, $9w9No.clearActiveTrace)();
    }
    handleStop(stopArguments) {
        const { customData: customData = null } = stopArguments;
        if (customData) this.custom = {
            ...this.custom,
            ...customData
        };
        this.config.include && this.config.include.forEach((metric)=>{
            const included = metric.getData();
            if (included.state === "finished" && included.start !== null && included.start >= (this.startTime || 0)) this.addSubMetric(metric.getData());
        });
        this.onStopCallbacks.forEach(([success])=>{
            success(stopArguments);
        });
        this.onStopCallbacks = [];
        (0, $7VGNa.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
    }
    mark(mark, timestamp = window.performance.now()) {
        this.marks[mark] = timestamp;
    }
    cancel() {
        if (this.state !== "started") return;
        this.state = "cancelled";
        this.cancelUntil();
        this.onStopCallbacks.forEach(([, cancel])=>{
            cancel();
        });
        this.onStopCallbacks = [];
        (0, $jaz8P.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
    }
    merge(mergeData) {
        this.state = mergeData.state;
        this.pageVisibleState = mergeData.pageVisibleState;
        this.startTime = mergeData.start;
        this.stopTime = mergeData.stop;
        this.marks = {
            ...this.marks,
            ...mergeData.marks
        };
        this.submetrics = [
            ...this.submetrics,
            ...mergeData.submetrics
        ];
        this.onStopCallbacks = [
            ...this.onStopCallbacks,
            ...mergeData.onStopCallbacks
        ];
    }
    onStop(success, cancel) {
        this.onStopCallbacks.push([
            success,
            cancel
        ]);
    }
    removeOnStopCallback(success) {
        const index = this.onStopCallbacks.findIndex(([successCallback])=>{
            return success === successCallback;
        });
        if (index > -1) this.onStopCallbacks.splice(index, 1);
    }
    getData() {
        return {
            key: this.key,
            state: this.state,
            start: this.startTime,
            stop: this.stopTime,
            //todo ranges
            // ranges: this.makeRanges()
            marks: this.marks,
            // todo make copy
            custom: this.custom,
            submetrics: this.submetrics,
            config: this.config,
            route: this.route,
            pageVisibleState: this.pageVisibleState,
            type: this.config.type,
            ...(0, $3H4LK.fg)('uip_bm3_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    getDataToMerge() {
        return {
            ...this.getData(),
            onStopCallbacks: this.onStopCallbacks
        };
    }
    addSubMetric(data) {
        this.submetrics.push(data);
    }
    /**
   *
   * @param metric
   * The array of Until metrics can be of two types
   * This function returns an UntilExperience
   */ getConfiguredUntilMetric(metricOrConfig) {
        return metricOrConfig instanceof $4fe368424ccd055b$export$2bce4ffdd840e878 ? (0, $6hYNG.UntilExperience).fromMetric(metricOrConfig) : (0, $6hYNG.UntilExperience).fromConfig(metricOrConfig);
    }
    getConfiguredUntilMetricArray(metricArray) {
        if (!metricArray.length) return [];
        return metricArray.map((metric)=>this.getConfiguredUntilMetric(metric));
    }
    isUntilFinished() {
        return this.untilMetrics.every((metric)=>metric.experience.getData().state === "finished");
    }
    handleAllUntilFinished() {
        // Order by ascending stop time
        const sorted = [
            ...this.untilMetrics
        ].sort((m1, m2)=>{
            return m1.getDependencyStopTime() - m2.getDependencyStopTime();
        });
        // Find the latest page segment to become fully interactive
        const latestFullyInteractiveSegment = [
            ...this.untilMetrics
        ].reduce((currentLatestSegment, metric)=>{
            const currentLatestStopTime = (currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) ?? 0;
            const metricStopTime = metric.getFullyInteractiveStopTime() ?? 0;
            return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
        }, undefined);
        // Accumulate the custom data from each metric, later metrics take priority
        const accumulatedCustomData = {};
        sorted.forEach((metric)=>{
            Object.assign(accumulatedCustomData, metric.experience.getData().custom);
        });
        const latestSegment = sorted[sorted.length - 1];
        const latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
        this.stop({
            stopTime: latestSegment.getDependencyStopTime(),
            customData: {
                ...accumulatedCustomData,
                segment: latestSegment.getKey(),
                segmentOverrided: latestSegment.getIsSegmentLoadOverrided(),
                ...latestFullyInteractiveStopTime ? {
                    latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                    latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                } : {}
            }
        });
    }
    watchUntil() {
        if (!this.untilMetrics.length) return;
        if (this.isUntilFinished()) {
            // Already finished, handle it immediately
            this.handleAllUntilFinished();
            return;
        }
        // If not currently finished, register stop callbacks to re-check
        this.untilOnStopCallback = ()=>{
            if (this.isUntilFinished()) this.handleAllUntilFinished();
        };
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "finished") metric.experience.onStop(this.untilOnStopCallback, ()=>this.cancel());
        });
    }
    cancelUntil() {
        this.untilMetrics.forEach((metric)=>{
            if (metric.experience.getData().state !== "cancelled" && this.untilOnStopCallback) metric.experience.removeOnStopCallback(this.untilOnStopCallback);
        });
    }
    clear() {
        // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
        this.cancelUntil();
        this.state = "not-started";
        this.startTime = null;
        this.stopTime = null;
        this.marks = {};
        this.custom = null;
        this.submetrics = [];
        this.route = null;
        this.pageVisibleState = $4fe368424ccd055b$var$getPageVisibleState();
        this.traceContext = null;
    }
}

});
parcelRegister("9w9No", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $95d539cf9513b373$export$295213bc4d0c54ad);
$parcel$export(module.exports, "generateTraceId", () => $95d539cf9513b373$export$dc6d7ea554bcce10);
$parcel$export(module.exports, "setActiveTrace", () => $95d539cf9513b373$export$a1002be327997103);
$parcel$export(module.exports, "getActiveTrace", () => $95d539cf9513b373$export$b6ac780db3a3cc77);
$parcel$export(module.exports, "clearActiveTrace", () => $95d539cf9513b373$export$17ab21d7be720b);

var $Idrdz = parcelRequire("Idrdz");
var $jgvOT = parcelRequire("jgvOT");

var $du4Vf = parcelRequire("du4Vf");
function $95d539cf9513b373$var$getEnvironment() {
    // Gaurd for running in the browser - if SSR (somehow) just return prod
    if (typeof window === 'undefined') return (0, $jgvOT.envType).PROD;
    const { hostname: hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') return (0, $jgvOT.envType).LOCAL;
    if (hostname.includes('.dev.')) return (0, $jgvOT.envType).STAGING;
    if (hostname.includes('.stg.')) return (0, $jgvOT.envType).STAGING;
    return (0, $jgvOT.envType).PROD;
}
// Get an AWC so that we can record issues when setting or getting the global trace context
// Heavily borrowed from browser-storage-controls package
const $95d539cf9513b373$var$getAnalyticsClient = (()=>{
    let instance;
    return ()=>{
        if (!instance) {
            const env = $95d539cf9513b373$var$getEnvironment();
            instance = new (0, $Idrdz.default)({
                env: env,
                product: 'observability'
            });
        }
        return instance;
    };
})();
/**
 * Global state for storing the active trace context.
 * This is a simple in-memory store that maintains the current trace context
 */ const $95d539cf9513b373$var$state = {
    context: null
};
function $95d539cf9513b373$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $95d539cf9513b373$export$dc6d7ea554bcce10() {
    return Array.from(new Array(32), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $95d539cf9513b373$export$a1002be327997103(traceId, spanId, source) {
    // If trace context has already been set, there has been an experience collision
    // Don't update the trace context.
    if ($95d539cf9513b373$var$state.context !== null) $95d539cf9513b373$var$getAnalyticsClient().sendOperationalEvent({
        source: source,
        action: 'setActiveTrace',
        actionSubject: 'traceContext',
        attributes: {
            currentContext: $95d539cf9513b373$var$state.context,
            incomingContext: {
                traceId: traceId,
                spanId: spanId
            },
            status: 'collision'
        },
        tags: [
            'observability'
        ]
    });
    else $95d539cf9513b373$var$state.context = {
        traceId: traceId,
        spanId: spanId
    };
}
function $95d539cf9513b373$export$b6ac780db3a3cc77() {
    return $95d539cf9513b373$var$state.context;
}
function $95d539cf9513b373$export$17ab21d7be720b() {
    $95d539cf9513b373$var$state.context = null;
}
function $95d539cf9513b373$export$63b3d412fff54e8d() {
    const trace = $95d539cf9513b373$export$b6ac780db3a3cc77();
    if (!trace) return null;
    const { traceId: traceId, spanId: spanId } = trace;
    return (0, $du4Vf.makeTraceHttpHeaders)(traceId, spanId);
}
function $95d539cf9513b373$export$a1e7396778592551() {
    const headers = $95d539cf9513b373$export$63b3d412fff54e8d();
    return headers ? new URLSearchParams(headers).toString().toLowerCase() : null;
}

});
parcelRegister("du4Vf", function(module, exports) {
$parcel$export(module.exports, "makeTraceHttpHeaders", () => $d4702063daccf5f5$export$c7fbc6d88d400f6f);
/**
 * Creates HTTP headers from trace context.
 *
 * @param traceId - The trace ID
 * @param spanId - The span ID
 * @returns An object containing HTTP headers to add to outgoing requests in order to propagate the trace context
 */ function $d4702063daccf5f5$export$c7fbc6d88d400f6f(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
}

});


parcelRegister("d560n", function(module, exports) {
$parcel$export(module.exports, "restrictedTimingKeys", () => $702bbefb3cf6cde9$export$1d17377365286b00);
$parcel$export(module.exports, "clsWaitTimeMs", () => $702bbefb3cf6cde9$export$df21d285cfcda81e);
const $702bbefb3cf6cde9$export$1d17377365286b00 = [
    'ssr'
];
const $702bbefb3cf6cde9$export$df21d285cfcda81e = 7500;

});

parcelRegister("jaz8P", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $c8ff250a3fa0bf88$export$13e680397ec8f3eb);
class $c8ff250a3fa0bf88$var$VisibilityChangeObserver {
    start() {
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $c8ff250a3fa0bf88$export$13e680397ec8f3eb = new $c8ff250a3fa0bf88$var$VisibilityChangeObserver();

});

parcelRegister("6hYNG", function(module, exports) {
$parcel$export(module.exports, "UntilExperience", () => $f051139f577c808f$export$3fcc0936ee2cc852);
class $f051139f577c808f$export$3fcc0936ee2cc852 {
    static #_ = this.FMP = 'fmp';
    static fromConfig(config) {
        return new $f051139f577c808f$export$3fcc0936ee2cc852(config.experience, config.useFmpAsUntilStopTime);
    }
    static fromMetric(metric) {
        return new $f051139f577c808f$export$3fcc0936ee2cc852(metric);
    }
    constructor(experience, useFmpAsUntilStopTime){
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ getFmp() {
        const { marks: marks, stop: stop } = this.experience.getData();
        return marks[$f051139f577c808f$export$3fcc0936ee2cc852.FMP] ?? stop;
    }
    getDependencyStopTime() {
        if (this.useFmpAsUntilStopTime) return this.getFmp();
        return this.experience.getData().stop;
    }
    /**
   * Get the time it takes for a segment to become fully interactable,
   * regardless of whether it uses the FMP as the stop time. (Eventual load)
   */ getFullyInteractiveStopTime() {
        return this.experience.getData().stop;
    }
    getIsSegmentLoadOverrided() {
        if (this.useFmpAsUntilStopTime) {
            const { marks: marks } = this.experience.getData();
            return marks[$f051139f577c808f$export$3fcc0936ee2cc852.FMP] ? true : false;
        }
        return false;
    }
    getKey() {
        return this.experience.getData().key;
    }
}

});



parcelRegister("3NQBM", function(module, exports) {
$parcel$export(module.exports, "BasePageLoadMetric", () => $4535c4a8b1d801fd$export$fd1447b187f590fe);

var $7VGNa = parcelRequire("7VGNa");

var $9QQSZ = parcelRequire("9QQSZ");
class $4535c4a8b1d801fd$export$fd1447b187f590fe extends (0, $9QQSZ.BaseMetric) {
    static #_ = this.FMP = 'fmp';
    constructor(args){
        super(args), this.isInitial = true, this.explicitTimings = null;
        this.config = args;
    }
    start({} = {}) {
        // please use startPageLoad
        return;
    }
    startPageLoad(params = {
        isInitial: false
    }) {
        // todo this should update meta page load metric
        this.isInitial = params.isInitial;
        if (params.isInitial) super.start({
            startTime: 0
        });
        else super.start(params);
        (0, $7VGNa.logger).logCond(!!this.config.debug, this.key, this.startTime);
    }
    stopPageLoad(pageLoadMetaMetricData, stopArguments = {
        stopTime: window.performance.now()
    }) {
        if (pageLoadMetaMetricData.state !== (0, $9QQSZ.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
            (0, $7VGNa.logger).log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
            return false;
        }
        if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
            (0, $7VGNa.logger).log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
            return false;
        }
        this.merge(pageLoadMetaMetricData);
        this.stopTime = stopArguments.stopTime;
        this.state = (0, $9QQSZ.MetricState).FINISHED;
        this.handleStop(stopArguments);
        return true;
    }
    handleStop(stopArguments) {
        const { until: until } = this.config;
        const fmpWasMarked = $4535c4a8b1d801fd$export$fd1447b187f590fe.FMP in this.marks;
        if (!fmpWasMarked && until) {
            // Extract the maximum FMP value from the until metrics
            const untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                until
            ]);
            const untilFmpMarks = untilArr.map((metric)=>metric.getFmp());
            if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max(...untilFmpMarks));
        }
        super.handleStop(stopArguments);
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $4535c4a8b1d801fd$export$fd1447b187f590fe.FMP) return;
        super.mark(mark, timestamp);
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
        this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? {
            ...mergeData.explicitTimings,
            ...this.explicitTimings
        } : null;
    }
    markFMP(timestamp) {
        super.mark($4535c4a8b1d801fd$export$fd1447b187f590fe.FMP, timestamp);
    }
    getPageLoadData() {
        return {
            isInitial: this.isInitial,
            explicitTimings: this.explicitTimings
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageLoadData()
        };
    }
    clear() {
        this.explicitTimings = null;
        super.clear();
    }
}

});


parcelRegister("1cdQf", function(module, exports) {
$parcel$export(module.exports, "webVitalsObserver", () => $c4979dc176b2f504$export$253d38dccbb37615);


class $c4979dc176b2f504$var$WebVitalsObserver {
    start() {
        this.ttciDetermined = this.registerTTCI();
        this.webVitalsDetermined = this.registerWebVitals();
    }
    async registerWebVitals() {
        try {
            const { getCLS: getCLS, getFCP: getFCP, getFID: getFID, getLCP: getLCP, getTTFB: getTTFB } = await (parcelRequire("6gsja"));
            await Promise.all([
                getTTFB,
                getFID,
                getFCP,
                getLCP,
                getCLS
            ].map((fx)=>new Promise((resolve)=>{
                    fx(({ name: name, value: value })=>{
                        // round FCP, FID, LCP, TTFB to nearest integer.
                        // CLS is rounded to two decimal places.
                        const metricName = name.toLowerCase();
                        const metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                        this.data[`metric:${metricName}`] = metricValue;
                        resolve();
                    });
                })));
        } catch (e) {}
    }
    async registerTTCI() {
        try {
            const ttiPolyfill = await (parcelRequire("iQDTn"));
            await ttiPolyfill.getFirstConsistentlyInteractive().then((value)=>{
                // according to the docs:
                // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                // the promise resolves to null.
                this.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                return true;
            });
        } catch (e) {}
    }
    constructor(){
        this.data = {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        };
    }
}
const $c4979dc176b2f504$export$253d38dccbb37615 = new $c4979dc176b2f504$var$WebVitalsObserver();

});
parcelRegister("6gsja", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fGrNo").then(()=>parcelRequire('aTuUn'));

});

parcelRegister("iQDTn", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7wVax").then(()=>parcelRequire('BE3Iw'));

});


parcelRegister("2lYVa", function(module, exports) {
$parcel$export(module.exports, "Route", () => $3dec348d5637c772$export$e7b0ac011bb776c6);
const $3dec348d5637c772$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});

parcelRegister("gbY6t", function(module, exports) {
$parcel$export(module.exports, "submitter", () => $058a98ed660f774a$export$c21a25872e3f5a2b);

var $c62a8 = parcelRequire("c62a8");

var $ls3p0 = parcelRequire("ls3p0");

var $8OPAZ = parcelRequire("8OPAZ");

var $kRVif = parcelRequire("kRVif");
const $058a98ed660f774a$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure (config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $kRVif.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $ls3p0.PageVisibleFields).pageVisibleState;
    },
    setDebug (debug) {
        this.debug = debug;
    },
    async queue (data) {
        if (this.config.enableReactUFOTracker) (0, $c62a8.addBrowserMetricEvent)(data);
        if (!this.config.configChunk) {
            // eslint-disable-next-line no-console
            this.debug && console.warn('Submitter is not configured');
            return null;
        }
        const chunk = await this.config.configChunk;
        const payload = await (0, $8OPAZ.eventDataProcessor)(chunk[data.config.type], data);
        if (payload === null) return;
        if (this.config.gasv3 !== undefined) {
            const client = await this.config.gasv3;
            const attributes = {
                task: payload['event:key'],
                properties: payload
            };
            client && client.sendOperationalEvent({
                actionSubject: 'performance',
                attributes: attributes,
                source: 'performance',
                action: 'measured'
            });
        }
        return;
    }
};

});
parcelRegister("8OPAZ", function(module, exports) {
$parcel$export(module.exports, "eventDataProcessor", () => $4e3a3420a525e278$export$896b6e121bbaec25);

var $d560n = parcelRequire("d560n");

var $7VGNa = parcelRequire("7VGNa");

var $gLsUp = parcelRequire("gLsUp");

var $7JcDG = parcelRequire("7JcDG");

var $kRsyF = parcelRequire("kRsyF");

var $7I2n0 = parcelRequire("7I2n0");

var $7WZLF = parcelRequire("7WZLF");

var $d2DPd = parcelRequire("d2DPd");

var $ko3CV = parcelRequire("ko3CV");

var $21TUf = parcelRequire("21TUf");

var $gldlN = parcelRequire("gldlN");

var $fb2PF = parcelRequire("fb2PF");

var $fvkMW = parcelRequire("fvkMW");

var $8Ax1l = parcelRequire("8Ax1l");

var $3jMvJ = parcelRequire("3jMvJ");

var $9Ipyd = parcelRequire("9Ipyd");

var $jnR4u = parcelRequire("jnR4u");

var $c4Zvd = parcelRequire("c4Zvd");

var $jOGTb = parcelRequire("jOGTb");

var $lPNTH = parcelRequire("lPNTH");

var $innhU = parcelRequire("innhU");

var $9zTLw = parcelRequire("9zTLw");

var $eyzWz = parcelRequire("eyzWz");

var $cGWPw = parcelRequire("cGWPw");

var $3T4N4 = parcelRequire("3T4N4");

var $fksVR = parcelRequire("fksVR");

var $fdzgm = parcelRequire("fdzgm");

var $45bXr = parcelRequire("45bXr");

var $4MQuq = parcelRequire("4MQuq");

var $cAXle = parcelRequire("cAXle");

var $8feLb = parcelRequire("8feLb");

var $bQaH5 = parcelRequire("bQaH5");

var $2GLa2 = parcelRequire("2GLa2");

var $2dSe3 = parcelRequire("2dSe3");

var $3aG2T = parcelRequire("3aG2T");

var $9reV9 = parcelRequire("9reV9");

var $1xF9e = parcelRequire("1xF9e");

var $1P6N6 = parcelRequire("1P6N6");

var $ls3p0 = parcelRequire("ls3p0");
const $4e3a3420a525e278$var$defaultSet = [
    (0, $21TUf.eventKey),
    (0, $9Ipyd.eventType),
    (0, $fvkMW.eventProduct),
    (0, $fb2PF.eventPopulation),
    (0, $3jMvJ.eventRoute),
    (0, $d2DPd.eventId),
    (0, $gldlN.eventLocalTime),
    (0, $8Ax1l.eventRegion),
    (0, $7JcDG.appFramework),
    (0, $kRsyF.appVersion),
    (0, $7I2n0.bmVersion),
    (0, $8feLb.telemetryBrowser),
    (0, $bQaH5.telemetryCpu),
    (0, $2GLa2.telemetryMemory),
    (0, $2dSe3.telemetryNetwork),
    (0, $7WZLF.customData),
    (0, $jnR4u.featureFlags),
    (0, $c4Zvd.hostname),
    (0, $45bXr.productCustomData),
    (0, $3aG2T.appTimings),
    (0, $1xF9e.resourceTimings),
    (0, $1P6N6.traceContext)
];
const $4e3a3420a525e278$var$pageLoadCommon = [
    ...$4e3a3420a525e278$var$defaultSet,
    (0, $fksVR.pageVisibleState),
    (0, $fdzgm.pageVisibleValue),
    (0, $ko3CV.eventInitial),
    (0, $eyzWz.pageLoadMetrics),
    (0, $9reV9.bundleEvalTimings)
];
const $4e3a3420a525e278$var$initialPageLoadSet = [
    ...$4e3a3420a525e278$var$pageLoadCommon,
    (0, $lPNTH.initialPageLoadMetrics),
    (0, $9zTLw.navigationMetrics),
    (0, $cAXle.ssrSuccess),
    (0, $4MQuq.ssrFeatureFlags)
];
const $4e3a3420a525e278$var$spaTransitionSet = [
    ...$4e3a3420a525e278$var$pageLoadCommon
];
const $4e3a3420a525e278$var$pageSegmentLoadSet = [
    ...$4e3a3420a525e278$var$defaultSet,
    (0, $cGWPw.pageSegmentLoadMetrics),
    (0, $fksVR.pageVisibleState),
    (0, $fdzgm.pageVisibleValue),
    (0, $ko3CV.eventInitial),
    (0, $9reV9.bundleEvalTimings)
];
const $4e3a3420a525e278$var$interactionSet = [
    ...$4e3a3420a525e278$var$defaultSet,
    (0, $fksVR.pageVisibleState),
    (0, $fdzgm.pageVisibleValue),
    (0, $innhU.interactionMetrics)
];
const $4e3a3420a525e278$var$customMetricSet = [
    ...$4e3a3420a525e278$var$defaultSet,
    (0, $fksVR.pageVisibleState),
    (0, $fdzgm.pageVisibleValue),
    (0, $jOGTb.customEventMetrics)
];
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
const $4e3a3420a525e278$var$webVitalsMetricSet = [
    ...$4e3a3420a525e278$var$defaultSet,
    (0, $3T4N4.webVitalsMetrics)
];
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
const $4e3a3420a525e278$var$waitForCLS = (delay = (0, $d560n.clsWaitTimeMs) + 500)=>{
    return new Promise((resolve)=>setTimeout(resolve, delay));
};
const $4e3a3420a525e278$export$896b6e121bbaec25 = async (globalConfig, data)=>{
    if (data.start === null || data.stop === null) {
        (0, $7VGNa.logger).log(`eventDataProcessor: Metric "${data.key}" start or stop are incorrect; start: ${data.start}; stop: ${data.stop}`);
        return null;
    }
    let set = [];
    if (data.config.type === (0, $ls3p0.BMEventsType).PAGE_LOAD && (0, $gLsUp.isPageLoadMetricData)(data) && data.isInitial) set = $4e3a3420a525e278$var$initialPageLoadSet;
    if (data.config.type === (0, $ls3p0.BMEventsType).PAGE_LOAD && (0, $gLsUp.isPageLoadMetricData)(data) && !data.isInitial) set = $4e3a3420a525e278$var$spaTransitionSet;
    if (data.config.type === (0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD && (0, $gLsUp.isPageSegmentLoadMetricData)(data)) set = $4e3a3420a525e278$var$pageSegmentLoadSet;
    if (data.config.type === (0, $ls3p0.BMEventsType).INLINE_RESULT) set = $4e3a3420a525e278$var$interactionSet;
    if (data.config.type === (0, $ls3p0.BMEventsType).CUSTOM) set = $4e3a3420a525e278$var$customMetricSet;
    if (data.config.type === (0, $ls3p0.BMEventsType).WEB_VITALS) {
        set = $4e3a3420a525e278$var$webVitalsMetricSet;
        // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
        await $4e3a3420a525e278$var$waitForCLS();
    }
    //TODO if type is different - do not send at all
    const plugins = [];
    for (const plugin of set){
        const result = await plugin(data.config, data, // some plugins support page load specific data with special check
        globalConfig);
        if (result) plugins.push(result);
    }
    const pluginResults = await Promise.all(plugins);
    const generated = {};
    pluginResults.forEach((pluginResult)=>{
        if (pluginResult === null) return;
        Object.keys(pluginResult).forEach((key)=>{
            const keyResult = pluginResult[key];
            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
        });
    });
    return generated;
};

});
parcelRegister("gLsUp", function(module, exports) {
$parcel$export(module.exports, "isPageLoadMetricData", () => $0a19a38eed12687a$export$b0e12e7abb0bff11);
$parcel$export(module.exports, "isPageSegmentLoadMetricData", () => $0a19a38eed12687a$export$83d0099ee6dbb5b0);
$parcel$export(module.exports, "isPageLoadConfig", () => $0a19a38eed12687a$export$8672fa27ba8bba88);
$parcel$export(module.exports, "isPageSegmentLoadConfig", () => $0a19a38eed12687a$export$abe063537ef4987b);
$parcel$export(module.exports, "isInteractionConfig", () => $0a19a38eed12687a$export$ae68674b6a9353be);
$parcel$export(module.exports, "isCustomConfig", () => $0a19a38eed12687a$export$b493eb8b2ba87421);

var $ls3p0 = parcelRequire("ls3p0");
const $0a19a38eed12687a$export$b0e12e7abb0bff11 = (data)=>{
    return data.type === (0, $ls3p0.BMEventsType).PAGE_LOAD;
};
const $0a19a38eed12687a$export$83d0099ee6dbb5b0 = (data)=>{
    return data.type === (0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $0a19a38eed12687a$export$8672fa27ba8bba88 = (data)=>{
    return data.type === (0, $ls3p0.BMEventsType).PAGE_LOAD;
};
const $0a19a38eed12687a$export$abe063537ef4987b = (data)=>{
    return data.type === (0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD;
};
const $0a19a38eed12687a$export$ae68674b6a9353be = (data)=>{
    return data.type === (0, $ls3p0.BMEventsType).INLINE_RESULT;
};
const $0a19a38eed12687a$export$b493eb8b2ba87421 = (data)=>{
    return data.type === (0, $ls3p0.BMEventsType).CUSTOM;
};

});

parcelRegister("7JcDG", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $d536fe7858ce0dda$export$e34e4529b979f74c);
const $d536fe7858ce0dda$export$e34e4529b979f74c = (_config, _data, globalConfig)=>{
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("kRsyF", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $56aef8f42bd16ae7$export$82ae485178b37419);
const $56aef8f42bd16ae7$export$82ae485178b37419 = (_config, _data, globalConfig)=>{
    const pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("7I2n0", function(module, exports) {
$parcel$export(module.exports, "bmVersion", () => $8a00d8f7ec8a8b48$export$5cafa465fc876895);
const $8a00d8f7ec8a8b48$export$5cafa465fc876895 = ()=>{
    return {
        'bm:version': 3
    };
};

});

parcelRegister("7WZLF", function(module, exports) {
$parcel$export(module.exports, "customData", () => $afb8d975062bdc96$export$f7e743c7db162193);
const $afb8d975062bdc96$export$f7e743c7db162193 = (_config, data)=>{
    const custom = {};
    let changed = false;
    if (data.custom) Object.entries(data.custom).forEach(([key, value])=>{
        changed = true;
        custom[`custom:${key}`] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("d2DPd", function(module, exports) {
$parcel$export(module.exports, "eventId", () => $0a4c5ca85dcad6e6$export$aed28df7ac07d79a);
const $0a4c5ca85dcad6e6$export$aed28df7ac07d79a = (config)=>{
    return {
        'event:id': config.key
    };
};

});

parcelRegister("ko3CV", function(module, exports) {
$parcel$export(module.exports, "eventInitial", () => $63efd48af9f57cc1$export$fa8e91d436b3ef8b);

var $gLsUp = parcelRequire("gLsUp");
const $63efd48af9f57cc1$export$fa8e91d436b3ef8b = (_config, data)=>{
    if (!(0, $gLsUp.isPageLoadMetricData)(data) && !(0, $gLsUp.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("21TUf", function(module, exports) {
$parcel$export(module.exports, "eventKey", () => $5e55c48fa371d95f$export$10be2d3a558d3f88);

var $5icwZ = parcelRequire("5icwZ");
const $5e55c48fa371d95f$export$10be2d3a558d3f88 = (config, _data, globalConfig)=>{
    return {
        'event:key': `${globalConfig.product}.fe.${(0, $5icwZ.mapEventType)(config.type)}.${config.key}`
    };
};

});
parcelRegister("5icwZ", function(module, exports) {
$parcel$export(module.exports, "mapEventType", () => $f4941043b880b6fa$export$b334d07f11140768);

var $ls3p0 = parcelRequire("ls3p0");
const $f4941043b880b6fa$export$b334d07f11140768 = (type)=>{
    switch(type){
        case (0, $ls3p0.BMEventsType).CUSTOM:
            return (0, $ls3p0.StorableBMEventsType).CUSTOM;
        case (0, $ls3p0.BMEventsType).INLINE_RESULT:
            return (0, $ls3p0.StorableBMEventsType).INLINE_RESULT;
        case (0, $ls3p0.BMEventsType).PAGE_LOAD:
            return (0, $ls3p0.StorableBMEventsType).PAGE_LOAD;
        case (0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $ls3p0.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $ls3p0.BMEventsType).WEB_VITALS:
            return (0, $ls3p0.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("gldlN", function(module, exports) {
$parcel$export(module.exports, "eventLocalTime", () => $66c3899be135c56c$export$5219854ae7ec45da);

var $bqJEq = parcelRequire("bqJEq");
const $66c3899be135c56c$export$5219854ae7ec45da = ()=>({
        'event:localHour': parseInt((0, $bqJEq.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $bqJEq.default)(new Date(), 'i'), 10)
    });

});
parcelRegister("bqJEq", function(module, exports) {
$parcel$export(module.exports, "default", () => $852588c58a9956e8$export$2e2bcd8739ae039);

var $aS86U = parcelRequire("aS86U");

var $glZPY = parcelRequire("glZPY");

var $2L8Oe = parcelRequire("2L8Oe");

var $qzcIf = parcelRequire("qzcIf");

var $lO7AZ = parcelRequire("lO7AZ");

var $cfem5 = parcelRequire("cfem5");

var $ejtMj = parcelRequire("ejtMj");

var $gaR4O = parcelRequire("gaR4O");

var $9hhlF = parcelRequire("9hhlF");

var $lUVDS = parcelRequire("lUVDS");

var $atEHZ = parcelRequire("atEHZ");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $852588c58a9956e8$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $852588c58a9956e8$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $852588c58a9956e8$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $852588c58a9956e8$var$doubleQuoteRegExp = /''/g;
var $852588c58a9956e8$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $852588c58a9956e8$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $9hhlF.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $lUVDS.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $atEHZ.default);
    var firstWeekContainsDate = (0, $gaR4O.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gaR4O.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $2L8Oe.default)(dirtyDate);
    if (!(0, $aS86U.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $cfem5.default)(originalDate);
    var utcDate = (0, $glZPY.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($852588c58a9956e8$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $lO7AZ.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($852588c58a9956e8$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $852588c58a9956e8$var$cleanEscapedString(substring);
        var formatter = (0, $qzcIf.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ejtMj.isProtectedWeekYearToken)(substring)) (0, $ejtMj.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ejtMj.isProtectedDayOfYearToken)(substring)) (0, $ejtMj.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($852588c58a9956e8$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $852588c58a9956e8$var$cleanEscapedString(input) {
    var matched = input.match($852588c58a9956e8$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($852588c58a9956e8$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("aS86U", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ea53d1b3c06e049$export$2e2bcd8739ae039);

var $7QAdy = parcelRequire("7QAdy");

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");
function $7ea53d1b3c06e049$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    if (!(0, $7QAdy.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $2L8Oe.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("7QAdy", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b697bc6e30a153f$export$2e2bcd8739ae039);

var $5WRll = parcelRequire("5WRll");

var $9hhlF = parcelRequire("9hhlF");
function $5b697bc6e30a153f$export$2e2bcd8739ae039(value) {
    (0, $9hhlF.default)(1, arguments);
    return value instanceof Date || (0, $5WRll.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("glZPY", function(module, exports) {
$parcel$export(module.exports, "default", () => $be7e93179a0f0d8a$export$2e2bcd8739ae039);

var $d64iJ = parcelRequire("d64iJ");

var $9hhlF = parcelRequire("9hhlF");

var $gaR4O = parcelRequire("gaR4O");
function $be7e93179a0f0d8a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $9hhlF.default)(2, arguments);
    var amount = (0, $gaR4O.default)(dirtyAmount);
    return (0, $d64iJ.default)(dirtyDate, -amount);
}

});
parcelRegister("d64iJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $988f2c022955d9ed$export$2e2bcd8739ae039);

var $gaR4O = parcelRequire("gaR4O");

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");
function $988f2c022955d9ed$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $9hhlF.default)(2, arguments);
    var timestamp = (0, $2L8Oe.default)(dirtyDate).getTime();
    var amount = (0, $gaR4O.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("gaR4O", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc66c0673afd45b0$export$2e2bcd8739ae039);
function $bc66c0673afd45b0$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("qzcIf", function(module, exports) {
$parcel$export(module.exports, "default", () => $04fdbc9ca8d51901$export$2e2bcd8739ae039);

var $gyi5Y = parcelRequire("gyi5Y");

var $bXwHl = parcelRequire("bXwHl");

var $30GJl = parcelRequire("30GJl");

var $lPn0o = parcelRequire("lPn0o");

var $e9vT2 = parcelRequire("e9vT2");

var $ijHLd = parcelRequire("ijHLd");

var $g4mpV = parcelRequire("g4mpV");
var $04fdbc9ca8d51901$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $04fdbc9ca8d51901$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $g4mpV.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $e9vT2.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $ijHLd.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $ijHLd.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $30GJl.default)(date);
        // Padding
        return (0, $ijHLd.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $ijHLd.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $ijHLd.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $ijHLd.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $g4mpV.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $ijHLd.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $lPn0o.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $ijHLd.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $bXwHl.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $ijHLd.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $g4mpV.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $gyi5Y.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $ijHLd.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $ijHLd.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $ijHLd.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $ijHLd.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $04fdbc9ca8d51901$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $04fdbc9ca8d51901$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $04fdbc9ca8d51901$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $04fdbc9ca8d51901$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $04fdbc9ca8d51901$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $04fdbc9ca8d51901$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $g4mpV.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $g4mpV.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $ijHLd.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $ijHLd.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $g4mpV.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $g4mpV.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $g4mpV.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $04fdbc9ca8d51901$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $04fdbc9ca8d51901$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $04fdbc9ca8d51901$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $04fdbc9ca8d51901$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $04fdbc9ca8d51901$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $04fdbc9ca8d51901$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $04fdbc9ca8d51901$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $04fdbc9ca8d51901$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $04fdbc9ca8d51901$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $04fdbc9ca8d51901$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $ijHLd.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $ijHLd.default)(timestamp, token.length);
    }
};
function $04fdbc9ca8d51901$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $ijHLd.default)(minutes, 2);
}
function $04fdbc9ca8d51901$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $ijHLd.default)(Math.abs(offset) / 60, 2);
    }
    return $04fdbc9ca8d51901$var$formatTimezone(offset, dirtyDelimiter);
}
function $04fdbc9ca8d51901$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $ijHLd.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $ijHLd.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $04fdbc9ca8d51901$export$2e2bcd8739ae039 = $04fdbc9ca8d51901$var$formatters;

});
parcelRegister("gyi5Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0cddbb38db89590$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");
var $c0cddbb38db89590$var$MILLISECONDS_IN_DAY = 86400000;
function $c0cddbb38db89590$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $c0cddbb38db89590$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("bXwHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b4e919236809a15$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $azmnV = parcelRequire("azmnV");

var $fcwH2 = parcelRequire("fcwH2");

var $9hhlF = parcelRequire("9hhlF");
var $8b4e919236809a15$var$MILLISECONDS_IN_WEEK = 604800000;
function $8b4e919236809a15$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var diff = (0, $azmnV.default)(date).getTime() - (0, $fcwH2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8b4e919236809a15$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("azmnV", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b1e897242f89082$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");
function $7b1e897242f89082$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $2L8Oe.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("fcwH2", function(module, exports) {
$parcel$export(module.exports, "default", () => $b111562ff312fa93$export$2e2bcd8739ae039);

var $30GJl = parcelRequire("30GJl");

var $azmnV = parcelRequire("azmnV");

var $9hhlF = parcelRequire("9hhlF");
function $b111562ff312fa93$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    var year = (0, $30GJl.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $azmnV.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("30GJl", function(module, exports) {
$parcel$export(module.exports, "default", () => $231284895e546549$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");

var $azmnV = parcelRequire("azmnV");
function $231284895e546549$export$2e2bcd8739ae039(dirtyDate) {
    (0, $9hhlF.default)(1, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $azmnV.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $azmnV.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("lPn0o", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4034c26a3ba0f2$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $k8T8Q = parcelRequire("k8T8Q");

var $kFFr3 = parcelRequire("kFFr3");

var $9hhlF = parcelRequire("9hhlF");
var $fe4034c26a3ba0f2$var$MILLISECONDS_IN_WEEK = 604800000;
function $fe4034c26a3ba0f2$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $9hhlF.default)(1, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var diff = (0, $k8T8Q.default)(date, options).getTime() - (0, $kFFr3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $fe4034c26a3ba0f2$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("k8T8Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea9f53fcca4efc5c$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");

var $gaR4O = parcelRequire("gaR4O");

var $lUVDS = parcelRequire("lUVDS");
function $ea9f53fcca4efc5c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9hhlF.default)(1, arguments);
    var defaultOptions = (0, $lUVDS.getDefaultOptions)();
    var weekStartsOn = (0, $gaR4O.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $2L8Oe.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("lUVDS", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $ff4b8a7bb4bec86f$export$430a3269e24b912e);
var $ff4b8a7bb4bec86f$var$defaultOptions = {};
function $ff4b8a7bb4bec86f$export$430a3269e24b912e() {
    return $ff4b8a7bb4bec86f$var$defaultOptions;
}
function $ff4b8a7bb4bec86f$export$95365be1b0704abc(newOptions) {
    $ff4b8a7bb4bec86f$var$defaultOptions = newOptions;
}

});


parcelRegister("kFFr3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0c7c72ddd1f06de$export$2e2bcd8739ae039);

var $e9vT2 = parcelRequire("e9vT2");

var $9hhlF = parcelRequire("9hhlF");

var $k8T8Q = parcelRequire("k8T8Q");

var $gaR4O = parcelRequire("gaR4O");

var $lUVDS = parcelRequire("lUVDS");
function $f0c7c72ddd1f06de$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9hhlF.default)(1, arguments);
    var defaultOptions = (0, $lUVDS.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gaR4O.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $e9vT2.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $k8T8Q.default)(firstWeek, options);
    return date;
}

});
parcelRegister("e9vT2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4daa3f8afcb46e6$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");

var $k8T8Q = parcelRequire("k8T8Q");

var $gaR4O = parcelRequire("gaR4O");

var $lUVDS = parcelRequire("lUVDS");
function $a4daa3f8afcb46e6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9hhlF.default)(1, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $lUVDS.getDefaultOptions)();
    var firstWeekContainsDate = (0, $gaR4O.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $k8T8Q.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $k8T8Q.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("ijHLd", function(module, exports) {
$parcel$export(module.exports, "default", () => $d55bf241e0ac80ea$export$2e2bcd8739ae039);
function $d55bf241e0ac80ea$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("g4mpV", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb2e689f89eb5097$export$2e2bcd8739ae039);

var $ijHLd = parcelRequire("ijHLd");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $bb2e689f89eb5097$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $ijHLd.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $ijHLd.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $ijHLd.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $ijHLd.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $ijHLd.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $ijHLd.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $ijHLd.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $ijHLd.default)(fractionalSeconds, token.length);
    }
};
var $bb2e689f89eb5097$export$2e2bcd8739ae039 = $bb2e689f89eb5097$var$formatters;

});


parcelRegister("lO7AZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe0428cfde4acaf7$export$2e2bcd8739ae039);
var $fe0428cfde4acaf7$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $fe0428cfde4acaf7$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $fe0428cfde4acaf7$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $fe0428cfde4acaf7$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $fe0428cfde4acaf7$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $fe0428cfde4acaf7$var$timeLongFormatter(timePattern, formatLong));
};
var $fe0428cfde4acaf7$var$longFormatters = {
    p: $fe0428cfde4acaf7$var$timeLongFormatter,
    P: $fe0428cfde4acaf7$var$dateTimeLongFormatter
};
var $fe0428cfde4acaf7$export$2e2bcd8739ae039 = $fe0428cfde4acaf7$var$longFormatters;

});

parcelRegister("ejtMj", function(module, exports) {
$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $a6b9f064495510e1$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $a6b9f064495510e1$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $a6b9f064495510e1$export$8073c1ae88f0e727);
var $a6b9f064495510e1$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $a6b9f064495510e1$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $a6b9f064495510e1$export$c6cc36aa33304772(token) {
    return $a6b9f064495510e1$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a6b9f064495510e1$export$c6b49d6dceb604a1(token) {
    return $a6b9f064495510e1$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a6b9f064495510e1$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("atEHZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a0c30b2fe2dbc4c$export$2e2bcd8739ae039);

var $9VzUj = parcelRequire("9VzUj");
var $7a0c30b2fe2dbc4c$export$2e2bcd8739ae039 = (0, $9VzUj.default);

});
parcelRegister("9VzUj", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a54a60f42d99c6$export$2e2bcd8739ae039);

var $3ebE6 = parcelRequire("3ebE6");

var $l8I8e = parcelRequire("l8I8e");

var $l8mTv = parcelRequire("l8mTv");

var $90gpy = parcelRequire("90gpy");

var $jPQs1 = parcelRequire("jPQs1");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $73a54a60f42d99c6$var$locale = {
    code: 'en-US',
    formatDistance: (0, $3ebE6.default),
    formatLong: (0, $l8I8e.default),
    formatRelative: (0, $l8mTv.default),
    localize: (0, $90gpy.default),
    match: (0, $jPQs1.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $73a54a60f42d99c6$export$2e2bcd8739ae039 = $73a54a60f42d99c6$var$locale;

});
parcelRegister("3ebE6", function(module, exports) {
$parcel$export(module.exports, "default", () => $259bb6818ff7c7da$export$2e2bcd8739ae039);
var $259bb6818ff7c7da$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $259bb6818ff7c7da$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $259bb6818ff7c7da$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $259bb6818ff7c7da$export$2e2bcd8739ae039 = $259bb6818ff7c7da$var$formatDistance;

});

parcelRegister("l8I8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $f63c93fa6bc51b84$export$2e2bcd8739ae039);

var $r4skQ = parcelRequire("r4skQ");
var $f63c93fa6bc51b84$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $f63c93fa6bc51b84$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f63c93fa6bc51b84$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f63c93fa6bc51b84$var$formatLong = {
    date: (0, $r4skQ.default)({
        formats: $f63c93fa6bc51b84$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $r4skQ.default)({
        formats: $f63c93fa6bc51b84$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $r4skQ.default)({
        formats: $f63c93fa6bc51b84$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f63c93fa6bc51b84$export$2e2bcd8739ae039 = $f63c93fa6bc51b84$var$formatLong;

});
parcelRegister("r4skQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0515fa9a97d1531e$export$2e2bcd8739ae039);
function $0515fa9a97d1531e$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("l8mTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $f62c1aa6ef4818fc$export$2e2bcd8739ae039);
var $f62c1aa6ef4818fc$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $f62c1aa6ef4818fc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f62c1aa6ef4818fc$var$formatRelativeLocale[token];
};
var $f62c1aa6ef4818fc$export$2e2bcd8739ae039 = $f62c1aa6ef4818fc$var$formatRelative;

});

parcelRegister("90gpy", function(module, exports) {
$parcel$export(module.exports, "default", () => $68e0d8116c709728$export$2e2bcd8739ae039);

var $74S1Y = parcelRequire("74S1Y");
var $68e0d8116c709728$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $68e0d8116c709728$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $68e0d8116c709728$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $68e0d8116c709728$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $68e0d8116c709728$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $68e0d8116c709728$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $68e0d8116c709728$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $68e0d8116c709728$var$localize = {
    ordinalNumber: $68e0d8116c709728$var$ordinalNumber,
    era: (0, $74S1Y.default)({
        values: $68e0d8116c709728$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $74S1Y.default)({
        values: $68e0d8116c709728$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $74S1Y.default)({
        values: $68e0d8116c709728$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $74S1Y.default)({
        values: $68e0d8116c709728$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $74S1Y.default)({
        values: $68e0d8116c709728$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $68e0d8116c709728$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $68e0d8116c709728$export$2e2bcd8739ae039 = $68e0d8116c709728$var$localize;

});
parcelRegister("74S1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $5272d187e58250b6$export$2e2bcd8739ae039);
function $5272d187e58250b6$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("jPQs1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e70b776e37005544$export$2e2bcd8739ae039);

var $ht9XV = parcelRequire("ht9XV");

var $8VW8M = parcelRequire("8VW8M");
var $e70b776e37005544$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $e70b776e37005544$var$parseOrdinalNumberPattern = /\d+/i;
var $e70b776e37005544$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $e70b776e37005544$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $e70b776e37005544$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $e70b776e37005544$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e70b776e37005544$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $e70b776e37005544$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e70b776e37005544$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $e70b776e37005544$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $e70b776e37005544$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $e70b776e37005544$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $e70b776e37005544$var$match = {
    ordinalNumber: (0, $8VW8M.default)({
        matchPattern: $e70b776e37005544$var$matchOrdinalNumberPattern,
        parsePattern: $e70b776e37005544$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ht9XV.default)({
        matchPatterns: $e70b776e37005544$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e70b776e37005544$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ht9XV.default)({
        matchPatterns: $e70b776e37005544$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e70b776e37005544$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ht9XV.default)({
        matchPatterns: $e70b776e37005544$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e70b776e37005544$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ht9XV.default)({
        matchPatterns: $e70b776e37005544$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e70b776e37005544$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ht9XV.default)({
        matchPatterns: $e70b776e37005544$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e70b776e37005544$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e70b776e37005544$export$2e2bcd8739ae039 = $e70b776e37005544$var$match;

});
parcelRegister("ht9XV", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb7ce00c72f0c803$export$2e2bcd8739ae039);
function $cb7ce00c72f0c803$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $cb7ce00c72f0c803$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $cb7ce00c72f0c803$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $cb7ce00c72f0c803$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $cb7ce00c72f0c803$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("8VW8M", function(module, exports) {
$parcel$export(module.exports, "default", () => $6810bf22f30f8f60$export$2e2bcd8739ae039);
function $6810bf22f30f8f60$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("fb2PF", function(module, exports) {
$parcel$export(module.exports, "eventPopulation", () => $c64631a309abb9c5$export$9086dbeda9b1d633);
const $c64631a309abb9c5$export$9086dbeda9b1d633 = (_config, _data, globalConfig)=>{
    if (!globalConfig.population) return {};
    return {
        'event:population': `${globalConfig.population}`
    };
};

});

parcelRegister("fvkMW", function(module, exports) {
$parcel$export(module.exports, "eventProduct", () => $391a785e9f3631a6$export$a7df4e8088db8843);
const $391a785e9f3631a6$export$a7df4e8088db8843 = (_config, _data, globalConfig)=>{
    return {
        'event:product': `${globalConfig.product}`
    };
};

});

parcelRegister("8Ax1l", function(module, exports) {
$parcel$export(module.exports, "eventRegion", () => $958938a8f3cb7dd9$export$d0117b71adcdebc0);
const $958938a8f3cb7dd9$export$d0117b71adcdebc0 = (_config, _data, globalConfig)=>{
    return {
        'event:region': `${globalConfig.region}`
    };
};

});

parcelRegister("3jMvJ", function(module, exports) {
$parcel$export(module.exports, "eventRoute", () => $d960f7965b0b15e8$export$44d3627af289ca16);
const $d960f7965b0b15e8$export$44d3627af289ca16 = (_config, data)=>{
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("9Ipyd", function(module, exports) {
$parcel$export(module.exports, "eventType", () => $cd6a3c351d5f41ad$export$4c045e605d532c98);

var $5icwZ = parcelRequire("5icwZ");
const $cd6a3c351d5f41ad$export$4c045e605d532c98 = (config)=>{
    return {
        'event:type': (0, $5icwZ.mapEventType)(config.type)
    };
};

});

parcelRegister("jnR4u", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $2655b2459cf6ff44$export$e62953d023125748);
const $2655b2459cf6ff44$export$e62953d023125748 = (config, _data, globalConfig)=>{
    var _config$featureFlags;
    const localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce((acc, ffName)=>{
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: {
            ...localFeatureFlags,
            ...globalConfig.featureFlags
        }
    };
};

});

parcelRegister("c4Zvd", function(module, exports) {
$parcel$export(module.exports, "hostname", () => $86462f1f61c2f2c6$export$640106f6dc7d2706);
const $86462f1f61c2f2c6$export$640106f6dc7d2706 = (_config, _data, globalConfig)=>{
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("jOGTb", function(module, exports) {
$parcel$export(module.exports, "customEventMetrics", () => $9c0be897d7e1fce7$export$cab039265c52a2e9);

var $gLsUp = parcelRequire("gLsUp");
const $9c0be897d7e1fce7$export$cab039265c52a2e9 = (config, data, globalConfig)=>{
    var _config$slo, _config$histogram;
    if (!(0, $gLsUp.isCustomConfig)(config)) return null;
    const payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("lPNTH", function(module, exports) {
$parcel$export(module.exports, "initialPageLoadMetrics", () => $8fe33a5598d34d80$export$cc95aa3f6ea8e5cb);
const $8fe33a5598d34d80$export$cc95aa3f6ea8e5cb = ()=>{
    const metrics = {};
    performance.getEntriesByType('paint').forEach((entry)=>{
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("innhU", function(module, exports) {
$parcel$export(module.exports, "interactionMetrics", () => $501b3c2fd0901f50$export$86db56030b57ba34);

var $gLsUp = parcelRequire("gLsUp");

var $ls3p0 = parcelRequire("ls3p0");
const $501b3c2fd0901f50$export$86db56030b57ba34 = (config, data, globalConfig)=>{
    var _config$histogram;
    if (!(0, $gLsUp.isInteractionConfig)(config)) return null;
    const result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $ls3p0.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $ls3p0.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $ls3p0.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            const histogram = globalConfig.histogram;
            if (histogram.result !== undefined) result['metric:response:histogramBuckets'] = histogram[(0, $ls3p0.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $ls3p0.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("9zTLw", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $629b0df44ce0eaa2$export$b88d990436be0f8a);
const $629b0df44ce0eaa2$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("eyzWz", function(module, exports) {
$parcel$export(module.exports, "pageLoadMetrics", () => $ac8f7bfcf7462937$export$2878bf482e539059);

var $gLsUp = parcelRequire("gLsUp");

var $ls3p0 = parcelRequire("ls3p0");
const $ac8f7bfcf7462937$var$getThreshold = (isInitial, metric)=>{
    return (0, $ls3p0.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $ac8f7bfcf7462937$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $ac8f7bfcf7462937$export$2878bf482e539059 = (config, data, globalConfig)=>{
    if (!(0, $gLsUp.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    const fmp = data.marks[(0, $ls3p0.BMPageLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $ac8f7bfcf7462937$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $ac8f7bfcf7462937$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $ac8f7bfcf7462937$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $ac8f7bfcf7462937$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        const threshold = $ac8f7bfcf7462937$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        const threshold = $ac8f7bfcf7462937$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    return result;
};

});

parcelRegister("cGWPw", function(module, exports) {
$parcel$export(module.exports, "pageSegmentLoadMetrics", () => $fe12e606da5ffa8f$export$ba86cb47f2f22db5);

var $gb1pK = parcelRequire("gb1pK");

var $gLsUp = parcelRequire("gLsUp");

var $ls3p0 = parcelRequire("ls3p0");
const $fe12e606da5ffa8f$var$getThreshold = (isInitial, metric)=>{
    return (0, $ls3p0.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
const $fe12e606da5ffa8f$var$getHistogram = (isInitial, metric, histogram)=>{
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
const $fe12e606da5ffa8f$export$ba86cb47f2f22db5 = (config, data, globalConfig)=>{
    var _config$slo, _config$slo2;
    if (!(0, $gLsUp.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    const fmp = data.marks[(0, $ls3p0.BMPageSegmentLoadMetrics).fmp] || data.stop;
    const result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $fe12e606da5ffa8f$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $fe12e606da5ffa8f$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        const histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $fe12e606da5ffa8f$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $fe12e606da5ffa8f$var$getHistogram(data.isInitial, (0, $ls3p0.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        const threshold = $fe12e606da5ffa8f$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        const threshold = $fe12e606da5ffa8f$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= threshold;
        result['metric:tti:slo:threshold'] = threshold;
    }
    if (config.includePageLoadTimings === (0, $ls3p0.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $ls3p0.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        const pageLoadData = (0, $gb1pK.pageLoadMetaMetric).getData();
        const fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $ls3p0.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        const tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("3T4N4", function(module, exports) {
$parcel$export(module.exports, "webVitalsMetrics", () => $b7bd03e9245ad06e$export$3731db279f590f30);

var $9QQSZ = parcelRequire("9QQSZ");

var $jaz8P = parcelRequire("jaz8P");

var $1cdQf = parcelRequire("1cdQf");

var $fdzgm = parcelRequire("fdzgm");
const $b7bd03e9245ad06e$export$3731db279f590f30 = async (config, data, globalConfig)=>{
    var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
    let pageVisibleState = data.pageVisibleState;
    const setPageVisibleStateToMixed = ()=>{
        pageVisibleState = (0, $9QQSZ.PageVisibleState).MIXED;
    };
    (0, $jaz8P.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
    const ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
    const webVitalMetrics = await $b7bd03e9245ad06e$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
    (0, $jaz8P.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
    return {
        ...webVitalMetrics,
        'pageVisible:state': pageVisibleState,
        ...(0, $fdzgm.pageVisibleValue)(config, data, globalConfig)
    };
};
const $b7bd03e9245ad06e$export$193ae490b52081dd = async (ttciEnabled, timeout)=>{
    // wait for webVitalsObserver.ttciDetermined if ttciEnabled is true
    await (ttciEnabled ? (0, $1cdQf.webVitalsObserver).ttciDetermined : Promise.resolve());
    // wait up to $timeout ms longer for web-vitals until returning
    const timeoutWindow = new Promise((resolve)=>setTimeout(resolve, timeout));
    await Promise.race([
        timeoutWindow,
        (0, $1cdQf.webVitalsObserver).webVitalsDetermined
    ]);
    return (0, $1cdQf.webVitalsObserver).data;
};

});
parcelRegister("fdzgm", function(module, exports) {
$parcel$export(module.exports, "pageVisibleValue", () => $17245e8f6b491dff$export$177b923114656380);

var $9QQSZ = parcelRequire("9QQSZ");
var $ls3p0 = parcelRequire("ls3p0");
const $17245e8f6b491dff$export$177b923114656380 = (_config, data, globalConfig)=>{
    const value = globalConfig.pageVisibleValueOrigin === (0, $ls3p0.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $9QQSZ.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("fksVR", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $a07c28f2706c7fbb$export$723b4c298aca63af);
const $a07c28f2706c7fbb$export$723b4c298aca63af = (_config, data)=>{
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("45bXr", function(module, exports) {
$parcel$export(module.exports, "productCustomData", () => $6aabf9814165435f$export$fa2af6e412815a74);
const $6aabf9814165435f$export$fa2af6e412815a74 = async (_config, data, globalConfig)=>{
    if (!globalConfig.custom && !globalConfig.plugins) return null;
    const result = {};
    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(([key, value])=>{
        result[`${globalConfig.product}:${key}`] = value;
    });
    if (globalConfig.plugins) {
        const pluginOutputs = await Promise.all(globalConfig.plugins.map((plugin)=>plugin({
                start: data.start,
                stop: data.stop,
                key: data.key
            })));
        pluginOutputs.forEach((pluginOutput)=>{
            if (pluginOutput === null) return;
            Object.entries(pluginOutput).forEach(([key, value])=>{
                result[`${globalConfig.product}:${key}`] = value;
            });
        });
    }
    return result;
};

});

parcelRegister("4MQuq", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $1d4453c453396657$export$fdbea518c19dfa8);

var $ls3p0 = parcelRequire("ls3p0");
const $1d4453c453396657$var$retrieveFeatureFlags = async (getFeatureFlags)=>{
    try {
        const featureFlags = await getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};
const $1d4453c453396657$export$fdbea518c19dfa8 = async (config, _data, globalConfig)=>{
    var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
    // no config or missing
    if (!((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags)) return null;
    const includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $ls3p0.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
    if (includeFeatureFlags === (0, $ls3p0.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $ls3p0.IncludeSSRFeatureFlagsConfig).WHEN_FMP) return await $1d4453c453396657$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
    return null;
};

});

parcelRegister("cAXle", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $35aef32c3a79670b$export$a3dc8251cf55b2e0);
const $35aef32c3a79670b$export$a3dc8251cf55b2e0 = (config, _data, globalConfig)=>{
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("8feLb", function(module, exports) {
$parcel$export(module.exports, "telemetryBrowser", () => $fa2e992af0dabe89$export$386b10ac64a50b1);

var $hh89M = parcelRequire("hh89M");
const $fa2e992af0dabe89$export$386b10ac64a50b1 = ()=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hh89M))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($hh89M))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("hh89M", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("bQaH5", function(module, exports) {
$parcel$export(module.exports, "telemetryCpu", () => $59dad9900236dda3$export$9f84cb359ed29139);
const $59dad9900236dda3$export$9f84cb359ed29139 = ()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("2GLa2", function(module, exports) {
$parcel$export(module.exports, "telemetryMemory", () => $4c50b002020c170c$export$496c14d72b257e07);
const $4c50b002020c170c$export$496c14d72b257e07 = ()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("2dSe3", function(module, exports) {
$parcel$export(module.exports, "telemetryNetwork", () => $468bf328e968f4aa$export$88bf7b55f7fc4e8e);
const $468bf328e968f4aa$export$88bf7b55f7fc4e8e = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("3aG2T", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $8eed9fa1afc73bc2$export$e952f50a4f2d02da);

var $ls3p0 = parcelRequire("ls3p0");

var $eMuFQ = parcelRequire("eMuFQ");

var $iISuJ = parcelRequire("iISuJ");
const $8eed9fa1afc73bc2$export$e952f50a4f2d02da = (config, data, globalConfig)=>{
    const explicitTimings = config.type === (0, $ls3p0.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    const timings = (0, $eMuFQ.customTimings)(config, data);
    const ssr = config.type === (0, $ls3p0.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $iISuJ.ssrTimings)(config, data, globalConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("eMuFQ", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $7c05aa31a837729b$export$6126f85083a72c6e);

var $hEOjK = parcelRequire("hEOjK");
const $7c05aa31a837729b$var$retrieveTimings = (config, data, relativeTo = 0, prefix = '')=>{
    const configTimings = config.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        const startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        const duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries[`${prefix}${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $7c05aa31a837729b$export$6126f85083a72c6e = (config, data)=>{
    if (!config.timings && data.submetrics.length === 0) return null;
    const timings = $7c05aa31a837729b$var$retrieveTimings(config, data);
    data.submetrics.forEach((submetric)=>{
        if (submetric.start !== null && submetric.stop !== null) {
            const submetricPrefix = `include:${submetric.config.key}`;
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $7c05aa31a837729b$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $hEOjK.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("hEOjK", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $dad3d2610dca084f$export$b98e411ae80c806f);
const $dad3d2610dca084f$export$b98e411ae80c806f = '/';

});


parcelRegister("iISuJ", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $73e63e0f4bd4c02b$export$130f411261a599c5);

var $hEOjK = parcelRequire("hEOjK");
const $73e63e0f4bd4c02b$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $73e63e0f4bd4c02b$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $73e63e0f4bd4c02b$var$SSR_PREFIX = 'ssr';
const $73e63e0f4bd4c02b$var$mapKey = (key)=>{
    if (key === 'total') return $73e63e0f4bd4c02b$var$SSR_PREFIX;
    return `${$73e63e0f4bd4c02b$var$SSR_PREFIX}${0, $hEOjK.NESTED_METRIC_SEPARATOR}${key}`;
};
const $73e63e0f4bd4c02b$export$130f411261a599c5 = (_config, _data, globalConfig)=>{
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    const timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($73e63e0f4bd4c02b$var$filterEntry(entry[1])) acc[$73e63e0f4bd4c02b$var$mapKey(entry[0])] = $73e63e0f4bd4c02b$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("9reV9", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $6d5aeed034af3624$export$1a2bb347935fc536);
const $6d5aeed034af3624$var$bundleEvalTimingsInternal = (_config, data, globalConfig, performance = window.performance)=>{
    const started = {};
    const timings = {};
    const enableBundleEvalTimings = (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) ?? true;
    performance.getEntriesByType('mark').forEach((mark)=>{
        if (!globalConfig.bundleEvalTimings) return;
        const result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        const { type: type, name: name } = result;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        const result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
const $6d5aeed034af3624$export$1a2bb347935fc536 = (...args)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve($6d5aeed034af3624$var$bundleEvalTimingsInternal(...args));
        });
    });
};

});

parcelRegister("1xF9e", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $e4872df1e98635f5$export$81a7d52441a06b50);
const $e4872df1e98635f5$var$cacheableTypes = [
    'script',
    'link'
];
const $e4872df1e98635f5$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $e4872df1e98635f5$var$CACHE_NETWORK = 'network';
const $e4872df1e98635f5$var$CACHE_MEMORY = 'memory';
const $e4872df1e98635f5$var$CACHE_DISK = 'disk';
const $e4872df1e98635f5$var$calculateTransferType = (type, duration, size)=>{
    if (!$e4872df1e98635f5$var$cacheableTypes.includes(type)) return $e4872df1e98635f5$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $e4872df1e98635f5$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $e4872df1e98635f5$var$CACHE_DISK;
    if (size === undefined) return null;
    return $e4872df1e98635f5$var$CACHE_NETWORK;
};
const $e4872df1e98635f5$var$hasAccessToResourceSize = (url, type, hasTimingHeaders)=>{
    return !$e4872df1e98635f5$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
const $e4872df1e98635f5$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $e4872df1e98635f5$var$withoutHeaders = ()=>false;
const $e4872df1e98635f5$var$evaluateAccessToResourceTimings = (entry)=>{
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
const $e4872df1e98635f5$var$getEvaluatedTimingHeader = (entry, enabled = false, hasTimingHeaders = $e4872df1e98635f5$var$withoutHeaders)=>{
    if (!enabled) return null;
    const manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    const autoResolution = $e4872df1e98635f5$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
const $e4872df1e98635f5$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $e4872df1e98635f5$var$getNetworkData = (item, eventStart, hasTimingHeaders = $e4872df1e98635f5$var$withoutHeaders)=>{
    const { name: name, duration: duration, transferSize: size, initiatorType: type, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$e4872df1e98635f5$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($e4872df1e98635f5$var$cacheableTypes.includes(type)) {
        const transferType = $e4872df1e98635f5$var$calculateTransferType(type, duration, size);
        if (!transferType) return {
            ttfb: ttfb,
            ...$e4872df1e98635f5$var$getSizeObject(size)
        };
        if (transferType !== $e4872df1e98635f5$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$e4872df1e98635f5$var$getSizeObject(size)
        };
    }
    return {
        ttfb: ttfb,
        ...$e4872df1e98635f5$var$getSizeObject(size)
    };
};
const $e4872df1e98635f5$export$81a7d52441a06b50 = (_config, data, globalConfig, performance = window.performance)=>{
    if (data.start === null) return null;
    const resources = performance.getEntriesByType('resource').filter((entry)=>entry.startTime >= data.start);
    if (!resources.length) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = globalConfig.resourceTimings;
    const reportedInitiatorTypes = $e4872df1e98635f5$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: type } = item;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $e4872df1e98635f5$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type,
            ...$e4872df1e98635f5$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders),
            ...$e4872df1e98635f5$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});

parcelRegister("1P6N6", function(module, exports) {
$parcel$export(module.exports, "traceContext", () => $56481741b1de55fa$export$90f20fc1d8cfb95b);
const $56481741b1de55fa$export$90f20fc1d8cfb95b = (_config, data, _globalConfig)=>{
    if (!data.traceContext) return null;
    return {
        tracingContext: {
            'X-B3-TraceId': data.traceContext.traceId,
            'X-B3-SpanId': data.traceContext.spanId
        }
    };
};

});


parcelRegister("kRVif", function(module, exports) {
$parcel$export(module.exports, "makeShareableGlobalConfig", () => $999080fb244f91d3$export$5b4fb14409a2a825);

var $ls3p0 = parcelRequire("ls3p0");
const $999080fb244f91d3$var$makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags)=>{
    const featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push(...allFeatureFlags);
    if (eventTypeFeatureFlags) featureFlagsForType.push(...eventTypeFeatureFlags);
    return featureFlagsForType;
};
const $999080fb244f91d3$var$makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig)=>{
    const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    const eventConfigCustom = eventConfig && eventConfig.custom;
    const custom = (allEventsConfigCustom || eventConfigCustom) && {
        ...allEventsConfigCustom,
        ...eventConfigCustom
    } || undefined;
    const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    const eventConfigPlugins = eventConfig && eventConfig.plugins;
    const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [
        ...allEventsConfigPlugins || [],
        ...eventConfigPlugins || []
    ] || undefined;
    const pageVisibleValueOrigin = (eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) ?? (allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) ?? (0, $ls3p0.PageVisibleValueOrigin).documentHidden;
    return Object.freeze({
        ...global,
        featureFlags: Object.freeze($999080fb244f91d3$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value)=>{
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    });
};
const $999080fb244f91d3$export$5b4fb14409a2a825 = async (globalConfig)=>{
    var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
    const ffClient = await globalConfig.plugins.featureFlags.client;
    const global = {
        app: globalConfig.info.app,
        product: globalConfig.info.product,
        region: globalConfig.info.region,
        resourceTimings: globalConfig.plugins.resourceTimings,
        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
        ffClient: ffClient,
        hostname: globalConfig.info.hostname || window.location.hostname,
        ssr: globalConfig.ssr,
        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
        webVitals: {
            enabled: (_globalConfig$events$ = globalConfig.events[(0, $ls3p0.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $ls3p0.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $ls3p0.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
        }
    };
    return {
        [(0, $ls3p0.BMEventsType).PAGE_LOAD]: $999080fb244f91d3$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $ls3p0.BMEventsType).PAGE_LOAD]),
        [(0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD]: $999080fb244f91d3$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD]),
        [(0, $ls3p0.BMEventsType).INLINE_RESULT]: $999080fb244f91d3$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $ls3p0.BMEventsType).INLINE_RESULT]),
        [(0, $ls3p0.BMEventsType).CUSTOM]: $999080fb244f91d3$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $ls3p0.BMEventsType).CUSTOM]),
        [(0, $ls3p0.BMEventsType).WEB_VITALS]: $999080fb244f91d3$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $ls3p0.BMEventsType).WEB_VITALS])
    };
};

});



parcelRegister("5MMPz", function(module, exports) {
$parcel$export(module.exports, "featureFlagsPlugin", () => $536975031edd44f5$export$79626a094e303f80);
$parcel$export(module.exports, "resourceTimingsPlugin", () => $536975031edd44f5$export$8c43ac1c32352978);
$parcel$export(module.exports, "customPerfMarks", () => $536975031edd44f5$export$960f38db9936e6ea);

var $6bGmX = parcelRequire("6bGmX");

var $29xKq = parcelRequire("29xKq");

var $29qmE = parcelRequire("29qmE");

var $6aEBs = parcelRequire("6aEBs");
const $536975031edd44f5$export$e5bb225813e92c1f = (url)=>url.includes('jsm-portal-frontend');
const $536975031edd44f5$export$79626a094e303f80 = {
    client: Promise.resolve({
        getValue: (featureFlagName)=>{
            return (0, $6bGmX.default).checkGate(featureFlagName);
        }
    })
};
const $536975031edd44f5$export$6dfc8bfc2349f367 = (url)=>{
    const { isProcessed: isProcessed, url: processedUrl } = (0, $6aEBs.processUrl)(url, []);
    if (!isProcessed) {
        (0, $29xKq.devLog)(`Unsanitised URL: ${processedUrl}`);
        return 'unknown';
    }
    return processedUrl;
};
const $536975031edd44f5$export$8c43ac1c32352978 = {
    hasTimingHeaders: $536975031edd44f5$export$e5bb225813e92c1f,
    sanitiseEndpoints: $536975031edd44f5$export$6dfc8bfc2349f367,
    mapResources: (0, $29qmE.sanitizeAssetName)(false)
};
function $536975031edd44f5$export$960f38db9936e6ea() {
    var _window$performance, _window$performance$g;
    const marks = {};
    const entries = (_window$performance = window.performance) === null || _window$performance === void 0 || (_window$performance$g = _window$performance.getEntriesByType) === null || _window$performance$g === void 0 ? void 0 : _window$performance$g.call(_window$performance, 'mark');
    if (entries && entries.length > 0) entries.forEach((entry)=>{
        const key = `mark__${entry.name}`;
        const value = Math.floor(entry.startTime);
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        marks[key] = value;
    });
    return marks;
}

});
parcelRegister("29qmE", function(module, exports) {
$parcel$export(module.exports, "sanitizeAssetName", () => $dd244ebb5c86989d$export$715967a06dea6152);
/**
 * Webpack dev assets without hashes
 */ const $dd244ebb5c86989d$var$webpackDevAssetsRegexp = /(.*)\.(?:chunk|bundle)(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * Webpack prod assets with hashes
 */ const $dd244ebb5c86989d$var$webpackProdAssetsRegexp = /(.*)\.(?:chunk|bundle)\..*(_[a-z]+-[A-Z]+)?\.js$/;
/**
 * jira.webresources:calendar.js asset with localization string
 */ const $dd244ebb5c86989d$var$calendarWRMRegexp = /(jira.webresources:calendar)(-[a-z]+).js$/;
/**
 * This returns the base name of the asset/url that is getting loaded.
 * eg: for: https://<your-domain>/assets/servicedesk-vendor.chunk.js
 * return servicedesk-vendor.chunk.js
 * @param assetPathOrURL all the external asset/path urls,  eg: anything refereced using <link>, <script> etc tag
 */ const $dd244ebb5c86989d$var$getBaseName = (assetPathOrURL)=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop() || '';
const $dd244ebb5c86989d$export$715967a06dea6152 = (isDevelopment)=>(assetPathOrURL)=>{
        const assetBaseName = $dd244ebb5c86989d$var$getBaseName(assetPathOrURL);
        const webpackAssetsMatch = assetBaseName.match(isDevelopment ? $dd244ebb5c86989d$var$webpackDevAssetsRegexp : $dd244ebb5c86989d$var$webpackProdAssetsRegexp);
        if (webpackAssetsMatch) return `${webpackAssetsMatch[1]}.js`;
        const calendarWRMMatch = assetBaseName.match($dd244ebb5c86989d$var$calendarWRMRegexp);
        if (calendarWRMMatch) return `${calendarWRMMatch[1]}.js`;
        return assetBaseName;
    };

});

parcelRegister("6aEBs", function(module, exports) {
$parcel$export(module.exports, "processUrl", () => $3effa56197e79f8e$export$8378cb52a6ed7e05);
class $3effa56197e79f8e$export$b323b8cc3ace981b {
    /**
   * Processes URLs that match a given pattern.
   *
   * @param pattern The pattern to match the URL against
   * @param onMatch The action to perform on the URL
   */ constructor(options){
        this.hasMatched = false;
        this.name = options.name;
        this.onMatch = options.onMatch;
        this.pattern = options.pattern;
    }
    /**
   * True if the last URL processed matched the processor's pattern.
   */ getHasMatched() {
        return this.hasMatched;
    }
    /**
   * The name of the processor.
   */ getName() {
        return this.name;
    }
    /**
   * Attempt to process the URL.
   *
   * If the URL matches the processor's pattern, then the URL is processed
   * and `hasMatched` is set to true. Otherwise, return the URL as is, and
   * set `hasMatched` to false.
   *
   * @param url The URL to process
   * @returns The URL (processed if the pattern matched, otherwise as-is)
   */ process(url) {
        const match = url.match(this.pattern);
        if (match) {
            this.hasMatched = true;
            const processedUrl = this.onMatch(url, match);
            return processedUrl;
        }
        this.hasMatched = false;
        return url;
    }
}
const $3effa56197e79f8e$export$8378cb52a6ed7e05 = (url, processors)=>{
    for (const processor of processors){
        const processedUrl = processor.process(url);
        if (processor.getHasMatched()) return {
            url: processedUrl,
            isProcessed: true
        };
    }
    return {
        url: url,
        isProcessed: false
    };
};

});


parcelRegister("hCyqP", function(module, exports) {
$parcel$export(module.exports, "isPageLoadInstrumented", () => $f792f997a830a17b$export$f571430402d3e925);
$parcel$export(module.exports, "default", () => $f792f997a830a17b$export$2e2bcd8739ae039);

var $hn5Pa = parcelRequire("hn5Pa");

var $748yq = parcelRequire("748yq");
const $f792f997a830a17b$export$8d6ac02b84099d24 = ()=>{
    if (window.__IS_PAGE_SERVER_SIDE_RENDERED__) return {
        ssr: {
            doneAsFmp: true
        }
    };
    return {};
};
/**
 * Object containing page load metric for all instrumented screens,
 * as we instrument BM3 for more screens we update values here
 * all new keys will follow the `service-management.help-center.[screenName]` schema
 * and can be accessed using `jira.fe.page-load.service-management.help-center.[screenName]`
 */ const $f792f997a830a17b$var$perfConfig = {
    [(0, $748yq.ScreenName).HELP_CENTER]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-help-center',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).PORTAL_REORDER_SETTINGS]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-reorder-settings',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).VIEW_TOPIC]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.view-topic',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).EDIT_TOPIC]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.edit-topic',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).EDIT_HOMEPAGE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.edit-homepage',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-knowledge-resources',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).ADD_HELP_CONTENT_EXTERNAL_LINKS]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.add-help-content-external-links',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).UNIFIED_HELP_HOME_PAGE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.unified-help-center.home-page',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).HELP_CENTERS_MANAGEMENT]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.help-centers-management',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).HELP_HUBS_MANAGEMENT]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.help-hubs-management',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    })
};
const $f792f997a830a17b$var$bm3BatchOneMetrics = {
    [(0, $748yq.ScreenName).REQUEST_LIST]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-requests',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).LOGIN]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-login',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).KNOWLEDGE_ARTICLE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.knowledge-article',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).LOGIN_SINGLE_SIGN_ON]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-single-sign-on',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).SIGNUP]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-signup',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).APPROVAL_LIST]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-approvals',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).KNOWLEDGE_CATEGORY]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.category-page',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).USER_PROFILE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-profile',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).CHECK_EMAIL]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-validate-email',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).COMPLETE_SIGNUP]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).RESET_PASSWORD]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-reset-password',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).INVITED_SIGNUP]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-accept-invite',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).COMPLETE_SIGNUP_TOKEN_INVALID]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-invalid',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).COMPLETE_SIGNUP_TOKEN_EXPIRED]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-complete-signup-token-expired',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-login-forgot-password-confirmation',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).CONSENT_FORM_PAGE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.user-consent',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    })
};
const $f792f997a830a17b$var$bm3BatchTwoMetrics = {
    [(0, $748yq.ScreenName).REQUEST_DETAILS]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-details',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).REQUEST_CREATE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-create',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).PORTAL_HOME]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.single-portal',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).REQUEST_GROUP]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.request-group',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).REQUEST_GROUP_LIST]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.request-group-list',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).FEEDBACK]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.request-create-anonymous-success',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).UNSUBSCRIBE]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-unsubscribe-confirmation',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    }),
    [(0, $748yq.ScreenName).FEEDBACK_SUBMITTED]: (0, $hn5Pa.metrics).pageLoad({
        key: 'service-management.help-center.portal-request-feedback-comment-submitted',
        ...$f792f997a830a17b$export$8d6ac02b84099d24()
    })
};
Object.assign($f792f997a830a17b$var$perfConfig, $f792f997a830a17b$var$bm3BatchOneMetrics, $f792f997a830a17b$var$bm3BatchTwoMetrics);
const $f792f997a830a17b$export$f571430402d3e925 = (screenName)=>{
    if (!screenName) return false;
    return $f792f997a830a17b$var$perfConfig.hasOwnProperty(screenName);
};
var $f792f997a830a17b$export$2e2bcd8739ae039 = $f792f997a830a17b$var$perfConfig;

});
parcelRegister("hn5Pa", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $d543e2a2e1a19df0$export$b0c5c2fac8144e54);

var $RwY2g = parcelRequire("RwY2g");

var $4qoq9 = parcelRequire("4qoq9");
const $d543e2a2e1a19df0$export$b0c5c2fac8144e54 = {
    pageLoad: $4qoq9.pageLoad,
    pageSegmentLoad: $4qoq9.pageSegmentLoad,
    interaction: $4qoq9.interaction,
    custom: $4qoq9.custom,
    concurrent: $RwY2g.concurrent
};

});
parcelRegister("RwY2g", function(module, exports) {
$parcel$export(module.exports, "concurrent", () => $80aa7403d3a7cd70$export$370df09ecc3de059);

var $ls3p0 = parcelRequire("ls3p0");

var $4qoq9 = parcelRequire("4qoq9");
const $80aa7403d3a7cd70$var$concurrentMetrics = {};
const $80aa7403d3a7cd70$var$getKey = (config, type)=>`${type}--${config.key}`;
const $80aa7403d3a7cd70$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $80aa7403d3a7cd70$var$ensurePath = (config, type)=>{
    const key = $80aa7403d3a7cd70$var$getKey(config, type);
    if (!(key in $80aa7403d3a7cd70$var$concurrentMetrics)) $80aa7403d3a7cd70$var$concurrentMetrics[key] = {};
};
const $80aa7403d3a7cd70$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $80aa7403d3a7cd70$var$getKey(config, type);
    if (concurrentKey in $80aa7403d3a7cd70$var$concurrentMetrics && $80aa7403d3a7cd70$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $80aa7403d3a7cd70$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $80aa7403d3a7cd70$var$concurrentMetrics)) $80aa7403d3a7cd70$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $80aa7403d3a7cd70$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $80aa7403d3a7cd70$var$validateConfig(config);
    $80aa7403d3a7cd70$var$ensurePath(config, type);
    const metricFromCache = $80aa7403d3a7cd70$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $ls3p0.BMEventsType).INLINE_RESULT ? (0, $4qoq9.interaction) : (0, $4qoq9.custom);
    const metric = metricFactory(config);
    $80aa7403d3a7cd70$var$concurrentMetrics[$80aa7403d3a7cd70$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $80aa7403d3a7cd70$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$80aa7403d3a7cd70$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$80aa7403d3a7cd70$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $ls3p0.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$80aa7403d3a7cd70$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $ls3p0.BMEventsType).CUSTOM)
};

});
parcelRegister("4qoq9", function(module, exports) {
$parcel$export(module.exports, "pageLoad", () => $1290d94883225ef2$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageSegmentLoad", () => $1290d94883225ef2$export$94114666844d5f66);
$parcel$export(module.exports, "interaction", () => $1290d94883225ef2$export$92473e6020ad89b4);
$parcel$export(module.exports, "custom", () => $1290d94883225ef2$export$4c00f665f0d4b443);

var $3d8Ew = parcelRequire("3d8Ew");

var $5CZ8P = parcelRequire("5CZ8P");

var $hhEj9 = parcelRequire("hhEj9");

var $ls3p0 = parcelRequire("ls3p0");
const $1290d94883225ef2$export$791d520f7e8058a5 = (config)=>{
    return new (0, $5CZ8P.PageLoadMetric)({
        ...config,
        type: (0, $ls3p0.BMEventsType).PAGE_LOAD
    });
};
const $1290d94883225ef2$export$94114666844d5f66 = (config)=>{
    return new (0, $hhEj9.PageSegmentLoadMetric)({
        ...config,
        type: (0, $ls3p0.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $1290d94883225ef2$export$92473e6020ad89b4 = (config)=>{
    return new (0, $3d8Ew.Metric)({
        ...config,
        type: (0, $ls3p0.BMEventsType).INLINE_RESULT
    });
};
const $1290d94883225ef2$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $3d8Ew.Metric)({
        ...config,
        type: (0, $ls3p0.BMEventsType).CUSTOM
    });
};

});
parcelRegister("3d8Ew", function(module, exports) {
$parcel$export(module.exports, "Metric", () => $5bca87a93b09ee01$export$efdd3e096bc27746);

var $2lYVa = parcelRequire("2lYVa");

var $gbY6t = parcelRequire("gbY6t");

var $9QQSZ = parcelRequire("9QQSZ");
class $5bca87a93b09ee01$export$efdd3e096bc27746 extends (0, $9QQSZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $2lYVa.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $gbY6t.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}

});

parcelRegister("5CZ8P", function(module, exports) {
$parcel$export(module.exports, "PageLoadMetric", () => $4b54ee2f3d32c367$export$3c51073271a9eac3);

var $96dcU = parcelRequire("96dcU");

var $7VGNa = parcelRequire("7VGNa");

var $2lYVa = parcelRequire("2lYVa");

var $gbY6t = parcelRequire("gbY6t");

var $ls3p0 = parcelRequire("ls3p0");

var $3NQBM = parcelRequire("3NQBM");

var $gb1pK = parcelRequire("gb1pK");

var $6lZEX = parcelRequire("6lZEX");
class $4b54ee2f3d32c367$export$3c51073271a9eac3 extends (0, $3NQBM.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $gb1pK.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        var _this$config$ssr;
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $gb1pK.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $gb1pK.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[(0, $3NQBM.BasePageLoadMetric).FMP]) {
                const mark = (0, $96dcU.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $gb1pK.pageLoadMetaMetric).markFMP(mark);
            } else (0, $gb1pK.pageLoadMetaMetric).markFMP(this.marks[(0, $3NQBM.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $2lYVa.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $gbY6t.submitter).queue(data);
        (0, $7VGNa.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $gb1pK.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $gb1pK.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $gb1pK.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        var _configChunk$BMEvents;
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $gbY6t.submitter).config.configChunk;
        if (!(configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $ls3p0.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled)) return false;
        const webVitalMetric = new (0, $6lZEX.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $gbY6t.submitter).queue(webVitalMetric.getData());
        (0, $7VGNa.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}

});
parcelRegister("6lZEX", function(module, exports) {
$parcel$export(module.exports, "WebVitalsMetric", () => $8937c3f8c92bd4c0$export$dc0d85d4d6503cd7);

var $ls3p0 = parcelRequire("ls3p0");

var $9QQSZ = parcelRequire("9QQSZ");
class $8937c3f8c92bd4c0$export$dc0d85d4d6503cd7 extends (0, $9QQSZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $ls3p0.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $9QQSZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}

});


parcelRegister("hhEj9", function(module, exports) {
$parcel$export(module.exports, "PageSegmentLoadMetric", () => $8e492231ff3753e8$export$24c8bfcd77494cc1);

var $96dcU = parcelRequire("96dcU");

var $ls3p0 = parcelRequire("ls3p0");

var $9QQSZ = parcelRequire("9QQSZ");

var $3d8Ew = parcelRequire("3d8Ew");

var $gb1pK = parcelRequire("gb1pK");
class $8e492231ff3753e8$export$24c8bfcd77494cc1 extends (0, $3d8Ew.Metric) {
    static #_ = this.FMP = 'fmp';
    constructor(config){
        super(config), this.isInitial = true;
        this.config = config;
    }
    startFromPageLoad() {
        const pageLoadMetaData = (0, $gb1pK.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $8e492231ff3753e8$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($8e492231ff3753e8$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        var _this$config$ssr;
        const pageLoadData = (0, $gb1pK.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
            if (!this.marks[$8e492231ff3753e8$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $96dcU.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $ls3p0.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $9QQSZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $9QQSZ.MetricState).STARTED) (0, $gb1pK.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
}

});





parcelRegister("e5QQn", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $9923db8919d6b748$export$f45af69d005a6ed);
const $9923db8919d6b748$export$f45af69d005a6ed = (markName)=>{
    if (!performance.getEntriesByName) return null;
    const marks = performance.getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};

});

parcelRegister("2Z0VB", function(module, exports) {
$parcel$export(module.exports, "payloadPublisher", () => $f4b765de9fc4ae71$export$edb879ae55bb9be3);

var $3H4LK = parcelRequire("3H4LK");

var $bdtMB = parcelRequire("bdtMB");
var $hkVbV = parcelRequire("hkVbV");

var $2uYvC = parcelRequire("2uYvC");

var $fWi4d = parcelRequire("fWi4d");

var $6ZJBZ = parcelRequire("6ZJBZ");

var $hoZoB = parcelRequire("hoZoB");

var $5bPKk = parcelRequire("5bPKk");

var $73ZrL = parcelRequire("73ZrL");

var $hepeg = parcelRequire("hepeg");

var $3qaYU = parcelRequire("3qaYU");

var $ggl1m = parcelRequire("ggl1m");

var $fjJik = parcelRequire("fjJik");

var $YW7ml = parcelRequire("YW7ml");

var $UAFee = parcelRequire("UAFee");

var $1fo1x = parcelRequire("1fo1x");

var $kKTUg = parcelRequire("kKTUg");

var $t5tod = parcelRequire("t5tod");

var $8u7Vb = parcelRequire("8u7Vb");

var $K0gEt = parcelRequire("K0gEt");

var $4Ys1i = parcelRequire("4Ys1i");

var $lI7Zx = parcelRequire("lI7Zx");

var $b2cNg = parcelRequire("b2cNg");

var $5l4Hj = parcelRequire("5l4Hj");
var $f4b765de9fc4ae71$var$_getWindowObject;
const $f4b765de9fc4ae71$var$UNKNOWN_VALUE = 'unknown';
const $f4b765de9fc4ae71$var$DEFAULT_PAYLOAD_DATA = {
    schemaVersion: $f4b765de9fc4ae71$var$UNKNOWN_VALUE,
    id: $f4b765de9fc4ae71$var$UNKNOWN_VALUE,
    uuid: $f4b765de9fc4ae71$var$UNKNOWN_VALUE,
    state: {
        id: $f4b765de9fc4ae71$var$UNKNOWN_VALUE
    },
    result: {
        startTime: 0,
        duration: 0,
        success: false
    },
    type: (0, $bdtMB.ExperienceTypes).Experience,
    category: $f4b765de9fc4ae71$var$UNKNOWN_VALUE,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).Custom,
    metadata: {},
    explicitTimings: {},
    metrics: {
        startTime: 0,
        endTime: 0,
        marks: []
    },
    platform: null,
    children: [],
    pageVisibleState: (0, $6ZJBZ.PageVisibleState).MIXED,
    isSSROutputAsFMP: false,
    timings: [],
    featureFlags: []
};
class $f4b765de9fc4ae71$var$Publisher {
    publish(data) {
        var _getPerformanceObject, _getPerformanceObject2, _getPerformanceObject3;
        const payloadStart = ((_getPerformanceObject = (0, $5l4Hj.getPerformanceObject)()) === null || _getPerformanceObject === void 0 ? void 0 : _getPerformanceObject.now()) || 0;
        const experienceKey = this.getExperienceKey(data);
        if (!this.allowlist(experienceKey, data)) {
            (0, $fWi4d.ufowarn)(`experience ${experienceKey} does not meet requirements of allowlist`);
            return;
        }
        // it is used to setup default properties on the data to prevent errors
        const supportedData = {
            ...$f4b765de9fc4ae71$var$DEFAULT_PAYLOAD_DATA,
            ...data
        };
        const payload = {
            actionSubject: 'experience',
            action: 'measured',
            source: 'measured',
            tags: [
                'observability'
            ],
            attributes: {
                properties: {
                    'event:source': {
                        name: 'ufo/web',
                        version: supportedData.schemaVersion
                    },
                    'event:schema': (0, $hoZoB.UFO_BUILD_VERSION) || $f4b765de9fc4ae71$var$UNKNOWN_VALUE,
                    'event:product': this.product,
                    'event:region': this.region,
                    'event:hostname': this.hostname,
                    'event:route': this.route.getRoute(),
                    ...(0, $UAFee.eventBrowserPlugin)(),
                    ...(0, $1fo1x.eventCpusPlugin)(),
                    ...(0, $t5tod.eventMemoryPlugin)(),
                    ...(0, $8u7Vb.eventNetworkPlugin)(),
                    ...(0, $fjJik.appFramework)(this.app),
                    ...(0, $YW7ml.appVersion)(this.app),
                    'experience:name': supportedData.id,
                    // platform.fe.page-load|interaction|custom|page-segment.editor
                    'experience:key': experienceKey,
                    'experience:status': supportedData.state.id,
                    'experience:duration': supportedData.result.duration,
                    ...supportedData.result.startTime !== null ? {
                        'experience:startTime': supportedData.result.startTime
                    } : null,
                    ...supportedData.uuid ? {
                        'experience:spanId': supportedData.uuid
                    } : null,
                    ...this.tenantType !== (0, $5bPKk.TenantType).RealUser ? {
                        'event:tenantType': this.tenantType
                    } : null,
                    ...this.mapMetadataToPayload(supportedData.metadata),
                    ...this.extractPageLoadData(supportedData),
                    ...(0, $3qaYU.pageVisibleState)(supportedData),
                    ...(0, $b2cNg.isInitialPageLoad)(supportedData) && (0, $4Ys1i.ssrSuccess)(this.ssr),
                    ...(0, $b2cNg.isInitialPageLoad)(supportedData) && (0, $K0gEt.ssrFeatureFlags)(this.ssr),
                    ...this.featureFlagClient && (0, $kKTUg.featureFlags)(this.featureFlagClient, this.featureFlags, supportedData)
                },
                performance: {
                    ...this.getPerformanceMetrics(supportedData),
                    ...supportedData.traceContext && (0, $3H4LK.fg)('ufo_v1_tracing_2') ? {
                        'ufo:tracingContext': {
                            'X-B3-TraceId': supportedData.traceContext.traceId,
                            'X-B3-SpanId': supportedData.traceContext.spanId,
                            browserTimeOrigin: ((_getPerformanceObject2 = (0, $5l4Hj.getPerformanceObject)()) === null || _getPerformanceObject2 === void 0 ? void 0 : _getPerformanceObject2.timeOrigin) ?? 0
                        }
                    } : null
                },
                task: supportedData.id
            }
        };
        const payloadEnd = ((_getPerformanceObject3 = (0, $5l4Hj.getPerformanceObject)()) === null || _getPerformanceObject3 === void 0 ? void 0 : _getPerformanceObject3.now()) || 0;
        payload.attributes.performance.payloadTime = payloadEnd - payloadStart;
        if (this.gasv3) this.gasv3.sendOperationalEvent(payload);
        else this.buffer.push(payload);
        (0, $fWi4d.ufolog)('PAYLOAD:', JSON.stringify(payload, null, 2));
    }
    setGlobalEventStream() {
        if (!((0, $2uYvC.getGlobalEventStream)() instanceof (0, $73ZrL.UFOGlobalEventStream))) {
            const eventStream = new (0, $73ZrL.UFOGlobalEventStream)();
            eventStream.push({
                type: (0, $6ZJBZ.UFOGlobalEventStreamEventType).SUBSCRIBE,
                payload: {
                    experienceId: '__SUBSCRIBE_ALL__',
                    callback: this.publish.bind(this)
                }
            });
            (0, $2uYvC.setGlobalEventStream)(eventStream);
        }
    }
    setRoute(newRoute) {
        this.route.setRoute(newRoute);
    }
    setup(config) {
        (0, $hkVbV.visibilityChangeObserver).start();
        (0, $ggl1m.resourceTimingBuffer).start();
        if (!this.product) this.product = config.product || '';
        if (config.allowlist) this.allowlist = config.allowlist;
        if (config.tenantType) this.tenantType = config.tenantType;
        if (config.hostname) this.hostname = config.hostname;
        if (config.region) this.region = config.region;
        if (config.app) this.app = config.app;
        if (config.featureFlagClient) this.featureFlagClient = config.featureFlagClient;
        if (config.featureFlags) this.featureFlags = config.featureFlags;
        if (config.ssr) this.ssr = config.ssr;
        if (config.bundleEvalTimings) this.bundleEvalTimings = config.bundleEvalTimings;
        if (config.resourceTimings) this.resourceTimings = config.resourceTimings;
        if (config.performanceConfig) this.performanceConfig = config.performanceConfig;
        if (config.plugins) this.plugins = config.plugins;
        this.setGlobalEventStream();
        if (!this.gasv3) {
            this.gasv3 = config.gasv3;
            this.buffer.forEach(this.gasv3.sendOperationalEvent);
        }
    }
    mapMetadataToPayload(metadata) {
        const payload = {};
        Object.entries(metadata).forEach(([key, value])=>{
            if (value !== undefined) payload[`custom:${key}`] = value;
        });
        return payload;
    }
    extractPageLoadData(data) {
        if ('initial' in data) return {
            'experience:pageLoadType': data.initial ? 'initial' : 'transition'
        };
        return {};
    }
    getPrefix(data) {
        if (data.platform !== null) return 'platform';
        return this.product;
    }
    getExperienceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.type
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceKey(data) {
        const keyParts = [
            this.getPrefix(data),
            'fe',
            data.performanceType
        ];
        if (data.platform) keyParts.push(data.platform.component);
        keyParts.push(data.id);
        return keyParts.join('.');
    }
    getExperiencePerformanceType(data) {
        return data.performanceType;
    }
    getPerformanceMetrics(data) {
        return {
            'event:key': this.getExperiencePerformanceKey(data),
            'event:type': this.getExperiencePerformanceType(data),
            ...(0, $hepeg.getPerformancePayload)(data, this.ssr, this.bundleEvalTimings, this.resourceTimings, this.performanceConfig),
            ...this.getPluginsMetrics(data)
        };
    }
    constructor(){
        this.gasv3 = null;
        this.product = '';
        this.region = $f4b765de9fc4ae71$var$UNKNOWN_VALUE;
        this.hostname = (($f4b765de9fc4ae71$var$_getWindowObject = (0, $5l4Hj.getWindowObject)()) === null || $f4b765de9fc4ae71$var$_getWindowObject === void 0 || ($f4b765de9fc4ae71$var$_getWindowObject = $f4b765de9fc4ae71$var$_getWindowObject.location) === null || $f4b765de9fc4ae71$var$_getWindowObject === void 0 ? void 0 : $f4b765de9fc4ae71$var$_getWindowObject.hostname) || '';
        this.tenantType = (0, $5bPKk.TenantType).RealUser;
        this.app = {
            version: {
                web: $f4b765de9fc4ae71$var$UNKNOWN_VALUE
            }
        };
        this.performanceConfig = {};
        this.buffer = [];
        this.featureFlagClient = null;
        this.featureFlags = [];
        this.ssr = null;
        this.resourceTimings = null;
        this.bundleEvalTimings = null;
        this.route = (0, $lI7Zx.Route);
        this.plugins = null;
        this.allowlist = ()=>true;
        this.getPluginsMetrics = (data)=>{
            const result = {};
            if (this.plugins) this.plugins.forEach((plugin)=>{
                const pluginOutput = plugin({
                    ...data
                });
                if (pluginOutput === null || typeof pluginOutput !== 'object') return;
                Object.entries(pluginOutput).forEach(([key, value])=>{
                    result[`${this.product}:${key}`] = value;
                });
            });
            return result;
        };
    }
}
const $f4b765de9fc4ae71$export$edb879ae55bb9be3 = new $f4b765de9fc4ae71$var$Publisher();

});
parcelRegister("bdtMB", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $37e6fbcb11a32a30$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $37e6fbcb11a32a30$export$cc26007c03242fff);
var $37e6fbcb11a32a30$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $37e6fbcb11a32a30$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});

parcelRegister("hkVbV", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $c200109edb5cc3ee$export$13e680397ec8f3eb);

var $fITq6 = parcelRequire("fITq6");
class $c200109edb5cc3ee$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $fITq6.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $c200109edb5cc3ee$export$13e680397ec8f3eb = new $c200109edb5cc3ee$var$VisibilityChangeObserver();

});
parcelRegister("fITq6", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $7a74d78cd523c7fc$export$15e172712955e18f);
const $7a74d78cd523c7fc$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("2uYvC", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $dd4ad64c2c87dcf0$export$6123a44dc2384540);
$parcel$export(module.exports, "setGlobalEventStream", () => $dd4ad64c2c87dcf0$export$c1522520b417b066);
$parcel$export(module.exports, "subscribeEvent", () => $dd4ad64c2c87dcf0$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $dd4ad64c2c87dcf0$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $dd4ad64c2c87dcf0$export$7c957416596ca127);

var $fWi4d = parcelRequire("fWi4d");

var $6ZJBZ = parcelRequire("6ZJBZ");
const $dd4ad64c2c87dcf0$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $dd4ad64c2c87dcf0$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $dd4ad64c2c87dcf0$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $dd4ad64c2c87dcf0$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $fWi4d.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $dd4ad64c2c87dcf0$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $6ZJBZ.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $dd4ad64c2c87dcf0$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $6ZJBZ.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $dd4ad64c2c87dcf0$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $6ZJBZ.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("fWi4d", function(module, exports) {
$parcel$export(module.exports, "ufologger", () => $c68a174a2ec25a58$export$4ab84f6f04f6566d);
$parcel$export(module.exports, "ufolog", () => $c68a174a2ec25a58$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c68a174a2ec25a58$export$d53d07b6034c4560);
class $c68a174a2ec25a58$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c68a174a2ec25a58$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c68a174a2ec25a58$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c68a174a2ec25a58$export$4ab84f6f04f6566d = new $c68a174a2ec25a58$var$UFOLogger();
const $c68a174a2ec25a58$export$b4958caff08a0960 = (...args)=>{
    $c68a174a2ec25a58$export$4ab84f6f04f6566d.log(...args);
};
const $c68a174a2ec25a58$export$d53d07b6034c4560 = (...args)=>{
    $c68a174a2ec25a58$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("6ZJBZ", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $93e5fd9d23f580a5$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $93e5fd9d23f580a5$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $93e5fd9d23f580a5$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $93e5fd9d23f580a5$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $93e5fd9d23f580a5$export$837e0f79a8056912);
var $93e5fd9d23f580a5$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $93e5fd9d23f580a5$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $93e5fd9d23f580a5$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $93e5fd9d23f580a5$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $93e5fd9d23f580a5$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $93e5fd9d23f580a5$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $93e5fd9d23f580a5$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $93e5fd9d23f580a5$export$9f2bf58999404c75 = 'fmp';
const $93e5fd9d23f580a5$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("hoZoB", function(module, exports) {
$parcel$export(module.exports, "UFO_BUILD_VERSION", () => $ff6dd11a0322a095$export$93809551debf385f);
// temp solution until a proper versioning
const $ff6dd11a0322a095$export$93809551debf385f = '0.1.7';

});

parcelRegister("5bPKk", function(module, exports) {
$parcel$export(module.exports, "TenantType", () => $3b39f12a9349b47c$export$92a757ac1398962f);

var $3b39f12a9349b47c$export$92a757ac1398962f = /*#__PURE__*/ function(TenantType) {
    TenantType["RealUser"] = "real-user";
    TenantType["Synthetic"] = "synthetic";
    return TenantType;
}({});

});

parcelRegister("73ZrL", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStream", () => $d79dd946b0492cac$export$faf4c91b80fc830e);

var $fWi4d = parcelRequire("fWi4d");

var $6ZJBZ = parcelRequire("6ZJBZ");
class $d79dd946b0492cac$export$faf4c91b80fc830e {
    push(event) {
        (0, $fWi4d.ufolog)('EVENT STREAM push', event.type, event.payload);
        if (event.type === (0, $6ZJBZ.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD) this.publish(event.payload);
        if (event.type === (0, $6ZJBZ.UFOGlobalEventStreamEventType).SUBSCRIBE) this.subscribe(event.payload.experienceId, event.payload.callback);
        if (event.type === (0, $6ZJBZ.UFOGlobalEventStreamEventType).UNSUBSCRIBE) this.unsubscribe(event.payload.experienceId, event.payload.callback);
    }
    publish(eventPayload) {
        var _this$subscribers$eve;
        if (this.subscribers[0, $6ZJBZ.SUBSCRIBE_ALL]) this.subscribers[0, $6ZJBZ.SUBSCRIBE_ALL].forEach((fn)=>{
            fn(eventPayload);
        });
        (_this$subscribers$eve = this.subscribers[eventPayload.id]) === null || _this$subscribers$eve === void 0 || _this$subscribers$eve.forEach((fn)=>{
            fn(eventPayload);
        });
    }
    subscribe(experienceId, fn) {
        (0, $fWi4d.ufolog)('EVENT STREAM subscribe', experienceId);
        if (!this.subscribers[experienceId]) this.subscribers[experienceId] = [];
        this.subscribers[experienceId].push(fn);
    }
    unsubscribe(experienceId, fn) {
        const index = this.subscribers[experienceId].findIndex((entry)=>entry === fn);
        if (index !== -1) this.subscribers[experienceId].splice(index, 1);
    }
    constructor(){
        this.__buffer_only__ = false;
        this.subscribers = {};
    }
}

});

parcelRegister("hepeg", function(module, exports) {
$parcel$export(module.exports, "getPerformancePayload", () => $3573f4d0a887567f$export$738d24377baf6a5e);

var $bdtMB = parcelRequire("bdtMB");

var $6ZJBZ = parcelRequire("6ZJBZ");

var $b2cNg = parcelRequire("b2cNg");

var $fpKI2 = parcelRequire("fpKI2");

var $1hVPc = parcelRequire("1hVPc");

var $bADWo = parcelRequire("bADWo");

var $idYgq = parcelRequire("idYgq");
const $3573f4d0a887567f$var$LoadMetricKeys = {
    tti: 'metric:tti',
    fmp: 'metric:fmp',
    ttiHistograms: 'metric:tti:histogramBuckets',
    fmpHistograms: 'metric:fmp:histogramBuckets'
};
const $3573f4d0a887567f$var$InlineResultMetricKeys = {
    result: 'metric:result',
    response: 'metric:response',
    resultHistograms: 'metric:result:histogramBuckets',
    responseHistograms: 'metric:response:histogramBuckets'
};
const $3573f4d0a887567f$var$CustomMetricKeys = {
    duration: 'metric:duration',
    durationHistograms: 'metric:duration:histogramBuckets'
};
const $3573f4d0a887567f$var$getHistogram = (data, performanceConfig, isInitial)=>{
    var _data$performanceConf;
    let histogram = {};
    if ((_data$performanceConf = data.performanceConfig) !== null && _data$performanceConf !== void 0 && _data$performanceConf.histogram) histogram = data.performanceConfig.histogram;
    else if (performanceConfig !== null && performanceConfig !== void 0 && performanceConfig.histogram) histogram = performanceConfig.histogram;
    if (histogram) {
        const histograms = histogram[data.performanceType];
        switch(data.performanceType){
            case (0, $bdtMB.ExperiencePerformanceTypes).PageLoad:
            case (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad:
                const histogramType = isInitial !== undefined && isInitial === true ? 'initial' : 'transition';
                return histograms ? {
                    [$3573f4d0a887567f$var$LoadMetricKeys.ttiHistograms]: histograms[histogramType].tti,
                    [$3573f4d0a887567f$var$LoadMetricKeys.fmpHistograms]: histograms[histogramType].fmp
                } : {};
            case (0, $bdtMB.ExperiencePerformanceTypes).InlineResult:
                return histograms ? {
                    [$3573f4d0a887567f$var$InlineResultMetricKeys.resultHistograms]: histograms.result,
                    [$3573f4d0a887567f$var$InlineResultMetricKeys.responseHistograms]: histograms.response
                } : {};
            case (0, $bdtMB.ExperiencePerformanceTypes).Custom:
                return histograms ? {
                    [$3573f4d0a887567f$var$CustomMetricKeys.durationHistograms]: histograms.duration
                } : {};
        }
    }
    return undefined;
};
const $3573f4d0a887567f$export$bd4e6d81a822ece6 = (data, ssr, performanceConfig)=>{
    var _data$metrics$marks$f;
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const fmpMark = ((_data$metrics$marks$f = data.metrics.marks.find((mark)=>mark.name === (0, $6ZJBZ.FMP_MARK))) === null || _data$metrics$marks$f === void 0 ? void 0 : _data$metrics$marks$f.time) || (0, $b2cNg.isInitialPageLoad)(data) && (ssr === null || ssr === void 0 ? void 0 : ssr.getDoneMark());
    const tti = data.metrics.endTime - data.metrics.startTime;
    const fmp = typeof fmpMark === 'number' ? fmpMark - data.metrics.startTime : tti;
    return {
        [$3573f4d0a887567f$var$LoadMetricKeys.tti]: Math.round(tti),
        [$3573f4d0a887567f$var$LoadMetricKeys.fmp]: Math.round(fmp),
        ...$3573f4d0a887567f$var$getHistogram(data, performanceConfig)
    };
};
const $3573f4d0a887567f$export$47f0208fd62dffce = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const responseMark = data.metrics.marks.find((mark)=>mark.name === (0, $6ZJBZ.INLINE_RESPONSE_MARK));
    const result = data.metrics.endTime - data.metrics.startTime;
    const response = responseMark ? responseMark.time - data.metrics.startTime : result;
    return {
        [$3573f4d0a887567f$var$InlineResultMetricKeys.result]: Math.round(result),
        [$3573f4d0a887567f$var$InlineResultMetricKeys.response]: Math.round(response),
        ...$3573f4d0a887567f$var$getHistogram(data, performanceConfig)
    };
};
const $3573f4d0a887567f$export$c25c1b3ff2ce92cf = (data, performanceConfig)=>{
    if (data.metrics.endTime === null || data.metrics.startTime === null) return null;
    const duration = data.metrics.endTime - data.metrics.startTime;
    return {
        [$3573f4d0a887567f$var$CustomMetricKeys.duration]: Math.round(duration),
        ...$3573f4d0a887567f$var$getHistogram(data, performanceConfig)
    };
};
const $3573f4d0a887567f$var$getPerformanceMetrics = (data, ssr, performanceConfig)=>{
    switch(data.performanceType){
        case (0, $bdtMB.ExperiencePerformanceTypes).PageLoad:
        case (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad:
            return $3573f4d0a887567f$export$bd4e6d81a822ece6(data, ssr, performanceConfig);
        case (0, $bdtMB.ExperiencePerformanceTypes).InlineResult:
            return $3573f4d0a887567f$export$47f0208fd62dffce(data, performanceConfig);
        case (0, $bdtMB.ExperiencePerformanceTypes).Custom:
            return $3573f4d0a887567f$export$c25c1b3ff2ce92cf(data, performanceConfig);
    }
};
const $3573f4d0a887567f$export$738d24377baf6a5e = (data, ssr, bundleEvalConfig, resourceConfig, performanceConfig)=>{
    return {
        ...$3573f4d0a887567f$var$getPerformanceMetrics(data, ssr, performanceConfig),
        ...(0, $idYgq.resourceTimings)(data, resourceConfig),
        ...(0, $bADWo.bundleEvalTimings)(data, bundleEvalConfig),
        ...(0, $1hVPc.appTimings)(data, ssr),
        ...(0, $b2cNg.isInitialPageLoad)(data) ? (0, $fpKI2.navigationMetrics)() : null
    };
};

});
parcelRegister("b2cNg", function(module, exports) {
$parcel$export(module.exports, "isInitialPageLoad", () => $7109723cacc1247c$export$7167d96e9881d500);

var $bdtMB = parcelRequire("bdtMB");
const $7109723cacc1247c$export$7167d96e9881d500 = (data)=>{
    return data.performanceType === (0, $bdtMB.ExperiencePerformanceTypes).PageLoad && data.initial === true;
};

});

parcelRegister("fpKI2", function(module, exports) {
$parcel$export(module.exports, "navigationMetrics", () => $34c24d9ad1e0897d$export$b88d990436be0f8a);
const $34c24d9ad1e0897d$export$b88d990436be0f8a = ()=>{
    const entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    const navigation = entries[0];
    const metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("1hVPc", function(module, exports) {
$parcel$export(module.exports, "appTimings", () => $24f673470faf2f4b$export$e952f50a4f2d02da);

var $bdtMB = parcelRequire("bdtMB");

var $b2cNg = parcelRequire("b2cNg");

var $dErn4 = parcelRequire("dErn4");

var $gNkg6 = parcelRequire("gNkg6");
const $24f673470faf2f4b$export$e952f50a4f2d02da = (data, ssrConfig)=>{
    const explicitTimings = data.performanceType === (0, $bdtMB.ExperiencePerformanceTypes).PageLoad && data.explicitTimings || null;
    const timings = (0, $dErn4.customTimings)(data);
    const ssr = (0, $b2cNg.isInitialPageLoad)(data) ? (0, $gNkg6.ssrTimings)(ssrConfig) : null;
    const timingsApp = (explicitTimings || timings || ssr) && {
        ...explicitTimings,
        ...timings,
        ...ssr
    };
    if (!timingsApp || Object.keys(timingsApp).length === 0) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("dErn4", function(module, exports) {
$parcel$export(module.exports, "customTimings", () => $944f9a0638ea6dc0$export$6126f85083a72c6e);
const $944f9a0638ea6dc0$var$retrieveTimings = (data)=>{
    const configTimings = data.timings || [];
    const timings = configTimings.reduce((entries, timing)=>{
        const startMark = data.metrics.marks.find((mark)=>mark.name === timing.startMark);
        if (timing.startMark && !startMark) return entries;
        const endMark = data.metrics.marks.find((mark)=>mark.name === timing.endMark);
        if (timing.endMark && !endMark) return entries;
        if (data.metrics.startTime === null || data.metrics.endTime === null) return null;
        const startTime = Math.round((startMark ? startMark.time : data.metrics.startTime) - data.metrics.startTime);
        const duration = Math.round((endMark ? endMark.time : data.metrics.endTime) - data.metrics.startTime - startTime);
        entries[`${timing.key}`] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
const $944f9a0638ea6dc0$export$6126f85083a72c6e = (data)=>{
    if (!data.timings) return null;
    const timings = $944f9a0638ea6dc0$var$retrieveTimings(data);
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});

parcelRegister("gNkg6", function(module, exports) {
$parcel$export(module.exports, "ssrTimings", () => $acdafcb6bc86cae7$export$130f411261a599c5);

var $5zVCt = parcelRequire("5zVCt");
const $acdafcb6bc86cae7$var$filterEntry = (entry)=>{
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
const $acdafcb6bc86cae7$var$mapEntry = (entry)=>{
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
const $acdafcb6bc86cae7$var$SSR_PREFIX = 'ssr';
const $acdafcb6bc86cae7$var$mapKey = (key)=>{
    if (key === 'total') return $acdafcb6bc86cae7$var$SSR_PREFIX;
    return `${$acdafcb6bc86cae7$var$SSR_PREFIX}${0, $5zVCt.NESTED_METRIC_SEPARATOR}${key}`;
};
const $acdafcb6bc86cae7$export$130f411261a599c5 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getTimings)) return null;
    const timings = ssr.getTimings();
    if (!timings) return null;
    const ssrTimings = Object.entries(timings).reduce((acc, entry)=>{
        if ($acdafcb6bc86cae7$var$filterEntry(entry[1])) acc[$acdafcb6bc86cae7$var$mapKey(entry[0])] = $acdafcb6bc86cae7$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});
parcelRegister("5zVCt", function(module, exports) {
$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", () => $364f4551ea21bc75$export$b98e411ae80c806f);
const $364f4551ea21bc75$export$b98e411ae80c806f = '/';

});



parcelRegister("bADWo", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $78c7db656f8c8990$export$1a2bb347935fc536);

var $5l4Hj = parcelRequire("5l4Hj");
const $78c7db656f8c8990$export$1a2bb347935fc536 = (data, bundleEvalTimings, performance = (0, $5l4Hj.getPerformanceObject)() || undefined)=>{
    if (!bundleEvalTimings) return null;
    const started = {};
    const timings = {};
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach((mark)=>{
        const result = bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result || data.result.startTime === null) return;
        const { type: type, name: name } = result;
        if (type === 'start' && mark.startTime >= data.result.startTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.result.startTime),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (bundleEvalTimings !== null && bundleEvalTimings !== void 0 && bundleEvalTimings.additionalTimings && data.result.startTime !== null) {
        const result = bundleEvalTimings.additionalTimings(data.result.startTime);
        if (result) Object.entries(result).forEach(([key, value])=>{
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};

});
parcelRegister("5l4Hj", function(module, exports) {
$parcel$export(module.exports, "getWindowObject", () => $48651272f64e6e75$export$9aa44f85591248d9);
$parcel$export(module.exports, "getPerformanceObject", () => $48651272f64e6e75$export$8cd0c777b0eb66a0);
$parcel$export(module.exports, "getPerformanceObserverObject", () => $48651272f64e6e75$export$74560fd4e61fd440);
const $48651272f64e6e75$export$9aa44f85591248d9 = ()=>{
    return typeof window !== 'undefined' && !!window ? window : undefined;
};
const $48651272f64e6e75$export$8cd0c777b0eb66a0 = ()=>{
    const { performance: performance } = $48651272f64e6e75$export$9aa44f85591248d9() || {};
    return performance;
};
const $48651272f64e6e75$export$74560fd4e61fd440 = ()=>{
    const { PerformanceObserver: PerformanceObserver } = $48651272f64e6e75$export$9aa44f85591248d9() || {};
    return PerformanceObserver;
};

});


parcelRegister("idYgq", function(module, exports) {
$parcel$export(module.exports, "resourceTimings", () => $0f826f548bcc8339$export$81a7d52441a06b50);

var $5l4Hj = parcelRequire("5l4Hj");

var $ggl1m = parcelRequire("ggl1m");
const $0f826f548bcc8339$var$cacheableTypes = [
    'script',
    'link'
];
const $0f826f548bcc8339$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
const $0f826f548bcc8339$var$CACHE_NETWORK = 'network';
const $0f826f548bcc8339$var$CACHE_MEMORY = 'memory';
const $0f826f548bcc8339$var$CACHE_DISK = 'disk';
const $0f826f548bcc8339$var$calculateTransferType = (type, duration, size)=>{
    if (!$0f826f548bcc8339$var$cacheableTypes.includes(type)) return $0f826f548bcc8339$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $0f826f548bcc8339$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $0f826f548bcc8339$var$CACHE_DISK;
    if (size === undefined) return null;
    return $0f826f548bcc8339$var$CACHE_NETWORK;
};
const $0f826f548bcc8339$var$hasAccessToResourceSize = (url, type, entry, hasTimingHeaders)=>{
    return !$0f826f548bcc8339$var$cacheableTypes.includes(type) || url.includes('localhost') || !!(0, $5l4Hj.getWindowObject)() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
};
const $0f826f548bcc8339$var$getReportedInitiatorTypes = (xhrEnabled)=>{
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
const $0f826f548bcc8339$var$evaluateAccessToResourceTimings = (_url, entry)=>{
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
};
const $0f826f548bcc8339$var$getSizeObject = (size)=>size !== undefined ? {
        size: size
    } : null;
const $0f826f548bcc8339$var$getNetworkData = (item, eventStart, hasTimingHeaders = $0f826f548bcc8339$var$evaluateAccessToResourceTimings)=>{
    const { name: name, duration: duration, transferSize: transferSize, initiatorType: initiatorType, responseStart: responseStart } = item;
    const ttfb = Math.round(responseStart - eventStart);
    if (!$0f826f548bcc8339$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($0f826f548bcc8339$var$cacheableTypes.includes(initiatorType)) {
        const transferType = $0f826f548bcc8339$var$calculateTransferType(initiatorType, duration, transferSize);
        if (!transferType) return {
            ttfb: ttfb,
            ...$0f826f548bcc8339$var$getSizeObject(transferSize)
        };
        if (transferType !== $0f826f548bcc8339$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return {
            ttfb: ttfb,
            transferType: transferType,
            ...$0f826f548bcc8339$var$getSizeObject(transferSize)
        };
    }
    return {
        ttfb: ttfb,
        ...$0f826f548bcc8339$var$getSizeObject(transferSize)
    };
};
const $0f826f548bcc8339$export$81a7d52441a06b50 = (data, resourceTimings, performance = (0, $5l4Hj.getPerformanceObject)() || undefined)=>{
    if (data.result.startTime === null || !(resourceTimings !== null && resourceTimings !== void 0 && resourceTimings.sanitiseEndpoints)) return null;
    const resources = (0, $ggl1m.getResourceTimings)(data.result.startTime, performance);
    if (!(resources !== null && resources !== void 0 && resources.length)) return null;
    const resourceTiming = {};
    const { xhrFilter: xhrFilter } = resourceTimings;
    const reportedInitiatorTypes = $0f826f548bcc8339$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach((item)=>{
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        const { name: name, startTime: startTime, duration: duration, workerStart: workerStart, fetchStart: fetchStart, initiatorType: initiatorType } = item;
        if (!name || data.result.startTime === null) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        const url = $0f826f548bcc8339$var$resourceTypes.includes(initiatorType) ? resourceTimings.sanitiseEndpoints(name) : resourceTimings.mapResources(name);
        if (!url || resourceTiming[url]) return;
        resourceTiming[url] = {
            startTime: Math.round(startTime - data.result.startTime),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.result.startTime), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.result.startTime), 0),
            type: initiatorType,
            ...$0f826f548bcc8339$var$getNetworkData(item, data.result.startTime, resourceTimings.hasTimingHeaders)
        };
    });
    return {
        'timings:resource': resourceTiming
    };
};

});
parcelRegister("ggl1m", function(module, exports) {
$parcel$export(module.exports, "resourceTimingBuffer", () => $8b77864ddfe536c4$export$bea963256235a63e);
$parcel$export(module.exports, "getResourceTimings", () => $8b77864ddfe536c4$export$9eebb59359c2e9e5);
// @flow strict-local

var $fWi4d = parcelRequire("fWi4d");

var $5l4Hj = parcelRequire("5l4Hj");
const $8b77864ddfe536c4$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: (entry)=>({
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            fetchStart: Math.round(entry.fetchStart || 0),
            workerStart: Math.round(entry.workerStart || 0),
            responseStart: Math.round(entry.responseStart || 0)
        }),
    start: (performance = (0, $5l4Hj.getPerformanceObject)(), PerformanceObserver1 = (0, $5l4Hj.getPerformanceObserverObject)())=>{
        var _performance$getEntri;
        if (!PerformanceObserver1 || !performance || typeof PerformanceObserver1 === 'undefined') return;
        if ($8b77864ddfe536c4$export$bea963256235a63e.observer) {
            (0, $fWi4d.ufologger).warn('Observer is already running');
            return;
        }
        const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $8b77864ddfe536c4$export$bea963256235a63e.timings = resources.map((resource)=>$8b77864ddfe536c4$export$bea963256235a63e.transformResource(resource));
        $8b77864ddfe536c4$export$bea963256235a63e.observer = new PerformanceObserver1($8b77864ddfe536c4$export$bea963256235a63e.addTimings);
        $8b77864ddfe536c4$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: ()=>{
        if ($8b77864ddfe536c4$export$bea963256235a63e.observer) {
            $8b77864ddfe536c4$export$bea963256235a63e.observer.disconnect();
            $8b77864ddfe536c4$export$bea963256235a63e.observer = null;
        }
        $8b77864ddfe536c4$export$bea963256235a63e.timings = [];
    },
    addTimings: (list)=>{
        const entries = list.getEntries().map((entry)=>$8b77864ddfe536c4$export$bea963256235a63e.transformResource(entry));
        const overflow = $8b77864ddfe536c4$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $8b77864ddfe536c4$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $8b77864ddfe536c4$export$bea963256235a63e.maxSize;
            $8b77864ddfe536c4$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $8b77864ddfe536c4$export$bea963256235a63e.timings.push(...entries);
    }
};
const $8b77864ddfe536c4$export$9eebb59359c2e9e5 = (startTime, performance = (0, $5l4Hj.getPerformanceObject)())=>{
    if (!PerformanceObserver || !$8b77864ddfe536c4$export$bea963256235a63e.observer) {
        const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>timing.startTime >= startTime);
        return null;
    }
    return $8b77864ddfe536c4$export$bea963256235a63e.timings.filter((timing)=>timing.startTime >= startTime);
};

});



parcelRegister("3qaYU", function(module, exports) {
$parcel$export(module.exports, "pageVisibleState", () => $5a32d2955c933f01$export$723b4c298aca63af);

var $6ZJBZ = parcelRequire("6ZJBZ");
const $5a32d2955c933f01$export$723b4c298aca63af = (data)=>{
    return {
        'experience:pageVisible': data.pageVisibleState ?? (document.hidden ? (0, $6ZJBZ.PageVisibleState).HIDDEN : (0, $6ZJBZ.PageVisibleState).VISIBLE)
    };
};

});

parcelRegister("fjJik", function(module, exports) {
$parcel$export(module.exports, "appFramework", () => $a6e23dc756b320b1$export$e34e4529b979f74c);
const $a6e23dc756b320b1$export$e34e4529b979f74c = (config)=>{
    if (!config.framework) return null;
    return {
        'app:framework:name': config.framework.name,
        'app:framework:version': config.framework.version
    };
};

});

parcelRegister("YW7ml", function(module, exports) {
$parcel$export(module.exports, "appVersion", () => $2c627350ebbee171$export$82ae485178b37419);
const $2c627350ebbee171$export$82ae485178b37419 = (config)=>{
    const pluginData = {
        'app:web:version': config.version.web
    };
    if (config.version.ssr) pluginData['app:ssr:version'] = config.version.ssr;
    return pluginData;
};

});

parcelRegister("UAFee", function(module, exports) {
$parcel$export(module.exports, "eventBrowserPlugin", () => $1fa5e0d06eef5b2a$export$f435c2789ca334a7);

var $hh89M = parcelRequire("hh89M");

var $jE04u = parcelRequire("jE04u");

var $5l4Hj = parcelRequire("5l4Hj");
const $1fa5e0d06eef5b2a$export$f435c2789ca334a7 = (0, $jE04u.default)(()=>{
    var _getWindowObject;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hh89M))).getParser) return null;
    const browser = (0, (/*@__PURE__*/$parcel$interopDefault($hh89M))).getParser(((_getWindowObject = (0, $5l4Hj.getWindowObject)()) === null || _getWindowObject === void 0 || (_getWindowObject = _getWindowObject.navigator) === null || _getWindowObject === void 0 ? void 0 : _getWindowObject.userAgent) || '');
    return {
        'event:browser:name': browser.getBrowserName(),
        'event:browser:version': browser.getBrowserVersion()
    };
});

});

parcelRegister("1fo1x", function(module, exports) {
$parcel$export(module.exports, "eventCpusPlugin", () => $62d7cc9f6d06c8c7$export$db7649b8854107ad);

var $jE04u = parcelRequire("jE04u");
const $62d7cc9f6d06c8c7$export$db7649b8854107ad = (0, $jE04u.default)(()=>{
    if (!navigator.hardwareConcurrency) return null;
    return {
        'event:cpus': navigator.hardwareConcurrency
    };
});

});

parcelRegister("kKTUg", function(module, exports) {
$parcel$export(module.exports, "featureFlags", () => $cabbec226455c465$export$e62953d023125748);
const $cabbec226455c465$export$e62953d023125748 = (featureFlagClient, featureFlags, data)=>{
    const allFeatureFlags = [
        ...featureFlags,
        ...data.featureFlags || []
    ];
    if (allFeatureFlags.length === 0) return null;
    const initialMemo = [];
    allFeatureFlags.reduce((memo, featureFlagKey)=>{
        const ffVal = featureFlagClient.getValue(featureFlagKey);
        if (ffVal !== undefined && ffVal !== null) memo.push([
            featureFlagKey,
            ffVal
        ]);
        return memo;
    }, initialMemo);
    const mappedFeatureFlags = Object.fromEntries(initialMemo);
    return {
        featureFlags: mappedFeatureFlags
    };
};

});

parcelRegister("t5tod", function(module, exports) {
$parcel$export(module.exports, "eventMemoryPlugin", () => $22a87c2a17d70157$export$81efaf8414879a1a);

var $jE04u = parcelRequire("jE04u");
const $22a87c2a17d70157$export$81efaf8414879a1a = (0, $jE04u.default)(()=>{
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'event:memory': navigator.deviceMemory
    };
});

});

parcelRegister("8u7Vb", function(module, exports) {
$parcel$export(module.exports, "eventNetworkPlugin", () => $c023599968ba0b6b$export$ce1cf816dce1da56);
const $c023599968ba0b6b$export$ce1cf816dce1da56 = ()=>{
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("K0gEt", function(module, exports) {
$parcel$export(module.exports, "ssrFeatureFlags", () => $deace8e8c4fa852a$export$fdbea518c19dfa8);
const $deace8e8c4fa852a$export$fdbea518c19dfa8 = (ssr)=>{
    if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) return null;
    try {
        const featureFlags = ssr.getFeatureFlags();
        if (featureFlags) return {
            'ssr:featureFlags': featureFlags
        };
    } catch (e) {}
    return null;
};

});

parcelRegister("4Ys1i", function(module, exports) {
$parcel$export(module.exports, "ssrSuccess", () => $a7ffa4b605a3b3a6$export$a3dc8251cf55b2e0);
const $a7ffa4b605a3b3a6$export$a3dc8251cf55b2e0 = (ssr)=>{
    if (ssr !== null && ssr !== void 0 && ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("lI7Zx", function(module, exports) {
$parcel$export(module.exports, "Route", () => $466543a1db6a4b5b$export$e7b0ac011bb776c6);
const $466543a1db6a4b5b$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute (newRoute) {
        this.route = newRoute;
    },
    getRoute () {
        return this.route;
    }
};

});



parcelRegister("9VfQ7", function(module, exports) {
$parcel$export(module.exports, "initialiseConnectAndSentryAndCleanUrl", () => $c5bab00a54e49169$export$d937591d0adcb4ed);

var $bG6ob = parcelRequire("bG6ob");

var $24WaN = parcelRequire("24WaN");

var $iwOiX = parcelRequire("iwOiX");

var $PL4bf = parcelRequire("PL4bf");

var $3TeDY = parcelRequire("3TeDY");

var $fVwZr = parcelRequire("fVwZr");

var $6LO3M = parcelRequire("6LO3M");

var $91yYl = parcelRequire("91yYl");
const $c5bab00a54e49169$export$d937591d0adcb4ed = ()=>{
    if (!(0, $bG6ob.isWrmOptimizationsEnabled)()) (0, $24WaN.awaitGlobal)('connectHost', (0, $iwOiX.default));
    if ((0, $fVwZr.isSentryEnabled)()) {
        (0, $6LO3M.install)();
        (0, $91yYl.sentryQueue).flushErrors();
    }
    const url = (0, $3TeDY.href)();
    const modifiedUrl = (0, $PL4bf.removeParamsFromUrl)(url, [
        'sda_source'
    ]);
    if (url !== modifiedUrl) (0, $PL4bf.set)({
        sda_source: undefined
    });
};

});
parcelRegister("24WaN", function(module, exports) {
$parcel$export(module.exports, "awaitGlobal", () => $11138906721bd49c$export$653e97524db056d2);
const $11138906721bd49c$var$isGlobalDefined = (objName)=>{
    // @ts-ignore TS(7015) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because index... Remove this comment to see the full error message
    return window[objName] !== undefined;
};
const $11138906721bd49c$export$653e97524db056d2 = (objectName, cb)=>{
    if ($11138906721bd49c$var$isGlobalDefined(objectName)) cb();
    else {
        const intervalTime = 100;
        let loopCounter = 0;
        const awaitInterval = setInterval(()=>{
            if ($11138906721bd49c$var$isGlobalDefined(objectName)) {
                clearInterval(awaitInterval);
                cb();
            }
            loopCounter += 1;
            // Loop will run for maximum of 10 seconds
            if (loopCounter > 100) clearInterval(awaitInterval);
        }, intervalTime);
    }
};

});

parcelRegister("iwOiX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f890c7bb90323b79$export$2e2bcd8739ae039);

var $fbYHu = parcelRequire("fbYHu");
function $f890c7bb90323b79$var$init() {
    const { connectHost: connectHost } = window;
    const api = (0, $fbYHu.connectApi)(connectHost);
    function createRequestPropertiesModule() {
        class RequestProperties {
            validate(isValid, context) {
                api.validate(isValid, context._context);
            }
            serialize(data, context) {
                api.serialize(data, context._context);
            }
        }
        return {
            constructor: RequestProperties,
            validate: RequestProperties.prototype.validate,
            serialize: RequestProperties.prototype.serialize
        };
    }
    const jiraServiceDesk = {
        RequestProperties: createRequestPropertiesModule()
    };
    connectHost.defineModule('jiraServiceDesk', jiraServiceDesk);
}
var $f890c7bb90323b79$export$2e2bcd8739ae039 = $f890c7bb90323b79$var$init;

});
parcelRegister("fbYHu", function(module, exports) {
$parcel$export(module.exports, "getAppKeyFromFullKey", () => $2c46a4d8d741235d$export$30f3f10c136c0ee6);
$parcel$export(module.exports, "getUniqueAppKeysFromConnectFragments", () => $2c46a4d8d741235d$export$bc66b351c49d3b94);
$parcel$export(module.exports, "connectApi", () => $2c46a4d8d741235d$export$b0d55f75723432a0);
$parcel$export(module.exports, "validate", () => $2c46a4d8d741235d$export$a22775fa5e2eebd9);
$parcel$export(module.exports, "serialize", () => $2c46a4d8d741235d$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "register", () => $2c46a4d8d741235d$export$6503ec6e8aabbaf);
$parcel$export(module.exports, "unregister", () => $2c46a4d8d741235d$export$d07f55d4c15c0440);
// Events that the connect field add-on will need to listen to, These are API.
// We don't need to worry about these as it's handled by us but they shouldn't be changed.

var $63sfu = parcelRequire("63sfu");
const $2c46a4d8d741235d$var$EVENTS = {
    VALIDATE: 'jira-servicedesk-request-properties-validate',
    SERIALIZE: 'jira-servicedesk-request-properties-serialize'
};
const $2c46a4d8d741235d$var$connectPluginKey = 'com.atlassian.plugins.atlassian-connect-plugin';
const $2c46a4d8d741235d$var$internalListOfAddons = {};
function $2c46a4d8d741235d$var$getFullkey(context) {
    const addonKey = context.extension.addon_key;
    const panelKey = context.extension.key;
    return `${$2c46a4d8d741235d$var$connectPluginKey}:${addonKey}__${panelKey}`;
}
const $2c46a4d8d741235d$export$30f3f10c136c0ee6 = (fullKey = '')=>{
    const strippedOfModuleKey = fullKey.substring(0, fullKey.lastIndexOf('__'));
    return strippedOfModuleKey.substring(strippedOfModuleKey.lastIndexOf(':') + 1);
};
const $2c46a4d8d741235d$export$bc66b351c49d3b94 = (connectFragments)=>{
    return (0, $63sfu.uniq)(connectFragments.map((fragment)=>$2c46a4d8d741235d$export$30f3f10c136c0ee6(fragment.key)));
};
let $2c46a4d8d741235d$var$connectHost;
const $2c46a4d8d741235d$export$b0d55f75723432a0 = (host)=>{
    $2c46a4d8d741235d$var$connectHost = host;
    $2c46a4d8d741235d$var$connectHost.onIframeEstablished((context)=>{
        const fullKey = $2c46a4d8d741235d$var$getFullkey(context);
        const addonRef = $2c46a4d8d741235d$var$internalListOfAddons[fullKey];
        if (!!addonRef) $2c46a4d8d741235d$var$internalListOfAddons[fullKey] = {
            ...$2c46a4d8d741235d$var$internalListOfAddons[fullKey],
            contextExtension: context.extension
        };
    });
    return {
        // add-ons will call this on the request create page with the result of the validation after they receive the EVENTS.VALIDATE event
        validate (isValid, context) {
            const fullKey = $2c46a4d8d741235d$var$getFullkey(context);
            const addonRef = $2c46a4d8d741235d$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onValidated(isValid);
        },
        // add-ons will call this on the request create page with the serialized data after they receive the EVENTS.SERIALIZE event
        serialize (data, context) {
            const fullKey = $2c46a4d8d741235d$var$getFullkey(context);
            const addonRef = $2c46a4d8d741235d$var$internalListOfAddons[fullKey];
            if (!!addonRef) addonRef.onSerialized(data);
        }
    };
};
const $2c46a4d8d741235d$export$a22775fa5e2eebd9 = (key)=>{
    const addonRef = $2c46a4d8d741235d$var$internalListOfAddons[key];
    $2c46a4d8d741235d$var$connectHost && addonRef && addonRef.contextExtension && $2c46a4d8d741235d$var$connectHost.broadcastEvent($2c46a4d8d741235d$var$EVENTS.VALIDATE, addonRef.contextExtension);
};
const $2c46a4d8d741235d$export$dfdc1655ccc5b9cb = (key)=>{
    const addonRef = $2c46a4d8d741235d$var$internalListOfAddons[key];
    $2c46a4d8d741235d$var$connectHost && addonRef && addonRef.contextExtension && $2c46a4d8d741235d$var$connectHost.broadcastEvent($2c46a4d8d741235d$var$EVENTS.SERIALIZE, addonRef.contextExtension);
};
const $2c46a4d8d741235d$export$6503ec6e8aabbaf = (key, onSerialized, onValidated)=>{
    $2c46a4d8d741235d$var$internalListOfAddons[key] = {
        onSerialized: onSerialized,
        onValidated: onValidated
    };
};
const $2c46a4d8d741235d$export$d07f55d4c15c0440 = (key)=>{
    delete $2c46a4d8d741235d$var$internalListOfAddons[key];
};

});


parcelRegister("PL4bf", function(module, exports) {
$parcel$export(module.exports, "getAll", () => $6db15fccf9cf7622$export$2774c37398bee8b2);
$parcel$export(module.exports, "get", () => $6db15fccf9cf7622$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $6db15fccf9cf7622$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "addParamsToUrl", () => $6db15fccf9cf7622$export$e1e3ddd390fd26f2);
$parcel$export(module.exports, "removeParamsFromUrl", () => $6db15fccf9cf7622$export$9d6317f3c41bff91);

var $63sfu = parcelRequire("63sfu");

var $4i2V5 = parcelRequire("4i2V5");

var $3wR8f = parcelRequire("3wR8f");
function $6db15fccf9cf7622$export$2774c37398bee8b2() {
    if (!(0, $3wR8f.default).location.search) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...$4i2V5.parse((0, $3wR8f.default).location.search)
    };
}
function $6db15fccf9cf7622$export$3988ae62b71be9a3(key) {
    const values = $6db15fccf9cf7622$export$2774c37398bee8b2();
    return values && values[key];
}
const $6db15fccf9cf7622$export$fac44ee5b035f737 = (queryParams)=>$4i2V5.stringify(queryParams).replace(/%20/g, '+');
function $6db15fccf9cf7622$export$adaa4cf7ef1b65be(newValues, replace = true) {
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values = $4i2V5.parse((0, $3wR8f.default).location.search);
    const search = $6db15fccf9cf7622$export$fac44ee5b035f737({
        ...values,
        ...newValues
    });
    const newLocation = {
        ...(0, $3wR8f.default).location,
        search: search
    };
    if (replace) (0, $3wR8f.default).replace(newLocation);
    else (0, $3wR8f.default).push(newLocation);
}
const $6db15fccf9cf7622$export$e1e3ddd390fd26f2 = (url, addParams)=>{
    const qs = $4i2V5.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = {
        ...$4i2V5.parse(qs),
        ...addParams
    };
    const newQueryString = $6db15fccf9cf7622$export$fac44ee5b035f737(params);
    if (newQueryString) return `${url.split('?')[0]}?${newQueryString}`;
    return url;
};
const $6db15fccf9cf7622$export$9d6317f3c41bff91 = (url, paramsToRemove)=>{
    const qs = $4i2V5.extract(url);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const params = $4i2V5.parse(qs);
    let isParamsRemoved = false;
    paramsToRemove.forEach((paramToRemove)=>{
        if ((0, $63sfu.has)(params, paramToRemove)) {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            delete params[paramToRemove];
            isParamsRemoved = true;
        }
    });
    // don't modify url if there is nothing to remove
    if (!isParamsRemoved) return url;
    const newQueryString = $6db15fccf9cf7622$export$fac44ee5b035f737(params);
    const urlWithoutQuery = url.split('?')[0];
    if (newQueryString) return `${urlWithoutQuery}?${newQueryString}`;
    return urlWithoutQuery;
};

});
parcelRegister("4i2V5", function(module, exports) {
$parcel$export(module.exports, "extract", () => $31fb1ba99327bce3$export$f9380c9a627682d3, (v) => $31fb1ba99327bce3$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $31fb1ba99327bce3$export$98e6a39c04603d36, (v) => $31fb1ba99327bce3$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $31fb1ba99327bce3$export$fac44ee5b035f737, (v) => $31fb1ba99327bce3$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $31fb1ba99327bce3$export$7a5253c0f62e0150, (v) => $31fb1ba99327bce3$export$7a5253c0f62e0150 = v);
var $31fb1ba99327bce3$export$f9380c9a627682d3;
var $31fb1ba99327bce3$export$98e6a39c04603d36;
var $31fb1ba99327bce3$export$fac44ee5b035f737;
var $31fb1ba99327bce3$export$7a5253c0f62e0150;
'use strict';

var $4VtXZ = parcelRequire("4VtXZ");

var $gNmgN = parcelRequire("gNmgN");

var $bCuqp = parcelRequire("bCuqp");
function $31fb1ba99327bce3$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $31fb1ba99327bce3$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $31fb1ba99327bce3$var$encode(key, opts),
                    '[',
                    $31fb1ba99327bce3$var$encode(index, opts),
                    ']=',
                    $31fb1ba99327bce3$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $31fb1ba99327bce3$var$encode(key, opts) : [
                    $31fb1ba99327bce3$var$encode(key, opts),
                    '[]=',
                    $31fb1ba99327bce3$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $31fb1ba99327bce3$var$encode(key, opts) : [
                    $31fb1ba99327bce3$var$encode(key, opts),
                    '=',
                    $31fb1ba99327bce3$var$encode(value, opts)
                ].join('');
            };
    }
}
function $31fb1ba99327bce3$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $31fb1ba99327bce3$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $4VtXZ(value) : encodeURIComponent(value);
    return value;
}
function $31fb1ba99327bce3$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $31fb1ba99327bce3$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $31fb1ba99327bce3$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $31fb1ba99327bce3$var$parse(str, opts) {
    opts = $gNmgN({
        arrayFormat: 'none'
    }, opts);
    var formatter = $31fb1ba99327bce3$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $bCuqp(val);
        formatter($bCuqp(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $31fb1ba99327bce3$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$31fb1ba99327bce3$export$f9380c9a627682d3 = $31fb1ba99327bce3$var$extract;
$31fb1ba99327bce3$export$98e6a39c04603d36 = $31fb1ba99327bce3$var$parse;
$31fb1ba99327bce3$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $gNmgN(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $31fb1ba99327bce3$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $31fb1ba99327bce3$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $31fb1ba99327bce3$var$encode(key, opts) + '=' + $31fb1ba99327bce3$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$31fb1ba99327bce3$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $31fb1ba99327bce3$var$parse($31fb1ba99327bce3$var$extract(str), opts)
    };
};

});
parcelRegister("4VtXZ", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("gNmgN", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $c3a27f46c8edf904$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c3a27f46c8edf904$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c3a27f46c8edf904$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $c3a27f46c8edf904$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $c3a27f46c8edf904$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $c3a27f46c8edf904$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $c3a27f46c8edf904$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($c3a27f46c8edf904$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($c3a27f46c8edf904$var$getOwnPropertySymbols) {
            symbols = $c3a27f46c8edf904$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($c3a27f46c8edf904$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("3TeDY", function(module, exports) {
$parcel$export(module.exports, "reload", () => $c5a54dbb0691fc63$export$32da5b5043dcd88c);
$parcel$export(module.exports, "replace", () => $c5a54dbb0691fc63$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "pathname", () => $c5a54dbb0691fc63$export$7333db99aa99d383);
$parcel$export(module.exports, "location", () => $c5a54dbb0691fc63$export$17b07c660794dc13);
$parcel$export(module.exports, "href", () => $c5a54dbb0691fc63$export$8f51af5840e0602a);
$parcel$export(module.exports, "hash", () => $c5a54dbb0691fc63$export$d6af199866bfb566);
$parcel$export(module.exports, "origin", () => $c5a54dbb0691fc63$export$f710a83a91838a36);
$parcel$export(module.exports, "search", () => $c5a54dbb0691fc63$export$d76128d007d19019);
$parcel$export(module.exports, "open", () => $c5a54dbb0691fc63$export$3ce6949f20cea765);
$parcel$export(module.exports, "assign", () => $c5a54dbb0691fc63$export$e6e34fd1f2686227);
$parcel$export(module.exports, "isValidLocation", () => $c5a54dbb0691fc63$export$f15ea956d38b6f8a);

var $63sfu = parcelRequire("63sfu");
const $c5a54dbb0691fc63$export$32da5b5043dcd88c = ()=>window.location.reload();
const $c5a54dbb0691fc63$export$77ad94ebf1c2b9ed = (path)=>window.location.replace(path);
const $c5a54dbb0691fc63$export$7333db99aa99d383 = ()=>window.location.pathname;
const $c5a54dbb0691fc63$export$17b07c660794dc13 = ()=>window.location;
const $c5a54dbb0691fc63$export$8f51af5840e0602a = ()=>window.location.href;
const $c5a54dbb0691fc63$export$d6af199866bfb566 = ()=>window.location.hash;
const $c5a54dbb0691fc63$export$f710a83a91838a36 = ()=>window.location.origin;
const $c5a54dbb0691fc63$export$d76128d007d19019 = ()=>window.location.search;
const $c5a54dbb0691fc63$export$3ce6949f20cea765 = (url, target)=>window.open(url, target);
const $c5a54dbb0691fc63$export$e6e34fd1f2686227 = (url)=>window.location.assign(url);
const $c5a54dbb0691fc63$export$f15ea956d38b6f8a = (maybeUrl)=>{
    if (decodeURIComponent(maybeUrl).startsWith('//')) return false;
    return (0, $63sfu.startsWith)(maybeUrl, 'http') || (0, $63sfu.startsWith)(maybeUrl, '/') || (0, $63sfu.startsWith)(maybeUrl, '%2F') || (0, $63sfu.startsWith)(maybeUrl, '%2f');
};

});

parcelRegister("6LO3M", function(module, exports) {
$parcel$export(module.exports, "install", () => $298b0b29720f03c1$export$4b3e715f166fdd78);

var $ePuex = parcelRequire("ePuex");
var $KhyL6 = parcelRequire("KhyL6");
var $lVVcj = parcelRequire("lVVcj");

var $522KT = parcelRequire("522KT");

var $dvNUn = parcelRequire("dvNUn");

var $6mmHn = parcelRequire("6mmHn");

var $ebpTf = parcelRequire("ebpTf");
function $298b0b29720f03c1$export$94684a7ef5037b24(event) {
    try {
        var _event$exception;
        const rewriteStacktrace = (value)=>{
            var _value$stacktrace, _value$stacktrace2;
            if (!Array.isArray(value === null || value === void 0 || (_value$stacktrace = value.stacktrace) === null || _value$stacktrace === void 0 ? void 0 : _value$stacktrace.frames)) return;
            value === null || value === void 0 || (_value$stacktrace2 = value.stacktrace) === null || _value$stacktrace2 === void 0 || _value$stacktrace2.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `event.stacktrace`
        rewriteStacktrace(event);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (Array.isArray(event === null || event === void 0 || (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : _event$exception.values)) {
            var _event$exception2;
            event === null || event === void 0 || (_event$exception2 = event.exception) === null || _event$exception2 === void 0 || _event$exception2.values.forEach(rewriteStacktrace);
        }
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return event;
}
function $298b0b29720f03c1$var$getSentryEnv(env) {
    switch(env){
        case (0, $ebpTf.EnvType).PROD:
            return 'production';
        case (0, $ebpTf.EnvType).STAGING:
            return 'staging';
        default:
            return 'development';
    }
}
class $298b0b29720f03c1$var$SentryInstaller {
    static install() {
        // Check if we have already initialised Sentry to be defensive in case two fragments are loaded in the same page, we don't want duplicated error reports.
        const client = $KhyL6.getCurrentHub().getClient();
        if (client && client.getOptions().enabled) return;
        $lVVcj.init({
            dsn: $298b0b29720f03c1$var$SentryInstaller.JS_ERROR_TRACKING_SENTRY_URL,
            release: $298b0b29720f03c1$var$SentryInstaller.getRelease(),
            environment: $298b0b29720f03c1$var$getSentryEnv((0, $ebpTf.getEnv)().environment),
            // This is evaluated against the *first* frame of the stack trace. If it doesn't match, the error is not sent.
            whitelistUrls: $298b0b29720f03c1$var$SentryInstaller.FRONTEND_RESOURCES,
            beforeSend: (event)=>{
                return $298b0b29720f03c1$export$94684a7ef5037b24(event);
            },
            maxBreadcrumbs: 100,
            integrations: (integrations)=>{
                integrations.push(// This is used to mark which frames of the stacktrace are part of our app. They will be displayed in a different UI in Sentry.
                new $522KT.RewriteFrames({
                    iteratee: (frame)=>{
                        if (frame.filename) frame.in_app = $298b0b29720f03c1$var$SentryInstaller.FRONTEND_RESOURCES.some((path)=>// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            path.test(frame.filename));
                        return frame;
                    }
                }));
                return integrations;
            }
        });
        // This is for OpsGenie, so that alerts are tagged correctly.
        $ePuex.configureScope((scope)=>{
            scope.setTag('environment_type', (0, $ebpTf.getEnv)().environment);
            scope.setTag('service_id', 'jsm-portal-frontend');
            const commit = $298b0b29720f03c1$var$SentryInstaller.getCommit();
            if (commit) scope.setTag('commit', commit);
            const cloudId = $298b0b29720f03c1$var$SentryInstaller.getCloudId();
            if (cloudId) scope.setTag('cloud_id', cloudId);
        });
    // TODO: add Aa ID + feature flags state tracking  - FSD-2309
    }
    static #_ = // TODO: extract this URL in a env variable - FSD-2309
    this.JS_ERROR_TRACKING_SENTRY_URL = (0, $dvNUn.isFedRamp)() ? 'https://9f5728b18f4afcbbd6127c57b615afa3@sentry.prod.services.kitt-inf-us-gov-mod.net/15' : 'https://dc9ea62591514adf8234e2c995959d5c@o55978.ingest.sentry.io/5988807';
    static #_2 = this.FRONTEND_RESOURCES = [
        // Our DEV and PROD environments in Micros Static.
        /https:\/\/jsm-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsd-portal-frontend\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atl-paas\.net\//,
        /https:\/\/jsm-help-center-ui\..*\.atlassian-us-gov-mod\.com\//,
        // For devs using `yarn dev`.
        /localhost/
    ];
    static getCommit() {
        if (window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit) return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.commit;
        return undefined;
    }
    static getRelease() {
        return window.JSD_CUSTOMER_PORTAL_BUILD_VERSION && window.JSD_CUSTOMER_PORTAL_BUILD_VERSION.buildKey;
    }
    static getCloudId() {
        return (0, $6mmHn.getMeta)('tenant-id');
    }
}
const $298b0b29720f03c1$export$4b3e715f166fdd78 = $298b0b29720f03c1$var$SentryInstaller.install;

});
parcelRegister("lVVcj", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $ff7b4a1734228768$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $ff7b4a1734228768$export$2cd8252107eb640b);
$parcel$export(module.exports, "showReportDialog", () => $ff7b4a1734228768$export$3a8fd680da42627b);
$parcel$export(module.exports, "lastEventId", () => $ff7b4a1734228768$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "forceLoad", () => $ff7b4a1734228768$export$a3f323d81eede727);
$parcel$export(module.exports, "onLoad", () => $ff7b4a1734228768$export$4e4d8b287d028b6b);
$parcel$export(module.exports, "flush", () => $ff7b4a1734228768$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $ff7b4a1734228768$export$8360e631d277ea4d);
$parcel$export(module.exports, "wrap", () => $ff7b4a1734228768$export$4997ffc0176396a6);

var $d8KcD = parcelRequire("d8KcD");

var $KhyL6 = parcelRequire("KhyL6");
var $h6dCx = parcelRequire("h6dCx");
var $iwFaq = parcelRequire("iwFaq");
parcelRequire("kzlYU");
var $hlQcu = parcelRequire("hlQcu");
var $gLjeB = parcelRequire("gLjeB");
var $6rwao = parcelRequire("6rwao");
var $8pMAa = parcelRequire("8pMAa");

var $3LPRs = parcelRequire("3LPRs");

var $4M6ZE = parcelRequire("4M6ZE");

var $fIcQk = parcelRequire("fIcQk");

var $3uF9Q = parcelRequire("3uF9Q");
var $dhEHm = parcelRequire("dhEHm");
var $iMRuB = parcelRequire("iMRuB");
var $kWwDh = parcelRequire("kWwDh");
var $k5dhX = parcelRequire("k5dhX");
var $cbP8C = parcelRequire("cbP8C");
var $ff7b4a1734228768$export$5ef831fccfce35e5 = [
    new (0, $iwFaq).InboundFilters(),
    new (0, $iwFaq).FunctionToString(),
    new (0, $k5dhX.TryCatch)(),
    new (0, $3uF9Q.Breadcrumbs)(),
    new (0, $iMRuB.GlobalHandlers)(),
    new (0, $kWwDh.LinkedErrors)(),
    new (0, $dhEHm.Dedupe)(),
    new (0, $cbP8C.UserAgent)()
];
function $ff7b4a1734228768$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $ff7b4a1734228768$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $gLjeB.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    (0, $h6dCx.initAndBind)((0, $3LPRs.BrowserClient), options);
    if (options.autoSessionTracking) $ff7b4a1734228768$var$startSessionTracking();
}
function $ff7b4a1734228768$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    var hub = (0, $KhyL6.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) options.user = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, scope.getUser()), options.user);
    if (!options.eventId) options.eventId = hub.lastEventId();
    var client = hub.getClient();
    if (client) client.showReportDialog(options);
}
function $ff7b4a1734228768$export$5d4e9fd7fac8e617() {
    return (0, $KhyL6.getCurrentHub)().lastEventId();
}
function $ff7b4a1734228768$export$a3f323d81eede727() {
// Noop
}
function $ff7b4a1734228768$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $ff7b4a1734228768$export$4909b86c8034bf73(timeout) {
    var client = (0, $KhyL6.getCurrentHub)().getClient();
    if (client) return client.flush(timeout);
    (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Cannot flush events. No client defined.');
    return (0, $8pMAa.resolvedSyncPromise)(false);
}
function $ff7b4a1734228768$export$8360e631d277ea4d(timeout) {
    var client = (0, $KhyL6.getCurrentHub)().getClient();
    if (client) return client.close(timeout);
    (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return (0, $8pMAa.resolvedSyncPromise)(false);
}
function $ff7b4a1734228768$export$4997ffc0176396a6(fn) {
    return (0, $fIcQk.wrap)(fn)();
}
function $ff7b4a1734228768$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $ff7b4a1734228768$var$startSessionTracking() {
    var window = (0, $gLjeB.getGlobalObject)();
    var document = window.document;
    if (typeof document === 'undefined') {
        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = (0, $KhyL6.getCurrentHub)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $ff7b4a1734228768$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $hlQcu.addInstrumentationHandler)('history', function(_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $ff7b4a1734228768$var$startSessionOnHub((0, $KhyL6.getCurrentHub)());
    });
}

});
parcelRegister("h6dCx", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $c72d8ff7f148ffb8$export$5333c3f1c58d9bc1);

var $KhyL6 = parcelRequire("KhyL6");
parcelRequire("kzlYU");
var $6rwao = parcelRequire("6rwao");

var $1D8Qu = parcelRequire("1D8Qu");
function $c72d8ff7f148ffb8$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $1D8Qu.IS_DEBUG_BUILD) (0, $6rwao.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
    var hub = (0, $KhyL6.getCurrentHub)();
    var scope = hub.getScope();
    if (scope) scope.update(options.initialScope);
    var client = new clientClass(options);
    hub.bindClient(client);
}

});
parcelRegister("1D8Qu", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $13004b8586b90244$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $13004b8586b90244$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("iwFaq", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("2yDux")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("7YO6D")).InboundFilters);

var $2yDux = parcelRequire("2yDux");

var $7YO6D = parcelRequire("7YO6D");

});
parcelRegister("2yDux", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => $1dcd63f5004453d6$export$da4704525c20ae79);
parcelRequire("kzlYU");
var $1Haiv = parcelRequire("1Haiv");
var $1dcd63f5004453d6$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $1dcd63f5004453d6$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $1dcd63f5004453d6$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = (0, $1Haiv.getOriginalFunction)(this) || this;
            return $1dcd63f5004453d6$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}();

});

parcelRegister("7YO6D", function(module, exports) {
$parcel$export(module.exports, "InboundFilters", () => $5cf501025ec5cf39$export$2ffbb5359dcc6be4);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("kzlYU");
var $1WJpp = parcelRequire("1WJpp");
var $caql8 = parcelRequire("caql8");
var $6rwao = parcelRequire("6rwao");

var $1D8Qu = parcelRequire("1D8Qu");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $5cf501025ec5cf39$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $5cf501025ec5cf39$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = $5cf501025ec5cf39$export$6620a151868b99aa(self_1._options, clientOptions);
                    return $5cf501025ec5cf39$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}();
function $5cf501025ec5cf39$export$6620a151868b99aa(internalOptions, clientOptions) {
    if (internalOptions === void 0) internalOptions = {};
    if (clientOptions === void 0) clientOptions = {};
    return {
        allowUrls: (0, $d8KcD.__spread)(internalOptions.whitelistUrls || [], internalOptions.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
        denyUrls: (0, $d8KcD.__spread)(internalOptions.blacklistUrls || [], internalOptions.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
        ignoreErrors: (0, $d8KcD.__spread)(internalOptions.ignoreErrors || [], clientOptions.ignoreErrors || [], $5cf501025ec5cf39$var$DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $5cf501025ec5cf39$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $5cf501025ec5cf39$var$_isSentryError(event)) {
        (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $1WJpp.getEventDescription)(event));
        return true;
    }
    if ($5cf501025ec5cf39$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $1WJpp.getEventDescription)(event));
        return true;
    }
    if ($5cf501025ec5cf39$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $1WJpp.getEventDescription)(event) + ".\nUrl: " + $5cf501025ec5cf39$var$_getEventFilterUrl(event));
        return true;
    }
    if (!$5cf501025ec5cf39$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $1WJpp.getEventDescription)(event) + ".\nUrl: " + $5cf501025ec5cf39$var$_getEventFilterUrl(event));
        return true;
    }
    return false;
}
function $5cf501025ec5cf39$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) return false;
    return $5cf501025ec5cf39$var$_getPossibleEventMessages(event).some(function(message) {
        return ignoreErrors.some(function(pattern) {
            return (0, $caql8.isMatchingPattern)(message, pattern);
        });
    });
}
function $5cf501025ec5cf39$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = $5cf501025ec5cf39$var$_getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function(pattern) {
        return (0, $caql8.isMatchingPattern)(url, pattern);
    });
}
function $5cf501025ec5cf39$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = $5cf501025ec5cf39$var$_getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function(pattern) {
        return (0, $caql8.isMatchingPattern)(url, pattern);
    });
}
function $5cf501025ec5cf39$var$_getPossibleEventMessages(event) {
    if (event.message) return [
        event.message
    ];
    if (event.exception) try {
        var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
        return [
            "" + value,
            type + ": " + value
        ];
    } catch (oO) {
        (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error("Cannot extract message for event " + (0, $1WJpp.getEventDescription)(event));
        return [];
    }
    return [];
}
function $5cf501025ec5cf39$var$_isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $5cf501025ec5cf39$var$_getLastValidUrl(frames) {
    if (frames === void 0) frames = [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $5cf501025ec5cf39$var$_getEventFilterUrl(event) {
    try {
        if (event.stacktrace) return $5cf501025ec5cf39$var$_getLastValidUrl(event.stacktrace.frames);
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames_1 ? $5cf501025ec5cf39$var$_getLastValidUrl(frames_1) : null;
    } catch (oO) {
        (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error("Cannot extract url for event " + (0, $1WJpp.getEventDescription)(event));
        return null;
    }
}

});


parcelRegister("3LPRs", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $2bedfd6b62f733bd$export$1df9218a526d318d);

var $d8KcD = parcelRequire("d8KcD");

var $l1JJM = parcelRequire("l1JJM");
var $l9dIb = parcelRequire("l9dIb");
parcelRequire("kzlYU");
var $gLjeB = parcelRequire("gLjeB");
var $6rwao = parcelRequire("6rwao");

var $iF3zS = parcelRequire("iF3zS");

var $4M6ZE = parcelRequire("4M6ZE");

var $fIcQk = parcelRequire("fIcQk");

var $3uF9Q = parcelRequire("3uF9Q");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $2bedfd6b62f733bd$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $l9dIb.SDK_VERSION)
                }
            ],
            version: (0, $l9dIb.SDK_VERSION)
        };
        _this = _super.call(this, (0, $iF3zS.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $gLjeB.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $fIcQk.injectReportDialog)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $3uF9Q.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $l1JJM.BaseClient));

});
parcelRegister("l1JJM", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $f4ed2b7b0efcaa45$export$4f22f74eddb7716a);

var $d8KcD = parcelRequire("d8KcD");

var $1Isls = parcelRequire("1Isls");
parcelRequire("kzlYU");
var $1WJpp = parcelRequire("1WJpp");
var $7V4My = parcelRequire("7V4My");
var $gzHhz = parcelRequire("gzHhz");
var $6rwao = parcelRequire("6rwao");
var $12JF9 = parcelRequire("12JF9");
var $fzdxc = parcelRequire("fzdxc");
var $8pMAa = parcelRequire("8pMAa");
var $7Uuus = parcelRequire("7Uuus");
var $caql8 = parcelRequire("caql8");

var $1D8Qu = parcelRequire("1D8Qu");

var $fJIqJ = parcelRequire("fJIqJ");
var $f4ed2b7b0efcaa45$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $f4ed2b7b0efcaa45$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $12JF9.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $1WJpp.checkOrSetAlreadyCaught)(exception)) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).log($f4ed2b7b0efcaa45$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $gzHhz.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $1WJpp.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).log($f4ed2b7b0efcaa45$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $fJIqJ.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $d8KcD.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $8pMAa.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $1WJpp.uuid4)()),
            timestamp: event.timestamp || (0, $7V4My.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $1Isls.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $8pMAa.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $fzdxc.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, b), b.data && {
                    data: (0, $fzdxc.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $fzdxc.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $fzdxc.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $fzdxc.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $caql8.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $caql8.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $caql8.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $d8KcD.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $8pMAa.rejectedSyncPromise)(new (0, $7Uuus.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $8pMAa.rejectedSyncPromise)(new (0, $7Uuus.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $7Uuus.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $f4ed2b7b0efcaa45$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $7Uuus.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $7Uuus.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $7Uuus.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $f4ed2b7b0efcaa45$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $gzHhz.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $gzHhz.isPlainObject)(event) || event === null)) throw new (0, $7Uuus.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $7Uuus.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $gzHhz.isPlainObject)(rv) || rv === null)) throw new (0, $7Uuus.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("fJIqJ", function(module, exports) {
$parcel$export(module.exports, "setupIntegrations", () => $b74d85dff1144e02$export$51abed9797baa598);

var $d8KcD = parcelRequire("d8KcD");

var $1Isls = parcelRequire("1Isls");
var $KhyL6 = parcelRequire("KhyL6");
parcelRequire("kzlYU");
var $1Haiv = parcelRequire("1Haiv");
var $6rwao = parcelRequire("6rwao");

var $1D8Qu = parcelRequire("1D8Qu");
var $b74d85dff1144e02$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $b74d85dff1144e02$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $b74d85dff1144e02$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $d8KcD.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $d8KcD.__spread)($b74d85dff1144e02$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $d8KcD.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $b74d85dff1144e02$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $d8KcD.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $b74d85dff1144e02$export$e7390a03b70a6f2f(integration) {
    if ($b74d85dff1144e02$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $1Isls.addGlobalEventProcessor), (0, $KhyL6.getCurrentHub));
    $b74d85dff1144e02$export$b14a8888f80a0b3e.push(integration.name);
    (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).log("Integration installed: " + integration.name);
}
function $b74d85dff1144e02$export$51abed9797baa598(options) {
    var integrations = {};
    $b74d85dff1144e02$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $b74d85dff1144e02$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $1Haiv.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});


parcelRegister("l9dIb", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $f65513129bf4fa36$export$31499a9cd224b78c);
var $f65513129bf4fa36$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("iF3zS", function(module, exports) {
$parcel$export(module.exports, "BrowserBackend", () => $d95ed4c73ffb5319$export$2526e21aec9d0ce7);

var $d8KcD = parcelRequire("d8KcD");

var $2TVxv = parcelRequire("2TVxv");
var $czdXu = parcelRequire("czdXu");

var $ahlU2 = parcelRequire("ahlU2");
parcelRequire("kzlYU");
var $lCv2K = parcelRequire("lCv2K");

var $dY1vR = parcelRequire("dY1vR");

var $71od0 = parcelRequire("71od0");
var $I9px3 = parcelRequire("I9px3");
var $4YhAB = parcelRequire("4YhAB");
var $7feBg = parcelRequire("7feBg");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $d95ed4c73ffb5319$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $dY1vR.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $ahlU2.Severity).Info;
        return (0, $dY1vR.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $czdXu.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $czdXu.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $lCv2K.supportsFetch)()) {
            var requestOptions = (0, $d8KcD.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $I9px3.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $71od0.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $4YhAB.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $7feBg.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $2TVxv.BaseBackend));

});
parcelRegister("2TVxv", function(module, exports) {
$parcel$export(module.exports, "BaseBackend", () => $21cd59f0160218c6$export$8f43a53a38d7e95f);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("kzlYU");
var $6rwao = parcelRequire("6rwao");
var $7Uuus = parcelRequire("7Uuus");

var $czdXu = parcelRequire("czdXu");

var $1D8Qu = parcelRequire("1D8Qu");

var $aocAe = parcelRequire("aocAe");

var $kf1b9 = parcelRequire("kf1b9");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $21cd59f0160218c6$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $7Uuus.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $7Uuus.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $czdXu.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $aocAe.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $czdXu.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $d8KcD.__read)((0, $aocAe.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $1D8Qu.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $kf1b9.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("czdXu", function(module, exports) {
$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $926394cc74fb4e3c$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $926394cc74fb4e3c$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $926394cc74fb4e3c$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $926394cc74fb4e3c$export$671c7ed8e40a7a57);
parcelRequire("kzlYU");
var $12JF9 = parcelRequire("12JF9");
var $1Haiv = parcelRequire("1Haiv");
var $926394cc74fb4e3c$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $926394cc74fb4e3c$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $12JF9.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $926394cc74fb4e3c$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $926394cc74fb4e3c$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $926394cc74fb4e3c$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $926394cc74fb4e3c$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $926394cc74fb4e3c$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $12JF9.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $926394cc74fb4e3c$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $926394cc74fb4e3c$var$_getIngestEndpoint(dsn, target) {
    return "" + $926394cc74fb4e3c$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $926394cc74fb4e3c$var$_encodedAuth(dsn) {
    return (0, $1Haiv.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $926394cc74fb4e3c$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $926394cc74fb4e3c$var$getStoreEndpoint(dsn) {
    return $926394cc74fb4e3c$var$_getIngestEndpoint(dsn, 'store');
}
function $926394cc74fb4e3c$export$c1677e22ac2217a5(dsn) {
    return $926394cc74fb4e3c$var$getStoreEndpoint(dsn) + "?" + $926394cc74fb4e3c$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $926394cc74fb4e3c$var$_getEnvelopeEndpoint(dsn) {
    return $926394cc74fb4e3c$var$_getIngestEndpoint(dsn, 'envelope');
}
function $926394cc74fb4e3c$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $926394cc74fb4e3c$var$_getEnvelopeEndpoint(dsn) + "?" + $926394cc74fb4e3c$var$_encodedAuth(dsn);
}
function $926394cc74fb4e3c$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $926394cc74fb4e3c$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $926394cc74fb4e3c$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $12JF9.makeDsn)(dsnLike);
    var endpoint = $926394cc74fb4e3c$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $12JF9.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("aocAe", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $7905e80f0606064d$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $7905e80f0606064d$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $7905e80f0606064d$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $7905e80f0606064d$export$2006389de558b996);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("kzlYU");
var $i6KQw = parcelRequire("i6KQw");
var $12JF9 = parcelRequire("12JF9");
var $fzdxc = parcelRequire("fzdxc");

var $czdXu = parcelRequire("czdXu");
/** Extract sdk info from from the API metadata */ function $7905e80f0606064d$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $7905e80f0606064d$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $d8KcD.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $d8KcD.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $7905e80f0606064d$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $7905e80f0606064d$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $12JF9.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $i6KQw.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $7905e80f0606064d$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $d8KcD.__read)($7905e80f0606064d$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $i6KQw.serializeEnvelope)(envelope),
        type: type,
        url: (0, $czdXu.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $7905e80f0606064d$export$c31057337a18010f(event, api) {
    var sdkInfo = $7905e80f0606064d$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $7905e80f0606064d$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $12JF9.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $i6KQw.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $7905e80f0606064d$export$2006389de558b996(event, api) {
    var sdkInfo = $7905e80f0606064d$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $7905e80f0606064d$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $fzdxc.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $czdXu.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $czdXu.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $12JF9.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $i6KQw.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $i6KQw.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("kf1b9", function(module, exports) {
$parcel$export(module.exports, "NoopTransport", () => $ebc61f78b8bef31e$export$6f2767450ea1346c);
parcelRequire("kzlYU");
var $8pMAa = parcelRequire("8pMAa");
/** Noop transport */ var $ebc61f78b8bef31e$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $8pMAa.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $8pMAa.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("dY1vR", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $a2b20d5c79c75979$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $a2b20d5c79c75979$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $a2b20d5c79c75979$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $a2b20d5c79c75979$export$5425b53185d13d6c);

var $d8KcD = parcelRequire("d8KcD");

var $ahlU2 = parcelRequire("ahlU2");
parcelRequire("kzlYU");
var $1WJpp = parcelRequire("1WJpp");
var $bSrCK = parcelRequire("bSrCK");
var $1Haiv = parcelRequire("1Haiv");
var $gzHhz = parcelRequire("gzHhz");
var $fzdxc = parcelRequire("fzdxc");
var $8pMAa = parcelRequire("8pMAa");

var $6RDRy = parcelRequire("6RDRy");
function $a2b20d5c79c75979$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $a2b20d5c79c75979$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $a2b20d5c79c75979$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $a2b20d5c79c75979$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $gzHhz.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $1Haiv.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $fzdxc.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $a2b20d5c79c75979$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $a2b20d5c79c75979$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $a2b20d5c79c75979$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $a2b20d5c79c75979$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $a2b20d5c79c75979$var$getPopSize(ex);
    try {
        return (0, $bSrCK.createStackParser)((0, $6RDRy.opera10StackParser), (0, $6RDRy.opera11StackParser), (0, $6RDRy.chromeStackParser), (0, $6RDRy.winjsStackParser), (0, $6RDRy.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $a2b20d5c79c75979$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $a2b20d5c79c75979$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($a2b20d5c79c75979$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $a2b20d5c79c75979$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $a2b20d5c79c75979$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $a2b20d5c79c75979$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $1WJpp.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $ahlU2.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $8pMAa.resolvedSyncPromise)(event);
}
function $a2b20d5c79c75979$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $ahlU2.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $a2b20d5c79c75979$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $8pMAa.resolvedSyncPromise)(event);
}
function $a2b20d5c79c75979$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $gzHhz.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $a2b20d5c79c75979$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $gzHhz.isDOMError)(exception) || (0, $gzHhz.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $a2b20d5c79c75979$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $gzHhz.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $a2b20d5c79c75979$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $1WJpp.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $gzHhz.isError)(exception)) // we have a real Error object, do nothing
    return $a2b20d5c79c75979$export$73fbea5a0a5234af(exception);
    if ((0, $gzHhz.isPlainObject)(exception) || (0, $gzHhz.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $a2b20d5c79c75979$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $1WJpp.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $a2b20d5c79c75979$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $1WJpp.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $1WJpp.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $a2b20d5c79c75979$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $a2b20d5c79c75979$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("6RDRy", function(module, exports) {
$parcel$export(module.exports, "chromeStackParser", () => $4ff69d39f68e8764$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $4ff69d39f68e8764$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $4ff69d39f68e8764$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $4ff69d39f68e8764$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $4ff69d39f68e8764$export$989a1824b4734ce6);

var $d8KcD = parcelRequire("d8KcD");
// global reference to slice
var $4ff69d39f68e8764$var$UNKNOWN_FUNCTION = '?';
var $4ff69d39f68e8764$var$OPERA10_PRIORITY = 10;
var $4ff69d39f68e8764$var$OPERA11_PRIORITY = 20;
var $4ff69d39f68e8764$var$CHROME_PRIORITY = 30;
var $4ff69d39f68e8764$var$WINJS_PRIORITY = 40;
var $4ff69d39f68e8764$var$GECKO_PRIORITY = 50;
function $4ff69d39f68e8764$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $4ff69d39f68e8764$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $4ff69d39f68e8764$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $4ff69d39f68e8764$var$chrome = function(line) {
    var parts = $4ff69d39f68e8764$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $4ff69d39f68e8764$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $d8KcD.__read)($4ff69d39f68e8764$var$extractSafariExtensionDetails(parts[1] || $4ff69d39f68e8764$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $4ff69d39f68e8764$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $4ff69d39f68e8764$export$c693d9295441d8f9 = [
    $4ff69d39f68e8764$var$CHROME_PRIORITY,
    $4ff69d39f68e8764$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $4ff69d39f68e8764$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $4ff69d39f68e8764$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $4ff69d39f68e8764$var$gecko = function(line) {
    var _a;
    var parts = $4ff69d39f68e8764$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $4ff69d39f68e8764$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $4ff69d39f68e8764$var$UNKNOWN_FUNCTION;
        _a = (0, $d8KcD.__read)($4ff69d39f68e8764$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $4ff69d39f68e8764$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $4ff69d39f68e8764$export$c9ddf1e2b5d48bff = [
    $4ff69d39f68e8764$var$GECKO_PRIORITY,
    $4ff69d39f68e8764$var$gecko
];
var $4ff69d39f68e8764$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $4ff69d39f68e8764$var$winjs = function(line) {
    var parts = $4ff69d39f68e8764$var$winjsRegex.exec(line);
    return parts ? $4ff69d39f68e8764$var$createFrame(parts[2], parts[1] || $4ff69d39f68e8764$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $4ff69d39f68e8764$export$b6d155d85c1dcba5 = [
    $4ff69d39f68e8764$var$WINJS_PRIORITY,
    $4ff69d39f68e8764$var$winjs
];
var $4ff69d39f68e8764$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $4ff69d39f68e8764$var$opera10 = function(line) {
    var parts = $4ff69d39f68e8764$var$opera10Regex.exec(line);
    return parts ? $4ff69d39f68e8764$var$createFrame(parts[2], parts[3] || $4ff69d39f68e8764$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $4ff69d39f68e8764$export$966ec832d9699d6 = [
    $4ff69d39f68e8764$var$OPERA10_PRIORITY,
    $4ff69d39f68e8764$var$opera10
];
var $4ff69d39f68e8764$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $4ff69d39f68e8764$var$opera11 = function(line) {
    var parts = $4ff69d39f68e8764$var$opera11Regex.exec(line);
    return parts ? $4ff69d39f68e8764$var$createFrame(parts[5], parts[3] || parts[4] || $4ff69d39f68e8764$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $4ff69d39f68e8764$export$989a1824b4734ce6 = [
    $4ff69d39f68e8764$var$OPERA11_PRIORITY,
    $4ff69d39f68e8764$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $4ff69d39f68e8764$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $4ff69d39f68e8764$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("71od0", function(module, exports) {
$parcel$export(module.exports, "FetchTransport", () => $51cb67bb642f2a50$export$2bdee3f9b92f4e82);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("kzlYU");
var $7Uuus = parcelRequire("7Uuus");
var $lCv2K = parcelRequire("lCv2K");
var $8pMAa = parcelRequire("8pMAa");

var $iiUL0 = parcelRequire("iiUL0");

var $aAx5k = parcelRequire("aAx5k");
/** `fetch` based transport */ var $51cb67bb642f2a50$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $aAx5k.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $lCv2K.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $8pMAa.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $7Uuus.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $iiUL0.BaseTransport));

});
parcelRegister("iiUL0", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => $d535ef34150764ba$export$74b99d619e90f481);

var $d8KcD = parcelRequire("d8KcD");

var $aocAe = parcelRequire("aocAe");
var $czdXu = parcelRequire("czdXu");
parcelRequire("kzlYU");
var $cWrcf = parcelRequire("cWrcf");
var $iGPXA = parcelRequire("iGPXA");
var $12JF9 = parcelRequire("12JF9");
var $2kC7D = parcelRequire("2kC7D");
var $gLjeB = parcelRequire("gLjeB");
var $6rwao = parcelRequire("6rwao");
var $9HvcJ = parcelRequire("9HvcJ");
var $i6KQw = parcelRequire("i6KQw");

var $4M6ZE = parcelRequire("4M6ZE");

var $aAx5k = parcelRequire("aAx5k");
function $d535ef34150764ba$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $d535ef34150764ba$var$global = (0, $gLjeB.getGlobalObject)();
/** Base Transport class implementation */ var $d535ef34150764ba$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $9HvcJ.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $czdXu.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $czdXu.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $d535ef34150764ba$var$global.document) $d535ef34150764ba$var$global.document.addEventListener('visibilitychange', function() {
            if ($d535ef34150764ba$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $aocAe.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $aocAe.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $d535ef34150764ba$var$requestTypeToCategory(category) + ":" + reason;
        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).log('No outcomes to flush');
            return;
        }
        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $czdXu.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $d8KcD.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $cWrcf.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $12JF9.dsnToString)(this._api.dsn));
        try {
            (0, $aAx5k.sendReport)(url, (0, $i6KQw.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $2kC7D.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $iGPXA.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $4M6ZE.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $6rwao.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $d535ef34150764ba$var$requestTypeToCategory(requestType);
        return new Date((0, $iGPXA.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $d535ef34150764ba$var$requestTypeToCategory(requestType);
        return (0, $iGPXA.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("4M6ZE", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $37a111de212473ee$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $37a111de212473ee$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("aAx5k", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $7b56ee2d13103957$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $7b56ee2d13103957$export$84bb63b2c17ec44d);
parcelRequire("kzlYU");
var $giojG = parcelRequire("giojG");
var $gLjeB = parcelRequire("gLjeB");
var $lCv2K = parcelRequire("lCv2K");
var $6rwao = parcelRequire("6rwao");

var $4M6ZE = parcelRequire("4M6ZE");
var $7b56ee2d13103957$var$global = (0, $gLjeB.getGlobalObject)();
var $7b56ee2d13103957$var$cachedFetchImpl;
function $7b56ee2d13103957$export$8be2119ce08e3379() {
    if ($7b56ee2d13103957$var$cachedFetchImpl) return $7b56ee2d13103957$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $lCv2K.isNativeFetch)($7b56ee2d13103957$var$global.fetch)) return $7b56ee2d13103957$var$cachedFetchImpl = $7b56ee2d13103957$var$global.fetch.bind($7b56ee2d13103957$var$global);
    var document = $7b56ee2d13103957$var$global.document;
    var fetchImpl = $7b56ee2d13103957$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $7b56ee2d13103957$var$cachedFetchImpl = fetchImpl.bind($7b56ee2d13103957$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $7b56ee2d13103957$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($7b56ee2d13103957$var$global && $7b56ee2d13103957$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $7b56ee2d13103957$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $7b56ee2d13103957$var$global.navigator.sendBeacon.bind($7b56ee2d13103957$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $lCv2K.supportsFetch)()) {
        var fetch_1 = $7b56ee2d13103957$export$8be2119ce08e3379();
        return (0, $giojG.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("I9px3", function(module, exports) {
$parcel$export(module.exports, "makeNewFetchTransport", () => $084b68f762fe97b8$export$1c57e6bfd09bad13);

var $d8KcD = parcelRequire("d8KcD");

var $kkKmu = parcelRequire("kkKmu");

var $aAx5k = parcelRequire("aAx5k");
function $084b68f762fe97b8$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $aAx5k.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $d8KcD.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $kkKmu.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("kkKmu", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $ecd9a35d0c06939d$export$d09f50d9ab7f7b69);
parcelRequire("kzlYU");
var $iGPXA = parcelRequire("iGPXA");
var $2kC7D = parcelRequire("2kC7D");
var $i6KQw = parcelRequire("i6KQw");
var $9HvcJ = parcelRequire("9HvcJ");
var $8pMAa = parcelRequire("8pMAa");
var $ecd9a35d0c06939d$export$d8a725a7dce95622 = 'error';
var $ecd9a35d0c06939d$export$99adc6fe67a3c63e = 'transaction';
var $ecd9a35d0c06939d$export$9d7ad34f132fe68f = 'attachment';
var $ecd9a35d0c06939d$export$42d9e7b5fc564c45 = 'session';
var $ecd9a35d0c06939d$export$e515cf6dfd2f98b8 = 30;
function $ecd9a35d0c06939d$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $9HvcJ.makePromiseBuffer)(options.bufferSize || $ecd9a35d0c06939d$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $i6KQw.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $i6KQw.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $iGPXA.isRateLimited)(rateLimits, category)) return (0, $8pMAa.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $ecd9a35d0c06939d$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $2kC7D.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $iGPXA.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $8pMAa.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $8pMAa.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $ecd9a35d0c06939d$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $ecd9a35d0c06939d$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $iGPXA.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("4YhAB", function(module, exports) {
$parcel$export(module.exports, "makeNewXHRTransport", () => $39ea68e15d9a922d$export$4c0ac1dd4bbf4921);

var $kkKmu = parcelRequire("kkKmu");
parcelRequire("kzlYU");
var $8pMAa = parcelRequire("8pMAa");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $39ea68e15d9a922d$var$XHR_READYSTATE_DONE = 4;
function $39ea68e15d9a922d$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $8pMAa.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $39ea68e15d9a922d$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $kkKmu.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("7feBg", function(module, exports) {
$parcel$export(module.exports, "XHRTransport", () => $54654267e13b8def$export$874a283af77e8e62);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("kzlYU");
var $7Uuus = parcelRequire("7Uuus");
var $8pMAa = parcelRequire("8pMAa");

var $iiUL0 = parcelRequire("iiUL0");
/** `XHR` based transport */ var $54654267e13b8def$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $8pMAa.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $7Uuus.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $iiUL0.BaseTransport));

});


parcelRegister("fIcQk", function(module, exports) {
$parcel$export(module.exports, "shouldIgnoreOnError", () => $b704ed72fecdbb5f$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $b704ed72fecdbb5f$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $b704ed72fecdbb5f$export$deb9aac8ea0b576c);

var $d8KcD = parcelRequire("d8KcD");

var $ePuex = parcelRequire("ePuex");
var $czdXu = parcelRequire("czdXu");
parcelRequire("kzlYU");
var $1WJpp = parcelRequire("1WJpp");
var $1Haiv = parcelRequire("1Haiv");
var $gLjeB = parcelRequire("gLjeB");
var $6rwao = parcelRequire("6rwao");

var $4M6ZE = parcelRequire("4M6ZE");
var $b704ed72fecdbb5f$var$global = (0, $gLjeB.getGlobalObject)();
var $b704ed72fecdbb5f$var$ignoreOnError = 0;
function $b704ed72fecdbb5f$export$b79738ab10c590b2() {
    return $b704ed72fecdbb5f$var$ignoreOnError > 0;
}
function $b704ed72fecdbb5f$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b704ed72fecdbb5f$var$ignoreOnError += 1;
    setTimeout(function() {
        $b704ed72fecdbb5f$var$ignoreOnError -= 1;
    });
}
function $b704ed72fecdbb5f$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $1Haiv.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $b704ed72fecdbb5f$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b704ed72fecdbb5f$export$1265a142ff5ba165();
            (0, $ePuex.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $1WJpp.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $1WJpp.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $ePuex.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $1Haiv.markFunctionWrapped)(sentryWrapped, fn);
    (0, $1Haiv.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $b704ed72fecdbb5f$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$b704ed72fecdbb5f$var$global.document) return;
    if (!options.eventId) {
        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $b704ed72fecdbb5f$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $czdXu.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $b704ed72fecdbb5f$var$global.document.head || $b704ed72fecdbb5f$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});

parcelRegister("3uF9Q", function(module, exports) {
$parcel$export(module.exports, "Breadcrumbs", () => $28b4198b22dc47d5$export$2dc68d50d56fbbd);

var $d8KcD = parcelRequire("d8KcD");

var $KhyL6 = parcelRequire("KhyL6");

var $ahlU2 = parcelRequire("ahlU2");
parcelRequire("kzlYU");
var $hlQcu = parcelRequire("hlQcu");
var $1WJpp = parcelRequire("1WJpp");
var $gLjeB = parcelRequire("gLjeB");
var $5ruYt = parcelRequire("5ruYt");
var $caql8 = parcelRequire("caql8");
var $4rAdB = parcelRequire("4rAdB");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $28b4198b22dc47d5$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $d8KcD.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $KhyL6.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $1WJpp.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $hlQcu.addInstrumentationHandler)('console', $28b4198b22dc47d5$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $hlQcu.addInstrumentationHandler)('dom', $28b4198b22dc47d5$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $hlQcu.addInstrumentationHandler)('xhr', $28b4198b22dc47d5$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $hlQcu.addInstrumentationHandler)('fetch', $28b4198b22dc47d5$var$_fetchBreadcrumb);
        if (this._options.history) (0, $hlQcu.addInstrumentationHandler)('history', $28b4198b22dc47d5$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28b4198b22dc47d5$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $5ruYt.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $5ruYt.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $KhyL6.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28b4198b22dc47d5$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $4rAdB.severityFromString)(handlerData.level),
        message: (0, $caql8.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $caql8.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $KhyL6.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28b4198b22dc47d5$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $KhyL6.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28b4198b22dc47d5$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $KhyL6.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $ahlU2.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $KhyL6.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $28b4198b22dc47d5$var$_historyBreadcrumb(handlerData) {
    var global = (0, $gLjeB.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $1WJpp.parseUrl)(global.location.href);
    var parsedFrom = (0, $1WJpp.parseUrl)(from);
    var parsedTo = (0, $1WJpp.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $KhyL6.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("dhEHm", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $9abc6ec1e3836b03$export$688d98c249d31ad3);
parcelRequire("kzlYU");
var $6rwao = parcelRequire("6rwao");

var $4M6ZE = parcelRequire("4M6ZE");
/** Deduplication filter */ var $9abc6ec1e3836b03$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($9abc6ec1e3836b03$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
/** JSDoc */ function $9abc6ec1e3836b03$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($9abc6ec1e3836b03$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($9abc6ec1e3836b03$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $9abc6ec1e3836b03$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$9abc6ec1e3836b03$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9abc6ec1e3836b03$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $9abc6ec1e3836b03$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $9abc6ec1e3836b03$var$_getExceptionFromEvent(previousEvent);
    var currentException = $9abc6ec1e3836b03$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$9abc6ec1e3836b03$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$9abc6ec1e3836b03$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $9abc6ec1e3836b03$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $9abc6ec1e3836b03$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $9abc6ec1e3836b03$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $9abc6ec1e3836b03$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $9abc6ec1e3836b03$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $9abc6ec1e3836b03$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});

parcelRegister("iMRuB", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => $dad63436209e1cb8$export$204155decbc90e5a);

var $d8KcD = parcelRequire("d8KcD");

var $KhyL6 = parcelRequire("KhyL6");

var $ahlU2 = parcelRequire("ahlU2");
parcelRequire("kzlYU");
var $1WJpp = parcelRequire("1WJpp");
var $hlQcu = parcelRequire("hlQcu");
var $5ruYt = parcelRequire("5ruYt");
var $gzHhz = parcelRequire("gzHhz");
var $6rwao = parcelRequire("6rwao");

var $dY1vR = parcelRequire("dY1vR");

var $4M6ZE = parcelRequire("4M6ZE");

var $fIcQk = parcelRequire("fIcQk");
/** Global handlers */ var $dad63436209e1cb8$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */ this._installFunc = {
            onerror: $dad63436209e1cb8$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $dad63436209e1cb8$var$_installGlobalOnUnhandledRejectionHandler
        };
        this._options = (0, $d8KcD.__assign)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(var key in options){
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $dad63436209e1cb8$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}();
/** JSDoc */ function $dad63436209e1cb8$var$_installGlobalOnErrorHandler() {
    (0, $hlQcu.addInstrumentationHandler)('error', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(data) {
        var _a = (0, $d8KcD.__read)($dad63436209e1cb8$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($dad63436209e1cb8$export$204155decbc90e5a)) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if ((0, $fIcQk.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return;
        var event = error === undefined && (0, $gzHhz.isString)(msg) ? $dad63436209e1cb8$var$_eventFromIncompleteOnError(msg, url, line, column) : $dad63436209e1cb8$var$_enhanceEventWithInitialFrame((0, $dY1vR.eventFromUnknownInput)(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = (0, $ahlU2.Severity).Error;
        $dad63436209e1cb8$var$addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */ function $dad63436209e1cb8$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $hlQcu.addInstrumentationHandler)('unhandledrejection', // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(e) {
        var _a = (0, $d8KcD.__read)($dad63436209e1cb8$var$getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration($dad63436209e1cb8$export$204155decbc90e5a)) return;
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) error = e.reason;
            else if ('detail' in e && 'reason' in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $fIcQk.shouldIgnoreOnError)() || error && error.__sentry_own_request__) return true;
        var event = (0, $gzHhz.isPrimitive)(error) ? $dad63436209e1cb8$var$_eventFromRejectionWithPrimitive(error) : (0, $dY1vR.eventFromUnknownInput)(error, undefined, attachStacktrace, true);
        event.level = (0, $ahlU2.Severity).Error;
        $dad63436209e1cb8$var$addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $dad63436209e1cb8$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason)
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dad63436209e1cb8$var$_eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, $gzHhz.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $dad63436209e1cb8$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dad63436209e1cb8$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, $gzHhz.isString)(url) && url.length > 0 ? url : (0, $5ruYt.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $dad63436209e1cb8$var$globalHandlerLog(type) {
    (0, $4M6ZE.IS_DEBUG_BUILD) && (0, $6rwao.logger).log("Global Handler attached: " + type);
}
function $dad63436209e1cb8$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $1WJpp.addExceptionMechanism)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $dad63436209e1cb8$var$getHubAndAttachStacktrace() {
    var hub = (0, $KhyL6.getCurrentHub)();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [
        hub,
        attachStacktrace
    ];
}

});

parcelRegister("kWwDh", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $f3f289907e5e208b$export$8d1e60aaf616fb4f);

var $d8KcD = parcelRequire("d8KcD");

var $1Isls = parcelRequire("1Isls");
var $KhyL6 = parcelRequire("KhyL6");
parcelRequire("kzlYU");
var $gzHhz = parcelRequire("gzHhz");

var $dY1vR = parcelRequire("dY1vR");
var $f3f289907e5e208b$var$DEFAULT_KEY = 'cause';
var $f3f289907e5e208b$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $f3f289907e5e208b$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $f3f289907e5e208b$var$DEFAULT_KEY;
        this._limit = options.limit || $f3f289907e5e208b$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $1Isls.addGlobalEventProcessor)(function(event, hint) {
            var self = (0, $KhyL6.getCurrentHub)().getIntegration(LinkedErrors);
            return self ? $f3f289907e5e208b$export$7bd713d0612d8839(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}();
function $f3f289907e5e208b$export$7bd713d0612d8839(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $gzHhz.isInstanceOf)(hint.originalException, Error)) return event;
    var linkedErrors = $f3f289907e5e208b$export$e4e3ecf6f8f76c75(limit, hint.originalException, key);
    event.exception.values = (0, $d8KcD.__spread)(linkedErrors, event.exception.values);
    return event;
}
function $f3f289907e5e208b$export$e4e3ecf6f8f76c75(limit, error, key, stack) {
    if (stack === void 0) stack = [];
    if (!(0, $gzHhz.isInstanceOf)(error[key], Error) || stack.length + 1 >= limit) return stack;
    var exception = (0, $dY1vR.exceptionFromError)(error[key]);
    return $f3f289907e5e208b$export$e4e3ecf6f8f76c75(limit, error[key], key, (0, $d8KcD.__spread)([
        exception
    ], stack));
}

});

parcelRegister("k5dhX", function(module, exports) {
$parcel$export(module.exports, "TryCatch", () => $e9ee9525aea37dcd$export$f1a018517668e6d3);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("kzlYU");
var $1Haiv = parcelRequire("1Haiv");
var $bSrCK = parcelRequire("bSrCK");
var $gLjeB = parcelRequire("gLjeB");

var $fIcQk = parcelRequire("fIcQk");
var $e9ee9525aea37dcd$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $e9ee9525aea37dcd$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $d8KcD.__assign)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $gLjeB.getGlobalObject)();
        if (this._options.setTimeout) (0, $1Haiv.fill)(global, 'setTimeout', $e9ee9525aea37dcd$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $1Haiv.fill)(global, 'setInterval', $e9ee9525aea37dcd$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $1Haiv.fill)(global, 'requestAnimationFrame', $e9ee9525aea37dcd$var$_wrapRAF);
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) (0, $1Haiv.fill)(XMLHttpRequest.prototype, 'send', $e9ee9525aea37dcd$var$_wrapXHR);
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e9ee9525aea37dcd$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($e9ee9525aea37dcd$var$_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */ TryCatch.id = 'TryCatch';
    return TryCatch;
}();
/** JSDoc */ function $e9ee9525aea37dcd$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var originalCallback = args[0];
        args[0] = (0, $fIcQk.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $bSrCK.getFunctionName)(original)
                },
                handled: true,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e9ee9525aea37dcd$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $fIcQk.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $bSrCK.getFunctionName)(original)
                    },
                    handled: true,
                    type: 'instrument'
                }
            })
        ]);
    };
}
/** JSDoc */ function $e9ee9525aea37dcd$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $1Haiv.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $bSrCK.getFunctionName)(original)
                        },
                        handled: true,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, $1Haiv.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $bSrCK.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $fIcQk.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $e9ee9525aea37dcd$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = (0, $gLjeB.getGlobalObject)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $1Haiv.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') fn.handleEvent = (0, $fIcQk.wrap)(fn.handleEvent.bind(fn), {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $bSrCK.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $fIcQk.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $bSrCK.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $1Haiv.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("cbP8C", function(module, exports) {
$parcel$export(module.exports, "UserAgent", () => $8dfe2e0ebc8f63ca$export$5fba5e10934a4faf);

var $d8KcD = parcelRequire("d8KcD");

var $1Isls = parcelRequire("1Isls");
var $KhyL6 = parcelRequire("KhyL6");
parcelRequire("kzlYU");
var $gLjeB = parcelRequire("gLjeB");
var $8dfe2e0ebc8f63ca$var$global = (0, $gLjeB.getGlobalObject)();
/** UserAgent */ var $8dfe2e0ebc8f63ca$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $1Isls.addGlobalEventProcessor)(function(event) {
            if ((0, $KhyL6.getCurrentHub)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$8dfe2e0ebc8f63ca$var$global.navigator && !$8dfe2e0ebc8f63ca$var$global.location && !$8dfe2e0ebc8f63ca$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = event.request && event.request.url || $8dfe2e0ebc8f63ca$var$global.location && $8dfe2e0ebc8f63ca$var$global.location.href;
                var referrer = ($8dfe2e0ebc8f63ca$var$global.document || {}).referrer;
                var userAgent = ($8dfe2e0ebc8f63ca$var$global.navigator || {}).userAgent;
                var headers = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event.request && event.request.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    'User-Agent': userAgent
                });
                var request = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = 'UserAgent';
    return UserAgent;
}();

});


parcelRegister("522KT", function(module, exports) {
$parcel$export(module.exports, "RewriteFrames", () => $3a9f46d28c4d8b9b$export$af39fa91d1acf248);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("6AxhP");
var $8GMBw = parcelRequire("8GMBw");
/** Rewrite event frames paths */ var $3a9f46d28c4d8b9b$export$af39fa91d1acf248 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function RewriteFrames(options) {
        var _this = this;
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = RewriteFrames.id;
        /**
         * @inheritDoc
         */ this._prefix = 'app:///';
        /**
         * @inheritDoc
         */ this._iteratee = function(frame) {
            if (!frame.filename) return frame;
            // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
            var isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
            var startsWithSlash = /^\//.test(frame.filename);
            if (isWindowsFrame || startsWithSlash) {
                var filename = isWindowsFrame ? frame.filename.replace(/^[A-Z]:/, '') // remove Windows-style prefix
                .replace(/\\/g, '/') // replace all `\\` instances with `/`
                 : frame.filename;
                var base = _this._root ? (0, $8GMBw.relative)(_this._root, filename) : (0, $8GMBw.basename)(filename);
                frame.filename = "" + _this._prefix + base;
            }
            return frame;
        };
        if (options.root) this._root = options.root;
        if (options.prefix) this._prefix = options.prefix;
        if (options.iteratee) this._iteratee = options.iteratee;
    }
    /**
     * @inheritDoc
     */ RewriteFrames.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(RewriteFrames);
            if (self) return self.process(event);
            return event;
        });
    };
    /** JSDoc */ RewriteFrames.prototype.process = function(originalEvent) {
        var processedEvent = originalEvent;
        if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = this._processExceptionsEvent(processedEvent);
        if (originalEvent.stacktrace) processedEvent = this._processStacktraceEvent(processedEvent);
        return processedEvent;
    };
    /** JSDoc */ RewriteFrames.prototype._processExceptionsEvent = function(event) {
        var _this = this;
        try {
            return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event), {
                exception: (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, value), {
                            stacktrace: _this._processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktraceEvent = function(event) {
        try {
            return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event), {
                stacktrace: this._processStacktrace(event.stacktrace)
            });
        } catch (_oO) {
            return event;
        }
    };
    /** JSDoc */ RewriteFrames.prototype._processStacktrace = function(stacktrace) {
        var _this = this;
        return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return _this._iteratee(f);
            })
        });
    };
    /**
     * @inheritDoc
     */ RewriteFrames.id = 'RewriteFrames';
    return RewriteFrames;
}();

});
parcelRegister("6AxhP", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("8rVYd")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("g71FP")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("g71FP")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("jXuA5")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("jXuA5")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("3Fm3S")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("f1NKK")).fill);
$parcel$export(module.exports, "basename", () => (parcelRequire("8GMBw")).basename);
$parcel$export(module.exports, "relative", () => (parcelRequire("8GMBw")).relative);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("lLenz")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("fNmkX")).safeJoin);





parcelRequire("8rVYd");

parcelRequire("g71FP");
parcelRequire("jXuA5");



var $bK6pv = parcelRequire("bK6pv");
parcelRequire("3Fm3S");
parcelRequire("f1NKK");
parcelRequire("8GMBw");

parcelRequire("lLenz");


parcelRequire("fNmkX");



var $eF8qm = parcelRequire("eF8qm");





$parcel$exportWildcard(module.exports, $bK6pv);
$parcel$exportWildcard(module.exports, $eF8qm);

});
parcelRegister("8rVYd", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => $626dd002c0cc5034$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $626dd002c0cc5034$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $bK6pv = parcelRequire("bK6pv");
var $626dd002c0cc5034$var$fallbackGlobalObject = {};
function $626dd002c0cc5034$export$256479dc0cea61c4() {
    return (0, $bK6pv.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $626dd002c0cc5034$var$fallbackGlobalObject;
}
function $626dd002c0cc5034$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $626dd002c0cc5034$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("bK6pv", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $hCdC7 = parcelRequire("hCdC7");

var $3TFEq = parcelRequire("3TFEq");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $hCdC7.isBrowserBundle)() && Object.prototype.toString.call(typeof $3TFEq !== 'undefined' ? $3TFEq : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("hCdC7", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $cd308bb4ccca2846$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $cd308bb4ccca2846$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("g71FP", function(module, exports) {
$parcel$export(module.exports, "isError", () => $bbae992618869b90$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $bbae992618869b90$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $bbae992618869b90$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $bbae992618869b90$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $bbae992618869b90$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $bbae992618869b90$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $bbae992618869b90$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $bbae992618869b90$export$49841c62b9eff15);
$parcel$export(module.exports, "isSyntheticEvent", () => $bbae992618869b90$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $bbae992618869b90$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $bbae992618869b90$var$objectToString = Object.prototype.toString;
function $bbae992618869b90$export$e6127cc7fe7395c3(wat) {
    switch($bbae992618869b90$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $bbae992618869b90$export$49034edbe6b62415(wat, Error);
    }
}
function $bbae992618869b90$var$isBuiltin(wat, ty) {
    return $bbae992618869b90$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $bbae992618869b90$export$9f9636d330b71954(wat) {
    return $bbae992618869b90$var$isBuiltin(wat, 'ErrorEvent');
}
function $bbae992618869b90$export$ef9e2056653f0c8e(wat) {
    return $bbae992618869b90$var$isBuiltin(wat, 'DOMError');
}
function $bbae992618869b90$export$12e869b2a583f783(wat) {
    return $bbae992618869b90$var$isBuiltin(wat, 'DOMException');
}
function $bbae992618869b90$export$844ec244b1367d54(wat) {
    return $bbae992618869b90$var$isBuiltin(wat, 'String');
}
function $bbae992618869b90$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $bbae992618869b90$export$53b83ca8eaab0383(wat) {
    return $bbae992618869b90$var$isBuiltin(wat, 'Object');
}
function $bbae992618869b90$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $bbae992618869b90$export$49034edbe6b62415(wat, Event);
}
function $bbae992618869b90$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $bbae992618869b90$export$49034edbe6b62415(wat, Element);
}
function $bbae992618869b90$export$49841c62b9eff15(wat) {
    return $bbae992618869b90$var$isBuiltin(wat, 'RegExp');
}
function $bbae992618869b90$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $bbae992618869b90$export$bc2894c7158efbac(wat) {
    return $bbae992618869b90$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $bbae992618869b90$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $bbae992618869b90$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("jXuA5", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $e87b3fc828e3867d$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "logger", () => $e87b3fc828e3867d$export$af88d00dbe7f521);

var $d8KcD = parcelRequire("d8KcD");

var $jAdCU = parcelRequire("jAdCU");

var $8rVYd = parcelRequire("8rVYd");
// TODO: Implement different loggers for different environments
var $e87b3fc828e3867d$var$global = (0, $8rVYd.getGlobalObject)();
/** Prefix for logging strings */ var $e87b3fc828e3867d$var$PREFIX = 'Sentry Logger ';
var $e87b3fc828e3867d$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $e87b3fc828e3867d$export$cda52e2a8927a2ca(callback) {
    var global = (0, $8rVYd.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $e87b3fc828e3867d$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $e87b3fc828e3867d$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $jAdCU.IS_DEBUG_BUILD) $e87b3fc828e3867d$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $e87b3fc828e3867d$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $e87b3fc828e3867d$var$global.console)[name].apply(_a, (0, $d8KcD.__spread)([
                    $e87b3fc828e3867d$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $e87b3fc828e3867d$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $e87b3fc828e3867d$export$af88d00dbe7f521;
if (0, $jAdCU.IS_DEBUG_BUILD) $e87b3fc828e3867d$export$af88d00dbe7f521 = (0, $8rVYd.getGlobalSingleton)('logger', $e87b3fc828e3867d$var$makeLogger);
else $e87b3fc828e3867d$export$af88d00dbe7f521 = $e87b3fc828e3867d$var$makeLogger();

});
parcelRegister("jAdCU", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $e41bf3145acff223$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $e41bf3145acff223$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("3Fm3S", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $2ab65069d923e742$export$a3295358bff77e);

var $d8KcD = parcelRequire("d8KcD");

var $g71FP = parcelRequire("g71FP");

var $gEhyA = parcelRequire("gEhyA");

var $f1NKK = parcelRequire("f1NKK");

var $hWIy0 = parcelRequire("hWIy0");
function $2ab65069d923e742$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $2ab65069d923e742$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $2ab65069d923e742$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $2ab65069d923e742$export$a3295358bff77e(object, depth);
    if ($2ab65069d923e742$var$jsonSize(normalized) > maxSize) return $2ab65069d923e742$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $2ab65069d923e742$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $gEhyA.memoBuilder)();
    var _a = (0, $d8KcD.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $g71FP.isNaN)(value)) return value;
    var stringified = $2ab65069d923e742$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $g71FP.isError)(value) || (0, $g71FP.isEvent)(value) ? (0, $f1NKK.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $2ab65069d923e742$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $2ab65069d923e742$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $g71FP.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $hWIy0.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $2ab65069d923e742$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $2ab65069d923e742$var$jsonSize(value) {
    return $2ab65069d923e742$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("gEhyA", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $c1ee003656a2dcc8$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $c1ee003656a2dcc8$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("f1NKK", function(module, exports) {
$parcel$export(module.exports, "fill", () => $af0d8ae9cce82057$export$9563e054e6f787fb);
$parcel$export(module.exports, "convertToPlainObject", () => $af0d8ae9cce82057$export$62ff257738bf57f5);

var $d8KcD = parcelRequire("d8KcD");

var $jGRAb = parcelRequire("jGRAb");

var $g71FP = parcelRequire("g71FP");

var $fNmkX = parcelRequire("fNmkX");
function $af0d8ae9cce82057$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $af0d8ae9cce82057$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $af0d8ae9cce82057$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $af0d8ae9cce82057$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $af0d8ae9cce82057$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $af0d8ae9cce82057$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $af0d8ae9cce82057$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $af0d8ae9cce82057$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $g71FP.isError)(value)) newObj = (0, $d8KcD.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $af0d8ae9cce82057$var$getOwnProperties(value));
    else if ((0, $g71FP.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $d8KcD.__assign)({
            type: event_1.type,
            target: $af0d8ae9cce82057$var$serializeEventTarget(event_1.target),
            currentTarget: $af0d8ae9cce82057$var$serializeEventTarget(event_1.currentTarget)
        }, $af0d8ae9cce82057$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $g71FP.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $af0d8ae9cce82057$var$serializeEventTarget(target) {
    try {
        return (0, $g71FP.isElement)(target) ? (0, $jGRAb.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $af0d8ae9cce82057$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $af0d8ae9cce82057$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($af0d8ae9cce82057$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $fNmkX.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $fNmkX.truncate)(serialized, maxLength);
    }
    return '';
}
function $af0d8ae9cce82057$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $g71FP.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $d8KcD.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $af0d8ae9cce82057$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($af0d8ae9cce82057$export$d25f2688db1bb433);
    return val;
}
function $af0d8ae9cce82057$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $g71FP.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("jGRAb", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $e55b80f322e401f0$export$5647df6b7814ac86);

var $8rVYd = parcelRequire("8rVYd");

var $g71FP = parcelRequire("g71FP");
function $e55b80f322e401f0$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $e55b80f322e401f0$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $e55b80f322e401f0$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $g71FP.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $e55b80f322e401f0$export$1cfafeee2987818b() {
    var global = (0, $8rVYd.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("fNmkX", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $b7fcc24a5e0b362c$export$6a506b36fdea397d);
$parcel$export(module.exports, "safeJoin", () => $b7fcc24a5e0b362c$export$465e9d514283d4fd);

var $g71FP = parcelRequire("g71FP");
function $b7fcc24a5e0b362c$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $b7fcc24a5e0b362c$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $b7fcc24a5e0b362c$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $b7fcc24a5e0b362c$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $g71FP.isString)(value)) return false;
    if ((0, $g71FP.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $b7fcc24a5e0b362c$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});


parcelRegister("hWIy0", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $d10a68a44ccd411d$export$aad197c7121a6651);

var $d8KcD = parcelRequire("d8KcD");
var $d10a68a44ccd411d$var$STACKTRACE_LIMIT = 50;
function $d10a68a44ccd411d$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $d8KcD.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $d8KcD.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $d10a68a44ccd411d$export$c55c24c0eeba0205(frames);
    };
}
function $d10a68a44ccd411d$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $d10a68a44ccd411d$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $d10a68a44ccd411d$var$defaultFunctionName = '<anonymous>';
function $d10a68a44ccd411d$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $d10a68a44ccd411d$var$defaultFunctionName;
        return fn.name || $d10a68a44ccd411d$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d10a68a44ccd411d$var$defaultFunctionName;
    }
}

});


parcelRegister("8GMBw", function(module, exports) {
$parcel$export(module.exports, "relative", () => $6537f2c4f360362c$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $6537f2c4f360362c$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */ function $6537f2c4f360362c$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up++;
        } else if (up) {
            parts.splice(i, 1);
            // eslint-disable-next-line no-plusplus
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) // eslint-disable-next-line no-plusplus
    for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var $6537f2c4f360362c$var$splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */ function $6537f2c4f360362c$var$splitPath(filename) {
    var parts = $6537f2c4f360362c$var$splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
function $6537f2c4f360362c$export$f7ad0328861e2f03() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $6537f2c4f360362c$var$normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $6537f2c4f360362c$var$trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
function $6537f2c4f360362c$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $6537f2c4f360362c$export$f7ad0328861e2f03(from).substr(1);
    to = $6537f2c4f360362c$export$f7ad0328861e2f03(to).substr(1);
    /* eslint-enable no-param-reassign */ var fromParts = $6537f2c4f360362c$var$trim(from.split('/'));
    var toParts = $6537f2c4f360362c$var$trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
function $6537f2c4f360362c$export$6af368f973c74c5(path) {
    var isPathAbsolute = $6537f2c4f360362c$export$e434c7255acda994(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = $6537f2c4f360362c$var$normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
function $6537f2c4f360362c$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
function $6537f2c4f360362c$export$f7e2c8231c57a8bd() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $6537f2c4f360362c$export$6af368f973c74c5(args.join('/'));
}
function $6537f2c4f360362c$export$7f7b8152cc673abe(path) {
    var result = $6537f2c4f360362c$var$splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
    return root + dir;
}
function $6537f2c4f360362c$export$9bf319d8f74f51d1(path, ext) {
    var f = $6537f2c4f360362c$var$splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) f = f.substr(0, f.length - ext.length);
    return f;
}

});

parcelRegister("lLenz", function(module, exports) {
$parcel$export(module.exports, "severityFromString", () => $fd792424c706aa56$export$e01cef29b4327697);

var $ahlU2 = parcelRequire("ahlU2");

var $fI5tD = parcelRequire("fI5tD");
function $fd792424c706aa56$var$isSupportedSeverity(level) {
    return (0, $fI5tD.SeverityLevels).indexOf(level) !== -1;
}
function $fd792424c706aa56$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $ahlU2.Severity).Warning;
    if ($fd792424c706aa56$var$isSupportedSeverity(level)) return level;
    return (0, $ahlU2.Severity).Log;
}

});
parcelRegister("fI5tD", function(module, exports) {
$parcel$export(module.exports, "SeverityLevels", () => $b6ff36b729cca75f$export$484b1ea9aec914c);
var $b6ff36b729cca75f$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("eF8qm", function(module, exports) {

var $8rVYd = parcelRequire("8rVYd");

var $bK6pv = parcelRequire("bK6pv");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $8rVYd.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $bK6pv.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $bK6pv.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $8rVYd.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});





parcelRegister("d30rG", function(module, exports) {
$parcel$export(module.exports, "initialisePlatformFeatureFlags", () => $ca3b2ee27015a977$export$bcd24dd77ba35b8a);
/**
 *  Adapted from JFE:
 *  https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/browse/src/packages/common-legacy-do-not-add-anything-new/src/util/get-feature-flag-value.js
 *
 */ 
var $6bGmX = parcelRequire("6bGmX");

var $3H4LK = parcelRequire("3H4LK");
const $ca3b2ee27015a977$export$bcd24dd77ba35b8a = ()=>{
    (0, $3H4LK.setBooleanFeatureFlagResolver)((flagKey)=>(0, $6bGmX.default).checkGate(flagKey));
};

});

parcelRegister("2XL92", function(module, exports) {
$parcel$export(module.exports, "handleDOMGoogleTranslateIssues", () => $d4bd03c85f92e379$export$d1215808cd22e615);
// #reference /confluence/packages/confluence-frontend-server/src/google-translate-issue-workaround.js

var $keOG0 = parcelRequire("keOG0");
const $d4bd03c85f92e379$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $d4bd03c85f92e379$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot remove a child from a different parent', child, this);
                    $d4bd03c85f92e379$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $d4bd03c85f92e379$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-return
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $d4bd03c85f92e379$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $d4bd03c85f92e379$var$extractNodeData(childNode)
    };
    $d4bd03c85f92e379$var$sendAnalyticsEvent($d4bd03c85f92e379$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $d4bd03c85f92e379$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $d4bd03c85f92e379$var$extractNodeData(newNode),
        referenceNode: $d4bd03c85f92e379$var$extractNodeData(referenceNode)
    };
    $d4bd03c85f92e379$var$sendAnalyticsEvent($d4bd03c85f92e379$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $d4bd03c85f92e379$var$sendAnalyticsEvent(action, nodeData) {
    (0, $keOG0.trackError)('google.translate.issue.error', {
        ...nodeData,
        errorBoundaryId: 'root',
        suppressedError: action,
        errorBoundaryPackageName: 'unknown'
    }, new Error(action));
}
function $d4bd03c85f92e379$var$extractNodeData(node) {
    var _node$parentElement;
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.nodeName,
        isConnected: node.isConnected
    };
}

});

parcelRegister("aJIdj", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelp", () => $478c7fe234ae53d4$export$1d3b4fb23d556424);

var $4fqPo = parcelRequire("4fqPo");

var $gMSZD = parcelRequire("gMSZD");

var $1hcn6 = parcelRequire("1hcn6");
parcelRequire("TqMeT");
var $3w7cm = parcelRequire("3w7cm");
parcelRequire("3bzDg");
var $3Q6vF = parcelRequire("3Q6vF");
parcelRequire("aHhQY");
var $4yB8T = parcelRequire("4yB8T");
const $478c7fe234ae53d4$var$renderError = ()=>/*#__PURE__*/ $4fqPo.createElement((0, $3w7cm.default), null);
const $478c7fe234ae53d4$export$1d3b4fb23d556424 = ({ config: config })=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $1hcn6.AppProviders), {
        config: config
    }, /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
        renderError: $478c7fe234ae53d4$var$renderError
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4yB8T.ThemingContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $3Q6vF.default), null))));
};

});
parcelRegister("1hcn6", function(module, exports) {
$parcel$export(module.exports, "store", () => $14462b7d47b05de5$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "injectReducer", () => $14462b7d47b05de5$export$8d491a82891620e4);
$parcel$export(module.exports, "onIntlNextError", () => $14462b7d47b05de5$export$3bcefabe8b04378c);
$parcel$export(module.exports, "AppProviders", () => $14462b7d47b05de5$export$6c4743022ef2c318);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $dm6D5 = parcelRequire("dm6D5");

var $bG6ob = parcelRequire("bG6ob");

var $63sfu = parcelRequire("63sfu");

var $3SIyc = parcelRequire("3SIyc");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");

var $e4b3P = parcelRequire("e4b3P");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $cdm1b = parcelRequire("cdm1b");
parcelRequire("3RD2P");
var $lde7Z = parcelRequire("lde7Z");
parcelRequire("1MWC1");
var $eAvqP = parcelRequire("eAvqP");
parcelRequire("7voRY");
var $lVTEP = parcelRequire("lVTEP");
parcelRequire("7BEQF");
var $fcd6D = parcelRequire("fcd6D");
parcelRequire("lkz0W");
var $7EenD = parcelRequire("7EenD");
var $6niD6 = parcelRequire("6niD6");

var $73FZL = parcelRequire("73FZL");

var $6bGmX = parcelRequire("6bGmX");

var $gHT3x = parcelRequire("gHT3x");

var $4xChi = parcelRequire("4xChi");

var $keOG0 = parcelRequire("keOG0");

var $fJQMR = parcelRequire("fJQMR");

var $bYfAV = parcelRequire("bYfAV");

var $kXlzl = parcelRequire("kXlzl");

var $aiZWa = parcelRequire("aiZWa");

var $keOG0 = parcelRequire("keOG0");

var $d64Rz = parcelRequire("d64Rz");

var $75i57 = parcelRequire("75i57");

var $lDY9g = parcelRequire("lDY9g");

var $7xkqd = parcelRequire("7xkqd");

var $gcTFJ = parcelRequire("gcTFJ");

var $4Ysr0 = parcelRequire("4Ysr0");

var $klY6L = parcelRequire("klY6L");
parcelRequire("3B6fC");
var $iHP9e = parcelRequire("iHP9e");
const $14462b7d47b05de5$var$initialState = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $14462b7d47b05de5$var$accountTypeMetaTagMiddleware = ()=>(next)=>(action)=>{
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (action.type === (0, $3R99L.UPDATE_USER_MODEL)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $4xChi.setAccountMetaTag)(action.payload.atlassianAccountManaged, action.payload.accountId);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return next(action);
        };
const { store: $14462b7d47b05de5$export$6f57813fe9f31bf9, injectReducer: $14462b7d47b05de5$export$8d491a82891620e4 } = (0, $e4b3P.default)({
    initialState: $14462b7d47b05de5$var$initialState,
    middleware: [
        $14462b7d47b05de5$var$accountTypeMetaTagMiddleware
    ]
});
const $14462b7d47b05de5$export$ec3f29afcf92cc87 = (intlError)=>{
    try {
        /**
     * Do not report to sentry if missing translations are from external packages.
     * Extend the regexp to add support for multiple packages
     */ if (!intlError) return;
        const isExternalTranslation = intlError.match(/Missing message: "fabric\.(editor|media|theme|emoji)\..*/);
        const { errorKey: errorKey, errorLocale: errorLocale, isNonFinal: isNonFinal } = (0, $7xkqd.intlErrorMatch)(intlError);
        // According to this document https://hello.atlassian.net/wiki/spaces/i18n/pages/647802766/Localized+Language+Support+Coverage+and+Strategy after 2018 we have discontinued support for these locales
        const isUnSupportedLocale = !!intlError.match(/.*Missing message.*for locale "(ro|pt|no|sk|et|is)".*/);
        if (isExternalTranslation || isUnSupportedLocale) return;
        (0, $kXlzl.operationalEvent)({
            attributes: {
                isNonFinal: isNonFinal,
                key: errorKey,
                locale: errorLocale
            },
            actionSubject: 'intl_translation',
            action: 'missing',
            source: 'unknownSource'
        });
    } catch (err) {
        // oxlint-disable-next-line no-console
        console.error(`Failed to report intl error: ${intlError}`, err);
    }
};
const $14462b7d47b05de5$export$3bcefabe8b04378c = (intlError)=>{
    $14462b7d47b05de5$export$ec3f29afcf92cc87(`IntlV5: ${intlError.message}`);
};
const $14462b7d47b05de5$var$onAnalyticsEvent = (event)=>{
    if ((0, $6bGmX.default).checkGate('enable_help_center_analytics_bridge')) (0, $keOG0.sendEventFromAnalyticsBridge)(event);
    else (0, $keOG0.legacySendEvent)(event);
};
class $14462b7d47b05de5$export$6c4743022ef2c318 extends $4fqPo.Component {
    render() {
        const { config: config } = this.props;
        const analyticsClient = (0, $fJQMR.getAnalyticsWebClient)().getInstance();
        const envFeatureFlags = $14462b7d47b05de5$export$6f57813fe9f31bf9.getState().persisted.env.featureFlags;
        const configFeatureFlags = config === null || config === void 0 ? void 0 : config.featureFlags;
        const memoizedFeatureFlags = (0, $63sfu.memoize)(// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        (envFFs, configFFs)=>({
                ...envFFs,
                ...configFFs
            }), (...args)=>(0, $63sfu.keys)({
                ...args[0],
                ...args[1]
            }));
        const WrmResourceProvider = (0, $bG6ob.isWrmOptimizationsEnabled)() ? (0, $klY6L.default) : $4fqPo.Fragment;
        return /*#__PURE__*/ $4fqPo.createElement((0, $gIeP2.RelayEnvironmentProvider), {
            environment: (0, $4Ysr0.getRelayEnvironment)()
        }, /*#__PURE__*/ $4fqPo.createElement((0, $bYfAV.CustomDomainsAnalyticsProvider), {
            baseUrl: config.baseUrl
        }, /*#__PURE__*/ $4fqPo.createElement((0, $7EenD.default), {
            client: analyticsClient,
            excludedChannels: [
                (0, $6niD6.FabricChannel).atlaskit
            ]
        }, /*#__PURE__*/ $4fqPo.createElement((0, $lde7Z.EngagementProviderWrapper), {
            config: config,
            analyticsClientInstance: analyticsClient
        }, /*#__PURE__*/ $4fqPo.createElement((0, $73FZL.default), {
            onEvent: (0, $keOG0.sendAtlaskitUIEvent),
            channel: "atlaskit"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $73FZL.default), {
            onEvent: (0, $keOG0.sendEventFromAnalyticsBridge),
            channel: (0, $gHT3x.ANALYTICS_BRIDGE_CHANNEL)
        }, /*#__PURE__*/ $4fqPo.createElement((0, $73FZL.default), {
            onEvent: $14462b7d47b05de5$var$onAnalyticsEvent
        }, /*#__PURE__*/ $4fqPo.createElement((0, $3SIyc.default), {
            messages: (0, $lDY9g.default)(),
            locale: (0, $gcTFJ.getLanguageFromLocale)((0, $2hx7o.getLocale)($14462b7d47b05de5$export$6f57813fe9f31bf9.getState())),
            onError: $14462b7d47b05de5$export$3bcefabe8b04378c
        }, /*#__PURE__*/ $4fqPo.createElement((0, $dm6D5.default), {
            store: $14462b7d47b05de5$export$6f57813fe9f31bf9
        }, /*#__PURE__*/ $4fqPo.createElement((0, $iHP9e.default), {
            config: this.props.config
        }, /*#__PURE__*/ $4fqPo.createElement(WrmResourceProvider, null, /*#__PURE__*/ $4fqPo.createElement((0, $d64Rz.PortalAnalyticsContext), null, /*#__PURE__*/ $4fqPo.createElement((0, $cdm1b.HelpSeekerTypeProvider), null, /*#__PURE__*/ $4fqPo.createElement((0, $eAvqP.default), {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            featureFlags: memoizedFeatureFlags(envFeatureFlags, configFeatureFlags)
        }, /*#__PURE__*/ $4fqPo.createElement((0, $aiZWa.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $75i57.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $lVTEP.TFECacheProvider), null, /*#__PURE__*/ $4fqPo.createElement((0, $fcd6D.CustomiseSidebarTriggerProvider), null, this.props.children))))))))))))))))));
    }
}

});
parcelRegister("3wP4d", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("dm6D5")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("bmgw6")).default);

var $dm6D5 = parcelRequire("dm6D5");

var $4YdPA = parcelRequire("4YdPA");

var $bYoP4 = parcelRequire("bYoP4");

var $bmgw6 = parcelRequire("bmgw6");

});
parcelRegister("dm6D5", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b9278e4c8d6247f$export$2e2bcd8739ae039);

var $dDznA = parcelRequire("dDznA");

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $bYoP4 = parcelRequire("bYoP4");
var $9b9278e4c8d6247f$var$Provider = /*#__PURE__*/ function(_Component) {
    (0, $dDznA.default)(Provider, _Component);
    function Provider(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        var store = props.store;
        _this.state = {
            storeState: store.getState(),
            store: store
        };
        return _this;
    }
    var _proto = Provider.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.subscribe();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribe) this.unsubscribe();
        this._isMounted = false;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.store !== prevProps.store) {
            if (this.unsubscribe) this.unsubscribe();
            this.subscribe();
        }
    };
    _proto.subscribe = function subscribe() {
        var _this2 = this;
        var store = this.props.store;
        this.unsubscribe = store.subscribe(function() {
            var newStoreState = store.getState();
            if (!_this2._isMounted) return;
            _this2.setState(function(providerState) {
                // If the value is the same, skip the unnecessary state update.
                if (providerState.storeState === newStoreState) return null;
                return {
                    storeState: newStoreState
                };
            });
        }); // Actions might have been dispatched between render and mount - handle those
        var postMountStoreState = store.getState();
        if (postMountStoreState !== this.state.storeState) this.setState({
            storeState: postMountStoreState
        });
    };
    _proto.render = function render() {
        var Context = this.props.context || (0, $bYoP4.ReactReduxContext);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Context.Provider, {
            value: this.state
        }, this.props.children);
    };
    return Provider;
}((0, $4fqPo.Component));
$9b9278e4c8d6247f$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).any
};
var $9b9278e4c8d6247f$export$2e2bcd8739ae039 = $9b9278e4c8d6247f$var$Provider;

});
parcelRegister("dDznA", function(module, exports) {
$parcel$export(module.exports, "default", () => $9eda5c825549239b$export$2e2bcd8739ae039);

var $kqSvQ = parcelRequire("kqSvQ");
function $9eda5c825549239b$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $kqSvQ.default)(t, o);
}

});
parcelRegister("kqSvQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee008567dfe58ae4$export$2e2bcd8739ae039);
function $ee008567dfe58ae4$export$2e2bcd8739ae039(t, e) {
    return $ee008567dfe58ae4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ee008567dfe58ae4$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("bYoP4", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $8b788d9531839637$export$cc80c08dc91f1c00);

var $4fqPo = parcelRequire("4fqPo");
var $8b788d9531839637$export$cc80c08dc91f1c00 = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(null);
var $8b788d9531839637$export$2e2bcd8739ae039 = $8b788d9531839637$export$cc80c08dc91f1c00;

});


parcelRegister("4YdPA", function(module, exports) {
$parcel$export(module.exports, "default", () => $39e77e9684c353fa$export$2e2bcd8739ae039);

var $evzgG = parcelRequire("evzgG");

var $dDznA = parcelRequire("dDznA");

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");

var $cpFTT = parcelRequire("cpFTT");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");

var $8KJmM = parcelRequire("8KJmM");

var $bYoP4 = parcelRequire("bYoP4");
var $39e77e9684c353fa$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $39e77e9684c353fa$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $bYoP4.ReactReduxContext) : _ref2$context, connectOptions = (0, $gMtYT.default)(_ref2, [
        "getDisplayName",
        "methodName",
        "renderCountProp",
        "shouldHandleStateChanges",
        "storeKey",
        "withRef",
        "forwardRef",
        "context"
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($1K7ys)))(renderCountProp === undefined, "renderCountProp is removed. render counting is built into the latest React dev tools profiling extension");
    (0, (/*@__PURE__*/$parcel$interopDefault($1K7ys)))(!withRef, 'withRef is removed. To access the wrapped instance, use a ref on the connected component');
    var customStoreWarningMessage = "To use a custom Redux store for specific components,  create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like:  <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    (0, (/*@__PURE__*/$parcel$interopDefault($1K7ys)))(storeKey === 'store', 'storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $ichJ5.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        var OuterBaseComponent = (0, $4fqPo.Component);
        if (pure) OuterBaseComponent = (0, $4fqPo.PureComponent);
        function makeDerivedPropsSelector() {
            var lastProps;
            var lastState;
            var lastDerivedProps;
            var lastStore;
            var lastSelectorFactoryOptions;
            var sourceSelector;
            return function selectDerivedProps(state, props, store, selectorFactoryOptions) {
                if (pure && lastProps === props && lastState === state) return lastDerivedProps;
                if (store !== lastStore || lastSelectorFactoryOptions !== selectorFactoryOptions) {
                    lastStore = store;
                    lastSelectorFactoryOptions = selectorFactoryOptions;
                    sourceSelector = selectorFactory(store.dispatch, selectorFactoryOptions);
                }
                lastProps = props;
                lastState = state;
                var nextProps = sourceSelector(state, props);
                lastDerivedProps = nextProps;
                return lastDerivedProps;
            };
        }
        function makeChildElementSelector() {
            var lastChildProps, lastForwardRef, lastChildElement, lastComponent;
            return function selectChildElement(WrappedComponent, childProps, forwardRef) {
                if (childProps !== lastChildProps || forwardRef !== lastForwardRef || lastComponent !== WrappedComponent) {
                    lastChildProps = childProps;
                    lastForwardRef = forwardRef;
                    lastComponent = WrappedComponent;
                    lastChildElement = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, (0, $ichJ5.default)({}, childProps, {
                        ref: forwardRef
                    }));
                }
                return lastChildElement;
            };
        }
        var Connect = /*#__PURE__*/ function(_OuterBaseComponent) {
            (0, $dDznA.default)(Connect, _OuterBaseComponent);
            function Connect(props) {
                var _this;
                _this = _OuterBaseComponent.call(this, props) || this;
                (0, (/*@__PURE__*/$parcel$interopDefault($1K7ys)))(forwardRef ? !props.wrapperProps[storeKey] : !props[storeKey], 'Passing redux store in props has been removed and does not do anything. ' + customStoreWarningMessage);
                _this.selectDerivedProps = makeDerivedPropsSelector();
                _this.selectChildElement = makeChildElementSelector();
                _this.indirectRenderWrappedComponent = _this.indirectRenderWrappedComponent.bind((0, $evzgG.default)(_this));
                return _this;
            }
            var _proto = Connect.prototype;
            _proto.indirectRenderWrappedComponent = function indirectRenderWrappedComponent(value) {
                // calling renderWrappedComponent on prototype from indirectRenderWrappedComponent bound to `this`
                return this.renderWrappedComponent(value);
            };
            _proto.renderWrappedComponent = function renderWrappedComponent(value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1K7ys)))(value, "Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
                var storeState = value.storeState, store = value.store;
                var wrapperProps = this.props;
                var forwardedRef;
                if (forwardRef) {
                    wrapperProps = this.props.wrapperProps;
                    forwardedRef = this.props.forwardedRef;
                }
                var derivedProps = this.selectDerivedProps(storeState, wrapperProps, store, selectorFactoryOptions);
                return this.selectChildElement(WrappedComponent, derivedProps, forwardedRef);
            };
            _proto.render = function render() {
                var ContextToUse = this.props.context && this.props.context.Consumer && (0, $8KJmM.isContextConsumer)((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(this.props.context.Consumer, null)) ? this.props.context : Context;
                return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ContextToUse.Consumer, null, this.indirectRenderWrappedComponent);
            };
            return Connect;
        }(OuterBaseComponent);
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function forwardConnectRef(props, ref) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Connect, {
                    wrapperProps: props,
                    forwardedRef: ref
                });
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("evzgG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8ff516cd265b21f$export$2e2bcd8739ae039);
function $a8ff516cd265b21f$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("bmgw6", function(module, exports) {
$parcel$export(module.exports, "default", () => $844e8fb1e112571f$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");

var $4YdPA = parcelRequire("4YdPA");

var $gv4RR = parcelRequire("gv4RR");

var $6EazA = parcelRequire("6EazA");

var $8YTEr = parcelRequire("8YTEr");

var $lHS2d = parcelRequire("lHS2d");

var $1Be9b = parcelRequire("1Be9b");
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $844e8fb1e112571f$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $844e8fb1e112571f$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $844e8fb1e112571f$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $4YdPA.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $8YTEr.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $6EazA.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $lHS2d.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $1Be9b.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $844e8fb1e112571f$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $gv4RR.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $gv4RR.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $gv4RR.default) : _ref3$areMergedPropsE, extraOptions = (0, $gMtYT.default)(_ref3, [
            "pure",
            "areStatesEqual",
            "areOwnPropsEqual",
            "areStatePropsEqual",
            "areMergedPropsEqual"
        ]);
        var initMapStateToProps = $844e8fb1e112571f$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $844e8fb1e112571f$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $844e8fb1e112571f$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $ichJ5.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $844e8fb1e112571f$export$2e2bcd8739ae039 = $844e8fb1e112571f$export$9f9feb656dec1fc4();

});
parcelRegister("gv4RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c03351355beb60e5$export$2e2bcd8739ae039);
var $c03351355beb60e5$var$hasOwn = Object.prototype.hasOwnProperty;
function $c03351355beb60e5$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c03351355beb60e5$export$2e2bcd8739ae039(objA, objB) {
    if ($c03351355beb60e5$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!$c03351355beb60e5$var$hasOwn.call(objB, keysA[i]) || !$c03351355beb60e5$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("6EazA", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d6eae0d61b1b589$export$2e2bcd8739ae039);
parcelRequire("2pQ8V");
var $iHC8M = parcelRequire("iHC8M");

var $axjQt = parcelRequire("axjQt");
function $4d6eae0d61b1b589$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $axjQt.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $4d6eae0d61b1b589$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $axjQt.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $4d6eae0d61b1b589$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $axjQt.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $iHC8M.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $4d6eae0d61b1b589$export$2e2bcd8739ae039 = [
    $4d6eae0d61b1b589$export$a9f27b4b187c1166,
    $4d6eae0d61b1b589$export$ba20d1a7aa0c4a90,
    $4d6eae0d61b1b589$export$94a6e55709d4d961
];

});
parcelRegister("2pQ8V", function(module, exports) {
$parcel$export(module.exports, "createStore", () => (parcelRequire("8Snhx")).default);
$parcel$export(module.exports, "combineReducers", () => (parcelRequire("8Qej1")).default);
$parcel$export(module.exports, "bindActionCreators", () => (parcelRequire("iHC8M")).default);
$parcel$export(module.exports, "applyMiddleware", () => (parcelRequire("2Wz6l")).default);
$parcel$export(module.exports, "compose", () => (parcelRequire("6WMcD")).default);

var $8Snhx = parcelRequire("8Snhx");

var $8Qej1 = parcelRequire("8Qej1");

var $iHC8M = parcelRequire("iHC8M");

var $2Wz6l = parcelRequire("2Wz6l");

var $6WMcD = parcelRequire("6WMcD");
parcelRequire("hn4Pr");
/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/ function $1c265d0e77ee9ba8$var$isCrushed() {}

});
parcelRegister("8Snhx", function(module, exports) {
$parcel$export(module.exports, "ActionTypes", () => $67656d29f82c638e$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "default", () => $67656d29f82c638e$export$2e2bcd8739ae039);

var $e6jsI = parcelRequire("e6jsI");

var $bTqwV = parcelRequire("bTqwV");
var $67656d29f82c638e$export$1385d81a6c6bbcd4 = {
    INIT: '@@redux/INIT'
};
function $67656d29f82c638e$export$2e2bcd8739ae039(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error('Expected the enhancer to be a function.');
        return enhancer($67656d29f82c638e$export$2e2bcd8739ae039)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error('Expected the reducer to be a function.');
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error('Expected listener to be a function.');
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!(0, $e6jsI.default)(action)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error('Expected the nextReducer to be a function.');
        currentReducer = nextReducer;
        dispatch({
            type: $67656d29f82c638e$export$1385d81a6c6bbcd4.INIT
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object') throw new TypeError('Expected the observer to be an object.');
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[0, $bTqwV.default] = function() {
            return this;
        }, _ref;
    }
    // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $67656d29f82c638e$export$1385d81a6c6bbcd4.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[0, $bTqwV.default] = observable, _ref2;
}

});
parcelRegister("e6jsI", function(module, exports) {
$parcel$export(module.exports, "default", () => $a440b8fc146cea47$export$2e2bcd8739ae039);

var $8ynYx = parcelRequire("8ynYx");

var $9HpCV = parcelRequire("9HpCV");

var $7IgkD = parcelRequire("7IgkD");
/** `Object#toString` result references. */ var $a440b8fc146cea47$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a440b8fc146cea47$var$funcProto = Function.prototype, $a440b8fc146cea47$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a440b8fc146cea47$var$funcToString = $a440b8fc146cea47$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a440b8fc146cea47$var$hasOwnProperty = $a440b8fc146cea47$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $a440b8fc146cea47$var$objectCtorString = $a440b8fc146cea47$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $a440b8fc146cea47$var$isPlainObject(value) {
    if (!(0, $7IgkD.default)(value) || (0, $8ynYx.default)(value) != $a440b8fc146cea47$var$objectTag) return false;
    var proto = (0, $9HpCV.default)(value);
    if (proto === null) return true;
    var Ctor = $a440b8fc146cea47$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $a440b8fc146cea47$var$funcToString.call(Ctor) == $a440b8fc146cea47$var$objectCtorString;
}
var $a440b8fc146cea47$export$2e2bcd8739ae039 = $a440b8fc146cea47$var$isPlainObject;

});
parcelRegister("8ynYx", function(module, exports) {
$parcel$export(module.exports, "default", () => $019b6bc0fb9df008$export$2e2bcd8739ae039);

var $gmktH = parcelRequire("gmktH");

var $knEwL = parcelRequire("knEwL");

var $grcHV = parcelRequire("grcHV");
/** `Object#toString` result references. */ var $019b6bc0fb9df008$var$nullTag = '[object Null]', $019b6bc0fb9df008$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $019b6bc0fb9df008$var$symToStringTag = (0, $gmktH.default) ? (0, $gmktH.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $019b6bc0fb9df008$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $019b6bc0fb9df008$var$undefinedTag : $019b6bc0fb9df008$var$nullTag;
    return $019b6bc0fb9df008$var$symToStringTag && $019b6bc0fb9df008$var$symToStringTag in Object(value) ? (0, $knEwL.default)(value) : (0, $grcHV.default)(value);
}
var $019b6bc0fb9df008$export$2e2bcd8739ae039 = $019b6bc0fb9df008$var$baseGetTag;

});
parcelRegister("gmktH", function(module, exports) {
$parcel$export(module.exports, "default", () => $be8e95f18830576e$export$2e2bcd8739ae039);

var $ozUsB = parcelRequire("ozUsB");
/** Built-in value references. */ var $be8e95f18830576e$var$Symbol = (0, $ozUsB.default).Symbol;
var $be8e95f18830576e$export$2e2bcd8739ae039 = $be8e95f18830576e$var$Symbol;

});
parcelRegister("ozUsB", function(module, exports) {
$parcel$export(module.exports, "default", () => $049e18e9f8df0159$export$2e2bcd8739ae039);

var $eyPF9 = parcelRequire("eyPF9");
/** Detect free variable `self`. */ var $049e18e9f8df0159$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $049e18e9f8df0159$var$root = (0, $eyPF9.default) || $049e18e9f8df0159$var$freeSelf || Function('return this')();
var $049e18e9f8df0159$export$2e2bcd8739ae039 = $049e18e9f8df0159$var$root;

});
parcelRegister("eyPF9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a99c50c8968f6027$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $a99c50c8968f6027$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $a99c50c8968f6027$export$2e2bcd8739ae039 = $a99c50c8968f6027$var$freeGlobal;

});



parcelRegister("knEwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed65648639316477$export$2e2bcd8739ae039);

var $gmktH = parcelRequire("gmktH");
/** Used for built-in method references. */ var $ed65648639316477$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ed65648639316477$var$hasOwnProperty = $ed65648639316477$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ed65648639316477$var$nativeObjectToString = $ed65648639316477$var$objectProto.toString;
/** Built-in value references. */ var $ed65648639316477$var$symToStringTag = (0, $gmktH.default) ? (0, $gmktH.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $ed65648639316477$var$getRawTag(value) {
    var isOwn = $ed65648639316477$var$hasOwnProperty.call(value, $ed65648639316477$var$symToStringTag), tag = value[$ed65648639316477$var$symToStringTag];
    try {
        value[$ed65648639316477$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $ed65648639316477$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$ed65648639316477$var$symToStringTag] = tag;
        else delete value[$ed65648639316477$var$symToStringTag];
    }
    return result;
}
var $ed65648639316477$export$2e2bcd8739ae039 = $ed65648639316477$var$getRawTag;

});

parcelRegister("grcHV", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf79066a38822602$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $bf79066a38822602$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bf79066a38822602$var$nativeObjectToString = $bf79066a38822602$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $bf79066a38822602$var$objectToString(value) {
    return $bf79066a38822602$var$nativeObjectToString.call(value);
}
var $bf79066a38822602$export$2e2bcd8739ae039 = $bf79066a38822602$var$objectToString;

});


parcelRegister("9HpCV", function(module, exports) {
$parcel$export(module.exports, "default", () => $70fc022dce542b79$export$2e2bcd8739ae039);

var $fDZRH = parcelRequire("fDZRH");
/** Built-in value references. */ var $70fc022dce542b79$var$getPrototype = (0, $fDZRH.default)(Object.getPrototypeOf, Object);
var $70fc022dce542b79$export$2e2bcd8739ae039 = $70fc022dce542b79$var$getPrototype;

});
parcelRegister("fDZRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $b63a7ca65f8b430a$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $b63a7ca65f8b430a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $b63a7ca65f8b430a$export$2e2bcd8739ae039 = $b63a7ca65f8b430a$var$overArg;

});


parcelRegister("7IgkD", function(module, exports) {
$parcel$export(module.exports, "default", () => $59d94f9bfffdf722$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $59d94f9bfffdf722$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $59d94f9bfffdf722$export$2e2bcd8739ae039 = $59d94f9bfffdf722$var$isObjectLike;

});


parcelRegister("bTqwV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a896918f1b4222c$export$2e2bcd8739ae039);
/* global window */ 
var $aHLe6 = parcelRequire("aHLe6");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $aHLe6.default)(root);
var $8a896918f1b4222c$export$2e2bcd8739ae039 = result;

});
parcelRegister("aHLe6", function(module, exports) {
$parcel$export(module.exports, "default", () => $0202e140deaefe15$export$2e2bcd8739ae039);
function $0202e140deaefe15$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("8Qej1", function(module, exports) {
$parcel$export(module.exports, "default", () => $66fe46ea49c6da18$export$2e2bcd8739ae039);

var $8Snhx = parcelRequire("8Snhx");

var $e6jsI = parcelRequire("e6jsI");
parcelRequire("hn4Pr");
function $66fe46ea49c6da18$var$getUndefinedStateErrorMessage(key, action) {
    var actionType = action && action.type;
    var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
    return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}
function $66fe46ea49c6da18$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === (0, $8Snhx.ActionTypes).INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!(0, $e6jsI.default)(inputState)) return 'The ' + argumentName + ' has unexpected type of "' + ({}).toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (unexpectedKeys.length > 0) return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $66fe46ea49c6da18$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: (0, $8Snhx.ActionTypes).INIT
        });
        if (typeof initialState === 'undefined') throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
        var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
        if (typeof reducer(undefined, {
            type: type
        }) === 'undefined') throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + (0, $8Snhx.ActionTypes).INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    });
}
function $66fe46ea49c6da18$export$2e2bcd8739ae039(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache = void 0;
    var shapeAssertionError = void 0;
    try {
        $66fe46ea49c6da18$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var errorMessage = $66fe46ea49c6da18$var$getUndefinedStateErrorMessage(_key, action);
                throw new Error(errorMessage);
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}

});
parcelRegister("hn4Pr", function(module, exports) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ca585485f71b3227$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});


parcelRegister("iHC8M", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9d9d4121ecabb3a$export$2e2bcd8739ae039);
function $d9d9d4121ecabb3a$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(undefined, arguments));
    };
}
function $d9d9d4121ecabb3a$export$2e2bcd8739ae039(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $d9d9d4121ecabb3a$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var keys = Object.keys(actionCreators);
    var boundActionCreators = {};
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $d9d9d4121ecabb3a$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}

});

parcelRegister("2Wz6l", function(module, exports) {
$parcel$export(module.exports, "default", () => $224c39f40f9505b0$export$2e2bcd8739ae039);

var $6WMcD = parcelRequire("6WMcD");
var $224c39f40f9505b0$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $224c39f40f9505b0$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = (0, $6WMcD.default).apply(undefined, chain)(store.dispatch);
            return $224c39f40f9505b0$var$_extends({}, store, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("6WMcD", function(module, exports) {
$parcel$export(module.exports, "default", () => $50ed8ce8b9acb15f$export$2e2bcd8739ae039);
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $50ed8ce8b9acb15f$export$2e2bcd8739ae039() {
    for(var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(undefined, arguments));
        };
    });
}

});



parcelRegister("axjQt", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $7abc6150a7f611bc$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $7abc6150a7f611bc$export$8d46c7f53c8c602f);
parcelRequire("92RPB");
function $7abc6150a7f611bc$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $7abc6150a7f611bc$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $7abc6150a7f611bc$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $7abc6150a7f611bc$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $7abc6150a7f611bc$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("92RPB", function(module, exports) {

var $7f1F1 = parcelRequire("7f1F1");

var $76U5U = parcelRequire("76U5U");
function $695e0ec0eb593ae7$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $7f1F1.default)(value)) (0, $76U5U.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("7f1F1", function(module, exports) {
$parcel$export(module.exports, "default", () => $545b38e55456b169$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $545b38e55456b169$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("76U5U", function(module, exports) {
$parcel$export(module.exports, "default", () => $52d49b1d6729ed9b$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $52d49b1d6729ed9b$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("8YTEr", function(module, exports) {
$parcel$export(module.exports, "default", () => $689f1888fcb23cd4$export$2e2bcd8739ae039);

var $axjQt = parcelRequire("axjQt");
function $689f1888fcb23cd4$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $axjQt.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $689f1888fcb23cd4$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $axjQt.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $689f1888fcb23cd4$export$2e2bcd8739ae039 = [
    $689f1888fcb23cd4$export$23fc470827b14aa,
    $689f1888fcb23cd4$export$514bc8c1a53c1d66
];

});

parcelRegister("lHS2d", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcd7874713a11bd9$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");
parcelRequire("92RPB");
function $fcd7874713a11bd9$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $ichJ5.default)({}, ownProps, stateProps, dispatchProps);
}
function $fcd7874713a11bd9$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $fcd7874713a11bd9$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $fcd7874713a11bd9$export$5b105939c84b5234(mergeProps) : undefined;
}
function $fcd7874713a11bd9$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $fcd7874713a11bd9$export$691c327fc30bc857;
    } : undefined;
}
var $fcd7874713a11bd9$export$2e2bcd8739ae039 = [
    $fcd7874713a11bd9$export$d61b680184bc3f00,
    $fcd7874713a11bd9$export$a13ba70ef50dda6d
];

});

parcelRegister("1Be9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $12a438751f1b70f3$export$2e2bcd8739ae039);

var $gMtYT = parcelRequire("gMtYT");
parcelRequire("5MIeB");
function $12a438751f1b70f3$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $12a438751f1b70f3$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $12a438751f1b70f3$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $gMtYT.default)(_ref2, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $12a438751f1b70f3$export$d20c0c2ca6eb2b6f : $12a438751f1b70f3$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("5MIeB", function(module, exports) {

var $76U5U = parcelRequire("76U5U");
function $4363bf831d80f68a$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!selector.hasOwnProperty('dependsOnOwnProps')) (0, $76U5U.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $4363bf831d80f68a$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $4363bf831d80f68a$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $4363bf831d80f68a$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $4363bf831d80f68a$var$verify(mergeProps, 'mergeProps', displayName);
}

});




parcelRegister("gIeP2", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("jcWK3"));

});
parcelRegister("jcWK3", function(module, exports) {
'use strict';

var $2uUDX = parcelRequire("2uUDX");

var $3gIJg = parcelRequire("3gIJg");

var $fygQH = parcelRequire("fygQH");

var $gbJQ3 = parcelRequire("gbJQ3");

var $c0x6s = parcelRequire("c0x6s");

var $9RvWx = parcelRequire("9RvWx");

var $ejVUJ = parcelRequire("ejVUJ");

var $jBqbF = parcelRequire("jBqbF");

var $jseT6 = parcelRequire("jseT6");
var $dfbcb432c5e6bc36$var$loadQuery = $jseT6.loadQuery;

var $fqdPA = parcelRequire("fqdPA");

var $k4kpR = parcelRequire("k4kpR");

var $2RKqr = parcelRequire("2RKqr");

var $1Phpp = parcelRequire("1Phpp");

var $dVTdt = parcelRequire("dVTdt");

var $6EUbP = parcelRequire("6EUbP");

var $26iG2 = parcelRequire("26iG2");

var $9LSMn = parcelRequire("9LSMn");

var $hE4S7 = parcelRequire("hE4S7");

var $bpanV = parcelRequire("bpanV");

var $hJBLU = parcelRequire("hJBLU");

var $bCTRv = parcelRequire("bCTRv");

var $6Rb0E = parcelRequire("6Rb0E");

var $2h1rk = parcelRequire("2h1rk");

var $yjcQd = parcelRequire("yjcQd");

var $f2UoR = parcelRequire("f2UoR");
module.exports = {
    ConnectionHandler: $f2UoR.ConnectionHandler,
    QueryRenderer: $c0x6s,
    LocalQueryRenderer: $fygQH,
    MutationTypes: $f2UoR.MutationTypes,
    RangeOperations: $f2UoR.RangeOperations,
    ReactRelayContext: $2uUDX,
    applyOptimisticMutation: $f2UoR.applyOptimisticMutation,
    commitLocalUpdate: $f2UoR.commitLocalUpdate,
    commitMutation: $f2UoR.commitMutation,
    createFragmentContainer: $3gIJg.createContainer,
    createPaginationContainer: $gbJQ3.createContainer,
    createRefetchContainer: $9RvWx.createContainer,
    fetchQuery_DEPRECATED: $f2UoR.fetchQuery_DEPRECATED,
    graphql: $f2UoR.graphql,
    readInlineData: $f2UoR.readInlineData,
    requestSubscription: $f2UoR.requestSubscription,
    EntryPointContainer: $ejVUJ,
    RelayEnvironmentProvider: $k4kpR,
    ProfilerContext: $fqdPA,
    fetchQuery: $f2UoR.fetchQuery,
    loadQuery: $dfbcb432c5e6bc36$var$loadQuery,
    loadEntryPoint: $jBqbF,
    useClientQuery: $2RKqr,
    useFragment: $dVTdt,
    useLazyLoadQuery: $6EUbP,
    useEntryPointLoader: $1Phpp,
    useQueryLoader: $hJBLU,
    useMutation: $26iG2,
    usePaginationFragment: $9LSMn,
    usePreloadedQuery: $bpanV,
    useRefetchableFragment: $bCTRv,
    usePrefetchableForwardPaginationFragment: $hE4S7,
    useRelayEnvironment: $6Rb0E,
    useSubscribeToInvalidationState: $2h1rk,
    useSubscription: $yjcQd
};

});
parcelRegister("2uUDX", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $1d1a5253c87b7ce0$var$createRelayContext = $f2UoR.__internal.createRelayContext;
module.exports = $1d1a5253c87b7ce0$var$createRelayContext($4fqPo);

});

parcelRegister("3gIJg", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $26158ff523c305fc$var$_interopRequireDefault = $5gh7j.default;

var $26158ff523c305fc$var$_extends2 = $26158ff523c305fc$var$_interopRequireDefault((parcelRequire("idTMb")));

var $26158ff523c305fc$var$_objectWithoutPropertiesLoose2 = $26158ff523c305fc$var$_interopRequireDefault((parcelRequire("f75CH")));

var $26158ff523c305fc$var$_assertThisInitialized2 = $26158ff523c305fc$var$_interopRequireDefault((parcelRequire("4iqe3")));

var $26158ff523c305fc$var$_inheritsLoose2 = $26158ff523c305fc$var$_interopRequireDefault((parcelRequire("cNLTC")));

var $26158ff523c305fc$var$_defineProperty2 = $26158ff523c305fc$var$_interopRequireDefault((parcelRequire("dS6Sc")));
var $26158ff523c305fc$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lDEgC = parcelRequire("lDEgC");

var $gMozn = parcelRequire("gMozn");
var $26158ff523c305fc$var$getContainerName = $gMozn.getContainerName;

var $cENOs = parcelRequire("cENOs");
var $26158ff523c305fc$var$assertRelayContext = $cENOs.assertRelayContext;

var $aAp8o = parcelRequire("aAp8o");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $26158ff523c305fc$var$createFragmentSpecResolver = $f2UoR.createFragmentSpecResolver, $26158ff523c305fc$var$getDataIDsFromObject = $f2UoR.getDataIDsFromObject, $26158ff523c305fc$var$isScalarAndEqual = $f2UoR.isScalarAndEqual;
function $26158ff523c305fc$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $26158ff523c305fc$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $26158ff523c305fc$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $26158ff523c305fc$var$_defineProperty2["default"])((0, $26158ff523c305fc$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $26158ff523c305fc$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $26158ff523c305fc$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $26158ff523c305fc$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $26158ff523c305fc$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $26158ff523c305fc$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $26158ff523c305fc$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $26158ff523c305fc$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$aAp8o(prevIDs, nextIDs)) {
                resolver = $26158ff523c305fc$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $26158ff523c305fc$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $26158ff523c305fc$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$26158ff523c305fc$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $26158ff523c305fc$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $26158ff523c305fc$var$_excluded);
            return /*#__PURE__*/ $4fqPo.createElement(Component, (0, $26158ff523c305fc$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($4fqPo.Component), (0, $26158ff523c305fc$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $26158ff523c305fc$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $26158ff523c305fc$var$createContainer(Component, fragmentSpec) {
    return $lDEgC(Component, fragmentSpec, $26158ff523c305fc$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $26158ff523c305fc$var$createContainer
};

});
parcelRegister("idTMb", function(module, exports) {
function $d444b4dc3089d235$var$_extends() {
    return module.exports = $d444b4dc3089d235$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $d444b4dc3089d235$var$_extends.apply(null, arguments);
}
module.exports = $d444b4dc3089d235$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4iqe3", function(module, exports) {
function $320d2fc2101fb095$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $320d2fc2101fb095$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cNLTC", function(module, exports) {

var $lRG9C = parcelRequire("lRG9C");
function $951f36c71d77d69a$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $lRG9C(t, o);
}
module.exports = $951f36c71d77d69a$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lRG9C", function(module, exports) {
function $feaf3f29ef182405$var$_setPrototypeOf(t, e) {
    return module.exports = $feaf3f29ef182405$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $feaf3f29ef182405$var$_setPrototypeOf(t, e);
}
module.exports = $feaf3f29ef182405$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("lDEgC", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $0410b7a3d6b92c5c$var$_interopRequireDefault = $5gh7j.default;

var $0410b7a3d6b92c5c$var$_extends2 = $0410b7a3d6b92c5c$var$_interopRequireDefault((parcelRequire("idTMb")));

var $jZHzV = parcelRequire("jZHzV");

var $gMozn = parcelRequire("gMozn");
var $0410b7a3d6b92c5c$var$getComponentName = $gMozn.getComponentName, $0410b7a3d6b92c5c$var$getContainerName = $gMozn.getContainerName;

var $2uUDX = parcelRequire("2uUDX");

var $5dMH0 = parcelRequire("5dMH0");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $0410b7a3d6b92c5c$var$getFragment = $f2UoR.getFragment;
var $0410b7a3d6b92c5c$var$useContext = $4fqPo.useContext;
function $0410b7a3d6b92c5c$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $0410b7a3d6b92c5c$var$getContainerName(ComponentClass);
    $jZHzV($0410b7a3d6b92c5c$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $0410b7a3d6b92c5c$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $0410b7a3d6b92c5c$var$useContext($2uUDX);
        !(context != null) && $1K7ys(false);
        var queryRendererContext = $0410b7a3d6b92c5c$var$useContext($5dMH0);
        return /*#__PURE__*/ $4fqPo.createElement(Container, (0, $0410b7a3d6b92c5c$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $4fqPo.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $0410b7a3d6b92c5c$var$buildReactRelayContainer;

});
parcelRegister("jZHzV", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");
function $e8e584991a37a1a9$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $1K7ys(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $1K7ys(false);
    }
}
module.exports = $e8e584991a37a1a9$var$assertFragmentMap;

});

parcelRegister("gMozn", function(module, exports) {
'use strict';
function $c3743009faf60857$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $c3743009faf60857$var$getContainerName(Component) {
    return 'Relay(' + $c3743009faf60857$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $c3743009faf60857$var$getComponentName,
    getContainerName: $c3743009faf60857$var$getContainerName
};

});

parcelRegister("5dMH0", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");
module.exports = $4fqPo.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("cENOs", function(module, exports) {
'use strict';

var $9WLGg = parcelRequire("9WLGg");

var $1K7ys = parcelRequire("1K7ys");
function $936fdc413edcb650$var$assertRelayContext(relay) {
    !$936fdc413edcb650$var$isRelayContext(relay) && $1K7ys(false);
    return relay;
}
function $936fdc413edcb650$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $9WLGg(context.environment);
}
module.exports = {
    assertRelayContext: $936fdc413edcb650$var$assertRelayContext,
    isRelayContext: $936fdc413edcb650$var$isRelayContext
};

});
parcelRegister("9WLGg", function(module, exports) {
'use strict';
function $73de8433e13eeefb$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $73de8433e13eeefb$var$isRelayEnvironment;

});



parcelRegister("fygQH", function(module, exports) {
'use strict';

var $2uUDX = parcelRequire("2uUDX");

var $5dMH0 = parcelRequire("5dMH0");

var $aAp8o = parcelRequire("aAp8o");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $b52719d7ea96b18e$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $b52719d7ea96b18e$var$deepFreeze = $f2UoR.deepFreeze, $b52719d7ea96b18e$var$getRequest = $f2UoR.getRequest;
var $b52719d7ea96b18e$var$useLayoutEffect = $4fqPo.useLayoutEffect, $b52719d7ea96b18e$var$useState = $4fqPo.useState, $b52719d7ea96b18e$var$useRef = $4fqPo.useRef, $b52719d7ea96b18e$var$useMemo = $4fqPo.useMemo;
var $b52719d7ea96b18e$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $b52719d7ea96b18e$var$useDeepCompare(value) {
    var latestValue = $4fqPo.useRef(value);
    if (!$aAp8o(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $b52719d7ea96b18e$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $b52719d7ea96b18e$var$useDeepCompare(variables);
    var operation = $b52719d7ea96b18e$var$useMemo(function() {
        var request = $b52719d7ea96b18e$var$getRequest(query);
        return $b52719d7ea96b18e$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $b52719d7ea96b18e$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $b52719d7ea96b18e$var$useRef(null);
    var _useState = $b52719d7ea96b18e$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $b52719d7ea96b18e$var$useRef(null);
    var snapshot = $b52719d7ea96b18e$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $b52719d7ea96b18e$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($2uUDX.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $4fqPo.createElement($5dMH0.Provider, {
        value: $b52719d7ea96b18e$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $b52719d7ea96b18e$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("gbJQ3", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $bc913b0261d6d328$var$_interopRequireDefault = $5gh7j.default;

var $bc913b0261d6d328$var$_extends2 = $bc913b0261d6d328$var$_interopRequireDefault((parcelRequire("idTMb")));

var $bc913b0261d6d328$var$_objectWithoutPropertiesLoose2 = $bc913b0261d6d328$var$_interopRequireDefault((parcelRequire("f75CH")));

var $bc913b0261d6d328$var$_assertThisInitialized2 = $bc913b0261d6d328$var$_interopRequireDefault((parcelRequire("4iqe3")));

var $bc913b0261d6d328$var$_inheritsLoose2 = $bc913b0261d6d328$var$_interopRequireDefault((parcelRequire("cNLTC")));

var $bc913b0261d6d328$var$_defineProperty2 = $bc913b0261d6d328$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $bc913b0261d6d328$var$_objectSpread3 = $bc913b0261d6d328$var$_interopRequireDefault((parcelRequire("kV9I3")));
var $bc913b0261d6d328$var$_excluded = [
    "componentRef"
], $bc913b0261d6d328$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $bc913b0261d6d328$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lDEgC = parcelRequire("lDEgC");

var $8gyt1 = parcelRequire("8gyt1");

var $gMozn = parcelRequire("gMozn");
var $bc913b0261d6d328$var$getComponentName = $gMozn.getComponentName, $bc913b0261d6d328$var$getContainerName = $gMozn.getContainerName;

var $2uUDX = parcelRequire("2uUDX");

var $bKgvM = parcelRequire("bKgvM");

var $cENOs = parcelRequire("cENOs");
var $bc913b0261d6d328$var$assertRelayContext = $cENOs.assertRelayContext;

var $aAp8o = parcelRequire("aAp8o");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $bc913b0261d6d328$var$ConnectionInterface = $f2UoR.ConnectionInterface, $bc913b0261d6d328$var$Observable = $f2UoR.Observable, $bc913b0261d6d328$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $bc913b0261d6d328$var$createFragmentSpecResolver = $f2UoR.createFragmentSpecResolver, $bc913b0261d6d328$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $bc913b0261d6d328$var$getDataIDsFromObject = $f2UoR.getDataIDsFromObject, $bc913b0261d6d328$var$getRequest = $f2UoR.getRequest, $bc913b0261d6d328$var$getVariablesFromObject = $f2UoR.getVariablesFromObject, $bc913b0261d6d328$var$isScalarAndEqual = $f2UoR.isScalarAndEqual;
parcelRequire("cfakl");
var $bc913b0261d6d328$var$FORWARD = 'forward';
function $bc913b0261d6d328$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $1K7ys(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $bc913b0261d6d328$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $1K7ys(false);
    return function(prevVars, totalCount) {
        return (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, prevVars), {}, (0, $bc913b0261d6d328$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $bc913b0261d6d328$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $1K7ys(false);
            !!foundConnectionMetadata && $1K7ys(false);
            foundConnectionMetadata = (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $1K7ys(false);
    return foundConnectionMetadata || {};
}
function $bc913b0261d6d328$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $bc913b0261d6d328$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $bc913b0261d6d328$var$getComponentName(Component);
    var containerName = $bc913b0261d6d328$var$getContainerName(Component);
    var metadata = $bc913b0261d6d328$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $bc913b0261d6d328$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $1K7ys(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $bc913b0261d6d328$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $bc913b0261d6d328$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $bc913b0261d6d328$var$_defineProperty2["default"])((0, $bc913b0261d6d328$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $bc913b0261d6d328$var$_defineProperty2["default"])((0, $bc913b0261d6d328$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $bc913b0261d6d328$var$_defineProperty2["default"])((0, $bc913b0261d6d328$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $bc913b0261d6d328$var$_defineProperty2["default"])((0, $bc913b0261d6d328$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $bc913b0261d6d328$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $bc913b0261d6d328$var$_defineProperty2["default"])((0, $bc913b0261d6d328$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $bc913b0261d6d328$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $bc913b0261d6d328$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $bc913b0261d6d328$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $bc913b0261d6d328$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($bc913b0261d6d328$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $bc913b0261d6d328$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $bc913b0261d6d328$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($bc913b0261d6d328$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($bc913b0261d6d328$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $bc913b0261d6d328$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $bc913b0261d6d328$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $bc913b0261d6d328$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $8gyt1(fragments, this.props);
            var nextRootVariables = $8gyt1(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$aAp8o(prevRootVariables, nextRootVariables) || !$aAp8o(prevIDs, nextIDs)) {
                this._cleanup();
                if ($bc913b0261d6d328$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $bc913b0261d6d328$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $bc913b0261d6d328$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$bc913b0261d6d328$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $bc913b0261d6d328$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $bc913b0261d6d328$var$_excluded);
            var props = (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $bc913b0261d6d328$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $1K7ys(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $1K7ys(false);
            !(typeof pageInfo === 'object') && $1K7ys(false);
            var hasMore = direction === $bc913b0261d6d328$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $bc913b0261d6d328$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $bKgvM();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $bc913b0261d6d328$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $bc913b0261d6d328$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $bc913b0261d6d328$var$_excluded2);
            var props = (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $8gyt1(fragments, restProps);
            fragmentVariables = $bc913b0261d6d328$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $1K7ys(false);
            fetchVariables = (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $bc913b0261d6d328$var$_objectSpread3["default"])((0, $bc913b0261d6d328$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $bc913b0261d6d328$var$getRequest(connectionConfig.query);
            var operation = $bc913b0261d6d328$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$aAp8o(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $bc913b0261d6d328$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $bc913b0261d6d328$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $bc913b0261d6d328$var$_excluded3);
            return /*#__PURE__*/ $4fqPo.createElement($2uUDX.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $4fqPo.createElement(Component, (0, $bc913b0261d6d328$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($4fqPo.Component), (0, $bc913b0261d6d328$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $bc913b0261d6d328$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $lDEgC(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $bc913b0261d6d328$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $bc913b0261d6d328$var$createContainer
};

});
parcelRegister("8gyt1", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $604a8dc857c505a2$var$_interopRequireDefault = $5gh7j.default;

var $604a8dc857c505a2$var$_objectSpread2 = $604a8dc857c505a2$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $f2UoR = parcelRequire("f2UoR");
var $604a8dc857c505a2$var$getSelector = $f2UoR.getSelector;
function $604a8dc857c505a2$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $604a8dc857c505a2$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $604a8dc857c505a2$var$_objectSpread2["default"])((0, $604a8dc857c505a2$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $604a8dc857c505a2$var$getRootVariablesForFragments;

});

parcelRegister("bKgvM", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $88d0cc72c39fc33e$var$_interopRequireDefault = $5gh7j.default;

var $88d0cc72c39fc33e$var$_defineProperty2 = $88d0cc72c39fc33e$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $1K7ys = parcelRequire("1K7ys");

var $f2UoR = parcelRequire("f2UoR");
var $88d0cc72c39fc33e$var$fetchQuery = $f2UoR.__internal.fetchQuery, $88d0cc72c39fc33e$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $88d0cc72c39fc33e$var$isRelayModernEnvironment = $f2UoR.isRelayModernEnvironment;
var $88d0cc72c39fc33e$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $88d0cc72c39fc33e$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $88d0cc72c39fc33e$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$88d0cc72c39fc33e$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $88d0cc72c39fc33e$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $1K7ys(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $88d0cc72c39fc33e$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $1K7ys(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $1K7ys(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $88d0cc72c39fc33e$var$ReactRelayQueryFetcher;

});


parcelRegister("c0x6s", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $8bdf29b1c6f12b3f$var$_interopRequireDefault = $5gh7j.default;

var $8bdf29b1c6f12b3f$var$_objectSpread2 = $8bdf29b1c6f12b3f$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $8bdf29b1c6f12b3f$var$_assertThisInitialized2 = $8bdf29b1c6f12b3f$var$_interopRequireDefault((parcelRequire("4iqe3")));

var $8bdf29b1c6f12b3f$var$_inheritsLoose2 = $8bdf29b1c6f12b3f$var$_interopRequireDefault((parcelRequire("cNLTC")));

var $8bdf29b1c6f12b3f$var$_defineProperty2 = $8bdf29b1c6f12b3f$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $2uUDX = parcelRequire("2uUDX");

var $bKgvM = parcelRequire("bKgvM");

var $5dMH0 = parcelRequire("5dMH0");

var $aAp8o = parcelRequire("aAp8o");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $8bdf29b1c6f12b3f$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $8bdf29b1c6f12b3f$var$deepFreeze = $f2UoR.deepFreeze, $8bdf29b1c6f12b3f$var$getRequest = $f2UoR.getRequest;
var $8bdf29b1c6f12b3f$var$requestCache = {};
var $8bdf29b1c6f12b3f$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $8bdf29b1c6f12b3f$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $8bdf29b1c6f12b3f$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $8bdf29b1c6f12b3f$var$_defineProperty2["default"])((0, $8bdf29b1c6f12b3f$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $8bdf29b1c6f12b3f$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $8bdf29b1c6f12b3f$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $8bdf29b1c6f12b3f$var$getRequest(query);
            requestCacheKey = $8bdf29b1c6f12b3f$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey] ? $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey].queryFetcher : new $bKgvM();
        } else queryFetcher = new $bKgvM();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $8bdf29b1c6f12b3f$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $8bdf29b1c6f12b3f$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$aAp8o(prevState.prevPropsVariables, nextProps.variables)) return $8bdf29b1c6f12b3f$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $8bdf29b1c6f12b3f$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $8bdf29b1c6f12b3f$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $8bdf29b1c6f12b3f$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $4fqPo.createElement($2uUDX.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $4fqPo.createElement($5dMH0.Provider, {
            value: $8bdf29b1c6f12b3f$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($4fqPo.Component);
function $8bdf29b1c6f12b3f$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $8bdf29b1c6f12b3f$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $8bdf29b1c6f12b3f$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $8bdf29b1c6f12b3f$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $8bdf29b1c6f12b3f$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $8bdf29b1c6f12b3f$var$getRequest(query);
        var requestCacheKey = $8bdf29b1c6f12b3f$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey] ? $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey].queryFetcher : new $bKgvM(prevSelectionReferences);
    } else queryFetcher = new $bKgvM(prevSelectionReferences);
    return (0, $8bdf29b1c6f12b3f$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $8bdf29b1c6f12b3f$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $8bdf29b1c6f12b3f$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $8bdf29b1c6f12b3f$var$getRequest(query);
        var operation = $8bdf29b1c6f12b3f$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey]) {
            var snapshot = $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $8bdf29b1c6f12b3f$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $8bdf29b1c6f12b3f$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $8bdf29b1c6f12b3f$var$getRequestCacheKey(request.params, props.variables);
            $8bdf29b1c6f12b3f$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $8bdf29b1c6f12b3f$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $8bdf29b1c6f12b3f$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $8bdf29b1c6f12b3f$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $8bdf29b1c6f12b3f$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $8bdf29b1c6f12b3f$var$ReactRelayQueryRenderer;

});

parcelRegister("9RvWx", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $72e1d783cedd93b4$var$_interopRequireDefault = $5gh7j.default;

var $72e1d783cedd93b4$var$_extends2 = $72e1d783cedd93b4$var$_interopRequireDefault((parcelRequire("idTMb")));

var $72e1d783cedd93b4$var$_objectWithoutPropertiesLoose2 = $72e1d783cedd93b4$var$_interopRequireDefault((parcelRequire("f75CH")));

var $72e1d783cedd93b4$var$_objectSpread2 = $72e1d783cedd93b4$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $72e1d783cedd93b4$var$_assertThisInitialized2 = $72e1d783cedd93b4$var$_interopRequireDefault((parcelRequire("4iqe3")));

var $72e1d783cedd93b4$var$_inheritsLoose2 = $72e1d783cedd93b4$var$_interopRequireDefault((parcelRequire("cNLTC")));

var $72e1d783cedd93b4$var$_defineProperty2 = $72e1d783cedd93b4$var$_interopRequireDefault((parcelRequire("dS6Sc")));
var $72e1d783cedd93b4$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $lDEgC = parcelRequire("lDEgC");

var $8gyt1 = parcelRequire("8gyt1");

var $gMozn = parcelRequire("gMozn");
var $72e1d783cedd93b4$var$getContainerName = $gMozn.getContainerName;

var $2uUDX = parcelRequire("2uUDX");

var $bKgvM = parcelRequire("bKgvM");

var $cENOs = parcelRequire("cENOs");
var $72e1d783cedd93b4$var$assertRelayContext = $cENOs.assertRelayContext;

var $aAp8o = parcelRequire("aAp8o");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $72e1d783cedd93b4$var$Observable = $f2UoR.Observable, $72e1d783cedd93b4$var$createFragmentSpecResolver = $f2UoR.createFragmentSpecResolver, $72e1d783cedd93b4$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $72e1d783cedd93b4$var$getDataIDsFromObject = $f2UoR.getDataIDsFromObject, $72e1d783cedd93b4$var$getRequest = $f2UoR.getRequest, $72e1d783cedd93b4$var$getVariablesFromObject = $f2UoR.getVariablesFromObject, $72e1d783cedd93b4$var$isScalarAndEqual = $f2UoR.isScalarAndEqual;
parcelRequire("cfakl");
function $72e1d783cedd93b4$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $72e1d783cedd93b4$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $72e1d783cedd93b4$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $72e1d783cedd93b4$var$_defineProperty2["default"])((0, $72e1d783cedd93b4$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $72e1d783cedd93b4$var$_defineProperty2["default"])((0, $72e1d783cedd93b4$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $72e1d783cedd93b4$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $8gyt1(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $72e1d783cedd93b4$var$_objectSpread2["default"])((0, $72e1d783cedd93b4$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $72e1d783cedd93b4$var$_objectSpread2["default"])((0, $72e1d783cedd93b4$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $72e1d783cedd93b4$var$getRequest(taggedNode);
                var operation = $72e1d783cedd93b4$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $72e1d783cedd93b4$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $72e1d783cedd93b4$var$_objectSpread2["default"])((0, $72e1d783cedd93b4$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $72e1d783cedd93b4$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $72e1d783cedd93b4$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $72e1d783cedd93b4$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $72e1d783cedd93b4$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $72e1d783cedd93b4$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $72e1d783cedd93b4$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $8gyt1(fragments, prevProps);
            var nextRootVariables = $8gyt1(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$aAp8o(prevRootVariables, nextRootVariables) || !$aAp8o(prevIDs, nextIDs)) {
                resolver = $72e1d783cedd93b4$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $72e1d783cedd93b4$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$72e1d783cedd93b4$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $72e1d783cedd93b4$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $bKgvM();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $72e1d783cedd93b4$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $72e1d783cedd93b4$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $4fqPo.createElement($2uUDX.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $4fqPo.createElement(Component, (0, $72e1d783cedd93b4$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($4fqPo.Component), (0, $72e1d783cedd93b4$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $72e1d783cedd93b4$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $72e1d783cedd93b4$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $lDEgC(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $72e1d783cedd93b4$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $72e1d783cedd93b4$var$createContainer
};

});

parcelRegister("ejVUJ", function(module, exports) {
'use strict';

var $fqdPA = parcelRequire("fqdPA");

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");

var $4fqPo = parcelRequire("4fqPo");
var $a6cfc38faa80834e$var$useContext = $4fqPo.useContext, $a6cfc38faa80834e$var$useEffect = $4fqPo.useEffect;
parcelRequire("cfakl");
function $a6cfc38faa80834e$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $a6cfc38faa80834e$var$useContext($fqdPA);
    var environment = $6Rb0E();
    $a6cfc38faa80834e$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $4fqPo.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $a6cfc38faa80834e$var$EntryPointContainer;

});
parcelRegister("fqdPA", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");
var $b3a403484eeb105c$var$ProfilerContext = $4fqPo.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $b3a403484eeb105c$var$ProfilerContext;

});

parcelRegister("6Rb0E", function(module, exports) {
'use strict';

var $2uUDX = parcelRequire("2uUDX");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $4fe03b907e8b60bd$var$useContext = $4fqPo.useContext;
function $4fe03b907e8b60bd$var$useRelayEnvironment() {
    var context = $4fe03b907e8b60bd$var$useContext($2uUDX);
    !(context != null) && $1K7ys(false);
    return context.environment;
}
module.exports = $4fe03b907e8b60bd$var$useRelayEnvironment;

});


parcelRegister("jBqbF", function(module, exports) {
'use strict';

var $jseT6 = parcelRequire("jseT6");
var $e455c94663492499$var$loadQuery = $jseT6.loadQuery;
function $e455c94663492499$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $e455c94663492499$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $e455c94663492499$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $e455c94663492499$var$loadEntryPoint;

});
parcelRegister("jseT6", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $e29c2e4461b933b7$var$_interopRequireDefault = $5gh7j.default;

var $e29c2e4461b933b7$var$_objectSpread2 = $e29c2e4461b933b7$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $1K7ys = parcelRequire("1K7ys");

var $f2UoR = parcelRequire("f2UoR");
var $e29c2e4461b933b7$var$fetchQueryDeduped = $f2UoR.__internal.fetchQueryDeduped, $e29c2e4461b933b7$var$Observable = $f2UoR.Observable, $e29c2e4461b933b7$var$PreloadableQueryRegistry = $f2UoR.PreloadableQueryRegistry, $e29c2e4461b933b7$var$ReplaySubject = $f2UoR.ReplaySubject, $e29c2e4461b933b7$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $e29c2e4461b933b7$var$getRequest = $f2UoR.getRequest, $e29c2e4461b933b7$var$getRequestIdentifier = $f2UoR.getRequestIdentifier;
var $e29c2e4461b933b7$var$fetchKey = 100001;
function $e29c2e4461b933b7$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $e29c2e4461b933b7$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $e29c2e4461b933b7$var$_objectSpread2["default"])((0, $e29c2e4461b933b7$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $e29c2e4461b933b7$var$ReplaySubject();
    var returnedObservable = $e29c2e4461b933b7$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $e29c2e4461b933b7$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $e29c2e4461b933b7$var$getRequestIdentifier(params, variables);
        var observable = $e29c2e4461b933b7$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $e29c2e4461b933b7$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $e29c2e4461b933b7$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $e29c2e4461b933b7$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $1K7ys(false);
        var _module = $e29c2e4461b933b7$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $e29c2e4461b933b7$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $e29c2e4461b933b7$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $e29c2e4461b933b7$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $e29c2e4461b933b7$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $e29c2e4461b933b7$var$loadQuery
};

});


parcelRegister("k4kpR", function(module, exports) {
'use strict';

var $2uUDX = parcelRequire("2uUDX");

var $4fqPo = parcelRequire("4fqPo");
var $e9c40499a322300c$var$useMemo = $4fqPo.useMemo;
function $e9c40499a322300c$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $e9c40499a322300c$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($2uUDX.Provider, {
        value: context
    }, children);
}
module.exports = $e9c40499a322300c$var$RelayEnvironmentProvider;

});

parcelRegister("2RKqr", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $21648b288f3fd96e$var$_interopRequireDefault = $5gh7j.default;

var $21648b288f3fd96e$var$_objectSpread2 = $21648b288f3fd96e$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $6EUbP = parcelRequire("6EUbP");
function $21648b288f3fd96e$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $6EUbP(query, variables, (0, $21648b288f3fd96e$var$_objectSpread2["default"])((0, $21648b288f3fd96e$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $21648b288f3fd96e$var$useClientQuery;

});
parcelRegister("6EUbP", function(module, exports) {
'use strict';

var $gGXhB = parcelRequire("gGXhB");

var $cxsn0 = parcelRequire("cxsn0");

var $6Rb0E = parcelRequire("6Rb0E");

var $f2UoR = parcelRequire("f2UoR");
var $4d9210a4e7f264bf$var$fetchQuery = $f2UoR.__internal.fetchQuery;
function $4d9210a4e7f264bf$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $6Rb0E();
    var query = $cxsn0(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $gGXhB({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $4d9210a4e7f264bf$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $4d9210a4e7f264bf$var$useLazyLoadQuery;

});
parcelRegister("gGXhB", function(module, exports) {
'use strict';

var $fqdPA = parcelRequire("fqdPA");

var $68R8N = parcelRequire("68R8N");
var $c26e8defb78d9d4e$var$getQueryCacheIdentifier = $68R8N.getQueryCacheIdentifier, $c26e8defb78d9d4e$var$getQueryResourceForEnvironment = $68R8N.getQueryResourceForEnvironment;

var $dQm4z = parcelRequire("dQm4z");

var $aLpXs = parcelRequire("aLpXs");

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");
var $c26e8defb78d9d4e$var$useContext = $4fqPo.useContext, $c26e8defb78d9d4e$var$useEffect = $4fqPo.useEffect, $c26e8defb78d9d4e$var$useState = $4fqPo.useState, $c26e8defb78d9d4e$var$useRef = $4fqPo.useRef;
function $c26e8defb78d9d4e$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $6Rb0E();
    var profilerContext = $c26e8defb78d9d4e$var$useContext($fqdPA);
    var QueryResource = $c26e8defb78d9d4e$var$getQueryResourceForEnvironment(environment);
    var _useState = $c26e8defb78d9d4e$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $dQm4z(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $c26e8defb78d9d4e$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $c26e8defb78d9d4e$var$useRef(false);
    $c26e8defb78d9d4e$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $c26e8defb78d9d4e$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $c26e8defb78d9d4e$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $aLpXs(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $c26e8defb78d9d4e$var$useLazyLoadQueryNode;

});
parcelRegister("68R8N", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $478cb61e5d0cb082$var$_interopRequireDefault = $5gh7j.default;

var $478cb61e5d0cb082$var$_objectSpread2 = $478cb61e5d0cb082$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $478cb61e5d0cb082$var$_defineProperty2 = $478cb61e5d0cb082$var$_interopRequireDefault((parcelRequire("dS6Sc")));

var $jpkp0 = parcelRequire("jpkp0");

var $7KJZC = parcelRequire("7KJZC");

var $1K7ys = parcelRequire("1K7ys");

var $f2UoR = parcelRequire("f2UoR");
var $478cb61e5d0cb082$var$isPromise = $f2UoR.isPromise;
parcelRequire("cfakl");
var $478cb61e5d0cb082$var$CACHE_CAPACITY = 1000;
var $478cb61e5d0cb082$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $478cb61e5d0cb082$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $478cb61e5d0cb082$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $478cb61e5d0cb082$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $478cb61e5d0cb082$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $478cb61e5d0cb082$var$operationIsLiveQuery(operation) ? $478cb61e5d0cb082$var$DEFAULT_LIVE_FETCH_POLICY : $478cb61e5d0cb082$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $478cb61e5d0cb082$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $478cb61e5d0cb082$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $478cb61e5d0cb082$var$nextID = 200000;
function $478cb61e5d0cb082$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $478cb61e5d0cb082$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $7KJZC(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $478cb61e5d0cb082$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $478cb61e5d0cb082$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $478cb61e5d0cb082$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $jpkp0.create($478cb61e5d0cb082$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $478cb61e5d0cb082$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $478cb61e5d0cb082$var$operationIsLiveQuery(operation) ? $478cb61e5d0cb082$var$DEFAULT_LIVE_FETCH_POLICY : $478cb61e5d0cb082$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $478cb61e5d0cb082$var$_objectSpread2["default"])((0, $478cb61e5d0cb082$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($478cb61e5d0cb082$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $478cb61e5d0cb082$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $478cb61e5d0cb082$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $478cb61e5d0cb082$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $478cb61e5d0cb082$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $478cb61e5d0cb082$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $478cb61e5d0cb082$var$_objectSpread2["default"])((0, $478cb61e5d0cb082$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($478cb61e5d0cb082$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $478cb61e5d0cb082$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $1K7ys(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $478cb61e5d0cb082$var$createQueryResource(environment) {
    return new $478cb61e5d0cb082$var$QueryResourceImpl(environment);
}
var $478cb61e5d0cb082$var$dataResources = $478cb61e5d0cb082$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $478cb61e5d0cb082$var$getQueryResourceForEnvironment(environment) {
    var cached = $478cb61e5d0cb082$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $478cb61e5d0cb082$var$createQueryResource(environment);
    $478cb61e5d0cb082$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $478cb61e5d0cb082$var$createQueryResource,
    getQueryResourceForEnvironment: $478cb61e5d0cb082$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $478cb61e5d0cb082$var$getQueryCacheIdentifier
};

});
parcelRegister("jpkp0", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");
var $e2102d9619a02a23$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $1K7ys(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $e2102d9619a02a23$var$create(capacity) {
    return new $e2102d9619a02a23$var$LRUCache(capacity);
}
module.exports = {
    create: $e2102d9619a02a23$var$create
};

});

parcelRegister("7KJZC", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $5a50818451b2d89f$var$_interopRequireDefault = $5gh7j.default;

var $5a50818451b2d89f$var$_defineProperty2 = $5a50818451b2d89f$var$_interopRequireDefault((parcelRequire("dS6Sc")));
parcelRequire("cfakl");
var $5a50818451b2d89f$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $5a50818451b2d89f$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $5a50818451b2d89f$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $5a50818451b2d89f$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $5a50818451b2d89f$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $5a50818451b2d89f$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $5a50818451b2d89f$var$SuspenseResource;

});


parcelRegister("dQm4z", function(module, exports) {
'use strict';

var $051OY = parcelRequire("051OY");

var $4fqPo = parcelRequire("4fqPo");
var $a14140dfc4d700c5$var$useCallback = $4fqPo.useCallback, $a14140dfc4d700c5$var$useEffect = $4fqPo.useEffect;
function $a14140dfc4d700c5$var$useFetchTrackingRef() {
    var subscriptionRef = $051OY(null);
    var isFetchingRef = $051OY(false);
    var disposeFetch = $a14140dfc4d700c5$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $a14140dfc4d700c5$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $a14140dfc4d700c5$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $a14140dfc4d700c5$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $a14140dfc4d700c5$var$useFetchTrackingRef;

});
parcelRegister("051OY", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");
var $00f1e15eba5f456e$var$useMemo = $4fqPo.useMemo;
function $00f1e15eba5f456e$var$useUnsafeRef_DEPRECATED(init) {
    return $00f1e15eba5f456e$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $00f1e15eba5f456e$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("aLpXs", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $7d626de6053ef089$var$_interopRequireDefault = $5gh7j.default;

var $7d626de6053ef089$var$_useFragmentInternal_CURRENT = $7d626de6053ef089$var$_interopRequireDefault((parcelRequire("5k7wr")));

var $7d626de6053ef089$var$_useFragmentInternal_EXPERIMENTAL = $7d626de6053ef089$var$_interopRequireDefault((parcelRequire("7XFeN")));

var $f2UoR = parcelRequire("f2UoR");
function $7d626de6053ef089$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($f2UoR.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $7d626de6053ef089$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $7d626de6053ef089$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $7d626de6053ef089$var$useFragmentInternal;

});
parcelRegister("5k7wr", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $3e04a7c8fe78c69b$var$_interopRequireDefault = $5gh7j.default;

var $3e04a7c8fe78c69b$var$_objectSpread2 = $3e04a7c8fe78c69b$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2 = $3e04a7c8fe78c69b$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $3e04a7c8fe78c69b$var$_toConsumableArray2 = $3e04a7c8fe78c69b$var$_interopRequireDefault((parcelRequire("bmnrf")));

var $68R8N = parcelRequire("68R8N");
var $3e04a7c8fe78c69b$var$getQueryResourceForEnvironment = $68R8N.getQueryResourceForEnvironment;

var $6Rb0E = parcelRequire("6Rb0E");

var $4QnMP = parcelRequire("4QnMP");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $3e04a7c8fe78c69b$var$useDebugValue = $4fqPo.useDebugValue, $3e04a7c8fe78c69b$var$useEffect = $4fqPo.useEffect, $3e04a7c8fe78c69b$var$useMemo = $4fqPo.useMemo, $3e04a7c8fe78c69b$var$useRef = $4fqPo.useRef, $3e04a7c8fe78c69b$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $3e04a7c8fe78c69b$var$_require3$__internal = $f2UoR.__internal, $3e04a7c8fe78c69b$var$fetchQueryInternal = $3e04a7c8fe78c69b$var$_require3$__internal.fetchQuery, $3e04a7c8fe78c69b$var$getPromiseForActiveRequest = $3e04a7c8fe78c69b$var$_require3$__internal.getPromiseForActiveRequest, $3e04a7c8fe78c69b$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $3e04a7c8fe78c69b$var$areEqualSelectors = $f2UoR.areEqualSelectors, $3e04a7c8fe78c69b$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $3e04a7c8fe78c69b$var$getPendingOperationsForFragment = $f2UoR.getPendingOperationsForFragment, $3e04a7c8fe78c69b$var$getSelector = $f2UoR.getSelector, $3e04a7c8fe78c69b$var$getVariablesFromFragment = $f2UoR.getVariablesFromFragment, $3e04a7c8fe78c69b$var$handlePotentialSnapshotErrors = $f2UoR.handlePotentialSnapshotErrors, $3e04a7c8fe78c69b$var$recycleNodesInto = $f2UoR.recycleNodesInto;
parcelRequire("cfakl");
function $3e04a7c8fe78c69b$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $3e04a7c8fe78c69b$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $3e04a7c8fe78c69b$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $3e04a7c8fe78c69b$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $3e04a7c8fe78c69b$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $3e04a7c8fe78c69b$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $3e04a7c8fe78c69b$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $3e04a7c8fe78c69b$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $3e04a7c8fe78c69b$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $1K7ys(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $3e04a7c8fe78c69b$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $3e04a7c8fe78c69b$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $3e04a7c8fe78c69b$var$_objectSpread2["default"])((0, $3e04a7c8fe78c69b$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $3e04a7c8fe78c69b$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $3e04a7c8fe78c69b$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $3e04a7c8fe78c69b$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $3e04a7c8fe78c69b$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $3e04a7c8fe78c69b$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $3e04a7c8fe78c69b$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $3e04a7c8fe78c69b$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $3e04a7c8fe78c69b$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $3e04a7c8fe78c69b$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $3e04a7c8fe78c69b$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $3e04a7c8fe78c69b$var$useMemo(function() {
        return $3e04a7c8fe78c69b$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $1K7ys(false);
    else !!Array.isArray(fragmentRef) && $1K7ys(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $1K7ys(false);
    var environment = $6Rb0E();
    var loggerContext;
    if ($3e04a7c8fe78c69b$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $4QnMP();
    var _useState = $3e04a7c8fe78c69b$var$useState(function() {
        return $3e04a7c8fe78c69b$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $3e04a7c8fe78c69b$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $3e04a7c8fe78c69b$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $3e04a7c8fe78c69b$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$3e04a7c8fe78c69b$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $3e04a7c8fe78c69b$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $3e04a7c8fe78c69b$var$useRef(false);
    $3e04a7c8fe78c69b$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $3e04a7c8fe78c69b$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $3e04a7c8fe78c69b$var$useMemo(function() {
            var missingClientEdges = $3e04a7c8fe78c69b$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $3e04a7c8fe78c69b$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $3e04a7c8fe78c69b$var$useEffect(function() {
            var QueryResource = $3e04a7c8fe78c69b$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $3e04a7c8fe78c69b$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($3e04a7c8fe78c69b$var$isMissingData(state)) {
        var suspendingLiveResolvers = $3e04a7c8fe78c69b$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($3e04a7c8fe78c69b$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$3e04a7c8fe78c69b$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $1K7ys(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $3e04a7c8fe78c69b$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $3e04a7c8fe78c69b$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $3e04a7c8fe78c69b$var$useRef(false);
    $3e04a7c8fe78c69b$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $3e04a7c8fe78c69b$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $3e04a7c8fe78c69b$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $3e04a7c8fe78c69b$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $3e04a7c8fe78c69b$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $1K7ys(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $1K7ys(false);
        data = state.snapshot.data;
    }
    if ($3e04a7c8fe78c69b$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $3e04a7c8fe78c69b$var$useFragmentInternal;

});
parcelRegister("4QnMP", function(module, exports) {
'use strict';

var $hZcbA = parcelRequire("hZcbA");

var $4fqPo = parcelRequire("4fqPo");
var $386e783e07b6f9c0$var$useContext = $4fqPo.useContext;
function $386e783e07b6f9c0$var$useRelayLoggingContext() {
    return $386e783e07b6f9c0$var$useContext($hZcbA);
}
module.exports = $386e783e07b6f9c0$var$useRelayLoggingContext;

});
parcelRegister("hZcbA", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $d1819605f3c4c7f6$var$createRelayLoggingContext = $f2UoR.__internal.createRelayLoggingContext;
module.exports = $d1819605f3c4c7f6$var$createRelayLoggingContext($4fqPo);

});



parcelRegister("7XFeN", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $5cbe080d4fdbdea9$var$_interopRequireDefault = $5gh7j.default;

var $5cbe080d4fdbdea9$var$_objectSpread2 = $5cbe080d4fdbdea9$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2 = $5cbe080d4fdbdea9$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $5cbe080d4fdbdea9$var$_toConsumableArray2 = $5cbe080d4fdbdea9$var$_interopRequireDefault((parcelRequire("bmnrf")));

var $68R8N = parcelRequire("68R8N");
var $5cbe080d4fdbdea9$var$getQueryResourceForEnvironment = $68R8N.getQueryResourceForEnvironment;

var $6Rb0E = parcelRequire("6Rb0E");

var $4QnMP = parcelRequire("4QnMP");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $5cbe080d4fdbdea9$var$useDebugValue = $4fqPo.useDebugValue, $5cbe080d4fdbdea9$var$useEffect = $4fqPo.useEffect, $5cbe080d4fdbdea9$var$useMemo = $4fqPo.useMemo, $5cbe080d4fdbdea9$var$useRef = $4fqPo.useRef, $5cbe080d4fdbdea9$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $5cbe080d4fdbdea9$var$_require3$__internal = $f2UoR.__internal, $5cbe080d4fdbdea9$var$fetchQueryInternal = $5cbe080d4fdbdea9$var$_require3$__internal.fetchQuery, $5cbe080d4fdbdea9$var$getPromiseForActiveRequest = $5cbe080d4fdbdea9$var$_require3$__internal.getPromiseForActiveRequest, $5cbe080d4fdbdea9$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $5cbe080d4fdbdea9$var$areEqualSelectors = $f2UoR.areEqualSelectors, $5cbe080d4fdbdea9$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $5cbe080d4fdbdea9$var$getPendingOperationsForFragment = $f2UoR.getPendingOperationsForFragment, $5cbe080d4fdbdea9$var$getSelector = $f2UoR.getSelector, $5cbe080d4fdbdea9$var$getVariablesFromFragment = $f2UoR.getVariablesFromFragment, $5cbe080d4fdbdea9$var$handlePotentialSnapshotErrors = $f2UoR.handlePotentialSnapshotErrors, $5cbe080d4fdbdea9$var$recycleNodesInto = $f2UoR.recycleNodesInto;
parcelRequire("cfakl");
function $5cbe080d4fdbdea9$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $5cbe080d4fdbdea9$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $5cbe080d4fdbdea9$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $5cbe080d4fdbdea9$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $5cbe080d4fdbdea9$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $5cbe080d4fdbdea9$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $5cbe080d4fdbdea9$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $5cbe080d4fdbdea9$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $5cbe080d4fdbdea9$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $1K7ys(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $5cbe080d4fdbdea9$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $5cbe080d4fdbdea9$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $5cbe080d4fdbdea9$var$_objectSpread2["default"])((0, $5cbe080d4fdbdea9$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $5cbe080d4fdbdea9$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $5cbe080d4fdbdea9$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $5cbe080d4fdbdea9$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $5cbe080d4fdbdea9$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $5cbe080d4fdbdea9$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $5cbe080d4fdbdea9$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $5cbe080d4fdbdea9$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $5cbe080d4fdbdea9$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $5cbe080d4fdbdea9$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $5cbe080d4fdbdea9$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $5cbe080d4fdbdea9$var$useMemo(function() {
        return $5cbe080d4fdbdea9$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $1K7ys(false);
    else !!Array.isArray(fragmentRef) && $1K7ys(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $1K7ys(false);
    var environment = $6Rb0E();
    var loggerContext;
    if ($5cbe080d4fdbdea9$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $4QnMP();
    var _useState = $5cbe080d4fdbdea9$var$useState(function() {
        return $5cbe080d4fdbdea9$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$5cbe080d4fdbdea9$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $5cbe080d4fdbdea9$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $5cbe080d4fdbdea9$var$useRef(false);
    $5cbe080d4fdbdea9$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $5cbe080d4fdbdea9$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $5cbe080d4fdbdea9$var$useMemo(function() {
            var missingClientEdges = $5cbe080d4fdbdea9$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $5cbe080d4fdbdea9$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $5cbe080d4fdbdea9$var$useEffect(function() {
            var QueryResource = $5cbe080d4fdbdea9$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $5cbe080d4fdbdea9$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($5cbe080d4fdbdea9$var$isMissingData(state)) {
        var suspendingLiveResolvers = $5cbe080d4fdbdea9$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($5cbe080d4fdbdea9$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$5cbe080d4fdbdea9$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $1K7ys(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $5cbe080d4fdbdea9$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $5cbe080d4fdbdea9$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $5cbe080d4fdbdea9$var$useRef(null);
    $5cbe080d4fdbdea9$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $5cbe080d4fdbdea9$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $5cbe080d4fdbdea9$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $5cbe080d4fdbdea9$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $5cbe080d4fdbdea9$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $5cbe080d4fdbdea9$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $1K7ys(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $1K7ys(false);
        data = state.snapshot.data;
    }
    if ($5cbe080d4fdbdea9$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $5cbe080d4fdbdea9$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("cxsn0", function(module, exports) {
'use strict';

var $ePLdn = parcelRequire("ePLdn");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $920e92ccc166adf7$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $920e92ccc166adf7$var$getRequest = $f2UoR.getRequest;
var $920e92ccc166adf7$var$useMemo = $4fqPo.useMemo;
function $920e92ccc166adf7$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $ePLdn(variables);
    var memoCacheConfig = $ePLdn(cacheConfig || {});
    return $920e92ccc166adf7$var$useMemo(function() {
        return $920e92ccc166adf7$var$createOperationDescriptor($920e92ccc166adf7$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $920e92ccc166adf7$var$useMemoOperationDescriptor;

});
parcelRegister("ePLdn", function(module, exports) {
'use strict';

var $aAp8o = parcelRequire("aAp8o");

var $4fqPo = parcelRequire("4fqPo");
var $02c9757bb68edb42$var$useState = $4fqPo.useState;
function $02c9757bb68edb42$var$useMemoVariables(variables) {
    var _useState = $02c9757bb68edb42$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($aAp8o(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $02c9757bb68edb42$var$useMemoVariables;

});




parcelRegister("1Phpp", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $15480ee032dcb0f6$var$_interopRequireDefault = $5gh7j.default;

var $15480ee032dcb0f6$var$_createForOfIteratorHelper2 = $15480ee032dcb0f6$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $jBqbF = parcelRequire("jBqbF");

var $iCqaO = parcelRequire("iCqaO");

var $4fqPo = parcelRequire("4fqPo");
var $15480ee032dcb0f6$var$useCallback = $4fqPo.useCallback, $15480ee032dcb0f6$var$useEffect = $4fqPo.useEffect, $15480ee032dcb0f6$var$useRef = $4fqPo.useRef, $15480ee032dcb0f6$var$useState = $4fqPo.useState;
var $15480ee032dcb0f6$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $15480ee032dcb0f6$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $15480ee032dcb0f6$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $iCqaO();
    var undisposedEntryPointReferencesRef = $15480ee032dcb0f6$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $15480ee032dcb0f6$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $15480ee032dcb0f6$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $15480ee032dcb0f6$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $15480ee032dcb0f6$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $jBqbF(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $15480ee032dcb0f6$var$useRef(false);
    $15480ee032dcb0f6$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $15480ee032dcb0f6$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $15480ee032dcb0f6$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $15480ee032dcb0f6$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $15480ee032dcb0f6$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $15480ee032dcb0f6$var$useLoadEntryPoint;

});
parcelRegister("iCqaO", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");
var $d8e01418c4791e8e$var$useEffect = $4fqPo.useEffect, $d8e01418c4791e8e$var$useRef = $4fqPo.useRef;
function $d8e01418c4791e8e$var$useIsMountedRef() {
    var isMountedRef = $d8e01418c4791e8e$var$useRef(true);
    $d8e01418c4791e8e$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $d8e01418c4791e8e$var$useIsMountedRef;

});


parcelRegister("dVTdt", function(module, exports) {
'use strict';

var $aLpXs = parcelRequire("aLpXs");

var $jyOlf = parcelRequire("jyOlf");

var $4fqPo = parcelRequire("4fqPo");
var $a24b6e0e213b81c1$var$useDebugValue = $4fqPo.useDebugValue;

var $f2UoR = parcelRequire("f2UoR");
var $a24b6e0e213b81c1$var$getFragment = $f2UoR.getFragment;
function $a24b6e0e213b81c1$var$useFragment(fragment, key) {
    var fragmentNode = $a24b6e0e213b81c1$var$getFragment(fragment);
    $jyOlf(fragmentNode, 'first argument of useFragment()');
    var data = $aLpXs(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $a24b6e0e213b81c1$var$useFragment;

});
parcelRegister("jyOlf", function(module, exports) {
'use strict';
parcelRequire("051OY");
parcelRequire("cfakl");
function $e3d83e1a2add5fdc$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $e3d83e1a2add5fdc$var$useStaticFragmentNodeWarning;

});


parcelRegister("26iG2", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $187aa12bddf37107$var$_interopRequireDefault = $5gh7j.default;

var $187aa12bddf37107$var$_objectSpread2 = $187aa12bddf37107$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $iCqaO = parcelRequire("iCqaO");

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $187aa12bddf37107$var$defaultCommitMutation = $f2UoR.commitMutation;
var $187aa12bddf37107$var$useState = $4fqPo.useState, $187aa12bddf37107$var$useEffect = $4fqPo.useEffect, $187aa12bddf37107$var$useRef = $4fqPo.useRef, $187aa12bddf37107$var$useCallback = $4fqPo.useCallback;
function $187aa12bddf37107$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $187aa12bddf37107$var$defaultCommitMutation;
    var environment = $6Rb0E();
    var isMountedRef = $iCqaO();
    var environmentRef = $187aa12bddf37107$var$useRef(environment);
    var mutationRef = $187aa12bddf37107$var$useRef(mutation);
    var inFlightMutationsRef = $187aa12bddf37107$var$useRef(new Set());
    var _useState = $187aa12bddf37107$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $187aa12bddf37107$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $187aa12bddf37107$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $187aa12bddf37107$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $187aa12bddf37107$var$_objectSpread2["default"])((0, $187aa12bddf37107$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $187aa12bddf37107$var$useMutation;

});

parcelRegister("9LSMn", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $71d2fed870f08f74$var$_interopRequireDefault = $5gh7j.default;

var $71d2fed870f08f74$var$_objectSpread2 = $71d2fed870f08f74$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $cNPv2 = parcelRequire("cNPv2");

var $1rSAC = parcelRequire("1rSAC");

var $6Rb0E = parcelRequire("6Rb0E");

var $jyOlf = parcelRequire("jyOlf");

var $4fqPo = parcelRequire("4fqPo");
var $71d2fed870f08f74$var$useCallback = $4fqPo.useCallback, $71d2fed870f08f74$var$useDebugValue = $4fqPo.useDebugValue, $71d2fed870f08f74$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $71d2fed870f08f74$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $71d2fed870f08f74$var$getFragment = $f2UoR.getFragment, $71d2fed870f08f74$var$getFragmentIdentifier = $f2UoR.getFragmentIdentifier, $71d2fed870f08f74$var$getPaginationMetadata = $f2UoR.getPaginationMetadata;
function $71d2fed870f08f74$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $71d2fed870f08f74$var$getFragment(fragmentInput);
    $jyOlf(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $71d2fed870f08f74$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $1rSAC(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $71d2fed870f08f74$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $71d2fed870f08f74$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $71d2fed870f08f74$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $71d2fed870f08f74$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $71d2fed870f08f74$var$_objectSpread2["default"])((0, $71d2fed870f08f74$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $71d2fed870f08f74$var$useLoadMore(args) {
    var environment = $6Rb0E();
    var _useState = $71d2fed870f08f74$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $71d2fed870f08f74$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $cNPv2((0, $71d2fed870f08f74$var$_objectSpread2["default"])((0, $71d2fed870f08f74$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $71d2fed870f08f74$var$usePaginationFragment;

});
parcelRegister("cNPv2", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $9522025fd1da3c45$var$_interopRequireDefault = $5gh7j.default;

var $9522025fd1da3c45$var$_objectSpread2 = $9522025fd1da3c45$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $c9tzO = parcelRequire("c9tzO");

var $dQm4z = parcelRequire("dQm4z");

var $iCqaO = parcelRequire("iCqaO");

var $fgzS7 = parcelRequire("fgzS7");

var $cE9nz = parcelRequire("cE9nz");

var $6Rb0E = parcelRequire("6Rb0E");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $9522025fd1da3c45$var$useCallback = $4fqPo.useCallback, $9522025fd1da3c45$var$useEffect = $4fqPo.useEffect, $9522025fd1da3c45$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $9522025fd1da3c45$var$fetchQuery = $f2UoR.__internal.fetchQuery, $9522025fd1da3c45$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $9522025fd1da3c45$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $9522025fd1da3c45$var$getPaginationVariables = $f2UoR.getPaginationVariables, $9522025fd1da3c45$var$getRefetchMetadata = $f2UoR.getRefetchMetadata, $9522025fd1da3c45$var$getSelector = $f2UoR.getSelector;
parcelRequire("cfakl");
function $9522025fd1da3c45$var$useLoadMoreFunction(args) {
    if ($9522025fd1da3c45$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $cE9nz(args);
    return $9522025fd1da3c45$var$useLoadMoreFunction_CURRENT(args);
}
function $9522025fd1da3c45$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $6Rb0E();
    var _useFetchTrackingRef = $dQm4z(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $9522025fd1da3c45$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $iCqaO();
    var _useState = $9522025fd1da3c45$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $9522025fd1da3c45$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $fgzS7(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $c9tzO(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $9522025fd1da3c45$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $9522025fd1da3c45$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $9522025fd1da3c45$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $1K7ys(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $9522025fd1da3c45$var$_objectSpread2["default"])((0, $9522025fd1da3c45$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $9522025fd1da3c45$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $9522025fd1da3c45$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $9522025fd1da3c45$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $9522025fd1da3c45$var$fetchQuery(environment, paginationQuery).subscribe((0, $9522025fd1da3c45$var$_objectSpread2["default"])((0, $9522025fd1da3c45$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $9522025fd1da3c45$var$useLoadMoreFunction;

});
parcelRegister("c9tzO", function(module, exports) {
'use strict';

var $1K7ys = parcelRequire("1K7ys");

var $f2UoR = parcelRequire("f2UoR");
var $8d8d449499542b83$var$ConnectionInterface = $f2UoR.ConnectionInterface, $8d8d449499542b83$var$getValueAtPath = $f2UoR.getValueAtPath;
function $8d8d449499542b83$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $8d8d449499542b83$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $8d8d449499542b83$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $1K7ys(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $1K7ys(false);
    !(typeof pageInfo === 'object') && $1K7ys(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $1K7ys(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $8d8d449499542b83$var$getConnectionState;

});

parcelRegister("fgzS7", function(module, exports) {
'use strict';

var $6Rb0E = parcelRequire("6Rb0E");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");

var $f2UoR = parcelRequire("f2UoR");
var $b1d42d0a57f35a81$var$getObservableForActiveRequest = $f2UoR.__internal.getObservableForActiveRequest, $b1d42d0a57f35a81$var$getSelector = $f2UoR.getSelector;
var $b1d42d0a57f35a81$var$useEffect = $4fqPo.useEffect, $b1d42d0a57f35a81$var$useState = $4fqPo.useState, $b1d42d0a57f35a81$var$useMemo = $4fqPo.useMemo;
function $b1d42d0a57f35a81$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $6Rb0E();
    var observable = $b1d42d0a57f35a81$var$useMemo(function() {
        var selector = $b1d42d0a57f35a81$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $1K7ys(false);
        return $b1d42d0a57f35a81$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $b1d42d0a57f35a81$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $b1d42d0a57f35a81$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $b1d42d0a57f35a81$var$useIsOperationNodeActive;

});

parcelRegister("cE9nz", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $0260441cb495a3ca$var$_interopRequireDefault = $5gh7j.default;

var $0260441cb495a3ca$var$_objectSpread2 = $0260441cb495a3ca$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $c9tzO = parcelRequire("c9tzO");

var $iCqaO = parcelRequire("iCqaO");

var $fgzS7 = parcelRequire("fgzS7");

var $6Rb0E = parcelRequire("6Rb0E");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $0260441cb495a3ca$var$useCallback = $4fqPo.useCallback, $0260441cb495a3ca$var$useRef = $4fqPo.useRef, $0260441cb495a3ca$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $0260441cb495a3ca$var$fetchQuery = $f2UoR.__internal.fetchQuery, $0260441cb495a3ca$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $0260441cb495a3ca$var$getPaginationVariables = $f2UoR.getPaginationVariables, $0260441cb495a3ca$var$getRefetchMetadata = $f2UoR.getRefetchMetadata, $0260441cb495a3ca$var$getSelector = $f2UoR.getSelector;
parcelRequire("cfakl");
function $0260441cb495a3ca$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $6Rb0E();
    var _getRefetchMetadata = $0260441cb495a3ca$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $0260441cb495a3ca$var$useRef({
        kind: 'none'
    });
    var _useState = $0260441cb495a3ca$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $0260441cb495a3ca$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $fgzS7(fragmentNode, fragmentRef);
    var forceDisposeFn = $0260441cb495a3ca$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $c9tzO(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $iCqaO();
    var loadMore = $0260441cb495a3ca$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $0260441cb495a3ca$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $1K7ys(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $0260441cb495a3ca$var$_objectSpread2["default"])((0, $0260441cb495a3ca$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $0260441cb495a3ca$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $0260441cb495a3ca$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $0260441cb495a3ca$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $0260441cb495a3ca$var$fetchQuery(environment, paginationQuery).subscribe((0, $0260441cb495a3ca$var$_objectSpread2["default"])((0, $0260441cb495a3ca$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $0260441cb495a3ca$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("1rSAC", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $10e2a86e161b1f85$var$_interopRequireDefault = $5gh7j.default;

var $10e2a86e161b1f85$var$_objectSpread2 = $10e2a86e161b1f85$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $fqdPA = parcelRequire("fqdPA");

var $68R8N = parcelRequire("68R8N");
var $10e2a86e161b1f85$var$getQueryResourceForEnvironment = $68R8N.getQueryResourceForEnvironment;

var $l3Wiy = parcelRequire("l3Wiy");

var $aLpXs = parcelRequire("aLpXs");

var $iCqaO = parcelRequire("iCqaO");

var $hJBLU = parcelRequire("hJBLU");

var $6Rb0E = parcelRequire("6Rb0E");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $10e2a86e161b1f85$var$useCallback = $4fqPo.useCallback, $10e2a86e161b1f85$var$useContext = $4fqPo.useContext, $10e2a86e161b1f85$var$useReducer = $4fqPo.useReducer;

var $f2UoR = parcelRequire("f2UoR");
var $10e2a86e161b1f85$var$fetchQuery = $f2UoR.__internal.fetchQuery, $10e2a86e161b1f85$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $10e2a86e161b1f85$var$getFragmentIdentifier = $f2UoR.getFragmentIdentifier, $10e2a86e161b1f85$var$getRefetchMetadata = $f2UoR.getRefetchMetadata, $10e2a86e161b1f85$var$getSelector = $f2UoR.getSelector, $10e2a86e161b1f85$var$getValueAtPath = $f2UoR.getValueAtPath;
parcelRequire("cfakl");
function $10e2a86e161b1f85$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $10e2a86e161b1f85$var$_objectSpread2["default"])((0, $10e2a86e161b1f85$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $10e2a86e161b1f85$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $6Rb0E();
    var _getRefetchMetadata = $10e2a86e161b1f85$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $10e2a86e161b1f85$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $10e2a86e161b1f85$var$useReducer($10e2a86e161b1f85$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $10e2a86e161b1f85$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $10e2a86e161b1f85$var$useContext($fqdPA);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $hJBLU(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $10e2a86e161b1f85$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $l3Wiy(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $1K7ys(false);
        var refetchedFragmentRef = $10e2a86e161b1f85$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $aLpXs(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $10e2a86e161b1f85$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $10e2a86e161b1f85$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $iCqaO();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $10e2a86e161b1f85$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $10e2a86e161b1f85$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $10e2a86e161b1f85$var$_objectSpread2["default"])((0, $10e2a86e161b1f85$var$_objectSpread2["default"])((0, $10e2a86e161b1f85$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $10e2a86e161b1f85$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $10e2a86e161b1f85$var$debugFunctions;
module.exports = $10e2a86e161b1f85$var$useRefetchableFragmentInternal;

});
parcelRegister("l3Wiy", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $f55719950ec95ce9$var$_interopRequireDefault = $5gh7j.default;

var $f55719950ec95ce9$var$_objectSpread2 = $f55719950ec95ce9$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $f55719950ec95ce9$var$_createForOfIteratorHelper2 = $f55719950ec95ce9$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $68R8N = parcelRequire("68R8N");
var $f55719950ec95ce9$var$getQueryResourceForEnvironment = $68R8N.getQueryResourceForEnvironment;

var $1K7ys = parcelRequire("1K7ys");

var $f2UoR = parcelRequire("f2UoR");
var $f55719950ec95ce9$var$fetchQueryInternal = $f2UoR.__internal.fetchQuery, $f55719950ec95ce9$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $f55719950ec95ce9$var$createOperationDescriptor = $f2UoR.createOperationDescriptor, $f55719950ec95ce9$var$getPendingOperationsForFragment = $f2UoR.getPendingOperationsForFragment, $f55719950ec95ce9$var$getSelector = $f2UoR.getSelector, $f55719950ec95ce9$var$getVariablesFromFragment = $f2UoR.getVariablesFromFragment, $f55719950ec95ce9$var$handlePotentialSnapshotErrors = $f2UoR.handlePotentialSnapshotErrors;
parcelRequire("cfakl");
function $f55719950ec95ce9$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $f55719950ec95ce9$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $f55719950ec95ce9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $f55719950ec95ce9$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $f55719950ec95ce9$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $f55719950ec95ce9$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $f55719950ec95ce9$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $f55719950ec95ce9$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $f55719950ec95ce9$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $f55719950ec95ce9$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $f55719950ec95ce9$var$_objectSpread2["default"])((0, $f55719950ec95ce9$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $f55719950ec95ce9$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $f55719950ec95ce9$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $f55719950ec95ce9$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $f55719950ec95ce9$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $f55719950ec95ce9$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $f55719950ec95ce9$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $1K7ys(false);
    else !!Array.isArray(fragmentRef) && $1K7ys(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $1K7ys(false);
    var state = $f55719950ec95ce9$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $f55719950ec95ce9$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $f55719950ec95ce9$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $f55719950ec95ce9$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($f55719950ec95ce9$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($f55719950ec95ce9$var$isMissingData(state)) {
        !(fragmentSelector != null) && $1K7ys(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $f55719950ec95ce9$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $f55719950ec95ce9$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($f55719950ec95ce9$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $f55719950ec95ce9$var$readFragmentInternal;

});

parcelRegister("hJBLU", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $ce93f051244941ed$var$_interopRequireDefault = $5gh7j.default;

var $ce93f051244941ed$var$_createForOfIteratorHelper2 = $ce93f051244941ed$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $jseT6 = parcelRequire("jseT6");
var $ce93f051244941ed$var$loadQuery = $jseT6.loadQuery;

var $iCqaO = parcelRequire("iCqaO");

var $jg42Y = parcelRequire("jg42Y");

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");
var $ce93f051244941ed$var$useCallback = $4fqPo.useCallback, $ce93f051244941ed$var$useEffect = $4fqPo.useEffect, $ce93f051244941ed$var$useRef = $4fqPo.useRef, $ce93f051244941ed$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $ce93f051244941ed$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $ce93f051244941ed$var$getRequest = $f2UoR.getRequest;
var $ce93f051244941ed$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $ce93f051244941ed$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $ce93f051244941ed$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $ce93f051244941ed$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($ce93f051244941ed$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $jg42Y(preloadableRequest, initialQueryReference);
    return $ce93f051244941ed$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $ce93f051244941ed$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $ce93f051244941ed$var$initialNullQueryReferenceState;
    var environment = $6Rb0E();
    var isMountedRef = $iCqaO();
    var undisposedQueryReferencesRef = $ce93f051244941ed$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $ce93f051244941ed$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $ce93f051244941ed$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $ce93f051244941ed$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($ce93f051244941ed$var$initialNullQueryReferenceState);
            setQueryReference($ce93f051244941ed$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $ce93f051244941ed$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $ce93f051244941ed$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $ce93f051244941ed$var$useRef(false);
    $ce93f051244941ed$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $ce93f051244941ed$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $ce93f051244941ed$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($ce93f051244941ed$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $ce93f051244941ed$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $ce93f051244941ed$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($ce93f051244941ed$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $ce93f051244941ed$var$useQueryLoader;

});
parcelRegister("jg42Y", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $e052a691937d762b$var$_interopRequireDefault = $5gh7j.default;

var $e052a691937d762b$var$_createForOfIteratorHelper2 = $e052a691937d762b$var$_interopRequireDefault((parcelRequire("7Sq6l")));

var $jseT6 = parcelRequire("jseT6");
var $e052a691937d762b$var$loadQuery = $jseT6.loadQuery;

var $iCqaO = parcelRequire("iCqaO");

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");
var $e052a691937d762b$var$useCallback = $4fqPo.useCallback, $e052a691937d762b$var$useEffect = $4fqPo.useEffect, $e052a691937d762b$var$useInsertionEffect = $4fqPo.useInsertionEffect, $e052a691937d762b$var$useRef = $4fqPo.useRef, $e052a691937d762b$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $e052a691937d762b$var$getRequest = $f2UoR.getRequest;
var $e052a691937d762b$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $e052a691937d762b$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $e052a691937d762b$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $e052a691937d762b$var$CLEANUP_TIMEOUT = 300000;
function $e052a691937d762b$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $e052a691937d762b$var$initialNullQueryReferenceState;
    var environment = $6Rb0E();
    var isMountedRef = $iCqaO();
    var undisposedQueryReferencesRef = $e052a691937d762b$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $e052a691937d762b$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $e052a691937d762b$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $e052a691937d762b$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($e052a691937d762b$var$initialNullQueryReferenceState);
            setQueryReference($e052a691937d762b$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $e052a691937d762b$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $e052a691937d762b$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $e052a691937d762b$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $e052a691937d762b$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($e052a691937d762b$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $e052a691937d762b$var$useRef(null);
    $e052a691937d762b$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $e052a691937d762b$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $e052a691937d762b$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $e052a691937d762b$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("hE4S7", function(module, exports) {
'use strict';

var $5gh7j = parcelRequire("5gh7j");
var $cd89f3925bfa1c94$var$_interopRequireDefault = $5gh7j.default;

var $cd89f3925bfa1c94$var$_objectSpread2 = $cd89f3925bfa1c94$var$_interopRequireDefault((parcelRequire("kV9I3")));

var $dVTdt = parcelRequire("dVTdt");

var $cNPv2 = parcelRequire("cNPv2");

var $1rSAC = parcelRequire("1rSAC");

var $6Rb0E = parcelRequire("6Rb0E");

var $jyOlf = parcelRequire("jyOlf");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $cd89f3925bfa1c94$var$useCallback = $4fqPo.useCallback, $cd89f3925bfa1c94$var$useDebugValue = $4fqPo.useDebugValue, $cd89f3925bfa1c94$var$useEffect = $4fqPo.useEffect, $cd89f3925bfa1c94$var$useLayoutEffect = $4fqPo.useLayoutEffect, $cd89f3925bfa1c94$var$useMemo = $4fqPo.useMemo, $cd89f3925bfa1c94$var$useRef = $4fqPo.useRef, $cd89f3925bfa1c94$var$useState = $4fqPo.useState;

var $f2UoR = parcelRequire("f2UoR");
var $cd89f3925bfa1c94$var$getFragment = $f2UoR.getFragment, $cd89f3925bfa1c94$var$getFragmentIdentifier = $f2UoR.getFragmentIdentifier, $cd89f3925bfa1c94$var$getPaginationMetadata = $f2UoR.getPaginationMetadata;

var $f2UoR = parcelRequire("f2UoR");
var $cd89f3925bfa1c94$var$ConnectionInterface = $f2UoR.ConnectionInterface, $cd89f3925bfa1c94$var$RelayFeatureFlags = $f2UoR.RelayFeatureFlags, $cd89f3925bfa1c94$var$getSelector = $f2UoR.getSelector, $cd89f3925bfa1c94$var$getValueAtPath = $f2UoR.getValueAtPath;
function $cd89f3925bfa1c94$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $cd89f3925bfa1c94$var$getFragment(fragmentInput);
    $jyOlf(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $cd89f3925bfa1c94$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $1rSAC(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $cd89f3925bfa1c94$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $cd89f3925bfa1c94$var$useMemo(function() {
        var connection = $cd89f3925bfa1c94$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $cd89f3925bfa1c94$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $cd89f3925bfa1c94$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $6Rb0E();
    var _useState2 = $cd89f3925bfa1c94$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $cd89f3925bfa1c94$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $cd89f3925bfa1c94$var$useRef(0);
    var setIsLoadingMore = $cd89f3925bfa1c94$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $cd89f3925bfa1c94$var$useRef(false);
    var observer = $cd89f3925bfa1c94$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $cd89f3925bfa1c94$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $cd89f3925bfa1c94$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $cNPv2({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $cd89f3925bfa1c94$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $cd89f3925bfa1c94$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $cd89f3925bfa1c94$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $1K7ys(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $1K7ys(false);
    $cd89f3925bfa1c94$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $cd89f3925bfa1c94$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $1K7ys(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $cd89f3925bfa1c94$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $dVTdt(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $cd89f3925bfa1c94$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $cd89f3925bfa1c94$var$_objectSpread2["default"])((0, $cd89f3925bfa1c94$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $cd89f3925bfa1c94$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("bpanV", function(module, exports) {
'use strict';

var $gGXhB = parcelRequire("gGXhB");

var $cxsn0 = parcelRequire("cxsn0");

var $6Rb0E = parcelRequire("6Rb0E");

var $1K7ys = parcelRequire("1K7ys");

var $4fqPo = parcelRequire("4fqPo");
var $84da15bf83c273dc$var$useDebugValue = $4fqPo.useDebugValue;

var $f2UoR = parcelRequire("f2UoR");
var $84da15bf83c273dc$var$_require2$__internal = $f2UoR.__internal, $84da15bf83c273dc$var$fetchQueryDeduped = $84da15bf83c273dc$var$_require2$__internal.fetchQueryDeduped, $84da15bf83c273dc$var$fetchQuery = $84da15bf83c273dc$var$_require2$__internal.fetchQuery;
parcelRequire("cfakl");
function $84da15bf83c273dc$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $6Rb0E();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $cxsn0(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $1K7ys(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $84da15bf83c273dc$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $84da15bf83c273dc$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $gGXhB(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $84da15bf83c273dc$var$usePreloadedQuery;

});

parcelRegister("bCTRv", function(module, exports) {
'use strict';

var $1rSAC = parcelRequire("1rSAC");

var $jyOlf = parcelRequire("jyOlf");

var $4fqPo = parcelRequire("4fqPo");
var $876e935a6adbf51e$var$useDebugValue = $4fqPo.useDebugValue;

var $f2UoR = parcelRequire("f2UoR");
var $876e935a6adbf51e$var$getFragment = $f2UoR.getFragment;
function $876e935a6adbf51e$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $876e935a6adbf51e$var$getFragment(fragmentInput);
    $jyOlf(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $1rSAC(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $876e935a6adbf51e$var$useRefetchableFragment;

});

parcelRegister("2h1rk", function(module, exports) {
'use strict';

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");
var $1a7e493992ff0c15$var$useEffect = $4fqPo.useEffect, $1a7e493992ff0c15$var$useRef = $4fqPo.useRef;
function $1a7e493992ff0c15$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $6Rb0E();
    var disposableRef = $1a7e493992ff0c15$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $1a7e493992ff0c15$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $1a7e493992ff0c15$var$useSubscribeToInvalidationState;

});

parcelRegister("yjcQd", function(module, exports) {
'use strict';

var $6Rb0E = parcelRequire("6Rb0E");

var $4fqPo = parcelRequire("4fqPo");
var $067213067641c753$var$useEffect = $4fqPo.useEffect;

var $f2UoR = parcelRequire("f2UoR");
var $067213067641c753$var$requestSubscription = $f2UoR.requestSubscription;
function $067213067641c753$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $067213067641c753$var$requestSubscription;
    var environment = $6Rb0E();
    $067213067641c753$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $067213067641c753$var$useSubscription;

});



parcelRegister("6jcXZ", function(module, exports) {
$parcel$export(module.exports, "updateUserModelAction", () => (parcelRequire("3R99L")).updateUserModelAction);
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => (parcelRequire("3R99L")).UPDATE_USER_MODEL);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => (parcelRequire("3R99L")).updateUserModelAnonymousAction);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => (parcelRequire("3R99L")).UPDATE_USER_TO_ANON);
$parcel$export(module.exports, "saveUserProfile", () => (parcelRequire("3R99L")).saveUserProfile);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => (parcelRequire("3R99L")).SAVE_USER_PROFILE);
$parcel$export(module.exports, "saveUserProfileFailure", () => (parcelRequire("3R99L")).saveUserProfileFailure);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => (parcelRequire("3R99L")).SAVE_USER_PROFILE_FAILURE);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => (parcelRequire("3R99L")).setUserProfileValidationErrors);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => (parcelRequire("3R99L")).SET_USER_PROFILE_VALIDATION_ERRORS);
$parcel$export(module.exports, "saveUserProfileSuccess", () => (parcelRequire("3R99L")).saveUserProfileSuccess);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => (parcelRequire("3R99L")).SAVE_USER_PROFILE_SUCCESS);
$parcel$export(module.exports, "showChangePasswordDialog", () => (parcelRequire("3R99L")).showChangePasswordDialog);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("3R99L")).SHOW_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "closeChangePasswordDialog", () => (parcelRequire("3R99L")).closeChangePasswordDialog);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => (parcelRequire("3R99L")).CLOSE_CHANGE_PASSWORD_DIALOG);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => (parcelRequire("3R99L")).validateAndSavePasswordChange);
$parcel$export(module.exports, "validatePassword", () => (parcelRequire("3R99L")).validatePassword);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => (parcelRequire("3R99L")).VALIDATE_PASSWORD);
$parcel$export(module.exports, "validatePasswordSuccess", () => (parcelRequire("3R99L")).validatePasswordSuccess);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => (parcelRequire("3R99L")).VALIDATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => (parcelRequire("3R99L")).VALIDATE_AND_SAVE_PASSWORD_CHANGE);
$parcel$export(module.exports, "changePassword", () => (parcelRequire("3R99L")).changePassword);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => (parcelRequire("3R99L")).CHANGE_PASSWORD);
$parcel$export(module.exports, "changePasswordFailure", () => (parcelRequire("3R99L")).changePasswordFailure);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => (parcelRequire("3R99L")).CHANGE_PASSWORD_FAILURE);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => (parcelRequire("3R99L")).CHANGE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "successfullyLoggedIn", () => (parcelRequire("3R99L")).successfullyLoggedIn);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => (parcelRequire("3R99L")).SUCCESSFULLY_LOGGED_IN);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => (parcelRequire("3R99L")).UPDATE_USER_REQUESTS_COUNTS_MODEL);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("3R99L")).forgotPassword);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("3R99L")).forgotPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordFailure", () => (parcelRequire("3R99L")).forgotPasswordFailure);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => (parcelRequire("3R99L")).USER_PROFILE_FORGOT_PASSWORD);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("3R99L")).USER_PROFILE_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("3R99L")).USER_PROFILE_FORGOT_PASSWORD_FAILURE);

var $3R99L = parcelRequire("3R99L");

});
parcelRegister("3R99L", function(module, exports) {
$parcel$export(module.exports, "UPDATE_USER_MODEL", () => $6ea99941b572885d$export$bb738d1d47f9c080);
$parcel$export(module.exports, "UPDATE_USER_REQUESTS_COUNTS_MODEL", () => $6ea99941b572885d$export$e2e5f617828e4213);
$parcel$export(module.exports, "UPDATE_USER_TO_ANON", () => $6ea99941b572885d$export$b1b3790fd3dd41e);
$parcel$export(module.exports, "SAVE_USER_PROFILE", () => $6ea99941b572885d$export$ed8e9a22a73d5238);
$parcel$export(module.exports, "SAVE_USER_PROFILE_SUCCESS", () => $6ea99941b572885d$export$c705a7e05c58a85d);
$parcel$export(module.exports, "SAVE_USER_PROFILE_FAILURE", () => $6ea99941b572885d$export$617cd283d6722784);
$parcel$export(module.exports, "SET_USER_PROFILE_VALIDATION_ERRORS", () => $6ea99941b572885d$export$9e99a97090f99b20);
$parcel$export(module.exports, "SUCCESSFULLY_LOGGED_IN", () => $6ea99941b572885d$export$dbaf6c31aeaab4c0);
$parcel$export(module.exports, "SHOW_CHANGE_PASSWORD_DIALOG", () => $6ea99941b572885d$export$15f268d233a1a9e8);
$parcel$export(module.exports, "CLOSE_CHANGE_PASSWORD_DIALOG", () => $6ea99941b572885d$export$5ea2388969a07735);
$parcel$export(module.exports, "VALIDATE_AND_SAVE_PASSWORD_CHANGE", () => $6ea99941b572885d$export$d4203d6239c0a45f);
$parcel$export(module.exports, "VALIDATE_PASSWORD", () => $6ea99941b572885d$export$2776cc46c0e74482);
$parcel$export(module.exports, "VALIDATE_PASSWORD_SUCCESS", () => $6ea99941b572885d$export$87c02ba615b030f7);
$parcel$export(module.exports, "CHANGE_PASSWORD", () => $6ea99941b572885d$export$67e8c4b0fd356271);
$parcel$export(module.exports, "CHANGE_PASSWORD_SUCCESS", () => $6ea99941b572885d$export$52dd5c72d66642a1);
$parcel$export(module.exports, "CHANGE_PASSWORD_FAILURE", () => $6ea99941b572885d$export$8095eb34b5a9bf48);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD", () => $6ea99941b572885d$export$b03aac23a3b960e0);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_SUCCESS", () => $6ea99941b572885d$export$fd1274b492be3442);
$parcel$export(module.exports, "USER_PROFILE_FORGOT_PASSWORD_FAILURE", () => $6ea99941b572885d$export$228c8378e3cf38db);
$parcel$export(module.exports, "updateUserModelAction", () => $6ea99941b572885d$export$e64d70be6597f269);
$parcel$export(module.exports, "updateUserRequestsCountsAction", () => $6ea99941b572885d$export$8de1e14d714c3764);
$parcel$export(module.exports, "updateUserModelAnonymousAction", () => $6ea99941b572885d$export$c79034a87b96133d);
$parcel$export(module.exports, "saveUserProfile", () => $6ea99941b572885d$export$12b30392f405d671);
$parcel$export(module.exports, "saveUserProfileSuccess", () => $6ea99941b572885d$export$7ded1c1b185ee372);
$parcel$export(module.exports, "saveUserProfileFailure", () => $6ea99941b572885d$export$bb55fe7965c57a31);
$parcel$export(module.exports, "setUserProfileValidationErrors", () => $6ea99941b572885d$export$f5417889851341ee);
$parcel$export(module.exports, "showChangePasswordDialog", () => $6ea99941b572885d$export$b473bd12e6a9a566);
$parcel$export(module.exports, "closeChangePasswordDialog", () => $6ea99941b572885d$export$1a2f283b7350e33f);
$parcel$export(module.exports, "validatePassword", () => $6ea99941b572885d$export$4d2a7159fda5dc93);
$parcel$export(module.exports, "validateAndSavePasswordChange", () => $6ea99941b572885d$export$3d37c4744747732c);
$parcel$export(module.exports, "changePassword", () => $6ea99941b572885d$export$99d837dc30eb1ef7);
$parcel$export(module.exports, "validatePasswordSuccess", () => $6ea99941b572885d$export$6c2ac98735d96a42);
$parcel$export(module.exports, "changePasswordFailure", () => $6ea99941b572885d$export$a60289eb7ee45981);
$parcel$export(module.exports, "successfullyLoggedIn", () => $6ea99941b572885d$export$ffc865c9cfe87560);
$parcel$export(module.exports, "forgotPassword", () => $6ea99941b572885d$export$66791fb2cfeec3e);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $6ea99941b572885d$export$e65d2e9031cf7578);
$parcel$export(module.exports, "forgotPasswordFailure", () => $6ea99941b572885d$export$c82fc620622643dd);
const $6ea99941b572885d$export$bb738d1d47f9c080 = 'state.persisted.user.UPDATE_USER_MODEL';
const $6ea99941b572885d$export$e2e5f617828e4213 = 'state.persisted.user.UPDATE_USER_REQUESTS_COUNTS_MODEL';
const $6ea99941b572885d$export$b1b3790fd3dd41e = 'state.persisted.user.UPDATE_USER_TO_ANON';
const $6ea99941b572885d$export$ed8e9a22a73d5238 = 'state.persisted.user.SAVE_USER_PROFILE';
const $6ea99941b572885d$export$c705a7e05c58a85d = 'state.persisted.user.SAVE_USER_PROFILE_SUCCESS';
const $6ea99941b572885d$export$617cd283d6722784 = 'state.persisted.user.SAVE_USER_PROFILE_FAILURE';
const $6ea99941b572885d$export$9e99a97090f99b20 = 'state.persisted.user.SET_USER_PROFILE_VALIDATION_ERRORS';
const $6ea99941b572885d$export$dbaf6c31aeaab4c0 = 'state.persisted.user.SUCCESSFULLY_LOGGED_IN';
const $6ea99941b572885d$export$15f268d233a1a9e8 = 'state.ui.user.profile.SHOW_CHANGE_PASSWORD_DIALOG';
const $6ea99941b572885d$export$5ea2388969a07735 = 'state.ui.user.profile.CLOSE_CHANGE_PASSWORD_DIALOG';
const $6ea99941b572885d$export$d4203d6239c0a45f = 'state.persisted.user.VALIDATE_AND_SAVE_PASSWORD_CHANGE';
const $6ea99941b572885d$export$2776cc46c0e74482 = 'state.persisted.user.VALIDATE_PASSWORD';
const $6ea99941b572885d$export$87c02ba615b030f7 = 'state.persisted.user.VALIDATE_PASSWORD_SUCCESS';
const $6ea99941b572885d$export$67e8c4b0fd356271 = 'state.persisted.user.CHANGE_PASSWORD';
const $6ea99941b572885d$export$52dd5c72d66642a1 = 'state.persisted.user.CHANGE_PASSWORD_SUCCESS';
const $6ea99941b572885d$export$8095eb34b5a9bf48 = 'state.persisted.user.CHANGE_PASSWORD_FAILURE';
const $6ea99941b572885d$export$b03aac23a3b960e0 = 'state.ui.user.profile.FORGOT_PASSWORD';
const $6ea99941b572885d$export$fd1274b492be3442 = 'state.ui.user.profile.FORGOT_PASSWORD_SUCCESS';
const $6ea99941b572885d$export$228c8378e3cf38db = 'state.ui.user.profile.FORGOT_PASSWORD_FAILURE';
const $6ea99941b572885d$export$e64d70be6597f269 = (userResponse)=>({
        payload: userResponse,
        type: $6ea99941b572885d$export$bb738d1d47f9c080
    });
const $6ea99941b572885d$export$8de1e14d714c3764 = (userRequestsCountsResponse)=>({
        payload: userRequestsCountsResponse,
        type: $6ea99941b572885d$export$e2e5f617828e4213
    });
const $6ea99941b572885d$export$c79034a87b96133d = ()=>({
        type: $6ea99941b572885d$export$b1b3790fd3dd41e
    });
const $6ea99941b572885d$export$12b30392f405d671 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $6ea99941b572885d$export$ed8e9a22a73d5238
    });
const $6ea99941b572885d$export$7ded1c1b185ee372 = (displayName, language, timezone)=>({
        payload: {
            displayName: displayName,
            language: language,
            timezone: timezone
        },
        type: $6ea99941b572885d$export$c705a7e05c58a85d
    });
const $6ea99941b572885d$export$bb55fe7965c57a31 = ()=>({
        type: $6ea99941b572885d$export$617cd283d6722784
    });
const $6ea99941b572885d$export$f5417889851341ee = (nameError, timezoneError)=>({
        payload: {
            nameError: nameError,
            timezoneError: timezoneError
        },
        type: $6ea99941b572885d$export$9e99a97090f99b20
    });
const $6ea99941b572885d$export$b473bd12e6a9a566 = ()=>({
        type: $6ea99941b572885d$export$15f268d233a1a9e8
    });
const $6ea99941b572885d$export$1a2f283b7350e33f = ()=>({
        type: $6ea99941b572885d$export$5ea2388969a07735
    });
const $6ea99941b572885d$export$4d2a7159fda5dc93 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $6ea99941b572885d$export$2776cc46c0e74482
    });
const $6ea99941b572885d$export$3d37c4744747732c = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $6ea99941b572885d$export$d4203d6239c0a45f
    });
const $6ea99941b572885d$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmPassword)=>({
        payload: {
            currentPassword: currentPassword,
            newPassword: newPassword,
            confirmPassword: confirmPassword
        },
        type: $6ea99941b572885d$export$67e8c4b0fd356271
    });
const $6ea99941b572885d$export$6c2ac98735d96a42 = ()=>({
        type: $6ea99941b572885d$export$87c02ba615b030f7
    });
const $6ea99941b572885d$export$592a066e988f52df = ()=>({
        type: $6ea99941b572885d$export$52dd5c72d66642a1
    });
const $6ea99941b572885d$export$a60289eb7ee45981 = (currentPasswordError, newPasswordError, confirmPasswordError, generalError)=>({
        payload: {
            currentPasswordError: currentPasswordError,
            newPasswordError: newPasswordError,
            confirmPasswordError: confirmPasswordError,
            generalError: generalError
        },
        type: $6ea99941b572885d$export$8095eb34b5a9bf48
    });
const $6ea99941b572885d$export$ffc865c9cfe87560 = ()=>{
    return {
        type: $6ea99941b572885d$export$dbaf6c31aeaab4c0
    };
};
const $6ea99941b572885d$export$66791fb2cfeec3e = (resetUrl, email, createAnalyticsEvent)=>({
        type: $6ea99941b572885d$export$b03aac23a3b960e0,
        payload: {
            resetUrl: resetUrl,
            email: email,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $6ea99941b572885d$export$e65d2e9031cf7578 = ()=>({
        type: $6ea99941b572885d$export$fd1274b492be3442
    });
const $6ea99941b572885d$export$c82fc620622643dd = ()=>({
        type: $6ea99941b572885d$export$228c8378e3cf38db
    });

});


parcelRegister("e4b3P", function(module, exports) {
$parcel$export(module.exports, "default", () => $6afb023eca400fe1$export$2e2bcd8739ae039);
parcelRequire("2pQ8V");
var $2Wz6l = parcelRequire("2Wz6l");
var $8Qej1 = parcelRequire("8Qej1");
var $6WMcD = parcelRequire("6WMcD");
var $8Snhx = parcelRequire("8Snhx");
parcelRequire("lbln8");
var $7X0Po = parcelRequire("7X0Po");

var $9uWXW = parcelRequire("9uWXW");

var $gKlTs = parcelRequire("gKlTs");

var $7nkv6 = parcelRequire("7nkv6");

var $447tR = parcelRequire("447tR");
const $6afb023eca400fe1$var$createReducer = (asyncPersistedReducers, asyncUIReducers)=>{
    const persisted = (0, $gKlTs.getCombinedPersistedReducer)(asyncPersistedReducers);
    const ui = (0, $447tR.getCombinedUIReducer)(asyncUIReducers);
    return (0, $8Qej1.default)({
        persisted: persisted,
        ui: ui
    });
};
/**
 * Sometimes we want to run storybooks as standalone apps so we can embed them. In that case they
 * behave a little differently to when they are embedded inside the Storybook application frame.
 * This checks a query parameter to make sure we don't run into CORS issues.
 *
 * @returns True if we're in a storybook and it's being embedded outside the usual storybook frame.
 */ const $6afb023eca400fe1$var$isStandaloneStory = ()=>{
    const params = new URLSearchParams(window.location.search);
    return (params.get('singleStory') || params.get('singlestory')) === 'true';
};
function $6afb023eca400fe1$export$2e2bcd8739ae039({ initialState: initialState, middleware: middleware = [], initializeEpics: initializeEpics = true } = {}) {
    // Enables redux for storybook
    // trueWindow will hold the value of the window in which portal is loaded
    let trueWindow;
    // if portal is loaded inside an iframe, window.self will not be equal to window.top
    if ($6afb023eca400fe1$var$isStandaloneStory() || window.self !== window.top) trueWindow = window.self || window;
    else trueWindow = window.parent || window;
    const composeEnhancers = trueWindow.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $6WMcD.default);
    const epicMiddlewares = initializeEpics ? [
        (0, $7X0Po.createEpicMiddleware)((0, $9uWXW.default))
    ] : [];
    const store = (0, $8Snhx.default)((0, $7nkv6.default), initialState || {}, composeEnhancers((0, $2Wz6l.default)(...epicMiddlewares, ...middleware)));
    let asyncPersistedReducers = {};
    let asyncUIReducers = {};
    const injectReducer = (storeType, key, asyncReducer)=>{
        if (storeType === 'ui') asyncUIReducers = {
            ...asyncUIReducers,
            [key]: asyncReducer
        };
        if (storeType === 'persisted') asyncPersistedReducers = {
            ...asyncPersistedReducers,
            [key]: asyncReducer
        };
        store.replaceReducer($6afb023eca400fe1$var$createReducer(asyncPersistedReducers, asyncUIReducers));
    };
    return {
        store: store,
        injectReducer: injectReducer
    };
}

});
parcelRegister("lbln8", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => (parcelRequire("7X0Po")).createEpicMiddleware);
$parcel$export(module.exports, "combineEpics", () => (parcelRequire("4akjj")).combineEpics);

var $7X0Po = parcelRequire("7X0Po");

var $1MzGw = parcelRequire("1MzGw");

var $4akjj = parcelRequire("4akjj");

var $1S0sA = parcelRequire("1S0sA");

var $1sXwb = parcelRequire("1sXwb");

});
parcelRegister("7X0Po", function(module, exports) {
$parcel$export(module.exports, "createEpicMiddleware", () => $5c9eaf852faafc6d$export$147cf6f7ce5462cb);

var $hJCZY = parcelRequire("hJCZY");

var $2DnZi = parcelRequire("2DnZi");

var $6tFNK = parcelRequire("6tFNK");

var $1MzGw = parcelRequire("1MzGw");

var $1S0sA = parcelRequire("1S0sA");
var $5c9eaf852faafc6d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5c9eaf852faafc6d$var$defaultAdapter = {
    input: function input(action$) {
        return action$;
    },
    output: function output(action$) {
        return action$;
    }
};
var $5c9eaf852faafc6d$var$defaultOptions = {
    adapter: $5c9eaf852faafc6d$var$defaultAdapter
};
function $5c9eaf852faafc6d$export$147cf6f7ce5462cb(rootEpic) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $5c9eaf852faafc6d$var$defaultOptions;
    if (typeof rootEpic !== 'function') throw new TypeError('You must provide a root Epic to createEpicMiddleware');
    // even though we used default param, we need to merge the defaults
    // inside the options object as well in case they declare only some
    options = $5c9eaf852faafc6d$var$_extends({}, $5c9eaf852faafc6d$var$defaultOptions, options);
    var input$ = new (0, $hJCZY.Subject)();
    var action$ = options.adapter.input(new (0, $1MzGw.ActionsObservable)(input$));
    var epic$ = new (0, $hJCZY.Subject)();
    var store = void 0;
    var epicMiddleware = function epicMiddleware(_store) {
        store = _store;
        return function(next) {
            var _context;
            (_context = (0, $2DnZi.map).call(epic$, function(epic) {
                var vault = store;
                var output$ = 'dependencies' in options ? epic(action$, vault, options.dependencies) : epic(action$, vault);
                if (!output$) throw new TypeError('Your root Epic "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
                return output$;
            }), $6tFNK.switchMap).call(_context, function(output$) {
                return options.adapter.output(output$);
            }).subscribe(store.dispatch);
            // Setup initial root epic
            epic$.next(rootEpic);
            return function(action) {
                var result = next(action);
                input$.next(action);
                return result;
            };
        };
    };
    epicMiddleware.replaceEpic = function(rootEpic) {
        // gives the previous root Epic a last chance
        // to do some clean up
        store.dispatch({
            type: (0, $1S0sA.EPIC_END)
        });
        // switches to the new root Epic, synchronously terminating
        // the previous one
        epic$.next(rootEpic);
    };
    return epicMiddleware;
}

});
parcelRegister("2DnZi", function(module, exports) {
$parcel$export(module.exports, "map", () => $1eb1d4b7fde2aee8$export$871de8747c9eaa88, (v) => $1eb1d4b7fde2aee8$export$871de8747c9eaa88 = v);
var $1eb1d4b7fde2aee8$export$871de8747c9eaa88;
"use strict";

var $bWhgb = parcelRequire("bWhgb");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */ function $1eb1d4b7fde2aee8$var$map(project, thisArg) {
    return $bWhgb.map(project, thisArg)(this);
}
$1eb1d4b7fde2aee8$export$871de8747c9eaa88 = $1eb1d4b7fde2aee8$var$map;

});

parcelRegister("6tFNK", function(module, exports) {
$parcel$export(module.exports, "switchMap", () => $4b75e06513d228fd$export$9f6ea8e48bc26eab, (v) => $4b75e06513d228fd$export$9f6ea8e48bc26eab = v);
var $4b75e06513d228fd$export$9f6ea8e48bc26eab;
"use strict";

var $3hXUB = parcelRequire("3hXUB");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $4b75e06513d228fd$var$switchMap(project, resultSelector) {
    return $3hXUB.switchMap(project, resultSelector)(this);
}
$4b75e06513d228fd$export$9f6ea8e48bc26eab = $4b75e06513d228fd$var$switchMap;

});
parcelRegister("3hXUB", function(module, exports) {
"use strict";
var $26516ee5a904de8d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $26516ee5a904de8d$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $26516ee5a904de8d$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $26516ee5a904de8d$var$switchMap;
var $26516ee5a904de8d$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $26516ee5a904de8d$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $26516ee5a904de8d$var$SwitchMapSubscriber = function(_super) {
    $26516ee5a904de8d$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $d3klE.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($5XpGv.OuterSubscriber);

});


parcelRegister("1MzGw", function(module, exports) {
$parcel$export(module.exports, "ActionsObservable", () => $14c5f46c5fbf94e7$export$fa75b7f5c32db4e9);

var $b0T1M = parcelRequire("b0T1M");

var $6lMR1 = parcelRequire("6lMR1");

var $5wVlw = parcelRequire("5wVlw");

var $1sXwb = parcelRequire("1sXwb");
var $14c5f46c5fbf94e7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $14c5f46c5fbf94e7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $14c5f46c5fbf94e7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $14c5f46c5fbf94e7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $14c5f46c5fbf94e7$export$fa75b7f5c32db4e9 = function(_Observable) {
    $14c5f46c5fbf94e7$var$_inherits(ActionsObservable, _Observable);
    $14c5f46c5fbf94e7$var$_createClass(ActionsObservable, null, [
        {
            key: 'of',
            value: function of() {
                return new this((0, $6lMR1.of).apply(undefined, arguments));
            }
        },
        {
            key: 'from',
            value: function from(actions, scheduler) {
                return new this((0, $5wVlw.from)(actions, scheduler));
            }
        }
    ]);
    function ActionsObservable(actionsSubject) {
        $14c5f46c5fbf94e7$var$_classCallCheck(this, ActionsObservable);
        var _this = $14c5f46c5fbf94e7$var$_possibleConstructorReturn(this, (ActionsObservable.__proto__ || Object.getPrototypeOf(ActionsObservable)).call(this));
        _this.source = actionsSubject;
        return _this;
    }
    $14c5f46c5fbf94e7$var$_createClass(ActionsObservable, [
        {
            key: 'lift',
            value: function lift(operator) {
                var observable = new ActionsObservable(this);
                observable.operator = operator;
                return observable;
            }
        },
        {
            key: 'ofType',
            value: function ofType() {
                return (0, $1sXwb.ofType).apply(undefined, arguments)(this);
            }
        }
    ]);
    return ActionsObservable;
}((0, $b0T1M.Observable));

});
parcelRegister("6lMR1", function(module, exports) {
$parcel$export(module.exports, "of", () => $49fa99a513490df6$export$ba255e9e49e00608, (v) => $49fa99a513490df6$export$ba255e9e49e00608 = v);
var $49fa99a513490df6$export$ba255e9e49e00608;
"use strict";

var $fS4Qr = parcelRequire("fS4Qr");
$49fa99a513490df6$export$ba255e9e49e00608 = $fS4Qr.ArrayObservable.of;

});

parcelRegister("1sXwb", function(module, exports) {
$parcel$export(module.exports, "ofType", () => $1116930a34706c40$export$5db8774c0df95fce);

var $883aF = parcelRequire("883aF");
var $1116930a34706c40$var$keyHasType = function keyHasType(type, key) {
    return type === key || typeof key === 'function' && type === key.toString();
};
function $1116930a34706c40$export$5db8774c0df95fce() {
    for(var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
    return function ofTypeOperatorFunction(source) {
        return (0, $883aF.filter).call(source, function(_ref) {
            var type = _ref.type;
            var len = keys.length;
            if (len === 1) return $1116930a34706c40$var$keyHasType(type, keys[0]);
            else for(var i = 0; i < len; i++){
                if ($1116930a34706c40$var$keyHasType(type, keys[i])) return true;
            }
            return false;
        });
    };
}

});
parcelRegister("883aF", function(module, exports) {
$parcel$export(module.exports, "filter", () => $5eb187c4ad339383$export$3dea766d36a8935f, (v) => $5eb187c4ad339383$export$3dea766d36a8935f = v);
var $5eb187c4ad339383$export$3dea766d36a8935f;
"use strict";

var $7lL5Z = parcelRequire("7lL5Z");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $5eb187c4ad339383$var$filter(predicate, thisArg) {
    return $7lL5Z.filter(predicate, thisArg)(this);
}
$5eb187c4ad339383$export$3dea766d36a8935f = $5eb187c4ad339383$var$filter;

});
parcelRegister("7lL5Z", function(module, exports) {
"use strict";
var $559f06c1ee94c5c5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $559f06c1ee94c5c5$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $559f06c1ee94c5c5$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $559f06c1ee94c5c5$var$filter;
var $559f06c1ee94c5c5$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $559f06c1ee94c5c5$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $559f06c1ee94c5c5$var$FilterSubscriber = function(_super) {
    $559f06c1ee94c5c5$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($kVbBc.Subscriber);

});




parcelRegister("1S0sA", function(module, exports) {
$parcel$export(module.exports, "EPIC_END", () => $15cb30f3b94520f5$export$b74d5afcca2d016c);
var $15cb30f3b94520f5$export$b74d5afcca2d016c = '@@redux-observable/EPIC_END';

});


parcelRegister("4akjj", function(module, exports) {
$parcel$export(module.exports, "combineEpics", () => $3087d9d59e1cf572$export$6259fe981e4a41dc);

var $eqsjw = parcelRequire("eqsjw");
function $3087d9d59e1cf572$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $3087d9d59e1cf572$export$6259fe981e4a41dc = function combineEpics() {
    for(var _len = arguments.length, epics = Array(_len), _key = 0; _key < _len; _key++)epics[_key] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return (0, $eqsjw.merge).apply(undefined, $3087d9d59e1cf572$var$_toConsumableArray(epics.map(function(epic) {
            var output$ = epic.apply(undefined, args);
            if (!output$) throw new TypeError('combineEpics: one of the provided Epics "' + (epic.name || '<anonymous>') + '" does not return a stream. Double check you\'re not missing a return statement!');
            return output$;
        })));
    };
};

});
parcelRegister("eqsjw", function(module, exports) {
$parcel$export(module.exports, "merge", () => $a80974f37cca9361$export$4950aa0f605343fb, (v) => $a80974f37cca9361$export$4950aa0f605343fb = v);
var $a80974f37cca9361$export$4950aa0f605343fb;
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $fS4Qr = parcelRequire("fS4Qr");

var $6eaCl = parcelRequire("6eaCl");

var $jMu5f = parcelRequire("jMu5f");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $a80974f37cca9361$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($6eaCl.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $b0T1M.Observable) return observables[0];
    return $jMu5f.mergeAll(concurrent)(new $fS4Qr.ArrayObservable(observables, scheduler));
}
$a80974f37cca9361$export$4950aa0f605343fb = $a80974f37cca9361$var$merge;

});
parcelRegister("jMu5f", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $e669d603b49c2d81$export$18aef43295bbe906, (v) => $e669d603b49c2d81$export$18aef43295bbe906 = v);
var $e669d603b49c2d81$export$18aef43295bbe906;
"use strict";

var $fcKxV = parcelRequire("fcKxV");

var $3a2S6 = parcelRequire("3a2S6");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $e669d603b49c2d81$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $fcKxV.mergeMap($3a2S6.identity, null, concurrent);
}
$e669d603b49c2d81$export$18aef43295bbe906 = $e669d603b49c2d81$var$mergeAll;

});
parcelRegister("3a2S6", function(module, exports) {
$parcel$export(module.exports, "identity", () => $24d4888507ae70d3$export$f0954fd7d5368655, (v) => $24d4888507ae70d3$export$f0954fd7d5368655 = v);
var $24d4888507ae70d3$export$f0954fd7d5368655;
"use strict";
function $24d4888507ae70d3$var$identity(x) {
    return x;
}
$24d4888507ae70d3$export$f0954fd7d5368655 = $24d4888507ae70d3$var$identity;

});





parcelRegister("9uWXW", function(module, exports) {
$parcel$export(module.exports, "epic$", () => $36c2cd514bd0e60a$export$5eda8fe942b06fa7);
$parcel$export(module.exports, "default", () => $36c2cd514bd0e60a$export$2e2bcd8739ae039);
parcelRequire("lbln8");
var $4akjj = parcelRequire("4akjj");

var $5geAe = parcelRequire("5geAe");

var $8ie7e = parcelRequire("8ie7e");

var $1QY14 = parcelRequire("1QY14");

var $4LAfg = parcelRequire("4LAfg");

var $lhKfW = parcelRequire("lhKfW");

var $WHQZk = parcelRequire("WHQZk");

var $jCsvq = parcelRequire("jCsvq");

var $55BYE = parcelRequire("55BYE");

var $5WXUY = parcelRequire("5WXUY");

var $8ZdLN = parcelRequire("8ZdLN");

var $5Wk6A = parcelRequire("5Wk6A");
var $5r3Gl = parcelRequire("5r3Gl");
var $6SvHM = parcelRequire("6SvHM");
var $1sxKu = parcelRequire("1sxKu");
var $b1oBD = parcelRequire("b1oBD");

var $1Werj = parcelRequire("1Werj");

var $cTFGY = parcelRequire("cTFGY");

var $exHYR = parcelRequire("exHYR");

var $hGVNB = parcelRequire("hGVNB");

var $hcLYa = parcelRequire("hcLYa");

var $3CgCH = parcelRequire("3CgCH");
var $o83ZW = parcelRequire("o83ZW");
var $h1iWI = parcelRequire("h1iWI");
var $7jHGd = parcelRequire("7jHGd");
var $fwR6p = parcelRequire("fwR6p");
var $3QzMH = parcelRequire("3QzMH");
var $1Sond = parcelRequire("1Sond");
var $becIW = parcelRequire("becIW");

var $iSMxf = parcelRequire("iSMxf");

var $iEcK7 = parcelRequire("iEcK7");
var $5WdyL = parcelRequire("5WdyL");
var $ccvqN = parcelRequire("ccvqN");
var $7WxpH = parcelRequire("7WxpH");
var $jyQWh = parcelRequire("jyQWh");

var $cmatD = parcelRequire("cmatD");

var $5j5Nc = parcelRequire("5j5Nc");

var $7hzi7 = parcelRequire("7hzi7");

var $O6qmY = parcelRequire("O6qmY");

var $6tCVT = parcelRequire("6tCVT");

var $3ceqH = parcelRequire("3ceqH");
const $36c2cd514bd0e60a$export$678ceb4a4ee87d76 = [
    (0, $hGVNB.default),
    (0, $7hzi7.default),
    (0, $exHYR.logOutEpic),
    (0, $lhKfW.default),
    (0, $iSMxf.requestGroupsEpic),
    (0, $5WdyL.createGroupWithRequestTypeEpic),
    (0, $iEcK7.addRequestTypeToRequestGroupEpic),
    (0, $ccvqN.deleteRequestTypeFromGroupEpic),
    (0, $jyQWh.setRequestTypeGroupsEpic),
    (0, $7WxpH.reorderRequestTypeEpic),
    (0, $3CgCH.changeRequestSubscriptionEpic),
    (0, $o83ZW.createCommentEpic),
    (0, $h1iWI.decideApprovalEpic),
    (0, $fwR6p.removeOrganisationEpic),
    (0, $3QzMH.removeParticipantEpic),
    (0, $1Sond.shareRequestEpic),
    (0, $becIW.transitionRequestEpic),
    (0, $7jHGd.getMediaReadCredentialsEpic),
    (0, $jCsvq.handleAjaxErrorEpic),
    (0, $O6qmY.resendValidationEmailEpic),
    (0, $6tCVT.validateAndSavePasswordChangeEpic),
    (0, $6tCVT.validateEpic),
    (0, $6tCVT.changePasswordEpic),
    (0, $6tCVT.updateUserProfileEpic),
    (0, $5Wk6A.checkLoginActionEpic),
    (0, $1sxKu.forgotPasswordEpic),
    (0, $5r3Gl.createPasswordEpic),
    (0, $b1oBD.loginEpic),
    (0, $5WXUY.invitedSignUpEpic),
    (0, $1QY14.completeSignupEpic),
    (0, $1QY14.sendNewSignupLinkEpic),
    (0, $55BYE.updateHelpCenterBrandingEpic),
    (0, $55BYE.updateHelpCenterBrandingEpicMutationSuccess),
    (0, $55BYE.updateHelpCenterBrandingEpicMutationFailure),
    (0, $5j5Nc.resetPasswordEpic),
    (0, $1Werj.updateLoginAnnouncementsEpic),
    (0, $hcLYa.updatePortalAnnouncementsEpic),
    (0, $3ceqH.forgotPasswordEpic),
    (0, $6SvHM.exitTestModeEpic),
    (0, $cmatD.resendVerifyEmailEpic),
    (0, $cTFGY.loginConsentEpic),
    (0, $4LAfg.fetchCrossSiteArticleEpic),
    (0, $WHQZk.fetchSpaceKeyEpic),
    (0, $8ZdLN.fetchLinkedSpacesEpic)
];
const $36c2cd514bd0e60a$var$staticEpics = (0, $4akjj.combineEpics)(...$36c2cd514bd0e60a$export$678ceb4a4ee87d76);
const $36c2cd514bd0e60a$export$5eda8fe942b06fa7 = new (0, $5geAe.BehaviorSubject)($36c2cd514bd0e60a$var$staticEpics);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $36c2cd514bd0e60a$var$combinedEpic = (action$, store$, deps)=>$36c2cd514bd0e60a$export$5eda8fe942b06fa7.pipe((0, $8ie7e.mergeMap)((epic)=>epic(action$, store$, deps)));
var $36c2cd514bd0e60a$export$2e2bcd8739ae039 = $36c2cd514bd0e60a$var$combinedEpic;

});
parcelRegister("5geAe", function(module, exports) {
$parcel$export(module.exports, "Observable", () => $3d49c2553092e2a2$export$77cea355fa80b5f4, (v) => $3d49c2553092e2a2$export$77cea355fa80b5f4 = v);
$parcel$export(module.exports, "Subscription", () => $3d49c2553092e2a2$export$f55210826850c514, (v) => $3d49c2553092e2a2$export$f55210826850c514 = v);
$parcel$export(module.exports, "BehaviorSubject", () => $3d49c2553092e2a2$export$cc3d42e6b2b9cf8b, (v) => $3d49c2553092e2a2$export$cc3d42e6b2b9cf8b = v);
$parcel$export(module.exports, "AjaxError", () => $3d49c2553092e2a2$export$9b8f4d0b97ba3d22, (v) => $3d49c2553092e2a2$export$9b8f4d0b97ba3d22 = v);
$parcel$export(module.exports, "Scheduler", () => $3d49c2553092e2a2$export$d3e54bb8584cda7c, (v) => $3d49c2553092e2a2$export$d3e54bb8584cda7c = v);
var $3d49c2553092e2a2$export$b6bbab5a9b109038;
var $3d49c2553092e2a2$export$155189cde295587d;
var $3d49c2553092e2a2$export$77cea355fa80b5f4;
var $3d49c2553092e2a2$export$f55210826850c514;
var $3d49c2553092e2a2$export$60959659b2c22881;
var $3d49c2553092e2a2$export$fe960da701faae26;
var $3d49c2553092e2a2$export$915d2682b0aa0991;
var $3d49c2553092e2a2$export$cc3d42e6b2b9cf8b;
var $3d49c2553092e2a2$export$9038dea0172d3ba9;
var $3d49c2553092e2a2$export$14834abbfce3b8cd;
var $3d49c2553092e2a2$export$78f6d1b1dbcda304;
var $3d49c2553092e2a2$export$630691c4a0cd4093;
var $3d49c2553092e2a2$export$f708eee25634bc80;
var $3d49c2553092e2a2$export$66d311bf29d5c89c;
var $3d49c2553092e2a2$export$c9648b76fd580c34;
var $3d49c2553092e2a2$export$8bb95198b45adaac;
var $3d49c2553092e2a2$export$d9bcbd5e1ff81430;
var $3d49c2553092e2a2$export$62927158df9c43dd;
var $3d49c2553092e2a2$export$789cef2613b1402;
var $3d49c2553092e2a2$export$ae07db09d6fbd01b;
var $3d49c2553092e2a2$export$9b8f4d0b97ba3d22;
var $3d49c2553092e2a2$export$fcf72a1ab36e1e65;
var $3d49c2553092e2a2$export$a4627e546088548d;
var $3d49c2553092e2a2$export$ccbce4efa7f8029b;
var $3d49c2553092e2a2$export$d3e54bb8584cda7c;
var $3d49c2553092e2a2$export$3e25e887b7a5b37b;
"use strict";

var $hJCZY = parcelRequire("hJCZY");
$3d49c2553092e2a2$export$b6bbab5a9b109038 = $hJCZY.Subject;
$3d49c2553092e2a2$export$155189cde295587d = $hJCZY.AnonymousSubject;

var $b0T1M = parcelRequire("b0T1M");
$3d49c2553092e2a2$export$77cea355fa80b5f4 = $b0T1M.Observable;
parcelRequire("eLJ64");
parcelRequire("eQUQy");
parcelRequire("6xWJo");
parcelRequire("5YUL8");
parcelRequire("4lfCD");
parcelRequire("2dG9T");
parcelRequire("lFsWJ");
parcelRequire("95xQu");
parcelRequire("lTsWc");
parcelRequire("9MAdb");
parcelRequire("aQQ20");
parcelRequire("kzrO8");
parcelRequire("lTmzS");
parcelRequire("8GJ9R");
parcelRequire("kWN7f");
parcelRequire("8BhjG");
parcelRequire("cqvVe");
parcelRequire("ahsa1");
parcelRequire("iTXAu");
parcelRequire("dZ6X4");
parcelRequire("iQlC3");
parcelRequire("inJsy");
parcelRequire("4gt3S");
parcelRequire("e1Yf3");
parcelRequire("2V4ph");
parcelRequire("1a2eL");
parcelRequire("i4MRD");
parcelRequire("aBouX");
parcelRequire("dziYq");
parcelRequire("c2pWB");
parcelRequire("d9Umi");
parcelRequire("aex1Z");
parcelRequire("FJQG9");
parcelRequire("YWjMu");
parcelRequire("46mvO");
parcelRequire("9PzFk");
parcelRequire("fnpO0");
parcelRequire("7sblN");
parcelRequire("26QRx");
parcelRequire("j1Ua9");
parcelRequire("hcKjX");
parcelRequire("iXQTj");
parcelRequire("ci1Jm");
parcelRequire("5KXIn");
parcelRequire("bV9X7");
parcelRequire("kgThj");
parcelRequire("kKPzV");
parcelRequire("cGJbR");
parcelRequire("cFJOJ");
parcelRequire("ihAqs");
parcelRequire("4G3Bo");
parcelRequire("lnB8I");
parcelRequire("1OpKX");
parcelRequire("g3UBU");
parcelRequire("9INLY");
parcelRequire("kcOq1");
parcelRequire("immO9");
parcelRequire("ir8ja");
parcelRequire("1wQyG");
parcelRequire("is1Qo");
parcelRequire("VyJ7k");
parcelRequire("kHuyu");
parcelRequire("5PWw5");
parcelRequire("3Wba3");
parcelRequire("a3PPT");
parcelRequire("lgRId");
parcelRequire("kDnP4");
parcelRequire("bhZtn");
parcelRequire("1WHbF");
parcelRequire("5TcvX");
parcelRequire("aWBq9");
parcelRequire("hIxFK");
parcelRequire("35tg2");
parcelRequire("n0pyq");
parcelRequire("4wxX0");
parcelRequire("2BpAw");
parcelRequire("8kSPc");
parcelRequire("bV9rb");
parcelRequire("6ezBu");
parcelRequire("btNQN");
parcelRequire("kp4C5");
parcelRequire("dHrhW");
parcelRequire("aEoSl");
parcelRequire("jAhjW");
parcelRequire("7NB0r");
parcelRequire("bNgWJ");
parcelRequire("8ZPZy");
parcelRequire("hywim");
parcelRequire("bWP2x");
parcelRequire("3Alyg");
parcelRequire("a4KR5");
parcelRequire("eZBS3");
parcelRequire("aTJhu");
parcelRequire("kPxCC");
parcelRequire("6fPoo");
parcelRequire("eNoD1");
parcelRequire("6lOOS");
parcelRequire("2WBJx");
parcelRequire("14Cty");
parcelRequire("egqDo");
parcelRequire("4VrXW");
parcelRequire("ja8MS");
parcelRequire("cXyXt");
parcelRequire("fHgTN");
parcelRequire("ixqMu");
parcelRequire("ibIeh");
parcelRequire("6YHdg");
parcelRequire("km5LH");
parcelRequire("9O0Lj");
parcelRequire("kOGz4");
parcelRequire("let7e");
parcelRequire("atcms");
parcelRequire("8px1l");
parcelRequire("bI8PG");
parcelRequire("2RbJd");
parcelRequire("lxuro");
parcelRequire("lT4IG");
parcelRequire("en3oJ");
parcelRequire("2llMb");
parcelRequire("hJ1NB");
parcelRequire("kD0kt");
parcelRequire("iRegk");
parcelRequire("ltcHV");
parcelRequire("jsKX9");
parcelRequire("jwAgx");
parcelRequire("8yzRo");
parcelRequire("4YPMk");
parcelRequire("caoeC");
parcelRequire("lanqG");

var $cGvOX = parcelRequire("cGvOX");
$3d49c2553092e2a2$export$f55210826850c514 = $cGvOX.Subscription;

var $kVbBc = parcelRequire("kVbBc");
$3d49c2553092e2a2$export$60959659b2c22881 = $kVbBc.Subscriber;

var $l5vGt = parcelRequire("l5vGt");
$3d49c2553092e2a2$export$fe960da701faae26 = $l5vGt.AsyncSubject;

var $gNLuz = parcelRequire("gNLuz");
$3d49c2553092e2a2$export$915d2682b0aa0991 = $gNLuz.ReplaySubject;

var $5bb7M = parcelRequire("5bb7M");
$3d49c2553092e2a2$export$cc3d42e6b2b9cf8b = $5bb7M.BehaviorSubject;

var $3hL74 = parcelRequire("3hL74");
$3d49c2553092e2a2$export$9038dea0172d3ba9 = $3hL74.ConnectableObservable;

var $lnB2i = parcelRequire("lnB2i");
$3d49c2553092e2a2$export$14834abbfce3b8cd = $lnB2i.Notification;

var $7Aiqv = parcelRequire("7Aiqv");
$3d49c2553092e2a2$export$78f6d1b1dbcda304 = $7Aiqv.EmptyError;

var $9pTpk = parcelRequire("9pTpk");
$3d49c2553092e2a2$export$630691c4a0cd4093 = $9pTpk.ArgumentOutOfRangeError;

var $1QtXt = parcelRequire("1QtXt");
$3d49c2553092e2a2$export$f708eee25634bc80 = $1QtXt.ObjectUnsubscribedError;

var $l8UrM = parcelRequire("l8UrM");
$3d49c2553092e2a2$export$66d311bf29d5c89c = $l8UrM.TimeoutError;

var $2LnVI = parcelRequire("2LnVI");
$3d49c2553092e2a2$export$c9648b76fd580c34 = $2LnVI.UnsubscriptionError;

var $eqcG8 = parcelRequire("eqcG8");
$3d49c2553092e2a2$export$8bb95198b45adaac = $eqcG8.TimeInterval;

var $bzTtj = parcelRequire("bzTtj");
$3d49c2553092e2a2$export$d9bcbd5e1ff81430 = $bzTtj.Timestamp;

var $96Oe7 = parcelRequire("96Oe7");
$3d49c2553092e2a2$export$62927158df9c43dd = $96Oe7.TestScheduler;

var $EYojK = parcelRequire("EYojK");
$3d49c2553092e2a2$export$789cef2613b1402 = $EYojK.VirtualTimeScheduler;

var $2DcNu = parcelRequire("2DcNu");
$3d49c2553092e2a2$export$ae07db09d6fbd01b = $2DcNu.AjaxResponse;
$3d49c2553092e2a2$export$9b8f4d0b97ba3d22 = $2DcNu.AjaxError;
$3d49c2553092e2a2$export$fcf72a1ab36e1e65 = $2DcNu.AjaxTimeoutError;

var $aXt93 = parcelRequire("aXt93");
$3d49c2553092e2a2$export$a4627e546088548d = $aXt93.pipe;

var $w0jLy = parcelRequire("w0jLy");

var $hBoCS = parcelRequire("hBoCS");

var $5uXxO = parcelRequire("5uXxO");

var $aFkIb = parcelRequire("aFkIb");

var $2xP00 = parcelRequire("2xP00");

var $aT16R = parcelRequire("aT16R");

var $jkDT5 = parcelRequire("jkDT5");

var $8ie7e = parcelRequire("8ie7e");
$3d49c2553092e2a2$export$ccbce4efa7f8029b = $8ie7e;
/* tslint:enable:no-unused-variable */ /**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */ var $3d49c2553092e2a2$var$Scheduler = {
    asap: $w0jLy.asap,
    queue: $5uXxO.queue,
    animationFrame: $aFkIb.animationFrame,
    async: $hBoCS.async
};
$3d49c2553092e2a2$export$d3e54bb8584cda7c = $3d49c2553092e2a2$var$Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */ var $3d49c2553092e2a2$var$Symbol = {
    rxSubscriber: $2xP00.rxSubscriber,
    observable: $jkDT5.observable,
    iterator: $aT16R.iterator
};
$3d49c2553092e2a2$export$3e25e887b7a5b37b = $3d49c2553092e2a2$var$Symbol;

});
parcelRegister("eLJ64", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $6Ye6x = parcelRequire("6Ye6x");
$b0T1M.Observable.bindCallback = $6Ye6x.bindCallback;

});
parcelRegister("6Ye6x", function(module, exports) {
$parcel$export(module.exports, "bindCallback", () => $51334983ad993f2e$export$ba9059a8de3f18e, (v) => $51334983ad993f2e$export$ba9059a8de3f18e = v);
var $51334983ad993f2e$export$ba9059a8de3f18e;
"use strict";

var $d9exe = parcelRequire("d9exe");
$51334983ad993f2e$export$ba9059a8de3f18e = $d9exe.BoundCallbackObservable.create;

});
parcelRegister("d9exe", function(module, exports) {
"use strict";
var $992763f5e92e11e7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $l5vGt = parcelRequire("l5vGt");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $992763f5e92e11e7$var$BoundCallbackObservable = function(_super) {
    $992763f5e92e11e7$var$__extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments it will return an Observable. If function `func`
     * calls its callback with one argument the Observable will emit that value.
     * If on the other hand the callback is called with multiple values the resulting
     * Observable will emit an array with said values as arguments.
     *
     * It is very important to remember that input function `func` is not called
     * when the output function is, but rather when the Observable returned by the output
     * function is subscribed. This means if `func` makes an AJAX request, that request
     * will be made every time someone subscribes to the resulting Observable, but not before.
     *
     * Optionally, a selector function can be passed to `bindObservable`. The selector function
     * takes the same arguments as the callback and returns the value that will be emitted by the Observable.
     * Even though by default multiple arguments passed to callback appear in the stream as an array
     * the selector function will be called with arguments directly, just as the callback would.
     * This means you can imagine the default selector (when one is not provided explicitly)
     * as a function that aggregates all its arguments into an array, or simply returns first argument
     * if there is only one.
     *
     * The last optional parameter - {@link Scheduler} - can be used to control when the call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default, the subscription to  an Observable calls `func`
     * synchronously, but using `Scheduler.async` as the last parameter will defer the call to `func`,
     * just like wrapping the call in `setTimeout` with a timeout of `0` would. If you use the async Scheduler
     * and call `subscribe` on the output Observable all function calls that are currently executing
     * will end before `func` is invoked.
     *
     * By default results passed to the callback are emitted immediately after `func` invokes the callback.
     * In particular, if the callback is called synchronously the subscription of the resulting Observable
     * will call the `next` function synchronously as well.  If you want to defer that call,
     * you may use `Scheduler.async` just as before.  This means that by using `Scheduler.async` you can
     * ensure that `func` always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that the Observable created by the output function will always emit a single value
     * and then complete immediately. If `func` calls the callback multiple times, values from subsequent
     * calls will not appear in the stream. If you need to listen for multiple calls,
     *  you probably want to use {@link fromEvent} or {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property) and is not already bound the context of `func`
     * will be the context that the output function has at call time. In particular, if `func`
     * is called as a method of some objec and if `func` is not already bound, in order to preserve the context
     * it is recommended that the context of the output function is set to that object as well.
     *
     * If the input function calls its callback in the "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether the call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions the same as any other and error parameters
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive an array of arguments passed to a callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with a selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on an object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func A function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps them to a value that is emitted on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */ BoundCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $l5vGt.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = $3kkLM.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $geExo.errorObject) subject.error($geExo.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $3kkLM.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $geExo.errorObject) subject.error($geExo.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule(BoundCallbackObservable.dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    BoundCallbackObservable.dispatch = function(state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new $l5vGt.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = $3kkLM.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === $geExo.errorObject) self.add(scheduler.schedule($992763f5e92e11e7$var$dispatchError, 0, {
                        err: $geExo.errorObject.e,
                        subject: subject
                    }));
                    else self.add(scheduler.schedule($992763f5e92e11e7$var$dispatchNext, 0, {
                        value: result_2,
                        subject: subject
                    }));
                } else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule($992763f5e92e11e7$var$dispatchNext, 0, {
                        value: value,
                        subject: subject
                    }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = $3kkLM.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === $geExo.errorObject) subject.error($geExo.errorObject.e);
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}($b0T1M.Observable);
module.exports.BoundCallbackObservable = $992763f5e92e11e7$var$BoundCallbackObservable;
function $992763f5e92e11e7$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $992763f5e92e11e7$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});
parcelRegister("l5vGt", function(module, exports) {
"use strict";
var $f5a2a467e7551f78$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $cGvOX = parcelRequire("cGvOX");
/**
 * @class AsyncSubject<T>
 */ var $f5a2a467e7551f78$var$AsyncSubject = function(_super) {
    $f5a2a467e7551f78$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $cGvOX.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $cGvOX.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($hJCZY.Subject);
module.exports.AsyncSubject = $f5a2a467e7551f78$var$AsyncSubject;

});




parcelRegister("eQUQy", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $autA5 = parcelRequire("autA5");
$b0T1M.Observable.bindNodeCallback = $autA5.bindNodeCallback;

});
parcelRegister("autA5", function(module, exports) {
$parcel$export(module.exports, "bindNodeCallback", () => $7a33a6eb4dcdb01e$export$4893451713772b1a, (v) => $7a33a6eb4dcdb01e$export$4893451713772b1a = v);
var $7a33a6eb4dcdb01e$export$4893451713772b1a;
"use strict";

var $bSNdp = parcelRequire("bSNdp");
$7a33a6eb4dcdb01e$export$4893451713772b1a = $bSNdp.BoundNodeCallbackObservable.create;

});
parcelRegister("bSNdp", function(module, exports) {
"use strict";
var $8a6ae9ff90c83749$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $l5vGt = parcelRequire("l5vGt");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $8a6ae9ff90c83749$var$BoundNodeCallbackObservable = function(_super) {
    $8a6ae9ff90c83749$var$__extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */ /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */ BoundNodeCallbackObservable.create = function(func, selector, scheduler) {
        if (selector === void 0) selector = undefined;
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    /** @deprecated internal use only */ BoundNodeCallbackObservable.prototype._subscribe = function(subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new $l5vGt.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) subject.error(err);
                    else if (selector) {
                        var result_1 = $3kkLM.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === $geExo.errorObject) subject.error($geExo.errorObject.e);
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    } else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = $3kkLM.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === $geExo.errorObject) subject.error($geExo.errorObject.e);
            }
            return subject.subscribe(subscriber);
        } else return scheduler.schedule($8a6ae9ff90c83749$var$dispatch, 0, {
            source: this,
            subscriber: subscriber,
            context: this.context
        });
    };
    return BoundNodeCallbackObservable;
}($b0T1M.Observable);
module.exports.BoundNodeCallbackObservable = $8a6ae9ff90c83749$var$BoundNodeCallbackObservable;
function $8a6ae9ff90c83749$var$dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new $l5vGt.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)innerArgs[_i - 0] = arguments[_i];
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) self.add(scheduler.schedule($8a6ae9ff90c83749$var$dispatchError, 0, {
                err: err,
                subject: subject
            }));
            else if (selector) {
                var result_2 = $3kkLM.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === $geExo.errorObject) self.add(scheduler.schedule($8a6ae9ff90c83749$var$dispatchError, 0, {
                    err: $geExo.errorObject.e,
                    subject: subject
                }));
                else self.add(scheduler.schedule($8a6ae9ff90c83749$var$dispatchNext, 0, {
                    value: result_2,
                    subject: subject
                }));
            } else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule($8a6ae9ff90c83749$var$dispatchNext, 0, {
                    value: value,
                    subject: subject
                }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = $3kkLM.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === $geExo.errorObject) self.add(scheduler.schedule($8a6ae9ff90c83749$var$dispatchError, 0, {
            err: $geExo.errorObject.e,
            subject: subject
        }));
    }
    self.add(subject.subscribe(subscriber));
}
function $8a6ae9ff90c83749$var$dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function $8a6ae9ff90c83749$var$dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

});



parcelRegister("6xWJo", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $io0ah = parcelRequire("io0ah");
$b0T1M.Observable.combineLatest = $io0ah.combineLatest;

});
parcelRegister("io0ah", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $d62a989a301d5515$export$77fa7d86f5204e8a, (v) => $d62a989a301d5515$export$77fa7d86f5204e8a = v);
var $d62a989a301d5515$export$77fa7d86f5204e8a;
"use strict";

var $6eaCl = parcelRequire("6eaCl");

var $8SQia = parcelRequire("8SQia");

var $fS4Qr = parcelRequire("fS4Qr");

var $5ogow = parcelRequire("5ogow");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */ function $d62a989a301d5515$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    var scheduler = null;
    if ($6eaCl.isScheduler(observables[observables.length - 1])) scheduler = observables.pop();
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $8SQia.isArray(observables[0])) observables = observables[0];
    return new $fS4Qr.ArrayObservable(observables, scheduler).lift(new $5ogow.CombineLatestOperator(project));
}
$d62a989a301d5515$export$77fa7d86f5204e8a = $d62a989a301d5515$var$combineLatest;

});
parcelRegister("5ogow", function(module, exports) {
"use strict";
var $3ecbe93af0eafb88$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fS4Qr = parcelRequire("fS4Qr");

var $8SQia = parcelRequire("8SQia");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
var $3ecbe93af0eafb88$var$none = {};
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $3ecbe93af0eafb88$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') project = observables.pop();
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && $8SQia.isArray(observables[0])) observables = observables[0].slice();
    return function(source) {
        return source.lift.call(new $fS4Qr.ArrayObservable([
            source
        ].concat(observables)), new $3ecbe93af0eafb88$var$CombineLatestOperator(project));
    };
}
module.exports.combineLatest = $3ecbe93af0eafb88$var$combineLatest;
var $3ecbe93af0eafb88$var$CombineLatestOperator = function() {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3ecbe93af0eafb88$var$CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}();
module.exports.CombineLatestOperator = $3ecbe93af0eafb88$var$CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3ecbe93af0eafb88$var$CombineLatestSubscriber = function(_super) {
    $3ecbe93af0eafb88$var$__extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function(observable) {
        this.values.push($3ecbe93af0eafb88$var$none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            this.active = len;
            this.toRespond = len;
            for(var i = 0; i < len; i++){
                var observable = observables[i];
                this.add($d3klE.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function(unused) {
        if ((this.active -= 1) === 0) this.destination.complete();
    };
    CombineLatestSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond ? 0 : oldVal === $3ecbe93af0eafb88$var$none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) this._tryProject(values);
            else this.destination.next(values.slice());
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function(values) {
        var result;
        try {
            result = this.project.apply(this, values);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.CombineLatestSubscriber = $3ecbe93af0eafb88$var$CombineLatestSubscriber;

});



parcelRegister("5YUL8", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $jd6MB = parcelRequire("jd6MB");
$b0T1M.Observable.concat = $jd6MB.concat;

});
parcelRegister("jd6MB", function(module, exports) {
$parcel$export(module.exports, "concat", () => $dfc47e2cba6156dc$export$ee1b3e54f0441b22, (v) => $dfc47e2cba6156dc$export$ee1b3e54f0441b22 = v);
var $dfc47e2cba6156dc$export$ee1b3e54f0441b22;
"use strict";

var $6eaCl = parcelRequire("6eaCl");

var $6lMR1 = parcelRequire("6lMR1");

var $5wVlw = parcelRequire("5wVlw");

var $8kkVC = parcelRequire("8kkVC");
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */ function $dfc47e2cba6156dc$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    if (observables.length === 1 || observables.length === 2 && $6eaCl.isScheduler(observables[1])) return $5wVlw.from(observables[0]);
    return $8kkVC.concatAll()($6lMR1.of.apply(void 0, observables));
}
$dfc47e2cba6156dc$export$ee1b3e54f0441b22 = $dfc47e2cba6156dc$var$concat;

});
parcelRegister("8kkVC", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $61006ce904cfe8e5$export$b314777ae20abca9, (v) => $61006ce904cfe8e5$export$b314777ae20abca9 = v);
var $61006ce904cfe8e5$export$b314777ae20abca9;
"use strict";

var $jMu5f = parcelRequire("jMu5f");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $61006ce904cfe8e5$var$concatAll() {
    return $jMu5f.mergeAll(1);
}
$61006ce904cfe8e5$export$b314777ae20abca9 = $61006ce904cfe8e5$var$concatAll;

});



parcelRegister("4lfCD", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $8Tge8 = parcelRequire("8Tge8");
$b0T1M.Observable.defer = $8Tge8.defer;

});
parcelRegister("8Tge8", function(module, exports) {
$parcel$export(module.exports, "defer", () => $67900c1b70c934eb$export$260e5c0943f31606, (v) => $67900c1b70c934eb$export$260e5c0943f31606 = v);
var $67900c1b70c934eb$export$260e5c0943f31606;
"use strict";

var $h6IsJ = parcelRequire("h6IsJ");
$67900c1b70c934eb$export$260e5c0943f31606 = $h6IsJ.DeferObservable.create;

});
parcelRegister("h6IsJ", function(module, exports) {
"use strict";
var $c7457c856f1d118a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $c7457c856f1d118a$var$DeferObservable = function(_super) {
    $c7457c856f1d118a$var$__extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */ DeferObservable.create = function(observableFactory) {
        return new DeferObservable(observableFactory);
    };
    /** @deprecated internal use only */ DeferObservable.prototype._subscribe = function(subscriber) {
        return new $c7457c856f1d118a$var$DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}($b0T1M.Observable);
module.exports.DeferObservable = $c7457c856f1d118a$var$DeferObservable;
var $c7457c856f1d118a$var$DeferSubscriber = function(_super) {
    $c7457c856f1d118a$var$__extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function() {
        try {
            this._callFactory();
        } catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function() {
        var result = this.factory();
        if (result) this.add($d3klE.subscribeToResult(this, result));
    };
    return DeferSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("2dG9T", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $dEuRq = parcelRequire("dEuRq");
$b0T1M.Observable.empty = $dEuRq.empty;

});
parcelRegister("dEuRq", function(module, exports) {
$parcel$export(module.exports, "empty", () => $9f06f3115e2107f6$export$6e22c362a0406a2c, (v) => $9f06f3115e2107f6$export$6e22c362a0406a2c = v);
var $9f06f3115e2107f6$export$6e22c362a0406a2c;
"use strict";

var $lmQ1o = parcelRequire("lmQ1o");
$9f06f3115e2107f6$export$6e22c362a0406a2c = $lmQ1o.EmptyObservable.create;

});


parcelRegister("lFsWJ", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $1I5Du = parcelRequire("1I5Du");
$b0T1M.Observable.forkJoin = $1I5Du.forkJoin;

});
parcelRegister("1I5Du", function(module, exports) {
$parcel$export(module.exports, "forkJoin", () => $13ee45b126a29e21$export$b5bbde3786dfbd68, (v) => $13ee45b126a29e21$export$b5bbde3786dfbd68 = v);
var $13ee45b126a29e21$export$b5bbde3786dfbd68;
"use strict";

var $2wRMH = parcelRequire("2wRMH");
$13ee45b126a29e21$export$b5bbde3786dfbd68 = $2wRMH.ForkJoinObservable.create;

});
parcelRegister("2wRMH", function(module, exports) {
"use strict";
var $1d784a6a0014652c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $lmQ1o = parcelRequire("lmQ1o");

var $8SQia = parcelRequire("8SQia");

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $1d784a6a0014652c$var$ForkJoinObservable = function(_super) {
    $1d784a6a0014652c$var$__extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */ /**
     * Joins last values emitted by passed Observables.
     *
     * <span class="informal">Wait for Observables to complete and then combine last values they emitted.</span>
     *
     * <img src="./img/forkJoin.png" width="100%">
     *
     * `forkJoin` is an operator that takes any number of Observables which can be passed either as an array
     * or directly as arguments. If no input Observables are provided, resulting stream will complete
     * immediately.
     *
     * `forkJoin` will wait for all passed Observables to complete and then it will emit an array with last
     * values from corresponding Observables. So if you pass `n` Observables to the operator, resulting
     * array will have `n` values, where first value is the last thing emitted by the first Observable,
     * second value is the last thing emitted by the second Observable and so on. That means `forkJoin` will
     * not emit more than once and it will complete after that. If you need to emit combined values not only
     * at the end of lifecycle of passed Observables, but also throughout it, try out {@link combineLatest}
     * or {@link zip} instead.
     *
     * In order for resulting array to have the same length as the number of input Observables, whenever any of
     * that Observables completes without emitting any value, `forkJoin` will complete at that moment as well
     * and it will not emit anything either, even if it already has some last values from other Observables.
     * Conversely, if there is an Observable that never completes, `forkJoin` will never complete as well,
     * unless at any point some other Observable completes without emitting value, which brings us back to
     * the previous case. Overall, in order for `forkJoin` to emit a value, all Observables passed as arguments
     * have to emit something at least once and complete.
     *
     * If any input Observable errors at some point, `forkJoin` will error as well and all other Observables
     * will be immediately unsubscribed.
     *
     * Optionally `forkJoin` accepts project function, that will be called with values which normally
     * would land in emitted array. Whatever is returned by project function, will appear in output
     * Observable instead. This means that default project can be thought of as a function that takes
     * all its arguments and puts them into an array. Note that project function will be called only
     * when output Observable is supposed to emit a result.
     *
     * @example <caption>Use forkJoin with operator emitting immediately</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.of(1, 2, 3, 4),
     *   Rx.Observable.of(5, 6, 7, 8)
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [4, 8]
     * // "This is how it ends!"
     *
     *
     * @example <caption>Use forkJoin with operator emitting after some time</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4) // emit 0, 1, 2, 3 every half a second and complete
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // [2, 3] after 3 seconds
     * // "This is how it ends!" immediately after
     *
     *
     * @example <caption>Use forkJoin with project function</caption>
     * const observable = Rx.Observable.forkJoin(
     *   Rx.Observable.interval(1000).take(3), // emit 0, 1, 2 every second and complete
     *   Rx.Observable.interval(500).take(4), // emit 0, 1, 2, 3 every half a second and complete
     *   (n, m) => n + m
     * );
     * observable.subscribe(
     *   value => console.log(value),
     *   err => {},
     *   () => console.log('This is how it ends!')
     * );
     *
     * // Logs:
     * // 5 after 3 seconds
     * // "This is how it ends!" immediately after
     *
     * @see {@link combineLatest}
     * @see {@link zip}
     *
     * @param {...SubscribableOrPromise} sources Any number of Observables provided either as an array or as an arguments
     * passed directly to the operator.
     * @param {function} [project] Function that takes values emitted by input Observables and returns value
     * that will appear in resulting Observable instead of default array.
     * @return {Observable} Observable emitting either an array of last values emitted by passed Observables
     * or value from project function.
     * @static true
     * @name forkJoin
     * @owner Observable
     */ ForkJoinObservable.create = function() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i - 0] = arguments[_i];
        if (sources === null || arguments.length === 0) return new $lmQ1o.EmptyObservable();
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') resultSelector = sources.pop();
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && $8SQia.isArray(sources[0])) sources = sources[0];
        if (sources.length === 0) return new $lmQ1o.EmptyObservable();
        return new ForkJoinObservable(sources, resultSelector);
    };
    /** @deprecated internal use only */ ForkJoinObservable.prototype._subscribe = function(subscriber) {
        return new $1d784a6a0014652c$var$ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}($b0T1M.Observable);
module.exports.ForkJoinObservable = $1d784a6a0014652c$var$ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1d784a6a0014652c$var$ForkJoinSubscriber = function(_super) {
    $1d784a6a0014652c$var$__extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for(var i = 0; i < len; i++){
            var source = sources[i];
            var innerSubscription = $d3klE.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function(innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) return;
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("95xQu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $5wVlw = parcelRequire("5wVlw");
$b0T1M.Observable.from = $5wVlw.from;

});

parcelRegister("lTsWc", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $kk7n9 = parcelRequire("kk7n9");
$b0T1M.Observable.fromEvent = $kk7n9.fromEvent;

});
parcelRegister("kk7n9", function(module, exports) {
$parcel$export(module.exports, "fromEvent", () => $ecbb64eb9f120d83$export$a36e16046ae8f1bb, (v) => $ecbb64eb9f120d83$export$a36e16046ae8f1bb = v);
var $ecbb64eb9f120d83$export$a36e16046ae8f1bb;
"use strict";

var $oGM99 = parcelRequire("oGM99");
$ecbb64eb9f120d83$export$a36e16046ae8f1bb = $oGM99.FromEventObservable.create;

});
parcelRegister("oGM99", function(module, exports) {
"use strict";
var $04a36c572b871d72$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $3kkLM = parcelRequire("3kkLM");

var $02vJ2 = parcelRequire("02vJ2");

var $geExo = parcelRequire("geExo");

var $cGvOX = parcelRequire("cGvOX");
var $04a36c572b871d72$var$toString = Object.prototype.toString;
function $04a36c572b871d72$var$isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function $04a36c572b871d72$var$isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function $04a36c572b871d72$var$isNodeList(sourceObj) {
    return !!sourceObj && $04a36c572b871d72$var$toString.call(sourceObj) === '[object NodeList]';
}
function $04a36c572b871d72$var$isHTMLCollection(sourceObj) {
    return !!sourceObj && $04a36c572b871d72$var$toString.call(sourceObj) === '[object HTMLCollection]';
}
function $04a36c572b871d72$var$isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $04a36c572b871d72$var$FromEventObservable = function(_super) {
    $04a36c572b871d72$var$__extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */ /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node.js
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * `fromEvent` accepts as a first argument event target, which is an object with methods
     * for registering event handler functions. As a second argument it takes string that indicates
     * type of event we want to listen for. `fromEvent` supports selected types of event targets,
     * which are described in detail below. If your event target does not match any of the ones listed,
     * you should use {@link fromEventPattern}, which can be used on arbitrary APIs.
     * When it comes to APIs supported by `fromEvent`, their methods for adding and removing event
     * handler functions have different names, but they all accept a string describing event type
     * and function itself, which will be called whenever said event happens.
     *
     * Every time resulting Observable is subscribed, event handler function will be registered
     * to event target on given event type. When that event fires, value
     * passed as a first argument to registered function will be emitted by output Observable.
     * When Observable is unsubscribed, function will be unregistered from event target.
     *
     * Note that if event target calls registered function with more than one argument, second
     * and following arguments will not appear in resulting stream. In order to get access to them,
     * you can pass to `fromEvent` optional project function, which will be called with all arguments
     * passed to event handler. Output Observable will then emit value returned by project function,
     * instead of the usual value.
     *
     * Remember that event targets listed below are checked via duck typing. It means that
     * no matter what kind of object you have and no matter what environment you work in,
     * you can safely use `fromEvent` on that object if it exposes described methods (provided
     * of course they behave as was described above). So for example if Node.js library exposes
     * event target which has the same method names as DOM EventTarget, `fromEvent` is still
     * a good choice.
     *
     * If the API you use is more callback then event handler oriented (subscribed
     * callback function fires only once and thus there is no need to manually
     * unregister it), you should use {@link bindCallback} or {@link bindNodeCallback}
     * instead.
     *
     * `fromEvent` supports following types of event targets:
     *
     * **DOM EventTarget**
     *
     * This is an object with `addEventListener` and `removeEventListener` methods.
     *
     * In the browser, `addEventListener` accepts - apart from event type string and event
     * handler function arguments - optional third parameter, which is either an object or boolean,
     * both used for additional configuration how and when passed function will be called. When
     * `fromEvent` is used with event target of that type, you can provide this values
     * as third parameter as well.
     *
     * **Node.js EventEmitter**
     *
     * An object with `addListener` and `removeListener` methods.
     *
     * **JQuery-style event target**
     *
     * An object with `on` and `off` methods
     *
     * **DOM NodeList**
     *
     * List of DOM Nodes, returned for example by `document.querySelectorAll` or `Node.childNodes`.
     *
     * Although this collection is not event target in itself, `fromEvent` will iterate over all Nodes
     * it contains and install event handler function in every of them. When returned Observable
     * is unsubscribed, function will be removed from all Nodes.
     *
     * **DOM HtmlCollection**
     *
     * Just as in case of NodeList it is a collection of DOM nodes. Here as well event handler function is
     * installed and removed in each of elements.
     *
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console every time a click
     * // occurs on the document.
     *
     *
     * @example <caption>Use addEventListener with capture option</caption>
     * var clicksInDocument = Rx.Observable.fromEvent(document, 'click', true); // note optional configuration parameter
     *                                                                          // which will be passed to addEventListener
     * var clicksInDiv = Rx.Observable.fromEvent(someDivInDocument, 'click');
     *
     * clicksInDocument.subscribe(() => console.log('document'));
     * clicksInDiv.subscribe(() => console.log('div'));
     *
     * // By default events bubble UP in DOM tree, so normally
     * // when we would click on div in document
     * // "div" would be logged first and then "document".
     * // Since we specified optional `capture` option, document
     * // will catch event when it goes DOWN DOM tree, so console
     * // will log "document" and then "div".
     *
     * @see {@link bindCallback}
     * @see {@link bindNodeCallback}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOM EventTarget, Node.js
     * EventEmitter, JQuery-like event target, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */ FromEventObservable.create = function(target, eventName, options, selector) {
        if ($02vJ2.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function(sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if ($04a36c572b871d72$var$isNodeList(sourceObj) || $04a36c572b871d72$var$isHTMLCollection(sourceObj)) for(var i = 0, len = sourceObj.length; i < len; i++)FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        else if ($04a36c572b871d72$var$isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function() {
                return source_1.removeEventListener(eventName, handler, options);
            };
        } else if ($04a36c572b871d72$var$isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function() {
                return source_2.off(eventName, handler);
            };
        } else if ($04a36c572b871d72$var$isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function() {
                return source_3.removeListener(eventName, handler);
            };
        } else throw new TypeError('Invalid event target');
        subscriber.add(new $cGvOX.Subscription(unsubscribe));
    };
    /** @deprecated internal use only */ FromEventObservable.prototype._subscribe = function(subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            var result = $3kkLM.tryCatch(selector).apply(void 0, args);
            if (result === $geExo.errorObject) subscriber.error($geExo.errorObject.e);
            else subscriber.next(result);
        } : function(e) {
            return subscriber.next(e);
        };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}($b0T1M.Observable);
module.exports.FromEventObservable = $04a36c572b871d72$var$FromEventObservable;

});



parcelRegister("9MAdb", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $d4Dw7 = parcelRequire("d4Dw7");
$b0T1M.Observable.fromEventPattern = $d4Dw7.fromEventPattern;

});
parcelRegister("d4Dw7", function(module, exports) {
$parcel$export(module.exports, "fromEventPattern", () => $984a4d57c0c6fb52$export$af596f9f0ff848f8, (v) => $984a4d57c0c6fb52$export$af596f9f0ff848f8 = v);
var $984a4d57c0c6fb52$export$af596f9f0ff848f8;
"use strict";

var $dMiBC = parcelRequire("dMiBC");
$984a4d57c0c6fb52$export$af596f9f0ff848f8 = $dMiBC.FromEventPatternObservable.create;

});
parcelRegister("dMiBC", function(module, exports) {
"use strict";
var $a07e30c5ac6a5e62$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $02vJ2 = parcelRequire("02vJ2");

var $b0T1M = parcelRequire("b0T1M");

var $cGvOX = parcelRequire("cGvOX");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a07e30c5ac6a5e62$var$FromEventPatternObservable = function(_super) {
    $a07e30c5ac6a5e62$var$__extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */ FromEventPatternObservable.create = function(addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    /** @deprecated internal use only */ FromEventPatternObservable.prototype._subscribe = function(subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
            _this._callSelector(subscriber, args);
        } : function(e) {
            subscriber.next(e);
        };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!$02vJ2.isFunction(removeHandler)) return;
        subscriber.add(new $cGvOX.Subscription(function() {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function(subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        } catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function(handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        } catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}($b0T1M.Observable);
module.exports.FromEventPatternObservable = $a07e30c5ac6a5e62$var$FromEventPatternObservable;

});



parcelRegister("aQQ20", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $440xD = parcelRequire("440xD");
$b0T1M.Observable.fromPromise = $440xD.fromPromise;

});

parcelRegister("kzrO8", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $gpl0I = parcelRequire("gpl0I");
$b0T1M.Observable.generate = $gpl0I.generate;

});
parcelRegister("gpl0I", function(module, exports) {
$parcel$export(module.exports, "generate", () => $bf1f47631e63e2a7$export$80d376111cc09ad7, (v) => $bf1f47631e63e2a7$export$80d376111cc09ad7 = v);
var $bf1f47631e63e2a7$export$80d376111cc09ad7;
"use strict";

var $etX6v = parcelRequire("etX6v");
$bf1f47631e63e2a7$export$80d376111cc09ad7 = $etX6v.GenerateObservable.create;

});
parcelRegister("etX6v", function(module, exports) {
"use strict";
var $a8b19eed64721918$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $6eaCl = parcelRequire("6eaCl");
var $a8b19eed64721918$var$selfSelector = function(value) {
    return value;
};
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a8b19eed64721918$var$GenerateObservable = function(_super) {
    $a8b19eed64721918$var$__extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || $a8b19eed64721918$var$selfSelector, initialStateOrOptions.scheduler);
        if (resultSelectorOrObservable === undefined || $6eaCl.isScheduler(resultSelectorOrObservable)) return new GenerateObservable(initialStateOrOptions, condition, iterate, $a8b19eed64721918$var$selfSelector, resultSelectorOrObservable);
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    /** @deprecated internal use only */ GenerateObservable.prototype._subscribe = function(subscriber) {
        var state = this.initialState;
        if (this.scheduler) return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
            subscriber: subscriber,
            iterate: this.iterate,
            condition: this.condition,
            resultSelector: this.resultSelector,
            state: state
        });
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) break;
            try {
                state = iterate(state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
        }while (true);
    };
    GenerateObservable.dispatch = function(state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) return;
        if (state.needIterate) try {
            state.state = state.iterate(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        else state.needIterate = true;
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            } catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) return;
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        } catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) return;
        subscriber.next(value);
        if (subscriber.closed) return;
        return this.schedule(state);
    };
    return GenerateObservable;
}($b0T1M.Observable);
module.exports.GenerateObservable = $a8b19eed64721918$var$GenerateObservable;

});



parcelRegister("lTmzS", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $etSEx = parcelRequire("etSEx");
$b0T1M.Observable.if = $etSEx._if;

});
parcelRegister("etSEx", function(module, exports) {
$parcel$export(module.exports, "_if", () => $a8ae2b0457e262ea$export$3d19121892ad9076, (v) => $a8ae2b0457e262ea$export$3d19121892ad9076 = v);
var $a8ae2b0457e262ea$export$3d19121892ad9076;
"use strict";

var $9Neim = parcelRequire("9Neim");
$a8ae2b0457e262ea$export$3d19121892ad9076 = $9Neim.IfObservable.create;

});
parcelRegister("9Neim", function(module, exports) {
"use strict";
var $7213c766b13c5da3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $7213c766b13c5da3$var$IfObservable = function(_super) {
    $7213c766b13c5da3$var$__extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function(condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    /** @deprecated internal use only */ IfObservable.prototype._subscribe = function(subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new $7213c766b13c5da3$var$IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}($b0T1M.Observable);
module.exports.IfObservable = $7213c766b13c5da3$var$IfObservable;
var $7213c766b13c5da3$var$IfSubscriber = function(_super) {
    $7213c766b13c5da3$var$__extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function() {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) this.add($d3klE.subscribeToResult(this, source));
            else this._complete();
        } catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("8GJ9R", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $5N2lv = parcelRequire("5N2lv");
$b0T1M.Observable.interval = $5N2lv.interval;

});
parcelRegister("5N2lv", function(module, exports) {
$parcel$export(module.exports, "interval", () => $4373592c7eb56a05$export$3174cdbf0a0cbc84, (v) => $4373592c7eb56a05$export$3174cdbf0a0cbc84 = v);
var $4373592c7eb56a05$export$3174cdbf0a0cbc84;
"use strict";

var $iQu85 = parcelRequire("iQu85");
$4373592c7eb56a05$export$3174cdbf0a0cbc84 = $iQu85.IntervalObservable.create;

});
parcelRegister("iQu85", function(module, exports) {
"use strict";
var $db84746c5a8a729d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kAEty = parcelRequire("kAEty");

var $b0T1M = parcelRequire("b0T1M");

var $hBoCS = parcelRequire("hBoCS");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $db84746c5a8a729d$var$IntervalObservable = function(_super) {
    $db84746c5a8a729d$var$__extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $hBoCS.async;
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!$kAEty.isNumeric(period) || period < 0) this.period = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $hBoCS.async;
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */ IntervalObservable.create = function(period, scheduler) {
        if (period === void 0) period = 0;
        if (scheduler === void 0) scheduler = $hBoCS.async;
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function(state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) return;
        state.index += 1;
        this.schedule(state, period);
    };
    /** @deprecated internal use only */ IntervalObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index,
            subscriber: subscriber,
            period: period
        }));
    };
    return IntervalObservable;
}($b0T1M.Observable);
module.exports.IntervalObservable = $db84746c5a8a729d$var$IntervalObservable;

});
parcelRegister("kAEty", function(module, exports) {
$parcel$export(module.exports, "isNumeric", () => $efd6910cca833a50$export$e90fb89750dba83f, (v) => $efd6910cca833a50$export$e90fb89750dba83f = v);
var $efd6910cca833a50$export$e90fb89750dba83f;
"use strict";

var $8SQia = parcelRequire("8SQia");
function $efd6910cca833a50$var$isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !$8SQia.isArray(val) && val - parseFloat(val) + 1 >= 0;
}
$efd6910cca833a50$export$e90fb89750dba83f = $efd6910cca833a50$var$isNumeric;

});

parcelRegister("hBoCS", function(module, exports) {
$parcel$export(module.exports, "async", () => $cd08fe90d809ae7a$export$12af436354f1a4f7, (v) => $cd08fe90d809ae7a$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $cd08fe90d809ae7a$export$12af436354f1a4f7;
"use strict";

var $jvUn0 = parcelRequire("jvUn0");

var $63qby = parcelRequire("63qby");
$cd08fe90d809ae7a$export$12af436354f1a4f7 = new $63qby.AsyncScheduler($jvUn0.AsyncAction);

});




parcelRegister("kWN7f", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $eqsjw = parcelRequire("eqsjw");
$b0T1M.Observable.merge = $eqsjw.merge;

});

parcelRegister("8BhjG", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $eMy72 = parcelRequire("eMy72");
$b0T1M.Observable.race = $eMy72.race;

});
parcelRegister("eMy72", function(module, exports) {
"use strict";
var $ac3002676bf56b87$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8SQia = parcelRequire("8SQia");

var $fS4Qr = parcelRequire("fS4Qr");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
function $ac3002676bf56b87$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($8SQia.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $fS4Qr.ArrayObservable(observables).lift(new $ac3002676bf56b87$var$RaceOperator());
}
module.exports.race = $ac3002676bf56b87$var$race;
var $ac3002676bf56b87$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ac3002676bf56b87$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $ac3002676bf56b87$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ac3002676bf56b87$var$RaceSubscriber = function(_super) {
    $ac3002676bf56b87$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $d3klE.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.RaceSubscriber = $ac3002676bf56b87$var$RaceSubscriber;

});


parcelRegister("cqvVe", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $kfMsW = parcelRequire("kfMsW");
$b0T1M.Observable.never = $kfMsW.never;

});
parcelRegister("kfMsW", function(module, exports) {
$parcel$export(module.exports, "never", () => $ebeacda3e3198fbe$export$b3e22bcfd64c1022, (v) => $ebeacda3e3198fbe$export$b3e22bcfd64c1022 = v);
var $ebeacda3e3198fbe$export$b3e22bcfd64c1022;
"use strict";

var $1u7jx = parcelRequire("1u7jx");
$ebeacda3e3198fbe$export$b3e22bcfd64c1022 = $1u7jx.NeverObservable.create;

});
parcelRegister("1u7jx", function(module, exports) {
"use strict";
var $114e443b35aa1ada$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $kjljt = parcelRequire("kjljt");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $114e443b35aa1ada$var$NeverObservable = function(_super) {
    $114e443b35aa1ada$var$__extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please note
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */ NeverObservable.create = function() {
        return new NeverObservable();
    };
    /** @deprecated internal use only */ NeverObservable.prototype._subscribe = function(subscriber) {
        $kjljt.noop();
    };
    return NeverObservable;
}($b0T1M.Observable);
module.exports.NeverObservable = $114e443b35aa1ada$var$NeverObservable;

});



parcelRegister("ahsa1", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $6lMR1 = parcelRequire("6lMR1");
$b0T1M.Observable.of = $6lMR1.of;

});

parcelRegister("iTXAu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $doWRs = parcelRequire("doWRs");
$b0T1M.Observable.onErrorResumeNext = $doWRs.onErrorResumeNext;

});
parcelRegister("doWRs", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $9c1b2cdf262b570d$export$5fba66d61591f42, (v) => $9c1b2cdf262b570d$export$5fba66d61591f42 = v);
var $9c1b2cdf262b570d$export$5fba66d61591f42;
"use strict";

var $8gEWr = parcelRequire("8gEWr");
$9c1b2cdf262b570d$export$5fba66d61591f42 = $8gEWr.onErrorResumeNextStatic;

});
parcelRegister("8gEWr", function(module, exports) {
"use strict";
var $604f9382005c95ee$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $7wGfx = parcelRequire("7wGfx");

var $8SQia = parcelRequire("8SQia");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $604f9382005c95ee$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $8SQia.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $604f9382005c95ee$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $604f9382005c95ee$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $604f9382005c95ee$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $8SQia.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $7wGfx.FromObservable(source, null).lift(new $604f9382005c95ee$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $604f9382005c95ee$var$onErrorResumeNextStatic;
var $604f9382005c95ee$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $604f9382005c95ee$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $604f9382005c95ee$var$OnErrorResumeNextSubscriber = function(_super) {
    $604f9382005c95ee$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($d3klE.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("dZ6X4", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $lbh5d = parcelRequire("lbh5d");
$b0T1M.Observable.pairs = $lbh5d.pairs;

});
parcelRegister("lbh5d", function(module, exports) {
$parcel$export(module.exports, "pairs", () => $f6b7e06b0719df3a$export$589748d90c221be3, (v) => $f6b7e06b0719df3a$export$589748d90c221be3 = v);
var $f6b7e06b0719df3a$export$589748d90c221be3;
"use strict";

var $go3kn = parcelRequire("go3kn");
$f6b7e06b0719df3a$export$589748d90c221be3 = $go3kn.PairsObservable.create;

});
parcelRegister("go3kn", function(module, exports) {
"use strict";
var $bee1780a32dca542$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");
function $bee1780a32dca542$var$dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([
        key,
        obj[key]
    ]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $bee1780a32dca542$var$PairsObservable = function(_super) {
    $bee1780a32dca542$var$__extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */ PairsObservable.create = function(obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    /** @deprecated internal use only */ PairsObservable.prototype._subscribe = function(subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) return scheduler.schedule($bee1780a32dca542$var$dispatch, 0, {
            obj: this.obj,
            keys: keys,
            length: length,
            index: 0,
            subscriber: subscriber
        });
        else {
            for(var idx = 0; idx < length; idx++){
                var key = keys[idx];
                subscriber.next([
                    key,
                    this.obj[key]
                ]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}($b0T1M.Observable);
module.exports.PairsObservable = $bee1780a32dca542$var$PairsObservable;

});



parcelRegister("iQlC3", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3ARJI = parcelRequire("3ARJI");
$b0T1M.Observable.range = $3ARJI.range;

});

parcelRegister("inJsy", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $iJDB1 = parcelRequire("iJDB1");
$b0T1M.Observable.using = $iJDB1.using;

});
parcelRegister("iJDB1", function(module, exports) {
$parcel$export(module.exports, "using", () => $da3b24e844c5407c$export$fb1889ddede82380, (v) => $da3b24e844c5407c$export$fb1889ddede82380 = v);
var $da3b24e844c5407c$export$fb1889ddede82380;
"use strict";

var $5uwvl = parcelRequire("5uwvl");
$da3b24e844c5407c$export$fb1889ddede82380 = $5uwvl.UsingObservable.create;

});
parcelRegister("5uwvl", function(module, exports) {
"use strict";
var $3ff8f7d6175f532e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $3ff8f7d6175f532e$var$UsingObservable = function(_super) {
    $3ff8f7d6175f532e$var$__extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function(resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    /** @deprecated internal use only */ UsingObservable.prototype._subscribe = function(subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new $3ff8f7d6175f532e$var$UsingSubscriber(subscriber, resource, observableFactory);
        } catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}($b0T1M.Observable);
module.exports.UsingObservable = $3ff8f7d6175f532e$var$UsingObservable;
var $3ff8f7d6175f532e$var$UsingSubscriber = function(_super) {
    $3ff8f7d6175f532e$var$__extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function() {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) this.add($d3klE.subscribeToResult(this, source));
        } catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("4gt3S", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $4limE = parcelRequire("4limE");
$b0T1M.Observable.throw = $4limE._throw;

});
parcelRegister("4limE", function(module, exports) {
$parcel$export(module.exports, "_throw", () => $32975e5d1ccaebca$export$82a8af9b11518516, (v) => $32975e5d1ccaebca$export$82a8af9b11518516 = v);
var $32975e5d1ccaebca$export$82a8af9b11518516;
"use strict";

var $e3UFg = parcelRequire("e3UFg");
$32975e5d1ccaebca$export$82a8af9b11518516 = $e3UFg.ErrorObservable.create;

});
parcelRegister("e3UFg", function(module, exports) {
"use strict";
var $a3cd4ce3adccf22f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $a3cd4ce3adccf22f$var$ErrorObservable = function(_super) {
    $a3cd4ce3adccf22f$var$__extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */ ErrorObservable.create = function(error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function(arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    /** @deprecated internal use only */ ErrorObservable.prototype._subscribe = function(subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        subscriber.syncErrorThrowable = true;
        if (scheduler) return scheduler.schedule(ErrorObservable.dispatch, 0, {
            error: error,
            subscriber: subscriber
        });
        else subscriber.error(error);
    };
    return ErrorObservable;
}($b0T1M.Observable);
module.exports.ErrorObservable = $a3cd4ce3adccf22f$var$ErrorObservable;

});



parcelRegister("e1Yf3", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $1ARln = parcelRequire("1ARln");
$b0T1M.Observable.timer = $1ARln.timer;

});
parcelRegister("1ARln", function(module, exports) {
$parcel$export(module.exports, "timer", () => $12928831749b383f$export$9dc4ecf953986f04, (v) => $12928831749b383f$export$9dc4ecf953986f04 = v);
var $12928831749b383f$export$9dc4ecf953986f04;
"use strict";

var $blu0G = parcelRequire("blu0G");
$12928831749b383f$export$9dc4ecf953986f04 = $blu0G.TimerObservable.create;

});
parcelRegister("blu0G", function(module, exports) {
"use strict";
var $8428ef37de0ffb2d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kAEty = parcelRequire("kAEty");

var $b0T1M = parcelRequire("b0T1M");

var $hBoCS = parcelRequire("hBoCS");

var $6eaCl = parcelRequire("6eaCl");

var $lrUXm = parcelRequire("lrUXm");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $8428ef37de0ffb2d$var$TimerObservable = function(_super) {
    $8428ef37de0ffb2d$var$__extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) dueTime = 0;
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if ($kAEty.isNumeric(period)) this.period = Number(period) < 1 && 1 || Number(period);
        else if ($6eaCl.isScheduler(period)) scheduler = period;
        if (!$6eaCl.isScheduler(scheduler)) scheduler = $hBoCS.async;
        this.scheduler = scheduler;
        this.dueTime = $lrUXm.isDate(dueTime) ? +dueTime - this.scheduler.now() : dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */ TimerObservable.create = function(initialDelay, period, scheduler) {
        if (initialDelay === void 0) initialDelay = 0;
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function(state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) return;
        else if (period === -1) return subscriber.complete();
        state.index = index + 1;
        action.schedule(state, period);
    };
    /** @deprecated internal use only */ TimerObservable.prototype._subscribe = function(subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index,
            period: period,
            subscriber: subscriber
        });
    };
    return TimerObservable;
}($b0T1M.Observable);
module.exports.TimerObservable = $8428ef37de0ffb2d$var$TimerObservable;

});
parcelRegister("lrUXm", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $f9d84cede7da5310$export$871608497c498473, (v) => $f9d84cede7da5310$export$871608497c498473 = v);
var $f9d84cede7da5310$export$871608497c498473;
"use strict";
function $f9d84cede7da5310$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$f9d84cede7da5310$export$871608497c498473 = $f9d84cede7da5310$var$isDate;

});




parcelRegister("2V4ph", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $egbjl = parcelRequire("egbjl");
$b0T1M.Observable.zip = $egbjl.zip;

});
parcelRegister("egbjl", function(module, exports) {
$parcel$export(module.exports, "zip", () => $a61b55742f1da8f0$export$8901015135f2fb22, (v) => $a61b55742f1da8f0$export$8901015135f2fb22 = v);
var $a61b55742f1da8f0$export$8901015135f2fb22;
"use strict";

var $8bwYR = parcelRequire("8bwYR");
$a61b55742f1da8f0$export$8901015135f2fb22 = $8bwYR.zipStatic;

});
parcelRegister("8bwYR", function(module, exports) {
"use strict";
var $5f58ef0f30e4c4af$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fS4Qr = parcelRequire("fS4Qr");

var $8SQia = parcelRequire("8SQia");

var $kVbBc = parcelRequire("kVbBc");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");

var $aT16R = parcelRequire("aT16R");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $5f58ef0f30e4c4af$var$zip() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function zipOperatorFunction(source) {
        return source.lift.call($5f58ef0f30e4c4af$var$zipStatic.apply(void 0, [
            source
        ].concat(observables)));
    };
}
module.exports.zip = $5f58ef0f30e4c4af$var$zip;
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */ function $5f58ef0f30e4c4af$var$zipStatic() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var project = observables[observables.length - 1];
    if (typeof project === 'function') observables.pop();
    return new $fS4Qr.ArrayObservable(observables).lift(new $5f58ef0f30e4c4af$var$ZipOperator(project));
}
module.exports.zipStatic = $5f58ef0f30e4c4af$var$zipStatic;
var $5f58ef0f30e4c4af$var$ZipOperator = function() {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5f58ef0f30e4c4af$var$ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}();
module.exports.ZipOperator = $5f58ef0f30e4c4af$var$ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5f58ef0f30e4c4af$var$ZipSubscriber = function(_super) {
    $5f58ef0f30e4c4af$var$__extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) values = Object.create(null);
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = typeof project === 'function' ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function(value) {
        var iterators = this.iterators;
        if ($8SQia.isArray(value)) iterators.push(new $5f58ef0f30e4c4af$var$StaticArrayIterator(value));
        else if (typeof value[$aT16R.iterator] === 'function') iterators.push(new $5f58ef0f30e4c4af$var$StaticIterator(value[$aT16R.iterator]()));
        else iterators.push(new $5f58ef0f30e4c4af$var$ZipBufferIterator(this.destination, this, value));
    };
    ZipSubscriber.prototype._complete = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) this.add(iterator.subscribe(iterator, i));
            else this.active--; // not an observable
        }
    };
    ZipSubscriber.prototype.notifyInactive = function() {
        this.active--;
        if (this.active === 0) this.destination.complete();
    };
    ZipSubscriber.prototype.checkIterators = function() {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) return;
        }
        var shouldComplete = false;
        var args = [];
        for(var i = 0; i < len; i++){
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) shouldComplete = true;
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) this._tryProject(args);
        else destination.next(args);
        if (shouldComplete) destination.complete();
    };
    ZipSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}($kVbBc.Subscriber);
module.exports.ZipSubscriber = $5f58ef0f30e4c4af$var$ZipSubscriber;
var $5f58ef0f30e4c4af$var$StaticIterator = function() {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function() {
        return true;
    };
    StaticIterator.prototype.next = function() {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function() {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}();
var $5f58ef0f30e4c4af$var$StaticArrayIterator = function() {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[$aT16R.iterator] = function() {
        return this;
    };
    StaticArrayIterator.prototype.next = function(value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? {
            value: array[i],
            done: false
        } : {
            value: null,
            done: true
        };
    };
    StaticArrayIterator.prototype.hasValue = function() {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function() {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5f58ef0f30e4c4af$var$ZipBufferIterator = function(_super) {
    $5f58ef0f30e4c4af$var$__extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[$aT16R.iterator] = function() {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function() {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) return {
            value: null,
            done: true
        };
        else return {
            value: buffer.shift(),
            done: false
        };
    };
    ZipBufferIterator.prototype.hasValue = function() {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function() {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function() {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        } else this.destination.complete();
    };
    ZipBufferIterator.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function(value, index) {
        return $d3klE.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}($5XpGv.OuterSubscriber);

});



parcelRegister("1a2eL", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $7PYLS = parcelRequire("7PYLS");
$b0T1M.Observable.ajax = $7PYLS.ajax;

});
parcelRegister("7PYLS", function(module, exports) {
$parcel$export(module.exports, "ajax", () => $5b4c6fb6d2c9c380$export$e68fce4c5f453854, (v) => $5b4c6fb6d2c9c380$export$e68fce4c5f453854 = v);
var $5b4c6fb6d2c9c380$export$e68fce4c5f453854;
"use strict";

var $2DcNu = parcelRequire("2DcNu");
$5b4c6fb6d2c9c380$export$e68fce4c5f453854 = $2DcNu.AjaxObservable.create;

});
parcelRegister("2DcNu", function(module, exports) {
"use strict";
var $1ea9268d3f95d69b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jYFjc = parcelRequire("jYFjc");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $b0T1M = parcelRequire("b0T1M");

var $kVbBc = parcelRequire("kVbBc");

var $bWhgb = parcelRequire("bWhgb");
function $1ea9268d3f95d69b$var$getCORSRequest() {
    if ($jYFjc.root.XMLHttpRequest) return new $jYFjc.root.XMLHttpRequest();
    else if (!!$jYFjc.root.XDomainRequest) return new $jYFjc.root.XDomainRequest();
    else throw new Error('CORS is not supported by your browser');
}
function $1ea9268d3f95d69b$var$getXMLHttpRequest() {
    if ($jYFjc.root.XMLHttpRequest) return new $jYFjc.root.XMLHttpRequest();
    else {
        var progId = void 0;
        try {
            var progIds = [
                'Msxml2.XMLHTTP',
                'Microsoft.XMLHTTP',
                'Msxml2.XMLHTTP.4.0'
            ];
            for(var i = 0; i < 3; i++)try {
                progId = progIds[i];
                new $jYFjc.root.ActiveXObject(progId);
                break;
            } catch (e) {}
            return new $jYFjc.root.ActiveXObject(progId);
        } catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function $1ea9268d3f95d69b$var$ajaxGet(url, headers) {
    if (headers === void 0) headers = null;
    return new $1ea9268d3f95d69b$var$AjaxObservable({
        method: 'GET',
        url: url,
        headers: headers
    });
}
module.exports.ajaxGet = $1ea9268d3f95d69b$var$ajaxGet;
function $1ea9268d3f95d69b$var$ajaxPost(url, body, headers) {
    return new $1ea9268d3f95d69b$var$AjaxObservable({
        method: 'POST',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPost = $1ea9268d3f95d69b$var$ajaxPost;
function $1ea9268d3f95d69b$var$ajaxDelete(url, headers) {
    return new $1ea9268d3f95d69b$var$AjaxObservable({
        method: 'DELETE',
        url: url,
        headers: headers
    });
}
module.exports.ajaxDelete = $1ea9268d3f95d69b$var$ajaxDelete;
function $1ea9268d3f95d69b$var$ajaxPut(url, body, headers) {
    return new $1ea9268d3f95d69b$var$AjaxObservable({
        method: 'PUT',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPut = $1ea9268d3f95d69b$var$ajaxPut;
function $1ea9268d3f95d69b$var$ajaxPatch(url, body, headers) {
    return new $1ea9268d3f95d69b$var$AjaxObservable({
        method: 'PATCH',
        url: url,
        body: body,
        headers: headers
    });
}
module.exports.ajaxPatch = $1ea9268d3f95d69b$var$ajaxPatch;
var $1ea9268d3f95d69b$var$mapResponse = $bWhgb.map(function(x, index) {
    return x.response;
});
function $1ea9268d3f95d69b$var$ajaxGetJSON(url, headers) {
    return $1ea9268d3f95d69b$var$mapResponse(new $1ea9268d3f95d69b$var$AjaxObservable({
        method: 'GET',
        url: url,
        responseType: 'json',
        headers: headers
    }));
}
module.exports.ajaxGetJSON = $1ea9268d3f95d69b$var$ajaxGetJSON;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $1ea9268d3f95d69b$var$AjaxObservable = function(_super) {
    $1ea9268d3f95d69b$var$__extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function() {
                return this.crossDomain ? $1ea9268d3f95d69b$var$getCORSRequest.call(this) : $1ea9268d3f95d69b$var$getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') request.url = urlOrRequest;
        else {
            for(var prop in urlOrRequest)if (urlOrRequest.hasOwnProperty(prop)) request[prop] = urlOrRequest[prop];
        }
        this.request = request;
    }
    /** @deprecated internal use only */ AjaxObservable.prototype._subscribe = function(subscriber) {
        return new $1ea9268d3f95d69b$var$AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */ AjaxObservable.create = function() {
        var create = function(urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = $1ea9268d3f95d69b$var$ajaxGet;
        create.post = $1ea9268d3f95d69b$var$ajaxPost;
        create.delete = $1ea9268d3f95d69b$var$ajaxDelete;
        create.put = $1ea9268d3f95d69b$var$ajaxPut;
        create.patch = $1ea9268d3f95d69b$var$ajaxPatch;
        create.getJSON = $1ea9268d3f95d69b$var$ajaxGetJSON;
        return create;
    }();
    return AjaxObservable;
}($b0T1M.Observable);
module.exports.AjaxObservable = $1ea9268d3f95d69b$var$AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1ea9268d3f95d69b$var$AjaxSubscriber = function(_super) {
    $1ea9268d3f95d69b$var$__extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) headers['X-Requested-With'] = 'XMLHttpRequest';
        // ensure content type is set
        if (!('Content-Type' in headers) && !($jYFjc.root.FormData && request.body instanceof $jYFjc.root.FormData) && typeof request.body !== 'undefined') headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function(e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new $1ea9268d3f95d69b$var$AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function() {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = $3kkLM.tryCatch(createXHR).call(request);
        if (xhr === $geExo.errorObject) this.error($geExo.errorObject.e);
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) result = $3kkLM.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            else result = $3kkLM.tryCatch(xhr.open).call(xhr, method, url, async);
            if (result === $geExo.errorObject) {
                this.error($geExo.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            if (async) {
                xhr.timeout = request.timeout;
                xhr.responseType = request.responseType;
            }
            if ('withCredentials' in xhr) xhr.withCredentials = !!request.withCredentials;
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? $3kkLM.tryCatch(xhr.send).call(xhr, body) : $3kkLM.tryCatch(xhr.send).call(xhr);
            if (result === $geExo.errorObject) {
                this.error($geExo.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function(body, contentType) {
        if (!body || typeof body === 'string') return body;
        else if ($jYFjc.root.FormData && body instanceof $jYFjc.root.FormData) return body;
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) contentType = contentType.substring(0, splitIndex);
        }
        switch(contentType){
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function(key) {
                    return encodeURIComponent(key) + "=" + encodeURIComponent(body[key]);
                }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function(xhr, headers) {
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    };
    AjaxSubscriber.prototype.setupEvents = function(xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) progressSubscriber.error(e);
            subscriber.error(new $1ea9268d3f95d69b$var$AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function(e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if ($jYFjc.root.XDomainRequest) xhr.onprogress = xhrProgress_1;
                else xhr.upload.onprogress = xhrProgress_1;
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function(e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) progressSubscriber.error(e);
                subscriber.error(new $1ea9268d3f95d69b$var$AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = this.responseType === 'text' ? this.response || this.responseText : this.response;
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) status_1 = response ? 200 : 0;
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) progressSubscriber.complete();
                    subscriber.next(e);
                    subscriber.complete();
                } else {
                    if (progressSubscriber) progressSubscriber.error(e);
                    subscriber.error(new $1ea9268d3f95d69b$var$AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function() {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') xhr.abort();
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}($kVbBc.Subscriber);
module.exports.AjaxSubscriber = $1ea9268d3f95d69b$var$AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */ var $1ea9268d3f95d69b$var$AjaxResponse = function() {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $1ea9268d3f95d69b$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxResponse;
}();
module.exports.AjaxResponse = $1ea9268d3f95d69b$var$AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */ var $1ea9268d3f95d69b$var$AjaxError = function(_super) {
    $1ea9268d3f95d69b$var$__extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        this.response = $1ea9268d3f95d69b$var$parseXhrResponse(this.responseType, xhr);
    }
    return AjaxError;
}(Error);
module.exports.AjaxError = $1ea9268d3f95d69b$var$AjaxError;
function $1ea9268d3f95d69b$var$parseXhrResponse(responseType, xhr) {
    switch(responseType){
        case 'json':
            if ('response' in xhr) //IE does not support json as responseType, parse it internally
            return xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
            else // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return JSON.parse(xhr.responseText || 'null');
        case 'xml':
            return xhr.responseXML;
        case 'text':
        default:
            // HACK(benlesh): TypeScript shennanigans
            // tslint:disable-next-line:no-any latest TS seems to think xhr is "never" here.
            return 'response' in xhr ? xhr.response : xhr.responseText;
    }
}
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */ var $1ea9268d3f95d69b$var$AjaxTimeoutError = function(_super) {
    $1ea9268d3f95d69b$var$__extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}($1ea9268d3f95d69b$var$AjaxError);
module.exports.AjaxTimeoutError = $1ea9268d3f95d69b$var$AjaxTimeoutError;

});



parcelRegister("i4MRD", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $lC7sD = parcelRequire("lC7sD");
$b0T1M.Observable.webSocket = $lC7sD.webSocket;

});
parcelRegister("lC7sD", function(module, exports) {
$parcel$export(module.exports, "webSocket", () => $fbc2ef28e6c8680a$export$debf5095acd2163f, (v) => $fbc2ef28e6c8680a$export$debf5095acd2163f = v);
var $fbc2ef28e6c8680a$export$debf5095acd2163f;
"use strict";

var $9k4t3 = parcelRequire("9k4t3");
$fbc2ef28e6c8680a$export$debf5095acd2163f = $9k4t3.WebSocketSubject.create;

});
parcelRegister("9k4t3", function(module, exports) {
"use strict";
var $6c9972809a9e5a24$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $kVbBc = parcelRequire("kVbBc");

var $b0T1M = parcelRequire("b0T1M");

var $cGvOX = parcelRequire("cGvOX");

var $jYFjc = parcelRequire("jYFjc");

var $gNLuz = parcelRequire("gNLuz");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $lF26U = parcelRequire("lF26U");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $6c9972809a9e5a24$var$WebSocketSubject = function(_super) {
    $6c9972809a9e5a24$var$__extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof $b0T1M.Observable) _super.call(this, destination, urlConfigOrSource);
        else {
            _super.call(this);
            this.WebSocketCtor = $jYFjc.root.WebSocket;
            this._output = new $hJCZY.Subject();
            if (typeof urlConfigOrSource === 'string') this.url = urlConfigOrSource;
            else // WARNING: config object could override important members here.
            $lF26U.assign(this, urlConfigOrSource);
            if (!this.WebSocketCtor) throw new Error('no WebSocket constructor can be found');
            this.destination = new $gNLuz.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function(e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */ WebSocketSubject.create = function(urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function(operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function() {
        this.socket = null;
        if (!this.source) this.destination = new $gNLuz.ReplaySubject();
        this._output = new $hJCZY.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function(subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new $b0T1M.Observable(function(observer) {
            var result = $3kkLM.tryCatch(subMsg)();
            if (result === $geExo.errorObject) observer.error($geExo.errorObject.e);
            else self.next(result);
            var subscription = self.subscribe(function(x) {
                var result = $3kkLM.tryCatch(messageFilter)(x);
                if (result === $geExo.errorObject) observer.error($geExo.errorObject.e);
                else if (result) observer.next(x);
            }, function(err) {
                return observer.error(err);
            }, function() {
                return observer.complete();
            });
            return function() {
                var result = $3kkLM.tryCatch(unsubMsg)();
                if (result === $geExo.errorObject) observer.error($geExo.errorObject.e);
                else self.next(result);
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function() {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ? new WebSocketCtor(this.url, this.protocol) : new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) this.socket.binaryType = this.binaryType;
        } catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new $cGvOX.Subscription(function() {
            _this.socket = null;
            if (socket && socket.readyState === 1) socket.close();
        });
        socket.onopen = function(e) {
            var openObserver = _this.openObserver;
            if (openObserver) openObserver.next(e);
            var queue = _this.destination;
            _this.destination = $kVbBc.Subscriber.create(function(x) {
                return socket.readyState === 1 && socket.send(x);
            }, function(e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                if (e && e.code) socket.close(e.code, e.reason);
                else observer.error(new TypeError("WebSocketSubject.error must be called with an object with an error code, and an optional reason: { code: number, reason: string }"));
                _this._resetState();
            }, function() {
                var closingObserver = _this.closingObserver;
                if (closingObserver) closingObserver.next(undefined);
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof $gNLuz.ReplaySubject) subscription.add(queue.subscribe(_this.destination));
        };
        socket.onerror = function(e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function(e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) closeObserver.next(e);
            if (e.wasClean) observer.complete();
            else observer.error(e);
        };
        socket.onmessage = function(e) {
            var result = $3kkLM.tryCatch(_this.resultSelector)(e);
            if (result === $geExo.errorObject) observer.error($geExo.errorObject.e);
            else observer.next(result);
        };
    };
    /** @deprecated internal use only */ WebSocketSubject.prototype._subscribe = function(subscriber) {
        var _this = this;
        var source = this.source;
        if (source) return source.subscribe(subscriber);
        if (!this.socket) this._connectSocket();
        var subscription = new $cGvOX.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function() {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) socket.close();
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function() {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) this.destination = new $gNLuz.ReplaySubject();
    };
    return WebSocketSubject;
}($hJCZY.AnonymousSubject);
module.exports.WebSocketSubject = $6c9972809a9e5a24$var$WebSocketSubject;

});
parcelRegister("lF26U", function(module, exports) {
$parcel$export(module.exports, "assign", () => $fc4f106c709f8e8d$export$e6e34fd1f2686227, (v) => $fc4f106c709f8e8d$export$e6e34fd1f2686227 = v);
var $fc4f106c709f8e8d$export$b668effad3120ef4;
var $fc4f106c709f8e8d$export$e4f7f8fe212de33b;
var $fc4f106c709f8e8d$export$e6e34fd1f2686227;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
function $fc4f106c709f8e8d$var$assignImpl(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    var len = sources.length;
    for(var i = 0; i < len; i++){
        var source = sources[i];
        for(var k in source)if (source.hasOwnProperty(k)) target[k] = source[k];
    }
    return target;
}
$fc4f106c709f8e8d$export$b668effad3120ef4 = $fc4f106c709f8e8d$var$assignImpl;
function $fc4f106c709f8e8d$var$getAssign(root) {
    return root.Object.assign || $fc4f106c709f8e8d$var$assignImpl;
}
$fc4f106c709f8e8d$export$e4f7f8fe212de33b = $fc4f106c709f8e8d$var$getAssign;
$fc4f106c709f8e8d$export$e6e34fd1f2686227 = $fc4f106c709f8e8d$var$getAssign($jYFjc.root);

});




parcelRegister("aBouX", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $fFnWh = parcelRequire("fFnWh");
$b0T1M.Observable.prototype.buffer = $fFnWh.buffer;

});
parcelRegister("fFnWh", function(module, exports) {
$parcel$export(module.exports, "buffer", () => $b67d411fc1ac0857$export$ab1029bcae9ddb4a, (v) => $b67d411fc1ac0857$export$ab1029bcae9ddb4a = v);
var $b67d411fc1ac0857$export$ab1029bcae9ddb4a;
"use strict";

var $hr1kd = parcelRequire("hr1kd");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function $b67d411fc1ac0857$var$buffer(closingNotifier) {
    return $hr1kd.buffer(closingNotifier)(this);
}
$b67d411fc1ac0857$export$ab1029bcae9ddb4a = $b67d411fc1ac0857$var$buffer;

});
parcelRegister("hr1kd", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */ function buffer(closingNotifier) {
    return function bufferOperatorFunction(source) {
        return source.lift(new BufferOperator(closingNotifier));
    };
}
exports.buffer = buffer;
var BufferOperator = function() {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var BufferSubscriber = function(_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add($d3klE.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("dziYq", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $7S5oE = parcelRequire("7S5oE");
$b0T1M.Observable.prototype.bufferCount = $7S5oE.bufferCount;

});
parcelRegister("7S5oE", function(module, exports) {
$parcel$export(module.exports, "bufferCount", () => $5bb1c331ba96467e$export$8916d2c8119541bb, (v) => $5bb1c331ba96467e$export$8916d2c8119541bb = v);
var $5bb1c331ba96467e$export$8916d2c8119541bb;
"use strict";

var $5zaNb = parcelRequire("5zaNb");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */ function $5bb1c331ba96467e$var$bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    return $5zaNb.bufferCount(bufferSize, startBufferEvery)(this);
}
$5bb1c331ba96467e$export$8916d2c8119541bb = $5bb1c331ba96467e$var$bufferCount;

});


parcelRegister("c2pWB", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $26mpb = parcelRequire("26mpb");
$b0T1M.Observable.prototype.bufferTime = $26mpb.bufferTime;

});
parcelRegister("26mpb", function(module, exports) {
$parcel$export(module.exports, "bufferTime", () => $187d857cc6ac2eab$export$d6b40c95035461c7, (v) => $187d857cc6ac2eab$export$d6b40c95035461c7 = v);
var $187d857cc6ac2eab$export$d6b40c95035461c7;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $6eaCl = parcelRequire("6eaCl");

var $hg0kO = parcelRequire("hg0kO");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $187d857cc6ac2eab$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $hBoCS.async;
    if ($6eaCl.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return $hg0kO.bufferTime(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler)(this);
}
$187d857cc6ac2eab$export$d6b40c95035461c7 = $187d857cc6ac2eab$var$bufferTime;

});
parcelRegister("hg0kO", function(module, exports) {
"use strict";
var $c90430c0f9812eb7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hBoCS = parcelRequire("hBoCS");

var $kVbBc = parcelRequire("kVbBc");

var $6eaCl = parcelRequire("6eaCl");
/* tslint:enable:max-line-length */ /**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */ function $c90430c0f9812eb7$var$bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = $hBoCS.async;
    if ($6eaCl.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) bufferCreationInterval = arguments[1];
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) maxBufferSize = arguments[2];
    return function bufferTimeOperatorFunction(source) {
        return source.lift(new $c90430c0f9812eb7$var$BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
    };
}
module.exports.bufferTime = $c90430c0f9812eb7$var$bufferTime;
var $c90430c0f9812eb7$var$BufferTimeOperator = function() {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c90430c0f9812eb7$var$BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}();
var $c90430c0f9812eb7$var$Context = function() {
    function Context() {
        this.buffer = [];
    }
    return Context;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c90430c0f9812eb7$var$BufferTimeSubscriber = function(_super) {
    $c90430c0f9812eb7$var$__extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = scheduler.schedule($c90430c0f9812eb7$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        } else {
            var closeState = {
                subscriber: this,
                context: context
            };
            var creationState = {
                bufferTimeSpan: bufferTimeSpan,
                bufferCreationInterval: bufferCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(context.closeAction = scheduler.schedule($c90430c0f9812eb7$var$dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule($c90430c0f9812eb7$var$dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for(var i = 0; i < len; i++){
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) filledBufferContext = context;
        }
        if (filledBufferContext) this.onBufferFull(filledBufferContext);
    };
    BufferTimeSubscriber.prototype._error = function(err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function() {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while(contexts.length > 0){
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferTimeSubscriber.prototype._unsubscribe = function() {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function(context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = {
                subscriber: this,
                context: context,
                bufferTimeSpan: bufferTimeSpan
            };
            this.add(context.closeAction = this.scheduler.schedule($c90430c0f9812eb7$var$dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function() {
        var context = new $c90430c0f9812eb7$var$Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function(context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) contexts.splice(contexts.indexOf(context), 1);
    };
    return BufferTimeSubscriber;
}($kVbBc.Subscriber);
function $c90430c0f9812eb7$var$dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) subscriber.closeContext(prevContext);
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function $c90430c0f9812eb7$var$dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule($c90430c0f9812eb7$var$dispatchBufferClose, bufferTimeSpan, {
            subscriber: subscriber,
            context: context
        }));
        action.schedule(state, bufferCreationInterval);
    }
}
function $c90430c0f9812eb7$var$dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}

});



parcelRegister("d9Umi", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $gbLZd = parcelRequire("gbLZd");
$b0T1M.Observable.prototype.bufferToggle = $gbLZd.bufferToggle;

});
parcelRegister("gbLZd", function(module, exports) {
$parcel$export(module.exports, "bufferToggle", () => $bc92e587c5bf54e3$export$91115bdd8709945f, (v) => $bc92e587c5bf54e3$export$91115bdd8709945f = v);
var $bc92e587c5bf54e3$export$91115bdd8709945f;
"use strict";

var $kHNXO = parcelRequire("kHNXO");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $bc92e587c5bf54e3$var$bufferToggle(openings, closingSelector) {
    return $kHNXO.bufferToggle(openings, closingSelector)(this);
}
$bc92e587c5bf54e3$export$91115bdd8709945f = $bc92e587c5bf54e3$var$bufferToggle;

});
parcelRegister("kHNXO", function(module, exports) {
"use strict";
var $f12e948ff3b6c293$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cGvOX = parcelRequire("cGvOX");

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */ function $f12e948ff3b6c293$var$bufferToggle(openings, closingSelector) {
    return function bufferToggleOperatorFunction(source) {
        return source.lift(new $f12e948ff3b6c293$var$BufferToggleOperator(openings, closingSelector));
    };
}
module.exports.bufferToggle = $f12e948ff3b6c293$var$bufferToggle;
var $f12e948ff3b6c293$var$BufferToggleOperator = function() {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $f12e948ff3b6c293$var$BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f12e948ff3b6c293$var$BufferToggleSubscriber = function(_super) {
    $f12e948ff3b6c293$var$__extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add($d3klE.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for(var i = 0; i < len; i++)contexts[i].buffer.push(value);
    };
    BufferToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        while(contexts.length > 0){
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function(innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function(value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) this.trySubscribe(closingNotifier);
        } catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function(context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function(closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new $cGvOX.Subscription();
        var context = {
            buffer: buffer,
            subscription: subscription
        };
        contexts.push(context);
        var innerSubscription = $d3klE.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) this.closeBuffer(context);
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("aex1Z", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $aIWWW = parcelRequire("aIWWW");
$b0T1M.Observable.prototype.bufferWhen = $aIWWW.bufferWhen;

});
parcelRegister("aIWWW", function(module, exports) {
$parcel$export(module.exports, "bufferWhen", () => $7cebbda342d57239$export$9e55760d3282e08c, (v) => $7cebbda342d57239$export$9e55760d3282e08c = v);
var $7cebbda342d57239$export$9e55760d3282e08c;
"use strict";

var $7VFgk = parcelRequire("7VFgk");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $7cebbda342d57239$var$bufferWhen(closingSelector) {
    return $7VFgk.bufferWhen(closingSelector)(this);
}
$7cebbda342d57239$export$9e55760d3282e08c = $7cebbda342d57239$var$bufferWhen;

});
parcelRegister("7VFgk", function(module, exports) {
"use strict";
var $5c5ddd23d3f0add1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cGvOX = parcelRequire("cGvOX");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */ function $5c5ddd23d3f0add1$var$bufferWhen(closingSelector) {
    return function(source) {
        return source.lift(new $5c5ddd23d3f0add1$var$BufferWhenOperator(closingSelector));
    };
}
module.exports.bufferWhen = $5c5ddd23d3f0add1$var$bufferWhen;
var $5c5ddd23d3f0add1$var$BufferWhenOperator = function() {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5c5ddd23d3f0add1$var$BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5c5ddd23d3f0add1$var$BufferWhenSubscriber = function(_super) {
    $5c5ddd23d3f0add1$var$__extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function(value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function() {
        var buffer = this.buffer;
        if (buffer) this.destination.next(buffer);
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ BufferWhenSubscriber.prototype._unsubscribe = function() {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function() {
        if (this.subscribing) this.complete();
        else this.openBuffer();
    };
    BufferWhenSubscriber.prototype.openBuffer = function() {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) this.destination.next(buffer);
        this.buffer = [];
        var closingNotifier = $3kkLM.tryCatch(this.closingSelector)();
        if (closingNotifier === $geExo.errorObject) this.error($geExo.errorObject.e);
        else {
            closingSubscription = new $cGvOX.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add($d3klE.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("FJQG9", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $l5Emi = parcelRequire("l5Emi");
$b0T1M.Observable.prototype.catch = $l5Emi._catch;
$b0T1M.Observable.prototype._catch = $l5Emi._catch;

});
parcelRegister("l5Emi", function(module, exports) {
$parcel$export(module.exports, "_catch", () => $f5a95ef6f4f1cf86$export$7f43fa37c3d8a0b3, (v) => $f5a95ef6f4f1cf86$export$7f43fa37c3d8a0b3 = v);
var $f5a95ef6f4f1cf86$export$7f43fa37c3d8a0b3;
"use strict";

var $aIlDy = parcelRequire("aIlDy");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */ function $f5a95ef6f4f1cf86$var$_catch(selector) {
    return $aIlDy.catchError(selector)(this);
}
$f5a95ef6f4f1cf86$export$7f43fa37c3d8a0b3 = $f5a95ef6f4f1cf86$var$_catch;

});
parcelRegister("aIlDy", function(module, exports) {
"use strict";
var $7ccecc1623770be3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $7ccecc1623770be3$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $7ccecc1623770be3$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $7ccecc1623770be3$var$catchError;
var $7ccecc1623770be3$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7ccecc1623770be3$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7ccecc1623770be3$var$CatchSubscriber = function(_super) {
    $7ccecc1623770be3$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($d3klE.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("YWjMu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $ieyXa = parcelRequire("ieyXa");
$b0T1M.Observable.prototype.combineAll = $ieyXa.combineAll;

});
parcelRegister("ieyXa", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $d464a5cdc8be7729$export$29ae691b7de52fe3, (v) => $d464a5cdc8be7729$export$29ae691b7de52fe3 = v);
var $d464a5cdc8be7729$export$29ae691b7de52fe3;
"use strict";

var $jLpnz = parcelRequire("jLpnz");
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */ function $d464a5cdc8be7729$var$combineAll(project) {
    return $jLpnz.combineAll(project)(this);
}
$d464a5cdc8be7729$export$29ae691b7de52fe3 = $d464a5cdc8be7729$var$combineAll;

});
parcelRegister("jLpnz", function(module, exports) {
$parcel$export(module.exports, "combineAll", () => $e63617e7d70ccfec$export$29ae691b7de52fe3, (v) => $e63617e7d70ccfec$export$29ae691b7de52fe3 = v);
var $e63617e7d70ccfec$export$29ae691b7de52fe3;
"use strict";

var $5ogow = parcelRequire("5ogow");
function $e63617e7d70ccfec$var$combineAll(project) {
    return function(source) {
        return source.lift(new $5ogow.CombineLatestOperator(project));
    };
}
$e63617e7d70ccfec$export$29ae691b7de52fe3 = $e63617e7d70ccfec$var$combineAll;

});



parcelRegister("46mvO", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $keJPA = parcelRequire("keJPA");
$b0T1M.Observable.prototype.combineLatest = $keJPA.combineLatest;

});
parcelRegister("keJPA", function(module, exports) {
$parcel$export(module.exports, "combineLatest", () => $ebb8aa87c38da9d8$export$77fa7d86f5204e8a, (v) => $ebb8aa87c38da9d8$export$77fa7d86f5204e8a = v);
var $ebb8aa87c38da9d8$export$77fa7d86f5204e8a;
"use strict";

var $5ogow = parcelRequire("5ogow");
/* tslint:enable:max-line-length */ /**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */ function $ebb8aa87c38da9d8$var$combineLatest() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $5ogow.combineLatest.apply(void 0, observables)(this);
}
$ebb8aa87c38da9d8$export$77fa7d86f5204e8a = $ebb8aa87c38da9d8$var$combineLatest;

});


parcelRegister("9PzFk", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $iCLow = parcelRequire("iCLow");
$b0T1M.Observable.prototype.concat = $iCLow.concat;

});
parcelRegister("iCLow", function(module, exports) {
$parcel$export(module.exports, "concat", () => $d8f08a2dbd932360$export$ee1b3e54f0441b22, (v) => $d8f08a2dbd932360$export$ee1b3e54f0441b22 = v);
var $d8f08a2dbd932360$export$9343b684b018b33a;
var $d8f08a2dbd932360$export$ee1b3e54f0441b22;
"use strict";

var $4j1zC = parcelRequire("4j1zC");

var $jd6MB = parcelRequire("jd6MB");
$d8f08a2dbd932360$export$9343b684b018b33a = $jd6MB.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $d8f08a2dbd932360$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $4j1zC.concat.apply(void 0, observables)(this);
}
$d8f08a2dbd932360$export$ee1b3e54f0441b22 = $d8f08a2dbd932360$var$concat;

});
parcelRegister("4j1zC", function(module, exports) {
$parcel$export(module.exports, "concat", () => $322a283a1a202a3b$export$ee1b3e54f0441b22, (v) => $322a283a1a202a3b$export$ee1b3e54f0441b22 = v);
var $322a283a1a202a3b$export$9343b684b018b33a;
var $322a283a1a202a3b$export$ee1b3e54f0441b22;
"use strict";

var $jd6MB = parcelRequire("jd6MB");

var $jd6MB = parcelRequire("jd6MB");
$322a283a1a202a3b$export$9343b684b018b33a = $jd6MB.concat;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */ function $322a283a1a202a3b$var$concat() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($jd6MB.concat.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$322a283a1a202a3b$export$ee1b3e54f0441b22 = $322a283a1a202a3b$var$concat;

});



parcelRegister("fnpO0", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $a3Wg4 = parcelRequire("a3Wg4");
$b0T1M.Observable.prototype.concatAll = $a3Wg4.concatAll;

});
parcelRegister("a3Wg4", function(module, exports) {
$parcel$export(module.exports, "concatAll", () => $75376016087a90d7$export$b314777ae20abca9, (v) => $75376016087a90d7$export$b314777ae20abca9 = v);
var $75376016087a90d7$export$b314777ae20abca9;
"use strict";

var $8kkVC = parcelRequire("8kkVC");
/* tslint:enable:max-line-length */ /**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */ function $75376016087a90d7$var$concatAll() {
    return $8kkVC.concatAll()(this);
}
$75376016087a90d7$export$b314777ae20abca9 = $75376016087a90d7$var$concatAll;

});


parcelRegister("7sblN", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $9MlJ8 = parcelRequire("9MlJ8");
$b0T1M.Observable.prototype.concatMap = $9MlJ8.concatMap;

});
parcelRegister("9MlJ8", function(module, exports) {
$parcel$export(module.exports, "concatMap", () => $71e9734c2b549f21$export$c28c8388be0ab31a, (v) => $71e9734c2b549f21$export$c28c8388be0ab31a = v);
var $71e9734c2b549f21$export$c28c8388be0ab31a;
"use strict";

var $1PoKX = parcelRequire("1PoKX");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */ function $71e9734c2b549f21$var$concatMap(project, resultSelector) {
    return $1PoKX.concatMap(project, resultSelector)(this);
}
$71e9734c2b549f21$export$c28c8388be0ab31a = $71e9734c2b549f21$var$concatMap;

});


parcelRegister("26QRx", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3w7Rw = parcelRequire("3w7Rw");
$b0T1M.Observable.prototype.concatMapTo = $3w7Rw.concatMapTo;

});
parcelRegister("3w7Rw", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $28fa758aca4ff8fe$export$82fbd7a2841d2484, (v) => $28fa758aca4ff8fe$export$82fbd7a2841d2484 = v);
var $28fa758aca4ff8fe$export$82fbd7a2841d2484;
"use strict";

var $iuoUD = parcelRequire("iuoUD");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $28fa758aca4ff8fe$var$concatMapTo(innerObservable, resultSelector) {
    return $iuoUD.concatMapTo(innerObservable, resultSelector)(this);
}
$28fa758aca4ff8fe$export$82fbd7a2841d2484 = $28fa758aca4ff8fe$var$concatMapTo;

});
parcelRegister("iuoUD", function(module, exports) {
$parcel$export(module.exports, "concatMapTo", () => $d75e5a6cfbe06eba$export$82fbd7a2841d2484, (v) => $d75e5a6cfbe06eba$export$82fbd7a2841d2484 = v);
var $d75e5a6cfbe06eba$export$82fbd7a2841d2484;
"use strict";

var $1PoKX = parcelRequire("1PoKX");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $d75e5a6cfbe06eba$var$concatMapTo(innerObservable, resultSelector) {
    return $1PoKX.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$d75e5a6cfbe06eba$export$82fbd7a2841d2484 = $d75e5a6cfbe06eba$var$concatMapTo;

});



parcelRegister("j1Ua9", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $2ZedK = parcelRequire("2ZedK");
$b0T1M.Observable.prototype.count = $2ZedK.count;

});
parcelRegister("2ZedK", function(module, exports) {
$parcel$export(module.exports, "count", () => $22cc4f35835cacea$export$85b9a36db797e02b, (v) => $22cc4f35835cacea$export$85b9a36db797e02b = v);
var $22cc4f35835cacea$export$85b9a36db797e02b;
"use strict";

var $8mnGO = parcelRequire("8mnGO");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function $22cc4f35835cacea$var$count(predicate) {
    return $8mnGO.count(predicate)(this);
}
$22cc4f35835cacea$export$85b9a36db797e02b = $22cc4f35835cacea$var$count;

});
parcelRegister("8mnGO", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("hcKjX", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $9pv7U = parcelRequire("9pv7U");
$b0T1M.Observable.prototype.dematerialize = $9pv7U.dematerialize;

});
parcelRegister("9pv7U", function(module, exports) {
$parcel$export(module.exports, "dematerialize", () => $6d9e97f03554252f$export$ab9a5985b741fa7a, (v) => $6d9e97f03554252f$export$ab9a5985b741fa7a = v);
var $6d9e97f03554252f$export$ab9a5985b741fa7a;
"use strict";

var $chUQD = parcelRequire("chUQD");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $6d9e97f03554252f$var$dematerialize() {
    return $chUQD.dematerialize()(this);
}
$6d9e97f03554252f$export$ab9a5985b741fa7a = $6d9e97f03554252f$var$dematerialize;

});
parcelRegister("chUQD", function(module, exports) {
"use strict";
var $8f232b6758e5d3b0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $8f232b6758e5d3b0$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $8f232b6758e5d3b0$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $8f232b6758e5d3b0$var$dematerialize;
var $8f232b6758e5d3b0$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8f232b6758e5d3b0$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8f232b6758e5d3b0$var$DeMaterializeSubscriber = function(_super) {
    $8f232b6758e5d3b0$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("iXQTj", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $fLy4t = parcelRequire("fLy4t");
$b0T1M.Observable.prototype.debounce = $fLy4t.debounce;

});
parcelRegister("fLy4t", function(module, exports) {
$parcel$export(module.exports, "debounce", () => $b7a5ac99d4771c7c$export$61fc7d43ac8f84b0, (v) => $b7a5ac99d4771c7c$export$61fc7d43ac8f84b0 = v);
var $b7a5ac99d4771c7c$export$61fc7d43ac8f84b0;
"use strict";

var $cKr74 = parcelRequire("cKr74");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $b7a5ac99d4771c7c$var$debounce(durationSelector) {
    return $cKr74.debounce(durationSelector)(this);
}
$b7a5ac99d4771c7c$export$61fc7d43ac8f84b0 = $b7a5ac99d4771c7c$var$debounce;

});
parcelRegister("cKr74", function(module, exports) {
"use strict";
var $947ed0038fc854d2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */ function $947ed0038fc854d2$var$debounce(durationSelector) {
    return function(source) {
        return source.lift(new $947ed0038fc854d2$var$DebounceOperator(durationSelector));
    };
}
module.exports.debounce = $947ed0038fc854d2$var$debounce;
var $947ed0038fc854d2$var$DebounceOperator = function() {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $947ed0038fc854d2$var$DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $947ed0038fc854d2$var$DebounceSubscriber = function(_super) {
    $947ed0038fc854d2$var$__extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function(value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) this._tryNext(value, result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function() {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function(value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = $d3klE.subscribeToResult(this, duration);
        if (!subscription.closed) this.add(this.durationSubscription = subscription);
    };
    DebounceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("ci1Jm", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $edK6X = parcelRequire("edK6X");
$b0T1M.Observable.prototype.debounceTime = $edK6X.debounceTime;

});
parcelRegister("edK6X", function(module, exports) {
$parcel$export(module.exports, "debounceTime", () => $a5a60c4cee8657ed$export$7843a4469d64c07e, (v) => $a5a60c4cee8657ed$export$7843a4469d64c07e = v);
var $a5a60c4cee8657ed$export$7843a4469d64c07e;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $bEZYz = parcelRequire("bEZYz");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $a5a60c4cee8657ed$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $bEZYz.debounceTime(dueTime, scheduler)(this);
}
$a5a60c4cee8657ed$export$7843a4469d64c07e = $a5a60c4cee8657ed$var$debounceTime;

});
parcelRegister("bEZYz", function(module, exports) {
"use strict";
var $87d381480e29befe$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $hBoCS = parcelRequire("hBoCS");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $87d381480e29befe$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return function(source) {
        return source.lift(new $87d381480e29befe$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $87d381480e29befe$var$debounceTime;
var $87d381480e29befe$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $87d381480e29befe$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $87d381480e29befe$var$DebounceTimeSubscriber = function(_super) {
    $87d381480e29befe$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($87d381480e29befe$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($kVbBc.Subscriber);
function $87d381480e29befe$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});



parcelRegister("5KXIn", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $jCqam = parcelRequire("jCqam");
$b0T1M.Observable.prototype.defaultIfEmpty = $jCqam.defaultIfEmpty;

});
parcelRegister("jCqam", function(module, exports) {
$parcel$export(module.exports, "defaultIfEmpty", () => $e485dcfcb4e2b4db$export$e4ca6d7b7a6dcf9b, (v) => $e485dcfcb4e2b4db$export$e4ca6d7b7a6dcf9b = v);
var $e485dcfcb4e2b4db$export$e4ca6d7b7a6dcf9b;
"use strict";

var $gSfoM = parcelRequire("gSfoM");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $e485dcfcb4e2b4db$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return $gSfoM.defaultIfEmpty(defaultValue)(this);
}
$e485dcfcb4e2b4db$export$e4ca6d7b7a6dcf9b = $e485dcfcb4e2b4db$var$defaultIfEmpty;

});
parcelRegister("gSfoM", function(module, exports) {
"use strict";
var $c48da25afb3ef46d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $c48da25afb3ef46d$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $c48da25afb3ef46d$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $c48da25afb3ef46d$var$defaultIfEmpty;
var $c48da25afb3ef46d$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c48da25afb3ef46d$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c48da25afb3ef46d$var$DefaultIfEmptySubscriber = function(_super) {
    $c48da25afb3ef46d$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("bV9X7", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $7gzfq = parcelRequire("7gzfq");
$b0T1M.Observable.prototype.delay = $7gzfq.delay;

});
parcelRegister("7gzfq", function(module, exports) {
$parcel$export(module.exports, "delay", () => $54a55e7c07a16d55$export$1391212d75b2ee65, (v) => $54a55e7c07a16d55$export$1391212d75b2ee65 = v);
var $54a55e7c07a16d55$export$1391212d75b2ee65;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $k2Kkr = parcelRequire("k2Kkr");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function $54a55e7c07a16d55$var$delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $k2Kkr.delay(delay, scheduler)(this);
}
$54a55e7c07a16d55$export$1391212d75b2ee65 = $54a55e7c07a16d55$var$delay;

});
parcelRegister("k2Kkr", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hBoCS = parcelRequire("hBoCS");

var $lrUXm = parcelRequire("lrUXm");

var $kVbBc = parcelRequire("kVbBc");

var $lnB2i = parcelRequire("lnB2i");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    var absoluteDelay = $lrUXm.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($lnB2i.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($lnB2i.Notification.createComplete());
    };
    return DelaySubscriber;
}($kVbBc.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});



parcelRegister("kgThj", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $kz26R = parcelRequire("kz26R");
$b0T1M.Observable.prototype.delayWhen = $kz26R.delayWhen;

});
parcelRegister("kz26R", function(module, exports) {
$parcel$export(module.exports, "delayWhen", () => $ef88b677f4836ad1$export$286ca829307725c9, (v) => $ef88b677f4836ad1$export$286ca829307725c9 = v);
var $ef88b677f4836ad1$export$286ca829307725c9;
"use strict";

var $8Hamk = parcelRequire("8Hamk");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $ef88b677f4836ad1$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    return $8Hamk.delayWhen(delayDurationSelector, subscriptionDelay)(this);
}
$ef88b677f4836ad1$export$286ca829307725c9 = $ef88b677f4836ad1$var$delayWhen;

});
parcelRegister("8Hamk", function(module, exports) {
"use strict";
var $654a5ffb25ae3022$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $b0T1M = parcelRequire("b0T1M");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $654a5ffb25ae3022$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $654a5ffb25ae3022$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $654a5ffb25ae3022$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $654a5ffb25ae3022$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $654a5ffb25ae3022$var$delayWhen;
var $654a5ffb25ae3022$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $654a5ffb25ae3022$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $654a5ffb25ae3022$var$DelayWhenSubscriber = function(_super) {
    $654a5ffb25ae3022$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $d3klE.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($5XpGv.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $654a5ffb25ae3022$var$SubscriptionDelayObservable = function(_super) {
    $654a5ffb25ae3022$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $654a5ffb25ae3022$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($b0T1M.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $654a5ffb25ae3022$var$SubscriptionDelaySubscriber = function(_super) {
    $654a5ffb25ae3022$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("kKPzV", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $1YW0N = parcelRequire("1YW0N");
$b0T1M.Observable.prototype.distinct = $1YW0N.distinct;

});
parcelRegister("1YW0N", function(module, exports) {
$parcel$export(module.exports, "distinct", () => $171864f8353402d5$export$983a3b5fb2f7202e, (v) => $171864f8353402d5$export$983a3b5fb2f7202e = v);
var $171864f8353402d5$export$983a3b5fb2f7202e;
"use strict";

var $dZudP = parcelRequire("dZudP");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $171864f8353402d5$var$distinct(keySelector, flushes) {
    return $dZudP.distinct(keySelector, flushes)(this);
}
$171864f8353402d5$export$983a3b5fb2f7202e = $171864f8353402d5$var$distinct;

});
parcelRegister("dZudP", function(module, exports) {
"use strict";
var $a2f86a5074ee043d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");

var $6FWIm = parcelRequire("6FWIm");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $a2f86a5074ee043d$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $a2f86a5074ee043d$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $a2f86a5074ee043d$var$distinct;
var $a2f86a5074ee043d$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a2f86a5074ee043d$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a2f86a5074ee043d$var$DistinctSubscriber = function(_super) {
    $a2f86a5074ee043d$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $6FWIm.Set();
        if (flushes) this.add($d3klE.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.DistinctSubscriber = $a2f86a5074ee043d$var$DistinctSubscriber;

});
parcelRegister("6FWIm", function(module, exports) {
$parcel$export(module.exports, "Set", () => $4dc41de1fec6d481$export$bdf4ff5a442cbbc5, (v) => $4dc41de1fec6d481$export$bdf4ff5a442cbbc5 = v);
var $4dc41de1fec6d481$export$ac57f2e66ff143c0;
var $4dc41de1fec6d481$export$bdf4ff5a442cbbc5;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
function $4dc41de1fec6d481$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$4dc41de1fec6d481$export$ac57f2e66ff143c0 = $4dc41de1fec6d481$var$minimalSetImpl;
$4dc41de1fec6d481$export$bdf4ff5a442cbbc5 = $jYFjc.root.Set || $4dc41de1fec6d481$var$minimalSetImpl();

});




parcelRegister("cGJbR", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $4ySTS = parcelRequire("4ySTS");
$b0T1M.Observable.prototype.distinctUntilChanged = $4ySTS.distinctUntilChanged;

});
parcelRegister("4ySTS", function(module, exports) {
$parcel$export(module.exports, "distinctUntilChanged", () => $3524ec6d67400813$export$779c5fb865a0172e, (v) => $3524ec6d67400813$export$779c5fb865a0172e = v);
var $3524ec6d67400813$export$779c5fb865a0172e;
"use strict";

var $ewuYL = parcelRequire("ewuYL");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $3524ec6d67400813$var$distinctUntilChanged(compare, keySelector) {
    return $ewuYL.distinctUntilChanged(compare, keySelector)(this);
}
$3524ec6d67400813$export$779c5fb865a0172e = $3524ec6d67400813$var$distinctUntilChanged;

});
parcelRegister("ewuYL", function(module, exports) {
"use strict";
var $a92c15a73f3b6f9c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $a92c15a73f3b6f9c$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $a92c15a73f3b6f9c$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $a92c15a73f3b6f9c$var$distinctUntilChanged;
var $a92c15a73f3b6f9c$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a92c15a73f3b6f9c$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a92c15a73f3b6f9c$var$DistinctUntilChangedSubscriber = function(_super) {
    $a92c15a73f3b6f9c$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $3kkLM.tryCatch(this.keySelector)(value);
            if (key === $geExo.errorObject) return this.destination.error($geExo.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $3kkLM.tryCatch(this.compare)(this.key, key);
            if (result === $geExo.errorObject) return this.destination.error($geExo.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("cFJOJ", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3sddT = parcelRequire("3sddT");
$b0T1M.Observable.prototype.distinctUntilKeyChanged = $3sddT.distinctUntilKeyChanged;

});
parcelRegister("3sddT", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $283e3e71714199dc$export$571da16e28367bde, (v) => $283e3e71714199dc$export$571da16e28367bde = v);
var $283e3e71714199dc$export$571da16e28367bde;
"use strict";

var $9WAUY = parcelRequire("9WAUY");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $283e3e71714199dc$var$distinctUntilKeyChanged(key, compare) {
    return $9WAUY.distinctUntilKeyChanged(key, compare)(this);
}
$283e3e71714199dc$export$571da16e28367bde = $283e3e71714199dc$var$distinctUntilKeyChanged;

});
parcelRegister("9WAUY", function(module, exports) {
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $73d62afe58d68dd6$export$571da16e28367bde, (v) => $73d62afe58d68dd6$export$571da16e28367bde = v);
var $73d62afe58d68dd6$export$571da16e28367bde;
"use strict";

var $ewuYL = parcelRequire("ewuYL");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $73d62afe58d68dd6$var$distinctUntilKeyChanged(key, compare) {
    return $ewuYL.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$73d62afe58d68dd6$export$571da16e28367bde = $73d62afe58d68dd6$var$distinctUntilKeyChanged;

});



parcelRegister("ihAqs", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $aJlvj = parcelRequire("aJlvj");
$b0T1M.Observable.prototype.do = $aJlvj._do;
$b0T1M.Observable.prototype._do = $aJlvj._do;

});
parcelRegister("aJlvj", function(module, exports) {
$parcel$export(module.exports, "_do", () => $7cfec99c7f9fa97e$export$6e1c2ce23f3c9991, (v) => $7cfec99c7f9fa97e$export$6e1c2ce23f3c9991 = v);
var $7cfec99c7f9fa97e$export$6e1c2ce23f3c9991;
"use strict";

var $kcvp1 = parcelRequire("kcvp1");
/* tslint:enable:max-line-length */ /**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source as long as errors don't occur.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */ function $7cfec99c7f9fa97e$var$_do(nextOrObserver, error, complete) {
    return $kcvp1.tap(nextOrObserver, error, complete)(this);
}
$7cfec99c7f9fa97e$export$6e1c2ce23f3c9991 = $7cfec99c7f9fa97e$var$_do;

});


parcelRegister("4G3Bo", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $61UrG = parcelRequire("61UrG");
$b0T1M.Observable.prototype.exhaust = $61UrG.exhaust;

});
parcelRegister("61UrG", function(module, exports) {
$parcel$export(module.exports, "exhaust", () => $463e9efb7bb32845$export$31039f1fbd797b9c, (v) => $463e9efb7bb32845$export$31039f1fbd797b9c = v);
var $463e9efb7bb32845$export$31039f1fbd797b9c;
"use strict";

var $kqNeR = parcelRequire("kqNeR");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $463e9efb7bb32845$var$exhaust() {
    return $kqNeR.exhaust()(this);
}
$463e9efb7bb32845$export$31039f1fbd797b9c = $463e9efb7bb32845$var$exhaust;

});
parcelRegister("kqNeR", function(module, exports) {
"use strict";
var $edfc6e24e9e1a0d7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $edfc6e24e9e1a0d7$var$exhaust() {
    return function(source) {
        return source.lift(new $edfc6e24e9e1a0d7$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $edfc6e24e9e1a0d7$var$exhaust;
var $edfc6e24e9e1a0d7$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $edfc6e24e9e1a0d7$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $edfc6e24e9e1a0d7$var$SwitchFirstSubscriber = function(_super) {
    $edfc6e24e9e1a0d7$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($d3klE.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("lnB8I", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $efM2I = parcelRequire("efM2I");
$b0T1M.Observable.prototype.exhaustMap = $efM2I.exhaustMap;

});
parcelRegister("efM2I", function(module, exports) {
$parcel$export(module.exports, "exhaustMap", () => $a607bbb677afce17$export$d70d492cd31004c0, (v) => $a607bbb677afce17$export$d70d492cd31004c0 = v);
var $a607bbb677afce17$export$d70d492cd31004c0;
"use strict";

var $g4djV = parcelRequire("g4djV");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $a607bbb677afce17$var$exhaustMap(project, resultSelector) {
    return $g4djV.exhaustMap(project, resultSelector)(this);
}
$a607bbb677afce17$export$d70d492cd31004c0 = $a607bbb677afce17$var$exhaustMap;

});
parcelRegister("g4djV", function(module, exports) {
"use strict";
var $bb275a37d66ee88a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000).take(5));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */ function $bb275a37d66ee88a$var$exhaustMap(project, resultSelector) {
    return function(source) {
        return source.lift(new $bb275a37d66ee88a$var$SwitchFirstMapOperator(project, resultSelector));
    };
}
module.exports.exhaustMap = $bb275a37d66ee88a$var$exhaustMap;
var $bb275a37d66ee88a$var$SwitchFirstMapOperator = function() {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $bb275a37d66ee88a$var$SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $bb275a37d66ee88a$var$SwitchFirstMapSubscriber = function(_super) {
    $bb275a37d66ee88a$var$__extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) this.tryNext(value);
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function(value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add($d3klE.subscribeToResult(this, result, value, index));
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        } catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstMapSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("1OpKX", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $iiIsg = parcelRequire("iiIsg");
$b0T1M.Observable.prototype.expand = $iiIsg.expand;

});
parcelRegister("iiIsg", function(module, exports) {
$parcel$export(module.exports, "expand", () => $d52c6441b13de15a$export$9f77e0932fb78f72, (v) => $d52c6441b13de15a$export$9f77e0932fb78f72 = v);
var $d52c6441b13de15a$export$9f77e0932fb78f72;
"use strict";

var $324xV = parcelRequire("324xV");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $d52c6441b13de15a$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return $324xV.expand(project, concurrent, scheduler)(this);
}
$d52c6441b13de15a$export$9f77e0932fb78f72 = $d52c6441b13de15a$var$expand;

});
parcelRegister("324xV", function(module, exports) {
"use strict";
var $235515c7f0f1c3c1$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $235515c7f0f1c3c1$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $235515c7f0f1c3c1$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $235515c7f0f1c3c1$var$expand;
var $235515c7f0f1c3c1$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $235515c7f0f1c3c1$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $235515c7f0f1c3c1$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $235515c7f0f1c3c1$var$ExpandSubscriber = function(_super) {
    $235515c7f0f1c3c1$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $3kkLM.tryCatch(this.project)(value, index);
            if (result === $geExo.errorObject) destination.error($geExo.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($d3klE.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.ExpandSubscriber = $235515c7f0f1c3c1$var$ExpandSubscriber;

});



parcelRegister("g3UBU", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $9wW1T = parcelRequire("9wW1T");
$b0T1M.Observable.prototype.elementAt = $9wW1T.elementAt;

});
parcelRegister("9wW1T", function(module, exports) {
$parcel$export(module.exports, "elementAt", () => $6f041da9f480b092$export$91d69c7761a17bbc, (v) => $6f041da9f480b092$export$91d69c7761a17bbc = v);
var $6f041da9f480b092$export$91d69c7761a17bbc;
"use strict";

var $eL9fi = parcelRequire("eL9fi");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $6f041da9f480b092$var$elementAt(index, defaultValue) {
    return $eL9fi.elementAt(index, defaultValue)(this);
}
$6f041da9f480b092$export$91d69c7761a17bbc = $6f041da9f480b092$var$elementAt;

});
parcelRegister("eL9fi", function(module, exports) {
"use strict";
var $abeca080c1d66ca3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $9pTpk = parcelRequire("9pTpk");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $abeca080c1d66ca3$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $abeca080c1d66ca3$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $abeca080c1d66ca3$var$elementAt;
var $abeca080c1d66ca3$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $9pTpk.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $abeca080c1d66ca3$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $abeca080c1d66ca3$var$ElementAtSubscriber = function(_super) {
    $abeca080c1d66ca3$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $9pTpk.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($kVbBc.Subscriber);

});
parcelRegister("9pTpk", function(module, exports) {
"use strict";
var $6db16d9d08c772fa$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $6db16d9d08c772fa$var$ArgumentOutOfRangeError = function(_super) {
    $6db16d9d08c772fa$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $6db16d9d08c772fa$var$ArgumentOutOfRangeError;

});




parcelRegister("9INLY", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $883aF = parcelRequire("883aF");
$b0T1M.Observable.prototype.filter = $883aF.filter;

});

parcelRegister("kcOq1", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $haIVQ = parcelRequire("haIVQ");
$b0T1M.Observable.prototype.finally = $haIVQ._finally;
$b0T1M.Observable.prototype._finally = $haIVQ._finally;

});
parcelRegister("haIVQ", function(module, exports) {
$parcel$export(module.exports, "_finally", () => $c80639644e173359$export$f6224470e4cea3fa, (v) => $c80639644e173359$export$f6224470e4cea3fa = v);
var $c80639644e173359$export$f6224470e4cea3fa;
"use strict";

var $6d9Bs = parcelRequire("6d9Bs");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $c80639644e173359$var$_finally(callback) {
    return $6d9Bs.finalize(callback)(this);
}
$c80639644e173359$export$f6224470e4cea3fa = $c80639644e173359$var$_finally;

});
parcelRegister("6d9Bs", function(module, exports) {
"use strict";
var $485b67ef61b6348b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $cGvOX = parcelRequire("cGvOX");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */ function $485b67ef61b6348b$var$finalize(callback) {
    return function(source) {
        return source.lift(new $485b67ef61b6348b$var$FinallyOperator(callback));
    };
}
module.exports.finalize = $485b67ef61b6348b$var$finalize;
var $485b67ef61b6348b$var$FinallyOperator = function() {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $485b67ef61b6348b$var$FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $485b67ef61b6348b$var$FinallySubscriber = function(_super) {
    $485b67ef61b6348b$var$__extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new $cGvOX.Subscription(callback));
    }
    return FinallySubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("immO9", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3hh9Z = parcelRequire("3hh9Z");
$b0T1M.Observable.prototype.find = $3hh9Z.find;

});
parcelRegister("3hh9Z", function(module, exports) {
$parcel$export(module.exports, "find", () => $2630454742f7be11$export$71aa6c912b956294, (v) => $2630454742f7be11$export$71aa6c912b956294 = v);
var $2630454742f7be11$export$71aa6c912b956294;
"use strict";

var $eoI2r = parcelRequire("eoI2r");
/* tslint:enable:max-line-length */ /**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $2630454742f7be11$var$find(predicate, thisArg) {
    return $eoI2r.find(predicate, thisArg)(this);
}
$2630454742f7be11$export$71aa6c912b956294 = $2630454742f7be11$var$find;

});
parcelRegister("eoI2r", function(module, exports) {
"use strict";
var $a7b577b4c4bd22d8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $a7b577b4c4bd22d8$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $a7b577b4c4bd22d8$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $a7b577b4c4bd22d8$var$find;
var $a7b577b4c4bd22d8$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $a7b577b4c4bd22d8$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $a7b577b4c4bd22d8$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a7b577b4c4bd22d8$var$FindValueSubscriber = function(_super) {
    $a7b577b4c4bd22d8$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($kVbBc.Subscriber);
module.exports.FindValueSubscriber = $a7b577b4c4bd22d8$var$FindValueSubscriber;

});



parcelRegister("ir8ja", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $41Iez = parcelRequire("41Iez");
$b0T1M.Observable.prototype.findIndex = $41Iez.findIndex;

});
parcelRegister("41Iez", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $2ee9916176cad83a$export$de3a4d4a0d731119, (v) => $2ee9916176cad83a$export$de3a4d4a0d731119 = v);
var $2ee9916176cad83a$export$de3a4d4a0d731119;
"use strict";

var $5LQnN = parcelRequire("5LQnN");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $2ee9916176cad83a$var$findIndex(predicate, thisArg) {
    return $5LQnN.findIndex(predicate, thisArg)(this);
}
$2ee9916176cad83a$export$de3a4d4a0d731119 = $2ee9916176cad83a$var$findIndex;

});
parcelRegister("5LQnN", function(module, exports) {
$parcel$export(module.exports, "findIndex", () => $4339f9b1303bb9d5$export$de3a4d4a0d731119, (v) => $4339f9b1303bb9d5$export$de3a4d4a0d731119 = v);
var $4339f9b1303bb9d5$export$de3a4d4a0d731119;
"use strict";

var $eoI2r = parcelRequire("eoI2r");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $4339f9b1303bb9d5$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $eoI2r.FindValueOperator(predicate, source, true, thisArg));
    };
}
$4339f9b1303bb9d5$export$de3a4d4a0d731119 = $4339f9b1303bb9d5$var$findIndex;

});



parcelRegister("1wQyG", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $azbmj = parcelRequire("azbmj");
$b0T1M.Observable.prototype.first = $azbmj.first;

});
parcelRegister("azbmj", function(module, exports) {
$parcel$export(module.exports, "first", () => $7b15fbebf0d104cd$export$43128fadae87b74a, (v) => $7b15fbebf0d104cd$export$43128fadae87b74a = v);
var $7b15fbebf0d104cd$export$43128fadae87b74a;
"use strict";

var $kX41W = parcelRequire("kX41W");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $7b15fbebf0d104cd$var$first(predicate, resultSelector, defaultValue) {
    return $kX41W.first(predicate, resultSelector, defaultValue)(this);
}
$7b15fbebf0d104cd$export$43128fadae87b74a = $7b15fbebf0d104cd$var$first;

});
parcelRegister("kX41W", function(module, exports) {
"use strict";
var $f40c71a5e3532cfc$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $7Aiqv = parcelRequire("7Aiqv");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */ function $f40c71a5e3532cfc$var$first(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $f40c71a5e3532cfc$var$FirstOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.first = $f40c71a5e3532cfc$var$first;
var $f40c71a5e3532cfc$var$FirstOperator = function() {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $f40c71a5e3532cfc$var$FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $f40c71a5e3532cfc$var$FirstSubscriber = function(_super) {
    $f40c71a5e3532cfc$var$__extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else this._emit(value, index);
    };
    FirstSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this._emit(value, index);
    };
    FirstSubscriber.prototype._emit = function(value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function(value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        } else if (!this.hasCompleted) destination.error(new $7Aiqv.EmptyError);
    };
    return FirstSubscriber;
}($kVbBc.Subscriber);

});
parcelRegister("7Aiqv", function(module, exports) {
"use strict";
var $585a304f0985bb13$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */ var $585a304f0985bb13$var$EmptyError = function(_super) {
    $585a304f0985bb13$var$__extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error);
module.exports.EmptyError = $585a304f0985bb13$var$EmptyError;

});




parcelRegister("is1Qo", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $lvLsg = parcelRequire("lvLsg");
$b0T1M.Observable.prototype.groupBy = $lvLsg.groupBy;

});
parcelRegister("lvLsg", function(module, exports) {
$parcel$export(module.exports, "groupBy", () => $fa914dc68210fe99$export$3f063810d7bf01bd, (v) => $fa914dc68210fe99$export$3f063810d7bf01bd = v);
var $fa914dc68210fe99$export$ff26824b3dc37d8c;
var $fa914dc68210fe99$export$3f063810d7bf01bd;
"use strict";

var $52ANt = parcelRequire("52ANt");
$fa914dc68210fe99$export$ff26824b3dc37d8c = $52ANt.GroupedObservable;
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $fa914dc68210fe99$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return $52ANt.groupBy(keySelector, elementSelector, durationSelector, subjectSelector)(this);
}
$fa914dc68210fe99$export$3f063810d7bf01bd = $fa914dc68210fe99$var$groupBy;

});
parcelRegister("52ANt", function(module, exports) {
"use strict";
var $3ab9aec37fbf65bf$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $cGvOX = parcelRequire("cGvOX");

var $b0T1M = parcelRequire("b0T1M");

var $hJCZY = parcelRequire("hJCZY");

var $c3c9k = parcelRequire("c3c9k");

var $hLCJk = parcelRequire("hLCJk");
/* tslint:enable:max-line-length */ /**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.name)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */ function $3ab9aec37fbf65bf$var$groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return function(source) {
        return source.lift(new $3ab9aec37fbf65bf$var$GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
    };
}
module.exports.groupBy = $3ab9aec37fbf65bf$var$groupBy;
var $3ab9aec37fbf65bf$var$GroupByOperator = function() {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3ab9aec37fbf65bf$var$GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3ab9aec37fbf65bf$var$GroupBySubscriber = function(_super) {
    $3ab9aec37fbf65bf$var$__extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function(value) {
        var key;
        try {
            key = this.keySelector(value);
        } catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function(value, key) {
        var groups = this.groups;
        if (!groups) groups = this.groups = typeof key === 'string' ? new $hLCJk.FastMap() : new $c3c9k.Map();
        var group = groups.get(key);
        var element;
        if (this.elementSelector) try {
            element = this.elementSelector(value);
        } catch (err) {
            this.error(err);
        }
        else element = value;
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new $hJCZY.Subject();
            groups.set(key, group);
            var groupedObservable = new $3ab9aec37fbf65bf$var$GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new $3ab9aec37fbf65bf$var$GroupedObservable(key, group));
                } catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new $3ab9aec37fbf65bf$var$GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) group.next(element);
    };
    GroupBySubscriber.prototype._error = function(err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function() {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function(group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function(key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) _super.prototype.unsubscribe.call(this);
        }
    };
    return GroupBySubscriber;
}($kVbBc.Subscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3ab9aec37fbf65bf$var$GroupDurationSubscriber = function(_super) {
    $3ab9aec37fbf65bf$var$__extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this, group);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function(value) {
        this.complete();
    };
    /** @deprecated internal use only */ GroupDurationSubscriber.prototype._unsubscribe = function() {
        var _a = this, parent = _a.parent, key = _a.key;
        this.key = this.parent = null;
        if (parent) parent.removeGroup(key);
    };
    return GroupDurationSubscriber;
}($kVbBc.Subscriber);
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */ var $3ab9aec37fbf65bf$var$GroupedObservable = function(_super) {
    $3ab9aec37fbf65bf$var$__extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    /** @deprecated internal use only */ GroupedObservable.prototype._subscribe = function(subscriber) {
        var subscription = new $cGvOX.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) subscription.add(new $3ab9aec37fbf65bf$var$InnerRefCountSubscription(refCountSubscription));
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}($b0T1M.Observable);
module.exports.GroupedObservable = $3ab9aec37fbf65bf$var$GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3ab9aec37fbf65bf$var$InnerRefCountSubscription = function(_super) {
    $3ab9aec37fbf65bf$var$__extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function() {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) parent.unsubscribe();
        }
    };
    return InnerRefCountSubscription;
}($cGvOX.Subscription);

});
parcelRegister("c3c9k", function(module, exports) {
$parcel$export(module.exports, "Map", () => $8c5f3075287663f9$export$a5c7b93649eaf8f8, (v) => $8c5f3075287663f9$export$a5c7b93649eaf8f8 = v);
var $8c5f3075287663f9$export$a5c7b93649eaf8f8;
"use strict";

var $jYFjc = parcelRequire("jYFjc");

var $e1WlT = parcelRequire("e1WlT");
$8c5f3075287663f9$export$a5c7b93649eaf8f8 = $jYFjc.root.Map || function() {
    return $e1WlT.MapPolyfill;
}();

});
parcelRegister("e1WlT", function(module, exports) {
$parcel$export(module.exports, "MapPolyfill", () => $a36e6c30a997d154$export$dd450425f6b4a07, (v) => $a36e6c30a997d154$export$dd450425f6b4a07 = v);
var $a36e6c30a997d154$export$dd450425f6b4a07;
"use strict";
var $a36e6c30a997d154$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function(key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function(key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        } else this._values[i] = value;
        return this;
    };
    MapPolyfill.prototype.delete = function(key) {
        var i = this._keys.indexOf(key);
        if (i === -1) return false;
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function() {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function(cb, thisArg) {
        for(var i = 0; i < this.size; i++)cb.call(thisArg, this._values[i], this._keys[i]);
    };
    return MapPolyfill;
}();
$a36e6c30a997d154$export$dd450425f6b4a07 = $a36e6c30a997d154$var$MapPolyfill;

});


parcelRegister("hLCJk", function(module, exports) {
$parcel$export(module.exports, "FastMap", () => $cef4de6bed0c07f8$export$d3f0a24774bb4055, (v) => $cef4de6bed0c07f8$export$d3f0a24774bb4055 = v);
var $cef4de6bed0c07f8$export$d3f0a24774bb4055;
"use strict";
var $cef4de6bed0c07f8$var$FastMap = function() {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function(key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function(key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function(key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function(cb, thisArg) {
        var values = this.values;
        for(var key in values)if (values.hasOwnProperty(key) && values[key] !== null) cb.call(thisArg, values[key], key);
    };
    FastMap.prototype.clear = function() {
        this.values = {};
    };
    return FastMap;
}();
$cef4de6bed0c07f8$export$d3f0a24774bb4055 = $cef4de6bed0c07f8$var$FastMap;

});




parcelRegister("VyJ7k", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $8gWY0 = parcelRequire("8gWY0");
$b0T1M.Observable.prototype.ignoreElements = $8gWY0.ignoreElements;

});
parcelRegister("8gWY0", function(module, exports) {
$parcel$export(module.exports, "ignoreElements", () => $605d8ef2100fc621$export$6953b97c7d866605, (v) => $605d8ef2100fc621$export$6953b97c7d866605 = v);
var $605d8ef2100fc621$export$6953b97c7d866605;
"use strict";

var $62rmE = parcelRequire("62rmE");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $605d8ef2100fc621$var$ignoreElements() {
    return $62rmE.ignoreElements()(this);
}
$605d8ef2100fc621$export$6953b97c7d866605 = $605d8ef2100fc621$var$ignoreElements;

});
parcelRegister("62rmE", function(module, exports) {
"use strict";
var $465827fadaa4d2f6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $kjljt = parcelRequire("kjljt");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */ function $465827fadaa4d2f6$var$ignoreElements() {
    return function ignoreElementsOperatorFunction(source) {
        return source.lift(new $465827fadaa4d2f6$var$IgnoreElementsOperator());
    };
}
module.exports.ignoreElements = $465827fadaa4d2f6$var$ignoreElements;
var $465827fadaa4d2f6$var$IgnoreElementsOperator = function() {
    function IgnoreElementsOperator() {}
    IgnoreElementsOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $465827fadaa4d2f6$var$IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $465827fadaa4d2f6$var$IgnoreElementsSubscriber = function(_super) {
    $465827fadaa4d2f6$var$__extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function(unused) {
        $kjljt.noop();
    };
    return IgnoreElementsSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("kHuyu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $9tnBc = parcelRequire("9tnBc");
$b0T1M.Observable.prototype.isEmpty = $9tnBc.isEmpty;

});
parcelRegister("9tnBc", function(module, exports) {
$parcel$export(module.exports, "isEmpty", () => $6e5920bede9f5240$export$dd1bc94b04021eeb, (v) => $6e5920bede9f5240$export$dd1bc94b04021eeb = v);
var $6e5920bede9f5240$export$dd1bc94b04021eeb;
"use strict";

var $fHW2m = parcelRequire("fHW2m");
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */ function $6e5920bede9f5240$var$isEmpty() {
    return $fHW2m.isEmpty()(this);
}
$6e5920bede9f5240$export$dd1bc94b04021eeb = $6e5920bede9f5240$var$isEmpty;

});
parcelRegister("fHW2m", function(module, exports) {
"use strict";
var $b6f7e42440769826$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
function $b6f7e42440769826$var$isEmpty() {
    return function(source) {
        return source.lift(new $b6f7e42440769826$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $b6f7e42440769826$var$isEmpty;
var $b6f7e42440769826$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $b6f7e42440769826$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b6f7e42440769826$var$IsEmptySubscriber = function(_super) {
    $b6f7e42440769826$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("5PWw5", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $2bv6c = parcelRequire("2bv6c");
$b0T1M.Observable.prototype.audit = $2bv6c.audit;

});
parcelRegister("2bv6c", function(module, exports) {
$parcel$export(module.exports, "audit", () => $1974bb774180a048$export$d779b02e6b68c3e8, (v) => $1974bb774180a048$export$d779b02e6b68c3e8 = v);
var $1974bb774180a048$export$d779b02e6b68c3e8;
"use strict";

var $ip0bJ = parcelRequire("ip0bJ");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $1974bb774180a048$var$audit(durationSelector) {
    return $ip0bJ.audit(durationSelector)(this);
}
$1974bb774180a048$export$d779b02e6b68c3e8 = $1974bb774180a048$var$audit;

});
parcelRegister("ip0bJ", function(module, exports) {
"use strict";
var $d65ab5268bd6a29d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $d65ab5268bd6a29d$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $d65ab5268bd6a29d$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $d65ab5268bd6a29d$var$audit;
var $d65ab5268bd6a29d$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d65ab5268bd6a29d$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d65ab5268bd6a29d$var$AuditSubscriber = function(_super) {
    $d65ab5268bd6a29d$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $3kkLM.tryCatch(this.durationSelector)(value);
            if (duration === $geExo.errorObject) this.destination.error($geExo.errorObject.e);
            else {
                var innerSubscription = $d3klE.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("3Wba3", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $5lmKe = parcelRequire("5lmKe");
$b0T1M.Observable.prototype.auditTime = $5lmKe.auditTime;

});
parcelRegister("5lmKe", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $3e408e8a283b7a5e$export$719c70722b10e5ff, (v) => $3e408e8a283b7a5e$export$719c70722b10e5ff = v);
var $3e408e8a283b7a5e$export$719c70722b10e5ff;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $8RG1P = parcelRequire("8RG1P");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $3e408e8a283b7a5e$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $8RG1P.auditTime(duration, scheduler)(this);
}
$3e408e8a283b7a5e$export$719c70722b10e5ff = $3e408e8a283b7a5e$var$auditTime;

});
parcelRegister("8RG1P", function(module, exports) {
$parcel$export(module.exports, "auditTime", () => $6743dfecbb088393$export$719c70722b10e5ff, (v) => $6743dfecbb088393$export$719c70722b10e5ff = v);
var $6743dfecbb088393$export$719c70722b10e5ff;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $ip0bJ = parcelRequire("ip0bJ");

var $1ARln = parcelRequire("1ARln");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $6743dfecbb088393$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $ip0bJ.audit(function() {
        return $1ARln.timer(duration, scheduler);
    });
}
$6743dfecbb088393$export$719c70722b10e5ff = $6743dfecbb088393$var$auditTime;

});



parcelRegister("a3PPT", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $h0Zj5 = parcelRequire("h0Zj5");
$b0T1M.Observable.prototype.last = $h0Zj5.last;

});
parcelRegister("h0Zj5", function(module, exports) {
$parcel$export(module.exports, "last", () => $c631fe01ac7360c1$export$4c7897fafd92b108, (v) => $c631fe01ac7360c1$export$4c7897fafd92b108 = v);
var $c631fe01ac7360c1$export$4c7897fafd92b108;
"use strict";

var $93L5V = parcelRequire("93L5V");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $c631fe01ac7360c1$var$last(predicate, resultSelector, defaultValue) {
    return $93L5V.last(predicate, resultSelector, defaultValue)(this);
}
$c631fe01ac7360c1$export$4c7897fafd92b108 = $c631fe01ac7360c1$var$last;

});
parcelRegister("93L5V", function(module, exports) {
"use strict";
var $6988ece3f05dea75$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $7Aiqv = parcelRequire("7Aiqv");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */ function $6988ece3f05dea75$var$last(predicate, resultSelector, defaultValue) {
    return function(source) {
        return source.lift(new $6988ece3f05dea75$var$LastOperator(predicate, resultSelector, defaultValue, source));
    };
}
module.exports.last = $6988ece3f05dea75$var$last;
var $6988ece3f05dea75$var$LastOperator = function() {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $6988ece3f05dea75$var$LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6988ece3f05dea75$var$LastSubscriber = function(_super) {
    $6988ece3f05dea75$var$__extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this._tryPredicate(value, index);
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function(value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function(value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        } else destination.error(new $7Aiqv.EmptyError);
    };
    return LastSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("lgRId", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $g08XA = parcelRequire("g08XA");
$b0T1M.Observable.prototype.let = $g08XA.letProto;
$b0T1M.Observable.prototype.letBind = $g08XA.letProto;

});
parcelRegister("g08XA", function(module, exports) {
$parcel$export(module.exports, "letProto", () => $ba6398b0605642ae$export$50696b801ff96e66, (v) => $ba6398b0605642ae$export$50696b801ff96e66 = v);
var $ba6398b0605642ae$export$50696b801ff96e66;
"use strict";
/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */ function $ba6398b0605642ae$var$letProto(func) {
    return func(this);
}
$ba6398b0605642ae$export$50696b801ff96e66 = $ba6398b0605642ae$var$letProto;

});


parcelRegister("kDnP4", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $jcCKu = parcelRequire("jcCKu");
$b0T1M.Observable.prototype.every = $jcCKu.every;

});
parcelRegister("jcCKu", function(module, exports) {
$parcel$export(module.exports, "every", () => $dfad3200f4ba44a6$export$7ecc1a3b11b57dab, (v) => $dfad3200f4ba44a6$export$7ecc1a3b11b57dab = v);
var $dfad3200f4ba44a6$export$7ecc1a3b11b57dab;
"use strict";

var $4gnel = parcelRequire("4gnel");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $dfad3200f4ba44a6$var$every(predicate, thisArg) {
    return $4gnel.every(predicate, thisArg)(this);
}
$dfad3200f4ba44a6$export$7ecc1a3b11b57dab = $dfad3200f4ba44a6$var$every;

});
parcelRegister("4gnel", function(module, exports) {
"use strict";
var $31aaad17293d0b1e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $31aaad17293d0b1e$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $31aaad17293d0b1e$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $31aaad17293d0b1e$var$every;
var $31aaad17293d0b1e$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $31aaad17293d0b1e$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $31aaad17293d0b1e$var$EverySubscriber = function(_super) {
    $31aaad17293d0b1e$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("bhZtn", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $2DnZi = parcelRequire("2DnZi");
$b0T1M.Observable.prototype.map = $2DnZi.map;

});

parcelRegister("1WHbF", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $l9vsW = parcelRequire("l9vsW");
$b0T1M.Observable.prototype.mapTo = $l9vsW.mapTo;

});
parcelRegister("l9vsW", function(module, exports) {
$parcel$export(module.exports, "mapTo", () => $f662d8b2664426bf$export$e0eaf3a86c03b2ad, (v) => $f662d8b2664426bf$export$e0eaf3a86c03b2ad = v);
var $f662d8b2664426bf$export$e0eaf3a86c03b2ad;
"use strict";

var $7jTXs = parcelRequire("7jTXs");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $f662d8b2664426bf$var$mapTo(value) {
    return $7jTXs.mapTo(value)(this);
}
$f662d8b2664426bf$export$e0eaf3a86c03b2ad = $f662d8b2664426bf$var$mapTo;

});
parcelRegister("7jTXs", function(module, exports) {
"use strict";
var $5545b6d84f01791b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */ function $5545b6d84f01791b$var$mapTo(value) {
    return function(source) {
        return source.lift(new $5545b6d84f01791b$var$MapToOperator(value));
    };
}
module.exports.mapTo = $5545b6d84f01791b$var$mapTo;
var $5545b6d84f01791b$var$MapToOperator = function() {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5545b6d84f01791b$var$MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5545b6d84f01791b$var$MapToSubscriber = function(_super) {
    $5545b6d84f01791b$var$__extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function(x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("5TcvX", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $8hF4s = parcelRequire("8hF4s");
$b0T1M.Observable.prototype.materialize = $8hF4s.materialize;

});
parcelRegister("8hF4s", function(module, exports) {
$parcel$export(module.exports, "materialize", () => $607fc50f8ba5e1b6$export$76dbd6ffd832405d, (v) => $607fc50f8ba5e1b6$export$76dbd6ffd832405d = v);
var $607fc50f8ba5e1b6$export$76dbd6ffd832405d;
"use strict";

var $2OD20 = parcelRequire("2OD20");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $607fc50f8ba5e1b6$var$materialize() {
    return $2OD20.materialize()(this);
}
$607fc50f8ba5e1b6$export$76dbd6ffd832405d = $607fc50f8ba5e1b6$var$materialize;

});
parcelRegister("2OD20", function(module, exports) {
"use strict";
var $20ce871abca3777d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $lnB2i = parcelRequire("lnB2i");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $20ce871abca3777d$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $20ce871abca3777d$var$MaterializeOperator());
    };
}
module.exports.materialize = $20ce871abca3777d$var$materialize;
var $20ce871abca3777d$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $20ce871abca3777d$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $20ce871abca3777d$var$MaterializeSubscriber = function(_super) {
    $20ce871abca3777d$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($lnB2i.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($lnB2i.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($lnB2i.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("aWBq9", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $l7mP2 = parcelRequire("l7mP2");
$b0T1M.Observable.prototype.max = $l7mP2.max;

});
parcelRegister("l7mP2", function(module, exports) {
$parcel$export(module.exports, "max", () => $f5fbf46c4045a6b8$export$8960430cfd85939f, (v) => $f5fbf46c4045a6b8$export$8960430cfd85939f = v);
var $f5fbf46c4045a6b8$export$8960430cfd85939f;
"use strict";

var $gI1rl = parcelRequire("gI1rl");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $f5fbf46c4045a6b8$var$max(comparer) {
    return $gI1rl.max(comparer)(this);
}
$f5fbf46c4045a6b8$export$8960430cfd85939f = $f5fbf46c4045a6b8$var$max;

});
parcelRegister("gI1rl", function(module, exports) {
$parcel$export(module.exports, "max", () => $c2a1df5a02832659$export$8960430cfd85939f, (v) => $c2a1df5a02832659$export$8960430cfd85939f = v);
var $c2a1df5a02832659$export$8960430cfd85939f;
"use strict";

var $1aHIk = parcelRequire("1aHIk");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $c2a1df5a02832659$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $1aHIk.reduce(max);
}
$c2a1df5a02832659$export$8960430cfd85939f = $c2a1df5a02832659$var$max;

});
parcelRegister("1aHIk", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $0da8a24c89945c8e$export$533b26079ad0b4b, (v) => $0da8a24c89945c8e$export$533b26079ad0b4b = v);
var $0da8a24c89945c8e$export$533b26079ad0b4b;
"use strict";

var $lPaeJ = parcelRequire("lPaeJ");

var $ilSxQ = parcelRequire("ilSxQ");

var $gSfoM = parcelRequire("gSfoM");

var $aXt93 = parcelRequire("aXt93");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $0da8a24c89945c8e$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $aXt93.pipe($lPaeJ.scan(accumulator, seed), $ilSxQ.takeLast(1), $gSfoM.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $aXt93.pipe($lPaeJ.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $ilSxQ.takeLast(1))(source);
    };
}
$0da8a24c89945c8e$export$533b26079ad0b4b = $0da8a24c89945c8e$var$reduce;

});
parcelRegister("lPaeJ", function(module, exports) {
"use strict";
var $fe364d29a4b08f42$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $fe364d29a4b08f42$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $fe364d29a4b08f42$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $fe364d29a4b08f42$var$scan;
var $fe364d29a4b08f42$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe364d29a4b08f42$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe364d29a4b08f42$var$ScanSubscriber = function(_super) {
    $fe364d29a4b08f42$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($kVbBc.Subscriber);

});

parcelRegister("ilSxQ", function(module, exports) {
"use strict";
var $d5c47fa1db0d0824$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $9pTpk = parcelRequire("9pTpk");

var $lmQ1o = parcelRequire("lmQ1o");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $d5c47fa1db0d0824$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $lmQ1o.EmptyObservable();
        else return source.lift(new $d5c47fa1db0d0824$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $d5c47fa1db0d0824$var$takeLast;
var $d5c47fa1db0d0824$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $9pTpk.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d5c47fa1db0d0824$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5c47fa1db0d0824$var$TakeLastSubscriber = function(_super) {
    $d5c47fa1db0d0824$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($kVbBc.Subscriber);

});





parcelRegister("hIxFK", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3pr28 = parcelRequire("3pr28");
$b0T1M.Observable.prototype.merge = $3pr28.merge;

});
parcelRegister("3pr28", function(module, exports) {
$parcel$export(module.exports, "merge", () => $27b8ad275815ab3e$export$4950aa0f605343fb, (v) => $27b8ad275815ab3e$export$4950aa0f605343fb = v);
var $27b8ad275815ab3e$export$9f199afc30ae2269;
var $27b8ad275815ab3e$export$4950aa0f605343fb;
"use strict";

var $aOLK2 = parcelRequire("aOLK2");

var $eqsjw = parcelRequire("eqsjw");
$27b8ad275815ab3e$export$9f199afc30ae2269 = $eqsjw.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $27b8ad275815ab3e$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $aOLK2.merge.apply(void 0, observables)(this);
}
$27b8ad275815ab3e$export$4950aa0f605343fb = $27b8ad275815ab3e$var$merge;

});
parcelRegister("aOLK2", function(module, exports) {
$parcel$export(module.exports, "merge", () => $7e039b5c80b1a7be$export$4950aa0f605343fb, (v) => $7e039b5c80b1a7be$export$4950aa0f605343fb = v);
var $7e039b5c80b1a7be$export$9f199afc30ae2269;
var $7e039b5c80b1a7be$export$4950aa0f605343fb;
"use strict";

var $eqsjw = parcelRequire("eqsjw");

var $eqsjw = parcelRequire("eqsjw");
$7e039b5c80b1a7be$export$9f199afc30ae2269 = $eqsjw.merge;
/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */ function $7e039b5c80b1a7be$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function(source) {
        return source.lift.call($eqsjw.merge.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$7e039b5c80b1a7be$export$4950aa0f605343fb = $7e039b5c80b1a7be$var$merge;

});



parcelRegister("35tg2", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $dfGYZ = parcelRequire("dfGYZ");
$b0T1M.Observable.prototype.mergeAll = $dfGYZ.mergeAll;

});
parcelRegister("dfGYZ", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $9a5e0489896c66b4$export$18aef43295bbe906, (v) => $9a5e0489896c66b4$export$18aef43295bbe906 = v);
var $9a5e0489896c66b4$export$18aef43295bbe906;
"use strict";

var $jMu5f = parcelRequire("jMu5f");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $9a5e0489896c66b4$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $jMu5f.mergeAll(concurrent)(this);
}
$9a5e0489896c66b4$export$18aef43295bbe906 = $9a5e0489896c66b4$var$mergeAll;

});


parcelRegister("n0pyq", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $b9qRK = parcelRequire("b9qRK");
$b0T1M.Observable.prototype.mergeMap = $b9qRK.mergeMap;
$b0T1M.Observable.prototype.flatMap = $b9qRK.mergeMap;

});
parcelRegister("b9qRK", function(module, exports) {
$parcel$export(module.exports, "mergeMap", () => $81e55ffa74201f46$export$6b9f6c0d32c093f9, (v) => $81e55ffa74201f46$export$6b9f6c0d32c093f9 = v);
var $81e55ffa74201f46$export$6b9f6c0d32c093f9;
"use strict";

var $fcKxV = parcelRequire("fcKxV");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */ function $81e55ffa74201f46$var$mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $fcKxV.mergeMap(project, resultSelector, concurrent)(this);
}
$81e55ffa74201f46$export$6b9f6c0d32c093f9 = $81e55ffa74201f46$var$mergeMap;

});


parcelRegister("4wxX0", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $fUZs2 = parcelRequire("fUZs2");
$b0T1M.Observable.prototype.flatMapTo = $fUZs2.mergeMapTo;
$b0T1M.Observable.prototype.mergeMapTo = $fUZs2.mergeMapTo;

});
parcelRegister("fUZs2", function(module, exports) {
$parcel$export(module.exports, "mergeMapTo", () => $b96bc0e404a664ba$export$bd7cfc9a42b8a412, (v) => $b96bc0e404a664ba$export$bd7cfc9a42b8a412 = v);
var $b96bc0e404a664ba$export$bd7cfc9a42b8a412;
"use strict";

var $1MekL = parcelRequire("1MekL");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $b96bc0e404a664ba$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $1MekL.mergeMapTo(innerObservable, resultSelector, concurrent)(this);
}
$b96bc0e404a664ba$export$bd7cfc9a42b8a412 = $b96bc0e404a664ba$var$mergeMapTo;

});
parcelRegister("1MekL", function(module, exports) {
"use strict";
var $14b5648c4d6b7b64$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $14b5648c4d6b7b64$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $14b5648c4d6b7b64$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $14b5648c4d6b7b64$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $14b5648c4d6b7b64$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $14b5648c4d6b7b64$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $14b5648c4d6b7b64$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $14b5648c4d6b7b64$var$MergeMapToSubscriber = function(_super) {
    $14b5648c4d6b7b64$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($d3klE.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.MergeMapToSubscriber = $14b5648c4d6b7b64$var$MergeMapToSubscriber;

});



parcelRegister("2BpAw", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $iFQIA = parcelRequire("iFQIA");
$b0T1M.Observable.prototype.mergeScan = $iFQIA.mergeScan;

});
parcelRegister("iFQIA", function(module, exports) {
$parcel$export(module.exports, "mergeScan", () => $d984f312574f3dda$export$c1fc905202bced53, (v) => $d984f312574f3dda$export$c1fc905202bced53 = v);
var $d984f312574f3dda$export$c1fc905202bced53;
"use strict";

var $7m0Ce = parcelRequire("7m0Ce");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $d984f312574f3dda$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $7m0Ce.mergeScan(accumulator, seed, concurrent)(this);
}
$d984f312574f3dda$export$c1fc905202bced53 = $d984f312574f3dda$var$mergeScan;

});
parcelRegister("7m0Ce", function(module, exports) {
"use strict";
var $55ab10b72b7a9d75$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $d3klE = parcelRequire("d3klE");

var $5XpGv = parcelRequire("5XpGv");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $55ab10b72b7a9d75$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $55ab10b72b7a9d75$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $55ab10b72b7a9d75$var$mergeScan;
var $55ab10b72b7a9d75$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $55ab10b72b7a9d75$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $55ab10b72b7a9d75$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $55ab10b72b7a9d75$var$MergeScanSubscriber = function(_super) {
    $55ab10b72b7a9d75$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $3kkLM.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $geExo.errorObject) destination.error($geExo.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($d3klE.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($5XpGv.OuterSubscriber);
module.exports.MergeScanSubscriber = $55ab10b72b7a9d75$var$MergeScanSubscriber;

});



parcelRegister("8kSPc", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $bKiRu = parcelRequire("bKiRu");
$b0T1M.Observable.prototype.min = $bKiRu.min;

});
parcelRegister("bKiRu", function(module, exports) {
$parcel$export(module.exports, "min", () => $88d29f23de201349$export$96ec731ed4dcb222, (v) => $88d29f23de201349$export$96ec731ed4dcb222 = v);
var $88d29f23de201349$export$96ec731ed4dcb222;
"use strict";

var $2OVeR = parcelRequire("2OVeR");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $88d29f23de201349$var$min(comparer) {
    return $2OVeR.min(comparer)(this);
}
$88d29f23de201349$export$96ec731ed4dcb222 = $88d29f23de201349$var$min;

});
parcelRegister("2OVeR", function(module, exports) {
$parcel$export(module.exports, "min", () => $20dca6b506aa89cb$export$96ec731ed4dcb222, (v) => $20dca6b506aa89cb$export$96ec731ed4dcb222 = v);
var $20dca6b506aa89cb$export$96ec731ed4dcb222;
"use strict";

var $1aHIk = parcelRequire("1aHIk");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $20dca6b506aa89cb$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $1aHIk.reduce(min);
}
$20dca6b506aa89cb$export$96ec731ed4dcb222 = $20dca6b506aa89cb$var$min;

});



parcelRegister("bV9rb", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $l3bju = parcelRequire("l3bju");
$b0T1M.Observable.prototype.multicast = $l3bju.multicast;

});
parcelRegister("l3bju", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $f532a7607cdb983a$export$1364843af8d5a963, (v) => $f532a7607cdb983a$export$1364843af8d5a963 = v);
var $f532a7607cdb983a$export$1364843af8d5a963;
"use strict";

var $dxmlm = parcelRequire("dxmlm");
/* tslint:enable:max-line-length */ /**
 * Allows source Observable to be subscribed only once with a Subject of choice,
 * while still sharing its values between multiple subscribers.
 *
 * <span class="informal">Subscribe to Observable once, but send its values to multiple subscribers.</span>
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * `multicast` is an operator that works in two modes.
 *
 * In the first mode you provide a single argument to it, which can be either an initialized Subject or a Subject
 * factory. As a result you will get a special kind of an Observable - a {@link ConnectableObservable}. It can be
 * subscribed multiple times, just as regular Observable, but it won't subscribe to the source Observable at that
 * moment. It will do it only if you call its `connect` method. This means you can essentially control by hand, when
 * source Observable will be actually subscribed. What is more, ConnectableObservable will share this one subscription
 * between all of its subscribers. This means that, for example, `ajax` Observable will only send a request once,
 * even though usually it would send a request per every subscriber. Since it sends a request at the moment of
 * subscription, here request would be sent when the `connect` method of a ConnectableObservable is called.
 *
 * The most common pattern of using ConnectableObservable is calling `connect` when the first consumer subscribes,
 * keeping the subscription alive while several consumers come and go and finally unsubscribing from the source
 * Observable, when the last consumer unsubscribes. To not implement that logic over and over again,
 * ConnectableObservable has a special operator, `refCount`. When called, it returns an Observable, which will count
 * the number of consumers subscribed to it and keep ConnectableObservable connected as long as there is at least
 * one consumer. So if you don't actually need to decide yourself when to connect and disconnect a
 * ConnectableObservable, use `refCount`.
 *
 * The second mode is invoked by calling `multicast` with an additional, second argument - selector function.
 * This function accepts an Observable - which basically mirrors the source Observable - and returns Observable
 * as well, which should be the input stream modified by any operators you want. Note that in this
 * mode you cannot provide initialized Subject as a first argument - it has to be a Subject factory. If
 * you provide selector function, `multicast` returns just a regular Observable, instead of ConnectableObservable.
 * Thus, as usual, each subscription to this stream triggers subscription to the source Observable. However,
 * if inside the selector function you subscribe to the input Observable multiple times, actual source stream
 * will be subscribed only once. So if you have a chain of operators that use some Observable many times,
 * but you want to subscribe to that Observable only once, this is the mode you would use.
 *
 * Subject provided as a first parameter of `multicast` is used as a proxy for the single subscription to the
 * source Observable. It means that all values from the source stream go through that Subject. Thus, if a Subject
 * has some special properties, Observable returned by `multicast` will have them as well. If you want to use
 * `multicast` with a Subject that is one of the ones included in RxJS by default - {@link Subject},
 * {@link AsyncSubject}, {@link BehaviorSubject}, or {@link ReplaySubject} - simply use {@link publish},
 * {@link publishLast}, {@link publishBehavior} or {@link publishReplay} respectively. These are actually
 * just wrappers around `multicast`, with a specific Subject hardcoded inside.
 *
 * Also, if you use {@link publish} or {@link publishReplay} with a ConnectableObservables `refCount` operator,
 * you can simply use {@link share} and {@link shareReplay} respectively, which chain these two.
 *
 * @example <caption>Use ConnectableObservable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const connectableSeconds = seconds.multicast(new Subject());
 *
 * connectableSeconds.subscribe(value => console.log('first: ' + value));
 * connectableSeconds.subscribe(value => console.log('second: ' + value));
 *
 * // At this point still nothing happens, even though we subscribed twice.
 *
 * connectableSeconds.connect();
 *
 * // From now on `seconds` are being logged to the console,
 * // twice per every second. `seconds` Observable was however only subscribed once,
 * // so under the hood Observable.interval had only one clock started.
 *
 * @example <caption>Use selector</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds
 *     .multicast(
 *         () => new Subject(),
 *         seconds => seconds.zip(seconds) // Usually zip would subscribe to `seconds` twice.
 *                                         // Because we are inside selector, `seconds` is subscribed once,
 *     )                                   // thus starting only one clock used internally by Observable.interval.
 *     .subscribe();
 *
 * @see {@link publish}
 * @see {@link publishLast}
 * @see {@link publishBehavior}
 * @see {@link publishReplay}
 * @see {@link share}
 * @see {@link shareReplay}
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate Subject through
 * which the source sequence's elements will be multicast to the selector function input Observable or
 * ConnectableObservable returned by the operator.
 * @param {Function} [selector] - Optional selector function that can use the input stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the input source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable<T>|ConnectableObservable<T>} An Observable that emits the results of invoking the selector
 * on the source stream or a special {@link ConnectableObservable}, if selector was not provided.
 *
 * @method multicast
 * @owner Observable
 */ function $f532a7607cdb983a$var$multicast(subjectOrSubjectFactory, selector) {
    return $dxmlm.multicast(subjectOrSubjectFactory, selector)(this);
}
$f532a7607cdb983a$export$1364843af8d5a963 = $f532a7607cdb983a$var$multicast;

});
parcelRegister("dxmlm", function(module, exports) {
$parcel$export(module.exports, "multicast", () => $9dafb0644d7d5d6c$export$1364843af8d5a963, (v) => $9dafb0644d7d5d6c$export$1364843af8d5a963 = v);
var $9dafb0644d7d5d6c$export$1364843af8d5a963;
var $9dafb0644d7d5d6c$export$150d52413393bf2c;
"use strict";

var $3hL74 = parcelRequire("3hL74");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */ function $9dafb0644d7d5d6c$var$multicast(subjectOrSubjectFactory, selector) {
    return function multicastOperatorFunction(source) {
        var subjectFactory;
        if (typeof subjectOrSubjectFactory === 'function') subjectFactory = subjectOrSubjectFactory;
        else subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
        if (typeof selector === 'function') return source.lift(new $9dafb0644d7d5d6c$var$MulticastOperator(subjectFactory, selector));
        var connectable = Object.create(source, $3hL74.connectableObservableDescriptor);
        connectable.source = source;
        connectable.subjectFactory = subjectFactory;
        return connectable;
    };
}
$9dafb0644d7d5d6c$export$1364843af8d5a963 = $9dafb0644d7d5d6c$var$multicast;
var $9dafb0644d7d5d6c$var$MulticastOperator = function() {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function(subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}();
$9dafb0644d7d5d6c$export$150d52413393bf2c = $9dafb0644d7d5d6c$var$MulticastOperator;

});
parcelRegister("3hL74", function(module, exports) {
"use strict";
var $26478151f9e6daf6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $b0T1M = parcelRequire("b0T1M");

var $kVbBc = parcelRequire("kVbBc");

var $cGvOX = parcelRequire("cGvOX");

var $d1zoQ = parcelRequire("d1zoQ");
/**
 * @class ConnectableObservable<T>
 */ var $26478151f9e6daf6$var$ConnectableObservable = function(_super) {
    $26478151f9e6daf6$var$__extends(ConnectableObservable, _super);
    function ConnectableObservable(/** @deprecated internal use only */ source, /** @deprecated internal use only */ subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        /** @deprecated internal use only */ this._refCount = 0;
        this._isComplete = false;
    }
    /** @deprecated internal use only */ ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    /** @deprecated internal use only */ ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function() {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new $cGvOX.Subscription();
            connection.add(this.source.subscribe(new $26478151f9e6daf6$var$ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = $cGvOX.Subscription.EMPTY;
            } else this._connection = connection;
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return $d1zoQ.refCount()(this);
    };
    return ConnectableObservable;
}($b0T1M.Observable);
module.exports.ConnectableObservable = $26478151f9e6daf6$var$ConnectableObservable;
var $26478151f9e6daf6$var$connectableProto = $26478151f9e6daf6$var$ConnectableObservable.prototype;
module.exports.connectableObservableDescriptor = {
    operator: {
        value: null
    },
    _refCount: {
        value: 0,
        writable: true
    },
    _subject: {
        value: null,
        writable: true
    },
    _connection: {
        value: null,
        writable: true
    },
    _subscribe: {
        value: $26478151f9e6daf6$var$connectableProto._subscribe
    },
    _isComplete: {
        value: $26478151f9e6daf6$var$connectableProto._isComplete,
        writable: true
    },
    getSubject: {
        value: $26478151f9e6daf6$var$connectableProto.getSubject
    },
    connect: {
        value: $26478151f9e6daf6$var$connectableProto.connect
    },
    refCount: {
        value: $26478151f9e6daf6$var$connectableProto.refCount
    }
};
var $26478151f9e6daf6$var$ConnectableSubscriber = function(_super) {
    $26478151f9e6daf6$var$__extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function(err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function() {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ ConnectableSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) connection.unsubscribe();
        }
    };
    return ConnectableSubscriber;
}($hJCZY.SubjectSubscriber);
var $26478151f9e6daf6$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $26478151f9e6daf6$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $26478151f9e6daf6$var$RefCountSubscriber = function(_super) {
    $26478151f9e6daf6$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($kVbBc.Subscriber);

});
parcelRegister("d1zoQ", function(module, exports) {
"use strict";
var $97b6d405b8edc8c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
function $97b6d405b8edc8c4$var$refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new $97b6d405b8edc8c4$var$RefCountOperator(source));
    };
}
module.exports.refCount = $97b6d405b8edc8c4$var$refCount;
var $97b6d405b8edc8c4$var$RefCountOperator = function() {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function(subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new $97b6d405b8edc8c4$var$RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) refCounter.connection = connectable.connect();
        return subscription;
    };
    return RefCountOperator;
}();
var $97b6d405b8edc8c4$var$RefCountSubscriber = function(_super) {
    $97b6d405b8edc8c4$var$__extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    /** @deprecated internal use only */ RefCountSubscriber.prototype._unsubscribe = function() {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) sharedConnection.unsubscribe();
    };
    return RefCountSubscriber;
}($kVbBc.Subscriber);

});





parcelRegister("6ezBu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $bmbfW = parcelRequire("bmbfW");
$b0T1M.Observable.prototype.observeOn = $bmbfW.observeOn;

});
parcelRegister("bmbfW", function(module, exports) {
$parcel$export(module.exports, "observeOn", () => $844a7b0333b1fc0f$export$9007f49c319d1ac7, (v) => $844a7b0333b1fc0f$export$9007f49c319d1ac7 = v);
var $844a7b0333b1fc0f$export$9007f49c319d1ac7;
"use strict";

var $kpNTS = parcelRequire("kpNTS");
/**
 *
 * Re-emits all notifications from source Observable with specified scheduler.
 *
 * <span class="informal">Ensure a specific scheduler is used, from outside of an Observable.</span>
 *
 * `observeOn` is an operator that accepts a scheduler as a first parameter, which will be used to reschedule
 * notifications emitted by the source Observable. It might be useful, if you do not have control over
 * internal scheduler of a given Observable, but want to control when its values are emitted nevertheless.
 *
 * Returned Observable emits the same notifications (nexted values, complete and error events) as the source Observable,
 * but rescheduled with provided scheduler. Note that this doesn't mean that source Observables internal
 * scheduler will be replaced in any way. Original scheduler still will be used, but when the source Observable emits
 * notification, it will be immediately scheduled again - this time with scheduler passed to `observeOn`.
 * An anti-pattern would be calling `observeOn` on Observable that emits lots of values synchronously, to split
 * that emissions into asynchronous chunks. For this to happen, scheduler would have to be passed into the source
 * Observable directly (usually into the operator that creates it). `observeOn` simply delays notifications a
 * little bit more, to ensure that they are emitted at expected moments.
 *
 * As a matter of fact, `observeOn` accepts second parameter, which specifies in milliseconds with what delay notifications
 * will be emitted. The main difference between {@link delay} operator and `observeOn` is that `observeOn`
 * will delay all notifications - including error notifications - while `delay` will pass through error
 * from source Observable immediately when it is emitted. In general it is highly recommended to use `delay` operator
 * for any kind of delaying of values in the stream, while using `observeOn` to specify which scheduler should be used
 * for notification emissions in general.
 *
 * @example <caption>Ensure values in subscribe are called just before browser repaint.</caption>
 * const intervals = Rx.Observable.interval(10); // Intervals are scheduled
 *                                               // with async scheduler by default...
 *
 * intervals
 * .observeOn(Rx.Scheduler.animationFrame)       // ...but we will observe on animationFrame
 * .subscribe(val => {                           // scheduler to ensure smooth animation.
 *   someDiv.style.height = val + 'px';
 * });
 *
 * @see {@link delay}
 *
 * @param {IScheduler} scheduler Scheduler that will be used to reschedule notifications from source Observable.
 * @param {number} [delay] Number of milliseconds that states with what delay every notification should be rescheduled.
 * @return {Observable<T>} Observable that emits the same notifications as the source Observable,
 * but with provided scheduler.
 *
 * @method observeOn
 * @owner Observable
 */ function $844a7b0333b1fc0f$var$observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $kpNTS.observeOn(scheduler, delay)(this);
}
$844a7b0333b1fc0f$export$9007f49c319d1ac7 = $844a7b0333b1fc0f$var$observeOn;

});


parcelRegister("btNQN", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $dUWJM = parcelRequire("dUWJM");
$b0T1M.Observable.prototype.onErrorResumeNext = $dUWJM.onErrorResumeNext;

});
parcelRegister("dUWJM", function(module, exports) {
$parcel$export(module.exports, "onErrorResumeNext", () => $a21e1154682b03d9$export$5fba66d61591f42, (v) => $a21e1154682b03d9$export$5fba66d61591f42 = v);
var $a21e1154682b03d9$export$5fba66d61591f42;
"use strict";

var $8gEWr = parcelRequire("8gEWr");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $a21e1154682b03d9$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    return $8gEWr.onErrorResumeNext.apply(void 0, nextSources)(this);
}
$a21e1154682b03d9$export$5fba66d61591f42 = $a21e1154682b03d9$var$onErrorResumeNext;

});


parcelRegister("kp4C5", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $kPomj = parcelRequire("kPomj");
$b0T1M.Observable.prototype.pairwise = $kPomj.pairwise;

});
parcelRegister("kPomj", function(module, exports) {
$parcel$export(module.exports, "pairwise", () => $f29b7738de7dc4cb$export$8f9d79d42bff1aac, (v) => $f29b7738de7dc4cb$export$8f9d79d42bff1aac = v);
var $f29b7738de7dc4cb$export$8f9d79d42bff1aac;
"use strict";

var $eBfuU = parcelRequire("eBfuU");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $f29b7738de7dc4cb$var$pairwise() {
    return $eBfuU.pairwise()(this);
}
$f29b7738de7dc4cb$export$8f9d79d42bff1aac = $f29b7738de7dc4cb$var$pairwise;

});
parcelRegister("eBfuU", function(module, exports) {
"use strict";
var $aa108ae42fa739c7$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */ function $aa108ae42fa739c7$var$pairwise() {
    return function(source) {
        return source.lift(new $aa108ae42fa739c7$var$PairwiseOperator());
    };
}
module.exports.pairwise = $aa108ae42fa739c7$var$pairwise;
var $aa108ae42fa739c7$var$PairwiseOperator = function() {
    function PairwiseOperator() {}
    PairwiseOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $aa108ae42fa739c7$var$PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $aa108ae42fa739c7$var$PairwiseSubscriber = function(_super) {
    $aa108ae42fa739c7$var$__extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function(value) {
        if (this.hasPrev) this.destination.next([
            this.prev,
            value
        ]);
        else this.hasPrev = true;
        this.prev = value;
    };
    return PairwiseSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("dHrhW", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $c9Qm7 = parcelRequire("c9Qm7");
$b0T1M.Observable.prototype.partition = $c9Qm7.partition;

});
parcelRegister("c9Qm7", function(module, exports) {
$parcel$export(module.exports, "partition", () => $8d9ef0112a234f5d$export$b29f828819edca8d, (v) => $8d9ef0112a234f5d$export$b29f828819edca8d = v);
var $8d9ef0112a234f5d$export$b29f828819edca8d;
"use strict";

var $anVo0 = parcelRequire("anVo0");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $8d9ef0112a234f5d$var$partition(predicate, thisArg) {
    return $anVo0.partition(predicate, thisArg)(this);
}
$8d9ef0112a234f5d$export$b29f828819edca8d = $8d9ef0112a234f5d$var$partition;

});
parcelRegister("anVo0", function(module, exports) {
$parcel$export(module.exports, "partition", () => $78f891113e480d04$export$b29f828819edca8d, (v) => $78f891113e480d04$export$b29f828819edca8d = v);
var $78f891113e480d04$export$b29f828819edca8d;
"use strict";

var $lBo3l = parcelRequire("lBo3l");

var $7lL5Z = parcelRequire("7lL5Z");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $78f891113e480d04$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $7lL5Z.filter(predicate, thisArg)(source),
            $7lL5Z.filter($lBo3l.not(predicate, thisArg))(source)
        ];
    };
}
$78f891113e480d04$export$b29f828819edca8d = $78f891113e480d04$var$partition;

});
parcelRegister("lBo3l", function(module, exports) {
$parcel$export(module.exports, "not", () => $fb9fb613c92ba7e0$export$6003a5f097c73977, (v) => $fb9fb613c92ba7e0$export$6003a5f097c73977 = v);
var $fb9fb613c92ba7e0$export$6003a5f097c73977;
"use strict";
function $fb9fb613c92ba7e0$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$fb9fb613c92ba7e0$export$6003a5f097c73977 = $fb9fb613c92ba7e0$var$not;

});




parcelRegister("aEoSl", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $cpO1Q = parcelRequire("cpO1Q");
$b0T1M.Observable.prototype.pluck = $cpO1Q.pluck;

});
parcelRegister("cpO1Q", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $909ea082e7f2280c$export$c44985b87d605eff, (v) => $909ea082e7f2280c$export$c44985b87d605eff = v);
var $909ea082e7f2280c$export$c44985b87d605eff;
"use strict";

var $3fA6Q = parcelRequire("3fA6Q");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $909ea082e7f2280c$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    return $3fA6Q.pluck.apply(void 0, properties)(this);
}
$909ea082e7f2280c$export$c44985b87d605eff = $909ea082e7f2280c$var$pluck;

});
parcelRegister("3fA6Q", function(module, exports) {
$parcel$export(module.exports, "pluck", () => $25dec8686b785419$export$c44985b87d605eff, (v) => $25dec8686b785419$export$c44985b87d605eff = v);
var $25dec8686b785419$export$c44985b87d605eff;
"use strict";

var $bWhgb = parcelRequire("bWhgb");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */ function $25dec8686b785419$var$pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i - 0] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return function(source) {
        return $bWhgb.map($25dec8686b785419$var$plucker(properties, length))(source);
    };
}
$25dec8686b785419$export$c44985b87d605eff = $25dec8686b785419$var$pluck;
function $25dec8686b785419$var$plucker(props, length) {
    var mapper = function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    };
    return mapper;
}

});



parcelRegister("jAhjW", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $1xp1d = parcelRequire("1xp1d");
$b0T1M.Observable.prototype.publish = $1xp1d.publish;

});
parcelRegister("1xp1d", function(module, exports) {
$parcel$export(module.exports, "publish", () => $11ec47ae5575756a$export$89b472e03be495df, (v) => $11ec47ae5575756a$export$89b472e03be495df = v);
var $11ec47ae5575756a$export$89b472e03be495df;
"use strict";

var $iy7b2 = parcelRequire("iy7b2");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $11ec47ae5575756a$var$publish(selector) {
    return $iy7b2.publish(selector)(this);
}
$11ec47ae5575756a$export$89b472e03be495df = $11ec47ae5575756a$var$publish;

});
parcelRegister("iy7b2", function(module, exports) {
$parcel$export(module.exports, "publish", () => $d810f82f33a62878$export$89b472e03be495df, (v) => $d810f82f33a62878$export$89b472e03be495df = v);
var $d810f82f33a62878$export$89b472e03be495df;
"use strict";

var $hJCZY = parcelRequire("hJCZY");

var $dxmlm = parcelRequire("dxmlm");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $d810f82f33a62878$var$publish(selector) {
    return selector ? $dxmlm.multicast(function() {
        return new $hJCZY.Subject();
    }, selector) : $dxmlm.multicast(new $hJCZY.Subject());
}
$d810f82f33a62878$export$89b472e03be495df = $d810f82f33a62878$var$publish;

});



parcelRegister("7NB0r", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $l3Qsh = parcelRequire("l3Qsh");
$b0T1M.Observable.prototype.publishBehavior = $l3Qsh.publishBehavior;

});
parcelRegister("l3Qsh", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $f552914a11db6e53$export$16ae46fda9567053, (v) => $f552914a11db6e53$export$16ae46fda9567053 = v);
var $f552914a11db6e53$export$16ae46fda9567053;
"use strict";

var $7nrwj = parcelRequire("7nrwj");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $f552914a11db6e53$var$publishBehavior(value) {
    return $7nrwj.publishBehavior(value)(this);
}
$f552914a11db6e53$export$16ae46fda9567053 = $f552914a11db6e53$var$publishBehavior;

});
parcelRegister("7nrwj", function(module, exports) {
$parcel$export(module.exports, "publishBehavior", () => $55f0075101850993$export$16ae46fda9567053, (v) => $55f0075101850993$export$16ae46fda9567053 = v);
var $55f0075101850993$export$16ae46fda9567053;
"use strict";

var $5bb7M = parcelRequire("5bb7M");

var $dxmlm = parcelRequire("dxmlm");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $55f0075101850993$var$publishBehavior(value) {
    return function(source) {
        return $dxmlm.multicast(new $5bb7M.BehaviorSubject(value))(source);
    };
}
$55f0075101850993$export$16ae46fda9567053 = $55f0075101850993$var$publishBehavior;

});
parcelRegister("5bb7M", function(module, exports) {
"use strict";
var $3c569be5d9b32263$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $1QtXt = parcelRequire("1QtXt");
/**
 * @class BehaviorSubject<T>
 */ var $3c569be5d9b32263$var$BehaviorSubject = function(_super) {
    $3c569be5d9b32263$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $1QtXt.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($hJCZY.Subject);
module.exports.BehaviorSubject = $3c569be5d9b32263$var$BehaviorSubject;

});




parcelRegister("bNgWJ", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $8PEwa = parcelRequire("8PEwa");
$b0T1M.Observable.prototype.publishReplay = $8PEwa.publishReplay;

});
parcelRegister("8PEwa", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $66e2842801beb20b$export$1f3342bf81d92d52, (v) => $66e2842801beb20b$export$1f3342bf81d92d52 = v);
var $66e2842801beb20b$export$1f3342bf81d92d52;
"use strict";

var $1p9Zl = parcelRequire("1p9Zl");
/* tslint:enable:max-line-length */ /**
 * @param bufferSize
 * @param windowTime
 * @param selectorOrScheduler
 * @param scheduler
 * @return {Observable<T> | ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */ function $66e2842801beb20b$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    return $1p9Zl.publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler)(this);
}
$66e2842801beb20b$export$1f3342bf81d92d52 = $66e2842801beb20b$var$publishReplay;

});
parcelRegister("1p9Zl", function(module, exports) {
$parcel$export(module.exports, "publishReplay", () => $105fdfbf41ab4909$export$1f3342bf81d92d52, (v) => $105fdfbf41ab4909$export$1f3342bf81d92d52 = v);
var $105fdfbf41ab4909$export$1f3342bf81d92d52;
"use strict";

var $gNLuz = parcelRequire("gNLuz");

var $dxmlm = parcelRequire("dxmlm");
/* tslint:enable:max-line-length */ function $105fdfbf41ab4909$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $gNLuz.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $dxmlm.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$105fdfbf41ab4909$export$1f3342bf81d92d52 = $105fdfbf41ab4909$var$publishReplay;

});



parcelRegister("8ZPZy", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $4vjtg = parcelRequire("4vjtg");
$b0T1M.Observable.prototype.publishLast = $4vjtg.publishLast;

});
parcelRegister("4vjtg", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $34792931f68b5ec5$export$42d9b6b38c68d989, (v) => $34792931f68b5ec5$export$42d9b6b38c68d989 = v);
var $34792931f68b5ec5$export$42d9b6b38c68d989;
"use strict";

var $6SL9s = parcelRequire("6SL9s");
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */ function $34792931f68b5ec5$var$publishLast() {
    //TODO(benlesh): correct type-flow through here.
    return $6SL9s.publishLast()(this);
}
$34792931f68b5ec5$export$42d9b6b38c68d989 = $34792931f68b5ec5$var$publishLast;

});
parcelRegister("6SL9s", function(module, exports) {
$parcel$export(module.exports, "publishLast", () => $502c5c8fd56381a0$export$42d9b6b38c68d989, (v) => $502c5c8fd56381a0$export$42d9b6b38c68d989 = v);
var $502c5c8fd56381a0$export$42d9b6b38c68d989;
"use strict";

var $l5vGt = parcelRequire("l5vGt");

var $dxmlm = parcelRequire("dxmlm");
function $502c5c8fd56381a0$var$publishLast() {
    return function(source) {
        return $dxmlm.multicast(new $l5vGt.AsyncSubject())(source);
    };
}
$502c5c8fd56381a0$export$42d9b6b38c68d989 = $502c5c8fd56381a0$var$publishLast;

});



parcelRegister("hywim", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $2K0a9 = parcelRequire("2K0a9");
$b0T1M.Observable.prototype.race = $2K0a9.race;

});
parcelRegister("2K0a9", function(module, exports) {
$parcel$export(module.exports, "race", () => $1ff000f201da9bb8$export$236c05de452bec2, (v) => $1ff000f201da9bb8$export$236c05de452bec2 = v);
var $1ff000f201da9bb8$export$dc3f181b77d95dcc;
var $1ff000f201da9bb8$export$236c05de452bec2;
"use strict";

var $enYEv = parcelRequire("enYEv");

var $eMy72 = parcelRequire("eMy72");
$1ff000f201da9bb8$export$dc3f181b77d95dcc = $eMy72.race;
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $1ff000f201da9bb8$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $enYEv.race.apply(void 0, observables)(this);
}
$1ff000f201da9bb8$export$236c05de452bec2 = $1ff000f201da9bb8$var$race;

});
parcelRegister("enYEv", function(module, exports) {
$parcel$export(module.exports, "race", () => $a79242f13244b102$export$236c05de452bec2, (v) => $a79242f13244b102$export$236c05de452bec2 = v);
var $a79242f13244b102$export$236c05de452bec2;
"use strict";

var $8SQia = parcelRequire("8SQia");

var $eMy72 = parcelRequire("eMy72");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $a79242f13244b102$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $8SQia.isArray(observables[0])) observables = observables[0];
        return source.lift.call($eMy72.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$a79242f13244b102$export$236c05de452bec2 = $a79242f13244b102$var$race;

});



parcelRegister("bWP2x", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3kDam = parcelRequire("3kDam");
$b0T1M.Observable.prototype.reduce = $3kDam.reduce;

});
parcelRegister("3kDam", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $26d19eea48d7d282$export$533b26079ad0b4b, (v) => $26d19eea48d7d282$export$533b26079ad0b4b = v);
var $26d19eea48d7d282$export$533b26079ad0b4b;
"use strict";

var $1aHIk = parcelRequire("1aHIk");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $26d19eea48d7d282$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return $1aHIk.reduce(accumulator, seed)(this);
    return $1aHIk.reduce(accumulator)(this);
}
$26d19eea48d7d282$export$533b26079ad0b4b = $26d19eea48d7d282$var$reduce;

});


parcelRegister("3Alyg", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $63MwS = parcelRequire("63MwS");
$b0T1M.Observable.prototype.repeat = $63MwS.repeat;

});
parcelRegister("63MwS", function(module, exports) {
$parcel$export(module.exports, "repeat", () => $4698aacd733227d9$export$76d90c956114f2c2, (v) => $4698aacd733227d9$export$76d90c956114f2c2 = v);
var $4698aacd733227d9$export$76d90c956114f2c2;
"use strict";

var $dvRsB = parcelRequire("dvRsB");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $4698aacd733227d9$var$repeat(count) {
    if (count === void 0) count = -1;
    return $dvRsB.repeat(count)(this);
}
$4698aacd733227d9$export$76d90c956114f2c2 = $4698aacd733227d9$var$repeat;

});
parcelRegister("dvRsB", function(module, exports) {
"use strict";
var $9d67a3b413aeb0c3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $lmQ1o = parcelRequire("lmQ1o");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $9d67a3b413aeb0c3$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $lmQ1o.EmptyObservable();
        else if (count < 0) return source.lift(new $9d67a3b413aeb0c3$var$RepeatOperator(-1, source));
        else return source.lift(new $9d67a3b413aeb0c3$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $9d67a3b413aeb0c3$var$repeat;
var $9d67a3b413aeb0c3$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9d67a3b413aeb0c3$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9d67a3b413aeb0c3$var$RepeatSubscriber = function(_super) {
    $9d67a3b413aeb0c3$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("a4KR5", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $5DoCF = parcelRequire("5DoCF");
$b0T1M.Observable.prototype.repeatWhen = $5DoCF.repeatWhen;

});
parcelRegister("5DoCF", function(module, exports) {
$parcel$export(module.exports, "repeatWhen", () => $41a3b1cae1c552e5$export$b39ac5b4ffd1415a, (v) => $41a3b1cae1c552e5$export$b39ac5b4ffd1415a = v);
var $41a3b1cae1c552e5$export$b39ac5b4ffd1415a;
"use strict";

var $fGPgr = parcelRequire("fGPgr");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $41a3b1cae1c552e5$var$repeatWhen(notifier) {
    return $fGPgr.repeatWhen(notifier)(this);
}
$41a3b1cae1c552e5$export$b39ac5b4ffd1415a = $41a3b1cae1c552e5$var$repeatWhen;

});
parcelRegister("fGPgr", function(module, exports) {
"use strict";
var $b6c28b4480543fd4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $b6c28b4480543fd4$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $b6c28b4480543fd4$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $b6c28b4480543fd4$var$repeatWhen;
var $b6c28b4480543fd4$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $b6c28b4480543fd4$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $b6c28b4480543fd4$var$RepeatWhenSubscriber = function(_super) {
    $b6c28b4480543fd4$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $hJCZY.Subject();
        var retries = $3kkLM.tryCatch(this.notifier)(this.notifications);
        if (retries === $geExo.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $d3klE.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("eZBS3", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $aFRCn = parcelRequire("aFRCn");
$b0T1M.Observable.prototype.retry = $aFRCn.retry;

});
parcelRegister("aFRCn", function(module, exports) {
$parcel$export(module.exports, "retry", () => $7c57531d7b372074$export$9369b12211e1fce4, (v) => $7c57531d7b372074$export$9369b12211e1fce4 = v);
var $7c57531d7b372074$export$9369b12211e1fce4;
"use strict";

var $jn2xT = parcelRequire("jn2xT");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $7c57531d7b372074$var$retry(count) {
    if (count === void 0) count = -1;
    return $jn2xT.retry(count)(this);
}
$7c57531d7b372074$export$9369b12211e1fce4 = $7c57531d7b372074$var$retry;

});
parcelRegister("jn2xT", function(module, exports) {
"use strict";
var $e1a223d69e7e46e8$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */ function $e1a223d69e7e46e8$var$retry(count) {
    if (count === void 0) count = -1;
    return function(source) {
        return source.lift(new $e1a223d69e7e46e8$var$RetryOperator(count, source));
    };
}
module.exports.retry = $e1a223d69e7e46e8$var$retry;
var $e1a223d69e7e46e8$var$RetryOperator = function() {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e1a223d69e7e46e8$var$RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e1a223d69e7e46e8$var$RetrySubscriber = function(_super) {
    $e1a223d69e7e46e8$var$__extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.error.call(this, err);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("aTJhu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $3RArY = parcelRequire("3RArY");
$b0T1M.Observable.prototype.retryWhen = $3RArY.retryWhen;

});
parcelRegister("3RArY", function(module, exports) {
$parcel$export(module.exports, "retryWhen", () => $2d029899dbe5b677$export$1281551253cfee02, (v) => $2d029899dbe5b677$export$1281551253cfee02 = v);
var $2d029899dbe5b677$export$1281551253cfee02;
"use strict";

var $bVoCc = parcelRequire("bVoCc");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $2d029899dbe5b677$var$retryWhen(notifier) {
    return $bVoCc.retryWhen(notifier)(this);
}
$2d029899dbe5b677$export$1281551253cfee02 = $2d029899dbe5b677$var$retryWhen;

});
parcelRegister("bVoCc", function(module, exports) {
"use strict";
var $8ae81ca7905e4323$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */ function $8ae81ca7905e4323$var$retryWhen(notifier) {
    return function(source) {
        return source.lift(new $8ae81ca7905e4323$var$RetryWhenOperator(notifier, source));
    };
}
module.exports.retryWhen = $8ae81ca7905e4323$var$retryWhen;
var $8ae81ca7905e4323$var$RetryWhenOperator = function() {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8ae81ca7905e4323$var$RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8ae81ca7905e4323$var$RetryWhenSubscriber = function(_super) {
    $8ae81ca7905e4323$var$__extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new $hJCZY.Subject();
                retries = $3kkLM.tryCatch(this.notifier)(errors);
                if (retries === $geExo.errorObject) return _super.prototype.error.call(this, $geExo.errorObject.e);
                retriesSubscription = $d3klE.subscribeToResult(this, retries);
            } else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    /** @deprecated internal use only */ RetryWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("kPxCC", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $2TM7P = parcelRequire("2TM7P");
$b0T1M.Observable.prototype.sample = $2TM7P.sample;

});
parcelRegister("2TM7P", function(module, exports) {
$parcel$export(module.exports, "sample", () => $21c60c7e578818d3$export$4812e460280c6ef2, (v) => $21c60c7e578818d3$export$4812e460280c6ef2 = v);
var $21c60c7e578818d3$export$4812e460280c6ef2;
"use strict";

var $jnLwa = parcelRequire("jnLwa");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $21c60c7e578818d3$var$sample(notifier) {
    return $jnLwa.sample(notifier)(this);
}
$21c60c7e578818d3$export$4812e460280c6ef2 = $21c60c7e578818d3$var$sample;

});
parcelRegister("jnLwa", function(module, exports) {
"use strict";
var $e1c50657a47263a2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */ function $e1c50657a47263a2$var$sample(notifier) {
    return function(source) {
        return source.lift(new $e1c50657a47263a2$var$SampleOperator(notifier));
    };
}
module.exports.sample = $e1c50657a47263a2$var$sample;
var $e1c50657a47263a2$var$SampleOperator = function() {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function(subscriber, source) {
        var sampleSubscriber = new $e1c50657a47263a2$var$SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add($d3klE.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e1c50657a47263a2$var$SampleSubscriber = function(_super) {
    $e1c50657a47263a2$var$__extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function() {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("6fPoo", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $4OSQT = parcelRequire("4OSQT");
$b0T1M.Observable.prototype.sampleTime = $4OSQT.sampleTime;

});
parcelRegister("4OSQT", function(module, exports) {
$parcel$export(module.exports, "sampleTime", () => $3826616caf84b1aa$export$fe33c7b2002d97b0, (v) => $3826616caf84b1aa$export$fe33c7b2002d97b0 = v);
var $3826616caf84b1aa$export$fe33c7b2002d97b0;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $9bNPU = parcelRequire("9bNPU");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $3826616caf84b1aa$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $9bNPU.sampleTime(period, scheduler)(this);
}
$3826616caf84b1aa$export$fe33c7b2002d97b0 = $3826616caf84b1aa$var$sampleTime;

});
parcelRegister("9bNPU", function(module, exports) {
"use strict";
var $6b0bcc8d5bd5eaf9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $hBoCS = parcelRequire("hBoCS");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $6b0bcc8d5bd5eaf9$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return function(source) {
        return source.lift(new $6b0bcc8d5bd5eaf9$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $6b0bcc8d5bd5eaf9$var$sampleTime;
var $6b0bcc8d5bd5eaf9$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6b0bcc8d5bd5eaf9$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6b0bcc8d5bd5eaf9$var$SampleTimeSubscriber = function(_super) {
    $6b0bcc8d5bd5eaf9$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($6b0bcc8d5bd5eaf9$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($kVbBc.Subscriber);
function $6b0bcc8d5bd5eaf9$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});



parcelRegister("eNoD1", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $6dEgF = parcelRequire("6dEgF");
$b0T1M.Observable.prototype.scan = $6dEgF.scan;

});
parcelRegister("6dEgF", function(module, exports) {
$parcel$export(module.exports, "scan", () => $48733152d38e0cd1$export$c87d910e63d22ed6, (v) => $48733152d38e0cd1$export$c87d910e63d22ed6 = v);
var $48733152d38e0cd1$export$c87d910e63d22ed6;
"use strict";

var $lPaeJ = parcelRequire("lPaeJ");
/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $48733152d38e0cd1$var$scan(accumulator, seed) {
    if (arguments.length >= 2) return $lPaeJ.scan(accumulator, seed)(this);
    return $lPaeJ.scan(accumulator)(this);
}
$48733152d38e0cd1$export$c87d910e63d22ed6 = $48733152d38e0cd1$var$scan;

});


parcelRegister("6lOOS", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $fClLR = parcelRequire("fClLR");
$b0T1M.Observable.prototype.sequenceEqual = $fClLR.sequenceEqual;

});
parcelRegister("fClLR", function(module, exports) {
$parcel$export(module.exports, "sequenceEqual", () => $b5eb4ae7a155dcd0$export$d0a07e60ae428313, (v) => $b5eb4ae7a155dcd0$export$d0a07e60ae428313 = v);
var $b5eb4ae7a155dcd0$export$d0a07e60ae428313;
"use strict";

var $84CWP = parcelRequire("84CWP");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $b5eb4ae7a155dcd0$var$sequenceEqual(compareTo, comparor) {
    return $84CWP.sequenceEqual(compareTo, comparor)(this);
}
$b5eb4ae7a155dcd0$export$d0a07e60ae428313 = $b5eb4ae7a155dcd0$var$sequenceEqual;

});
parcelRegister("84CWP", function(module, exports) {
"use strict";
var $5e0ce8ae9a609d30$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $5e0ce8ae9a609d30$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $5e0ce8ae9a609d30$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $5e0ce8ae9a609d30$var$sequenceEqual;
var $5e0ce8ae9a609d30$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5e0ce8ae9a609d30$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $5e0ce8ae9a609d30$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5e0ce8ae9a609d30$var$SequenceEqualSubscriber = function(_super) {
    $5e0ce8ae9a609d30$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $5e0ce8ae9a609d30$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $3kkLM.tryCatch(comparor)(a, b);
                if (areEqual === $geExo.errorObject) this.destination.error($geExo.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($kVbBc.Subscriber);
module.exports.SequenceEqualSubscriber = $5e0ce8ae9a609d30$var$SequenceEqualSubscriber;
var $5e0ce8ae9a609d30$var$SequenceEqualCompareToSubscriber = function(_super) {
    $5e0ce8ae9a609d30$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("2WBJx", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $1kFvW = parcelRequire("1kFvW");
$b0T1M.Observable.prototype.share = $1kFvW.share;

});
parcelRegister("1kFvW", function(module, exports) {
$parcel$export(module.exports, "share", () => $0f87dc8e581953d1$export$ed80d9de1d9df928, (v) => $0f87dc8e581953d1$export$ed80d9de1d9df928 = v);
var $0f87dc8e581953d1$export$ed80d9de1d9df928;
"use strict";

var $iGWJA = parcelRequire("iGWJA");
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 *
 * This behaves similarly to .publish().refCount(), with a behavior difference when the source observable emits complete.
 * .publish().refCount() will not resubscribe to the original source, however .share() will resubscribe to the original source.
 * Observable.of("test").publish().refCount() will not re-emit "test" on new subscriptions, Observable.of("test").share() will
 * re-emit "test" to new subscriptions.
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $0f87dc8e581953d1$var$share() {
    return $iGWJA.share()(this);
}
$0f87dc8e581953d1$export$ed80d9de1d9df928 = $0f87dc8e581953d1$var$share;

});
parcelRegister("iGWJA", function(module, exports) {
$parcel$export(module.exports, "share", () => $d9b9b5a921a27038$export$ed80d9de1d9df928, (v) => $d9b9b5a921a27038$export$ed80d9de1d9df928 = v);
var $d9b9b5a921a27038$export$ed80d9de1d9df928;
"use strict";

var $dxmlm = parcelRequire("dxmlm");

var $d1zoQ = parcelRequire("d1zoQ");

var $hJCZY = parcelRequire("hJCZY");
function $d9b9b5a921a27038$var$shareSubjectFactory() {
    return new $hJCZY.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .multicast(() => new Subject()).refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */ function $d9b9b5a921a27038$var$share() {
    return function(source) {
        return $d1zoQ.refCount()($dxmlm.multicast($d9b9b5a921a27038$var$shareSubjectFactory)(source));
    };
}
$d9b9b5a921a27038$export$ed80d9de1d9df928 = $d9b9b5a921a27038$var$share;

});



parcelRegister("14Cty", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $bq2Aw = parcelRequire("bq2Aw");
$b0T1M.Observable.prototype.shareReplay = $bq2Aw.shareReplay;

});
parcelRegister("bq2Aw", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $85042156e4f8611f$export$db61d692014e534e, (v) => $85042156e4f8611f$export$db61d692014e534e = v);
var $85042156e4f8611f$export$db61d692014e534e;
"use strict";

var $bNlZl = parcelRequire("bNlZl");
/**
 * @method shareReplay
 * @owner Observable
 */ function $85042156e4f8611f$var$shareReplay(bufferSize, windowTime, scheduler) {
    return $bNlZl.shareReplay(bufferSize, windowTime, scheduler)(this);
}
$85042156e4f8611f$export$db61d692014e534e = $85042156e4f8611f$var$shareReplay;

});
parcelRegister("bNlZl", function(module, exports) {
$parcel$export(module.exports, "shareReplay", () => $896553bc0fc88fa5$export$db61d692014e534e, (v) => $896553bc0fc88fa5$export$db61d692014e534e = v);
var $896553bc0fc88fa5$export$db61d692014e534e;
"use strict";

var $gNLuz = parcelRequire("gNLuz");
/**
 * @method shareReplay
 * @owner Observable
 */ function $896553bc0fc88fa5$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($896553bc0fc88fa5$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$896553bc0fc88fa5$export$db61d692014e534e = $896553bc0fc88fa5$var$shareReplay;
function $896553bc0fc88fa5$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $gNLuz.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});



parcelRegister("egqDo", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $cy4vf = parcelRequire("cy4vf");
$b0T1M.Observable.prototype.single = $cy4vf.single;

});
parcelRegister("cy4vf", function(module, exports) {
$parcel$export(module.exports, "single", () => $922c27396aecab47$export$863d7ca51b416cee, (v) => $922c27396aecab47$export$863d7ca51b416cee = v);
var $922c27396aecab47$export$863d7ca51b416cee;
"use strict";

var $3X7EG = parcelRequire("3X7EG");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $922c27396aecab47$var$single(predicate) {
    return $3X7EG.single(predicate)(this);
}
$922c27396aecab47$export$863d7ca51b416cee = $922c27396aecab47$var$single;

});
parcelRegister("3X7EG", function(module, exports) {
"use strict";
var $2e0cd1f33b4df031$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $7Aiqv = parcelRequire("7Aiqv");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $2e0cd1f33b4df031$var$single(predicate) {
    return function(source) {
        return source.lift(new $2e0cd1f33b4df031$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $2e0cd1f33b4df031$var$single;
var $2e0cd1f33b4df031$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2e0cd1f33b4df031$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e0cd1f33b4df031$var$SingleSubscriber = function(_super) {
    $2e0cd1f33b4df031$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $7Aiqv.EmptyError);
    };
    return SingleSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("4VrXW", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $esVuU = parcelRequire("esVuU");
$b0T1M.Observable.prototype.skip = $esVuU.skip;

});
parcelRegister("esVuU", function(module, exports) {
$parcel$export(module.exports, "skip", () => $a880480234424004$export$955fc4a6c4be454d, (v) => $a880480234424004$export$955fc4a6c4be454d = v);
var $a880480234424004$export$955fc4a6c4be454d;
"use strict";

var $h0mxd = parcelRequire("h0mxd");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $a880480234424004$var$skip(count) {
    return $h0mxd.skip(count)(this);
}
$a880480234424004$export$955fc4a6c4be454d = $a880480234424004$var$skip;

});
parcelRegister("h0mxd", function(module, exports) {
"use strict";
var $c613eaaf83e5031c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $c613eaaf83e5031c$var$skip(count) {
    return function(source) {
        return source.lift(new $c613eaaf83e5031c$var$SkipOperator(count));
    };
}
module.exports.skip = $c613eaaf83e5031c$var$skip;
var $c613eaaf83e5031c$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $c613eaaf83e5031c$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c613eaaf83e5031c$var$SkipSubscriber = function(_super) {
    $c613eaaf83e5031c$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("ja8MS", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $8UNgl = parcelRequire("8UNgl");
$b0T1M.Observable.prototype.skipLast = $8UNgl.skipLast;

});
parcelRegister("8UNgl", function(module, exports) {
$parcel$export(module.exports, "skipLast", () => $67d9c43605c14af4$export$635f6273df29ea1c, (v) => $67d9c43605c14af4$export$635f6273df29ea1c = v);
var $67d9c43605c14af4$export$635f6273df29ea1c;
"use strict";

var $i5z7t = parcelRequire("i5z7t");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $67d9c43605c14af4$var$skipLast(count) {
    return $i5z7t.skipLast(count)(this);
}
$67d9c43605c14af4$export$635f6273df29ea1c = $67d9c43605c14af4$var$skipLast;

});
parcelRegister("i5z7t", function(module, exports) {
"use strict";
var $d2b3efa518970ef9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $9pTpk = parcelRequire("9pTpk");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $d2b3efa518970ef9$var$skipLast(count) {
    return function(source) {
        return source.lift(new $d2b3efa518970ef9$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $d2b3efa518970ef9$var$skipLast;
var $d2b3efa518970ef9$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $9pTpk.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $kVbBc.Subscriber(subscriber));
        else return source.subscribe(new $d2b3efa518970ef9$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d2b3efa518970ef9$var$SkipLastSubscriber = function(_super) {
    $d2b3efa518970ef9$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("cXyXt", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $9W6qK = parcelRequire("9W6qK");
$b0T1M.Observable.prototype.skipUntil = $9W6qK.skipUntil;

});
parcelRegister("9W6qK", function(module, exports) {
$parcel$export(module.exports, "skipUntil", () => $73be84c20de29540$export$facc584867c26fde, (v) => $73be84c20de29540$export$facc584867c26fde = v);
var $73be84c20de29540$export$facc584867c26fde;
"use strict";

var $ijRaO = parcelRequire("ijRaO");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $73be84c20de29540$var$skipUntil(notifier) {
    return $ijRaO.skipUntil(notifier)(this);
}
$73be84c20de29540$export$facc584867c26fde = $73be84c20de29540$var$skipUntil;

});
parcelRegister("ijRaO", function(module, exports) {
"use strict";
var $d5633f7bc9b586b5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $d5633f7bc9b586b5$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $d5633f7bc9b586b5$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $d5633f7bc9b586b5$var$skipUntil;
var $d5633f7bc9b586b5$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d5633f7bc9b586b5$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5633f7bc9b586b5$var$SkipUntilSubscriber = function(_super) {
    $d5633f7bc9b586b5$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($d3klE.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("fHgTN", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $4dXq5 = parcelRequire("4dXq5");
$b0T1M.Observable.prototype.skipWhile = $4dXq5.skipWhile;

});
parcelRegister("4dXq5", function(module, exports) {
$parcel$export(module.exports, "skipWhile", () => $313677dedec2453d$export$175dedd748069215, (v) => $313677dedec2453d$export$175dedd748069215 = v);
var $313677dedec2453d$export$175dedd748069215;
"use strict";

var $3fUQw = parcelRequire("3fUQw");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $313677dedec2453d$var$skipWhile(predicate) {
    return $3fUQw.skipWhile(predicate)(this);
}
$313677dedec2453d$export$175dedd748069215 = $313677dedec2453d$var$skipWhile;

});
parcelRegister("3fUQw", function(module, exports) {
"use strict";
var $25eede475ebb3e31$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $25eede475ebb3e31$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $25eede475ebb3e31$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $25eede475ebb3e31$var$skipWhile;
var $25eede475ebb3e31$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $25eede475ebb3e31$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $25eede475ebb3e31$var$SkipWhileSubscriber = function(_super) {
    $25eede475ebb3e31$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("ixqMu", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $5LH3h = parcelRequire("5LH3h");
$b0T1M.Observable.prototype.startWith = $5LH3h.startWith;

});
parcelRegister("5LH3h", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $4332bcc21a508a8c$export$a4fe86229b0e9bdd, (v) => $4332bcc21a508a8c$export$a4fe86229b0e9bdd = v);
var $4332bcc21a508a8c$export$a4fe86229b0e9bdd;
"use strict";

var $HSnUx = parcelRequire("HSnUx");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $4332bcc21a508a8c$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return $HSnUx.startWith.apply(void 0, array)(this);
}
$4332bcc21a508a8c$export$a4fe86229b0e9bdd = $4332bcc21a508a8c$var$startWith;

});
parcelRegister("HSnUx", function(module, exports) {
$parcel$export(module.exports, "startWith", () => $083e33ed5b8b8072$export$a4fe86229b0e9bdd, (v) => $083e33ed5b8b8072$export$a4fe86229b0e9bdd = v);
var $083e33ed5b8b8072$export$a4fe86229b0e9bdd;
"use strict";

var $fS4Qr = parcelRequire("fS4Qr");

var $28a5P = parcelRequire("28a5P");

var $lmQ1o = parcelRequire("lmQ1o");

var $jd6MB = parcelRequire("jd6MB");

var $6eaCl = parcelRequire("6eaCl");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */ function $083e33ed5b8b8072$var$startWith() {
    var array = [];
    for(var _i = 0; _i < arguments.length; _i++)array[_i - 0] = arguments[_i];
    return function(source) {
        var scheduler = array[array.length - 1];
        if ($6eaCl.isScheduler(scheduler)) array.pop();
        else scheduler = null;
        var len = array.length;
        if (len === 1) return $jd6MB.concat(new $28a5P.ScalarObservable(array[0], scheduler), source);
        else if (len > 1) return $jd6MB.concat(new $fS4Qr.ArrayObservable(array, scheduler), source);
        else return $jd6MB.concat(new $lmQ1o.EmptyObservable(scheduler), source);
    };
}
$083e33ed5b8b8072$export$a4fe86229b0e9bdd = $083e33ed5b8b8072$var$startWith;

});



parcelRegister("ibIeh", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $druk1 = parcelRequire("druk1");
$b0T1M.Observable.prototype.subscribeOn = $druk1.subscribeOn;

});
parcelRegister("druk1", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $9c95514f1c5c2a9f$export$1eb44d8f5f64733b, (v) => $9c95514f1c5c2a9f$export$1eb44d8f5f64733b = v);
var $9c95514f1c5c2a9f$export$1eb44d8f5f64733b;
"use strict";

var $6C2Ml = parcelRequire("6C2Ml");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $9c95514f1c5c2a9f$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return $6C2Ml.subscribeOn(scheduler, delay)(this);
}
$9c95514f1c5c2a9f$export$1eb44d8f5f64733b = $9c95514f1c5c2a9f$var$subscribeOn;

});
parcelRegister("6C2Ml", function(module, exports) {
$parcel$export(module.exports, "subscribeOn", () => $4d08727f8675f663$export$1eb44d8f5f64733b, (v) => $4d08727f8675f663$export$1eb44d8f5f64733b = v);
var $4d08727f8675f663$export$1eb44d8f5f64733b;
"use strict";

var $i7KQ2 = parcelRequire("i7KQ2");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */ function $4d08727f8675f663$var$subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return function subscribeOnOperatorFunction(source) {
        return source.lift(new $4d08727f8675f663$var$SubscribeOnOperator(scheduler, delay));
    };
}
$4d08727f8675f663$export$1eb44d8f5f64733b = $4d08727f8675f663$var$subscribeOn;
var $4d08727f8675f663$var$SubscribeOnOperator = function() {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function(subscriber, source) {
        return new $i7KQ2.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}();

});
parcelRegister("i7KQ2", function(module, exports) {
"use strict";
var $d31d368bbd11e053$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $w0jLy = parcelRequire("w0jLy");

var $kAEty = parcelRequire("kAEty");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */ var $d31d368bbd11e053$var$SubscribeOnObservable = function(_super) {
    $d31d368bbd11e053$var$__extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) delayTime = 0;
        if (scheduler === void 0) scheduler = $w0jLy.asap;
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!$kAEty.isNumeric(delayTime) || delayTime < 0) this.delayTime = 0;
        if (!scheduler || typeof scheduler.schedule !== 'function') this.scheduler = $w0jLy.asap;
    }
    SubscribeOnObservable.create = function(source, delay, scheduler) {
        if (delay === void 0) delay = 0;
        if (scheduler === void 0) scheduler = $w0jLy.asap;
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function(arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    /** @deprecated internal use only */ SubscribeOnObservable.prototype._subscribe = function(subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source,
            subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}($b0T1M.Observable);
module.exports.SubscribeOnObservable = $d31d368bbd11e053$var$SubscribeOnObservable;

});
parcelRegister("w0jLy", function(module, exports) {
$parcel$export(module.exports, "asap", () => $06033c6231dd4662$export$dc4d482300a341e1, (v) => $06033c6231dd4662$export$dc4d482300a341e1 = v);
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */ var $06033c6231dd4662$export$dc4d482300a341e1;
"use strict";

var $374ja = parcelRequire("374ja");

var $1Dduj = parcelRequire("1Dduj");
$06033c6231dd4662$export$dc4d482300a341e1 = new $1Dduj.AsapScheduler($374ja.AsapAction);

});
parcelRegister("374ja", function(module, exports) {
"use strict";
var $24455e08c2073c8a$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $6m7Dr = parcelRequire("6m7Dr");

var $jvUn0 = parcelRequire("jvUn0");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $24455e08c2073c8a$var$AsapAction = function(_super) {
    $24455e08c2073c8a$var$__extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = $6m7Dr.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            $6m7Dr.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}($jvUn0.AsyncAction);
module.exports.AsapAction = $24455e08c2073c8a$var$AsapAction;

});
parcelRegister("6m7Dr", function(module, exports) {
$parcel$export(module.exports, "Immediate", () => $4a0ab85b00cf3593$export$9bf7f22d83f7b5af, (v) => $4a0ab85b00cf3593$export$9bf7f22d83f7b5af = v);
/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/ var $4a0ab85b00cf3593$export$9dc12cb738f70fa0;
var $4a0ab85b00cf3593$export$9bf7f22d83f7b5af;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
var $4a0ab85b00cf3593$var$ImmediateDefinition = function() {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        } else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) // For Node.js before 0.9
            this.setImmediate = this.createProcessNextTickSetImmediate();
            else if (this.canUsePostMessage()) // For non-IE10 modern browsers
            this.setImmediate = this.createPostMessageSetImmediate();
            else if (this.canUseMessageChannel()) // For web workers, where supported
            this.setImmediate = this.createMessageChannelSetImmediate();
            else if (this.canUseReadyStateChange()) // For IE 6–8
            this.setImmediate = this.createReadyStateChangeSetImmediate();
            else // For older browsers
            this.setImmediate = this.createSetTimeoutSetImmediate();
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function(o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function() {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function() {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function() {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function() {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function() {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function(handler) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') handler.apply(undefined, args);
            else new Function('' + handler)();
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function(args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root && typeof event.data === 'string' && event.data.indexOf(messagePrefix) === 0) instance.runIfPresent(+event.data.slice(messagePrefix.length));
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function(handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // 'too much recursion' error.
        this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                } finally{
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function() {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function() {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function() {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}();
$4a0ab85b00cf3593$export$9dc12cb738f70fa0 = $4a0ab85b00cf3593$var$ImmediateDefinition;
$4a0ab85b00cf3593$export$9bf7f22d83f7b5af = new $4a0ab85b00cf3593$var$ImmediateDefinition($jYFjc.root);

});


parcelRegister("1Dduj", function(module, exports) {
"use strict";
var $1303e55e4a25ab08$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $63qby = parcelRequire("63qby");
var $1303e55e4a25ab08$var$AsapScheduler = function(_super) {
    $1303e55e4a25ab08$var$__extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}($63qby.AsyncScheduler);
module.exports.AsapScheduler = $1303e55e4a25ab08$var$AsapScheduler;

});






parcelRegister("6YHdg", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $4DdO6 = parcelRequire("4DdO6");
$b0T1M.Observable.prototype.switch = $4DdO6._switch;
$b0T1M.Observable.prototype._switch = $4DdO6._switch;

});
parcelRegister("4DdO6", function(module, exports) {
$parcel$export(module.exports, "_switch", () => $35f583c223325c4f$export$424b8b2ab9af2944, (v) => $35f583c223325c4f$export$424b8b2ab9af2944 = v);
var $35f583c223325c4f$export$424b8b2ab9af2944;
"use strict";

var $Uppq8 = parcelRequire("Uppq8");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */ function $35f583c223325c4f$var$_switch() {
    return $Uppq8.switchAll()(this);
}
$35f583c223325c4f$export$424b8b2ab9af2944 = $35f583c223325c4f$var$_switch;

});
parcelRegister("Uppq8", function(module, exports) {
$parcel$export(module.exports, "switchAll", () => $0a98f0c6f95a3793$export$6a45284a4b0bf33a, (v) => $0a98f0c6f95a3793$export$6a45284a4b0bf33a = v);
var $0a98f0c6f95a3793$export$6a45284a4b0bf33a;
"use strict";

var $3hXUB = parcelRequire("3hXUB");

var $3a2S6 = parcelRequire("3a2S6");
function $0a98f0c6f95a3793$var$switchAll() {
    return $3hXUB.switchMap($3a2S6.identity);
}
$0a98f0c6f95a3793$export$6a45284a4b0bf33a = $0a98f0c6f95a3793$var$switchAll;

});



parcelRegister("km5LH", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $6tFNK = parcelRequire("6tFNK");
$b0T1M.Observable.prototype.switchMap = $6tFNK.switchMap;

});

parcelRegister("9O0Lj", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $bY0iX = parcelRequire("bY0iX");
$b0T1M.Observable.prototype.switchMapTo = $bY0iX.switchMapTo;

});
parcelRegister("bY0iX", function(module, exports) {
$parcel$export(module.exports, "switchMapTo", () => $8b6588d2212bfa2f$export$a439dc30c845238, (v) => $8b6588d2212bfa2f$export$a439dc30c845238 = v);
var $8b6588d2212bfa2f$export$a439dc30c845238;
"use strict";

var $4Knek = parcelRequire("4Knek");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $8b6588d2212bfa2f$var$switchMapTo(innerObservable, resultSelector) {
    return $4Knek.switchMapTo(innerObservable, resultSelector)(this);
}
$8b6588d2212bfa2f$export$a439dc30c845238 = $8b6588d2212bfa2f$var$switchMapTo;

});
parcelRegister("4Knek", function(module, exports) {
"use strict";
var $374d7a5465b5909f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */ function $374d7a5465b5909f$var$switchMapTo(innerObservable, resultSelector) {
    return function(source) {
        return source.lift(new $374d7a5465b5909f$var$SwitchMapToOperator(innerObservable, resultSelector));
    };
}
module.exports.switchMapTo = $374d7a5465b5909f$var$switchMapTo;
var $374d7a5465b5909f$var$SwitchMapToOperator = function() {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $374d7a5465b5909f$var$SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $374d7a5465b5909f$var$SwitchMapToSubscriber = function(_super) {
    $374d7a5465b5909f$var$__extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function(value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $d3klE.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapToSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("kOGz4", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $jpukU = parcelRequire("jpukU");
$b0T1M.Observable.prototype.take = $jpukU.take;

});
parcelRegister("jpukU", function(module, exports) {
$parcel$export(module.exports, "take", () => $e217e248378074a2$export$b7df5d561049483a, (v) => $e217e248378074a2$export$b7df5d561049483a = v);
var $e217e248378074a2$export$b7df5d561049483a;
"use strict";

var $6mUvG = parcelRequire("6mUvG");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $e217e248378074a2$var$take(count) {
    return $6mUvG.take(count)(this);
}
$e217e248378074a2$export$b7df5d561049483a = $e217e248378074a2$var$take;

});
parcelRegister("6mUvG", function(module, exports) {
"use strict";
var $4a30a1d85c41ceab$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $9pTpk = parcelRequire("9pTpk");

var $lmQ1o = parcelRequire("lmQ1o");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $4a30a1d85c41ceab$var$take(count) {
    return function(source) {
        if (count === 0) return new $lmQ1o.EmptyObservable();
        else return source.lift(new $4a30a1d85c41ceab$var$TakeOperator(count));
    };
}
module.exports.take = $4a30a1d85c41ceab$var$take;
var $4a30a1d85c41ceab$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $9pTpk.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $4a30a1d85c41ceab$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4a30a1d85c41ceab$var$TakeSubscriber = function(_super) {
    $4a30a1d85c41ceab$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("let7e", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $gEwpb = parcelRequire("gEwpb");
$b0T1M.Observable.prototype.takeLast = $gEwpb.takeLast;

});
parcelRegister("gEwpb", function(module, exports) {
$parcel$export(module.exports, "takeLast", () => $c1f984bd161698fe$export$1b47ad771ce5af5e, (v) => $c1f984bd161698fe$export$1b47ad771ce5af5e = v);
var $c1f984bd161698fe$export$1b47ad771ce5af5e;
"use strict";

var $ilSxQ = parcelRequire("ilSxQ");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $c1f984bd161698fe$var$takeLast(count) {
    return $ilSxQ.takeLast(count)(this);
}
$c1f984bd161698fe$export$1b47ad771ce5af5e = $c1f984bd161698fe$var$takeLast;

});


parcelRegister("atcms", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $2jZdg = parcelRequire("2jZdg");
$b0T1M.Observable.prototype.takeUntil = $2jZdg.takeUntil;

});
parcelRegister("2jZdg", function(module, exports) {
$parcel$export(module.exports, "takeUntil", () => $1b0cd6bf8129d824$export$ac8dfd3a7ad06e80, (v) => $1b0cd6bf8129d824$export$ac8dfd3a7ad06e80 = v);
var $1b0cd6bf8129d824$export$ac8dfd3a7ad06e80;
"use strict";

var $jyvpZ = parcelRequire("jyvpZ");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value, the output Observable stops mirroring the source Observable
 * and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $1b0cd6bf8129d824$var$takeUntil(notifier) {
    return $jyvpZ.takeUntil(notifier)(this);
}
$1b0cd6bf8129d824$export$ac8dfd3a7ad06e80 = $1b0cd6bf8129d824$var$takeUntil;

});
parcelRegister("jyvpZ", function(module, exports) {
"use strict";
var $e3c9905059492f74$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */ function $e3c9905059492f74$var$takeUntil(notifier) {
    return function(source) {
        return source.lift(new $e3c9905059492f74$var$TakeUntilOperator(notifier));
    };
}
module.exports.takeUntil = $e3c9905059492f74$var$takeUntil;
var $e3c9905059492f74$var$TakeUntilOperator = function() {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e3c9905059492f74$var$TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e3c9905059492f74$var$TakeUntilSubscriber = function(_super) {
    $e3c9905059492f74$var$__extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add($d3klE.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    return TakeUntilSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("8px1l", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $5MIRA = parcelRequire("5MIRA");
$b0T1M.Observable.prototype.takeWhile = $5MIRA.takeWhile;

});
parcelRegister("5MIRA", function(module, exports) {
$parcel$export(module.exports, "takeWhile", () => $43643c60a18530b6$export$9384c7afe4015e42, (v) => $43643c60a18530b6$export$9384c7afe4015e42 = v);
var $43643c60a18530b6$export$9384c7afe4015e42;
"use strict";

var $JU7sv = parcelRequire("JU7sv");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $43643c60a18530b6$var$takeWhile(predicate) {
    return $JU7sv.takeWhile(predicate)(this);
}
$43643c60a18530b6$export$9384c7afe4015e42 = $43643c60a18530b6$var$takeWhile;

});
parcelRegister("JU7sv", function(module, exports) {
"use strict";
var $089fbc3563077d65$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */ function $089fbc3563077d65$var$takeWhile(predicate) {
    return function(source) {
        return source.lift(new $089fbc3563077d65$var$TakeWhileOperator(predicate));
    };
}
module.exports.takeWhile = $089fbc3563077d65$var$takeWhile;
var $089fbc3563077d65$var$TakeWhileOperator = function() {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $089fbc3563077d65$var$TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $089fbc3563077d65$var$TakeWhileSubscriber = function(_super) {
    $089fbc3563077d65$var$__extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        } catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function(value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) destination.next(value);
        else destination.complete();
    };
    return TakeWhileSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("bI8PG", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $eUU5V = parcelRequire("eUU5V");
$b0T1M.Observable.prototype.throttle = $eUU5V.throttle;

});
parcelRegister("eUU5V", function(module, exports) {
$parcel$export(module.exports, "throttle", () => $adc1ceddf56da104$export$de363e709c412c8a, (v) => $adc1ceddf56da104$export$de363e709c412c8a = v);
var $adc1ceddf56da104$export$de363e709c412c8a;
"use strict";

var $5yPdY = parcelRequire("5yPdY");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $adc1ceddf56da104$var$throttle(durationSelector, config) {
    if (config === void 0) config = $5yPdY.defaultThrottleConfig;
    return $5yPdY.throttle(durationSelector, config)(this);
}
$adc1ceddf56da104$export$de363e709c412c8a = $adc1ceddf56da104$var$throttle;

});
parcelRegister("5yPdY", function(module, exports) {
"use strict";
var $40c7dcce6e8608ec$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
module.exports.defaultThrottleConfig = {
    leading: true,
    trailing: false
};
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @param {Object} config a configuration object to define `leading` and `trailing` behavior. Defaults
 * to `{ leading: true, trailing: false }`.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */ function $40c7dcce6e8608ec$var$throttle(durationSelector, config) {
    if (config === void 0) config = module.exports.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $40c7dcce6e8608ec$var$ThrottleOperator(durationSelector, config.leading, config.trailing));
    };
}
module.exports.throttle = $40c7dcce6e8608ec$var$throttle;
var $40c7dcce6e8608ec$var$ThrottleOperator = function() {
    function ThrottleOperator(durationSelector, leading, trailing) {
        this.durationSelector = durationSelector;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $40c7dcce6e8608ec$var$ThrottleSubscriber(subscriber, this.durationSelector, this.leading, this.trailing));
    };
    return ThrottleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc
 * @ignore
 * @extends {Ignored}
 */ var $40c7dcce6e8608ec$var$ThrottleSubscriber = function(_super) {
    $40c7dcce6e8608ec$var$__extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector, _leading, _trailing) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
        this._leading = _leading;
        this._trailing = _trailing;
        this._hasTrailingValue = false;
    }
    ThrottleSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this._trailing) {
                this._hasTrailingValue = true;
                this._trailingValue = value;
            }
        } else {
            var duration = this.tryDurationSelector(value);
            if (duration) this.add(this.throttled = $d3klE.subscribeToResult(this, duration));
            if (this._leading) {
                this.destination.next(value);
                if (this._trailing) {
                    this._hasTrailingValue = true;
                    this._trailingValue = value;
                }
            }
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function(value) {
        try {
            return this.durationSelector(value);
        } catch (err) {
            this.destination.error(err);
            return null;
        }
    };
    /** @deprecated internal use only */ ThrottleSubscriber.prototype._unsubscribe = function() {
        var _a = this, throttled = _a.throttled, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue, _trailing = _a._trailing;
        this._trailingValue = null;
        this._hasTrailingValue = false;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype._sendTrailing = function() {
        var _a = this, destination = _a.destination, throttled = _a.throttled, _trailing = _a._trailing, _trailingValue = _a._trailingValue, _hasTrailingValue = _a._hasTrailingValue;
        if (throttled && _trailing && _hasTrailingValue) {
            destination.next(_trailingValue);
            this._trailingValue = null;
            this._hasTrailingValue = false;
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._sendTrailing();
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function() {
        this._sendTrailing();
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("2RbJd", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $ldQjd = parcelRequire("ldQjd");
$b0T1M.Observable.prototype.throttleTime = $ldQjd.throttleTime;

});
parcelRegister("ldQjd", function(module, exports) {
$parcel$export(module.exports, "throttleTime", () => $f733634f9a6d97b8$export$4efe28f192921dd4, (v) => $f733634f9a6d97b8$export$4efe28f192921dd4 = v);
var $f733634f9a6d97b8$export$4efe28f192921dd4;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $5yPdY = parcelRequire("5yPdY");

var $29wCr = parcelRequire("29wCr");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $f733634f9a6d97b8$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    if (config === void 0) config = $5yPdY.defaultThrottleConfig;
    return $29wCr.throttleTime(duration, scheduler, config)(this);
}
$f733634f9a6d97b8$export$4efe28f192921dd4 = $f733634f9a6d97b8$var$throttleTime;

});
parcelRegister("29wCr", function(module, exports) {
"use strict";
var $1915b97d546b50d5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $hBoCS = parcelRequire("hBoCS");

var $5yPdY = parcelRequire("5yPdY");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the throttling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */ function $1915b97d546b50d5$var$throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    if (config === void 0) config = $5yPdY.defaultThrottleConfig;
    return function(source) {
        return source.lift(new $1915b97d546b50d5$var$ThrottleTimeOperator(duration, scheduler, config.leading, config.trailing));
    };
}
module.exports.throttleTime = $1915b97d546b50d5$var$throttleTime;
var $1915b97d546b50d5$var$ThrottleTimeOperator = function() {
    function ThrottleTimeOperator(duration, scheduler, leading, trailing) {
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
    }
    ThrottleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1915b97d546b50d5$var$ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler, this.leading, this.trailing));
    };
    return ThrottleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1915b97d546b50d5$var$ThrottleTimeSubscriber = function(_super) {
    $1915b97d546b50d5$var$__extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler, leading, trailing) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.leading = leading;
        this.trailing = trailing;
        this._hasTrailingValue = false;
        this._trailingValue = null;
    }
    ThrottleTimeSubscriber.prototype._next = function(value) {
        if (this.throttled) {
            if (this.trailing) {
                this._trailingValue = value;
                this._hasTrailingValue = true;
            }
        } else {
            this.add(this.throttled = this.scheduler.schedule($1915b97d546b50d5$var$dispatchNext, this.duration, {
                subscriber: this
            }));
            if (this.leading) this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function() {
        var throttled = this.throttled;
        if (throttled) {
            if (this.trailing && this._hasTrailingValue) {
                this.destination.next(this._trailingValue);
                this._trailingValue = null;
                this._hasTrailingValue = false;
            }
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}($kVbBc.Subscriber);
function $1915b97d546b50d5$var$dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}

});



parcelRegister("lxuro", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $eqcG8 = parcelRequire("eqcG8");
$b0T1M.Observable.prototype.timeInterval = $eqcG8.timeInterval;

});
parcelRegister("eqcG8", function(module, exports) {
$parcel$export(module.exports, "TimeInterval", () => $a7fd541567dfc872$export$8bb95198b45adaac, (v) => $a7fd541567dfc872$export$8bb95198b45adaac = v);
$parcel$export(module.exports, "timeInterval", () => $a7fd541567dfc872$export$1a539c8b2950ab40, (v) => $a7fd541567dfc872$export$1a539c8b2950ab40 = v);
var $a7fd541567dfc872$export$8bb95198b45adaac;
var $a7fd541567dfc872$export$1a539c8b2950ab40;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $gIhPu = parcelRequire("gIhPu");
$a7fd541567dfc872$export$8bb95198b45adaac = $gIhPu.TimeInterval;
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */ function $a7fd541567dfc872$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $gIhPu.timeInterval(scheduler)(this);
}
$a7fd541567dfc872$export$1a539c8b2950ab40 = $a7fd541567dfc872$var$timeInterval;

});
parcelRegister("gIhPu", function(module, exports) {
"use strict";
var $c2ae95f4dc94c0db$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $hBoCS = parcelRequire("hBoCS");
function $c2ae95f4dc94c0db$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return function(source) {
        return source.lift(new $c2ae95f4dc94c0db$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $c2ae95f4dc94c0db$var$timeInterval;
var $c2ae95f4dc94c0db$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $c2ae95f4dc94c0db$var$TimeInterval;
var $c2ae95f4dc94c0db$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $c2ae95f4dc94c0db$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $c2ae95f4dc94c0db$var$TimeIntervalSubscriber = function(_super) {
    $c2ae95f4dc94c0db$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $c2ae95f4dc94c0db$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("lT4IG", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $fAadw = parcelRequire("fAadw");
$b0T1M.Observable.prototype.timeout = $fAadw.timeout;

});
parcelRegister("fAadw", function(module, exports) {
$parcel$export(module.exports, "timeout", () => $b58224b432bc02b4$export$83e74882c5df8fe1, (v) => $b58224b432bc02b4$export$83e74882c5df8fe1 = v);
var $b58224b432bc02b4$export$83e74882c5df8fe1;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $bb70W = parcelRequire("bb70W");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $b58224b432bc02b4$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $bb70W.timeout(due, scheduler)(this);
}
$b58224b432bc02b4$export$83e74882c5df8fe1 = $b58224b432bc02b4$var$timeout;

});
parcelRegister("bb70W", function(module, exports) {
"use strict";
var $823629a6f3625f0d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hBoCS = parcelRequire("hBoCS");

var $lrUXm = parcelRequire("lrUXm");

var $kVbBc = parcelRequire("kVbBc");

var $l8UrM = parcelRequire("l8UrM");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $823629a6f3625f0d$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    var absoluteTimeout = $lrUXm.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $823629a6f3625f0d$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $l8UrM.TimeoutError()));
    };
}
module.exports.timeout = $823629a6f3625f0d$var$timeout;
var $823629a6f3625f0d$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $823629a6f3625f0d$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $823629a6f3625f0d$var$TimeoutSubscriber = function(_super) {
    $823629a6f3625f0d$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($kVbBc.Subscriber);

});
parcelRegister("l8UrM", function(module, exports) {
"use strict";
var $f64621856ea645a4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $f64621856ea645a4$var$TimeoutError = function(_super) {
    $f64621856ea645a4$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $f64621856ea645a4$var$TimeoutError;

});




parcelRegister("en3oJ", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $h8lP7 = parcelRequire("h8lP7");
$b0T1M.Observable.prototype.timeoutWith = $h8lP7.timeoutWith;

});
parcelRegister("h8lP7", function(module, exports) {
$parcel$export(module.exports, "timeoutWith", () => $c7941cb0c7cb8d9b$export$86fe999fba7953f2, (v) => $c7941cb0c7cb8d9b$export$86fe999fba7953f2 = v);
var $c7941cb0c7cb8d9b$export$86fe999fba7953f2;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $2VMPF = parcelRequire("2VMPF");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $c7941cb0c7cb8d9b$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $2VMPF.timeoutWith(due, withObservable, scheduler)(this);
}
$c7941cb0c7cb8d9b$export$86fe999fba7953f2 = $c7941cb0c7cb8d9b$var$timeoutWith;

});
parcelRegister("2VMPF", function(module, exports) {
"use strict";
var $2226c8b8c43ca70c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hBoCS = parcelRequire("hBoCS");

var $lrUXm = parcelRequire("lrUXm");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $2226c8b8c43ca70c$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return function(source) {
        var absoluteTimeout = $lrUXm.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $2226c8b8c43ca70c$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $2226c8b8c43ca70c$var$timeoutWith;
var $2226c8b8c43ca70c$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2226c8b8c43ca70c$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2226c8b8c43ca70c$var$TimeoutWithSubscriber = function(_super) {
    $2226c8b8c43ca70c$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($d3klE.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("2llMb", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $21CMb = parcelRequire("21CMb");
$b0T1M.Observable.prototype.timestamp = $21CMb.timestamp;

});
parcelRegister("21CMb", function(module, exports) {
$parcel$export(module.exports, "timestamp", () => $1799c0e1c89aa48a$export$fc00ee57782020aa, (v) => $1799c0e1c89aa48a$export$fc00ee57782020aa = v);
var $1799c0e1c89aa48a$export$fc00ee57782020aa;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $bzTtj = parcelRequire("bzTtj");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function $1799c0e1c89aa48a$var$timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $bzTtj.timestamp(scheduler)(this);
}
$1799c0e1c89aa48a$export$fc00ee57782020aa = $1799c0e1c89aa48a$var$timestamp;

});
parcelRegister("bzTtj", function(module, exports) {
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $bWhgb = parcelRequire("bWhgb");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $hBoCS.async;
    return $bWhgb.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});



parcelRegister("hJ1NB", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $gHIrA = parcelRequire("gHIrA");
$b0T1M.Observable.prototype.toArray = $gHIrA.toArray;

});
parcelRegister("gHIrA", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $c293231d27ff5794$export$45b10814cc054894, (v) => $c293231d27ff5794$export$45b10814cc054894 = v);
var $c293231d27ff5794$export$45b10814cc054894;
"use strict";

var $fEpEu = parcelRequire("fEpEu");
/**
 * Collects all source emissions and emits them as an array when the source completes.
 *
 * <span class="informal">Get all values inside an array when the source completes</span>
 *
 * <img src="./img/toArray.png" width="100%">
 *
 * `toArray` will wait until the source Observable completes
 * before emitting the array containing all emissions.
 * When the source Observable errors no array will be emitted.
 *
 * @example <caption>Create array from input</caption>
 * const input = Rx.Observable.interval(100).take(4);
 *
 * input.toArray()
 *   .subscribe(arr => console.log(arr)); // [0,1,2,3]
 *
 * @see {@link buffer}
 *
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */ function $c293231d27ff5794$var$toArray() {
    return $fEpEu.toArray()(this);
}
$c293231d27ff5794$export$45b10814cc054894 = $c293231d27ff5794$var$toArray;

});
parcelRegister("fEpEu", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $b64e7d6387d8dc61$export$45b10814cc054894, (v) => $b64e7d6387d8dc61$export$45b10814cc054894 = v);
var $b64e7d6387d8dc61$export$45b10814cc054894;
"use strict";

var $1aHIk = parcelRequire("1aHIk");
function $b64e7d6387d8dc61$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $b64e7d6387d8dc61$var$toArray() {
    return $1aHIk.reduce($b64e7d6387d8dc61$var$toArrayReducer, []);
}
$b64e7d6387d8dc61$export$45b10814cc054894 = $b64e7d6387d8dc61$var$toArray;

});



parcelRegister("kD0kt", function(module, exports) {
// HACK: does nothing, because `toPromise` now lives on the `Observable` itself.
// leaving this module here to prevent breakage.

});

parcelRegister("iRegk", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $6x7Ck = parcelRequire("6x7Ck");
$b0T1M.Observable.prototype.window = $6x7Ck.window;

});
parcelRegister("6x7Ck", function(module, exports) {
$parcel$export(module.exports, "window", () => $4c1bbbc8d3b7fb6b$export$8291e5b88f90ce4, (v) => $4c1bbbc8d3b7fb6b$export$8291e5b88f90ce4 = v);
var $4c1bbbc8d3b7fb6b$export$8291e5b88f90ce4;
"use strict";

var $4gl5b = parcelRequire("4gl5b");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function $4c1bbbc8d3b7fb6b$var$window(windowBoundaries) {
    return $4gl5b.window(windowBoundaries)(this);
}
$4c1bbbc8d3b7fb6b$export$8291e5b88f90ce4 = $4c1bbbc8d3b7fb6b$var$window;

});
parcelRegister("4gl5b", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */ function window(windowBoundaries) {
    return function windowOperatorFunction(source) {
        return source.lift(new WindowOperator(windowBoundaries));
    };
}
exports.window = window;
var WindowOperator = function() {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) windowSubscriber.add($d3klE.subscribeToResult(windowSubscriber, this.windowBoundaries));
        return sourceSubscription;
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var WindowSubscriber = function(_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new $hJCZY.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowSubscriber.prototype._unsubscribe = function() {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function() {
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var destination = this.destination;
        var newWindow = this.window = new $hJCZY.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("ltcHV", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $i7yua = parcelRequire("i7yua");
$b0T1M.Observable.prototype.windowCount = $i7yua.windowCount;

});
parcelRegister("i7yua", function(module, exports) {
$parcel$export(module.exports, "windowCount", () => $d313a1943ca67ab5$export$f3a19e933f377396, (v) => $d313a1943ca67ab5$export$f3a19e933f377396 = v);
var $d313a1943ca67ab5$export$f3a19e933f377396;
"use strict";

var $5ldaT = parcelRequire("5ldaT");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $d313a1943ca67ab5$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return $5ldaT.windowCount(windowSize, startWindowEvery)(this);
}
$d313a1943ca67ab5$export$f3a19e933f377396 = $d313a1943ca67ab5$var$windowCount;

});
parcelRegister("5ldaT", function(module, exports) {
"use strict";
var $3e392221b380cb12$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $kVbBc = parcelRequire("kVbBc");

var $hJCZY = parcelRequire("hJCZY");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $3e392221b380cb12$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $3e392221b380cb12$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $3e392221b380cb12$var$windowCount;
var $3e392221b380cb12$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3e392221b380cb12$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3e392221b380cb12$var$WindowCountSubscriber = function(_super) {
    $3e392221b380cb12$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $hJCZY.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $hJCZY.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($kVbBc.Subscriber);

});



parcelRegister("jsKX9", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $1gGOw = parcelRequire("1gGOw");
$b0T1M.Observable.prototype.windowTime = $1gGOw.windowTime;

});
parcelRegister("1gGOw", function(module, exports) {
$parcel$export(module.exports, "windowTime", () => $0ec87f0355c64c13$export$1284415effa79ee0, (v) => $0ec87f0355c64c13$export$1284415effa79ee0 = v);
var $0ec87f0355c64c13$export$1284415effa79ee0;
"use strict";

var $hBoCS = parcelRequire("hBoCS");

var $kAEty = parcelRequire("kAEty");

var $6eaCl = parcelRequire("6eaCl");

var $53wrv = parcelRequire("53wrv");
function $0ec87f0355c64c13$var$windowTime(windowTimeSpan) {
    var scheduler = $hBoCS.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($6eaCl.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($6eaCl.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($kAEty.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($6eaCl.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($kAEty.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return $53wrv.windowTime(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler)(this);
}
$0ec87f0355c64c13$export$1284415effa79ee0 = $0ec87f0355c64c13$var$windowTime;

});
parcelRegister("53wrv", function(module, exports) {
"use strict";
var $3ae665fe7b6ff38b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $hBoCS = parcelRequire("hBoCS");

var $kVbBc = parcelRequire("kVbBc");

var $kAEty = parcelRequire("kAEty");

var $6eaCl = parcelRequire("6eaCl");
function $3ae665fe7b6ff38b$var$windowTime(windowTimeSpan) {
    var scheduler = $hBoCS.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($6eaCl.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($6eaCl.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($kAEty.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($6eaCl.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($kAEty.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $3ae665fe7b6ff38b$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $3ae665fe7b6ff38b$var$windowTime;
var $3ae665fe7b6ff38b$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3ae665fe7b6ff38b$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $3ae665fe7b6ff38b$var$CountedSubject = function(_super) {
    $3ae665fe7b6ff38b$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($hJCZY.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3ae665fe7b6ff38b$var$WindowTimeSubscriber = function(_super) {
    $3ae665fe7b6ff38b$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($3ae665fe7b6ff38b$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($3ae665fe7b6ff38b$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($3ae665fe7b6ff38b$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $3ae665fe7b6ff38b$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($kVbBc.Subscriber);
function $3ae665fe7b6ff38b$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $3ae665fe7b6ff38b$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($3ae665fe7b6ff38b$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $3ae665fe7b6ff38b$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});



parcelRegister("jwAgx", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $37XGt = parcelRequire("37XGt");
$b0T1M.Observable.prototype.windowToggle = $37XGt.windowToggle;

});
parcelRegister("37XGt", function(module, exports) {
$parcel$export(module.exports, "windowToggle", () => $24705287b9785b8f$export$3182be990e0eeaad, (v) => $24705287b9785b8f$export$3182be990e0eeaad = v);
var $24705287b9785b8f$export$3182be990e0eeaad;
"use strict";

var $ltcFs = parcelRequire("ltcFs");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $24705287b9785b8f$var$windowToggle(openings, closingSelector) {
    return $ltcFs.windowToggle(openings, closingSelector)(this);
}
$24705287b9785b8f$export$3182be990e0eeaad = $24705287b9785b8f$var$windowToggle;

});
parcelRegister("ltcFs", function(module, exports) {
"use strict";
var $fa1621f16914c835$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $cGvOX = parcelRequire("cGvOX");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $fa1621f16914c835$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $fa1621f16914c835$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $fa1621f16914c835$var$windowToggle;
var $fa1621f16914c835$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fa1621f16914c835$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fa1621f16914c835$var$WindowToggleSubscriber = function(_super) {
    $fa1621f16914c835$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $d3klE.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $3kkLM.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $geExo.errorObject) return this.error($geExo.errorObject.e);
            else {
                var window_1 = new $hJCZY.Subject();
                var subscription = new $cGvOX.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $d3klE.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("8yzRo", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $7fFAG = parcelRequire("7fFAG");
$b0T1M.Observable.prototype.windowWhen = $7fFAG.windowWhen;

});
parcelRegister("7fFAG", function(module, exports) {
$parcel$export(module.exports, "windowWhen", () => $547a322b9560ac62$export$6a5dea797879f644, (v) => $547a322b9560ac62$export$6a5dea797879f644 = v);
var $547a322b9560ac62$export$6a5dea797879f644;
"use strict";

var $iQJw6 = parcelRequire("iQJw6");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $547a322b9560ac62$var$windowWhen(closingSelector) {
    return $iQJw6.windowWhen(closingSelector)(this);
}
$547a322b9560ac62$export$6a5dea797879f644 = $547a322b9560ac62$var$windowWhen;

});
parcelRegister("iQJw6", function(module, exports) {
"use strict";
var $db9064034e30c409$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $3kkLM = parcelRequire("3kkLM");

var $geExo = parcelRequire("geExo");

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $db9064034e30c409$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $db9064034e30c409$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $db9064034e30c409$var$windowWhen;
var $db9064034e30c409$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $db9064034e30c409$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $db9064034e30c409$var$WindowSubscriber = function(_super) {
    $db9064034e30c409$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $hJCZY.Subject();
        this.destination.next(window);
        var closingNotifier = $3kkLM.tryCatch(this.closingSelector)();
        if (closingNotifier === $geExo.errorObject) {
            var err = $geExo.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $d3klE.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("4YPMk", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $b5Sua = parcelRequire("b5Sua");
$b0T1M.Observable.prototype.withLatestFrom = $b5Sua.withLatestFrom;

});
parcelRegister("b5Sua", function(module, exports) {
$parcel$export(module.exports, "withLatestFrom", () => $813a6d0c4b87e742$export$d449030e5c10edf7, (v) => $813a6d0c4b87e742$export$d449030e5c10edf7 = v);
var $813a6d0c4b87e742$export$d449030e5c10edf7;
"use strict";

var $bPywJ = parcelRequire("bPywJ");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $813a6d0c4b87e742$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return $bPywJ.withLatestFrom.apply(void 0, args)(this);
}
$813a6d0c4b87e742$export$d449030e5c10edf7 = $813a6d0c4b87e742$var$withLatestFrom;

});
parcelRegister("bPywJ", function(module, exports) {
"use strict";
var $89cf3d78de378318$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5XpGv = parcelRequire("5XpGv");

var $d3klE = parcelRequire("d3klE");
/* tslint:enable:max-line-length */ /**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */ function $89cf3d78de378318$var$withLatestFrom() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i - 0] = arguments[_i];
    return function(source) {
        var project;
        if (typeof args[args.length - 1] === 'function') project = args.pop();
        var observables = args;
        return source.lift(new $89cf3d78de378318$var$WithLatestFromOperator(observables, project));
    };
}
module.exports.withLatestFrom = $89cf3d78de378318$var$withLatestFrom;
var $89cf3d78de378318$var$WithLatestFromOperator = function() {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $89cf3d78de378318$var$WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $89cf3d78de378318$var$WithLatestFromSubscriber = function(_super) {
    $89cf3d78de378318$var$__extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for(var i = 0; i < len; i++)this.toRespond.push(i);
        for(var i = 0; i < len; i++){
            var observable = observables[i];
            this.add($d3klE.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) toRespond.splice(found, 1);
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function() {
    // noop
    };
    WithLatestFromSubscriber.prototype._next = function(value) {
        if (this.toRespond.length === 0) {
            var args = [
                value
            ].concat(this.values);
            if (this.project) this._tryProject(args);
            else this.destination.next(args);
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function(args) {
        var result;
        try {
            result = this.project.apply(this, args);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}($5XpGv.OuterSubscriber);

});



parcelRegister("caoeC", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $lkKBb = parcelRequire("lkKBb");
$b0T1M.Observable.prototype.zip = $lkKBb.zipProto;

});
parcelRegister("lkKBb", function(module, exports) {
$parcel$export(module.exports, "zipProto", () => $f87f9cbe8873a273$export$ad1b5245dc53c655, (v) => $f87f9cbe8873a273$export$ad1b5245dc53c655 = v);
var $f87f9cbe8873a273$export$ad1b5245dc53c655;
"use strict";

var $8bwYR = parcelRequire("8bwYR");
/* tslint:enable:max-line-length */ /**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */ function $f87f9cbe8873a273$var$zipProto() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return $8bwYR.zip.apply(void 0, observables)(this);
}
$f87f9cbe8873a273$export$ad1b5245dc53c655 = $f87f9cbe8873a273$var$zipProto;

});


parcelRegister("lanqG", function(module, exports) {
"use strict";

var $b0T1M = parcelRequire("b0T1M");

var $b34NE = parcelRequire("b34NE");
$b0T1M.Observable.prototype.zipAll = $b34NE.zipAll;

});
parcelRegister("b34NE", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $80b3b2aaa2db2a0f$export$adddb6a2fa3864e9, (v) => $80b3b2aaa2db2a0f$export$adddb6a2fa3864e9 = v);
var $80b3b2aaa2db2a0f$export$adddb6a2fa3864e9;
"use strict";

var $kquoj = parcelRequire("kquoj");
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */ function $80b3b2aaa2db2a0f$var$zipAll(project) {
    return $kquoj.zipAll(project)(this);
}
$80b3b2aaa2db2a0f$export$adddb6a2fa3864e9 = $80b3b2aaa2db2a0f$var$zipAll;

});
parcelRegister("kquoj", function(module, exports) {
$parcel$export(module.exports, "zipAll", () => $ededcf6addfee902$export$adddb6a2fa3864e9, (v) => $ededcf6addfee902$export$adddb6a2fa3864e9 = v);
var $ededcf6addfee902$export$adddb6a2fa3864e9;
"use strict";

var $8bwYR = parcelRequire("8bwYR");
function $ededcf6addfee902$var$zipAll(project) {
    return function(source) {
        return source.lift(new $8bwYR.ZipOperator(project));
    };
}
$ededcf6addfee902$export$adddb6a2fa3864e9 = $ededcf6addfee902$var$zipAll;

});



parcelRegister("96Oe7", function(module, exports) {
"use strict";
var $6a1ba295db3f2939$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $lnB2i = parcelRequire("lnB2i");

var $klbjH = parcelRequire("klbjH");

var $4Sr8u = parcelRequire("4Sr8u");

var $knsAD = parcelRequire("knsAD");

var $EYojK = parcelRequire("EYojK");
var $6a1ba295db3f2939$var$defaultMaxFrame = 750;
var $6a1ba295db3f2939$var$TestScheduler = function(_super) {
    $6a1ba295db3f2939$var$__extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, $EYojK.VirtualAction, $6a1ba295db3f2939$var$defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function(marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) throw new Error('marble diagram for time should have a completion marker "|"');
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function(marbles, values, error) {
        if (marbles.indexOf('^') !== -1) throw new Error('cold observable cannot have subscription offset "^"');
        if (marbles.indexOf('!') !== -1) throw new Error('cold observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new $klbjH.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function(marbles, values, error) {
        if (marbles.indexOf('!') !== -1) throw new Error('hot observable cannot have unsubscription marker "!"');
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new $4Sr8u.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function(observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function(value) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $lnB2i.Notification.createNext(value)
            });
        }, function(err) {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $lnB2i.Notification.createError(err)
            });
        }, function() {
            messages.push({
                frame: _this.frame - outerFrame,
                notification: $lnB2i.Notification.createComplete()
            });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function(observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) unsubscriptionMarbles = null;
        var actual = [];
        var flushTest = {
            actual: actual,
            ready: false
        };
        var unsubscriptionFrame = TestScheduler.parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function() {
            subscription = observable.subscribe(function(x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof $b0T1M.Observable) value = _this.materializeInnerObservable(value, _this.frame);
                actual.push({
                    frame: _this.frame,
                    notification: $lnB2i.Notification.createNext(value)
                });
            }, function(err) {
                actual.push({
                    frame: _this.frame,
                    notification: $lnB2i.Notification.createError(err)
                });
            }, function() {
                actual.push({
                    frame: _this.frame,
                    notification: $lnB2i.Notification.createComplete()
                });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) this.schedule(function() {
            return subscription.unsubscribe();
        }, unsubscriptionFrame);
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function(actualSubscriptionLogs) {
        var flushTest = {
            actual: actualSubscriptionLogs,
            ready: false
        };
        this.flushTests.push(flushTest);
        return {
            toBe: function(marbles) {
                var marblesArray = typeof marbles === 'string' ? [
                    marbles
                ] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function(marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function() {
        var hotObservables = this.hotObservables;
        while(hotObservables.length > 0)hotObservables.shift().setup();
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function(test) {
            return test.ready;
        });
        while(readyFlushTests.length > 0){
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function(marbles) {
        if (typeof marbles !== 'string') return new $knsAD.SubscriptionLog(Number.POSITIVE_INFINITY);
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) throw new Error("found a second subscription point '^' in a subscription marble diagram. There can only be one.");
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error("there can only be '^' and '!' markers in a subscription marble diagram. Found instead '" + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) return new $knsAD.SubscriptionLog(subscriptionFrame);
        else return new $knsAD.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
    };
    TestScheduler.parseMarbles = function(marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) materializeInnerObservables = false;
        if (marbles.indexOf('!') !== -1) throw new Error('conventional marble diagrams cannot have the unsubscription marker "!"');
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : subIndex * -this.frameTimeFactor;
        var getValue = typeof values !== 'object' ? function(x) {
            return x;
        } : function(x) {
            // Support Observable-of-Observables
            if (materializeInnerObservables && values[x] instanceof $klbjH.ColdObservable) return values[x].messages;
            return values[x];
        };
        var groupStart = -1;
        for(var i = 0; i < len; i++){
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch(c){
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = $lnB2i.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = $lnB2i.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = $lnB2i.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) testMessages.push({
                frame: groupStart > -1 ? groupStart : frame,
                notification: notification
            });
        }
        return testMessages;
    };
    return TestScheduler;
}($EYojK.VirtualTimeScheduler);
module.exports.TestScheduler = $6a1ba295db3f2939$var$TestScheduler;

});
parcelRegister("klbjH", function(module, exports) {
"use strict";
var $ecee8c13c5ef34f2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b0T1M = parcelRequire("b0T1M");

var $cGvOX = parcelRequire("cGvOX");

var $gMvpn = parcelRequire("gMvpn");

var $7SUMo = parcelRequire("7SUMo");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ecee8c13c5ef34f2$var$ColdObservable = function(_super) {
    $ecee8c13c5ef34f2$var$__extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function(subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new $cGvOX.Subscription(function() {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function(subscriber) {
        var messagesLength = this.messages.length;
        for(var i = 0; i < messagesLength; i++){
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function(_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, {
                message: message,
                subscriber: subscriber
            }));
        }
    };
    return ColdObservable;
}($b0T1M.Observable);
module.exports.ColdObservable = $ecee8c13c5ef34f2$var$ColdObservable;
$7SUMo.applyMixins($ecee8c13c5ef34f2$var$ColdObservable, [
    $gMvpn.SubscriptionLoggable
]);

});
parcelRegister("gMvpn", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLoggable", () => $c3797e156d049537$export$b07abd1cdf2201bb, (v) => $c3797e156d049537$export$b07abd1cdf2201bb = v);
var $c3797e156d049537$export$b07abd1cdf2201bb;
"use strict";

var $knsAD = parcelRequire("knsAD");
var $c3797e156d049537$var$SubscriptionLoggable = function() {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function() {
        this.subscriptions.push(new $knsAD.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function(index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new $knsAD.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}();
$c3797e156d049537$export$b07abd1cdf2201bb = $c3797e156d049537$var$SubscriptionLoggable;

});
parcelRegister("knsAD", function(module, exports) {
$parcel$export(module.exports, "SubscriptionLog", () => $03d4111078ee05b8$export$63bb55968f4c7c1e, (v) => $03d4111078ee05b8$export$63bb55968f4c7c1e = v);
var $03d4111078ee05b8$export$63bb55968f4c7c1e;
"use strict";
var $03d4111078ee05b8$var$SubscriptionLog = function() {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) unsubscribedFrame = Number.POSITIVE_INFINITY;
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}();
$03d4111078ee05b8$export$63bb55968f4c7c1e = $03d4111078ee05b8$var$SubscriptionLog;

});


parcelRegister("7SUMo", function(module, exports) {
$parcel$export(module.exports, "applyMixins", () => $5bd99ece90a36a5a$export$6ccb92ce135089b4, (v) => $5bd99ece90a36a5a$export$6ccb92ce135089b4 = v);
var $5bd99ece90a36a5a$export$6ccb92ce135089b4;
"use strict";
function $5bd99ece90a36a5a$var$applyMixins(derivedCtor, baseCtors) {
    for(var i = 0, len = baseCtors.length; i < len; i++){
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for(var j = 0, len2 = propertyKeys.length; j < len2; j++){
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
$5bd99ece90a36a5a$export$6ccb92ce135089b4 = $5bd99ece90a36a5a$var$applyMixins;

});


parcelRegister("4Sr8u", function(module, exports) {
"use strict";
var $38d1412f574448fb$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hJCZY = parcelRequire("hJCZY");

var $cGvOX = parcelRequire("cGvOX");

var $gMvpn = parcelRequire("gMvpn");

var $7SUMo = parcelRequire("7SUMo");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $38d1412f574448fb$var$HotObservable = function(_super) {
    $38d1412f574448fb$var$__extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    /** @deprecated internal use only */ HotObservable.prototype._subscribe = function(subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new $cGvOX.Subscription(function() {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function() {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */ for(var i = 0; i < messagesLength; i++)(function() {
            var message = subject.messages[i];
            /* tslint:enable */ subject.scheduler.schedule(function() {
                message.notification.observe(subject);
            }, message.frame);
        })();
    };
    return HotObservable;
}($hJCZY.Subject);
module.exports.HotObservable = $38d1412f574448fb$var$HotObservable;
$7SUMo.applyMixins($38d1412f574448fb$var$HotObservable, [
    $gMvpn.SubscriptionLoggable
]);

});

parcelRegister("EYojK", function(module, exports) {
"use strict";
var $07b294fabfab0bbf$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jvUn0 = parcelRequire("jvUn0");

var $63qby = parcelRequire("63qby");
var $07b294fabfab0bbf$var$VirtualTimeScheduler = function(_super) {
    $07b294fabfab0bbf$var$__extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) SchedulerAction = $07b294fabfab0bbf$var$VirtualAction;
        if (maxFrames === void 0) maxFrames = Number.POSITIVE_INFINITY;
        _super.call(this, SchedulerAction, function() {
            return _this.frame;
        });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */ VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while((action = actions.shift()) && (this.frame = action.delay) <= maxFrames){
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}($63qby.AsyncScheduler);
module.exports.VirtualTimeScheduler = $07b294fabfab0bbf$var$VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $07b294fabfab0bbf$var$VirtualAction = function(_super) {
    $07b294fabfab0bbf$var$__extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (!this.id) return _super.prototype.schedule.call(this, state, delay);
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}($jvUn0.AsyncAction);
module.exports.VirtualAction = $07b294fabfab0bbf$var$VirtualAction;

});


parcelRegister("aFkIb", function(module, exports) {
$parcel$export(module.exports, "animationFrame", () => $7c3dcca2cf81b2a8$export$1402cba6a733f33a, (v) => $7c3dcca2cf81b2a8$export$1402cba6a733f33a = v);
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */ var $7c3dcca2cf81b2a8$export$1402cba6a733f33a;
"use strict";

var $bhh4H = parcelRequire("bhh4H");

var $lIe0K = parcelRequire("lIe0K");
$7c3dcca2cf81b2a8$export$1402cba6a733f33a = new $lIe0K.AnimationFrameScheduler($bhh4H.AnimationFrameAction);

});
parcelRegister("bhh4H", function(module, exports) {
"use strict";
var $835e86ec7fff2a15$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $jvUn0 = parcelRequire("jvUn0");

var $YonzC = parcelRequire("YonzC");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $835e86ec7fff2a15$var$AnimationFrameAction = function(_super) {
    $835e86ec7fff2a15$var$__extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = $YonzC.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if (delay !== null && delay > 0 || delay === null && this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            $YonzC.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}($jvUn0.AsyncAction);
module.exports.AnimationFrameAction = $835e86ec7fff2a15$var$AnimationFrameAction;

});
parcelRegister("YonzC", function(module, exports) {
$parcel$export(module.exports, "AnimationFrame", () => $0b5883ea7380ed89$export$1f3d5b43727c648a, (v) => $0b5883ea7380ed89$export$1f3d5b43727c648a = v);
var $0b5883ea7380ed89$export$5e49294fc1f79cc3;
var $0b5883ea7380ed89$export$1f3d5b43727c648a;
"use strict";

var $jYFjc = parcelRequire("jYFjc");
var $0b5883ea7380ed89$var$RequestAnimationFrameDefinition = function() {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        } else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        } else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        } else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        } else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        } else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function(cb) {
                return root.setTimeout(cb, 1000 / 60);
            };
        }
    }
    return RequestAnimationFrameDefinition;
}();
$0b5883ea7380ed89$export$5e49294fc1f79cc3 = $0b5883ea7380ed89$var$RequestAnimationFrameDefinition;
$0b5883ea7380ed89$export$1f3d5b43727c648a = new $0b5883ea7380ed89$var$RequestAnimationFrameDefinition($jYFjc.root);

});


parcelRegister("lIe0K", function(module, exports) {
"use strict";
var $fce8935cabc77515$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $63qby = parcelRequire("63qby");
var $fce8935cabc77515$var$AnimationFrameScheduler = function(_super) {
    $fce8935cabc77515$var$__extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while(++index < count && (action = actions.shift()))action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}($63qby.AsyncScheduler);
module.exports.AnimationFrameScheduler = $fce8935cabc77515$var$AnimationFrameScheduler;

});


parcelRegister("8ie7e", function(module, exports) {
$parcel$export(module.exports, "audit", () => $609af440636cfb25$export$d779b02e6b68c3e8, (v) => $609af440636cfb25$export$d779b02e6b68c3e8 = v);
$parcel$export(module.exports, "auditTime", () => $609af440636cfb25$export$719c70722b10e5ff, (v) => $609af440636cfb25$export$719c70722b10e5ff = v);
$parcel$export(module.exports, "buffer", () => $609af440636cfb25$export$ab1029bcae9ddb4a, (v) => $609af440636cfb25$export$ab1029bcae9ddb4a = v);
$parcel$export(module.exports, "bufferCount", () => $609af440636cfb25$export$8916d2c8119541bb, (v) => $609af440636cfb25$export$8916d2c8119541bb = v);
$parcel$export(module.exports, "bufferTime", () => $609af440636cfb25$export$d6b40c95035461c7, (v) => $609af440636cfb25$export$d6b40c95035461c7 = v);
$parcel$export(module.exports, "bufferToggle", () => $609af440636cfb25$export$91115bdd8709945f, (v) => $609af440636cfb25$export$91115bdd8709945f = v);
$parcel$export(module.exports, "bufferWhen", () => $609af440636cfb25$export$9e55760d3282e08c, (v) => $609af440636cfb25$export$9e55760d3282e08c = v);
$parcel$export(module.exports, "catchError", () => $609af440636cfb25$export$3dede90624df3ba9, (v) => $609af440636cfb25$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "combineAll", () => $609af440636cfb25$export$29ae691b7de52fe3, (v) => $609af440636cfb25$export$29ae691b7de52fe3 = v);
$parcel$export(module.exports, "combineLatest", () => $609af440636cfb25$export$77fa7d86f5204e8a, (v) => $609af440636cfb25$export$77fa7d86f5204e8a = v);
$parcel$export(module.exports, "concat", () => $609af440636cfb25$export$ee1b3e54f0441b22, (v) => $609af440636cfb25$export$ee1b3e54f0441b22 = v);
$parcel$export(module.exports, "concatAll", () => $609af440636cfb25$export$b314777ae20abca9, (v) => $609af440636cfb25$export$b314777ae20abca9 = v);
$parcel$export(module.exports, "concatMap", () => $609af440636cfb25$export$c28c8388be0ab31a, (v) => $609af440636cfb25$export$c28c8388be0ab31a = v);
$parcel$export(module.exports, "concatMapTo", () => $609af440636cfb25$export$82fbd7a2841d2484, (v) => $609af440636cfb25$export$82fbd7a2841d2484 = v);
$parcel$export(module.exports, "count", () => $609af440636cfb25$export$85b9a36db797e02b, (v) => $609af440636cfb25$export$85b9a36db797e02b = v);
$parcel$export(module.exports, "debounce", () => $609af440636cfb25$export$61fc7d43ac8f84b0, (v) => $609af440636cfb25$export$61fc7d43ac8f84b0 = v);
$parcel$export(module.exports, "debounceTime", () => $609af440636cfb25$export$7843a4469d64c07e, (v) => $609af440636cfb25$export$7843a4469d64c07e = v);
$parcel$export(module.exports, "defaultIfEmpty", () => $609af440636cfb25$export$e4ca6d7b7a6dcf9b, (v) => $609af440636cfb25$export$e4ca6d7b7a6dcf9b = v);
$parcel$export(module.exports, "delay", () => $609af440636cfb25$export$1391212d75b2ee65, (v) => $609af440636cfb25$export$1391212d75b2ee65 = v);
$parcel$export(module.exports, "delayWhen", () => $609af440636cfb25$export$286ca829307725c9, (v) => $609af440636cfb25$export$286ca829307725c9 = v);
$parcel$export(module.exports, "dematerialize", () => $609af440636cfb25$export$ab9a5985b741fa7a, (v) => $609af440636cfb25$export$ab9a5985b741fa7a = v);
$parcel$export(module.exports, "distinct", () => $609af440636cfb25$export$983a3b5fb2f7202e, (v) => $609af440636cfb25$export$983a3b5fb2f7202e = v);
$parcel$export(module.exports, "distinctUntilChanged", () => $609af440636cfb25$export$779c5fb865a0172e, (v) => $609af440636cfb25$export$779c5fb865a0172e = v);
$parcel$export(module.exports, "distinctUntilKeyChanged", () => $609af440636cfb25$export$571da16e28367bde, (v) => $609af440636cfb25$export$571da16e28367bde = v);
$parcel$export(module.exports, "elementAt", () => $609af440636cfb25$export$91d69c7761a17bbc, (v) => $609af440636cfb25$export$91d69c7761a17bbc = v);
$parcel$export(module.exports, "every", () => $609af440636cfb25$export$7ecc1a3b11b57dab, (v) => $609af440636cfb25$export$7ecc1a3b11b57dab = v);
$parcel$export(module.exports, "exhaust", () => $609af440636cfb25$export$31039f1fbd797b9c, (v) => $609af440636cfb25$export$31039f1fbd797b9c = v);
$parcel$export(module.exports, "exhaustMap", () => $609af440636cfb25$export$d70d492cd31004c0, (v) => $609af440636cfb25$export$d70d492cd31004c0 = v);
$parcel$export(module.exports, "expand", () => $609af440636cfb25$export$9f77e0932fb78f72, (v) => $609af440636cfb25$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "filter", () => $609af440636cfb25$export$3dea766d36a8935f, (v) => $609af440636cfb25$export$3dea766d36a8935f = v);
$parcel$export(module.exports, "finalize", () => $609af440636cfb25$export$578723aef62d92f5, (v) => $609af440636cfb25$export$578723aef62d92f5 = v);
$parcel$export(module.exports, "find", () => $609af440636cfb25$export$71aa6c912b956294, (v) => $609af440636cfb25$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "findIndex", () => $609af440636cfb25$export$de3a4d4a0d731119, (v) => $609af440636cfb25$export$de3a4d4a0d731119 = v);
$parcel$export(module.exports, "first", () => $609af440636cfb25$export$43128fadae87b74a, (v) => $609af440636cfb25$export$43128fadae87b74a = v);
$parcel$export(module.exports, "groupBy", () => $609af440636cfb25$export$3f063810d7bf01bd, (v) => $609af440636cfb25$export$3f063810d7bf01bd = v);
$parcel$export(module.exports, "ignoreElements", () => $609af440636cfb25$export$6953b97c7d866605, (v) => $609af440636cfb25$export$6953b97c7d866605 = v);
$parcel$export(module.exports, "isEmpty", () => $609af440636cfb25$export$dd1bc94b04021eeb, (v) => $609af440636cfb25$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "last", () => $609af440636cfb25$export$4c7897fafd92b108, (v) => $609af440636cfb25$export$4c7897fafd92b108 = v);
$parcel$export(module.exports, "map", () => $609af440636cfb25$export$871de8747c9eaa88, (v) => $609af440636cfb25$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "mapTo", () => $609af440636cfb25$export$e0eaf3a86c03b2ad, (v) => $609af440636cfb25$export$e0eaf3a86c03b2ad = v);
$parcel$export(module.exports, "materialize", () => $609af440636cfb25$export$76dbd6ffd832405d, (v) => $609af440636cfb25$export$76dbd6ffd832405d = v);
$parcel$export(module.exports, "max", () => $609af440636cfb25$export$8960430cfd85939f, (v) => $609af440636cfb25$export$8960430cfd85939f = v);
$parcel$export(module.exports, "merge", () => $609af440636cfb25$export$4950aa0f605343fb, (v) => $609af440636cfb25$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "mergeAll", () => $609af440636cfb25$export$18aef43295bbe906, (v) => $609af440636cfb25$export$18aef43295bbe906 = v);
$parcel$export(module.exports, "mergeMap", () => $609af440636cfb25$export$6b9f6c0d32c093f9, (v) => $609af440636cfb25$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "flatMap", () => $609af440636cfb25$export$5b8affa63fc6df16, (v) => $609af440636cfb25$export$5b8affa63fc6df16 = v);
$parcel$export(module.exports, "mergeMapTo", () => $609af440636cfb25$export$bd7cfc9a42b8a412, (v) => $609af440636cfb25$export$bd7cfc9a42b8a412 = v);
$parcel$export(module.exports, "mergeScan", () => $609af440636cfb25$export$c1fc905202bced53, (v) => $609af440636cfb25$export$c1fc905202bced53 = v);
$parcel$export(module.exports, "min", () => $609af440636cfb25$export$96ec731ed4dcb222, (v) => $609af440636cfb25$export$96ec731ed4dcb222 = v);
$parcel$export(module.exports, "multicast", () => $609af440636cfb25$export$1364843af8d5a963, (v) => $609af440636cfb25$export$1364843af8d5a963 = v);
$parcel$export(module.exports, "observeOn", () => $609af440636cfb25$export$9007f49c319d1ac7, (v) => $609af440636cfb25$export$9007f49c319d1ac7 = v);
$parcel$export(module.exports, "onErrorResumeNext", () => $609af440636cfb25$export$5fba66d61591f42, (v) => $609af440636cfb25$export$5fba66d61591f42 = v);
$parcel$export(module.exports, "pairwise", () => $609af440636cfb25$export$8f9d79d42bff1aac, (v) => $609af440636cfb25$export$8f9d79d42bff1aac = v);
$parcel$export(module.exports, "partition", () => $609af440636cfb25$export$b29f828819edca8d, (v) => $609af440636cfb25$export$b29f828819edca8d = v);
$parcel$export(module.exports, "pluck", () => $609af440636cfb25$export$c44985b87d605eff, (v) => $609af440636cfb25$export$c44985b87d605eff = v);
$parcel$export(module.exports, "publish", () => $609af440636cfb25$export$89b472e03be495df, (v) => $609af440636cfb25$export$89b472e03be495df = v);
$parcel$export(module.exports, "publishBehavior", () => $609af440636cfb25$export$16ae46fda9567053, (v) => $609af440636cfb25$export$16ae46fda9567053 = v);
$parcel$export(module.exports, "publishLast", () => $609af440636cfb25$export$42d9b6b38c68d989, (v) => $609af440636cfb25$export$42d9b6b38c68d989 = v);
$parcel$export(module.exports, "publishReplay", () => $609af440636cfb25$export$1f3342bf81d92d52, (v) => $609af440636cfb25$export$1f3342bf81d92d52 = v);
$parcel$export(module.exports, "race", () => $609af440636cfb25$export$236c05de452bec2, (v) => $609af440636cfb25$export$236c05de452bec2 = v);
$parcel$export(module.exports, "reduce", () => $609af440636cfb25$export$533b26079ad0b4b, (v) => $609af440636cfb25$export$533b26079ad0b4b = v);
$parcel$export(module.exports, "repeat", () => $609af440636cfb25$export$76d90c956114f2c2, (v) => $609af440636cfb25$export$76d90c956114f2c2 = v);
$parcel$export(module.exports, "repeatWhen", () => $609af440636cfb25$export$b39ac5b4ffd1415a, (v) => $609af440636cfb25$export$b39ac5b4ffd1415a = v);
$parcel$export(module.exports, "retry", () => $609af440636cfb25$export$9369b12211e1fce4, (v) => $609af440636cfb25$export$9369b12211e1fce4 = v);
$parcel$export(module.exports, "retryWhen", () => $609af440636cfb25$export$1281551253cfee02, (v) => $609af440636cfb25$export$1281551253cfee02 = v);
$parcel$export(module.exports, "refCount", () => $609af440636cfb25$export$18d0766d894cba0c, (v) => $609af440636cfb25$export$18d0766d894cba0c = v);
$parcel$export(module.exports, "sample", () => $609af440636cfb25$export$4812e460280c6ef2, (v) => $609af440636cfb25$export$4812e460280c6ef2 = v);
$parcel$export(module.exports, "sampleTime", () => $609af440636cfb25$export$fe33c7b2002d97b0, (v) => $609af440636cfb25$export$fe33c7b2002d97b0 = v);
$parcel$export(module.exports, "scan", () => $609af440636cfb25$export$c87d910e63d22ed6, (v) => $609af440636cfb25$export$c87d910e63d22ed6 = v);
$parcel$export(module.exports, "sequenceEqual", () => $609af440636cfb25$export$d0a07e60ae428313, (v) => $609af440636cfb25$export$d0a07e60ae428313 = v);
$parcel$export(module.exports, "share", () => $609af440636cfb25$export$ed80d9de1d9df928, (v) => $609af440636cfb25$export$ed80d9de1d9df928 = v);
$parcel$export(module.exports, "shareReplay", () => $609af440636cfb25$export$db61d692014e534e, (v) => $609af440636cfb25$export$db61d692014e534e = v);
$parcel$export(module.exports, "single", () => $609af440636cfb25$export$863d7ca51b416cee, (v) => $609af440636cfb25$export$863d7ca51b416cee = v);
$parcel$export(module.exports, "skip", () => $609af440636cfb25$export$955fc4a6c4be454d, (v) => $609af440636cfb25$export$955fc4a6c4be454d = v);
$parcel$export(module.exports, "skipLast", () => $609af440636cfb25$export$635f6273df29ea1c, (v) => $609af440636cfb25$export$635f6273df29ea1c = v);
$parcel$export(module.exports, "skipUntil", () => $609af440636cfb25$export$facc584867c26fde, (v) => $609af440636cfb25$export$facc584867c26fde = v);
$parcel$export(module.exports, "skipWhile", () => $609af440636cfb25$export$175dedd748069215, (v) => $609af440636cfb25$export$175dedd748069215 = v);
$parcel$export(module.exports, "startWith", () => $609af440636cfb25$export$a4fe86229b0e9bdd, (v) => $609af440636cfb25$export$a4fe86229b0e9bdd = v);
$parcel$export(module.exports, "switchAll", () => $609af440636cfb25$export$6a45284a4b0bf33a, (v) => $609af440636cfb25$export$6a45284a4b0bf33a = v);
$parcel$export(module.exports, "switchMap", () => $609af440636cfb25$export$9f6ea8e48bc26eab, (v) => $609af440636cfb25$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "switchMapTo", () => $609af440636cfb25$export$a439dc30c845238, (v) => $609af440636cfb25$export$a439dc30c845238 = v);
$parcel$export(module.exports, "take", () => $609af440636cfb25$export$b7df5d561049483a, (v) => $609af440636cfb25$export$b7df5d561049483a = v);
$parcel$export(module.exports, "takeLast", () => $609af440636cfb25$export$1b47ad771ce5af5e, (v) => $609af440636cfb25$export$1b47ad771ce5af5e = v);
$parcel$export(module.exports, "takeUntil", () => $609af440636cfb25$export$ac8dfd3a7ad06e80, (v) => $609af440636cfb25$export$ac8dfd3a7ad06e80 = v);
$parcel$export(module.exports, "takeWhile", () => $609af440636cfb25$export$9384c7afe4015e42, (v) => $609af440636cfb25$export$9384c7afe4015e42 = v);
$parcel$export(module.exports, "tap", () => $609af440636cfb25$export$3f23594af5f37336, (v) => $609af440636cfb25$export$3f23594af5f37336 = v);
$parcel$export(module.exports, "throttle", () => $609af440636cfb25$export$de363e709c412c8a, (v) => $609af440636cfb25$export$de363e709c412c8a = v);
$parcel$export(module.exports, "throttleTime", () => $609af440636cfb25$export$4efe28f192921dd4, (v) => $609af440636cfb25$export$4efe28f192921dd4 = v);
$parcel$export(module.exports, "timeInterval", () => $609af440636cfb25$export$1a539c8b2950ab40, (v) => $609af440636cfb25$export$1a539c8b2950ab40 = v);
$parcel$export(module.exports, "timeout", () => $609af440636cfb25$export$83e74882c5df8fe1, (v) => $609af440636cfb25$export$83e74882c5df8fe1 = v);
$parcel$export(module.exports, "timeoutWith", () => $609af440636cfb25$export$86fe999fba7953f2, (v) => $609af440636cfb25$export$86fe999fba7953f2 = v);
$parcel$export(module.exports, "timestamp", () => $609af440636cfb25$export$fc00ee57782020aa, (v) => $609af440636cfb25$export$fc00ee57782020aa = v);
$parcel$export(module.exports, "toArray", () => $609af440636cfb25$export$45b10814cc054894, (v) => $609af440636cfb25$export$45b10814cc054894 = v);
$parcel$export(module.exports, "window", () => $609af440636cfb25$export$8291e5b88f90ce4, (v) => $609af440636cfb25$export$8291e5b88f90ce4 = v);
$parcel$export(module.exports, "windowCount", () => $609af440636cfb25$export$f3a19e933f377396, (v) => $609af440636cfb25$export$f3a19e933f377396 = v);
$parcel$export(module.exports, "windowTime", () => $609af440636cfb25$export$1284415effa79ee0, (v) => $609af440636cfb25$export$1284415effa79ee0 = v);
$parcel$export(module.exports, "windowToggle", () => $609af440636cfb25$export$3182be990e0eeaad, (v) => $609af440636cfb25$export$3182be990e0eeaad = v);
$parcel$export(module.exports, "windowWhen", () => $609af440636cfb25$export$6a5dea797879f644, (v) => $609af440636cfb25$export$6a5dea797879f644 = v);
$parcel$export(module.exports, "withLatestFrom", () => $609af440636cfb25$export$d449030e5c10edf7, (v) => $609af440636cfb25$export$d449030e5c10edf7 = v);
$parcel$export(module.exports, "zip", () => $609af440636cfb25$export$8901015135f2fb22, (v) => $609af440636cfb25$export$8901015135f2fb22 = v);
$parcel$export(module.exports, "zipAll", () => $609af440636cfb25$export$adddb6a2fa3864e9, (v) => $609af440636cfb25$export$adddb6a2fa3864e9 = v);
var $609af440636cfb25$export$d779b02e6b68c3e8;
var $609af440636cfb25$export$719c70722b10e5ff;
var $609af440636cfb25$export$ab1029bcae9ddb4a;
var $609af440636cfb25$export$8916d2c8119541bb;
var $609af440636cfb25$export$d6b40c95035461c7;
var $609af440636cfb25$export$91115bdd8709945f;
var $609af440636cfb25$export$9e55760d3282e08c;
var $609af440636cfb25$export$3dede90624df3ba9;
var $609af440636cfb25$export$29ae691b7de52fe3;
var $609af440636cfb25$export$77fa7d86f5204e8a;
var $609af440636cfb25$export$ee1b3e54f0441b22;
var $609af440636cfb25$export$b314777ae20abca9;
var $609af440636cfb25$export$c28c8388be0ab31a;
var $609af440636cfb25$export$82fbd7a2841d2484;
var $609af440636cfb25$export$85b9a36db797e02b;
var $609af440636cfb25$export$61fc7d43ac8f84b0;
var $609af440636cfb25$export$7843a4469d64c07e;
var $609af440636cfb25$export$e4ca6d7b7a6dcf9b;
var $609af440636cfb25$export$1391212d75b2ee65;
var $609af440636cfb25$export$286ca829307725c9;
var $609af440636cfb25$export$ab9a5985b741fa7a;
var $609af440636cfb25$export$983a3b5fb2f7202e;
var $609af440636cfb25$export$779c5fb865a0172e;
var $609af440636cfb25$export$571da16e28367bde;
var $609af440636cfb25$export$91d69c7761a17bbc;
var $609af440636cfb25$export$7ecc1a3b11b57dab;
var $609af440636cfb25$export$31039f1fbd797b9c;
var $609af440636cfb25$export$d70d492cd31004c0;
var $609af440636cfb25$export$9f77e0932fb78f72;
var $609af440636cfb25$export$3dea766d36a8935f;
var $609af440636cfb25$export$578723aef62d92f5;
var $609af440636cfb25$export$71aa6c912b956294;
var $609af440636cfb25$export$de3a4d4a0d731119;
var $609af440636cfb25$export$43128fadae87b74a;
var $609af440636cfb25$export$3f063810d7bf01bd;
var $609af440636cfb25$export$6953b97c7d866605;
var $609af440636cfb25$export$dd1bc94b04021eeb;
var $609af440636cfb25$export$4c7897fafd92b108;
var $609af440636cfb25$export$871de8747c9eaa88;
var $609af440636cfb25$export$e0eaf3a86c03b2ad;
var $609af440636cfb25$export$76dbd6ffd832405d;
var $609af440636cfb25$export$8960430cfd85939f;
var $609af440636cfb25$export$4950aa0f605343fb;
var $609af440636cfb25$export$18aef43295bbe906;
var $609af440636cfb25$export$6b9f6c0d32c093f9;
var $609af440636cfb25$export$5b8affa63fc6df16;
var $609af440636cfb25$export$bd7cfc9a42b8a412;
var $609af440636cfb25$export$c1fc905202bced53;
var $609af440636cfb25$export$96ec731ed4dcb222;
var $609af440636cfb25$export$1364843af8d5a963;
var $609af440636cfb25$export$9007f49c319d1ac7;
var $609af440636cfb25$export$5fba66d61591f42;
var $609af440636cfb25$export$8f9d79d42bff1aac;
var $609af440636cfb25$export$b29f828819edca8d;
var $609af440636cfb25$export$c44985b87d605eff;
var $609af440636cfb25$export$89b472e03be495df;
var $609af440636cfb25$export$16ae46fda9567053;
var $609af440636cfb25$export$42d9b6b38c68d989;
var $609af440636cfb25$export$1f3342bf81d92d52;
var $609af440636cfb25$export$236c05de452bec2;
var $609af440636cfb25$export$533b26079ad0b4b;
var $609af440636cfb25$export$76d90c956114f2c2;
var $609af440636cfb25$export$b39ac5b4ffd1415a;
var $609af440636cfb25$export$9369b12211e1fce4;
var $609af440636cfb25$export$1281551253cfee02;
var $609af440636cfb25$export$18d0766d894cba0c;
var $609af440636cfb25$export$4812e460280c6ef2;
var $609af440636cfb25$export$fe33c7b2002d97b0;
var $609af440636cfb25$export$c87d910e63d22ed6;
var $609af440636cfb25$export$d0a07e60ae428313;
var $609af440636cfb25$export$ed80d9de1d9df928;
var $609af440636cfb25$export$db61d692014e534e;
var $609af440636cfb25$export$863d7ca51b416cee;
var $609af440636cfb25$export$955fc4a6c4be454d;
var $609af440636cfb25$export$635f6273df29ea1c;
var $609af440636cfb25$export$facc584867c26fde;
var $609af440636cfb25$export$175dedd748069215;
var $609af440636cfb25$export$a4fe86229b0e9bdd;
var $609af440636cfb25$export$6a45284a4b0bf33a;
var $609af440636cfb25$export$9f6ea8e48bc26eab;
var $609af440636cfb25$export$a439dc30c845238;
var $609af440636cfb25$export$b7df5d561049483a;
var $609af440636cfb25$export$1b47ad771ce5af5e;
var $609af440636cfb25$export$ac8dfd3a7ad06e80;
var $609af440636cfb25$export$9384c7afe4015e42;
var $609af440636cfb25$export$3f23594af5f37336;
var $609af440636cfb25$export$de363e709c412c8a;
var $609af440636cfb25$export$4efe28f192921dd4;
var $609af440636cfb25$export$1a539c8b2950ab40;
var $609af440636cfb25$export$83e74882c5df8fe1;
var $609af440636cfb25$export$86fe999fba7953f2;
var $609af440636cfb25$export$fc00ee57782020aa;
var $609af440636cfb25$export$45b10814cc054894;
var $609af440636cfb25$export$8291e5b88f90ce4;
var $609af440636cfb25$export$f3a19e933f377396;
var $609af440636cfb25$export$1284415effa79ee0;
var $609af440636cfb25$export$3182be990e0eeaad;
var $609af440636cfb25$export$6a5dea797879f644;
var $609af440636cfb25$export$d449030e5c10edf7;
var $609af440636cfb25$export$8901015135f2fb22;
var $609af440636cfb25$export$adddb6a2fa3864e9;
"use strict";

var $ip0bJ = parcelRequire("ip0bJ");
$609af440636cfb25$export$d779b02e6b68c3e8 = $ip0bJ.audit;

var $8RG1P = parcelRequire("8RG1P");
$609af440636cfb25$export$719c70722b10e5ff = $8RG1P.auditTime;

var $hr1kd = parcelRequire("hr1kd");
$609af440636cfb25$export$ab1029bcae9ddb4a = $hr1kd.buffer;

var $5zaNb = parcelRequire("5zaNb");
$609af440636cfb25$export$8916d2c8119541bb = $5zaNb.bufferCount;

var $hg0kO = parcelRequire("hg0kO");
$609af440636cfb25$export$d6b40c95035461c7 = $hg0kO.bufferTime;

var $kHNXO = parcelRequire("kHNXO");
$609af440636cfb25$export$91115bdd8709945f = $kHNXO.bufferToggle;

var $7VFgk = parcelRequire("7VFgk");
$609af440636cfb25$export$9e55760d3282e08c = $7VFgk.bufferWhen;

var $aIlDy = parcelRequire("aIlDy");
$609af440636cfb25$export$3dede90624df3ba9 = $aIlDy.catchError;

var $jLpnz = parcelRequire("jLpnz");
$609af440636cfb25$export$29ae691b7de52fe3 = $jLpnz.combineAll;

var $5ogow = parcelRequire("5ogow");
$609af440636cfb25$export$77fa7d86f5204e8a = $5ogow.combineLatest;

var $4j1zC = parcelRequire("4j1zC");
$609af440636cfb25$export$ee1b3e54f0441b22 = $4j1zC.concat;

var $8kkVC = parcelRequire("8kkVC");
$609af440636cfb25$export$b314777ae20abca9 = $8kkVC.concatAll;

var $1PoKX = parcelRequire("1PoKX");
$609af440636cfb25$export$c28c8388be0ab31a = $1PoKX.concatMap;

var $iuoUD = parcelRequire("iuoUD");
$609af440636cfb25$export$82fbd7a2841d2484 = $iuoUD.concatMapTo;

var $8mnGO = parcelRequire("8mnGO");
$609af440636cfb25$export$85b9a36db797e02b = $8mnGO.count;

var $cKr74 = parcelRequire("cKr74");
$609af440636cfb25$export$61fc7d43ac8f84b0 = $cKr74.debounce;

var $bEZYz = parcelRequire("bEZYz");
$609af440636cfb25$export$7843a4469d64c07e = $bEZYz.debounceTime;

var $gSfoM = parcelRequire("gSfoM");
$609af440636cfb25$export$e4ca6d7b7a6dcf9b = $gSfoM.defaultIfEmpty;

var $k2Kkr = parcelRequire("k2Kkr");
$609af440636cfb25$export$1391212d75b2ee65 = $k2Kkr.delay;

var $8Hamk = parcelRequire("8Hamk");
$609af440636cfb25$export$286ca829307725c9 = $8Hamk.delayWhen;

var $chUQD = parcelRequire("chUQD");
$609af440636cfb25$export$ab9a5985b741fa7a = $chUQD.dematerialize;

var $dZudP = parcelRequire("dZudP");
$609af440636cfb25$export$983a3b5fb2f7202e = $dZudP.distinct;

var $ewuYL = parcelRequire("ewuYL");
$609af440636cfb25$export$779c5fb865a0172e = $ewuYL.distinctUntilChanged;

var $9WAUY = parcelRequire("9WAUY");
$609af440636cfb25$export$571da16e28367bde = $9WAUY.distinctUntilKeyChanged;

var $eL9fi = parcelRequire("eL9fi");
$609af440636cfb25$export$91d69c7761a17bbc = $eL9fi.elementAt;

var $4gnel = parcelRequire("4gnel");
$609af440636cfb25$export$7ecc1a3b11b57dab = $4gnel.every;

var $kqNeR = parcelRequire("kqNeR");
$609af440636cfb25$export$31039f1fbd797b9c = $kqNeR.exhaust;

var $g4djV = parcelRequire("g4djV");
$609af440636cfb25$export$d70d492cd31004c0 = $g4djV.exhaustMap;

var $324xV = parcelRequire("324xV");
$609af440636cfb25$export$9f77e0932fb78f72 = $324xV.expand;

var $7lL5Z = parcelRequire("7lL5Z");
$609af440636cfb25$export$3dea766d36a8935f = $7lL5Z.filter;

var $6d9Bs = parcelRequire("6d9Bs");
$609af440636cfb25$export$578723aef62d92f5 = $6d9Bs.finalize;

var $eoI2r = parcelRequire("eoI2r");
$609af440636cfb25$export$71aa6c912b956294 = $eoI2r.find;

var $5LQnN = parcelRequire("5LQnN");
$609af440636cfb25$export$de3a4d4a0d731119 = $5LQnN.findIndex;

var $kX41W = parcelRequire("kX41W");
$609af440636cfb25$export$43128fadae87b74a = $kX41W.first;

var $52ANt = parcelRequire("52ANt");
$609af440636cfb25$export$3f063810d7bf01bd = $52ANt.groupBy;

var $62rmE = parcelRequire("62rmE");
$609af440636cfb25$export$6953b97c7d866605 = $62rmE.ignoreElements;

var $fHW2m = parcelRequire("fHW2m");
$609af440636cfb25$export$dd1bc94b04021eeb = $fHW2m.isEmpty;

var $93L5V = parcelRequire("93L5V");
$609af440636cfb25$export$4c7897fafd92b108 = $93L5V.last;

var $bWhgb = parcelRequire("bWhgb");
$609af440636cfb25$export$871de8747c9eaa88 = $bWhgb.map;

var $7jTXs = parcelRequire("7jTXs");
$609af440636cfb25$export$e0eaf3a86c03b2ad = $7jTXs.mapTo;

var $2OD20 = parcelRequire("2OD20");
$609af440636cfb25$export$76dbd6ffd832405d = $2OD20.materialize;

var $gI1rl = parcelRequire("gI1rl");
$609af440636cfb25$export$8960430cfd85939f = $gI1rl.max;

var $aOLK2 = parcelRequire("aOLK2");
$609af440636cfb25$export$4950aa0f605343fb = $aOLK2.merge;

var $jMu5f = parcelRequire("jMu5f");
$609af440636cfb25$export$18aef43295bbe906 = $jMu5f.mergeAll;

var $fcKxV = parcelRequire("fcKxV");
$609af440636cfb25$export$6b9f6c0d32c093f9 = $fcKxV.mergeMap;

var $fcKxV = parcelRequire("fcKxV");
$609af440636cfb25$export$5b8affa63fc6df16 = $fcKxV.mergeMap;

var $1MekL = parcelRequire("1MekL");
$609af440636cfb25$export$bd7cfc9a42b8a412 = $1MekL.mergeMapTo;

var $7m0Ce = parcelRequire("7m0Ce");
$609af440636cfb25$export$c1fc905202bced53 = $7m0Ce.mergeScan;

var $2OVeR = parcelRequire("2OVeR");
$609af440636cfb25$export$96ec731ed4dcb222 = $2OVeR.min;

var $dxmlm = parcelRequire("dxmlm");
$609af440636cfb25$export$1364843af8d5a963 = $dxmlm.multicast;

var $kpNTS = parcelRequire("kpNTS");
$609af440636cfb25$export$9007f49c319d1ac7 = $kpNTS.observeOn;

var $8gEWr = parcelRequire("8gEWr");
$609af440636cfb25$export$5fba66d61591f42 = $8gEWr.onErrorResumeNext;

var $eBfuU = parcelRequire("eBfuU");
$609af440636cfb25$export$8f9d79d42bff1aac = $eBfuU.pairwise;

var $anVo0 = parcelRequire("anVo0");
$609af440636cfb25$export$b29f828819edca8d = $anVo0.partition;

var $3fA6Q = parcelRequire("3fA6Q");
$609af440636cfb25$export$c44985b87d605eff = $3fA6Q.pluck;

var $iy7b2 = parcelRequire("iy7b2");
$609af440636cfb25$export$89b472e03be495df = $iy7b2.publish;

var $7nrwj = parcelRequire("7nrwj");
$609af440636cfb25$export$16ae46fda9567053 = $7nrwj.publishBehavior;

var $6SL9s = parcelRequire("6SL9s");
$609af440636cfb25$export$42d9b6b38c68d989 = $6SL9s.publishLast;

var $1p9Zl = parcelRequire("1p9Zl");
$609af440636cfb25$export$1f3342bf81d92d52 = $1p9Zl.publishReplay;

var $enYEv = parcelRequire("enYEv");
$609af440636cfb25$export$236c05de452bec2 = $enYEv.race;

var $1aHIk = parcelRequire("1aHIk");
$609af440636cfb25$export$533b26079ad0b4b = $1aHIk.reduce;

var $dvRsB = parcelRequire("dvRsB");
$609af440636cfb25$export$76d90c956114f2c2 = $dvRsB.repeat;

var $fGPgr = parcelRequire("fGPgr");
$609af440636cfb25$export$b39ac5b4ffd1415a = $fGPgr.repeatWhen;

var $jn2xT = parcelRequire("jn2xT");
$609af440636cfb25$export$9369b12211e1fce4 = $jn2xT.retry;

var $bVoCc = parcelRequire("bVoCc");
$609af440636cfb25$export$1281551253cfee02 = $bVoCc.retryWhen;

var $d1zoQ = parcelRequire("d1zoQ");
$609af440636cfb25$export$18d0766d894cba0c = $d1zoQ.refCount;

var $jnLwa = parcelRequire("jnLwa");
$609af440636cfb25$export$4812e460280c6ef2 = $jnLwa.sample;

var $9bNPU = parcelRequire("9bNPU");
$609af440636cfb25$export$fe33c7b2002d97b0 = $9bNPU.sampleTime;

var $lPaeJ = parcelRequire("lPaeJ");
$609af440636cfb25$export$c87d910e63d22ed6 = $lPaeJ.scan;

var $84CWP = parcelRequire("84CWP");
$609af440636cfb25$export$d0a07e60ae428313 = $84CWP.sequenceEqual;

var $iGWJA = parcelRequire("iGWJA");
$609af440636cfb25$export$ed80d9de1d9df928 = $iGWJA.share;

var $bNlZl = parcelRequire("bNlZl");
$609af440636cfb25$export$db61d692014e534e = $bNlZl.shareReplay;

var $3X7EG = parcelRequire("3X7EG");
$609af440636cfb25$export$863d7ca51b416cee = $3X7EG.single;

var $h0mxd = parcelRequire("h0mxd");
$609af440636cfb25$export$955fc4a6c4be454d = $h0mxd.skip;

var $i5z7t = parcelRequire("i5z7t");
$609af440636cfb25$export$635f6273df29ea1c = $i5z7t.skipLast;

var $ijRaO = parcelRequire("ijRaO");
$609af440636cfb25$export$facc584867c26fde = $ijRaO.skipUntil;

var $3fUQw = parcelRequire("3fUQw");
$609af440636cfb25$export$175dedd748069215 = $3fUQw.skipWhile;

var $HSnUx = parcelRequire("HSnUx");
$609af440636cfb25$export$a4fe86229b0e9bdd = $HSnUx.startWith;

var $Uppq8 = parcelRequire("Uppq8");
$609af440636cfb25$export$6a45284a4b0bf33a = $Uppq8.switchAll;

var $3hXUB = parcelRequire("3hXUB");
$609af440636cfb25$export$9f6ea8e48bc26eab = $3hXUB.switchMap;

var $4Knek = parcelRequire("4Knek");
$609af440636cfb25$export$a439dc30c845238 = $4Knek.switchMapTo;

var $6mUvG = parcelRequire("6mUvG");
$609af440636cfb25$export$b7df5d561049483a = $6mUvG.take;

var $ilSxQ = parcelRequire("ilSxQ");
$609af440636cfb25$export$1b47ad771ce5af5e = $ilSxQ.takeLast;

var $jyvpZ = parcelRequire("jyvpZ");
$609af440636cfb25$export$ac8dfd3a7ad06e80 = $jyvpZ.takeUntil;

var $JU7sv = parcelRequire("JU7sv");
$609af440636cfb25$export$9384c7afe4015e42 = $JU7sv.takeWhile;

var $kcvp1 = parcelRequire("kcvp1");
$609af440636cfb25$export$3f23594af5f37336 = $kcvp1.tap;

var $5yPdY = parcelRequire("5yPdY");
$609af440636cfb25$export$de363e709c412c8a = $5yPdY.throttle;

var $29wCr = parcelRequire("29wCr");
$609af440636cfb25$export$4efe28f192921dd4 = $29wCr.throttleTime;

var $gIhPu = parcelRequire("gIhPu");
$609af440636cfb25$export$1a539c8b2950ab40 = $gIhPu.timeInterval;

var $bb70W = parcelRequire("bb70W");
$609af440636cfb25$export$83e74882c5df8fe1 = $bb70W.timeout;

var $2VMPF = parcelRequire("2VMPF");
$609af440636cfb25$export$86fe999fba7953f2 = $2VMPF.timeoutWith;

var $bzTtj = parcelRequire("bzTtj");
$609af440636cfb25$export$fc00ee57782020aa = $bzTtj.timestamp;

var $fEpEu = parcelRequire("fEpEu");
$609af440636cfb25$export$45b10814cc054894 = $fEpEu.toArray;

var $4gl5b = parcelRequire("4gl5b");
$609af440636cfb25$export$8291e5b88f90ce4 = $4gl5b.window;

var $5ldaT = parcelRequire("5ldaT");
$609af440636cfb25$export$f3a19e933f377396 = $5ldaT.windowCount;

var $53wrv = parcelRequire("53wrv");
$609af440636cfb25$export$1284415effa79ee0 = $53wrv.windowTime;

var $ltcFs = parcelRequire("ltcFs");
$609af440636cfb25$export$3182be990e0eeaad = $ltcFs.windowToggle;

var $iQJw6 = parcelRequire("iQJw6");
$609af440636cfb25$export$6a5dea797879f644 = $iQJw6.windowWhen;

var $bPywJ = parcelRequire("bPywJ");
$609af440636cfb25$export$d449030e5c10edf7 = $bPywJ.withLatestFrom;

var $8bwYR = parcelRequire("8bwYR");
$609af440636cfb25$export$8901015135f2fb22 = $8bwYR.zip;

var $kquoj = parcelRequire("kquoj");
$609af440636cfb25$export$adddb6a2fa3864e9 = $kquoj.zipAll;

});


parcelRegister("1QY14", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $92e284836e21b512$export$c3902030a5d4d47a);
$parcel$export(module.exports, "sendNewSignupLinkEpic", () => $92e284836e21b512$export$5566cb2a1dee7448);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $3AtBL = parcelRequire("3AtBL");

var $aeY98 = parcelRequire("aeY98");
parcelRequire("iKA91");
var $1uz6E = parcelRequire("1uz6E");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");

var $fI5Sq = parcelRequire("fI5Sq");
const $92e284836e21b512$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $1uz6E.COMPLETE_SIGNUP)).mergeMap((completeSignupAction)=>{
        const { jwtToken: jwtToken, fullName: fullName, password: password, email: email, contactAdminsFormEnabled: contactAdminsFormEnabled, continueParam: continueParam } = completeSignupAction.payload;
        return (0, $3AtBL.completeSignup)(jwtToken, fullName, password).flatMap(()=>{
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $1uz6E.completeSignupSuccess)()), (0, $b0T1M.Observable).of((0, $8o5VQ.loginAttempt)({
                email: email,
                password: password,
                continueParam: continueParam ?? null
            })));
        }).catch((error)=>{
            const parsedError = (0, $fI5Sq.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $b0T1M.Observable).of((0, $1uz6E.completeSignupFailure)(parsedError));
        });
    });
};
const $92e284836e21b512$export$5566cb2a1dee7448 = (action$)=>{
    return action$.ofType((0, $1uz6E.SEND_NEW_SIGNUP_LINK)).mergeMap((sendNewSignupLinkAction)=>{
        const { email: email, portalId: portalId } = sendNewSignupLinkAction.payload;
        return (0, $aeY98.resendValidationEmail)(email, portalId, undefined).map(()=>{
            return (0, $1uz6E.sendNewSignupLinkSuccess)();
        }).catch((error)=>{
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $1uz6E.sendNewSignupLinkFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("gBYjj", function(module, exports) {
$parcel$export(module.exports, "HANDLE_AJAX_ERROR", () => $cd68b3582b593584$export$a7c57e52be964b91);
$parcel$export(module.exports, "SHOW_ERROR_FLAG", () => $cd68b3582b593584$export$2b6b999b3eafcf24);
$parcel$export(module.exports, "SHOW_WARNING_FLAG", () => $cd68b3582b593584$export$4f0f0fac05b2a93f);
$parcel$export(module.exports, "SHOW_SUCCESS_FLAG", () => $cd68b3582b593584$export$c911d7565dd7a733);
$parcel$export(module.exports, "SHOW_BOLD_APPEARANCE_FLAG", () => $cd68b3582b593584$export$8eec0f3e4bc42e5c);
$parcel$export(module.exports, "DISMISS_FLAG", () => $cd68b3582b593584$export$1eb56620df104bf);
$parcel$export(module.exports, "handleAjaxError", () => $cd68b3582b593584$export$1245fce1755f5ec2);
$parcel$export(module.exports, "showErrorFlag", () => $cd68b3582b593584$export$dfa2148cdb92917d);
$parcel$export(module.exports, "showWarningFlag", () => $cd68b3582b593584$export$9475ea83c9ea0d1c);
$parcel$export(module.exports, "showSuccessFlag", () => $cd68b3582b593584$export$fef8478a2c810f18);
$parcel$export(module.exports, "showBoldAppearanceFlag", () => $cd68b3582b593584$export$4231a8f3b05ab067);
$parcel$export(module.exports, "dismissFlag", () => $cd68b3582b593584$export$900a08a292ad23cd);
const $cd68b3582b593584$export$a7c57e52be964b91 = 'state.ui.flags.HANDLE_AJAX_ERROR';
const $cd68b3582b593584$export$2b6b999b3eafcf24 = 'state.ui.flags.SHOW_ERROR_FLAG';
const $cd68b3582b593584$export$4f0f0fac05b2a93f = 'state.ui.flags.SHOW_WARNING_FLAG';
const $cd68b3582b593584$export$c911d7565dd7a733 = 'state.ui.flags.SHOW_SUCCESS_FLAG';
const $cd68b3582b593584$export$8eec0f3e4bc42e5c = 'state.ui.flags.SHOW_BOLD_APPEARANCE_FLAG';
const $cd68b3582b593584$export$1eb56620df104bf = 'state.ui.flags.DISMISS_FLAG';
const $cd68b3582b593584$export$1245fce1755f5ec2 = (error)=>({
        type: $cd68b3582b593584$export$a7c57e52be964b91,
        payload: {
            error: error
        }
    });
const $cd68b3582b593584$export$dfa2148cdb92917d = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $cd68b3582b593584$export$2b6b999b3eafcf24,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $cd68b3582b593584$export$9475ea83c9ea0d1c = (titleMessage, descriptionMessage, actions = [], titleMessageValues, descriptionMessageValues)=>({
        type: $cd68b3582b593584$export$4f0f0fac05b2a93f,
        payload: {
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            actions: actions,
            titleMessageValues: titleMessageValues,
            descriptionMessageValues: descriptionMessageValues
        }
    });
const $cd68b3582b593584$export$fef8478a2c810f18 = (titleMessage, titleMessageValues, descriptionMessage, actions, descriptionMessageValues)=>({
        type: $cd68b3582b593584$export$c911d7565dd7a733,
        payload: {
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            actions: actions
        }
    });
const $cd68b3582b593584$export$4231a8f3b05ab067 = (appearance, titleMessage, titleMessageValues, descriptionMessage, descriptionMessageValues, actions, dismissActionValue)=>({
        type: $cd68b3582b593584$export$8eec0f3e4bc42e5c,
        payload: {
            appearance: appearance,
            titleMessage: titleMessage,
            titleMessageValues: titleMessageValues,
            descriptionMessage: descriptionMessage,
            descriptionMessageValues: descriptionMessageValues,
            dismissActionValue: dismissActionValue,
            actions: actions
        }
    });
const $cd68b3582b593584$export$900a08a292ad23cd = (flagId)=>({
        type: $cd68b3582b593584$export$1eb56620df104bf,
        payload: {
            flagId: flagId
        }
    });

});

parcelRegister("3AtBL", function(module, exports) {
$parcel$export(module.exports, "completeSignup", () => $da6de0a281d504c6$export$96271c6a96268661);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $da6de0a281d504c6$export$96271c6a96268661 = (token, fullName, password, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/complete-signup?jwt=${token}`;
    const body = $da6de0a281d504c6$var$createBody(fullName, password);
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};
const $da6de0a281d504c6$var$createBody = (fullName, password)=>{
    return JSON.stringify({
        fullName: fullName,
        password: password
    });
};

});

parcelRegister("aeY98", function(module, exports) {
$parcel$export(module.exports, "signUp", () => $11fd93a84f97698d$export$cf64224bcd829024);
$parcel$export(module.exports, "resendValidationEmail", () => $11fd93a84f97698d$export$b53bc6c531462e2c);

var $lVFX8 = parcelRequire("lVFX8");

var $6mmHn = parcelRequire("6mmHn");

var $3wR8f = parcelRequire("3wR8f");
const $11fd93a84f97698d$var$baseSignupBody = (email, portalId, redirectUrl)=>({
        email: email,
        signUpContext: {
            portalId: portalId,
            redirectUrl: redirectUrl,
            helpCenterAri: (0, $6mmHn.getHelpCenterAri)()
        }
    });
const $11fd93a84f97698d$export$cf64224bcd829024 = async (email, secondaryEmail, portalId, redirectUrl, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/signup`;
    const body = {
        ...$11fd93a84f97698d$var$baseSignupBody(email, portalId, redirectUrl),
        secondaryEmail: secondaryEmail,
        usingNewUi: true
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise().catch((e)=>Promise.reject(e));
};
const $11fd93a84f97698d$export$b53bc6c531462e2c = (email, portalId, redirectUrl, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/pages/user/send-validation-email`;
    const body = $11fd93a84f97698d$var$baseSignupBody(email, portalId, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("iKA91", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => (parcelRequire("1uz6E")).FETCH_COMPLETE_SIGNUP_MODEL);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => (parcelRequire("1uz6E")).FETCH_COMPLETE_SIGNUP_SUCCESS);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("1uz6E")).FETCH_COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => (parcelRequire("1uz6E")).COMPLETE_SIGNUP);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => (parcelRequire("1uz6E")).COMPLETE_SIGNUP_FAILURE);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => (parcelRequire("1uz6E")).SEND_NEW_SIGNUP_LINK);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => (parcelRequire("1uz6E")).SEND_NEW_SIGNUP_LINK_SUCCESS);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => (parcelRequire("1uz6E")).SEND_NEW_SIGNUP_LINK_FAILURE);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => (parcelRequire("1uz6E")).fetchCompleteSignupModel);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => (parcelRequire("1uz6E")).fetchCompleteSignupSuccess);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => (parcelRequire("1uz6E")).fetchCompleteSignupFailure);
$parcel$export(module.exports, "completeSignup", () => (parcelRequire("1uz6E")).completeSignup);
$parcel$export(module.exports, "completeSignupSuccess", () => (parcelRequire("1uz6E")).completeSignupSuccess);
$parcel$export(module.exports, "completeSignupFailure", () => (parcelRequire("1uz6E")).completeSignupFailure);
$parcel$export(module.exports, "sendNewSignupLink", () => (parcelRequire("1uz6E")).sendNewSignupLink);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => (parcelRequire("1uz6E")).sendNewSignupLinkSuccess);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => (parcelRequire("1uz6E")).sendNewSignupLinkFailure);

var $1uz6E = parcelRequire("1uz6E");

});
parcelRegister("1uz6E", function(module, exports) {
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_MODEL", () => $4e1d26ff04aee636$export$a57d1f559f8199cb);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_SUCCESS", () => $4e1d26ff04aee636$export$c991c467f18c47c4);
$parcel$export(module.exports, "FETCH_COMPLETE_SIGNUP_FAILURE", () => $4e1d26ff04aee636$export$af520912b7d6706d);
$parcel$export(module.exports, "COMPLETE_SIGNUP", () => $4e1d26ff04aee636$export$53ff245dddbf796c);
$parcel$export(module.exports, "COMPLETE_SIGNUP_FAILURE", () => $4e1d26ff04aee636$export$88f081a1fe475d4e);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK", () => $4e1d26ff04aee636$export$d76ccb8fbc57714);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_SUCCESS", () => $4e1d26ff04aee636$export$50cb33d74bd8c2e4);
$parcel$export(module.exports, "SEND_NEW_SIGNUP_LINK_FAILURE", () => $4e1d26ff04aee636$export$10f6ec3c86fb611d);
$parcel$export(module.exports, "fetchCompleteSignupModel", () => $4e1d26ff04aee636$export$22acc17286f74b59);
$parcel$export(module.exports, "fetchCompleteSignupSuccess", () => $4e1d26ff04aee636$export$93e33f94b1c7e30b);
$parcel$export(module.exports, "fetchCompleteSignupFailure", () => $4e1d26ff04aee636$export$7559c63f3aa1d23b);
$parcel$export(module.exports, "completeSignup", () => $4e1d26ff04aee636$export$96271c6a96268661);
$parcel$export(module.exports, "completeSignupSuccess", () => $4e1d26ff04aee636$export$854f5c75b16a30e1);
$parcel$export(module.exports, "completeSignupFailure", () => $4e1d26ff04aee636$export$76e49af38e42140f);
$parcel$export(module.exports, "sendNewSignupLink", () => $4e1d26ff04aee636$export$bc99093a83dfa75);
$parcel$export(module.exports, "sendNewSignupLinkSuccess", () => $4e1d26ff04aee636$export$1277dcc40c57fab3);
$parcel$export(module.exports, "sendNewSignupLinkFailure", () => $4e1d26ff04aee636$export$f5f09020b407e701);

var $dNzn5 = parcelRequire("dNzn5");
const $4e1d26ff04aee636$export$a57d1f559f8199cb = 'epic.model.FETCH_COMPLETE_SIGNUP_MODEL';
const $4e1d26ff04aee636$export$c991c467f18c47c4 = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_SUCCESS';
const $4e1d26ff04aee636$export$af520912b7d6706d = 'state.persisted.visit.portal.FETCH_COMPLETE_SIGNUP_FAILURE';
const $4e1d26ff04aee636$export$53ff245dddbf796c = 'state.ui.invited.sign.up.COMPLETE_SIGNUP';
const $4e1d26ff04aee636$export$e7a1360e631dd35b = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_SUCCESS';
const $4e1d26ff04aee636$export$88f081a1fe475d4e = 'state.ui.invited.sign.up.COMPLETE_SIGNUP_FAILURE';
const $4e1d26ff04aee636$export$d76ccb8fbc57714 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK';
const $4e1d26ff04aee636$export$50cb33d74bd8c2e4 = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_SUCCESS';
const $4e1d26ff04aee636$export$10f6ec3c86fb611d = 'state.ui.invited.sign.up.SEND_NEW_SIGNUP_LINK_FAILURE';
const $4e1d26ff04aee636$export$22acc17286f74b59 = (0, $dNzn5.buildModelsActionCreator)($4e1d26ff04aee636$export$a57d1f559f8199cb, 'completeSignup');
const $4e1d26ff04aee636$export$93e33f94b1c7e30b = (completeSignupResponse)=>({
        type: $4e1d26ff04aee636$export$c991c467f18c47c4,
        payload: completeSignupResponse
    });
const $4e1d26ff04aee636$export$7559c63f3aa1d23b = (error)=>({
        type: $4e1d26ff04aee636$export$af520912b7d6706d,
        payload: {
            error: error
        }
    });
const $4e1d26ff04aee636$export$96271c6a96268661 = (jwtToken, fullName, password, email, contactAdminsFormEnabled, continueParam)=>({
        type: $4e1d26ff04aee636$export$53ff245dddbf796c,
        payload: {
            jwtToken: jwtToken,
            fullName: fullName,
            password: password,
            email: email,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            continueParam: continueParam
        }
    });
const $4e1d26ff04aee636$export$854f5c75b16a30e1 = ()=>({
        type: $4e1d26ff04aee636$export$e7a1360e631dd35b
    });
const $4e1d26ff04aee636$export$76e49af38e42140f = (error)=>({
        type: $4e1d26ff04aee636$export$88f081a1fe475d4e,
        payload: {
            error: error
        }
    });
const $4e1d26ff04aee636$export$bc99093a83dfa75 = (email, portalId)=>({
        type: $4e1d26ff04aee636$export$d76ccb8fbc57714,
        payload: {
            email: email,
            portalId: portalId
        }
    });
const $4e1d26ff04aee636$export$1277dcc40c57fab3 = ()=>({
        type: $4e1d26ff04aee636$export$50cb33d74bd8c2e4
    });
const $4e1d26ff04aee636$export$f5f09020b407e701 = ()=>({
        type: $4e1d26ff04aee636$export$10f6ec3c86fb611d
    });

});
parcelRegister("dNzn5", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $529dc2cc3b949cf3$export$9f8a38b5e77ac29);
const $529dc2cc3b949cf3$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});



parcelRegister("8bE9a", function(module, exports) {
$parcel$export(module.exports, "changeEmailInput", () => (parcelRequire("8o5VQ")).changeEmailInput);
$parcel$export(module.exports, "checkLoginAction", () => (parcelRequire("8o5VQ")).checkLoginAction);
$parcel$export(module.exports, "checkLoginActionSuccess", () => (parcelRequire("8o5VQ")).checkLoginActionSuccess);
$parcel$export(module.exports, "checkLoginActionFailure", () => (parcelRequire("8o5VQ")).checkLoginActionFailure);
$parcel$export(module.exports, "fetchLoginSuccess", () => (parcelRequire("8o5VQ")).fetchLoginSuccess);
$parcel$export(module.exports, "fetchLoginFailure", () => (parcelRequire("8o5VQ")).fetchLoginFailure);
$parcel$export(module.exports, "forgotPassword", () => (parcelRequire("8o5VQ")).forgotPassword);
$parcel$export(module.exports, "createPassword", () => (parcelRequire("8o5VQ")).createPassword);
$parcel$export(module.exports, "createPasswordSuccess", () => (parcelRequire("8o5VQ")).createPasswordSuccess);
$parcel$export(module.exports, "forgotPasswordSuccess", () => (parcelRequire("8o5VQ")).forgotPasswordSuccess);
$parcel$export(module.exports, "loginAttempt", () => (parcelRequire("8o5VQ")).loginAttempt);
$parcel$export(module.exports, "loginAttemptSuccess", () => (parcelRequire("8o5VQ")).loginAttemptSuccess);
$parcel$export(module.exports, "loginAttemptFailure", () => (parcelRequire("8o5VQ")).loginAttemptFailure);
$parcel$export(module.exports, "resetLogin", () => (parcelRequire("8o5VQ")).resetLogin);
$parcel$export(module.exports, "exitTestModeAction", () => (parcelRequire("8o5VQ")).exitTestModeAction);
$parcel$export(module.exports, "caSsoTestModeFailure", () => (parcelRequire("8o5VQ")).caSsoTestModeFailure);
$parcel$export(module.exports, "loginConsentFailure", () => (parcelRequire("8o5VQ")).loginConsentFailure);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => (parcelRequire("8o5VQ")).CHANGE_EMAIL_INPUT);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => (parcelRequire("8o5VQ")).CHECK_LOGIN_ACTION);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => (parcelRequire("8o5VQ")).CHECK_LOGIN_ACTION_FAILURE);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => (parcelRequire("8o5VQ")).CHECK_LOGIN_ACTION_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => (parcelRequire("8o5VQ")).FETCH_LOGIN_FAILURE);
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => (parcelRequire("8o5VQ")).FETCH_LOGIN_SUCCESS);
$parcel$export(module.exports, "CREATE_PASSWORD", () => (parcelRequire("8o5VQ")).CREATE_PASSWORD);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => (parcelRequire("8o5VQ")).CREATE_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => (parcelRequire("8o5VQ")).FORGOT_PASSWORD);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("8o5VQ")).FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => (parcelRequire("8o5VQ")).FORGOT_PASSWORD_FAILURE);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => (parcelRequire("8o5VQ")).LOGIN_ATTEMPT);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => (parcelRequire("8o5VQ")).LOGIN_ATTEMPT_SUCCESS);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => (parcelRequire("8o5VQ")).LOGIN_ATTEMPT_FAILURE);
$parcel$export(module.exports, "RESET_LOGIN", () => (parcelRequire("8o5VQ")).RESET_LOGIN);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => (parcelRequire("8o5VQ")).CA_SSO_TEST_MODE_FAILURE);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => (parcelRequire("8o5VQ")).LOGIN_CONSENT_FAILURE);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => (parcelRequire("8o5VQ")).EXIT_TEST_MODE_ACTION);

var $8o5VQ = parcelRequire("8o5VQ");

});
parcelRegister("8o5VQ", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_SUCCESS", () => $b64147ddc37ef75c$export$839deb1eefe4e515);
$parcel$export(module.exports, "FETCH_LOGIN_FAILURE", () => $b64147ddc37ef75c$export$8cf8563c2d1c6683);
$parcel$export(module.exports, "CREATE_PASSWORD", () => $b64147ddc37ef75c$export$fe8137105dc1ed9);
$parcel$export(module.exports, "CREATE_PASSWORD_SUCCESS", () => $b64147ddc37ef75c$export$66c73e13cf8b697a);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION", () => $b64147ddc37ef75c$export$816b17d1322118b2);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_SUCCESS", () => $b64147ddc37ef75c$export$f5cb563064a027ff);
$parcel$export(module.exports, "CHECK_LOGIN_ACTION_FAILURE", () => $b64147ddc37ef75c$export$150db551ad2bf414);
$parcel$export(module.exports, "FORGOT_PASSWORD", () => $b64147ddc37ef75c$export$e479859894f5f058);
$parcel$export(module.exports, "FORGOT_PASSWORD_SUCCESS", () => $b64147ddc37ef75c$export$e70701c4dc1893e1);
$parcel$export(module.exports, "FORGOT_PASSWORD_FAILURE", () => $b64147ddc37ef75c$export$7e8a762ed2d6f2d2);
$parcel$export(module.exports, "LOGIN_ATTEMPT", () => $b64147ddc37ef75c$export$f3ad885eaa1b5f72);
$parcel$export(module.exports, "LOGIN_ATTEMPT_SUCCESS", () => $b64147ddc37ef75c$export$716c6a62442b28d7);
$parcel$export(module.exports, "LOGIN_ATTEMPT_FAILURE", () => $b64147ddc37ef75c$export$1c3cf2fdaea15601);
$parcel$export(module.exports, "RESET_LOGIN", () => $b64147ddc37ef75c$export$afec5a557a208da9);
$parcel$export(module.exports, "EXIT_TEST_MODE_ACTION", () => $b64147ddc37ef75c$export$98672ea6f23cc2ca);
$parcel$export(module.exports, "CHANGE_EMAIL_INPUT", () => $b64147ddc37ef75c$export$cbb84f780c133cae);
$parcel$export(module.exports, "CA_SSO_TEST_MODE_FAILURE", () => $b64147ddc37ef75c$export$82f99ffed31fea50);
$parcel$export(module.exports, "LOGIN_CONSENT_FAILURE", () => $b64147ddc37ef75c$export$daf9894dcc19911a);
$parcel$export(module.exports, "fetchLoginSuccess", () => $b64147ddc37ef75c$export$edced81742fba4bc);
$parcel$export(module.exports, "fetchLoginFailure", () => $b64147ddc37ef75c$export$d8cdd04268f89e8d);
$parcel$export(module.exports, "checkLoginAction", () => $b64147ddc37ef75c$export$a4840b835bebc845);
$parcel$export(module.exports, "checkLoginActionSuccess", () => $b64147ddc37ef75c$export$80f72fff3f8aebd3);
$parcel$export(module.exports, "checkLoginActionFailure", () => $b64147ddc37ef75c$export$ab186d6cbffedaab);
$parcel$export(module.exports, "loginAttempt", () => $b64147ddc37ef75c$export$bff2b4217ebde9c3);
$parcel$export(module.exports, "loginAttemptSuccess", () => $b64147ddc37ef75c$export$4b4199104faef544);
$parcel$export(module.exports, "loginAttemptFailure", () => $b64147ddc37ef75c$export$6df4ba6cdf3cad7f);
$parcel$export(module.exports, "forgotPassword", () => $b64147ddc37ef75c$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $b64147ddc37ef75c$export$2effc3102ad6a101);
$parcel$export(module.exports, "createPasswordSuccess", () => $b64147ddc37ef75c$export$dc17890d1692fbd);
$parcel$export(module.exports, "forgotPasswordSuccess", () => $b64147ddc37ef75c$export$e65d2e9031cf7578);
$parcel$export(module.exports, "resetLogin", () => $b64147ddc37ef75c$export$9a31ad345a1aa336);
$parcel$export(module.exports, "exitTestModeAction", () => $b64147ddc37ef75c$export$ba564c8e35ce769d);
$parcel$export(module.exports, "changeEmailInput", () => $b64147ddc37ef75c$export$c55ade57a8bbcea5);
$parcel$export(module.exports, "caSsoTestModeFailure", () => $b64147ddc37ef75c$export$cf9ecdd9f9c734b3);
$parcel$export(module.exports, "loginConsentFailure", () => $b64147ddc37ef75c$export$22b3a2f6203607fa);
const $b64147ddc37ef75c$export$839deb1eefe4e515 = 'state.ui.login.FETCH_LOGIN_SUCCESS';
const $b64147ddc37ef75c$export$8cf8563c2d1c6683 = 'state.ui.login.FETCH_LOGIN_FAILURE';
const $b64147ddc37ef75c$export$fe8137105dc1ed9 = 'state.ui.login.CREATE_PASSWORD';
const $b64147ddc37ef75c$export$66c73e13cf8b697a = 'state.ui.login.CREATE_PASSWORD_SUCCESS';
const $b64147ddc37ef75c$export$816b17d1322118b2 = 'state.ui.login.CHECK_LOGIN_ACTION';
const $b64147ddc37ef75c$export$f5cb563064a027ff = 'state.ui.login.CHECK_LOGIN_ACTION_SUCCESS';
const $b64147ddc37ef75c$export$150db551ad2bf414 = 'state.ui.login.CHECK_LOGIN_ACTION_FAILURE';
const $b64147ddc37ef75c$export$e479859894f5f058 = 'state.ui.login.FORGOT_PASSWORD';
const $b64147ddc37ef75c$export$e70701c4dc1893e1 = 'state.ui.login.FORGOT_PASSWORD_SUCCESS';
const $b64147ddc37ef75c$export$7e8a762ed2d6f2d2 = 'state.ui.login.FORGOT_PASSWORD_FAILURE';
const $b64147ddc37ef75c$export$f3ad885eaa1b5f72 = 'state.ui.login.LOGIN_ATTEMPT';
const $b64147ddc37ef75c$export$716c6a62442b28d7 = 'state.ui.login.LOGIN_ATTEMPT_SUCCESS';
const $b64147ddc37ef75c$export$1c3cf2fdaea15601 = 'state.ui.login.LOGIN_ATTEMPT_FAILURE';
const $b64147ddc37ef75c$export$afec5a557a208da9 = 'state.ui.login.RESET_LOGIN';
const $b64147ddc37ef75c$export$98672ea6f23cc2ca = 'state.ui.login.EXIT_TEST_MODE_ACTION';
const $b64147ddc37ef75c$export$cbb84f780c133cae = 'state.ui.login.CHANGE_EMAIL_INPUT';
const $b64147ddc37ef75c$export$82f99ffed31fea50 = 'state.ui.login.CA_SSO_TEST_MODE_FAILURE';
const $b64147ddc37ef75c$export$daf9894dcc19911a = 'state.ui.login.LOGIN_CONSENT_FAILURE';
const $b64147ddc37ef75c$export$edced81742fba4bc = (loginModel)=>({
        payload: loginModel,
        type: $b64147ddc37ef75c$export$839deb1eefe4e515
    });
const $b64147ddc37ef75c$export$d8cdd04268f89e8d = (error)=>({
        type: $b64147ddc37ef75c$export$8cf8563c2d1c6683,
        payload: {
            error: error
        }
    });
const $b64147ddc37ef75c$export$a4840b835bebc845 = (email, portalId, authData, createAnalyticsEvent)=>({
        type: $b64147ddc37ef75c$export$816b17d1322118b2,
        payload: {
            email: email,
            portalId: portalId,
            authData: authData,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $b64147ddc37ef75c$export$80f72fff3f8aebd3 = (action, authInfo)=>({
        type: $b64147ddc37ef75c$export$f5cb563064a027ff,
        payload: {
            action: action,
            authInfo: authInfo
        }
    });
const $b64147ddc37ef75c$export$ab186d6cbffedaab = (error)=>({
        type: $b64147ddc37ef75c$export$150db551ad2bf414,
        payload: {
            error: error
        }
    });
const $b64147ddc37ef75c$export$bff2b4217ebde9c3 = (payload)=>({
        payload: payload,
        type: $b64147ddc37ef75c$export$f3ad885eaa1b5f72
    });
const $b64147ddc37ef75c$export$4b4199104faef544 = (loginAttemptResponse)=>({
        type: $b64147ddc37ef75c$export$716c6a62442b28d7,
        payload: {
            loginAttemptResponse: loginAttemptResponse
        }
    });
const $b64147ddc37ef75c$export$6df4ba6cdf3cad7f = (error)=>({
        type: $b64147ddc37ef75c$export$1c3cf2fdaea15601,
        payload: {
            error: error
        }
    });
const $b64147ddc37ef75c$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>({
        type: $b64147ddc37ef75c$export$e479859894f5f058,
        payload: {
            resetUrl: resetUrl,
            email: email,
            redirectUrl: redirectUrl
        }
    });
const $b64147ddc37ef75c$export$2effc3102ad6a101 = (resetUrl, email)=>({
        type: $b64147ddc37ef75c$export$fe8137105dc1ed9,
        payload: {
            resetUrl: resetUrl,
            email: email
        }
    });
const $b64147ddc37ef75c$export$dc17890d1692fbd = ()=>({
        type: $b64147ddc37ef75c$export$66c73e13cf8b697a
    });
const $b64147ddc37ef75c$export$e65d2e9031cf7578 = ()=>({
        type: $b64147ddc37ef75c$export$e70701c4dc1893e1
    });
const $b64147ddc37ef75c$export$c82fc620622643dd = (error)=>({
        type: $b64147ddc37ef75c$export$7e8a762ed2d6f2d2,
        payload: {
            error: error
        }
    });
const $b64147ddc37ef75c$export$9a31ad345a1aa336 = (email = '')=>({
        type: $b64147ddc37ef75c$export$afec5a557a208da9,
        payload: {
            email: email
        }
    });
const $b64147ddc37ef75c$export$ba564c8e35ce769d = (email = '')=>({
        type: $b64147ddc37ef75c$export$98672ea6f23cc2ca,
        payload: {
            email: email
        }
    });
const $b64147ddc37ef75c$export$c55ade57a8bbcea5 = (email)=>({
        type: $b64147ddc37ef75c$export$cbb84f780c133cae,
        payload: {
            email: email
        }
    });
const $b64147ddc37ef75c$export$cf9ecdd9f9c734b3 = ()=>({
        type: $b64147ddc37ef75c$export$82f99ffed31fea50
    });
const $b64147ddc37ef75c$export$22b3a2f6203607fa = ()=>({
        type: $b64147ddc37ef75c$export$daf9894dcc19911a
    });

});


parcelRegister("fI5Sq", function(module, exports) {
$parcel$export(module.exports, "getFirstMessageFromJiraError", () => $590ebbd648c1a56c$export$63b892f0c5ffc91e);
$parcel$export(module.exports, "getJiraErrorOrDefault", () => $590ebbd648c1a56c$export$c3183aaaea823e43);
$parcel$export(module.exports, "getDefaultError", () => $590ebbd648c1a56c$export$7419e04ae130d87b);
$parcel$export(module.exports, "getJiraErrorResponse", () => $590ebbd648c1a56c$export$93579a27d9d34c28);
$parcel$export(module.exports, "genericError", () => $590ebbd648c1a56c$export$28cd364e99d3d2cb);
$parcel$export(module.exports, "getDefaultSignUpError", () => $590ebbd648c1a56c$export$48e9b610f790f75b);
$parcel$export(module.exports, "getDefaultCheckLoginError", () => $590ebbd648c1a56c$export$e35369cd8bc15322);
$parcel$export(module.exports, "isSsoTestModeError", () => $590ebbd648c1a56c$export$ef531073403eb96);
$parcel$export(module.exports, "getUserProfileForgotPasswordFailedError", () => $590ebbd648c1a56c$export$8258d31b06384bf2);

var $ebSwD = parcelRequire("ebSwD");

var $3TeDY = parcelRequire("3TeDY");
const $590ebbd648c1a56c$export$ce1888b50106d3cd = (errorResponse)=>{
    const hasError = errorResponse && errorResponse.errors;
    return hasError ? errorResponse.errors.map((error)=>error && error.errorMessage) : [];
};
const $590ebbd648c1a56c$export$63b892f0c5ffc91e = (errorResponse)=>{
    const errorMessages = $590ebbd648c1a56c$export$ce1888b50106d3cd(errorResponse);
    return errorMessages.length > 0 ? errorMessages[0] : '';
};
const $590ebbd648c1a56c$export$c3183aaaea823e43 = (error)=>{
    const jiraErrorMessage = $590ebbd648c1a56c$export$63b892f0c5ffc91e(error.response);
    if (jiraErrorMessage.length > 0) return {
        errorMessage: jiraErrorMessage
    };
    return $590ebbd648c1a56c$export$7419e04ae130d87b(error);
};
const $590ebbd648c1a56c$export$93579a27d9d34c28 = (error)=>{
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (error.response && error.response.errors) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return error.response;
    return undefined;
};
const $590ebbd648c1a56c$export$7419e04ae130d87b = (error)=>{
    if ($590ebbd648c1a56c$var$isRateLimitedError(error)) return $590ebbd648c1a56c$export$91ba33ab5aae4f04;
    if ($590ebbd648c1a56c$var$isNetworkError(error)) return $590ebbd648c1a56c$export$2b69dc41a4a4ae83();
    return $590ebbd648c1a56c$export$28cd364e99d3d2cb;
};
const $590ebbd648c1a56c$export$48e9b610f790f75b = (error, contactAdminsFormEnabled)=>{
    if ($590ebbd648c1a56c$var$isNetworkError(error)) return $590ebbd648c1a56c$export$2b69dc41a4a4ae83();
    return $590ebbd648c1a56c$export$fb8509ea6df35a83(contactAdminsFormEnabled);
};
const $590ebbd648c1a56c$export$e35369cd8bc15322 = (error)=>{
    const jiraErrorResponse = $590ebbd648c1a56c$export$93579a27d9d34c28(error);
    if (jiraErrorResponse) {
        if ($590ebbd648c1a56c$var$isSignupDomainBlockedError(error)) return $590ebbd648c1a56c$export$7528741a99bb3a62;
        if ($590ebbd648c1a56c$var$isEmailInvalidError(error)) return $590ebbd648c1a56c$export$e97b837fddbca6b3;
    } else if ($590ebbd648c1a56c$var$isNetworkError(error)) return $590ebbd648c1a56c$export$2b69dc41a4a4ae83();
    return $590ebbd648c1a56c$export$28cd364e99d3d2cb;
};
const $590ebbd648c1a56c$export$ef531073403eb96 = (error)=>$590ebbd648c1a56c$export$93579a27d9d34c28(error) && $590ebbd648c1a56c$var$isSsoTestModeFailure(error);
const $590ebbd648c1a56c$export$fb8509ea6df35a83 = (contactAdminsFormEnabled)=>{
    const noContactDescription = (0, $ebSwD.GenericSignUpErrorNoContactLinkDescription);
    const description = contactAdminsFormEnabled ? (0, $ebSwD.GenericSignUpErrorDescriptionUnified) : noContactDescription;
    return {
        description: description,
        title: (0, $ebSwD.GenericErrorTitle),
        action: $590ebbd648c1a56c$var$getGenericErrorFlagActions()
    };
};
const $590ebbd648c1a56c$var$isNetworkError = (errorResponse)=>errorResponse.status === 0;
const $590ebbd648c1a56c$var$isSignupDomainBlockedError = (errorResponse)=>{
    var _errorResponse$respon, _errorResponse$respon2;
    return errorResponse.status === 403 && (((_errorResponse$respon = errorResponse.response) === null || _errorResponse$respon === void 0 ? void 0 : _errorResponse$respon.reasonKey) === 'sd.customer.management.rest.error.customer.account.signup.blocked' || ((_errorResponse$respon2 = errorResponse.response) === null || _errorResponse$respon2 === void 0 ? void 0 : _errorResponse$respon2.reasonKey) === 'customer-signup-domain-blocked');
};
const $590ebbd648c1a56c$var$isEmailInvalidError = (errorResponse)=>{
    var _errorResponse$respon3;
    return errorResponse.status === 400 && ((_errorResponse$respon3 = errorResponse.response) === null || _errorResponse$respon3 === void 0 ? void 0 : _errorResponse$respon3.reasonKey) === 'signup.error.email.valid';
};
const $590ebbd648c1a56c$var$isSsoTestModeFailure = (errorResponse)=>{
    var _errorResponse$respon4;
    return errorResponse.status === 400 && ((_errorResponse$respon4 = errorResponse.response) === null || _errorResponse$respon4 === void 0 ? void 0 : _errorResponse$respon4.reasonKey) === 'CA_SSO_TEST_MODE_NOT_ENABLED';
};
const $590ebbd648c1a56c$var$isRateLimited = (errorResponse)=>errorResponse.status === 429;
const $590ebbd648c1a56c$var$isRateLimitedError = (errorResponse)=>{
    var _errorResponse$respon5;
    return $590ebbd648c1a56c$var$isRateLimited(errorResponse) && ((_errorResponse$respon5 = errorResponse.response) === null || _errorResponse$respon5 === void 0 ? void 0 : _errorResponse$respon5.reasonKey) === 'sd.email.signup.email.rate.limited';
};
const $590ebbd648c1a56c$var$getGenericErrorFlagActions = ()=>({
        href: (0, $3TeDY.location)().href,
        content: (0, $ebSwD.GenericErrorRefreshPageAction)
    });
const $590ebbd648c1a56c$export$2b69dc41a4a4ae83 = ()=>$590ebbd648c1a56c$export$5bd59b549d90b63;
const $590ebbd648c1a56c$export$5bd59b549d90b63 = {
    title: (0, $ebSwD.NoNetworkTitle),
    description: (0, $ebSwD.NoNetworkDescription)
};
const $590ebbd648c1a56c$export$91ba33ab5aae4f04 = {
    title: (0, $ebSwD.GenericErrorTitle),
    description: (0, $ebSwD.SignupEmailResendRateLimitedDescription)
};
const $590ebbd648c1a56c$export$7528741a99bb3a62 = {
    title: (0, $ebSwD.SignupDomainBlockedTitle),
    description: (0, $ebSwD.SignupDomainBlockedDescription)
};
const $590ebbd648c1a56c$export$e97b837fddbca6b3 = {
    title: (0, $ebSwD.InvalidEmailTitle),
    description: (0, $ebSwD.InvalidEmailDescription)
};
const $590ebbd648c1a56c$export$28cd364e99d3d2cb = {
    title: (0, $ebSwD.GenericErrorTitle),
    description: (0, $ebSwD.GenericErrorDescription),
    action: $590ebbd648c1a56c$var$getGenericErrorFlagActions()
};
const $590ebbd648c1a56c$var$genericUserProfileForgotPasswordFailedError = {
    title: (0, $ebSwD.UserProfileForgotPasswordFailedErrorTitle),
    description: (0, $ebSwD.UserProfileForgotPasswordFailedErrorDescription)
};
const $590ebbd648c1a56c$export$3cd8f5c164dad65c = {
    title: (0, $ebSwD.UserProfileForgotPasswordRateLimitedErrorTitle),
    description: (0, $ebSwD.UserProfileForgotPasswordRateLimitedErrorDescription)
};
const $590ebbd648c1a56c$export$8258d31b06384bf2 = (error)=>{
    if ($590ebbd648c1a56c$var$isNetworkError(error)) return $590ebbd648c1a56c$export$2b69dc41a4a4ae83();
    if ($590ebbd648c1a56c$var$isRateLimited(error)) return $590ebbd648c1a56c$export$3cd8f5c164dad65c;
    return $590ebbd648c1a56c$var$genericUserProfileForgotPasswordFailedError;
};

});
parcelRegister("ebSwD", function(module, exports) {
$parcel$export(module.exports, "GenericErrorTitle", () => $bd82c0c61a14fbc6$export$e882af1f191f98ed);
$parcel$export(module.exports, "GenericErrorDescription", () => $bd82c0c61a14fbc6$export$435282e749b7e900);
$parcel$export(module.exports, "GenericSignUpErrorDescriptionUnified", () => $bd82c0c61a14fbc6$export$814e1ad271462eee);
$parcel$export(module.exports, "GenericSignUpErrorNoContactLinkDescription", () => $bd82c0c61a14fbc6$export$53a250c0a0614ddf);
$parcel$export(module.exports, "RefreshPageLinkText", () => $bd82c0c61a14fbc6$export$2c865db45566f3fc);
$parcel$export(module.exports, "TellUsAboutIssueLinkText", () => $bd82c0c61a14fbc6$export$4cd0b637ea791e58);
$parcel$export(module.exports, "LetUsKnowLinkText", () => $bd82c0c61a14fbc6$export$91b106f2d7a60f86);
$parcel$export(module.exports, "GenericErrorRefreshPageAction", () => $bd82c0c61a14fbc6$export$20483281c243b1a0);
$parcel$export(module.exports, "NoNetworkTitle", () => $bd82c0c61a14fbc6$export$b0cc5cbdc11d8431);
$parcel$export(module.exports, "SignupEmailResendRateLimitedDescription", () => $bd82c0c61a14fbc6$export$fdbfe2d9101e694);
$parcel$export(module.exports, "NoNetworkDescription", () => $bd82c0c61a14fbc6$export$d349948b740c510b);
$parcel$export(module.exports, "SignupDomainBlockedDescription", () => $bd82c0c61a14fbc6$export$f1af5cb5b09d8e91);
$parcel$export(module.exports, "SignupDomainBlockedTitle", () => $bd82c0c61a14fbc6$export$23a02d68ec91feaf);
$parcel$export(module.exports, "InvalidEmailTitle", () => $bd82c0c61a14fbc6$export$593b1e00f52b5f5e);
$parcel$export(module.exports, "InvalidEmailDescription", () => $bd82c0c61a14fbc6$export$82cbc81342a448dd);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorTitle", () => $bd82c0c61a14fbc6$export$6e2b8a076a84e30b);
$parcel$export(module.exports, "UserProfileForgotPasswordFailedErrorDescription", () => $bd82c0c61a14fbc6$export$eb78dd4efec095b1);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorTitle", () => $bd82c0c61a14fbc6$export$17669172b666864);
$parcel$export(module.exports, "UserProfileForgotPasswordRateLimitedErrorDescription", () => $bd82c0c61a14fbc6$export$6daa483c0f823589);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("12C9Q")).default);

var $12C9Q = parcelRequire("12C9Q");

var $cgfAU = parcelRequire("cgfAU");
const $bd82c0c61a14fbc6$export$e882af1f191f98ed = (0, $cgfAU.default).genericErrorTitle;
const $bd82c0c61a14fbc6$export$435282e749b7e900 = (0, $cgfAU.default).genericErrorDescription;
const $bd82c0c61a14fbc6$export$814e1ad271462eee = (0, $cgfAU.default).genericSignUpErrorDescriptionUnified;
const $bd82c0c61a14fbc6$export$53a250c0a0614ddf = (0, $cgfAU.default).genericSignUpErrorNoContactLinkDescription;
const $bd82c0c61a14fbc6$export$2c865db45566f3fc = (0, $cgfAU.default).refreshPageLinkText;
const $bd82c0c61a14fbc6$export$4cd0b637ea791e58 = (0, $cgfAU.default).tellUsAboutIssueLinkText;
const $bd82c0c61a14fbc6$export$91b106f2d7a60f86 = (0, $cgfAU.default).letUsKnowLinkText;
const $bd82c0c61a14fbc6$export$20483281c243b1a0 = (0, $cgfAU.default).genericErrorRefreshPageAction;
const $bd82c0c61a14fbc6$export$b0cc5cbdc11d8431 = (0, $cgfAU.default).noNetworkTitle;
const $bd82c0c61a14fbc6$export$fdbfe2d9101e694 = (0, $cgfAU.default).signupEmailResendRateLimitedDescription;
const $bd82c0c61a14fbc6$export$d349948b740c510b = (0, $cgfAU.default).noNetworkDescription;
const $bd82c0c61a14fbc6$export$f1af5cb5b09d8e91 = (0, $cgfAU.default).blockedDescription;
const $bd82c0c61a14fbc6$export$23a02d68ec91feaf = (0, $cgfAU.default).blockedTitle;
const $bd82c0c61a14fbc6$export$593b1e00f52b5f5e = (0, $cgfAU.default).invalidEmailTitle;
const $bd82c0c61a14fbc6$export$82cbc81342a448dd = (0, $cgfAU.default).invalidEmailDescription;
const $bd82c0c61a14fbc6$export$6e2b8a076a84e30b = (0, $cgfAU.default).userProfileForgotPasswordFailedFlagTitle;
const $bd82c0c61a14fbc6$export$eb78dd4efec095b1 = (0, $cgfAU.default).userProfileForgotPasswordFailedFlagDescription;
const $bd82c0c61a14fbc6$export$17669172b666864 = (0, $cgfAU.default).userProfileForgotPasswordRateLimitedFlagTitle;
const $bd82c0c61a14fbc6$export$6daa483c0f823589 = (0, $cgfAU.default).userProfileForgotPasswordRateLimitedFlagDescription;

});
parcelRegister("12C9Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec481bd3453e28eb$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $gBYjj = parcelRequire("gBYjj");
parcelRequire("bJaAD");
var $cfGXM = parcelRequire("cfGXM");

var $k0PSo = parcelRequire("k0PSo");
const $ec481bd3453e28eb$var$selector = (0, $3yyCx.createSelector)((state)=>(0, $cfGXM.getFlags)(state), (flags)=>({
        flags: flags
    }));
var $ec481bd3453e28eb$export$2e2bcd8739ae039 = (0, $bmgw6.default)($ec481bd3453e28eb$var$selector, {
    dismissFlagAction: (0, $gBYjj.dismissFlag)
})((0, $k0PSo.default));

});
parcelRegister("3yyCx", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $296f66fba830525e$export$595d22ed68ca2841, (v) => $296f66fba830525e$export$595d22ed68ca2841 = v);
var $296f66fba830525e$export$1e511d4a378977f5;
var $296f66fba830525e$export$281bff7f05488aa2;
var $296f66fba830525e$export$5943f4447f6ef248;
var $296f66fba830525e$export$75979cfcd91bf38f;
var $296f66fba830525e$export$595d22ed68ca2841;
'use strict';
$296f66fba830525e$export$1e511d4a378977f5 = true;
$296f66fba830525e$export$281bff7f05488aa2 = $296f66fba830525e$var$defaultMemoize;
$296f66fba830525e$export$5943f4447f6ef248 = $296f66fba830525e$var$createSelectorCreator;
$296f66fba830525e$export$75979cfcd91bf38f = $296f66fba830525e$var$createStructuredSelector;
function $296f66fba830525e$var$defaultEqualityCheck(a, b) {
    return a === b;
}
function $296f66fba830525e$var$areArgumentsShallowlyEqual(equalityCheck, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
    var length = prev.length;
    for(var i = 0; i < length; i++){
        if (!equalityCheck(prev[i], next[i])) return false;
    }
    return true;
}
function $296f66fba830525e$var$defaultMemoize(func) {
    var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $296f66fba830525e$var$defaultEqualityCheck;
    var lastArgs = null;
    var lastResult = null;
    // we reference arguments instead of spreading them for performance reasons
    return function() {
        if (!$296f66fba830525e$var$areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) // apply arguments instead of spreading for performance.
        lastResult = func.apply(null, arguments);
        lastArgs = arguments;
        return lastResult;
    };
}
function $296f66fba830525e$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
        }).join(', ');
        throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
    }
    return dependencies;
}
function $296f66fba830525e$var$createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptions[_key - 1] = arguments[_key];
    return function() {
        for(var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var recomputations = 0;
        var resultFunc = funcs.pop();
        var dependencies = $296f66fba830525e$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(undefined, [
            function() {
                recomputations++;
                // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(memoizeOptions));
        // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = $296f66fba830525e$var$defaultMemoize(function() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            params.push(dependencies[i].apply(null, arguments));
            // apply arguments instead of spreading for performance.
            return memoizedResultFunc.apply(null, params);
        });
        selector.resultFunc = resultFunc;
        selector.recomputations = function() {
            return recomputations;
        };
        selector.resetRecomputations = function() {
            return recomputations = 0;
        };
        return selector;
    };
}
var $296f66fba830525e$var$createSelector = $296f66fba830525e$export$595d22ed68ca2841 = $296f66fba830525e$var$createSelectorCreator($296f66fba830525e$var$defaultMemoize);
function $296f66fba830525e$var$createStructuredSelector(selectors) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $296f66fba830525e$var$createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
    var objectKeys = Object.keys(selectors);
    return selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
}

});

parcelRegister("bJaAD", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => (parcelRequire("cfGXM")).getFlags);

var $cfGXM = parcelRequire("cfGXM");

});
parcelRegister("cfGXM", function(module, exports) {
$parcel$export(module.exports, "getFlags", () => $1437ab6123dcac4f$export$d5815430bcc75df0);
const $1437ab6123dcac4f$export$d5815430bcc75df0 = (state)=>{
    return state.ui.flags.flags;
};

});


parcelRegister("k0PSo", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c4de90421b28c20$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("4Eve9");
var $aXmKW = parcelRequire("aXmKW");
class $0c4de90421b28c20$export$2e2bcd8739ae039 extends $4fqPo.Component {
    render() {
        const { flags: flags, dismissFlagAction: dismissFlagAction } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $aXmKW.default), {
            flags: flags,
            dismissFlagAction: dismissFlagAction
        });
    }
}

});
parcelRegister("4Eve9", function(module, exports) {
$parcel$export(module.exports, "FlagGroupStateless", () => (parcelRequire("aXmKW")).default);

var $aXmKW = parcelRequire("aXmKW");

});
parcelRegister("aXmKW", function(module, exports) {
$parcel$export(module.exports, "default", () => $17778fcb41511597$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $efDRU = parcelRequire("efDRU");

var $25gao = parcelRequire("25gao");
var $h1mlL = parcelRequire("h1mlL");

var $hMwsV = parcelRequire("hMwsV");

var $bNwNQ = parcelRequire("bNwNQ");

var $3RpuA = parcelRequire("3RpuA");

var $klZKM = parcelRequire("klZKM");
const $17778fcb41511597$var$isSuccessFlagAction = (flagAction)=>{
    return 'contentNode' in flagAction && !!flagAction.contentNode;
};
class $17778fcb41511597$export$bf63ac67069f812 extends $4fqPo.Component {
    render() {
        const { flags: flags } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $h1mlL.default), {
            onDismissed: this.handleFlagDismissed
        }, flags.map((flag)=>this.renderFlag(flag)));
    }
    constructor(...args){
        super(...args), this.handleFlagDismissed = (flagId)=>{
            this.props.dismissFlagAction(flagId);
        }, this.i18nFlagActions = (actions)=>{
            const { intl: intl } = this.props;
            return actions.map((action)=>{
                return $17778fcb41511597$var$isSuccessFlagAction(action) ? {
                    content: action.contentNode,
                    href: action === null || action === void 0 ? void 0 : action.href
                } : {
                    content: intl.formatMessage(action.content),
                    href: action.href
                };
            });
        }, this.getIcon = (flag)=>{
            switch(flag.type){
                case 'error':
                    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMwsV))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'warning':
                    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($klZKM))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-warning, #FF8B00)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'success':
                    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-success, #36B37E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                case 'bold':
                    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-information, #42526E)",
                        label: "",
                        "aria-hidden": "true"
                    });
                default:
                    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMwsV))), {
                        spacing: "spacious",
                        color: "var(--ds-icon-danger, #BF2600)",
                        label: "",
                        "aria-hidden": "true"
                    });
            }
        }, this.renderFlag = (flag)=>{
            const { intl: intl } = this.props;
            if (flag.type === 'bold') {
                const dismissAction = [];
                if (flag.dismissActionValue) dismissAction.push({
                    content: intl.formatMessage(flag.dismissActionValue),
                    onClick: ()=>{
                        this.handleFlagDismissed(flag.id);
                    }
                });
                return /*#__PURE__*/ $4fqPo.createElement((0, $25gao.default), {
                    appearance: flag.appearance,
                    id: flag.id,
                    key: flag.id,
                    icon: this.getIcon(flag),
                    title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                    description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                    actions: [
                        ...flag.actions,
                        ...dismissAction
                    ]
                });
            }
            return /*#__PURE__*/ $4fqPo.createElement((0, $25gao.default), {
                id: flag.id,
                key: flag.id,
                icon: this.getIcon(flag),
                title: intl.formatMessage(flag.titleMessage, flag.titleMessageValues),
                description: flag.descriptionMessage === undefined ? undefined : intl.formatMessage(flag.descriptionMessage, flag.descriptionMessageValues),
                actions: this.i18nFlagActions(flag.actions)
            });
        };
    }
}
var $17778fcb41511597$export$2e2bcd8739ae039 = (0, $efDRU.default)($17778fcb41511597$export$bf63ac67069f812);

});
parcelRegister("25gao", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ee0ab2e4b97baf4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");

var $edOls = parcelRequire("edOls");

var $eYatF = parcelRequire("eYatF");
const $2ee0ab2e4b97baf4$var$packageName = undefined;
const $2ee0ab2e4b97baf4$var$packageVersion = undefined;
const $2ee0ab2e4b97baf4$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $2ee0ab2e4b97baf4$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $c1tmZ.default), autoDismissSeconds: autoDismissSeconds = $2ee0ab2e4b97baf4$export$66c3d409977b5615 } = props;
    const autoDismissTimer = (0, $4fqPo.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $eYatF.useFlagGroup)();
    const onDismissed = (0, $4fqPo.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $2ee0ab2e4b97baf4$var$packageName,
        packageVersion: $2ee0ab2e4b97baf4$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $4fqPo.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $4fqPo.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $4fqPo.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, autoDismissSeconds * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed,
        autoDismissSeconds
    ]);
    (0, $4fqPo.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $edOls.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $2ee0ab2e4b97baf4$export$2e2bcd8739ae039 = $2ee0ab2e4b97baf4$var$AutoDismissFlag;

});
parcelRegister("edOls", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e04bacbbf3be26b$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.37.1 */ /* flag.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4EOcq = parcelRequire("4EOcq");

var $fxmw9 = parcelRequire("fxmw9");

var $c1tmZ = parcelRequire("c1tmZ");

var $2eKV2 = parcelRequire("2eKV2");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");
var $Cp2Ub = parcelRequire("Cp2Ub");
var $5E02Z = parcelRequire("5E02Z");

var $gFdUI = parcelRequire("gFdUI");

var $hOB95 = parcelRequire("hOB95");

var $fgk83 = parcelRequire("fgk83");

var $iCn4C = parcelRequire("iCn4C");

var $axlDK = parcelRequire("axlDK");

var $hSJ8e = parcelRequire("hSJ8e");

var $3PgRa = parcelRequire("3PgRa");

var $ezuEG = parcelRequire("ezuEG");

var $ehOsK = parcelRequire("ehOsK");
var $fil1W = parcelRequire("fil1W");

var $eYatF = parcelRequire("eYatF");
const $9e04bacbbf3be26b$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs130s _1pbyni7l _1bsb1osq",
    flagT26Shape: "_2rko1mok"
};
const $9e04bacbbf3be26b$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $9e04bacbbf3be26b$var$descriptionStyles = null;
const $9e04bacbbf3be26b$var$iconWrapperStyles = null;
const $9e04bacbbf3be26b$var$flagWrapperStyles = null;
const $9e04bacbbf3be26b$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: undefined,
    packageVersion: undefined
};
const $9e04bacbbf3be26b$var$transitionStyles = null;
// jpo-41318-fix-flag-overflow-fg TODO: Merge into base after rollout
const $9e04bacbbf3be26b$var$minWidthStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ const $9e04bacbbf3be26b$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $hOB95.DEFAULT_APPEARANCE), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $c1tmZ.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $c1tmZ.default), onDismissed: onDismissedProp = (0, $c1tmZ.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $4fqPo.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $eYatF.useFlagGroup)();
    const onDismissed = (0, $4fqPo.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $4fqPo.useState)(false);
    const onDismissedAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$9e04bacbbf3be26b$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $hOB95.DEFAULT_APPEARANCE);
    const toggleExpand = (0, $4fqPo.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $4fqPo.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$9e04bacbbf3be26b$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$9e04bacbbf3be26b$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $3PgRa.flagTextColor)[appearance];
    const iconColor = (0, $axlDK.flagIconColor)[appearance];
    const iconGlyph = (0, $hSJ8e.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $4fqPo.createElement((0, $gFdUI.default), null, title, description) : undefined;
    // A11y improvement opportunity: all flags currently use role="alert" (assertive),
    // but non-critical flags (e.g. info, success) should use role="status" (polite)
    // to avoid interrupting screen reader users. See WCAG 4.1.3.
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $ltgDR.default)([
            "_1bsb1osq"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        padding: "space.200",
        backgroundColor: (0, $iCn4C.flagBackgroundColor)[appearance],
        xcss: (0, $fxmw9.cx)($9e04bacbbf3be26b$var$styles.flag, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $9e04bacbbf3be26b$var$styles.flagT26Shape)
    }, /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9e04bacbbf3be26b$var$CSS_VAR_ICON_COLOR]: iconColor
        },
        "data-testid": testId && `${testId}-icon-container`,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0"
        ])
    }, icon || iconGlyph), /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            "_v5641hdc _16jlkb7n",
            (0, $3H4LK.fg)('jpo-41318-fix-flag-overflow-fg') && "_1ul9idpf"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), {
        space: shouldRenderGap ? 'space.100' : 'space.0'
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $9e04bacbbf3be26b$var$styles.overflowWrap
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        as: `h${headingLevel}`,
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $4fqPo.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $4fqPo.createElement((0, $ehOsK.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $4fqPo.createElement((0, $fil1W.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $ezuEG.flagTextColorToken)[appearance]
        },
        "data-testid": testId && `${testId}-description`,
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
        className: (0, $ltgDR.default)([
            "_11c8fhey _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $4fqPo.createElement((0, $fgk83.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $9e04bacbbf3be26b$export$2e2bcd8739ae039 = $9e04bacbbf3be26b$var$Flag;

});
parcelRegister("fxmw9", function(module, exports) {
$parcel$export(module.exports, "cx", () => $49055316a2404233$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ parcelRequire("4fqPo");

var $a0Trt = parcelRequire("a0Trt");
const $49055316a2404233$var$strictApi = (0, $a0Trt.createStrictAPI)();
const $49055316a2404233$export$dbf350e5966cf602 = $49055316a2404233$var$strictApi.css;
const $49055316a2404233$export$eb1ecd84a24ee424 = $49055316a2404233$var$strictApi.cssMap;
$49055316a2404233$var$strictApi.cssMap;
const $49055316a2404233$export$a274e22fb40f762e = $49055316a2404233$var$strictApi.cx;
const $49055316a2404233$var$XCSSProp = $49055316a2404233$var$strictApi.XCSSProp;

});
parcelRegister("a0Trt", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $74a4e9235dfe83e7$export$39716b4af53f4ad);

var $bPk0O = parcelRequire("bPk0O");

var $9h99w = parcelRequire("9h99w");
function $74a4e9235dfe83e7$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $bPk0O.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $bPk0O.createStrictSetupError)();
        },
        cx: $9h99w.cx,
        XCSSProp () {
            throw (0, $bPk0O.createStrictSetupError)();
        }
    };
}

});
parcelRegister("bPk0O", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $89c3fb1eb1f4b69a$export$c4df1cb0c2b4d77c);
const $89c3fb1eb1f4b69a$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $89c3fb1eb1f4b69a$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("9h99w", function(module, exports) {
$parcel$export(module.exports, "cx", () => $6c0ccd19db2e415c$export$a274e22fb40f762e);

var $ltgDR = parcelRequire("ltgDR");
const $6c0ccd19db2e415c$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $ltgDR.default)(actualStyles);
};

});



parcelRegister("7fscZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a19d601b42b0baf$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.37.1 */ /* box.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $28VoU = parcelRequire("28VoU");
const $3a19d601b42b0baf$var$baseStyles = null;
const $3a19d601b42b0baf$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhk187o",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $3a19d601b42b0baf$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $3a19d601b42b0baf$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $3a19d601b42b0baf$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $3a19d601b42b0baf$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $3a19d601b42b0baf$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $3a19d601b42b0baf$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $3a19d601b42b0baf$var$Box = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ $4fqPo.createElement(Component, {
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $ltgDR.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $3a19d601b42b0baf$var$backgroundColorMap[backgroundColor],
            backgroundColor && $3a19d601b42b0baf$var$isSurfaceToken(backgroundColor) && $3a19d601b42b0baf$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $3a19d601b42b0baf$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $3a19d601b42b0baf$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $3a19d601b42b0baf$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $3a19d601b42b0baf$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId
    }, children);
    if (backgroundColor) return /*#__PURE__*/ $4fqPo.createElement((0, $28VoU.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $3a19d601b42b0baf$export$2e2bcd8739ae039 = $3a19d601b42b0baf$var$Box;
function $3a19d601b42b0baf$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $3a19d601b42b0baf$var$setSurfaceTokenMap;
}

});

parcelRegister("Cp2Ub", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c03444de1c88953$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.37.1 */ /* inline.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fxmw9 = parcelRequire("fxmw9");

var $2UMA8 = parcelRequire("2UMA8");
const $3c03444de1c88953$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $3c03444de1c88953$var$Separator = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $3c03444de1c88953$var$styles.separator
        ])
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $3c03444de1c88953$var$Inline = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $4fqPo.createElement($3c03444de1c88953$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $4fqPo.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $4fqPo.createElement((0, $2UMA8.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $fxmw9.cx)(grow === 'hug' && $3c03444de1c88953$var$styles.hug, grow === 'fill' && $3c03444de1c88953$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$3c03444de1c88953$var$Inline.displayName = 'Inline';
var $3c03444de1c88953$export$2e2bcd8739ae039 = $3c03444de1c88953$var$Inline;

});
parcelRegister("2UMA8", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f54f46a48075447$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $2f54f46a48075447$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $2f54f46a48075447$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $2f54f46a48075447$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $2f54f46a48075447$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $2f54f46a48075447$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $2f54f46a48075447$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $2f54f46a48075447$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $2f54f46a48075447$var$Flex = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ $4fqPo.createElement(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $ltgDR.default)([
            $2f54f46a48075447$var$styles.root,
            gap && $2f54f46a48075447$var$columnGapMap[gap],
            columnGap && $2f54f46a48075447$var$columnGapMap[columnGap],
            gap && $2f54f46a48075447$var$rowGapMap[gap],
            rowGap && $2f54f46a48075447$var$rowGapMap[rowGap],
            alignItems && $2f54f46a48075447$var$alignItemsMap[alignItems],
            direction && $2f54f46a48075447$var$flexDirectionMap[direction],
            justifyContent && $2f54f46a48075447$var$justifyContentMap[justifyContent],
            wrap && $2f54f46a48075447$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$2f54f46a48075447$var$Flex.displayName = 'Flex';
var $2f54f46a48075447$export$2e2bcd8739ae039 = $2f54f46a48075447$var$Flex;

});


parcelRegister("5E02Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $a68abe320bf9ae4b$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.37.1 */ /* stack.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $2UMA8 = parcelRequire("2UMA8");
const $a68abe320bf9ae4b$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $a68abe320bf9ae4b$var$Stack = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $2UMA8.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $fxmw9.cx)(grow === 'hug' && $a68abe320bf9ae4b$var$styles.hug, grow === 'fill' && $a68abe320bf9ae4b$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }, children);
}));
$a68abe320bf9ae4b$var$Stack.displayName = 'Stack';
var $a68abe320bf9ae4b$export$2e2bcd8739ae039 = $a68abe320bf9ae4b$var$Stack;

});

parcelRegister("hOB95", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_APPEARANCE", () => $2628201bf5704128$export$d6830277b06edd6);
const $2628201bf5704128$export$d6830277b06edd6 = 'normal';

});

parcelRegister("fgk83", function(module, exports) {
$parcel$export(module.exports, "default", () => $db84fc5876fcf2e7$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $dM8x1 = parcelRequire("dM8x1");

var $Cp2Ub = parcelRequire("Cp2Ub");

var $hdF7X = parcelRequire("hdF7X");

var $hOB95 = parcelRequire("hOB95");

var $cJO21 = parcelRequire("cJO21");
const $db84fc5876fcf2e7$var$buttonStyles = null;
const $db84fc5876fcf2e7$var$fontStyles = null;
const $db84fc5876fcf2e7$var$appearanceNormalButtonStyles = null;
const $db84fc5876fcf2e7$var$appearanceNormalActionsContainerStyles = null;
const $db84fc5876fcf2e7$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $hOB95.DEFAULT_APPEARANCE), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $hOB95.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c8fhey"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && `${testId}-actions`
    }, actions.map((action, index)=>/*#__PURE__*/ $4fqPo.createElement((0, $dM8x1.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $hdF7X.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $cJO21.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $cJO21.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $cJO21.actionBackgroundColor)[appearance].active
            },
            className: (0, $ltgDR.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $hOB95.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ])
        }, action.content))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db84fc5876fcf2e7$export$2e2bcd8739ae039 = $db84fc5876fcf2e7$var$FlagActions;

});
parcelRegister("dM8x1", function(module, exports) {
$parcel$export(module.exports, "default", () => $75e030813e5f30a9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $km85U = parcelRequire("km85U");

var $cgBrh = parcelRequire("cgBrh");

var $4hzy3 = parcelRequire("4hzy3");

var $6Umy0 = parcelRequire("6Umy0");

var $9KxIx = parcelRequire("9KxIx");

var $aMsbe = parcelRequire("aMsbe");

var $9cU7i = parcelRequire("9cU7i");
function $75e030813e5f30a9$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $75e030813e5f30a9$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $75e030813e5f30a9$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $9KxIx.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $4fqPo.useState)($75e030813e5f30a9$var$initial);
    const onMouseEnter = (0, $4fqPo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $4fqPo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $4fqPo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $4fqPo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $4fqPo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $4fqPo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9cU7i.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($km85U))).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9cU7i.default).Consumer, {
            mode: mode,
            state: $75e030813e5f30a9$var$getInteractionState({
                ...state,
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            }),
            iconIsOnlyChild: (0, $4hzy3.default)(restProps),
            isLoading: isLoading,
            ...restProps
        }, ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cgBrh.default), {
                ...restProps,
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6Umy0.default), restProps) : null,
                // No need to render aria-disabled when it is false
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $aMsbe.getSpecifiers)(buttonStyles)
            }))));
}));
// Tools including enzyme rely on components having a display name
$75e030813e5f30a9$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $75e030813e5f30a9$export$2e2bcd8739ae039 = $75e030813e5f30a9$var$CustomThemeButton;

});
parcelRegister("km85U", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $7iypa = parcelRequire("7iypa");
module.exports = Object.assign({}, $7iypa, {
    themed: (propsToValues)=>(props)=>{
            const vals = typeof propsToValues === 'function' ? propsToValues(props) : propsToValues;
            return vals.light;
        }
});
if ($7iypa.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("7iypa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "getTheme", () => (parcelRequire("lLvR0")).default);
$parcel$export(module.exports, "default", () => (parcelRequire("aveND")).default);
$parcel$export(module.exports, "createTheme", () => (parcelRequire("b8zZJ")).createTheme);
/*
   This file will become the new index for theme once the codemod is mature enough.
   For now we're keeping the index file to avoid having to do a major change.
   Once the codemod is done and all the AK modules have been codeshifted, we delete index.js and rename this file to index + update all the imports
*/ 
var $lLvR0 = parcelRequire("lLvR0");

var $aveND = parcelRequire("aveND");

var $b8zZJ = parcelRequire("b8zZJ");

});
parcelRegister("lLvR0", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbe6053b1a8e0016$export$2e2bcd8739ae039);

var $hDp3n = parcelRequire("hDp3n");
function $fbe6053b1a8e0016$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $hDp3n.CHANNEL) in props.theme) return props.theme[0, $hDp3n.CHANNEL];
        else if ('mode' in props.theme && (0, $hDp3n.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $hDp3n.DEFAULT_THEME_MODE)
    };
}

});

parcelRegister("aveND", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5a9b6c12de5d2ca$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $b8zZJ = parcelRequire("b8zZJ");
// Create default global light theme
const $e5a9b6c12de5d2ca$var$dest = (0, $b8zZJ.createTheme)(()=>({
        mode: 'light'
    }));
const $e5a9b6c12de5d2ca$var$Provider = $e5a9b6c12de5d2ca$var$dest.Provider;
const $e5a9b6c12de5d2ca$var$Consumer = $e5a9b6c12de5d2ca$var$dest.Consumer;
const $e5a9b6c12de5d2ca$export$7692396083754928 = $e5a9b6c12de5d2ca$var$dest.useTheme;
const $e5a9b6c12de5d2ca$var$Theme = {
    Provider: $e5a9b6c12de5d2ca$var$Provider,
    Consumer: $e5a9b6c12de5d2ca$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e5a9b6c12de5d2ca$export$2e2bcd8739ae039 = $e5a9b6c12de5d2ca$var$Theme;

});
parcelRegister("b8zZJ", function(module, exports) {
$parcel$export(module.exports, "createTheme", () => $6914868fd8c0d325$export$25d302a5b900a763);

var $4fqPo = parcelRequire("4fqPo");
function $6914868fd8c0d325$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $4fqPo.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $4fqPo.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $4fqPo.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $4fqPo.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});




parcelRegister("6Umy0", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d224a8e3ecbf7d4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5qWT2 = parcelRequire("5qWT2");
function $5d224a8e3ecbf7d4$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $5d224a8e3ecbf7d4$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        size: size,
        label: ", Loading",
        appearance: $5d224a8e3ecbf7d4$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("5qWT2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8720d5a78cf210ac$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $9XaAY = parcelRequire("9XaAY");

var $lBWOj = parcelRequire("lBWOj");
/**
 * Returns the appropriate circle stroke color.
 */ function $8720d5a78cf210ac$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-inverse, #FFFFFF)";
}
const $8720d5a78cf210ac$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ const $8720d5a78cf210ac$var$loadIn = null;
const $8720d5a78cf210ac$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $8720d5a78cf210ac$var$useLayoutEffect = typeof window === 'undefined' ? (0, $4fqPo.useEffect) : (0, $4fqPo.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $8720d5a78cf210ac$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $lBWOj.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $8720d5a78cf210ac$var$getStrokeColor(appearance);
    const context = (0, $4fqPo.useContext)((0, $9XaAY.default));
    $8720d5a78cf210ac$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $ltgDR.default)([
            $8720d5a78cf210ac$var$styles.wrapperStyles,
            $8720d5a78cf210ac$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $ltgDR.default)([
            $8720d5a78cf210ac$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $ltgDR.default)([
            $8720d5a78cf210ac$var$styles.circleStyles
        ])
    })));
}));
var $8720d5a78cf210ac$export$2e2bcd8739ae039 = $8720d5a78cf210ac$var$Spinner;

});
parcelRegister("lBWOj", function(module, exports) {
$parcel$export(module.exports, "presetSizes", () => $b29868c63c130586$export$4e9f1640bbe7a1a8);
const $b29868c63c130586$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});



parcelRegister("9KxIx", function(module, exports) {
$parcel$export(module.exports, "defaultThemeFn", () => $2ba7826047632aff$export$437a7f77d13d7916);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $2ba7826047632aff$export$437a7f77d13d7916(current, values) {
    return current(values);
}

});

parcelRegister("aMsbe", function(module, exports) {
$parcel$export(module.exports, "getSpecifiers", () => $c116786088167060$export$643db0b8d8778e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $c116786088167060$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}

});

parcelRegister("9cU7i", function(module, exports) {
$parcel$export(module.exports, "default", () => $43f60d4e4757b251$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $km85U = parcelRequire("km85U");

var $flQuU = parcelRequire("flQuU");
const $43f60d4e4757b251$var$Theme = (0, $km85U.createTheme)((themeProps)=>({
        buttonStyles: (0, $flQuU.getCustomCss)(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f60d4e4757b251$export$2e2bcd8739ae039 = $43f60d4e4757b251$var$Theme;

});
parcelRegister("flQuU", function(module, exports) {
$parcel$export(module.exports, "getCustomCss", () => $78c5866e5d54f1ec$export$31512de7fa606fa4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bnkkA = parcelRequire("bnkkA");
const $78c5866e5d54f1ec$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $78c5866e5d54f1ec$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $bnkkA.getCss)({
        appearance: appearance,
        spacing: spacing,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $78c5866e5d54f1ec$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}

});



parcelRegister("hdF7X", function(module, exports) {
$parcel$export(module.exports, "actionTextColor", () => $7874afced02c2963$export$7bcfe3cca4dd78b6);
const $7874afced02c2963$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    normal: "var(--ds-link, #1868DB)"
};

});

parcelRegister("cJO21", function(module, exports) {
$parcel$export(module.exports, "actionBackgroundColor", () => $edcf784bfe40c906$export$81ba6b63eedb299f);






const $edcf784bfe40c906$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    info: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    error: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, #00000029)",
        active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
        pressed: "var(--ds-background-inverse-subtle-hovered, #0000003D)"
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};

});


parcelRegister("iCn4C", function(module, exports) {
$parcel$export(module.exports, "flagBackgroundColor", () => $fa694319265d82b4$export$59e42969c95d314);
const $fa694319265d82b4$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};

});

parcelRegister("axlDK", function(module, exports) {
$parcel$export(module.exports, "flagIconColor", () => $e287ac861612994b$export$7f70afe2167f8235);
const $e287ac861612994b$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #505258)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #292A2E)"
};

});

parcelRegister("hSJ8e", function(module, exports) {
$parcel$export(module.exports, "flagIconGlyph", () => $3de3eba756247c90$export$73f08aee70487cd4);

var $4fqPo = parcelRequire("4fqPo");

var $geWWn = parcelRequire("geWWn");

var $bNwNQ = parcelRequire("bNwNQ");

var $3RpuA = parcelRequire("3RpuA");

var $klZKM = parcelRequire("klZKM");
const $3de3eba756247c90$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        label: ""
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))), {
        label: ""
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))), {
        label: ""
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))), {
        label: ""
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($klZKM))), {
        label: ""
    })
};

});
parcelRegister("geWWn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd2bac851459ac1d$var$_react = $bd2bac851459ac1d$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $bd2bac851459ac1d$var$_baseNew = $bd2bac851459ac1d$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $bd2bac851459ac1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd2bac851459ac1d$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $bd2bac851459ac1d$var$_react.default.createElement($bd2bac851459ac1d$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$bd2bac851459ac1d$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $bd2bac851459ac1d$var$_default = module.exports.default = $bd2bac851459ac1d$var$StatusErrorIcon;

});

parcelRegister("bNwNQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02377270a2936812$var$_react = $02377270a2936812$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $02377270a2936812$var$_baseNew = $02377270a2936812$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $02377270a2936812$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02377270a2936812$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $02377270a2936812$var$_react.default.createElement($02377270a2936812$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$02377270a2936812$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $02377270a2936812$var$_default = module.exports.default = $02377270a2936812$var$StatusInformationIcon;

});

parcelRegister("3RpuA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cfa1898f6994054$var$_react = $2cfa1898f6994054$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $2cfa1898f6994054$var$_baseNew = $2cfa1898f6994054$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $2cfa1898f6994054$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cfa1898f6994054$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $2cfa1898f6994054$var$_react.default.createElement($2cfa1898f6994054$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$2cfa1898f6994054$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $2cfa1898f6994054$var$_default = module.exports.default = $2cfa1898f6994054$var$StatusSuccessIcon;

});

parcelRegister("klZKM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ed15abc680ce360c$var$_react = $ed15abc680ce360c$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $ed15abc680ce360c$var$_baseNew = $ed15abc680ce360c$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $ed15abc680ce360c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ed15abc680ce360c$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $ed15abc680ce360c$var$_react.default.createElement($ed15abc680ce360c$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$ed15abc680ce360c$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $ed15abc680ce360c$var$_default = module.exports.default = $ed15abc680ce360c$var$StatusWarningIcon;

});


parcelRegister("3PgRa", function(module, exports) {
$parcel$export(module.exports, "flagTextColor", () => $885a1ba826f77e8b$export$f50075b2584087f);
const $885a1ba826f77e8b$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};

});

parcelRegister("ezuEG", function(module, exports) {
$parcel$export(module.exports, "flagTextColorToken", () => $c003f098b16d2229$export$13b42cd9d596bfe0);
const $c003f098b16d2229$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, #FFFFFF)",
    info: "var(--ds-text-inverse, #FFFFFF)",
    normal: "var(--ds-text, #292A2E)",
    success: "var(--ds-text-inverse, #FFFFFF)",
    warning: "var(--ds-text-warning-inverse, #292A2E)"
};

});

parcelRegister("ehOsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9add499102de5f3$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $21P09 = parcelRequire("21P09");

var $cTq8x = parcelRequire("cTq8x");

var $aO0yS = parcelRequire("aO0yS");

var $9RW5e = parcelRequire("9RW5e");

var $ezuEG = parcelRequire("ezuEG");
const $e9add499102de5f3$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($9RW5e)));
    let buttonLabel = 'Dismiss';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($aO0yS))) : (0, (/*@__PURE__*/$parcel$interopDefault($cTq8x)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $21P09.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ButtonIcon, {
                ...iconProps,
                size: "small",
                label: "",
                color: (0, $ezuEG.flagTextColorToken)[appearance]
            }),
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
const $e9add499102de5f3$var$DismissButton = /*#__PURE__*/ (0, $4fqPo.memo)($e9add499102de5f3$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e9add499102de5f3$export$2e2bcd8739ae039 = $e9add499102de5f3$var$DismissButton;

});
parcelRegister("21P09", function(module, exports) {
$parcel$export(module.exports, "default", () => $6063cff004f73393$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5wgou = parcelRequire("5wgou");

var $8Mj6h = parcelRequire("8Mj6h");

var $gFdUI = parcelRequire("gFdUI");

var $98k4G = parcelRequire("98k4G");

var $Az2gn = parcelRequire("Az2gn");

var $c6jSC = parcelRequire("c6jSC");
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $6063cff004f73393$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $98k4G.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Az2gn.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c6jSC.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gFdUI.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents,
        shortcut: tooltip === null || tooltip === void 0 ? void 0 : tooltip.shortcut
    }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $98k4G.default), {
            ...saferRest,
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: (e, analyticsEvent)=>{
                var _triggerProps$onClick;
                onClick === null || onClick === void 0 || onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: (e)=>{
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: (e)=>{
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: (e)=>{
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: (e)=>{
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: (e)=>{
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: (e)=>{
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $5wgou.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Az2gn.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c6jSC.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gFdUI.default), null, label))));
}));
$6063cff004f73393$var$IconButton.displayName = 'IconButton';
var $6063cff004f73393$export$2e2bcd8739ae039 = $6063cff004f73393$var$IconButton;

});
parcelRegister("98k4G", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7355cece643f5f3$export$2e2bcd8739ae039);
/* button-base.tsx generated by @compiled/babel-plugin v0.37.1 */ /* button-base.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $5wgou = parcelRequire("5wgou");

var $jNU2T = parcelRequire("jNU2T");

var $a4Rr2 = parcelRequire("a4Rr2");

var $3H4LK = parcelRequire("3H4LK");

var $iqiKs = parcelRequire("iqiKs");

var $gFdUI = parcelRequire("gFdUI");

var $5BgTD = parcelRequire("5BgTD");

var $kAiyH = parcelRequire("kAiyH");

var $luCk9 = parcelRequire("luCk9");

var $b5a3w = parcelRequire("b5a3w");
const $b7355cece643f5f3$var$LOADING_LABEL = ', Loading';
const $b7355cece643f5f3$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhk187o _irr3187o _1di6187o",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $b7355cece643f5f3$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $b7355cece643f5f3$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $b7355cece643f5f3$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31afz _9h8h15cr _1di61kru"
};
const $b7355cece643f5f3$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $b7355cece643f5f3$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $b7355cece643f5f3$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $b7355cece643f5f3$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $b7355cece643f5f3$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $b7355cece643f5f3$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const localRef = (0, $4fqPo.useRef)(null);
    const splitButtonContext = (0, $kAiyH.useSplitButtonContext)();
    const loadingLabelId = (0, $a4Rr2.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    const isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    const spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    const isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $jNU2T.default)(localRef, autoFocus);
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iqiKs.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $5wgou.default)([
            localRef,
            ref
        ]),
        xcss: (0, $fxmw9.cx)($b7355cece643f5f3$var$styles.base, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $b7355cece643f5f3$var$styles.baseT26Shape, appearance === 'default' && $b7355cece643f5f3$var$defaultStyles.root, appearance === 'default' && isInteractive && $b7355cece643f5f3$var$defaultStyles.interactive, appearance === 'primary' && $b7355cece643f5f3$var$primaryStyles.root, appearance === 'primary' && isInteractive && $b7355cece643f5f3$var$primaryStyles.interactive, appearance === 'rovo' && $b7355cece643f5f3$var$rovoStyles.root, appearance === 'rovo' && isInteractive && $b7355cece643f5f3$var$rovoStyles.interactive, appearance === 'warning' && $b7355cece643f5f3$var$warningStyles.root, appearance === 'warning' && isInteractive && $b7355cece643f5f3$var$warningStyles.interactive, appearance === 'danger' && $b7355cece643f5f3$var$dangerStyles.root, appearance === 'danger' && isInteractive && $b7355cece643f5f3$var$dangerStyles.interactive, appearance === 'discovery' && $b7355cece643f5f3$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $b7355cece643f5f3$var$discoveryStyles.interactive, appearance === 'subtle' && $b7355cece643f5f3$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $b7355cece643f5f3$var$subtleStyles.interactive, $b7355cece643f5f3$var$styles.linkDecorationUnset, isSelected && $b7355cece643f5f3$var$selectedStyles.root, isSelected && isSplitButton && $b7355cece643f5f3$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $b7355cece643f5f3$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $b7355cece643f5f3$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $b7355cece643f5f3$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $b7355cece643f5f3$var$selectedStyles.discovery, isDisabled && $b7355cece643f5f3$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $b7355cece643f5f3$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $b7355cece643f5f3$var$defaultStyles.disabled, spacing === 'compact' && $b7355cece643f5f3$var$styles.spacingCompact, spacing === 'compact' && (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $b7355cece643f5f3$var$styles.spacingCompactT26Shape, // This must come after spacing compact styling as it overrides the border radius
        isCircle && !isSplitButton && $b7355cece643f5f3$var$styles.circle, shouldFitContainer && $b7355cece643f5f3$var$styles.fullWidth, hasIconBefore && $b7355cece643f5f3$var$styles.buttonIconBefore, hasIconAfter && $b7355cece643f5f3$var$styles.buttonIconAfter, isIconButton && $b7355cece643f5f3$var$styles.iconButton, isIconButton && spacing === 'compact' && $b7355cece643f5f3$var$styles.iconButtonCompact, isLoading && $b7355cece643f5f3$var$styles.loading, isSplitButton && $b7355cece643f5f3$var$styles.splitButton, isNavigationSplitButton && $b7355cece643f5f3$var$styles.navigationSplitButton),
        isDisabled: (0, $3H4LK.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $3H4LK.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $3H4LK.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$b7355cece643f5f3$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $luCk9.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5BgTD.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        className: (0, $ltgDR.default)([
            $b7355cece643f5f3$var$styles.loadingOverlay
        ])
    }, (0, $b5a3w.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gFdUI.default), {
        id: loadingLabelId
    }, $b7355cece643f5f3$var$LOADING_LABEL)));
});
var $b7355cece643f5f3$export$2e2bcd8739ae039 = $b7355cece643f5f3$var$ButtonBase;

});
parcelRegister("iqiKs", function(module, exports) {
$parcel$export(module.exports, "default", () => $28e3002bb9ce7cdd$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.37.1 */ /* pressable.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9h99w = parcelRequire("9h99w");

var $4EOcq = parcelRequire("4EOcq");

var $11QcA = parcelRequire("11QcA");

var $c1tmZ = parcelRequire("c1tmZ");

var $9XaAY = parcelRequire("9XaAY");

var $gesza = parcelRequire("gesza");
const $28e3002bb9ce7cdd$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $28e3002bb9ce7cdd$var$Pressable = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $c1tmZ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $4fqPo.createElement((0, $gesza.default), {
        // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
        as: "button",
        // Safari does not apply focus to buttons on click like other browsers, which means click events will not be fired.
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $11QcA.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $9h99w.cx)($28e3002bb9ce7cdd$var$styles.root, isDisabled && $28e3002bb9ce7cdd$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }, children);
});
var $28e3002bb9ce7cdd$export$2e2bcd8739ae039 = $28e3002bb9ce7cdd$var$Pressable;

});
parcelRegister("11QcA", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $949410f9bfa635e9$export$95df08bae54cb4df);
function $949410f9bfa635e9$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use;
        const ua = (_window$navigator$use = window.navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}

});

parcelRegister("gesza", function(module, exports) {
$parcel$export(module.exports, "default", () => $2458e9c0aab5a1e4$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $2458e9c0aab5a1e4$var$focusRingStyles = null;
const $2458e9c0aab5a1e4$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $2458e9c0aab5a1e4$var$Focusable = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ $4fqPo.createElement(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $ltgDR.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu194a _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId
    }, children);
});
var $2458e9c0aab5a1e4$export$2e2bcd8739ae039 = $2458e9c0aab5a1e4$var$Focusable;

});


parcelRegister("5BgTD", function(module, exports) {
$parcel$export(module.exports, "SplitButtonContext", () => $38e7bc5b88273aa0$export$4b86304b2c0d7e71);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");
const $38e7bc5b88273aa0$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});

parcelRegister("kAiyH", function(module, exports) {
$parcel$export(module.exports, "useSplitButtonContext", () => $162a6320387c35ff$export$47e2c6fdb142d947);

var $4fqPo = parcelRequire("4fqPo");

var $5BgTD = parcelRequire("5BgTD");
const $162a6320387c35ff$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $4fqPo.useContext)((0, $5BgTD.SplitButtonContext));
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("luCk9", function(module, exports) {
$parcel$export(module.exports, "default", () => $258835d101e11e83$export$2e2bcd8739ae039);
function $258835d101e11e83$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $258835d101e11e83$var$tabKeyCode = 9;
function $258835d101e11e83$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $258835d101e11e83$var$tabKeyCode) return;
    $258835d101e11e83$var$abort(event);
}
function $258835d101e11e83$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $258835d101e11e83$var$abort,
        onMouseUpCapture: $258835d101e11e83$var$abort,
        onKeyDownCapture: $258835d101e11e83$var$onKey,
        onKeyUpCapture: $258835d101e11e83$var$onKey,
        onTouchStartCapture: $258835d101e11e83$var$abort,
        onTouchEndCapture: $258835d101e11e83$var$abort,
        onPointerDownCapture: $258835d101e11e83$var$abort,
        onPointerUpCapture: $258835d101e11e83$var$abort,
        onClickCapture: $258835d101e11e83$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $258835d101e11e83$var$abort
    } : events;
}

});

parcelRegister("b5a3w", function(module, exports) {
$parcel$export(module.exports, "default", () => $5257932ed6d45c70$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5qWT2 = parcelRequire("5qWT2");
function $5257932ed6d45c70$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $5257932ed6d45c70$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'rovo' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $5257932ed6d45c70$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        size: $5257932ed6d45c70$var$getIconSpacing(spacing),
        appearance: $5257932ed6d45c70$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});


parcelRegister("Az2gn", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d8dac52528b4a3c$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");
const $8d8dac52528b4a3c$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $8d8dac52528b4a3c$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        className: (0, $ltgDR.default)([
            $8d8dac52528b4a3c$var$styles.common,
            type === 'text' && $8d8dac52528b4a3c$var$styles.text,
            type === 'icon' && $8d8dac52528b4a3c$var$styles.icon,
            isLoading && $8d8dac52528b4a3c$var$styles.fade
        ])
    }, children);
};
var $8d8dac52528b4a3c$export$2e2bcd8739ae039 = $8d8dac52528b4a3c$var$Content;

});

parcelRegister("c6jSC", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c68fc439c905d7e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
function $8c68fc439c905d7e$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $8c68fc439c905d7e$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $8c68fc439c905d7e$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $3H4LK.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Icon, iconProps));
};
var $8c68fc439c905d7e$export$2e2bcd8739ae039 = $8c68fc439c905d7e$var$IconRenderer;

});


parcelRegister("aO0yS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ddf026ca15dd7d5$var$_react = $7ddf026ca15dd7d5$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $7ddf026ca15dd7d5$var$_baseNew = $7ddf026ca15dd7d5$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $7ddf026ca15dd7d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ddf026ca15dd7d5$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $7ddf026ca15dd7d5$var$_react.default.createElement($7ddf026ca15dd7d5$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$7ddf026ca15dd7d5$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $7ddf026ca15dd7d5$var$_default = module.exports.default = $7ddf026ca15dd7d5$var$ChevronUpIcon;

});

parcelRegister("9RW5e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6e34d167858ba514f74d5881b8440fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72f61e6e599ba7bc$var$_react = $72f61e6e599ba7bc$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $72f61e6e599ba7bc$var$_baseNew = $72f61e6e599ba7bc$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $72f61e6e599ba7bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72f61e6e599ba7bc$var$CrossIcon = (props)=>/*#__PURE__*/ $72f61e6e599ba7bc$var$_react.default.createElement($72f61e6e599ba7bc$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.53 3.53 9.06 8l4.47 4.47-1.06 1.06L8 9.06l-4.47 4.47-1.06-1.06L6.94 8 2.47 3.53l1.06-1.06L8 6.94l4.47-4.47z"/>`
    }, props));
$72f61e6e599ba7bc$var$CrossIcon.displayName = 'CrossIcon';
var $72f61e6e599ba7bc$var$_default = module.exports.default = $72f61e6e599ba7bc$var$CrossIcon;

});


parcelRegister("fil1W", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac8932329cbcf4b8$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $eO5yD = parcelRequire("eO5yD");
var $93stz = parcelRequire("93stz");

var $7fscZ = parcelRequire("7fscZ");
var $5E02Z = parcelRequire("5E02Z");
const $ac8932329cbcf4b8$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $ac8932329cbcf4b8$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $ac8932329cbcf4b8$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`
    }, /*#__PURE__*/ $4fqPo.createElement((0, $eO5yD.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $4fqPo.createElement((0, $93stz.default), null, (props)=>/*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
            xcss: $ac8932329cbcf4b8$var$styles.container,
            ...props
        }, /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), {
            space: "space.100"
        }, children)))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ac8932329cbcf4b8$export$2e2bcd8739ae039 = $ac8932329cbcf4b8$var$Expander;

});

parcelRegister("eYatF", function(module, exports) {
$parcel$export(module.exports, "useFlagGroup", () => $8c7f8d39bfb2c8b3$export$e91ea202abb66350);

var $4fqPo = parcelRequire("4fqPo");

var $04CtO = parcelRequire("04CtO");
function $8c7f8d39bfb2c8b3$export$e91ea202abb66350() {
    return (0, $4fqPo.useContext)((0, $04CtO.FlagGroupContext));
}

});
parcelRegister("04CtO", function(module, exports) {
$parcel$export(module.exports, "FlagGroupContext", () => $47967df06a434e2d$export$c57ba665aaa722be);

var $4fqPo = parcelRequire("4fqPo");

var $5iubj = parcelRequire("5iubj");
const $47967df06a434e2d$export$c57ba665aaa722be = /*#__PURE__*/ (0, $4fqPo.createContext)((0, $5iubj.defaultFlagGroupContext));

});
parcelRegister("5iubj", function(module, exports) {
$parcel$export(module.exports, "defaultFlagGroupContext", () => $9a78e5f239813aaf$export$643760c4938da30d);

var $c1tmZ = parcelRequire("c1tmZ");
const $9a78e5f239813aaf$export$643760c4938da30d = {
    onDismissed: (0, $c1tmZ.default),
    isDismissAllowed: false
};

});





parcelRegister("h1mlL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e00409fa844998e3$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.37.1 */ /* flag-group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $lMcEJ = parcelRequire("lMcEJ");

var $ew3Bn = parcelRequire("ew3Bn");

var $564zZ = parcelRequire("564zZ");

var $fxmw9 = parcelRequire("fxmw9");

var $c1tmZ = parcelRequire("c1tmZ");

var $eO5yD = parcelRequire("eO5yD");
var $6cMex = parcelRequire("6cMex");
var $gOmDd = parcelRequire("gOmDd");

var $3H4LK = parcelRequire("3H4LK");

var $7biT4 = parcelRequire("7biT4");

var $7fscZ = parcelRequire("7fscZ");

var $2vWb1 = parcelRequire("2vWb1");

var $1v8Ej = parcelRequire("1v8Ej");

var $gFdUI = parcelRequire("gFdUI");

var $5iubj = parcelRequire("5iubj");

var $04CtO = parcelRequire("04CtO");
const $e00409fa844998e3$export$1eee5ddc4f6d41c5 = 400;
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $e00409fa844998e3$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $e00409fa844998e3$var$groupStylesNew = {
    root: "_v564t8bh _kqswstnw _u7coidpf _1bsb1kdj _1eqkauwl",
    first: "_t9ec1ygq _1pbyqfx8",
    second: "_t9ec1pi4 _1pbyegat",
    nth: "_t9ec15wd",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $e00409fa844998e3$var$dismissAllowedStyles = null;
const $e00409fa844998e3$var$flagGroupContainerStyles = null;
// When rendering in top layer, z-index is redundant (top layer stacks above everything).
// Override to avoid leaving an explicit z-index on the container.
const $e00409fa844998e3$var$flagGroupContainerStylesTopLayer = null;
// cc_mohiti_flag_anchoring: update left inset from space.1000 (80px) to space.600 (48px)
// to match the bottom inset and produce a symmetric 48px × 48px anchor.
// The 80px left offset was a legacy artefact from the old left-rail nav sidebar.
// The mobile reset is mirrored from the base style so the override is self-contained
// and doesn't depend on @compiled's atomic CSS emit order at the ≤560px breakpoint.
const $e00409fa844998e3$var$flagGroupContainerStylesSymmetric = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $e00409fa844998e3$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $c1tmZ.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $4fqPo.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    // Keep a stable reference to the latest children, dismiss handler, and
    // analytics creator so the keydown listener never reads stale closures.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const latestRef = (0, $4fqPo.useRef)({
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    });
    latestRef.current = {
        children: children,
        onDismissed: onDismissed,
        createAnalyticsEvent: createAnalyticsEvent
    };
    // Accessibility (JRACLOUD-97876): allow keyboard-only and assistive
    // technology users to dismiss the topmost (and only dismissable) flag with
    // the Escape key, without having to tab through the entire page to reach
    // the dismiss button. Behaviour is gated behind a feature flag so it can
    // be rolled out and validated incrementally.
    (0, $4fqPo.useEffect)(()=>{
        if (!(0, $3H4LK.fg)('platform_dst_flag_keyboard_dismiss')) return;
        if (!hasFlags) return;
        const doc = (0, $564zZ.getDocument)();
        if (!doc) return;
        return (0, $lMcEJ.bind)(doc, {
            type: 'keydown',
            listener: (event)=>{
                var _props, _latestRef$current$on, _latestRef$current;
                if (event.key !== 'Escape' || event.defaultPrevented) return;
                const currentChildren = latestRef.current.children;
                const firstFlag = Array.isArray(currentChildren) ? currentChildren.find(Boolean) : currentChildren;
                if (!firstFlag || typeof firstFlag !== 'object') return;
                const id = (_props = firstFlag.props) === null || _props === void 0 ? void 0 : _props.id;
                if (id === undefined || id === null || id === '') return;
                const analyticsEvent = latestRef.current.createAnalyticsEvent({
                    action: 'dismissed',
                    actionSubject: 'flag',
                    attributes: {
                        dismissedVia: 'keyboardShortcut',
                        key: 'Escape'
                    }
                });
                event.preventDefault();
                (_latestRef$current$on = (_latestRef$current = latestRef.current).onDismissed) === null || _latestRef$current$on === void 0 || _latestRef$current$on.call(_latestRef$current, id, analyticsEvent);
            }
        });
    }, [
        hasFlags
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $4fqPo.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return (0, $3H4LK.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
                xcss: (0, $fxmw9.cx)($e00409fa844998e3$var$groupStylesNew.root, index === 0 && $e00409fa844998e3$var$groupStylesNew.first, index === 1 && $e00409fa844998e3$var$groupStylesNew.second, index >= 2 && $e00409fa844998e3$var$groupStylesNew.nth, index >= 3 && $e00409fa844998e3$var$groupStylesNew.hidden),
                "data-vc-oob": true
            }, /*#__PURE__*/ $4fqPo.createElement((0, $6cMex.default), {
                enteringAnimation: "var(--ds-flag-enter, 250ms cubic-bezier(0, 0.4, 0, 1) SlideIn50PercentLeft, 250ms cubic-bezier(0, 0.4, 0, 1) FadeIn0to100)",
                exitingAnimation: "var(--ds-flag-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOut15PercentLeft, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
            }, /*#__PURE__*/ $4fqPo.createElement((0, $04CtO.FlagGroupContext).Provider, {
                value: // Only the first flag should be able to be dismissed.
                isDismissAllowed ? dismissFlagContext : (0, $5iubj.defaultFlagGroupContext)
            }, flag))) : /*#__PURE__*/ $4fqPo.createElement((0, $gOmDd.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, ({ className: className, ref: ref })=>/*#__PURE__*/ $4fqPo.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $ltgDR.default)([
                        $e00409fa844998e3$var$groupStyles.root,
                        index === 0 && $e00409fa844998e3$var$groupStyles.first,
                        index === 1 && $e00409fa844998e3$var$groupStyles.second,
                        index >= 1 && $e00409fa844998e3$var$groupStyles.nth,
                        index >= 2 && $e00409fa844998e3$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref,
                    "data-vc-oob": true
                }, /*#__PURE__*/ $4fqPo.createElement((0, $04CtO.FlagGroupContext).Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : (0, $5iubj.defaultFlagGroupContext)
                }, flag)));
        }) : false;
    };
    const useTopLayer = (0, $3H4LK.fg)('platform-dst-top-layer');
    const useSymmetricAnchor = (0, $3H4LK.fg)('cc_mohiti_flag_anchoring');
    const isKeyboardDismissEnabled = (0, $3H4LK.fg)('platform_dst_flag_keyboard_dismiss');
    // When the keyboard dismiss shortcut is available, surface it to assistive
    // technology users via the existing visually-hidden landmark heading so they
    // know they can press Escape to dismiss the topmost flag.
    const screenReaderLabel = isKeyboardDismissEnabled ? `${label}. Press Escape to dismiss.` : label;
    const flags = /*#__PURE__*/ $4fqPo.createElement("div", {
        id: id,
        "data-vc-oob": true,
        className: (0, $ltgDR.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf",
            useTopLayer && "_1pby1wug",
            useSymmetricAnchor && "_1e02oahv _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $4fqPo.createElement((0, $gFdUI.default), null, /*#__PURE__*/ $4fqPo.createElement(LabelTag, null, screenReaderLabel)) : null, /*#__PURE__*/ $4fqPo.createElement((0, $eO5yD.default), {
        appear: false
    }, renderChildren()));
    if (useTopLayer) return /*#__PURE__*/ $4fqPo.createElement((0, $1v8Ej.Popover), {
        mode: "manual",
        isOpen: true
    }, flags);
    return shouldRenderToParent ? flags : /*#__PURE__*/ $4fqPo.createElement((0, $7biT4.default), {
        zIndex: (0, $2vWb1.layers).flag()
    }, flags);
};
var $e00409fa844998e3$export$2e2bcd8739ae039 = $e00409fa844998e3$var$FlagGroup;

});
parcelRegister("6cMex", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e6fffcb323afd60$export$2e2bcd8739ae039);
/* motion.tsx generated by @compiled/babel-plugin v0.37.1 */ /* motion.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $5wgou = parcelRequire("5wgou");

var $1GP9P = parcelRequire("1GP9P");

var $abZll = parcelRequire("abZll");

var $1dGol = parcelRequire("1dGol");

var $irVHf = parcelRequire("irVHf");

var $eO5yD = parcelRequire("eO5yD");

var $bUfH0 = parcelRequire("bUfH0");

var $ko2Wp = parcelRequire("ko2Wp");
const $3e6fffcb323afd60$var$styles = {
    base: "_1y0co91m _1bumglyw _sedtglyw",
    hidden: "_3um015vq",
    entering: "_1o51eoah",
    exiting: "_1o51q7pw"
};
/**
 * __Motion__
 *
 * A motion primitive that can be used to animate the entry and exit of components.
 */ const $3e6fffcb323afd60$var$Motion = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, enteringAnimation: enteringAnimation, enteringAnimationXcss: enteringAnimationXcss, exitingAnimation: exitingAnimation, exitingAnimationXcss: exitingAnimationXcss, onFinish: onFinishMotion, xcss: xcss, style: styleProp, testId: testId }, ref)=>{
    const staggered = (0, $ko2Wp.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $eO5yD.useExitingPersistence)();
    const staggeredDelay = isExiting ? 0 : staggered.delay;
    const staggedIsReady = staggered.isReady;
    const [state, setState] = (0, $4fqPo.useState)(appear ? staggedIsReady && !staggeredDelay ? 'entering' : 'init' : 'idle');
    const elementRef = (0, $4fqPo.useRef)(null);
    const reanimateRef = (0, $4fqPo.useRef)();
    const animationRef = (0, $4fqPo.useRef)();
    const staggeredEntryRef = (0, $4fqPo.useRef)();
    (0, $4fqPo.useEffect)(()=>{
        if (isExiting) setState('exiting');
    }, [
        isExiting
    ]);
    // Handles staggered entry
    (0, $4fqPo.useEffect)(()=>{
        if (state !== 'init') return;
        // We delay the entry animation by the stagger delay
        staggeredEntryRef.current = setTimeout(()=>{
            setState('entering');
        }, staggeredDelay);
        return ()=>{
            if (staggeredEntryRef.current) clearTimeout(staggeredEntryRef.current);
        };
    }, [
        state,
        staggedIsReady,
        staggeredDelay
    ]);
    /**
   * Updates relevant state.
   * Called when the animation is finished, or immediately with reduced motion.
   */ const onAnimationEnd = (0, $4fqPo.useCallback)((state, cancelled)=>{
        // We are done animating, so we set the state to idle
        let newState = 'idle';
        if (state === 'exiting') {
            if (!reanimateRef.current) // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('exiting');
        }
        if (state === 'entering') onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion('entering');
        if (reanimateRef.current === (0, $bUfH0.Reanimate).exit_then_enter) {
            // We are done exiting, so we set the state to entering
            reanimateRef.current = (0, $bUfH0.Reanimate).enter;
            newState = 'entering';
        } else if (reanimateRef.current) // We are done reanimating, so we clear the reanimate state
        reanimateRef.current = undefined;
        if (!cancelled) setState(newState);
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        onExitFinished
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (!staggedIsReady) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        // This only occurs on initial mount, as appear will be true once the component is mounted
        if (!appear) {
            onFinishMotion && onFinishMotion('entering');
            return;
        }
        // If the state is idle or init, we don't need to do anything
        if (state === 'idle' || state === 'init') return;
        // If there is reduced motion or no exit animation, we call the onAnimationEnd function immediately
        if ((0, $1dGol.isReducedMotion)() || !exitingAnimation && !exitingAnimationXcss) {
            onAnimationEnd(state, isCancelled);
            return;
        }
        let animationDuration = 0;
        let animationDelay = 0;
        if (state === 'entering' || state === 'exiting') {
            if (elementRef.current) {
                if (elementRef.current.style.animation) {
                    // Motion token
                    const animationTimings = (0, $abZll.getDurationMs)((0, $irVHf.resolveMotionToken)(elementRef.current.style.animation));
                    animationDuration = animationTimings.duration;
                    animationDelay = animationTimings.delay;
                } else {
                    // Custom motion
                    const styles = window.getComputedStyle(elementRef.current);
                    if (styles.animationDuration) animationDuration = (0, $1GP9P.convertToMs)(styles.animationDuration);
                    if (styles.animationDelay) animationDelay = (0, $1GP9P.convertToMs)(styles.animationDelay);
                }
            }
        }
        // Queue `onAnimationEnd` for after the animation has finished
        if (state === 'exiting' && (exitingAnimation || exitingAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        else if (state === 'entering' && (enteringAnimation || enteringAnimationXcss)) animationRef.current = setTimeout(()=>onAnimationEnd(state, isCancelled), animationDuration + animationDelay);
        return ()=>{
            isCancelled = true;
            if (animationRef.current) clearTimeout(animationRef.current);
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onAnimationEnd,
        state,
        exitingAnimation,
        enteringAnimation,
        exitingAnimationXcss,
        enteringAnimationXcss,
        staggeredDelay,
        staggedIsReady
    ]);
    (0, $4fqPo.useImperativeHandle)(ref, ()=>({
            reanimate: (value)=>{
                animationRef.current && clearTimeout(animationRef.current);
                reanimateRef.current = value;
                if (value === (0, $bUfH0.Reanimate).exit_then_enter) setState('exiting');
                else if (value === (0, $bUfH0.Reanimate).enter) setState('entering');
            }
        }));
    let style = {};
    let customAnimation;
    if (state === 'entering') {
        if (enteringAnimation) style.animation = `${enteringAnimation} backwards`;
        else if (enteringAnimationXcss) customAnimation = enteringAnimationXcss;
    } else if (state === 'exiting') {
        if (exitingAnimation) style.animation = `${exitingAnimation} forwards`;
        else if (exitingAnimationXcss) customAnimation = exitingAnimationXcss;
    }
    const hasAnimationStyles = state !== 'idle' && state !== 'init';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            hasAnimationStyles && $3e6fffcb323afd60$var$styles.base,
            state === 'init' && $3e6fffcb323afd60$var$styles.hidden,
            state === 'entering' && $3e6fffcb323afd60$var$styles.entering,
            state === 'exiting' && $3e6fffcb323afd60$var$styles.exiting,
            (0, $fxmw9.cx)(xcss, customAnimation)
        ]),
        ref: (0, $5wgou.default)([
            staggered.ref,
            elementRef
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: styleProp || hasAnimationStyles ? {
            ...styleProp,
            ...style
        } : undefined,
        "data-testid": testId
    }, children);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$3e6fffcb323afd60$export$2e2bcd8739ae039 = $3e6fffcb323afd60$var$Motion;

});
parcelRegister("1GP9P", function(module, exports) {
$parcel$export(module.exports, "convertToMs", () => $1b1adf160142036e$export$75eee42ff540d8ae);
const $1b1adf160142036e$export$75eee42ff540d8ae = (duration)=>{
    // Use regex to separate the number and the unit
    const matches = duration.match(/^(\d+\.?\d*)(s|ms)$/);
    if (!matches) return 0; // Or return for invalid format
    const value = parseFloat(matches[1]);
    const unit = matches[2];
    if (unit === 's') return value * 1000; // Convert seconds to milliseconds
    else return value; // Already in milliseconds
};

});

parcelRegister("abZll", function(module, exports) {
$parcel$export(module.exports, "getDurationMs", () => $dbcd4fbfae66c144$export$d0038b6e47881463);
/**
 * Gets the duration in milliseconds for an animation property.
 * @param animation - The animation property to get the duration for.
 * @returns The duration in milliseconds.
 */ const $dbcd4fbfae66c144$export$d0038b6e47881463 = (animation)=>{
    const match = [
        ...animation.trim().matchAll(/(-?\d*\.?\d+)(ms|s)\b/g)
    ];
    if (match.length === 0) return {
        duration: 0,
        delay: 0
    };
    const durationValue = parseFloat(match[0][1]);
    const durationUnit = match[0][2];
    const duration = durationUnit === 's' ? durationValue * 1000 : durationValue;
    let delay = 0;
    if (match[1]) {
        const delayValue = parseFloat(match[1][1]);
        const delayUnit = match[1][2];
        delay = delayUnit === 's' ? delayValue * 1000 : delayValue;
    }
    return {
        duration: duration,
        delay: delay
    };
};

});

parcelRegister("irVHf", function(module, exports) {
$parcel$export(module.exports, "resolveMotionToken", () => $c11972839fc36905$export$82b92541889a035d);

var $564zZ = parcelRequire("564zZ");
const $c11972839fc36905$export$82b92541889a035d = (token)=>{
    const cssVarMatch = token.match(/var\(\s*(--[^,\s)]+)/);
    const cssVar = cssVarMatch ? cssVarMatch[1] : null;
    if (cssVar) {
        var _getDocument;
        const documentElement = (_getDocument = (0, $564zZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.documentElement;
        if (documentElement) return getComputedStyle(documentElement).getPropertyValue(cssVar);
    }
    return '';
};

});

parcelRegister("bUfH0", function(module, exports) {
$parcel$export(module.exports, "Reanimate", () => $16f76ff1d0a538b5$export$569340a66b14e0dc);
/**
 * Supported reanimate values.
 * 'enter' will re-enter the animation.
 * 'exit-then-enter' will exit the animation and then enter it again.
 */ var $16f76ff1d0a538b5$export$569340a66b14e0dc = /*#__PURE__*/ function(Reanimate) {
    Reanimate["enter"] = "enter";
    Reanimate["exit_then_enter"] = "exit_then_enter";
    return Reanimate;
}({});

});


parcelRegister("gOmDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $13fc7bb98242ca54$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bUO1m = parcelRequire("bUO1m");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion).
 */ const $13fc7bb98242ca54$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bUO1m.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $13fc7bb98242ca54$export$2e2bcd8739ae039 = $13fc7bb98242ca54$var$SlideIn;

});


parcelRegister("hMwsV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf201a54e1eb5c3c$var$_react = $cf201a54e1eb5c3c$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $cf201a54e1eb5c3c$var$_baseNew = $cf201a54e1eb5c3c$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $cf201a54e1eb5c3c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf201a54e1eb5c3c$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cf201a54e1eb5c3c$var$_react.default.createElement($cf201a54e1eb5c3c$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cf201a54e1eb5c3c$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cf201a54e1eb5c3c$var$_default = module.exports.default = $cf201a54e1eb5c3c$var$CrossCircleIcon;

});





parcelRegister("cgfAU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3432dfa07f546f5$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $b3432dfa07f546f5$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    genericErrorTitle: {
        id: 'cv.generic.error.title',
        defaultMessage: 'Error',
        description: 'Title of the error panel shown when a generic error has occurred.'
    },
    genericErrorDescription: {
        id: 'cv.generic.error.description',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred.'
    },
    genericSignUpErrorDescriptionUnified: {
        id: 'cv.generic.sign.up.error.description.unified',
        defaultMessage: "We couldn't submit your request. Refresh the page and try again. If you continue to experience issues, {contactAdminLinkUnified}.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    genericSignUpErrorNoContactLinkDescription: {
        id: 'cv.generic.sign.up.error.no.contact.link.description.unified',
        defaultMessage: "We couldn\u2019t submit your request. Refresh the page and try again.",
        description: 'Message body of the error panel shown when a generic error has occurred when a customer is signing up.'
    },
    refreshPageLinkText: {
        id: 'cv.generic.refresh.page.link.text',
        defaultMessage: 'refresh',
        description: 'The text is shown as a hyperlink label that triggers a page refresh, displayed within an error flag or error panel when a generic error has occurred.'
    },
    tellUsAboutIssueLinkText: {
        id: 'cv.generic.tell.about.issue.link.text',
        defaultMessage: 'tell us about this issue',
        description: 'Text shown for the tell us about this issue link, used to report errors.'
    },
    letUsKnowLinkText: {
        id: 'cv.generic.let.us.know.link.text',
        defaultMessage: 'let us know',
        description: 'Text shown for the let us know link, used to report errors.'
    },
    genericErrorRefreshPageAction: {
        id: 'cv.generic.error.refresh.page.action',
        defaultMessage: 'Refresh page',
        description: 'Label of the refresh page button on the error panel shown when a generic error has occurred.'
    },
    noNetworkTitle: {
        id: 'cv.no.network.title',
        defaultMessage: 'Check your connection',
        description: 'Title of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    noNetworkDescription: {
        id: 'cv.no.network.description.unified',
        defaultMessage: "It looks like you've lost your internet connection. Check your network and try again later.",
        description: 'Message body of the error panel shown when a network connection problem prevents an action from being performed.'
    },
    signupEmailResendRateLimitedDescription: {
        defaultMessage: "There\u2019s an issue with sending the email at the moment. Try again later in 10 minutes",
        description: 'Message to notify the user that the sign up email has been rate limited',
        id: 'cv.sign.up.email.resend.rate.limited.description'
    },
    blockedTitle: {
        id: 'cv.signup.blocked.title',
        defaultMessage: 'Access Blocked',
        description: 'Title of the error panel shown when a blocked action occurs.'
    },
    blockedDescription: {
        id: 'cv.signup.blocked.description',
        defaultMessage: "The email isn't approved for access. Use another email and try again.",
        description: 'Message body of the error panel  shown when a blocked action occurs.'
    },
    invalidEmailTitle: {
        id: 'cv.signup.email.invalid.title',
        defaultMessage: 'Invalid Email',
        description: 'Title of the error panel shown when a invalid email is entered.'
    },
    invalidEmailDescription: {
        id: 'cv.signup.email.invalid.description',
        defaultMessage: 'You must specify a valid email address.',
        description: 'Message body of the error panel shown when a invalid email is entered.'
    },
    userProfileForgotPasswordFailedFlagTitle: {
        id: 'cv.user.profile.forgot.password.failed.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordFailedFlagDescription: {
        id: 'cv.user.profile.forgot.password.failed.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagTitle: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.title',
        defaultMessage: "We're unable to send a link",
        description: 'Title for the error flag shown when system fails to send email after user clicks on forgot password link'
    },
    userProfileForgotPasswordRateLimitedFlagDescription: {
        id: 'cv.user.profile.forgot.password.rate_limited.flag.description',
        defaultMessage: 'Something went wrong while trying to send you a reset password link. Try again in a few minutes.',
        description: 'Description for the error flag shown when system fails to send email after user clicks on forgot password link'
    }
});

});




parcelRegister("4LAfg", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticleEpic", () => $10d809bb6470a5b6$export$d67800395c791e52);

var $b0T1M = parcelRequire("b0T1M");

var $7OQtz = parcelRequire("7OQtz");
parcelRequire("35SbM");
var $dzJzK = parcelRequire("dzJzK");

var $1VNDe = parcelRequire("1VNDe");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");
const $10d809bb6470a5b6$export$3361e9be8093ddcc = (response, articleId)=>{
    const parseAri = (0, $1VNDe.ConfluenceSpaceAri).parse(response.space.id);
    return {
        id: parseInt(articleId, 10),
        title: response.title,
        url: '',
        projects: response.projects.map((project)=>({
                projectId: parseInt(project.projectId, 10),
                portalId: parseInt(project.portalId, 10),
                projectAri: project.projectAri
            })),
        space: {
            key: response.space.key,
            id: parseInt(parseAri.spaceId, 10)
        },
        idInString: articleId,
        hostname: response.hostname
    };
};
const $10d809bb6470a5b6$export$d67800395c791e52 = (action$)=>action$.ofType((0, $dzJzK.FETCH_CROSS_SITE_ARTICLE)).mergeMap((action)=>{
        const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = action.payload;
        return (0, $7OQtz.fetchCrossSiteArticles)({
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId || ''
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            const articleResponse = $10d809bb6470a5b6$export$3361e9be8093ddcc(response, articleId);
            return (0, $dzJzK.fetchArticleSuccess)(articleResponse);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $dzJzK.fetchArticleFailure)(articleId, error));
        });
    });

});
parcelRegister("7OQtz", function(module, exports) {
$parcel$export(module.exports, "fetchCrossSiteArticles", () => $be70feea08ec1a37$export$5cbd1a869c9b635a);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $6mmHn = parcelRequire("6mmHn");

var $4i2V5 = parcelRequire("4i2V5");

var $djHPz = parcelRequire("djHPz");
var $gnwNl = parcelRequire("gnwNl");

var $keOG0 = parcelRequire("keOG0");

var $4axJ1 = parcelRequire("4axJ1");
const $be70feea08ec1a37$export$5cbd1a869c9b635a = ({ articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId })=>{
    const cloudId = (0, $6mmHn.getMeta)('tenant-id') || '';
    const activationId = (0, $6mmHn.getMeta)('activation-id');
    const pageAri = (0, $djHPz.ConfluencePageAri).create({
        siteId: crossSiteTenantId,
        pageId: articleId
    }).toString();
    const projectAri = projectId && (0, $gnwNl.JiraProjectAri).create({
        projectId: projectId.toString(),
        siteId: cloudId
    }).toString();
    const queryStringV2 = $4i2V5.stringify({
        projectAri: projectAri,
        articleAri: pageAri
    });
    const uri = `${(0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/article-metadata?${queryStringV2}`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        (0, $keOG0.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $b0T1M.Observable).throw(e);
    });
};

});
parcelRegister("djHPz", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAri", () => $9b1f0c935dde3541$export$3f931dd15d96caff);

var $gi5jG = parcelRequire("gi5jG");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/confluence/page/manifest.ts
var $9b1f0c935dde3541$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $gi5jG.ConfluencePageAriResourceOwner),
    resourceType: (0, $gi5jG.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $9b1f0c935dde3541$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9b1f0c935dde3541$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $9b1f0c935dde3541$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9b1f0c935dde3541$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $9b1f0c935dde3541$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $9b1f0c935dde3541$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $9b1f0c935dde3541$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("gi5jG", function(module, exports) {
$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $bdc27380b46b8348$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $bdc27380b46b8348$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $bdc27380b46b8348$export$da53e4f7db4c6a71 = "confluence", $bdc27380b46b8348$export$636fc622562a2c5b = "page";

});


parcelRegister("gnwNl", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAri", () => $bec83bb7214d068b$export$75a0a0a7cb0a58ae);

var $7yQbi = parcelRequire("7yQbi");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/jira/project/manifest.ts
var $bec83bb7214d068b$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7yQbi.JiraProjectAriResourceOwner),
    resourceType: (0, $7yQbi.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $bec83bb7214d068b$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bec83bb7214d068b$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $bec83bb7214d068b$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bec83bb7214d068b$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $bec83bb7214d068b$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $bec83bb7214d068b$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $bec83bb7214d068b$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("7yQbi", function(module, exports) {
$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $58142f7c684446a6$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $58142f7c684446a6$export$736763838d3aa22e);
// src/jira/project/types.ts
var $58142f7c684446a6$export$99d538a3b04916b1 = "jira", $58142f7c684446a6$export$736763838d3aa22e = "project";

});


parcelRegister("4axJ1", function(module, exports) {
$parcel$export(module.exports, "APOLLO_STARGATE_CONTEXT_ROOT", () => $6a5ee34f01e59a2a$export$f224912d4ec4705e);
const $6a5ee34f01e59a2a$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

});


parcelRegister("35SbM", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => (parcelRequire("dzJzK")).FETCH_ARTICLE);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => (parcelRequire("dzJzK")).FETCH_ARTICLE_FAILURE);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY", () => (parcelRequire("dzJzK")).FETCH_ARTICLE_SPACE_KEY);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_FAILURE", () => (parcelRequire("dzJzK")).FETCH_ARTICLE_SPACE_KEY_FAILURE);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_SUCCESS", () => (parcelRequire("dzJzK")).FETCH_ARTICLE_SPACE_KEY_SUCCESS);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => (parcelRequire("dzJzK")).FETCH_ARTICLE_SUCCESS);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => (parcelRequire("dzJzK")).FETCH_CROSS_SITE_ARTICLE);
$parcel$export(module.exports, "fetchArticle", () => (parcelRequire("dzJzK")).fetchArticle);
$parcel$export(module.exports, "fetchArticleFailure", () => (parcelRequire("dzJzK")).fetchArticleFailure);
$parcel$export(module.exports, "fetchArticleSpaceKey", () => (parcelRequire("dzJzK")).fetchArticleSpaceKey);
$parcel$export(module.exports, "fetchArticleSpaceKeyFailure", () => (parcelRequire("dzJzK")).fetchArticleSpaceKeyFailure);
$parcel$export(module.exports, "fetchArticleSpaceKeySuccess", () => (parcelRequire("dzJzK")).fetchArticleSpaceKeySuccess);
$parcel$export(module.exports, "fetchArticleSuccess", () => (parcelRequire("dzJzK")).fetchArticleSuccess);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => (parcelRequire("dzJzK")).fetchCrossSiteArticle);
parcelRequire("dzJzK");

});
parcelRegister("dzJzK", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLE", () => $ba821730419d573b$export$a55f0530be417648);
$parcel$export(module.exports, "FETCH_ARTICLE_SUCCESS", () => $ba821730419d573b$export$2d213dcac7fc3339);
$parcel$export(module.exports, "FETCH_ARTICLE_FAILURE", () => $ba821730419d573b$export$862d1fc538bf047c);
$parcel$export(module.exports, "FETCH_CROSS_SITE_ARTICLE", () => $ba821730419d573b$export$ffd65713f8cf7ee0);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY", () => $ba821730419d573b$export$5ad5cd897e4bf515);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_SUCCESS", () => $ba821730419d573b$export$3b80ee6a6cfa1792);
$parcel$export(module.exports, "FETCH_ARTICLE_SPACE_KEY_FAILURE", () => $ba821730419d573b$export$4ce7256daebadb2e);
$parcel$export(module.exports, "fetchArticle", () => $ba821730419d573b$export$b455945318d7989e);
$parcel$export(module.exports, "fetchCrossSiteArticle", () => $ba821730419d573b$export$9b8d6025673edc75);
$parcel$export(module.exports, "fetchArticleSuccess", () => $ba821730419d573b$export$6910c63a4b3017af);
$parcel$export(module.exports, "fetchArticleFailure", () => $ba821730419d573b$export$b135c19fc249d3ab);
$parcel$export(module.exports, "fetchArticleSpaceKey", () => $ba821730419d573b$export$1bb14e9adb3b68ac);
$parcel$export(module.exports, "fetchArticleSpaceKeySuccess", () => $ba821730419d573b$export$e5aa07ff7178b780);
$parcel$export(module.exports, "fetchArticleSpaceKeyFailure", () => $ba821730419d573b$export$5fc693c79f10bc4f);

var $dNzn5 = parcelRequire("dNzn5");
const $ba821730419d573b$export$a55f0530be417648 = 'epic.model.FETCH_ARTICLE';
const $ba821730419d573b$export$2d213dcac7fc3339 = 'state.persisted.article.FETCH_ARTICLE_SUCCESS';
const $ba821730419d573b$export$862d1fc538bf047c = 'state.persisted.article.FETCH_ARTICLE_FAILURE';
const $ba821730419d573b$export$ffd65713f8cf7ee0 = 'epic.model.FETCH_CROSS_SITE_ARTICLE';
const $ba821730419d573b$export$5ad5cd897e4bf515 = 'epic.model.FETCH_ARTICLE_SPACE_KEY';
const $ba821730419d573b$export$3b80ee6a6cfa1792 = 'state.persisted.article.FETCH_ARTICLE_SPACE_KEY_SUCCESS';
const $ba821730419d573b$export$4ce7256daebadb2e = 'state.persisted.article.FETCH_ARTICLE_SPACE_KEY_FAILURE';
const $ba821730419d573b$export$b455945318d7989e = (payload, meta)=>({
        meta: meta,
        ...(0, $dNzn5.buildModelsActionCreator)($ba821730419d573b$export$a55f0530be417648, 'kbPage')(payload)
    });
const $ba821730419d573b$export$9b8d6025673edc75 = (params)=>{
    const { meta: meta, articleId: articleId, projectId: projectId, crossSiteTenantId: crossSiteTenantId } = params;
    return {
        type: $ba821730419d573b$export$ffd65713f8cf7ee0,
        payload: {
            articleId: articleId,
            projectId: projectId,
            crossSiteTenantId: crossSiteTenantId,
            meta: meta
        }
    };
};
const $ba821730419d573b$export$6910c63a4b3017af = (article)=>({
        type: $ba821730419d573b$export$2d213dcac7fc3339,
        payload: article
    });
const $ba821730419d573b$export$b135c19fc249d3ab = (id, error)=>({
        type: $ba821730419d573b$export$862d1fc538bf047c,
        payload: {
            id: id,
            error: error
        }
    });
const $ba821730419d573b$export$1bb14e9adb3b68ac = (articleId, meta)=>({
        meta: meta,
        type: $ba821730419d573b$export$5ad5cd897e4bf515,
        payload: {
            articleId: articleId
        }
    });
const $ba821730419d573b$export$e5aa07ff7178b780 = (article)=>({
        type: $ba821730419d573b$export$3b80ee6a6cfa1792,
        payload: article
    });
const $ba821730419d573b$export$5fc693c79f10bc4f = (id, error)=>({
        type: $ba821730419d573b$export$4ce7256daebadb2e,
        payload: {
            id: id,
            error: error
        }
    });

});


parcelRegister("1VNDe", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAri", () => $16819d2abb3340fb$export$4e1bd9257e1b7213);

var $jPDpv = parcelRequire("jPDpv");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/confluence/space/manifest.ts
var $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jPDpv.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $jPDpv.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $16819d2abb3340fb$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $16819d2abb3340fb$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
};

});
parcelRegister("jPDpv", function(module, exports) {
$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $e70159d2bcf039e8$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $e70159d2bcf039e8$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $e70159d2bcf039e8$export$204c4c730af505ce = "confluence", $e70159d2bcf039e8$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("eo5zF", function(module, exports) {
$parcel$export(module.exports, "isNetworkErrorCode", () => $49d842b3213bf2c7$export$1a5a4674dd906e7e);
$parcel$export(module.exports, "isClientErrorCode", () => $49d842b3213bf2c7$export$d31fd506ce75fa65);
$parcel$export(module.exports, "isNetworkOrClientErrorCode", () => $49d842b3213bf2c7$export$53ee51427129200c);
const $49d842b3213bf2c7$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
const $49d842b3213bf2c7$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
const $49d842b3213bf2c7$export$53ee51427129200c = (statusCode)=>$49d842b3213bf2c7$export$1a5a4674dd906e7e(statusCode) || $49d842b3213bf2c7$export$d31fd506ce75fa65(statusCode);

});


parcelRegister("lhKfW", function(module, exports) {
$parcel$export(module.exports, "default", () => $17d0a2a9e6f69c8a$export$2e2bcd8739ae039);
parcelRequire("lbln8");
var $4akjj = parcelRequire("4akjj");

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("jYob8");
var $cGPrY = parcelRequire("cGPrY");

var $5eCdR = parcelRequire("5eCdR");
const $17d0a2a9e6f69c8a$export$21d16fd7fed1f163 = (action$)=>{
    return action$.filter((action)=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        action.type.startsWith('epic.model') && action.type !== (0, $5eCdR.FETCH_HELP_CENTER_BRANDING_MODEL)).switchMap(()=>(0, $elY4q.default)({
            type: 'xsrfToken',
            params: {}
        }))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    .filter((response)=>!!response && (!!response.xsrfToken || !!response.env.xsrfToken))// jsd-customer-portal-models-without-backbone
    // When cleaning up remove all instances of "env" here. Just use xsrfToken directly.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    .map((response)=>(0, $cGPrY.updateXsrfAction)(response.xsrfToken || response.env.xsrfToken)).catch((_)=>(0, $b0T1M.Observable).never());
};
var $17d0a2a9e6f69c8a$export$2e2bcd8739ae039 = (0, $4akjj.combineEpics)($17d0a2a9e6f69c8a$export$21d16fd7fed1f163);

});
parcelRegister("elY4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $803c63a72b6c243b$export$2e2bcd8739ae039);

var $2LqDa = parcelRequire("2LqDa");
function $803c63a72b6c243b$export$2e2bcd8739ae039(request, options) {
    return (0, $2LqDa.fetchModel)(request, options);
}

});
parcelRegister("2LqDa", function(module, exports) {
$parcel$export(module.exports, "fetchModel", () => $644724db897f8121$export$6146dff2e008af3d);

var $b0T1M = parcelRequire("b0T1M");

var $6mmHn = parcelRequire("6mmHn");

var $63sfu = parcelRequire("63sfu");

var $e1EO7 = parcelRequire("e1EO7");

var $6UDG7 = parcelRequire("6UDG7");

var $6bGmX = parcelRequire("6bGmX");

var $kXlzl = parcelRequire("kXlzl");

var $85R51 = parcelRequire("85R51");

var $3wR8f = parcelRequire("3wR8f");
const $644724db897f8121$var$createBatchOperationalPayload = (modelType, batchingType)=>{
    return {
        action: batchingType,
        actionSubject: 'model-batched',
        source: 'unknownSource',
        attributes: {
            modelType: modelType
        }
    };
};
const $644724db897f8121$var$mergeOrReplaceOptions = (obj1, obj2, modelType)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,  @typescript-eslint/no-explicit-any
    if (!obj1 || obj1.id !== obj2.id) {
        (0, $kXlzl.operationalEvent)($644724db897f8121$var$createBatchOperationalPayload(modelType, 'model-replaced'));
        return obj2;
    }
    return (0, $63sfu.mergeWith)(obj1, obj2, (value, srcValue, key)=>{
        if (key === 'expand' && value) {
            (0, $kXlzl.operationalEvent)($644724db897f8121$var$createBatchOperationalPayload(modelType, 'model-merged'));
            // We merge expand arrays if it is from the same type and they have the same id.
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            return (0, $63sfu.uniq)(srcValue.concat(value));
        }
        return undefined;
    });
};
function $644724db897f8121$var$fetchModels(requests) {
    const requestTypes = (0, $63sfu.uniq)(requests.map((request)=>request.type));
    // This will build up the request params. If the request type is the same and the id is different it will
    // replace the type params, else it will merge them together.
    // If it finds two expand arrays to merge together it will concat them together and ensure only unique values.
    const requestOptions = requests.reduce((obj, request)=>Object.keys(request.params || {}).length ? {
            ...obj,
            [request.type]: $644724db897f8121$var$mergeOrReplaceOptions(obj[request.type], request.params, request.type)
        } : obj, {});
    const modelContext = {
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
        clientBasePath: (0, $3wR8f.getBasePath)()
    };
    return (0, $e1EO7.requestModels)(requestTypes, requestOptions, modelContext).toPromise();
}
/**
 * A TS limitation results in this losing its arg type.
 * See: https://github.com/Microsoft/TypeScript/issues/29638
 *
 * As a work around we create another wrapping function and re-type it.
 */ const $644724db897f8121$var$secondaryBatchedFetchModels = (0, $85R51.default)($644724db897f8121$var$fetchModels, 0);
const $644724db897f8121$var$primaryBatchedFetchModels = (0, $85R51.default)($644724db897f8121$var$fetchModels, 0);
function $644724db897f8121$export$6146dff2e008af3d(request, { type: type, disableBatching: disableBatching } = {
    type: 'primary',
    disableBatching: false
}) {
    const modelContext = {
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
        clientBasePath: (0, $3wR8f.getBasePath)()
    };
    if ((0, $6UDG7.ModelsCache).getInstance().shouldCache(request.type)) {
        const cachedData = (0, $6UDG7.ModelsCache).getInstance().getFromCache(request);
        if (cachedData !== undefined) return (0, $b0T1M.Observable).from(Promise.resolve(cachedData.response));
    }
    if (disableBatching) {
        const options = {
            [request.type]: request.params
        };
        return (0, $e1EO7.requestModels)([
            request.type
        ], options, modelContext);
    }
    const promise = type === 'secondary' ? $644724db897f8121$var$secondaryBatchedFetchModels(request).then((successResult)=>$644724db897f8121$export$8d0b7c1ef062bcaa(request, successResult)) : $644724db897f8121$var$primaryBatchedFetchModels(request).then((successResult)=>$644724db897f8121$export$8d0b7c1ef062bcaa(request, successResult));
    return (0, $b0T1M.Observable).from(promise);
}
function $644724db897f8121$export$8d0b7c1ef062bcaa(request, modelsResponse) {
    const requestType = request.type;
    if ((0, $6UDG7.ModelsCache).getInstance().shouldCache(requestType)) {
        if ((0, $6bGmX.default).checkGate('model_cache_save_full_response')) (0, $6UDG7.ModelsCache).getInstance().putToCache(request, modelsResponse);
        else (0, $6UDG7.ModelsCache).getInstance().putToCache(request, {
            [requestType]: modelsResponse[requestType]
        });
    }
    return modelsResponse;
}

});
parcelRegister("e1EO7", function(module, exports) {
$parcel$export(module.exports, "requestModels", () => $3dc31f296817c6dc$export$be054e1f3ca89815);

var $lVFX8 = parcelRequire("lVFX8");

var $1CB66 = parcelRequire("1CB66");

var $hGOIV = parcelRequire("hGOIV");

var $b0T1M = parcelRequire("b0T1M");

var $bG6ob = parcelRequire("bG6ob");

var $63sfu = parcelRequire("63sfu");

var $8ie7e = parcelRequire("8ie7e");

var $kXlzl = parcelRequire("kXlzl");

var $3wR8f = parcelRequire("3wR8f");
const $3dc31f296817c6dc$var$retryableStatusCodes = [
    429,
    500,
    502,
    503
];
const $3dc31f296817c6dc$var$isRetryableStatusCode = (status)=>$3dc31f296817c6dc$var$retryableStatusCodes.includes(status);
const $3dc31f296817c6dc$var$MAX_RETRY_DELAY_MS = 30000;
const $3dc31f296817c6dc$var$BASE_DELAY_MS = 10000;
const $3dc31f296817c6dc$var$maxExpBackoffWithJitter = (retries, baseDelay, maxDelay)=>{
    const exponential = Math.pow(2, retries) * baseDelay;
    return Math.min(exponential, maxDelay) + Math.floor(Math.random() * 1000);
};
const $3dc31f296817c6dc$var$NUMBER_OF_RETRIES = 2;
const $3dc31f296817c6dc$var$createOperationalEvent = (models, numberOfRetries, success, status)=>{
    return {
        action: 'fetch',
        actionSubject: 'models',
        source: 'unknownSource',
        attributes: {
            models: models,
            numberOfRetries: numberOfRetries,
            success: success,
            status: status
        }
    };
};
const $3dc31f296817c6dc$var$optionsNotAvailableInRestEndpoint = [
    'availableLanguages',
    'forgotPassword',
    'organisations',
    'portalsAndRequestTypes',
    'profileWebFragments',
    'sharedPortal',
    'timezones',
    'timezoneRegions',
    'xsrfToken',
    'portalsAndStatuses'
];
const $3dc31f296817c6dc$var$setTimezoneMetaTag = (timezone)=>{
    const windowDocument = (0, $1CB66.default).getDataRef();
    if (!timezone || !windowDocument) return;
    let metaTimezone = (0, $1CB66.default).querySelector('meta[name="user-timezone"]');
    if (metaTimezone) metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
    else {
        metaTimezone = windowDocument.createElement('meta');
        metaTimezone.setAttribute('name', 'user-timezone');
        metaTimezone.setAttribute('content', timezone === null || timezone === void 0 ? void 0 : timezone.id);
        windowDocument.head.appendChild(metaTimezone);
    }
};
const $3dc31f296817c6dc$var$addExtraImplicitDataRequirements = (types, options)=>{
    var _requestOptions$porta;
    const requestTypes = types.concat([]);
    // We want to clone child objects as well so we don't accidentally mutate them.
    // Not having it previously caused downstream actions to no longer have params after we deleted some propeties.
    const requestOptions = (0, $63sfu.cloneDeep)(options);
    if (requestTypes.includes('portal') && !requestTypes.includes('branding') && requestOptions.portal) {
        requestTypes.push('branding');
        requestOptions.branding = {
            id: requestOptions.portal.id
        };
    }
    // Implicitly add 'kbs' in portals requestOptions if fetchPortal is requested. // ref src/view/help-center/help-center-content/single-portal/index.tsx:15, projectId & isKbEnabled is considered to be present together
    if (requestTypes.includes('portal') && !((_requestOptions$porta = requestOptions.portal) !== null && _requestOptions$porta !== void 0 && (_requestOptions$porta = _requestOptions$porta.expand) !== null && _requestOptions$porta !== void 0 && _requestOptions$porta.includes('kbs'))) {
        var _requestOptions$porta2;
        (_requestOptions$porta2 = requestOptions.portal) === null || _requestOptions$porta2 === void 0 || (_requestOptions$porta2 = _requestOptions$porta2.expand) === null || _requestOptions$porta2 === void 0 || _requestOptions$porta2.push('kbs');
    }
    // Implicitly fetch portal if portalWebFragments defined portalId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.portalId && !requestTypes.includes('portal')) {
        if ((0, $bG6ob.isRemoveRedundantModelsCreateRequest)() && requestOptions.portalWebFragments.portalPage === (0, $hGOIV.REQUEST_CREATE)) requestOptions.portal = {
            id: requestOptions.portalWebFragments.portalId
        };
        else {
            requestTypes.push('portal');
            requestOptions.portal = {
                id: requestOptions.portalWebFragments.portalId
            };
        }
    }
    // Implicitly fetch request create if portalWebFragments defined portalId and requestTypeId.
    if (requestTypes.includes('portalWebFragments') && requestOptions.portalWebFragments && requestOptions.portalWebFragments.requestTypeId && requestOptions.portalWebFragments.portalPage === (0, $hGOIV.REQUEST_CREATE) && !requestTypes.includes('reqCreate')) {
        if ((0, $bG6ob.isRemoveRedundantModelsCreateRequest)()) requestOptions.reqCreate = {
            portalId: requestOptions.portalWebFragments.portalId,
            id: requestOptions.portalWebFragments.requestTypeId
        };
        else {
            requestTypes.push('reqCreate');
            requestOptions.reqCreate = {
                portalId: requestOptions.portalWebFragments.portalId,
                id: requestOptions.portalWebFragments.requestTypeId
            };
        }
    }
    if (requestTypes.includes('portal') && requestOptions.portal) requestOptions.portalId = requestOptions.portal.id;
    return {
        requestTypes: requestTypes,
        requestOptions: requestOptions
    };
};
const $3dc31f296817c6dc$var$adjustRequestOptions = (options)=>{
    const requestOptions = {
        ...options
    };
    for(const key in requestOptions){
        if (requestOptions.hasOwnProperty(key)) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        {
            if (requestOptions[key].portalId) // The backend needs this as a blanket rule.
            // If we run into any we add it onto the request options object.
            // Last one wins.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            requestOptions.portalId = requestOptions[key].portalId;
        }
    }
    for(const key in requestOptions)if ($3dc31f296817c6dc$var$optionsNotAvailableInRestEndpoint.includes(key)) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    delete requestOptions[key];
    return requestOptions;
};
const $3dc31f296817c6dc$var$getTraceId = (err)=>{
    let traceId = '';
    try {
        const { xhr: xhr } = err;
        traceId = xhr.getResponseHeader('Atl-Traceid') || '';
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get traceId from error', e);
    }
    return traceId;
};
const $3dc31f296817c6dc$var$getAllResponseHeaders = (err)=>{
    let headers = '';
    try {
        const { xhr: xhr } = err;
        headers = xhr.getAllResponseHeaders();
    } catch (e) {
        // oxlint-disable-next-line no-console
        console.warn('Failed to get headers from error', e);
    }
    return headers;
};
const $3dc31f296817c6dc$export$a06581639cf24e1e = (modelsDescriptor, options, modelContext, context = (0, $3wR8f.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $3dc31f296817c6dc$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $3dc31f296817c6dc$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((response)=>response.response).catch((err)=>{
        const traceId = $3dc31f296817c6dc$var$getTraceId(err);
        const responseHeaders = $3dc31f296817c6dc$var$getAllResponseHeaders(err);
        return (0, $b0T1M.Observable).throw(err.response ? {
            traceId: traceId,
            responseHeaders: responseHeaders,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            status: err.response.status,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorMessages: err.response.errorMessages,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionUrl: err.response.nextActionUrl,
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            nextActionDisplayText: err.response.nextActionDisplayText
        } : {
            traceId: traceId,
            responseHeaders: responseHeaders,
            status: err.status,
            errorMessages: []
        });
    });
};
const $3dc31f296817c6dc$var$requestModelsWithRetries = (modelsDescriptor, options, modelContext, context = (0, $3wR8f.contextPath))=>{
    const { requestOptions: requestOptions, requestTypes: requestTypes } = $3dc31f296817c6dc$var$addExtraImplicitDataRequirements(modelsDescriptor, options);
    let retries = 0;
    return (0, $lVFX8.post)(`${context}/rest/servicedesk/1/customer/models`, {
        options: $3dc31f296817c6dc$var$adjustRequestOptions(requestOptions),
        models: requestTypes,
        context: modelContext
    }, {
        'Content-Type': 'application/json'
    }).pipe((0, $8ie7e.retryWhen)((errors)=>errors.mergeMap((errorValue)=>{
            retries += 1;
            const status = errorValue.status;
            if (!$3dc31f296817c6dc$var$isRetryableStatusCode(status) || retries > $3dc31f296817c6dc$var$NUMBER_OF_RETRIES) return (0, $b0T1M.Observable).throw(errorValue);
            return (0, $b0T1M.Observable).of(errorValue).delay($3dc31f296817c6dc$var$maxExpBackoffWithJitter(retries, $3dc31f296817c6dc$var$BASE_DELAY_MS, $3dc31f296817c6dc$var$MAX_RETRY_DELAY_MS));
        })), (0, $8ie7e.map)((response)=>{
        if (retries > 0) //only send event if there were retries to avoid sending too many events
        (0, $kXlzl.operationalEvent)($3dc31f296817c6dc$var$createOperationalEvent(requestTypes, retries, true, undefined));
        //Update timezone meta tag when model response has user properties
        if (response.response) {
            var _modelResponse$user;
            const modelResponse = response.response;
            if (modelResponse !== null && modelResponse !== void 0 && (_modelResponse$user = modelResponse.user) !== null && _modelResponse$user !== void 0 && _modelResponse$user.timezone) {
                var _modelResponse$user2;
                $3dc31f296817c6dc$var$setTimezoneMetaTag(modelResponse === null || modelResponse === void 0 || (_modelResponse$user2 = modelResponse.user) === null || _modelResponse$user2 === void 0 ? void 0 : _modelResponse$user2.timezone);
            }
        }
        return response.response;
    }), (0, $8ie7e.catchError)((err)=>{
        (0, $kXlzl.operationalEvent)($3dc31f296817c6dc$var$createOperationalEvent(requestTypes, retries, false, err.status));
        const traceId = $3dc31f296817c6dc$var$getTraceId(err);
        const responseHeaders = $3dc31f296817c6dc$var$getAllResponseHeaders(err);
        return new (0, $b0T1M.Observable)((observer)=>{
            observer.error(err.response ? {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.response.status,
                errorMessages: err.response.errorMessages,
                nextActionUrl: err.response.nextActionUrl,
                nextActionDisplayText: err.response.nextActionDisplayText
            } : {
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: err.status,
                errorMessages: []
            });
        });
    }));
};
const $3dc31f296817c6dc$export$be054e1f3ca89815 = (modelsDescriptor, options, modelContext, context = (0, $3wR8f.contextPath))=>{
    if ((0, $bG6ob.isRetryMechanismTuningEnabled)()) return $3dc31f296817c6dc$var$requestModelsWithRetries(modelsDescriptor, options, modelContext, context);
    return $3dc31f296817c6dc$export$a06581639cf24e1e(modelsDescriptor, options, modelContext, context);
};

});
parcelRegister("hGOIV", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER", () => $46562f2b61ad75ad$export$8e46b442a40fd146);
$parcel$export(module.exports, "PORTAL_HOME", () => $46562f2b61ad75ad$export$e7639abf9d430473);
$parcel$export(module.exports, "REQUEST_CREATE", () => $46562f2b61ad75ad$export$722b80b55a1414f);
$parcel$export(module.exports, "REQUEST_DETAILS", () => $46562f2b61ad75ad$export$9e5185d6a2a60dc);
$parcel$export(module.exports, "REQUEST_LIST", () => $46562f2b61ad75ad$export$805e3047ef7cb33e);
$parcel$export(module.exports, "PROFILE", () => $46562f2b61ad75ad$export$91c3232a793620f2);
$parcel$export(module.exports, "PROFILE_PANEL", () => $46562f2b61ad75ad$export$b87ce3f352c7af33);
$parcel$export(module.exports, "REQUEST_CREATE_PANEL", () => $46562f2b61ad75ad$export$fcdaac8f3aa2d02e);
$parcel$export(module.exports, "HEADER", () => $46562f2b61ad75ad$export$526a1e214ba17198);
$parcel$export(module.exports, "SUB_HEADER", () => $46562f2b61ad75ad$export$9e49b02bf8c4161f);
$parcel$export(module.exports, "FOOTER", () => $46562f2b61ad75ad$export$d8d929c77d921e7d);
$parcel$export(module.exports, "DETAILS", () => $46562f2b61ad75ad$export$e094c4db500be584);
$parcel$export(module.exports, "DETAILS_SIDE_SECTION", () => $46562f2b61ad75ad$export$6c81f8b23c0dd1d2);
$parcel$export(module.exports, "ConnectFragment", () => $46562f2b61ad75ad$export$aa8ab018415f92e4);

var $4fqPo = parcelRequire("4fqPo");

var $54jwS = parcelRequire("54jwS");

var $fbYHu = parcelRequire("fbYHu");

var $a34o1 = parcelRequire("a34o1");

var $h6PK5 = parcelRequire("h6PK5");
const $46562f2b61ad75ad$export$8e46b442a40fd146 = 'HELP_CENTER';
const $46562f2b61ad75ad$export$e7639abf9d430473 = 'PORTAL';
const $46562f2b61ad75ad$export$722b80b55a1414f = 'CREATE_REQUEST';
const $46562f2b61ad75ad$export$9e5185d6a2a60dc = 'VIEW_REQUEST';
const $46562f2b61ad75ad$export$805e3047ef7cb33e = 'MY_REQUESTS';
const $46562f2b61ad75ad$export$91c3232a793620f2 = 'PROFILE';
const $46562f2b61ad75ad$export$b87ce3f352c7af33 = 'profilePagePanel';
const $46562f2b61ad75ad$export$fcdaac8f3aa2d02e = 'requestCreatePanel';
const $46562f2b61ad75ad$export$526a1e214ba17198 = 'headerPanels';
const $46562f2b61ad75ad$export$9e49b02bf8c4161f = 'subheaderPanels';
const $46562f2b61ad75ad$export$d8d929c77d921e7d = 'footerPanels';
const $46562f2b61ad75ad$export$e094c4db500be584 = 'detailsPanels';
const $46562f2b61ad75ad$export$6c81f8b23c0dd1d2 = 'optionPanels';
class $46562f2b61ad75ad$export$aa8ab018415f92e4 extends $4fqPo.Component {
    componentDidMount() {
        const { fetchConnectFragments: fetchConnectFragments, page: page, connectFragments: connectFragments, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        if (!connectFragments) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        else this.fireConnectFragmentAnalytics();
        this.fireShowConnectBlockedAppsBanner();
    }
    componentDidUpdate(prevProps) {
        const { fetchConnectFragments: fetchConnectFragments, connectFragments: connectFragments, page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = this.props;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId || prevProps.portalId !== portalId;
        if (requestTypeUpdated) fetchConnectFragments({
            portalId: portalId,
            requestTypeId: requestTypeId,
            requestKey: requestKey,
            portalPage: page
        });
        if (!prevProps.connectFragments && connectFragments) this.fireConnectFragmentAnalytics();
        else if (prevProps.connectFragments && connectFragments) {
            const previouslyErrored = 'error' in prevProps.connectFragments;
            const currentlyErrored = 'error' in connectFragments;
            if (previouslyErrored !== currentlyErrored) this.fireConnectFragmentAnalytics();
        }
        if (prevProps.projectId !== this.props.projectId) this.fireShowConnectBlockedAppsBanner();
    }
    render() {
        const { connectFragments: connectFragments, className: className, location: location } = this.props;
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        return /*#__PURE__*/ $4fqPo.createElement((0, $h6PK5.default), {
            location: location,
            className: className,
            connectFragments: connectFragments
        });
    }
    constructor(...args){
        super(...args), this.fireShowConnectBlockedAppsBanner = ()=>{
            const { page: page, projectId: projectId } = this.props;
            if ((0, $a34o1.isConnectBlockedAppsRelevantPage)(page)) {
                this.props.resetBannerState(page);
                if (projectId) (0, $a34o1.fetchIsAnyConnectAppBlocked)({
                    projectId: projectId,
                    page: page
                }).then((isBlocked)=>{
                    if (isBlocked) this.props.showBanner(page);
                }).catch(()=>{
                // The error is already logged in the fetchIsAnyConnectAppBlocked function
                });
            }
        }, this.fireConnectFragmentAnalytics = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent, connectFragments: connectFragments, location: location, portalId: portalId, requestTypeId: requestTypeId } = this.props;
            if (!createAnalyticsEvent || !connectFragments) return;
            const isError = 'error' in connectFragments;
            if (!isError && connectFragments.length === 0) return;
            const uniqueAppKeys = !isError ? (0, $fbYHu.getUniqueAppKeysFromConnectFragments)(connectFragments) : [];
            const analyticsEvent = createAnalyticsEvent({
                portalId: portalId,
                requestTypeId: requestTypeId,
                location: location,
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: isError ? 'failed' : 'loaded',
                appKeys: uniqueAppKeys
            });
            analyticsEvent.fire();
        };
    }
}

});
parcelRegister("a34o1", function(module, exports) {
$parcel$export(module.exports, "isConnectBlockedAppsRelevantPage", () => $06eea099309be2b8$export$aa2542e596000b48);
$parcel$export(module.exports, "fetchIsAnyConnectAppBlocked", () => $06eea099309be2b8$export$40f1d90131a12a2);

var $lVFX8 = parcelRequire("lVFX8");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");
const $06eea099309be2b8$var$perProjectRequestCache = new Map();
const $06eea099309be2b8$export$aa2542e596000b48 = (page)=>{
    const relevantConnectPages = [
        'PORTAL',
        'CREATE_REQUEST',
        'VIEW_REQUEST'
    ];
    return relevantConnectPages.includes(page);
};
const $06eea099309be2b8$export$40f1d90131a12a2 = (context)=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/atlassian-connect/latest/addon-access`;
    const body = {
        context: context
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    const cacheKey = context.projectId.toString();
    let cachedRequest = $06eea099309be2b8$var$perProjectRequestCache.get(cacheKey);
    if (!cachedRequest) {
        cachedRequest = (0, $lVFX8.post)(uri, body, headers).map(({ response: response })=>response.isAnyAppBlocked).catch((e)=>{
            (0, $keOG0.trackError)('connect.blocked-apps.fetch.failed', {}, e);
            return Promise.reject(e);
        }).toPromise();
        $06eea099309be2b8$var$perProjectRequestCache.set(cacheKey, cachedRequest);
    }
    return cachedRequest;
};

});

parcelRegister("h6PK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $badfd22cb9531962$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $36Pct = parcelRequire("36Pct");
const $badfd22cb9531962$var$ConnectFragmentsDumb = ({ connectFragments: connectFragments, className: className, location: location })=>{
    if (!connectFragments || 'error' in connectFragments) return null;
    if (connectFragments.length) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ $4fqPo.createElement($badfd22cb9531962$var$Root, {
        className: className
    }, connectFragments.map((fragment)=>/*#__PURE__*/ $4fqPo.createElement((0, $36Pct.default), {
            key: fragment.key,
            fullKey: fragment.key,
            location: location,
            fragmentHtml: fragment.html
        }))));
    return null;
};
var $badfd22cb9531962$export$2e2bcd8739ae039 = $badfd22cb9531962$var$ConnectFragmentsDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $badfd22cb9531962$var$Root = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-19x1uwk-0"
})`margin-top:${"var(--ds-space-400, 32px)"};`;

});
parcelRegister("el3DQ", function(module, exports) {
$parcel$export(module.exports, "css", () => $cc1fe8bb1adaf3a9$export$dbf350e5966cf602);
$parcel$export(module.exports, "injectGlobal", () => $cc1fe8bb1adaf3a9$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "keyframes", () => $cc1fe8bb1adaf3a9$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeProvider", () => $cc1fe8bb1adaf3a9$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $cc1fe8bb1adaf3a9$export$e8748c6a27b910dc);
$parcel$export(module.exports, "default", () => $cc1fe8bb1adaf3a9$export$2e2bcd8739ae039);

var $9QAmg = parcelRequire("9QAmg");
const { css: $cc1fe8bb1adaf3a9$export$dbf350e5966cf602, injectGlobal: $cc1fe8bb1adaf3a9$export$efb9f5caaa2ca0c7, keyframes: $cc1fe8bb1adaf3a9$export$d25ddfdf17c3ad3e, ThemeProvider: $cc1fe8bb1adaf3a9$export$d8964aec282183a3, default: $cc1fe8bb1adaf3a9$var$styled } = $9QAmg;
// Custom type definition for withTheme method for styled components so that
// we don't have to manually inject theme props in storybook
const $cc1fe8bb1adaf3a9$export$e8748c6a27b910dc = (component)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $9QAmg.withTheme(component);
var $cc1fe8bb1adaf3a9$export$2e2bcd8739ae039 = $cc1fe8bb1adaf3a9$var$styled;

});
parcelRegister("9QAmg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "isStyledComponent", () => $72b52c5606f20ccc$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "consolidateStreamedStyles", () => $72b52c5606f20ccc$export$953e7e0c06f2f28b);
$parcel$export(module.exports, "css", () => $72b52c5606f20ccc$export$dbf350e5966cf602);
$parcel$export(module.exports, "StyleSheetManager", () => $72b52c5606f20ccc$export$a473771da2f0ff7c);
$parcel$export(module.exports, "ServerStyleSheet", () => $72b52c5606f20ccc$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "ThemeProvider", () => $72b52c5606f20ccc$export$d8964aec282183a3);
$parcel$export(module.exports, "withTheme", () => $72b52c5606f20ccc$export$e8748c6a27b910dc);
$parcel$export(module.exports, "__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS", () => $72b52c5606f20ccc$export$84079c323bb0915e);
$parcel$export(module.exports, "keyframes", () => $72b52c5606f20ccc$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "injectGlobal", () => $72b52c5606f20ccc$export$efb9f5caaa2ca0c7);
$parcel$export(module.exports, "default", () => $72b52c5606f20ccc$export$2e2bcd8739ae039);

var $8LOVE = parcelRequire("8LOVE");

var $4fqPo = parcelRequire("4fqPo");

var $d9MfL = parcelRequire("d9MfL");

var $e7EQ2 = parcelRequire("e7EQ2");

var $4S7MC = parcelRequire("4S7MC");

var $bjaoS = parcelRequire("bjaoS");

var $8KJmM = parcelRequire("8KJmM");

var $3TFEq = parcelRequire("3TFEq");
var $72b52c5606f20ccc$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $72b52c5606f20ccc$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $72b52c5606f20ccc$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $72b52c5606f20ccc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $72b52c5606f20ccc$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $72b52c5606f20ccc$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $72b52c5606f20ccc$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $72b52c5606f20ccc$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $72b52c5606f20ccc$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $72b52c5606f20ccc$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $72b52c5606f20ccc$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $72b52c5606f20ccc$var$StyledComponentsError = function(_Error) {
    $72b52c5606f20ccc$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $72b52c5606f20ccc$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $72b52c5606f20ccc$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $72b52c5606f20ccc$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $72b52c5606f20ccc$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($72b52c5606f20ccc$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($8LOVE)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $72b52c5606f20ccc$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $72b52c5606f20ccc$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $72b52c5606f20ccc$var$isPlainObject(chunk) ? $72b52c5606f20ccc$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $72b52c5606f20ccc$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $72b52c5606f20ccc$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($d9MfL)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $72b52c5606f20ccc$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($d9MfL)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $72b52c5606f20ccc$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $72b52c5606f20ccc$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $72b52c5606f20ccc$var$parsingRules;
        $72b52c5606f20ccc$var$parsingRules = [];
        return parsedRules;
    }
};
var $72b52c5606f20ccc$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($e7EQ2)))(function(rule) {
    $72b52c5606f20ccc$var$parsingRules.push(rule);
});
$72b52c5606f20ccc$var$stylis.use([
    $72b52c5606f20ccc$var$parseRulesPlugin,
    $72b52c5606f20ccc$var$returnRulesPlugin
]);
$72b52c5606f20ccc$var$stylisSplitter.use([
    $72b52c5606f20ccc$var$parseRulesPlugin,
    $72b52c5606f20ccc$var$returnRulesPlugin
]);
var $72b52c5606f20ccc$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($72b52c5606f20ccc$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $72b52c5606f20ccc$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $72b52c5606f20ccc$var$splitByRules = function splitByRules(css) {
    return $72b52c5606f20ccc$var$stylisSplitter('', css);
};
// 
function $72b52c5606f20ccc$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $72b52c5606f20ccc$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $72b52c5606f20ccc$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $72b52c5606f20ccc$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $72b52c5606f20ccc$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $72b52c5606f20ccc$var$charsLength; x = Math.floor(x / $72b52c5606f20ccc$var$charsLength))name = $72b52c5606f20ccc$var$getAlphabeticChar(x % $72b52c5606f20ccc$var$charsLength) + name;
    return $72b52c5606f20ccc$var$getAlphabeticChar(x % $72b52c5606f20ccc$var$charsLength) + name;
};
// 
var $72b52c5606f20ccc$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $72b52c5606f20ccc$var$EMPTY_ARRAY = Object.freeze([]);
var $72b52c5606f20ccc$var$EMPTY_OBJECT = Object.freeze({});
// 
var $72b52c5606f20ccc$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $72b52c5606f20ccc$var$isPlainObject(styles)) // $FlowFixMe
    return $72b52c5606f20ccc$var$flatten($72b52c5606f20ccc$var$interleave($72b52c5606f20ccc$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $72b52c5606f20ccc$var$flatten($72b52c5606f20ccc$var$interleave(styles, interpolations));
};
// 
var $72b52c5606f20ccc$var$SC_ATTR = (typeof $3TFEq !== 'undefined' && undefined, 'data-styled-components');
var $72b52c5606f20ccc$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $72b52c5606f20ccc$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $72b52c5606f20ccc$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $72b52c5606f20ccc$var$DISABLE_SPEEDY = false;
// 
var $72b52c5606f20ccc$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $72b52c5606f20ccc$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($72b52c5606f20ccc$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $72b52c5606f20ccc$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $72b52c5606f20ccc$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $72b52c5606f20ccc$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $72b52c5606f20ccc$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $72b52c5606f20ccc$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $72b52c5606f20ccc$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $72b52c5606f20ccc$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $72b52c5606f20ccc$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $72b52c5606f20ccc$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $72b52c5606f20ccc$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $72b52c5606f20ccc$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $72b52c5606f20ccc$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $72b52c5606f20ccc$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $72b52c5606f20ccc$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $72b52c5606f20ccc$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($72b52c5606f20ccc$var$SC_ATTR, '');
    var nonce = $72b52c5606f20ccc$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $72b52c5606f20ccc$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $72b52c5606f20ccc$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $72b52c5606f20ccc$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $72b52c5606f20ccc$var$SC_ATTR + '="' + $72b52c5606f20ccc$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $72b52c5606f20ccc$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$72b52c5606f20ccc$var$SC_ATTR] = $72b52c5606f20ccc$var$stringifyNames(names), _props);
        var nonce = $72b52c5606f20ccc$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement('style', $72b52c5606f20ccc$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $72b52c5606f20ccc$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $72b52c5606f20ccc$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $72b52c5606f20ccc$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $72b52c5606f20ccc$var$sheetForTag(el);
        var insertIndex = $72b52c5606f20ccc$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($72b52c5606f20ccc$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $72b52c5606f20ccc$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $72b52c5606f20ccc$var$sheetForTag(el);
        var removalIndex = $72b52c5606f20ccc$var$addUpUntilIndex(sizes, marker);
        $72b52c5606f20ccc$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $72b52c5606f20ccc$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $72b52c5606f20ccc$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $72b52c5606f20ccc$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $72b52c5606f20ccc$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $72b52c5606f20ccc$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $72b52c5606f20ccc$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $72b52c5606f20ccc$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $72b52c5606f20ccc$var$wrapAsElement(css, names),
        toHTML: $72b52c5606f20ccc$var$wrapAsHtmlTag(css, names)
    };
};
var $72b52c5606f20ccc$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($72b52c5606f20ccc$var$makeTextMarker(id));
};
var $72b52c5606f20ccc$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $72b52c5606f20ccc$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $72b52c5606f20ccc$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $72b52c5606f20ccc$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $72b52c5606f20ccc$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $72b52c5606f20ccc$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $72b52c5606f20ccc$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $72b52c5606f20ccc$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $72b52c5606f20ccc$var$wrapAsElement(css, names),
        toHTML: $72b52c5606f20ccc$var$wrapAsHtmlTag(css, names)
    };
};
var $72b52c5606f20ccc$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $72b52c5606f20ccc$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $72b52c5606f20ccc$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $72b52c5606f20ccc$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $72b52c5606f20ccc$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $72b52c5606f20ccc$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $72b52c5606f20ccc$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $72b52c5606f20ccc$var$wrapAsElement(css, names),
        toHTML: $72b52c5606f20ccc$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $72b52c5606f20ccc$var$makeServerTag = function makeServerTag() {
    return $72b52c5606f20ccc$var$makeServerTagInternal();
};
var $72b52c5606f20ccc$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($72b52c5606f20ccc$var$IS_BROWSER && !forceServer) {
        var el = $72b52c5606f20ccc$var$makeStyleTag(target, tagEl, insertBefore);
        if ($72b52c5606f20ccc$var$DISABLE_SPEEDY) return $72b52c5606f20ccc$var$makeBrowserTag(el, getImportRuleTag);
        else return $72b52c5606f20ccc$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $72b52c5606f20ccc$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $72b52c5606f20ccc$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $72b52c5606f20ccc$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $72b52c5606f20ccc$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $72b52c5606f20ccc$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $72b52c5606f20ccc$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $72b52c5606f20ccc$var$MAX_SIZE = void 0;
if ($72b52c5606f20ccc$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $72b52c5606f20ccc$var$MAX_SIZE = $72b52c5606f20ccc$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $72b52c5606f20ccc$var$MAX_SIZE = -1;
var $72b52c5606f20ccc$var$sheetRunningId = 0;
var $72b52c5606f20ccc$var$master = void 0;
var $72b52c5606f20ccc$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $72b52c5606f20ccc$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $72b52c5606f20ccc$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $72b52c5606f20ccc$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $72b52c5606f20ccc$var$sheetRunningId += 1;
        this.id = $72b52c5606f20ccc$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$72b52c5606f20ccc$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $72b52c5606f20ccc$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($72b52c5606f20ccc$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($72b52c5606f20ccc$var$SC_ATTR) || '').trim().split($72b52c5606f20ccc$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $72b52c5606f20ccc$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $72b52c5606f20ccc$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $72b52c5606f20ccc$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $72b52c5606f20ccc$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $72b52c5606f20ccc$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $72b52c5606f20ccc$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $72b52c5606f20ccc$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $72b52c5606f20ccc$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $4fqPo.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $72b52c5606f20ccc$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $72b52c5606f20ccc$var$master || ($72b52c5606f20ccc$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $72b52c5606f20ccc$var$_StyleSheetManager$ch;
var $72b52c5606f20ccc$export$a473771da2f0ff7c = function(_Component) {
    $72b52c5606f20ccc$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $72b52c5606f20ccc$var$classCallCheck(this, StyleSheetManager);
        return $72b52c5606f20ccc$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$72b52c5606f20ccc$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $72b52c5606f20ccc$var$StyleSheet(this.props.target);
        else throw new $72b52c5606f20ccc$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $4fqPo.Component));
$72b52c5606f20ccc$export$a473771da2f0ff7c.childContextTypes = ($72b52c5606f20ccc$var$_StyleSheetManager$ch = {}, $72b52c5606f20ccc$var$_StyleSheetManager$ch[$72b52c5606f20ccc$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).instanceOf($72b52c5606f20ccc$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).instanceOf($72b52c5606f20ccc$export$ae8c7d15c8b89a20)
]).isRequired, $72b52c5606f20ccc$var$_StyleSheetManager$ch);
// 
var $72b52c5606f20ccc$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $72b52c5606f20ccc$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $72b52c5606f20ccc$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $72b52c5606f20ccc$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($72b52c5606f20ccc$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $72b52c5606f20ccc$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $72b52c5606f20ccc$var$LIMIT = 200;
var $72b52c5606f20ccc$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $72b52c5606f20ccc$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $72b52c5606f20ccc$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $72b52c5606f20ccc$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $72b52c5606f20ccc$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $72b52c5606f20ccc$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $72b52c5606f20ccc$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($72b52c5606f20ccc$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($72b52c5606f20ccc$var$dashesAtEnds, '');
}
// 
function $72b52c5606f20ccc$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $72b52c5606f20ccc$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $72b52c5606f20ccc$var$generateDisplayName(target) {
    return $72b52c5606f20ccc$var$isTag(target) ? 'styled.' + target : 'Styled(' + $72b52c5606f20ccc$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $72b52c5606f20ccc$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $72b52c5606f20ccc$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $72b52c5606f20ccc$var$ATTRIBUTE_NAME_CHAR = $72b52c5606f20ccc$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $72b52c5606f20ccc$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $72b52c5606f20ccc$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $72b52c5606f20ccc$var$validAttr = function(name) {
    return $72b52c5606f20ccc$var$ATTRIBUTE_REGEX.test(name) || $72b52c5606f20ccc$var$isCustomAttribute(name.toLowerCase());
};
// 
function $72b52c5606f20ccc$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $72b52c5606f20ccc$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $72b52c5606f20ccc$var$_contextShape, $72b52c5606f20ccc$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $72b52c5606f20ccc$var$CHANNEL = '__styled-components__';
var $72b52c5606f20ccc$var$CHANNEL_NEXT = $72b52c5606f20ccc$var$CHANNEL + 'next__';
var $72b52c5606f20ccc$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
});
var $72b52c5606f20ccc$var$contextShape = ($72b52c5606f20ccc$var$_contextShape = {}, $72b52c5606f20ccc$var$_contextShape[$72b52c5606f20ccc$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func, $72b52c5606f20ccc$var$_contextShape[$72b52c5606f20ccc$var$CHANNEL_NEXT] = $72b52c5606f20ccc$var$CONTEXT_CHANNEL_SHAPE, $72b52c5606f20ccc$var$_contextShape);
var $72b52c5606f20ccc$var$warnChannelDeprecated = void 0;
var $72b52c5606f20ccc$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $72b52c5606f20ccc$export$d8964aec282183a3 = function(_Component) {
    $72b52c5606f20ccc$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $72b52c5606f20ccc$var$classCallCheck(this, ThemeProvider);
        var _this = $72b52c5606f20ccc$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$72b52c5606f20ccc$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $72b52c5606f20ccc$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $72b52c5606f20ccc$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$72b52c5606f20ccc$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$72b52c5606f20ccc$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$72b52c5606f20ccc$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($72b52c5606f20ccc$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $72b52c5606f20ccc$var$_typeof(theme)) !== 'object') throw new $72b52c5606f20ccc$var$StyledComponentsError(8);
        return $72b52c5606f20ccc$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $4fqPo.Component));
$72b52c5606f20ccc$export$d8964aec282183a3.childContextTypes = $72b52c5606f20ccc$var$contextShape;
$72b52c5606f20ccc$export$d8964aec282183a3.contextTypes = ($72b52c5606f20ccc$var$_ThemeProvider$contex = {}, $72b52c5606f20ccc$var$_ThemeProvider$contex[$72b52c5606f20ccc$var$CHANNEL_NEXT] = $72b52c5606f20ccc$var$CONTEXT_CHANNEL_SHAPE, $72b52c5606f20ccc$var$_ThemeProvider$contex);
var $72b52c5606f20ccc$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $72b52c5606f20ccc$var$STATIC_EXECUTION_CONTEXT = {};
var $72b52c5606f20ccc$var$modifiedContextShape = $72b52c5606f20ccc$var$_extends({}, $72b52c5606f20ccc$var$contextShape, ($72b52c5606f20ccc$var$_babelHelpers$extends = {}, $72b52c5606f20ccc$var$_babelHelpers$extends[$72b52c5606f20ccc$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).instanceOf($72b52c5606f20ccc$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).instanceOf($72b52c5606f20ccc$export$ae8c7d15c8b89a20)
]), $72b52c5606f20ccc$var$_babelHelpers$extends));
var $72b52c5606f20ccc$var$identifiers = {};
/* We depend on components having unique IDs */ var $72b52c5606f20ccc$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $72b52c5606f20ccc$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($72b52c5606f20ccc$var$identifiers[displayName] || 0) + 1;
    $72b52c5606f20ccc$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $72b52c5606f20ccc$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $72b52c5606f20ccc$var$BaseStyledComponent = function(_Component) {
    $72b52c5606f20ccc$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $72b52c5606f20ccc$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $72b52c5606f20ccc$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $72b52c5606f20ccc$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$72b52c5606f20ccc$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $72b52c5606f20ccc$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$72b52c5606f20ccc$var$hasInInheritanceChain(attr, (0, $4fqPo.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $72b52c5606f20ccc$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$72b52c5606f20ccc$var$CONTEXT_KEY] || $72b52c5606f20ccc$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($72b52c5606f20ccc$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$72b52c5606f20ccc$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($72b52c5606f20ccc$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $72b52c5606f20ccc$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $72b52c5606f20ccc$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $72b52c5606f20ccc$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $72b52c5606f20ccc$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $72b52c5606f20ccc$var$_extends({}, this.attrs, {
            className: className
        });
        if ($72b52c5606f20ccc$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $72b52c5606f20ccc$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $72b52c5606f20ccc$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $4fqPo.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $4fqPo.Component));
var $72b52c5606f20ccc$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$72b52c5606f20ccc$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $72b52c5606f20ccc$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $72b52c5606f20ccc$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $72b52c5606f20ccc$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $72b52c5606f20ccc$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $72b52c5606f20ccc$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $72b52c5606f20ccc$var$classCallCheck(this, StyledComponent);
                return $72b52c5606f20ccc$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $72b52c5606f20ccc$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($72b52c5606f20ccc$var$isTag(tag) ? tag : $72b52c5606f20ccc$var$escape($72b52c5606f20ccc$var$getComponentName(tag)));
                var newOptions = $72b52c5606f20ccc$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $72b52c5606f20ccc$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $72b52c5606f20ccc$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $72b52c5606f20ccc$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $72b52c5606f20ccc$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $72b52c5606f20ccc$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($bjaoS)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $72b52c5606f20ccc$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $72b52c5606f20ccc$var$areStylesCacheable = $72b52c5606f20ccc$var$IS_BROWSER;
var $72b52c5606f20ccc$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$72b52c5606f20ccc$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $72b52c5606f20ccc$var$isHMREnabled = null && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $72b52c5606f20ccc$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($72b52c5606f20ccc$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $72b52c5606f20ccc$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$72b52c5606f20ccc$var$isHMREnabled && $72b52c5606f20ccc$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$72b52c5606f20ccc$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $72b52c5606f20ccc$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($72b52c5606f20ccc$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $72b52c5606f20ccc$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $72b52c5606f20ccc$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $72b52c5606f20ccc$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $72b52c5606f20ccc$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $72b52c5606f20ccc$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $72b52c5606f20ccc$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($72b52c5606f20ccc$var$murmurhash($72b52c5606f20ccc$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $72b52c5606f20ccc$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $72b52c5606f20ccc$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $72b52c5606f20ccc$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $72b52c5606f20ccc$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $72b52c5606f20ccc$var$EMPTY_OBJECT;
        if (!(0, $8KJmM.isValidElementType)(tag)) throw new $72b52c5606f20ccc$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $72b52c5606f20ccc$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $72b52c5606f20ccc$var$_extends({}, options, {
                attrs: $72b52c5606f20ccc$var$_extends({}, options.attrs || $72b52c5606f20ccc$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $72b52c5606f20ccc$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $72b52c5606f20ccc$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $72b52c5606f20ccc$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $72b52c5606f20ccc$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $72b52c5606f20ccc$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $72b52c5606f20ccc$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $72b52c5606f20ccc$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$72b52c5606f20ccc$var$CHANNEL_NEXT];
            var themeProp = $72b52c5606f20ccc$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $72b52c5606f20ccc$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $72b52c5606f20ccc$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$72b52c5606f20ccc$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $72b52c5606f20ccc$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component);
    WithTheme.contextTypes = $72b52c5606f20ccc$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $72b52c5606f20ccc$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($bjaoS)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $72b52c5606f20ccc$export$84079c323bb0915e = {
    StyleSheet: $72b52c5606f20ccc$var$StyleSheet
};
/* Instantiate singletons */ var $72b52c5606f20ccc$var$ComponentStyle = $72b52c5606f20ccc$var$_ComponentStyle($72b52c5606f20ccc$var$generateAlphabeticName, $72b52c5606f20ccc$var$flatten, $72b52c5606f20ccc$var$stringifyRules);
var $72b52c5606f20ccc$var$constructWithOptions = $72b52c5606f20ccc$var$_constructWithOptions($72b52c5606f20ccc$export$dbf350e5966cf602);
var $72b52c5606f20ccc$var$StyledComponent = $72b52c5606f20ccc$var$_StyledComponent($72b52c5606f20ccc$var$ComponentStyle, $72b52c5606f20ccc$var$constructWithOptions);
/* Instantiate exported singletons */ var $72b52c5606f20ccc$export$d25ddfdf17c3ad3e = $72b52c5606f20ccc$var$_keyframes($72b52c5606f20ccc$var$generateAlphabeticName, $72b52c5606f20ccc$var$stringifyRules, $72b52c5606f20ccc$export$dbf350e5966cf602);
var $72b52c5606f20ccc$export$efb9f5caaa2ca0c7 = $72b52c5606f20ccc$var$_injectGlobal($72b52c5606f20ccc$var$stringifyRules, $72b52c5606f20ccc$export$dbf350e5966cf602);
var $72b52c5606f20ccc$var$styled = $72b52c5606f20ccc$var$_styled($72b52c5606f20ccc$var$StyledComponent, $72b52c5606f20ccc$var$constructWithOptions);
var $72b52c5606f20ccc$export$2e2bcd8739ae039 = $72b52c5606f20ccc$var$styled;

});
parcelRegister("8LOVE", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $dUBrh = parcelRequire("dUBrh");
var $01a5d79ca5411370$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $01a5d79ca5411370$var$hyphenateStyleName(string) {
    return $dUBrh(string).replace($01a5d79ca5411370$var$msPattern, '-ms-');
}
module.exports = $01a5d79ca5411370$var$hyphenateStyleName;

});
parcelRegister("dUBrh", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $a20d8be827a0d535$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $a20d8be827a0d535$var$hyphenate(string) {
    return string.replace($a20d8be827a0d535$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $a20d8be827a0d535$var$hyphenate;

});


parcelRegister("d9MfL", function(module, exports) {
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    module.exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});

});

parcelRegister("e7EQ2", function(module, exports) {
(function(factory) {
    module.exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});

});

parcelRegister("bjaoS", function(module, exports) {
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $83b98954385a3731$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $83b98954385a3731$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $83b98954385a3731$var$defineProperty = Object.defineProperty;
var $83b98954385a3731$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $83b98954385a3731$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $83b98954385a3731$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $83b98954385a3731$var$getPrototypeOf = Object.getPrototypeOf;
var $83b98954385a3731$var$objectPrototype = $83b98954385a3731$var$getPrototypeOf && $83b98954385a3731$var$getPrototypeOf(Object);
function $83b98954385a3731$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($83b98954385a3731$var$objectPrototype) {
            var inheritedComponent = $83b98954385a3731$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $83b98954385a3731$var$objectPrototype) $83b98954385a3731$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $83b98954385a3731$var$getOwnPropertyNames(sourceComponent);
        if ($83b98954385a3731$var$getOwnPropertySymbols) keys = keys.concat($83b98954385a3731$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$83b98954385a3731$var$REACT_STATICS[key] && !$83b98954385a3731$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $83b98954385a3731$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $83b98954385a3731$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
module.exports = $83b98954385a3731$var$hoistNonReactStatics;

});



parcelRegister("36Pct", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac21d980c4bf9e9a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $54jwS = parcelRequire("54jwS");

var $fbYHu = parcelRequire("fbYHu");
class $ac21d980c4bf9e9a$var$ConnectFragmentDumb extends $4fqPo.Component {
    render() {
        return /*#__PURE__*/ $4fqPo.createElement("div", {
            ref: this.onRef,
            dangerouslySetInnerHTML: {
                __html: this.props.fragmentHtml
            }
        });
    }
    constructor(...args){
        super(...args), this.componentDidMount = ()=>{
            const { onMount: onMount } = this.props;
            onMount && onMount();
        }, this.onRef = (element)=>{
            if (element) this.savedElement = element;
            this.executeConnectIFrameScripts();
        }, this.executeConnectIFrameScripts = ()=>{
            if (this.savedElement) {
                // We manually go through each script tag and then clone it so that it will execute
                const scriptTags = this.savedElement.querySelectorAll('script') || [];
                Array.prototype.forEach.call(scriptTags, (scriptTag)=>{
                    if (scriptTag.parentNode) {
                        // We create a new script tag and then append it to the parent node this way it will execute properly.
                        // Upgrading @atlaskit/platform; fix these violations.
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                        const newScript = document.createElement('script');
                        newScript.innerHTML = scriptTag.innerHTML;
                        scriptTag.parentNode.replaceChild(newScript, scriptTag);
                    }
                });
            }
        }, this.componentDidUpdate = ()=>{
            // If we don't call this, then Connect addon iframes are not rendered when a component is reloaded
            this.executeConnectIFrameScripts();
        };
    }
}
var $ac21d980c4bf9e9a$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    componentName: 'ConnectFragment'
})((0, $as4kh.default)({
    onMount: (create, props)=>create({
            action: 'mounted',
            analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
            location: props.location ?? 'LocationUnknown',
            appKeys: [
                (0, $fbYHu.getAppKeyFromFullKey)(props.fullKey)
            ]
        }).fire()
})($ac21d980c4bf9e9a$var$ConnectFragmentDumb));

});




parcelRegister("85R51", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc2de193f4f80418$export$2e2bcd8739ae039);

var $63sfu = parcelRequire("63sfu");
const $fc2de193f4f80418$var$defer = ()=>{
    let resolve;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let reject;
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: // @ts-ignore
        resolve,
        reject: // @ts-ignore
        reject
    };
};
const $fc2de193f4f80418$var$proxyFunction = (func, wait, options = {})=>{
    let arrArg = [];
    let deferred = $fc2de193f4f80418$var$defer();
    const callThenResetArgs = (args)=>{
        try {
            const result = func(args);
            deferred.resolve(result);
        } catch (err) {
            deferred.reject(err);
        }
        arrArg = [];
        deferred = $fc2de193f4f80418$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $63sfu.debounce)(callThenResetArgs, wait, options);
    return (arg)=>{
        if (arg) arrArg = arrArg.concat(arg);
        debouncedFunc(arrArg);
        return deferred.promise;
    };
};
var $fc2de193f4f80418$export$2e2bcd8739ae039 = $fc2de193f4f80418$var$proxyFunction;

});



parcelRegister("jYob8", function(module, exports) {
$parcel$export(module.exports, "updateEnvAction", () => (parcelRequire("cGPrY")).updateEnvAction);
$parcel$export(module.exports, "UPDATE_ENV", () => (parcelRequire("cGPrY")).UPDATE_ENV);
$parcel$export(module.exports, "updateXsrfAction", () => (parcelRequire("cGPrY")).updateXsrfAction);
$parcel$export(module.exports, "UPDATE_XSRF", () => (parcelRequire("cGPrY")).UPDATE_XSRF);

var $cGPrY = parcelRequire("cGPrY");

});
parcelRegister("cGPrY", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ENV", () => $d1beb292aa068468$export$54fc9c8b94b5595f);
$parcel$export(module.exports, "UPDATE_XSRF", () => $d1beb292aa068468$export$b024063085428a5d);
$parcel$export(module.exports, "updateEnvAction", () => $d1beb292aa068468$export$b66da392cb9395e8);
$parcel$export(module.exports, "updateXsrfAction", () => $d1beb292aa068468$export$1293ace05a0f6e97);
const $d1beb292aa068468$export$54fc9c8b94b5595f = 'state.persisted.env.UPDATE_ENV';
const $d1beb292aa068468$export$b024063085428a5d = 'state.persisted.env.UPDATE_XSRF';
const $d1beb292aa068468$export$b66da392cb9395e8 = (env)=>({
        payload: env,
        type: $d1beb292aa068468$export$54fc9c8b94b5595f
    });
const $d1beb292aa068468$export$1293ace05a0f6e97 = (xsrf)=>({
        payload: xsrf,
        type: $d1beb292aa068468$export$b024063085428a5d
    });

});


parcelRegister("5eCdR", function(module, exports) {
$parcel$export(module.exports, "FETCH_HELP_CENTER_MODEL", () => $649f968a39271571$export$5586a78b777598b9);
$parcel$export(module.exports, "INVALIDATE_HELP_CENTER_RELAY_STORE", () => $649f968a39271571$export$e3632d3a6ee981be);
$parcel$export(module.exports, "fetchHelpCenterAction", () => $649f968a39271571$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "invalidateHelpCenterStoreAction", () => $649f968a39271571$export$d06ed959afe649d4);
$parcel$export(module.exports, "FETCH_HELP_CENTER_BRANDING_MODEL", () => $649f968a39271571$export$d8cc5374b8afc050);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $649f968a39271571$export$42cfcdfd4935cc23);

var $dNzn5 = parcelRequire("dNzn5");
const $649f968a39271571$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $649f968a39271571$export$e3632d3a6ee981be = 'epic.model.INVALIDATE_HELP_CENTER_RELAY_STORE';
const $649f968a39271571$export$61e2f9e78cb604c7 = (0, $dNzn5.buildModelsActionCreator)($649f968a39271571$export$5586a78b777598b9, 'sharedPortal');
const $649f968a39271571$export$d06ed959afe649d4 = ()=>({
        type: $649f968a39271571$export$e3632d3a6ee981be
    });
const $649f968a39271571$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $649f968a39271571$export$42cfcdfd4935cc23 = (0, $dNzn5.buildModelsActionCreator)($649f968a39271571$export$d8cc5374b8afc050, 'helpCenterBranding');

});


parcelRegister("WHQZk", function(module, exports) {
$parcel$export(module.exports, "fetchSpaceKeyEpic", () => $496c42ee5e399f18$export$6f464ce566402c7);

var $b0T1M = parcelRequire("b0T1M");

var $8oyTL = parcelRequire("8oyTL");
parcelRequire("35SbM");
var $dzJzK = parcelRequire("dzJzK");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");
const $496c42ee5e399f18$export$6f464ce566402c7 = (action$)=>{
    return action$.ofType((0, $dzJzK.FETCH_ARTICLE_SPACE_KEY)).mergeMap((action)=>{
        const { meta: meta } = action;
        return (0, $8oyTL.fetchArticleSpaceKey)({
            articleId: action.payload.articleId
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $dzJzK.fetchArticleSpaceKeySuccess)(response);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $dzJzK.fetchArticleSpaceKeyFailure)(action.payload.articleId, error));
        });
    });
};

});
parcelRegister("8oyTL", function(module, exports) {
$parcel$export(module.exports, "fetchArticleSpaceKey", () => $96d49bb4e14258b8$export$1bb14e9adb3b68ac);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $6mmHn = parcelRequire("6mmHn");

var $4axJ1 = parcelRequire("4axJ1");

var $yLYo1 = parcelRequire("yLYo1");

var $keOG0 = parcelRequire("keOG0");
const $96d49bb4e14258b8$var$fetchArticleSpaceKeyEndpoint = (articleId)=>{
    const activationId = (0, $6mmHn.getMeta)('activation-id');
    (0, $yLYo1.default)(activationId, 'Activation ID not available');
    return `${0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/article/${articleId || ''}`;
};
const $96d49bb4e14258b8$export$1bb14e9adb3b68ac = ({ articleId: articleId })=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)($96d49bb4e14258b8$var$fetchArticleSpaceKeyEndpoint(articleId), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        (0, $keOG0.trackError)('article.space.key.fetch.failed', {}, e);
        return (0, $b0T1M.Observable).throw(e);
    });
};

});


parcelRegister("jCsvq", function(module, exports) {
$parcel$export(module.exports, "handleAjaxErrorEpic", () => $7277c8b6e60a5a8b$export$91f7ef464c43cc97);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $fI5Sq = parcelRequire("fI5Sq");
const $7277c8b6e60a5a8b$export$91f7ef464c43cc97 = (action$)=>{
    return action$.ofType((0, $gBYjj.HANDLE_AJAX_ERROR)).mergeMap((handleAjaxErrorAction)=>{
        const { error: error } = handleAjaxErrorAction.payload;
        // TODO: Handle errors that come directly from the backend already translated (https://jdog.jira-dev.com/browse/JNW-236)
        const errorDescriptor = (0, $fI5Sq.getDefaultError)(error);
        const genericAction = errorDescriptor.action === undefined ? undefined : [
            errorDescriptor.action
        ];
        const errorFlagAction = (0, $gBYjj.showErrorFlag)(errorDescriptor.title, errorDescriptor.description, genericAction);
        return (0, $b0T1M.Observable).of(errorFlagAction);
    });
};

});

parcelRegister("55BYE", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterBrandingEpic", () => $812b17f5bb3be0da$export$dbe2bc3705ae4647);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationSuccess", () => $812b17f5bb3be0da$export$8d56a889e7db4abe);
$parcel$export(module.exports, "updateHelpCenterBrandingEpicMutationFailure", () => $812b17f5bb3be0da$export$f0ef15072aa7d01f);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $krFoK = parcelRequire("krFoK");

var $5eCdR = parcelRequire("5eCdR");

var $2U8W3 = parcelRequire("2U8W3");
parcelRequire("eicll");
var $9wmEV = parcelRequire("9wmEV");

var $6bgjt = parcelRequire("6bgjt");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $4SM7Y = parcelRequire("4SM7Y");
const $812b17f5bb3be0da$var$getAnnouncementBodyFromHCBrandingBody = (body, siteDefaultLanguageTag)=>{
    return {
        header: body.translations[siteDefaultLanguageTag].announcementHeader,
        message: body.translations[siteDefaultLanguageTag].announcementMessage
    };
};
/*
    Different APIs for admins and agents. Admins have permissions to update help center branding along
    with announcements so help center branding api is used. For the agents on the other hand announcement API is used.
    TODO: Separate out announcements from help center branding.
*/ const $812b17f5bb3be0da$var$getUpdateBrandingPromise = (body, canAdministerJira, rawBrandingResponse)=>{
    return !canAdministerJira && rawBrandingResponse ? (0, $2U8W3.updateAnnouncement)($812b17f5bb3be0da$var$getAnnouncementBodyFromHCBrandingBody(body, rawBrandingResponse.siteDefaultLanguageTag)) : (0, $2U8W3.updateBranding)(body);
};
const $812b17f5bb3be0da$export$dbe2bc3705ae4647 = (action$, store)=>{
    return action$.ofType((0, $krFoK.UPDATE_HELP_CENTER_BRANDING)).mergeMap((updateBrandingAction)=>{
        const { payload: payload, meta: meta } = updateBrandingAction;
        const { body: body } = payload;
        const state = store.getState();
        const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return $812b17f5bb3be0da$var$getUpdateBrandingPromise(body, canAdministerJira, rawBrandingResponse).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            const modifiedResponse = rawBrandingResponse ? {
                ...rawBrandingResponse,
                ...response
            } : response;
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingModelAction)(modifiedResponse)), (0, $b0T1M.Observable).of((0, $krFoK.clearHCPreviewModelAction)()));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && error.status >= 500) (0, $keOG0.legacySendEvent)((0, $4SM7Y.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $krFoK.updateBrandingFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
        });
    });
};
const $812b17f5bb3be0da$export$8d56a889e7db4abe = (action$, store)=>{
    return action$.ofType((0, $krFoK.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS)).mergeMap((updateBrandingMutationSuccessAction)=>{
        const { response: response, meta: meta } = updateBrandingMutationSuccessAction;
        const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6bgjt.updateThemeSideBarExperience).success();
        const modifiedResponse = rawBrandingResponse ? {
            ...rawBrandingResponse,
            ...response
        } : response;
        return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingModelAction)(modifiedResponse)), (0, $b0T1M.Observable).of((0, $krFoK.clearHCPreviewModelAction)()), (0, $b0T1M.Observable).of((0, $5eCdR.invalidateHelpCenterStoreAction)()));
    });
};
const $812b17f5bb3be0da$export$f0ef15072aa7d01f = (action$)=>{
    return action$.ofType((0, $krFoK.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE)).mergeMap((updateBrandingMutationFailureAction)=>{
        const { error: error, meta: meta } = updateBrandingMutationFailureAction;
        //const state = store.getState();
        // const canAdministerJira = state.persisted.user.canAdministerJIRA;
        // const rawBrandingResponse = state.persisted.helpCenter.rawBrandingResponse;
        return (0, $b0T1M.Observable).from(Promise.reject(error)).catch((err)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(err.status)) (0, $keOG0.legacySendEvent)((0, $4SM7Y.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
            if (!(0, $eo5zF.isNetworkOrClientErrorCode)(err.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $6bgjt.updateThemeSideBarExperience).failure({
                metadata: {
                    error: err.message
                }
            });
            else // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $6bgjt.updateThemeSideBarExperience).success();
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $krFoK.updateBrandingFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(err)));
        });
    });
};

});
parcelRegister("krFoK", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_PREVIEW_MODEL", () => $98033277d1306447$export$f0cfe50b4b81e5e5);
$parcel$export(module.exports, "CLEAR_HELP_CENTER_PREVIEW_MODEL", () => $98033277d1306447$export$61f6f0f25aef37a);
$parcel$export(module.exports, "EDITING_HELP_CENTER", () => $98033277d1306447$export$429f706ec067751a);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING", () => $98033277d1306447$export$e49dc7a9374bb0ed);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS", () => $98033277d1306447$export$75be5b55c825c5f4);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE", () => $98033277d1306447$export$bb6272ebd92e455f);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_FAILURE", () => $98033277d1306447$export$d249354c8afb6e40);
$parcel$export(module.exports, "UPLOAD_START", () => $98033277d1306447$export$b03358de8b670bd6);
$parcel$export(module.exports, "UPLOAD_END", () => $98033277d1306447$export$56dfdb40a4995b23);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_SAVE_START", () => $98033277d1306447$export$d6b07b90ea00e758);
$parcel$export(module.exports, "editingHelpCenter", () => $98033277d1306447$export$8f5c235cd10e8248);
$parcel$export(module.exports, "updateHCPreviewModelAction", () => $98033277d1306447$export$52aab28d032a2b51);
$parcel$export(module.exports, "clearHCPreviewModelAction", () => $98033277d1306447$export$1044307c0b2e2fc4);
$parcel$export(module.exports, "updateBranding", () => $98033277d1306447$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateBrandingMutationSuccess", () => $98033277d1306447$export$e7ca67101719c569);
$parcel$export(module.exports, "updateBrandingMutationFailure", () => $98033277d1306447$export$4522a481460f5735);
$parcel$export(module.exports, "updateBrandingSaveStart", () => $98033277d1306447$export$676616ec28a47579);
$parcel$export(module.exports, "updateBrandingFailure", () => $98033277d1306447$export$be3ae179d979bebe);
$parcel$export(module.exports, "uploadStart", () => $98033277d1306447$export$34ff845ea9831833);
$parcel$export(module.exports, "uploadEnd", () => $98033277d1306447$export$f986c9a8af4f4565);
const $98033277d1306447$export$f0cfe50b4b81e5e5 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_PREVIEW_MODEL';
const $98033277d1306447$export$61f6f0f25aef37a = 'state.ui.help-center-preview.CLEAR_HELP_CENTER_PREVIEW_MODEL';
const $98033277d1306447$export$429f706ec067751a = 'state.ui.help-center-preview.EDITING_HELP_CENTER';
const $98033277d1306447$export$e49dc7a9374bb0ed = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING';
const $98033277d1306447$export$75be5b55c825c5f4 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS';
const $98033277d1306447$export$bb6272ebd92e455f = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE';
const $98033277d1306447$export$d249354c8afb6e40 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_FAILURE';
const $98033277d1306447$export$b03358de8b670bd6 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_START';
const $98033277d1306447$export$56dfdb40a4995b23 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_UPLOAD_END';
const $98033277d1306447$export$d6b07b90ea00e758 = 'state.ui.help-center-preview.UPDATE_HELP_CENTER_BRANDING_SAVE_START';
const $98033277d1306447$export$8f5c235cd10e8248 = (isEditing)=>({
        type: $98033277d1306447$export$429f706ec067751a,
        payload: isEditing
    });
const $98033277d1306447$export$52aab28d032a2b51 = (previewPayload)=>({
        payload: previewPayload,
        type: $98033277d1306447$export$f0cfe50b4b81e5e5
    });
const $98033277d1306447$export$1044307c0b2e2fc4 = ()=>({
        type: $98033277d1306447$export$61f6f0f25aef37a
    });
const $98033277d1306447$export$eb176b496ba6ad25 = (body, meta = {})=>({
        meta: meta,
        type: $98033277d1306447$export$e49dc7a9374bb0ed,
        payload: {
            body: body
        }
    });
const $98033277d1306447$export$e7ca67101719c569 = (response, meta = {})=>({
        meta: meta,
        response: response,
        type: $98033277d1306447$export$75be5b55c825c5f4
    });
const $98033277d1306447$export$4522a481460f5735 = (error, meta = {})=>({
        meta: meta,
        error: error,
        type: $98033277d1306447$export$bb6272ebd92e455f
    });
const $98033277d1306447$export$676616ec28a47579 = ()=>({
        type: $98033277d1306447$export$d6b07b90ea00e758
    });
const $98033277d1306447$export$be3ae179d979bebe = ()=>({
        type: $98033277d1306447$export$d249354c8afb6e40
    });
const $98033277d1306447$export$34ff845ea9831833 = (fileCollection)=>({
        type: $98033277d1306447$export$b03358de8b670bd6,
        payload: {
            fileCollection: fileCollection
        }
    });
const $98033277d1306447$export$f986c9a8af4f4565 = (fileCollection)=>({
        type: $98033277d1306447$export$56dfdb40a4995b23,
        payload: {
            fileCollection: fileCollection
        }
    });

});

parcelRegister("2U8W3", function(module, exports) {
$parcel$export(module.exports, "BrandingTargetCollections", () => $15db2605cc5f874a$export$b5e98a61473b07ad);
$parcel$export(module.exports, "getUploadTokenWithClientInfo", () => $15db2605cc5f874a$export$1c22c9bf986a3d58);
$parcel$export(module.exports, "updateBranding", () => $15db2605cc5f874a$export$eb176b496ba6ad25);
$parcel$export(module.exports, "updateAnnouncement", () => $15db2605cc5f874a$export$159f65cfbafa86b5);

var $lVFX8 = parcelRequire("lVFX8");

var $63sfu = parcelRequire("63sfu");

var $6UDG7 = parcelRequire("6UDG7");

var $3wR8f = parcelRequire("3wR8f");
var $15db2605cc5f874a$export$b5e98a61473b07ad = /*#__PURE__*/ function(BrandingTargetCollections) {
    BrandingTargetCollections["banner"] = "sd-banner-upload";
    BrandingTargetCollections["logo"] = "sd-logo-upload";
    return BrandingTargetCollections;
}({});
const $15db2605cc5f874a$export$de87322aceb1e609 = async (targetCollection, context = (0, $3wR8f.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    .map((ajaxResponse)=>ajaxResponse.response.token).toPromise();
};
const $15db2605cc5f874a$export$1c22c9bf986a3d58 = async (targetCollection, context = (0, $3wR8f.contextPath))=>{
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(`${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/upload-media-token/${targetCollection}`, undefined, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).toPromise();
};
const $15db2605cc5f874a$export$eb176b496ba6ad25 = (body, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/help-center-theme-branding/with-translations`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $6UDG7.ModelsCache).getInstance().del('helpCenterBranding');
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
/*
    Map announcement response to help center branding response. Since we are using same epic and reducer for
    announcement API and help center branding API. TODO: A new epic for help center announcements.
*/ const $15db2605cc5f874a$var$mapAnnouncementResponseToHelpCenterBrandingResponse = (ajaxResponse)=>{
    let modifiedTranslations = {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = ajaxResponse.response;
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    modifiedTranslations = (0, $63sfu.mapValues)(response.translations, (translation)=>({
            announcementHeader: translation.header,
            announcementMessage: translation.message
        }));
    return {
        translations: modifiedTranslations,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementHeader: response.header,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        userInitialAnnouncementMessageWiki: response.messageWiki
    };
};
const $15db2605cc5f874a$export$159f65cfbafa86b5 = (body, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk-data/announcement/help-center`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    (0, $6UDG7.ModelsCache).getInstance().del('helpCenterBranding');
    return (0, $lVFX8.post)(uri, body, headers).map($15db2605cc5f874a$var$mapAnnouncementResponseToHelpCenterBrandingResponse);
};

});

parcelRegister("eicll", function(module, exports) {
$parcel$export(module.exports, "updateHCBrandingModelAction", () => (parcelRequire("9wmEV")).updateHCBrandingModelAction);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => (parcelRequire("9wmEV")).updateHelpCenterModelAction);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => (parcelRequire("9wmEV")).updateHCBrandingLoaderAction);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => (parcelRequire("9wmEV")).UPDATE_HELP_CENTER_BRANDING_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => (parcelRequire("9wmEV")).UPDATE_HELP_CENTER_BRANDING_LOADER);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => (parcelRequire("9wmEV")).UPDATE_HELP_CENTER_MODEL);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => (parcelRequire("9wmEV")).UPDATE_HELP_CENTER_THEME_COLOR);

var $9wmEV = parcelRequire("9wmEV");

});
parcelRegister("9wmEV", function(module, exports) {
$parcel$export(module.exports, "UPDATE_HELP_CENTER_MODEL", () => $4213b64202b4d291$export$791f10ed5ca1afbc);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_MODEL", () => $4213b64202b4d291$export$72877be1acecfff2);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_THEME_COLOR", () => $4213b64202b4d291$export$51eff4874ab833ce);
$parcel$export(module.exports, "UPDATE_HELP_CENTER_BRANDING_LOADER", () => $4213b64202b4d291$export$749d9a3565d43c74);
$parcel$export(module.exports, "updateHelpCenterModelAction", () => $4213b64202b4d291$export$9c200ab172652613);
$parcel$export(module.exports, "updateHCBrandingModelAction", () => $4213b64202b4d291$export$765a61788077a43a);
$parcel$export(module.exports, "updateHCThemeColorAction", () => $4213b64202b4d291$export$8865f165e0e8e610);
$parcel$export(module.exports, "updateHCBrandingLoaderAction", () => $4213b64202b4d291$export$b9ec760cc662cf16);
const $4213b64202b4d291$export$791f10ed5ca1afbc = 'state.persisted.help-center.UPDATE_HELP_CENTER_MODEL';
const $4213b64202b4d291$export$72877be1acecfff2 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_MODEL';
const $4213b64202b4d291$export$51eff4874ab833ce = 'state.persisted.help-center.UPDATE_HELP_CENTER_THEME_COLOR';
const $4213b64202b4d291$export$749d9a3565d43c74 = 'state.persisted.help-center.UPDATE_HELP_CENTER_BRANDING_LOADER';
const $4213b64202b4d291$export$9c200ab172652613 = (modelResponse)=>({
        payload: modelResponse,
        type: $4213b64202b4d291$export$791f10ed5ca1afbc
    });
const $4213b64202b4d291$export$765a61788077a43a = (brandingResponse)=>({
        payload: brandingResponse,
        type: $4213b64202b4d291$export$72877be1acecfff2
    });
const $4213b64202b4d291$export$8865f165e0e8e610 = (themeColorResponse)=>({
        payload: themeColorResponse,
        type: $4213b64202b4d291$export$51eff4874ab833ce
    });
const $4213b64202b4d291$export$b9ec760cc662cf16 = (loaded)=>({
        payload: {
            loaded: loaded
        },
        type: $4213b64202b4d291$export$749d9a3565d43c74
    });

});


parcelRegister("6bgjt", function(module, exports) {
$parcel$export(module.exports, "updateAnnouncementSideBarExperience", () => $fa4c6fa301735257$export$9202b582e9a7e7e5);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperience", () => $fa4c6fa301735257$export$bbfbb2132f16ad3e);
$parcel$export(module.exports, "updateThemeSideBarExperience", () => $fa4c6fa301735257$export$d4df676089e680c5);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $fa4c6fa301735257$export$9202b582e9a7e7e5 = new (0, $3odV5.UFOExperience)((0, $hWlSg.updateAnnouncementSideBarExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $fa4c6fa301735257$export$bbfbb2132f16ad3e = new (0, $3odV5.UFOExperience)((0, $hWlSg.updateLoginAnnouncementSideBarExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $fa4c6fa301735257$export$d4df676089e680c5 = new (0, $3odV5.UFOExperience)((0, $hWlSg.updateThemeSideBarExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});
parcelRegister("hWlSg", function(module, exports) {
$parcel$export(module.exports, "ProductExperienceStart", () => $c98920615b92bfb6$export$8c235a9c4b486599);
$parcel$export(module.exports, "externalLinksProductExperienceId", () => $c98920615b92bfb6$export$df6053b3f6f8746e);
$parcel$export(module.exports, "yourApprovalExperienceId", () => $c98920615b92bfb6$export$2748904bbde569a6);
$parcel$export(module.exports, "approvalStatusSectionExperienceId", () => $c98920615b92bfb6$export$53d4142e5691fc30);
$parcel$export(module.exports, "publishLayoutExperienceId", () => $c98920615b92bfb6$export$7706cfa126a5e293);
$parcel$export(module.exports, "topicsReorderExperienceId", () => $c98920615b92bfb6$export$45f14e05062fc2ca);
$parcel$export(module.exports, "helpCenterTopicsProductExperienceId", () => $c98920615b92bfb6$export$3bdaba26dccf5ee6);
$parcel$export(module.exports, "helpCenterViewHomePageExperienceId", () => $c98920615b92bfb6$export$d165863a94dcab28);
$parcel$export(module.exports, "helpCenterTopicEditExperienceId", () => $c98920615b92bfb6$export$d58e75689d75e480);
$parcel$export(module.exports, "helpCenterTopicViewExperienceId", () => $c98920615b92bfb6$export$f1ae827b1686e4b6);
$parcel$export(module.exports, "viewHomepageExperienceId", () => $c98920615b92bfb6$export$42633b810d73bab2);
$parcel$export(module.exports, "viewCustomPageExperienceId", () => $c98920615b92bfb6$export$c25f92d477e645db);
$parcel$export(module.exports, "profileExperienceId", () => $c98920615b92bfb6$export$6b7cf274ce127c6c);
$parcel$export(module.exports, "updateManageColumnsSidebarExperienceId", () => $c98920615b92bfb6$export$1d4505191d749c3);
$parcel$export(module.exports, "editHomepageExperienceId", () => $c98920615b92bfb6$export$f5b418a8fb4c2e52);
$parcel$export(module.exports, "editCustomPageExperienceId", () => $c98920615b92bfb6$export$1a5dc88687c6c743);
$parcel$export(module.exports, "searchExperienceId", () => $c98920615b92bfb6$export$8e695cad45fa9462);
$parcel$export(module.exports, "inlineSearchExperienceId", () => $c98920615b92bfb6$export$ef4e3240bcfb0749);
$parcel$export(module.exports, "helpCenterReportingExperienceId", () => $c98920615b92bfb6$export$a31e9803c7cf4e9c);
$parcel$export(module.exports, "helpCenterReportingContentGapExperienceId", () => $c98920615b92bfb6$export$a49db1fcfecaa197);
$parcel$export(module.exports, "helpCentersManagementExperienceId", () => $c98920615b92bfb6$export$28b0efc551538ce4);
$parcel$export(module.exports, "manageProjectsExperienceId", () => $c98920615b92bfb6$export$8125d660e6f5341);
$parcel$export(module.exports, "managePagesExperienceId", () => $c98920615b92bfb6$export$b3c36987f8f3e130);
$parcel$export(module.exports, "editHelpCenterExperienceId", () => $c98920615b92bfb6$export$9d36a9a1a5392695);
$parcel$export(module.exports, "avatarMenuExperienceId", () => $c98920615b92bfb6$export$ccd2c0d87dacec5b);
$parcel$export(module.exports, "updateAnnouncementSideBarExperienceId", () => $c98920615b92bfb6$export$afc2346bbf17f6dc);
$parcel$export(module.exports, "updateSinglePortalAnnouncementSideBarExperienceId", () => $c98920615b92bfb6$export$ad5e73bffe8e8683);
$parcel$export(module.exports, "updateLoginAnnouncementSideBarExperienceId", () => $c98920615b92bfb6$export$7b03636a868ec87a);
$parcel$export(module.exports, "updateThemeSideBarExperienceId", () => $c98920615b92bfb6$export$3a07bc7f4f48662a);
$parcel$export(module.exports, "requestCreateEntitlementPickerExperienceId", () => $c98920615b92bfb6$export$950826a562410f6a);
$parcel$export(module.exports, "csmContactsUFormPickerExperienceId", () => $c98920615b92bfb6$export$eb5378d79d45e2ce);
$parcel$export(module.exports, "csmViewHomepageExperienceId", () => $c98920615b92bfb6$export$cb86036c3a8f0a3d);

var $7hsFm = parcelRequire("7hsFm");
const $c98920615b92bfb6$export$8c235a9c4b486599 = (props)=>{
    const { ufoExperience: ufoExperience } = props;
    (0, $7hsFm.useUFOComponentExperience)(ufoExperience);
    return null;
};
const $c98920615b92bfb6$export$df6053b3f6f8746e = 'service-management.help-center.external-resources';
const $c98920615b92bfb6$export$2748904bbde569a6 = 'service-management.help-center.your-approval';
const $c98920615b92bfb6$export$53d4142e5691fc30 = 'service-management.help-center.approval-status-section';
const $c98920615b92bfb6$export$7706cfa126a5e293 = 'service-management.help-center.publish.layout';
const $c98920615b92bfb6$export$45f14e05062fc2ca = 'service-management.help-center.topics.reorder';
const $c98920615b92bfb6$export$3bdaba26dccf5ee6 = 'service-management.help-center.topics';
const $c98920615b92bfb6$export$d165863a94dcab28 = 'service-management.help-center.view.homepage';
const $c98920615b92bfb6$export$d58e75689d75e480 = 'service-management.help-center.topic.edit';
const $c98920615b92bfb6$export$f1ae827b1686e4b6 = 'service-management.help-center.topic.view';
const $c98920615b92bfb6$export$42633b810d73bab2 = 'service-management.help-center.advanced.homepage.view';
const $c98920615b92bfb6$export$c25f92d477e645db = 'service-management.help-center.custom.page.view';
const $c98920615b92bfb6$export$6b7cf274ce127c6c = 'service-management.help-center.profile.view';
const $c98920615b92bfb6$export$1d4505191d749c3 = 'service-management.help-center.update.manage-columns-sidebar-view';
const $c98920615b92bfb6$export$f5b418a8fb4c2e52 = 'service-management.help-center.advanced.homepage.edit';
const $c98920615b92bfb6$export$1a5dc88687c6c743 = 'service-management.help-center.custom.page.edit';
const $c98920615b92bfb6$export$8e695cad45fa9462 = 'service-management.help-center.search';
const $c98920615b92bfb6$export$ef4e3240bcfb0749 = 'service-management.help-center.inline-search';
const $c98920615b92bfb6$export$a31e9803c7cf4e9c = 'service-management.help-center.help-center-reporting';
const $c98920615b92bfb6$export$a49db1fcfecaa197 = 'service-management.help-center.help-center-reporting-content-gap';
const $c98920615b92bfb6$export$28b0efc551538ce4 = 'service-management.help-center.help-centers-management';
const $c98920615b92bfb6$export$8125d660e6f5341 = 'service-management.help-center.manage-projects';
const $c98920615b92bfb6$export$b3c36987f8f3e130 = 'service-management.help-center.manage-pages';
const $c98920615b92bfb6$export$9d36a9a1a5392695 = 'service-management.help-center.edit-details';
const $c98920615b92bfb6$export$814916ea7ef3fe17 = 'service-management.help-center.multi-hc-dropdown';
const $c98920615b92bfb6$export$ccd2c0d87dacec5b = 'service-management.help-center.avatar-menu';
const $c98920615b92bfb6$export$afc2346bbf17f6dc = 'service-management.help-center.update.announcement-sidebar';
const $c98920615b92bfb6$export$ad5e73bffe8e8683 = 'service-management.help-center.update.single-portal-announcement-sidebar';
const $c98920615b92bfb6$export$7b03636a868ec87a = 'service-management.help-center.update.login-announcement-sidebar';
const $c98920615b92bfb6$export$3a07bc7f4f48662a = 'service-management.help-center.update.theme-sidebar';
const $c98920615b92bfb6$export$950826a562410f6a = 'service-management.help-center.request-create.jsm-cs-entitlement-custom-field-load';
const $c98920615b92bfb6$export$a14ae97aa64fd38f = 'service-management.help-center.csm-help-center-form-picker';
const $c98920615b92bfb6$export$eb5378d79d45e2ce = 'service-management.help-center.csm-contact-us-form-picker';
const $c98920615b92bfb6$export$cb86036c3a8f0a3d = 'service-management.help-center.advanced.csm.homepage.view';

});
parcelRegister("7hsFm", function(module, exports) {
$parcel$export(module.exports, "useUFOComponentExperience", () => $3105bc8f3e5b1071$export$30ab340faaed55d4);

var $4fqPo = parcelRequire("4fqPo");
const $3105bc8f3e5b1071$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $4fqPo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $3105bc8f3e5b1071$export$30ab340faaed55d4 = (experience)=>{
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $3105bc8f3e5b1071$var$useConstructor(()=>experience.start());
    return null;
};

});


parcelRegister("3odV5", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $8ba622185abf1aba$export$c00d22927c60484a);

var $bjRok = parcelRequire("bjRok");
class $8ba622185abf1aba$export$c00d22927c60484a extends (0, $bjRok.UFOAbstractExperience) {
}

});
parcelRegister("bjRok", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $67fc567f60bfc517$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2OOKU = parcelRequire("2OOKU");

var $3H4LK = parcelRequire("3H4LK");

var $9w9No = parcelRequire("9w9No");

var $idbdP = parcelRequire("idbdP");

var $fITq6 = parcelRequire("fITq6");

var $2uYvC = parcelRequire("2uYvC");

var $fWi4d = parcelRequire("fWi4d");

var $hkVbV = parcelRequire("hkVbV");

var $6ZJBZ = parcelRequire("6ZJBZ");

var $bqk0v = parcelRequire("bqk0v");

var $kb0Kk = parcelRequire("kb0Kk");

var $2eiiB = parcelRequire("2eiiB");

var $bdtMB = parcelRequire("bdtMB");
const $67fc567f60bfc517$var$getPageVisibleState = ()=>{
    return !(0, $fITq6.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $6ZJBZ.PageVisibleState).VISIBLE : (0, $6ZJBZ.PageVisibleState).HIDDEN;
};
const $67fc567f60bfc517$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $bqk0v.roundPerfNow)();
};
class $67fc567f60bfc517$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $kb0Kk.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.traceContext = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $6ZJBZ.PageVisibleState).MIXED;
            (0, $hkVbV.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $67fc567f60bfc517$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $bdtMB.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $fWi4d.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $2eiiB.canTransition)(this.state, newState)) {
            (0, $fWi4d.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $kb0Kk.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $67fc567f60bfc517$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $2OOKU.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $67fc567f60bfc517$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $2uYvC.getGlobalEventStream)().push((0, $2uYvC.unsubscribeEvent)((0, $6ZJBZ.SUBSCRIBE_ALL), this.handleDoneBind));
                this.stopTrace();
                const data = await this.exportData();
                (0, $fWi4d.ufolog)('this.parent', this.parent);
                (0, $2uYvC.getGlobalEventStream)().push((0, $2uYvC.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $fWi4d.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $fWi4d.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $kb0Kk.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $67fc567f60bfc517$var$getPageVisibleState();
            (0, $hkVbV.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $fWi4d.ufolog)('subscribed', this.id);
                (0, $2uYvC.getGlobalEventStream)().push((0, $2uYvC.subscribeEvent)((0, $6ZJBZ.SUBSCRIBE_ALL), this.handleDoneBind));
            }
            this.startTrace(this.id);
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $6ZJBZ.FMP_MARK) && name !== (0, $6ZJBZ.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $fWi4d.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $67fc567f60bfc517$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $kb0Kk.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $6ZJBZ.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $6ZJBZ.INLINE_RESPONSE_MARK), timestamp);
    }
    startTrace(experienceId) {
        if ((0, $3H4LK.fg)('ufo_v1_tracing')) {
            let traceContext = (0, $9w9No.getActiveTrace)();
            if (!traceContext) {
                traceContext = {
                    traceId: (0, $9w9No.generateTraceId)(),
                    spanId: (0, $9w9No.generateSpanId)()
                };
                (0, $9w9No.setActiveTrace)(traceContext.traceId, traceContext.spanId, 'ufo_v1.' + experienceId);
            }
            this.traceContext = traceContext;
        }
    }
    stopTrace() {
        if ((0, $3H4LK.fg)('ufo_v1_tracing')) (0, $9w9No.clearActiveTrace)();
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $fWi4d.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $hkVbV.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $kb0Kk.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $kb0Kk.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $kb0Kk.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $fWi4d.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $idbdP.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig,
            ...(0, $3H4LK.fg)('ufo_v1_tracing') ? {
                traceContext: this.traceContext
            } : {}
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.traceContext = null;
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("idbdP", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $9a6a435a3983d096$export$2295b861f318254a);
// temp solution until we can get it automated
const $9a6a435a3983d096$export$2295b861f318254a = '0.1.5';

});

parcelRegister("bqk0v", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $3c3c24e3c27bc718$export$5f490af6b2b115cf);
const $3c3c24e3c27bc718$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("kb0Kk", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $d3315b909da04ade$export$81b70111112841a0);
const $d3315b909da04ade$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("2eiiB", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $f77439ea2d7da243$export$178881f329fdb81f);

var $kb0Kk = parcelRequire("kb0Kk");
const $f77439ea2d7da243$var$UFOStateAvailableTransitions = {
    [(0, $kb0Kk.UFOExperienceState).NOT_STARTED.id]: [
        (0, $kb0Kk.UFOExperienceState).STARTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).STARTED.id]: [
        (0, $kb0Kk.UFOExperienceState).IN_PROGRESS.id,
        (0, $kb0Kk.UFOExperienceState).BLOCKED.id,
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED.id,
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $kb0Kk.UFOExperienceState).FAILED.id,
        (0, $kb0Kk.UFOExperienceState).ABORTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $kb0Kk.UFOExperienceState).BLOCKED.id,
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED.id,
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $kb0Kk.UFOExperienceState).FAILED.id,
        (0, $kb0Kk.UFOExperienceState).ABORTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).BLOCKED.id]: [
        (0, $kb0Kk.UFOExperienceState).RECOVERED.id,
        (0, $kb0Kk.UFOExperienceState).ABORTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).RECOVERED.id]: [
        (0, $kb0Kk.UFOExperienceState).STARTED.id,
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED.id,
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $kb0Kk.UFOExperienceState).FAILED.id,
        (0, $kb0Kk.UFOExperienceState).ABORTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).SUCCEEDED.id]: [
        (0, $kb0Kk.UFOExperienceState).STARTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $kb0Kk.UFOExperienceState).SUCCEEDED.id,
        (0, $kb0Kk.UFOExperienceState).FAILED.id,
        (0, $kb0Kk.UFOExperienceState).ABORTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).FAILED.id]: [
        (0, $kb0Kk.UFOExperienceState).STARTED.id
    ],
    [(0, $kb0Kk.UFOExperienceState).ABORTED.id]: [
        (0, $kb0Kk.UFOExperienceState).STARTED.id
    ]
};
const $f77439ea2d7da243$export$178881f329fdb81f = (state1, state2)=>{
    return $f77439ea2d7da243$var$UFOStateAvailableTransitions[state1.id] && $f77439ea2d7da243$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});




parcelRegister("4SM7Y", function(module, exports) {
$parcel$export(module.exports, "logErrorToFailureEvent", () => $aa7a6e2be9129de7$export$7c2011d2dfcd2230);
const $aa7a6e2be9129de7$export$7c2011d2dfcd2230 = (analyticsFailureEvent, error)=>{
    analyticsFailureEvent.update((payload)=>{
        var _errorMessages;
        return {
            ...payload,
            errorMessage: error.message || error.errorMessage || ((_errorMessages = error.errorMessages) === null || _errorMessages === void 0 ? void 0 : _errorMessages.join(',')),
            status: error.status || error.statusCode
        };
    });
    return analyticsFailureEvent;
};

});


parcelRegister("5WXUY", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpEpic", () => $95081eba091542ac$export$ccd8cad10bc12583);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $ignEk = parcelRequire("ignEk");
parcelRequire("4C3Ab");
var $dSbFt = parcelRequire("dSbFt");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");

var $fI5Sq = parcelRequire("fI5Sq");
const $95081eba091542ac$export$ccd8cad10bc12583 = (action$)=>{
    return action$.ofType((0, $dSbFt.INVITED_SIGN_UP)).mergeMap((invitedSignUpAction)=>{
        const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, contactAdminsFormEnabled: contactAdminsFormEnabled, setPasswordJwt: setPasswordJwt } = invitedSignUpAction.payload;
        return (0, $ignEk.invitedSignUp)({
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            setPasswordJwt: setPasswordJwt
        }).flatMap(()=>{
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $dSbFt.invitedSignUpSuccess)()), (0, $b0T1M.Observable).of((0, $8o5VQ.loginAttempt)({
                email: email,
                password: password,
                continueParam: null
            })));
        }).catch((error)=>{
            const parsedError = (0, $fI5Sq.getDefaultSignUpError)(error, contactAdminsFormEnabled);
            return (0, $b0T1M.Observable).of((0, $dSbFt.invitedSignUpFailure)(parsedError));
        });
    });
};

});
parcelRegister("ignEk", function(module, exports) {
$parcel$export(module.exports, "invitedSignUp", () => $5441ccbb6bf8bc5a$export$3693303625071052);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $5441ccbb6bf8bc5a$export$3693303625071052 = (params)=>{
    const { portalId: portalId, email: email, fullName: fullName, password: password, token: token, username: username, setPasswordJwt: setPasswordJwt, context: context = (0, $3wR8f.contextPath) } = params;
    const uri = setPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword?jwt=${setPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/portal/${portalId}/user/setpassword`;
    const body = {
        fullName: fullName,
        password: password,
        username: username,
        email: email,
        ...token ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};

});

parcelRegister("4C3Ab", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => (parcelRequire("dSbFt")).FETCH_VISIT_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => (parcelRequire("dSbFt")).FETCH_VISIT_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => (parcelRequire("dSbFt")).FETCH_VISIT_PORTAL_FAILURE);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => (parcelRequire("dSbFt")).INVITED_SIGN_UP);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => (parcelRequire("dSbFt")).INVITED_SIGN_UP_FAILURE);
$parcel$export(module.exports, "fetchVisitPortalModel", () => (parcelRequire("dSbFt")).fetchVisitPortalModel);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => (parcelRequire("dSbFt")).fetchVisitPortalSuccess);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => (parcelRequire("dSbFt")).fetchVisitPortalFailure);
$parcel$export(module.exports, "invitedSignUp", () => (parcelRequire("dSbFt")).invitedSignUp);
$parcel$export(module.exports, "invitedSignUpSuccess", () => (parcelRequire("dSbFt")).invitedSignUpSuccess);
$parcel$export(module.exports, "invitedSignUpFailure", () => (parcelRequire("dSbFt")).invitedSignUpFailure);

var $dSbFt = parcelRequire("dSbFt");

});
parcelRegister("dSbFt", function(module, exports) {
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_MODEL", () => $9a82406e236e67fb$export$5aa92ec48cad67e1);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_SUCCESS", () => $9a82406e236e67fb$export$cd1a8438490d4c7e);
$parcel$export(module.exports, "FETCH_VISIT_PORTAL_FAILURE", () => $9a82406e236e67fb$export$7d63bf92ff546bd4);
$parcel$export(module.exports, "INVITED_SIGN_UP", () => $9a82406e236e67fb$export$10a878c7005ffa23);
$parcel$export(module.exports, "INVITED_SIGN_UP_FAILURE", () => $9a82406e236e67fb$export$fc43f808dcbef187);
$parcel$export(module.exports, "fetchVisitPortalModel", () => $9a82406e236e67fb$export$6513e51a3bb59ea8);
$parcel$export(module.exports, "fetchVisitPortalSuccess", () => $9a82406e236e67fb$export$fd6356a11ec803b4);
$parcel$export(module.exports, "fetchVisitPortalFailure", () => $9a82406e236e67fb$export$4807fff848ef2c1a);
$parcel$export(module.exports, "invitedSignUp", () => $9a82406e236e67fb$export$3693303625071052);
$parcel$export(module.exports, "invitedSignUpSuccess", () => $9a82406e236e67fb$export$a2add4c6435cf561);
$parcel$export(module.exports, "invitedSignUpFailure", () => $9a82406e236e67fb$export$7ae6305616bacef7);

var $dNzn5 = parcelRequire("dNzn5");
const $9a82406e236e67fb$export$5aa92ec48cad67e1 = 'epic.model.FETCH_VISIT_PORTAL_MODEL';
const $9a82406e236e67fb$export$cd1a8438490d4c7e = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_SUCCESS';
const $9a82406e236e67fb$export$7d63bf92ff546bd4 = 'state.persisted.visit.portal.FETCH_VISIT_PORTAL_FAILURE';
const $9a82406e236e67fb$export$10a878c7005ffa23 = 'state.ui.invited.sign.up.INVITED_SIGN_UP';
const $9a82406e236e67fb$export$6bf64c2d60f7e63d = 'state.ui.invited.sign.up.INVITED_SIGN_UP_SUCCESS';
const $9a82406e236e67fb$export$fc43f808dcbef187 = 'state.ui.invited.sign.up.INVITED_SIGN_UP_FAILURE';
const $9a82406e236e67fb$export$6513e51a3bb59ea8 = (0, $dNzn5.buildModelsActionCreator)($9a82406e236e67fb$export$5aa92ec48cad67e1, 'visitPortal');
const $9a82406e236e67fb$export$fd6356a11ec803b4 = (visitPortalResponse)=>({
        type: $9a82406e236e67fb$export$cd1a8438490d4c7e,
        payload: visitPortalResponse
    });
const $9a82406e236e67fb$export$4807fff848ef2c1a = (error)=>({
        type: $9a82406e236e67fb$export$7d63bf92ff546bd4,
        payload: {
            error: error
        }
    });
const $9a82406e236e67fb$export$3693303625071052 = (portalId, email, fullName, password, token, username, contactAdminsFormEnabled, setPasswordJwt)=>({
        type: $9a82406e236e67fb$export$10a878c7005ffa23,
        payload: {
            portalId: portalId,
            email: email,
            fullName: fullName,
            password: password,
            token: token,
            username: username,
            contactAdminsFormEnabled: contactAdminsFormEnabled,
            setPasswordJwt: setPasswordJwt
        }
    });
const $9a82406e236e67fb$export$a2add4c6435cf561 = ()=>({
        type: $9a82406e236e67fb$export$6bf64c2d60f7e63d
    });
const $9a82406e236e67fb$export$7ae6305616bacef7 = (error)=>({
        type: $9a82406e236e67fb$export$fc43f808dcbef187,
        payload: {
            error: error
        }
    });

});



parcelRegister("8ZdLN", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpacesEpic", () => $c49772386bd4f839$export$fe4c3219e901f34f);

var $b0T1M = parcelRequire("b0T1M");

var $7Snl7 = parcelRequire("7Snl7");
parcelRequire("kbOJM");
var $kJFCO = parcelRequire("kJFCO");

var $keOG0 = parcelRequire("keOG0");
const $c49772386bd4f839$export$fe4c3219e901f34f = (action$)=>action$.ofType((0, $kJFCO.FETCH_LINKED_SPACES)).mergeMap((action)=>{
        const { meta: meta } = action.payload;
        return (0, $7Snl7.fetchLinkedSpaces)().map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $kJFCO.fetchLinkedSpacesSuccess)(response.linkedSpaces.map((space)=>space.spaceKey));
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) {
                const failureEvent = meta.analyticsFailureEvent.update((payload)=>({
                        ...payload,
                        status: error.status
                    }));
                (0, $keOG0.legacySendEvent)(failureEvent);
            }
            return (0, $b0T1M.Observable).of((0, $kJFCO.fetchLinkedSpacesFailure)(error));
        });
    });

});
parcelRegister("7Snl7", function(module, exports) {
$parcel$export(module.exports, "fetchLinkedSpaces", () => $7d3d9a6c11e628b4$export$1999596e4ea30c16);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $6mmHn = parcelRequire("6mmHn");

var $4axJ1 = parcelRequire("4axJ1");

var $keOG0 = parcelRequire("keOG0");
const $7d3d9a6c11e628b4$export$1999596e4ea30c16 = ()=>{
    const activationId = (0, $6mmHn.getMeta)('activation-id');
    const uri = `${(0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/jsm-portal/linked-spaces`;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        return response;
    }).catch((e)=>{
        (0, $keOG0.trackError)('linked-spaces.fetch.failed', {}, e);
        return (0, $b0T1M.Observable).throw(e);
    });
};

});

parcelRegister("kbOJM", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => (parcelRequire("kJFCO")).FETCH_LINKED_SPACES);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => (parcelRequire("kJFCO")).FETCH_LINKED_SPACES_SUCCESS);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => (parcelRequire("kJFCO")).FETCH_LINKED_SPACES_FAILURE);
$parcel$export(module.exports, "fetchLinkedSpaces", () => (parcelRequire("kJFCO")).fetchLinkedSpaces);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => (parcelRequire("kJFCO")).fetchLinkedSpacesSuccess);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => (parcelRequire("kJFCO")).fetchLinkedSpacesFailure);

var $kJFCO = parcelRequire("kJFCO");

});
parcelRegister("kJFCO", function(module, exports) {
$parcel$export(module.exports, "FETCH_LINKED_SPACES", () => $7dc4eda19320f61d$export$3d78263a729bb91);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_SUCCESS", () => $7dc4eda19320f61d$export$55cd199355628b5a);
$parcel$export(module.exports, "FETCH_LINKED_SPACES_FAILURE", () => $7dc4eda19320f61d$export$9c186423b974805a);
$parcel$export(module.exports, "fetchLinkedSpaces", () => $7dc4eda19320f61d$export$1999596e4ea30c16);
$parcel$export(module.exports, "fetchLinkedSpacesSuccess", () => $7dc4eda19320f61d$export$ad2cc5272eef487);
$parcel$export(module.exports, "fetchLinkedSpacesFailure", () => $7dc4eda19320f61d$export$e63a5f7249c4e5d6);
const $7dc4eda19320f61d$export$3d78263a729bb91 = 'state.actions.linked-spaces.FETCH_LINKED_SPACES';
const $7dc4eda19320f61d$export$55cd199355628b5a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_SUCCESS';
const $7dc4eda19320f61d$export$9c186423b974805a = 'state.actions.linked-spaces.FETCH_LINKED_SPACES_FAILURE';
const $7dc4eda19320f61d$export$1999596e4ea30c16 = (meta)=>({
        type: $7dc4eda19320f61d$export$3d78263a729bb91,
        payload: {
            meta: meta
        }
    });
const $7dc4eda19320f61d$export$ad2cc5272eef487 = (linkedSpaces)=>({
        type: $7dc4eda19320f61d$export$55cd199355628b5a,
        payload: {
            linkedSpaces: linkedSpaces
        }
    });
const $7dc4eda19320f61d$export$e63a5f7249c4e5d6 = (error)=>({
        type: $7dc4eda19320f61d$export$9c186423b974805a,
        payload: {
            error: error
        }
    });

});



parcelRegister("5Wk6A", function(module, exports) {
$parcel$export(module.exports, "checkLoginActionEpic", () => $80aeae80fab4e151$export$f1b0b99279015d5e);

var $5geAe = parcelRequire("5geAe");

var $b0T1M = parcelRequire("b0T1M");

var $kV63N = parcelRequire("kV63N");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("3kjQH");
var $jrtA6 = parcelRequire("jrtA6");

var $fI5Sq = parcelRequire("fI5Sq");

var $2fF64 = parcelRequire("2fF64");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");

var $g01X2 = parcelRequire("g01X2");

var $Y85G3 = parcelRequire("Y85G3");
const $80aeae80fab4e151$export$f1b0b99279015d5e = (action$)=>{
    return action$.ofType((0, $8o5VQ.CHECK_LOGIN_ACTION)).mergeMap((checkLoginActionAction)=>{
        const { email: email, portalId: portalId, authData: authData, createAnalyticsEvent: createAnalyticsEvent } = checkLoginActionAction.payload;
        return (0, $2fF64.fetchAwsWafToken)(createAnalyticsEvent).mergeMap((token)=>(0, $kV63N.checkLoginAction)({
                email: email,
                authData: authData,
                awsWafToken: token
            })).flatMap((response)=>{
            const autoInfo = $80aeae80fab4e151$var$extractAuthInfoFromResponse(response);
            const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'enteredEmailAndClickedNext',
                actionSubject: 'jsmPortalUnifiedLogin',
                attributes: {
                    accountStage: autoInfo.accountStage,
                    authMethodTypes: Array.from(autoInfo.authMethods.keys())
                }
            });
            trackEvent && (0, $keOG0.legacySendEvent)(trackEvent);
            if (response.action === (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_SIGNUP) return (0, $b0T1M.Observable).of((0, $jrtA6.setSignupDataAction)(email, autoInfo)).do(()=>{
                // Make sure we set the signup state first before doing the transition
                (0, $5geAe.Scheduler).async.schedule(()=>{
                    (0, $3wR8f.default).push((0, $Y85G3.getSignupUrl)(portalId ? Number.parseInt(portalId, 10) : undefined));
                }, 0);
            });
            return (0, $b0T1M.Observable).of((0, $8o5VQ.checkLoginActionSuccess)(response.action, autoInfo));
        }).catch((error)=>{
            if ((0, $fI5Sq.isSsoTestModeError)(error)) return (0, $b0T1M.Observable).of((0, $8o5VQ.caSsoTestModeFailure)());
            const parsedError = (0, $fI5Sq.getDefaultCheckLoginError)(error);
            return (0, $b0T1M.Observable).of((0, $8o5VQ.checkLoginActionFailure)(parsedError));
        });
    });
};
const $80aeae80fab4e151$var$getAccountStage = (action)=>{
    switch(action){
        case (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $g01X2.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
            return (0, $g01X2.AccountStageType).SIGNUP;
        case (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        case (0, $g01X2.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
        default:
            return (0, $g01X2.AccountStageType).LOGIN;
    }
};
const $80aeae80fab4e151$var$extractAuthInfoFromResponse = (payload)=>{
    const { action: action, methods: methods } = payload;
    const stage = $80aeae80fab4e151$var$getAccountStage(action);
    if (methods.length === 0) // add observable
    // cleanup entire part when FF is cleaned up - Jira ticket
    switch(action){
        case (0, $g01X2.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $g01X2.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $g01X2.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {}
                    ]
                ])
            };
        case (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map([
                    [
                        (0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            };
    }
    switch(action){
        case (0, $g01X2.LoginType).ATLASSIAN_ACCOUNT_SIGNUP:
        case (0, $g01X2.LoginType).ATLASSIAN_ACCOUNT_LOGIN:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    return [
                        (0, $g01X2.AuthMethodType).ATLASSIAN_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                }))
            };
        case (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_SIGNUP:
        case (0, $g01X2.LoginType).CUSTOMER_ACCOUNT_LOGIN:
        default:
            return {
                accountStage: stage,
                authMethods: new Map(methods.map((method)=>{
                    if (method.authType === 'SSO') return [
                        (0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_SSO,
                        {
                            redirectLink: method.authUrl
                        }
                    ];
                    return [
                        (0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ];
                }))
            };
    }
};

});
parcelRegister("kV63N", function(module, exports) {
$parcel$export(module.exports, "LoginAttemptErrorType", () => $4d25d1260e8e8883$export$d265801d14b9cbd6);
$parcel$export(module.exports, "checkLoginAction", () => $4d25d1260e8e8883$export$a4840b835bebc845);
$parcel$export(module.exports, "forgotPassword", () => $4d25d1260e8e8883$export$66791fb2cfeec3e);
$parcel$export(module.exports, "createPassword", () => $4d25d1260e8e8883$export$2effc3102ad6a101);
$parcel$export(module.exports, "loginV2", () => $4d25d1260e8e8883$export$c5789ac087856ec0);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $6bGmX = parcelRequire("6bGmX");

var $kXlzl = parcelRequire("kXlzl");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $3TeDY = parcelRequire("3TeDY");

var $fVwZr = parcelRequire("fVwZr");

var $Y85G3 = parcelRequire("Y85G3");
const $4d25d1260e8e8883$var$IDENTITY_LOGIN_RETRY_DELAY_MS = 500;
const $4d25d1260e8e8883$var$IDENTITY_LOGIN_DEFAULT_MAX_RETRIES = 1;
const $4d25d1260e8e8883$var$IDENTITY_LOGIN_INCREASED_MAX_RETRIES = 2;
const $4d25d1260e8e8883$var$isRetryableError = (status)=>{
    // Retry on 5xx server errors or network errors (status 0)
    return status >= 500 || status === 0;
};
const $4d25d1260e8e8883$var$delay = (ms)=>{
    return new (0, $b0T1M.Observable)((subscriber)=>{
        const timeoutId = setTimeout(()=>{
            subscriber.next();
            subscriber.complete();
        }, ms);
        return ()=>clearTimeout(timeoutId);
    });
};
var $4d25d1260e8e8883$export$d265801d14b9cbd6 = /*#__PURE__*/ function(LoginAttemptErrorType) {
    LoginAttemptErrorType[LoginAttemptErrorType["INVALID_CREDENTIALS"] = 0] = "INVALID_CREDENTIALS";
    LoginAttemptErrorType[LoginAttemptErrorType["ACCOUNT_LOCKED_ERROR"] = 1] = "ACCOUNT_LOCKED_ERROR";
    LoginAttemptErrorType[LoginAttemptErrorType["MISC_LOGIN_ERROR"] = 2] = "MISC_LOGIN_ERROR";
    return LoginAttemptErrorType;
}({});
const $4d25d1260e8e8883$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'login',
        source: 'unknownSource'
    };
};
const $4d25d1260e8e8883$export$a4840b835bebc845 = (params)=>{
    const { email: email, authData: authData, awsWafToken: awsWafToken, context: context = (0, $3wR8f.contextPath) } = params;
    const uri = `${context}/rest/servicedesk/customer-management/1/twosteplogin/action`;
    const body = JSON.stringify({
        email: email,
        ...authData
    });
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...awsWafToken ? {
            'x-aws-waf-token': `${awsWafToken}`
        } : {},
        ...(0, $6bGmX.default).getExperiment('bypass_jsm_two_step_login_waf_challenge_js').value.value ? {
            'atl-jsm-login-challenge-bypass': true
        } : {}
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $4d25d1260e8e8883$export$66791fb2cfeec3e = (resetUrl, email, redirectUrl)=>{
    const uri = (0, $Y85G3.prependWithSlashIfAbsent)(resetUrl);
    const body = $4d25d1260e8e8883$var$createBodyForForgotPassword(email, redirectUrl);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers);
};
const $4d25d1260e8e8883$export$2effc3102ad6a101 = (resetUrl, email)=>{
    const uri = (0, $Y85G3.prependWithSlashIfAbsent)(resetUrl);
    const body = $4d25d1260e8e8883$var$createBodyForForgotPassword(email);
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers);
};
const $4d25d1260e8e8883$var$createBodyForForgotPassword = (usernameOrEmail, redirectUrl)=>{
    return JSON.stringify({
        usernameOrEmail: usernameOrEmail,
        redirectUrl: redirectUrl
    });
};
const $4d25d1260e8e8883$var$responseKeyToErrorType = (loginPayload)=>{
    if (loginPayload) switch(loginPayload.key){
        case 'invalid-user-credentials':
            return 0;
        case 'blocked-user-credentials':
            return 1;
        default:
    }
    return 2;
};
const $4d25d1260e8e8883$export$4030e1d1ae5ebd69 = (ajaxError)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const ajaxResponse = ajaxError.response;
    if (ajaxError.status === 403) {
        const errorType = $4d25d1260e8e8883$var$responseKeyToErrorType(ajaxResponse);
        if (errorType === 2) (0, $fVwZr.reportError)(ajaxError, {
            message: JSON.stringify(ajaxResponse)
        });
        return {
            loginSucceeded: false,
            error: {
                errorType: errorType
            }
        };
    }
    (0, $fVwZr.reportError)(ajaxError, {
        message: JSON.stringify(ajaxResponse)
    });
    throw ajaxError;
};
const $4d25d1260e8e8883$export$abbe0c285917a9df = ()=>`${(0, $3TeDY.origin)()}${(0, $3wR8f.getBaseName)()}${(0, $Y85G3.getHelpCenterUrl)()}`;
const $4d25d1260e8e8883$export$f7ebdb13a3e88fec = (params)=>{
    const { email: email, password: password, context: context = (0, $3wR8f.contextPath) } = params;
    const continueParam = params.continueParam ? params.continueParam : $4d25d1260e8e8883$export$abbe0c285917a9df();
    const uri = `${context}/jsd-login-v2/v2/customer/login/authenticate?continue=${continueParam}`;
    const body = {
        email: email,
        password: password
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    const envWithEdition = (0, $ebpTf.getEnv)();
    const edition = envWithEdition.edition;
    const maxRetries = (0, $6bGmX.default).checkGate('jsm_help-center_increase_login_retries') ? $4d25d1260e8e8883$var$IDENTITY_LOGIN_INCREASED_MAX_RETRIES : $4d25d1260e8e8883$var$IDENTITY_LOGIN_DEFAULT_MAX_RETRIES;
    const fireSuccessEvent = (ajaxResponse, retryCount)=>{
        (0, $kXlzl.operationalEvent)($4d25d1260e8e8883$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString(),
            traceId: ajaxResponse.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const fireErrorEvent = (ajaxError, retryCount)=>{
        const response = ajaxError.response;
        (0, $kXlzl.operationalEvent)($4d25d1260e8e8883$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            errorKey: (response === null || response === void 0 ? void 0 : response.key) || 'unknown',
            errorMessage: typeof (response === null || response === void 0 ? void 0 : response.context) === 'object' && response.context ? response.context.errorDetail || 'unknown' : 'unknown',
            traceId: ajaxError.xhr.getResponseHeader('atl-traceid') || 'unknown',
            ...edition ? {
                edition: edition
            } : {},
            retryCount: `${retryCount}`
        }));
    };
    const makeRequest = (retryCount)=>{
        return (0, $lVFX8.post)(uri, body, headers).do((ajaxResponse)=>fireSuccessEvent(ajaxResponse, retryCount), (ajaxError)=>{
            if (retryCount >= maxRetries || !$4d25d1260e8e8883$var$isRetryableError(ajaxError.status)) fireErrorEvent(ajaxError, retryCount);
        }).map(()=>({
                loginSucceeded: true,
                error: null
            })).catch((ajaxError)=>{
            if (retryCount < maxRetries && $4d25d1260e8e8883$var$isRetryableError(ajaxError.status)) return $4d25d1260e8e8883$var$delay($4d25d1260e8e8883$var$IDENTITY_LOGIN_RETRY_DELAY_MS).switchMap(()=>makeRequest(retryCount + 1));
            return (0, $b0T1M.Observable).of($4d25d1260e8e8883$export$4030e1d1ae5ebd69(ajaxError));
        });
    };
    return makeRequest(0);
};
const $4d25d1260e8e8883$export$c5789ac087856ec0 = (email, password, continueParam)=>{
    return $4d25d1260e8e8883$export$f7ebdb13a3e88fec({
        email: email,
        password: password,
        continueParam: continueParam
    });
};

});
parcelRegister("Y85G3", function(module, exports) {
$parcel$export(module.exports, "HELP_CENTER_URL", () => $552a6388380f66eb$export$5b56ffbd3ae3f811);
$parcel$export(module.exports, "getLoginUrl", () => $552a6388380f66eb$export$8abe2e83e8d74da2);
$parcel$export(module.exports, "getLoginUrlForPortalId", () => $552a6388380f66eb$export$2c3bf2ac72f35daf);
$parcel$export(module.exports, "getLoginUrlForPortalIdAsString", () => $552a6388380f66eb$export$cf0d2e77a068eb02);
$parcel$export(module.exports, "getSignupUrl", () => $552a6388380f66eb$export$61811316248f3423);
$parcel$export(module.exports, "getRedirectUrlOrLoginUrlIfNotLoggedIn", () => $552a6388380f66eb$export$e1ec45c36436315e);
$parcel$export(module.exports, "stripBasename", () => $552a6388380f66eb$export$b69e3301ce081aa3);
$parcel$export(module.exports, "getLoginUrlForTestMode", () => $552a6388380f66eb$export$538cfa4687a1dbf1);
$parcel$export(module.exports, "parseLoginSignupRedirectUrlParams", () => $552a6388380f66eb$export$63db7ca0fb70fb36);
$parcel$export(module.exports, "getManageAtlassianAccountUrl", () => $552a6388380f66eb$export$ad959f16b2c52bb0);
$parcel$export(module.exports, "getEditAccountPreferenceUrl", () => $552a6388380f66eb$export$aa7a50c8d9783676);
$parcel$export(module.exports, "getHelpCenterUrl", () => $552a6388380f66eb$export$bb97e50e9203cc1d);
$parcel$export(module.exports, "getLearnMoreUrl", () => $552a6388380f66eb$export$54cf7883df84f437);
$parcel$export(module.exports, "getPortalUrl", () => $552a6388380f66eb$export$8f6fdb27182bf17e);
$parcel$export(module.exports, "getPortalUrlWithPortalIdAsString", () => $552a6388380f66eb$export$46b08aeb2d28084e);
$parcel$export(module.exports, "prependWithSlashIfAbsent", () => $552a6388380f66eb$export$1d7449e2f82591f7);
$parcel$export(module.exports, "parseIssueKeyFromUrl", () => $552a6388380f66eb$export$286b4bf70293043b);
$parcel$export(module.exports, "getNextgenSettingsRequestTypesUrl", () => $552a6388380f66eb$export$289b05216208b30f);
$parcel$export(module.exports, "getPortalGroupSettingsUrl", () => $552a6388380f66eb$export$902d92fe4f764798);
$parcel$export(module.exports, "getRequestTypeSettingsUrl", () => $552a6388380f66eb$export$521ab03a93b5e8f0);
$parcel$export(module.exports, "isForThisJiraTenant", () => $552a6388380f66eb$export$7517f177d0bcebc3);
$parcel$export(module.exports, "getMyPendingApprovalsUrl", () => $552a6388380f66eb$export$b7fb861bceb68e9e);
$parcel$export(module.exports, "isTestModeRequested", () => $552a6388380f66eb$export$87980cf49820be56);
$parcel$export(module.exports, "getSsoTestModeParamFromUrl", () => $552a6388380f66eb$export$a992d459a03ed45d);
$parcel$export(module.exports, "convertAbsoluteUrlToRelativeUrl", () => $552a6388380f66eb$export$71e894c24943ddb2);
$parcel$export(module.exports, "getUpdatedDisplayLink", () => $552a6388380f66eb$export$1f8744d5447339dc);
$parcel$export(module.exports, "getUpdatedDisplayLinkForArticleSearch", () => $552a6388380f66eb$export$6c23a56732080745);
$parcel$export(module.exports, "getBillingUrl", () => $552a6388380f66eb$export$776b50dd35ff8711);
$parcel$export(module.exports, "formatTitleForUrl", () => $552a6388380f66eb$export$4ff2caca9bc551ab);
$parcel$export(module.exports, "getDefaultDestination", () => $552a6388380f66eb$export$3621fe01f0e72eb7);
$parcel$export(module.exports, "getContinueParam", () => $552a6388380f66eb$export$46b6a16917b33fad);
$parcel$export(module.exports, "getRedirectUrlForSignupAndResetPasswordRequestParam", () => $552a6388380f66eb$export$c20e132b33b4b975);

var $4i2V5 = parcelRequire("4i2V5");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $PL4bf = parcelRequire("PL4bf");

var $3TeDY = parcelRequire("3TeDY");

var $g01X2 = parcelRequire("g01X2");
const $552a6388380f66eb$export$5b56ffbd3ae3f811 = (0, $eSL4S.isAdvancedHelpCenter)() || (0, $eSL4S.isUnifiedHelpHelpCenter)() || (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) ? '/' : '/portals';
const $552a6388380f66eb$var$ATLASSIAN_ACCOUNT_URL = 'https://id.atlassian.com';
const $552a6388380f66eb$var$ATLASSIAN_ACCOUNT_STG_URL = 'https://id.stg.internal.atlassian.com';
const $552a6388380f66eb$var$envToAtlassianAccountUrlMap = new Map([
    [
        (0, $ebpTf.EnvType).LOCAL,
        $552a6388380f66eb$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $ebpTf.EnvType).DEV,
        $552a6388380f66eb$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $ebpTf.EnvType).STAGING,
        $552a6388380f66eb$var$ATLASSIAN_ACCOUNT_STG_URL
    ],
    [
        (0, $ebpTf.EnvType).PROD,
        $552a6388380f66eb$var$ATLASSIAN_ACCOUNT_URL
    ]
]);
const $552a6388380f66eb$export$8abe2e83e8d74da2 = (loginOptions)=>{
    return $552a6388380f66eb$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl);
};
const $552a6388380f66eb$export$2c3bf2ac72f35daf = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/login${(0, $3TeDY.search)()}` : `/user/login${(0, $3TeDY.search)()}`;
};
const $552a6388380f66eb$export$cf0d2e77a068eb02 = (portalIdAsString)=>{
    return $552a6388380f66eb$export$2c3bf2ac72f35daf($552a6388380f66eb$var$stringToNumberOrUndefined(portalIdAsString));
};
const $552a6388380f66eb$export$61811316248f3423 = (portalId)=>{
    return portalId ? `/portal/${portalId}/user/signup${(0, $3TeDY.search)()}` : `/user/signup${(0, $3TeDY.search)()}`;
};
const $552a6388380f66eb$export$e1ec45c36436315e = (redirectToLogin, url, portalId)=>{
    const strippedUrl = $552a6388380f66eb$export$b69e3301ce081aa3(url);
    if (redirectToLogin) return $552a6388380f66eb$var$internalGetLoginUrl(false, portalId, strippedUrl);
    return strippedUrl;
};
const $552a6388380f66eb$var$internalGetLoginUrl = (isAbsolute, portalId, redirectUrl)=>{
    const pathUrl = portalId ? `portal/${portalId}/user/login` : 'user/login';
    const portalUrl = isAbsolute ? `${(0, $3wR8f.getBaseName)()}/${pathUrl}` : `/${pathUrl}`;
    if (redirectUrl) {
        // trim leading slash if it is present
        const url = redirectUrl.replace(/^\/+/g, '');
        return (0, $PL4bf.addParamsToUrl)(portalUrl, {
            destination: url
        });
    }
    return portalUrl;
};
const $552a6388380f66eb$export$538cfa4687a1dbf1 = (loginOptions)=>{
    return (0, $PL4bf.addParamsToUrl)($552a6388380f66eb$var$internalGetLoginUrl(loginOptions.isAbsolute, loginOptions.portalId, loginOptions.redirectUrl), {
        [(0, $g01X2.QUERY_PARAM_SSO_TEST)]: 'true'
    });
};
const $552a6388380f66eb$export$63db7ca0fb70fb36 = ()=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsedSearchQuery = $4i2V5.parse((0, $3TeDY.search)());
    return {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        destination: parsedSearchQuery.destination,
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        isAbsolute: parsedSearchQuery.absolute === 'true'
    };
};
const $552a6388380f66eb$export$ad959f16b2c52bb0 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $PL4bf.addParamsToUrl)(url, {
        target: 'profile-visibility'
    });
};
const $552a6388380f66eb$export$aa7a50c8d9783676 = ()=>{
    const url = '/plugins/servlet/redirectToProfile';
    return (0, $PL4bf.addParamsToUrl)(url, {
        target: 'edit-preference'
    });
};
const $552a6388380f66eb$export$bb97e50e9203cc1d = ()=>{
    return $552a6388380f66eb$export$5b56ffbd3ae3f811;
};
const $552a6388380f66eb$export$54cf7883df84f437 = ()=>{
    var _envToAtlassianAccoun;
    return (_envToAtlassianAccoun = $552a6388380f66eb$var$envToAtlassianAccountUrlMap.get((0, $ebpTf.getEnv)().environment)) === null || _envToAtlassianAccoun === void 0 ? void 0 : _envToAtlassianAccoun.concat('/manage-profile/apps');
};
const $552a6388380f66eb$export$8f6fdb27182bf17e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $552a6388380f66eb$export$bb97e50e9203cc1d();
};
const $552a6388380f66eb$export$46b08aeb2d28084e = (portalId)=>{
    if (portalId) return `/portal/${portalId}`;
    return $552a6388380f66eb$export$bb97e50e9203cc1d();
};
const $552a6388380f66eb$export$b69e3301ce081aa3 = (url)=>{
    if (url) {
        const pos = url.indexOf((0, $3wR8f.getRelativeBasePath)());
        if (pos >= 0) return url.substring(pos + (0, $3wR8f.getRelativeBasePath)().length);
    }
    return url;
};
const $552a6388380f66eb$export$1ca0042661bee534 = (parameters)=>{
    const queryParameters = [
        `page=${parameters.page}`
    ];
    if (parameters.reporter) queryParameters.push(`reporter=${parameters.reporter}`);
    if (parameters.statuses) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    queryParameters.push(`statuses=${parameters.statuses}`);
    return `/user/requests?${queryParameters.join('&')}`;
};
const $552a6388380f66eb$export$1d7449e2f82591f7 = (toPrepend)=>{
    if (toPrepend.startsWith('/')) return toPrepend;
    return `/${toPrepend}`;
};
const $552a6388380f66eb$var$stringToNumberOrUndefined = (toConvert)=>toConvert === undefined ? undefined : Number(toConvert);
const $552a6388380f66eb$export$286b4bf70293043b = (url)=>{
    const jiraUrlMatch = `${(0, $3TeDY.origin)()}/browse/([A-Z][A-Z0-9_]+-\\d+)`;
    const portalUrlMatch = `${(0, $3TeDY.origin)()}${(0, $3wR8f.getRelativeBasePath)()}/portal/\\d+/([A-Z][A-Z0-9_]+-\\d+)`;
    const jiraMatch = url.match(jiraUrlMatch);
    if (jiraMatch) return jiraMatch[1];
    const portalMatch = url.match(portalUrlMatch);
    return portalMatch === null ? null : portalMatch[1];
};
// eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
const $552a6388380f66eb$var$getNextgenSettingsUrl = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/settings`;
const $552a6388380f66eb$export$718bab188935b069 = (projectKey)=>`${$552a6388380f66eb$var$getNextgenSettingsUrl(projectKey)}/language`;
const $552a6388380f66eb$export$289b05216208b30f = (projectKey)=>`${$552a6388380f66eb$var$getNextgenSettingsUrl(projectKey)}/issuetypes`;
const $552a6388380f66eb$export$c38761508d5f074d = (projectKey, requestTypeId)=>`${$552a6388380f66eb$export$289b05216208b30f(projectKey)}/${requestTypeId}`;
const $552a6388380f66eb$export$902d92fe4f764798 = (projectKey)=>`${$552a6388380f66eb$var$getNextgenSettingsUrl(projectKey)}/portal-settings/portal-groups`;
const $552a6388380f66eb$export$521ab03a93b5e8f0 = (projectKey, requestTypeId)=>`${$552a6388380f66eb$var$getNextgenSettingsUrl(projectKey)}/request-types/category/service-requests/request-type/${requestTypeId}/request-form`;
const $552a6388380f66eb$export$7517f177d0bcebc3 = (url, jiraBaseUrl)=>{
    return url.startsWith(jiraBaseUrl);
};
const $552a6388380f66eb$export$b7fb861bceb68e9e = ()=>{
    return `/user/approvals?approvalQueryType=myPending&page=1`;
};
const $552a6388380f66eb$export$87980cf49820be56 = (ssoTest)=>{
    return ssoTest === 'true';
};
const $552a6388380f66eb$export$a992d459a03ed45d = (params)=>{
    return params.get((0, $g01X2.QUERY_PARAM_SSO_TEST)) === 'true';
};
const $552a6388380f66eb$export$a1cbf2de32a9fd1 = (url)=>{
    if (decodeURIComponent(url).startsWith('//')) return false;
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $552a6388380f66eb$export$71e894c24943ddb2 = (url)=>{
    if ($552a6388380f66eb$export$a1cbf2de32a9fd1(url)) return url.replace(`${new URL(url).origin}`, '') || '/';
    return url;
};
const $552a6388380f66eb$export$1f8744d5447339dc = (displayLink)=>{
    const isBasicHCRegex = /\/servicedesk\/customer\/.+/;
    if ((0, $eSL4S.isAdvancedHelpCenter)() && isBasicHCRegex.test(displayLink) && !$552a6388380f66eb$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace('/servicedesk/customer/', '/');
    return displayLink;
};
const $552a6388380f66eb$export$6c23a56732080745 = (displayLink)=>{
    if ((0, $eSL4S.isAdvancedHelpCenter)() && displayLink.includes('/servicedesk/customer/') && $552a6388380f66eb$export$a1cbf2de32a9fd1(displayLink)) return displayLink.replace(/.+\/servicedesk\/customer\//, `${(0, $3wR8f.getRelativeBasePath)()}/`);
    return displayLink;
};
const $552a6388380f66eb$var$ADMIN_STAGING_URL = 'http://admin.stg.atlassian.com';
const $552a6388380f66eb$var$ADMIN_PROD_URL = 'https://admin.atlassian.com';
const $552a6388380f66eb$export$1cfdf9a01e3f7773 = ()=>window.location.host.includes('-dev.com') ? false : true;
const $552a6388380f66eb$export$995f5f30765d3edb = $552a6388380f66eb$export$1cfdf9a01e3f7773() ? $552a6388380f66eb$var$ADMIN_PROD_URL : $552a6388380f66eb$var$ADMIN_STAGING_URL;
const $552a6388380f66eb$export$776b50dd35ff8711 = (products, cloudId)=>{
    const baseUrl = `${$552a6388380f66eb$export$995f5f30765d3edb}/s/${cloudId}`;
    return products.length === 1 ? `${baseUrl}/billing/applications/change-edition/${products[0]}.ondemand` : `${baseUrl}/billing-preview`;
};
const $552a6388380f66eb$export$4ff2caca9bc551ab = (title)=>{
    return title.trim().replace(/[^a-zA-Z0-9]+/g, '+').replace(/^(?:\++)|(?:\++)$/g, '');
};
const $552a6388380f66eb$export$3621fe01f0e72eb7 = (portalId)=>{
    if (portalId) return `portal/${portalId}`;
    return $552a6388380f66eb$export$bb97e50e9203cc1d().replace(/\//g, '');
};
const $552a6388380f66eb$export$46b6a16917b33fad = (portalId)=>{
    const { destination: destination, isAbsolute: isAbsolute } = $552a6388380f66eb$export$63db7ca0fb70fb36();
    const prefix = destination && isAbsolute ? '' : `${(0, $3TeDY.origin)()}${(0, $3wR8f.getBaseName)()}/`;
    const continueParam = `${prefix}${destination || $552a6388380f66eb$export$3621fe01f0e72eb7(portalId)}`;
    return `${continueParam}`;
};
const $552a6388380f66eb$export$c20e132b33b4b975 = (baseUrl)=>{
    const { destination: destination } = $552a6388380f66eb$export$63db7ca0fb70fb36();
    if (destination && ($552a6388380f66eb$export$7517f177d0bcebc3(destination, baseUrl) || !$552a6388380f66eb$export$a1cbf2de32a9fd1(destination))) return destination;
    return undefined;
};

});
parcelRegister("g01X2", function(module, exports) {
$parcel$export(module.exports, "AccountStageType", () => $6cf5f9eb0478ea04$export$fcf6b116730276db);
$parcel$export(module.exports, "AuthMethodType", () => $6cf5f9eb0478ea04$export$ccd4174b7ee5aaf9);
$parcel$export(module.exports, "LoginType", () => $6cf5f9eb0478ea04$export$7ecae1a0f094da22);
$parcel$export(module.exports, "QUERY_PARAM_SSO_TEST", () => $6cf5f9eb0478ea04$export$491b9d320a651537);
// eslint-disable-next-line no-shadow
var $6cf5f9eb0478ea04$export$fcf6b116730276db = /*#__PURE__*/ function(AccountStageType) {
    AccountStageType["LOGIN"] = "LOGIN";
    AccountStageType["SIGNUP"] = "SIGNUP";
    return AccountStageType;
}({});
var $6cf5f9eb0478ea04$export$ccd4174b7ee5aaf9 = /*#__PURE__*/ function(AuthMethodType) {
    AuthMethodType["CUSTOMER_ACCOUNT_PASSWORD"] = "CUSTOMER_ACCOUNT_PASSWORD";
    AuthMethodType["CUSTOMER_ACCOUNT_SSO"] = "CUSTOMER_ACCOUNT_SSO";
    AuthMethodType["ATLASSIAN_ACCOUNT_SSO"] = "ATLASSIAN_ACCOUNT_SSO";
    return AuthMethodType;
}({});
var $6cf5f9eb0478ea04$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["ATLASSIAN_ACCOUNT_LOGIN"] = "atlassian.account.login";
    LoginType["ATLASSIAN_ACCOUNT_SIGNUP"] = "atlassian.account.signup";
    LoginType["CUSTOMER_ACCOUNT_LOGIN"] = "customer.account.login";
    LoginType["CUSTOMER_ACCOUNT_SIGNUP"] = "customer.account.signup";
    return LoginType;
}({});
const $6cf5f9eb0478ea04$export$491b9d320a651537 = 'sso_test';

});



parcelRegister("3kjQH", function(module, exports) {
$parcel$export(module.exports, "enableResendValidationEmailLink", () => (parcelRequire("jrtA6")).enableResendValidationEmailLink);
$parcel$export(module.exports, "resendValidationEmail", () => (parcelRequire("jrtA6")).resendValidationEmail);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => (parcelRequire("jrtA6")).resendValidationEmailSuccess);
$parcel$export(module.exports, "resendValidationEmailFailure", () => (parcelRequire("jrtA6")).resendValidationEmailFailure);
$parcel$export(module.exports, "setSignupDataAction", () => (parcelRequire("jrtA6")).setSignupDataAction);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => (parcelRequire("jrtA6")).ENABLE_RESEND_VALIDATION_EMAIL_LINK);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => (parcelRequire("jrtA6")).RESEND_VALIDATION_EMAIL);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => (parcelRequire("jrtA6")).RESEND_VALIDATION_EMAIL_SUCCESS);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => (parcelRequire("jrtA6")).RESEND_VALIDATION_EMAIL_FAILURE);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => (parcelRequire("jrtA6")).SET_SIGN_UP_DATA);

var $jrtA6 = parcelRequire("jrtA6");

});
parcelRegister("jrtA6", function(module, exports) {
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL", () => $27ff0efe66758629$export$9186eb7b1196909f);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_SUCCESS", () => $27ff0efe66758629$export$54095a5808d614c5);
$parcel$export(module.exports, "RESEND_VALIDATION_EMAIL_FAILURE", () => $27ff0efe66758629$export$bb70263db5ecc48f);
$parcel$export(module.exports, "ENABLE_RESEND_VALIDATION_EMAIL_LINK", () => $27ff0efe66758629$export$1f3acfffff4b90ca);
$parcel$export(module.exports, "SET_SIGN_UP_DATA", () => $27ff0efe66758629$export$b5da7c907fc7ff71);
$parcel$export(module.exports, "resendValidationEmail", () => $27ff0efe66758629$export$b53bc6c531462e2c);
$parcel$export(module.exports, "resendValidationEmailSuccess", () => $27ff0efe66758629$export$5e093ceac56a577c);
$parcel$export(module.exports, "resendValidationEmailFailure", () => $27ff0efe66758629$export$49a7f6865c86a52a);
$parcel$export(module.exports, "enableResendValidationEmailLink", () => $27ff0efe66758629$export$bfd31929fb03dc3a);
$parcel$export(module.exports, "setSignupDataAction", () => $27ff0efe66758629$export$b9b1c14c91a0ee7a);
const $27ff0efe66758629$export$9186eb7b1196909f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL';
const $27ff0efe66758629$export$54095a5808d614c5 = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_SUCCESS';
const $27ff0efe66758629$export$bb70263db5ecc48f = 'epic.persisted.signup.RESEND_VALIDATION_EMAIL_FAILURE';
const $27ff0efe66758629$export$1f3acfffff4b90ca = 'epic.persisted.signup.ENABLE_RESEND_VALIDATION_EMAIL_LINK';
const $27ff0efe66758629$export$b5da7c907fc7ff71 = 'epic.persisted.signup.SET_SIGN_UP_DATA';
const $27ff0efe66758629$export$b53bc6c531462e2c = (email, portalId, redirectUrl)=>({
        type: $27ff0efe66758629$export$9186eb7b1196909f,
        payload: {
            email: email,
            portalId: portalId,
            redirectUrl: redirectUrl
        }
    });
const $27ff0efe66758629$export$5e093ceac56a577c = ()=>({
        type: $27ff0efe66758629$export$54095a5808d614c5
    });
const $27ff0efe66758629$export$49a7f6865c86a52a = ()=>({
        type: $27ff0efe66758629$export$bb70263db5ecc48f
    });
const $27ff0efe66758629$export$bfd31929fb03dc3a = ()=>({
        type: $27ff0efe66758629$export$1f3acfffff4b90ca
    });
const $27ff0efe66758629$export$b9b1c14c91a0ee7a = (email, authInfo)=>({
        type: $27ff0efe66758629$export$b5da7c907fc7ff71,
        payload: {
            email: email,
            authInfo: authInfo
        }
    });

});


parcelRegister("2fF64", function(module, exports) {
$parcel$export(module.exports, "fetchAwsWafToken", () => $82a6c587625f9265$export$408b4a82d889c63b);

var $b0T1M = parcelRequire("b0T1M");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");
const $82a6c587625f9265$export$408b4a82d889c63b = (createAnalyticsEvent)=>{
    try {
        if (typeof AwsWafIntegration !== 'undefined' && typeof AwsWafIntegration.getToken === 'function') return (0, $b0T1M.Observable).from(AwsWafIntegration.getToken());
        $82a6c587625f9265$var$sendFailToFetchWafTokenEvent("js.not.load", createAnalyticsEvent);
        return (0, $b0T1M.Observable).of(undefined);
    } catch (error) {
        $82a6c587625f9265$var$sendFailToFetchWafTokenEvent("unknown.error", createAnalyticsEvent);
        return (0, $b0T1M.Observable).of(undefined);
    }
};
const $82a6c587625f9265$var$sendFailToFetchWafTokenEvent = (failureType, createAnalyticsEvent)=>{
    const trackEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
        analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
        action: 'failed',
        actionSubject: 'fetchWafToken',
        attributes: {
            failureType: failureType
        }
    });
    trackEvent && (0, $keOG0.legacySendEvent)(trackEvent);
};

});


parcelRegister("5r3Gl", function(module, exports) {
$parcel$export(module.exports, "createPasswordEpic", () => $7602b4c03acc1aa5$export$4f23d4ad55796890);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $kV63N = parcelRequire("kV63N");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
const $7602b4c03acc1aa5$export$4f23d4ad55796890 = (action$)=>{
    return action$.ofType((0, $8o5VQ.CREATE_PASSWORD)).mergeMap((createPasswordAction)=>{
        const { resetUrl: resetUrl, email: email } = createPasswordAction.payload;
        return (0, $kV63N.createPassword)(resetUrl, email).map(()=>{
            return (0, $8o5VQ.createPasswordSuccess)();
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("6SvHM", function(module, exports) {
$parcel$export(module.exports, "exitTestModeEpic", () => $83c1ef88c3113444$export$2da1b652de0f5c38);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");

var $3wR8f = parcelRequire("3wR8f");

var $Y85G3 = parcelRequire("Y85G3");

var $aKXUg = parcelRequire("aKXUg");
const $83c1ef88c3113444$export$2da1b652de0f5c38 = (action$)=>{
    return action$.ofType((0, $8o5VQ.EXIT_TEST_MODE_ACTION)).mergeMap((exitTestModeAction)=>{
        const { email: email } = exitTestModeAction.payload;
        return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $8o5VQ.resetLogin)(email)), (0, $b0T1M.Observable).of((0, $gBYjj.showSuccessFlag)((0, $aKXUg.default).exitTestModeSuccessFlagTitle, undefined, (0, $aKXUg.default).exitTestModeSuccessFlagDescription, undefined, {
            emailAddress: email
        }))).do(()=>{
            (0, $3wR8f.default).push((0, $Y85G3.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
        });
    });
};

});
parcelRegister("aKXUg", function(module, exports) {
$parcel$export(module.exports, "default", () => $83b60ba39a70a578$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $83b60ba39a70a578$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    exitTestModeSuccessFlagTitle: {
        defaultMessage: "You\u2019re out of single sign-on test mode",
        description: 'Message title for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.title'
    },
    exitTestModeSuccessFlagDescription: {
        defaultMessage: 'Go to the Authentication page in your Jira settings to enable single sign-on for customers.',
        description: 'Message description for toast flag when the exit testMode action is successful.',
        id: 'cv.login.exit.test.mode.success.flag.description'
    }
});

});


parcelRegister("1sxKu", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $35e56e207c61e589$export$cb36b6e8b9a45314);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $kV63N = parcelRequire("kV63N");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
const $35e56e207c61e589$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $8o5VQ.FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, redirectUrl: redirectUrl } = forgotPasswordAction.payload;
        return (0, $kV63N.forgotPassword)(resetUrl, email, redirectUrl).map(()=>{
            return (0, $8o5VQ.forgotPasswordSuccess)();
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error));
        });
    });
};

});

parcelRegister("b1oBD", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $694aa6f4363e7253$export$da8045e9cad7ec9b);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $kV63N = parcelRequire("kV63N");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");

var $fI5Sq = parcelRequire("fI5Sq");
const $694aa6f4363e7253$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $8o5VQ.LOGIN_ATTEMPT)).mergeMap((loginAction)=>{
        const { email: email, password: password, continueParam: continueParam } = loginAction.payload;
        const loginResponse = (0, $kV63N.loginV2)(email, password, continueParam);
        return loginResponse.flatMap((response)=>{
            if (response.loginSucceeded) return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $8o5VQ.loginAttemptSuccess)(response)), (0, $b0T1M.Observable).of((0, $3R99L.successfullyLoggedIn)()));
            return (0, $b0T1M.Observable).of((0, $8o5VQ.loginAttemptSuccess)(response));
        }).catch((error)=>{
            const parsedError = (0, $fI5Sq.getDefaultError)(error);
            return (0, $b0T1M.Observable).of((0, $8o5VQ.loginAttemptFailure)(parsedError));
        });
    });
};

});

parcelRegister("1Werj", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsEpic", () => $6137335b6334ed16$export$2bd3c7829bd01a9c);

var $748yq = parcelRequire("748yq");

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");
parcelRequire("5raaz");
var $bK3LM = parcelRequire("bK3LM");

var $6bgjt = parcelRequire("6bgjt");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $grJV8 = parcelRequire("grJV8");

var $4SM7Y = parcelRequire("4SM7Y");
const $6137335b6334ed16$var$gqlMutationLoginAnnouncements = (action)=>{
    var _inputVariables$input, _inputVariables$input2;
    const { meta: meta, payload: payload } = action;
    const inputVariables = (0, $grJV8.mapLoginAnnouncementsPayloadToGqlInput)(payload);
    if (!((_inputVariables$input = inputVariables.input.nameTranslations) !== null && _inputVariables$input !== void 0 && _inputVariables$input.every((translation)=>translation.locale)) || !((_inputVariables$input2 = inputVariables.input.descriptionTranslations) !== null && _inputVariables$input2 !== void 0 && _inputVariables$input2.every((translation)=>translation.locale))) {
        // making sure that empty locale is not sent to the server
        const errorResponse = {
            status: (0, $748yq.HTTP).BAD_REQUEST
        };
        return (0, $b0T1M.Observable).from(Promise.reject(errorResponse)).catch((error)=>{
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $bK3LM.updateLoginAnnouncementsFailure)(errorResponse)), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
        });
    }
    return (0, $b0T1M.Observable).from((0, $grJV8.updateLoginAnnouncementsData)(inputVariables).then((response)=>{
        var _response$helpCenter, _response$helpCenter2, _response$helpCenter3;
        if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateLoginAnnouncement) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) // incase of mutation success, we get success as true and no errors
        return true;
        // we get success as false and errors in case of mutation failure
        const errorResponse = {
            errorMessages: ((_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateLoginAnnouncement) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.errors) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.map((error)=>error.message ?? '')) ?? [],
            status: ((_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateLoginAnnouncement) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.errors) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3[0]) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.extensions) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.statusCode) ?? (0, $748yq.HTTP).SERVER
        };
        return Promise.reject(errorResponse);
    })).flatMap(()=>{
        if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6bgjt.updateLoginAnnouncementSideBarExperience).success();
        // unlink model mutation call, we do not get login announcements in response, hence using payload to call updateLoginAnnouncementsSuccess
        return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $bK3LM.updateLoginAnnouncementsSuccess)(payload)), (0, $b0T1M.Observable).of((0, $bK3LM.resetLoginAnnouncements)()));
    }).catch((error)=>{
        if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)((0, $4SM7Y.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
        if (!(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6bgjt.updateLoginAnnouncementSideBarExperience).failure({
            metadata: {
                error: error.message
            }
        });
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6bgjt.updateLoginAnnouncementSideBarExperience).success();
        // we are mapping the error, because mutation error in not always in form of AjaxError
        const errorResponse = {
            ...error,
            errorMessages: [
                error.message
            ],
            status: error.status ?? (0, $748yq.HTTP).SERVER
        };
        return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $bK3LM.updateLoginAnnouncementsFailure)(errorResponse)), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(errorResponse)));
    });
};
const $6137335b6334ed16$export$2bd3c7829bd01a9c = (action$)=>{
    return action$.ofType((0, $bK3LM.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL)).mergeMap((action)=>{
        return $6137335b6334ed16$var$gqlMutationLoginAnnouncements(action);
    });
};

});
parcelRegister("5raaz", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => (parcelRequire("bK3LM")).fetchLoginAnnouncementModel);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("bK3LM")).FETCH_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("bK3LM")).FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("bK3LM")).FETCH_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => (parcelRequire("bK3LM")).fetchLoginAnnouncementsSuccess);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => (parcelRequire("bK3LM")).fetchLoginAnnouncementsFailure);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => (parcelRequire("bK3LM")).UPDATE_LOGIN_ANNOUNCEMENTS_MODEL);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => (parcelRequire("bK3LM")).UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => (parcelRequire("bK3LM")).UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("bK3LM")).UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => (parcelRequire("bK3LM")).RESET_LOGIN_ANNOUNCEMENTS);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => (parcelRequire("bK3LM")).updateLoginAnnouncementsModel);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => (parcelRequire("bK3LM")).updateLoginAnnouncementsSuccess);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => (parcelRequire("bK3LM")).updateLoginAnnouncementsFailure);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => (parcelRequire("bK3LM")).updateLoginAnnouncementsUIState);
$parcel$export(module.exports, "resetLoginAnnouncements", () => (parcelRequire("bK3LM")).resetLoginAnnouncements);

var $bK3LM = parcelRequire("bK3LM");

});
parcelRegister("bK3LM", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS", () => $3a19dc797b17e5af$export$dc62bc08b47f80d);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $3a19dc797b17e5af$export$b975358f73425401);
$parcel$export(module.exports, "FETCH_LOGIN_ANNOUNCEMENTS_FAILURE", () => $3a19dc797b17e5af$export$182afe1fbca9c1ad);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_MODEL", () => $3a19dc797b17e5af$export$ebcd8b9795616937);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE", () => $3a19dc797b17e5af$export$85451866d84a5811);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS", () => $3a19dc797b17e5af$export$bca8bb13b9278354);
$parcel$export(module.exports, "UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE", () => $3a19dc797b17e5af$export$12b5ff9da9aaaa28);
$parcel$export(module.exports, "RESET_LOGIN_ANNOUNCEMENTS", () => $3a19dc797b17e5af$export$2ef132370a38839c);
$parcel$export(module.exports, "fetchLoginAnnouncementModel", () => $3a19dc797b17e5af$export$2510bc335620bfa4);
$parcel$export(module.exports, "fetchLoginAnnouncementsSuccess", () => $3a19dc797b17e5af$export$66b083401f2dd420);
$parcel$export(module.exports, "fetchLoginAnnouncementsFailure", () => $3a19dc797b17e5af$export$b7ec07a46de8ffd1);
$parcel$export(module.exports, "updateLoginAnnouncementsModel", () => $3a19dc797b17e5af$export$c139274c332846b7);
$parcel$export(module.exports, "updateLoginAnnouncementsSuccess", () => $3a19dc797b17e5af$export$1723ccec0130d524);
$parcel$export(module.exports, "updateLoginAnnouncementsFailure", () => $3a19dc797b17e5af$export$682d06bd9eef1572);
$parcel$export(module.exports, "updateLoginAnnouncementsUIState", () => $3a19dc797b17e5af$export$5b3b63a7f806c6d8);
$parcel$export(module.exports, "resetLoginAnnouncements", () => $3a19dc797b17e5af$export$c992a3f94eef7527);

var $dNzn5 = parcelRequire("dNzn5");
const $3a19dc797b17e5af$export$dc62bc08b47f80d = 'epic.model.FETCH_LOGIN_ANNOUNCEMENTS';
const $3a19dc797b17e5af$export$b975358f73425401 = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $3a19dc797b17e5af$export$182afe1fbca9c1ad = 'state.persisted.loginAnnouncements.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE';
const $3a19dc797b17e5af$export$ebcd8b9795616937 = 'epic.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL';
const $3a19dc797b17e5af$export$85451866d84a5811 = 'state.ui.login-announcements.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE';
const $3a19dc797b17e5af$export$bca8bb13b9278354 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS';
const $3a19dc797b17e5af$export$12b5ff9da9aaaa28 = 'state.persisted.loginAnnouncements.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE';
const $3a19dc797b17e5af$export$2ef132370a38839c = 'state.ui.loginAnnouncements.RESET_LOGIN_ANNOUNCEMENTS';
const $3a19dc797b17e5af$export$2510bc335620bfa4 = (0, $dNzn5.buildModelsActionCreator)($3a19dc797b17e5af$export$dc62bc08b47f80d, 'loginAnnouncements');
const $3a19dc797b17e5af$export$66b083401f2dd420 = (loginAnnouncementsModel)=>({
        type: $3a19dc797b17e5af$export$b975358f73425401,
        payload: loginAnnouncementsModel
    });
const $3a19dc797b17e5af$export$b7ec07a46de8ffd1 = (error)=>({
        type: $3a19dc797b17e5af$export$182afe1fbca9c1ad,
        payload: {
            error: error
        }
    });
const $3a19dc797b17e5af$export$c139274c332846b7 = (loginAnnouncementsModel, meta)=>({
        meta: meta,
        type: $3a19dc797b17e5af$export$ebcd8b9795616937,
        payload: loginAnnouncementsModel
    });
const $3a19dc797b17e5af$export$1723ccec0130d524 = (loginAnnouncementsModel)=>({
        type: $3a19dc797b17e5af$export$bca8bb13b9278354,
        payload: loginAnnouncementsModel
    });
const $3a19dc797b17e5af$export$682d06bd9eef1572 = (error)=>({
        type: $3a19dc797b17e5af$export$12b5ff9da9aaaa28,
        payload: {
            error: error
        }
    });
const $3a19dc797b17e5af$export$5b3b63a7f806c6d8 = (loginAnnouncementsModel)=>({
        type: $3a19dc797b17e5af$export$85451866d84a5811,
        payload: loginAnnouncementsModel
    });
const $3a19dc797b17e5af$export$c992a3f94eef7527 = ()=>({
        type: $3a19dc797b17e5af$export$2ef132370a38839c
    });

});


parcelRegister("grJV8", function(module, exports) {
$parcel$export(module.exports, "updateLoginAnnouncementsData", () => $b3f2fd6d58aee5d7$export$40a99b486fb0f5fd);
$parcel$export(module.exports, "mapLoginAnnouncementsPayloadToGqlInput", () => $b3f2fd6d58aee5d7$export$85e7a57e62ad0fbc);

var $gbYIh = parcelRequire("gbYIh");

var $f2UoR = parcelRequire("f2UoR");

var $6mmHn = parcelRequire("6mmHn");

var $4Ysr0 = parcelRequire("4Ysr0");
const $b3f2fd6d58aee5d7$export$40a99b486fb0f5fd = (variables)=>{
    return new Promise((resolve, reject)=>{
        (0, $f2UoR.commitMutation)((0, $4Ysr0.getRelayEnvironment)(), {
            variables: variables,
            mutation: (0, $gbYIh.default),
            onCompleted: (response)=>{
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
};
const $b3f2fd6d58aee5d7$export$85e7a57e62ad0fbc = (payload)=>{
    const nameTranslations = [];
    const descriptionTranslations = [];
    // map payload to gql input
    Object.keys(payload.translatedLogInAnnouncements).forEach((locale)=>{
        nameTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].header
        });
        descriptionTranslations.push({
            locale: locale,
            value: payload.translatedLogInAnnouncements[locale].message
        });
    });
    return {
        cloudId: (0, $6mmHn.getCloudId)(),
        input: {
            nameTranslations: nameTranslations,
            descriptionTranslations: descriptionTranslations,
            helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
            descriptionType: 'WIKI_MARKUP'
        }
    };
};

});
parcelRegister("gbYIh", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ec1df75cd151393$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a43a0b0a9899057b05221c5b213a09fa>>
 * @relayHash d08d5aad8dde8629cc060f7256c65f6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c
const $8ec1df75cd151393$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterAnnouncementUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateLoginAnnouncement",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "12622079dcdaf3db5d698493bb7d1443dbaf69551d80a2467f5a3d4c6a9a666c",
            "metadata": {},
            "name": "loginAnnouncementsUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$8ec1df75cd151393$var$node.hash = "a5dd7f4861ac93d9b41cc3104b2a0e6a";
var $8ec1df75cd151393$export$2e2bcd8739ae039 = $8ec1df75cd151393$var$node;

});



parcelRegister("cTFGY", function(module, exports) {
$parcel$export(module.exports, "loginConsentEpic", () => $0db251ab7842431a$export$90c588d343cf5f98);

var $b0T1M = parcelRequire("b0T1M");

var $gkluK = parcelRequire("gkluK");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("kTw6N");
var $4HeWZ = parcelRequire("4HeWZ");

var $3wR8f = parcelRequire("3wR8f");

var $3TeDY = parcelRequire("3TeDY");

var $Y85G3 = parcelRequire("Y85G3");
const $0db251ab7842431a$export$90c588d343cf5f98 = (action$)=>{
    return action$.ofType((0, $4HeWZ.LOGIN_CONSENT)).mergeMap((action)=>{
        const { param: param } = action.payload;
        return (0, $gkluK.loginConsent)(param).mergeMap(({ response: response })=>{
            (0, $3TeDY.replace)(response.uri);
            return (0, $b0T1M.Observable).empty();
        }).catch(()=>{
            (0, $3wR8f.default).push((0, $Y85G3.getLoginUrl)({
                isAbsolute: false,
                portalId: undefined
            }));
            return (0, $b0T1M.Observable).of((0, $8o5VQ.loginConsentFailure)());
        });
    });
};

});
parcelRegister("gkluK", function(module, exports) {
$parcel$export(module.exports, "loginConsent", () => $0b068018c4ca6f0e$export$fd88d7fe0deeba34);

var $lVFX8 = parcelRequire("lVFX8");
const $0b068018c4ca6f0e$export$fd88d7fe0deeba34 = (param)=>{
    const uri = `/jsd-login-v2/v2/customer/login/fedramp/consent${param}`;
    const body = {
        fedrampConsent: 'provided'
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers);
};

});

parcelRegister("kTw6N", function(module, exports) {
$parcel$export(module.exports, "loginConsentAction", () => (parcelRequire("4HeWZ")).loginConsentAction);
$parcel$export(module.exports, "LOGIN_CONSENT", () => (parcelRequire("4HeWZ")).LOGIN_CONSENT);

var $4HeWZ = parcelRequire("4HeWZ");

});
parcelRegister("4HeWZ", function(module, exports) {
$parcel$export(module.exports, "LOGIN_CONSENT", () => $9d63faf06ce1df89$export$12110c14f93a926f);
$parcel$export(module.exports, "loginConsentAction", () => $9d63faf06ce1df89$export$684d17f74d8831a7);
const $9d63faf06ce1df89$export$12110c14f93a926f = 'state.ui.LOGIN_CONSENT';
const $9d63faf06ce1df89$export$684d17f74d8831a7 = (param)=>{
    return {
        payload: {
            param: param
        },
        type: $9d63faf06ce1df89$export$12110c14f93a926f
    };
};

});



parcelRegister("exHYR", function(module, exports) {
$parcel$export(module.exports, "logOutEpic", () => $1688d417e17de9e8$export$c4456f69976aae9b);

var $b0T1M = parcelRequire("b0T1M");

var $fgWTm = parcelRequire("fgWTm");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");

var $jhBPy = parcelRequire("jhBPy");

var $3TeDY = parcelRequire("3TeDY");

var $Y85G3 = parcelRequire("Y85G3");

var $fVVtD = parcelRequire("fVVtD");
const $1688d417e17de9e8$var$AA_LOGOUT_REDIRECT_URL = `/logout?dest-url=${encodeURIComponent(`${(0, $3wR8f.getRelativeBasePath)()}${(0, $Y85G3.getHelpCenterUrl)()}`)}`;
const $1688d417e17de9e8$export$8931338e80b3349d = (state)=>{
    if ((0, $2hx7o.isAtlassianAccountManaged)(state)) // no need to call Jira to log out Atlassian accounts. Simply redirect to AA logout page
    return (0, $b0T1M.Observable).of({
        logoutRedirectUrl: $1688d417e17de9e8$var$AA_LOGOUT_REDIRECT_URL
    });
    return (0, $fgWTm.logoutUsingIdentity)(`${(0, $2mzxy.getBaseUrl)(state)}${$1688d417e17de9e8$var$getAfterLogoutUrl(state)}`);
};
const $1688d417e17de9e8$export$c4456f69976aae9b = (action$, store)=>{
    return action$.ofType((0, $fVVtD.LOG_OUT)).mergeMap(()=>{
        const state = store.getState();
        // Removing cached response of help-seeker-type on logout
        (0, $jhBPy.removeLocalStorageItem)('help-seeker-type');
        return $1688d417e17de9e8$export$8931338e80b3349d(state).mergeMap((response)=>{
            // We do a full page load to the login or help center page to clear out the redux store and avoid
            // data for one user being seen by another if one logs out and another logs in in the same tab
            (0, $3TeDY.assign)($1688d417e17de9e8$var$getLogoutDestination(state, response));
            return (0, $b0T1M.Observable).empty();
        }).catch((error)=>{
            return $1688d417e17de9e8$var$handleLogoutError(error);
        });
    });
};
function $1688d417e17de9e8$var$handleLogoutError(error) {
    (0, $keOG0.trackError)('session.logout.failed', {}, error);
    (0, $3TeDY.reload)();
    return (0, $b0T1M.Observable).empty();
}
function $1688d417e17de9e8$var$getAfterLogoutUrl(state) {
    if ((0, $2mzxy.getIsAnonymousEnabled)(state)) return (0, $Y85G3.getHelpCenterUrl)();
    return (0, $Y85G3.getLoginUrlForPortalId)((0, $h1MVT.getPortalId)(state));
}
function $1688d417e17de9e8$var$getLogoutDestination(state, logoutResponseBody) {
    if (logoutResponseBody && logoutResponseBody.logoutRedirectUrl) return logoutResponseBody.logoutRedirectUrl;
    return `${(0, $3wR8f.getBaseName)()}${$1688d417e17de9e8$var$getAfterLogoutUrl(state)}`;
}

});
parcelRegister("fgWTm", function(module, exports) {
$parcel$export(module.exports, "logoutUsingIdentity", () => $869227edbe2edaca$export$7d7e0f6e9da553cb);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $keOG0 = parcelRequire("keOG0");

var $kXlzl = parcelRequire("kXlzl");

var $3wR8f = parcelRequire("3wR8f");
const $869227edbe2edaca$var$createOperationalPayload = (actionSubject, attributes)=>{
    return {
        attributes: attributes,
        actionSubject: actionSubject,
        action: 'logout',
        source: 'unknownSource'
    };
};
const $869227edbe2edaca$export$7d7e0f6e9da553cb = (redirectUrl, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/jsd-login-v2/v2/customer/logout?continue=${redirectUrl}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri).do((ajaxResponse)=>{
        (0, $kXlzl.operationalEvent)($869227edbe2edaca$var$createOperationalPayload('identity', {
            success: true,
            status: ajaxResponse.status.toString()
        }));
    }, (ajaxError)=>{
        var _ajaxError$response;
        (0, $kXlzl.operationalEvent)($869227edbe2edaca$var$createOperationalPayload('identity', {
            success: false,
            status: ajaxError.status.toString(),
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            errorKey: (_ajaxError$response = ajaxError.response) === null || _ajaxError$response === void 0 ? void 0 : _ajaxError$response.key
        }));
        (0, $keOG0.trackError)('session.logout.failed', {}, ajaxError);
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};

});

parcelRegister("8XdUW", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => (parcelRequire("h1MVT")).getPathname);
$parcel$export(module.exports, "getPortalId", () => (parcelRequire("h1MVT")).getPortalId);

var $h1MVT = parcelRequire("h1MVT");

});
parcelRegister("h1MVT", function(module, exports) {
$parcel$export(module.exports, "getPathname", () => $d3d51965fea27493$export$b829272b1dcc6798);
$parcel$export(module.exports, "getPortalId", () => $d3d51965fea27493$export$79c9b12a0a57147a);
const $d3d51965fea27493$export$f71e6ac2c1d88be0 = (state)=>state.ui.context.portalId !== undefined && state.ui.context.portalId !== null && !isNaN(state.ui.context.portalId);
const $d3d51965fea27493$export$b829272b1dcc6798 = (state)=>state.ui.context.pathname;
const $d3d51965fea27493$export$6c570a1091322ad4 = (state)=>state.ui.context.routeName;
const $d3d51965fea27493$export$79c9b12a0a57147a = (state)=>{
    if (!$d3d51965fea27493$export$f71e6ac2c1d88be0(state)) return undefined;
    return state.ui.context.portalId;
};

});


parcelRegister("58htq", function(module, exports) {
$parcel$export(module.exports, "getWacLink", () => (parcelRequire("2mzxy")).getWacLink);
$parcel$export(module.exports, "getHeadless", () => (parcelRequire("2mzxy")).getHeadless);
$parcel$export(module.exports, "getServiceDeskVersion", () => (parcelRequire("2mzxy")).getServiceDeskVersion);
$parcel$export(module.exports, "getXsrfToken", () => (parcelRequire("2mzxy")).getXsrfToken);
$parcel$export(module.exports, "getBaseUrl", () => (parcelRequire("2mzxy")).getBaseUrl);
$parcel$export(module.exports, "getContactLink", () => (parcelRequire("2mzxy")).getContactLink);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => (parcelRequire("2mzxy")).getIsAnonymousEnabled);
$parcel$export(module.exports, "getFabricEmojiUrl", () => (parcelRequire("2mzxy")).getFabricEmojiUrl);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => (parcelRequire("2mzxy")).getJsmAIConfigEnabled);
$parcel$export(module.exports, "getJiraDisplayUrl", () => (parcelRequire("2mzxy")).getJiraDisplayUrl);

var $2mzxy = parcelRequire("2mzxy");

});
parcelRegister("2mzxy", function(module, exports) {
$parcel$export(module.exports, "getServiceDeskVersion", () => $994c706fb5cc44c4$export$cf63d87096689a17);
$parcel$export(module.exports, "getWacLink", () => $994c706fb5cc44c4$export$94833c7df37d6b17);
$parcel$export(module.exports, "getHeadless", () => $994c706fb5cc44c4$export$915f62c9c01bc3d6);
$parcel$export(module.exports, "getXsrfToken", () => $994c706fb5cc44c4$export$14407a25c57e1f92);
$parcel$export(module.exports, "getContactLink", () => $994c706fb5cc44c4$export$a204de3b9df9c687);
$parcel$export(module.exports, "getIsAnonymousEnabled", () => $994c706fb5cc44c4$export$10062cf4ec7decdd);
$parcel$export(module.exports, "getFabricEmojiUrl", () => $994c706fb5cc44c4$export$81a8d16acc87f947);
$parcel$export(module.exports, "getBaseUrl", () => $994c706fb5cc44c4$export$f654b28f82155665);
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $994c706fb5cc44c4$export$a90992f5204fc247);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $994c706fb5cc44c4$export$9679fa5312e1354b);
const $994c706fb5cc44c4$export$cf63d87096689a17 = (state)=>state.persisted.env.serviceDeskVersion;
const $994c706fb5cc44c4$export$94833c7df37d6b17 = (state)=>state.persisted.env.wacLink;
const $994c706fb5cc44c4$export$915f62c9c01bc3d6 = (state)=>state.persisted.env.headless;
const $994c706fb5cc44c4$export$14407a25c57e1f92 = (state)=>state.persisted.env.xsrfToken;
const $994c706fb5cc44c4$export$a204de3b9df9c687 = (state)=>state.persisted.env.contactLink;
const $994c706fb5cc44c4$export$10062cf4ec7decdd = (state)=>state.persisted.env.anonymousEnabled;
const $994c706fb5cc44c4$export$81a8d16acc87f947 = (state)=>state.persisted.env.fabricEmojiUrl;
const $994c706fb5cc44c4$export$f654b28f82155665 = (state)=>state.persisted.env.baseUrl;
const $994c706fb5cc44c4$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $994c706fb5cc44c4$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $994c706fb5cc44c4$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $994c706fb5cc44c4$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;
const $994c706fb5cc44c4$export$16e2ca57934a087e = (state)=>state.persisted.env.customerAccountAvailabilty;

});


parcelRegister("iAm81", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => (parcelRequire("2hx7o")).getLocale);
$parcel$export(module.exports, "getAvatar", () => (parcelRequire("2hx7o")).getAvatar);
$parcel$export(module.exports, "AvatarSizes", () => (parcelRequire("2hx7o")).AvatarSizes);
$parcel$export(module.exports, "isLoggedIn", () => (parcelRequire("2hx7o")).isLoggedIn);
$parcel$export(module.exports, "isUserLoaded", () => (parcelRequire("2hx7o")).isUserLoaded);
$parcel$export(module.exports, "getCanAdministerJIRA", () => (parcelRequire("2hx7o")).getCanAdministerJIRA);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => (parcelRequire("2hx7o")).getHasSiteAdministerAccess);
$parcel$export(module.exports, "getAgentForPortal", () => (parcelRequire("2hx7o")).getAgentForPortal);
$parcel$export(module.exports, "getAccountId", () => (parcelRequire("2hx7o")).getAccountId);
$parcel$export(module.exports, "getDisplayName", () => (parcelRequire("2hx7o")).getDisplayName);
$parcel$export(module.exports, "getAvatarSrc", () => (parcelRequire("2hx7o")).getAvatarSrc);
$parcel$export(module.exports, "getUserState", () => (parcelRequire("2hx7o")).getUserState);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => (parcelRequire("2hx7o")).isAtlassianAccountManaged);

var $2hx7o = parcelRequire("2hx7o");

});
parcelRegister("2hx7o", function(module, exports) {
$parcel$export(module.exports, "AvatarSizes", () => $1696216e9eb37f99$export$a56a976854e036b3);
$parcel$export(module.exports, "isLoggedIn", () => $1696216e9eb37f99$export$256a5a3564694cfc);
$parcel$export(module.exports, "isUserLoaded", () => $1696216e9eb37f99$export$e184595b7ec7bf2a);
$parcel$export(module.exports, "getLocale", () => $1696216e9eb37f99$export$180605366c04f0cd);
$parcel$export(module.exports, "getAvatar", () => $1696216e9eb37f99$export$4832dff6e2fcc91f);
$parcel$export(module.exports, "getAvatarSrc", () => $1696216e9eb37f99$export$35125d98e6f1484);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $1696216e9eb37f99$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $1696216e9eb37f99$export$c5f994129d97ed23);
$parcel$export(module.exports, "getAgentForPortal", () => $1696216e9eb37f99$export$a163df73b48c15df);
$parcel$export(module.exports, "getAccountId", () => $1696216e9eb37f99$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getDisplayName", () => $1696216e9eb37f99$export$be63e0664592e141);
$parcel$export(module.exports, "getUserState", () => $1696216e9eb37f99$export$531a2013799771e3);
$parcel$export(module.exports, "isAtlassianAccountManaged", () => $1696216e9eb37f99$export$9055c338585b9def);
var $1696216e9eb37f99$export$a56a976854e036b3 = /*#__PURE__*/ function(AvatarSizes) {
    AvatarSizes["XSMALL"] = "xsmall";
    AvatarSizes["SMALL"] = "small";
    AvatarSizes["MEDIUM"] = "medium";
    AvatarSizes["LARGE"] = "large";
    AvatarSizes["XLARGE"] = "xlarge";
    return AvatarSizes;
}({});
const $1696216e9eb37f99$export$256a5a3564694cfc = (state)=>state.persisted.user.isLoggedIn;
const $1696216e9eb37f99$export$e184595b7ec7bf2a = (state)=>state.persisted.user.isLoaded;
const $1696216e9eb37f99$export$180605366c04f0cd = (state)=>state.persisted.user.language.key;
const $1696216e9eb37f99$export$4832dff6e2fcc91f = (state, size)=>{
    if (state.persisted.user.avatars && size) return state.persisted.user.avatars[size];
    return undefined;
};
const $1696216e9eb37f99$export$35125d98e6f1484 = (state)=>$1696216e9eb37f99$export$4832dff6e2fcc91f(state, "xlarge");
const $1696216e9eb37f99$export$ee387765d0284f6c = (state)=>{
    return state.persisted.user.userRequests;
};
const $1696216e9eb37f99$export$aa593f8d08aea763 = (state)=>{
    return state.persisted.user.userRequests.myRequestCount;
};
const $1696216e9eb37f99$export$e088f15960c351f6 = (state)=>{
    return state.persisted.user.userRequests.pendingApprovalCount;
};
const $1696216e9eb37f99$export$c0edbdc6282ca463 = (state)=>{
    return state.persisted.user.userRequests.approvalCount;
};
const $1696216e9eb37f99$export$bf9a934424e2dbf1 = (state)=>state.persisted.user.customMenuLinks;
const $1696216e9eb37f99$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $1696216e9eb37f99$export$c5f994129d97ed23 = (state)=>{
    return state.persisted.user.hasSiteAdministerAccess;
};
const $1696216e9eb37f99$export$a163df73b48c15df = (state)=>{
    return state.persisted.user.agentForPortal;
};
const $1696216e9eb37f99$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $1696216e9eb37f99$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName;
};
const $1696216e9eb37f99$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $1696216e9eb37f99$export$531a2013799771e3 = (state)=>{
    return state.persisted.user;
};
const $1696216e9eb37f99$export$9055c338585b9def = (state)=>{
    return state.persisted.user.atlassianAccountManaged;
};

});


parcelRegister("jhBPy", function(module, exports) {
$parcel$export(module.exports, "getLocalStorageItem", () => $22675fe8bf0a7a92$export$93d719890ad66653);
$parcel$export(module.exports, "setLocalStorageItem", () => $22675fe8bf0a7a92$export$5aa524d86254b4f);
$parcel$export(module.exports, "removeLocalStorageItem", () => $22675fe8bf0a7a92$export$baf306891f1b93bd);

var $kcQKb = parcelRequire("kcQKb");

var $7HnFM = parcelRequire("7HnFM");
const $22675fe8bf0a7a92$export$93d719890ad66653 = (key, errorHandler)=>{
    return (0, $7HnFM.safeAccessWithErrorHandler)(()=>(0, $kcQKb.AtlBrowserStorageLocal).getItem(key), errorHandler);
};
const $22675fe8bf0a7a92$export$5aa524d86254b4f = (key, value, errorHandler)=>{
    return (0, $7HnFM.safeAccessWithErrorHandler)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $kcQKb.AtlBrowserStorageLocal).setItem(key, value);
    }, errorHandler);
};
const $22675fe8bf0a7a92$export$baf306891f1b93bd = (key, errorHandler)=>{
    return (0, $7HnFM.safeAccessWithErrorHandler)(()=>(0, $kcQKb.AtlBrowserStorageLocal).removeItem(key), errorHandler);
};

});
parcelRegister("kcQKb", function(module, exports) {
$parcel$export(module.exports, "AtlBrowserStorageLocal", () => $b8c60277017eb863$export$c8cc3ffd3f2c1d2f);
$parcel$export(module.exports, "AtlBrowserStorageSession", () => $b8c60277017eb863$export$edbae459bdf957a5);
$parcel$export(module.exports, "findStorageTarget", () => $b8c60277017eb863$export$14921bfc334334c0);
$parcel$export(module.exports, "WebStorageType", () => (parcelRequire("lFYsw")).WebStorageType);

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $2manU = parcelRequire("2manU");
var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");

var $8f0nK = parcelRequire("8f0nK");

var $gkGYs = parcelRequire("gkGYs");

var $lFYsw = parcelRequire("lFYsw");

var $jjF1d = parcelRequire("jjF1d");
var $h3KTJ = parcelRequire("h3KTJ");
var $eNGSn = parcelRequire("eNGSn");
class $b8c60277017eb863$export$8e4a3cf07a10930b {
    constructor(storage, storageType){
        this.isAvailable = false;
        this.checkIfSetByPackage = async ({ itemKey: itemKey, isSetCallback: isSetCallback = ()=>{}, isNotSetCallback: isNotSetCallback = ()=>{} })=>{
            // As IDB is asynchronous in nature, when this in invoked, we need to rely on the callbacks
            // to actually do something with the result.
            try {
                const record = await (0, $gkGYs.BSCIndexedDB).getRecord(itemKey);
                if (record) {
                    isSetCallback();
                    return true;
                } else {
                    isNotSetCallback();
                    return false;
                }
            } catch (e) {
                // If it fails to pull from IDB, we can't validate that it's been set by our package or not, so log the error
                // and assume it hasn't been set by our package. This will only impact our analytics correctness.
                (0, $KilRp.Logger).errorWithOperationalEvent({
                    action: 'usedCheckIfSetByPackageError',
                    message: `IDB lookup failed to check if item was set by package. ${e.message || ''}`,
                    attributes: {
                        itemKey: itemKey
                    }
                });
                isNotSetCallback();
                return false;
            }
        };
        this.storage = storage;
        this.storageType = storageType;
        this.isAvailable = this.isStorageAvailable();
    }
    get isWebStorageEnabled() {
        // Note: outside of user configuration, webStorageEnabled is also feature gated by
        // 1. platform_moonjelly_bsc_master_killswitch
        // 2. platform_moonjelly_bsc_web_storage_killswitch
        if ((0, $aoZN9.getBscGlobalState)().webStorageEnabled) return true;
        (0, $KilRp.Logger).debug('WebStorage config is disabled, cannot proceed.');
        return false;
    }
    // Core API
    getItem(key) {
        if (!this.isWebStorageEnabled) return this.storage.getItem(key);
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $KilRp.Logger).warn(`${this.storageType} is unavailable. Failed to get item ${key}`);
            return null;
        }
        const retrievedItem = (0, $jjF1d.getStorageItem)(key, this.storageType, this.storage);
        return retrievedItem;
    }
    async setItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return {
                status: (0, $8f0nK.Status).SUCCESS
            };
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $KilRp.Logger).warn(`${this.storageType} is unavailable. Failed to set item ${key}`);
            return {
                status: (0, $8f0nK.Status).ERROR,
                error: new Error(`${this.storageType} is unavailable. Failed to set item ${key}`)
            };
        }
        const globalStateProduct = (0, $aoZN9.getBscGlobalState)().product;
        const wasInitialized = (0, $aoZN9.getBscGlobalState)().hasInitialized;
        // IMPORTANT: do not await above this line - if you do it will cause reading after writing to not return the new value until the microtask queue is drained, instead of just those that need to wait for remote fetch.
        const itemSetResult = await (0, $h3KTJ.setStorageItem)(key, value, this.storageType, globalStateProduct, this.storage);
        if (!wasInitialized && (0, $3H4LK.fg)('platform_bsc_initialize_controls_analytics')) (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $KilRp.Logger).debug(`${itemSetResult.status === (0, $8f0nK.Status).SUCCESS ? 'Successfully' : 'Failed to'} set item ${key} with value ${value}`);
        return itemSetResult;
    }
    setStrictlyNecessaryItem(key, value) {
        if (!this.isWebStorageEnabled) {
            this.storage.setItem(key, value);
            return;
        }
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $KilRp.Logger).warn(`${this.storageType} is unavailable. Failed to set strictly necessary item ${key}`);
            return;
        }
        const itemSetStatus = (0, $eNGSn.setStrictlyNecessaryStorageItem)(key, value, this.storageType, this.storage);
        if (!(0, $aoZN9.getBscGlobalState)().hasInitialized && (0, $3H4LK.fg)('platform_bsc_initialize_controls_analytics')) (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: this.storageType
            }
        });
        (0, $KilRp.Logger).debug(`${itemSetStatus === (0, $8f0nK.Status).SUCCESS ? 'Successfully' : 'Failed to'} set strictly necessary item ${key} with value ${value}`);
    }
    // Native Utilities
    removeItem(key) {
        if (!this.isAvailable) {
            // If our storage hasn't been enabled, short-circuit because we can't use the native utility
            (0, $KilRp.Logger).warn(`${this.storageType} is unavailable. Failed to remove item ${key}`);
            return;
        }
        this.storage.removeItem(key);
    }
    key(index) {
        if (!this.isAvailable) return null;
        return this.storage.key(index);
    }
    length() {
        if (!this.isAvailable) return 0;
        return this.storage.length;
    }
    clear() {
        if (!this.isAvailable) return;
        this.storage.clear();
    }
    // Utilities
    isStorageAvailable() {
        if ((0, $2manU.isSSR)()) return false;
        try {
            const x = '__storage_test__';
            this.storage.setItem(x, x);
            this.storage.removeItem(x);
            return true;
        } catch (e) {
            return e instanceof DOMException && // everything except Firefox
            (e.code === 22 || // Firefox
            e.code === 1014 || // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' || // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
            this.storage && this.storage.length !== 0;
        }
    }
}
const $b8c60277017eb863$export$c8cc3ffd3f2c1d2f = new $b8c60277017eb863$export$8e4a3cf07a10930b(globalThis.localStorage, (0, $lFYsw.WebStorageType).LocalStorage);
const $b8c60277017eb863$export$edbae459bdf957a5 = new $b8c60277017eb863$export$8e4a3cf07a10930b(globalThis.sessionStorage, (0, $lFYsw.WebStorageType).SessionStorage);
const $b8c60277017eb863$export$14921bfc334334c0 = (type)=>{
    return ({
        [(0, $lFYsw.WebStorageType).LocalStorage]: $b8c60277017eb863$export$c8cc3ffd3f2c1d2f,
        [(0, $lFYsw.WebStorageType).SessionStorage]: $b8c60277017eb863$export$edbae459bdf957a5
    })[type];
};

});
parcelRegister("aoZN9", function(module, exports) {
$parcel$export(module.exports, "getBscGlobalState", () => $bf1e136f23cb32b1$export$3b78a1ea01f5ec28);
$parcel$export(module.exports, "__internalApplyInitialState", () => $bf1e136f23cb32b1$export$725ef39b428c0dc2);
$parcel$export(module.exports, "__internalGetHasInitialized", () => $bf1e136f23cb32b1$export$8835d45f445e6ba4);
$parcel$export(module.exports, "__internalGetProductGlobalState", () => $bf1e136f23cb32b1$export$9dfdd17bbd03b460);
$parcel$export(module.exports, "__internalGetWebStorageControlsEnabledGlobalState", () => $bf1e136f23cb32b1$export$d96c3b0fb6d35c5d);
$parcel$export(module.exports, "__internalGetIndexedDbControlsEnabledGlobalState", () => $bf1e136f23cb32b1$export$c8554d68c78456d3);
$parcel$export(module.exports, "__internalGetDisableWebStorageConsentChecksGlobalState", () => $bf1e136f23cb32b1$export$ea650e4f51ec84d8);
$parcel$export(module.exports, "__internalGetAllowUncategorizedCookiesInOverridesGlobalState", () => $bf1e136f23cb32b1$export$fa1f6ebb49ec4b30);
$parcel$export(module.exports, "__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState", () => $bf1e136f23cb32b1$export$b60c6437117dfaf9);
$parcel$export(module.exports, "__internalGetShouldEnforceKeyGlobalState", () => $bf1e136f23cb32b1$export$45364c2f8f3ebde3);
$parcel$export(module.exports, "__internalGetDisableIndexedDbConsentChecksGlobalState", () => $bf1e136f23cb32b1$export$ea32fe1e8610fd3b);

var $8f0nK = parcelRequire("8f0nK");
let $bf1e136f23cb32b1$var$analyticsEnabledGlobalState;
let $bf1e136f23cb32b1$var$productGlobalState;
let $bf1e136f23cb32b1$var$perimeterGlobalState;
let $bf1e136f23cb32b1$var$webStorageControlsEnabledGlobalState;
let $bf1e136f23cb32b1$var$indexedDbControlsEnabledGlobalState;
let $bf1e136f23cb32b1$var$disableWebStorageConsentChecksGlobalState;
let $bf1e136f23cb32b1$var$localConsentModeGlobalState;
let $bf1e136f23cb32b1$var$packageDebugModeEnabledGlobalState;
let $bf1e136f23cb32b1$var$allowUncategorizedCookiesInOverridesGlobalState;
let $bf1e136f23cb32b1$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
let $bf1e136f23cb32b1$var$disableIndexedDbConsentChecksGlobalState;
let $bf1e136f23cb32b1$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
let $bf1e136f23cb32b1$var$userIdGlobalState;
let $bf1e136f23cb32b1$var$cloudIdGlobalState;
let $bf1e136f23cb32b1$var$hasInitialized = false;
let $bf1e136f23cb32b1$var$cookiesCacheLoader;
let $bf1e136f23cb32b1$var$localStorageCacheLoader;
let $bf1e136f23cb32b1$var$sessionStorageCacheLoader;
let $bf1e136f23cb32b1$var$indexedDBCacheLoader;
let $bf1e136f23cb32b1$var$loadCache = async (storageType)=>{
    var _cookiesCacheLoader, _localStorageCacheLoa, _sessionStorageCacheL, _indexedDBCacheLoader;
    switch(storageType){
        case (0, $8f0nK.CategoryStorageType).Cookies:
            return await ((_cookiesCacheLoader = $bf1e136f23cb32b1$var$cookiesCacheLoader) === null || _cookiesCacheLoader === void 0 ? void 0 : _cookiesCacheLoader.loadStorageControlsData());
        case (0, $8f0nK.CategoryStorageType).LocalStorage:
            return await ((_localStorageCacheLoa = $bf1e136f23cb32b1$var$localStorageCacheLoader) === null || _localStorageCacheLoa === void 0 ? void 0 : _localStorageCacheLoa.loadStorageControlsData());
        case (0, $8f0nK.CategoryStorageType).SessionStorage:
            return await ((_sessionStorageCacheL = $bf1e136f23cb32b1$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL === void 0 ? void 0 : _sessionStorageCacheL.loadStorageControlsData());
        case (0, $8f0nK.CategoryStorageType).IndexedDB:
            return await ((_indexedDBCacheLoader = $bf1e136f23cb32b1$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader === void 0 ? void 0 : _indexedDBCacheLoader.loadStorageControlsData());
        default:
            return undefined;
    }
};
let $bf1e136f23cb32b1$var$loadCacheMaybeSync = (storageType)=>{
    var _cookiesCacheLoader2, _cookiesCacheLoader3, _localStorageCacheLoa2, _localStorageCacheLoa3, _sessionStorageCacheL2, _sessionStorageCacheL3, _indexedDBCacheLoader2, _indexedDBCacheLoader3;
    switch(storageType){
        case (0, $8f0nK.CategoryStorageType).Cookies:
            return ((_cookiesCacheLoader2 = $bf1e136f23cb32b1$var$cookiesCacheLoader) === null || _cookiesCacheLoader2 === void 0 ? void 0 : _cookiesCacheLoader2.getStorageControlsDataFromCache()) ?? ((_cookiesCacheLoader3 = $bf1e136f23cb32b1$var$cookiesCacheLoader) === null || _cookiesCacheLoader3 === void 0 ? void 0 : _cookiesCacheLoader3.loadStorageControlsData());
        case (0, $8f0nK.CategoryStorageType).LocalStorage:
            return ((_localStorageCacheLoa2 = $bf1e136f23cb32b1$var$localStorageCacheLoader) === null || _localStorageCacheLoa2 === void 0 ? void 0 : _localStorageCacheLoa2.getStorageControlsDataFromCache()) ?? ((_localStorageCacheLoa3 = $bf1e136f23cb32b1$var$localStorageCacheLoader) === null || _localStorageCacheLoa3 === void 0 ? void 0 : _localStorageCacheLoa3.loadStorageControlsData());
        case (0, $8f0nK.CategoryStorageType).SessionStorage:
            return ((_sessionStorageCacheL2 = $bf1e136f23cb32b1$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL2 === void 0 ? void 0 : _sessionStorageCacheL2.getStorageControlsDataFromCache()) ?? ((_sessionStorageCacheL3 = $bf1e136f23cb32b1$var$sessionStorageCacheLoader) === null || _sessionStorageCacheL3 === void 0 ? void 0 : _sessionStorageCacheL3.loadStorageControlsData());
        case (0, $8f0nK.CategoryStorageType).IndexedDB:
            return ((_indexedDBCacheLoader2 = $bf1e136f23cb32b1$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader2 === void 0 ? void 0 : _indexedDBCacheLoader2.getStorageControlsDataFromCache()) ?? ((_indexedDBCacheLoader3 = $bf1e136f23cb32b1$var$indexedDBCacheLoader) === null || _indexedDBCacheLoader3 === void 0 ? void 0 : _indexedDBCacheLoader3.loadStorageControlsData());
        default:
            return undefined;
    }
};
const $bf1e136f23cb32b1$export$3b78a1ea01f5ec28 = ()=>{
    return {
        analyticsEnabled: $bf1e136f23cb32b1$var$analyticsEnabledGlobalState ?? true,
        product: $bf1e136f23cb32b1$var$productGlobalState,
        perimeter: $bf1e136f23cb32b1$var$perimeterGlobalState,
        webStorageEnabled: $bf1e136f23cb32b1$var$webStorageControlsEnabledGlobalState ?? false,
        indexedDbEnabled: $bf1e136f23cb32b1$var$indexedDbControlsEnabledGlobalState ?? false,
        disableWebStorageConsentChecks: $bf1e136f23cb32b1$var$disableWebStorageConsentChecksGlobalState ?? false,
        localConsentMode: $bf1e136f23cb32b1$var$localConsentModeGlobalState ?? false,
        packageDebugMode: $bf1e136f23cb32b1$var$packageDebugModeEnabledGlobalState,
        allowUncategorizedCookiesInOverrides: $bf1e136f23cb32b1$var$allowUncategorizedCookiesInOverridesGlobalState ?? false,
        allowUncategorizedItemsInWebStorageOverrides: $bf1e136f23cb32b1$var$allowUncategorizedItemsInWebStorageOverridesGlobalState ?? false,
        disableIndexedDbConsentChecks: $bf1e136f23cb32b1$var$disableIndexedDbConsentChecksGlobalState ?? false,
        __UNSAFE_shouldEnforceKeyForRollout: $bf1e136f23cb32b1$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState,
        cookiesCacheLoader: $bf1e136f23cb32b1$var$cookiesCacheLoader,
        localStorageCacheLoader: $bf1e136f23cb32b1$var$localStorageCacheLoader,
        sessionStorageCacheLoader: $bf1e136f23cb32b1$var$sessionStorageCacheLoader,
        indexedDBCacheLoader: $bf1e136f23cb32b1$var$indexedDBCacheLoader,
        loadCache: $bf1e136f23cb32b1$var$loadCache,
        loadCacheMaybeSync: $bf1e136f23cb32b1$var$loadCacheMaybeSync,
        hasInitialized: $bf1e136f23cb32b1$var$hasInitialized,
        userId: $bf1e136f23cb32b1$var$userIdGlobalState,
        cloudId: $bf1e136f23cb32b1$var$cloudIdGlobalState
    };
};
const $bf1e136f23cb32b1$export$f86e17381f699baf = ({ loadCache: overrideLoadCache, loadCacheMaybeSync: overrideLoadCacheMaybeSync, product: overrideProduct })=>{
    if (overrideLoadCache) $bf1e136f23cb32b1$var$loadCache = overrideLoadCache;
    if (overrideLoadCacheMaybeSync) $bf1e136f23cb32b1$var$loadCacheMaybeSync = overrideLoadCacheMaybeSync;
    if (overrideProduct) $bf1e136f23cb32b1$var$productGlobalState = overrideProduct;
};
const $bf1e136f23cb32b1$export$ac7c2edd09656c05 = ()=>{
    $bf1e136f23cb32b1$var$analyticsEnabledGlobalState = undefined;
    $bf1e136f23cb32b1$var$productGlobalState = undefined;
    $bf1e136f23cb32b1$var$webStorageControlsEnabledGlobalState = undefined;
    $bf1e136f23cb32b1$var$indexedDbControlsEnabledGlobalState = undefined;
    $bf1e136f23cb32b1$var$disableWebStorageConsentChecksGlobalState = undefined;
    $bf1e136f23cb32b1$var$localConsentModeGlobalState = undefined;
    $bf1e136f23cb32b1$var$packageDebugModeEnabledGlobalState = undefined;
    $bf1e136f23cb32b1$var$allowUncategorizedCookiesInOverridesGlobalState = undefined;
    $bf1e136f23cb32b1$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = undefined;
    $bf1e136f23cb32b1$var$disableIndexedDbConsentChecksGlobalState = undefined;
    $bf1e136f23cb32b1$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = undefined;
    $bf1e136f23cb32b1$var$userIdGlobalState = undefined;
    $bf1e136f23cb32b1$var$cloudIdGlobalState = undefined;
    $bf1e136f23cb32b1$var$cookiesCacheLoader = undefined;
    $bf1e136f23cb32b1$var$localStorageCacheLoader = undefined;
    $bf1e136f23cb32b1$var$sessionStorageCacheLoader = undefined;
    $bf1e136f23cb32b1$var$indexedDBCacheLoader = undefined;
    $bf1e136f23cb32b1$var$hasInitialized = false;
};
function $bf1e136f23cb32b1$export$725ef39b428c0dc2(updates) {
    if (updates.productGlobalState !== undefined) $bf1e136f23cb32b1$var$productGlobalState = updates.productGlobalState;
    if (updates.webStorageControlsEnabledGlobalState !== undefined) $bf1e136f23cb32b1$var$webStorageControlsEnabledGlobalState = updates.webStorageControlsEnabledGlobalState;
    if (updates.indexedDbControlsEnabledGlobalState !== undefined) $bf1e136f23cb32b1$var$indexedDbControlsEnabledGlobalState = updates.indexedDbControlsEnabledGlobalState;
    if (updates.disableWebStorageConsentChecksGlobalState !== undefined) $bf1e136f23cb32b1$var$disableWebStorageConsentChecksGlobalState = updates.disableWebStorageConsentChecksGlobalState;
    if (updates.allowUncategorizedCookiesInOverridesGlobalState !== undefined) $bf1e136f23cb32b1$var$allowUncategorizedCookiesInOverridesGlobalState = updates.allowUncategorizedCookiesInOverridesGlobalState;
    if (updates.allowUncategorizedItemsInWebStorageOverridesGlobalState !== undefined) $bf1e136f23cb32b1$var$allowUncategorizedItemsInWebStorageOverridesGlobalState = updates.allowUncategorizedItemsInWebStorageOverridesGlobalState;
    if (updates.disableIndexedDbConsentChecksGlobalState !== undefined) $bf1e136f23cb32b1$var$disableIndexedDbConsentChecksGlobalState = updates.disableIndexedDbConsentChecksGlobalState;
    if (updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState !== undefined) $bf1e136f23cb32b1$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState = updates.__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
    if (updates.localConsentModeGlobalState !== undefined) $bf1e136f23cb32b1$var$localConsentModeGlobalState = updates.localConsentModeGlobalState;
    if (updates.analyticsEnabledGlobalState !== undefined) $bf1e136f23cb32b1$var$analyticsEnabledGlobalState = updates.analyticsEnabledGlobalState;
    if (updates.perimeterGlobalState !== undefined) $bf1e136f23cb32b1$var$perimeterGlobalState = updates.perimeterGlobalState;
    if (updates.cookiesCacheLoader !== undefined) $bf1e136f23cb32b1$var$cookiesCacheLoader = updates.cookiesCacheLoader;
    if (updates.localStorageCacheLoader !== undefined) $bf1e136f23cb32b1$var$localStorageCacheLoader = updates.localStorageCacheLoader;
    if (updates.sessionStorageCacheLoader !== undefined) $bf1e136f23cb32b1$var$sessionStorageCacheLoader = updates.sessionStorageCacheLoader;
    if (updates.indexedDBCacheLoader !== undefined) $bf1e136f23cb32b1$var$indexedDBCacheLoader = updates.indexedDBCacheLoader;
    if (updates.packageDebugModeEnabledGlobalState !== undefined) $bf1e136f23cb32b1$var$packageDebugModeEnabledGlobalState = updates.packageDebugModeEnabledGlobalState;
    if (updates.hasInitialized !== undefined) $bf1e136f23cb32b1$var$hasInitialized = updates.hasInitialized;
    if (updates.cloudIdGlobalState !== undefined) $bf1e136f23cb32b1$var$cloudIdGlobalState = updates.cloudIdGlobalState;
    if (updates.userIdGlobalState !== undefined) $bf1e136f23cb32b1$var$userIdGlobalState = updates.userIdGlobalState;
}
function $bf1e136f23cb32b1$export$8835d45f445e6ba4() {
    return $bf1e136f23cb32b1$var$hasInitialized;
}
function $bf1e136f23cb32b1$export$9dfdd17bbd03b460() {
    return $bf1e136f23cb32b1$var$productGlobalState;
}
function $bf1e136f23cb32b1$export$d96c3b0fb6d35c5d() {
    return $bf1e136f23cb32b1$var$webStorageControlsEnabledGlobalState;
}
function $bf1e136f23cb32b1$export$c8554d68c78456d3() {
    return $bf1e136f23cb32b1$var$indexedDbControlsEnabledGlobalState;
}
function $bf1e136f23cb32b1$export$ea650e4f51ec84d8() {
    return $bf1e136f23cb32b1$var$disableWebStorageConsentChecksGlobalState;
}
function $bf1e136f23cb32b1$export$fa1f6ebb49ec4b30() {
    return $bf1e136f23cb32b1$var$allowUncategorizedCookiesInOverridesGlobalState;
}
function $bf1e136f23cb32b1$export$b60c6437117dfaf9() {
    return $bf1e136f23cb32b1$var$allowUncategorizedItemsInWebStorageOverridesGlobalState;
}
function $bf1e136f23cb32b1$export$45364c2f8f3ebde3() {
    return $bf1e136f23cb32b1$var$__UNSAFE_shouldEnforceKeyForRolloutGlobalState;
}
function $bf1e136f23cb32b1$export$ea32fe1e8610fd3b() {
    return $bf1e136f23cb32b1$var$disableIndexedDbConsentChecksGlobalState;
}

});
parcelRegister("8f0nK", function(module, exports) {
$parcel$export(module.exports, "PreferenceCategory", () => $b77a01b95fb06e5d$export$ba064dbfe4bb66d7);
$parcel$export(module.exports, "ConsentPreferenceV2", () => $b77a01b95fb06e5d$export$cdef20bac194f235);
$parcel$export(module.exports, "ContextualConsentProperty", () => $b77a01b95fb06e5d$export$fac80ad19b60e313);
$parcel$export(module.exports, "PrefetchedPreferenceState", () => $b77a01b95fb06e5d$export$5d6594a0bba4ab8a);
$parcel$export(module.exports, "CategoryStorageType", () => $b77a01b95fb06e5d$export$2506b012eb637f61);
$parcel$export(module.exports, "Status", () => $b77a01b95fb06e5d$export$96e9906d6d93a972);
var $b77a01b95fb06e5d$export$ba064dbfe4bb66d7 = /*#__PURE__*/ function(PreferenceCategory) {
    PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
    PreferenceCategory["Functional"] = "FUNCTIONAL";
    PreferenceCategory["Marketing"] = "MARKETING";
    PreferenceCategory["Analytics"] = "ANALYTICS";
    PreferenceCategory["Unknown"] = "UNKNOWN";
    return PreferenceCategory;
}({});
var $b77a01b95fb06e5d$export$cdef20bac194f235 = /*#__PURE__*/ function(ConsentPreferenceV2) {
    ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
    ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
    ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
    ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
    return ConsentPreferenceV2;
}({});
var $b77a01b95fb06e5d$export$fac80ad19b60e313 = /*#__PURE__*/ function(ContextualConsentProperty) {
    ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
    ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
    ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
    return ContextualConsentProperty;
}({});
var $b77a01b95fb06e5d$export$4fda8eb914d6791c = /*#__PURE__*/ function(CachedKeysDataPropertyLegacy) {
    CachedKeysDataPropertyLegacy["LocalStorage"] = "localStorageKeys";
    CachedKeysDataPropertyLegacy["SessionStorage"] = "sessionStorageKeys";
    CachedKeysDataPropertyLegacy["Cookies"] = "keys";
    CachedKeysDataPropertyLegacy["ThirdParty"] = "thirdPartyKeys";
    return CachedKeysDataPropertyLegacy;
}({});
var $b77a01b95fb06e5d$export$5d6594a0bba4ab8a = /*#__PURE__*/ function(PrefetchedPreferenceState) {
    PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
    return PrefetchedPreferenceState;
}({});
var $b77a01b95fb06e5d$export$2506b012eb637f61 = /*#__PURE__*/ function(CategoryStorageType) {
    CategoryStorageType["Cookies"] = "Cookies";
    CategoryStorageType["LocalStorage"] = "LocalStorage";
    CategoryStorageType["SessionStorage"] = "SessionStorage";
    CategoryStorageType["IndexedDB"] = "IndexedDB";
    return CategoryStorageType;
}({});
var $b77a01b95fb06e5d$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["SUCCESS"] = "SUCCESS";
    Status["BLOCKED"] = "BLOCKED";
    Status["FAILED"] = "FAILED";
    Status["ERROR"] = "ERROR";
    return Status;
}({});
var $b77a01b95fb06e5d$export$eefdbcf75990494a = /*#__PURE__*/ function(BSC_PACKAGE_KILLSWITCHES) {
    BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
    BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
    BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
    BSC_PACKAGE_KILLSWITCHES["WEB_STORAGE_KILLSWITCH"] = "platform_moonjelly_bsc_web_storage_killswitch";
    return BSC_PACKAGE_KILLSWITCHES;
}({});

});


parcelRegister("2manU", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $82b72528b28094f0$export$48d7c418edadb60c);

var $Idrdz = parcelRequire("Idrdz");

var $3H4LK = parcelRequire("3H4LK");
const $82b72528b28094f0$export$48d7c418edadb60c = ()=>{
    const isMissingNecessaryBrowserUtils = typeof document === 'undefined' || typeof window === 'undefined' || !Document || !Document.prototype || !Object || !Object.defineProperty;
    const isMissingBooleanFF = !(0, $3H4LK.fg);
    const isMissingAnalyticsWebClient = !Boolean((0, $Idrdz.default));
    if (isMissingNecessaryBrowserUtils || isMissingBooleanFF || isMissingAnalyticsWebClient) return true;
    else return false;
};

});

parcelRegister("hTxA3", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsClient", () => $fbcb492ace194bac$export$fde53e78fd93a54d);
$parcel$export(module.exports, "sendPackageOperationalEvent", () => $fbcb492ace194bac$export$5bfe55348e7aebc1);
$parcel$export(module.exports, "sendUnsampledPackageOperationalEvent", () => $fbcb492ace194bac$export$c986f0e7f985d67f);
$parcel$export(module.exports, "sendUIEvent", () => $fbcb492ace194bac$export$1aecf263098db667);
$parcel$export(module.exports, "sendScreenEvent", () => $fbcb492ace194bac$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendTrackEvent", () => $fbcb492ace194bac$export$1ba525b8a711eaac);

var $Idrdz = parcelRequire("Idrdz");
var $jgvOT = parcelRequire("jgvOT");

var $aoZN9 = parcelRequire("aoZN9");

var $4YVpY = parcelRequire("4YVpY");

var $eDpsE = parcelRequire("eDpsE");

var $azs2r = parcelRequire("azs2r");
const $fbcb492ace194bac$var$getEnvironment = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname.includes('.dev.') || hostname.includes('.stg.') || hostname.includes('.jira-dev.') || hostname.includes('.jira-stg.')) return (0, $jgvOT.envType).STAGING;
    if (hostname.includes('localhost') || hostname.includes('ngrok') || hostname.includes('atlastunnel')) return (0, $jgvOT.envType).DEV;
    return (0, $jgvOT.envType).PROD;
};
const $fbcb492ace194bac$export$78d7c0236b4fece9 = (path)=>{
    let subPath = '';
    if (!path) return subPath;
    const checkPath = (match)=>{
        return new RegExp(`^${match}(/|$)`).test(String(path));
    };
    if (checkPath('/wiki')) subPath = '/wiki';
    if (checkPath('/jira')) subPath = '/jira';
    if (checkPath('/compass')) subPath = '/compass';
    if (checkPath('/canvas')) subPath = '/canvas';
    if (checkPath('/servicedesk') || checkPath('/jira/servicedesk')) subPath = '/servicedesk';
    return subPath;
};
const $fbcb492ace194bac$var$getProductFromDomain = (domain)=>{
    if (domain === 'https://trello.com') return 'trello';
    return null;
};
const $fbcb492ace194bac$export$fce3dd735e04d566 = ()=>{
    const { origin: origin, pathname: pathname } = window.location;
    const productPath = $fbcb492ace194bac$export$78d7c0236b4fece9(pathname);
    const domain = `${origin}${productPath}`;
    const product = $fbcb492ace194bac$var$getProductFromDomain(domain) || productPath.slice(1);
    return {
        domain: domain,
        product: product
    };
};
const $fbcb492ace194bac$var$decorateEventAttributes = (attributes)=>{
    var _getBscGlobalState$pr;
    const { domain: domain, product: product } = $fbcb492ace194bac$export$fce3dd735e04d566();
    return {
        packageName: $eDpsE.packageName,
        packageVersion: $eDpsE.packageVersion,
        domain: domain,
        product: ((_getBscGlobalState$pr = (0, $aoZN9.getBscGlobalState)().product) === null || _getBscGlobalState$pr === void 0 ? void 0 : _getBscGlobalState$pr.toLowerCase()) ?? product,
        ...attributes && attributes
    };
};
const $fbcb492ace194bac$export$fde53e78fd93a54d = (()=>{
    let instance;
    return ()=>{
        try {
            if (!instance && (0, $aoZN9.getBscGlobalState)().analyticsEnabled) {
                instance = new (0, $Idrdz.default)({
                    env: $fbcb492ace194bac$var$getEnvironment(),
                    product: 'atlassianCookies'
                }, {
                    // useLegacyUrl tells the analytics client to make calls directly to Global Analytics Service.
                    // When set to false, the client will use a stargate proxy for the current URL to send events
                    // to GAS. Said another way:
                    // true => events are sent to https://api-private.stg.atlassian.com/gasv3/api/v1/batch
                    // false => events are sent to <the current domain>/gasv3/api/v1/batch
                    //
                    // By default, this should be set to false.  If you need to validate that analytics events
                    // are being transmitted correctly in local dev, you can temporarily enable it since localhost
                    // won't be able to proxy to GAS via stargate.
                    useLegacyUrl: false,
                    disableCookiePersistence: true
                });
                if ((0, $aoZN9.getBscGlobalState)().cloudId) instance.setTenantInfo((0, $jgvOT.tenantType).CLOUD_ID, (0, $aoZN9.getBscGlobalState)().cloudId);
                if ((0, $aoZN9.getBscGlobalState)().userId) instance.setUserInfo((0, $jgvOT.userType).ATLASSIAN_ACCOUNT, (0, $aoZN9.getBscGlobalState)().userId ?? '');
            }
        } catch (e) {
            // Log  errors thrown in constructor initialization for the AnalyticsWebClient
            // eslint-disable-next-line no-console
            console.error(`${(0, $4YVpY.LOG_PREFIX)}: Failed to initialize AnalyticsWebClient. ${e}`);
        }
        if (!(0, $aoZN9.getBscGlobalState)().analyticsEnabled) return undefined;
        // Return the instance, even if it is undefined
        return instance;
    };
})();
function $fbcb492ace194bac$export$5bfe55348e7aebc1(properties) {
    (0, $azs2r.withAnalyticsEventSampling)(properties.action, ()=>{
        var _getAnalyticsClient;
        return (_getAnalyticsClient = $fbcb492ace194bac$export$fde53e78fd93a54d()) === null || _getAnalyticsClient === void 0 ? void 0 : _getAnalyticsClient.sendOperationalEvent({
            source: 'package',
            actionSubject: 'package',
            action: properties.action,
            attributes: $fbcb492ace194bac$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $fbcb492ace194bac$export$c986f0e7f985d67f(properties) {
    var _getAnalyticsClient2;
    (_getAnalyticsClient2 = $fbcb492ace194bac$export$fde53e78fd93a54d()) === null || _getAnalyticsClient2 === void 0 || _getAnalyticsClient2.sendOperationalEvent({
        source: 'package',
        actionSubject: 'package',
        action: properties.action,
        attributes: $fbcb492ace194bac$var$decorateEventAttributes(properties.attributes)
    });
}
function $fbcb492ace194bac$export$1aecf263098db667(properties) {
    (0, $azs2r.withAnalyticsEventSampling)(properties.actionSubjectId, ()=>{
        var _getAnalyticsClient3;
        return (_getAnalyticsClient3 = $fbcb492ace194bac$export$fde53e78fd93a54d()) === null || _getAnalyticsClient3 === void 0 ? void 0 : _getAnalyticsClient3.sendUIEvent({
            ...properties,
            attributes: $fbcb492ace194bac$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $fbcb492ace194bac$export$22a3b1671f38a193(properties) {
    (0, $azs2r.withAnalyticsEventSampling)(properties.name, ()=>{
        var _getAnalyticsClient4;
        return (_getAnalyticsClient4 = $fbcb492ace194bac$export$fde53e78fd93a54d()) === null || _getAnalyticsClient4 === void 0 ? void 0 : _getAnalyticsClient4.sendScreenEvent({
            ...properties,
            attributes: $fbcb492ace194bac$var$decorateEventAttributes(properties.attributes)
        });
    });
}
function $fbcb492ace194bac$export$1ba525b8a711eaac(properties) {
    (0, $azs2r.withAnalyticsEventSampling)(properties.actionSubject, ()=>{
        var _getAnalyticsClient5;
        return (_getAnalyticsClient5 = $fbcb492ace194bac$export$fde53e78fd93a54d()) === null || _getAnalyticsClient5 === void 0 ? void 0 : _getAnalyticsClient5.sendTrackEvent({
            ...properties,
            attributes: $fbcb492ace194bac$var$decorateEventAttributes(properties.attributes)
        });
    });
}

});
parcelRegister("4YVpY", function(module, exports) {
$parcel$export(module.exports, "LOG_PREFIX", () => $0729e6477fb76c6d$export$5e28bf885ebebfa6);
const $0729e6477fb76c6d$export$5e28bf885ebebfa6 = '[browser-storage-controls]';

});

parcelRegister("eDpsE", function(module, exports) {
$parcel$export(module.exports, "packageName", () => $9a9edf70783f5789$export$9345d7360ffe0722);
$parcel$export(module.exports, "packageVersion", () => $9a9edf70783f5789$export$91546b032799aa40);
const $9a9edf70783f5789$export$9345d7360ffe0722 = undefined ?? '';
const $9a9edf70783f5789$export$91546b032799aa40 = undefined ?? '';

});

parcelRegister("azs2r", function(module, exports) {
$parcel$export(module.exports, "withAnalyticsEventSampling", () => $6ffa336d857a2b47$export$67b6e87f323cb6ad);

var $8f0nK = parcelRequire("8f0nK");

var $aoZN9 = parcelRequire("aoZN9");

var $b4eGZ = parcelRequire("b4eGZ");

var $2manU = parcelRequire("2manU");
const $6ffa336d857a2b47$export$1138592b3c099377 = {
    usedGetCookie: 100000,
    usedGetCookieError: 1,
    usedSetCookie: 1000,
    usedSetCookieError: 1,
    usedSetStrictlyNecessaryCookie: 10000,
    usedSetStrictlyNecessaryCookieError: 1,
    usedDeleteCookie: 10,
    usedDeleteCookieError: 1,
    usedCheckThirdParty: 100000,
    checkThirdPartyError: 1,
    usedDocumentCookie: 100,
    usedDocumentCookieError: 1,
    initializeControlsError: 1,
    loadStorageControlsError: 1,
    updatePreferencesError: 1,
    fetchConsentPreferencesError: 1,
    saveConsentPreferencesError: 1,
    usedAtlBrowserStorageGetItem: 100,
    usedAtlBrowserStorageGetItemError: 1,
    usedAtlBrowserStorageSetItem: 100,
    usedAtlBrowserStorageSetItemError: 1,
    usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
    usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
    indexDbSetRecordError: 1,
    usedCheckIfSetByPackageError: 1,
    renderConsentBannerError: 1,
    bannerAppearanceAfterDismissal: 1,
    usedAtlIndexedDBOpen: 100,
    usedAtlIndexedDBOpenError: 1,
    usedAtlIndexedDBOpenStrictlyNecessary: 100,
    usedAtlIndexedDBOpenStrictlyNecessaryError: 1,
    bscInitControlsParameters: 1000,
    setItemWithoutInit: 1000,
    uncategorizedWebStorageItemSet: 100,
    storageCleanupCategorized: 100,
    storageCleanupDeleted: 100,
    storageCleanupError: 1,
    cookieConsentPreferences: 1,
    cookieConsentModal: 1,
    cookieConsentBanner: 1,
    preferences: 1,
    onlyNecessary: 1,
    acceptAll: 1,
    cookiesTrackingNotice: 1,
    confirm: 1,
    performanceConsent: 1,
    functionalConsent: 1,
    targetingConsent: 1,
    cancel: 1,
    close: 1,
    background: 1
};
// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
const $6ffa336d857a2b47$var$localOnlySamplingKeys = [
    'loadStorageControlsError'
];
async function $6ffa336d857a2b47$var$loadSamplingConfig() {
    if ((0, $b4eGZ.cache).cachedSamplingConfig) return (0, $b4eGZ.cache).cachedSamplingConfig;
    if ((0, $2manU.isSSR)()) return undefined;
    const { loadCache: loadCache } = (0, $aoZN9.getBscGlobalState)();
    const controlsData = await loadCache((0, $8f0nK.CategoryStorageType).Cookies);
    const analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
    (0, $b4eGZ.cache).cachedSamplingConfig = analyticsSamplingRatioConfigs;
    return analyticsSamplingRatioConfigs;
}
async function $6ffa336d857a2b47$export$b286f5e8716d11ad(analyticsEventKey) {
    if ($6ffa336d857a2b47$var$localOnlySamplingKeys.includes(analyticsEventKey)) return $6ffa336d857a2b47$export$1138592b3c099377[analyticsEventKey];
    const remoteSamplingConfig = await $6ffa336d857a2b47$var$loadSamplingConfig();
    const samplingConfig = remoteSamplingConfig ?? $6ffa336d857a2b47$export$1138592b3c099377;
    const samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : $6ffa336d857a2b47$export$1138592b3c099377[analyticsEventKey];
    return samplingRatio;
}
function $6ffa336d857a2b47$export$dc2f0946255b3f89(samplingRatio, cb) {
    /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */ const shouldRun = !Math.floor(Math.random() * samplingRatio);
    shouldRun && cb();
}
async function $6ffa336d857a2b47$export$67b6e87f323cb6ad(analyticsEventKey, cb) {
    const ratio = await $6ffa336d857a2b47$export$b286f5e8716d11ad(analyticsEventKey);
    $6ffa336d857a2b47$export$dc2f0946255b3f89(ratio, cb);
}

});
parcelRegister("b4eGZ", function(module, exports) {
$parcel$export(module.exports, "cache", () => $45a89768827ad957$export$69a3209f1a06c04d);

var $3xlKW = parcelRequire("3xlKW");
const $45a89768827ad957$export$69a3209f1a06c04d = new (0, $3xlKW.CachedSamplingConfig)();

});
parcelRegister("3xlKW", function(module, exports) {
$parcel$export(module.exports, "CachedSamplingConfig", () => $3331c72d542afe77$export$b886edaf6623554a);
class $3331c72d542afe77$export$b886edaf6623554a {
    get cachedSamplingConfig() {
        return this.cache;
    }
    set cachedSamplingConfig(value) {
        this.cache = value;
    }
}

});




parcelRegister("KilRp", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $1c9de2fd5a380443$export$efa9a398d6368992);
/* eslint-disable no-console */ 
var $3H4LK = parcelRequire("3H4LK");

var $hTxA3 = parcelRequire("hTxA3");

var $aoZN9 = parcelRequire("aoZN9");

var $4YVpY = parcelRequire("4YVpY");
class $1c9de2fd5a380443$export$efa9a398d6368992 {
    static info(message, metadata) {
        console.log(`${(0, $4YVpY.LOG_PREFIX)}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static error(message, metadata) {
        console.error(`${(0, $4YVpY.LOG_PREFIX)}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    static errorWithOperationalEvent({ action: action, attributes: attributes = {}, message: message, metadata: metadata }) {
        try {
            (0, $hTxA3.sendUnsampledPackageOperationalEvent)({
                action: action,
                attributes: {
                    error: message,
                    ...attributes
                }
            });
        } catch (e) {
            this.error(`Failed to send operational event on error: ${action}. ${e.message || ''}`);
        }
        this.error(message, metadata ? JSON.stringify(metadata) : '');
    }
    static warn(message, metadata) {
        console.warn(`${(0, $4YVpY.LOG_PREFIX)}: ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
    /**
   * Logger for additional debugging of the package. Debug logs are only sent when the
   * atl-bsc-debug-mode cookie is set on the browser. This is evaluated via global state
   */ static debug(message, metadata) {
        if ((0, $aoZN9.getBscGlobalState)().packageDebugMode && (0, $3H4LK.fg)('platform_moonjelly_bsc_debug_mode')) console.debug(`${(0, $4YVpY.LOG_PREFIX)}: DEBUG ${message}`, metadata ? JSON.stringify(metadata) : '');
    }
}

});

parcelRegister("gkGYs", function(module, exports) {
$parcel$export(module.exports, "BSCIndexedDB", () => $cd88a2e9835a2deb$export$36328b3bcbe4623a);

var $3H4LK = parcelRequire("3H4LK");

var $2manU = parcelRequire("2manU");
var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");
class $cd88a2e9835a2deb$export$fde2a4e0e57f47e {
    static #_ = this.OPEN_DB_TIMEOUT_MS = 3000;
    constructor(dbName, storeName){
        this.db = null;
        this.isBooted = false;
        this.isAvailable = false;
        this.onConnectionErrorHandler = (reject)=>(event)=>{
                (0, $KilRp.Logger).warn('Error opening database.');
                reject(event);
            };
        this.onConnectionSuccessHandler = (connection, resolve)=>()=>{
                this.db = connection.result;
                resolve();
            };
        this.onConnectionUpgradeNeededHandler = (request)=>()=>{
                this.db = request.result;
                this.db.createObjectStore(this.storeName, {
                    keyPath: 'id'
                });
            };
        this.onGetRecordErrorHandler = (reject)=>()=>{
                const getErrorMessage = `Failed to perform a get transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $KilRp.Logger).warn(getErrorMessage);
                reject(getErrorMessage);
            };
        this.onGetRecordSuccessHandler = (getRequest, resolve)=>()=>{
                resolve(getRequest.result);
            };
        this.onSetRecordErrorHandler = (reject)=>()=>{
                const errorMessage = `Failed to perform a set transaction on IndexedDB: ${this.dbName} + ${this.storeName}`;
                (0, $KilRp.Logger).warn(errorMessage);
                reject(errorMessage);
            };
        this.onSetRecordSuccessHandler = (resolve)=>()=>{
                resolve();
            };
        this.dbName = dbName;
        this.storeName = storeName;
        this.isAvailable = this.getIsDBAvailable();
        this.isBooted = false;
        this.bootUpPromiseCache = null;
    }
    async boot() {
        if (!this.isAvailable) {
            (0, $KilRp.Logger).warn('IndexedDB is not available');
            return;
        }
        if (this.isBooted) // Short circuit if we've already booted once
        return;
        // Only boot once, even if we've been called numerous times sequentially
        if (!this.bootUpPromiseCache) {
            this.bootUpPromiseCache = this.openDB();
            try {
                await this.bootUpPromiseCache;
                this.isBooted = true;
            } catch (e) {
                this.isBooted = false;
                (0, $KilRp.Logger).warn('Error booting up IndexedDB.');
                throw e;
            }
        }
    }
    getIsDBAvailable() {
        return !(0, $2manU.isSSR)() && !!window.indexedDB;
    }
    async openDB() {
        const openPromise = new Promise((resolve, reject)=>{
            let request = indexedDB.open(this.dbName, 2);
            request.onerror = this.onConnectionErrorHandler(reject);
            request.onsuccess = this.onConnectionSuccessHandler(request, resolve);
            request.onupgradeneeded = this.onConnectionUpgradeNeededHandler(request);
        });
        if ((0, $3H4LK.fg)('cookies-bsc-timeout-for-indexeddb')) {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject(new Error(`IndexedDB open timed out after ${$cd88a2e9835a2deb$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS}ms`));
                }, $cd88a2e9835a2deb$export$fde2a4e0e57f47e.OPEN_DB_TIMEOUT_MS);
            });
            return Promise.race([
                openPromise,
                timeoutPromise
            ]);
        }
        return openPromise;
    }
    async getRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $hTxA3.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                return Promise.resolve({
                    atlSetItem: '',
                    id: recordKey
                }); // return empty AtlIndexedDBItem object to exit code
            }
            let fetchTransaction = this.db.transaction([
                this.storeName
            ]);
            let recordStore = fetchTransaction.objectStore(this.storeName);
            const fetchedRecord = new Promise((resolve, reject)=>{
                let request = recordStore.get(recordKey);
                request.onerror = this.onGetRecordErrorHandler(reject);
                request.onsuccess = this.onGetRecordSuccessHandler(request, resolve);
            });
            return fetchedRecord;
        } catch (e) {
            (0, $KilRp.Logger).error(`Error fetching record from database. ${e.message || ''}`);
            throw e;
        }
    }
    async setRecord(recordKey) {
        try {
            if (!this.isBooted) await this.boot();
            if (!this.db) {
                (0, $hTxA3.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: {
                        recordKey: recordKey
                    }
                });
                Promise.resolve(); // return void promise to exit code and not pass a null record
            }
            const setRecord = new Promise((resolve, reject)=>{
                let setTransaction = this.db.transaction([
                    this.storeName
                ], 'readwrite');
                let objectStore = setTransaction.objectStore(this.storeName);
                const newAtlRecord = {
                    atlSetItem: 'SET-BY-PACKAGE',
                    id: recordKey
                };
                let request = objectStore.put(newAtlRecord);
                request.onerror = this.onSetRecordErrorHandler(reject);
                request.onsuccess = this.onSetRecordSuccessHandler(resolve);
            });
            return setRecord;
        } catch (e) {
            (0, $KilRp.Logger).warn(`Error setting record in database. ${e.message || ''}`);
            throw e;
        }
    }
}
const $cd88a2e9835a2deb$export$36328b3bcbe4623a = new $cd88a2e9835a2deb$export$fde2a4e0e57f47e('BSCIndexedDB', 'InternalStorageKeys');

});

parcelRegister("lFYsw", function(module, exports) {
$parcel$export(module.exports, "WebStorageType", () => $2630f3fbac480efb$export$259e3a861f28589b);
var $2630f3fbac480efb$export$259e3a861f28589b = /*#__PURE__*/ function(WebStorageType) {
    WebStorageType["LocalStorage"] = "LocalStorage";
    WebStorageType["SessionStorage"] = "SessionStorage";
    return WebStorageType;
}({});

});

parcelRegister("jjF1d", function(module, exports) {
$parcel$export(module.exports, "getStorageItem", () => $17ec5d41e60e695f$export$e612bb1301d659de);

var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");
const $17ec5d41e60e695f$export$e612bb1301d659de = (itemKey, storageType, browserStorage)=>{
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageGetItem',
            attributes: eventAttributes
        });
        return browserStorage.getItem(itemKey);
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageGetItemError',
            attributes: eventAttributes,
            message: `Failed to get ${storageType} item. ${e.message || ''}`
        });
        return null;
    }
};

});

parcelRegister("h3KTJ", function(module, exports) {
$parcel$export(module.exports, "setStorageItem", () => $add2479aa834484f$export$5ee8760f703d9d62);

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $hTxA3 = parcelRequire("hTxA3");

var $812Hd = parcelRequire("812Hd");

var $KilRp = parcelRequire("KilRp");

var $gkGYs = parcelRequire("gkGYs");

var $8f0nK = parcelRequire("8f0nK");

var $bBzKh = parcelRequire("bBzKh");

var $lFYsw = parcelRequire("lFYsw");
const $add2479aa834484f$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $add2479aa834484f$export$5ee8760f703d9d62 = async (itemKey, value, storageType, productName, browserStorage)=>{
    const categoryStorageType = storageType === (0, $lFYsw.WebStorageType).LocalStorage ? (0, $8f0nK.CategoryStorageType).LocalStorage : (0, $8f0nK.CategoryStorageType).SessionStorage;
    // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
    // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
    let disableWebStorageConsentChecks = (0, $aoZN9.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
    if ((0, $3H4LK.fg)('jfp-magma-selective-storage-enforcement')) {
        const __UNSAFE_shouldEnforceKeyForRollout = (0, $aoZN9.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
        const enforceThisKey = (__UNSAFE_shouldEnforceKeyForRollout === null || __UNSAFE_shouldEnforceKeyForRollout === void 0 ? void 0 : __UNSAFE_shouldEnforceKeyForRollout(itemKey, categoryStorageType)) === true;
        disableWebStorageConsentChecks = ((0, $aoZN9.getBscGlobalState)().disableWebStorageConsentChecks ?? false) && !enforceThisKey;
    }
    if (disableWebStorageConsentChecks) {
        const eventAttributes = {
            itemKey: itemKey,
            storageType: storageType,
            consentChecksDisabled: true
        };
        try {
            if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
                // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
                (0, $bBzKh.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
                browserStorage.setItem(itemKey, value);
            } else {
                browserStorage.setItem(itemKey, value);
                await (0, $gkGYs.BSCIndexedDB).setRecord(itemKey);
            }
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                attributes: eventAttributes
            });
            return {
                status: (0, $8f0nK.Status).ERROR,
                error: e
            };
        }
        let wasAsync = true;
        try {
            let shouldSetItem;
            if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                const shouldSetItemOrPromise = (0, $812Hd.isProcessingAllowedByPreferencesMaybeSync)({
                    itemKey: itemKey,
                    storageType: categoryStorageType,
                    productName: productName
                });
                if ($add2479aa834484f$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
                else {
                    wasAsync = false;
                    shouldSetItem = shouldSetItemOrPromise;
                }
            } else shouldSetItem = await (0, $812Hd.isProcessingAllowedByPreferences)({
                itemKey: itemKey,
                storageType: categoryStorageType,
                productName: productName
            });
            (0, $hTxA3.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    ...eventAttributes,
                    wasRejected: !shouldSetItem,
                    wasAsync: wasAsync
                }
            });
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                attributes: {
                    ...eventAttributes,
                    wasAsync: wasAsync
                },
                message: `Failed to emit analytics for setStorageItem with consent checks disabled. ${e.message || ''}`
            });
        }
        return {
            status: (0, $8f0nK.Status).SUCCESS
        };
    }
    // user belongs to an org that opted into cookies management and we should respect their preferences
    let shouldSetItem;
    let wasAsync = true;
    if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
        const shouldSetItemOrPromise = (0, $812Hd.isProcessingAllowedByPreferencesMaybeSync)({
            itemKey: itemKey,
            storageType: categoryStorageType,
            productName: productName
        });
        if ($add2479aa834484f$var$isPromise(shouldSetItemOrPromise)) shouldSetItem = await shouldSetItemOrPromise;
        else {
            wasAsync = false;
            shouldSetItem = shouldSetItemOrPromise;
        }
    } else // user belongs to an org that opted into cookies management and we should respect their preferences
    shouldSetItem = await (0, $812Hd.isProcessingAllowedByPreferences)({
        itemKey: itemKey,
        storageType: categoryStorageType,
        productName: productName
    });
    const eventAttributes = {
        wasRejected: !shouldSetItem,
        itemKey: itemKey,
        storageType: storageType,
        consentChecksDisabled: false,
        wasAsync: wasAsync
    };
    try {
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetItem',
            attributes: eventAttributes
        });
        if (shouldSetItem) {
            if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
                // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
                (0, $bBzKh.ItemKeyCache).markSetByPackage(categoryStorageType, itemKey);
                browserStorage.setItem(itemKey, value);
                return {
                    status: (0, $8f0nK.Status).SUCCESS
                };
            } else {
                // Store the item as a record in our IDB service to track that we've seen it before.
                // That way, when we can confirm/deny that this has been set by our service when we check again.
                // If it fails for some reason, it will be caught before actually setting the item
                await (0, $gkGYs.BSCIndexedDB).setRecord(itemKey);
                browserStorage.setItem(itemKey, value);
                return {
                    status: (0, $8f0nK.Status).SUCCESS
                };
            }
        } else return {
            status: (0, $8f0nK.Status).BLOCKED
        };
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetItemError',
            attributes: eventAttributes,
            message: `Failed to set ${storageType} item. ${e.message || ''}`
        });
        return {
            status: (0, $8f0nK.Status).ERROR,
            error: e
        };
    }
};

});
parcelRegister("812Hd", function(module, exports) {
$parcel$export(module.exports, "getItemCategoryFromPassedCache", () => $3e2618c407f9c204$export$69d5b68d01f4a366);
$parcel$export(module.exports, "getItemCategory", () => $3e2618c407f9c204$export$ec8ce5237293e4a4);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesMaybeSync", () => $3e2618c407f9c204$export$ffbb879d3fefb45c);
$parcel$export(module.exports, "isProcessingAllowedByPreferences", () => $3e2618c407f9c204$export$e7a3dca206fec6e2);
$parcel$export(module.exports, "isProcessingAllowedByPreferencesWithCategory", () => $3e2618c407f9c204$export$17e4a7e00d5b99d9);

var $3H4LK = parcelRequire("3H4LK");

var $7umuC = parcelRequire("7umuC");

var $8f0nK = parcelRequire("8f0nK");

var $aoZN9 = parcelRequire("aoZN9");

var $KilRp = parcelRequire("KilRp");
/**
 * WeakMap cache for precompiled RegExp objects, keyed by the raw regExp product map.
 * This ensures RegExp strings are compiled at most once per unique cache object.
 */ const $3e2618c407f9c204$var$compiledRegExpCache = new WeakMap();
const $3e2618c407f9c204$var$compileRegExpPatterns = (rawPatterns)=>{
    if ($3e2618c407f9c204$var$compiledRegExpCache.has(rawPatterns)) return $3e2618c407f9c204$var$compiledRegExpCache.get(rawPatterns);
    const compiled = [];
    for (const [regexString, category] of Object.entries(rawPatterns))try {
        compiled.push({
            regexp: new RegExp(regexString),
            category: category
        });
    } catch (e) {
        (0, $KilRp.Logger).warn(`BSC: Invalid RegExp pattern "${regexString}" in storage controls cache \u{2014} skipping.`);
    }
    $3e2618c407f9c204$var$compiledRegExpCache.set(rawPatterns, compiled);
    return compiled;
};
const $3e2618c407f9c204$export$2c141b1c00f3e482 = (itemKey, startsWith)=>{
    // Setup initial pattern step and position
    let currentStep = startsWith;
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        // The value of item character at the position
        const currentStepValue = currentStep[itemKey[position]];
        // If there is no match for item symbol in cache, this means there is no
        // pattern match for the item key
        if (currentStepValue === undefined) return null;
        // If current step value is a number, this means we reached the end of the pattern
        // and should return category number
        if (typeof currentStepValue === 'number') return currentStepValue;
        // Continue to going through pattern
        currentStep = currentStepValue;
        position++;
    }
    // No pattern match - all patterns longer or shorter than item key
    return null;
};
const $3e2618c407f9c204$export$81a82818a800a999 = (itemKey, compiledPatterns)=>{
    for (const { regexp: regexp, category: category } of compiledPatterns){
        if (regexp.test(itemKey)) return category;
    }
    return null;
};
const $3e2618c407f9c204$export$c4a1dd71bbd8954c = (itemKey, endsWith)=>{
    // Return category number if str is found in the trie, otherwise return undefined
    const trieSearch = (str)=>{
        let currentStep = endsWith;
        let foundString = '';
        let terminalNumber;
        for(let i = 0; i < str.length; i++){
            const char = str[i];
            currentStep = currentStep[char];
            if (currentStep === undefined) break;
            foundString += char;
            if (typeof currentStep === 'number') {
                terminalNumber = currentStep;
                break;
            }
        }
        if (foundString === str) // Trie contained the complete string
        return terminalNumber;
        else // Trie did not contain the complete string
        return undefined;
    };
    let position = 0;
    // Iterate through item key symbol by symbol
    while(position < itemKey.length){
        const remainderMatch = trieSearch(itemKey.slice(position));
        if (remainderMatch !== undefined) return remainderMatch;
        position++;
    }
    return null;
};
const $3e2618c407f9c204$export$915dea35caff63c = (itemKey, startsWith)=>{
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) return startsWith[prefix];
    }
    return null;
};
const $3e2618c407f9c204$export$4381be1b9fd38456 = (itemKey, startsWith)=>{
    let best = null;
    for (const prefix of Object.keys(startsWith)){
        if (itemKey.startsWith(prefix)) {
            if (best === null || prefix.length > best.length) best = {
                category: startsWith[prefix],
                length: prefix.length
            };
        }
    }
    return best;
};
const $3e2618c407f9c204$export$495f1917e0bfb98c = (itemKey, endsWith)=>{
    let best = null;
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) {
            if (best === null || suffix.length > best.length) best = {
                category: endsWith[suffix],
                length: suffix.length
            };
        }
    }
    return best;
};
const $3e2618c407f9c204$export$f6f7882079c4a2cb = (itemKey, endsWith)=>{
    for (const suffix of Object.keys(endsWith)){
        if (itemKey.endsWith(suffix)) return endsWith[suffix];
    }
    return null;
};
const $3e2618c407f9c204$export$69d5b68d01f4a366 = (itemKey, storageControlsData, productName)=>{
    const downcasedProduct = productName === null || productName === void 0 ? void 0 : productName.toLowerCase();
    let itemCategoryNumber = null;
    const { categories: categories, patterns: patterns } = storageControlsData;
    let productKeys = {
        ...storageControlsData['keys']['all'],
        ...downcasedProduct ? storageControlsData['keys'][downcasedProduct] : {}
    };
    const productStartsWithPatterns = {
        ...patterns.startsWith['all'],
        ...downcasedProduct ? patterns.startsWith[downcasedProduct] : {}
    };
    const productEndsWithPatterns = {
        ...patterns.endsWith['all'],
        ...downcasedProduct ? patterns.endsWith[downcasedProduct] : {}
    };
    // Find direct match in keys
    if (Object.keys(productKeys).includes(itemKey)) itemCategoryNumber = productKeys[itemKey];
    else if ((0, $3H4LK.fg)('platform_bsc_flat_pattern_file_structure')) {
        if ((0, $3H4LK.fg)('platform_bsc_longest_pattern_match_wins')) {
            // Longest-match-wins flat path
            const swMatch = $3e2618c407f9c204$export$4381be1b9fd38456(itemKey, productStartsWithPatterns);
            if (swMatch !== null) itemCategoryNumber = swMatch.category;
            else {
                const ewMatch = $3e2618c407f9c204$export$495f1917e0bfb98c(itemKey, productEndsWithPatterns);
                if (ewMatch !== null) itemCategoryNumber = ewMatch.category;
            }
        } else {
            // First-match flat path (COOK-435)
            itemCategoryNumber = $3e2618c407f9c204$export$915dea35caff63c(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $3e2618c407f9c204$export$f6f7882079c4a2cb(itemKey, productEndsWithPatterns);
        }
        // 3. RegExp fallback for both flat paths
        if (itemCategoryNumber === null && (0, $3H4LK.fg)('platform_moonjelly_bsc_regexp_pattern_matching')) {
            var _patterns$regexp, _patterns$regexp2;
            const rawRegExpPatterns = {
                ...(_patterns$regexp = patterns.regexp) === null || _patterns$regexp === void 0 ? void 0 : _patterns$regexp['all'],
                ...downcasedProduct ? (_patterns$regexp2 = patterns.regexp) === null || _patterns$regexp2 === void 0 ? void 0 : _patterns$regexp2[downcasedProduct] : {}
            };
            const compiledPatterns = $3e2618c407f9c204$var$compileRegExpPatterns(rawRegExpPatterns);
            itemCategoryNumber = $3e2618c407f9c204$export$81a82818a800a999(itemKey, compiledPatterns);
        }
    } else {
        // Legacy trie matching path. When platform_bsc_lookup_product_then_all_pattern_tries
        // is ON we search the product trie first and fall back to the 'all' trie;
        // a merged trie is unsafe because a shared first character silently
        // drops the entire 'all' subtree under it (HOT-303432).
        if ((0, $3H4LK.fg)('platform_bsc_lookup_product_then_all_pattern_tries')) {
            const productStartsWith = downcasedProduct ? patterns.startsWith[downcasedProduct] : undefined;
            const productEndsWith = downcasedProduct ? patterns.endsWith[downcasedProduct] : undefined;
            const allStartsWith = patterns.startsWith['all'];
            const allEndsWith = patterns.endsWith['all'];
            if (productStartsWith) itemCategoryNumber = $3e2618c407f9c204$export$2c141b1c00f3e482(itemKey, productStartsWith);
            if (itemCategoryNumber === null && allStartsWith) itemCategoryNumber = $3e2618c407f9c204$export$2c141b1c00f3e482(itemKey, allStartsWith);
            if (itemCategoryNumber === null && productEndsWith) itemCategoryNumber = $3e2618c407f9c204$export$c4a1dd71bbd8954c(itemKey, productEndsWith);
            if (itemCategoryNumber === null && allEndsWith) itemCategoryNumber = $3e2618c407f9c204$export$c4a1dd71bbd8954c(itemKey, allEndsWith);
        } else {
            itemCategoryNumber = $3e2618c407f9c204$export$2c141b1c00f3e482(itemKey, productStartsWithPatterns);
            if (itemCategoryNumber === null) itemCategoryNumber = $3e2618c407f9c204$export$c4a1dd71bbd8954c(itemKey, productEndsWithPatterns);
        }
        if (itemCategoryNumber === null && (0, $3H4LK.fg)('platform_moonjelly_bsc_regexp_pattern_matching')) {
            var _patterns$regexp3, _patterns$regexp4;
            const rawRegExpPatterns = {
                ...(_patterns$regexp3 = patterns.regexp) === null || _patterns$regexp3 === void 0 ? void 0 : _patterns$regexp3['all'],
                ...downcasedProduct ? (_patterns$regexp4 = patterns.regexp) === null || _patterns$regexp4 === void 0 ? void 0 : _patterns$regexp4[downcasedProduct] : {}
            };
            const compiledPatterns = $3e2618c407f9c204$var$compileRegExpPatterns(rawRegExpPatterns);
            itemCategoryNumber = $3e2618c407f9c204$export$81a82818a800a999(itemKey, compiledPatterns);
        }
    }
    const numToCategoryMap = {
        [categories.STRICTLY_NECESSARY]: (0, $8f0nK.PreferenceCategory).StrictlyNecessary,
        [categories.FUNCTIONAL]: (0, $8f0nK.PreferenceCategory).Functional,
        [categories.ANALYTICS]: (0, $8f0nK.PreferenceCategory).Analytics,
        [categories.MARKETING]: (0, $8f0nK.PreferenceCategory).Marketing,
        [categories.UNKNOWN]: (0, $8f0nK.PreferenceCategory).Unknown
    };
    return itemCategoryNumber !== null ? numToCategoryMap[itemCategoryNumber] : null;
};
const $3e2618c407f9c204$export$ec8ce5237293e4a4 = async (itemKey, storageType, productName)=>{
    const storageControlsData = await (0, $aoZN9.getBscGlobalState)().loadCache(storageType);
    if (!storageControlsData) return null;
    else return $3e2618c407f9c204$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
};
const $3e2618c407f9c204$var$isPromise = (value)=>value != null && typeof value.then === 'function';
const $3e2618c407f9c204$export$68b935e7ddb93762 = (itemKey, storageType, productName)=>{
    const storageControlsDataOrPromise = (0, $aoZN9.getBscGlobalState)().loadCacheMaybeSync(storageType);
    if ($3e2618c407f9c204$var$isPromise(storageControlsDataOrPromise)) return storageControlsDataOrPromise.then((storageControlsData)=>{
        if (!storageControlsData) return null;
        else return $3e2618c407f9c204$export$69d5b68d01f4a366(itemKey, storageControlsData, productName);
    });
    if (!storageControlsDataOrPromise) return null;
    else return $3e2618c407f9c204$export$69d5b68d01f4a366(itemKey, storageControlsDataOrPromise, productName);
};
function $3e2618c407f9c204$var$isProcessingAllowedForCategoryAndPreferenceSync(category, preferences) {
    if (!!preferences) {
        if (!!category) return preferences[category];
    }
    return false;
}
/**
 * Given an item category and a promise or object of user preferences, determines whether the item can be set.
 * It avoids only returns a promise if we need the preference data to determine the result, otherwise it returns synchronously.
 *
 * DO NOT CONVERT THIS FUNCTION TO ASYNC - as async functions always return a promise, breaking read-after-write consistency for clients that have already loaded the cache.
 */ function $3e2618c407f9c204$var$isProcessingAllowedForCategoryMaybeSync(itemCategory, preferencesOrPromise) {
    if (itemCategory === (0, $8f0nK.PreferenceCategory).StrictlyNecessary) return {
        itemCategory: itemCategory,
        shouldProcessItem: true
    };
    if ($3e2618c407f9c204$var$isPromise(preferencesOrPromise)) return preferencesOrPromise.then((prefs)=>{
        return {
            itemCategory: itemCategory,
            shouldProcessItem: $3e2618c407f9c204$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, prefs)
        };
    });
    else return {
        itemCategory: itemCategory,
        shouldProcessItem: $3e2618c407f9c204$var$isProcessingAllowedForCategoryAndPreferenceSync(itemCategory, preferencesOrPromise)
    };
}
const $3e2618c407f9c204$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    // start fetching both promises upfront, so they can resolve in parallel if needed
    const itemCategoryOrPromise = $3e2618c407f9c204$export$68b935e7ddb93762(itemKey, storageType, productName);
    const preferencesOrPromise = (0, $7umuC.getPreferencesMaybeSync)();
    if ($3e2618c407f9c204$var$isPromise(itemCategoryOrPromise)) return itemCategoryOrPromise.then((category)=>$3e2618c407f9c204$var$isProcessingAllowedForCategoryMaybeSync(category, preferencesOrPromise));
    else return $3e2618c407f9c204$var$isProcessingAllowedForCategoryMaybeSync(itemCategoryOrPromise, preferencesOrPromise);
};
const $3e2618c407f9c204$export$ffbb879d3fefb45c = ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    const categoryAndPreferenceOrPromise = $3e2618c407f9c204$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    if ($3e2618c407f9c204$var$isPromise(categoryAndPreferenceOrPromise)) return categoryAndPreferenceOrPromise.then(({ shouldProcessItem: shouldProcessItem })=>shouldProcessItem);
    else return categoryAndPreferenceOrPromise.shouldProcessItem;
};
const $3e2618c407f9c204$export$e7a3dca206fec6e2 = async ({ itemKey: itemKey, allowedCallback: allowedCallback = ()=>{}, blockedCallback: blockedCallback = ()=>{}, storageType: storageType, productName: productName })=>{
    let shouldProcessItem;
    let itemCategory = null;
    let wasAsync = true;
    if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
        let categoryAndPreferenceOrPromise = $3e2618c407f9c204$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
            itemKey: itemKey,
            storageType: storageType,
            productName: productName
        });
        if ($3e2618c407f9c204$var$isPromise(categoryAndPreferenceOrPromise)) // this should be the only await in the function.
        ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
        else {
            wasAsync = false;
            ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
        }
    } else {
        itemCategory = await $3e2618c407f9c204$export$ec8ce5237293e4a4(itemKey, storageType, productName);
        if (itemCategory === (0, $8f0nK.PreferenceCategory).StrictlyNecessary) shouldProcessItem = true;
        else {
            const preferences = await (0, $7umuC.getPreferences)();
            let hasPreferencesForCategory = false;
            if (!!preferences) {
                if (!!itemCategory) hasPreferencesForCategory = preferences[itemCategory];
            }
            shouldProcessItem = hasPreferencesForCategory;
        }
    }
    if (shouldProcessItem) allowedCallback === null || allowedCallback === void 0 || allowedCallback({
        wasAsync: wasAsync
    });
    else blockedCallback === null || blockedCallback === void 0 || blockedCallback({
        itemHasCategory: itemCategory != null,
        itemCategory: itemCategory,
        wasAsync: wasAsync
    });
    return shouldProcessItem;
};
const $3e2618c407f9c204$export$17e4a7e00d5b99d9 = async ({ itemKey: itemKey, storageType: storageType, productName: productName })=>{
    const categoryAndPreferenceOrPromise = $3e2618c407f9c204$var$getProcessingAllowedByPreferencesAndCategoryMaybeSync({
        itemKey: itemKey,
        storageType: storageType,
        productName: productName
    });
    let shouldProcessItem;
    let itemCategory;
    if ($3e2618c407f9c204$var$isPromise(categoryAndPreferenceOrPromise)) ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = await categoryAndPreferenceOrPromise);
    else ({ shouldProcessItem: shouldProcessItem, itemCategory: itemCategory } = categoryAndPreferenceOrPromise);
    return {
        isAllowed: shouldProcessItem,
        itemCategory: itemCategory
    };
};

});
parcelRegister("7umuC", function(module, exports) {
$parcel$export(module.exports, "getPreferences", () => $2208004b94a9ce70$export$1de6a888ae076ff8);
$parcel$export(module.exports, "getPreferencesMaybeSync", () => $2208004b94a9ce70$export$39c2cb6e65c1c16b);

var $aoZN9 = parcelRequire("aoZN9");
var $2manU = parcelRequire("2manU");

var $2Itg6 = parcelRequire("2Itg6");

var $afFiG = parcelRequire("afFiG");

var $cnMPG = parcelRequire("cnMPG");

var $2edmn = parcelRequire("2edmn");
async function $2208004b94a9ce70$export$1de6a888ae076ff8() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $aoZN9.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $cnMPG.getCookie)((0, $2Itg6.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $2edmn.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) {
            const consentToken = await (0, $afFiG.getConsentToken)();
            if ((0, $2manU.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $2edmn.unpackUserPreferencesCookie)(consentToken) : undefined;
        }
        return (0, $2edmn.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}
function $2208004b94a9ce70$export$39c2cb6e65c1c16b() {
    // when localConsentMode is on, don't make calls to ConsentHub
    if ((0, $aoZN9.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $cnMPG.getCookie)((0, $2Itg6.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY));
        if (!packedPrefs) return undefined;
        return (0, $2edmn.unpackUserPreferencesCookie)(packedPrefs);
    } else {
        let packedLocalPrefs = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_COOKIE_KEY));
        if (!packedLocalPrefs) return (0, $afFiG.getConsentToken)().then((consentToken)=>{
            if ((0, $2manU.isSSR)() && consentToken) window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign(window.__COOKIE_CONSENT_PREFERENCES__ || {}, {
                consentToken: consentToken
            });
            return consentToken ? (0, $2edmn.unpackUserPreferencesCookie)(consentToken) : undefined;
        });
        else return (0, $2edmn.unpackUserPreferencesCookie)(packedLocalPrefs);
    }
}

});
parcelRegister("2Itg6", function(module, exports) {
$parcel$export(module.exports, "LEGACY_ATLASSIAN_GDPR_COOKIE_KEY", () => $a3e5a35ceab28210$export$10d7db8e1a856fd8);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_COOKIE_KEY", () => $a3e5a35ceab28210$export$435de28e5b000487);
$parcel$export(module.exports, "ATLASSIAN_SHOW_BANNER_COOKIE_KEY", () => $a3e5a35ceab28210$export$4b17acc0e875ba2a);
$parcel$export(module.exports, "ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY", () => $a3e5a35ceab28210$export$23a1e02c3c0b0d08);
$parcel$export(module.exports, "TESTING_TOKEN_OVERRIDE_COOKIE_KEY", () => $a3e5a35ceab28210$export$37073d560ecebada);
$parcel$export(module.exports, "ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY", () => $a3e5a35ceab28210$export$5dc0026db06844f3);
$parcel$export(module.exports, "ACCEPT_ALL_PREFERENCES", () => $a3e5a35ceab28210$export$b28b5d760fe14a21);
$parcel$export(module.exports, "ONLY_NECESSARY_PREFERENCES", () => $a3e5a35ceab28210$export$4a12f9e99971760a);
$parcel$export(module.exports, "DEFAULT_PREFERENCES", () => $a3e5a35ceab28210$export$f0fd1d13ec1d48f2);
$parcel$export(module.exports, "V001_SCHEMA_KEY", () => $a3e5a35ceab28210$export$f95182b7aa141c57);
$parcel$export(module.exports, "V002_SCHEMA_KEY", () => $a3e5a35ceab28210$export$1f25427b34f9c405);
$parcel$export(module.exports, "V003_SCHEMA_KEY", () => $a3e5a35ceab28210$export$31deaeaebce525bb);

var $8f0nK = parcelRequire("8f0nK");
const $a3e5a35ceab28210$export$10d7db8e1a856fd8 = 'atl-gdpr-consent';
const $a3e5a35ceab28210$export$435de28e5b000487 = 'atl-bsc-consent-token';
const $a3e5a35ceab28210$export$4b17acc0e875ba2a = 'atl-bsc-show-banner';
const $a3e5a35ceab28210$export$f57af01b64fc97b8 = 'atl-bsc-current-locale';
const $a3e5a35ceab28210$export$23a1e02c3c0b0d08 = 'atl-bsc-consent-token-fallback';
const $a3e5a35ceab28210$export$37073d560ecebada = 'atl-testing-consents';
const $a3e5a35ceab28210$export$5dc0026db06844f3 = 'atl-bsc-banner-dismissed-time';
const $a3e5a35ceab28210$export$b28b5d760fe14a21 = {
    [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $8f0nK.PreferenceCategory).Functional]: true,
    [(0, $8f0nK.PreferenceCategory).Marketing]: true,
    [(0, $8f0nK.PreferenceCategory).Analytics]: true,
    [(0, $8f0nK.PreferenceCategory).Unknown]: true // Includes uncategorized cookies
};
const $a3e5a35ceab28210$export$4a12f9e99971760a = {
    [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: true,
    [(0, $8f0nK.PreferenceCategory).Functional]: false,
    [(0, $8f0nK.PreferenceCategory).Marketing]: false,
    [(0, $8f0nK.PreferenceCategory).Analytics]: false,
    [(0, $8f0nK.PreferenceCategory).Unknown]: false
};
const $a3e5a35ceab28210$export$f0fd1d13ec1d48f2 = {
    ...$a3e5a35ceab28210$export$4a12f9e99971760a,
    [(0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault]: true,
    [(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated]: false,
    [(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable]: true
};
const $a3e5a35ceab28210$export$f95182b7aa141c57 = '001';
const $a3e5a35ceab28210$export$1f25427b34f9c405 = '002';
const $a3e5a35ceab28210$export$31deaeaebce525bb = '003';

});

parcelRegister("afFiG", function(module, exports) {
$parcel$export(module.exports, "getConsentToken", () => $889764a09b697e87$export$f1b8f2ca713fca08);

var $3H4LK = parcelRequire("3H4LK");

var $2Itg6 = parcelRequire("2Itg6");

var $cnMPG = parcelRequire("cnMPG");

var $mXH3S = parcelRequire("mXH3S");

var $9sIkA = parcelRequire("9sIkA");

var $tBh9k = parcelRequire("tBh9k");
/**
 * Module-level cache of the in-flight ConsentHub fetch promise.
 * Cleared as soon as the promise settles (resolved or rejected).
 *
 * Without this, N concurrent callers that all find the consent cookie absent
 * would each independently fire a fetch to ConsentHub, causing a request
 * fan-out on every page load where multiple components call getPreferences()
 * simultaneously.
 *
 * Only active when `platform_bsc_deduplicate_consent_hub_fetch` is ON.
 */ let $889764a09b697e87$var$inFlightConsentToken = null;
const $889764a09b697e87$var$_getConsentToken = async ()=>{
    const fallbackConsentToken = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const consentData = await (0, $tBh9k.getValidConsentData)(fallbackConsentToken);
    if (consentData) {
        const { consentToken: consentToken, consentTimestamp: consentTimestamp } = consentData;
        /*** TESTING OVERRIDES ***/ const potentiallyOverriddenConsentToken = (0, $mXH3S.overrideConsentTokenForLiveTesting)(consentToken);
        const testingConsentOverride = (0, $cnMPG.getCookie)((0, $2Itg6.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
        const hasTestingConsents = !!(testingConsentOverride || testingConsentOverride === '');
        if (hasTestingConsents) {
            // If testing, set the cookies accordingly so we can test with any overridden token data.
            (0, $9sIkA.setShouldShowBannerCookie)(potentiallyOverriddenConsentToken);
            (0, $9sIkA.setConsentTokenCookie)(potentiallyOverriddenConsentToken);
            // Unfortunately, if you've previously saved to ConsentHub, that data will always resolve, so to simulate ConsentHub
            // being down, or the token data being bunk/invalid, we must set the testing token to an empty string. This will
            // return undefined here and skip any unpacking of the token. Otherwise, it will use the overridden token value.
            return potentiallyOverriddenConsentToken === '' ? undefined : potentiallyOverriddenConsentToken;
        }
        // At this point, all data should be valid and overridden for testing as needed, so set those cookies!
        (0, $9sIkA.setRequiredConsentCookies)(potentiallyOverriddenConsentToken, consentTimestamp);
        return consentToken;
    }
    return undefined;
};
const $889764a09b697e87$export$f1b8f2ca713fca08 = ()=>{
    if ((0, $3H4LK.fg)('platform_bsc_deduplicate_consent_hub_fetch')) {
        // Deduplicated path: N concurrent callers share a single in-flight promise so only
        // one ConsentHub fetch fires per page load regardless of how many components call
        // getPreferences() simultaneously.
        if ($889764a09b697e87$var$inFlightConsentToken) return $889764a09b697e87$var$inFlightConsentToken;
        $889764a09b697e87$var$inFlightConsentToken = $889764a09b697e87$var$_getConsentToken().finally(()=>{
            $889764a09b697e87$var$inFlightConsentToken = null;
        });
        return $889764a09b697e87$var$inFlightConsentToken;
    }
    // Original path: call through directly (one fetch per caller).
    return $889764a09b697e87$var$_getConsentToken();
};

});
parcelRegister("cnMPG", function(module, exports) {
$parcel$export(module.exports, "getCookie", () => $c8f6eee5f460fffe$export$4be65e66cfa2648a);

var $fJXyP = parcelRequire("fJXyP");

var $3H4LK = parcelRequire("3H4LK");

var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");
function $c8f6eee5f460fffe$export$4be65e66cfa2648a(key) {
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch')) // Get the cookie without package operational events
    // when master killswitch is enabled
    return key ? (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get();
    try {
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedGetCookie',
            attributes: {
                cookieKey: key
            }
        });
        return key ? (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get(key) : (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get();
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedGetCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use get cookie. ${e.message || ''}`
        });
    }
}

});

parcelRegister("mXH3S", function(module, exports) {
$parcel$export(module.exports, "overrideConsentTokenForLiveTesting", () => $e14bd002fe5cb083$export$b5282052fc15e1ae);

var $2Itg6 = parcelRequire("2Itg6");

var $cnMPG = parcelRequire("cnMPG");
const $e14bd002fe5cb083$export$b5282052fc15e1ae = (genuineConsentToken)=>{
    // The existence of this cookie will make it look like fetched ConsentHub data is missing
    // You can set it to undefined yourself/empty string, or an actual default value.
    const tokenOverride = (0, $cnMPG.getCookie)((0, $2Itg6.TESTING_TOKEN_OVERRIDE_COOKIE_KEY));
    // Note: Clear this cookie out of your browser when you're done testing empty data sets
    // Or you'll be stuck seeing the banner and never actually consenting on the UI
    return tokenOverride || genuineConsentToken;
};

});

parcelRegister("9sIkA", function(module, exports) {
$parcel$export(module.exports, "setConsentTokenCookie", () => $7fb4143a52d8c0f5$export$8e560d0760f733a2);
$parcel$export(module.exports, "setConsentTokenFallbackCookie", () => $7fb4143a52d8c0f5$export$133cd762b0f705a2);
$parcel$export(module.exports, "setShouldShowBannerCookie", () => $7fb4143a52d8c0f5$export$99ecece88c58d938);
$parcel$export(module.exports, "setRequiredConsentCookies", () => $7fb4143a52d8c0f5$export$b3365240280cb3c3);

var $3H4LK = parcelRequire("3H4LK");

var $5zn62 = parcelRequire("5zn62");
var $KilRp = parcelRequire("KilRp");

var $2Itg6 = parcelRequire("2Itg6");

var $8sIDt = parcelRequire("8sIDt");

var $a5OUx = parcelRequire("a5OUx");
const $7fb4143a52d8c0f5$var$LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES = 10;
const $7fb4143a52d8c0f5$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 50;
const $7fb4143a52d8c0f5$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = 70;
const $7fb4143a52d8c0f5$export$6e0b780517c88191 = ()=>{
    // Random offset is 0-20 minutes inclusive, so the final lifetime spreads across 50-70 minutes.
    const randomizedOffsetMinutes = Math.floor(Math.random() * ($7fb4143a52d8c0f5$var$MAX_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES - $7fb4143a52d8c0f5$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + 1));
    // Spread cookie expiration times to smooth traffic spikes to ConsentHub.
    return $7fb4143a52d8c0f5$var$MIN_RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES + randomizedOffsetMinutes;
};
// Pick once per module load so both required consent cookies share the same spread-out expiry.
const $7fb4143a52d8c0f5$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES = $7fb4143a52d8c0f5$export$6e0b780517c88191();
const $7fb4143a52d8c0f5$var$getRequiredConsentCookieExpiryDate = ()=>{
    const expiryDate = new Date();
    const lifetimeInMinutes = (0, $3H4LK.fg)('platform_bsc_cookie_lifetime') ? $7fb4143a52d8c0f5$var$RANDOMIZED_CONSENT_COOKIE_LIFETIME_MINUTES : $7fb4143a52d8c0f5$var$LEGACY_CONSENT_COOKIE_LIFETIME_MINUTES;
    expiryDate.setTime(expiryDate.getTime() + lifetimeInMinutes * 60000);
    return expiryDate;
};
const $7fb4143a52d8c0f5$export$8e560d0760f733a2 = (consentToken)=>{
    (0, $a5OUx.setStrictlyNecessaryCookie)((0, $2Itg6.ATLASSIAN_CONSENT_COOKIE_KEY), consentToken, {
        expires: $7fb4143a52d8c0f5$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $KilRp.Logger).debug(`Set Consent Token ${(0, $2Itg6.ATLASSIAN_CONSENT_COOKIE_KEY)} ${consentToken}`);
};
const $7fb4143a52d8c0f5$export$133cd762b0f705a2 = (consentToken)=>{
    const inOneYear = new Date();
    inOneYear.setFullYear(inOneYear.getFullYear() + 1);
    (0, $a5OUx.setStrictlyNecessaryCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY), consentToken, {
        expires: inOneYear,
        path: '/'
    });
    (0, $KilRp.Logger).debug(`set fallback consent token: ${(0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)} ${consentToken}`);
};
const $7fb4143a52d8c0f5$export$99ecece88c58d938 = (consentToken, consentTimestamp)=>{
    // Since we have no good way to reference this as a global state object, we want to precompute and store the
    // banner visibility in a temporary, session-scope cookie (same expiry as the other cookies), which we can
    // lookup in the UI as needed
    const bannerVisibility = (0, $8sIDt.getBannerVisibility)({
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    });
    const shouldShowBanner = (0, $5zn62.getBitValueFromBool)(!!bannerVisibility);
    (0, $a5OUx.setStrictlyNecessaryCookie)((0, $2Itg6.ATLASSIAN_SHOW_BANNER_COOKIE_KEY), shouldShowBanner, {
        expires: $7fb4143a52d8c0f5$var$getRequiredConsentCookieExpiryDate(),
        path: '/'
    });
    (0, $KilRp.Logger).debug(`set shouldShowBannerCookie: ${(0, $2Itg6.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)} ${shouldShowBanner}`);
};
const $7fb4143a52d8c0f5$export$b3365240280cb3c3 = (consentToken, consentTimestamps)=>{
    $7fb4143a52d8c0f5$export$8e560d0760f733a2(consentToken);
    $7fb4143a52d8c0f5$export$99ecece88c58d938(consentToken, consentTimestamps);
};

});
parcelRegister("5zn62", function(module, exports) {
$parcel$export(module.exports, "getBitValueFromBool", () => $347224423d7e16f6$export$929f1500428a1fc8);
$parcel$export(module.exports, "getBoolFromBitValue", () => $347224423d7e16f6$export$27647458f3cf29d2);
const $347224423d7e16f6$export$929f1500428a1fc8 = (value)=>{
    return Number(value).toString();
};
const $347224423d7e16f6$export$27647458f3cf29d2 = (bitValue)=>{
    if (bitValue) return !!Number(bitValue);
};

});

parcelRegister("8sIDt", function(module, exports) {
$parcel$export(module.exports, "getBannerVisibility", () => $4d22d5560164443b$export$bfdb9f82a9194c1e);

var $fJXyP = parcelRequire("fJXyP");

var $2manU = parcelRequire("2manU");

var $5zn62 = parcelRequire("5zn62");

var $2Itg6 = parcelRequire("2Itg6");

var $gCY8Y = parcelRequire("gCY8Y");

var $cnMPG = parcelRequire("cnMPG");

var $2edmn = parcelRequire("2edmn");
const $4d22d5560164443b$var$getUserIsAuthenticatedBit = (consentToken)=>{
    const { isV002: isV002 } = (0, $2edmn.checkTokenVersionValidity)(consentToken);
    let userIsAuthenticatedBit = consentToken[8]; // V3 position
    if (isV002) {
        // Schema has changed in V3, V2 had this bit in a different position. Logged out users will have this bit set to 1
        const legacyV2ConsentDataUnavailableBit = consentToken[7];
        // We can backfill the UserIsAuthenticated bit by flipping the bit value. If ConsentHub was unavailable, that means they were logged out.
        userIsAuthenticatedBit = legacyV2ConsentDataUnavailableBit === '1' ? '0' : '1';
    }
    return userIsAuthenticatedBit;
};
const $4d22d5560164443b$var$shouldShowBannerForLoggedOutDefaultToken = (fallbackConsentToken)=>{
    // Logged out + default consents + fallback: we have a discrepancy where ConsentHub is down/unavailable, or they're just logged out,
    // but the user has actually consented previously (which essentially the only way to save to the fallback to begin with)
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $4d22d5560164443b$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $5zn62.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $gCY8Y.checkIfTokenIsDefault)(fallbackConsentToken);
        const localOnlyUsersHasGenuineConsents = isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        // If the fallback is from a logged out consent (localOnlyConsent), they're currently
        // logged out and also saved while logged out, so don't show the banner
        if (localOnlyUsersHasGenuineConsents) return !fallbackTokenHasGenuineConsents;
        const loggedOutUserPreviouslyConsentedWhileLoggedIn = !isLoggedOutFallbackConsents && fallbackTokenHasGenuineConsents;
        if (loggedOutUserPreviouslyConsentedWhileLoggedIn) // Or if it is from a logged in consent, and they've consented somewhere (they must have)
        // then we should not show the banner, as their consents aren't "stale", we're just in a situation
        // where the original token has expired so they get a default set, but we should hide the banner
        return false;
    }
    // Defaults consents + unauthed + missing a fallback, show the banner, as they haven't consented in the past year
    return true;
};
const $4d22d5560164443b$var$shouldShowBannerForLoggedOutUser = ({ consentToken: consentToken, fallbackConsentToken: fallbackConsentToken })=>{
    const tokenIsADefaultConsent = !!(0, $gCY8Y.checkIfTokenIsDefault)(consentToken);
    // Handle default token flow
    if (tokenIsADefaultConsent) return $4d22d5560164443b$var$shouldShowBannerForLoggedOutDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    // If they're a legacy/V2 user who hasn't consented, this will have checked the V3 "is default" bit to note they've consented or not
    const localOnlyUserHasConsented = (0, $gCY8Y.hasLegacyV2TokenConsentedPreviously)(consentToken) || !tokenIsADefaultConsent;
    if (localOnlyUserHasConsented) // LocalOnly users will never have a timestamp to validate against since they can't talk to ConsentHub
    // Existence of fallback consents means they've consented in the past year and do not have stale consents, do not show banner
    return fallbackConsentToken ? false : true;
    // This case should never be hit: if it's not a default, but they haven't consented... what is it? Add a catch-all "show banner"
    return true;
};
const $4d22d5560164443b$var$shouldShowBannerForLoggedInDefaultToken = (fallbackConsentToken)=>{
    // Defaults + fallback + logged in, but they consented while they were previously logged out:
    if (fallbackConsentToken) {
        const fallbackUserIsAuthenticatedBit = $4d22d5560164443b$var$getUserIsAuthenticatedBit(fallbackConsentToken);
        const isLoggedOutFallbackConsents = !(0, $5zn62.getBoolFromBitValue)(fallbackUserIsAuthenticatedBit);
        const fallbackTokenHasGenuineConsents = !(0, $gCY8Y.checkIfTokenIsDefault)(fallbackConsentToken);
        if (fallbackTokenHasGenuineConsents) {
            // Defaults + logged in user + consented <1yr ago, but while logged out
            if (isLoggedOutFallbackConsents) /*
            They've consented, and thus stored a fallback while logged out (fallback's CH bit is 1),
            then fetched from CH but get empty data (since they couldn't save to CH on their initial "save"), which sets authed consent defaults (bit 0)
             UX Problem:
            Since they have genuinely consented within the past year, the ideal UX would be to not show the banner...
            But if we do not re-prompt here in an effort to recapture their consents, the opportunity for them/us to actually get consents in the DB
            is infrequent (either via Account Privacy Page or once this fallback expires in a year).
             Example:
            While logged out, they consent in Trello, so we store the unauthed fallback token, then log in on Trello. If we hide the banner when the
            fallback exists, if that user later goes to Confluence's cookie domain (where they have no fallback), it would show the banner
            because they have no stored consents on CH, and no fallback in that domain, but are logged in. Repeat for every new domain...
             We could be fancy and save under the hood for them if they have a fallback, but to ensure we don't copy stale/different consents saved in a fallback
            to ConsentHub on their behalf, we should just re-prompt them for consents now that they're logged in. This way, they will actually
            persist their choices, and when loading other domains/products, there will be a Source of Truth to reference and not show the banner.
             Ultimately, this feels like the more "correct" way to handle this situation, as the cost of showing the banner again to officially capture
            consents feels lower than the potential cost of relying on fallbacks in all situations/across all domains for this user for the next whole year
             Result: Show the banner again and hope we officially recapture consents this time around
          */ return true;
            // Defaults + logged in user + consented <1yr ago, but while logged in
            // This scenario shouldn't happen, or if it does, it's in a phase where we haven't fetched preferences
            // yet, so hide the banner for now
            return false;
        }
        // Default token + default fallback (authed or unauthed) mean we've likely stored this
        // fallback from SSR's initialPreferences flow in. Fallbacks should not be saved with defaults intentionally
        // But sometimes we copy an existing token to the fallback via SSR flow, so let's treat this
        // as an bunk fallback, and show the banner as they haven't consented
        return true;
    }
    // Default consent token + logged in user + no fallback = they haven't consented in the past year, show banner
    return true;
};
const $4d22d5560164443b$var$shouldShowBannerForLoggedInUser = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsentToken })=>{
    // Handle default token flow
    const tokenIsADefaultConsent = !!(0, $gCY8Y.checkIfTokenIsDefault)(consentToken);
    if (tokenIsADefaultConsent) return $4d22d5560164443b$var$shouldShowBannerForLoggedInDefaultToken(fallbackConsentToken);
    // Handle genuine token flow
    if (consentTimestamp) {
        // If the user has genuine consents, and a timestamp, check if they're stale (> 1yr old), show the banner if they're stale
        const showBannerIfStale = (0, $gCY8Y.checkIfConsentsAreStale)(consentTimestamp);
        return showBannerIfStale;
    }
    // Genuine consents + no timestamp— we're in a situation where we've been passed cached cookie data instead of CH response data,
    // so the only way to determine staleness is through the absence of the fallback.
    // Technically, we could assume since they've consented recently, we don't have to show the banner here but... to be safe we should
    return fallbackConsentToken ? false : true;
};
const $4d22d5560164443b$export$bfdb9f82a9194c1e = ({ consentToken: consentToken, consentTimestamp: consentTimestamp, fallbackConsentToken: fallbackConsents }, ssrOptions)=>{
    // Consent tokens are either a set of defaults, or genuine (persisted to the remote, or saved in an entire local-only flow via fallbacks).
    // the deciding factor is whether or not your consents are stale/fresh, either via the existence/absence of a fallback (a.k.a consented within a year or not)
    // or if the ConsentHub response data of a user's consent has a timestamp that is older than a year
    // Detect if js-cookie has been replaced with SSR-safe version (Confluence only)
    const isJsCookieSSRSafe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).__SSR_INITIALIZE_COOKIES__ === 'function';
    // Jira passes getCookie explicitly via ssrOptions - it works on both SSR and CSR.
    const ssrFriendlyGetCookie = ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.getCookie;
    let fallbackConsentToken;
    if (ssrFriendlyGetCookie) fallbackConsentToken = fallbackConsents || ssrFriendlyGetCookie((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    else fallbackConsentToken = (0, $2manU.isSSR)() ? fallbackConsents || (isJsCookieSSRSafe ? (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) : undefined) : fallbackConsents || (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    let userIsAuthenticatedBit = $4d22d5560164443b$var$getUserIsAuthenticatedBit(consentToken);
    const isLoggedOutConsentToken = !(0, $5zn62.getBoolFromBitValue)(userIsAuthenticatedBit);
    let isBannerVisible = true; // By default, show the banner to every user
    // Unauthed/logged out user flow, should never receive a timestamp because logged out users can't communicate to ConsentHub
    if (isLoggedOutConsentToken) isBannerVisible = $4d22d5560164443b$var$shouldShowBannerForLoggedOutUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    });
    else // Authed/logged in user flow
    isBannerVisible = $4d22d5560164443b$var$shouldShowBannerForLoggedInUser({
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken,
        consentTimestamp: consentTimestamp
    });
    return isBannerVisible;
};

});
parcelRegister("gCY8Y", function(module, exports) {
$parcel$export(module.exports, "hasLegacyV2TokenConsentedPreviously", () => $9342052ad934b870$export$42b0ca8aba2631e4);
$parcel$export(module.exports, "checkIfTokenIsDefault", () => $9342052ad934b870$export$497a647f0eb30ef4);
$parcel$export(module.exports, "serializeConsents", () => $9342052ad934b870$export$92ba0b2fe50f90df);
$parcel$export(module.exports, "deserializeConsents", () => $9342052ad934b870$export$bfa0c91662787fb0);
$parcel$export(module.exports, "getConsentTimestamp", () => $9342052ad934b870$export$13e4cff933f26b03);
$parcel$export(module.exports, "checkIfConsentsAreStale", () => $9342052ad934b870$export$3387347b75450ae1);
$parcel$export(module.exports, "hasPrefetchedDataConsents", () => $9342052ad934b870$export$7133f415a79804e8);
$parcel$export(module.exports, "StatusCodeError", () => $9342052ad934b870$export$a79c0ea3d7c2444a);

var $5zn62 = parcelRequire("5zn62");

var $2Itg6 = parcelRequire("2Itg6");

var $cnMPG = parcelRequire("cnMPG");

var $8f0nK = parcelRequire("8f0nK");

var $bDGzl = parcelRequire("bDGzl");
const $9342052ad934b870$var$isLegacyGeoTargetingV2Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV2Schema = version === (0, $2Itg6.V002_SCHEMA_KEY);
    return isV2Schema;
};
const $9342052ad934b870$var$isLegacyV1Token = (consentToken)=>{
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV1Schema = version === (0, $2Itg6.V001_SCHEMA_KEY);
    return isV1Schema;
};
const $9342052ad934b870$export$42b0ca8aba2631e4 = (consentToken)=>{
    if ($9342052ad934b870$var$isLegacyGeoTargetingV2Token(consentToken)) {
        // If we're looking at a V2 token and they have ANY saved 'consentedUnderXX' bits,
        // we know it must be a set of valid consents instead of defaults
        const consentedUnderGDPR = consentToken[8] === '1';
        const consentedUnderCPRA = consentToken[9] === '1';
        const consentedUnderLGPD = consentToken[10] === '1';
        const consentedUnderFADP = consentToken[11] === '1';
        const hasConsentedPreviously = consentedUnderGDPR || consentedUnderCPRA || consentedUnderLGPD || consentedUnderFADP;
        return hasConsentedPreviously;
    }
    return false;
};
const $9342052ad934b870$export$497a647f0eb30ef4 = (consentToken)=>{
    const isLegacyV1ConsentToken = $9342052ad934b870$var$isLegacyV1Token(consentToken);
    const isLegacyV2ConsentToken = $9342052ad934b870$var$isLegacyGeoTargetingV2Token(consentToken);
    if (isLegacyV1ConsentToken) // We only add a legacy `atl-gdpr-consents` cookie if a user has consented,
    // so if we see a V1 token, we know it must be a set of valid consents
    // instead of default consents
    return false;
    if (isLegacyV2ConsentToken) {
        const legacyTokenHasConsents = $9342052ad934b870$export$42b0ca8aba2631e4(consentToken);
        return !legacyTokenHasConsents;
    }
    // Check 'isDefaultConsentBit' bit for V003 Schema tokens
    const isDefaultTokenV3 = (0, $5zn62.getBoolFromBitValue)(consentToken[7]);
    return isDefaultTokenV3;
};
const $9342052ad934b870$export$c42e1a74e60f4d73 = (consentsUnavailable)=>{
    const version = (0, $2Itg6.V003_SCHEMA_KEY);
    // DEFAULT_PREFERENCES now has the default boolean baked into it, so we don't need to set it here
    const serializedBits = Object.entries((0, $2Itg6.DEFAULT_PREFERENCES)).reduce((acc, [key, val])=>{
        // Skip the STRICTLY_NECESSARY as it's always allowed
        if (key === (0, $8f0nK.PreferenceCategory).StrictlyNecessary) return acc;
        if (key === (0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated) {
            // If consents are missing when setting these defaults, the user will be logged out,
            // so pack this info into the consent token bits
            const userIsAuthed = !consentsUnavailable;
            return acc + (0, $5zn62.getBitValueFromBool)(userIsAuthed);
        }
        if (key === (0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable) // If consents are missing when setting these defaults, the user will be logged out,
        // so pack this info into the consent token bits
        return acc + (0, $5zn62.getBitValueFromBool)(!!consentsUnavailable);
        return acc + (0, $5zn62.getBitValueFromBool)(val);
    }, '');
    return `${version}${serializedBits}`;
};
const $9342052ad934b870$export$42a0b3fb1e53e7b9 = (consents)=>{
    var _consents$find, _consents$find2, _consents$find3, _consents$find4;
    const version = (0, $2Itg6.V003_SCHEMA_KEY);
    // As 'strictlyNecessaryConsent' would always be allowed, we don't store it in the cookie or use ConsentHub
    const functionalConsent = (0, $5zn62.getBitValueFromBool)(!!((_consents$find = consents.find((key)=>key.key === (0, $bDGzl.ConsentHubKey).Functional)) !== null && _consents$find !== void 0 && _consents$find.granted));
    const analyticsConsent = (0, $5zn62.getBitValueFromBool)(!!((_consents$find2 = consents.find((key)=>key.key === (0, $bDGzl.ConsentHubKey).Analytics)) !== null && _consents$find2 !== void 0 && _consents$find2.granted));
    const marketingConsent = (0, $5zn62.getBitValueFromBool)(!!((_consents$find3 = consents.find((key)=>key.key === (0, $bDGzl.ConsentHubKey).Marketing)) !== null && _consents$find3 !== void 0 && _consents$find3.granted));
    const unknownConsent = (0, $5zn62.getBitValueFromBool)(!!((_consents$find4 = consents.find((key)=>key.key === (0, $bDGzl.ConsentHubKey).Unknown)) !== null && _consents$find4 !== void 0 && _consents$find4.granted));
    // As these consents were returned from the server, ConsentHub is obviously available, they're logged in, and aren't defaults
    const isDefaultToken = 0;
    const userIsAuthenticated = 1;
    const consentHubDataUnavailable = 0;
    return [
        version,
        functionalConsent,
        analyticsConsent,
        marketingConsent,
        unknownConsent,
        isDefaultToken,
        userIsAuthenticated,
        consentHubDataUnavailable
    ].join('');
};
const $9342052ad934b870$export$92ba0b2fe50f90df = ({ consents: consents })=>{
    if (!consents) {
        // When generating consents for an unauthenticated user, use the fallback token if it exists
        // This circumvents us setting defaults for them if their token has expired, but they have consented previously
        const existingFallbackToken = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
        if (existingFallbackToken) return existingFallbackToken;
        // User is unauthed, will only use local consenting, consent data will also be unavailable
        return $9342052ad934b870$export$c42e1a74e60f4d73(true); // e.g. 0030000101
    } else if (consents.length === 0) // User is authed but has no consents in the system, so use defaults in the interim, consentData must be available
    return $9342052ad934b870$export$c42e1a74e60f4d73(); // e.g. 0030000110
    else // User is authed and has consents in the system
    return $9342052ad934b870$export$42a0b3fb1e53e7b9(consents); // e.g. 0030110110
};
const $9342052ad934b870$export$bfa0c91662787fb0 = (unpackedUserPreferences, displayedTextMap)=>{
    const validConsentHubCookieConsents = [
        (0, $8f0nK.PreferenceCategory).StrictlyNecessary,
        (0, $8f0nK.PreferenceCategory).Functional,
        (0, $8f0nK.PreferenceCategory).Analytics,
        (0, $8f0nK.PreferenceCategory).Marketing,
        (0, $8f0nK.PreferenceCategory).Unknown
    ];
    const consentKeyMap = {
        [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: (0, $bDGzl.ConsentHubKey).StrictlyNecessary,
        [(0, $8f0nK.PreferenceCategory).Functional]: (0, $bDGzl.ConsentHubKey).Functional,
        [(0, $8f0nK.PreferenceCategory).Analytics]: (0, $bDGzl.ConsentHubKey).Analytics,
        [(0, $8f0nK.PreferenceCategory).Marketing]: (0, $bDGzl.ConsentHubKey).Marketing,
        [(0, $8f0nK.PreferenceCategory).Unknown]: (0, $bDGzl.ConsentHubKey).Unknown
    };
    const consentRecords = validConsentHubCookieConsents.map((consentKey)=>{
        const key = consentKeyMap[consentKey];
        return {
            key: key,
            granted: !!unpackedUserPreferences[consentKey],
            gatheredTs: new Date().toISOString(),
            displayedText: displayedTextMap[consentKey]
        };
    });
    return consentRecords;
};
const $9342052ad934b870$export$13e4cff933f26b03 = ({ consents: consents })=>{
    if (consents && consents.length) {
        // As consents can be updated individually, we need to find the most recent timestamp to use as "most recent consent"
        const timestamps = consents.map((consent)=>{
            return new Date(consent.updatedTs).getTime();
        });
        const maxTimestamp = Math.max(...timestamps);
        const mostRecentConsentTimestamp = new Date(maxTimestamp).toISOString();
        return mostRecentConsentTimestamp;
    }
};
const $9342052ad934b870$export$3387347b75450ae1 = (consentTimestamp)=>{
    // Privacy has determined that we should re-prompt users for consent if they haven't
    // consented in over a year regardless, because they're legally stale/expired
    let consentedOverAYearAgo = false;
    if (consentTimestamp) {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        consentedOverAYearAgo = new Date(consentTimestamp) < oneYearAgo;
    }
    return consentedOverAYearAgo;
};
const $9342052ad934b870$export$7133f415a79804e8 = (preferences)=>{
    if (!preferences) return false;
    const prefetchedToken = 'consentToken' in preferences && preferences.consentToken;
    const prefetchedTokenIsDefault = $9342052ad934b870$export$497a647f0eb30ef4(prefetchedToken || '');
    const hasLegitConsentToken = prefetchedToken && !prefetchedTokenIsDefault;
    const prefetchedConsents = 'consents' in preferences && preferences.consents;
    const hasLegitConsents = prefetchedConsents && Array.isArray(prefetchedConsents) && prefetchedConsents.length > 0;
    return Boolean(hasLegitConsentToken || hasLegitConsents);
};
class $9342052ad934b870$export$a79c0ea3d7c2444a extends Error {
    constructor(message, status){
        super(message);
        this.status = status;
        Object.setPrototypeOf(this, $9342052ad934b870$export$a79c0ea3d7c2444a.prototype);
        // Captures the stack trace (for environments that support it)
        if (Error.captureStackTrace) Error.captureStackTrace(this, $9342052ad934b870$export$a79c0ea3d7c2444a);
        this.name = 'StatusCodeError';
    }
}

});
parcelRegister("bDGzl", function(module, exports) {
$parcel$export(module.exports, "ConsentHubKey", () => $335b2be848a98b05$export$31140359b1e505cf);
var $335b2be848a98b05$export$31140359b1e505cf = /*#__PURE__*/ function(ConsentHubKey) {
    ConsentHubKey["StrictlyNecessary"] = "strictlyNecessaryCookies";
    ConsentHubKey["Functional"] = "functionalCookies";
    ConsentHubKey["Analytics"] = "performanceCookies";
    ConsentHubKey["Marketing"] = "targetingCookies";
    ConsentHubKey["Unknown"] = "unknownCookies";
    return ConsentHubKey;
}({});

});


parcelRegister("2edmn", function(module, exports) {
$parcel$export(module.exports, "checkTokenVersionValidity", () => $56218bf982d32d30$export$64b31470e8522819);
$parcel$export(module.exports, "packUserPreferences", () => $56218bf982d32d30$export$3199823fec979bd1);
$parcel$export(module.exports, "unpackUserPreferencesCookie", () => $56218bf982d32d30$export$8d213cb390bab4fa);
$parcel$export(module.exports, "initialPreferencesAreMissing", () => $56218bf982d32d30$export$67f70eb55341bd29);
$parcel$export(module.exports, "initializePreferencesData", () => $56218bf982d32d30$export$7962405c3ca274b1);

var $aoZN9 = parcelRequire("aoZN9");

var $5zn62 = parcelRequire("5zn62");

var $2Itg6 = parcelRequire("2Itg6");

var $gCY8Y = parcelRequire("gCY8Y");

var $8f0nK = parcelRequire("8f0nK");
const $56218bf982d32d30$export$64b31470e8522819 = (consentToken)=>{
    // A token can technically be bad data (alphanumeric instead of binary) but we should fail gracefully if so
    if (consentToken.length < 3) // Wrong format, no version
    return {
        isValid: false,
        isV001: false,
        isV002: false,
        isV003: false
    };
    const version = consentToken[0] + consentToken[1] + consentToken[2];
    const isV001 = version === (0, $2Itg6.V001_SCHEMA_KEY) && consentToken.length === 7;
    const isV002 = version === (0, $2Itg6.V002_SCHEMA_KEY) && consentToken.length === 12;
    const isV003 = version === (0, $2Itg6.V003_SCHEMA_KEY) && consentToken.length === 10;
    // We support version 001, 002, 003 only
    const isSupportedVersion = [
        (0, $2Itg6.V001_SCHEMA_KEY),
        (0, $2Itg6.V002_SCHEMA_KEY),
        (0, $2Itg6.V003_SCHEMA_KEY)
    ].includes(version);
    const isValid = isSupportedVersion && (isV001 || isV002 || isV003);
    return {
        isValid: isValid,
        isV001: isV001,
        isV002: isV002,
        isV003: isV003
    };
};
/* Schema Version 001:
---------------------------------------------------
  - Format 0000000
  - 001 (schema version 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies disabled/enabled)
*/ const $56218bf982d32d30$var$packPrefsVersion001 = (userPreferences)=>{
    const version = (0, $2Itg6.V001_SCHEMA_KEY);
    return [
        version,
        (0, $5zn62.getBitValueFromBool)(userPreferences.FUNCTIONAL),
        (0, $5zn62.getBitValueFromBool)(userPreferences.ANALYTICS),
        (0, $5zn62.getBitValueFromBool)(userPreferences.MARKETING),
        (0, $5zn62.getBitValueFromBool)(userPreferences.UNKNOWN)
    ].join('');
};
const $56218bf982d32d30$var$unpackPrefsVersion001 = (userPreferencesCookie)=>{
    if (userPreferencesCookie.length !== 7) // Wrong length for version 001
    return;
    return {
        [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $8f0nK.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $8f0nK.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $8f0nK.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $8f0nK.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1'
    };
};
/* Schema Version 002 ***** DEPRECATED *****
---------------------------------------------------
  - Format 000000000000
  - 002 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, consent records are unavailable from ConsentHub (logged out) - yes/no)
  - 0/1 (1 digit, consents saved while in GDPR locale (Europe) - yes/no)
  - 0/1 (1 digit, consents saved while in CPRA locale (CPRA will act as 'all USA' bucket) - yes/no)
  - 0/1 (1 digit, consents saved while in LGPD locale (Brazil) - yes/no)
  - 0/1 (1 digit, consents saved while in FADP locale (Switzerland) - yes/no)
*/ const $56218bf982d32d30$var$packPrefsVersion002 = (userPreferences)=>{
    // As we want to slowly kill off any V002 preferences, if we're provided one for some reason
    // internally convert it to a V003 preference to drop contextual GeoIP details
    const version = (0, $2Itg6.V003_SCHEMA_KEY);
    const hasConsentedPreviously = userPreferences[(0, $8f0nK.ConsentPreferenceV2).ConsentedUnderGDPR] || userPreferences[(0, $8f0nK.ConsentPreferenceV2).ConsentedUnderCPRA] || userPreferences[(0, $8f0nK.ConsentPreferenceV2).ConsentedUnderLGPD] || userPreferences[(0, $8f0nK.ConsentPreferenceV2).ConsentedUnderFADP];
    const isDefaultConsentBit = !hasConsentedPreviously;
    // As we've broken out authentication insights/context from "ConsentDataUnavailable" bit in V3,
    // and it does not exist, we will backfill the value based on the previous bit state
    const existingConsentDataUnavailableBit = userPreferences[(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable];
    const userIsAuthenticatedBit = !existingConsentDataUnavailableBit;
    return [
        version,
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Functional]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Analytics]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Marketing]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Unknown]),
        (0, $5zn62.getBitValueFromBool)(isDefaultConsentBit),
        (0, $5zn62.getBitValueFromBool)(userIsAuthenticatedBit),
        (0, $5zn62.getBitValueFromBool)(existingConsentDataUnavailableBit)
    ].join('');
};
const $56218bf982d32d30$var$unpackPrefsVersion002 = (userPreferencesCookie)=>{
    // If the provided V002 token has consented anywhere, we'll drop the contextual GeoIP bits and
    // convert it to a V003 schema
    const isADefaultConsentToken = (0, $gCY8Y.checkIfTokenIsDefault)(userPreferencesCookie);
    // Backfill the value based on the previous "ConsentDataUnavailable" bit state as we've broken this contextual info out
    const consentDataUnavailable = userPreferencesCookie[7] === '1';
    const userIsDeemedAuthenticated = !consentDataUnavailable;
    return {
        ...$56218bf982d32d30$var$unpackPrefsVersion003(userPreferencesCookie),
        [(0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault]: !!isADefaultConsentToken,
        [(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated]: userIsDeemedAuthenticated,
        [(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable]: consentDataUnavailable
    };
};
/* Schema Version 003
---------------------------------------------------
  - Format 0000000000
  - 003 (schema version, 3 digits)
  - 0/1 (1 digit, FUNCTIONAL cookies - disabled/enabled)
  - 0/1 (1 digit, ANALYTICS cookies - disabled/enabled)
  - 0/1 (1 digit, MARKETING cookies - disabled/enabled)
  - 0/1 (1 digit, UNKNOWN cookies - disabled/enabled)
  - 0/1 (1 digit, Consent token in a default state, user has yet to consent) - no/yes)
  - 0/1 (1 digit, User is authenticated, did not 401 during save) - no/yes)
  - 0/1 (1 digit, ConsentHub records are unavailable (CH is down, errored while saving, etc) - no/yes)
*/ const $56218bf982d32d30$var$packPrefsVersion003 = (userPreferences)=>{
    const version = (0, $2Itg6.V003_SCHEMA_KEY);
    return [
        version,
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Functional]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Analytics]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Marketing]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.PreferenceCategory).Unknown]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated]),
        (0, $5zn62.getBitValueFromBool)(userPreferences[(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable])
    ].join('');
};
const $56218bf982d32d30$var$unpackPrefsVersion003 = (userPreferencesCookie)=>{
    return {
        [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: true,
        // always allowed
        [(0, $8f0nK.PreferenceCategory).Functional]: userPreferencesCookie[3] === '1',
        [(0, $8f0nK.PreferenceCategory).Analytics]: userPreferencesCookie[4] === '1',
        [(0, $8f0nK.PreferenceCategory).Marketing]: userPreferencesCookie[5] === '1',
        [(0, $8f0nK.PreferenceCategory).Unknown]: userPreferencesCookie[6] === '1',
        [(0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault]: userPreferencesCookie[7] === '1',
        [(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated]: userPreferencesCookie[8] === '1',
        [(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable]: userPreferencesCookie[9] === '1'
    };
};
const $56218bf982d32d30$var$V002SpecificBitKeys = [
    (0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable,
    (0, $8f0nK.ConsentPreferenceV2).ConsentedUnderGDPR,
    (0, $8f0nK.ConsentPreferenceV2).ConsentedUnderCPRA,
    (0, $8f0nK.ConsentPreferenceV2).ConsentedUnderLGPD,
    (0, $8f0nK.ConsentPreferenceV2).ConsentedUnderFADP
];
const $56218bf982d32d30$var$V003SpecificBitKeys = [
    (0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault,
    (0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated,
    (0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable
];
function $56218bf982d32d30$export$3199823fec979bd1(userPreferences) {
    if ((0, $aoZN9.getBscGlobalState)().localConsentMode) return $56218bf982d32d30$var$packPrefsVersion001(userPreferences);
    const isV002 = $56218bf982d32d30$var$V002SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV002) // As V002 is deprecated, if we've been provided V002 set of "legacy" prefs, internally
    // convert them to V003 to drop the unnecessary contextual details
    return $56218bf982d32d30$var$packPrefsVersion002(userPreferences);
    const isV003 = $56218bf982d32d30$var$V003SpecificBitKeys.every((key)=>key in userPreferences);
    if (isV003) return $56218bf982d32d30$var$packPrefsVersion003(userPreferences);
    // Fallback to V001
    return $56218bf982d32d30$var$packPrefsVersion001(userPreferences);
}
function $56218bf982d32d30$export$8d213cb390bab4fa(userPreferencesCookie) {
    if ((0, $aoZN9.getBscGlobalState)().localConsentMode) {
        if (userPreferencesCookie.length < 3) // Wrong format, no version
        return;
        const version = userPreferencesCookie[0] + userPreferencesCookie[1] + userPreferencesCookie[2];
        if (version === (0, $2Itg6.V001_SCHEMA_KEY)) return $56218bf982d32d30$var$unpackPrefsVersion001(userPreferencesCookie);
        return;
    }
    const { isValid: isValid, isV001: isV001, isV002: isV002, isV003: isV003 } = $56218bf982d32d30$export$64b31470e8522819(userPreferencesCookie);
    if (!isValid) // We support version 001, 002, 003 only
    return;
    if (isV001) return $56218bf982d32d30$var$unpackPrefsVersion001(userPreferencesCookie);
    if (isV002) // Deprecated, so this will unpack to 003 to drop the contextual GeoIP bits
    return $56218bf982d32d30$var$unpackPrefsVersion002(userPreferencesCookie);
    if (isV003) return $56218bf982d32d30$var$unpackPrefsVersion003(userPreferencesCookie);
}
const $56218bf982d32d30$export$67f70eb55341bd29 = (initialPreferences)=>{
    if (!initialPreferences) return true;
    const prefExistButAreEmpty = Object.keys(initialPreferences).length === 0;
    return prefExistButAreEmpty;
};
const $56218bf982d32d30$export$7962405c3ca274b1 = (initialPreferences)=>{
    if (initialPreferences !== (0, $8f0nK.PrefetchedPreferenceState).INTERNAL) {
        if ($56218bf982d32d30$export$67f70eb55341bd29(initialPreferences)) // Failsafe handling: Consumer failed to provide data even though they have prefetched, so we need to fetch again
        // This may occur if a consumer's prefetch requests fails, or if they fail to implement the system correctly
        return {
            prefs: undefined,
            isPrefetchedPrefsInternalState: true
        };
        // If initialPreferences is not INTERNAL on first render, we have been provided a pre-fetched
        // value, which means we don't need to make a fetch to storage or ConsentHub to get it.
        // If that preference is defined, we persist it to our local cookie set
        // If the data is a ConsentHubResponse/PrefetchedConsentCookieData, we'll need to transform it properly before consumption
        const consentToken = initialPreferences && 'consentToken' in initialPreferences && initialPreferences.consentToken;
        if (consentToken) {
            // We already have a consent cookie that was passed in, let's not override it by setting it again
            const unpackedExistingPrefs = $56218bf982d32d30$export$8d213cb390bab4fa(consentToken);
            return {
                prefs: unpackedExistingPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedExistingPrefs)
            };
        }
        // This type guard protects the below casting of ConsentHubResponse ensuring we have the correct shape
        if (initialPreferences && 'consents' in initialPreferences) {
            const serializedPrefetchedConsentToken = (0, $gCY8Y.serializeConsents)(initialPreferences);
            const unpackedPrefetchedPrefs = $56218bf982d32d30$export$8d213cb390bab4fa(serializedPrefetchedConsentToken);
            return {
                prefs: unpackedPrefetchedPrefs,
                isPrefetchedPrefsInternalState: !Boolean(unpackedPrefetchedPrefs)
            };
        }
    }
    // If we've fallen into this, EMPTY implies we have no data at all
    // INTERNAL implies we still need to fetch new data, so trigger a refetch
    if (initialPreferences === (0, $8f0nK.PrefetchedPreferenceState).INTERNAL) return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: true
    };
    return {
        prefs: undefined,
        isPrefetchedPrefsInternalState: false
    };
};

});


parcelRegister("a5OUx", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryCookie", () => $01468dd6dc7a68d1$export$93509ff9a62ee022);

var $fJXyP = parcelRequire("fJXyP");

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");
const $01468dd6dc7a68d1$export$93509ff9a62ee022 = (key, value, attributes)=>{
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch')) // Set the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).set(key, value, {
        ...attributes,
        'atl-set-cookie': true
    });
    else try {
        if (!(0, $aoZN9.getBscGlobalState)().hasInitialized && (0, $3H4LK.fg)('platform_bsc_initialize_controls_analytics')) (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'setItemWithoutInit',
            attributes: {
                itemKey: key,
                storageType: 'Cookie'
            }
        });
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedSetStrictlyNecessaryCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).set(key, value, {
            ...attributes,
            'atl-set-cookie': true
        });
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedSetStrictlyNecessaryCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
        });
    }
};

});


parcelRegister("tBh9k", function(module, exports) {
$parcel$export(module.exports, "getValidConsentData", () => $920ef9bbe5530d7c$export$c515de1cc9cebc71);

var $2Itg6 = parcelRequire("2Itg6");

var $bzEve = parcelRequire("bzEve");

var $2edmn = parcelRequire("2edmn");
const $920ef9bbe5530d7c$export$c515de1cc9cebc71 = async (fallbackConsentToken)=>{
    // Fetches preferences from ConsentHub and returns serialized token data if possible
    const consentData = await (0, $bzEve.fetchConsentPreferences)();
    let { consentToken: consentToken, consentTimestamp: consentTimestamp, consentHubInaccessible: consentHubInaccessible } = consentData;
    let { isValid: isValid } = (0, $2edmn.checkTokenVersionValidity)(consentToken);
    if (isValid && consentHubInaccessible) {
        if (fallbackConsentToken) // `consentHubInaccessible`: ConsentHub request failed (e.g. service is down/bad request/etc). Attempt to use
        // any previously set consents in the interim if we have them.
        consentToken = fallbackConsentToken;
        else {
            const version = (0, $2Itg6.V003_SCHEMA_KEY);
            const consents = consentToken.slice(3, 7);
            // V003 BSC bits set to reflect default consent token status, authenticated user status,
            // and unavailable consentHub records status)
            const serviceBits = '111';
            // Temporary: Sets a default token with V003 properties
            // when ConsentHub is inaccessible and there is not fallback token. This
            // will ensure the banner isn't shown when ConsentHub is down.
            consentToken = `${version}${consents}${serviceBits}`;
        }
    }
    return isValid ? {
        consentToken: consentToken,
        consentTimestamp: consentTimestamp
    } : undefined;
};

});
parcelRegister("bzEve", function(module, exports) {
$parcel$export(module.exports, "buildConsentPreferences", () => $1ce6574d1a95fab7$export$bd9f5bcbf9cd947c);
$parcel$export(module.exports, "fetchConsentPreferences", () => $1ce6574d1a95fab7$export$86467566615ab85e);
$parcel$export(module.exports, "saveConsentPreferences", () => $1ce6574d1a95fab7$export$f8422650c3dec8b2);

var $3H4LK = parcelRequire("3H4LK");

var $KilRp = parcelRequire("KilRp");

var $gCY8Y = parcelRequire("gCY8Y");
const $1ce6574d1a95fab7$var$BASE_CONSENTS_URL = '/gateway/api/consenthub/session';
const $1ce6574d1a95fab7$var$POST_CONSENTS_URL = `${$1ce6574d1a95fab7$var$BASE_CONSENTS_URL}/user`;
const $1ce6574d1a95fab7$var$GET_CONSENTS_URL = `${$1ce6574d1a95fab7$var$POST_CONSENTS_URL}/consents/cookies`;
const $1ce6574d1a95fab7$var$getConsentHubHeaders = ()=>({
        'Content-Type': 'application/json',
        ...(0, $3H4LK.fg)('platform_bsc_consent_hub_x_origin') ? {
            'X-Request-Origin': 'bsc'
        } : {}
    });
const $1ce6574d1a95fab7$export$bd9f5bcbf9cd947c = (consentData)=>{
    if (consentData) {
        const serializedConsents = (0, $gCY8Y.serializeConsents)(consentData);
        const consentTimestamp = (0, $gCY8Y.getConsentTimestamp)(consentData);
        return {
            consentToken: serializedConsents,
            consentTimestamp: consentTimestamp
        };
    }
    // Without consent data (due to server failure or unauthenticated user), set defaults illustrating that absence
    return {
        consentToken: (0, $gCY8Y.serializeConsents)({}),
        consentHubInaccessible: true
    };
};
const $1ce6574d1a95fab7$export$86467566615ab85e = async ()=>{
    const { origin: origin } = window.location;
    const getFromConsentHubURL = `${origin}${$1ce6574d1a95fab7$var$GET_CONSENTS_URL}`;
    try {
        const response = await fetch(getFromConsentHubURL, {
            method: 'GET',
            headers: $1ce6574d1a95fab7$var$getConsentHubHeaders()
        });
        if (!response.ok) throw new Error(`Failed to fetch preferences from ConsentHub with status: ${response.status}`);
        const consentData = await response.json();
        return $1ce6574d1a95fab7$export$bd9f5bcbf9cd947c(consentData);
    } catch (err) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'fetchConsentPreferencesError',
            message: err.message || ''
        });
        return $1ce6574d1a95fab7$export$bd9f5bcbf9cd947c();
    }
};
const $1ce6574d1a95fab7$var$buildConsentRequestBody = (unpackedUserPreferences, displayedTextMap)=>{
    const { origin: origin, pathname: pathname } = window.location;
    const deserializedConsents = (0, $gCY8Y.deserializeConsents)(unpackedUserPreferences, displayedTextMap);
    // Type guard here so TS knows we're working with ConsentPreferenceV003
    const action = 'CONSENT_DATA_UNAVAILABLE' in unpackedUserPreferences && unpackedUserPreferences.CONSENT_DATA_UNAVAILABLE ? 'FORM_FILL' : 'UPDATE_PREFERENCES';
    const consentRequestBody = {
        action: action,
        // If there are no consents, it's a first time fill, otherwise it's an update action
        consents: deserializedConsents,
        formUrl: `${origin}${pathname}`,
        locale: 'UNKNOWN',
        site: 'atlassian',
        source: 'COOKIE_PREFERENCES'
    };
    return JSON.stringify(consentRequestBody);
};
const $1ce6574d1a95fab7$export$f8422650c3dec8b2 = async (unpackedUserPreferences, displayedTextMap)=>{
    const saveToConsentHubURL = `${window.location.origin}${$1ce6574d1a95fab7$var$POST_CONSENTS_URL}`;
    try {
        const response = await fetch(saveToConsentHubURL, {
            method: 'POST',
            headers: $1ce6574d1a95fab7$var$getConsentHubHeaders(),
            body: $1ce6574d1a95fab7$var$buildConsentRequestBody(unpackedUserPreferences, displayedTextMap)
        });
        // Saving is an async API (we don't know if the save succeeds) so returns 202 Accepted.
        // 401 = User is unauthenticated
        // 5xx = ConsentHub is unavailable
        if (!response.ok || response.status !== 202 && response.status !== 200) {
            const errMsg = `Failed to save preferences to ConsentHub with status: ${response.status}`;
            const errWithStatusCode = new (0, $gCY8Y.StatusCodeError)(errMsg, response.status);
            throw errWithStatusCode;
        }
    } catch (err) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'saveConsentPreferencesError',
            message: err.message || ''
        });
        // Re-throw to any encapsulating logic, a la `setConsentToken()`
        throw err;
    }
};

});





parcelRegister("bBzKh", function(module, exports) {
$parcel$export(module.exports, "ItemKeyCache", () => $e3baeacdef787ce4$export$ff3c91e80f54f26c);

var $8f0nK = parcelRequire("8f0nK");
class $e3baeacdef787ce4$var$ItemKeyCacheService {
    constructor(){
        this.cache = Object.fromEntries(Object.keys((0, $8f0nK.CategoryStorageType)).map((storageType)=>{
            return [
                storageType,
                new Set()
            ];
        }));
    }
    markSetByPackage(storageType, itemKey) {
        this.cache[storageType].add(itemKey);
    }
    wasSetByPackage(storageType, itemKey) {
        return this.cache[storageType].has(itemKey);
    }
}
const $e3baeacdef787ce4$export$ff3c91e80f54f26c = new $e3baeacdef787ce4$var$ItemKeyCacheService();

});


parcelRegister("eNGSn", function(module, exports) {
$parcel$export(module.exports, "setStrictlyNecessaryStorageItem", () => $e3cdec3f1eb867ed$export$f1b0c189562aa9fd);

var $3H4LK = parcelRequire("3H4LK");

var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");

var $8f0nK = parcelRequire("8f0nK");

var $gkGYs = parcelRequire("gkGYs");

var $bBzKh = parcelRequire("bBzKh");

var $lFYsw = parcelRequire("lFYsw");
const $e3cdec3f1eb867ed$export$f1b0c189562aa9fd = (itemKey, value, storageType, browserStorage)=>{
    // Flag disabled, allow all items.
    const eventAttributes = {
        itemKey: itemKey,
        storageType: storageType
    };
    try {
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItem',
            attributes: eventAttributes
        });
        if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
            // note: at the time of writing, this doesn't actually do anything because browserStorage.setItem calls the original setItem, not the overridden one.
            // see this thread for more information: https://atlassian.slack.com/archives/C05U6KCDNQJ/p1778585948364219
            (0, $bBzKh.ItemKeyCache).markSetByPackage(storageType === (0, $lFYsw.WebStorageType).LocalStorage ? (0, $8f0nK.CategoryStorageType).LocalStorage : (0, $8f0nK.CategoryStorageType).SessionStorage, itemKey);
            browserStorage.setItem(itemKey, value);
        } else {
            // Store the item as a record in our IDB service to track that we've seen it before.
            // That way, when we can confirm/deny that this has been set by our service when we check again.
            // If it fails for some reason, it will be caught before actually setting the item
            // As setting Strictly Necessary requires synchronous operation, wait on the promise in an OG fashion
            (0, $gkGYs.BSCIndexedDB).setRecord(itemKey).then(()=>{
            // NOTE: Should this just no-op/be removed? It already set and returned the item theoretically since this main func is sync
            }).catch(()=>{
                (0, $hTxA3.sendPackageOperationalEvent)({
                    action: 'indexDbSetRecordError',
                    attributes: eventAttributes
                });
            });
            browserStorage.setItem(itemKey, value);
        }
        return (0, $8f0nK.Status).SUCCESS;
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedAtlBrowserStorageSetStrictlyNecessaryItemError',
            attributes: eventAttributes,
            message: `Failed to set strictly necessary ${storageType} item. ${e.message || ''}`
        });
        return (0, $8f0nK.Status).FAILED;
    }
};

});


parcelRegister("7HnFM", function(module, exports) {
$parcel$export(module.exports, "safeAccessWithErrorHandler", () => $ed2defe6413ae698$export$d1415594ea5ec958);
const $ed2defe6413ae698$export$d1415594ea5ec958 = (action, errorCase)=>{
    try {
        return action();
    } catch (err) {
        return errorCase && errorCase();
    }
};

});


parcelRegister("fVVtD", function(module, exports) {
$parcel$export(module.exports, "LOG_OUT", () => $a2c6d079c25de653$export$cb307dad255adf47);
$parcel$export(module.exports, "logOutAction", () => $a2c6d079c25de653$export$1a3865346be34527);
const $a2c6d079c25de653$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $a2c6d079c25de653$export$1a3865346be34527 = ()=>{
    return {
        type: $a2c6d079c25de653$export$cb307dad255adf47
    };
};

});


parcelRegister("hGVNB", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f4e27995a3b8f9c$export$2e2bcd8739ae039);
parcelRequire("lbln8");
var $4akjj = parcelRequire("4akjj");

var $kgPPq = parcelRequire("kgPPq");

var $6J2aw = parcelRequire("6J2aw");

var $6bGmX = parcelRequire("6bGmX");

var $1CeXL = parcelRequire("1CeXL");

var $cVw4D = parcelRequire("cVw4D");

var $eh8AM = parcelRequire("eh8AM");

var $ieWqL = parcelRequire("ieWqL");

var $dEpGZ = parcelRequire("dEpGZ");

var $ghArW = parcelRequire("ghArW");

var $4xnQn = parcelRequire("4xnQn");

var $9lgXg = parcelRequire("9lgXg");

var $eKcjF = parcelRequire("eKcjF");

var $do6Dv = parcelRequire("do6Dv");

var $isOOS = parcelRequire("isOOS");

var $FiKDW = parcelRequire("FiKDW");

var $eos1s = parcelRequire("eos1s");

var $2zNLi = parcelRequire("2zNLi");

var $cSNss = parcelRequire("cSNss");

var $fLzw9 = parcelRequire("fLzw9");

var $5xEoT = parcelRequire("5xEoT");

var $exsKQ = parcelRequire("exsKQ");

var $5GYV5 = parcelRequire("5GYV5");

var $jd0eh = parcelRequire("jd0eh");

var $8TdBT = parcelRequire("8TdBT");

var $c49HS = parcelRequire("c49HS");

var $k1GLu = parcelRequire("k1GLu");

var $jnfRh = parcelRequire("jnfRh");
var // Need to force typescript to pick up the right combineEpics
$9f4e27995a3b8f9c$export$2e2bcd8739ae039 = (0, $4akjj.combineEpics)((0, $9lgXg.helpCenterBrandingEpic), (0, $9lgXg.helpCenterEpic), (0, $9lgXg.invalidateHelpCenterBrandingEpic), (0, $cSNss.portalEpic), (0, $cSNss.portalUploadMediaTokenEpic), (0, $cSNss.refreshPortalUploadMediaTokenBeforeExpiryEpic), (0, $kgPPq.default), (0, $2zNLi.organisationsEpic), (0, $fLzw9.requestCreateEpic), (0, $5GYV5.requestTypeSuggestionEpic), (0, $dEpGZ.connectFragmentsEpic), (0, $do6Dv.default), (0, $eKcjF.default), (0, $k1GLu.unsubscribedConfirmationEpic), (0, $FiKDW.loginEpic), (0, $eos1s.loginAnnouncementsEpic), (0, $4xnQn.forgotPasswordEpic), (0, $eh8AM.fetchArticleEpic), (0, $5xEoT.requestDetailsEpic), (0, $exsKQ.requestListEpic), (0, $jd0eh.requestsColumnSettingsEpic), (0, $cVw4D.approvalListEpic), (0, $isOOS.languagesEpic), (0, $8TdBT.timezoneRegionsEpic), (0, $8TdBT.timezonesEpic), (0, $dEpGZ.profileConnectFragmentsEpic), (0, $jnfRh.visitPortalEpic), (0, $ieWqL.completeSignupEpic), (0, $6J2aw.default), (0, $ghArW.featuredAndSortedPortalsEpic), (0, $1CeXL.aiAnswerFeedbackPageEpic), ...(0, $6bGmX.default).checkGate('ditto_uim_root_query_rest') ? [
    (0, $c49HS.uiModificationsEpic)
] : []);

});
parcelRegister("kgPPq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d29492ba6673662$export$2e2bcd8739ae039);

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");

var $elY4q = parcelRequire("elY4q");

var $f4IfF = parcelRequire("f4IfF");
const $5d29492ba6673662$var$epic = (action$)=>{
    return action$.ofType((0, $f4IfF.FETCH_USER_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).map((response)=>{
            // If we requested for a user model but never got one or got an empty user object we assume that the user is anonymous.
            if (!response.user || !response.user.accountId) return (0, $3R99L.updateUserModelAnonymousAction)();
            return (0, $3R99L.updateUserModelAction)(response.user);
        }).catch(()=>(0, $b0T1M.Observable).never()));
};
var $5d29492ba6673662$export$2e2bcd8739ae039 = $5d29492ba6673662$var$epic;

});
parcelRegister("f4IfF", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_MODEL", () => $1022f955bd984c90$export$d79dd8ba2ab60f61);
$parcel$export(module.exports, "fetchUserModelAction", () => $1022f955bd984c90$export$d4f34f8f1b2704a8);

var $dNzn5 = parcelRequire("dNzn5");
const $1022f955bd984c90$export$d79dd8ba2ab60f61 = 'epic.model.FETCH_USER_MODEL';
const $1022f955bd984c90$export$d4f34f8f1b2704a8 = (params = {})=>{
    const excludeRequestCountsParam = {
        ...params,
        fetchRequestCounts: false
    };
    return (0, $dNzn5.buildModelsActionCreator)($1022f955bd984c90$export$d79dd8ba2ab60f61, 'user')(excludeRequestCountsParam);
};

});


parcelRegister("6J2aw", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b4b44a0b4186235$export$2e2bcd8739ae039);

var $b0T1M = parcelRequire("b0T1M");

var $3R99L = parcelRequire("3R99L");

var $elY4q = parcelRequire("elY4q");

var $k16VK = parcelRequire("k16VK");
const $8b4b44a0b4186235$var$fetchUserRequestsCountsEpic = (action$)=>{
    return action$.ofType((0, $k16VK.FETCH_USER_REQUESTS_COUNTS_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.userRequestsCounts).map((response)=>(0, $3R99L.updateUserRequestsCountsAction)(response.userRequestsCounts)).catch(()=>(0, $b0T1M.Observable).never()));
};
var $8b4b44a0b4186235$export$2e2bcd8739ae039 = $8b4b44a0b4186235$var$fetchUserRequestsCountsEpic;

});
parcelRegister("k16VK", function(module, exports) {
$parcel$export(module.exports, "FETCH_USER_REQUESTS_COUNTS_MODEL", () => $fb3d5ec58e6c2fd8$export$dfecf710cdf030b1);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $fb3d5ec58e6c2fd8$export$71172847a48a08a6);

var $dNzn5 = parcelRequire("dNzn5");
const $fb3d5ec58e6c2fd8$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $fb3d5ec58e6c2fd8$export$71172847a48a08a6 = (0, $dNzn5.buildModelsActionCreator)($fb3d5ec58e6c2fd8$export$dfecf710cdf030b1, 'userRequestsCounts');

});


parcelRegister("1CeXL", function(module, exports) {
$parcel$export(module.exports, "aiAnswerFeedbackPageEpic", () => $0f4db8675824a032$export$ceff4b1bfa1bc6ba);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("cad2o");
var $b6TGM = parcelRequire("b6TGM");
const $0f4db8675824a032$export$ceff4b1bfa1bc6ba = (action$)=>{
    return action$.ofType((0, $b6TGM.FETCH_AI_ANSWER_FEEDBACK_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.aianswer).map((response)=>{
            return (0, $b6TGM.fetchAiAnswerFeedbackSuccess)(response.aianswer);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $b6TGM.fetchAiAnswerFeedbackFailure)(error));
        }));
};

});
parcelRegister("cad2o", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => (parcelRequire("b6TGM")).FETCH_AI_ANSWER_FEEDBACK_MODEL);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => (parcelRequire("b6TGM")).FETCH_AI_ANSWER_FEEDBACK_SUCCESS);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => (parcelRequire("b6TGM")).FETCH_AI_ANSWER_FEEDBACK_FAILURE);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => (parcelRequire("b6TGM")).fetchAiAnswerFeedbackModel);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => (parcelRequire("b6TGM")).fetchAiAnswerFeedbackSuccess);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => (parcelRequire("b6TGM")).fetchAiAnswerFeedbackFailure);

var $b6TGM = parcelRequire("b6TGM");

});
parcelRegister("b6TGM", function(module, exports) {
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_MODEL", () => $d8a5b1814f6df81e$export$ae77fa01ad25f4c9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_SUCCESS", () => $d8a5b1814f6df81e$export$6f922337a7af3b9);
$parcel$export(module.exports, "FETCH_AI_ANSWER_FEEDBACK_FAILURE", () => $d8a5b1814f6df81e$export$4daab78c9d39cdb5);
$parcel$export(module.exports, "fetchAiAnswerFeedbackModel", () => $d8a5b1814f6df81e$export$4514f111c053f647);
$parcel$export(module.exports, "fetchAiAnswerFeedbackSuccess", () => $d8a5b1814f6df81e$export$4da568a91bd226dc);
$parcel$export(module.exports, "fetchAiAnswerFeedbackFailure", () => $d8a5b1814f6df81e$export$a1584ed81f70c36d);

var $dNzn5 = parcelRequire("dNzn5");
const $d8a5b1814f6df81e$export$ae77fa01ad25f4c9 = 'epic.model.FETCH_AI_ANSWER_FEEDBACK_MODEL';
const $d8a5b1814f6df81e$export$6f922337a7af3b9 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_SUCCESS';
const $d8a5b1814f6df81e$export$4daab78c9d39cdb5 = 'state.persisted.ai.answer.feedback.FETCH_AI_ANSWER_FEEDBACK_FAILURE';
const $d8a5b1814f6df81e$export$4514f111c053f647 = (0, $dNzn5.buildModelsActionCreator)($d8a5b1814f6df81e$export$ae77fa01ad25f4c9, 'aianswer');
const $d8a5b1814f6df81e$export$4da568a91bd226dc = (aiAnswerFeedbackResponse)=>({
        type: $d8a5b1814f6df81e$export$6f922337a7af3b9,
        payload: aiAnswerFeedbackResponse
    });
const $d8a5b1814f6df81e$export$a1584ed81f70c36d = (error)=>({
        type: $d8a5b1814f6df81e$export$4daab78c9d39cdb5,
        payload: {
            error: error
        }
    });

});



parcelRegister("cVw4D", function(module, exports) {
$parcel$export(module.exports, "approvalListEpic", () => $20560bcc9be8e464$export$77e5ddee619f2d69);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("g99P5");
var $cht5V = parcelRequire("cht5V");
const $20560bcc9be8e464$export$77e5ddee619f2d69 = (action$)=>{
    return action$.ofType((0, $cht5V.FETCH_APPROVAL_LIST_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.approvalListFilter && !!response.approvalListFilter.requests).map((response)=>{
            return (0, $cht5V.fetchApprovalListSuccess)(response.approvalListFilter);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $cht5V.fetchApprovalListFailure)(error));
        }));
};

});
parcelRegister("g99P5", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => (parcelRequire("cht5V")).FETCH_APPROVAL_LIST_MODEL);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => (parcelRequire("cht5V")).FETCH_APPROVAL_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => (parcelRequire("cht5V")).FETCH_APPROVAL_LIST_FAILURE);
$parcel$export(module.exports, "fetchApprovalListModel", () => (parcelRequire("cht5V")).fetchApprovalListModel);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => (parcelRequire("cht5V")).fetchApprovalListSuccess);
$parcel$export(module.exports, "fetchApprovalListFailure", () => (parcelRequire("cht5V")).fetchApprovalListFailure);

var $cht5V = parcelRequire("cht5V");

});
parcelRegister("cht5V", function(module, exports) {
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_MODEL", () => $ad717a35316e91c4$export$2e7343d23ce2e264);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_SUCCESS", () => $ad717a35316e91c4$export$42d9c935d4bfef61);
$parcel$export(module.exports, "FETCH_APPROVAL_LIST_FAILURE", () => $ad717a35316e91c4$export$132a25b8ba1cc94);
$parcel$export(module.exports, "fetchApprovalListModel", () => $ad717a35316e91c4$export$c4decf32e9c96894);
$parcel$export(module.exports, "fetchApprovalListSuccess", () => $ad717a35316e91c4$export$2ac6685d409334fa);
$parcel$export(module.exports, "fetchApprovalListFailure", () => $ad717a35316e91c4$export$9059cd838e20fcf6);

var $dNzn5 = parcelRequire("dNzn5");
const $ad717a35316e91c4$export$2e7343d23ce2e264 = 'epic.model.FETCH_APPROVAL_LIST_MODEL';
const $ad717a35316e91c4$export$42d9c935d4bfef61 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_SUCCESS';
const $ad717a35316e91c4$export$132a25b8ba1cc94 = 'state.persisted.approval.List.FETCH_APPROVAL_LIST_FAILURE';
const $ad717a35316e91c4$export$c4decf32e9c96894 = (0, $dNzn5.buildModelsActionCreator)($ad717a35316e91c4$export$2e7343d23ce2e264, 'approvalListFilter');
const $ad717a35316e91c4$export$2ac6685d409334fa = (approvalListFilter)=>({
        type: $ad717a35316e91c4$export$42d9c935d4bfef61,
        payload: approvalListFilter
    });
const $ad717a35316e91c4$export$9059cd838e20fcf6 = (error)=>({
        type: $ad717a35316e91c4$export$132a25b8ba1cc94,
        payload: {
            error: error
        }
    });

});



parcelRegister("eh8AM", function(module, exports) {
$parcel$export(module.exports, "fetchArticleEpic", () => $8a5076c57f799628$export$3c4e80b80ffa2c37);

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("35SbM");
var $dzJzK = parcelRequire("dzJzK");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $elY4q = parcelRequire("elY4q");
const $8a5076c57f799628$export$3c4e80b80ffa2c37 = (action$)=>action$.ofType((0, $dzJzK.FETCH_ARTICLE)).mergeMap((action)=>{
        const { meta: meta } = action;
        return (0, $elY4q.default)(action.payload).filter((response)=>!!response.kbPage).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $dzJzK.fetchArticleSuccess)(response.kbPage);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $dzJzK.fetchArticleFailure)(action.payload.params.id, error));
        });
    });

});

parcelRegister("ieWqL", function(module, exports) {
$parcel$export(module.exports, "completeSignupEpic", () => $21f5ebeb7fecf44d$export$c3902030a5d4d47a);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("iKA91");
var $1uz6E = parcelRequire("1uz6E");
const $21f5ebeb7fecf44d$export$c3902030a5d4d47a = (action$)=>{
    return action$.ofType((0, $1uz6E.FETCH_COMPLETE_SIGNUP_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.completeSignup && !!response.completeSignup.emailAddress).map((response)=>{
            return (0, $1uz6E.fetchCompleteSignupSuccess)(response.completeSignup);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $1uz6E.fetchCompleteSignupFailure)(error));
        }));
};

});

parcelRegister("dEpGZ", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsEpic", () => $ec13ac912101cd5f$export$da9f118c732015e);
$parcel$export(module.exports, "profileConnectFragmentsEpic", () => $ec13ac912101cd5f$export$a3ede6811238e533);

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("g3u0z");
var $lWKdO = parcelRequire("lWKdO");

var $elY4q = parcelRequire("elY4q");
const $ec13ac912101cd5f$export$da9f118c732015e = (action$)=>action$.ofType((0, $lWKdO.FETCH_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $elY4q.default)(action.payload, {
            type: action.payload.params.portalPage === 'CREATE_REQUEST' ? 'secondary' : 'primary'
        }).filter((response)=>!!response.portalWebFragments).map((response)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $lWKdO.fetchConnectFragmentsSuccess)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                requestKey: requestKey,
                portalPageName: portalPage,
                connectFragments: response.portalWebFragments
            });
        }).catch((error)=>{
            const { portalPage: portalPage, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = action.payload.params;
            return (0, $b0T1M.Observable).of((0, $lWKdO.fetchConnectFragmentsFailure)({
                portalId: portalId,
                requestTypeId: requestTypeId,
                error: error,
                requestKey: requestKey,
                portalPageName: portalPage
            }));
        }));
const $ec13ac912101cd5f$export$a3ede6811238e533 = (action$)=>action$.ofType((0, $lWKdO.FETCH_PROFILE_CONNECT_FRAGMENTS)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.profileWebFragments).map((response)=>{
            return (0, $lWKdO.fetchProfileConnectFragmentsSuccess)(response.profileWebFragments);
        }).catch((error)=>(0, $b0T1M.Observable).of((0, $lWKdO.fetchProfileConnectFragmentsFailure)(error))));

});
parcelRegister("g3u0z", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => (parcelRequire("lWKdO")).FETCH_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("lWKdO")).FETCH_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("lWKdO")).FETCH_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => (parcelRequire("lWKdO")).FETCH_PROFILE_CONNECT_FRAGMENTS);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => (parcelRequire("lWKdO")).FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => (parcelRequire("lWKdO")).FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => (parcelRequire("lWKdO")).fetchConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => (parcelRequire("lWKdO")).fetchConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => (parcelRequire("lWKdO")).fetchProfileConnectFragmentsFailure);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => (parcelRequire("lWKdO")).fetchProfileConnectFragmentsSuccess);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => (parcelRequire("lWKdO")).fetchConnectFragmentsAction);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => (parcelRequire("lWKdO")).fetchProfileConnectFragmentsAction);

var $lWKdO = parcelRequire("lWKdO");

});
parcelRegister("lWKdO", function(module, exports) {
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_SUCCESS", () => $820e176561565d6c$export$be3b6b321a4b2e30);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS_FAILURE", () => $820e176561565d6c$export$8c14498d55ee35d5);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS", () => $820e176561565d6c$export$c4d0c4cc4d23ec29);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE", () => $820e176561565d6c$export$ac33d6e70ef6394b);
$parcel$export(module.exports, "FETCH_CONNECT_FRAGMENTS", () => $820e176561565d6c$export$93b4a584ef971c3e);
$parcel$export(module.exports, "fetchConnectFragmentsAction", () => $820e176561565d6c$export$bd274633ff57df1a);
$parcel$export(module.exports, "FETCH_PROFILE_CONNECT_FRAGMENTS", () => $820e176561565d6c$export$acefa59403de59c3);
$parcel$export(module.exports, "fetchProfileConnectFragmentsAction", () => $820e176561565d6c$export$9b734d900be9577d);
$parcel$export(module.exports, "fetchConnectFragmentsSuccess", () => $820e176561565d6c$export$2e62b6b504d95c08);
$parcel$export(module.exports, "fetchConnectFragmentsFailure", () => $820e176561565d6c$export$ea99ad4f53065bdf);
$parcel$export(module.exports, "fetchProfileConnectFragmentsSuccess", () => $820e176561565d6c$export$802082c6f9bfe7);
$parcel$export(module.exports, "fetchProfileConnectFragmentsFailure", () => $820e176561565d6c$export$3b319d8313349388);

var $dNzn5 = parcelRequire("dNzn5");
const $820e176561565d6c$export$be3b6b321a4b2e30 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_SUCCESS';
const $820e176561565d6c$export$8c14498d55ee35d5 = 'state.persisted.connect-addon.FETCH_CONNECT_FRAGMENTS_FAILURE';
const $820e176561565d6c$export$c4d0c4cc4d23ec29 = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS';
const $820e176561565d6c$export$ac33d6e70ef6394b = 'state.persisted.connect-addon.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE';
const $820e176561565d6c$export$93b4a584ef971c3e = 'epic.model.FETCH_CONNECT_FRAGMENTS';
const $820e176561565d6c$export$bd274633ff57df1a = (0, $dNzn5.buildModelsActionCreator)($820e176561565d6c$export$93b4a584ef971c3e, 'portalWebFragments');
const $820e176561565d6c$export$acefa59403de59c3 = 'epic.model.FETCH_PROFILE_CONNECT_FRAGMENTS';
const $820e176561565d6c$export$9b734d900be9577d = (0, $dNzn5.buildModelsActionCreator)($820e176561565d6c$export$acefa59403de59c3, 'profileWebFragments');
const $820e176561565d6c$export$2e62b6b504d95c08 = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey })=>({
        type: $820e176561565d6c$export$be3b6b321a4b2e30,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            connectFragments: connectFragments,
            requestKey: requestKey
        }
    });
const $820e176561565d6c$export$ea99ad4f53065bdf = ({ portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey })=>({
        type: $820e176561565d6c$export$8c14498d55ee35d5,
        payload: {
            portalPageName: portalPageName,
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error,
            requestKey: requestKey
        }
    });
const $820e176561565d6c$export$802082c6f9bfe7 = (fragments)=>({
        type: $820e176561565d6c$export$c4d0c4cc4d23ec29,
        payload: {
            fragments: fragments
        }
    });
const $820e176561565d6c$export$3b319d8313349388 = (error)=>({
        type: $820e176561565d6c$export$ac33d6e70ef6394b,
        payload: {
            error: error
        }
    });

});



parcelRegister("ghArW", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsEpic", () => $a59a44c1b16afe07$export$482dd9b2afe107b5);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $elY4q = parcelRequire("elY4q");
parcelRequire("7LVOt");
var $db9ld = parcelRequire("db9ld");

var $eSL4S = parcelRequire("eSL4S");

var $9Con0 = parcelRequire("9Con0");
const $a59a44c1b16afe07$var$emptyFeaturedAndSortedPortalsResponse = {
    portals: [],
    total: 0
};
const $a59a44c1b16afe07$export$482dd9b2afe107b5 = (action$)=>{
    return action$.ofType((0, $db9ld.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL)).mergeMap((action)=>{
        const { isPortalReorderingSelected: isPortalReorderingSelected, ...params } = action.payload.params;
        if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)()) return (0, $b0T1M.Observable).from((0, $9Con0.fetchFeaturedAndSortedPortalsData)(params).toPromise().then((response)=>(0, $9Con0.convertToFeaturedAndSortedPortalsResponse)(response))).flatMap((data)=>{
            return (0, $b0T1M.Observable).of((0, $db9ld.fetchFeaturedAndSortedPortalsSuccess)(data || $a59a44c1b16afe07$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $db9ld.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $b0T1M.Observable).of((0, $db9ld.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
        return (0, $elY4q.default)({
            ...action.payload,
            params: params
        }).filter((response)=>!!response.featuredAndSortedPortals).flatMap((response)=>{
            return (0, $b0T1M.Observable).of((0, $db9ld.fetchFeaturedAndSortedPortalsSuccess)(response.featuredAndSortedPortals || $a59a44c1b16afe07$var$emptyFeaturedAndSortedPortalsResponse, action.payload.params));
        }).catch((error)=>{
            //if error while fetching sorted data, show error flag using ajax error payload
            if (action.payload.params.sortBy) return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $db9ld.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params)), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
            //for featured /un-featured portals, let component handle the error state
            return (0, $b0T1M.Observable).of((0, $db9ld.fetchFeaturedAndSortedPortalsFailure)(error, action.payload.params));
        });
    });
};

});
parcelRegister("7LVOt", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => (parcelRequire("db9ld")).FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => (parcelRequire("db9ld")).fetchFeaturedAndSortedPortalsSuccess);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => (parcelRequire("db9ld")).FETCH_FEATURED_AND_SORTED_PORTALS_MODEL);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => (parcelRequire("db9ld")).fetchFeaturedAndSortedPortalsModel);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => (parcelRequire("db9ld")).FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => (parcelRequire("db9ld")).fetchFeaturedAndSortedPortalsFailure);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => (parcelRequire("db9ld")).REORDER_FEATURED_PORTAL);
$parcel$export(module.exports, "reorderFeaturedPortal", () => (parcelRequire("db9ld")).reorderFeaturedPortal);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => (parcelRequire("db9ld")).MARK_PORTAL_FEATURED);
$parcel$export(module.exports, "markPortalFeatured", () => (parcelRequire("db9ld")).markPortalFeatured);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("db9ld")).UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => (parcelRequire("db9ld")).updatePortalReorderSettingsSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => (parcelRequire("db9ld")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => (parcelRequire("db9ld")).updatePortalReorderSettingsModel);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => (parcelRequire("db9ld")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => (parcelRequire("db9ld")).updatePortalReorderSettingsModelSuccess);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => (parcelRequire("db9ld")).UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => (parcelRequire("db9ld")).updatePortalReorderSettingsModelFailure);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => (parcelRequire("db9ld")).UPDATE_PORTAL_REORDER_SETTINGS_FAILURE);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => (parcelRequire("db9ld")).updatePortalReorderSettingsFailure);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => (parcelRequire("db9ld")).RESET_PORTAL_REORDER_SETTINGS);
$parcel$export(module.exports, "resetPortalReorderSettings", () => (parcelRequire("db9ld")).resetPortalReorderSettings);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => (parcelRequire("db9ld")).RESET_PORTAL_REORDER_SETTINGS_SUCCESS);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => (parcelRequire("db9ld")).resetPortalReorderSettingsSuccess);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => (parcelRequire("db9ld")).MARK_PORTAL_REORDER_SETTINGS_DIRTY);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => (parcelRequire("db9ld")).markPortalReorderSettingsDirty);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => (parcelRequire("db9ld")).TOGGLE_PORTAL_VISIBILITY);
$parcel$export(module.exports, "togglePortalVisibility", () => (parcelRequire("db9ld")).togglePortalVisibility);

var $db9ld = parcelRequire("db9ld");

});
parcelRegister("db9ld", function(module, exports) {
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_MODEL", () => $167708e0f38d7b1f$export$8772f11deb28968a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS", () => $167708e0f38d7b1f$export$6ed163277f07d17a);
$parcel$export(module.exports, "FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE", () => $167708e0f38d7b1f$export$9198b985767ee6a9);
$parcel$export(module.exports, "MARK_PORTAL_FEATURED", () => $167708e0f38d7b1f$export$c4ada71ac24d5427);
$parcel$export(module.exports, "REORDER_FEATURED_PORTAL", () => $167708e0f38d7b1f$export$e78177131adb1a7a);
$parcel$export(module.exports, "TOGGLE_PORTAL_VISIBILITY", () => $167708e0f38d7b1f$export$f04d3c0a6161427f);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL", () => $167708e0f38d7b1f$export$68f1a628095e7df5);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS", () => $167708e0f38d7b1f$export$aa2114acd4f820aa);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE", () => $167708e0f38d7b1f$export$2d425395f1203ae4);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS", () => $167708e0f38d7b1f$export$e6dde7e78d51edc9);
$parcel$export(module.exports, "UPDATE_PORTAL_REORDER_SETTINGS_FAILURE", () => $167708e0f38d7b1f$export$d6299724cb4f13de);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS", () => $167708e0f38d7b1f$export$47862f368a701d13);
$parcel$export(module.exports, "RESET_PORTAL_REORDER_SETTINGS_SUCCESS", () => $167708e0f38d7b1f$export$bce4411b856ef9e5);
$parcel$export(module.exports, "MARK_PORTAL_REORDER_SETTINGS_DIRTY", () => $167708e0f38d7b1f$export$a90731f74ba59c30);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsModel", () => $167708e0f38d7b1f$export$6ea18f901a4f825e);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsSuccess", () => $167708e0f38d7b1f$export$6d3c5bcff4d8dcfc);
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsFailure", () => $167708e0f38d7b1f$export$9d041bf07bd04f34);
$parcel$export(module.exports, "markPortalFeatured", () => $167708e0f38d7b1f$export$3b1a77584c9a6b81);
$parcel$export(module.exports, "togglePortalVisibility", () => $167708e0f38d7b1f$export$89b8e7ec4e1c2d07);
$parcel$export(module.exports, "reorderFeaturedPortal", () => $167708e0f38d7b1f$export$62b3d711c52e9aa2);
$parcel$export(module.exports, "updatePortalReorderSettingsModel", () => $167708e0f38d7b1f$export$ff946f5ffd1293d7);
$parcel$export(module.exports, "updatePortalReorderSettingsModelSuccess", () => $167708e0f38d7b1f$export$eeed66775c51f217);
$parcel$export(module.exports, "updatePortalReorderSettingsModelFailure", () => $167708e0f38d7b1f$export$eb2d78b304e5909c);
$parcel$export(module.exports, "updatePortalReorderSettingsSuccess", () => $167708e0f38d7b1f$export$8fabcd6d8271b790);
$parcel$export(module.exports, "updatePortalReorderSettingsFailure", () => $167708e0f38d7b1f$export$4b50f99aebbcd6b7);
$parcel$export(module.exports, "resetPortalReorderSettings", () => $167708e0f38d7b1f$export$4157bb81256cfd7f);
$parcel$export(module.exports, "markPortalReorderSettingsDirty", () => $167708e0f38d7b1f$export$d0f9348a57407b6c);
$parcel$export(module.exports, "resetPortalReorderSettingsSuccess", () => $167708e0f38d7b1f$export$5c52eef312473e8b);
const $167708e0f38d7b1f$export$8772f11deb28968a = 'epic.model.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL';
const $167708e0f38d7b1f$export$6ed163277f07d17a = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS';
const $167708e0f38d7b1f$export$9198b985767ee6a9 = 'state.persisted.featuredAndSortedPortals.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE';
const $167708e0f38d7b1f$export$c4ada71ac24d5427 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_FEATURED';
const $167708e0f38d7b1f$export$e78177131adb1a7a = 'state.ui.featuredAndSortedPortals.REORDER_FEATURED_PORTAL';
const $167708e0f38d7b1f$export$f04d3c0a6161427f = 'state.ui.featuredAndSortedPortals.TOGGLE_PORTAL_VISIBILITY';
const $167708e0f38d7b1f$export$68f1a628095e7df5 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL';
const $167708e0f38d7b1f$export$aa2114acd4f820aa = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS';
const $167708e0f38d7b1f$export$2d425395f1203ae4 = 'epic.portal-reorder-settings.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE';
const $167708e0f38d7b1f$export$e6dde7e78d51edc9 = 'state.persisted.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS';
const $167708e0f38d7b1f$export$d6299724cb4f13de = 'state.ui.featuredAndSortedPortals.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE';
const $167708e0f38d7b1f$export$47862f368a701d13 = 'epic.portal-reorder-settings.RESET_PORTAL_REORDER_SETTINGS';
const $167708e0f38d7b1f$export$bce4411b856ef9e5 = 'state.ui.featuredAndSortedPortals.RESET_PORTAL_REORDER_SETTINGS_SUCCESS';
const $167708e0f38d7b1f$export$a90731f74ba59c30 = 'state.ui.featuredAndSortedPortals.MARK_PORTAL_REORDER_SETTINGS_DIRTY';
/* isPortalReorderingSelected is used to distinguish between the calls made to featuredAndSortedPortals model in case of help-seeker view from that of portal reordering screen view, inside the state reducers */ const $167708e0f38d7b1f$var$buildModelsActionCreatorForFeaturedAndSortedPortals = (actionType, type)=>(params = {}, isPortalReorderingSelected)=>({
            type: actionType,
            payload: {
                type: type,
                params: {
                    ...params,
                    isPortalReorderingSelected: isPortalReorderingSelected
                }
            }
        });
const $167708e0f38d7b1f$export$6ea18f901a4f825e = $167708e0f38d7b1f$var$buildModelsActionCreatorForFeaturedAndSortedPortals($167708e0f38d7b1f$export$8772f11deb28968a, 'featuredAndSortedPortals');
const $167708e0f38d7b1f$export$6d3c5bcff4d8dcfc = (featuredAndSortedPortalsModel, requestParams)=>({
        requestParams: requestParams,
        type: $167708e0f38d7b1f$export$6ed163277f07d17a,
        payload: featuredAndSortedPortalsModel
    });
const $167708e0f38d7b1f$export$9d041bf07bd04f34 = (error, requestParams)=>({
        requestParams: requestParams,
        type: $167708e0f38d7b1f$export$9198b985767ee6a9,
        payload: {
            error: error
        }
    });
const $167708e0f38d7b1f$export$3b1a77584c9a6b81 = (id, isFeatured)=>({
        type: $167708e0f38d7b1f$export$c4ada71ac24d5427,
        payload: {
            isFeatured: isFeatured,
            id: id
        }
    });
const $167708e0f38d7b1f$export$89b8e7ec4e1c2d07 = (id, hiddenFromHomeScreen)=>({
        type: $167708e0f38d7b1f$export$f04d3c0a6161427f,
        payload: {
            id: id,
            hiddenFromHomeScreen: hiddenFromHomeScreen
        }
    });
const $167708e0f38d7b1f$export$62b3d711c52e9aa2 = (oldIndex, newIndex)=>({
        type: $167708e0f38d7b1f$export$e78177131adb1a7a,
        payload: {
            oldIndex: oldIndex,
            newIndex: newIndex
        }
    });
const $167708e0f38d7b1f$export$ff946f5ffd1293d7 = (meta)=>({
        meta: meta,
        type: $167708e0f38d7b1f$export$68f1a628095e7df5
    });
const $167708e0f38d7b1f$export$eeed66775c51f217 = (meta)=>({
        meta: meta,
        type: $167708e0f38d7b1f$export$aa2114acd4f820aa
    });
const $167708e0f38d7b1f$export$eb2d78b304e5909c = (meta, error)=>({
        meta: meta,
        error: error,
        type: $167708e0f38d7b1f$export$2d425395f1203ae4
    });
const $167708e0f38d7b1f$export$8fabcd6d8271b790 = (featuredPortalIds, sortBy, orderedPortalIds, hiddenPortalIds)=>({
        type: $167708e0f38d7b1f$export$e6dde7e78d51edc9,
        payload: {
            featuredPortalIds: featuredPortalIds,
            sortBy: sortBy,
            orderedPortalIds: orderedPortalIds,
            hiddenPortalIds: hiddenPortalIds
        }
    });
const $167708e0f38d7b1f$export$4b50f99aebbcd6b7 = (error)=>({
        type: $167708e0f38d7b1f$export$d6299724cb4f13de,
        payload: {
            error: error
        }
    });
const $167708e0f38d7b1f$export$4157bb81256cfd7f = (shouldRedirect)=>({
        type: $167708e0f38d7b1f$export$47862f368a701d13,
        payload: {
            shouldRedirect: shouldRedirect
        }
    });
const $167708e0f38d7b1f$export$d0f9348a57407b6c = ()=>({
        type: $167708e0f38d7b1f$export$a90731f74ba59c30
    });
const $167708e0f38d7b1f$export$5c52eef312473e8b = (featuredPortalIds, orderedPortalIds, sortBy)=>({
        type: $167708e0f38d7b1f$export$bce4411b856ef9e5,
        payload: {
            featuredPortalIds: featuredPortalIds,
            orderedPortalIds: orderedPortalIds,
            sortBy: sortBy
        }
    });

});


parcelRegister("9Con0", function(module, exports) {
$parcel$export(module.exports, "fetchFeaturedAndSortedPortalsData", () => $19b717e59ff6c28c$export$1e547feda5a72cb5);
$parcel$export(module.exports, "convertToFeaturedAndSortedPortalsResponse", () => $19b717e59ff6c28c$export$af9ca8a283fc9983);

var $j4t7D = parcelRequire("j4t7D");

var $5geAe = parcelRequire("5geAe");

var $f2UoR = parcelRequire("f2UoR");

var $6mmHn = parcelRequire("6mmHn");

var $4Ysr0 = parcelRequire("4Ysr0");
const $19b717e59ff6c28c$export$1e547feda5a72cb5 = (params)=>{
    return (0, $f2UoR.fetchQuery)((0, $4Ysr0.getRelayEnvironment)(), (0, $j4t7D.default), {
        cloudId: (0, $6mmHn.getCloudId)(),
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
        sortOrder: $19b717e59ff6c28c$var$getSortIngParams(params.sortBy),
        portalsFilter: $19b717e59ff6c28c$var$getFilterParams(params.exploreAll)
    });
};
const $19b717e59ff6c28c$var$getFilterParams = (exploreAll)=>{
    if (exploreAll) return undefined;
    return {
        typeFilter: [
            'VISIBLE'
        ]
    };
};
const $19b717e59ff6c28c$var$getSortIngParams = (sortBy)=>{
    if (sortBy === 'ALPHABETICALLY') return 'NAME_ASCENDING';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $19b717e59ff6c28c$var$getSortIngValues = (sortBy)=>{
    if (sortBy === 'NAME_ASCENDING') return 'ALPHABETICALLY';
    if (sortBy === 'POPULARITY') return 'POPULARITY';
    return undefined;
};
const $19b717e59ff6c28c$export$af9ca8a283fc9983 = (response)=>{
    var _response$helpCenter;
    if (response === undefined) return undefined;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') {
        const extensions = data.extensions;
        const message = data.message;
        if (extensions && Array.isArray(extensions) && extensions.length > 0 && message) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const { statusCode: statusCode } = extensions[0];
            const xhr = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                status: statusCode,
                responseType: 'json',
                response: data
            };
            throw new (0, $5geAe.AjaxError)(`${message} with status ${String(statusCode)}`, xhr, {});
        }
        throw new Error(message || '');
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter') {
        const portals = data.portals;
        const { portalsList: portalsList } = portals || {
            portalsList: []
        };
        return {
            sortBy: $19b717e59ff6c28c$var$getSortIngValues(portals === null || portals === void 0 ? void 0 : portals.sortOrder),
            // Backend will return all the portals there is no pagination
            total: portalsList === null || portalsList === void 0 ? void 0 : portalsList.length,
            // This FF has been rolled out so this is always true
            isPortalHidingEnabled: true,
            portals: (portalsList === null || portalsList === void 0 ? void 0 : portalsList.map((portal)=>({
                    // right now id is number will have to verify while backend integration
                    id: parseInt(portal.id, 10),
                    key: portal.key || '',
                    name: portal.name || '',
                    description: portal.description || '',
                    logoUrl: portal.logoUrl || undefined,
                    rank: portal.rank || -1,
                    portalBaseUrl: portal.portalBaseUrl,
                    isFeatured: !!portal.isFeatured,
                    hiddenFromHomeScreen: !!portal.isHidden,
                    isPortalNotVisibleOnHelpCentre: false
                }))) || []
        };
    }
    return undefined;
};

});
parcelRegister("j4t7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $01a5b2f339178faf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d849493470a62f53c7a36f89d8810125>>
 * @relayHash 25e6269361cd6efc34c09587ad76c352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e
const $01a5b2f339178faf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortOrder"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "portalsFilter",
                "variableName": "portalsFilter"
            },
            {
                "kind": "Variable",
                "name": "sortOrder",
                "variableName": "sortOrder"
            }
        ],
        "concreteType": "HelpCenterPortals",
        "kind": "LinkedField",
        "name": "portals",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sortOrder"
            },
            {
                "concreteType": "HelpCenterPortal",
                "kind": "LinkedField",
                "name": "portalsList",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "logoUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "portalBaseUrl"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isFeatured"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isHidden"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "rank"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "featuredAndSortedPortalsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f39ee54689dc5a6ad3d842c0a754bc231a105713b5b09a391d0a41c535fcb10e",
            "metadata": {},
            "name": "featuredAndSortedPortalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$01a5b2f339178faf$var$node.hash = "db239181519d00ccb6f4d7cba5dc3acd";
var $01a5b2f339178faf$export$2e2bcd8739ae039 = $01a5b2f339178faf$var$node;

});



parcelRegister("4xnQn", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $9cd65479ead62856$export$cb36b6e8b9a45314);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("f8FTt");
var $kAOtO = parcelRequire("kAOtO");

var $1MLMt = parcelRequire("1MLMt");
const $9cd65479ead62856$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $1MLMt.FETCH_FORGOT_PASSWORD_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.forgotPassword && !!response.forgotPassword.resetUrl).map((response)=>{
            return (0, $kAOtO.fetchForgotPasswordModelSuccess)(response.forgotPassword);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $kAOtO.fetchForgotPasswordModelFailure)(error));
        }));
};

});
parcelRegister("f8FTt", function(module, exports) {
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => (parcelRequire("kAOtO")).fetchForgotPasswordModelSuccess);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => (parcelRequire("kAOtO")).fetchForgotPasswordModelFailure);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => (parcelRequire("kAOtO")).FETCH_FORGOT_PASSWORD_SUCCESS);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => (parcelRequire("kAOtO")).FETCH_FORGOT_PASSWORD_FAILURE);

var $kAOtO = parcelRequire("kAOtO");

});
parcelRegister("kAOtO", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_SUCCESS", () => $521f1a07cb6dae3a$export$78f743c8c0190142);
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_FAILURE", () => $521f1a07cb6dae3a$export$aeb2acd4962d8ce9);
$parcel$export(module.exports, "fetchForgotPasswordModelSuccess", () => $521f1a07cb6dae3a$export$f5ac004adf4f85e3);
$parcel$export(module.exports, "fetchForgotPasswordModelFailure", () => $521f1a07cb6dae3a$export$d6a87818b7101f95);
const $521f1a07cb6dae3a$export$78f743c8c0190142 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_SUCCESS';
const $521f1a07cb6dae3a$export$aeb2acd4962d8ce9 = 'state.persisted.forgot.password.FETCH_FORGOT_PASSWORD_FAILURE';
const $521f1a07cb6dae3a$export$f5ac004adf4f85e3 = (forgotPasswordModel)=>({
        payload: forgotPasswordModel,
        type: $521f1a07cb6dae3a$export$78f743c8c0190142
    });
const $521f1a07cb6dae3a$export$d6a87818b7101f95 = (error)=>({
        type: $521f1a07cb6dae3a$export$aeb2acd4962d8ce9,
        payload: {
            error: error
        }
    });

});


parcelRegister("1MLMt", function(module, exports) {
$parcel$export(module.exports, "FETCH_FORGOT_PASSWORD_MODEL", () => $3daa8def47077b38$export$8908eff00e7804c6);
$parcel$export(module.exports, "fetchForgotPasswordModel", () => $3daa8def47077b38$export$41d4a614faed30ee);

var $dNzn5 = parcelRequire("dNzn5");
const $3daa8def47077b38$export$8908eff00e7804c6 = 'epic.model.FETCH_FORGOT_PASSWORD_MODEL';
const $3daa8def47077b38$export$41d4a614faed30ee = (0, $dNzn5.buildModelsActionCreator)($3daa8def47077b38$export$8908eff00e7804c6, 'forgotPassword');

});


parcelRegister("9lgXg", function(module, exports) {
$parcel$export(module.exports, "helpCenterEpic", () => $138bf9715a2e0acd$export$5b8469c39769260e);
$parcel$export(module.exports, "invalidateHelpCenterBrandingEpic", () => $138bf9715a2e0acd$export$dc52639d81083812);
$parcel$export(module.exports, "helpCenterBrandingEpic", () => $138bf9715a2e0acd$export$10de7c69d36b21f6);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $f2UoR = parcelRequire("f2UoR");
parcelRequire("eicll");
var $9wmEV = parcelRequire("9wmEV");

var $6bGmX = parcelRequire("6bGmX");

var $eSL4S = parcelRequire("eSL4S");

var $95JF0 = parcelRequire("95JF0");

var $4Ysr0 = parcelRequire("4Ysr0");

var $elY4q = parcelRequire("elY4q");

var $5eCdR = parcelRequire("5eCdR");
const $138bf9715a2e0acd$export$5b8469c39769260e = (action$)=>{
    return action$.ofType((0, $5eCdR.FETCH_HELP_CENTER_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.sharedPortal).map((response)=>{
            return (0, $9wmEV.updateHelpCenterModelAction)(response.sharedPortal);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $b0T1M.Observable).never()));
};
const $138bf9715a2e0acd$export$dc52639d81083812 = (action$)=>{
    return action$.ofType((0, $5eCdR.INVALIDATE_HELP_CENTER_RELAY_STORE)).mergeMap(()=>{
        // invalidate local cache of relay store for help center branding
        (0, $f2UoR.commitLocalUpdate)((0, $4Ysr0.getRelayEnvironment)(), (relayStore)=>{
            const root = relayStore.getRoot();
            const query = root.getLinkedRecord('helpCenter', {
                cloudId: (0, $6mmHn.getCloudId)()
            });
            const helpCenter = query === null || query === void 0 ? void 0 : query.getLinkedRecord('helpCenterById', {
                helpCenterAri: (0, $6mmHn.getHelpCenterAri)()
            });
            helpCenter === null || helpCenter === void 0 || helpCenter.invalidateRecord();
        });
        const noAction = (0, $b0T1M.Observable).never();
        return noAction;
    });
};
const $138bf9715a2e0acd$export$10de7c69d36b21f6 = (action$)=>{
    return action$.ofType((0, $5eCdR.FETCH_HELP_CENTER_BRANDING_MODEL)).mergeMap((action)=>{
        const noAction = (0, $b0T1M.Observable).never();
        if ((0, $bG6ob.isDefaultHCUsingGqlBrandingCalls)() || (0, $eSL4S.isKoshEnabledForDefaultHelpCenter)()) return (0, $b0T1M.Observable).from((0, $95JF0.fetchBrandingData)().toPromise().then((response)=>(0, $95JF0.convertToHCBrandingResponse)(response))).filter((data)=>!!data).flatMap((data)=>{
            if (data) return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingModelAction)(data)), (0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingLoaderAction)(true)));
            throw new Error('No data');
        }).catch(()=>(0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingLoaderAction)(true)));
        return (0, $b0T1M.Observable).from((0, $elY4q.default)(action.payload).filter((response)=>!!response.helpCenterBranding).flatMap((response)=>{
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingModelAction)(response.helpCenterBranding)), (0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingLoaderAction)(true)));
        }).catch((_)=>(0, $6bGmX.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? (0, $b0T1M.Observable).of((0, $9wmEV.updateHCBrandingLoaderAction)(true)) : noAction));
    });
};

});

parcelRegister("eKcjF", function(module, exports) {
$parcel$export(module.exports, "default", () => $177caca65be4ca5f$export$2e2bcd8739ae039);

var $jd6MB = parcelRequire("jd6MB");
var $1I5Du = parcelRequire("1I5Du");
var $b0T1M = parcelRequire("b0T1M");

var $iUmnK = parcelRequire("iUmnK");

var $02SMv = parcelRequire("02SMv");
parcelRequire("aOAJO");
var $2akLv = parcelRequire("2akLv");
parcelRequire("frlrJ");
var $bHntx = parcelRequire("bHntx");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $5s0wd = parcelRequire("5s0wd");
const $177caca65be4ca5f$var$categoryArticlesEpic = (action$)=>{
    return action$.ofType((0, $5s0wd.FETCH_ARTICLES)).mergeMap((action)=>{
        const { projectId: projectId, categoryId: categoryId, portalId: portalId, categoryDataRequired: categoryDataRequired, meta: meta } = action.payload;
        if (categoryDataRequired) // parallelize categories request with articles, used on initial category page load, ensures we always have the necessary category data
        return (0, $1I5Du.forkJoin)((0, $02SMv.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((articlesResponse)=>(0, $2akLv.fetchArticlesSuccess)(articlesResponse, categoryId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.statusCode)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $2akLv.fetchArticlesFailure)(error, portalId, categoryId));
        }), (0, $iUmnK.fetchCategories)({
            projectId: projectId
        }).map((categoriesResponse)=>(0, $bHntx.fetchCategoriesSuccess)(categoriesResponse, portalId)).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.statusCode)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $bHntx.fetchCategoriesFailure)(error, portalId));
        })).mergeMap(([articlesSuccessOrFailure, categoriesSuccessOrFailure])=>(0, $jd6MB.concat)((0, $b0T1M.Observable).of(articlesSuccessOrFailure), (0, $b0T1M.Observable).of(categoriesSuccessOrFailure)));
        return (0, $02SMv.fetchArticlesForCategory)({
            projectId: projectId,
            categoryId: categoryId
        }).map((response)=>{
            return (0, $2akLv.fetchArticlesSuccess)(response, categoryId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.statusCode)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $2akLv.fetchArticlesFailure)(error, portalId, categoryId));
        });
    });
};
var $177caca65be4ca5f$export$2e2bcd8739ae039 = $177caca65be4ca5f$var$categoryArticlesEpic;

});
parcelRegister("iUmnK", function(module, exports) {
$parcel$export(module.exports, "fetchCategories", () => $b1ba00fd391adc43$export$416ec9f5729de215);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $6mmHn = parcelRequire("6mmHn");

var $4axJ1 = parcelRequire("4axJ1");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");
const $b1ba00fd391adc43$var$mapApolloErrorResponse = (error)=>{
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: error.message || ''
    };
};
const $b1ba00fd391adc43$export$416ec9f5729de215 = ({ projectId: projectId, contextPath: contextPath = (0, $3wR8f.contextPath) })=>{
    const activationId = (0, $6mmHn.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category`;
    return (0, $lVFX8.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $keOG0.trackError)('categories.fetch.all.failed', {}, e);
        return (0, $b0T1M.Observable).throw($b1ba00fd391adc43$var$mapApolloErrorResponse(e));
    });
};

});

parcelRegister("02SMv", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesForCategory", () => $e36abf1c5a582cf8$export$b51ae2f6685b749);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $6mmHn = parcelRequire("6mmHn");

var $4i2V5 = parcelRequire("4i2V5");

var $4axJ1 = parcelRequire("4axJ1");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");

var $kwfwK = parcelRequire("kwfwK");
const $e36abf1c5a582cf8$var$errorKeyToMessage = {
    'jsd.apollo.error.category.not.found': (0, $kwfwK.default).categoryNotFound,
    'jsd.apollo.error.project.permission.no.view.project.permission': (0, $kwfwK.default).noPermission,
    'jsd.apollo.error.article.not.found': (0, $kwfwK.default).articleNotFound
};
const $e36abf1c5a582cf8$var$mapApolloErrorResponse = (error)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = error.response;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (response && response.errorKey && $e36abf1c5a582cf8$var$errorKeyToMessage[response.errorKey]) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const translatedMessage = $e36abf1c5a582cf8$var$errorKeyToMessage[response.errorKey];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
        return {
            ...error.response,
            errorMessage: translatedMessage
        };
    }
    return {
        statusCode: error.status,
        errorKey: '',
        errorMessage: ''
    };
};
const $e36abf1c5a582cf8$export$b51ae2f6685b749 = ({ projectId: projectId, categoryId: categoryId, contextPath: contextPath = (0, $3wR8f.contextPath) })=>{
    const queryString = $4i2V5.stringify({
        limit: 100,
        orderBy: '+featured',
        expand: 'category'
    });
    const activationId = (0, $6mmHn.getMeta)('activation-id');
    const uri = `${contextPath}${(0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT)}/${activationId}/api/project/${projectId}/category/${categoryId}/article?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        (0, $keOG0.trackError)('category.article.fetch.failed', {}, e);
        return (0, $b0T1M.Observable).throw($e36abf1c5a582cf8$var$mapApolloErrorResponse(e));
    });
};

});
parcelRegister("kwfwK", function(module, exports) {
$parcel$export(module.exports, "default", () => $fcab6999f5785778$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $fcab6999f5785778$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    categoryNotFound: {
        id: 'cv.error.page.category.page.category.not.found',
        defaultMessage: "That category doesn't exist.",
        description: 'The error message shown when the category not found on the category page.'
    },
    articleNotFound: {
        id: 'cv.error.page.category.page.article.not.found',
        defaultMessage: "That article doesn't exist.",
        description: 'The error message shown when the requested article was not found on the category page.'
    },
    noPermission: {
        id: 'cv.error.page.category.page.no-permission',
        defaultMessage: 'You do not have permission to view this category. Ask an admin to check your permissions.',
        description: 'The error shown when the user does not have permission to add categories to the project.'
    },
    callToActionText: {
        id: 'cv.error.page.category.page.call.to.action',
        defaultMessage: 'Go back',
        description: 'Call to action message shown when an error occurs on the category page'
    }
});

});


parcelRegister("aOAJO", function(module, exports) {
$parcel$export(module.exports, "fetchArticlesSuccess", () => (parcelRequire("2akLv")).fetchArticlesSuccess);
$parcel$export(module.exports, "fetchArticlesFailure", () => (parcelRequire("2akLv")).fetchArticlesFailure);

var $2akLv = parcelRequire("2akLv");

});
parcelRegister("2akLv", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES_SUCCESS", () => $2a7e889f6c0d932d$export$76b83d637130c0fa);
$parcel$export(module.exports, "FETCH_ARTICLES_FAILURE", () => $2a7e889f6c0d932d$export$7c415676e9f98e60);
$parcel$export(module.exports, "fetchArticlesSuccess", () => $2a7e889f6c0d932d$export$5a1d149417c43ad9);
$parcel$export(module.exports, "fetchArticlesFailure", () => $2a7e889f6c0d932d$export$47896f258d652153);
const $2a7e889f6c0d932d$export$76b83d637130c0fa = 'state.persisted.kb.articles.FETCH_ARTICLES_SUCCESS';
const $2a7e889f6c0d932d$export$7c415676e9f98e60 = 'state.persisted.kb.articles.FETCH_ARTICLES_FAILURE';
const $2a7e889f6c0d932d$export$5a1d149417c43ad9 = (response, categoryId)=>({
        type: $2a7e889f6c0d932d$export$76b83d637130c0fa,
        payload: {
            response: response,
            categoryId: categoryId
        }
    });
const $2a7e889f6c0d932d$export$47896f258d652153 = (error, portalId, categoryId)=>({
        type: $2a7e889f6c0d932d$export$7c415676e9f98e60,
        payload: {
            error: error,
            portalId: portalId,
            categoryId: categoryId
        }
    });

});


parcelRegister("frlrJ", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => (parcelRequire("bHntx")).FETCH_CATEGORIES_SUCCESS);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => (parcelRequire("bHntx")).FETCH_CATEGORIES_FAILURE);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => (parcelRequire("bHntx")).fetchCategoriesSuccess);
$parcel$export(module.exports, "fetchCategoriesFailure", () => (parcelRequire("bHntx")).fetchCategoriesFailure);

var $bHntx = parcelRequire("bHntx");

});
parcelRegister("bHntx", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES_SUCCESS", () => $4ddc41048b819575$export$8fe15054f89178e3);
$parcel$export(module.exports, "FETCH_CATEGORIES_FAILURE", () => $4ddc41048b819575$export$4425a101b60fad1);
$parcel$export(module.exports, "fetchCategoriesSuccess", () => $4ddc41048b819575$export$1372a078b0bbb728);
$parcel$export(module.exports, "fetchCategoriesFailure", () => $4ddc41048b819575$export$10b1ac5b71f5513e);
const $4ddc41048b819575$export$8fe15054f89178e3 = 'state.persisted.kb.categories.FETCH_CATEGORIES_SUCCESS';
const $4ddc41048b819575$export$4425a101b60fad1 = 'state.persisted.kb.categories.FETCH_CATEGORIES_FAILURE';
const $4ddc41048b819575$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $4ddc41048b819575$export$1372a078b0bbb728 = (response, portalId)=>{
    if (Array.isArray(response)) return {
        type: $4ddc41048b819575$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: response
        }
    };
    const isCategoriesSupported = response.categoriesSupported;
    return {
        type: $4ddc41048b819575$export$8fe15054f89178e3,
        payload: {
            portalId: portalId,
            categories: isCategoriesSupported ? response.categories : $4ddc41048b819575$export$baa53a1870be4bc5
        }
    };
};
const $4ddc41048b819575$export$10b1ac5b71f5513e = (error, portalId)=>({
        type: $4ddc41048b819575$export$4425a101b60fad1,
        payload: {
            error: error,
            portalId: portalId
        }
    });

});


parcelRegister("5s0wd", function(module, exports) {
$parcel$export(module.exports, "FETCH_ARTICLES", () => $448b048cf11d3c4b$export$d5cdb0266add81c8);
$parcel$export(module.exports, "fetchArticlesAction", () => $448b048cf11d3c4b$export$43937e098a3fb347);
const $448b048cf11d3c4b$export$d5cdb0266add81c8 = 'epic.model.FETCH_KB_ARTICLES';
const $448b048cf11d3c4b$export$43937e098a3fb347 = (params)=>{
    const { projectId: projectId, portalId: portalId, categoryId: categoryId, categoryDataRequired: categoryDataRequired, meta: meta } = params;
    return {
        type: $448b048cf11d3c4b$export$d5cdb0266add81c8,
        payload: {
            projectId: projectId,
            portalId: portalId,
            categoryId: categoryId,
            categoryDataRequired: categoryDataRequired,
            meta: meta
        }
    };
};

});


parcelRegister("do6Dv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f37c38ed409c84e$export$2e2bcd8739ae039);

var $b0T1M = parcelRequire("b0T1M");

var $iUmnK = parcelRequire("iUmnK");
parcelRequire("frlrJ");
var $bHntx = parcelRequire("bHntx");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $jz05t = parcelRequire("jz05t");
const $2f37c38ed409c84e$var$categoriesEpic = (action$)=>{
    return action$.ofType((0, $jz05t.FETCH_CATEGORIES)).mergeMap((action)=>{
        const { portalId: portalId, projectId: projectId, meta: meta } = action.payload;
        return (0, $iUmnK.fetchCategories)({
            projectId: projectId
        }).map((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            return (0, $bHntx.fetchCategoriesSuccess)(response, portalId);
        }).catch((error)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.statusCode)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $bHntx.fetchCategoriesFailure)(error, portalId));
        });
    });
};
var $2f37c38ed409c84e$export$2e2bcd8739ae039 = $2f37c38ed409c84e$var$categoriesEpic;

});
parcelRegister("jz05t", function(module, exports) {
$parcel$export(module.exports, "FETCH_CATEGORIES", () => $4391f357900777ce$export$cce9a7031b65f96c);
$parcel$export(module.exports, "fetchCategoriesAction", () => $4391f357900777ce$export$10813fa84276d50);
const $4391f357900777ce$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $4391f357900777ce$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $4391f357900777ce$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});


parcelRegister("isOOS", function(module, exports) {
$parcel$export(module.exports, "languagesEpic", () => $096d1e3c86daba8e$export$f18fac0a77b35e0d);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $elY4q = parcelRequire("elY4q");
parcelRequire("cjuJm");
var $hM8jd = parcelRequire("hM8jd");

var $fI5Sq = parcelRequire("fI5Sq");
const $096d1e3c86daba8e$export$f18fac0a77b35e0d = (action$)=>{
    return action$.ofType((0, $hM8jd.FETCH_LANGUAGES_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.availableLanguages).map((response)=>{
            return (0, $hM8jd.fetchLanguagesSuccess)(response.availableLanguages || []);
        }).catch((_)=>{
            return (0, $b0T1M.Observable).of((0, $gBYjj.showErrorFlag)((0, $fI5Sq.genericError).title, (0, $fI5Sq.genericError).description));
        }));
};

});
parcelRegister("cjuJm", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => (parcelRequire("hM8jd")).FETCH_LANGUAGES_SUCCESS);
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => (parcelRequire("hM8jd")).FETCH_LANGUAGES_MODEL);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => (parcelRequire("hM8jd")).fetchLanguagesSuccess);
$parcel$export(module.exports, "fetchLanguagesModel", () => (parcelRequire("hM8jd")).fetchLanguagesModel);

var $hM8jd = parcelRequire("hM8jd");

});
parcelRegister("hM8jd", function(module, exports) {
$parcel$export(module.exports, "FETCH_LANGUAGES_MODEL", () => $2e820b4f1958faef$export$50695c17a56afb1c);
$parcel$export(module.exports, "FETCH_LANGUAGES_SUCCESS", () => $2e820b4f1958faef$export$e4a250eae790b1c0);
$parcel$export(module.exports, "fetchLanguagesModel", () => $2e820b4f1958faef$export$93153c0d57b5d23f);
$parcel$export(module.exports, "fetchLanguagesSuccess", () => $2e820b4f1958faef$export$5ecfd42a9b3d2b31);

var $dNzn5 = parcelRequire("dNzn5");
const $2e820b4f1958faef$export$50695c17a56afb1c = 'epic.model.FETCH_LANGUAGES_MODEL';
const $2e820b4f1958faef$export$e4a250eae790b1c0 = 'state.persisted.languages.FETCH_LANGUAGES_SUCCESS';
const $2e820b4f1958faef$export$93153c0d57b5d23f = (0, $dNzn5.buildModelsActionCreator)($2e820b4f1958faef$export$50695c17a56afb1c, 'availableLanguages');
const $2e820b4f1958faef$export$5ecfd42a9b3d2b31 = (languages)=>({
        type: $2e820b4f1958faef$export$e4a250eae790b1c0,
        payload: {
            languages: languages
        }
    });

});



parcelRegister("FiKDW", function(module, exports) {
$parcel$export(module.exports, "loginEpic", () => $4fd278c897e9ba35$export$da8045e9cad7ec9b);

var $iLkO5 = parcelRequire("iLkO5");

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");

var $gb0lQ = parcelRequire("gb0lQ");
const $4fd278c897e9ba35$export$da8045e9cad7ec9b = (action$)=>{
    return action$.ofType((0, $gb0lQ.FETCH_LOGIN_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.login && !(0, (/*@__PURE__*/$parcel$interopDefault($iLkO5)))(response.login)).map((response)=>{
            return (0, $8o5VQ.fetchLoginSuccess)(response.login);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $8o5VQ.fetchLoginFailure)(error));
        }));
};

});
parcelRegister("iLkO5", function(module, exports) {

var $lmpdm = parcelRequire("lmpdm");

var $4L1Ez = parcelRequire("4L1Ez");

var $8v2QX = parcelRequire("8v2QX");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $l6LA7 = parcelRequire("l6LA7");

var $gJsvo = parcelRequire("gJsvo");

var $4hd8j = parcelRequire("4hd8j");

var $bGgiZ = parcelRequire("bGgiZ");
/** `Object#toString` result references. */ var $da8cc199652e1110$var$mapTag = '[object Map]', $da8cc199652e1110$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $da8cc199652e1110$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $da8cc199652e1110$var$hasOwnProperty = $da8cc199652e1110$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $da8cc199652e1110$var$isEmpty(value) {
    if (value == null) return true;
    if ($l6LA7(value) && ($3Tp9Q(value) || typeof value == 'string' || typeof value.splice == 'function' || $gJsvo(value) || $bGgiZ(value) || $8v2QX(value))) return !value.length;
    var tag = $4L1Ez(value);
    if (tag == $da8cc199652e1110$var$mapTag || tag == $da8cc199652e1110$var$setTag) return !value.size;
    if ($4hd8j(value)) return !$lmpdm(value).length;
    for(var key in value){
        if ($da8cc199652e1110$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $da8cc199652e1110$var$isEmpty;

});

parcelRegister("gb0lQ", function(module, exports) {
$parcel$export(module.exports, "FETCH_LOGIN_MODEL", () => $f19afca28519be02$export$c7e01c95750f0d63);
$parcel$export(module.exports, "fetchLoginModel", () => $f19afca28519be02$export$6e443fe31e715257);

var $dNzn5 = parcelRequire("dNzn5");
const $f19afca28519be02$export$c7e01c95750f0d63 = 'epic.model.FETCH_LOGIN_MODEL';
const $f19afca28519be02$export$6e443fe31e715257 = (0, $dNzn5.buildModelsActionCreator)($f19afca28519be02$export$c7e01c95750f0d63, 'login');

});


parcelRegister("eos1s", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsEpic", () => $6e0d050d3236f36e$export$8abec8cdaadd5d28);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("5raaz");
var $bK3LM = parcelRequire("bK3LM");

var $eSL4S = parcelRequire("eSL4S");

var $ifTD8 = parcelRequire("ifTD8");
const $6e0d050d3236f36e$export$32d9db53927095d3 = {
    defaultLocale: '',
    translatedLoginAnnouncements: {}
};
const $6e0d050d3236f36e$export$8abec8cdaadd5d28 = (action$)=>{
    return action$.ofType((0, $bK3LM.FETCH_LOGIN_ANNOUNCEMENTS)).mergeMap((action)=>{
        if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)()) return (0, $b0T1M.Observable).from((0, $ifTD8.fetchLoginAnnouncementsData)().toPromise().then((response)=>(0, $ifTD8.convertToLoginAnnouncementsResponse)(response))).filter((data)=>Boolean(data)).map((data)=>{
            if (data) return (0, $bK3LM.fetchLoginAnnouncementsSuccess)(data);
            return (0, $bK3LM.fetchLoginAnnouncementsSuccess)($6e0d050d3236f36e$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $bK3LM.fetchLoginAnnouncementsFailure)(error));
        });
        return (0, $elY4q.default)(action.payload).filter((response)=>Boolean(response)).map((response)=>{
            if (response.loginAnnouncements) return (0, $bK3LM.fetchLoginAnnouncementsSuccess)(response.loginAnnouncements);
            return (0, $bK3LM.fetchLoginAnnouncementsSuccess)($6e0d050d3236f36e$export$32d9db53927095d3);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $bK3LM.fetchLoginAnnouncementsFailure)(error));
        });
    });
};

});
parcelRegister("ifTD8", function(module, exports) {
$parcel$export(module.exports, "fetchLoginAnnouncementsData", () => $4613d5f97cfd7b1c$export$32c914da1ff32f72);
$parcel$export(module.exports, "convertToLoginAnnouncementsResponse", () => $4613d5f97cfd7b1c$export$a8a0b51b62d54e0);

var $cXiF2 = parcelRequire("cXiF2");

var $6mmHn = parcelRequire("6mmHn");

var $f2UoR = parcelRequire("f2UoR");

var $4Ysr0 = parcelRequire("4Ysr0");
const $4613d5f97cfd7b1c$export$32c914da1ff32f72 = ()=>{
    return (0, $f2UoR.fetchQuery)((0, $4Ysr0.getRelayEnvironment)(), (0, $cXiF2.default), {
        cloudId: (0, $6mmHn.getCloudId)(),
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)()
    });
};
const $4613d5f97cfd7b1c$var$mergeNameAndDescriptionTranslations = (nameTranslationsRaw, descriptionTranslationsRaw)=>{
    const translatedLoginAnnouncements = {};
    nameTranslationsRaw === null || nameTranslationsRaw === void 0 || nameTranslationsRaw.forEach((translationName)=>{
        const locale = translationName.locale;
        const header = translationName.value;
        const targetDescriptionAnnouncement = descriptionTranslationsRaw === null || descriptionTranslationsRaw === void 0 ? void 0 : descriptionTranslationsRaw.find((translationDescription)=>translationDescription.locale === locale);
        translatedLoginAnnouncements[locale] = {
            header: header,
            message: (targetDescriptionAnnouncement === null || targetDescriptionAnnouncement === void 0 ? void 0 : targetDescriptionAnnouncement.value) || '',
            localeDisplayName: translationName.localeDisplayName
        };
    });
    return translatedLoginAnnouncements;
};
const $4613d5f97cfd7b1c$export$a8a0b51b62d54e0 = (response)=>{
    var _response$helpCenter, _data$announcements;
    if (response === undefined) return null;
    const data = response === null || response === void 0 || (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterById;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'QueryError') return null;
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && (_data$announcements = data.announcements) !== null && _data$announcements !== void 0 && (_data$announcements = _data$announcements.loginAnnouncements) !== null && _data$announcements !== void 0 && _data$announcements.length) {
        // Currently we only support one login announcement
        const targetLoginAnnouncement = data.announcements.loginAnnouncements[0];
        return {
            translatedLoginAnnouncements: $4613d5f97cfd7b1c$var$mergeNameAndDescriptionTranslations(targetLoginAnnouncement.nameTranslationsRaw || [], targetLoginAnnouncement.descriptionTranslationsRaw || []),
            defaultLocale: data.siteDefaultLanguageTag || ''
        };
    }
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'HelpCenter' && data.siteDefaultLanguageTag) // case then loginAnnouncements array is empty but siteDefaultLanguageTag is present, we have to map default locale
    return {
        translatedLoginAnnouncements: {
            [data.siteDefaultLanguageTag]: {
                localeDisplayName: data.siteDefaultLanguageTag,
                header: '',
                message: ''
            }
        },
        defaultLocale: data.siteDefaultLanguageTag
    };
    return null;
};

});
parcelRegister("cXiF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d023b1e4093ac3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e9a2845fdb0ebf85b6c1c8816fcdfced>>
 * @relayHash 71f2f66044bc8f8bd3ab026ad2505549
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b
const $5d023b1e4093ac3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "siteDefaultLanguageTag"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "locale"
        },
        {
            "kind": "ScalarField",
            "name": "localeDisplayName"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "nameTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterTranslation",
                        "kind": "LinkedField",
                        "name": "descriptionTranslationsRaw",
                        "plural": true,
                        "selections": v5 /*: any*/ 
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "00910c359e88e27b753f51cb8a569097d0d751c8ced7cfea7f2763072ff56f4b",
            "metadata": {},
            "name": "loginAnnouncementsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5d023b1e4093ac3f$var$node.hash = "76319886fc90231eee48f51d80798d47";
var $5d023b1e4093ac3f$export$2e2bcd8739ae039 = $5d023b1e4093ac3f$var$node;

});



parcelRegister("2zNLi", function(module, exports) {
$parcel$export(module.exports, "organisationsEpic", () => $03cde963d2060bd8$export$11ed7e95538202ff);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");

var $3dLJl = parcelRequire("3dLJl");

var $63sfu = parcelRequire("63sfu");
parcelRequire("3zVJa");
var $fZ4s6 = parcelRequire("fZ4s6");
const $03cde963d2060bd8$export$11ed7e95538202ff = (action$)=>{
    return action$.ofType((0, $3dLJl.FETCH_ORGANISATIONS_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.organisations && !(0, $63sfu.isEmpty)(response.organisations)).map((response)=>{
            return (0, $fZ4s6.updateOrganisationsModelAction)(response.organisations);
        })// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $b0T1M.Observable).never()));
};
var $03cde963d2060bd8$export$2e2bcd8739ae039 = $03cde963d2060bd8$export$11ed7e95538202ff;

});
parcelRegister("3dLJl", function(module, exports) {
$parcel$export(module.exports, "FETCH_ORGANISATIONS_MODEL", () => $ef2e5ec4a5dd1d0d$export$b60557155cf3c6c0);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $ef2e5ec4a5dd1d0d$export$cbdd5d7a098d34a2);

var $dNzn5 = parcelRequire("dNzn5");
const $ef2e5ec4a5dd1d0d$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $ef2e5ec4a5dd1d0d$export$cbdd5d7a098d34a2 = (0, $dNzn5.buildModelsActionCreator)($ef2e5ec4a5dd1d0d$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("3zVJa", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => (parcelRequire("fZ4s6")).UPDATE_ORGANISATIONS_MODEL);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => (parcelRequire("fZ4s6")).updateOrganisationsModelAction);

var $fZ4s6 = parcelRequire("fZ4s6");

});
parcelRegister("fZ4s6", function(module, exports) {
$parcel$export(module.exports, "UPDATE_ORGANISATIONS_MODEL", () => $334ca58cc6098bd6$export$1fb754e532426cdc);
$parcel$export(module.exports, "updateOrganisationsModelAction", () => $334ca58cc6098bd6$export$72c2e60e3f358ed9);
const $334ca58cc6098bd6$export$1fb754e532426cdc = 'state.persisted.organisations.UPDATE_ORGANISATIONS_MODEL';
const $334ca58cc6098bd6$export$72c2e60e3f358ed9 = (organisations)=>({
        payload: organisations,
        type: $334ca58cc6098bd6$export$1fb754e532426cdc
    });

});



parcelRegister("cSNss", function(module, exports) {
$parcel$export(module.exports, "portalEpic", () => $2c9f8786695a6a20$export$a9922bad2863d6ee);
$parcel$export(module.exports, "portalUploadMediaTokenEpic", () => $2c9f8786695a6a20$export$a5051d4620a9cd24);
$parcel$export(module.exports, "refreshPortalUploadMediaTokenBeforeExpiryEpic", () => $2c9f8786695a6a20$export$9bf2e8f39289e99a);

var $b0T1M = parcelRequire("b0T1M");

var $lki4o = parcelRequire("lki4o");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");

var $keOG0 = parcelRequire("keOG0");

var $elY4q = parcelRequire("elY4q");
const $2c9f8786695a6a20$export$a9922bad2863d6ee = (action$)=>{
    return action$.ofType((0, $lXazD.FETCH_PORTAL_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.portal && !!response.branding).map((response)=>{
            var _action$meta;
            if ((_action$meta = action.meta) !== null && _action$meta !== void 0 && _action$meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(action.meta.analyticsSuccessEvent);
            return (0, $lXazD.fetchPortalSuccess)(response.portal, response.branding);
        }).catch((error)=>{
            var _action$meta2;
            if ((_action$meta2 = action.meta) !== null && _action$meta2 !== void 0 && _action$meta2.analyticsFailureEvent && error.status !== 0) (0, $keOG0.legacySendEvent)(action.meta.analyticsFailureEvent);
            const params = action.payload.params;
            return (0, $b0T1M.Observable).of((0, $lXazD.fetchPortalFailure)(params.id, error));
        }));
};
const $2c9f8786695a6a20$export$a5051d4620a9cd24 = (action$)=>{
    return action$.ofType((0, $lXazD.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION)).mergeMap((action)=>{
        const portalId = action.payload.portalId;
        return (0, $lki4o.getUploadCredentialsObservable)(portalId).map((response)=>(0, $lXazD.fetchPortalUploadMediaTokenSuccess)({
                ...response,
                tokenDurationInMins: (response.expiryEpoch - Date.now()) / 60000
            }, portalId)).catch(()=>{
            return (0, $b0T1M.Observable).of((0, $lXazD.fetchPortalUploadMediaTokenFailure)());
        });
    });
};
const $2c9f8786695a6a20$export$9bf2e8f39289e99a = (action$)=>{
    return action$.ofType((0, $lXazD.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS), (0, $lXazD.FETCH_PORTAL_SUCCESS)).switchMap((action)=>{
        const uploadContext = action.payload.mediaApiUploadInformation;
        if (uploadContext && 'token' in uploadContext) {
            const mediaApiUploadToken = uploadContext;
            // gets the token duration in milliseconds minus 5 minute buffer for network calls/inactive tab throttling
            const wantsRefreshAt = mediaApiUploadToken.tokenDurationInMins * 60000 - 300000;
            const timeUntilRefresh = Math.max(1, wantsRefreshAt);
            const portalId = action.type === (0, $lXazD.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS) ? action.payload.portalId : action.payload.id;
            if (portalId) return (0, $b0T1M.Observable).of((0, $lXazD.fetchPortalUploadMediaTokenAction)(Number(portalId))).delay(timeUntilRefresh);
        }
        return (0, $b0T1M.Observable).empty();
    });
};

});
parcelRegister("lki4o", function(module, exports) {
$parcel$export(module.exports, "getUploadCredentials", () => $c0c73ba78b214c37$export$1d8e51ec2b973100);
$parcel$export(module.exports, "getUploadCredentialsObservable", () => $c0c73ba78b214c37$export$42e3feb9754fda17);
$parcel$export(module.exports, "getCredentialsForMediaRequest", () => $c0c73ba78b214c37$export$ec7ab5d74f1f3c37);
$parcel$export(module.exports, "getUploadCredentialsForRequest", () => $c0c73ba78b214c37$export$766d1bd3b5e7fe1b);
$parcel$export(module.exports, "getReadCredentialsForRequest", () => $c0c73ba78b214c37$export$9748c08f8d568d41);

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $c0c73ba78b214c37$export$1d8e51ec2b973100 = (portalId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $c0c73ba78b214c37$export$42e3feb9754fda17 = (portalId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, headers).map((ajaxResponse)=>ajaxResponse.response);
};
const $c0c73ba78b214c37$export$ec7ab5d74f1f3c37 = (portalId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/credentials/upload/inline`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $c0c73ba78b214c37$export$766d1bd3b5e7fe1b = (portalId, requestId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/upload`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response);
};
const $c0c73ba78b214c37$export$9748c08f8d568d41 = (portalId, requestId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/portal/${portalId}/media/${requestId}/credentials/read`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, headers).map((response)=>response.response);
};

});

parcelRegister("6myLg", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => (parcelRequire("lXazD")).FETCH_PORTAL_MODEL);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => (parcelRequire("lXazD")).FETCH_PORTAL_SUCCESS);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => (parcelRequire("lXazD")).FETCH_PORTAL_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => (parcelRequire("lXazD")).UPDATE_PORTAL_ANNOUNCEMENT_MODEL);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => (parcelRequire("lXazD")).UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => (parcelRequire("lXazD")).UPDATE_PORTAL_ANNOUNCEMENT_FAILURE);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => (parcelRequire("lXazD")).UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => (parcelRequire("lXazD")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => (parcelRequire("lXazD")).FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS);
$parcel$export(module.exports, "fetchPortalAction", () => (parcelRequire("lXazD")).fetchPortalAction);
$parcel$export(module.exports, "fetchPortalSuccess", () => (parcelRequire("lXazD")).fetchPortalSuccess);
$parcel$export(module.exports, "fetchPortalFailure", () => (parcelRequire("lXazD")).fetchPortalFailure);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => (parcelRequire("lXazD")).updatePortalAnnouncementModel);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => (parcelRequire("lXazD")).updatePortalAnnouncementSuccess);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => (parcelRequire("lXazD")).updatePortalAnnouncementFailure);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => (parcelRequire("lXazD")).updatePortalAnnouncementsUIState);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => (parcelRequire("lXazD")).fetchPortalUploadMediaTokenAction);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => (parcelRequire("lXazD")).fetchPortalUploadMediaTokenSuccess);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => (parcelRequire("lXazD")).fetchPortalUploadMediaTokenFailure);

var $lXazD = parcelRequire("lXazD");

});
parcelRegister("lXazD", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_MODEL", () => $40fc3da09ded601f$export$fca1c6628f14bdf2);
$parcel$export(module.exports, "FETCH_PORTAL_SUCCESS", () => $40fc3da09ded601f$export$b929cb285face2c);
$parcel$export(module.exports, "FETCH_PORTAL_FAILURE", () => $40fc3da09ded601f$export$d0378806ff79f20f);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_MODEL", () => $40fc3da09ded601f$export$f1992600da6904c6);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS", () => $40fc3da09ded601f$export$9181049110925f2a);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENT_FAILURE", () => $40fc3da09ded601f$export$d5fa92c7d79f8706);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION", () => $40fc3da09ded601f$export$6a473efc246ca86a);
$parcel$export(module.exports, "FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS", () => $40fc3da09ded601f$export$eedf58a097d7a901);
$parcel$export(module.exports, "UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE", () => $40fc3da09ded601f$export$c769ac1c1c5f67f5);
$parcel$export(module.exports, "fetchPortalAction", () => $40fc3da09ded601f$export$8262b38db2952a96);
$parcel$export(module.exports, "fetchPortalSuccess", () => $40fc3da09ded601f$export$c9cc1b81c69f8b54);
$parcel$export(module.exports, "fetchPortalFailure", () => $40fc3da09ded601f$export$bc631fe34431953a);
$parcel$export(module.exports, "updatePortalAnnouncementModel", () => $40fc3da09ded601f$export$a2c25b3a57d1e1e1);
$parcel$export(module.exports, "updatePortalAnnouncementSuccess", () => $40fc3da09ded601f$export$1cb4859b979a107e);
$parcel$export(module.exports, "updatePortalAnnouncementFailure", () => $40fc3da09ded601f$export$a71bb12efca5ed02);
$parcel$export(module.exports, "updatePortalAnnouncementsUIState", () => $40fc3da09ded601f$export$7f7bb35e246605cc);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenAction", () => $40fc3da09ded601f$export$82b91227c2617f7c);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenSuccess", () => $40fc3da09ded601f$export$977a37e5820c7d60);
$parcel$export(module.exports, "fetchPortalUploadMediaTokenFailure", () => $40fc3da09ded601f$export$5531ab3802c122e6);

var $dNzn5 = parcelRequire("dNzn5");
const $40fc3da09ded601f$export$fca1c6628f14bdf2 = 'epic.model.FETCH_PORTAL_MODEL';
const $40fc3da09ded601f$export$b929cb285face2c = 'state.persisted.portals.FETCH_PORTAL_SUCCESS';
const $40fc3da09ded601f$export$d0378806ff79f20f = 'state.persisted.portals.FETCH_PORTAL_FAILURE';
const $40fc3da09ded601f$export$f1992600da6904c6 = 'epic.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENT_MODEL';
const $40fc3da09ded601f$export$9181049110925f2a = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS';
const $40fc3da09ded601f$export$d5fa92c7d79f8706 = 'state.persisted.portals.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE';
const $40fc3da09ded601f$export$6a473efc246ca86a = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_ACTION';
const $40fc3da09ded601f$export$eedf58a097d7a901 = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $40fc3da09ded601f$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE = 'state.persisted.portal.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE';
const $40fc3da09ded601f$export$c769ac1c1c5f67f5 = 'state.ui.portal-announcements.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE';
const $40fc3da09ded601f$export$8262b38db2952a96 = (payload, meta)=>({
        meta: meta,
        ...(0, $dNzn5.buildModelsActionCreator)($40fc3da09ded601f$export$fca1c6628f14bdf2, 'portal')(payload)
    });
const $40fc3da09ded601f$export$c9cc1b81c69f8b54 = (portalModel, portalBrandingResponse)=>{
    return {
        payload: {
            ...portalBrandingResponse,
            ...portalModel
        },
        type: $40fc3da09ded601f$export$b929cb285face2c
    };
};
const $40fc3da09ded601f$export$bc631fe34431953a = (portalId, error)=>({
        type: $40fc3da09ded601f$export$d0378806ff79f20f,
        payload: {
            portalId: portalId,
            error: error
        }
    });
const $40fc3da09ded601f$export$a2c25b3a57d1e1e1 = (portalId, portalAnnouncementModel, meta)=>({
        portalId: portalId,
        meta: meta,
        type: $40fc3da09ded601f$export$f1992600da6904c6,
        payload: portalAnnouncementModel
    });
const $40fc3da09ded601f$export$1cb4859b979a107e = (portalAnnouncementModel)=>({
        type: $40fc3da09ded601f$export$9181049110925f2a,
        payload: portalAnnouncementModel
    });
const $40fc3da09ded601f$export$a71bb12efca5ed02 = (error)=>({
        type: $40fc3da09ded601f$export$d5fa92c7d79f8706,
        payload: {
            error: error
        }
    });
const $40fc3da09ded601f$export$7f7bb35e246605cc = (portalAnnouncementModel)=>({
        type: $40fc3da09ded601f$export$c769ac1c1c5f67f5,
        payload: portalAnnouncementModel
    });
const $40fc3da09ded601f$export$82b91227c2617f7c = (portalId)=>({
        type: $40fc3da09ded601f$export$6a473efc246ca86a,
        payload: {
            portalId: portalId
        }
    });
const $40fc3da09ded601f$export$977a37e5820c7d60 = (mediaUploadToken, portalId)=>{
    return {
        type: $40fc3da09ded601f$export$eedf58a097d7a901,
        payload: {
            portalId: portalId,
            mediaApiUploadInformation: mediaUploadToken
        }
    };
};
const $40fc3da09ded601f$export$5531ab3802c122e6 = ()=>{
    return {
        type: $40fc3da09ded601f$var$FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_FAILURE
    };
};

});



parcelRegister("fLzw9", function(module, exports) {
$parcel$export(module.exports, "requestCreateEpic", () => $5864c0a58822f55c$export$a2b66173a86c1319);

var $b0T1M = parcelRequire("b0T1M");

var $bG6ob = parcelRequire("bG6ob");

var $elY4q = parcelRequire("elY4q");

var $d9tOd = parcelRequire("d9tOd");

var $k8GqG = parcelRequire("k8GqG");
parcelRequire("7Aj7n");
var $3SWp7 = parcelRequire("3SWp7");

var $cpFVz = parcelRequire("cpFVz");

var $5ZAyY = parcelRequire("5ZAyY");
parcelRequire("2fMSF");
var $liOqu = parcelRequire("liOqu");
const $5864c0a58822f55c$export$a2b66173a86c1319 = (action$)=>{
    return action$.ofType((0, $3SWp7.FETCH_REQUEST_CREATE_MODEL)).mergeMap((action)=>{
        const portalId = action.payload && action.payload.params && action.payload.params.portalId;
        const requestTypeId = action.payload && action.payload.params && action.payload.params.id;
        if ((0, $bG6ob.isJsmPortalRovoIntegrationEnabled)()) return (0, $elY4q.default)(action.payload).filter((response)=>!!response.reqCreate).mergeMap((response)=>{
            return $5864c0a58822f55c$var$hydrateUrlParamOverrides(response.reqCreate, portalId, requestTypeId).then(({ requestCreateResponse: requestCreateResponse, hydratedUrlParamOverrides: hydratedUrlParamOverrides })=>(0, $3SWp7.fetchRequestCreateSuccess)({
                    ...requestCreateResponse,
                    hydratedUrlParamOverrides: hydratedUrlParamOverrides,
                    portalId: portalId
                }));
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $b0T1M.Observable).of((0, $3SWp7.fetchRequestCreateFailure)(portalId, params.id, error));
        });
        return (0, $elY4q.default)(action.payload).filter((response)=>!!response.reqCreate).map((response)=>{
            return (0, $3SWp7.fetchRequestCreateSuccess)({
                ...response.reqCreate,
                portalId: portalId,
                hydratedUrlParamOverrides: {}
            });
        }).catch((error)=>{
            const params = action.payload.params;
            return (0, $b0T1M.Observable).of((0, $3SWp7.fetchRequestCreateFailure)(portalId, params.id, error));
        });
    });
};
/**
 * Builds a set of URL param overrides from the query parameters, and attempts to hydrate any overrides
 * for dynamic fields.
 *
 * This should never break the request create flow. If a dynamic field cannot be hydrated successfully (failed
 * API call), this function will proceed as though a URL override was not provided for that field.
 */ const $5864c0a58822f55c$var$hydrateUrlParamOverrides = async (requestCreateResponse, portalId, requestTypeId)=>{
    const fieldStates = (0, $cpFVz.toFieldStates)(requestCreateResponse.fields);
    const fieldStatesMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    const fieldValueOverrides = (0, $5ZAyY.parseFieldUrlParams)(fieldStates);
    const asyncFieldStatesWithDependencies = [];
    // This is a map used to store a representation of all current field values (including any hydrated ones)
    // so that it can be sent in the payload for CMDB queries. CMDB queries require this since AQL can filter
    // based on dependencies on other fields.
    const fieldValueMap = fieldStates.reduce((valueMap, field)=>{
        var _field$value;
        valueMap[field.id] = (_field$value = field.value) === null || _field$value === void 0 ? void 0 : _field$value.toString();
        return valueMap;
    }, {});
    // Mapping all dynamic pre-fill fields to promises so they can be hydrated in parallel.
    // Fields with dependencies need to be mapped last so we can populate the fielValueMap
    // as much as possible. The only known field with dependencies at the moment are CMDB fields.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const asyncFieldValuePromises = fieldStates.map((fieldState)=>{
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                // We don't resolve CMDB fields immediately because they may have dependencies that need to be resolved first
                asyncFieldStatesWithDependencies.push(fieldState);
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'userpicker':
                return $5864c0a58822f55c$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'reporter':
                return $5864c0a58822f55c$var$getUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'multiuserpicker':
                return $5864c0a58822f55c$var$getMultiUserPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            case 'organisationpicker':
                return $5864c0a58822f55c$var$getOrganisationPickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, undefined, requestCreateResponse.userOrganisations);
            case 'entitlementpicker':
                // Entitlement picker value is just passed through as a string
                if (fieldValueOverrides[fieldState.id]) return Promise.resolve({
                    fieldId: fieldState.id,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    value: fieldValueOverrides[fieldState.id]
                });
                return Promise.resolve({
                    fieldId: fieldState.id,
                    value: undefined
                });
            case 'multiservicepicker':
                return $5864c0a58822f55c$var$getMultiServicePickerLoader(fieldState, fieldValueOverrides, portalId, requestTypeId);
            // The following are static fields which have been converted into options. They need to be converted
            // to a different format for the fieldValueMap
            case 'labelpicker':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((defaultLabel)=>defaultLabel.value).toString();
                return undefined;
            case 'select':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].value;
                return undefined;
            case 'multiselect':
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].map((multiSelectOverride)=>multiSelectOverride.value).toString();
                return undefined;
            // All other static field types don't need to be hydrated or transformed, so we can store them
            // directly on fieldValueMap
            default:
                // TODO: Work out the format for cascading select data. This is currently also broken in the existing
                // CMDB field implementation so we're only being consistent with how cascading fields work in
                // Portal view.
                if (fieldValueOverrides[fieldState.id]) fieldValueMap[fieldState.id] = fieldValueOverrides[fieldState.id].toString();
                return undefined;
        }
    }).filter((loader)=>loader !== undefined);
    // When storing the hydrated results of dynamic fields, we need to keep asyncFieldValueOverrides in sync with
    // fieldValueMap. They need to store the same results, but in a different representation.
    const asyncFieldValueOverrides = await Promise.all(asyncFieldValuePromises).then((results)=>results.reduce((accumulator, result)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            accumulator[result.fieldId] = result.value;
            if (result.value === undefined) return accumulator;
            const fieldType = fieldStatesMap[result.fieldId].type;
            switch(fieldType){
                case 'userpicker':
                case 'reporter':
                    {
                        const userValue = result.value;
                        fieldValueMap[result.fieldId] = userValue.accountId;
                        break;
                    }
                case 'multiuserpicker':
                    {
                        const userValues = result.value;
                        fieldValueMap[result.fieldId] = userValues.map((user)=>user.accountId).toString();
                        break;
                    }
                case 'organisationpicker':
                    {
                        const organisationValue = result.value;
                        fieldValueMap[result.fieldId] = organisationValue.id.toString();
                        break;
                    }
                case 'multiservicepicker':
                    {
                        const multiServiceValues = result.value;
                        if (multiServiceValues && multiServiceValues.length > 0) fieldValueMap[result.fieldId] = multiServiceValues.toString();
                        break;
                    }
                default:
                    break;
            }
            return accumulator;
        }, {}));
    // A for loop is needed because CMDB fields can depend on other CMDB fields. Hence we need to hydrate them one
    // at a time and make subsequent calls with an updated fieldValueMap.
    for (const fieldState of asyncFieldStatesWithDependencies){
        const fieldId = fieldState.id;
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                {
                    const cmdbPickerValue = // oxlint-disable-next-line no-await-in-loop
                    (await $5864c0a58822f55c$var$getCmdbObjectLoader(fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap)).value;
                    asyncFieldValueOverrides[fieldId] = cmdbPickerValue;
                    if (cmdbPickerValue === undefined) break;
                    fieldValueMap[fieldId] = cmdbPickerValue.map((value)=>value.value).toString();
                    break;
                }
            default:
                break;
        }
    }
    const hydratedUrlParamOverrides = Object.fromEntries(Object.entries({
        ...fieldValueOverrides,
        ...asyncFieldValueOverrides
    }).filter(([, fieldValue])=>fieldValue !== undefined));
    return {
        requestCreateResponse: requestCreateResponse,
        hydratedUrlParamOverrides: hydratedUrlParamOverrides
    };
};
const $5864c0a58822f55c$var$getMultiUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiUserPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof multiUserPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Split comma-separated user queries and search for each
    const userQueries = multiUserPickerQuery.split(',').map((query)=>query.trim()).filter((query)=>query.length > 0);
    if (userQueries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const userSearchPromises = userQueries.map((query)=>(0, $k8GqG.searchUser)({
            portalId: portalId,
            query: query,
            fieldName: fieldId,
            fieldConfigId: fieldState.fieldConfigId
        }).toPromise().then((userSearchResponse)=>{
            if (userSearchResponse.length === 0) return undefined;
            // Return the first matching user for this query
            const userResult = userSearchResponse[0];
            return {
                accountId: userResult.accountId,
                email: userResult.emailAddress,
                iconUrl: userResult.avatar,
                label: userResult.displayName,
                value: userResult.accountId
            };
        }).catch(()=>undefined));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Promise.all(userSearchPromises).then((results)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const users = results.filter((user)=>user !== undefined);
        return {
            fieldId: fieldState.id,
            value: users.length > 0 ? users : undefined
        };
    });
};
const $5864c0a58822f55c$var$getUserPickerLoader = (fieldState, fieldValueOverrides, portalId)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const userPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof userPickerQuery !== 'string') return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return (0, $k8GqG.searchUser)({
        portalId: portalId,
        query: userPickerQuery,
        fieldName: fieldId,
        fieldConfigId: fieldState.fieldConfigId
    }).toPromise().then((userSearchResponse)=>{
        if (userSearchResponse.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstUserResult = userSearchResponse[0];
        return {
            fieldId: fieldState.id,
            value: {
                accountId: firstUserResult.accountId,
                email: firstUserResult.emailAddress,
                iconUrl: firstUserResult.avatar,
                label: firstUserResult.displayName,
                value: firstUserResult.accountId
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};
const $5864c0a58822f55c$var$getOrganisationPickerLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap, userOrganisations)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const organisationPickerQuery = fieldValueOverrides[fieldState.id];
    if (typeof organisationPickerQuery !== 'string' || !userOrganisations) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Try to match the URL parameter against user's organisations
    // First, try to match by ID (if the query is numeric)
    const queryAsId = parseInt(organisationPickerQuery, 10);
    if (!isNaN(queryAsId)) {
        const matchedOrgById = userOrganisations.find((org)=>org.id === queryAsId);
        if (matchedOrgById) return Promise.resolve({
            fieldId: fieldId,
            value: {
                id: matchedOrgById.id,
                name: matchedOrgById.name,
                domain: ''
            }
        });
    }
    // Try to match by name (case-insensitive)
    const matchedOrgByName = userOrganisations.find((org)=>org.name.toLowerCase() === organisationPickerQuery.toLowerCase());
    if (matchedOrgByName) return Promise.resolve({
        fieldId: fieldId,
        value: {
            id: matchedOrgByName.id,
            name: matchedOrgByName.name,
            domain: ''
        }
    });
    // No matching organisation found
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $5864c0a58822f55c$var$getMultiServicePickerLoader = async (fieldState, fieldValueOverrides)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const multiServicePickerQuery = fieldValueOverrides[fieldState.id];
    if (!multiServicePickerQuery) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    // Handle both single value and array of values
    let queries = [];
    if (Array.isArray(multiServicePickerQuery)) queries = multiServicePickerQuery;
    else if (typeof multiServicePickerQuery === 'string') queries = [
        multiServicePickerQuery
    ];
    if (queries.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    const matchedServiceIds = [];
    // For each query, try to find a matching service
    for (const query of queries)try {
        // Try to match by searching for the service name
        // oxlint-disable-next-line no-await-in-loop
        const result = await (0, $d9tOd.fetchServices)(query);
        // Find exact or partial match by name
        let matchedService = result.services.find((service)=>service.label.toLowerCase() === query.toLowerCase());
        // If no exact match, try to match by ID
        if (!matchedService) matchedService = result.services.find((service)=>service.value === query);
        if (matchedService) matchedServiceIds.push(matchedService.value);
    } catch (error) {
        // If fetch fails, continue to next query
        // oxlint-disable-next-line no-console
        console.warn(`Failed to fetch services for query: ${query}`, error);
    }
    if (matchedServiceIds.length === 0) return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
    return Promise.resolve({
        fieldId: fieldId,
        value: matchedServiceIds
    });
};
const $5864c0a58822f55c$var$getCmdbObjectLoader = (fieldState, fieldValueOverrides, portalId, requestTypeId, fieldValueMap)=>{
    const fieldId = fieldState.id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const cmdbPickerQuery = fieldValueOverrides[fieldState.id];
    const abortController = new AbortController();
    const { signal: signal } = abortController;
    if (typeof cmdbPickerQuery === 'string') return $5864c0a58822f55c$var$getSingleCmdbObjectLoader(signal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId).then((cmdbResult)=>cmdbResult.value === undefined ? {
            fieldId: cmdbResult.fieldId,
            value: undefined
        } : {
            fieldId: cmdbResult.fieldId,
            value: [
                cmdbResult.value
            ]
        });
    if (Array.isArray(cmdbPickerQuery)) {
        const cmdbObjectPickerQueries = cmdbPickerQuery.filter((query)=>typeof query === 'string');
        const cmdbObjectPickerPromises = cmdbObjectPickerQueries.map((query)=>$5864c0a58822f55c$var$getSingleCmdbObjectLoader(signal, query, fieldId, fieldValueMap, portalId, requestTypeId));
        return Promise.all(cmdbObjectPickerPromises).then((results)=>{
            const options = results.map((loaderResult)=>loaderResult.value).filter((option)=>option !== undefined);
            return {
                fieldId: fieldId,
                value: options.length === 0 ? undefined : options
            };
        });
    }
    return Promise.resolve({
        fieldId: fieldId,
        value: undefined
    });
};
const $5864c0a58822f55c$var$getSingleCmdbObjectLoader = (abortSignal, cmdbPickerQuery, fieldId, fieldValueMap, portalId, requestTypeId)=>{
    return (0, $liOqu.fetchCmdbObjectsWithSignal)(portalId, requestTypeId, fieldId, cmdbPickerQuery, Object.entries(fieldValueMap).filter(([_, fieldValue])=>!!fieldValue), abortSignal, 0).then((response)=>{
        const responseObjects = response.cmdbObjects;
        if (responseObjects.length === 0) return {
            fieldId: fieldId,
            value: undefined
        };
        const firstResult = responseObjects[0];
        return {
            fieldId: fieldId,
            value: {
                cmdbObject: firstResult,
                label: firstResult.label,
                value: firstResult.id
            }
        };
    }).catch(()=>({
            fieldId: fieldId,
            value: undefined
        }));
};

});
parcelRegister("d9tOd", function(module, exports) {
$parcel$export(module.exports, "fetchServices", () => $5f7760228187bb06$export$aaba171dbee0d63b);

var $lVFX8 = parcelRequire("lVFX8");

var $6mmHn = parcelRequire("6mmHn");

var $3wR8f = parcelRequire("3wR8f");
const $5f7760228187bb06$export$6ad2d0b3772389f4 = `
    query GetServices($cloudId: String!, $nameContains: String!, $first: Int!, $after: String) {
        devOpsServices(cloudId: $cloudId, filter: { nameContains: $nameContains }, first: $first, after: $after) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
`;
const $5f7760228187bb06$var$pageLimit = 20;
const $5f7760228187bb06$export$aaba171dbee0d63b = async (inputValue, after)=>(0, $lVFX8.post)(`${(0, $3wR8f.contextPath)}/gateway/api/graphql`, JSON.stringify({
        query: $5f7760228187bb06$export$6ad2d0b3772389f4,
        variables: {
            after: after,
            cloudId: (0, $6mmHn.getMeta)('tenant-id'),
            nameContains: inputValue,
            first: $5f7760228187bb06$var$pageLimit
        }
    }), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const res = response;
        const { data: { devOpsServices: { nodes: nodes, pageInfo: { hasNextPage: hasNextPage, endCursor: endCursor } } } } = res;
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            services: nodes.map(({ id: id, name: name })=>({
                    label: name,
                    value: id
                }))
        };
    }).toPromise();

});

parcelRegister("k8GqG", function(module, exports) {
$parcel$export(module.exports, "searchUser", () => $ca8214d0f0800e91$export$c6a60b910185c7f2);
$parcel$export(module.exports, "updateUserProfile", () => $ca8214d0f0800e91$export$c92c4ec7a2418617);
$parcel$export(module.exports, "changePassword", () => $ca8214d0f0800e91$export$99d837dc30eb1ef7);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $4i2V5 = parcelRequire("4i2V5");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");
const $ca8214d0f0800e91$export$c6a60b910185c7f2 = (userQuery, context = (0, $3wR8f.contextPath))=>{
    const query = {
        query: userQuery.query,
        fieldName: userQuery.fieldName,
        fieldConfigId: userQuery.fieldConfigId
    };
    const queryString = $4i2V5.stringify(query);
    const uri = `${context}/rest/servicedesk/1/customer/portal/${userQuery.portalId}/user-search?${queryString}`;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri).map((ajaxResponse)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return ajaxResponse.response;
    }).catch((e)=>{
        (0, $keOG0.trackError)('finduser.fetch.failed', {}, e);
        return (0, $b0T1M.Observable).throw(e);
    });
};
const $ca8214d0f0800e91$export$c92c4ec7a2418617 = (displayName, languageKey, timezone, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user`;
    const body = {
        displayName: displayName,
        languageKey: languageKey,
        timezone: timezone
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $b0T1M.Observable).throw(e);
    });
};
const $ca8214d0f0800e91$export$99d837dc30eb1ef7 = (currentPassword, newPassword, confirmNewPassword, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/user/password`;
    const body = {
        current: currentPassword,
        password: newPassword,
        confirm: confirmNewPassword
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $b0T1M.Observable).throw(e);
    });
};

});

parcelRegister("7Aj7n", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => (parcelRequire("3SWp7")).FETCH_REQUEST_CREATE_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => (parcelRequire("3SWp7")).FETCH_REQUEST_CREATE_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => (parcelRequire("3SWp7")).FETCH_REQUEST_CREATE_FAILURE);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => (parcelRequire("3SWp7")).RESET_REQUEST_CREATE_STATE);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => (parcelRequire("3SWp7")).PROFORMA_FORM_DIRTY);
$parcel$export(module.exports, "fetchRequestCreateAction", () => (parcelRequire("3SWp7")).fetchRequestCreateAction);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => (parcelRequire("3SWp7")).fetchRequestCreateSuccess);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => (parcelRequire("3SWp7")).fetchRequestCreateFailure);
$parcel$export(module.exports, "proformaFormDirtyAction", () => (parcelRequire("3SWp7")).proformaFormDirtyAction);
$parcel$export(module.exports, "resetRequestCreateStateAction", () => (parcelRequire("3SWp7")).resetRequestCreateStateAction);

var $3SWp7 = parcelRequire("3SWp7");

});
parcelRegister("3SWp7", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_MODEL", () => $b7ff1274f810a2b2$export$d4d8c69b4715e057);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_SUCCESS", () => $b7ff1274f810a2b2$export$372a19d33177b0bf);
$parcel$export(module.exports, "FETCH_REQUEST_CREATE_FAILURE", () => $b7ff1274f810a2b2$export$fee18c3aa48984ad);
$parcel$export(module.exports, "RESET_REQUEST_CREATE_STATE", () => $b7ff1274f810a2b2$export$8b4f4d20da5c4667);
$parcel$export(module.exports, "PROFORMA_FORM_DIRTY", () => $b7ff1274f810a2b2$export$b8bfd97914e38eff);
$parcel$export(module.exports, "fetchRequestCreateAction", () => $b7ff1274f810a2b2$export$466553923c00f94b);
$parcel$export(module.exports, "fetchRequestCreateSuccess", () => $b7ff1274f810a2b2$export$180824a15bbc742e);
$parcel$export(module.exports, "fetchRequestCreateFailure", () => $b7ff1274f810a2b2$export$fdc3fd637ad84f03);
$parcel$export(module.exports, "resetRequestCreateStateAction", () => $b7ff1274f810a2b2$export$4f2b3c2ed928ac62);
$parcel$export(module.exports, "proformaFormDirtyAction", () => $b7ff1274f810a2b2$export$b8e903edf5d19376);

var $dNzn5 = parcelRequire("dNzn5");
const $b7ff1274f810a2b2$export$d4d8c69b4715e057 = 'epic.model.FETCH_REQUEST_CREATE_MODEL';
const $b7ff1274f810a2b2$export$372a19d33177b0bf = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_SUCCESS';
const $b7ff1274f810a2b2$export$fee18c3aa48984ad = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_FAILURE';
const $b7ff1274f810a2b2$export$8b4f4d20da5c4667 = 'state.persisted.reqCreate.RESET_REQUEST_CREATE_STATE';
const $b7ff1274f810a2b2$export$67e1c6172c207525 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_ACTION';
const $b7ff1274f810a2b2$export$9d7c65c6842f6093 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_SUCCESS';
const $b7ff1274f810a2b2$export$751581aefd0ecd0 = 'state.persisted.reqCreate.FETCH_REQUEST_CREATE_UPLOAD_MEDIA_TOKEN_FAILURE';
const $b7ff1274f810a2b2$export$b8bfd97914e38eff = 'state.persisted.reqCreate.PROFORMA_FORM_DIRTY';
const $b7ff1274f810a2b2$export$466553923c00f94b = (0, $dNzn5.buildModelsActionCreator)($b7ff1274f810a2b2$export$d4d8c69b4715e057, 'reqCreate');
const $b7ff1274f810a2b2$export$180824a15bbc742e = (requestCreateResponse)=>({
        payload: requestCreateResponse,
        type: $b7ff1274f810a2b2$export$372a19d33177b0bf
    });
const $b7ff1274f810a2b2$export$fdc3fd637ad84f03 = (portalId, requestCreateId, error)=>({
        type: $b7ff1274f810a2b2$export$fee18c3aa48984ad,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId,
            error: error
        }
    });
const $b7ff1274f810a2b2$export$702e4cce91196841 = (portalId, requestCreateId)=>({
        type: $b7ff1274f810a2b2$export$67e1c6172c207525,
        payload: {
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    });
const $b7ff1274f810a2b2$export$a6d0fa922519029e = (mediaApiUploadInformation, portalId, requestCreateId)=>{
    return {
        type: $b7ff1274f810a2b2$export$9d7c65c6842f6093,
        payload: {
            mediaApiUploadInformation: mediaApiUploadInformation,
            portalId: portalId,
            requestCreateId: requestCreateId
        }
    };
};
const $b7ff1274f810a2b2$export$e9635fc96da2dc14 = ()=>{
    return {
        type: $b7ff1274f810a2b2$export$751581aefd0ecd0
    };
};
const $b7ff1274f810a2b2$export$4f2b3c2ed928ac62 = ()=>{
    return {
        type: $b7ff1274f810a2b2$export$8b4f4d20da5c4667,
        payload: {}
    };
};
const $b7ff1274f810a2b2$export$b8e903edf5d19376 = (payload)=>{
    return {
        payload: payload,
        type: $b7ff1274f810a2b2$export$b8bfd97914e38eff
    };
};

});


parcelRegister("cpFVz", function(module, exports) {
$parcel$export(module.exports, "toFieldStates", () => $e023802e78abc854$export$9144b5804cf423d6);

var $bG6ob = parcelRequire("bG6ob");

var $bqJEq = parcelRequire("bqJEq");
var $aS86U = parcelRequire("aS86U");

var $6bGmX = parcelRequire("6bGmX");

var $juTqc = parcelRequire("juTqc");
const $e023802e78abc854$var$MAX_CMDB_OBJECTS_PER_FIELD = 20;
const $e023802e78abc854$var$MAX_AFFECTED_SERVICES_PER_FIELD = 20;
const $e023802e78abc854$export$9144b5804cf423d6 = (fields)=>{
    return fields.map((field)=>{
        const fieldType = field.fieldType;
        switch(fieldType){
            case 'text':
                return $e023802e78abc854$var$toTextFieldState(field);
            case 'textarea':
                return $e023802e78abc854$var$toTextAreaState(field);
            case 'checkbox':
                return $e023802e78abc854$var$toCheckboxGroupState(field);
            case 'radio':
                return $e023802e78abc854$var$toRadioGroupState(field);
            case 'date':
            case 'duedate':
                return $e023802e78abc854$var$toDateState(field, fieldType);
            case 'datetime':
                return $e023802e78abc854$var$toDateTimeState(field);
            case 'attachment':
                return $e023802e78abc854$var$toAttachmentState(field);
            case 'reporter':
                return $e023802e78abc854$var$toReporterState(field);
            case 'userpicker':
                return $e023802e78abc854$var$toUserPickerState(field);
            case 'multiuserpicker':
                return $e023802e78abc854$var$toMultiUserPickerState(field);
            case 'organduserpicker':
                if ((0, $6bGmX.default).checkGate('jsm_portal_combined_share_with_field')) return $e023802e78abc854$var$toOrgAndUserPickerState(field);
                // When feature flag is off, treat as unknown (like before)
                return $e023802e78abc854$var$toUnknownState(field);
            case 'labelpicker':
                return $e023802e78abc854$var$toLabelPickerState(field);
            case 'select':
                return $e023802e78abc854$var$toSelectState(field);
            case 'multiselect':
                return $e023802e78abc854$var$toMultiSelectState(field);
            case 'organisationpicker':
                return $e023802e78abc854$var$toOrganisationState(field);
            case 'assetspicker':
                return $e023802e78abc854$var$toAssetsState(field);
            case 'multiservicepicker':
                return $e023802e78abc854$var$toMultiServicePickerState(field);
            case 'cascadingselect':
                return $e023802e78abc854$var$toCascadingSelect(field);
            case 'cmdbobjectpicker':
                return $e023802e78abc854$var$toCmdbObjectPickerState(field);
            case 'entitlementpicker':
                return $e023802e78abc854$var$toEntitlementPickerState(field);
            case 'forge':
                return $e023802e78abc854$var$toForgeFieldState(field);
            default:
                return $e023802e78abc854$var$toUnknownState(field);
        }
    });
};
/**
 * Parses defaultObjectAsJson and converts to an object if it can be parsed
 */ const $e023802e78abc854$var$getDefaultObjectAsJsonFromField = (field)=>{
    const { defaultObjectAsJson: defaultObjectAsJson } = field;
    let defaultObj;
    try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultObj = defaultObjectAsJson && JSON.parse(defaultObjectAsJson);
    } catch (e) {
    // Swallow the error here
    }
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return defaultObj;
};
// This extracts all the common field properties, normally the only difference between fields are
// type and value
const $e023802e78abc854$var$extractCommonFieldProperties = (field)=>({
        id: field.fieldId,
        displayed: field.displayed,
        label: field.label,
        required: field.required,
        description: field.descriptionHtml,
        ...(0, $bG6ob.isUiModificationsSupportEnabled)() ? {
            jiraFieldType: field.jiraFieldType
        } : {}
    });
const $e023802e78abc854$var$toTextFieldState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'text',
        value: defaultObject ? defaultObject : ''
    };
};
const $e023802e78abc854$var$toTextAreaState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, rendererType: rendererType, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    const emptyDefaultValue = (0, $bG6ob.isRichTextAreaEnabled)() && rendererType === 'atlassian-wiki-renderer' ? undefined : '';
    return {
        ...baseFieldProperties,
        rendererType: rendererType,
        fieldConfigId: fieldConfigId,
        type: 'textarea',
        value: defaultObject ? defaultObject : emptyDefaultValue
    };
};
const $e023802e78abc854$var$toCheckboxGroupState = (field)=>{
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const checkboxItems = fieldValues.map((fieldValue)=>({
            label: fieldValue.label,
            value: fieldValue.value,
            checked: fieldValue.selected
        }));
    const checkedItems = checkboxItems.filter((item)=>!!item.checked);
    const value = checkedItems.map((item)=>item.value);
    return {
        ...baseFieldProperties,
        value: value,
        type: 'checkbox',
        items: checkboxItems
    };
};
const $e023802e78abc854$var$toRadioGroupState = (field)=>{
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    const fieldValues = field.values || [];
    const radioGroupItems = fieldValues.map((item)=>({
            name: field.fieldId,
            label: item.label,
            value: item.value,
            selected: item.selected
        }));
    const selectedItem = radioGroupItems.find((item)=>!!item.selected);
    const value = selectedItem ? selectedItem.value : '';
    return {
        ...baseFieldProperties,
        value: value,
        items: radioGroupItems,
        type: 'radio'
    };
};
const $e023802e78abc854$var$IsoDateFormat = /^\d{4}-\d{2}-\d{2}$/;
const $e023802e78abc854$var$normalizeDateTimeFromJson = (field, isoFormat)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    let defaultDate = $e023802e78abc854$var$getDefaultObjectAsJsonFromField(field);
    if (!defaultDate || !(0, $aS86U.default)(new Date(defaultDate))) // This needs fallback to undefined so the datetime picker sets todays date
    // as the initial screen correctly, else it's 1970.
    return undefined;
    // Fix for the one-day-off issue with new Date()
    // Link: [DateTime Picker One Day Off Issue](https://hello.atlassian.net/wiki/x/zwTjxw)
    if (defaultDate.match($e023802e78abc854$var$IsoDateFormat)) defaultDate = defaultDate.replace(/-/g, '/');
    return (0, $bqJEq.default)(new Date(defaultDate), isoFormat);
};
const $e023802e78abc854$var$toDateState = (field, fieldType)=>{
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $e023802e78abc854$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd'),
        type: fieldType,
        value: $e023802e78abc854$var$normalizeDateTimeFromJson(field, 'yyyy-MM-dd')
    };
};
const $e023802e78abc854$var$toDateTimeState = (field)=>{
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        defaultDate: $e023802e78abc854$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm"),
        type: 'datetime',
        // We don't store timezone date, it's assumed the timezone will be the users timezone set in Jira.
        value: $e023802e78abc854$var$normalizeDateTimeFromJson(field, "yyyy-MM-dd'T'HH:mm")
    };
};
const $e023802e78abc854$var$toReporterState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'reporter',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultReporter: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $e023802e78abc854$var$toUserPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject, fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'userpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUser: defaultObject,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: defaultObject ? defaultObject.id : undefined,
        fieldConfigId: fieldConfigId ? String(fieldConfigId) : ''
    };
};
const $e023802e78abc854$var$toMultiUserPickerState = (field)=>{
    const defaultList = field.defaultList || [];
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'multiuserpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        defaultUsers: defaultList,
        fieldConfigId: field.fieldConfigId ? String(field.fieldConfigId) : '',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
        value: defaultList.map((u)=>u.id).join(',')
    };
};
const $e023802e78abc854$var$toOrgAndUserPickerState = (field)=>{
    var _field$portalFieldCon, _field$portalFieldCon2;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    const autoCompleteUrl = // portalFieldConfiguration is typed as any in the Field type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    field.autoCompleteUrl ?? ((_field$portalFieldCon = field.portalFieldConfiguration) === null || _field$portalFieldCon === void 0 ? void 0 : _field$portalFieldCon.autoCompleteUrl);
    // Extract shareWithOrgByDefault from portalFieldConfiguration, defaulting to true if not provided
    const shareWithOrgByDefault = ((_field$portalFieldCon2 = field.portalFieldConfiguration) === null || _field$portalFieldCon2 === void 0 ? void 0 : _field$portalFieldCon2.shareWithOrgByDefault) ?? true;
    return {
        ...baseFieldProperties,
        autoCompleteUrl: autoCompleteUrl,
        shareWithOrgByDefault: shareWithOrgByDefault,
        type: 'organduserpicker',
        fieldConfigId: field.fieldConfigId ? String(field.fieldConfigId) : '',
        // defaultObject is typed as any in the Field type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        value: field.defaultObject ? field.defaultObject.id : undefined
    };
};
const $e023802e78abc854$var$toSelectState = (field)=>{
    const selectedValue = field.values ? field.values.find((v)=>v.selected) : undefined;
    const value = selectedValue && selectedValue.value;
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        value: value,
        type: 'select',
        options: field.values || [],
        defaultValue: selectedValue
    };
};
const $e023802e78abc854$var$toMultiSelectState = (field)=>{
    const selectedValues = field.values ? field.values.filter((v)=>v.selected) : [];
    const values = selectedValues.map((v)=>v.value);
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        type: 'multiselect',
        options: field.values || [],
        defaultValue: selectedValues,
        value: values
    };
};
const $e023802e78abc854$var$toLabelPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const value = field.defaultList || [];
    /**
   * The field id takes the form of customfield_xxxx where xxxx is the custom field id.
   *
   * The field id can also be "label" if it is the system label field.
   * In the case where the field is the system field we will consider the custom field id to be undefiend
   */ const fieldIdTokens = (field.fieldId || '').toLowerCase().split('customfield_');
    const customFieldId = fieldIdTokens.length > 1 ? fieldIdTokens[1] : undefined;
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        value: value,
        customFieldId: customFieldId,
        type: 'labelpicker',
        defaultLabels: value.map((labelStr)=>({
                label: labelStr,
                value: labelStr
            }))
    };
};
const $e023802e78abc854$var$toCascadingSelect = (field)=>{
    const selectedGroup = field.values && field.values.find((v)=>v.selected);
    const selectedValue = selectedGroup && selectedGroup.children.find((v)=>v.selected);
    const value = selectedGroup && {
        primaryValue: selectedGroup.value,
        children: selectedValue && selectedValue.value
    };
    /**
   * UI Modifications requires defaultValue because it includes both labels and values for parent and child options,
   * whereas the value field only contains the values. This enables the getValueTransformer to properly
   * reconstruct the complete option data structure with value and labels.
   */ const defaultValue = selectedGroup ? {
        primaryValue: {
            label: selectedGroup.label,
            value: selectedGroup.value
        },
        children: selectedValue ? {
            label: selectedValue.label,
            value: selectedValue.value
        } : undefined
    } : undefined;
    const options = field.values ? field.values.map((v)=>({
            label: v.label,
            value: v.value,
            children: v.children
        })) : [];
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        options: options,
        value: value,
        type: 'cascadingselect',
        ...(0, $bG6ob.cascadingSelectDefaultValueSupportEnabled)() ? {
            defaultValue: defaultValue
        } : {}
    };
};
const $e023802e78abc854$var$toOrganisationState = (field)=>{
    var _field$portalFieldCon3;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { fieldConfigId: fieldConfigId, defaultObject: defaultObject } = field;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const shareWithOrgByDefault = ((_field$portalFieldCon3 = field.portalFieldConfiguration) === null || _field$portalFieldCon3 === void 0 ? void 0 : _field$portalFieldCon3.shareWithOrgByDefault) ?? true;
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        fieldConfigId: fieldConfigId,
        shareWithOrgByDefault: // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        shareWithOrgByDefault,
        type: 'organisationpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
};
const $e023802e78abc854$var$toAssetsState = (field)=>{
    const { fieldConfigId: fieldConfigId } = field;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        fieldConfigId: fieldConfigId,
        type: 'assetspicker'
    };
};
const $e023802e78abc854$var$toMultiServicePickerState = (field)=>{
    var _field$portalFieldCon4;
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        type: 'multiservicepicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon4 = field.portalFieldConfiguration) === null || _field$portalFieldCon4 === void 0 ? void 0 : _field$portalFieldCon4.limit) ?? $e023802e78abc854$var$MAX_AFFECTED_SERVICES_PER_FIELD
    };
};
const $e023802e78abc854$var$toAttachmentState = (field)=>{
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        value: [],
        type: 'attachment'
    };
};
const $e023802e78abc854$var$toCmdbObjectPickerState = (field)=>{
    var _field$portalFieldCon5, _field$portalFieldCon6, _field$portalFieldCon7;
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        hasValidConfig: Boolean(field.portalFieldConfiguration),
        type: 'cmdbobjectpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        isMulti: field.portalFieldConfiguration ? field.portalFieldConfiguration.isMulti : false,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        filterAttributes: field.portalFieldConfiguration ? field.portalFieldConfiguration.filterAttributes : [],
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        limit: ((_field$portalFieldCon5 = field.portalFieldConfiguration) === null || _field$portalFieldCon5 === void 0 ? void 0 : _field$portalFieldCon5.limit) ?? $e023802e78abc854$var$MAX_CMDB_OBJECTS_PER_FIELD,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        placeholderKeys: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon6 = field.portalFieldConfiguration) === null || _field$portalFieldCon6 === void 0 ? void 0 : _field$portalFieldCon6.placeholderKeys) ?? undefined,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        populateDefaultValue: // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ((_field$portalFieldCon7 = field.portalFieldConfiguration) === null || _field$portalFieldCon7 === void 0 ? void 0 : _field$portalFieldCon7.populateDefaultValue) ?? false
    };
};
const $e023802e78abc854$var$toEntitlementPickerState = (field)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { defaultObject: defaultObject } = field;
    if ((0, $bG6ob.isJsmPortalRovoIntegrationEnabled)()) return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker',
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        value: defaultObject
    };
    return {
        ...$e023802e78abc854$var$extractCommonFieldProperties(field),
        type: 'entitlementpicker'
    };
};
const $e023802e78abc854$var$toForgeFieldState = (field)=>{
    var _field$forge, _forgeExtension$prope, _forgeExtension$prope2;
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    const forgeExtension = (_field$forge = field.forge) === null || _field$forge === void 0 ? void 0 : _field$forge.extension;
    const fieldType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope = forgeExtension.properties) === null || _forgeExtension$prope === void 0 ? void 0 : _forgeExtension$prope.type;
    const collectionType = forgeExtension === null || forgeExtension === void 0 || (_forgeExtension$prope2 = forgeExtension.properties) === null || _forgeExtension$prope2 === void 0 ? void 0 : _forgeExtension$prope2.collection;
    // defaultObject is typed as any in the Field type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const defaultObject = field.defaultObject;
    const defaultList = field.defaultList || [];
    const { value: value, additionalProps: additionalProps } = (0, $juTqc.forgeFieldParamsParser)(fieldType, collectionType, defaultObject, defaultList);
    if ((0, $bG6ob.isForgeCustomFieldsOnPortalViewEnabled)()) return {
        value: value,
        ...baseFieldProperties,
        ...additionalProps,
        type: 'forge',
        extension: forgeExtension
    };
    return {
        ...baseFieldProperties,
        type: 'forge',
        jiraFieldType: field.jiraFieldType // TODO: remove as with ditto_uim_-_jsm_support_main FF cleanup
    };
};
const $e023802e78abc854$var$toUnknownState = (field)=>{
    const baseFieldProperties = $e023802e78abc854$var$extractCommonFieldProperties(field);
    return {
        ...baseFieldProperties,
        type: 'unknown'
    };
};

});
parcelRegister("juTqc", function(module, exports) {
$parcel$export(module.exports, "forgeFieldParamsParser", () => $7f43c5e8927ecbe9$export$ba975bd6e357689d);

var $bqJEq = parcelRequire("bqJEq");
const $7f43c5e8927ecbe9$export$ba975bd6e357689d = (fieldType, collectionType, defaultObject, defaultList)=>{
    let value;
    let additionalProps = {};
    switch(fieldType){
        case 'string':
            if (collectionType === 'list') {
                value = defaultList;
                additionalProps = {
                    // String list is rendered as label picker
                    defaultLabels: value.map((labelStr)=>({
                            label: labelStr,
                            value: labelStr
                        }))
                };
            } else value = defaultObject;
            break;
        case 'number':
            value = defaultObject;
            break;
        case 'date':
            value = defaultObject ? (0, $bqJEq.default)(new Date(defaultObject), 'yyyy-MM-dd') : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'datetime':
            value = defaultObject ? (0, $bqJEq.default)(new Date(defaultObject), "yyyy-MM-dd'T'HH:mm") : undefined;
            additionalProps = {
                defaultDate: value
            };
            break;
        case 'user':
            if (collectionType === 'list') {
                value = defaultList.map((u)=>u.id).join(',');
                additionalProps = {
                    defaultUsers: defaultList
                };
            } else {
                value = defaultList && defaultList.length > 0 ? defaultList[0].id : undefined;
                additionalProps = {
                    defaultUser: defaultList[0]
                };
            }
            break;
        default:
            value = null;
            break;
    }
    return {
        value: value,
        additionalProps: additionalProps
    };
};

});


parcelRegister("5ZAyY", function(module, exports) {
$parcel$export(module.exports, "parseFieldUrlParams", () => $9d3b10fe721c7e47$export$23f65b7a085343aa);

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $4i2V5 = parcelRequire("4i2V5");

var $bpwJt = parcelRequire("bpwJt");

var $kXlzl = parcelRequire("kXlzl");

var $3TeDY = parcelRequire("3TeDY");
const $9d3b10fe721c7e47$var$CASCADE_SELECT_ID_SUFFIX = ':1';
function $9d3b10fe721c7e47$export$23f65b7a085343aa(fields) {
    if (!fields || fields.length === 0) return {};
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const urlParams = (0, $4i2V5.parse)((0, $3TeDY.search)());
    if (!urlParams) return {};
    return fields.reduce((values, field)=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        const urlParamValue = urlParams[field.id];
        if (urlParamValue !== undefined) {
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            const cascadeNestedSelectUrlParamValue = urlParams[`${field.id}${$9d3b10fe721c7e47$var$CASCADE_SELECT_ID_SUFFIX}`];
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            values[field.id] = $9d3b10fe721c7e47$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue);
            if (cascadeNestedSelectUrlParamValue) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            values[`${field.id}${$9d3b10fe721c7e47$var$CASCADE_SELECT_ID_SUFFIX}`] = cascadeNestedSelectUrlParamValue;
        }
        return values;
    }, {});
}
function $9d3b10fe721c7e47$var$parseUrlParamValue(field, urlParamValue, cascadeNestedSelectUrlParamValue) {
    $9d3b10fe721c7e47$var$firePrePopAnalyticsEvent(field);
    switch(field.type){
        case 'labelpicker':
            return $9d3b10fe721c7e47$var$parseLabelsUrlParam(urlParamValue);
        case 'checkbox':
            {
                const checkboxGroup = field;
                return $9d3b10fe721c7e47$var$parseCheckboxUrlParam(urlParamValue, checkboxGroup.items);
            }
        case 'select':
            {
                const select = field;
                return $9d3b10fe721c7e47$var$parseSelectUrlParam(urlParamValue, select.options);
            }
        case 'multiselect':
            {
                const multiSelect = field;
                return $9d3b10fe721c7e47$var$parseMultiSelectUrlParam(urlParamValue, multiSelect.options);
            }
        case 'cascadingselect':
            {
                const cascadingSelectState = field;
                return $9d3b10fe721c7e47$var$parseCascadingSelectUrlParam(cascadingSelectState.options, urlParamValue, cascadeNestedSelectUrlParamValue);
            }
        case 'textarea':
            if ((0, $bG6ob.isRichTextAreaEnabled)() && field.rendererType === 'atlassian-wiki-renderer') return $9d3b10fe721c7e47$var$parseRichTextAreaUrlParam(urlParamValue);
            return urlParamValue;
        case 'multiuserpicker':
            return urlParamValue;
        default:
            // Dynamic fields are handled directly in hydrateUrlParamOverrides() since async calls need to be made
            return urlParamValue;
    }
}
function $9d3b10fe721c7e47$var$firePrePopAnalyticsEvent(field) {
    const actionSubjectId = field.id.startsWith('customfield') ? 'customfield' : field.id;
    (0, $kXlzl.operationalEvent)({
        actionSubjectId: actionSubjectId,
        action: 'prePopulated',
        actionSubject: 'field',
        source: (0, $748yq.ScreenName).REQUEST_CREATE,
        attributes: {
            fieldType: field.type
        }
    });
}
function $9d3b10fe721c7e47$var$parseLabelsUrlParam(labels) {
    if ($9d3b10fe721c7e47$var$isEmptyStringOrArray(labels)) return [];
    if (typeof labels === 'string') {
        const singleLabel = labels;
        return [
            {
                label: singleLabel,
                value: singleLabel
            }
        ];
    }
    const multipleLabels = labels;
    return multipleLabels.map((toConvert)=>({
            label: toConvert,
            value: toConvert
        }));
}
const $9d3b10fe721c7e47$var$isEmptyStringOrArray = (value)=>value.length === 0;
const $9d3b10fe721c7e47$var$parseSelectUrlParam = (urlParam, options)=>options.find((option)=>option.value === urlParam);
function $9d3b10fe721c7e47$var$parseCheckboxUrlParam(checkedUrlParam, items) {
    if ($9d3b10fe721c7e47$var$isEmptyStringOrArray(checkedUrlParam)) return [];
    if (typeof checkedUrlParam === 'string') {
        const checkedBoxValue = checkedUrlParam;
        const checkedBox = items.find((item)=>item.value === checkedBoxValue);
        return checkedBox ? [
            checkedBox.value
        ] : [];
    }
    const checkedBoxValues = checkedUrlParam;
    return items.filter((item)=>checkedBoxValues.includes(item.value)).map((item)=>item.value);
}
function $9d3b10fe721c7e47$var$parseMultiSelectUrlParam(selected, options) {
    if ($9d3b10fe721c7e47$var$isEmptyStringOrArray(selected)) return [];
    if (typeof selected === 'string') {
        const selection = selected;
        return options.filter((option)=>option.value === selection);
    }
    const selections = selected;
    return options.filter((option)=>selections.includes(option.value));
}
function $9d3b10fe721c7e47$var$parseCascadingSelectUrlParam(options, parentUrlParam, childUrlParam) {
    const parentOption = options.find((option)=>option.value === parentUrlParam);
    if (!parentOption) return null;
    const childOption = parentOption.children.find((option)=>option.value === childUrlParam);
    return {
        primaryValue: parentOption.value,
        children: childOption && childOption.value
    };
}
const $9d3b10fe721c7e47$var$parseRichTextAreaUrlParam = (urlParam)=>JSON.stringify((0, $bpwJt.plainTextToAdfParagraph)(urlParam));

});
parcelRegister("bpwJt", function(module, exports) {
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $f2ec19f5731615bb$export$cf4bde415465976c);
$parcel$export(module.exports, "parseAdf", () => $f2ec19f5731615bb$export$5659c60045974de9);
$parcel$export(module.exports, "plainTextToAdfParagraph", () => $f2ec19f5731615bb$export$a5c4f0d0658bc780);
$parcel$export(module.exports, "getAccountIdsFromComment", () => $f2ec19f5731615bb$export$f9672ae84945eb8e);

var $jFbx9 = parcelRequire("jFbx9");

var $c5t3p = parcelRequire("c5t3p");

var $Y85G3 = parcelRequire("Y85G3");
const $f2ec19f5731615bb$var$hardBreakNodeType = 'hardBreak';
const $f2ec19f5731615bb$export$cf4bde415465976c = (adf)=>{
    if (adf && adf.content) return adf.content.every((content)=>{
        return $f2ec19f5731615bb$var$isOnlyWhitespaceParagraphNode(content);
    });
    return false;
};
const $f2ec19f5731615bb$var$isOnlyWhitespaceParagraphNode = (content)=>{
    if (content.type === 'paragraph') return content.content === undefined || content.content.length === 0 || content.content.every((innerContent)=>$f2ec19f5731615bb$var$isOnlyWhitespaceTextNode(innerContent) || $f2ec19f5731615bb$var$isHardBreakNode(innerContent));
    return false;
};
const $f2ec19f5731615bb$var$isOnlyWhitespaceTextNode = (content)=>{
    if ((content === null || content === void 0 ? void 0 : content.type) === 'text') return content.text === undefined || content.text.match(/^\s*$/) !== null;
    return false;
};
const $f2ec19f5731615bb$var$isHardBreakNode = (content)=>{
    return (content === null || content === void 0 ? void 0 : content.type) === $f2ec19f5731615bb$var$hardBreakNodeType;
};
const $f2ec19f5731615bb$export$5659c60045974de9 = (content)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const node = JSON.parse(content);
    /*
  With Editor and Media upgrade, we have a strongly typed renderer, which is causing some types
  to break. This (typecasting to DocNode['content']) should be fixed in a follow-up.
  */ node.content = $f2ec19f5731615bb$var$removeSuffixFromNodes(node.content);
    return node;
};
const $f2ec19f5731615bb$var$removeSuffixFromNodes = (nodes)=>{
    if (!nodes) return nodes;
    return nodes.map((node)=>{
        if (!node) return node;
        if (node.type === 'inlineCard' && node.attrs) node.attrs = $f2ec19f5731615bb$var$updateInlineCardAttributes(node.attrs);
        if (node.content) node.content = $f2ec19f5731615bb$var$removeSuffixFromNodes(node.content);
        return node;
    });
};
const $f2ec19f5731615bb$export$a5c4f0d0658bc780 = (plainText)=>({
        version: 1,
        // Using static version number as this doesn't seem to change
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: plainText
                    }
                ]
            }
        ]
    });
const $f2ec19f5731615bb$var$removedIcftFromUrlCache = {};
const $f2ec19f5731615bb$var$updateInlineCardAttributes = (attributes)=>{
    if (attributes.url && (0, $Y85G3.parseIssueKeyFromUrl)(attributes.url)) {
        if (!$f2ec19f5731615bb$var$removedIcftFromUrlCache[attributes.url]) {
            (0, $c5t3p.trackLegacyEvent)('servicedesk.customerview.util.adf.remove.icft.suffix', {});
            $f2ec19f5731615bb$var$removedIcftFromUrlCache[attributes.url] = true;
        }
        attributes.url = $f2ec19f5731615bb$var$removeICFTURLSuffix(attributes.url);
    }
    return attributes;
};
const $f2ec19f5731615bb$var$removeICFTURLSuffix = (content)=>{
    return content.replace(/#icft=[A-Z][A-Z0-9_]+-\d+/gi, '');
};
const $f2ec19f5731615bb$export$f9672ae84945eb8e = (adfText)=>{
    const accountIds = new Map();
    (0, $jFbx9.traverse)(adfText, {
        mention: (node)=>{
            var _node$attrs, _node$attrs2;
            /* text can be of form @user_name or user_name */ // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            let displayName = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.text;
            if (displayName) displayName = displayName.charAt(0) === '@' ? displayName.substring(1) : displayName;
            accountIds.set((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.id, displayName);
        }
    });
    return accountIds;
};

});
parcelRegister("jFbx9", function(module, exports) {
$parcel$export(module.exports, "traverse", () => $6205cbfd0a129372$export$df3f009e3d155b20);
function $6205cbfd0a129372$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $6205cbfd0a129372$export$df3f009e3d155b20(adf, visitors) {
    if (!$6205cbfd0a129372$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $6205cbfd0a129372$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $6205cbfd0a129372$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $6205cbfd0a129372$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});



parcelRegister("2fMSF", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => (parcelRequire("liOqu")).fetchCmdbObjectsWithSignal);

var $liOqu = parcelRequire("liOqu");

});
parcelRegister("liOqu", function(module, exports) {
$parcel$export(module.exports, "fetchCmdbObjectsWithSignal", () => $f1e3030099e340b7$export$d4d0e07838855f63);

var $hZWMk = parcelRequire("hZWMk");

var $3wR8f = parcelRequire("3wR8f");
const $f1e3030099e340b7$export$d4d0e07838855f63 = (portalId, requestTypeId, fieldId, inputValue, fieldValueMap, signal, start)=>{
    const fieldValueMapObject = fieldValueMap.reduce((accumulator, field)=>{
        if (field[0] !== 'attachment') accumulator[field[0]] = field[1];
        return accumulator;
    }, {});
    const body = {
        query: inputValue,
        fieldValueMap: fieldValueMapObject
    };
    return (0, $hZWMk.fetchJson)(`${(0, $3wR8f.contextPath)}/rest/servicedesk/cmdb/1/customer/portal/${portalId}/request/${requestTypeId}/field/${fieldId}/autocomplete?start=${start}`, {
        signal: signal,
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(({ results: results, total: total, hasNextPage: hasNextPage })=>({
            total: total,
            hasNextPage: hasNextPage,
            cmdbObjects: results
        }));
};

});



parcelRegister("5xEoT", function(module, exports) {
$parcel$export(module.exports, "requestDetailsEpic", () => $dfecc2f89820882d$export$211ba11a17095531);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");
const $dfecc2f89820882d$export$211ba11a17095531 = (action$)=>{
    return action$.ofType((0, $gEejF.FETCH_REQUEST_DETAILS_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload, {
            type: 'secondary',
            disableBatching: true
        }).filter((response)=>!!response.reqDetails && !!response.reqDetails.issue).map((response)=>{
            return (0, $gEejF.fetchRequestDetailsSuccess)(response.reqDetails);
        }).catch((error)=>{
            const key = action.payload.params.key;
            return (0, $b0T1M.Observable).of((0, $gEejF.fetchRequestDetailsFailure)(key, error));
        }));
};

});
parcelRegister("cKnoq", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => (parcelRequire("gEejF")).CHANGE_SUBSCRIPTION);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => (parcelRequire("gEejF")).CHANGE_SUBSCRIPTION_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT", () => (parcelRequire("gEejF")).CREATE_COMMENT);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => (parcelRequire("gEejF")).CREATE_COMMENT_SUCCESS);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => (parcelRequire("gEejF")).CREATE_COMMENT_FAILURE);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => (parcelRequire("gEejF")).GET_MEDIA_READ_CREDENTIALS);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => (parcelRequire("gEejF")).GET_MEDIA_READ_CREDENTIALS_SUCCESS);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => (parcelRequire("gEejF")).DECIDE_APPROVAL);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => (parcelRequire("gEejF")).DECIDE_APPROVAL_FAILURE);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => (parcelRequire("gEejF")).FETCH_REQUEST_DETAILS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => (parcelRequire("gEejF")).FETCH_REQUEST_DETAILS_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => (parcelRequire("gEejF")).FETCH_REQUEST_DETAILS_FAILURE);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => (parcelRequire("gEejF")).REMOVE_ORGANISATION);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => (parcelRequire("gEejF")).REMOVE_ORGANISATION_SUCCESS);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => (parcelRequire("gEejF")).ADD_PARTICIPANTS_SUCCESS);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => (parcelRequire("gEejF")).REMOVE_PARTICIPANT);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => (parcelRequire("gEejF")).REMOVE_PARTICIPANT_SUCCESS);
$parcel$export(module.exports, "SHARE_REQUEST", () => (parcelRequire("gEejF")).SHARE_REQUEST);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => (parcelRequire("gEejF")).SHOW_TRANSITION_DIALOG);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => (parcelRequire("gEejF")).HIDE_TRANSITION_DIALOG);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => (parcelRequire("gEejF")).TRANSITION_REQUEST);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => (parcelRequire("gEejF")).TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => (parcelRequire("gEejF")).CLEAR_TRANSITION_REQUEST_FAILURE);
$parcel$export(module.exports, "changeSubscription", () => (parcelRequire("gEejF")).changeSubscription);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => (parcelRequire("gEejF")).changeSubscriptionSuccess);
$parcel$export(module.exports, "createCommentFailure", () => (parcelRequire("gEejF")).createCommentFailure);
$parcel$export(module.exports, "createComment", () => (parcelRequire("gEejF")).createComment);
$parcel$export(module.exports, "createCommentSuccess", () => (parcelRequire("gEejF")).createCommentSuccess);
$parcel$export(module.exports, "getReadCredentials", () => (parcelRequire("gEejF")).getReadCredentials);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => (parcelRequire("gEejF")).getReadCredentialsSuccess);
$parcel$export(module.exports, "getReadCredentialsFailure", () => (parcelRequire("gEejF")).getReadCredentialsFailure);
$parcel$export(module.exports, "decideApproval", () => (parcelRequire("gEejF")).decideApproval);
$parcel$export(module.exports, "decideApprovalFailure", () => (parcelRequire("gEejF")).decideApprovalFailure);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => (parcelRequire("gEejF")).fetchRequestDetailsModel);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => (parcelRequire("gEejF")).fetchRequestDetailsSuccess);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => (parcelRequire("gEejF")).fetchRequestDetailsFailure);
$parcel$export(module.exports, "removeOrganisation", () => (parcelRequire("gEejF")).removeOrganisation);
$parcel$export(module.exports, "removeOrganisationSuccess", () => (parcelRequire("gEejF")).removeOrganisationSuccess);
$parcel$export(module.exports, "addParticipantsSuccess", () => (parcelRequire("gEejF")).addParticipantsSuccess);
$parcel$export(module.exports, "removeParticipant", () => (parcelRequire("gEejF")).removeParticipant);
$parcel$export(module.exports, "removeParticipantSuccess", () => (parcelRequire("gEejF")).removeParticipantSuccess);
$parcel$export(module.exports, "shareRequest", () => (parcelRequire("gEejF")).shareRequest);
$parcel$export(module.exports, "showTransitionDialog", () => (parcelRequire("gEejF")).showTransitionDialog);
$parcel$export(module.exports, "hideTransitionDialog", () => (parcelRequire("gEejF")).hideTransitionDialog);
$parcel$export(module.exports, "transitionRequest", () => (parcelRequire("gEejF")).transitionRequest);
$parcel$export(module.exports, "transitionRequestFailure", () => (parcelRequire("gEejF")).transitionRequestFailure);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => (parcelRequire("gEejF")).clearTransitionRequestFailure);

var $gEejF = parcelRequire("gEejF");

});
parcelRegister("gEejF", function(module, exports) {
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION", () => $2eb07ee6692649ac$export$c82a76c42259b55e);
$parcel$export(module.exports, "CHANGE_SUBSCRIPTION_SUCCESS", () => $2eb07ee6692649ac$export$aed2f68a180d5132);
$parcel$export(module.exports, "CREATE_COMMENT", () => $2eb07ee6692649ac$export$b2aae42fb0a19db3);
$parcel$export(module.exports, "CREATE_COMMENT_SUCCESS", () => $2eb07ee6692649ac$export$5e5d6c973a5c4e53);
$parcel$export(module.exports, "CREATE_COMMENT_FAILURE", () => $2eb07ee6692649ac$export$423d075659092bbe);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS", () => $2eb07ee6692649ac$export$6e57eb44a84791a7);
$parcel$export(module.exports, "GET_MEDIA_READ_CREDENTIALS_SUCCESS", () => $2eb07ee6692649ac$export$710f501aa8462ae0);
$parcel$export(module.exports, "DECIDE_APPROVAL", () => $2eb07ee6692649ac$export$17b4c1a883566436);
$parcel$export(module.exports, "DECIDE_APPROVAL_FAILURE", () => $2eb07ee6692649ac$export$32a89de369c73827);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_MODEL", () => $2eb07ee6692649ac$export$c6977262f615318f);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_SUCCESS", () => $2eb07ee6692649ac$export$16e2b1f014063eb8);
$parcel$export(module.exports, "FETCH_REQUEST_DETAILS_FAILURE", () => $2eb07ee6692649ac$export$b793c4f327f63a76);
$parcel$export(module.exports, "REMOVE_ORGANISATION", () => $2eb07ee6692649ac$export$8fb5a515e01e48c5);
$parcel$export(module.exports, "REMOVE_ORGANISATION_SUCCESS", () => $2eb07ee6692649ac$export$74436d62ceb0e590);
$parcel$export(module.exports, "ADD_PARTICIPANTS_SUCCESS", () => $2eb07ee6692649ac$export$85378bb183dca844);
$parcel$export(module.exports, "REMOVE_PARTICIPANT", () => $2eb07ee6692649ac$export$fbce83858fb867fb);
$parcel$export(module.exports, "REMOVE_PARTICIPANT_SUCCESS", () => $2eb07ee6692649ac$export$dfb1c2f386aee705);
$parcel$export(module.exports, "SHARE_REQUEST", () => $2eb07ee6692649ac$export$5cf2f51c187a7d5f);
$parcel$export(module.exports, "SHOW_TRANSITION_DIALOG", () => $2eb07ee6692649ac$export$7fb10a1857e0e02a);
$parcel$export(module.exports, "HIDE_TRANSITION_DIALOG", () => $2eb07ee6692649ac$export$3a407eae5b6f60b);
$parcel$export(module.exports, "TRANSITION_REQUEST", () => $2eb07ee6692649ac$export$a966f1a0c1a920e7);
$parcel$export(module.exports, "TRANSITION_REQUEST_FAILURE", () => $2eb07ee6692649ac$export$fd4af480b5082555);
$parcel$export(module.exports, "CLEAR_TRANSITION_REQUEST_FAILURE", () => $2eb07ee6692649ac$export$9e405a82dd6dd4e1);
$parcel$export(module.exports, "fetchRequestDetailsModel", () => $2eb07ee6692649ac$export$5d6a7943e794d360);
$parcel$export(module.exports, "fetchRequestDetailsSuccess", () => $2eb07ee6692649ac$export$f9b1366a7a60a8a);
$parcel$export(module.exports, "addParticipantsSuccess", () => $2eb07ee6692649ac$export$524d371754c76f3c);
$parcel$export(module.exports, "fetchRequestDetailsFailure", () => $2eb07ee6692649ac$export$5ef0f7883c2144b6);
$parcel$export(module.exports, "changeSubscription", () => $2eb07ee6692649ac$export$99effa43b85cc1d1);
$parcel$export(module.exports, "changeSubscriptionSuccess", () => $2eb07ee6692649ac$export$e91b59ae91b1c17d);
$parcel$export(module.exports, "decideApprovalFailure", () => $2eb07ee6692649ac$export$8ab1e7354f0ec72f);
$parcel$export(module.exports, "decideApproval", () => $2eb07ee6692649ac$export$5fffe31f8df4a90b);
$parcel$export(module.exports, "removeOrganisation", () => $2eb07ee6692649ac$export$66d4278db03b2954);
$parcel$export(module.exports, "removeOrganisationSuccess", () => $2eb07ee6692649ac$export$f8de82921adab699);
$parcel$export(module.exports, "removeParticipant", () => $2eb07ee6692649ac$export$971a7382b074b466);
$parcel$export(module.exports, "removeParticipantSuccess", () => $2eb07ee6692649ac$export$9be1ee8fbc799e1c);
$parcel$export(module.exports, "shareRequest", () => $2eb07ee6692649ac$export$904a7ffbfa202969);
$parcel$export(module.exports, "showTransitionDialog", () => $2eb07ee6692649ac$export$375ec276b5b0476c);
$parcel$export(module.exports, "hideTransitionDialog", () => $2eb07ee6692649ac$export$69175c2908a46e20);
$parcel$export(module.exports, "transitionRequest", () => $2eb07ee6692649ac$export$e72771314c1d54);
$parcel$export(module.exports, "transitionRequestFailure", () => $2eb07ee6692649ac$export$18f56c137e75378a);
$parcel$export(module.exports, "clearTransitionRequestFailure", () => $2eb07ee6692649ac$export$20cf1fa346e88708);
$parcel$export(module.exports, "createComment", () => $2eb07ee6692649ac$export$2a15b079e3f46654);
$parcel$export(module.exports, "createCommentSuccess", () => $2eb07ee6692649ac$export$e993efecfd9a08b4);
$parcel$export(module.exports, "createCommentFailure", () => $2eb07ee6692649ac$export$5e212521c28e6663);
$parcel$export(module.exports, "getReadCredentials", () => $2eb07ee6692649ac$export$c62f8329852c0c3e);
$parcel$export(module.exports, "getReadCredentialsSuccess", () => $2eb07ee6692649ac$export$1c3602ad787f66de);
$parcel$export(module.exports, "getReadCredentialsFailure", () => $2eb07ee6692649ac$export$c1fdee8bb31030c2);

var $dNzn5 = parcelRequire("dNzn5");
const $2eb07ee6692649ac$export$c82a76c42259b55e = 'state.persisted.request.details.CHANGE_SUBSCRIPTION';
const $2eb07ee6692649ac$export$aed2f68a180d5132 = 'state.persisted.request.details.CHANGE_SUBSCRIPTION_SUCCESS';
const $2eb07ee6692649ac$export$b2aae42fb0a19db3 = 'state.persisted.request.details.CREATE_COMMENT';
const $2eb07ee6692649ac$export$5e5d6c973a5c4e53 = 'state.persisted.request.details.CREATE_COMMENT_SUCCESS';
const $2eb07ee6692649ac$export$423d075659092bbe = 'state.persisted.request.details.CREATE_COMMENT_FAILURE';
const $2eb07ee6692649ac$export$6e57eb44a84791a7 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS';
const $2eb07ee6692649ac$export$710f501aa8462ae0 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_SUCCESS';
const $2eb07ee6692649ac$export$73373e74567a5c83 = 'state.persisted.request.details.GET_MEDIA_READ_CREDENTIALS_FAILURE';
const $2eb07ee6692649ac$export$17b4c1a883566436 = 'state.persisted.request.details.DECIDE_APPROVAL';
const $2eb07ee6692649ac$export$32a89de369c73827 = 'state.persisted.request.details.DECIDE_APPROVAL_FAILURE';
const $2eb07ee6692649ac$export$c6977262f615318f = 'epic.model.FETCH_REQUEST_DETAILS_MODEL';
const $2eb07ee6692649ac$export$16e2b1f014063eb8 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_SUCCESS';
const $2eb07ee6692649ac$export$b793c4f327f63a76 = 'state.persisted.request.details.FETCH_REQUEST_DETAILS_FAILURE';
const $2eb07ee6692649ac$export$8fb5a515e01e48c5 = 'state.persisted.request.details.REMOVE_ORGANISATION';
const $2eb07ee6692649ac$export$74436d62ceb0e590 = 'state.persisted.request.details.REMOVE_ORGANISATION_SUCCESS';
const $2eb07ee6692649ac$export$85378bb183dca844 = 'state.persisted.request.details.ADD_PARTICIPANTS_SUCCESS';
const $2eb07ee6692649ac$export$fbce83858fb867fb = 'state.persisted.request.details.REMOVE_PARTICIPANT';
const $2eb07ee6692649ac$export$dfb1c2f386aee705 = 'state.persisted.request.details.REMOVE_PARTICIPANT_SUCCESS';
const $2eb07ee6692649ac$export$5cf2f51c187a7d5f = 'state.persisted.request.details.SHARE_REQUEST';
const $2eb07ee6692649ac$export$7fb10a1857e0e02a = 'state.ui.request.details.SHOW_TRANSITION_DIALOG';
const $2eb07ee6692649ac$export$3a407eae5b6f60b = 'state.ui.request.details.HIDE_TRANSITION_DIALOG';
const $2eb07ee6692649ac$export$a966f1a0c1a920e7 = 'state.persisted.request.details.TRANSITION_REQUEST';
const $2eb07ee6692649ac$export$fd4af480b5082555 = 'state.persisted.request.details.TRANSITION_REQUEST_FAILURE';
const $2eb07ee6692649ac$export$9e405a82dd6dd4e1 = 'state.persisted.request.details.CLEAR_TRANSITION_REQUEST';
const $2eb07ee6692649ac$export$5d6a7943e794d360 = (0, $dNzn5.buildModelsActionCreator)($2eb07ee6692649ac$export$c6977262f615318f, 'reqDetails');
const $2eb07ee6692649ac$export$f9b1366a7a60a8a = (requestDetailsModel)=>({
        type: $2eb07ee6692649ac$export$16e2b1f014063eb8,
        payload: requestDetailsModel
    });
const $2eb07ee6692649ac$export$524d371754c76f3c = (requestKey, addParticipantsSuccessResponse, userMentionedDuringRequestCreation = false)=>({
        type: $2eb07ee6692649ac$export$85378bb183dca844,
        payload: {
            requestKey: requestKey,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            addParticipantsSuccessResponse: addParticipantsSuccessResponse
        }
    });
const $2eb07ee6692649ac$export$5ef0f7883c2144b6 = (requestKey, error)=>({
        type: $2eb07ee6692649ac$export$b793c4f327f63a76,
        payload: {
            requestKey: requestKey,
            error: error
        }
    });
const $2eb07ee6692649ac$export$99effa43b85cc1d1 = (requestKey, requestId, shouldSubscribe)=>({
        type: $2eb07ee6692649ac$export$c82a76c42259b55e,
        payload: {
            requestKey: requestKey,
            requestId: requestId,
            shouldSubscribe: shouldSubscribe
        }
    });
const $2eb07ee6692649ac$export$e91b59ae91b1c17d = (requestKey, shouldSubscribe)=>({
        type: $2eb07ee6692649ac$export$aed2f68a180d5132,
        payload: {
            requestKey: requestKey,
            shouldSubscribe: shouldSubscribe
        }
    });
const $2eb07ee6692649ac$export$8ab1e7354f0ec72f = ()=>({
        type: $2eb07ee6692649ac$export$32a89de369c73827
    });
const $2eb07ee6692649ac$export$5fffe31f8df4a90b = (portalId, requestKey, approvalId, approve, createAnalyticsEvent)=>({
        type: $2eb07ee6692649ac$export$17b4c1a883566436,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            approvalId: approvalId,
            approve: approve,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $2eb07ee6692649ac$export$66d4278db03b2954 = (requestKey, organisationId)=>({
        type: $2eb07ee6692649ac$export$8fb5a515e01e48c5,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $2eb07ee6692649ac$export$f8de82921adab699 = (requestKey, organisationId)=>({
        type: $2eb07ee6692649ac$export$74436d62ceb0e590,
        payload: {
            requestKey: requestKey,
            organisationId: organisationId
        }
    });
const $2eb07ee6692649ac$export$971a7382b074b466 = (requestKey, accountId)=>({
        type: $2eb07ee6692649ac$export$fbce83858fb867fb,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $2eb07ee6692649ac$export$9be1ee8fbc799e1c = (requestKey, accountId)=>({
        type: $2eb07ee6692649ac$export$dfb1c2f386aee705,
        payload: {
            requestKey: requestKey,
            accountId: accountId
        }
    });
const $2eb07ee6692649ac$export$904a7ffbfa202969 = (requestKey, organizations, emailAddresses, accountIds, isUserMentioned, mentionedUserName, userMentionedDuringRequestCreation)=>({
        type: $2eb07ee6692649ac$export$5cf2f51c187a7d5f,
        payload: {
            requestKey: requestKey,
            organizations: organizations,
            emailAddresses: emailAddresses,
            accountIds: accountIds,
            isUserMentioned: isUserMentioned,
            mentionedUserName: mentionedUserName,
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation
        }
    });
const $2eb07ee6692649ac$export$375ec276b5b0476c = (id)=>({
        type: $2eb07ee6692649ac$export$7fb10a1857e0e02a,
        payload: {
            id: id
        }
    });
const $2eb07ee6692649ac$export$69175c2908a46e20 = ()=>({
        type: $2eb07ee6692649ac$export$3a407eae5b6f60b
    });
const $2eb07ee6692649ac$export$e72771314c1d54 = (portalId, requestKey, transitionId, comment, createAnalyticsEvent)=>({
        type: $2eb07ee6692649ac$export$a966f1a0c1a920e7,
        payload: {
            portalId: portalId,
            requestKey: requestKey,
            transitionId: transitionId,
            comment: comment,
            createAnalyticsEvent: createAnalyticsEvent
        }
    });
const $2eb07ee6692649ac$export$18f56c137e75378a = (error)=>({
        type: $2eb07ee6692649ac$export$fd4af480b5082555,
        payload: {
            error: error
        }
    });
const $2eb07ee6692649ac$export$20cf1fa346e88708 = ()=>({
        type: $2eb07ee6692649ac$export$9e405a82dd6dd4e1
    });
const $2eb07ee6692649ac$export$2a15b079e3f46654 = (portalId, requestId, requestKey, comment, fileIds, xsrftoken, numberOfMentionedUsers, meta)=>({
        type: $2eb07ee6692649ac$export$b2aae42fb0a19db3,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey,
            comment: comment,
            fileIds: fileIds,
            xsrftoken: xsrftoken,
            numberOfMentionedUsers: numberOfMentionedUsers,
            meta: meta
        }
    });
const $2eb07ee6692649ac$export$e993efecfd9a08b4 = (requestKey, response)=>({
        type: $2eb07ee6692649ac$export$5e5d6c973a5c4e53,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $2eb07ee6692649ac$export$5e212521c28e6663 = ()=>({
        type: $2eb07ee6692649ac$export$423d075659092bbe,
        payload: {}
    });
const $2eb07ee6692649ac$export$c62f8329852c0c3e = (portalId, requestId, requestKey)=>({
        type: $2eb07ee6692649ac$export$6e57eb44a84791a7,
        payload: {
            portalId: portalId,
            requestId: requestId,
            requestKey: requestKey
        }
    });
const $2eb07ee6692649ac$export$1c3602ad787f66de = (requestKey, response)=>({
        type: $2eb07ee6692649ac$export$710f501aa8462ae0,
        payload: {
            requestKey: requestKey,
            response: response
        }
    });
const $2eb07ee6692649ac$export$c1fdee8bb31030c2 = ()=>({
        type: $2eb07ee6692649ac$export$73373e74567a5c83,
        payload: {}
    });

});



parcelRegister("exsKQ", function(module, exports) {
$parcel$export(module.exports, "requestListEpic", () => $f9b0ec33e1d6a1fb$export$ab46e56cc8f700e6);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("bxUrV");
var $kH8Rm = parcelRequire("kH8Rm");
const $f9b0ec33e1d6a1fb$export$ab46e56cc8f700e6 = (action$)=>{
    return action$.ofType((0, $kH8Rm.FETCH_REQUEST_LIST_MODEL)).switchMap((action)=>{
        return (0, $elY4q.default)(action.payload).filter((response)=>response.allReqFilter !== undefined && 'requestList' in response.allReqFilter && Array.isArray(response.allReqFilter.requestList)).flatMap((response)=>{
            const filter = action.payload.params.filter;
            // TypeScript's Observable.filter() does not narrow types, so response.allReqFilter
            // is still typed as RequestListResponse | undefined here even though the preceding
            // .filter() guarantees it is defined and has a valid requestList array.
            const requestListModel = response.allReqFilter;
            return (0, $b0T1M.Observable).of((0, $kH8Rm.fetchRequestListSuccess)({
                ...requestListModel,
                filter: filter
            }));
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $kH8Rm.fetchRequestListFailure)(error));
        });
    });
};

});
parcelRegister("bxUrV", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => (parcelRequire("kH8Rm")).FETCH_REQUEST_LIST_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => (parcelRequire("kH8Rm")).FETCH_REQUEST_LIST_SUCCESS);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => (parcelRequire("kH8Rm")).FETCH_REQUEST_LIST_FAILURE);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => (parcelRequire("kH8Rm")).MARK_INITIAL_PAGE_LOAD_RENDERED);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => (parcelRequire("kH8Rm")).INVALIDATE_PAGES);
$parcel$export(module.exports, "fetchRequestListModel", () => (parcelRequire("kH8Rm")).fetchRequestListModel);
$parcel$export(module.exports, "fetchRequestListSuccess", () => (parcelRequire("kH8Rm")).fetchRequestListSuccess);
$parcel$export(module.exports, "fetchRequestListFailure", () => (parcelRequire("kH8Rm")).fetchRequestListFailure);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => (parcelRequire("kH8Rm")).markInitialPageLoadRendered);
$parcel$export(module.exports, "invalidatePages", () => (parcelRequire("kH8Rm")).invalidatePages);

var $kH8Rm = parcelRequire("kH8Rm");

});
parcelRegister("kH8Rm", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_LIST_MODEL", () => $a8fce1c6e489bc93$export$7ee1e1fb4cf5db91);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_SUCCESS", () => $a8fce1c6e489bc93$export$f9ff6948957ba5c5);
$parcel$export(module.exports, "FETCH_REQUEST_LIST_FAILURE", () => $a8fce1c6e489bc93$export$f5e5c834c1e2e455);
$parcel$export(module.exports, "MARK_INITIAL_PAGE_LOAD_RENDERED", () => $a8fce1c6e489bc93$export$4f7af1d62055a261);
$parcel$export(module.exports, "INVALIDATE_PAGES", () => $a8fce1c6e489bc93$export$d772cf5cfb44df9);
$parcel$export(module.exports, "fetchRequestListModel", () => $a8fce1c6e489bc93$export$decc5f94205f709e);
$parcel$export(module.exports, "invalidatePages", () => $a8fce1c6e489bc93$export$64b565f3a0ba7cb5);
$parcel$export(module.exports, "fetchRequestListSuccess", () => $a8fce1c6e489bc93$export$132d3416d8175125);
$parcel$export(module.exports, "fetchRequestListFailure", () => $a8fce1c6e489bc93$export$a842eadee8280475);
$parcel$export(module.exports, "markInitialPageLoadRendered", () => $a8fce1c6e489bc93$export$b643261c092a4f6);

var $dNzn5 = parcelRequire("dNzn5");
const $a8fce1c6e489bc93$export$7ee1e1fb4cf5db91 = 'epic.model.FETCH_REQUEST_LIST_MODEL';
const $a8fce1c6e489bc93$export$f9ff6948957ba5c5 = 'state.persisted.request.List.FETCH_REQUEST_LIST_SUCCESS';
const $a8fce1c6e489bc93$export$f5e5c834c1e2e455 = 'state.persisted.request.List.FETCH_REQUEST_LIST_FAILURE';
const $a8fce1c6e489bc93$export$4f7af1d62055a261 = 'state.persisted.request.List.MARK_INITIAL_PAGE_LOAD_RENDERED';
const $a8fce1c6e489bc93$export$d772cf5cfb44df9 = 'state.persisted.request.List.INVALIDATE_PAGES';
const $a8fce1c6e489bc93$export$decc5f94205f709e = (0, $dNzn5.buildModelsActionCreator)($a8fce1c6e489bc93$export$7ee1e1fb4cf5db91, 'allReqFilter');
const $a8fce1c6e489bc93$export$64b565f3a0ba7cb5 = (currentPage)=>({
        type: $a8fce1c6e489bc93$export$d772cf5cfb44df9,
        payload: currentPage
    });
const $a8fce1c6e489bc93$export$132d3416d8175125 = (requestListModel)=>({
        type: $a8fce1c6e489bc93$export$f9ff6948957ba5c5,
        payload: requestListModel
    });
const $a8fce1c6e489bc93$export$a842eadee8280475 = (error)=>({
        type: $a8fce1c6e489bc93$export$f5e5c834c1e2e455,
        payload: {
            error: error
        }
    });
const $a8fce1c6e489bc93$export$b643261c092a4f6 = ()=>({
        type: $a8fce1c6e489bc93$export$4f7af1d62055a261
    });

});



parcelRegister("5GYV5", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionEpic", () => $68457924e6f6b26e$export$6dca1de129d1f3d9);

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("fZNes");
var $fzeUC = parcelRequire("fzeUC");

var $elY4q = parcelRequire("elY4q");
const $68457924e6f6b26e$export$6dca1de129d1f3d9 = (action$)=>{
    return action$.ofType((0, $fzeUC.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload, {
            type: 'secondary'
        }).filter((response)=>!!response.suggestedRequestTypes).map((response)=>(0, $fzeUC.fetchRequestTypeSuggestionSuccess)(response.suggestedRequestTypes))// we're casting to success here as we swallow any errors for now
        .catch((_)=>(0, $b0T1M.Observable).never()));
};

});
parcelRegister("fZNes", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => (parcelRequire("fzeUC")).FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => (parcelRequire("fzeUC")).FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => (parcelRequire("fzeUC")).fetchRequestTypeSuggestionAction);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => (parcelRequire("fzeUC")).fetchRequestTypeSuggestionSuccess);

var $fzeUC = parcelRequire("fzeUC");

});
parcelRegister("fzeUC", function(module, exports) {
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL", () => $7874794b785aa47c$export$19c1cce5df18edab);
$parcel$export(module.exports, "FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS", () => $7874794b785aa47c$export$16165835dcce301e);
$parcel$export(module.exports, "fetchRequestTypeSuggestionAction", () => $7874794b785aa47c$export$2eae5c2f108f9b38);
$parcel$export(module.exports, "fetchRequestTypeSuggestionSuccess", () => $7874794b785aa47c$export$677aa00fa9ff8a57);

var $dNzn5 = parcelRequire("dNzn5");
const $7874794b785aa47c$export$19c1cce5df18edab = 'epic.model.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL';
const $7874794b785aa47c$export$16165835dcce301e = 'state.persisted.request-type-suggestion.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS';
const $7874794b785aa47c$export$2eae5c2f108f9b38 = (0, $dNzn5.buildModelsActionCreator)($7874794b785aa47c$export$19c1cce5df18edab, 'suggestedRequestTypes');
const $7874794b785aa47c$export$677aa00fa9ff8a57 = (requestTypeSuggestions)=>({
        payload: requestTypeSuggestions,
        type: $7874794b785aa47c$export$16165835dcce301e
    });

});



parcelRegister("jd0eh", function(module, exports) {
$parcel$export(module.exports, "requestsColumnSettingsEpic", () => $8236667bbb49448d$export$3d5be110c2cef28d);

var $b0T1M = parcelRequire("b0T1M");

var $eHHQc = parcelRequire("eHHQc");

var $elY4q = parcelRequire("elY4q");
const $8236667bbb49448d$export$3d5be110c2cef28d = (action$)=>{
    return action$.ofType((0, $eHHQc.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.requestsColumnSettings).map((response)=>{
            return (0, $eHHQc.fetchRequestsColumnSettingsSuccess)(response.requestsColumnSettings || []);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $eHHQc.fetchRequestsColumnSettingsFailure)(error));
        }));
};

});
parcelRegister("eHHQc", function(module, exports) {
$parcel$export(module.exports, "CUSTOMIZING_REQUEST_LIST_COLUMN", () => $2c1cb3e6d45e37ca$export$71e1a7c3232c719e);
$parcel$export(module.exports, "TOGGLE_COLUMN_RE_ORDER_WIDGET", () => $2c1cb3e6d45e37ca$export$839cbba59bbe0238);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_MODEL", () => $2c1cb3e6d45e37ca$export$abc90ee82ed578f);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $2c1cb3e6d45e37ca$export$47e32c3c3500bef2);
$parcel$export(module.exports, "FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $2c1cb3e6d45e37ca$export$10398b8018af3940);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL", () => $2c1cb3e6d45e37ca$export$f90917a8f5386b09);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS", () => $2c1cb3e6d45e37ca$export$e560350e06e586db);
$parcel$export(module.exports, "UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE", () => $2c1cb3e6d45e37ca$export$79deac20d43b585c);
$parcel$export(module.exports, "RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS", () => $2c1cb3e6d45e37ca$export$29dc39ddf284347c);
$parcel$export(module.exports, "REORDER_REQUEST_LIST_COLUMNS", () => $2c1cb3e6d45e37ca$export$8d4d9dae0354b673);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL", () => $2c1cb3e6d45e37ca$export$ff2ed1ddece23eaa);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS", () => $2c1cb3e6d45e37ca$export$70626e2ee8f09144);
$parcel$export(module.exports, "UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE", () => $2c1cb3e6d45e37ca$export$3fe3cdc959a8c16a);
$parcel$export(module.exports, "customizingRequestListColumn", () => $2c1cb3e6d45e37ca$export$cef6e00d44beb902);
$parcel$export(module.exports, "toggleColumnReOrderWidget", () => $2c1cb3e6d45e37ca$export$82755465bec7b53d);
$parcel$export(module.exports, "fetchRequestsColumnSettingsModel", () => $2c1cb3e6d45e37ca$export$2ddd8f55c6e79cad);
$parcel$export(module.exports, "fetchRequestsColumnSettingsSuccess", () => $2c1cb3e6d45e37ca$export$91fa974aae399c3e);
$parcel$export(module.exports, "fetchRequestsColumnSettingsFailure", () => $2c1cb3e6d45e37ca$export$358a9b23c953cceb);
$parcel$export(module.exports, "updateRequestsColumnSettingsModel", () => $2c1cb3e6d45e37ca$export$d283121346cbb92e);
$parcel$export(module.exports, "updateRequestsColumnSettingsSuccess", () => $2c1cb3e6d45e37ca$export$46519305d1bd5dcc);
$parcel$export(module.exports, "updateRequestsColumnSettingsFailure", () => $2c1cb3e6d45e37ca$export$a9e9b393ae51b9eb);
$parcel$export(module.exports, "resetCustomizeRequestsColumnSettings", () => $2c1cb3e6d45e37ca$export$b835f37760c00124);
$parcel$export(module.exports, "reOrderRequestListColumns", () => $2c1cb3e6d45e37ca$export$7401badd435f0b7c);
$parcel$export(module.exports, "updateOrderedRequestListColumnsModel", () => $2c1cb3e6d45e37ca$export$bca82c1325293cdd);
$parcel$export(module.exports, "updateOrderedRequestListColumnsSuccess", () => $2c1cb3e6d45e37ca$export$7e3f487fe57e88e3);
$parcel$export(module.exports, "updateOrderedRequestListColumnsFailure", () => $2c1cb3e6d45e37ca$export$98a8373db0072493);

var $dNzn5 = parcelRequire("dNzn5");
const $2c1cb3e6d45e37ca$export$71e1a7c3232c719e = 'state.ui.requests.column.settings.CUSTOMIZING_REQUEST_LIST_COLUMN';
const $2c1cb3e6d45e37ca$export$839cbba59bbe0238 = 'state.ui.requests.column.settings.TOGGLE_COLUMN_RE_ORDER_WIDGET';
const $2c1cb3e6d45e37ca$export$abc90ee82ed578f = 'epic.model.FETCH_REQUESTS_COLUMN_SETTINGS_MODEL';
const $2c1cb3e6d45e37ca$export$47e32c3c3500bef2 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $2c1cb3e6d45e37ca$export$10398b8018af3940 = 'state.persisted.requests.column.settings.FETCH_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $2c1cb3e6d45e37ca$export$f90917a8f5386b09 = 'epic.requests-column-settings.UPDATE_REQUESTS_COLUMN_SETTINGS_MODEL';
const $2c1cb3e6d45e37ca$export$e560350e06e586db = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_SUCCESS';
const $2c1cb3e6d45e37ca$export$79deac20d43b585c = 'state.persisted.requests.column.settings.UPDATE_REQUESTS_COLUMN_SETTINGS_FAILURE';
const $2c1cb3e6d45e37ca$export$29dc39ddf284347c = 'state.ui.requests.column.settings.RESET_CUSTOMIZE_REQUESTS_COLUMN_SETTINGS';
const $2c1cb3e6d45e37ca$export$8d4d9dae0354b673 = 'state.ui.requests.column.settings.REORDER_REQUEST_LIST_COLUMNS';
const $2c1cb3e6d45e37ca$export$ff2ed1ddece23eaa = 'epic.requests-column-settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_MODEL';
const $2c1cb3e6d45e37ca$export$70626e2ee8f09144 = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_SUCCESS';
const $2c1cb3e6d45e37ca$export$3fe3cdc959a8c16a = 'state.persisted.requests.column.settings.UPDATE_ORDERED_REQUEST_LIST_COLUMNS_FAILURE';
const $2c1cb3e6d45e37ca$export$cef6e00d44beb902 = (isCustomizing)=>({
        type: $2c1cb3e6d45e37ca$export$71e1a7c3232c719e,
        payload: isCustomizing
    });
const $2c1cb3e6d45e37ca$export$82755465bec7b53d = (isReOrdering)=>({
        type: $2c1cb3e6d45e37ca$export$839cbba59bbe0238,
        payload: isReOrdering
    });
const $2c1cb3e6d45e37ca$export$2ddd8f55c6e79cad = (0, $dNzn5.buildModelsActionCreator)($2c1cb3e6d45e37ca$export$abc90ee82ed578f, 'requestsColumnSettings');
const $2c1cb3e6d45e37ca$export$91fa974aae399c3e = (requestsColumnSettingsModel)=>({
        type: $2c1cb3e6d45e37ca$export$47e32c3c3500bef2,
        payload: requestsColumnSettingsModel
    });
const $2c1cb3e6d45e37ca$export$358a9b23c953cceb = (error)=>({
        type: $2c1cb3e6d45e37ca$export$10398b8018af3940,
        payload: {
            error: error
        }
    });
const $2c1cb3e6d45e37ca$export$d283121346cbb92e = (requestsColumnSettingsModel, meta)=>({
        meta: meta,
        type: $2c1cb3e6d45e37ca$export$f90917a8f5386b09,
        payload: requestsColumnSettingsModel
    });
const $2c1cb3e6d45e37ca$export$46519305d1bd5dcc = (requestsColumnSettingsModel)=>({
        type: $2c1cb3e6d45e37ca$export$e560350e06e586db,
        payload: requestsColumnSettingsModel
    });
const $2c1cb3e6d45e37ca$export$a9e9b393ae51b9eb = (error)=>({
        type: $2c1cb3e6d45e37ca$export$79deac20d43b585c,
        payload: {
            error: error
        }
    });
const $2c1cb3e6d45e37ca$export$b835f37760c00124 = ()=>({
        type: $2c1cb3e6d45e37ca$export$29dc39ddf284347c
    });
const $2c1cb3e6d45e37ca$export$7401badd435f0b7c = (newOrder)=>({
        type: $2c1cb3e6d45e37ca$export$8d4d9dae0354b673,
        payload: newOrder
    });
const $2c1cb3e6d45e37ca$export$bca82c1325293cdd = (newOrder, meta)=>{
    return {
        meta: meta,
        type: $2c1cb3e6d45e37ca$export$ff2ed1ddece23eaa,
        payload: newOrder
    };
};
const $2c1cb3e6d45e37ca$export$7e3f487fe57e88e3 = (requestsColumnSettings)=>({
        type: $2c1cb3e6d45e37ca$export$70626e2ee8f09144,
        payload: requestsColumnSettings
    });
const $2c1cb3e6d45e37ca$export$98a8373db0072493 = (error)=>({
        type: $2c1cb3e6d45e37ca$export$3fe3cdc959a8c16a,
        payload: {
            error: error
        }
    });

});


parcelRegister("8TdBT", function(module, exports) {
$parcel$export(module.exports, "timezonesEpic", () => $5bc0810f3193a72a$export$be7068db419e43b3);
$parcel$export(module.exports, "timezoneRegionsEpic", () => $5bc0810f3193a72a$export$f2ed825e49baebf1);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $elY4q = parcelRequire("elY4q");
parcelRequire("gTNQM");
var $nk7DB = parcelRequire("nk7DB");

var $fI5Sq = parcelRequire("fI5Sq");
const $5bc0810f3193a72a$export$be7068db419e43b3 = (action$)=>{
    return action$.ofType((0, $nk7DB.FETCH_TIMEZONES_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.timezones).map((response)=>{
            return (0, $nk7DB.fetchTimezonesSuccess)(response.timezones || []);
        }).catch((_)=>{
            return (0, $b0T1M.Observable).of((0, $gBYjj.showErrorFlag)((0, $fI5Sq.genericError).title, (0, $fI5Sq.genericError).description));
        }));
};
const $5bc0810f3193a72a$export$f2ed825e49baebf1 = (action$)=>{
    return action$.ofType((0, $nk7DB.FETCH_TIMEZONE_REGIONS_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.timezoneRegions).map((response)=>{
            return (0, $nk7DB.fetchTimezoneRegionsSuccess)(response.timezoneRegions || []);
        }).catch((_)=>{
            return (0, $b0T1M.Observable).of((0, $gBYjj.showErrorFlag)((0, $fI5Sq.genericError).title, (0, $fI5Sq.genericError).description));
        }));
};

});
parcelRegister("gTNQM", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => (parcelRequire("nk7DB")).FETCH_TIMEZONES_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => (parcelRequire("nk7DB")).FETCH_TIMEZONE_REGIONS_MODEL);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => (parcelRequire("nk7DB")).FETCH_TIMEZONES_SUCCESS);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => (parcelRequire("nk7DB")).FETCH_TIMEZONE_REGIONS_SUCCESS);
$parcel$export(module.exports, "fetchTimezonesModel", () => (parcelRequire("nk7DB")).fetchTimezonesModel);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => (parcelRequire("nk7DB")).fetchTimezoneRegionsModel);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => (parcelRequire("nk7DB")).fetchTimezonesSuccess);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => (parcelRequire("nk7DB")).fetchTimezoneRegionsSuccess);

var $nk7DB = parcelRequire("nk7DB");

});
parcelRegister("nk7DB", function(module, exports) {
$parcel$export(module.exports, "FETCH_TIMEZONES_MODEL", () => $de9d68a8d071ee5f$export$932af27e6d5887a0);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_MODEL", () => $de9d68a8d071ee5f$export$3b699f83ba8d2c06);
$parcel$export(module.exports, "FETCH_TIMEZONES_SUCCESS", () => $de9d68a8d071ee5f$export$6b053ef4439b07a6);
$parcel$export(module.exports, "FETCH_TIMEZONE_REGIONS_SUCCESS", () => $de9d68a8d071ee5f$export$6932839fde3fd591);
$parcel$export(module.exports, "fetchTimezonesModel", () => $de9d68a8d071ee5f$export$f02c0cf38058cca0);
$parcel$export(module.exports, "fetchTimezoneRegionsModel", () => $de9d68a8d071ee5f$export$2ac437e497040cf4);
$parcel$export(module.exports, "fetchTimezoneRegionsSuccess", () => $de9d68a8d071ee5f$export$f577dd22c3538327);
$parcel$export(module.exports, "fetchTimezonesSuccess", () => $de9d68a8d071ee5f$export$219ccd71bd1012b);

var $dNzn5 = parcelRequire("dNzn5");
const $de9d68a8d071ee5f$export$932af27e6d5887a0 = 'epic.model.FETCH_TIMEZONES_MODEL';
const $de9d68a8d071ee5f$export$3b699f83ba8d2c06 = 'epic.model.FETCH_TIMEZONE_REGIONS_MODEL';
const $de9d68a8d071ee5f$export$6b053ef4439b07a6 = 'state.persisted.timezone.FETCH_TIMEZONEs_SUCCESS';
const $de9d68a8d071ee5f$export$6932839fde3fd591 = 'state.persisted.timezone.FETCH_TIMEZONE_REGIONS_SUCCESS';
const $de9d68a8d071ee5f$export$f02c0cf38058cca0 = (0, $dNzn5.buildModelsActionCreator)($de9d68a8d071ee5f$export$932af27e6d5887a0, 'timezones');
const $de9d68a8d071ee5f$export$2ac437e497040cf4 = (0, $dNzn5.buildModelsActionCreator)($de9d68a8d071ee5f$export$3b699f83ba8d2c06, 'timezoneRegions');
const $de9d68a8d071ee5f$export$f577dd22c3538327 = (timezoneRegions)=>({
        type: $de9d68a8d071ee5f$export$6932839fde3fd591,
        payload: {
            timezoneRegions: timezoneRegions
        }
    });
const $de9d68a8d071ee5f$export$219ccd71bd1012b = (timezones)=>({
        type: $de9d68a8d071ee5f$export$6b053ef4439b07a6,
        payload: {
            timezones: timezones
        }
    });

});



parcelRegister("c49HS", function(module, exports) {
$parcel$export(module.exports, "uiModificationsEpic", () => $e345dc13af6040b0$export$b3e7540861af6314);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("95qI5");
var $aEVH2 = parcelRequire("aEVH2");
const $e345dc13af6040b0$export$b3e7540861af6314 = (action$)=>{
    return action$.ofType((0, $aEVH2.FETCH_UI_MODIFICATIONS_MODEL)).mergeMap((action)=>{
        var _action$payload, _action$payload2;
        const portalId = (_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.params) === null || _action$payload === void 0 ? void 0 : _action$payload.portalId;
        const requestTypeId = (_action$payload2 = action.payload) === null || _action$payload2 === void 0 || (_action$payload2 = _action$payload2.params) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.requestTypeId;
        // Guard clause: ensure required params are defined
        // If params are missing, don't emit any action (nothing meaningful to store)
        if (portalId === undefined || requestTypeId === undefined) return (0, $b0T1M.Observable).empty();
        return (0, $elY4q.default)(action.payload).filter((response)=>{
            return !!response.uiModifications;
        }).mergeMap((response)=>{
            const uiModifications = response.uiModifications;
            // Check if the response contains an error object
            if ('error' in uiModifications && uiModifications.error) {
                const error = uiModifications.error;
                return (0, $b0T1M.Observable).of((0, $aEVH2.fetchUiModificationsFailure)(portalId, requestTypeId, {
                    status: 500,
                    errorMessages: [
                        error.message || error.code || 'Unknown error'
                    ]
                }));
            }
            return (0, $b0T1M.Observable).of((0, $aEVH2.fetchUiModificationsSuccess)(portalId, requestTypeId, uiModifications));
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $aEVH2.fetchUiModificationsFailure)(portalId, requestTypeId, error));
        });
    });
};

});
parcelRegister("95qI5", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => (parcelRequire("aEVH2")).FETCH_UI_MODIFICATIONS_MODEL);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => (parcelRequire("aEVH2")).FETCH_UI_MODIFICATIONS_SUCCESS);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => (parcelRequire("aEVH2")).FETCH_UI_MODIFICATIONS_FAILURE);
$parcel$export(module.exports, "fetchUiModificationsAction", () => (parcelRequire("aEVH2")).fetchUiModificationsAction);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => (parcelRequire("aEVH2")).fetchUiModificationsSuccess);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => (parcelRequire("aEVH2")).fetchUiModificationsFailure);

var $aEVH2 = parcelRequire("aEVH2");

});
parcelRegister("aEVH2", function(module, exports) {
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_MODEL", () => $bf0e4846a8732617$export$8dbb39b6146e28fc);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_SUCCESS", () => $bf0e4846a8732617$export$7165d2daf9f7546b);
$parcel$export(module.exports, "FETCH_UI_MODIFICATIONS_FAILURE", () => $bf0e4846a8732617$export$f2bc8b8032fa83f9);
$parcel$export(module.exports, "fetchUiModificationsAction", () => $bf0e4846a8732617$export$d5c10586cf66ad48);
$parcel$export(module.exports, "fetchUiModificationsSuccess", () => $bf0e4846a8732617$export$5811aa4798efe56f);
$parcel$export(module.exports, "fetchUiModificationsFailure", () => $bf0e4846a8732617$export$aa1b71ac6d05f568);

var $dNzn5 = parcelRequire("dNzn5");
const $bf0e4846a8732617$export$8dbb39b6146e28fc = 'epic.model.FETCH_UI_MODIFICATIONS_MODEL';
const $bf0e4846a8732617$export$7165d2daf9f7546b = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_SUCCESS';
const $bf0e4846a8732617$export$f2bc8b8032fa83f9 = 'state.persisted.uiModifications.FETCH_UI_MODIFICATIONS_FAILURE';
const $bf0e4846a8732617$export$d5c10586cf66ad48 = (0, $dNzn5.buildModelsActionCreator)($bf0e4846a8732617$export$8dbb39b6146e28fc, 'uiModifications');
const $bf0e4846a8732617$export$5811aa4798efe56f = (portalId, requestTypeId, uiModifications)=>({
        type: $bf0e4846a8732617$export$7165d2daf9f7546b,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            uiModifications: uiModifications
        }
    });
const $bf0e4846a8732617$export$aa1b71ac6d05f568 = (portalId, requestTypeId, error)=>({
        type: $bf0e4846a8732617$export$f2bc8b8032fa83f9,
        payload: {
            portalId: portalId,
            requestTypeId: requestTypeId,
            error: error
        }
    });

});



parcelRegister("k1GLu", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationEpic", () => $5f03bbb09eac7711$export$a5c82ee4d4a62853);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("7pPzB");
var $4xqOU = parcelRequire("4xqOU");

var $bnV9E = parcelRequire("bnV9E");
const $5f03bbb09eac7711$export$a5c82ee4d4a62853 = (action$)=>{
    return action$.ofType((0, $bnV9E.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.unsubscribedConfirmation && !!response.unsubscribedConfirmation.requestKey).map((response)=>{
            return (0, $4xqOU.fetchUnsubscribedConfirmationSuccess)(response.unsubscribedConfirmation);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $4xqOU.fetchUnsubscribedConfirmationFailure)(error));
        }));
};

});
parcelRegister("7pPzB", function(module, exports) {
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => (parcelRequire("4xqOU")).fetchUnsubscribedConfirmationSuccess);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => (parcelRequire("4xqOU")).fetchUnsubscribedConfirmationFailure);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => (parcelRequire("4xqOU")).FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => (parcelRequire("4xqOU")).FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS);

var $4xqOU = parcelRequire("4xqOU");

});
parcelRegister("4xqOU", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS", () => $f741c93fead14e15$export$f72ddca71405b95d);
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE", () => $f741c93fead14e15$export$ebaa1597e87c25cb);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationSuccess", () => $f741c93fead14e15$export$c1bfe5b0bc39b67c);
$parcel$export(module.exports, "fetchUnsubscribedConfirmationFailure", () => $f741c93fead14e15$export$97f97477d437893);
const $f741c93fead14e15$export$f72ddca71405b95d = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS';
const $f741c93fead14e15$export$ebaa1597e87c25cb = 'state.persisted.unsibscribedconfirmation.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE';
const $f741c93fead14e15$export$c1bfe5b0bc39b67c = (unsubscribedConfirmationModel)=>({
        payload: unsubscribedConfirmationModel,
        type: $f741c93fead14e15$export$f72ddca71405b95d
    });
const $f741c93fead14e15$export$97f97477d437893 = (error)=>({
        type: $f741c93fead14e15$export$ebaa1597e87c25cb,
        payload: {
            error: error
        }
    });

});


parcelRegister("bnV9E", function(module, exports) {
$parcel$export(module.exports, "FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL", () => $a96d07cc50876471$export$2e46ab911cbec5e7);
$parcel$export(module.exports, "fetchUnsubscribedConfirmation", () => $a96d07cc50876471$export$4b67c7752a799aa6);

var $dNzn5 = parcelRequire("dNzn5");
const $a96d07cc50876471$export$2e46ab911cbec5e7 = 'epic.model.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL';
const $a96d07cc50876471$export$4b67c7752a799aa6 = (0, $dNzn5.buildModelsActionCreator)($a96d07cc50876471$export$2e46ab911cbec5e7, 'unsubscribedConfirmation');

});


parcelRegister("jnfRh", function(module, exports) {
$parcel$export(module.exports, "visitPortalEpic", () => $56b1f5138b04c0e0$export$b0dd3b8f13c4a9ce);

var $b0T1M = parcelRequire("b0T1M");

var $elY4q = parcelRequire("elY4q");
parcelRequire("4C3Ab");
var $dSbFt = parcelRequire("dSbFt");
const $56b1f5138b04c0e0$export$b0dd3b8f13c4a9ce = (action$)=>{
    return action$.ofType((0, $dSbFt.FETCH_VISIT_PORTAL_MODEL)).mergeMap((action)=>(0, $elY4q.default)(action.payload).filter((response)=>!!response.visitPortal && !!response.visitPortal.email).map((response)=>{
            return (0, $dSbFt.fetchVisitPortalSuccess)(response.visitPortal);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $dSbFt.fetchVisitPortalFailure)(error));
        }));
};

});


parcelRegister("hcLYa", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncementsEpic", () => $526c37ad567c2536$export$e4577247bf7a5bb1);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $90cjn = parcelRequire("90cjn");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");

var $keOG0 = parcelRequire("keOG0");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $4SM7Y = parcelRequire("4SM7Y");
const $526c37ad567c2536$export$e4577247bf7a5bb1 = (action$)=>{
    return action$.ofType((0, $lXazD.UPDATE_PORTAL_ANNOUNCEMENT_MODEL)).mergeMap((action)=>{
        const { meta: meta, portalId: portalId } = action;
        return (0, $90cjn.updatePortalAnnouncements)(action.payload, portalId).flatMap((response)=>{
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $lXazD.updatePortalAnnouncementSuccess)(response)));
        }).catch((error)=>{
            if ((0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) // Filter out client errors
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.success();
            else {
                if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $keOG0.legacySendEvent)((0, $4SM7Y.logErrorToFailureEvent)(meta.analyticsFailureEvent, error));
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                meta === null || meta === void 0 || meta.updateSinglePortalAnnouncementSideBarExperience.failure({
                    metadata: {
                        error: (0, $keOG0.getErrorData)(error)
                    }
                });
            }
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $lXazD.updatePortalAnnouncementFailure)(error)), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("90cjn", function(module, exports) {
$parcel$export(module.exports, "updatePortalAnnouncements", () => $7801e21a828d1f1d$export$9e961f2770667246);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $7801e21a828d1f1d$export$9e961f2770667246 = (payload, portalId, context = (0, $3wR8f.contextPath))=>{
    const portalAnnouncementUpdateURI = `${context}/rest/servicedesk/1/servicedesk-data/announcement/portal/${portalId}`;
    const contentType = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(portalAnnouncementUpdateURI, payload, contentType)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $5geAe.Observable).throw(e));
};

});


parcelRegister("3CgCH", function(module, exports) {
$parcel$export(module.exports, "changeRequestSubscriptionEpic", () => $24e41c8e980ff88f$export$43fea900952d51e2);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $dw08K = parcelRequire("dw08K");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");
const $24e41c8e980ff88f$export$43fea900952d51e2 = (action$)=>{
    return action$.ofType((0, $gEejF.CHANGE_SUBSCRIPTION)).mergeMap((changeSubscriptionAction)=>{
        const { shouldSubscribe: shouldSubscribe, requestId: requestId, requestKey: requestKey } = changeSubscriptionAction.payload;
        const restCall = shouldSubscribe ? (0, $dw08K.subscribe) : (0, $dw08K.unsubscribe);
        return restCall(requestId).map(()=>{
            return (0, $gEejF.changeSubscriptionSuccess)(requestKey, shouldSubscribe);
        }).catch((error)=>{
            return (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("dw08K", function(module, exports) {
$parcel$export(module.exports, "subscribe", () => $72b3c479fcf42ec9$export$ec068583843480e7);
$parcel$export(module.exports, "unsubscribe", () => $72b3c479fcf42ec9$export$f500693cef883ffd);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $72b3c479fcf42ec9$export$ec068583843480e7 = (requestId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $lVFX8.put)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};
const $72b3c479fcf42ec9$export$f500693cef883ffd = (requestId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/notification/subscription/${requestId}`;
    return (0, $lVFX8.doDelete)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};

});


parcelRegister("o83ZW", function(module, exports) {
$parcel$export(module.exports, "createCommentEpic", () => $49b8f16ec715acfe$export$3d130ce773bd2648);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $1n0vn = parcelRequire("1n0vn");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");

var $eoiFu = parcelRequire("eoiFu");
const $49b8f16ec715acfe$export$3d130ce773bd2648 = (action$)=>{
    return action$.ofType((0, $gEejF.CREATE_COMMENT)).mergeMap((createCommentAction)=>{
        const payload = createCommentAction.payload;
        return (0, $1n0vn.createComment)(payload.requestId, payload.comment, payload.fileIds, payload.xsrftoken).flatMap((createCommentResponse)=>{
            const { meta: meta, numberOfMentionedUsers: numberOfMentionedUsers } = payload;
            if (meta !== null && meta !== void 0 && meta.analyticsSuccessEvent) {
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // oxlint-disable-next-line no-shadow
                meta === null || meta === void 0 || meta.analyticsSuccessEvent.update((payload)=>({
                        ...payload,
                        count: numberOfMentionedUsers || 0
                    }));
                (0, $keOG0.legacySendEvent)(meta === null || meta === void 0 ? void 0 : meta.analyticsSuccessEvent);
            }
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $gEejF.createCommentSuccess)(payload.requestKey, createCommentResponse)), (0, $b0T1M.Observable).of((0, $gEejF.getReadCredentials)(payload.portalId, payload.requestId, payload.requestKey)));
        }).catch((error)=>{
            const meta = payload.meta;
            if (meta !== null && meta !== void 0 && meta.analyticsFailureEvent) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent);
            const isShowErrorFlag = payload.numberOfMentionedUsers && payload.numberOfMentionedUsers > 0 && !(0, $eo5zF.isNetworkErrorCode)(error.status);
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $gEejF.createCommentFailure)()), (0, $b0T1M.Observable).of(isShowErrorFlag ? (0, $gBYjj.showErrorFlag)((0, $eoiFu.default).commentCreateWithMentionsFailedTitle, (0, $eoiFu.default).commentCreateWithMentionsFailedDescription) : (0, $gBYjj.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("1n0vn", function(module, exports) {
$parcel$export(module.exports, "createComment", () => $fc1ead2909bb05dd$export$2a15b079e3f46654);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");
const $fc1ead2909bb05dd$export$2a15b079e3f46654 = (issueId, comment, fileIds, xsrfToken, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/customer/comment`;
    const body = {
        issueId: issueId,
        comment: comment,
        fileIds: fileIds,
        xsrfToken: xsrfToken
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map((ajaxResponse)=>ajaxResponse.response).catch((e)=>{
        return (0, $b0T1M.Observable).throw(e);
    });
};

});

parcelRegister("eoiFu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cae3d09197904192$export$2e2bcd8739ae039);
/* Note: these messages are not final */ 
var $jalUJ = parcelRequire("jalUJ");
var $cae3d09197904192$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    commentCreateWithMentionsFailedTitle: {
        defaultMessage: "We couldn\u2019t add this comment",
        description: 'Comment containing user mentions failed to create title',
        id: 'sd.comment.create.with.mentions.failed.title'
    },
    commentCreateWithMentionsFailedDescription: {
        defaultMessage: 'Try adding it again in a few minutes. ',
        description: 'Comment containing user mentions failed to create description',
        id: 'sd.comment.create.with.mentions.failed.description'
    }
});

});


parcelRegister("h1iWI", function(module, exports) {
$parcel$export(module.exports, "decideApprovalEpic", () => $7a6752a939ee1b87$export$d61d906dee97954f);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $bG6ob = parcelRequire("bG6ob");

var $gBYjj = parcelRequire("gBYjj");

var $luktJ = parcelRequire("luktJ");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");

var $68w2P = parcelRequire("68w2P");
const $7a6752a939ee1b87$var$isClientSideError = (error)=>error.status >= 400 && error.status < 500;
const $7a6752a939ee1b87$export$d61d906dee97954f = (action$)=>{
    return action$.ofType((0, $gEejF.DECIDE_APPROVAL)).mergeMap((decideApprovalAction)=>{
        const payload = decideApprovalAction.payload;
        const restCall = payload.approve ? (0, $luktJ.approve)(payload.approvalId) : (0, $luktJ.decline)(payload.approvalId);
        return restCall.map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'recorded'
            });
            if (successEvent) {
                successEvent.context.push({
                    componentName: 'approverDecision'
                });
                (0, $keOG0.legacySendEvent)(successEvent);
            }
            return (0, $gEejF.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        })// @ts-ignore
        .catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                statusCode: $7a6752a939ee1b87$var$isClientSideError(error) ? '4XX' : '5XX'
            });
            if (failEvent) {
                failEvent.context.push({
                    componentName: 'portalRequestDetailsScreen.answerApprovalService'
                });
                (0, $keOG0.legacySendEvent)(failEvent);
            }
            if (error.status === 409) return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $gEejF.decideApprovalFailure)()), (0, $b0T1M.Observable).of((0, $gEejF.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            })), (0, $b0T1M.Observable).of((0, $gBYjj.showErrorFlag)((0, $68w2P.default).conflictErrorTitle, (0, $bG6ob.isItsmIssueRenamingEnabled)() ? (0, $68w2P.default).conflictErrorDescriptionIssueTermRefresh : (0, $68w2P.default).conflictErrorDescription)));
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $gEejF.decideApprovalFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)));
        });
    });
};

});
parcelRegister("luktJ", function(module, exports) {
$parcel$export(module.exports, "approve", () => $a19852de5cee1007$export$5ba7c78c9d5e2122);
$parcel$export(module.exports, "decline", () => $a19852de5cee1007$export$ff9b5abb0defe452);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $a19852de5cee1007$export$5ba7c78c9d5e2122 = (approvalId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/approve`;
    return (0, $lVFX8.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};
const $a19852de5cee1007$export$ff9b5abb0defe452 = (approvalId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/approvals/1/customer/approval/${approvalId}/reject`;
    return (0, $lVFX8.post)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        return (0, $5geAe.Observable).throw(e);
    });
};

});

parcelRegister("68w2P", function(module, exports) {
$parcel$export(module.exports, "default", () => $e90daa2dea1dec0d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $e90daa2dea1dec0d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    conflictErrorTitle: {
        defaultMessage: 'Error',
        description: 'Conflict error when user clicking a stale approval panel decision button.',
        id: 'sd.stale.approval.panel.conflict.title'
    },
    conflictErrorDescription: {
        defaultMessage: 'An approval response has already been submitted for this issue.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description'
    },
    conflictErrorDescriptionIssueTermRefresh: {
        defaultMessage: 'An approval response has already been submitted for this work item.',
        description: 'Conflict error when user clicking a stale approval panel decision button description',
        id: 'sd.stale.approval.panel.conflict.description-issue-term-refresh'
    }
});

});


parcelRegister("7jHGd", function(module, exports) {
$parcel$export(module.exports, "getMediaReadCredentialsEpic", () => $2158795cc44c2baf$export$248d895b14907a3);

var $b0T1M = parcelRequire("b0T1M");

var $lki4o = parcelRequire("lki4o");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");
const $2158795cc44c2baf$export$248d895b14907a3 = (action$)=>{
    return action$.ofType((0, $gEejF.GET_MEDIA_READ_CREDENTIALS)).mergeMap((getReadCredentialsAction)=>{
        const payload = getReadCredentialsAction.payload;
        return (0, $lki4o.getReadCredentialsForRequest)(payload.portalId, payload.requestId).map((getReadCredentialsResponse)=>{
            return (0, $gEejF.getReadCredentialsSuccess)(payload.requestKey, getReadCredentialsResponse);
        }).catch((_)=>{
            return (0, $b0T1M.Observable).of((0, $gEejF.getReadCredentialsFailure)());
        });
    });
};

});

parcelRegister("fwR6p", function(module, exports) {
$parcel$export(module.exports, "removeOrganisationEpic", () => $ef965581f1090977$export$b62b13475aa4d5e);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $AxD9s = parcelRequire("AxD9s");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $aW6dl = parcelRequire("aW6dl");
const $ef965581f1090977$export$b62b13475aa4d5e = (action$)=>{
    return action$.ofType((0, $gEejF.REMOVE_ORGANISATION)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, organisationId: organisationId } = removeParticipantAction.payload;
        return (0, $AxD9s.removeOrganisation)(requestKey, organisationId).map(()=>{
            return (0, $gEejF.removeOrganisationSuccess)(requestKey, organisationId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $b0T1M.Observable).of(isPermissionDenied ? (0, $gBYjj.showErrorFlag)((0, $aW6dl.default).permissionDeniedErrorTitle, (0, $aW6dl.default).permissionDeniedErrorDescription) : (0, $gBYjj.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("AxD9s", function(module, exports) {
$parcel$export(module.exports, "removeUsingAccountId", () => $a7aaaf89110c2378$export$d06c11dbdb4f724e);
$parcel$export(module.exports, "removeOrganisation", () => $a7aaaf89110c2378$export$66d4278db03b2954);
$parcel$export(module.exports, "search", () => $a7aaaf89110c2378$export$d76128d007d19019);
$parcel$export(module.exports, "addParticipants", () => $a7aaaf89110c2378$export$600fe12d720e6ff9);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $4i2V5 = parcelRequire("4i2V5");

var $3wR8f = parcelRequire("3wR8f");
const $a7aaaf89110c2378$export$d06c11dbdb4f724e = (requestKey, accountId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeParticipant`;
    const body = {
        accountId: accountId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $b0T1M.Observable).throw(e));
};
const $a7aaaf89110c2378$export$66d4278db03b2954 = (requestKey, organisationId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/removeOrganisation`;
    const body = {
        organisationId: organisationId
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.put)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $b0T1M.Observable).throw(e));
};
const $a7aaaf89110c2378$export$d76128d007d19019 = (requestKey, query = '', context = (0, $3wR8f.contextPath))=>{
    const queryString = $4i2V5.stringify({
        q: query
    });
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/search?${queryString}`;
    const headers = {
        Accept: 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, headers).toPromise()// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .then((ajaxResponse)=>ajaxResponse.response).catch((e)=>Promise.reject(e));
};
const $a7aaaf89110c2378$export$600fe12d720e6ff9 = (requestKey, accountIds, organizationIds, emailAddresses, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/participants/${requestKey}/add`;
    const body = {
        accountIds: accountIds,
        organisationIds: organizationIds,
        emails: emailAddresses
    };
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.put)(uri, body, headers).map((ajaxResponse)=>ajaxResponse.response);
};

});

parcelRegister("aW6dl", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc4657191daea86f$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $cc4657191daea86f$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.organization.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.organization.permission.denied.description'
    }
});

});


parcelRegister("3QzMH", function(module, exports) {
$parcel$export(module.exports, "removeParticipantEpic", () => $8e667fd965095e72$export$3f20d6b824d24e4c);

var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $AxD9s = parcelRequire("AxD9s");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $ak1Q9 = parcelRequire("ak1Q9");
const $8e667fd965095e72$export$3f20d6b824d24e4c = (action$)=>{
    return action$.ofType((0, $gEejF.REMOVE_PARTICIPANT)).mergeMap((removeParticipantAction)=>{
        const { requestKey: requestKey, accountId: accountId } = removeParticipantAction.payload;
        return (0, $AxD9s.removeUsingAccountId)(requestKey, accountId).map(()=>{
            return (0, $gEejF.removeParticipantSuccess)(requestKey, accountId);
        }).catch((error)=>{
            const isPermissionDenied = error.status === 403;
            return (0, $b0T1M.Observable).of(isPermissionDenied ? (0, $gBYjj.showErrorFlag)((0, $ak1Q9.default).permissionDeniedErrorTitle, (0, $ak1Q9.default).permissionDeniedErrorDescription) : (0, $gBYjj.handleAjaxError)(error));
        });
    });
};

});
parcelRegister("ak1Q9", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd4f99f2a45aca27$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $dd4f99f2a45aca27$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    permissionDeniedErrorTitle: {
        defaultMessage: "You don't have permission to remove this request participant",
        description: 'Permission Denied while removing participants title',
        id: 'sd.remove.participants.permission.denied.title'
    },
    permissionDeniedErrorDescription: {
        defaultMessage: 'Ask your admin to remove this request participant.',
        description: 'Permission Denied while removing participants description',
        id: 'sd.remove.participants.permission.denied.description'
    }
});

});


parcelRegister("1Sond", function(module, exports) {
$parcel$export(module.exports, "shareRequestEpic", () => $4950937c6e3c89fd$export$d11c340ce54e3cbb);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $AxD9s = parcelRequire("AxD9s");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $5s6ui = parcelRequire("5s6ui");
const $4950937c6e3c89fd$export$d11c340ce54e3cbb = (action$)=>action$.ofType((0, $gEejF.SHARE_REQUEST)).mergeMap((shareRequestAction)=>{
        const { requestKey: requestKey, organizations: organizations, emailAddresses: emailAddresses, accountIds: accountIds, isUserMentioned: isUserMentioned, mentionedUserName: mentionedUserName, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation } = shareRequestAction.payload;
        return (0, $AxD9s.addParticipants)(requestKey, accountIds, organizations, emailAddresses).flatMap((response)=>{
            if (isUserMentioned) {
                const messageTitle = mentionedUserName ? (0, $5s6ui.default).requestSharedWithSingleMentionedUserSuccessTitle : (0, $5s6ui.default).requestSharedWithMentionedUsersSuccessTitle;
                const messageDescription = mentionedUserName ? (0, $5s6ui.default).requestSharedWithSingleMentionedUserSuccessDescription : (0, $5s6ui.default).requestSharedWithMentionedUsersSuccessDescription;
                const descriptionValues = mentionedUserName ? {
                    userName: mentionedUserName
                } : undefined;
                return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $gEejF.addParticipantsSuccess)(requestKey, response, userMentionedDuringRequestCreation)), (0, $b0T1M.Observable).of((0, $gBYjj.showSuccessFlag)(messageTitle, undefined, messageDescription, undefined, descriptionValues)));
            }
            return (0, $b0T1M.Observable).of((0, $gEejF.addParticipantsSuccess)(requestKey, response));
        }).catch((error)=>{
            const isShowErrorFlag = isUserMentioned;
            const messageTitle = mentionedUserName ? (0, $5s6ui.default).requestSharedWithSingleMentionedUserFailureTitle : (0, $5s6ui.default).requestSharedWithMentionedUsersFailureTitle;
            const messageDescription = mentionedUserName ? (0, $5s6ui.default).requestSharedWithSingleMentionedUserFailureDescription : (0, $5s6ui.default).requestSharedWithMentionedUsersFailureDescription;
            const descriptionValues = mentionedUserName ? {
                userName: mentionedUserName
            } : undefined;
            return (0, $b0T1M.Observable).of(isShowErrorFlag ? (0, $gBYjj.showErrorFlag)(messageTitle, messageDescription, undefined, undefined, descriptionValues) : (0, $gBYjj.handleAjaxError)(error));
        });
    });

});
parcelRegister("5s6ui", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b4b6b6091677a99$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $1b4b6b6091677a99$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requestSharedWithSingleMentionedUserSuccessTitle: {
        defaultMessage: 'New request participant added',
        description: 'request shared with the single user mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.title'
    },
    requestSharedWithSingleMentionedUserSuccessDescription: {
        defaultMessage: '{userName} has been added as a request participant to this request.',
        description: 'request shared with the single user mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.success.description'
    },
    requestSharedWithMentionedUsersSuccessTitle: {
        defaultMessage: 'New request participants added',
        description: 'request shared with users mentioned in comment successfully title',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.title'
    },
    requestSharedWithMentionedUsersSuccessDescription: {
        defaultMessage: 'The users you mentioned have been added as request participants to this request.',
        description: 'request shared with users mentioned in comment successfully description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.success.description'
    },
    requestSharedWithSingleMentionedUserFailureTitle: {
        defaultMessage: "We couldn\u2019t add this request participant",
        description: 'requests sharing with single user failed title',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.title'
    },
    requestSharedWithSingleMentionedUserFailureDescription: {
        defaultMessage: "{userName} couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing with single user failed description',
        id: 'sd.comment.create.request.shared.with.single.mentioned.user.failure.description'
    },
    requestSharedWithMentionedUsersFailureTitle: {
        defaultMessage: "We couldn\u2019t add these request participants",
        description: 'requests sharing failed title',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.title'
    },
    requestSharedWithMentionedUsersFailureDescription: {
        defaultMessage: "The users you mentioned couldn\u2019t be added to this request. Try adding them again in a few minutes. ",
        description: 'request sharing failed description',
        id: 'sd.comment.create.request.shared.with.mentioned.users.failure.description'
    }
});

});


parcelRegister("becIW", function(module, exports) {
$parcel$export(module.exports, "transitionRequestEpic", () => $0a81fb7ddf399a44$export$2b9c3ffd3e776468);

var $b0T1M = parcelRequire("b0T1M");

var $fuQW5 = parcelRequire("fuQW5");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $fI5Sq = parcelRequire("fI5Sq");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
const $0a81fb7ddf399a44$export$2b9c3ffd3e776468 = (action$, store)=>{
    return action$.ofType((0, $gEejF.TRANSITION_REQUEST)).mergeMap((transitionAction)=>{
        const payload = transitionAction.payload;
        return (0, $fuQW5.transition)(payload.requestKey, payload.transitionId, payload.comment).map(()=>{
            var _payload$createAnalyt;
            const successEvent = (_payload$createAnalyt = payload.createAnalyticsEvent) === null || _payload$createAnalyt === void 0 ? void 0 : _payload$createAnalyt.call(payload, {
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'customerTransition',
                projectId: (0, $95tqy.getProjectId)(store.getState(), payload.portalId)
            });
            successEvent && (0, $keOG0.legacySendEvent)(successEvent);
            return (0, $gEejF.fetchRequestDetailsModel)({
                portalId: payload.portalId,
                key: payload.requestKey
            });
        }).catch((error)=>{
            var _payload$createAnalyt2;
            const failEvent = (_payload$createAnalyt2 = payload.createAnalyticsEvent) === null || _payload$createAnalyt2 === void 0 ? void 0 : _payload$createAnalyt2.call(payload, {
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'customerTransition'
            });
            failEvent && (0, $keOG0.legacySendEvent)(failEvent);
            return (0, $b0T1M.Observable).of((0, $gEejF.transitionRequestFailure)((0, $fI5Sq.getJiraErrorOrDefault)(error)));
        });
    });
};

});
parcelRegister("fuQW5", function(module, exports) {
$parcel$export(module.exports, "transition", () => $5c8f1e06d015dcdb$export$66bb15e2994e6a26);

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $5c8f1e06d015dcdb$export$66bb15e2994e6a26 = (issueKey, transitionId, comment, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/customer/requests/transition`;
    const body = {
        issueKey: issueKey,
        transitionId: transitionId,
        comment: comment
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.put)(uri, body, headers);
};

});

parcelRegister("laOAz", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => (parcelRequire("95tqy")).getPortalAnalyticAttributes);
$parcel$export(module.exports, "getName", () => (parcelRequire("95tqy")).getName);
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("95tqy")).getLogoUrl);
$parcel$export(module.exports, "getDescription", () => (parcelRequire("95tqy")).getDescription);
$parcel$export(module.exports, "getCategories", () => (parcelRequire("95tqy")).getCategories);
$parcel$export(module.exports, "getCategory", () => (parcelRequire("95tqy")).getCategory);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("95tqy")).getIsKbEnabled);
$parcel$export(module.exports, "getIsKbServer", () => (parcelRequire("95tqy")).getIsKbServer);
$parcel$export(module.exports, "getIsPortalLoaded", () => (parcelRequire("95tqy")).getIsPortalLoaded);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("95tqy")).getProjectId);
$parcel$export(module.exports, "getProjectKey", () => (parcelRequire("95tqy")).getProjectKey);
$parcel$export(module.exports, "getPortalRequestGroups", () => (parcelRequire("95tqy")).getPortalRequestGroups);
$parcel$export(module.exports, "getPortalRequestTypes", () => (parcelRequire("95tqy")).getPortalRequestTypes);
$parcel$export(module.exports, "getPortalRequestType", () => (parcelRequire("95tqy")).getPortalRequestType);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => (parcelRequire("95tqy")).getPortalRequestTypesForRequestGroup);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => (parcelRequire("95tqy")).getPortalRequestTypesNotInRequestGroup);
$parcel$export(module.exports, "getPortal", () => (parcelRequire("95tqy")).getPortal);
$parcel$export(module.exports, "getPortalOrError", () => (parcelRequire("95tqy")).getPortalOrError);
$parcel$export(module.exports, "getPortalAnnouncement", () => (parcelRequire("95tqy")).getPortalAnnouncement);
$parcel$export(module.exports, "getCanAdministerProject", () => (parcelRequire("95tqy")).getCanAdministerProject);
$parcel$export(module.exports, "getIsProjectSimplified", () => (parcelRequire("95tqy")).getIsProjectSimplified);
$parcel$export(module.exports, "getPortalLink", () => (parcelRequire("95tqy")).getPortalLink);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => (parcelRequire("95tqy")).getRequestGroupsForRequestType);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => (parcelRequire("95tqy")).getIsRequestTypeBelongsToGroup);
$parcel$export(module.exports, "canCreateRequest", () => (parcelRequire("95tqy")).canCreateRequest);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => (parcelRequire("95tqy")).getPortalAnnouncementPersisted);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => (parcelRequire("95tqy")).getPortalAnnouncementsUI);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("95tqy")).isSaveInProgress);
$parcel$export(module.exports, "isSaveFailed", () => (parcelRequire("95tqy")).isSaveFailed);
$parcel$export(module.exports, "getServiceDeskId", () => (parcelRequire("95tqy")).getServiceDeskId);
$parcel$export(module.exports, "getKbSuggestions", () => (parcelRequire("95tqy")).getKbSuggestions);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => (parcelRequire("95tqy")).getKbLinkDomainURLs);
$parcel$export(module.exports, "getMediaApiUploadToken", () => (parcelRequire("95tqy")).getMediaApiUploadToken);
$parcel$export(module.exports, "getMediaApiError", () => (parcelRequire("95tqy")).getMediaApiError);

var $95tqy = parcelRequire("95tqy");

});
parcelRegister("95tqy", function(module, exports) {
$parcel$export(module.exports, "getPortalAnalyticAttributes", () => $aa54b5e08b53f968$export$c60f1a869d2c2c74);
$parcel$export(module.exports, "getPortal", () => $aa54b5e08b53f968$export$e16cb606b6ef4a60);
$parcel$export(module.exports, "getName", () => $aa54b5e08b53f968$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getLogoUrl", () => $aa54b5e08b53f968$export$976f80239b15365);
$parcel$export(module.exports, "getDescription", () => $aa54b5e08b53f968$export$67580b1c13935958);
$parcel$export(module.exports, "getIsPortalLoaded", () => $aa54b5e08b53f968$export$bf5e3f9152d94e3b);
$parcel$export(module.exports, "getPortalRequestGroups", () => $aa54b5e08b53f968$export$78d9d04100263c2d);
$parcel$export(module.exports, "getPortalRequestTypes", () => $aa54b5e08b53f968$export$64da133fb6380f70);
$parcel$export(module.exports, "getPortalRequestType", () => $aa54b5e08b53f968$export$d1bf58a210f1b84e);
$parcel$export(module.exports, "getPortalRequestTypesForRequestGroup", () => $aa54b5e08b53f968$export$4965f91d890eed3b);
$parcel$export(module.exports, "getRequestGroupsForRequestType", () => $aa54b5e08b53f968$export$5a1e358eca2c7b0a);
$parcel$export(module.exports, "getIsRequestTypeBelongsToGroup", () => $aa54b5e08b53f968$export$2f20ba1ff04c787e);
$parcel$export(module.exports, "getPortalRequestTypesNotInRequestGroup", () => $aa54b5e08b53f968$export$3e60634ba4e73f5f);
$parcel$export(module.exports, "getProjectKey", () => $aa54b5e08b53f968$export$667f2a0f99c75faa);
$parcel$export(module.exports, "getProjectId", () => $aa54b5e08b53f968$export$89040d072f281f85);
$parcel$export(module.exports, "getPortalOrError", () => $aa54b5e08b53f968$export$aa66ead34639a340);
$parcel$export(module.exports, "getIsKbEnabled", () => $aa54b5e08b53f968$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getIsKbServer", () => $aa54b5e08b53f968$export$62e14b755e26ac1e);
$parcel$export(module.exports, "getKbLinkDomainURLs", () => $aa54b5e08b53f968$export$8f367c2862b9eaf4);
$parcel$export(module.exports, "getPortalAnnouncement", () => $aa54b5e08b53f968$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $aa54b5e08b53f968$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $aa54b5e08b53f968$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $aa54b5e08b53f968$export$7a0f33e8df10bd94);
$parcel$export(module.exports, "getCategory", () => $aa54b5e08b53f968$export$410364bbb673ddbc);
$parcel$export(module.exports, "getPortalLink", () => $aa54b5e08b53f968$export$ed7921430af91c7c);
$parcel$export(module.exports, "canCreateRequest", () => $aa54b5e08b53f968$export$f609845398295f39);
$parcel$export(module.exports, "getPortalAnnouncementPersisted", () => $aa54b5e08b53f968$export$65fec43abdb7eb83);
$parcel$export(module.exports, "getPortalAnnouncementsUI", () => $aa54b5e08b53f968$export$bf2c3b9a218e4a01);
$parcel$export(module.exports, "isSaveInProgress", () => $aa54b5e08b53f968$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isSaveFailed", () => $aa54b5e08b53f968$export$3620a86b3ad94622);
$parcel$export(module.exports, "getServiceDeskId", () => $aa54b5e08b53f968$export$f65464f8f75f45bc);
$parcel$export(module.exports, "getKbSuggestions", () => $aa54b5e08b53f968$export$e8626520ddba5456);
$parcel$export(module.exports, "getMediaApiUploadToken", () => $aa54b5e08b53f968$export$b87c6f04552c18ef);
$parcel$export(module.exports, "getMediaApiError", () => $aa54b5e08b53f968$export$ddddbd1696231d6a);

var $63sfu = parcelRequire("63sfu");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");
const $aa54b5e08b53f968$export$c60f1a869d2c2c74 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.analyticAttributes;
};
const $aa54b5e08b53f968$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.name;
};
const $aa54b5e08b53f968$export$976f80239b15365 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.logoUrl;
};
const $aa54b5e08b53f968$export$67580b1c13935958 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.description;
};
const $aa54b5e08b53f968$export$bf5e3f9152d94e3b = (state, portalId)=>!!$aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
const $aa54b5e08b53f968$export$78d9d04100263c2d = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqGroups : [];
};
const $aa54b5e08b53f968$export$8a8ef1c92929d685 = (state, portalId, requestGroupId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    if (!portal) return undefined;
    const requestGroupWithId = portal.reqGroups.find((reqGroup)=>reqGroup.id === requestGroupId);
    return requestGroupWithId;
};
const $aa54b5e08b53f968$export$64da133fb6380f70 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.reqTypes : [];
};
const $aa54b5e08b53f968$export$d1bf58a210f1b84e = (state, portalId, requestTypeId)=>{
    if ((0, $63sfu.isNil)(portalId) || (0, $63sfu.isNil)(requestTypeId)) return undefined;
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal && portal.reqTypes.find((reqType)=>reqType.id === String(requestTypeId));
};
const $aa54b5e08b53f968$export$4965f91d890eed3b = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $aa54b5e08b53f968$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $aa54b5e08b53f968$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return [];
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesInGroup = reqTypesIdsInSelectedGroup// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .map((id)=>allRequestTypesInPortal.find((rt)=>rt.id === id)).filter(Boolean);
    return requestTypesInGroup;
};
const $aa54b5e08b53f968$export$5a1e358eca2c7b0a = ({ state: state, portalId: portalId, requestTypeId: requestTypeId })=>{
    const requestGroups = $aa54b5e08b53f968$export$78d9d04100263c2d(state, portalId);
    return requestGroups.filter((group)=>group.reqTypes.includes(String(requestTypeId)));
};
const $aa54b5e08b53f968$export$2f20ba1ff04c787e = (state, portalId, requestGroupId, requestTypeId)=>{
    const requestGroups = $aa54b5e08b53f968$export$5a1e358eca2c7b0a({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return (requestGroups || []).filter((requestGroup)=>requestGroup.id === requestGroupId).length > 0;
};
const $aa54b5e08b53f968$export$3e60634ba4e73f5f = (state, portalId, requestGroupId)=>{
    const allRequestTypesInPortal = $aa54b5e08b53f968$export$64da133fb6380f70(state, portalId);
    const selectedRequestGroup = $aa54b5e08b53f968$export$8a8ef1c92929d685(state, portalId, requestGroupId);
    if (!selectedRequestGroup) return allRequestTypesInPortal;
    const { reqTypes: reqTypesIdsInSelectedGroup } = selectedRequestGroup;
    const requestTypesNotInSelectedGroup = allRequestTypesInPortal.filter(({ id: idInPortal })=>// only include request types that are not in the specified group
        !reqTypesIdsInSelectedGroup.some((idInGroup)=>idInGroup === idInPortal));
    return requestTypesNotInSelectedGroup;
};
const $aa54b5e08b53f968$export$667f2a0f99c75faa = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && portal.projectKey && portal.projectKey.toUpperCase();
};
const $aa54b5e08b53f968$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $63sfu.isNil)(portalId)) return undefined;
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $aa54b5e08b53f968$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $63sfu.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $aa54b5e08b53f968$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $aa54b5e08b53f968$export$d56e4bff0fec91ad = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return !!portal && !!portal.knowledgeBase;
};
const $aa54b5e08b53f968$export$62e14b755e26ac1e = (state, portalId)=>{
    var _portal$knowledgeBase;
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return Boolean(portal === null || portal === void 0 || (_portal$knowledgeBase = portal.knowledgeBase) === null || _portal$knowledgeBase === void 0 || (_portal$knowledgeBase = _portal$knowledgeBase.kbLink) === null || _portal$knowledgeBase === void 0 ? void 0 : _portal$knowledgeBase.isServer);
};
const $aa54b5e08b53f968$export$8f367c2862b9eaf4 = (state, portalId)=>{
    var _portal$knowledgeBase2;
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return (portal === null || portal === void 0 || (_portal$knowledgeBase2 = portal.knowledgeBase) === null || _portal$knowledgeBase2 === void 0 ? void 0 : _portal$knowledgeBase2.kbLinkDomainURLs) || [];
};
const $aa54b5e08b53f968$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $aa54b5e08b53f968$export$b88ee522e5c6bc90 = (state, portalId)=>{
    const portalAnnouncement = $aa54b5e08b53f968$export$78e1a2ab89c0908b(state, portalId);
    return !!portalAnnouncement && portalAnnouncement.canEditAnnouncement;
};
const $aa54b5e08b53f968$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $aa54b5e08b53f968$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement && portalAnnouncement.canAdministerProject;
};
const $aa54b5e08b53f968$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.isProjectSimplified : undefined;
};
const $aa54b5e08b53f968$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};
const $aa54b5e08b53f968$export$410364bbb673ddbc = (state, portalId, categoryId)=>{
    if (!categoryId || !portalId) return undefined;
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        if (Array.isArray(categoryOrError)) return categoryOrError.find((category)=>category.id === categoryId);
        return categoryOrError;
    }
    return undefined;
};
const $aa54b5e08b53f968$export$ed7921430af91c7c = (state, portalId)=>{
    const requestGroups = $aa54b5e08b53f968$export$78d9d04100263c2d(state, portalId);
    // If the user has exactly 1 request group and request type, we link them directly to that form.
    // Otherwise we direct them to the request groups
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    let portalLink = `/portal/${portalId}/group/-1`;
    if (requestGroups.length === 1) {
        const [requestGroup] = requestGroups;
        if (requestGroup.reqTypes.length === 1) {
            const [requestTypeId] = requestGroup.reqTypes;
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            portalLink = `/portal/${portalId}/group/${requestGroup.id}/create/${requestTypeId}`;
        }
    }
    return portalLink;
};
const $aa54b5e08b53f968$export$f609845398295f39 = (state, portalId)=>{
    if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) return false;
    return Object.keys($aa54b5e08b53f968$export$78d9d04100263c2d(state, Number(portalId))).length > 0;
};
const $aa54b5e08b53f968$export$65fec43abdb7eb83 = (state, payload)=>{
    const portalAnnouncement = $aa54b5e08b53f968$export$78e1a2ab89c0908b(state, payload === null || payload === void 0 ? void 0 : payload.portalId);
    return portalAnnouncement ? portalAnnouncement : undefined;
};
const $aa54b5e08b53f968$export$bf2c3b9a218e4a01 = (state)=>state.ui.portals.portalAnnouncementsResponse;
const $aa54b5e08b53f968$export$2b75ac2de7a23db1 = (state)=>state.ui.portals.isSaveInProgress;
const $aa54b5e08b53f968$export$3620a86b3ad94622 = (state)=>state.ui.portals.isSaveFailed;
const $aa54b5e08b53f968$export$f65464f8f75f45bc = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.serviceDeskId;
};
const $aa54b5e08b53f968$export$e8626520ddba5456 = (state, portalId)=>{
    var _portal$knowledgeBase3;
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    const kbSuggestions = portal && !('error' in portal) && ((_portal$knowledgeBase3 = portal.knowledgeBase) === null || _portal$knowledgeBase3 === void 0 ? void 0 : _portal$knowledgeBase3.kbArticleSuggestions);
    if (kbSuggestions === false || kbSuggestions === undefined) return [];
    return kbSuggestions;
};
const $aa54b5e08b53f968$export$b87c6f04552c18ef = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiUploadToken;
};
const $aa54b5e08b53f968$export$ddddbd1696231d6a = (state, portalId)=>{
    const portal = $aa54b5e08b53f968$export$e16cb606b6ef4a60(state, portalId);
    return portal === null || portal === void 0 ? void 0 : portal.mediaApiError;
};

});



parcelRegister("iSMxf", function(module, exports) {
$parcel$export(module.exports, "requestGroupsEpic", () => $e46fbd0fb467be09$export$194ec9e5a7b72182);
parcelRequire("lbln8");
var $4akjj = parcelRequire("4akjj");

var $1UqLs = parcelRequire("1UqLs");

var $gW6uZ = parcelRequire("gW6uZ");

var $8pKd8 = parcelRequire("8pKd8");

var $cINVU = parcelRequire("cINVU");
const $e46fbd0fb467be09$export$194ec9e5a7b72182 = (0, $4akjj.combineEpics)((0, $1UqLs.addRequestGroupEpic), (0, $cINVU.reorderRequestGroupEpic), (0, $8pKd8.removeRequestGroupEpic), (0, $gW6uZ.getAllRequestGroupsEpic));

});
parcelRegister("1UqLs", function(module, exports) {
$parcel$export(module.exports, "addRequestGroupEpic", () => $371f50a558a6e3bf$export$8362a74d5020b3ae);

var $b0T1M = parcelRequire("b0T1M");

var $lYwo6 = parcelRequire("lYwo6");
parcelRequire("3hIYf");
var $5glmA = parcelRequire("5glmA");
parcelRequire("5eWkp");
var $5sVYY = parcelRequire("5sVYY");

var $fI5Sq = parcelRequire("fI5Sq");

var $keOG0 = parcelRequire("keOG0");
const $371f50a558a6e3bf$export$8362a74d5020b3ae = (action$)=>{
    return action$.ofType((0, $5glmA.ADD_REQUEST_GROUP)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId, groupName: groupName, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        return (0, $lYwo6.addRequestGroup)(groupName, projectId).map((response)=>{
            if (analyticsEvent) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEvent.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $keOG0.legacySendEvent)(analyticsEvent);
            }
            return (0, $5sVYY.getRequestGroupsAction)(projectId, portalId);
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $keOG0.legacySendEvent)(analyticsFailureEvent);
            return (0, $b0T1M.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $5glmA.addRequestGroupFailedAction)((0, $fI5Sq.getFirstMessageFromJiraError)(error.response), groupName));
        });
    });
};

});
parcelRegister("lYwo6", function(module, exports) {
$parcel$export(module.exports, "addRequestGroup", () => $4221647cd4d9528e$export$2a108ddc24673b82);
$parcel$export(module.exports, "updateRequestGroup", () => $4221647cd4d9528e$export$6343ebb5dbd23e24);
$parcel$export(module.exports, "fetchAllRequestGroups", () => $4221647cd4d9528e$export$1baf2ae38689e29e);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $4221647cd4d9528e$export$2a108ddc24673b82 = (name, projectId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $lVFX8.post)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $5geAe.Observable).throw(e);
    });
};
const $4221647cd4d9528e$export$6343ebb5dbd23e24 = ({ name: name, projectId: projectId, requestGroupId: requestGroupId, context: context = (0, $3wR8f.contextPath) })=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}`;
    return (0, $lVFX8.put)(uri, {
        name: name
    }, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $5geAe.Observable).throw(e));
};
const $4221647cd4d9528e$export$1baf2ae38689e29e = (projectId, context = (0, $3wR8f.contextPath))=>{
    const uri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    return (0, $lVFX8.get)(uri)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $5geAe.Observable).throw(e));
};

});

parcelRegister("3hIYf", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => (parcelRequire("5glmA")).ADD_REQUEST_GROUP);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => (parcelRequire("5glmA")).ADD_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestGroupAction", () => (parcelRequire("5glmA")).addRequestGroupAction);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => (parcelRequire("5glmA")).addRequestGroupFailedAction);

var $5glmA = parcelRequire("5glmA");

});
parcelRegister("5glmA", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_GROUP", () => $1441f6b17f6e6324$export$8e1d62e25202aae2);
$parcel$export(module.exports, "ADD_REQUEST_GROUP_FAILED", () => $1441f6b17f6e6324$export$3098f04a186c7a1a);
$parcel$export(module.exports, "addRequestGroupAction", () => $1441f6b17f6e6324$export$207b3b17fddc56c6);
$parcel$export(module.exports, "addRequestGroupFailedAction", () => $1441f6b17f6e6324$export$668bfa1c007e18ef);
const $1441f6b17f6e6324$export$8e1d62e25202aae2 = 'epic.request-groups.ADD_REQUEST_GROUP';
const $1441f6b17f6e6324$export$3098f04a186c7a1a = 'epic.request-groups.ADD_REQUEST_GROUP_FAILED';
const $1441f6b17f6e6324$export$207b3b17fddc56c6 = (payload)=>({
        payload: payload,
        type: $1441f6b17f6e6324$export$8e1d62e25202aae2
    });
const $1441f6b17f6e6324$export$668bfa1c007e18ef = (message, groupNameThatCausedError)=>({
        payload: {
            message: message,
            groupNameThatCausedError: groupNameThatCausedError
        },
        type: $1441f6b17f6e6324$export$3098f04a186c7a1a
    });

});


parcelRegister("5eWkp", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => (parcelRequire("5sVYY")).GET_ALL_REQUEST_GROUPS);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => (parcelRequire("5sVYY")).GET_ALL_REQUEST_GROUPS_FAILURE);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => (parcelRequire("5sVYY")).GET_ALL_REQUEST_GROUPS_SUCCESS);
$parcel$export(module.exports, "getRequestGroupsAction", () => (parcelRequire("5sVYY")).getRequestGroupsAction);
$parcel$export(module.exports, "getRequestGroupsFailure", () => (parcelRequire("5sVYY")).getRequestGroupsFailure);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => (parcelRequire("5sVYY")).getRequestGroupsSuccess);
parcelRequire("5sVYY");

});
parcelRegister("5sVYY", function(module, exports) {
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS", () => $59a622e1952fb6c2$export$4385e1518ec9ee53);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_SUCCESS", () => $59a622e1952fb6c2$export$b61d00db9e210ef);
$parcel$export(module.exports, "GET_ALL_REQUEST_GROUPS_FAILURE", () => $59a622e1952fb6c2$export$80b563f5e425073f);
$parcel$export(module.exports, "getRequestGroupsAction", () => $59a622e1952fb6c2$export$9c0c7a1030efe8de);
$parcel$export(module.exports, "getRequestGroupsSuccess", () => $59a622e1952fb6c2$export$c1f5fa36efe1c1c7);
$parcel$export(module.exports, "getRequestGroupsFailure", () => $59a622e1952fb6c2$export$a8d060d6575e9dfb);
const $59a622e1952fb6c2$export$4385e1518ec9ee53 = 'epic.request-groups.GET_ALL_REQUEST_GROUPS';
const $59a622e1952fb6c2$export$b61d00db9e210ef = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_SUCCESS';
const $59a622e1952fb6c2$export$80b563f5e425073f = 'epic.request-groups.GET_ALL_REQUEST_GROUPS_FAILURE';
const $59a622e1952fb6c2$export$9c0c7a1030efe8de = (projectId, portalId)=>({
        payload: {
            projectId: projectId,
            portalId: portalId
        },
        type: $59a622e1952fb6c2$export$4385e1518ec9ee53
    });
const $59a622e1952fb6c2$export$c1f5fa36efe1c1c7 = (payload)=>({
        payload: payload,
        type: $59a622e1952fb6c2$export$b61d00db9e210ef
    });
const $59a622e1952fb6c2$export$a8d060d6575e9dfb = (payload)=>({
        payload: payload,
        type: $59a622e1952fb6c2$export$80b563f5e425073f
    });

});



parcelRegister("gW6uZ", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsEpic", () => $c057db94a65e5f5f$export$53dc813939b78da1);

var $5geAe = parcelRequire("5geAe");

var $lYwo6 = parcelRequire("lYwo6");
parcelRequire("5eWkp");
var $5sVYY = parcelRequire("5sVYY");

var $fI5Sq = parcelRequire("fI5Sq");
const $c057db94a65e5f5f$export$53dc813939b78da1 = (action$)=>action$.ofType((0, $5sVYY.GET_ALL_REQUEST_GROUPS)).mergeMap((action)=>{
        const { projectId: projectId, portalId: portalId } = action.payload;
        return (0, $lYwo6.fetchAllRequestGroups)(projectId).map((requestGroups)=>(0, $5sVYY.getRequestGroupsSuccess)({
                portalId: portalId,
                requestGroups: requestGroups
            })).catch((e)=>{
            const errorMessage = (0, $fI5Sq.getFirstMessageFromJiraError)(e.response);
            return (0, $5geAe.Observable).of((0, $5sVYY.getRequestGroupsFailure)({
                errorMessage: errorMessage,
                projectId: projectId
            }));
        });
    });

});

parcelRegister("8pKd8", function(module, exports) {
$parcel$export(module.exports, "removeRequestGroupEpic", () => $4491dda4c3dd5371$export$7a528fd4d213cd7);

var $b0T1M = parcelRequire("b0T1M");

var $7ZaED = parcelRequire("7ZaED");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("5N1Bu");
var $dNnO3 = parcelRequire("dNnO3");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $keOG0 = parcelRequire("keOG0");
const $4491dda4c3dd5371$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $4491dda4c3dd5371$export$7a528fd4d213cd7 = (action$, store)=>{
    return action$.ofType((0, $dNnO3.REMOVE_REQUEST_GROUP)).mergeMap(({ payload: { portalId: portalId, deletedId: deletedId, onRemoveGroupSuccess: onRemoveGroupSuccess, onRemoveGroupError: onRemoveGroupError, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $95tqy.getProjectId)(state, portalId);
        const requestGroups = (0, $95tqy.getPortalRequestGroups)(state, portalId);
        const newOrder = requestGroups.map(({ id: id })=>id).filter((id)=>id !== deletedId);
        // Perform the rest call to update groups
        return (0, $7ZaED.requestGroupReorder)({
            projectId: projectId,
            order: newOrder,
            id: $4491dda4c3dd5371$var$REQUEST_ID,
            deleted: [
                deletedId
            ],
            inline: true
        })// On success, refresh the model
        .map(()=>{
            analyticsEvent && (0, $keOG0.legacySendEvent)(analyticsEvent);
            if (onRemoveGroupSuccess) onRemoveGroupSuccess();
            return (0, $lXazD.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        })// On fail, clear the ui state to reverse optimistic update
        .catch(()=>{
            if (onRemoveGroupError) onRemoveGroupError();
            if (analyticsFailureEvent) (0, $keOG0.legacySendEvent)(analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $dNnO3.removeRequestGroupFailedAction)());
        });
    });
};

});
parcelRegister("7ZaED", function(module, exports) {
$parcel$export(module.exports, "requestGroupReorder", () => $e602c3b202aba79a$export$e26022a90e227660);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");
const $e602c3b202aba79a$export$e26022a90e227660 = ({ id: id, deleted: deleted, order: order, inline: inline, projectId: projectId })=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups`;
    const body = {
        id: id,
        deleted: deleted,
        order: order,
        inline: inline
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.put)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>{
        return (0, $b0T1M.Observable).throw(e);
    });
};

});

parcelRegister("5N1Bu", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => (parcelRequire("dNnO3")).REMOVE_REQUEST_GROUP);
$parcel$export(module.exports, "removeRequestGroupAction", () => (parcelRequire("dNnO3")).removeRequestGroupAction);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => (parcelRequire("dNnO3")).removeRequestGroupFailedAction);

var $dNnO3 = parcelRequire("dNnO3");

});
parcelRegister("dNnO3", function(module, exports) {
$parcel$export(module.exports, "REMOVE_REQUEST_GROUP", () => $84cbb4c6b7161735$export$7aaaf575c1ef21c8);
$parcel$export(module.exports, "removeRequestGroupAction", () => $84cbb4c6b7161735$export$fe2120d3bdfd11a7);
$parcel$export(module.exports, "removeRequestGroupFailedAction", () => $84cbb4c6b7161735$export$35f1f33f6fdb929d);
const $84cbb4c6b7161735$export$7aaaf575c1ef21c8 = 'epic.request-groups.REMOVE_REQUEST_GROUP';
const $84cbb4c6b7161735$var$REMOVE_REQUEST_GROUP_FAILED = 'epic.request-groups.REMOVE_REQUEST_GROUP_FAILED';
const $84cbb4c6b7161735$export$fe2120d3bdfd11a7 = (payload)=>{
    return {
        payload: payload,
        type: $84cbb4c6b7161735$export$7aaaf575c1ef21c8
    };
};
const $84cbb4c6b7161735$export$35f1f33f6fdb929d = ()=>{
    return {
        type: $84cbb4c6b7161735$var$REMOVE_REQUEST_GROUP_FAILED
    };
};

});



parcelRegister("cINVU", function(module, exports) {
$parcel$export(module.exports, "reorderRequestGroupEpic", () => $5180420743c9865d$export$691172c527fd88df);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $7ZaED = parcelRequire("7ZaED");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("5pors");
var $1wRjC = parcelRequire("1wRjC");
parcelRequire("5eWkp");
var $5sVYY = parcelRequire("5sVYY");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("bOPUR");
var $gc9yt = parcelRequire("gc9yt");

var $keOG0 = parcelRequire("keOG0");
const $5180420743c9865d$var$REQUEST_ID = 'com.atlassian.servicedesk.portal-ui:customize-portal-sidebar';
const $5180420743c9865d$export$691172c527fd88df = (action$, store)=>{
    return action$.ofType((0, $1wRjC.UPDATE_REQUEST_GROUPS_ORDER))// User may perform updates (reorders and deletes) rapidly but we want to minimise unnecessary REST calls
    // We could debounce but we want ALL the analytics events so instead we buffer, get ALL the analytics events
    // and then just process the most recent event and if successful fire ALL analytics events
    .bufferTime(500).mergeMap((bufferedActions)=>{
        // First, create list of buffered analytic events (ALL will be fired if `update request groups` REST call is successful)
        const analyticsEvents = bufferedActions.map((action)=>action.payload.analyticsEvent).filter(Boolean);
        const analyticsFailureEvents = bufferedActions.map((action)=>action.payload.analyticsFailureEvent).filter(Boolean);
        // Second, pop the most recently published action
        const mostRecentAction = bufferedActions.pop();
        if (!mostRecentAction) return (0, $b0T1M.Observable).empty();
        const { portalId: portalId, order: order } = mostRecentAction.payload;
        const state = store.getState();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const projectId = (0, $95tqy.getProjectId)(state, portalId);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const requestGroups = (0, $gc9yt.getUIRequestGroups)(state, portalId);
        const deletedIds = requestGroups.map(({ id: id })=>id).filter((id)=>!order.includes(id));
        // Perform the rest call to update groups
        return (0, $7ZaED.requestGroupReorder)({
            projectId: projectId,
            order: order,
            deleted: deletedIds,
            id: $5180420743c9865d$var$REQUEST_ID,
            inline: true
        })// On success, refresh the model
        .mergeMap(()=>{
            // Success; fire ALL analytics events
            analyticsEvents.forEach((0, $keOG0.legacySendEvent));
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $5sVYY.getRequestGroupsAction)(projectId, portalId)), (0, $b0T1M.Observable).of((0, $lXazD.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            })));
        })// On fail, clear the ui state to reverse optimistic update
        .catch((_)=>{
            analyticsFailureEvents.forEach((0, $keOG0.legacySendEvent));
            return (0, $b0T1M.Observable).of((0, $1wRjC.clearRequestGroupsOrderAction)());
        });
    });
};

});
parcelRegister("5pors", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => (parcelRequire("1wRjC")).UPDATE_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => (parcelRequire("1wRjC")).CLEAR_REQUEST_GROUPS_ORDER);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => (parcelRequire("1wRjC")).CLEAR_ERROR_MESSAGE);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => (parcelRequire("1wRjC")).CLEAR_REQUEST_TYPES_ORDER);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => (parcelRequire("1wRjC")).updateRequestGroupsOrderAction);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => (parcelRequire("1wRjC")).clearRequestGroupsOrderAction);
$parcel$export(module.exports, "clearErrorMessageAction", () => (parcelRequire("1wRjC")).clearErrorMessageAction);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => (parcelRequire("1wRjC")).clearRequestTypesOrderAction);

var $1wRjC = parcelRequire("1wRjC");

});
parcelRegister("1wRjC", function(module, exports) {
$parcel$export(module.exports, "UPDATE_REQUEST_GROUPS_ORDER", () => $0a96f3c0f303b3a6$export$3206afd0265da736);
$parcel$export(module.exports, "CLEAR_REQUEST_GROUPS_ORDER", () => $0a96f3c0f303b3a6$export$cef961ec6e406565);
$parcel$export(module.exports, "CLEAR_ERROR_MESSAGE", () => $0a96f3c0f303b3a6$export$954b6cd4735c91da);
$parcel$export(module.exports, "CLEAR_REQUEST_TYPES_ORDER", () => $0a96f3c0f303b3a6$export$896c4eec286cc76c);
$parcel$export(module.exports, "updateRequestGroupsOrderAction", () => $0a96f3c0f303b3a6$export$c362b5f333b2372c);
$parcel$export(module.exports, "clearRequestGroupsOrderAction", () => $0a96f3c0f303b3a6$export$1a19c76107cb4b0c);
$parcel$export(module.exports, "clearErrorMessageAction", () => $0a96f3c0f303b3a6$export$a72b98a8de57346e);
$parcel$export(module.exports, "clearRequestTypesOrderAction", () => $0a96f3c0f303b3a6$export$8e8d01bbfddde092);
const $0a96f3c0f303b3a6$export$3206afd0265da736 = 'state.ui.portal-customisation.UPDATE_REQUEST_GROUPS_ORDER';
const $0a96f3c0f303b3a6$export$cef961ec6e406565 = 'state.ui.portal-customisation.CLEAR_REQUEST_GROUPS_ORDER';
const $0a96f3c0f303b3a6$export$954b6cd4735c91da = 'state.ui.portal-customisation.CLEAR_ERROR_MESSAGE';
const $0a96f3c0f303b3a6$export$896c4eec286cc76c = 'state.ui.portal-customisation.CLEAR_REQUEST_TYPES_ORDER';
const $0a96f3c0f303b3a6$export$c362b5f333b2372c = (payload)=>({
        payload: payload,
        type: $0a96f3c0f303b3a6$export$3206afd0265da736
    });
const $0a96f3c0f303b3a6$export$1a19c76107cb4b0c = ()=>({
        type: $0a96f3c0f303b3a6$export$cef961ec6e406565
    });
const $0a96f3c0f303b3a6$export$a72b98a8de57346e = ()=>({
        type: $0a96f3c0f303b3a6$export$954b6cd4735c91da
    });
const $0a96f3c0f303b3a6$export$8e8d01bbfddde092 = ()=>({
        type: $0a96f3c0f303b3a6$export$896c4eec286cc76c
    });

});


parcelRegister("bOPUR", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => (parcelRequire("gc9yt")).getAllRequestGroupsWithRequestTypesForPortal);
$parcel$export(module.exports, "getErrorMessage", () => (parcelRequire("gc9yt")).getErrorMessage);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => (parcelRequire("gc9yt")).getGroupNameThatCausedError);
$parcel$export(module.exports, "getPortalCustomisationError", () => (parcelRequire("gc9yt")).getPortalCustomisationError);
$parcel$export(module.exports, "getRequestGroupById", () => (parcelRequire("gc9yt")).getRequestGroupById);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => (parcelRequire("gc9yt")).getUIIsParentRequestGroupsLoading);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => (parcelRequire("gc9yt")).getUIParentRequestGroupsForRequestType);
$parcel$export(module.exports, "getUIRequestGroups", () => (parcelRequire("gc9yt")).getUIRequestGroups);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => (parcelRequire("gc9yt")).getUIRequestGroupsOrder);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => (parcelRequire("gc9yt")).getUIRequestGroupsWithRequestTypes);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => (parcelRequire("gc9yt")).getUIRequestTypesInRequestGroupById);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => (parcelRequire("gc9yt")).getUIRequestTypesNotInRequestGroupById);
parcelRequire("gc9yt");

});
parcelRegister("gc9yt", function(module, exports) {
$parcel$export(module.exports, "getAllRequestGroupsWithRequestTypesForPortal", () => $ee4fc4b8b07df452$export$eafd9d6b190f9991);
$parcel$export(module.exports, "getErrorMessage", () => $ee4fc4b8b07df452$export$82f46aa4e6535a45);
$parcel$export(module.exports, "getRequestGroupById", () => $ee4fc4b8b07df452$export$c93f0b0a861dcf03);
$parcel$export(module.exports, "getUIRequestGroupsOrder", () => $ee4fc4b8b07df452$export$13689122403cb761);
$parcel$export(module.exports, "getUIRequestGroups", () => $ee4fc4b8b07df452$export$5b1cb606e38791c6);
$parcel$export(module.exports, "getUIRequestGroupsWithRequestTypes", () => $ee4fc4b8b07df452$export$5d023274645990b2);
$parcel$export(module.exports, "getUIRequestTypesInRequestGroupById", () => $ee4fc4b8b07df452$export$3257afc3359cfce);
$parcel$export(module.exports, "getUIParentRequestGroupsForRequestType", () => $ee4fc4b8b07df452$export$9abf85e04ff9329b);
$parcel$export(module.exports, "getUIIsParentRequestGroupsLoading", () => $ee4fc4b8b07df452$export$1863e442385dba5c);
$parcel$export(module.exports, "getPortalCustomisationError", () => $ee4fc4b8b07df452$export$7b32ab9a7ad364f3);
$parcel$export(module.exports, "getGroupNameThatCausedError", () => $ee4fc4b8b07df452$export$9f49200face9760d);
$parcel$export(module.exports, "getUIRequestTypesNotInRequestGroupById", () => $ee4fc4b8b07df452$export$5f6e3f684cf8395b);
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
/**
 *
 *  Persisted Portal Customisation state selectors
 *
 */ const $ee4fc4b8b07df452$var$withRequestTypesPopulated = (groupsWithTypes)=>(reqGroup)=>{
        const existingReqTypes = groupsWithTypes.find((rg)=>rg.id === reqGroup.id);
        return {
            ...reqGroup,
            reqTypes: !!existingReqTypes ? existingReqTypes.reqTypes : []
        };
    };
const $ee4fc4b8b07df452$export$25ec121fd14d9df3 = (state)=>state.persisted.portalCustomisation.allRequestGroups;
const $ee4fc4b8b07df452$export$514a0edc3b518db9 = (state, portalId)=>{
    const allRequestGroups = $ee4fc4b8b07df452$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return allRequestGroups[portalId];
};
const $ee4fc4b8b07df452$export$eafd9d6b190f9991 = (state, portalId)=>{
    const allRequestGroups = $ee4fc4b8b07df452$export$25ec121fd14d9df3(state);
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!(portalId && allRequestGroups && allRequestGroups[portalId])) return undefined;
    const groupsWithExistingRequestTypes = (0, $95tqy.getPortalRequestGroups)(state, portalId);
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
    const requestGroupsWithRequestTypes = allRequestGroups[portalId].map($ee4fc4b8b07df452$var$withRequestTypesPopulated(groupsWithExistingRequestTypes));
    return requestGroupsWithRequestTypes;
};
const $ee4fc4b8b07df452$export$82f46aa4e6535a45 = (state)=>state.persisted.portalCustomisation.errorMessage;
const $ee4fc4b8b07df452$export$c93f0b0a861dcf03 = (state, portalId, requestGroupId)=>{
    const requestGroups = $ee4fc4b8b07df452$export$eafd9d6b190f9991(state, portalId);
    return !!requestGroups ? requestGroups.find((group)=>group.id === requestGroupId) : undefined;
};
const $ee4fc4b8b07df452$export$13689122403cb761 = (state)=>state.ui.portalCustomisation.requestGroupsOrder;
const $ee4fc4b8b07df452$export$f7da43c7a00426c = (state)=>state.ui.portalCustomisation.requestTypesOrder;
const $ee4fc4b8b07df452$export$5b1cb606e38791c6 = (state, portalId)=>state.ui.portalCustomisation.requestGroups || $ee4fc4b8b07df452$export$514a0edc3b518db9(state, portalId);
const $ee4fc4b8b07df452$export$5d023274645990b2 = (state, portalId)=>state.ui.portalCustomisation.requestGroups ? state.ui.portalCustomisation.requestGroups.map($ee4fc4b8b07df452$var$withRequestTypesPopulated((0, $95tqy.getPortalRequestGroups)(state, portalId))) : $ee4fc4b8b07df452$export$eafd9d6b190f9991(state, portalId);
const $ee4fc4b8b07df452$export$3257afc3359cfce = (state, portalId, requestGroupId)=>{
    let requestTypesInRequestGroup = state.ui.portalCustomisation.requestTypesInRequestGroup || (0, $95tqy.getPortalRequestTypesForRequestGroup)(state, portalId, requestGroupId);
    const requestTypesOrder = $ee4fc4b8b07df452$export$f7da43c7a00426c(state);
    if (requestTypesOrder) requestTypesInRequestGroup = requestTypesOrder.map((requestTypeId)=>requestTypesInRequestGroup.find((rt)=>Number(rt.id) === requestTypeId)).filter(Boolean);
    return requestTypesInRequestGroup;
};
const $ee4fc4b8b07df452$export$9abf85e04ff9329b = (state, portalId, requestTypeId)=>{
    const parentRequestGroups = state.ui.portalCustomisation.parentRequestGroups || (0, $95tqy.getRequestGroupsForRequestType)({
        state: state,
        portalId: portalId,
        requestTypeId: requestTypeId
    });
    return [
        ...parentRequestGroups
    ].sort((first, second)=>first.name.toLowerCase().localeCompare(second.name.toLowerCase()));
};
const $ee4fc4b8b07df452$export$1863e442385dba5c = (state)=>{
    return state.ui.portalCustomisation.isParentRequestGroupsLoading;
};
const $ee4fc4b8b07df452$export$7b32ab9a7ad364f3 = (state)=>state.ui.portalCustomisation.error;
const $ee4fc4b8b07df452$export$9f49200face9760d = (state)=>state.ui.portalCustomisation.groupNameThatCausedError;
const $ee4fc4b8b07df452$export$5f6e3f684cf8395b = (state, portalId, requestGroupId)=>{
    return state.ui.portalCustomisation.requestTypesNotInRequestGroup || (0, $95tqy.getPortalRequestTypesNotInRequestGroup)(state, portalId, requestGroupId);
};

});




parcelRegister("iEcK7", function(module, exports) {
$parcel$export(module.exports, "addRequestTypeToRequestGroupEpic", () => $6f5629fba83567a3$export$7219fe759636c43a);

var $b0T1M = parcelRequire("b0T1M");

var $63sfu = parcelRequire("63sfu");

var $9Zn9X = parcelRequire("9Zn9X");
parcelRequire("bWv0L");
var $bBJtE = parcelRequire("bBJtE");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("bOPUR");
var $gc9yt = parcelRequire("gc9yt");

var $fI5Sq = parcelRequire("fI5Sq");

var $keOG0 = parcelRequire("keOG0");
const $6f5629fba83567a3$var$getAssociatedGroups = (requestType, requestGroup, requestGroups)=>{
    const associatedRequestGroups = (0, $63sfu.uniqBy)(requestGroups, 'id').filter((reqGroup)=>reqGroup.reqTypes.includes(requestType.id));
    // Add group association to request type if not already added
    if (!associatedRequestGroups.includes(requestGroup)) associatedRequestGroups.push(requestGroup);
    return associatedRequestGroups;
};
const $6f5629fba83567a3$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $6f5629fba83567a3$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $6f5629fba83567a3$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroup, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $6f5629fba83567a3$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $6f5629fba83567a3$var$getSanitizedText(requestType.descriptionHtml),
        groups: $6f5629fba83567a3$var$getAssociatedGroups(requestType, requestGroup, requestGroups)
    });
const $6f5629fba83567a3$export$7219fe759636c43a = (action$, store)=>{
    return action$.ofType((0, $bBJtE.ADD_REQUEST_TYPE_TO_REQUEST_GROUP)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroup: requestGroup, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const state = store.getState();
        const requestGroups = (0, $gc9yt.getAllRequestGroupsWithRequestTypesForPortal)(state, portalId) || [];
        return (0, $9Zn9X.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: requestGroup.id,
            requestGroupId: requestGroup.id,
            requestType: $6f5629fba83567a3$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroup, requestGroups)
        }).map(()=>{
            analyticsEvent && (0, $keOG0.legacySendEvent)(analyticsEvent);
            return (0, $lXazD.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $keOG0.legacySendEvent)(analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $bBJtE.addRequestTypeToRequestGroupFailedAction)((0, $fI5Sq.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("9Zn9X", function(module, exports) {
$parcel$export(module.exports, "setRequestGroupsForRequestType", () => $0b467a4de9cd29e9$export$9067d57db9e6b38e);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");
const $0b467a4de9cd29e9$export$9067d57db9e6b38e = ({ isProjectSimplified: isProjectSimplified, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroupId: requestGroupId, projectId: projectId, context: context = (0, $3wR8f.contextPath) })=>{
    if (isProjectSimplified) {
        const nextGenUri = (groupId)=>`${context}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${groupId}/${requestType.id}`;
        const isAdded = requestType.groups.some(({ id: id })=>id === updatedRequestTypeGroupId);
        const httpMethod = isAdded ? (0, $lVFX8.put) : (0, $lVFX8.doDelete);
        return httpMethod(nextGenUri(updatedRequestTypeGroupId))// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        .map(({ response: response })=>response).catch((e)=>{
            // Rethrow error
            return (0, $b0T1M.Observable).throw(e);
        });
    }
    // In Classic:
    // The request type <-> group association is stored on a request type in the backend
    // We call the update request type endpoint with the request type in the body with the new group associsation
    const classicUri = `${context}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestType.id}`;
    return (0, $lVFX8.put)(classicUri, requestType, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>{
        // Rethrow error
        return (0, $b0T1M.Observable).throw(e);
    });
};

});

parcelRegister("bWv0L", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => (parcelRequire("bBJtE")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => (parcelRequire("bBJtE")).addRequestTypeToRequestGroupAction);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => (parcelRequire("bBJtE")).ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => (parcelRequire("bBJtE")).addRequestTypeToRequestGroupFailedAction);

var $bBJtE = parcelRequire("bBJtE");

});
parcelRegister("bBJtE", function(module, exports) {
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP", () => $a9e854ade5a68501$export$eb48643df0521b0d);
$parcel$export(module.exports, "addRequestTypeToRequestGroupAction", () => $a9e854ade5a68501$export$196767c05c5a3485);
$parcel$export(module.exports, "ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED", () => $a9e854ade5a68501$export$e0f4630e32187ebc);
$parcel$export(module.exports, "addRequestTypeToRequestGroupFailedAction", () => $a9e854ade5a68501$export$87cedd1ffa234cc5);
const $a9e854ade5a68501$export$eb48643df0521b0d = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP';
const $a9e854ade5a68501$export$196767c05c5a3485 = (payload)=>{
    return {
        payload: payload,
        type: $a9e854ade5a68501$export$eb48643df0521b0d
    };
};
const $a9e854ade5a68501$var$ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_SUCCEEDED';
const $a9e854ade5a68501$export$e0f4630e32187ebc = 'state.ui.request-types.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED';
const $a9e854ade5a68501$export$87cedd1ffa234cc5 = (message)=>({
        payload: {
            message: message
        },
        type: $a9e854ade5a68501$export$e0f4630e32187ebc
    });

});



parcelRegister("5WdyL", function(module, exports) {
$parcel$export(module.exports, "createGroupWithRequestTypeEpic", () => $5d17238607f8bd6d$export$2d5fcba5bbcf0933);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $lYwo6 = parcelRequire("lYwo6");
parcelRequire("3Sl7d");
var $jcEEo = parcelRequire("jcEEo");
parcelRequire("5eWkp");
var $5sVYY = parcelRequire("5sVYY");
parcelRequire("joL0M");
var $8pWZm = parcelRequire("8pWZm");

var $fI5Sq = parcelRequire("fI5Sq");

var $keOG0 = parcelRequire("keOG0");
const $5d17238607f8bd6d$export$2d5fcba5bbcf0933 = (action$)=>{
    return action$.ofType((0, $jcEEo.CREATE_GROUP_WITH_REQUEST_TYPE)).mergeMap((action)=>{
        const { isProjectSimplified: isProjectSimplified, projectId: projectId, portalId: portalId, groupName: groupName, analyticsEventRequestGroupCreated: analyticsEventRequestGroupCreated, analyticsEventRequestGroupUpdated: analyticsEventRequestGroupUpdated, requestType: requestType, requestGroups: requestGroups, analyticsEventRequestGroupCreatedFailure: analyticsEventRequestGroupCreatedFailure, analyticsEventRequestGroupUpdatedFailure: analyticsEventRequestGroupUpdatedFailure } = action.payload;
        return (0, $lYwo6.addRequestGroup)(groupName, projectId).mergeMap((response)=>{
            if (analyticsEventRequestGroupCreated) {
                // Update the analytics event with newly created Request type group's ID as the actionSubjectId
                analyticsEventRequestGroupCreated.update((payload)=>({
                        ...payload,
                        actionSubjectId: response.id
                    }));
                (0, $keOG0.legacySendEvent)(analyticsEventRequestGroupCreated);
            }
            if (analyticsEventRequestGroupUpdated) // Update the analytics event with newly created Request type group's ID as the actionSubjectId
            analyticsEventRequestGroupUpdated.update((payload)=>({
                    ...payload,
                    actionSubjectId: response.id
                }));
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $5sVYY.getRequestGroupsAction)(projectId, portalId)), (0, $b0T1M.Observable).of((0, $8pWZm.setRequestTypeGroupsAction)({
                isProjectSimplified: isProjectSimplified,
                portalId: portalId,
                projectId: projectId,
                requestType: requestType,
                updatedRequestTypeGroupId: response.id,
                analyticsEvent: analyticsEventRequestGroupUpdated,
                requestGroups: [
                    ...requestGroups,
                    response
                ]
            })));
        }).catch((error)=>{
            [
                analyticsEventRequestGroupCreatedFailure,
                analyticsEventRequestGroupUpdatedFailure
            ].filter((x)=>x).forEach((event)=>{
                (0, $keOG0.legacySendEvent)(event);
            });
            return (0, $b0T1M.Observable).of(// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (0, $jcEEo.createGroupWithRequestTypeFailedAction)((0, $fI5Sq.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});
parcelRegister("3Sl7d", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => (parcelRequire("jcEEo")).CREATE_GROUP_WITH_REQUEST_TYPE);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => (parcelRequire("jcEEo")).CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => (parcelRequire("jcEEo")).CREATE_GROUP_WITH_REQUEST_TYPE_FAILED);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => (parcelRequire("jcEEo")).createGroupWithRequestTypeAction);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => (parcelRequire("jcEEo")).createGroupWithRequestTypeFailedAction);

var $jcEEo = parcelRequire("jcEEo");

});
parcelRegister("jcEEo", function(module, exports) {
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE", () => $40b61231bdc29108$export$c69550447058b57a);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED", () => $40b61231bdc29108$export$c456181637c5858e);
$parcel$export(module.exports, "CREATE_GROUP_WITH_REQUEST_TYPE_FAILED", () => $40b61231bdc29108$export$71c9976978aa32b4);
$parcel$export(module.exports, "createGroupWithRequestTypeAction", () => $40b61231bdc29108$export$10336454f9456d40);
$parcel$export(module.exports, "createGroupWithRequestTypeFailedAction", () => $40b61231bdc29108$export$729bba13ddb7a330);
const $40b61231bdc29108$export$c69550447058b57a = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE';
const $40b61231bdc29108$export$c456181637c5858e = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED';
const $40b61231bdc29108$export$71c9976978aa32b4 = 'epic.request-groups.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED';
const $40b61231bdc29108$export$10336454f9456d40 = (payload)=>({
        payload: payload,
        type: $40b61231bdc29108$export$c69550447058b57a
    });
const $40b61231bdc29108$export$8bd250cf41846ec6 = ()=>({
        type: $40b61231bdc29108$export$c456181637c5858e
    });
const $40b61231bdc29108$export$729bba13ddb7a330 = (message)=>({
        payload: {
            message: message
        },
        type: $40b61231bdc29108$export$71c9976978aa32b4
    });

});


parcelRegister("joL0M", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => (parcelRequire("8pWZm")).SET_REQUEST_TYPE_GROUPS);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => (parcelRequire("8pWZm")).setRequestTypeGroupsAction);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => (parcelRequire("8pWZm")).SET_REQUEST_TYPE_GROUPS_FAILED);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => (parcelRequire("8pWZm")).setRequestTypeGroupsFailedAction);

var $8pWZm = parcelRequire("8pWZm");

});
parcelRegister("8pWZm", function(module, exports) {
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS", () => $9c5d50cfb9e2bd17$export$44dbc716b23b5565);
$parcel$export(module.exports, "setRequestTypeGroupsAction", () => $9c5d50cfb9e2bd17$export$9d952046e09fb735);
$parcel$export(module.exports, "SET_REQUEST_TYPE_GROUPS_FAILED", () => $9c5d50cfb9e2bd17$export$509c65d9f883a62a);
$parcel$export(module.exports, "setRequestTypeGroupsFailedAction", () => $9c5d50cfb9e2bd17$export$337a82f6e04125f9);
const $9c5d50cfb9e2bd17$export$44dbc716b23b5565 = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS';
const $9c5d50cfb9e2bd17$export$9d952046e09fb735 = (payload)=>{
    return {
        payload: payload,
        type: $9c5d50cfb9e2bd17$export$44dbc716b23b5565
    };
};
const $9c5d50cfb9e2bd17$export$509c65d9f883a62a = 'state.ui.request-types.SET_REQUEST_TYPE_GROUPS_FAILED';
const $9c5d50cfb9e2bd17$export$337a82f6e04125f9 = (message)=>({
        payload: {
            message: message
        },
        type: $9c5d50cfb9e2bd17$export$509c65d9f883a62a
    });

});



parcelRegister("ccvqN", function(module, exports) {
$parcel$export(module.exports, "deleteRequestTypeFromGroupEpic", () => $43df8cfc9dce28a9$export$d1c43b1bbe33b61c);

var $b0T1M = parcelRequire("b0T1M");

var $2ki5O = parcelRequire("2ki5O");
parcelRequire("efu6d");
var $ewU6B = parcelRequire("ewU6B");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("5pors");
var $1wRjC = parcelRequire("1wRjC");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $keOG0 = parcelRequire("keOG0");
const $43df8cfc9dce28a9$export$d1c43b1bbe33b61c = (action$, store)=>{
    return action$.ofType((0, $ewU6B.DELETE_REQUEST_TYPE_FROM_GROUP)).mergeMap((action)=>{
        const state = store.getState();
        const { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, requestGroupId: requestGroupId, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } = action.payload;
        const updatedRequestGroups = (0, $95tqy.getRequestGroupsForRequestType)({
            state: state,
            portalId: portalId,
            requestTypeId: Number(requestType.id)
        }).filter((requestGroup)=>requestGroup.id !== requestGroupId);
        const body = {
            ...requestType,
            groups: updatedRequestGroups
        };
        return (0, $2ki5O.deleteRequestTypeFromGroup)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            requestGroupId: requestGroupId,
            requestType: body
        }).map(()=>{
            analyticsEvent && (0, $keOG0.legacySendEvent)(analyticsEvent);
            return (0, $lXazD.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $keOG0.legacySendEvent)(analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $1wRjC.clearRequestTypesOrderAction)());
        });
    });
};

});
parcelRegister("2ki5O", function(module, exports) {
$parcel$export(module.exports, "requestTypeReorder", () => $fca8808b0bee2fc5$export$f7d2151053714646);
$parcel$export(module.exports, "deleteRequestTypeFromGroup", () => $fca8808b0bee2fc5$export$4ef0a9afff40ad59);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");
const $fca8808b0bee2fc5$export$f7d2151053714646 = ({ projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, body: body })=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}/move`;
    return (0, $lVFX8.post)(uri, body, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $b0T1M.Observable).throw(e));
};
const $fca8808b0bee2fc5$export$4ef0a9afff40ad59 = ({ isProjectSimplified: isProjectSimplified, projectId: projectId, requestGroupId: requestGroupId, requestType: toUpdate })=>{
    const { id: requestTypeId } = toUpdate;
    if (isProjectSimplified) {
        const nextGenUri = `${(0, $3wR8f.contextPath)}/rest/servicedesk/1/simplified/${projectId}/request-type-groups/${requestGroupId}/${requestTypeId}`;
        return (0, $lVFX8.doDelete)(nextGenUri, undefined).map(({ response: response })=>response).catch((e)=>(0, $b0T1M.Observable).throw(e));
    }
    const classicUri = `${(0, $3wR8f.contextPath)}/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeId}`;
    return (0, $lVFX8.put)(classicUri, toUpdate, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $b0T1M.Observable).throw(e));
};

});

parcelRegister("efu6d", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => (parcelRequire("ewU6B")).DELETE_REQUEST_TYPE_FROM_GROUP);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => (parcelRequire("ewU6B")).deleteRequestTypeFromGroupAction);
parcelRequire("ewU6B");

});
parcelRegister("ewU6B", function(module, exports) {
$parcel$export(module.exports, "DELETE_REQUEST_TYPE_FROM_GROUP", () => $ac155c36dea9c3b3$export$37d5cf3470d18d4a);
$parcel$export(module.exports, "deleteRequestTypeFromGroupAction", () => $ac155c36dea9c3b3$export$dd2f56a17442f2c4);
const $ac155c36dea9c3b3$export$37d5cf3470d18d4a = 'epic.request-types.DELETE_REQUEST_TYPE_FROM_GROUP';
const $ac155c36dea9c3b3$export$dd2f56a17442f2c4 = (payload)=>({
        payload: payload,
        type: $ac155c36dea9c3b3$export$37d5cf3470d18d4a
    });

});



parcelRegister("7WxpH", function(module, exports) {
$parcel$export(module.exports, "reorderRequestTypeEpic", () => $66daa92455f9eee3$export$efb6288a30e93a3a);

var $b0T1M = parcelRequire("b0T1M");

var $2ki5O = parcelRequire("2ki5O");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("5pors");
var $1wRjC = parcelRequire("1wRjC");
parcelRequire("S6V9t");
var $hBMej = parcelRequire("hBMej");

var $keOG0 = parcelRequire("keOG0");
const $66daa92455f9eee3$export$efb6288a30e93a3a = (action$)=>action$.ofType((0, $hBMej.REORDER_REQUEST_TYPE)).mergeMap(({ payload: { portalId: portalId, projectId: projectId, requestTypeId: requestTypeId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex, requestTypes: requestTypes, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        const body = $66daa92455f9eee3$var$getReorderPayload({
            requestTypes: requestTypes,
            fromIndex: fromIndex,
            toIndex: toIndex,
            projectId: projectId,
            requestGroupId: requestGroupId
        });
        return (0, $2ki5O.requestTypeReorder)({
            requestTypeId: requestTypeId,
            projectId: projectId,
            requestGroupId: requestGroupId,
            body: body
        }).map(()=>{
            analyticsEvent && (0, $keOG0.legacySendEvent)(analyticsEvent);
            return (0, $lXazD.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch(()=>{
            if (analyticsFailureEvent) (0, $keOG0.legacySendEvent)(analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $1wRjC.clearRequestTypesOrderAction)());
        });
    });
// The POST endpoint for reordering request types expects the body payload of POST request to look like:
// { position: 'First' } - when dragging a request type to the top of the list
// and { after: [url + requestTypeId] } - where requestTypeId is the id of the request type which the dragged req type will be under.
function $66daa92455f9eee3$var$getReorderPayload({ requestTypes: requestTypes, projectId: projectId, requestGroupId: requestGroupId, fromIndex: fromIndex, toIndex: toIndex }) {
    if (toIndex === 0) return {
        position: 'First'
    };
    let requestTypeAfter;
    if (toIndex < fromIndex) // if we're dragging UP the list we want it to set 'after' to the item above
    requestTypeAfter = requestTypes[toIndex - 1];
    else requestTypeAfter = requestTypes[toIndex];
    return {
        after: `/rest/servicedesk/1/servicedesk/${projectId}/request-type-groups/${requestGroupId}/request-types/${requestTypeAfter.id}`
    };
}

});
parcelRegister("S6V9t", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => (parcelRequire("hBMej")).REORDER_REQUEST_TYPE);
$parcel$export(module.exports, "reorderRequestTypeAction", () => (parcelRequire("hBMej")).reorderRequestTypeAction);
parcelRequire("hBMej");

});
parcelRegister("hBMej", function(module, exports) {
$parcel$export(module.exports, "REORDER_REQUEST_TYPE", () => $00c48ee3871d08c6$export$46dd7d5218860986);
$parcel$export(module.exports, "reorderRequestTypeAction", () => $00c48ee3871d08c6$export$f0a9fcf0696aeebb);
const $00c48ee3871d08c6$export$46dd7d5218860986 = 'epic.request-types.REORDER_REQUEST_TYPE';
const $00c48ee3871d08c6$export$f0a9fcf0696aeebb = (payload)=>({
        payload: payload,
        type: $00c48ee3871d08c6$export$46dd7d5218860986
    });

});



parcelRegister("jyQWh", function(module, exports) {
$parcel$export(module.exports, "setRequestTypeGroupsEpic", () => $d0f80dd69e8ddd6e$export$da9fdc969ff1b05d);

var $b0T1M = parcelRequire("b0T1M");

var $9Zn9X = parcelRequire("9Zn9X");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("joL0M");
var $8pWZm = parcelRequire("8pWZm");

var $fI5Sq = parcelRequire("fI5Sq");

var $keOG0 = parcelRequire("keOG0");
const $d0f80dd69e8ddd6e$var$getIconIdFromIconUrl = (iconUrl)=>iconUrl.substring(iconUrl.lastIndexOf('=') + 1, iconUrl.length);
const $d0f80dd69e8ddd6e$var$getSanitizedText = (html)=>{
    const stripHtmlTagsRegex = /(<([^>]+)>)/gi;
    return html.replace(stripHtmlTagsRegex, '');
};
const $d0f80dd69e8ddd6e$var$getSerializedRequestTypeWithRequestGroups = (requestType, requestGroups)=>({
        id: requestType.id,
        name: requestType.name,
        // Can remove after https://jdog.jira-dev.com/browse/JDW-292
        icon: $d0f80dd69e8ddd6e$var$getIconIdFromIconUrl(requestType.iconUrl),
        iconUrl: requestType.iconUrl,
        description: $d0f80dd69e8ddd6e$var$getSanitizedText(requestType.descriptionHtml),
        groups: requestGroups
    });
const $d0f80dd69e8ddd6e$export$da9fdc969ff1b05d = (action$)=>{
    return action$.ofType((0, $8pWZm.SET_REQUEST_TYPE_GROUPS)).mergeMap(({ payload: { isProjectSimplified: isProjectSimplified, portalId: portalId, projectId: projectId, requestType: requestType, updatedRequestTypeGroupId: updatedRequestTypeGroupId, requestGroups: requestGroups, analyticsEvent: analyticsEvent, analyticsFailureEvent: analyticsFailureEvent } })=>{
        return (0, $9Zn9X.setRequestGroupsForRequestType)({
            isProjectSimplified: isProjectSimplified,
            projectId: projectId,
            updatedRequestTypeGroupId: updatedRequestTypeGroupId,
            requestGroupId: 'hidden',
            requestType: $d0f80dd69e8ddd6e$var$getSerializedRequestTypeWithRequestGroups(requestType, requestGroups)
        }).map(()=>{
            if (analyticsEvent) (0, $keOG0.legacySendEvent)(analyticsEvent);
            return (0, $lXazD.fetchPortalAction)({
                id: portalId,
                expand: [
                    'reqTypes',
                    'reqGroups',
                    'orderMapping',
                    'kbs'
                ]
            });
        }).catch((error)=>{
            if (analyticsFailureEvent) (0, $keOG0.legacySendEvent)(analyticsFailureEvent);
            return (0, $b0T1M.Observable).of((0, $8pWZm.setRequestTypeGroupsFailedAction)((0, $fI5Sq.getFirstMessageFromJiraError)(error.response)));
        });
    });
};

});

parcelRegister("cmatD", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmailEpic", () => $1b88e16fa72b8886$export$a8c26f01f6ef2d73);

var $b0T1M = parcelRequire("b0T1M");

var $k0Nfi = parcelRequire("k0Nfi");
parcelRequire("268JS");
var $dCep4 = parcelRequire("dCep4");
const $1b88e16fa72b8886$export$a8c26f01f6ef2d73 = (action$)=>{
    return action$.ofType((0, $dCep4.FETCH_RESEND_VERIFY_EMAIL)).mergeMap((action)=>{
        const { emailAddress: emailAddress, portalId: portalId } = action.payload.params;
        const errorResponse = {
            status: 503
        };
        return (0, $k0Nfi.resendVerifyEmail)(emailAddress, portalId).map((response)=>{
            if (response.status === 204) return (0, $dCep4.fetchResendVerificationSuccess)();
            return (0, $dCep4.fetchResendVerificationFailure)(errorResponse);
        }).catch((error)=>(0, $b0T1M.Observable).of((0, $dCep4.fetchResendVerificationFailure)(error)));
    });
};

});
parcelRegister("k0Nfi", function(module, exports) {
$parcel$export(module.exports, "resendVerifyEmail", () => $b8c760db0a224487$export$da8af7e7b05b444);

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $b8c760db0a224487$var$getResendVerifyEmailRequestBody = (email, portalId)=>({
        email: email,
        verificationContext: {
            portalId: portalId
        }
    });
const $b8c760db0a224487$export$da8af7e7b05b444 = (email, portalId)=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/servicedesk/1/customer/pages/user/resend-verification-email`;
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    };
    const body = $b8c760db0a224487$var$getResendVerifyEmailRequestBody(email, portalId);
    return (0, $lVFX8.post)(uri, body, headers);
};

});

parcelRegister("268JS", function(module, exports) {
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => (parcelRequire("dCep4")).fetchResendVerifyEmailAction);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => (parcelRequire("dCep4")).fetchResendVerificationFailure);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => (parcelRequire("dCep4")).fetchResendVerificationSuccess);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => (parcelRequire("dCep4")).FETCH_RESEND_VERIFICATION_FAILURE);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => (parcelRequire("dCep4")).FETCH_RESEND_VERIFICATION_SUCCESS);
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => (parcelRequire("dCep4")).FETCH_RESEND_VERIFY_EMAIL);

var $dCep4 = parcelRequire("dCep4");

});
parcelRegister("dCep4", function(module, exports) {
$parcel$export(module.exports, "FETCH_RESEND_VERIFY_EMAIL", () => $cf4747fc91ae906d$export$c41322ca6fdfdd1f);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_FAILURE", () => $cf4747fc91ae906d$export$5d8d6d17a7bb9f46);
$parcel$export(module.exports, "FETCH_RESEND_VERIFICATION_SUCCESS", () => $cf4747fc91ae906d$export$7517f0d1f77dd091);
$parcel$export(module.exports, "fetchResendVerifyEmailAction", () => $cf4747fc91ae906d$export$33f84eb26dff7a8d);
$parcel$export(module.exports, "fetchResendVerificationSuccess", () => $cf4747fc91ae906d$export$548d04925c9d810e);
$parcel$export(module.exports, "fetchResendVerificationFailure", () => $cf4747fc91ae906d$export$ccba2c058636a09f);
const $cf4747fc91ae906d$export$c41322ca6fdfdd1f = 'epic.verify-email.FETCH_RESEND_VERIFY_EMAIL';
const $cf4747fc91ae906d$export$5d8d6d17a7bb9f46 = 'state.ui.resendVerifyEmail.FAILED';
const $cf4747fc91ae906d$export$7517f0d1f77dd091 = 'state.ui.resendVerifyEmail.SUCCEEDED';
const $cf4747fc91ae906d$export$33f84eb26dff7a8d = ({ emailAddress: emailAddress, portalId: portalId })=>{
    return {
        type: $cf4747fc91ae906d$export$c41322ca6fdfdd1f,
        payload: {
            params: {
                emailAddress: emailAddress,
                portalId: portalId
            }
        }
    };
};
const $cf4747fc91ae906d$export$548d04925c9d810e = ()=>({
        type: $cf4747fc91ae906d$export$7517f0d1f77dd091
    });
const $cf4747fc91ae906d$export$ccba2c058636a09f = (error)=>({
        type: $cf4747fc91ae906d$export$5d8d6d17a7bb9f46,
        payload: {
            error: error
        }
    });

});



parcelRegister("5j5Nc", function(module, exports) {
$parcel$export(module.exports, "resetPasswordEpic", () => $a5b01d6398384d31$export$eb399c940b1a806e);

var $b0T1M = parcelRequire("b0T1M");

var $kDlDk = parcelRequire("kDlDk");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("4Sj1L");
var $gByNL = parcelRequire("gByNL");

var $fI5Sq = parcelRequire("fI5Sq");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");
const $a5b01d6398384d31$export$eb399c940b1a806e = (action$)=>{
    return action$.ofType((0, $gByNL.RESET_PASSWORD)).mergeMap((resetPasswordAction)=>{
        const { emailAddress: emailAddress, password: password, token: token, resetPasswordJwt: resetPasswordJwt, createAnalyticsEvent: createAnalyticsEvent, redirectUrl: redirectUrl } = resetPasswordAction.payload;
        return (0, $kDlDk.resetPassword)({
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt
        }).map(()=>{
            return (0, $8o5VQ.loginAttempt)({
                password: password,
                email: emailAddress,
                continueParam: redirectUrl ?? null
            });
        }).catch((error)=>{
            if (createAnalyticsEvent && error.status === 400) {
                const event = createAnalyticsEvent({
                    analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                    actionSubject: 'submitNewPassword',
                    action: 'failed'
                });
                (0, $keOG0.legacySendEvent)(event);
            }
            return (0, $b0T1M.Observable).of((0, $gByNL.resetPasswordFailure)((0, $fI5Sq.getDefaultError)(error)));
        });
    });
};

});
parcelRegister("kDlDk", function(module, exports) {
$parcel$export(module.exports, "resetPassword", () => $e114e571544afb08$export$dc726c8e334dd814);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");
const $e114e571544afb08$export$dc726c8e334dd814 = (params)=>{
    const { emailAddress: emailAddress, password: password, resetPasswordJwt: resetPasswordJwt, token: token, context: context = (0, $3wR8f.contextPath) } = params;
    const uri = resetPasswordJwt ? `${context}/rest/servicedesk/1/customer/pages/user/resetpassword?jwt=${resetPasswordJwt}` : `${context}/rest/servicedesk/1/customer/pages/user/resetpassword`;
    const body = {
        emailAddress: emailAddress,
        password: password,
        ...token.length > 0 ? {
            token: token
        } : {}
    };
    const headers = {
        'Content-Type': 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers)// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).catch((e)=>(0, $b0T1M.Observable).throw(e));
};

});

parcelRegister("4Sj1L", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => (parcelRequire("gByNL")).RESET_PASSWORD);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => (parcelRequire("gByNL")).RESET_PASSWORD_FAILURE);
$parcel$export(module.exports, "resetPassword", () => (parcelRequire("gByNL")).resetPassword);
$parcel$export(module.exports, "resetPasswordFailure", () => (parcelRequire("gByNL")).resetPasswordFailure);

var $gByNL = parcelRequire("gByNL");

});
parcelRegister("gByNL", function(module, exports) {
$parcel$export(module.exports, "RESET_PASSWORD", () => $7d9234a95d6b78bc$export$bf768f070251ce56);
$parcel$export(module.exports, "RESET_PASSWORD_FAILURE", () => $7d9234a95d6b78bc$export$682377d29726ee75);
$parcel$export(module.exports, "resetPassword", () => $7d9234a95d6b78bc$export$dc726c8e334dd814);
$parcel$export(module.exports, "resetPasswordFailure", () => $7d9234a95d6b78bc$export$70c45c9f946d241a);
const $7d9234a95d6b78bc$export$bf768f070251ce56 = 'state.persisted.RESET_PASSWORD';
const $7d9234a95d6b78bc$export$682377d29726ee75 = 'state.persisted.RESET_PASSWORD_FAILURE';
const $7d9234a95d6b78bc$export$dc726c8e334dd814 = (emailAddress, password, token, resetPasswordJwt, createAnalyticsEvent, redirectUrl)=>({
        payload: {
            emailAddress: emailAddress,
            password: password,
            token: token,
            resetPasswordJwt: resetPasswordJwt,
            createAnalyticsEvent: createAnalyticsEvent,
            redirectUrl: redirectUrl
        },
        type: $7d9234a95d6b78bc$export$bf768f070251ce56
    });
const $7d9234a95d6b78bc$export$70c45c9f946d241a = (error)=>({
        payload: {
            error: error
        },
        type: $7d9234a95d6b78bc$export$682377d29726ee75
    });

});



parcelRegister("7hzi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fecc9c320d1029d$export$2e2bcd8739ae039);
parcelRequire("lbln8");
var $4akjj = parcelRequire("4akjj");

var $lR8e7 = parcelRequire("lR8e7");

var $81uU8 = parcelRequire("81uU8");

var $jVKGo = parcelRequire("jVKGo");
var $2fecc9c320d1029d$export$2e2bcd8739ae039 = (0, $4akjj.combineEpics)((0, $81uU8.default), (0, $lR8e7.default), (0, $jVKGo.searchEpic), (0, $jVKGo.fetchSearchResultsEpic), (0, $jVKGo.fetchKbSearchResultsEpic));

});
parcelRegister("lR8e7", function(module, exports) {
$parcel$export(module.exports, "context", () => $5f3dc60f888aeae2$export$a078c61943f9dbbe);
$parcel$export(module.exports, "default", () => $5f3dc60f888aeae2$export$2e2bcd8739ae039);

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("dMwUq");
var $gi2k1 = parcelRequire("gi2k1");

var $3wR8f = parcelRequire("3wR8f");

var $PL4bf = parcelRequire("PL4bf");
const $5f3dc60f888aeae2$export$a078c61943f9dbbe = 'from-location';
const $5f3dc60f888aeae2$var$epic = (_, store)=>{
    return (0, $3wR8f.historyObservable).mergeMap(({ action: action })=>{
        const queryParams = $PL4bf.getAll();
        const hasQueryParams = queryParams && queryParams.hasOwnProperty && queryParams.hasOwnProperty('q');
        if (action === 'POP') {
            if (hasQueryParams) return (0, $b0T1M.Observable).of($gi2k1.search(queryParams.q, {
                context: $5f3dc60f888aeae2$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (action === 'PUSH') {
            if (hasQueryParams) return (0, $b0T1M.Observable).of($gi2k1.updateSearch(queryParams.q, {
                context: $5f3dc60f888aeae2$export$a078c61943f9dbbe,
                time: queryParams.time ? +queryParams.time : null
            }));
        }
        if (!hasQueryParams) {
            const state = store.getState();
            if (state.ui.search.shown) return (0, $b0T1M.Observable).of($gi2k1.showSearch(false, {
                context: $5f3dc60f888aeae2$export$a078c61943f9dbbe
            }));
            return (0, $b0T1M.Observable).empty();
        }
        return (0, $b0T1M.Observable).empty();
    });
};
var $5f3dc60f888aeae2$export$2e2bcd8739ae039 = $5f3dc60f888aeae2$var$epic;

});
parcelRegister("dMwUq", function(module, exports) {
$parcel$export(module.exports, "SEARCH", () => (parcelRequire("gi2k1")).SEARCH);
$parcel$export(module.exports, "search", () => (parcelRequire("gi2k1")).search);
$parcel$export(module.exports, "resetSearch", () => (parcelRequire("gi2k1")).resetSearch);
$parcel$export(module.exports, "RESET_SEARCH", () => (parcelRequire("gi2k1")).RESET_SEARCH);
$parcel$export(module.exports, "SHOW_SEARCH", () => (parcelRequire("gi2k1")).SHOW_SEARCH);
$parcel$export(module.exports, "showSearch", () => (parcelRequire("gi2k1")).showSearch);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => (parcelRequire("gi2k1")).CLEAR_SEARCH_RESULTS);
$parcel$export(module.exports, "clearSearchResults", () => (parcelRequire("gi2k1")).clearSearchResults);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => (parcelRequire("gi2k1")).FETCH_SEARCH_RESULTS);
$parcel$export(module.exports, "fetchSearchResultsAction", () => (parcelRequire("gi2k1")).fetchSearchResultsAction);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => (parcelRequire("gi2k1")).FETCH_KB_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => (parcelRequire("gi2k1")).UPDATE_SEARCH_RESULTS);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => (parcelRequire("gi2k1")).UPDATE_SEARCH_RESULTS_BY_TYPE);
$parcel$export(module.exports, "updateSearchResultsByType", () => (parcelRequire("gi2k1")).updateSearchResultsByType);
$parcel$export(module.exports, "UPDATE_SEARCH", () => (parcelRequire("gi2k1")).UPDATE_SEARCH);
$parcel$export(module.exports, "updateSearch", () => (parcelRequire("gi2k1")).updateSearch);

var $gi2k1 = parcelRequire("gi2k1");

});
parcelRegister("gi2k1", function(module, exports) {
$parcel$export(module.exports, "SHOW_SEARCH", () => $e60064472b779415$export$c3d32479efe3cefd);
$parcel$export(module.exports, "SEARCH", () => $e60064472b779415$export$a6b9aaee40d49fd0);
$parcel$export(module.exports, "RESET_SEARCH", () => $e60064472b779415$export$1357260dfbbdd047);
$parcel$export(module.exports, "FETCH_KB_SEARCH_RESULTS", () => $e60064472b779415$export$51c1b519f9597fb6);
$parcel$export(module.exports, "FETCH_SEARCH_RESULTS", () => $e60064472b779415$export$ada24bdba9b1de5);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS", () => $e60064472b779415$export$41015fa2c6363474);
$parcel$export(module.exports, "UPDATE_SEARCH_RESULTS_BY_TYPE", () => $e60064472b779415$export$83fbaab84674965e);
$parcel$export(module.exports, "CLEAR_SEARCH_RESULTS", () => $e60064472b779415$export$e8fd6ac9f3290dd1);
$parcel$export(module.exports, "UPDATE_SEARCH", () => $e60064472b779415$export$e88baa2479d0f7d);
$parcel$export(module.exports, "fetchSearchResultsAction", () => $e60064472b779415$export$e6c9557a57e930cb);
$parcel$export(module.exports, "showSearch", () => $e60064472b779415$export$6a74a1717b2c4c0);
$parcel$export(module.exports, "resetSearch", () => $e60064472b779415$export$f4d94e8b97ed073f);
$parcel$export(module.exports, "search", () => $e60064472b779415$export$d76128d007d19019);
$parcel$export(module.exports, "updateSearchResultsByType", () => $e60064472b779415$export$d929024984f1b2ad);
$parcel$export(module.exports, "clearSearchResults", () => $e60064472b779415$export$20893a65977b35d3);
$parcel$export(module.exports, "updateSearch", () => $e60064472b779415$export$b14c90fc27f0b629);
const $e60064472b779415$export$c3d32479efe3cefd = 'ui.search.SHOW_SEARCH';
const $e60064472b779415$export$a6b9aaee40d49fd0 = 'ui.search.SEARCH';
const $e60064472b779415$export$1357260dfbbdd047 = 'ui.search.RESET_SEARCH';
const $e60064472b779415$export$51c1b519f9597fb6 = 'epic.search.FETCH_KB_SEARCH_RESULTS';
const $e60064472b779415$export$ada24bdba9b1de5 = 'epic.search.FETCH_SEARCH_RESULTS';
const $e60064472b779415$export$41015fa2c6363474 = 'ui.search.UPDATE_SEARCH_RESULTS';
const $e60064472b779415$export$83fbaab84674965e = 'ui.search.UPDATE_SEARCH_RESULTS_BY_TYPE';
const $e60064472b779415$export$e8fd6ac9f3290dd1 = 'ui.search.CLEAR_SEARCH_RESULTS';
const $e60064472b779415$export$e88baa2479d0f7d = 'ui.search.UPDATE_SEARCH';
const $e60064472b779415$export$e6c9557a57e930cb = (term, searchStartTime, meta)=>({
        payload: {
            term: term,
            searchStartTime: searchStartTime,
            meta: meta
        },
        type: $e60064472b779415$export$ada24bdba9b1de5
    });
const $e60064472b779415$export$6a74a1717b2c4c0 = (show, options = {})=>({
        payload: {
            show: show,
            ...options
        },
        type: $e60064472b779415$export$c3d32479efe3cefd
    });
const $e60064472b779415$export$f4d94e8b97ed073f = ()=>({
        type: $e60064472b779415$export$1357260dfbbdd047
    });
const $e60064472b779415$export$d76128d007d19019 = (term, { time: time = Date.now(), show: show = true, ...options } = {}, meta)=>({
        type: $e60064472b779415$export$a6b9aaee40d49fd0,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options,
            meta: meta
        }
    });
const $e60064472b779415$export$1ef413033527da6d = ({ term: term, limit: limit, expandPortal: expandPortal, meta: meta, categoryIds: categoryIds, portalIds: portalIds })=>{
    return {
        type: $e60064472b779415$export$51c1b519f9597fb6,
        payload: {
            term: term,
            limit: limit,
            expandPortal: expandPortal,
            categoryIds: categoryIds,
            portalIds: portalIds,
            meta: meta
        }
    };
};
//export type SearchType = 'portals' | 'requestTypes' | 'kbs';
const $e60064472b779415$var$searchTypes = [
    'portals',
    'requestTypes',
    'kbs'
];
const $e60064472b779415$export$d929024984f1b2ad = (searchResult, searchType)=>({
        searchType: searchType,
        type: $e60064472b779415$export$83fbaab84674965e,
        payload: searchResult
    });
const $e60064472b779415$export$20893a65977b35d3 = ()=>({
        type: $e60064472b779415$export$e8fd6ac9f3290dd1
    });
const $e60064472b779415$export$b14c90fc27f0b629 = (term, { time: time = Date.now(), show: show = true, ...options } = {})=>({
        type: $e60064472b779415$export$e88baa2479d0f7d,
        payload: {
            term: term,
            time: time,
            show: show,
            ...options
        }
    });

});



parcelRegister("81uU8", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a48044747b4bb63$export$2e2bcd8739ae039);
parcelRequire("dMwUq");
var $gi2k1 = parcelRequire("gi2k1");

var $PL4bf = parcelRequire("PL4bf");

var $lR8e7 = parcelRequire("lR8e7");
const $6a48044747b4bb63$var$isValidSearchAction = (action)=>(action.type === (0, $gi2k1.SHOW_SEARCH) || action.type === (0, $gi2k1.SEARCH) || action.type === (0, $gi2k1.UPDATE_SEARCH)) && action.payload.context !== (0, $lR8e7.context);
const $6a48044747b4bb63$var$setSearchQueryParams = (term, replaceRoute = false)=>{
    $PL4bf.set({
        q: term
    }, replaceRoute);
};
const $6a48044747b4bb63$var$epic = (action$, store)=>{
    return action$.filter($6a48044747b4bb63$var$isValidSearchAction).do((action)=>{
        if ((action.type === (0, $gi2k1.SEARCH) || action.type === (0, $gi2k1.UPDATE_SEARCH)) && action.payload.show) {
            const shouldReplaceRoute = $PL4bf.get('q') !== undefined;
            $6a48044747b4bb63$var$setSearchQueryParams(action.payload.term, shouldReplaceRoute);
            return;
        }
        if (action.type === (0, $gi2k1.SHOW_SEARCH)) {
            if (action.payload.show) {
                const state = store.getState();
                if (state.ui.search.term) {
                    $6a48044747b4bb63$var$setSearchQueryParams(state.ui.search.term);
                    return;
                }
                $6a48044747b4bb63$var$setSearchQueryParams('');
                return;
            }
            $6a48044747b4bb63$var$setSearchQueryParams(undefined);
        }
    }).ignoreElements();
};
var $6a48044747b4bb63$export$2e2bcd8739ae039 = $6a48044747b4bb63$var$epic;

});

parcelRegister("jVKGo", function(module, exports) {
$parcel$export(module.exports, "searchEpic", () => $b8fc078b7c307332$export$54e39fbf71be6145);
$parcel$export(module.exports, "fetchSearchResultsEpic", () => $b8fc078b7c307332$export$afbb5f5d68ce3b2b);
$parcel$export(module.exports, "fetchKbSearchResultsEpic", () => $b8fc078b7c307332$export$afb8d00d671f0126);
/**
 * Epic for performing the search request
 */ 
var $748yq = parcelRequire("748yq");

var $b0T1M = parcelRequire("b0T1M");
parcelRequire("dMwUq");
var $gi2k1 = parcelRequire("gi2k1");

var $ddKd8 = parcelRequire("ddKd8");
const $b8fc078b7c307332$var$SEARCH_PROVIDERS = [
    (0, $ddKd8.KbSearchProvider),
    (0, $ddKd8.RequestTypeSearchProvider),
    (0, $ddKd8.PortalSearchProvider)
];
const $b8fc078b7c307332$export$54e39fbf71be6145 = (action$)=>{
    return action$.ofType((0, $gi2k1.SEARCH)).map((action)=>{
        const { meta: meta, term: query } = action.payload;
        if (!query || query.trim() === '') return (0, $gi2k1.clearSearchResults)();
        return (0, $gi2k1.fetchSearchResultsAction)(query, performance.now(), meta);
    });
};
const $b8fc078b7c307332$export$afbb5f5d68ce3b2b = (action$, store)=>{
    return action$.ofType((0, $gi2k1.FETCH_SEARCH_RESULTS)).debounceTime((0, $748yq.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        // This cast is necessary otherwise TS doesn't know that this action can only be a FetchSearchResultsAction
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta } = action.payload;
        const observablesToWaitFor = $b8fc078b7c307332$var$SEARCH_PROVIDERS.map((provider)=>provider.execute(term, state, meta));
        return (0, $b0T1M.Observable).from(observablesToWaitFor).mergeMap((observable)=>{
            return observable.map((response)=>(0, $gi2k1.updateSearchResultsByType)(response, Object.keys(response)[0]));
        });
    }).takeUntil(action$.ofType((0, $gi2k1.CLEAR_SEARCH_RESULTS))).repeat();
};
const $b8fc078b7c307332$export$afb8d00d671f0126 = (action$, store)=>{
    return action$.ofType((0, $gi2k1.FETCH_KB_SEARCH_RESULTS)).debounceTime((0, $748yq.USER_TYPING_DEBOUNCE_TIME)).switchMap((fetchAction)=>{
        const action = fetchAction;
        const state = store.getState();
        const { term: term, meta: meta, limit: limit, expandPortal: expandPortal, categoryIds: categoryIds, portalIds: portalIds } = action.payload;
        return (0, $ddKd8.KbSearchProvider).execute(term, state, meta, limit, expandPortal, categoryIds, portalIds).map((response)=>(0, $gi2k1.updateSearchResultsByType)(response, Object.keys(response)[0]));
    }).takeUntil(action$.ofType((0, $gi2k1.CLEAR_SEARCH_RESULTS))).repeat();
};

});
parcelRegister("ddKd8", function(module, exports) {
$parcel$export(module.exports, "KbSearchProvider", () => $b1065a598a97fbe6$export$96508bc27743153d);
$parcel$export(module.exports, "RequestTypeSearchProvider", () => $b1065a598a97fbe6$export$836cf63ac20b672f);
$parcel$export(module.exports, "PortalSearchProvider", () => $b1065a598a97fbe6$export$c437cd06ecaa9215);

var $b0T1M = parcelRequire("b0T1M");

var $DjhUw = parcelRequire("DjhUw");
var $lu3Nm = parcelRequire("lu3Nm");
var $hfblY = parcelRequire("hfblY");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $keOG0 = parcelRequire("keOG0");

var $eo5zF = parcelRequire("eo5zF");
const $b1065a598a97fbe6$export$1e7a22c99c64fffc = 30;
const $b1065a598a97fbe6$export$96508bc27743153d = {
    execute: (query, state, meta, resultLimit, expandPortal, categoryIds, portalIds)=>{
        const DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL = 8;
        return $b1065a598a97fbe6$var$searchKbSuppressError(query.trim(), state, resultLimit || DEFAULT_MAX_KB_RESULTS_IN_SEARCH_MODAL, meta, expandPortal, categoryIds, portalIds);
    }
};
const $b1065a598a97fbe6$var$searchKbSuppressError = (query, state, resultLimit, meta, expandPortal, categoryIds, portalIds)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    const projectId = (0, $95tqy.getProjectId)(state, portalId);
    if (portalId) {
        // If the portal model is available and the kb is disabled then we will not make the kb search request.
        // i.e. if there is no portal model we will still make a kb request regardless
        if ((0, $95tqy.getIsPortalLoaded)(state, portalId) && !(0, $95tqy.getIsKbEnabled)(state, portalId)) return (0, $b0T1M.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    } else if ((0, $i8gmD.getIsLoaded)(state) && !(0, $i8gmD.getIsKbEnabled)(state)) // We will only NOT make a KB search request if the help center is loaded and kb is disabled
    return (0, $b0T1M.Observable).of({
        kbs: {
            articles: [],
            totalSize: 0
        }
    });
    const kbsQuery = {
        categoryIds: categoryIds,
        portalIds: portalIds,
        query: query,
        projectId: projectId,
        resultLimit: resultLimit,
        expandPortalName: expandPortal
    };
    return (0, $DjhUw.searchKbs)(kbsQuery).map((response)=>{
        var _meta$analyticsSucces;
        if (meta !== null && meta !== void 0 && (_meta$analyticsSucces = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces !== void 0 && _meta$analyticsSucces.kb) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent.kb);
        return {
            kbs: response
        };
    }).catch((error)=>{
        var _meta$analyticsFailur;
        if (meta !== null && meta !== void 0 && (_meta$analyticsFailur = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur !== void 0 && _meta$analyticsFailur.kb && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent.kb);
        return (0, $b0T1M.Observable).of({
            kbs: {
                articles: [],
                totalSize: 0
            }
        });
    });
};
const $b1065a598a97fbe6$export$836cf63ac20b672f = {
    execute: (query, state, meta)=>{
        var _performance;
        const DEFAULT_MAX_RT_RESULTS = 5;
        const requestTypeQuery = {
            query: query,
            resultLimit: DEFAULT_MAX_RT_RESULTS,
            includeRequestTypesFromOtherPortals: true,
            serviceDeskId: (0, $h1MVT.getPortalId)(state)
        };
        const start = (_performance = performance) === null || _performance === void 0 ? void 0 : _performance.now();
        return (0, $hfblY.searchRequestTypes)(requestTypeQuery).map((response)=>{
            var _meta$analyticsSucces2;
            const uiAnalyticsEvent = meta === null || meta === void 0 || (_meta$analyticsSucces2 = meta.analyticsSuccessEvent) === null || _meta$analyticsSucces2 === void 0 ? void 0 : _meta$analyticsSucces2.requestType;
            uiAnalyticsEvent === null || uiAnalyticsEvent === void 0 || uiAnalyticsEvent.update((payload)=>{
                var _performance2;
                return {
                    ...payload,
                    timeTaken: ((_performance2 = performance) === null || _performance2 === void 0 ? void 0 : _performance2.now()) - start
                };
            });
            if (uiAnalyticsEvent) (0, $keOG0.legacySendEvent)(uiAnalyticsEvent);
            return {
                requestTypes: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur2;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur2 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur2 !== void 0 && _meta$analyticsFailur2.requestType && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent.requestType);
            return (0, $b0T1M.Observable).of({
                requestTypes: []
            });
        });
    }
};
const $b1065a598a97fbe6$export$c437cd06ecaa9215 = {
    execute: (query, state, meta)=>{
        const DEFAULT_MAX_PORTAL_RESULTS = 3;
        const portalQuery = {
            query: query,
            limit: DEFAULT_MAX_PORTAL_RESULTS,
            excludedPortalId: (0, $h1MVT.getPortalId)(state)
        };
        return (0, $lu3Nm.searchPortals)(portalQuery).map((response)=>{
            var _meta$analyticsSucces3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsSucces3 = meta.analyticsSuccessEvent) !== null && _meta$analyticsSucces3 !== void 0 && _meta$analyticsSucces3.portal) (0, $keOG0.legacySendEvent)(meta.analyticsSuccessEvent.portal);
            return {
                portals: response
            };
        }).catch((error)=>{
            var _meta$analyticsFailur3;
            if (meta !== null && meta !== void 0 && (_meta$analyticsFailur3 = meta.analyticsFailureEvent) !== null && _meta$analyticsFailur3 !== void 0 && _meta$analyticsFailur3.portal && !(0, $eo5zF.isNetworkOrClientErrorCode)(error.status)) (0, $keOG0.legacySendEvent)(meta.analyticsFailureEvent.portal);
            return (0, $b0T1M.Observable).of({
                portals: []
            });
        });
    }
};

});
parcelRegister("DjhUw", function(module, exports) {
$parcel$export(module.exports, "searchKbs", () => $87da97396c910fbf$export$14f2b1f126d32b28);

var $lVFX8 = parcelRequire("lVFX8");

var $6mmHn = parcelRequire("6mmHn");

var $4i2V5 = parcelRequire("4i2V5");

var $4axJ1 = parcelRequire("4axJ1");

var $6bGmX = parcelRequire("6bGmX");
const $87da97396c910fbf$export$14f2b1f126d32b28 = (kbsQuery)=>{
    const { projectId: projectId, query: query, resultLimit: resultLimit, expandPortalName: expandPortalName, categoryIds: categoryIds, portalIds: portalIds, labels: labels, requestTypeId: requestTypeId } = kbsQuery;
    const queryParams = {
        labels: labels,
        portalIds: portalIds,
        categoryIds: categoryIds,
        searchQuery: query,
        limit: resultLimit,
        expand: expandPortalName ? 'portal' : undefined
    };
    const queryString = $4i2V5.stringify(queryParams);
    let uri;
    const activationId = (0, $6mmHn.getMeta)('activation-id');
    if (projectId) {
        if ((0, $6bGmX.default).checkGate('remove-linked-spaces-check-for-article-suggestions') && requestTypeId) uri = `${0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/request-type/${requestTypeId}/articles?${queryString}`;
        else uri = `${0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/project/${projectId}/articles?${queryString}`;
    } else uri = `${0, $4axJ1.APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/jsm-portal/articles?${queryString}`;
    return (0, $lVFX8.get)(uri, {
        'Content-Type': 'application/json'
    }).map((ajaxResponse)=>{
        const result = ajaxResponse.response;
        return {
            ...result,
            articles: result.articles.map((article)=>({
                    id: article.articleId,
                    name: article.articleTitle,
                    articleSnippet: article.articleSnippet,
                    pageVersion: article.articleVersion,
                    score: article.snippetScore,
                    isSmartSnippet: article.isSmartSnippet,
                    linkedPortals: article.linkedPortals,
                    sourceType: article.articleSource,
                    articleUrl: article.articleUrl
                }))
        };
    });
};

});

parcelRegister("lu3Nm", function(module, exports) {
$parcel$export(module.exports, "searchPortals", () => $142a295c034e03d1$export$89b85885f9d0f13);

var $lVFX8 = parcelRequire("lVFX8");

var $63sfu = parcelRequire("63sfu");

var $4i2V5 = parcelRequire("4i2V5");

var $3wR8f = parcelRequire("3wR8f");
const $142a295c034e03d1$export$89b85885f9d0f13 = (portalsQuery)=>{
    const sanitizedQuery = (0, $63sfu.pickBy)(portalsQuery, (prop)=>!(0, $63sfu.isNil)(prop));
    const queryString = $4i2V5.stringify(sanitizedQuery);
    return (0, $lVFX8.get)(`${(0, $3wR8f.contextPath)}/rest/servicedesk/search/1/search/portals?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.portals;
    });
};

});

parcelRegister("hfblY", function(module, exports) {
$parcel$export(module.exports, "searchRequestTypes", () => $c6c3ebb3fe79f776$export$c3cad6e5e6fca0f1);

var $lVFX8 = parcelRequire("lVFX8");

var $63sfu = parcelRequire("63sfu");

var $4i2V5 = parcelRequire("4i2V5");

var $3wR8f = parcelRequire("3wR8f");
const $c6c3ebb3fe79f776$export$c3cad6e5e6fca0f1 = (requestTypesQuery)=>{
    const sanitizedQuery = (0, $63sfu.pickBy)(requestTypesQuery, (prop)=>!(0, $63sfu.isNil)(prop));
    const queryString = $4i2V5.stringify(sanitizedQuery);
    return (0, $lVFX8.get)(`${(0, $3wR8f.contextPath)}/rest/servicedesk/search/1/search/request-type?${queryString}`).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return ajaxResponse.response.requestTypes;
    });
};

});

parcelRegister("bjlEi", function(module, exports) {
$parcel$export(module.exports, "getLogoUrl", () => (parcelRequire("i8gmD")).getLogoUrl);
$parcel$export(module.exports, "getSharedPortalName", () => (parcelRequire("i8gmD")).getSharedPortalName);
$parcel$export(module.exports, "getThemeColor", () => (parcelRequire("i8gmD")).getThemeColor);
$parcel$export(module.exports, "getIsKbEnabled", () => (parcelRequire("i8gmD")).getIsKbEnabled);
$parcel$export(module.exports, "getIsLoaded", () => (parcelRequire("i8gmD")).getIsLoaded);
$parcel$export(module.exports, "getHelpCenterBanner", () => (parcelRequire("i8gmD")).getHelpCenterBanner);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => (parcelRequire("i8gmD")).getHelpCenterTitleColor);
$parcel$export(module.exports, "getCanCustomize", () => (parcelRequire("i8gmD")).getCanCustomize);
$parcel$export(module.exports, "getHelpCenterState", () => (parcelRequire("i8gmD")).getHelpCenterState);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => (parcelRequire("i8gmD")).getDefaultSiteLanguageTag);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => (parcelRequire("i8gmD")).getHelpCenterStateTranslationPersisted);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => (parcelRequire("i8gmD")).getKbHelpCenterLinkDomainURLs);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => (parcelRequire("i8gmD")).getHelpCenterBrandingLoader);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => (parcelRequire("i8gmD")).getHelpCenterTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => (parcelRequire("i8gmD")).getHelpCenterPersistedTopBarSplitFlag);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => (parcelRequire("i8gmD")).getHelpCenterTopBarColor);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => (parcelRequire("i8gmD")).getHelpCenterTopBarTextColor);

var $i8gmD = parcelRequire("i8gmD");

});
parcelRegister("i8gmD", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterState", () => $de48218b235c0f42$export$85757b7e55ef3c9f);
$parcel$export(module.exports, "getLogoUrl", () => $de48218b235c0f42$export$976f80239b15365);
$parcel$export(module.exports, "getSharedPortalName", () => $de48218b235c0f42$export$bef10d4690ba4a95);
$parcel$export(module.exports, "getThemeColor", () => $de48218b235c0f42$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getIsLoaded", () => $de48218b235c0f42$export$c2ab4f36d4c3d60a);
$parcel$export(module.exports, "getIsKbEnabled", () => $de48218b235c0f42$export$d56e4bff0fec91ad);
$parcel$export(module.exports, "getDefaultSiteLanguageTag", () => $de48218b235c0f42$export$16e1b34e36aec9ef);
$parcel$export(module.exports, "getHelpCenterBanner", () => $de48218b235c0f42$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getCanCustomize", () => $de48218b235c0f42$export$eb9b5e885139dc39);
$parcel$export(module.exports, "getHelpCenterTitleColor", () => $de48218b235c0f42$export$4b8ac8e47961f765);
$parcel$export(module.exports, "getHelpCenterBrandingLoader", () => $de48218b235c0f42$export$62574aae884b522a);
$parcel$export(module.exports, "getHelpCenterTopBarSplitFlag", () => $de48218b235c0f42$export$76facf9cf6c06c3);
$parcel$export(module.exports, "getHelpCenterPersistedTopBarSplitFlag", () => $de48218b235c0f42$export$8dce832817c5aeef);
$parcel$export(module.exports, "getHelpCenterTopBarColor", () => $de48218b235c0f42$export$734cf776f7b0100e);
$parcel$export(module.exports, "getHelpCenterTopBarTextColor", () => $de48218b235c0f42$export$eaa9a84fffbc3381);
$parcel$export(module.exports, "getKbHelpCenterLinkDomainURLs", () => $de48218b235c0f42$export$8b6136ed26edce36);
$parcel$export(module.exports, "getHelpCenterStateTranslationPersisted", () => $de48218b235c0f42$export$7a7dbec5ebf74e05);

var $63sfu = parcelRequire("63sfu");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
const $de48218b235c0f42$export$85757b7e55ef3c9f = (state)=>(0, $63sfu.mergeWith)({}, state.persisted.helpCenter, state.ui.helpCenterPreview, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/ban-types
    (_, srcValue)=>{
        // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
        // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
const $de48218b235c0f42$var$getTranslation = (state, language)=>$de48218b235c0f42$export$85757b7e55ef3c9f(state).translations[language];
const $de48218b235c0f42$export$976f80239b15365 = (state)=>$de48218b235c0f42$export$85757b7e55ef3c9f(state).logoUrl;
const $de48218b235c0f42$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $2hx7o.getLocale)(state);
    const translation = userLocale && $de48218b235c0f42$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $de48218b235c0f42$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $de48218b235c0f42$export$e22c5d06d177c3fa = (state)=>$de48218b235c0f42$export$85757b7e55ef3c9f(state).themeColor;
const $de48218b235c0f42$export$c2ab4f36d4c3d60a = (state)=>state.persisted.helpCenter.isLoaded;
const $de48218b235c0f42$export$d56e4bff0fec91ad = (state)=>{
    return !!state.persisted.helpCenter.knowledgeBase;
};
const $de48218b235c0f42$export$f18b5fbfa1271f69 = (state)=>{
    return state.persisted.helpCenter.rawBrandingResponse;
};
const $de48218b235c0f42$export$16e1b34e36aec9ef = (state)=>{
    const rawBrandingResponse = $de48218b235c0f42$export$f18b5fbfa1271f69(state);
    return rawBrandingResponse !== undefined ? rawBrandingResponse.siteDefaultLanguageTag : undefined;
};
const $de48218b235c0f42$export$3b3c747bea011f3c = (state)=>$de48218b235c0f42$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
const $de48218b235c0f42$export$eb9b5e885139dc39 = (state)=>$de48218b235c0f42$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
const $de48218b235c0f42$export$899cf8c7a36d20bc = (state)=>{
    const userLocale = (0, $2hx7o.getLocale)(state);
    const translation = userLocale && $de48218b235c0f42$var$getTranslation(state, userLocale);
    const helpCenterTitle = translation && translation.helpCenterTitle ? translation.helpCenterTitle : $de48218b235c0f42$export$85757b7e55ef3c9f(state).helpCenterTitle;
    return helpCenterTitle;
};
const $de48218b235c0f42$export$4b8ac8e47961f765 = (state)=>{
    return $de48218b235c0f42$export$85757b7e55ef3c9f(state).helpCenterTitleColor;
};
const $de48218b235c0f42$export$62574aae884b522a = (state)=>{
    return $de48218b235c0f42$export$85757b7e55ef3c9f(state).isBrandingLoaded;
};
const $de48218b235c0f42$export$76facf9cf6c06c3 = (state)=>{
    return $de48218b235c0f42$export$85757b7e55ef3c9f(state).hasTopBarBeenSplit;
};
const $de48218b235c0f42$export$8dce832817c5aeef = (state)=>{
    var _state$persisted$help;
    return (_state$persisted$help = state.persisted.helpCenter) === null || _state$persisted$help === void 0 ? void 0 : _state$persisted$help.hasTopBarBeenSplit;
};
const $de48218b235c0f42$export$734cf776f7b0100e = (state)=>{
    return $de48218b235c0f42$export$85757b7e55ef3c9f(state).topBarColor;
};
const $de48218b235c0f42$export$eaa9a84fffbc3381 = (state)=>{
    return $de48218b235c0f42$export$85757b7e55ef3c9f(state).topBarTextColor;
};
const $de48218b235c0f42$export$33a08d7ce0f06d3 = (state)=>{
    const helpCenterState = $de48218b235c0f42$export$85757b7e55ef3c9f(state);
    const announcementHeader = helpCenterState.announcementHeader ? helpCenterState.announcementHeader : undefined;
    const announcementMessage = helpCenterState.announcementMessage ? helpCenterState.announcementMessage : undefined;
    return {
        announcementHeader: announcementHeader,
        announcementMessage: announcementMessage
    };
};
const $de48218b235c0f42$export$8b6136ed26edce36 = (state)=>{
    var _state$persisted$help2;
    return ((_state$persisted$help2 = state.persisted.helpCenter) === null || _state$persisted$help2 === void 0 || (_state$persisted$help2 = _state$persisted$help2.knowledgeBase) === null || _state$persisted$help2 === void 0 ? void 0 : _state$persisted$help2.kbLinkDomainURLs) || [];
};
const $de48218b235c0f42$export$7a7dbec5ebf74e05 = (state)=>{
    return state.persisted.helpCenter.translations ?? {};
};

});





parcelRegister("O6qmY", function(module, exports) {
$parcel$export(module.exports, "resendValidationEmailEpic", () => $e23806002cedca45$export$a58a5733508cf172);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $aeY98 = parcelRequire("aeY98");
parcelRequire("3kjQH");
var $jrtA6 = parcelRequire("jrtA6");

var $cdcZE = parcelRequire("cdcZE");
const $e23806002cedca45$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS = 5000;
const $e23806002cedca45$export$a58a5733508cf172 = (action$)=>{
    return action$.ofType((0, $jrtA6.RESEND_VALIDATION_EMAIL)).mergeMap((transitionAction)=>{
        const { email: email, portalId: portalId, redirectUrl: redirectUrl } = transitionAction.payload;
        return (0, $aeY98.resendValidationEmail)(email, portalId, redirectUrl).flatMap(()=>(0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $gBYjj.showSuccessFlag)((0, $cdcZE.default).emailSentSuccessMessage, {
                emailAddress: email
            })), (0, $b0T1M.Observable).of((0, $jrtA6.resendValidationEmailSuccess)()), (0, $b0T1M.Observable).of((0, $jrtA6.enableResendValidationEmailLink)()).delay($e23806002cedca45$var$ENABLE_RESEND_VALIDATION_LINK_DELAY_IN_MS))).catch((error)=>{
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $jrtA6.resendValidationEmailFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error)), (0, $b0T1M.Observable).of((0, $jrtA6.enableResendValidationEmailLink)()));
        });
    });
};

});
parcelRegister("cdcZE", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a52ee97d8faeb9e$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $3a52ee97d8faeb9e$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    documentTitle: {
        defaultMessage: 'Verify your email',
        description: 'The text is shown as the browser document title on the email verification page, displayed in the browser tab after the user registers and is prompted to verify their email address.',
        id: 'cv.sign.up.check.email.document.title'
    },
    emailSentSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'The text is shown in a success notification after the user requests a verification email resend. The placeholder {emailAddress} will be substituted with the recipient email address.',
        id: 'cv.sign.up.check.email.resend.success.message'
    },
    checkEmailToFinishSignup: {
        defaultMessage: 'Check your email to set your password',
        description: 'The text is shown as the main heading on the sign-up email verification page, instructing the user to check their inbox to complete the password setup process.',
        id: 'cv.sign.up.check.your.email.to.signup'
    },
    emailSentHint: {
        defaultMessage: "We've sent information on how to set your password to {emailAddress}.",
        description: 'help text to explain that and email has been sent and that the user has to check his inbox',
        id: 'cv.sign.up.check.email.sub.title'
    },
    resendSignupLink: {
        defaultMessage: 'Resend password setup link',
        description: 'The text is shown on a button on the email verification page that allows the user to resend the password setup email if they did not receive it.',
        id: 'cv.sign.up.resend.signup.link.button'
    }
});

});


parcelRegister("6tCVT", function(module, exports) {
$parcel$export(module.exports, "updateUserProfileEpic", () => $3c75fb0aa23a6362$export$776b3daee68de137);
$parcel$export(module.exports, "validateAndSavePasswordChangeEpic", () => $3c75fb0aa23a6362$export$dbb7ca6f3fcbf9c2);
$parcel$export(module.exports, "validateEpic", () => $3c75fb0aa23a6362$export$4a45b80683fc2fca);
$parcel$export(module.exports, "changePasswordEpic", () => $3c75fb0aa23a6362$export$2ab2d1c48dcca790);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $fVVtD = parcelRequire("fVVtD");

var $k8GqG = parcelRequire("k8GqG");
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");

var $fI5Sq = parcelRequire("fI5Sq");

var $gdGyH = parcelRequire("gdGyH");

var $5wO6q = parcelRequire("5wO6q");
const $3c75fb0aa23a6362$export$776b3daee68de137 = (action$)=>{
    return action$.ofType((0, $3R99L.SAVE_USER_PROFILE)).mergeMap((updateUserProfileAction)=>{
        const { displayName: displayName, language: language, timezone: timezone } = updateUserProfileAction.payload;
        const languageKey = language === undefined ? undefined : language.originalKey;
        const timezoneId = timezone === undefined ? undefined : timezone.id;
        return (0, $k8GqG.updateUserProfile)(displayName, languageKey, timezoneId).flatMap(()=>(0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $3R99L.saveUserProfileSuccess)(displayName, language, timezone)), (0, $b0T1M.Observable).of((0, $gBYjj.showSuccessFlag)((0, $5wO6q.default).profileDetailsUpdatedHeaderMessage, undefined, (0, $5wO6q.default).profileDetailsUpdatedBodyMessage)))).catch((error)=>(0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $3R99L.saveUserProfileFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.handleAjaxError)(error))));
    });
};
const $3c75fb0aa23a6362$export$dbb7ca6f3fcbf9c2 = (action$)=>{
    return action$.ofType((0, $3R99L.VALIDATE_AND_SAVE_PASSWORD_CHANGE)).mergeMap((validateAndSavePasswordChangeAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validateAndSavePasswordChangeAction.payload;
        const validationErrors = $3c75fb0aa23a6362$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $3R99L.changePassword)(currentPassword, newPassword, confirmPassword);
        return (0, $b0T1M.Observable).of(result);
    });
};
const $3c75fb0aa23a6362$export$4a45b80683fc2fca = (action$)=>{
    return action$.ofType((0, $3R99L.VALIDATE_PASSWORD)).mergeMap((validatePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = validatePasswordAction.payload;
        const validationErrors = $3c75fb0aa23a6362$var$validate(currentPassword, newPassword, confirmPassword);
        const result = validationErrors || (0, $3R99L.validatePasswordSuccess)();
        return (0, $b0T1M.Observable).of(result);
    });
};
const $3c75fb0aa23a6362$var$validate = (currentPassword, newPassword, confirmPassword)=>{
    const currentPasswordError = !currentPassword.trim() ? (0, $5wO6q.default).currentPasswordMissingError : undefined;
    let newPasswordError = !newPassword.trim() ? (0, $5wO6q.default).newPasswordMissingError : undefined;
    let confirmPasswordError = !confirmPassword.trim() ? (0, $5wO6q.default).confirmPasswordMissingError : undefined;
    if (!newPasswordError && newPassword.length < (0, $gdGyH.MIN_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $5wO6q.default).newPasswordTooShortError;
    if (!newPasswordError && newPassword.length > (0, $gdGyH.MAX_PASSWORD_LENGTH_IN_CHARS)) newPasswordError = (0, $5wO6q.default).newPasswordTooLongError;
    if (!newPasswordError && !confirmPasswordError && confirmPassword !== newPassword) confirmPasswordError = (0, $5wO6q.default).confirmPasswordDoesNotMatchError;
    if (currentPasswordError || newPasswordError || confirmPasswordError) return (0, $3R99L.changePasswordFailure)(currentPasswordError, newPasswordError, confirmPasswordError, undefined);
    return undefined;
};
const $3c75fb0aa23a6362$export$2ab2d1c48dcca790 = (action$)=>{
    return action$.ofType((0, $3R99L.CHANGE_PASSWORD)).mergeMap((receivedChangePasswordAction)=>{
        const { currentPassword: currentPassword, newPassword: newPassword, confirmPassword: confirmPassword } = receivedChangePasswordAction.payload;
        return (0, $k8GqG.changePassword)(currentPassword, newPassword, confirmPassword).map(()=>{
            return (0, $fVVtD.logOutAction)();
        }).catch((error)=>{
            const jiraError = (0, $fI5Sq.getJiraErrorResponse)(error);
            if (jiraError) return (0, $b0T1M.Observable).of($3c75fb0aa23a6362$var$getJiraErrorFailure(jiraError, error));
            return (0, $b0T1M.Observable).of($3c75fb0aa23a6362$var$getGenericErrorFailure(error));
        });
    });
};
const $3c75fb0aa23a6362$var$getJiraErrorFailure = (jiraError, ajaxError)=>{
    const currentError = $3c75fb0aa23a6362$var$getPasswordError(jiraError, 'current');
    const newError = $3c75fb0aa23a6362$var$getPasswordError(jiraError, 'password');
    const confirmError = $3c75fb0aa23a6362$var$getPasswordError(jiraError, 'confirm');
    if (currentError === undefined && newError === undefined && confirmError === undefined) return $3c75fb0aa23a6362$var$getGenericErrorFailure(ajaxError);
    return (0, $3R99L.changePasswordFailure)(currentError, newError, confirmError, undefined);
};
const $3c75fb0aa23a6362$var$getPasswordError = (error, field)=>{
    return error.errors.filter((e)=>e.field === field).map((e)=>e.errorMessage)[0];
};
const $3c75fb0aa23a6362$var$getGenericErrorFailure = (error)=>{
    return (0, $3R99L.changePasswordFailure)(undefined, undefined, undefined, (0, $fI5Sq.getDefaultError)(error));
};

});
parcelRegister("gdGyH", function(module, exports) {
$parcel$export(module.exports, "MAX_FULL_NAME_LENGTH_IN_CHARS", () => $707dcf0b49d05cb7$export$abf6aa48eca27616);
$parcel$export(module.exports, "MAX_PASSWORD_LENGTH_IN_CHARS", () => $707dcf0b49d05cb7$export$778010a9ee5e9c9b);
$parcel$export(module.exports, "MIN_PASSWORD_LENGTH_IN_CHARS", () => $707dcf0b49d05cb7$export$5dbee9b10a861405);
$parcel$export(module.exports, "validateAll", () => $707dcf0b49d05cb7$export$d1393b0ce6100c11);
$parcel$export(module.exports, "validateFullName", () => $707dcf0b49d05cb7$export$8369f6c309ebe358);
$parcel$export(module.exports, "validatePassword", () => $707dcf0b49d05cb7$export$4d2a7159fda5dc93);

var $2eDSB = parcelRequire("2eDSB");
const $707dcf0b49d05cb7$export$abf6aa48eca27616 = 255;
const $707dcf0b49d05cb7$export$778010a9ee5e9c9b = 72;
const $707dcf0b49d05cb7$export$5dbee9b10a861405 = 8;
function $707dcf0b49d05cb7$export$d1393b0ce6100c11(fullName, password) {
    const fullNameError = $707dcf0b49d05cb7$export$8369f6c309ebe358(fullName);
    const passwordError = $707dcf0b49d05cb7$export$4d2a7159fda5dc93(password);
    if (fullNameError || passwordError) return {
        fullNameError: fullNameError,
        passwordError: passwordError
    };
    return undefined;
}
function $707dcf0b49d05cb7$export$8369f6c309ebe358(fullName) {
    const trimmedFullName = fullName.trim();
    if (trimmedFullName.length === 0) return (0, $2eDSB.default).fullNameMissingError;
    if (trimmedFullName.length > $707dcf0b49d05cb7$export$abf6aa48eca27616) return (0, $2eDSB.default).fullNameTooLongError;
    return undefined;
}
function $707dcf0b49d05cb7$export$4d2a7159fda5dc93(password) {
    if (password.trim().length === 0) return (0, $2eDSB.default).passwordMissingError;
    if (password.length < $707dcf0b49d05cb7$export$5dbee9b10a861405) return (0, $2eDSB.default).passwordTooShortError;
    if (password.length > $707dcf0b49d05cb7$export$778010a9ee5e9c9b) return (0, $2eDSB.default).passwordTooLongError;
    return undefined;
}

});
parcelRegister("2eDSB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca8dc699e5d77ea4$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $ca8dc699e5d77ea4$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    fullNameMissingError: {
        defaultMessage: 'You must enter a full name',
        description: 'Error message when the full name field is blank',
        id: 'cv.sign.up.full.name.empty.error'
    },
    fullNameTooLongError: {
        defaultMessage: 'Full name must be less than 255 characters',
        description: 'Error message when the full name field value is too long',
        id: 'cv.sign.up.full.name.too.long.error'
    },
    passwordMissingError: {
        defaultMessage: 'You must enter a password',
        description: 'Error message when the password field is blank',
        id: 'cv.sign.up.password.empty.error'
    },
    passwordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.sign.up.password.too.short.error'
    },
    passwordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.sign.up.password.too.long.error.old'
    }
});

});


parcelRegister("5wO6q", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad1a7fba3cee66ff$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $ad1a7fba3cee66ff$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    currentPasswordMissingError: {
        defaultMessage: 'You must type your current password',
        description: 'error message when the current password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.current.error'
    },
    newPasswordMissingError: {
        defaultMessage: 'You must specify a new password',
        description: 'error message when the new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.new.error'
    },
    newPasswordTooShortError: {
        defaultMessage: 'Password is too short',
        description: 'Error message that will show under the password field if it is shorter than 8 characters.',
        id: 'cv.user.profile.change.password.new.too.short.error'
    },
    newPasswordTooLongError: {
        defaultMessage: 'Password may not contain more than {maxPasswordLength, plural, one {# character} other {# characters}}',
        description: 'Error message when the password field value is too long',
        id: 'cv.user.profile.change.password.too.new.long.error'
    },
    confirmPasswordMissingError: {
        defaultMessage: 'You must re-type the new password',
        description: 'error message when the confirm new password field is blank in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.error'
    },
    confirmPasswordDoesNotMatchError: {
        defaultMessage: 'Passwords do not match',
        description: 'error message when the confirmation password does not match the new password in the change password dialog',
        id: 'cv.user.profile.change.password.confirm.mismatch.error'
    },
    profileDetailsUpdatedHeaderMessage: {
        defaultMessage: 'Profile details updated',
        description: 'message header when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.header'
    },
    profileDetailsUpdatedBodyMessage: {
        defaultMessage: 'Your changes may take up to five minutes to appear.',
        description: 'message body when the profile details are updated.',
        id: 'cv.user.profile.field.save.success.body'
    }
});

});


parcelRegister("3ceqH", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordEpic", () => $130a6d73376aad74$export$cb36b6e8b9a45314);

var $jd6MB = parcelRequire("jd6MB");
var $b0T1M = parcelRequire("b0T1M");

var $gBYjj = parcelRequire("gBYjj");

var $kV63N = parcelRequire("kV63N");
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");

var $fI5Sq = parcelRequire("fI5Sq");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");

var $6bGx7 = parcelRequire("6bGx7");
const $130a6d73376aad74$export$cb36b6e8b9a45314 = (action$)=>{
    return action$.ofType((0, $3R99L.USER_PROFILE_FORGOT_PASSWORD)).mergeMap((forgotPasswordAction)=>{
        const { resetUrl: resetUrl, email: email, createAnalyticsEvent: createAnalyticsEvent } = forgotPasswordAction.payload;
        return (0, $kV63N.forgotPassword)(resetUrl, email).flatMap(()=>{
            const successEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'sent',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            successEvent && (0, $keOG0.legacySendEvent)(successEvent);
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $3R99L.forgotPasswordSuccess)()), (0, $b0T1M.Observable).of((0, $gBYjj.showSuccessFlag)((0, $6bGx7.default).forgotPasswordSuccessFlagTitle, undefined, (0, $6bGx7.default).forgotPasswordSuccessFlagDescription, undefined, {
                emailAddress: email
            })));
        }).catch((error)=>{
            const failEvent = createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'userProfileForgotPasswordLink'
            });
            failEvent && (0, $keOG0.legacySendEvent)(failEvent);
            const parsedError = (0, $fI5Sq.getUserProfileForgotPasswordFailedError)(error);
            const errorAction = parsedError.action === undefined ? undefined : [
                parsedError.action
            ];
            return (0, $jd6MB.concat)((0, $b0T1M.Observable).of((0, $3R99L.forgotPasswordFailure)()), (0, $b0T1M.Observable).of((0, $gBYjj.showErrorFlag)(parsedError.title, parsedError.description, errorAction)));
        });
    });
};

});
parcelRegister("6bGx7", function(module, exports) {
$parcel$export(module.exports, "default", () => $002970469efea3ff$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $002970469efea3ff$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    forgotPasswordSuccessFlagTitle: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Message title for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.title'
    },
    forgotPasswordSuccessFlagDescription: {
        defaultMessage: "We've sent a reset password link to {emailAddress}.",
        description: 'Message descritpion for toast flag when the forgot password action is successful.',
        id: 'cv.user.profile.forgot.password.success.flag.description'
    }
});

});



parcelRegister("gKlTs", function(module, exports) {
$parcel$export(module.exports, "getCombinedPersistedReducer", () => $698f62349ec467ae$export$1e1389697ca32ad5);
$parcel$export(module.exports, "default", () => $698f62349ec467ae$export$2e2bcd8739ae039);
parcelRequire("2pQ8V");
var $8Qej1 = parcelRequire("8Qej1");
parcelRequire("lVVH7");
var $1v2I9 = parcelRequire("1v2I9");

var $6bGmX = parcelRequire("6bGmX");
parcelRequire("kCLhW");
var $aovtE = parcelRequire("aovtE");
parcelRequire("624kd");
var $3eg1t = parcelRequire("3eg1t");
parcelRequire("JpGvS");
var $5Gz0W = parcelRequire("5Gz0W");
parcelRequire("fpsdZ");
var $95js3 = parcelRequire("95js3");
parcelRequire("jJU4g");
var $ah6hF = parcelRequire("ah6hF");
parcelRequire("kWwNi");
var $kMjJD = parcelRequire("kMjJD");
parcelRequire("2x03u");
var $qXAS1 = parcelRequire("qXAS1");
parcelRequire("6sHIZ");
var $caA4b = parcelRequire("caA4b");
parcelRequire("hT4qI");
var $hJPIq = parcelRequire("hJPIq");
parcelRequire("1nTl3");
var $709uz = parcelRequire("709uz");
parcelRequire("jRevb");
var $1lacs = parcelRequire("1lacs");
parcelRequire("84ozY");
var $ep4N8 = parcelRequire("ep4N8");
parcelRequire("jUG4n");
var $8vpEF = parcelRequire("8vpEF");
parcelRequire("76U79");
var $gC9el = parcelRequire("gC9el");
parcelRequire("jsZn7");
var $ksOPZ = parcelRequire("ksOPZ");
parcelRequire("eZ0Tb");
var $ScUz4 = parcelRequire("ScUz4");
parcelRequire("fTbZc");
var $izIW6 = parcelRequire("izIW6");
parcelRequire("hX3wg");
var $i5IG1 = parcelRequire("i5IG1");
parcelRequire("lK7Yv");
var $5vmki = parcelRequire("5vmki");
parcelRequire("50XJ7");
var $1xGnK = parcelRequire("1xGnK");
parcelRequire("j7hgW");
var $7Wy2K = parcelRequire("7Wy2K");
parcelRequire("5TN6q");
var $li9Ka = parcelRequire("li9Ka");
parcelRequire("1nMsA");
var $6YtKA = parcelRequire("6YtKA");
parcelRequire("jcmVC");
var $5p1lg = parcelRequire("5p1lg");
parcelRequire("1REWU");
var $lSmFU = parcelRequire("lSmFU");
parcelRequire("3ZGeF");
var $fMx6O = parcelRequire("fMx6O");
parcelRequire("8wTW2");
var $UthGp = parcelRequire("UthGp");
parcelRequire("c4FNG");
var $hHyyT = parcelRequire("hHyyT");
parcelRequire("58BPm");
var $pWj3c = parcelRequire("pWj3c");
parcelRequire("adTbC");
var $2WLfx = parcelRequire("2WLfx");
parcelRequire("86yRB");
var $2FEkJ = parcelRequire("2FEkJ");
parcelRequire("d0dlB");
var $9Y0l3 = parcelRequire("9Y0l3");
parcelRequire("je5sV");
var $fnUlz = parcelRequire("fnUlz");
const $698f62349ec467ae$var$reducerCollection = {
    helpCenter: (0, $709uz.default),
    portals: (0, $i5IG1.default),
    user: (0, $2WLfx.default),
    env: (0, $qXAS1.default),
    meta: (0, $ScUz4.default),
    organisations: (0, $izIW6.default),
    requestCreate: (0, $7Wy2K.default),
    requestTypeSuggestion: (0, $5p1lg.default),
    connectFragments: (0, $kMjJD.default),
    kbArticles: (0, $1lacs.default),
    portalCustomisation: (0, $5vmki.portalCustomisationReducer),
    unsubscribedConfirmation: (0, $pWj3c.unsubscribedConfirmationReducer),
    login: (0, $gC9el.loginReducer),
    forgotPassword: (0, $hJPIq.forgotPasswordReducer),
    requestDetails: (0, $li9Ka.requestDetailsReducer),
    timezones: (0, $UthGp.timezonesReducer),
    languages: (0, $ep4N8.languagesReducer),
    profileWebFragments: (0, $1xGnK.profileWebFragmentReducer),
    requestList: (0, $6YtKA.requestListReducer),
    approvalList: (0, $5Gz0W.approvalListReducer),
    visitPortal: (0, $fnUlz.visitPortalReducer),
    resetPassword: (0, $lSmFU.resetPasswordReducer),
    completeSignup: (0, $ah6hF.completeSignupReducer),
    verifyEmail: (0, $9Y0l3.verifyEmailReducer),
    signUp: (0, $fMx6O.signUpReducer),
    userRequestsCounts: (0, $2FEkJ.default),
    anonymousApproval: (0, $3eg1t.anonymousApprovalReducer),
    featuredAndSortedPortals: (0, $caA4b.featuredAndSortedPortalsReducer),
    loginAnnouncements: (0, $ksOPZ.loginAnnouncementsReducer),
    blockedAppsBanner: (0, $1v2I9.default),
    aiAnswerFeedbackPage: (0, $aovtE.aiAnswerReducer),
    linkedSpaces: (0, $8vpEF.default),
    branding: (0, $95js3.brandingReducer),
    ...(0, $6bGmX.default).checkGate('ditto_uim_root_query_rest') ? {
        uiModifications: (0, $hHyyT.uiModificationsReducer)
    } : {}
};
const $698f62349ec467ae$export$1e1389697ca32ad5 = (asyncReducers)=>(0, $8Qej1.default)({
        ...$698f62349ec467ae$var$reducerCollection,
        ...asyncReducers
    });
var $698f62349ec467ae$export$2e2bcd8739ae039 = (0, $8Qej1.default)($698f62349ec467ae$var$reducerCollection);

});
parcelRegister("lVVH7", function(module, exports) {
$parcel$export(module.exports, "blockedAppsBannerReducer", () => (parcelRequire("1v2I9")).default);

var $1v2I9 = parcelRequire("1v2I9");

});
parcelRegister("1v2I9", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsBanner", () => $fe80de49cf1b2c91$export$de142fee58ebb9a8);
$parcel$export(module.exports, "mapConnectDispatchToPropsBanner", () => $fe80de49cf1b2c91$export$b08e00302c3c215c);
$parcel$export(module.exports, "default", () => $fe80de49cf1b2c91$export$2e2bcd8739ae039);
const $fe80de49cf1b2c91$export$e872b6f4d4c58319 = 'state.persisted.blockedAppsBanner.SHOW_BANNER';
const $fe80de49cf1b2c91$export$8c1102f190441ac3 = 'state.persisted.blockedAppsBanner.SHOW_CONNECT_BANNER';
const $fe80de49cf1b2c91$export$c23ca0c98b7b93db = 'state.persisted.blockedAppsBanner.RESET_BANNER_STATE';
const $fe80de49cf1b2c91$export$24e8a154ba80b759 = 'state.persisted.blockedAppsBanner.RESET_CONNECT_BANNER_STATE';
const $fe80de49cf1b2c91$export$ad5fb8b7cdde24d7 = 'create_request';
const $fe80de49cf1b2c91$export$e63cec9acfdad935 = 'view_request';
const $fe80de49cf1b2c91$export$ac4d91f5203d82ae = 'portal';
const $fe80de49cf1b2c91$var$defaultState = {
    create_request: false,
    portal: false,
    view_request: false,
    connect: {
        create_request: false,
        view_request: false,
        portal: false
    }
};
const $fe80de49cf1b2c91$export$4a89ccf10a725e56 = (page)=>({
        type: $fe80de49cf1b2c91$export$e872b6f4d4c58319,
        payload: {
            page: page
        }
    });
const $fe80de49cf1b2c91$export$cf79152bba576f84 = (page)=>({
        type: $fe80de49cf1b2c91$export$8c1102f190441ac3,
        payload: {
            page: page
        }
    });
const $fe80de49cf1b2c91$export$4d7eca3346df6596 = (page)=>({
        type: $fe80de49cf1b2c91$export$c23ca0c98b7b93db,
        payload: {
            page: page
        }
    });
const $fe80de49cf1b2c91$export$9a8e10487635d611 = (page)=>({
        type: $fe80de49cf1b2c91$export$24e8a154ba80b759,
        payload: {
            page: page
        }
    });
const $fe80de49cf1b2c91$export$e04d0f37424da45e = (connectPageName)=>{
    switch(connectPageName){
        case 'PORTAL':
            return $fe80de49cf1b2c91$export$ac4d91f5203d82ae;
        case 'CREATE_REQUEST':
            return $fe80de49cf1b2c91$export$ad5fb8b7cdde24d7;
        case 'VIEW_REQUEST':
            return $fe80de49cf1b2c91$export$e63cec9acfdad935;
        default:
            return null;
    }
};
const $fe80de49cf1b2c91$export$912af6a6ce89d10c = (forgePageName)=>{
    let screen;
    switch(forgePageName){
        case 'create_request':
            screen = $fe80de49cf1b2c91$export$ad5fb8b7cdde24d7;
            break;
        case 'portal':
            screen = $fe80de49cf1b2c91$export$ac4d91f5203d82ae;
            break;
        case 'view_request':
            screen = $fe80de49cf1b2c91$export$e63cec9acfdad935;
            break;
        default:
            screen = null;
    }
    return screen;
};
const $fe80de49cf1b2c91$export$a1659b54bac3252a = ()=>{
    return {
        ...$fe80de49cf1b2c91$var$defaultState
    };
};
const $fe80de49cf1b2c91$export$de142fee58ebb9a8 = (dispatch)=>{
    return {
        showBanner: (forgePageName)=>{
            return dispatch($fe80de49cf1b2c91$export$4a89ccf10a725e56($fe80de49cf1b2c91$export$912af6a6ce89d10c(forgePageName)));
        },
        resetBannerState: (forgePageName)=>{
            return dispatch($fe80de49cf1b2c91$export$4d7eca3346df6596($fe80de49cf1b2c91$export$912af6a6ce89d10c(forgePageName)));
        }
    };
};
const $fe80de49cf1b2c91$export$b08e00302c3c215c = {
    showBanner: (connectPageName)=>{
        return $fe80de49cf1b2c91$export$cf79152bba576f84($fe80de49cf1b2c91$export$e04d0f37424da45e(connectPageName));
    },
    resetBannerState: (connectPageName)=>{
        return $fe80de49cf1b2c91$export$9a8e10487635d611($fe80de49cf1b2c91$export$e04d0f37424da45e(connectPageName));
    }
};
function $fe80de49cf1b2c91$export$2e2bcd8739ae039(currentState = $fe80de49cf1b2c91$export$a1659b54bac3252a(), action) {
    const newState = {
        ...currentState
    };
    switch(action.type){
        case $fe80de49cf1b2c91$export$e872b6f4d4c58319:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = true;
                return newState;
            }
        case $fe80de49cf1b2c91$export$8c1102f190441ac3:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: true
                };
                return newState;
            }
        case $fe80de49cf1b2c91$export$c23ca0c98b7b93db:
            {
                const screen = action.payload.page;
                if (screen) newState[screen] = false;
                return newState;
            }
        case $fe80de49cf1b2c91$export$24e8a154ba80b759:
            {
                const screen = action.payload.page;
                if (screen) newState.connect = {
                    ...currentState.connect,
                    [screen]: false
                };
                return newState;
            }
        default:
            return currentState;
    }
}

});


parcelRegister("kCLhW", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => (parcelRequire("aovtE")).aiAnswerReducer);

var $aovtE = parcelRequire("aovtE");

});
parcelRegister("aovtE", function(module, exports) {
$parcel$export(module.exports, "aiAnswerReducer", () => $30ede9bc2a5b74c7$export$2a26170741a0330c);
parcelRequire("cad2o");
var $b6TGM = parcelRequire("b6TGM");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $30ede9bc2a5b74c7$var$defaultState = {
    feedback: '',
    issueKey: '',
    projectId: 0,
    initialError: undefined
};
const $30ede9bc2a5b74c7$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.aiAnswerFeedbackPage) return initialModelState.aiAnswerFeedbackPage;
    return $30ede9bc2a5b74c7$var$defaultState;
};
function $30ede9bc2a5b74c7$export$2a26170741a0330c(state = $30ede9bc2a5b74c7$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $b6TGM.FETCH_AI_ANSWER_FEEDBACK_SUCCESS:
            return $30ede9bc2a5b74c7$var$handleFetchAiAnswerFeedbackSuccess(state, action);
        case 0, $b6TGM.FETCH_AI_ANSWER_FEEDBACK_FAILURE:
            return $30ede9bc2a5b74c7$var$handleFetchAiAnswerFeedbackFailure(state, action);
        default:
            return state;
    }
}
function $30ede9bc2a5b74c7$var$handleFetchAiAnswerFeedbackSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        feedback: response.feedback,
        issueKey: response.issueKey,
        projectId: response.projectId
    };
}
function $30ede9bc2a5b74c7$var$handleFetchAiAnswerFeedbackFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("624kd", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => (parcelRequire("3eg1t")).anonymousApprovalReducer);

var $3eg1t = parcelRequire("3eg1t");

});
parcelRegister("3eg1t", function(module, exports) {
$parcel$export(module.exports, "anonymousApprovalReducer", () => $a63b80bce7aa04e6$export$12846d9286d41238);

var $9mQxZ = parcelRequire("9mQxZ");
const $a63b80bce7aa04e6$var$defaultState = {
    token: '',
    requestDetailsUrl: '',
    loggedIn: false,
    initialError: undefined
};
const $a63b80bce7aa04e6$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.anonymousApproval) return initialModelState.anonymousApproval;
    return $a63b80bce7aa04e6$var$defaultState;
};
const $a63b80bce7aa04e6$export$12846d9286d41238 = (state = $a63b80bce7aa04e6$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("JpGvS", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => (parcelRequire("5Gz0W")).approvalListReducer);

var $5Gz0W = parcelRequire("5Gz0W");

});
parcelRegister("5Gz0W", function(module, exports) {
$parcel$export(module.exports, "approvalListReducer", () => $a781d3433ca1bcac$export$18397d0445d17954);
parcelRequire("g99P5");
var $cht5V = parcelRequire("cht5V");

var $bG6ob = parcelRequire("bG6ob");
const $a781d3433ca1bcac$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    },
    portalsRequestTypes: []
};
const $a781d3433ca1bcac$var$defaultState = $a781d3433ca1bcac$var$emptyState;
function $a781d3433ca1bcac$export$18397d0445d17954(state = $a781d3433ca1bcac$var$defaultState, action) {
    switch(action.type){
        case 0, $cht5V.FETCH_APPROVAL_LIST_SUCCESS:
            return $a781d3433ca1bcac$var$handleFetchApprovalListSuccess(state, action);
        default:
            return state;
    }
}
function $a781d3433ca1bcac$var$handleFetchApprovalListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.totalResults !== state.totalResults;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requests.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requests : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        approvalFilter: response.approvalFilterValue,
        portalId: response.portalId,
        requestTypeId: response.requestTypeId,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        nextToken: response.nextToken,
        allRows: newRows,
        pages: {
            isInitialPageLoad: false,
            [response.selectedPage]: response.requests
        },
        portalsRequestTypes: response.portalRequestTypes
    };
}
function $a781d3433ca1bcac$var$handleFetchApprovalListSuccess(state, action) {
    if ((0, $bG6ob.isApprovalListInfiniteScrollEnabled)()) return $a781d3433ca1bcac$var$handleFetchApprovalListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) return {
            ...state,
            pages: {
                ...state.pages,
                [response.selectedPage]: response.requests
            }
        };
        return {
            approvalFilter: response.approvalFilterValue,
            portalId: response.portalId,
            requestTypeId: response.requestTypeId,
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requests
            },
            portalsRequestTypes: response.portalRequestTypes
        };
    }
    return state;
}

});


parcelRegister("fpsdZ", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => (parcelRequire("95js3")).brandingReducer);

var $95js3 = parcelRequire("95js3");

});
parcelRegister("95js3", function(module, exports) {
$parcel$export(module.exports, "brandingReducer", () => $793b1108794d8722$export$77a6a980433b33f5);

var $9mQxZ = parcelRequire("9mQxZ");
const $793b1108794d8722$var$defaultState = {
    id: '',
    key: '',
    name: '',
    portalBaseUrl: ''
};
const $793b1108794d8722$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.branding) return initialModelState.branding;
    return $793b1108794d8722$var$defaultState;
};
const $793b1108794d8722$export$77a6a980433b33f5 = (state = $793b1108794d8722$export$53ac33307b5acee9(), _)=>state;

});


parcelRegister("jJU4g", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => (parcelRequire("ah6hF")).completeSignupReducer);

var $ah6hF = parcelRequire("ah6hF");

});
parcelRegister("ah6hF", function(module, exports) {
$parcel$export(module.exports, "completeSignupReducer", () => $4f19ba9269ea9241$export$b5b8ee9188984cd7);
parcelRequire("iKA91");
var $1uz6E = parcelRequire("1uz6E");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $4f19ba9269ea9241$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: undefined,
    portalId: undefined,
    initialError: undefined
};
const $4f19ba9269ea9241$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.completeSignup) return initialModelState.completeSignup;
    return $4f19ba9269ea9241$var$defaultState;
};
function $4f19ba9269ea9241$export$b5b8ee9188984cd7(state = $4f19ba9269ea9241$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $1uz6E.FETCH_COMPLETE_SIGNUP_SUCCESS:
            return $4f19ba9269ea9241$var$handleFetchCompleteSignupSuccess(state, action);
        case 0, $1uz6E.FETCH_COMPLETE_SIGNUP_FAILURE:
            return $4f19ba9269ea9241$var$handleFetchCompleteSignupFailure(state, action);
        default:
            return state;
    }
}
function $4f19ba9269ea9241$var$handleFetchCompleteSignupSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        signupToken: response.signupToken,
        emailAddress: response.emailAddress,
        validationOutcome: response.validationOutcome,
        portalId: response.portalId,
        redirectUrl: response.redirectUrl
    };
}
function $4f19ba9269ea9241$var$handleFetchCompleteSignupFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});


parcelRegister("kWwNi", function(module, exports) {
$parcel$export(module.exports, "connectFragmentsReducer", () => (parcelRequire("kMjJD")).default);
$parcel$export(module.exports, "generateKey", () => (parcelRequire("kMjJD")).generateKey);

var $kMjJD = parcelRequire("kMjJD");

});
parcelRegister("kMjJD", function(module, exports) {
$parcel$export(module.exports, "generateKey", () => $32163d6d1a858c74$export$3a7728e868aa3ebd);
$parcel$export(module.exports, "default", () => $32163d6d1a858c74$export$2e2bcd8739ae039);
parcelRequire("g3u0z");
var $lWKdO = parcelRequire("lWKdO");

var $9mQxZ = parcelRequire("9mQxZ");
const $32163d6d1a858c74$export$3a7728e868aa3ebd = (portalPageName, portalId, requestTypeId, requestKey)=>`${portalPageName}_${portalId || 'none'}_${requestTypeId || 'none'}${`_${requestKey || 'none'}`}`;
const $32163d6d1a858c74$export$a1659b54bac3252a = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    const { portal: portal, portalWebFragments: portalWebFragments, reqCreate: reqCreate } = initialModelState;
    const initialState = {
        HELP_CENTER_none_none: {},
        PORTAL_none_none: {},
        CREATE_REQUEST_none_none: {},
        REQUEST_DETAILS_none_none: {},
        PROFILE_none_none: {}
    };
    if (portal && portalWebFragments && reqCreate) {
        const { id: portalId } = portal;
        const { id: requestTypeId } = reqCreate;
        const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = portalWebFragments;
        const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
        return {
            ...initialState,
            [$32163d6d1a858c74$export$3a7728e868aa3ebd('CREATE_REQUEST', Number(portalId), requestTypeId, undefined)]: {
                headerPanels: headerPanels,
                subheaderPanels: subheaderPanels,
                footerPanels: footerPanels,
                propertyPanels: propertyPanels
            }
        };
    }
    return initialState;
};
const $32163d6d1a858c74$export$49d5fc8cba920a0 = $32163d6d1a858c74$export$a1659b54bac3252a();
function $32163d6d1a858c74$export$2e2bcd8739ae039(state = $32163d6d1a858c74$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $lWKdO.FETCH_CONNECT_FRAGMENTS_SUCCESS:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, connectFragments: connectFragments, requestKey: requestKey } = action.payload;
                const { headerPanels: headerPanels, subheaderPanels: subheaderPanels, footerPanels: footerPanels, pagePanels: pagePanels } = connectFragments;
                const propertyPanels = pagePanels ? pagePanels.propertyPanels : [];
                return {
                    ...state,
                    [$32163d6d1a858c74$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        headerPanels: headerPanels,
                        subheaderPanels: subheaderPanels,
                        footerPanels: footerPanels,
                        propertyPanels: propertyPanels
                    }
                };
            }
        case 0, $lWKdO.FETCH_CONNECT_FRAGMENTS_FAILURE:
            {
                const { portalPageName: portalPageName, portalId: portalId, requestTypeId: requestTypeId, error: error, requestKey: requestKey } = action.payload;
                return {
                    ...state,
                    [$32163d6d1a858c74$export$3a7728e868aa3ebd(portalPageName, portalId, requestTypeId, requestKey)]: {
                        error: error
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("2x03u", function(module, exports) {
$parcel$export(module.exports, "envReducer", () => (parcelRequire("qXAS1")).default);

var $qXAS1 = parcelRequire("qXAS1");

});
parcelRegister("qXAS1", function(module, exports) {
$parcel$export(module.exports, "default", () => $03440476edbd5371$export$2e2bcd8739ae039);
parcelRequire("jYob8");
var $cGPrY = parcelRequire("cGPrY");

var $ebpTf = parcelRequire("ebpTf");
const $03440476edbd5371$var$getStateFromEnvObject = (envObject)=>({
        headless: envObject.headless,
        wacLink: envObject.wacLink,
        xsrfToken: envObject.xsrfToken,
        baseUrl: envObject.baseUrl,
        mediaApiAppClientId: envObject.mediaApiAppClientId,
        mediaApiExternalUrl: envObject.mediaApiExternalUrl,
        serviceDeskVersion: envObject.serviceDeskVersion,
        featureFlags: envObject.featureFlags,
        contactLink: envObject.contactLink,
        anonymousEnabled: envObject.anonymousEnabled,
        fabricEmojiUrl: envObject.fabricEmojiUrl,
        jiraDisplayUrl: envObject.jiraDisplayUrl,
        helpCenterType: envObject.helpCenterType,
        featuredValues: envObject.featuredValues,
        hoistedProjectKey: envObject.hoistedProjectKey,
        customerAccountAvailabilty: envObject.customerAccountAvailabilty
    });
const $03440476edbd5371$var$defaultState = $03440476edbd5371$var$getStateFromEnvObject((0, $ebpTf.getEnv)());
function $03440476edbd5371$export$2e2bcd8739ae039(state = $03440476edbd5371$var$defaultState, action) {
    switch(action.type){
        case 0, $cGPrY.UPDATE_ENV:
            {
                const newState = $03440476edbd5371$var$getStateFromEnvObject(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $cGPrY.UPDATE_XSRF:
            return {
                ...state,
                xsrfToken: action.payload
            };
        default:
            return state;
    }
}

});


parcelRegister("6sHIZ", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("caA4b")).featuredAndSortedPortalsReducer);

var $caA4b = parcelRequire("caA4b");

});
parcelRegister("caA4b", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $656fc38e8c2b33a4$export$be9fe934804fce97);
parcelRequire("7LVOt");
var $db9ld = parcelRequire("db9ld");
parcelRequire("9MU8X");
var $2wESx = parcelRequire("2wESx");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $656fc38e8c2b33a4$var$FEATURED_PORTALS_LIMIT = 15;
const $656fc38e8c2b33a4$export$1c29b8ca59adcf6d = {
    portals: {},
    orderedPortalIds: [],
    sortBy: 'POPULARITY',
    limit: $656fc38e8c2b33a4$var$FEATURED_PORTALS_LIMIT,
    total: 0,
    isPortalHidingEnabled: false
};
const $656fc38e8c2b33a4$export$eb6ead3c9b4f1957 = (portals)=>{
    return portals.reduce((acc, portalSummary)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        acc[portalSummary.id] = {
            id: portalSummary.id,
            key: portalSummary.key,
            name: portalSummary.name,
            description: portalSummary.description,
            logoUrl: portalSummary.logoUrl,
            isFeatured: 'isFeatured' in portalSummary && portalSummary.isFeatured,
            rank: 'rank' in portalSummary && portalSummary.rank,
            isPortalNotVisibleOnHelpCentre: portalSummary.isPortalNotVisibleOnHelpCentre,
            hiddenFromHomeScreen: 'hiddenFromHomeScreen' in portalSummary && portalSummary.hiddenFromHomeScreen
        };
        return acc;
    }, {});
};
const $656fc38e8c2b33a4$export$67c021876d6362b9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals) {
        const modelResponse = initialModelState.featuredAndSortedPortals;
        return {
            portals: $656fc38e8c2b33a4$export$eb6ead3c9b4f1957(modelResponse.portals),
            orderedPortalIds: modelResponse.portals.map((portal)=>portal.id),
            sortBy: modelResponse.sortBy ? modelResponse.sortBy : 'POPULARITY',
            limit: modelResponse.limit ? modelResponse.limit : $656fc38e8c2b33a4$var$FEATURED_PORTALS_LIMIT,
            total: modelResponse.total ? modelResponse.total : 0,
            isPortalHidingEnabled: modelResponse.isPortalHidingEnabled
        };
    }
    return $656fc38e8c2b33a4$export$1c29b8ca59adcf6d;
};
const $656fc38e8c2b33a4$var$defaultState = $656fc38e8c2b33a4$export$67c021876d6362b9();
/**
 * This method is to return only those portals which are not already stored
 * This ensures that the rank and isFeatured values stored in existing data will not get overridden with new data missing these values
 */ const $656fc38e8c2b33a4$var$getPortalsNotAlreadyStored = (storedPortals, portals)=>{
    return portals.filter((portal)=>!storedPortals[portal.id]);
};
const $656fc38e8c2b33a4$var$updateFeaturedPortals = (state, updatedFeaturedPortalIds, updatedOrderedPortalIds, hiddenPortalIds)=>{
    const portals = {};
    updatedOrderedPortalIds.forEach((portalId)=>{
        portals[portalId] = {
            id: portalId,
            key: state.portals[portalId].key,
            name: state.portals[portalId].name,
            description: state.portals[portalId].description,
            logoUrl: state.portals[portalId].logoUrl,
            isPortalNotVisibleOnHelpCentre: state.portals[portalId].isPortalNotVisibleOnHelpCentre,
            isFeatured: false,
            hiddenFromHomeScreen: hiddenPortalIds.includes(portalId),
            rank: -1
        };
    });
    updatedFeaturedPortalIds.forEach((portalId, index)=>{
        portals[portalId] = {
            ...portals[portalId],
            isFeatured: true,
            rank: index
        };
    });
    return portals;
};
function $656fc38e8c2b33a4$export$be9fe934804fce97(state = $656fc38e8c2b33a4$var$defaultState, action) {
    switch(action.type){
        case 0, $db9ld.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $656fc38e8c2b33a4$var$handleFetchFeaturedAndSortedPortalsSuccess(action, state);
        case 0, $db9ld.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $656fc38e8c2b33a4$var$handleFetchFeaturedAndSortedPortalsFailure(action, state);
        case 0, $db9ld.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $656fc38e8c2b33a4$var$handleUpdatePortalReorderSettingsSuccess(action, state);
        default:
            return state;
    }
}
const $656fc38e8c2b33a4$var$handleFetchFeaturedAndSortedPortalsSuccess = (action, state)=>{
    const { portals: portals, sortBy: sortBy, limit: limit, total: total, isPortalHidingEnabled: isPortalHidingEnabled } = action.payload;
    /* On help seeker screen */ if (!action.requestParams.isPortalReorderingSelected) {
        /* On clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            portals: {
                ...state.portals,
                ...$656fc38e8c2b33a4$export$eb6ead3c9b4f1957($656fc38e8c2b33a4$var$getPortalsNotAlreadyStored(state.portals, portals))
            },
            orderedPortalIds: portals.map((portal)=>portal.id)
        };
        /* initial load */ return {
            ...state,
            isPortalHidingEnabled: isPortalHidingEnabled,
            portals: $656fc38e8c2b33a4$export$eb6ead3c9b4f1957(portals),
            orderedPortalIds: portals.map((portal)=>portal.id),
            sortBy: sortBy ? sortBy : 'POPULARITY',
            limit: limit ? limit : $656fc38e8c2b33a4$var$FEATURED_PORTALS_LIMIT,
            total: total ? total : 0,
            error: undefined
        };
    }
    /* On Portal reordering screen initial load */ if (!action.requestParams.sortBy) return {
        ...state,
        isPortalHidingEnabled: isPortalHidingEnabled,
        portals: $656fc38e8c2b33a4$export$eb6ead3c9b4f1957(portals),
        orderedPortalIds: portals.map((portal)=>portal.id),
        sortBy: sortBy ? sortBy : 'POPULARITY',
        limit: limit ? limit : $656fc38e8c2b33a4$var$FEATURED_PORTALS_LIMIT,
        total: total ? total : 0,
        error: undefined
    };
    return state;
};
const $656fc38e8c2b33a4$var$handleFetchFeaturedAndSortedPortalsFailure = (action, state)=>{
    const { error: error } = action.payload;
    const errorObject = {
        status: error.status,
        message: (error.errorMessages || [])[0],
        callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    /* Error in both help center and portal reordering view initial loads */ if (!action.requestParams.sortBy) return {
        ...state,
        error: errorObject
    };
    return state;
};
const $656fc38e8c2b33a4$var$handleUpdatePortalReorderSettingsSuccess = (action, state)=>{
    const { featuredPortalIds: featuredPortalIds, sortBy: sortBy, orderedPortalIds: orderedPortalIds, hiddenPortalIds: hiddenPortalIds } = action.payload;
    const portals = $656fc38e8c2b33a4$var$updateFeaturedPortals(state, featuredPortalIds, orderedPortalIds, hiddenPortalIds);
    const total = Object.values(portals).filter((portal)=>!(0, $2wESx.isHiddenPortal)(portal)).length;
    return {
        ...state,
        sortBy: sortBy,
        orderedPortalIds: orderedPortalIds,
        portals: portals,
        total: total
    };
};

});
parcelRegister("9MU8X", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => (parcelRequire("2wESx")).getFeaturedPortalsInSortedOrderByRank);
$parcel$export(module.exports, "isFeaturedPortal", () => (parcelRequire("2wESx")).isFeaturedPortal);
$parcel$export(module.exports, "isHiddenPortal", () => (parcelRequire("2wESx")).isHiddenPortal);
$parcel$export(module.exports, "getPortals", () => (parcelRequire("2wESx")).getPortals);
$parcel$export(module.exports, "getSortBy", () => (parcelRequire("2wESx")).getSortBy);
$parcel$export(module.exports, "getLimit", () => (parcelRequire("2wESx")).getLimit);
$parcel$export(module.exports, "getIsDirty", () => (parcelRequire("2wESx")).getIsDirty);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => (parcelRequire("2wESx")).getIsReorderingExperienceLoading);
$parcel$export(module.exports, "getIsSortedDataLoading", () => (parcelRequire("2wESx")).getIsSortedDataLoading);
$parcel$export(module.exports, "getTotal", () => (parcelRequire("2wESx")).getTotal);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => (parcelRequire("2wESx")).getfeaturedAndSortedPortalsError);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => (parcelRequire("2wESx")).getUIFeaturedPortalIds);
$parcel$export(module.exports, "getUISortBy", () => (parcelRequire("2wESx")).getUISortBy);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => (parcelRequire("2wESx")).getUIOrderedPortalIds);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => (parcelRequire("2wESx")).getPersistedOrderedPortalIds);
$parcel$export(module.exports, "getIsSaveInProgress", () => (parcelRequire("2wESx")).getIsSaveInProgress);
$parcel$export(module.exports, "getDefaultViewLoading", () => (parcelRequire("2wESx")).getDefaultViewLoading);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => (parcelRequire("2wESx")).getIsPortalReorderingDataLoaded);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => (parcelRequire("2wESx")).getUIHiddenPortalIds);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => (parcelRequire("2wESx")).getIsPortalHidingEnabled);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => (parcelRequire("2wESx")).getTotalVisiblePortalCount);
$parcel$export(module.exports, "getAllVisiblePortals", () => (parcelRequire("2wESx")).getAllVisiblePortals);
$parcel$export(module.exports, "getDefaultViewPortals", () => (parcelRequire("2wESx")).getDefaultViewPortals);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => (parcelRequire("2wESx")).getFeaturedPortalsUI);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => (parcelRequire("2wESx")).getUnFeaturedPortalsUI);

var $2wESx = parcelRequire("2wESx");

});
parcelRegister("2wESx", function(module, exports) {
$parcel$export(module.exports, "getFeaturedPortalsInSortedOrderByRank", () => $30aea7391225c414$export$92cc2a471200c3dd);
$parcel$export(module.exports, "isFeaturedPortal", () => $30aea7391225c414$export$4758cf9aa2bbe6ae);
$parcel$export(module.exports, "isHiddenPortal", () => $30aea7391225c414$export$40fc3a80f8881250);
$parcel$export(module.exports, "getPersistedOrderedPortalIds", () => $30aea7391225c414$export$22d41892c655b6a1);
$parcel$export(module.exports, "getUIFeaturedPortalIds", () => $30aea7391225c414$export$9d389d624d531812);
$parcel$export(module.exports, "getUIHiddenPortalIds", () => $30aea7391225c414$export$8bc764a453455857);
$parcel$export(module.exports, "getUIOrderedPortalIds", () => $30aea7391225c414$export$e907b47f94c1ad77);
$parcel$export(module.exports, "getUISortBy", () => $30aea7391225c414$export$3d2a08be86a3576b);
$parcel$export(module.exports, "getPortals", () => $30aea7391225c414$export$9fa4c2091a9d3b38);
$parcel$export(module.exports, "getSortBy", () => $30aea7391225c414$export$c7052c2989e7b681);
$parcel$export(module.exports, "getLimit", () => $30aea7391225c414$export$fb8ce379717a383d);
$parcel$export(module.exports, "getIsDirty", () => $30aea7391225c414$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getTotal", () => $30aea7391225c414$export$94860ac4a286a8d9);
$parcel$export(module.exports, "getfeaturedAndSortedPortalsError", () => $30aea7391225c414$export$9a33f9aea44dc01f);
$parcel$export(module.exports, "getIsReorderingExperienceLoading", () => $30aea7391225c414$export$8cc97acec2e1b274);
$parcel$export(module.exports, "getIsSortedDataLoading", () => $30aea7391225c414$export$20cc91a7c763745e);
$parcel$export(module.exports, "getIsSaveInProgress", () => $30aea7391225c414$export$3f495b2b37e734f1);
$parcel$export(module.exports, "getIsPortalReorderingDataLoaded", () => $30aea7391225c414$export$3e1f7fc063cfb951);
$parcel$export(module.exports, "getDefaultViewLoading", () => $30aea7391225c414$export$2b83ab3fa69f277d);
$parcel$export(module.exports, "getIsPortalHidingEnabled", () => $30aea7391225c414$export$6113b36bf23cc2fe);
$parcel$export(module.exports, "getAllVisiblePortals", () => $30aea7391225c414$export$30b34a0e1d7ec1fa);
$parcel$export(module.exports, "getDefaultViewPortals", () => $30aea7391225c414$export$35863edd27d88bac);
$parcel$export(module.exports, "getTotalVisiblePortalCount", () => $30aea7391225c414$export$22b4f0e1072fa163);
$parcel$export(module.exports, "getFeaturedPortalsUI", () => $30aea7391225c414$export$2650dad54aca58e1);
$parcel$export(module.exports, "getUnFeaturedPortalsUI", () => $30aea7391225c414$export$2834f451d5fc36b1);

var $3yyCx = parcelRequire("3yyCx");

var $eSL4S = parcelRequire("eSL4S");
const $30aea7391225c414$var$MAX_PORTAL_CARDS = 9;
const $30aea7391225c414$var$getPersistedPortals = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $30aea7391225c414$var$nanToZero = (rank)=>rank || 0;
const $30aea7391225c414$export$92cc2a471200c3dd = (portals)=>{
    return Object.values(portals).filter((portal)=>$30aea7391225c414$export$4758cf9aa2bbe6ae(portal)).sort((portal1, portal2)=>$30aea7391225c414$var$nanToZero(portal1.rank) - $30aea7391225c414$var$nanToZero(portal2.rank));
};
const $30aea7391225c414$export$4758cf9aa2bbe6ae = (portal)=>'isFeatured' in portal && portal.isFeatured;
const $30aea7391225c414$export$40fc3a80f8881250 = (portal)=>'hiddenFromHomeScreen' in portal && !!portal.hiddenFromHomeScreen;
const $30aea7391225c414$export$50625c10d80bbff6 = (portal)=>'isFeatured' in portal && !portal.isFeatured;
const $30aea7391225c414$export$22d41892c655b6a1 = (state)=>{
    return state.persisted.featuredAndSortedPortals.orderedPortalIds;
};
const $30aea7391225c414$export$9d389d624d531812 = (state)=>{
    return state.ui.featuredAndSortedPortals.featuredPortalIds;
};
const $30aea7391225c414$export$8bc764a453455857 = (state)=>{
    return state.ui.featuredAndSortedPortals.hiddenPortalIds;
};
const $30aea7391225c414$export$e907b47f94c1ad77 = (state)=>{
    return state.ui.featuredAndSortedPortals.orderedPortalIds;
};
const $30aea7391225c414$export$3d2a08be86a3576b = (state)=>{
    return state.ui.featuredAndSortedPortals.sortBy;
};
const $30aea7391225c414$export$9fa4c2091a9d3b38 = (state)=>{
    return state.persisted.featuredAndSortedPortals.portals;
};
const $30aea7391225c414$export$c7052c2989e7b681 = (state)=>{
    return state.persisted.featuredAndSortedPortals.sortBy;
};
const $30aea7391225c414$export$fb8ce379717a383d = (state)=>{
    return state.persisted.featuredAndSortedPortals.limit;
};
const $30aea7391225c414$export$4b1964ee9ad6f220 = (state)=>{
    return state.ui.featuredAndSortedPortals.isDirty;
};
const $30aea7391225c414$export$94860ac4a286a8d9 = (state)=>{
    return state.persisted.featuredAndSortedPortals.total;
};
const $30aea7391225c414$export$9a33f9aea44dc01f = (state)=>{
    return state.persisted.featuredAndSortedPortals.error;
};
const $30aea7391225c414$export$8cc97acec2e1b274 = (state)=>{
    return state.ui.featuredAndSortedPortals.isReorderingExperienceLoading;
};
const $30aea7391225c414$export$20cc91a7c763745e = (state)=>{
    return state.ui.featuredAndSortedPortals.isSortedDataLoading;
};
const $30aea7391225c414$export$3f495b2b37e734f1 = (state)=>{
    return state.ui.featuredAndSortedPortals.isSaveInProgress;
};
const $30aea7391225c414$export$3e1f7fc063cfb951 = (state)=>{
    return state.ui.featuredAndSortedPortals.isPortalReorderingDataLoaded;
};
const $30aea7391225c414$export$2b83ab3fa69f277d = (state)=>{
    return state.ui.featuredAndSortedPortals.isDefaultViewLoading;
};
const $30aea7391225c414$export$2cff399032fd66c7 = (state)=>{
    return state.ui.featuredAndSortedPortals.isExpandedViewLoading;
};
const $30aea7391225c414$export$6113b36bf23cc2fe = (state)=>{
    return state.persisted.featuredAndSortedPortals.isPortalHidingEnabled;
};
const $30aea7391225c414$export$30b34a0e1d7ec1fa = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, (persistedPortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access
    return Object.values(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre);
});
const $30aea7391225c414$export$731766e21e298d5 = (0, $3yyCx.createSelector)($30aea7391225c414$export$30b34a0e1d7ec1fa, (allVisiblePortals)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Object.values(allVisiblePortals).filter((portal)=>!$30aea7391225c414$export$40fc3a80f8881250(portal));
});
const $30aea7391225c414$export$35863edd27d88bac = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    const featuredPortals = $30aea7391225c414$export$92cc2a471200c3dd(persistedPortals).filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).filter((portal)=>!$30aea7391225c414$export$40fc3a80f8881250(portal));
    if (featuredPortals.length > 0) return featuredPortals;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$30aea7391225c414$export$40fc3a80f8881250(portal)).slice(0, Math.min(persistedOrderedPortalIds.length, $30aea7391225c414$var$MAX_PORTAL_CARDS));
});
const $30aea7391225c414$export$22b4f0e1072fa163 = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)()) return persistedOrderedPortalIds.length;
    return persistedOrderedPortalIds.filter((portalId)=>!persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).length;
});
const $30aea7391225c414$export$7a3c1f03fc45a503 = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>{
        var _persistedPortals$por;
        return !((_persistedPortals$por = persistedPortals[portalId]) !== null && _persistedPortals$por !== void 0 && _persistedPortals$por.isPortalNotVisibleOnHelpCentre);
    }).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$30aea7391225c414$export$40fc3a80f8881250(portal)).length;
});
const $30aea7391225c414$export$7574c566fd98dead = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$35863edd27d88bac, $30aea7391225c414$export$22d41892c655b6a1, (persistedPortals, defaultViewPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.filter((portalId)=>!defaultViewPortals.some((defaultViewPortal)=>portalId === defaultViewPortal.id) && !persistedPortals[portalId].isPortalNotVisibleOnHelpCentre).map((portalId)=>persistedPortals[portalId]).filter((portal)=>!$30aea7391225c414$export$40fc3a80f8881250(portal));
});
const $30aea7391225c414$export$bf663b849d73b99a = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, (persistedPortals)=>{
    return $30aea7391225c414$export$92cc2a471200c3dd(persistedPortals);
});
const $30aea7391225c414$export$e666136461a3c9a3 = (0, $3yyCx.createSelector)($30aea7391225c414$export$bf663b849d73b99a, (featuredPortals)=>{
    return featuredPortals.filter((portal)=>!portal.isPortalNotVisibleOnHelpCentre).length;
});
const $30aea7391225c414$export$2706ef7f7cb3a94c = (0, $3yyCx.createSelector)($30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$22d41892c655b6a1, (persistedPortals, persistedOrderedPortalIds)=>{
    return persistedOrderedPortalIds.map((portalId)=>persistedPortals[portalId]).filter($30aea7391225c414$export$50625c10d80bbff6);
});
const $30aea7391225c414$export$2650dad54aca58e1 = (0, $3yyCx.createSelector)($30aea7391225c414$export$9d389d624d531812, $30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$8bc764a453455857, (uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiFeaturedPortalIds.map((portalId)=>{
        const portal = persistedPortals[portalId];
        return {
            ...portal,
            isFeatured: true,
            rank: $30aea7391225c414$export$4758cf9aa2bbe6ae(portal) ? portal.rank : -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        };
    });
});
const $30aea7391225c414$export$2834f451d5fc36b1 = (0, $3yyCx.createSelector)($30aea7391225c414$export$e907b47f94c1ad77, $30aea7391225c414$export$9d389d624d531812, $30aea7391225c414$var$getPersistedPortals, $30aea7391225c414$export$8bc764a453455857, (uiOrderedPortalIds, uiFeaturedPortalIds, persistedPortals, uiHiddenPortalIds)=>{
    return uiOrderedPortalIds.filter((portalId)=>!uiFeaturedPortalIds.includes(portalId)).map((portalId)=>({
            ...persistedPortals[portalId],
            isFeatured: false,
            rank: -1,
            hiddenFromHomeScreen: uiHiddenPortalIds.includes(portalId)
        }));
});

});




parcelRegister("hT4qI", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => (parcelRequire("hJPIq")).forgotPasswordReducer);

var $hJPIq = parcelRequire("hJPIq");

});
parcelRegister("hJPIq", function(module, exports) {
$parcel$export(module.exports, "forgotPasswordReducer", () => $949b6a038dc476ae$export$545b1c441fc64b70);

var $1MLMt = parcelRequire("1MLMt");
parcelRequire("f8FTt");
var $kAOtO = parcelRequire("kAOtO");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $949b6a038dc476ae$export$4ad260a5db9e01cf = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.forgotPassword) return {
        forgotPassword: initialModelState.forgotPassword
    };
    return {};
};
const $949b6a038dc476ae$var$defaultState = $949b6a038dc476ae$export$4ad260a5db9e01cf();
function $949b6a038dc476ae$export$545b1c441fc64b70(state = $949b6a038dc476ae$var$defaultState, action) {
    switch(action.type){
        case 0, $1MLMt.FETCH_FORGOT_PASSWORD_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $kAOtO.FETCH_FORGOT_PASSWORD_FAILURE:
            {
                const fetchForgotPasswordFailureAction = action;
                const { error: error } = fetchForgotPasswordFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $kAOtO.FETCH_FORGOT_PASSWORD_SUCCESS:
            {
                const fetchPForgotPasswordSuccessAction = action;
                const response = fetchPForgotPasswordSuccessAction.payload;
                return {
                    forgotPassword: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("1nTl3", function(module, exports) {
$parcel$export(module.exports, "helpcenterReducer", () => (parcelRequire("709uz")).default);

var $709uz = parcelRequire("709uz");

});
parcelRegister("709uz", function(module, exports) {
$parcel$export(module.exports, "default", () => $278d0fd32eb72420$export$2e2bcd8739ae039);

var $bG6ob = parcelRequire("bG6ob");

var $bHBXJ = parcelRequire("bHBXJ");

var $63sfu = parcelRequire("63sfu");
parcelRequire("eicll");
var $9wmEV = parcelRequire("9wmEV");

var $eSL4S = parcelRequire("eSL4S");

var $eSL4S = parcelRequire("eSL4S");

var $9mQxZ = parcelRequire("9mQxZ");
function $278d0fd32eb72420$var$reduceHCBrandingToState(helpCenterBrandingResponse) {
    const translationState = (0, $63sfu.mapValues)(helpCenterBrandingResponse.translations, (translation)=>({
            ...translation
        }));
    const isAdvancedHelpCenterThemingEnabled = (0, $bG6ob.isCustomThemingEnabled)() && ((0, $eSL4S.isAdvancedHelpCenter)() || (0, $eSL4S.isDefaultHelpCenter)());
    const portalThemeColor = helpCenterBrandingResponse.portalThemeColor || '#0074e0';
    return {
        logoUrl: helpCenterBrandingResponse.logoUrl,
        logoMediaApiFileId: helpCenterBrandingResponse.logoId,
        sharedPortalName: helpCenterBrandingResponse.sharedPortalName,
        translations: translationState,
        helpCenterBannerUrl: helpCenterBrandingResponse.useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($bHBXJ))) : helpCenterBrandingResponse.bannerMediaApiUrl,
        bannerMediaApiFileId: helpCenterBrandingResponse.bannerMediaApiFileId,
        canCustomizeHelpCenter: !!helpCenterBrandingResponse.canEditAnnouncement,
        helpCenterTitle: helpCenterBrandingResponse.helpCenterTitle,
        helpCenterTitleColor: helpCenterBrandingResponse.helpCenterTitleColor,
        ...(0, $bG6ob.isUseHelpCenterRefresh)() ? {
            topBarColor: helpCenterBrandingResponse.topBarColor || portalThemeColor,
            topBarTextColor: helpCenterBrandingResponse.topBarTextColor || helpCenterBrandingResponse.helpCenterTitleColor,
            hasTopBarBeenSplit: helpCenterBrandingResponse.hasTopBarBeenSplit ?? false
        } : {},
        rawBrandingResponse: helpCenterBrandingResponse,
        announcementHeader: helpCenterBrandingResponse.userInitialAnnouncementHeader,
        announcementMessage: helpCenterBrandingResponse.userInitialAnnouncementMessageWiki,
        useDefaultBanner: helpCenterBrandingResponse.useDefaultBanner,
        isLoaded: true,
        ...isAdvancedHelpCenterThemingEnabled ? {} : {
            themeColor: portalThemeColor
        }
    };
}
function $278d0fd32eb72420$var$reduceHelpCenterToState(helpCenterResponse) {
    const newState = helpCenterResponse.kbs && helpCenterResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            appLinkUrl: helpCenterResponse.kbs.appLinkUrl,
            kbLinkDomainURLs: helpCenterResponse.kbs.kbLinkDomainURLs
        }
    } : {};
    return {
        ...newState,
        isLoaded: true
    };
}
const $278d0fd32eb72420$var$getInitialBrandingState = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.helpCenterBranding) return $278d0fd32eb72420$var$reduceHCBrandingToState(initialModelState.helpCenterBranding);
    return undefined;
};
const $278d0fd32eb72420$var$getInitialHelpCenterState = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.sharedPortal) return $278d0fd32eb72420$var$reduceHelpCenterToState(initialModelState.sharedPortal);
    return undefined;
};
const $278d0fd32eb72420$var$getInitialIsBrandingLoadedFlag = ()=>{
    if ((0, $bG6ob.isIncreasedFlexibilityEnabled)()) {
        const initialModelState = (0, $9mQxZ.default)();
        if (initialModelState && initialModelState.helpCenterBranding) return true;
    }
    return false;
};
const $278d0fd32eb72420$var$getDefaultState = ()=>({
        sharedPortalName: '',
        helpCenterTitle: '',
        helpCenterTitleColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarColor: '#FFFFFF',
        // do not tokenize as of now (this might fail on the polished methods)
        topBarTextColor: '#0D1424',
        // do not tokenize as of now (this might fail on the polished methods)
        translations: {
            'en-US': {
                sharedPortalName: '',
                helpCenterTitle: '',
                localeDisplayName: ''
            }
        },
        canCustomizeHelpCenter: false,
        isLoaded: false,
        themeColor: '#0052CC',
        // do not tokenize as of now (this will fail on the polished methods)
        useDefaultBanner: true,
        ...$278d0fd32eb72420$var$getInitialHelpCenterState(),
        ...$278d0fd32eb72420$var$getInitialBrandingState(),
        isBrandingLoaded: $278d0fd32eb72420$var$getInitialIsBrandingLoadedFlag()
    });
function $278d0fd32eb72420$export$2e2bcd8739ae039(state = $278d0fd32eb72420$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $9wmEV.UPDATE_HELP_CENTER_THEME_COLOR:
            return {
                ...state,
                ...action.payload
            };
        case 0, $9wmEV.UPDATE_HELP_CENTER_MODEL:
            {
                const newState = $278d0fd32eb72420$var$reduceHelpCenterToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $9wmEV.UPDATE_HELP_CENTER_BRANDING_MODEL:
            {
                const newState = $278d0fd32eb72420$var$reduceHCBrandingToState(action.payload);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $9wmEV.UPDATE_HELP_CENTER_BRANDING_LOADER:
            return {
                ...state,
                isBrandingLoaded: action.payload.loaded
            };
        default:
            return state;
    }
}

});
parcelRegister("bHBXJ", function(module, exports) {
module.exports = new URL("../images/default-banner.8e21c182.png", import.meta.url).toString();

});



parcelRegister("jRevb", function(module, exports) {
$parcel$export(module.exports, "articlesReducer", () => (parcelRequire("1lacs")).default);

var $1lacs = parcelRequire("1lacs");

});
parcelRegister("1lacs", function(module, exports) {
$parcel$export(module.exports, "default", () => $a44749c09827244f$export$2e2bcd8739ae039);

var $5s0wd = parcelRequire("5s0wd");
parcelRequire("35SbM");
var $dzJzK = parcelRequire("dzJzK");

var $2akLv = parcelRequire("2akLv");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $a44749c09827244f$var$reduceArticle = (article)=>({
        editUrl: '',
        id: `${article.id}`,
        isFeatured: false,
        friendlyLastModified: '',
        lastModified: '',
        shareUrl: '',
        summaryExcerpt: '',
        title: article.title,
        titleExcerpt: article.title,
        viewCount: -1,
        viewUrl: article.url,
        projects: article.projects,
        space: article.space,
        hostname: article.hostname
    });
const $a44749c09827244f$var$getArticleId = (article)=>article.idInString;
const $a44749c09827244f$var$getInitialState = ()=>{
    const models = (0, $9mQxZ.default)();
    return {
        articles: {},
        legacyArticles: models.kbPage ? {
            [$a44749c09827244f$var$getArticleId(models.kbPage)]: $a44749c09827244f$var$reduceArticle(models.kbPage)
        } : {}
    };
};
const $a44749c09827244f$var$defaultState = $a44749c09827244f$var$getInitialState();
function $a44749c09827244f$export$2e2bcd8739ae039(state = $a44749c09827244f$var$defaultState, action) {
    switch(action.type){
        case 0, $5s0wd.FETCH_ARTICLES:
            {
                const { categoryId: categoryId } = action.payload;
                if (state.articles[categoryId] && 'error' in state.articles[categoryId]) {
                    const newState = {
                        ...state,
                        articles: {
                            ...state.articles
                        }
                    };
                    delete newState.articles[categoryId];
                    return newState;
                }
                return state;
            }
        case 0, $2akLv.FETCH_ARTICLES_SUCCESS:
            {
                const { categoryId: categoryId, response: { results: articles } } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: articles.map(({ featuredInCategories: featuredInCategories, ...article })=>({
                                    ...article,
                                    isFeatured: !!featuredInCategories && featuredInCategories.includes(categoryId)
                                }))
                        }
                    }
                };
            }
        case 0, $2akLv.FETCH_ARTICLES_FAILURE:
            {
                const { portalId: portalId, categoryId: categoryId, error: apolloError } = action.payload;
                return {
                    ...state,
                    articles: {
                        ...state.articles,
                        [categoryId]: {
                            articles: [],
                            error: {
                                error: {
                                    status: apolloError.statusCode,
                                    message: apolloError.errorMessage,
                                    callToActionText: 'Go back',
                                    callToActionUrl: `/portal/${portalId}`
                                }
                            }
                        }
                    }
                };
            }
        case 0, $dzJzK.FETCH_ARTICLE:
            {
                const { id: id } = action.payload.params;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $dzJzK.FETCH_ARTICLE_SPACE_KEY:
            {
                const { articleId: id } = action.payload;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $dzJzK.FETCH_ARTICLE_SUCCESS:
            {
                const articleId = action.payload.idInString;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [articleId]: $a44749c09827244f$var$reduceArticle(action.payload)
                    }
                };
            }
        case 0, $dzJzK.FETCH_ARTICLE_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [action.payload.id]: {
                            error: {
                                // We really only care about the first error message
                                // grab it and throw the rest away
                                status: error.status,
                                message: (error.errorMessages || [])[0],
                                // Remove basename from the URL, we don't need it as the basename
                                // is already set inside react router.
                                // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                                callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                                callToActionText: error.nextActionDisplayText || ''
                            }
                        }
                    }
                };
            }
        case 0, $dzJzK.FETCH_CROSS_SITE_ARTICLE:
            {
                const { articleId: id } = action.payload;
                if (state.legacyArticles[id] && 'error' in state.legacyArticles[id]) {
                    const newState = {
                        ...state,
                        legacyArticles: {
                            ...state.legacyArticles
                        }
                    };
                    delete newState.legacyArticles[id];
                    return newState;
                }
                return state;
            }
        case 0, $dzJzK.FETCH_ARTICLE_SPACE_KEY_SUCCESS:
            {
                const { spaceKey: spaceKey, id: id } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [id]: $a44749c09827244f$var$reduceArticle({
                            ...action.payload,
                            space: {
                                key: spaceKey,
                                id: undefined
                            }
                        })
                    }
                };
            }
        case 0, $dzJzK.FETCH_ARTICLE_SPACE_KEY_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    legacyArticles: {
                        ...state.legacyArticles,
                        [action.payload.id]: {
                            error: {
                                // We really only care about the first error message
                                // grab it and throw the rest away
                                status: error.status,
                                message: (error.errorMessages || [])[0],
                                // Remove basename from the URL, we don't need it as the basename
                                // is already set inside react router.
                                // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                                callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                                callToActionText: error.nextActionDisplayText || ''
                            }
                        }
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("84ozY", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => (parcelRequire("ep4N8")).languagesReducer);

var $ep4N8 = parcelRequire("ep4N8");

});
parcelRegister("ep4N8", function(module, exports) {
$parcel$export(module.exports, "languagesReducer", () => $a82095ebdf7dab1e$export$675c3b6bfa6435e6);
parcelRequire("cjuJm");
var $hM8jd = parcelRequire("hM8jd");

var $5P26j = parcelRequire("5P26j");

var $9mQxZ = parcelRequire("9mQxZ");
const $a82095ebdf7dab1e$export$ef8b6f0b1af42002 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState) {
        const languages = initialModelState.availableLanguages === undefined ? [] : (0, $5P26j.ensureConsistentResponses)(initialModelState.availableLanguages);
        return {
            languages: languages
        };
    }
    return {
        languages: []
    };
};
const $a82095ebdf7dab1e$var$defaultState = $a82095ebdf7dab1e$export$ef8b6f0b1af42002();
function $a82095ebdf7dab1e$export$675c3b6bfa6435e6(state = $a82095ebdf7dab1e$var$defaultState, action) {
    switch(action.type){
        case 0, $hM8jd.FETCH_LANGUAGES_SUCCESS:
            return $a82095ebdf7dab1e$var$handleFetchLanguagesSuccess(state, action);
        default:
            return state;
    }
}
const $a82095ebdf7dab1e$var$handleFetchLanguagesSuccess = (state, action)=>({
        ...state,
        languages: (0, $5P26j.ensureConsistentResponses)(action.payload.languages)
    });

});
parcelRegister("5P26j", function(module, exports) {
$parcel$export(module.exports, "ensureConsistentKey", () => $b2da36c5074303b2$export$6117ad7803ddf800);
$parcel$export(module.exports, "ensureConsistentResponses", () => $b2da36c5074303b2$export$131bf7a7b9860e71);
const $b2da36c5074303b2$export$6117ad7803ddf800 = (localeKey)=>localeKey.replace('_', '-');
const $b2da36c5074303b2$var$ensureConsistentResponse = (response)=>({
        key: $b2da36c5074303b2$export$6117ad7803ddf800(response.key),
        originalKey: response.key,
        displayName: response.displayName
    });
const $b2da36c5074303b2$export$131bf7a7b9860e71 = (responses)=>responses.map((response)=>$b2da36c5074303b2$var$ensureConsistentResponse(response));

});



parcelRegister("jUG4n", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("8vpEF")).default);

var $8vpEF = parcelRequire("8vpEF");

});
parcelRegister("8vpEF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dd42c8fa1d70c7c$export$2e2bcd8739ae039);
parcelRequire("kbOJM");
var $kJFCO = parcelRequire("kJFCO");
const $4dd42c8fa1d70c7c$var$defaultState = {
    linkedSpaces: []
};
function $4dd42c8fa1d70c7c$export$2e2bcd8739ae039(state = $4dd42c8fa1d70c7c$var$defaultState, action) {
    switch(action.type){
        case 0, $kJFCO.FETCH_LINKED_SPACES:
            return {
                ...state,
                error: undefined
            };
        case 0, $kJFCO.FETCH_LINKED_SPACES_SUCCESS:
            {
                const { linkedSpaces: linkedSpaces } = action.payload;
                return {
                    ...state,
                    linkedSpaces: linkedSpaces || [],
                    error: undefined
                };
            }
        case 0, $kJFCO.FETCH_LINKED_SPACES_FAILURE:
            {
                const { error: error } = action.payload;
                return {
                    ...state,
                    error: {
                        error: {
                            status: error.status,
                            message: error.message || 'Failed to fetch linked spaces',
                            callToActionText: '',
                            callToActionUrl: ''
                        }
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("76U79", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => (parcelRequire("gC9el")).loginReducer);

var $gC9el = parcelRequire("gC9el");

});
parcelRegister("gC9el", function(module, exports) {
$parcel$export(module.exports, "loginReducer", () => $7ae115d7c54a4082$export$3d13b312f34d11e5);

var $gb0lQ = parcelRequire("gb0lQ");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $7ae115d7c54a4082$export$5b80378ff66478a5 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.login) return {
        login: initialModelState.login
    };
    return {};
};
const $7ae115d7c54a4082$var$defaultState = $7ae115d7c54a4082$export$5b80378ff66478a5();
function $7ae115d7c54a4082$export$3d13b312f34d11e5(state = $7ae115d7c54a4082$var$defaultState, action) {
    switch(action.type){
        case 0, $gb0lQ.FETCH_LOGIN_MODEL:
            if (state && 'error' in state) return {};
            return state;
        // We want to override the portal data if request create fails as well.
        case 0, $8o5VQ.FETCH_LOGIN_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    error: errorObject
                };
            }
        case 0, $8o5VQ.FETCH_LOGIN_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const response = fetchPortalSuccessAction.payload;
                return {
                    login: {
                        ...response
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("jsZn7", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("ksOPZ")).loginAnnouncementsReducer);

var $ksOPZ = parcelRequire("ksOPZ");

});
parcelRegister("ksOPZ", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $edee96e73859a4d2$export$14afe2784a94db4d);

var $63sfu = parcelRequire("63sfu");
parcelRequire("5raaz");
var $bK3LM = parcelRequire("bK3LM");

var $9mQxZ = parcelRequire("9mQxZ");
const $edee96e73859a4d2$export$d383b838c87089ae = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements) return initialModelState.loginAnnouncements;
    return {
        defaultLocale: '',
        translatedLoginAnnouncements: {}
    };
};
const $edee96e73859a4d2$var$defaultState = $edee96e73859a4d2$export$d383b838c87089ae();
function $edee96e73859a4d2$export$14afe2784a94db4d(state = $edee96e73859a4d2$var$defaultState, action) {
    switch(action.type){
        case 0, $bK3LM.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return action.payload;
        case 0, $bK3LM.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
            {
                const { payload: payload } = action;
                if ((0, $63sfu.isEmpty)(payload)) return state;
                return {
                    defaultLocale: state.defaultLocale,
                    translatedLoginAnnouncements: Object.keys(payload.translatedLogInAnnouncements).reduce((acc, languageKey)=>{
                        var _state$translatedLogi;
                        return {
                            ...acc,
                            [languageKey]: {
                                header: payload.translatedLogInAnnouncements[languageKey].header,
                                message: payload.translatedLogInAnnouncements[languageKey].message,
                                localeDisplayName: (_state$translatedLogi = state.translatedLoginAnnouncements[languageKey]) === null || _state$translatedLogi === void 0 ? void 0 : _state$translatedLogi.localeDisplayName
                            }
                        };
                    }, {})
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("eZ0Tb", function(module, exports) {
$parcel$export(module.exports, "metaReducer", () => (parcelRequire("ScUz4")).default);

var $ScUz4 = parcelRequire("ScUz4");

});
parcelRegister("ScUz4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d082e43105134df8$export$2e2bcd8739ae039);
parcelRequire("9FUG9");
var $kKQy2 = parcelRequire("kKQy2");
const $d082e43105134df8$var$defaultState = {};
function $d082e43105134df8$export$2e2bcd8739ae039(state = $d082e43105134df8$var$defaultState, action) {
    if (action.type === (0, $kKQy2.UPDATE_META)) {
        const newState = action.payload;
        return {
            ...state,
            ...newState
        };
    }
    return state;
}

});
parcelRegister("9FUG9", function(module, exports) {
$parcel$export(module.exports, "updateMetaAction", () => (parcelRequire("kKQy2")).updateMetaAction);
$parcel$export(module.exports, "UPDATE_META", () => (parcelRequire("kKQy2")).UPDATE_META);

var $kKQy2 = parcelRequire("kKQy2");

});
parcelRegister("kKQy2", function(module, exports) {
$parcel$export(module.exports, "UPDATE_META", () => $b4571e16cec8ff43$export$7db07bf896c7e69b);
$parcel$export(module.exports, "updateMetaAction", () => $b4571e16cec8ff43$export$4a183f4e7a49f459);
const $b4571e16cec8ff43$export$7db07bf896c7e69b = 'state.persisted.env.UPDATE_META';
const $b4571e16cec8ff43$export$4a183f4e7a49f459 = (meta)=>({
        payload: meta,
        type: $b4571e16cec8ff43$export$7db07bf896c7e69b
    });

});




parcelRegister("fTbZc", function(module, exports) {
$parcel$export(module.exports, "organisationsReducer", () => (parcelRequire("izIW6")).default);

var $izIW6 = parcelRequire("izIW6");

});
parcelRegister("izIW6", function(module, exports) {
$parcel$export(module.exports, "default", () => $56280bc1efb569c5$export$2e2bcd8739ae039);
parcelRequire("3zVJa");
var $fZ4s6 = parcelRequire("fZ4s6");

var $9mQxZ = parcelRequire("9mQxZ");
const $56280bc1efb569c5$var$emptyState = {
    organisations: []
};
const $56280bc1efb569c5$export$a7f9736258a0bacb = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.organisations) return {
        organisations: initialModelState.organisations.organisations
    };
    return $56280bc1efb569c5$var$emptyState;
};
const $56280bc1efb569c5$var$defaultState = $56280bc1efb569c5$export$a7f9736258a0bacb();
function $56280bc1efb569c5$export$2e2bcd8739ae039(state = $56280bc1efb569c5$var$defaultState, action) {
    switch(action.type){
        case 0, $fZ4s6.UPDATE_ORGANISATIONS_MODEL:
            {
                const organisations = action.payload.organisations.map((org)=>({
                        id: org.id,
                        name: org.name
                    }));
                const newState = {
                    organisations: organisations
                };
                return {
                    ...state,
                    ...newState
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("hX3wg", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("i5IG1")).default);

var $i5IG1 = parcelRequire("i5IG1");

});
parcelRegister("i5IG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e195cece15da6ce7$export$2e2bcd8739ae039);

var $hw2N0 = parcelRequire("hw2N0");
parcelRequire("frlrJ");
var $bHntx = parcelRequire("bHntx");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("4i4VL");
var $f1XNB = parcelRequire("f1XNB");
parcelRequire("7Aj7n");
var $3SWp7 = parcelRequire("3SWp7");

var $6bGmX = parcelRequire("6bGmX");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $e195cece15da6ce7$var$getMediaUploadToken = (mediaApiUploadInformation)=>{
    if ('token' in mediaApiUploadInformation) return {
        clientId: mediaApiUploadInformation.clientId,
        token: mediaApiUploadInformation.token,
        endpointUrl: mediaApiUploadInformation.endpointUrl,
        targetCollection: mediaApiUploadInformation.targetCollection,
        tokenDurationInMins: mediaApiUploadInformation.tokenDurationInMins
    };
    return undefined;
};
const $e195cece15da6ce7$var$getMediaError = (mediaApiUploadInformation)=>{
    if ('error' in mediaApiUploadInformation) return mediaApiUploadInformation.error;
    return undefined;
};
function $e195cece15da6ce7$var$reducePortalResponseToState(portalResponse, oldState = {}) {
    const portalId = parseInt(portalResponse.id, 10);
    const mediaApiUploadInformation = portalResponse.mediaApiUploadInformation;
    const mediaApiUploadToken = mediaApiUploadInformation && $e195cece15da6ce7$var$getMediaUploadToken(mediaApiUploadInformation);
    const mediaApiError = mediaApiUploadInformation && $e195cece15da6ce7$var$getMediaError(mediaApiUploadInformation);
    const newSinglePortalState = {
        mediaApiUploadToken: mediaApiUploadToken,
        mediaApiError: mediaApiError,
        id: portalId,
        name: portalResponse.name,
        logoUrl: portalResponse.logoUrl,
        description: portalResponse.description,
        projectKey: portalResponse.key,
        projectId: portalResponse.projectId,
        portalAnnouncement: portalResponse.portalAnnouncement,
        isProjectSimplified: portalResponse.isProjectSimplified,
        serviceDeskId: portalResponse.serviceDeskId,
        reqGroups: [],
        reqTypes: []
    };
    const categoriesData = portalResponse.categories;
    const categories = categoriesData !== null && categoriesData !== void 0 && categoriesData.categoriesSupported ? categoriesData.categories : undefined;
    const kbState = portalResponse.kbs && portalResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            kbLink: portalResponse.kbs.kbLink,
            kbLinkDomainURLs: portalResponse.kbs.kbLinkDomainURLs,
            kbCategories: categories
        }
    } : {};
    // If there is KB we try to maintain the previous categories
    if (!!kbState.knowledgeBase) {
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingPortal = oldState[portalId];
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const existingCategories = existingPortal && !('error' in existingPortal) && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        existingPortal.knowledgeBase.kbCategories;
        if (existingCategories) // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        kbState.knowledgeBase = {
            ...kbState.knowledgeBase,
            kbCategories: existingCategories
        };
    }
    const reqTypesState = portalResponse.reqTypes ? {
        reqTypes: portalResponse.reqTypes.map((reqtype)=>({
                id: reqtype.id,
                name: reqtype.name,
                // This is actually the description, not the intro.
                // The backend is wrecked.
                descriptionHtml: reqtype.introHtml,
                // This is actually the help text, not the description.
                // The backend is wrecked.
                helpTextHtml: reqtype.descriptionHtml,
                // Icon id here is required to pass backend validation of req type when removing from group
                // can remove once backend change JDW-292 is complete
                icon: reqtype.icon,
                iconUrl: reqtype.iconUrl || `${0, $3wR8f.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${reqtype.icon}`
            }))
    } : {};
    const orderMapping = portalResponse.orderMapping || {};
    const reqGroupsState = (portalResponse.reqGroups || []).map((reqGroup)=>({
            id: reqGroup.id,
            name: reqGroup.name,
            reqTypes: (orderMapping[reqGroup.id] || []).map(String)
        }));
    const { analyticsContext: analyticsContext } = portalResponse;
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const oldPortalState = oldState[portalId];
    const analyticAttributesState = analyticsContext ? {
        analyticAttributes: {
            jsdRole: analyticsContext.jsdRole,
            initialProjectTemplate: analyticsContext.initialProjectTemplate,
            openAccess: analyticsContext.openAccess,
            publicSignup: analyticsContext.publicSignup,
            nextGenProject: analyticsContext.nextGenProject,
            demoProject: analyticsContext.demoProject,
            eapOptedIn: analyticsContext.eapOptedIn,
            jsdDwCohort: analyticsContext.jsdDwCohort,
            previousSupportedProjects: analyticsContext.previousSupportedProjects,
            supportedProjects: analyticsContext.supportedProjects
        }
    } : {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        ...oldPortalState && oldPortalState.analyticAttributes ? // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        {
            analyticAttributes: oldPortalState.analyticAttributes
        } : {}
    };
    return {
        [portalId]: {
            ...newSinglePortalState,
            ...kbState,
            ...reqTypesState,
            ...analyticAttributesState,
            reqGroups: reqGroupsState
        }
    };
}
const $e195cece15da6ce7$export$6189f5b9656c1eb4 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.portal) {
        if (initialModelState.branding) return $e195cece15da6ce7$var$reducePortalResponseToState({
            ...initialModelState.branding,
            ...initialModelState.portal
        });
        return $e195cece15da6ce7$var$reducePortalResponseToState({
            ...initialModelState.portal,
            logoUrl: undefined,
            theme: {}
        });
    }
    return {};
};
const $e195cece15da6ce7$var$defaultState = $e195cece15da6ce7$export$6189f5b9656c1eb4();
function $e195cece15da6ce7$export$2e2bcd8739ae039(state = $e195cece15da6ce7$var$defaultState, action) {
    switch(action.type){
        case 0, $lXazD.FETCH_PORTAL_MODEL:
            {
                const fetchPortalAction = action;
                const portalId = fetchPortalAction.payload.params && fetchPortalAction.payload.params.id;
                if (portalId) {
                    const portal = state[portalId];
                    if (portal && 'error' in portal) {
                        const newState = {
                            ...state
                        };
                        delete newState[portalId];
                        return newState;
                    }
                }
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $3SWp7.FETCH_REQUEST_CREATE_FAILURE:
        case 0, $lXazD.FETCH_PORTAL_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error, portalId: portalId } = fetchPortalFailureAction.payload;
                return {
                    ...state,
                    [portalId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || '',
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders
                        }
                    }
                };
            }
        case 0, $lXazD.FETCH_PORTAL_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                return {
                    ...state,
                    ...$e195cece15da6ce7$var$reducePortalResponseToState(fetchPortalSuccessAction.payload, state)
                };
            }
        case 0, $bHntx.FETCH_CATEGORIES_SUCCESS:
            {
                const categoriesSuccessAction = action;
                const { portalId: portalId, categories: categories } = categoriesSuccessAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: categories
                        }
                    }
                };
            }
        case 0, $bHntx.FETCH_CATEGORIES_FAILURE:
            {
                const categoriesFailureAction = action;
                const { portalId: portalId, error: categoryError } = categoriesFailureAction.payload;
                const portal = state[portalId];
                if (!portal || !('knowledgeBase' in portal)) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbCategories: {
                                error: {
                                    status: categoryError.statusCode,
                                    message: categoryError.errorMessage,
                                    callToActionUrl: '/portal/',
                                    callToActionText: 'Go back'
                                }
                            }
                        }
                    }
                };
            }
        case 0, $lXazD.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
            {
                const { payload: payload } = action;
                if (!payload) return state;
                const { portalId: portalId } = payload;
                const portal = state[portalId];
                const portalAnnouncement = payload ?? portal.portalAnnouncement;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        portalAnnouncement: portalAnnouncement
                    }
                };
            }
        case 0, $hw2N0.FETCH_KB_SUGGESTIONS_SUCCESS:
            {
                const { kbArticleSuggestions: kbArticleSuggestions, portalId: portalId } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (!(0, $6bGmX.default).checkGate('remove-linked-spaces-check-for-article-suggestions')) {
                    if (!portal || !('knowledgeBase' in portal)) return state;
                } else if (!portal || 'error' in portal) return state;
                const kbState = portal.knowledgeBase;
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        knowledgeBase: {
                            ...kbState,
                            kbArticleSuggestions: kbArticleSuggestions
                        }
                    }
                };
            }
        case 0, $f1XNB.PROFORMA_FORM_LOADED:
            {
                const { portalId: portalId, proformaFormIsLoaded: proformaFormIsLoaded } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        proformaFormIsLoaded: proformaFormIsLoaded
                    }
                };
            }
        case 0, $lXazD.FETCH_PORTAL_UPLOAD_MEDIA_TOKEN_SUCCESS:
            {
                const { portalId: portalId, mediaApiUploadInformation: mediaApiUploadInformation } = action.payload;
                if (portalId === undefined) return state;
                const portal = state[portalId];
                if (portal && !('error' in portal)) return {
                    ...state,
                    [portalId]: {
                        ...portal,
                        mediaApiUploadToken: $e195cece15da6ce7$var$getMediaUploadToken(mediaApiUploadInformation)
                    }
                };
                return state;
            }
        default:
            return state;
    }
}

});
parcelRegister("hw2N0", function(module, exports) {
$parcel$export(module.exports, "FETCH_KB_SUGGESTIONS_SUCCESS", () => $7bc512c300c58287$export$1b2c5db514ac0bd7);
$parcel$export(module.exports, "fetchKBSuggestionsSuccessAction", () => $7bc512c300c58287$export$ce6a80dfe554c3b6);
const $7bc512c300c58287$export$1b2c5db514ac0bd7 = 'epic.model.FETCH_KB_SUGGESTIONS';
const $7bc512c300c58287$export$ce6a80dfe554c3b6 = (params)=>{
    return {
        type: $7bc512c300c58287$export$1b2c5db514ac0bd7,
        payload: params
    };
};

});

parcelRegister("4i4VL", function(module, exports) {
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => (parcelRequire("f1XNB")).fetchPortalAndRequestTypesModel);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => (parcelRequire("f1XNB")).fetchPortalsAndRequestTypesSuccess);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => (parcelRequire("f1XNB")).FETCH_PORTAL_AND_REQUEST_TYPES);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => (parcelRequire("f1XNB")).FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => (parcelRequire("f1XNB")).PROFORMA_FORM_LOADED);

var $f1XNB = parcelRequire("f1XNB");

});
parcelRegister("f1XNB", function(module, exports) {
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES", () => $eb0b995f409bdd22$export$172324766a8910d6);
$parcel$export(module.exports, "FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS", () => $eb0b995f409bdd22$export$5f63fa3daf3ecef8);
$parcel$export(module.exports, "PROFORMA_FORM_LOADED", () => $eb0b995f409bdd22$export$4c0299a035f236e5);
$parcel$export(module.exports, "fetchPortalAndRequestTypesModel", () => $eb0b995f409bdd22$export$b4741ec41baec80b);
$parcel$export(module.exports, "fetchPortalsAndRequestTypesSuccess", () => $eb0b995f409bdd22$export$da57d2f9cae3a05f);

var $dNzn5 = parcelRequire("dNzn5");
const $eb0b995f409bdd22$export$172324766a8910d6 = 'epic.model.FETCH_PORTAL_AND_REQUEST_TYPES';
const $eb0b995f409bdd22$export$5f63fa3daf3ecef8 = 'state.persisted.portals-and-request-types.FETCH_PORTAL_AND_REQUEST_TYPES_SUCCESS';
const $eb0b995f409bdd22$export$4c0299a035f236e5 = 'state.persisted.portals-and-request-types.PROFORMA_FORM_LOADED';
const $eb0b995f409bdd22$export$b4741ec41baec80b = (payload = {}, meta)=>({
        meta: meta,
        ...(0, $dNzn5.buildModelsActionCreator)($eb0b995f409bdd22$export$172324766a8910d6, 'portalsAndRequestTypes')(payload)
    });
const $eb0b995f409bdd22$export$da57d2f9cae3a05f = (portalsAndRequestTypesModel)=>({
        payload: portalsAndRequestTypesModel,
        type: $eb0b995f409bdd22$export$5f63fa3daf3ecef8
    });

});




parcelRegister("lK7Yv", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("5vmki")).portalCustomisationReducer);

var $5vmki = parcelRequire("5vmki");

});
parcelRegister("5vmki", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => $d039910219ddc616$export$b5745e15c8a52df8);
parcelRequire("5eWkp");
var $5sVYY = parcelRequire("5sVYY");
const $d039910219ddc616$export$49d5fc8cba920a0 = {
    allRequestGroups: {},
    errorMessage: undefined
};
function $d039910219ddc616$export$b5745e15c8a52df8(state = $d039910219ddc616$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $5sVYY.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { portalId: portalId, requestGroups: requestGroups } = action.payload;
                return {
                    errorMessage: undefined,
                    allRequestGroups: {
                        ...state.allRequestGroups,
                        [portalId]: requestGroups
                    }
                };
            }
        case 0, $5sVYY.GET_ALL_REQUEST_GROUPS_FAILURE:
            {
                const { errorMessage: errorMessage } = action.payload;
                return {
                    ...state,
                    errorMessage: errorMessage
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("50XJ7", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => (parcelRequire("1xGnK")).profileWebFragmentReducer);

var $1xGnK = parcelRequire("1xGnK");

});
parcelRegister("1xGnK", function(module, exports) {
$parcel$export(module.exports, "profileWebFragmentReducer", () => $2aa684122d5c55fd$export$530037ab477140ce);
parcelRequire("g3u0z");
var $lWKdO = parcelRequire("lWKdO");

var $9mQxZ = parcelRequire("9mQxZ");
const $2aa684122d5c55fd$export$f9c142b09e8e12af = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.profileWebFragments) return {
        ...initialModelState.profileWebFragments
    };
    return {};
};
const $2aa684122d5c55fd$export$49d5fc8cba920a0 = $2aa684122d5c55fd$export$f9c142b09e8e12af();
const $2aa684122d5c55fd$var$handleFetchProfileConnectFragmentsSuccess = (state, action)=>({
        ...state,
        ...action.payload.fragments
    });
const $2aa684122d5c55fd$var$handleFetchProfileConnectFragmentsFailure = (state, action)=>({
        ...state,
        panels: action.payload
    });
function $2aa684122d5c55fd$export$530037ab477140ce(state = $2aa684122d5c55fd$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $lWKdO.FETCH_PROFILE_CONNECT_FRAGMENTS_SUCCESS:
            return $2aa684122d5c55fd$var$handleFetchProfileConnectFragmentsSuccess(state, action);
        case 0, $lWKdO.FETCH_PROFILE_CONNECT_FRAGMENTS_FAILURE:
            return $2aa684122d5c55fd$var$handleFetchProfileConnectFragmentsFailure(state, action);
        default:
            return state;
    }
}

});


parcelRegister("j7hgW", function(module, exports) {
$parcel$export(module.exports, "requestCreateReducer", () => (parcelRequire("7Wy2K")).default);

var $7Wy2K = parcelRequire("7Wy2K");

});
parcelRegister("7Wy2K", function(module, exports) {
$parcel$export(module.exports, "default", () => $2132c561cb29f49e$export$2e2bcd8739ae039);

var $bG6ob = parcelRequire("bG6ob");

var $5ZAyY = parcelRequire("5ZAyY");
parcelRequire("7Aj7n");
var $3SWp7 = parcelRequire("3SWp7");

var $cpFVz = parcelRequire("cpFVz");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");

var $2jpwX = parcelRequire("2jpwX");

var $6b6S5 = parcelRequire("6b6S5");
const $2132c561cb29f49e$var$buildStoreKey = (portalId, requestCreateId)=>`${portalId || 'undefined'}/${requestCreateId}`;
const $2132c561cb29f49e$var$convertHydratedFieldValuesToInitialValues = (hydratedUrlParamOverrides, fieldStates)=>{
    const fieldStateMap = Object.fromEntries(fieldStates.map((fieldState)=>[
            fieldState.id,
            fieldState
        ]));
    return Object.fromEntries(Object.entries(hydratedUrlParamOverrides).map(([fieldId, valueOverride])=>{
        const fieldState = fieldStateMap[fieldId];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let overrideValue; // Setting this so TS can pick up the correct return value type
        if (!fieldState) {
            overrideValue = [
                fieldId,
                null
            ];
            return overrideValue;
        }
        switch(fieldState.type){
            case 'cmdbobjectpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.map((value)=>value.value)
                ];
                break;
            case 'userpicker':
            case 'reporter':
                overrideValue = [
                    fieldId,
                    valueOverride.accountId
                ];
                break;
            case 'multiuserpicker':
                {
                    const users = valueOverride;
                    overrideValue = [
                        fieldId,
                        users.map((user)=>user.accountId).join(',')
                    ];
                    break;
                }
            case 'organisationpicker':
                overrideValue = [
                    fieldId,
                    valueOverride.id
                ];
                break;
            case 'entitlementpicker':
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
                break;
            case 'multiservicepicker':
                {
                    const services = valueOverride;
                    overrideValue = [
                        fieldId,
                        services
                    ];
                    break;
                }
            default:
                overrideValue = [
                    fieldId,
                    valueOverride
                ];
        }
        return overrideValue;
    }).filter(([_, initialValue])=>initialValue !== null));
};
function $2132c561cb29f49e$var$reduceReqCreateResponseToState(reqCreateResponse) {
    var _reqCreateResponse$is, _reqCreateResponse$is2;
    const { hydratedUrlParamOverrides: hydratedUrlParamOverrides, portalId: portalId, id: requestCreateId } = reqCreateResponse;
    const storeId = $2132c561cb29f49e$var$buildStoreKey(portalId, requestCreateId);
    const { showRecaptcha: showRecaptcha, siteKey: siteKey, proformaTemplateForm: proformaTemplateForm, form: { name: name, intro: intro, instructions: instructions, descriptionHtml: descriptionHtml, icon: icon, iconUrl: iconUrl } } = reqCreateResponse;
    const form = {
        name: name,
        intro: intro,
        instructions: instructions,
        descriptionHtml: descriptionHtml,
        iconUrl: iconUrl || `${0, $3wR8f.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${icon}`,
        captchaEnabled: showRecaptcha,
        sitekey: siteKey
    };
    const kbState = reqCreateResponse.kbs && reqCreateResponse.kbs.kbEnabled ? {
        knowledgeBase: {
            spaceKey: reqCreateResponse.kbs.kbLink.spaceKey,
            labels: reqCreateResponse.kbs.labels,
            projectKey: reqCreateResponse.kbs.projectKey
        }
    } : {};
    const dateFormat = (0, $6b6S5.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateIfFormat);
    const dateTimeFormat = (0, $6b6S5.convertToDateFnsFormat)(reqCreateResponse.calendarParams.dateTimeIfFormat);
    const firstDay = reqCreateResponse.calendarParams.firstDay;
    const useISO8601WeekNumbers = reqCreateResponse.calendarParams.useISO8601WeekNumbers;
    const fields = (0, $cpFVz.toFieldStates)(reqCreateResponse.fields);
    let initialFieldValues = fields.reduce((values, field)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        values[field.id] = field.value;
        return values;
    }, {});
    const { lastSavedFormData: lastSavedFormData } = reqCreateResponse;
    if (lastSavedFormData && lastSavedFormData.portalId === portalId && lastSavedFormData.requestId === requestCreateId) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    initialFieldValues = {
        ...initialFieldValues,
        ...lastSavedFormData.formInput
    };
    let urlParamFieldValueOverrides;
    if ((0, $bG6ob.isJsmPortalRovoIntegrationEnabled)()) {
        urlParamFieldValueOverrides = hydratedUrlParamOverrides;
        if (Object.keys(hydratedUrlParamOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...$2132c561cb29f49e$var$convertHydratedFieldValuesToInitialValues(hydratedUrlParamOverrides, fields)
        };
    } else {
        urlParamFieldValueOverrides = (0, $5ZAyY.parseFieldUrlParams)(fields);
        if (Object.keys(urlParamFieldValueOverrides).length > 0) initialFieldValues = {
            ...initialFieldValues,
            ...urlParamFieldValueOverrides
        };
    }
    const organisationsForCurrentUser = reqCreateResponse.userOrganisations;
    const requestCreateFormState = {
        form: form,
        fields: fields,
        initialFieldValues: initialFieldValues,
        urlParamFieldValueOverrides: urlParamFieldValueOverrides,
        dateFormat: dateFormat,
        dateTimeFormat: dateTimeFormat,
        organisationsForCurrentUser: organisationsForCurrentUser,
        firstDay: firstDay,
        useISO8601WeekNumbers: useISO8601WeekNumbers,
        proformaTemplateForm: proformaTemplateForm,
        id: reqCreateResponse.id,
        projectId: reqCreateResponse.projectId,
        issueType: (_reqCreateResponse$is = reqCreateResponse.issueType) === null || _reqCreateResponse$is === void 0 ? void 0 : _reqCreateResponse$is.name,
        issueTypeId: (_reqCreateResponse$is2 = reqCreateResponse.issueType) === null || _reqCreateResponse$is2 === void 0 ? void 0 : _reqCreateResponse$is2.id,
        canBrowseUsers: !!reqCreateResponse.canBrowseUsers,
        canCreateUsers: !!reqCreateResponse.canSubmitWithEmailAddress,
        projectHasProformaForms: !!reqCreateResponse.hasProformaForm,
        proforma: reqCreateResponse.proforma,
        proformaFormIsLoaded: false,
        proformaFormIsDirty: false
    };
    return {
        [storeId]: {
            ...requestCreateFormState,
            ...kbState,
            initialFieldValues: initialFieldValues
        }
    };
}
const $2132c561cb29f49e$export$f7e14415d5a64cdc = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.reqCreate) {
        const portalId = (0, $2jpwX.toNumber)(initialModelState.portal && initialModelState.portal.id);
        const initialState = $2132c561cb29f49e$var$reduceReqCreateResponseToState({
            portalId: portalId,
            ...initialModelState.reqCreate,
            hydratedUrlParamOverrides: {}
        });
        // When the jsm_portal_rovo_integration flag is on, pre-fill logic runs in the epic
        // asynchronously. If URL params are present for any field, we need to delay rendering
        // the form until the epic resolves and dispatches FETCH_REQUEST_CREATE_SUCCESS with the
        // hydrated values. Without this, Formik initialises with empty values before the epic
        // completes, and the pre-fill data has no effect.
        if ((0, $bG6ob.isJsmPortalRovoIntegrationEnabled)()) {
            const storeKey = $2132c561cb29f49e$var$buildStoreKey(portalId, initialModelState.reqCreate.id);
            const formState = initialState[storeKey];
            if (formState) {
                const urlParamOverrides = (0, $5ZAyY.parseFieldUrlParams)(formState.fields);
                if (Object.keys(urlParamOverrides).length > 0) return {
                    [storeKey]: {
                        ...formState,
                        prefillPending: true
                    }
                };
            }
        }
        return initialState;
    }
    return {};
};
const $2132c561cb29f49e$var$defaultState = $2132c561cb29f49e$export$f7e14415d5a64cdc();
function $2132c561cb29f49e$export$2e2bcd8739ae039(state = $2132c561cb29f49e$var$defaultState, action) {
    switch(action.type){
        case 0, $3SWp7.FETCH_REQUEST_CREATE_MODEL:
            {
                const requestCreateId = action.payload.params && action.payload.params.id;
                const portalId = action.payload.params && action.payload.params.portalId;
                if (requestCreateId && portalId) {
                    const storeId = $2132c561cb29f49e$var$buildStoreKey(portalId, requestCreateId);
                    const requestCreate = state[storeId];
                    if (requestCreate && 'error' in requestCreate) {
                        const newState = {
                            ...state
                        };
                        delete newState[storeId];
                        return newState;
                    }
                }
                return state;
            }
        case 0, $3SWp7.FETCH_REQUEST_CREATE_FAILURE:
            {
                const { error: error, portalId: portalId, requestCreateId: requestCreateId } = action.payload;
                const storeId = $2132c561cb29f49e$var$buildStoreKey(portalId, requestCreateId);
                return {
                    ...state,
                    [storeId]: {
                        error: {
                            // We really only care about the first error message
                            // grab it and throw the rest away
                            status: error.status,
                            message: (error.errorMessages || [])[0],
                            traceId: error.traceId,
                            responseHeaders: error.responseHeaders,
                            // Remove basename from the URL, we don't need it as the basename
                            // is already set inside react router.
                            // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                            callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                            callToActionText: error.nextActionDisplayText || ''
                        }
                    }
                };
            }
        case 0, $3SWp7.FETCH_REQUEST_CREATE_SUCCESS:
            return {
                ...state,
                ...$2132c561cb29f49e$var$reduceReqCreateResponseToState(action.payload)
            };
        case 0, $3SWp7.PROFORMA_FORM_DIRTY:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, isDirty: isDirty } = action.payload;
                const storeId = $2132c561cb29f49e$var$buildStoreKey(portalId, requestTypeId);
                if (!state[storeId]) return state;
                return {
                    ...state,
                    [storeId]: {
                        ...state[storeId],
                        proformaFormIsDirty: isDirty
                    }
                };
            }
        case 0, $3SWp7.RESET_REQUEST_CREATE_STATE:
            // Reset the state to the default initial state
            return $2132c561cb29f49e$export$f7e14415d5a64cdc();
        default:
            return state;
    }
}

});
parcelRegister("2jpwX", function(module, exports) {
$parcel$export(module.exports, "toNumber", () => $fcf9051859ef56ba$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "toString", () => $fcf9051859ef56ba$export$f84e8e69fd4488a5);
// This exists as a shorthand func to return a default value if the parsed
// string was somehow not a valid number.
const $fcf9051859ef56ba$export$a0a81dc3380ce7d3 = (str, defaultValue)=>{
    if (typeof str === 'number') return str;
    if (str) {
        const parsedNumber = parseInt(str, 10);
        if (!isNaN(parsedNumber)) return parsedNumber;
    }
    return defaultValue;
};
const $fcf9051859ef56ba$export$f84e8e69fd4488a5 = (num)=>{
    if (num) return String(num);
    return undefined;
};

});

parcelRegister("6b6S5", function(module, exports) {
$parcel$export(module.exports, "convertToDateFnsFormat", () => $074540d0b63b8e12$export$e007e5b3b423e0a6);
$parcel$export(module.exports, "splitDateTimeFormat", () => $074540d0b63b8e12$export$b565d8b0afadc612);
/**
 * Utility to convert a subset of the unix date time format to data-fns.
 * Date-fns format: https://date-fns.org/v2.30.0/docs/format
 * Unix date time format: http://old-www.cs.dartmouth.edu/~cs50/data/tse/wikipedia/wiki/Date_(Unix).html#Formatting
 */ /**
 * This is a mapping of all equivalent time formats between unix and date-fns.
 *
 * There are a number of commented out unix time formats, these are the unix time formats that we don't support. There are no
 * direct equivalent for any of these between unix time format and date fns. I have left the closest matching date fns time format
 * for each of these keys if there are any, or I marked it as INCOMPATIBLE if there are no date fns that even remotely matches the
 * unix time format.
 */ const $074540d0b63b8e12$var$UNIX_TO_DATE_FNS_MAPPING = {
    '%a': 'iii',
    '%A': 'iiii',
    '%d': 'dd',
    '%e': 'd',
    '%j': 'DDD',
    '%u': 'i',
    // '%w': 'd',
    // '%U': 'WW',
    // '%W': 'WW',
    '%V': 'II',
    '%m': 'MM',
    '%h': 'MMM',
    '%b': 'MMM',
    '%B': 'MMMM',
    '%y': 'yy',
    '%Y': 'yyyy',
    // '%g': 'YY',
    // '%G': 'YYYY',
    // '%C': 'INCOMPATIBLE',
    '%D': 'MM/dd/yy',
    // '%x': "INCOMPATIBLE",
    '%F': 'yyyy-MM-dd',
    '%l': 'h',
    '%I': 'hh',
    '%k': 'H',
    '%H': 'HH',
    '%p': 'a',
    '%P': 'aaaa',
    '%M': 'mm',
    '%s': 't',
    '%S': 'ss',
    // '%N': 'INCOMPATIBLE',
    '%r': 'hh:mm:ss',
    '%R': 'HH:mm',
    '%T': 'HH:mm:ss',
    // '%X': 'INCOMPATIBLE',
    // '%c': 'INCOMPATIBLE',
    '%z': 'xx'
};
/**
 * These are the date-fns characters that are associated with 'time', time in this case refers to hour, minute, second and timezone.
 * This is used by splitDateTimeFormat to determine which sections of a date format is associated with time and which are associated  * with day.
 * This list IS case sensitive as capital M is month and not minute, see https://date-fns.org/v2.30.0/docs/format for full list.
 */ const $074540d0b63b8e12$var$LIST_OF_TIME_CHARS = [
    'h',
    // Hour
    'H',
    // Hour
    'm',
    // Minute (NOTE: capital M is month not minute)
    's',
    // Second
    'S',
    // Part of a second
    'a',
    // AM PM
    'xxx',
    // Timezone
    't',
    // Timestamp
    'T' // Timestamp
];
// eslint-disable-next-line no-useless-escape
const $074540d0b63b8e12$var$unixTimeFormatTokenRegex = /\%\w/gi;
const $074540d0b63b8e12$var$escapeRegExp = (literalString)=>literalString.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string;
/**
 * Converts a unix date time format to its closest equivalent in date-fns format
 * @param unixDateTimeFormat The unix date time format you want to convert
 */ function $074540d0b63b8e12$export$e007e5b3b423e0a6(unixDateTimeFormat) {
    let transformedString = unixDateTimeFormat;
    const incompatibleFormatString = [];
    const matches = unixDateTimeFormat.match($074540d0b63b8e12$var$unixTimeFormatTokenRegex);
    if (matches) matches.forEach((match)=>{
        // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const equivalentDateFnsFunctionString = $074540d0b63b8e12$var$UNIX_TO_DATE_FNS_MAPPING[match];
        if (equivalentDateFnsFunctionString) // Replaces all cases of the match with it's equivalent in date-fns time format
        transformedString = transformedString.replace(new RegExp($074540d0b63b8e12$var$escapeRegExp(match), 'g'), equivalentDateFnsFunctionString);
        else incompatibleFormatString.push(match);
    });
    return transformedString;
}
/**
 * Naively splits a date fns time format between date and time components. It is split by matching each individual character
 * Naively in this case means that there is a distinct separate between date and time, i.e. they're not mixed in between each other.
 */ function $074540d0b63b8e12$export$b565d8b0afadc612(dateFnsTimeFormat) {
    const matches = dateFnsTimeFormat.match(/\w/g);
    let lastMatchType;
    let indexOfMatchTypeChange = dateFnsTimeFormat.length;
    if (matches) {
        for (const match of matches){
            // We assume that any keys that are not time keys are used to represent date, date in this case refers to years, months, weeks and days
            const isTime = $074540d0b63b8e12$var$LIST_OF_TIME_CHARS.includes(match);
            const matchType = isTime ? 'time' : 'date';
            if (!lastMatchType) lastMatchType = matchType;
            else if (matchType !== lastMatchType) {
                // If the match type has changed, i.e. from date -> time or from time -> date we will stop and use this match to
                // split the date time to date and time.
                indexOfMatchTypeChange = dateFnsTimeFormat.indexOf(match);
                break;
            }
        }
        if (lastMatchType === 'date') // If we went from date -> time
        return {
            dateFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            timeFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
        // splitDateTimeFormat went from time -> date
        return {
            timeFormat: dateFnsTimeFormat.slice(0, indexOfMatchTypeChange).trim(),
            dateFormat: dateFnsTimeFormat.slice(indexOfMatchTypeChange).trim()
        };
    }
    return {
        timeFormat: 'hh:mm a',
        dateFormat: 'yyyy-MM-dd'
    };
}

});



parcelRegister("5TN6q", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("li9Ka")).requestDetailsReducer);

var $li9Ka = parcelRequire("li9Ka");

});
parcelRegister("li9Ka", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => $d0ff3a07a5a7e635$export$dfa3e5ac1f5274b8);

var $63sfu = parcelRequire("63sfu");

var $lQ6XI = parcelRequire("lQ6XI");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $d0ff3a07a5a7e635$export$efef4e30b826ddbf = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.reqDetails) return {
        [initialModelState.reqDetails.key]: initialModelState.reqDetails
    };
    return {};
};
const $d0ff3a07a5a7e635$var$defaultState = $d0ff3a07a5a7e635$export$efef4e30b826ddbf();
function $d0ff3a07a5a7e635$export$dfa3e5ac1f5274b8(state = $d0ff3a07a5a7e635$var$defaultState, action) {
    switch(action.type){
        case 0, $gEejF.FETCH_REQUEST_DETAILS_MODEL:
            return $d0ff3a07a5a7e635$var$handleFetchRequestDetailsModel(state, action);
        case 0, $gEejF.FETCH_REQUEST_DETAILS_FAILURE:
            return $d0ff3a07a5a7e635$var$handleFetchRequestDetailsFailureAction(state, action);
        case 0, $gEejF.FETCH_REQUEST_DETAILS_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleFetchRequestDetailsSuccessAction(state, action);
        case 0, $gEejF.CREATE_COMMENT_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleCreateCommentSuccessAction(state, action);
        case 0, $gEejF.CHANGE_SUBSCRIPTION_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleChangeSubscriptionSuccessAction(state, action);
        case 0, $gEejF.REMOVE_PARTICIPANT_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleRemoveParticipant(state, action);
        case 0, $gEejF.REMOVE_ORGANISATION_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleRemoveOrganisation(state, action);
        case 0, $gEejF.GET_MEDIA_READ_CREDENTIALS_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleGetReadCredentialsSuccess(state, action);
        case 0, $gEejF.ADD_PARTICIPANTS_SUCCESS:
            return $d0ff3a07a5a7e635$var$handleAddParticipantsSuccess(state, action);
        default:
            return state;
    }
}
function $d0ff3a07a5a7e635$var$handleFetchRequestDetailsModel(state, action) {
    const requestKey = action.payload.params.key;
    if (requestKey) {
        const requestDetails = state[requestKey];
        if (requestDetails && 'error' in requestDetails) {
            const newState = {
                ...state
            };
            delete newState[requestKey];
            return newState;
        }
    }
    return state;
}
function $d0ff3a07a5a7e635$var$handleFetchRequestDetailsFailureAction(state, action) {
    const { requestKey: requestKey, error: error } = action.payload;
    const errorObject = {
        // We really only care about the first error message
        // grab it and throw the rest away
        status: error.status,
        message: (error.errorMessages || [])[0] || '',
        // Remove basename from the URL, we don't need it as the basename
        // is already set inside react router.
        // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
        callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
        callToActionText: error.nextActionDisplayText || ''
    };
    return {
        ...state,
        [requestKey]: {
            error: errorObject
        }
    };
}
function $d0ff3a07a5a7e635$var$populateWithPreexistingState(preExistingRequestDetails, response) {
    let preExistingProperties;
    if (preExistingRequestDetails && !('error' in preExistingRequestDetails)) {
        if (preExistingRequestDetails.userMentionedDuringRequestCreation) preExistingProperties = {
            participants: (0, $63sfu.uniqBy)([
                ...preExistingRequestDetails.participants,
                ...response.participants
            ], 'accountId'),
            userMentionedDuringRequestCreation: false
        };
    }
    return preExistingProperties;
}
function $d0ff3a07a5a7e635$var$handleFetchRequestDetailsSuccessAction(state, action) {
    const response = action.payload;
    const requestKey = response.key;
    const preExistingProperties = $d0ff3a07a5a7e635$var$populateWithPreexistingState(state[requestKey], response);
    return {
        ...state,
        [requestKey]: {
            ...response,
            ...preExistingProperties
        }
    };
}
function $d0ff3a07a5a7e635$var$handleChangeSubscriptionSuccessAction(state, action) {
    const { requestKey: requestKey, shouldSubscribe: shouldSubscribe } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) {
        let newSubscribeAction = (0, $lQ6XI.SUBSCRIBE_ACTION_KEY);
        if (shouldSubscribe) newSubscribeAction = (0, $lQ6XI.UNSUBSCRIBE_ACTION_KEY);
        return {
            ...state,
            [requestKey]: {
                ...requestDetails,
                subscribeAction: newSubscribeAction
            }
        };
    }
    return state;
}
function $d0ff3a07a5a7e635$var$handleCreateCommentSuccessAction(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                activityStream: [
                    ...requestDetails.issue.activityStream,
                    response.comment
                ],
                status: response.status
            }
        }
    };
    return state;
}
function $d0ff3a07a5a7e635$var$handleRemoveOrganisation(state, action) {
    const { requestKey: requestKey, organisationId: organisationId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            organisations: requestDetails.organisations.filter((organisation)=>organisation.id !== organisationId),
            issue: {
                ...requestDetails.issue,
                organisations: requestDetails.issue.organisations.filter((organisation)=>organisation.id !== organisationId)
            }
        }
    };
    return state;
}
const $d0ff3a07a5a7e635$var$filterRemovedParticipant = (participants, removedUserAccountId)=>participants.filter((participant)=>participant.accountId !== removedUserAccountId);
function $d0ff3a07a5a7e635$var$handleRemoveParticipant(state, action) {
    const { requestKey: requestKey, accountId: accountId } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            participants: $d0ff3a07a5a7e635$var$filterRemovedParticipant(requestDetails.participants, accountId),
            issue: {
                ...requestDetails.issue,
                participants: $d0ff3a07a5a7e635$var$filterRemovedParticipant(requestDetails.issue.participants, accountId)
            }
        }
    };
    return state;
}
function $d0ff3a07a5a7e635$var$handleGetReadCredentialsSuccess(state, action) {
    const { requestKey: requestKey, response: response } = action.payload;
    const requestDetails = state[requestKey];
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            readFileMediaCredentials: response
        }
    };
    return state;
}
function $d0ff3a07a5a7e635$var$handleAddParticipantsSuccess(state, action) {
    const { requestKey: requestKey, userMentionedDuringRequestCreation: userMentionedDuringRequestCreation, addParticipantsSuccessResponse: addParticipantsSuccessResponse } = action.payload;
    const requestDetails = state[requestKey];
    const { participants: updatedParticipants, organisations: updatedOrganisations } = addParticipantsSuccessResponse;
    if (requestDetails && !('error' in requestDetails)) return {
        ...state,
        [requestKey]: {
            ...requestDetails,
            issue: {
                ...requestDetails.issue,
                participants: updatedParticipants,
                organisations: updatedOrganisations
            },
            participants: updatedParticipants,
            organisations: updatedOrganisations
        }
    };
    if (!requestDetails && userMentionedDuringRequestCreation) return {
        ...state,
        [requestKey]: {
            userMentionedDuringRequestCreation: userMentionedDuringRequestCreation,
            issue: {
                participants: updatedParticipants,
                activityStream: [],
                fields: []
            },
            participants: updatedParticipants,
            approvalStatus: []
        }
    };
    return state;
}

});
parcelRegister("lQ6XI", function(module, exports) {
$parcel$export(module.exports, "SUBSCRIBE_ACTION_KEY", () => $64acf8e76a1f5757$export$2f3123aa49f16a3c);
$parcel$export(module.exports, "UNSUBSCRIBE_ACTION_KEY", () => $64acf8e76a1f5757$export$5a45f83be8b212b8);
const $64acf8e76a1f5757$export$2f3123aa49f16a3c = 'subscribe';
const $64acf8e76a1f5757$export$5a45f83be8b212b8 = 'unsubscribe';
const $64acf8e76a1f5757$export$f10e0fb31f869e32 = 'none';

});



parcelRegister("1nMsA", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("6YtKA")).requestListReducer);

var $6YtKA = parcelRequire("6YtKA");

});
parcelRegister("6YtKA", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $685c6e67da86a917$export$476a1a148617ffd3);
parcelRequire("bxUrV");
var $kH8Rm = parcelRequire("kH8Rm");

var $9mQxZ = parcelRequire("9mQxZ");

var $bG6ob = parcelRequire("bG6ob");
const $685c6e67da86a917$var$emptyState = {
    totalResults: 0,
    resultsPerPage: 20,
    pages: {
        isInitialPageLoad: false
    }
};
const $685c6e67da86a917$export$c1708a8d295610ca = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.allReqFilter) {
        const { resultsPerPage: resultsPerPage, totalResults: totalResults, sortBy: sortBy, sortOrder: sortOrder, requestList: requestList, nextToken: nextToken } = initialModelState.allReqFilter;
        const baseState = {
            resultsPerPage: resultsPerPage,
            totalResults: totalResults,
            sortBy: sortBy,
            sortOrder: sortOrder,
            pages: {
                isInitialPageLoad: true,
                [initialModelState.allReqFilter.selectedPage]: requestList
            }
        };
        if ((0, $bG6ob.isRequestListInfiniteScrollEnabled)()) {
            baseState.nextToken = nextToken;
            baseState.allRows = requestList ?? [];
            baseState.filter = (0, $bG6ob.isEmptyStringFilterOnFirstReqListLoadEnabled)() ? initialModelState.allReqFilter.filter ?? '' : initialModelState.allReqFilter.filter;
        }
        return baseState;
    }
    return $685c6e67da86a917$var$emptyState;
};
const $685c6e67da86a917$var$defaultState = $685c6e67da86a917$export$c1708a8d295610ca();
function $685c6e67da86a917$export$476a1a148617ffd3(state = $685c6e67da86a917$var$defaultState, action) {
    switch(action.type){
        case 0, $kH8Rm.FETCH_REQUEST_LIST_SUCCESS:
            return $685c6e67da86a917$var$handleFetchRequestListSuccess(state, action);
        case 0, $kH8Rm.MARK_INITIAL_PAGE_LOAD_RENDERED:
            return $685c6e67da86a917$var$handleMarkInitialPageLoadRendered(state);
        case 0, $kH8Rm.INVALIDATE_PAGES:
            return $685c6e67da86a917$var$handleInvalidatePages(state, action);
        default:
            return state;
    }
}
function $685c6e67da86a917$var$handleInvalidatePages(state, action) {
    const currentPage = action.payload;
    return {
        ...state,
        pages: {
            isInitialPageLoad: false,
            [currentPage]: state.pages[currentPage]
        }
    };
}
function $685c6e67da86a917$var$handleFetchRequestListSuccessInfiniteScroll(state, action) {
    const response = action.payload;
    if (!response) return state;
    const isReset = response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder || response.totalResults !== state.totalResults || response.filter !== state.filter;
    const existingRows = state.allRows ?? [];
    // Deduplicate to prevent duplicate entries from race conditions or overlapping API calls
    const existingKeys = new Set(existingRows.map((row)=>row.key));
    const uniqueNewRows = response.requestList.filter((row)=>!existingKeys.has(row.key));
    const newRows = isReset ? response.requestList : [
        ...existingRows,
        ...uniqueNewRows
    ];
    return {
        ...state,
        resultsPerPage: response.resultsPerPage,
        totalResults: response.totalResults,
        sortBy: response.sortBy,
        sortOrder: response.sortOrder,
        nextToken: response.nextToken,
        filter: response.filter,
        allRows: newRows,
        // The `pages` object (keyed by selectedPage) is only used by the non-infinite-scroll
        // pagination path. In the infinite scroll path, `allRows` is the canonical source of
        // truth for all fetched rows, so we do not populate `pages[selectedPage]` here.
        // Doing so would store stale page-indexed data that is never consumed by infinite
        // scroll consumers, and `selectedPage` is irrelevant in nextToken-based pagination.
        pages: {
            isInitialPageLoad: false
        }
    };
}
function $685c6e67da86a917$var$handleFetchRequestListSuccess(state, action) {
    if ((0, $bG6ob.isRequestListInfiniteScrollEnabled)()) return $685c6e67da86a917$var$handleFetchRequestListSuccessInfiniteScroll(state, action);
    const response = action.payload;
    if (response) {
        if (response.totalResults === state.totalResults) {
            if (response.sortBy !== state.sortBy || response.sortOrder !== state.sortOrder) {
                if (response.selectedPage === 1) return {
                    ...state,
                    sortOrder: response.sortOrder,
                    sortBy: response.sortBy,
                    pages: {
                        isInitialPageLoad: false,
                        [response.selectedPage]: response.requestList
                    }
                };
            }
            return {
                ...state,
                pages: {
                    ...state.pages,
                    isInitialPageLoad: false,
                    [response.selectedPage]: response.requestList
                }
            };
        }
        return {
            resultsPerPage: response.resultsPerPage,
            totalResults: response.totalResults,
            sortBy: response.sortBy,
            sortOrder: response.sortOrder,
            pages: {
                isInitialPageLoad: false,
                [response.selectedPage]: response.requestList
            }
        };
    }
    return state;
}
const $685c6e67da86a917$var$handleMarkInitialPageLoadRendered = (state)=>({
        ...state,
        pages: {
            ...state.pages,
            isInitialPageLoad: false
        }
    });

});


parcelRegister("jcmVC", function(module, exports) {
$parcel$export(module.exports, "requestTypeSuggestionReducer", () => (parcelRequire("5p1lg")).default);
/**
 * This should be normalized with the normal request type model at some point
 */ 
var $5p1lg = parcelRequire("5p1lg");

});
parcelRegister("5p1lg", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c2d0c183f1bf4f4$export$2e2bcd8739ae039);
parcelRequire("fZNes");
var $fzeUC = parcelRequire("fzeUC");

var $3wR8f = parcelRequire("3wR8f");
const $6c2d0c183f1bf4f4$var$defaultState = {
    suggestions: [],
    isLoaded: false
};
function $6c2d0c183f1bf4f4$export$2e2bcd8739ae039(state = $6c2d0c183f1bf4f4$var$defaultState, action) {
    switch(action.type){
        case 0, $fzeUC.FETCH_REQUEST_TYPE_SUGGESTIONS_MODEL:
            // When we are making a new request for the request type model we will reset the state
            return {
                suggestions: [],
                isLoaded: false
            };
        case 0, $fzeUC.FETCH_REQUEST_TYPE_SUGGESTION_SUCCESS:
            {
                const requestTypeSuggestions = action.payload.map((suggestion)=>{
                    const requestTypeId = parseInt(String(suggestion.id), 10);
                    return {
                        id: requestTypeId,
                        portalId: suggestion.cvId,
                        portalName: suggestion.portalName,
                        name: suggestion.name,
                        descriptionHtml: suggestion.descriptionHtml,
                        iconUrl: suggestion.iconUrl || `${0, $3wR8f.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${suggestion.icon}`
                    };
                });
                return {
                    suggestions: requestTypeSuggestions,
                    isLoaded: true
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("1REWU", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("lSmFU")).resetPasswordReducer);

var $lSmFU = parcelRequire("lSmFU");

});
parcelRegister("lSmFU", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $d3a281daa01811a3$export$b0c3be5071e95c02);

var $9mQxZ = parcelRequire("9mQxZ");
const $d3a281daa01811a3$var$defaultState = {
    emailAddress: undefined,
    username: undefined,
    resetPasswordJwt: undefined
};
const $d3a281daa01811a3$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.resetPassword) return {
        ...$d3a281daa01811a3$var$defaultState,
        ...initialModelState.resetPassword
    };
    return $d3a281daa01811a3$var$defaultState;
};
const $d3a281daa01811a3$export$b0c3be5071e95c02 = (state = $d3a281daa01811a3$export$53ac33307b5acee9())=>state;

});


parcelRegister("3ZGeF", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => (parcelRequire("fMx6O")).signUpReducer);

var $fMx6O = parcelRequire("fMx6O");

});
parcelRegister("fMx6O", function(module, exports) {
$parcel$export(module.exports, "signUpReducer", () => $86c6fb07cb9992a1$export$a3d522c435cab174);
parcelRequire("3kjQH");
var $jrtA6 = parcelRequire("jrtA6");

var $g01X2 = parcelRequire("g01X2");

var $9mQxZ = parcelRequire("9mQxZ");
const $86c6fb07cb9992a1$var$defaultState = {
    authInfo: {
        accountStage: (0, $g01X2.AccountStageType).SIGNUP,
        authMethods: new Map([
            [
                (0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    emailAddress: null,
    requestKey: null,
    requestSummary: null
};
const $86c6fb07cb9992a1$var$getInitialState = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.signUp && initialModelState.signUp.emailAddress) return {
        ...$86c6fb07cb9992a1$var$defaultState,
        ...initialModelState.signUp
    };
    return $86c6fb07cb9992a1$var$defaultState;
};
const $86c6fb07cb9992a1$export$a3d522c435cab174 = (state = $86c6fb07cb9992a1$var$getInitialState(), action)=>{
    switch(action.type){
        case 0, $jrtA6.SET_SIGN_UP_DATA:
            return {
                ...state,
                emailAddress: action.payload.email,
                authInfo: action.payload.authInfo
            };
        default:
            return state;
    }
};

});


parcelRegister("8wTW2", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => (parcelRequire("UthGp")).timezonesReducer);

var $UthGp = parcelRequire("UthGp");

});
parcelRegister("UthGp", function(module, exports) {
$parcel$export(module.exports, "timezonesReducer", () => $0981c1cbf9cf839d$export$98e58b85fdd67f49);
parcelRequire("gTNQM");
var $nk7DB = parcelRequire("nk7DB");

var $9mQxZ = parcelRequire("9mQxZ");
const $0981c1cbf9cf839d$export$84faa4a7b0294c11 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState) return {
        timezoneRegions: initialModelState.timezoneRegions || [],
        timezones: initialModelState.timezones || []
    };
    return {
        timezoneRegions: [],
        timezones: []
    };
};
const $0981c1cbf9cf839d$var$defaultState = $0981c1cbf9cf839d$export$84faa4a7b0294c11();
function $0981c1cbf9cf839d$export$98e58b85fdd67f49(state = $0981c1cbf9cf839d$var$defaultState, action) {
    switch(action.type){
        case 0, $nk7DB.FETCH_TIMEZONES_SUCCESS:
            return $0981c1cbf9cf839d$var$handleFetchTimezonesSuccess(state, action);
        case 0, $nk7DB.FETCH_TIMEZONE_REGIONS_SUCCESS:
            return $0981c1cbf9cf839d$var$handleFetchTimezoneRegionsSuccess(state, action);
        default:
            return state;
    }
}
const $0981c1cbf9cf839d$var$handleFetchTimezonesSuccess = (state, action)=>({
        ...state,
        timezones: action.payload.timezones
    });
const $0981c1cbf9cf839d$var$handleFetchTimezoneRegionsSuccess = (state, action)=>({
        ...state,
        timezoneRegions: action.payload.timezoneRegions
    });

});


parcelRegister("c4FNG", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => (parcelRequire("hHyyT")).uiModificationsReducer);

var $hHyyT = parcelRequire("hHyyT");

});
parcelRegister("hHyyT", function(module, exports) {
$parcel$export(module.exports, "uiModificationsReducer", () => $689dded7f221d944$export$821013f52f243078);
parcelRequire("95qI5");
var $aEVH2 = parcelRequire("aEVH2");
const $689dded7f221d944$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $689dded7f221d944$var$defaultState = {};
function $689dded7f221d944$export$821013f52f243078(state = $689dded7f221d944$var$defaultState, action) {
    switch(action.type){
        case 0, $aEVH2.FETCH_UI_MODIFICATIONS_SUCCESS:
            {
                const { portalId: portalId, requestTypeId: requestTypeId, uiModifications: uiModifications } = action.payload;
                const storeKey = $689dded7f221d944$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: uiModifications,
                        error: undefined
                    }
                };
            }
        case 0, $aEVH2.FETCH_UI_MODIFICATIONS_FAILURE:
            {
                var _error$errorMessages;
                const { portalId: portalId, requestTypeId: requestTypeId, error: error } = action.payload;
                const storeKey = $689dded7f221d944$var$buildStoreKey(portalId, requestTypeId);
                return {
                    [storeKey]: {
                        data: undefined,
                        error: ((_error$errorMessages = error.errorMessages) === null || _error$errorMessages === void 0 ? void 0 : _error$errorMessages[0]) ?? 'Failed to fetch UI modifications'
                    }
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("58BPm", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => (parcelRequire("pWj3c")).unsubscribedConfirmationReducer);

var $pWj3c = parcelRequire("pWj3c");

});
parcelRegister("pWj3c", function(module, exports) {
$parcel$export(module.exports, "unsubscribedConfirmationReducer", () => $93dad0629638948d$export$ac175372d3d2c582);

var $bnV9E = parcelRequire("bnV9E");
parcelRequire("7pPzB");
var $4xqOU = parcelRequire("4xqOU");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $93dad0629638948d$export$c8b25b5da8be069b = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.unsubscribedConfirmation) return {
        unsubscribedConfirmation: initialModelState.unsubscribedConfirmation
    };
    return {};
};
const $93dad0629638948d$var$defaultState = $93dad0629638948d$export$c8b25b5da8be069b();
function $93dad0629638948d$export$ac175372d3d2c582(state = $93dad0629638948d$var$defaultState, action) {
    switch(action.type){
        case 0, $bnV9E.FETCH_UNSUBSCRIBED_CONFIRMATION_MODEL:
            {
                const unsubscribedConfirmation = state.unsubscribedConfirmation;
                if (unsubscribedConfirmation && 'error' in unsubscribedConfirmation) return {};
                return state;
            }
        // We want to override the portal data if request create fails as well.
        case 0, $4xqOU.FETCH_UNSUBSCRIBED_CONFIRMATION_FAILURE:
            {
                const fetchPortalFailureAction = action;
                const { error: error } = fetchPortalFailureAction.payload;
                const errorObject = {
                    // We really only care about the first error message
                    // grab it and throw the rest away
                    status: error.status,
                    message: (error.errorMessages || [])[0],
                    // Remove basename from the URL, we don't need it as the basename
                    // is already set inside react router.
                    // See ticket to update backend: https://jdog.jira-dev.com/browse/FSD-2557
                    callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                    callToActionText: error.nextActionDisplayText || ''
                };
                return {
                    ...state,
                    unsubscribedConfirmation: {
                        error: errorObject
                    }
                };
            }
        case 0, $4xqOU.FETCH_UNSUBSCRIBED_CONFIRMATION_SUCCESS:
            {
                const fetchPortalSuccessAction = action;
                const requestKey = fetchPortalSuccessAction.payload.requestKey;
                const unsubscribedConfirmation = {
                    requestKey: requestKey,
                    requestUrl: fetchPortalSuccessAction.payload.requestUrl,
                    summary: fetchPortalSuccessAction.payload.summary
                };
                return {
                    ...state,
                    unsubscribedConfirmation: unsubscribedConfirmation
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("adTbC", function(module, exports) {
$parcel$export(module.exports, "userReducer", () => (parcelRequire("2WLfx")).default);

var $2WLfx = parcelRequire("2WLfx");

});
parcelRegister("2WLfx", function(module, exports) {
$parcel$export(module.exports, "default", () => $0407b80936d11de1$export$2e2bcd8739ae039);
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");

var $bRLBS = parcelRequire("bRLBS");

var $5P26j = parcelRequire("5P26j");

var $9mQxZ = parcelRequire("9mQxZ");
function $0407b80936d11de1$var$reduceResponseToState(userResponse) {
    const state = {
        language: {
            key: (0, $5P26j.ensureConsistentKey)(userResponse.language.key),
            originalKey: userResponse.language.key,
            displayName: userResponse.language.displayName
        },
        storedLanguage: {
            key: (0, $5P26j.ensureConsistentKey)(userResponse.storedLanguage.key),
            originalKey: userResponse.storedLanguage.key,
            displayName: userResponse.storedLanguage.displayName
        },
        timezone: {
            id: userResponse.timezone.id,
            regionKey: userResponse.timezone.regionKey,
            city: userResponse.timezone.city,
            gmtOffset: userResponse.timezone.gmtOffset
        },
        avatars: userResponse.avatars,
        userRequests: {},
        isLoaded: true,
        isLoggedIn: !!userResponse.accountId,
        customMenuLinks: userResponse.customMenuLinks ? userResponse.customMenuLinks : [],
        canAdministerJIRA: userResponse.canAdministerJIRA,
        hasSiteAdministerAccess: userResponse.hasSiteAdministerAccess ?? false,
        agentForPortal: userResponse.agentForPortal,
        accountId: userResponse.accountId,
        displayName: userResponse.displayName,
        email: userResponse.email,
        atlassianAccountManaged: userResponse.atlassianAccountManaged,
        scimManaged: userResponse.scimManaged ?? false,
        externalCustomer: userResponse.externalCustomer
    };
    return state;
}
const $0407b80936d11de1$var$getLocale = ()=>$bRLBS.getMeta('user-locale') || '';
const $0407b80936d11de1$var$getInitialUserState = ()=>{
    const initialState = (0, $9mQxZ.default)();
    if (initialState && initialState.user) return $0407b80936d11de1$var$reduceResponseToState(initialState.user);
    return undefined;
};
const $0407b80936d11de1$var$anonymousState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $5P26j.ensureConsistentKey)($0407b80936d11de1$var$getLocale()),
        originalKey: $0407b80936d11de1$var$getLocale(),
        displayName: $0407b80936d11de1$var$getLocale()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $5P26j.ensureConsistentKey)($0407b80936d11de1$var$getLocale()),
        originalKey: $0407b80936d11de1$var$getLocale(),
        displayName: $0407b80936d11de1$var$getLocale()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: true,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false
};
const $0407b80936d11de1$var$defaultState = {
    language: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $5P26j.ensureConsistentKey)($0407b80936d11de1$var$getLocale()),
        originalKey: $0407b80936d11de1$var$getLocale(),
        displayName: $0407b80936d11de1$var$getLocale()
    },
    storedLanguage: {
        // temporary access user locale via AJS until we have the locale hard coded into each asset
        key: (0, $5P26j.ensureConsistentKey)($0407b80936d11de1$var$getLocale()),
        originalKey: $0407b80936d11de1$var$getLocale(),
        displayName: $0407b80936d11de1$var$getLocale()
    },
    timezone: {
        id: 'JIRA',
        regionKey: 'JIRA',
        city: '',
        gmtOffset: ''
    },
    isLoaded: false,
    isLoggedIn: false,
    userRequests: {},
    canAdministerJIRA: false,
    hasSiteAdministerAccess: false,
    customMenuLinks: [],
    atlassianAccountManaged: false,
    scimManaged: false,
    // Initial user state spreads _last_ just in case there are things on the server that should
    // override initial (local) state.
    ...$0407b80936d11de1$var$getInitialUserState()
};
function $0407b80936d11de1$export$2e2bcd8739ae039(state = $0407b80936d11de1$var$defaultState, action) {
    switch(action.type){
        case 0, $3R99L.UPDATE_USER_MODEL:
            {
                const userResponse = action.payload;
                const newState = $0407b80936d11de1$var$reduceResponseToState(userResponse);
                return {
                    ...state,
                    ...newState
                };
            }
        case 0, $3R99L.UPDATE_USER_TO_ANON:
            return {
                ...$0407b80936d11de1$var$anonymousState
            };
        case 0, $3R99L.SAVE_USER_PROFILE_SUCCESS:
            return $0407b80936d11de1$var$handleUpdateUserProfileSuccessAction(state, action);
        case 0, $3R99L.SUCCESSFULLY_LOGGED_IN:
            return $0407b80936d11de1$var$handleSuccessfullyLoggedIn(state);
        default:
            return state;
    }
}
function $0407b80936d11de1$var$handleUpdateUserProfileSuccessAction(state, action) {
    const displayName = action.payload.displayName || state.displayName;
    const language = action.payload.language || state.storedLanguage;
    const timezone = action.payload.timezone || state.timezone;
    return {
        ...state,
        displayName: displayName,
        timezone: timezone,
        storedLanguage: {
            key: (0, $5P26j.ensureConsistentKey)(language.originalKey),
            originalKey: language.originalKey,
            displayName: language.displayName
        }
    };
}
const $0407b80936d11de1$var$handleSuccessfullyLoggedIn = (state)=>({
        ...state,
        isLoggedIn: true
    });

});


parcelRegister("86yRB", function(module, exports) {
$parcel$export(module.exports, "userRequestsCountsReducer", () => (parcelRequire("2FEkJ")).default);

var $2FEkJ = parcelRequire("2FEkJ");

});
parcelRegister("2FEkJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf5b81d331cd522$export$2e2bcd8739ae039);
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");
function $5cf5b81d331cd522$export$2e2bcd8739ae039(state = {}, action) {
    switch(action.type){
        case 0, $3R99L.UPDATE_USER_REQUESTS_COUNTS_MODEL:
            {
                const userRequestCountResponse = action.payload;
                return {
                    myRequestCount: userRequestCountResponse.allOpenRequestsCount,
                    pendingApprovalCount: userRequestCountResponse.pendingApprovalsCount,
                    approvalCount: userRequestCountResponse.approvalsCount
                };
            }
        default:
            return state;
    }
}

});


parcelRegister("d0dlB", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => (parcelRequire("9Y0l3")).verifyEmailReducer);

var $9Y0l3 = parcelRequire("9Y0l3");

});
parcelRegister("9Y0l3", function(module, exports) {
$parcel$export(module.exports, "verifyEmailReducer", () => $acf42372365b3520$export$681ecd52c505c479);

var $ar2Dv = parcelRequire("ar2Dv");

var $9mQxZ = parcelRequire("9mQxZ");
const $acf42372365b3520$var$defaultState = {
    signupToken: '',
    emailAddress: '',
    validationOutcome: (0, $ar2Dv.SUCCESSFUL_VERIFICATION_OUTCOMES).SUCCEEDED,
    portalName: null,
    portalId: null
};
const $acf42372365b3520$export$681ecd52c505c479 = (state = $acf42372365b3520$export$53ac33307b5acee9())=>state;
const $acf42372365b3520$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.verifyEmail) return initialModelState.verifyEmail;
    return $acf42372365b3520$var$defaultState;
};

});
parcelRegister("ar2Dv", function(module, exports) {
$parcel$export(module.exports, "FAILED_VERIFICATION_OUTCOMES", () => $f9d3a2c790ee9d01$export$d054ec592d4dac6f);
$parcel$export(module.exports, "SUCCESSFUL_VERIFICATION_OUTCOMES", () => $f9d3a2c790ee9d01$export$a94c4b05d26d720a);
const $f9d3a2c790ee9d01$export$d054ec592d4dac6f = {
    IDENTITY_ERROR: 'IDENTITY_ERROR',
    TOKEN_INVALID: 'TOKEN_INVALID',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    PROCESSING_ERROR: 'PROCESSING_ERROR'
};
const $f9d3a2c790ee9d01$export$a94c4b05d26d720a = {
    SUCCEEDED: 'SUCCEEDED'
};

});



parcelRegister("je5sV", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => (parcelRequire("fnUlz")).visitPortalReducer);

var $fnUlz = parcelRequire("fnUlz");

});
parcelRegister("fnUlz", function(module, exports) {
$parcel$export(module.exports, "visitPortalReducer", () => $faeda95f166d650c$export$8f27b2a880eeba34);
parcelRequire("4C3Ab");
var $dSbFt = parcelRequire("dSbFt");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");
const $faeda95f166d650c$var$defaultState = {
    loggedInBeforeCheck: false,
    email: '',
    portalName: '',
    initialError: undefined,
    setPasswordJwt: undefined
};
const $faeda95f166d650c$export$53ac33307b5acee9 = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    if (initialModelState && initialModelState.visitPortal) return initialModelState.visitPortal;
    return $faeda95f166d650c$var$defaultState;
};
function $faeda95f166d650c$export$8f27b2a880eeba34(state = $faeda95f166d650c$export$53ac33307b5acee9(), action) {
    switch(action.type){
        case 0, $dSbFt.FETCH_VISIT_PORTAL_SUCCESS:
            return $faeda95f166d650c$var$handleFetchVisitPortalSuccess(state, action);
        case 0, $dSbFt.FETCH_VISIT_PORTAL_FAILURE:
            return $faeda95f166d650c$var$handleFetchVisitPortalFailure(state, action);
        default:
            return state;
    }
}
function $faeda95f166d650c$var$handleFetchVisitPortalSuccess(state, action) {
    const response = action.payload;
    if (!response) return state;
    return {
        ...state,
        loggedInBeforeCheck: response.loggedInBeforeCheck,
        email: response.email,
        portalName: response.portalName,
        setPasswordJwt: response.setPasswordJwt
    };
}
function $faeda95f166d650c$var$handleFetchVisitPortalFailure(state, action) {
    const { error: error } = action.payload;
    return {
        ...state,
        initialError: {
            error: {
                status: error.status,
                message: (error.errorMessages || [])[0],
                // We need to remove basename, see https://jdog.jira-dev.com/browse/FSD-2557
                callToActionUrl: (error.nextActionUrl || '').replace((0, $3wR8f.getBaseName)(), ''),
                callToActionText: error.nextActionDisplayText || ''
            }
        }
    };
}

});



parcelRegister("7nkv6", function(module, exports) {
$parcel$export(module.exports, "default", () => $115121159d54e7ff$export$2e2bcd8739ae039);
parcelRequire("2pQ8V");
var $8Qej1 = parcelRequire("8Qej1");

var $gKlTs = parcelRequire("gKlTs");

var $447tR = parcelRequire("447tR");
var $115121159d54e7ff$export$2e2bcd8739ae039 = (0, $8Qej1.default)({
    persisted: $gKlTs.default,
    ui: $447tR.default
});

});
parcelRegister("447tR", function(module, exports) {
$parcel$export(module.exports, "getCombinedUIReducer", () => $bf84b712f9bf78c5$export$7d44d6add2bebf09);
$parcel$export(module.exports, "default", () => $bf84b712f9bf78c5$export$2e2bcd8739ae039);
parcelRequire("2pQ8V");
var $8Qej1 = parcelRequire("8Qej1");
parcelRequire("4eCFQ");
var $cW9E8 = parcelRequire("cW9E8");
parcelRequire("6blDf");
var $6Hdre = parcelRequire("6Hdre");
parcelRequire("ftQDU");
var $2Edxt = parcelRequire("2Edxt");
parcelRequire("fNzsx");
var $36O4q = parcelRequire("36O4q");
parcelRequire("1b2b6");
var $k61VR = parcelRequire("k61VR");
parcelRequire("8Q83O");
var $aUHtj = parcelRequire("aUHtj");
parcelRequire("3dd2R");
var $fAXoV = parcelRequire("fAXoV");
parcelRequire("guKDy");
var $8HB3p = parcelRequire("8HB3p");
parcelRequire("caAMC");
var $5Bpy5 = parcelRequire("5Bpy5");
parcelRequire("aEUz1");
var $u3Dxh = parcelRequire("u3Dxh");
parcelRequire("hl85g");
var $4jCP3 = parcelRequire("4jCP3");
parcelRequire("kjUeg");
var $dYh4Q = parcelRequire("dYh4Q");
parcelRequire("3iPRO");
var $lLVsE = parcelRequire("lLVsE");
parcelRequire("58Zs0");
var $gmqeb = parcelRequire("gmqeb");
parcelRequire("dOIPO");
var $ajPNO = parcelRequire("ajPNO");
parcelRequire("80XtF");
var $02S0N = parcelRequire("02S0N");
parcelRequire("e3i7U");
var $aLZCw = parcelRequire("aLZCw");
parcelRequire("baX0y");
var $kd8ge = parcelRequire("kd8ge");
parcelRequire("bMqMr");
var $fpORt = parcelRequire("fpORt");
parcelRequire("7CHu4");
var $cUws4 = parcelRequire("cUws4");
parcelRequire("6eJAW");
var $j3Gfu = parcelRequire("j3Gfu");
const $bf84b712f9bf78c5$var$reducerCollection = {
    context: (0, $36O4q.default),
    search: (0, $kd8ge.default),
    helpCenterPreview: (0, $8HB3p.default),
    portalCustomisation: (0, $lLVsE.default),
    requestDetails: (0, $gmqeb.requestDetailsReducer),
    requestList: (0, $ajPNO.requestListReducer),
    approvalList: (0, $cW9E8.approvalistReducer),
    flags: (0, $fAXoV.flagsReducer),
    userProfile: (0, $j3Gfu.userProfileReducer),
    login: (0, $u3Dxh.loginUiReducer),
    loginAnnouncements: (0, $4jCP3.loginAnnouncementsReducer),
    invitedSignUp: (0, $5Bpy5.invitedSignUpUiReducer),
    resetPassword: (0, $aLZCw.resetPasswordReducer),
    completeSignup: (0, $2Edxt.completeSignupUiReducer),
    signUpCheckEmail: (0, $fpORt.checkEmailUiReducer),
    featuredAndSortedPortals: (0, $k61VR.featuredAndSortedPortalsReducer),
    feedbackCollector: (0, $aUHtj.feedbackCollectorReducer),
    portals: (0, $dYh4Q.portalReducer),
    resendVerifyEmail: (0, $02S0N.resendVerifyReducer),
    topics: (0, $cUws4.default),
    chatDetails: (0, $6Hdre.chatDetailsReducer)
};
const $bf84b712f9bf78c5$export$7d44d6add2bebf09 = (asyncReducers)=>(0, $8Qej1.default)({
        ...$bf84b712f9bf78c5$var$reducerCollection,
        ...asyncReducers
    });
var $bf84b712f9bf78c5$export$2e2bcd8739ae039 = (0, $8Qej1.default)($bf84b712f9bf78c5$var$reducerCollection);

});
parcelRegister("4eCFQ", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => (parcelRequire("cW9E8")).approvalistReducer);

var $cW9E8 = parcelRequire("cW9E8");

});
parcelRegister("cW9E8", function(module, exports) {
$parcel$export(module.exports, "approvalistReducer", () => $0ca802a0ec1c5788$export$b467bcef5b3409ab);
parcelRequire("g99P5");
var $cht5V = parcelRequire("cht5V");
const $0ca802a0ec1c5788$var$defaultState = {
    isLoading: false
};
function $0ca802a0ec1c5788$export$b467bcef5b3409ab(state = $0ca802a0ec1c5788$var$defaultState, action) {
    switch(action.type){
        case 0, $cht5V.FETCH_APPROVAL_LIST_MODEL:
            return $0ca802a0ec1c5788$var$handleFetchApprovalListAction(state);
        case 0, $cht5V.FETCH_APPROVAL_LIST_SUCCESS:
            return $0ca802a0ec1c5788$var$handleFetchApprovalListSuccess(state);
        case 0, $cht5V.FETCH_APPROVAL_LIST_FAILURE:
            return $0ca802a0ec1c5788$var$handleFetchApprovalListFailure(state);
        default:
            return state;
    }
}
const $0ca802a0ec1c5788$var$handleFetchApprovalListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $0ca802a0ec1c5788$var$handleFetchApprovalListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $0ca802a0ec1c5788$var$handleFetchApprovalListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("6blDf", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => (parcelRequire("6Hdre")).chatDetailsReducer);

var $6Hdre = parcelRequire("6Hdre");

});
parcelRegister("6Hdre", function(module, exports) {
$parcel$export(module.exports, "chatDetailsReducer", () => $b2483d94d7581a2e$export$38fe3740469ec1e6);
parcelRequire("2WwoJ");
var $ltiec = parcelRequire("ltiec");
const $b2483d94d7581a2e$export$29e68d440392d68e = {
    isChatSideBarOpen: false
};
function $b2483d94d7581a2e$export$38fe3740469ec1e6(state = $b2483d94d7581a2e$export$29e68d440392d68e, action) {
    if (action.type === (0, $ltiec.OPEN_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: true
    };
    if (action.type === (0, $ltiec.CLOSE_CHAT_SIDE_BAR)) return {
        ...state,
        isChatSideBarOpen: false
    };
    return state;
}

});
parcelRegister("2WwoJ", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => (parcelRequire("ltiec")).OPEN_CHAT_SIDE_BAR);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => (parcelRequire("ltiec")).CLOSE_CHAT_SIDE_BAR);
$parcel$export(module.exports, "openChatSideBar", () => (parcelRequire("ltiec")).openChatSideBar);
$parcel$export(module.exports, "closeChatSideBar", () => (parcelRequire("ltiec")).closeChatSideBar);

var $ltiec = parcelRequire("ltiec");

});
parcelRegister("ltiec", function(module, exports) {
$parcel$export(module.exports, "OPEN_CHAT_SIDE_BAR", () => $b7de0a09449f36e0$export$dc5a6dd48e3ba8bf);
$parcel$export(module.exports, "CLOSE_CHAT_SIDE_BAR", () => $b7de0a09449f36e0$export$c4de34e9e1c374f8);
$parcel$export(module.exports, "openChatSideBar", () => $b7de0a09449f36e0$export$348d5042d1099e44);
$parcel$export(module.exports, "closeChatSideBar", () => $b7de0a09449f36e0$export$7fb0f09e601a69a9);
const $b7de0a09449f36e0$export$dc5a6dd48e3ba8bf = 'state.ui.chat-details.OPEN_CHAT_SIDE_BAR';
const $b7de0a09449f36e0$export$c4de34e9e1c374f8 = 'state.ui.chat-details.CLOSE_CHAT_SIDE_BAR';
const $b7de0a09449f36e0$export$348d5042d1099e44 = ()=>({
        type: $b7de0a09449f36e0$export$dc5a6dd48e3ba8bf
    });
const $b7de0a09449f36e0$export$7fb0f09e601a69a9 = ()=>({
        type: $b7de0a09449f36e0$export$c4de34e9e1c374f8
    });

});




parcelRegister("ftQDU", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => (parcelRequire("2Edxt")).completeSignupUiReducer);

var $2Edxt = parcelRequire("2Edxt");

});
parcelRegister("2Edxt", function(module, exports) {
$parcel$export(module.exports, "completeSignupUiReducer", () => $f66d23276e032579$export$11cdd5afa8f3d37e);
parcelRequire("iKA91");
var $1uz6E = parcelRequire("1uz6E");
const $f66d23276e032579$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    submitError: undefined,
    isNewSignupLinkBeingSent: false,
    newSignupLinkSuccessfullySent: false
};
function $f66d23276e032579$export$11cdd5afa8f3d37e(state = $f66d23276e032579$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $1uz6E.COMPLETE_SIGNUP:
            return $f66d23276e032579$var$handleCompleteSignup(state);
        case 0, $1uz6E.COMPLETE_SIGNUP_FAILURE:
            return $f66d23276e032579$var$handleCompleteSignupFailure(state, action);
        case 0, $1uz6E.SEND_NEW_SIGNUP_LINK:
            return $f66d23276e032579$var$handleSendNewSignupLink(state);
        case 0, $1uz6E.SEND_NEW_SIGNUP_LINK_SUCCESS:
            return $f66d23276e032579$var$handleSendNewSignupLinkSuccess(state);
        case 0, $1uz6E.SEND_NEW_SIGNUP_LINK_FAILURE:
            return $f66d23276e032579$var$handleSendNewSignupLinkFailure(state);
        default:
            return state;
    }
}
const $f66d23276e032579$var$handleCompleteSignup = (state)=>({
        ...state,
        isSubmitting: true,
        submitError: undefined
    });
const $f66d23276e032579$var$handleCompleteSignupFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        submitError: action.payload.error
    });
const $f66d23276e032579$var$handleSendNewSignupLink = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: true
    });
const $f66d23276e032579$var$handleSendNewSignupLinkSuccess = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false,
        newSignupLinkSuccessfullySent: true
    });
const $f66d23276e032579$var$handleSendNewSignupLinkFailure = (state)=>({
        ...state,
        isNewSignupLinkBeingSent: false
    });

});


parcelRegister("fNzsx", function(module, exports) {
$parcel$export(module.exports, "contextReducer", () => (parcelRequire("36O4q")).default);

var $36O4q = parcelRequire("36O4q");

});
parcelRegister("36O4q", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0cdf9f9831e5df5$export$2e2bcd8739ae039);
parcelRequire("lCNLa");
var $cwmBL = parcelRequire("cwmBL");

var $9mQxZ = parcelRequire("9mQxZ");

var $2jpwX = parcelRequire("2jpwX");
const $e0cdf9f9831e5df5$export$53ac33307b5acee9 = ()=>{
    var _initialModelState$po;
    const initialModelState = (0, $9mQxZ.default)();
    const initialState = initialModelState !== null && initialModelState !== void 0 && initialModelState.portal ? {
        portalId: Number((_initialModelState$po = initialModelState.portal) === null || _initialModelState$po === void 0 ? void 0 : _initialModelState$po.id)
    } : {};
    return initialState;
};
const $e0cdf9f9831e5df5$export$49d5fc8cba920a0 = $e0cdf9f9831e5df5$export$53ac33307b5acee9();
function $e0cdf9f9831e5df5$export$2e2bcd8739ae039(state = $e0cdf9f9831e5df5$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $cwmBL.UPDATE_CONTEXT:
            {
                const { pathname: pathname, pathParams: pathParams, routeName: routeName } = action.payload;
                let portalId;
                if (pathParams) portalId = (0, $2jpwX.toNumber)(pathParams.portalId);
                return {
                    portalId: portalId,
                    pathname: pathname,
                    routeName: routeName
                };
            }
        case 0, $cwmBL.CLEAR_CONTEXT:
            return {};
        default:
            return state;
    }
}

});
parcelRegister("lCNLa", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => (parcelRequire("cwmBL")).UPDATE_CONTEXT);
$parcel$export(module.exports, "updateContextAction", () => (parcelRequire("cwmBL")).updateContextAction);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => (parcelRequire("cwmBL")).CLEAR_CONTEXT);
$parcel$export(module.exports, "clearContextAction", () => (parcelRequire("cwmBL")).clearContextAction);

var $cwmBL = parcelRequire("cwmBL");

});
parcelRegister("cwmBL", function(module, exports) {
$parcel$export(module.exports, "UPDATE_CONTEXT", () => $44b039890baa7620$export$5f26c565ccbc9352);
$parcel$export(module.exports, "CLEAR_CONTEXT", () => $44b039890baa7620$export$58f534967683dfbc);
$parcel$export(module.exports, "updateContextAction", () => $44b039890baa7620$export$42bc3ab9d92c16ac);
$parcel$export(module.exports, "clearContextAction", () => $44b039890baa7620$export$a40d7f795b5e0d7d);
const $44b039890baa7620$export$5f26c565ccbc9352 = 'state.ui.context.UPDATE_CONTEXT';
const $44b039890baa7620$export$58f534967683dfbc = 'state.ui.context.CLEAR_CONTEXT';
const $44b039890baa7620$export$42bc3ab9d92c16ac = (context)=>({
        type: $44b039890baa7620$export$5f26c565ccbc9352,
        payload: context
    });
const $44b039890baa7620$export$a40d7f795b5e0d7d = ()=>({
        type: $44b039890baa7620$export$58f534967683dfbc
    });

});




parcelRegister("1b2b6", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => (parcelRequire("k61VR")).featuredAndSortedPortalsReducer);

var $k61VR = parcelRequire("k61VR");

});
parcelRegister("k61VR", function(module, exports) {
$parcel$export(module.exports, "featuredAndSortedPortalsReducer", () => $6aac9400ae7cfee8$export$be9fe934804fce97);

var $63sfu = parcelRequire("63sfu");
parcelRequire("7LVOt");
var $db9ld = parcelRequire("db9ld");
parcelRequire("9MU8X");
var $2wESx = parcelRequire("2wESx");

var $9mQxZ = parcelRequire("9mQxZ");
const $6aac9400ae7cfee8$export$aa8b8e485fe6d2cc = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    return {
        featuredPortalIds: [],
        orderedPortalIds: [],
        hiddenPortalIds: [],
        sortBy: 'POPULARITY',
        isDefaultViewLoading: !(initialModelState !== null && initialModelState !== void 0 && initialModelState.featuredAndSortedPortals),
        isExpandedViewLoading: false,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false,
        isDirty: false,
        isSaveInProgress: false,
        isPortalReorderingDataLoaded: false
    };
};
const $6aac9400ae7cfee8$export$95d7509c19bcb89a = (rank)=>rank || 0;
const $6aac9400ae7cfee8$var$defaultState = $6aac9400ae7cfee8$export$aa8b8e485fe6d2cc();
function $6aac9400ae7cfee8$export$be9fe934804fce97(state = $6aac9400ae7cfee8$var$defaultState, action) {
    switch(action.type){
        case 0, $db9ld.FETCH_FEATURED_AND_SORTED_PORTALS_MODEL:
            return $6aac9400ae7cfee8$var$handleFetchFeaturedAndSortedPortalsAction(state, action);
        case 0, $db9ld.FETCH_FEATURED_AND_SORTED_PORTALS_SUCCESS:
            return $6aac9400ae7cfee8$var$handleFetchFeaturedAndSortedPortalsSuccess(state, action);
        case 0, $db9ld.FETCH_FEATURED_AND_SORTED_PORTALS_FAILURE:
            return $6aac9400ae7cfee8$var$handleFetchFeaturedAndSortedPortalsFailure(state, action);
        case 0, $db9ld.MARK_PORTAL_FEATURED:
            return $6aac9400ae7cfee8$var$handleMarkPortalFeatured(state, action);
        case 0, $db9ld.TOGGLE_PORTAL_VISIBILITY:
            return $6aac9400ae7cfee8$var$handleTogglePortalVisibility(state, action);
        case 0, $db9ld.REORDER_FEATURED_PORTAL:
            return $6aac9400ae7cfee8$var$handleReorderFeaturedPortal(state, action);
        case 0, $db9ld.UPDATE_PORTAL_REORDER_SETTINGS_MODEL:
            return $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettings(state);
        case 0, $db9ld.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_SUCCESS:
            return $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsModelSuccess(state);
        case 0, $db9ld.UPDATE_PORTAL_REORDER_SETTINGS_MODEL_FAILURE:
            return $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsModelFailure(state);
        case 0, $db9ld.UPDATE_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsSuccess(state);
        case 0, $db9ld.UPDATE_PORTAL_REORDER_SETTINGS_FAILURE:
            return $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsFailure(state);
        case 0, $db9ld.RESET_PORTAL_REORDER_SETTINGS_SUCCESS:
            return $6aac9400ae7cfee8$var$handleResetPortalReorderSettingsSuccess(state, action);
        case 0, $db9ld.MARK_PORTAL_REORDER_SETTINGS_DIRTY:
            return $6aac9400ae7cfee8$var$handleMarkPortalReorderSettingsDirty(state);
        default:
            return state;
    }
}
const $6aac9400ae7cfee8$var$handleFetchFeaturedAndSortedPortalsAction = (state, action)=>{
    if (action.payload.params.exploreAll) {
        /* On help seekers view, and clicked on exploreAll */ if (!action.payload.params.isPortalReorderingSelected) return {
            ...state,
            isExpandedViewLoading: true
        };
        /* on changing sorted preference on portal reordering screen */ if (action.payload.params.sortBy) return {
            ...state,
            isSortedDataLoading: true,
            sortBy: action.payload.params.sortBy ? action.payload.params.sortBy : 'POPULARITY'
        };
        /* on initial page load for portal reordering screen */ return {
            ...state,
            isReorderingExperienceLoading: true
        };
    }
    /* On help seekers view, initial loading for featured portals or top 6 sorted portals */ return {
        ...state,
        isDefaultViewLoading: true
    };
};
const $6aac9400ae7cfee8$var$handleFetchFeaturedAndSortedPortalsSuccess = (state, action)=>{
    if (!action.requestParams.isPortalReorderingSelected) {
        /* on Help seeker view - on clicking exploreAll */ if (action.requestParams.exploreAll) return {
            ...state,
            isExpandedViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
        /* on Help seeker view - initial loading */ return {
            ...state,
            isDefaultViewLoading: false,
            isPortalReorderingDataLoaded: false
        };
    }
    /* on portal reordering screen - on changing sortBy option */ if (action.requestParams.sortBy) return {
        ...state,
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isSortedDataLoading: false,
        sortBy: action.requestParams.sortBy || state.sortBy
    };
    /* on portal reordering screen - initial load */ return {
        ...state,
        featuredPortalIds: action.payload.portals.filter((0, $2wESx.isFeaturedPortal)).sort((portal1, portal2)=>$6aac9400ae7cfee8$export$95d7509c19bcb89a(portal1.rank) - $6aac9400ae7cfee8$export$95d7509c19bcb89a(portal2.rank)).map((portal)=>portal.id),
        hiddenPortalIds: action.payload.portals.filter((0, $2wESx.isHiddenPortal)).map((portal)=>portal.id),
        orderedPortalIds: action.payload.portals.map((portal)=>portal.id),
        isReorderingExperienceLoading: false,
        sortBy: action.payload.sortBy || state.sortBy,
        isPortalReorderingDataLoaded: true
    };
};
const $6aac9400ae7cfee8$var$handleFetchFeaturedAndSortedPortalsFailure = (state, action)=>{
    /* Error in  help seekers view*/ if (!action.requestParams.isPortalReorderingSelected) return {
        ...state,
        isExpandedViewLoading: false,
        isDefaultViewLoading: false
    };
    /* Error in portal reordering view */ return {
        ...state,
        isReorderingExperienceLoading: false,
        isSortedDataLoading: false
    };
};
const $6aac9400ae7cfee8$var$handleMarkPortalFeatured = (state, action)=>{
    const { id: id, isFeatured: isFeatured } = action.payload;
    const { featuredPortalIds: featuredPortalIds } = state;
    const updateFeaturedPortalIds = [
        ...featuredPortalIds
    ];
    if (isFeatured) updateFeaturedPortalIds.push(id);
    else (0, $63sfu.remove)(updateFeaturedPortalIds, (item)=>item === id);
    return {
        ...state,
        featuredPortalIds: updateFeaturedPortalIds,
        isDirty: true
    };
};
const $6aac9400ae7cfee8$var$handleTogglePortalVisibility = (state, action)=>{
    const { id: id, hiddenFromHomeScreen: hiddenFromHomeScreen } = action.payload;
    const { hiddenPortalIds: hiddenPortalIds } = state;
    const updatedHiddenPortalIds = [
        ...hiddenPortalIds
    ];
    if (hiddenFromHomeScreen) updatedHiddenPortalIds.push(id);
    else (0, $63sfu.remove)(updatedHiddenPortalIds, (item)=>item === id);
    return {
        ...state,
        hiddenPortalIds: (0, $63sfu.uniq)(updatedHiddenPortalIds),
        isDirty: true
    };
};
const $6aac9400ae7cfee8$var$reOrder = (list, startIndex, endIndex)=>{
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};
const $6aac9400ae7cfee8$var$handleReorderFeaturedPortal = (state, action)=>{
    const { oldIndex: oldIndex, newIndex: newIndex } = action.payload;
    return {
        ...state,
        featuredPortalIds: $6aac9400ae7cfee8$var$reOrder(state.featuredPortalIds, oldIndex, newIndex),
        isDirty: true
    };
};
const $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettings = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsModelSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsModelFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: true
    };
};
const $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsSuccess = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false
    };
};
const $6aac9400ae7cfee8$var$handleUpdatePortalReorderSettingsFailure = (state)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: true
    };
};
// Common logic for both Reset and Cancel action
const $6aac9400ae7cfee8$var$handleResetPortalReorderSettingsSuccess = (state, action)=>{
    return {
        ...state,
        isSaveInProgress: false,
        isDirty: false,
        sortBy: action.payload.sortBy,
        featuredPortalIds: action.payload.featuredPortalIds,
        orderedPortalIds: action.payload.orderedPortalIds
    };
};
const $6aac9400ae7cfee8$var$handleMarkPortalReorderSettingsDirty = (state)=>{
    return {
        ...state,
        isDirty: true
    };
};

});


parcelRegister("8Q83O", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => (parcelRequire("aUHtj")).feedbackCollectorReducer);

var $aUHtj = parcelRequire("aUHtj");

});
parcelRegister("aUHtj", function(module, exports) {
$parcel$export(module.exports, "feedbackCollectorReducer", () => $c3ccdb0e3ba290c3$export$8085646591e2a0b2);
parcelRequire("1ZnUa");
var $l3HT9 = parcelRequire("l3HT9");

var $ebpTf = parcelRequire("ebpTf");
const $c3ccdb0e3ba290c3$var$addPortalPrefix = (featureName)=>{
    return 'JSM Portal '.concat(featureName);
};
const $c3ccdb0e3ba290c3$export$fe349eba520514db = {
    shouldOpenFeedbackWidget: false,
    showTypeField: false,
    additionalFields: {}
};
const $c3ccdb0e3ba290c3$var$defaultState = $c3ccdb0e3ba290c3$export$fe349eba520514db;
function $c3ccdb0e3ba290c3$export$8085646591e2a0b2(state = $c3ccdb0e3ba290c3$var$defaultState, action) {
    switch(action.type){
        case 0, $l3HT9.SHOW_FEEDACK_COLLECTOR:
            return $c3ccdb0e3ba290c3$var$handleFeedbackCollector(state, action);
        case 0, $l3HT9.HIDE_FEEDACK_COLLECTOR:
            return $c3ccdb0e3ba290c3$var$handleFeedbackCollector(state, action);
        case 0, $l3HT9.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR:
            return $c3ccdb0e3ba290c3$var$handleUpdateAdditionalFieldsInFeedbackCollector(state, action);
        default:
            return state;
    }
}
const $c3ccdb0e3ba290c3$var$handleFeedbackCollector = (state, action)=>{
    if (action.type === (0, $l3HT9.HIDE_FEEDACK_COLLECTOR)) return {
        ...state,
        shouldOpenFeedbackWidget: false
    };
    const { showTypeField: showTypeField, CustomComponent: CustomComponent, featureName: featureName, env: env } = action.payload;
    const newState = {
        ...state,
        showTypeField: showTypeField,
        CustomComponent: CustomComponent,
        shouldOpenFeedbackWidget: true
    };
    if (env === (0, $ebpTf.EnvType).PROD) {
        newState.additionalFields = {
            // Do not change this field as this is an actual custom field in https://jira-feedback.atlassian.net. Changing this will break feedback collector in production.
            customfield_10076: $c3ccdb0e3ba290c3$var$addPortalPrefix(featureName)
        };
        return newState;
    }
    newState.additionalFields = {
        // Do not change this field as this is an actual custom field in https://arajpal.atlassian.net. Changing this will break feedback collector in staging.
        customfield_10094: $c3ccdb0e3ba290c3$var$addPortalPrefix(featureName)
    };
    return newState;
};
const $c3ccdb0e3ba290c3$var$handleUpdateAdditionalFieldsInFeedbackCollector = (state, action)=>{
    return {
        ...state,
        additionalFields: {
            ...state.additionalFields,
            ...action.payload.additionalFields
        }
    };
};

});
parcelRegister("1ZnUa", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => (parcelRequire("l3HT9")).SHOW_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "showFeedbackCollector", () => (parcelRequire("l3HT9")).showFeedbackCollector);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => (parcelRequire("l3HT9")).HIDE_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "hideFeedbackCollector", () => (parcelRequire("l3HT9")).hideFeedbackCollector);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => (parcelRequire("l3HT9")).UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => (parcelRequire("l3HT9")).updateAdditionalFieldsInFeedbackCollector);

var $l3HT9 = parcelRequire("l3HT9");

});
parcelRegister("l3HT9", function(module, exports) {
$parcel$export(module.exports, "SHOW_FEEDACK_COLLECTOR", () => $62d56ef814f03c26$export$e920d8568364aa72);
$parcel$export(module.exports, "HIDE_FEEDACK_COLLECTOR", () => $62d56ef814f03c26$export$20dd51f415d7804e);
$parcel$export(module.exports, "UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR", () => $62d56ef814f03c26$export$3366d0333401654a);
$parcel$export(module.exports, "showFeedbackCollector", () => $62d56ef814f03c26$export$c759098e05f62ce0);
$parcel$export(module.exports, "hideFeedbackCollector", () => $62d56ef814f03c26$export$92f2211d73785c9);
$parcel$export(module.exports, "updateAdditionalFieldsInFeedbackCollector", () => $62d56ef814f03c26$export$41e78cf91821ccad);
const $62d56ef814f03c26$export$e920d8568364aa72 = 'state.ui.feedback-collector.SHOW_FEEDACK_COLLECTOR';
const $62d56ef814f03c26$export$20dd51f415d7804e = 'state.ui.feedback-collector.HIDE_FEEDACK_COLLECTOR';
const $62d56ef814f03c26$export$3366d0333401654a = 'state.ui.feedback-collector.UPDATE_ADDITIONAL_FIELDS_IN_FEEDACK_COLLECTOR';
const $62d56ef814f03c26$export$c759098e05f62ce0 = (payload)=>({
        payload: payload,
        type: $62d56ef814f03c26$export$e920d8568364aa72
    });
const $62d56ef814f03c26$export$92f2211d73785c9 = ()=>({
        type: $62d56ef814f03c26$export$20dd51f415d7804e
    });
const $62d56ef814f03c26$export$41e78cf91821ccad = (additionalFields)=>({
        type: $62d56ef814f03c26$export$3366d0333401654a,
        payload: {
            additionalFields: additionalFields
        }
    });

});




parcelRegister("3dd2R", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => (parcelRequire("fAXoV")).flagsReducer);

var $fAXoV = parcelRequire("fAXoV");

});
parcelRegister("fAXoV", function(module, exports) {
$parcel$export(module.exports, "flagsReducer", () => $e81dee84d9135f21$export$64fc5b4c35b25733);

var $gBYjj = parcelRequire("gBYjj");
const $e81dee84d9135f21$var$MAX_FLAG_ID = 99999;
const $e81dee84d9135f21$var$defaultState = {
    flags: []
};
function $e81dee84d9135f21$export$64fc5b4c35b25733(state = $e81dee84d9135f21$var$defaultState, action) {
    switch(action.type){
        case 0, $gBYjj.SHOW_ERROR_FLAG:
            return $e81dee84d9135f21$var$handleShowErrorFlag(state, action);
        case 0, $gBYjj.SHOW_WARNING_FLAG:
            return $e81dee84d9135f21$var$handleShowWarningFlag(state, action);
        case 0, $gBYjj.SHOW_SUCCESS_FLAG:
            return $e81dee84d9135f21$var$handleShowSuccessFlag(state, action);
        case 0, $gBYjj.DISMISS_FLAG:
            return $e81dee84d9135f21$var$handleFlagDismissal(state, action);
        case 0, $gBYjj.SHOW_BOLD_APPEARANCE_FLAG:
            return $e81dee84d9135f21$var$handleShowBoldAppearanceFlag(state, action);
        default:
            return state;
    }
}
function $e81dee84d9135f21$var$handleShowErrorFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $e81dee84d9135f21$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'error'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $e81dee84d9135f21$var$handleShowWarningFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $e81dee84d9135f21$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'warning'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $e81dee84d9135f21$var$handleShowSuccessFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $e81dee84d9135f21$var$generateFlagId(),
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        type: 'success'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
function $e81dee84d9135f21$var$handleShowBoldAppearanceFlag(state, action) {
    const updatedFlags = [
        ...state.flags
    ];
    updatedFlags.unshift({
        id: $e81dee84d9135f21$var$generateFlagId(),
        appearance: action.payload.appearance,
        titleMessage: action.payload.titleMessage,
        titleMessageValues: action.payload.titleMessageValues,
        descriptionMessage: action.payload.descriptionMessage,
        descriptionMessageValues: action.payload.descriptionMessageValues,
        actions: action.payload.actions || [],
        dismissActionValue: action.payload.dismissActionValue,
        type: 'bold'
    });
    return {
        ...state,
        flags: updatedFlags
    };
}
const $e81dee84d9135f21$var$generateFlagId = ()=>// Integer between 0 and MAX_FLAG_ID
    Math.floor(Math.random() * Math.floor($e81dee84d9135f21$var$MAX_FLAG_ID));
function $e81dee84d9135f21$var$handleFlagDismissal(state, action) {
    const updatedFlags = state.flags.filter((flag)=>flag.id !== action.payload.flagId);
    return {
        ...state,
        flags: updatedFlags
    };
}

});


parcelRegister("guKDy", function(module, exports) {
$parcel$export(module.exports, "helpcenterPreviewReducer", () => (parcelRequire("8HB3p")).default);

var $8HB3p = parcelRequire("8HB3p");

});
parcelRegister("8HB3p", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e3eabad5c33df04$export$2e2bcd8739ae039);

var $krFoK = parcelRequire("krFoK");

var $63sfu = parcelRequire("63sfu");
const $4e3eabad5c33df04$var$getDefaultState = ()=>({
        isCustomizing: false,
        isSaveInProgress: false,
        translations: {},
        uploadsInProgress: {}
    });
function $4e3eabad5c33df04$export$2e2bcd8739ae039(state = $4e3eabad5c33df04$var$getDefaultState(), action) {
    switch(action.type){
        case $krFoK.UPDATE_HELP_CENTER_PREVIEW_MODEL:
            {
                const newState = (0, $63sfu.mergeWith)({}, {
                    ...state
                }, {
                    ...action.payload
                }, // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
                // eslint-disable-next-line @typescript-eslint/ban-types
                (_, srcValue)=>{
                    // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
                    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
                    if (srcValue === undefined) return null;
                    // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
                    return undefined;
                });
                return {
                    ...newState
                };
            }
        case $krFoK.EDITING_HELP_CENTER:
            return {
                ...state,
                isCustomizing: action.payload
            };
        case $krFoK.CLEAR_HELP_CENTER_PREVIEW_MODEL:
            return {
                translations: {},
                uploadsInProgress: {},
                isCustomizing: false,
                isSaveInProgress: false
            };
        case $krFoK.UPDATE_HELP_CENTER_BRANDING:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $krFoK.UPDATE_HELP_CENTER_BRANDING_MUTATION_SUCCESS:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $krFoK.UPDATE_HELP_CENTER_BRANDING_MUTATION_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $krFoK.UPDATE_HELP_CENTER_BRANDING_SAVE_START:
            return {
                ...state,
                isSaveInProgress: true
            };
        case $krFoK.UPDATE_HELP_CENTER_BRANDING_FAILURE:
            return {
                ...state,
                isSaveInProgress: false
            };
        case $krFoK.UPLOAD_START:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: true
                }
            };
        case $krFoK.UPLOAD_END:
            return {
                ...state,
                uploadsInProgress: {
                    ...state.uploadsInProgress,
                    [action.payload.fileCollection]: false
                }
            };
        default:
            return state;
    }
}

});


parcelRegister("caAMC", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => (parcelRequire("5Bpy5")).invitedSignUpUiReducer);

var $5Bpy5 = parcelRequire("5Bpy5");

});
parcelRegister("5Bpy5", function(module, exports) {
$parcel$export(module.exports, "invitedSignUpUiReducer", () => $591e2fbc0155b321$export$cbd9046ae6d17b9c);
parcelRequire("4C3Ab");
var $dSbFt = parcelRequire("dSbFt");
const $591e2fbc0155b321$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    error: undefined
};
function $591e2fbc0155b321$export$cbd9046ae6d17b9c(state = $591e2fbc0155b321$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $dSbFt.INVITED_SIGN_UP:
            return $591e2fbc0155b321$var$handleInvitedSignUp(state);
        case 0, $dSbFt.INVITED_SIGN_UP_FAILURE:
            return $591e2fbc0155b321$var$handleInvitedSignUpFailure(state, action);
        default:
            return state;
    }
}
const $591e2fbc0155b321$var$handleInvitedSignUp = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $591e2fbc0155b321$var$handleInvitedSignUpFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("aEUz1", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => (parcelRequire("u3Dxh")).loginUiReducer);

var $u3Dxh = parcelRequire("u3Dxh");

});
parcelRegister("u3Dxh", function(module, exports) {
$parcel$export(module.exports, "loginUiReducer", () => $a95bcf796d692b7d$export$b52e2813f588ee78);
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");

var $g01X2 = parcelRequire("g01X2");
const $a95bcf796d692b7d$export$49d5fc8cba920a0 = {
    email: '',
    atlassianAccountCheckPerformed: false,
    isSubmitting: false,
    isSendingForgotPasswordEmail: false,
    isSendingCreatePasswordEmail: false,
    authInfo: {
        accountStage: (0, $g01X2.AccountStageType).LOGIN,
        authMethods: new Map([
            [
                (0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                {}
            ]
        ])
    },
    showPasswordConfirmation: false,
    showSsoTestModeErrorPage: false,
    showLoginConsentErrorPage: false
};
function $a95bcf796d692b7d$export$b52e2813f588ee78(state = $a95bcf796d692b7d$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $8o5VQ.CHANGE_EMAIL_INPUT:
            return $a95bcf796d692b7d$var$handleChangeEmailInput(state, action);
        case 0, $8o5VQ.CHECK_LOGIN_ACTION:
            return $a95bcf796d692b7d$var$handleCheckLoginActionAction(state);
        case 0, $8o5VQ.CHECK_LOGIN_ACTION_SUCCESS:
            return $a95bcf796d692b7d$var$handleCheckLoginActionSuccess(state, action);
        case 0, $8o5VQ.CHECK_LOGIN_ACTION_FAILURE:
            return $a95bcf796d692b7d$var$handleCheckLoginActionFailure(state, action);
        case 0, $8o5VQ.CREATE_PASSWORD:
            return $a95bcf796d692b7d$var$handleCreatePassword(state);
        case 0, $8o5VQ.FORGOT_PASSWORD:
            return $a95bcf796d692b7d$var$handleForgotPassword(state);
        case 0, $8o5VQ.FORGOT_PASSWORD_FAILURE:
            return $a95bcf796d692b7d$var$handleForgotPasswordFailure(state);
        case 0, $8o5VQ.FORGOT_PASSWORD_SUCCESS:
            return $a95bcf796d692b7d$var$handleForgotPasswordSuccess(state);
        case 0, $8o5VQ.CREATE_PASSWORD_SUCCESS:
            return $a95bcf796d692b7d$var$handleCreatePasswordSuccess(state);
        case 0, $8o5VQ.LOGIN_ATTEMPT:
            return $a95bcf796d692b7d$var$handleLoginAttempt(state);
        case 0, $8o5VQ.LOGIN_ATTEMPT_SUCCESS:
            return $a95bcf796d692b7d$var$handleLoginAttemptSuccess(state, action);
        case 0, $8o5VQ.LOGIN_ATTEMPT_FAILURE:
            return $a95bcf796d692b7d$var$handleLoginAttemptFailure(state, action);
        case 0, $8o5VQ.CA_SSO_TEST_MODE_FAILURE:
            return $a95bcf796d692b7d$var$handleCaSsoTestModeFailure(state);
        case 0, $8o5VQ.LOGIN_CONSENT_FAILURE:
            return $a95bcf796d692b7d$var$handleLoginConsentFailure(state);
        case 0, $8o5VQ.RESET_LOGIN:
            return $a95bcf796d692b7d$var$resetLogin(action);
        default:
            return state;
    }
}
const $a95bcf796d692b7d$var$handleChangeEmailInput = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        email: action.payload.email
    });
const $a95bcf796d692b7d$var$handleCheckLoginActionAction = (state)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: undefined
    });
const $a95bcf796d692b7d$var$handleCheckLoginActionSuccess = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: true,
        authInfo: {
            ...state.authInfo,
            accountStage: action.payload.authInfo.accountStage,
            authMethods: action.payload.authInfo.authMethods
        },
        error: undefined
    });
const $a95bcf796d692b7d$var$handleCaSsoTestModeFailure = (state)=>({
        ...state,
        showSsoTestModeErrorPage: true
    });
const $a95bcf796d692b7d$var$handleLoginConsentFailure = (state)=>({
        ...state,
        showLoginConsentErrorPage: true
    });
const $a95bcf796d692b7d$var$handleCheckLoginActionFailure = (state, action)=>({
        ...state,
        atlassianAccountCheckPerformed: false,
        error: action.payload.error
    });
const $a95bcf796d692b7d$var$handleCreatePassword = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: true
    });
const $a95bcf796d692b7d$var$handleCreatePasswordSuccess = (state)=>({
        ...state,
        isSendingCreatePasswordEmail: false,
        showPasswordConfirmation: true
    });
const $a95bcf796d692b7d$var$handleForgotPassword = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: true
    });
const $a95bcf796d692b7d$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false
    });
const $a95bcf796d692b7d$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        isSendingForgotPasswordEmail: false,
        showPasswordConfirmation: true
    });
const $a95bcf796d692b7d$var$handleLoginAttempt = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined,
        loginAttemptResponse: undefined
    });
function $a95bcf796d692b7d$var$handleLoginAttemptSuccess(state, action) {
    const { loginAttemptResponse: loginAttemptResponse } = action.payload;
    const defaultValues = {
        loginAttemptResponse: loginAttemptResponse,
        isSubmitting: false,
        error: undefined
    };
    if (loginAttemptResponse.loginSucceeded) return {
        ...state,
        ...defaultValues,
        email: '',
        atlassianAccountCheckPerformed: false
    };
    return {
        ...state,
        ...defaultValues
    };
}
const $a95bcf796d692b7d$var$handleLoginAttemptFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        loginAttemptResponse: undefined,
        error: action.payload.error
    });
const $a95bcf796d692b7d$var$resetLogin = (action)=>({
        ...$a95bcf796d692b7d$export$49d5fc8cba920a0,
        email: action.payload.email
    });

});


parcelRegister("hl85g", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => (parcelRequire("4jCP3")).loginAnnouncementsReducer);

var $4jCP3 = parcelRequire("4jCP3");

});
parcelRegister("4jCP3", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsReducer", () => $a6169d2ecf453a6a$export$14afe2784a94db4d);
parcelRequire("5raaz");
var $bK3LM = parcelRequire("bK3LM");

var $9mQxZ = parcelRequire("9mQxZ");
const $a6169d2ecf453a6a$export$13a9a218541141cd = ()=>{
    const initialModelState = (0, $9mQxZ.default)();
    return {
        loginAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && initialModelState.loginAnnouncements ? initialModelState.loginAnnouncements : {
            defaultLocale: '',
            translatedLoginAnnouncements: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $a6169d2ecf453a6a$var$doesContainLocaleDisplayName = (translatedLoginAnnouncement)=>{
    return 'localeDisplayName' in translatedLoginAnnouncement && !!translatedLoginAnnouncement.localeDisplayName;
};
const $a6169d2ecf453a6a$export$49d5fc8cba920a0 = $a6169d2ecf453a6a$export$13a9a218541141cd();
const $a6169d2ecf453a6a$export$a85783f8b89d3dc8 = (payload, state)=>{
    return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$loginAnnouncem;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $a6169d2ecf453a6a$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$loginAnnouncem = state.loginAnnouncementsResponse.translatedLoginAnnouncements[languageKey]) === null || _state$loginAnnouncem === void 0 ? void 0 : _state$loginAnnouncem.localeDisplayName
            }
        };
    }, {});
};
function $a6169d2ecf453a6a$export$14afe2784a94db4d(state = $a6169d2ecf453a6a$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $bK3LM.FETCH_LOGIN_ANNOUNCEMENTS:
            return $a6169d2ecf453a6a$var$handleFetchLoginAnnouncements(state, true);
        case 0, $bK3LM.FETCH_LOGIN_ANNOUNCEMENTS_SUCCESS:
            return $a6169d2ecf453a6a$var$handleFetchLoginAnnouncementsSuccess(state, action.payload, false);
        case 0, $bK3LM.FETCH_LOGIN_ANNOUNCEMENTS_FAILURE:
            return $a6169d2ecf453a6a$var$handleFetchLoginAnnouncements(state, false);
        case 0, $bK3LM.UPDATE_LOGIN_ANNOUNCEMENTS_MODEL:
            {
                const newState = {
                    ...state,
                    loginAnnouncementsResponse: {
                        ...state.loginAnnouncementsResponse,
                        translatedLoginAnnouncements: $a6169d2ecf453a6a$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $bK3LM.UPDATE_LOGIN_ANNOUNCEMENTS_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $bK3LM.UPDATE_LOGIN_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                loginAnnouncementsResponse: {
                    ...state.loginAnnouncementsResponse,
                    translatedLoginAnnouncements: $a6169d2ecf453a6a$export$a85783f8b89d3dc8(action.payload.translatedLogInAnnouncements, state)
                }
            };
        case 0, $bK3LM.UPDATE_LOGIN_ANNOUNCEMENTS_SUCCESS:
        case 0, $bK3LM.RESET_LOGIN_ANNOUNCEMENTS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}
const $a6169d2ecf453a6a$var$handleFetchLoginAnnouncementsSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        loginAnnouncementsResponse: {
            ...state.loginAnnouncementsResponse,
            defaultLocale: payload.defaultLocale,
            translatedLoginAnnouncements: $a6169d2ecf453a6a$export$a85783f8b89d3dc8(payload.translatedLoginAnnouncements, state)
        },
        isSaveFailed: false
    });
const $a6169d2ecf453a6a$var$handleFetchLoginAnnouncements = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });

});


parcelRegister("kjUeg", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => (parcelRequire("dYh4Q")).portalReducer);

var $dYh4Q = parcelRequire("dYh4Q");

});
parcelRegister("dYh4Q", function(module, exports) {
$parcel$export(module.exports, "portalReducer", () => $ef22bc64366f9173$export$7b4acfe1c1a43b7c);

var $63sfu = parcelRequire("63sfu");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");

var $9mQxZ = parcelRequire("9mQxZ");
const $ef22bc64366f9173$export$db2e6bec0a5d318f = ()=>{
    var _initialModelState$po, _initialModelState$po2;
    const initialModelState = (0, $9mQxZ.default)();
    return {
        portalAnnouncementsResponse: initialModelState !== null && initialModelState !== void 0 && (_initialModelState$po = initialModelState.portal) !== null && _initialModelState$po !== void 0 && _initialModelState$po.portalAnnouncement ? initialModelState === null || initialModelState === void 0 || (_initialModelState$po2 = initialModelState.portal) === null || _initialModelState$po2 === void 0 ? void 0 : _initialModelState$po2.portalAnnouncement : {
            canAdministerProject: false,
            canEditAnnouncement: false,
            defaultLanguageDisplayName: '',
            defaultLanguageHeader: '',
            defaultLanguageMessage: '',
            isUsingLanguageSupport: false,
            portalId: 0,
            portalProjectKey: '',
            userLanguageHeader: '',
            userLanguageMessageWiki: '',
            translations: {}
        },
        isLoading: false,
        isSaveInProgress: false,
        isSaveFailed: false
    };
};
const $ef22bc64366f9173$var$doesContainLocaleDisplayName = (translatedPortalAnnouncement)=>'localeDisplayName' in translatedPortalAnnouncement && !!translatedPortalAnnouncement.localeDisplayName;
const $ef22bc64366f9173$export$49d5fc8cba920a0 = $ef22bc64366f9173$export$db2e6bec0a5d318f();
const $ef22bc64366f9173$export$76e9a6f613765d59 = (payload, state)=>{
    if (payload && !(0, $63sfu.isEmpty)(payload)) return Object.keys(payload).reduce((acc, languageKey)=>{
        var _state$portalAnnounce;
        const payloadForLanguageKey = payload[languageKey];
        return {
            ...acc,
            [languageKey]: {
                header: payloadForLanguageKey.header,
                message: payloadForLanguageKey.message,
                localeDisplayName: $ef22bc64366f9173$var$doesContainLocaleDisplayName(payloadForLanguageKey) ? payloadForLanguageKey.localeDisplayName : (_state$portalAnnounce = state.portalAnnouncementsResponse.translations) === null || _state$portalAnnounce === void 0 || (_state$portalAnnounce = _state$portalAnnounce[languageKey]) === null || _state$portalAnnounce === void 0 ? void 0 : _state$portalAnnounce.localeDisplayName
            }
        };
    }, {});
    return {};
};
const $ef22bc64366f9173$var$handleFetchPortalSuccess = (state, payload, isLoading)=>({
        ...state,
        isLoading: isLoading,
        portalAnnouncementsResponse: {
            ...payload,
            defaultLanguageDisplayName: payload.defaultLanguageDisplayName,
            translations: $ef22bc64366f9173$export$76e9a6f613765d59(payload.translations, state)
        },
        isSaveFailed: false
    });
const $ef22bc64366f9173$var$handleFetchPortal = (state, isLoading)=>({
        ...state,
        isLoading: isLoading,
        isSaveFailed: false
    });
function $ef22bc64366f9173$export$7b4acfe1c1a43b7c(state = $ef22bc64366f9173$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $lXazD.FETCH_PORTAL_MODEL:
            return $ef22bc64366f9173$var$handleFetchPortal(state, true);
        case 0, $lXazD.FETCH_PORTAL_SUCCESS:
            return $ef22bc64366f9173$var$handleFetchPortalSuccess(state, action.payload.portalAnnouncement, false);
        case 0, $lXazD.FETCH_PORTAL_FAILURE:
            return $ef22bc64366f9173$var$handleFetchPortal(state, false);
        case 0, $lXazD.UPDATE_PORTAL_ANNOUNCEMENT_MODEL:
            {
                const newState = {
                    ...state,
                    portalAnnouncementsResponse: {
                        ...state.portalAnnouncementsResponse,
                        translations: $ef22bc64366f9173$export$76e9a6f613765d59(action.payload.translations, state)
                    },
                    isSaveInProgress: true,
                    isSaveFailed: false
                };
                return newState;
            }
        case 0, $lXazD.UPDATE_PORTAL_ANNOUNCEMENT_FAILURE:
            return {
                ...state,
                isSaveFailed: true
            };
        case 0, $lXazD.UPDATE_PORTAL_ANNOUNCEMENTS_UI_STATE:
            return {
                ...state,
                portalAnnouncementsResponse: {
                    ...state.portalAnnouncementsResponse,
                    ...action.payload,
                    translations: $ef22bc64366f9173$export$76e9a6f613765d59(action.payload.translations, state)
                }
            };
        case 0, $lXazD.UPDATE_PORTAL_ANNOUNCEMENT_SUCCESS:
        default:
            return {
                ...state,
                isSaveInProgress: false
            };
    }
}

});


parcelRegister("3iPRO", function(module, exports) {
$parcel$export(module.exports, "portalCustomisationReducer", () => (parcelRequire("lLVsE")).default);
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => (parcelRequire("lLVsE")).PLACEHOLDER_REQUEST_GROUP_ID);

var $lLVsE = parcelRequire("lLVsE");

});
parcelRegister("lLVsE", function(module, exports) {
$parcel$export(module.exports, "PLACEHOLDER_REQUEST_GROUP_ID", () => $a16a6e5c04c3c48d$export$1d5c0939993f01ba);
$parcel$export(module.exports, "default", () => $a16a6e5c04c3c48d$export$2e2bcd8739ae039);
parcelRequire("3hIYf");
var $5glmA = parcelRequire("5glmA");
parcelRequire("bWv0L");
var $bBJtE = parcelRequire("bBJtE");
parcelRequire("3Sl7d");
var $jcEEo = parcelRequire("jcEEo");
parcelRequire("efu6d");
var $ewU6B = parcelRequire("ewU6B");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("5pors");
var $1wRjC = parcelRequire("1wRjC");
parcelRequire("S6V9t");
var $hBMej = parcelRequire("hBMej");
parcelRequire("5eWkp");
var $5sVYY = parcelRequire("5sVYY");
parcelRequire("joL0M");
var $8pWZm = parcelRequire("8pWZm");
parcelRequire("gVfYd");
var $8sM58 = parcelRequire("8sM58");
const $a16a6e5c04c3c48d$export$1d5c0939993f01ba = -1;
const $a16a6e5c04c3c48d$var$getDefaultState = ()=>({
        requestGroups: undefined,
        requestGroupsOrder: undefined,
        requestTypesOrder: undefined,
        requestTypesInRequestGroup: undefined,
        requestTypesNotInRequestGroup: undefined,
        parentRequestGroups: undefined,
        error: undefined,
        groupNameThatCausedError: undefined,
        isParentRequestGroupsLoading: false
    });
function $a16a6e5c04c3c48d$export$2e2bcd8739ae039(state = $a16a6e5c04c3c48d$var$getDefaultState(), action) {
    switch(action.type){
        case 0, $1wRjC.UPDATE_REQUEST_GROUPS_ORDER:
            return {
                ...state,
                requestGroupsOrder: action.payload.order
            };
        case 0, $5glmA.ADD_REQUEST_GROUP:
            {
                const newGroup = {
                    name: action.payload.groupName,
                    id: $a16a6e5c04c3c48d$export$1d5c0939993f01ba // We don't have an id yet because the request hasn't completed, we put in a fake number temporarily. the groups here will get cleared when the persisted model is fetched
                };
                return {
                    ...state,
                    requestGroups: [
                        ...action.payload.existingGroups,
                        newGroup
                    ],
                    error: undefined,
                    groupNameThatCausedError: undefined
                };
            }
        case 0, $5glmA.ADD_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestGroups: undefined,
                error: action.payload.message,
                groupNameThatCausedError: action.payload.groupNameThatCausedError
            };
        case 0, $jcEEo.CREATE_GROUP_WITH_REQUEST_TYPE:
            return {
                ...state,
                isParentRequestGroupsLoading: true
            };
        case 0, $jcEEo.CREATE_GROUP_WITH_REQUEST_TYPE_SUCCEEDED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $jcEEo.CREATE_GROUP_WITH_REQUEST_TYPE_FAILED:
            return {
                ...state,
                isParentRequestGroupsLoading: false
            };
        case 0, $ewU6B.DELETE_REQUEST_TYPE_FROM_GROUP:
            {
                const { requestTypes: requestTypes, index: index } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const udpatedRequestTypeIds = (0, $8sM58.deleteFromList)(requestTypeIds, index);
                return {
                    ...state,
                    requestTypesInRequestGroup: undefined,
                    requestTypesNotInRequestGroup: undefined,
                    requestTypesOrder: udpatedRequestTypeIds
                };
            }
        case 0, $8pWZm.SET_REQUEST_TYPE_GROUPS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    parentRequestGroups: requestGroups
                };
            }
        case 0, $8pWZm.SET_REQUEST_TYPE_GROUPS_FAILED:
            return {
                ...state,
                parentRequestGroups: undefined
            };
        case 0, $hBMej.REORDER_REQUEST_TYPE:
            {
                const { requestTypes: requestTypes, fromIndex: fromIndex, toIndex: toIndex } = action.payload;
                const requestTypeIds = requestTypes.map(({ id: requestTypeId })=>Number(requestTypeId));
                const updatedRequestTypeIds = (0, $8sM58.reorderList)(requestTypeIds, fromIndex, toIndex);
                return {
                    ...state,
                    requestTypesOrder: updatedRequestTypeIds
                };
            }
        case 0, $lXazD.FETCH_PORTAL_SUCCESS:
            return $a16a6e5c04c3c48d$var$getDefaultState();
        case 0, $bBJtE.ADD_REQUEST_TYPE_TO_REQUEST_GROUP:
            {
                const { requestType: requestType, requestTypesNotInRequestGroup: requestTypesNotInRequestGroup, requestTypesInRequestGroup: requestTypesInRequestGroup } = action.payload;
                // Remove request type from requestTypesNotInRequestGroup used for request type search options
                const optimisticRequestTypesNotInRequestGroup = requestTypesNotInRequestGroup.filter((requestTypeNotInRequestGroup)=>requestTypeNotInRequestGroup.id !== requestType.id);
                // Add request type as the last element of requestTypesInRequestGroup used to render request types in group
                const optimisticRequestTypesInRequestGroup = [
                    ...requestTypesInRequestGroup,
                    requestType
                ];
                // This will have the new request type as the last index (the order will then be persisted)
                const requestTypeIds = optimisticRequestTypesInRequestGroup.map(({ id: requestTypeId })=>Number(requestTypeId));
                return {
                    ...state,
                    requestTypesOrder: requestTypeIds,
                    requestTypesInRequestGroup: [
                        ...optimisticRequestTypesInRequestGroup
                    ],
                    requestTypesNotInRequestGroup: [
                        ...optimisticRequestTypesNotInRequestGroup
                    ],
                    error: undefined
                };
            }
        case 0, $bBJtE.ADD_REQUEST_TYPE_TO_REQUEST_GROUP_FAILED:
            return {
                ...state,
                requestTypesOrder: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: action.payload.message
            };
        case 0, $1wRjC.CLEAR_REQUEST_TYPES_ORDER:
            return {
                ...state,
                requestGroups: undefined,
                requestTypesInRequestGroup: undefined,
                requestTypesNotInRequestGroup: undefined,
                error: undefined,
                requestTypesOrder: undefined
            };
        case 0, $1wRjC.CLEAR_ERROR_MESSAGE:
            return {
                ...state,
                error: undefined,
                groupNameThatCausedError: undefined,
                requestTypesOrder: undefined
            };
        // Reset any errors and clear the UI state version of request groups so it can be populated with the newly persisted list as the new source of truth
        case 0, $1wRjC.CLEAR_REQUEST_GROUPS_ORDER:
            return $a16a6e5c04c3c48d$var$getDefaultState();
        // On successful edit clear UI state order, and use the newly persisted request groups state as the source of truth for the request groups list.
        case 0, $5sVYY.GET_ALL_REQUEST_GROUPS_SUCCESS:
            {
                const { requestGroups: requestGroups } = action.payload;
                return {
                    ...state,
                    requestGroups: requestGroups,
                    requestGroupsOrder: undefined
                };
            }
        default:
            return state;
    }
}

});
parcelRegister("gVfYd", function(module, exports) {
$parcel$export(module.exports, "deleteFromList", () => (parcelRequire("8sM58")).deleteFromList);
$parcel$export(module.exports, "reorderList", () => (parcelRequire("8sM58")).reorderList);
parcelRequire("8sM58");

});
parcelRegister("8sM58", function(module, exports) {
$parcel$export(module.exports, "reorderList", () => $c8720575314c9067$export$1c97eb4883130bfd);
$parcel$export(module.exports, "deleteFromList", () => $c8720575314c9067$export$e786ade68cfa1610);
/** Utility functions to assist managing drop events in React Beautiful DnD */ 
var $63sfu = parcelRequire("63sfu");
const $c8720575314c9067$export$1c97eb4883130bfd = (list, fromIndex, toIndex)=>{
    const newList = Array.from(list);
    if (!(0, $63sfu.isNil)(toIndex) && !(0, $63sfu.isNil)(fromIndex)) {
        newList.splice(fromIndex, 1);
        newList.splice(toIndex, 0, list[fromIndex]);
    }
    return newList;
};
const $c8720575314c9067$export$e786ade68cfa1610 = (list, index)=>{
    const newList = Array.from(list);
    if (!(0, $63sfu.isNil)(index)) newList.splice(index, 1);
    return newList;
};

});




parcelRegister("58Zs0", function(module, exports) {
$parcel$export(module.exports, "requestDetailsReducer", () => (parcelRequire("gmqeb")).requestDetailsReducer);
$parcel$export(module.exports, "ApprovalDecision", () => (parcelRequire("gmqeb")).ApprovalDecision);

var $gmqeb = parcelRequire("gmqeb");

});
parcelRegister("gmqeb", function(module, exports) {
$parcel$export(module.exports, "ApprovalDecision", () => $088edcb83f4153ec$export$b84e6e5b33fd1d21);
$parcel$export(module.exports, "requestDetailsReducer", () => $088edcb83f4153ec$export$dfa3e5ac1f5274b8);
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");
var $088edcb83f4153ec$export$b84e6e5b33fd1d21 = /*#__PURE__*/ function(ApprovalDecision) {
    ApprovalDecision[ApprovalDecision["APPROVE"] = 0] = "APPROVE";
    ApprovalDecision[ApprovalDecision["DECLINE"] = 1] = "DECLINE";
    return ApprovalDecision;
}({});
const $088edcb83f4153ec$var$defaultState = {
    commentSubmitting: false,
    commentBeingSubmitted: undefined
};
function $088edcb83f4153ec$export$dfa3e5ac1f5274b8(state = $088edcb83f4153ec$var$defaultState, action) {
    switch(action.type){
        case 0, $gEejF.TRANSITION_REQUEST:
            return $088edcb83f4153ec$var$handleTransition(state, action);
        case 0, $gEejF.TRANSITION_REQUEST_FAILURE:
            return $088edcb83f4153ec$var$handleTransitionFailure(state, action);
        case 0, $gEejF.CLEAR_TRANSITION_REQUEST_FAILURE:
            return $088edcb83f4153ec$var$handleClearTransitionFailure(state);
        case 0, $gEejF.FETCH_REQUEST_DETAILS_SUCCESS:
            return $088edcb83f4153ec$var$defaultState;
        case 0, $gEejF.CREATE_COMMENT:
            return $088edcb83f4153ec$var$handleCommentCreate(state, action);
        case 0, $gEejF.CREATE_COMMENT_SUCCESS:
            return $088edcb83f4153ec$var$handleCommentCreateSuccess(state);
        case 0, $gEejF.CREATE_COMMENT_FAILURE:
            return $088edcb83f4153ec$var$handleCommentCreateFailure(state);
        case 0, $gEejF.SHOW_TRANSITION_DIALOG:
            return $088edcb83f4153ec$var$handleShowTransitionDialog(state, action);
        case 0, $gEejF.HIDE_TRANSITION_DIALOG:
            return $088edcb83f4153ec$var$handleHideTransitionDialog(state);
        case 0, $gEejF.DECIDE_APPROVAL:
            return $088edcb83f4153ec$var$handleDecideApproval(state, action);
        case 0, $gEejF.DECIDE_APPROVAL_FAILURE:
            return $088edcb83f4153ec$var$handleDecideApprovalFailure(state);
        default:
            return state;
    }
}
const $088edcb83f4153ec$var$handleShowTransitionDialog = (state, action)=>({
        ...state,
        visibleTransitionDialog: action.payload.id
    });
const $088edcb83f4153ec$var$handleHideTransitionDialog = (state)=>({
        ...state,
        visibleTransitionDialog: undefined
    });
const $088edcb83f4153ec$var$handleTransition = (state, action)=>({
        ...state,
        inProgressTransitionId: action.payload.transitionId,
        transitionFailure: undefined
    });
function $088edcb83f4153ec$var$handleDecideApproval(state, action) {
    const approvalDecision = action.payload.approve ? 0 : 1;
    return {
        ...state,
        inProgressApprovalAction: approvalDecision
    };
}
const $088edcb83f4153ec$var$handleDecideApprovalFailure = (state)=>({
        ...state,
        inProgressApprovalAction: undefined
    });
const $088edcb83f4153ec$var$handleTransitionFailure = (state, action)=>({
        ...state,
        inProgressTransitionId: undefined,
        transitionFailure: action.payload.error
    });
const $088edcb83f4153ec$var$handleClearTransitionFailure = (state)=>({
        ...state,
        transitionFailure: undefined
    });
const $088edcb83f4153ec$var$handleCommentCreate = (state, action)=>({
        ...state,
        commentSubmitting: true,
        commentBeingSubmitted: action.payload.comment
    });
const $088edcb83f4153ec$var$handleCommentCreateSuccess = (state)=>({
        ...state,
        commentSubmitting: false,
        commentBeingSubmitted: undefined
    });
const $088edcb83f4153ec$var$handleCommentCreateFailure = (state)=>({
        ...state,
        commentSubmitting: false
    });

});


parcelRegister("dOIPO", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => (parcelRequire("ajPNO")).requestListReducer);

var $ajPNO = parcelRequire("ajPNO");

});
parcelRegister("ajPNO", function(module, exports) {
$parcel$export(module.exports, "requestListReducer", () => $4e13cab655fb7827$export$476a1a148617ffd3);
parcelRequire("bxUrV");
var $kH8Rm = parcelRequire("kH8Rm");
const $4e13cab655fb7827$var$defaultState = {
    isLoading: false
};
function $4e13cab655fb7827$export$476a1a148617ffd3(state = $4e13cab655fb7827$var$defaultState, action) {
    switch(action.type){
        case 0, $kH8Rm.FETCH_REQUEST_LIST_MODEL:
            return $4e13cab655fb7827$var$handleFetchRequestListAction(state);
        case 0, $kH8Rm.FETCH_REQUEST_LIST_SUCCESS:
            return $4e13cab655fb7827$var$handleFetchRequestListSuccess(state);
        case 0, $kH8Rm.FETCH_REQUEST_LIST_FAILURE:
            return $4e13cab655fb7827$var$handleFetchRequestListFailure(state);
        default:
            return state;
    }
}
const $4e13cab655fb7827$var$handleFetchRequestListAction = (state)=>({
        ...state,
        isLoading: true
    });
const $4e13cab655fb7827$var$handleFetchRequestListSuccess = (state)=>({
        ...state,
        isLoading: false
    });
const $4e13cab655fb7827$var$handleFetchRequestListFailure = (state)=>({
        ...state,
        isLoading: false
    });

});


parcelRegister("80XtF", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => (parcelRequire("02S0N")).resendVerifyReducer);

var $02S0N = parcelRequire("02S0N");

});
parcelRegister("02S0N", function(module, exports) {
$parcel$export(module.exports, "resendVerifyReducer", () => $8ad2a7d6af41f249$export$92942a05b04ae72);
parcelRequire("268JS");
var $dCep4 = parcelRequire("dCep4");

var $jCZs9 = parcelRequire("jCZs9");
const $8ad2a7d6af41f249$export$49d5fc8cba920a0 = {
    value: (0, $jCZs9.ResendStatus).NONE
};
function $8ad2a7d6af41f249$export$92942a05b04ae72(state = $8ad2a7d6af41f249$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $dCep4.FETCH_RESEND_VERIFY_EMAIL:
            return {
                value: (0, $jCZs9.ResendStatus).RESENDING
            };
        case 0, $dCep4.FETCH_RESEND_VERIFICATION_SUCCESS:
            return {
                value: (0, $jCZs9.ResendStatus).SUCCEEDED
            };
        case 0, $dCep4.FETCH_RESEND_VERIFICATION_FAILURE:
            return {
                errorStatus: action.payload.error,
                value: (0, $jCZs9.ResendStatus).FAILED
            };
        default:
            return state;
    }
}

});
parcelRegister("jCZs9", function(module, exports) {
$parcel$export(module.exports, "ResendStatus", () => $d95cd18428548b24$export$167f7de0a3de3f78);
const $d95cd18428548b24$export$167f7de0a3de3f78 = {
    NONE: 'NONE',
    RESENDING: 'RESENDING',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED'
};

});



parcelRegister("e3i7U", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => (parcelRequire("aLZCw")).resetPasswordReducer);

var $aLZCw = parcelRequire("aLZCw");

});
parcelRegister("aLZCw", function(module, exports) {
$parcel$export(module.exports, "resetPasswordReducer", () => $eca3b4ccb14a362b$export$b0c3be5071e95c02);
parcelRequire("4Sj1L");
var $gByNL = parcelRequire("gByNL");
const $eca3b4ccb14a362b$var$defaultState = {
    isSubmitting: false
};
function $eca3b4ccb14a362b$export$b0c3be5071e95c02(state = $eca3b4ccb14a362b$var$defaultState, action) {
    switch(action.type){
        case 0, $gByNL.RESET_PASSWORD:
            return $eca3b4ccb14a362b$var$handleResetPassword(state);
        case 0, $gByNL.RESET_PASSWORD_FAILURE:
            return $eca3b4ccb14a362b$var$handleResetPasswordFailure(state, action);
        default:
            return state;
    }
}
const $eca3b4ccb14a362b$var$handleResetPassword = (state)=>({
        ...state,
        isSubmitting: true,
        error: undefined
    });
const $eca3b4ccb14a362b$var$handleResetPasswordFailure = (state, action)=>({
        ...state,
        isSubmitting: false,
        error: action.payload.error
    });

});


parcelRegister("baX0y", function(module, exports) {
$parcel$export(module.exports, "searchReducer", () => (parcelRequire("kd8ge")).default);

var $kd8ge = parcelRequire("kd8ge");

});
parcelRegister("kd8ge", function(module, exports) {
$parcel$export(module.exports, "default", () => $98dbfa74e0f6a643$export$2e2bcd8739ae039);
parcelRequire("dMwUq");
var $gi2k1 = parcelRequire("gi2k1");

var $3wR8f = parcelRequire("3wR8f");

var $PL4bf = parcelRequire("PL4bf");
const $98dbfa74e0f6a643$var$generateDefaultSearchResults = ()=>{
    return {
        portals: [],
        requestTypes: [],
        knowledgeBase: {
            articles: [],
            totalSize: 0
        }
    };
};
const $98dbfa74e0f6a643$var$generateDefaultState = ()=>{
    const strings = $PL4bf.getAll();
    if (strings && strings.q !== undefined) return {
        shown: true,
        term: strings.q,
        time: strings.q_time ? +strings.q_time : undefined,
        hasError: false,
        isSearching: true,
        results: $98dbfa74e0f6a643$var$generateDefaultSearchResults(),
        isSearchingPortals: true,
        isSearchingKb: true,
        isSearchingRequestTypes: true
    };
    return {
        shown: false,
        term: '',
        portalIds: [],
        time: undefined,
        hasError: false,
        isSearching: false,
        results: $98dbfa74e0f6a643$var$generateDefaultSearchResults()
    };
};
const $98dbfa74e0f6a643$var$portalResponseToState = (portal)=>({
        id: portal.id,
        name: portal.name,
        iconUrl: portal.logoUrl
    });
const $98dbfa74e0f6a643$var$requestTypesResponseToState = (requestType)=>({
        id: requestType.id,
        portalId: requestType.cvId,
        name: requestType.name,
        portalName: requestType.portalName,
        iconUrl: requestType.iconUrl || `${0, $3wR8f.contextPath}/servicedesk/customershim/secure/viewavatar?avatarType=SD_REQTYPE&avatarId=${requestType.icon}`,
        searchMetaData: requestType.searchMetaData
    });
function $98dbfa74e0f6a643$export$2e2bcd8739ae039(state = $98dbfa74e0f6a643$var$generateDefaultState(), action) {
    switch(action.type){
        case 0, $gi2k1.SHOW_SEARCH:
            return {
                ...state,
                shown: action.payload.show,
                searchStartTime: undefined
            };
        case 0, $gi2k1.RESET_SEARCH:
            return {
                shown: false,
                term: '',
                time: undefined,
                hasError: false,
                isSearching: false,
                results: $98dbfa74e0f6a643$var$generateDefaultSearchResults()
            };
        case 0, $gi2k1.SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined,
                isSearchingPortals: true,
                isSearchingKb: true,
                isSearchingRequestTypes: true
            };
        case 0, $gi2k1.FETCH_KB_SEARCH_RESULTS:
            return {
                ...state,
                isSearchingKb: true
            };
        case 0, $gi2k1.UPDATE_SEARCH_RESULTS:
            {
                const result = action.payload;
                const newResultState = {
                    portals: result.portals ? result.portals.map($98dbfa74e0f6a643$var$portalResponseToState) : [],
                    requestTypes: result.requestTypes ? result.requestTypes.map($98dbfa74e0f6a643$var$requestTypesResponseToState) : [],
                    knowledgeBase: $98dbfa74e0f6a643$var$mapKnowledgeBaseResponseToState(result)
                };
                return {
                    ...state,
                    results: newResultState,
                    isSearching: false
                };
            }
        case 0, $gi2k1.UPDATE_SEARCH_RESULTS_BY_TYPE:
            {
                var _newResultState;
                const { searchType: searchType, payload: result } = action;
                let newResultState;
                if (searchType === 'portals') newResultState = {
                    results: {
                        ...state.results,
                        portals: result.portals ? result.portals.map($98dbfa74e0f6a643$var$portalResponseToState) : []
                    },
                    isSearchingPortals: false
                };
                if (searchType === 'requestTypes') newResultState = {
                    results: {
                        ...state.results,
                        requestTypes: result.requestTypes ? result.requestTypes.map($98dbfa74e0f6a643$var$requestTypesResponseToState) : []
                    },
                    isSearchingRequestTypes: false
                };
                if (searchType === 'kbs') newResultState = {
                    results: {
                        ...state.results,
                        knowledgeBase: $98dbfa74e0f6a643$var$mapKnowledgeBaseResponseToState(result)
                    },
                    isSearchingKb: false
                };
                return {
                    ...state,
                    ...newResultState ?? {},
                    isSearching: ((_newResultState = newResultState) === null || _newResultState === void 0 ? void 0 : _newResultState.isSearchingKb) === false ? false : state.isSearching
                };
            }
        case 0, $gi2k1.CLEAR_SEARCH_RESULTS:
            return {
                ...state,
                isSearching: false,
                results: $98dbfa74e0f6a643$var$generateDefaultSearchResults(),
                searchStartTime: undefined
            };
        case 0, $gi2k1.FETCH_SEARCH_RESULTS:
            return {
                ...state,
                searchStartTime: action.payload.searchStartTime
            };
        case 0, $gi2k1.UPDATE_SEARCH:
            return {
                ...state,
                ...action.payload,
                isSearching: true,
                shown: action.payload.show,
                time: action.payload.term ? action.payload.time : undefined
            };
        default:
            return state;
    }
}
const $98dbfa74e0f6a643$var$mapKnowledgeBaseResponseToState = (result)=>{
    return result.kbs ? result.kbs : {
        articles: [],
        totalSize: 0
    };
};

});


parcelRegister("bMqMr", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => (parcelRequire("fpORt")).checkEmailUiReducer);

var $fpORt = parcelRequire("fpORt");

});
parcelRegister("fpORt", function(module, exports) {
$parcel$export(module.exports, "checkEmailUiReducer", () => $4a2564968c601f57$export$a518ffb70e2a23c8);
parcelRequire("3kjQH");
var $jrtA6 = parcelRequire("jrtA6");
const $4a2564968c601f57$export$49d5fc8cba920a0 = {
    isSubmitting: false,
    resendValidationLinkDisabled: false
};
function $4a2564968c601f57$export$a518ffb70e2a23c8(state = $4a2564968c601f57$export$49d5fc8cba920a0, action) {
    switch(action.type){
        case 0, $jrtA6.ENABLE_RESEND_VALIDATION_EMAIL_LINK:
            return $4a2564968c601f57$var$handleEnableResendValidationLink(state);
        case 0, $jrtA6.RESEND_VALIDATION_EMAIL:
            return $4a2564968c601f57$var$handleResendValidationEmail(state);
        case 0, $jrtA6.RESEND_VALIDATION_EMAIL_SUCCESS:
            return $4a2564968c601f57$var$handleResendValidationEmailSuccess(state);
        case 0, $jrtA6.RESEND_VALIDATION_EMAIL_FAILURE:
            return $4a2564968c601f57$var$handleResendValidationEmailFailure(state);
        default:
            return state;
    }
}
const $4a2564968c601f57$var$handleEnableResendValidationLink = (state)=>({
        ...state,
        resendValidationLinkDisabled: false
    });
const $4a2564968c601f57$var$handleResendValidationEmail = (state)=>({
        ...state,
        isSubmitting: true,
        resendValidationLinkDisabled: true
    });
const $4a2564968c601f57$var$handleResendValidationEmailSuccess = (state)=>({
        ...state,
        isSubmitting: false
    });
const $4a2564968c601f57$var$handleResendValidationEmailFailure = (state)=>({
        ...state,
        isSubmitting: false
    });

});


parcelRegister("7CHu4", function(module, exports) {
$parcel$export(module.exports, "topicsReducer", () => (parcelRequire("cUws4")).default);

var $cUws4 = parcelRequire("cUws4");

});
parcelRegister("cUws4", function(module, exports) {
$parcel$export(module.exports, "default", () => $94d1ac2a8fa81d47$export$2e2bcd8739ae039);
parcelRequire("htoYX");
var $eoPTj = parcelRequire("eoPTj");
const $94d1ac2a8fa81d47$export$b81eca7e0c669bb0 = {
    fetchKey: 0
};
function $94d1ac2a8fa81d47$export$2e2bcd8739ae039(state = $94d1ac2a8fa81d47$export$b81eca7e0c669bb0, action) {
    if (action.type === (0, $eoPTj.UPDATE_TOPICS_FETCH_KEY)) return {
        ...state,
        fetchKey: state.fetchKey + 1
    };
    return state;
}

});
parcelRegister("htoYX", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => (parcelRequire("eoPTj")).UPDATE_TOPICS_FETCH_KEY);

var $eoPTj = parcelRequire("eoPTj");

});
parcelRegister("eoPTj", function(module, exports) {
$parcel$export(module.exports, "UPDATE_TOPICS_FETCH_KEY", () => $8d759b2e6ff88df4$export$9b3f2f1c719b0f8e);
const $8d759b2e6ff88df4$export$9b3f2f1c719b0f8e = 'state.ui.topics.UPDATE_TOPICS_FETCH_KEY';
const $8d759b2e6ff88df4$export$ff571764686d6022 = ()=>({
        type: $8d759b2e6ff88df4$export$9b3f2f1c719b0f8e
    });

});




parcelRegister("6eJAW", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => (parcelRequire("j3Gfu")).userProfileReducer);

var $j3Gfu = parcelRequire("j3Gfu");

});
parcelRegister("j3Gfu", function(module, exports) {
$parcel$export(module.exports, "userProfileReducer", () => $f257c4d626e8846d$export$6a0a871f19e6c5f6);
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");
const $f257c4d626e8846d$var$defaultState = {
    saveInProgress: false,
    changePasswordInProgress: false,
    showChangePasswordDialog: false,
    changePasswordErrors: {},
    saveUserProfileErrors: {},
    sendForgotPasswordEmailInProgress: false
};
function $f257c4d626e8846d$export$6a0a871f19e6c5f6(state = $f257c4d626e8846d$var$defaultState, action) {
    switch(action.type){
        case 0, $3R99L.SAVE_USER_PROFILE:
            return $f257c4d626e8846d$var$handleSaveUserProfile(state);
        case 0, $3R99L.SAVE_USER_PROFILE_FAILURE:
            return $f257c4d626e8846d$var$handleSaveUserProfileFailure(state);
        case 0, $3R99L.SET_USER_PROFILE_VALIDATION_ERRORS:
            return $f257c4d626e8846d$var$handleSetUserProfileValidationErrors(state, action);
        case 0, $3R99L.SAVE_USER_PROFILE_SUCCESS:
            return $f257c4d626e8846d$var$handleSaveUserProfileSuccess(state);
        case 0, $3R99L.SHOW_CHANGE_PASSWORD_DIALOG:
            return $f257c4d626e8846d$var$handleShowChangePasswordDialog(state);
        case 0, $3R99L.CLOSE_CHANGE_PASSWORD_DIALOG:
            return $f257c4d626e8846d$var$handleCloseChangePasswordDialog(state);
        case 0, $3R99L.CHANGE_PASSWORD:
            return $f257c4d626e8846d$var$handleChangePassword(state);
        case 0, $3R99L.CHANGE_PASSWORD_SUCCESS:
            return $f257c4d626e8846d$var$handleChangePasswordSuccess(state);
        case 0, $3R99L.CHANGE_PASSWORD_FAILURE:
            return $f257c4d626e8846d$var$handleChangePasswordFailure(state, action);
        case 0, $3R99L.VALIDATE_PASSWORD_SUCCESS:
            return $f257c4d626e8846d$var$handleValidatePasswordSuccess(state);
        case 0, $3R99L.USER_PROFILE_FORGOT_PASSWORD:
            return $f257c4d626e8846d$var$handleForgotPassword(state);
        case 0, $3R99L.USER_PROFILE_FORGOT_PASSWORD_FAILURE:
            return $f257c4d626e8846d$var$handleForgotPasswordFailure(state);
        case 0, $3R99L.USER_PROFILE_FORGOT_PASSWORD_SUCCESS:
            return $f257c4d626e8846d$var$handleForgotPasswordSuccess(state);
        default:
            return state;
    }
}
const $f257c4d626e8846d$var$handleSaveUserProfile = (state)=>({
        ...state,
        saveInProgress: true
    });
const $f257c4d626e8846d$var$handleSaveUserProfileFailure = (state)=>({
        ...state,
        saveInProgress: false
    });
function $f257c4d626e8846d$var$handleSetUserProfileValidationErrors(state, action) {
    const { nameError: nameError, timezoneError: timezoneError } = action.payload;
    return {
        ...state,
        saveUserProfileErrors: {
            nameError: nameError,
            timezoneError: timezoneError
        }
    };
}
const $f257c4d626e8846d$var$handleSaveUserProfileSuccess = (state)=>({
        ...state,
        saveInProgress: false
    });
const $f257c4d626e8846d$var$handleShowChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: true
    });
const $f257c4d626e8846d$var$handleCloseChangePasswordDialog = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordErrors: {}
    });
const $f257c4d626e8846d$var$handleValidatePasswordSuccess = (state)=>({
        ...state,
        changePasswordErrors: {}
    });
const $f257c4d626e8846d$var$handleChangePassword = (state)=>({
        ...state,
        changePasswordInProgress: true,
        changePasswordErrors: {}
    });
const $f257c4d626e8846d$var$handleChangePasswordSuccess = (state)=>({
        ...state,
        showChangePasswordDialog: false,
        changePasswordInProgress: false,
        changePasswordErrors: {}
    });
const $f257c4d626e8846d$var$handleChangePasswordFailure = (state, action)=>({
        ...state,
        changePasswordInProgress: false,
        changePasswordErrors: {
            currentPasswordError: action.payload.currentPasswordError,
            newPasswordError: action.payload.newPasswordError,
            confirmPasswordError: action.payload.confirmPasswordError,
            generalError: action.payload.generalError
        }
    });
const $f257c4d626e8846d$var$handleForgotPassword = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: true,
        showChangePasswordDialog: true
    });
const $f257c4d626e8846d$var$handleForgotPasswordFailure = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: true
    });
const $f257c4d626e8846d$var$handleForgotPasswordSuccess = (state)=>({
        ...state,
        sendForgotPasswordEmailInProgress: false,
        showChangePasswordDialog: false
    });

});





parcelRegister("cdm1b", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerTypeProvider", () => $34e079a0fec5a31a$export$e70650df369196ac);

var $4fqPo = parcelRequire("4fqPo");

var $6V1HD = parcelRequire("6V1HD");

var $gI5jE = parcelRequire("gI5jE");

var $54jwS = parcelRequire("54jwS");
const $34e079a0fec5a31a$export$e70650df369196ac = ({ children: children })=>{
    const [helpSeekerTypeAttributes, setHelpSeekerTypeAttributes] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState({
        isUserDomainSameAsAdmin: (0, $6V1HD.helpSeekerTypeAttributeValue).UNIDENTIFIED,
        isUserDomainInApprovedDomains: (0, $6V1HD.helpSeekerTypeAttributeValue).UNIDENTIFIED
    });
    const config = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext((0, $gI5jE.AtlassianHelpConfigContext));
    const constructHelpSeekerTypeResponse = (isUserDomainSameAsAdmin, isUserDomainInApprovedDomains, isUserLoggedIn)=>({
            isUserDomainSameAsAdmin: isUserDomainSameAsAdmin,
            isUserDomainInApprovedDomains: isUserDomainInApprovedDomains,
            isUserLoggedIn: isUserLoggedIn
        });
    const evaluateHelpSeekerTypeAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        if (config.accountType === 'customer') (0, $6V1HD.getHelpSeekerTypeAttributes)().subscribe((response)=>{
            setHelpSeekerTypeAttributes({
                ...response,
                isUserLoggedIn: true
            });
        });
        else if (config.accountType === 'atlassian') setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $6V1HD.helpSeekerTypeAttributeValue).YES, (0, $6V1HD.helpSeekerTypeAttributeValue).YES, true));
        else setHelpSeekerTypeAttributes(constructHelpSeekerTypeResponse((0, $6V1HD.helpSeekerTypeAttributeValue).NO, (0, $6V1HD.helpSeekerTypeAttributeValue).NO, false));
    }, [
        config
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        evaluateHelpSeekerTypeAttributes();
    }, [
        evaluateHelpSeekerTypeAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $54jwS.AnalyticsContext), {
        attributes: helpSeekerTypeAttributes
    }, children);
};

});
parcelRegister("6V1HD", function(module, exports) {
$parcel$export(module.exports, "helpSeekerTypeAttributeValue", () => $06ec74bd4233d970$export$5f93b09705cc6a59);
$parcel$export(module.exports, "getHelpSeekerTypeAttributes", () => $06ec74bd4233d970$export$ea5de7279b843e51);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");

var $jhBPy = parcelRequire("jhBPy");
const $06ec74bd4233d970$export$5f93b09705cc6a59 = Object.freeze({
    YES: 'Yes',
    NO: 'No',
    UNIDENTIFIED: 'Unidentified'
});
const $06ec74bd4233d970$export$ea5de7279b843e51 = (basePath = (0, $3wR8f.contextPath))=>{
    const uri = `${basePath}/rest/servicedesk/1/customer/analytics/help-seeker/type`;
    const localStorageHelpSeekerTypeResponse = (0, $jhBPy.getLocalStorageItem)('help-seeker-type');
    if (localStorageHelpSeekerTypeResponse) // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $b0T1M.Observable).of(JSON.parse(localStorageHelpSeekerTypeResponse));
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.get)(uri, {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>{
        (0, $jhBPy.setLocalStorageItem)('help-seeker-type', JSON.stringify(response));
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return response;
    }).catch(()=>{
        return (0, $b0T1M.Observable).of({
            isUserDomainSameAsAdmin: $06ec74bd4233d970$export$5f93b09705cc6a59.UNIDENTIFIED,
            isUserDomainInApprovedDomains: $06ec74bd4233d970$export$5f93b09705cc6a59.UNIDENTIFIED
        });
    });
};

});

parcelRegister("gI5jE", function(module, exports) {
$parcel$export(module.exports, "AtlassianHelpConfigContext", () => $b6589281900932a5$export$15b13d6286254aba);
$parcel$export(module.exports, "default", () => $b6589281900932a5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");
const $b6589281900932a5$export$eec32b9030a890bc = (config)=>({
        accountId: config.accountId,
        accountType: config.accountType,
        userLocale: config.userLocale,
        sdPluginVersion: config.sdPluginVersion || '',
        contextPath: config.contextPath,
        environment: config.environment,
        tenantId: config.tenantId,
        activationId: config.activationId,
        helpCenterARI: config.helpCenterARI
    });
const $b6589281900932a5$export$b5f4a66c86673938 = (config)=>({
        environment: config.environment,
        featureFlags: config.featureFlags || {},
        wacLink: config.wacLink,
        contactLink: config.contactLink,
        headless: config.headless || false,
        serviceDeskVersion: config.serviceDeskVersion || '',
        contextPath: config.contextPath,
        xsrfToken: config.xsrfToken || '',
        baseUrl: config.baseUrl,
        relativeBaseUrl: config.relativeBaseUrl,
        anonymousEnabled: config.anonymousEnabled || false,
        requestIntroEnabled: config.requestIntroEnabled || false,
        mediaApiExternalUrl: config.mediaApiExternalUrl || '',
        mediaApiAppClientId: config.mediaApiAppClientId || '',
        fabricEmojiUrl: config.fabricEmojiUrl || '',
        jiraDisplayUrl: config.jiraDisplayUrl,
        featuredValues: config.featuredValues || {},
        siteDefaultLanguageTag: config.siteDefaultLanguageTag || 'en-US',
        helpCenterType: config.helpCenterType || (0, $748yq.DEFAULT_HELP_CENTER_TYPE),
        hoistedProjectKey: config.hoistedProjectKey || undefined,
        helpCenterHomePageSlug: config.helpCenterHomePageSlug || '',
        customerAccountAvailabilty: config.customerAccountAvailabilty || (0, $748yq.DEFAULT_CUSTOMER_ACCOUNT_AVAILABILITY)
    });
const $b6589281900932a5$export$15b13d6286254aba = /*#__PURE__*/ $4fqPo.createContext({});
// TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
// oxlint-disable-next-line no-shadow
const $b6589281900932a5$var$MetaDataProvider = ({ children: children, config: config, updateEnvAction: updateEnvAction, updateMetaAction: updateMetaAction })=>{
    // We can add React context here in the future once relay is introduced and get rid of reducers altogether
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // oxlint-disable-next-line no-shadow
    const Env = $b6589281900932a5$export$b5f4a66c86673938(config);
    const Meta = $b6589281900932a5$export$eec32b9030a890bc(config);
    $4fqPo.useMemo(()=>{
        updateMetaAction(Meta);
        updateEnvAction(Env);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        Env,
        Meta
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($b6589281900932a5$export$15b13d6286254aba.Provider, {
        value: config
    }, children);
};
var $b6589281900932a5$export$2e2bcd8739ae039 = $b6589281900932a5$var$MetaDataProvider;

});


parcelRegister("3RD2P", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => (parcelRequire("lde7Z")).EngagementProviderWrapper);

var $lde7Z = parcelRequire("lde7Z");

});
parcelRegister("lde7Z", function(module, exports) {
$parcel$export(module.exports, "EngagementProviderWrapper", () => $3aa0f70e3c49f1a1$export$a055f8fe7b78f866);

var $4fqPo = parcelRequire("4fqPo");

var $fgeTe = parcelRequire("fgeTe");
var $laViG = parcelRequire("laViG");

var $gMSZD = parcelRequire("gMSZD");

var $fVwZr = parcelRequire("fVwZr");
const $3aa0f70e3c49f1a1$export$a055f8fe7b78f866 = ({ config: config, analyticsClientInstance: analyticsClientInstance, children: children })=>{
    const epConfig = {
        environment: config.environment,
        cloudId: config.tenantId,
        aaid: config.accountId,
        locale: config.userLocale,
        product: 'jira',
        subProduct: 'serviceDesk',
        stargateUrl: '/gateway/api'
    };
    const renderOnError = (0, $4fqPo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        id: 'engagement-provider-error',
        renderError: renderOnError,
        onError: (0, $fVwZr.reportError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $laViG.default), {
        config: epConfig,
        analyticsClientInstance: analyticsClientInstance,
        coordinationOptions: {
            enableChoreographer: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fgeTe.EngagementMessages), null), children)));
};

});
parcelRegister("fgeTe", function(module, exports) {
$parcel$export(module.exports, "EngagementMessages", () => $dc02618290636d3f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6VS7r = parcelRequire("6VS7r");

var $ifvSJ = parcelRequire("ifvSJ");

var $hXGgU = parcelRequire("hXGgU");
class $dc02618290636d3f$export$2e2bcd8739ae039 extends (0, $4fqPo.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hXGgU.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ifvSJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6VS7r.default), null));
    }
}

});
parcelRegister("6VS7r", function(module, exports) {
$parcel$export(module.exports, "ContextualSurveyWithEvents", () => $58689fd8d50f6a73$export$42b694a35bb75eda);
$parcel$export(module.exports, "default", () => $58689fd8d50f6a73$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ContextualSurvey", () => (parcelRequire("1cggT")).default);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ // eslint-disable-next-line import/order

var $jDrsU = parcelRequire("jDrsU");

var $bFWWU = parcelRequire("bFWWU");

var $1cggT = parcelRequire("1cggT");
const $58689fd8d50f6a73$export$42b694a35bb75eda = (0, $jDrsU.default)((0, $1cggT.default));
// eslint-disable-next-line camelcase
const $58689fd8d50f6a73$var$_default_1 = (0, $bFWWU.default)($58689fd8d50f6a73$export$42b694a35bb75eda, 'contextualSurvey');
var // eslint-disable-next-line camelcase
$58689fd8d50f6a73$export$2e2bcd8739ae039 = $58689fd8d50f6a73$var$_default_1;

});
parcelRegister("jDrsU", function(module, exports) {
$parcel$export(module.exports, "default", () => $bda6f7ce1212f7d4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");
var $bda6f7ce1212f7d4$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $4fqPo.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args), this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $as4kh.default)()(EngagementEventsWrapper);
};

});

parcelRegister("bFWWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $c235e60648212d4f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");
var $c235e60648212d4f$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $4fqPo.Component) {
        static #_ = this.contextTypes = {
            subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
            setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
        };
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
    }
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $4fqPo.useState)(null);
        const unsubscribeRef = (0, $4fqPo.useRef)(null);
        const removeConfigRef = (0, $4fqPo.useRef)(null);
        const canSubscribe = (0, $4fqPo.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.subscribeEngagementState);
        }, [
            context
        ]);
        const canSetConfig = (0, $4fqPo.useCallback)(()=>{
            return context && !!(context !== null && context !== void 0 && context.setComponentConfig);
        }, [
            context
        ]);
        const onStoreChange = (0, $4fqPo.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $4fqPo.useCallback)(()=>{
            var _context$subscribeEng;
            return context === null || context === void 0 || (_context$subscribeEng = context.subscribeEngagementState) === null || _context$subscribeEng === void 0 ? void 0 : _context$subscribeEng.call(context, onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $4fqPo.useCallback)((propsToUse = props)=>{
            var _context$setComponent;
            return context === null || context === void 0 || (_context$setComponent = context.setComponentConfig) === null || _context$setComponent === void 0 ? void 0 : _context$setComponent.call(context, getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $4fqPo.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $4fqPo.useRef)(engagementId);
        const previousMessageType = (0, $4fqPo.useRef)(messageType);
        const previousOnMessageDisposition = (0, $4fqPo.useRef)(onMessageDisposition);
        (0, $4fqPo.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("1cggT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd15a722aeb3c4c8$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $4fqPo = parcelRequire("4fqPo");

var $joyoW = parcelRequire("joyoW");

var $3WqgR = parcelRequire("3WqgR");

var $17kdz = parcelRequire("17kdz");

var $cd9H4 = parcelRequire("cd9H4");
function $fd15a722aeb3c4c8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $joyoW.default), {
        shouldShow: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cd9H4.default), {
            markAsSeenAndFatigued: (0, $3WqgR.markAsSeenAndFatigued),
            sendUserResponse: (0, $3WqgR.sendUserResponse),
            getFlag: (0, $17kdz.getFlag),
            setFlag: (0, $17kdz.setFlag),
            ...props
        }));
}

});
parcelRegister("joyoW", function(module, exports) {
$parcel$export(module.exports, "default", () => $15cabe59834a4445$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $eO5yD = parcelRequire("eO5yD");

var $gOmDd = parcelRequire("gOmDd");
// 8px is the base unit in pixels
const $15cabe59834a4445$var$surveyOffset = "var(--ds-space-600, 48px)";
const $15cabe59834a4445$var$marshalLayoutStyles = null;
const $15cabe59834a4445$var$marshalMotionLayerStyles = null;
function $15cabe59834a4445$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $eO5yD.default), {
        appear: true,
        children: shouldShow && /*#__PURE__*/ (0, $lhXNe.jsx)((0, $gOmDd.default), {
            enterFrom: "right",
            fade: "inout",
            duration: "medium",
            children: (motionProps)=>/*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                    ref: motionProps.ref,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- motion keyframes
                    className: (0, $ltgDR.default)([
                        "_kqsw1n9t _1xi2oahv _94n5oahv",
                        "_1pbyni7l",
                        motionProps.className
                    ]),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- motion animation styles
                    style: motionProps.style,
                    children: children()
                })
        }, "contextual-survey-marshal")
    });
}

});

parcelRegister("3WqgR", function(module, exports) {
$parcel$export(module.exports, "getMessages", () => $bd78a5393641b6b2$export$8c20ab16ac9cf14f);
$parcel$export(module.exports, "startMessage", () => $bd78a5393641b6b2$export$7a77c9a7b182680b);
$parcel$export(module.exports, "stopMessage", () => $bd78a5393641b6b2$export$159ff839f1f095d2);
$parcel$export(module.exports, "sendUserResponse", () => $bd78a5393641b6b2$export$e1fd1449cf83c1f5);
$parcel$export(module.exports, "markAsSeenAndFatigued", () => $bd78a5393641b6b2$export$3683393f780c6905);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ 
var $fDj9Q = parcelRequire("fDj9Q");
const $bd78a5393641b6b2$export$f4d1b02d312560f5 = '2';
async function $bd78a5393641b6b2$export$8c20ab16ac9cf14f(_cloudId, _stargateUrl, _product, _locale) {
    return {
        messages: [],
        interval: 0
    };
}
var $bd78a5393641b6b2$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
// Initialize the choreographer plugin on module load
// const choreographerPlugin = new EngagekitChoreographerPlugin();
let $bd78a5393641b6b2$var$choreographerPlugin;
async function $bd78a5393641b6b2$export$7a77c9a7b182680b(startMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $bd78a5393641b6b2$var$startMessageWithChoreographer(startMessageConfig, options);
    return $bd78a5393641b6b2$var$startMessageWithCoordination(startMessageConfig);
}
async function $bd78a5393641b6b2$export$159ff839f1f095d2(stopMessageConfig, options) {
    if (options !== null && options !== void 0 && options.enableChoreographer) return $bd78a5393641b6b2$var$stopMessageWithChoreographer(stopMessageConfig, options);
    return $bd78a5393641b6b2$var$stopMessageWithCoordination(stopMessageConfig);
}
async function $bd78a5393641b6b2$var$startMessageWithChoreographer(startMessageConfig, options) {
    if (!$bd78a5393641b6b2$var$choreographerPlugin) $bd78a5393641b6b2$var$choreographerPlugin = new (0, $fDj9Q.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $bd78a5393641b6b2$var$choreographerPlugin.startMessageWithPlugin(startMessageConfig.messageId, ()=>$bd78a5393641b6b2$var$startMessageWithCoordination(startMessageConfig, true), options.additionalData);
}
async function $bd78a5393641b6b2$var$stopMessageWithChoreographer(stopMessageConfig, options) {
    if (!$bd78a5393641b6b2$var$choreographerPlugin) $bd78a5393641b6b2$var$choreographerPlugin = new (0, $fDj9Q.EngagekitChoreographerPlugin)(options.envType ?? "local");
    return $bd78a5393641b6b2$var$choreographerPlugin.stopMessageWithPlugin(stopMessageConfig.messageId, ()=>$bd78a5393641b6b2$var$stopMessageWithCoordination(stopMessageConfig, true), options.additionalData);
}
async function $bd78a5393641b6b2$var$startMessageWithCoordination(_startMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $bd78a5393641b6b2$var$stopMessageWithCoordination(_stopMessageConfig, _choreographerEnabled = false) {
    return false;
}
async function $bd78a5393641b6b2$export$e1fd1449cf83c1f5(_cloudId, _stargateUrl, _messageId, _payload) {
    return Promise.resolve();
}
async function $bd78a5393641b6b2$export$3683393f780c6905(_seenMessageConfig) {
    return Promise.resolve();
}

});
parcelRegister("fDj9Q", function(module, exports) {
$parcel$export(module.exports, "EngagekitChoreographerPlugin", () => $72640e8aa07bdd92$export$da23bd36e2d631b);

var $4C4oc = parcelRequire("4C4oc");

var $5S02O = parcelRequire("5S02O");

var $d9E4D = parcelRequire("d9E4D");

var $2TqKe = parcelRequire("2TqKe");

var $60JH1 = parcelRequire("60JH1");
const $72640e8aa07bdd92$export$63ce1a41d951945d = 300000; // 5m timeout for duplicate request attempts
class $72640e8aa07bdd92$export$da23bd36e2d631b extends (0, $60JH1.ChoreographerPlugin) {
    constructor(env, metaMetricsData = {}){
        super((0, $5S02O.ProductIds).ENGAGEKIT, env, metaMetricsData);
    }
    /**
   * Informs the Logger utility class to *NOT* log the provided event if it contains a blockedByProductId
   * attribute of the Engagekit product. EP is _super_ noisy when it comes to logging, and we get no value
   * out of the events it logs for its own message starts that are blocked, by any messages. The reason is
   * that EP tries to start all of its messages all of the time, and lets the gateway determine whether to
   * actually display the message. Roughly 99.9% of messages fail to start for reasons of prior exposure,
   * the user being in the holdout group, or any number of other reasons, so we're logging roughly 1000x what
   * we get any value out of. This filter will now prevent all of those extra, more useless logs, from being
   * actually fired off, and will keep just the log entries from which we can derive some actual value.
   *
   * @param event OperationalEventPayload
   * @returns boolean
   */ shouldLogEvent(event) {
        return event.actionSubject !== (0, $5S02O.MessageAction).START || event.action !== (0, $5S02O.MessageDeliveryStatus).BLOCKED;
    }
    isValidDuplicateStartRequest(messageId) {
        const currentMessage = (0, $4C4oc.Choreographer).getInstance().getCurrentMessage() ?? (0, $4C4oc.Choreographer).getInstance().getCurrentPendingMessage();
        return Boolean(currentMessage && currentMessage.productId === this.state.productId && currentMessage.messageId === messageId && Date.now() - currentMessage.timestamp < $72640e8aa07bdd92$export$63ce1a41d951945d);
    }
    async startMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $d9E4D.DebugLogger)(this.state.productId, messageId);
        const actionSubject = (0, $5S02O.MessageAction).START;
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::startMessageWithPlugin`
        });
        /**
     * The Choreographer sets a 5m TTL for any message that opens, before forcefully closing it.
     * EP also allows a messageId to re-request its start if it hasn't yet been dismissed (this is a
     * feature of HISI. For this reason, we can mimic that functionality here (otherwise, Choreographer
     * will block the subsequest start request attempt altogether), by checking the Choreographer's
     * currentMessage against our productId/messageId combo here. If this *is* the currentMessage being
     * displayed, it means it hasn't been dismissed, and we let the request dispatch for EP to make the call.
     */ const isValidDuplicateStartRequest = this.isValidDuplicateStartRequest(messageId);
        if (isValidDuplicateStartRequest) {
            const logger = new (0, $2TqKe.Logger)(actionSubject, messageId, {
                ...this.state.metaMetricsData,
                ...additionalData
            }, this.analyticsClient);
            const didStart = Boolean(await callback());
            if (didStart) {
                logger.started();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        plugin: this.constructor.name,
                        disposition: (0, $5S02O.MessageDeliveryStatus).STARTED,
                        timestamp: performance.now()
                    }
                });
            }
            return didStart;
        }
        // Do a just-in-time message start subscription with our callback to stargate
        this.onStart(messageId, callback);
        /**
     * Dispatch the request to start the message, and return the response, which will
     * either be 'started' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.startMessage(messageId, additionalData);
        return result === (0, $5S02O.MessageDeliveryStatus).STARTED;
    }
    async stopMessageWithPlugin(messageId, callback, additionalData = {}) {
        const debugLogger = new (0, $d9E4D.DebugLogger)(this.state.productId, messageId);
        debugLogger.trace({
            verbose: `EngagekitChoreographerPlugin::stopMessageWithPlugin`
        });
        // Do a just-in-time message stop subscription with our callback to stargate
        this.onStop(messageId, callback);
        /**
     * Dispatch the request to stop the message, and return the response, which will
     * either be 'stopped' if successful, and anything else if unsuccessful. Convert
     * that value with a boolean check, because the consumer only cares about true/false.
     */ const result = await this.stopMessage(messageId, additionalData);
        return result === (0, $5S02O.MessageDeliveryStatus).STOPPED;
    }
}

});
parcelRegister("4C4oc", function(module, exports) {
$parcel$export(module.exports, "Choreographer", () => $6604b0be53145f0a$export$236158f15971c92e);

var $3H4LK = parcelRequire("3H4LK");

var $5S02O = parcelRequire("5S02O");

var $d9E4D = parcelRequire("d9E4D");

var $2TqKe = parcelRequire("2TqKe");

var $cJbbj = parcelRequire("cJbbj");

var $iui2Z = parcelRequire("iui2Z");
// This timeout is used for any long-running messages that are either stuck for some reason, or that the user has yet to clear, to ensure that messaging doesn't stay blocked indefinitely
const $6604b0be53145f0a$var$CHOREOGRAPHER_MESSAGE_TTL = 300000; // 5 minute TTL for messages
// Lazily instantiate this the first time it's requested
let $6604b0be53145f0a$var$singleton;
class $6604b0be53145f0a$export$236158f15971c92e {
    /**
   * Static method to create and/or return a singleton of the choreographer API.
   *
   * @returns Shared instance of choreographer API.
   */ static getInstance() {
        if (typeof window !== 'undefined') {
            var _window$postOffice, _window$postOffice2;
            if ((_window$postOffice = window.postOffice) !== null && _window$postOffice !== void 0 && (_window$postOffice = _window$postOffice.choreographer) !== null && _window$postOffice !== void 0 && _window$postOffice.singleton) return window.postOffice.choreographer.singleton;
            window.postOffice = {
                ...window.postOffice,
                choreographer: {
                    ...(_window$postOffice2 = window.postOffice) === null || _window$postOffice2 === void 0 ? void 0 : _window$postOffice2.choreographer,
                    singleton: new this()
                }
            };
            return window.postOffice.choreographer.singleton;
        }
        if (!$6604b0be53145f0a$var$singleton) $6604b0be53145f0a$var$singleton = new this();
        return $6604b0be53145f0a$var$singleton;
    }
    constructor(){
        this.shouldBeChoreographed = (productId, analyticsClient, metricsData = {}, props, coordinationOptions, toggleableProp)=>{
            var _this$state$seenTrans;
            /*
     * TODO: Remove this once we have enough transactional message data!!! This is a hacky TEMPORARY solution to get a sense
     * of how many transactional messages we are showing to users.
     *
     * We have to track which messages have been seen because shouldBeChoreographed is called on every rerender of
     * Choreographer-integrated components. So, if we log every call, we'll get an inaccurate number of transactional
     * messages that are actually being shown to users.
     *
     * Thus, we track which messages have been seen and only log the first time we see a transactional message.
     */ // Check if we should log the shouldBeChoreographed call
            const isTransactional = (props === null || props === void 0 ? void 0 : props.messageType) === (0, $5S02O.MessageTypesEnum).TRANSACTIONAL;
            const isTransactionalLoggingEnabled = (0, $3H4LK.fg)('post-office_choreographer_log_transactional_msg');
            const seen = (props === null || props === void 0 ? void 0 : props.messageId) && ((_this$state$seenTrans = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans === void 0 ? void 0 : _this$state$seenTrans.has(props.messageId));
            // If the component is toggleable, we only want to log the message if it is actually rendered
            const isRendered = !toggleableProp || toggleableProp && (props === null || props === void 0 ? void 0 : props[toggleableProp]);
            if (isTransactional && props !== null && props !== void 0 && props.messageId && isTransactionalLoggingEnabled && isRendered && !seen) {
                var _this$state$seenTrans2, _this$getCurrentMessa;
                // Mark the messageId as seen to prevent duplicate logging on rerenders
                if (!this.state.seenTransactionalMessages.has(productId)) this.state.seenTransactionalMessages.set(productId, new Set());
                (_this$state$seenTrans2 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans2 === void 0 || _this$state$seenTrans2.add(props.messageId);
                const logger = new (0, $2TqKe.Logger)('messageStart', props.messageId, {
                    ...metricsData,
                    messageId: props.messageId,
                    currentMessageId: (_this$getCurrentMessa = this.getCurrentMessage()) === null || _this$getCurrentMessa === void 0 ? void 0 : _this$getCurrentMessa.messageId,
                    messageType: props.messageType
                }, analyticsClient);
                logger.requested();
            }
            // Call the original function that actually determines if a message should be choreographed
            return (0, $cJbbj.shouldBeChoreographed)(props, coordinationOptions);
        };
        this.state = {
            currentMessage: null,
            isDisabled: false,
            messages: new Map(),
            messageQueue: [],
            messageTtl: null,
            plugins: new Map(),
            queueingBehindMessage: null,
            shouldQueueMessages: false,
            seenTransactionalMessages: new Map()
        };
    }
    stopCurrentMessage() {
        if (this.state.currentMessage) this.stopMessageInternal(this.state.currentMessage.productId, this.state.currentMessage.messageId, this.state.currentMessage.analyticsClient, this.state.currentMessage.metricsData, this.state.currentMessage.plugin, true).then(()=>{
            // Manually clear the message TTL and reenable plugins here just in case the unregistered plugin's message denied the
            // stop request. We may still get a collision on-screen, but we're considering the message forcibly stopped at this
            // point, so need to allow new requests.
            this.clearMessageTtl();
            this.enablePlugins();
        });
    }
    /**
   * Enables the message queue, and logs which message everybody else is queueing up behind.
   *
   * @param productId Unique identifier for the product making the current startMessage request blocking others.
   * @param messageId Unique identifier for the messageId blocking others.
   */ queueMessages(productId, messageId) {
        this.state.shouldQueueMessages = true;
        this.state.queueingBehindMessage = {
            productId: productId,
            messageId: messageId,
            timestamp: Date.now()
        };
    }
    /**
   * Pushes all data associated with a startMessage request onto an internal queue, to potentially be processed at a later time.
   * If a pending message request opts out (or otherwise fails to start), this data will be used to reinitiate the startMessage
   * request for this message request instance. Returns a Promise that the caller can await as normal, and which will eventually
   * either be resolved as 'blocked' if any prior pending message is started, or will be resolved with its eventual outcome when
   * its startMessage request is processed.
   *
   * @param productId Unique identifier for the product making the current startMessage request being queued.
   * @param messageId Unique identifier for the messageId being queued.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ queueMessage(productId, messageId, analyticsClient, metricsData, plugin) {
        return new Promise((resolve)=>{
            this.state.messageQueue.push({
                productId: productId,
                messageId: messageId,
                timestamp: Date.now(),
                analyticsClient: analyticsClient,
                metricsData: metricsData,
                plugin: plugin,
                resolve: resolve
            });
        });
    }
    /**
   * Responsible for pulling a previously queued message request that was received while a message request was already in flight.
   * Shift the first message off the top of the queue, and use the stored resolve function to kickstart another pass through the
   * startMessage function, ultimately resolving with the final disposition of the request. Set the internal state for shouldQueueMessages
   * to false if we're restarting a startMessage request, so that this doesn't get immediately thrown back into the queue. If it
   * makes it through to its start callback being fired, that code will turn the shouldQueueMessages state back on.
   */ processQueuedMessage() {
        const queuedMessage = this.state.messageQueue.shift();
        // Disable the shouldQueueMessages state here. If we have a queued message, it will turn the shouldQueueMessages state back on when it
        // hits the call to its message's startCallback function. Otherwise, the queue is now empty, and we let things process normally.
        this.state.shouldQueueMessages = false;
        // Also null out the queueingBehindMessage value, which will be recreated if/when another message opens the queue below.
        this.state.queueingBehindMessage = null;
        if (queuedMessage) queuedMessage.resolve(this.startMessage(queuedMessage.productId, queuedMessage.messageId, queuedMessage.analyticsClient, queuedMessage.metricsData, queuedMessage.plugin));
    }
    /**
   * Responsible for flushing out any queued messages and resolving their Promises as "blocked". We don't officially consider a
   * message as "blocked" until one of the prior calls has signaled a valid "started" state. This way, any async callbacks that
   * are in flight can allow additional messages to queue up, and if they eventually opt out, we can move on to the next message
   * in the queue and see if it will signal success. Only when we get a successful start to we consider all queued up messages to
   * be "blocked". Run a loop to shift each of them off of the array and resolve them as blocked, until the array is empty.
   *
   * @param [plugin] An optional plugin instance
   */ destroyMessageQueue(plugin) {
        this.state.shouldQueueMessages = false;
        this.state.queueingBehindMessage = null;
        while(this.state.messageQueue.length > 0){
            var _this$state$currentMe, _this$state$currentMe2, _this$state$currentMe3, _this$state$currentMe4;
            const { analyticsClient: analyticsClient, messageId: messageId, metricsData: metricsData, productId: productId, resolve: resolve } = this.state.messageQueue.shift();
            const attributes = {
                ...metricsData,
                productId: productId,
                messageId: messageId
            };
            const actionSubject = (0, $5S02O.MessageAction).START;
            const logger = new (0, $2TqKe.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
            const debugLogger = new (0, $d9E4D.DebugLogger)(productId, messageId);
            logger.blocked({
                blockedByProductId: (_this$state$currentMe = this.state.currentMessage) === null || _this$state$currentMe === void 0 ? void 0 : _this$state$currentMe.productId,
                blockedByMessageId: (_this$state$currentMe2 = this.state.currentMessage) === null || _this$state$currentMe2 === void 0 ? void 0 : _this$state$currentMe2.messageId
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $5S02O.MessageDeliveryStatus).BLOCKED,
                    blockedByProductId: (_this$state$currentMe3 = this.state.currentMessage) === null || _this$state$currentMe3 === void 0 ? void 0 : _this$state$currentMe3.productId,
                    blockedByMessageId: (_this$state$currentMe4 = this.state.currentMessage) === null || _this$state$currentMe4 === void 0 ? void 0 : _this$state$currentMe4.messageId
                }
            });
            resolve((0, $5S02O.MessageDeliveryStatus).BLOCKED);
        }
    }
    /**
   * Sets a timeout to auto-expire any messaging that stays open for too long, to prevent messaging from being blocked indefinitely.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param AnalyticsClient The analytics client to be used for logging/metrics.
   * @param metricsData Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   */ setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl) {
        this.state.currentMessage = {
            productId: productId,
            messageId: messageId,
            analyticsClient: analyticsClient,
            metricsData: metricsData,
            plugin: plugin,
            timestamp: Date.now()
        };
        const isCustomTtlEnabled = (0, $3H4LK.fg)('post-office_choreographer_custom_message_ttl');
        // If feature flag is off, always use default TTL
        if (!isCustomTtlEnabled) {
            this.state.messageTtl = setTimeout(()=>{
                if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
            }, $6604b0be53145f0a$var$CHOREOGRAPHER_MESSAGE_TTL);
            return;
        }
        // If TTL is 0, disable TTL for this message
        if (messageTtl === 0) return;
        // Use provided TTL or default to CHOREOGRAPHER_MESSAGE_TTL
        this.state.messageTtl = setTimeout(()=>{
            if (this.isCurrentMessage(productId, messageId)) this.stopCurrentMessage();
        }, messageTtl ?? $6604b0be53145f0a$var$CHOREOGRAPHER_MESSAGE_TTL);
    }
    /**
   * Checks to see if the requesting productId/messageId pair matches the data for the currently-displayed message.
   *
   * @param productId Unique identifier for the product being checked for a current message match.
   * @param messageId Unique identifier for the messageId being checked for a current message match.
   */ isCurrentMessage(productId, messageId) {
        return Boolean(this.state.currentMessage && this.state.currentMessage.productId === productId && this.state.currentMessage.messageId === messageId);
    }
    /**
   * Returns the currentMessage object.
   */ getCurrentMessage() {
        return this.state.currentMessage;
    }
    /**
   * Returns the queueingBehindMessage object.
   */ getCurrentPendingMessage() {
        return this.state.queueingBehindMessage;
    }
    /**
   * Returns a snapshot of messages currently queued behind an in-flight start or stop request.
   */ getQueuedMessages() {
        return this.state.messageQueue.map(({ messageId: messageId, productId: productId, timestamp: timestamp })=>({
                messageId: messageId,
                productId: productId,
                timestamp: timestamp
            }));
    }
    /**
   * Clears the timeout that was established for the currently-displayed message.
   */ clearMessageTtl() {
        this.state.currentMessage = null;
        if (this.state.messageTtl) clearTimeout(this.state.messageTtl);
    }
    /**
   * Disables all plugins that are currently registered with the choreographer when loaded in an iframe. For apps that
   * are shown within iframes (e.g. smart link embeds) we typically do not want to show in-product messages as they
   * may conflict with messages shown in parent frames.
   *
   * If called outside an iframe then this function is a noop.
   *
   * @returns A cleanup function to re-enable plugins, or `undefined` if the function was called outside an iframe.
   */ disableChoreographerForIframe() {
        // Exit if we're not in an iframe
        if (!(0, $iui2Z.isIframe)()) return;
        this.disablePlugins();
        // Cleanup function to re-enable plugins
        return ()=>this.enablePlugins();
    }
    /**
   * Disables all plugins that are currently registered with the choreographer, called when a startMessage call is being dispatched.
   *
   * @param [exceptFor] An optional plugin instance.
   */ disablePlugins(exceptFor) {
        this.state.isDisabled = true;
        [
            ...this.state.plugins.values()
        ].forEach((p)=>{
            if (p !== exceptFor) p.disable();
        });
    }
    /**
   * Enables all plugins that are currently registered with the choreographer, called when a matching stopMessage call is successful.
   */ enablePlugins() {
        [
            ...this.state.plugins.values()
        ].forEach((p)=>p.enable());
        this.state.isDisabled = false;
    }
    /**
   * A callback used to remove a plugin from the list of subscribers for the choreographer service.
   *
   * @param productId A unique string representing the plugin to be unregistered from the choreographer API.
   */ unregisterPlugin(productId) {
        var _this$state$currentMe5;
        // If we're unregistering this productId's plugin, and the currentMessage is from this productId, we need to stop it to clear the choreographer
        if (((_this$state$currentMe5 = this.state.currentMessage) === null || _this$state$currentMe5 === void 0 ? void 0 : _this$state$currentMe5.productId) === productId) this.stopCurrentMessage();
        this.state.messages.delete(productId);
        this.state.plugins.delete(productId);
        this.state.seenTransactionalMessages.delete(productId);
    }
    /**
   * Determines whether any message is currently being displayed, by checking its own status and optionally, asking each registered plugin for its individual status.
   *
   * @returns A value reflecting whether a message is currently being displayed on screen.
   */ isDisplayingMessage() {
        return Boolean(this.state.currentMessage || [
            ...this.state.plugins.values()
        ].reduce((isDisplayingMessage, p)=>{
            return isDisplayingMessage || p.isDisplayingMessage();
        }, false));
    }
    /**
   * Returns the registered messages for a product. This is used by diagnostics and tests to inspect
   * the current Choreographer registry without mutating it.
   *
   * @param productId Unique identifier for the product whose messages are being requested.
   * @returns A Map of IMessage objects, keyed by unique messageId strings.
   */ getMessages(productId) {
        return this.state.messages.get(productId) ?? new Map();
    }
    /**
   * Requests to start a message via the choreographer service, ensuring only a single message instance at a time on the screen.
   * A successful request will block any other message attempts until such time as the matching stopMessage request is received,
   * or a message TTL timeout has expired.
   *
   * @param productId Unique identifier for the product making the current startMessage request that triggered this message timeout.
   * @param messageId Unique identifier for the messageId that triggered this message timeout.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [messageTtl] Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use default TTL (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(productId, messageId, analyticsClient, metricsData = {}, plugin, messageTtl) {
        const debugLogger = new (0, $d9E4D.DebugLogger)(productId, messageId);
        const actionSubject = (0, $5S02O.MessageAction).START;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $2TqKe.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$start;
            if (!this.hasMessageRecord(productId, messageId)) {
                // Bail early here, before even checking if we're in a queueing situation, or blocked, or anything else
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $5S02O.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $5S02O.MessageDeliveryStatus).UNREGISTERED;
            }
            // If we're currently queueing messages, push this one onto the queue and return the new Promise
            if (this.state.shouldQueueMessages) {
                var _this$state$queueingB, _this$state$queueingB2;
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: `queued behind ${(_this$state$queueingB = this.state.queueingBehindMessage) === null || _this$state$queueingB === void 0 ? void 0 : _this$state$queueingB.productId} ${(_this$state$queueingB2 = this.state.queueingBehindMessage) === null || _this$state$queueingB2 === void 0 ? void 0 : _this$state$queueingB2.messageId}`
                    }
                });
                return this.queueMessage(productId, messageId, analyticsClient, metricsData, plugin);
            }
            if (this.state.isDisabled || this.isDisplayingMessage()) {
                var _this$state$currentMe6, _this$state$currentMe7, _this$state$currentMe8, _this$state$currentMe9;
                logger.blocked({
                    blockedByProductId: (_this$state$currentMe6 = this.state.currentMessage) === null || _this$state$currentMe6 === void 0 ? void 0 : _this$state$currentMe6.productId,
                    blockedByMessageId: (_this$state$currentMe7 = this.state.currentMessage) === null || _this$state$currentMe7 === void 0 ? void 0 : _this$state$currentMe7.messageId
                });
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $5S02O.MessageDeliveryStatus).BLOCKED,
                        blockedByProductId: (_this$state$currentMe8 = this.state.currentMessage) === null || _this$state$currentMe8 === void 0 ? void 0 : _this$state$currentMe8.productId,
                        blockedByMessageId: (_this$state$currentMe9 = this.state.currentMessage) === null || _this$state$currentMe9 === void 0 ? void 0 : _this$state$currentMe9.messageId
                    }
                });
                return (0, $5S02O.MessageDeliveryStatus).BLOCKED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            this.queueMessages(productId, messageId);
            const didStart = await ((_message$start = message.start) === null || _message$start === void 0 ? void 0 : _message$start.call(message)) ?? true;
            if (didStart) {
                var _message$onStart;
                // Fire the onStart callback, if provided, to handle any post-start concerns for the consumer
                (_message$onStart = message.onStart) === null || _message$onStart === void 0 || _message$onStart.call(message);
                logger.started();
                this.disablePlugins(plugin);
                this.setMessageTtl(productId, messageId, analyticsClient, metricsData, plugin, messageTtl);
                // Successfully started the message, flush the queue and mark any pending requests as "blocked"
                this.destroyMessageQueue(plugin);
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $5S02O.MessageDeliveryStatus).STARTED
                    }
                });
                return (0, $5S02O.MessageDeliveryStatus).STARTED;
            }
            // Check to see if we have any pending requests in the message queue and attempt to start the next one in line
            this.processQueuedMessage();
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $5S02O.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $5S02O.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $5S02O.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $5S02O.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   * This version of the stopMessage function is private, and only intended to be called internally, so that it can make use of the forceStop parameter without exposing that to external callers.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @param [forceStop] A boolean to denote whether to forcefully clear the Choreographer's blocked state (used for TTL expiration and unregistering a plugin).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessageInternal(productId, messageId, analyticsClient, metricsData = {}, plugin, forceStop = false) {
        const debugLogger = new (0, $d9E4D.DebugLogger)(productId, messageId);
        const actionSubject = (0, $5S02O.MessageAction).STOP;
        const requestTimestamp = performance.now();
        debugLogger.log({
            info: {
                phase: actionSubject,
                timestamp: requestTimestamp
            },
            verbose: {
                phase: actionSubject,
                timestamp: requestTimestamp
            }
        });
        const attributes = {
            ...metricsData,
            productId: productId,
            messageId: messageId
        };
        const logger = new (0, $2TqKe.Logger)(actionSubject, messageId, attributes, analyticsClient, plugin);
        try {
            var _message$stop;
            if (!this.hasMessageRecord(productId, messageId)) {
                logger.unregistered();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $5S02O.MessageDeliveryStatus).UNREGISTERED
                    }
                });
                return (0, $5S02O.MessageDeliveryStatus).UNREGISTERED;
            }
            const message = this.ensureMessageRecord(productId, messageId);
            // Enable the message queue *if* the current stopMessage request matches the currentMessage data.
            // Any incoming startMessage requests will be queued while this stopMessage request is in-flight,
            // so that they can be immediately honored if this request comes back successfully.
            if (this.isCurrentMessage(productId, messageId)) this.queueMessages(productId, messageId);
            const didStop = await ((_message$stop = message.stop) === null || _message$stop === void 0 ? void 0 : _message$stop.call(message)) ?? true;
            // If we're hitting this from stopCurrentMessage, it means either a TTL has expired, or we're
            // unregistering a plugin. We forceStop the choreographer blocked state here, even if the stop
            // callback returned false.We don't want to block the UI indefinitely, we'll just have to risk
            // 1 additional message collision if the current message's stop callback refuses to clear.
            if (didStop || forceStop) {
                if (this.isCurrentMessage(productId, messageId)) {
                    var _message$onStop;
                    // Fire the onStop callback, if provided, to handle any post-stop concerns for the consumer
                    (_message$onStop = message.onStop) === null || _message$onStop === void 0 || _message$onStop.call(message);
                    // Only log this even if we're stopping the current message, so we have a 1:1 mapping of starts to stops.
                    // If this is a forced stop, log that in the attributes, so we can track those events specifically.
                    // Also log the value of didStop, so we know if this was a rejected stop attempt that *had* to be force stopped.
                    logger.stopped(forceStop ? {
                        forceStop: forceStop,
                        didStop: didStop
                    } : undefined);
                    // Only clear the message TTL and reenable plugins if we're stopping the *current* message
                    this.clearMessageTtl();
                    this.enablePlugins();
                }
                // Check to see if we have any pending requests in the message queue and attempt to start them
                this.processQueuedMessage();
                debugLogger.log({
                    verbose: {
                        phase: actionSubject,
                        disposition: (0, $5S02O.MessageDeliveryStatus).STOPPED
                    }
                });
                return (0, $5S02O.MessageDeliveryStatus).STOPPED;
            }
            // Stopping the message failed, so the UI is still intentionally blocked, flush the queue and mark any pending requests as "blocked"
            this.destroyMessageQueue(plugin);
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $5S02O.MessageDeliveryStatus).CANCELED
                }
            });
            return (0, $5S02O.MessageDeliveryStatus).CANCELED;
        } catch (error) {
            const e = error;
            logger.error({
                reason: e.message
            });
            debugLogger.log({
                verbose: {
                    phase: actionSubject,
                    disposition: (0, $5S02O.MessageDeliveryStatus).ERROR
                }
            });
            return (0, $5S02O.MessageDeliveryStatus).ERROR;
        }
    }
    /**
   * Requests to stop a message via the choreographer service. A successful request will allow any other plugins to begin issuing startMessage requests again.
   *
   * @param productId Unique identifier for the product making the current stopMessage request.
   * @param messageId Unique identifier for the messageId to be stopped.
   * @param analyticsClient The analytics client to be used for logging/metrics.
   * @param [metricsData] Additional data from plugin to be sent for metrics logging.
   * @param [plugin] An optional plugin instance.
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(productId, messageId, analyticsClient, metricsData = {}, plugin) {
        return this.stopMessageInternal(productId, messageId, analyticsClient, metricsData, plugin);
    }
    /**
   * Registers a plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId Unique identifier to register as the product owner of this plugin.
   * @param plugin A plugin instance to be registered with the choreographer instance.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId, plugin) {
        if (this.state.plugins.has(productId)) throw new Error(`Choreographer plugin already registered for ${productId}!`);
        this.state.plugins = this.state.plugins.set(productId, plugin);
        this.state.seenTransactionalMessages.set(productId, new Set());
        if (this.state.isDisabled) plugin.disable();
        return ()=>{
            this.unregisterPlugin(productId);
        };
    }
    /**
   * Validates that a message record is present and ready to be retrieved and/or manipulated.
   * Creates the message instance if it doesn't yet exist, initializing both start and stop callbacks to noop functions.
   *
   * @param productId Unique identifier to retrieve map of IMessage objects.
   * @param messageId Unique identifier for the messageId to be retrieved.
   * @returns IMessage object for the requested productId/messageId combination.
   */ ensureMessageRecord(productId, messageId) {
        let productMessages = this.state.messages.get(productId);
        if (!productMessages) {
            productMessages = new Map();
            this.state.messages.set(productId, productMessages);
        }
        let message = productMessages.get(messageId);
        if (!message) {
            message = {};
            productMessages.set(messageId, message);
        }
        return message;
    }
    /**
   * Checks for the existance of a message record for a given productId/messageId combination.
   *
   * @param productId Unique identifier to check for a map of IMessage objects.
   * @param messageId Unique identifier to check for within the map of productId IMessage objects.
   * @returns Boolean indicating whether or not an IMessage record exists for the requested productId/messageId combination.
   */ hasMessageRecord(productId, messageId) {
        var _this$state$messages$, _this$state$messages$2;
        return Boolean((_this$state$messages$ = this.state.messages.get(productId)) === null || _this$state$messages$ === void 0 || (_this$state$messages$2 = _this$state$messages$.has) === null || _this$state$messages$2 === void 0 ? void 0 : _this$state$messages$2.call(_this$state$messages$, messageId));
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param options An object containing optional start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ on(productId, messageId, options = {}, finalizers = {}) {
        const message = {
            ...this.ensureMessageRecord(productId, messageId),
            ...options,
            ...finalizers
        };
        this.state.messages.get(productId).set(messageId, message);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStart(productId, messageId, startCallback, finalizers) {
        this.on(productId, messageId, {
            start: startCallback
        }, finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for this message subscription.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   * @param finalizers An object containing optional onStart and onStop callback functions, to be invoked upon successful starts and stops of messages, respectively.
   */ onStop(productId, messageId, stopCallback, finalizers = {}) {
        this.on(productId, messageId, {
            stop: stopCallback
        }, finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a combination of productId and messageId.
   *
   * @param productId Unique identifier to be used as a primary key for unsubscribing this message.
   * @param messageId Unique identifier within the context of all productId message entries, to be used as a secondary key for unsubscribing this message.
   */ off(productId, messageId) {
        var _this$state$messages$3, _this$state$messages$4;
        (_this$state$messages$3 = this.state.messages.get(productId)) === null || _this$state$messages$3 === void 0 || (_this$state$messages$4 = _this$state$messages$3.delete) === null || _this$state$messages$4 === void 0 || _this$state$messages$4.call(_this$state$messages$3, messageId);
    }
    /**
   * This should only be used for test cleanup purposes.
   * Clears the seen transactional messages cache for a given productId.
   *
   * @param productId Unique identifier to clear the seen transactional messages cache for.
   */ clearSeenTransactionalMessages(productId) {
        var _this$state$seenTrans3;
        (_this$state$seenTrans3 = this.state.seenTransactionalMessages.get(productId)) === null || _this$state$seenTrans3 === void 0 || _this$state$seenTrans3.clear();
    }
}

});
parcelRegister("5S02O", function(module, exports) {
$parcel$export(module.exports, "MessageEventType", () => $9bd1995c65274dfd$export$d33b097e0a285bc2);
$parcel$export(module.exports, "MessageDeliveryStatus", () => $9bd1995c65274dfd$export$f6a9504bc1305cf0);
$parcel$export(module.exports, "ProductIds", () => $9bd1995c65274dfd$export$7fb117db98868be6);
$parcel$export(module.exports, "MessageTypesEnum", () => $9bd1995c65274dfd$export$94e85cf3348f045a);
$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $9bd1995c65274dfd$export$dbe9e38c9d6f26d0);
$parcel$export(module.exports, "MessageAction", () => $9bd1995c65274dfd$export$865c0eaaa43d90f8);
const $9bd1995c65274dfd$export$d33b097e0a285bc2 = {
    START: 'start',
    STOP: 'stop'
};
const $9bd1995c65274dfd$export$f6a9504bc1305cf0 = {
    BLOCKED: 'blocked',
    CANCELED: 'canceled',
    ERROR: 'error',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
    // TEMPORARY: used to track when a transactional message is requested to be choreographed
    // when the choreographer is currently blocked.
    REQUESTED: 'requested'
};
var $9bd1995c65274dfd$export$7fb117db98868be6 = /*#__PURE__*/ function(ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
    ProductIds["CLOUDADMIN"] = "cloudadmin";
    ProductIds["BITBUCKET"] = "bitbucket";
    ProductIds["POST_OFFICE"] = "post-office";
    ProductIds["LOOM"] = "loom";
    ProductIds["TRELLO"] = "trello";
    return ProductIds;
}({});
const $9bd1995c65274dfd$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $9bd1995c65274dfd$export$dbe9e38c9d6f26d0 = [
    $9bd1995c65274dfd$export$94e85cf3348f045a.ENGAGEMENT,
    $9bd1995c65274dfd$export$94e85cf3348f045a.MARKETING
];
const $9bd1995c65274dfd$export$865c0eaaa43d90f8 = {
    START: 'messageStart',
    STOP: 'messageStop'
};
const $9bd1995c65274dfd$export$fc6a8b8cb405f50 = {
    INFO: 'info',
    VERBOSE: 'verbose'
};

});

parcelRegister("d9E4D", function(module, exports) {
$parcel$export(module.exports, "DebugLogger", () => $ae3879520d04bdd5$export$21e6cc849c1dc1ab);
function $ae3879520d04bdd5$var$getCurrentLoggingLevel() {
    return window.choreographerLoggingLevel;
}
function $ae3879520d04bdd5$var$logMessageIfValidLoggingLevel(loggingLevel, data) {
    if ($ae3879520d04bdd5$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.table(data);
}
function $ae3879520d04bdd5$var$traceMessageIfValidLoggingLevel(loggingLevel, productId, messageId, message) {
    if ($ae3879520d04bdd5$var$getCurrentLoggingLevel() === loggingLevel) // eslint-disable-next-line no-console
    console.log(`CHOREOGRAPHER - ${productId} - ${messageId} - ${message}`);
}
class $ae3879520d04bdd5$export$21e6cc849c1dc1ab {
    constructor(productId, messageId){
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. log.info and log.verbose, which are functions that take an
   * object of any key/value pairs, which will be merged with the productId
   * and the messageId values passed to the constructor, and output via
   * console.table.
   *
   * Example: debugLogger.log({
   *   info: { foo: true },
   *   verbose: {
   *     foo: true,
   *     bar: 123,
   *     baz 'abc',
   *     timestamp: performance.now()
   *   },
   * });
   *
   * @param messages Record<LoggingLevels, Record<string, unknown>> An object
   * keyed by the desired log-level, with each value being an object of any
   * key/value pairs to be output to console.table.
   */ this.log = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $ae3879520d04bdd5$var$logMessageIfValidLoggingLevel(loggingLevel, {
                    productId: this.state.productId,
                    messageId: this.state.messageId,
                    ...messages[loggingLevel] ?? {},
                    ...loggingLevel === 'verbose' ? {
                        timestamp: performance.now()
                    } : {}
                });
            });
        };
        /**
   * A function that takes an object of properties for each logging level
   * name, e.g. trace.info and trace.verbose, which are functions that take
   * a string to be used as the label for a stack trace via console.trace.
   *
   * Example: debugLogger.trace({
   *   info: 'This is a stack trace',
   *   verbose: `This is a stack trace with a much more verbose message which
   * contains data about the ${productId} and ${messageId} within my function,
   * invoked at ${performance.now()}ms`,
   * });
   *
   * @param messages Record<LoggingLevels, string> An object keyed by the
   * desired log-level, with each value being a string to be output as the
   * label to console.trace.
   */ this.trace = (messages)=>{
            [
                ...Object.keys(messages)
            ].forEach((loggingLevel)=>{
                $ae3879520d04bdd5$var$traceMessageIfValidLoggingLevel(loggingLevel, this.state.productId, this.state.messageId, `${messages[loggingLevel]}${loggingLevel === 'verbose' ? ` (${performance.now()})` : ''}`);
            });
        };
        this.state = {
            productId: productId,
            messageId: messageId
        };
    }
}

});

parcelRegister("2TqKe", function(module, exports) {
$parcel$export(module.exports, "Logger", () => $b3163f6fe5a55780$export$efa9a398d6368992);

var $5S02O = parcelRequire("5S02O");
class $b3163f6fe5a55780$export$efa9a398d6368992 {
    /**
   * Utility class to simplify and allow for wider use of sending operational event to the Analytics web client for logging/metrics.
   *
   * @param actionSubject A (MessageActions) string denoting either the start or stop phase of a message.
   * @param actionSubjectId Unique messageId to be logged with this even.
   * @param metricsData Additional data from plugin to be sent with event for metrics logging.
   * @param analyticsClient An instance of AnalyticsWebClient, unique to each caller
   * @param [plugin] An optional plugin instance.
   */ constructor(actionSubject, actionSubjectId, metricsData, analyticsClient, plugin){
        this.state = {
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            metricsData: metricsData,
            analyticsClient: analyticsClient,
            plugin: plugin
        };
    }
    /**
   * Send operational event to the Analytics web client for logging/metrics.
   *
   * @param action A (MessageDeliveryStatuses) string denoting the ultimate disposition of this message start or stop request.
   */ sendOperationalEvent(action, additionalAttributes) {
        var _plugin$shouldLogEven;
        const { analyticsClient: analyticsClient, actionSubject: actionSubject, actionSubjectId: actionSubjectId, metricsData: attributes, plugin: plugin } = this.state;
        const event = {
            source: 'choreographer',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...attributes ?? {},
                ...additionalAttributes ?? {}
            },
            tags: [
                'postOffice'
            ]
        };
        if ((plugin === null || plugin === void 0 || (_plugin$shouldLogEven = plugin.shouldLogEvent) === null || _plugin$shouldLogEven === void 0 ? void 0 : _plugin$shouldLogEven.call(plugin, event)) ?? true) analyticsClient.sendOperationalEvent(event);
    }
    blocked(additionalAttributes) {
        this.sendOperationalEvent((0, $5S02O.MessageDeliveryStatus).BLOCKED, additionalAttributes);
    }
    error(additionalAttributes) {
        this.sendOperationalEvent((0, $5S02O.MessageDeliveryStatus).ERROR, additionalAttributes);
    }
    unregistered(additionalAttributes) {
        this.sendOperationalEvent((0, $5S02O.MessageDeliveryStatus).UNREGISTERED, additionalAttributes);
    }
    started(additionalAttributes) {
        this.sendOperationalEvent((0, $5S02O.MessageDeliveryStatus).STARTED, additionalAttributes);
    }
    stopped(additionalAttributes) {
        this.sendOperationalEvent((0, $5S02O.MessageDeliveryStatus).STOPPED, additionalAttributes);
    }
    requested(additionalAttributes) {
        this.sendOperationalEvent((0, $5S02O.MessageDeliveryStatus).REQUESTED, additionalAttributes);
    }
}

});

parcelRegister("cJbbj", function(module, exports) {
$parcel$export(module.exports, "shouldBeChoreographed", () => $a480a195525ebbd4$export$a8ba9111c7eec9ac);
$parcel$export(module.exports, "wrapComponentForChoreographer", () => $a480a195525ebbd4$export$51d40de083bcc6e7);
$parcel$export(module.exports, "wrapToggleableComponentForChoreographer", () => $a480a195525ebbd4$export$7c574bc7a8b74124);

var $4fqPo = parcelRequire("4fqPo");

var $5S02O = parcelRequire("5S02O");
const $a480a195525ebbd4$export$a8ba9111c7eec9ac = (props, coordinationOptions)=>{
    return Boolean(coordinationOptions === null || coordinationOptions === void 0 ? void 0 : coordinationOptions.enableChoreographer) && (props === null || props === void 0 ? void 0 : props.messageType) !== undefined && (0, $5S02O.IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
};
const $a480a195525ebbd4$export$51d40de083bcc6e7 = (Component)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedRender: withChoreographedRender, ...props }) {
        const ChoreographedComponent = (0, $4fqPo.useMemo)(()=>withChoreographedRender(Component), [
            withChoreographedRender
        ]);
        if (shouldBeChoreographedProp(props)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};
const $a480a195525ebbd4$export$7c574bc7a8b74124 = (Component, toggleableProp)=>{
    function WrapperComponent({ shouldBeChoreographed: shouldBeChoreographedProp, withChoreographedToggle: withChoreographedToggle, ...props }) {
        const ChoreographedComponent = (0, $4fqPo.useMemo)(()=>withChoreographedToggle(Component, toggleableProp), [
            withChoreographedToggle
        ]);
        if (shouldBeChoreographedProp(props, toggleableProp)) {
            // Extract messageType since it is not a property of ChoreographedComponent
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { messageType: messageType, ...rest } = props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ChoreographedComponent, rest);
        }
        // Extract messageType since it is not a property of the original Atlaskit component
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, rest);
    }
    WrapperComponent.displayName = `ChoreographerWrapped${(Component.displayName ?? Component.name) || 'Component'}`;
    return WrapperComponent;
};

});

parcelRegister("iui2Z", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $92c0343ea2d3330d$export$e6c5ffa684aac4d7);
/**
 * Returns `true` if window is currently nested within an iframe.
 */ function $92c0343ea2d3330d$export$e6c5ffa684aac4d7() {
    return window.self !== window.top;
}

});


parcelRegister("60JH1", function(module, exports) {
$parcel$export(module.exports, "ChoreographerPlugin", () => $6450435eedb2fa30$export$71324a662782c710);

var $Idrdz = parcelRequire("Idrdz");
var $jgvOT = parcelRequire("jgvOT");

var $4C4oc = parcelRequire("4C4oc");
class $6450435eedb2fa30$export$71324a662782c710 {
    /**
   * Instantiates a plugin to be used with the main choreographer API. Requires a productId string
   * to be used for segmenting registered messageIds in other parts of the API, which ensures uniqueness
   * between individual products for tracking purposes.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @param env The environment type for the product, to be used for analytics events.
   * @param metaMetricsData An object containing additional metadata to be sent along with every message request.
   * @returns A new instance of this plugin to use for integrating a 1P or 3P product with the choreographer API.
   */ constructor(productId, env, metaMetricsData = {}){
        this.state = {
            isDisabled: false,
            isDisplayingMessage: false,
            metaMetricsData: metaMetricsData,
            productId: productId,
            unregisterPlugin: ()=>{}
        };
        this.analyticsClient = this.createAnalyticsClient(env);
        /**
     * These finalizers are callbacks to be invoked after a valid start or stop request in the Choreographer core.
     * Declaring them in the constructor because it's the same onStart/onStop pair that will be passed ot all of the
     * .on, .onStart, and .onStop function registrations.
     *
     * This behavior used to be managed by a decorator function that would auto-set the isDisplayingMessage value
     * whenever its start or stop callbacks were invoked. However, those start and stop callbacks are optional from
     * this layer, so if a consumer did *not* register a stop callback, the display state would never be cleared here
     * in the plugin, and would continue blocking messages.
     *
     * We're now passing these onStart and onStop callbacks as part of the message registration, so that any time a
     * message is started or stopped at the core layer, we can fire these callbacks to update the plugin's local state,
     * whether or not an actual start or stop callback was registered by the consumer.
     */ this.finalizers = {
            onStart: ()=>this.blockDisplayState(),
            onStop: ()=>this.clearDisplayState()
        };
        this.state.unregisterPlugin = this.registerPlugin(productId);
    }
    /**
   * Public method to clean up this plugin instance, which will handle unregistering it from the choreographer API.
   */ destroy() {
        this.state.unregisterPlugin();
    }
    /**
   * Determines whether this plugin is currently displaying a message on the screen. By default, is a simple boolean
   * toggle that gets flipped back and forth, but it could also be a function that checks the DOM for a given message
   * container to be present, or checks with some external API to tell it whether a message is being displayed, or
   * anything else. The logic is up to the consumer to implement, if something custom is desired.
   *
   * @returns A boolean that represents whether this plugin is currently displaying a message on the screen.
   */ isDisplayingMessage() {
        return this.state.isDisplayingMessage;
    }
    /**
   * Sets the internal isDisplayingMessage state to true, to denote that this plugin is currently blocking the UI.
   */ blockDisplayState() {
        this.state.isDisplayingMessage = true;
    }
    /**
   * Sets the internal isDisplayingMessage state to false, to denote that this plugin is no longer blocking the UI.
   */ clearDisplayState() {
        this.state.isDisplayingMessage = false;
    }
    /**
   * Disables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ disable() {
        this.state.isDisabled = true;
    }
    /**
   * Enables the plugin from being able to issue startMessage requests. By default, this is a simple boolean toggle
   * that gets flipped back and forth, but it could also be a call to an external API to disable some functionality
   * via its own public interface. The logic is up to the consumer to implement, if something custom is desired.
   */ enable() {
        this.state.isDisabled = false;
    }
    /**
   * Returns the Analytics Web Client instance for this plugin.
   *
   * @returns AnalyticsWebClient instance
   */ getAnalyticsClient() {
        return this.analyticsClient;
    }
    /**
   * Makes a request to start a message through the choreographer API. Will immediately return false if this plugin
   * is currently in a disabled state, and will otherwise return the ultimate result of the startMessage request.
   *
   * @param messageId The messageId for the message to be started through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message start request
   * @param messageTtl Optional TTL for this message. 0 = disable TTL, number > 0 = custom TTL in milliseconds, undefined = use global default (5 minutes).
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message start operation.
   */ async startMessage(messageId, additionalData = {}, messageTtl) {
        return (0, $4C4oc.Choreographer).getInstance().startMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        }, this, messageTtl);
    }
    /**
   * Makes a request to stop a message through the choreographer API. Will return the ultimate result of the stopMessage request.
   *
   * @param messageId The messageId for the message to be stopped through the choreographer API.
   * @param additionalData An object containing additional metadata to be sent along with the message stop request
   * @returns A Promise that resolves to a MessageDeliveryStatus value, to denote the ultimate status of the attempted message stop operation.
   */ async stopMessage(messageId, additionalData = {}) {
        return (0, $4C4oc.Choreographer).getInstance().stopMessage(this.state.productId, messageId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            ...additionalData
        });
    }
    /**
   * Subscribes callbacks to be used for starting and stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param options An object containing start and stop callback functions, to be invoked upon successful requests to startMessage and stopMessage, respectively.
   */ on(messageId, options = {}) {
        return (0, $4C4oc.Choreographer).getInstance().on(this.state.productId, messageId, options, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for starting message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param startCallback A callback to be invoked upon successful requests to startMessage.
   */ onStart(messageId, startCallback) {
        return (0, $4C4oc.Choreographer).getInstance().onStart(this.state.productId, messageId, startCallback, this.finalizers);
    }
    /**
   * Subscribes a callback to be used for stopping message requests through the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for this message subscription.
   * @param stopCallback A callback to be invoked upon successful requests to stopMessage.
   */ onStop(messageId, stopCallback) {
        return (0, $4C4oc.Choreographer).getInstance().onStop(this.state.productId, messageId, stopCallback, this.finalizers);
    }
    /**
   * Unsubscribes a message's start and stop message callbacks from the choreographer, keyed by a unique (to this plugin instance) messageId.
   *
   * @param messageId Unique identifier within the context of all of this plugin's message entries, to be used as a key for unsubscribing this message subscription.
   */ off(messageId) {
        return (0, $4C4oc.Choreographer).getInstance().off(this.state.productId, messageId);
    }
    shouldBeChoreographed(props, coordinationOptions, toggleableProp // TODO: Remove this once we no longer need transactional logs
    ) {
        return (0, $4C4oc.Choreographer).getInstance().shouldBeChoreographed(this.state.productId, this.analyticsClient, {
            ...this.state.metaMetricsData,
            productId: this.state.productId
        }, props, coordinationOptions, toggleableProp);
    }
    /**
   * Registers this plugin instance with the choreographer API. Allows the choreographer to enable and disable it as needed to ensure individual message experiences on screen.
   *
   * @param productId The name of the product for which this plugin will be managing communications with the choreographer API.
   * @returns A callback to be used to unregister this plugin with the choreographer instance, for cleanup purposes, if necessary.
   */ registerPlugin(productId) {
        return (0, $4C4oc.Choreographer).getInstance().registerPlugin(productId, this);
    }
    /**
   * Creates a new instance of the Analytics Web Client for a plugin to use for sending analytics events.
   *
   * @param env environment type used to create the analytics client
   * @returns AnalyticsWebClient instance
   */ createAnalyticsClient(env) {
        const analyticsClient = new (0, $Idrdz.default)({
            env: env,
            product: 'postOffice',
            origin: (0, $jgvOT.originType).WEB
        });
        return analyticsClient;
    }
}

});



parcelRegister("17kdz", function(module, exports) {
$parcel$export(module.exports, "getFlag", () => $05b171d0c087b03f$export$a19b74191e00c5e);
$parcel$export(module.exports, "setFlag", () => $05b171d0c087b03f$export$5e165df1e30a1331);
/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ async function $05b171d0c087b03f$export$a19b74191e00c5e(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return {
        status: false,
        lastSeenDate: ''
    };
}
async function $05b171d0c087b03f$export$5e165df1e30a1331(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return Promise.resolve();
}

});

parcelRegister("cd9H4", function(module, exports) {
$parcel$export(module.exports, "default", () => $66cfc26ecaf0cf9e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $hcJXd = parcelRequire("hcJXd");
const $66cfc26ecaf0cf9e$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $66cfc26ecaf0cf9e$export$2e2bcd8739ae039 extends (0, $4fqPo.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hcJXd.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args), this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $hcJXd.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        }, this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $66cfc26ecaf0cf9e$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        }, this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        }, this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $66cfc26ecaf0cf9e$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}

});
parcelRegister("hcJXd", function(module, exports) {
$parcel$export(module.exports, "DismissTrigger", () => $38ad37325daa5de0$export$151efc60ac534d42);
$parcel$export(module.exports, "default", () => $38ad37325daa5de0$export$2e2bcd8739ae039);

var $lhXNe = parcelRequire("lhXNe");

var $4fqPo = parcelRequire("4fqPo");

var $2TpYn = parcelRequire("2TpYn");

var $5KXNS = parcelRequire("5KXNS");

var $4Otf0 = parcelRequire("4Otf0");

var $hDv4O = parcelRequire("hDv4O");

var $2GCwA = parcelRequire("2GCwA");

var $3mqwV = parcelRequire("3mqwV");
var $38ad37325daa5de0$export$151efc60ac534d42 = /*#__PURE__*/ function(DismissTrigger) {
    DismissTrigger["AutoDismiss"] = "AUTO_DISMISS";
    DismissTrigger["Manual"] = "MANUAL";
    DismissTrigger["Finished"] = "FINISHED";
    DismissTrigger["Unmount"] = "UNMOUNT";
    return DismissTrigger;
}({});
const $38ad37325daa5de0$export$3e8963a077f85f25 = 8000;
var $38ad37325daa5de0$export$2e2bcd8739ae039 = ({ question: question, statement: statement, onDismiss: onDismiss, onSubmit: onSubmit, onMailingListAnswer: onMailingListAnswer, getUserHasAnsweredMailingList: getUserHasAnsweredMailingList, textLabel: textLabel = 'Why did you give that rating', textPlaceholder: textPlaceholder = 'Tell us why' })=>{
    const autoDisappearTimeoutRef = (0, $4fqPo.useRef)(null);
    // only allow a single dismiss for a component
    const isDismissedRef = (0, $4fqPo.useRef)(false);
    const tryDismiss = (0, $4fqPo.useCallback)((trigger)=>{
        // Already called dismiss once
        if (isDismissedRef.current) return;
        isDismissedRef.current = true;
        onDismissRef.current({
            trigger: trigger
        });
    }, []);
    const [currentStep, setCurrentStep] = (0, $4fqPo.useState)('SURVEY');
    const trySetCurrentStep = (0, $4fqPo.useCallback)((step)=>{
        // Already dismissed - cannot update the step
        if (isDismissedRef.current) return;
        setCurrentStep(step);
    }, [
        setCurrentStep
    ]);
    // using a ref so that we don't break all of our caches if a consumer is using an arrow function
    const onDismissRef = (0, $4fqPo.useRef)(onDismiss);
    (0, $4fqPo.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    // reset isDismissedRef.current on mount to be compatible with double render in react18 strict mode
    (0, $4fqPo.useEffect)(()=>{
        isDismissedRef.current = false;
    }, []);
    const tryClearTimeout = (0, $4fqPo.useCallback)(()=>{
        const id = autoDisappearTimeoutRef.current;
        if (id) {
            clearTimeout(id);
            autoDisappearTimeoutRef.current = null;
        }
    }, []);
    // Cleanup any auto dismiss after dismiss
    (0, $4fqPo.useEffect)(()=>{
        return function unmount() {
            tryClearTimeout();
            tryDismiss("UNMOUNT");
        };
    }, [
        tryClearTimeout,
        tryDismiss
    ]);
    const onSurveySubmit = (0, $4fqPo.useCallback)(async (formValues, _form, callback = ()=>{})=>{
        // Submitting form: Phase 1 complete
        await onSubmit(formValues);
        // Note: need to call callback just before we navigate away
        // It cleans up the form (required)
        // Optional Phase 2: Asking to join Atlassian Research Group
        // Only enter phase 2 if:
        // 1. not already dismissed; AND
        // 2. permission given to contact; AND
        // 3. user has previously not answered mailing list question (getUserHasAnsweredMailingList returns false)
        // Not entering phase 2: User has dismissed while the submit promise was resolving
        if (isDismissedRef.current) {
            callback();
            return;
        }
        // Not entering phase 2: no permission given to respond to feedback
        if (!formValues.canContact) {
            callback();
            trySetCurrentStep('POST_SURVEY_NO_CONSENT');
            return;
        }
        const userHasAnswered = await getUserHasAnsweredMailingList();
        callback();
        // Not entering phase 2: user has already answered this question
        if (userHasAnswered) {
            trySetCurrentStep('POST_SURVEY_HAS_SIGN_UP');
            return;
        }
        // Enter phase 2
        trySetCurrentStep('SIGN_UP_PROMPT');
    }, [
        getUserHasAnsweredMailingList,
        onSubmit,
        trySetCurrentStep
    ]);
    const onMailingListResponse = (0, $4fqPo.useCallback)(async (answer)=>{
        await onMailingListAnswer(answer);
        if (answer) {
            trySetCurrentStep('SIGN_UP_SUCCESS');
            return;
        }
        // We have already thanked to user, we can simply close
        tryDismiss("FINISHED");
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        tryDismiss,
        trySetCurrentStep
    ]);
    // Start the auto disappear when we are finished
    (0, $4fqPo.useEffect)(()=>{
        // Already dismissed
        if (isDismissedRef.current) return;
        // Timeout already scheduled
        if (autoDisappearTimeoutRef.current) return;
        if ([
            'SIGN_UP_SUCCESS',
            'POST_SURVEY_NO_CONSENT',
            'POST_SURVEY_HAS_SIGN_UP'
        ].includes(currentStep)) autoDisappearTimeoutRef.current = window.setTimeout(()=>tryDismiss("AUTO_DISMISS"), $38ad37325daa5de0$export$3e8963a077f85f25);
    }, [
        currentStep,
        tryDismiss
    ]);
    (0, $3mqwV.default)({
        onDismiss: ()=>tryDismiss("MANUAL")
    });
    const content = (()=>{
        if (currentStep === 'SURVEY') return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $2GCwA.default), {
            question: question,
            statement: statement,
            textLabel: textLabel,
            textPlaceholder: textPlaceholder,
            onSubmit: onSurveySubmit
        });
        if (currentStep === 'SIGN_UP_PROMPT') return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $5KXNS.default), {
            onAnswer: onMailingListResponse
        });
        if (currentStep === 'SIGN_UP_SUCCESS') return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $4Otf0.default), {});
        if (currentStep === 'POST_SURVEY_NO_CONSENT' || currentStep === 'POST_SURVEY_HAS_SIGN_UP') return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $2TpYn.default), {});
        return null;
    })();
    const manualDismiss = (0, $4fqPo.useCallback)(()=>{
        // clear any pending timers
        tryClearTimeout();
        tryDismiss("MANUAL");
    }, [
        tryDismiss,
        tryClearTimeout
    ]);
    return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $hDv4O.default), {
        onDismiss: manualDismiss,
        children: content
    });
};

});
parcelRegister("2TpYn", function(module, exports) {
$parcel$export(module.exports, "default", () => $9c784ae305eccafb$export$2e2bcd8739ae039);

var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $2eKV2 = parcelRequire("2eKV2");

var $kRpYo = parcelRequire("kRpYo");
var $9c784ae305eccafb$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $kRpYo.default), {
        children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $2eKV2.default), {
            size: "xsmall",
            children: "Thanks for your feedback"
        })
    });

});
parcelRegister("kRpYo", function(module, exports) {
$parcel$export(module.exports, "default", () => $721146f73c8a6365$export$2e2bcd8739ae039);
/* SuccessContainer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3RpuA = parcelRequire("3RpuA");
const $721146f73c8a6365$var$sectionStyles = null;
const $721146f73c8a6365$var$iconContainerStyles = null;
var $721146f73c8a6365$export$2e2bcd8739ae039 = ({ children: children })=>/*#__PURE__*/ (0, $lhXNe.jsxs)("section", {
        className: (0, $ltgDR.default)([
            "_18u01jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                className: (0, $ltgDR.default)([
                    "_kqswstnw _154iv47k _1ltv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))), {
                    spacing: "spacious",
                    label: "",
                    "aria-hidden": true,
                    color: "var(--ds-icon-success, #6A9A23)"
                })
            }),
            children
        ]
    });

});


parcelRegister("5KXNS", function(module, exports) {
$parcel$export(module.exports, "default", () => $d41b26fbe3b29f2c$export$2e2bcd8739ae039);
/* SignUpPrompt.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $d7mfg = parcelRequire("d7mfg");

var $2eKV2 = parcelRequire("2eKV2");

var $iByhD = parcelRequire("iByhD");

var $7fscZ = parcelRequire("7fscZ");
var $5E02Z = parcelRequire("5E02Z");
var $ekURY = parcelRequire("ekURY");

var $kRpYo = parcelRequire("kRpYo");
const $d41b26fbe3b29f2c$var$buttonContainerStyles = null;
var $d41b26fbe3b29f2c$export$2e2bcd8739ae039 = ({ onAnswer: onAnswer })=>{
    const [pending, setPending] = (0, $4fqPo.useState)(null);
    const answeredWith = (0, $4fqPo.useCallback)(async (answer)=>{
        setPending(answer ? 'yes' : 'no');
        await onAnswer(answer);
    }, [
        setPending,
        onAnswer
    ]);
    const isDisabled = Boolean(pending);
    return /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $kRpYo.default), {
        children: [
            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $2eKV2.default), {
                size: "xsmall",
                children: "Thanks for your feedback"
            }),
            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $7fscZ.default), {
                paddingBlockStart: "space.150",
                children: /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $5E02Z.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ekURY.default), {
                            as: "p",
                            children: "Are you interested in participating in our research?"
                        }),
                        /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $ekURY.default), {
                            as: "p",
                            children: [
                                "Sign up for the",
                                ' ',
                                /*#__PURE__*/ (0, $lhXNe.jsx)((0, $iByhD.default), {
                                    href: "https://www.atlassian.com/research-group",
                                    target: "_blank",
                                    children: "Atlassian Research Group"
                                }),
                                ' ',
                                "and we may contact you in the future with research opportunities."
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lhXNe.jsxs)("div", {
                className: (0, $ltgDR.default)([
                    "_19pkxy5q _1e0c1txw _1bahesu3 _pof3u2gc"
                ]),
                children: [
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $d7mfg.default), {
                        appearance: "subtle",
                        onClick: ()=>answeredWith(false),
                        isDisabled: isDisabled,
                        isLoading: pending === 'no',
                        children: "No, thanks"
                    }),
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $d7mfg.default), {
                        appearance: "primary",
                        onClick: ()=>answeredWith(true),
                        isDisabled: isDisabled,
                        isLoading: pending === 'yes',
                        children: "Yes, sign me up"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("d7mfg", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a58fb435d30387c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $98k4G = parcelRequire("98k4G");

var $Az2gn = parcelRequire("Az2gn");

var $c6jSC = parcelRequire("c6jSC");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $9a58fb435d30387c$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $98k4G.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest
    }, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Az2gn.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c6jSC.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Az2gn.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Az2gn.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c6jSC.default), {
        icon: iconAfter
    })));
}));
$9a58fb435d30387c$var$Button.displayName = 'Button';
var $9a58fb435d30387c$export$2e2bcd8739ae039 = $9a58fb435d30387c$var$Button;

});

parcelRegister("iByhD", function(module, exports) {
$parcel$export(module.exports, "default", () => $65ba3b008d82f9d7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fxmw9 = parcelRequire("fxmw9");

var $3H4LK = parcelRequire("3H4LK");

var $4nUcM = parcelRequire("4nUcM");
var $7fscZ = parcelRequire("7fscZ");
const $65ba3b008d82f9d7$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $65ba3b008d82f9d7$var$iconStyles = null;
const $65ba3b008d82f9d7$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $4nUcM.default), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $fxmw9.cx)($65ba3b008d82f9d7$var$styles.base, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $65ba3b008d82f9d7$var$styles.baseT26Shape, appearance === 'default' && $65ba3b008d82f9d7$var$styles.defaultAppearance, appearance === 'subtle' && $65ba3b008d82f9d7$var$styles.subtleAppearance, appearance === 'inverse' && $65ba3b008d82f9d7$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $65ba3b008d82f9d7$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        as: "span",
        xcss: $65ba3b008d82f9d7$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $4fqPo.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $ltgDR.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $65ba3b008d82f9d7$var$Link = /*#__PURE__*/ (0, $4fqPo.forwardRef)($65ba3b008d82f9d7$var$LinkWithoutRef);
var $65ba3b008d82f9d7$export$2e2bcd8739ae039 = $65ba3b008d82f9d7$var$Link;

});
parcelRegister("4nUcM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba3c370cecaa4137$export$2e2bcd8739ae039);
/* anchor.tsx generated by @compiled/babel-plugin v0.37.1 */ /* anchor.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9h99w = parcelRequire("9h99w");

var $yLYo1 = parcelRequire("yLYo1");

var $4EOcq = parcelRequire("4EOcq");

var $koPKk = parcelRequire("koPKk");

var $c1tmZ = parcelRequire("c1tmZ");

var $a4Rr2 = parcelRequire("a4Rr2");

var $9XaAY = parcelRequire("9XaAY");

var $gFdUI = parcelRequire("gFdUI");

var $gesza = parcelRequire("gesza");
const $ba3c370cecaa4137$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $ba3c370cecaa4137$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $ba3c370cecaa4137$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $ba3c370cecaa4137$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $c1tmZ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $a4Rr2.useId)();
    const onClick = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $koPKk.default)();
    const isExternal = typeof href === 'string' && $ba3c370cecaa4137$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $ba3c370cecaa4137$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $yLYo1.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $4fqPo.createElement((0, $gesza.default), {
        // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $9h99w.cx)($ba3c370cecaa4137$var$styles.root, $ba3c370cecaa4137$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $4fqPo.createElement((0, $gFdUI.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $ba3c370cecaa4137$var$Anchor = /*#__PURE__*/ (0, $4fqPo.forwardRef)($ba3c370cecaa4137$var$AnchorNoRef);
var $ba3c370cecaa4137$export$2e2bcd8739ae039 = $ba3c370cecaa4137$var$Anchor;

});
parcelRegister("koPKk", function(module, exports) {
$parcel$export(module.exports, "default", () => $25809d73ceab495b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $c7uHc = parcelRequire("c7uHc");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $25809d73ceab495b$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $4fqPo.useContext)((0, $c7uHc.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $25809d73ceab495b$export$2e2bcd8739ae039 = $25809d73ceab495b$var$useRouterLink;

});
parcelRegister("c7uHc", function(module, exports) {
$parcel$export(module.exports, "RouterLinkProviderContext", () => $0c9e6e4b9dba9274$export$2931e0ee690eee88);
$parcel$export(module.exports, "default", () => $0c9e6e4b9dba9274$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $0c9e6e4b9dba9274$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $4fqPo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $0c9e6e4b9dba9274$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0c9e6e4b9dba9274$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$0c9e6e4b9dba9274$export$2e2bcd8739ae039 = $0c9e6e4b9dba9274$var$RouterLinkProvider;

});




parcelRegister("ekURY", function(module, exports) {
$parcel$export(module.exports, "default", () => $747f52a823a4dd29$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.37.1 */ /* text.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $yLYo1 = parcelRequire("yLYo1");

var $rIiGL = parcelRequire("rIiGL");

var $5IVQv = parcelRequire("5IVQv");
const $747f52a823a4dd29$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $747f52a823a4dd29$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5IVQv.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($747f52a823a4dd29$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $747f52a823a4dd29$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $747f52a823a4dd29$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $747f52a823a4dd29$var$fontSizeMap = {
    medium: "_11c8fhey",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $747f52a823a4dd29$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $747f52a823a4dd29$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $747f52a823a4dd29$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $747f52a823a4dd29$var$Text = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $yLYo1.default)($747f52a823a4dd29$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $rIiGL.useHasTextAncestor)();
    const color = $747f52a823a4dd29$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ $4fqPo.createElement(Component, {
        id: id,
        className: (0, $ltgDR.default)([
            $747f52a823a4dd29$var$styles.root,
            size && $747f52a823a4dd29$var$fontSizeMap[size],
            color && $747f52a823a4dd29$var$textColorMap[color],
            maxLines && $747f52a823a4dd29$var$styles.truncation,
            maxLines === 1 && $747f52a823a4dd29$var$styles.breakAll,
            align && $747f52a823a4dd29$var$styles[`textAlign.${align}`],
            weight && $747f52a823a4dd29$var$fontWeightMap[weight],
            Component === 'em' && $747f52a823a4dd29$var$styles['as.em'],
            Component === 'strong' && $747f52a823a4dd29$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $4fqPo.createElement((0, $rIiGL.HasTextAncestorProvider), {
        value: true
    }, component);
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$747f52a823a4dd29$export$2e2bcd8739ae039 = $747f52a823a4dd29$var$Text;

});
parcelRegister("rIiGL", function(module, exports) {
$parcel$export(module.exports, "useHasTextAncestor", () => $6ec4f49636fbc2d5$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $6ec4f49636fbc2d5$export$ae933c6cbe5643ad);

var $4fqPo = parcelRequire("4fqPo");
const $6ec4f49636fbc2d5$var$HasTextAncestorContext = /*#__PURE__*/ (0, $4fqPo.createContext)(false);
const $6ec4f49636fbc2d5$export$9322276ec105d055 = ()=>(0, $4fqPo.useContext)($6ec4f49636fbc2d5$var$HasTextAncestorContext);
const $6ec4f49636fbc2d5$export$ae933c6cbe5643ad = $6ec4f49636fbc2d5$var$HasTextAncestorContext.Provider;

});



parcelRegister("4Otf0", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ce7ca928ba784d$export$2e2bcd8739ae039);

var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $2eKV2 = parcelRequire("2eKV2");

var $5E02Z = parcelRequire("5E02Z");
var $ekURY = parcelRequire("ekURY");

var $kRpYo = parcelRequire("kRpYo");
var $64ce7ca928ba784d$export$2e2bcd8739ae039 = ({})=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $kRpYo.default), {
        children: /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $5E02Z.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $lhXNe.jsx)((0, $2eKV2.default), {
                    size: "xsmall",
                    children: "Thanks for signing up"
                }),
                /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ekURY.default), {
                    as: "p",
                    children: "We may reach out to you in the future to participate in additional research."
                })
            ]
        })
    });

});

parcelRegister("hDv4O", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d7d2d9250e11bf3$export$2e2bcd8739ae039);
/* SurveyContainer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $21P09 = parcelRequire("21P09");

var $9RW5e = parcelRequire("9RW5e");
const $4d7d2d9250e11bf3$var$containerStyles = null;
const $4d7d2d9250e11bf3$var$buttonWrapperStyles = null;
var $4d7d2d9250e11bf3$export$2e2bcd8739ae039 = ({ children: children, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $lhXNe.jsxs)("div", {
        style: {},
        className: (0, $ltgDR.default)([
            "_2rkofajl _bfhk1bhr _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _16qs130s _1bsb1vif"
        ]),
        children: [
            /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                className: (0, $ltgDR.default)([
                    "_kqswstnw _154ipxbi _1xi2pxbi"
                ]),
                children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $21P09.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))),
                    label: "Dismiss",
                    appearance: "subtle",
                    onClick: onDismiss
                })
            }),
            children
        ]
    });
};

});

parcelRegister("2GCwA", function(module, exports) {
$parcel$export(module.exports, "default", () => $10f9b41c9937d6a7$export$2e2bcd8739ae039);
/* SurveyForm.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $kuhlf = parcelRequire("kuhlf");
var $gKFeR = parcelRequire("gKFeR");

var $2eKV2 = parcelRequire("2eKV2");

var $ivzym = parcelRequire("ivzym");

var $5E02Z = parcelRequire("5E02Z");
var $ekURY = parcelRequire("ekURY");

var $873Hb = parcelRequire("873Hb");

var $6NxPb = parcelRequire("6NxPb");
const $10f9b41c9937d6a7$var$transitionBaseStyles = null;
const $10f9b41c9937d6a7$var$TRANSITION_DURATION = 200;
var $10f9b41c9937d6a7$export$2e2bcd8739ae039 = ({ question: question, statement: statement, textPlaceholder: textPlaceholder, textLabel: textLabel, onSubmit: onSubmit })=>{
    const [expanded, setExpanded] = (0, $4fqPo.useState)(false);
    const [canContactDefault, setCanContactDefault] = (0, $4fqPo.useState)(false);
    const hasAutoFilledCanContactRef = (0, $4fqPo.useRef)(false);
    const onScoreSelect = (0, $4fqPo.useCallback)(()=>{
        setExpanded(true);
    }, [
        setExpanded
    ]);
    // On the first type the user types some feedback we auto select
    // the option for allowing feedback. This automatic selection only
    // happens once. After that it is up to the user to control
    const onFeedbackChange = (0, $4fqPo.useCallback)(()=>{
        if (hasAutoFilledCanContactRef.current) return;
        hasAutoFilledCanContactRef.current = true;
        setCanContactDefault(true);
    }, []);
    const resizingHeightProps = (0, $ivzym.useResizingHeight)({
        duration: ()=>$10f9b41c9937d6a7$var$TRANSITION_DURATION,
        timingFunction: ()=>'ease-in-out'
    });
    return /*#__PURE__*/ (0, $lhXNe.jsxs)("section", {
        "aria-labelledby": "contextualSurveyQuestion",
        children: [
            /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $5E02Z.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $2eKV2.default), {
                        id: "contextualSurveyQuestion",
                        size: "xsmall",
                        as: "h2",
                        children: question
                    }),
                    statement && /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ekURY.default), {
                        as: "p",
                        id: "contextualSurveyStatement",
                        children: statement
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $kuhlf.default), {
                onSubmit: onSubmit,
                children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $lhXNe.jsxs)("form", {
                        ...formProps,
                        children: [
                            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $gKFeR.default), {
                                name: "feedbackScore",
                                isDisabled: submitting,
                                isRequired: true,
                                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $873Hb.default), {
                                        ...fieldProps,
                                        onChange: (score)=>{
                                            fieldProps.onChange(score);
                                            onScoreSelect();
                                        }
                                    })
                            }),
                            /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                                ...resizingHeightProps,
                                className: (0, $ltgDR.default)([
                                    "_1reo15vq _18m915vq"
                                ]),
                                children: expanded ? /*#__PURE__*/ (0, $lhXNe.jsx)((0, $6NxPb.SurveyFormExpandedFeedback), {
                                    canContactDefault: canContactDefault,
                                    onFeedbackChange: onFeedbackChange,
                                    submitting: submitting,
                                    textLabel: textLabel,
                                    textPlaceholder: textPlaceholder
                                }) : null
                            })
                        ]
                    })
            })
        ]
    });
};

});
parcelRegister("kuhlf", function(module, exports) {
$parcel$export(module.exports, "default", () => $d79ffe866b0bd293$export$2e2bcd8739ae039);
/* form.tsx generated by @compiled/babel-plugin v0.37.1 */ /* form.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $5kisg = parcelRequire("5kisg");

var $hLZki = parcelRequire("hLZki");

var $4JybA = parcelRequire("4JybA");

var $jVk92 = parcelRequire("jVk92");

var $5wgou = parcelRequire("5wgou");

var $cZFZj = parcelRequire("cZFZj");

var $fk8Wg = parcelRequire("fk8Wg");

var $fM7gi = parcelRequire("fM7gi");
const $d79ffe866b0bd293$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $4fqPo.useRef)(null);
    const onSubmitRef = (0, $4fqPo.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $4fqPo.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $5kisg.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($4JybA)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($4JybA)))(values, name, value);
                    }
                }
            }
        });
        (0, $hLZki.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $fM7gi.getFirstErrorField))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $4fqPo.useState)({
        dirty: false,
        submitting: false
    });
    (0, $4fqPo.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $4fqPo.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ const getCurrentValue = (0, $4fqPo.useCallback)((name)=>{
        const formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $4fqPo.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    };
    // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $5wgou.default)([
            ref,
            formRef
        ]) : formRef
    };
    // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                resetFieldState: form.resetFieldState
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("form", {
            ...formProps,
            ...userProvidedFormProps
        }, children);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cZFZj.FormContext).Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fk8Wg.IsDisabledContext).Provider, {
        value: isDisabled
    }, childrenContent));
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $d79ffe866b0bd293$var$Form = (0, $jVk92.default)($d79ffe866b0bd293$var$FormBase);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$d79ffe866b0bd293$export$2e2bcd8739ae039 = $d79ffe866b0bd293$var$Form;

});
parcelRegister("5kisg", function(module, exports) {
$parcel$export(module.exports, "getIn", () => $3e0d22c3f545bd0a$export$c52e5867d5879e24);
$parcel$export(module.exports, "createForm", () => $3e0d22c3f545bd0a$export$f681a8129d2e9d28);

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");
//      
var $3e0d22c3f545bd0a$var$charCodeOfDot = ".".charCodeAt(0);
var $3e0d22c3f545bd0a$var$reEscapeChar = /\\(\\)?/g;
var $3e0d22c3f545bd0a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $3e0d22c3f545bd0a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $3e0d22c3f545bd0a$var$charCodeOfDot) result.push("");
    string.replace($3e0d22c3f545bd0a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($3e0d22c3f545bd0a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $3e0d22c3f545bd0a$var$keysCache = {};
var $3e0d22c3f545bd0a$var$keysRegex = /[.[\]]+/;
var $3e0d22c3f545bd0a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($3e0d22c3f545bd0a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $3e0d22c3f545bd0a$var$keysCache[key] = key.split($3e0d22c3f545bd0a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $3e0d22c3f545bd0a$var$keysCache[key] = $3e0d22c3f545bd0a$var$stringToPath(key);
    }
    return $3e0d22c3f545bd0a$var$keysCache[key];
};
//      
var $3e0d22c3f545bd0a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $3e0d22c3f545bd0a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $3e0d22c3f545bd0a$var$_toPropertyKey(arg) {
    var key = $3e0d22c3f545bd0a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $3e0d22c3f545bd0a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3e0d22c3f545bd0a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $gMtYT.default)(current, [
                key
            ].map($3e0d22c3f545bd0a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $ichJ5.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $3e0d22c3f545bd0a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $3e0d22c3f545bd0a$var$setInRecursor(state, 0, $3e0d22c3f545bd0a$var$toPath(key), value1, destroyArrays);
};
var $3e0d22c3f545bd0a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $3e0d22c3f545bd0a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $3e0d22c3f545bd0a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $3e0d22c3f545bd0a$export$c52e5867d5879e24(values, name);
    var error = $3e0d22c3f545bd0a$export$c52e5867d5879e24(errors, name);
    if (error && error[$3e0d22c3f545bd0a$export$735bebc8ffabf28a]) error = error[$3e0d22c3f545bd0a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $3e0d22c3f545bd0a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $3e0d22c3f545bd0a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($3e0d22c3f545bd0a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $3e0d22c3f545bd0a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $3e0d22c3f545bd0a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $3e0d22c3f545bd0a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$3e0d22c3f545bd0a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $3e0d22c3f545bd0a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $3e0d22c3f545bd0a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $3e0d22c3f545bd0a$var$subscriptionFilter(result, state, previousState, subscription, $3e0d22c3f545bd0a$export$41e855cb628c1b55, $3e0d22c3f545bd0a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $3e0d22c3f545bd0a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $3e0d22c3f545bd0a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $3e0d22c3f545bd0a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $3e0d22c3f545bd0a$var$subscriptionFilter(result, state, previousState, subscription, $3e0d22c3f545bd0a$export$f1ff97b9d1c7a3c3, $3e0d22c3f545bd0a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $3e0d22c3f545bd0a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$3e0d22c3f545bd0a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $3e0d22c3f545bd0a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $3e0d22c3f545bd0a$export$83d89fbfd8236492 = "4.20.10";
var $3e0d22c3f545bd0a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $3e0d22c3f545bd0a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $3e0d22c3f545bd0a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $3e0d22c3f545bd0a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $3e0d22c3f545bd0a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $3e0d22c3f545bd0a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $3e0d22c3f545bd0a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $3e0d22c3f545bd0a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($3e0d22c3f545bd0a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $3e0d22c3f545bd0a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $ichJ5.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $ichJ5.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $ichJ5.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $ichJ5.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $ichJ5.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $3e0d22c3f545bd0a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $3e0d22c3f545bd0a$export$e6bdf135a54e021b,
                    shallowEqual: $3e0d22c3f545bd0a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $ichJ5.default)({}, state.formState.values)); // clone to avoid writing
            if ($3e0d22c3f545bd0a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $3e0d22c3f545bd0a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $3e0d22c3f545bd0a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $ichJ5.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $ichJ5.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $3e0d22c3f545bd0a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $3e0d22c3f545bd0a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$3e0d22c3f545bd0a$export$735bebc8ffabf28a]) {
                    var existing = $3e0d22c3f545bd0a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$3e0d22c3f545bd0a$export$735bebc8ffabf28a] = error[$3e0d22c3f545bd0a$export$735bebc8ffabf28a];
                    merged = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$3e0d22c3f545bd0a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$3e0d22c3f545bd0a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $ichJ5.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $3e0d22c3f545bd0a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $3e0d22c3f545bd0a$var$notify(fieldSubscriber, fieldState, lastFieldState, $3e0d22c3f545bd0a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $3e0d22c3f545bd0a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $ichJ5.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.values, key), $3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.values, key), $3e0d22c3f545bd0a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$3e0d22c3f545bd0a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $3e0d22c3f545bd0a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $3e0d22c3f545bd0a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $3e0d22c3f545bd0a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $3e0d22c3f545bd0a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $3e0d22c3f545bd0a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $3e0d22c3f545bd0a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $3e0d22c3f545bd0a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $3e0d22c3f545bd0a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $3e0d22c3f545bd0a$var$notify(state.subscribers, nextFormState, lastFormState, $3e0d22c3f545bd0a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $ichJ5.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $ichJ5.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $ichJ5.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.values, key), $3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $3e0d22c3f545bd0a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $3e0d22c3f545bd0a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $3e0d22c3f545bd0a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.values, name) === $3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $3e0d22c3f545bd0a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $3e0d22c3f545bd0a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $ichJ5.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $ichJ5.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $ichJ5.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $3e0d22c3f545bd0a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$3e0d22c3f545bd0a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $ichJ5.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $3e0d22c3f545bd0a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $3e0d22c3f545bd0a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $3e0d22c3f545bd0a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $3e0d22c3f545bd0a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("hLZki", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf06659d6092b97b$export$2e2bcd8739ae039);

var $5kisg = parcelRequire("5kisg");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $cf06659d6092b97b$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $cf06659d6092b97b$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($cf06659d6092b97b$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $cf06659d6092b97b$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $5kisg.getIn)(errors, input.name);
    });
};
//      
var $cf06659d6092b97b$var$noop = function noop() {};
var $cf06659d6092b97b$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $cf06659d6092b97b$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $cf06659d6092b97b$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $cf06659d6092b97b$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $cf06659d6092b97b$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($cf06659d6092b97b$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$cf06659d6092b97b$export$2e2bcd8739ae039 = $cf06659d6092b97b$var$createDecorator;

});

parcelRegister("4JybA", function(module, exports) {

var $1MhNy = parcelRequire("1MhNy");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $3725e1fd29ce5718$var$set(object, path, value) {
    return object == null ? object : $1MhNy(object, path, value);
}
module.exports = $3725e1fd29ce5718$var$set;

});

parcelRegister("jVk92", function(module, exports) {
$parcel$export(module.exports, "default", () => $e02377d6d706f16e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e02377d6d706f16e$export$2e2bcd8739ae039 = (0, $4fqPo.forwardRef);

});

parcelRegister("cZFZj", function(module, exports) {
$parcel$export(module.exports, "FormContext", () => $6a9267970f1d3c13$export$c24727297075ec6a);

var $4fqPo = parcelRequire("4fqPo");
const $6a9267970f1d3c13$export$c24727297075ec6a = /*#__PURE__*/ (0, $4fqPo.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});

});

parcelRegister("fk8Wg", function(module, exports) {
$parcel$export(module.exports, "IsDisabledContext", () => $467026dba3546473$export$c17cf6b332a82dbc);

var $4fqPo = parcelRequire("4fqPo");
const $467026dba3546473$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $4fqPo.createContext)(false);

});

parcelRegister("fM7gi", function(module, exports) {
$parcel$export(module.exports, "getFirstErrorField", () => $f6b7372dc5a0db1d$export$fc06342dc8588d3b);

var $5kisg = parcelRequire("5kisg");
const $f6b7372dc5a0db1d$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $5kisg.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $5kisg.getIn)(errors, input.name);
    });
};

});


parcelRegister("gKFeR", function(module, exports) {
$parcel$export(module.exports, "default", () => $571d9e338acd7d45$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $c86HE = parcelRequire("c86HE");

var $6nkkA = parcelRequire("6nkkA");

var $cZFZj = parcelRequire("cZFZj");

var $gz8rg = parcelRequire("gz8rg");

var $fk8Wg = parcelRequire("fk8Wg");

var $i2DVD = parcelRequire("i2DVD");

var $haUyf = parcelRequire("haUyf");

var $eBKht = parcelRequire("eBKht");

var $exKOz = parcelRequire("exKOz");
const $571d9e338acd7d45$var$fieldWrapperStyles = null;
function $571d9e338acd7d45$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $571d9e338acd7d45$var$isFunction(x) {
    return typeof x === 'function';
}
function $571d9e338acd7d45$var$usePreviousRef(current) {
    const ref = (0, $4fqPo.useRef)(current);
    // will be updated on the next render
    (0, $4fqPo.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $571d9e338acd7d45$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $571d9e338acd7d45$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $4fqPo.useContext)((0, $cZFZj.FormContext));
    const isDisabled = (0, $4fqPo.useContext)((0, $fk8Wg.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $571d9e338acd7d45$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $571d9e338acd7d45$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$571d9e338acd7d45$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $4fqPo.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $571d9e338acd7d45$var$usePreviousRef(state);
    (0, $4fqPo.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $571d9e338acd7d45$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($571d9e338acd7d45$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        props.isRequired,
        isDefaultValueChanged
    ]);
    const uid = (0, $a4Rr2.useId)();
    const fieldId = (0, $4fqPo.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": props.testId,
        className: (0, $ltgDR.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i2DVD.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eBKht.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nkkA.FieldId).Provider, {
        value: fieldId
    }, component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, component({
        fieldProps: extendedFieldProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $haUyf.MessageWrapper), null, props.helperMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gz8rg.HelperMessage), null, props.helperMessage), state.error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c86HE.ErrorMessage), null, props.errorMessage || state.error), state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $exKOz.ValidMessage), null, props.validMessage))) : children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("c86HE", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $5609177fae1ac99f$export$915e9e7bd4f0f96d);

var $4fqPo = parcelRequire("4fqPo");

var $6nkkA = parcelRequire("6nkkA");

var $bb8F0 = parcelRequire("bb8F0");
const $5609177fae1ac99f$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nkkA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bb8F0.default), {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));

});
parcelRegister("6nkkA", function(module, exports) {
$parcel$export(module.exports, "FieldId", () => $770cdc5487716b22$export$3c4232819458a302);

var $4fqPo = parcelRequire("4fqPo");
const $770cdc5487716b22$export$3c4232819458a302 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});

parcelRegister("bb8F0", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c092ab604b2033b$export$2e2bcd8739ae039);
/* message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $geWWn = parcelRequire("geWWn");

var $3RpuA = parcelRequire("3RpuA");

var $gUzr0 = parcelRequire("gUzr0");
const $1c092ab604b2033b$var$messageStyles = null;
const $1c092ab604b2033b$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $1c092ab604b2033b$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $1c092ab604b2033b$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $1c092ab604b2033b$var$iconWrapperStyles.root
        ])
    }, children);
const $1c092ab604b2033b$var$messageIcons = {
    error: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
/**
 * __Message__
 *
 * A message component for displaying messages in a form.
 */ const $1c092ab604b2033b$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $1c092ab604b2033b$var$messageIcons[appearance];
    const messageRef = (0, $4fqPo.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $4fqPo.useState)(false);
    const { isWrapper: isWrapper } = (0, $4fqPo.useContext)((0, $gUzr0.MessageWrapperContext));
    (0, $4fqPo.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ $4fqPo.createElement("span", null, children);
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $ltgDR.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $1c092ab604b2033b$var$messageAppearanceStyles[appearance]
        ])
    }, icon && /*#__PURE__*/ $4fqPo.createElement($1c092ab604b2033b$var$IconWrapper, null, icon), content);
};
var $1c092ab604b2033b$export$2e2bcd8739ae039 = $1c092ab604b2033b$var$Message;

});
parcelRegister("gUzr0", function(module, exports) {
$parcel$export(module.exports, "MessageWrapperContext", () => $4d6d46ccc4a65179$export$579aef2c392a54d4);

var $4fqPo = parcelRequire("4fqPo");
const $4d6d46ccc4a65179$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    isWrapper: false
});

});



parcelRegister("gz8rg", function(module, exports) {
$parcel$export(module.exports, "HelperMessage", () => $06d815a98bc54a82$export$8fbe3c7d0ed2c683);

var $4fqPo = parcelRequire("4fqPo");

var $6nkkA = parcelRequire("6nkkA");

var $bb8F0 = parcelRequire("bb8F0");
const $06d815a98bc54a82$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nkkA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bb8F0.default), {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));

});

parcelRegister("i2DVD", function(module, exports) {
$parcel$export(module.exports, "Label", () => $3dc8a64083c4e6ad$export$b04be29aa201d4f5);
/* label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $3dc8a64083c4e6ad$var$fieldsetLabelStyles = null;
const $3dc8a64083c4e6ad$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ])
    }, children);

});

parcelRegister("haUyf", function(module, exports) {
$parcel$export(module.exports, "MessageWrapper", () => $cb3aa729c67b7b40$export$ec445f12f63100a5);

var $4fqPo = parcelRequire("4fqPo");

var $gUzr0 = parcelRequire("gUzr0");
const $cb3aa729c67b7b40$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gUzr0.MessageWrapperContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});

parcelRegister("eBKht", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac37c43f78d762e1$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $ac37c43f78d762e1$var$requiredIndicatorStyles = null;
function $ac37c43f78d762e1$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $ltgDR.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ])
    }, "*");
}

});

parcelRegister("exKOz", function(module, exports) {
$parcel$export(module.exports, "ValidMessage", () => $676f0e70352e1206$export$5505afb209a532c8);

var $4fqPo = parcelRequire("4fqPo");

var $6nkkA = parcelRequire("6nkkA");

var $bb8F0 = parcelRequire("bb8F0");
const $676f0e70352e1206$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nkkA.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bb8F0.default), {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));

});


parcelRegister("ivzym", function(module, exports) {
$parcel$export(module.exports, "useResizingHeight", () => $23957a1780700283$export$da99457d6430d83);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $4fqPo = parcelRequire("4fqPo");

var $5Aw5C = parcelRequire("5Aw5C");

var $cR2qL = parcelRequire("cR2qL");

var $1dGol = parcelRequire("1dGol");

var $bCKeW = parcelRequire("bCKeW");

var $lK4C3 = parcelRequire("lK4C3");

var $7RmaT = parcelRequire("7RmaT");

var $4Hk21 = parcelRequire("4Hk21");

var $fJUqt = parcelRequire("fJUqt");
const $23957a1780700283$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $cR2qL.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $5Aw5C.easeInOut) } = {})=>{
    const prevDimensions = (0, $4fqPo.useRef)();
    const [element, setElementRef] = (0, $bCKeW.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $4Hk21.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $7RmaT.useRequestAnimationFrame)();
    (0, $fJUqt.useSnapshotBeforeUpdate)(()=>{
        if ((0, $1dGol.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $lK4C3.useLayoutEffect)(()=>{
        if ((0, $1dGol.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});
parcelRegister("5Aw5C", function(module, exports) {
$parcel$export(module.exports, "easeInOut", () => $d834a9e7b3f012cd$export$c07234257a03d5e9);
$parcel$export(module.exports, "easeOut", () => $d834a9e7b3f012cd$export$57636bb43b1ccbb0);
const $d834a9e7b3f012cd$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d834a9e7b3f012cd$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d834a9e7b3f012cd$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
const $d834a9e7b3f012cd$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
const $d834a9e7b3f012cd$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
const $d834a9e7b3f012cd$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
const $d834a9e7b3f012cd$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});

parcelRegister("bCKeW", function(module, exports) {
$parcel$export(module.exports, "useElementRef", () => $ec6143219cff05b4$export$ff879f35a69d56b7);

var $4fqPo = parcelRequire("4fqPo");
const $ec6143219cff05b4$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $4fqPo.useRef)(null);
    const setRef = (0, $4fqPo.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("7RmaT", function(module, exports) {
$parcel$export(module.exports, "useRequestAnimationFrame", () => $bda55478ccc37170$export$1775f27e7c8051ca);

var $4fqPo = parcelRequire("4fqPo");
const $bda55478ccc37170$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $bda55478ccc37170$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $4fqPo.useRef)([]);
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $bda55478ccc37170$var$getHookDeps(opts));
    return (0, $4fqPo.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};

});

parcelRegister("fJUqt", function(module, exports) {
$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $357c9e4c042e2710$export$9e95200239cd148b);

var $4fqPo = parcelRequire("4fqPo");

var $lK4C3 = parcelRequire("lK4C3");
const $357c9e4c042e2710$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $4fqPo.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $lK4C3.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("873Hb", function(module, exports) {
$parcel$export(module.exports, "default", () => $93256b2d0e9a96ea$export$2e2bcd8739ae039);
/* FeedbackScoreButtons.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $d7mfg = parcelRequire("d7mfg");

var $ekURY = parcelRequire("ekURY");

var $8Mj6h = parcelRequire("8Mj6h");
const $93256b2d0e9a96ea$var$tooltipMessage = [
    'Strongly disagree',
    'Disagree',
    'Slightly disagree',
    'Neutral',
    'Slightly agree',
    'Agree',
    'Strongly agree'
];
const $93256b2d0e9a96ea$var$buttonWrapperStyles = null;
const $93256b2d0e9a96ea$var$descriptionWrapperStyles = null;
var $93256b2d0e9a96ea$export$2e2bcd8739ae039 = ({ onChange: onChange, value: value })=>/*#__PURE__*/ (0, $lhXNe.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                className: (0, $ltgDR.default)([
                    "_1e0c1txw _1bah1yb4 _zdxokb7n _v5ynkb7n _13lsf1ug _1o0a1h6o _pof3u2gc"
                ]),
                children: Array.from({
                    length: 7
                }, (_, i)=>{
                    const score = i + 1;
                    const isSelected = value === score;
                    return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $8Mj6h.default), {
                        content: $93256b2d0e9a96ea$var$tooltipMessage[i],
                        hideTooltipOnClick: true,
                        children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $d7mfg.default), {
                            onClick: ()=>onChange(score),
                            isSelected: isSelected,
                            "aria-pressed": isSelected,
                            "aria-describedby": "contextualSurveyStatement",
                            "aria-label": $93256b2d0e9a96ea$var$tooltipMessage[i],
                            shouldFitContainer: true,
                            children: score
                        })
                    }, score);
                })
            }),
            /*#__PURE__*/ (0, $lhXNe.jsxs)("div", {
                "aria-hidden": true,
                className: (0, $ltgDR.default)([
                    "_1e0c1txw _19pku2gc _otyr1ejb _1bah1yb4 _nbgx1epz"
                ]),
                children: [
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ekURY.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "start",
                        children: "Strongly disagree"
                    }),
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ekURY.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "center",
                        children: "Neutral"
                    }),
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ekURY.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        weight: "semibold",
                        align: "end",
                        children: "Strongly agree"
                    })
                ]
            })
        ]
    });

});

parcelRegister("6NxPb", function(module, exports) {
$parcel$export(module.exports, "SurveyFormExpandedFeedback", () => $c480969ee513a4ed$export$103c6e57bfbd4a99);
/* SurveyFormExpandedFeedback.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");

var $4fqPo = parcelRequire("4fqPo");

var $d7mfg = parcelRequire("d7mfg");

var $f0SW5 = parcelRequire("f0SW5");

var $1uuFp = parcelRequire("1uuFp");
var $gKFeR = parcelRequire("gKFeR");
var $d9Gpm = parcelRequire("d9Gpm");

var $1YQ0o = parcelRequire("1YQ0o");
function $c480969ee513a4ed$export$103c6e57bfbd4a99({ canContactDefault: canContactDefault, onFeedbackChange: onFeedbackChange, submitting: submitting, textLabel: textLabel, textPlaceholder: textPlaceholder }) {
    return /*#__PURE__*/ (0, $lhXNe.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $gKFeR.default), {
                name: "writtenFeedback",
                defaultValue: "",
                isDisabled: submitting,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $1YQ0o.default), {
                        ...fieldProps,
                        "aria-label": textLabel,
                        placeholder: textPlaceholder,
                        onChange: (event)=>{
                            fieldProps.onChange(event);
                            onFeedbackChange();
                        }
                    })
            }),
            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $1uuFp.default), {
                name: "canContact",
                isDisabled: submitting,
                defaultIsChecked: canContactDefault,
                children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $f0SW5.default), {
                        ...fieldProps,
                        label: "Atlassian can contact me about this feedback"
                    })
            }),
            /*#__PURE__*/ (0, $lhXNe.jsx)((0, $d9Gpm.default), {
                children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $d7mfg.default), {
                    type: "submit",
                    appearance: "primary",
                    isLoading: submitting,
                    children: "Submit"
                })
            })
        ]
    });
}

});
parcelRegister("f0SW5", function(module, exports) {
$parcel$export(module.exports, "default", () => $59b3e102ff060b2a$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4EOcq = parcelRequire("4EOcq");

var $5wgou = parcelRequire("5wgou");

var $9f3gy = parcelRequire("9f3gy");

var $9c0V7 = parcelRequire("9c0V7");

var $aYEfZ = parcelRequire("aYEfZ");

var $igQu2 = parcelRequire("igQu2");
/**
 * The input is visually hidden but remains in the DOM for accessibility.
 * State-based styling is handled by the Label component using CSS custom properties
 * that cascade to the CheckboxIcon, avoiding nested sibling selectors.
 */ const $59b3e102ff060b2a$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $59b3e102ff060b2a$var$Checkbox = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $4fqPo.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $4fqPo.useRef)(null);
    const mergedRefs = (0, $5wgou.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $4fqPo.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $4fqPo.createElement((0, $9c0V7.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $4fqPo.createElement("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            $59b3e102ff060b2a$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $4fqPo.createElement((0, $9f3gy.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $4fqPo.createElement((0, $aYEfZ.default), null, label, isRequired && /*#__PURE__*/ $4fqPo.createElement((0, $igQu2.default), null)));
}));
$59b3e102ff060b2a$var$Checkbox.displayName = 'Checkbox';
var $59b3e102ff060b2a$export$2e2bcd8739ae039 = $59b3e102ff060b2a$var$Checkbox;

});
parcelRegister("9f3gy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dede57668414009$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
/**
 * Styles for the checkbox icon.
 * CSS custom properties for colors are set by the parent Label element
 * and consumed directly in these styles.
 */ const $8dede57668414009$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $8dede57668414009$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $4fqPo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $4fqPo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $8dede57668414009$var$CheckboxIcon = /*#__PURE__*/ (0, $4fqPo.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $4fqPo.useMemo)(()=>$8dede57668414009$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $4fqPo.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $ltgDR.default)([
            $8dede57668414009$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $4fqPo.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $ltgDR.default)([
            $8dede57668414009$var$svgStyles.rect
        ])
    }), icon));
});
var $8dede57668414009$export$2e2bcd8739ae039 = $8dede57668414009$var$CheckboxIcon;

});

parcelRegister("9c0V7", function(module, exports) {
$parcel$export(module.exports, "default", () => $65e7579e7c5052cc$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
/**
 * Base state styles with CSS custom properties.
 * Pseudo-selectors (:hover, :focus-within, :active) on the label element
 * update CSS variables that cascade to the CheckboxIcon.
 * This avoids nested sibling selectors.
 *
 * Uses `css` over `cssMap` to work around a bug in Compiled types when
 * using CSS variables in pseudo-selectors.
 */ const $65e7579e7c5052cc$var$baseStyles = null;
const $65e7579e7c5052cc$var$textLabelLayoutStyles = null;
// Checked/Indeterminate state
const $65e7579e7c5052cc$var$checkedStyles = null;
// Invalid state - must override hover/active to maintain red border
const $65e7579e7c5052cc$var$invalidStyles = null;
// Disabled state - must override hover/active to maintain disabled appearance
const $65e7579e7c5052cc$var$disabledStyles = null;
// Disabled + Checked/Indeterminate
const $65e7579e7c5052cc$var$disabledCheckedStyles = null;
function $65e7579e7c5052cc$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $4fqPo.createElement("label", {
        className: (0, $ltgDR.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("aYEfZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f42c138b5d6887d$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $1f42c138b5d6887d$var$labelTextStyles = null;
function $1f42c138b5d6887d$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("igQu2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a202e3cf311a7dcc$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $a202e3cf311a7dcc$var$requiredIndicatorStyles = null;
function $a202e3cf311a7dcc$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "aria-hidden": true,
        className: (0, $ltgDR.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("1uuFp", function(module, exports) {
$parcel$export(module.exports, "default", () => $374743d18ef7b7d9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gKFeR = parcelRequire("gKFeR");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $374743d18ef7b7d9$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $4fqPo.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gKFeR.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                // Setting to any because it's typed weirdly at the field level
                onChange: (v)=>onChange(v),
                isChecked: !!fieldValue.find((v)=>v === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gKFeR.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                // Setting to any because it's typed weirdly at the field level
                onChange: (v)=>onChange(v),
                isChecked: fieldValue,
                value: value
            },
            ...others
        }));
};
var $374743d18ef7b7d9$export$2e2bcd8739ae039 = $374743d18ef7b7d9$var$CheckboxField;

});

parcelRegister("d9Gpm", function(module, exports) {
$parcel$export(module.exports, "default", () => $09bfcf894905442d$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $09bfcf894905442d$var$formFooterWrapperStyles = null;
const $09bfcf894905442d$var$justifyContentStyles = null;
function $09bfcf894905442d$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ $4fqPo.createElement("footer", {
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ])
    }, children);
}

});

parcelRegister("1YQ0o", function(module, exports) {
$parcel$export(module.exports, "default", () => $30042dfc38e3f5a1$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $3H4LK = parcelRequire("3H4LK");
const $30042dfc38e3f5a1$var$packageName = undefined;
const $30042dfc38e3f5a1$var$packageVersion = undefined;
const $30042dfc38e3f5a1$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $30042dfc38e3f5a1$var$packageName,
    packageVersion: $30042dfc38e3f5a1$var$packageVersion
};
const $30042dfc38e3f5a1$var$lineHeightBase = 20;
const $30042dfc38e3f5a1$var$lineHeightCompact = 16;
const $30042dfc38e3f5a1$var$compactVerticalPadding = 2;
const $30042dfc38e3f5a1$var$verticalPadding = 6;
const $30042dfc38e3f5a1$var$transitionDuration = '0.2s';
const $30042dfc38e3f5a1$var$borderWidth = 2;
const $30042dfc38e3f5a1$var$baseStyles = null;
const $30042dfc38e3f5a1$var$baseStylesT26Shape = null;
const $30042dfc38e3f5a1$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
};
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $30042dfc38e3f5a1$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $30042dfc38e3f5a1$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $30042dfc38e3f5a1$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $30042dfc38e3f5a1$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $30042dfc38e3f5a1$var$InnerTextArea = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const ourRef = (0, $4fqPo.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $4fqPo.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $30042dfc38e3f5a1$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$30042dfc38e3f5a1$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$30042dfc38e3f5a1$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $4fqPo.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $30042dfc38e3f5a1$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $3H4LK.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $30042dfc38e3f5a1$var$appearanceStyles[appearance],
            $30042dfc38e3f5a1$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $30042dfc38e3f5a1$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $3f61e.default)($30042dfc38e3f5a1$var$lineHeightCompact * minimumRows + $30042dfc38e3f5a1$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $3f61e.default)($30042dfc38e3f5a1$var$lineHeightBase * minimumRows + $30042dfc38e3f5a1$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $30042dfc38e3f5a1$var$TextArea = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($30042dfc38e3f5a1$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$30042dfc38e3f5a1$var$TextArea.displayName = 'TextArea';
var $30042dfc38e3f5a1$export$2e2bcd8739ae039 = $30042dfc38e3f5a1$var$TextArea;

});
parcelRegister("3f61e", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c7710ad61d0e70$export$2e2bcd8739ae039);
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $25c7710ad61d0e70$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});




parcelRegister("3mqwV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e41d42992f651e96$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $e41d42992f651e96$export$4e7f196112fea3c5 = 27;
function $e41d42992f651e96$var$bind(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function unbind() {
        target.removeEventListener(eventName, handler, options);
    };
}
function $e41d42992f651e96$var$shouldDismiss(target) {
    if (!target) return true;
    if (!(target instanceof HTMLElement)) return true;
    // Closest doesn't exist for ie11
    // Because we cannot be sure if in a text area - just don't allow dismissing
    if (!target.closest) return false;
    const inTextArea = Boolean(target.closest('textarea'));
    // Allow dismissing if not in a textarea
    return !inTextArea;
}
function $e41d42992f651e96$export$2e2bcd8739ae039({ onDismiss: onDismiss }) {
    const onDismissRef = (0, $4fqPo.useRef)(onDismiss);
    // Defensively accounting for consumer passing in a new function
    // each time. We just want to call the latest one
    (0, $4fqPo.useEffect)(()=>{
        onDismissRef.current = onDismiss;
    }, [
        onDismiss
    ]);
    (0, $4fqPo.useEffect)(()=>{
        let unbind;
        function onKeyDown(event) {
            if (event.keyCode !== $e41d42992f651e96$export$4e7f196112fea3c5) return;
            // Escape pressed
            // We don't want to close if the user is typing in the text area
            if (!$e41d42992f651e96$var$shouldDismiss(event.target)) return;
            if (unbind) // only want to call dismiss once
            unbind();
            onDismissRef.current();
        }
        unbind = $e41d42992f651e96$var$bind(window, 'keydown', // @ts-ignore: the typescript for this is lame
        onKeyDown, {
            passive: true
        });
        // double calls to unbind is fine
        return unbind;
    }, []);
}

});





parcelRegister("ifvSJ", function(module, exports) {
$parcel$export(module.exports, "FlagWithEvents", () => $d76f93c69840fde8$export$8423d11067fbf579);
$parcel$export(module.exports, "default", () => $d76f93c69840fde8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Flag", () => (parcelRequire("cQAJj")).default);
// eslint-disable-next-line import/order

var $jDrsU = parcelRequire("jDrsU");

var $bFWWU = parcelRequire("bFWWU");

var $cQAJj = parcelRequire("cQAJj");
const $d76f93c69840fde8$export$8423d11067fbf579 = (0, $jDrsU.default)((0, $cQAJj.default));
// eslint-disable-next-line camelcase
const $d76f93c69840fde8$var$_default_1 = (0, $bFWWU.default)($d76f93c69840fde8$export$8423d11067fbf579, 'flag');
var // eslint-disable-next-line camelcase
$d76f93c69840fde8$export$2e2bcd8739ae039 = $d76f93c69840fde8$var$_default_1;

});
parcelRegister("cQAJj", function(module, exports) {
$parcel$export(module.exports, "default", () => $af379440471a331b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1nPqj = parcelRequire("1nPqj");

var $edOls = parcelRequire("edOls");
var $h1mlL = parcelRequire("h1mlL");

var $itPWN = parcelRequire("itPWN");

var $kOPix = parcelRequire("kOPix");

var $hiGem = parcelRequire("hiGem");
class $af379440471a331b$export$2e2bcd8739ae039 extends (0, $4fqPo.Component) {
    static #_ = this.defaultProps = {
        fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1nPqj))),
        primaryText: null,
        primaryAction: null,
        secondaryText: null,
        secondaryAction: null,
        icon: 'smallInfo'
    };
    onClickActionHandler(action) {
        if (action && action.type === (0, $itPWN.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $hiGem.default)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h1mlL.default), {
            onDismissed: this.onDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $edOls.default), {
            id: "engagement-flag",
            appearance: "normal",
            icon: FlagIcon,
            title: title,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kOPix.default), {
                html: body
            }),
            actions: actions
        }));
    }
    constructor(...args){
        super(...args), this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        }, this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        }, this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}

});
parcelRegister("itPWN", function(module, exports) {
$parcel$export(module.exports, "buttonActionTypes", () => $a9a02f4ffb8367f8$export$e7d79186651244da);
const $a9a02f4ffb8367f8$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};

});

parcelRegister("kOPix", function(module, exports) {
$parcel$export(module.exports, "default", () => $14d38b9ad33dd770$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
class $14d38b9ad33dd770$export$2e2bcd8739ae039 extends (0, $4fqPo.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}

});

parcelRegister("hiGem", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb73eed53dea906e$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $8GUhn = parcelRequire("8GUhn");

var $fmxZJ = parcelRequire("fmxZJ");

var $dBdvS = parcelRequire("dBdvS");

var $4qDHC = parcelRequire("4qDHC");

var $geWWn = parcelRequire("geWWn");

var $bNwNQ = parcelRequire("bNwNQ");

var $klZKM = parcelRequire("klZKM");
const $cb73eed53dea906e$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($8GUhn))),
        label: 'success',
        color: "var(--ds-icon-success, #6A9A23)"
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($geWWn))),
        label: 'error',
        color: "var(--ds-icon-danger, #C9372C)"
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))),
        label: 'info',
        color: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($klZKM))),
        label: 'warning',
        color: "var(--ds-icon-warning, #E06C00)"
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))),
        label: 'info',
        color: "var(--ds-icon-discovery, #AF59E1)"
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($fmxZJ))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($dBdvS))),
        label: 'download',
        color: "var(--ds-icon, #292A2E)"
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($4qDHC))),
        label: 'comment',
        color: "var(--ds-icon, #292A2E)"
    }
};
var $cb73eed53dea906e$export$2e2bcd8739ae039 = $cb73eed53dea906e$var$flagMapping;

});
parcelRegister("8GUhn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6d66a24f642488d17115358045c30773>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $653de6d74c2a51f6$var$_react = $653de6d74c2a51f6$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $653de6d74c2a51f6$var$_baseNew = $653de6d74c2a51f6$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $653de6d74c2a51f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $653de6d74c2a51f6$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $653de6d74c2a51f6$var$_react.default.createElement($653de6d74c2a51f6$var$_baseNew.default, Object.assign({
        name: "CheckCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$653de6d74c2a51f6$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $653de6d74c2a51f6$var$_default = module.exports.default = $653de6d74c2a51f6$var$CheckCircleIcon;

});

parcelRegister("fmxZJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33181fb6c3dda951a22e3b4873cc95fe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b2f347bbe88e7972$var$_react = $b2f347bbe88e7972$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $b2f347bbe88e7972$var$_baseNew = $b2f347bbe88e7972$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $b2f347bbe88e7972$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b2f347bbe88e7972$var$CommentIcon = (props)=>/*#__PURE__*/ $b2f347bbe88e7972$var$_react.default.createElement($b2f347bbe88e7972$var$_baseNew.default, Object.assign({
        name: "CommentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$b2f347bbe88e7972$var$CommentIcon.displayName = 'CommentIcon';
var $b2f347bbe88e7972$var$_default = module.exports.default = $b2f347bbe88e7972$var$CommentIcon;

});

parcelRegister("dBdvS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::856226f5e73dfc11c44d43d912e311e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9e69367f639c67e6$var$_react = $9e69367f639c67e6$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $9e69367f639c67e6$var$_baseNew = $9e69367f639c67e6$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $9e69367f639c67e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9e69367f639c67e6$var$DownloadIcon = (props)=>/*#__PURE__*/ $9e69367f639c67e6$var$_react.default.createElement($9e69367f639c67e6$var$_baseNew.default, Object.assign({
        name: "DownloadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$9e69367f639c67e6$var$DownloadIcon.displayName = 'DownloadIcon';
var $9e69367f639c67e6$var$_default = module.exports.default = $9e69367f639c67e6$var$DownloadIcon;

});

parcelRegister("4qDHC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0442f8372c8ab0b117b1651de731ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33986335d5983e87$var$_react = $33986335d5983e87$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $33986335d5983e87$var$_baseNew = $33986335d5983e87$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $33986335d5983e87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33986335d5983e87$var$FeedbackIcon = (props)=>/*#__PURE__*/ $33986335d5983e87$var$_react.default.createElement($33986335d5983e87$var$_baseNew.default, Object.assign({
        name: "FeedbackIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$33986335d5983e87$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $33986335d5983e87$var$_default = module.exports.default = $33986335d5983e87$var$FeedbackIcon;

});




parcelRegister("hXGgU", function(module, exports) {
$parcel$export(module.exports, "ModalDialogWithEvents", () => $f6ad677144c72a1f$export$404a075b2b026e91);
$parcel$export(module.exports, "default", () => $f6ad677144c72a1f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ModalDialog", () => (parcelRequire("gCwvX")).default);
// eslint-disable-next-line import/order

var $jDrsU = parcelRequire("jDrsU");

var $bFWWU = parcelRequire("bFWWU");

var $gCwvX = parcelRequire("gCwvX");
const $f6ad677144c72a1f$export$404a075b2b026e91 = (0, $jDrsU.default)((0, $gCwvX.default));
// eslint-disable-next-line camelcase
const $f6ad677144c72a1f$var$_default_1 = (0, $bFWWU.default)($f6ad677144c72a1f$export$404a075b2b026e91, 'modalDialog');
var // eslint-disable-next-line camelcase
$f6ad677144c72a1f$export$2e2bcd8739ae039 = $f6ad677144c72a1f$var$_default_1;

});
parcelRegister("gCwvX", function(module, exports) {
$parcel$export(module.exports, "default", () => $270385b1d47d0230$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5UUZC = parcelRequire("5UUZC");

var $itPWN = parcelRequire("itPWN");

var $kOPix = parcelRequire("kOPix");
function $270385b1d47d0230$var$header() {
    return null;
}
class $270385b1d47d0230$export$2e2bcd8739ae039 extends (0, $4fqPo.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $itPWN.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $270385b1d47d0230$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5UUZC.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kOPix.default), {
            html: body
        }));
    }
    constructor(...args){
        super(...args), this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        }, this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}

});
parcelRegister("5UUZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ce0043d668bac31$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dM8x1 = parcelRequire("dM8x1");
var $9cU7i = parcelRequire("9cU7i");

var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $f2YSn = parcelRequire("f2YSn");

var $9JX4B = parcelRequire("9JX4B");

var $56UAo = parcelRequire("56UAo");
class $3ce0043d668bac31$export$2e2bcd8739ae039 extends (0, $4fqPo.Component) {
    render() {
        const { actions: _actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $f2YSn.useModal)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9JX4B.ModalHeading), {
                id: titleId
            }, heading);
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9JX4B.ModalBody), null, heading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(CustomHeader, null), children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Footer, null)));
    }
    constructor(...args){
        super(...args), this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9JX4B.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        }, this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9cU7i.default).Provider, {
                    value: (0, $56UAo.modalButtonTheme)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9JX4B.ModalActionContainer), {
                    shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                    const variant = idx ? 'subtle-link' : 'primary';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9JX4B.ModalActionItem), {
                        key: key || (typeof text === 'string' ? text : `${idx}`)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dM8x1.default), {
                        appearance: variant,
                        autoFocus: !idx,
                        ...rest
                    }, text));
                }))) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("bjlDd", function(module, exports) {
$parcel$export(module.exports, "default", () => $73a2c87afa6baf71$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $YZXKN = parcelRequire("YZXKN");
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $73a2c87afa6baf71$var$ModalWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $YZXKN.default), {
        ...props,
        isFullScreen: false,
        ref: ref
    });
});
$73a2c87afa6baf71$var$ModalWrapper.displayName = 'ModalWrapper';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$73a2c87afa6baf71$export$2e2bcd8739ae039 = $73a2c87afa6baf71$var$ModalWrapper;

});
parcelRegister("YZXKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b621798142e77562$export$2e2bcd8739ae039);
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $cjX8H = parcelRequire("cjX8H");

var $lBtjT = parcelRequire("lBtjT");

var $4EOcq = parcelRequire("4EOcq");

var $c3Vmk = parcelRequire("c3Vmk");

var $c1tmZ = parcelRequire("c1tmZ");

var $jNU2T = parcelRequire("jNU2T");

var $a4Rr2 = parcelRequire("a4Rr2");

var $hh7MV = parcelRequire("hh7MV");

var $1AxDb = parcelRequire("1AxDb");

var $6cMex = parcelRequire("6cMex");

var $eO5yD = parcelRequire("eO5yD");

var $93stz = parcelRequire("93stz");

var $3H4LK = parcelRequire("3H4LK");

var $7biT4 = parcelRequire("7biT4");
parcelRequire("aagiU");
var $3YOxy = parcelRequire("3YOxy");

var $2vWb1 = parcelRequire("2vWb1");

var $R17QT = parcelRequire("R17QT");

var $h2qC6 = parcelRequire("h2qC6");
var $krX6V = parcelRequire("krX6V");

var $cl95o = parcelRequire("cl95o");

var $gn2Jn = parcelRequire("gn2Jn");
var $g6yvD = parcelRequire("g6yvD");

var $ej19S = parcelRequire("ej19S");

var $3G850 = parcelRequire("3G850");

var $kELtn = parcelRequire("kELtn");

var $juRbr = parcelRequire("juRbr");

var $6jaFJ = parcelRequire("6jaFJ");

var $hI0hH = parcelRequire("hI0hH");

var $7A8hu = parcelRequire("7A8hu");

var $222JE = parcelRequire("222JE");
const $b621798142e77562$var$modalAnimation = (0, $R17QT.dialogMotion)();
const $b621798142e77562$var$fillScreenStyles = null;
// Visual styles for modal content inside native <dialog>.
// Uses cssMap (not css) to avoid triggering no-nested-styles lint rule.
const $b621798142e77562$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $b621798142e77562$var$topLayerStyles = {
    content: "_1e0c1txw _4t3i1osq _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _zg7p130s",
    borderRadius: "_epkxfajl",
    borderRadiusT26: "_epkxpb1k"
};
// Scroll-mode styles for the content div.
// Height overrides use ID-scoped <style> (see dialogPositionStyles) because
// Compiled atomic classes have specificity (0,1,0) (increaseSpecificity is disabled).
// The doubled-ID selector (#id#id > div) at (2,0,1) reliably wins.
// Only non-height properties needing the && boost remain here.
const $b621798142e77562$var$topLayerBodyScrollStyles = null;
const $b621798142e77562$var$topLayerViewportScrollStyles = null;
const $b621798142e77562$var$allowlistElements = (element, callback)=>{
    // Allow focus outside modal when AUI dialog is visible
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- legacy FocusLock allowlist
    if (Boolean(document.querySelector('.aui-blanket:not([hidden])'))) return false;
    // Optional callback to let consumers exclude elements from focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
const $b621798142e77562$var$InternalModalWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { autoFocus: autoFocus, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $c1tmZ.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const calculatedStackIndex = (0, $ej19S.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0;
    // If no ref is provided, autofocus on first element
    const autoFocusLock = !(typeof autoFocus === 'object');
    const onCloseHandler = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $c1tmZ.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: undefined,
        packageVersion: undefined
    });
    const onBlanketClicked = (0, $4fqPo.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // Stable callback to avoid re-renders when focusLockAllowlist is not provided.
    const allowListCallback = (0, $4fqPo.useCallback)((element)=>$b621798142e77562$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    // Called outside the feature-flag branch to keep hook order stable.
    // Legacy path: FadeIn calls onFinish. Top-layer path: called directly.
    const { isExiting: isExiting, onFinish: onExitFinish } = (0, $eO5yD.useExitingPersistence)();
    // Prevent background scroll (top-layer path uses DialogScrollLock instead).
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $3H4LK.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3G850.default)();
    // On the top-layer path, the Dialog primitive registers with the observer
    // directly, so we skip registration here to avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $3H4LK.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Always open — modal is conditionally rendered when visible.
        isOpen: true,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $c1tmZ.default)
    });
    /**
   * Top-layer path (platform-dst-top-layer).
   *
   * Replaces Portal, FocusLock, ScrollLock, Blanket, Positioner, and z-index
   * management with native <dialog> via @atlaskit/top-layer/dialog.
   *
   * Key decisions:
   * - Animation: CSS transitions via @starting-style / allow-discrete.
   * - Close gating: onDialogClose only forwards allowed reasons
   *   (see notes/guides/dialog-close-flow.md).
   * - onClose event param: undefined - consumers should use close reason.
   * - Focus restoration: native <dialog> behavior replaces react-focus-lock's
   *   returnFocus (see accessibility-criteria.md).
   */ if ((0, $3H4LK.fg)('platform-dst-top-layer')) {
        // Native <dialog> always restores focus on close - no opt-out via shouldReturnFocus.
        const defaultTestId = testId || 'modal-dialog';
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const id = (0, $a4Rr2.useId)();
        const titleId = `modal-dialog-title-${id}`;
        // Content container ref - used for onOpenComplete/onCloseComplete callbacks.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const contentRef = (0, $4fqPo.useRef)(null);
        // Cache last content element for onCloseComplete after children unmount
        // (with reduced motion, contentRef clears before onExitFinish fires).
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const lastContentElRef = (0, $4fqPo.useRef)(null);
        if (contentRef.current) lastContentElRef.current = contentRef.current;
        // Native <dialog> ref - needed for ExitingPersistence to call dialog.close().
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const dialogRef = (0, $4fqPo.useRef)(null);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const modalDialogContext = (0, $4fqPo.useMemo)(()=>({
                testId: defaultTestId,
                titleId: titleId,
                onClose: onCloseHandler,
                hasProvidedOnClose: Boolean(providedOnClose),
                isFullScreen: isFullScreen ?? false
            }), [
            defaultTestId,
            titleId,
            onCloseHandler,
            providedOnClose,
            isFullScreen
        ]);
        // Only forward close when the reason is allowed by props.
        // Passes a synthetic event to satisfy the KeyboardOrMouseEvent contract.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const onDialogClose = (0, $4fqPo.useCallback)(({ reason: reason })=>{
            if (reason === 'escape' && shouldCloseOnEscapePress) onCloseHandler((0, $h2qC6.createCloseEvent)({
                reason: reason
            }));
            if (reason === 'overlay-click' && shouldCloseOnOverlayClick) onCloseHandler((0, $h2qC6.createCloseEvent)({
                reason: reason
            }));
        }, [
            onCloseHandler,
            shouldCloseOnEscapePress,
            shouldCloseOnOverlayClick
        ]);
        // ExitingPersistence: isExiting → isOpen={false} → Dialog exit animation →
        // onExitFinish → onCloseComplete + unmount.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleDialogExitFinish = (0, $4fqPo.useCallback)(()=>{
            const el = contentRef.current ?? lastContentElRef.current;
            if (onCloseComplete && el) onCloseComplete(el);
            lastContentElRef.current = null;
            onExitFinish === null || onExitFinish === void 0 || onExitFinish();
        }, [
            onExitFinish,
            onCloseComplete
        ]);
        // Fire onOpenComplete after mount.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4fqPo.useEffect)(()=>{
            if (onOpenComplete && contentRef.current) onOpenComplete(contentRef.current, true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        // Honor `shouldReturnFocus={ref}` on unmount.
        // Native <dialog>.close() restores focus to the trigger that opened it,
        // but the consumer asked for focus to go to a specific element instead.
        // Run this in an unmount cleanup so it fires after dialog.close()
        // (which fires in the Dialog's effect cleanup).
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const shouldReturnFocusRef = (0, $4fqPo.useRef)(shouldReturnFocus);
        shouldReturnFocusRef.current = shouldReturnFocus;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4fqPo.useEffect)(()=>{
            return ()=>{
                const target = shouldReturnFocusRef.current;
                if (typeof target === 'object' && target.current) target.current.focus();
            };
        }, []);
        // Focus a ref-targeted element after mount (when autoFocus is a ref).
        // When true, native <dialog>.showModal() handles focus automatically.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jNU2T.default)(typeof autoFocus === 'object' ? autoFocus : undefined, typeof autoFocus === 'object');
        // Chrome cross-origin iframe DnD workaround (crbug.com/362301053)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4fqPo.useEffect)(()=>{
            return (0, $3YOxy.combine)((0, $kELtn.disableDraggingToCrossOriginIFramesForElement)(), (0, $6jaFJ.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $juRbr.disableDraggingToCrossOriginIFramesForExternal)());
        }, []);
        // Responsive layout via ID-scoped <style> (same pattern as Dialog's hideBackdrop).
        // ID selector beats Compiled atomic classes without !important and supports @media.
        const namedWidth = (0, $7A8hu.dialogWidth)(width ?? 'medium');
        const dialogId = `modal-dialog-${id}`;
        const escapedDialogId = CSS.escape(dialogId);
        // Percentage widths need special handling in the top layer.
        // In legacy, the percentage resolved against the Positioner's max-width
        // (100vw - 120px). In the top layer, the <dialog>'s containing block is the
        // viewport (100vw), so a raw percentage would produce a wider modal.
        // Transform e.g. '42%' → 'calc(42 * (100vw - 120px) / 100)' to match legacy.
        const resolvedWidth = namedWidth.endsWith('%') ? `calc(${parseFloat(namedWidth)} * (100vw - 120px) / 100)` : namedWidth;
        const dialogStyle = isFullScreen ? {
            width: '100vw',
            height: '100vh',
            margin: '0'
        } : {
            width: `min(${resolvedWidth}, 100vw)`
        };
        // Shift stacked background modals down by space.100 (8px) per level.
        if (stackIndex > 0) dialogStyle['transform'] = `translateY(calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"}))`;
        // Mobile: viewport fill. Desktop (≥ 30rem): gutter margins, auto height.
        // Content-div height set via #id > div to beat Compiled's atomic specificity.
        const desktopMargin = shouldScrollInViewport ? '60px auto' : '60px auto auto';
        const resolvedHeight = (0, $hI0hH.dialogHeight)(height);
        // Body-scroll: specified height or auto. Viewport-scroll: uses min-height.
        const desktopContentHeight = shouldScrollInViewport ? 'auto' : resolvedHeight;
        const desktopContentMinHeight = shouldScrollInViewport ? resolvedHeight : 'auto';
        // Viewport-scroll: the legacy Positioner was a fixed 100vh container that
        // scrolled internally, so the modal section could fill (100vh - 60px top gutter).
        // In the top layer the <dialog> sizes to content with height:auto, so we need
        // an explicit min-height to ensure the dialog stretches to the same visible area.
        const desktopDialogMinHeight = shouldScrollInViewport ? 'min-height:calc(100vh - 60px);' : '';
        // Doubled-ID selector (#id#id > div) at specificity (2,0,1) beats
        // Compiled atomic classes at (0,1,0) (increaseSpecificity is disabled).
        const dialogPositionStyles = isFullScreen ? '' : // Mobile: edge-to-edge. Desktop (≥ 30rem): 60px gutters, max-width.
        `#${escapedDialogId}#${escapedDialogId}{margin:0;height:100vh}#${escapedDialogId}#${escapedDialogId}>div{height:100%}@media(min-width:30rem){#${escapedDialogId}#${escapedDialogId}{margin:${desktopMargin};height:auto;${desktopDialogMinHeight}max-width:calc(100vw - 120px)}#${escapedDialogId}#${escapedDialogId}>div{height:${desktopContentHeight};min-height:${desktopContentMinHeight}}}`;
        return /*#__PURE__*/ $4fqPo.createElement((0, $krX6V.Dialog), {
            ref: dialogRef,
            id: dialogId,
            onClose: onDialogClose,
            onExitFinish: handleDialogExitFinish,
            animate: isFullScreen ? false : $b621798142e77562$var$modalAnimation,
            isOpen: !isExiting,
            shouldHideBackdrop: stackIndex > 0 || Boolean(isBlanketHidden),
            ...label ? {
                label: label
            } : {
                labelledBy: titleId
            },
            testId: defaultTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: dialogStyle
        }, /*#__PURE__*/ $4fqPo.createElement((0, $cl95o.DialogScrollLock), {
            isOpen: true
        }), dialogPositionStyles && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
        /*#__PURE__*/ $4fqPo.createElement("style", null, dialogPositionStyles), /*#__PURE__*/ $4fqPo.createElement("div", {
            ref: contentRef,
            className: (0, $ltgDR.default)([
                $b621798142e77562$var$topLayerStyles.content,
                !isFullScreen && $b621798142e77562$var$topLayerStyles.borderRadius,
                !isFullScreen && (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $b621798142e77562$var$topLayerStyles.borderRadiusT26,
                !isFullScreen && !shouldScrollInViewport && "_bolhzwhf",
                !isFullScreen && shouldScrollInViewport && "_1tke1kxc _c71lglyw"
            ])
        }, /*#__PURE__*/ $4fqPo.createElement((0, $gn2Jn.ModalContext).Provider, {
            value: modalDialogContext
        }, /*#__PURE__*/ $4fqPo.createElement((0, $g6yvD.ScrollContext).Provider, {
            value: shouldScrollInViewport
        }, children))));
    }
    const modalDialogWithBlanket = /*#__PURE__*/ $4fqPo.createElement((0, $c3Vmk.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`
    }, /*#__PURE__*/ $4fqPo.createElement((0, $222JE.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen,
        UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift,
        ref: ref
    }, children));
    let returnFocus = true;
    let onDeactivation = (0, $c1tmZ.default);
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $hh7MV.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7biT4.default), {
        zIndex: (0, $2vWb1.layers).modal()
    }, !UNSAFE_shouldDisableMotionUplift && (0, $3H4LK.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $4fqPo.createElement((0, $6cMex.default), {
        enteringAnimation: "var(--ds-blanket-enter, 250ms cubic-bezier(0.4, 0, 0, 1) FadeIn0to100)",
        exitingAnimation: "var(--ds-blanket-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        "aria-hidden": !isForeground,
        className: (0, $ltgDR.default)([
            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $cjX8H.default), {
        autoFocus: autoFocusLock,
        returnFocus: returnFocus,
        onDeactivation: onDeactivation,
        whiteList: allowListCallback
    }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBtjT))), null), shouldScrollInViewport ? /*#__PURE__*/ $4fqPo.createElement((0, $lBtjT.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket))) : /*#__PURE__*/ $4fqPo.createElement((0, $93stz.default), null, (fadeInProps)=>/*#__PURE__*/ $4fqPo.createElement("div", {
            ...fadeInProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $ltgDR.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }, /*#__PURE__*/ $4fqPo.createElement((0, $cjX8H.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBtjT))), null), shouldScrollInViewport ? /*#__PURE__*/ $4fqPo.createElement((0, $lBtjT.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket)))));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b621798142e77562$export$2e2bcd8739ae039 = $b621798142e77562$var$InternalModalWrapper;

});
parcelRegister("cjX8H", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f8522383e2af5f1$export$2e2bcd8739ae039);

var $2PcVr = parcelRequire("2PcVr");

var $8f8522383e2af5f1$export$2e2bcd8739ae039 = (0, $2PcVr.default);

});
parcelRegister("2PcVr", function(module, exports) {
$parcel$export(module.exports, "default", () => $20ea5ee9152b28ae$export$2e2bcd8739ae039);

var $gMtYT = parcelRequire("gMtYT");

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");

var $3B69p = parcelRequire("3B69p");

var $2az7L = parcelRequire("2az7L");
var $20ea5ee9152b28ae$var$FocusLockCombination = /*#__PURE__*/ $4fqPo.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $4fqPo.createElement((0, $3B69p.default), (0, $ichJ5.default)({
        sideCar: (0, $2az7L.default),
        ref: ref
    }, props));
});
var $20ea5ee9152b28ae$var$_ref = (0, $3B69p.default).propTypes || {}, $20ea5ee9152b28ae$var$sideCar = $20ea5ee9152b28ae$var$_ref.sideCar, $20ea5ee9152b28ae$var$propTypes = (0, $gMtYT.default)($20ea5ee9152b28ae$var$_ref, [
    "sideCar"
]);
$20ea5ee9152b28ae$var$FocusLockCombination.propTypes = {};
var $20ea5ee9152b28ae$export$2e2bcd8739ae039 = $20ea5ee9152b28ae$var$FocusLockCombination;

});
parcelRegister("3B69p", function(module, exports) {
$parcel$export(module.exports, "default", () => $29e99933f6b37732$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");


var $e1K3J = parcelRequire("e1K3J");

var $1H5vR = parcelRequire("1H5vR");

var $9lNSr = parcelRequire("9lNSr");

var $dW6P6 = parcelRequire("dW6P6");

var $7VjAg = parcelRequire("7VjAg");
var $29e99933f6b37732$var$emptyArray = [];
var $29e99933f6b37732$var$FocusLock = /*#__PURE__*/ $4fqPo.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $4fqPo.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $4fqPo.useRef();
    var isActive = $4fqPo.useRef(false);
    var originalFocusedElement = $4fqPo.useRef(null);
    var _React$useState2 = $4fqPo.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $29e99933f6b37732$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $4fqPo.useState({}), id = _React$useState3[0];
    var onActivation = $4fqPo.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $4fqPo.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $4fqPo.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $4fqPo.useCallback(function(event) {
        if (isActive.current) (0, $dW6P6.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $dW6P6.mediumBlur).useMedium;
    var setObserveNode = $4fqPo.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $ichJ5.default)((_extends2 = {}, _extends2[$e1K3J.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$e1K3J.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $1H5vR.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $4fqPo.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $4fqPo.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $9lNSr.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $4fqPo.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $9lNSr.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $4fqPo.createElement(SideCar, {
        id: id,
        sideCar: (0, $dW6P6.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $4fqPo.createElement(Container, (0, $ichJ5.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $4fqPo.createElement((0, $7VjAg.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $9lNSr.hiddenGuard)
    }));
});
$29e99933f6b37732$var$FocusLock.propTypes = {};
var $29e99933f6b37732$export$2e2bcd8739ae039 = $29e99933f6b37732$var$FocusLock;

});
parcelRegister("e1K3J", function(module, exports) {
$parcel$export(module.exports, "FOCUS_GROUP", () => $a364e30e1d2f67ae$export$4f9a06cb7441a087);
$parcel$export(module.exports, "FOCUS_DISABLED", () => $a364e30e1d2f67ae$export$aeda8252e54b50f7);
$parcel$export(module.exports, "FOCUS_ALLOW", () => $a364e30e1d2f67ae$export$54ecf528c58f9ef6);
$parcel$export(module.exports, "FOCUS_AUTO", () => $a364e30e1d2f67ae$export$70e9b4a1820af101);
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", () => $a364e30e1d2f67ae$export$134ebef29fd94853);
/**
 * defines a focus group
 */ var $a364e30e1d2f67ae$export$4f9a06cb7441a087 = 'data-focus-lock';
var $a364e30e1d2f67ae$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $a364e30e1d2f67ae$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $a364e30e1d2f67ae$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $a364e30e1d2f67ae$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("1H5vR", function(module, exports) {
$parcel$export(module.exports, "useMergeRefs", () => $13be155821a727a0$export$74665b213cb5c4cf);

var $4fqPo = parcelRequire("4fqPo");

var $1t0vW = parcelRequire("1t0vW");

var $7l1h2 = parcelRequire("7l1h2");
var $13be155821a727a0$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $4fqPo.useLayoutEffect : $4fqPo.useEffect;
var $13be155821a727a0$var$currentValues = new WeakMap();
function $13be155821a727a0$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $7l1h2.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $1t0vW.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $13be155821a727a0$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $13be155821a727a0$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $1t0vW.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $1t0vW.assignRef)(ref, current_1);
            });
        }
        $13be155821a727a0$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("1t0vW", function(module, exports) {
$parcel$export(module.exports, "assignRef", () => $1118e600ffc0d579$export$d734136a7b018efe);
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $1118e600ffc0d579$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("7l1h2", function(module, exports) {
$parcel$export(module.exports, "useCallbackRef", () => $557b7b8442e1cf82$export$25bec8c6f54ee79a);

var $4fqPo = parcelRequire("4fqPo");
function $557b7b8442e1cf82$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $4fqPo.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("9lNSr", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $6cecc3ca05d6d218$export$b8c7b07253306600);

var $4fqPo = parcelRequire("4fqPo");

var $6cecc3ca05d6d218$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $6cecc3ca05d6d218$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $6cecc3ca05d6d218$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $4fqPo.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $6cecc3ca05d6d218$export$b8c7b07253306600
    }));
};
$6cecc3ca05d6d218$var$InFocusGuard.propTypes = {};
var $6cecc3ca05d6d218$export$2e2bcd8739ae039 = $6cecc3ca05d6d218$var$InFocusGuard;

});

parcelRegister("dW6P6", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $a255fc16bddbdc88$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $a255fc16bddbdc88$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $a255fc16bddbdc88$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $a255fc16bddbdc88$export$892cbf28e5518020);

var $2dWkr = parcelRequire("2dWkr");
var $a255fc16bddbdc88$export$5733e022b1d538cb = (0, $2dWkr.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $a255fc16bddbdc88$export$b3e9a9312f73723c = (0, $2dWkr.createMedium)();
var $a255fc16bddbdc88$export$3a1d52767cbc07b8 = (0, $2dWkr.createMedium)();
var $a255fc16bddbdc88$export$892cbf28e5518020 = (0, $2dWkr.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("2dWkr", function(module, exports) {
$parcel$export(module.exports, "createMedium", () => $19ea0a862ba70110$export$9ffbfcaf067b02c6);
$parcel$export(module.exports, "createSidecarMedium", () => $19ea0a862ba70110$export$e13ec7dd7a14088d);

var $d8KcD = parcelRequire("d8KcD");
function $19ea0a862ba70110$var$ItoI(a) {
    return a;
}
function $19ea0a862ba70110$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $19ea0a862ba70110$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $19ea0a862ba70110$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $19ea0a862ba70110$var$ItoI;
    return $19ea0a862ba70110$var$innerCreateMedium(defaults, middleware);
}
function $19ea0a862ba70110$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $19ea0a862ba70110$var$innerCreateMedium(null);
    medium.options = (0, $d8KcD.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("7VjAg", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $5c4d0c34b3485782$export$f5272e9b1168239c);

var $4fqPo = parcelRequire("4fqPo");
var $5c4d0c34b3485782$export$f5272e9b1168239c = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});


parcelRegister("2az7L", function(module, exports) {
$parcel$export(module.exports, "default", () => $1947c2e6b8c07da4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");


var $kQT2v = parcelRequire("kQT2v");

var $jru52 = parcelRequire("jru52");
var $i8raH = parcelRequire("i8raH");
var $1rq2e = parcelRequire("1rq2e");
var $7eGB7 = parcelRequire("7eGB7");
var $10HpC = parcelRequire("10HpC");parcelRequire("cocEi");
var $9Iexm = parcelRequire("9Iexm");

var $aQ9sX = parcelRequire("aQ9sX");

var $dW6P6 = parcelRequire("dW6P6");
var $1947c2e6b8c07da4$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $1947c2e6b8c07da4$var$isFreeFocus = function isFreeFocus() {
    return $1947c2e6b8c07da4$var$focusOnBody() || (0, $10HpC.focusIsHidden)();
};
var $1947c2e6b8c07da4$var$lastActiveTrap = null;
var $1947c2e6b8c07da4$var$lastActiveFocus = null;
var $1947c2e6b8c07da4$var$lastPortaledElement = null;
var $1947c2e6b8c07da4$var$focusWasOutsideWindow = false;
var $1947c2e6b8c07da4$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $1947c2e6b8c07da4$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($1947c2e6b8c07da4$var$lastActiveTrap.whiteList || $1947c2e6b8c07da4$var$defaultWhitelist)(activeElement);
};
var $1947c2e6b8c07da4$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $1947c2e6b8c07da4$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $1947c2e6b8c07da4$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $1947c2e6b8c07da4$var$lastPortaledElement && $1947c2e6b8c07da4$var$lastPortaledElement.portaledElement === element;
};
function $1947c2e6b8c07da4$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $1947c2e6b8c07da4$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($1947c2e6b8c07da4$var$focusWasOutsideWindow);
    return $1947c2e6b8c07da4$var$focusWasOutsideWindow === 'meanwhile';
};
var $1947c2e6b8c07da4$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $1947c2e6b8c07da4$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $1947c2e6b8c07da4$var$checkInHost(activeElement, area, area);
    });
};
var $1947c2e6b8c07da4$var$activateTrap = function activateTrap() {
    var result = false;
    if ($1947c2e6b8c07da4$var$lastActiveTrap) {
        var _lastActiveTrap = $1947c2e6b8c07da4$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $1947c2e6b8c07da4$var$lastPortaledElement && $1947c2e6b8c07da4$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $aQ9sX.extractRef)).filter(Boolean));
            if (!activeElement || $1947c2e6b8c07da4$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $1947c2e6b8c07da4$var$focusWasOutside(crossFrame) || !$1947c2e6b8c07da4$var$isFreeFocus() || !$1947c2e6b8c07da4$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $7eGB7.focusInside)(workingArea) || activeElement && $1947c2e6b8c07da4$var$withinHost(activeElement, workingArea) || $1947c2e6b8c07da4$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$1947c2e6b8c07da4$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9Iexm.moveFocusInside)(workingArea, $1947c2e6b8c07da4$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $1947c2e6b8c07da4$var$lastPortaledElement = {};
                        }
                    }
                    $1947c2e6b8c07da4$var$focusWasOutsideWindow = false;
                    $1947c2e6b8c07da4$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $i8raH.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $1947c2e6b8c07da4$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $1947c2e6b8c07da4$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $1947c2e6b8c07da4$var$onTrap = function onTrap(event) {
    if ($1947c2e6b8c07da4$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $1947c2e6b8c07da4$var$onBlur = function onBlur() {
    return (0, $aQ9sX.deferAction)($1947c2e6b8c07da4$var$activateTrap);
};
var $1947c2e6b8c07da4$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $1947c2e6b8c07da4$var$recordPortal(currentNode, source);
};
var $1947c2e6b8c07da4$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $1947c2e6b8c07da4$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        onBlur: $1947c2e6b8c07da4$var$onBlur,
        onFocus: $1947c2e6b8c07da4$var$onFocus
    }, children);
};
$1947c2e6b8c07da4$var$FocusTrap.propTypes = {};
var $1947c2e6b8c07da4$var$onWindowBlur = function onWindowBlur() {
    $1947c2e6b8c07da4$var$focusWasOutsideWindow = 'just';
    (0, $aQ9sX.deferAction)(function() {
        $1947c2e6b8c07da4$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $1947c2e6b8c07da4$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $1947c2e6b8c07da4$var$onTrap);
    document.addEventListener('focusout', $1947c2e6b8c07da4$var$onBlur);
    window.addEventListener('blur', $1947c2e6b8c07da4$var$onWindowBlur);
};
var $1947c2e6b8c07da4$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $1947c2e6b8c07da4$var$onTrap);
    document.removeEventListener('focusout', $1947c2e6b8c07da4$var$onBlur);
    window.removeEventListener('blur', $1947c2e6b8c07da4$var$onWindowBlur);
};
function $1947c2e6b8c07da4$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $1947c2e6b8c07da4$var$focusLockAPI = {
    moveFocusInside: (0, $9Iexm.moveFocusInside),
    focusInside: (0, $7eGB7.focusInside),
    focusNextElement: (0, $1rq2e.focusNextElement),
    focusPrevElement: (0, $1rq2e.focusPrevElement),
    focusFirstElement: (0, $1rq2e.focusFirstElement),
    focusLastElement: (0, $1rq2e.focusLastElement),
    captureFocusRestore: (0, $jru52.captureFocusRestore)
};
function $1947c2e6b8c07da4$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$1947c2e6b8c07da4$var$lastActiveTrap) $1947c2e6b8c07da4$var$attachHandler();
    var lastTrap = $1947c2e6b8c07da4$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $1947c2e6b8c07da4$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $1947c2e6b8c07da4$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($1947c2e6b8c07da4$var$focusLockAPI);
        $1947c2e6b8c07da4$var$activateTrap(true);
        (0, $aQ9sX.deferAction)($1947c2e6b8c07da4$var$activateTrap);
    } else {
        $1947c2e6b8c07da4$var$detachHandler();
        $1947c2e6b8c07da4$var$lastActiveFocus = null;
    }
}
(0, $dW6P6.mediumFocus).assignSyncMedium($1947c2e6b8c07da4$var$onFocus);
(0, $dW6P6.mediumBlur).assignMedium($1947c2e6b8c07da4$var$onBlur);
(0, $dW6P6.mediumEffect).assignMedium(function(cb) {
    return cb($1947c2e6b8c07da4$var$focusLockAPI);
});
var $1947c2e6b8c07da4$export$2e2bcd8739ae039 = (0, $kQT2v.default)($1947c2e6b8c07da4$var$reducePropsToState, $1947c2e6b8c07da4$var$handleStateChangeOnClient)($1947c2e6b8c07da4$var$FocusWatcher);

});
parcelRegister("kQT2v", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2e35ba414747ebb$export$2e2bcd8739ae039);

var $dDznA = parcelRequire("dDznA");

var $6YQ3e = parcelRequire("6YQ3e");

var $4fqPo = parcelRequire("4fqPo");
function $f2e35ba414747ebb$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $dDznA.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $4fqPo.PureComponent));
        (0, $6YQ3e.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $f2e35ba414747ebb$export$2e2bcd8739ae039 = $f2e35ba414747ebb$var$withSideEffect;

});

parcelRegister("jru52", function(module, exports) {
$parcel$export(module.exports, "captureFocusRestore", () => $e277df3b49cd9ed8$export$d357db6e554ff59a);

var $4PCwQ = parcelRequire("4PCwQ");
function $e277df3b49cd9ed8$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $e277df3b49cd9ed8$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $e277df3b49cd9ed8$var$weakRef(currentElement),
            parent: $e277df3b49cd9ed8$var$weakRef(currentElement.parentElement),
            left: $e277df3b49cd9ed8$var$weakRef(currentElement.previousElementSibling),
            right: $e277df3b49cd9ed8$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $e277df3b49cd9ed8$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $e277df3b49cd9ed8$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $4PCwQ.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $e277df3b49cd9ed8$export$d357db6e554ff59a = function(targetElement) {
    var location = $e277df3b49cd9ed8$export$5061a7725be48ff9(targetElement);
    return function() {
        return $e277df3b49cd9ed8$var$restoreFocusTo(location);
    };
};

});
parcelRegister("4PCwQ", function(module, exports) {
$parcel$export(module.exports, "filterAutoFocusable", () => $3849cfde40fe2407$export$2f70373d403a5d2b);
$parcel$export(module.exports, "getTabbableNodes", () => $3849cfde40fe2407$export$3738e313571e2ad2);
$parcel$export(module.exports, "getFocusableNodes", () => $3849cfde40fe2407$export$493d05a3a8e6532d);
$parcel$export(module.exports, "parentAutofocusables", () => $3849cfde40fe2407$export$dc26309a71d1ce47);
$parcel$export(module.exports, "contains", () => $3849cfde40fe2407$export$2344b14b097df817);

var $67EIG = parcelRequire("67EIG");

var $kkBne = parcelRequire("kkBne");

var $h6gGB = parcelRequire("h6gGB");

var $5J8L4 = parcelRequire("5J8L4");
var $3849cfde40fe2407$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $67EIG.toArray)(nodes).filter(function(node) {
        return (0, $kkBne.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $kkBne.notHiddenInput)(node);
    });
};
var $3849cfde40fe2407$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $67EIG.toArray)(nodes).filter(function(node) {
        return (0, $kkBne.isAutoFocusAllowedCached)(cache, node);
    });
};
var $3849cfde40fe2407$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $h6gGB.orderByTabIndex)($3849cfde40fe2407$export$6266a5cd5915dc33((0, $5J8L4.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $3849cfde40fe2407$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $h6gGB.orderByTabIndex)($3849cfde40fe2407$export$6266a5cd5915dc33((0, $5J8L4.getFocusables)(topNodes), visibilityCache), false);
};
var $3849cfde40fe2407$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $3849cfde40fe2407$export$6266a5cd5915dc33((0, $5J8L4.getParentAutofocusables)(topNode), visibilityCache);
};
var $3849cfde40fe2407$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $3849cfde40fe2407$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $67EIG.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $3849cfde40fe2407$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $3849cfde40fe2407$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("67EIG", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $4752fba19dec656f$export$45b10814cc054894);
$parcel$export(module.exports, "asArray", () => $4752fba19dec656f$export$75093a47a9fa838d);
$parcel$export(module.exports, "getFirst", () => $4752fba19dec656f$export$bcd7afcd904dce14);
/*
IE11 support
 */ var $4752fba19dec656f$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $4752fba19dec656f$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $4752fba19dec656f$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("kkBne", function(module, exports) {
$parcel$export(module.exports, "isVisibleCached", () => $ecd2aa8b15a621de$export$3c9dc299685ad160);
$parcel$export(module.exports, "isAutoFocusAllowedCached", () => $ecd2aa8b15a621de$export$bcaa50628f6a736e);
$parcel$export(module.exports, "getDataset", () => $ecd2aa8b15a621de$export$698b339b0c8edae3);
$parcel$export(module.exports, "isRadioElement", () => $ecd2aa8b15a621de$export$9d74f6fbc6f469d0);
$parcel$export(module.exports, "notHiddenInput", () => $ecd2aa8b15a621de$export$8197b0ea56b3b055);
$parcel$export(module.exports, "isGuard", () => $ecd2aa8b15a621de$export$d94b8b58ec2f30eb);
$parcel$export(module.exports, "isNotAGuard", () => $ecd2aa8b15a621de$export$602e5a0d338d7750);
$parcel$export(module.exports, "isDefined", () => $ecd2aa8b15a621de$export$4e62c701997796c1);

var $e1K3J = parcelRequire("e1K3J");
var $ecd2aa8b15a621de$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $ecd2aa8b15a621de$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $ecd2aa8b15a621de$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $ecd2aa8b15a621de$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $ecd2aa8b15a621de$var$isVisibleUncached = function(node, checkParent) {
    return !node || $ecd2aa8b15a621de$var$isTopNode(node) || !$ecd2aa8b15a621de$var$isElementHidden(node) && !$ecd2aa8b15a621de$var$isInert(node) && checkParent($ecd2aa8b15a621de$var$getParentNode(node));
};
var $ecd2aa8b15a621de$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $ecd2aa8b15a621de$var$isVisibleUncached(node, $ecd2aa8b15a621de$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $ecd2aa8b15a621de$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$ecd2aa8b15a621de$var$isTopNode(node) ? $ecd2aa8b15a621de$export$b8550e27de209d85(node) ? checkParent($ecd2aa8b15a621de$var$getParentNode(node)) : false : true;
};
var $ecd2aa8b15a621de$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $ecd2aa8b15a621de$var$isAutoFocusAllowedUncached(node, $ecd2aa8b15a621de$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $ecd2aa8b15a621de$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $ecd2aa8b15a621de$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $ecd2aa8b15a621de$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $ecd2aa8b15a621de$export$9d74f6fbc6f469d0 = function(node) {
    return $ecd2aa8b15a621de$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $ecd2aa8b15a621de$export$8197b0ea56b3b055 = function(node) {
    return !(($ecd2aa8b15a621de$export$88a6ceeed5737ba3(node) || $ecd2aa8b15a621de$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $ecd2aa8b15a621de$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $e1K3J.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $ecd2aa8b15a621de$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $ecd2aa8b15a621de$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $ecd2aa8b15a621de$export$602e5a0d338d7750 = function(node) {
    return !$ecd2aa8b15a621de$export$d94b8b58ec2f30eb(node);
};
var $ecd2aa8b15a621de$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("h6gGB", function(module, exports) {
$parcel$export(module.exports, "orderByTabIndex", () => $c72ff0b8aed93b66$export$cb40ee071f0d5226);

var $67EIG = parcelRequire("67EIG");
var $c72ff0b8aed93b66$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $c72ff0b8aed93b66$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $c72ff0b8aed93b66$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $67EIG.toArray)(nodes).map(function(node, index) {
        var tabIndex = $c72ff0b8aed93b66$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($c72ff0b8aed93b66$export$350ee6c095d98996);
};

});

parcelRegister("5J8L4", function(module, exports) {
$parcel$export(module.exports, "getFocusables", () => $42b7f2e6ee603470$export$f6768025e418420e);
$parcel$export(module.exports, "getParentAutofocusables", () => $42b7f2e6ee603470$export$853fa94d922e78b9);

var $e1K3J = parcelRequire("e1K3J");

var $67EIG = parcelRequire("67EIG");

var $gFfa3 = parcelRequire("gFfa3");
var $42b7f2e6ee603470$var$queryTabbables = (0, $gFfa3.tabbables).join(',');
var $42b7f2e6ee603470$var$queryGuardTabbables = "".concat($42b7f2e6ee603470$var$queryTabbables, ", [data-focus-guard]");
var $42b7f2e6ee603470$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $67EIG.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $42b7f2e6ee603470$var$queryGuardTabbables : $42b7f2e6ee603470$var$queryTabbables) ? [
            child
        ] : [], $42b7f2e6ee603470$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $42b7f2e6ee603470$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $42b7f2e6ee603470$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $42b7f2e6ee603470$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $42b7f2e6ee603470$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $42b7f2e6ee603470$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $67EIG.toArray)(parent.parentNode.querySelectorAll($42b7f2e6ee603470$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $42b7f2e6ee603470$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $e1K3J.FOCUS_AUTO), "]"));
    return (0, $67EIG.toArray)(parentFocus).map(function(node) {
        return $42b7f2e6ee603470$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("gFfa3", function(module, exports) {
$parcel$export(module.exports, "tabbables", () => $c21c3c64fba577b6$export$8555f4622e95784);
/**
 * list of the object to be considered as focusable
 */ var $c21c3c64fba577b6$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("i8raH", function(module, exports) {
$parcel$export(module.exports, "expandFocusableNodes", () => $03683a044fd28c4e$export$f89ac71e91767111);

var $kYPzi = parcelRequire("kYPzi");

var $kkBne = parcelRequire("kkBne");

var $hd7k3 = parcelRequire("hd7k3");

var $h6gGB = parcelRequire("h6gGB");

var $5J8L4 = parcelRequire("5J8L4");
var $03683a044fd28c4e$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $kYPzi.getAllAffectedNodes)(topNode).filter((0, $kkBne.isNotAGuard));
    var commonParent = (0, $hd7k3.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $h6gGB.orderByTabIndex)((0, $5J8L4.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $5J8L4.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $kkBne.isGuard)(node)
        };
    });
};

});
parcelRegister("kYPzi", function(module, exports) {
$parcel$export(module.exports, "getAllAffectedNodes", () => $f46169a6d3df659b$export$7e87c4720b9b279b);

var $e1K3J = parcelRequire("e1K3J");

var $67EIG = parcelRequire("67EIG");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $f46169a6d3df659b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $f46169a6d3df659b$var$getTopParent = function(node) {
    return node.parentNode ? $f46169a6d3df659b$var$getTopParent(node.parentNode) : node;
};
var $f46169a6d3df659b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $67EIG.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $e1K3J.FOCUS_GROUP));
        acc.push.apply(acc, group ? $f46169a6d3df659b$var$filterNested((0, $67EIG.toArray)($f46169a6d3df659b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $e1K3J.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $e1K3J.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("hd7k3", function(module, exports) {
$parcel$export(module.exports, "getTopCommonParent", () => $c87954a13d07ff5c$export$a9a7252b5f2e280e);
$parcel$export(module.exports, "allParentAutofocusables", () => $c87954a13d07ff5c$export$8f99714c70a37db1);

var $4PCwQ = parcelRequire("4PCwQ");

var $67EIG = parcelRequire("67EIG");
var $c87954a13d07ff5c$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $c87954a13d07ff5c$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $c87954a13d07ff5c$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $c87954a13d07ff5c$var$getParents(nodeA);
    var parentsB = $c87954a13d07ff5c$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $c87954a13d07ff5c$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $67EIG.asArray)(baseActiveElement);
    var leftEntries = (0, $67EIG.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $c87954a13d07ff5c$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $c87954a13d07ff5c$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $4PCwQ.contains)(common, topCommon)) topCommon = common;
                else topCommon = $c87954a13d07ff5c$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $c87954a13d07ff5c$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $4PCwQ.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("1rq2e", function(module, exports) {
$parcel$export(module.exports, "focusNextElement", () => $10cc82169d9412f7$export$3b0237e8566c8d65);
$parcel$export(module.exports, "focusPrevElement", () => $10cc82169d9412f7$export$33b47db07a82b2fb);
$parcel$export(module.exports, "focusFirstElement", () => $10cc82169d9412f7$export$2a791d8097a66406);
$parcel$export(module.exports, "focusLastElement", () => $10cc82169d9412f7$export$6a79073ddabfd6c3);

var $7kW2E = parcelRequire("7kW2E");

var $4PCwQ = parcelRequire("4PCwQ");

var $67EIG = parcelRequire("67EIG");
var $10cc82169d9412f7$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $67EIG.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $4PCwQ.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $4PCwQ.getTabbableNodes)(shards, new Map()) : (0, $4PCwQ.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $10cc82169d9412f7$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $4PCwQ.getTabbableNodes)((0, $67EIG.asArray)(shards), new Map()) : (0, $4PCwQ.getFocusableNodes)((0, $67EIG.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $10cc82169d9412f7$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $10cc82169d9412f7$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $10cc82169d9412f7$var$defaultOptions(options);
    var solution = $10cc82169d9412f7$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $7kW2E.focusOn)(target.node, newOptions.focusOptions);
};
var $10cc82169d9412f7$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $10cc82169d9412f7$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $10cc82169d9412f7$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $10cc82169d9412f7$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $10cc82169d9412f7$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $10cc82169d9412f7$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $7kW2E.focusOn)(node.node, options.focusOptions);
};
var $10cc82169d9412f7$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $10cc82169d9412f7$var$pickBoundary(scope, options, 'first');
};
var $10cc82169d9412f7$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $10cc82169d9412f7$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("7kW2E", function(module, exports) {
$parcel$export(module.exports, "focusOn", () => $55776c88e7067448$export$c12b3da842c43a8);
var $55776c88e7067448$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("7eGB7", function(module, exports) {
$parcel$export(module.exports, "focusInside", () => $544ae236e2e62c51$export$20115f8da7baa6fa);

var $4PCwQ = parcelRequire("4PCwQ");

var $kYPzi = parcelRequire("kYPzi");

var $67EIG = parcelRequire("67EIG");

var $CjaNl = parcelRequire("CjaNl");
var $544ae236e2e62c51$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $544ae236e2e62c51$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $67EIG.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $544ae236e2e62c51$var$focusInFrame(node, activeElement);
    }));
};
var $544ae236e2e62c51$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $CjaNl.getActiveElement)((0, $67EIG.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $kYPzi.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $4PCwQ.contains)(node, activeElement) || $544ae236e2e62c51$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("CjaNl", function(module, exports) {
$parcel$export(module.exports, "getActiveElement", () => $07326c1ae911af0d$export$cd4e5573fbe2b576);
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $2aSzV = parcelRequire("2aSzV");
var $07326c1ae911af0d$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $07326c1ae911af0d$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $2aSzV.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $07326c1ae911af0d$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("2aSzV", function(module, exports) {
$parcel$export(module.exports, "safeProbe", () => $1956da13b6567ce5$export$78d20aae35adef88);
var $1956da13b6567ce5$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("10HpC", function(module, exports) {
$parcel$export(module.exports, "focusIsHidden", () => $0bc7774b8bdb9306$export$be6b21806d3fd485);

var $e1K3J = parcelRequire("e1K3J");

var $4PCwQ = parcelRequire("4PCwQ");

var $67EIG = parcelRequire("67EIG");

var $CjaNl = parcelRequire("CjaNl");
var $0bc7774b8bdb9306$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $CjaNl.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $67EIG.toArray)(inDocument.querySelectorAll("[".concat((0, $e1K3J.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $4PCwQ.contains)(node, activeElement);
    });
};

});

parcelRegister("cocEi", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => (parcelRequire("9Iexm")).moveFocusInside);

var $e1K3J = parcelRequire("e1K3J");

var $7eGB7 = parcelRequire("7eGB7");

var $10HpC = parcelRequire("10HpC");


var $i8raH = parcelRequire("i8raH");

var $9Iexm = parcelRequire("9Iexm");

var $jru52 = parcelRequire("jru52");

var $1rq2e = parcelRequire("1rq2e");

var $4PCwQ = parcelRequire("4PCwQ");
/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $905189c18d4a1797$export$1a988e7317c65621 = $e1K3J;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $905189c18d4a1797$var$deprecated_default_moveFocusInside = (0, $9Iexm.moveFocusInside);
var $905189c18d4a1797$export$2e2bcd8739ae039 //
 = $905189c18d4a1797$var$deprecated_default_moveFocusInside;

});
parcelRegister("9Iexm", function(module, exports) {
$parcel$export(module.exports, "moveFocusInside", () => $71237fdc951fcd6d$export$cd599851e879a025);

var $7kW2E = parcelRequire("7kW2E");

var $kbIcx = parcelRequire("kbIcx");
var $71237fdc951fcd6d$var$guardCount = 0;
var $71237fdc951fcd6d$var$lockDisabled = false;
var $71237fdc951fcd6d$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $kbIcx.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($71237fdc951fcd6d$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($71237fdc951fcd6d$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $71237fdc951fcd6d$var$lockDisabled = true;
            setTimeout(function() {
                $71237fdc951fcd6d$var$lockDisabled = false;
            }, 1);
            return;
        }
        $71237fdc951fcd6d$var$guardCount++;
        (0, $7kW2E.focusOn)(focusable.node, options.focusOptions);
        $71237fdc951fcd6d$var$guardCount--;
    }
};

});
parcelRegister("kbIcx", function(module, exports) {
$parcel$export(module.exports, "focusSolver", () => $eb271f272ed79812$export$305758c744b57f6f);

var $1Zdsd = parcelRequire("1Zdsd");

var $4PCwQ = parcelRequire("4PCwQ");

var $kYPzi = parcelRequire("kYPzi");

var $67EIG = parcelRequire("67EIG");

var $ldp6n = parcelRequire("ldp6n");

var $CjaNl = parcelRequire("CjaNl");

var $kkBne = parcelRequire("kkBne");

var $hd7k3 = parcelRequire("hd7k3");
var $eb271f272ed79812$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $kkBne.isDefined));
};
var $eb271f272ed79812$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $CjaNl.getActiveElement)((0, $67EIG.asArray)(topNode).length > 0 ? document : (0, $67EIG.getFirst)(topNode).ownerDocument);
    var entries = (0, $kYPzi.getAllAffectedNodes)(topNode).filter((0, $kkBne.isNotAGuard));
    var commonParent = (0, $hd7k3.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $4PCwQ.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $kkBne.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $4PCwQ.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $eb271f272ed79812$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $1Zdsd.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $1Zdsd.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $ldp6n.pickAutofocus)(anyFocusable, innerTabbable, (0, $hd7k3.allParentAutofocusables)(entries, visibilityCache)) || (0, $ldp6n.pickAutofocus)(anyFocusable, innerFocusables, (0, $hd7k3.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("1Zdsd", function(module, exports) {
$parcel$export(module.exports, "NEW_FOCUS", () => $1725eca8a18f95e2$export$85710b12cf912438);
$parcel$export(module.exports, "newFocus", () => $1725eca8a18f95e2$export$65842178e9bb4205);

var $Yppze = parcelRequire("Yppze");

var $fhNO3 = parcelRequire("fhNO3");

var $kkBne = parcelRequire("kkBne");
var $1725eca8a18f95e2$export$85710b12cf912438 = 'NEW_FOCUS';
var $1725eca8a18f95e2$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $kkBne.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $1725eca8a18f95e2$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $1725eca8a18f95e2$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $Yppze.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $fhNO3.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $fhNO3.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("Yppze", function(module, exports) {
$parcel$export(module.exports, "correctNode", () => $0b5950e19270ae87$export$5261662167ad7ced);
$parcel$export(module.exports, "correctNodes", () => $0b5950e19270ae87$export$4a5a72a7124e45f9);

var $kkBne = parcelRequire("kkBne");
var $0b5950e19270ae87$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $kkBne.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $0b5950e19270ae87$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $kkBne.isRadioElement)(node) && node.name) return $0b5950e19270ae87$var$findSelectedRadio(node, nodes);
    return node;
};
var $0b5950e19270ae87$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($0b5950e19270ae87$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("fhNO3", function(module, exports) {
$parcel$export(module.exports, "pickFirstFocus", () => $b20f1406e860ac98$export$f4e86cfa0679b9cc);
$parcel$export(module.exports, "pickFocusable", () => $b20f1406e860ac98$export$e06728ee87c96122);

var $Yppze = parcelRequire("Yppze");
var $b20f1406e860ac98$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $Yppze.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $b20f1406e860ac98$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $Yppze.correctNode)(node, nodes));
};

});


parcelRegister("ldp6n", function(module, exports) {
$parcel$export(module.exports, "pickAutofocus", () => $f71e4896a95311fd$export$cfb742983e257555);

var $4PCwQ = parcelRequire("4PCwQ");

var $fhNO3 = parcelRequire("fhNO3");

var $kkBne = parcelRequire("kkBne");
var $f71e4896a95311fd$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $kkBne.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $f71e4896a95311fd$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $4PCwQ.filterAutoFocusable)(nodes.filter($f71e4896a95311fd$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $fhNO3.pickFirstFocus)(autoFocusable);
    return (0, $fhNO3.pickFirstFocus)((0, $4PCwQ.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("aQ9sX", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $7e461a7325fa4373$export$6523025722806278);
$parcel$export(module.exports, "extractRef", () => $7e461a7325fa4373$export$c613fed06e332533);
function $7e461a7325fa4373$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $7e461a7325fa4373$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $7e461a7325fa4373$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("lBtjT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aOXuZ = parcelRequire("aOXuZ");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $fba3cc01b88e571d$var$_interopRequireDefault($aOXuZ).default;
    }
});

var $8sHnP = parcelRequire("8sHnP");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $8sHnP.TouchScrollable;
    }
});
function $fba3cc01b88e571d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("aOXuZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7e0cba1f0457e896$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4fqPo = parcelRequire("4fqPo");
var $7e0cba1f0457e896$var$_react2 = $7e0cba1f0457e896$var$_interopRequireDefault($4fqPo);

var $lBRXG = parcelRequire("lBRXG");

var $8sHnP = parcelRequire("8sHnP");

var $eoooC = parcelRequire("eoooC");
var $7e0cba1f0457e896$var$_withLockSheet2 = $7e0cba1f0457e896$var$_interopRequireDefault($eoooC);

var $23TPe = parcelRequire("23TPe");
var $7e0cba1f0457e896$var$_withTouchListeners2 = $7e0cba1f0457e896$var$_interopRequireDefault($23TPe);

var $6vOW5 = parcelRequire("6vOW5");
function $7e0cba1f0457e896$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e0cba1f0457e896$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e0cba1f0457e896$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7e0cba1f0457e896$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7e0cba1f0457e896$var$ScrollLock = function(_PureComponent) {
    $7e0cba1f0457e896$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $7e0cba1f0457e896$var$_classCallCheck(this, ScrollLock);
        return $7e0cba1f0457e896$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $7e0cba1f0457e896$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lBRXG.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $7e0cba1f0457e896$var$_react2.default.createElement($8sHnP.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($4fqPo.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $7e0cba1f0457e896$var$compose = (0, $6vOW5.pipe)($7e0cba1f0457e896$var$_withTouchListeners2.default, $7e0cba1f0457e896$var$_withLockSheet2.default);
var $7e0cba1f0457e896$var$SheetLock = $7e0cba1f0457e896$var$compose($7e0cba1f0457e896$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $7e0cba1f0457e896$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $7e0cba1f0457e896$var$_react2.default.createElement($7e0cba1f0457e896$var$SheetLock, props) : props.children;
};
$7e0cba1f0457e896$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $7e0cba1f0457e896$var$LockToggle;

});
parcelRegister("lBRXG", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("8sHnP", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $6292974822ce197a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6292974822ce197a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4fqPo = parcelRequire("4fqPo");

var $lBRXG = parcelRequire("lBRXG");

var $6vOW5 = parcelRequire("6vOW5");
function $6292974822ce197a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $6292974822ce197a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6292974822ce197a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6292974822ce197a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $6292974822ce197a$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $6292974822ce197a$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $6292974822ce197a$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $6292974822ce197a$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $6292974822ce197a$var$_possibleConstructorReturn(_this, _ret);
    }
    $6292974822ce197a$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$lBRXG.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $6vOW5.preventInertiaScroll, $6vOW5.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $6vOW5.allowTouchMove, $6vOW5.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$lBRXG.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $6vOW5.preventInertiaScroll, $6vOW5.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $6vOW5.allowTouchMove, $6vOW5.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $6292974822ce197a$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $4fqPo.cloneElement)(children, $6292974822ce197a$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($4fqPo.PureComponent);

});
parcelRegister("6vOW5", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $4bdd26275713ea46$var$preventTouchMove;
module.exports.allowTouchMove = $4bdd26275713ea46$var$allowTouchMove;
module.exports.preventInertiaScroll = $4bdd26275713ea46$var$preventInertiaScroll;
module.exports.isTouchDevice = $4bdd26275713ea46$var$isTouchDevice;
module.exports.camelToKebab = $4bdd26275713ea46$var$camelToKebab;
module.exports.parse = $4bdd26275713ea46$var$parse;
module.exports.getPadding = $4bdd26275713ea46$var$getPadding;
module.exports.getWindowHeight = $4bdd26275713ea46$var$getWindowHeight;
module.exports.getDocumentHeight = $4bdd26275713ea46$var$getDocumentHeight;
module.exports.makeStyleTag = $4bdd26275713ea46$var$makeStyleTag;
module.exports.injectStyles = $4bdd26275713ea46$var$injectStyles;
module.exports.insertStyleTag = $4bdd26275713ea46$var$insertStyleTag;

var $lBRXG = parcelRequire("lBRXG");
var $4bdd26275713ea46$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $4bdd26275713ea46$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $4bdd26275713ea46$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $4bdd26275713ea46$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $4bdd26275713ea46$var$isTouchDevice() {
    if (!$lBRXG.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $4bdd26275713ea46$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $4bdd26275713ea46$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $4bdd26275713ea46$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $4bdd26275713ea46$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($4bdd26275713ea46$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $4bdd26275713ea46$var$getPadding() {
    if (!$lBRXG.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $4bdd26275713ea46$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($lBRXG.canUseDOM) return window.innerHeight * multiplier;
}
function $4bdd26275713ea46$var$getDocumentHeight() {
    if ($lBRXG.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $4bdd26275713ea46$var$makeStyleTag() {
    if (!$lBRXG.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $4bdd26275713ea46$var$injectStyles(tag, css) {
    if (!$lBRXG.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $4bdd26275713ea46$var$insertStyleTag(tag) {
    if (!$lBRXG.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("eoooC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a7a63b25dedb4470$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $a7a63b25dedb4470$var$withLockSheet;

var $4fqPo = parcelRequire("4fqPo");
var $a7a63b25dedb4470$var$_react2 = $a7a63b25dedb4470$var$_interopRequireDefault($4fqPo);

var $6vOW5 = parcelRequire("6vOW5");
function $a7a63b25dedb4470$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a7a63b25dedb4470$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a7a63b25dedb4470$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a7a63b25dedb4470$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $a7a63b25dedb4470$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $a7a63b25dedb4470$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $a7a63b25dedb4470$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $a7a63b25dedb4470$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $6vOW5.makeStyleTag)();
                if (!sheet) return;
                (0, $6vOW5.injectStyles)(sheet, styles);
                (0, $6vOW5.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $6vOW5.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $6vOW5.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $a7a63b25dedb4470$var$_possibleConstructorReturn(_this, _ret);
        }
        $a7a63b25dedb4470$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet || !this.sheet.parentNode || typeof this.sheet.parentNode.removeChild !== 'function') return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $a7a63b25dedb4470$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($4fqPo.PureComponent);
}

});

parcelRegister("23TPe", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $18072a5267b3b256$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $18072a5267b3b256$var$withTouchListeners;

var $4fqPo = parcelRequire("4fqPo");
var $18072a5267b3b256$var$_react2 = $18072a5267b3b256$var$_interopRequireDefault($4fqPo);

var $lBRXG = parcelRequire("lBRXG");

var $6vOW5 = parcelRequire("6vOW5");
function $18072a5267b3b256$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $18072a5267b3b256$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $18072a5267b3b256$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $18072a5267b3b256$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $18072a5267b3b256$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $18072a5267b3b256$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $18072a5267b3b256$var$_classCallCheck(this, TouchProvider);
            return $18072a5267b3b256$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $18072a5267b3b256$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$lBRXG.canUseDOM || !(0, $6vOW5.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $6vOW5.preventTouchMove, $6vOW5.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$lBRXG.canUseDOM || !(0, $6vOW5.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $6vOW5.preventTouchMove, $6vOW5.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $18072a5267b3b256$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($4fqPo.PureComponent);
}

});



parcelRegister("c3Vmk", function(module, exports) {
$parcel$export(module.exports, "default", () => $775398b3f3c5d87c$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");
const $775398b3f3c5d87c$var$packageName = undefined;
const $775398b3f3c5d87c$var$packageVersion = undefined;
const $775398b3f3c5d87c$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $775398b3f3c5d87c$var$packageName,
    packageVersion: $775398b3f3c5d87c$var$packageVersion
};
const $775398b3f3c5d87c$var$baseStyles = null;
const $775398b3f3c5d87c$var$shouldAllowClickThroughStyles = null;
const $775398b3f3c5d87c$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ const $775398b3f3c5d87c$var$Blanket = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(function Blanket({ shouldAllowClickThrough: shouldAllowClickThrough = false, isTinted: isTinted = false, onBlanketClicked: onBlanketClicked = (0, $c1tmZ.default), testId: testId, children: children, analyticsContext: analyticsContext }, ref) {
    const mouseDownTarget = (0, $4fqPo.useRef)(null);
    const onBlanketClickedWithAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$775398b3f3c5d87c$var$analyticsAttributes
    });
    const blanketClickOutsideChildren = (0, $4fqPo.useCallback)((e)=>e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined, [
        onBlanketClickedWithAnalytics
    ]);
    const onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    const onMouseDown = (0, $4fqPo.useCallback)((e)=>{
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $ltgDR.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk1i5c _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ])
    }, children);
}));
$775398b3f3c5d87c$var$Blanket.displayName = 'Blanket';
var $775398b3f3c5d87c$export$2e2bcd8739ae039 = $775398b3f3c5d87c$var$Blanket;

});

parcelRegister("hh7MV", function(module, exports) {
$parcel$export(module.exports, "Layering", () => $f247354a3295b37d$export$7c885f891c940977);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $3JzCx = parcelRequire("3JzCx");

var $awcaa = parcelRequire("awcaa");

var $eKvEu = parcelRequire("eKvEu");

var $jfTcT = parcelRequire("jfTcT");
const $f247354a3295b37d$var$LevelProvider = ({ children: children, currentLevel: currentLevel, node: levelNode })=>{
    (0, $4fqPo.useEffect)(()=>{
        const levelNodeSafe = levelNode.current;
        const parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return ()=>{
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awcaa.LevelContext).Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eKvEu.LevelNodeContext).Provider, {
        value: levelNode
    }, children));
};
const $f247354a3295b37d$export$7c885f891c940977 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $4fqPo.useContext)((0, $awcaa.LevelContext));
    const parentNode = (0, $4fqPo.useContext)((0, $eKvEu.LevelNodeContext));
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    const newNode = (0, $4fqPo.useRef)(new (0, $3JzCx.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f247354a3295b37d$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jfTcT.RootNodeContext).Provider, {
        value: newNode
    }, content);
};

});
parcelRegister("3JzCx", function(module, exports) {
$parcel$export(module.exports, "LayerNode", () => $25a85694213eae80$export$da4f61fd78d35243);
class $25a85694213eae80$export$da4f61fd78d35243 {
    constructor(id, parent){
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    addChild(node) {
        this.childNodes.push(node);
    }
    removeChild(node) {
        this.childNodes = this.childNodes.filter((child)=>child.id !== node.id);
    }
    getLevel() {
        if (!this.parent) return 1;
        return this.parent.getLevel() + 1;
    }
    getHeight() {
        if (this.childNodes.length === 0) return 1;
        return Math.max(...this.childNodes.map((child)=>child.getHeight())) + 1;
    }
}

});

parcelRegister("awcaa", function(module, exports) {
$parcel$export(module.exports, "LevelContext", () => $673233ad53e7e9fc$export$650d12d3c2ddb8fc);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");
const $673233ad53e7e9fc$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $4fqPo.createContext)(0);

});

parcelRegister("eKvEu", function(module, exports) {
$parcel$export(module.exports, "LevelNodeContext", () => $74b7270df7f7bca5$export$18f4d8b5b3a77f59);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");
const $74b7270df7f7bca5$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    current: null
});

});

parcelRegister("jfTcT", function(module, exports) {
$parcel$export(module.exports, "RootNodeContext", () => $dc405f0216381345$export$fa973f110e8f6ca8);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");
const $dc405f0216381345$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    current: null
});

});


parcelRegister("aagiU", function(module, exports) {
$parcel$export(module.exports, "combine", () => (parcelRequire("3YOxy")).combine);

var $3YOxy = parcelRequire("3YOxy");

});
parcelRegister("3YOxy", function(module, exports) {
$parcel$export(module.exports, "combine", () => $83404b480882512a$export$1be1fc439b849fdf);
function $83404b480882512a$export$1be1fc439b849fdf(...fns) {
    return function cleanup() {
        fns.forEach((fn)=>fn());
    };
}

});


parcelRegister("h2qC6", function(module, exports) {
$parcel$export(module.exports, "createCloseEvent", () => $a59efd3c1937c30c$export$330cd73b9da5838b);
function $a59efd3c1937c30c$export$330cd73b9da5838b({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
}

});

parcelRegister("krX6V", function(module, exports) {
$parcel$export(module.exports, "Dialog", () => $e2dd72bb53bb5e11$export$3ddf2d174ce01153);
/* dialog-content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");

var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $5wgou = parcelRequire("5wgou");

var $c1tmZ = parcelRequire("c1tmZ");

var $1AxDb = parcelRequire("1AxDb");

var $77T25 = parcelRequire("77T25");

var $5kEJF = parcelRequire("5kEJF");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- dialog reset requires values not in cssMap's type union
const $e2dd72bb53bb5e11$var$styles = {
    dialog: "_19itglyw _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _p12fglyw _c71lglyw _bfhk1j28 _1ltk1i5c"
};
const $e2dd72bb53bb5e11$export$3ddf2d174ce01153 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function Dialog({ children: children, isOpen: isOpen, onClose: onClose, onExitFinish: onExitFinish, animate: animate, style: style, testId: testId, id: providedId, label: label, labelledBy: labelledBy, shouldHideBackdrop: shouldHideBackdrop }, ref) {
    const generatedId = (0, $4fqPo.useId)();
    const dialogId = providedId ?? generatedId;
    const ownRef = (0, $4fqPo.useRef)(null);
    const combinedRef = (0, $5wgou.default)([
        ownRef,
        ref
    ]);
    const { phase: phase, preset: preset } = (0, $77T25.useAnimatedVisibility)({
        isOpen: isOpen,
        animate: animate,
        elementRef: ownRef,
        onExitFinish: onExitFinish
    });
    // True while the host element is mounted (any phase except `closed`).
    // Used as a dep so listener-rebind effects re-attach after a remount.
    const isVisible = phase !== 'closed';
    // Native `<dialog>.showModal()` traps focus but wraps through `<body>` at
    // the boundary (A → B → C → body → A). This hook intercepts Tab to wrap
    // directly (A → B → C → A), matching the WAI-ARIA APG pattern. Passing
    // `phase` keeps the listener attached through the animated-exit window
    // (WCAG 2.4.3 Focus Order regression guard).
    (0, $5kEJF.useFocusWrap)({
        elementRef: ownRef,
        role: 'dialog',
        phase: phase
    });
    // Notify the open layer observer so app-coordination features
    // (open-count subscriptions) work with top-layer dialogs.
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        type: 'modal',
        isOpen: isOpen,
        // No-op: no current use case for programmatic close via OpenLayerObserver.
        onClose: (0, $c1tmZ.default)
    });
    (0, $4fqPo.useLayoutEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        if (isOpen) {
            if (!dialog.open) dialog.showModal();
            return ()=>{
                if (dialog.open) dialog.close();
            };
        }
        if (dialog.open) dialog.close();
    }, [
        isOpen
    ]);
    // Handle native Escape (cancel event)
    const handleCancel = (0, $4fqPo.useCallback)((event)=>{
        event.preventDefault();
        onClose({
            reason: 'escape'
        });
    }, [
        onClose
    ]);
    // Handle backdrop click
    // Attached via bind-event-listener rather than a React prop so we avoid
    // a11y lint suppressions on the <dialog> element.
    // Keyboard dismiss is already handled natively (Escape → onCancel above).
    // `isVisible` is in deps so the listener re-binds to the new <dialog>
    // element after a host unmount / remount cycle.
    (0, $4fqPo.useEffect)(()=>{
        const dialog = ownRef.current;
        if (!dialog) return;
        return (0, $lMcEJ.bind)(dialog, {
            type: 'click',
            listener (event) {
                if (event.target === event.currentTarget) onClose({
                    reason: 'overlay-click'
                });
            }
        });
    }, [
        onClose,
        isVisible
    ]);
    // Atomic CSS (Compiled) deduplicates ::backdrop { background-color }
    // into a single class, making it impossible to toggle between two values
    // via cssMap entries. An ID-scoped <style> has higher specificity than
    // any atomic class, so the override always wins.
    const escapedId = CSS.escape(dialogId);
    // Unmount the `<dialog>` once exit completes so it does not leave an
    // empty `role="dialog"` element in the accessibility tree. On the next
    // open the element remounts and the `[isOpen]` and `[onClose, isVisible]`
    // effects re-run against the fresh element.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, $lhXNe.jsxs)("dialog", {
        ref: combinedRef,
        id: dialogId,
        // `aria-modal` is intentionally NOT set: native `<dialog>.showModal()`
        // already conveys modal semantics to assistive tech, and double-
        // declaring it forecloses non-modal use cases (consumers calling
        // `.show()` would still appear modal). Modern AT (NVDA / JAWS /
        // VoiceOver) infer modality from the platform accessibility API.
        "aria-label": label,
        "aria-labelledby": label ? undefined : labelledBy,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        onCancel: handleCancel,
        "data-testid": testId,
        ...preset ? {
            [`data-ds-dialog-${preset.name}`]: ''
        } : undefined,
        className: (0, $ltgDR.default)([
            $e2dd72bb53bb5e11$var$styles.dialog
        ]),
        children: [
            shouldHideBackdrop && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles
            /*#__PURE__*/ (0, $lhXNe.jsx)("style", {
                children: `#${escapedId}::backdrop{background-color:transparent}`
            }),
            children
        ]
    });
});

});

parcelRegister("cl95o", function(module, exports) {
$parcel$export(module.exports, "DialogScrollLock", () => $678a5e5e99712a5c$export$e458030908e2d723);

var $4fqPo = parcelRequire("4fqPo");

var $564zZ = parcelRequire("564zZ");
function $678a5e5e99712a5c$export$e458030908e2d723({ isOpen: isOpen }) {
    (0, $4fqPo.useLayoutEffect)(()=>{
        var _getDocument;
        if (!isOpen) return;
        const body = (_getDocument = (0, $564zZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body;
        if (!body) return;
        const previousOverflow = body.style.overflow;
        body.style.overflow = 'hidden';
        return ()=>{
            body.style.overflow = previousOverflow;
        };
    }, [
        isOpen
    ]);
    return null;
}

});

parcelRegister("gn2Jn", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $b57037931fb054a8$export$ab57792b9b6974a6);

var $4fqPo = parcelRequire("4fqPo");

var $g6yvD = parcelRequire("g6yvD");
const $b57037931fb054a8$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);

});
parcelRegister("g6yvD", function(module, exports) {
$parcel$export(module.exports, "ScrollContext", () => $fbbb3a195599953c$export$dece24112a937f92);

var $4fqPo = parcelRequire("4fqPo");
const $fbbb3a195599953c$export$dece24112a937f92 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);

});


parcelRegister("ej19S", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe56589d81dbcc36$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $9PZQT = parcelRequire("9PZQT");

var $3kJNY = parcelRequire("3kJNY");

var $5l2cT = parcelRequire("5l2cT");

var $eO5yD = parcelRequire("eO5yD");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $fe56589d81dbcc36$var$modalStackRegister = [];
function $fe56589d81dbcc36$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $eO5yD.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $5l2cT.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $3kJNY.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $9PZQT.default)(()=>{
        const newStackIndex = $fe56589d81dbcc36$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $4fqPo.useEffect)(()=>{
        const currentStackIndex = $fe56589d81dbcc36$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $fe56589d81dbcc36$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $fe56589d81dbcc36$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $fe56589d81dbcc36$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $4fqPo.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $fe56589d81dbcc36$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $fe56589d81dbcc36$var$modalStackRegister.splice(currentStackIndex, 1);
                $fe56589d81dbcc36$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("9PZQT", function(module, exports) {
$parcel$export(module.exports, "default", () => $24e5263800caca68$export$2e2bcd8739ae039);

var $eIbBI = parcelRequire("eIbBI");
function $24e5263800caca68$export$2e2bcd8739ae039(callback) {
    const ref = (0, $eIbBI.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("eIbBI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d357658ae5eb14dc$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $d357658ae5eb14dc$var$uniqueReferencedValue = {};
function $d357658ae5eb14dc$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $4fqPo.useRef)($d357658ae5eb14dc$var$uniqueReferencedValue);
    if (ref.current === $d357658ae5eb14dc$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("3kJNY", function(module, exports) {
$parcel$export(module.exports, "default", () => $e507f463e9c5a64f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $e507f463e9c5a64f$export$2e2bcd8739ae039(value) {
    const ref = (0, $4fqPo.useRef)();
    (0, $4fqPo.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("5l2cT", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a7a1b03d5840624$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $9a7a1b03d5840624$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $4fqPo.useState)(initialState);
    const valueRef = (0, $4fqPo.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("3G850", function(module, exports) {
$parcel$export(module.exports, "default", () => $06d86f454305d6f1$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $06d86f454305d6f1$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $06d86f454305d6f1$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $4fqPo.useState)(0);
    (0, $4fqPo.useLayoutEffect)(()=>{
        setScrollTopOffset($06d86f454305d6f1$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $4fqPo.useCallback)(()=>{
        if ($06d86f454305d6f1$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $4fqPo.useEffect)(()=>{
        return (0, $lMcEJ.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("kELtn", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", () => $06314a50a464c4a8$export$ec28e97c7d8b1b35);

var $lMcEJ = parcelRequire("lMcEJ");
parcelRequire("aagiU");
var $3YOxy = parcelRequire("3YOxy");
parcelRequire("TTv9A");
var $6VpX8 = parcelRequire("6VpX8");

var $a3A0d = parcelRequire("a3A0d");
function $06314a50a464c4a8$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $lMcEJ.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $6VpX8.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $3YOxy.combine)(unbindEvents, unbindMonitor);
}
function $06314a50a464c4a8$var$watchForInteractionStart({ start: start }) {
    return (0, $lMcEJ.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $06314a50a464c4a8$var$api = (0, $a3A0d.makeFixForAdapter)({
    watchForInteractionStart: $06314a50a464c4a8$var$watchForInteractionStart,
    watchForInteractionEnd: $06314a50a464c4a8$var$watchForInteractionEnd
});
function $06314a50a464c4a8$export$ec28e97c7d8b1b35() {
    return $06314a50a464c4a8$var$api.registerUsage();
}

});
parcelRegister("TTv9A", function(module, exports) {
$parcel$export(module.exports, "draggable", () => (parcelRequire("6VpX8")).draggable);
$parcel$export(module.exports, "dropTargetForElements", () => (parcelRequire("6VpX8")).dropTargetForElements);
$parcel$export(module.exports, "monitorForElements", () => (parcelRequire("6VpX8")).monitorForElements);

var $6VpX8 = parcelRequire("6VpX8");

});
parcelRegister("6VpX8", function(module, exports) {
$parcel$export(module.exports, "dropTargetForElements", () => $8fc4747aeeb2c5dd$export$e7140b68045b5036);
$parcel$export(module.exports, "monitorForElements", () => $8fc4747aeeb2c5dd$export$59a074bac4c54f54);
$parcel$export(module.exports, "draggable", () => $8fc4747aeeb2c5dd$export$c746a5152d4ba26c);

var $lMcEJ = parcelRequire("lMcEJ");

var $gtLVY = parcelRequire("gtLVY");

var $eIGvm = parcelRequire("eIGvm");

var $lybba = parcelRequire("lybba");

var $3YOxy = parcelRequire("3YOxy");

var $9e9aq = parcelRequire("9e9aq");

var $g4m8v = parcelRequire("g4m8v");

var $hRRSY = parcelRequire("hRRSY");

var $71Gsw = parcelRequire("71Gsw");

var $c4oqQ = parcelRequire("c4oqQ");

var $9SaAv = parcelRequire("9SaAv");

var $7NfnN = parcelRequire("7NfnN");
const $8fc4747aeeb2c5dd$var$draggableRegistry = new WeakMap();
function $8fc4747aeeb2c5dd$var$addToRegistry(args) {
    $8fc4747aeeb2c5dd$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $8fc4747aeeb2c5dd$var$draggableRegistry.delete(args.element);
    };
}
const $8fc4747aeeb2c5dd$var$honeyPotFix = (0, $eIGvm.makeHoneyPotFix)();
const $8fc4747aeeb2c5dd$var$adapter = (0, $lybba.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount (api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $3YOxy.combine)($8fc4747aeeb2c5dd$var$honeyPotFix.bindEvents(), (0, $lMcEJ.bind)(document, {
            type: 'dragstart',
            listener (event) {
                var _entry$getInitialData, _entry$getInitialData2;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                const target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return;
                // see if the thing being dragged is owned by us
                const entry = $8fc4747aeeb2c5dd$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ const input = (0, $71Gsw.getInput)(event);
                const feedback = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    const over = (0, $gtLVY.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ const nativeData = ((_entry$getInitialData = entry.getInitialDataForExternal) === null || _entry$getInitialData === void 0 ? void 0 : _entry$getInitialData.call(entry, feedback)) ?? null;
                if (nativeData) for (const [key, data] of Object.entries(nativeData))event.dataTransfer.setData(key, data ?? '');
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $hRRSY.isAndroid)() && !event.dataTransfer.types.includes((0, $c4oqQ.textMediaType)) && !event.dataTransfer.types.includes((0, $9SaAv.URLMediaType))) event.dataTransfer.setData((0, $c4oqQ.textMediaType), (0, $hRRSY.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $7NfnN.elementAdapterNativeDataKey), '');
                const payload = {
                    element: entry.element,
                    dragHandle: entry.dragHandle ?? null,
                    data: ((_entry$getInitialData2 = entry.getInitialData) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) ?? {}
                };
                const dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: ({ eventName: eventName, payload: payload })=>{
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $8fc4747aeeb2c5dd$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $8fc4747aeeb2c5dd$var$honeyPotFix.getOnPostDispatch()
});
const $8fc4747aeeb2c5dd$export$e7140b68045b5036 = $8fc4747aeeb2c5dd$var$adapter.dropTarget;
const $8fc4747aeeb2c5dd$export$59a074bac4c54f54 = $8fc4747aeeb2c5dd$var$adapter.monitor;
function $8fc4747aeeb2c5dd$export$c746a5152d4ba26c(args) {
    const cleanup = (0, $3YOxy.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $8fc4747aeeb2c5dd$var$adapter.registerUsage(), $8fc4747aeeb2c5dd$var$addToRegistry(args), (0, $g4m8v.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $9e9aq.once)(cleanup);
}

});
parcelRegister("gtLVY", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => $205b9ea351ba0097$export$81d0353f25f5dd);

var $e4Fta = parcelRequire("e4Fta");
function $205b9ea351ba0097$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    const [top, second] = document.elementsFromPoint(client.x, client.y);
    if (!top) return null;
    if ((0, $e4Fta.isHoneyPotElement)(top)) return second ?? null;
    return top;
}

});
parcelRegister("e4Fta", function(module, exports) {
$parcel$export(module.exports, "isHoneyPotElement", () => $1def28095872de2f$export$821bdcd739a2706b);

var $1OJo3 = parcelRequire("1OJo3");
function $1def28095872de2f$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $1OJo3.honeyPotDataAttribute));
}

});
parcelRegister("1OJo3", function(module, exports) {
$parcel$export(module.exports, "honeyPotDataAttribute", () => $8a4d527a7a327a37$export$6eafea55f7947469);
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
const $8a4d527a7a327a37$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("eIGvm", function(module, exports) {
$parcel$export(module.exports, "makeHoneyPotFix", () => $e7eaa51d03b6b50b$export$8ecad27c959e89e0);

var $lMcEJ = parcelRequire("lMcEJ");

var $fBZWX = parcelRequire("fBZWX");

var $eYdgJ = parcelRequire("eYdgJ");

var $iMsJ0 = parcelRequire("iMsJ0");

var $1OJo3 = parcelRequire("1OJo3");
const $e7eaa51d03b6b50b$var$honeyPotSize = 2;
const $e7eaa51d03b6b50b$var$halfHoneyPotSize = $e7eaa51d03b6b50b$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $e7eaa51d03b6b50b$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $e7eaa51d03b6b50b$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $e7eaa51d03b6b50b$var$halfHoneyPotSize,
        y: point.y - $e7eaa51d03b6b50b$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $e7eaa51d03b6b50b$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $e7eaa51d03b6b50b$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $e7eaa51d03b6b50b$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $e7eaa51d03b6b50b$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $e7eaa51d03b6b50b$var$getHoneyPotRectFor({ client: client }) {
    const point = $e7eaa51d03b6b50b$var$preventGoingForwardsOffScreen($e7eaa51d03b6b50b$var$preventGoingBackwardsOffScreen($e7eaa51d03b6b50b$var$pullBackByHalfHoneyPotSize($e7eaa51d03b6b50b$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $e7eaa51d03b6b50b$var$honeyPotSize,
        height: $e7eaa51d03b6b50b$var$honeyPotSize
    });
}
function $e7eaa51d03b6b50b$var$getRectStyles({ clientRect: clientRect }) {
    return {
        left: `${clientRect.left}px`,
        top: `${clientRect.top}px`,
        width: `${clientRect.width}px`,
        height: `${clientRect.height}px`
    };
}
function $e7eaa51d03b6b50b$var$isWithin({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $e7eaa51d03b6b50b$var$mountHoneyPot({ initial: initial }) {
    const element = document.createElement('div');
    element.setAttribute((0, $1OJo3.honeyPotDataAttribute), 'true');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the honey pot is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    if ((0, $iMsJ0.supportsPopover)()) element.setAttribute('popover', 'manual');
    // can shift during the drag thanks to Firefox
    let clientRect = $e7eaa51d03b6b50b$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, {
        position: 'fixed',
        ...(0, $iMsJ0.supportsPopover)() ? // needs to come first as it has 'inset: unset' which
        // needs to be overridden by our top / left values
        (0, $eYdgJ.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $fBZWX.maxZIndex)
        },
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        ...$e7eaa51d03b6b50b$var$getRectStyles({
            clientRect: clientRect
        })
    });
    document.body.appendChild(element);
    if ((0, $iMsJ0.supportsPopover)()) element.showPopover();
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ const unbindPointerMove = (0, $lMcEJ.bind)(window, {
        type: 'pointermove',
        listener (event) {
            const client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $e7eaa51d03b6b50b$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $e7eaa51d03b6b50b$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish({ current: current }) {
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($e7eaa51d03b6b50b$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        const unbindPostDragEvents = (0, $lMcEJ.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $e7eaa51d03b6b50b$export$8ecad27c959e89e0() {
    let latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $lMcEJ.bind)(window, {
            type: 'pointermove',
            listener (event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        let finish = null;
        return function onPostEvent({ eventName: eventName, payload: payload }) {
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                const { input: input } = payload.location.initial;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                const initial = latestPointerMove ?? {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $e7eaa51d03b6b50b$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                const { input: input } = payload.location.current;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: input.clientX,
                        y: input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("fBZWX", function(module, exports) {
$parcel$export(module.exports, "maxZIndex", () => $e09ca6565a18b094$export$7d0a15ee70427305);
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $e09ca6565a18b094$export$7d0a15ee70427305 = 2147483647;

});

parcelRegister("eYdgJ", function(module, exports) {
$parcel$export(module.exports, "popoverResetUserAgentStyles", () => $35021b7182240ecb$export$74004cb910cdc478);
const $35021b7182240ecb$export$74004cb910cdc478 = {
    inset: 'unset',
    border: 'none',
    padding: 0,
    margin: 0,
    overflow: 'visible',
    color: 'inherit',
    background: 'transparent',
    width: 'auto',
    height: 'auto'
};

});

parcelRegister("iMsJ0", function(module, exports) {
$parcel$export(module.exports, "supportsPopover", () => $5748b8227a12e6c7$export$1150b66d0ff92823);

var $9e9aq = parcelRequire("9e9aq");
const $5748b8227a12e6c7$export$1150b66d0ff92823 = (0, $9e9aq.once)(function supportsPopover() {
    return typeof HTMLElement !== 'undefined' && typeof HTMLElement.prototype.showPopover === 'function';
});

});
parcelRegister("9e9aq", function(module, exports) {
$parcel$export(module.exports, "once", () => $19d7f3b48fd76bc5$export$d2de3aaeafa91619);
/** Provide a function that you only ever want to be called a single time */ function $19d7f3b48fd76bc5$export$d2de3aaeafa91619(fn) {
    let cache = null;
    return function wrapped(...args) {
        if (!cache) {
            const result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});



parcelRegister("lybba", function(module, exports) {
$parcel$export(module.exports, "makeAdapter", () => $6cf0191c37d2d1bd$export$2aa3a33160990d96);

var $bdByX = parcelRequire("bdByX");

var $ivBgl = parcelRequire("ivBgl");

var $lKNcH = parcelRequire("lKNcH");

var $dqNHW = parcelRequire("dqNHW");
function $6cf0191c37d2d1bd$export$2aa3a33160990d96({ typeKey: typeKey, mount: mount, dispatchEventToSource: dispatchEventToSource, onPostDispatch: onPostDispatch, defaultDropEffect: defaultDropEffect }) {
    const monitorAPI = (0, $dqNHW.makeMonitor)();
    const dropTargetAPI = (0, $lKNcH.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start({ event: event, dragType: dragType }) {
        (0, $bdByX.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            const api = {
                canStart: (0, $bdByX.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $ivBgl.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("bdByX", function(module, exports) {
$parcel$export(module.exports, "lifecycle", () => $304222db2382d54f$export$3efdceeb8ca25c51);

var $lMcEJ = parcelRequire("lMcEJ");

var $gtLVY = parcelRequire("gtLVY");

var $e4Fta = parcelRequire("e4Fta");

var $inFHX = parcelRequire("inFHX");

var $18Mfz = parcelRequire("18Mfz");

var $71Gsw = parcelRequire("71Gsw");

var $14kIi = parcelRequire("14kIi");
const $304222db2382d54f$var$globalState = {
    isActive: false
};
function $304222db2382d54f$var$canStart() {
    return !$304222db2382d54f$var$globalState.isActive;
}
function $304222db2382d54f$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $304222db2382d54f$var$hasHierarchyChanged({ current: current, next: next }) {
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(let i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $304222db2382d54f$var$start({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver, dispatchEvent: dispatchEvent }) {
    if (!$304222db2382d54f$var$canStart()) return;
    const initial = $304222db2382d54f$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $304222db2382d54f$var$globalState.isActive = true;
    const state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $304222db2382d54f$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    const dispatch = (0, $14kIi.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        const hasChanged = $304222db2382d54f$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        const input = (0, $71Gsw.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        const target = (0, $e4Fta.isHoneyPotElement)(event.target) ? (0, $gtLVY.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        const nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $304222db2382d54f$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $304222db2382d54f$var$globalState.isActive = false;
        unbindEvents();
    }
    const unbindEvents = (0, $lMcEJ.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener (event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener (event) {
                if (!(0, $inFHX.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener (event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $71Gsw.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $304222db2382d54f$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener (event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $71Gsw.getInput)(event)
                };
                cancel();
            }
        },
        ...(0, $18Mfz.getBindingsForBrokenDrags)({
            onDragEnd: cancel
        })
    ], // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $304222db2382d54f$var$getNativeSetDragImage(event)
    });
}
function $304222db2382d54f$var$setDropEffectOnEvent({ event: event, current: current }) {
    var _current$;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    const innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $304222db2382d54f$var$getStartLocation({ event: event, dragType: dragType, getDropTargetsOver: getDropTargetsOver }) {
    const input = (0, $71Gsw.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    const dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
const $304222db2382d54f$export$3efdceeb8ca25c51 = {
    canStart: $304222db2382d54f$var$canStart,
    start: $304222db2382d54f$var$start
};

});
parcelRegister("inFHX", function(module, exports) {
$parcel$export(module.exports, "isLeavingWindow", () => $15832dbdfd9c4e49$export$57d220c74e84a273);

var $f6IFE = parcelRequire("f6IFE");

var $fRUuX = parcelRequire("fRUuX");

var $fyJEp = parcelRequire("fyJEp");

var $hYVXV = parcelRequire("hYVXV");
function $15832dbdfd9c4e49$export$57d220c74e84a273({ dragLeave: dragLeave }) {
    const { type: type, relatedTarget: relatedTarget } = dragLeave;
    if (type !== 'dragleave') return false;
    if ((0, $fRUuX.isSafari)()) return (0, $fyJEp.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $f6IFE.isFirefox)()) return (0, $hYVXV.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("f6IFE", function(module, exports) {
$parcel$export(module.exports, "isFirefox", () => $8d438bbc2f0855d1$export$b7d78993b74f766d);

var $9e9aq = parcelRequire("9e9aq");
const $8d438bbc2f0855d1$export$b7d78993b74f766d = (0, $9e9aq.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});

parcelRegister("fRUuX", function(module, exports) {
$parcel$export(module.exports, "isSafari", () => $3da7f5a7c06323f0$export$95df08bae54cb4df);

var $9e9aq = parcelRequire("9e9aq");
const $3da7f5a7c06323f0$export$95df08bae54cb4df = (0, $9e9aq.once)(function isSafari() {
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("fyJEp", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindowInSafari", () => $b0816126b2cd29ab$export$de68634bd94ed596);
$parcel$export(module.exports, "isLeavingWindowInSafari", () => $b0816126b2cd29ab$export$f21837c338005454);

var $lMcEJ = parcelRequire("lMcEJ");

var $fRUuX = parcelRequire("fRUuX");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
const $b0816126b2cd29ab$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $b0816126b2cd29ab$export$de68634bd94ed596({ dragEnter: dragEnter }) {
    if (!(0, $fRUuX.isSafari)()) return false;
    return dragEnter.hasOwnProperty($b0816126b2cd29ab$var$symbols.isEnteringWindow);
}
function $b0816126b2cd29ab$export$f21837c338005454({ dragLeave: dragLeave }) {
    if (!(0, $fRUuX.isSafari)()) return false;
    return dragLeave.hasOwnProperty($b0816126b2cd29ab$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $fRUuX.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    let state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $lMcEJ.bindAll)(window, [
        {
            type: 'dragstart',
            listener: ()=>{
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: (event)=>{
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                event[$b0816126b2cd29ab$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: (event)=>{
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    event[$b0816126b2cd29ab$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("hYVXV", function(module, exports) {
$parcel$export(module.exports, "isFromAnotherWindow", () => $736de22bec093c6c$export$e46810fef53b5b0e);
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $736de22bec093c6c$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $736de22bec093c6c$export$e46810fef53b5b0e(eventTarget) {
    return $736de22bec093c6c$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("18Mfz", function(module, exports) {
$parcel$export(module.exports, "getBindingsForBrokenDrags", () => $dcd9afbaaeb82e3f$export$ac5e5b0daf997b2);
function $dcd9afbaaeb82e3f$export$ac5e5b0daf997b2({ onDragEnd: onDragEnd }) {
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: (()=>{
                let callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            })()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("71Gsw", function(module, exports) {
$parcel$export(module.exports, "getInput", () => $ec5d5f01f2c25925$export$7c112ceec8941e67);
function $ec5d5f01f2c25925$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("14kIi", function(module, exports) {
$parcel$export(module.exports, "makeDispatch", () => $4a87680a872687d2$export$9f13ecc44e83d682);

var $c1P93 = parcelRequire("c1P93");
const $4a87680a872687d2$var$scheduleOnDrag = (0, $c1P93.default)((fn)=>fn());
const $4a87680a872687d2$var$dragStart = (()=>{
    let scheduled = null;
    function schedule(fn) {
        const frameId = requestAnimationFrame(()=>{
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
})();
function $4a87680a872687d2$export$9f13ecc44e83d682({ source: source, initial: initial, dispatchEvent: dispatchEvent }) {
    let previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    const dispatch = {
        start ({ nativeSetDragImage: nativeSetDragImage }) {
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            const location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $4a87680a872687d2$var$dragStart.schedule(()=>{
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate ({ current: current }) {
            $4a87680a872687d2$var$dragStart.flush();
            $4a87680a872687d2$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag ({ current: current }) {
            $4a87680a872687d2$var$scheduleOnDrag(()=>{
                $4a87680a872687d2$var$dragStart.flush();
                const location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop ({ current: current, updatedSourcePayload: updatedSourcePayload }) {
            $4a87680a872687d2$var$dragStart.flush();
            $4a87680a872687d2$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload ?? source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});


parcelRegister("ivBgl", function(module, exports) {
$parcel$export(module.exports, "register", () => $f71c560143c6e640$export$6503ec6e8aabbaf);
const $f71c560143c6e640$var$ledger = new Map();
function $f71c560143c6e640$var$registerUsage({ typeKey: typeKey, mount: mount }) {
    const entry = $f71c560143c6e640$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    const initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $f71c560143c6e640$var$ledger.set(typeKey, initial);
    return initial;
}
function $f71c560143c6e640$export$6503ec6e8aabbaf(args) {
    const entry = $f71c560143c6e640$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $f71c560143c6e640$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("lKNcH", function(module, exports) {
$parcel$export(module.exports, "makeDropTarget", () => $3c8194f7052937e3$export$47d10e7bd9c81890);

var $3YOxy = parcelRequire("3YOxy");

var $9e9aq = parcelRequire("9e9aq");

var $g4m8v = parcelRequire("g4m8v");
function $3c8194f7052937e3$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $3c8194f7052937e3$export$47d10e7bd9c81890({ typeKey: typeKey, defaultDropEffect: defaultDropEffect }) {
    const registry = new WeakMap();
    const dropTargetDataAtt = `data-drop-target-for-${typeKey}`;
    const dropTargetSelector = `[${dropTargetDataAtt}]`;
    function addToRegistry(args) {
        registry.set(args.element, args);
        return ()=>registry.delete(args.element);
    }
    function dropTargetForConsumers(args) {
        const cleanup = (0, $3YOxy.combine)((0, $g4m8v.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $9e9aq.once)(cleanup);
    }
    function getActualDropTargets({ source: source, target: target, input: input, result: result = [] }) {
        var _args$getData, _args$getDropEffect;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        const closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        const args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        const feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        const data = ((_args$getData = args.getData) === null || _args$getData === void 0 ? void 0 : _args$getData.call(args, feedback)) ?? {};
        const dropEffect = ((_args$getDropEffect = args.getDropEffect) === null || _args$getDropEffect === void 0 ? void 0 : _args$getDropEffect.call(args, feedback)) ?? defaultDropEffect;
        const record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [
                ...result,
                record
            ]
        });
    }
    function notifyCurrent({ eventName: eventName, payload: payload }) {
        for (const record of payload.location.current.dropTargets){
            var _entry$eventName;
            const entry = registry.get(record.element);
            const args = {
                ...payload,
                self: record
            };
            entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
            // TS doesn't seem to like that one event can need `nativeSetDragImage`
            // @ts-expect-error
            args);
        }
    }
    const actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: ({ payload: payload })=>{
            const isCurrent = new Set(payload.location.current.dropTargets.map((record)=>record.element));
            const visited = new Set();
            for (const record of payload.location.previous.dropTargets){
                var _entry$onDropTargetCh;
                visited.add(record.element);
                const entry = registry.get(record.element);
                const isOver = isCurrent.has(record.element);
                const args = {
                    ...payload,
                    self: record
                };
                entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                // if we cannot find the drop target in the current array, then it has been left
                if (!isOver) {
                    var _entry$onDragLeave;
                    entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                }
            }
            for (const record of payload.location.current.dropTargets){
                var _entry$onDropTargetCh2, _entry$onDragEnter;
                // already published an update to this drop target
                if (visited.has(record.element)) continue;
                // at this point we have a new drop target that is being entered into
                const args = {
                    ...payload,
                    self: record
                };
                const entry = registry.get(record.element);
                entry === null || entry === void 0 || (_entry$onDropTargetCh2 = entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(entry, args);
                entry === null || entry === void 0 || (_entry$onDragEnter = entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(entry, args);
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver({ source: source, target: target, input: input, current: current }) {
        const actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        const lastCaptureOrdered = $3c8194f7052937e3$var$copyReverse(current);
        const actualCaptureOrdered = $3c8194f7052937e3$var$copyReverse(actual);
        const resultCaptureOrdered = [];
        for(let index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            const last = lastCaptureOrdered[index];
            const fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            const parent = resultCaptureOrdered[index - 1];
            const lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            const argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            const feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push({
                ...last,
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            });
        }
        // return bubble ordered result
        return $3c8194f7052937e3$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("g4m8v", function(module, exports) {
$parcel$export(module.exports, "addAttribute", () => $594c9e31d0e7f768$export$5dcb5c23b6ba980a);
function $594c9e31d0e7f768$export$5dcb5c23b6ba980a(element, { attribute: attribute, value: value }) {
    element.setAttribute(attribute, value);
    return ()=>element.removeAttribute(attribute);
}

});


parcelRegister("dqNHW", function(module, exports) {
$parcel$export(module.exports, "makeMonitor", () => $3fcf85ff1d26f3fe$export$5dd4ed888d5b12ca);

var $9e9aq = parcelRequire("9e9aq");
function $3fcf85ff1d26f3fe$export$5dd4ed888d5b12ca() {
    const registry = new Set();
    let dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        const entry = {
            ...args
        };
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $9e9aq.once)(cleanup);
    }
    function dispatchEvent({ eventName: eventName, payload: payload }) {
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            for (const monitor of registry)tryAddToActive(monitor);
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        const active = Array.from(dragging.active);
        for (const monitor of active)// A monitor can be removed by another monitor during an event.
        // We need to check that the monitor is still registered before calling it
        if (dragging.active.has(monitor)) {
            var _monitor$eventName;
            // @ts-expect-error: I cannot get this type working!
            (_monitor$eventName = monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(monitor, payload);
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("hRRSY", function(module, exports) {
$parcel$export(module.exports, "isAndroid", () => $c995b91f42639c7f$export$a11b0059900ceec8);
$parcel$export(module.exports, "androidFallbackText", () => $c995b91f42639c7f$export$aceb3ed8b7f7bd2c);

var $9e9aq = parcelRequire("9e9aq");
const $c995b91f42639c7f$export$a11b0059900ceec8 = (0, $9e9aq.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
const $c995b91f42639c7f$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("c4oqQ", function(module, exports) {
$parcel$export(module.exports, "textMediaType", () => $d5e11d2af29b500d$export$fd3d00026297c0ad);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $d5e11d2af29b500d$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("9SaAv", function(module, exports) {
$parcel$export(module.exports, "URLMediaType", () => $5e51c6dd5c2f7b5a$export$4c44a460f123106);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $5e51c6dd5c2f7b5a$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("7NfnN", function(module, exports) {
$parcel$export(module.exports, "elementAdapterNativeDataKey", () => $08a5db00edebc91e$export$c9c4cc54e73b125d);
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ const $08a5db00edebc91e$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("a3A0d", function(module, exports) {
$parcel$export(module.exports, "makeFixForAdapter", () => $0fbcc3a99f5c3f80$export$a74bff2507e6126b);
parcelRequire("aagiU");
var $3YOxy = parcelRequire("3YOxy");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $0fbcc3a99f5c3f80$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $0fbcc3a99f5c3f80$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $0fbcc3a99f5c3f80$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$0fbcc3a99f5c3f80$var$hasSameOrigin(window.location.href, iframe.src);
}
const $0fbcc3a99f5c3f80$var$registry = new Map();
function $0fbcc3a99f5c3f80$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($0fbcc3a99f5c3f80$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $0fbcc3a99f5c3f80$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $0fbcc3a99f5c3f80$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $0fbcc3a99f5c3f80$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $0fbcc3a99f5c3f80$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $3YOxy.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $0fbcc3a99f5c3f80$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $0fbcc3a99f5c3f80$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("juRbr", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", () => $c4d0e040c1a6acfc$export$27d79116d3a4e7d5);
parcelRequire("2l7Jq");
var $gCGxQ = parcelRequire("gCGxQ");

var $a3A0d = parcelRequire("a3A0d");
function $c4d0e040c1a6acfc$var$watchForInteractionStart({ start: start }) {
    return (0, $gCGxQ.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $c4d0e040c1a6acfc$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $gCGxQ.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $c4d0e040c1a6acfc$var$api = (0, $a3A0d.makeFixForAdapter)({
    watchForInteractionStart: $c4d0e040c1a6acfc$var$watchForInteractionStart,
    watchForInteractionEnd: $c4d0e040c1a6acfc$var$watchForInteractionEnd
});
function $c4d0e040c1a6acfc$export$27d79116d3a4e7d5() {
    return $c4d0e040c1a6acfc$var$api.registerUsage();
}

});
parcelRegister("2l7Jq", function(module, exports) {
$parcel$export(module.exports, "monitorForExternal", () => (parcelRequire("gCGxQ")).monitorForExternal);
$parcel$export(module.exports, "dropTargetForExternal", () => (parcelRequire("gCGxQ")).dropTargetForExternal);

var $gCGxQ = parcelRequire("gCGxQ");

});
parcelRegister("gCGxQ", function(module, exports) {
$parcel$export(module.exports, "dropTargetForExternal", () => $592fd1e67fe6cf8d$export$9edc779df9a85289);
$parcel$export(module.exports, "monitorForExternal", () => $592fd1e67fe6cf8d$export$bb1740f3194979c1);

var $lMcEJ = parcelRequire("lMcEJ");

var $lybba = parcelRequire("lybba");

var $hRRSY = parcelRequire("hRRSY");

var $5nWk7 = parcelRequire("5nWk7");

var $18Mfz = parcelRequire("18Mfz");

var $c4oqQ = parcelRequire("c4oqQ");

var $7NfnN = parcelRequire("7NfnN");
function $592fd1e67fe6cf8d$export$a8e56a860d7957c7({ type: type, value: value }) {
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $7NfnN.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $c4oqQ.textMediaType) && value === (0, $hRRSY.androidFallbackText)) return false;
    return true;
}
function $592fd1e67fe6cf8d$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter((type)=>$592fd1e67fe6cf8d$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        }));
}
function $592fd1e67fe6cf8d$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter((item)=>item.kind === 'file' || $592fd1e67fe6cf8d$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        }));
}
let $592fd1e67fe6cf8d$var$didDragStartLocally = false;
const $592fd1e67fe6cf8d$var$adapter = (0, $lybba.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $lMcEJ.bind)(window, {
            type: 'dragenter',
            listener (event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($592fd1e67fe6cf8d$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $5nWk7.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                const types = $592fd1e67fe6cf8d$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                const locked = {
                    types: types,
                    items: [],
                    getStringData: ()=>null
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload (event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            const items = $592fd1e67fe6cf8d$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            const nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData (mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    const value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$592fd1e67fe6cf8d$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $592fd1e67fe6cf8d$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $592fd1e67fe6cf8d$var$adapter.dropTarget(args);
}
function $592fd1e67fe6cf8d$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $592fd1e67fe6cf8d$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $592fd1e67fe6cf8d$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    const idle = {
        type: 'idle'
    };
    let state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $592fd1e67fe6cf8d$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $lMcEJ.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            },
            ...(0, $18Mfz.getBindingsForBrokenDrags)({
                onDragEnd: clear
            })
        ], // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $lMcEJ.bind)(window, {
        type: 'dragstart',
        listener () {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $592fd1e67fe6cf8d$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})();

});
parcelRegister("5nWk7", function(module, exports) {
$parcel$export(module.exports, "isEnteringWindow", () => $28796d024ad23246$export$d1c6f249e893cdf4);

var $f6IFE = parcelRequire("f6IFE");

var $fRUuX = parcelRequire("fRUuX");

var $fyJEp = parcelRequire("fyJEp");

var $hYVXV = parcelRequire("hYVXV");
function $28796d024ad23246$export$d1c6f249e893cdf4({ dragEnter: dragEnter }) {
    const { type: type, relatedTarget: relatedTarget } = dragEnter;
    if (type !== 'dragenter') return false;
    if ((0, $fRUuX.isSafari)()) return (0, $fyJEp.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $f6IFE.isFirefox)()) return (0, $hYVXV.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("6jaFJ", function(module, exports) {
$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", () => $0326b33f5d6d2e13$export$9c0606fcefb5d1e2);

var $lMcEJ = parcelRequire("lMcEJ");
parcelRequire("aagiU");
var $3YOxy = parcelRequire("3YOxy");
parcelRequire("lGCUJ");
var $bFFCv = parcelRequire("bFFCv");

var $a3A0d = parcelRequire("a3A0d");
function $0326b33f5d6d2e13$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $lMcEJ.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $bFFCv.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $3YOxy.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $0326b33f5d6d2e13$var$watchForInteractionStart({ start: start }) {
    return (0, $lMcEJ.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $0326b33f5d6d2e13$var$api = (0, $a3A0d.makeFixForAdapter)({
    watchForInteractionStart: $0326b33f5d6d2e13$var$watchForInteractionStart,
    watchForInteractionEnd: $0326b33f5d6d2e13$var$watchForInteractionEnd
});
function $0326b33f5d6d2e13$export$9c0606fcefb5d1e2() {
    return $0326b33f5d6d2e13$var$api.registerUsage();
}

});
parcelRegister("lGCUJ", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => (parcelRequire("bFFCv")).monitorForTextSelection);

var $bFFCv = parcelRequire("bFFCv");

});
parcelRegister("bFFCv", function(module, exports) {
$parcel$export(module.exports, "monitorForTextSelection", () => $fbc4d5804a4d4b99$export$2e178e3647f5e6e9);

var $lMcEJ = parcelRequire("lMcEJ");

var $eIGvm = parcelRequire("eIGvm");

var $lybba = parcelRequire("lybba");

var $3YOxy = parcelRequire("3YOxy");

var $fRUuX = parcelRequire("fRUuX");

var $gOjq2 = parcelRequire("gOjq2");

var $c4oqQ = parcelRequire("c4oqQ");

var $7NfnN = parcelRequire("7NfnN");
function $fbc4d5804a4d4b99$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $fRUuX.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $c4oqQ.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ const text = Array.from(event.target.childNodes).find((node)=>node.nodeType === Node.TEXT_NODE);
    return text ?? null;
}
const $fbc4d5804a4d4b99$var$honeyPotFix = (0, $eIGvm.makeHoneyPotFix)();
const $fbc4d5804a4d4b99$var$adapter = (0, $lybba.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount (api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $3YOxy.combine)($fbc4d5804a4d4b99$var$honeyPotFix.bindEvents(), (0, $lMcEJ.bind)(window, {
            type: 'dragstart',
            listener (event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $7NfnN.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $c4oqQ.textMediaType))) return;
                const target = $fbc4d5804a4d4b99$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                const payload = {
                    target: // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target,
                    plain: event.dataTransfer.getData((0, $c4oqQ.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $gOjq2.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $fbc4d5804a4d4b99$var$honeyPotFix.getOnPostDispatch()
});
function $fbc4d5804a4d4b99$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $fbc4d5804a4d4b99$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $fbc4d5804a4d4b99$var$adapter.registerUsage();
})();
function $fbc4d5804a4d4b99$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $fbc4d5804a4d4b99$var$adapter.monitor(args);
}

});
parcelRegister("gOjq2", function(module, exports) {
$parcel$export(module.exports, "HTMLMediaType", () => $dd0cbe580aaa876f$export$338a9f6c7a1f02b0);
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
const $dd0cbe580aaa876f$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("hI0hH", function(module, exports) {
$parcel$export(module.exports, "dialogHeight", () => $b4b6d3455b801c5a$export$ceba93bf0bdd16f2);
const $b4b6d3455b801c5a$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};

});

parcelRegister("7A8hu", function(module, exports) {
$parcel$export(module.exports, "dialogWidth", () => $99acda4c81ce155c$export$a3da89b899389ed8);

var $5VZRH = parcelRequire("5VZRH");
const $99acda4c81ce155c$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = (0, $5VZRH.width).values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${(0, $5VZRH.width).widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};

});
parcelRegister("5VZRH", function(module, exports) {
$parcel$export(module.exports, "width", () => $3b6789cb9d18bec5$export$7e3df82ee760448c);
const $3b6789cb9d18bec5$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};

});


parcelRegister("222JE", function(module, exports) {
$parcel$export(module.exports, "default", () => $51e18d70c0452652$export$2e2bcd8739ae039);
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.37.1 */ /* modal-dialog.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fxmw9 = parcelRequire("fxmw9");

var $5wgou = parcelRequire("5wgou");

var $jNU2T = parcelRequire("jNU2T");

var $a4Rr2 = parcelRequire("a4Rr2");

var $35XI7 = parcelRequire("35XI7");
var $fK4in = parcelRequire("fK4in");

var $6cMex = parcelRequire("6cMex");

var $93stz = parcelRequire("93stz");

var $3H4LK = parcelRequire("3H4LK");
parcelRequire("aagiU");
var $3YOxy = parcelRequire("3YOxy");

var $gn2Jn = parcelRequire("gn2Jn");

var $7DJCr = parcelRequire("7DJCr");

var $kELtn = parcelRequire("kELtn");

var $juRbr = parcelRequire("juRbr");

var $6jaFJ = parcelRequire("6jaFJ");

var $g6yvD = parcelRequire("g6yvD");

var $hI0hH = parcelRequire("hI0hH");

var $7A8hu = parcelRequire("7A8hu");

var $4LNuE = parcelRequire("4LNuE");
const $51e18d70c0452652$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $51e18d70c0452652$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k",
    motion: "_c71l1kw7 _p12f1kw7 _1e0c1txw _1jyk1jm9 _1if81osq",
    rootMotion: "_yakv1wug _4lht1wug",
    fullscreen: "_1jyk1osq"
};
const $51e18d70c0452652$var$viewportScrollStyles = null;
const $51e18d70c0452652$var$bodyScrollStyles = null;
const $51e18d70c0452652$var$ModalDialog = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: autoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false, UNSAFE_shouldDisableMotionUplift: UNSAFE_shouldDisableMotionUplift = false } = props;
    const id = (0, $a4Rr2.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog';
    (0, $4fqPo.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $3YOxy.combine)((0, $kELtn.disableDraggingToCrossOriginIFramesForElement)(), (0, $6jaFJ.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $juRbr.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $jNU2T.default)(autoFocus, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $7DJCr.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $4fqPo.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $35XI7.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $fK4in.useLayering)();
    return /*#__PURE__*/ $4fqPo.createElement((0, $4LNuE.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $4fqPo.createElement((0, $gn2Jn.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $4fqPo.createElement((0, $g6yvD.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, !UNSAFE_shouldDisableMotionUplift && (0, $3H4LK.fg)('platform-dst-motion-uplift-modal') ? /*#__PURE__*/ $4fqPo.createElement((0, $6cMex.default), {
        enteringAnimation: "var(--ds-modal-enter, 250ms cubic-bezier(0.4, 0, 0, 1) ScaleIn95to100)",
        exitingAnimation: "var(--ds-modal-exit, 200ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to95)",
        onFinish: onMotionFinish,
        xcss: (0, $fxmw9.cx)($51e18d70c0452652$var$dialogStyles.motion, isFullScreen && $51e18d70c0452652$var$dialogStyles.fullscreen),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $7A8hu.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $hI0hH.dialogHeight)(height)
        }
    }, /*#__PURE__*/ $4fqPo.createElement("section", {
        "aria-label": label,
        ref: (0, $5wgou.default)([
            motionRef,
            ref
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-width': (0, $7A8hu.dialogWidth)(width),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--modal-dialog-height': (0, $hI0hH.dialogHeight)(height)
        },
        role: "dialog",
        "aria-labelledby": label ? undefined : titleId,
        "data-testid": defaultTestId,
        "data-modal-stack": stackIndex,
        tabIndex: -1,
        "aria-modal": true,
        "data-ds--level": currentLevel,
        className: (0, $ltgDR.default)([
            $51e18d70c0452652$var$dialogStyles.root,
            $51e18d70c0452652$var$dialogStyles.rootMotion,
            !isFullScreen && $51e18d70c0452652$var$dialogStyles.borderRadius,
            !isFullScreen && (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $51e18d70c0452652$var$dialogStyles.borderRadiusT26Shape,
            shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7"
        ])
    }, children)) : /*#__PURE__*/ $4fqPo.createElement((0, $93stz.default), {
        /**
         * We don't want a 'slide in' for the full screen modals.
         */ entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, (bottomFadeInProps)=>/*#__PURE__*/ $4fqPo.createElement("section", {
            ...bottomFadeInProps,
            "aria-label": label,
            ref: (0, $5wgou.default)([
                bottomFadeInProps.ref,
                motionRef,
                ref
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $7A8hu.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $hI0hH.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $ltgDR.default)([
                $51e18d70c0452652$var$dialogStyles.root,
                !isFullScreen && $51e18d70c0452652$var$dialogStyles.borderRadius,
                !isFullScreen && (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $51e18d70c0452652$var$dialogStyles.borderRadiusT26Shape,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }, children)))));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc, @atlaskit/volt-strict-mode/no-multiple-exports
$51e18d70c0452652$export$2e2bcd8739ae039 = $51e18d70c0452652$var$ModalDialog;

});
parcelRegister("35XI7", function(module, exports) {
$parcel$export(module.exports, "useCloseOnEscapePress", () => $5b642cd9b81a4edc$export$4a4bf067ea9e7886);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $fK4in = parcelRequire("fK4in");
const $5b642cd9b81a4edc$var$ESCAPE = 'Escape';
function $5b642cd9b81a4edc$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $4fqPo.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = (0, $fK4in.useLayering)();
    const onKeyDown = (0, $4fqPo.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $5b642cd9b81a4edc$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $4fqPo.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $4fqPo.useEffect)(()=>{
        return (0, $lMcEJ.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}

});
parcelRegister("fK4in", function(module, exports) {
$parcel$export(module.exports, "useLayering", () => $dd4882236567efff$export$c8b4d54e03dee6ed);

var $4fqPo = parcelRequire("4fqPo");

var $awcaa = parcelRequire("awcaa");

var $eKvEu = parcelRequire("eKvEu");

var $jfTcT = parcelRequire("jfTcT");
function $dd4882236567efff$export$c8b4d54e03dee6ed() {
    const currentLevel = (0, $4fqPo.useContext)((0, $awcaa.LevelContext));
    const layerNode = (0, $4fqPo.useContext)((0, $eKvEu.LevelNodeContext));
    const rootNode = (0, $4fqPo.useContext)((0, $jfTcT.RootNodeContext));
    const isLayerDisabled = (0, $4fqPo.useCallback)(()=>{
        // This is an impossible case, added for type safety
        if (!(layerNode !== null && layerNode !== void 0 && layerNode.current) || !(rootNode !== null && rootNode !== void 0 && rootNode.current)) return false;
        return layerNode.current.getLevel() < rootNode.current.getHeight();
    }, [
        layerNode,
        rootNode
    ]);
    const getTopLevel = (0, $4fqPo.useCallback)(()=>rootNode !== null && rootNode !== void 0 && rootNode.current ? rootNode.current.getHeight() : null, [
        rootNode
    ]);
    return {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    };
}

});


parcelRegister("7DJCr", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a779e8337e04d41$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $7a779e8337e04d41$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $4fqPo.useRef)(null);
    const onMotionFinish = (0, $4fqPo.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("4LNuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $92ce2d4e25a63582$export$2e2bcd8739ae039);
/* positioner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $5Aw5C = parcelRequire("5Aw5C");

var $cR2qL = parcelRequire("cR2qL");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
const $92ce2d4e25a63582$var$positionerStyles = null;
const $92ce2d4e25a63582$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
};
// Hardcoded pixels are based off a 60px base gutter
const $92ce2d4e25a63582$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $92ce2d4e25a63582$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $92ce2d4e25a63582$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $92ce2d4e25a63582$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $cR2qL.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $5Aw5C.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $92ce2d4e25a63582$var$stackStyles.stackTransition,
            stackIndex > 0 ? $92ce2d4e25a63582$var$stackStyles.stackTransform : $92ce2d4e25a63582$var$stackStyles.stackIdle,
            $92ce2d4e25a63582$var$scrollStyles[scrollBehavior]
        ])
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$92ce2d4e25a63582$export$2e2bcd8739ae039 = $92ce2d4e25a63582$var$Positioner;

});




parcelRegister("dOhHl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $f4b9f9d0056462a1$export$2e2bcd8739ae039);
/* modal-body.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $lBtjT = parcelRequire("lBtjT");

var $f2YSn = parcelRequire("f2YSn");

var $dgY6A = parcelRequire("dgY6A");

var $h5Ws7 = parcelRequire("h5Ws7");
const $f4b9f9d0056462a1$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $f4b9f9d0056462a1$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $f2YSn.useModal)();
    const shouldScrollInViewport = (0, $h5Ws7.default)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            $f4b9f9d0056462a1$var$styles.root,
            hasInlinePadding && $f4b9f9d0056462a1$var$styles.paddingInline
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lBtjT.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dgY6A.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            $f4b9f9d0056462a1$var$styles.root,
            /**
       * Adding block padding for scroll keylines, which are only shown when the scrolling
       * is on the container.
       */ $f4b9f9d0056462a1$var$styles.paddingBlock,
            hasInlinePadding && $f4b9f9d0056462a1$var$styles.paddingInline
        ])
    }, children)));
};
var $f4b9f9d0056462a1$export$2e2bcd8739ae039 = $f4b9f9d0056462a1$var$ModalBody;

});
parcelRegister("f2YSn", function(module, exports) {
$parcel$export(module.exports, "useModal", () => $1f0a7d64dc17fbad$export$33ffd74ebf07f060);

var $4fqPo = parcelRequire("4fqPo");

var $gn2Jn = parcelRequire("gn2Jn");
const $1f0a7d64dc17fbad$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $4fqPo.useContext)((0, $gn2Jn.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("dgY6A", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab723f316d9cc580$export$2e2bcd8739ae039);
/* scroll-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* scroll-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $c1P93 = parcelRequire("c1P93");

var $fxmw9 = parcelRequire("fxmw9");

var $5wgou = parcelRequire("5wgou");

var $c1tmZ = parcelRequire("c1tmZ");

var $9PZQT = parcelRequire("9PZQT");

var $gesza = parcelRequire("gesza");
const $ab723f316d9cc580$var$keylineColor = "var(--ds-border, #0B120E24)";
const $ab723f316d9cc580$var$styles = {
    base: "_kkes1kw7 _1e0c1kw7 _2lx21kw7 _16jlkb7n _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2ia51",
    bottomKeyline: "_179ria51"
};
const $ab723f316d9cc580$var$keylineHeight = 1;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $ab723f316d9cc580$var$ScrollContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $4fqPo.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $4fqPo.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $4fqPo.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $4fqPo.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $4fqPo.useEffect)(()=>{
        const schedule = (0, $c1P93.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $9PZQT.default)((0, $c1P93.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $ab723f316d9cc580$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $ab723f316d9cc580$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $4fqPo.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $lMcEJ.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $lMcEJ.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $c1tmZ.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gesza.default), {
        as: "div",
        isInset: true,
        // tabindex is allowed here so that keyboard users can scroll content
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $5wgou.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $fxmw9.cx)($ab723f316d9cc580$var$styles.base, showTopKeyline && $ab723f316d9cc580$var$styles.topKeyline, showBottomKeyline && $ab723f316d9cc580$var$styles.bottomKeyline)
    }, children);
});
$ab723f316d9cc580$var$ScrollContainer.displayName = 'ScrollContainer';
var $ab723f316d9cc580$export$2e2bcd8739ae039 = $ab723f316d9cc580$var$ScrollContainer;

});

parcelRegister("h5Ws7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c02a55cea499cb5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $g6yvD = parcelRequire("g6yvD");
function $8c02a55cea499cb5$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $4fqPo.useContext)((0, $g6yvD.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("9JX4B", function(module, exports) {
$parcel$export(module.exports, "ModalBody", () => $fd413fae074e0602$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $fd413fae074e0602$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $fd413fae074e0602$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $fd413fae074e0602$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $fd413fae074e0602$export$c245e9f76e3299b1);
/* modal.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $7fscZ = parcelRequire("7fscZ");
const $fd413fae074e0602$var$modalBodyStyles = null;
const $fd413fae074e0602$var$modalHeadingStyles = null;
const $fd413fae074e0602$var$modalImageStyles = null;
const $fd413fae074e0602$var$modalActionContainerStyles = null;
const $fd413fae074e0602$var$modalActionContainerReversedStyles = null;
const $fd413fae074e0602$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
};
const $fd413fae074e0602$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ])
    }, children);
const $fd413fae074e0602$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ $4fqPo.createElement("h1", {
        id: id,
        className: (0, $ltgDR.default)([
            "_11c81af2 _syaz1kw7 _6rthu2gc"
        ])
    }, children);
};
const $fd413fae074e0602$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ $4fqPo.createElement("img", {
        alt: alt,
        src: src,
        className: (0, $ltgDR.default)([
            "_1bsb1osq _4t3i1wug _5fbcfajl _1s1gfajl _j722idpf"
        ])
    });
const $fd413fae074e0602$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ])
    }, children);
const $fd413fae074e0602$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $fd413fae074e0602$var$modalActionItemStyles.root
    }, children);

});

parcelRegister("56UAo", function(module, exports) {
$parcel$export(module.exports, "spotlightButtonTheme", () => $ca7be3bf8f870225$export$39a36121076ca24);
$parcel$export(module.exports, "modalButtonTheme", () => $ca7be3bf8f870225$export$d131eb21ba4cbd16);
const $ca7be3bf8f870225$var$spotlightTheme = {
    default: {
        background: {
            default: "var(--ds-background-inverse-subtle, #00000029)",
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: "var(--ds-background-disabled, #0515240F)",
            selected: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            focus: "var(--ds-background-inverse-subtle, #00000029)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    subtle: {
        background: {
            default: 'none',
            hover: "var(--ds-background-inverse-subtle-hovered, #0000003D)",
            active: "var(--ds-background-inverse-subtle-pressed, #00000052)",
            disabled: 'none',
            selected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            },
            focusSelected: {
                light: "var(--ds-background-selected-hovered, #CFE1FD)",
                dark: "var(--ds-background-selected-hovered, #CFE1FD)"
            }
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-disabled, #080F214A)",
            selected: "var(--ds-text-inverse, #FFFFFF)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    },
    'subtle-link': {
        textDecoration: {
            hover: `underline ${"var(--ds-text-inverse, #FFFFFF)"}`
        },
        textDecorationLine: {
            active: 'none'
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            hover: "var(--ds-text-inverse, #FFFFFF)",
            active: "var(--ds-text-inverse, #FFFFFF)",
            disabled: "var(--ds-text-discovery, #803FA5)",
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
const $ca7be3bf8f870225$var$modalTheme = {
    primary: {
        background: {
            default: "var(--ds-background-discovery-bold, #964AC0)",
            hover: "var(--ds-background-discovery-bold-hovered, #803FA5)",
            active: "var(--ds-background-discovery-bold-pressed, #673286)",
            disabled: {
                light: "var(--ds-background-disabled, #0515240F)",
                dark: "var(--ds-background-disabled, #0515240F)"
            },
            selected: "var(--ds-background-selected-hovered, #CFE1FD)",
            focus: "var(--ds-background-discovery-bold-hovered, #803FA5)"
        },
        color: {
            default: "var(--ds-text-inverse, #FFFFFF)",
            disabled: {
                light: "var(--ds-text-disabled, #080F214A)",
                dark: "var(--ds-text-disabled, #080F214A)"
            },
            selected: "var(--ds-text-selected, #1868DB)",
            focus: "var(--ds-text-inverse, #FFFFFF)"
        }
    }
};
function $ca7be3bf8f870225$var$extract(newTheme, { mode: mode, appearance: appearance, state: state }) {
    if (!newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!node[item]) return undefined;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return undefined;
            }
            node = node[item];
            return undefined;
        });
        return acc;
    }, {});
}
const $ca7be3bf8f870225$export$39a36121076ca24 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$ca7be3bf8f870225$var$extract($ca7be3bf8f870225$var$spotlightTheme, themeProps)
        },
        ...rest
    };
};
const $ca7be3bf8f870225$export$d131eb21ba4cbd16 = (current, themeProps)=>{
    const { buttonStyles: buttonStyles, ...rest } = current(themeProps);
    return {
        buttonStyles: {
            ...buttonStyles,
            ...$ca7be3bf8f870225$var$extract($ca7be3bf8f870225$var$modalTheme, themeProps)
        },
        ...rest
    };
};

});





parcelRegister("laViG", function(module, exports) {
$parcel$export(module.exports, "default", () => $7efc42ac3a084bc0$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");

var $4HbRw = parcelRequire("4HbRw");

var $ggWTW = parcelRequire("ggWTW");

var $kEONT = parcelRequire("kEONT");
const $7efc42ac3a084bc0$var$EngagementProviderWithEvents = (0, $as4kh.default)()((0, $kEONT.EngagementProvider));
const $7efc42ac3a084bc0$var$EngagementProviderWithDefaultStore = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7efc42ac3a084bc0$var$EngagementProviderWithEvents, {
        ...props,
        store: (0, $ggWTW.default)(props.config)
    });
};
// eslint-disable-next-line camelcase
const $7efc42ac3a084bc0$var$_default_1 = (0, $4HbRw.default)($7efc42ac3a084bc0$var$EngagementProviderWithDefaultStore);
var // eslint-disable-next-line camelcase
$7efc42ac3a084bc0$export$2e2bcd8739ae039 = $7efc42ac3a084bc0$var$_default_1;

});
parcelRegister("4HbRw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aff6d065e7e8712$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $6aff6d065e7e8712$export$2e2bcd8739ae039(Component) {
    const PreventNestedInstancesContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(false);
    return function PreventNestedInstances(props) {
        return(// TODO: Replace usage of PreventNestedInstancesContext.Consumer with useContext(PreventNestedInstancesContext)
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(PreventNestedInstancesContext.Consumer, null, (shouldPreventInstantiation)=>shouldPreventInstantiation ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(PreventNestedInstancesContext.Provider, {
                value: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, props))));
    };
}

});

parcelRegister("ggWTW", function(module, exports) {
$parcel$export(module.exports, "store", () => $c59d69f97da0ae98$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "default", () => $c59d69f97da0ae98$export$2e2bcd8739ae039);

var $2186w = parcelRequire("2186w");
parcelRequire("2pQ8V");
var $8Snhx = parcelRequire("8Snhx");

var $7XQDZ = parcelRequire("7XQDZ");

var $6LePX = parcelRequire("6LePX");

var $eSdXt = parcelRequire("eSdXt");

var $bVukM = parcelRequire("bVukM");
const $c59d69f97da0ae98$export$36d128238e6b60f5 = {
    messageMapping: new Map(),
    current: null,
    initialized: false,
    initializing: false,
    config: {
        cloudId: '',
        aaid: '',
        locale: '',
        product: '',
        stargateUrl: '',
        orgId: '',
        workspaceId: ''
    }
};
let $c59d69f97da0ae98$var$processMessagesCancellationToken = (0, $7XQDZ.createCancellationToken)();
function $c59d69f97da0ae98$export$7a10f46f72407bc5(messageMapping, component) {
    const newMapping = new Map();
    messageMapping.forEach((value, key)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($2186w)))(value.component, component)) newMapping.set(key, value);
    });
    return newMapping;
}
const $c59d69f97da0ae98$export$6f57813fe9f31bf9 = (0, $8Snhx.default)((state = $c59d69f97da0ae98$export$36d128238e6b60f5, action)=>{
    switch(action.type){
        case 0, $eSdXt.SET_MESSAGE_MAPPING:
            return {
                ...state,
                initialized: true,
                initializing: false,
                messageMapping: action.messageMapping
            };
        case 0, $eSdXt.SET_INITIALIZING:
            return {
                ...state,
                config: action.config,
                initializing: true
            };
        case 0, $eSdXt.SET_CURRENT:
            {
                const { eventMapping: eventMapping } = action;
                const { message: message, component: component } = eventMapping;
                const messageMapping = $c59d69f97da0ae98$export$7a10f46f72407bc5(state.messageMapping, component);
                return {
                    ...state,
                    current: {
                        messageId: message.messageId,
                        variationId: message.variationId,
                        ...component
                    },
                    messageMapping: messageMapping
                };
            }
        case 0, $eSdXt.CLEAR_CURRENT:
            return {
                ...state,
                current: null
            };
        case 0, $eSdXt.RESET_STORE:
            return $c59d69f97da0ae98$export$36d128238e6b60f5;
        default:
            return state;
    }
});
var $c59d69f97da0ae98$export$2e2bcd8739ae039 = (config)=>{
    const state = $c59d69f97da0ae98$export$6f57813fe9f31bf9.getState();
    if (state.initializing || state.initialized) {
        if (state.config.cloudId === config.cloudId) return $c59d69f97da0ae98$export$6f57813fe9f31bf9;
        // CloudId has changed, cancel any in process processMessages request
        $c59d69f97da0ae98$var$processMessagesCancellationToken.isCancelled = true;
        $c59d69f97da0ae98$var$processMessagesCancellationToken = (0, $7XQDZ.createCancellationToken)();
        $c59d69f97da0ae98$export$6f57813fe9f31bf9.dispatch((0, $eSdXt.resetStore)());
    }
    const newConfig = {
        ...config
    };
    newConfig.locale = newConfig.locale.replace('_', '-');
    $c59d69f97da0ae98$export$6f57813fe9f31bf9.dispatch((0, $eSdXt.initialize)(newConfig));
    if ((0, $6LePX.isMessagingEnabled)()) (0, $bVukM.processMessages)($c59d69f97da0ae98$export$6f57813fe9f31bf9, newConfig, $c59d69f97da0ae98$var$processMessagesCancellationToken);
    return $c59d69f97da0ae98$export$6f57813fe9f31bf9;
};

});
parcelRegister("2186w", function(module, exports) {

var $h4aRS = parcelRequire("h4aRS");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $1781f61af7f866a8$var$isEqual(value, other) {
    return $h4aRS(value, other);
}
module.exports = $1781f61af7f866a8$var$isEqual;

});

parcelRegister("7XQDZ", function(module, exports) {
$parcel$export(module.exports, "createCancellationToken", () => $fc1673fdc670887e$export$eac027797b968991);
function $fc1673fdc670887e$export$eac027797b968991(isCancelled = false) {
    return {
        isCancelled: isCancelled
    };
}

});

parcelRegister("6LePX", function(module, exports) {
$parcel$export(module.exports, "isMessagingEnabled", () => $8ce0f4d4cc2f7ea8$export$a77934ac158768dd);

var $dvNUn = parcelRequire("dvNUn");
function $8ce0f4d4cc2f7ea8$export$a77934ac158768dd() {
    return !(0, $dvNUn.isFedRamp)();
}

});

parcelRegister("eSdXt", function(module, exports) {
$parcel$export(module.exports, "SET_MESSAGE_MAPPING", () => $d4923068f8c8c75e$export$d05fe3e897340c89);
$parcel$export(module.exports, "SET_INITIALIZING", () => $d4923068f8c8c75e$export$eacd3ec165715d8);
$parcel$export(module.exports, "RESET_STORE", () => $d4923068f8c8c75e$export$874c5149d7f0e3b8);
$parcel$export(module.exports, "CLEAR_CURRENT", () => $d4923068f8c8c75e$export$cb5041d68cb18859);
$parcel$export(module.exports, "SET_CURRENT", () => $d4923068f8c8c75e$export$a9319af002a4c677);
$parcel$export(module.exports, "resetStore", () => $d4923068f8c8c75e$export$a20a1205b2a2b7e4);
$parcel$export(module.exports, "initialize", () => $d4923068f8c8c75e$export$2a47f398eeff8b01);
$parcel$export(module.exports, "setMessageMapping", () => $d4923068f8c8c75e$export$375dd0a76fecd4c7);
$parcel$export(module.exports, "setCurrent", () => $d4923068f8c8c75e$export$5f80f094fd31fffd);
$parcel$export(module.exports, "clearCurrent", () => $d4923068f8c8c75e$export$96105f873ade39d7);
const $d4923068f8c8c75e$export$d05fe3e897340c89 = 'SET_MESSAGE_MAPPING';
const $d4923068f8c8c75e$export$eacd3ec165715d8 = 'SET_INITIALIZING';
const $d4923068f8c8c75e$export$874c5149d7f0e3b8 = 'RESET_STORE';
const $d4923068f8c8c75e$export$cb5041d68cb18859 = 'CLEAR_CURRENT';
const $d4923068f8c8c75e$export$a9319af002a4c677 = 'SET_CURRENT';
const $d4923068f8c8c75e$export$a20a1205b2a2b7e4 = ()=>({
        type: $d4923068f8c8c75e$export$874c5149d7f0e3b8
    });
const $d4923068f8c8c75e$export$2a47f398eeff8b01 = (config)=>({
        type: $d4923068f8c8c75e$export$eacd3ec165715d8,
        config: config
    });
const $d4923068f8c8c75e$export$375dd0a76fecd4c7 = (messageMapping)=>({
        type: $d4923068f8c8c75e$export$d05fe3e897340c89,
        messageMapping: messageMapping
    });
function $d4923068f8c8c75e$export$5f80f094fd31fffd(eventMapping) {
    return {
        type: $d4923068f8c8c75e$export$a9319af002a4c677,
        eventMapping: eventMapping
    };
}
function $d4923068f8c8c75e$export$96105f873ade39d7() {
    return {
        type: $d4923068f8c8c75e$export$cb5041d68cb18859
    };
}

});

parcelRegister("bVukM", function(module, exports) {
$parcel$export(module.exports, "processMessages", () => $602def995d7e3a61$export$d2e92820f98a2592);

var $3WqgR = parcelRequire("3WqgR");

var $eSdXt = parcelRequire("eSdXt");

var $ggWTW = parcelRequire("ggWTW");
const $602def995d7e3a61$export$a9d4ce3abb5d2365 = (messages)=>{
    const mapping = new Map();
    messages.forEach((message)=>{
        const components = message.components;
        components.forEach((component, index)=>{
            component.triggers.forEach((trigger)=>{
                mapping.set(trigger, {
                    message: message,
                    component: {
                        componentId: index,
                        isLast: index === components.length - 1,
                        ...component
                    }
                });
            });
        });
    });
    return mapping;
};
async function $602def995d7e3a61$export$d2e92820f98a2592(engagementStore, config, cancellationToken) {
    if (cancellationToken.isCancelled) return;
    const state = (0, $ggWTW.store).getState();
    const { cloudId: cloudId, stargateUrl: stargateUrl, product: product, locale: locale } = config;
    let messages, interval;
    try {
        const results = await (0, $3WqgR.getMessages)(cloudId, stargateUrl, product, locale);
        if (cancellationToken.isCancelled) return;
        messages = results.messages;
        interval = results.interval;
    } catch (e) {
        // TODO: Configure metal to monitor errors here
        // Give up, don't try fetching again
        return;
    }
    // Don't overwrite the messageMapping if there's an active message
    if (state.current === null) {
        const messageMapping = $602def995d7e3a61$export$a9d4ce3abb5d2365(messages);
        engagementStore.dispatch((0, $eSdXt.setMessageMapping)(messageMapping));
    }
    if (interval !== 0) setTimeout(()=>{
        $602def995d7e3a61$export$d2e92820f98a2592(engagementStore, config, cancellationToken);
    }, interval * 1000);
// TODO: Configure metal to monitor success response here
}

});


parcelRegister("kEONT", function(module, exports) {
$parcel$export(module.exports, "EngagementProvider", () => $726433c0b80621eb$export$83b8ae7ce7b4d59c);
/* eslint-disable max-lines */ 
var $4fqPo = parcelRequire("4fqPo");

var $5Jqmb = parcelRequire("5Jqmb");

var $h0NjX = parcelRequire("h0NjX");

var $4S7MC = parcelRequire("4S7MC");

var $9PfBO = parcelRequire("9PfBO");

var $kvj1k = parcelRequire("kvj1k");
var $73FZL = parcelRequire("73FZL");

var $5S02O = parcelRequire("5S02O");
var $cJbbj = parcelRequire("cJbbj");

var $3WqgR = parcelRequire("3WqgR");

var $ebLpi = parcelRequire("ebLpi");

var $5EQ0O = parcelRequire("5EQ0O");

var $i8O7m = parcelRequire("i8O7m");

var $6LePX = parcelRequire("6LePX");

var $eSdXt = parcelRequire("eSdXt");

var $5PcED = parcelRequire("5PcED");
const $726433c0b80621eb$var$MAX_EVENT_QUEUE_SIZE = 100;
const $726433c0b80621eb$var$EK_LOADED_EVENT = 'engagement.inproduct.loaded';
const $726433c0b80621eb$export$5306bd00631dbf8c = 'ep.analyticEvent';
function $726433c0b80621eb$var$collapseEventToPayload(event) {
    const payload = {
        ...event.payload,
        context: {}
    };
    Object.assign(payload.context, ...event.context);
    return payload;
}
function $726433c0b80621eb$var$findMatchingTrigger(messageMapping, payload) {
    return Array.from(messageMapping.keys()).find((trigger)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Jqmb)))(payload, trigger);
    });
}
function $726433c0b80621eb$var$fireExposureEvent(attributes, clientOrPromise) {
    const analyticsEvent = new (0, $kvj1k.default)({
        payload: {
            action: 'exposed',
            actionSubject: 'feature',
            actionSubjectId: attributes.flagKey,
            source: 'engagement-platform',
            attributes: attributes
        }
    });
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendTrackEvent(analyticsEvent.payload);
    });
}
function $726433c0b80621eb$var$getExposureAttributes(messageId, cohort, additionalProps) {
    return {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        flagKey: `engagement.inproduct.${messageId}`,
        value: cohort,
        ...additionalProps
    };
}
function $726433c0b80621eb$var$getBaseAttributes(messageId, variationId, componentId, locale) {
    return {
        messageId: messageId,
        variationId: variationId,
        componentIndex: componentId,
        locale: locale
    };
}
async function $726433c0b80621eb$export$473a2bbbfd90c87b(eventMapping, config, store, clientOrPromise, coordinationOptions, componentConfig) {
    const { locale: locale } = config;
    const { message: message, component: component } = eventMapping;
    if (message.holdout) {
        await (0, $3WqgR.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        await (0, $3WqgR.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        $726433c0b80621eb$var$fireExposureEvent($726433c0b80621eb$var$getExposureAttributes(message.messageId, 'holdout', {
            locale: locale
        }), clientOrPromise);
        return;
    }
    if (component.componentId === 0) {
        const success = await (0, $3WqgR.startMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: message.messageId,
            variationId: message.variationId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions !== null && coordinationOptions !== void 0 && coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(success ? (0, $5S02O.MessageDeliveryStatus).STARTED : (0, $5S02O.MessageDeliveryStatus).BLOCKED);
        if (success) {
            $726433c0b80621eb$var$fireExposureEvent($726433c0b80621eb$var$getExposureAttributes(message.messageId, message.variationId, {
                locale: locale
            }), clientOrPromise);
            store.dispatch((0, $eSdXt.setCurrent)(eventMapping));
        }
    } else {
        $726433c0b80621eb$var$fireExposureEvent($726433c0b80621eb$var$getExposureAttributes(message.messageId, message.variationId, {
            locale: locale
        }), clientOrPromise);
        store.dispatch((0, $eSdXt.setCurrent)(eventMapping));
    }
}
class $726433c0b80621eb$export$83b8ae7ce7b4d59c extends (0, $4fqPo.Component) {
    static #_ = this.componentConfig = new Map();
    static #_2 = this.childContextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
    };
    static #_3 = this.defaultProps = {
        eventTarget: (0, (/*@__PURE__*/$parcel$interopDefault($9PfBO)))
    };
    static #_4 = /*
   * We use this flag for ensuring that we only fire the engagement.inproduct.loaded event once. This is an interim solution
   * until we can more holistically rethink our code architecture to eliminate duplicate behaviour across EngagementProviders.
   */ this.hasInitializedAtLeastOneEngagementProvider = false;
    constructor(props){
        super(props), this.onStoreChange = (state)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const config = this.getConfig();
            const { locale: locale } = config;
            if (state.initialized) {
                if (!$726433c0b80621eb$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider) {
                    this.sendOperationalEventWithClient({
                        action: 'loaded',
                        actionSubject: 'messages',
                        actionSubjectId: undefined,
                        source: 'engagekit',
                        attributes: {
                            locale: locale
                        }
                    });
                    const browserInfo = (0, $5EQ0O.getBrowserInfo)();
                    this.onEvent(createAnalyticsEvent({
                        event: $726433c0b80621eb$var$EK_LOADED_EVENT,
                        properties: {
                            browser: browserInfo.name,
                            browserVersion: browserInfo.version
                        }
                    }));
                    $726433c0b80621eb$export$83b8ae7ce7b4d59c.hasInitializedAtLeastOneEngagementProvider = true;
                }
                this.analyticsEventQueue.flush(this.onEvent);
                if (this.unsubscribeFromStore) this.unsubscribeFromStore();
            }
        }, this.onEvent = (event)=>{
            var _eventMapping$compone;
            const state = this.getState();
            if (!state.initialized) {
                const success = this.analyticsEventQueue.enqueue(event);
                if (!success) this.fireQueueOverflowEvent();
                return;
            }
            const { eventTarget: eventTarget, store: store, analyticsClientInstance: analyticsClientInstance } = this.props;
            const config = this.getConfig();
            const { current: current, messageMapping: messageMapping } = state;
            const payload = $726433c0b80621eb$var$collapseEventToPayload(event);
            eventTarget.dispatchEvent((0, $i8O7m.default)({
                eventName: $726433c0b80621eb$export$5306bd00631dbf8c,
                canBubble: false,
                cancellable: false,
                detail: payload
            }));
            if (!(0, $6LePX.isMessagingEnabled)()) return;
            // existing message found
            if (current) return;
            const trigger = $726433c0b80621eb$var$findMatchingTrigger(messageMapping, payload);
            // No messages found for trigger
            if (!trigger) return;
            const eventMapping = messageMapping.get(trigger);
            let componentConfig;
            if ((_eventMapping$compone = eventMapping.component) !== null && _eventMapping$compone !== void 0 && _eventMapping$compone.componentType) {
                const componentConfigId = this.getConfigId(eventMapping.component.componentType, eventMapping.component.target);
                componentConfig = $726433c0b80621eb$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
            }
            const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
            $726433c0b80621eb$export$473a2bbbfd90c87b(eventMapping, config, store, analyticsClientInstance, coordinationOptions, componentConfig);
        }, this.onEngagementEvent = (event)=>{
            const { action: action, clickType: clickType, ekMessageId: ekMessageId, ekVariationId: ekVariationId, ekComponentId: ekComponentId, ekComponentType: ekComponentType, ekIsLast: ekIsLast } = event.payload;
            const config = this.getConfig();
            const { locale: locale } = config;
            const attributes = $726433c0b80621eb$var$getBaseAttributes(ekMessageId, ekVariationId, ekComponentId, locale);
            if (action === 'click') {
                this.handleClickEvent(ekMessageId, ekVariationId, ekComponentId);
                attributes.buttonType = clickType;
                this.sendUIEventWithClient({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: `${clickType}Button`,
                    source: `engagement_${ekComponentType}`,
                    attributes: attributes
                });
            } else {
                if (action === 'shown') {
                    attributes.componentType = ekComponentType;
                    this.sendScreenEventWithClient({
                        name: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
                if (action === 'hidden') {
                    attributes.isLast = ekIsLast;
                    this.sendUIEventWithClient({
                        action: 'hid',
                        actionSubject: 'component',
                        actionSubjectId: undefined,
                        source: `engagement_${ekComponentType}`,
                        attributes: attributes
                    });
                }
            }
            this.onEvent(event);
        }, this.subscribeEngagementState = (callback)=>{
            const { store: store } = this.props;
            callback(store.getState());
            return store.subscribe(()=>{
                callback(store.getState());
            });
        }, this.getComponentCoordinationOptions = (componentConfig)=>{
            var _this$props$coordinat;
            // Default enableChoreographer to the EngagementProvider's coordinationOptions
            const enableChoreographer = Boolean((_this$props$coordinat = this.props.coordinationOptions) === null || _this$props$coordinat === void 0 ? void 0 : _this$props$coordinat.enableChoreographer);
            return {
                ...this.props.coordinationOptions,
                enableChoreographer: componentConfig !== null && componentConfig !== void 0 && componentConfig.messageType ? // Use the component's individual choreographer configuration, if defined,
                // regardless of the EngagementProvider's coordinationOptions
                (0, $cJbbj.shouldBeChoreographed)(componentConfig, {
                    enableChoreographer: true
                }) : enableChoreographer
            };
        }, this.getConfigId = (componentType, engagementId)=>{
            return engagementId ? `${componentType}-${engagementId}` : componentType;
        }, this.setComponentConfig = (componentType, config, engagementId)=>{
            const configId = this.getConfigId(componentType, engagementId);
            $726433c0b80621eb$export$83b8ae7ce7b4d59c.componentConfig.set(configId, config);
            return ()=>this.removeComponentConfig(configId);
        }, this.removeComponentConfig = (configId)=>{
            if ($726433c0b80621eb$export$83b8ae7ce7b4d59c.componentConfig.has(configId)) $726433c0b80621eb$export$83b8ae7ce7b4d59c.componentConfig.delete(configId);
        };
        const { analyticsClientInstance: analyticsClientInstance } = this.props;
        this.sendUIEventWithClient = (0, $ebLpi.sendUIEvent).bind(null, analyticsClientInstance);
        this.sendScreenEventWithClient = (0, $ebLpi.sendScreenEvent).bind(null, analyticsClientInstance);
        this.sendOperationalEventWithClient = (0, $ebLpi.sendOperationalEvent).bind(null, analyticsClientInstance);
        this.analyticsEventQueue = new (0, $5PcED.default)($726433c0b80621eb$var$MAX_EVENT_QUEUE_SIZE);
        this.unsubscribeFromStore = this.subscribeEngagementState(this.onStoreChange);
        this.fireQueueOverflowEvent = (0, (/*@__PURE__*/$parcel$interopDefault($h0NjX)))(// TODO: create metric for this with Metal
        ()=>{});
    }
    getConfig() {
        const { config: config } = this.getState();
        return config;
    }
    getChildContext() {
        return {
            subscribeEngagementState: this.subscribeEngagementState,
            setComponentConfig: this.setComponentConfig
        };
    }
    getState() {
        return this.props.store.getState();
    }
    getActiveMessage() {
        return this.getState().current;
    }
    async completeMessage(messageId, componentConfig) {
        const config = this.getConfig();
        const coordinationOptions = this.getComponentCoordinationOptions(componentConfig);
        const disposition = await (0, $3WqgR.stopMessage)({
            cloudId: config.cloudId,
            stargateUrl: config.stargateUrl,
            messageId: messageId,
            orgId: config.orgId,
            workspaceId: config.workspaceId
        }, coordinationOptions);
        if (coordinationOptions.enableChoreographer && componentConfig !== null && componentConfig !== void 0 && componentConfig.onMessageDisposition) componentConfig.onMessageDisposition(disposition ? (0, $5S02O.MessageDeliveryStatus).STOPPED : (0, $5S02O.MessageDeliveryStatus).CANCELED);
    }
    handleClickEvent(messageId, variationId, componentId) {
        const activeMessage = this.getActiveMessage();
        // It is important to check that the event we're handling matches the
        // current active message because it is possible for an event to come
        // through for a past message. We don't want to mess up the current
        // message by calling clearCurrent just because the old message is done.
        if (!activeMessage || activeMessage.messageId !== messageId || activeMessage.variationId !== variationId || activeMessage.componentId !== componentId) return;
        let componentConfig;
        if (activeMessage.componentType) {
            const componentConfigId = this.getConfigId(activeMessage.componentType, activeMessage.target);
            componentConfig = $726433c0b80621eb$export$83b8ae7ce7b4d59c.componentConfig.get(componentConfigId);
        }
        if (activeMessage.isLast) this.completeMessage(messageId, componentConfig);
        this.props.store.dispatch((0, $eSdXt.clearCurrent)());
    }
    componentWillUnmount() {
        this.unsubscribeFromStore && this.unsubscribeFromStore();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $73FZL.default), {
            channel: "*",
            onEvent: this.onEvent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $73FZL.default), {
            channel: "engagement",
            onEvent: this.onEngagementEvent
        }, this.props.children));
    }
}

});
parcelRegister("5Jqmb", function(module, exports) {

var $8VDwo = parcelRequire("8VDwo");

var $gmYCm = parcelRequire("gmYCm");
/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */ function $42c599a0ad4baa7f$var$isMatch(object, source) {
    return object === source || $8VDwo(object, source, $gmYCm(source));
}
module.exports = $42c599a0ad4baa7f$var$isMatch;

});

parcelRegister("h0NjX", function(module, exports) {

var $jfkY8 = parcelRequire("jfkY8");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $c628b1d7a081f988$var$once(func) {
    return $jfkY8(2, func);
}
module.exports = $c628b1d7a081f988$var$once;

});
parcelRegister("jfkY8", function(module, exports) {

var $lmC5W = parcelRequire("lmC5W");
/** Error message constants. */ var $e02faf02fc53ad79$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $e02faf02fc53ad79$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($e02faf02fc53ad79$var$FUNC_ERROR_TEXT);
    n = $lmC5W(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
module.exports = $e02faf02fc53ad79$var$before;

});
parcelRegister("lmC5W", function(module, exports) {

var $4BFRG = parcelRequire("4BFRG");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f8d933e5daa867c5$var$toInteger(value) {
    var result = $4BFRG(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $f8d933e5daa867c5$var$toInteger;

});
parcelRegister("4BFRG", function(module, exports) {

var $84yTr = parcelRequire("84yTr");
/** Used as references for various `Number` constants. */ var $35ab179d9a05e81f$var$INFINITY = 1 / 0, $35ab179d9a05e81f$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $35ab179d9a05e81f$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $84yTr(value);
    if (value === $35ab179d9a05e81f$var$INFINITY || value === -$35ab179d9a05e81f$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $35ab179d9a05e81f$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $35ab179d9a05e81f$var$toFinite;

});
parcelRegister("84yTr", function(module, exports) {

var $25C6O = parcelRequire("25C6O");

var $p4u5f = parcelRequire("p4u5f");

var $cTEyW = parcelRequire("cTEyW");
/** Used as references for various `Number` constants. */ var $5e09c380be27f6da$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $5e09c380be27f6da$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $5e09c380be27f6da$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $5e09c380be27f6da$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $5e09c380be27f6da$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $5e09c380be27f6da$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($cTEyW(value)) return $5e09c380be27f6da$var$NAN;
    if ($p4u5f(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $p4u5f(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $25C6O(value);
    var isBinary = $5e09c380be27f6da$var$reIsBinary.test(value);
    return isBinary || $5e09c380be27f6da$var$reIsOctal.test(value) ? $5e09c380be27f6da$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $5e09c380be27f6da$var$reIsBadHex.test(value) ? $5e09c380be27f6da$var$NAN : +value;
}
module.exports = $5e09c380be27f6da$var$toNumber;

});
parcelRegister("25C6O", function(module, exports) {

var $7mEJA = parcelRequire("7mEJA");
/** Used to match leading whitespace. */ var $18599c0dca041a60$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $18599c0dca041a60$var$baseTrim(string) {
    return string ? string.slice(0, $7mEJA(string) + 1).replace($18599c0dca041a60$var$reTrimStart, '') : string;
}
module.exports = $18599c0dca041a60$var$baseTrim;

});
parcelRegister("7mEJA", function(module, exports) {
/** Used to match a single whitespace character. */ var $55ca2f79053f34e5$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $55ca2f79053f34e5$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $55ca2f79053f34e5$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $55ca2f79053f34e5$var$trimmedEndIndex;

});







parcelRegister("9PfBO", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("ebLpi", function(module, exports) {
$parcel$export(module.exports, "sendScreenEvent", () => $bdbf1731aa3b6204$export$22a3b1671f38a193);
$parcel$export(module.exports, "sendUIEvent", () => $bdbf1731aa3b6204$export$1aecf263098db667);
$parcel$export(module.exports, "sendOperationalEvent", () => $bdbf1731aa3b6204$export$e5f89b51c6d4e36b);
function $bdbf1731aa3b6204$export$22a3b1671f38a193(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendScreenEvent(payload);
    });
}
function $bdbf1731aa3b6204$export$1aecf263098db667(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendUIEvent(payload);
    });
}
function $bdbf1731aa3b6204$export$e5f89b51c6d4e36b(clientOrPromise, payload) {
    Promise.resolve(clientOrPromise).then((client)=>{
        client.sendOperationalEvent(payload);
    });
}

});

parcelRegister("5EQ0O", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $ccdcb76ad132ec16$export$6c724a6ffa2dc3e1);
const $ccdcb76ad132ec16$var$browserMatchers = [
    {
        name: 'IE',
        pattern: /Trident\/.*; rv:([^;)]+)/
    },
    {
        name: 'Chrome',
        pattern: /Chrome\/([^ )]+)/
    },
    {
        name: 'Firefox',
        pattern: /Firefox\/([^ )]+)/
    }
];
const $ccdcb76ad132ec16$export$cda2203640e08931 = {
    name: 'unknown',
    version: 'unknown'
};
function $ccdcb76ad132ec16$export$6c724a6ffa2dc3e1(userAgent) {
    if (!window.navigator) return $ccdcb76ad132ec16$export$cda2203640e08931;
    if (!userAgent) userAgent = window.navigator.userAgent;
    for (const matcher of $ccdcb76ad132ec16$var$browserMatchers){
        const versionMatch = userAgent.match(matcher.pattern);
        if (versionMatch) return {
            name: matcher.name,
            version: versionMatch[1]
        };
    }
    return $ccdcb76ad132ec16$export$cda2203640e08931;
}

});

parcelRegister("i8O7m", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7532b9866ddfa64$export$2e2bcd8739ae039);
const $e7532b9866ddfa64$var$createCustomEvent = ({ eventName: eventName, canBubble: canBubble, cancellable: cancellable, detail: detail })=>{
    const customEvent = document.createEvent('CustomEvent');
    customEvent.initCustomEvent(eventName, canBubble, cancellable, detail);
    return customEvent;
};
var $e7532b9866ddfa64$export$2e2bcd8739ae039 = $e7532b9866ddfa64$var$createCustomEvent;

});

parcelRegister("5PcED", function(module, exports) {
$parcel$export(module.exports, "default", () => $d02912de36584b87$export$2e2bcd8739ae039);
class $d02912de36584b87$export$2e2bcd8739ae039 {
    constructor(maxSize){
        this.queue = [];
        this.maxSize = maxSize;
    }
    enqueue(item) {
        if (this.queue.length === this.maxSize) return false;
        this.queue.push(item);
        return true;
    }
    flush(callback) {
        this.queue.forEach(callback);
        this.queue = [];
    }
    getSize() {
        return this.queue.length;
    }
}

});





parcelRegister("1MWC1", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("eAvqP")).default);

var $6AaIK = parcelRequire("6AaIK");
parcelRequire("dcJDN");
var $eAvqP = parcelRequire("eAvqP");

});
parcelRegister("6AaIK", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $63sfu = parcelRequire("63sfu");
parcelRequire("dcJDN");
var $eAvqP = parcelRequire("eAvqP");
const $9815cbe3228eb896$var$FeatureFlag = ({ children: children, name: name, defaultValue: defaultValue, showIf: showIf = 'enabled' })=>{
    const flags = (0, $4fqPo.useContext)((0, $eAvqP.FeatureFlagsContext));
    let value = defaultValue;
    if ((0, $63sfu.has)(flags, name)) value = !!flags[name];
    const shouldShow = showIf === 'enabled' ? value : !value;
    return shouldShow ? children : null;
};
var $9815cbe3228eb896$export$2e2bcd8739ae039 = $9815cbe3228eb896$var$FeatureFlag;

});
parcelRegister("dcJDN", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagProvider", () => (parcelRequire("eAvqP")).default);
$parcel$export(module.exports, "FeatureFlagsContext", () => (parcelRequire("eAvqP")).FeatureFlagsContext);

var $eAvqP = parcelRequire("eAvqP");

});
parcelRegister("eAvqP", function(module, exports) {
$parcel$export(module.exports, "FeatureFlagsContext", () => $db36949b853e9f3f$export$778f04ce1f3940a0);
$parcel$export(module.exports, "default", () => $db36949b853e9f3f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $db36949b853e9f3f$export$778f04ce1f3940a0 = /*#__PURE__*/ $4fqPo.createContext({});
const $db36949b853e9f3f$var$FeatureFlagProvider = ({ featureFlags: featureFlags, children: children })=>/*#__PURE__*/ $4fqPo.createElement($db36949b853e9f3f$export$778f04ce1f3940a0.Provider, {
        value: featureFlags
    }, children);
var $db36949b853e9f3f$export$2e2bcd8739ae039 = $db36949b853e9f3f$var$FeatureFlagProvider;

});




parcelRegister("7voRY", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => (parcelRequire("lVTEP")).TFECacheProvider);

var $lVTEP = parcelRequire("lVTEP");

});
parcelRegister("lVTEP", function(module, exports) {
$parcel$export(module.exports, "TFECacheProvider", () => $3b913cafe40a7020$export$55b822f5d1bfb2cf);

var $4fqPo = parcelRequire("4fqPo");

var $618GC = parcelRequire("618GC");

var $kjD4H = parcelRequire("kjD4H");

var $jQEh0 = parcelRequire("jQEh0");

var $ew3Bn = parcelRequire("ew3Bn");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");

var $85R51 = parcelRequire("85R51");
parcelRequire("cKxlN");
var $hqlqo = parcelRequire("hqlqo");
const $3b913cafe40a7020$var$FIVE_MINUTE_IN_SECONDS = 300;
const $3b913cafe40a7020$var$batchedGetExtensions = (0, $85R51.default)((0, $kjD4H.fetchTFExtensions), 0);
const $3b913cafe40a7020$var$batchedGetExtensionsV2 = (0, $jQEh0.default)((0, $kjD4H.fetchTFExtensions), 0);
const $3b913cafe40a7020$export$55b822f5d1bfb2cf = ({ children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const cacheRef = $4fqPo.useRef(new (0, (/*@__PURE__*/$parcel$interopDefault($618GC)))({
        stdTTL: $3b913cafe40a7020$var$FIVE_MINUTE_IN_SECONDS,
        checkperiod: $3b913cafe40a7020$var$FIVE_MINUTE_IN_SECONDS * 0.5,
        useClones: false
    }));
    const getExtensionsByType = (type, page)=>{
        const extensionsByType = cacheRef.current.get(type);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $3b913cafe40a7020$var$batchedGetExtensions(type);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: property,
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $keOG0.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const getExtensionsByTypeV2 = (type, resourceContext, page)=>{
        const { resourceId: resourceId } = resourceContext || {};
        const key = constructKey(resourceId, type);
        const extensionsByType = cacheRef.current.get(key);
        if (extensionsByType) return Promise.resolve({
            [type]: extensionsByType
        });
        const promise = $3b913cafe40a7020$var$batchedGetExtensionsV2(type, resourceContext);
        promise.then((fetchedExtensions)=>{
            const allFetchedExtensionsForCache = [];
            for(const property in fetchedExtensions)if (Object.prototype.hasOwnProperty.call(fetchedExtensions, property)) allFetchedExtensionsForCache.push({
                key: constructKey(resourceId, property),
                val: fetchedExtensions[property]
            });
            cacheRef.current.mset(allFetchedExtensionsForCache);
        }).catch((e)=>{
            (0, $keOG0.trackError)('forge-tfe.setCache.failed', {}, e);
            const event = createAnalyticsEvent({
                action: 'failed',
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'fetchForgeTFE',
                attributes: {
                    page: page,
                    moduleType: type,
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    statusCode: e.status,
                    error: JSON.stringify(e)
                }
            });
            event.context.push({
                componentName: 'fetchForgeTFE'
            });
            event.fire();
        });
        return promise;
    };
    const constructKey = (resourceId, property)=>resourceId ? resourceId.concat('-'.concat(property)) : property;
    return /*#__PURE__*/ $4fqPo.createElement((0, $hqlqo.TFECacheContext).Provider, {
        value: {
            getExtensionsByType: getExtensionsByType,
            getExtensionsByTypeV2: getExtensionsByTypeV2
        }
    }, children);
};
var $3b913cafe40a7020$export$2e2bcd8739ae039 = $3b913cafe40a7020$export$55b822f5d1bfb2cf;

});
parcelRegister("kjD4H", function(module, exports) {
$parcel$export(module.exports, "fetchTFExtensions", () => $f745d1e1813b4799$export$d3cc23e3d22de5ea);

var $lVFX8 = parcelRequire("lVFX8");

var $adk9i = parcelRequire("adk9i");

var $keOG0 = parcelRequire("keOG0");

var $3wR8f = parcelRequire("3wR8f");
const $f745d1e1813b4799$export$d3cc23e3d22de5ea = (types, resourceContext)=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/servicedesk/1/customer/servicedesk-data/forge/fetch-extensions`;
    let body;
    const { resourceType: resourceType } = resourceContext || {};
    if (resourceType === (0, $adk9i.RESOURCE_TYPE_ISSUE) || resourceType === (0, $adk9i.RESOURCE_TYPE_PROJECT)) body = {
        resourceContext: resourceContext,
        extensionTypes: types
    };
    else body = {
        extensionTypes: types
    };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };
    return (0, $lVFX8.post)(uri, body, headers).map(({ response: response })=>response.extensions).catch((e)=>{
        (0, $keOG0.trackError)('forge-tfe.fetch.failed', {}, e);
        return Promise.reject(e);
    }).toPromise();
};

});
parcelRegister("adk9i", function(module, exports) {
$parcel$export(module.exports, "FORGE_HELP_CENTER", () => $08775dba7c65e4c5$export$5fb35f580fb0ead9);
$parcel$export(module.exports, "FORGE_PORTAL_HOME", () => $08775dba7c65e4c5$export$f54ea43d8fdbc220);
$parcel$export(module.exports, "FORGE_REQUEST_CREATE", () => $08775dba7c65e4c5$export$7fba94cefb87c359);
$parcel$export(module.exports, "FORGE_REQUEST_DETAILS", () => $08775dba7c65e4c5$export$bc84cd79c53ab7bc);
$parcel$export(module.exports, "FORGE_REQUEST_LIST", () => $08775dba7c65e4c5$export$6089843c57d171a8);
$parcel$export(module.exports, "FORGE_PROFILE", () => $08775dba7c65e4c5$export$6c0b0fa4877ce128);
$parcel$export(module.exports, "FORGE_CSM_REQUEST_DETAILS", () => $08775dba7c65e4c5$export$4fb482ff92f899c1);
$parcel$export(module.exports, "REQUEST_DETAIL_MAIN_SECTION_MODULE", () => $08775dba7c65e4c5$export$a5069caad77a64d4);
$parcel$export(module.exports, "REQUEST_DETAIL_SIDE_SECTION_MODULE", () => $08775dba7c65e4c5$export$6df357f715dfd2f4);
$parcel$export(module.exports, "PORTAL_HEADER_MODULE", () => $08775dba7c65e4c5$export$463e8578e35a18ba);
$parcel$export(module.exports, "PORTAL_FOOTER_MODULE", () => $08775dba7c65e4c5$export$70cbbad22fbf0821);
$parcel$export(module.exports, "PORTAL_SUBHEADER_MODULE", () => $08775dba7c65e4c5$export$19ebf81efc141cb9);
$parcel$export(module.exports, "PROFILE_PANEL_MODULE", () => $08775dba7c65e4c5$export$d47ce30c5cdcdaa7);
$parcel$export(module.exports, "USER_MENU_ACTION_SECTION_MODULE", () => $08775dba7c65e4c5$export$b7f7df64576d21aa);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_MODULE", () => $08775dba7c65e4c5$export$2cdcdb01b87d24f8);
$parcel$export(module.exports, "PORTAL_REQUEST_CREATE_PROPERTY_PANEL_MODULE", () => $08775dba7c65e4c5$export$4df0942241cd5cc);
$parcel$export(module.exports, "HELP_CENTER_LAYOUT_ELEMENT_MODULE", () => $08775dba7c65e4c5$export$9183c6a9b59c394c);
$parcel$export(module.exports, "CSM_REQUEST_DETAIL_MODULE", () => $08775dba7c65e4c5$export$3b8e5fc21e252d78);
$parcel$export(module.exports, "CUSTOM_FIELD", () => $08775dba7c65e4c5$export$522be55130e84de4);
$parcel$export(module.exports, "CUSTOM_FIELD_TYPE", () => $08775dba7c65e4c5$export$96b7ba112deb79bf);
$parcel$export(module.exports, "UI_MODIFICATIONS", () => $08775dba7c65e4c5$export$c1878e6e4b67d4ad);
$parcel$export(module.exports, "JIRA_MODULES", () => $08775dba7c65e4c5$export$f9e7f55440c76553);
$parcel$export(module.exports, "USER_MENU_ACTION_COMPONENT", () => $08775dba7c65e4c5$export$84b6b6a1a76815b6);
$parcel$export(module.exports, "REQUEST_VIEW_ACTION_COMPONENT", () => $08775dba7c65e4c5$export$bec9cdaa83793785);
$parcel$export(module.exports, "RESOURCE_TYPE_ISSUE", () => $08775dba7c65e4c5$export$7c5d9a7c5f30e041);
$parcel$export(module.exports, "RESOURCE_TYPE_PROJECT", () => $08775dba7c65e4c5$export$39205aa8618a798);
$parcel$export(module.exports, "RESOURCE_TYPE_UNKNOWN", () => $08775dba7c65e4c5$export$a62b153e8eb10906);
$parcel$export(module.exports, "TOP_LEVEL_COMPONENTS", () => $08775dba7c65e4c5$export$fa9195e99a5ec8a7);
$parcel$export(module.exports, "ENTRY_POINT_EDIT", () => $08775dba7c65e4c5$export$2b8aeda236486576);
const $08775dba7c65e4c5$export$5fb35f580fb0ead9 = 'help_center';
const $08775dba7c65e4c5$export$f54ea43d8fdbc220 = 'portal';
const $08775dba7c65e4c5$export$7fba94cefb87c359 = 'create_request';
const $08775dba7c65e4c5$export$bc84cd79c53ab7bc = 'view_request';
const $08775dba7c65e4c5$export$6089843c57d171a8 = 'my_requests';
const $08775dba7c65e4c5$export$6c0b0fa4877ce128 = 'profile';
const $08775dba7c65e4c5$export$4fb482ff92f899c1 = 'csm_view_request';
const $08775dba7c65e4c5$export$a5069caad77a64d4 = 'jiraServiceManagement:portalRequestDetail';
const $08775dba7c65e4c5$export$6df357f715dfd2f4 = 'jiraServiceManagement:portalRequestDetailPanel';
const $08775dba7c65e4c5$export$463e8578e35a18ba = 'jiraServiceManagement:portalHeader';
const $08775dba7c65e4c5$export$70cbbad22fbf0821 = 'jiraServiceManagement:portalFooter';
const $08775dba7c65e4c5$export$19ebf81efc141cb9 = 'jiraServiceManagement:portalSubheader';
const $08775dba7c65e4c5$export$d47ce30c5cdcdaa7 = 'jiraServiceManagement:portalProfilePanel';
const $08775dba7c65e4c5$export$b7f7df64576d21aa = 'jiraServiceManagement:portalUserMenuAction';
const $08775dba7c65e4c5$export$2cdcdb01b87d24f8 = 'jiraServiceManagement:portalRequestViewAction';
const $08775dba7c65e4c5$export$4df0942241cd5cc = 'jiraServiceManagement:portalRequestCreatePropertyPanel';
const $08775dba7c65e4c5$export$9183c6a9b59c394c = 'jiraServiceManagement:helpCenterLayoutElement';
const $08775dba7c65e4c5$export$3b8e5fc21e252d78 = 'customerServiceManagement:requestDetail';
const $08775dba7c65e4c5$export$522be55130e84de4 = 'jira:customField';
const $08775dba7c65e4c5$export$96b7ba112deb79bf = 'jira:customFieldType';
const $08775dba7c65e4c5$export$c1878e6e4b67d4ad = 'jira:uiModifications';
const $08775dba7c65e4c5$export$f9e7f55440c76553 = [
    $08775dba7c65e4c5$export$522be55130e84de4,
    $08775dba7c65e4c5$export$96b7ba112deb79bf,
    $08775dba7c65e4c5$export$c1878e6e4b67d4ad
];
const $08775dba7c65e4c5$export$84b6b6a1a76815b6 = 'PortalUserMenuAction';
const $08775dba7c65e4c5$export$bec9cdaa83793785 = 'PortalRequestViewAction';
const $08775dba7c65e4c5$export$7c5d9a7c5f30e041 = 'ISSUE';
const $08775dba7c65e4c5$export$39205aa8618a798 = 'PROJECT';
const $08775dba7c65e4c5$export$a62b153e8eb10906 = 'UNKNOWN';
const $08775dba7c65e4c5$export$fa9195e99a5ec8a7 = {
    [$08775dba7c65e4c5$export$a5069caad77a64d4]: 'PortalRequestDetail',
    [$08775dba7c65e4c5$export$6df357f715dfd2f4]: 'PortalRequestDetailPanel',
    [$08775dba7c65e4c5$export$463e8578e35a18ba]: 'PortalHeader',
    [$08775dba7c65e4c5$export$70cbbad22fbf0821]: 'PortalFooter',
    [$08775dba7c65e4c5$export$19ebf81efc141cb9]: 'PortalSubheader',
    [$08775dba7c65e4c5$export$d47ce30c5cdcdaa7]: 'PortalProfilePanel',
    [$08775dba7c65e4c5$export$4df0942241cd5cc]: 'PortalRequestCreatePropertyPanel',
    [$08775dba7c65e4c5$export$3b8e5fc21e252d78]: 'CsmRequestDetail'
};
const $08775dba7c65e4c5$export$2b8aeda236486576 = 'edit';

});


parcelRegister("jQEh0", function(module, exports) {
$parcel$export(module.exports, "default", () => $38cbb0251b83f379$export$2e2bcd8739ae039);

var $63sfu = parcelRequire("63sfu");
const $38cbb0251b83f379$var$defer = ()=>{
    let resolve = ()=>{
        throw new Error('Resolve function not implememnted');
    };
    let reject = ()=>{
        throw new Error('Reject function not implemented');
    };
    const promise = new Promise((rslv, rjct)=>{
        resolve = rslv;
        reject = rjct;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
const $38cbb0251b83f379$var$proxyFunctionV2 = (func, wait, options = {})=>{
    const arrMap = new Map();
    const auxillaryMap = new Map();
    let deferred = $38cbb0251b83f379$var$defer();
    const callThenResetArgs = (arrMap1, auxillaryMap1)=>{
        try {
            const promiseArr = [];
            arrMap1.forEach((value, key)=>promiseArr.push(func(value, auxillaryMap1.get(key))));
            promiseArr.forEach((value)=>{
                deferred.resolve(value);
            });
        } catch (err) {
            deferred.reject(err);
        }
        arrMap.clear();
        auxillaryMap.clear();
        deferred = $38cbb0251b83f379$var$defer();
    };
    // Suppressing existing violations for the testing-library/react plugin.
    // eslint-disable-next-line testing-library/await-async-utils
    const debouncedFunc = (0, $63sfu.debounce)(callThenResetArgs, wait, options);
    return (arg, resourceContext)=>{
        const { resourceId: resourceId } = resourceContext || {};
        if (!resourceContext || resourceId === undefined) return deferred.promise;
        if (arrMap.has(resourceId)) {
            var _arrMap$get;
            if (!((_arrMap$get = arrMap.get(resourceId)) !== null && _arrMap$get !== void 0 && _arrMap$get.includes(arg))) {
                var _arrMap$get2;
                (_arrMap$get2 = arrMap.get(resourceId)) === null || _arrMap$get2 === void 0 || _arrMap$get2.push(arg);
            }
        } else {
            const arr = [];
            arr.push(arg);
            arrMap.set(resourceId, arr);
            auxillaryMap.set(resourceId, resourceContext);
        }
        debouncedFunc(arrMap, auxillaryMap);
        return deferred.promise;
    };
};
var $38cbb0251b83f379$export$2e2bcd8739ae039 = $38cbb0251b83f379$var$proxyFunctionV2;

});

parcelRegister("cKxlN", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => (parcelRequire("hqlqo")).TFECacheContext);

var $hqlqo = parcelRequire("hqlqo");

});
parcelRegister("hqlqo", function(module, exports) {
$parcel$export(module.exports, "TFECacheContext", () => $83d99781d0ad9e77$export$2a99743cd152f1d4);

var $4fqPo = parcelRequire("4fqPo");

var $kjD4H = parcelRequire("kjD4H");

var $jQEh0 = parcelRequire("jQEh0");

var $85R51 = parcelRequire("85R51");
const $83d99781d0ad9e77$var$batchedGetExtensions = (0, $85R51.default)((0, $kjD4H.fetchTFExtensions), 0);
const $83d99781d0ad9e77$var$batchedGetExtensionsV2 = (0, $jQEh0.default)((0, $kjD4H.fetchTFExtensions), 0);
const $83d99781d0ad9e77$export$2a99743cd152f1d4 = /*#__PURE__*/ $4fqPo.createContext({
    getExtensionsByType: $83d99781d0ad9e77$var$batchedGetExtensions,
    getExtensionsByTypeV2: $83d99781d0ad9e77$var$batchedGetExtensionsV2
});
$83d99781d0ad9e77$export$2a99743cd152f1d4.displayName = 'TFECacheContext';

});




parcelRegister("7BEQF", function(module, exports) {
$parcel$export(module.exports, "LazyPushingCustomizeSidebar", () => $cf17d802f6205ca7$export$1ccd6783fcfdc887);
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("1gHGC")).default);
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("fcd6D")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("fcd6D")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("fcd6D")).useSetCustomiseSidebarTrigger);
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("73kcG");
var $1gHGC = parcelRequire("1gHGC");
parcelRequire("cVNJm");
var $fcd6D = parcelRequire("fcd6D");

const $cf17d802f6205ca7$export$1ccd6783fcfdc887 = (0, $60vf0.lazy)(()=>(parcelRequire("gcy9V")), {
    moduleId: "./src/view/common/pushing-customize-sidebar/pushing-customize-sidebar.tsx"
});

});
parcelRegister("73kcG", function(module, exports) {
$parcel$export(module.exports, "SidebarPusher", () => (parcelRequire("1gHGC")).default);
$parcel$export(module.exports, "PusherConsumer", () => (parcelRequire("1gHGC")).PusherConsumer);

var $1gHGC = parcelRequire("1gHGC");

});
parcelRegister("1gHGC", function(module, exports) {
$parcel$export(module.exports, "PusherConsumer", () => $e395ee4f5b062a0d$export$693eb5228d48f25d);
$parcel$export(module.exports, "default", () => $e395ee4f5b062a0d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $2xGi5 = parcelRequire("2xGi5");

var $iSWaE = parcelRequire("iSWaE");

var $brRRh = parcelRequire("brRRh");

var $63sfu = parcelRequire("63sfu");

var $9lS0v = parcelRequire("9lS0v");
const $e395ee4f5b062a0d$var$PusherContext = /*#__PURE__*/ $4fqPo.createContext({
    onOpen: (0, $63sfu.noop),
    onClose: (0, $63sfu.noop)
});
const $e395ee4f5b062a0d$export$693eb5228d48f25d = $e395ee4f5b062a0d$var$PusherContext.Consumer;
class $e395ee4f5b062a0d$export$2e2bcd8739ae039 extends $4fqPo.Component {
    render() {
        const { children: children, className: className } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ $4fqPo.createElement($e395ee4f5b062a0d$var$PusherContext.Provider, {
            value: {
                onOpen: this.handleOpen,
                onClose: this.handleClose
            }
        }, /*#__PURE__*/ $4fqPo.createElement($e395ee4f5b062a0d$var$ContainerPusher, {
            className: className,
            isOpen: isOpen
        }, children));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false
        }, this.handleOpen = ()=>{
            this.setState({
                isOpen: true
            });
        }, this.handleClose = ()=>{
            this.setState({
                isOpen: false
            });
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $e395ee4f5b062a0d$var$ContainerPusher = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-sak91x-0"
})`will-change:padding-right;transition:padding-right ${(props)=>props.isOpen ? $brRRh.timingFunctions.easeOut : $brRRh.timingFunctions.easeIn} ${(0, $9lS0v.EXPAND_TIME_MS)}ms;${(props)=>$iSWaE.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $el3DQ.css)`padding:${(0, $9lS0v.SIDEBAR_HEIGHT_SMALL_VIEWPORT)} 0 0 0;`)};${$2xGi5.fromMedium.css`
        ${(props)=>$iSWaE.applyIf(props.isOpen, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $el3DQ.css)`padding:0 ${(0, $9lS0v.SIDEBAR_WIDTH_LARGE_VIEWPORT)} 0 0;`)};
    `};`;

});
parcelRegister("2xGi5", function(module, exports) {
$parcel$export(module.exports, "fromCustom", () => $5274e96b4e46d6e8$export$932b0cf23a178537);
$parcel$export(module.exports, "fromXSmall", () => $5274e96b4e46d6e8$export$b7a79c964fba7552);
$parcel$export(module.exports, "fromSmall", () => $5274e96b4e46d6e8$export$639a1bf83d3a4645);
$parcel$export(module.exports, "fromMedium", () => $5274e96b4e46d6e8$export$e95a160cb61e118);
$parcel$export(module.exports, "fromLarge", () => $5274e96b4e46d6e8$export$a37dde2f785d088f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $kQ79X = parcelRequire("kQ79X");
const $5274e96b4e46d6e8$var$generateBreakpoint = (minSize, maxSize)=>{
    // use em in breakpoints to work properly cross-browser and support users
    // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
    const emMinSize = minSize / 16;
    const emMaxSize = maxSize && maxSize / 16;
    let mediaQuery;
    if (emMinSize && emMaxSize) mediaQuery = `(min-width: ${emMinSize}em) and (max-width: ${emMaxSize})`;
    else if (emMinSize) mediaQuery = `(min-width: ${emMinSize}em)`;
    else if (emMaxSize) mediaQuery = `(max-width: ${emMaxSize}em)`;
    const func = (strings, ...interpolations)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        (0, $el3DQ.css)`@media ${mediaQuery}{${(0, $el3DQ.css)(// @ts-expect-error -- css overloads doesn't like this, but this is the exact root type we allow, confirmed to work via Storybook
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        strings, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        ...interpolations)};}`;
    return {
        // So we get syntax highlighting easily.
        css: func
    };
};
const $5274e96b4e46d6e8$export$932b0cf23a178537 = (minSize, maxSize)=>$5274e96b4e46d6e8$var$generateBreakpoint(minSize, maxSize);
const $5274e96b4e46d6e8$export$4da665ccee8caf55 = $5274e96b4e46d6e8$var$generateBreakpoint(0, (0, $kQ79X.sizes).xxsmall);
const $5274e96b4e46d6e8$export$9f4ec08b07b6fafc = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).xxsmall);
const $5274e96b4e46d6e8$export$b7a79c964fba7552 = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).xsmall);
const $5274e96b4e46d6e8$export$639a1bf83d3a4645 = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).small);
const $5274e96b4e46d6e8$export$e95a160cb61e118 = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).medium);
const $5274e96b4e46d6e8$export$a37dde2f785d088f = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).large);
const $5274e96b4e46d6e8$export$3621f41c276f9a6f = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).xlarge);
const $5274e96b4e46d6e8$export$86edc938645eb2d4 = $5274e96b4e46d6e8$var$generateBreakpoint((0, $kQ79X.sizes).xxlarge);

});
parcelRegister("kQ79X", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $0b86fdcee9539ba5$export$c647cb0ee6e282fe);
const $0b86fdcee9539ba5$export$c647cb0ee6e282fe = {
    xxlarge: 1600,
    xlarge: 1440,
    large: 1280,
    medium: 960,
    small: 840,
    xsmall: 600,
    xxsmall: 480,
    tablet: 800
};

});


parcelRegister("iSWaE", function(module, exports) {
$parcel$export(module.exports, "focusRing", () => $83b63b97eb352e2a$export$8e24544ddba725ee);
$parcel$export(module.exports, "borderBox", () => $83b63b97eb352e2a$export$ed32643c9618a26);
$parcel$export(module.exports, "flexCenter", () => $83b63b97eb352e2a$export$6f9e4349aad79600);
$parcel$export(module.exports, "center", () => $83b63b97eb352e2a$export$3481c78889e8fbe8);
$parcel$export(module.exports, "breakWord", () => $83b63b97eb352e2a$export$7cb287253100bd3f);
$parcel$export(module.exports, "borderRadius", () => $83b63b97eb352e2a$export$7a57f79000377ca2);
$parcel$export(module.exports, "borderRadiusValue", () => $83b63b97eb352e2a$export$56a32ffee3e5ef01);
$parcel$export(module.exports, "clamp", () => $83b63b97eb352e2a$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "multiLineClamp", () => $83b63b97eb352e2a$export$6a2fc6dc0ea84acc);
$parcel$export(module.exports, "applyIf", () => $83b63b97eb352e2a$export$64120c40e5147be9);
$parcel$export(module.exports, "placeholder", () => $83b63b97eb352e2a$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "raiseUpOnHoverOrFocus", () => $83b63b97eb352e2a$export$44d27400011e4794);
$parcel$export(module.exports, "subtleThemeColorBackground", () => $83b63b97eb352e2a$export$b2d8a5f61fea402f);
$parcel$export(module.exports, "toolTipPrimitiveStyle", () => $83b63b97eb352e2a$export$2c414b247dcd2e5d);
$parcel$export(module.exports, "panelExpansionAnimationFix", () => $83b63b97eb352e2a$export$de6b6b015066ff26);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $7L1Sn = parcelRequire("7L1Sn");

var $bpWyP = parcelRequire("bpWyP");

var $brRRh = parcelRequire("brRRh");
/**
 * TODO: Replace with `import { focusRing, noFocusRing } from '@atlaskit/theme' when updating
 * to @atlaskit/theme@^7.x.x :-).
 */ const $83b63b97eb352e2a$var$atlaskitFocusRing = {
    focusRing: (color = "var(--ds-border-focused, #4C9AFF)", outlineWidth = 2)=>`
        &:focus {
          outline: none;
          box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
        }
      `,
    noFocusRing: ()=>`
        box-shadow: none;
      `
};
const $83b63b97eb352e2a$var$defaultFocusRing = $83b63b97eb352e2a$var$atlaskitFocusRing.focusRing();
const $83b63b97eb352e2a$var$noFocusRing = $83b63b97eb352e2a$var$atlaskitFocusRing.noFocusRing();
const $83b63b97eb352e2a$export$8e24544ddba725ee = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    default: (0, $el3DQ.css)`&:focus-visible{${$83b63b97eb352e2a$var$defaultFocusRing};}&:focus:not(:focus-visible){outline:0;}`,
    none: $83b63b97eb352e2a$var$noFocusRing
};
const $83b63b97eb352e2a$export$ed32643c9618a26 = /*#__PURE__*/ (0, $el3DQ.css)`box-sizing:border-box;*{box-sizing:border-box;}`;
const $83b63b97eb352e2a$export$6f9e4349aad79600 = /*#__PURE__*/ (0, $el3DQ.css)`display:flex;align-items:center;justify-content:center;`;
const $83b63b97eb352e2a$export$3481c78889e8fbe8 = (position)=>(0, $el3DQ.css)`position:${position};top:50%;left:50%;transform:translate3d(-50%,-50%,0);`;
const $83b63b97eb352e2a$export$7cb287253100bd3f = /*#__PURE__*/ (0, $el3DQ.css)`white-space:pre-wrap;word-break:break-word;`;
const $83b63b97eb352e2a$export$7a57f79000377ca2 = /*#__PURE__*/ (0, $el3DQ.css)`border-radius:${"var(--ds-radius-small, 3px)"};`;
const $83b63b97eb352e2a$export$56a32ffee3e5ef01 = `${"var(--ds-radius-small, 0.25rem)"}`;
const $83b63b97eb352e2a$export$7d15b64cf5a3a4c4 = /*#__PURE__*/ (0, $el3DQ.css)`text-overflow:ellipsis;overflow:hidden;white-space:nowrap;`;
const $83b63b97eb352e2a$export$6a2fc6dc0ea84acc = (lines, lineHeight = $bpWyP.multiple(2.5).unitless)=>(0, $el3DQ.css)`display:-webkit-box;-webkit-line-clamp:${lines};-webkit-box-orient:vertical;max-height:${lineHeight * lines}px;overflow:hidden;`;
const $83b63b97eb352e2a$export$64120c40e5147be9 = (predicateResult, mixin)=>// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $el3DQ.css)`${predicateResult ? mixin : ''};`;
const $83b63b97eb352e2a$export$c7187bbd1a7a9244 = (color)=>(0, $el3DQ.css)`&::-webkit-input-placeholder{color:${color};}&::-moz-placeholder{color:${color};opacity:1;}&::-ms-input-placeholder{color:${color};}&:-moz-placeholder{color:${color};opacity:1;}&:-ms-input-placeholder{color:${color};}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $83b63b97eb352e2a$var$raiseUpOnHoverPsuedoElement = /*#__PURE__*/ (0, $el3DQ.css)`${$83b63b97eb352e2a$export$7a57f79000377ca2};content:'';position:absolute;top:0;left:0;right:0;bottom:0;transition:opacity ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};`;
const $83b63b97eb352e2a$export$44d27400011e4794 = (fromElevation = $7L1Sn.e100, toElevation = $7L1Sn.e200)=>(0, $el3DQ.css)`position:relative;transition:transform ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};&::before{${$83b63b97eb352e2a$var$raiseUpOnHoverPsuedoElement};${fromElevation};z-index:inherit;}&::after{${$83b63b97eb352e2a$var$raiseUpOnHoverPsuedoElement};${toElevation};opacity:0;z-index:inherit;}&:focus,&:hover{transform:translate3d(0,-2px,0);&::after{opacity:1;}&::before{opacity:0;}}`;
const $83b63b97eb352e2a$export$b2d8a5f61fea402f = /*#__PURE__*/ (0, $el3DQ.css)`background-image:linear-gradient(to right,rgba(255,255,255,0.85),rgba(255,255,255,0.85)),linear-gradient(to right,${(props)=>props.theme.color},${(props)=>props.theme.color});`;
// Overrides the @atlaskit/css-reset focus ring with our own
// wrapper that only shows it if you interact by keyboard.
(0, $el3DQ.injectGlobal)`a{${$83b63b97eb352e2a$export$8e24544ddba725ee.default};}`;
const $83b63b97eb352e2a$export$2c414b247dcd2e5d = /*#__PURE__*/ (0, $el3DQ.css)`color:${"var(--ds-text-inverse, #FFFFFF)"};background-color:${"var(--ds-text, #172B4D)"};padding:${"var(--ds-space-025, 2px)"} ${"var(--ds-space-075, 6px)"};border-radius:${$83b63b97eb352e2a$export$7a57f79000377ca2};`;
const $83b63b97eb352e2a$export$de6b6b015066ff26 = /*#__PURE__*/ (0, $el3DQ.css)`> div > div{box-sizing:content-box;}.rah-animating{overflow:visible !important;filter:opacity(0.05);}`;

});
parcelRegister("7L1Sn", function(module, exports) {
$parcel$export(module.exports, "e100", () => $ed9aabf8fbc962e5$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $ed9aabf8fbc962e5$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e400", () => $ed9aabf8fbc962e5$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "newElevationsFromDesignSystems", () => $ed9aabf8fbc962e5$export$78129b34f80acd5f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $dXHSc = parcelRequire("dXHSc");
const $ed9aabf8fbc962e5$export$b390b459b8b8d8d0 = /*#__PURE__*/ (0, $el3DQ.css)`box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};z-index:${$dXHSc.card};`;
const $ed9aabf8fbc962e5$export$3c35fb2adfe0992 = /*#__PURE__*/ (0, $el3DQ.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$dXHSc.dialog};`;
const $ed9aabf8fbc962e5$export$f330dca4c33ed51f = /*#__PURE__*/ (0, $el3DQ.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 8px 16px -4px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$dXHSc.modal};`;
const $ed9aabf8fbc962e5$export$3c7c047ca0ed675e = /*#__PURE__*/ (0, $el3DQ.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 12px 24px -6px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$dXHSc.panel};`;
const $ed9aabf8fbc962e5$export$e6af781b0d301e56 = /*#__PURE__*/ (0, $el3DQ.css)`box-shadow:${`var(--ds-shadow-overlay, ${`0 20px 32px -8px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};z-index:${$dXHSc.flag};`;
const $ed9aabf8fbc962e5$export$78129b34f80acd5f = {
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e100: (0, $el3DQ.css)`z-index:${$dXHSc.card};box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};`,
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    e200: (0, $el3DQ.css)`z-index:${$dXHSc.dialog};box-shadow:${`var(--ds-shadow-overlay, ${`0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 1px rgba(9, 30, 66, 0.31)`})`};`
};

});
parcelRegister("dXHSc", function(module, exports) {
$parcel$export(module.exports, "modal", () => $e7171626100ff9c6$export$96e4b36520c26a2c);
$parcel$export(module.exports, "card", () => $e7171626100ff9c6$export$aa3e815946b80764);
$parcel$export(module.exports, "dialog", () => $e7171626100ff9c6$export$518824cf31321346);
$parcel$export(module.exports, "panel", () => $e7171626100ff9c6$export$21f42ab9b6679f44);
$parcel$export(module.exports, "flag", () => $e7171626100ff9c6$export$42405f212471e8a2);
$parcel$export(module.exports, "layer", () => $e7171626100ff9c6$export$50a222d9023da98b);
$parcel$export(module.exports, "pushingCustomizeSidebarSmall", () => $e7171626100ff9c6$export$d937b725511051a5);
$parcel$export(module.exports, "pushingCustomizeSidebarLarge", () => $e7171626100ff9c6$export$6d600c1f7c7bf904);
$parcel$export(module.exports, "pageInBannerLayout", () => $e7171626100ff9c6$export$b3a6c753aad12c21);
$parcel$export(module.exports, "banner", () => $e7171626100ff9c6$export$bb5ee47d9ea2348e);
$parcel$export(module.exports, "portalCardLayout", () => $e7171626100ff9c6$export$1f2452f153db200);
$parcel$export(module.exports, "forgeLoadingComponent", () => $e7171626100ff9c6$export$6bbd03fd9ab1103f);

var $hDp3n = parcelRequire("hDp3n");
const $e7171626100ff9c6$export$96e4b36520c26a2c = (0, $hDp3n.layers).modal();
const $e7171626100ff9c6$export$aa3e815946b80764 = (0, $hDp3n.layers).card();
const $e7171626100ff9c6$export$518824cf31321346 = (0, $hDp3n.layers).dialog();
const $e7171626100ff9c6$export$21f42ab9b6679f44 = (0, $hDp3n.layers).navigation();
const $e7171626100ff9c6$export$42405f212471e8a2 = (0, $hDp3n.layers).flag();
const $e7171626100ff9c6$export$50a222d9023da98b = (0, $hDp3n.layers).layer();
const $e7171626100ff9c6$export$4e6f96734dfe12f4 = (0, $hDp3n.layers).tooltip();
const $e7171626100ff9c6$export$f2ea4ab276c3e3fa = 502; // This has to be > atlaskit blanket which has a z-index of 500 and smaller than the modal layer which is at 510
const $e7171626100ff9c6$export$312cd8ab1e0faaaa = $e7171626100ff9c6$export$f2ea4ab276c3e3fa;
const $e7171626100ff9c6$export$cb3a20fdbbf963aa = $e7171626100ff9c6$export$312cd8ab1e0faaaa + 1;
const $e7171626100ff9c6$export$d937b725511051a5 = $e7171626100ff9c6$export$cb3a20fdbbf963aa + 1;
const $e7171626100ff9c6$export$6d600c1f7c7bf904 = $e7171626100ff9c6$export$96e4b36520c26a2c - 50;
const $e7171626100ff9c6$export$363009303e3f9227 = 1;
const $e7171626100ff9c6$export$b339878b6d12ef6c = 2;
const $e7171626100ff9c6$export$980027fe3bc5cfbc = 3;
const $e7171626100ff9c6$export$b3a6c753aad12c21 = -1;
const $e7171626100ff9c6$export$bb5ee47d9ea2348e = -2;
const $e7171626100ff9c6$export$1f2452f153db200 = 0;
const $e7171626100ff9c6$export$6bbd03fd9ab1103f = 500;

});


parcelRegister("bpWyP", function(module, exports) {
$parcel$export(module.exports, "unitless", () => $d032d161ed8bb8d5$export$c6b9faa6b723d31a);
$parcel$export(module.exports, "multiple", () => $d032d161ed8bb8d5$export$939ddaa3205df08e);
$parcel$export(module.exports, "SINGLE_LINE_PARAGRAPH_HEIGHT", () => $d032d161ed8bb8d5$export$7a95f3449f53d741);
const $d032d161ed8bb8d5$export$c6b9faa6b723d31a = 8;
const $d032d161ed8bb8d5$export$91c0eda1d06bf008 = '8px';
const $d032d161ed8bb8d5$export$939ddaa3205df08e = (multiplier)=>({
        px: `${multiplier * 8}px`,
        unitless: multiplier * 8,
        multiple: (additionalMultiplier)=>$d032d161ed8bb8d5$export$939ddaa3205df08e(multiplier * additionalMultiplier)
    });
const $d032d161ed8bb8d5$export$7a95f3449f53d741 = 20;

});

parcelRegister("brRRh", function(module, exports) {
$parcel$export(module.exports, "timingFunctions", () => $2c0887001f185923$export$61210fa83792a81);
$parcel$export(module.exports, "speedMs", () => $2c0887001f185923$export$e913427a0c9547b);
$parcel$export(module.exports, "fadeInOutTiming", () => $2c0887001f185923$export$44a465aba7fd9c0a);
$parcel$export(module.exports, "fadeInOut", () => $2c0887001f185923$export$6c232a6cba05a953);
$parcel$export(module.exports, "slideInOutFromTop", () => $2c0887001f185923$export$cb4674081b5c3c03);
$parcel$export(module.exports, "slideInOutFromRight", () => $2c0887001f185923$export$cb755d7f610bdc3b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
const $2c0887001f185923$export$61210fa83792a81 = {
    easeOut: 'ease-out',
    easeIn: 'ease-in',
    easeInOut: 'ease-in-out',
    // http://cubic-bezier.com/#.47,0,0,1.19
    easeInOutSpring: 'cubic-bezier(.79,.22,0,1.19)',
    linear: 'linear',
    // Same easing used in Atlaskit modal:
    // https://bitbucket.org/atlassian/atlaskit-mk-2/src/fd22974e576281b2f4d158b0a0df3badc4ed9ab2/packages/core/modal-dialog/src/components/Animation.js?at=master&fileviewer=file-view-default
    easeInOutQuad: 'cubic-bezier(0.23, 1, 0.32, 1)'
};
const $2c0887001f185923$export$e913427a0c9547b = {
    superFast: 50,
    fast: 140,
    medium: 200,
    slow: 300
};
const $2c0887001f185923$var$fadeInOutOpacityMap = {
    entering: 0,
    entered: 1,
    exiting: 0,
    exited: 0
};
const $2c0887001f185923$export$44a465aba7fd9c0a = (ms, delay = 0)=>(0, $el3DQ.css)`transition:opacity ${ms}ms;transition-delay:${delay}ms;transition-timing-function:${$2c0887001f185923$export$61210fa83792a81.easeOut};`;
const $2c0887001f185923$export$6c232a6cba05a953 = (ms, delay = 0)=>(0, $el3DQ.css)`${$2c0887001f185923$export$44a465aba7fd9c0a(ms, delay)};opacity:${(props)=>$2c0887001f185923$var$fadeInOutOpacityMap[props.state]};`;
const $2c0887001f185923$export$e83f174dbf56adcc = (ms = $2c0887001f185923$export$e913427a0c9547b.fast)=>(0, $el3DQ.css)`transition:transform ${ms}ms;transition-timing-function:${$2c0887001f185923$export$61210fa83792a81.easeInOut};transform:scale(1.1);`;
const $2c0887001f185923$var$slideInOutFromTopTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(0, -100%, 0)',
    exited: 'translate3d(0, -100%, 0)'
};
const $2c0887001f185923$var$slideInOutFromRightTransformMap = {
    entering: 'translate3d(0, 0, 0)',
    entered: 'none',
    exiting: 'translate3d(100%, 0, 0)',
    exited: 'translate3d(100%, 0, 0)'
};
const $2c0887001f185923$var$slideInOutTransitionMap = (ms)=>({
        /* This will ease out when entering, and ease-in when leaving. */ entering: `transform ${ms}ms ${$2c0887001f185923$export$61210fa83792a81.easeOut}`,
        entered: `transform ${ms}ms ${$2c0887001f185923$export$61210fa83792a81.easeOut}`,
        exiting: `transform ${ms}ms ${$2c0887001f185923$export$61210fa83792a81.easeIn}`
    });
const $2c0887001f185923$export$cb4674081b5c3c03 = (ms)=>(0, $el3DQ.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $2c0887001f185923$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$2c0887001f185923$var$slideInOutFromTopTransformMap[props.state]};`;
const $2c0887001f185923$export$cb755d7f610bdc3b = (ms)=>(0, $el3DQ.css)`transition:${(props)=>{
        //@ts-ignore TypeScript upgrade 5.1.6, please fix this violation.
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return $2c0887001f185923$var$slideInOutTransitionMap(ms)[props.state];
    }};transform:${(props)=>$2c0887001f185923$var$slideInOutFromRightTransformMap[props.state]};`;

});


parcelRegister("9lS0v", function(module, exports) {
$parcel$export(module.exports, "EXPAND_TIME_MS", () => $ec9a59e307abd463$export$a718feb2020f924e);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_MULTIPLIER", () => $ec9a59e307abd463$export$916ffa0b867d54d8);
$parcel$export(module.exports, "SIDEBAR_WIDTH_LARGE_VIEWPORT", () => $ec9a59e307abd463$export$66e2a13bbb493bde);
$parcel$export(module.exports, "SIDEBAR_HEIGHT_SMALL_VIEWPORT", () => $ec9a59e307abd463$export$3d0c478f72970318);
$parcel$export(module.exports, "SIDEBAR_FULL_HEIGHT_SMALL_VIEWPORT", () => $ec9a59e307abd463$export$aea0de5dee32e42e);
$parcel$export(module.exports, "TAG_BUTTON_HEIGHT", () => $ec9a59e307abd463$export$9aa6c06b2eb3bd9e);

var $bpWyP = parcelRequire("bpWyP");

var $brRRh = parcelRequire("brRRh");
const $ec9a59e307abd463$export$a718feb2020f924e = $brRRh.speedMs.medium;
const $ec9a59e307abd463$export$916ffa0b867d54d8 = 50;
const $ec9a59e307abd463$export$66e2a13bbb493bde = $bpWyP.multiple($ec9a59e307abd463$export$916ffa0b867d54d8).px;
const $ec9a59e307abd463$export$3d0c478f72970318 = '40vh';
const $ec9a59e307abd463$export$aea0de5dee32e42e = '100vh';
const $ec9a59e307abd463$export$9aa6c06b2eb3bd9e = $bpWyP.unitless * 5;

});



parcelRegister("cVNJm", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => (parcelRequire("fcd6D")).CustomiseSidebarTriggerProvider);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => (parcelRequire("fcd6D")).useCustomiseSidebarTriggerRef);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => (parcelRequire("fcd6D")).useSetCustomiseSidebarTrigger);

var $fcd6D = parcelRequire("fcd6D");

});
parcelRegister("fcd6D", function(module, exports) {
$parcel$export(module.exports, "CustomiseSidebarTriggerProvider", () => $bb519bafac004188$export$80c1c1cfdf49ec8a);
$parcel$export(module.exports, "useCustomiseSidebarTriggerRef", () => $bb519bafac004188$export$2ffc1f557dddded2);
$parcel$export(module.exports, "useSetCustomiseSidebarTrigger", () => $bb519bafac004188$export$d2c4b172b3db92fb);

var $4fqPo = parcelRequire("4fqPo");
const $bb519bafac004188$var$TriggerRefContext = /*#__PURE__*/ $4fqPo.createContext(null);
const $bb519bafac004188$export$80c1c1cfdf49ec8a = ({ children: children })=>{
    const triggerRef = $4fqPo.useRef(null);
    const setTriggerElement = $4fqPo.useCallback((element)=>{
        // Using a mutable ref pattern since we can't reassign .current on a RefObject
        triggerRef.current = element;
    }, []);
    const value = $4fqPo.useMemo(()=>({
            triggerRef: triggerRef,
            setTriggerElement: setTriggerElement
        }), [
        setTriggerElement
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($bb519bafac004188$var$TriggerRefContext.Provider, {
        value: value
    }, children);
};
const $bb519bafac004188$export$2ffc1f557dddded2 = ()=>{
    const context = $4fqPo.useContext($bb519bafac004188$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.triggerRef;
};
const $bb519bafac004188$export$d2c4b172b3db92fb = ()=>{
    const context = $4fqPo.useContext($bb519bafac004188$var$TriggerRefContext);
    return context === null || context === void 0 ? void 0 : context.setTriggerElement;
};

});


parcelRegister("gcy9V", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("6yKOd").then(()=>parcelRequire('cTgCQ'));

});


parcelRegister("lkz0W", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("7EenD")).default);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("6niD6")).FabricChannel);

var $7EenD = parcelRequire("7EenD");

var $lB7PV = parcelRequire("lB7PV");

var $6niD6 = parcelRequire("6niD6");

});
parcelRegister("7EenD", function(module, exports) {
$parcel$export(module.exports, "default", () => $a54dd996a918cf1d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $6SAO3 = parcelRequire("6SAO3");

var $1ychy = parcelRequire("1ychy");

var $lB7PV = parcelRequire("lB7PV");

var $gz1V9 = parcelRequire("gz1V9");

var $4qQ7A = parcelRequire("4qQ7A");

var $axXB1 = parcelRequire("axXB1");

var $l8xvv = parcelRequire("l8xvv");

var $iwIGP = parcelRequire("iwIGP");

var $lLddi = parcelRequire("lLddi");

var $jyt5l = parcelRequire("jyt5l");

var $cDzPu = parcelRequire("cDzPu");

var $5dflY = parcelRequire("5dflY");

var $gYXZT = parcelRequire("gYXZT");

var $iCaDK = parcelRequire("iCaDK");

var $9omjr = parcelRequire("9omjr");

var $1cGfp = parcelRequire("1cGfp");

var $9OwW2 = parcelRequire("9OwW2");

var $lLZgZ = parcelRequire("lLZgZ");

var $E26To = parcelRequire("E26To");

var $bx8iY = parcelRequire("bx8iY");
const $a54dd996a918cf1d$var$listenerMap = {
    [(0, $6niD6.FabricChannel).elements]: (0, $6SAO3.default),
    [(0, $6niD6.FabricChannel).editor]: (0, $4qQ7A.default),
    [(0, $6niD6.FabricChannel).atlaskit]: (0, $1ychy.default),
    [(0, $6niD6.FabricChannel).navigation]: (0, $gz1V9.default),
    [(0, $6niD6.FabricChannel).media]: (0, $axXB1.default),
    [(0, $6niD6.FabricChannel).peopleTeams]: (0, $l8xvv.default),
    [(0, $6niD6.FabricChannel).notifications]: (0, $iwIGP.default),
    [(0, $6niD6.FabricChannel).recentWork]: (0, $lLddi.default),
    [(0, $6niD6.FabricChannel).atlas]: (0, $jyt5l.default),
    [(0, $6niD6.FabricChannel).crossFlow]: (0, $cDzPu.default),
    [(0, $6niD6.FabricChannel).linkingPlatform]: (0, $5dflY.default),
    [(0, $6niD6.FabricChannel).postOffice]: (0, $gYXZT.default),
    [(0, $6niD6.FabricChannel).aiMate]: (0, $iCaDK.default),
    [(0, $6niD6.FabricChannel).avp]: (0, $9omjr.default),
    [(0, $6niD6.FabricChannel).growth]: (0, $1cGfp.default),
    [(0, $6niD6.FabricChannel).omniChannel]: (0, $9OwW2.default),
    [(0, $6niD6.FabricChannel).townsquareHome]: (0, $lLZgZ.default),
    [(0, $6niD6.FabricChannel).rovoExtension]: (0, $E26To.default),
    [(0, $6niD6.FabricChannel).teamworkGraph]: (0, $bx8iY.default)
};
class $a54dd996a918cf1d$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $lB7PV.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($a54dd996a918cf1d$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$a54dd996a918cf1d$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Listener, {
                client: client,
                logger: this.logger
            }, prev), children);
        return listeners;
    }
}
var $a54dd996a918cf1d$export$2e2bcd8739ae039 = $a54dd996a918cf1d$var$FabricAnalyticsListeners;

});
parcelRegister("6niD6", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => $f590e109fc386c8b$export$8faa0b115ef0268b);
var $f590e109fc386c8b$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    FabricChannel["omniChannel"] = "omniChannel";
    FabricChannel["townsquareHome"] = "townsquareHome";
    FabricChannel["rovoExtension"] = "rovoExtension";
    FabricChannel["teamworkGraph"] = "teamworkGraph";
    return FabricChannel;
}({});

});

parcelRegister("6SAO3", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_TAG", () => $d294b8684f2613e5$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $d294b8684f2613e5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $73FZL = parcelRequire("73FZL");

var $6niD6 = parcelRequire("6niD6");

var $fNIU0 = parcelRequire("fNIU0");
const $d294b8684f2613e5$export$ed71ae78997933a = 'fabricElements';
class $d294b8684f2613e5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $73FZL.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $6niD6.FabricChannel).elements
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $fNIU0.handleEvent)(event, $d294b8684f2613e5$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("fNIU0", function(module, exports) {
$parcel$export(module.exports, "handleEvent", () => $b77d0884a026643f$export$d6e5ca10785815df);

var $gBo3v = parcelRequire("gBo3v");

var $jhU9A = parcelRequire("jhU9A");
const $b77d0884a026643f$export$d6e5ca10785815df = (event, tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $jhU9A.processEventPayload)(event, tags);
    (0, $gBo3v.sendEvent)(logger, client)(payload);
};

});
parcelRegister("gBo3v", function(module, exports) {
$parcel$export(module.exports, "sendEvent", () => $3e424e78a6171f32$export$7329bcdc3edcd90e);
const $3e424e78a6171f32$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $3e424e78a6171f32$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($3e424e78a6171f32$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("jhU9A", function(module, exports) {
$parcel$export(module.exports, "processEventPayload", () => $ff76049d0f03a1b1$export$c37d638b7f2ca192);

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $dQ0Pl = parcelRequire("dQ0Pl");
var $i6OfG = parcelRequire("i6OfG");

var $lc40q = parcelRequire("lc40q");

var $6SAO3 = parcelRequire("6SAO3");

var $4qQ7A = parcelRequire("4qQ7A");
const $ff76049d0f03a1b1$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(result, item), {});
const $ff76049d0f03a1b1$var$fieldExtractor = (contextKey)=>$ff76049d0f03a1b1$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $ff76049d0f03a1b1$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $6SAO3.ELEMENTS_TAG:
            return 0, $i6OfG.ELEMENTS_CONTEXT;
        case 0, $4qQ7A.EDITOR_TAG:
            return 0, $dQ0Pl.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $ff76049d0f03a1b1$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $dgWJT.DEFAULT_SOURCE),
        ...event.payload
    };
    const contextKey = $ff76049d0f03a1b1$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $ff76049d0f03a1b1$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $dgWJT.DEFAULT_SOURCE),
        ...fields,
        ...event.payload
    };
};
const $ff76049d0f03a1b1$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $ff76049d0f03a1b1$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $ff76049d0f03a1b1$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $ff76049d0f03a1b1$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$ff76049d0f03a1b1$var$updatePayloadWithContext(primaryTag, event),
        tags: $ff76049d0f03a1b1$var$addTags(tagsArray, event.payload.tags)
    };
};

});
parcelRegister("dgWJT", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $c779fc0be5a62c8c$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $c779fc0be5a62c8c$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $c779fc0be5a62c8c$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $c779fc0be5a62c8c$export$12346a674644c156);
$parcel$export(module.exports, "DEFAULT_SOURCE", () => $c779fc0be5a62c8c$export$b055de0e665cb20c);
// same types defined in analytics-web-client but avoid creating dependency with that
const $c779fc0be5a62c8c$export$a1562d08625f5d7e = 'ui';
const $c779fc0be5a62c8c$export$947dac6c72b26f81 = 'track';
const $c779fc0be5a62c8c$export$f1d537d508d2945a = 'screen';
const $c779fc0be5a62c8c$export$12346a674644c156 = 'operational';
const $c779fc0be5a62c8c$export$b055de0e665cb20c = 'unknown';

});

parcelRegister("8lHWD", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("i6OfG")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("i6OfG")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("iIhgr")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("iIhgr")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("dQ0Pl")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("dQ0Pl")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => (parcelRequire("c6QjZ")).MEDIA_CONTEXT);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("lEpZN")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("lEpZN")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("hIC2w")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("eygP4")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("7zWjd")).ATLAS_CONTEXT);
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => (parcelRequire("bJcpB")).TOWNSQUARE_HOME_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("3FSPr")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("hNNQu")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("hNNQu")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("2dcyp")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("kTYB3")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("a5b21")).GROWTH_CONTEXT);
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => (parcelRequire("kFi7L")).OMNI_CHANNEL_CONTEXT);
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => (parcelRequire("gKvHx")).ROVO_EXTENSION_CONTEXT);

var $i6OfG = parcelRequire("i6OfG");

var $iIhgr = parcelRequire("iIhgr");

var $dQ0Pl = parcelRequire("dQ0Pl");

var $c6QjZ = parcelRequire("c6QjZ");

var $lEpZN = parcelRequire("lEpZN");

var $hIC2w = parcelRequire("hIC2w");

var $eygP4 = parcelRequire("eygP4");

var $7zWjd = parcelRequire("7zWjd");

var $bJcpB = parcelRequire("bJcpB");

var $3FSPr = parcelRequire("3FSPr");

var $hNNQu = parcelRequire("hNNQu");

var $2dcyp = parcelRequire("2dcyp");

var $kTYB3 = parcelRequire("kTYB3");

var $a5b21 = parcelRequire("a5b21");

var $kFi7L = parcelRequire("kFi7L");

var $gKvHx = parcelRequire("gKvHx");

});
parcelRegister("i6OfG", function(module, exports) {
$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $a2a845541523049e$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $a2a845541523049e$export$3fe25500478a635c);

var $2RyvH = parcelRequire("2RyvH");
const $a2a845541523049e$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $a2a845541523049e$export$3fe25500478a635c = (0, $2RyvH.default)($a2a845541523049e$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("2RyvH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ed0b86d03f2873b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");
const $1ed0b86d03f2873b$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $1ed0b86d03f2873b$export$2e2bcd8739ae039 = $1ed0b86d03f2873b$var$createNamespaceContext;

});


parcelRegister("iIhgr", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $ee94a0c004c734d1$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $ee94a0c004c734d1$export$d0a82da1a0b94929);

var $2RyvH = parcelRequire("2RyvH");
const $ee94a0c004c734d1$export$1fd3aad76a7c6788 = 'navigationCtx';
const $ee94a0c004c734d1$export$d0a82da1a0b94929 = (0, $2RyvH.default)($ee94a0c004c734d1$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("dQ0Pl", function(module, exports) {
$parcel$export(module.exports, "EDITOR_CONTEXT", () => $0ade42c2c338674b$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $0ade42c2c338674b$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $0ade42c2c338674b$export$629cada6c5e621e1);

var $2RyvH = parcelRequire("2RyvH");
const $0ade42c2c338674b$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $0ade42c2c338674b$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    EDITOR_APPEARANCE_CONTEXT["MAX"] = "max";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $0ade42c2c338674b$export$629cada6c5e621e1 = (0, $2RyvH.default)($0ade42c2c338674b$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

parcelRegister("c6QjZ", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $96d9bed626244f6a$export$70df29c238ba7306);
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $96d9bed626244f6a$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

});

parcelRegister("lEpZN", function(module, exports) {
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $c16ba9ae45e54407$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $c16ba9ae45e54407$export$4119ddb38ccbfb87);

var $2RyvH = parcelRequire("2RyvH");
const $c16ba9ae45e54407$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $c16ba9ae45e54407$export$4119ddb38ccbfb87 = (0, $2RyvH.default)($c16ba9ae45e54407$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("hIC2w", function(module, exports) {
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $b1ffed4be087c7d0$export$da1befb791e93c7e);

var $2RyvH = parcelRequire("2RyvH");
const $b1ffed4be087c7d0$export$da1befb791e93c7e = 'NotificationsCtx';
const $b1ffed4be087c7d0$export$6f8e7ff1e3feafd7 = (0, $2RyvH.default)($b1ffed4be087c7d0$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("eygP4", function(module, exports) {
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $b83846347ea43f9e$export$fc7a65795610cb71);

var $2RyvH = parcelRequire("2RyvH");
const $b83846347ea43f9e$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $b83846347ea43f9e$export$745926731087ebe2 = (0, $2RyvH.default)($b83846347ea43f9e$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("7zWjd", function(module, exports) {
$parcel$export(module.exports, "ATLAS_CONTEXT", () => $58e32324793a7399$export$4906017439f33fc0);

var $2RyvH = parcelRequire("2RyvH");
const $58e32324793a7399$export$4906017439f33fc0 = 'atlasCtx';
const $58e32324793a7399$export$43ebbe41370d4543 = (0, $2RyvH.default)($58e32324793a7399$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("bJcpB", function(module, exports) {
$parcel$export(module.exports, "TOWNSQUARE_HOME_CONTEXT", () => $9bd6d94301460af6$export$aa18ab4fff926c9e);

var $2RyvH = parcelRequire("2RyvH");
const $9bd6d94301460af6$export$aa18ab4fff926c9e = 'townsquareHomeCtx';
const $9bd6d94301460af6$export$d283110f5d85c8f2 = (0, $2RyvH.default)($9bd6d94301460af6$export$aa18ab4fff926c9e, 'TownsquareHomeAnalyticsContext');

});

parcelRegister("3FSPr", function(module, exports) {
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $43013ed74bc0f45d$export$3240443bf2b83834);

var $2RyvH = parcelRequire("2RyvH");
const $43013ed74bc0f45d$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $43013ed74bc0f45d$export$6d568da622ce0a08 = (0, $2RyvH.default)($43013ed74bc0f45d$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("hNNQu", function(module, exports) {
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $b2297c9b689e76b7$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $b2297c9b689e76b7$export$dcd232f3be312f94);

var $2RyvH = parcelRequire("2RyvH");
const $b2297c9b689e76b7$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $b2297c9b689e76b7$export$dcd232f3be312f94 = (0, $2RyvH.default)($b2297c9b689e76b7$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("2dcyp", function(module, exports) {
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $a83ef4cd7fbb34b3$export$5c3a6fd8b96e8b66);

var $2RyvH = parcelRequire("2RyvH");
const $a83ef4cd7fbb34b3$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $a83ef4cd7fbb34b3$export$de3826c30468da26 = (0, $2RyvH.default)($a83ef4cd7fbb34b3$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("kTYB3", function(module, exports) {
$parcel$export(module.exports, "AVP_CONTEXT", () => $5b9fa3abd9061d3f$export$c2a811a4e42f4af5);

var $2RyvH = parcelRequire("2RyvH");
const $5b9fa3abd9061d3f$export$c2a811a4e42f4af5 = 'avpCtx';
const $5b9fa3abd9061d3f$export$da383e8879a25b03 = (0, $2RyvH.default)($5b9fa3abd9061d3f$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("a5b21", function(module, exports) {
$parcel$export(module.exports, "GROWTH_CONTEXT", () => $bb092dbaa95f315c$export$82023f2f4bfb06c1);

var $2RyvH = parcelRequire("2RyvH");
const $bb092dbaa95f315c$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $bb092dbaa95f315c$export$84980182680018f = (0, $2RyvH.default)($bb092dbaa95f315c$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});

parcelRegister("kFi7L", function(module, exports) {
$parcel$export(module.exports, "OMNI_CHANNEL_CONTEXT", () => $f6062070a79e367a$export$6d3c48fd1b3e4f3b);

var $2RyvH = parcelRequire("2RyvH");
const $f6062070a79e367a$export$6d3c48fd1b3e4f3b = 'omniChannelCtx';
const $f6062070a79e367a$export$e4e6df99270bbbb1 = (0, $2RyvH.default)($f6062070a79e367a$export$6d3c48fd1b3e4f3b, 'OmniChannelAnalyticsContext');

});

parcelRegister("gKvHx", function(module, exports) {
$parcel$export(module.exports, "ROVO_EXTENSION_CONTEXT", () => $2b6b4c8c0486c29a$export$fae437eb1dd9520c);

var $2RyvH = parcelRequire("2RyvH");
const $2b6b4c8c0486c29a$export$fae437eb1dd9520c = 'rovoExtensionCtx';
const $2b6b4c8c0486c29a$export$7fcecc25ee38fbef = (0, $2RyvH.default)($2b6b4c8c0486c29a$export$fae437eb1dd9520c, 'RovoExtensionAnalyticsContext');

});


parcelRegister("4qQ7A", function(module, exports) {
$parcel$export(module.exports, "EDITOR_TAG", () => $116ea2491361bea2$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $116ea2491361bea2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $73FZL = parcelRequire("73FZL");

var $6niD6 = parcelRequire("6niD6");

var $fNIU0 = parcelRequire("fNIU0");
const $116ea2491361bea2$export$a1d9dc589a29b3aa = 'editor';
const $116ea2491361bea2$export$8aa0d788f94a809 = 'fabricEditor';
class $116ea2491361bea2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $73FZL.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $6niD6.FabricChannel).editor
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $fNIU0.handleEvent)(event, [
                $116ea2491361bea2$export$a1d9dc589a29b3aa,
                $116ea2491361bea2$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("1ychy", function(module, exports) {
$parcel$export(module.exports, "default", () => $af19294aa1f6cb7e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $1vm9L = parcelRequire("1vm9L");

var $9fxvd = parcelRequire("9fxvd");
function $af19294aa1f6cb7e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).atlaskit,
        processEvent: (0, $1vm9L.default)
    });
}

});
parcelRegister("1vm9L", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fae2a0bf81e5d5c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");

var $5LAfC = parcelRequire("5LAfC");
const $7fae2a0bf81e5d5c$var$ATLASKIT_TAG = 'atlaskit';
const $7fae2a0bf81e5d5c$var$listenerVersion = undefined;
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7fae2a0bf81e5d5c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $5LAfC.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $5LAfC.getExtraAttributes)(event);
    const components = (0, $5LAfC.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $5LAfC.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $7fae2a0bf81e5d5c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $5LAfC.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($7fae2a0bf81e5d5c$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $dgWJT.UI_EVENT_TYPE)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $5LAfC.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $dgWJT.TRACK_EVENT_TYPE) || eventType === (0, $dgWJT.OPERATIONAL_EVENT_TYPE) || eventType === (0, $dgWJT.SCREEN_EVENT_TYPE)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("5LAfC", function(module, exports) {
$parcel$export(module.exports, "extractFromEventContext", () => $72d032912a21a9e4$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $72d032912a21a9e4$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $72d032912a21a9e4$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $72d032912a21a9e4$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $72d032912a21a9e4$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $72d032912a21a9e4$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $72d032912a21a9e4$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $lc40q = parcelRequire("lc40q");
const $72d032912a21a9e4$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $72d032912a21a9e4$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $72d032912a21a9e4$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $72d032912a21a9e4$export$5f9bc633b116660f = (event)=>$72d032912a21a9e4$export$9b947b4502cd2705('source', event);
const $72d032912a21a9e4$export$4e811121b221213b = (event)=>$72d032912a21a9e4$export$9b947b4502cd2705('component', event);
const $72d032912a21a9e4$export$67c3590839ebecdd = (event)=>$72d032912a21a9e4$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(result, extraAttributes), {});
const $72d032912a21a9e4$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $72d032912a21a9e4$export$18cd124b5098d330 = (event)=>$72d032912a21a9e4$export$9b947b4502cd2705('packageVersion', event);
function $72d032912a21a9e4$export$4e0b83da1896ebc7(event) {
    const packages = $72d032912a21a9e4$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("9fxvd", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ae2ee3d546c435e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $73FZL = parcelRequire("73FZL");

var $gBo3v = parcelRequire("gBo3v");
class $3ae2ee3d546c435e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $73FZL.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $gBo3v.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("lB7PV", function(module, exports) {
$parcel$export(module.exports, "default", () => $55fe17a4f0748cdd$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $55fe17a4f0748cdd$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $55fe17a4f0748cdd$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $55fe17a4f0748cdd$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $55fe17a4f0748cdd$export$ffe0c436e29512cf.DEBUG && logLevel <= $55fe17a4f0748cdd$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $55fe17a4f0748cdd$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($55fe17a4f0748cdd$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($55fe17a4f0748cdd$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($55fe17a4f0748cdd$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($55fe17a4f0748cdd$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("gz1V9", function(module, exports) {
$parcel$export(module.exports, "default", () => $89558f61ed5f1c4a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $6UtqP = parcelRequire("6UtqP");

var $9fxvd = parcelRequire("9fxvd");
function $89558f61ed5f1c4a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).navigation,
        processEvent: (0, $6UtqP.default)
    });
}

});
parcelRegister("6UtqP", function(module, exports) {
$parcel$export(module.exports, "default", () => $87493eddf5438bcb$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $iIhgr = parcelRequire("iIhgr");

var $bQz1w = parcelRequire("bQz1w");
const $87493eddf5438bcb$var$NAVIGATION_TAG = 'navigation';
const $87493eddf5438bcb$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $87493eddf5438bcb$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $iIhgr.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $iIhgr.NAVIGATION_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $iIhgr.NAVIGATION_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $iIhgr.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $iIhgr.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $87493eddf5438bcb$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($87493eddf5438bcb$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("bQz1w", function(module, exports) {
$parcel$export(module.exports, "getSources", () => $ea4fa1d32311a975$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $ea4fa1d32311a975$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $ea4fa1d32311a975$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $ea4fa1d32311a975$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $lc40q = parcelRequire("lc40q");
const $ea4fa1d32311a975$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $ea4fa1d32311a975$export$5f9bc633b116660f = (event, contextName)=>$ea4fa1d32311a975$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $ea4fa1d32311a975$export$4e811121b221213b = (event, contextName)=>$ea4fa1d32311a975$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $ea4fa1d32311a975$export$67c3590839ebecdd = (event, contextName)=>$ea4fa1d32311a975$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(result, extraAttributes), {});
const $ea4fa1d32311a975$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $ea4fa1d32311a975$export$18cd124b5098d330 = (event, contextName)=>$ea4fa1d32311a975$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("axXB1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a417aceaf3935304$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $419hV = parcelRequire("419hV");

var $9fxvd = parcelRequire("9fxvd");
function $a417aceaf3935304$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).media,
        processEvent: (0, $419hV.processEvent)
    });
}

});
parcelRegister("419hV", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $656b14946c9cf80e$export$22af68e3614bf024);

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $c6QjZ = parcelRequire("c6QjZ");

var $lc40q = parcelRequire("lc40q");

var $dZ56i = parcelRequire("dZ56i");

var $5LAfC = parcelRequire("5LAfC");
const $656b14946c9cf80e$var$listenerVersion = undefined;
function $656b14946c9cf80e$var$getMediaContexts(event) {
    return (0, $5LAfC.extractFromEventContext)((0, $c6QjZ.MEDIA_CONTEXT), event);
}
function $656b14946c9cf80e$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $656b14946c9cf80e$export$22af68e3614bf024(event) {
    const sources = (0, $5LAfC.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $5LAfC.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $5LAfC.getExtraAttributes)(event);
    const mediaContexts = $656b14946c9cf80e$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $5LAfC.getComponents)(event);
    const mediaRegion = $656b14946c9cf80e$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $5LAfC.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $656b14946c9cf80e$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("l8xvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac3e6d04e21e92d4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $60Sti = parcelRequire("60Sti");

var $9fxvd = parcelRequire("9fxvd");
function $ac3e6d04e21e92d4$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).peopleTeams,
        processEvent: (0, $60Sti.default)
    });
}

});
parcelRegister("60Sti", function(module, exports) {
$parcel$export(module.exports, "default", () => $9165f0e14c942447$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $lEpZN = parcelRequire("lEpZN");

var $bQz1w = parcelRequire("bQz1w");
const $9165f0e14c942447$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $9165f0e14c942447$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $9165f0e14c942447$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $lEpZN.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $lEpZN.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $lEpZN.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $lEpZN.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $lEpZN.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9165f0e14c942447$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($9165f0e14c942447$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("iwIGP", function(module, exports) {
$parcel$export(module.exports, "default", () => $a50cc2a215032187$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $20dfl = parcelRequire("20dfl");

var $9fxvd = parcelRequire("9fxvd");
function $a50cc2a215032187$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).notifications,
        processEvent: (0, $20dfl.default)
    });
}

});
parcelRegister("20dfl", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4e5bf3416d48c57$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");

var $bQz1w = parcelRequire("bQz1w");
parcelRequire("8lHWD");
var $hIC2w = parcelRequire("hIC2w");

var $6niD6 = parcelRequire("6niD6");
const $f4e5bf3416d48c57$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $f4e5bf3416d48c57$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $hIC2w.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $hIC2w.NOTIFICATIONS_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $hIC2w.NOTIFICATIONS_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $hIC2w.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $hIC2w.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $f4e5bf3416d48c57$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $6niD6.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("lLddi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ba3532562de8aeb$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $h74G0 = parcelRequire("h74G0");

var $9fxvd = parcelRequire("9fxvd");
function $2ba3532562de8aeb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).recentWork,
        processEvent: (0, $h74G0.default)
    });
}

});
parcelRegister("h74G0", function(module, exports) {
$parcel$export(module.exports, "default", () => $7aadb585fb3e3587$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");

var $bQz1w = parcelRequire("bQz1w");
parcelRequire("8lHWD");
var $eygP4 = parcelRequire("eygP4");

var $6niD6 = parcelRequire("6niD6");
const $7aadb585fb3e3587$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $7aadb585fb3e3587$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $eygP4.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $eygP4.RECENT_WORK_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $eygP4.RECENT_WORK_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $eygP4.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $eygP4.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $7aadb585fb3e3587$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $6niD6.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("jyt5l", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea0f435446818fdc$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $kuWSS = parcelRequire("kuWSS");

var $9fxvd = parcelRequire("9fxvd");
function $ea0f435446818fdc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).atlas,
        processEvent: (0, $kuWSS.default)
    });
}

});
parcelRegister("kuWSS", function(module, exports) {
$parcel$export(module.exports, "default", () => $383c1b81475ede26$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");

var $bQz1w = parcelRequire("bQz1w");
parcelRequire("8lHWD");
var $7zWjd = parcelRequire("7zWjd");
const $383c1b81475ede26$var$ATLAS_TAG = 'atlas';
const $383c1b81475ede26$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $383c1b81475ede26$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $7zWjd.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $7zWjd.ATLAS_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $7zWjd.ATLAS_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $7zWjd.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $7zWjd.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $383c1b81475ede26$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($383c1b81475ede26$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("cDzPu", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e2ca20ecabdaa36$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $bAcDB = parcelRequire("bAcDB");

var $9fxvd = parcelRequire("9fxvd");
function $5e2ca20ecabdaa36$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).crossFlow,
        processEvent: (0, $bAcDB.default)
    });
}

});
parcelRegister("bAcDB", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe35db9cf2fe2ca0$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dgWJT = parcelRequire("dgWJT");

var $dZ56i = parcelRequire("dZ56i");
parcelRequire("8lHWD");
var $iIhgr = parcelRequire("iIhgr");

var $5LAfC = parcelRequire("5LAfC");

var $bQz1w = parcelRequire("bQz1w");
const $fe35db9cf2fe2ca0$var$CROSS_FLOW_TAG = 'crossFlow';
var $fe35db9cf2fe2ca0$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $5LAfC.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $5LAfC.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $bQz1w.getExtraAttributes)(event, (0, $iIhgr.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($fe35db9cf2fe2ca0$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("5dflY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7caef51a075b2a77$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4Rek6 = parcelRequire("4Rek6");

var $6niD6 = parcelRequire("6niD6");

var $9fxvd = parcelRequire("9fxvd");
function $7caef51a075b2a77$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).linkingPlatform,
        processEvent: (0, $4Rek6.default)
    });
}

});
parcelRegister("4Rek6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8aeb1f4c48f4aa0$export$2e2bcd8739ae039);

var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $3FSPr = parcelRequire("3FSPr");

var $bQz1w = parcelRequire("bQz1w");

var $6niD6 = parcelRequire("6niD6");
const $d8aeb1f4c48f4aa0$var$listenerVersion = undefined;
var $d8aeb1f4c48f4aa0$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $3FSPr.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $3FSPr.LINKING_PLATFORM_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $3FSPr.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $3FSPr.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $6niD6.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $d8aeb1f4c48f4aa0$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("gYXZT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae11f0b66d3a47d7$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $19vUj = parcelRequire("19vUj");

var $9fxvd = parcelRequire("9fxvd");
function $ae11f0b66d3a47d7$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).postOffice,
        processEvent: (0, $19vUj.default)
    });
}

});
parcelRegister("19vUj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ab62aa893ae1df1$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $hNNQu = parcelRequire("hNNQu");

var $bQz1w = parcelRequire("bQz1w");

var $6niD6 = parcelRequire("6niD6");
const $8ab62aa893ae1df1$var$POST_OFFICE_TAG = (0, $6niD6.FabricChannel).postOffice;
const $8ab62aa893ae1df1$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $8ab62aa893ae1df1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $hNNQu.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $hNNQu.POST_OFFICE_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $hNNQu.POST_OFFICE_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $hNNQu.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $hNNQu.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $8ab62aa893ae1df1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($8ab62aa893ae1df1$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("iCaDK", function(module, exports) {
$parcel$export(module.exports, "default", () => $417672ec5787710c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $3tBjl = parcelRequire("3tBjl");

var $9fxvd = parcelRequire("9fxvd");
function $417672ec5787710c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).aiMate,
        processEvent: (0, $3tBjl.default)
    });
}

});
parcelRegister("3tBjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $530ff8b579650045$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $2dcyp = parcelRequire("2dcyp");

var $bQz1w = parcelRequire("bQz1w");
const $530ff8b579650045$var$AI_MATE_TAG = 'aiMate';
const $530ff8b579650045$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $530ff8b579650045$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $2dcyp.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $2dcyp.AI_MATE_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $2dcyp.AI_MATE_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $2dcyp.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $2dcyp.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name, objectId: objectId, objectType: objectType, containerType: containerType, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $530ff8b579650045$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($530ff8b579650045$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags),
                ...objectId && {
                    objectId: objectId
                },
                ...objectType && {
                    objectType: objectType
                },
                ...containerType && {
                    containerType: containerType
                },
                ...containerId && {
                    containerId: containerId
                }
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9omjr", function(module, exports) {
$parcel$export(module.exports, "default", () => $276436058f367519$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $gLVhE = parcelRequire("gLVhE");

var $9fxvd = parcelRequire("9fxvd");
function $276436058f367519$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).avp,
        processEvent: (0, $gLVhE.default)
    });
}

});
parcelRegister("gLVhE", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9039439e3461ce7$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $kTYB3 = parcelRequire("kTYB3");

var $bQz1w = parcelRequire("bQz1w");
const $c9039439e3461ce7$var$AVP_TAG = 'avp';
const $c9039439e3461ce7$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c9039439e3461ce7$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $kTYB3.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $kTYB3.AVP_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $kTYB3.AVP_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $kTYB3.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $kTYB3.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c9039439e3461ce7$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c9039439e3461ce7$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("1cGfp", function(module, exports) {
$parcel$export(module.exports, "default", () => $02ee1139070ca2a8$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $gst9o = parcelRequire("gst9o");

var $9fxvd = parcelRequire("9fxvd");
function $02ee1139070ca2a8$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).growth,
        processEvent: (0, $gst9o.default)
    });
}

});
parcelRegister("gst9o", function(module, exports) {
$parcel$export(module.exports, "default", () => $117837a37ecc0be8$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $a5b21 = parcelRequire("a5b21");

var $bQz1w = parcelRequire("bQz1w");
const $117837a37ecc0be8$var$GROWTH_TAG = 'growth';
const $117837a37ecc0be8$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $117837a37ecc0be8$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $a5b21.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $a5b21.GROWTH_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $a5b21.GROWTH_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $a5b21.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $a5b21.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $117837a37ecc0be8$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($117837a37ecc0be8$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("9OwW2", function(module, exports) {
$parcel$export(module.exports, "default", () => $171822abc0ceb5a2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $1qFxy = parcelRequire("1qFxy");

var $9fxvd = parcelRequire("9fxvd");
const $171822abc0ceb5a2$var$OmniChannelAnalyticsListener = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).omniChannel,
        processEvent: (0, $1qFxy.default)
    });
};
var $171822abc0ceb5a2$export$2e2bcd8739ae039 = $171822abc0ceb5a2$var$OmniChannelAnalyticsListener;

});
parcelRegister("1qFxy", function(module, exports) {
$parcel$export(module.exports, "default", () => $76eeeba4cec10cb1$export$2e2bcd8739ae039);

var $dgWJT = parcelRequire("dgWJT");
parcelRequire("8lHWD");
var $kFi7L = parcelRequire("kFi7L");

var $bQz1w = parcelRequire("bQz1w");

var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $6niD6 = parcelRequire("6niD6");
const $76eeeba4cec10cb1$var$listenerVersion = undefined;
var $76eeeba4cec10cb1$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $kFi7L.OMNI_CHANNEL_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $kFi7L.OMNI_CHANNEL_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $kFi7L.OMNI_CHANNEL_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $kFi7L.OMNI_CHANNEL_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $kFi7L.OMNI_CHANNEL_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $76eeeba4cec10cb1$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $6niD6.FabricChannel).omniChannel);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("lLZgZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7141ca40d558df2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $dM9YB = parcelRequire("dM9YB");

var $9fxvd = parcelRequire("9fxvd");
function $e7141ca40d558df2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).townsquareHome,
        processEvent: (0, $dM9YB.default)
    });
}

});
parcelRegister("dM9YB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b74ee10f1f7f378$export$2e2bcd8739ae039);

var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");

var $bQz1w = parcelRequire("bQz1w");
parcelRequire("8lHWD");
var $bJcpB = parcelRequire("bJcpB");
const $2b74ee10f1f7f378$var$TOWNSQUARE_TAG = 'townsquare';
const $2b74ee10f1f7f378$var$TOWNSQUARE_HOME_TAG = 'townsquareHome';
const $2b74ee10f1f7f378$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $2b74ee10f1f7f378$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $bJcpB.TOWNSQUARE_HOME_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $bJcpB.TOWNSQUARE_HOME_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $bJcpB.TOWNSQUARE_HOME_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $bJcpB.TOWNSQUARE_HOME_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $bJcpB.TOWNSQUARE_HOME_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $2b74ee10f1f7f378$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "townsquare" is our platform analytic for data portal
    tags.add($2b74ee10f1f7f378$var$TOWNSQUARE_TAG);
    // "townsquareHome" allows us to differentiate our events from townsquare events.
    tags.add($2b74ee10f1f7f378$var$TOWNSQUARE_HOME_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("E26To", function(module, exports) {
$parcel$export(module.exports, "default", () => $28dd571600a7af03$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $6WDTb = parcelRequire("6WDTb");

var $9fxvd = parcelRequire("9fxvd");
function $28dd571600a7af03$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).rovoExtension,
        processEvent: (0, $6WDTb.default)
    });
}

});
parcelRegister("6WDTb", function(module, exports) {
$parcel$export(module.exports, "default", () => $286939ac70d6077f$export$2e2bcd8739ae039);

var $dZ56i = parcelRequire("dZ56i");

var $lc40q = parcelRequire("lc40q");

var $dgWJT = parcelRequire("dgWJT");

var $bQz1w = parcelRequire("bQz1w");
parcelRequire("8lHWD");
var $gKvHx = parcelRequire("gKvHx");
const $286939ac70d6077f$var$ROVO_EXTENSION_TAG = 'rovoExtension';
const $286939ac70d6077f$var$listenerVersion = undefined;
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * It's a copy paste from the other process-event mappers.
 */ $286939ac70d6077f$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $bQz1w.getSources)(event, (0, $gKvHx.ROVO_EXTENSION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE);
    const extraAttributes = (0, $bQz1w.getExtraAttributes)(event, (0, $gKvHx.ROVO_EXTENSION_CONTEXT));
    const components = (0, $bQz1w.getComponents)(event, (0, $gKvHx.ROVO_EXTENSION_CONTEXT));
    const packages = (0, $bQz1w.getPackageInfo)(event, (0, $gKvHx.ROVO_EXTENSION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $bQz1w.getPackageInfo)(event, (0, $gKvHx.ROVO_EXTENSION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $dgWJT.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $286939ac70d6077f$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))(extraAttributes, payloadAttributes)
    };
    const tags = new Set(event.payload.tags || []);
    // "rovoExtension" allows us to differentiate our events from rovo events.
    tags.add($286939ac70d6077f$var$ROVO_EXTENSION_TAG);
    if (event.payload) switch(eventType){
        case 0, $dgWJT.UI_EVENT_TYPE:
        case 0, $dgWJT.OPERATIONAL_EVENT_TYPE:
        case 0, $dgWJT.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $dgWJT.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("bx8iY", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dabd31ad280b4c9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6niD6 = parcelRequire("6niD6");

var $2FyvZ = parcelRequire("2FyvZ");

var $9fxvd = parcelRequire("9fxvd");
function $9dabd31ad280b4c9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9fxvd.default), {
        ...props,
        channel: (0, $6niD6.FabricChannel).teamworkGraph,
        processEvent: (0, $2FyvZ.processEvent)
    });
}

});
parcelRegister("2FyvZ", function(module, exports) {
$parcel$export(module.exports, "processEvent", () => $09e216b6d2bf7e62$export$22af68e3614bf024);

var $dgWJT = parcelRequire("dgWJT");

var $lc40q = parcelRequire("lc40q");

var $dZ56i = parcelRequire("dZ56i");

var $5LAfC = parcelRequire("5LAfC");
const $09e216b6d2bf7e62$var$listenerVersion = undefined;
function $09e216b6d2bf7e62$export$22af68e3614bf024(event) {
    const sources = (0, $5LAfC.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))((0, $5LAfC.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $5LAfC.getExtraAttributes)(event);
    const tags = new Set(event.payload.tags || []);
    tags.add('teamworkGraph');
    const components = (0, $5LAfC.getComponents)(event);
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(sources) || (0, $dgWJT.DEFAULT_SOURCE),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))({}, extraAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $5LAfC.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $09e216b6d2bf7e62$var$listenerVersion
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});




parcelRegister("4xChi", function(module, exports) {
$parcel$export(module.exports, "setAccountMetaTag", () => $183e22ed944eb631$export$3ffe5752aad15e0d);

var $63sfu = parcelRequire("63sfu");

var $fJQMR = parcelRequire("fJQMR");

var $6mmHn = parcelRequire("6mmHn");
const $183e22ed944eb631$export$3ffe5752aad15e0d = (isAtlassianManaged, accountId)=>{
    if (!accountId) return;
    const accountTypeMeta = (0, $6mmHn.getMetaFromHTML)('ajs-account-type');
    const accountIdMeta = (0, $6mmHn.getMetaFromHTML)('ajs-atlassian-account-id');
    if (!(0, $63sfu.isNil)(accountTypeMeta) && !(0, $63sfu.isNil)(accountIdMeta) && accountIdMeta === accountId) return;
    (0, $6mmHn.setHTMLMeta)('ajs-atlassian-account-id', accountId);
    (0, $6mmHn.setHTMLMeta)('account-id', accountId);
    if (isAtlassianManaged) (0, $6mmHn.setHTMLMeta)('ajs-account-type', 'atlassian');
    else (0, $6mmHn.setHTMLMeta)('ajs-account-type', 'customer');
    (0, $fJQMR.updateUserInfo)(accountId);
};

});

parcelRegister("bYfAV", function(module, exports) {
$parcel$export(module.exports, "CustomDomainsAnalyticsProvider", () => $89ef2118e2c94271$export$8bf41bf02d1555eb);

var $4fqPo = parcelRequire("4fqPo");

var $54jwS = parcelRequire("54jwS");
const $89ef2118e2c94271$export$8bf41bf02d1555eb = ({ children: children, baseUrl: baseUrl })=>{
    const atlassianDomains = [
        'atlassian.net',
        'jira-dev.com',
        'atlassian.com',
        'jira.com',
        'atl-paas.net',
        'trello.com',
        'bitbucket.org'
    ];
    if (atlassianDomains.some((domain)=>baseUrl.toLowerCase().includes(domain))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $54jwS.AnalyticsContext), {
        attributes: {
            isCustomDomain: false
        }
    }, children);
    const customDomain = new URL(baseUrl).hostname;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $54jwS.AnalyticsContext), {
        attributes: {
            customDomain: customDomain,
            isCustomDomain: true
        }
    }, children);
};

});

parcelRegister("aiZWa", function(module, exports) {
$parcel$export(module.exports, "default", () => $43878bbc886debc3$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $54jwS = parcelRequire("54jwS");
const $43878bbc886debc3$var$extractFlags = ()=>Object.entries($bG6ob).reduce((acc, [key, value])=>{
        if (typeof value !== 'function') return acc;
        return {
            ...acc,
            [key]: value()
        };
    }, {});
const $43878bbc886debc3$var$FeatureFlagContext = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $54jwS.AnalyticsContext), {
        attributes: $43878bbc886debc3$var$extractFlags()
    }, children);
var $43878bbc886debc3$export$2e2bcd8739ae039 = $43878bbc886debc3$var$FeatureFlagContext;

});

parcelRegister("d64Rz", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsContext", () => $95c93da8cb0090d9$export$156073b6afb2624e);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $jiwWm = parcelRequire("jiwWm");
const $95c93da8cb0090d9$var$selector = (state)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    const attributes = (0, $95tqy.getPortalAnalyticAttributes)(state, portalId);
    return {
        attributes: attributes
    };
};
const $95c93da8cb0090d9$export$156073b6afb2624e = (0, $bmgw6.default)($95c93da8cb0090d9$var$selector)((0, $jiwWm.default));

});
parcelRegister("jiwWm", function(module, exports) {
$parcel$export(module.exports, "default", () => $134c276fb8fce0c4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $54jwS = parcelRequire("54jwS");
const $134c276fb8fce0c4$var$PortalContext = ({ children: children, attributes: attributes })=>/*#__PURE__*/ $4fqPo.createElement((0, $54jwS.AnalyticsContext), {
        sourceName: "portalUnknown",
        sourceType: (0, $54jwS.ScreenTypes).SCREEN,
        attributes: {
            context: 'Portal',
            ...attributes
        }
    }, children);
var $134c276fb8fce0c4$export$2e2bcd8739ae039 = $134c276fb8fce0c4$var$PortalContext;

});


parcelRegister("75i57", function(module, exports) {
$parcel$export(module.exports, "withCoordinationClient", () => $c74a4992f26731c4$export$eeb046361df75e84);
$parcel$export(module.exports, "default", () => $c74a4992f26731c4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $6mmHn = parcelRequire("6mmHn");

var $bZcCh = parcelRequire("bZcCh");

var $fVwZr = parcelRequire("fVwZr");
const $c74a4992f26731c4$export$a91cdb60d3cc20e2 = /*#__PURE__*/ $4fqPo.createContext({
    coordinationClient: undefined
});

const $c74a4992f26731c4$var$CoordinationClientProvider = ({ cloudId: cloudId, children: children })=>{
    const [coordinationClient, setCoordinationClient] = $4fqPo.useState(undefined);
    $4fqPo.useEffect(()=>{
        (0, $bZcCh.promiseWithRetries)(()=>(parcelRequire("3nglj"))).then((module)=>{
            setCoordinationClient(new module.CoordinationClient(cloudId, '/gateway/api'));
        }).catch((error)=>{
            (0, $fVwZr.reportError)(error);
        });
    }, [
        cloudId
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($c74a4992f26731c4$export$a91cdb60d3cc20e2.Provider, {
        value: {
            coordinationClient: coordinationClient
        }
    }, children);
};
const $c74a4992f26731c4$export$eeb046361df75e84 = (InnerComponent)=>{
    const Component = (props)=>{
        const { coordinationClient: coordinationClient } = $4fqPo.useContext($c74a4992f26731c4$export$a91cdb60d3cc20e2);
        return /*#__PURE__*/ $4fqPo.createElement(InnerComponent, {
            ...props,
            coordinationClient: coordinationClient
        });
    };
    return Component;
};
const $c74a4992f26731c4$var$mapStateToProps = ()=>{
    return {
        cloudId: (0, $6mmHn.getMeta)('tenant-id')
    };
};
var $c74a4992f26731c4$export$2e2bcd8739ae039 = (0, $bmgw6.default)($c74a4992f26731c4$var$mapStateToProps)($c74a4992f26731c4$var$CoordinationClientProvider);

});
parcelRegister("bZcCh", function(module, exports) {
$parcel$export(module.exports, "promiseWithRetries", () => $6dc7df7c5511fc9f$export$e27278bd94558912);
const $6dc7df7c5511fc9f$var$DEFAULT_TIMEOUT_MS = 1000;
const $6dc7df7c5511fc9f$var$DEFAULT_NUMBER_OF_RETRIES = 3;
const $6dc7df7c5511fc9f$var$delay = (timeMs)=>new Promise((resolve)=>setTimeout(resolve, timeMs));
const $6dc7df7c5511fc9f$export$e27278bd94558912 = (promise, config = {})=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { numberOfRetries: numberOfRetries = $6dc7df7c5511fc9f$var$DEFAULT_NUMBER_OF_RETRIES, timeoutMs: timeoutMs = $6dc7df7c5511fc9f$var$DEFAULT_TIMEOUT_MS, error: error = null } = config;
    if (numberOfRetries <= 0) return Promise.reject(error);
    return promise().catch((promiseError)=>$6dc7df7c5511fc9f$var$delay(timeoutMs).then(()=>// Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            $6dc7df7c5511fc9f$export$e27278bd94558912(promise, {
                ...config,
                numberOfRetries: numberOfRetries - 1,
                error: promiseError
            })));
};

});

parcelRegister("3nglj", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("cosbn"),
    $e46AW("86ale"),
    $e46AW("6fRBC")
]).then(()=>parcelRequire('b67Ip'));

});


parcelRegister("7xkqd", function(module, exports) {
$parcel$export(module.exports, "intlErrorMatch", () => $79e16bdd485493e5$export$c8d26e19aa1787d3);
const $79e16bdd485493e5$export$c8d26e19aa1787d3 = (intlError)=>{
    const match = intlError.match(/Missing message: "(.*)" for locale "(.*)", using default message as fallback./);
    let isNonFinal = false;
    const errorKey = match ? match[1] : null;
    if (errorKey) isNonFinal = [
        '.non-final',
        'nonFinal'
    ].some((checkString)=>errorKey.includes(checkString));
    return {
        errorKey: errorKey,
        isNonFinal: isNonFinal,
        errorLocale: match ? match[2] : null
    };
};

});

parcelRegister("klY6L", function(module, exports) {
$parcel$export(module.exports, "default", () => $afd853f3dcfbaa7a$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $cjgvu = parcelRequire("cjgvu");
const $afd853f3dcfbaa7a$var$selector = (0, $3yyCx.createSelector)((0, $2hx7o.getLocale), (locale)=>({
        locale: locale
    }));
var $afd853f3dcfbaa7a$export$2e2bcd8739ae039 = (0, $bmgw6.default)($afd853f3dcfbaa7a$var$selector)((0, $cjgvu.DeferredWrmResourceProvider));

});
parcelRegister("cjgvu", function(module, exports) {
$parcel$export(module.exports, "DeferredWrmResourceContext", () => $4f7bbba299e76bb9$export$266fd8d1fd8c9019);
$parcel$export(module.exports, "DeferredWrmResourceProvider", () => $4f7bbba299e76bb9$export$f1f3f896300d60a3);

var $4fqPo = parcelRequire("4fqPo");

var $63sfu = parcelRequire("63sfu");

var $iUBoQ = parcelRequire("iUBoQ");

var $29d7g = parcelRequire("29d7g");
const $4f7bbba299e76bb9$export$266fd8d1fd8c9019 = /*#__PURE__*/ $4fqPo.createContext({
    resourcesLoaded: false,
    setResourcesLoaded: (0, $63sfu.noop)
});
const $4f7bbba299e76bb9$var$DEFERRED_WRM_CONTEXT = [
    'deferred.customer.portal.wrm'
];
const $4f7bbba299e76bb9$var$getDeferredWrmContexts = (0, $iUBoQ.default)((locale)=>[
        ...$4f7bbba299e76bb9$var$DEFERRED_WRM_CONTEXT,
        `jira.webresources:calendar-${locale}`
    ]);
const $4f7bbba299e76bb9$export$f1f3f896300d60a3 = ({ children: children, locale: locale })=>{
    const [resourcesLoaded, setLoaded] = $4fqPo.useState(false);
    const setResourcesLoaded = $4fqPo.useCallback(()=>{
        setLoaded(true);
    }, [
        setLoaded
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($4f7bbba299e76bb9$export$266fd8d1fd8c9019.Provider, {
        value: {
            resourcesLoaded: resourcesLoaded,
            setResourcesLoaded: setResourcesLoaded
        }
    }, /*#__PURE__*/ $4fqPo.createElement((0, $29d7g.default), {
        onResourcesLoaded: setResourcesLoaded,
        resourceKeys: $4f7bbba299e76bb9$var$getDeferredWrmContexts(locale)
    }), children);
};

});
parcelRegister("iUBoQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d16d4852bbe6a4b$export$2e2bcd8739ae039);
/**
 * Copied from https://github.com/alexreardon/memoize-one/tree/master/src
 *
 *
 * Delete this folder when https://github.com/alexreardon/memoize-one/issues/37 is resolved and we can use the package directly
 * turning on esModuleInterop breaks a whole bunch of other tests, so for now this is the least intrusive workaround to get this utility
 *
 */ function $0d16d4852bbe6a4b$var$areInputsEqual(newInputs, lastInputs) {
    // no checks needed if the inputs length has changed
    if (newInputs.length !== lastInputs.length) return false;
    // Using for loop for speed. It generally performs better than array.every
    // https://github.com/alexreardon/memoize-one/pull/59
    for(let i = 0; i < newInputs.length; i++){
        // using shallow equality check
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $0d16d4852bbe6a4b$export$2e2bcd8739ae039(resultFn, isEqual = $0d16d4852bbe6a4b$var$areInputsEqual) {
    let lastThis;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    // breaking cache when context (this) or arguments change
    function memoized(...newArgs) {
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        // Throwing during an assignment aborts the assignment: https://codepen.io/alexreardon/pen/RYKoaz
        // Doing the lastResult assignment first so that if it throws
        // nothing will be overwritten
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        // @typescript-eslint upgrade to v5.61.0
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

});

parcelRegister("29d7g", function(module, exports) {
$parcel$export(module.exports, "default", () => $7969d94d4e8dcafc$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $63sfu = parcelRequire("63sfu");

var $keOG0 = parcelRequire("keOG0");

var $kXlzl = parcelRequire("kXlzl");

var $iLGPT = parcelRequire("iLGPT");
const $7969d94d4e8dcafc$var$createScriptResource = (url)=>Object.assign(document.createElement('script'), {
        type: 'text/javascript',
        charset: 'utf-8',
        async: true,
        src: url
    });
const $7969d94d4e8dcafc$var$createCssResource = (url)=>Object.assign(document.createElement('link'), {
        rel: 'stylesheet',
        type: 'text/css',
        href: url
    });
const $7969d94d4e8dcafc$var$createResource = (resourceDescriptor)=>{
    const { resourceType: resourceType, url: url } = resourceDescriptor;
    if (resourceType === 'CSS') return $7969d94d4e8dcafc$var$createCssResource(url);
    return $7969d94d4e8dcafc$var$createScriptResource(url);
};
const $7969d94d4e8dcafc$var$loadResources = (0, $63sfu.once)((wrmResources, unparsedData)=>{
    window.WRM = {
        _unparsedData: {
            ...unparsedData
        }
    };
    const resources = wrmResources.map((resource)=>new Promise((resolve)=>{
            resource.onload = ()=>{
                resolve();
            };
            resource.onerror = (error)=>{
                (0, $keOG0.trackError)(`deferred.wrm.resource.load.failed`, {}, error.message);
                (0, $kXlzl.operationalEvent)({
                    action: 'failed',
                    actionSubject: 'loadWrmResources',
                    source: 'unknownSource',
                    attributes: {
                        errorMessage: error.message
                    }
                });
            };
            document.head.appendChild(resource);
        }));
    return Promise.all(resources);
});
const $7969d94d4e8dcafc$var$WrmModuleLoader = ({ onResourcesLoaded: onResourcesLoaded, resourceKeys: resourceKeys })=>{
    const asyncWrmRequire = $4fqPo.useCallback(async ()=>{
        try {
            const { unparsedData: unparsedData, resources: resourceDescriptors } = await (0, $iLGPT.fetchWrmResourceDescriptors)(resourceKeys);
            const wrmResources = resourceDescriptors.map((resourceDescriptor)=>$7969d94d4e8dcafc$var$createResource(resourceDescriptor));
            // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $7969d94d4e8dcafc$var$loadResources(wrmResources, unparsedData).then(()=>{
                onResourcesLoaded();
            });
        } catch (e) {
            (0, $keOG0.trackError)('fetchWrmResourceDescriptors.fetch.failed', {}, e);
            (0, $kXlzl.operationalEvent)({
                action: 'failed',
                actionSubject: 'fetchWrmResourceDescriptors',
                source: 'unknownSource',
                attributes: {
                    resourceKeys: resourceKeys,
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    errorMessage: e.message
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (0, $iLGPT.fetchWrmResourceDescriptors)
    ]);
    $4fqPo.useEffect(()=>{
        // Disabling existing violations, should be fixed when revisited.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        asyncWrmRequire();
    }, [
        asyncWrmRequire
    ]);
    return null;
};
var $7969d94d4e8dcafc$export$2e2bcd8739ae039 = $7969d94d4e8dcafc$var$WrmModuleLoader;

});
parcelRegister("iLGPT", function(module, exports) {
$parcel$export(module.exports, "fetchWrmResourceDescriptors", () => $5ef41fea16ecc5ef$export$25121547929106be);

var $lVFX8 = parcelRequire("lVFX8");

var $3wR8f = parcelRequire("3wR8f");
const $5ef41fea16ecc5ef$var$getRequestBody = ({ webResources: webResources = [], contexts: contexts = [], excludedContexts: excludedContexts = [], excludedWebResources: excludedWebResources = [] })=>({
        r: webResources,
        c: contexts,
        xc: excludedContexts,
        xr: excludedWebResources
    });
const $5ef41fea16ecc5ef$export$25121547929106be = (resources)=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/webResources/1.0/resources`;
    const body = $5ef41fea16ecc5ef$var$getRequestBody({
        contexts: resources
    });
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (0, $lVFX8.post)(uri, body, {
        'Content-Type': 'application/json'
    })// Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    .map(({ response: response })=>response).toPromise().catch((e)=>Promise.reject(e));
};

});




parcelRegister("3B6fC", function(module, exports) {
$parcel$export(module.exports, "MetaDataProvider", () => (parcelRequire("iHP9e")).default);

var $iHP9e = parcelRequire("iHP9e");

var $gI5jE = parcelRequire("gI5jE");

});
parcelRegister("iHP9e", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b25842584620b05$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");
parcelRequire("jYob8");
var $cGPrY = parcelRequire("cGPrY");
parcelRequire("9FUG9");
var $kKQy2 = parcelRequire("kKQy2");

var $gI5jE = parcelRequire("gI5jE");
const $6b25842584620b05$var$mapDispatchToProps = {
    updateEnvAction: $cGPrY.updateEnvAction,
    updateMetaAction: $kKQy2.updateMetaAction
};
var $6b25842584620b05$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, $6b25842584620b05$var$mapDispatchToProps)((0, $gI5jE.default));

});



parcelRegister("TqMeT", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => (parcelRequire("3w7cm")).default);

var $3w7cm = parcelRequire("3w7cm");

});
parcelRegister("3w7cm", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac482844f0b4451d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $fNJfr = parcelRequire("fNJfr");

var $2rHMv = parcelRequire("2rHMv");

var $5Uaxl = parcelRequire("5Uaxl");

var $4g4yb = parcelRequire("4g4yb");

var $2eKV2 = parcelRequire("2eKV2");

var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");

var $fwSzd = parcelRequire("fwSzd");
const $ac482844f0b4451d$var$GenericErrorPage = ({ title: title, message: message, hideFooter: hideFooter })=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $2rHMv.Root), null, /*#__PURE__*/ $4fqPo.createElement((0, $2rHMv.Container), null, /*#__PURE__*/ $4fqPo.createElement((0, $2rHMv.PageErrorIcon), null), /*#__PURE__*/ $4fqPo.createElement((0, $2rHMv.MessageContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
            space: "space.200",
            alignInline: "center"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
            size: "xlarge"
        }, title ? title : /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $fNJfr.default).errorTitle)), /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), {
            align: "center"
        }, message ? message : /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $fNJfr.default).errorMessage)))
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2rHMv.ErrorMessage), null, title ? title : /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $fNJfr.default).errorTitle)), /*#__PURE__*/ $4fqPo.createElement((0, $2rHMv.HelpText), null, message ? message : /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $fNJfr.default).errorMessage))))), !hideFooter && /*#__PURE__*/ $4fqPo.createElement((0, $4g4yb.Footer), null));
};
var $ac482844f0b4451d$export$2e2bcd8739ae039 = $ac482844f0b4451d$var$GenericErrorPage;

});
parcelRegister("fNJfr", function(module, exports) {
$parcel$export(module.exports, "default", () => $72ef8002205e562b$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $72ef8002205e562b$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    errorTitle: {
        defaultMessage: "We're on it",
        description: 'Error title to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.title'
    },
    errorMessage: {
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'Error message to show on the generic error page.',
        id: 'cv.portal.generic.error.page.error.message'
    }
});

});

parcelRegister("2rHMv", function(module, exports) {
$parcel$export(module.exports, "Root", () => $4f4e3387a03842f7$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "Container", () => $4f4e3387a03842f7$export$42a852a2b6b56249);
$parcel$export(module.exports, "ErrorMessage", () => $4f4e3387a03842f7$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "HelpText", () => $4f4e3387a03842f7$export$a67c0bc59081311a);
$parcel$export(module.exports, "MessageContainer", () => $4f4e3387a03842f7$export$616d763e306cba45);
$parcel$export(module.exports, "PageErrorIcon", () => $4f4e3387a03842f7$export$4e475cfbf52c9b29);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $kmGPV = parcelRequire("kmGPV");
const $4f4e3387a03842f7$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-16pz4j-0"
})`${$iSWaE.flexCenter};height:100%;flex:1 1 auto;flex-direction:column;`;
const $4f4e3387a03842f7$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-16pz4j-1"
})`${$iSWaE.flexCenter};flex:1 1 auto;flex-direction:column;margin-bottom:${"var(--ds-space-800, 64px)"};padding-bottom:${"var(--ds-space-100, 8px)"};`;
const $4f4e3387a03842f7$export$915e9e7bd4f0f96d = /*#__PURE__*/ (0, $el3DQ.default).h1.withConfig({
    componentId: "sc-16pz4j-2"
})`${$4W9tu.h800};`;
const $4f4e3387a03842f7$export$a67c0bc59081311a = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-16pz4j-3"
})`margin-top:${"var(--ds-space-200, 16px)"};`;
const $4f4e3387a03842f7$export$616d763e306cba45 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-16pz4j-4"
})`text-align:center;padding:0 ${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-300, 24px)"};max-width:${$bpWyP.multiple(53).px};`;
const $4f4e3387a03842f7$export$4e475cfbf52c9b29 = /*#__PURE__*/ (0, $el3DQ.default)((0, $kmGPV.default)).withConfig({
    componentId: "sc-16pz4j-5"
})`width:${$bpWyP.multiple(34).px};`;

});
parcelRegister("4W9tu", function(module, exports) {
$parcel$export(module.exports, "small", () => $384c9c70e9677aaf$export$3c17b0e969a90510);
$parcel$export(module.exports, "regular", () => $384c9c70e9677aaf$export$28a535dd448ffda4);
$parcel$export(module.exports, "medium", () => $384c9c70e9677aaf$export$649ecc744817b5c7);
$parcel$export(module.exports, "mediumLarge", () => $384c9c70e9677aaf$export$eab9f63b1324bb90);
$parcel$export(module.exports, "xsmall", () => $384c9c70e9677aaf$export$53e73bcd5097e50d);
$parcel$export(module.exports, "h800", () => $384c9c70e9677aaf$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $384c9c70e9677aaf$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $384c9c70e9677aaf$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $384c9c70e9677aaf$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $384c9c70e9677aaf$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $384c9c70e9677aaf$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $384c9c70e9677aaf$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $384c9c70e9677aaf$export$dfc0e69214efdc3c);
/* eslint-disable @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css -- Disabled to upgrade atlaskit/theme */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
const $384c9c70e9677aaf$export$3c17b0e969a90510 = /*#__PURE__*/ (0, $el3DQ.css)`font-size:12px;`;
const $384c9c70e9677aaf$export$28a535dd448ffda4 = /*#__PURE__*/ (0, $el3DQ.css)`font-size:14px;`;
const $384c9c70e9677aaf$export$649ecc744817b5c7 = /*#__PURE__*/ (0, $el3DQ.css)`font-size:16px;`;
const $384c9c70e9677aaf$export$eab9f63b1324bb90 = /*#__PURE__*/ (0, $el3DQ.css)`font-size:18px;`;
const $384c9c70e9677aaf$export$53e73bcd5097e50d = /*#__PURE__*/ (0, $el3DQ.css)`font-size:11px;`;
const $384c9c70e9677aaf$export$3953fb6fbd158d23 = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '2.071em',
    fontStyle: 'inherit',
    lineHeight: 1.103
});
const $384c9c70e9677aaf$export$e4f993a313607daa = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    marginTop: "var(--ds-space-500, 40px)",
    fontSize: '1.714em',
    fontStyle: 'inherit',
    lineHeight: 1.167
});
const $384c9c70e9677aaf$export$1e8b2acea3fb3119 = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/use-tokens-space
    marginTop: '28px',
    fontSize: '1.429em',
    fontStyle: 'inherit',
    lineHeight: 1.2
});
const $384c9c70e9677aaf$export$85aa43a9b9f06707 = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    marginTop: "var(--ds-space-300, 24px)",
    fontSize: '1.143em',
    fontStyle: 'inherit',
    lineHeight: 1.25
});
const $384c9c70e9677aaf$export$fcb7764b80bd908f = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '1em',
    fontStyle: 'inherit',
    lineHeight: 1.143
});
const $384c9c70e9677aaf$export$a0e59c3bbc05e815 = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text, #172B4D)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-250, 20px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333,
    textTransform: 'uppercase'
});
const $384c9c70e9677aaf$export$7ccf32eb2150ac7e = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333
});
const $384c9c70e9677aaf$export$dfc0e69214efdc3c = /*#__PURE__*/ (0, $el3DQ.css)({
    color: "var(--ds-text-subtlest, #6B778C)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    marginTop: "var(--ds-space-200, 16px)",
    fontSize: '0.786em',
    fontStyle: 'inherit',
    lineHeight: 1.455
});

});

parcelRegister("kmGPV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e2e1a86ec08f1ec$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $6e2e1a86ec08f1ec$var$SvgPageerrorreact = (props)=>/*#__PURE__*/ $4fqPo.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 244.1 215.54",
        ...props
    }, /*#__PURE__*/ $4fqPo.createElement("defs", null, /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient",
        x1: 161.63,
        y1: 110.9,
        x2: 64.3,
        y2: 156.29,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-2",
        x1: 14.8,
        y1: 230.34,
        x2: 229.01,
        y2: 16.13,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0,
        stopColor: "#c1c7d0"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 1,
        stopColor: "#fafbfc"
    })), /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-3",
        x1: 44.97,
        y1: 136.36,
        x2: 187.42,
        y2: -6.09,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0,
        stopColor: "#fafbfc",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0.82,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: "page_error_react_svg__linear-gradient-4",
        x1: 68.71,
        y1: 188.85,
        x2: 148.65,
        y2: 108.91,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0,
        stopColor: "#ebecf0",
        stopOpacity: 0.1
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 1,
        stopColor: "#ebecf0"
    })), /*#__PURE__*/ $4fqPo.createElement("clipPath", {
        id: "page_error_react_svg__clip-path"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "page_error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    })), /*#__PURE__*/ $4fqPo.createElement("clipPath", {
        id: "page_error_react_svg__clip-path-2"
    }, /*#__PURE__*/ $4fqPo.createElement("rect", {
        id: "page_error_react_svg___Rectangle_",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    })), /*#__PURE__*/ $4fqPo.createElement("style", null, ".page_error_react_svg__cls-1{fill:#fff}.page_error_react_svg__cls-2{fill:url(#page_error_react_svg__linear-gradient)}.page_error_react_svg__cls-7{fill:#253858}.page_error_react_svg__cls-15{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $4fqPo.createElement("g", {
        style: {
            isolation: "isolate"
        }
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        id: "page_error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        id: "page_error_react_svg__Software"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "page_error_react_svg___Rectangle_2",
        "data-name": "<Rectangle>",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-2)"
        },
        d: "M0 30.92h243.81v184.62H0z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        style: {
            fill: "#ebecf0"
        },
        d: "M0 30.92h243.81v19.67H0z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M244.1 67.68c-69.18-6-108.85.91-132.52 8.71-4.66 1.53-10.66 3.75-20.52 6.35-35.63 9.41-68.6 9.94-90.77 8.93V50.59H244.1Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-3)",
            mixBlendMode: "multiply"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("circle", {
        className: "page_error_react_svg__cls-7",
        cx: 15.69,
        cy: 40.69,
        r: 5.11
    }), /*#__PURE__*/ $4fqPo.createElement("circle", {
        cx: 32.37,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#a5adba"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("circle", {
        cx: 49.05,
        cy: 40.69,
        r: 5.11,
        style: {
            fill: "#0065ff"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("rect", {
        id: "page_error_react_svg___Rectangle_3",
        "data-name": "<Rectangle>",
        className: "page_error_react_svg__cls-1",
        x: 36.6,
        y: 80.59,
        width: 170.61,
        height: 106.38,
        rx: 5.07,
        ry: 5.07
    }), /*#__PURE__*/ $4fqPo.createElement("g", {
        style: {
            clipPath: "url(#page_error_react_svg__clip-path-2)"
        }
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "page_error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        d: "m118 78.83 47.32 82A10.81 10.81 0 0 1 156 177H61.36A10.81 10.81 0 0 1 52 160.8l47.32-82a10.81 10.81 0 0 1 18.68.03Z",
        style: {
            fill: "url(#page_error_react_svg__linear-gradient-4)",
            mixBlendMode: "multiply"
        }
    })), /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "page_error_react_svg___Polygon_3",
        "data-name": "<Polygon>",
        className: "page_error_react_svg__cls-2",
        d: "m133.8 70.82 47.32 82a10.81 10.81 0 0 1-9.36 16.18H77.11a10.81 10.81 0 0 1-9.36-16.21l47.32-82a10.81 10.81 0 0 1 18.73.03Z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "page_error_react_svg__cls-7",
        d: "m128.41 130.33 2.05-31.59a6.54 6.54 0 0 0-6.53-7 6.54 6.54 0 0 0-6.53 7l2.05 31.59a4.49 4.49 0 0 0 4.48 4.2 4.49 4.49 0 0 0 4.48-4.2ZM117.13 147.1a6.79 6.79 0 0 0 7.4 6.82 6.89 6.89 0 0 0-.64-13.76 6.87 6.87 0 0 0-6.76 6.94Z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M134.17 26.76 126.87.44a.6.6 0 0 0-1.17.05l-4.59 24.72-5.71-1.06a.6.6 0 0 0-.69.75L122 51.23a.6.6 0 0 0 1.17-.05l4.59-24.72 5.71 1.06a.6.6 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "m108 41.19-10.73-8.43a.26.26 0 0 0-.4.32l5.44 11.26-2.62 1.27a.26.26 0 0 0 0 .45l10.71 8.42a.26.26 0 0 0 .4-.32l-5.49-11.26 2.62-1.27a.26.26 0 0 0 .07-.44Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M157.26 36c-1.15 1.57-10.83-5.52-12-3.95s8.53 8.66 7.38 10.23-10.83-5.52-12-3.94 8.53 8.66 7.38 10.23-10.84-5.51-12-3.94 8.53 8.66 7.38 10.24",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "page_error_react_svg__cls-15",
        d: "M162 63.22c-1.44 1.31-6.95-4.71-8.38-3.39s4.07 7.34 2.63 8.65-6.95-4.71-8.38-3.39c-.67.61.16 2.23 1.1 3.93M88 63.09c1.79.76 5-6.77 6.76-6s-1.37 8.28.42 9 5-6.77 6.76-6c.83.35.6 2.16.29 4.07"
    })))));
var $6e2e1a86ec08f1ec$export$2e2bcd8739ae039 = $6e2e1a86ec08f1ec$var$SvgPageerrorreact;

});


parcelRegister("4g4yb", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $70dfca05c916eaf2$export$a06f1c675e846f6f);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");

var $lIm9q = parcelRequire("lIm9q");
const $70dfca05c916eaf2$var$selector = (0, $3yyCx.createSelector)((0, $2mzxy.getWacLink), (linkTo)=>({
        linkTo: linkTo
    }));
const $70dfca05c916eaf2$export$a06f1c675e846f6f = (0, $bmgw6.default)($70dfca05c916eaf2$var$selector)((0, $lIm9q.default));

});
parcelRegister("lIm9q", function(module, exports) {
$parcel$export(module.exports, "default", () => $22d67a2e1ea7d262$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eiGUu = parcelRequire("eiGUu");

var $eG61t = parcelRequire("eG61t");

var $bG6ob = parcelRequire("bG6ob");

var $4W9tu = parcelRequire("4W9tu");

var $brRRh = parcelRequire("brRRh");

var $a3mTv = parcelRequire("a3mTv");

var $1scQH = parcelRequire("1scQH");

var $5Uaxl = parcelRequire("5Uaxl");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $fFB0R = parcelRequire("fFB0R");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $aQEED = parcelRequire("aQEED");

var $hTMzE = parcelRequire("hTMzE");
const $22d67a2e1ea7d262$var$EDIT_HOMEPAGE_ROUTE_NAME = 'edit-homepage';
const $22d67a2e1ea7d262$var$Footer = ({ linkTo: linkTo, className: className, isCSM: isCSM })=>{
    const [{ route: route }] = (0, $hfD9S.useRouter)();
    // isCSM check is used for generating correct footer in CSMRequest Type Previews
    const showCSMFooter = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) || isCSM;
    const renderCsmFooter = ()=>{
        // TODO: move contact us section to edit csm page, once page builder allows additional children components
        return (0, $bG6ob.isCsmContactUsSectionEnabled)() && route.name === $22d67a2e1ea7d262$var$EDIT_HOMEPAGE_ROUTE_NAME ? /*#__PURE__*/ $4fqPo.createElement((0, $eG61t.ContactUsSection), null) : null;
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            source: 'footer'
        }
    }, /*#__PURE__*/ $4fqPo.createElement($22d67a2e1ea7d262$var$FooterContainer, {
        id: "portal-layout-footer",
        className: className,
        "data-testid": "portal-layout-footer"
    }, showCSMFooter ? renderCsmFooter() : /*#__PURE__*/ $4fqPo.createElement($22d67a2e1ea7d262$var$FooterLink, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        target: "_blank",
        rel: "noopener noreferrer",
        href: linkTo,
        actionSubjectId: "waclink"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
        ...(0, $aQEED.default).footer,
        values: {
            iconHtml: (0, $bG6ob.isFooterInlineSvgIconEnabled)() ? /*#__PURE__*/ $4fqPo.createElement($22d67a2e1ea7d262$var$FooterJsdIcon, null) : /*#__PURE__*/ $4fqPo.createElement($22d67a2e1ea7d262$var$FooterJsdIconImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($1scQH))),
                alt: ""
            })
        }
    }))));
};
var $22d67a2e1ea7d262$export$2e2bcd8739ae039 = $22d67a2e1ea7d262$var$Footer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $22d67a2e1ea7d262$var$FooterContainer = /*#__PURE__*/ (0, $el3DQ.default).footer.withConfig({
    componentId: "sc-1d68q8x-0"
})`padding:${`var(--ds-space-600, ${`${(0, $hTMzE.footerPadding)}px`})`} 0;text-align:center;white-space:nowrap;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $22d67a2e1ea7d262$var$FooterJsdIconImg = /*#__PURE__*/ (0, $el3DQ.default).img.withConfig({
    componentId: "sc-1d68q8x-1"
})`object-fit:contain;height:${`var(--ds-space-250, ${`${(0, $hTMzE.footerJsdIconHeight)}px`})`};vertical-align:middle;opacity:0.5;transition:opacity ${$brRRh.timingFunctions.easeInOut} ${$brRRh.speedMs.fast}ms;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $22d67a2e1ea7d262$var$FooterJsdIcon = /*#__PURE__*/ (0, $el3DQ.default)((0, $a3mTv.default)).withConfig({
    componentId: "sc-1d68q8x-2"
})`object-fit:contain;height:${`var(--ds-space-250, ${`${(0, $hTMzE.footerJsdIconHeight)}px`})`};vertical-align:middle;opacity:0.5;transition:opacity ${$brRRh.timingFunctions.easeInOut} ${$brRRh.speedMs.fast}ms;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $22d67a2e1ea7d262$var$FooterLink = /*#__PURE__*/ (0, $el3DQ.default)((0, $eiGUu.HtmlAnchor)).withConfig({
    componentId: "sc-1d68q8x-3"
})`${$4W9tu.small};color:${"var(--ds-text-subtlest, #5E6C84)"};cursor:pointer;:hover,:active{color:${"var(--ds-text-subtlest, #5E6C84)"};text-decoration:none;${$22d67a2e1ea7d262$var$FooterJsdIcon}{opacity:1;stop:first-child{stop-color:${"var(--ds-background-brand-bold-hovered, #0052CC)"};}stop:last-child{stop-color:${"var(--ds-background-brand-bold, #2684FF)"};}> g > g > path:last-child{fill:${"var(--ds-background-brand-bold, #2684FF)"};}}}`;

});
parcelRegister("eiGUu", function(module, exports) {
$parcel$export(module.exports, "HtmlAnchor", () => $5de65d756cfa524a$export$acca9dc24cfe2034);

var $4fqPo = parcelRequire("4fqPo");

var $fD39j = parcelRequire("fD39j");
const $5de65d756cfa524a$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...anchorProps })=>{
    // Disabling existing violations, should be fixed when revisited.
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content
    return /*#__PURE__*/ $4fqPo.createElement("a", anchorProps);
};
const $5de65d756cfa524a$export$acca9dc24cfe2034 = (0, $fD39j.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($5de65d756cfa524a$var$InstrumentedLink);

});
parcelRegister("fD39j", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cff2deae333af64$export$2e2bcd8739ae039);

var $63sfu = parcelRequire("63sfu");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $54jwS = parcelRequire("54jwS");
/**
 * Will create and fire a UI event when the callback is called.
 * Works like the following:
 *
 * YOU NEED TO PASS IN PROPS UNFORTUNATELY SORRY LIMITATION W/ TYPESCRIPT!
 * This means your default props probably won't work. And your props won't be set correctly on the wrapped component.
 * JUST PASS IN TPROPS!
 */ const $8cff2deae333af64$var$withCreateFireUIAnalytics = (actionSubject, analyticsDefinition)=>{
    return (Component)=>{
        const mappedAnalyticsDefinition = (0, $63sfu.mapValues)(analyticsDefinition, (val)=>{
            return (create, props)=>{
                const payload = val(props);
                const event = create({
                    ...payload,
                    ...props.attributes,
                    actionSubjectId: props.actionSubjectId,
                    analyticsType: (0, $54jwS.UI_EVENT_TYPE)
                });
                event.fire();
                return event;
            };
        });
        const WrappedComponent = (0, $apbG6.default)({
            componentName: actionSubject
        })(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $as4kh.default)(mappedAnalyticsDefinition)(Component));
        WrappedComponent.displayName = `withCreateFireUIAnalytics(${Component.displayName || Component.name})`;
        return WrappedComponent;
    };
};
var $8cff2deae333af64$export$2e2bcd8739ae039 = $8cff2deae333af64$var$withCreateFireUIAnalytics;

});


parcelRegister("eG61t", function(module, exports) {
$parcel$export(module.exports, "ContactUsSection", () => $adf52334d77d82be$export$919152da49f07ab);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $adf52334d77d82be$export$919152da49f07ab = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("gI7Mc")), {
        moduleId: "./packages/common-utils/contact-us-section/src/contact-us-section.tsx"
    })
});

});
parcelRegister("gi5ak", function(module, exports) {
$parcel$export(module.exports, "default", () => $0754e6043730ea3f$export$2e2bcd8739ae039);

var $khkGd = parcelRequire("khkGd");
/**
 * This will generically handle async loading of components with a
 * loading, timeout, and errored states. If you need more specific
 * handling use react-loosely-lazy directly.
 *
 * Use the preload option if you want the component to start loading
 * immediately.
 */ const $0754e6043730ea3f$var$withAsync = (options)=>{
    const LoadableComponent = (0, $khkGd.default)({
        loader: options.loader,
        LoadingSkeleton: options.LoadingSkeleton,
        loadingPosition: options.loadingPosition,
        timeout: 5000
    });
    if (options.preload) LoadableComponent.preload();
    return LoadableComponent;
};
var $0754e6043730ea3f$export$2e2bcd8739ae039 = $0754e6043730ea3f$var$withAsync;

});
parcelRegister("khkGd", function(module, exports) {
$parcel$export(module.exports, "default", () => $460ccfff2ee69529$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $bPz0N = parcelRequire("bPz0N");
var $hsDVb = parcelRequire("hsDVb");
var $i43Pg = parcelRequire("i43Pg");
const $460ccfff2ee69529$var$LooselyLoadableWrapper = (options)=>{
    const Component = options.loader;
    const LazyComponent = (props)=>{
        const renderError = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((error)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i43Pg.LoadingComponent), {
                error: error,
                LoadingSkeleton: options.LoadingSkeleton
            });
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bPz0N.ErrorBoundaryAnalytics), {
            renderError: renderError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hsDVb.Fallback), options)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, props)));
    };
    LazyComponent.preload = options.loader.preload;
    return LazyComponent;
};
var $460ccfff2ee69529$export$2e2bcd8739ae039 = $460ccfff2ee69529$var$LooselyLoadableWrapper;

});
parcelRegister("bPz0N", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryAnalytics", () => $f7d50117bc17114a$export$627f773fbbb39e);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $54jwS = parcelRequire("54jwS");

var $keOG0 = parcelRequire("keOG0");
class $f7d50117bc17114a$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error) {
        if (error.name !== 'ChunkLoadError') {
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent !== undefined) {
                // This analytics will help us to note any errors which were previously marked as chunk errors. This might get triggered multiple times if islooselyLazyJsErrorsToSentryEnabled is true.
                const analyticsEvent = createAnalyticsEvent({
                    analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                    action: 'failed',
                    errorMessage: error.message,
                    errorName: error.name,
                    stack: error.stack
                });
                const finalId = 'looselyLazyErrorBoundary';
                const finalPackage = 'looselyLazyPackage';
                const actionSubject = `${finalPackage}.${finalId}`;
                analyticsEvent.context.push({
                    componentName: actionSubject
                });
                analyticsEvent.fire();
            }
        }
        if ((0, $bG6ob.islooselyLazyJsErrorsToSentryEnabled)()) {
            // Differentiate between a chunkLoadError and other JS error.
            if (error.name === 'ChunkLoadError') {
                var _this$props$onError, _this$props;
                (0, $keOG0.trackError)('async.loader.failed', {}, error);
                (_this$props$onError = (_this$props = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props, error);
            } else {
                var _this$props$onError2, _this$props2;
                (_this$props$onError2 = (_this$props2 = this.props).onError) === null || _this$props$onError2 === void 0 || _this$props$onError2.call(_this$props2, error);
                // this error will be caught by ScreenErrorBoundary at route level which will add it to sentry with packageName derived from route ScreenName
                throw error;
            }
        } else {
            var _this$props$onError3, _this$props3;
            (0, $keOG0.trackError)('async.loader.failed', {}, error);
            (_this$props$onError3 = (_this$props3 = this.props).onError) === null || _this$props$onError3 === void 0 || _this$props$onError3.call(_this$props3, error);
        }
    }
    render() {
        const error = this.state.error;
        return error ? this.props.renderError(error) : this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            error: undefined
        };
    }
}
const $f7d50117bc17114a$export$627f773fbbb39e = (0, $apbG6.default)()((0, $as4kh.default)()($f7d50117bc17114a$var$ErrorBoundary));

});

parcelRegister("hsDVb", function(module, exports) {
$parcel$export(module.exports, "Fallback", () => $234bd6878a868c74$export$fb8d7f40caaeea67);

var $4fqPo = parcelRequire("4fqPo");

var $cijxS = parcelRequire("cijxS");

var $i43Pg = parcelRequire("i43Pg");
const $234bd6878a868c74$export$fb8d7f40caaeea67 = (options)=>{
    let displayName = 'unknown';
    if ('loader' in options) displayName = options.loader.displayName || 'unknown';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: displayName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i43Pg.LoadingComponent), {
        LoadingSkeleton: options.LoadingSkeleton,
        timeout: options.timeout
    }));
};

});
parcelRegister("cijxS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d44adeeb89d94d6$export$2e2bcd8739ae039);

var $eBxLu = parcelRequire("eBxLu");
var $6d44adeeb89d94d6$export$2e2bcd8739ae039 = (0, $eBxLu.default);

});

parcelRegister("i43Pg", function(module, exports) {
$parcel$export(module.exports, "LoadingComponent", () => $0e156f49de32e007$export$7db30d367db7d20a);

var $4fqPo = parcelRequire("4fqPo");

var $bvB7a = parcelRequire("bvB7a");
const $0e156f49de32e007$export$7db30d367db7d20a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(function LoadingComponent({ error: error, LoadingSkeleton: LoadingSkeleton, timeout: timeout, loadingPosition: loadingPosition }) {
    const [isTimedOut, setIsTimedOut] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        let timer;
        if (timeout) timer = setTimeout(()=>{
            setIsTimedOut(true);
        }, timeout);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        timeout
    ]);
    if (LoadingSkeleton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LoadingSkeleton, {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bvB7a.default), {
        isLoading: !error,
        error: error,
        loadingPosition: loadingPosition,
        timedOut: isTimedOut
    });
});

});
parcelRegister("bvB7a", function(module, exports) {
$parcel$export(module.exports, "ChunkLoadErrorMessage", () => $59fd3ad7ac4fcb21$export$7bbd51879bbec526);
$parcel$export(module.exports, "SkeletonLoadingWrapper", () => $59fd3ad7ac4fcb21$export$48d1937c6c46b883);
$parcel$export(module.exports, "default", () => $59fd3ad7ac4fcb21$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $748yq = parcelRequire("748yq");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $5Uaxl = parcelRequire("5Uaxl");

var $geWWn = parcelRequire("geWWn");

var $5qWT2 = parcelRequire("5qWT2");

var $el3Lx = parcelRequire("el3Lx");

var $fVQGu = parcelRequire("fVQGu");
const $59fd3ad7ac4fcb21$var$ICON_SIZE = $bpWyP.multiple(6);
const $59fd3ad7ac4fcb21$export$7bbd51879bbec526 = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        label: "",
        size: "medium",
        spacing: "spacious"
    }), /*#__PURE__*/ $4fqPo.createElement($59fd3ad7ac4fcb21$var$Message, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $el3Lx.default).error)));
};
const $59fd3ad7ac4fcb21$export$fead96407cda089b = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-11ukfs2-0"
})`margin-top:${"var(--ds-space-025, 2px)"};`;
const $59fd3ad7ac4fcb21$export$48d1937c6c46b883 = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $4fqPo.createElement($59fd3ad7ac4fcb21$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $fVQGu.LoadingSkeletonFields), null), props.timedOut && /*#__PURE__*/ $4fqPo.createElement($59fd3ad7ac4fcb21$var$Message, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $el3Lx.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $fVQGu.AbsoluteFillContainer) : $59fd3ad7ac4fcb21$var$Container;
    return /*#__PURE__*/ $4fqPo.createElement($59fd3ad7ac4fcb21$export$fead96407cda089b, null, /*#__PURE__*/ $4fqPo.createElement(Wrapper, null, content));
};
const $59fd3ad7ac4fcb21$var$Loading = (props)=>{
    let content;
    if (props.error) content = /*#__PURE__*/ $4fqPo.createElement($59fd3ad7ac4fcb21$export$7bbd51879bbec526, null);
    else content = /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        interactionName: props.interactionName || 'help-center-unknown-loader',
        delay: (0, $748yq.SPINNER_DELAY),
        appearance: "inherit",
        size: $59fd3ad7ac4fcb21$var$ICON_SIZE.unitless
    }), props.timedOut && /*#__PURE__*/ $4fqPo.createElement($59fd3ad7ac4fcb21$var$Message, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $el3Lx.default).timeout)));
    const Wrapper = props.loadingPosition === 'static' ? (0, $fVQGu.AbsoluteFillContainer) : $59fd3ad7ac4fcb21$var$Container;
    return /*#__PURE__*/ $4fqPo.createElement(Wrapper, {
        "data-testid": "loading-container"
    }, content);
};
var $59fd3ad7ac4fcb21$export$2e2bcd8739ae039 = $59fd3ad7ac4fcb21$var$Loading;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $59fd3ad7ac4fcb21$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-11ukfs2-1"
})`${$iSWaE.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $59fd3ad7ac4fcb21$var$Message = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-11ukfs2-2"
})`${$4W9tu.small};margin-top:${"var(--ds-space-100, 8px)"};`;

});
parcelRegister("el3Lx", function(module, exports) {
$parcel$export(module.exports, "default", () => $0bf90b7fd7844086$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $0bf90b7fd7844086$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    error: {
        defaultMessage: 'There was a problem loading, please refresh and try again.',
        description: 'Error message shown when something could not be loaded.',
        id: 'cv.loading.component.error'
    },
    timeout: {
        defaultMessage: 'Taking longer than usual...',
        description: 'Message shown when loading is taking a long time.',
        id: 'cv.loading.component.timeout'
    }
});

});

parcelRegister("fVQGu", function(module, exports) {
$parcel$export(module.exports, "AbsoluteFillContainer", () => $c741b1e7b93dee31$export$c55b13eeae4b9470);
$parcel$export(module.exports, "LoadingSkeleton", () => $c741b1e7b93dee31$export$44c18d210d5de37b);
$parcel$export(module.exports, "FieldLoadingSkeleton", () => $c741b1e7b93dee31$export$e2529b450e72f74e);
$parcel$export(module.exports, "AvatarLoadingSkeleton", () => $c741b1e7b93dee31$export$281e083a77da722c);
$parcel$export(module.exports, "LoadingSkeletonFields", () => $c741b1e7b93dee31$export$1844a556d867ecb4);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $63sfu = parcelRequire("63sfu");
const $c741b1e7b93dee31$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ovlcu-0"
})`${$iSWaE.flexCenter};padding:${"var(--ds-space-100, 8px)"};flex-direction:column;pointer-events:none;flex:1 1 auto;`;
const $c741b1e7b93dee31$export$c55b13eeae4b9470 = /*#__PURE__*/ (0, $el3DQ.default)($c741b1e7b93dee31$export$42a852a2b6b56249).withConfig({
    componentId: "sc-3ovlcu-1"
})`position:absolute;top:0;left:0;right:0;bottom:0;`;
const $c741b1e7b93dee31$var$fromPositionX = -400;
const $c741b1e7b93dee31$var$toPositionX = 800;
const $c741b1e7b93dee31$var$shimmer = /*#__PURE__*/ (0, $el3DQ.keyframes)({
    '0%': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        backgroundPosition: `${$c741b1e7b93dee31$var$fromPositionX}px 0`
    },
    '100%': {
        backgroundPosition: `${$c741b1e7b93dee31$var$toPositionX}px 0`
    }
});
const $c741b1e7b93dee31$export$44c18d210d5de37b = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ovlcu-2"
})`${$iSWaE.borderRadius};height:${(props)=>`${props.height}px`};background-color:${(props)=>props.backgroundColor};background-image:linear-gradient( to right,${(props)=>props.backgroundColor} 10%,${"var(--ds-surface, #FFFFFF)"} 40%,${(props)=>props.backgroundColor} 50% );background-repeat:no-repeat;animation-duration:0.8s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$c741b1e7b93dee31$var$shimmer};animation-timing-function:ease-in;`;
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c741b1e7b93dee31$var$FieldSkeletonWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ovlcu-3"
})`${$iSWaE.borderRadius};border:${"var(--ds-border-width-selected, 2px)"} solid;border-color:${"var(--ds-border, #DFE1E6)"};`;
const $c741b1e7b93dee31$export$e2529b450e72f74e = ()=>/*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$var$FieldSkeletonWrapper, null, /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$44c18d210d5de37b, {
        height: 150,
        backgroundColor: "var(--ds-skeleton-subtle, #FAFBFC)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c741b1e7b93dee31$var$AvatarSkeletonWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ovlcu-4"
})`min-width:${$bpWyP.multiple(4.5).px};border-radius:50%;overflow:hidden;`;
const $c741b1e7b93dee31$export$281e083a77da722c = ()=>/*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$var$AvatarSkeletonWrapper, null, /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$44c18d210d5de37b, {
        height: 36,
        backgroundColor: "var(--ds-skeleton, #EBECF0)"
    }));
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $c741b1e7b93dee31$var$TextFieldLoadingSkeletonWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ovlcu-5"
})`margin-top:${"var(--ds-space-500, 40px)"};margin-bottom:${"var(--ds-space-500, 40px)"};`;
const $c741b1e7b93dee31$export$66b8cea0c448285 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ovlcu-6"
})`width:100%;`;
const $c741b1e7b93dee31$export$37ec45a296aa56b5 = ({ shortText: shortText })=>{
    return /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$var$TextFieldLoadingSkeletonWrapper, null, /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$44c18d210d5de37b, {
        height: shortText ? $bpWyP.multiple(5).unitless : $bpWyP.multiple(22).unitless,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    }));
};
const $c741b1e7b93dee31$export$1844a556d867ecb4 = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$66b8cea0c448285, null, (0, $63sfu.range)(3).map((ndx)=>/*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$37ec45a296aa56b5, {
            key: ndx,
            shortText: true
        })), /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$37ec45a296aa56b5, {
        shortText: false
    }), /*#__PURE__*/ $4fqPo.createElement($c741b1e7b93dee31$export$37ec45a296aa56b5, {
        shortText: true
    })));
};

});






parcelRegister("gI7Mc", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("hdgsL").then(()=>parcelRequire('ixcgb'));

});


parcelRegister("a3mTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $962400bdf292cb29$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $962400bdf292cb29$var$SvgJsdIconreact = (props)=>/*#__PURE__*/ $4fqPo.createElement("svg", {
        width: 15,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ $4fqPo.createElement("defs", null, /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        x1: "38.04%",
        y1: "6.64%",
        x2: "59.86%",
        y2: "63.78%",
        id: "jsd-icon_react_svg__a"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        stopColor: "#344563",
        offset: "0%"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        stopColor: "#5E6C84",
        offset: "100%"
    }))), /*#__PURE__*/ $4fqPo.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M-9-6h32v32H-9z"
    }), /*#__PURE__*/ $4fqPo.createElement("g", {
        fillRule: "nonzero"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "m8.93 7.56 5.2.02a.81.81 0 0 1 .65 1.3L7.09 19.14A5.46 5.46 0 0 1 6 11.5l2.94-3.94z",
        fill: "url(#jsd-icon_react_svg__a)"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "m5.98 11.5-5.17-.04a.81.81 0 0 1-.65-1.3L7.77 0a5.46 5.46 0 0 1 1.11 7.64l-2.9 3.86z",
        fill: "#5E6C84"
    }))));
var $962400bdf292cb29$export$2e2bcd8739ae039 = $962400bdf292cb29$var$SvgJsdIconreact;

});

parcelRegister("1scQH", function(module, exports) {
module.exports = new URL("../images/jsd-icon.96c174f6.svg", import.meta.url).toString();

});

parcelRegister("aQEED", function(module, exports) {
$parcel$export(module.exports, "default", () => $06fbf210d0a2506d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $06fbf210d0a2506d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    footer: {
        defaultMessage: 'Powered by {iconHtml} Jira Service Management',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.servicemanagement'
    },
    csmFooter: {
        defaultMessage: 'Powered by Jira Customer Service',
        description: 'Message displayed in the webpage footer',
        id: 'sd.jsm.customerview.footer.powered.by.atlassiancustomercollection.non-final'
    }
});

});

parcelRegister("hTMzE", function(module, exports) {
$parcel$export(module.exports, "footerPadding", () => $ea8beb458352f43c$export$7d9aba7536a61853);
$parcel$export(module.exports, "footerJsdIconHeight", () => $ea8beb458352f43c$export$220c44e1c3ab6f4);
$parcel$export(module.exports, "FOOTER_HEIGHT", () => $ea8beb458352f43c$export$a2dd5f25b5a4e5d2);

var $bpWyP = parcelRequire("bpWyP");
const $ea8beb458352f43c$export$7d9aba7536a61853 = $bpWyP.multiple(6).unitless;
const $ea8beb458352f43c$export$220c44e1c3ab6f4 = $bpWyP.multiple(2.5).unitless;
const $ea8beb458352f43c$export$a2dd5f25b5a4e5d2 = $ea8beb458352f43c$export$7d9aba7536a61853 * 2 + $ea8beb458352f43c$export$220c44e1c3ab6f4;

});



parcelRegister("4hIeL", function(module, exports) {
$parcel$export(module.exports, "default", () => $8313dd86e2980a79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $2m8U6 = parcelRequire("2m8U6");

var $9Ix81 = parcelRequire("9Ix81");
const $8313dd86e2980a79$var$flexGrowMap = {
    hug: (0, $2m8U6.xcss)({
        flexGrow: 0
    }),
    fill: (0, $2m8U6.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $8313dd86e2980a79$var$Stack = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $8313dd86e2980a79$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $9Ix81.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$8313dd86e2980a79$var$Stack.displayName = 'Stack';
var $8313dd86e2980a79$export$2e2bcd8739ae039 = $8313dd86e2980a79$var$Stack;

});

parcelRegister("e2Zgo", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1c80e56757e7ef7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $yLYo1 = parcelRequire("yLYo1");

var $rIiGL = parcelRequire("rIiGL");

var $5IVQv = parcelRequire("5IVQv");

var $fJeCl = parcelRequire("fJeCl");
function $a1c80e56757e7ef7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1c80e56757e7ef7$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $a1c80e56757e7ef7$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $a1c80e56757e7ef7$var$strongStyles = {
    name: "17rayov",
    styles: "font-weight:var(--ds-font-weight-bold, 653)"
};
const $a1c80e56757e7ef7$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $a1c80e56757e7ef7$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $a1c80e56757e7ef7$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $a1c80e56757e7ef7$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $a1c80e56757e7ef7$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5IVQv.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $fJeCl.inverseColorMap).hasOwnProperty(surface)) return (0, $fJeCl.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $a1c80e56757e7ef7$var$Text = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $yLYo1.default)($a1c80e56757e7ef7$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $rIiGL.useHasTextAncestor)();
    const color = $a1c80e56757e7ef7$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $lqVX7.jsx)(Component, {
        ref: ref,
        css: [
            $a1c80e56757e7ef7$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $fJeCl.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $fJeCl.textColorStylesMap)[color],
            maxLines && $a1c80e56757e7ef7$var$truncationStyles,
            maxLines === 1 && $a1c80e56757e7ef7$var$wordBreakMap.breakAll,
            align && $a1c80e56757e7ef7$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $fJeCl.textWeightStylesMap)[weight],
            Component === 'em' && $a1c80e56757e7ef7$var$emStyles,
            Component === 'strong' && $a1c80e56757e7ef7$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $lqVX7.jsx)((0, $rIiGL.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $a1c80e56757e7ef7$export$2e2bcd8739ae039 = $a1c80e56757e7ef7$var$Text;

});

parcelRegister("fwSzd", function(module, exports) {
$parcel$export(module.exports, "useIsCSMTypographyMigrationEnabled", () => $3451c25b61465d4c$export$f77c7e452595da18);
$parcel$export(module.exports, "UseTypographyMigratedComponent", () => $3451c25b61465d4c$export$527b88b630251664);

var $6bGmX = parcelRequire("6bGmX");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");
const $3451c25b61465d4c$export$f77c7e452595da18 = (useWhiteListedRouteNamesCheck = false)=>{
    if (useWhiteListedRouteNamesCheck) return (0, $6bGmX.default).checkGate('enable_typography_token_migration_for_csm') && (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    return (0, $6bGmX.default).checkGate('enable_typography_token_migration_for_csm') && (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
};
const $3451c25b61465d4c$export$527b88b630251664 = (props)=>{
    const isCSMTypographyMigrationEnabled = $3451c25b61465d4c$export$f77c7e452595da18();
    return isCSMTypographyMigrationEnabled ? props.migratedComponent : props.children;
};

});



parcelRegister("3bzDg", function(module, exports) {
$parcel$export(module.exports, "App", () => (parcelRequire("3Q6vF")).default);

var $3Q6vF = parcelRequire("3Q6vF");

});
parcelRegister("3Q6vF", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e7f5db24e78533d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $6bGmX = parcelRequire("6bGmX");

var $dQegt = parcelRequire("dQegt");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");

var $cy51j = parcelRequire("cy51j");
parcelRequire("ebSwD");
var $12C9Q = parcelRequire("12C9Q");
parcelRequire("bz4eG");
var $8zTXq = parcelRequire("8zTXq");

var $6sMkA = parcelRequire("6sMkA");

var $klZKM = parcelRequire("klZKM");

var $2nGAn = parcelRequire("2nGAn");

var $3H4LK = parcelRequire("3H4LK");

var $54jwS = parcelRequire("54jwS");

var $eSL4S = parcelRequire("eSL4S");

var $eSL4S = parcelRequire("eSL4S");

var $knJah = parcelRequire("knJah");

var $kTE4q = parcelRequire("kTE4q");

var $bKOXH = parcelRequire("bKOXH");

var $ebpTf = parcelRequire("ebpTf");

var $f3oaK = parcelRequire("f3oaK");

var $l5RAG = parcelRequire("l5RAG");
parcelRequire("85P7r");
var $1mJi4 = parcelRequire("1mJi4");

var $7hsFm = parcelRequire("7hsFm");

var $d14GD = parcelRequire("d14GD");

var $jH4v9 = parcelRequire("jH4v9");

var $lkGq4 = parcelRequire("lkGq4");

var $g7tcY = parcelRequire("g7tcY");

var $12TH6 = parcelRequire("12TH6");
parcelRequire("7IzBc");
var $lJuxo = parcelRequire("lJuxo");

var $fwyFy = parcelRequire("fwyFy");

var $6ITor = parcelRequire("6ITor");

var $gzaph = parcelRequire("gzaph");
var $7e7f5db24e78533d$var$_window$JSD_CUSTOMER_;
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $7e7f5db24e78533d$var$BUILD_KEY = (($7e7f5db24e78533d$var$_window$JSD_CUSTOMER_ = window.JSD_CUSTOMER_PORTAL_BUILD_VERSION) === null || $7e7f5db24e78533d$var$_window$JSD_CUSTOMER_ === void 0 ? void 0 : $7e7f5db24e78533d$var$_window$JSD_CUSTOMER_.buildKey) || 'local';
const $7e7f5db24e78533d$export$86fbec116b87613f = (props)=>{
    const { serviceDeskVersion: serviceDeskVersion } = props;
    const isHelpCentersManagementPath = (0, $eSL4S.isHelpCentersManagement)();
    const shouldUseCsmRouter = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) || (0, $eSL4S.isJcsOnlyRestrictedRoute)((0, $ebpTf.getEnv)().customerAccountAvailabilty);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
    const shouldUseHubRouter = (0, $3H4LK.fg)('enable-jsm-in-hubs') && (0, $ebpTf.getEnv)().helpCenterType === 'HELP_HUB';
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    (0, $7hsFm.useUFOComponentExperience)((0, $lkGq4.helpCenterViewHomePageExperience));
    (0, $4fqPo.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $f3oaK.hasValidHelpCenterARI)()) {
                (0, $kTE4q.fireAnalyticsForEmptyHelpCenterAri)();
                const traceId = (0, $ebpTf.getEnv)().traceId ?? '';
                // Disabling existing violations, should be fixed when revisited.
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lkGq4.helpCenterViewHomePageExperience).failure({
                    metadata: {
                        error: `Empty Help Center Ari, traceId: ${traceId}`
                    }
                });
            } else // Disabling existing violations, should be fixed when revisited.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $lkGq4.helpCenterViewHomePageExperience).success();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!isHelpCentersManagementPath) {
            if (!(0, $6mmHn.isValidLayoutAriPresent)()) (0, $bKOXH.fireAnalyticsForEmptyHelpCenterLayoutAri)();
        }
    }, [
        isHelpCentersManagementPath
    ]);
    const analyticData = {
        version: serviceDeskVersion,
        application: 'jira-servicedesk',
        buildKey: $7e7f5db24e78533d$var$BUILD_KEY
    };
    const isAdvancedHelpCenterThemingEnabled = ((0, $eSL4S.isAdvancedHelpCenter)() || (0, $eSL4S.isDefaultHelpCenter)()) && (0, $bG6ob.isCustomThemingEnabled)();
    const isCsmAccessControlSplitFgEnabled = (0, $bG6ob.isCsmAccessControlSplitEnabled)();
    const getResourceRouter = $4fqPo.useCallback(()=>{
        if (shouldUseCsmRouter) {
            if (isCsmAccessControlSplitFgEnabled) return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $4fqPo.createElement((0, $d14GD.AppContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $jH4v9.CSMResourceRouterNew), null)) : /*#__PURE__*/ $4fqPo.createElement((0, $jH4v9.CSMResourceRouterNew), null);
            return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $4fqPo.createElement((0, $d14GD.AppContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $jH4v9.default), null)) : /*#__PURE__*/ $4fqPo.createElement((0, $jH4v9.default), null);
        }
        if (isHelpCentersManagementPath) return /*#__PURE__*/ $4fqPo.createElement((0, $g7tcY.default), null);
        if (shouldUseHubRouter) return /*#__PURE__*/ $4fqPo.createElement((0, $12TH6.default), null);
        return isAdvancedHelpCenterThemingEnabled ? /*#__PURE__*/ $4fqPo.createElement((0, $d14GD.AppContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $6ITor.default), null)) : /*#__PURE__*/ $4fqPo.createElement((0, $6ITor.default), null);
    }, [
        shouldUseCsmRouter,
        isHelpCentersManagementPath,
        shouldUseHubRouter,
        isAdvancedHelpCenterThemingEnabled,
        isCsmAccessControlSplitFgEnabled
    ]);
    if ((0, $6bGmX.default).checkGate('enable-portal-kit')) return /*#__PURE__*/ $4fqPo.createElement((0, $fwyFy.ForgePortalHeaderModule), null);
    return /*#__PURE__*/ $4fqPo.createElement((0, $2nGAn.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ $4fqPo.createElement((0, $54jwS.AnalyticsContext), {
        attributes: analyticData
    }, /*#__PURE__*/ $4fqPo.createElement((0, $knJah.BrowserMetricsScreenTransitionStatusProvider), null, /*#__PURE__*/ $4fqPo.createElement((0, $lJuxo.SSRSafeJSMCookieConsentBanner), null), (0, $l5RAG.isBrowserUnsupported)() && /*#__PURE__*/ $4fqPo.createElement((0, $6sMkA.default), {
        appearance: "warning",
        icon: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($klZKM))), {
            spacing: "spacious",
            label: ""
        })
    }, formatMessage((0, $gzaph.default).unsupportedBrowser)), getResourceRouter(), /*#__PURE__*/ $4fqPo.createElement((0, $12C9Q.default), null), /*#__PURE__*/ $4fqPo.createElement((0, $cy51j.FeedbackCollector), null), /*#__PURE__*/ $4fqPo.createElement((0, $1mJi4.Heartbeat), null), /*#__PURE__*/ $4fqPo.createElement((0, $8zTXq.MarkAppMounted), null))));
};
const $7e7f5db24e78533d$var$selector = (0, $3yyCx.createSelector)((0, $2mzxy.getServiceDeskVersion), (serviceDeskVersion)=>({
        serviceDeskVersion: serviceDeskVersion
    }));
var $7e7f5db24e78533d$export$2e2bcd8739ae039 = (0, $bmgw6.default)($7e7f5db24e78533d$var$selector)($7e7f5db24e78533d$export$86fbec116b87613f);

});
parcelRegister("cy51j", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollector", () => $8420452d1e3c3f54$export$fa63c8dd87ea8148);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $8420452d1e3c3f54$export$fa63c8dd87ea8148 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("faW9A")), {
        moduleId: "./src/view/common/feedback-collector/hocs.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("faW9A", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("eNoIp"),
    $e46AW("g2c67")
]).then(()=>parcelRequire('exTTh'));

});


parcelRegister("bz4eG", function(module, exports) {
$parcel$export(module.exports, "MarkAppMounted", () => (parcelRequire("8zTXq")).MarkAppMounted);
$parcel$export(module.exports, "isAppMounted", () => (parcelRequire("8zTXq")).isAppMounted);

var $8zTXq = parcelRequire("8zTXq");

});
parcelRegister("8zTXq", function(module, exports) {
$parcel$export(module.exports, "isAppMounted", () => $07fc2defad3bc5e9$export$495d224993f5c3c8);
$parcel$export(module.exports, "MarkAppMounted", () => $07fc2defad3bc5e9$export$2525a7fc0773bc4d);

var $4fqPo = parcelRequire("4fqPo");
let $07fc2defad3bc5e9$var$isMounted = false;
function $07fc2defad3bc5e9$var$setIsMounted(value) {
    $07fc2defad3bc5e9$var$isMounted = value;
}
const $07fc2defad3bc5e9$export$495d224993f5c3c8 = {
    /** Readonly value and is set only from MarkAppMounted */ get value () {
        return $07fc2defad3bc5e9$var$isMounted;
    }
};
const $07fc2defad3bc5e9$export$2525a7fc0773bc4d = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        $07fc2defad3bc5e9$var$setIsMounted(true);
    }, []);
    return null;
};

});


parcelRegister("6sMkA", function(module, exports) {
$parcel$export(module.exports, "default", () => $626b1a1c8c68a094$export$2e2bcd8739ae039);
/* banner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");
var $Cp2Ub = parcelRequire("Cp2Ub");
const $626b1a1c8c68a094$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
const $626b1a1c8c68a094$var$inlineStyles = {
    root: "_1ul9idpf"
};
const $626b1a1c8c68a094$var$textStyles = {
    root: "_11c8fhey _1reo15vq _18m915vq _syaz12s4 _k48p1wq8 _1bto1l2s _o5721q9c _59381r31 _7hxb1r31 _9m7f1r31 _rfqo1r31 _qfs11r31 _yha28stv _15zv8stv _w7sw8stv _1bgk8stv _s41o8stv _1nmznqa1 _1xvinqa1 _15a9nqa1 _1t0pnqa1 _1k6pnqa1 _43ds1r31 _p03c1r31 _oavv1r31 _oxk41r31 _1cay1r31"
};
const $626b1a1c8c68a094$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
const $626b1a1c8c68a094$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, #FBC828)",
    error: "var(--ds-background-danger-bold, #C9372C)",
    announcement: "var(--ds-background-neutral-bold, #292A2E)"
};
const $626b1a1c8c68a094$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, #292A2E)",
    error: "var(--ds-text-inverse, #FFFFFF)",
    announcement: "var(--ds-text-inverse, #FFFFFF)"
};
const $626b1a1c8c68a094$var$containerStyles = {
    root: "_4t3i1wto _4cvr1h6o _1e0c1txw"
};
const $626b1a1c8c68a094$var$iconWrapperStyles = {
    root: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s _1o9zidpf"
};
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ const $626b1a1c8c68a094$var$Banner = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ appearance: appearance = 'warning', children: children, icon: icon, testId: testId }, ref)=>{
    const appearanceType = appearance in $626b1a1c8c68a094$var$backgroundColors ? appearance : 'warning';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $626b1a1c8c68a094$var$containerStyles.root,
        backgroundColor: $626b1a1c8c68a094$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        xcss: $626b1a1c8c68a094$var$inlineStyles.root
    }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        as: "span",
        xcss: $626b1a1c8c68a094$var$iconWrapperStyles.root,
        style: {
            fill: $626b1a1c8c68a094$var$tokenBackgroundColors[appearanceType],
            color: $626b1a1c8c68a094$var$tokenTextColors[appearanceType]
        }
    }, icon) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            [$626b1a1c8c68a094$var$CSS_VAR_TEXT_COLOR]: $626b1a1c8c68a094$var$tokenTextColors[appearanceType]
        },
        className: (0, $ltgDR.default)([
            $626b1a1c8c68a094$var$textStyles.root
        ])
    }, children)));
});
var $626b1a1c8c68a094$export$2e2bcd8739ae039 = $626b1a1c8c68a094$var$Banner;

});

parcelRegister("2nGAn", function(module, exports) {
$parcel$export(module.exports, "TargetConsumer", () => $7f0fde78b293861f$export$f643dd64c1952cc8);
$parcel$export(module.exports, "SpotlightConsumer", () => $7f0fde78b293861f$export$3503199acd121708);
$parcel$export(module.exports, "default", () => $7f0fde78b293861f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $jE04u = parcelRequire("jE04u");

var $c1tmZ = parcelRequire("c1tmZ");

var $eO5yD = parcelRequire("eO5yD");
var $93stz = parcelRequire("93stz");

var $7biT4 = parcelRequire("7biT4");

var $5jS2V = parcelRequire("5jS2V");

var $3TFEq = parcelRequire("3TFEq");
const $7f0fde78b293861f$var$dest = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);
const $7f0fde78b293861f$export$f643dd64c1952cc8 = $7f0fde78b293861f$var$dest.Consumer;
const $7f0fde78b293861f$var$TargetProvider = $7f0fde78b293861f$var$dest.Provider;
const $7f0fde78b293861f$export$7b5aa0f5b37a336d = /*#__PURE__*/ (0, $4fqPo.createContext)({
    opened: (0, $c1tmZ.default),
    closed: (0, $c1tmZ.default),
    targets: {}
});
const $7f0fde78b293861f$export$3503199acd121708 = $7f0fde78b293861f$export$7b5aa0f5b37a336d.Consumer;
const $7f0fde78b293861f$var$SpotlightStateProvider = $7f0fde78b293861f$export$7b5aa0f5b37a336d.Provider;
const $7f0fde78b293861f$var$Container = ({ component: Wrapper, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Wrapper, null, children);
class $7f0fde78b293861f$export$2e2bcd8739ae039 extends (0, $4fqPo.PureComponent) {
    static #_ = this.defaultProps = {
        blanketIsTinted: true
    };
    componentDidMount() {
        typeof $3TFEq;
    }
    render() {
        const { blanketIsTinted: blanketIsTinted, children: children, component: Tag, onBlanketClicked: onBlanketClicked } = this.props;
        const isActive = this.state.spotlightCount > 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7f0fde78b293861f$var$SpotlightStateProvider, {
            value: this.getStateProviderValue(this.state.targets)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7f0fde78b293861f$var$TargetProvider, {
            value: this.getTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7f0fde78b293861f$var$Container, {
            component: Tag || (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eO5yD.default), null, isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93stz.default), {
            duration: "medium"
        }, ({ ref: ref, className: className, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7biT4.default), {
                zIndex: 700
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5jS2V.default), {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: className,
                style: style,
                isTinted: blanketIsTinted,
                onBlanketClicked: onBlanketClicked
            })))), children)));
    }
    constructor(...args){
        super(...args), this.state = {
            spotlightCount: 0,
            targets: {}
        }, /*
   * When enabling React Streaming in Confluence, a
   * "This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering"
   * error happens.
   * This is to fix this error by wrapping the state update in startTransition as suggested by React: https://react.dev/errors/421?invariant=421
   */ this.getTargetRef = (name)=>(element)=>{
                (0, $4fqPo.startTransition)(()=>{
                    this.setState((state)=>({
                            targets: {
                                ...state.targets,
                                [name]: element || undefined
                            }
                        }));
                });
            }, this.spotlightOpen = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount + 1
                }));
        }, this.spotlightClose = ()=>{
            this.setState((state)=>({
                    spotlightCount: state.spotlightCount - 1
                }));
        }, this.getStateProviderValue = (0, $jE04u.default)((targets)=>({
                opened: this.spotlightOpen,
                closed: this.spotlightClose,
                targets: targets
            }));
    }
}

});
parcelRegister("5jS2V", function(module, exports) {
$parcel$export(module.exports, "default", () => $246c803cef26c5c6$export$2e2bcd8739ae039);
/* blanket.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
// IE11 and Edge: z-index needed because fixed position calculates z-index relative
// to body instead of nearest stacking context (Portal in our case).
const $246c803cef26c5c6$var$blanketStyles = null;
/**
 * __Blanket__
 *
 * A replacement for `@atlaskit/blanket`.
 *
 * We use this for spotlights instead of `@atlaskit/blanket`
 * because spotlights must sit on top of other layered elements,
 * such as modals, which have their own blankets.
 *
 * @internal
 */ const $246c803cef26c5c6$var$Blanket = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ isTinted: isTinted, onBlanketClicked: onBlanketClicked, style: style, className: className }, ref)=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ref: ref,
        role: "presentation",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_1r04idpf _v56414ka _kqsw1n9t _1pby1fw0",
            className
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Pass-through style props are not allowed
            ...style,
            backgroundColor: isTinted ? "var(--ds-blanket, #050C1F75)" : 'transparent'
        },
        onClick: onBlanketClicked
    });
});
var $246c803cef26c5c6$export$2e2bcd8739ae039 = $246c803cef26c5c6$var$Blanket;

});


parcelRegister("knJah", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusContext", () => $104e278f655dfb66$export$2b9bf691adcf6b30);
$parcel$export(module.exports, "BrowserMetricsScreenTransitionStatusProvider", () => $104e278f655dfb66$export$71210ed9cdfad1f5);
$parcel$export(module.exports, "default", () => $104e278f655dfb66$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2dPNI = parcelRequire("2dPNI");

var $29xKq = parcelRequire("29xKq");
const $104e278f655dfb66$export$2b9bf691adcf6b30 = /*#__PURE__*/ $4fqPo.createContext({
    preventBrowserMetricsTimerResetOnScreenMount: false,
    startBrowserMetricsTransitionToNewScreen: ()=>undefined,
    stopBrowserMetricsTransitionToNewScreen: ()=>undefined
});
class $104e278f655dfb66$export$71210ed9cdfad1f5 extends $4fqPo.Component {
    render() {
        return /*#__PURE__*/ $4fqPo.createElement($104e278f655dfb66$export$2b9bf691adcf6b30.Provider, {
            value: {
                preventBrowserMetricsTimerResetOnScreenMount: this.state.preventBrowserMetricsTimerResetOnScreenMount,
                startBrowserMetricsTransitionToNewScreen: this.startTransitionToNewScreen,
                stopBrowserMetricsTransitionToNewScreen: this.stopTransitionToNewScreen
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            preventBrowserMetricsTimerResetOnScreenMount: false
        }, /**
   * Explicitly start the browsermetrics timer,
   * and set state that will prevent the timer from being reset when we eventually transition to the new screen.
   */ this.startTransitionToNewScreen = (screenName)=>{
            (0, $29xKq.devLog)('Browser metrics: starting timer for new screen before transition:', screenName);
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: true
            });
            /**
     * Browser metrics v3 start page load
     */ (0, $2dPNI.startPageLoad)(screenName);
        }, /**
   * Stop measuring any transition that may have been started.
   * This must be called any time the transition does not go ahead, e.g. if there are errors in a form submission
   * This will also be called any time an AnalyticsScreen component is mounted,
   * so you won't need to call this yourself if the transition is successful
   */ this.stopTransitionToNewScreen = ()=>{
            this.setState({
                preventBrowserMetricsTimerResetOnScreenMount: false
            });
        };
    }
}
const $104e278f655dfb66$var$withBrowserMetricsScreenTransitionStatus = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $4fqPo.createElement($104e278f655dfb66$export$2b9bf691adcf6b30.Consumer, null, (value)=>/*#__PURE__*/ $4fqPo.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $104e278f655dfb66$export$2e2bcd8739ae039 = $104e278f655dfb66$var$withBrowserMetricsScreenTransitionStatus;

});

parcelRegister("kTE4q", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterAri", () => $3519e27dac23a6b6$export$ac08ed49e9190090);

var $kXlzl = parcelRequire("kXlzl");

var $ebpTf = parcelRequire("ebpTf");
const $3519e27dac23a6b6$export$ac08ed49e9190090 = ()=>{
    const traceId = (0, $ebpTf.getEnv)().traceId;
    (0, $kXlzl.operationalEvent)({
        action: 'emptyHelpCenterAriReceived',
        actionSubject: 'help-center-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("bKOXH", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsForEmptyHelpCenterLayoutAri", () => $2f4542cd1888b06a$export$c36b085b938f36b6);

var $kXlzl = parcelRequire("kXlzl");

var $ebpTf = parcelRequire("ebpTf");
const $2f4542cd1888b06a$export$c36b085b938f36b6 = ()=>{
    const traceId = (0, $ebpTf.getEnv)().traceId;
    (0, $kXlzl.operationalEvent)({
        action: 'emptyHelpCenterLayoutAriReceived',
        actionSubject: 'help-center-layout-ari',
        attributes: {
            traceId: traceId
        },
        source: 'HelpCenter'
    });
};

});

parcelRegister("f3oaK", function(module, exports) {
$parcel$export(module.exports, "hasValidHelpCenterARI", () => $8179af6453a801c7$export$a15bc0aef789ec4c);

var $6mmHn = parcelRequire("6mmHn");
const $8179af6453a801c7$var$EMPTY_VALUES_LIST = [
    'undefined',
    'null'
];
const $8179af6453a801c7$export$a15bc0aef789ec4c = ()=>{
    const helpCenterAri = (0, $6mmHn.getHelpCenterAri)();
    return Boolean(helpCenterAri) && !$8179af6453a801c7$var$EMPTY_VALUES_LIST.includes(helpCenterAri);
};

});

parcelRegister("l5RAG", function(module, exports) {
$parcel$export(module.exports, "isBrowserUnsupported", () => $3b5e5e1c1ebef5d7$export$dfffa53722e06033);
$parcel$export(module.exports, "isOldSafari", () => $3b5e5e1c1ebef5d7$export$572d6d0be4ae9ec5);
$parcel$export(module.exports, "isIE7", () => $3b5e5e1c1ebef5d7$export$e7ef7234dd9b1f65);
/**
 * Unsupported browsers regex generated using command -
 * npx browserslist-useragent-regexp "Firefox 60 , Firefox 61, Firefox 68, Firefox 72, Safari 12, Safari 15, iOS 12, iOS 15".
 * All unsupported browser versions can be viewed on https://browserslist.dev/, using above query.
 * These browser versions do not support Intersection Observer API.
 * Safari > 12.0 and iOS > 12.1 supports this API but does not support "options.root" parameter to be a Document
 * */ const $3b5e5e1c1ebef5d7$export$67d4cb90585439f7 = new RegExp(/Firefox\/(6[01]\.0|68\.0|72\.0)(\.\d+|)|Maci.+ Version\/(12\.0|15\.0)([,.]\d+|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(12[._][01]|15[._][01])([._]\d+|)/);
const $3b5e5e1c1ebef5d7$export$dfffa53722e06033 = (regex = $3b5e5e1c1ebef5d7$export$67d4cb90585439f7)=>{
    if (!(navigator && navigator.userAgent)) return true;
    if (regex && regex.test) return regex.test(navigator.userAgent);
    return false;
};
function $3b5e5e1c1ebef5d7$export$572d6d0be4ae9ec5() {
    const userAgentString = navigator.userAgent;
    const safariAgent = userAgentString.indexOf('Safari') > -1;
    // If the current browser is Safari
    if (safariAgent) {
        var _userAgentString$spli;
        const safariVersion = parseInt((_userAgentString$spli = userAgentString.split('Version/')) === null || _userAgentString$spli === void 0 || (_userAgentString$spli = _userAgentString$spli[1]) === null || _userAgentString$spli === void 0 ? void 0 : _userAgentString$spli.split(' Safari')[0], 10);
        // If the Safari version is less than 14
        if (safariVersion < 14) return true;
    }
    return false;
}
function $3b5e5e1c1ebef5d7$export$e7ef7234dd9b1f65() {
    const userAgentString = navigator.userAgent;
    const msieAgent = userAgentString.indexOf('MSIE') > -1;
    // If the current browser is Internet Explorer
    if (msieAgent) {
        const ieVersion = parseInt(userAgentString.split('MSIE ')[1].split(';')[0], 10);
        // If the IE version is 7
        if (ieVersion === 7) return true;
    }
    return false;
}

});

parcelRegister("85P7r", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => (parcelRequire("1mJi4")).Heartbeat);

var $1mJi4 = parcelRequire("1mJi4");

});
parcelRegister("1mJi4", function(module, exports) {
$parcel$export(module.exports, "Heartbeat", () => $7f370b8ecb05aea0$export$38f39b921d5551c1);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $isIps = parcelRequire("isIps");

var $3fxxp = parcelRequire("3fxxp");
const $7f370b8ecb05aea0$export$b5257641a9b528be = ()=>{
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments.includes('login')) return;
    if (pathSegments.includes('helpcenter-management')) {
        window.location.href = `/servicedesk/customer/user/login`;
        return;
    }
    const path = window.location.pathname + window.location.search;
    const match = path.match(/\/portal\/(\d+)/);
    const portalId = match ? Number(match[1]) : undefined;
    const basePath = pathSegments.slice(0, 2).join('/');
    const loginBasePath = portalId ? `/${basePath}/portal/${portalId}/user/login` : `/${basePath}/user/login`;
    const destination = pathSegments.slice(2).join('/');
    window.location.href = `${loginBasePath}?destination=${encodeURIComponent(destination + window.location.search)}`;
};
const $7f370b8ecb05aea0$export$461970fb9101e674 = ({ isLoggedIn: isLoggedIn })=>{
    return isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3fxxp.AsyncHeartbeat), {
        idleTime: 1200000,
        onAuthenticationFailed: $7f370b8ecb05aea0$export$b5257641a9b528be
    }) : null;
};
const $7f370b8ecb05aea0$export$38f39b921d5551c1 = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $isIps.isLoggedIn)(state)
    };
})($7f370b8ecb05aea0$export$461970fb9101e674);

});
parcelRegister("isIps", function(module, exports) {
$parcel$export(module.exports, "getAccountId", () => $87b21b881e1fcd11$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "getEmail", () => $87b21b881e1fcd11$export$d29968a6889079e0);
$parcel$export(module.exports, "getDisplayName", () => $87b21b881e1fcd11$export$be63e0664592e141);
$parcel$export(module.exports, "isLoggedIn", () => $87b21b881e1fcd11$export$256a5a3564694cfc);
$parcel$export(module.exports, "getLocale", () => $87b21b881e1fcd11$export$180605366c04f0cd);
$parcel$export(module.exports, "getCanAdministerJIRA", () => $87b21b881e1fcd11$export$8c98af27b4458cd1);
$parcel$export(module.exports, "getHasSiteAdministerAccess", () => $87b21b881e1fcd11$export$c5f994129d97ed23);
$parcel$export(module.exports, "getCustomMenuLinks", () => $87b21b881e1fcd11$export$bf9a934424e2dbf1);
$parcel$export(module.exports, "getAvatarSrc", () => $87b21b881e1fcd11$export$35125d98e6f1484);
const $87b21b881e1fcd11$export$c1e0336bde96e2dc = (state)=>{
    return state.persisted.user.accountId;
};
const $87b21b881e1fcd11$export$d29968a6889079e0 = (state)=>{
    return state.persisted.user.email;
};
const $87b21b881e1fcd11$export$be63e0664592e141 = (state)=>{
    return state.persisted.user.displayName || state.persisted.user.email || '';
};
const $87b21b881e1fcd11$export$256a5a3564694cfc = (state)=>{
    return state.persisted.user.isLoggedIn;
};
const $87b21b881e1fcd11$export$180605366c04f0cd = (state)=>{
    return state.persisted.user.language.key;
};
const $87b21b881e1fcd11$export$8c98af27b4458cd1 = (state)=>{
    return state.persisted.user.canAdministerJIRA;
};
const $87b21b881e1fcd11$export$c5f994129d97ed23 = (state)=>{
    var _state$persisted$user;
    return ((_state$persisted$user = state.persisted.user) === null || _state$persisted$user === void 0 ? void 0 : _state$persisted$user.hasSiteAdministerAccess) || false;
};
const $87b21b881e1fcd11$export$bf9a934424e2dbf1 = (state)=>{
    return state.persisted.user.customMenuLinks;
};
const $87b21b881e1fcd11$export$35125d98e6f1484 = (state)=>{
    var _state$persisted$user2;
    return (_state$persisted$user2 = state.persisted.user.avatars) === null || _state$persisted$user2 === void 0 ? void 0 : _state$persisted$user2.xlarge;
};

});

parcelRegister("3fxxp", function(module, exports) {
$parcel$export(module.exports, "AsyncHeartbeat", () => $d00710e3b9b7fb3e$export$503c0e70c2bcbfc7);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $d00710e3b9b7fb3e$export$503c0e70c2bcbfc7 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("bfENf")), {
        moduleId: "../platform/packages/security/heartbeat/src/index.ts"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("bfENf", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("goGVT").then(()=>parcelRequire('jALUu'));

});




parcelRegister("d14GD", function(module, exports) {
$parcel$export(module.exports, "AppContainer", () => $210612ec033760a5$export$7469f2cda7546515);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $210612ec033760a5$export$7469f2cda7546515 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("2bg1M")), {
        moduleId: "./src/view/app-container/app-container.tsx"
    })
});

});
parcelRegister("2bg1M", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gJJTt").then(()=>parcelRequire('XN9rI'));

});


parcelRegister("jH4v9", function(module, exports) {
$parcel$export(module.exports, "CSMResourceRouterNew", () => $98b66f6838cc749a$export$a487b0571b6a921a);
$parcel$export(module.exports, "default", () => $98b66f6838cc749a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $el3DQ = parcelRequire("el3DQ");

var $bG6ob = parcelRequire("bG6ob");

var $l9AOu = parcelRequire("l9AOu");

var $dfktK = parcelRequire("dfktK");

parcelRequire("l8iRu");
var $7H5nz = parcelRequire("7H5nz");
var $8NB5B = parcelRequire("8NB5B");

var $bTtiN = parcelRequire("bTtiN");

var $dfMEw = parcelRequire("dfMEw");

var $7XSXo = parcelRequire("7XSXo");

var $j7rgu = parcelRequire("j7rgu");

var $6JaEN = parcelRequire("6JaEN");

var $ebomm = parcelRequire("ebomm");

var $1gJdX = parcelRequire("1gJdX");

var $l9QNW = parcelRequire("l9QNW");

var $7qo7n = parcelRequire("7qo7n");

var $cYDr2 = parcelRequire("cYDr2");

var $3zvSe = parcelRequire("3zvSe");

var $47xIg = parcelRequire("47xIg");

var $jYI2M = parcelRequire("jYI2M");

var $18hBH = parcelRequire("18hBH");

var $9bbBv = parcelRequire("9bbBv");

var $8xPh7 = parcelRequire("8xPh7");

var $hnpj5 = parcelRequire("hnpj5");

var $6WWzZ = parcelRequire("6WWzZ");

var $3Qwj5 = parcelRequire("3Qwj5");

var $6FTHb = parcelRequire("6FTHb");

var $k05Lp = parcelRequire("k05Lp");

var $jddke = parcelRequire("jddke");

var $dq1KB = parcelRequire("dq1KB");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $4we4O = parcelRequire("4we4O");
parcelRequire("fpAYG");
var $gQA2V = parcelRequire("gQA2V");

var $6bGmX = parcelRequire("6bGmX");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $kuWHC = parcelRequire("kuWHC");

var $6ITor = parcelRequire("6ITor");

var $5VtTl = parcelRequire("5VtTl");
parcelRequire("5FSYN");
var $cBf1I = parcelRequire("cBf1I");
var $a8eAa = parcelRequire("a8eAa");
// Check if enhanced article view feature gate is enabled
const $98b66f6838cc749a$var$isEnhancedArticleViewEnabled = ()=>{
    return (0, $6bGmX.default).checkGate('jcs_enhanced_article_view');
};
// Helper function to determine which requests list route to use
const $98b66f6838cc749a$var$getRequestsListRoute = ()=>{
    const isHubsEnabled = (0, $bG6ob.isHubsEnabledInHelpCenter)();
    if (isHubsEnabled) return (0, $gQA2V.getCsmRequestsListRouteWithHubShell)();
    return 0, $7qo7n.csmRequestsListRoute;
};
const $98b66f6838cc749a$var$getCustomPageRoutes = ()=>{
    return (0, $bG6ob.isCustomPagesUiEnabled)() && (0, $ebpTf.getIsHCCustomizationEnabled)() ? [
        (0, $3zvSe.getEditCustomPageRoute)(),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getHubCustompageRoute)() : (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $ebomm.getViewCustomPageRoute)())
    ] : [];
};
const $98b66f6838cc749a$var$getAnonymousRoutes = ()=>{
    return [
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getLoginRouteWithHubShell)() : (0, $8xPh7.loginRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getResetPasswordRouteWithHubShell)() : (0, $k05Lp.userResetPasswordRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getSignupRouteWithHubShell)() : (0, $k05Lp.userSignupRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCompleteSignupRouteWithHubShell)() : (0, $k05Lp.userCompleteSignupRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCheckEmailRouteWithHubShell)() : (0, $k05Lp.userCheckMailRoute)
    ];
};
const $98b66f6838cc749a$var$getActiveCsmRoutes = ()=>{
    return {
        activeViewArticleRoute: (0, $l9QNW.csmViewArticleRoute),
        activeKbPageRoute: (0, $l9QNW.csmViewKbPageRoute),
        activeCrossSiteArticleRoute: (0, $l9QNW.csmViewCrossSiteArticleRoute),
        activeUserProfileRoute: (0, $cYDr2.csmUserProfileRoute)
    };
};
const $98b66f6838cc749a$var$getAccessAndAuthenticationRoutes = ()=>{
    return [
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getPortalAccessForbiddenRouteWithHubShell)() : (0, $hnpj5.portalAccessForbiddenRoute),
        (0, $8xPh7.portalLoginRoute),
        (0, $k05Lp.portalSignupRoute),
        (0, $k05Lp.portalResetPasswordRoute),
        (0, $k05Lp.portalCompleteSignupRoute),
        (0, $k05Lp.portalInvitedSignupRoute)
    ];
};
const $98b66f6838cc749a$var$getUserProfileRoute = ()=>{
    const { activeUserProfileRoute: activeUserProfileRoute } = $98b66f6838cc749a$var$getActiveCsmRoutes();
    return (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmUserProfileRouteWithHubShell)() : activeUserProfileRoute);
};
const $98b66f6838cc749a$var$getSearchAndArticleRoutes = ()=>{
    const { activeViewArticleRoute: activeViewArticleRoute, activeKbPageRoute: activeKbPageRoute, activeCrossSiteArticleRoute: activeCrossSiteArticleRoute } = $98b66f6838cc749a$var$getActiveCsmRoutes();
    return [
        (0, $kuWHC.routeWithAiWidgetConfigResource)(activeKbPageRoute),
        (0, $9bbBv.viewAllSearchResultsRoute),
        (0, $9bbBv.viewPortalAllSearchResultsRoute),
        (0, $9bbBv.viewPortalCategoryArticleRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmViewPortalArticleRouteWithHubShell)() : (0, $9bbBv.viewPortalArticleRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmViewCrossSitePortalArticleRouteWithHubShell)() : (0, $9bbBv.viewCrossSitePortalArticleRoute),
        (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmViewArticleRouteWithHubShell)() : activeViewArticleRoute),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmViewCrossSiteArticleRouteWithHubShell)() : activeCrossSiteArticleRoute
    ];
};
const $98b66f6838cc749a$var$getContactUsRoute = ()=>{
    return (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmContactUsRouteWithHubShell)() : (0, $6JaEN.csmContactUsRoute));
};
const $98b66f6838cc749a$export$30b4ff4634181478 = ()=>{
    const isAdvancedOrFlexiHCEnabled = (0, $eSL4S.isAdvancedHelpCenter)() || (0, $eSL4S.isFlexiHCEnabledInDefaultHC)();
    return [
        ...(0, $bG6ob.isHubsEnabledInHelpCenter)() ? [
            (0, $gQA2V.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bTtiN.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $bTtiN.getEditHomePageRoute)()
        ] : [],
        ...(0, $bG6ob.isEmailVerifiedSignalEnabled)() ? [
            (0, $dq1KB.userVerifyEmailRoute)
        ] : [],
        (0, $dfMEw.aiAnswerRoute),
        (0, $j7rgu.consentFormRoute),
        ...$98b66f6838cc749a$var$getAnonymousRoutes(),
        ...$98b66f6838cc749a$var$getAccessAndAuthenticationRoutes(),
        (0, $cBf1I.requestFeedbackRoute),
        (0, $cBf1I.unsubscribeRoute),
        (0, $18hBH.getHelpCenterRoute)(),
        (0, $6FTHb.requestDetailsRoute),
        ...$98b66f6838cc749a$var$getSearchAndArticleRoutes(),
        (0, $kuWHC.routeWithAiWidgetConfigResource)($98b66f6838cc749a$var$getRequestsListRoute()),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmRequestDetailsRouteWithHubShell)() : (0, $7qo7n.csmRequestDetailsRoute),
        (0, $cBf1I.helpCenterRequestFeedbackRoute),
        (0, $7XSXo.approvalsRoute),
        (0, $3Qwj5.requestApprovalRoute),
        $98b66f6838cc749a$var$getUserProfileRoute(),
        (0, $9bbBv.viewPortalKnowledgeCategoryRoute),
        (0, $cBf1I.anonymousRequestSuccessRoute),
        (0, $cBf1I.getRequestCreateRoute)(),
        (0, $6WWzZ.getPortalHomeRoutes)(),
        (0, $jYI2M.getEmbedCreateRequestRoute)(),
        (0, $jYI2M.embedSinglePortalRoute),
        (0, $jYI2M.embedKBArticleRoute),
        (0, $a8eAa.portalReorderRoute)(true),
        (0, $47xIg.editTopicRoute),
        (0, $47xIg.addTopicRoute),
        (0, $jddke.getViewTopicRoute)(),
        $98b66f6838cc749a$var$getContactUsRoute(),
        ...$98b66f6838cc749a$var$isEnhancedArticleViewEnabled() ? [
            (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmFolderRouteWithHubShell)() : (0, $1gJdX.csmFolderRoute))
        ] : [],
        ...$98b66f6838cc749a$var$getCustomPageRoutes(),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getNotFoundRouteWithHubShell)() : (0, $cBf1I.notFoundErrorRoute)
    ];
};
const $98b66f6838cc749a$export$8dfc12d998aeca9c = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $l9AOu.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $l9AOu.lightenColor)(themeColor);
    const routes = (0, $4fqPo.useMemo)(()=>{
        return $98b66f6838cc749a$export$30b4ff4634181478();
    }, []);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $el3DQ.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8NB5B.Router), {
        routes: routes,
        history: (0, $3wR8f.default),
        isGlobal: false,
        plugins: [
            (0, $5VtTl.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dfktK.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4we4O.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7H5nz.RouteComponent), null)));
};
const $98b66f6838cc749a$var$selectorOld = (0, $3yyCx.createSelector)((0, $2mzxy.getHeadless), (0, $i8gmD.getThemeColor), (0, $i8gmD.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
const $98b66f6838cc749a$export$2f7745f2f5ab3897 = ({ externalCustomer: externalCustomer })=>{
    // Routes that are restricted to non external users when
    // base path is /servicedesk/customer and customerAccountAvailabilty is JCS_ONLY
    const isAdvancedOrFlexiHCEnabled = (0, $eSL4S.isAdvancedHelpCenter)() || (0, $eSL4S.isFlexiHCEnabledInDefaultHC)();
    const restrictedRoutes = [
        ...(0, $bG6ob.isHubsEnabledInHelpCenter)() ? [
            (0, $gQA2V.getHubHomepageRoute)()
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bTtiN.getViewHomePageRoute)())
        ] : [],
        ...isAdvancedOrFlexiHCEnabled ? [
            (0, $bTtiN.getEditHomePageRoute)()
        ] : [],
        ...(0, $bG6ob.isEmailVerifiedSignalEnabled)() ? [
            (0, $dq1KB.userVerifyEmailRoute)
        ] : [],
        (0, $dfMEw.aiAnswerRoute),
        (0, $j7rgu.consentFormRoute),
        ...$98b66f6838cc749a$var$getAnonymousRoutes(),
        ...$98b66f6838cc749a$var$getAccessAndAuthenticationRoutes(),
        (0, $cBf1I.requestFeedbackRoute),
        (0, $cBf1I.unsubscribeRoute),
        (0, $18hBH.getHelpCenterRoute)(),
        (0, $6FTHb.requestDetailsRoute),
        ...$98b66f6838cc749a$var$getSearchAndArticleRoutes(),
        (0, $kuWHC.routeWithAiWidgetConfigResource)($98b66f6838cc749a$var$getRequestsListRoute()),
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmRequestDetailsRouteWithHubShell)() : (0, $7qo7n.csmRequestDetailsRoute),
        (0, $cBf1I.helpCenterRequestFeedbackRoute),
        (0, $7XSXo.approvalsRoute),
        (0, $3Qwj5.requestApprovalRoute),
        $98b66f6838cc749a$var$getUserProfileRoute(),
        (0, $jYI2M.getEmbedCreateRequestRoute)(),
        (0, $jYI2M.embedSinglePortalRoute),
        (0, $jYI2M.embedKBArticleRoute),
        $98b66f6838cc749a$var$getContactUsRoute(),
        ...$98b66f6838cc749a$var$isEnhancedArticleViewEnabled() ? [
            (0, $kuWHC.routeWithAiWidgetConfigResource)((0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getCsmFolderRouteWithHubShell)() : (0, $1gJdX.csmFolderRoute))
        ] : [],
        ...$98b66f6838cc749a$var$getCustomPageRoutes()
    ];
    return [
        ...(0, $eSL4S.isJcsOnlyRestrictedRoute)((0, $ebpTf.getEnv)().customerAccountAvailabilty) && externalCustomer ? [] : restrictedRoutes,
        (0, $bG6ob.isHubsEnabledInHelpCenter)() ? (0, $gQA2V.getNotFoundRouteWithHubShell)() : (0, $cBf1I.notFoundErrorRoute)
    ];
};
const $98b66f6838cc749a$export$7abc1d14de40c7e1 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor, user: user } = props;
    const readableTextColorFromTheme = (0, $l9AOu.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $l9AOu.lightenColor)(themeColor);
    const routes = (0, $4fqPo.useMemo)(()=>{
        return $98b66f6838cc749a$export$2f7745f2f5ab3897({
            externalCustomer: user === null || user === void 0 ? void 0 : user.externalCustomer
        });
    }, [
        user
    ]);
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const location = window.location.pathname + window.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    // If JCS_ONLY and accessing a JSM route (path starts with /servicedesk/customer) and the user is not external, redirect to JSM
    if ((0, $eSL4S.isJcsOnlyRestrictedRoute)((0, $ebpTf.getEnv)().customerAccountAvailabilty) && !(user !== null && user !== void 0 && user.externalCustomer)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6ITor.default), null);
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $el3DQ.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8NB5B.Router), {
        routes: routes,
        history: (0, $3wR8f.default),
        isGlobal: false,
        plugins: [
            (0, $5VtTl.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dfktK.GlobalStyled), {
        isCsm: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4we4O.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7H5nz.RouteComponent), null)));
};
const $98b66f6838cc749a$var$selector = (0, $3yyCx.createSelector)((0, $2mzxy.getHeadless), (0, $i8gmD.getThemeColor), (0, $i8gmD.getHelpCenterTitleColor), (state)=>(0, $2hx7o.getUserState)(state), (headerless, themeColor, titleColor, userState)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor,
        user: {
            externalCustomer: userState.externalCustomer
        }
    }));
const $98b66f6838cc749a$export$a487b0571b6a921a = (0, $bmgw6.default)($98b66f6838cc749a$var$selector)($98b66f6838cc749a$export$7abc1d14de40c7e1);
var $98b66f6838cc749a$export$2e2bcd8739ae039 = (0, $bmgw6.default)($98b66f6838cc749a$var$selectorOld)($98b66f6838cc749a$export$8dfc12d998aeca9c);

});
parcelRegister("l9AOu", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $cfa3c2c2aee7d39e$export$3d31854eb05903e0);
$parcel$export(module.exports, "lightenColor", () => $cfa3c2c2aee7d39e$export$3abf4abc58accee2);

var $5uMut = parcelRequire("5uMut");
const $cfa3c2c2aee7d39e$export$3d31854eb05903e0 = (color)=>{
    return (0, $5uMut.getLuminance)(color) > 0.5 ? "var(--ds-text, #172B4D)" : "var(--ds-text-inverse, #FFFFFF)";
};
const $cfa3c2c2aee7d39e$export$3abf4abc58accee2 = (color)=>{
    return (0, $5uMut.transparentize)(0.8, color);
};

});
parcelRegister("5uMut", function(module, exports) {
$parcel$export(module.exports, "darken", () => $40055e487d35a294$export$4b073707ff63303);
$parcel$export(module.exports, "getLuminance", () => $40055e487d35a294$export$c852d90bf7403b62);
$parcel$export(module.exports, "lighten", () => $40055e487d35a294$export$c0816ed86df316af);
$parcel$export(module.exports, "transparentize", () => $40055e487d35a294$export$d11da87e55cc498f);

var $ichJ5 = parcelRequire("ichJ5");

var $6KOWn = parcelRequire("6KOWn");
// @private
function $40055e487d35a294$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $40055e487d35a294$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $40055e487d35a294$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + $40055e487d35a294$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function $40055e487d35a294$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$40055e487d35a294$var$generateProperty(property, $40055e487d35a294$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $40055e487d35a294$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $40055e487d35a294$var$generateStyles(property, valuesWithDefaults);
}
function $40055e487d35a294$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $40055e487d35a294$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $40055e487d35a294$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$40055e487d35a294$var$endsWith(pxval, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the first argument to " + to + "(), got \"" + pxval + "\" instead.");
            newPxval = $40055e487d35a294$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$40055e487d35a294$var$endsWith(base, 'px')) throw new Error("Expected a string ending in \"px\" or a number passed as the second argument to " + to + "(), got \"" + base + "\" instead.");
            newBase = $40055e487d35a294$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error("Passed invalid pixel value (\"" + pxval + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        if (typeof newBase === 'string') throw new Error("Passed invalid base value (\"" + base + "\") to " + to + "(), please pass a value like \"12px\" or 12.");
        return "" + newPxval / newBase + to;
    };
};
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $40055e487d35a294$export$c63c6f932822f543 = /*#__PURE__*/ $40055e487d35a294$var$pxtoFactory('em');
var $40055e487d35a294$var$cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */ function $40055e487d35a294$export$feec6b849ef388ab(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match($40055e487d35a294$var$cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
var $40055e487d35a294$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $40055e487d35a294$var$getRatio(ratioName) {
    return $40055e487d35a294$var$ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function $40055e487d35a294$export$c82a8a23c9e8bdb6(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$40055e487d35a294$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $40055e487d35a294$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $40055e487d35a294$var$getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new Error("Invalid value passed as base to modularScale, expected number or em string but got \"" + base + "\"");
    return realBase * Math.pow(realRatio, steps) + "em";
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $40055e487d35a294$export$fb1897a40d146f7f = /*#__PURE__*/ $40055e487d35a294$var$pxtoFactory('rem');
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function $40055e487d35a294$export$cf95c51b03f10bae(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = $40055e487d35a294$export$feec6b849ef388ab(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = $40055e487d35a294$export$feec6b849ef388ab(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = $40055e487d35a294$export$feec6b849ef388ab(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = $40055e487d35a294$export$feec6b849ef388ab(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + fromSizeUnit + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $40055e487d35a294$export$8c467e8859fdef13(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function $40055e487d35a294$export$4bdbf921f0c0fd8c(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $40055e487d35a294$export$a5b94313d6908893(width) {
    if (width === void 0) width = '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function $40055e487d35a294$export$de4c2ac00f6121cf(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _extends2, _extends3;
            var _ref;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }
            var obj = _ref;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, $ichJ5.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = $40055e487d35a294$export$cf95c51b03f10bae(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, $ichJ5.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, $ichJ5.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref2, _ref3, _ref4;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
        return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4["@media (min-width: " + minScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = $40055e487d35a294$export$cf95c51b03f10bae(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4["@media (min-width: " + maxScreen + ")"] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
    }
}
function $40055e487d35a294$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")";
    });
    return fileFontReferences.join(', ');
}
function $40055e487d35a294$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function $40055e487d35a294$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($40055e487d35a294$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($40055e487d35a294$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $40055e487d35a294$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $40055e487d35a294$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        } // Removes undefined fields for cleaner css object.
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $40055e487d35a294$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $40055e487d35a294$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $40055e487d35a294$export$e79006618d7c6cc3(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $40055e487d35a294$export$a3295358bff77e() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $40055e487d35a294$export$c7187bbd1a7a9244(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    return _ref = {}, _ref[parent + "::-webkit-input-placeholder"] = (0, $ichJ5.default)({}, styles), _ref[parent + ":-moz-placeholder"] = (0, $ichJ5.default)({}, styles), _ref[parent + "::-moz-placeholder"] = (0, $ichJ5.default)({}, styles), _ref[parent + ":-ms-input-placeholder"] = (0, $ichJ5.default)({}, styles), _ref;
}
function $40055e487d35a294$var$_templateObject() {
    var data = (0, $6KOWn.default)([
        "radial-gradient(",
        "",
        "",
        "",
        ")"
    ]);
    $40055e487d35a294$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $40055e487d35a294$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $40055e487d35a294$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i]; // Adds leading coma if properties preceed color-stops
        if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ", " + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += "" + (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]); // Only adds substitution if it is defined
        else if (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1]) + " ";
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $40055e487d35a294$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $40055e487d35a294$var$parseFallback(colorStops),
        backgroundImage: $40055e487d35a294$var$constructGradientValue($40055e487d35a294$var$_templateObject(), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $40055e487d35a294$export$19389033401d366a(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
     // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[$40055e487d35a294$export$e79006618d7c6cc3()] = (0, $ichJ5.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $40055e487d35a294$export$7c69810f7b8835c9(styles, parent) {
    var _ref;
    if (parent === void 0) parent = '';
    return _ref = {}, _ref[parent + "::-moz-selection"] = (0, $ichJ5.default)({}, styles), _ref[parent + "::selection"] = (0, $ichJ5.default)({}, styles), _ref;
}
/* eslint-disable key-spacing */ var $40055e487d35a294$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $40055e487d35a294$var$getTimingFunction(functionName) {
    return $40055e487d35a294$var$functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function $40055e487d35a294$export$61210fa83792a81(timingFunction) {
    return $40055e487d35a294$var$getTimingFunction(timingFunction);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $40055e487d35a294$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
        'borderColor'
    ].concat(values));
}
var $40055e487d35a294$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return "0 " + width[0] / 2 + width[1] + " " + height[0] + height[1] + " " + width[0] / 2 + width[1];
        case 'left':
            return "" + height[0] / 2 + height[1] + " " + width[0] + width[1] + " " + height[0] / 2 + height[1] + " 0";
        case 'bottom':
            return "" + height[0] + height[1] + " " + width[0] / 2 + width[1] + " 0 " + width[0] / 2 + width[1];
        case 'right':
            return "" + height[0] / 2 + height[1] + " 0 " + height[0] / 2 + height[1] + " " + width[0] + width[1];
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
}; // needed for border-color
var $40055e487d35a294$var$reverseDirection = [
    'bottom',
    'left',
    'top',
    'right'
];
var $40055e487d35a294$var$NUMBER_AND_FLOAT = /(\d*\.?\d*)/;
/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function $40055e487d35a294$export$9eed783d03e0135c(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = [
        parseFloat(width),
        String(width).replace($40055e487d35a294$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    var heightAndUnit = [
        parseFloat(height),
        String(height).replace($40055e487d35a294$var$NUMBER_AND_FLOAT, '') || 'px'
    ];
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    var reverseDirectionIndex = $40055e487d35a294$var$reverseDirection.indexOf(pointingDirection);
    return (0, $ichJ5.default)({
        width: '0',
        height: '0',
        borderWidth: $40055e487d35a294$var$getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
        borderStyle: 'solid'
    }, $40055e487d35a294$export$e7fb0694ba2404fc.apply(void 0, Array.from({
        length: 4
    }).map(function(_, index) {
        return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
    })));
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $40055e487d35a294$export$dca3d8ad656c34d2(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function $40055e487d35a294$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $40055e487d35a294$var$convertToInt(red, green, blue) {
    return $40055e487d35a294$var$colorToInt(red) + "," + $40055e487d35a294$var$colorToInt(green) + "," + $40055e487d35a294$var$colorToInt(blue);
}
function $40055e487d35a294$var$hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = $40055e487d35a294$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var $40055e487d35a294$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $40055e487d35a294$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $40055e487d35a294$var$namedColorMap[normalizedColorName] ? "#" + $40055e487d35a294$var$namedColorMap[normalizedColorName] : color;
}
var $40055e487d35a294$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $40055e487d35a294$var$hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var $40055e487d35a294$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $40055e487d35a294$var$reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var $40055e487d35a294$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $40055e487d35a294$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $40055e487d35a294$var$hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $40055e487d35a294$var$hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function $40055e487d35a294$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $40055e487d35a294$var$nameToHex(color);
    if (normalizedColor.match($40055e487d35a294$var$hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($40055e487d35a294$var$hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match($40055e487d35a294$var$reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match($40055e487d35a294$var$reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = $40055e487d35a294$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = $40055e487d35a294$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = $40055e487d35a294$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + $40055e487d35a294$var$hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = $40055e487d35a294$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + rgbColorString + ".");
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $40055e487d35a294$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + $40055e487d35a294$var$hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = $40055e487d35a294$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error("Couldn't generate valid rgb string from " + normalizedColor + ", it returned " + _rgbColorString + ".");
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
function $40055e487d35a294$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function $40055e487d35a294$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $40055e487d35a294$var$rgbToHsl($40055e487d35a294$export$2f48baff6995707a(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $40055e487d35a294$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
function $40055e487d35a294$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $40055e487d35a294$var$colorToHex(color) {
    return $40055e487d35a294$var$numberToHex(Math.round(color * 255));
}
function $40055e487d35a294$var$convertToHex(red, green, blue) {
    return $40055e487d35a294$var$reduceHexValue("#" + $40055e487d35a294$var$colorToHex(red) + $40055e487d35a294$var$colorToHex(green) + $40055e487d35a294$var$colorToHex(blue));
}
function $40055e487d35a294$var$hslToHex(hue, saturation, lightness) {
    return $40055e487d35a294$var$hslToRgb(hue, saturation, lightness, $40055e487d35a294$var$convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $40055e487d35a294$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $40055e487d35a294$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $40055e487d35a294$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $40055e487d35a294$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $40055e487d35a294$var$hslToHex(value, saturation, lightness) : "rgba(" + $40055e487d35a294$var$hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $40055e487d35a294$var$hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + $40055e487d35a294$var$hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $40055e487d35a294$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $40055e487d35a294$var$reduceHexValue("#" + $40055e487d35a294$var$numberToHex(value) + $40055e487d35a294$var$numberToHex(green) + $40055e487d35a294$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $40055e487d35a294$var$reduceHexValue("#" + $40055e487d35a294$var$numberToHex(value.red) + $40055e487d35a294$var$numberToHex(value.green) + $40055e487d35a294$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $40055e487d35a294$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $40055e487d35a294$export$2f48baff6995707a(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $40055e487d35a294$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $40055e487d35a294$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
var $40055e487d35a294$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $40055e487d35a294$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $40055e487d35a294$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $40055e487d35a294$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $40055e487d35a294$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $40055e487d35a294$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($40055e487d35a294$var$errMsg);
    if ($40055e487d35a294$var$isRgba(color)) return $40055e487d35a294$export$4e46ac54fc82cf3b(color);
    if ($40055e487d35a294$var$isRgb(color)) return $40055e487d35a294$export$8972dc0e6ad9238f(color);
    if ($40055e487d35a294$var$isHsla(color)) return $40055e487d35a294$export$810b04175080204c(color);
    if ($40055e487d35a294$var$isHsl(color)) return $40055e487d35a294$export$8f4a7c0bb78e6ea8(color);
    throw new Error($40055e487d35a294$var$errMsg);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $40055e487d35a294$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $40055e487d35a294$var$curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function $40055e487d35a294$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $40055e487d35a294$var$curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $40055e487d35a294$var$adjustHue(degree, color) {
    var hslColor = $40055e487d35a294$export$1286688e1b3fde9c(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, hslColor, {
        hue: (hslColor.hue + parseFloat(degree)) % 360
    }));
} // prettier-ignore
var $40055e487d35a294$export$2b372a09365374d6 = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$adjustHue);
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $40055e487d35a294$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $40055e487d35a294$export$1286688e1b3fde9c(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function $40055e487d35a294$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $40055e487d35a294$var$darken(amount, color) {
    var hslColor = $40055e487d35a294$export$1286688e1b3fde9c(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, hslColor, {
        lightness: $40055e487d35a294$var$guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
} // prettier-ignore
var $40055e487d35a294$export$4b073707ff63303 = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$darken);
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $40055e487d35a294$var$desaturate(amount, color) {
    var hslColor = $40055e487d35a294$export$1286688e1b3fde9c(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, hslColor, {
        saturation: $40055e487d35a294$var$guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
} // prettier-ignore
var $40055e487d35a294$export$fb75607d98509d9 = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$desaturate);
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $40055e487d35a294$export$c852d90bf7403b62(color) {
    var rgbColor = $40055e487d35a294$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $40055e487d35a294$export$6f416a6db2dfcd5c(color) {
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, $40055e487d35a294$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $40055e487d35a294$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $40055e487d35a294$export$2f48baff6995707a(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $40055e487d35a294$var$lighten(amount, color) {
    var hslColor = $40055e487d35a294$export$1286688e1b3fde9c(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, hslColor, {
        lightness: $40055e487d35a294$var$guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
} // prettier-ignore
var $40055e487d35a294$export$c0816ed86df316af = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$lighten);
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $40055e487d35a294$var$mix(weight, color, otherColor) {
    var parsedColor1 = $40055e487d35a294$export$2f48baff6995707a(color);
    var color1 = (0, $ichJ5.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $40055e487d35a294$export$2f48baff6995707a(otherColor);
    var color2 = (0, $ichJ5.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1 // The formular is copied from the original Sass implementation:
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
    };
    return $40055e487d35a294$export$4e46ac54fc82cf3b(mixedColor);
} // prettier-ignore
var $40055e487d35a294$export$2c9e8a9632a706b2 = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$mix);
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $40055e487d35a294$var$opacify(amount, color) {
    var parsedColor = $40055e487d35a294$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $ichJ5.default)({}, parsedColor, {
        alpha: $40055e487d35a294$var$guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return $40055e487d35a294$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $40055e487d35a294$export$f4f50e3877dd0530 = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$opacify);
/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $40055e487d35a294$export$61654c1796c44811(color) {
    return $40055e487d35a294$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $40055e487d35a294$var$saturate(amount, color) {
    var hslColor = $40055e487d35a294$export$1286688e1b3fde9c(color);
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, hslColor, {
        saturation: $40055e487d35a294$var$guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
} // prettier-ignore
var $40055e487d35a294$export$5fcac96f5a87e3db = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$saturate);
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $40055e487d35a294$var$setHue(hue, color) {
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, $40055e487d35a294$export$1286688e1b3fde9c(color), {
        hue: parseFloat(hue)
    }));
} // prettier-ignore
var $40055e487d35a294$export$3bf58ce3e497a846 = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$setHue);
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $40055e487d35a294$var$setLightness(lightness, color) {
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, $40055e487d35a294$export$1286688e1b3fde9c(color), {
        lightness: parseFloat(lightness)
    }));
} // prettier-ignore
var $40055e487d35a294$export$7ef5d725337b805d = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$setLightness);
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $40055e487d35a294$var$setSaturation(saturation, color) {
    return $40055e487d35a294$export$42fe740cdf79b2df((0, $ichJ5.default)({}, $40055e487d35a294$export$1286688e1b3fde9c(color), {
        saturation: parseFloat(saturation)
    }));
} // prettier-ignore
var $40055e487d35a294$export$b40fe421ea7a4f7e = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$setSaturation);
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $40055e487d35a294$var$shade(percentage, color) {
    return $40055e487d35a294$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore
var $40055e487d35a294$export$3e32adda0df4ef5d = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$shade);
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $40055e487d35a294$var$tint(percentage, color) {
    return $40055e487d35a294$export$2c9e8a9632a706b2(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore
var $40055e487d35a294$export$fc176dd65a27d98b = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$tint);
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $40055e487d35a294$var$transparentize(amount, color) {
    var parsedColor = $40055e487d35a294$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, $ichJ5.default)({}, parsedColor, {
        alpha: $40055e487d35a294$var$guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
    });
    return $40055e487d35a294$export$4e46ac54fc82cf3b(colorWithAlpha);
} // prettier-ignore
var $40055e487d35a294$export$d11da87e55cc498f = /*#__PURE__*/ $40055e487d35a294$var$curry($40055e487d35a294$var$transparentize);
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $40055e487d35a294$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $40055e487d35a294$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $40055e487d35a294$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var $40055e487d35a294$var$sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function $40055e487d35a294$export$1edee58a52776cd9(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && $40055e487d35a294$var$sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + $40055e487d35a294$var$capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + $40055e487d35a294$var$capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + $40055e487d35a294$var$capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $40055e487d35a294$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $40055e487d35a294$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $40055e487d35a294$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $40055e487d35a294$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function $40055e487d35a294$var$generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $40055e487d35a294$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $40055e487d35a294$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($40055e487d35a294$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var $40055e487d35a294$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $40055e487d35a294$var$template(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $40055e487d35a294$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $40055e487d35a294$var$statefulSelectors(states, $40055e487d35a294$var$template, $40055e487d35a294$var$stateMap);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $40055e487d35a294$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $40055e487d35a294$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
        'padding'
    ].concat(values));
}
var $40055e487d35a294$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $40055e487d35a294$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($40055e487d35a294$var$positionMap$1.indexOf(positionKeyword) >= 0) return (0, $ichJ5.default)({
        position: positionKeyword
    }, $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $40055e487d35a294$export$4fc00c04dd60af95.apply(void 0, [
            '',
            firstValue
        ].concat(values));
    }
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $40055e487d35a294$export$346677f925de839c(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var $40055e487d35a294$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $40055e487d35a294$var$template$1(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $40055e487d35a294$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $40055e487d35a294$var$statefulSelectors(states, $40055e487d35a294$var$template$1, $40055e487d35a294$var$stateMap$1);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function $40055e487d35a294$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new Error('Property must be a string value.');
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}

});
parcelRegister("6KOWn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eae8db41dd64509$export$2e2bcd8739ae039);
function $4eae8db41dd64509$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), e.raw = t, e;
}

});



parcelRegister("dfktK", function(module, exports) {
$parcel$export(module.exports, "GlobalStyled", () => $1867496a20383332$export$b606131378921a7b);
$parcel$export(module.exports, "NewGlobalBGColor", () => $1867496a20383332$export$aa61b57bede93357);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
parcelRequire("6uBMs");
var $93uvS = parcelRequire("93uvS");

var $2R2ud = parcelRequire("2R2ud");
const $1867496a20383332$var$getLinkColorToken = (props)=>{
    if (props !== null && props !== void 0 && props.isCsm) {
        const generatedColors = (0, $2R2ud.generateThemeBranding)(props.theme.color);
        return `var(--ds-link, ${generatedColors.color900})`;
    }
    return `var(--ds-link, ${props.theme.color})`;
};
const $1867496a20383332$export$b606131378921a7b = /*#__PURE__*/ (0, $el3DQ.default)((0, $93uvS.default)).withConfig({
    componentId: "sc-15eor0s-0"
})`background-color:${"var(--ds-surface, #FFFFFF)"};font:${"var(--ds-font-body, normal 400 14px/1.42857142857143 -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"};a:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']),a:hover:not(.cv-exclude-from-customisation):not([data-exclude-global-styling='true']){color:${(props)=>$1867496a20383332$var$getLinkColorToken(props)};}h1,h2{letter-spacing:-0.001em;}:root{--ds-space-0:0;--ds-space-025:0.125rem;--ds-space-050:0.25rem;--ds-space-075:0.375rem;--ds-space-100:0.5rem;--ds-space-150:0.75rem;--ds-space-200:1rem;--ds-space-250:1.25rem;--ds-space-300:1.5rem;--ds-space-400:2rem;--ds-space-500:2.5rem;--ds-space-600:3rem;--ds-space-800:4rem;--ds-space-1000:5rem;--ds-font-family-monospace:'SFMono-Medium','SF Mono','Segoe UI Mono','Roboto Mono','Ubuntu Mono',Menlo,Consolas,Courier,monospace;--ds-font-family-sans:-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;--ds-font-size-050:11px;--ds-font-size-075:12px;--ds-font-size-100:14px;--ds-font-size-200:16px;--ds-font-size-300:20px;--ds-font-size-400:24px;--ds-font-size-500:29px;--ds-font-size-600:35px;--ds-font-weight-bold:700;--ds-font-weight-medium:500;--ds-font-weight-regular:400;--ds-font-weight-semibold:600;--ds-font-lineHeight-100:1rem;--ds-font-lineHeight-200:1.25rem;--ds-font-lineHeight-300:1.5rem;--ds-font-lineHeight-400:1.75rem;--ds-font-lineHeight-500:2rem;--ds-font-lineHeight-600:2.5rem;}`;
const $1867496a20383332$export$aa61b57bede93357 = /*#__PURE__*/ (0, $el3DQ.default)((0, $93uvS.default)).withConfig({
    componentId: "sc-15eor0s-1"
})`background-color:${"var(--ds-surface, #FFFFFF)"};`;

});
parcelRegister("6uBMs", function(module, exports) {
$parcel$export(module.exports, "BodyClassName", () => (parcelRequire("93uvS")).default);

var $93uvS = parcelRequire("93uvS");

});
parcelRegister("93uvS", function(module, exports) {
$parcel$export(module.exports, "default", () => $468baf5fc0b2017d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1CB66 = parcelRequire("1CB66");
class $468baf5fc0b2017d$export$2e2bcd8739ae039 extends $4fqPo.PureComponent {
    constructor(props){
        super(props);
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            classes.forEach((className)=>{
                (0, $1CB66.default).addClassName('body', className);
            });
        }
    }
    componentWillUnmount() {
        if (this.props.className) {
            const classes = this.props.className.split(' ');
            // IE 11 doesn't allow you to add multiple classes at once.
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            classes.forEach((className)=>document.body.classList.remove(className));
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.className !== this.props.className) {
            if (prevProps.className) {
                const prevClasses = prevProps.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.remove(...prevClasses);
            }
            if (this.props.className) {
                const classes = this.props.className.split(' ');
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                document.body.classList.add(...classes);
            }
        }
    }
    render() {
        return null;
    }
}

});


parcelRegister("2R2ud", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $60cbe5cc7dc11d1f$export$c1410db1c88d6e0f);

var $h89b7 = parcelRequire("h89b7");

var $iYRmT = parcelRequire("iYRmT");
/**
 * Default primary color for CSM branding
 */ const $60cbe5cc7dc11d1f$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR = '#B5B5B5';
const $60cbe5cc7dc11d1f$export$c1410db1c88d6e0f = (primaryColour)=>(0, $h89b7.generateColorRamps)((0, $iYRmT.isValidHex)(primaryColour) ? primaryColour : $60cbe5cc7dc11d1f$var$CSM_BRANDING_DEFAULT_PRIMARY_COLOR);

});
parcelRegister("h89b7", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $e9da92a5602ad093$export$3a180ce5632a9d57);

var $1FxP5 = parcelRequire("1FxP5");

var $fkz4U = parcelRequire("fkz4U");

var $jg8q9 = parcelRequire("jg8q9");

var $joST6 = parcelRequire("joST6");
const $e9da92a5602ad093$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $e9da92a5602ad093$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $e9da92a5602ad093$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $1FxP5.deltaE)((0, $1FxP5.hexToRgb)(value), (0, $1FxP5.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $e9da92a5602ad093$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $1FxP5.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $1FxP5.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $1FxP5.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $e9da92a5602ad093$var$lowLuminanceContrastRatios : $e9da92a5602ad093$var$highLuminanceContrastRatios;
    const brandRgba = (0, $1FxP5.hexToRgbA)(brandColor);
    const hctColor = (0, $joST6.Hct).fromInt((0, $fkz4U.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $fkz4U.rgbaFromArgb)((0, $joST6.Hct).from(hctColor.hue, hctColor.chroma, (0, $jg8q9.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $1FxP5.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $e9da92a5602ad093$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $e9da92a5602ad093$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $e9da92a5602ad093$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("1FxP5", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $b65575808367ef98$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $b65575808367ef98$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $b65575808367ef98$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $b65575808367ef98$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $b65575808367ef98$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $b65575808367ef98$export$e770b01b744f3745);
$parcel$export(module.exports, "deltaE", () => $b65575808367ef98$export$e8ddad763b4bebf9);

var $iYRmT = parcelRequire("iYRmT");
function $b65575808367ef98$export$34d09c4a771c46ef(r, g, b) {
    const chars = (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    return `#${chars}`;
}
function $b65575808367ef98$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $b65575808367ef98$export$b36dbdb4f463f05c(hex) {
    if (!(0, $iYRmT.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $b65575808367ef98$export$1212645cf40ebf71(hex)
    ];
}
function $b65575808367ef98$export$5a544e13ad4e1fa5(hex) {
    if (!(0, $iYRmT.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $b65575808367ef98$export$47ea145a83f50dc0(hex) {
    if (!(0, $iYRmT.isValidHex)(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $b65575808367ef98$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $b65575808367ef98$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $b65575808367ef98$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $iYRmT.isValidHex)(foreground) || !(0, $iYRmT.isValidHex)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $b65575808367ef98$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $b65575808367ef98$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $b65575808367ef98$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $b65575808367ef98$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $b65575808367ef98$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $b65575808367ef98$var$rgbToLab(rgbA);
    let labB = $b65575808367ef98$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $b65575808367ef98$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});
parcelRegister("iYRmT", function(module, exports) {
$parcel$export(module.exports, "isValidHex", () => $14766e205029020d$export$944f75ec5697b362);
const $14766e205029020d$export$944f75ec5697b362 = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);

});


parcelRegister("fkz4U", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $9020b4b03b8fdbaa$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $9020b4b03b8fdbaa$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $9020b4b03b8fdbaa$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $9020b4b03b8fdbaa$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $9020b4b03b8fdbaa$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $9020b4b03b8fdbaa$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $9020b4b03b8fdbaa$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $9020b4b03b8fdbaa$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $9020b4b03b8fdbaa$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $9020b4b03b8fdbaa$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $eOSeH = parcelRequire("eOSeH");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $9020b4b03b8fdbaa$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $9020b4b03b8fdbaa$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $9020b4b03b8fdbaa$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $9020b4b03b8fdbaa$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $9020b4b03b8fdbaa$export$7928ddf440518d19(linrgb) {
    const r = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(linrgb[0]);
    const g = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(linrgb[1]);
    const b = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(linrgb[2]);
    return $9020b4b03b8fdbaa$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $9020b4b03b8fdbaa$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $9020b4b03b8fdbaa$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $9020b4b03b8fdbaa$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $9020b4b03b8fdbaa$var$blueFromArgb(argb) {
    return argb & 255;
}
function $9020b4b03b8fdbaa$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $9020b4b03b8fdbaa$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(linearR);
    const g = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(linearG);
    const b = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(linearB);
    return $9020b4b03b8fdbaa$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $9020b4b03b8fdbaa$var$xyzFromArgb(argb) {
    const r = $9020b4b03b8fdbaa$export$dec6bcda7bf47f2c($9020b4b03b8fdbaa$var$redFromArgb(argb));
    const g = $9020b4b03b8fdbaa$export$dec6bcda7bf47f2c($9020b4b03b8fdbaa$var$greenFromArgb(argb));
    const b = $9020b4b03b8fdbaa$export$dec6bcda7bf47f2c($9020b4b03b8fdbaa$var$blueFromArgb(argb));
    return $eOSeH.matrixMultiply([
        r,
        g,
        b
    ], $9020b4b03b8fdbaa$var$SRGB_TO_XYZ);
}
function $9020b4b03b8fdbaa$export$ae8c227f6d0cbddb(lstar) {
    const y = $9020b4b03b8fdbaa$export$7f3071c4a5db05a0(lstar);
    const component = $9020b4b03b8fdbaa$export$777e26aa2ec02b1(y);
    return $9020b4b03b8fdbaa$export$58a74b9f8e513b7b(component, component, component);
}
function $9020b4b03b8fdbaa$export$8b8f7ef2e0a71c61(argb) {
    const y = $9020b4b03b8fdbaa$var$xyzFromArgb(argb)[1];
    return 116.0 * $9020b4b03b8fdbaa$var$labF(y / 100.0) - 16.0;
}
function $9020b4b03b8fdbaa$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $9020b4b03b8fdbaa$var$labInvf((lstar + 16.0) / 116.0);
}
function $9020b4b03b8fdbaa$export$bfc0d1dd9c64ada2(y) {
    return $9020b4b03b8fdbaa$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $9020b4b03b8fdbaa$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $9020b4b03b8fdbaa$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $eOSeH.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $9020b4b03b8fdbaa$export$d4534a444c6526c3() {
    return $9020b4b03b8fdbaa$var$WHITE_POINT_D65;
}
function $9020b4b03b8fdbaa$export$fb1fd26c787a8662(argb) {
    const r = $9020b4b03b8fdbaa$var$redFromArgb(argb);
    const g = $9020b4b03b8fdbaa$var$greenFromArgb(argb);
    const b = $9020b4b03b8fdbaa$var$blueFromArgb(argb);
    const a = $9020b4b03b8fdbaa$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $9020b4b03b8fdbaa$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $9020b4b03b8fdbaa$var$clampComponent(r);
    const gValue = $9020b4b03b8fdbaa$var$clampComponent(g);
    const bValue = $9020b4b03b8fdbaa$var$clampComponent(b);
    const aValue = $9020b4b03b8fdbaa$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $9020b4b03b8fdbaa$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $9020b4b03b8fdbaa$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $9020b4b03b8fdbaa$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("eOSeH", function(module, exports) {
$parcel$export(module.exports, "signum", () => $7c6a27a2aacc46f3$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $7c6a27a2aacc46f3$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $7c6a27a2aacc46f3$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $7c6a27a2aacc46f3$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $7c6a27a2aacc46f3$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $7c6a27a2aacc46f3$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $7c6a27a2aacc46f3$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $7c6a27a2aacc46f3$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $7c6a27a2aacc46f3$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $7c6a27a2aacc46f3$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $7c6a27a2aacc46f3$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $7c6a27a2aacc46f3$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("jg8q9", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $9ed8aa4fc13492f2$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $fkz4U = parcelRequire("fkz4U");

var $eOSeH = parcelRequire("eOSeH");
class $9ed8aa4fc13492f2$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $eOSeH.clampDouble(0.0, 100.0, toneA);
        toneB = $eOSeH.clampDouble(0.0, 100.0, toneB);
        return $9ed8aa4fc13492f2$export$656ae42051d0ca86.ratioOfYs($fkz4U.yFromLstar(toneA), $fkz4U.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $fkz4U.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $9ed8aa4fc13492f2$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $fkz4U.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $fkz4U.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $9ed8aa4fc13492f2$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $fkz4U.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $9ed8aa4fc13492f2$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $9ed8aa4fc13492f2$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("joST6", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $4ed365c670b0e9be$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fkz4U = parcelRequire("fkz4U");

var $eOSeH = parcelRequire("eOSeH");
class $4ed365c670b0e9be$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $4ed365c670b0e9be$export$91d2e033b3924566($4ed365c670b0e9be$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $4ed365c670b0e9be$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($4ed365c670b0e9be$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($4ed365c670b0e9be$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($4ed365c670b0e9be$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $4ed365c670b0e9be$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $fkz4U.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $4ed365c670b0e9be$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $fkz4U.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $4ed365c670b0e9be$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $4ed365c670b0e9be$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $4ed365c670b0e9be$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $4ed365c670b0e9be$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $fkz4U.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $4ed365c670b0e9be$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $4ed365c670b0e9be$var$Cam16.fromIntInViewingConditions(argb, $4ed365c670b0e9be$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $fkz4U.linearized(red);
        const greenL = $fkz4U.linearized(green);
        const blueL = $fkz4U.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $eOSeH.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $eOSeH.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $eOSeH.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $4ed365c670b0e9be$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $4ed365c670b0e9be$var$Cam16.fromJchInViewingConditions(j, c, h, $4ed365c670b0e9be$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $4ed365c670b0e9be$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $4ed365c670b0e9be$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $4ed365c670b0e9be$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $4ed365c670b0e9be$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($4ed365c670b0e9be$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $eOSeH.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $eOSeH.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $eOSeH.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $fkz4U.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $eOSeH.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $eOSeH.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $eOSeH.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $4ed365c670b0e9be$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $eOSeH.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $eOSeH.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $eOSeH.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $4ed365c670b0e9be$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $eOSeH.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $eOSeH.matrixMultiply(linrgb, $4ed365c670b0e9be$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $4ed365c670b0e9be$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $4ed365c670b0e9be$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $4ed365c670b0e9be$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $4ed365c670b0e9be$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $4ed365c670b0e9be$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $4ed365c670b0e9be$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $4ed365c670b0e9be$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $4ed365c670b0e9be$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $4ed365c670b0e9be$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $4ed365c670b0e9be$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($4ed365c670b0e9be$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($4ed365c670b0e9be$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($4ed365c670b0e9be$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $4ed365c670b0e9be$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $4ed365c670b0e9be$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $4ed365c670b0e9be$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($4ed365c670b0e9be$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $4ed365c670b0e9be$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $4ed365c670b0e9be$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $4ed365c670b0e9be$var$HctSolver.criticalPlaneBelow($4ed365c670b0e9be$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $4ed365c670b0e9be$var$HctSolver.criticalPlaneAbove($4ed365c670b0e9be$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $4ed365c670b0e9be$var$HctSolver.criticalPlaneAbove($4ed365c670b0e9be$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $4ed365c670b0e9be$var$HctSolver.criticalPlaneBelow($4ed365c670b0e9be$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $4ed365c670b0e9be$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $4ed365c670b0e9be$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $4ed365c670b0e9be$var$HctSolver.hueOf(mid);
                    if ($4ed365c670b0e9be$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $4ed365c670b0e9be$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $eOSeH.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $4ed365c670b0e9be$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $4ed365c670b0e9be$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $4ed365c670b0e9be$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $4ed365c670b0e9be$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $eOSeH.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $4ed365c670b0e9be$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $4ed365c670b0e9be$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $4ed365c670b0e9be$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $4ed365c670b0e9be$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $fkz4U.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $fkz4U.argbFromLstar(lstar);
        hueDegrees = $eOSeH.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $fkz4U.yFromLstar(lstar);
        const exactAnswer = $4ed365c670b0e9be$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $4ed365c670b0e9be$var$HctSolver.bisectToLimit(y, hueRadians);
        return $fkz4U.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $4ed365c670b0e9be$var$Cam16.fromInt($4ed365c670b0e9be$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $4ed365c670b0e9be$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $4ed365c670b0e9be$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $fkz4U.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $fkz4U.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $eOSeH.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $eOSeH.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $fkz4U.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $4ed365c670b0e9be$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});




parcelRegister("bTtiN", function(module, exports) {
$parcel$export(module.exports, "getFlexiHelpCenterRoute", () => $027d231bb0e3bd57$export$21b2409877effae5);
$parcel$export(module.exports, "getViewHomePageRoute", () => $027d231bb0e3bd57$export$2601c63db4e9c5eb);
$parcel$export(module.exports, "getEditHomePageRoute", () => $027d231bb0e3bd57$export$ce4073fcfac7d40d);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $6nes2 = parcelRequire("6nes2");

var $3Zmh8 = parcelRequire("3Zmh8");

var $gi5ak = parcelRequire("gi5ak");

var $dQegt = parcelRequire("dQegt");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("kZndO");
var $1iSZL = parcelRequire("1iSZL");
parcelRequire("5FSYN");
var $cBf1I = parcelRequire("cBf1I");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");
parcelRequire("evK9u");
var $a8nBS = parcelRequire("a8nBS");
parcelRequire("8zo3m");
var $f1dKT = parcelRequire("f1dKT");

var $corqd = parcelRequire("corqd");

var $as4kh = parcelRequire("as4kh");

var $54jwS = parcelRequire("54jwS");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $bp9tj = parcelRequire("bp9tj");

var $l1IDP = parcelRequire("l1IDP");

var $6RZw4 = parcelRequire("6RZw4");

var $3NY3t = parcelRequire("3NY3t");
const $027d231bb0e3bd57$var$VIEW_HOMEPAGE_PATH = '(/)?';
const $027d231bb0e3bd57$var$EDIT_HOMEPAGE_PATH = '/edit';

const $027d231bb0e3bd57$var$AsyncViewHomepage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("8tUJD")), {
        moduleId: "./src/view/advanced-help-center/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), null)
});

const $027d231bb0e3bd57$var$AsyncCSMViewHomepage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("4HBoM")), {
        moduleId: "./src/view/customer-service/view-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), null)
});
const $027d231bb0e3bd57$export$21b2409877effae5 = (name = 'help-center', path = $027d231bb0e3bd57$var$VIEW_HOMEPAGE_PATH, screenName = (0, $748yq.ScreenName).VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = [
        (0, $3NY3t.brandingResource),
        (0, $3Zmh8.ViewHomepageResource),
        (0, $3Zmh8.searchComponentVirtualAgentResource)
    ];
    return (0, $bp9tj.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $027d231bb0e3bd57$var$AsyncViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $3Zmh8.ViewHomepageResource),
            (0, $3Zmh8.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $027d231bb0e3bd57$export$fc52ccc4768cd164 = (name = 'help-center', path = $027d231bb0e3bd57$var$VIEW_HOMEPAGE_PATH, screenName = (0, $748yq.ScreenName).CSM_VIEW_HOMEPAGE)=>{
    const viewHomePageSSRResources = [
        (0, $3NY3t.brandingResource),
        (0, $3Zmh8.ViewHomepageResource),
        (0, $3Zmh8.searchComponentVirtualAgentResource)
    ];
    return (0, $bp9tj.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: $027d231bb0e3bd57$var$AsyncCSMViewHomepage,
        /**
     * These resources can be removed once the individual elements data starts coming in the layout response
     */ resources: [
            (0, $3Zmh8.ViewHomepageResource),
            (0, $3Zmh8.searchComponentVirtualAgentResource)
        ]
    }, screenName, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};
const $027d231bb0e3bd57$export$2601c63db4e9c5eb = ()=>{
    if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) return $027d231bb0e3bd57$export$fc52ccc4768cd164();
    return $027d231bb0e3bd57$export$21b2409877effae5();
};

const $027d231bb0e3bd57$export$ebbcccd382fe1f3b = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("8aZES")), {
        moduleId: "./src/view/advanced-help-center/edit-homepage/index.tsx"
    }),
    LoadingSkeleton: ()=>(0, $bG6ob.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1iSZL.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), {
            showActionBar: true
        })
});

const $027d231bb0e3bd57$export$400d7e0667f80c3f = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("gmLeS")), {
        moduleId: "./src/view/advanced-help-center/edit-homepage-v2/index.tsx"
    }),
    LoadingSkeleton: ()=>(0, $bG6ob.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1iSZL.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), {
            showActionBar: true
        })
});
const $027d231bb0e3bd57$export$96880615462f6c7f = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: props.location.pathname
    }), (0, $3RiO6.default)({
        message: formatMessage((0, $corqd.authPageMessage)),
        callToActionText: formatMessage((0, $corqd.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a8nBS.default), {
            path: $027d231bb0e3bd57$var$EDIT_HOMEPAGE_PATH,
            component: (0, $bG6ob.isCustomPagesUiEnabled)() ? $027d231bb0e3bd57$export$400d7e0667f80c3f : $027d231bb0e3bd57$export$ebbcccd382fe1f3b,
            screenName: (0, $748yq.ScreenName).EDIT_HOMEPAGE,
            isFooterHidden: (0, $bG6ob.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f1dKT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props));
};
const $027d231bb0e3bd57$export$ce4073fcfac7d40d = (name = 'edit-homepage', path = '/edit')=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        resources: [
            (0, $bG6ob.isCustomPagesUiEnabled)() ? (0, $6RZw4.EditHomepageV2Resource) : (0, $l1IDP.EditHomepageResource)
        ],
        exact: true,
        component: (0, $ebpTf.getIsHCCustomizationEnabled)() && (0, $bG6ob.isAdvancedCustomizationEditPageEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo($027d231bb0e3bd57$export$96880615462f6c7f) : (0, $54jwS.withAnalyticsContext)({
            componentName: 'notFoundPage'
        })(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        (0, $as4kh.default)({})((0, $cBf1I.NotFoundPage)))
    };
    return editHomePageRoute;
};

});
parcelRegister("6nes2", function(module, exports) {
$parcel$export(module.exports, "default", () => $000091a083925996$export$2e2bcd8739ae039);
/* flexible-homepage-loader.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fVQGu = parcelRequire("fVQGu");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("eXmLN");
var $2mGQj = parcelRequire("2mGQj");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $cijxS = parcelRequire("cijxS");
const $000091a083925996$var$SECTION_HEIGHT = 232;
const $000091a083925996$var$FlexibleHomepageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: "flexible-homepage-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $000091a083925996$var$skeletonContainer
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2mGQj.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $000091a083925996$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $5Kpwp.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($000091a083925996$var$SectionLoader, {
            key: `flexibleHCLoader_${index}`,
            "data-testid": "flexible-hc-section-skeleton",
            height: $000091a083925996$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        });
    })));
};
const $000091a083925996$var$skeletonContainer = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
const $000091a083925996$var$headerContainer = (0, $2m8U6.xcss)({
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $000091a083925996$var$SectionLoader = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $fVQGu.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_2rko12b0 _1bsb1osq _19pk1ejb _69lw94vn _9wd01ejb _n71h1ejb",
            __cmplp.className
        ])
    });
});
var $000091a083925996$export$2e2bcd8739ae039 = $000091a083925996$var$FlexibleHomepageLoader;

});
parcelRegister("5Kpwp", function(module, exports) {
$parcel$export(module.exports, "BANNER_HEIGHT", () => $123dbb6bd49e8344$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "HEADER_HEIGHT", () => $123dbb6bd49e8344$export$cdb7fd9d999c7168);
$parcel$export(module.exports, "SEARCH_INPUT_FONT_SIZE", () => $123dbb6bd49e8344$export$1d74cef432cdcb55);
$parcel$export(module.exports, "FilterContainer", () => $123dbb6bd49e8344$export$2f96f6f204f87534);
$parcel$export(module.exports, "FormErrorContainer", () => $123dbb6bd49e8344$export$ae0c09a310b3720b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");
const $123dbb6bd49e8344$export$c09feb53ddd4034b = 300;
const $123dbb6bd49e8344$export$ed7cc0d417ee89e = $bpWyP.multiple(44);
const $123dbb6bd49e8344$export$cdb7fd9d999c7168 = $bpWyP.unitless * 7;
const $123dbb6bd49e8344$export$1d74cef432cdcb55 = $4W9tu.mediumLarge;
const $123dbb6bd49e8344$export$2f96f6f204f87534 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1pch1g4-0"
})`display:flex;flex-wrap:wrap;margin-top:${"var(--ds-space-negative-100, -8px)"};margin-right:${"var(--ds-space-negative-200, -16px)"};> *{flex-basis:0;margin-right:${"var(--ds-space-200, 16px)"};margin-top:${"var(--ds-space-100, 8px)"};min-width:${$bpWyP.multiple(27.5).px};flex-grow:1;}`;
const $123dbb6bd49e8344$export$ae0c09a310b3720b = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1pch1g4-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("eXmLN", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => (parcelRequire("2mGQj")).ActionBarStateless);

var $2mGQj = parcelRequire("2mGQj");

});
parcelRegister("2mGQj", function(module, exports) {
$parcel$export(module.exports, "ActionBarStateless", () => $42183aafb9729662$export$dc910ca71acdb8f0);
/* action-bar-stateless.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $1HSOM = parcelRequire("1HSOM");

var $56isT = parcelRequire("56isT");

var $dQegt = parcelRequire("dQegt");
parcelRequire("6yHJB");
var $eOel9 = parcelRequire("eOel9");

var $a4wAe = parcelRequire("a4wAe");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $aJpl3 = parcelRequire("aJpl3");
const $42183aafb9729662$export$cc312d5a7378bea1 = 'Help Centers customize page layout';
const $42183aafb9729662$export$dc910ca71acdb8f0 = ({ isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, isPublishing: isPublishing, onPublish: onPublish, onClose: onClose, publishButtonDisabled: publishButtonDisabled, previewButtonDisabled: previewButtonDisabled, children: children, isPageInPreviewMode: isPageInPreviewMode, togglePreviewMode: togglePreviewMode })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    if (isPageInBrandingPreviewMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$ActionsWrapper, {
        isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOel9.BrandingPreviewBanner), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$ActionsWrapper, {
        id: "advance-customization-action-bar",
        isPageInBrandingPreviewMode: !!isPageInBrandingPreviewMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$ButtonContainer, null, !isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $42183aafb9729662$var$buttonGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$ButtonWrapper, {
        actionSubjectId: "backToHomePage",
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $aJpl3.default).backToSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $56isT.default), {
        showIcon: true,
        showTypeField: true,
        featureName: $42183aafb9729662$export$cc312d5a7378bea1,
        buttonLabel: (0, $aJpl3.default).giveFeedback,
        analyticsSubjectId: "customizePageLayoutFeedbackButton"
    })), isPageInPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$PreviewButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a4wAe.default), {
        appearance: "info",
        title: formatMessage((0, $aJpl3.default).previewMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$ButtonGroup, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.Button), {
        isDisabled: previewButtonDisabled,
        actionSubjectId: "preview",
        appearance: "default",
        onClick: togglePreviewMode
    }, isPageInPreviewMode ? formatMessage((0, $aJpl3.default).exitPreview) : formatMessage((0, $aJpl3.default).preview)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($42183aafb9729662$var$ActionButton, {
        appearance: "primary",
        actionSubjectId: "publish",
        isDisabled: publishButtonDisabled,
        onClick: onPublish,
        isLoading: isPublishing
    }, formatMessage((0, $aJpl3.default).publish)))), children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $42183aafb9729662$var$ButtonWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1HSOM.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_18u0xmi2",
            __cmplp.className
        ])
    });
});
const $42183aafb9729662$var$ButtonGroup = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $42183aafb9729662$var$buttonGroup = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'row',
    gap: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $42183aafb9729662$var$ActionButton = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1HSOM.LoadingButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $42183aafb9729662$var$ActionsWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPageInBrandingPreviewMode: isPageInBrandingPreviewMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt46hdp _154iidpf _1ltvidpf _1bsb1osq _kqsw1if8 _16qsfihs _vchhusvi _1pbyaft6",
            __cmplp.isPageInBrandingPreviewMode ? "_bfhkb7r6" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $42183aafb9729662$var$ButtonContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1n261g80 _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $42183aafb9729662$var$PreviewButtonWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1HSOM", function(module, exports) {
$parcel$export(module.exports, "Button", () => $203d5ec24e66fbcf$export$353f5b6fc5456de1);
$parcel$export(module.exports, "IconButton", () => $203d5ec24e66fbcf$export$c25acd513dcc8062);
$parcel$export(module.exports, "LoadingButton", () => $203d5ec24e66fbcf$export$4ec83e90d030b2f3);
$parcel$export(module.exports, "ThemedButton", () => $203d5ec24e66fbcf$export$f67fb575035cc7d0);

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");

var $lszf6 = parcelRequire("lszf6");

var $dM8x1 = parcelRequire("dM8x1");

var $fn6af = parcelRequire("fn6af");

var $21P09 = parcelRequire("21P09");
const $203d5ec24e66fbcf$export$353f5b6fc5456de1 = /*#__PURE__*/ $4fqPo.memo(/*#__PURE__*/ $4fqPo.forwardRef(function Button({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $4fqPo.createElement((0, $lszf6.default), {
        ...props,
        ref: ref
    }));
}));
const $203d5ec24e66fbcf$export$c25acd513dcc8062 = /*#__PURE__*/ $4fqPo.memo(/*#__PURE__*/ $4fqPo.forwardRef(function IconButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $4fqPo.createElement((0, $21P09.default), {
        ...props,
        ref: ref
    }));
}));
const $203d5ec24e66fbcf$export$4ec83e90d030b2f3 = /*#__PURE__*/ $4fqPo.memo(/*#__PURE__*/ $4fqPo.forwardRef(function LoadingButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $4fqPo.createElement((0, $fn6af.default), {
        ...props,
        ref: ref
    }));
}));
const $203d5ec24e66fbcf$export$f67fb575035cc7d0 = /*#__PURE__*/ $4fqPo.memo(/*#__PURE__*/ $4fqPo.forwardRef(function ThemedButton({ actionSubjectId: actionSubjectId, ...props }, ref) {
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: actionSubjectId
        }
    }, /*#__PURE__*/ $4fqPo.createElement((0, $dM8x1.default), {
        ...props,
        ref: ref
    }));
}));

});
parcelRegister("fn6af", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4701c2b6bf1e4e4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lszf6 = parcelRequire("lszf6");

var $6Umy0 = parcelRequire("6Umy0");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $a4701c2b6bf1e4e4$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6Umy0.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$a4701c2b6bf1e4e4$var$LoadingButton.displayName = 'LoadingButton';
var $a4701c2b6bf1e4e4$export$2e2bcd8739ae039 = $a4701c2b6bf1e4e4$var$LoadingButton;

});


parcelRegister("56isT", function(module, exports) {
$parcel$export(module.exports, "default", () => $81a9f76e69cd91f4$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $gBYjj = parcelRequire("gBYjj");

var $efDRU = parcelRequire("efDRU");
parcelRequire("1ZnUa");
var $l3HT9 = parcelRequire("l3HT9");
parcelRequire("bJaAD");
var $cfGXM = parcelRequire("cfGXM");

var $ebpTf = parcelRequire("ebpTf");

var $atmjR = parcelRequire("atmjR");
const $81a9f76e69cd91f4$var$selector = (0, $3yyCx.createSelector)((0, $cfGXM.getFlags), (0, $ebpTf.getEnv), (flags, env)=>({
        flags: flags,
        env: env.environment
    }));
const $81a9f76e69cd91f4$var$mapDispatchToProps = {
    showFeedbackCollector: $l3HT9.showFeedbackCollector,
    dismissFlag: $gBYjj.dismissFlag
};
var $81a9f76e69cd91f4$export$2e2bcd8739ae039 = (0, $bmgw6.default)($81a9f76e69cd91f4$var$selector, $81a9f76e69cd91f4$var$mapDispatchToProps)((0, $efDRU.default)((0, $atmjR.FeedbackCollectorButton)));

});
parcelRegister("atmjR", function(module, exports) {
$parcel$export(module.exports, "FeedbackCollectorButton", () => $474d35272b6c675c$export$b39479f42d974760);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $eQdiM = parcelRequire("eQdiM");

var $4qDHC = parcelRequire("4qDHC");

var $lFMRN = parcelRequire("lFMRN");
const $474d35272b6c675c$export$b39479f42d974760 = ({ intl: intl, env: env, flags: flags, showIcon: showIcon, featureName: featureName, showTypeField: showTypeField, buttonLabel: buttonLabel, analyticsSubjectId: analyticsSubjectId, dismissFlagMessage: dismissFlagMessage, dismissFlag: dismissFlag, showFeedbackCollector: showFeedbackCollector, appearance: appearance = 'subtle', spacing: spacing = 'default', useTheme: useTheme = false, useSideNavButton: useSideNavButton = false })=>{
    const openFeedbackCollector = $4fqPo.useCallback(()=>{
        const showFeedbackCollectorPayload = {
            env: env,
            showTypeField: showTypeField,
            featureName: featureName,
            shouldOpenFeedbackWidget: true
        };
        if (dismissFlagMessage) {
            const successFlag = flags.filter(// @ts-ignore TS(2532) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Object is possibly 'undefined'.
            (flag)=>flag.titleMessage.defaultMessage.localeCompare(dismissFlagMessage.defaultMessage) === 0)[0];
            successFlag && dismissFlag(successFlag.id);
        }
        showFeedbackCollector(showFeedbackCollectorPayload);
    }, [
        env,
        showTypeField,
        featureName,
        dismissFlagMessage,
        flags,
        dismissFlag,
        showFeedbackCollector
    ]);
    if (useSideNavButton) return /*#__PURE__*/ $4fqPo.createElement((0, $lFMRN.default), {
        iconBefore: showIcon ? /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qDHC))), {
            spacing: "spacious",
            label: ""
        }) : undefined,
        onClick: openFeedbackCollector
    }, intl.formatMessage(buttonLabel));
    const ButtonComponent = useTheme ? (0, $eQdiM.ThemedButton) : (0, $1HSOM.Button);
    return /*#__PURE__*/ $4fqPo.createElement(ButtonComponent, {
        iconBefore: showIcon ? /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4qDHC))), {
            spacing: "spacious",
            label: "feedback"
        }) : undefined,
        appearance: appearance,
        onClick: openFeedbackCollector,
        actionSubjectId: analyticsSubjectId,
        spacing: spacing
    }, intl.formatMessage(buttonLabel));
};

});
parcelRegister("eQdiM", function(module, exports) {
$parcel$export(module.exports, "ThemedButton", () => $8a06604f0f7d9642$export$f67fb575035cc7d0);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $1HSOM = parcelRequire("1HSOM");

var $5uMut = parcelRequire("5uMut");

var $2R2ud = parcelRequire("2R2ud");
const $8a06604f0f7d9642$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $el3DQ.withTheme)(({ innerRef: innerRef, ...props })=>/*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.ThemedButton), {
        ...props,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...styles } = currentTheme(themeProps);
            let customTheme;
            if (props.appearance === 'primary' && !props.isDisabled) {
                const backgroundColor = {
                    default: props.theme.color,
                    focus: props.theme.color,
                    hover: (0, $5uMut.lighten)(0.05, props.theme.color),
                    active: (0, $5uMut.darken)(0.05, props.theme.color)
                };
                customTheme = {
                    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                    // Suppressing existing violation. Please fix this.
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    backgroundColor: props.overrideThemeColor || backgroundColor[themeProps.state],
                    color: `${props.theme.readableTextColor} !important` // we need to add !important here for buttons with the href attribute
                };
            }
            if (props.appearance === 'link') {
                const primaryColor = props.overrideThemeColor || props.theme.color;
                const generatedThemeVariations = (0, $2R2ud.generateThemeBranding)(primaryColor);
                customTheme = {
                    color: `${generatedThemeVariations.color900} !important`
                };
            }
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...customTheme
                },
                ...styles
            };
        }
    }));

});

parcelRegister("lFMRN", function(module, exports) {
$parcel$export(module.exports, "default", () => $121689b8f646c9cd$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $aRYa1 = parcelRequire("aRYa1");

var $jTy7p = parcelRequire("jTy7p");
const $121689b8f646c9cd$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g"
};
/**
 * __Button item__
 *
 * A button item renders an item wrapped in a button tag, used primarily when an
 * action does something other than changing routes.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#button-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $121689b8f646c9cd$var$ButtonItem = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $jTy7p.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ $4fqPo.createElement((0, $aRYa1.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            $121689b8f646c9cd$var$styles.root,
            props.isSelected && $121689b8f646c9cd$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $121689b8f646c9cd$export$2e2bcd8739ae039 = $121689b8f646c9cd$var$ButtonItem;

});
parcelRegister("aRYa1", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4ce632353dd8409$export$2e2bcd8739ae039);
/* button-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9XaAY = parcelRequire("9XaAY");

var $lFnTx = parcelRequire("lFnTx");
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $f4ce632353dd8409$var$ButtonItem = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $4fqPo.createElement((0, $lFnTx.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ $4fqPo.createElement("button", {
            "data-testid": testId,
            // This is intentionally placed before the `...rest` spread to prevent overriding existing usages of `aria-current`,
            // which are already being passed to the button element.
            "aria-current": isSelected ? 'true' : undefined,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }, children));
}));
var $f4ce632353dd8409$export$2e2bcd8739ae039 = $f4ce632353dd8409$var$ButtonItem;

});
parcelRegister("lFnTx", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f6a54975cc7e45b$export$2e2bcd8739ae039);
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $Cp2Ub = parcelRequire("Cp2Ub");

var $HFx74 = parcelRequire("HFx74");

var $c70rl = parcelRequire("c70rl");
const $3f6a54975cc7e45b$var$renderTitle = (Component, props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ $4fqPo.createElement(Component, props);
const $3f6a54975cc7e45b$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt751v1w _mizu1v1w _1bg41gjf _1ah31gjf _49pcnqa1 _ra3xnqa1 _1hvwdkaa _128mdkaa _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c8fhey",
    wordBreak: "_1nmz1hna",
    description: "_11c8wadc _syaz1rpy",
    disabledDescription: "_syaz1gmx",
    unselected: "_bfhksm61 _syaz1r31 _10531r31 _irr31dpa _30l31r31 _1di61dpa _9h8h1r31",
    disabled: "_80om13gf _bfhksm61 _syaz1gmx _irr3sm61 _30l31gmx _1di6sm61 _9h8h1gmx",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rusq98m _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l316jw _1di6nozp _9h8h6x5g",
    selectedOld: "_30l36x5g"
};
const $3f6a54975cc7e45b$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
const $3f6a54975cc7e45b$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ const $3f6a54975cc7e45b$var$MenuItemPrimitive = ({ children: children, title: title, description: description, iconAfter: iconAfter, iconBefore: iconBefore, className: UNSAFE_externalClassName, shouldTitleWrap: shouldTitleWrap = false, shouldDescriptionWrap: shouldDescriptionWrap = false, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, testId: testId })=>{
    const spacing = (0, $4fqPo.useContext)((0, $HFx74.SpacingContext));
    const selectionStyle = (0, $4fqPo.useContext)((0, $c70rl.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    const UNSAFE_className = UNSAFE_externalClassName;
    return (()=>{
        return children({
            className: (0, $ltgDR.default)([
                (0, $ltgDR.default)([
                    $3f6a54975cc7e45b$var$styles.root,
                    $3f6a54975cc7e45b$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $3f6a54975cc7e45b$var$styles.unselected,
                    !isDisabled && isSelected && $3f6a54975cc7e45b$var$styles.selected,
                    !isDisabled && isSelected && $3f6a54975cc7e45b$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $3f6a54975cc7e45b$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $3f6a54975cc7e45b$var$styles.selectedNotch,
                    isDisabled && $3f6a54975cc7e45b$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $3f6a54975cc7e45b$var$gapMap[spacing],
                grow: "fill",
                testId: testId && `${testId}--container`
            }, iconBefore && /*#__PURE__*/ $4fqPo.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && `${testId}--icon-before`,
                className: (0, $ltgDR.default)([
                    $3f6a54975cc7e45b$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $4fqPo.createElement("div", {
                className: (0, $ltgDR.default)([
                    $3f6a54975cc7e45b$var$styles.content
                ])
            }, $3f6a54975cc7e45b$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $ltgDR.default)([
                    $3f6a54975cc7e45b$var$styles.title,
                    shouldTitleWrap ? $3f6a54975cc7e45b$var$styles.wordBreak : $3f6a54975cc7e45b$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $4fqPo.createElement("span", {
                "data-item-description": true,
                className: (0, $ltgDR.default)([
                    $3f6a54975cc7e45b$var$styles.description,
                    isDisabled && $3f6a54975cc7e45b$var$styles.disabledDescription,
                    shouldDescriptionWrap && $3f6a54975cc7e45b$var$styles.wordBreak,
                    !shouldDescriptionWrap && $3f6a54975cc7e45b$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $4fqPo.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && `${testId}--icon-after`,
                className: (0, $ltgDR.default)([
                    $3f6a54975cc7e45b$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    })();
};
var $3f6a54975cc7e45b$export$2e2bcd8739ae039 = $3f6a54975cc7e45b$var$MenuItemPrimitive;

});
parcelRegister("HFx74", function(module, exports) {
$parcel$export(module.exports, "SpacingContext", () => $69c6f96ddbb6538d$export$443076ec7ebce042);

var $4fqPo = parcelRequire("4fqPo");

var $c70rl = parcelRequire("c70rl");
const $69c6f96ddbb6538d$export$443076ec7ebce042 = /*#__PURE__*/ (0, $4fqPo.createContext)('cozy');

});
parcelRegister("c70rl", function(module, exports) {
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", () => $a7fa9ae4082cb819$export$9ca534b70725964d);

var $4fqPo = parcelRequire("4fqPo");
const $a7fa9ae4082cb819$export$9ca534b70725964d = /*#__PURE__*/ (0, $4fqPo.createContext)('border');

});




parcelRegister("jTy7p", function(module, exports) {
$parcel$export(module.exports, "useShouldNestedElementRender", () => $7fad72e17d5cacaf$export$37e8646a1abfc3e6);

var $4fqPo = parcelRequire("4fqPo");

var $ehhlD = parcelRequire("ehhlD");
const $7fad72e17d5cacaf$export$37e8646a1abfc3e6 = ()=>{
    const context = (0, $4fqPo.useContext)((0, $ehhlD.NestedContext));
    if (!context) return {
        shouldRender: true
    };
    return {
        shouldRender: context.currentStackId === context.parentId
    };
};

});
parcelRegister("ehhlD", function(module, exports) {
$parcel$export(module.exports, "NestedContext", () => $02ddbb4c0d9d643f$export$46b2c2071c8c725a);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");
const $02ddbb4c0d9d643f$export$46b2c2071c8c725a = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});





parcelRegister("6yHJB", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => (parcelRequire("eOel9")).BrandingPreviewBanner);

var $eOel9 = parcelRequire("eOel9");

});
parcelRegister("eOel9", function(module, exports) {
$parcel$export(module.exports, "BrandingPreviewBanner", () => $b22de3be389cb1ca$export$f6521d01859545a5);
/* branding-preview-banner.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $dQegt = parcelRequire("dQegt");

var $dO3eH = parcelRequire("dO3eH");

var $d3M4d = parcelRequire("d3M4d");
const $b22de3be389cb1ca$export$f6521d01859545a5 = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b22de3be389cb1ca$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b22de3be389cb1ca$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dO3eH))), {
        label: "watch-icon",
        size: "small",
        spacing: "compact"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", null, formatMessage((0, $d3M4d.default).brandingPreviewText)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b22de3be389cb1ca$var$Wrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt412x7 _1e0c1txw _1bah1h6o _syaz15cr",
            __cmplp.className
        ])
    });
});
const $b22de3be389cb1ca$var$IconWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt4otz2 _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dO3eH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0d2747f6d9c7bf3$var$_react = $a0d2747f6d9c7bf3$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $a0d2747f6d9c7bf3$var$_baseNew = $a0d2747f6d9c7bf3$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $a0d2747f6d9c7bf3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0d2747f6d9c7bf3$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $a0d2747f6d9c7bf3$var$_react.default.createElement($a0d2747f6d9c7bf3$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$a0d2747f6d9c7bf3$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $a0d2747f6d9c7bf3$var$_default = module.exports.default = $a0d2747f6d9c7bf3$var$EyeOpenIcon;

});

parcelRegister("d3M4d", function(module, exports) {
$parcel$export(module.exports, "default", () => $94de8d0eb3cb730d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $94de8d0eb3cb730d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    brandingPreviewText: {
        defaultMessage: 'You are currently previewing your global branding changes',
        description: 'Global Branding Preview Banner Text',
        id: 'cv.branding.preview.banner.text.non-final'
    }
});

});



parcelRegister("a4wAe", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a18c7d51cc012ee$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $a4Rr2 = parcelRequire("a4Rr2");

var $6hIdA = parcelRequire("6hIdA");

var $7fscZ = parcelRequire("7fscZ");
var $Cp2Ub = parcelRequire("Cp2Ub");
var $iqiKs = parcelRequire("iqiKs");
var $ekURY = parcelRequire("ekURY");

var $YaIMg = parcelRequire("YaIMg");
const $4a18c7d51cc012ee$var$styles = {
    contentStyles: "_1reo1wug _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $4a18c7d51cc012ee$var$iconColor = {
    connectivity: "_x5v91ft0",
    confirmation: "_x5v94pcx",
    info: "_x5v9qm1h",
    warning: "_x5v9ervl",
    error: "_x5v9s4qr"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $4a18c7d51cc012ee$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $4fqPo.useState)(false);
    const id = (0, $a4Rr2.useId)();
    const toggleDialog = (0, $4fqPo.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $4fqPo.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            $4a18c7d51cc012ee$var$styles.rootStyles,
            $4a18c7d51cc012ee$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $6hIdA.default), {
        onClose: onCloseDialog,
        content: ()=>/*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
                xcss: $4a18c7d51cc012ee$var$styles.contentStyles
            }, children),
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--popup`,
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ $4fqPo.createElement((0, $iqiKs.default), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $4a18c7d51cc012ee$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $4fqPo.createElement((0, $YaIMg.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))))
    }));
};
var $4a18c7d51cc012ee$export$2e2bcd8739ae039 = $4a18c7d51cc012ee$var$InlineMessage;

});
parcelRegister("6hIdA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6ecfc3af6cfbc0b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Popup", () => (parcelRequire("13Iqs")).Popup);

var $13Iqs = parcelRequire("13Iqs");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b6ecfc3af6cfbc0b$export$2e2bcd8739ae039 = (0, $13Iqs.Popup);

});
parcelRegister("13Iqs", function(module, exports) {
$parcel$export(module.exports, "Popup", () => $f10a385a2278d6b2$export$129a32eedafa97c5);
/* popup.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $hh7MV = parcelRequire("hh7MV");

var $1AxDb = parcelRequire("1AxDb");

var $eO5yD = parcelRequire("eO5yD");

var $3H4LK = parcelRequire("3H4LK");

var $7DOtr = parcelRequire("7DOtr");
var $6FozM = parcelRequire("6FozM");

var $7biT4 = parcelRequire("7biT4");

var $7fscZ = parcelRequire("7fscZ");

var $DQeMy = parcelRequire("DQeMy");

var $huyiE = parcelRequire("huyiE");

var $8MqEv = parcelRequire("8MqEv");

var $lEhpP = parcelRequire("lEhpP");

var $7Q0eS = parcelRequire("7Q0eS");
const $f10a385a2278d6b2$var$defaultLayer = 400;
const $f10a385a2278d6b2$var$wrapperStyles = {
    root: "_kqswh2mm"
};
const $f10a385a2278d6b2$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $4fqPo.memo)((props)=>{
    const { xcss: xcss, appearance: inAppearance = 'default', isOpen: isOpen, id: providedId, offset: offset, testId: testId, trigger: trigger, content: content, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: PopupContainer, autoFocus: autoFocus = true, zIndex: zIndex = $f10a385a2278d6b2$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: inShouldRenderToParent = false, shouldFitContainer: shouldFitContainer = false, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport } = props;
    const [triggerRef, setTriggerRef] = (0, $4fqPo.useState)(null);
    const getMergedTriggerRef = (0, $lEhpP.useGetMemoizedMergedTriggerRef)();
    const getMergedTriggerRefNew = (0, $7Q0eS.useGetMemoizedMergedTriggerRefNew)();
    const generatedId = (0, $a4Rr2.useId)();
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $8MqEv.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const id = providedId || generatedId;
    const handleOpenLayerObserverCloseSignal = (0, $4fqPo.useCallback)(()=>{
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    // On the top-layer path, the Popover primitive registers with the observer
    // directly, so we skip registration here to avoid double-counting.
    // Safe conditional hook: feature flags are resolved once at startup.
    if (!(0, $3H4LK.fg)('platform-dst-top-layer')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal,
        type: 'popup'
    });
    // Top-layer rendering path: native Popover API via @atlaskit/top-layer
    if ((0, $3H4LK.fg)('platform-dst-top-layer')) // Pass the original props object to preserve the discriminated union
    // (shouldFitContainer: true vs false) that is lost after destructuring.
    return /*#__PURE__*/ $4fqPo.createElement((0, $huyiE.PopupTopLayer), props);
    // `xcss` is part of Popup's public API and is forwarded as-is to
    // the internal PopperWrapper, which rebuilds the inner styles. We
    // re-bind via a property accessor on a stable object so the
    // design-system css-prop lint rule's identifier-shape check no
    // longer flags it (avoiding a ratcheted lint suppression here).
    const xcssPassthrough = {
        value: xcss
    };
    const renderPopperWrapper = /*#__PURE__*/ $4fqPo.createElement((0, $hh7MV.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $4fqPo.createElement((0, $DQeMy.default), {
        xcss: xcssPassthrough.value,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        zIndex: zIndex,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    const popupContent = /*#__PURE__*/ $4fqPo.createElement((0, $7DOtr.Manager), null, /*#__PURE__*/ $4fqPo.createElement((0, $6FozM.Reference), null, ({ ref: ref })=>{
        return trigger({
            ref: !(0, $3H4LK.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $3H4LK.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), !(0, $3H4LK.fg)('platform-dst-motion-uplift-popup') && isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $4fqPo.createElement((0, $7biT4.default), {
        zIndex: zIndex
    }, renderPopperWrapper)), (0, $3H4LK.fg)('platform-dst-motion-uplift-popup') && /*#__PURE__*/ $4fqPo.createElement((0, $eO5yD.default), {
        appear: true
    }, isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $4fqPo.createElement((0, $7biT4.default), {
        zIndex: zIndex
    }, renderPopperWrapper))));
    if (shouldFitContainer) return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $f10a385a2278d6b2$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("6FozM", function(module, exports) {
$parcel$export(module.exports, "Reference", () => $4da9a2b84711db37$export$e0be378c32fb70a7);

var $4fqPo = parcelRequire("4fqPo");

var $9vpuj = parcelRequire("9vpuj");

var $7DOtr = parcelRequire("7DOtr");

var $5Epqn = parcelRequire("5Epqn");
function $4da9a2b84711db37$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $4fqPo.useContext((0, $7DOtr.ManagerReferenceNodeSetterContext));
    var refHandler = $4fqPo.useCallback(function(node) {
        (0, $5Epqn.setRef)(innerRef, node);
        (0, $5Epqn.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $4fqPo.useEffect(function() {
        return function() {
            return (0, $5Epqn.setRef)(innerRef, null);
        };
    }, []);
    $4fqPo.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($9vpuj)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $5Epqn.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("9vpuj", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $6ebac7b2ffb1ec8e$var$__DEV__ = false;
var $6ebac7b2ffb1ec8e$var$warning = function() {};
if ($6ebac7b2ffb1ec8e$var$__DEV__) {
    var $6ebac7b2ffb1ec8e$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $6ebac7b2ffb1ec8e$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $6ebac7b2ffb1ec8e$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $6ebac7b2ffb1ec8e$var$warning;

});


parcelRegister("DQeMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7a4f519be1a2a8d$export$2e2bcd8739ae039);
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fK4in = parcelRequire("fK4in");

var $6cMex = parcelRequire("6cMex");

var $3H4LK = parcelRequire("3H4LK");

var $iWcAk = parcelRequire("iWcAk");

var $k6OaV = parcelRequire("k6OaV");

var $ciuY2 = parcelRequire("ciuY2");

var $8CD70 = parcelRequire("8CD70");
const $b7a4f519be1a2a8d$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $b7a4f519be1a2a8d$var$fullWidthStyles = null;
const $b7a4f519be1a2a8d$var$wrapperStyles = {
    root: "_2rko12b0 _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs130s _syazi7uo _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36",
    rootT26Shape: "_2rko1mok",
    fullWidth: "_1bsb1osq",
    motion: "_c71l1kw7 _1e0c1txw"
};
const $b7a4f519be1a2a8d$var$scrollableStyles = null;
const $b7a4f519be1a2a8d$var$blanketStyles = null;
const $b7a4f519be1a2a8d$var$modalStyles = null;
const $b7a4f519be1a2a8d$var$focusRingStyles = {
    root: "_mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y"
};
const $b7a4f519be1a2a8d$var$placementMap = {
    top: {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-start': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'top-end': {
        enter: "var(--ds-popup-enter-top, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInTop8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-top, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutTop8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    bottom: {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-start': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'bottom-end': {
        enter: "var(--ds-popup-enter-bottom, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInBottom8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-bottom, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutBottom8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    left: {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-start': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'left-end': {
        enter: "var(--ds-popup-enter-left, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInLeft8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-left, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutLeft8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    right: {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-start': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    },
    'right-end': {
        enter: "var(--ds-popup-enter-right, 150ms cubic-bezier(0.4, 1, 0.6, 1) SlideInRight8px, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
        exit: "var(--ds-popup-exit-right, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) SlideOutRight8px, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
    }
};
const $b7a4f519be1a2a8d$var$DefaultPopupComponent = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, children: children, appearance: appearance, className: className, isReferenceHidden: _isReferenceHidden, shouldFitViewport: shouldFitViewport, ...htmlAttributes } = props;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            $b7a4f519be1a2a8d$var$wrapperStyles.root,
            (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $b7a4f519be1a2a8d$var$wrapperStyles.rootT26Shape,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71l1ei0 _kqsw1n9t _152t1b66",
            (!shouldRenderToParent || shouldFitViewport) && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ]),
        ...htmlAttributes,
        ref: !(0, $3H4LK.fg)('platform-dst-motion-uplift-popup') ? ref : undefined
    }, children);
});
function $b7a4f519be1a2a8d$var$PopperWrapper({ xcss: xcss, isOpen: isOpen, id: id, offset: offset, testId: testId, content: content, fallbackPlacements: fallbackPlacements, onClose: onClose, boundary: boundary, rootBoundary: rootBoundary, shouldFlip: shouldFlip, placement: placement = 'auto', // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
popupComponent: PopupContainer = $b7a4f519be1a2a8d$var$DefaultPopupComponent, autoFocus: autoFocus = true, triggerRef: triggerRef, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldRenderToParent: shouldRenderToParent, shouldFitContainer: shouldFitContainer, shouldDisableFocusLock: shouldDisableFocusLock, shouldReturnFocus: shouldReturnFocus = true, strategy: strategy, role: role, label: label, titleId: titleId, modifiers: modifiers, shouldFitViewport: shouldFitViewport, appearance: appearance = 'default', zIndex: zIndex }) {
    const [popupRef, setPopupRef] = (0, $4fqPo.useState)(null);
    const [initialFocusRef, setInitialFocusRef] = (0, $4fqPo.useState)(null);
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    const shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    const shouldDisableFocusTrap = role !== 'dialog';
    (0, $8CD70.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $ciuY2.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    const { currentLevel: currentLevel } = (0, $fK4in.useLayering)();
    const mergedModifiers = (0, $4fqPo.useMemo)(()=>[
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            },
            ...modifiers || []
        ], [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $4fqPo.createElement((0, $iWcAk.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, ({ ref: ref, style: style, placement: placement, update: update, isReferenceHidden: isReferenceHidden })=>{
        const popupContainer = /*#__PURE__*/ $4fqPo.createElement(PopupContainer, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $ltgDR.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && (0, $3H4LK.fg)('platform-design-system-apply-popup-wrapper-focus') && $b7a4f519be1a2a8d$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: !(0, $3H4LK.fg)('platform-dst-motion-uplift-popup') ? (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setPopupRef(node);
                }
            } : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: (0, $3H4LK.fg)('platform-dst-motion-uplift-popup') || appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            shouldFitViewport: shouldFitViewport,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $4fqPo.createElement((0, $k6OaV.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        const isAutoPlacement = placement === 'auto' || placement === 'auto-start' || placement === 'auto-end';
        const container = /*#__PURE__*/ $4fqPo.createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...style,
                zIndex: zIndex
            },
            // using tabIndex={-1} would cause a bug where Safari focuses
            // first on the browser address bar when using keyboard
            ref: (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                    setPopupRef(node);
                }
            },
            "data-testid": `${testId}--container`,
            className: (0, $ltgDR.default)([
                shouldFitContainer && $b7a4f519be1a2a8d$var$wrapperStyles.fullWidth
            ])
        }, /*#__PURE__*/ $4fqPo.createElement((0, $6cMex.default), {
            enteringAnimation: !isAutoPlacement ? $b7a4f519be1a2a8d$var$placementMap[placement].enter : undefined,
            exitingAnimation: !isAutoPlacement ? $b7a4f519be1a2a8d$var$placementMap[placement].exit : undefined,
            xcss: $b7a4f519be1a2a8d$var$wrapperStyles.motion
        }, popupContainer));
        return /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, (0, $3H4LK.fg)('platform-dst-motion-uplift-popup') ? container : popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $4fqPo.createElement("div", {
            className: (0, $ltgDR.default)([
                "_1r04idpf _kqsw1n9t _bfhk1i5c"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b7a4f519be1a2a8d$export$2e2bcd8739ae039 = $b7a4f519be1a2a8d$var$PopperWrapper;

});
parcelRegister("k6OaV", function(module, exports) {
$parcel$export(module.exports, "RepositionOnUpdate", () => $9b438ab0db4f0f0f$export$51eddd7655ca235a);

var $4fqPo = parcelRequire("4fqPo");
const $9b438ab0db4f0f0f$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $4fqPo.useRef)(true);
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, children);
};

});

parcelRegister("ciuY2", function(module, exports) {
$parcel$export(module.exports, "useCloseManager", () => $ae3a765cfcf47ec0$export$92dae2778ae88f9d);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $c1tmZ = parcelRequire("c1tmZ");

var $fK4in = parcelRequire("fK4in");

var $3H4LK = parcelRequire("3H4LK");

var $afa3p = parcelRequire("afa3p");

var $h6IhL = parcelRequire("h6IhL");
const $ae3a765cfcf47ec0$export$92dae2778ae88f9d = ({ isOpen: isOpen, onClose: onClose, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldUseCaptureOnOutsideClick: capture, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldCloseOnTab: shouldCloseOnTab, shouldRenderToParent: shouldRenderToParent })=>{
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fK4in.useLayering)();
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $h6IhL.useAnimationFrame)();
    const mouseDownTarget = (0, $4fqPo.useRef)(null);
    (0, $4fqPo.useEffect)(()=>{
        if (!isOpen || !popupRef) return 0, $c1tmZ.default;
        const closePopup = (event)=>{
            if (shouldIgnoreCloseEvent !== null && shouldIgnoreCloseEvent !== void 0 && shouldIgnoreCloseEvent(event) && (0, $3H4LK.fg)('cc_blocks_changeboarding')) return;
            if (onClose) {
                let currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    currentLevel = ((_event$target$closest = event.target.closest(`[data-ds--level]`)) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level')) ?? null;
                }
                currentLevel ? onClose(event, Number(currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $3H4LK.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(()=>{
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        const onClick = (event)=>{
            const { target: target } = event;
            const doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            if ((0, $3H4LK.fg)('jsmgrowth_popup_fix')) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    const layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, `[data-ds--level]`);
                    if (layeredElement) {
                        const closeType = layeredElement.getAttribute('data-ds--close--type');
                        if (closeType === 'single' && isLayerDisabled()) // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // Don't close this popup when the click landed inside a higher-level layer
                        // (e.g. a Drawer or Modal that portals to <body>). Such nodes are not DOM
                        // descendants of popupRef, so the contains() checks below would wrongly
                        // classify them as "outside" clicks and close the popup prematurely.
                        return;
                    }
                }
            } else {
                if (isLayerDisabled()) {
                    if (target instanceof HTMLElement) {
                        var _target$closest2;
                        const layeredElement = (_target$closest2 = target.closest) === null || _target$closest2 === void 0 ? void 0 : _target$closest2.call(target, `[data-ds--level]`);
                        if (layeredElement) {
                            const closeType = layeredElement.getAttribute('[data-ds--close--type]');
                            if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                            return;
                            const levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                            if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                            return;
                        }
                    }
                }
            }
            const isClickOnPopup = popupRef && popupRef.contains(target);
            const isClickOnTrigger = triggerRef && triggerRef.contains(target);
            const didClickStartInsidePopup = popupRef && mouseDownTarget.current instanceof Node && popupRef.contains(mouseDownTarget.current);
            if (!isClickOnPopup && !isClickOnTrigger && !didClickStartInsidePopup) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $afa3p.isInteractiveElement)(document.activeElement) && (0, $3H4LK.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        const onMouseDown = (event)=>{
            /**
       * Tracking the target of the mouse down event.
       * This is used to prevent the popup from closing when the user mouses down inside the popup, but then
       * moves the mouse outside the popup before releasing the mouse button.
       *
       * This is a common user interaction - users may have mistakenly clicked on something, or changed their mind,
       * so they try to cancel their click by moving their mouse away from what they had moused down on.
       *
       * Blanket uses the same technique.
       */ mouseDownTarget.current = event.target;
        };
        const onKeyDown = (event)=>{
            const key = event.key;
            if ((key === 'Escape' || key === 'Esc') && (0, $3H4LK.fg)('platform_dst_nested_escape')) {
                var _eventTarget$closest;
                const eventTarget = event.target instanceof HTMLElement ? event.target : null;
                const layeredAncestor = eventTarget === null || eventTarget === void 0 || (_eventTarget$closest = eventTarget.closest) === null || _eventTarget$closest === void 0 ? void 0 : _eventTarget$closest.call(eventTarget, '[data-ds--level]');
                const levelStr = layeredAncestor === null || layeredAncestor === void 0 ? void 0 : layeredAncestor.getAttribute('data-ds--level');
                if (levelStr && Number(levelStr) > currentLevel) return;
            }
            if ((0, $3H4LK.fg)('platform_dst_popup-disable-focuslock')) {
                const { shiftKey: shiftKey } = event;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(()=>{
                        const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(()=>{
                            const isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(()=>{
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc' || shouldCloseOnTab && key === 'Tab') closePopup(event);
            }
        };
        let unbind = (0, $c1tmZ.default);
        if ((0, $3H4LK.fg)('popup-onclose-fix')) setTimeout(()=>{
            unbind = (0, $lMcEJ.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                },
                {
                    type: 'mousedown',
                    listener: onMouseDown
                }
            ]);
        }, 0);
        else unbind = (0, $lMcEJ.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'mousedown',
                listener: onMouseDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        let unbindBlur = (0, $c1tmZ.default);
        unbindBlur = (0, $lMcEJ.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return ()=>{
            if ((0, $3H4LK.fg)('popup-onclose-fix')) setTimeout(()=>{
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        shouldIgnoreCloseEvent,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("afa3p", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $ee82791c30abb71b$export$3dee5e4542c672d9);
const $ee82791c30abb71b$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
const $ee82791c30abb71b$export$3dee5e4542c672d9 = (element)=>{
    if ($ee82791c30abb71b$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("h6IhL", function(module, exports) {
$parcel$export(module.exports, "useAnimationFrame", () => $c0f93af057536b1c$export$641fa9c94086b46e);

var $4fqPo = parcelRequire("4fqPo");
const $c0f93af057536b1c$export$641fa9c94086b46e = ()=>{
    const animationsRef = (0, $4fqPo.useRef)([]);
    const requestFrame = (0, $4fqPo.useCallback)((callback)=>{
        const id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    const cancelFrame = (0, $4fqPo.useCallback)((id)=>{
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter((frameId)=>frameId !== id);
    }, []);
    const cancelAllFrames = (0, $4fqPo.useCallback)(()=>{
        animationsRef.current.forEach((id)=>cancelAnimationFrame(id));
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("8CD70", function(module, exports) {
$parcel$export(module.exports, "useFocusManager", () => $c7a1fcb11d50ab2b$export$10c5169755ce7bd7);

var $4fqPo = parcelRequire("4fqPo");

var $gfb5x = parcelRequire("gfb5x");

var $c1tmZ = parcelRequire("c1tmZ");

var $fK4in = parcelRequire("fK4in");

var $3H4LK = parcelRequire("3H4LK");

var $h6IhL = parcelRequire("h6IhL");
const $c7a1fcb11d50ab2b$export$10c5169755ce7bd7 = ({ initialFocusRef: initialFocusRef, popupRef: popupRef, triggerRef: triggerRef, autoFocus: autoFocus, shouldCloseOnTab: shouldCloseOnTab, shouldDisableFocusTrap: shouldDisableFocusTrap, shouldReturnFocus: shouldReturnFocus, shouldRenderToParent: shouldRenderToParent })=>{
    const { requestFrame: requestFrame, cancelAllFrames: cancelAllFrames } = (0, $h6IhL.useAnimationFrame)();
    const { currentLevel: currentLevel } = (0, $fK4in.useLayering)();
    (0, $4fqPo.useEffect)(()=>{
        if (!popupRef || shouldCloseOnTab) return 0, $c1tmZ.default;
        if (shouldDisableFocusTrap && (0, $3H4LK.fg)('platform_dst_popup-disable-focuslock')) {
            const isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            const popups = document.querySelectorAll(`[data-ds--level="${currentLevel - 1}"]`);
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(()=>{
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $c1tmZ.default;
            }
        }
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: (0, $3H4LK.fg)('platform_dst_nested_escape') ? false : true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($gfb5x)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(()=>{
            focusTrap.activate();
        });
        return ()=>{
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("gfb5x", function(module, exports) {

var $hyBce = parcelRequire("hyBce");
var $bd36a5f7dad8eb83$var$listeningFocusTrap = null;
function $bd36a5f7dad8eb83$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $bd36a5f7dad8eb83$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($bd36a5f7dad8eb83$var$listeningFocusTrap) $bd36a5f7dad8eb83$var$listeningFocusTrap.pause();
        $bd36a5f7dad8eb83$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        $bd36a5f7dad8eb83$var$tryFocus(firstFocusNode());
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $bd36a5f7dad8eb83$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $bd36a5f7dad8eb83$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $bd36a5f7dad8eb83$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $bd36a5f7dad8eb83$var$tryFocus(lastTabbableNode);
            return $bd36a5f7dad8eb83$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $bd36a5f7dad8eb83$var$tryFocus(firstTabbableNode);
        $bd36a5f7dad8eb83$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $hyBce(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $bd36a5f7dad8eb83$var$tryFocus(lastTabbableNode);
        $bd36a5f7dad8eb83$var$tryFocus(firstTabbableNode);
    }
}
function $bd36a5f7dad8eb83$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $bd36a5f7dad8eb83$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $bd36a5f7dad8eb83$var$focusTrap;

});
parcelRegister("hyBce", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $034c6d466ab6db8c$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $034c6d466ab6db8c$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("huyiE", function(module, exports) {
$parcel$export(module.exports, "PopupTopLayer", () => $57d863368548f334$export$e24b8cb659609dee);
/* popup-top-layer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $c1tmZ = parcelRequire("c1tmZ");

var $R17QT = parcelRequire("R17QT");

var $eKwwy = parcelRequire("eKwwy");

var $9VLm8 = parcelRequire("9VLm8");

var $42gPv = parcelRequire("42gPv");
var $1v8Ej = parcelRequire("1v8Ej");

var $ewvhz = parcelRequire("ewvhz");

var $jC6gp = parcelRequire("jC6gp");

var $jJne7 = parcelRequire("jJne7");

var $ldc2k = parcelRequire("ldc2k");

var $1u5dF = parcelRequire("1u5dF");
const $57d863368548f334$var$contentOverflowStyles = {
    fitViewport: "_1reo1wug _18m91wug",
    default: ""
};
const $57d863368548f334$var$animation = (0, $R17QT.popupMotion)();
// Top-layer positioning is handled by CSS Anchor Positioning, not inline styles.
const $57d863368548f334$var$EMPTY_STYLE = {};
const $57d863368548f334$export$e24b8cb659609dee = /*#__PURE__*/ (0, $4fqPo.memo)(function PopupTopLayer({ xcss: xcss, isOpen: isOpen, id: providedId, offset: offsetProp, testId: testId, trigger: trigger, content: content, onClose: onClose, placement: placement = 'auto', fallbackPlacements: _fallbackPlacements, shouldFlip: _shouldFlip = true, popupComponent: PopupContainer, autoFocus: autoFocus = true, shouldFitContainer: shouldFitContainer = false, // top-layer: focus restoration is handled natively by the Popover API. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldReturnFocus: _shouldReturnFocus = true, role: role, label: label, titleId: titleId, // No-op props.
// These props are accepted for API compatibility but have no effect
// in the top-layer path. Each is documented with why it is unnecessary.
// top-layer: stacking managed by browser top layer. zIndex is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
zIndex: _zIndex, // top-layer: always renders in top layer. shouldRenderToParent is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldRenderToParent: _shouldRenderToParent, // top-layer: CSS Anchor Positioning replaces Popper strategy. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
strategy: _strategy, // top-layer: Popper.js modifiers not applicable. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
modifiers: _modifiers, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
boundary: _boundary, // top-layer: viewport is the natural boundary. No-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
rootBoundary: _rootBoundary, // top-layer: native light dismiss replaces capture-phase click handler.
// Could add mousedown drag guard later if needed.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldUseCaptureOnOutsideClick: _shouldUseCaptureOnOutsideClick, // top-layer: focus trapping is role-based. shouldDisableFocusLock is a no-op.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
shouldDisableFocusLock: _shouldDisableFocusLock, shouldFitViewport: // top-layer: shouldFitViewport is handled via overflow on content wrapper.
shouldFitViewport, // top-layer: appearance is accepted but UNSAFE_modal-below-sm is not yet implemented.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
appearance: _appearance }) {
    const triggerRef = (0, $4fqPo.useRef)(null);
    const popoverRef = (0, $4fqPo.useRef)(null);
    const popupContainerRef = (0, $4fqPo.useRef)(null);
    /**
   * Escape hatch for consumer-chosen initial focus target.
   *
   * The legacy `Popup` surfaced `setInitialFocusRef` on the content
   * render prop with a `Dispatch<SetStateAction<HTMLElement | null>>`
   * signature so it could be passed as a React `ref` callback. We
   * keep the same shape for API compatibility, but store the value in
   * a ref rather than component state. Flipping state on every open
   * caused a needless re-render and, more importantly, raced the
   * initial-focus effect below. The ref is read in the open-side
   * effect to override the role-based default focus chosen by
   * `useInitialFocus` inside the underlying `Popover`.
   */ const consumerInitialFocusRef = (0, $4fqPo.useRef)(null);
    const setInitialFocusRef = (0, $4fqPo.useCallback)((value)=>{
        consumerInitialFocusRef.current = typeof value === 'function' ? value(consumerInitialFocusRef.current) : value;
    }, []);
    /**
   * Override the role-based initial focus chosen by the underlying
   * `Popover` (its internal `useInitialFocus`).
   *
   * React flushes child effects before parent effects, so by the time
   * this effect runs the role-based default focus has already moved.
   * We then apply the legacy `Popup` contract:
   *
   * 1. If the consumer wired `setInitialFocusRef`, focus that element
   *    (escape hatch wins).
   * 2. Otherwise, if `autoFocus={false}`, return focus to the trigger.
   *    The `autoFocus` prop on `Popup` opts out of any initial-focus
   *    movement, even for roles like `dialog`.
   *
   * When neither applies the role-based default from the underlying
   * `Popover` stays in place.
   */ (0, $4fqPo.useEffect)(()=>{
        if (!isOpen) {
            /**
       * Clear the consumer-supplied focus target on close so a
       * subsequent open does not silently inherit a stale ref from
       * the previous open cycle. The next open will re-collect a
       * target only if the content render prop re-wires
       * `setInitialFocusRef`.
       */ consumerInitialFocusRef.current = null;
            return;
        }
        const consumerTarget = consumerInitialFocusRef.current;
        if (consumerTarget && consumerTarget.isConnected) {
            consumerTarget.focus();
            return;
        }
        if (!autoFocus) {
            const trigger = triggerRef.current;
            if (trigger && trigger.isConnected) trigger.focus();
        }
    }, [
        isOpen,
        autoFocus
    ]);
    const popoverId = (0, $jJne7.usePopoverId)();
    // Placement conversion.
    // Legacy `offset` is the popper `[along, away]` tuple; `fromLegacyPlacement`
    // folds it into the new `placement.offset` shape so it travels with placement.
    const topLayerPlacement = (0, $4fqPo.useMemo)(()=>(0, $9VLm8.fromLegacyPlacement)({
            legacy: placement,
            offset: offsetProp
        }), [
        placement,
        offsetProp
    ]);
    (0, $jC6gp.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isOpen
    });
    (0, $ldc2k.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'match-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isOpen
    });
    // onClose bridge.
    // Translates top-layer's { reason: TPopoverCloseReason } into legacy
    // onClose(event, currentLevel?) by synthesizing DOM events.
    //
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    // No manual triggerRef.current?.focus() is needed.
    const handleOnClose = (0, $4fqPo.useCallback)(({ reason: reason })=>{
        if (!onClose) return;
        onClose((0, $42gPv.createPopoverCloseEvent)({
            reason: reason
        }));
    }, [
        onClose
    ]);
    // Content render-prop bridge.
    // Legacy content() receives { isOpen, update, setInitialFocusRef, onClose }.
    // update is a no-op because CSS Anchor Positioning self-updates.
    const contentProps = (0, $4fqPo.useMemo)(()=>({
            isOpen: isOpen,
            update: (0, $c1tmZ.default),
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        }), [
        isOpen,
        onClose,
        setInitialFocusRef
    ]);
    // Role mapping.
    // Build the role/label props for Popover.
    // Roles requiring accessible names must have label or labelledBy.
    const roleProps = (0, $1u5dF.useRoleProps)({
        role: role,
        label: label,
        titleId: titleId
    });
    const ariaAttributes = (0, $eKwwy.getAriaForTrigger)({
        role: roleProps.role ?? 'dialog',
        isOpen: isOpen,
        popoverId: popoverId
    });
    // Narrow to ForwardRefExoticComponent so JSX accepts the ref prop.
    // All popupComponent implementations use forwardRef per the PopupComponentProps contract.
    const Container = PopupContainer;
    // Map to legacy TriggerProps.
    const triggerProps = {
        ref: (node)=>{
            triggerRef.current = node;
        },
        'aria-controls': providedId ?? popoverId,
        // `aria-expanded` reflects current open state.
        'aria-expanded': ariaAttributes['aria-expanded'],
        // FUDGE(top-layer-api): cast to the narrow public TriggerProps['aria-haspopup'] union.
        // `getAriaForTrigger` derives `aria-haspopup` from the content's role and types it
        // as the wider WAI-ARIA union (boolean | 'dialog' | 'menu' | 'listbox' | 'tree' | 'grid').
        // We keep the public popup TriggerProps narrow (boolean | 'dialog') because the
        // top-layer API surface is not yet settled. Widening adopter types now would commit
        // us to a public surface we may revisit. The runtime value is unchanged; only the
        // TypeScript-visible type is narrowed at this boundary.
        'aria-haspopup': ariaAttributes['aria-haspopup']
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, trigger(triggerProps), /*#__PURE__*/ $4fqPo.createElement((0, $1v8Ej.Popover), {
        ref: popoverRef,
        id: providedId ?? popoverId,
        ...roleProps,
        isOpen: isOpen,
        onClose: handleOnClose,
        animate: $57d863368548f334$var$animation,
        placement: topLayerPlacement,
        testId: testId && `${testId}--content`
    }, Container ? /*#__PURE__*/ $4fqPo.createElement(Container, {
        ref: popupContainerRef,
        style: $57d863368548f334$var$EMPTY_STYLE,
        id: providedId,
        "data-placement": placement,
        "data-testid": testId,
        tabIndex: autoFocus ? -1 : undefined,
        xcss: xcss
    }, content(contentProps)) : /*#__PURE__*/ $4fqPo.createElement((0, $ewvhz.PopoverSurface), null, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $57d863368548f334$var$contentOverflowStyles[shouldFitViewport ? 'fitViewport' : 'default']
        ])
    }, content(contentProps)))));
});

});
parcelRegister("eKwwy", function(module, exports) {
$parcel$export(module.exports, "getAriaForTrigger", () => $0c7e53d121f019c6$export$9dd1d61dd4d4755);

var $kJTmF = parcelRequire("kJTmF");
function $0c7e53d121f019c6$export$9dd1d61dd4d4755({ role: role, isOpen: isOpen, popoverId: popoverId }) {
    // `roleToAriaHasPopup` accepts a wider role union (including tooltip-family
    // roles that map to `undefined`). `TAriaForTriggerRole` excludes those, so
    // the returned value is guaranteed to be a defined string. The cast narrows
    // the wider helper signature to match.
    const ariaHasPopup = (0, $kJTmF.roleToAriaHasPopup)({
        role: role
    });
    // `aria-controls` is set to `undefined` while closed. The `Popover` /
    // `Dialog` primitives unmount their host element after the exit
    // animation finishes, so a closed-state `aria-controls` would point
    // at a node that is not in the DOM. Returning `undefined` here means
    // JSX spread renders no `aria-controls` attribute on the trigger
    // until the target exists, avoiding the dangling reference while
    // keeping the relationship live whenever it is meaningful.
    return {
        'aria-haspopup': ariaHasPopup,
        'aria-expanded': isOpen,
        'aria-controls': isOpen ? popoverId : undefined
    };
}

});
parcelRegister("kJTmF", function(module, exports) {
$parcel$export(module.exports, "roleToAriaHasPopup", () => $f4128cc6a5c8b629$export$6cb223e9f5abbdb0);
function $f4128cc6a5c8b629$export$6cb223e9f5abbdb0({ role: role }) {
    if (role === 'menu') return 'menu';
    if (role === 'listbox') return 'listbox';
    if (role === 'tree') return 'tree';
    if (role === 'grid') return 'grid';
    if (role === 'dialog' || role === 'alertdialog') return 'dialog';
    // Non-popup roles (tooltip, note, status, alert, log) and the
    // no-role case: omit `aria-haspopup` entirely. React drops the
    // attribute when the value is `undefined`.
    return undefined;
}

});


parcelRegister("42gPv", function(module, exports) {
$parcel$export(module.exports, "createPopoverCloseEvent", () => $f1c8968f7f01f103$export$27b4de066896ac63);
function $f1c8968f7f01f103$export$27b4de066896ac63({ reason: reason }) {
    if (reason === 'escape') return new KeyboardEvent('keydown', {
        key: 'Escape',
        bubbles: true
    });
    if (reason === 'light-dismiss') return new MouseEvent('click', {
        bubbles: true,
        cancelable: true
    });
    return new Event('close');
}

});

parcelRegister("ewvhz", function(module, exports) {
$parcel$export(module.exports, "PopoverSurface", () => $61a4770c8bb38272$export$8b7437164e479115);
/* popover-surface.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $61a4770c8bb38272$var$styles = {
    root: "_2rkofajl _1reo1wug _18m91wug _bfhk1bhr _16qs130s"
};
function $61a4770c8bb38272$export$8b7437164e479115({ children: children }) {
    return /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
        className: (0, $ltgDR.default)([
            $61a4770c8bb38272$var$styles.root
        ]),
        children: children
    });
}

});

parcelRegister("jJne7", function(module, exports) {
$parcel$export(module.exports, "usePopoverId", () => $8ccd7d3ac8dd3d38$export$9198c6c168be2eeb);

var $a4Rr2 = parcelRequire("a4Rr2");
function $8ccd7d3ac8dd3d38$export$9198c6c168be2eeb() {
    // `@atlaskit/ds-lib/use-id` already strips characters that React's
    // `useId` produces (`:`, `«`, `»`) which are invalid in HTML ID
    // tokens. The `popover-` prefix is purely for DOM debug clarity.
    return `popover-${(0, $a4Rr2.useId)()}`;
}

});

parcelRegister("ldc2k", function(module, exports) {
$parcel$export(module.exports, "useWidthFromAnchor", () => $7d08e5c19171fdc5$export$7071d791a7b131ed);

var $4fqPo = parcelRequire("4fqPo");

var $gNpuf = parcelRequire("gNpuf");
function $7d08e5c19171fdc5$export$7071d791a7b131ed({ mode: mode, popoverRef: popoverRef, anchorRef: anchorRef, isOpen: isOpen }) {
    (0, $4fqPo.useLayoutEffect)(()=>{
        const node = popoverRef.current;
        if (!node) return;
        // Feature-detect `anchor-size()` specifically (not just `anchor-name`)
        // so the JS fallback fires correctly in browsers that support anchor
        // positioning but not anchor sizing.
        const supportsAnchorSize = typeof CSS !== 'undefined' && typeof CSS.supports === 'function' && CSS.supports('width', 'anchor-size(width)');
        if (mode === 'match-anchor') {
            // Set an exact width matching the anchor.
            // `min-inline-size` is intentionally NOT set here - it would override the
            // explicit width constraint, allowing the popover to grow past the anchor's width.
            if (supportsAnchorSize) return (0, $gNpuf.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            // JS fallback: one-off read of the anchor's width.
            const anchor = anchorRef.current;
            if (anchor) return (0, $gNpuf.setStyle)({
                element: node,
                styles: [
                    {
                        property: 'width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            return;
        }
        // For 'min-anchor' and 'none', apply `min-inline-size: max-content` to ensure
        // correct position-try-fallbacks behaviour (popover margin box overflows the
        // viewport when its span region is too narrow, rather than wrapping content).
        const minInlineSizeStyle = {
            property: 'min-inline-size',
            value: 'max-content'
        };
        if (mode === 'min-anchor') {
            // Set a minimum width matching the anchor. The popover can grow wider
            // if its content requires it.
            if (supportsAnchorSize) return (0, $gNpuf.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: 'anchor-size(width)'
                    }
                ]
            });
            const anchor = anchorRef.current;
            if (anchor) return (0, $gNpuf.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle,
                    {
                        property: 'min-width',
                        value: `${anchor.offsetWidth}px`
                    }
                ]
            });
            // No anchor available in JS fallback - still apply min-inline-size.
            return (0, $gNpuf.setStyle)({
                element: node,
                styles: [
                    minInlineSizeStyle
                ]
            });
        }
        // 'none' mode: no explicit width, but still apply `min-inline-size: max-content`.
        return (0, $gNpuf.setStyle)({
            element: node,
            styles: [
                minInlineSizeStyle
            ]
        });
    }, [
        mode,
        popoverRef,
        anchorRef,
        isOpen
    ]);
}

});

parcelRegister("1u5dF", function(module, exports) {
$parcel$export(module.exports, "useRoleProps", () => $b9c5bfc0ff3e0d1b$export$892580369e97d8b9);

var $4fqPo = parcelRequire("4fqPo");
function $b9c5bfc0ff3e0d1b$export$892580369e97d8b9({ role: role, label: label, titleId: titleId }) {
    return (0, $4fqPo.useMemo)(()=>{
        if (role === 'dialog' || role === 'alertdialog' || role === 'menu') {
            if (titleId) return {
                role: role,
                labelledBy: titleId
            };
            return {
                role: role,
                label: label ?? 'Popup'
            };
        }
        if (role) return {
            role: role,
            label: label
        };
        // No role supplied: preserve the legacy "no popup semantics" contract.
        return {
            role: undefined,
            label: label
        };
    }, [
        role,
        label,
        titleId
    ]);
}

});


parcelRegister("8MqEv", function(module, exports) {
$parcel$export(module.exports, "usePopupAppearance", () => $1741770d9a3a76cc$export$4065aef1d79a5730);

var $4fqPo = parcelRequire("4fqPo");

var $3Ln0N = parcelRequire("3Ln0N");
function $1741770d9a3a76cc$export$4065aef1d79a5730({ appearance: _appearance, shouldRenderToParent: _shouldRenderToParent }) {
    const mq = (0, $3Ln0N.UNSAFE_useMediaQuery)('below.sm', (e)=>{
        setIsSmallViewport(!!e.matches);
    });
    const [isSmallViewport, setIsSmallViewport] = (0, $4fqPo.useState)(!!(mq !== null && mq !== void 0 && mq.matches));
    const appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    const shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("3Ln0N", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $bb3c784db2acc9d5$export$49e55ae2c03d6045);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $dejGS = parcelRequire("dejGS");
var $bb3c784db2acc9d5$var$_window, $bb3c784db2acc9d5$var$_window$matchMedia, $bb3c784db2acc9d5$var$_window2, $bb3c784db2acc9d5$var$_window2$matchMedia, $bb3c784db2acc9d5$var$_window3, $bb3c784db2acc9d5$var$_window3$matchMedia, $bb3c784db2acc9d5$var$_window4, $bb3c784db2acc9d5$var$_window4$matchMedia, $bb3c784db2acc9d5$var$_window5, $bb3c784db2acc9d5$var$_window5$matchMedia, $bb3c784db2acc9d5$var$_window6, $bb3c784db2acc9d5$var$_window6$matchMedia, $bb3c784db2acc9d5$var$_window7, $bb3c784db2acc9d5$var$_window7$matchMedia, $bb3c784db2acc9d5$var$_window8, $bb3c784db2acc9d5$var$_window8$matchMedia, $bb3c784db2acc9d5$var$_window9, $bb3c784db2acc9d5$var$_window9$matchMedia, $bb3c784db2acc9d5$var$_window0, $bb3c784db2acc9d5$var$_window0$matchMedia, $bb3c784db2acc9d5$var$_window1, $bb3c784db2acc9d5$var$_window1$matchMedia;
const $bb3c784db2acc9d5$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window = window) === null || $bb3c784db2acc9d5$var$_window === void 0 || ($bb3c784db2acc9d5$var$_window$matchMedia = $bb3c784db2acc9d5$var$_window.matchMedia) === null || $bb3c784db2acc9d5$var$_window$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window$matchMedia.call($bb3c784db2acc9d5$var$_window, (0, $dejGS.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window2 = window) === null || $bb3c784db2acc9d5$var$_window2 === void 0 || ($bb3c784db2acc9d5$var$_window2$matchMedia = $bb3c784db2acc9d5$var$_window2.matchMedia) === null || $bb3c784db2acc9d5$var$_window2$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window2$matchMedia.call($bb3c784db2acc9d5$var$_window2, (0, $dejGS.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window3 = window) === null || $bb3c784db2acc9d5$var$_window3 === void 0 || ($bb3c784db2acc9d5$var$_window3$matchMedia = $bb3c784db2acc9d5$var$_window3.matchMedia) === null || $bb3c784db2acc9d5$var$_window3$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window3$matchMedia.call($bb3c784db2acc9d5$var$_window3, (0, $dejGS.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window4 = window) === null || $bb3c784db2acc9d5$var$_window4 === void 0 || ($bb3c784db2acc9d5$var$_window4$matchMedia = $bb3c784db2acc9d5$var$_window4.matchMedia) === null || $bb3c784db2acc9d5$var$_window4$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window4$matchMedia.call($bb3c784db2acc9d5$var$_window4, (0, $dejGS.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window5 = window) === null || $bb3c784db2acc9d5$var$_window5 === void 0 || ($bb3c784db2acc9d5$var$_window5$matchMedia = $bb3c784db2acc9d5$var$_window5.matchMedia) === null || $bb3c784db2acc9d5$var$_window5$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window5$matchMedia.call($bb3c784db2acc9d5$var$_window5, (0, $dejGS.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window6 = window) === null || $bb3c784db2acc9d5$var$_window6 === void 0 || ($bb3c784db2acc9d5$var$_window6$matchMedia = $bb3c784db2acc9d5$var$_window6.matchMedia) === null || $bb3c784db2acc9d5$var$_window6$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window6$matchMedia.call($bb3c784db2acc9d5$var$_window6, (0, $dejGS.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window7 = window) === null || $bb3c784db2acc9d5$var$_window7 === void 0 || ($bb3c784db2acc9d5$var$_window7$matchMedia = $bb3c784db2acc9d5$var$_window7.matchMedia) === null || $bb3c784db2acc9d5$var$_window7$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window7$matchMedia.call($bb3c784db2acc9d5$var$_window7, (0, $dejGS.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window8 = window) === null || $bb3c784db2acc9d5$var$_window8 === void 0 || ($bb3c784db2acc9d5$var$_window8$matchMedia = $bb3c784db2acc9d5$var$_window8.matchMedia) === null || $bb3c784db2acc9d5$var$_window8$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window8$matchMedia.call($bb3c784db2acc9d5$var$_window8, (0, $dejGS.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window9 = window) === null || $bb3c784db2acc9d5$var$_window9 === void 0 || ($bb3c784db2acc9d5$var$_window9$matchMedia = $bb3c784db2acc9d5$var$_window9.matchMedia) === null || $bb3c784db2acc9d5$var$_window9$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window9$matchMedia.call($bb3c784db2acc9d5$var$_window9, (0, $dejGS.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window0 = window) === null || $bb3c784db2acc9d5$var$_window0 === void 0 || ($bb3c784db2acc9d5$var$_window0$matchMedia = $bb3c784db2acc9d5$var$_window0.matchMedia) === null || $bb3c784db2acc9d5$var$_window0$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window0$matchMedia.call($bb3c784db2acc9d5$var$_window0, (0, $dejGS.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($bb3c784db2acc9d5$var$_window1 = window) === null || $bb3c784db2acc9d5$var$_window1 === void 0 || ($bb3c784db2acc9d5$var$_window1$matchMedia = $bb3c784db2acc9d5$var$_window1.matchMedia) === null || $bb3c784db2acc9d5$var$_window1$matchMedia === void 0 ? void 0 : $bb3c784db2acc9d5$var$_window1$matchMedia.call($bb3c784db2acc9d5$var$_window1, (0, $dejGS.media).below.xl.replace('@media ', '').trim())
};
const $bb3c784db2acc9d5$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $4fqPo.useRef)(listener);
    (0, $4fqPo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $bb3c784db2acc9d5$var$queries[queryString];
    (0, $4fqPo.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $lMcEJ.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("dejGS", function(module, exports) {
$parcel$export(module.exports, "media", () => $c0ea2a04826c5389$export$987d49ffe1b0900f);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $c0ea2a04826c5389$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});



parcelRegister("lEhpP", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", () => $65cbefdd04db14d2$export$7cc5c058dd769dff);

var $4fqPo = parcelRequire("4fqPo");

var $jE04u = parcelRequire("jE04u");
const $65cbefdd04db14d2$export$7cc5c058dd769dff = ()=>{
    const [getMemoizedMergedTriggerRef] = (0, $4fqPo.useState)(()=>(0, $jE04u.default)((ref, setTriggerRef, isOpen)=>{
            return (node)=>{
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("7Q0eS", function(module, exports) {
$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", () => $b344751f42ae916f$export$5d3a2de79e07b376);

var $4fqPo = parcelRequire("4fqPo");

var $jE04u = parcelRequire("jE04u");
const $b344751f42ae916f$export$5d3a2de79e07b376 = ()=>{
    const [getMemoizedMergedTriggerRefNew] = (0, $4fqPo.useState)(()=>(0, $jE04u.default)((ref, setTriggerRef)=>{
            return (node)=>{
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        }));
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("YaIMg", function(module, exports) {
$parcel$export(module.exports, "default", () => $0811c5481ae6cbcc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9VRUT = parcelRequire("9VRUT");
const $0811c5481ae6cbcc$var$iconColor = {
    connectivity: "_syaz1ft0",
    confirmation: "_syaz4pcx",
    info: "_syazqm1h",
    warning: "_syazervl",
    error: "_syazs4qr"
};
const $0811c5481ae6cbcc$var$iconWrapperStyles = null;
const $0811c5481ae6cbcc$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $0811c5481ae6cbcc$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $9VRUT.typesMapping);
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $ltgDR.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o",
            $0811c5481ae6cbcc$var$iconColor[appearance],
            isOpen && "_syaz1kum"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        spacing: spacing
    }));
};
var $0811c5481ae6cbcc$export$2e2bcd8739ae039 = $0811c5481ae6cbcc$var$SelectedIcon;

});
parcelRegister("9VRUT", function(module, exports) {
$parcel$export(module.exports, "typesMapping", () => $b6839099ee781e0c$export$4d111645c0b39d5d);

var $geWWn = parcelRequire("geWWn");

var $bNwNQ = parcelRequire("bNwNQ");

var $3RpuA = parcelRequire("3RpuA");

var $klZKM = parcelRequire("klZKM");
const $b6839099ee781e0c$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($klZKM))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($klZKM))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($geWWn))),
        defaultLabel: 'error inline message'
    }
};

});



parcelRegister("aJpl3", function(module, exports) {
$parcel$export(module.exports, "default", () => $495f9fd680892108$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $495f9fd680892108$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    backToSettings: {
        defaultMessage: 'Cancel',
        description: 'Action label for back button in layout builder screen',
        id: 'cv.portal.customization.action.cancel.help.center.settings'
    },
    giveFeedback: {
        defaultMessage: 'Give feedback',
        description: 'The text for give feedback button for layout builder screen',
        id: 'cv.portal.customization.action.give.feedback.help.center.settings'
    },
    publish: {
        defaultMessage: 'Publish',
        description: 'Label for publish button',
        id: 'cv.portal.customization.action.publish.layout.label'
    },
    preview: {
        defaultMessage: 'Preview',
        description: 'Label for preview button',
        id: 'cv.portal.customization.action.preview.layout.label'
    },
    previewMessage: {
        defaultMessage: 'This is a preview of the changes you made to the page layout.',
        description: 'Message displayed when user is previewing layout changes',
        id: 'cv.portal.customization.action.preview.layout.message'
    },
    exitPreview: {
        defaultMessage: 'Back',
        description: 'Label for exit preview button',
        id: 'cv.portal.customization.action.exit.preview.layout.label'
    }
});

});




parcelRegister("3Zmh8", function(module, exports) {
$parcel$export(module.exports, "ViewHomepageResource", () => $b4ad11e5f22a43bd$export$6527e8b974db86ba);
$parcel$export(module.exports, "searchComponentVirtualAgentResource", () => $b4ad11e5f22a43bd$export$b92a87df2da13e74);

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $kCov4 = parcelRequire("kCov4");

var $1W8L4 = parcelRequire("1W8L4");

var $kFddt = parcelRequire("kFddt");

var $6bGmX = parcelRequire("6bGmX");

var $3H4LK = parcelRequire("3H4LK");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $fZppw = parcelRequire("fZppw");

var $iu3aL = parcelRequire("iu3aL");
const $b4ad11e5f22a43bd$export$6527e8b974db86ba = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) ? (0, $fZppw.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $1W8L4.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}) : (0, $fZppw.createRelayResource)({
    type: 'VIEW_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $kCov4.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});
const $b4ad11e5f22a43bd$export$b92a87df2da13e74 = (0, $3H4LK.fg)('helpcenter_search_api_changes') ? (0, $fZppw.createRelayResource)({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, isUserLoggedIn: isUserLoggedIn })=>{
        const isLoggedIn = (0, $6bGmX.default).checkGate('jsd-search-router-login-logic-removal') ? Boolean((0, $6mmHn.getMeta)('ajs-atlassian-account-id')) : isUserLoggedIn;
        return {
            parameters: (0, $iu3aL.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $bG6ob.isVAOnHelpCenterGAEnabled)() && isLoggedIn
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
}) : (0, $fZppw.createRelayResource)({
    type: 'HELP_CENTER_SEARCH_VIRTUAL_AGENT',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, isUserLoggedIn: isUserLoggedIn })=>{
        const isLoggedIn = (0, $6bGmX.default).checkGate('jsd-search-router-login-logic-removal') ? Boolean((0, $6mmHn.getMeta)('ajs-atlassian-account-id')) : isUserLoggedIn;
        return {
            parameters: (0, $kFddt.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $bG6ob.isVAOnHelpCenterGAEnabled)() && isLoggedIn
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("kCov4", function(module, exports) {
$parcel$export(module.exports, "default", () => $6064d5ff987c0a2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<528eb58a638804d653f316e7c8c17c1d>>
 * @relayHash 52150ef5f0d7c47144a859118fbd07a1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14c76222fff73d5c344c4dbaf7f9cbba582818f6f65793980afa0a5fcbe0c9b0
const $6064d5ff987c0a2b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14c76222fff73d5c344c4dbaf7f9cbba582818f6f65793980afa0a5fcbe0c9b0",
            "metadata": {},
            "name": "viewHomepageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6064d5ff987c0a2b$var$node.hash = "42b522e52d1baf895f59577f86f4867c";
var $6064d5ff987c0a2b$export$2e2bcd8739ae039 = $6064d5ff987c0a2b$var$node;

});

parcelRegister("1W8L4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d658a0876299a4b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<458f53226bb2432219d88352bf96afc7>>
 * @relayHash 75bedb2759687e5e6f48516802def4db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 71c95185f2dd2b29635a3a3395cbc06e341c004da231c2e1a9bf5a4c18842223
const $d658a0876299a4b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterAnnouncements",
                "kind": "LinkedField",
                "name": "announcements",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "canEditHomePageAnnouncement"
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v11 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v13 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "kind": "ScalarField",
        "name": "name"
    }, v16 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v17 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v18 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v19 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v14 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v21 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v24 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            v9 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v8 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v9 /*: any*/ 
                                                ]
                                            },
                                            v10 /*: any*/ ,
                                            v7 /*: any*/ 
                                        ],
                                        "type": "QueryError"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewHomepageForCsmQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v14 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v11 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v15 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v10 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v16 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v18 /*: any*/ ,
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v22 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v10 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v15 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v19 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v12 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v11 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v25 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                },
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "71c95185f2dd2b29635a3a3395cbc06e341c004da231c2e1a9bf5a4c18842223",
            "metadata": {},
            "name": "viewHomepageForCsmQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d658a0876299a4b2$var$node.hash = "6e15b917f113b3de216943c357988704";
var $d658a0876299a4b2$export$2e2bcd8739ae039 = $d658a0876299a4b2$var$node;

});

parcelRegister("kFddt", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ad5362d8d558607$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<08e6d21d38f5bb981d852759d101102b>>
 * @relayHash 8f1826e2b5128402f612ebed9cd3ead7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cef3402a4dba2853f871dc4054dde3db258a73cfca1f1548f7ba65bb695e7773
const $6ad5362d8d558607$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v5 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchLoaderVirtualAgentEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchLoaderVirtualAgentEnabledQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "cef3402a4dba2853f871dc4054dde3db258a73cfca1f1548f7ba65bb695e7773",
            "metadata": {},
            "name": "searchLoaderVirtualAgentEnabledQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6ad5362d8d558607$var$node.hash = "e02588c503555d8e364b2427c266c0f8";
var $6ad5362d8d558607$export$2e2bcd8739ae039 = $6ad5362d8d558607$var$node;

});

parcelRegister("fZppw", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $b85878ea3eb0dd72$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $b85878ea3eb0dd72$export$42ca7b248c7aaee);

var $bG6ob = parcelRequire("bG6ob");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");
var $cpzpY = parcelRequire("cpzpY");

var $f2UoR = parcelRequire("f2UoR");

var $4Ysr0 = parcelRequire("4Ysr0");
const $b85878ea3eb0dd72$export$1cc887c62079ea32 = ({ type: type, getQuery: getQuery })=>(0, $f03OU.createResource)({
        type: `RELAY_RESOURCE_TYPE_${type}`,
        getKey: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $bG6ob.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return 'RELAY_RESOURCE_DISABLED';
            }
            //@ts-ignore this key does not really matter since max-age is set to zero. This util is a polyfill and will be done away with once we adopt Relay entry points.
            const request = (0, $f2UoR.getRequest)(parameters);
            const params = request.params;
            const queryId = 'cacheID' in params && params.cacheID != null ? params.cacheID : params.id;
            return `${String(queryId)}${JSON.stringify(variables || {})}`;
        },
        getData: (routerContext, customContext)=>{
            const { variables: variables, parameters: parameters, options: options, isResourceDisabled: isResourceDisabled = false } = getQuery(routerContext, customContext);
            if ((0, $bG6ob.isUiModificationsSupportEnabled)()) {
                if (isResourceDisabled) return Promise.resolve(null);
            }
            const queryReference = (0, $gIeP2.loadQuery)((0, $4Ysr0.getRelayEnvironment)(), parameters, variables || {}, options);
            return Promise.resolve(queryReference);
        },
        maxAge: 0
    });
const $b85878ea3eb0dd72$export$42ca7b248c7aaee = (resource)=>{
    const { refresh: refresh, data: queryReference } = (0, $cpzpY.useResource)(resource);
    return {
        queryReference: queryReference,
        refresh: refresh
    };
};

});

parcelRegister("iu3aL", function(module, exports) {
$parcel$export(module.exports, "default", () => $d348e8c50425dc5a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2cd94073415fdd0bbf4409dae41a9174>>
 * @relayHash 078d7490b0e32c04c06ec9ee114c1d15
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da
const $d348e8c50425dc5a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v5 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "03d8ca3b906e633a6c083ef59059162a50ed2c23e54526b126020d5a455071da",
            "metadata": {},
            "name": "searchLoaderVirtualAgentEnabledV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d348e8c50425dc5a$var$node.hash = "fb84e9b37fd41dce66a7b8b53fc81357";
var $d348e8c50425dc5a$export$2e2bcd8739ae039 = $d348e8c50425dc5a$var$node;

});


parcelRegister("kZndO", function(module, exports) {
$parcel$export(module.exports, "FlexibleEditpageLoader", () => (parcelRequire("1iSZL")).default);

var $1iSZL = parcelRequire("1iSZL");

});
parcelRegister("1iSZL", function(module, exports) {
$parcel$export(module.exports, "default", () => $f92d7d179d6e3e9b$export$2e2bcd8739ae039);
/* flexible-edit-page-loader.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fVQGu = parcelRequire("fVQGu");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("eXmLN");
var $2mGQj = parcelRequire("2mGQj");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $cijxS = parcelRequire("cijxS");
const $f92d7d179d6e3e9b$var$SECTION_HEIGHT = 232;
const $f92d7d179d6e3e9b$var$FlexibleEditpageLoader = ({ showActionBar: showActionBar, removeHeader: removeHeader, sectionCount: sectionCount = 5 })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: "flexible-edit-page-loader"
    }, showActionBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2mGQj.ActionBarStateless), {
        previewButtonDisabled: true,
        publishButtonDisabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $f92d7d179d6e3e9b$var$container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        as: "main",
        xcss: $f92d7d179d6e3e9b$var$skeletonContainerWithSidebar,
        style: {
            marginRight: '340px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $f92d7d179d6e3e9b$var$layoutBuilderWrapper
    }, !removeHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $f92d7d179d6e3e9b$var$headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
        "data-testid": "flexible-hc-header-skeleton",
        height: (0, $5Kpwp.HEADER_HEIGHT),
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), Array(sectionCount).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $f92d7d179d6e3e9b$var$sectionLoader,
            key: `flexibleHCLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            "data-testid": "flexible-hc-section-skeleton",
            height: $f92d7d179d6e3e9b$var$SECTION_HEIGHT,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        as: "aside",
        xcss: $f92d7d179d6e3e9b$var$sidebarWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $f92d7d179d6e3e9b$var$breadcrumbContainer
    }, Array(3).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $f92d7d179d6e3e9b$var$breadCrumbItem,
            key: `breadCrumbLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f92d7d179d6e3e9b$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })))), Array(4).fill(1).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: [
                $f92d7d179d6e3e9b$var$configWrapper,
                index === 0 && $f92d7d179d6e3e9b$var$configWrapper24PxWidth,
                index === 3 && $f92d7d179d6e3e9b$var$configWrapper146PxWidth
            ],
            key: `ConfigPanelLoader_${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f92d7d179d6e3e9b$var$SidePanelLoader, {
            "data-testid": "flexible-hc-section-skeleton",
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))))));
};
const $f92d7d179d6e3e9b$var$skeletonContainerWithSidebar = (0, $2m8U6.xcss)({
    position: 'relative',
    padding: 'space.150',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    backgroundColor: 'elevation.surface.hovered',
    alignItems: 'center',
    overflowY: 'auto',
    height: 'calc(100vh - 56px)'
});
const $f92d7d179d6e3e9b$var$headerContainer = (0, $2m8U6.xcss)({
    width: '100%'
});
const $f92d7d179d6e3e9b$var$container = (0, $2m8U6.xcss)({
    display: 'flex',
    justifyContent: 'stretch',
    flex: '1 1 auto'
});
const $f92d7d179d6e3e9b$var$sidebarWrapper = (0, $2m8U6.xcss)({
    flex: 0,
    position: 'fixed',
    right: 'space.0',
    width: '340px',
    backgroundColor: 'elevation.surface',
    zIndex: 'navigation',
    minHeight: '-webkit-fill-available',
    boxShadow: 'elevation.shadow.overlay',
    height: 'calc(100vh - 56px)'
});
const $f92d7d179d6e3e9b$var$layoutBuilderWrapper = (0, $2m8U6.xcss)({
    position: 'relative',
    width: '100%',
    borderRadius: 'radius.large',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised',
    overflow: 'visible'
});
const $f92d7d179d6e3e9b$var$sectionLoader = (0, $2m8U6.xcss)({
    padding: 'space.400',
    borderRadius: 'radius.large'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f92d7d179d6e3e9b$var$SidePanelLoader = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $fVQGu.LoadingSkeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $f92d7d179d6e3e9b$var$breadcrumbContainer = (0, $2m8U6.xcss)({
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    textAlign: 'left',
    padding: 'space.100',
    borderBottomColor: 'color.border',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid'
});
const $f92d7d179d6e3e9b$var$breadCrumbItem = (0, $2m8U6.xcss)({
    width: '84px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    margin: 'space.100'
});
const $f92d7d179d6e3e9b$var$configWrapper = (0, $2m8U6.xcss)({
    width: '100%',
    height: 'space.250',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: 'space.300',
    paddingBottom: 'space.0'
});
const $f92d7d179d6e3e9b$var$configWrapper24PxWidth = (0, $2m8U6.xcss)({
    width: '72px'
});
const $f92d7d179d6e3e9b$var$configWrapper146PxWidth = (0, $2m8U6.xcss)({
    width: '194px'
});
var $f92d7d179d6e3e9b$export$2e2bcd8739ae039 = $f92d7d179d6e3e9b$var$FlexibleEditpageLoader;

});


parcelRegister("5FSYN", function(module, exports) {
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => (parcelRequire("cBf1I")).anonymousRequestSuccessRoute);
$parcel$export(module.exports, "getRequestCreateRoute", () => (parcelRequire("cBf1I")).getRequestCreateRoute);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => (parcelRequire("cBf1I")).helpCenterRequestFeedbackRoute);
$parcel$export(module.exports, "notFoundErrorRoute", () => (parcelRequire("cBf1I")).notFoundErrorRoute);
$parcel$export(module.exports, "NotFoundPage", () => (parcelRequire("cBf1I")).NotFoundPage);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("a8eAa")).portalReorderRoute);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => (parcelRequire("cBf1I")).RenderCreateAnonymousSuccess);
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => (parcelRequire("cBf1I")).RenderRequestCreateForHubs);
$parcel$export(module.exports, "requestFeedbackRoute", () => (parcelRequire("cBf1I")).requestFeedbackRoute);
$parcel$export(module.exports, "unsubscribeRoute", () => (parcelRequire("cBf1I")).unsubscribeRoute);
$parcel$export(module.exports, "userProfileRoute", () => (parcelRequire("cBf1I")).userProfileRoute);
parcelRequire("cBf1I");

});
parcelRegister("cBf1I", function(module, exports) {
$parcel$export(module.exports, "RenderRequestCreateForHubs", () => $296fb49166875925$export$a877efa523a67c07);
$parcel$export(module.exports, "RenderCreateAnonymousSuccess", () => $296fb49166875925$export$1d1b8e06f48bd2d4);
$parcel$export(module.exports, "userProfileRoute", () => $296fb49166875925$export$abc0ddbfeed2cc26);
$parcel$export(module.exports, "NotFoundPage", () => $296fb49166875925$export$31641b61980e511f);
$parcel$export(module.exports, "getRequestCreateRoute", () => $296fb49166875925$export$b0cc27459efb2ff4);
$parcel$export(module.exports, "anonymousRequestSuccessRoute", () => $296fb49166875925$export$ea05b9ec1342627e);
$parcel$export(module.exports, "requestFeedbackRoute", () => $296fb49166875925$export$a3cf9a79f03e97df);
$parcel$export(module.exports, "helpCenterRequestFeedbackRoute", () => $296fb49166875925$export$45634ebe4da270df);
$parcel$export(module.exports, "unsubscribeRoute", () => $296fb49166875925$export$7dfcaf0a6ac7c9fe);
$parcel$export(module.exports, "notFoundErrorRoute", () => $296fb49166875925$export$5443dabb022476b2);
$parcel$export(module.exports, "portalReorderRoute", () => (parcelRequire("a8eAa")).portalReorderRoute);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $MM3bs = parcelRequire("MM3bs");

var $bG6ob = parcelRequire("bG6ob");

var $cwZKZ = parcelRequire("cwZKZ");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");

var $4F4yI = parcelRequire("4F4yI");

var $9Iutg = parcelRequire("9Iutg");

var $4mNG1 = parcelRequire("4mNG1");

var $cwVD2 = parcelRequire("cwVD2");

var $6hzbh = parcelRequire("6hzbh");

var $e68D0 = parcelRequire("e68D0");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $54jwS = parcelRequire("54jwS");

var $eHkSG = parcelRequire("eHkSG");

var $bp9tj = parcelRequire("bp9tj");

var $5fDAd = parcelRequire("5fDAd");

var $a8eAa = parcelRequire("a8eAa");
const $296fb49166875925$var$portalRoutePrefix = '/portal/:portalId(\\d+)';
const $296fb49166875925$export$4340468daf4d707e = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eHkSG.default), {
        screenName: (0, $748yq.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60sOE.default), {
        screenName: (0, $748yq.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5fDAd.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Iutg.RequestCreatePage), routerState))));
};
const $296fb49166875925$export$a877efa523a67c07 = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eHkSG.default), {
        screenName: (0, $748yq.ScreenName).REQUEST_CREATE,
        screenId: routerState.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60sOE.default), {
        screenName: (0, $748yq.ScreenName).REQUEST_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5fDAd.UiModificationsContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4mNG1.RequestCreatePageForHubs), routerState))));
};
const $296fb49166875925$export$1d1b8e06f48bd2d4 = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eHkSG.default), {
        screenName: (0, $748yq.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60sOE.default), {
        screenName: (0, $748yq.ScreenName).REQUEST_CREATE_ANONYMOUS_SUCCESS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4F4yI.RequestCreateAnonymousSuccess), routeContext)));
};
const $296fb49166875925$export$abc0ddbfeed2cc26 = (0, $bp9tj.createRouteWithLayout)({
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $e68D0.UserProfile)
}, (0, $748yq.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});
const $296fb49166875925$export$31641b61980e511f = ({ createAnalyticsEvent: createAnalyticsEvent })=>{
    createAnalyticsEvent && createAnalyticsEvent({
        action: 'rendered',
        analyticsType: (0, $54jwS.UI_EVENT_TYPE)
    }).fire();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $MM3bs.default), {
        error: {
            status: (0, $748yq.HTTP).NOT_FOUND,
            message: '',
            callToActionUrl: '',
            callToActionText: ''
        }
    }, '');
};
const $296fb49166875925$export$b0cc27459efb2ff4 = ()=>(0, $bp9tj.createRouteWithLayout)({
        name: 'request-create',
        path: '/portal/:portalId/create/:requestTypeId',
        exact: true,
        component: $296fb49166875925$export$4340468daf4d707e,
        resources: (0, $bG6ob.isUiModificationsSupportEnabled)() && !(0, $6bGmX.default).checkGate('ditto_uim_root_query_rest') ? [
            (0, $cwZKZ.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE)
        ] : []
    }, (0, $748yq.ScreenName).REQUEST_CREATE, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });
const $296fb49166875925$export$ea05b9ec1342627e = (0, $bp9tj.createRouteWithLayout)({
    name: 'request-create-anonymous-success',
    path: '/portal/:portalId/create/:requestTypeId/confirm',
    exact: true,
    component: $296fb49166875925$export$1d1b8e06f48bd2d4,
    resources: []
}, (0, $748yq.ScreenName).KNOWLEDGE_CATEGORY, {
    fadeInSearchModal: true
});
const $296fb49166875925$export$a3cf9a79f03e97df = (0, $bp9tj.createRouteWithLayout)({
    name: 'request-feedback',
    path: `${$296fb49166875925$var$portalRoutePrefix}/:requestKey/feedback`,
    exact: true,
    component: (0, $cwVD2.RequestFeedback),
    resources: []
}, (0, $748yq.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $296fb49166875925$export$45634ebe4da270df = (0, $bp9tj.createRouteWithLayout)({
    name: 'request-feedback',
    path: `/user/requests/:requestKey/feedback`,
    exact: true,
    component: (0, $cwVD2.RequestFeedback),
    resources: []
}, (0, $748yq.ScreenName).FEEDBACK, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $296fb49166875925$export$7dfcaf0a6ac7c9fe = (0, $bp9tj.createRouteWithLayout)({
    name: 'unsubscribeRoute',
    path: `${$296fb49166875925$var$portalRoutePrefix}/:requestKey/unsubscribe`,
    exact: true,
    component: (0, $6hzbh.Unsubscribe),
    resources: []
}, (0, $748yq.ScreenName).UNSUBSCRIBE, {
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});
const $296fb49166875925$export$5443dabb022476b2 = (0, $bp9tj.createRouteWithLayout)({
    name: 'not-found-error-page',
    path: '(.*)',
    exact: true,
    component: (0, $apbG6.default)({
        componentName: 'notFoundPage'
    })((0, $as4kh.default)({})($296fb49166875925$export$31641b61980e511f)),
    resources: []
}, (0, $748yq.ScreenName).ERROR_NOT_FOUND, {
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("MM3bs", function(module, exports) {
$parcel$export(module.exports, "withErrorPage", () => $530622c9f1e4d1d1$export$60ebd61e40e72272);
$parcel$export(module.exports, "default", () => $530622c9f1e4d1d1$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $hZeiN = parcelRequire("hZeiN");

var $748yq = parcelRequire("748yq");

var $9Ut8d = parcelRequire("9Ut8d");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $iEknj = parcelRequire("iEknj");

var $93CI1 = parcelRequire("93CI1");

var $efDRU = parcelRequire("efDRU");
parcelRequire("b0F8E");
var $awGaB = parcelRequire("awGaB");

var $2eKV2 = parcelRequire("2eKV2");

var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $eSL4S = parcelRequire("eSL4S");

var $fwSzd = parcelRequire("fwSzd");

var $ebpTf = parcelRequire("ebpTf");

var $loAKY = parcelRequire("loAKY");

var $4FxLV = parcelRequire("4FxLV");
const $530622c9f1e4d1d1$var$isUnhandledError = (statusCode)=>{
    // We want to report on any 5xx errors for the experience tracker.
    return `${statusCode}`.startsWith('5');
};
const $530622c9f1e4d1d1$export$5d56d6fe10c95f05 = ({ error: error, intl: intl })=>{
    let Icon;
    let heading = '';
    let description = '';
    const isCSMHelpCenterEnabled = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    switch(error.status){
        case (0, $748yq.HTTP).FORBIDDEN:
            heading = intl.formatMessage((0, $4FxLV.default).permissionDenied);
            description = intl.formatMessage((0, $4FxLV.default).permissionDeniedMessage);
            Icon = (0, $93CI1.default);
            break;
        case (0, $748yq.HTTP).NOT_FOUND:
            heading = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $4FxLV.default).notFoundV2 : (0, $4FxLV.default).notFound);
            description = intl.formatMessage(isCSMHelpCenterEnabled ? (0, $4FxLV.default).notFoundMessageV2 : (0, $4FxLV.default).notFoundMessage);
            Icon = (0, $iEknj.default);
            break;
        case (0, $748yq.HTTP).OFFLINE:
            heading = intl.formatMessage((0, $4FxLV.default).offlineHeading);
            description = intl.formatMessage((0, $4FxLV.default).offlineMessage);
            Icon = (0, $iEknj.default);
            break;
        case (0, $748yq.HTTP).SERVER:
        default:
            heading = intl.formatMessage((0, $4FxLV.default).genericHeading);
            description = intl.formatMessage((0, $4FxLV.default).genericMessage);
            Icon = (0, $iEknj.default);
            break;
    }
    if (error.message) // If there is a message with the error we override it.
    description = typeof error.message === 'string' ? error.message : intl.formatMessage(error.message);
    if (error.heading) heading = typeof error.heading === 'string' ? error.heading : intl.formatMessage(error.heading);
    return {
        heading: heading,
        description: description,
        Icon: Icon
    };
};
const $530622c9f1e4d1d1$export$c120a0e80fd44ca6 = ({ error: error, children: children, intl: intl, config: config })=>{
    if (!!error) {
        const { Icon: Icon, heading: heading, description: description } = $530622c9f1e4d1d1$export$5d56d6fe10c95f05({
            error: error,
            intl: intl
        });
        // failure logging to be avoided only if the traceId is absent and the config is set to exclude empty traceId logs
        const shouldLogFailure = error.traceId ? true : !(config !== null && config !== void 0 && config.isEmptyTraceIdLogExcluded);
        const shouldRenderExperienceFailure = $530622c9f1e4d1d1$var$isUnhandledError(error.status) && shouldLogFailure;
        return /*#__PURE__*/ $4fqPo.createElement((0, $9Ut8d.default), {
            title: description
        }, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.PaperContent), null, /*#__PURE__*/ $4fqPo.createElement($530622c9f1e4d1d1$var$Container, null, /*#__PURE__*/ $4fqPo.createElement($530622c9f1e4d1d1$var$IconContainer, null, /*#__PURE__*/ $4fqPo.createElement(Icon, null)), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
                space: "space.100",
                alignInline: "center",
                xcss: $530622c9f1e4d1d1$var$errorMessageContainerStyle
            }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                size: "medium",
                as: "div"
            }, heading), /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), {
                align: "center"
            }, description))
        }, /*#__PURE__*/ $4fqPo.createElement($530622c9f1e4d1d1$export$f69c19e57285b83a, null, heading), /*#__PURE__*/ $4fqPo.createElement($530622c9f1e4d1d1$var$Description, null, description)), error.status !== (0, $748yq.HTTP).OFFLINE && /*#__PURE__*/ $4fqPo.createElement((0, $loAKY.ErrorLink), {
            callToActionUrl: error.callToActionUrl
        }, error.callToActionText), shouldRenderExperienceFailure && /*#__PURE__*/ $4fqPo.createElement((0, $hZeiN.ExperienceFailure), {
            location: "error-page",
            errorMessage: description,
            traceId: error.traceId,
            responseHeaders: error.responseHeaders,
            status: error.status
        }))));
    }
    return $4fqPo.Children.only(children);
};
const $530622c9f1e4d1d1$var$IntlErrorPage = (0, $efDRU.default)($530622c9f1e4d1d1$export$c120a0e80fd44ca6);
const $530622c9f1e4d1d1$export$60ebd61e40e72272 = (WrappedComponent, config)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $4fqPo.createElement($530622c9f1e4d1d1$var$IntlErrorPage, {
            ...props,
            error: props.error,
            config: config
        }, /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props));
var $530622c9f1e4d1d1$export$2e2bcd8739ae039 = $530622c9f1e4d1d1$var$IntlErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $530622c9f1e4d1d1$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-a8w8t7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $530622c9f1e4d1d1$var$IconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-a8w8t7-1"
})`width:${$bpWyP.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $530622c9f1e4d1d1$var$Description = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-a8w8t7-2"
})`${$4W9tu.regular};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
const $530622c9f1e4d1d1$export$f69c19e57285b83a = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-a8w8t7-3"
})`${$4W9tu.h600};max-width:100%;margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
const $530622c9f1e4d1d1$var$errorMessageContainerStyle = (0, $2m8U6.xcss)({
    marginBlockEnd: 'space.100'
});

});
parcelRegister("hZeiN", function(module, exports) {
$parcel$export(module.exports, "withExperienceNotifier", () => $73bd6cb0fd6c0b52$export$43b8ee6172152b23);
$parcel$export(module.exports, "ExperienceSuccess", () => $73bd6cb0fd6c0b52$export$4962f3898bd5c829);
$parcel$export(module.exports, "ExperienceFailure", () => $73bd6cb0fd6c0b52$export$eed1d73ebdd8c7ab);

var $4fqPo = parcelRequire("4fqPo");

var $jERmM = parcelRequire("jERmM");
// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
// eslint-disable-next-line react/display-name
const $73bd6cb0fd6c0b52$var$createExperienceNotifier = (type)=>(props)=>/*#__PURE__*/ $4fqPo.createElement((0, $jERmM.default), {
            ...props,
            type: type
        });
const $73bd6cb0fd6c0b52$export$43b8ee6172152b23 = (experienceLocation)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $4fqPo.createElement((0, $jERmM.default), {
                type: "CAN_SUCCEED_OR_FAIL",
                location: experienceLocation
            }, (notify)=>/*#__PURE__*/ $4fqPo.createElement(Component, {
                    ...props,
                    ...notify
                }));
        };
const $73bd6cb0fd6c0b52$export$4962f3898bd5c829 = $73bd6cb0fd6c0b52$var$createExperienceNotifier('IMMEDIATE_SUCCESS');
const $73bd6cb0fd6c0b52$export$eed1d73ebdd8c7ab = $73bd6cb0fd6c0b52$var$createExperienceNotifier('IMMEDIATE_FAILURE');

});
parcelRegister("jERmM", function(module, exports) {
$parcel$export(module.exports, "default", () => $42450b2ba819bae0$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $l5RAG = parcelRequire("l5RAG");

var $f1dzi = parcelRequire("f1dzi");
class $42450b2ba819bae0$export$2e2bcd8739ae039 extends $4fqPo.Component {
    static #_ = this.contextType = (0, $f1dzi.ExperienceContext);
    componentDidMount() {
        const { type: type, location: location, errorMessage: errorMessage, traceId: traceId, responseHeaders: responseHeaders, status: status } = this.props;
        if (type !== 'CAN_FAIL') this.context.onPending();
        if (type === 'IMMEDIATE_FAILURE') this.onFailure(errorMessage || location, traceId, responseHeaders, status);
        else if (type === 'IMMEDIATE_SUCCESS') this.onSuccess();
    // Otherwise we wait for the child to either throw an error or call `onExperienceSuccess`.
    }
    componentWillUnmount() {
        // If this component is being unmounted and still hasn't notified - assume it was successful.
        if (this.props.type !== 'CAN_FAIL') this.onSuccess();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
        const isIE7Browser = (0, $3H4LK.fg)('filter_ie7_for_request_create_errors') && (0, $l5RAG.isIE7)();
        if (!isIE7Browser) this.context.onFailure({
            errorMessage: message,
            errorName: name,
            traceId: this.props.traceId,
            unhandledError: true,
            errorLocation: this.props.location
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    render() {
        const { children: children } = this.props;
        const markup = typeof children === 'function' ? children({
            notifySuccess: this.onSuccess,
            notifyFailure: this.onFailure
        }) : children;
        return markup || null;
    }
    constructor(...args){
        super(...args), this.hasSignalledSuccess = false, this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess) {
                this.hasSignalledSuccess = true;
                this.context.onSuccess();
            }
        }, this.onFailure = (errorMessage, traceId, responseHeaders, status)=>{
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
            const isIE7Browser = (0, $3H4LK.fg)('filter_ie7_for_request_create_errors') && (0, $l5RAG.isIE7)();
            if (!isIE7Browser) this.context.onFailure({
                errorMessage: errorMessage,
                traceId: traceId,
                responseHeaders: responseHeaders,
                status: status,
                errorName: 'NotifyFailure',
                unhandledError: false,
                errorLocation: this.props.location
            });
        };
    }
}
const $42450b2ba819bae0$export$eed1d73ebdd8c7ab = ({ experience: experience, config: config })=>{
    $4fqPo.useEffect(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        experience.failure(config);
    }, [
        experience,
        config
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null);
};

});
parcelRegister("f1dzi", function(module, exports) {
$parcel$export(module.exports, "ExperienceContext", () => $b87a23e4e85a94f9$export$fb99266658f5da06);
$parcel$export(module.exports, "default", () => $b87a23e4e85a94f9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $63sfu = parcelRequire("63sfu");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $eSL4S = parcelRequire("eSL4S");

var $ba0cl = parcelRequire("ba0cl");

var $ebpTf = parcelRequire("ebpTf");
const $b87a23e4e85a94f9$export$fb99266658f5da06 = /*#__PURE__*/ $4fqPo.createContext({
    onFailure: (0, $63sfu.noop),
    onPending: (0, $63sfu.noop),
    onSuccess: (0, $63sfu.noop)
});
class $b87a23e4e85a94f9$export$c90b54e658fc4d7c extends $4fqPo.Component {
    static #_ = this.checkNotifiersInterval = 1000;
    static #_2 = this.defaultProps = {
        isExperienceReady: true
    };
    componentDidMount() {
        this.checkAndStartTimer();
        this.trackExperience('taskStart');
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isExperienceReady && this.props.isExperienceReady) this.checkAndStartTimer();
    }
    checkAndStartTimer() {
        if (this.notifierHasBegunPending && this.props.isExperienceReady) this.startTimer();
    }
    componentDidCatch(error) {
        const { name: name, message: message } = error;
        // This catches any errors that bubble up to the Provider that
        // may not be caught by any ExperienceTrackers
        this.trackFailure({
            errorMessage: message,
            errorName: name,
            unhandledError: true,
            errorLocation: this.props.name
        });
        // We're deliberately rethrow the error here because we don't want to interfere with
        // any error handling the container app may have in place.
        throw error;
    }
    startTimer() {
        clearTimeout(this.timerId);
        this.timerId = window.setTimeout(()=>{
            if (this.pendingCount === 0) this.trackSuccess();
        }, $b87a23e4e85a94f9$export$c90b54e658fc4d7c.checkNotifiersInterval);
    }
    trackSuccess() {
        this.trackExperience('taskSuccess');
    }
    trackFailure(failure) {
        this.trackExperience('taskFail', failure);
    }
    trackExperience(action, errorFailure) {
        if (this.hasTrackedExperience) // Ignore any follow up tracking fired after the experience has been tracked.
        return;
        const { createAnalyticsEvent: createAnalyticsEvent, experienceId: experienceId } = this.props;
        let { name: name } = this.props;
        // Adding the check to avoid firing Premium SLA event for CSM help center
        // This check will be removed once CSM is migrated to SSR
        if ((0, $bG6ob.isCsmPremiumSlaDisabledFlagEnabled)() && (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) switch(name){
            case (0, $748yq.ExperienceName).HELP_CENTER:
                name = (0, $748yq.ExperienceName).HELP_CENTER_CSM;
                break;
            case (0, $748yq.ExperienceName).REQUEST_CREATE:
                name = (0, $748yq.ExperienceName).REQUEST_CREATE_CSM;
                break;
            default:
                return;
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const event = createAnalyticsEvent({});
        switch(action){
            case 'taskFail':
                (0, $ba0cl.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    error: errorFailure
                }, event);
                break;
            case 'taskSuccess':
                (0, $ba0cl.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
            case 'taskStart':
            default:
                (0, $ba0cl.default)({
                    action: action,
                    name: name,
                    experienceId: experienceId
                }, event);
                break;
        }
        if (action !== 'taskStart') this.hasTrackedExperience = true;
    }
    render() {
        return /*#__PURE__*/ $4fqPo.createElement($b87a23e4e85a94f9$export$fb99266658f5da06.Provider, {
            value: {
                onPending: this.onPending,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), /**
   * This value is needed so the timer doesn't start until
   * at least one notifier has been turned on.
   */ this.notifierHasBegunPending = false, this.timerId = undefined, this.pendingCount = 0, this.hasTrackedExperience = false, /**
   * Called when a descendant experience notifier is waiting to see if it is successful or not.
   */ this.onPending = ()=>{
            this.pendingCount += 1;
            this.notifierHasBegunPending = true;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier successfully loaded.
   * ALL descendant experience notifiers need to successfully load for a SUCCESS
   * to be considered.
   */ this.onSuccess = ()=>{
            this.pendingCount -= 1;
            this.checkAndStartTimer();
        }, /**
   * Called when a descendant experience notifier failed to load.
   * This caused the entire experience to FAIL.
   */ this.onFailure = (failure)=>{
            // We need to track failure *immediately*, otherwise this component may
            // be unmounted and we'd miss our chance.
            this.trackFailure(failure);
        };
    }
}
var // Use "componentName" as a drop-in replacement for "actionSubject"
// analytics-web-react getEvent() currently only supports TRACK events
// setting it directly.
$b87a23e4e85a94f9$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    componentName: 'ui'
})((0, $as4kh.default)()($b87a23e4e85a94f9$export$c90b54e658fc4d7c));

});
parcelRegister("ba0cl", function(module, exports) {
$parcel$export(module.exports, "default", () => $40fb1b37eb5d1aa0$export$2e2bcd8739ae039);

var $bG6ob = parcelRequire("bG6ob");

var $3IJ1B = parcelRequire("3IJ1B");
var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");
const $40fb1b37eb5d1aa0$var$createAnalyticsPayload = ({ name: name, action: action, experienceId: experienceId, ...rest })=>{
    const error = 'error' in rest ? rest.error : undefined;
    return {
        action: action,
        task: name,
        taskId: experienceId,
        reason: error && error.errorMessage,
        ...error
    };
};
var $40fb1b37eb5d1aa0$export$2e2bcd8739ae039 = (experienceDescription, analyticsEvent)=>{
    const payload = $40fb1b37eb5d1aa0$var$createAnalyticsPayload(experienceDescription);
    if ((0, $bG6ob.isMigrateToAnalyticsBridgeEnabled)()) {
        const { action: action, ...rest } = payload;
        (0, $3IJ1B.fireAnalytics)(analyticsEvent, (0, $gHT3x.OPERATIONAL_EVENT_TYPE), {
            action: action,
            attributes: rest
        });
    } else {
        analyticsEvent.update(payload);
        (0, $54jwS.fireAnalyticsEvent)({
            payload: payload,
            analyticsEvent: analyticsEvent,
            type: (0, $54jwS.EventTypes).OPERATIONAL
        });
    }
};

});
parcelRegister("3IJ1B", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $e4c8ea452c7688a1$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $e4c8ea452c7688a1$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $e4c8ea452c7688a1$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $e4c8ea452c7688a1$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $e4c8ea452c7688a1$export$6f46fb37ad7d962b);

var $dZ56i = parcelRequire("dZ56i");

var $gHT3x = parcelRequire("gHT3x");

var $bfhHP = parcelRequire("bfhHP");
const $e4c8ea452c7688a1$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $gHT3x.ANALYTICS_BRIDGE_CHANNEL));
};
const $e4c8ea452c7688a1$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dZ56i)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $e4c8ea452c7688a1$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bfhHP.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $e4c8ea452c7688a1$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $e4c8ea452c7688a1$export$34ac71ce24cddec2(event, (0, $gHT3x.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $e4c8ea452c7688a1$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bfhHP.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $e4c8ea452c7688a1$export$34ac71ce24cddec2(event, (0, $gHT3x.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $e4c8ea452c7688a1$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bfhHP.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $e4c8ea452c7688a1$export$34ac71ce24cddec2(event, (0, $gHT3x.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $e4c8ea452c7688a1$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $bfhHP.getImperativeAnalyticsDataFromArguments)(rest);
    $e4c8ea452c7688a1$export$34ac71ce24cddec2(event, (0, $gHT3x.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};

});
parcelRegister("bfhHP", function(module, exports) {
$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $331b9530fc0875e7$export$e6baab532ef8c6bf);
const $331b9530fc0875e7$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $331b9530fc0875e7$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $331b9530fc0875e7$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $331b9530fc0875e7$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $331b9530fc0875e7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $331b9530fc0875e7$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $331b9530fc0875e7$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $331b9530fc0875e7$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $331b9530fc0875e7$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $331b9530fc0875e7$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $331b9530fc0875e7$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $331b9530fc0875e7$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});






parcelRegister("9Ut8d", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bbf4c44f07725bb$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3nx4r = parcelRequire("3nx4r");

var $efDRU = parcelRequire("efDRU");

var $bZjnM = parcelRequire("bZjnM");
const $9bbf4c44f07725bb$export$dd5ad0b65cf665da = ({ children: children, title: title, intl: intl, ignoreBaseTitle: ignoreBaseTitle })=>{
    let documentTitle = intl.formatMessage((0, $bZjnM.default).defaultTitle);
    if (ignoreBaseTitle && title) documentTitle = title;
    else if (title) documentTitle = intl.formatMessage((0, $bZjnM.default).baseTitle, {
        title: title
    });
    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nx4r))), {
        title: documentTitle
    }, children);
};
var $9bbf4c44f07725bb$export$2e2bcd8739ae039 = (0, $efDRU.default)($9bbf4c44f07725bb$export$dd5ad0b65cf665da);

});
parcelRegister("3nx4r", function(module, exports) {
'use strict';

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $aqvE7 = parcelRequire("aqvE7");
function $275d2c39d6895743$var$reducePropsToState(propsList) {
    var innermostProps = propsList[propsList.length - 1];
    if (innermostProps) return innermostProps.title;
}
function $275d2c39d6895743$var$handleStateChangeOnClient(title) {
    var nextTitle = title || '';
    if (nextTitle !== document.title) document.title = nextTitle;
}
function $275d2c39d6895743$var$DocumentTitle() {}
$275d2c39d6895743$var$DocumentTitle.prototype = Object.create($4fqPo.Component.prototype);
$275d2c39d6895743$var$DocumentTitle.displayName = 'DocumentTitle';
$275d2c39d6895743$var$DocumentTitle.propTypes = {
    title: $4S7MC.string.isRequired
};
$275d2c39d6895743$var$DocumentTitle.prototype.render = function() {
    if (this.props.children) return $4fqPo.Children.only(this.props.children);
    else return null;
};
module.exports = $aqvE7($275d2c39d6895743$var$reducePropsToState, $275d2c39d6895743$var$handleStateChangeOnClient)($275d2c39d6895743$var$DocumentTitle);

});
parcelRegister("aqvE7", function(module, exports) {
'use strict';
function $7974e15a4c928256$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $4fqPo = parcelRequire("4fqPo");
var $7974e15a4c928256$var$React__default = $7974e15a4c928256$var$_interopDefault($4fqPo);

var $7974e15a4c928256$var$shallowEqual = $7974e15a4c928256$var$_interopDefault((parcelRequire("lP4L9")));
function $7974e15a4c928256$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7974e15a4c928256$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $7974e15a4c928256$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $7974e15a4c928256$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $7974e15a4c928256$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$7974e15a4c928256$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $7974e15a4c928256$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($4fqPo.Component);
        $7974e15a4c928256$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $7974e15a4c928256$var$_defineProperty(SideEffect, "canUseDOM", $7974e15a4c928256$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $7974e15a4c928256$var$withSideEffect;

});
parcelRegister("lP4L9", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("bZjnM", function(module, exports) {
$parcel$export(module.exports, "default", () => $4afa8bb80f049b97$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $4afa8bb80f049b97$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    defaultTitle: {
        defaultMessage: 'Jira Service Management',
        description: 'Default document page title',
        id: 'cv.jsm.document.page.title.default'
    },
    baseTitle: {
        defaultMessage: '{title} - Jira Service Management',
        description: 'Base document page title appended to custom document titles.',
        id: 'cv.jsm.document.page.title.base'
    }
});

});


parcelRegister("iEknj", function(module, exports) {
$parcel$export(module.exports, "default", () => $8599e3dea0684806$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $8599e3dea0684806$var$SvgErrorreact = (props)=>/*#__PURE__*/ $4fqPo.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 163.28 218",
        ...props
    }, /*#__PURE__*/ $4fqPo.createElement("defs", null, /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: "error_react_svg__linear-gradient",
        x1: 133.86,
        y1: 136.43,
        x2: -2.79,
        y2: 200.15,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0,
        stopColor: "#ffd740"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 1,
        stopColor: "#ffab00"
    })), /*#__PURE__*/ $4fqPo.createElement("clipPath", {
        id: "error_react_svg__clip-path"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "error_react_svg___Polygon_",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    })), /*#__PURE__*/ $4fqPo.createElement("style", null, ".error_react_svg__cls-1{fill:url(#error_react_svg__linear-gradient)}.error_react_svg__cls-2{fill:#253858}.error_react_svg__cls-6{fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:#5e6c84}")), /*#__PURE__*/ $4fqPo.createElement("g", {
        id: "error_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        id: "error_react_svg__Software"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "error_react_svg___Polygon_2",
        "data-name": "<Polygon>",
        className: "error_react_svg__cls-1",
        d: "m94.78 80.16 66.44 115.08A15.17 15.17 0 0 1 148.08 218H15.2a15.17 15.17 0 0 1-13.14-22.76L68.5 80.16a15.17 15.17 0 0 1 26.28 0Z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "error_react_svg__cls-2",
        d: "m87.22 163.71 2.88-44.35a9.18 9.18 0 0 0-9.16-9.78 9.18 9.18 0 0 0-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89 6.3 6.3 0 0 0 6.28-5.89ZM71.38 187.25a9.53 9.53 0 0 0 10.39 9.58 9.68 9.68 0 0 0-.9-19.32 9.64 9.64 0 0 0-9.49 9.74Z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M91.7 27.17 84.29.45A.61.61 0 0 0 83.1.5l-4.66 25.1-5.8-1.08a.61.61 0 0 0-.7.76L79.35 52a.61.61 0 0 0 1.19 0l4.66-25.1 5.8 1.03a.61.61 0 0 0 .7-.76Z",
        style: {
            fill: "#ffc400"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "m65.12 41.81-10.88-8.55a.27.27 0 0 0-.41.33L59.36 45l-2.66 1.31a.27.27 0 0 0 0 .45l10.87 8.55a.27.27 0 0 0 .41-.33l-5.57-11.43 2.66-1.29a.27.27 0 0 0 .05-.45Z",
        style: {
            fill: "#ffab00"
        }
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M115.15 36.6c-1.17 1.59-11-5.6-12.16-4s8.66 8.79 7.5 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39-11-5.6-12.17-4 8.66 8.79 7.49 10.39",
        style: {
            stroke: "#344563",
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            strokeWidth: 2
        }
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "error_react_svg__cls-6",
        d: "M119.92 64.19c-1.46 1.33-7.05-4.78-8.51-3.44s4.13 7.45 2.67 8.78-7.05-4.78-8.51-3.44c-.68.62.16 2.27 1.11 4M44.8 64c1.82.77 5-6.87 6.86-6.1s-1.39 8.4.43 9.17 5-6.87 6.86-6.1c.85.36.61 2.19.29 4.13"
    }))));
var $8599e3dea0684806$export$2e2bcd8739ae039 = $8599e3dea0684806$var$SvgErrorreact;

});

parcelRegister("93CI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab102afe034d5d2f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $ab102afe034d5d2f$var$SvgLockreact = (props)=>/*#__PURE__*/ $4fqPo.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 168.837 221.487",
        ...props
    }, /*#__PURE__*/ $4fqPo.createElement("defs", null, /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: "lock_react_svg__linear-gradient",
        x1: 49.42,
        y1: 59.767,
        x2: 122.662,
        y2: 59.767,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0,
        stopColor: "#0065ff"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0.219,
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 0.6,
        stopColor: "#2780ff"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: 1,
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ $4fqPo.createElement("style", null, ".lock_react_svg__cls-2{fill:#de350b}.lock_react_svg__cls-3{fill:#ff5630}")), /*#__PURE__*/ $4fqPo.createElement("g", {
        id: "lock_react_svg__Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        id: "lock_react_svg__Objects"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M122.662 119.535H49.42V36.62a36.621 36.621 0 0 1 73.242 0zm-61.242-12h49.242V36.62a24.621 24.621 0 0 0-49.242 0z",
        fill: "url(#lock_react_svg__linear-gradient)"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "lock_react_svg__cls-2",
        d: "M160.324 111.17a65.496 65.496 0 0 1-5.657-46.117l.002-.009a5.053 5.053 0 0 0-4.904-6.273H19.072a5.053 5.053 0 0 0-4.904 6.273l.002.006a66.149 66.149 0 0 1-5.785 46.367 75.49 75.49 0 0 0 65.21 110.047h17.866a75.491 75.491 0 0 0 68.863-110.294z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "m154.667 65.053.002-.009a5.053 5.053 0 0 0-4.904-6.273H36.94a5.053 5.053 0 0 0-4.904 6.273l.001.006a66.15 66.15 0 0 1-5.784 46.367 75.485 75.485 0 1 0 134.072-.247 65.496 65.496 0 0 1-5.657-46.117z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "lock_react_svg___Path_",
        "data-name": "<Path>",
        d: "M93.352 213.6q-.845 0-1.697-.02a67.603 67.603 0 0 1-58.396-98.539A74.376 74.376 0 0 0 40.47 66.66h105.762a73.488 73.488 0 0 0 7.098 48.16 67.6 67.6 0 0 1-59.975 98.78z",
        fill: "#ff7452"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        className: "lock_react_svg__cls-3",
        d: "M90.007 176.885a16.308 16.308 0 0 1-16.115-18.82l2.23-14.32A24.148 24.148 0 0 1 92.21 102.69c.382-.017.766-.026 1.144-.026a24.15 24.15 0 0 1 17.229 41.08l2.23 14.32a16.31 16.31 0 0 1-16.114 18.82z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        id: "lock_react_svg___Path_2",
        "data-name": "<Path>",
        className: "lock_react_svg__cls-2",
        d: "M108.481 126.824a15.061 15.061 0 0 1-4.83 11.067 7.222 7.222 0 0 0-2.122 6.412l2.36 15.154a7.278 7.278 0 0 1-7.192 8.398h-6.69a7.278 7.278 0 0 1-7.192-8.398l2.388-15.332a7.232 7.232 0 0 0-2.269-6.345 15.064 15.064 0 0 1-4.69-11.753 15.13 15.13 0 0 1 30.237.797z"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M82.815 159.457a7.256 7.256 0 1 0 14.333 0l-2.36-15.154a7.221 7.221 0 0 1 2.122-6.412 15.104 15.104 0 0 0-6.945-25.804 15.268 15.268 0 0 0-11.722 13.94 15.063 15.063 0 0 0 4.691 11.753 7.232 7.232 0 0 1 2.268 6.345z",
        fill: "#344563"
    }))));
var $ab102afe034d5d2f$export$2e2bcd8739ae039 = $ab102afe034d5d2f$var$SvgLockreact;

});

parcelRegister("b0F8E", function(module, exports) {
$parcel$export(module.exports, "Paper", () => (parcelRequire("37N7U")).default);
$parcel$export(module.exports, "PaperContent", () => (parcelRequire("awGaB")).PaperContent);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => (parcelRequire("awGaB")).SmallPaddingPaperContent);

var $37N7U = parcelRequire("37N7U");

var $awGaB = parcelRequire("awGaB");

});
parcelRegister("37N7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $7195afc9edc5eda3$export$2e2bcd8739ae039);
/* paper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
parcelRequire("jv2lM");
var $d72GX = parcelRequire("d72GX");
parcelRequire("4r1vU");
var $9OTKp = parcelRequire("9OTKp");

var $awGaB = parcelRequire("awGaB");
const $7195afc9edc5eda3$var$SkipToMainContent = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement((0, $9OTKp.MainContentSkipLinkWrapper), null, /*#__PURE__*/ $4fqPo.createElement($7195afc9edc5eda3$var$MainContentSkipLink, null, children));
// We want to delay fade in until after the paper transition is complete
const $7195afc9edc5eda3$var$FadeContent = (0, $d72GX.default)({
    fadeInTime: (0, $awGaB.paperTransitionTime),
    delay: (0, $awGaB.paperTransitionTime)
})((0, $awGaB.Content));
class $7195afc9edc5eda3$var$Paper extends $4fqPo.Component {
    render() {
        const { children: children, pageKey: pageKey, isCSM: isCSM } = this.props;
        const hide = this.props.appearance === 'none';
        const appearance = this.props.appearance || 'normal';
        if (appearance === 'note') return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.PaperBackground), {
            appearance: "none",
            hide: true
        }), /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.NoteContent), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.NoteBackground), null, children), /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.StyledFooter), null)));
        return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.PaperBackground), {
            appearance: appearance,
            hide: hide
        }), /*#__PURE__*/ $4fqPo.createElement($7195afc9edc5eda3$var$FadeContent, {
            appearance: appearance,
            hide: hide,
            key: pageKey
        }, /*#__PURE__*/ $4fqPo.createElement($7195afc9edc5eda3$var$SkipToMainContent, null, children, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.StyledFooter), {
            isCSM: isCSM
        }))));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $7195afc9edc5eda3$var$MainContentSkipLink = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _2lx21bp4 _1tke1osq",
            __cmplp.className
        ])
    });
});
var $7195afc9edc5eda3$export$2e2bcd8739ae039 = $7195afc9edc5eda3$var$Paper;

});
parcelRegister("jv2lM", function(module, exports) {
$parcel$export(module.exports, "withFadeIn", () => (parcelRequire("d72GX")).default);

var $d72GX = parcelRequire("d72GX");

});
parcelRegister("d72GX", function(module, exports) {
$parcel$export(module.exports, "default", () => $36977b09584152ab$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $brRRh = parcelRequire("brRRh");

var $2MK3g = parcelRequire("2MK3g");
parcelRequire("bz4eG");
var $8zTXq = parcelRequire("8zTXq");

var $ebpTf = parcelRequire("ebpTf");
const $36977b09584152ab$var$withFadeIn = (options)=>(WrappedComponent)=>{
        const defaultOptions = {
            fadeInTime: $brRRh.speedMs.slow,
            delay: 0
        };
        const mergedOptions = {
            ...defaultOptions,
            ...options
        };
        // eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        const ComponentWithFadeIn = /*#__PURE__*/ (0, $el3DQ.default)(WrappedComponent).withConfig({
            componentId: "sc-1uyl3wn-0"
        })`${$brRRh.fadeInOut(mergedOptions.fadeInTime, mergedOptions.delay)};`;
        const ReturnComponent = (props)=>{
            const shouldSkipTransition = $4fqPo.useMemo(()=>!(0, $8zTXq.isAppMounted).value, []);
            /**
     * In server side rendering -  component should appear
     * on First time load from SSR - component should appear
     * on next time onwards - component should transition
     * on client only - component should transition
     */ const shouldTransitOnMount = ()=>{
                // Invalid report.
                // eslint-disable-next-line testing-library/render-result-naming-convention
                const isPageServerSideRendered = (0, $ebpTf.getIsPageServerSideRendered)();
                if (isPageServerSideRendered && shouldSkipTransition) return false;
                return true;
            };
            return /*#__PURE__*/ $4fqPo.createElement((0, $2MK3g.default), {
                in: true,
                timeout: 0,
                mountOnEnter: true,
                appear: shouldTransitOnMount()
            }, (state)=>// Spreading props blows type checking up for some reason. Why??
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                /*#__PURE__*/ $4fqPo.createElement(ComponentWithFadeIn, {
                    ...props,
                    state: state
                }));
        };
        return ReturnComponent;
    };
var $36977b09584152ab$export$2e2bcd8739ae039 = $36977b09584152ab$var$withFadeIn;

});
parcelRegister("2MK3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $2073c958097a1cdc$export$2e2bcd8739ae039, (v) => $2073c958097a1cdc$export$2e2bcd8739ae039 = v);
var $2073c958097a1cdc$export$1e511d4a378977f5;
var $2073c958097a1cdc$export$2e2bcd8739ae039;
var $2073c958097a1cdc$export$4aacc83d4d59139f;
var $2073c958097a1cdc$export$78e9e6e3e014d60a;
var $2073c958097a1cdc$export$df38205c966be359;
var $2073c958097a1cdc$export$84cbff306f539230;
var $2073c958097a1cdc$export$bb38bb9a1161268;
"use strict";
$2073c958097a1cdc$export$1e511d4a378977f5 = true;
$2073c958097a1cdc$export$2e2bcd8739ae039 = $2073c958097a1cdc$export$4aacc83d4d59139f = $2073c958097a1cdc$export$78e9e6e3e014d60a = $2073c958097a1cdc$export$df38205c966be359 = $2073c958097a1cdc$export$84cbff306f539230 = $2073c958097a1cdc$export$bb38bb9a1161268 = void 0;

var $2073c958097a1cdc$var$PropTypes = $2073c958097a1cdc$var$_interopRequireWildcard((parcelRequire("4S7MC")));

var $2073c958097a1cdc$var$_react = $2073c958097a1cdc$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $2073c958097a1cdc$var$_reactDom = $2073c958097a1cdc$var$_interopRequireDefault((parcelRequire("b2Ka1")));

var $l4VHl = parcelRequire("l4VHl");

function $2073c958097a1cdc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2073c958097a1cdc$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $2073c958097a1cdc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2073c958097a1cdc$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $2073c958097a1cdc$var$UNMOUNTED = 'unmounted';
$2073c958097a1cdc$export$bb38bb9a1161268 = $2073c958097a1cdc$var$UNMOUNTED;
var $2073c958097a1cdc$var$EXITED = 'exited';
$2073c958097a1cdc$export$84cbff306f539230 = $2073c958097a1cdc$var$EXITED;
var $2073c958097a1cdc$var$ENTERING = 'entering';
$2073c958097a1cdc$export$df38205c966be359 = $2073c958097a1cdc$var$ENTERING;
var $2073c958097a1cdc$var$ENTERED = 'entered';
$2073c958097a1cdc$export$78e9e6e3e014d60a = $2073c958097a1cdc$var$ENTERED;
var $2073c958097a1cdc$var$EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $2073c958097a1cdc$export$4aacc83d4d59139f = $2073c958097a1cdc$var$EXITING;
var $2073c958097a1cdc$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $2073c958097a1cdc$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $2073c958097a1cdc$var$EXITED;
                _this.appearStatus = $2073c958097a1cdc$var$ENTERING;
            } else initialStatus = $2073c958097a1cdc$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $2073c958097a1cdc$var$UNMOUNTED;
        else initialStatus = $2073c958097a1cdc$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $2073c958097a1cdc$var$UNMOUNTED) return {
            status: $2073c958097a1cdc$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $2073c958097a1cdc$var$ENTERING && status !== $2073c958097a1cdc$var$ENTERED) nextStatus = $2073c958097a1cdc$var$ENTERING;
            } else if (status === $2073c958097a1cdc$var$ENTERING || status === $2073c958097a1cdc$var$ENTERED) nextStatus = $2073c958097a1cdc$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $2073c958097a1cdc$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $2073c958097a1cdc$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $2073c958097a1cdc$var$EXITED) this.setState({
            status: $2073c958097a1cdc$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $2073c958097a1cdc$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $2073c958097a1cdc$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $2073c958097a1cdc$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $2073c958097a1cdc$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $2073c958097a1cdc$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $2073c958097a1cdc$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $2073c958097a1cdc$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $2073c958097a1cdc$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === 'function') return children(status, childProps);
        var child = $2073c958097a1cdc$var$_react.default.Children.only(children);
        return $2073c958097a1cdc$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($2073c958097a1cdc$var$_react.default.Component);
$2073c958097a1cdc$var$Transition.contextTypes = {
    transitionGroup: $2073c958097a1cdc$var$PropTypes.object
};
$2073c958097a1cdc$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$2073c958097a1cdc$var$Transition.propTypes = {};
function $2073c958097a1cdc$var$noop() {}
$2073c958097a1cdc$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $2073c958097a1cdc$var$noop,
    onEntering: $2073c958097a1cdc$var$noop,
    onEntered: $2073c958097a1cdc$var$noop,
    onExit: $2073c958097a1cdc$var$noop,
    onExiting: $2073c958097a1cdc$var$noop,
    onExited: $2073c958097a1cdc$var$noop
};
$2073c958097a1cdc$var$Transition.UNMOUNTED = 0;
$2073c958097a1cdc$var$Transition.EXITED = 1;
$2073c958097a1cdc$var$Transition.ENTERING = 2;
$2073c958097a1cdc$var$Transition.ENTERED = 3;
$2073c958097a1cdc$var$Transition.EXITING = 4;
var $2073c958097a1cdc$var$_default = (0, $l4VHl.polyfill)($2073c958097a1cdc$var$Transition);
$2073c958097a1cdc$export$2e2bcd8739ae039 = $2073c958097a1cdc$var$_default;

});
parcelRegister("l4VHl", function(module, exports) {
$parcel$export(module.exports, "polyfill", () => $f586ba5a20da0064$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $f586ba5a20da0064$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $f586ba5a20da0064$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $f586ba5a20da0064$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$f586ba5a20da0064$var$componentWillMount.__suppressDeprecationWarning = true;
$f586ba5a20da0064$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$f586ba5a20da0064$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $f586ba5a20da0064$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $f586ba5a20da0064$var$componentWillMount;
        prototype.componentWillReceiveProps = $f586ba5a20da0064$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $f586ba5a20da0064$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});




parcelRegister("4r1vU", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => (parcelRequire("9OTKp")).MainContentSkipLinkWrapper);

var $9OTKp = parcelRequire("9OTKp");

});
parcelRegister("9OTKp", function(module, exports) {
$parcel$export(module.exports, "MainContentSkipLinkWrapper", () => $fd7117545ee878f0$export$505b93f76cb5cb5c);

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");

var $dCEPI = parcelRequire("dCEPI");

var $81qaj = parcelRequire("81qaj");
const $fd7117545ee878f0$export$505b93f76cb5cb5c = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dCEPI.default), {
        id: "main",
        skipLinkTitle: formatMessage((0, $81qaj.default).skipToMainA11yLabel),
        testId: "main"
    }, children);
};

});
parcelRegister("dCEPI", function(module, exports) {
$parcel$export(module.exports, "default", () => $92865a42ede060ac$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $aJv53 = parcelRequire("aJv53");

var $5Aw5C = parcelRequire("5Aw5C");

var $gSpw2 = parcelRequire("gSpw2");

var $e3uEz = parcelRequire("e3uEz");

var $cJwJ4 = parcelRequire("cJwJ4");

var $424Vp = parcelRequire("424Vp");
var $fRy95 = parcelRequire("fRy95");

var $5jaCT = parcelRequire("5jaCT");
function $92865a42ede060ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $92865a42ede060ac$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $lqVX7.css)((0, $aJv53.prefersReducedMotion)());
const $92865a42ede060ac$var$mainStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    minWidth: 0,
    flexGrow: 1,
    marginInlineStart: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `margin-left ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s`
});
const $92865a42ede060ac$var$draggingStyles = {
    name: "1wx2bp",
    styles: "transition:none"
};
/**
 * Adds a negative left margin to main,
 * which transitions at the same speed as the left sidebar's width increase.
 * This give an illusion that the flyout is appearing on top of the main content,
 * while main remains in place.
 */ const $92865a42ede060ac$var$flyoutStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: `calc(-1 * var(--${(0, $gSpw2.VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, $gSpw2.DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, $gSpw2.COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
});
/**
 * __Main__
 *
 * Provides a slot for main content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $92865a42ede060ac$var$Main = (props)=>{
    const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    (0, $fRy95.useSkipLink)(id, skipLinkTitle);
    const isDragging = (0, $cJwJ4.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $4fqPo.useContext)((0, $424Vp.SidebarResizeContext));
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $5jaCT.default), null, ({ className: className })=>/*#__PURE__*/ (0, $lqVX7.jsx)("main", {
            "data-testid": testId,
            css: [
                $92865a42ede060ac$var$mainStyles,
                isDragging && $92865a42ede060ac$var$draggingStyles,
                isFlyoutOpen && !isFixed && $92865a42ede060ac$var$flyoutStyles,
                $92865a42ede060ac$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            ...(0, $e3uEz.getPageLayoutSlotSelector)('main')
        }, children));
};
var $92865a42ede060ac$export$2e2bcd8739ae039 = $92865a42ede060ac$var$Main;

});
parcelRegister("aJv53", function(module, exports) {
$parcel$export(module.exports, "prefersReducedMotion", () => $8a952f2c7a53f756$export$ff7706047246b98b);

var $813Hf = parcelRequire("813Hf");
const $8a952f2c7a53f756$export$ff7706047246b98b = ()=>(0, $813Hf.reduceMotionAsPerUserPreference);

});
parcelRegister("813Hf", function(module, exports) {
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $3e691cd80ba2516f$export$f0f789643ba5a83c);
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $3e691cd80ba2516f$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};

});


parcelRegister("gSpw2", function(module, exports) {
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_WIDTH", () => $791c9ad1c7a9f7e2$export$a30f2e00489a8957);
$parcel$export(module.exports, "VAR_TOP_NAVIGATION_HEIGHT", () => $791c9ad1c7a9f7e2$export$3a6a779d9181047c);
$parcel$export(module.exports, "VAR_LEFT_SIDEBAR_FLYOUT", () => $791c9ad1c7a9f7e2$export$b6744d31294864fd);
$parcel$export(module.exports, "LEFT_PANEL", () => $791c9ad1c7a9f7e2$export$344062f7cfc9528e);
$parcel$export(module.exports, "RIGHT_PANEL", () => $791c9ad1c7a9f7e2$export$c7139cc2d6110b5f);
$parcel$export(module.exports, "BANNER", () => $791c9ad1c7a9f7e2$export$238d30785c4bca84);
$parcel$export(module.exports, "TOP_NAVIGATION", () => $791c9ad1c7a9f7e2$export$bec6dca2e63de4ae);
$parcel$export(module.exports, "CONTENT", () => $791c9ad1c7a9f7e2$export$d1213e82613ff4df);
$parcel$export(module.exports, "DEFAULT_TOP_NAVIGATION_HEIGHT", () => $791c9ad1c7a9f7e2$export$4a98ee0bd1ae362);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", () => $791c9ad1c7a9f7e2$export$539e68c09584883a);
$parcel$export(module.exports, "COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $791c9ad1c7a9f7e2$export$46acf8758e9e2636);
$parcel$export(module.exports, "MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH", () => $791c9ad1c7a9f7e2$export$70740f5ad8360a78);
$parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH", () => $791c9ad1c7a9f7e2$export$991d5285ad765a3d);
$parcel$export(module.exports, "MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH", () => $791c9ad1c7a9f7e2$export$d6e7e8af042815bb);
$parcel$export(module.exports, "TRANSITION_DURATION", () => $791c9ad1c7a9f7e2$export$3749e1104328fde4);
$parcel$export(module.exports, "PAGE_LAYOUT_LS_KEY", () => $791c9ad1c7a9f7e2$export$451e84a45a9e4a75);
$parcel$export(module.exports, "IS_SIDEBAR_DRAGGING", () => $791c9ad1c7a9f7e2$export$802bb2c050f3db5c);
$parcel$export(module.exports, "IS_SIDEBAR_COLLAPSING", () => $791c9ad1c7a9f7e2$export$5e5e1875c3fd8f4f);
$parcel$export(module.exports, "PAGE_LAYOUT_SLOT_SELECTOR", () => $791c9ad1c7a9f7e2$export$5253dd9707b8c3ba);
$parcel$export(module.exports, "DEFAULT_I18N_PROPS_SKIP_LINKS", () => $791c9ad1c7a9f7e2$export$206a08f7f8beb554);
$parcel$export(module.exports, "PAGE_LAYOUT_CONTAINER_SELECTOR", () => $791c9ad1c7a9f7e2$export$659ee746b31b360d);
$parcel$export(module.exports, "LEFT_PANEL_WIDTH", () => $791c9ad1c7a9f7e2$export$f963aecf2d4465bd);
$parcel$export(module.exports, "RIGHT_PANEL_WIDTH", () => $791c9ad1c7a9f7e2$export$750459958906793);
$parcel$export(module.exports, "LEFT_SIDEBAR_WIDTH", () => $791c9ad1c7a9f7e2$export$f897e1ed9f8ed251);
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $791c9ad1c7a9f7e2$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $791c9ad1c7a9f7e2$export$ed7cc0d417ee89e);
$parcel$export(module.exports, "LEFT_SIDEBAR_FLYOUT_WIDTH", () => $791c9ad1c7a9f7e2$export$d2fa14f05b61e66);
// dimension vars
const $791c9ad1c7a9f7e2$export$cbfb0f5b2869b17b = 'leftPanelWidth';
const $791c9ad1c7a9f7e2$export$a30f2e00489a8957 = 'leftSidebarWidth';
const $791c9ad1c7a9f7e2$export$c103b605cd368aed = 'rightSidebarWidth';
const $791c9ad1c7a9f7e2$export$fa34f417972d6341 = 'rightPanelWidth';
const $791c9ad1c7a9f7e2$export$3a6a779d9181047c = 'topNavigationHeight';
const $791c9ad1c7a9f7e2$export$bcd94a6a792e7f96 = 'bannerHeight';
const $791c9ad1c7a9f7e2$export$b6744d31294864fd = 'leftSidebarFlyoutWidth';
const $791c9ad1c7a9f7e2$export$344062f7cfc9528e = 'left-panel';
const $791c9ad1c7a9f7e2$export$c7139cc2d6110b5f = 'right-panel';
const $791c9ad1c7a9f7e2$export$238d30785c4bca84 = 'banner';
const $791c9ad1c7a9f7e2$export$bec6dca2e63de4ae = 'top-navigation';
const $791c9ad1c7a9f7e2$export$d1213e82613ff4df = 'content';
const $791c9ad1c7a9f7e2$export$be83e7118304b28e = 56;
const $791c9ad1c7a9f7e2$export$4a98ee0bd1ae362 = 56;
const $791c9ad1c7a9f7e2$export$539e68c09584883a = 240;
const $791c9ad1c7a9f7e2$export$b92df8810d2fcd01 = 280;
const $791c9ad1c7a9f7e2$export$c3e41153b9288bcf = 368;
const $791c9ad1c7a9f7e2$export$c4d6152f86ea28f6 = 368;
const $791c9ad1c7a9f7e2$export$46acf8758e9e2636 = 20;
const $791c9ad1c7a9f7e2$export$70740f5ad8360a78 = 16;
const $791c9ad1c7a9f7e2$export$991d5285ad765a3d = 240;
const $791c9ad1c7a9f7e2$export$6949d4f32b161684 = 200;
const $791c9ad1c7a9f7e2$export$d6e7e8af042815bb = 350;
const $791c9ad1c7a9f7e2$export$3749e1104328fde4 = 300;
const $791c9ad1c7a9f7e2$export$1074d925b0b82be5 = 200;
const $791c9ad1c7a9f7e2$export$451e84a45a9e4a75 = 'DS_PAGE_LAYOUT_UI_STATE';
const $791c9ad1c7a9f7e2$export$802bb2c050f3db5c = 'data-is-sidebar-dragging';
const $791c9ad1c7a9f7e2$export$5e5e1875c3fd8f4f = 'data-is-sidebar-collapsing';
const $791c9ad1c7a9f7e2$export$70c702a8c5895f03 = 'data-grab-area-line';
const $791c9ad1c7a9f7e2$export$48a43f91e4becf4e = 'data-grab-area';
const $791c9ad1c7a9f7e2$export$dac2fb31a9f6844d = 'data-resize-button';
const $791c9ad1c7a9f7e2$export$9ecd22db14e6c70e = 'data-resize-control';
const $791c9ad1c7a9f7e2$export$5253dd9707b8c3ba = 'data-ds--page-layout--slot';
const $791c9ad1c7a9f7e2$export$206a08f7f8beb554 = 'Skip to:';
const $791c9ad1c7a9f7e2$export$659ee746b31b360d = 'data-layout-container';
const $791c9ad1c7a9f7e2$export$f963aecf2d4465bd = `var(--${$791c9ad1c7a9f7e2$export$cbfb0f5b2869b17b}, 0px)`;
const $791c9ad1c7a9f7e2$export$750459958906793 = `var(--${$791c9ad1c7a9f7e2$export$fa34f417972d6341}, 0px)`;
const $791c9ad1c7a9f7e2$export$f897e1ed9f8ed251 = `var(--${$791c9ad1c7a9f7e2$export$a30f2e00489a8957}, 0px)`;
const $791c9ad1c7a9f7e2$export$b44ab66843c05a69 = `var(--${$791c9ad1c7a9f7e2$export$c103b605cd368aed}, 0px)`;
const $791c9ad1c7a9f7e2$export$aeff86a16f13529 = `var(--${$791c9ad1c7a9f7e2$export$3a6a779d9181047c}, 0px)`;
const $791c9ad1c7a9f7e2$export$ed7cc0d417ee89e = `var(--${$791c9ad1c7a9f7e2$export$bcd94a6a792e7f96}, 0px)`;
const $791c9ad1c7a9f7e2$export$d2fa14f05b61e66 = `var(--${$791c9ad1c7a9f7e2$export$b6744d31294864fd}, ${$791c9ad1c7a9f7e2$export$991d5285ad765a3d}px)`;

});

parcelRegister("e3uEz", function(module, exports) {
$parcel$export(module.exports, "getPageLayoutSlotSelector", () => $c7bdd08afb3cafc8$export$e895e3e8b708ae2a);

var $gSpw2 = parcelRequire("gSpw2");
const $c7bdd08afb3cafc8$export$e895e3e8b708ae2a = (slotName)=>({
        [(0, $gSpw2.PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
    });

});

parcelRegister("cJwJ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $73cf652eca86a00b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gSpw2 = parcelRequire("gSpw2");
const $73cf652eca86a00b$var$getIsDragging = ()=>{
    // SSR bail-out because document is undefined on the server
    if (typeof document === 'undefined') return false;
    return document.documentElement.getAttribute((0, $gSpw2.IS_SIDEBAR_DRAGGING)) === 'true';
};
// TODO: I think this should be derived from the sidebar state,
// and not indirectly from observing an attribute change
const $73cf652eca86a00b$var$useIsSidebarDragging = ()=>{
    const [isDragging, setIsDragging] = (0, $4fqPo.useState)($73cf652eca86a00b$var$getIsDragging);
    (0, $4fqPo.useEffect)(()=>{
        const observer = new MutationObserver(()=>{
            setIsDragging($73cf652eca86a00b$var$getIsDragging);
        });
        observer.observe(document.documentElement, {
            attributeFilter: [
                (0, $gSpw2.IS_SIDEBAR_DRAGGING)
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, []);
    return isDragging;
};
var $73cf652eca86a00b$export$2e2bcd8739ae039 = $73cf652eca86a00b$var$useIsSidebarDragging;

});

parcelRegister("424Vp", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeContext", () => $6685b74539bbbe8b$export$aa5a712eea4c2ae8);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");
const $6685b74539bbbe8b$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $6685b74539bbbe8b$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $c1tmZ.default),
    collapseLeftSidebar: (0, $c1tmZ.default),
    leftSidebarState: $6685b74539bbbe8b$var$leftSidebarState,
    setLeftSidebarState: (0, $c1tmZ.default),
    toggleLeftSidebar: (0, $c1tmZ.default)
});

});

parcelRegister("fRy95", function(module, exports) {
$parcel$export(module.exports, "useSkipLink", () => $d09f9b94194b7562$export$89d9323301efc7d6);

var $4fqPo = parcelRequire("4fqPo");

var $jNMXh = parcelRequire("jNMXh");
const $d09f9b94194b7562$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
    const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, $jNMXh.useSkipLinks)();
    (0, $4fqPo.useEffect)(()=>{
        if (id && skipLinkTitle) registerSkipLink({
            id: id,
            skipLinkTitle: skipLinkTitle
        });
        return ()=>{
            unregisterSkipLink(id);
        };
    }, [
        id,
        skipLinkTitle,
        registerSkipLink,
        unregisterSkipLink
    ]);
};

});
parcelRegister("jNMXh", function(module, exports) {
$parcel$export(module.exports, "useSkipLinks", () => $940ba092272d6416$export$c9d9cb2ee9590f87);

var $4fqPo = parcelRequire("4fqPo");

var $5AS0Q = parcelRequire("5AS0Q");
const $940ba092272d6416$export$c9d9cb2ee9590f87 = ()=>(0, $4fqPo.useContext)((0, $5AS0Q.SkipLinksContext));

});
parcelRegister("5AS0Q", function(module, exports) {
$parcel$export(module.exports, "SkipLinksContext", () => $aef0db7d15e87de3$export$4c5cc3b14c7678a);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");
const $aef0db7d15e87de3$export$4c5cc3b14c7678a = /*#__PURE__*/ (0, $4fqPo.createContext)({
    skipLinksData: [],
    registerSkipLink: (0, $c1tmZ.default),
    unregisterSkipLink: (0, $c1tmZ.default)
});

});



parcelRegister("5jaCT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6de7330a707e1e09$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lqVX7 = parcelRequire("lqVX7");
const $6de7330a707e1e09$var$focusStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * Sidebars have an outer and inner component,
 * so the nested selector needs to target an extra level deeper.
 */ const $6de7330a707e1e09$var$sidebarFocusStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none',
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div > div': {
            boxShadow: `0px 0px 0px 2px inset ${"var(--ds-border-focused, #4688EC)"}`,
            outline: 'none'
        }
    }
});
/**
 * We don't use `@atlaskit/focus-ring` here,
 * because we need inset focus styles and:
 *
 * 1. If we set them directly to the layout element,
 *    then any child element's background will cover the shadow.
 * 2. We cannot wrap `children` in `FocusRing`,
 *    because there's no guarantee the passed child takes `className`.
 */ const $6de7330a707e1e09$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $lqVX7.ClassNames), null, ({ css: css })=>children({
            className: isSidebar ? css($6de7330a707e1e09$var$sidebarFocusStyles) : css($6de7330a707e1e09$var$focusStyles)
        }));
};
var $6de7330a707e1e09$export$2e2bcd8739ae039 = $6de7330a707e1e09$var$SlotFocusRing;

});


parcelRegister("81qaj", function(module, exports) {
$parcel$export(module.exports, "default", () => $39bc2cc833b3adcd$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $39bc2cc833b3adcd$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    skipToMainA11yLabel: {
        defaultMessage: 'Skip to Main Content',
        description: 'A11y Label for Skip to Main Content',
        id: 'sd.view.common.skip.links.main-content-skip-link.a11y-label'
    }
});

});



parcelRegister("awGaB", function(module, exports) {
$parcel$export(module.exports, "paperTransitionTime", () => $8e3c0b2537e8c2cf$export$c04d9b45b952bb2f);
$parcel$export(module.exports, "Content", () => $8e3c0b2537e8c2cf$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "NoteContent", () => $8e3c0b2537e8c2cf$export$fe2e0d4376bdc305);
$parcel$export(module.exports, "NoteBackground", () => $8e3c0b2537e8c2cf$export$8eb56b799bce002f);
$parcel$export(module.exports, "SmallPaddingPaperContent", () => $8e3c0b2537e8c2cf$export$80c4326e65e7230d);
$parcel$export(module.exports, "PaperContent", () => $8e3c0b2537e8c2cf$export$bf9cd54d94ffe52b);
$parcel$export(module.exports, "PaperBackground", () => $8e3c0b2537e8c2cf$export$69bd0e70980f4e9f);
$parcel$export(module.exports, "StyledFooter", () => $8e3c0b2537e8c2cf$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $2xGi5 = parcelRequire("2xGi5");

var $7L1Sn = parcelRequire("7L1Sn");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $brRRh = parcelRequire("brRRh");

var $dXHSc = parcelRequire("dXHSc");

var $5Kpwp = parcelRequire("5Kpwp");

var $4g4yb = parcelRequire("4g4yb");

var $3H4LK = parcelRequire("3H4LK");
// This is the width of the paper without any scaling
// It's fixed at 1000px for easy calculation.
const $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS = $bpWyP.multiple(125);
// 800px is normal width
const $8e3c0b2537e8c2cf$var$PAPER_NORMAL_WIDTH = $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.multiple(0.8).unitless;
// 1000px is wide width
const $8e3c0b2537e8c2cf$var$PAPER_WIDE_WIDTH = $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.multiple(1).unitless;
// 1100px is extra wide width
const $8e3c0b2537e8c2cf$var$PAPER_XWIDE_WIDTH = $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.multiple(1.1).unitless;
// 1200px is extra wide width
const $8e3c0b2537e8c2cf$var$PAPER_XXWIDE_WIDTH = $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.multiple(1.2).unitless;
const $8e3c0b2537e8c2cf$var$PAPER_NOTE_WIDTH = $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.multiple(0.48).unitless;
const $8e3c0b2537e8c2cf$var$PAPER_PADDING_TOP = "var(--ds-space-300, 24px)";
const $8e3c0b2537e8c2cf$var$PAPER_PADDING_RIGHT_MOBILE = "var(--ds-space-400, 32px)";
const $8e3c0b2537e8c2cf$var$PAPER_PADDING_LEFT_MOBILE = "var(--ds-space-400, 32px)";
const $8e3c0b2537e8c2cf$var$PAPER_PADDING_RIGHT_DESKTOP = $bpWyP.multiple(13.5).unitless;
const $8e3c0b2537e8c2cf$var$PAPER_PADDING_LEFT_DESKTOP = $bpWyP.multiple(11).unitless;
const $8e3c0b2537e8c2cf$var$PAPER_PADDING_SMALL = "var(--ds-space-600, 48px)";
const $8e3c0b2537e8c2cf$var$PAPER_NOTE_HEIGHT = $bpWyP.multiple(52).unitless;
const $8e3c0b2537e8c2cf$var$PAPER_NOTE_MARGIN_TOP = $bpWyP.multiple(20).unitless - (0, $5Kpwp.HEADER_HEIGHT);
const $8e3c0b2537e8c2cf$export$c04d9b45b952bb2f = $brRRh.speedMs.slow;
const $8e3c0b2537e8c2cf$var$getContentWidth = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $8e3c0b2537e8c2cf$var$PAPER_XXWIDE_WIDTH;
        case 'xwide':
            return $8e3c0b2537e8c2cf$var$PAPER_XWIDE_WIDTH;
        case 'wide':
            return $8e3c0b2537e8c2cf$var$PAPER_WIDE_WIDTH;
        case 'note':
            return $8e3c0b2537e8c2cf$var$PAPER_NOTE_WIDTH;
        default:
            return $8e3c0b2537e8c2cf$var$PAPER_NORMAL_WIDTH;
    }
};
const $8e3c0b2537e8c2cf$var$getScale = (appearance)=>$8e3c0b2537e8c2cf$var$getContentWidth(appearance) / $8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.unitless;
const $8e3c0b2537e8c2cf$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $el3DQ.default).main.withConfig({
    componentId: "sc-1jc43ym-0"
})`box-sizing:border-box;display:flex;flex-direction:column;flex:1 1 auto;margin:${"var(--ds-space-0, 0px)"} auto;width:100%;max-width:${(props)=>props.hide ? '100%' : `${$8e3c0b2537e8c2cf$var$getContentWidth(props.appearance)}px`};min-height:100%;${$2xGi5.fromCustom($8e3c0b2537e8c2cf$var$PAPER_NOTE_WIDTH).css`
        min-height: ${(props)=>props.appearance === 'note' ? `${$8e3c0b2537e8c2cf$var$PAPER_NOTE_HEIGHT}px` : '100%'};
        margin-top: ${(props)=>props.appearance === 'note' ? `${$8e3c0b2537e8c2cf$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $8e3c0b2537e8c2cf$export$fe2e0d4376bdc305 = /*#__PURE__*/ (0, $el3DQ.default)($8e3c0b2537e8c2cf$export$7c6e2c02157bb7d2).attrs({
    appearance: 'note'
}).withConfig({
    componentId: "sc-1jc43ym-1"
})`align-self:flex-start;max-width:${(props)=>props.hide ? '100%' : `${$8e3c0b2537e8c2cf$var$getContentWidth(props.appearance)}px`};`;
const $8e3c0b2537e8c2cf$export$8eb56b799bce002f = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1jc43ym-2"
})`${$7L1Sn.e100};border-radius:${()=>(0, $3H4LK.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-large, 8px)" : $bpWyP.multiple(0.375).px};background-color:${"var(--ds-surface, #FFFFFF)"};min-height:inherit;`;
const $8e3c0b2537e8c2cf$export$80c4326e65e7230d = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1jc43ym-3"
})`display:flex;flex-direction:column;flex:1 1 auto;padding-top:${$8e3c0b2537e8c2cf$var$PAPER_PADDING_TOP};padding-left:${$8e3c0b2537e8c2cf$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$8e3c0b2537e8c2cf$var$PAPER_PADDING_RIGHT_MOBILE};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};${$2xGi5.fromCustom($8e3c0b2537e8c2cf$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$8e3c0b2537e8c2cf$var$PAPER_PADDING_SMALL};
        padding-right: ${$8e3c0b2537e8c2cf$var$PAPER_PADDING_SMALL};
    `};`;
const $8e3c0b2537e8c2cf$export$49f7b90a0c83f2b0 = /*#__PURE__*/ (0, $el3DQ.css)`padding-top:${$8e3c0b2537e8c2cf$var$PAPER_PADDING_TOP};padding-left:${$8e3c0b2537e8c2cf$var$PAPER_PADDING_LEFT_MOBILE};padding-right:${$8e3c0b2537e8c2cf$var$PAPER_PADDING_RIGHT_MOBILE};${$2xGi5.fromCustom($8e3c0b2537e8c2cf$var$PAPER_NORMAL_WIDTH).css`
        /* We use padding top/left/right so we can override more easily */
        padding-left: ${$8e3c0b2537e8c2cf$var$PAPER_PADDING_LEFT_DESKTOP}px;
        padding-right: ${$8e3c0b2537e8c2cf$var$PAPER_PADDING_RIGHT_DESKTOP}px;
    `};`;
const $8e3c0b2537e8c2cf$export$bf9cd54d94ffe52b = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1jc43ym-4"
})`display:flex;flex-direction:column;flex:1 1 auto;${$8e3c0b2537e8c2cf$export$49f7b90a0c83f2b0};height:${(props)=>props.takeFullHeight ? '100%' : 'auto'};`;
const $8e3c0b2537e8c2cf$export$69bd0e70980f4e9f = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1jc43ym-5"
})`position:absolute;width:${$8e3c0b2537e8c2cf$var$PAPER_WIDTH_BASIS.px};height:inherit;right:0;bottom:0;top:0;left:50%;${$iSWaE.borderRadius};border-bottom-left-radius:0;border-bottom-right-radius:0;background-color:${"var(--ds-surface, #FFFFFF)"};box-shadow:${`var(--ds-shadow-overlay, ${`0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} -${$bpWyP.multiple(0.5).px} ${'rgba(9, 30, 66, 0.25)'}, 0 0 1px ${'rgba(9, 30, 66, 0.31)'}`})`};z-index:${$dXHSc.pageInBannerLayout};transition:transform ${$brRRh.timingFunctions.easeInOutQuad} ${$8e3c0b2537e8c2cf$export$c04d9b45b952bb2f}ms;transform:${(props)=>`translate3d(-50%, ${props.hide ? '100%' : '0'}, 0) scale3d(${$8e3c0b2537e8c2cf$var$getScale(props.appearance)}, 1, 1)`};${$2xGi5.fromCustom($8e3c0b2537e8c2cf$var$PAPER_NOTE_WIDTH).css`
        height: ${(props)=>props.appearance === 'note' ? `${$8e3c0b2537e8c2cf$var$PAPER_NOTE_HEIGHT}px` : 'inherit'};
        top: ${(props)=>props.appearance === 'note' ? `${$8e3c0b2537e8c2cf$var$PAPER_NOTE_MARGIN_TOP}px` : '0'};
    `};`;
const $8e3c0b2537e8c2cf$export$61905ae62c7860fb = /*#__PURE__*/ (0, $el3DQ.default)((0, $4g4yb.Footer)).withConfig({
    componentId: "sc-1jc43ym-6"
})`left:0;right:0;height:${$bpWyP.multiple(6).px};padding:${"var(--ds-space-600, 48px)"} 0 ${"var(--ds-space-100, 8px)"} 0;display:flex;align-items:center;justify-content:center;`;

});



parcelRegister("loAKY", function(module, exports) {
$parcel$export(module.exports, "ErrorLink", () => $ddbf4ed470c60dbe$export$d2c8415987899609);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eiGUu = parcelRequire("eiGUu");

var $8Gf3q = parcelRequire("8Gf3q");

var $3wR8f = parcelRequire("3wR8f");

var $1XMNp = parcelRequire("1XMNp");
const $ddbf4ed470c60dbe$export$d2c8415987899609 = ({ callToActionUrl: callToActionUrl, children: children })=>{
    if (callToActionUrl.includes((0, $1XMNp.LOGIN_ROUTE))) return /*#__PURE__*/ $4fqPo.createElement($ddbf4ed470c60dbe$export$f13d6b6525b315e0, {
        actionSubjectId: "redirectToLogin",
        href: (0, $3wR8f.getRelativeBasePath)() + callToActionUrl
    }, children);
    return /*#__PURE__*/ $4fqPo.createElement($ddbf4ed470c60dbe$export$a6c7ac8248d6e38a, {
        actionSubjectId: "callToAction",
        to: callToActionUrl
    }, children);
};
$ddbf4ed470c60dbe$export$d2c8415987899609.displayName = 'ErrorLink';
const $ddbf4ed470c60dbe$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $el3DQ.default)((0, $8Gf3q.default)).withConfig({
    componentId: "sc-1mmbyta-0"
})`text-align:center;`;
const $ddbf4ed470c60dbe$export$f13d6b6525b315e0 = /*#__PURE__*/ (0, $el3DQ.default)((0, $eiGUu.HtmlAnchor)).withConfig({
    componentId: "sc-1mmbyta-1"
})`text-align:center;`;

});
parcelRegister("8Gf3q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f8c6506f366ed46$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $1P8FK = parcelRequire("1P8FK");
const $5f8c6506f366ed46$export$1d567c320f4763bc = /*#__PURE__*/ (0, $el3DQ.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};${(props)=>props.hasUnderline && 'text-decoration: underline;'} &:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $5f8c6506f366ed46$var$ThemedLink = /*#__PURE__*/ (0, $el3DQ.default)((0, $1P8FK.Link)).withConfig({
    componentId: "sc-1tr99za-0"
})`${$5f8c6506f366ed46$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$5f8c6506f366ed46$export$2e2bcd8739ae039 = $5f8c6506f366ed46$var$ThemedLink;

});
parcelRegister("1P8FK", function(module, exports) {
$parcel$export(module.exports, "Link", () => $4c7ec02248b03cc6$export$a6c7ac8248d6e38a);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("l8iRu");
var $bdubZ = parcelRequire("bdubZ");

var $fD39j = parcelRequire("fD39j");

var $lEVbX = parcelRequire("lEVbX");
const $4c7ec02248b03cc6$var$InstrumentedLink = ({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, ...props })=>{
    const { to: to, target: target, ...rest } = props;
    if (typeof to === 'string') return /*#__PURE__*/ $4fqPo.createElement((0, $lEVbX.default), {
        to: to,
        target: target,
        ...rest
    });
    return /*#__PURE__*/ $4fqPo.createElement((0, $bdubZ.default), props);
};
const $4c7ec02248b03cc6$export$a6c7ac8248d6e38a = (0, $fD39j.default)('link', {
    onClick: ()=>({
            action: 'clicked'
        })
})($4c7ec02248b03cc6$var$InstrumentedLink);

});
parcelRegister("lEVbX", function(module, exports) {
$parcel$export(module.exports, "default", () => $df431f9e6a499f53$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $g2zI4 = parcelRequire("g2zI4");
parcelRequire("l8iRu");
var $bdubZ = parcelRequire("bdubZ");
var $dCuc5 = parcelRequire("dCuc5");

const $df431f9e6a499f53$export$d3010bc2e9cc1386 = (to, currentLocation)=>{
    // @ts-ignore the location provided by RRR is compatible with history location
    return (0, $g2zI4.createLocation)(to, null, undefined, currentLocation);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $df431f9e6a499f53$var$isModifiedEvent = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
/**
 * In server side rendering we use memory history, which doesn't have the base name. hence append basename manually
 */ function $df431f9e6a499f53$var$getHref(history, location) {
    return history.createHref(location);
}
/**
 * React resource router doesn't support baseUrl if the "to" property is a string.
 * We have to introduce this wrapper to workaround it otherwise the migration's surface area become too large.
 * Moving forward we should use "route" instead of string for the link component since it is better supported.
 *
 *  @deprecated this component shouldn't be used directly.
 */ const $df431f9e6a499f53$var$BaseUrlRespectLink = (props)=>{
    const { to: to, onClick: onClick, history: history, location: location, ...rest } = props;
    const toAsLocation = $df431f9e6a499f53$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $df431f9e6a499f53$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $4fqPo.useCallback)((e)=>{
        try {
            onClick && onClick(e);
        } catch (ex) {
            e.preventDefault();
            throw ex;
        }
        if (!e.defaultPrevented && (// onClick prevented default
        e.button === 0 || e.keyCode === 13) && // ignore everything but left clicks or enter
        (!props.target || props.target === '_self') && // let browser handle "target=_blank" etc.
        !$df431f9e6a499f53$var$isModifiedEvent(e) // ignore clicks with modifier keys
        ) {
            e.preventDefault();
            const method = props.replace ? history.replace : history.push;
            method(toAsLocation);
        }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    return /*#__PURE__*/ $4fqPo.createElement((0, $bdubZ.default), {
        href: href,
        ...rest,
        onClick: wrappedOnClick
    });
};
const $df431f9e6a499f53$var$BaseUrlRespectLinkWithRouter = (props)=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $dCuc5.RouterSubscriber), null, (// @ts-ignore access private `history` store property
    { location: location, history: history })=>// Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        /*#__PURE__*/ $4fqPo.createElement($df431f9e6a499f53$var$BaseUrlRespectLink, {
            location: location,
            history: history,
            ...props
        }));
};
var $df431f9e6a499f53$export$2e2bcd8739ae039 = $df431f9e6a499f53$var$BaseUrlRespectLinkWithRouter;

});



parcelRegister("1XMNp", function(module, exports) {
$parcel$export(module.exports, "PORTAL_ROUTE_PREFIX", () => $637c7a12f123df27$export$2b06f7190715126f);
$parcel$export(module.exports, "LOGIN_ROUTE", () => $637c7a12f123df27$export$9f22ab6dfd3d5ec5);
$parcel$export(module.exports, "PROJECT_NAME", () => $637c7a12f123df27$export$cb77c55dd12a845e);
$parcel$export(module.exports, "anonymousScreenLayout", () => $637c7a12f123df27$export$205bfffc91265169);
const $637c7a12f123df27$export$2b06f7190715126f = '/portal/:portalId(\\d+)';
const $637c7a12f123df27$export$9f22ab6dfd3d5ec5 = '/user/login';
const $637c7a12f123df27$export$cb77c55dd12a845e = 'jira-servicedesk.ondemand';
const $637c7a12f123df27$export$205bfffc91265169 = Object.freeze({
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'note',
    fadeInSearchModal: true
});

});


parcelRegister("4FxLV", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27ab06a07d6ac8b$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $e27ab06a07d6ac8b$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    permissionDenied: {
        defaultMessage: 'No Access',
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.error'
    },
    permissionDeniedMessage: {
        defaultMessage: "Sorry you're not allowed to see this.",
        description: 'Message to show when user does not have the permission to access the portal.',
        id: 'cv.portal.permission.denied.message'
    },
    notFound: {
        defaultMessage: 'Not Found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error'
    },
    notFoundMessage: {
        defaultMessage: 'We are having trouble finding that. Check the details and try again.',
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message'
    },
    notFoundV2: {
        defaultMessage: 'Site not found',
        description: 'Heading to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.error.v2'
    },
    notFoundMessageV2: {
        defaultMessage: "We couldn\u2019t find the site. Check the details and try again.",
        description: 'Message to show when user try to access portal or request create page that does not exist.',
        id: 'cv.portal.request.create.not.found.message.v2'
    },
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.heading'
    },
    genericMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'cv.portal.error-page.generic.error.message'
    },
    offlineHeading: {
        defaultMessage: "You're disconnected from the internet",
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.heading'
    },
    offlineMessage: {
        defaultMessage: 'The internet may be out to lunch. Check your network connection and try again.',
        description: 'Title for the error message when the user was offline when trying to view a page',
        id: 'cv.portal.error-page.offline.message'
    }
});

});


parcelRegister("cwZKZ", function(module, exports) {
$parcel$export(module.exports, "UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE", () => $9047431b6044e74c$export$ac0ed14b86f6f7e1);

var $6mmHn = parcelRequire("6mmHn");

var $dJs2E = parcelRequire("dJs2E");

var $fZppw = parcelRequire("fZppw");

var $ks84T = parcelRequire("ks84T");
const $9047431b6044e74c$export$ac0ed14b86f6f7e1 = (0, $fZppw.createRelayResource)({
    type: 'UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE',
    getQuery: ({ match: match }, { cloudId: cloudId, accountType: accountType })=>{
        const { portalId: portalId, requestTypeId: requestTypeId } = match.params;
        return {
            parameters: (0, $ks84T.default),
            variables: {
                cloudId: cloudId,
                uiModificationsContext: {
                    viewType: 'JSMRequestCreate',
                    portalId: portalId ?? '',
                    requestTypeId: requestTypeId ? (0, $dJs2E.JiraServicedeskRequestTypeAri).create({
                        requestTypeId: requestTypeId,
                        activationId: (0, $6mmHn.getActivationId)()
                    }).toString() : ''
                },
                forgeExtensionRenderingContext: {
                    portalId: match.params.portalId ?? ''
                }
            },
            options: {
                fetchPolicy: 'network-only'
            },
            /**
       * Covers the case for `/portal/:portalId` and `/portal/:portalId/group/:requestGroupId` without the `requestTypeId` parameter.
       */ isResourceDisabled: !portalId || !requestTypeId || accountType !== 'atlassian'
        };
    }
});

});
parcelRegister("dJs2E", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskRequestTypeAri", () => $9ff53ad26603cfca$export$eb8f42c57b94089e);

var $5KCNB = parcelRequire("5KCNB");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/jira-servicedesk/request-type/manifest.ts
var $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5KCNB.JiraServicedeskRequestTypeAriResourceOwner),
    resourceType: (0, $5KCNB.JiraServicedeskRequestTypeAriResourceType),
    resourceIdSlug: "activation/{activationId}/{requestTypeId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        requestTypeId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira-servicedesk/request-type/index.ts
var $9ff53ad26603cfca$export$eb8f42c57b94089e = class _JiraServicedeskRequestTypeAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._requestTypeId = opts.resourceIdSegmentValues.requestTypeId;
    }
    get activationId() {
        return this._activationId;
    }
    get requestTypeId() {
        return this._requestTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts.qualifier,
            platformQualifier: $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts.resourceOwner,
            resourceType: $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.requestTypeId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                requestTypeId: opts.requestTypeId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts);
        return new _JiraServicedeskRequestTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $9ff53ad26603cfca$var$jiraServicedeskRequestTypeAriStaticOpts);
        return new _JiraServicedeskRequestTypeAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            requestTypeId: this.requestTypeId
        };
    }
};

});
parcelRegister("5KCNB", function(module, exports) {
$parcel$export(module.exports, "JiraServicedeskRequestTypeAriResourceOwner", () => $42ff5852d63deea4$export$3bb883071b0c8c1a);
$parcel$export(module.exports, "JiraServicedeskRequestTypeAriResourceType", () => $42ff5852d63deea4$export$185a855be42467b5);
// src/jira-servicedesk/request-type/types.ts
var $42ff5852d63deea4$export$3bb883071b0c8c1a = "jira-servicedesk", $42ff5852d63deea4$export$185a855be42467b5 = "request-type";

});


parcelRegister("ks84T", function(module, exports) {
$parcel$export(module.exports, "default", () => $865f8967f053c4dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f62162b881d18b9ab2234089cdb30775>>
 * @relayHash 1ab5a3c31c93d15066415c7122f4c697
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e45293f8a27ead7abd3ce9b719eca0f4e86961473ff018b8fd9a39c723ca81a9
const $865f8967f053c4dc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "forgeExtensionRenderingContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "uiModificationsContext"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "forgeExtensionRenderingContext",
                            "variableName": "forgeExtensionRenderingContext"
                        },
                        {
                            "kind": "Variable",
                            "name": "uiModificationsContext",
                            "variableName": "uiModificationsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "fragment_AtlassianUiModificationsCore_RootFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "rootUiModificationsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraForgeQuery",
                            "kind": "LinkedField",
                            "name": "forge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e45293f8a27ead7abd3ce9b719eca0f4e86961473ff018b8fd9a39c723ca81a9",
            "metadata": {},
            "name": "rootUiModificationsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$865f8967f053c4dc$var$node.hash = "9036ea3b10c5003976e51018f89bdc35";
var $865f8967f053c4dc$export$2e2bcd8739ae039 = $865f8967f053c4dc$var$node;

});


parcelRegister("l7YB5", function(module, exports) {
$parcel$export(module.exports, "ScreenErrorBoundary", () => (parcelRequire("60sOE")).default);

var $60sOE = parcelRequire("60sOE");

});
parcelRegister("60sOE", function(module, exports) {
$parcel$export(module.exports, "default", () => $39af65ba2246bc53$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gMSZD = parcelRequire("gMSZD");
const $39af65ba2246bc53$var$ScreenErrorBoundary = ({ screenName: screenName, children: children, renderError: renderError })=>// TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
        packageName: screenName,
        id: `${screenName}Screen`,
        renderError: renderError
    }, children);
var $39af65ba2246bc53$export$2e2bcd8739ae039 = $39af65ba2246bc53$var$ScreenErrorBoundary;

});


parcelRegister("4F4yI", function(module, exports) {
$parcel$export(module.exports, "RequestCreateAnonymousSuccess", () => $17b31c35dc2c8596$export$c343a4f818004f01);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $17b31c35dc2c8596$export$c343a4f818004f01 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("1UeUg")), {
        moduleId: "./src/view/request-create-anonymous-success/request-create-anonymous-success.tsx"
    })
});

});
parcelRegister("1UeUg", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("dWqi6").then(()=>parcelRequire('2PeJt'));

});


parcelRegister("9Iutg", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePage", () => $4237d289ab619b10$export$cf665508b87b4a0f);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $4237d289ab619b10$var$loader = (0, $60vf0.lazyForPaint)(()=>{
    return (parcelRequire("6R3eX"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hocs.tsx"
});
const $4237d289ab619b10$export$cf665508b87b4a0f = (0, $gi5ak.default)({
    loader: $4237d289ab619b10$var$loader
});

});
parcelRegister("6R3eX", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("iI9gE").then(()=>parcelRequire('60KXD'));

});


parcelRegister("4mNG1", function(module, exports) {
$parcel$export(module.exports, "RequestCreatePageForHubs", () => $2d0ad40c6e4d4520$export$43b5a631464c5e8e);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $2d0ad40c6e4d4520$var$loader = (0, $60vf0.lazyForPaint)(()=>{
    return (parcelRequire("1dkEC"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-page/hub-variant/hub-variant.tsx"
});
const $2d0ad40c6e4d4520$export$43b5a631464c5e8e = (0, $gi5ak.default)({
    loader: $2d0ad40c6e4d4520$var$loader
});

});
parcelRegister("1dkEC", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("ibPpH"),
    $e46AW("5YgJY"),
    $e46AW("gtuk5"),
    $e46AW("5fJ5v"),
    $e46AW("1nzUi"),
    $e46AW("aBuAd"),
    $e46AW("jZPNc"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("kgNSH"),
    $e46AW("45caK"),
    $e46AW("3vgBs"),
    $e46AW("cDliv"),
    $e46AW("3d0wD")
]).then(()=>parcelRequire('32S17'));

});


parcelRegister("cwVD2", function(module, exports) {
$parcel$export(module.exports, "RequestFeedback", () => $2c2dea87ef74f4e8$export$3dcde5242ce8b346);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $2c2dea87ef74f4e8$export$3dcde5242ce8b346 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("hoYZn")), {
        moduleId: "./src/view/request-feedback/hocs.tsx"
    })
});

});
parcelRegister("hoYZn", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("liMWX").then(()=>parcelRequire('10RpD'));

});


parcelRegister("6hzbh", function(module, exports) {
$parcel$export(module.exports, "Unsubscribe", () => $58d4e05dc9dbe7b0$export$cf424b9d16eab6b0);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $58d4e05dc9dbe7b0$export$cf424b9d16eab6b0 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cPMOK")), {
        moduleId: "./src/view/unsubscribe/hocs.tsx"
    })
});

});
parcelRegister("cPMOK", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lXGvi").then(()=>parcelRequire('bmb4X'));

});


parcelRegister("e68D0", function(module, exports) {
$parcel$export(module.exports, "UserProfile", () => $7cc3201083dbfdb4$export$b7b58f2e100445f7);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $7cc3201083dbfdb4$var$loader = (0, $60vf0.lazyForPaint)(()=>(parcelRequire("5bPrh")), {
    moduleId: "./src/view/user-profile/hocs.tsx"
});
const $7cc3201083dbfdb4$export$b7b58f2e100445f7 = (0, $gi5ak.default)({
    loader: $7cc3201083dbfdb4$var$loader
});

});
parcelRegister("5bPrh", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1oLOq").then(()=>parcelRequire('5eSD9'));

});


parcelRegister("eHkSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5edeb653e2260b8e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $54jwS = parcelRequire("54jwS");

var $2dPNI = parcelRequire("2dPNI");

var $knJah = parcelRequire("knJah");

var $3OiWH = parcelRequire("3OiWH");

var $29xKq = parcelRequire("29xKq");
class $5edeb653e2260b8e$var$PortalScreenWithBrowserMetrics extends $4fqPo.Component {
    constructor(props){
        super(props), this.state = {
            screenWasHidden: false
        }, this.startTimer = (screenName)=>{
            const { preventBrowserMetricsTimerResetOnScreenMount: preventBrowserMetricsTimerResetOnScreenMount, stopBrowserMetricsTransitionToNewScreen: stopBrowserMetricsTransitionToNewScreen } = this.props;
            if (!preventBrowserMetricsTimerResetOnScreenMount) {
                (0, $29xKq.devLog)('Browser metrics: starting timer for screen:', screenName);
                /**
       * Browser metrics v3 start page load
       */ (0, $2dPNI.startPageLoad)(screenName);
            } else stopBrowserMetricsTransitionToNewScreen();
        }, this.handleVisibilityChange = ()=>{
            this.setState({
                screenWasHidden: true
            });
        };
        this.startTimer(props.screenName);
    }
    // this must be called before post-mount and post-update lifecycle methods
    // to ensure it is called before `endTimer` is called.
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { screenName: screenName, screenId: screenId } = this.props;
        if (nextProps.screenName !== screenName || nextProps.screenId !== screenId) {
            this.setState({
                screenWasHidden: false
            });
            this.startTimer(nextProps.screenName);
        }
    }
    componentDidMount() {
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false);
    }
    render() {
        const { screenName: screenName, children: children, screenId: screenId } = this.props;
        // We need to set the screen name to undefined if the window visibility changed
        // so the browser metrics event never gets fired.
        // If the user changes tabs while the page is loading, the time to load is calculated incorrectly.
        // So we're discarding these events as a workaround. See FSD-3537.
        const screenNameForBrowserMetrics = this.state.screenWasHidden ? undefined : screenName;
        return /*#__PURE__*/ $4fqPo.createElement((0, $3OiWH.ScreenNameProvider), {
            params: {
                screenId: screenId,
                screenName: screenNameForBrowserMetrics
            }
        }, /*#__PURE__*/ $4fqPo.createElement((0, $54jwS.AnalyticsContext), {
            sourceName: screenName,
            sourceType: (0, $54jwS.ScreenTypes).SCREEN
        }, children));
    }
}
/**
 * Establishes a new screen for analytics and browsermetrics purposes.
 * Will set analytics context, and start a browsermetrics timer for the screen.
 * @param screenName the name of the screen, fired in the event
 * @param screenId an optional further identifier for cases when a user can navigate between two
 * different screens with the same name, e.g. two request create screens for different request types
 */ const $5edeb653e2260b8e$var$AnalyticsScreen = (props)=>{
    const { screenName: screenName, children: children, screenId: screenId } = props;
    return /*#__PURE__*/ $4fqPo.createElement((0, $knJah.BrowserMetricsScreenTransitionStatusContext).Consumer, null, (value)=>/*#__PURE__*/ $4fqPo.createElement($5edeb653e2260b8e$var$PortalScreenWithBrowserMetrics, {
            screenName: screenName,
            screenId: screenId,
            preventBrowserMetricsTimerResetOnScreenMount: value.preventBrowserMetricsTimerResetOnScreenMount,
            stopBrowserMetricsTransitionToNewScreen: value.stopBrowserMetricsTransitionToNewScreen
        }, children));
};
var $5edeb653e2260b8e$export$2e2bcd8739ae039 = $5edeb653e2260b8e$var$AnalyticsScreen;

});
parcelRegister("3OiWH", function(module, exports) {
$parcel$export(module.exports, "ScreenNameProvider", () => $ecae29fe1bcdc671$export$e037354b8fc39c88);
$parcel$export(module.exports, "clearScreenName", () => $ecae29fe1bcdc671$export$d4736a6a534144a);
$parcel$export(module.exports, "default", () => $ecae29fe1bcdc671$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $ecae29fe1bcdc671$var$ScreenNameContext = /*#__PURE__*/ $4fqPo.createContext({
    screenName: undefined
});
const $ecae29fe1bcdc671$export$e037354b8fc39c88 = (props)=>/*#__PURE__*/ $4fqPo.createElement($ecae29fe1bcdc671$var$ScreenNameContext.Provider, {
        value: props.params
    }, props.children);
const $ecae29fe1bcdc671$export$d4736a6a534144a = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $4fqPo.createElement($ecae29fe1bcdc671$var$ScreenNameContext.Provider, {
            value: {
                screenName: undefined
            }
        }, /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props));
const $ecae29fe1bcdc671$var$withScreenName = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $4fqPo.createElement($ecae29fe1bcdc671$var$ScreenNameContext.Consumer, null, (value)=>/*#__PURE__*/ $4fqPo.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
var $ecae29fe1bcdc671$export$2e2bcd8739ae039 = $ecae29fe1bcdc671$var$withScreenName;

});


parcelRegister("bp9tj", function(module, exports) {
$parcel$export(module.exports, "createRouteWithLayout", () => $df4ed8752e083d6e$export$64cff199c78ee95d);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("aHmOa");
var $hJsSa = parcelRequire("hJsSa");
const $df4ed8752e083d6e$var$selector = (0, $3yyCx.createSelector)((0, $2mzxy.getHeadless), (headerless)=>({
        headerless: headerless
    }));
const $df4ed8752e083d6e$export$64cff199c78ee95d = (route, screenName, layoutProps)=>{
    const { path: path, component: component } = route;
    const LayoutRouteComponent = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hJsSa.BannerWithPaperLayoutRoute), {
            path: path,
            component: component,
            layoutProps: {
                headerless: props.headerless,
                ...layoutProps
            },
            screenName: screenName
        });
    };
    return {
        ...route,
        component: (0, $lM7Z9.withRouter)((0, $bmgw6.default)($df4ed8752e083d6e$var$selector)(LayoutRouteComponent))
    };
};

});
parcelRegister("aHmOa", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => (parcelRequire("hJsSa")).BannerWithPaperLayoutRoute);

var $hJsSa = parcelRequire("hJsSa");

});
parcelRegister("hJsSa", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutRoute", () => $b149a196a5e97d4e$export$fd1a0cfe11934244);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("gNfyY");
var $5lxa8 = parcelRequire("5lxa8");

var $6bGmX = parcelRequire("6bGmX");

var $cijxS = parcelRequire("cijxS");

var $l4FWm = parcelRequire("l4FWm");
parcelRequire("jQ3Kc");
var $1gAUX = parcelRequire("1gAUX");
parcelRequire("951Ke");
var $dxTw2 = parcelRequire("dxTw2");
parcelRequire("e2QHY");
var $7aI9q = parcelRequire("7aI9q");
const $b149a196a5e97d4e$export$75ef22cdda92e1da = (props)=>{
    const { children: children, helpCenterBanner: helpCenterBanner, ...restProps } = props;
    const [initialBannerUrl] = $4fqPo.useState(helpCenterBanner);
    // Use the useCachedUrl hook to handle the banner URL
    const { cachedBannerUrl: cachedBannerUrl, isLoading: isBannerImageLoading } = (0, $l4FWm.useCachedUrl)(helpCenterBanner);
    if ((0, $bG6ob.isUseHelpCenterRefresh)()) return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, (0, $6bGmX.default).checkGate('add_ufo_holds_to_help_center_banner') && /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), (0, $6bGmX.default).checkGate('jsm_help_center_branding_image_improvement') && initialBannerUrl && /*#__PURE__*/ $4fqPo.createElement("link", {
        rel: "preload",
        as: "fetch",
        href: initialBannerUrl,
        crossOrigin: "anonymous"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $1gAUX.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, (0, $6bGmX.default).checkGate('add_ufo_holds_to_help_center_banner') && /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
        name: "banner-with-paper-layout-image-loader",
        hold: isBannerImageLoading
    }), /*#__PURE__*/ $4fqPo.createElement((0, $dxTw2.default), {
        ...restProps,
        helpCenterBanner: cachedBannerUrl || undefined
    }, children));
};
const $b149a196a5e97d4e$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getHelpCenterBanner), (0, $5lxa8.getShown), (0, $i8gmD.getHelpCenterBrandingLoader), (helpCenterBanner, searchShown, isBrandingLoaded)=>({
        helpCenterBanner: helpCenterBanner,
        searchShown: searchShown,
        isBrandingLoaded: isBrandingLoaded
    }));
const $b149a196a5e97d4e$var$ConnectedBannerWithPaperLayout = (0, $bmgw6.default)($b149a196a5e97d4e$var$selector)($b149a196a5e97d4e$export$75ef22cdda92e1da);
const $b149a196a5e97d4e$export$fd1a0cfe11934244 = (0, $7aI9q.default)($b149a196a5e97d4e$var$ConnectedBannerWithPaperLayout);
var $b149a196a5e97d4e$export$2e2bcd8739ae039 = $b149a196a5e97d4e$var$ConnectedBannerWithPaperLayout;

});
parcelRegister("gNfyY", function(module, exports) {
$parcel$export(module.exports, "getShown", () => (parcelRequire("5lxa8")).getShown);
$parcel$export(module.exports, "getTerm", () => (parcelRequire("5lxa8")).getTerm);

var $5lxa8 = parcelRequire("5lxa8");

});
parcelRegister("5lxa8", function(module, exports) {
$parcel$export(module.exports, "getShown", () => $0170f1a2368a8eea$export$75d5ea8092347462);
$parcel$export(module.exports, "getTerm", () => $0170f1a2368a8eea$export$3947fb2f9e53bfd);
const $0170f1a2368a8eea$export$75d5ea8092347462 = (state)=>state.ui.search.shown;
const $0170f1a2368a8eea$export$3947fb2f9e53bfd = (state)=>state.ui.search.term;

});


parcelRegister("l4FWm", function(module, exports) {
$parcel$export(module.exports, "useCachedUrl", () => $bad828c704237dcf$export$6c4a7056bc19c165);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");

var $8aBg0 = parcelRequire("8aBg0");
const $bad828c704237dcf$export$6c4a7056bc19c165 = function(inputUrl) {
    const [cachedBannerUrl, setCachedBannerUrl] = (0, $4fqPo.useState)();
    const [isLoading, setIsLoading] = (0, $4fqPo.useState)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    (0, $4fqPo.useEffect)(()=>{
        if (!!inputUrl && inputUrl.startsWith('blob:')) {
            setCachedBannerUrl(inputUrl);
            setIsLoading(false);
        } else if (!!inputUrl) (0, $8aBg0.getObjectURLFromMediaURLWithCaching)(inputUrl).then((url)=>{
            setCachedBannerUrl(url);
            setIsLoading(false);
        }).catch((error)=>{
            setIsLoading(false);
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'useCachedUrl',
                attributes: {
                    errorMessage: error.message
                }
            }).fire((0, $gHT3x.ANALYTICS_BRIDGE_CHANNEL));
        });
        else {
            setCachedBannerUrl(null);
            setIsLoading(false);
        }
    }, [
        createAnalyticsEvent,
        inputUrl,
        setCachedBannerUrl
    ]);
    return {
        cachedBannerUrl: cachedBannerUrl,
        isLoading: isLoading
    };
};

});
parcelRegister("8aBg0", function(module, exports) {
$parcel$export(module.exports, "getObjectURLFromMediaURLWithCaching", () => $7aae2e66a8663004$export$183e77d363d2e63e);

var $4i2V5 = parcelRequire("4i2V5");

var $6bGmX = parcelRequire("6bGmX");

var $lOJfe = parcelRequire("lOJfe");
const $7aae2e66a8663004$var$PARAM_KEY_TOKEN = 'token';
const $7aae2e66a8663004$var$PARAM_KEY_MAX_AGE = 'max-age';
const $7aae2e66a8663004$var$PARAM_KEY_HEIGHT = 'height';
const $7aae2e66a8663004$var$DEFAULT_PARAM_VALUE_MAX_AGE = '31536000'; // maximum value for max-age supported by media services
const $7aae2e66a8663004$var$HEIGHT_MAX_PARAM_VALUE = '4096'; // maximum value for height supported by media services
const $7aae2e66a8663004$var$MAX_RETRIES = 5;
const $7aae2e66a8663004$var$MS_BETWEEN_TRIES = 500;
const $7aae2e66a8663004$var$USE_ASYNC = true;
// A local cache for the blob URLs to avoid polluting blob storage
const $7aae2e66a8663004$var$BLOB_CACHE = {};
const $7aae2e66a8663004$var$BLOB_FUTURE_CACHE = {};
const $7aae2e66a8663004$export$183e77d363d2e63e = (completeUrl, msBetweenTries = $7aae2e66a8663004$var$MS_BETWEEN_TRIES)=>{
    return (0, $6bGmX.default).checkGate('jsm_help_center_branding_image_improvement') ? $7aae2e66a8663004$var$internalGetObjectURLFromMediaURLWithCachingAndRace(completeUrl, msBetweenTries) : $7aae2e66a8663004$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries);
};
const $7aae2e66a8663004$var$internalGetObjectURLFromMediaURLWithCaching = (completeUrl, msBetweenTries = $7aae2e66a8663004$var$MS_BETWEEN_TRIES, tryNumber = 1)=>{
    // Suppressing existing violation. Please fix this.
    const { url: url, token: token } = $7aae2e66a8663004$var$parseUrl(completeUrl);
    // if we already created a blob url for this url, just finish.
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if ($7aae2e66a8663004$var$BLOB_CACHE[url]) // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    return Promise.resolve($7aae2e66a8663004$var$BLOB_CACHE[url]);
    const req = new XMLHttpRequest();
    req.open('GET', url, $7aae2e66a8663004$var$USE_ASYNC);
    req.responseType = 'arraybuffer';
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    token && req.setRequestHeader('Authorization', `Bearer ${token}`);
    return new Promise((resolve, reject)=>{
        req.onload = ()=>{
            if (req.status === 200) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const blobUrl = (0, $lOJfe.createObjectURLFromResponse)(req.response, req.getResponseHeader('content-type'));
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                $7aae2e66a8663004$var$BLOB_CACHE[url] = blobUrl;
                resolve(blobUrl);
            } else reject(req.statusText);
        };
        req.onerror = ()=>{
            if (req.status === 404 && tryNumber < $7aae2e66a8663004$var$MAX_RETRIES) $7aae2e66a8663004$var$wait(msBetweenTries).then(()=>$7aae2e66a8663004$var$internalGetObjectURLFromMediaURLWithCaching(completeUrl, msBetweenTries, tryNumber + 1)).then(resolve, reject);
            else reject(req.statusText);
        };
        req.send();
    });
};
const $7aae2e66a8663004$var$internalGetObjectURLFromMediaURLWithCachingAndRace = (completeUrl, msBetweenTries = $7aae2e66a8663004$var$MS_BETWEEN_TRIES, tryNumber = 1)=>{
    const { url: url, token: token } = $7aae2e66a8663004$var$parseUrl(completeUrl);
    if (tryNumber > $7aae2e66a8663004$var$MAX_RETRIES) throw Error(`failed to load ${url} after ${$7aae2e66a8663004$var$MAX_RETRIES} retries. Giving up.`);
    // during initial call: if we already requested a blob url for this url just return from cache
    if (tryNumber === 1 && $7aae2e66a8663004$var$BLOB_FUTURE_CACHE[url] !== undefined) return $7aae2e66a8663004$var$BLOB_FUTURE_CACHE[url];
    const preloadAbort = new AbortController();
    const cacheableFetch = fetch(url, {
        headers: token ? {
            Authorization: `Bearer ${token}`
        } : {}
    }).then((response)=>{
        if (response.ok) {
            preloadAbort.abort('cache was faster');
            return response.blob().then((blob)=>URL.createObjectURL(blob));
        }
        throw new Error(response.statusText);
    });
    const preloadableFetch = fetch(completeUrl, {
        signal: preloadAbort.signal
    }).then((response)=>{
        if (response.ok) return response.blob().then((blob)=>URL.createObjectURL(blob));
        throw new Error(response.statusText);
    });
    const racePromise = Promise.any([
        cacheableFetch,
        preloadableFetch
    ]).catch(()=>{
        return $7aae2e66a8663004$var$wait(msBetweenTries).then(()=>$7aae2e66a8663004$var$internalGetObjectURLFromMediaURLWithCachingAndRace(completeUrl, msBetweenTries, tryNumber + 1));
    });
    $7aae2e66a8663004$var$BLOB_FUTURE_CACHE[url] = racePromise;
    return racePromise;
};
const $7aae2e66a8663004$var$parseUrl = (completeUrl)=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { url: url, query: query } = $4i2V5.parseUrl(completeUrl);
    // parse the url and token
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const mediaApiJwt = query[$7aae2e66a8663004$var$PARAM_KEY_TOKEN];
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    delete query[$7aae2e66a8663004$var$PARAM_KEY_TOKEN];
    // prepare the query string
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$7aae2e66a8663004$var$PARAM_KEY_MAX_AGE] = $7aae2e66a8663004$var$DEFAULT_PARAM_VALUE_MAX_AGE;
    // ensure no cropping/fitting/scaling of the image until we release the cropper
    // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    query[$7aae2e66a8663004$var$PARAM_KEY_HEIGHT] = $7aae2e66a8663004$var$HEIGHT_MAX_PARAM_VALUE;
    const parsedUrl = `${url}?${$4i2V5.stringify(query)}`;
    return {
        url: parsedUrl,
        token: mediaApiJwt
    };
};
const $7aae2e66a8663004$export$d2adf65b87e47523 = ()=>{
    Object.keys($7aae2e66a8663004$var$BLOB_CACHE).forEach((cachedItem)=>{
        delete $7aae2e66a8663004$var$BLOB_CACHE[cachedItem];
    });
    Object.keys($7aae2e66a8663004$var$BLOB_FUTURE_CACHE).forEach((cachedItem)=>{
        delete $7aae2e66a8663004$var$BLOB_FUTURE_CACHE[cachedItem];
    });
};
const $7aae2e66a8663004$var$wait = (msBetweenTries)=>new Promise((r)=>setTimeout(r, msBetweenTries));

});
parcelRegister("lOJfe", function(module, exports) {
$parcel$export(module.exports, "createObjectURLFromResponse", () => $c7610d4393688cc9$export$c1dfa855638dae6c);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c7610d4393688cc9$export$c1dfa855638dae6c = (response, contentType)=>{
    const arrayBuffer = [
        response
    ];
    const blob = new Blob(arrayBuffer, {
        type: contentType
    });
    return URL.createObjectURL(blob);
};

});



parcelRegister("jQ3Kc", function(module, exports) {
$parcel$export(module.exports, "BannerWithGridLayoutDumb", () => (parcelRequire("1gAUX")).default);

var $1gAUX = parcelRequire("1gAUX");

});
parcelRegister("1gAUX", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8de94852b6e8cc3$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");
parcelRequire("6uBMs");
var $93uvS = parcelRequire("93uvS");
parcelRequire("9im5N");
var $hvxv7 = parcelRequire("hvxv7");
parcelRequire("7BEQF");
var $1gHGC = parcelRequire("1gHGC");

var $7zOGv = parcelRequire("7zOGv");

var $fNSBJ = parcelRequire("fNSBJ");
var $iHhPj = parcelRequire("iHhPj");

var $bJQcu = parcelRequire("bJQcu");
parcelRequire("bYk9e");
var $hVqlO = parcelRequire("hVqlO");
parcelRequire("fbqkx");
var $hzxL3 = parcelRequire("hzxL3");
const $f8de94852b6e8cc3$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iHhPj.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fNSBJ.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $f8de94852b6e8cc3$var$BannerWithGridLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, searchShown: searchShown, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent })=>{
    const showCompressedBanner = ![
        'none',
        'note'
    ].includes(paperAppearance || 'normal');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f8de94852b6e8cc3$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f8de94852b6e8cc3$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f8de94852b6e8cc3$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f8de94852b6e8cc3$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93uvS.default), {
        className: "px-paper-layout"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bJQcu.BannerWithLayoutHeaderMemoizedHOC), {
        isAnonymous: isAnonymous,
        removeHeader: removeHeader,
        headerless: headerless,
        hideSearchButton: hideSearchButton,
        helpCenterBanner: helpCenterBanner,
        hideBanner: hideBanner,
        prefetchBrandingModel: prefetchBrandingModel,
        renderForPaperLayout: !showCompressedBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hVqlO.default), {
        appearance: paperAppearance
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hzxL3.default), {
        appearance: paperAppearance,
        isCSM: isCSM,
        hideSkipToMainContent: hideSkipToMainContent
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7zOGv.AutoHeightBody), null)))));
};
var $f8de94852b6e8cc3$export$2e2bcd8739ae039 = $f8de94852b6e8cc3$var$BannerWithGridLayoutDumb;
const $f8de94852b6e8cc3$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f8de94852b6e8cc3$var$SidebarPusherRoot = /*#__PURE__*/ (0, $el3DQ.default)((0, $1gHGC.default)).withConfig({
    componentId: "sc-kh8qt6-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $f8de94852b6e8cc3$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-kh8qt6-1"
})`display:flex;flex-direction:column;min-height:${$f8de94852b6e8cc3$var$CONTAINER_MIN_HEIGHT};`;
const $f8de94852b6e8cc3$export$36525627ce333d44 = /*#__PURE__*/ (0, $el3DQ.default)((0, $hvxv7.Flipper)).withConfig({
    componentId: "sc-kh8qt6-2"
})`display:flex;flex-direction:column;`;

});
parcelRegister("9im5N", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("hvxv7")).Flipper);

var $hvxv7 = parcelRequire("hvxv7");

});
parcelRegister("hvxv7", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => $bb7a1b508a492e4e$export$3e759dc50fe56038);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("aoxmx");
var $UwTQP = parcelRequire("UwTQP");
var $wYFix = parcelRequire("wYFix");
const $bb7a1b508a492e4e$export$3e759dc50fe56038 = (props)=>/*#__PURE__*/ $4fqPo.createElement((0, $wYFix.default), {
        ...props,
        spring: {
            stiffness: 600,
            damping: 40
        }
    }, props.children);
const $bb7a1b508a492e4e$export$c3816ea9cb166de0 = (props)=>/*#__PURE__*/ $4fqPo.createElement((0, $UwTQP.default), props, props.children);

});
parcelRegister("aoxmx", function(module, exports) {
$parcel$export(module.exports, "Flipper", () => (parcelRequire("wYFix")).default);
$parcel$export(module.exports, "Flipped", () => (parcelRequire("UwTQP")).default);

var $wYFix = parcelRequire("wYFix");

var $UwTQP = parcelRequire("UwTQP");

var $iNW05 = parcelRequire("iNW05");
var // for umd build
$7916065b387208ff$export$2e2bcd8739ae039 = {
    Flipper: (0, $wYFix.default),
    Flipped: (0, $UwTQP.default),
    ExitContainer: (0, $iNW05.default)
};

});
parcelRegister("wYFix", function(module, exports) {
$parcel$export(module.exports, "FlipContext", () => $06320c192766e73f$export$aa77f7b4e64b9ea9);
$parcel$export(module.exports, "PortalContext", () => $06320c192766e73f$export$60d741e20e0aa309);
$parcel$export(module.exports, "default", () => $06320c192766e73f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");


var $io5og = parcelRequire("io5og");

var $8Tzwm = parcelRequire("8Tzwm");
function $06320c192766e73f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $06320c192766e73f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $06320c192766e73f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $06320c192766e73f$export$aa77f7b4e64b9ea9 = (0, $4fqPo.createContext)("flip");
var $06320c192766e73f$export$60d741e20e0aa309 = (0, $4fqPo.createContext)("portal");
var $06320c192766e73f$var$Flipper = function(_Component) {
    $06320c192766e73f$var$_inherits(Flipper, _Component);
    function Flipper(props) {
        $06320c192766e73f$var$_classCallCheck(this, Flipper);
        var _this = $06320c192766e73f$var$_possibleConstructorReturn(this, _Component.call(this, props));
        _this.inProgressAnimations = {};
        _this.flipCallbacks = {};
        return _this;
    }
    Flipper.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate(prevProps) {
        if (prevProps.flipKey !== this.props.flipKey) return (0, $8Tzwm.getFlippedElementPositionsBeforeUpdate)({
            element: this.el,
            // if onExit callbacks exist here, we'll cache the DOM node
            flipCallbacks: this.flipCallbacks,
            inProgressAnimations: this.inProgressAnimations,
            portalKey: this.props.portalKey
        });
        return null;
    };
    Flipper.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, cachedData) {
        if (this.props.flipKey !== prevProps.flipKey) (0, $io5og.default)({
            cachedFlipChildrenPositions: cachedData.flippedElementPositions,
            cachedOrderedFlipIds: cachedData.cachedOrderedFlipIds,
            containerEl: this.el,
            inProgressAnimations: this.inProgressAnimations,
            flipCallbacks: this.flipCallbacks,
            applyTransformOrigin: this.props.applyTransformOrigin,
            spring: this.props.spring,
            debug: this.props.debug,
            portalKey: this.props.portalKey,
            staggerConfig: this.props.staggerConfig,
            handleEnterUpdateDelete: this.props.handleEnterUpdateDelete,
            decisionData: {
                prev: prevProps.decisionData,
                current: this.props.decisionData
            }
        });
    };
    Flipper.prototype.render = function render() {
        var _this2 = this;
        var _props = this.props, element = _props.element, className = _props.className, portalKey = _props.portalKey;
        var Element = element;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($06320c192766e73f$export$60d741e20e0aa309.Provider, {
            value: portalKey
        }, (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($06320c192766e73f$export$aa77f7b4e64b9ea9.Provider, {
            value: this.flipCallbacks
        }, (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Element, {
            className: className,
            ref: function ref(el) {
                return _this2.el = el;
            }
        }, this.props.children)));
    };
    return Flipper;
}((0, $4fqPo.Component));
$06320c192766e73f$var$Flipper.propTypes = {};
$06320c192766e73f$var$Flipper.defaultProps = {
    applyTransformOrigin: true,
    element: "div"
};
var $06320c192766e73f$export$2e2bcd8739ae039 = $06320c192766e73f$var$Flipper;

});
parcelRegister("io5og", function(module, exports) {
$parcel$export(module.exports, "default", () => $d62ea64d5c9f9597$export$2e2bcd8739ae039);

var $fT69s = parcelRequire("fT69s");

var $9rYsR = parcelRequire("9rYsR");

var $8Tzwm = parcelRequire("8Tzwm");

var $gmpEl = parcelRequire("gmpEl");

var $3C3VY = parcelRequire("3C3VY");
var $d62ea64d5c9f9597$var$createScopedSelector = function createScopedSelector(element, portalKey) {
    if (portalKey) return function(selector) {
        return document.querySelectorAll("[" + $gmpEl.DATA_PORTAL_KEY + "=" + portalKey + "]" + selector);
    };
    else return function(selector) {
        return element.querySelectorAll(selector);
    };
};
var $d62ea64d5c9f9597$var$createGetElementFunc = function createGetElementFunc(element, portalKey) {
    // this should only ever return 1 element
    return function(id) {
        return $d62ea64d5c9f9597$var$createScopedSelector(element, portalKey)("[" + $gmpEl.DATA_FLIP_ID + "=\"" + id + "\"]")[0];
    };
};
var $d62ea64d5c9f9597$var$onFlipKeyUpdate = function onFlipKeyUpdate(_ref) {
    var _ref$cachedOrderedFli = _ref.cachedOrderedFlipIds, cachedOrderedFlipIds = _ref$cachedOrderedFli === undefined ? [] : _ref$cachedOrderedFli, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, _ref$cachedFlipChildr = _ref.cachedFlipChildrenPositions, cachedFlipChildrenPositions = _ref$cachedFlipChildr === undefined ? {} : _ref$cachedFlipChildr, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, containerEl = _ref.containerEl, applyTransformOrigin = _ref.applyTransformOrigin, spring = _ref.spring, debug = _ref.debug, portalKey = _ref.portalKey, _ref$staggerConfig = _ref.staggerConfig, staggerConfig = _ref$staggerConfig === undefined ? {} : _ref$staggerConfig, _ref$decisionData = _ref.decisionData, decisionData = _ref$decisionData === undefined ? {} : _ref$decisionData, handleEnterUpdateDelete = _ref.handleEnterUpdateDelete;
    var newFlipChildrenPositions = (0, $8Tzwm.getFlippedElementPositionsAfterUpdate)({
        element: containerEl,
        portalKey: portalKey
    });
    var scopedSelector = $d62ea64d5c9f9597$var$createScopedSelector(containerEl, portalKey);
    var getElement = $d62ea64d5c9f9597$var$createGetElementFunc(containerEl, portalKey);
    var isFlipped = function isFlipped(id) {
        return cachedFlipChildrenPositions[id] && newFlipChildrenPositions[id];
    };
    var unflippedIds = Object.keys(cachedFlipChildrenPositions).concat(Object.keys(newFlipChildrenPositions)).filter(function(id) {
        return !isFlipped(id);
    });
    var baseArgs = {
        flipCallbacks: flipCallbacks,
        getElement: getElement,
        cachedFlipChildrenPositions: cachedFlipChildrenPositions,
        newFlipChildrenPositions: newFlipChildrenPositions,
        inProgressAnimations: inProgressAnimations
    };
    var _animateUnflippedElem = (0, $fT69s.default)((0, $3C3VY.assign)({}, baseArgs, {
        unflippedIds: unflippedIds
    })), hideEnteringElements = _animateUnflippedElem.hideEnteringElements, animateEnteringElements = _animateUnflippedElem.animateEnteringElements, animateExitingElements = _animateUnflippedElem.animateExitingElements;
    var flippedIds = cachedOrderedFlipIds.filter(isFlipped);
    var animateFlippedElementsArgs = (0, $3C3VY.assign)({}, baseArgs, {
        flippedIds: flippedIds,
        applyTransformOrigin: applyTransformOrigin,
        spring: spring,
        debug: debug,
        staggerConfig: staggerConfig,
        decisionData: decisionData,
        scopedSelector: scopedSelector
    });
    // the function handles putting flipped elements back in their original positions
    // and returns another function to actually call flip
    var flip = (0, $9rYsR.default)(animateFlippedElementsArgs);
    if (handleEnterUpdateDelete) handleEnterUpdateDelete({
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements,
        animateFlippedElements: flip
    });
    else {
        hideEnteringElements();
        animateExitingElements().then(animateEnteringElements);
        flip();
    }
};
var $d62ea64d5c9f9597$export$2e2bcd8739ae039 = $d62ea64d5c9f9597$var$onFlipKeyUpdate;

});
parcelRegister("fT69s", function(module, exports) {
$parcel$export(module.exports, "default", () => $b910c39e0ce89877$export$2e2bcd8739ae039);
var $b910c39e0ce89877$var$animateUnflippedElements = function animateUnflippedElements(_ref) {
    var unflippedIds = _ref.unflippedIds, flipCallbacks = _ref.flipCallbacks, getElement = _ref.getElement, newFlipChildrenPositions = _ref.newFlipChildrenPositions, cachedFlipChildrenPositions = _ref.cachedFlipChildrenPositions, inProgressAnimations = _ref.inProgressAnimations;
    var enteringElements = unflippedIds.filter(function(id) {
        return newFlipChildrenPositions[id] && flipCallbacks[id];
    });
    var exitingElementIds = unflippedIds.filter(function(id) {
        return cachedFlipChildrenPositions[id] && flipCallbacks[id] && flipCallbacks[id].onExit;
    });
    var hideEnteringElements = function hideEnteringElements() {
        enteringElements.forEach(function(id) {
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) {
                var element = getElement(id);
                element.style.opacity = "0";
            }
        });
    };
    var animateEnteringElements = function animateEnteringElements() {
        enteringElements.forEach(function(id, i) {
            var element = getElement(id);
            if (flipCallbacks[id] && flipCallbacks[id].onAppear) flipCallbacks[id].onAppear(element, i);
        });
    };
    var closureResolve = void 0;
    var promiseToReturn = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var fragmentTuples = [];
    var exitingElementCount = 0;
    var onExitCallbacks = exitingElementIds.map(function(id, i) {
        var _cachedFlipChildrenPo = cachedFlipChildrenPositions[id].domData, element = _cachedFlipChildrenPo.element, parent = _cachedFlipChildrenPo.parent, _cachedFlipChildrenPo2 = _cachedFlipChildrenPo.childPosition, top = _cachedFlipChildrenPo2.top, left = _cachedFlipChildrenPo2.left, width = _cachedFlipChildrenPo2.width, height = _cachedFlipChildrenPo2.height;
        // insert back into dom
        if (getComputedStyle(parent).position === "static") parent.style.position = "relative";
        element.style.transform = "matrix(1, 0, 0, 1, 0, 0)";
        element.style.position = "absolute";
        element.style.top = top + "px";
        element.style.left = left + "px";
        // taken out of the dom flow, the element might have lost these dimensions
        element.style.height = height + "px";
        element.style.width = width + "px";
        var fragmentTuple = fragmentTuples.filter(function(t) {
            return t[0] === parent;
        })[0];
        if (!fragmentTuple) {
            fragmentTuple = [
                parent,
                document.createDocumentFragment()
            ];
            fragmentTuples.push(fragmentTuple);
        }
        fragmentTuple[1].appendChild(element);
        exitingElementCount += 1;
        var stop = function stop() {
            try {
                parent.removeChild(element);
                exitingElementCount -= 1;
                if (exitingElementCount === 0) closureResolve();
            } catch (DOMException) {
            // the element is already gone
            }
        };
        inProgressAnimations[id] = {
            stop: stop
        };
        return function() {
            return flipCallbacks[id].onExit(element, i, stop);
        };
    });
    // now append all the fragments from the onExit callbacks
    // (we use fragments for performance)
    fragmentTuples.forEach(function(t) {
        var parent = t[0];
        var fragment = t[1];
        parent.appendChild(fragment);
    });
    if (!onExitCallbacks.length) closureResolve();
    var animateExitingElements = function animateExitingElements() {
        onExitCallbacks.forEach(function(c) {
            return c();
        });
        return promiseToReturn;
    };
    return {
        hideEnteringElements: hideEnteringElements,
        animateEnteringElements: animateEnteringElements,
        animateExitingElements: animateExitingElements
    };
};
var $b910c39e0ce89877$export$2e2bcd8739ae039 = $b910c39e0ce89877$var$animateUnflippedElements;

});

parcelRegister("9rYsR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e1589a82b42bcd0$export$2e2bcd8739ae039);

var $ebnca = parcelRequire("ebnca");

var $e51su = parcelRequire("e51su");

var $3C3VY = parcelRequire("3C3VY");

var $gmpEl = parcelRequire("gmpEl");

var $1vu6m = parcelRequire("1vu6m");

var $98NNB = parcelRequire("98NNB");
var $6e1589a82b42bcd0$export$3bb3cb1a74f66649 = function convertMatrix3dArrayTo2dArray(matrix) {
    return [
        0,
        1,
        4,
        5,
        12,
        13
    ].map(function(index) {
        return matrix[index];
    });
};
var $6e1589a82b42bcd0$export$ae3bd8c5261b681e = function convertMatrix2dArrayToString(matrix) {
    return "matrix(" + matrix.join(", ") + ")";
};
var $6e1589a82b42bcd0$export$7fd64b870f6a7bb9 = function invertTransformsForChildren(_ref) {
    var invertedChildren = _ref.invertedChildren, matrix = _ref.matrix, body = _ref.body;
    invertedChildren.forEach(function(_ref2) {
        var child = _ref2[0], childFlipConfig = _ref2[1];
        if (!body.contains(child)) return;
        var scaleX = matrix[0];
        var scaleY = matrix[3];
        var translateX = matrix[4];
        var translateY = matrix[5];
        var inverseVals = {
            translateX: 0,
            translateY: 0,
            scaleX: 1,
            scaleY: 1
        };
        var transformString = "";
        if (childFlipConfig.translate) {
            inverseVals.translateX = -translateX / scaleX;
            inverseVals.translateY = -translateY / scaleY;
            transformString += "translate(" + inverseVals.translateX + "px, " + inverseVals.translateY + "px)";
        }
        if (childFlipConfig.scale) {
            inverseVals.scaleX = 1 / scaleX;
            inverseVals.scaleY = 1 / scaleY;
            transformString += " scale(" + inverseVals.scaleX + ", " + inverseVals.scaleY + ")";
        }
        child.style.transform = transformString;
    });
};
var $6e1589a82b42bcd0$export$ca4fe190a8429f9e = function createApplyStylesFunc(_ref3) {
    var element = _ref3.element, invertedChildren = _ref3.invertedChildren, body = _ref3.body;
    return function(_ref4) {
        var matrix = _ref4.matrix, opacity = _ref4.opacity, forceMinVals = _ref4.forceMinVals;
        if ((0, $3C3VY.isNumber)(opacity)) element.style.opacity = opacity;
        if (forceMinVals) {
            element.style.minHeight = "1px";
            element.style.minWidth = "1px";
        }
        if (!matrix) return;
        var stringTransform = $6e1589a82b42bcd0$export$ae3bd8c5261b681e(matrix);
        // keep a tiny, (hopefully) invisible rotateZ transform on the element to try to
        // prevent Chrome from pixel-snapping when scale transforms
        // are removed
        stringTransform = stringTransform === "matrix(1, 0, 0, 1, 0, 0)" ? "matrix(1, 0.00001, -0.00001, 1, 0, 0)" : stringTransform;
        element.style.transform = stringTransform;
        if (invertedChildren) $6e1589a82b42bcd0$export$7fd64b870f6a7bb9({
            invertedChildren: invertedChildren,
            matrix: matrix,
            body: body
        });
    };
};
var $6e1589a82b42bcd0$export$90503d75ca6e7d46 = function rectInViewport(_ref5) {
    var top = _ref5.top, bottom = _ref5.bottom, left = _ref5.left, right = _ref5.right;
    return top < window.innerHeight && bottom > 0 && left < window.innerWidth && right > 0;
};
var $6e1589a82b42bcd0$var$getInvertedChildren = function getInvertedChildren(element, id) {
    return (0, $3C3VY.toArray)(element.querySelectorAll("[" + $gmpEl.DATA_INVERSE_FLIP_ID + "=\"" + id + "\"]"));
};
var $6e1589a82b42bcd0$export$3ec95ebfc77511bd = function tweenProp(start, end, position) {
    return start + (end - start) * position;
};
var $6e1589a82b42bcd0$var$animateFlippedElements = function animateFlippedElements(_ref6) {
    var flippedIds = _ref6.flippedIds, flipCallbacks = _ref6.flipCallbacks, inProgressAnimations = _ref6.inProgressAnimations, cachedFlipChildrenPositions = _ref6.cachedFlipChildrenPositions, newFlipChildrenPositions = _ref6.newFlipChildrenPositions, applyTransformOrigin = _ref6.applyTransformOrigin, spring = _ref6.spring, getElement = _ref6.getElement, debug = _ref6.debug, staggerConfig = _ref6.staggerConfig, decisionData = _ref6.decisionData, scopedSelector = _ref6.scopedSelector;
    var body = document.querySelector("body");
    // the stuff below is used so we can return a promise that resolves when all FLIP animations have
    // completed
    var closureResolve = void 0;
    var flipCompletedPromise = new Promise(function(resolve, reject) {
        closureResolve = resolve;
    });
    var withInitFuncs = void 0;
    var completedAnimationIds = [];
    if (debug) // eslint-disable-next-line no-console
    console.error('[react-flip-toolkit]\nThe "debug" prop is set to true. All FLIP animations will return at the beginning of the transition.');
    var duplicateFlipIds = (0, $3C3VY.getDuplicateValsAsStrings)(flippedIds);
    if (duplicateFlipIds.length) // eslint-disable-next-line no-console
    console.error("[react-flip-toolkit]\nThere are currently multiple elements with the same flipId on the page.\nThe animation will only work if each Flipped component has a unique flipId.\nDuplicate flipId" + (duplicateFlipIds.length > 1 ? "s" : "") + ": " + duplicateFlipIds.join("\n"));
    var flipDataArray = flippedIds// take all the measurements we need
    // and return an object with animation functions + necessary data
    .map(function(id) {
        var prevRect = cachedFlipChildrenPositions[id].rect;
        var currentRect = newFlipChildrenPositions[id].rect;
        var prevOpacity = cachedFlipChildrenPositions[id].opacity;
        var currentOpacity = newFlipChildrenPositions[id].opacity;
        var needsForcedMinVals = currentRect.width < 1 || currentRect.height < 1;
        // don't animate elements outside of the user's viewport
        if (!$6e1589a82b42bcd0$export$90503d75ca6e7d46(prevRect) && !$6e1589a82b42bcd0$export$90503d75ca6e7d46(currentRect)) return false;
        // it's never going to be visible, so dont animate it
        if (prevRect.width === 0 && currentRect.width === 0 || prevRect.height === 0 && currentRect.height === 0) return false;
        var element = getElement(id);
        // this might happen if we are rapidly adding & removing elements(?)
        if (!element) return false;
        var flipConfig = JSON.parse(element.dataset.flipConfig);
        var springConfig = (0, $e51su.getSpringConfig)({
            flipperSpring: spring,
            flippedSpring: flipConfig.spring
        });
        var stagger = flipConfig.stagger === true ? "default" : flipConfig.stagger;
        var toReturn = {
            element: element,
            id: id,
            stagger: stagger,
            springConfig: springConfig,
            noOp: true
        };
        if (flipCallbacks[id] && flipCallbacks[id].shouldFlip) {
            var elementShouldFlip = flipCallbacks[id].shouldFlip(decisionData.prev, decisionData.current);
            // this element wont be animated, but its children might be
            if (!elementShouldFlip) return toReturn;
        }
        // don't animate elements that didn't change
        // but we might want to animate children
        if (prevRect.left === currentRect.left && prevRect.top === currentRect.top && prevRect.width === currentRect.width && prevRect.height === currentRect.height && prevOpacity === currentOpacity) // this element wont be animated, but its children might be
        return toReturn;
        toReturn.noOp = false;
        var currentTransform = $ebnca.parse(newFlipChildrenPositions[id].transform);
        var toVals = {
            matrix: currentTransform
        };
        var fromVals = {};
        var transformsArray = [
            currentTransform
        ];
        // we're only going to animate the values that the child wants animated
        if (flipConfig.translate) {
            transformsArray.push($ebnca.translateX(prevRect.left - currentRect.left));
            transformsArray.push($ebnca.translateY(prevRect.top - currentRect.top));
        }
        // going any smaller than 1px breaks transitions in Chrome
        if (flipConfig.scale) {
            transformsArray.push($ebnca.scaleX(Math.max(prevRect.width, 1) / Math.max(currentRect.width, 1)));
            transformsArray.push($ebnca.scaleY(Math.max(prevRect.height, 1) / Math.max(currentRect.height, 1)));
        }
        if (flipConfig.opacity) {
            fromVals.opacity = prevOpacity;
            toVals.opacity = currentOpacity;
        }
        var invertedChildren = [];
        if (!flipCallbacks[id] || !flipCallbacks[id].shouldInvert || flipCallbacks[id].shouldInvert(decisionData.prev, decisionData.current)) invertedChildren = $6e1589a82b42bcd0$var$getInvertedChildren(element, id).map(function(c) {
            return [
                c,
                JSON.parse(c.dataset.flipConfig)
            ];
        });
        fromVals.matrix = $6e1589a82b42bcd0$export$3bb3cb1a74f66649(transformsArray.reduce($ebnca.multiply));
        toVals.matrix = $6e1589a82b42bcd0$export$3bb3cb1a74f66649(toVals.matrix);
        var applyStyles = $6e1589a82b42bcd0$export$ca4fe190a8429f9e({
            element: element,
            invertedChildren: invertedChildren,
            body: body
        });
        var onComplete = void 0;
        if (flipCallbacks[id] && flipCallbacks[id].onComplete) {
            // must cache or else this could cause an error
            var cachedOnComplete = flipCallbacks[id].onComplete;
            onComplete = function onComplete() {
                return cachedOnComplete(element, decisionData.prev, decisionData.current);
            };
        }
        // this should be called when animation ends naturally
        // but also when it is interrupted
        // when it is called, the animation has already been cancelled
        var onAnimationEnd = function onAnimationEnd() {
            delete inProgressAnimations[id];
            (0, $3C3VY.isFunction)(onComplete) && onComplete();
            if (needsForcedMinVals && element) {
                element.style.minHeight = "";
                element.style.minWidth = "";
            }
            completedAnimationIds.push(id);
            if (completedAnimationIds.length >= withInitFuncs.length) // we can theoretically call multiple times since a promise only resolves 1x
            // but that shouldnt happen
            closureResolve();
        };
        var animateOpacity = (0, $3C3VY.isNumber)(fromVals.opacity) && fromVals.opacity !== toVals.opacity;
        var onStartCalled = false;
        var getOnUpdateFunc = function getOnUpdateFunc(stop) {
            inProgressAnimations[id] = {
                stop: stop,
                onComplete: onComplete
            };
            return function(spring) {
                //trigger the user provided onStart function
                if (!onStartCalled) {
                    onStartCalled = true;
                    if (flipCallbacks[id] && flipCallbacks[id].onStart) flipCallbacks[id].onStart(element, decisionData.prev, decisionData.current);
                }
                var currentValue = spring.getCurrentValue();
                if (!body.contains(element)) {
                    stop();
                    return;
                }
                var vals = {};
                vals.matrix = fromVals.matrix.map(function(fromVal, index) {
                    return $6e1589a82b42bcd0$export$3ec95ebfc77511bd(fromVal, toVals.matrix[index], currentValue);
                });
                if (animateOpacity) vals.opacity = $6e1589a82b42bcd0$export$3ec95ebfc77511bd(fromVals.opacity, toVals.opacity, currentValue);
                applyStyles(vals);
            };
        };
        var initializeFlip = function initializeFlip() {
            // before animating, immediately apply FLIP styles to prevent flicker
            applyStyles({
                matrix: fromVals.matrix,
                opacity: animateOpacity && fromVals.opacity,
                forceMinVals: needsForcedMinVals
            });
            // and batch any other style updates if necessary
            if (flipConfig.transformOrigin) element.style.transformOrigin = flipConfig.transformOrigin;
            else if (applyTransformOrigin) element.style.transformOrigin = "0 0";
            invertedChildren.forEach(function(_ref7) {
                var child = _ref7[0], childFlipConfig = _ref7[1];
                if (childFlipConfig.transformOrigin) child.style.transformOrigin = childFlipConfig.transformOrigin;
                else if (applyTransformOrigin) child.style.transformOrigin = "0 0";
            });
        };
        return (0, $3C3VY.assign)({}, toReturn, {
            stagger: stagger,
            springConfig: springConfig,
            getOnUpdateFunc: getOnUpdateFunc,
            initializeFlip: initializeFlip,
            onAnimationEnd: onAnimationEnd
        });
    }).filter(function(x) {
        return x;
    });
    // we use this array to compare with completed animations
    // to decide when all animations are completed
    withInitFuncs = flipDataArray.filter(function(_ref8) {
        var initializeFlip = _ref8.initializeFlip;
        return Boolean(initializeFlip);
    });
    //  put items back in place
    withInitFuncs.forEach(function(_ref9) {
        var initializeFlip = _ref9.initializeFlip;
        return initializeFlip();
    });
    if (debug) return;
    var flipDict = flipDataArray.reduce(function(acc, curr) {
        acc[curr.id] = curr;
        return acc;
    }, {});
    // this function modifies flipDataArray in-place
    // by removing references to non-direct children
    // to enable recursive stagger
    var _filterFlipDescendant = (0, $1vu6m.default)({
        flipDict: flipDict,
        flippedIds: flippedIds,
        scopedSelector: scopedSelector
    }), topLevelChildren = _filterFlipDescendant.topLevelChildren;
    return function() {
        // there are no active FLIP animations, so immediately resolve the
        // returned promise
        if (!withInitFuncs.length) closureResolve();
        (0, $98NNB.default)({
            topLevelChildren: topLevelChildren,
            flipDict: flipDict,
            staggerConfig: staggerConfig
        });
        return flipCompletedPromise;
    };
};
var $6e1589a82b42bcd0$export$2e2bcd8739ae039 = $6e1589a82b42bcd0$var$animateFlippedElements;

});
parcelRegister("ebnca", function(module, exports) {
$parcel$export(module.exports, "multiply", () => $a53415da87714973$export$2060d2db72cce88f);
$parcel$export(module.exports, "parse", () => $a53415da87714973$export$98e6a39c04603d36);
$parcel$export(module.exports, "scaleX", () => $a53415da87714973$export$55295ade51f88202);
$parcel$export(module.exports, "scaleY", () => $a53415da87714973$export$2092e2a44ac13bb2);
$parcel$export(module.exports, "translateX", () => $a53415da87714973$export$5667f2d3f182f284);
$parcel$export(module.exports, "translateY", () => $a53415da87714973$export$a1f0f3245f0cf0a4);
/*! @license Rematrix v0.2.3

	Copyright 2018 Fisssion LLC.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ /**
 * @module Rematrix
 */ /**
 * Transformation matrices in the browser come in two flavors:
 *
 *  - `matrix` using 6 values (short)
 *  - `matrix3d` using 16 values (long)
 *
 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
 * to expand short form matrices to their equivalent long form.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $a53415da87714973$export$d9468344d3651243(source) {
    if (source.constructor !== Array) throw new TypeError('Expected array.');
    if (source.length === 16) return source;
    if (source.length === 6) {
        var matrix = $a53415da87714973$export$f0954fd7d5368655();
        matrix[0] = source[0];
        matrix[1] = source[1];
        matrix[4] = source[2];
        matrix[5] = source[3];
        matrix[12] = source[4];
        matrix[13] = source[5];
        return matrix;
    }
    throw new RangeError('Expected array with either 6 or 16 values.');
}
/**
 * Returns a matrix representing no transformation. The product of any matrix
 * multiplied by the identity matrix will be the original matrix.
 *
 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
 *
 * @return {array}
 */ function $a53415da87714973$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
/**
 * Returns a matrix describing the inverse transformation of the source
 * matrix. The product of any matrix multiplied by its inverse will be the
 * identity matrix.
 *
 * > **Tip:** Similar to how `5 * (1/5) === 1`, where `1/5` is the inverse.
 *
 * @param  {array} source - Accepts both short and long form matrices.
 * @return {array}
 */ function $a53415da87714973$export$70ae2c07e401031b(source) {
    var m = $a53415da87714973$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error('Inverse determinant attempted to divide by zero.');
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
/**
 * Returns a 4x4 matrix describing the combined transformations
 * of both arguments.
 *
 * > **Note:** Order is very important. For example, rotating 45°
 * along the Z-axis, followed by translating 500 pixels along the
 * Y-axis... is not the same as translating 500 pixels along the
 * Y-axis, followed by rotating 45° along on the Z-axis.
 *
 * @param  {array} m - Accepts both short and long form matrices.
 * @param  {array} x - Accepts both short and long form matrices.
 * @return {array}
 */ function $a53415da87714973$export$2060d2db72cce88f(m, x) {
    var fm = $a53415da87714973$export$d9468344d3651243(m);
    var fx = $a53415da87714973$export$d9468344d3651243(x);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fm[i],
            fm[i + 4],
            fm[i + 8],
            fm[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fx[k],
                fx[k + 1],
                fx[k + 2],
                fx[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
/**
 * Attempts to return a 4x4 matrix describing the CSS transform
 * matrix passed in, but will return the identity matrix as a
 * fallback.
 *
 * **Tip:** In virtually all cases, this method is used to convert
 * a CSS matrix (retrieved as a `string` from computed styles) to
 * its equivalent array format.
 *
 * @param  {string} source - String containing a valid CSS `matrix` or `matrix3d` property.
 * @return {array}
 */ function $a53415da87714973$export$98e6a39c04603d36(source) {
    if (typeof source === 'string') {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(', ').map(parseFloat);
            return $a53415da87714973$export$d9468344d3651243(raw);
        }
    }
    return $a53415da87714973$export$f0954fd7d5368655();
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $a53415da87714973$export$bb628a54ab399bc9(angle) {
    return $a53415da87714973$export$ea6eae3365de5b9c(angle);
}
/**
 * Returns a 4x4 matrix describing X-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $a53415da87714973$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $a53415da87714973$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis rotation.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $a53415da87714973$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D scaling. The first argument
 * is used for both X and Y-axis scaling, unless an optional
 * second argument is provided to explicitly define Y-axis scaling.
 *
 * @param  {number} scalar    - Decimal multiplier.
 * @param  {number} [scalarY] - Decimal multiplier.
 * @return {array}
 */ function $a53415da87714973$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === 'number' ? scalarY : scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $a53415da87714973$export$55295ade51f88202(scalar) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $a53415da87714973$export$2092e2a44ac13bb2(scalar) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis scaling.
 *
 * @param  {number} scalar - Decimal multiplier.
 * @return {array}
 */ function $a53415da87714973$export$13034b1ece9569d5(scalar) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing shear. The first argument
 * defines X-axis shearing, and an optional second argument
 * defines Y-axis shearing.
 *
 * @param  {number} angleX   - Measured in degrees.
 * @param  {number} [angleY] - Measured in degrees.
 * @return {array}
 */ function $a53415da87714973$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis shear.
 *
 * @param  {number} angle - Measured in degrees.
 * @return {array}
 */ function $a53415da87714973$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis shear.
 *
 * @param  {number} angle - Measured in degrees
 * @return {array}
 */ function $a53415da87714973$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
/**
 * Returns a 4x4 matrix describing 2D translation. The first
 * argument defines X-axis translation, and an optional second
 * argument defines Y-axis translation.
 *
 * @param  {number} distanceX   - Measured in pixels.
 * @param  {number} [distanceY] - Measured in pixels.
 * @return {array}
 */ function $a53415da87714973$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing X-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $a53415da87714973$export$5667f2d3f182f284(distance) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Y-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $a53415da87714973$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
/**
 * Returns a 4x4 matrix describing Z-axis translation.
 *
 * @param  {number} distance - Measured in pixels.
 * @return {array}
 */ function $a53415da87714973$export$6e43fd17fc519956(distance) {
    var matrix = $a53415da87714973$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}

});

parcelRegister("e51su", function(module, exports) {
$parcel$export(module.exports, "getSpringConfig", () => $a402a9f131a66a4e$export$29bc3b1ca84e38c8);

var $3C3VY = parcelRequire("3C3VY");
var $a402a9f131a66a4e$export$31bbaa982ba04c49 = {
    noWobble: {
        stiffness: 200,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    veryGentle: {
        stiffness: 130,
        damping: 17
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 260,
        damping: 26
    }
};
var $a402a9f131a66a4e$export$29bc3b1ca84e38c8 = function getSpringConfig() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, flipperSpring = _ref.flipperSpring, flippedSpring = _ref.flippedSpring;
    var normalizeSpring = function normalizeSpring(spring) {
        if ((0, $3C3VY.isObject)(spring)) return spring;
        else if ($a402a9f131a66a4e$export$31bbaa982ba04c49[spring]) return $a402a9f131a66a4e$export$31bbaa982ba04c49[spring];
        else return {};
    };
    return (0, $3C3VY.assign)({}, $a402a9f131a66a4e$export$31bbaa982ba04c49.noWobble, normalizeSpring(flipperSpring), normalizeSpring(flippedSpring));
};

});
parcelRegister("3C3VY", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $2a17f8ec1c948dbe$export$7e4aa119212bc614);
$parcel$export(module.exports, "isFunction", () => $2a17f8ec1c948dbe$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isObject", () => $2a17f8ec1c948dbe$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "toArray", () => $2a17f8ec1c948dbe$export$45b10814cc054894);
$parcel$export(module.exports, "getDuplicateValsAsStrings", () => $2a17f8ec1c948dbe$export$b118174c74c51022);
$parcel$export(module.exports, "assign", () => $2a17f8ec1c948dbe$export$e6e34fd1f2686227);
var $2a17f8ec1c948dbe$export$7e4aa119212bc614 = function isNumber(x) {
    return typeof x === "number";
};
var $2a17f8ec1c948dbe$export$f6e2535fb5126e54 = function isFunction(x) {
    return typeof x === "function";
};
var $2a17f8ec1c948dbe$export$a6cdc56e425d0d0a = function isObject(x) {
    return Object.prototype.toString.call(x) === "[object Object]";
};
var $2a17f8ec1c948dbe$export$45b10814cc054894 = function toArray(arrayLike) {
    return Array.prototype.slice.apply(arrayLike);
};
var $2a17f8ec1c948dbe$export$b118174c74c51022 = function getDuplicateValsAsStrings(arr) {
    var obj = arr.reduce(function(acc, curr) {
        acc[curr] = acc[curr] ? acc[curr] + 1 : 1;
        return acc;
    }, {});
    return Object.keys(obj).filter(function(val) {
        return obj[val] > 1;
    });
};
var $2a17f8ec1c948dbe$export$e6e34fd1f2686227 = function assign(target) {
    for(var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    args.forEach(function(arg) {
        if (!arg) return;
        // Skip over if undefined or null
        for(var nextKey in arg)// Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(arg, nextKey)) target[nextKey] = arg[nextKey];
    });
    return target;
};

});


parcelRegister("gmpEl", function(module, exports) {
$parcel$export(module.exports, "DATA_FLIP_ID", () => $be9298f103f31956$export$4e7d89757a685662);
$parcel$export(module.exports, "DATA_INVERSE_FLIP_ID", () => $be9298f103f31956$export$6e4fe3c088b4bf3f);
$parcel$export(module.exports, "DATA_FLIP_CONFIG", () => $be9298f103f31956$export$94198d9f80ac9749);
$parcel$export(module.exports, "DATA_PORTAL_KEY", () => $be9298f103f31956$export$a5965b078f441f7e);
$parcel$export(module.exports, "DATA_EXIT_CONTAINER", () => $be9298f103f31956$export$ee2a39d85d3284e4);
var $be9298f103f31956$export$4e7d89757a685662 = "data-flip-id";
var $be9298f103f31956$export$6e4fe3c088b4bf3f = "data-inverse-flip-id";
var $be9298f103f31956$export$49e62738b103b74e = "data-flip-component-id";
var $be9298f103f31956$export$94198d9f80ac9749 = "data-flip-config";
var $be9298f103f31956$export$a5965b078f441f7e = "data-portal-key";
var $be9298f103f31956$export$ee2a39d85d3284e4 = "data-exit-container";

});

parcelRegister("1vu6m", function(module, exports) {
$parcel$export(module.exports, "default", () => $1190093bccdffe38$export$2e2bcd8739ae039);

var $3C3VY = parcelRequire("3C3VY");

var $gmpEl = parcelRequire("gmpEl");
// scoped selector makes sure we're querying inside the right Flipper
// container, either internally or with the right portal key
var $1190093bccdffe38$var$selectFlipChildIds = function selectFlipChildIds(scopedSelector, selector, flippedIds) {
    var childIds = (0, $3C3VY.toArray)(scopedSelector(selector)).map(function(el) {
        return el.dataset.flipId;
    });
    // now return an array ordered by the original order in the DOM
    return flippedIds.filter(function(id) {
        return childIds.indexOf(id) > -1;
    });
};
var $1190093bccdffe38$var$baseSelector = "[" + $gmpEl.DATA_FLIP_ID + "]";
var $1190093bccdffe38$export$2e2bcd8739ae039 = function(_ref) {
    var flipDict = _ref.flipDict, flippedIds = _ref.flippedIds, scopedSelector = _ref.scopedSelector;
    var levelToChildren = {};
    var buildHierarchy = function buildHierarchy(selector, level, oldResult) {
        var newSelector = selector + " " + $1190093bccdffe38$var$baseSelector;
        // make sure this is scoped to the Flipper element in case there are
        // mulitiple Flipper elements on the page
        var newResult = $1190093bccdffe38$var$selectFlipChildIds(scopedSelector, newSelector, flippedIds);
        var oldLevelChildren = oldResult.filter(function(id) {
            return newResult.indexOf(id) === -1;
        });
        levelToChildren[level] = oldLevelChildren;
        oldLevelChildren.forEach(function(childId) {
            if (flipDict[childId]) flipDict[childId].level = level;
        });
        if (newResult.length !== 0) buildHierarchy(newSelector, level + 1, newResult);
    };
    // the top level selectChildFlipIds should use the scopedSelector,
    buildHierarchy($1190093bccdffe38$var$baseSelector, 0, $1190093bccdffe38$var$selectFlipChildIds(scopedSelector, $1190093bccdffe38$var$baseSelector, flippedIds));
    // now make sure childIds in each flippedData contains only direct children
    // since to enable nested stagger  we want each parent to be able to kick off
    // the animations only for its direct children
    Object.keys(flipDict).forEach(function(flipId) {
        var data = flipDict[flipId];
        // scop by parent element
        data.childIds = $1190093bccdffe38$var$selectFlipChildIds(function(selector) {
            return data.element.querySelectorAll(selector);
        }, $1190093bccdffe38$var$baseSelector, flippedIds);
        data.childIds = data.childIds.filter(function(id) {
            return levelToChildren[data.level + 1] && levelToChildren[data.level + 1].indexOf(id) > -1;
        });
    });
    return {
        topLevelChildren: levelToChildren["0"]
    };
};

});

parcelRegister("98NNB", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a7b7d7b18085af7$export$2e2bcd8739ae039);

var $1pp1G = parcelRequire("1pp1G");
var $6a7b7d7b18085af7$var$initiateImmediateAnimations = function initiateImmediateAnimations(immediate) {
    if (!immediate) return;
    immediate.forEach(function(flipped) {
        (0, $1pp1G.createSpring)(flipped);
        initiateImmediateAnimations(flipped.immediate);
    });
};
var $6a7b7d7b18085af7$export$5e8092f8b030bcec = function createCallTree(_ref) {
    var flipDict = _ref.flipDict, topLevelChildren = _ref.topLevelChildren, initiateStaggeredAnimations = _ref.initiateStaggeredAnimations;
    //build a data struct to run the springs
    var tree = {
        root: {
            staggeredChildren: {},
            immediateChildren: []
        }
    };
    var appendChild = function appendChild(parent, childId) {
        var flipData = flipDict[childId];
        // might have been filtered (e.g. because it was off screen)
        if (!flipData) return;
        if (flipData.stagger) parent.staggeredChildren[flipData.stagger] ? parent.staggeredChildren[flipData.stagger].push(flipData) : parent.staggeredChildren[flipData.stagger] = [
            flipData
        ];
        else parent.immediateChildren.push(flipData);
        // only when the spring is first activated, activate the child animations as well
        // this enables nested stagger
        flipData.onSpringActivate = function() {
            $6a7b7d7b18085af7$var$initiateImmediateAnimations(flipData.immediateChildren);
            initiateStaggeredAnimations(flipData.staggeredChildren);
        };
        flipData.staggeredChildren = {};
        flipData.immediateChildren = [];
        flipData.childIds.forEach(function(childId) {
            return appendChild(flipData, childId);
        });
    };
    // create the nested structure
    topLevelChildren.forEach(function(c) {
        appendChild(tree.root, c);
    });
    return tree;
};
var $6a7b7d7b18085af7$export$2e2bcd8739ae039 = function(_ref2) {
    var staggerConfig = _ref2.staggerConfig, flipDict = _ref2.flipDict, topLevelChildren = _ref2.topLevelChildren;
    var initiateStaggeredAnimations = function initiateStaggeredAnimations(staggered) {
        if (!staggered || !Object.keys(staggered).length) return;
        Object.keys(staggered).forEach(function(staggerKey) {
            return (0, $1pp1G.staggeredSprings)(staggered[staggerKey], staggerConfig[staggerKey]);
        });
    };
    var tree = $6a7b7d7b18085af7$export$5e8092f8b030bcec({
        flipDict: flipDict,
        topLevelChildren: topLevelChildren,
        initiateStaggeredAnimations: initiateStaggeredAnimations
    });
    $6a7b7d7b18085af7$var$initiateImmediateAnimations(tree.root.immediateChildren);
    initiateStaggeredAnimations(tree.root.staggeredChildren);
};

});
parcelRegister("1pp1G", function(module, exports) {
$parcel$export(module.exports, "createSpring", () => $106b89eda7dcf728$export$d1f8fcb84651afa9);
$parcel$export(module.exports, "staggeredSprings", () => $106b89eda7dcf728$export$ac7d870a005a890f);
parcelRequire("fVr5Z");
var $e6D5k = parcelRequire("e6D5k");
// this should get created only 1x
var $106b89eda7dcf728$var$springSystem = new (0, $e6D5k.default)();
var $106b89eda7dcf728$export$1c192fd9ecdd1c80 = function createSuspendedSpring(_ref) {
    var _ref$springConfig = _ref.springConfig, stiffness = _ref$springConfig.stiffness, damping = _ref$springConfig.damping, overshootClamping = _ref$springConfig.overshootClamping, noOp = _ref.noOp, onSpringActivate = _ref.onSpringActivate, getOnUpdateFunc = _ref.getOnUpdateFunc, onAnimationEnd = _ref.onAnimationEnd;
    if (noOp) return;
    var spring = $106b89eda7dcf728$var$springSystem.createSpring(stiffness, damping);
    spring.setOvershootClampingEnabled(!!overshootClamping);
    spring.addListener({
        onSpringActivate: onSpringActivate,
        onSpringUpdate: getOnUpdateFunc(spring.destroy.bind(spring)),
        onSpringAtRest: function onSpringAtRest() {
            // prevent SpringSystem from caching unused springs
            spring.destroy();
            onAnimationEnd();
        }
    });
    return spring;
};
var $106b89eda7dcf728$export$d1f8fcb84651afa9 = function createSpring(flipped) {
    var spring = $106b89eda7dcf728$export$1c192fd9ecdd1c80(flipped);
    if (spring) spring.setEndValue(1);
    else // even if it was a noop,
    // we still need to call onSpringActivate in case it calls
    // cascading flip initiation functions
    flipped.onSpringActivate();
};
var $106b89eda7dcf728$export$ac7d870a005a890f = function staggeredSprings(flippedArray) {
    var staggerConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!flippedArray || !flippedArray.length) return;
    if (staggerConfig.reverse) flippedArray.reverse();
    var normalizedSpeed = staggerConfig.speed ? 1 + Math.max(Math.min(staggerConfig.speed, 0), 1) : 1.1;
    var nextThreshold = 1 / Math.max(Math.min(flippedArray.length, 100), 10);
    var springFuncs = flippedArray.filter(function(flipped) {
        return !flipped.noOp;
    }).map(function(flipped, i) {
        var cachedGetOnUpdate = flipped.getOnUpdateFunc;
        // modify the update function to adjust
        // the end value of the trailing Flipped component
        flipped.getOnUpdateFunc = function(stop) {
            var onUpdate = cachedGetOnUpdate(stop);
            return function(spring) {
                var currentValue = spring.getCurrentValue();
                if (currentValue > nextThreshold) springFuncs[i + 1] && springFuncs[i + 1].setEndValue(Math.min(currentValue * normalizedSpeed, 1));
                // now call the actual update function
                onUpdate(spring);
            };
        };
        return flipped;
    }).map(function(flipped) {
        return $106b89eda7dcf728$export$1c192fd9ecdd1c80(flipped);
    });
    springFuncs[0] && springFuncs[0].setEndValue(1);
};

});
parcelRegister("fVr5Z", function(module, exports) {
$parcel$export(module.exports, "SpringSystem", () => (parcelRequire("e6D5k")).default);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *      
 */ 
var $e6D5k = parcelRequire("e6D5k");

var $dMNbY = parcelRequire("dMNbY");

});
parcelRegister("e6D5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $a44ff1b1ae731409$export$2e2bcd8739ae039);

var $a1vcU = parcelRequire("a1vcU");

var $eSryd = parcelRequire("eSryd");

var $dMNbY = parcelRequire("dMNbY");
function $a44ff1b1ae731409$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/**
 * A set of Springs that all run on the same physics
 * timing loop. To get started with a Rebound animation, first
 * create a new SpringSystem and then add springs to it.
 * @public
 */ var $a44ff1b1ae731409$var$SpringSystem = function() {
    function SpringSystem(looper) {
        $a44ff1b1ae731409$var$_classCallCheck(this, SpringSystem);
        this.looper = looper || new (0, $a1vcU.AnimationLooper)();
        this.looper.springSystem = this;
        this.listeners = [];
        this._activeSprings = [];
        this._idleSpringIndices = [];
        this._isIdle = true;
        this._lastTimeMillis = -1;
        this._springRegistry = {};
    }
    /**
   * Add a new spring to this SpringSystem. This Spring will now be solved for
   * during the physics iteration loop. By default the spring will use the
   * default Origami spring config with 40 tension and 7 friction, but you can
   * also provide your own values here.
   * @public
   */ SpringSystem.prototype.createSpring = function createSpring(tension, friction) {
        return this.createSpringWithConfig({
            tension: tension,
            friction: friction
        });
    };
    /**
   * Add a spring with the provided SpringConfig.
   * @public
   */ SpringSystem.prototype.createSpringWithConfig = function createSpringWithConfig(springConfig) {
        var spring = new (0, $eSryd.default)(this);
        this.registerSpring(spring);
        spring.setSpringConfig(springConfig);
        return spring;
    };
    /**
   * Check if a SpringSystem is idle or active. If all of the Springs in the
   * SpringSystem are at rest, i.e. the physics forces have reached equilibrium,
   * then this method will return true.
   * @public
   */ SpringSystem.prototype.getIsIdle = function getIsIdle() {
        return this._isIdle;
    };
    /**
   * Manually add a spring to this system. This is called automatically
   * if a Spring is created with SpringSystem#createSpring.
   *
   * This method sets the spring up in the registry so that it can be solved
   * in the solver loop.
   * @public
   */ SpringSystem.prototype.registerSpring = function registerSpring(spring) {
        this._springRegistry[spring.getId()] = spring;
    };
    /**
   * Deregister a spring with this SpringSystem. The SpringSystem will
   * no longer consider this Spring during its integration loop once
   * this is called. This is normally done automatically for you when
   * you call Spring#destroy.
   * @public
   */ SpringSystem.prototype.deregisterSpring = function deregisterSpring(spring) {
        (0, $dMNbY.removeFirst)(this._activeSprings, spring);
        delete this._springRegistry[spring.getId()];
    };
    SpringSystem.prototype.advance = function advance(time, deltaTime) {
        while(this._idleSpringIndices.length > 0)this._idleSpringIndices.pop();
        for(var i = 0, len = this._activeSprings.length; i < len; i++){
            var spring = this._activeSprings[i];
            // note from alex: had to add this otherwise deleting springs caused errors
            if (!spring) return;
            if (spring.systemShouldAdvance()) spring.advance(time / 1000.0, deltaTime / 1000.0);
            else this._idleSpringIndices.push(this._activeSprings.indexOf(spring));
        }
        while(this._idleSpringIndices.length > 0){
            var idx = this._idleSpringIndices.pop();
            idx >= 0 && this._activeSprings.splice(idx, 1);
        }
    };
    /**
   * This is the main solver loop called to move the simulation
   * forward through time. Before each pass in the solver loop
   * onBeforeIntegrate is called on an any listeners that have
   * registered themeselves with the SpringSystem. This gives you
   * an opportunity to apply any constraints or adjustments to
   * the springs that should be enforced before each iteration
   * loop. Next the advance method is called to move each Spring in
   * the systemShouldAdvance forward to the current time. After the
   * integration step runs in advance, onAfterIntegrate is called
   * on any listeners that have registered themselves with the
   * SpringSystem. This gives you an opportunity to run any post
   * integration constraints or adjustments on the Springs in the
   * SpringSystem.
   * @public
   */ SpringSystem.prototype.loop = function loop(currentTimeMillis) {
        var listener = void 0;
        if (this._lastTimeMillis === -1) this._lastTimeMillis = currentTimeMillis - 1;
        var ellapsedMillis = currentTimeMillis - this._lastTimeMillis;
        this._lastTimeMillis = currentTimeMillis;
        var i = 0;
        var len = this.listeners.length;
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onBeforeIntegrate && listener.onBeforeIntegrate(this);
        }
        this.advance(currentTimeMillis, ellapsedMillis);
        if (this._activeSprings.length === 0) {
            this._isIdle = true;
            this._lastTimeMillis = -1;
        }
        for(i = 0; i < len; i++){
            listener = this.listeners[i];
            listener.onAfterIntegrate && listener.onAfterIntegrate(this);
        }
        if (!this._isIdle) this.looper.run();
    };
    /**
   * Used to notify the SpringSystem that a Spring has become displaced.
   * The system responds by starting its solver loop up if it is currently idle.
   */ SpringSystem.prototype.activateSpring = function activateSpring(springId) {
        var spring = this._springRegistry[springId];
        if (this._activeSprings.indexOf(spring) === -1) this._activeSprings.push(spring);
        if (this.getIsIdle()) {
            this._isIdle = false;
            this.looper.run();
        }
    };
    return SpringSystem;
}();
var $a44ff1b1ae731409$export$2e2bcd8739ae039 = $a44ff1b1ae731409$var$SpringSystem;

});
parcelRegister("a1vcU", function(module, exports) {
$parcel$export(module.exports, "AnimationLooper", () => $74c2347e1cf40236$export$253af54c72735e05);

var $dMNbY = parcelRequire("dMNbY");
function $74c2347e1cf40236$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $74c2347e1cf40236$export$253af54c72735e05 = function() {
    function AnimationLooper() {
        $74c2347e1cf40236$var$_classCallCheck(this, AnimationLooper);
    }
    AnimationLooper.prototype.run = function run() {
        var _this = this;
        (0, $dMNbY.onFrame)(function() {
            _this.springSystem.loop((0, $dMNbY.performanceNow)());
        });
    };
    return AnimationLooper;
}();

});
parcelRegister("dMNbY", function(module, exports) {
$parcel$export(module.exports, "onFrame", () => $a095ea98c13ecb84$export$1241ca3c22b48b34);
$parcel$export(module.exports, "performanceNow", () => $a095ea98c13ecb84$export$fb4230f160368c88);
$parcel$export(module.exports, "removeFirst", () => $a095ea98c13ecb84$export$2529f734547e2830);

var $aaZ6k = parcelRequire("aaZ6k");
var $a095ea98c13ecb84$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $a095ea98c13ecb84$export$1241ca3c22b48b34(func) {
    return (0, $aaZ6k.default)(func);
}
var $a095ea98c13ecb84$var$start = Date.now();
var $a095ea98c13ecb84$export$fb4230f160368c88 = (typeof performance === "undefined" ? "undefined" : $a095ea98c13ecb84$var$_typeof(performance)) === "object" && typeof performance.now === "function" ? function() {
    return performance.now();
} : function() {
    return Date.now() - $a095ea98c13ecb84$var$start;
};
function $a095ea98c13ecb84$export$2529f734547e2830(array, item) {
    var idx = array.indexOf(item);
    idx !== -1 && array.splice(idx, 1);
}

});
parcelRegister("aaZ6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $01e9749470ffea52$export$2e2bcd8739ae039);
/**
 *  Copyright (c) 2013, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 *
 *
 */ var $01e9749470ffea52$var$_onFrame = void 0;
if (typeof window !== "undefined") $01e9749470ffea52$var$_onFrame = window.requestAnimationFrame;
$01e9749470ffea52$var$_onFrame = $01e9749470ffea52$var$_onFrame || function(callback) {
    window.setTimeout(callback, 1000 / 60);
};
var $01e9749470ffea52$export$2e2bcd8739ae039 = $01e9749470ffea52$var$_onFrame;

});



parcelRegister("eSryd", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad4b7ae3179b1f09$export$2e2bcd8739ae039);

var $dMNbY = parcelRequire("dMNbY");
function $ad4b7ae3179b1f09$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $ad4b7ae3179b1f09$var$PhysicsState = function PhysicsState() {
    $ad4b7ae3179b1f09$var$_classCallCheck(this, PhysicsState);
    this.position = 0;
    this.velocity = 0;
};
/**
 * Provides a model of a classical spring acting to
 * resolve a body to equilibrium. Springs have configurable
 * tension which is a force multipler on the displacement of the
 * spring from its rest point or `endValue` as defined by [Hooke's
 * law](http://en.wikipedia.org/wiki/Hooke's_law). Springs also have
 * configurable friction, which ensures that they do not oscillate
 * infinitely. When a Spring is displaced by updating it's resting
 * or `currentValue`, the SpringSystems that contain that Spring
 * will automatically start looping to solve for equilibrium. As each
 * timestep passes, `SpringListener` objects attached to the Spring
 * will be notified of the updates providing a way to drive an
 * animation off of the spring's resolution curve.
 * @public
 */ var $ad4b7ae3179b1f09$var$Spring = function() {
    function Spring(springSystem) {
        $ad4b7ae3179b1f09$var$_classCallCheck(this, Spring);
        this._id = "s" + Spring._ID++;
        this._springSystem = springSystem;
        this.listeners = [];
        this._startValue = 0;
        this._currentState = new $ad4b7ae3179b1f09$var$PhysicsState();
        this._displacementFromRestThreshold = 0.001;
        this._endValue = 0;
        this._overshootClampingEnabled = false;
        this._previousState = new $ad4b7ae3179b1f09$var$PhysicsState();
        this._restSpeedThreshold = 0.001;
        this._tempState = new $ad4b7ae3179b1f09$var$PhysicsState();
        this._timeAccumulator = 0;
        this._wasAtRest = true;
    }
    Spring.prototype.getId = function getId() {
        return this._id;
    };
    /**
   * Remove a Spring from simulation and clear its listeners.
   * @public
   */ Spring.prototype.destroy = function destroy() {
        this.listeners = [];
        this._springSystem.deregisterSpring(this);
    };
    /**
   * Set the configuration values for this Spring. A SpringConfig
   * contains the tension and friction values used to solve for the
   * equilibrium of the Spring in the physics loop.
   * @public
   */ Spring.prototype.setSpringConfig = function setSpringConfig(springConfig) {
        this._springConfig = springConfig;
        return this;
    };
    /**
   * Retrieve the current value of the Spring.
   * @public
   */ Spring.prototype.getCurrentValue = function getCurrentValue() {
        return this._currentState.position;
    };
    /**
   * Get the absolute distance of the Spring from a given state value
   */ Spring.prototype.getDisplacementDistanceForState = function getDisplacementDistanceForState(state) {
        return Math.abs(this._endValue - state.position);
    };
    /**
   * Set the endValue or resting position of the spring. If this
   * value is different than the current value, the SpringSystem will
   * be notified and will begin running its solver loop to resolve
   * the Spring to equilibrium. Any listeners that are registered
   * for onSpringEndStateChange will also be notified of this update
   * immediately.
   * @public
   */ Spring.prototype.setEndValue = function setEndValue(endValue) {
        if (this._endValue === endValue && this.isAtRest()) return this;
        this._startValue = this.getCurrentValue();
        this._endValue = endValue;
        this._springSystem.activateSpring(this.getId());
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            var onChange = listener.onSpringEndStateChange;
            onChange && onChange(this);
        }
        return this;
    };
    /**
   * Set the current velocity of the Spring, in pixels per second. As
   * previously mentioned, this can be useful when you are performing
   * a direct manipulation gesture. When a UI element is released you
   * may call setVelocity on its animation Spring so that the Spring
   * continues with the same velocity as the gesture ended with. The
   * friction, tension, and displacement of the Spring will then
   * govern its motion to return to rest on a natural feeling curve.
   * @public
   */ Spring.prototype.setVelocity = function setVelocity(velocity) {
        if (velocity === this._currentState.velocity) return this;
        this._currentState.velocity = velocity;
        this._springSystem.activateSpring(this.getId());
        return this;
    };
    /**
   * Enable overshoot clamping. This means that the Spring will stop
   * immediately when it reaches its resting position regardless of
   * any existing momentum it may have. This can be useful for certain
   * types of animations that should not oscillate such as a scale
   * down to 0 or alpha fade.
   * @public
   */ Spring.prototype.setOvershootClampingEnabled = function setOvershootClampingEnabled(enabled) {
        this._overshootClampingEnabled = enabled;
        return this;
    };
    /**
   * Check if the Spring has gone past its end point by comparing
   * the direction it was moving in when it started to the current
   * position and end value.
   * @public
   */ Spring.prototype.isOvershooting = function isOvershooting() {
        var start = this._startValue;
        var end = this._endValue;
        return this._springConfig.tension > 0 && (start < end && this.getCurrentValue() > end || start > end && this.getCurrentValue() < end);
    };
    /**
   * The main solver method for the Spring. It takes
   * the current time and delta since the last time step and performs
   * an RK4 integration to get the new position and velocity state
   * for the Spring based on the tension, friction, velocity, and
   * displacement of the Spring.
   * @public
   */ Spring.prototype.advance = function advance(time, realDeltaTime) {
        var isAtRest = this.isAtRest();
        if (isAtRest && this._wasAtRest) return;
        var adjustedDeltaTime = realDeltaTime;
        if (realDeltaTime > Spring.MAX_DELTA_TIME_SEC) adjustedDeltaTime = Spring.MAX_DELTA_TIME_SEC;
        this._timeAccumulator += adjustedDeltaTime;
        var tension = this._springConfig.tension;
        var friction = this._springConfig.friction;
        var position = this._currentState.position;
        var velocity = this._currentState.velocity;
        var tempPosition = this._tempState.position;
        var tempVelocity = this._tempState.velocity;
        var aVelocity = void 0;
        var aAcceleration = void 0;
        var bVelocity = void 0;
        var bAcceleration = void 0;
        var cVelocity = void 0;
        var cAcceleration = void 0;
        var dVelocity = void 0;
        var dAcceleration = void 0;
        var dxdt = void 0;
        var dvdt = void 0;
        while(this._timeAccumulator >= Spring.SOLVER_TIMESTEP_SEC){
            this._timeAccumulator -= Spring.SOLVER_TIMESTEP_SEC;
            if (this._timeAccumulator < Spring.SOLVER_TIMESTEP_SEC) {
                this._previousState.position = position;
                this._previousState.velocity = velocity;
            }
            aVelocity = velocity;
            aAcceleration = tension * (this._endValue - tempPosition) - friction * velocity;
            tempPosition = position + aVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + aAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            bVelocity = tempVelocity;
            bAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + bVelocity * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            tempVelocity = velocity + bAcceleration * Spring.SOLVER_TIMESTEP_SEC * 0.5;
            cVelocity = tempVelocity;
            cAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            tempPosition = position + cVelocity * Spring.SOLVER_TIMESTEP_SEC;
            tempVelocity = velocity + cAcceleration * Spring.SOLVER_TIMESTEP_SEC;
            dVelocity = tempVelocity;
            dAcceleration = tension * (this._endValue - tempPosition) - friction * tempVelocity;
            dxdt = 1.0 / 6.0 * (aVelocity + 2.0 * (bVelocity + cVelocity) + dVelocity);
            dvdt = 1.0 / 6.0 * (aAcceleration + 2.0 * (bAcceleration + cAcceleration) + dAcceleration);
            position += dxdt * Spring.SOLVER_TIMESTEP_SEC;
            velocity += dvdt * Spring.SOLVER_TIMESTEP_SEC;
        }
        this._tempState.position = tempPosition;
        this._tempState.velocity = tempVelocity;
        this._currentState.position = position;
        this._currentState.velocity = velocity;
        if (this._timeAccumulator > 0) this._interpolate(this._timeAccumulator / Spring.SOLVER_TIMESTEP_SEC);
        if (this.isAtRest() || this._overshootClampingEnabled && this.isOvershooting()) {
            if (this._springConfig.tension > 0) {
                this._startValue = this._endValue;
                this._currentState.position = this._endValue;
            } else {
                this._endValue = this._currentState.position;
                this._startValue = this._endValue;
            }
            this.setVelocity(0);
            isAtRest = true;
        }
        var notifyActivate = false;
        if (this._wasAtRest) {
            this._wasAtRest = false;
            notifyActivate = true;
        }
        var notifyAtRest = false;
        if (isAtRest) {
            this._wasAtRest = true;
            notifyAtRest = true;
        }
        this.notifyPositionUpdated(notifyActivate, notifyAtRest);
    };
    Spring.prototype.notifyPositionUpdated = function notifyPositionUpdated(notifyActivate, notifyAtRest) {
        for(var i = 0, len = this.listeners.length; i < len; i++){
            var listener = this.listeners[i];
            if (notifyActivate && listener.onSpringActivate) listener.onSpringActivate(this);
            if (listener.onSpringUpdate) listener.onSpringUpdate(this);
            if (notifyAtRest && listener.onSpringAtRest) listener.onSpringAtRest(this);
        }
    };
    /**
   * Check if the SpringSystem should advance. Springs are advanced
   * a final frame after they reach equilibrium to ensure that the
   * currentValue is exactly the requested endValue regardless of the
   * displacement threshold.
   * @public
   */ Spring.prototype.systemShouldAdvance = function systemShouldAdvance() {
        return !this.isAtRest() || !this.wasAtRest();
    };
    Spring.prototype.wasAtRest = function wasAtRest() {
        return this._wasAtRest;
    };
    /**
   * Check if the Spring is atRest meaning that it's currentValue and
   * endValue are the same and that it has no velocity. The previously
   * described thresholds for speed and displacement define the bounds
   * of this equivalence check. If the Spring has 0 tension, then it will
   * be considered at rest whenever its absolute velocity drops below the
   * restSpeedThreshold.
   * @public
   */ Spring.prototype.isAtRest = function isAtRest() {
        return Math.abs(this._currentState.velocity) < this._restSpeedThreshold && (this.getDisplacementDistanceForState(this._currentState) <= this._displacementFromRestThreshold || this._springConfig.tension === 0);
    };
    Spring.prototype._interpolate = function _interpolate(alpha) {
        this._currentState.position = this._currentState.position * alpha + this._previousState.position * (1 - alpha);
        this._currentState.velocity = this._currentState.velocity * alpha + this._previousState.velocity * (1 - alpha);
    };
    Spring.prototype.addListener = function addListener(newListener) {
        this.listeners.push(newListener);
        return this;
    };
    Spring.prototype.removeListener = function removeListener(listenerToRemove) {
        (0, $dMNbY.removeFirst)(this.listeners, listenerToRemove);
        return this;
    };
    return Spring;
}();
$ad4b7ae3179b1f09$var$Spring._ID = 0;
$ad4b7ae3179b1f09$var$Spring.MAX_DELTA_TIME_SEC = 0.064;
$ad4b7ae3179b1f09$var$Spring.SOLVER_TIMESTEP_SEC = 0.001;
var $ad4b7ae3179b1f09$export$2e2bcd8739ae039 = $ad4b7ae3179b1f09$var$Spring;

});






parcelRegister("8Tzwm", function(module, exports) {
$parcel$export(module.exports, "getFlippedElementPositionsBeforeUpdate", () => $679f03804c671c02$export$45700a1d2c971fdb);
$parcel$export(module.exports, "getFlippedElementPositionsAfterUpdate", () => $679f03804c671c02$export$df23be7918af8adb);

var $3C3VY = parcelRequire("3C3VY");

var $gmpEl = parcelRequire("gmpEl");
var $679f03804c671c02$var$cancelInProgressAnimations = function cancelInProgressAnimations(inProgressAnimations) {
    Object.keys(inProgressAnimations).forEach(function(id) {
        if (inProgressAnimations[id].stop) inProgressAnimations[id].stop();
        delete inProgressAnimations[id];
    });
};
var $679f03804c671c02$var$addTupleToObject = function addTupleToObject(acc, curr) {
    var _assign;
    return (0, $3C3VY.assign)(acc, (_assign = {}, _assign[curr[0]] = curr[1], _assign));
};
var $679f03804c671c02$export$b087c5eb899bb598 = function getAllElements(element, portalKey) {
    if (portalKey) return (0, $3C3VY.toArray)(document.querySelectorAll("[" + $gmpEl.DATA_PORTAL_KEY + "=\"" + portalKey + "\"]"));
    else return (0, $3C3VY.toArray)(element.querySelectorAll("[" + $gmpEl.DATA_FLIP_ID + "]"));
};
var $679f03804c671c02$export$45700a1d2c971fdb = function getFlippedElementPositionsBeforeUpdate(_ref) {
    var element = _ref.element, _ref$flipCallbacks = _ref.flipCallbacks, flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks, _ref$inProgressAnimat = _ref.inProgressAnimations, inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat, portalKey = _ref.portalKey;
    var flippedElements = $679f03804c671c02$export$b087c5eb899bb598(element, portalKey);
    var inverseFlippedElements = (0, $3C3VY.toArray)(element.querySelectorAll("[" + $gmpEl.DATA_INVERSE_FLIP_ID + "]"));
    var childIdsToParentBCRs = {};
    var parentBCRs = [];
    var childIdsToParents = {};
    // this is for exit animations so we can re-insert exiting elements in the
    // DOM later
    flippedElements.filter(function(el) {
        return flipCallbacks && flipCallbacks[el.dataset.flipId] && flipCallbacks[el.dataset.flipId].onExit;
    }).forEach(function(el) {
        var parent = el.parentNode;
        // this won't work for IE11
        if (el.closest) {
            var exitContainer = el.closest("[" + $gmpEl.DATA_EXIT_CONTAINER + "]");
            if (exitContainer) parent = exitContainer;
        }
        var bcrIndex = parentBCRs.findIndex(function(n) {
            return n[0] === parent;
        });
        if (bcrIndex === -1) {
            parentBCRs.push([
                parent,
                parent.getBoundingClientRect()
            ]);
            bcrIndex = parentBCRs.length - 1;
        }
        childIdsToParentBCRs[el.dataset.flipId] = parentBCRs[bcrIndex][1];
        childIdsToParents[el.dataset.flipId] = parent;
    });
    var flippedElementPositions = flippedElements.map(function(child) {
        var domData = {};
        var childBCR = child.getBoundingClientRect();
        // only cache extra data for exit animations
        // if the element has an onExit listener
        if (flipCallbacks && flipCallbacks[child.dataset.flipId] && flipCallbacks[child.dataset.flipId].onExit) {
            var parentBCR = childIdsToParentBCRs[child.dataset.flipId];
            (0, $3C3VY.assign)(domData, {
                element: child,
                parent: childIdsToParents[child.dataset.flipId],
                childPosition: {
                    top: childBCR.top - parentBCR.top,
                    left: childBCR.left - parentBCR.left,
                    width: childBCR.width,
                    height: childBCR.height
                }
            });
        }
        return [
            child.dataset.flipId,
            {
                rect: childBCR,
                opacity: parseFloat(window.getComputedStyle(child).opacity),
                domData: domData
            }
        ];
    }).reduce($679f03804c671c02$var$addTupleToObject, {});
    // do this at the very end since we want to cache positions of elements
    // while they are mid-transition
    $679f03804c671c02$var$cancelInProgressAnimations(inProgressAnimations);
    flippedElements.concat(inverseFlippedElements).forEach(function(el) {
        el.style.transform = "";
        el.style.opacity = "";
    });
    return {
        flippedElementPositions: flippedElementPositions,
        cachedOrderedFlipIds: flippedElements.map(function(el) {
            return el.dataset.flipId;
        })
    };
};
var $679f03804c671c02$export$df23be7918af8adb = function getFlippedElementPositionsAfterUpdate(_ref2) {
    var element = _ref2.element, portalKey = _ref2.portalKey;
    return $679f03804c671c02$export$b087c5eb899bb598(element, portalKey).map(function(child) {
        var computedStyle = window.getComputedStyle(child);
        var rect = child.getBoundingClientRect();
        return [
            child.dataset.flipId,
            {
                rect: rect,
                opacity: parseFloat(computedStyle.opacity),
                domData: {},
                transform: computedStyle.transform
            }
        ];
    }).reduce($679f03804c671c02$var$addTupleToObject, {});
};

});



parcelRegister("UwTQP", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a9ec04bfae8b41b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $wYFix = parcelRequire("wYFix");

var $gmpEl = parcelRequire("gmpEl");

var $3C3VY = parcelRequire("3C3VY");
var $0a9ec04bfae8b41b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $0a9ec04bfae8b41b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a9ec04bfae8b41b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0a9ec04bfae8b41b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $0a9ec04bfae8b41b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $0a9ec04bfae8b41b$var$customPropCheck = function customPropCheck(props, propName) {
    if (props.flipId && props.inverseFlipId) return new Error('Please only provide one of the two: "FlipId" or "inverseFlipID"');
    else if (props.flipId === undefined && props.inverseFlipId === undefined) return new Error("Must provide either a \"FlipId\" or an \"InverseFlipId\" prop");
    else if (props[propName] && typeof props[propName] !== "string") return new Error(propName + " must be a string");
};
var $0a9ec04bfae8b41b$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
    ]).isRequired,
    inverseFlipId: $0a9ec04bfae8b41b$var$customPropCheck,
    flipId: $0a9ec04bfae8b41b$var$customPropCheck,
    opacity: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).bool,
    translate: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).bool,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).bool,
    transformOrigin: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).string,
    spring: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).object
    ]),
    onStart: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    onComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    onAppear: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    shouldFlip: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    shouldInvert: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func,
    portalKey: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).string,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).bool
    ])
};
function $0a9ec04bfae8b41b$export$c3816ea9cb166de0(_ref) {
    var _dataAttributes;
    var children = _ref.children, flipId = _ref.flipId, inverseFlipId = _ref.inverseFlipId, portalKey = _ref.portalKey, rest = $0a9ec04bfae8b41b$var$_objectWithoutProperties(_ref, [
        "children",
        "flipId",
        "inverseFlipId",
        "portalKey"
    ]);
    var child = children;
    var isFunctionAsChildren = typeof child === 'function';
    if (!isFunctionAsChildren) try {
        child = (0, $4fqPo.Children).only(children);
    } catch (e) {
        throw new Error("Each Flipped component must wrap a single child");
    }
    // if nothing is being animated, assume everything is being animated
    if (!rest.scale && !rest.translate && !rest.opacity) (0, $3C3VY.assign)(rest, {
        translate: true,
        scale: true,
        opacity: true
    });
    var dataAttributes = (_dataAttributes = {}, _dataAttributes[$gmpEl.DATA_FLIP_ID] = flipId, _dataAttributes[$gmpEl.DATA_INVERSE_FLIP_ID] = inverseFlipId, _dataAttributes[$gmpEl.DATA_FLIP_CONFIG] = JSON.stringify(rest), _dataAttributes);
    if (portalKey) dataAttributes[$gmpEl.DATA_PORTAL_KEY] = portalKey;
    return isFunctionAsChildren ? child(dataAttributes) : (0, $4fqPo.cloneElement)(child, dataAttributes);
}
var $0a9ec04bfae8b41b$var$FlippedWithContext = function(_Component) {
    $0a9ec04bfae8b41b$var$_inherits(FlippedWithContext, _Component);
    function FlippedWithContext() {
        $0a9ec04bfae8b41b$var$_classCallCheck(this, FlippedWithContext);
        return $0a9ec04bfae8b41b$var$_possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    FlippedWithContext.prototype.render = function render() {
        var _props = this.props, children = _props.children, flipId = _props.flipId, shouldFlip = _props.shouldFlip, shouldInvert = _props.shouldInvert, onAppear = _props.onAppear, onStart = _props.onStart, onComplete = _props.onComplete, onExit = _props.onExit, rest = $0a9ec04bfae8b41b$var$_objectWithoutProperties(_props, [
            "children",
            "flipId",
            "shouldFlip",
            "shouldInvert",
            "onAppear",
            "onStart",
            "onComplete",
            "onExit"
        ]);
        if (rest.inverseFlipId) return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0a9ec04bfae8b41b$export$c3816ea9cb166de0, rest, children);
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $wYFix.PortalContext).Consumer, null, function(portalKey) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $wYFix.FlipContext).Consumer, null, function(data) {
                // if there is no surrounding Flipper component,
                // we don't want to throw an error, so check
                // that data exists and is not the default string
                if ((0, $3C3VY.isObject)(data)) data[flipId] = {
                    shouldFlip: shouldFlip,
                    shouldInvert: shouldInvert,
                    onAppear: onAppear,
                    onStart: onStart,
                    onComplete: onComplete,
                    onExit: onExit
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0a9ec04bfae8b41b$export$c3816ea9cb166de0, $0a9ec04bfae8b41b$var$_extends({
                    flipId: flipId
                }, rest, {
                    portalKey: portalKey
                }), children);
            });
        });
    };
    return FlippedWithContext;
}((0, $4fqPo.Component));
$0a9ec04bfae8b41b$var$FlippedWithContext.propTypes = {};
var $0a9ec04bfae8b41b$export$2e2bcd8739ae039 = $0a9ec04bfae8b41b$var$FlippedWithContext;

});

parcelRegister("iNW05", function(module, exports) {
$parcel$export(module.exports, "default", () => $db09cb40b8348992$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gmpEl = parcelRequire("gmpEl");
var $db09cb40b8348992$var$ExitContainer = function ExitContainer(_ref) {
    var _cloneElement;
    var children = _ref.children;
    return (0, $4fqPo.cloneElement)(children, (_cloneElement = {}, _cloneElement[0, $gmpEl.DATA_EXIT_CONTAINER] = true, _cloneElement));
};
var $db09cb40b8348992$export$2e2bcd8739ae039 = $db09cb40b8348992$var$ExitContainer;

});




parcelRegister("7zOGv", function(module, exports) {
$parcel$export(module.exports, "AutoHeightBody", () => $210332957676ee4c$export$9a6247d807712c45);
$parcel$export(module.exports, "StyledFooter", () => $210332957676ee4c$export$61905ae62c7860fb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $1P8FK = parcelRequire("1P8FK");
parcelRequire("6uBMs");
var $93uvS = parcelRequire("93uvS");

var $4g4yb = parcelRequire("4g4yb");
const $210332957676ee4c$export$9a6247d807712c45 = /*#__PURE__*/ (0, $el3DQ.default)((0, $93uvS.default)).withConfig({
    componentId: "sc-vv1aut-0"
})`min-height:100%;height:auto !important;position:relative;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $210332957676ee4c$var$stickyBottom = /*#__PURE__*/ (0, $el3DQ.css)`position:absolute;bottom:0;left:50%;transform:translateX(-50%);`;
const $210332957676ee4c$export$61905ae62c7860fb = /*#__PURE__*/ (0, $el3DQ.default)((0, $4g4yb.Footer)).withConfig({
    componentId: "sc-vv1aut-1"
})`${(props)=>props.sticky ? $210332957676ee4c$var$stickyBottom : ''};`;
const $210332957676ee4c$export$2598938b3673d496 = /*#__PURE__*/ (0, $el3DQ.default)((0, $1P8FK.Link)).withConfig({
    componentId: "sc-vv1aut-2"
})`text-decoration:none;&:focus,&:hover,&:visited,&:link,&:active{text-decoration:none;}`;

});

parcelRegister("fNSBJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $96fd5742e59bb6a7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lqVX7 = parcelRequire("lqVX7");

var $gSpw2 = parcelRequire("gSpw2");
const $96fd5742e59bb6a7$var$contentStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $gSpw2.CONTENT)
});
/**
 * __Content__
 *
 * Provides a slot for your application content within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $96fd5742e59bb6a7$var$Content = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        "data-testid": testId,
        css: $96fd5742e59bb6a7$var$contentStyles
    }, children);
};
var $96fd5742e59bb6a7$export$2e2bcd8739ae039 = $96fd5742e59bb6a7$var$Content;

});

parcelRegister("iHhPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ed3e5427ac946aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");


var $dVnnV = parcelRequire("dVnnV");

var $gSpw2 = parcelRequire("gSpw2");

var $1OKS4 = parcelRequire("1OKS4");
var $curuD = parcelRequire("curuD");

var $8Mom2 = parcelRequire("8Mom2");

var $3TFEq = parcelRequire("3TFEq");
const $2ed3e5427ac946aa$var$pageLayoutSelector = {
    [(0, $gSpw2.PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
};
const $2ed3e5427ac946aa$var$gridTemplateAreasMobile = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $gSpw2.LEFT_PANEL)} ${(0, $gSpw2.BANNER)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $gSpw2.LEFT_PANEL)} ${(0, $gSpw2.TOP_NAVIGATION)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $gSpw2.LEFT_PANEL)} ${(0, $gSpw2.CONTENT)}"
 `;
const $2ed3e5427ac946aa$var$gridTemplateAreas = `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $gSpw2.LEFT_PANEL)} ${(0, $gSpw2.BANNER)} ${(0, $gSpw2.RIGHT_PANEL)}"
  ${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $gSpw2.LEFT_PANEL)} ${(0, $gSpw2.TOP_NAVIGATION)} ${(0, $gSpw2.RIGHT_PANEL)}"
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766 */ ''}
  "${(0, $gSpw2.LEFT_PANEL)} ${(0, $gSpw2.CONTENT)} ${(0, $gSpw2.RIGHT_PANEL)}"
 `;
const $2ed3e5427ac946aa$var$gridStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'grid',
    height: '100%',
    gridTemplateAreas: $2ed3e5427ac946aa$var$gridTemplateAreas,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateColumns: `${(0, $gSpw2.LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, $gSpw2.RIGHT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridTemplateRows: `${(0, $gSpw2.BANNER_HEIGHT)} ${(0, $gSpw2.TOP_NAVIGATION_HEIGHT)} auto`,
    outline: 'none'
});
const $2ed3e5427ac946aa$var$gridStylesMobileStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $dVnnV.UNSAFE_media).below.sm]: {
        gridTemplateAreas: $2ed3e5427ac946aa$var$gridTemplateAreasMobile,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `${(0, $gSpw2.LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
    }
});
/**
 * __Page layout__
 *
 * A collection of components which let you compose an application's page layout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $2ed3e5427ac946aa$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, $gSpw2.DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
    typeof $3TFEq;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $curuD.SkipLinksController), null, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mom2.SkipLinkWrapper), {
        skipLinksLabel: skipLinksLabel
    }), /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        ...$2ed3e5427ac946aa$var$pageLayoutSelector,
        "data-testid": testId,
        css: [
            $2ed3e5427ac946aa$var$gridStyles,
            $2ed3e5427ac946aa$var$gridStylesMobileStyles
        ],
        tabIndex: -1,
        "data-vc": "page-layout"
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $1OKS4.SidebarResizeController), {
        onLeftSidebarCollapse: onLeftSidebarCollapse,
        onLeftSidebarExpand: onLeftSidebarExpand
    }, children))));
};
var $2ed3e5427ac946aa$export$2e2bcd8739ae039 = $2ed3e5427ac946aa$var$PageLayout;

});
parcelRegister("dVnnV", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_media", () => $5c56fdc0f105b815$export$c881183ca713c214);
$parcel$export(module.exports, "media", () => (parcelRequire("3jKXW")).media);

var $3jKXW = parcelRequire("3jKXW");
const $5c56fdc0f105b815$export$c881183ca713c214 = (0, $3jKXW.media);

});
parcelRegister("3jKXW", function(module, exports) {
$parcel$export(module.exports, "media", () => $bba56aa81d4585bd$export$987d49ffe1b0900f);
const $bba56aa81d4585bd$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});


parcelRegister("1OKS4", function(module, exports) {
$parcel$export(module.exports, "SidebarResizeController", () => $96a07d54d71d0ce5$export$850bd1bba41f1448);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $c1tmZ = parcelRequire("c1tmZ");

var $1dGol = parcelRequire("1dGol");

var $16U9w = parcelRequire("16U9w");

var $gSpw2 = parcelRequire("gSpw2");

var $gf9d9 = parcelRequire("gf9d9");

var $424Vp = parcelRequire("424Vp");
const $96a07d54d71d0ce5$var$handleDataAttributesAndCb = (callback = (0, $c1tmZ.default), leftSidebarState)=>{
    document.documentElement.removeAttribute((0, $gSpw2.IS_SIDEBAR_COLLAPSING));
    callback(leftSidebarState);
};
const $96a07d54d71d0ce5$var$leftSidebarSelector = (0, $gf9d9.getPageLayoutSlotCSSSelector)('left-sidebar');
const $96a07d54d71d0ce5$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
    const [leftSidebarState, setLeftSidebarState] = (0, $4fqPo.useState)({
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true,
        hasInit: false
    });
    const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen, hasInit: hasInit } = leftSidebarState;
    // We put the latest callbacks into a ref so we can always have the latest
    // functions in our transitionend listeners
    const stableRef = (0, $4fqPo.useRef)({
        onExpand: onExpand,
        onCollapse: onCollapse
    });
    (0, $4fqPo.useEffect)(()=>{
        stableRef.current = {
            onExpand: onExpand,
            onCollapse: onCollapse
        };
    }, [
        onExpand,
        onCollapse
    ]);
    const transition = (0, $4fqPo.useRef)(null);
    const mobileMediaQuery = (0, $16U9w.UNSAFE_useMediaQuery)('below.sm');
    const isOpen = mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
    const expandLeftSidebar = (0, $4fqPo.useCallback)(()=>{
        var _transition$current2, _transition$current3;
        if (isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't expand at mobile widths; instead we use a flyout which is treated the same otherwise
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current;
            const flyoutOpenSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $gSpw2.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isFlyoutOpen: true,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutOpenSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onExpand` still
            (_transition$current = transition.current) === null || _transition$current === void 0 || _transition$current.complete();
            $96a07d54d71d0ce5$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
            return;
        }
        if (isResizing || !isLeftSidebarCollapsed || // already expanding
        ((_transition$current2 = transition.current) === null || _transition$current2 === void 0 ? void 0 : _transition$current2.action) === 'expand') return;
        // flush existing transition
        (_transition$current3 = transition.current) === null || _transition$current3 === void 0 || _transition$current3.complete();
        const width = Math.max(lastLeftSidebarWidth, (0, $gSpw2.DEFAULT_LEFT_SIDEBAR_WIDTH));
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: false,
            isFlyoutOpen: false,
            leftSidebarWidth: width,
            lastLeftSidebarWidth: lastLeftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $96a07d54d71d0ce5$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($96a07d54d71d0ce5$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if ((0, $1dGol.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $lMcEJ.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (event.target === sidebar && event.propertyName === 'width') {
                    var _transition$current4;
                    (_transition$current4 = transition.current) === null || _transition$current4 === void 0 || _transition$current4.complete();
                }
            }
        });
        const value = {
            action: 'expand',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        lastLeftSidebarWidth,
        flyoutLockCount,
        isFixed,
        leftSidebarWidth,
        hasInit
    ]);
    const collapseLeftSidebar = (0, $4fqPo.useCallback)((_event, collapseWithoutTransition)=>{
        var _transition$current6, _transition$current7;
        if (!isOpen) return;
        // If the user is at a mobile viewport when this runs, we handle it differently
        // We don't collapse at mobile widths; instead we close the flyout.
        if (mobileMediaQuery !== null && mobileMediaQuery !== void 0 && mobileMediaQuery.matches) {
            var _transition$current5;
            const flyoutCloseSidebarState = {
                isResizing: false,
                isLeftSidebarCollapsed: true,
                leftSidebarWidth: (0, $gSpw2.COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isFlyoutOpen: false,
                flyoutLockCount: 0,
                isFixed: isFixed,
                hasInit: hasInit
            };
            setLeftSidebarState(flyoutCloseSidebarState);
            // Flush the desktop transitions, cleanup, and call the `onCollapse` still
            (_transition$current5 = transition.current) === null || _transition$current5 === void 0 || _transition$current5.complete();
            $96a07d54d71d0ce5$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
            return;
        }
        if (isResizing || isLeftSidebarCollapsed || // already collapsing
        ((_transition$current6 = transition.current) === null || _transition$current6 === void 0 ? void 0 : _transition$current6.action) === 'collapse') return;
        // flush existing transition
        (_transition$current7 = transition.current) === null || _transition$current7 === void 0 || _transition$current7.complete();
        // data-attribute is used as a CSS selector to sync the hiding/showing
        // of the nav contents with expand/collapse animation
        document.documentElement.setAttribute((0, $gSpw2.IS_SIDEBAR_COLLAPSING), 'true');
        const updatedLeftSidebarState = {
            isLeftSidebarCollapsed: true,
            isFlyoutOpen: false,
            leftSidebarWidth: (0, $gSpw2.COLLAPSED_LEFT_SIDEBAR_WIDTH),
            lastLeftSidebarWidth: leftSidebarWidth,
            isResizing: isResizing,
            flyoutLockCount: flyoutLockCount,
            isFixed: isFixed,
            hasInit: hasInit
        };
        setLeftSidebarState(updatedLeftSidebarState);
        function finish() {
            $96a07d54d71d0ce5$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
        }
        const sidebar = document.querySelector($96a07d54d71d0ce5$var$leftSidebarSelector);
        // onTransitionEnd isn't triggered when a user prefers reduced motion
        if (collapseWithoutTransition || (0, $1dGol.isReducedMotion)() || !sidebar) {
            finish();
            return;
        }
        const unbindEvent = (0, $lMcEJ.bind)(sidebar, {
            type: 'transitionend',
            listener (event) {
                if (sidebar === event.target && event.propertyName === 'width') {
                    var _transition$current8;
                    (_transition$current8 = transition.current) === null || _transition$current8 === void 0 || _transition$current8.complete();
                }
            }
        });
        const value = {
            action: 'collapse',
            complete: ()=>{
                value.abort();
                finish();
            },
            abort: ()=>{
                unbindEvent();
                transition.current = null;
            }
        };
        transition.current = value;
    }, [
        isOpen,
        mobileMediaQuery,
        isResizing,
        isLeftSidebarCollapsed,
        leftSidebarWidth,
        flyoutLockCount,
        isFixed,
        lastLeftSidebarWidth,
        hasInit
    ]);
    /**
   * Conditionally toggle the expanding or collapsing the sidebars.
   * This supports our mobile flyout mode as well.
   */ const toggleLeftSidebar = (0, $4fqPo.useCallback)((event, collapseWithoutTransition)=>{
        if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
        else expandLeftSidebar();
    }, [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar
    ]);
    // Make sure we finish any lingering transitions when unmounting
    (0, $4fqPo.useEffect)(function mount() {
        return function unmount() {
            var _transition$current9;
            (_transition$current9 = transition.current) === null || _transition$current9 === void 0 || _transition$current9.abort();
        };
    }, []);
    const context = (0, $4fqPo.useMemo)(()=>({
            isLeftSidebarCollapsed: !isOpen,
            expandLeftSidebar: // Technically this isn't quite true, but with mobile it's a bit safer if apps are using this to roll their own collapse/expand
            expandLeftSidebar,
            collapseLeftSidebar: collapseLeftSidebar,
            leftSidebarState: leftSidebarState,
            setLeftSidebarState: setLeftSidebarState,
            toggleLeftSidebar: toggleLeftSidebar
        }), [
        isOpen,
        expandLeftSidebar,
        collapseLeftSidebar,
        leftSidebarState,
        toggleLeftSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $424Vp.SidebarResizeContext).Provider, {
        value: context
    }, children);
};

});
parcelRegister("16U9w", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $ba84a39600316e84$export$49e55ae2c03d6045);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $1VniX = parcelRequire("1VniX");

var $dVnnV = parcelRequire("dVnnV");
var $ba84a39600316e84$var$_window, $ba84a39600316e84$var$_window$matchMedia, $ba84a39600316e84$var$_window2, $ba84a39600316e84$var$_window2$matchMedia, $ba84a39600316e84$var$_window3, $ba84a39600316e84$var$_window3$matchMedia, $ba84a39600316e84$var$_window4, $ba84a39600316e84$var$_window4$matchMedia, $ba84a39600316e84$var$_window5, $ba84a39600316e84$var$_window5$matchMedia, $ba84a39600316e84$var$_window6, $ba84a39600316e84$var$_window6$matchMedia, $ba84a39600316e84$var$_window7, $ba84a39600316e84$var$_window7$matchMedia, $ba84a39600316e84$var$_window8, $ba84a39600316e84$var$_window8$matchMedia, $ba84a39600316e84$var$_window9, $ba84a39600316e84$var$_window9$matchMedia, $ba84a39600316e84$var$_window0, $ba84a39600316e84$var$_window0$matchMedia, $ba84a39600316e84$var$_window1, $ba84a39600316e84$var$_window1$matchMedia;
const $ba84a39600316e84$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window = window) === null || $ba84a39600316e84$var$_window === void 0 || ($ba84a39600316e84$var$_window$matchMedia = $ba84a39600316e84$var$_window.matchMedia) === null || $ba84a39600316e84$var$_window$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window$matchMedia.call($ba84a39600316e84$var$_window, (0, $dVnnV.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window2 = window) === null || $ba84a39600316e84$var$_window2 === void 0 || ($ba84a39600316e84$var$_window2$matchMedia = $ba84a39600316e84$var$_window2.matchMedia) === null || $ba84a39600316e84$var$_window2$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window2$matchMedia.call($ba84a39600316e84$var$_window2, (0, $dVnnV.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window3 = window) === null || $ba84a39600316e84$var$_window3 === void 0 || ($ba84a39600316e84$var$_window3$matchMedia = $ba84a39600316e84$var$_window3.matchMedia) === null || $ba84a39600316e84$var$_window3$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window3$matchMedia.call($ba84a39600316e84$var$_window3, (0, $dVnnV.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window4 = window) === null || $ba84a39600316e84$var$_window4 === void 0 || ($ba84a39600316e84$var$_window4$matchMedia = $ba84a39600316e84$var$_window4.matchMedia) === null || $ba84a39600316e84$var$_window4$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window4$matchMedia.call($ba84a39600316e84$var$_window4, (0, $dVnnV.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window5 = window) === null || $ba84a39600316e84$var$_window5 === void 0 || ($ba84a39600316e84$var$_window5$matchMedia = $ba84a39600316e84$var$_window5.matchMedia) === null || $ba84a39600316e84$var$_window5$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window5$matchMedia.call($ba84a39600316e84$var$_window5, (0, $dVnnV.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window6 = window) === null || $ba84a39600316e84$var$_window6 === void 0 || ($ba84a39600316e84$var$_window6$matchMedia = $ba84a39600316e84$var$_window6.matchMedia) === null || $ba84a39600316e84$var$_window6$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window6$matchMedia.call($ba84a39600316e84$var$_window6, (0, $dVnnV.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window7 = window) === null || $ba84a39600316e84$var$_window7 === void 0 || ($ba84a39600316e84$var$_window7$matchMedia = $ba84a39600316e84$var$_window7.matchMedia) === null || $ba84a39600316e84$var$_window7$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window7$matchMedia.call($ba84a39600316e84$var$_window7, (0, $dVnnV.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window8 = window) === null || $ba84a39600316e84$var$_window8 === void 0 || ($ba84a39600316e84$var$_window8$matchMedia = $ba84a39600316e84$var$_window8.matchMedia) === null || $ba84a39600316e84$var$_window8$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window8$matchMedia.call($ba84a39600316e84$var$_window8, (0, $dVnnV.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window9 = window) === null || $ba84a39600316e84$var$_window9 === void 0 || ($ba84a39600316e84$var$_window9$matchMedia = $ba84a39600316e84$var$_window9.matchMedia) === null || $ba84a39600316e84$var$_window9$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window9$matchMedia.call($ba84a39600316e84$var$_window9, (0, $dVnnV.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window0 = window) === null || $ba84a39600316e84$var$_window0 === void 0 || ($ba84a39600316e84$var$_window0$matchMedia = $ba84a39600316e84$var$_window0.matchMedia) === null || $ba84a39600316e84$var$_window0$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window0$matchMedia.call($ba84a39600316e84$var$_window0, (0, $dVnnV.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($ba84a39600316e84$var$_window1 = window) === null || $ba84a39600316e84$var$_window1 === void 0 || ($ba84a39600316e84$var$_window1$matchMedia = $ba84a39600316e84$var$_window1.matchMedia) === null || $ba84a39600316e84$var$_window1$matchMedia === void 0 ? void 0 : $ba84a39600316e84$var$_window1$matchMedia.call($ba84a39600316e84$var$_window1, (0, $dVnnV.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $ba84a39600316e84$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $4fqPo.useRef)(listener);
    (0, $4fqPo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $ba84a39600316e84$var$queries[queryString];
    (0, $1VniX.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $lMcEJ.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("1VniX", function(module, exports) {
$parcel$export(module.exports, "useLayoutEffect", () => $2b9af2d65c1dc9b7$export$e5c5a5f917a5871c);

var $4fqPo = parcelRequire("4fqPo");
const $2b9af2d65c1dc9b7$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $4fqPo.useEffect) : (0, $4fqPo.useLayoutEffect);

});


parcelRegister("gf9d9", function(module, exports) {
$parcel$export(module.exports, "getPageLayoutSlotCSSSelector", () => $4d3bebe5d2a1344a$export$218ece2c32b7db0e);

var $gSpw2 = parcelRequire("gSpw2");
const $4d3bebe5d2a1344a$export$218ece2c32b7db0e = (slotName)=>`[${0, $gSpw2.PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;

});


parcelRegister("curuD", function(module, exports) {
$parcel$export(module.exports, "SkipLinksController", () => $be1e0326a414a59d$export$da7be99d6a868f3d);

var $4fqPo = parcelRequire("4fqPo");

var $gSpw2 = parcelRequire("gSpw2");

var $5AS0Q = parcelRequire("5AS0Q");
const $be1e0326a414a59d$var$byDOMOrder = (a, b)=>{
    const elems = Array.from(document.querySelectorAll(`[${(0, $gSpw2.PAGE_LAYOUT_SLOT_SELECTOR)}]`));
    const elemA = document.getElementById(a.id);
    const elemB = document.getElementById(b.id);
    const indexA = a.listIndex ?? elems.indexOf(elemA);
    const indexB = b.listIndex ?? elems.indexOf(elemB);
    /**
   * If they are tied it is because one (or both) is
   * a custom skiplink with a set index.
   *
   * Give the custom skiplink priority.
   */ if (indexA === indexB) {
        if (a.listIndex !== undefined) return -1;
        else return 1;
    }
    return indexA - indexB;
};
const $be1e0326a414a59d$export$da7be99d6a868f3d = ({ children: children })=>{
    const [links, setLinks] = (0, $4fqPo.useState)([]);
    const registerSkipLink = (0, $4fqPo.useRef)((skipLinkData)=>{
        // Don't add duplicate SkipLinks
        setLinks((oldLinks)=>{
            if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
            return [
                ...oldLinks,
                skipLinkData
            ].sort($be1e0326a414a59d$var$byDOMOrder);
        });
    });
    const unregisterSkipLink = (0, $4fqPo.useRef)((id)=>{
        setLinks((links)=>links.filter((link)=>link.id !== id));
    });
    const context = {
        registerSkipLink: registerSkipLink.current,
        skipLinksData: links,
        unregisterSkipLink: unregisterSkipLink.current
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5AS0Q.SkipLinksContext).Provider, {
        value: context
    }, children);
};

});

parcelRegister("8Mom2", function(module, exports) {
$parcel$export(module.exports, "SkipLinkWrapper", () => $7e316f397af19f2b$export$4241a460557ba901);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lqVX7 = parcelRequire("lqVX7");

var $5Aw5C = parcelRequire("5Aw5C");
var $aJv53 = parcelRequire("aJv53");

var $gSpw2 = parcelRequire("gSpw2");

var $jNMXh = parcelRequire("jNMXh");

var $7alXq = parcelRequire("7alXq");
function $7e316f397af19f2b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $7e316f397af19f2b$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $lqVX7.css)((0, $aJv53.prefersReducedMotion)());
const $7e316f397af19f2b$var$skipLinkStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    margin: "var(--ds-space-250, 20px)",
    padding: '0.8rem 1rem',
    position: 'fixed',
    zIndex: -1,
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    border: 'none',
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    insetInlineStart: -999999,
    opacity: 0,
    transform: 'translateY(-50%)',
    transition: `transform 0.3s ${(0, $5Aw5C.easeOut)}`,
    '&:focus-within': {
        zIndex: 2147483640,
        insetInlineStart: 0,
        opacity: 1,
        transform: 'translateY(0%)'
    }
});
const $7e316f397af19f2b$var$skipLinkHeadingStyles = {
    name: "1blmyc0",
    styles: "font-weight:var(--ds-font-weight-semibold, 600)"
};
const $7e316f397af19f2b$var$skipLinkListStyles = {
    name: "1xay72g",
    styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
};
const $7e316f397af19f2b$var$assignIndex = (num, arr)=>{
    if (!arr.includes(num)) return num;
    return $7e316f397af19f2b$var$assignIndex(num + 1, arr);
};
const $7e316f397af19f2b$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
    const { skipLinksData: skipLinksData } = (0, $jNMXh.useSkipLinks)();
    if (skipLinksData.length === 0) return null;
    const sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $7e316f397af19f2b$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const escapeHandler = (event)=>{
        if (event.keyCode === 27) {
            const container = document.querySelector(`[${(0, $gSpw2.PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
            if (container !== null) container.focus();
        }
    };
    const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
    const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
    const emptyLabelOverride = !!(skipLinksLabel !== null && skipLinksLabel !== void 0 && skipLinksLabel.match(/^\s+$/));
    const label = skipLinksLabel || (0, $gSpw2.DEFAULT_I18N_PROPS_SKIP_LINKS);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        onFocus: attachEscHandler,
        onBlur: removeEscHandler,
        css: [
            $7e316f397af19f2b$var$skipLinkStyles,
            $7e316f397af19f2b$var$prefersReducedMotionStyles
        ],
        "data-skip-link-wrapper": true
    }, emptyLabelOverride ? null : /*#__PURE__*/ (0, $lqVX7.jsx)("p", {
        css: $7e316f397af19f2b$var$skipLinkHeadingStyles
    }, label), /*#__PURE__*/ (0, $lqVX7.jsx)("ol", {
        css: $7e316f397af19f2b$var$skipLinkListStyles
    }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>/*#__PURE__*/ (0, $lqVX7.jsx)((0, $7alXq.SkipLink), {
            key: id,
            href: `#${id}`,
            isFocusable: true
        }, skipLinkTitle))));
};

});
parcelRegister("7alXq", function(module, exports) {
$parcel$export(module.exports, "SkipLink", () => $3ae74876bbce7de2$export$ef95c37428582a65);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lqVX7 = parcelRequire("lqVX7");

var $iByhD = parcelRequire("iByhD");
function $3ae74876bbce7de2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ae74876bbce7de2$var$skipLinkListItemStyles = {
    name: "19m435s",
    styles: "margin-block-start:0"
};
const $3ae74876bbce7de2$var$focusTargetRef = (href)=>(event)=>{
        event.preventDefault();
        const targetRef = document.querySelector(href);
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        // @ts-ignore
        const key = event.which || event.keycode;
        // if it is a keypress and the key is not
        // space or enter, just ignore it.
        if (key && key !== 13 && key !== 32) return;
        if (targetRef) {
            targetRef.setAttribute('tabindex', '-1');
            // @ts-ignore
            targetRef.addEventListener('blur', handleBlur);
            // @ts-ignore
            targetRef.focus();
            document.activeElement && document.activeElement.scrollIntoView({
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                behavior: 'smooth'
            });
            window.scrollTo(0, 0);
        }
        return false;
    };
const $3ae74876bbce7de2$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
    return /*#__PURE__*/ (0, $lqVX7.jsx)("li", {
        css: $3ae74876bbce7de2$var$skipLinkListItemStyles
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $iByhD.default), {
        tabIndex: isFocusable ? 0 : -1,
        href: href,
        onClick: $3ae74876bbce7de2$var$focusTargetRef(href)
    }, children));
};

});



parcelRegister("bJQcu", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoizedHOC", () => $81ad4e46beac85b0$export$f0da0221ee5515ac);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $cBTCm = parcelRequire("cBTCm");
const $81ad4e46beac85b0$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getThemeColor), (0, $i8gmD.getHelpCenterBrandingLoader), (0, $i8gmD.getHelpCenterTopBarSplitFlag), (themeColor, isBrandingLoaded, hasTopBarBeenSplit)=>({
        themeColor: themeColor,
        isBrandingLoaded: isBrandingLoaded,
        hasTopBarBeenSplit: hasTopBarBeenSplit
    }));
const $81ad4e46beac85b0$var$ConnectedBannerWithLayoutHeader = (0, $bmgw6.default)($81ad4e46beac85b0$var$selector)((0, $cBTCm.BannerWithLayoutHeader));
var $81ad4e46beac85b0$export$2e2bcd8739ae039 = $81ad4e46beac85b0$var$ConnectedBannerWithLayoutHeader;
const $81ad4e46beac85b0$export$f0da0221ee5515ac = (0, $bmgw6.default)($81ad4e46beac85b0$var$selector)((0, $cBTCm.BannerWithLayoutHeaderMemoized));

});
parcelRegister("cBTCm", function(module, exports) {
$parcel$export(module.exports, "BannerWithLayoutHeader", () => $bf4454dbb5868c4b$export$dc6fa5f6f452943b);
$parcel$export(module.exports, "BannerWithLayoutHeaderMemoized", () => $bf4454dbb5868c4b$export$2e33b09d9c57faa1);
/* banner-with-layout-header.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $bG6ob = parcelRequire("bG6ob");

var $fVQGu = parcelRequire("fVQGu");

var $bpWyP = parcelRequire("bpWyP");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("eSizR");
var $aOk5W = parcelRequire("aOk5W");
parcelRequire("8zo3m");
var $f1dKT = parcelRequire("f1dKT");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $cijxS = parcelRequire("cijxS");
const $bf4454dbb5868c4b$export$ed7cc0d417ee89e = $bpWyP.unitless * 23; // 184
const $bf4454dbb5868c4b$export$6ba969052247c298 = $bpWyP.unitless * 23 + (0, $5Kpwp.HEADER_HEIGHT); // 240
const $bf4454dbb5868c4b$export$87562042682a224f = $bpWyP.unitless * 37; // 296
const $bf4454dbb5868c4b$export$f6510fb522c3cc26 = 300;
const $bf4454dbb5868c4b$export$5c538a381f9a90ef = $bpWyP.unitless * 22; // 176
const $bf4454dbb5868c4b$var$BANNER_WITH_REDUCED_HEIGHT = 152;
const $bf4454dbb5868c4b$export$60963c14ec4e3ee7 = 'layout-banner';
const $bf4454dbb5868c4b$export$dc6fa5f6f452943b = ({ themeColor: themeColor, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, isBrandingLoaded: isBrandingLoaded, hideBanner: hideBanner, prefetchBrandingModel: prefetchBrandingModel, hasTopBarBeenSplit: hasTopBarBeenSplit, renderForPaperLayout: renderForPaperLayout })=>{
    // Update CSS variable when helpCenterBanner changes
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty('--banner-bg-image', helpCenterBanner ? `url(${helpCenterBanner})` : 'none');
    }, [
        helpCenterBanner
    ]);
    let updatedBannerHeight = hasTopBarBeenSplit ? $bf4454dbb5868c4b$export$ed7cc0d417ee89e : $bf4454dbb5868c4b$var$BANNER_WITH_REDUCED_HEIGHT;
    if (renderForPaperLayout) updatedBannerHeight = hasTopBarBeenSplit ? $bf4454dbb5868c4b$export$f6510fb522c3cc26 : $bf4454dbb5868c4b$export$87562042682a224f + (0, $5Kpwp.HEADER_HEIGHT); // in login page we render paper layout
    if ((0, $bG6ob.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) updatedBannerHeight = $bf4454dbb5868c4b$var$BANNER_WITH_REDUCED_HEIGHT;
    const bannerCustomProp = {
        style: {
            height: `${updatedBannerHeight}px`,
            backgroundColor: themeColor,
            backgroundImage: 'var(--banner-bg-image)',
            borderRadius: hasTopBarBeenSplit ? "var(--ds-radius-large, 8px)" : 'initial'
        }
    };
    const showBannerWithLoader = ()=>{
        if (hideBanner) return null;
        if ((0, $bG6ob.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $bf4454dbb5868c4b$var$bannerContainerStyleWithReducedHeight
        }, isBrandingLoaded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            "data-testId": $bf4454dbb5868c4b$export$60963c14ec4e3ee7,
            xcss: $bf4454dbb5868c4b$var$bannerStyle,
            ...bannerCustomProp
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
        const bannerContainerCustomPropPaperLayout = {
            style: {
                height: `${updatedBannerHeight + (hasTopBarBeenSplit ? 16 : 0) * 2}px`,
                top: renderForPaperLayout && hasTopBarBeenSplit ? `${0, $5Kpwp.HEADER_HEIGHT}px` : 'initial',
                bottom: renderForPaperLayout ? 'initial' : 0,
                paddingTop: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingBottom: hasTopBarBeenSplit ? "var(--ds-space-200, 16px)" : "var(--ds-space-0, 0px)",
                paddingLeft: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)",
                paddingRight: hasTopBarBeenSplit ? "var(--ds-space-400, 32px)" : "var(--ds-space-0, 0px)"
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($bf4454dbb5868c4b$var$BannerContainer, {
            ...bannerContainerCustomPropPaperLayout,
            "data-testid": 'BannerContainer'
        }, !isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: updatedBannerHeight,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })), isBrandingLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($bf4454dbb5868c4b$var$BannerStyleWithImage, {
            "data-testid": $bf4454dbb5868c4b$export$60963c14ec4e3ee7,
            ...bannerCustomProp
        }));
    };
    let containerHeight = renderForPaperLayout ? (0, $5Kpwp.HEADER_HEIGHT) : $bf4454dbb5868c4b$var$BANNER_WITH_REDUCED_HEIGHT;
    if ((0, $bG6ob.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit && !renderForPaperLayout) containerHeight = (0, $5Kpwp.HEADER_HEIGHT) + $bf4454dbb5868c4b$var$BANNER_WITH_REDUCED_HEIGHT + 32;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($bf4454dbb5868c4b$var$Container, {
        "data-testid": 'outer-BannerContainer',
        style: {
            height: removeHeader || headerless || hideBanner ? 'auto' : `${containerHeight}px`
        }
    }, showBannerWithLoader(), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f1dKT.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($bf4454dbb5868c4b$var$HeaderContainerStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aOk5W.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    })), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($bf4454dbb5868c4b$var$EmptyHeader, {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            height: `${(0, $5Kpwp.HEADER_HEIGHT)}px`
        }
    }));
};
const $bf4454dbb5868c4b$export$2e33b09d9c57faa1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo($bf4454dbb5868c4b$export$dc6fa5f6f452943b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bf4454dbb5868c4b$var$Container = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $bf4454dbb5868c4b$var$BannerStyleWithImage = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1bsb1osq _4t3i1osq _1lrw1dfr _12vemgnk _ouxl1ssb _bfhk1pom _1itk8q6q",
            __cmplp.className
        ])
    });
});
const $bf4454dbb5868c4b$var$BannerContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_kqswstnw _1bsb1osq _vchhusvi",
            __cmplp.className
        ])
    });
});
const $bf4454dbb5868c4b$var$bannerContainerStyleWithReducedHeight = (0, $2m8U6.xcss)({
    position: 'absolute',
    width: '100%',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.400',
    paddingRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    bottom: 'space.0',
    height: `${$bf4454dbb5868c4b$var$BANNER_WITH_REDUCED_HEIGHT + 32}px`
});
const $bf4454dbb5868c4b$var$bannerStyle = (0, $2m8U6.xcss)({
    width: '100%',
    height: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: 'radius.large',
    backgroundColor: 'color.background.brand.bold'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $bf4454dbb5868c4b$var$HeaderContainerStyle = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_kqswh2mm _1pbykuz3",
            __cmplp.className
        ])
    });
});
const $bf4454dbb5868c4b$var$EmptyHeader = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eSizR", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("aOk5W")).default);

var $aOk5W = parcelRequire("aOk5W");

});
parcelRegister("aOk5W", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c8b9ceb1b6374b1$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $f4IfF = parcelRequire("f4IfF");

var $fVQGu = parcelRequire("fVQGu");

var $5eCdR = parcelRequire("5eCdR");

var $3dLJl = parcelRequire("3dLJl");

var $k16VK = parcelRequire("k16VK");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("cp5a8");
var $toigl = parcelRequire("toigl");
parcelRequire("nuvfZ");
var $guxiT = parcelRequire("guxiT");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("4Vvkl");
var $6BARu = parcelRequire("6BARu");

var $5Kpwp = parcelRequire("5Kpwp");

var $cijxS = parcelRequire("cijxS");

var $eSL4S = parcelRequire("eSL4S");

var $Y85G3 = parcelRequire("Y85G3");
parcelRequire("eeRbP");
var $cX46g = parcelRequire("cX46g");
const $3c8b9ceb1b6374b1$var$getHeaderLoginUrl = (state)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    return (0, $Y85G3.getLoginUrl)({
        portalId: portalId,
        isAbsolute: true,
        redirectUrl: (0, $h1MVT.getPathname)(state)
    });
};
const $3c8b9ceb1b6374b1$var$userRequestsSelector = (state)=>{
    return (0, $6BARu.getUserRequestsCounts)(state);
};
const $3c8b9ceb1b6374b1$var$selector = (0, $3yyCx.createSelector)((0, $2hx7o.isLoggedIn), $3c8b9ceb1b6374b1$var$getHeaderLoginUrl, (0, $2hx7o.isUserLoaded), (0, $toigl.isCustomizing), $3c8b9ceb1b6374b1$var$userRequestsSelector, (0, $guxiT.getOrganisations), (0, $2mzxy.getIsAnonymousEnabled), (0, $i8gmD.getHelpCenterBrandingLoader), (0, $i8gmD.getHelpCenterTopBarColor), (0, $i8gmD.getHelpCenterTopBarSplitFlag), (0, $i8gmD.getLogoUrl), (0, $i8gmD.getSharedPortalName), (userLoggedIn, loginUrl, userLoaded, customizing, userRequest, organisations, anonymousEnabled, isBrandingLoaded, topBarColor, hasTopBarBeenSplit, logoUrl, name)=>({
        userLoggedIn: userLoggedIn,
        loginUrl: loginUrl,
        userRequest: userRequest,
        organisations: organisations,
        anonymousEnabled: anonymousEnabled,
        name: name,
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded,
        isCustomizing: customizing,
        headerBackgroundColor: hasTopBarBeenSplit ? topBarColor : undefined,
        logoUrl: logoUrl ?? undefined
    }));
class $3c8b9ceb1b6374b1$var$Header extends $4fqPo.Component {
    componentDidMount() {
        if (!this.props.isModelCallPrefetched) {
            if (!(0, $eSL4S.isHelpCentersManagement)()) this.props.fetchBranding();
            if (!this.props.isAnonymous) {
                this.props.fetchUser();
                this.props.fetchOrganisations();
                this.props.fetchUserRequestsCounts();
            }
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous && !this.props.isModelCallPrefetched) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)() && !(0, $eSL4S.isHelpCentersManagement)()) {
            if (this.props.isBrandingLoaded) return /*#__PURE__*/ $4fqPo.createElement((0, $cX46g.default), this.props);
            return /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
                name: "header-loader"
            }, /*#__PURE__*/ $4fqPo.createElement((0, $fVQGu.LoadingSkeleton), {
                "data-testid": "header-skeleton",
                height: (0, $5Kpwp.HEADER_HEIGHT),
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        }
        return /*#__PURE__*/ $4fqPo.createElement((0, $cX46g.default), this.props);
    }
}
var $3c8b9ceb1b6374b1$export$2e2bcd8739ae039 = (0, $bmgw6.default)($3c8b9ceb1b6374b1$var$selector, {
    fetchBranding: (0, $5eCdR.fetchHelpCenterBrandingAction),
    fetchUser: (0, $f4IfF.fetchUserModelAction),
    fetchOrganisations: (0, $3dLJl.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $k16VK.fetchUserRequestsCountsAction)
})($3c8b9ceb1b6374b1$var$Header);

});
parcelRegister("cp5a8", function(module, exports) {
$parcel$export(module.exports, "isAnyUploadInProgress", () => (parcelRequire("toigl")).isAnyUploadInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("toigl")).isCustomizing);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("toigl")).isSaveInProgress);
$parcel$export(module.exports, "isUploadInProgress", () => (parcelRequire("toigl")).isUploadInProgress);
parcelRequire("toigl");

});
parcelRegister("toigl", function(module, exports) {
$parcel$export(module.exports, "isCustomizing", () => $903731ebdc48d7bb$export$ce3eed7c98304744);
$parcel$export(module.exports, "isSaveInProgress", () => $903731ebdc48d7bb$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isUploadInProgress", () => $903731ebdc48d7bb$export$cf866b9449681342);
$parcel$export(module.exports, "isAnyUploadInProgress", () => $903731ebdc48d7bb$export$4dfd840e8ddac89d);
const $903731ebdc48d7bb$export$ce3eed7c98304744 = (state)=>state.ui.helpCenterPreview.isCustomizing;
const $903731ebdc48d7bb$export$2b75ac2de7a23db1 = (state)=>state.ui.helpCenterPreview.isSaveInProgress;
const $903731ebdc48d7bb$export$cf866b9449681342 = (state, fileCollection)=>!!state.ui.helpCenterPreview.uploadsInProgress[fileCollection];
const $903731ebdc48d7bb$export$4dfd840e8ddac89d = (state)=>{
    const { uploadsInProgress: uploadsInProgress } = state.ui.helpCenterPreview;
    return Object.keys(uploadsInProgress).find((uploadKey)=>uploadsInProgress[uploadKey]) !== undefined;
};

});


parcelRegister("nuvfZ", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("guxiT")).getOrganisations);

var $guxiT = parcelRequire("guxiT");

});
parcelRegister("guxiT", function(module, exports) {
$parcel$export(module.exports, "getOrganisations", () => $bb6e0cd7fb4540fa$export$17495f9c20464b8);
const $bb6e0cd7fb4540fa$export$17495f9c20464b8 = (state)=>state.persisted.organisations.organisations;

});


parcelRegister("4Vvkl", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => (parcelRequire("6BARu")).getUserRequestsCounts);

var $6BARu = parcelRequire("6BARu");

});
parcelRegister("6BARu", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $a285455b5654a5cf$export$be73da9c8fdefffb);
const $a285455b5654a5cf$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});


parcelRegister("eeRbP", function(module, exports) {
$parcel$export(module.exports, "DumbHeader", () => (parcelRequire("cX46g")).default);

var $cX46g = parcelRequire("cX46g");

});
parcelRegister("cX46g", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9ba80d47582d68f$export$2e2bcd8739ae039);
/* header-dumb.tsx generated by @compiled/babel-plugin v0.37.1 */ /** @jsxFrag React.Fragment */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $el3DQ = parcelRequire("el3DQ");

var $1P8FK = parcelRequire("1P8FK");

var $1HSOM = parcelRequire("1HSOM");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $5Uaxl = parcelRequire("5Uaxl");
var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("6EL7C");
var $1PnsK = parcelRequire("1PnsK");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("dO3UT");
var $b5eoO = parcelRequire("b5eoO");

var $fFB0R = parcelRequire("fFB0R");

var $5yLXq = parcelRequire("5yLXq");

var $6bGmX = parcelRequire("6bGmX");

var $3H4LK = parcelRequire("3H4LK");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $cijxS = parcelRequire("cijxS");

var $5k5F5 = parcelRequire("5k5F5");
parcelRequire("7WK95");
var $gsFvz = parcelRequire("gsFvz");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $5Z4uE = parcelRequire("5Z4uE");

var $Y85G3 = parcelRequire("Y85G3");
parcelRequire("jgUOz");
var $eOmbo = parcelRequire("eOmbo");
parcelRequire("2A86r");
var $3qvcg = parcelRequire("3qvcg");
parcelRequire("ggiKZ");
var $7i0Yg = parcelRequire("7i0Yg");

var $K1VQU = parcelRequire("K1VQU");
const $b9ba80d47582d68f$var$isCompiledCssEnabled = ()=>(0, $6bGmX.default).checkGate('help_center_login_compiled_css');
const $b9ba80d47582d68f$var$Header = ({ isAnonymous: isAnonymous, isUserLoaded: isUserLoaded, userLoggedIn: userLoggedIn, loginUrl: loginUrl, logoTextColor: logoTextColor, hideSearchButton: hideSearchButton, anonymousEnabled: anonymousEnabled, showThemedBackground: showThemedBackground, disableAllHeaderLinks: disableAllHeaderLinks, headerBackgroundColor: headerBackgroundColor, logoUrl: logoUrl, name: name })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const showPortalLink = isCSM ? !!logoUrl : true;
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const defaultLoginUrl = `/user/login?destination=${(0, $Y85G3.getHelpCenterUrl)().replace(/\//g, '')}`;
    const authenticatedNavLinks = $4fqPo.useMemo(()=>/*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, (0, $bG6ob.isVirtualAgentHeaderButtonEnabled)() && !isCSM && /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'virtualAgentHeaderButton'
        }, /*#__PURE__*/ $4fqPo.createElement($4fqPo.Suspense, {
            fallback: null
        }, /*#__PURE__*/ $4fqPo.createElement((0, $7i0Yg.default), {
            portalId: portalId ?? ''
        })))), /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavItem, null, /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
            packageName: 'viewLayoutHeaderDumb',
            id: 'customizeMenu'
        }, /*#__PURE__*/ $4fqPo.createElement((0, $3qvcg.default), {
            disableCustomiseMenu: disableAllHeaderLinks
        }))), isCSM && /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavItem, {
            role: "listitem"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
            packageName: "viewLayoutHeaderDumb",
            id: "CsmRequestsHeaderLink"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
            xcss: $b9ba80d47582d68f$var$requestsLinkStyles
        }, /*#__PURE__*/ $4fqPo.createElement((0, $5k5F5.CsmRequestsHeaderLink), null)))), /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavItem, null, /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: 'navbarAvatar'
            }
        }, /*#__PURE__*/ $4fqPo.createElement((0, $gsFvz.default), {
            disableAvatarMenu: disableAllHeaderLinks
        })))), [
        disableAllHeaderLinks,
        isCSM,
        portalId
    ]);
    const unauthenticatedNavLinks = /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavItem, {
        role: "listitem"
    }, /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$export$7d5b37ae6eb004e5, null, /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$LoginButton, {
        href: loginUrl ? loginUrl : defaultLoginUrl,
        actionSubjectId: "navbarLogin"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $K1VQU.default).login))));
    const anonymousAccessNotEnbledAndUserNotLoggedIn = !(!!anonymousEnabled || !!userLoggedIn);
    let portalLinkUrl;
    let portalLinkAriaLabel;
    if (isAnonymous || anonymousAccessNotEnbledAndUserNotLoggedIn) {
        portalLinkUrl = defaultLoginUrl;
        portalLinkAriaLabel = formatMessage((0, $K1VQU.default).helpCenter);
    } else {
        portalLinkUrl = (0, $Y85G3.getHelpCenterUrl)();
        portalLinkAriaLabel = name ? name : formatMessage((0, $K1VQU.default).helpCenter);
    }
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            source: 'navbar'
        }
    }, /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$Root, {
        showThemedBackground: Boolean(showThemedBackground),
        headerBackgroundColor: headerBackgroundColor
    }, showPortalLink && /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$PortalLink, {
        to: portalLinkUrl,
        logoTextColor: logoTextColor,
        actionSubjectId: "navbarHelpCenter",
        disabled: Boolean(disableAllHeaderLinks),
        tabIndex: disableAllHeaderLinks ? -1 : undefined,
        "aria-label": portalLinkAriaLabel
    }, /*#__PURE__*/ $4fqPo.createElement($4fqPo.Suspense, {
        fallback: /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
            name: "header-dumb-logo-fallback"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $5yLXq.default), {
            appearance: "square",
            size: "medium"
        }))
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1PnsK.LogoMemoizedHOC), null))), /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$Nav, null, /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavList, {
        role: "list"
    }, isUserLoaded && /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, hideSearchButton || /*#__PURE__*/ $4fqPo.createElement($b9ba80d47582d68f$var$NavItem, {
        role: "listitem"
    }, (0, $3H4LK.fg)('helpcenter_search_api_changes') ? /*#__PURE__*/ $4fqPo.createElement((0, $eOmbo.default), {
        trigger: "icon",
        disableSearch: disableAllHeaderLinks
    }) : /*#__PURE__*/ $4fqPo.createElement((0, $b5eoO.default), {
        trigger: "icon",
        disableSearch: disableAllHeaderLinks
    })), userLoggedIn ? authenticatedNavLinks : unauthenticatedNavLinks)))));
};
var $b9ba80d47582d68f$export$2e2bcd8739ae039 = $b9ba80d47582d68f$var$Header;
const $b9ba80d47582d68f$var$rootStyles = null;
const $b9ba80d47582d68f$var$refreshRootStyles = null;
const $b9ba80d47582d68f$var$RootCompiled = (props)=>{
    let backgroundColor;
    if (props.headerBackgroundColor) backgroundColor = props.headerBackgroundColor;
    else backgroundColor = props.showThemedBackground ? props.themeColor : '';
    return /*#__PURE__*/ $4fqPo.createElement("header", {
        style: {
            backgroundColor: backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            height: `${(0, $5Kpwp.HEADER_HEIGHT)}px`
        },
        className: (0, $ltgDR.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bah1yb4 _4cvr1h6o _u5f3u2gc _19bvu2gc",
            (0, $bG6ob.isUseHelpCenterRefresh)() && "_19bvpxbi"
        ])
    }, props.children);
};
const $b9ba80d47582d68f$var$RootCompiledConnected = (0, $bmgw6.default)((state)=>{
    return {
        themeColor: (0, $i8gmD.getThemeColor)(state)
    };
})($b9ba80d47582d68f$var$RootCompiled);
// Nav line height set to 0 so it is correctly vertically aligned.
const $b9ba80d47582d68f$var$NAV_LINE_HEIGHT = 0;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9ba80d47582d68f$var$RootStyled = /*#__PURE__*/ (0, $el3DQ.default).header.withConfig({
    componentId: "sc-l83nge-0"
})`display:flex;justify-content:space-between;align-items:center;${()=>{
    if ((0, $bG6ob.isUseHelpCenterRefresh)()) return `
                padding-left: ${"var(--ds-space-200, 16px)"};
            `;
    return `
            padding-left: ${"var(--ds-space-100, 8px)"};
            `;
}} padding-right:${"var(--ds-space-100, 8px)"};height:${(0, $5Kpwp.HEADER_HEIGHT)}px;overflow:hidden;${(props)=>{
    if (props.headerBackgroundColor) return props.headerBackgroundColor ? `background-color: ${props.headerBackgroundColor}` : '';
    return props.showThemedBackground ? `background-color: ${props.theme.color}` : '';
}}`;
const $b9ba80d47582d68f$var$Root = (0, $5Z4uE.componentWithCondition)($b9ba80d47582d68f$var$isCompiledCssEnabled, $b9ba80d47582d68f$var$RootCompiledConnected, $b9ba80d47582d68f$var$RootStyled);
const $b9ba80d47582d68f$var$navStyles = null;
const $b9ba80d47582d68f$var$NavCompiled = (props)=>/*#__PURE__*/ $4fqPo.createElement("nav", {
        className: (0, $ltgDR.default)([
            "_vwz4idpf _18u01wug"
        ])
    }, props.children);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve,rulesdir/styled-component-order
const $b9ba80d47582d68f$var$NavStyled = /*#__PURE__*/ (0, $el3DQ.default).nav.withConfig({
    componentId: "sc-l83nge-1"
})`line-height:${$b9ba80d47582d68f$var$NAV_LINE_HEIGHT};margin-left:auto;`;
const $b9ba80d47582d68f$var$Nav = (0, $5Z4uE.componentWithCondition)($b9ba80d47582d68f$var$isCompiledCssEnabled, $b9ba80d47582d68f$var$NavCompiled, $b9ba80d47582d68f$var$NavStyled);
const $b9ba80d47582d68f$var$navListStyles = null;
const $b9ba80d47582d68f$var$NavListCompiled = (props)=>/*#__PURE__*/ $4fqPo.createElement("div", {
        role: props.role,
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o"
        ])
    }, props.children);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9ba80d47582d68f$var$NavListStyled = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-l83nge-2"
})`margin:0;padding:0;display:flex;align-items:center;`;
const $b9ba80d47582d68f$var$NavList = (0, $5Z4uE.componentWithCondition)($b9ba80d47582d68f$var$isCompiledCssEnabled, $b9ba80d47582d68f$var$NavListCompiled, $b9ba80d47582d68f$var$NavListStyled);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9ba80d47582d68f$var$NavItem = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-l83nge-3"
})`display:inline;margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, rulesdir/styled-component-order -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9ba80d47582d68f$var$LoginButton = /*#__PURE__*/ (0, $el3DQ.default)((props)=>/*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.Button), props)).withConfig({
    componentId: "sc-l83nge-4"
})`&&{padding-left:${"var(--ds-space-150, 12px)"};padding-right:${"var(--ds-space-150, 12px)"};}`;
const $b9ba80d47582d68f$export$7d5b37ae6eb004e5 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-l83nge-5"
})`${$iSWaE.subtleThemeColorBackground};border:${"var(--ds-border-width-selected, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"} solid;border-radius:${$bpWyP.multiple(2).px};margin-left:${"var(--ds-space-100, 8px)"};`;
const $b9ba80d47582d68f$var$PortalLinkCompiled = (props)=>{
    const { logoTextColor: logoTextColor, disabled: disabled, themeColor: themeColor, titleColor: titleColor, children: children, ...linkProps } = props;
    return /*#__PURE__*/ $4fqPo.createElement((0, $1P8FK.Link), {
        to: linkProps.to,
        actionSubjectId: linkProps.actionSubjectId,
        tabIndex: linkProps.tabIndex,
        "aria-label": linkProps['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: 'cv-exclude-from-customisation',
        style: {
            pointerEvents: disabled ? 'none' : 'auto',
            color: logoTextColor === 'banner' ? titleColor : `var(--ds-link, ${themeColor})`
        },
        // @ts-ignore
        disabled: disabled
    }, children);
};
const $b9ba80d47582d68f$var$PortalLinkCompiledConnected = (0, $bmgw6.default)((state)=>({
        themeColor: (0, $i8gmD.getThemeColor)(state),
        titleColor: (0, $i8gmD.getHelpCenterTitleColor)(state)
    }))($b9ba80d47582d68f$var$PortalLinkCompiled);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b9ba80d47582d68f$var$PortalLinkStyled = /*#__PURE__*/ (0, $el3DQ.default)(({ logoTextColor: logoTextColor, ...props })=>// eslint-disable-next-line @atlassian/a11y/anchor-has-content -- Disabling existing violation, should be fixed when revisited.
    /*#__PURE__*/ $4fqPo.createElement((0, $1P8FK.Link), props)).attrs({
    className: 'cv-exclude-from-customisation'
}).withConfig({
    componentId: "sc-l83nge-6"
})`color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>props.logoTextColor === 'banner' ? props.theme.titleColor : `var(--ds-link, ${props.theme.color})`};}pointer-events:${(props)=>props.disabled ? 'none' : 'auto'};`;
const $b9ba80d47582d68f$var$PortalLink = (0, $5Z4uE.componentWithCondition)($b9ba80d47582d68f$var$isCompiledCssEnabled, $b9ba80d47582d68f$var$PortalLinkCompiledConnected, $b9ba80d47582d68f$var$PortalLinkStyled);
const $b9ba80d47582d68f$var$requestsLinkStyles = (0, $2m8U6.xcss)({
    marginInlineEnd: 'space.075'
});

});
parcelRegister("6EL7C", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => (parcelRequire("1PnsK")).LogoMemoizedHOC);

var $1PnsK = parcelRequire("1PnsK");

});
parcelRegister("1PnsK", function(module, exports) {
$parcel$export(module.exports, "LogoMemoizedHOC", () => $2d3615dce11d1918$export$299f731b9b12cd90);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $9SwPi = parcelRequire("9SwPi");
const $2d3615dce11d1918$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getLogoUrl), (0, $i8gmD.getSharedPortalName), (0, $i8gmD.getHelpCenterTopBarTextColor), (0, $i8gmD.getHelpCenterTopBarSplitFlag), (url, name, topBarTextColor, hasTopBarBeenSplit)=>({
        url: url,
        name: name,
        topBarTextColor: hasTopBarBeenSplit ? topBarTextColor : undefined
    }));
const $2d3615dce11d1918$export$299f731b9b12cd90 = (0, $bmgw6.default)($2d3615dce11d1918$var$selector)((0, $9SwPi.LogoMemoized));
var $2d3615dce11d1918$export$2e2bcd8739ae039 = (0, $bmgw6.default)($2d3615dce11d1918$var$selector)((0, $9SwPi.Logo));

});
parcelRegister("9SwPi", function(module, exports) {
$parcel$export(module.exports, "Logo", () => $c7c3a1f947fa958a$export$e6ff31bff12b7ff4);
$parcel$export(module.exports, "LogoMemoized", () => $c7c3a1f947fa958a$export$acb5f09fe495ae97);

var $bqQ71 = parcelRequire("bqQ71");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $ie39Q = parcelRequire("ie39Q");

var $gIeP2 = parcelRequire("gIeP2");

var $6bGmX = parcelRequire("6bGmX");

var $cijxS = parcelRequire("cijxS");

var $eSL4S = parcelRequire("eSL4S");

var $8aBg0 = parcelRequire("8aBg0");
parcelRequire("11oYs");
var $eLDyS = parcelRequire("eLDyS");
const $c7c3a1f947fa958a$export$e6ff31bff12b7ff4 = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    var _helpCenter$helpCente, _helpCenter$helpCente2;
    const isFetchingData = (0, $bG6ob.isCustomThemingEnabled)();
    const [defaultLogoUrl] = $4fqPo.useState(url);
    const [stateUrl, setStateUrl] = $4fqPo.useState('');
    const [shouldHoldUFO, setShouldHoldUFO] = $4fqPo.useState(true);
    const { helpCenter: helpCenter } = (0, $gIeP2.useLazyLoadQuery)((0, $bqQ71.default), {
        cloudId: (0, $6mmHn.getCloudId)(),
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
        skip: !isFetchingData
    });
    const advancedName = (helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente = helpCenter.helpCenterById) === null || _helpCenter$helpCente === void 0 || (_helpCenter$helpCente = _helpCenter$helpCente.name) === null || _helpCenter$helpCente === void 0 ? void 0 : _helpCenter$helpCente.default) || name;
    const advancedUrl = helpCenter === null || helpCenter === void 0 || (_helpCenter$helpCente2 = helpCenter.helpCenterById) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.helpCenterBranding) === null || _helpCenter$helpCente2 === void 0 || (_helpCenter$helpCente2 = _helpCenter$helpCente2.logo) === null || _helpCenter$helpCente2 === void 0 ? void 0 : _helpCenter$helpCente2.url;
    $4fqPo.useEffect(()=>{
        if (!isFetchingData && url && !url.startsWith('blob:')) (0, $8aBg0.getObjectURLFromMediaURLWithCaching)(url).then(setStateUrl).catch(()=>setStateUrl('')).finally(()=>setShouldHoldUFO(false));
        else {
            setStateUrl(url || '');
            setShouldHoldUFO(false);
        }
    }, [
        url,
        isFetchingData
    ]);
    const isHelpCentersManagementPage = (0, $eSL4S.isHelpCentersManagement)();
    const getUrl = $4fqPo.useCallback(()=>{
        if (isFetchingData) return advancedUrl;
        if (isHelpCentersManagementPage) return 0, (/*@__PURE__*/$parcel$interopDefault($ie39Q));
        return stateUrl;
    }, [
        advancedUrl,
        isFetchingData,
        isHelpCentersManagementPage,
        stateUrl
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, shouldHoldUFO && /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
        name: "help-center-common-logo"
    }), (0, $6bGmX.default).checkGate('jsm_help_center_branding_image_improvement') && defaultLogoUrl && /*#__PURE__*/ $4fqPo.createElement("link", {
        rel: "preload",
        as: "fetch",
        href: defaultLogoUrl,
        crossOrigin: "anonymous"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $eLDyS.default), {
        url: getUrl(),
        name: advancedName,
        topBarTextColor: topBarTextColor
    }));
};
const $c7c3a1f947fa958a$export$acb5f09fe495ae97 = /*#__PURE__*/ $4fqPo.memo($c7c3a1f947fa958a$export$e6ff31bff12b7ff4);

});
parcelRegister("bqQ71", function(module, exports) {
$parcel$export(module.exports, "default", () => $379df0a6ff771dbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c8437f71d8ffa7c62d1c0fe41e32f02>>
 * @relayHash 89b5ac4560edc5779e88acaa2f693808
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360
const $379df0a6ff771dbc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "default"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "url"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "logoQuery",
            "selections": [
                {
                    "condition": "skip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4d0682ac128b1814b5e2ef5bed041589a8703b625dc2193d4eaf2b90ded3e360",
            "metadata": {},
            "name": "logoQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$379df0a6ff771dbc$var$node.hash = "50f3d8eb5808e1ee69db4f8e639d0b3e";
var $379df0a6ff771dbc$export$2e2bcd8739ae039 = $379df0a6ff771dbc$var$node;

});

parcelRegister("ie39Q", function(module, exports) {
module.exports = new URL("../images/atlassian-icon.632e3804.png", import.meta.url).toString();

});

parcelRegister("11oYs", function(module, exports) {
$parcel$export(module.exports, "LogoStateless", () => (parcelRequire("eLDyS")).default);

var $eLDyS = parcelRequire("eLDyS");

});
parcelRegister("eLDyS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b24c4690acde6d18$export$2e2bcd8739ae039);
/* logo-stateless.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bpWyP = parcelRequire("bpWyP");

var $6bGmX = parcelRequire("6bGmX");
const $b24c4690acde6d18$var$isCompiledCssEnabled = ()=>(0, $6bGmX.default).checkGate('help_center_login_compiled_css');
const $b24c4690acde6d18$var$LogoStateless = ({ url: url, name: name, topBarTextColor: topBarTextColor })=>{
    if ($b24c4690acde6d18$var$isCompiledCssEnabled()) {
        const compiledContent = url ? /*#__PURE__*/ $4fqPo.createElement("img", {
            src: url,
            alt: name,
            style: {
                height: `${$b24c4690acde6d18$var$imageHeight}px`
            }
        }) : /*#__PURE__*/ $4fqPo.createElement("span", null, name);
        return /*#__PURE__*/ $4fqPo.createElement("div", {
            style: {
                height: `${$b24c4690acde6d18$var$imageHeight}px`,
                color: topBarTextColor || 'inherit'
            },
            className: (0, $ltgDR.default)([
                "_1e0c116y _4cvr1h6o _1bah1h6o _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _k48p1pd9"
            ])
        }, compiledContent);
    }
    const content = url ? /*#__PURE__*/ $4fqPo.createElement($b24c4690acde6d18$var$ImageStyled, {
        src: url,
        alt: name
    }) : /*#__PURE__*/ $4fqPo.createElement("span", null, name);
    return /*#__PURE__*/ $4fqPo.createElement($b24c4690acde6d18$var$RootStyled, {
        topBarTextColor: topBarTextColor
    }, content);
};
var $b24c4690acde6d18$export$2e2bcd8739ae039 = $b24c4690acde6d18$var$LogoStateless;
const $b24c4690acde6d18$var$imageHeight = $bpWyP.unitless * 5;
// Compiled CSS styles
const $b24c4690acde6d18$var$rootCompiledStyles = null;
// Styled-components version (legacy)
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b24c4690acde6d18$var$RootStyled = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-prcwi5-0"
})`height:${$b24c4690acde6d18$var$imageHeight}px;display:inline-flex;align-items:center;justify-content:center;padding:${"var(--ds-space-075, 6px)"};font-weight:600;color:${(props)=>props.topBarTextColor || 'inherit'};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b24c4690acde6d18$var$ImageStyled = /*#__PURE__*/ (0, $el3DQ.default).img.withConfig({
    componentId: "sc-prcwi5-1"
})`height:${$b24c4690acde6d18$var$imageHeight}px;`;

});





parcelRegister("dO3UT", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("b5eoO")).default);

var $b5eoO = parcelRequire("b5eoO");

});
parcelRegister("b5eoO", function(module, exports) {
$parcel$export(module.exports, "default", () => $07b40f9b89af5e19$export$2e2bcd8739ae039);

var $kFddt = parcelRequire("kFddt");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $3Zmh8 = parcelRequire("3Zmh8");

var $ibOOf = parcelRequire("ibOOf");

var $5eCdR = parcelRequire("5eCdR");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("dMwUq");
var $gi2k1 = parcelRequire("gi2k1");
parcelRequire("gNfyY");
var $5lxa8 = parcelRequire("5lxa8");
parcelRequire("fk79P");
var $GAyRP = parcelRequire("GAyRP");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $bqq79 = parcelRequire("bqq79");

var $fZppw = parcelRequire("fZppw");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("5Sfyk");
var $2bRRM = parcelRequire("2bRRM");
parcelRequire("2Y6oN");
var $4JXuf = parcelRequire("4JXuf");
parcelRequire("3yiCA");
var $lOAAh = parcelRequire("lOAAh");
parcelRequire("djmoH");
var $8kRBt = parcelRequire("8kRBt");
const $07b40f9b89af5e19$export$4b85d3515bd863a5 = ({ term: term, trigger: trigger, isOpen: isOpen, onSearch: onSearch, onClose: onClose, onOpen: onOpen, resetSearch: resetSearch, fetchHelpCenter: fetchHelpCenter, fetchPortals: fetchPortals, disableSearch: disableSearch, isVSAOnHCEnabled: isVSAOnHCEnabled })=>{
    const searchButtonRef = (0, $4fqPo.useRef)(null);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $4azHH.isSinglePortalSearch)(portalId)) fetchPortals({
            id: (0, $4azHH.getPortalIdAsNumber)(portalId),
            expand: [
                'kbs',
                'reqTypes',
                'reqGroups',
                'orderMapping'
            ]
        });
    }, [
        portalId,
        fetchHelpCenter,
        fetchPortals
    ]);
    const onReturnFocus = (0, $4fqPo.useCallback)((_)=>{
        //FocusLock trap is still active due to that we deffer setting focus with zero-timeout
        setTimeout(()=>{
            var _searchButtonRef$curr;
            searchButtonRef === null || searchButtonRef === void 0 || (_searchButtonRef$curr = searchButtonRef.current) === null || _searchButtonRef$curr === void 0 || _searchButtonRef$curr.focus();
        }, 0);
        return true;
    }, []);
    (0, $4fqPo.useEffect)(()=>()=>{
            resetSearch();
        }, [
        resetSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lOAAh.default), {
        isOpen: isOpen,
        term: term,
        portalId: portalId,
        onSearch: onSearch,
        onClose: onClose,
        onReturnFocus: onReturnFocus,
        isVSAOnHCEnabled: isVSAOnHCEnabled
    }), trigger === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $GAyRP.default), {
        ref: searchButtonRef,
        shown: isOpen,
        onClick: onOpen,
        disableSearch: disableSearch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bRRM.InlineResultsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8kRBt.default), {
        term: term,
        disableSearch: disableSearch,
        isVSAOnHCEnabled: !!isVSAOnHCEnabled
    }))));
};
const $07b40f9b89af5e19$var$SearchWithVirtualAgentAvailability = (props)=>{
    var _data$helpCenter, _data$helpCenter2, _data$virtualAgent;
    const { queryReference: queryReference, ...rest } = props;
    const data = (0, $gIeP2.usePreloadedQuery)((0, $kFddt.default), props.queryReference);
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($07b40f9b89af5e19$export$4b85d3515bd863a5, rest);
    const isVirtualAgentEnabled = ((_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.virtualAgentEnabled) ?? false;
    const isVirtualAgentAvailable = (0, $bG6ob.isVAOnHelpCenterGAEnabled)() ? ((_data$virtualAgent = data.virtualAgent) === null || _data$virtualAgent === void 0 ? void 0 : _data$virtualAgent.virtualAgentAvailability) ?? false : true;
    const isVSAOnHCEnabled = isVirtualAgentEnabled && isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($07b40f9b89af5e19$export$4b85d3515bd863a5, {
        isVSAOnHCEnabled: isVSAOnHCEnabled,
        ...rest
    });
};
const $07b40f9b89af5e19$export$ab176425b2a52b00 = (props)=>{
    const { queryReference: queryReference } = (0, $fZppw.useRelayResource)((0, $3Zmh8.searchComponentVirtualAgentResource));
    const renderError = (0, $4fqPo.useCallback)(()=>{
        // We fallback to non-VSA search if there is an error occurs in this loader, All the other errors should be handled by the SearchErrorBoundary default renderError
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4JXuf.default), {
            id: "help-center-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($07b40f9b89af5e19$export$4b85d3515bd863a5, props));
    }, [
        props
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4JXuf.default), {
        id: "help-center-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($07b40f9b89af5e19$export$4b85d3515bd863a5, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4JXuf.default), {
        id: "help-center-search",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($07b40f9b89af5e19$export$4b85d3515bd863a5, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($07b40f9b89af5e19$var$SearchWithVirtualAgentAvailability, {
        queryReference: queryReference,
        ...props
    })));
};
const $07b40f9b89af5e19$var$selector = (0, $3yyCx.createSelector)((0, $5lxa8.getShown), (0, $5lxa8.getTerm), (shown, term)=>({
        term: term,
        isOpen: shown
    }));
const $07b40f9b89af5e19$var$ConnectedSearch = (0, $bmgw6.default)($07b40f9b89af5e19$var$selector, {
    onOpen: ()=>(0, $gi2k1.showSearch)(true),
    onClose: ()=>(0, $gi2k1.showSearch)(false),
    onSearch: (term)=>(0, $gi2k1.updateSearch)(term, {}),
    resetSearch: (0, $gi2k1.resetSearch),
    fetchPortals: (0, $lXazD.fetchPortalAction),
    fetchHelpCenter: (0, $5eCdR.fetchHelpCenterAction)
})((0, $bqq79.PortalAnalyticsModal)((0, $748yq.ScreenName).HELP_CENTER_SEARCH)(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
(0, $ibOOf.default)((0, $apbG6.default)({
    component: (0, $748yq.ScreenName).HELP_CENTER_SEARCH
})((0, $as4kh.default)()($07b40f9b89af5e19$export$ab176425b2a52b00)))));
var $07b40f9b89af5e19$export$2e2bcd8739ae039 = $07b40f9b89af5e19$var$ConnectedSearch;

});
parcelRegister("ibOOf", function(module, exports) {
$parcel$export(module.exports, "PathParamsProvider", () => $d5b9addeb2ec00ed$export$ebcbd875f0707321);
$parcel$export(module.exports, "withPathParamProvider", () => $d5b9addeb2ec00ed$export$e8aa4f1b1a2e784c);
$parcel$export(module.exports, "default", () => $d5b9addeb2ec00ed$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
const $d5b9addeb2ec00ed$var$RouteParamContext = /*#__PURE__*/ $4fqPo.createContext({});
const $d5b9addeb2ec00ed$export$ebcbd875f0707321 = (props)=>/*#__PURE__*/ $4fqPo.createElement($d5b9addeb2ec00ed$var$RouteParamContext.Provider, {
        value: props.params
    }, props.children);
const $d5b9addeb2ec00ed$var$withPathParams = (WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props)=>/*#__PURE__*/ $4fqPo.createElement($d5b9addeb2ec00ed$var$RouteParamContext.Consumer, null, (value)=>/*#__PURE__*/ $4fqPo.createElement(WrappedComponent, {
                ...props,
                ...value
            }));
const $d5b9addeb2ec00ed$export$e8aa4f1b1a2e784c = (Component)=>{
    // eslint-disable-next-line react/display-name
    return (props)=>{
        const [{ match: match }] = (0, $hfD9S.useRouter)();
        return /*#__PURE__*/ $4fqPo.createElement($d5b9addeb2ec00ed$export$ebcbd875f0707321, {
            params: match.params
        }, /*#__PURE__*/ $4fqPo.createElement(Component, props));
    };
};
var $d5b9addeb2ec00ed$export$2e2bcd8739ae039 = $d5b9addeb2ec00ed$var$withPathParams;

});

parcelRegister("fk79P", function(module, exports) {
$parcel$export(module.exports, "SearchButton", () => (parcelRequire("GAyRP")).default);

var $GAyRP = parcelRequire("GAyRP");

});
parcelRegister("GAyRP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab471af3872fb61c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $lszf6 = parcelRequire("lszf6");

var $8B6Ry = parcelRequire("8B6Ry");
const $ab471af3872fb61c$export$690bcf3a1f1e9f2f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(({ onClick: onClick, disableSearch: disableSearch }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($ab471af3872fb61c$var$StyledSearchIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        isDisabled: disableSearch,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        style: {
            borderRadius: '50%'
        },
        ref: ref,
        onClick: onClick,
        appearance: "subtle",
        shouldFitContainer: true,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
            spacing: "spacious",
            label: "Search",
            color: "var(--ds-icon, #42526E)"
        }),
        analyticsContext: {
            actionSubjectId: 'navbarSearch'
        }
    }));
});
$ab471af3872fb61c$export$690bcf3a1f1e9f2f.displayName = 'SearchButton';
var $ab471af3872fb61c$export$2e2bcd8739ae039 = $ab471af3872fb61c$export$690bcf3a1f1e9f2f;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ab471af3872fb61c$var$StyledSearchIconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-tktwuw-0"
})`display:flex;height:${"var(--ds-space-400, 32px)"};width:${"var(--ds-space-400, 32px)"};align-items:stretch;background-color:${"var(--ds-surface-overlay, #EBECF0)"};border-radius:50%;flex-direction:column;justify-content:center;transform:translateZ(0);transition:transform 200ms,opacity 200ms;box-shadow:${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-0, 0px)"} ${"var(--ds-space-025, 2px)"} ${"var(--ds-border-inverse, #FFFFFF)"};border:none;margin:${"var(--ds-space-150, 12px)"};padding:0;cursor:pointer;`;

});
parcelRegister("8B6Ry", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64271a3f860e9517$var$_react = $64271a3f860e9517$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $64271a3f860e9517$var$_baseNew = $64271a3f860e9517$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $64271a3f860e9517$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64271a3f860e9517$var$SearchIcon = (props)=>/*#__PURE__*/ $64271a3f860e9517$var$_react.default.createElement($64271a3f860e9517$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$64271a3f860e9517$var$SearchIcon.displayName = 'SearchIcon';
var $64271a3f860e9517$var$_default = module.exports.default = $64271a3f860e9517$var$SearchIcon;

});



parcelRegister("bqq79", function(module, exports) {
$parcel$export(module.exports, "PortalAnalyticsInlineDialog", () => $d0ac7a747518c968$export$4de18d88452d7a08);
$parcel$export(module.exports, "PortalAnalyticsModal", () => $d0ac7a747518c968$export$e80acabac337720d);
$parcel$export(module.exports, "PortalAnalyticsDrawer", () => $d0ac7a747518c968$export$3b1f159f4ab6aaae);

var $54jwS = parcelRequire("54jwS");

var $3OiWH = parcelRequire("3OiWH");
function $d0ac7a747518c968$var$screenWithoutBrowserMetrics(name, sourceType, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attributes) {
    const analyticsWrapper = (0, $54jwS.withAnalyticsContext)({
        sourceType: sourceType,
        sourceName: name,
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        attributes: {
            ...attributes,
            context: 'Portal'
        }
    });
    return (component)=>(0, $3OiWH.clearScreenName)(analyticsWrapper(component));
}
const $d0ac7a747518c968$export$4de18d88452d7a08 = (name, attributes)=>$d0ac7a747518c968$var$screenWithoutBrowserMetrics(name, (0, $54jwS.ScreenTypes).INLINE_DIALOG, attributes);
const $d0ac7a747518c968$export$e80acabac337720d = (name, attributes)=>$d0ac7a747518c968$var$screenWithoutBrowserMetrics(name, (0, $54jwS.ScreenTypes).MODAL, attributes);
const $d0ac7a747518c968$export$3b1f159f4ab6aaae = (name, attributes)=>$d0ac7a747518c968$var$screenWithoutBrowserMetrics(name, (0, $54jwS.ScreenTypes).DRAWER, attributes);

});

parcelRegister("2TV9p", function(module, exports) {
$parcel$export(module.exports, "ALL_RESULTS_COUNT", () => (parcelRequire("iD7Jo")).ALL_RESULTS_COUNT);
$parcel$export(module.exports, "DEFAULT_RESULTS_COUNT", () => (parcelRequire("iD7Jo")).DEFAULT_RESULTS_COUNT);
$parcel$export(module.exports, "INITIAL_ARTICLES_COUNT", () => (parcelRequire("iD7Jo")).INITIAL_ARTICLES_COUNT);
$parcel$export(module.exports, "INITIAL_PORTALS_COUNT", () => (parcelRequire("iD7Jo")).INITIAL_PORTALS_COUNT);
$parcel$export(module.exports, "INITIAL_REQUEST_FORMS_COUNT", () => (parcelRequire("iD7Jo")).INITIAL_REQUEST_FORMS_COUNT);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => (parcelRequire("iD7Jo")).SEARCH_QUERY_DEBOUNCE_TIME);
$parcel$export(module.exports, "SHOW_MORE_RESULTS_COUNT", () => (parcelRequire("iD7Jo")).SHOW_MORE_RESULTS_COUNT);
$parcel$export(module.exports, "DropdownOptionList", () => (parcelRequire("jEoO3")).DropdownOptionList);
$parcel$export(module.exports, "Img", () => (parcelRequire("jEoO3")).Img);
$parcel$export(module.exports, "InlineResultLink", () => (parcelRequire("jEoO3")).InlineResultLink);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => (parcelRequire("jEoO3")).InlineResultsHeadingWrapper);
$parcel$export(module.exports, "LinkContainer", () => (parcelRequire("jEoO3")).LinkContainer);
$parcel$export(module.exports, "ResultList", () => (parcelRequire("jEoO3")).ResultList);
$parcel$export(module.exports, "ResultTitle", () => (parcelRequire("jEoO3")).ResultTitle);
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => (parcelRequire("jEoO3")).SEARCH_BAR_HEIGHT);
$parcel$export(module.exports, "formatText", () => (parcelRequire("4azHH")).formatText);
$parcel$export(module.exports, "formatToCleanText", () => (parcelRequire("4azHH")).formatToCleanText);
$parcel$export(module.exports, "getIdsArray", () => (parcelRequire("4azHH")).getIdsArray);
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("4azHH")).getPortalIdAsNumber);
$parcel$export(module.exports, "isSinglePortalSearch", () => (parcelRequire("4azHH")).isSinglePortalSearch);
$parcel$export(module.exports, "isValidSearchTerm", () => (parcelRequire("4azHH")).isValidSearchTerm);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => (parcelRequire("4azHH")).sendSearchOperationalAnalyticEvents);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => (parcelRequire("4azHH")).sendSearchUIAnalyticEvents);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("4azHH")).useQueryParams);
$parcel$export(module.exports, "useVisibilityState", () => (parcelRequire("4azHH")).useVisibilityState);
parcelRequire("iD7Jo");
parcelRequire("jEoO3");
parcelRequire("4azHH");

});
parcelRegister("iD7Jo", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_RESULTS_COUNT", () => $4c91a82b6ef0f73d$export$f14c45907e18a763);
$parcel$export(module.exports, "INITIAL_ARTICLES_COUNT", () => $4c91a82b6ef0f73d$export$49754c91e8c4555b);
$parcel$export(module.exports, "INITIAL_REQUEST_FORMS_COUNT", () => $4c91a82b6ef0f73d$export$5c16d76778f8ba6d);
$parcel$export(module.exports, "INITIAL_PORTALS_COUNT", () => $4c91a82b6ef0f73d$export$de93546541b3e2e);
$parcel$export(module.exports, "SHOW_MORE_RESULTS_COUNT", () => $4c91a82b6ef0f73d$export$897393da5c49885d);
$parcel$export(module.exports, "ALL_RESULTS_COUNT", () => $4c91a82b6ef0f73d$export$7652aee25e1c7c1e);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => $4c91a82b6ef0f73d$export$95aa4d213e66754b);
const $4c91a82b6ef0f73d$export$f14c45907e18a763 = 31;
const $4c91a82b6ef0f73d$export$49754c91e8c4555b = 11;
const $4c91a82b6ef0f73d$export$5c16d76778f8ba6d = 5;
const $4c91a82b6ef0f73d$export$de93546541b3e2e = 3;
const $4c91a82b6ef0f73d$export$897393da5c49885d = 30;
const $4c91a82b6ef0f73d$export$7652aee25e1c7c1e = 30;
const $4c91a82b6ef0f73d$export$95aa4d213e66754b = 300;

});

parcelRegister("jEoO3", function(module, exports) {
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => $40447691d8c5e21e$export$9ac4f4162406e081);
$parcel$export(module.exports, "LinkContainer", () => $40447691d8c5e21e$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "ResultTitle", () => $40447691d8c5e21e$export$d971b98a124cabfc);
$parcel$export(module.exports, "ResultList", () => $40447691d8c5e21e$export$7ebf7682ef098fb8);
$parcel$export(module.exports, "Img", () => $40447691d8c5e21e$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => $40447691d8c5e21e$export$a8317adc66cb9be6);
$parcel$export(module.exports, "InlineResultLink", () => $40447691d8c5e21e$export$5a34ff55d4e5e484);
$parcel$export(module.exports, "DropdownOptionList", () => $40447691d8c5e21e$export$b5e293376cc6b1ce);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $el3DQ = parcelRequire("el3DQ");

var $1P8FK = parcelRequire("1P8FK");

var $iSWaE = parcelRequire("iSWaE");
const $40447691d8c5e21e$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $40447691d8c5e21e$export$f99233281efd08a0 = /*#__PURE__*/ (0, $el3DQ.default).h3.withConfig({
    componentId: "sc-19gahx3-0"
})`${$iSWaE.clamp};margin:0;font-weight:normal;font-size:${"var(--ds-space-200, 16px)"};`;
const $40447691d8c5e21e$export$10c56fa12fda26f9 = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-19gahx3-1"
})`color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-100, 8px)"};padding-right:${"var(--ds-space-200, 16px)"};${$iSWaE.multiLineClamp(3, 20)};`;
const $40447691d8c5e21e$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $el3DQ.default)((0, $1P8FK.Link)).withConfig({
    componentId: "sc-19gahx3-2"
})`display:flex;border-radius:${"var(--ds-radius-small, 3px)"};${$iSWaE.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};padding:${"var(--ds-space-200, 16px)"};margin:${"var(--ds-space-100, 8px)"} 0 0;&:hover,&:focus{background:${"var(--ds-surface-raised, #FFFFFF)"};text-decoration:none;}&:hover h3,&:focus h3{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
const $40447691d8c5e21e$export$d971b98a124cabfc = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_ca0qpxbi _19pkze3t _1p1dangw _1wybutpp _k48p8n31 _syaz117m",
            __cmplp.className
        ])
    });
});
const $40447691d8c5e21e$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $40447691d8c5e21e$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $40447691d8c5e21e$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $40447691d8c5e21e$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1P8FK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $40447691d8c5e21e$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4azHH", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $05352fa0a886d3c6$export$905fe28a7c283e1d);
$parcel$export(module.exports, "formatToCleanText", () => $05352fa0a886d3c6$export$519cc8c1640d01b8);
$parcel$export(module.exports, "useQueryParams", () => $05352fa0a886d3c6$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "isSinglePortalSearch", () => $05352fa0a886d3c6$export$3bdd4cf348080703);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $05352fa0a886d3c6$export$c36431be801010b);
$parcel$export(module.exports, "isValidSearchTerm", () => $05352fa0a886d3c6$export$34d09b0baed7315d);
$parcel$export(module.exports, "getIdsArray", () => $05352fa0a886d3c6$export$b78190df63b1b0c4);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => $05352fa0a886d3c6$export$c8b38685f22f1bb2);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => $05352fa0a886d3c6$export$653243929c3168a8);
$parcel$export(module.exports, "useVisibilityState", () => $05352fa0a886d3c6$export$54299a3c81f5425);

var $4fqPo = parcelRequire("4fqPo");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $3lnPx = parcelRequire("3lnPx");

var $hH1ci = parcelRequire("hH1ci");

var $jJnx5 = parcelRequire("jJnx5");

var $c5Ksk = parcelRequire("c5Ksk");

var $4i2V5 = parcelRequire("4i2V5");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
const $05352fa0a886d3c6$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $05352fa0a886d3c6$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $05352fa0a886d3c6$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $c5Ksk.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $05352fa0a886d3c6$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $c5Ksk.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $05352fa0a886d3c6$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $hfD9S.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $4fqPo.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($4i2V5))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $4fqPo.useMemo)(()=>$05352fa0a886d3c6$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $4fqPo.useMemo)(()=>$05352fa0a886d3c6$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $05352fa0a886d3c6$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $05352fa0a886d3c6$export$c36431be801010b(portalId) !== 0;
const $05352fa0a886d3c6$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $05352fa0a886d3c6$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jJnx5)))(portalId);
};
const $05352fa0a886d3c6$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3lnPx)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($hH1ci)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($3Tp9Q)))(ids) ? ids : [];
    }
    return [];
};
const $05352fa0a886d3c6$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $05352fa0a886d3c6$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $05352fa0a886d3c6$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $4fqPo.useState)(false);
    const [isFocused, setIsFocused] = (0, $4fqPo.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $4fqPo.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});
parcelRegister("3lnPx", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $26f5d17566af4d8e$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $26f5d17566af4d8e$var$isNumber(value) {
    return typeof value == 'number' || $5eSIk(value) && $AxfGO(value) == $26f5d17566af4d8e$var$numberTag;
}
module.exports = $26f5d17566af4d8e$var$isNumber;

});

parcelRegister("hH1ci", function(module, exports) {

var $AxfGO = parcelRequire("AxfGO");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $ce17619519413cce$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $ce17619519413cce$var$isString(value) {
    return typeof value == 'string' || !$3Tp9Q(value) && $5eSIk(value) && $AxfGO(value) == $ce17619519413cce$var$stringTag;
}
module.exports = $ce17619519413cce$var$isString;

});

parcelRegister("jJnx5", function(module, exports) {

var $b6rPU = parcelRequire("b6rPU");

var $lmC5W = parcelRequire("lmC5W");
/** Used as references for various `Number` constants. */ var $e5d4795e1a713188$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Converts `value` to a safe integer. A safe integer can be compared and
 * represented correctly.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toSafeInteger(3.2);
 * // => 3
 *
 * _.toSafeInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toSafeInteger(Infinity);
 * // => 9007199254740991
 *
 * _.toSafeInteger('3.2');
 * // => 3
 */ function $e5d4795e1a713188$var$toSafeInteger(value) {
    return value ? $b6rPU($lmC5W(value), -$e5d4795e1a713188$var$MAX_SAFE_INTEGER, $e5d4795e1a713188$var$MAX_SAFE_INTEGER) : value === 0 ? value : 0;
}
module.exports = $e5d4795e1a713188$var$toSafeInteger;

});
parcelRegister("b6rPU", function(module, exports) {
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */ function $8155d8effdfe9a14$var$baseClamp(number, lower, upper) {
    if (number === number) {
        if (upper !== undefined) number = number <= upper ? number : upper;
        if (lower !== undefined) number = number >= lower ? number : lower;
    }
    return number;
}
module.exports = $8155d8effdfe9a14$var$baseClamp;

});


parcelRegister("c5Ksk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b917258a6fa22344$export$2e2bcd8739ae039);

var $63sfu = parcelRequire("63sfu");
function $b917258a6fa22344$export$2e2bcd8739ae039(textHtml, keyword) {
    const escapedTextHtml = (0, $63sfu.escape)(textHtml);
    if (keyword) {
        const dynamicRegex = new RegExp(`([^_\\s,-]*)${(0, $63sfu.escapeRegExp)((0, $63sfu.escape)(keyword))}([^_\\s,-]*)`, 'gi');
        return escapedTextHtml.replace(dynamicRegex, (match)=>{
            return `<strong>${match}</strong>`;
        });
    }
    return escapedTextHtml;
}

});



parcelRegister("5Sfyk", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => (parcelRequire("2bRRM")).InlineResultsContextProvider);
$parcel$export(module.exports, "useInlineResultsContext", () => (parcelRequire("2bRRM")).useInlineResultsContext);

var $2bRRM = parcelRequire("2bRRM");

});
parcelRegister("2bRRM", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => $48792d8c8d8dbfc9$export$55d16b7f4336c4d7);
$parcel$export(module.exports, "useInlineResultsContext", () => $48792d8c8d8dbfc9$export$243a7c3fd4b96b3e);

var $4fqPo = parcelRequire("4fqPo");
const $48792d8c8d8dbfc9$var$InlineResultsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(null);
const $48792d8c8d8dbfc9$export$55d16b7f4336c4d7 = ({ children: children })=>{
    const [resultsCount, setResultsCount] = (0, $4fqPo.useState)(null);
    const updateSearchResultsCount = (0, $4fqPo.useCallback)((resourceType, resourceCount)=>setResultsCount((state)=>({
                ...state,
                [resourceType]: resourceCount
            })), [
        setResultsCount
    ]);
    const clearSearchResultsCount = (0, $4fqPo.useCallback)(()=>setResultsCount(null), [
        setResultsCount
    ]);
    const contextValue = (0, $4fqPo.useMemo)(()=>({
            resultsCount: resultsCount,
            clearSearchResultsCount: clearSearchResultsCount,
            updateSearchResultsCount: updateSearchResultsCount
        }), [
        resultsCount,
        clearSearchResultsCount,
        updateSearchResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($48792d8c8d8dbfc9$var$InlineResultsContext.Provider, {
        value: contextValue
    }, children);
};
const $48792d8c8d8dbfc9$export$243a7c3fd4b96b3e = ()=>{
    const context = (0, $4fqPo.useContext)($48792d8c8d8dbfc9$var$InlineResultsContext);
    if (!context) throw new Error('useInlineResultsContext must be used within InlineResultsContextProvider');
    return context;
};

});


parcelRegister("2Y6oN", function(module, exports) {
$parcel$export(module.exports, "SearchErrorBoundary", () => (parcelRequire("4JXuf")).default);

var $4JXuf = parcelRequire("4JXuf");

});
parcelRegister("4JXuf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b59f1a3ae7ff1dd2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gMSZD = parcelRequire("gMSZD");

var $63sfu = parcelRequire("63sfu");

var $eSL4S = parcelRequire("eSL4S");

var $3OiWH = parcelRequire("3OiWH");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");
parcelRequire("dwmhv");
var $kiMfc = parcelRequire("kiMfc");

var $2UiQO = parcelRequire("2UiQO");
const $b59f1a3ae7ff1dd2$var$SearchErrorBoundary = ({ screenName: screenName, id: id, children: children, renderError: renderError })=>{
    /**
   * If any error unrecoverable occurs inside search
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure using UFO
   */ const markExperienceFailed = (0, $4fqPo.useCallback)((error)=>{
        if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) {
            const metadata = {
                id: id,
                error: error === null || error === void 0 ? void 0 : error.message,
                failureEvent: screenName
            };
            (0, $2UiQO.searchExperience).failure({
                metadata: metadata
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
            if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) (0, $2UiQO.csmSearchExperience).failure({
                metadata: metadata
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
            (0, $2UiQO.inlineSearchExperience).failure({
                metadata: metadata
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
        }
    }, [
        id,
        screenName
    ]);
    const defaultRenderError = (0, $4fqPo.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kiMfc.default), null);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: screenName,
        id: id,
        renderError: renderError ? renderError : defaultRenderError,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(children));
};
var $b59f1a3ae7ff1dd2$export$2e2bcd8739ae039 = (0, $3OiWH.default)($b59f1a3ae7ff1dd2$var$SearchErrorBoundary);

});
parcelRegister("dwmhv", function(module, exports) {
$parcel$export(module.exports, "SearchResultError", () => (parcelRequire("kiMfc")).default);

var $kiMfc = parcelRequire("kiMfc");

});
parcelRegister("kiMfc", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8fd0b22dbcf3eaa$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $8Gf3q = parcelRequire("8Gf3q");

var $6MV1v = parcelRequire("6MV1v");

var $dQegt = parcelRequire("dQegt");

var $2eKV2 = parcelRequire("2eKV2");

var $4hIeL = parcelRequire("4hIeL");

var $Y85G3 = parcelRequire("Y85G3");
parcelRequire("2TV9p");
var $jEoO3 = parcelRequire("jEoO3");

var $1Fl9h = parcelRequire("1Fl9h");
const $d8fd0b22dbcf3eaa$var$SearchResultError = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6MV1v)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xsmall"
    }, formatMessage((0, $1Fl9h.default).searchErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("p", {
        style: {
            textAlign: 'center'
        }
    }, formatMessage((0, $1Fl9h.default).searchErrorText, {
        helpCenterLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Gf3q.default), {
            to: (0, $Y85G3.getHelpCenterUrl)(),
            actionSubjectId: "helpCenterLink"
        }, formatMessage((0, $1Fl9h.default).helpCenter))
    })));
};
var $d8fd0b22dbcf3eaa$export$2e2bcd8739ae039 = $d8fd0b22dbcf3eaa$var$SearchResultError;

});
parcelRegister("6MV1v", function(module, exports) {
module.exports = new URL("../images/search-modal-error.b0f67bec.svg", import.meta.url).toString();

});

parcelRegister("1Fl9h", function(module, exports) {
$parcel$export(module.exports, "default", () => $93ea219129c348e7$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $93ea219129c348e7$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    searchErrorTitle: {
        defaultMessage: 'We couldn\u2019t load your search results',
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.error.title'
    },
    searchErrorText: {
        defaultMessage: 'Refresh the page and try again. Or go back to the { helpCenterLink }.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.error.message'
    },
    helpCenter: {
        defaultMessage: 'help center',
        description: 'Text to render help center link',
        id: 'cv.search.error.help-center'
    }
});

});



parcelRegister("2UiQO", function(module, exports) {
$parcel$export(module.exports, "searchExperience", () => $55e25bd8fa7d45c4$export$478fc2b872b7df27);
$parcel$export(module.exports, "csmSearchExperience", () => $55e25bd8fa7d45c4$export$c32ff69c6cd0bb0b);
$parcel$export(module.exports, "inlineSearchExperience", () => $55e25bd8fa7d45c4$export$e3eaed2128f58e6a);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $55e25bd8fa7d45c4$export$478fc2b872b7df27 = new (0, $3odV5.UFOExperience)((0, $hWlSg.searchExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageLoad
});
const $55e25bd8fa7d45c4$export$c32ff69c6cd0bb0b = new (0, $3odV5.UFOExperience)('csm-help-center-search', {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $55e25bd8fa7d45c4$export$e3eaed2128f58e6a = new (0, $3odV5.UFOExperience)((0, $hWlSg.inlineSearchExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("3yiCA", function(module, exports) {
$parcel$export(module.exports, "SearchModal", () => (parcelRequire("lOAAh")).default);

var $lOAAh = parcelRequire("lOAAh");

});
parcelRegister("lOAAh", function(module, exports) {
$parcel$export(module.exports, "default", () => $96795c214e41c0ae$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $6mmHn = parcelRequire("6mmHn");

var $fpChy = parcelRequire("fpChy");

var $4i2V5 = parcelRequire("4i2V5");

var $88P4u = parcelRequire("88P4u");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $c3Vmk = parcelRequire("c3Vmk");

var $93stz = parcelRequire("93stz");

var $7biT4 = parcelRequire("7biT4");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $dEWOM = parcelRequire("dEWOM");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $2vWb1 = parcelRequire("2vWb1");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3nV5N = parcelRequire("3nV5N");

var $ja75a = parcelRequire("ja75a");

var $h9nNX = parcelRequire("h9nNX");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
var $jEoO3 = parcelRequire("jEoO3");
parcelRequire("43Ruj");
var $7dQEO = parcelRequire("7dQEO");
parcelRequire("6GY1V");
var $lqLJ4 = parcelRequire("lqLJ4");
parcelRequire("kKF1m");
var $cwSyS = parcelRequire("cwSyS");

var $jnS9b = parcelRequire("jnS9b");
function $96795c214e41c0ae$var$deriveVirtualAgentAvailable(forProject, scope, isVSAOnHCEnabled) {
    const forPortal = scope === 'portal' && forProject;
    const forHelpCenter = scope === 'helpCenter' && Boolean(isVSAOnHCEnabled);
    return Boolean(forPortal || forHelpCenter);
}
const $96795c214e41c0ae$var$SearchModal = ({ isOpen: isOpen, term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, isLoggedIn: isLoggedIn, portalId: portalId, projectId: projectId, onSearch: onSearch, onClose: onClose, onReturnFocus: onReturnFocus })=>{
    const cloudId = (0, $6mmHn.getCloudId)();
    const scope = portalId ? 'portal' : 'helpCenter';
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const showSearchResults = (0, $4azHH.isValidSearchTerm)(term);
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $3nV5N.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const isVirtualAgentAvailable = $96795c214e41c0ae$var$deriveVirtualAgentAvailable(isVirtualAgentAvailableForProject, scope, isVSAOnHCEnabled);
    const showFilters = !isCSM;
    const onKeyUp = (0, $4fqPo.useCallback)((event)=>{
        if (event.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const [{ location: location }, { replace: replace }] = (0, $hfD9S.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $4azHH.useQueryParams)();
    const { portalIds: portalIds, categoryIds: categoryIds } = queryStringParams;
    const portalIdAsNumber = (0, $4azHH.getPortalIdAsNumber)(portalId);
    const showCategoryFilter = (0, $4azHH.isSinglePortalSearch)(portalIdAsNumber);
    const onServiceDeskFilterChange = (0, $4fqPo.useCallback)((options)=>{
        const selectedPortalIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($4i2V5))).stringify({
            ...queryStringParams,
            portalIds: selectedPortalIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const onCategoryFilterChange = (0, $4fqPo.useCallback)((options)=>{
        const selectedCategoryIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($4i2V5))).stringify({
            ...queryStringParams,
            categoryIds: selectedCategoryIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const filtersRow = showFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $96795c214e41c0ae$var$filterStyles
    }, showCategoryFilter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h9nNX.default), {
        onChange: onCategoryFilterChange,
        portalId: portalIdAsNumber,
        projectId: projectId,
        categoryIds: categoryIds
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jnS9b.default), {
        onChange: onServiceDeskFilterChange,
        portalIds: portalIds
    }));
    const resultsContent = showSearchResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), null, isVirtualAgentAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $96795c214e41c0ae$var$virtualBannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ja75a.VirtualAgentBanner), {
        cloudId: cloudId,
        portalId: portalId
    })), filtersRow), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cwSyS.SearchResult), {
        term: term
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7dQEO.SearchResultNone), {
        term: term
    });
    const renderResults = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
            gap: "space.200",
            templateColumns: "1fr",
            alignItems: "center",
            xcss: $96795c214e41c0ae$var$responsiveStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null), resultsContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93stz.default), {
        duration: "small",
        entranceDirection: "bottom"
    }, (fadeInProps)=>isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7biT4.default), {
            zIndex: (0, $2vWb1.layers).dialog()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            ...fadeInProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            style: {
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: '0px',
                left: '0px'
            },
            role: "dialog",
            "aria-modal": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $88P4u.default), {
            autoFocus: true,
            returnFocus: onReturnFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fpChy.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c3Vmk.default), {
            shouldAllowClickThrough: false,
            isTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $2m8U6.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: `calc(100% - ${(0, $jEoO3.SEARCH_BAR_HEIGHT)})`
            }),
            onKeyUp: onKeyUp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lqLJ4.SearchBar), {
            term: term,
            onChange: onSearch,
            onClose: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            id: "dynamic-search-result",
            "aria-live": "polite",
            "aria-atomic": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $2m8U6.xcss)({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: (0, $jEoO3.SEARCH_BAR_HEIGHT),
                backgroundColor: 'elevation.surface.overlay',
                paddingTop: 'space.300',
                paddingBottom: 'space.200',
                overflow: 'auto'
            })
        }, renderResults())))))));
};
var $96795c214e41c0ae$export$2e2bcd8739ae039 = (0, $bmgw6.default)((0, $3yyCx.createSelector)((0, $2hx7o.isLoggedIn), (state, { portalId: portalId })=>({
        portalId: portalId,
        projectId: (0, $95tqy.getProjectId)(state, (0, $4azHH.getPortalIdAsNumber)(portalId))
    }), (isLoggedIn, { portalId: portalId, projectId: projectId })=>({
        isLoggedIn: isLoggedIn,
        portalId: portalId,
        projectId: projectId
    })))($96795c214e41c0ae$var$SearchModal);
const $96795c214e41c0ae$var$virtualBannerStyles = (0, $2m8U6.xcss)({
    marginBottom: 'space.200'
});
const $96795c214e41c0ae$var$filterStyles = (0, $2m8U6.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.300'
});
const $96795c214e41c0ae$var$responsiveStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        gridTemplateColumns: '1fr 965px 1fr',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    }
});

});
parcelRegister("fpChy", function(module, exports) {
$parcel$export(module.exports, "default", () => $848aaa16e245a0d2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");
parcelRequire("6uBMs");
var $93uvS = parcelRequire("93uvS");

var $iZNwy = parcelRequire("iZNwy");
const $848aaa16e245a0d2$export$38d08b04f5a0ce72 = /*#__PURE__*/ (0, $el3DQ.default)((0, $93uvS.default)).withConfig({
    componentId: "sc-1eshvn8-0"
})`overflow:hidden;position:relative;box-sizing:border-box;padding-right:${(props)=>props.scrollbarWidth}px;`;
class $848aaa16e245a0d2$export$2e2bcd8739ae039 extends $4fqPo.Component {
    componentDidMount() {
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        if (!document.body) return;
        const scrollbarWidth = (0, $iZNwy.windowInnerWidth)() - (0, $iZNwy.bodyClientWidth)();
        this.setState({
            scrollbarWidth: scrollbarWidth,
            show: true
        });
    }
    render() {
        return this.state.show ? /*#__PURE__*/ $4fqPo.createElement($848aaa16e245a0d2$export$38d08b04f5a0ce72, {
            scrollbarWidth: this.state.scrollbarWidth
        }) : null;
    }
    constructor(...args){
        super(...args), this.state = {
            scrollbarWidth: 0,
            show: false
        };
    }
}

});
parcelRegister("iZNwy", function(module, exports) {
$parcel$export(module.exports, "windowInnerWidth", () => $45117eeb9f300c00$export$c2f81cb82ec2bad8);
$parcel$export(module.exports, "bodyClientWidth", () => $45117eeb9f300c00$export$d31820d1c745406f);
const $45117eeb9f300c00$export$c2f81cb82ec2bad8 = ()=>window.innerWidth;
const $45117eeb9f300c00$export$d31820d1c745406f = ()=>document.body.clientWidth;

});


parcelRegister("88P4u", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ed6afd006377da1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "MoveFocusInside", () => (parcelRequire("iWNKz")).default);

var $4hrsm = parcelRequire("4hrsm");

var $iWNKz = parcelRequire("iWNKz");
var $5ed6afd006377da1$export$2e2bcd8739ae039 = (0, $4hrsm.default);

});
parcelRegister("4hrsm", function(module, exports) {
$parcel$export(module.exports, "default", () => $31de0c3c11d038dc$export$2e2bcd8739ae039);

var $gMtYT = parcelRequire("gMtYT");

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");

var $en1R6 = parcelRequire("en1R6");

var $is3mM = parcelRequire("is3mM");
var $31de0c3c11d038dc$var$FocusLockCombination = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $en1R6.default), (0, $ichJ5.default)({
        sideCar: (0, $is3mM.default),
        ref: ref
    }, props));
});
var $31de0c3c11d038dc$var$_ref = (0, $en1R6.default).propTypes || {}, $31de0c3c11d038dc$var$sideCar = $31de0c3c11d038dc$var$_ref.sideCar, $31de0c3c11d038dc$var$propTypes = (0, $gMtYT.default)($31de0c3c11d038dc$var$_ref, [
    "sideCar"
]);
$31de0c3c11d038dc$var$FocusLockCombination.propTypes = {};
var $31de0c3c11d038dc$export$2e2bcd8739ae039 = $31de0c3c11d038dc$var$FocusLockCombination;

});
parcelRegister("en1R6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a764a7214aa36010$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");


var $e1K3J = parcelRequire("e1K3J");

var $1H5vR = parcelRequire("1H5vR");

var $jsXp6 = parcelRequire("jsXp6");

var $63SkW = parcelRequire("63SkW");

var $1g2mM = parcelRequire("1g2mM");
var $a764a7214aa36010$var$emptyArray = [];
var $a764a7214aa36010$var$FocusLock = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = (0, $4fqPo.useState)(), realObserved = _useState[0], setObserved = _useState[1];
    var observed = (0, $4fqPo.useRef)();
    var isActive = (0, $4fqPo.useRef)(false);
    var originalFocusedElement = (0, $4fqPo.useRef)(null);
    var _useState2 = (0, $4fqPo.useState)({}), update = _useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $a764a7214aa36010$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _useState3 = (0, $4fqPo.useState)({}), id = _useState3[0];
    var onActivation = (0, $4fqPo.useCallback)(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = (0, $4fqPo.useCallback)(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = (0, $4fqPo.useCallback)(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = (0, $4fqPo.useCallback)(function(event) {
        if (isActive.current) (0, $63SkW.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $63SkW.mediumBlur).useMedium;
    var setObserveNode = (0, $4fqPo.useCallback)(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $ichJ5.default)((_extends2 = {}, _extends2[0, $e1K3J.FOCUS_DISABLED] = disabled && 'disabled', _extends2[0, $e1K3J.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $1H5vR.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = (0, $4fqPo.useMemo)(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, hasLeadingGuards && [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $jsXp6.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $jsXp6.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(SideCar, {
        id: id,
        sideCar: (0, $63SkW.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions,
        noFocusGuards: noFocusGuards
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Container, (0, $ichJ5.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1g2mM.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $jsXp6.hiddenGuard)
    }));
});
$a764a7214aa36010$var$FocusLock.propTypes = {};
var $a764a7214aa36010$export$2e2bcd8739ae039 = $a764a7214aa36010$var$FocusLock;

});
parcelRegister("jsXp6", function(module, exports) {
$parcel$export(module.exports, "hiddenGuard", () => $e2beb63e78f930de$export$b8c7b07253306600);

var $4fqPo = parcelRequire("4fqPo");

var $e2beb63e78f930de$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $e2beb63e78f930de$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $e2beb63e78f930de$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $e2beb63e78f930de$export$b8c7b07253306600
    }));
};
$e2beb63e78f930de$var$InFocusGuard.propTypes = {};
var $e2beb63e78f930de$export$2e2bcd8739ae039 = $e2beb63e78f930de$var$InFocusGuard;

});

parcelRegister("63SkW", function(module, exports) {
$parcel$export(module.exports, "mediumFocus", () => $469d2c056d710214$export$5733e022b1d538cb);
$parcel$export(module.exports, "mediumBlur", () => $469d2c056d710214$export$b3e9a9312f73723c);
$parcel$export(module.exports, "mediumEffect", () => $469d2c056d710214$export$3a1d52767cbc07b8);
$parcel$export(module.exports, "mediumSidecar", () => $469d2c056d710214$export$892cbf28e5518020);

var $2dWkr = parcelRequire("2dWkr");
var $469d2c056d710214$export$5733e022b1d538cb = (0, $2dWkr.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $469d2c056d710214$export$b3e9a9312f73723c = (0, $2dWkr.createMedium)();
var $469d2c056d710214$export$3a1d52767cbc07b8 = (0, $2dWkr.createMedium)();
var $469d2c056d710214$export$892cbf28e5518020 = (0, $2dWkr.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});

parcelRegister("1g2mM", function(module, exports) {
$parcel$export(module.exports, "focusScope", () => $0ea91ef996f446da$export$f5272e9b1168239c);

var $4fqPo = parcelRequire("4fqPo");
var $0ea91ef996f446da$export$f5272e9b1168239c = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});


parcelRegister("is3mM", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ed7407c7bdb02f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");


var $kQT2v = parcelRequire("kQT2v");

var $jru52 = parcelRequire("jru52");
var $i8raH = parcelRequire("i8raH");
var $1rq2e = parcelRequire("1rq2e");
var $7eGB7 = parcelRequire("7eGB7");
var $10HpC = parcelRequire("10HpC");
var $4PCwQ = parcelRequire("4PCwQ");parcelRequire("cocEi");
var $9Iexm = parcelRequire("9Iexm");

var $lf2ac = parcelRequire("lf2ac");

var $63SkW = parcelRequire("63SkW");
var $d6ed7407c7bdb02f$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $d6ed7407c7bdb02f$var$isFreeFocus = function isFreeFocus() {
    return $d6ed7407c7bdb02f$var$focusOnBody() || (0, $10HpC.focusIsHidden)();
};
var $d6ed7407c7bdb02f$var$lastActiveTrap = null;
var $d6ed7407c7bdb02f$var$lastActiveFocus = null;
var $d6ed7407c7bdb02f$var$tryRestoreFocus = function tryRestoreFocus() {
    return null;
};
var $d6ed7407c7bdb02f$var$lastPortaledElement = null;
var $d6ed7407c7bdb02f$var$focusWasOutsideWindow = false;
var $d6ed7407c7bdb02f$var$windowFocused = false;
var $d6ed7407c7bdb02f$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $d6ed7407c7bdb02f$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($d6ed7407c7bdb02f$var$lastActiveTrap.whiteList || $d6ed7407c7bdb02f$var$defaultWhitelist)(activeElement);
};
var $d6ed7407c7bdb02f$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $d6ed7407c7bdb02f$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $d6ed7407c7bdb02f$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $d6ed7407c7bdb02f$var$lastPortaledElement && $d6ed7407c7bdb02f$var$lastPortaledElement.portaledElement === element;
};
function $d6ed7407c7bdb02f$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $d6ed7407c7bdb02f$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($d6ed7407c7bdb02f$var$focusWasOutsideWindow);
    return $d6ed7407c7bdb02f$var$focusWasOutsideWindow === 'meanwhile';
};
var $d6ed7407c7bdb02f$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $d6ed7407c7bdb02f$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $d6ed7407c7bdb02f$var$checkInHost(activeElement, area, area);
    });
};
var $d6ed7407c7bdb02f$var$getNodeFocusables = function getNodeFocusables(nodes) {
    return (0, $4PCwQ.getFocusableNodes)(nodes, new Map());
};
var $d6ed7407c7bdb02f$var$isNotFocusable = function isNotFocusable(node) {
    return !$d6ed7407c7bdb02f$var$getNodeFocusables([
        node.parentNode
    ]).some(function(el) {
        return el.node === node;
    });
};
var $d6ed7407c7bdb02f$var$activateTrap = function activateTrap() {
    var result = false;
    if ($d6ed7407c7bdb02f$var$lastActiveTrap) {
        var _lastActiveTrap = $d6ed7407c7bdb02f$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions, noFocusGuards = _lastActiveTrap.noFocusGuards;
        var workingNode = observed || $d6ed7407c7bdb02f$var$lastPortaledElement && $d6ed7407c7bdb02f$var$lastPortaledElement.portaledElement;
        if ($d6ed7407c7bdb02f$var$focusOnBody() && $d6ed7407c7bdb02f$var$lastActiveFocus && $d6ed7407c7bdb02f$var$lastActiveFocus !== document.body) {
            if (!document.body.contains($d6ed7407c7bdb02f$var$lastActiveFocus) || $d6ed7407c7bdb02f$var$isNotFocusable($d6ed7407c7bdb02f$var$lastActiveFocus)) {
                var newTarget = $d6ed7407c7bdb02f$var$tryRestoreFocus();
                if (newTarget) newTarget.focus();
            }
        }
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $lf2ac.extractRef)).filter(Boolean));
            var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
                if (!$d6ed7407c7bdb02f$var$focusWasOutside(crossFrame) || !noFocusGuards || !$d6ed7407c7bdb02f$var$lastActiveFocus || $d6ed7407c7bdb02f$var$windowFocused) return false;
                var nodes = $d6ed7407c7bdb02f$var$getNodeFocusables(workingArea);
                var lastIndex = nodes.findIndex(function(_ref) {
                    var node = _ref.node;
                    return node === $d6ed7407c7bdb02f$var$lastActiveFocus;
                });
                return lastIndex === 0 || lastIndex === nodes.length - 1;
            };
            if (!activeElement || $d6ed7407c7bdb02f$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || shouldForceRestoreFocus() || !$d6ed7407c7bdb02f$var$isFreeFocus() || !$d6ed7407c7bdb02f$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $7eGB7.focusInside)(workingArea) || activeElement && $d6ed7407c7bdb02f$var$withinHost(activeElement, workingArea) || $d6ed7407c7bdb02f$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$d6ed7407c7bdb02f$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $9Iexm.moveFocusInside)(workingArea, $d6ed7407c7bdb02f$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $d6ed7407c7bdb02f$var$lastPortaledElement = {};
                        }
                    }
                    $d6ed7407c7bdb02f$var$lastActiveFocus = document && document.activeElement;
                    if ($d6ed7407c7bdb02f$var$lastActiveFocus !== document.body) $d6ed7407c7bdb02f$var$tryRestoreFocus = (0, $jru52.captureFocusRestore)($d6ed7407c7bdb02f$var$lastActiveFocus);
                    $d6ed7407c7bdb02f$var$focusWasOutsideWindow = false;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $i8raH.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref2) {
                    var node = _ref2.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref3) {
                        var guard = _ref3.guard, node = _ref3.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref4) {
                        var node = _ref4.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $d6ed7407c7bdb02f$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $d6ed7407c7bdb02f$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $d6ed7407c7bdb02f$var$onTrap = function onTrap(event) {
    if ($d6ed7407c7bdb02f$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $d6ed7407c7bdb02f$var$onBlur = function onBlur() {
    return (0, $lf2ac.deferAction)($d6ed7407c7bdb02f$var$activateTrap);
};
var $d6ed7407c7bdb02f$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $d6ed7407c7bdb02f$var$recordPortal(currentNode, source);
};
var $d6ed7407c7bdb02f$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $d6ed7407c7bdb02f$var$FocusTrap = function FocusTrap(_ref5) {
    var children = _ref5.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        onBlur: $d6ed7407c7bdb02f$var$onBlur,
        onFocus: $d6ed7407c7bdb02f$var$onFocus
    }, children);
};
$d6ed7407c7bdb02f$var$FocusTrap.propTypes = {};
var $d6ed7407c7bdb02f$var$onWindowFocus = function onWindowFocus() {
    $d6ed7407c7bdb02f$var$windowFocused = true;
};
var $d6ed7407c7bdb02f$var$onWindowBlur = function onWindowBlur() {
    $d6ed7407c7bdb02f$var$windowFocused = false;
    $d6ed7407c7bdb02f$var$focusWasOutsideWindow = 'just';
    (0, $lf2ac.deferAction)(function() {
        $d6ed7407c7bdb02f$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $d6ed7407c7bdb02f$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $d6ed7407c7bdb02f$var$onTrap);
    document.addEventListener('focusout', $d6ed7407c7bdb02f$var$onBlur);
    window.addEventListener('focus', $d6ed7407c7bdb02f$var$onWindowFocus);
    window.addEventListener('blur', $d6ed7407c7bdb02f$var$onWindowBlur);
};
var $d6ed7407c7bdb02f$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $d6ed7407c7bdb02f$var$onTrap);
    document.removeEventListener('focusout', $d6ed7407c7bdb02f$var$onBlur);
    window.removeEventListener('focus', $d6ed7407c7bdb02f$var$onWindowFocus);
    window.removeEventListener('blur', $d6ed7407c7bdb02f$var$onWindowBlur);
};
function $d6ed7407c7bdb02f$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref6) {
        var disabled = _ref6.disabled;
        return !disabled;
    });
}
var $d6ed7407c7bdb02f$var$focusLockAPI = {
    moveFocusInside: (0, $9Iexm.moveFocusInside),
    focusInside: (0, $7eGB7.focusInside),
    focusNextElement: (0, $1rq2e.focusNextElement),
    focusPrevElement: (0, $1rq2e.focusPrevElement),
    focusFirstElement: (0, $1rq2e.focusFirstElement),
    focusLastElement: (0, $1rq2e.focusLastElement),
    captureFocusRestore: (0, $jru52.captureFocusRestore)
};
function $d6ed7407c7bdb02f$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$d6ed7407c7bdb02f$var$lastActiveTrap) $d6ed7407c7bdb02f$var$attachHandler();
    var lastTrap = $d6ed7407c7bdb02f$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $d6ed7407c7bdb02f$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref7) {
            var id = _ref7.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $d6ed7407c7bdb02f$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($d6ed7407c7bdb02f$var$focusLockAPI);
        $d6ed7407c7bdb02f$var$activateTrap(true);
        (0, $lf2ac.deferAction)($d6ed7407c7bdb02f$var$activateTrap);
    } else {
        $d6ed7407c7bdb02f$var$detachHandler();
        $d6ed7407c7bdb02f$var$lastActiveFocus = null;
    }
}
(0, $63SkW.mediumFocus).assignSyncMedium($d6ed7407c7bdb02f$var$onFocus);
(0, $63SkW.mediumBlur).assignMedium($d6ed7407c7bdb02f$var$onBlur);
(0, $63SkW.mediumEffect).assignMedium(function(cb) {
    return cb($d6ed7407c7bdb02f$var$focusLockAPI);
});
var $d6ed7407c7bdb02f$export$2e2bcd8739ae039 = (0, $kQT2v.default)($d6ed7407c7bdb02f$var$reducePropsToState, $d6ed7407c7bdb02f$var$handleStateChangeOnClient)($d6ed7407c7bdb02f$var$FocusWatcher);

});
parcelRegister("lf2ac", function(module, exports) {
$parcel$export(module.exports, "deferAction", () => $f76cad575139219f$export$6523025722806278);
$parcel$export(module.exports, "inlineProp", () => $f76cad575139219f$export$db10c343af3f20fa);
$parcel$export(module.exports, "extractRef", () => $f76cad575139219f$export$c613fed06e332533);
function $f76cad575139219f$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $f76cad575139219f$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $f76cad575139219f$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});



parcelRegister("iWNKz", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb43c22a97faf70$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");


var $e1K3J = parcelRequire("e1K3J");

var $lf2ac = parcelRequire("lf2ac");

var $63SkW = parcelRequire("63SkW");
var $dcb43c22a97faf70$export$729dec1d3bf84074 = function useFocusInside(observedRef) {
    (0, $4fqPo.useEffect)(function() {
        var enabled = true;
        (0, $63SkW.mediumEffect).useMedium(function(car) {
            var observed = observedRef && observedRef.current;
            if (enabled && observed) {
                if (!car.focusInside(observed)) car.moveFocusInside(observed, null);
            }
        });
        return function() {
            enabled = false;
        };
    }, [
        observedRef
    ]);
};
function $dcb43c22a97faf70$var$MoveFocusInside(_ref) {
    var _ref$disabled = _ref.disabled, isDisabled = _ref$disabled === void 0 ? false : _ref$disabled, className = _ref.className, children = _ref.children;
    var ref = (0, $4fqPo.useRef)(null);
    $dcb43c22a97faf70$export$729dec1d3bf84074(isDisabled ? undefined : ref);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", (0, $ichJ5.default)({}, (0, $lf2ac.inlineProp)((0, $e1K3J.FOCUS_AUTO), !isDisabled), {
        ref: ref,
        className: className
    }), children);
}
$dcb43c22a97faf70$var$MoveFocusInside.propTypes = {};
var $dcb43c22a97faf70$export$2e2bcd8739ae039 = $dcb43c22a97faf70$var$MoveFocusInside;

});


parcelRegister("eNI4Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae713d54d98594de$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $fJeCl = parcelRequire("fJeCl");

var $2m8U6 = parcelRequire("2m8U6");
function $ae713d54d98594de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ae713d54d98594de$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $ae713d54d98594de$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $ae713d54d98594de$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $ae713d54d98594de$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $ae713d54d98594de$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $ae713d54d98594de$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $ae713d54d98594de$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $ae713d54d98594de$var$baseStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$ae713d54d98594de$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$ae713d54d98594de$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$ae713d54d98594de$var$gridTemplateRowsVar})`
});
const $ae713d54d98594de$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $ae713d54d98594de$var$Grid = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $2m8U6.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $4fqPo.useMemo)(()=>({
            [$ae713d54d98594de$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$ae713d54d98594de$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$ae713d54d98594de$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $lqVX7.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $ae713d54d98594de$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $fJeCl.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $fJeCl.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $fJeCl.spaceStylesMap).rowGap[rowGap],
            alignItems && $ae713d54d98594de$var$alignItemsMap[alignItems],
            alignContent && $ae713d54d98594de$var$alignContentMap[alignContent],
            justifyContent && $ae713d54d98594de$var$justifyContentMap[justifyContent],
            autoFlow && $ae713d54d98594de$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$ae713d54d98594de$var$Grid.displayName = 'Grid';
var $ae713d54d98594de$export$2e2bcd8739ae039 = $ae713d54d98594de$var$Grid;

});

parcelRegister("3nV5N", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentAvailability", () => $a0febfd869785e2c$export$4cf57cfa614a5585);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $54jwS = parcelRequire("54jwS");

var $hZWMk = parcelRequire("hZWMk");
const $a0febfd869785e2c$var$initialState = {
    isVirtualAgentAvailable: false,
    isVirtualAgentEnabled: false,
    isLoading: true
};
const $a0febfd869785e2c$var$reducer = (state, action)=>{
    switch(action.type){
        case 'RESET':
            return {
                ...$a0febfd869785e2c$var$initialState,
                isLoading: false
            };
        case 'LOAD_AVAILABLITY':
            return $a0febfd869785e2c$var$initialState;
        case 'SET_AVAILABILITY':
            return {
                isVirtualAgentAvailable: action.isVirtualAgentAvailable,
                isVirtualAgentEnabled: action.isVirtualAgentEnabled,
                isLoading: false
            };
        default:
            return state;
    }
};
const $a0febfd869785e2c$export$4cf57cfa614a5585 = ({ isLoggedIn: isLoggedIn, projectId: projectId, cloudId: cloudId, baseUrl: baseUrl = '' })=>{
    const [{ isVirtualAgentAvailable: isVirtualAgentAvailable, isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isLoading }, dispatch] = (0, $4fqPo.useReducer)($a0febfd869785e2c$var$reducer, $a0febfd869785e2c$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    (0, $4fqPo.useEffect)(()=>{
        const canAccess = isLoggedIn;
        if (!canAccess) {
            dispatch({
                type: 'RESET'
            });
            return;
        }
        if (projectId === undefined) {
            dispatch({
                type: 'LOAD_AVAILABLITY'
            });
            return;
        }
        dispatch({
            type: 'LOAD_AVAILABLITY'
        });
        (0, $hZWMk.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${encodeURIComponent(cloudId)}/public/api/v1/virtualagent/byprojectid/${encodeURIComponent(projectId)}/availability`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: true,
                isVirtualAgentEnabled: response.isVirtualAgentEnabled
            });
        }).catch((err)=>{
            dispatch({
                type: 'SET_AVAILABILITY',
                isVirtualAgentAvailable: false,
                isVirtualAgentEnabled: false
            });
            if ('status' in err && typeof err.status === 'number' && err.status === 403) // AI is disabled or the user lacks permission, so this is not an error
            return;
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                action: 'failed',
                actionSubject: 'virtualAgentAvailability',
                attributes: {
                    error: err.message
                }
            }).fire();
        });
    }, [
        createAnalyticsEvent,
        baseUrl,
        isLoggedIn,
        cloudId,
        projectId
    ]);
    return {
        isVirtualAgentAvailable: isVirtualAgentAvailable,
        isLoading: isLoading,
        isVirtualAgentEnabled: isVirtualAgentEnabled
    };
};

});

parcelRegister("ja75a", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentBanner", () => $938b412bb5eb8a55$export$c79d8d330f0b0297);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $ew3Bn = parcelRequire("ew3Bn");

var $lszf6 = parcelRequire("lszf6");

var $2eKV2 = parcelRequire("2eKV2");

var $fmxZJ = parcelRequire("fmxZJ");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");

var $54jwS = parcelRequire("54jwS");

var $WVSzu = parcelRequire("WVSzu");

var $8fAwj = parcelRequire("8fAwj");
const $938b412bb5eb8a55$export$c79d8d330f0b0297 = ({ cloudId: cloudId, portalId: portalId })=>{
    const scope = portalId ? 'portal' : 'helpCenter';
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const [, { push: push }] = (0, $hfD9S.useRouter)();
    const chatWithVirtualAgentForPortal = (0, $4fqPo.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/66942
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButton'
        }).fire();
        if (portalId) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push(`/portal/${portalId}/conversation`);
    }, [
        push,
        portalId,
        createAnalyticsEvent
    ]);
    const chatWithVirtualAgentForHelpCenter = (0, $4fqPo.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'chatWithVAButtonOnHelpCenter'
        }).fire();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        push,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $938b412bb5eb8a55$var$containerStyles,
        role: "status",
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        spread: "space-between",
        space: "space.100",
        xcss: $938b412bb5eb8a55$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $8fAwj.default).virtualAgentBannerHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($938b412bb5eb8a55$var$Message, null, formatMessage((0, $8fAwj.default).virtualServiceAgentEAPBannerDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fmxZJ))), {
            label: ""
        }),
        appearance: "primary",
        onClick: scope === 'portal' ? chatWithVirtualAgentForPortal : chatWithVirtualAgentForHelpCenter
    }, formatMessage((0, $8fAwj.default).buttonTextV2))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), {
        customData: {
            name: 'virtualAgentBanner',
            attributes: {
                cloudId: cloudId,
                portalId: portalId,
                state: 'visible'
            }
        }
    }));
};
const $938b412bb5eb8a55$var$containerStyles = (0, $2m8U6.xcss)({
    background: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    padding: 'space.300',
    borderRadius: 'radius.small'
});
const $938b412bb5eb8a55$var$contentStyles = (0, $2m8U6.xcss)({
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $938b412bb5eb8a55$var$Message = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("WVSzu", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMount", () => $31450dcd1ab209d7$export$787df3507b9eb1ae);

var $gcpCN = parcelRequire("gcpCN");

var $3OiWH = parcelRequire("3OiWH");
const $31450dcd1ab209d7$export$787df3507b9eb1ae = (0, $3OiWH.default)((0, $gcpCN.FireScreenEventOnMountStateless));
// Manually set the display name for sensible snapshots
$31450dcd1ab209d7$export$787df3507b9eb1ae.displayName = 'FireScreenEventOnMount';

});
parcelRegister("gcpCN", function(module, exports) {
$parcel$export(module.exports, "FireScreenEventOnMountStateless", () => $b7fdbba8a9ad8d12$export$641a363dc7c73107);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $3IJ1B = parcelRequire("3IJ1B");
var $9wH3t = parcelRequire("9wH3t");
var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");

var $hCyqP = parcelRequire("hCyqP");

var $29xKq = parcelRequire("29xKq");

var $2dPNI = parcelRequire("2dPNI");

var $kXlzl = parcelRequire("kXlzl");
class $b7fdbba8a9ad8d12$export$641a363dc7c73107 extends $4fqPo.Component {
    render() {
        if ((0, $bG6ob.isMigrateToAnalyticsBridgeEnabled)()) // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return /*#__PURE__*/ $4fqPo.createElement((0, $9wH3t.MountEvent), {
            onMount: this.onMount,
            key: `${this.props.screenName}-${this.props.screenId}`
        });
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return /*#__PURE__*/ $4fqPo.createElement((0, $54jwS.MountEvent), {
            onMount: this.onMount,
            key: `${this.props.screenName}-${this.props.screenId}`
        });
    }
    constructor(...args){
        super(...args), this.endBrowserMetricsV3 = (screenName)=>{
            const { customData: customData } = this.props;
            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            const metric = (0, $hCyqP.default)[screenName];
            /**
     * This is used to support the previously created performance mark
     */ (0, $2dPNI.perfMark)('second.data.loaded');
            (0, $29xKq.devLog)('Browser Metrics v3: ending timer and firing event for screen:', screenName);
            // Suppressing existing violation. Please fix this.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            metric.stop({
                customData: customData
            });
        }, this.onMount = (analyticsEvent)=>{
            const { screenName: screenName } = this.props;
            if ((0, $bG6ob.isMigrateToAnalyticsBridgeEnabled)()) (0, $3IJ1B.fireScreenAnalytics)(analyticsEvent, (0, $kXlzl.AnalyticsTrackActions).VIEWED);
            else (0, $54jwS.fireAnalyticsEvent)({
                analyticsEvent: analyticsEvent,
                type: (0, $54jwS.EventTypes).SCREEN
            });
            /**
     * Fire jsm-ui viewed event along with screen event
     * 1. This is done to for anti abuse spam work to detect human or bot spam
     * 2. We are firing this instead of `ui viewed` because that event is used for overall Atlassian MAU calculations.
     * 3. Event registration -> https://data-portal.internal.atlassian.com/analytics/registry/59264?tabIndex=Details
     */ const uiAnalyticsEvent = analyticsEvent.clone();
            if ((0, $bG6ob.isMigrateToAnalyticsBridgeEnabled)()) (0, $3IJ1B.fireAnalytics)(uiAnalyticsEvent, (0, $gHT3x.UI_EVENT_TYPE), {
                actionSubject: 'jsm-ui',
                action: (0, $kXlzl.AnalyticsTrackActions).VIEWED
            });
            else {
                // The componentName is used as actionSubject in the analytics event
                uiAnalyticsEvent.context.push({
                    componentName: 'jsm-ui'
                });
                (0, $54jwS.fireAnalyticsEvent)({
                    analyticsEvent: uiAnalyticsEvent,
                    type: (0, $54jwS.EventTypes).UI,
                    payload: {}
                });
            }
            /**
     * Trigger Stop timer for for Page load metric only if
     * 1. screenName exists
     * 2. metrics is instrumented for that screen
     * 3. BM3 feature flag is enabled
     */ if (screenName && (0, $hCyqP.isPageLoadInstrumented)(screenName)) this.endBrowserMetricsV3(screenName);
        };
    }
}

});
parcelRegister("9wH3t", function(module, exports) {
$parcel$export(module.exports, "MountEvent", () => $9862455b2ab84961$export$2c6963927dbc68f1);

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");
class $9862455b2ab84961$var$MountEventComponent extends (0, $4fqPo.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $9862455b2ab84961$var$MountEventComponentWithHOC = (0, $as4kh.default)()($9862455b2ab84961$var$MountEventComponent);
const $9862455b2ab84961$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($9862455b2ab84961$var$MountEventComponentWithHOC, props);

});



parcelRegister("8fAwj", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca3d687806c70862$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $ca3d687806c70862$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    virtualAgentBannerHeading: {
        defaultMessage: 'Spend less time hunting for the right request form',
        description: 'Heading in section message displayed when user is on the portal and virtual service agent search is turned on.',
        id: 'virtual-agent.virtual-agent-banner-heading'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    virtualServiceAgentEAPBannerDescription: {
        defaultMessage: 'Ask any question and give our AI-powered virtual service agent a try.',
        description: 'Desription in section message displayed when user is on the portal and virtual service agent search is turned on for EAP.',
        id: 'virtual-agent.virtual-service-agent-EAP-banner-description'
    },
    iconAlt: {
        defaultMessage: 'Atlassian Intelligence',
        description: 'Alternative text for Atlassian Intelligence logo.',
        id: 'virtual-agent.virtual-agent-banner-icon-alt'
    },
    buttonTextV2: {
        defaultMessage: 'Chat with virtual service agent',
        description: 'Text for button which will take the user to the virtual agent conversation page.',
        id: 'virtual-agent.virtual-agent-banner-button-text-v-2'
    }
});

});


parcelRegister("h9nNX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfd30bb58faf7303$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $jz05t = parcelRequire("jz05t");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $8oPMJ = parcelRequire("8oPMJ");
const $bfd30bb58faf7303$var$selector = (0, $3yyCx.createSelector)((state, props)=>(0, $95tqy.getCategories)(state, props.portalId), (maybeCategories)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories
    };
});
const $bfd30bb58faf7303$var$CategoryFilter = (0, $bmgw6.default)($bfd30bb58faf7303$var$selector, {
    fetchCategories: (0, $jz05t.fetchCategoriesAction)
})((0, $8oPMJ.default));
var $bfd30bb58faf7303$export$2e2bcd8739ae039 = $bfd30bb58faf7303$var$CategoryFilter;

});
parcelRegister("8oPMJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ce46e0847b1f2cd$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
parcelRequire("8pZem");
var $ktOA2 = parcelRequire("ktOA2");

var $lFf5e = parcelRequire("lFf5e");
const $4ce46e0847b1f2cd$var$CategoryFilter = ({ portalId: portalId, fetchCategories: fetchCategories, categories: categories, categoryIds: categoryIds, onChange: onChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [values, _] = $4fqPo.useState(categoryIds ?? []);
    $4fqPo.useEffect(()=>{
        if (!projectId || !portalId) return;
        fetchCategories(projectId, portalId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectId,
        portalId
    ]);
    const options = $4fqPo.useMemo(()=>{
        return categories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories
    ]);
    const preSelectedOptions = $4fqPo.useMemo(()=>{
        const preselectedCategories = categories.filter((category)=>values.find((id)=>id === category.id));
        return preselectedCategories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories,
        values
    ]);
    return categories.length > 1 ? /*#__PURE__*/ $4fqPo.createElement((0, $ktOA2.default), {
        fieldId: "category_filter",
        fieldLabel: formatMessage((0, $lFf5e.default).categoryFilter),
        testId: "categoryFilter",
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange
    }) : null;
};
var $4ce46e0847b1f2cd$export$2e2bcd8739ae039 = $4ce46e0847b1f2cd$var$CategoryFilter;

});
parcelRegister("8pZem", function(module, exports) {
$parcel$export(module.exports, "SimplePicker", () => (parcelRequire("ktOA2")).default);

var $ktOA2 = parcelRequire("ktOA2");

});
parcelRegister("ktOA2", function(module, exports) {
$parcel$export(module.exports, "default", () => $30cf65421b490223$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6dMTP = parcelRequire("6dMTP");

var $63sfu = parcelRequire("63sfu");

var $fFB0R = parcelRequire("fFB0R");
const $30cf65421b490223$export$a250605dcad5aca0 = (str, toMatch)=>{
    if (!str) return false;
    return toMatch ? str.toLowerCase().includes(toMatch.toLowerCase()) : true;
};
const $30cf65421b490223$export$60d56ed3961c839c = (0, $63sfu.memoize)((options, searchText)=>{
    if ((0, $63sfu.isEmpty)(searchText)) return options;
    const filteredOptions = [];
    for (const option of options)if ($30cf65421b490223$export$a250605dcad5aca0(option.label, searchText)) filteredOptions.push(option);
    return filteredOptions;
}, (...args)=>JSON.stringify(args));
const $30cf65421b490223$var$Picker = ({ options: options, preSelectedOptions: preSelectedOptions, onChange: onChange, fieldId: fieldId, testId: testId, fieldLabel: fieldLabel })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const [selectedValues, setSelectedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(preSelectedOptions ?? []);
    const onPickerTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        setIsOpen(true);
    }, []);
    const onClose = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        setIsOpen(false);
    }, []);
    const onFilterChange = (0, $4fqPo.useCallback)((selectedOptions)=>{
        onChange(selectedOptions);
        setSelectedValues(selectedOptions);
    }, [
        onChange
    ]);
    const onFilterClearValues = (0, $4fqPo.useCallback)(()=>{
        onChange([]);
        setSelectedValues([]);
    }, [
        onChange
    ]);
    const onLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((search, _enableFullList, _showFullList, _showMore, _lastOption, cb)=>{
        const filteredOptions = $30cf65421b490223$export$60d56ed3961c839c(options, search);
        cb({
            options: filteredOptions,
            totalCount: filteredOptions.length
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: fieldId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6dMTP.default), {
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        isOpen: isOpen,
        value: selectedValues,
        enablePagination: false,
        onOpen: onOpen,
        onClose: onClose,
        onChange: onFilterChange,
        onLoadOptions: onLoadOptions,
        onClearValues: onFilterClearValues,
        onPickerTriggerClick: onPickerTriggerClick,
        testId: testId
    }));
};
var $30cf65421b490223$export$2e2bcd8739ae039 = $30cf65421b490223$var$Picker;

});
parcelRegister("6dMTP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8577ae9829257f10$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bZXab = parcelRequire("bZXab");
var $1VfXT = parcelRequire("1VfXT");
var $kAWVv = parcelRequire("kAWVv");
const $8577ae9829257f10$var$PaginatedFilter = (props)=>{
    const { isOpen: isOpen, onOpen: onOpen, onClose: onClose, value: value, fieldId: fieldId, fieldLabel: fieldLabel, onChange: onChange, onLoadOptions: onLoadOptions, onClearValues: onClearValues, onPickerTriggerClick: onPickerTriggerClick, testId: testId, enablePagination: enablePagination = true } = props;
    const paginationConfig = enablePagination ? {
        enableFullList: false
    } : undefined;
    const onTrigger = $4fqPo.useCallback(({ ref: ref })=>{
        return /*#__PURE__*/ $4fqPo.createElement((0, $kAWVv.default), {
            hasValues: value.length > 0,
            onClick: onPickerTriggerClick,
            isSelected: isOpen,
            isInvalid: value.some((val)=>val.invalid),
            ref: ref,
            testId: testId
        }, (0, $1VfXT.formatLabel)(fieldLabel, value));
    }, // oxlint-disable-next-line react-hooks/exhaustive-deps
    [
        value,
        onOpen,
        isOpen,
        fieldLabel,
        onPickerTriggerClick
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($8577ae9829257f10$var$PaginatedFilterWrapper, null, /*#__PURE__*/ $4fqPo.createElement((0, $bZXab.Picker), {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        value: value,
        pagination: paginationConfig,
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        onChange: onChange,
        onLoadOptions: onLoadOptions,
        onTrigger: onTrigger,
        onClearValues: onClearValues
    }));
};
var $8577ae9829257f10$export$2e2bcd8739ae039 = $8577ae9829257f10$var$PaginatedFilter;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8577ae9829257f10$var$PaginatedFilterWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-6q3nln-0"
})`display:flex;`;

});
parcelRegister("bZXab", function(module, exports) {
$parcel$export(module.exports, "Picker", () => $28ca956ed0b72aba$export$ba25329847403e11);

var $4fqPo = parcelRequire("4fqPo");

var $6hIdA = parcelRequire("6hIdA");

var $dtuVb = parcelRequire("dtuVb");

var $kBL3m = parcelRequire("kBL3m");

var $gIgjO = parcelRequire("gIgjO");

var $1FiiX = parcelRequire("1FiiX");
const $28ca956ed0b72aba$export$ba25329847403e11 = ({ ariaLabel: ariaLabel, isOpen: isOpen, value: value, onClose: onClose, onClearValues: onClearValues, fieldId: fieldId, fieldLabel: fieldLabel, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $gIgjO.default), onLoadOptions: onLoadOptions, pagination: pagination, PopupComponent: PopupComponent, onTrigger: onTrigger, initiallyAddSelectedFirst: initiallyAddSelectedFirst = true, showFooter: showFooter = true, popupProps: popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dtuVb.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1FiiX.DialogInner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kBL3m.default), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            })),
        ...popupProps
    }));

});
parcelRegister("dtuVb", function(module, exports) {
$parcel$export(module.exports, "PaginatedPickerIntlProvider", () => $f9c4c5d7117fb4a2$export$b61655080b0a1f32);

var $4fqPo = parcelRequire("4fqPo");

var $99BhM = parcelRequire("99BhM");
var $4MCQn = parcelRequire("4MCQn");

var $b0rBh = parcelRequire("b0rBh");
const $f9c4c5d7117fb4a2$var$i18n = $b0rBh;
const $f9c4c5d7117fb4a2$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
const $f9c4c5d7117fb4a2$export$b61655080b0a1f32 = ({ children: children })=>{
    const intl = (0, $4MCQn.default)();
    const { language: language, country: country } = $f9c4c5d7117fb4a2$var$getCodesFromLocale(intl.locale.toString());
    const messages = $f9c4c5d7117fb4a2$var$i18n[`${language}_${country}`] || $f9c4c5d7117fb4a2$var$i18n[language] || $f9c4c5d7117fb4a2$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $99BhM.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};

});
parcelRegister("99BhM", function(module, exports) {
$parcel$export(module.exports, "default", () => $6aa1e07bad8d1d15$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d8KcD = parcelRequire("d8KcD");

var $fckbz = parcelRequire("fckbz");

var $4fqPo = parcelRequire("4fqPo");

var $5m6Va = parcelRequire("5m6Va");

var $3rTf2 = parcelRequire("3rTf2");

var $atQYF = parcelRequire("atQYF");
function $6aa1e07bad8d1d15$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $6aa1e07bad8d1d15$var$IntlProvider = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $fckbz.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $atQYF.createIntl)($6aa1e07bad8d1d15$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $6aa1e07bad8d1d15$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $6aa1e07bad8d1d15$var$processIntlConfig(props);
        if (!(0, $5m6Va.shallowEqual)(prevConfig, config)) return {
            intl: (0, $atQYF.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $5m6Va.invariantIntlContext)(this.state.intl);
        return $4fqPo.createElement((0, $3rTf2.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $5m6Va.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($4fqPo.PureComponent);
var $6aa1e07bad8d1d15$export$2e2bcd8739ae039 = $6aa1e07bad8d1d15$var$IntlProvider;

});
parcelRegister("fckbz", function(module, exports) {
$parcel$export(module.exports, "filterProps", () => $b107a26e5c8e12ff$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $b107a26e5c8e12ff$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $b107a26e5c8e12ff$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $b107a26e5c8e12ff$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $b107a26e5c8e12ff$export$4ee1db8ce44a209b);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("8fPlY");
var $jPSWm = parcelRequire("jPSWm");

var $lKbLF = parcelRequire("lKbLF");

var $3mjJX = parcelRequire("3mjJX");
function $b107a26e5c8e12ff$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b107a26e5c8e12ff$var$defaultErrorHandler = function(error) {};
var $b107a26e5c8e12ff$var$defaultWarnHandler = function(warning) {};
var $b107a26e5c8e12ff$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b107a26e5c8e12ff$var$defaultErrorHandler,
    onWarn: $b107a26e5c8e12ff$var$defaultWarnHandler
};
function $b107a26e5c8e12ff$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b107a26e5c8e12ff$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b107a26e5c8e12ff$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b107a26e5c8e12ff$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $lKbLF.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $lKbLF.strategies).variadic
    });
    var getNumberFormat = (0, $lKbLF.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.number),
        strategy: (0, $lKbLF.strategies).variadic
    });
    var getPluralRules = (0, $lKbLF.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d8KcD.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $lKbLF.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $lKbLF.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $jPSWm.IntlMessageFormat)(message, locales, overrideFormats, (0, $d8KcD.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.message),
            strategy: (0, $lKbLF.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $lKbLF.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $lKbLF.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $lKbLF.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.list),
            strategy: (0, $lKbLF.strategies).variadic
        }),
        getDisplayNames: (0, $lKbLF.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b107a26e5c8e12ff$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $lKbLF.strategies).variadic
        })
    };
}
function $b107a26e5c8e12ff$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $3mjJX.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("8fPlY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("lSzKm")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("lSzKm")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("kEYjx")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("jPSWm")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $jPSWm = parcelRequire("jPSWm");
parcelRequire("lSzKm");
parcelRequire("kEYjx");
var $60278f29c23c34b6$export$2e2bcd8739ae039 = (0, $jPSWm.IntlMessageFormat);

});
parcelRegister("jPSWm", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $e70d65bd0e4f5c10$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $d8KcD = parcelRequire("d8KcD");

var $awpcx = parcelRequire("awpcx");

var $iVYSv = parcelRequire("iVYSv");

var $kEYjx = parcelRequire("kEYjx");
// -- MessageFormat --------------------------------------------------------
function $e70d65bd0e4f5c10$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $e70d65bd0e4f5c10$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $e70d65bd0e4f5c10$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $d8KcD.__assign)({}, defaultConfig));
}
function $e70d65bd0e4f5c10$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $e70d65bd0e4f5c10$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $awpcx.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $e70d65bd0e4f5c10$var$createFastMemoizeCache(cache.number),
            strategy: (0, $awpcx.strategies).variadic
        }),
        getDateTimeFormat: (0, $awpcx.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $e70d65bd0e4f5c10$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $awpcx.strategies).variadic
        }),
        getPluralRules: (0, $awpcx.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d8KcD.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $e70d65bd0e4f5c10$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $awpcx.strategies).variadic
        })
    };
}
var $e70d65bd0e4f5c10$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $kEYjx.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $kEYjx.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $d8KcD.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $e70d65bd0e4f5c10$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $e70d65bd0e4f5c10$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $iVYSv.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("awpcx", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $7a9070faf141e17e$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $7a9070faf141e17e$export$c5491a8691a23b9e);
//
// Main
//
function $7a9070faf141e17e$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $7a9070faf141e17e$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $7a9070faf141e17e$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $7a9070faf141e17e$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $7a9070faf141e17e$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $7a9070faf141e17e$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $7a9070faf141e17e$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7a9070faf141e17e$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7a9070faf141e17e$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $7a9070faf141e17e$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $7a9070faf141e17e$var$monadic : $7a9070faf141e17e$var$variadic;
    return $7a9070faf141e17e$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $7a9070faf141e17e$var$strategyVariadic(fn, options) {
    return $7a9070faf141e17e$var$assemble(fn, this, $7a9070faf141e17e$var$variadic, options.cache.create(), options.serializer);
}
function $7a9070faf141e17e$var$strategyMonadic(fn, options) {
    return $7a9070faf141e17e$var$assemble(fn, this, $7a9070faf141e17e$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $7a9070faf141e17e$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $7a9070faf141e17e$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$7a9070faf141e17e$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$7a9070faf141e17e$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $7a9070faf141e17e$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $7a9070faf141e17e$var$ObjectWithoutPrototypeCache();
    }
};
var $7a9070faf141e17e$export$c5491a8691a23b9e = {
    variadic: $7a9070faf141e17e$var$strategyVariadic,
    monadic: $7a9070faf141e17e$var$strategyMonadic
};

});

parcelRegister("iVYSv", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("2oXKb")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("2oXKb")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("2oXKb")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("2oXKb")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("2oXKb")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("2oXKb")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("2oXKb")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("2oXKb")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("2oXKb")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("2oXKb")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("2oXKb")).isTimeElement);
$parcel$export(module.exports, "parse", () => $dc8cc6006536f484$export$98e6a39c04603d36);

var $d8KcD = parcelRequire("d8KcD");

var $daARt = parcelRequire("daARt");

var $d44ZQ = parcelRequire("d44ZQ");

var $2oXKb = parcelRequire("2oXKb");
function $dc8cc6006536f484$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $2oXKb.isSelectElement)(el) || (0, $2oXKb.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $dc8cc6006536f484$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $2oXKb.isNumberElement)(el) && (0, $2oXKb.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $2oXKb.isDateElement)(el) || (0, $2oXKb.isTimeElement)(el)) && (0, $2oXKb.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $2oXKb.isTagElement)(el)) $dc8cc6006536f484$var$pruneLocation(el.children);
    });
}
function $dc8cc6006536f484$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $d8KcD.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $d44ZQ.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $daARt.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $dc8cc6006536f484$var$pruneLocation(result.val);
    return result.val;
}
var $dc8cc6006536f484$export$d3c1bfa0f7d806e9 = (0, $d44ZQ.Parser);

});
parcelRegister("daARt", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $9968cd79be866205$export$896afd8541959ee5);
var $9968cd79be866205$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($9968cd79be866205$export$896afd8541959ee5 || ($9968cd79be866205$export$896afd8541959ee5 = {}));

});

parcelRegister("d44ZQ", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $982f864929a0a5c9$export$7acfa6ed01010e37);

var $d8KcD = parcelRequire("d8KcD");

var $daARt = parcelRequire("daARt");

var $2oXKb = parcelRequire("2oXKb");

var $eQY57 = parcelRequire("eQY57");
parcelRequire("lV2I1");
var $3PZke = parcelRequire("3PZke");
var $jdc2a = parcelRequire("jdc2a");

var $eOlTY = parcelRequire("eOlTY");
var $982f864929a0a5c9$var$_a;
var $982f864929a0a5c9$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $eQY57.SPACE_SEPARATOR_REGEX).source, "*"));
var $982f864929a0a5c9$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $eQY57.SPACE_SEPARATOR_REGEX).source, "*$"));
function $982f864929a0a5c9$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $982f864929a0a5c9$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $982f864929a0a5c9$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $982f864929a0a5c9$var$hasNativeFromEntries = !!Object.fromEntries;
var $982f864929a0a5c9$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $982f864929a0a5c9$var$hasTrimStart = !!String.prototype.trimStart;
var $982f864929a0a5c9$var$hasTrimEnd = !!String.prototype.trimEnd;
var $982f864929a0a5c9$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $982f864929a0a5c9$var$isSafeInteger = $982f864929a0a5c9$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $982f864929a0a5c9$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $982f864929a0a5c9$var$re = $982f864929a0a5c9$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $982f864929a0a5c9$var$REGEX_SUPPORTS_U_AND_Y = (($982f864929a0a5c9$var$_a = $982f864929a0a5c9$var$re.exec('a')) === null || $982f864929a0a5c9$var$_a === void 0 ? void 0 : $982f864929a0a5c9$var$_a[0]) === 'a';
} catch (_) {
    $982f864929a0a5c9$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $982f864929a0a5c9$var$startsWith = $982f864929a0a5c9$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $982f864929a0a5c9$var$fromCodePoint = $982f864929a0a5c9$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $982f864929a0a5c9$var$fromEntries = // native
$982f864929a0a5c9$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $982f864929a0a5c9$var$codePointAt = $982f864929a0a5c9$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $982f864929a0a5c9$var$trimStart = $982f864929a0a5c9$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($982f864929a0a5c9$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $982f864929a0a5c9$var$trimEnd = $982f864929a0a5c9$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($982f864929a0a5c9$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $982f864929a0a5c9$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $982f864929a0a5c9$var$matchIdentifierAtIndex;
if ($982f864929a0a5c9$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $982f864929a0a5c9$var$IDENTIFIER_PREFIX_RE_1 = $982f864929a0a5c9$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $982f864929a0a5c9$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $982f864929a0a5c9$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $982f864929a0a5c9$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$982f864929a0a5c9$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $982f864929a0a5c9$var$codePointAt(s, index);
        if (c === undefined || $982f864929a0a5c9$var$_isWhiteSpace(c) || $982f864929a0a5c9$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $982f864929a0a5c9$var$fromCodePoint.apply(void 0, match);
};
var $982f864929a0a5c9$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $2oXKb.TYPE).pound,
                    location: $982f864929a0a5c9$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $daARt.ErrorKind).UNMATCHED_CLOSING_TAG, $982f864929a0a5c9$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $982f864929a0a5c9$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $2oXKb.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $982f864929a0a5c9$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$982f864929a0a5c9$var$_isAlpha(this.char())) return this.error((0, $daARt.ErrorKind).INVALID_TAG, $982f864929a0a5c9$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $daARt.ErrorKind).UNMATCHED_CLOSING_TAG, $982f864929a0a5c9$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $daARt.ErrorKind).INVALID_TAG, $982f864929a0a5c9$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $2oXKb.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $982f864929a0a5c9$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $daARt.ErrorKind).UNCLOSED_TAG, $982f864929a0a5c9$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $daARt.ErrorKind).INVALID_TAG, $982f864929a0a5c9$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $982f864929a0a5c9$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $982f864929a0a5c9$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $2oXKb.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$982f864929a0a5c9$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $982f864929a0a5c9$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $982f864929a0a5c9$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $daARt.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $daARt.ErrorKind).EMPTY_ARGUMENT, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $daARt.ErrorKind).MALFORMED_ARGUMENT, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $daARt.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $2oXKb.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $daARt.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $daARt.ErrorKind).MALFORMED_ARGUMENT, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $982f864929a0a5c9$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $982f864929a0a5c9$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $daARt.ErrorKind).EXPECT_ARGUMENT_TYPE, $982f864929a0a5c9$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $982f864929a0a5c9$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $daARt.ErrorKind).EXPECT_ARGUMENT_STYLE, $982f864929a0a5c9$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $982f864929a0a5c9$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $982f864929a0a5c9$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $982f864929a0a5c9$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $2oXKb.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $daARt.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $eOlTY.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $2oXKb.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $3PZke.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $2oXKb.TYPE).date : (0, $2oXKb.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $2oXKb.TYPE).number : argType === 'date' ? (0, $2oXKb.TYPE).date : (0, $2oXKb.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $daARt.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $982f864929a0a5c9$var$createLocation(typeEndPosition_1, (0, $d8KcD.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $daARt.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $982f864929a0a5c9$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $daARt.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $daARt.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $2oXKb.TYPE).select,
                        value: value,
                        options: $982f864929a0a5c9$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $2oXKb.TYPE).plural,
                        value: value,
                        options: $982f864929a0a5c9$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $daARt.ErrorKind).INVALID_ARGUMENT_TYPE, $982f864929a0a5c9$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $daARt.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $daARt.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $982f864929a0a5c9$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $jdc2a.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $daARt.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $2oXKb.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $jdc2a.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $daARt.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $daARt.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $982f864929a0a5c9$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $daARt.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $daARt.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $daARt.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $daARt.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $982f864929a0a5c9$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $982f864929a0a5c9$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $daARt.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $daARt.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $982f864929a0a5c9$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $daARt.ErrorKind).MISSING_OTHER_CLAUSE, $982f864929a0a5c9$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $982f864929a0a5c9$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$982f864929a0a5c9$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $982f864929a0a5c9$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($982f864929a0a5c9$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $982f864929a0a5c9$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $982f864929a0a5c9$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $982f864929a0a5c9$var$_isAlphaOrSlash(codepoint) {
    return $982f864929a0a5c9$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $982f864929a0a5c9$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $982f864929a0a5c9$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $982f864929a0a5c9$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("2oXKb", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $1bfc2a8ea034c391$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $1bfc2a8ea034c391$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $1bfc2a8ea034c391$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $1bfc2a8ea034c391$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $1bfc2a8ea034c391$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $1bfc2a8ea034c391$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $1bfc2a8ea034c391$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $1bfc2a8ea034c391$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $1bfc2a8ea034c391$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $1bfc2a8ea034c391$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $1bfc2a8ea034c391$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $1bfc2a8ea034c391$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $1bfc2a8ea034c391$export$7680c41f1a55f4cf);
var $1bfc2a8ea034c391$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($1bfc2a8ea034c391$export$b87f371cbc396fcf || ($1bfc2a8ea034c391$export$b87f371cbc396fcf = {}));
var $1bfc2a8ea034c391$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($1bfc2a8ea034c391$export$906452485466fa53 || ($1bfc2a8ea034c391$export$906452485466fa53 = {}));
function $1bfc2a8ea034c391$export$cfa10c5697238752(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.literal;
}
function $1bfc2a8ea034c391$export$4f55724281bdfaf9(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.argument;
}
function $1bfc2a8ea034c391$export$e11187b219e191e1(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.number;
}
function $1bfc2a8ea034c391$export$32d811605da75f40(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.date;
}
function $1bfc2a8ea034c391$export$34ec46f596b1702f(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.time;
}
function $1bfc2a8ea034c391$export$dcfe1c11d168b5a1(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.select;
}
function $1bfc2a8ea034c391$export$6c796d116f0a4fbc(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.plural;
}
function $1bfc2a8ea034c391$export$c0ece297bdd0c082(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.pound;
}
function $1bfc2a8ea034c391$export$5c83de34745812b(el) {
    return el.type === $1bfc2a8ea034c391$export$b87f371cbc396fcf.tag;
}
function $1bfc2a8ea034c391$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $1bfc2a8ea034c391$export$906452485466fa53.number);
}
function $1bfc2a8ea034c391$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $1bfc2a8ea034c391$export$906452485466fa53.dateTime);
}
function $1bfc2a8ea034c391$export$f0ac572c1121c662(value) {
    return {
        type: $1bfc2a8ea034c391$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $1bfc2a8ea034c391$export$425e864b0ba114f1(value, style) {
    return {
        type: $1bfc2a8ea034c391$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("eQY57", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $ad0486f7637da7ee$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $ad0486f7637da7ee$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $ad0486f7637da7ee$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("lV2I1", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("3PZke")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("jdc2a")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("jdc2a")).parseNumberSkeletonFromString);
parcelRequire("3PZke");
parcelRequire("jdc2a");

});
parcelRegister("3PZke", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $2cb5b46cdacb2717$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $2cb5b46cdacb2717$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $2cb5b46cdacb2717$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($2cb5b46cdacb2717$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("jdc2a", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $dfc890eb5a1cd437$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $dfc890eb5a1cd437$export$47c6f8480bda3e11);

var $d8KcD = parcelRequire("d8KcD");

var $2sWJ4 = parcelRequire("2sWJ4");
function $dfc890eb5a1cd437$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $2sWJ4.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $dfc890eb5a1cd437$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $dfc890eb5a1cd437$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $dfc890eb5a1cd437$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $dfc890eb5a1cd437$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $dfc890eb5a1cd437$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $dfc890eb5a1cd437$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($dfc890eb5a1cd437$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $dfc890eb5a1cd437$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $dfc890eb5a1cd437$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$dfc890eb5a1cd437$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $dfc890eb5a1cd437$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $dfc890eb5a1cd437$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $dfc890eb5a1cd437$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $dfc890eb5a1cd437$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, all), $dfc890eb5a1cd437$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, all), $dfc890eb5a1cd437$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($dfc890eb5a1cd437$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($dfc890eb5a1cd437$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($dfc890eb5a1cd437$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($dfc890eb5a1cd437$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), $dfc890eb5a1cd437$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($dfc890eb5a1cd437$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), $dfc890eb5a1cd437$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $dfc890eb5a1cd437$var$parseSign(token.stem);
        if (signOpts) result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $dfc890eb5a1cd437$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("2sWJ4", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $1cbbc01207199703$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $1cbbc01207199703$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("eOlTY", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $ac86b96d06640700$export$29c5368be8904d27);

var $4r91D = parcelRequire("4r91D");
function $ac86b96d06640700$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $ac86b96d06640700$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $ac86b96d06640700$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $4r91D.timeData)[regionTag || ''] || (0, $4r91D.timeData)[languageTag || ''] || (0, $4r91D.timeData)["".concat(languageTag, "-001")] || (0, $4r91D.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("4r91D", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $33b0af4a7d63b331$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $33b0af4a7d63b331$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("kEYjx", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $f0a6542df1de8380$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $f0a6542df1de8380$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $f0a6542df1de8380$export$275d4a3bb5f66fda);
parcelRequire("iVYSv");
var $2oXKb = parcelRequire("2oXKb");

var $lSzKm = parcelRequire("lSzKm");
var $f0a6542df1de8380$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($f0a6542df1de8380$export$49694c2877b44c57 || ($f0a6542df1de8380$export$49694c2877b44c57 = {}));
function $f0a6542df1de8380$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $f0a6542df1de8380$export$49694c2877b44c57.literal || part.type !== $f0a6542df1de8380$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $f0a6542df1de8380$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $f0a6542df1de8380$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $2oXKb.isLiteralElement)(els[0])) return [
        {
            type: $f0a6542df1de8380$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $2oXKb.isLiteralElement)(el)) {
            result.push({
                type: $f0a6542df1de8380$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $2oXKb.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $f0a6542df1de8380$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $lSzKm.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $2oXKb.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $f0a6542df1de8380$export$49694c2877b44c57.literal : $f0a6542df1de8380$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $2oXKb.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $2oXKb.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $f0a6542df1de8380$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2oXKb.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $2oXKb.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $f0a6542df1de8380$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2oXKb.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $2oXKb.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $f0a6542df1de8380$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2oXKb.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$f0a6542df1de8380$export$df0c12a2d414a163(formatFn)) throw new (0, $lSzKm.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $f0a6542df1de8380$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $f0a6542df1de8380$export$49694c2877b44c57.literal : $f0a6542df1de8380$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $2oXKb.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $lSzKm.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $f0a6542df1de8380$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $2oXKb.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $lSzKm.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $lSzKm.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $lSzKm.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $f0a6542df1de8380$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $f0a6542df1de8380$var$mergeLiteral(result);
}

});
parcelRegister("lSzKm", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $feda5eb1de5dcbb5$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $feda5eb1de5dcbb5$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $feda5eb1de5dcbb5$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $feda5eb1de5dcbb5$export$8bfc137e4d23fdf0);

var $d8KcD = parcelRequire("d8KcD");
var $feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb || ($feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb = {}));
var $feda5eb1de5dcbb5$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $feda5eb1de5dcbb5$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($feda5eb1de5dcbb5$export$7369836851cc1329);
var $feda5eb1de5dcbb5$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($feda5eb1de5dcbb5$export$7369836851cc1329);
var $feda5eb1de5dcbb5$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $feda5eb1de5dcbb5$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($feda5eb1de5dcbb5$export$7369836851cc1329);

});




parcelRegister("lKbLF", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $fd4705b178d9b883$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $fd4705b178d9b883$export$c5491a8691a23b9e);
//
// Main
//
function $fd4705b178d9b883$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $fd4705b178d9b883$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $fd4705b178d9b883$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $fd4705b178d9b883$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $fd4705b178d9b883$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $fd4705b178d9b883$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $fd4705b178d9b883$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fd4705b178d9b883$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fd4705b178d9b883$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $fd4705b178d9b883$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $fd4705b178d9b883$var$monadic : $fd4705b178d9b883$var$variadic;
    return $fd4705b178d9b883$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $fd4705b178d9b883$var$strategyVariadic(fn, options) {
    return $fd4705b178d9b883$var$assemble(fn, this, $fd4705b178d9b883$var$variadic, options.cache.create(), options.serializer);
}
function $fd4705b178d9b883$var$strategyMonadic(fn, options) {
    return $fd4705b178d9b883$var$assemble(fn, this, $fd4705b178d9b883$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $fd4705b178d9b883$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $fd4705b178d9b883$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$fd4705b178d9b883$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$fd4705b178d9b883$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $fd4705b178d9b883$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $fd4705b178d9b883$var$ObjectWithoutPrototypeCache();
    }
};
var $fd4705b178d9b883$export$c5491a8691a23b9e = {
    variadic: $fd4705b178d9b883$var$strategyVariadic,
    monadic: $fd4705b178d9b883$var$strategyMonadic
};

});

parcelRegister("3mjJX", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $2722bd2dcc1ae3e3$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $2722bd2dcc1ae3e3$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $2722bd2dcc1ae3e3$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $2722bd2dcc1ae3e3$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $2722bd2dcc1ae3e3$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $2722bd2dcc1ae3e3$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $2722bd2dcc1ae3e3$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $2722bd2dcc1ae3e3$export$2ddcb436d0aa3688);

var $d8KcD = parcelRequire("d8KcD");
var $2722bd2dcc1ae3e3$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($2722bd2dcc1ae3e3$export$557d6acb76e8a244 || ($2722bd2dcc1ae3e3$export$557d6acb76e8a244 = {}));
var $2722bd2dcc1ae3e3$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $2722bd2dcc1ae3e3$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $2722bd2dcc1ae3e3$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($2722bd2dcc1ae3e3$export$c016d36112f6ddf8);
var $2722bd2dcc1ae3e3$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $2722bd2dcc1ae3e3$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($2722bd2dcc1ae3e3$export$c016d36112f6ddf8);
var $2722bd2dcc1ae3e3$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $2722bd2dcc1ae3e3$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($2722bd2dcc1ae3e3$export$c016d36112f6ddf8);
var $2722bd2dcc1ae3e3$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $2722bd2dcc1ae3e3$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($2722bd2dcc1ae3e3$export$c016d36112f6ddf8);
var $2722bd2dcc1ae3e3$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($2722bd2dcc1ae3e3$export$e3b7eee1dbc44895);
var $2722bd2dcc1ae3e3$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $d8KcD.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $2722bd2dcc1ae3e3$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($2722bd2dcc1ae3e3$export$c016d36112f6ddf8);

});


parcelRegister("5m6Va", function(module, exports) {
$parcel$export(module.exports, "invariantIntlContext", () => $3e646037ebf98fe8$export$45c4bbf6e55bba1f);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $3e646037ebf98fe8$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "assignUniqueKeysToParts", () => $3e646037ebf98fe8$export$cfec03d26465fa63);
$parcel$export(module.exports, "shallowEqual", () => $3e646037ebf98fe8$export$d36bdfa510afb180);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $7Gzpn = parcelRequire("7Gzpn");

var $fckbz = parcelRequire("fckbz");
function $3e646037ebf98fe8$export$45c4bbf6e55bba1f(intl) {
    (0, $7Gzpn.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $3e646037ebf98fe8$export$b52f8d6fc0d47415 = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, (0, $fckbz.DEFAULT_INTL_CONFIG)), {
    textComponent: $4fqPo.Fragment
});
function $3e646037ebf98fe8$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($4fqPo.Children.toArray(parts));
    };
}
function $3e646037ebf98fe8$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("7Gzpn", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $5987ec04aac3babc$export$f5708dca728d7177);

var $d8KcD = parcelRequire("d8KcD");

var $kkZPs = parcelRequire("kkZPs");
function $5987ec04aac3babc$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $5987ec04aac3babc$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $5987ec04aac3babc$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $5987ec04aac3babc$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $5987ec04aac3babc$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $5987ec04aac3babc$export$3fae2929ed23c202(map, pl, field) {
    return $5987ec04aac3babc$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $5987ec04aac3babc$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $5987ec04aac3babc$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $5987ec04aac3babc$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $5987ec04aac3babc$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $5987ec04aac3babc$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $5987ec04aac3babc$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $5987ec04aac3babc$export$a99e4aaac79eeead = (0, $kkZPs.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $kkZPs.strategies).variadic
});
var $5987ec04aac3babc$export$b479a1a2d8754359 = (0, $kkZPs.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $kkZPs.strategies).variadic
});
var $5987ec04aac3babc$export$569bb3095db8432e = (0, $kkZPs.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $d8KcD.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $kkZPs.strategies).variadic
});
var $5987ec04aac3babc$export$e124bc7d23dd0e5a = (0, $kkZPs.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $d8KcD.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $kkZPs.strategies).variadic
});
var $5987ec04aac3babc$export$a1209f8c6068edc3 = (0, $kkZPs.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $d8KcD.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $kkZPs.strategies).variadic
});

});
parcelRegister("kkZPs", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $ece5a2d3fdecc658$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $ece5a2d3fdecc658$export$c5491a8691a23b9e);
//
// Main
//
function $ece5a2d3fdecc658$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $ece5a2d3fdecc658$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $ece5a2d3fdecc658$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $ece5a2d3fdecc658$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $ece5a2d3fdecc658$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $ece5a2d3fdecc658$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $ece5a2d3fdecc658$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $ece5a2d3fdecc658$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $ece5a2d3fdecc658$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $ece5a2d3fdecc658$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $ece5a2d3fdecc658$var$monadic : $ece5a2d3fdecc658$var$variadic;
    return $ece5a2d3fdecc658$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $ece5a2d3fdecc658$var$strategyVariadic(fn, options) {
    return $ece5a2d3fdecc658$var$assemble(fn, this, $ece5a2d3fdecc658$var$variadic, options.cache.create(), options.serializer);
}
function $ece5a2d3fdecc658$var$strategyMonadic(fn, options) {
    return $ece5a2d3fdecc658$var$assemble(fn, this, $ece5a2d3fdecc658$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $ece5a2d3fdecc658$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $ece5a2d3fdecc658$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$ece5a2d3fdecc658$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$ece5a2d3fdecc658$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $ece5a2d3fdecc658$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $ece5a2d3fdecc658$var$ObjectWithoutPrototypeCache();
    }
};
var $ece5a2d3fdecc658$export$c5491a8691a23b9e = {
    variadic: $ece5a2d3fdecc658$var$strategyVariadic,
    monadic: $ece5a2d3fdecc658$var$strategyMonadic
};

});



parcelRegister("3rTf2", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $282ebe86dc41031a$export$2881499e37b75b9a);
$parcel$export(module.exports, "Context", () => $282ebe86dc41031a$export$841858b892ce1f4c);
$parcel$export(module.exports, "default", () => $282ebe86dc41031a$export$2e2bcd8739ae039);

var $d8KcD = parcelRequire("d8KcD");

var $cpFTT = parcelRequire("cpFTT");

var $4fqPo = parcelRequire("4fqPo");

var $5m6Va = parcelRequire("5m6Va");
function $282ebe86dc41031a$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $282ebe86dc41031a$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $4fqPo.createContext(null)) : $4fqPo.createContext(null);
var $282ebe86dc41031a$var$IntlConsumer = $282ebe86dc41031a$var$IntlContext.Consumer, $282ebe86dc41031a$var$IntlProvider = $282ebe86dc41031a$var$IntlContext.Provider;
var $282ebe86dc41031a$export$2881499e37b75b9a = $282ebe86dc41031a$var$IntlProvider;
var $282ebe86dc41031a$export$841858b892ce1f4c = $282ebe86dc41031a$var$IntlContext;
function $282ebe86dc41031a$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $4fqPo.createElement($282ebe86dc41031a$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $5m6Va.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $4fqPo.createElement(WrappedComponent, (0, $d8KcD.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($282ebe86dc41031a$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(// @ts-expect-error
    $4fqPo.forwardRef(function(props, ref) {
        return $4fqPo.createElement(WithIntl, (0, $d8KcD.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(WithIntl, WrappedComponent);
}

});

parcelRegister("atQYF", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $7a15b507ba4fa2ed$export$7e4cbedfdd7b4c0d);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d8KcD = parcelRequire("d8KcD");

var $2iRfG = parcelRequire("2iRfG");
var $jT2tE = parcelRequire("jT2tE");

var $4fqPo = parcelRequire("4fqPo");

var $5m6Va = parcelRequire("5m6Va");

var $kEYjx = parcelRequire("kEYjx");
function $7a15b507ba4fa2ed$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $kEYjx.isFormatXMLElementFn)(v) ? (0, $5m6Va.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $7a15b507ba4fa2ed$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $7a15b507ba4fa2ed$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $jT2tE.formatMessage).apply(void 0, (0, $d8KcD.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $4fqPo.Children.toArray(chunks);
    return chunks;
};
var $7a15b507ba4fa2ed$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $d8KcD.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $7a15b507ba4fa2ed$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $2iRfG.createIntl)((0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, (0, $5m6Va.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, coreIntl), {
        formatMessage: $7a15b507ba4fa2ed$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $7a15b507ba4fa2ed$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("2iRfG", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $1ad691f603b08a74$export$7e4cbedfdd7b4c0d);

var $d8KcD = parcelRequire("d8KcD");

var $fckbz = parcelRequire("fckbz");

var $3mjJX = parcelRequire("3mjJX");

var $2Z0PR = parcelRequire("2Z0PR");

var $bIYdP = parcelRequire("bIYdP");

var $c2Irf = parcelRequire("c2Irf");

var $dGneE = parcelRequire("dGneE");

var $jT2tE = parcelRequire("jT2tE");

var $lIwQK = parcelRequire("lIwQK");

var $bxnMV = parcelRequire("bxnMV");
function $1ad691f603b08a74$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $1ad691f603b08a74$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $1ad691f603b08a74$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $1ad691f603b08a74$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $fckbz.createFormatters)(cache);
    var resolvedConfig = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, (0, $fckbz.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $3mjJX.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $3mjJX.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $3mjJX.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $1ad691f603b08a74$var$verifyConfigMessages(resolvedConfig);
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $2Z0PR.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $2Z0PR.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $bIYdP.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $c2Irf.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $c2Irf.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $c2Irf.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $c2Irf.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $c2Irf.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $dGneE.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $jT2tE.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $jT2tE.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $lIwQK.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $lIwQK.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $bxnMV.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("2Z0PR", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $22c1ed350e29ebe2$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $22c1ed350e29ebe2$export$6871080848f10b2f);

var $3mjJX = parcelRequire("3mjJX");

var $fckbz = parcelRequire("fckbz");
var $22c1ed350e29ebe2$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $22c1ed350e29ebe2$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $fckbz.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $fckbz.filterProps)(options, $22c1ed350e29ebe2$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $22c1ed350e29ebe2$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $22c1ed350e29ebe2$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $22c1ed350e29ebe2$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $22c1ed350e29ebe2$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("bIYdP", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $8892849a4b27b2e8$export$b4ea3b48dcf921f6);

var $fckbz = parcelRequire("fckbz");

var $lSzKm = parcelRequire("lSzKm");

var $3mjJX = parcelRequire("3mjJX");
var $8892849a4b27b2e8$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $8892849a4b27b2e8$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $fckbz.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $fckbz.filterProps)(options, $8892849a4b27b2e8$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $8892849a4b27b2e8$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $lSzKm.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $lSzKm.ErrorCode).MISSING_INTL_API));
    try {
        return $8892849a4b27b2e8$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("c2Irf", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $8c482484241ffa00$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $8c482484241ffa00$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $8c482484241ffa00$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $8c482484241ffa00$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $8c482484241ffa00$export$af6e5d7a5c73edeb);

var $d8KcD = parcelRequire("d8KcD");

var $fckbz = parcelRequire("fckbz");

var $3mjJX = parcelRequire("3mjJX");
var $8c482484241ffa00$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $8c482484241ffa00$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $fckbz.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $fckbz.filterProps)(options, $8c482484241ffa00$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $8c482484241ffa00$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $8c482484241ffa00$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $8c482484241ffa00$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $8c482484241ffa00$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $8c482484241ffa00$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $fckbz.filterProps)(options, $8c482484241ffa00$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $3mjJX.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $8c482484241ffa00$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $8c482484241ffa00$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $8c482484241ffa00$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $8c482484241ffa00$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $3mjJX.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("dGneE", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $9f6138a5bca311fb$export$bbbd05c900f3568d);

var $fckbz = parcelRequire("fckbz");

var $3mjJX = parcelRequire("3mjJX");

var $lSzKm = parcelRequire("lSzKm");
var $9f6138a5bca311fb$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $9f6138a5bca311fb$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $lSzKm.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $lSzKm.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $fckbz.filterProps)(options, $9f6138a5bca311fb$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $3mjJX.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("jT2tE", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $e7a5135019d78fed$export$25868d1e8e76735f);

var $d8KcD = parcelRequire("d8KcD");

var $7Gzpn = parcelRequire("7Gzpn");
parcelRequire("8fPlY");
var $jPSWm = parcelRequire("jPSWm");

var $3mjJX = parcelRequire("3mjJX");
parcelRequire("hxnxL");
var $ja1m4 = parcelRequire("ja1m4");
function $e7a5135019d78fed$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $d8KcD.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $e7a5135019d78fed$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $e7a5135019d78fed$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $jPSWm.IntlMessageFormat).formats;
    return (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, mfFormats), f1), {
        date: $e7a5135019d78fed$var$deepMergeOptions($e7a5135019d78fed$var$setTimeZoneInOptions(mfFormats.date, timeZone), $e7a5135019d78fed$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $e7a5135019d78fed$var$deepMergeOptions($e7a5135019d78fed$var$setTimeZoneInOptions(mfFormats.time, timeZone), $e7a5135019d78fed$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $e7a5135019d78fed$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $7Gzpn.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $ja1m4.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, defaultRichTextElements), values || {});
    formats = $e7a5135019d78fed$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $e7a5135019d78fed$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $3mjJX.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $3mjJX.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $d8KcD.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $3mjJX.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $3mjJX.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});
parcelRegister("hxnxL", function(module, exports) {
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("ja1m4")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("ja1m4")).isDateTimeSkeleton);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("ja1m4")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("ja1m4")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("ja1m4")).isPluralElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("ja1m4")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("ja1m4")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("ja1m4")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("ja1m4")).TYPE);

var $d8KcD = parcelRequire("d8KcD");

var $6w6zj = parcelRequire("6w6zj");

var $jqIqe = parcelRequire("jqIqe");

var $ja1m4 = parcelRequire("ja1m4");
function $cc47c802f7ed6138$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $ja1m4.isSelectElement)(el) || (0, $ja1m4.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $cc47c802f7ed6138$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $ja1m4.isNumberElement)(el) && (0, $ja1m4.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $ja1m4.isDateElement)(el) || (0, $ja1m4.isTimeElement)(el)) && (0, $ja1m4.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $ja1m4.isTagElement)(el)) $cc47c802f7ed6138$var$pruneLocation(el.children);
    });
}
function $cc47c802f7ed6138$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $d8KcD.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $jqIqe.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $6w6zj.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $cc47c802f7ed6138$var$pruneLocation(result.val);
    return result.val;
}
var $cc47c802f7ed6138$export$d3c1bfa0f7d806e9 = (0, $jqIqe.Parser);

});
parcelRegister("6w6zj", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $4bead39cfe9aa79a$export$896afd8541959ee5);
var $4bead39cfe9aa79a$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($4bead39cfe9aa79a$export$896afd8541959ee5 || ($4bead39cfe9aa79a$export$896afd8541959ee5 = {}));

});

parcelRegister("jqIqe", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $03a67f9a2cfa052b$export$7acfa6ed01010e37);

var $d8KcD = parcelRequire("d8KcD");

var $6w6zj = parcelRequire("6w6zj");

var $ja1m4 = parcelRequire("ja1m4");

var $f4fCM = parcelRequire("f4fCM");
parcelRequire("lV2I1");
var $3PZke = parcelRequire("3PZke");
var $jdc2a = parcelRequire("jdc2a");

var $lcrNI = parcelRequire("lcrNI");
var $03a67f9a2cfa052b$var$_a;
var $03a67f9a2cfa052b$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $f4fCM.SPACE_SEPARATOR_REGEX).source, "*"));
var $03a67f9a2cfa052b$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $f4fCM.SPACE_SEPARATOR_REGEX).source, "*$"));
function $03a67f9a2cfa052b$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $03a67f9a2cfa052b$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $03a67f9a2cfa052b$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $03a67f9a2cfa052b$var$hasNativeFromEntries = !!Object.fromEntries;
var $03a67f9a2cfa052b$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $03a67f9a2cfa052b$var$hasTrimStart = !!String.prototype.trimStart;
var $03a67f9a2cfa052b$var$hasTrimEnd = !!String.prototype.trimEnd;
var $03a67f9a2cfa052b$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $03a67f9a2cfa052b$var$isSafeInteger = $03a67f9a2cfa052b$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $03a67f9a2cfa052b$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $03a67f9a2cfa052b$var$re = $03a67f9a2cfa052b$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $03a67f9a2cfa052b$var$REGEX_SUPPORTS_U_AND_Y = (($03a67f9a2cfa052b$var$_a = $03a67f9a2cfa052b$var$re.exec('a')) === null || $03a67f9a2cfa052b$var$_a === void 0 ? void 0 : $03a67f9a2cfa052b$var$_a[0]) === 'a';
} catch (_) {
    $03a67f9a2cfa052b$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $03a67f9a2cfa052b$var$startsWith = $03a67f9a2cfa052b$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $03a67f9a2cfa052b$var$fromCodePoint = $03a67f9a2cfa052b$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $03a67f9a2cfa052b$var$fromEntries = // native
$03a67f9a2cfa052b$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $03a67f9a2cfa052b$var$codePointAt = $03a67f9a2cfa052b$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $03a67f9a2cfa052b$var$trimStart = $03a67f9a2cfa052b$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($03a67f9a2cfa052b$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $03a67f9a2cfa052b$var$trimEnd = $03a67f9a2cfa052b$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($03a67f9a2cfa052b$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $03a67f9a2cfa052b$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $03a67f9a2cfa052b$var$matchIdentifierAtIndex;
if ($03a67f9a2cfa052b$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $03a67f9a2cfa052b$var$IDENTIFIER_PREFIX_RE_1 = $03a67f9a2cfa052b$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $03a67f9a2cfa052b$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $03a67f9a2cfa052b$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $03a67f9a2cfa052b$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$03a67f9a2cfa052b$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $03a67f9a2cfa052b$var$codePointAt(s, index);
        if (c === undefined || $03a67f9a2cfa052b$var$_isWhiteSpace(c) || $03a67f9a2cfa052b$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $03a67f9a2cfa052b$var$fromCodePoint.apply(void 0, match);
};
var $03a67f9a2cfa052b$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $ja1m4.TYPE).pound,
                    location: $03a67f9a2cfa052b$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $6w6zj.ErrorKind).UNMATCHED_CLOSING_TAG, $03a67f9a2cfa052b$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $03a67f9a2cfa052b$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $ja1m4.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $03a67f9a2cfa052b$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$03a67f9a2cfa052b$var$_isAlpha(this.char())) return this.error((0, $6w6zj.ErrorKind).INVALID_TAG, $03a67f9a2cfa052b$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $6w6zj.ErrorKind).UNMATCHED_CLOSING_TAG, $03a67f9a2cfa052b$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $6w6zj.ErrorKind).INVALID_TAG, $03a67f9a2cfa052b$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $ja1m4.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $03a67f9a2cfa052b$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $6w6zj.ErrorKind).UNCLOSED_TAG, $03a67f9a2cfa052b$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $6w6zj.ErrorKind).INVALID_TAG, $03a67f9a2cfa052b$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $03a67f9a2cfa052b$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $03a67f9a2cfa052b$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $ja1m4.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$03a67f9a2cfa052b$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $03a67f9a2cfa052b$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $03a67f9a2cfa052b$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6w6zj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $6w6zj.ErrorKind).EMPTY_ARGUMENT, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $6w6zj.ErrorKind).MALFORMED_ARGUMENT, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $6w6zj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $ja1m4.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $6w6zj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $6w6zj.ErrorKind).MALFORMED_ARGUMENT, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $03a67f9a2cfa052b$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $03a67f9a2cfa052b$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $6w6zj.ErrorKind).EXPECT_ARGUMENT_TYPE, $03a67f9a2cfa052b$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $03a67f9a2cfa052b$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $6w6zj.ErrorKind).EXPECT_ARGUMENT_STYLE, $03a67f9a2cfa052b$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $03a67f9a2cfa052b$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $03a67f9a2cfa052b$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $03a67f9a2cfa052b$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $ja1m4.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $6w6zj.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $lcrNI.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $ja1m4.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $3PZke.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $ja1m4.TYPE).date : (0, $ja1m4.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $ja1m4.TYPE).number : argType === 'date' ? (0, $ja1m4.TYPE).date : (0, $ja1m4.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $6w6zj.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $03a67f9a2cfa052b$var$createLocation(typeEndPosition_1, (0, $d8KcD.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $6w6zj.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $03a67f9a2cfa052b$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $6w6zj.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $6w6zj.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $ja1m4.TYPE).select,
                        value: value,
                        options: $03a67f9a2cfa052b$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $ja1m4.TYPE).plural,
                        value: value,
                        options: $03a67f9a2cfa052b$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $6w6zj.ErrorKind).INVALID_ARGUMENT_TYPE, $03a67f9a2cfa052b$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $6w6zj.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $6w6zj.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $03a67f9a2cfa052b$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $jdc2a.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $6w6zj.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $ja1m4.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $jdc2a.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $6w6zj.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $6w6zj.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $03a67f9a2cfa052b$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $6w6zj.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $6w6zj.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $6w6zj.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $6w6zj.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $03a67f9a2cfa052b$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $03a67f9a2cfa052b$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $6w6zj.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $6w6zj.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $03a67f9a2cfa052b$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $6w6zj.ErrorKind).MISSING_OTHER_CLAUSE, $03a67f9a2cfa052b$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $03a67f9a2cfa052b$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$03a67f9a2cfa052b$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $03a67f9a2cfa052b$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($03a67f9a2cfa052b$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $03a67f9a2cfa052b$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $03a67f9a2cfa052b$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $03a67f9a2cfa052b$var$_isAlphaOrSlash(codepoint) {
    return $03a67f9a2cfa052b$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $03a67f9a2cfa052b$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $03a67f9a2cfa052b$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $03a67f9a2cfa052b$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("ja1m4", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $df300089ed2326ac$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $df300089ed2326ac$export$906452485466fa53);
$parcel$export(module.exports, "isNumberElement", () => $df300089ed2326ac$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $df300089ed2326ac$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $df300089ed2326ac$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $df300089ed2326ac$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $df300089ed2326ac$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isTagElement", () => $df300089ed2326ac$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $df300089ed2326ac$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $df300089ed2326ac$export$7680c41f1a55f4cf);
var $df300089ed2326ac$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($df300089ed2326ac$export$b87f371cbc396fcf || ($df300089ed2326ac$export$b87f371cbc396fcf = {}));
var $df300089ed2326ac$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($df300089ed2326ac$export$906452485466fa53 || ($df300089ed2326ac$export$906452485466fa53 = {}));
function $df300089ed2326ac$export$cfa10c5697238752(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.literal;
}
function $df300089ed2326ac$export$4f55724281bdfaf9(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.argument;
}
function $df300089ed2326ac$export$e11187b219e191e1(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.number;
}
function $df300089ed2326ac$export$32d811605da75f40(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.date;
}
function $df300089ed2326ac$export$34ec46f596b1702f(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.time;
}
function $df300089ed2326ac$export$dcfe1c11d168b5a1(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.select;
}
function $df300089ed2326ac$export$6c796d116f0a4fbc(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.plural;
}
function $df300089ed2326ac$export$c0ece297bdd0c082(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.pound;
}
function $df300089ed2326ac$export$5c83de34745812b(el) {
    return el.type === $df300089ed2326ac$export$b87f371cbc396fcf.tag;
}
function $df300089ed2326ac$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $df300089ed2326ac$export$906452485466fa53.number);
}
function $df300089ed2326ac$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $df300089ed2326ac$export$906452485466fa53.dateTime);
}
function $df300089ed2326ac$export$f0ac572c1121c662(value) {
    return {
        type: $df300089ed2326ac$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $df300089ed2326ac$export$425e864b0ba114f1(value, style) {
    return {
        type: $df300089ed2326ac$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("f4fCM", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $af835969f276bfe3$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $af835969f276bfe3$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $af835969f276bfe3$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("lcrNI", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $f6f048a4e5d1f623$export$29c5368be8904d27);

var $1sYkJ = parcelRequire("1sYkJ");
function $f6f048a4e5d1f623$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $f6f048a4e5d1f623$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $f6f048a4e5d1f623$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $1sYkJ.timeData)[regionTag || ''] || (0, $1sYkJ.timeData)[languageTag || ''] || (0, $1sYkJ.timeData)["".concat(languageTag, "-001")] || (0, $1sYkJ.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("1sYkJ", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $111734ea0c103d64$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $111734ea0c103d64$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});





parcelRegister("lIwQK", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $fcf730549f2f4971$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $fcf730549f2f4971$export$6f284aad1934db69);

var $d8KcD = parcelRequire("d8KcD");

var $fckbz = parcelRequire("fckbz");

var $lSzKm = parcelRequire("lSzKm");

var $3mjJX = parcelRequire("3mjJX");
var $fcf730549f2f4971$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $fcf730549f2f4971$var$now = Date.now();
function $fcf730549f2f4971$var$generateToken(i) {
    return "".concat($fcf730549f2f4971$var$now, "_").concat(i, "_").concat($fcf730549f2f4971$var$now);
}
function $fcf730549f2f4971$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $fcf730549f2f4971$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $fcf730549f2f4971$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $lSzKm.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $lSzKm.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $fckbz.filterProps)(options, $fcf730549f2f4971$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $fcf730549f2f4971$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $3mjJX.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("bxnMV", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $86653a9ae03b2a1b$export$62fe1a4d9e891fa2);

var $fckbz = parcelRequire("fckbz");

var $lSzKm = parcelRequire("lSzKm");

var $3mjJX = parcelRequire("3mjJX");
var $86653a9ae03b2a1b$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $86653a9ae03b2a1b$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $lSzKm.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $lSzKm.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $fckbz.filterProps)(options, $86653a9ae03b2a1b$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $3mjJX.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});




parcelRegister("4MCQn", function(module, exports) {
$parcel$export(module.exports, "default", () => $37b9c6afc6db6542$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5m6Va = parcelRequire("5m6Va");

var $3rTf2 = parcelRequire("3rTf2");
function $37b9c6afc6db6542$export$2e2bcd8739ae039() {
    var intl = $4fqPo.useContext((0, $3rTf2.Context));
    (0, $5m6Va.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("b0rBh", function(module, exports) {
$parcel$export(module.exports, "cs", () => (parcelRequire("go9Mo")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("i8IFS")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("9fB1R")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("7eztX")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("lKaZc")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("1EJdA")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("1Ki89")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("dL28V")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("g1dVg")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("h8YWV")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("hlAT5")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("6ZcIw")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("cW35A")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("gGuYI")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("1XQLr")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("5A7DT")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("8h3EU")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("linLV")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("6j9ga")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("fKmdW")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("hi76o")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("U792X")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("7VZD8")).default);
$parcel$export(module.exports, "zh", () => (parcelRequire("kA3hp")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("kMzwY")).default);

var $go9Mo = parcelRequire("go9Mo");

var $i8IFS = parcelRequire("i8IFS");

var $9fB1R = parcelRequire("9fB1R");

var $7eztX = parcelRequire("7eztX");

var $lKaZc = parcelRequire("lKaZc");

var $1EJdA = parcelRequire("1EJdA");

var $1Ki89 = parcelRequire("1Ki89");

var $dL28V = parcelRequire("dL28V");

var $g1dVg = parcelRequire("g1dVg");

var $h8YWV = parcelRequire("h8YWV");

var $hlAT5 = parcelRequire("hlAT5");

var $6ZcIw = parcelRequire("6ZcIw");

var $cW35A = parcelRequire("cW35A");

var $gGuYI = parcelRequire("gGuYI");

var $1XQLr = parcelRequire("1XQLr");

var $5A7DT = parcelRequire("5A7DT");

var $8h3EU = parcelRequire("8h3EU");

var $linLV = parcelRequire("linLV");

var $6j9ga = parcelRequire("6j9ga");

var $fKmdW = parcelRequire("fKmdW");

var $hi76o = parcelRequire("hi76o");

var $U792X = parcelRequire("U792X");

var $7VZD8 = parcelRequire("7VZD8");

var $kA3hp = parcelRequire("kA3hp");

var $kMzwY = parcelRequire("kMzwY");

});
parcelRegister("go9Mo", function(module, exports) {
$parcel$export(module.exports, "default", () => $543dc528296fe130$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $j15Id = parcelRequire("j15Id");
var $543dc528296fe130$export$2e2bcd8739ae039 = (0, $j15Id.default);

});
parcelRegister("j15Id", function(module, exports) {
$parcel$export(module.exports, "default", () => $154c3dedb270e38e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $154c3dedb270e38e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Zru\u0161it v\xfdb\u011Br",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Na\u010D\xedt\xe1n\xed\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Zobrazit v\xedce",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} z\xa0{totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    'paginated-picker.async-select.select.option.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.select.option.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Zobrazit \xfapln\xfd seznam"
};

});


parcelRegister("i8IFS", function(module, exports) {
$parcel$export(module.exports, "default", () => $107bb98c34f03f3a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $9erC6 = parcelRequire("9erC6");
var $107bb98c34f03f3a$export$2e2bcd8739ae039 = (0, $9erC6.default);

});
parcelRegister("9erC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $de6499cad9607979$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $de6499cad9607979$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Indl\xe6ser ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
    'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.select.option.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8g",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
};

});


parcelRegister("9fB1R", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ed2eaef059bd6ef$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $duSym = parcelRequire("duSym");
var $7ed2eaef059bd6ef$export$2e2bcd8739ae039 = (0, $duSym.default);

});
parcelRegister("duSym", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f4bbc9f8109c92c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $7f4bbc9f8109c92c$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Auswahl l\xf6schen",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4dt\xa0...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
    'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.select.search-placeholder': 'Suchen',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Vollst\xe4ndige Liste anzeigen"
};

});


parcelRegister("7eztX", function(module, exports) {
$parcel$export(module.exports, "default", () => $190570e261e75e30$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dTJuA = parcelRequire("dTJuA");
var $190570e261e75e30$export$2e2bcd8739ae039 = (0, $dTJuA.default);

});
parcelRegister("dTJuA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e438218e1f7459e5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $e438218e1f7459e5$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};

});


parcelRegister("lKaZc", function(module, exports) {
$parcel$export(module.exports, "default", () => $c66f55ca4a5d29b2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $3tubX = parcelRequire("3tubX");
var $c66f55ca4a5d29b2$export$2e2bcd8739ae039 = (0, $3tubX.default);

});
parcelRegister("3tubX", function(module, exports) {
$parcel$export(module.exports, "default", () => $01bc76f710b18343$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $01bc76f710b18343$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};

});


parcelRegister("1EJdA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c0cf18eb38d2f0d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $afUKm = parcelRequire("afUKm");
var $3c0cf18eb38d2f0d$export$2e2bcd8739ae039 = (0, $afUKm.default);

});
parcelRegister("afUKm", function(module, exports) {
$parcel$export(module.exports, "default", () => $87407908dfe08c0f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $87407908dfe08c0f$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    'paginated-picker.async-select.select.option.error-message': "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    'paginated-picker.async-select.select.option.retry-message': "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    'paginated-picker.async-select.select.search-placeholder': "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};

});


parcelRegister("1Ki89", function(module, exports) {
$parcel$export(module.exports, "default", () => $c67d274cb2382cfa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $h3fvm = parcelRequire("h3fvm");
var $c67d274cb2382cfa$export$2e2bcd8739ae039 = (0, $h3fvm.default);

});
parcelRegister("h3fvm", function(module, exports) {
$parcel$export(module.exports, "default", () => $aba85951d71ba54e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $aba85951d71ba54e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Borrar selecci\xf3n",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Cargando\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Mostrar m\xe1s",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
    'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.select.search-placeholder': 'Buscar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};

});


parcelRegister("dL28V", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e325d309802a090$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $guP1z = parcelRequire("guP1z");
var $9e325d309802a090$export$2e2bcd8739ae039 = (0, $guP1z.default);

});
parcelRegister("guP1z", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f98d4e72c68c0a3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $4f98d4e72c68c0a3$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Tyhjenn\xe4 valinta",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "N\xe4yt\xe4 lis\xe4\xe4",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
    'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.select.option.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.select.search-placeholder': 'Hae',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "N\xe4yt\xe4 koko luettelo"
};

});


parcelRegister("g1dVg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d53fb31c09b38e1e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7OY8N = parcelRequire("7OY8N");
var $d53fb31c09b38e1e$export$2e2bcd8739ae039 = (0, $7OY8N.default);

});
parcelRegister("7OY8N", function(module, exports) {
$parcel$export(module.exports, "default", () => $3e768a6d0f83e49c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $3e768a6d0f83e49c$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Effacer la s\xe9lection",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Chargement en cours\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "R\xe9sultats introuvables",
    'paginated-picker.async-select.select.option.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.select.option.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste'
};

});


parcelRegister("h8YWV", function(module, exports) {
$parcel$export(module.exports, "default", () => $41dfd2b5385866f2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6cHl6 = parcelRequire("6cHl6");
var $41dfd2b5385866f2$export$2e2bcd8739ae039 = (0, $6cHl6.default);

});
parcelRegister("6cHl6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e60022a4914495e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $8e60022a4914495e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Bet\xf6lt\xe9s\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "T\xf6bb",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nincs egyez\xe9s",
    'paginated-picker.async-select.select.option.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.select.option.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.select.search-placeholder': "Keres\xe9s",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Teljes lista megjelen\xedt\xe9se"
};

});


parcelRegister("hlAT5", function(module, exports) {
$parcel$export(module.exports, "default", () => $561055c80f7084fc$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $caBiE = parcelRequire("caBiE");
var $561055c80f7084fc$export$2e2bcd8739ae039 = (0, $caBiE.default);

});
parcelRegister("caBiE", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e61da16a281e6c0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $8e61da16a281e6c0$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
    'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
};

});


parcelRegister("6ZcIw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d34dac6d1f47b2e4$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hTHIa = parcelRequire("hTHIa");
var $d34dac6d1f47b2e4$export$2e2bcd8739ae039 = (0, $hTHIa.default);

});
parcelRegister("hTHIa", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc2639c05c3cc134$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $fc2639c05c3cc134$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u9078\u629E\u3092\u89E3\u9664",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u8868\u793A\u3092\u5897\u3084\u3059",
    'paginated-picker.async-select.pagination-details.of-total-count': "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.select.search-placeholder': "\u691C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};

});


parcelRegister("cW35A", function(module, exports) {
$parcel$export(module.exports, "default", () => $61ab9f1801c27866$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hfNr9 = parcelRequire("hfNr9");
var $61ab9f1801c27866$export$2e2bcd8739ae039 = (0, $hfNr9.default);

});
parcelRegister("hfNr9", function(module, exports) {
$parcel$export(module.exports, "default", () => $242d3b10e94d5e0d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $242d3b10e94d5e0d$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\uB85C\uB4DC \uC911...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\uB354 \uBCF4\uAE30",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.select.search-placeholder': "\uAC80\uC0C9",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};

});


parcelRegister("gGuYI", function(module, exports) {
$parcel$export(module.exports, "default", () => $50e8b9bdfc9aee62$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lC3IN = parcelRequire("lC3IN");
var $50e8b9bdfc9aee62$export$2e2bcd8739ae039 = (0, $lC3IN.default);

});
parcelRegister("lC3IN", function(module, exports) {
$parcel$export(module.exports, "default", () => $3cbfa8db02342067$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $3cbfa8db02342067$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Laster\xa0\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
    'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.select.option.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
};

});


parcelRegister("1XQLr", function(module, exports) {
$parcel$export(module.exports, "default", () => $0913065eafcfdfdd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hKIPx = parcelRequire("hKIPx");
var $0913065eafcfdfdd$export$2e2bcd8739ae039 = (0, $hKIPx.default);

});
parcelRegister("hKIPx", function(module, exports) {
$parcel$export(module.exports, "default", () => $45e96ce37fe6a42b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $45e96ce37fe6a42b$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
    'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
};

});


parcelRegister("5A7DT", function(module, exports) {
$parcel$export(module.exports, "default", () => $976caa3b64743c6e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $jPpcp = parcelRequire("jPpcp");
var $976caa3b64743c6e$export$2e2bcd8739ae039 = (0, $jPpcp.default);

});
parcelRegister("jPpcp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5cf817113602ff37$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $5cf817113602ff37$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Wyczy\u015B\u0107 wyb\xf3r",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0141adowanie...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Poka\u017C wi\u0119cej",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nie znaleziono dopasowa\u0144",
    'paginated-picker.async-select.select.option.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.select.option.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Poka\u017C pe\u0142n\u0105 list\u0119"
};

});


parcelRegister("8h3EU", function(module, exports) {
$parcel$export(module.exports, "default", () => $66870b3629f79d73$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $43igC = parcelRequire("43igC");
var $66870b3629f79d73$export$2e2bcd8739ae039 = (0, $43igC.default);

});
parcelRegister("43igC", function(module, exports) {
$parcel$export(module.exports, "default", () => $b595c1e8cf7c9044$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $b595c1e8cf7c9044$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Limpar sele\xe7\xe3o",
    'paginated-picker.async-select.menu-list.error-message.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nenhuma correspond\xeancia encontrada",
    'paginated-picker.async-select.select.option.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};

});


parcelRegister("linLV", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf60cc44662781d3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bEDiX = parcelRequire("bEDiX");
var $cf60cc44662781d3$export$2e2bcd8739ae039 = (0, $bEDiX.default);

});
parcelRegister("bEDiX", function(module, exports) {
$parcel$export(module.exports, "default", () => $939a09acfc8a35d6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $939a09acfc8a35d6$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0438\u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0438\u0441\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("6j9ga", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3f1cdb19a032a24$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $dVtab = parcelRequire("dVtab");
var $a3f1cdb19a032a24$export$2e2bcd8739ae039 = (0, $dVtab.default);

});
parcelRegister("dVtab", function(module, exports) {
$parcel$export(module.exports, "default", () => $88b3e35a50a4b9c2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $88b3e35a50a4b9c2$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4ser in ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Inga tr\xe4ffar hittades",
    'paginated-picker.async-select.select.option.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.select.option.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf6k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Visa fullst\xe4ndig lista"
};

});


parcelRegister("fKmdW", function(module, exports) {
$parcel$export(module.exports, "default", () => $20a9d55ef8a4d640$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $7dKKy = parcelRequire("7dKKy");
var $20a9d55ef8a4d640$export$2e2bcd8739ae039 = (0, $7dKKy.default);

});
parcelRegister("7dKKy", function(module, exports) {
$parcel$export(module.exports, "default", () => $f994c968c78e00d7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $f994c968c78e00d7$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    'paginated-picker.async-select.select.option.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.select.option.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.select.search-placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};

});


parcelRegister("hi76o", function(module, exports) {
$parcel$export(module.exports, "default", () => $231875a81aa9bc1f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fr59p = parcelRequire("fr59p");
var $231875a81aa9bc1f$export$2e2bcd8739ae039 = (0, $fr59p.default);

});
parcelRegister("fr59p", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed26c13caccaf01e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $ed26c13caccaf01e$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Se\xe7imi temizle",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Y\xfckleniyor...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Daha fazla g\xf6ster",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "E\u015Fle\u015Fme bulunamad\u0131",
    'paginated-picker.async-select.select.option.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.select.option.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.select.search-placeholder': 'Ara',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Tam listeyi g\xf6ster"
};

});


parcelRegister("U792X", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb1d35d54c6e5f6b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $aabsx = parcelRequire("aabsx");
var $eb1d35d54c6e5f6b$export$2e2bcd8739ae039 = (0, $aabsx.default);

});
parcelRegister("aabsx", function(module, exports) {
$parcel$export(module.exports, "default", () => $33d8a39269d985db$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $33d8a39269d985db$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0448\u0443\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});


parcelRegister("7VZD8", function(module, exports) {
$parcel$export(module.exports, "default", () => $85df5ea4e8049b45$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $fsn2r = parcelRequire("fsn2r");
var $85df5ea4e8049b45$export$2e2bcd8739ae039 = (0, $fsn2r.default);

});
parcelRegister("fsn2r", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd07764ee1056829$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $cd07764ee1056829$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0110ang t\u1EA3i...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Hi\u1EC3n th\u1ECB th\xeam",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    'paginated-picker.async-select.select.option.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.select.option.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.select.search-placeholder': "T\xecm ki\u1EBFm",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};

});


parcelRegister("kA3hp", function(module, exports) {
$parcel$export(module.exports, "default", () => $509ccc3a09561497$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $jKFip = parcelRequire("jKFip");
var $509ccc3a09561497$export$2e2bcd8739ae039 = (0, $jKFip.default);

});
parcelRegister("jKFip", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c1c6dc093aa8d99$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $7c1c6dc093aa8d99$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u7A7A\u9009\u62E9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u52A0\u8F7D...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u663E\u793A\u66F4\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u672A\u627E\u5230\u5339\u914D\u9879",
    'paginated-picker.async-select.select.option.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.select.option.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};

});


parcelRegister("kMzwY", function(module, exports) {
$parcel$export(module.exports, "default", () => $26bcec27d9a08729$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $eoUhB = parcelRequire("eoUhB");
var $26bcec27d9a08729$export$2e2bcd8739ae039 = (0, $eoUhB.default);

});
parcelRegister("eoUhB", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb41dc416500e679$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $cb41dc416500e679$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u8F09\u5165...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u986F\u793A\u8F03\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    'paginated-picker.async-select.select.option.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.select.option.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u5C0B",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};

});




parcelRegister("kBL3m", function(module, exports) {
$parcel$export(module.exports, "default", () => $078e73bc0e504684$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1gKxY = parcelRequire("1gKxY");

var $lD9dq = parcelRequire("lD9dq");

var $k4MJ3 = parcelRequire("k4MJ3");

var $3yRSW = parcelRequire("3yRSW");

var $gP8Gu = parcelRequire("gP8Gu");

var $5CmOQ = parcelRequire("5CmOQ");

var $cxuyz = parcelRequire("cxuyz");

var $gopac = parcelRequire("gopac");

var $esSyQ = parcelRequire("esSyQ");
const $078e73bc0e504684$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $078e73bc0e504684$var$paginatedComponents = {
    ...(0, $cxuyz.selectComponents),
    MenuList: $gP8Gu.MenuList
};
const $078e73bc0e504684$var$ProxyBaseSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(({ selectOptions: selectOptions, ...props }, ref)=>{
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cxuyz.LocalBaseSelect), {
        ...props,
        options: selectOptions,
        ref: ref
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cxuyz.LocalBaseSelect), {
        ...props,
        ref: ref
    });
});
$078e73bc0e504684$var$ProxyBaseSelect.displayName = 'ProxyBaseSelect';
const $078e73bc0e504684$var$AsyncSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef((props, ref)=>{
    const baseSelectProps = (0, $k4MJ3.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($078e73bc0e504684$var$ProxyBaseSelect, {
        ...props,
        ...baseSelectProps,
        ref: ref
    });
});
$078e73bc0e504684$var$AsyncSelect.displayName = 'AsyncSelect';
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ const $078e73bc0e504684$var$addUniqueOptions = (keys, options, option)=>{
    if (option.optionType === 'group') {
        const groupOptions = [];
        option.options.forEach((groupOption)=>{
            $078e73bc0e504684$var$addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push({
            ...option,
            options: groupOptions
        });
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
const $078e73bc0e504684$var$generateOptions = (selectedValues, newOptions, addSelectedFirst, previousOptions)=>{
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) selectedValues.forEach((option)=>{
        $078e73bc0e504684$var$addUniqueOptions(optionKeys, options, option);
    });
    previousOptions === null || previousOptions === void 0 || previousOptions.forEach((option)=>{
        $078e73bc0e504684$var$addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach((option)=>{
        $078e73bc0e504684$var$addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
const $078e73bc0e504684$var$getLastCursorOption = (options)=>(0, (/*@__PURE__*/$parcel$interopDefault($lD9dq)))(options, (option)=>'cursor' in option && !!option.cursor);
// Needed to disable filtering from react-select
const $078e73bc0e504684$var$noFilterOptions = ()=>true;
const $078e73bc0e504684$var$noLoadOptions = ()=>Promise.resolve();
const $078e73bc0e504684$export$54319cf8344f1691 = (options)=>options.map((option)=>option.optionType === 'group' ? option.options.length : 1).reduce((sumSoFar, count)=>sumSoFar + count, 0);
const $078e73bc0e504684$export$fccf54b4cac6e0b3 = ({ ariaLabel: ariaLabel, field: field, value: value, onChange: onChange, onClear: onClear, initiallyAddSelectedFirst: initiallyAddSelectedFirst, showFooter: showFooter, ...restProps })=>{
    var _field$pagination;
    const selectRef = (0, $4fqPo.useRef)(null);
    const [page, setPage] = (0, $4fqPo.useState)(0);
    const [isLoading, setIsLoading] = (0, $4fqPo.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $4fqPo.useState)(false);
    const [inputValue, setInputValue] = (0, $4fqPo.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $4fqPo.useState)([]);
    const [enableFullList, setEnableFullList] = (0, $4fqPo.useState)(((_field$pagination = field.pagination) === null || _field$pagination === void 0 ? void 0 : _field$pagination.enableFullList) ?? false);
    const [totalCount, setTotalCount] = (0, $4fqPo.useState)(null);
    const [error, setError] = (0, $4fqPo.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const getTotalCountWithFunctions = (0, $4fqPo.useCallback)((newTotalCount)=>{
        var _field$pagination2;
        if (newTotalCount === null || !((_field$pagination2 = field.pagination) !== null && _field$pagination2 !== void 0 && (_field$pagination2 = _field$pagination2.keywordValues) !== null && _field$pagination2 !== void 0 && _field$pagination2.length)) return newTotalCount;
        const { pagination: { keywordValues: keywordValues } } = field;
        const newTotalCountWithKeywords = newTotalCount + value.filter((option)=>keywordValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $078e73bc0e504684$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $078e73bc0e504684$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    const checkIfError = (0, $4fqPo.useCallback)((_search, options, onRetry)=>{
        if (options.some((option)=>option.optionType === 'error')) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $4fqPo.useCallback)((search)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, ({ options: options, totalCount: newTotalCount })=>{
            if (checkIfError(search, options, ()=>handleLoadOptions(search))) return;
            setLoadedOptions($078e73bc0e504684$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $4fqPo.useCallback)((showFullList = false, isRetry = false)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        let originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $078e73bc0e504684$var$getLastCursorOption(loadedOptions), ({ options: options, totalCount: newTotalCount })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($078e73bc0e504684$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    const handleShowFullList = (0, $4fqPo.useCallback)(()=>{
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $4fqPo.useCallback)((newInputValue)=>{
        const { onInputChange: onInputChange } = field;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    const handleOnChange = (0, $4fqPo.useCallback)((options, action)=>{
        let selectData;
        if ('option' in action) {
            const actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1gKxY)))(loadedOptions, (option)=>'value' in option && option.value === actionOption.value)
            };
        }
        onChange === null || onChange === void 0 || onChange(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    const handleClear = (0, $4fqPo.useCallback)(()=>{
        onClear === null || onClear === void 0 || onClear();
        // Focus the search input after clearing
        setTimeout(()=>{
            var _selectRef$current;
            (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || _selectRef$current.focus();
        }, 0);
    }, [
        onClear
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $4fqPo.useEffect)(()=>{
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsCount = totalCount === null ? 0 : $078e73bc0e504684$export$54319cf8344f1691(loadedOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($078e73bc0e504684$var$AsyncSelect, {
        ref: selectRef,
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $078e73bc0e504684$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $078e73bc0e504684$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        selectOptions: loadedOptions,
        onFilterOption: $078e73bc0e504684$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value,
        ...restProps
    }), (showFooter || !showFooter && !!value.length) && field.pagination && !isLoading && !!(loadedOptions !== null && loadedOptions !== void 0 && loadedOptions.length) && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $esSyQ.Footer), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gopac.ShowFullListButton), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), !!value.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3yRSW.ClearSelectedItemsButton), {
        onClear: handleClear,
        type: field.key
    }), showFooter && !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5CmOQ.PaginationDetails), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $078e73bc0e504684$export$2e2bcd8739ae039 = $078e73bc0e504684$export$fccf54b4cac6e0b3;

});
parcelRegister("1gKxY", function(module, exports) {

var $aVpwI = parcelRequire("aVpwI");

var $kUeJo = parcelRequire("kUeJo");

var $lmC5W = parcelRequire("lmC5W");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0ecb6457e7a1a04e$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $0ecb6457e7a1a04e$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $lmC5W(fromIndex);
    if (index < 0) index = $0ecb6457e7a1a04e$var$nativeMax(length + index, 0);
    return $aVpwI(array, $kUeJo(predicate, 3), index);
}
module.exports = $0ecb6457e7a1a04e$var$findIndex;

});

parcelRegister("lD9dq", function(module, exports) {

var $hKpM9 = parcelRequire("hKpM9");

var $8bFH1 = parcelRequire("8bFH1");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $fbf463801fc5c548$var$findLast = $hKpM9($8bFH1);
module.exports = $fbf463801fc5c548$var$findLast;

});
parcelRegister("hKpM9", function(module, exports) {

var $kUeJo = parcelRequire("kUeJo");

var $l6LA7 = parcelRequire("l6LA7");

var $ggedu = parcelRequire("ggedu");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $cebaba0f699f4be9$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$l6LA7(collection)) {
            var iteratee = $kUeJo(predicate, 3);
            collection = $ggedu(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $cebaba0f699f4be9$var$createFind;

});

parcelRegister("8bFH1", function(module, exports) {

var $aVpwI = parcelRequire("aVpwI");

var $kUeJo = parcelRequire("kUeJo");

var $lmC5W = parcelRequire("lmC5W");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5f5fb127fab0eb09$var$nativeMax = Math.max, $5f5fb127fab0eb09$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $5f5fb127fab0eb09$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $lmC5W(fromIndex);
        index = fromIndex < 0 ? $5f5fb127fab0eb09$var$nativeMax(length + index, 0) : $5f5fb127fab0eb09$var$nativeMin(index, length - 1);
    }
    return $aVpwI(array, $kUeJo(predicate, 3), index, true);
}
module.exports = $5f5fb127fab0eb09$var$findLastIndex;

});


parcelRegister("k4MJ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2eceef15e1afeab$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $f2eceef15e1afeab$var$handleInputChange(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $f2eceef15e1afeab$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $4fqPo.useRef)(undefined);
    const mounted = (0, $4fqPo.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $4fqPo.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $4fqPo.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $4fqPo.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $4fqPo.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $4fqPo.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $4fqPo.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $4fqPo.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $4fqPo.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $4fqPo.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $4fqPo.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $4fqPo.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $4fqPo.useCallback)((newValue, actionMeta)=>{
        const inputValue = $f2eceef15e1afeab$var$handleInputChange(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("3yRSW", function(module, exports) {
$parcel$export(module.exports, "ClearSelectedItemsButton", () => $cc700326e1922ffd$export$1d4b7cda9e589b53);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $lszf6 = parcelRequire("lszf6");

var $1K9la = parcelRequire("1K9la");
const $cc700326e1922ffd$export$1d4b7cda9e589b53 = ({ onClear: onClear /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClearSelectedItems = (0, $4fqPo.useCallback)(()=>{
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $1K9la.default).clearAllSelectedItemsButtonText));
};
var $cc700326e1922ffd$export$2e2bcd8739ae039 = $cc700326e1922ffd$export$1d4b7cda9e589b53;

});
parcelRegister("hCKuP", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd4a0d7904930abe$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $5m6Va = parcelRequire("5m6Va");

var $4MCQn = parcelRequire("4MCQn");
function $cd4a0d7904930abe$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $d8KcD.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $d8KcD.__rest)(nextProps, [
        "values"
    ]);
    return (0, $5m6Va.shallowEqual)(nextValues, values) && (0, $5m6Va.shallowEqual)(otherProps, nextOtherProps);
}
function $cd4a0d7904930abe$var$FormattedMessage(props) {
    var intl = (0, $4MCQn.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $4fqPo.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $4fqPo.createElement(Component, null, $4fqPo.Children.toArray(nodes));
    return $4fqPo.createElement($4fqPo.Fragment, null, nodes);
}
$cd4a0d7904930abe$var$FormattedMessage.displayName = 'FormattedMessage';
var $cd4a0d7904930abe$var$MemoizedFormattedMessage = $4fqPo.memo($cd4a0d7904930abe$var$FormattedMessage, $cd4a0d7904930abe$var$areEqual);
$cd4a0d7904930abe$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $cd4a0d7904930abe$export$2e2bcd8739ae039 = $cd4a0d7904930abe$var$MemoizedFormattedMessage;

});

parcelRegister("1K9la", function(module, exports) {
$parcel$export(module.exports, "default", () => $c62933f636bf7de6$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $c62933f636bf7de6$var$message = (0, $6BhDL.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});
var $c62933f636bf7de6$export$2e2bcd8739ae039 = $c62933f636bf7de6$var$message;

});
parcelRegister("6BhDL", function(module, exports) {
$parcel$export(module.exports, "defineMessages", () => $4ce3e1c89e9fffe7$export$1adfeb024f5185b);
$parcel$export(module.exports, "defineMessage", () => $4ce3e1c89e9fffe7$export$747d244ee58120dd);
$parcel$export(module.exports, "FormattedDate", () => $4ce3e1c89e9fffe7$export$40ae3194919d16b);
$parcel$export(module.exports, "FormattedNumber", () => $4ce3e1c89e9fffe7$export$db80edc1e6b2f63d);

var $kk2MV = parcelRequire("kk2MV");

var $3rTf2 = parcelRequire("3rTf2");

var $4MCQn = parcelRequire("4MCQn");

var $99BhM = parcelRequire("99BhM");

var $atQYF = parcelRequire("atQYF");

var $bAVwL = parcelRequire("bAVwL");

var $gk2f8 = parcelRequire("gk2f8");

var $hCKuP = parcelRequire("hCKuP");

var $6NGSq = parcelRequire("6NGSq");

var $fckbz = parcelRequire("fckbz");
var $3mjJX = parcelRequire("3mjJX");
function $4ce3e1c89e9fffe7$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $4ce3e1c89e9fffe7$export$747d244ee58120dd(msg) {
    return msg;
}
var $4ce3e1c89e9fffe7$export$40ae3194919d16b = (0, $kk2MV.createFormattedComponent)('formatDate');
var $4ce3e1c89e9fffe7$export$5b390a54f8a846f7 = (0, $kk2MV.createFormattedComponent)('formatTime');
var $4ce3e1c89e9fffe7$export$db80edc1e6b2f63d = (0, $kk2MV.createFormattedComponent)('formatNumber');
var $4ce3e1c89e9fffe7$export$f52b44e459e6e71d = (0, $kk2MV.createFormattedComponent)('formatList');
var $4ce3e1c89e9fffe7$export$c2336ea5aaab92fa = (0, $kk2MV.createFormattedComponent)('formatDisplayName');
var $4ce3e1c89e9fffe7$export$7fdc7d2c91ce149b = (0, $kk2MV.createFormattedDateTimePartsComponent)('formatDate');
var $4ce3e1c89e9fffe7$export$ec35873761676c2a = (0, $kk2MV.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("kk2MV", function(module, exports) {
$parcel$export(module.exports, "FormattedNumberParts", () => $ecb7d68bf62e7406$export$54d4989ed3eea1ea);
$parcel$export(module.exports, "FormattedListParts", () => $ecb7d68bf62e7406$export$5ac259c7da6d2188);
$parcel$export(module.exports, "createFormattedDateTimePartsComponent", () => $ecb7d68bf62e7406$export$7448277f6036d2ab);
$parcel$export(module.exports, "createFormattedComponent", () => $ecb7d68bf62e7406$export$b37e14176d001dec);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");
var $ecb7d68bf62e7406$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($ecb7d68bf62e7406$var$DisplayName || ($ecb7d68bf62e7406$var$DisplayName = {}));
var $ecb7d68bf62e7406$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($ecb7d68bf62e7406$var$DisplayNameParts || ($ecb7d68bf62e7406$var$DisplayNameParts = {}));
var $ecb7d68bf62e7406$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $4MCQn.default)();
    var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$ecb7d68bf62e7406$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $ecb7d68bf62e7406$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $4MCQn.default)();
    var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$ecb7d68bf62e7406$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $ecb7d68bf62e7406$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $4MCQn.default)();
        var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $ecb7d68bf62e7406$var$DisplayNameParts[name];
    return ComponentParts;
}
function $ecb7d68bf62e7406$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $4MCQn.default)();
        var value = props.value, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $4fqPo.Fragment;
        return $4fqPo.createElement(Text, null, formattedValue);
    };
    Component.displayName = $ecb7d68bf62e7406$var$DisplayName[name];
    return Component;
}

});

parcelRegister("bAVwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $870fae40a32429db$export$2e2bcd8739ae039);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $7Gzpn = parcelRequire("7Gzpn");

var $4MCQn = parcelRequire("4MCQn");
var $870fae40a32429db$var$MINUTE = 60;
var $870fae40a32429db$var$HOUR = 3600;
var $870fae40a32429db$var$DAY = 86400;
function $870fae40a32429db$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $870fae40a32429db$var$MINUTE) return 'second';
    if (absValue < $870fae40a32429db$var$HOUR) return 'minute';
    if (absValue < $870fae40a32429db$var$DAY) return 'hour';
    return 'day';
}
function $870fae40a32429db$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $870fae40a32429db$var$MINUTE;
        case 'hour':
            return $870fae40a32429db$var$HOUR;
        default:
            return $870fae40a32429db$var$DAY;
    }
}
function $870fae40a32429db$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $870fae40a32429db$var$MINUTE;
        default:
            return value * $870fae40a32429db$var$HOUR;
    }
}
var $870fae40a32429db$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $870fae40a32429db$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $870fae40a32429db$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $870fae40a32429db$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $4MCQn.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $d8KcD.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $4fqPo.createElement(Text, null, formattedRelativeTime);
    return $4fqPo.createElement($4fqPo.Fragment, null, formattedRelativeTime);
};
var $870fae40a32429db$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $d8KcD.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $7Gzpn.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $870fae40a32429db$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $4fqPo.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $4fqPo.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $4fqPo.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($870fae40a32429db$var$canIncrement(unit) ? $870fae40a32429db$var$valueToSeconds(value, unit) : 0);
    }
    $4fqPo.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$870fae40a32429db$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $870fae40a32429db$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $870fae40a32429db$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($870fae40a32429db$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $870fae40a32429db$var$selectUnit(currentValueInSeconds);
        var unitDuration = $870fae40a32429db$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $4fqPo.createElement($870fae40a32429db$var$SimpleFormattedRelativeTime, (0, $d8KcD.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$870fae40a32429db$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $870fae40a32429db$export$2e2bcd8739ae039 = $870fae40a32429db$var$FormattedRelativeTime;

});

parcelRegister("gk2f8", function(module, exports) {
$parcel$export(module.exports, "default", () => $be20410e237bad2f$export$2e2bcd8739ae039);
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");
var $be20410e237bad2f$var$FormattedPlural = function(props) {
    var _a = (0, $4MCQn.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $4fqPo.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$be20410e237bad2f$var$FormattedPlural.displayName = 'FormattedPlural';
var $be20410e237bad2f$export$2e2bcd8739ae039 = $be20410e237bad2f$var$FormattedPlural;

});

parcelRegister("6NGSq", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f38941abb0bc79f$export$2e2bcd8739ae039);

var $d8KcD = parcelRequire("d8KcD");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");
var $4f38941abb0bc79f$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $4MCQn.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $d8KcD.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $4fqPo.Fragment;
    return $4fqPo.createElement(Text, null, formattedValue);
};
$4f38941abb0bc79f$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $4f38941abb0bc79f$export$2e2bcd8739ae039 = $4f38941abb0bc79f$var$FormattedDateTimeRange;

});




parcelRegister("gP8Gu", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $61aced1a6cf74cf2$export$d4c4e98c5044dc8);

var $4fqPo = parcelRequire("4fqPo");

var $fbHBj = parcelRequire("fbHBj");

var $5qWT2 = parcelRequire("5qWT2");

var $lBPoc = parcelRequire("lBPoc");

var $78Til = parcelRequire("78Til");

var $aknis = parcelRequire("aknis");

var $cgLoh = parcelRequire("cgLoh");
const $61aced1a6cf74cf2$export$d4c4e98c5044dc8 = (props)=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const [clickCount, setClickCount] = (0, $4fqPo.useState)(1);
    const { selectProps: { //@ts-ignore react-select unsupported props
    menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
    const handleOnShowMore = (0, $4fqPo.useCallback)(()=>{
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fbHBj.components).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $78Til.LoadingMessage), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lBPoc.default), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cgLoh.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aknis.default), {
        onShowMore: handleOnShowMore
    })));
};
var $61aced1a6cf74cf2$export$2e2bcd8739ae039 = $61aced1a6cf74cf2$export$d4c4e98c5044dc8;

});
parcelRegister("fbHBj", function(module, exports) {
$parcel$export(module.exports, "components", () => $24c32af5b4c2801e$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $24c32af5b4c2801e$export$71abc632aa29e6fe);

var $1wAKU = parcelRequire("1wAKU");

var $34OYD = parcelRequire("34OYD");

var $jwO0i = parcelRequire("jwO0i");

var $TiRTm = parcelRequire("TiRTm");

var $5XBba = parcelRequire("5XBba");

var $ggLpi = parcelRequire("ggLpi");

var $jpTAq = parcelRequire("jpTAq");

var $gsMXT = parcelRequire("gsMXT");

var $9xyTL = parcelRequire("9xyTL");

var $4oY1b = parcelRequire("4oY1b");

var $TS4Hw = parcelRequire("TS4Hw");

var $2mOvj = parcelRequire("2mOvj");

var $fUwEA = parcelRequire("fUwEA");

var $a3Led = parcelRequire("a3Led");

var $fCsLs = parcelRequire("fCsLs");

var $7nVta = parcelRequire("7nVta");

var $2XuFo = parcelRequire("2XuFo");

var $hH5l6 = parcelRequire("hH5l6");

var $323Xo = parcelRequire("323Xo");

var $iRYSb = parcelRequire("iRYSb");

var $anFpC = parcelRequire("anFpC");

var $3FW9d = parcelRequire("3FW9d");
const $24c32af5b4c2801e$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $gsMXT.ClearIndicator),
    Control: (0, $5XBba.default),
    DropdownIndicator: (0, $9xyTL.DropdownIndicator),
    Group: (0, $ggLpi.default),
    GroupHeading: (0, $jpTAq.GroupHeading),
    IndicatorsContainer: (0, $1wAKU.IndicatorsContainer),
    Input: (0, $TS4Hw.default),
    LoadingIndicator: (0, $4oY1b.LoadingIndicator),
    Menu: (0, $2mOvj.default),
    MenuList: (0, $fUwEA.MenuList),
    MenuPortal: (0, $7nVta.MenuPortal),
    LoadingMessage: (0, $a3Led.LoadingMessage),
    NoOptionsMessage: (0, $fCsLs.NoOptionsMessage),
    MultiValue: (0, $2XuFo.default),
    MultiValueContainer: (0, $34OYD.MultiValueContainer),
    MultiValueLabel: (0, $hH5l6.MultiValueLabel),
    MultiValueRemove: (0, $323Xo.MultiValueRemove),
    Option: (0, $iRYSb.default),
    Placeholder: (0, $anFpC.default),
    SelectContainer: (0, $jwO0i.SelectContainer),
    SingleValue: (0, $3FW9d.default),
    ValueContainer: (0, $TiRTm.ValueContainer)
};
const $24c32af5b4c2801e$export$71abc632aa29e6fe = (props)=>({
        ...$24c32af5b4c2801e$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("1wAKU", function(module, exports) {
$parcel$export(module.exports, "IndicatorsContainer", () => $69ccbcc480f0bced$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* indicators-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $69ccbcc480f0bced$var$indicatorContainerStyles = null;
const $69ccbcc480f0bced$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $9h99w.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps
    }, children);
};

});
parcelRegister("lgGqQ", function(module, exports) {
$parcel$export(module.exports, "getStyleProps", () => $08691de907ae9a1a$export$26417cabd806a658);
const $08691de907ae9a1a$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};

});


parcelRegister("34OYD", function(module, exports) {
$parcel$export(module.exports, "MultiValueContainer", () => $8a08e0f5de151c01$export$cf9cf2a30a59265c);
/* multi-value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");
const $8a08e0f5de151c01$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $8a08e0f5de151c01$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $8a08e0f5de151c01$var$multiValueStyles.root,
            isDisabled && $8a08e0f5de151c01$var$multiValueStyles.disabled,
            isFocused && $8a08e0f5de151c01$var$multiValueStyles.focused,
            (0, $9h99w.cx)(className, xcss, '-multiValue')
        ])
    }, children);
};

});

parcelRegister("jwO0i", function(module, exports) {
$parcel$export(module.exports, "SelectContainer", () => $ebf09dd31b3eed45$export$446eebadefe1123b);
/* select-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* select-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $ebf09dd31b3eed45$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
};
const $ebf09dd31b3eed45$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $lgGqQ.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $ebf09dd31b3eed45$var$containerStyles.default,
            isRtl && $ebf09dd31b3eed45$var$containerStyles.rtl,
            isDisabled && $ebf09dd31b3eed45$var$containerStyles.disabled,
            (0, $9h99w.cx)(className, xcss, '-container')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    }, children);
};

});

parcelRegister("TiRTm", function(module, exports) {
$parcel$export(module.exports, "ValueContainer", () => $f78777ef9bce5001$export$4dc9f58ad9a1a000);
/* value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* value-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $3H4LK = parcelRequire("3H4LK");

var $lgGqQ = parcelRequire("lgGqQ");
const $f78777ef9bce5001$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _y4ti12x7 _bozg12x7",
    verticalPaddingStandard: "_1q51v77o _85i5v77o",
    verticalPaddingTagUpliftMulti: "_1q511b66 _85i51b66",
    verticalPaddingTagUpliftCompactMulti: "_1q51v77o _85i5v77o",
    verticalPaddingCompactNonUplift: "_1q51ze3t _85i5ze3t",
    flex: "_1e0c1txw",
    flexWithGap: "_zulp1b66 _1e0c1txw _1n261g80"
};
const $f78777ef9bce5001$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    const ffTagUplifts = (0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const tagUpliftMultiVertical = ffTagUplifts && isMulti;
    const tagUpliftChipRow = ffTagUplifts && isMulti && hasValue && controlShouldRenderValue;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $f78777ef9bce5001$var$valueContainerStyles.default,
            tagUpliftMultiVertical && isCompact && $f78777ef9bce5001$var$valueContainerStyles.verticalPaddingTagUpliftCompactMulti,
            tagUpliftMultiVertical && !isCompact && $f78777ef9bce5001$var$valueContainerStyles.verticalPaddingTagUpliftMulti,
            !tagUpliftMultiVertical && !isCompact && $f78777ef9bce5001$var$valueContainerStyles.verticalPaddingStandard,
            !tagUpliftMultiVertical && isCompact && $f78777ef9bce5001$var$valueContainerStyles.verticalPaddingCompactNonUplift,
            isMulti && hasValue && controlShouldRenderValue && $f78777ef9bce5001$var$valueContainerStyles.flex,
            tagUpliftChipRow && $f78777ef9bce5001$var$valueContainerStyles.flexWithGap,
            (0, $9h99w.cx)(className, xcss, '-ValueContainer')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    }, children);
};

});

parcelRegister("5XBba", function(module, exports) {
$parcel$export(module.exports, "default", () => $920925c35e30c9c3$export$2e2bcd8739ae039);
/* control.tsx generated by @compiled/babel-plugin v0.37.1 */ /* control.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $3H4LK = parcelRequire("3H4LK");

var $lgGqQ = parcelRequire("lgGqQ");
const $920925c35e30c9c3$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6d187o _lcxvglyw _bfhk187o _1u6lfrlt",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
const $920925c35e30c9c3$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $920925c35e30c9c3$var$styles.default,
            (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $920925c35e30c9c3$var$styles.defaultT26Shape,
            isDisabled && $920925c35e30c9c3$var$styles.disabled,
            isInvalid && $920925c35e30c9c3$var$styles.invalid,
            isCompact && $920925c35e30c9c3$var$styles.compact,
            appearance === 'subtle' && $920925c35e30c9c3$var$styles.subtle,
            appearance === 'subtle' && isFocused && $920925c35e30c9c3$var$styles.subtleFocused,
            isFocused && $920925c35e30c9c3$var$styles.focused,
            appearance === 'none' && $920925c35e30c9c3$var$styles.none,
            (0, $9h99w.cx)(className, xcss, '-control')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$920925c35e30c9c3$export$2e2bcd8739ae039 = $920925c35e30c9c3$var$Control;

});

parcelRegister("ggLpi", function(module, exports) {
$parcel$export(module.exports, "default", () => $1364bf51cded8b6b$export$2e2bcd8739ae039);
/* group.tsx generated by @compiled/babel-plugin v0.37.1 */ /* group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $1364bf51cded8b6b$var$styles = {
    root: "_85i5u2gc _1q51u2gc"
};
const $1364bf51cded8b6b$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $1364bf51cded8b6b$var$styles.root,
            (0, $9h99w.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }, label && /*#__PURE__*/ $4fqPo.createElement(Heading, {
        ...headingProps,
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }, label), /*#__PURE__*/ $4fqPo.createElement("div", null, children));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1364bf51cded8b6b$export$2e2bcd8739ae039 = $1364bf51cded8b6b$var$Group;

});

parcelRegister("jpTAq", function(module, exports) {
$parcel$export(module.exports, "GroupHeading", () => $d952ea8c5ba776f7$export$85c8b41a3cd87edc);
/* group-heading.tsx generated by @compiled/babel-plugin v0.37.1 */ /* group-heading.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");

var $4y7YU = parcelRequire("4y7YU");
const $d952ea8c5ba776f7$var$headingStyles = null;
const $d952ea8c5ba776f7$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $4y7YU.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $9h99w.cx)(className, xcss, '-group')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps
    });
};

});
parcelRegister("4y7YU", function(module, exports) {
$parcel$export(module.exports, "cleanCommonProps", () => $066c904aa755609a$export$8e9fd4287627890c);
// Clean Common Props
// ==============================
const $066c904aa755609a$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};

});


parcelRegister("gsMXT", function(module, exports) {
$parcel$export(module.exports, "ClearIndicator", () => $72a849f89206feb8$export$ecf9cf59142dd54a);
/* clear-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ /* clear-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $hMwsV = parcelRequire("hMwsV");

var $iqiKs = parcelRequire("iqiKs");

var $lgGqQ = parcelRequire("lgGqQ");
const $72a849f89206feb8$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $72a849f89206feb8$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
};
const $72a849f89206feb8$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $72a849f89206feb8$var$clearIndicatorStyles.default,
            isCompact && $72a849f89206feb8$var$clearIndicatorStyles.compact,
            (0, $9h99w.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps
    }, /*#__PURE__*/ $4fqPo.createElement((0, $iqiKs.default), {
        xcss: $72a849f89206feb8$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMwsV))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
};

});

parcelRegister("9xyTL", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $a651a3a26ecd676d$export$ec98719d3db7f2e4);
/* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ /* dropdown-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $cTq8x = parcelRequire("cTq8x");

var $Cp2Ub = parcelRequire("Cp2Ub");

var $lgGqQ = parcelRequire("lgGqQ");
const $a651a3a26ecd676d$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
};
const $a651a3a26ecd676d$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
const $a651a3a26ecd676d$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $a651a3a26ecd676d$var$dropdownStyles.default,
            isDisabled && $a651a3a26ecd676d$var$dropdownStyles.disabled,
            isCompact && $a651a3a26ecd676d$var$dropdownStyles.compact,
            (0, $9h99w.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps
    }, children ? children : /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        as: "span",
        xcss: $a651a3a26ecd676d$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
        color: "currentColor",
        label: "open",
        size: "small"
    })));
};

});

parcelRegister("4oY1b", function(module, exports) {
$parcel$export(module.exports, "LoadingIndicator", () => $cb03427d70498b03$export$7c20be4c1d342248);
/* loading-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ /* loading-indicator.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $5qWT2 = parcelRequire("5qWT2");

var $lgGqQ = parcelRequire("lgGqQ");
const $cb03427d70498b03$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $cb03427d70498b03$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $cb03427d70498b03$var$loadingIndicatorStyles.default,
            isCompact && $cb03427d70498b03$var$loadingIndicatorStyles.compact,
            (0, $9h99w.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        size: "small"
    }));
};

});

parcelRegister("TS4Hw", function(module, exports) {
$parcel$export(module.exports, "default", () => $65ed65f24b399d15$export$2e2bcd8739ae039);
/* input.tsx generated by @compiled/babel-plugin v0.37.1 */ /* input.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $3H4LK = parcelRequire("3H4LK");

var $lgGqQ = parcelRequire("lgGqQ");

var $4y7YU = parcelRequire("4y7YU");
const $65ed65f24b399d15$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $65ed65f24b399d15$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq",
    labellingFFStyles: "_11c8wadc _1mouze3t _195gze3t _1rjcze3t"
};
const $65ed65f24b399d15$var$nativeInputStylesOld = null;
const $65ed65f24b399d15$var$nativeInputStyles = null;
const $65ed65f24b399d15$var$hidden = null;
const $65ed65f24b399d15$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss, isMulti: isMulti } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $4y7YU.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'input', {
        'input-container': true
    });
    const ffTagUplifts = (0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    if ((0, $3H4LK.fg)('platform_fix_input_component_styling')) return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $65ed65f24b399d15$var$inputStyles.root,
            isMulti && ffTagUplifts && $65ed65f24b399d15$var$inputStyles.labellingFFStyles,
            isDisabled && $65ed65f24b399d15$var$inputStyles.disabled,
            (0, $9h99w.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ $4fqPo.createElement("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $65ed65f24b399d15$var$inputStylesOld.root,
            isMulti && ffTagUplifts && $65ed65f24b399d15$var$inputStylesOld.labellingFFStyles,
            isDisabled && $65ed65f24b399d15$var$inputStylesOld.disabled,
            (0, $9h99w.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`
    }, /*#__PURE__*/ $4fqPo.createElement("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$65ed65f24b399d15$export$2e2bcd8739ae039 = $65ed65f24b399d15$var$Input;

});

parcelRegister("2mOvj", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb0ecc3fc21a4fd8$export$2e2bcd8739ae039);
/* menu.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $3H4LK = parcelRequire("3H4LK");

var $lgGqQ = parcelRequire("lgGqQ");
const $eb0ecc3fc21a4fd8$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const $eb0ecc3fc21a4fd8$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $eb0ecc3fc21a4fd8$var$menuStyles.root,
            $eb0ecc3fc21a4fd8$var$menuStyles[placement],
            (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $eb0ecc3fc21a4fd8$var$menuStyles.rootT26Shape,
            (0, $9h99w.cx)(xcss, className, '-menu')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eb0ecc3fc21a4fd8$export$2e2bcd8739ae039 = $eb0ecc3fc21a4fd8$var$Menu;

});

parcelRegister("fUwEA", function(module, exports) {
$parcel$export(module.exports, "MenuList", () => $76ffe999ae4b8b52$export$d4c4e98c5044dc8);
/* menu-list.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-list.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $76ffe999ae4b8b52$var$menuListStyles = null;
const $76ffe999ae4b8b52$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $9h99w.cx)(className, xcss, '-MenuList')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};

});

parcelRegister("a3Led", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $9bcc252e57cc7c28$export$e928a71d039d3102);
/* menu-loading-message.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-loading-message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $ekURY = parcelRequire("ekURY");

var $lgGqQ = parcelRequire("lgGqQ");
const $9bcc252e57cc7c28$var$noticeStyles = null;
const $9bcc252e57cc7c28$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $9h99w.cx)(className, xcss, '-LoadingMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        ...innerProps,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        color: "color.text.subtle"
    }, children));
};

});

parcelRegister("fCsLs", function(module, exports) {
$parcel$export(module.exports, "NoOptionsMessage", () => $314030d3eafecbb8$export$d58b72b7d3c4072c);
/* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-no-options-message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $ekURY = parcelRequire("ekURY");

var $lgGqQ = parcelRequire("lgGqQ");
const $314030d3eafecbb8$var$noticeStyles = null;
const $314030d3eafecbb8$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $9h99w.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlassian/a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        color: "color.text.subtle"
    }, children));
};

});

parcelRegister("7nVta", function(module, exports) {
$parcel$export(module.exports, "MenuPortal", () => $593dd3de874bc1e8$export$793392f970497feb);
/* menu-portal.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-portal.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $kz5VE = parcelRequire("kz5VE");

var $b2Ka1 = parcelRequire("b2Ka1");

var $3H4LK = parcelRequire("3H4LK");

var $lgGqQ = parcelRequire("lgGqQ");

var $a96MM = parcelRequire("a96MM");

var $2VGK4 = parcelRequire("2VGK4");
function $593dd3de874bc1e8$var$getBoundingClientObj(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
const $593dd3de874bc1e8$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $593dd3de874bc1e8$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
};
// eslint-disable-next-line @repo/internal/react/require-jsdoc
function $593dd3de874bc1e8$var$MenuPortalLegacy(props) {
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $4fqPo.useRef)(null);
    const cleanupRef = (0, $4fqPo.useRef)(null);
    const [placement, setPortalPlacement] = (0, $4fqPo.useState)($593dd3de874bc1e8$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $4fqPo.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $4fqPo.useState)(null);
    const updateComputedPosition = (0, $4fqPo.useCallback)(()=>{
        if (!controlElement) return;
        const rect = $593dd3de874bc1e8$var$getBoundingClientObj(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $4fqPo.useLayoutEffect)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $4fqPo.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $kz5VE.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $4fqPo.useLayoutEffect)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $4fqPo.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // Legacy quirk: `computedPosition` is null until the layout effect runs,
    // so the first render returns null even with `defaultMenuIsOpen` set.
    // Synchronous observers (VR snapshots) see a one-frame "closed" state.
    // Left as-is; the top-layer path supersedes this and positions declaratively.
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    });
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $593dd3de874bc1e8$var$menuPortalStyles.root,
            (0, $9h99w.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps
    }, children);
    return /*#__PURE__*/ $4fqPo.createElement((0, $a96MM.PortalPlacementContext).Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $b2Ka1.createPortal)(menuWrapper, appendTo) : menuWrapper);
}
const $593dd3de874bc1e8$export$793392f970497feb = (props)=>{
    if ((0, $3H4LK.fg)('platform-dst-top-layer')) // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $4fqPo.createElement((0, $2VGK4.MenuPortalTopLayer), props);
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ $4fqPo.createElement($593dd3de874bc1e8$var$MenuPortalLegacy, props);
};

});
parcelRegister("kz5VE", function(module, exports) {
$parcel$export(module.exports, "autoUpdate", () => $ef8bace0e5c1d093$export$deee3a793edee05f);

var $5R4Av = parcelRequire("5R4Av");
var $ASZMd = parcelRequire("ASZMd");

var $ASZMd = parcelRequire("ASZMd");

var $9Tfac = parcelRequire("9Tfac");
function $ef8bace0e5c1d093$var$getCssDimensions(element) {
    const css = (0, $9Tfac.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $9Tfac.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $ASZMd.round)(width) !== offsetWidth || (0, $ASZMd.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $ef8bace0e5c1d093$var$unwrapElement(element) {
    return !(0, $9Tfac.isElement)(element) ? element.contextElement : element;
}
function $ef8bace0e5c1d093$var$getScale(element) {
    const domElement = $ef8bace0e5c1d093$var$unwrapElement(element);
    if (!(0, $9Tfac.isHTMLElement)(domElement)) return (0, $ASZMd.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $ef8bace0e5c1d093$var$getCssDimensions(domElement);
    let x = ($ ? (0, $ASZMd.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $ASZMd.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $ef8bace0e5c1d093$var$noOffsets = /*#__PURE__*/ (0, $ASZMd.createCoords)(0);
function $ef8bace0e5c1d093$var$getVisualOffsets(element) {
    const win = (0, $9Tfac.getWindow)(element);
    if (!(0, $9Tfac.isWebKit)() || !win.visualViewport) return $ef8bace0e5c1d093$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $ef8bace0e5c1d093$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $9Tfac.getWindow)(element)) return false;
    return isFixed;
}
function $ef8bace0e5c1d093$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $ef8bace0e5c1d093$var$unwrapElement(element);
    let scale = (0, $ASZMd.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $9Tfac.isElement)(offsetParent)) scale = $ef8bace0e5c1d093$var$getScale(offsetParent);
        } else scale = $ef8bace0e5c1d093$var$getScale(element);
    }
    const visualOffsets = $ef8bace0e5c1d093$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $ef8bace0e5c1d093$var$getVisualOffsets(domElement) : (0, $ASZMd.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $9Tfac.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $9Tfac.isElement)(offsetParent) ? (0, $9Tfac.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $9Tfac.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $ef8bace0e5c1d093$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $9Tfac.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $9Tfac.getWindow)(currentIFrame);
            currentIFrame = (0, $9Tfac.getFrameElement)(currentWin);
        }
    }
    return (0, $ASZMd.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $ef8bace0e5c1d093$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $9Tfac.getNodeScroll)(element).scrollLeft;
    if (!rect) return $ef8bace0e5c1d093$var$getBoundingClientRect((0, $9Tfac.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $ef8bace0e5c1d093$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $ef8bace0e5c1d093$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $ef8bace0e5c1d093$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $9Tfac.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $9Tfac.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $ASZMd.createCoords)(1);
    const offsets = (0, $ASZMd.createCoords)(0);
    const isOffsetParentAnElement = (0, $9Tfac.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9Tfac.getNodeName)(offsetParent) !== 'body' || (0, $9Tfac.isOverflowElement)(documentElement)) scroll = (0, $9Tfac.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $ef8bace0e5c1d093$var$getBoundingClientRect(offsetParent);
            scale = $ef8bace0e5c1d093$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $ef8bace0e5c1d093$var$getHTMLOffset(documentElement, scroll) : (0, $ASZMd.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $ef8bace0e5c1d093$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $ef8bace0e5c1d093$var$getDocumentRect(element) {
    const html = (0, $9Tfac.getDocumentElement)(element);
    const scroll = (0, $9Tfac.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $ASZMd.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $ASZMd.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $ef8bace0e5c1d093$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $9Tfac.getComputedStyle)(body).direction === 'rtl') x += (0, $ASZMd.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $ef8bace0e5c1d093$var$SCROLLBAR_MAX = 25;
function $ef8bace0e5c1d093$var$getViewportRect(element, strategy) {
    const win = (0, $9Tfac.getWindow)(element);
    const html = (0, $9Tfac.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $9Tfac.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $ef8bace0e5c1d093$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $ef8bace0e5c1d093$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $ef8bace0e5c1d093$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $ef8bace0e5c1d093$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $ef8bace0e5c1d093$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $9Tfac.isHTMLElement)(element) ? $ef8bace0e5c1d093$var$getScale(element) : (0, $ASZMd.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $ef8bace0e5c1d093$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $ef8bace0e5c1d093$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $ef8bace0e5c1d093$var$getDocumentRect((0, $9Tfac.getDocumentElement)(element));
    else if ((0, $9Tfac.isElement)(clippingAncestor)) rect = $ef8bace0e5c1d093$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $ef8bace0e5c1d093$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $ASZMd.rectToClientRect)(rect);
}
function $ef8bace0e5c1d093$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $9Tfac.getParentNode)(element);
    if (parentNode === stopNode || !(0, $9Tfac.isElement)(parentNode) || (0, $9Tfac.isLastTraversableNode)(parentNode)) return false;
    return (0, $9Tfac.getComputedStyle)(parentNode).position === 'fixed' || $ef8bace0e5c1d093$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $ef8bace0e5c1d093$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $9Tfac.getOverflowAncestors)(element, [], false).filter((el)=>(0, $9Tfac.isElement)(el) && (0, $9Tfac.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $9Tfac.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $9Tfac.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $9Tfac.isElement)(currentNode) && !(0, $9Tfac.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $9Tfac.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $9Tfac.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $9Tfac.isOverflowElement)(currentNode) && !currentNodeIsContaining && $ef8bace0e5c1d093$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $9Tfac.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $ef8bace0e5c1d093$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $9Tfac.isTopLayer)(element) ? [] : $ef8bace0e5c1d093$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $ef8bace0e5c1d093$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $ef8bace0e5c1d093$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $ASZMd.max)(rect.top, top);
        right = (0, $ASZMd.min)(rect.right, right);
        bottom = (0, $ASZMd.min)(rect.bottom, bottom);
        left = (0, $ASZMd.max)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $ef8bace0e5c1d093$var$getDimensions(element) {
    const { width: width, height: height } = $ef8bace0e5c1d093$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $ef8bace0e5c1d093$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $9Tfac.isHTMLElement)(offsetParent);
    const documentElement = (0, $9Tfac.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $ef8bace0e5c1d093$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $ASZMd.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $ef8bace0e5c1d093$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9Tfac.getNodeName)(offsetParent) !== 'body' || (0, $9Tfac.isOverflowElement)(documentElement)) scroll = (0, $9Tfac.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $ef8bace0e5c1d093$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $ef8bace0e5c1d093$var$getHTMLOffset(documentElement, scroll) : (0, $ASZMd.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $ef8bace0e5c1d093$var$isStaticPositioned(element) {
    return (0, $9Tfac.getComputedStyle)(element).position === 'static';
}
function $ef8bace0e5c1d093$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $9Tfac.isHTMLElement)(element) || (0, $9Tfac.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $9Tfac.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $ef8bace0e5c1d093$var$getOffsetParent(element, polyfill) {
    const win = (0, $9Tfac.getWindow)(element);
    if ((0, $9Tfac.isTopLayer)(element)) return win;
    if (!(0, $9Tfac.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $9Tfac.getParentNode)(element);
        while(svgOffsetParent && !(0, $9Tfac.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $9Tfac.isElement)(svgOffsetParent) && !$ef8bace0e5c1d093$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $9Tfac.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $ef8bace0e5c1d093$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $9Tfac.isTableElement)(offsetParent) && $ef8bace0e5c1d093$var$isStaticPositioned(offsetParent))offsetParent = $ef8bace0e5c1d093$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $9Tfac.isLastTraversableNode)(offsetParent) && $ef8bace0e5c1d093$var$isStaticPositioned(offsetParent) && !(0, $9Tfac.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $9Tfac.getContainingBlock)(element) || win;
}
const $ef8bace0e5c1d093$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $ef8bace0e5c1d093$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $ef8bace0e5c1d093$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $ef8bace0e5c1d093$var$isRTL(element) {
    return (0, $9Tfac.getComputedStyle)(element).direction === 'rtl';
}
const $ef8bace0e5c1d093$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $ef8bace0e5c1d093$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $9Tfac.getDocumentElement,
    getClippingRect: $ef8bace0e5c1d093$var$getClippingRect,
    getOffsetParent: $ef8bace0e5c1d093$var$getOffsetParent,
    getElementRects: $ef8bace0e5c1d093$var$getElementRects,
    getClientRects: $ef8bace0e5c1d093$var$getClientRects,
    getDimensions: $ef8bace0e5c1d093$var$getDimensions,
    getScale: $ef8bace0e5c1d093$var$getScale,
    isElement: $9Tfac.isElement,
    isRTL: $ef8bace0e5c1d093$var$isRTL
};
function $ef8bace0e5c1d093$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $ef8bace0e5c1d093$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $9Tfac.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $ASZMd.floor)(top);
        const insetRight = (0, $ASZMd.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $ASZMd.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $ASZMd.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $ASZMd.max)(0, (0, $ASZMd.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$ef8bace0e5c1d093$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $ef8bace0e5c1d093$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $ef8bace0e5c1d093$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $9Tfac.getOverflowAncestors)(referenceEl) : [],
        ...floating ? (0, $9Tfac.getOverflowAncestors)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $ef8bace0e5c1d093$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $ef8bace0e5c1d093$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $ef8bace0e5c1d093$var$getBoundingClientRect(reference);
        if (prevRefRect && !$ef8bace0e5c1d093$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $ef8bace0e5c1d093$export$37b6bde19b108ecc = (0, $5R4Av.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $ef8bace0e5c1d093$export$cc800923e997bb8 = (0, $5R4Av.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $ef8bace0e5c1d093$export$91fb6ecbd551914 = (0, $5R4Av.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $ef8bace0e5c1d093$export$fba63a578e423eb = (0, $5R4Av.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $ef8bace0e5c1d093$export$8a83211c878a3f1f = (0, $5R4Av.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $ef8bace0e5c1d093$export$346677f925de839c = (0, $5R4Av.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $ef8bace0e5c1d093$export$fe8985bb6374093c = (0, $5R4Av.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $ef8bace0e5c1d093$export$f2120bbfa5450bd2 = (0, $5R4Av.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $ef8bace0e5c1d093$export$18c8ad048e32c7d5 = (0, $5R4Av.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $ef8bace0e5c1d093$export$7bf07e38f3dc4b69 = (0, $5R4Av.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $ef8bace0e5c1d093$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $ef8bace0e5c1d093$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $5R4Av.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};

});
parcelRegister("5R4Av", function(module, exports) {
$parcel$export(module.exports, "detectOverflow", () => $4435760bca6da151$export$37b6bde19b108ecc);
$parcel$export(module.exports, "computePosition", () => $4435760bca6da151$export$48a53dcb22e581d0);
$parcel$export(module.exports, "arrow", () => $4435760bca6da151$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "autoPlacement", () => $4435760bca6da151$export$91fb6ecbd551914);
$parcel$export(module.exports, "flip", () => $4435760bca6da151$export$8a83211c878a3f1f);
$parcel$export(module.exports, "hide", () => $4435760bca6da151$export$fe8985bb6374093c);
$parcel$export(module.exports, "inline", () => $4435760bca6da151$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "offset", () => $4435760bca6da151$export$cc800923e997bb8);
$parcel$export(module.exports, "shift", () => $4435760bca6da151$export$fba63a578e423eb);
$parcel$export(module.exports, "limitShift", () => $4435760bca6da151$export$7bf07e38f3dc4b69);
$parcel$export(module.exports, "size", () => $4435760bca6da151$export$346677f925de839c);
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("ASZMd")).rectToClientRect);

var $ASZMd = parcelRequire("ASZMd");
function $4435760bca6da151$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $ASZMd.getSideAxis)(placement);
    const alignmentAxis = (0, $ASZMd.getAlignmentAxis)(placement);
    const alignLength = (0, $ASZMd.getAxisLength)(alignmentAxis);
    const side = (0, $ASZMd.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $ASZMd.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $4435760bca6da151$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $ASZMd.evaluate)(options, state);
    const paddingObject = (0, $ASZMd.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $ASZMd.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $ASZMd.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $4435760bca6da151$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $4435760bca6da151$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : {
        ...platform,
        detectOverflow: $4435760bca6da151$export$37b6bde19b108ecc
    };
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $4435760bca6da151$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = {
            ...middlewareData[name],
            ...data
        };
        if (reset && resetCount < $4435760bca6da151$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $4435760bca6da151$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $4435760bca6da151$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $ASZMd.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $ASZMd.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $ASZMd.getAlignmentAxis)(placement);
            const length = (0, $ASZMd.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $ASZMd.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $ASZMd.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $ASZMd.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $ASZMd.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $4435760bca6da151$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $ASZMd.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $ASZMd.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $ASZMd.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $ASZMd.getAlignment)(placement) === alignment || (autoAlignment ? (0, $ASZMd.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $4435760bca6da151$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $ASZMd.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $ASZMd.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $ASZMd.placements) ? $4435760bca6da151$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $ASZMd.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $ASZMd.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $ASZMd.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $ASZMd.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $4435760bca6da151$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $ASZMd.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $ASZMd.getSide)(placement);
            const initialSideAxis = (0, $ASZMd.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $ASZMd.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $ASZMd.getOppositePlacement)(initialPlacement)
            ] : (0, $ASZMd.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $ASZMd.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $ASZMd.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $ASZMd.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $ASZMd.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $ASZMd.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $4435760bca6da151$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $4435760bca6da151$var$isAnySideFullyClipped(overflow) {
    return (0, $ASZMd.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $4435760bca6da151$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $ASZMd.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $4435760bca6da151$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $4435760bca6da151$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $4435760bca6da151$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $4435760bca6da151$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4435760bca6da151$var$getBoundingRect(rects) {
    const minX = (0, $ASZMd.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $ASZMd.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $ASZMd.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $ASZMd.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $4435760bca6da151$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $ASZMd.rectToClientRect)($4435760bca6da151$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $4435760bca6da151$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $ASZMd.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $4435760bca6da151$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $ASZMd.rectToClientRect)($4435760bca6da151$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $ASZMd.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $ASZMd.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $ASZMd.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $ASZMd.getSide)(placement) === 'left';
                    const maxRight = (0, $ASZMd.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $ASZMd.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $4435760bca6da151$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $4435760bca6da151$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $ASZMd.getSide)(placement);
    const alignment = (0, $ASZMd.getAlignment)(placement);
    const isVertical = (0, $ASZMd.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $4435760bca6da151$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $ASZMd.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $4435760bca6da151$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $4435760bca6da151$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $4435760bca6da151$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $ASZMd.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $ASZMd.getSideAxis)((0, $ASZMd.getSide)(placement));
            const mainAxis = (0, $ASZMd.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $ASZMd.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $ASZMd.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $4435760bca6da151$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $ASZMd.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $ASZMd.getSideAxis)(placement);
            const mainAxis = (0, $ASZMd.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $ASZMd.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $4435760bca6da151$var$originSides.has((0, $ASZMd.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $4435760bca6da151$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $ASZMd.evaluate)(options, state);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $ASZMd.getSide)(placement);
            const alignment = (0, $ASZMd.getAlignment)(placement);
            const isYAxis = (0, $ASZMd.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $ASZMd.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $ASZMd.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $ASZMd.max)(overflow.left, 0);
                const xMax = (0, $ASZMd.max)(overflow.right, 0);
                const yMin = (0, $ASZMd.max)(overflow.top, 0);
                const yMax = (0, $ASZMd.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $ASZMd.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $ASZMd.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("ASZMd", function(module, exports) {
$parcel$export(module.exports, "sides", () => $06ee05d92aa99d67$export$832b6fa47fa053d2);
$parcel$export(module.exports, "placements", () => $06ee05d92aa99d67$export$803cd8101b6c182b);
$parcel$export(module.exports, "min", () => $06ee05d92aa99d67$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $06ee05d92aa99d67$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $06ee05d92aa99d67$export$2077e0241d6afd3c);
$parcel$export(module.exports, "floor", () => $06ee05d92aa99d67$export$a3fe094919f356fd);
$parcel$export(module.exports, "createCoords", () => $06ee05d92aa99d67$export$a397704b5e280835);
$parcel$export(module.exports, "clamp", () => $06ee05d92aa99d67$export$7d15b64cf5a3a4c4);
$parcel$export(module.exports, "evaluate", () => $06ee05d92aa99d67$export$fef61f332f2c0afc);
$parcel$export(module.exports, "getSide", () => $06ee05d92aa99d67$export$3c915306cb7fc97a);
$parcel$export(module.exports, "getAlignment", () => $06ee05d92aa99d67$export$f0989780f32bfcda);
$parcel$export(module.exports, "getOppositeAxis", () => $06ee05d92aa99d67$export$8a000a963141ac32);
$parcel$export(module.exports, "getAxisLength", () => $06ee05d92aa99d67$export$320bd9d53520c68a);
$parcel$export(module.exports, "getSideAxis", () => $06ee05d92aa99d67$export$f28e8f882010718a);
$parcel$export(module.exports, "getAlignmentAxis", () => $06ee05d92aa99d67$export$2b57e0052a6d6d4c);
$parcel$export(module.exports, "getAlignmentSides", () => $06ee05d92aa99d67$export$be42861551f17911);
$parcel$export(module.exports, "getOppositePlacement", () => $06ee05d92aa99d67$export$9c5e28bad23365fa);
$parcel$export(module.exports, "getExpandedPlacements", () => $06ee05d92aa99d67$export$496432a3699e50b1);
$parcel$export(module.exports, "getOppositeAlignmentPlacement", () => $06ee05d92aa99d67$export$2b182c584985588b);
$parcel$export(module.exports, "getOppositeAxisPlacements", () => $06ee05d92aa99d67$export$a9b6fb18fd92c3ec);
$parcel$export(module.exports, "getPaddingObject", () => $06ee05d92aa99d67$export$598c291c29bc2e71);
$parcel$export(module.exports, "rectToClientRect", () => $06ee05d92aa99d67$export$ee05aea0aeecbad4);
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $06ee05d92aa99d67$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $06ee05d92aa99d67$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $06ee05d92aa99d67$export$803cd8101b6c182b = /*#__PURE__*/ $06ee05d92aa99d67$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $06ee05d92aa99d67$export$27b07d8a310ed8b5[0], side + "-" + $06ee05d92aa99d67$export$27b07d8a310ed8b5[1]), []);
const $06ee05d92aa99d67$export$96ec731ed4dcb222 = Math.min;
const $06ee05d92aa99d67$export$8960430cfd85939f = Math.max;
const $06ee05d92aa99d67$export$2077e0241d6afd3c = Math.round;
const $06ee05d92aa99d67$export$a3fe094919f356fd = Math.floor;
const $06ee05d92aa99d67$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $06ee05d92aa99d67$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $06ee05d92aa99d67$export$7d15b64cf5a3a4c4(start, value, end) {
    return $06ee05d92aa99d67$export$8960430cfd85939f(start, $06ee05d92aa99d67$export$96ec731ed4dcb222(value, end));
}
function $06ee05d92aa99d67$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $06ee05d92aa99d67$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $06ee05d92aa99d67$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $06ee05d92aa99d67$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $06ee05d92aa99d67$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $06ee05d92aa99d67$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $06ee05d92aa99d67$export$2b57e0052a6d6d4c(placement) {
    return $06ee05d92aa99d67$export$8a000a963141ac32($06ee05d92aa99d67$export$f28e8f882010718a(placement));
}
function $06ee05d92aa99d67$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $06ee05d92aa99d67$export$f0989780f32bfcda(placement);
    const alignmentAxis = $06ee05d92aa99d67$export$2b57e0052a6d6d4c(placement);
    const length = $06ee05d92aa99d67$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $06ee05d92aa99d67$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $06ee05d92aa99d67$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $06ee05d92aa99d67$export$496432a3699e50b1(placement) {
    const oppositePlacement = $06ee05d92aa99d67$export$9c5e28bad23365fa(placement);
    return [
        $06ee05d92aa99d67$export$2b182c584985588b(placement),
        oppositePlacement,
        $06ee05d92aa99d67$export$2b182c584985588b(oppositePlacement)
    ];
}
function $06ee05d92aa99d67$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $06ee05d92aa99d67$var$lrPlacement = [
    'left',
    'right'
];
const $06ee05d92aa99d67$var$rlPlacement = [
    'right',
    'left'
];
const $06ee05d92aa99d67$var$tbPlacement = [
    'top',
    'bottom'
];
const $06ee05d92aa99d67$var$btPlacement = [
    'bottom',
    'top'
];
function $06ee05d92aa99d67$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $06ee05d92aa99d67$var$rlPlacement : $06ee05d92aa99d67$var$lrPlacement;
            return isStart ? $06ee05d92aa99d67$var$lrPlacement : $06ee05d92aa99d67$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $06ee05d92aa99d67$var$tbPlacement : $06ee05d92aa99d67$var$btPlacement;
        default:
            return [];
    }
}
function $06ee05d92aa99d67$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $06ee05d92aa99d67$export$f0989780f32bfcda(placement);
    let list = $06ee05d92aa99d67$var$getSideList($06ee05d92aa99d67$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($06ee05d92aa99d67$export$2b182c584985588b));
    }
    return list;
}
function $06ee05d92aa99d67$export$9c5e28bad23365fa(placement) {
    const side = $06ee05d92aa99d67$export$3c915306cb7fc97a(placement);
    return $06ee05d92aa99d67$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $06ee05d92aa99d67$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $06ee05d92aa99d67$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $06ee05d92aa99d67$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $06ee05d92aa99d67$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("9Tfac", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $73350340fc2dfe75$export$651544f548703224);
$parcel$export(module.exports, "getWindow", () => $73350340fc2dfe75$export$38b2d434cce3ea22);
$parcel$export(module.exports, "getDocumentElement", () => $73350340fc2dfe75$export$e495491855dc5418);
$parcel$export(module.exports, "isElement", () => $73350340fc2dfe75$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $73350340fc2dfe75$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isOverflowElement", () => $73350340fc2dfe75$export$989e911fa9af580a);
$parcel$export(module.exports, "getComputedStyle", () => $73350340fc2dfe75$export$3735103072e4a80);
$parcel$export(module.exports, "isTableElement", () => $73350340fc2dfe75$export$71535ffaa902797f);
$parcel$export(module.exports, "isTopLayer", () => $73350340fc2dfe75$export$89e651af02346cd4);
$parcel$export(module.exports, "isContainingBlock", () => $73350340fc2dfe75$export$d6c4e8150c35fed1);
$parcel$export(module.exports, "isWebKit", () => $73350340fc2dfe75$export$78551043582a6a98);
$parcel$export(module.exports, "getContainingBlock", () => $73350340fc2dfe75$export$940d8225183e1404);
$parcel$export(module.exports, "getParentNode", () => $73350340fc2dfe75$export$4e12058fc4d51d56);
$parcel$export(module.exports, "isLastTraversableNode", () => $73350340fc2dfe75$export$d1162fb0b6d4cd51);
$parcel$export(module.exports, "getNodeScroll", () => $73350340fc2dfe75$export$dc8fc79fa2800137);
$parcel$export(module.exports, "getOverflowAncestors", () => $73350340fc2dfe75$export$3b57c1601291186b);
$parcel$export(module.exports, "getFrameElement", () => $73350340fc2dfe75$export$7bf1f8740e3e34af);
function $73350340fc2dfe75$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $73350340fc2dfe75$export$651544f548703224(node) {
    if ($73350340fc2dfe75$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $73350340fc2dfe75$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $73350340fc2dfe75$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($73350340fc2dfe75$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $73350340fc2dfe75$export$8ee0fc9ee280b4ee(value) {
    if (!$73350340fc2dfe75$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $73350340fc2dfe75$export$38b2d434cce3ea22(value).Node;
}
function $73350340fc2dfe75$export$45a5e7f76e0caa8d(value) {
    if (!$73350340fc2dfe75$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $73350340fc2dfe75$export$38b2d434cce3ea22(value).Element;
}
function $73350340fc2dfe75$export$1b3bfaa9684536aa(value) {
    if (!$73350340fc2dfe75$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $73350340fc2dfe75$export$38b2d434cce3ea22(value).HTMLElement;
}
function $73350340fc2dfe75$export$af51f0f06c0f328a(value) {
    if (!$73350340fc2dfe75$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $73350340fc2dfe75$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $73350340fc2dfe75$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $73350340fc2dfe75$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $73350340fc2dfe75$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($73350340fc2dfe75$export$651544f548703224(element));
}
function $73350340fc2dfe75$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $73350340fc2dfe75$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $73350340fc2dfe75$var$containRe = /paint|layout|strict|content/;
const $73350340fc2dfe75$var$isNotNone = (value)=>!!value && value !== 'none';
let $73350340fc2dfe75$var$isWebKitValue;
function $73350340fc2dfe75$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $73350340fc2dfe75$export$45a5e7f76e0caa8d(elementOrCss) ? $73350340fc2dfe75$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $73350340fc2dfe75$var$isNotNone(css.transform) || $73350340fc2dfe75$var$isNotNone(css.translate) || $73350340fc2dfe75$var$isNotNone(css.scale) || $73350340fc2dfe75$var$isNotNone(css.rotate) || $73350340fc2dfe75$var$isNotNone(css.perspective) || !$73350340fc2dfe75$export$78551043582a6a98() && ($73350340fc2dfe75$var$isNotNone(css.backdropFilter) || $73350340fc2dfe75$var$isNotNone(css.filter)) || $73350340fc2dfe75$var$willChangeRe.test(css.willChange || '') || $73350340fc2dfe75$var$containRe.test(css.contain || '');
}
function $73350340fc2dfe75$export$940d8225183e1404(element) {
    let currentNode = $73350340fc2dfe75$export$4e12058fc4d51d56(element);
    while($73350340fc2dfe75$export$1b3bfaa9684536aa(currentNode) && !$73350340fc2dfe75$export$d1162fb0b6d4cd51(currentNode)){
        if ($73350340fc2dfe75$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($73350340fc2dfe75$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $73350340fc2dfe75$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $73350340fc2dfe75$export$78551043582a6a98() {
    if ($73350340fc2dfe75$var$isWebKitValue == null) $73350340fc2dfe75$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $73350340fc2dfe75$var$isWebKitValue;
}
function $73350340fc2dfe75$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($73350340fc2dfe75$export$651544f548703224(node));
}
function $73350340fc2dfe75$export$3735103072e4a80(element) {
    return $73350340fc2dfe75$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $73350340fc2dfe75$export$dc8fc79fa2800137(element) {
    if ($73350340fc2dfe75$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $73350340fc2dfe75$export$4e12058fc4d51d56(node) {
    if ($73350340fc2dfe75$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $73350340fc2dfe75$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $73350340fc2dfe75$export$e495491855dc5418(node);
    return $73350340fc2dfe75$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $73350340fc2dfe75$export$7cd01a57c8ca906c(node) {
    const parentNode = $73350340fc2dfe75$export$4e12058fc4d51d56(node);
    if ($73350340fc2dfe75$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($73350340fc2dfe75$export$1b3bfaa9684536aa(parentNode) && $73350340fc2dfe75$export$989e911fa9af580a(parentNode)) return parentNode;
    return $73350340fc2dfe75$export$7cd01a57c8ca906c(parentNode);
}
function $73350340fc2dfe75$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $73350340fc2dfe75$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $73350340fc2dfe75$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $73350340fc2dfe75$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $73350340fc2dfe75$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $73350340fc2dfe75$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $73350340fc2dfe75$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $73350340fc2dfe75$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

});


parcelRegister("a96MM", function(module, exports) {
$parcel$export(module.exports, "PortalPlacementContext", () => $074e4448fc537a34$export$e001f626511a0ead);

var $4fqPo = parcelRequire("4fqPo");
const $074e4448fc537a34$export$e001f626511a0ead = /*#__PURE__*/ (0, $4fqPo.createContext)(null);

});

parcelRegister("2VGK4", function(module, exports) {
$parcel$export(module.exports, "MenuPortalTopLayer", () => $59570a977e00abfc$export$1f5427c7f5364d0b);
/* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v0.37.1 */ /* menu-portal-top-layer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $1AxDb = parcelRequire("1AxDb");

var $1v8Ej = parcelRequire("1v8Ej");

var $jC6gp = parcelRequire("jC6gp");

var $ldc2k = parcelRequire("ldc2k");

var $lgGqQ = parcelRequire("lgGqQ");

var $e5kSj = parcelRequire("e5kSj");
// `'auto'` falls through to `'end'`; top-layer's `position-try-fallbacks` flips it if needed.
function $59570a977e00abfc$var$reactSelectEdgeToTopLayerEdge(menuPlacement) {
    return menuPlacement === 'top' ? 'start' : 'end';
}
const $59570a977e00abfc$var$menuPortalStyles = {
    root: "_ofie1496"
};
function $59570a977e00abfc$export$1f5427c7f5364d0b(props) {
    const { children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    // Select's "close the menu" callback, distinct from `Popover.onClose`.
    const closeSelect = (0, $4fqPo.useContext)((0, $e5kSj.MenuPortalCloseContext));
    const popoverRef = (0, $4fqPo.useRef)(null);
    // Top-layer hooks need a RefObject; in-render mutation keeps it in sync
    // with the prop without an effect. The hooks re-read `.current` from
    // `isOpen`-keyed layout effects, so a stable ref identity is fine.
    const anchorRef = (0, $4fqPo.useRef)(null);
    anchorRef.current = controlElement;
    // `controlElement` is null on initial mount / SSR until `Select` mirrors
    // its ref into state. While null, every hook below no-ops to avoid DOM
    // reads or registering an unpositioned popover.
    const isAnchored = controlElement !== null;
    // `gap: 0` matches the legacy MenuPortal (no trigger-to-menu gap; the
    // menu root already declares its own `marginBlockStart`). Without this
    // override `useAnchorPosition`'s default 8px gap would diverge visually
    // from the legacy path.
    (0, $jC6gp.useAnchorPosition)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: {
            axis: 'block',
            edge: $59570a977e00abfc$var$reactSelectEdgeToTopLayerEdge(menuPlacement),
            offset: {
                gap: 0
            }
        },
        isOpen: isAnchored
    });
    (0, $ldc2k.useWidthFromAnchor)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        mode: 'match-anchor',
        isOpen: isAnchored
    });
    const handlePopoverClose = (0, $4fqPo.useCallback)(()=>{
        if (closeSelect) closeSelect();
    }, [
        closeSelect
    ]);
    // Explicit observer registration: the outer Popover is intentionally
    // roleless (see Popover comment below), so Popover cannot auto-register
    // from its role. This lets `closeLayers()` (Modal / Drawer) dismiss us.
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        type: 'popup',
        isOpen: isAnchored,
        onClose: handlePopoverClose
    });
    // Top-layer owns positioning; zero offset/rect preserves the consumer
    // styles call shape.
    const { className: className } = (0, $lgGqQ.getStyleProps)({
        ...props,
        offset: 0,
        position: menuPosition,
        rect: {
            left: 0,
            width: 0
        }
    }, 'menuPortal', {
        'menu-portal': true
    });
    // Popover stays mounted and is driven by `isOpen` so its layout-effect
    // teardown (`hidePopover`, observer cleanup, position-hook style reset)
    // runs against a live element. Conditional render would skip that path.
    //
    // `mode="manual"` opts out of native light-dismiss: react-select already
    // owns outside-click and Escape via its own handlers, and the combobox
    // trigger lives in a separate DOM subtree that the spec algorithm cannot
    // see. Matches the pattern in `@atlaskit/datetime-picker`'s MenuTopLayer.
    //
    // The Popover host is intentionally roleless: the inner `MenuList`
    // keeps `role="listbox"` and the id referenced by `aria-controls`.
    // Putting the role on the outer host caused Playwright `toBeVisible`
    // and some SR hit-testing to treat it as hidden (zero bounding rect
    // while `styles.root` opts out of UA `[popover]` positioning).
    //
    // TODO: add open / close animation. Select unmounts MenuPortalTopLayer
    // the moment `menuIsOpen` flips false, so Popover's `animate` exit
    // transition never gets a frame. Needs keeping the portal mounted
    // through the exit (`onExitFinish`) on the Select side.
    return /*#__PURE__*/ $4fqPo.createElement((0, $1v8Ej.Popover), {
        ref: popoverRef,
        mode: "manual",
        isOpen: isAnchored,
        onClose: handlePopoverClose
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        // `className` carries consumer `styles.menuPortal({...})` output,
        // `xcss` carries caller compiled atomic classes, and `-MenuPortal`
        // is a legacy selector hook kept for parity with MenuPortalLegacy.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss, @typescript-eslint/no-explicit-any
        className: (0, $ltgDR.default)([
            $59570a977e00abfc$var$menuPortalStyles.root,
            (0, $9h99w.cx)(className, xcss, '-MenuPortal')
        ]),
        ...innerProps
    }, children));
}

});
parcelRegister("e5kSj", function(module, exports) {
$parcel$export(module.exports, "MenuPortalCloseContext", () => $cb2dd9b40e6ed9f7$export$a0d5b29fa9affc38);

var $4fqPo = parcelRequire("4fqPo");
const $cb2dd9b40e6ed9f7$export$a0d5b29fa9affc38 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});



parcelRegister("2XuFo", function(module, exports) {
$parcel$export(module.exports, "default", () => $4be76edfa59ff714$export$2e2bcd8739ae039);
/* multi-value.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $3H4LK = parcelRequire("3H4LK");

var $hQRBf = parcelRequire("hQRBf");

var $lgGqQ = parcelRequire("lgGqQ");

var $kvJ0Y = parcelRequire("kvJ0Y");

var $34OYD = parcelRequire("34OYD");

var $hH5l6 = parcelRequire("hH5l6");
const $4be76edfa59ff714$var$multiValueTagWrapperStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1mouze3t _195gze3t _4cvr1h6o _1e0c1txw _1ul9ze3t _zdxokb7n _v5ynkb7n _13lsf1ug _3pxh1h6o _d0dz1txw _1ouwze3t"
};
// Tag-like color styles
const $4be76edfa59ff714$var$tagLikeColorStyles = {
    gray: "_119bmsup",
    blue: "_119b18hp",
    green: "_119b5d2u",
    red: "_119bn9dc",
    yellow: "_119b1s7j",
    purple: "_119bluwt",
    lime: "_119b1m7d",
    magenta: "_119b132u",
    orange: "_119b1ip5",
    teal: "_119b131p"
};
const $4be76edfa59ff714$var$tagLikeBorderFilterStyles = null;
// Tag-like styles for custom content values (not plain text) when FF is on.
// Mirrors the TagNew component's visual appearance (padding, margins, sizing, colors).
// The container uses tag-like styling while Label/Remove sub-components are preserved
// so custom overrides (e.g. custom aria-labels, rendering objects as data) continue to work.
const $4be76edfa59ff714$var$multiValueTagLikeStyles = {
    root: "_1reo15vq _18m915vq _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1mouze3t _195gze3t _1e0c116y _vchhusvi _kqswh2mm _4cvr1h6o _1wpz1h6o _1ul9ze3t _1o9zkb7n _p12ff6dh _4t3i1k92 _bfhksm61 _syazi7uo _80om73ad _3yq3glyw",
    labelWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _11c8wadc _1e0c1txw _4cvr1h6o _1ul9ze3t _1tkeidpf _2a9v1kw7",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk1dpa _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $4be76edfa59ff714$var$getMultiValueLabelText = (children, data)=>{
    if (typeof children === 'string') return children;
    const label = data === null || data === void 0 ? void 0 : data.label;
    return typeof label === 'string' ? label : '';
};
const $4be76edfa59ff714$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const labelText = $4be76edfa59ff714$var$getMultiValueLabelText(children, data);
    const isPlainLabel = typeof children === 'string';
    const ffTagUplifts = (0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    const { css: containerCss, className: containerClassName } = (0, $lgGqQ.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $lgGqQ.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $lgGqQ.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    const hasCustomLabel = Label !== (0, $hH5l6.MultiValueLabel);
    const hasCustomContainer = Container !== (0, $34OYD.MultiValueContainer);
    const selectStyles = selectProps.styles;
    const hasCustomMultiValueStyles = Boolean((selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValue) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueLabel) || (selectStyles === null || selectStyles === void 0 ? void 0 : selectStyles.multiValueRemove));
    const selectClassNames = selectProps.classNames;
    const hasCustomMultiValueClassNames = Boolean((selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValue) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueLabel) || (selectClassNames === null || selectClassNames === void 0 ? void 0 : selectClassNames.multiValueRemove));
    // Detect if getStyles was overridden directly on this component instance (e.g. via the
    // components prop wrapper passing a custom getStyles). The context holds the original
    // Select instance's getStyles — a reference inequality means a custom override was passed.
    // When context is absent (e.g. in mocked/test contexts), assume no override.
    const selectGetStyles = (0, $kvJ0Y.useSelectGetStyles)();
    const hasOverriddenGetStyles = selectGetStyles !== undefined && props.getStyles !== selectGetStyles;
    const hasCustomContainerStyles = hasCustomMultiValueStyles || hasCustomMultiValueClassNames || hasOverriddenGetStyles;
    if (ffTagUplifts && isPlainLabel && !hasCustomLabel && !hasCustomContainer && !hasCustomContainerStyles) {
        const { elemBefore: elemBefore, color: tagColor } = data ?? {};
        return /*#__PURE__*/ $4fqPo.createElement("div", {
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $ltgDR.default)([
                $4be76edfa59ff714$var$multiValueTagWrapperStyles.root,
                (0, $9h99w.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }, /*#__PURE__*/ $4fqPo.createElement((0, $hQRBf.default), {
            text: labelText,
            isRemovable: !isDisabled,
            removeButtonLabel: `${labelText}, remove`,
            onBeforeRemoveAction: ()=>{
                var _removeProps$onClick;
                (_removeProps$onClick = removeProps.onClick) === null || _removeProps$onClick === void 0 || _removeProps$onClick.call(removeProps, {});
                return false;
            },
            color: tagColor ?? 'gray',
            elemBefore: elemBefore,
            hasMargin: false
        }));
    }
    // FF on + custom content → tag-like path
    if (ffTagUplifts && !hasCustomContainer) {
        const colorKey = data === null || data === void 0 ? void 0 : data.color;
        return /*#__PURE__*/ $4fqPo.createElement("div", {
            "data-multi-value-tag-like": "true",
            ...innerProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- custom styles.multiValue overrides (e.g. colored borders) must be preserved
            style: containerCss,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
            className: (0, $ltgDR.default)([
                $4be76edfa59ff714$var$multiValueTagLikeStyles.root,
                $4be76edfa59ff714$var$tagLikeColorStyles.gray,
                colorKey === 'blue' && $4be76edfa59ff714$var$tagLikeColorStyles.blue,
                colorKey === 'green' && $4be76edfa59ff714$var$tagLikeColorStyles.green,
                colorKey === 'red' && $4be76edfa59ff714$var$tagLikeColorStyles.red,
                colorKey === 'yellow' && $4be76edfa59ff714$var$tagLikeColorStyles.yellow,
                colorKey === 'purple' && $4be76edfa59ff714$var$tagLikeColorStyles.purple,
                colorKey === 'lime' && $4be76edfa59ff714$var$tagLikeColorStyles.lime,
                colorKey === 'magenta' && $4be76edfa59ff714$var$tagLikeColorStyles.magenta,
                colorKey === 'orange' && $4be76edfa59ff714$var$tagLikeColorStyles.orange,
                colorKey === 'teal' && $4be76edfa59ff714$var$tagLikeColorStyles.teal,
                "_1h6dip4g",
                isDisabled && $4be76edfa59ff714$var$multiValueTagLikeStyles.disabled,
                isFocused && $4be76edfa59ff714$var$multiValueTagLikeStyles.focused,
                (0, $9h99w.cx)(props.className, containerClassName, props.xcss, '-multiValue')
            ])
        }, /*#__PURE__*/ $4fqPo.createElement("div", {
            className: (0, $ltgDR.default)([
                $4be76edfa59ff714$var$multiValueTagLikeStyles.labelWrapper
            ])
        }, /*#__PURE__*/ $4fqPo.createElement(Label, {
            data: data,
            innerProps: {
                style: labelCss,
                className: labelClassName
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: labelClassName,
            hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
            selectProps: selectProps
        }, children)), /*#__PURE__*/ $4fqPo.createElement(Remove, {
            data: data,
            innerProps: {
                style: removeCss,
                className: removeClassName,
                role: 'button',
                tabIndex: -1,
                'aria-label': `${labelText || 'option'}, remove`,
                ...removeProps
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: removeClassName,
            isDisabled: isDisabled,
            selectProps: selectProps
        }));
    }
    // FF off → default styles
    return /*#__PURE__*/ $4fqPo.createElement(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $4fqPo.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $4fqPo.createElement(Remove, {
        data: data,
        innerProps: {
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': `${labelText || 'option'}, remove`,
            ...removeProps
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4be76edfa59ff714$export$2e2bcd8739ae039 = $4be76edfa59ff714$var$MultiValue;

});
parcelRegister("hQRBf", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e0012d1d2dd6061$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9rkxa = parcelRequire("9rkxa");

var $5wgou = parcelRequire("5wgou");

var $c1tmZ = parcelRequire("c1tmZ");

var $9qmTW = parcelRequire("9qmTW");

var $eO5yD = parcelRequire("eO5yD");
var $hJvsu = parcelRequire("hJvsu");

var $3H4LK = parcelRequire("3H4LK");
parcelRequire("e6mBg");
var $aVeDG = parcelRequire("aVeDG");
var $e6mBg = parcelRequire("e6mBg");

var $aViyV = parcelRequire("aViyV");

var $q39rQ = parcelRequire("q39rQ");

var $1GUMH = parcelRequire("1GUMH");

var $a6y6t = parcelRequire("a6y6t");

var $6czJH = parcelRequire("6czJH");

var $83RtZ = parcelRequire("83RtZ");
const $8e0012d1d2dd6061$var$textLinkCssVar = '--ds-ctl';
const $8e0012d1d2dd6061$var$textDefaultCssVar = '--ds-ct';
const $8e0012d1d2dd6061$var$textActiveCssVar = '--ds-ctp';
const $8e0012d1d2dd6061$var$backgroundHoverCssVar = '--ds-cbh';
const $8e0012d1d2dd6061$var$backgroundActiveCssVar = '--ds-cba';
var $8e0012d1d2dd6061$var$TagStatus = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}($8e0012d1d2dd6061$var$TagStatus || {});
const $8e0012d1d2dd6061$var$packageName = undefined;
const $8e0012d1d2dd6061$var$packageVersion = undefined;
const $8e0012d1d2dd6061$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $8e0012d1d2dd6061$var$removingStyles = null;
const $8e0012d1d2dd6061$var$RemovableTagComponent = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $8e0012d1d2dd6061$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $c1tmZ.default), linkComponent: linkComponent, migration_fallback: migration_fallback, maxWidth: maxWidth, hasMargin: hasMargin = true, swatchBefore: swatchBefore, ...rest }, ref)=>{
    const [status, setStatus] = (0, $4fqPo.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $4fqPo.useState)(false);
    const normalizedText = (0, $aViyV.getTagText)(text);
    const onAfterRemoveActionWithAnalytics = (0, $9rkxa.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $8e0012d1d2dd6061$var$packageName,
            packageVersion: $8e0012d1d2dd6061$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $4fqPo.useCallback)(()=>{
        setStatus("removed");
    }, []);
    const handleRemoveRequest = (0, $4fqPo.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) {
            onAfterRemoveActionWithAnalytics(normalizedText);
            handleRemoveComplete();
        }
    }, [
        handleRemoveComplete,
        normalizedText,
        onBeforeRemoveAction,
        onAfterRemoveActionWithAnalytics
    ]);
    const onKeyPress = (0, $4fqPo.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $4fqPo.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $4fqPo.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $4fqPo.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $4fqPo.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ $4fqPo.createElement((0, $83RtZ.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${normalizedText}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    // Handle migration_fallback: render Lozenge when flag is off and migration_fallback is 'lozenge'
    if (migration_fallback === 'lozenge' && !(0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const lozengeAppearance = (0, $a6y6t.getLozengeAppearance)(color);
        return /*#__PURE__*/ $4fqPo.createElement((0, $9qmTW.default), {
            appearance: lozengeAppearance,
            isBold: false,
            testId: testId,
            ...rest
        }, normalizedText);
    }
    // Use new TagNew component behind feature flag
    // TagNew handles its own animation internally via RemovableWrapper
    if ((0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const newColor = (0, $aVeDG.colorMapping)[color || 'standard'];
        return /*#__PURE__*/ $4fqPo.createElement((0, $e6mBg.default), {
            ref: ref,
            color: newColor,
            text: normalizedText,
            elemBefore: elemBefore,
            href: href,
            testId: testId,
            isRemovable: isRemovable,
            removeButtonLabel: removeButtonLabel,
            onBeforeRemoveAction: onBeforeRemoveAction,
            onAfterRemoveAction: onAfterRemoveActionWithAnalytics,
            maxWidth: maxWidth,
            hasMargin: hasMargin,
            swatchBefore: swatchBefore
        });
    }
    // Original implementation
    const content = /*#__PURE__*/ $4fqPo.createElement((0, $6czJH.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: normalizedText,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
        // Tag background color on hover
        [$8e0012d1d2dd6061$var$backgroundHoverCssVar]: undefined,
        // Tag background color on press
        [$8e0012d1d2dd6061$var$backgroundActiveCssVar]: undefined,
        // The tag text on hover of remove button
        [$8e0012d1d2dd6061$var$textDefaultCssVar]: undefined,
        // 'elemBefore' text on press of remove button
        [$8e0012d1d2dd6061$var$textActiveCssVar]: undefined,
        // The tag link text on hover of remove button
        [$8e0012d1d2dd6061$var$textLinkCssVar]: undefined
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $eO5yD.default), null, !(status === "removed") && /*#__PURE__*/ $4fqPo.createElement((0, $hJvsu.default), {
        key: "atlaskit-removable-tag-legacy-shrink-out",
        onFinish: handleRemoveComplete
    }, (motion)=>{
        return /*#__PURE__*/ $4fqPo.createElement((0, $q39rQ.default), {
            ref: (0, $5wgou.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ $4fqPo.createElement((0, $1GUMH.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton,
            className: (0, $ltgDR.default)([
                status === "removing" && "_z30c1r31 _twwiglyw _1pka1o36 _bqhtfiwo"
            ])
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $8e0012d1d2dd6061$var$RemovableTag = /*#__PURE__*/ (0, $4fqPo.memo)($8e0012d1d2dd6061$var$RemovableTagComponent);
var $8e0012d1d2dd6061$export$2e2bcd8739ae039 = $8e0012d1d2dd6061$var$RemovableTag;

});
parcelRegister("9rkxa", function(module, exports) {
$parcel$export(module.exports, "useCallbackWithAnalytics", () => $680a5d2c8779567b$export$53c2b9c37c40e0d8);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $kjnaA = parcelRequire("kjnaA");
const $680a5d2c8779567b$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const methodRef = (0, $kjnaA.useTrackedRef)(method);
    const payloadRef = (0, $kjnaA.useTrackedRef)(payload);
    return (0, $4fqPo.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("9qmTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $c643a5994ad4190c$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3H4LK = parcelRequire("3H4LK");

var $RCANU = parcelRequire("RCANU");
/**
 * TODO: We should be using our bounded `cssMap` here, but most of
 * these styles from the visual refresh are not in the Design System.
 */ const $c643a5994ad4190c$var$styles = {
    container: "_2rkofajl _1reo15vq _18m915vq _1e0c116y _vchhusvi _kqswpfqs _1kz6184x _bozg1b66 _y4ti1b66",
    containerSubtle: "_1cwg1n1a",
    text: "_1reo15vq _18m915vq _ect4ttxp _1wyb1skh _zg8l4jg8 _k48pwu06 _vwz47vkz _1bto1l2s _1p1dangw _o5721q9c",
    customLetterspacing: "_1dyz9vsi",
    'bg.bold.default': "_bfhk1fkg",
    'bg.bold.inprogress': "_bfhk1ymo",
    'bg.bold.moved': "_bfhkxmjf",
    'bg.bold.new': "_bfhkshej",
    'bg.bold.removed': "_bfhk1366",
    'bg.bold.success': "_bfhk3uhp",
    'bg.subtle.default': "_bfhksm61",
    'bg.subtle.inprogress': "_bfhksm61",
    'bg.subtle.moved': "_bfhksm61",
    'bg.subtle.new': "_bfhksm61",
    'bg.subtle.removed': "_bfhksm61",
    'bg.subtle.success': "_bfhksm61",
    'outline.subtle.default': "_12ji14je _1qu2nqa1 _12y3t94y",
    'outline.subtle.inprogress': "_12jiuisw _1qu2nqa1 _12y3t94y",
    'outline.subtle.moved': "_12jih727 _1qu2nqa1 _12y3t94y",
    'outline.subtle.new': "_12ji157s _1qu2nqa1 _12y3t94y",
    'outline.subtle.removed': "_12jia2c0 _1qu2nqa1 _12y3t94y",
    'outline.subtle.success': "_12jin0nx _1qu2nqa1 _12y3t94y",
    'text.subtle': "_syazi7uo",
    'text.bold': "_syazwwip"
};
const $c643a5994ad4190c$var$appearanceTypes = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed'
];
const $c643a5994ad4190c$var$newSemanticColors = [
    'success',
    'discovery',
    'warning',
    'danger',
    'information',
    'neutral'
];
const $c643a5994ad4190c$var$appearanceMapping = {
    neutral: 'default',
    default: 'default',
    information: 'inprogress',
    inprogress: 'inprogress',
    warning: 'moved',
    moved: 'moved',
    removed: 'removed',
    danger: 'removed',
    success: 'success',
    discovery: 'new',
    new: 'new'
};
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $c643a5994ad4190c$var$LegacyLozenge = /*#__PURE__*/ (0, $4fqPo.memo)(({ children: children, testId: testId, isBold: isBold = false, appearance: appearance = 'default', maxWidth: maxWidth = 200, style: style })=>{
    const appearanceStyle = isBold ? 'bold' : 'subtle';
    const appearanceType = (0, $4fqPo.useMemo)(()=>$c643a5994ad4190c$var$appearanceTypes.includes(appearance) || $c643a5994ad4190c$var$newSemanticColors.includes(appearance) ? $c643a5994ad4190c$var$appearanceMapping[appearance] : 'default', [
        appearance
    ]);
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        style: {
            backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
            maxWidth: maxWidthIsPc ? maxWidth : '100%'
        },
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            $c643a5994ad4190c$var$styles.container,
            $c643a5994ad4190c$var$styles[`bg.${appearanceStyle}.${appearanceType}`],
            appearanceStyle === 'subtle' && $c643a5994ad4190c$var$styles[`outline.subtle.${appearanceType}`],
            appearanceStyle === 'subtle' && $c643a5994ad4190c$var$styles.containerSubtle
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("span", {
        style: {
            color: style === null || style === void 0 ? void 0 : style.color,
            // to negate paddingInline specified on Box above
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
        },
        "data-testid": testId && `${testId}--text`,
        className: (0, $ltgDR.default)([
            $c643a5994ad4190c$var$styles.text,
            (0, $3H4LK.fg)('platform-lozenge-custom-letterspacing') && $c643a5994ad4190c$var$styles.customLetterspacing,
            $c643a5994ad4190c$var$styles[`text.${appearanceStyle}`]
        ])
    }, children));
});
$c643a5994ad4190c$var$LegacyLozenge.displayName = 'Lozenge';
/**
 * Wrapper component that switches between old and new Lozenge based on feature flag
 */ const $c643a5994ad4190c$var$LozengeWrapper = /*#__PURE__*/ (0, $4fqPo.memo)((props)=>{
    if ((0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) return /*#__PURE__*/ $4fqPo.createElement((0, $RCANU.default), props);
    return /*#__PURE__*/ $4fqPo.createElement($c643a5994ad4190c$var$LegacyLozenge, props);
});
$c643a5994ad4190c$var$LozengeWrapper.displayName = 'Lozenge';
var $c643a5994ad4190c$export$2e2bcd8739ae039 = $c643a5994ad4190c$var$LozengeWrapper;

});
parcelRegister("RCANU", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c2ee127d711a9b7$export$2e2bcd8739ae039);
/* lozenge.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $iSjfj = parcelRequire("iSjfj");
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */ const $7c2ee127d711a9b7$var$Lozenge = ({ appearance: appearance = 'neutral', spacing: spacing = 'default', maxWidth: maxWidth = 200, style: style, testId: testId, children: children, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance })=>{
    const baseProps = {
        appearance: appearance,
        spacing: spacing,
        iconBefore: iconBefore,
        trailingMetric: trailingMetric,
        trailingMetricAppearance: trailingMetricAppearance,
        maxWidth: maxWidth,
        style: style,
        testId: testId,
        children: children
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $iSjfj.default), baseProps, children);
};
$7c2ee127d711a9b7$var$Lozenge.displayName = 'Lozenge';
var $7c2ee127d711a9b7$export$2e2bcd8739ae039 = $7c2ee127d711a9b7$var$Lozenge;

});
parcelRegister("iSjfj", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8a0aed7b7d2949e$export$2e2bcd8739ae039);
/* lozenge-base.tsx generated by @compiled/babel-plugin v0.37.1 */ /* lozenge-base.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $68JOj = parcelRequire("68JOj");

var $fxmw9 = parcelRequire("fxmw9");

var $cTq8x = parcelRequire("cTq8x");

var $fMVPx = parcelRequire("fMVPx");

var $3H4LK = parcelRequire("3H4LK");

var $82vM7 = parcelRequire("82vM7");

var $5qWT2 = parcelRequire("5qWT2");

var $1pWeE = parcelRequire("1pWeE");

var $3IjYG = parcelRequire("3IjYG");

var $8zEnZ = parcelRequire("8zEnZ");
// Get the pressed background color for the selected lozenge dropdown trigger
const $c8a0aed7b7d2949e$var$pressedBackgroundMapping = {
    success: "var(--ds-background-success-subtler-pressed, #B3DF72)",
    warning: "var(--ds-background-warning-subtler-pressed, #FBC828)",
    danger: "var(--ds-background-danger-subtler-pressed, #FD9891)",
    information: "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    neutral: "var(--ds-background-neutral-pressed, #080F214A)",
    discovery: "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'accent-red': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'accent-orange': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'accent-yellow': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'accent-lime': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'accent-green': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'accent-teal': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'accent-blue': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'accent-purple': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'accent-magenta': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'accent-gray': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)"
};
const $c8a0aed7b7d2949e$var$styles = {
    container: "_2rko12b0 _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1j28 _kqswh2mm _1e0c116y _4cvr1h6o _vchhusvi _4t3i1k92 _1q51v77o _85i5v77o _bozg1b66 _y4ti1b66",
    motionContainer: "_k8m01rje _1oeci9qs _6fl41d08",
    containerSpacious: "_2rko1qi0 _1tkeviql _1q511b66 _85i51b66 _bozgutpp _y4tiutpp",
    containerBadgePadding: "_y4ti303w",
    text: "_11c8wadc _1reo15vq _18m915vq _o5721q9c",
    textEllipsis: "_1bto1l2s",
    textClip: "_1btozryt",
    textSpacious: "_11c8fhey _k48p1wq8",
    textSelected: "_syaz6x5g",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw",
    metricBadgeWrapper: "_1e0c1txw",
    'semantic.success': "_3wu02gvx _bfhk14j0 _syaz1p1e",
    'semantic.warning': "_3wu01wfx _bfhk10f4 _syazmgs1",
    'semantic.danger': "_3wu01mzp _bfhk18wg _syaz1blx",
    'semantic.information': "_3wu0wn4u _bfhk8lbg _syaz1qd9",
    'semantic.neutral': "_3wu01l7x _bfhki8nm _syazi7uo",
    'semantic.discovery': "_3wu019v3 _bfhke670 _syaz1g72",
    'accent.red': "_3wu0n9dc _bfhk1rtt _syazhwvp",
    'accent.orange': "_3wu01ip5 _bfhk165s _syaz7i1p",
    'accent.yellow': "_3wu01s7j _bfhk1773 _syazekll",
    'accent.lime': "_3wu01m7d _bfhkz2ec _syaz1ik3",
    'accent.green': "_3wu05d2u _bfhk1wnw _syaz1y78",
    'accent.teal': "_3wu0131p _bfhk1a17 _syaz12v7",
    'accent.blue': "_3wu018hp _bfhk1dy8 _syaz1kyx",
    'accent.purple': "_3wu0luwt _bfhk1nm4 _syaz1mn1",
    'accent.magenta': "_3wu0132u _bfhkv9ra _syaz1qur",
    'accent.gray': "_3wu01l7x _bfhkysee _syaz1tmo",
    'interactive.semantic.success': "_irr31r82 _1di6d6jc",
    'interactive.semantic.warning': "_irr31yx4 _1di6bkku",
    'interactive.semantic.danger': "_irr370oi _1di6jkmi",
    'interactive.semantic.information': "_irr315aw _1di6ar1y",
    'interactive.semantic.neutral': "_irr3plhp _1di61gdz",
    'interactive.semantic.discovery': "_irr3rumk _1di65usi",
    'interactive.accent.red': "_irr3affd _1di61j5a",
    'interactive.accent.orange': "_irr31ei0 _1di6dpo3",
    'interactive.accent.yellow': "_irr31uw7 _1di61r9w",
    'interactive.accent.lime': "_irr31gf0 _1di62kxc",
    'interactive.accent.green': "_irr31e2h _1di6ybhx",
    'interactive.accent.teal': "_irr3kwwr _1di61jb0",
    'interactive.accent.blue': "_irr3815t _1di6rwxf",
    'interactive.accent.purple': "_irr3attl _1di63nfk",
    'interactive.accent.magenta': "_irr31axx _1di642ri",
    'interactive.accent.gray': "_irr3wejn _1di618ut",
    iconBorderFilter: "_1h6d74of",
    content: "_zulp1b66 _1e0c116y _4cvr1h6o",
    maxWidth: "_p12f1osq",
    contentSpacious: "_zulp12x7",
    loadingContent: "_tzy4idpf",
    containerBadgePressed: "_1axmtoke _17i7toke",
    containerBadgeNeutralAppearance: "_1ftrnkaw _1axmnkaw _17i7nkaw"
};
/**
 * __New Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 * This is the updated version with the new North Star visual language.
 */ const $c8a0aed7b7d2949e$var$LozengeBase = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, testId: testId, appearance: appearance, iconBefore: iconBefore, trailingMetric: trailingMetric, trailingMetricAppearance: trailingMetricAppearance, maxWidth: maxWidth = 200, spacing: spacing = 'default', isSelected: isSelected, isLoading: // for dropdown trigger
isLoading = false, onClick: // for dropdown trigger
onClick, style: // for dropdown trigger
style, analyticsContext: analyticsContext, interactionName: interactionName, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, 'aria-label': ariaLabel }, ref)=>{
    const [resizing, setResizing] = (0, $4fqPo.useState)(false);
    const onFinishMotion = ()=>setResizing(false);
    const resizingWidth = (0, $fMVPx.useResizing)({
        dimension: 'width',
        duration: "var(--ds-duration-medium, 200ms)",
        easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))",
        onFinishMotion: onFinishMotion
    });
    const isInitialRender = (0, $4fqPo.useRef)(true);
    const isInteractive = typeof onClick === 'function';
    // Determine the effective color, with fallback logic for legacy appearances
    const resolvedColor = (0, $8zEnZ.resolveLozengeColor)(appearance) || 'neutral';
    const { category: category, key: key } = (0, $1pWeE.getThemeStyles)(resolvedColor);
    const colorStyleKey = `${category}.${key}`;
    const interactiveStyleKey = `interactive.${category}.${key}`;
    const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
    const maxWidthIsPc = typeof maxWidth === 'string' && maxWidth.endsWith('%');
    const resolvedTrailingMetricAppearance = trailingMetricAppearance ? trailingMetricAppearance === 'inverse' ? 'inverse' : (0, $8zEnZ.resolveLozengeColor)(trailingMetricAppearance) : resolvedColor;
    // Map the resolved trailing metric appearance to a Badge appearance.
    // Semantic colors map to their new bold variants (e.g. successBold),
    // which provide sufficient color emphasis on top of the subtler
    // lozenge background. Accent colors and unknown values fall back to
    // the neutral appearance.
    const metricBadgeAppearance = (()=>{
        if (resolvedTrailingMetricAppearance === 'inverse') return 'inverse';
        if (resolvedTrailingMetricAppearance == null) return 'neutral';
        if (resolvedTrailingMetricAppearance.startsWith('accent-')) return 'neutral';
        switch(resolvedTrailingMetricAppearance){
            case 'success':
                return 'successBold';
            case 'warning':
                return 'warningBold';
            case 'danger':
                return 'dangerBold';
            case 'information':
                return 'informationBold';
            case 'discovery':
                return 'discoveryBold';
            case 'neutral':
            default:
                return 'neutral';
        }
    })();
    const commonStyleOverrides = {
        backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
        // Constrain the container to the smaller of the explicit maxWidth and 100% of
        // the parent. Using min(...) means the lozenge never overflows its parent,
        // while still honouring the explicit maxWidth prop when the parent is wider.
        maxWidth: maxWidthIsPc ? maxWidth : `min(${maxWidthValue}, 100%)`
    };
    const hasTrailingMetric = trailingMetric != null && trailingMetric !== '';
    const childrenKey = typeof children === 'string' ? children : undefined;
    (0, $4fqPo.useLayoutEffect)(()=>{
        // Ignore initial render
        if (isInitialRender.current) {
            isInitialRender.current = false;
            return;
        }
        setResizing(true);
    }, [
        childrenKey
    ]);
    const enableMotionFG = (0, $3H4LK.fg)('platform-dst-motion-uplift');
    const innerContent = /*#__PURE__*/ $4fqPo.createElement("span", {
        ...enableMotionFG ? resizingWidth : undefined,
        className: (0, $ltgDR.default)([
            $c8a0aed7b7d2949e$var$styles.content,
            spacing === 'spacious' && $c8a0aed7b7d2949e$var$styles.contentSpacious,
            isLoading && $c8a0aed7b7d2949e$var$styles.loadingContent,
            // Constrain the content wrapper to its container so text truncation
            // works correctly within the flex layout, regardless of whether maxWidth
            // is a percentage, fixed value, or the parent container is narrower than
            // the explicit maxWidth.
            $c8a0aed7b7d2949e$var$styles.maxWidth
        ])
    }, iconBefore && /*#__PURE__*/ $4fqPo.createElement((0, $3IjYG.default), {
        size: spacing === 'spacious' ? 'medium' : 'small',
        icon: iconBefore,
        color: resolvedColor,
        testId: testId && `${testId}--icon`
    }), /*#__PURE__*/ $4fqPo.createElement("span", {
        style: {
            // The text fills 100% of the inner content wrapper. The container's
            // own max-width (set on the container via commonStyleOverrides) handles
            // the actual size constraint, so the text just needs to fill the available
            // space and truncate when it overflows.
            maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        "data-testid": testId && `${testId}--text`,
        className: (0, $ltgDR.default)([
            $c8a0aed7b7d2949e$var$styles.text,
            enableMotionFG && resizing && !maxWidth ? $c8a0aed7b7d2949e$var$styles.textClip : $c8a0aed7b7d2949e$var$styles.textEllipsis,
            spacing === 'spacious' && $c8a0aed7b7d2949e$var$styles.textSpacious
        ])
    }, children), hasTrailingMetric && !resolvedColor.startsWith('accent-') && /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-lozenge-metric-wrapper": true,
        "data-testid": testId && `${testId}--metric`,
        className: (0, $ltgDR.default)([
            $c8a0aed7b7d2949e$var$styles.metricBadgeWrapper
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $68JOj.default), {
        appearance: metricBadgeAppearance
    }, trailingMetric)), isInteractive && /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && `${testId}--chevron`
    }));
    if (isInteractive) return /*#__PURE__*/ $4fqPo.createElement((0, $82vM7.default), {
        ref: ref,
        xcss: (0, $fxmw9.cx)($c8a0aed7b7d2949e$var$styles.container, (0, $3H4LK.fg)('platform-dst-motion-uplift') && $c8a0aed7b7d2949e$var$styles.motionContainer, spacing === 'spacious' && $c8a0aed7b7d2949e$var$styles.containerSpacious, !isSelected && $c8a0aed7b7d2949e$var$styles.iconBorderFilter, $c8a0aed7b7d2949e$var$styles[colorStyleKey], !isLoading && $c8a0aed7b7d2949e$var$styles[interactiveStyleKey], hasTrailingMetric && $c8a0aed7b7d2949e$var$styles.containerBadgePressed, hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $c8a0aed7b7d2949e$var$styles.containerBadgeNeutralAppearance),
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        "aria-label": isLoading ? 'Loading' : ariaLabel,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        onClick: isLoading ? undefined : onClick,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...commonStyleOverrides,
            // Specified because Pressable has a default border:none which overrides the border specified on the container
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            border: `solid ${"var(--ds-border-width, 1px)"} ${isSelected ? 'var(--border-color) !important' : 'transparent'}`,
            backgroundColor: isSelected ? $c8a0aed7b7d2949e$var$pressedBackgroundMapping[resolvedColor] : undefined,
            cursor: isLoading ? 'progress' : 'pointer'
        },
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LozengeDropdownTrigger",
        ...isSelected && {
            'data-selected': 'true'
        }
    }, innerContent, isLoading && /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $c8a0aed7b7d2949e$var$styles.loadingOverlay
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        size: spacing === 'spacious' ? 'small' : 'xsmall',
        label: ", Loading",
        testId: testId ? `${testId}--loading-spinner` : undefined
    })));
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        ref: ref,
        style: commonStyleOverrides,
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            $c8a0aed7b7d2949e$var$styles.container,
            spacing === 'spacious' && $c8a0aed7b7d2949e$var$styles.containerSpacious,
            spacing !== 'spacious' && hasTrailingMetric && $c8a0aed7b7d2949e$var$styles.containerBadgePadding,
            $c8a0aed7b7d2949e$var$styles[colorStyleKey],
            $c8a0aed7b7d2949e$var$styles.iconBorderFilter,
            hasTrailingMetric && resolvedTrailingMetricAppearance === 'neutral' && $c8a0aed7b7d2949e$var$styles.containerBadgeNeutralAppearance
        ])
    }, innerContent);
}));
var $c8a0aed7b7d2949e$export$2e2bcd8739ae039 = $c8a0aed7b7d2949e$var$LozengeBase;

});
parcelRegister("68JOj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d00d2d7bfc3dd1c8$export$2e2bcd8739ae039);
/* badge-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $ekURY = parcelRequire("ekURY");

var $a1GvG = parcelRequire("a1GvG");

var $jC1xp = parcelRequire("jC1xp");
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ // Nested selectors with data attributes are required for theme switching
const $d00d2d7bfc3dd1c8$var$stylesNew = {
    root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    success: "_syaz1p1e _bfhk14j0",
    danger: "_syaz1blx _bfhk18wg",
    warning: "_syazmgs1 _bfhk10f4",
    information: "_syaz1qd9 _bfhk8lbg",
    discovery: "_syaz1g72 _bfhke670",
    neutral: "_syazi7uo _bfhk7qp0",
    inverse: "_bfhkvuon _syazi7uo",
    informationBold: "_syaz1qd9 _bfhk9pm7",
    successBold: "_syaz1p1e _bfhk16ib",
    dangerBold: "_syaz1blx _bfhkud63",
    warningBold: "_syazmgs1 _bfhk1kmu",
    warningBoldDark: "_syazmgs1 _bfhkgj02",
    discoveryBold: "_syaz1g72 _bfhk5ly7"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */ const $d00d2d7bfc3dd1c8$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && max ? (0, $jC1xp.formatValue)(children, max) : children;
};
/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 * - informationBold (bold blue, color.background.information.subtle)
 * - successBold (bold green, color.background.success.subtle)
 * - dangerBold (bold red, color.background.danger.subtle)
 * - warningBold (bold warning, color.background.warning.bold)
 * - discoveryBold (bold purple, color.background.discovery.subtle)
 */ const $d00d2d7bfc3dd1c8$var$BadgeNew = /*#__PURE__*/ (0, $4fqPo.memo)(function BadgeNew({ appearance: appearance = 'neutral', children: children = 0, max: max = 99, style: style, testId: testId }) {
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    // In dark theme, warningBold needs to swap to a lighter background
    // (color.background.warning.subtle / Orange800) for better contrast against
    // the typical dark surface colors.
    const resolvedAppearance = appearance === 'warningBold' && colorMode === 'dark' ? 'warningBoldDark' : appearance;
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $ltgDR.default)([
            $d00d2d7bfc3dd1c8$var$stylesNew.root,
            $d00d2d7bfc3dd1c8$var$stylesNew[resolvedAppearance]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $d00d2d7bfc3dd1c8$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $d00d2d7bfc3dd1c8$export$2e2bcd8739ae039 = $d00d2d7bfc3dd1c8$var$BadgeNew;

});
parcelRegister("a1GvG", function(module, exports) {
$parcel$export(module.exports, "default", () => $071d70fe5d247fe6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $kdx0d = parcelRequire("kdx0d");

var $lfKTU = parcelRequire("lfKTU");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $071d70fe5d247fe6$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $4fqPo.useState)((0, $kdx0d.default)());
    (0, $4fqPo.useEffect)(()=>{
        const observer = new (0, $lfKTU.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $071d70fe5d247fe6$export$2e2bcd8739ae039 = $071d70fe5d247fe6$var$useThemeObserver;

});

parcelRegister("jC1xp", function(module, exports) {
$parcel$export(module.exports, "formatValue", () => $bdf0a36ad340bf36$export$7c4d25c0c3217d8c);
function $bdf0a36ad340bf36$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $bdf0a36ad340bf36$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $bdf0a36ad340bf36$var$getSafeValue(value);
    const safeMax = $bdf0a36ad340bf36$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("fMVPx", function(module, exports) {
$parcel$export(module.exports, "useResizing", () => $46479af18eb670b8$export$a300664a1a230956);

var $4fqPo = parcelRequire("4fqPo");

var $1dGol = parcelRequire("1dGol");

var $bCKeW = parcelRequire("bCKeW");

var $lK4C3 = parcelRequire("lK4C3");

var $7RmaT = parcelRequire("7RmaT");

var $4Hk21 = parcelRequire("4Hk21");

var $fJUqt = parcelRequire("fJUqt");
/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $46479af18eb670b8$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $46479af18eb670b8$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $46479af18eb670b8$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $46479af18eb670b8$export$a300664a1a230956 = ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $4fqPo.useRef)();
    const [element, setElementRef] = (0, $bCKeW.useElementRef)();
    const setTimeout = (0, $4Hk21.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $7RmaT.useRequestAnimationFrame)();
    (0, $fJUqt.useSnapshotBeforeUpdate)(()=>{
        if ((0, $1dGol.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $lK4C3.useLayoutEffect)(()=>{
        if ((0, $1dGol.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect.width,
            height: rect.height
        };
        if (!$46479af18eb670b8$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
            return;
        }
        const propertyList = $46479af18eb670b8$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $46479af18eb670b8$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};

});

parcelRegister("82vM7", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b0ab9becf2dfdf8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");

var $9XaAY = parcelRequire("9XaAY");

var $fJeCl = parcelRequire("fJeCl");

var $2m8U6 = parcelRequire("2m8U6");
function $5b0ab9becf2dfdf8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $5b0ab9becf2dfdf8$var$focusRingStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $fJeCl.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $fJeCl.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $fJeCl.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $fJeCl.borderWidthMap)['border.width']} solid`
        }
    }
});
const $5b0ab9becf2dfdf8$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $5b0ab9becf2dfdf8$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $5b0ab9becf2dfdf8$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $5b0ab9becf2dfdf8$var$Pressable = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $c1tmZ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2m8U6.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("button", {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $5b0ab9becf2dfdf8$var$baseStyles,
            $5b0ab9becf2dfdf8$var$focusRingStyles,
            isDisabled ? $5b0ab9becf2dfdf8$var$disabledStyles : $5b0ab9becf2dfdf8$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fJeCl.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fJeCl.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fJeCl.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fJeCl.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fJeCl.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fJeCl.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fJeCl.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fJeCl.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var $5b0ab9becf2dfdf8$export$2e2bcd8739ae039 = $5b0ab9becf2dfdf8$var$Pressable;

});

parcelRegister("1pWeE", function(module, exports) {
$parcel$export(module.exports, "getThemeStyles", () => $6cbbbda5f9dfa9c8$export$a3fc04b8551e006a);
const $6cbbbda5f9dfa9c8$export$a3fc04b8551e006a = (resolvedColor)=>{
    const isAccent = resolvedColor.startsWith('accent-');
    const category = isAccent ? 'accent' : 'semantic';
    const key = isAccent ? resolvedColor.replace('accent-', '') : resolvedColor;
    return {
        category: category,
        key: key
    };
};

});

parcelRegister("3IjYG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2216810d40c114f6$export$2e2bcd8739ae039);
/* icon-renderer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");
// Map lozenge colors to appropriate icon colors.
//
// We intentionally use `color.text.*.bolder` tokens for icons across all
// colored lozenges (semantic + accent). Text tokens use higher-stop palette
// values (Color700+) which pass 3:1 contrast against subtler backgrounds in
// every interactive state — including pressed where icon Color600 fails for
// most hues. Using text tokens uniformly:
//   - avoids global changes to the `color.icon.*` token ramps
//   - keeps icon and text visually aligned in the lozenge
//   - guarantees ≥3:1 contrast across default/hover/pressed states
//
// Neutral lozenges use `color.text.subtle` to match the neutral text styling
// and remain consistent with their alpha-based backgrounds.
const $2216810d40c114f6$var$getIconColor = (color)=>{
    switch(color){
        // Semantic
        case 'success':
            return "var(--ds-text-success, #4C6B1F)";
        case 'warning':
            return "var(--ds-text-warning, #9E4C00)";
        case 'danger':
            return "var(--ds-text-danger, #AE2E24)";
        case 'information':
            return "var(--ds-text-information, #1558BC)";
        case 'discovery':
            return "var(--ds-text-discovery, #803FA5)";
        case 'neutral':
            return "var(--ds-text-subtle, #505258)";
        // Accent
        case 'accent-red':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'accent-orange':
            return "var(--ds-text-accent-orange, #9E4C00)";
        case 'accent-yellow':
            return "var(--ds-text-accent-yellow, #7F5F01)";
        case 'accent-lime':
            return "var(--ds-text-accent-lime, #4C6B1F)";
        case 'accent-green':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'accent-teal':
            return "var(--ds-text-accent-teal, #206A83)";
        case 'accent-blue':
            return "var(--ds-text-accent-blue, #1558BC)";
        case 'accent-purple':
            return "var(--ds-text-accent-purple, #803FA5)";
        case 'accent-magenta':
            return "var(--ds-text-accent-magenta, #943D73)";
        case 'accent-gray':
            return "var(--ds-text-subtle, #505258)";
        default:
            return "var(--ds-text-subtle, #505258)";
    }
};
const $2216810d40c114f6$var$styles = {
    motion: "_k8m01ylx _1oeci9qs _6fl41d08"
};
/**
 * Icon renderer for lozenge components
 * Handles proper sizing and color theming for icons
 */ const $2216810d40c114f6$var$IconRenderer = ({ icon: Icon, color: color, testId: testId, size: size })=>{
    const iconColor = $2216810d40c114f6$var$getIconColor(color);
    return (0, $3H4LK.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $2216810d40c114f6$var$styles.motion,
        style: {
            color: iconColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Icon, {
        label: "",
        size: size,
        testId: testId
    })) : // Cast required because the lozenge intentionally uses some
    // `color.text.*.bolder` tokens for icons that don't pass 3:1 contrast
    // at their default `color.icon.*` stop. The Icon component types only
    // accept `IconColor`, but text tokens are valid CSS color values and
    // render correctly at runtime.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Icon, {
        color: iconColor,
        label: "",
        size: size,
        testId: testId
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2216810d40c114f6$export$2e2bcd8739ae039 = $2216810d40c114f6$var$IconRenderer;

});

parcelRegister("8zEnZ", function(module, exports) {
$parcel$export(module.exports, "resolveLozengeColor", () => $65d40a7636ee536b$export$acf5d2b7dc999bda);

// Map legacy appearance to new color values
const $65d40a7636ee536b$var$legacyAppearanceMap = {
    default: 'neutral',
    removed: 'danger',
    inprogress: 'information',
    new: 'discovery',
    moved: 'warning'
};
const $65d40a7636ee536b$export$acf5d2b7dc999bda = (appearance = 'neutral')=>{
    if (appearance.startsWith('accent-')) return appearance;
    return $65d40a7636ee536b$var$legacyAppearanceMap[appearance] ?? appearance;
};

});




parcelRegister("hJvsu", function(module, exports) {
$parcel$export(module.exports, "default", () => $2836ce04ab25a8d2$export$2e2bcd8739ae039);

var $cR2qL = parcelRequire("cR2qL");

var $1dGol = parcelRequire("1dGol");

var $bCKeW = parcelRequire("bCKeW");

var $lK4C3 = parcelRequire("lK4C3");

var $7RmaT = parcelRequire("7RmaT");

var $4Hk21 = parcelRequire("4Hk21");

var $eO5yD = parcelRequire("eO5yD");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motion)
 */ const $2836ce04ab25a8d2$var$ShrinkOut = ({ children: children, duration: duration = 'small', onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $bCKeW.useElementRef)();
    const exiting = (0, $eO5yD.useExitingPersistence)();
    const requestAnimationFrame = (0, $7RmaT.useRequestAnimationFrame)();
    const setTimeout = (0, $4Hk21.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $lK4C3.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            if ((0, $1dGol.isReducedMotion)()) {
                exiting.onFinish && exiting.onFinish();
                onFinish && onFinish('exiting');
                return;
            }
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        // We animate margin down to zero so it doesn't take any space.
                        transitionTimingFunction: 'cubic-bezier(0.8,0,0,0.8)',
                        transitionDuration: (0, $cR2qL.durations)[duration] + 'ms',
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, (0, $cR2qL.durations)[duration]);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $2836ce04ab25a8d2$export$2e2bcd8739ae039 = $2836ce04ab25a8d2$var$ShrinkOut;

});

parcelRegister("e6mBg", function(module, exports) {
$parcel$export(module.exports, "default", () => $48466c25296b3861$export$2e2bcd8739ae039);
$parcel$export(module.exports, "colorMapping", () => (parcelRequire("aVeDG")).colorMapping);
/* tag-new.tsx generated by @compiled/babel-plugin v0.37.1 */ /* tag-new.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $cTq8x = parcelRequire("cTq8x");

var $iqiKs = parcelRequire("iqiKs");

var $5qWT2 = parcelRequire("5qWT2");

var $aVeDG = parcelRequire("aVeDG");

var $aViyV = parcelRequire("aViyV");

var $dWE8c = parcelRequire("dWE8c");

var $8Vc6N = parcelRequire("8Vc6N");

var $lhiNE = parcelRequire("lhiNE");

var $gasMW = parcelRequire("gasMW");

var $cAAtP = parcelRequire("cAAtP");

var $8QIIz = parcelRequire("8QIIz");

var $h7vJB = parcelRequire("h7vJB");
const $48466c25296b3861$var$styles = {
    baseStyles: "_zulp1b66 _2rko12b0 _11c8wadc _1dqonqa1 _189ee4h9 _1rjcv77o _18zr1mie _1mou1b66 _195g1b66 _1e0c116y _vchhusvi _1ul9idpf _p12ff6dh _4t3i1k92 _kqswh2mm _4cvr1h6o _80om73ad _bfhksm61",
    noMarginStyles: "_1mouze3t _195gze3t",
    removableStyles: "_zulp1b66",
    beforeStyles: "_4bfu1snc _1hmsagmp _ajmmvv82 _1e0c116y _4cvr1h6o _1o9zidpf _syaz125o",
    beforeStylesSelected: "_syazxl6c",
    textStyles: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n _1ul9idpf _syazi7uo",
    textStylesSelected: "_syaz6x5g",
    afterStyles: "_1e0c1txw _4cvr1h6o _1o9zidpf _lcxv1wug _kqswh2mm",
    trailingMetric: "_2rkolb4i _11c8wadc _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _4cvr1h6o _1o9zidpf _1kz6184x _bfhk1w9g _syazi7uo",
    trailingMetricEndPadding: "_y4ti303w",
    focusRingStyles: "_1ygbdfik _1ah3v77o",
    childFocusRingStyles: "_1a37dfik _1cwgv77o",
    interactiveBaseStyles: "_80omtlke _1all1b66 _qsdj1r31 _17ncglyw _15hpnqa1 _1rg815vq _1yoo15vq _j8j91snc _1afaagmp _gdbt10yn _h5vp116y _1qxz1h6o _8zx0idpf _1km4jdj5 _wc1fagmp _9408jdj5 _usew1snc _ebtnagmp _uvk910yn _10nj1r31 _1xq0glyw _18x1nqa1 _2mpsagmp",
    interactiveHoverStyles: "_17501r31 _qrsc8stv _1wodnqa1 _irr31dpa _rlyhjdj5 _1di6fcek"
};
// For accent borders, we use the new color.border.accent.*.subtle tokens (Color300
// light / Color800 dark) which provide proper decorative-border colours
//
// Icons keep color.icon.accent.* in the default state (vibrant on the plain page
// background) and swap to color.text.accent.* in hovered/pressed states (where the
// Tag picks up a coloured background and needs guaranteed 3:1 icon contrast).
const $48466c25296b3861$var$colorStyles = {
    gray: "_119bmsup _1ib21diz _egnk1sqi _17x31sqi _ih6z7qp0",
    blue: "_119b18hp _1ib26txe _egnk16jw _17x316jw _ih6z1dy8",
    green: "_119b5d2u _1ib217hp _egnkh55r _17x3h55r _ih6z1wnw",
    red: "_119bn9dc _1ib2nbxb _egnk9lu1 _17x39lu1 _ih6z1rtt",
    yellow: "_119b1s7j _1ib21oqg _egnkfb2s _17x3fb2s _ih6z1773",
    purple: "_119bluwt _1ib2uq3u _egnkqmo9 _17x3qmo9 _ih6z1nm4",
    lime: "_119b1m7d _1ib28645 _egnk1tco _17x31tco _ih6zz2ec",
    magenta: "_119b132u _1ib2v8hk _egnk1s8m _17x31s8m _ih6zv9ra",
    orange: "_119b1ip5 _1ib21j6y _egnkp1lv _17x3p1lv _ih6z165s",
    teal: "_119b131p _1ib28uof _egnk17qg _17x317qg _ih6z1a17"
};
// Border + icon filter styles - base state.
// Borders use the new color.border.accent.*.subtle tokens directly.
// Icons use the color.icon.accent.* tokens directly in the default state.
const $48466c25296b3861$var$borderIconFilterStyles = {
    root: "_1h6dip4g _wi6h9ea2"
};
// Border + icon filter styles - interactive states (hover/pressed).
// Icons swap to the color.text.accent.* tokens for guaranteed 3:1 contrast
// against the coloured interactive backgrounds. Borders stay constant.
const $48466c25296b3861$var$borderIconInteractiveFilterStyles = {
    root: "_4cvxip4g _zqoiipvw _q4ztip4g _ba35u0j8"
};
const $48466c25296b3861$var$dropdownStyles = {
    interactive: "_irr31dpa _1di6fcek",
    selected: "_1h6dq98m _syaz6x5g _bfhk15s3 _irr3ufnl _1di6nozp",
    content: "_zulp1b66 _1reo15vq _18m915vq _1e0c116y _4cvr1h6o _16jlkb7n _1o9zkb7n _1ul9idpf",
    loadingContent: "_tzy4idpf",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t _lcxvglyw"
};
/**
 * __TagNew__
 *
 * TagNew is the visual uplift implementation of Tag
 */ const $48466c25296b3861$var$TagNewComponent = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function TagNew({ color: color = 'gray', text: text, elemBefore: elemBefore, href: href, linkComponent: linkComponent, isRemovable: isRemovable = true, removeButtonLabel: removeButtonLabel, onBeforeRemoveAction: onBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const normalizedText = (0, $aViyV.getTagText)(text);
    const { status: status, handleRemoveRequest: handleRemoveRequest, onKeyPress: onKeyPress, removingTag: removingTag, showingTag: showingTag } = (0, $h7vJB.useTagRemoval)(onBeforeRemoveAction);
    const onShrinkOutExitComplete = (0, $4fqPo.useCallback)(()=>{
        onAfterRemoveAction === null || onAfterRemoveAction === void 0 || onAfterRemoveAction(normalizedText);
    }, [
        normalizedText,
        onAfterRemoveAction
    ]);
    const { isLink: isLink, LinkComponent: LinkComponent } = (0, $cAAtP.useLink)(href, linkComponent);
    const { isLinkHovered: isLinkHovered, isOverButton: isOverButton, isButtonFocused: isButtonFocused, isLinkFocused: isLinkFocused, buttonHandlers: buttonHandlers, linkHandlers: linkHandlers } = (0, $gasMW.useButtonInteraction)();
    const removeButton = (0, $8QIIz.useRemoveButton)({
        isRemovable: isRemovable,
        tagText: normalizedText,
        removeButtonLabel: removeButtonLabel,
        testId: testId,
        handleRemoveRequest: handleRemoveRequest,
        removingTag: removingTag,
        showingTag: showingTag,
        onKeyPress: onKeyPress,
        buttonHandlers: buttonHandlers
    });
    const tagContent = /*#__PURE__*/ $4fqPo.createElement("span", {
        ...other,
        ref: ref,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: maxWidth !== undefined ? {
            maxWidth: maxWidth
        } : undefined,
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.baseStyles,
            !hasMargin && $48466c25296b3861$var$styles.noMarginStyles,
            $48466c25296b3861$var$colorStyles[color],
            $48466c25296b3861$var$borderIconFilterStyles.root,
            isLink && $48466c25296b3861$var$styles.interactiveBaseStyles,
            isLink && $48466c25296b3861$var$styles.focusRingStyles,
            isLink && isLinkHovered && !isOverButton && $48466c25296b3861$var$borderIconInteractiveFilterStyles.root,
            isLink && isLinkHovered && !isOverButton && $48466c25296b3861$var$styles.interactiveHoverStyles,
            isRemovable && $48466c25296b3861$var$styles.removableStyles,
            isLinkFocused && !isButtonFocused && $48466c25296b3861$var$styles.childFocusRingStyles,
            !isRemovable && trailingMetric != null && trailingMetric !== '' && $48466c25296b3861$var$styles.trailingMetricEndPadding
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $dWE8c.LinkWrapper), {
        isLink: isLink,
        href: href,
        LinkComponent: LinkComponent,
        testId: testId,
        linkHandlers: linkHandlers,
        onClick: onClick
    }, /*#__PURE__*/ $4fqPo.createElement((0, $lhiNE.default), {
        colorKey: color,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.beforeStyles
        ])
    }, elemBefore), /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-tag-text": true,
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.textStyles
        ])
    }, normalizedText), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId && `${testId}--metric`,
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.trailingMetric
        ])
    }, trailingMetric)), removeButton && /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.afterStyles
        ])
    }, removeButton));
    return /*#__PURE__*/ $4fqPo.createElement((0, $8Vc6N.RemovableWrapper), {
        isRemovable: isRemovable,
        status: status,
        onShrinkOutExitComplete: isRemovable ? onShrinkOutExitComplete : undefined
    }, tagContent);
});
const $48466c25296b3861$export$aba6bd1190e79361 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function TagDropdownTrigger({ color: color = 'gray', text: text, elemBefore: elemBefore, testId: testId, maxWidth: maxWidth, hasMargin: hasMargin = true, onClick: onClick, isSelected: isSelected = false, isLoading: isLoading = false, analyticsContext: _analyticsContext, hasChevron: hasChevron = true, swatchBefore: swatchBefore, trailingMetric: trailingMetric, ...other }, ref) {
    const resolvedColor = (0, $aVeDG.colorMapping)[color] || 'gray';
    return /*#__PURE__*/ $4fqPo.createElement((0, $iqiKs.default), {
        ref: ref,
        // @ts-expect-error paddingInline is 0.1875rem
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $9h99w.cx)($48466c25296b3861$var$styles.baseStyles, !hasMargin && $48466c25296b3861$var$styles.noMarginStyles, $48466c25296b3861$var$colorStyles[resolvedColor], $48466c25296b3861$var$borderIconFilterStyles.root, $48466c25296b3861$var$dropdownStyles.interactive, $48466c25296b3861$var$styles.focusRingStyles, $48466c25296b3861$var$borderIconInteractiveFilterStyles.root, isSelected && $48466c25296b3861$var$dropdownStyles.selected, // Reduce end padding when trailing metric is the last element (no chevron)
        !hasChevron && trailingMetric != null && trailingMetric !== '' && $48466c25296b3861$var$styles.trailingMetricEndPadding),
        onClick: isLoading ? undefined : onClick,
        style: {
            borderColor: isSelected ? "var(--ds-border-selected, #1868DB)" : undefined,
            cursor: isLoading ? 'progress' : 'pointer',
            maxWidth: maxWidth !== undefined ? maxWidth : undefined
        },
        ...isLoading && {
            'aria-busy': true,
            'aria-disabled': true,
            isDisabled: true
        },
        testId: testId,
        ...other
    }, /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$dropdownStyles.content,
            isLoading && $48466c25296b3861$var$dropdownStyles.loadingContent
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $lhiNE.default), {
        colorKey: resolvedColor,
        swatchBefore: swatchBefore
    }), elemBefore && /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.beforeStyles,
            isSelected && $48466c25296b3861$var$styles.beforeStylesSelected
        ])
    }, elemBefore), /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-tag-text": true,
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.textStyles,
            isSelected && $48466c25296b3861$var$styles.textStylesSelected
        ])
    }, (0, $aViyV.getTagText)(text)), trailingMetric != null && trailingMetric !== '' && /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId && `${testId}--metric`,
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$styles.trailingMetric
        ])
    }, trailingMetric), hasChevron && /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
        label: "",
        size: "small",
        color: 'currentColor',
        testId: testId && `${testId}--chevron`
    })), isLoading && /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $48466c25296b3861$var$dropdownStyles.loadingOverlay
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        size: 'xsmall',
        label: ", Loading",
        testId: testId ? `${testId}--loading-spinner` : undefined
    })));
});
/**
 * __Tag new__
 */ const $48466c25296b3861$var$TagNew = /*#__PURE__*/ (0, $4fqPo.memo)($48466c25296b3861$var$TagNewComponent);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$48466c25296b3861$export$2e2bcd8739ae039 = $48466c25296b3861$var$TagNew;

});
parcelRegister("aVeDG", function(module, exports) {
$parcel$export(module.exports, "colorMapping", () => $27ac7bd104a144d7$export$3351a8d90bcc13aa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $27ac7bd104a144d7$export$3351a8d90bcc13aa = {
    standard: 'gray',
    grey: 'gray',
    blue: 'blue',
    green: 'green',
    red: 'red',
    yellow: 'yellow',
    purple: 'purple',
    lime: 'lime',
    magenta: 'magenta',
    orange: 'orange',
    teal: 'teal',
    // Light variants map to same as their non-light counterparts
    greyLight: 'gray',
    blueLight: 'blue',
    greenLight: 'green',
    redLight: 'red',
    yellowLight: 'yellow',
    purpleLight: 'purple',
    limeLight: 'lime',
    magentaLight: 'magenta',
    orangeLight: 'orange',
    tealLight: 'teal'
};

});

parcelRegister("aViyV", function(module, exports) {
$parcel$export(module.exports, "getTagText", () => $dc21b360414af44f$export$7d100de1166870f6);
// Intentionally scoped to the UI-uplifted TagNew implementation.
const $dc21b360414af44f$export$7d100de1166870f6 = (text)=>Array.isArray(text) ? text.join('') : text;

});

parcelRegister("dWE8c", function(module, exports) {
$parcel$export(module.exports, "LinkWrapper", () => $3eea08ee8a54345e$export$ce4b6a469c26f53f);

var $4fqPo = parcelRequire("4fqPo");
function $3eea08ee8a54345e$export$ce4b6a469c26f53f({ isLink: isLink, href: href, LinkComponent: LinkComponent, testId: testId, children: children, onClick: onClick, linkHandlers: linkHandlers }) {
    if (isLink && href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LinkComponent, {
        href: href,
        testId: testId ? `${testId}--link` : undefined,
        onClick: onClick,
        onMouseEnter: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseEnter,
        onMouseLeave: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseLeave,
        onMouseDown: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onMouseDown,
        onFocus: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onFocus,
        onBlur: linkHandlers === null || linkHandlers === void 0 ? void 0 : linkHandlers.onBlur
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, children);
}

});

parcelRegister("8Vc6N", function(module, exports) {
$parcel$export(module.exports, "RemovableWrapper", () => $7a35406bae8e19aa$export$898a500849bb5cf4);
/* removable-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ /**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $eO5yD = parcelRequire("eO5yD");
var $hJvsu = parcelRequire("hJvsu");

var $alUdc = parcelRequire("alUdc");
/**
 * Stable key so ExitingPersistence can match this child across the remove transition
 * (see ShrinkOut + ExitingPersistence docs in @atlaskit/motion).
 */ const $7a35406bae8e19aa$var$removableShrinkOutChildKey = 'atlaskit-tag-removable-shrink-out';
const $7a35406bae8e19aa$var$motionWrapperStyles = null;
function $7a35406bae8e19aa$export$898a500849bb5cf4({ isRemovable: isRemovable, status: status, onShrinkOutExitComplete: onShrinkOutExitComplete, children: children }) {
    if (isRemovable) return /*#__PURE__*/ $4fqPo.createElement((0, $eO5yD.default), null, !(status === (0, $alUdc.TagStatus).Removed) && /*#__PURE__*/ $4fqPo.createElement((0, $hJvsu.default), {
        key: $7a35406bae8e19aa$var$removableShrinkOutChildKey,
        onFinish: onShrinkOutExitComplete ? (phase)=>{
            if (phase === 'exiting') onShrinkOutExitComplete();
        } : undefined
    }, (motion)=>/*#__PURE__*/ $4fqPo.createElement("span", {
            ref: motion.ref,
            className: (0, $ltgDR.default)([
                "_1e0c116y"
            ])
        }, children)));
    return children;
}

});
parcelRegister("alUdc", function(module, exports) {
$parcel$export(module.exports, "TagStatus", () => $c33751b70166a98d$export$74452314b63acabc);
// Tag status enum
var $c33751b70166a98d$export$74452314b63acabc = /*#__PURE__*/ function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
    return TagStatus;
}({});

});


parcelRegister("lhiNE", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba44ee1ee70d67ec$export$2e2bcd8739ae039);
/* swatch-before.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $ba44ee1ee70d67ec$var$tagSwatchBeforeStyles = {
    swatch: "_2rkolb4i _1bsboqnp _4t3ioqnp _1o9zidpf"
};
const $ba44ee1ee70d67ec$var$tagSwatchBeforeColorStyles = {
    gray: "_bfhk18j9",
    blue: "_bfhk115i",
    green: "_bfhk1rsu",
    red: "_bfhkkrt9",
    yellow: "_bfhk8y3s",
    purple: "_bfhk18ah",
    lime: "_bfhkbq5w",
    magenta: "_bfhk1mi6",
    orange: "_bfhk1kkj",
    teal: "_bfhktdv8"
};
function $ba44ee1ee70d67ec$export$2e2bcd8739ae039({ colorKey: colorKey, swatchBefore: swatchBefore }) {
    if (swatchBefore === undefined || swatchBefore === false) return null;
    if (swatchBefore === true) return /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $ba44ee1ee70d67ec$var$tagSwatchBeforeStyles.swatch,
            $ba44ee1ee70d67ec$var$tagSwatchBeforeColorStyles[colorKey]
        ])
    });
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            backgroundColor: swatchBefore
        },
        className: (0, $ltgDR.default)([
            $ba44ee1ee70d67ec$var$tagSwatchBeforeStyles.swatch
        ])
    });
}

});

parcelRegister("gasMW", function(module, exports) {
$parcel$export(module.exports, "useButtonInteraction", () => $56e5886d39d4b9cc$export$84acd183858d8235);

var $4fqPo = parcelRequire("4fqPo");
function $56e5886d39d4b9cc$export$84acd183858d8235() {
    const [isLinkHovered, setIsLinkHovered] = (0, $4fqPo.useState)(false);
    const [isOverButton, setIsOverButton] = (0, $4fqPo.useState)(false);
    const [isButtonFocused, setIsButtonFocused] = (0, $4fqPo.useState)(false);
    const [isLinkFocused, setIsLinkFocused] = (0, $4fqPo.useState)(false);
    // Track if last interaction was via mouse (to determine keyboard vs mouse focus)
    const hadMouseDownRef = (0, $4fqPo.useRef)(false);
    // Button handlers
    const buttonHandlers = (0, $4fqPo.useMemo)(()=>({
            onMouseEnter: ()=>setIsOverButton(true),
            onMouseLeave: ()=>setIsOverButton(false),
            onMouseDown: (e)=>{
                // Prevent the browser from moving focus to the remove button on mousedown.
                // Without this, parent composite widgets (e.g. Select) lose input focus when
                // the user clicks remove, triggering unwanted blur side-effects.
                e === null || e === void 0 || e.preventDefault();
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsButtonFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsButtonFocused(false)
        }), []);
    // Link handlers - includes hover tracking
    const linkHandlers = (0, $4fqPo.useMemo)(()=>({
            onMouseEnter: ()=>setIsLinkHovered(true),
            onMouseLeave: ()=>setIsLinkHovered(false),
            onMouseDown: ()=>{
                hadMouseDownRef.current = true;
            },
            onFocus: ()=>{
                // Only track keyboard focus for focus ring styles
                // If mousedown happened just before focus, it's mouse focus (not keyboard)
                if (!hadMouseDownRef.current) setIsLinkFocused(true);
                hadMouseDownRef.current = false;
            },
            onBlur: ()=>setIsLinkFocused(false)
        }), []);
    return {
        isLinkHovered: isLinkHovered,
        isOverButton: isOverButton,
        isButtonFocused: isButtonFocused,
        isLinkFocused: isLinkFocused,
        buttonHandlers: buttonHandlers,
        linkHandlers: linkHandlers
    };
}

});

parcelRegister("cAAtP", function(module, exports) {
$parcel$export(module.exports, "useLink", () => $e2886c858ba6df93$export$dcf14c9974fe2767);

var $iByhD = parcelRequire("iByhD");
function $e2886c858ba6df93$export$dcf14c9974fe2767(href, linkComponent) {
    const isLink = Boolean(href);
    const LinkComponent = linkComponent ?? (0, $iByhD.default);
    return {
        isLink: isLink,
        LinkComponent: LinkComponent
    };
}

});

parcelRegister("8QIIz", function(module, exports) {
$parcel$export(module.exports, "useRemoveButton", () => $84e5af4dc9a89cb6$export$97d8be09cd53869b);
/**
 * Shared utilities for TagNew and AvatarTag components.
 * Note: CSS styles cannot be shared due to Compiled CSS static analysis requirements.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $83RtZ = parcelRequire("83RtZ");
function $84e5af4dc9a89cb6$export$97d8be09cd53869b({ isRemovable: isRemovable, tagText: tagText, removeButtonLabel: removeButtonLabel, testId: testId, handleRemoveRequest: handleRemoveRequest, removingTag: removingTag, showingTag: showingTag, onKeyPress: onKeyPress, shape: shape = 'default', buttonHandlers: buttonHandlers }) {
    const handleFocus = (0, $4fqPo.useCallback)(()=>{
        removingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onFocus();
    }, [
        removingTag,
        buttonHandlers
    ]);
    const handleBlur = (0, $4fqPo.useCallback)(()=>{
        showingTag();
        buttonHandlers === null || buttonHandlers === void 0 || buttonHandlers.onBlur();
    }, [
        showingTag,
        buttonHandlers
    ]);
    return (0, $4fqPo.useMemo)(()=>{
        if (!isRemovable) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $83RtZ.default), {
            "aria-label": `${removeButtonLabel || 'Remove'} ${tagText}`,
            onClick: handleRemoveRequest,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyPress: onKeyPress,
            onMouseEnter: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseEnter,
            onMouseLeave: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseLeave,
            onMouseDown: buttonHandlers === null || buttonHandlers === void 0 ? void 0 : buttonHandlers.onMouseDown,
            testId: testId ? `close-button-${testId}` : undefined,
            shape: shape
        });
    }, [
        isRemovable,
        removeButtonLabel,
        tagText,
        handleRemoveRequest,
        handleFocus,
        handleBlur,
        onKeyPress,
        buttonHandlers,
        testId,
        shape
    ]);
}

});
parcelRegister("83RtZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $43afb2e969e34855$export$2e2bcd8739ae039);
/* remove-button.tsx generated by @compiled/babel-plugin v0.37.1 */ /* remove-button.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $9RW5e = parcelRequire("9RW5e");

var $3H4LK = parcelRequire("3H4LK");

var $iqiKs = parcelRequire("iqiKs");
const $43afb2e969e34855$var$removeButtonStyles = {
    root: "_19itglyw _2rkolb4i _195gze3t _1mouze3t _18zrze3t _1rjcze3t _1e0c1txw _4t3i1j6v _1bsb1j6v _rjxpze3t _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _80omtlke _lcxv1wug _ahbq1i6y _12l21i6y _1ah3idpf _irr31dpa _1di6fcek",
    circle: "_2rko1rr0 _1ah3idpf",
    focusRing: "_1ah3v77o",
    newIcon: "_rjxpv77o"
};
const $43afb2e969e34855$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, testId: testId, shape: shape = 'default' })=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $iqiKs.default), {
        xcss: (0, $fxmw9.cx)($43afb2e969e34855$var$removeButtonStyles.root, shape === 'circle' && $43afb2e969e34855$var$removeButtonStyles.circle, $43afb2e969e34855$var$removeButtonStyles.newIcon, (0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && $43afb2e969e34855$var$removeButtonStyles.focusRing),
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: testId
    }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
        color: "currentColor",
        label: "",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43afb2e969e34855$export$2e2bcd8739ae039 = $43afb2e969e34855$var$RemoveButton;

});


parcelRegister("h7vJB", function(module, exports) {
$parcel$export(module.exports, "useTagRemoval", () => $dcd8ed6c27d43166$export$f26019543e9f862f);

var $4fqPo = parcelRequire("4fqPo");

var $98zBT = parcelRequire("98zBT");

var $alUdc = parcelRequire("alUdc");
function $dcd8ed6c27d43166$export$f26019543e9f862f(onBeforeRemoveAction) {
    const [status, setStatus] = (0, $4fqPo.useState)((0, $alUdc.TagStatus).Showing);
    const handleRemoveRequest = (0, $4fqPo.useCallback)(()=>{
        const beforeAction = onBeforeRemoveAction ?? (0, $98zBT.defaultBeforeRemoveAction);
        if (beforeAction()) // Defer onAfterRemoveAction until ShrinkOut's onFinish so ExitingPersistence can run
        // the exit animation (e.g. in multi-select and user pickers).
        setStatus((0, $alUdc.TagStatus).Removed);
    }, [
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $4fqPo.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $4fqPo.useCallback)(()=>setStatus((0, $alUdc.TagStatus).Removing), []);
    const showingTag = (0, $4fqPo.useCallback)(()=>setStatus((0, $alUdc.TagStatus).Showing), []);
    return {
        status: status,
        handleRemoveRequest: handleRemoveRequest,
        onKeyPress: onKeyPress,
        removingTag: removingTag,
        showingTag: showingTag
    };
}

});
parcelRegister("98zBT", function(module, exports) {
$parcel$export(module.exports, "defaultBeforeRemoveAction", () => $61484324365d8c27$export$279e7025ed114474);
const $61484324365d8c27$export$279e7025ed114474 = ()=>true;

});



parcelRegister("q39rQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $28f30ada25f4e7a3$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");
// Border colors - Hardcoded for Visual Refresh - to be removed with labelling system work
const $28f30ada25f4e7a3$var$borderColors = {
    standard: "_1h6d14je",
    blue: "_1h6duisw",
    red: "_1h6da2c0",
    yellow: "_1h6deh2r",
    green: "_1h6d18uw",
    teal: "_1h6d1ug6",
    purple: "_1h6d157s",
    lime: "_1h6dn0nx",
    magenta: "_1h6d1lf6",
    orange: "_1h6dh727",
    grey: "_1h6d14je",
    standardLink: "_1h6d14je",
    blueLight: "_1h6duisw",
    redLight: "_1h6da2c0",
    yellowLight: "_1h6deh2r",
    greenLight: "_1h6d18uw",
    tealLight: "_1h6d1ug6",
    purpleLight: "_1h6d157s",
    limeLight: "_1h6dn0nx",
    magentaLight: "_1h6d1lf6",
    orangeLight: "_1h6dh727",
    greyLight: "_1h6d14je"
};
const $28f30ada25f4e7a3$var$baseStyles = null;
const $28f30ada25f4e7a3$var$interactiveStyles = null;
const $28f30ada25f4e7a3$var$focusRingStyles = null;
const $28f30ada25f4e7a3$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    if (color === 'gray') // internally we use 'grey' for gray color so that we can make migration easier behind the ff (gray will work with and without ff now)
    color = 'grey';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        ...other,
        ref: ref,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            "_zulp1b66 _2rko12b0 _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3i1k92 _kqswh2mm _4cvr1h6o _bfhksm61 _syazi7uo _80om73ad",
            isInteractive && "_1e38dfik _7glxv77o",
            isLink && "_irr31dpa _1di6fcek",
            $28f30ada25f4e7a3$var$borderColors[color],
            className
        ]),
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$28f30ada25f4e7a3$export$2e2bcd8739ae039 = $28f30ada25f4e7a3$var$BaseTag;

});

parcelRegister("1GUMH", function(module, exports) {
$parcel$export(module.exports, "default", () => $d084c83fbf5a9d97$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $d084c83fbf5a9d97$var$beforeElementStyles = null;
const $d084c83fbf5a9d97$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            "_1e0c1txw _4t3i1j6v _4cvr1h6o _1bah1h6o _152tze3t"
        ])
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d084c83fbf5a9d97$export$2e2bcd8739ae039 = $d084c83fbf5a9d97$var$Before;

});

parcelRegister("a6y6t", function(module, exports) {
$parcel$export(module.exports, "getLozengeAppearance", () => $6a7d97f96c3ca241$export$4d9e331cafeacb9d);
/**
 * Maps Tag color values to Lozenge appearance values.
 * Used for migration_fallback rendering when feature flag is off.
 */ const $6a7d97f96c3ca241$var$colorToLozengeAppearanceMap = {
    gray: 'default',
    grey: 'default',
    lime: 'success',
    green: 'success',
    blue: 'inprogress',
    red: 'removed',
    purple: 'new',
    yellow: 'moved',
    orange: 'moved',
    magenta: 'new',
    teal: 'inprogress',
    grayLight: 'default',
    greyLight: 'default',
    limeLight: 'success',
    greenLight: 'success',
    blueLight: 'inprogress',
    redLight: 'removed',
    purpleLight: 'new',
    yellowLight: 'moved',
    orangeLight: 'moved',
    magentaLight: 'new',
    tealLight: 'inprogress'
};
function $6a7d97f96c3ca241$export$4d9e331cafeacb9d(color) {
    return $6a7d97f96c3ca241$var$colorToLozengeAppearanceMap[color || 'gray'] || 'default';
}

});

parcelRegister("6czJH", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a2f700035d6dacb$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $aViyV = parcelRequire("aViyV");
const $8a2f700035d6dacb$var$baseStyles = null;
const $8a2f700035d6dacb$var$linkStyles = null;
const $8a2f700035d6dacb$var$hasAfterStyles = null;
const $8a2f700035d6dacb$var$Content = ({ isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent, testId: testId })=>{
    const Link = linkComponent ?? 'a';
    const normalizedText = (0, $aViyV.getTagText)(text);
    if (href) return /*#__PURE__*/ $4fqPo.createElement(Link, {
        href: href,
        "data-color": color,
        "data-testid": testId ? `${testId}--link` : undefined,
        className: (0, $ltgDR.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazi7uo _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
    else return /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            "_11c8fhey _1reo15vq _18m915vq _p12ff6dh _1bto1l2s _o5721q9c",
            isRemovable && "_p12f1lit"
        ])
    }, normalizedText);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8a2f700035d6dacb$export$2e2bcd8739ae039 = $8a2f700035d6dacb$var$Content;

});


parcelRegister("kvJ0Y", function(module, exports) {
$parcel$export(module.exports, "useSelectGetStyles", () => $1fb36926f6bfe6ff$export$2a533455c10aa11f);
/**
 * Hook to consume the SelectGetStylesContext.
 *
 * @internal — not part of the public API
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $eZfF2 = parcelRequire("eZfF2");
const $1fb36926f6bfe6ff$export$2a533455c10aa11f = ()=>(0, $4fqPo.useContext)((0, $eZfF2.SelectGetStylesContext));

});
parcelRegister("eZfF2", function(module, exports) {
$parcel$export(module.exports, "SelectGetStylesContext", () => $aaf6b1114ac265f6$export$50727c0a52da4015);
/**
 * Internal context used to pass the original Select instance's getStyles function
 * down to components like MultiValue, without polluting the public CommonProps API.
 *
 * This allows MultiValue to detect whether getStyles has been overridden on a
 * component instance (e.g. via a custom component wrapper passing a different
 * getStyles prop), by comparing props.getStyles against the original.
 *
 * @internal — not part of the public API
 */ 
var $4fqPo = parcelRequire("4fqPo");
const $aaf6b1114ac265f6$export$50727c0a52da4015 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);

});


parcelRegister("hH5l6", function(module, exports) {
$parcel$export(module.exports, "MultiValueLabel", () => $84c4b119fb756d7e$export$544aeea2a5ce08ee);
/* multi-value-label.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value-label.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");
const $84c4b119fb756d7e$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $84c4b119fb756d7e$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $84c4b119fb756d7e$var$multiValueLabelStyles.root,
            isDisabled && $84c4b119fb756d7e$var$multiValueLabelStyles.disabled,
            hasEllipsis && $84c4b119fb756d7e$var$multiValueLabelStyles.ellipsis,
            (0, $9h99w.cx)(className, xcss, '-MultiValueLabel')
        ])
    }, children);
};

});


parcelRegister("323Xo", function(module, exports) {
$parcel$export(module.exports, "MultiValueRemove", () => $d91ada24c8c01329$export$8e1fd1a40e7a2f4a);
/* multi-value-remove.tsx generated by @compiled/babel-plugin v0.37.1 */ /* multi-value-remove.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $9RW5e = parcelRequire("9RW5e");
const $d91ada24c8c01329$var$disabledStyles = null;
const $d91ada24c8c01329$var$enabledStyles = null;
const $d91ada24c8c01329$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
function $d91ada24c8c01329$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ...innerProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $d91ada24c8c01329$var$multiValueRemoveStyles.root,
            isFocused && $d91ada24c8c01329$var$multiValueRemoveStyles.focused,
            (0, $9h99w.cx)(className, xcss, '-MultiValueRemove')
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $ltgDR.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
        label: "",
        color: "currentColor",
        size: "small"
    })));
}

});

parcelRegister("iRYSb", function(module, exports) {
$parcel$export(module.exports, "default", () => $edc5093a26f711c4$export$2e2bcd8739ae039);
/* option.tsx generated by @compiled/babel-plugin v0.37.1 */ /* option.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $edc5093a26f711c4$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
const $edc5093a26f711c4$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $edc5093a26f711c4$var$optionStyles.root,
            isFocused && $edc5093a26f711c4$var$optionStyles.focused,
            isSelected && $edc5093a26f711c4$var$optionStyles.selected,
            isFocused && isSelected && $edc5093a26f711c4$var$optionStyles.focusedSelected,
            isDisabled && $edc5093a26f711c4$var$optionStyles.disabled,
            (0, $9h99w.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$edc5093a26f711c4$export$2e2bcd8739ae039 = $edc5093a26f711c4$var$Option;

});

parcelRegister("anFpC", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca5625022838afab$export$2e2bcd8739ae039);
/* placeholder.tsx generated by @compiled/babel-plugin v0.37.1 */ /* placeholder.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $ca5625022838afab$var$placeholderStyles = {
    root: "_nd5l1sux _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
const $ca5625022838afab$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $ca5625022838afab$var$placeholderStyles.root,
            isDisabled && $ca5625022838afab$var$placeholderStyles.disabled,
            (0, $9h99w.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ca5625022838afab$export$2e2bcd8739ae039 = $ca5625022838afab$var$Placeholder;

});

parcelRegister("3FW9d", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d7f1de1d2957268$export$2e2bcd8739ae039);
/* single-value.tsx generated by @compiled/babel-plugin v0.37.1 */ /* single-value.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9h99w = parcelRequire("9h99w");

var $lgGqQ = parcelRequire("lgGqQ");
const $5d7f1de1d2957268$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _1pfhidpf _12l2v77o _6rthidpf _ahbqv77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $5d7f1de1d2957268$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $lgGqQ.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $ltgDR.default)([
            $5d7f1de1d2957268$var$styles.root,
            isDisabled && $5d7f1de1d2957268$var$styles.disalbed,
            (0, $9h99w.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5d7f1de1d2957268$export$2e2bcd8739ae039 = $5d7f1de1d2957268$var$SingleValue;

});


parcelRegister("lBPoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $48eaca6437a27c2f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $lszf6 = parcelRequire("lszf6");

var $geWWn = parcelRequire("geWWn");

var $lLh34 = parcelRequire("lLh34");

var $bcOG6 = parcelRequire("bcOG6");
const $48eaca6437a27c2f$var$ErrorMessage = ({ onRetry: onRetry })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = (0, $4fqPo.useCallback)(()=>{
        onRetry === null || onRetry === void 0 || onRetry();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledBox), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #505258)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bcOG6.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bcOG6.default).retryMessage)));
};
var $48eaca6437a27c2f$export$2e2bcd8739ae039 = $48eaca6437a27c2f$var$ErrorMessage;

});
parcelRegister("lLh34", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $08e49f225897108c$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $08e49f225897108c$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $08e49f225897108c$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $08e49f225897108c$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $08e49f225897108c$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $08e49f225897108c$export$6833d6d22987ee7f);
$parcel$export(module.exports, "StyledInvalidCheckboxOption", () => $08e49f225897108c$export$e786733cafde97b9);
/* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766 */ 
var $9QAmg = parcelRequire("9QAmg");
const $08e49f225897108c$export$30c615a45297e297 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-0"
})({
    marginRight: "var(--ds-space-025, 2px)",
    textAlign: 'center',
    width: '32px'
});
const $08e49f225897108c$export$d675f139b342d51a = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${props.height || 128}px`,
        justifyContent: 'center'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ iconSize: iconSize })=>iconSize ? `svg {
          width: ${iconSize}px;
          height: ${iconSize}px;
        }` : '');
const $08e49f225897108c$export$31ea92f3997410dd = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-2"
})({
    font: "var(--ds-font-heading-xsmall, normal 653 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginTop: "var(--ds-space-100, 8px)"
});
const $08e49f225897108c$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-3"
})({
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    display: 'flex',
    padding: "var(--ds-space-050, 4px)"
});
const $08e49f225897108c$export$94756becb802e330 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-4"
})({
    cursor: 'pointer',
    color: "var(--ds-text-subtlest, #6B6E76)",
    '&:hover, &:focus': {
        color: "var(--ds-text-subtle, #505258)"
    }
});
const $08e49f225897108c$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-5"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.displayFlag ? 'block' : 'none'
    }));
const $08e49f225897108c$export$e786733cafde97b9 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-12oo4m7-6"
})({
    backgroundColor: "var(--ds-background-danger, #FFECEB)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        backgroundColor: 'inherit !important'
    }
});

});

parcelRegister("bcOG6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ff47be3d0ccaade$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $8ff47be3d0ccaade$var$message = (0, $6BhDL.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});
var $8ff47be3d0ccaade$export$2e2bcd8739ae039 = $8ff47be3d0ccaade$var$message;

});


parcelRegister("78Til", function(module, exports) {
$parcel$export(module.exports, "LoadingMessage", () => $1fe0186d0bbb2e34$export$e928a71d039d3102);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $5qWT2 = parcelRequire("5qWT2");

var $lLh34 = parcelRequire("lLh34");

var $2Qeo9 = parcelRequire("2Qeo9");
const $1fe0186d0bbb2e34$export$e928a71d039d3102 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $2Qeo9.default).loadingMessage)));

});
parcelRegister("2Qeo9", function(module, exports) {
$parcel$export(module.exports, "default", () => $37b04ecc3d4e14aa$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $37b04ecc3d4e14aa$var$message = (0, $6BhDL.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});
var $37b04ecc3d4e14aa$export$2e2bcd8739ae039 = $37b04ecc3d4e14aa$var$message;

});


parcelRegister("aknis", function(module, exports) {
$parcel$export(module.exports, "default", () => $7db8fe0663f8c717$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $lszf6 = parcelRequire("lszf6");

var $3inVz = parcelRequire("3inVz");
const $7db8fe0663f8c717$var$ShowMoreButton = ({ onShowMore: onShowMore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $3inVz.default).showMoreButtonText));
var $7db8fe0663f8c717$export$2e2bcd8739ae039 = $7db8fe0663f8c717$var$ShowMoreButton;

});
parcelRegister("3inVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f6b28b2e2a31671$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $8f6b28b2e2a31671$var$message = (0, $6BhDL.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});
var $8f6b28b2e2a31671$export$2e2bcd8739ae039 = $8f6b28b2e2a31671$var$message;

});


parcelRegister("cgLoh", function(module, exports) {
$parcel$export(module.exports, "LoadingWrapper", () => $8132c8813c787b97$export$43a792a870d28db2);

var $9QAmg = parcelRequire("9QAmg");
const $8132c8813c787b97$export$43a792a870d28db2 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-8ouqtd-0"
})({
    display: 'flex',
    justifyContent: 'center',
    margin: `${"var(--ds-space-050, 4px)"} 0`
});

});


parcelRegister("5CmOQ", function(module, exports) {
$parcel$export(module.exports, "PaginationDetails", () => $3f691205be2ded47$export$33eb0288c0936a84);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $gJEVG = parcelRequire("gJEVG");

var $dUzNT = parcelRequire("dUzNT");
const $3f691205be2ded47$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dUzNT.PaginationDetailsStyled), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
        ...(0, $gJEVG.default).ofTotalCount,
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    }));
var $3f691205be2ded47$export$2e2bcd8739ae039 = $3f691205be2ded47$export$33eb0288c0936a84;

});
parcelRegister("gJEVG", function(module, exports) {
$parcel$export(module.exports, "default", () => $40f40185aad032f3$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $40f40185aad032f3$var$message = (0, $6BhDL.defineMessages)({
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Text shown in a paginated picker indicating how many items are currently loaded versus the total available. The placeholder {itemsCount} is the number of currently visible items and {totalCount} is the total number of items.'
    }
});
var $40f40185aad032f3$export$2e2bcd8739ae039 = $40f40185aad032f3$var$message;

});

parcelRegister("dUzNT", function(module, exports) {
$parcel$export(module.exports, "PaginationDetailsStyled", () => $e461854c54914214$export$fff9218028c24180);

var $9QAmg = parcelRequire("9QAmg");
const $e461854c54914214$export$fff9218028c24180 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-2jljtl-0"
})({
    flex: 1,
    textAlign: 'right',
    margin: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #6B6E76)"
});

});


parcelRegister("cxuyz", function(module, exports) {
$parcel$export(module.exports, "selectComponents", () => $91cb9eca2cf51798$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "LocalBaseSelect", () => $91cb9eca2cf51798$export$51cc13ac81e51592);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");
var $4MCQn = parcelRequire("4MCQn");

var $lv3so = parcelRequire("lv3so");

var $l1bcS = parcelRequire("l1bcS");

var $iiq0i = parcelRequire("iiq0i");

var $4iCDe = parcelRequire("4iCDe");

var $EidJH = parcelRequire("EidJH");

var $8l5wm = parcelRequire("8l5wm");

var $hmWer = parcelRequire("hmWer");
const $91cb9eca2cf51798$export$c34d65c0f5a1c617 = {
    Control: $iiq0i.Control,
    DropdownIndicator: $4iCDe.DropdownIndicator,
    LoadingIndicator: null,
    Menu: $EidJH.Menu,
    Option: $hmWer.Option
};
const $91cb9eca2cf51798$var$onIsOptionDisabled = (option)=>'error' in option ? !!option.error : false;
const $91cb9eca2cf51798$export$51cc13ac81e51592 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(({ onFilterOption: onFilterOption, placeholder: placeholder, ...restProps }, ref)=>{
    const intl = (0, $4MCQn.default)();
    const { ariaLabel: ariaLabelProp, onInputChange: onInputChangeProp, inputValue: inputValueProp } = restProps;
    const [inputValue, setInputValue] = (0, $4fqPo.useState)(inputValueProp || '');
    const onInputChange = (0, $4fqPo.useCallback)((newValue, actionMeta)=>{
        /**
     * Do not clear the filter input value when an input is selected or blurred.
     * NOTE: We are also returning when 'menu-close' event are triggered,
     * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
     * */ if ([
            (0, $l1bcS.MetaActions).setValue,
            (0, $l1bcS.MetaActions).inputBlur,
            (0, $l1bcS.MetaActions).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp === null || onInputChangeProp === void 0 || onInputChangeProp(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lv3so.default), {
        ...restProps,
        ref: ref,
        label: ariaLabelProp || intl.formatMessage((0, $8l5wm.default).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: true,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: ()=>intl.formatMessage((0, $8l5wm.default).noOptionsMessage),
        onInputChange: onInputChange,
        isOptionDisabled: $91cb9eca2cf51798$var$onIsOptionDisabled,
        filterOption: onFilterOption,
        placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $8l5wm.default).searchPlaceholder)
    });
});
$91cb9eca2cf51798$export$51cc13ac81e51592.displayName = 'LocalBaseSelect';

});
parcelRegister("lv3so", function(module, exports) {
$parcel$export(module.exports, "default", () => $36854b31132c1502$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $jQXWT = parcelRequire("jQXWT");
var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $i1yhA = parcelRequire("i1yhA");
const $36854b31132c1502$var$packageName = undefined;
const $36854b31132c1502$var$packageVersion = undefined;
const $36854b31132c1502$var$createAndFireEventOnAtlaskit = (0, $jQXWT.default)('atlaskit');
const $36854b31132c1502$var$Select = (0, $apbG6.default)({
    componentName: 'select',
    packageName: $36854b31132c1502$var$packageName,
    packageVersion: $36854b31132c1502$var$packageVersion
})((0, $as4kh.default)({
    onChange: $36854b31132c1502$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $36854b31132c1502$var$packageName,
            packageVersion: $36854b31132c1502$var$packageVersion
        }
    })
})((0, $i1yhA.SelectWithoutAnalytics)));
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$36854b31132c1502$export$2e2bcd8739ae039 = $36854b31132c1502$var$Select;

});
parcelRegister("jQXWT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d26b1671ae6bc4c$export$2e2bcd8739ae039);
var $4d26b1671ae6bc4c$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("i1yhA", function(module, exports) {
$parcel$export(module.exports, "SelectWithoutAnalytics", () => $9c06c33b770d667b$export$d1de3b251ccaa8a3);

var $7o9pt = parcelRequire("7o9pt");

var $cOaLL = parcelRequire("cOaLL");
const $9c06c33b770d667b$export$d1de3b251ccaa8a3 = (0, $cOaLL.default)((0, $7o9pt.default));

});
parcelRegister("7o9pt", function(module, exports) {
$parcel$export(module.exports, "default", () => $021c81f3407372b9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5VSzD = parcelRequire("5VSzD");

var $k4MJ3 = parcelRequire("k4MJ3");

var $2QceZ = parcelRequire("2QceZ");
const $021c81f3407372b9$var$AsyncSelect = /*#__PURE__*/ (0, $4fqPo.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $k4MJ3.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $2QceZ.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5VSzD.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$021c81f3407372b9$export$2e2bcd8739ae039 = $021c81f3407372b9$var$AsyncSelect;

});
parcelRegister("5VSzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $be19959b108bb2ba$export$2e2bcd8739ae039);
/* select.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $SbPqW = parcelRequire("SbPqW");

var $11QcA = parcelRequire("11QcA");

var $c1tmZ = parcelRequire("c1tmZ");

var $3H4LK = parcelRequire("3H4LK");

var $dvVVy = parcelRequire("dvVVy");
var $dRl9j = parcelRequire("dRl9j");
var $izn4k = parcelRequire("izn4k");
var $3f6hc = parcelRequire("3f6hc");

var $fbHBj = parcelRequire("fbHBj");

var $lEjML = parcelRequire("lEjML");

var $m6DuV = parcelRequire("m6DuV");

var $htZ9W = parcelRequire("htZ9W");

var $5AFHe = parcelRequire("5AFHe");

var $kguEb = parcelRequire("kguEb");

var $iZBgo = parcelRequire("iZBgo");

var $1v39A = parcelRequire("1v39A");

var $e5kSj = parcelRequire("e5kSj");

var $g2Jhd = parcelRequire("g2Jhd");

var $aXBkL = parcelRequire("aXBkL");

var $60DN5 = parcelRequire("60DN5");

var $iYpKn = parcelRequire("iYpKn");

var $bLgSU = parcelRequire("bLgSU");

var $eZfF2 = parcelRequire("eZfF2");

var $c5Xvi = parcelRequire("c5Xvi");

var $ezTdO = parcelRequire("ezTdO");
const $be19959b108bb2ba$var$noop = (0, $c1tmZ.default);
function $be19959b108bb2ba$var$notNullish(item) {
    return item != null;
}
function $be19959b108bb2ba$var$scrollIntoView(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) (0, $bLgSU.scrollTo)(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) (0, $bLgSU.scrollTo)(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $be19959b108bb2ba$var$isMobileDevice() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
function $be19959b108bb2ba$var$isTouchCapable() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Filters out unsupported selectors (e.g., pseudo-classes, complex selectors) from a styles object.
 * @param styles - The styles object to filter.
 * @returns A new object containing only supported styles.
 */ const $be19959b108bb2ba$var$filterUnsupportedSelectors = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
const $be19959b108bb2ba$var$elemBeforeCSS = null;
const $be19959b108bb2ba$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: $be19959b108bb2ba$var$isTouchCapable(),
    captureMenuScroll: !$be19959b108bb2ba$var$isTouchCapable(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5AFHe.createFilter)(),
    formatGroupLabel: (0, $dvVVy.formatGroupLabel),
    getOptionLabel: (0, $dRl9j.getOptionLabel),
    getOptionValue: (0, $izn4k.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $3f6hc.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !$be19959b108bb2ba$var$isMobileDevice(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $be19959b108bb2ba$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $be19959b108bb2ba$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $be19959b108bb2ba$var$isOptionSelected(props, option, selectValue);
    const label = $be19959b108bb2ba$var$getOptionLabel(props, option);
    const value = $be19959b108bb2ba$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $be19959b108bb2ba$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$be19959b108bb2ba$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$be19959b108bb2ba$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $be19959b108bb2ba$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $be19959b108bb2ba$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter($be19959b108bb2ba$var$notNullish);
}
function $be19959b108bb2ba$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $be19959b108bb2ba$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $be19959b108bb2ba$var$buildFocusableOptions(props, selectValue) {
    return $be19959b108bb2ba$var$buildFocusableOptionsFromCategorizedOptions($be19959b108bb2ba$var$buildCategorizedOptions(props, selectValue));
}
function $be19959b108bb2ba$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$be19959b108bb2ba$var$shouldHideSelectedOptions(props) || !isSelected) && $be19959b108bb2ba$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $be19959b108bb2ba$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $be19959b108bb2ba$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $be19959b108bb2ba$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    var _focusableOptionsWith;
    const focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find((option)=>option.data === focusedOption)) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
const $be19959b108bb2ba$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $be19959b108bb2ba$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $be19959b108bb2ba$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $be19959b108bb2ba$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $be19959b108bb2ba$var$getOptionValue(props, option);
    return selectValue.some((i)=>$be19959b108bb2ba$var$getOptionValue(props, i) === candidate);
}
function $be19959b108bb2ba$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $be19959b108bb2ba$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $be19959b108bb2ba$var$instanceId = 1;
class $be19959b108bb2ba$export$2e2bcd8739ae039 extends (0, $4fqPo.Component) {
    static #_ = this.defaultProps = $be19959b108bb2ba$export$9c21a3269931e1e6;
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props), this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: '',
            controlElement: null
        }, // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false, this.isComposing = false, this.initialTouchX = 0, this.initialTouchY = 0, this.openAfterFocus = false, this.scrollToFocusedOptionOnUpdate = false, // Cleanup for a pending document `pointerup` listener registered by
        // `openMenuAfterPointerUp`. See that method for the full rationale.
        this.deferredOpenMenuCleanup = null, // Refs
        // ------------------------------
        this.controlRef = null, this.getControlRef = (ref)=>{
            this.controlRef = ref;
            // Mirror the ref into state on the top-layer path so
            // `MenuPortalTopLayer`'s layout effects react to the anchor attaching.
            // Skip the null-ref (unmount) case: setState during unmount is unsafe
            // and the state is dropped with the instance anyway.
            if (ref === null) return;
            if (this.state.controlElement !== ref && (0, $3H4LK.fg)('platform-dst-top-layer')) this.setState({
                controlElement: ref
            });
        }, this.focusedOptionRef = null, this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        }, this.menuListRef = null, this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        }, this.inputRef = null, this.getInputRef = (ref)=>{
            this.inputRef = ref;
        }, // aliased for consumers
        this.focus = this.focusInput, this.blur = this.blurInput, this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        }, this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        }, this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $g2Jhd.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $g2Jhd.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $c5Xvi.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $c5Xvi.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        }, this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $ezTdO.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        }, this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $ezTdO.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        }, this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $ezTdO.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        }, // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $be19959b108bb2ba$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        }, this.getFocusableOptionsWithIds = ()=>{
            return $be19959b108bb2ba$var$buildFocusableOptionsWithIds($be19959b108bb2ba$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        }, this.getValue = ()=>this.state.selectValue, this.cx = (...args)=>(0, $kguEb.classNames)(this.props.classNamePrefix, ...args), this.getOptionLabel = (data)=>{
            return $be19959b108bb2ba$var$getOptionLabel(this.props, data);
        }, this.getOptionValue = (data)=>{
            return $be19959b108bb2ba$var$getOptionValue(this.props, data);
        }, this.getStyles = (key, props)=>{
            const base = {
                boxSizing: 'border-box'
            };
            const custom = this.props.styles[key];
            if (custom) return $be19959b108bb2ba$var$filterUnsupportedSelectors(custom(base, props));
            return base;
        }, this.getClassNames = (key, props)=>{
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        }, this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        }, this.getComponents = ()=>{
            return (0, $fbHBj.defaultComponents)(this.props);
        }, this.buildCategorizedOptions = ()=>$be19959b108bb2ba$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [], this.buildFocusableOptions = ()=>$be19959b108bb2ba$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions()), this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [], // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        }, // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        }, this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        }, this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenuAfterPointerUp('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        }, this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenuAfterPointerUp('first');
            event.preventDefault();
        }, this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        }, this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $1v39A.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        }, this.onCompositionStart = ()=>{
            this.isComposing = true;
        }, this.onCompositionEnd = ()=>{
            this.isComposing = false;
        }, this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        }, this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        }, this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        }, this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        }, this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        }, this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        }, // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        }, this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) {
                // `openAfterFocus` always follows a pointer gesture, so defer past
                // pointerup. `openMenuOnFocus` alone can come from a keyboard tab
                // with no pointer gesture in flight, so open synchronously.
                if (this.openAfterFocus) this.openMenuAfterPointerUp('first');
                else this.openMenu('first');
            }
            this.openAfterFocus = false;
        }, this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $3H4LK.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        }, this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        }, this.shouldHideSelectedOptions = ()=>{
            return $be19959b108bb2ba$var$shouldHideSelectedOptions(this.props);
        }, // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        }, // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        }, this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$be19959b108bb2ba$var$instanceId);
        this.state.selectValue = (0, $iZBgo.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $be19959b108bb2ba$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $iZBgo.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $be19959b108bb2ba$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $be19959b108bb2ba$var$buildFocusableOptionsWithIds($be19959b108bb2ba$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $be19959b108bb2ba$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $be19959b108bb2ba$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $be19959b108bb2ba$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $ezTdO.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) $be19959b108bb2ba$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            $be19959b108bb2ba$var$scrollIntoView(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        this.cancelDeferredOpenMenu();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    /**
   * Whether to defer the menu open past the in-flight pointer gesture.
   * Any renderer that drives a `popover="auto"` element must, otherwise
   * the browser's light-dismiss runs on the matching `pointerup` and
   * closes the menu immediately. Today only the top-layer path needs it.
   */ shouldDeferOpenPastPointerUp() {
        return (0, $3H4LK.fg)('platform-dst-top-layer');
    }
    /**
   * Open the menu after the current pointer gesture, instead of
   * synchronously inside `mousedown`.
   *
   * On the top-layer path the menu is a `popover="auto"` element. The
   * browser captures the pointerdown target before the popover exists, so
   * opening synchronously gets immediately light-dismissed on pointerup
   * (and the matching `beforetoggle: closed` is not cancellable). Deferring
   * to the next `pointerup` avoids that.
   *
   * We listen for `pointerup` rather than `click` because `pointerup` is
   * the exact event the browser uses for light-dismiss (earliest safe
   * moment), always fires (`click` requires same down/up target), is hard
   * to lose to upstream `stopPropagation`, and is uniform across input
   * types. Off the top-layer path we open synchronously as before.
   */ openMenuAfterPointerUp(focusOption) {
        if (!this.shouldDeferOpenPastPointerUp()) {
            this.openMenu(focusOption);
            return;
        }
        // A second pointerdown can land before the queued pointerup if the
        // user releases and re-clicks very quickly. Replace any pending
        // deferred open with the latest one so we never stack listeners.
        this.cancelDeferredOpenMenu();
        const handlePointerUp = ()=>{
            this.deferredOpenMenuCleanup = null;
            this.openMenu(focusOption);
        };
        this.deferredOpenMenuCleanup = (0, $lMcEJ.bind)(document, {
            type: 'pointerup',
            listener: handlePointerUp,
            options: {
                capture: true,
                once: true
            }
        });
    }
    cancelDeferredOpenMenu() {
        if (this.deferredOpenMenuCleanup) {
            this.deferredOpenMenuCleanup();
            this.deferredOpenMenuCleanup = null;
        }
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $11QcA.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            var _this$inputRef;
            (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) {
                    var _this$inputRef2;
                    (_this$inputRef2 = this.inputRef) === null || _this$inputRef2 === void 0 || _this$inputRef2.setAttribute('aria-label', normalizedLabel);
                } else {
                    var _this$inputRef3;
                    (_this$inputRef3 = this.inputRef) === null || _this$inputRef3 === void 0 || _this$inputRef3.removeAttribute('aria-label');
                }
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options === null || options === void 0 ? void 0 : options.find((option)=>{
            var _groupCandidate$optio;
            const groupCandidate = option;
            return ((_groupCandidate$optio = groupCandidate.options) === null || _groupCandidate$optio === void 0 ? void 0 : _groupCandidate$optio.some(isOptionFocused)) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = (groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) ?? 0;
            const totalLength = options === null || options === void 0 ? void 0 : options.reduce((acc, currentGroup)=>{
                var _group$options;
                const group = currentGroup;
                acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options === null || options === void 0 ? void 0 : options.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $be19959b108bb2ba$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $be19959b108bb2ba$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $be19959b108bb2ba$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        var _this$props$component;
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        }
        // Auto-render elemBefore in dropdown menu only if formatOptionLabel is not provided
        // and no custom Option component is provided (custom Option components may already
        // render elemBefore themselves, causing it to appear twice)
        if (context === 'menu' && !this.props.formatOptionLabel && !((_this$props$component = this.props.components) !== null && _this$props$component !== void 0 && _this$props$component.Option) && (0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const elemBefore = data.elemBefore;
            if (elemBefore) {
                const label = this.getOptionLabel(data);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
                    className: (0, $ltgDR.default)([
                        "_zulpu2gc _1e0c1txw _4cvr1h6o"
                    ])
                }, elemBefore, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", null, label));
            }
        }
        return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $3H4LK.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && !(0, $3H4LK.fg)('select_issearchable_aria-readonly_fix') && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lEjML.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: $be19959b108bb2ba$var$noop,
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            }
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                }
            }, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $htZ9W.default), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                    ...testId && {
                        'data-testid': `${testId}-select--listbox-container`
                    }
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iYpKn.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>{
                var _this$inputRef4, _this$inputRef5;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                        ...this.props['UNSAFE_is_experimental_generic'] && {
                            'aria-labelledby': ((_this$inputRef4 = this.inputRef) === null || _this$inputRef4 === void 0 ? void 0 : _this$inputRef4.id) || this.getElementId('input')
                        },
                        'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                        id: this.getElementId('listbox'),
                        ...testId && {
                            'data-testid': `${testId}-select--listbox`
                        },
                        // add aditional label on listbox for safari to announce first option
                        ...(0, $11QcA.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                            'aria-describedby': ((_this$inputRef5 = this.inputRef) === null || _this$inputRef5 === void 0 ? void 0 : _this$inputRef5.id) || this.getElementId('input')
                        }
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
                    role: "list"
                }, menuUI) : menuUI);
            })));
        // On the top-layer path the menu always portals (into the top layer)
        // regardless of consumer `menuPortalTarget` / `menuPosition`. Off the
        // flag we keep the legacy "portal only when needed" behaviour.
        const shouldPortal = (0, $3H4LK.fg)('platform-dst-top-layer') || menuPortalTarget || menuPosition === 'fixed';
        if (!shouldPortal) return menuElement;
        // Top-layer path needs the state mirror so MenuPortalTopLayer re-renders
        // when the anchor attaches; legacy path keeps the direct ref read.
        const controlElementForPortal = (0, $3H4LK.fg)('platform-dst-top-layer') ? this.state.controlElement : this.controlRef;
        const menuPortal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: controlElementForPortal,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement);
        // The Provider plumbs the close signal to MenuPortalTopLayer; not
        // needed on the legacy path.
        if (!(0, $3H4LK.fg)('platform-dst-top-layer')) return menuPortal;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e5kSj.MenuPortalCloseContext).Provider, {
            value: this.handleOpenLayerObserverCloseSignal
        }, menuPortal);
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60DN5.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $m6DuV.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
            id: this.getElementId('multi-message'),
            hidden: true
        }, msg));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eZfF2.SelectGetStylesContext).Provider, {
            value: this.getStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd,
                ...testId && {
                    'data-testid': `${testId}-select--control`
                }
            },
            appearance: appearance,
            isInvalid: isInvalid,
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen,
            isCompact: isCompact
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled,
            isCompact: isCompact,
            innerProps: {
                ...testId && {
                    'data-testid': `${testId}-select--value-container`
                },
                ...commonProps.isMulti && commonProps.hasValue && !(0, $SbPqW.isAppleDevice)() && {
                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                    // DST Accessibility.
                    role: 'application'
                }
            }
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled,
            innerProps: {
                ...testId && {
                    'data-testid': `${testId}-select--indicators-container`
                }
            }
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), !(0, $3H4LK.fg)('platform-dst-top-layer') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aXBkL.NotifyOpenLayerObserver), {
            isOpen: this.props.menuIsOpen,
            onClose: this.handleOpenLayerObserverCloseSignal
        })));
    }
}

});
parcelRegister("SbPqW", function(module, exports) {
$parcel$export(module.exports, "isAppleDevice", () => $12bbe42702cd607d$export$e1865c3bedcd822b);
function $12bbe42702cd607d$var$testPlatform(re) {
    var _userAgentData;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_userAgentData = window.navigator['userAgentData']) === null || _userAgentData === void 0 ? void 0 : _userAgentData.platform) || window.navigator.platform) : false;
}
function $12bbe42702cd607d$var$isIPhone() {
    return $12bbe42702cd607d$var$testPlatform(/^iPhone/i);
}
function $12bbe42702cd607d$var$isIPad() {
    return $12bbe42702cd607d$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $12bbe42702cd607d$var$isMac() && navigator.maxTouchPoints > 1;
}
function $12bbe42702cd607d$var$isMac() {
    return $12bbe42702cd607d$var$testPlatform(/^Mac/i);
}
function $12bbe42702cd607d$var$isIOS() {
    return $12bbe42702cd607d$var$isIPhone() || $12bbe42702cd607d$var$isIPad();
}
function $12bbe42702cd607d$export$e1865c3bedcd822b() {
    return $12bbe42702cd607d$var$isMac() || $12bbe42702cd607d$var$isIOS();
}

});

parcelRegister("dvVVy", function(module, exports) {
$parcel$export(module.exports, "formatGroupLabel", () => $aa427ebc3ef16121$export$f4da216a6ca54656);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $aa427ebc3ef16121$export$f4da216a6ca54656 = (group)=>group.label;

});

parcelRegister("dRl9j", function(module, exports) {
$parcel$export(module.exports, "getOptionLabel", () => $6af6bf0cdffdabfc$export$dac6ace3020563ca);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $6af6bf0cdffdabfc$export$dac6ace3020563ca = (option)=>option.label;

});

parcelRegister("izn4k", function(module, exports) {
$parcel$export(module.exports, "getOptionValue", () => $9a9036d6a726796f$export$40be908210c5a79c);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $9a9036d6a726796f$export$40be908210c5a79c = (option)=>option.value;

});

parcelRegister("3f6hc", function(module, exports) {
$parcel$export(module.exports, "isOptionDisabled", () => $076ee47199e5d2be$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $076ee47199e5d2be$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("lEjML", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2472949ca01ae18$export$2e2bcd8739ae039);
/* dummy-input.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $a2472949ca01ae18$var$removeProps = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $a2472949ca01ae18$var$dummyInputStyles = null;
function $a2472949ca01ae18$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = $a2472949ca01ae18$var$removeProps(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $4fqPo.createElement("input", {
        ref: innerRef,
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

});

parcelRegister("m6DuV", function(module, exports) {
$parcel$export(module.exports, "default", () => $da410ab1e65a01f7$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $aXFQs = parcelRequire("aXFQs");

var $gczgB = parcelRequire("gczgB");
const $da410ab1e65a01f7$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $4fqPo.useMemo)(()=>({
            ...(0, $aXFQs.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $4fqPo.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $4fqPo.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gczgB.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gczgB.default), {
        "aria-live": ariaLive,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$da410ab1e65a01f7$export$2e2bcd8739ae039 = $da410ab1e65a01f7$var$LiveRegion;

});
parcelRegister("aXFQs", function(module, exports) {
$parcel$export(module.exports, "defaultAriaLiveMessages", () => $314308fc7fe8a17d$export$a7265767c78f9bae);
const $314308fc7fe8a17d$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};

});

parcelRegister("gczgB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5f920a5a981d7e9$export$2e2bcd8739ae039);
/* a11y-text.tsx generated by @compiled/babel-plugin v0.37.1 */ // Assistive text to describe visual elements. Hidden for sighted users.

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $f5f920a5a981d7e9$var$styles = null;
const $f5f920a5a981d7e9$var$A11yText = (props)=>/*#__PURE__*/ $4fqPo.createElement("span", {
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $f5f920a5a981d7e9$export$2e2bcd8739ae039 = $f5f920a5a981d7e9$var$A11yText;

});


parcelRegister("htZ9W", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5135f06139d2f31$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");

var $3H4LK = parcelRequire("3H4LK");

var $a96MM = parcelRequire("a96MM");
const $e5135f06139d2f31$var$noop = (0, $c1tmZ.default);
function $e5135f06139d2f31$var$getScrollParent(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
function $e5135f06139d2f31$var$isDocumentElement(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $e5135f06139d2f31$var$normalizedHeight(el) {
    if ($e5135f06139d2f31$var$isDocumentElement(el)) return window.innerHeight;
    return el.clientHeight;
}
function $e5135f06139d2f31$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e5135f06139d2f31$var$isDocumentElement(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $e5135f06139d2f31$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e5135f06139d2f31$var$getScrollTop(el) {
    if ($e5135f06139d2f31$var$isDocumentElement(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e5135f06139d2f31$var$animatedScrollTo(element, to, duration = 200, callback = $e5135f06139d2f31$var$noop) {
    const start = $e5135f06139d2f31$var$getScrollTop(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $e5135f06139d2f31$var$easeOutCubic(currentTime, start, change, duration);
        $e5135f06139d2f31$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $e5135f06139d2f31$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = $e5135f06139d2f31$var$getScrollParent(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : $e5135f06139d2f31$var$normalizedHeight(scrollParent);
    const scrollTop = $e5135f06139d2f31$var$getScrollTop(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5135f06139d2f31$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e5135f06139d2f31$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e5135f06139d2f31$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e5135f06139d2f31$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e5135f06139d2f31$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $e5135f06139d2f31$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
// NOTE: internal only
// eslint-disable-next-line @repo/internal/react/require-jsdoc
// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Menu placer__
 *
 * A menu placer {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $e5135f06139d2f31$var$MenuPlacer = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $4fqPo.useContext)((0, $a96MM.PortalPlacementContext)) || {};
    const ref = (0, $4fqPo.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $4fqPo.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $4fqPo.useState)(null);
    // The minimum height of the control
    const controlHeight = 38;
    (0, $4fqPo.useLayoutEffect)(()=>{
        // When the menu is hosted in the browser top layer, positioning, flipping
        // and viewport-fit are all handled by `@atlaskit/top-layer`. The placer
        // becomes a pass-through that only forwards `maxMenuHeight` as a cap.
        if ((0, $3H4LK.fg)('platform-dst-top-layer')) return;
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $e5135f06139d2f31$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $e5135f06139d2f31$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
var $e5135f06139d2f31$export$2e2bcd8739ae039 = $e5135f06139d2f31$var$MenuPlacer;

});

parcelRegister("5AFHe", function(module, exports) {
$parcel$export(module.exports, "createFilter", () => $1d784f26b7207914$export$5d81789ff4aeccdf);

var $jE04u = parcelRequire("jE04u");

var $5qNKx = parcelRequire("5qNKx");
const $1d784f26b7207914$var$memoizedStripDiacriticsForInput = (0, $jE04u.default)((0, $5qNKx.stripDiacritics));
const $1d784f26b7207914$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $1d784f26b7207914$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $1d784f26b7207914$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $1d784f26b7207914$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $1d784f26b7207914$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $1d784f26b7207914$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $1d784f26b7207914$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $5qNKx.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("5qNKx", function(module, exports) {
$parcel$export(module.exports, "stripDiacritics", () => $d3f19a03bbc60978$export$b5bee4b27048330b);
const $d3f19a03bbc60978$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $d3f19a03bbc60978$var$anyDiacritic = new RegExp('[' + $d3f19a03bbc60978$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $d3f19a03bbc60978$var$diacriticToBase = {};
for(let i = 0; i < $d3f19a03bbc60978$var$diacritics.length; i++){
    let diacritic = $d3f19a03bbc60978$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$d3f19a03bbc60978$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $d3f19a03bbc60978$export$b5bee4b27048330b = (str)=>{
    return str.replace($d3f19a03bbc60978$var$anyDiacritic, (match)=>$d3f19a03bbc60978$var$diacriticToBase[match]);
};

});


parcelRegister("kguEb", function(module, exports) {
$parcel$export(module.exports, "classNames", () => $23b15d34021b4e16$export$ce4ab0c55987d1ff);
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $23b15d34021b4e16$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $23b15d34021b4e16$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$23b15d34021b4e16$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}

});

parcelRegister("iZBgo", function(module, exports) {
$parcel$export(module.exports, "cleanValue", () => $6d01a9ced7deda0b$export$33f062f47f21a01);
const $6d01a9ced7deda0b$export$33f062f47f21a01 = (value)=>{
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};

});

parcelRegister("1v39A", function(module, exports) {
$parcel$export(module.exports, "isDocumentElement", () => $6387de1c155b117c$export$d8a62a489b442872);
function $6387de1c155b117c$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}

});

parcelRegister("g2Jhd", function(module, exports) {
$parcel$export(module.exports, "multiValueAsValue", () => $4fd8c0d326cd8af6$export$d1ca752ec761b95b);
function $4fd8c0d326cd8af6$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}

});

parcelRegister("aXBkL", function(module, exports) {
$parcel$export(module.exports, "NotifyOpenLayerObserver", () => $148581c8a12b49de$export$17baa7c95b6ba1b8);

var $1AxDb = parcelRequire("1AxDb");
function $148581c8a12b49de$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $1AxDb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("60DN5", function(module, exports) {
$parcel$export(module.exports, "default", () => $41e1101919c3197b$export$2e2bcd8739ae039);
/* required-input.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $c1tmZ = parcelRequire("c1tmZ");
const $41e1101919c3197b$var$styles = null;
const $41e1101919c3197b$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ $4fqPo.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $c1tmZ.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$41e1101919c3197b$export$2e2bcd8739ae039 = $41e1101919c3197b$var$RequiredInput;

});

parcelRegister("iYpKn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f93b440e4dd1c72$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $kdVio = parcelRequire("kdVio");

var $XHUGJ = parcelRequire("XHUGJ");
const $7f93b440e4dd1c72$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $7f93b440e4dd1c72$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $kdVio.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $XHUGJ.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        onClick: $7f93b440e4dd1c72$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}

});
parcelRegister("kdVio", function(module, exports) {
$parcel$export(module.exports, "default", () => $46da84c1d18b3a45$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $8nSua = parcelRequire("8nSua");
const $46da84c1d18b3a45$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $46da84c1d18b3a45$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $4fqPo.useRef)(false);
    const isTop = (0, $4fqPo.useRef)(false);
    const touchStart = (0, $4fqPo.useRef)(0);
    const scrollTarget = (0, $4fqPo.useRef)(null);
    const handleEventDelta = (0, $4fqPo.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $46da84c1d18b3a45$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $4fqPo.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $4fqPo.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $4fqPo.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $4fqPo.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $8nSua.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $4fqPo.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});
parcelRegister("8nSua", function(module, exports) {
$parcel$export(module.exports, "supportsPassiveEvents", () => $f1d45d3531feb14f$export$b0622a6911dbeaf5);
// ==============================
// Passive Event Detector
// ==============================

var $c1tmZ = parcelRequire("c1tmZ");
const $f1d45d3531feb14f$var$noop = (0, $c1tmZ.default);
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $f1d45d3531feb14f$var$passiveOptionAccessed = false;
const $f1d45d3531feb14f$var$options = {
    get passive () {
        return $f1d45d3531feb14f$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $f1d45d3531feb14f$var$w = typeof window !== 'undefined' ? window : {};
if ($f1d45d3531feb14f$var$w.addEventListener && $f1d45d3531feb14f$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $f1d45d3531feb14f$var$w.addEventListener('p', $f1d45d3531feb14f$var$noop, $f1d45d3531feb14f$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $f1d45d3531feb14f$var$w.removeEventListener('p', $f1d45d3531feb14f$var$noop, false);
}
const $f1d45d3531feb14f$export$b0622a6911dbeaf5 = $f1d45d3531feb14f$var$passiveOptionAccessed;

});


parcelRegister("XHUGJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c9aa87d9f9f7cd$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $86c9aa87d9f9f7cd$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $86c9aa87d9f9f7cd$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $86c9aa87d9f9f7cd$var$preventTouchMove(e) {
    e.preventDefault();
}
function $86c9aa87d9f9f7cd$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $86c9aa87d9f9f7cd$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $86c9aa87d9f9f7cd$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $86c9aa87d9f9f7cd$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $86c9aa87d9f9f7cd$var$activeScrollLocks = 0;
const $86c9aa87d9f9f7cd$var$listenerOptions = {
    capture: false,
    passive: false
};
function $86c9aa87d9f9f7cd$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $4fqPo.useRef)({});
    const scrollTarget = (0, $4fqPo.useRef)(null);
    const addScrollLock = (0, $4fqPo.useCallback)((touchScrollTarget)=>{
        if (!$86c9aa87d9f9f7cd$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $86c9aa87d9f9f7cd$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $86c9aa87d9f9f7cd$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($86c9aa87d9f9f7cd$var$LOCK_STYLES).forEach((key)=>{
                const val = $86c9aa87d9f9f7cd$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $86c9aa87d9f9f7cd$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $86c9aa87d9f9f7cd$var$preventTouchMove, $86c9aa87d9f9f7cd$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $86c9aa87d9f9f7cd$var$preventInertiaScroll, $86c9aa87d9f9f7cd$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $86c9aa87d9f9f7cd$var$allowTouchMove, $86c9aa87d9f9f7cd$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $86c9aa87d9f9f7cd$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $4fqPo.useCallback)((touchScrollTarget)=>{
        if (!$86c9aa87d9f9f7cd$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $86c9aa87d9f9f7cd$var$activeScrollLocks = Math.max($86c9aa87d9f9f7cd$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $86c9aa87d9f9f7cd$var$activeScrollLocks < 1) $86c9aa87d9f9f7cd$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $86c9aa87d9f9f7cd$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $86c9aa87d9f9f7cd$var$preventTouchMove, $86c9aa87d9f9f7cd$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $86c9aa87d9f9f7cd$var$preventInertiaScroll, $86c9aa87d9f9f7cd$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $86c9aa87d9f9f7cd$var$allowTouchMove, $86c9aa87d9f9f7cd$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("bLgSU", function(module, exports) {
$parcel$export(module.exports, "scrollTo", () => $60729c0b3a67be16$export$3f99968195accfaf);

var $1v39A = parcelRequire("1v39A");
function $60729c0b3a67be16$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ((0, $1v39A.isDocumentElement)(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}

});

parcelRegister("c5Xvi", function(module, exports) {
$parcel$export(module.exports, "singleValueAsValue", () => $04b2ea6be683e4b3$export$dea4763e29237f4c);
function $04b2ea6be683e4b3$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}

});

parcelRegister("ezTdO", function(module, exports) {
$parcel$export(module.exports, "valueTernary", () => $33c9cd7da6c2b509$export$40fb9515c784cc3b);
function $33c9cd7da6c2b509$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}

});


parcelRegister("2QceZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b561eb2d8708904$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $9b561eb2d8708904$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $4fqPo.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $4fqPo.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $4fqPo.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $4fqPo.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $4fqPo.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $4fqPo.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $4fqPo.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("cOaLL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab7c7780e8e2eb5f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $ab7c7780e8e2eb5f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { ariaLiveMessages: ariaLiveMessages, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $4fqPo.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $4fqPo.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: ()=>{
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error',
            ...restProps,
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});



parcelRegister("l1bcS", function(module, exports) {
$parcel$export(module.exports, "MetaActions", () => $7d13808f6cd2e6bd$export$50531cf3046c5956);
const $7d13808f6cd2e6bd$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("iiq0i", function(module, exports) {
$parcel$export(module.exports, "Control", () => $1715b8c8a83d1320$export$7a7fa4424cb20976);

var $4fqPo = parcelRequire("4fqPo");

var $lLh34 = parcelRequire("lLh34");
const $1715b8c8a83d1320$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledControl), {
        ...innerProps,
        ref: innerRef
    }, children);
};

});

parcelRegister("4iCDe", function(module, exports) {
$parcel$export(module.exports, "DropdownIndicator", () => $666a46807e70497b$export$ec98719d3db7f2e4);

var $4fqPo = parcelRequire("4fqPo");

var $hMwsV = parcelRequire("hMwsV");

var $8B6Ry = parcelRequire("8B6Ry");

var $fbHBj = parcelRequire("fbHBj");

var $lLh34 = parcelRequire("lLh34");
const $666a46807e70497b$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fbHBj.components).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.DropdownIndicatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.DisplayWrapper), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.CloseIconWrapper), {
        onClick: (event)=>{
            var _props$selectProps$on, _props$selectProps;
            event.preventDefault();
            (_props$selectProps$on = (_props$selectProps = props.selectProps).onInputChange) === null || _props$selectProps$on === void 0 || _props$selectProps$on.call(_props$selectProps, '', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMwsV))), {
        color: "currentColor",
        label: "",
        size: "small"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
        color: "currentColor",
        label: ""
    }))));

});

parcelRegister("EidJH", function(module, exports) {
$parcel$export(module.exports, "Menu", () => $8fd6f57070caf740$export$d9b273488cd8ce6f);

var $4fqPo = parcelRequire("4fqPo");
const $8fd6f57070caf740$export$d9b273488cd8ce6f = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);

});

parcelRegister("8l5wm", function(module, exports) {
$parcel$export(module.exports, "default", () => $db08a6872b55f64b$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $db08a6872b55f64b$var$message = (0, $6BhDL.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});
var $db08a6872b55f64b$export$2e2bcd8739ae039 = $db08a6872b55f64b$var$message;

});

parcelRegister("hmWer", function(module, exports) {
$parcel$export(module.exports, "Option", () => $2ff08b50aa316ea2$export$36d18380658d5d20);

var $4fqPo = parcelRequire("4fqPo");

var $geWWn = parcelRequire("geWWn");

var $bHhGt = parcelRequire("bHhGt");

var $8Mj6h = parcelRequire("8Mj6h");

var $lLh34 = parcelRequire("lLh34");
const $2ff08b50aa316ea2$export$36d18380658d5d20 = (props)=>{
    var _props$data;
    if ((_props$data = props.data) !== null && _props$data !== void 0 && _props$data.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLh34.StyledInvalidCheckboxOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bHhGt.CheckboxOption), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        label: "Test",
        color: "var(--ds-icon-danger, #C9372C)"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bHhGt.CheckboxOption), props);
};

});
parcelRegister("bHhGt", function(module, exports) {
$parcel$export(module.exports, "CheckboxOption", () => $6c1f83862744b3a3$export$d40cc97ecda916f9);
/* checkbox-option.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4frqK = parcelRequire("4frqK");
const $6c1f83862744b3a3$var$svgStyles = null;
const $6c1f83862744b3a3$var$CheckboxIcon = (props)=>{
    const { primaryColor: primaryColor, secondaryColor: secondaryColor, label: label } = props;
    return /*#__PURE__*/ $4fqPo.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            fill: secondaryColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $ltgDR.default)([
            "_1reo15vq _18m915vq _1bsb1tcg _4t3i1tcg _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $4fqPo.createElement("rect", {
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
const $6c1f83862744b3a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ $4fqPo.createElement((0, $4frqK.ControlOption), {
        Icon: $6c1f83862744b3a3$var$CheckboxIcon,
        ...props
    });

});
parcelRegister("4frqK", function(module, exports) {
$parcel$export(module.exports, "ControlOption", () => $a49c231e01a9260c$export$e41f7c07e51665da);
/* control-option.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $a49c231e01a9260c$var$optionStyles = {
    default: "_1e0c1txw _4cvr1h6o _1bsb1osq _uiztglyw _18ql1j7p _vchhusvi _85i51b66 _1q511b66 _bozgpxbi _y4tiutpp _bfhk1j28 _16qs1kw7 _syaz1kw7 _1di6fcek",
    focused: "_bfhk1dpa _16qsgkog _112e5u6v",
    disabled: "_syaz1gmx"
};
// the primary color represents the outer or background element
const $a49c231e01a9260c$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled) return "var(--ds-background-disabled, #0515240F)";
    else if (isSelected && isActive) return "var(--ds-background-selected-bold-pressed, #123263)";
    else if (isActive) return "var(--ds-background-selected-pressed, #8FB8F6)";
    else if (isFocused && isSelected) return "var(--ds-background-selected-bold-hovered, #1558BC)";
    else if (isFocused) return "var(--ds-surface, #FFFFFF)";
    else if (isSelected) return "var(--ds-background-selected-bold, #1868DB)";
    return "var(--ds-background-neutral, #0515240F)";
};
// the secondary color represents the radio dot or checkmark
const $a49c231e01a9260c$var$getSecondaryColor = ({ isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return "var(--ds-text-disabled, #080F214A)";
    else if (!isSelected) return 'transparent';
    return "var(--ds-surface, #FFFFFF)";
};
const $a49c231e01a9260c$var$iconStyles = {
    inherit: "_1u9j1r31 _1gqp1r31",
    default: "_1u9j1ihb _1gqp1ihb"
};
const $a49c231e01a9260c$var$baseIconStyles = null;
const $a49c231e01a9260c$var$baseOptionStyles = null;
const $a49c231e01a9260c$export$e41f7c07e51665da = (props)=>{
    const [isActive, setIsActive] = (0, $4fqPo.useState)(false);
    const onMouseDown = (0, $4fqPo.useCallback)(()=>setIsActive(true), []);
    const onMouseUp = (0, $4fqPo.useCallback)(()=>setIsActive(false), []);
    const { Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, cx: cx, className: className, isDisabled: isDisabled, isSelected: isSelected, isFocused: isFocused } = props;
    const classNames = (0, $4fqPo.useMemo)(()=>cx({
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }, className), [
        cx,
        isDisabled,
        isFocused,
        isSelected,
        className
    ]);
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            $a49c231e01a9260c$var$optionStyles.default,
            isFocused && $a49c231e01a9260c$var$optionStyles.focused,
            isDisabled && $a49c231e01a9260c$var$optionStyles.disabled,
            classNames
        ]),
        ref: innerRef,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: onMouseUp,
        ...innerProps
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _y4ti1b66 _16cu892t _1xci892t _59qxe4h9 _8y3xe4h9",
            isSelected || isActive || isDisabled ? $a49c231e01a9260c$var$iconStyles.inherit : $a49c231e01a9260c$var$iconStyles.default
        ])
    }, !!Icon ? /*#__PURE__*/ $4fqPo.createElement(Icon, {
        label: "",
        primaryColor: $a49c231e01a9260c$var$getPrimaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected,
            isFocused: isFocused,
            isActive: isActive
        }),
        secondaryColor: $a49c231e01a9260c$var$getSecondaryColor({
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        isFacadeDisabled: true
    }) : null), /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_16jlkb7n _1reo15vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};

});




parcelRegister("gopac", function(module, exports) {
$parcel$export(module.exports, "ShowFullListButton", () => $6220cff4fdcabdca$export$bf0956d66cd7566b);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $lszf6 = parcelRequire("lszf6");

var $eOl6E = parcelRequire("eOl6E");
const $6220cff4fdcabdca$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const handleShowFullList = (0, $4fqPo.useCallback)(()=>{
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $eOl6E.default).showFullListButtonText));
};
var $6220cff4fdcabdca$export$2e2bcd8739ae039 = $6220cff4fdcabdca$export$bf0956d66cd7566b;

});
parcelRegister("eOl6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $3548a5b8f17231e3$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $3548a5b8f17231e3$var$message = (0, $6BhDL.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});
var $3548a5b8f17231e3$export$2e2bcd8739ae039 = $3548a5b8f17231e3$var$message;

});


parcelRegister("esSyQ", function(module, exports) {
$parcel$export(module.exports, "Footer", () => $0fdc0f5eb35c153a$export$a06f1c675e846f6f);

var $9QAmg = parcelRequire("9QAmg");
const $0fdc0f5eb35c153a$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-1bj6bqn-0"
})({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width-selected, 2px)"}}`,
    paddingTop: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});

});


parcelRegister("gIgjO", function(module, exports) {
$parcel$export(module.exports, "default", () => $71bde9e828253ad2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $ujsU6 = parcelRequire("ujsU6");

var $4Dg0k = parcelRequire("4Dg0k");

var $iSjAZ = parcelRequire("iSjAZ");
const $71bde9e828253ad2$var$formatOptionLabel = (option)=>{
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4Dg0k.IconOptionLabel), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ujsU6.AvatarOptionLabel), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iSjAZ.LozengeOptionLabel), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null);
};
var $71bde9e828253ad2$export$2e2bcd8739ae039 = $71bde9e828253ad2$var$formatOptionLabel;

});
parcelRegister("ujsU6", function(module, exports) {
$parcel$export(module.exports, "AvatarOptionLabel", () => $92a02ed0ac5171ae$export$fe00f602c942368a);

var $4fqPo = parcelRequire("4fqPo");

var $aHUNw = parcelRequire("aHUNw");

var $jDYU4 = parcelRequire("jDYU4");
const $92a02ed0ac5171ae$export$fe00f602c942368a = ({ avatarOption: avatarOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aHUNw.default), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledChild), null, avatarOption.label));

});
parcelRegister("jDYU4", function(module, exports) {
$parcel$export(module.exports, "StyledChild", () => $0b84ddfa21b13047$export$8133811dea85f484);
$parcel$export(module.exports, "StyledOption", () => $0b84ddfa21b13047$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledItem", () => $0b84ddfa21b13047$export$7c16ae7705e422c4);
$parcel$export(module.exports, "StyledChildIcon", () => $0b84ddfa21b13047$export$c23e66fb1706d7dd);
$parcel$export(module.exports, "StyledOptionIcon", () => $0b84ddfa21b13047$export$20da797b837461ca);

var $9QAmg = parcelRequire("9QAmg");
const $0b84ddfa21b13047$export$8133811dea85f484 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-3nijrx-0"
})({
    margin: "var(--ds-space-050, 4px)",
    minWidth: 0
});
const $0b84ddfa21b13047$export$844bee7de236d7ec = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-3nijrx-1"
})({
    alignItems: 'center',
    display: 'flex'
});
const $0b84ddfa21b13047$export$7c16ae7705e422c4 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-3nijrx-2"
})({
    display: 'flex'
});
const $0b84ddfa21b13047$export$c23e66fb1706d7dd = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-3nijrx-3"
})({
    marginLeft: "var(--ds-space-100, 8px)"
});
const $0b84ddfa21b13047$export$20da797b837461ca = /*#__PURE__*/ (0, $9QAmg.default).img.withConfig({
    componentId: "sc-3nijrx-4"
})({
    borderRadius: "var(--ds-radius-full, 9999px)",
    height: '16px',
    width: '16px',
    display: 'flex',
    margin: "var(--ds-space-025, 2px)"
});

});


parcelRegister("4Dg0k", function(module, exports) {
$parcel$export(module.exports, "IconOptionLabel", () => $3d12489a5000bde1$export$914fa095fc1e0a45);

var $4fqPo = parcelRequire("4fqPo");

var $jDYU4 = parcelRequire("jDYU4");
const $3d12489a5000bde1$export$914fa095fc1e0a45 = ({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledItem), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledOptionIcon), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledChildIcon), null, option.label)));

});

parcelRegister("iSjAZ", function(module, exports) {
$parcel$export(module.exports, "LozengeOptionLabel", () => $78034cf4493b180e$export$5f70fe304106fcb1);

var $4fqPo = parcelRequire("4fqPo");

var $9qmTW = parcelRequire("9qmTW");

var $jDYU4 = parcelRequire("jDYU4");
const $78034cf4493b180e$export$5f70fe304106fcb1 = ({ lozengeOption: lozengeOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledChild), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jDYU4.StyledItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));

});


parcelRegister("1FiiX", function(module, exports) {
$parcel$export(module.exports, "DialogInner", () => $4e6b1fbd86487512$export$999ca5bf223f627);

var $9QAmg = parcelRequire("9QAmg");
const $4e6b1fbd86487512$export$999ca5bf223f627 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-mzm5tv-0"
})({
    minWidth: '220px',
    overflow: 'hidden'
});

});


parcelRegister("1VfXT", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $bf372adceccaded6$export$957d7daebd899f12);

var $4fqPo = parcelRequire("4fqPo");

var $ev2wS = parcelRequire("ev2wS");

var $ekURY = parcelRequire("ekURY");

var $97NTA = parcelRequire("97NTA");
const $bf372adceccaded6$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : !!value;
const $bf372adceccaded6$export$957d7daebd899f12 = (label = '', value)=>{
    if (!value || !$bf372adceccaded6$export$96bdbc84526f3739(value)) return label;
    const [firstValue, ...otherValues] = value.map((v)=>v.label ?? '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $97NTA.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), {
        as: "strong",
        color: "inherit"
    }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $97NTA.LabelValueWrapper), null, firstValue, otherValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $97NTA.BadgeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ev2wS.default), null, `+${otherValues.length}`))));
};

});
parcelRegister("ev2wS", function(module, exports) {
$parcel$export(module.exports, "default", () => $b86a3b96092178be$export$2e2bcd8739ae039);
/* badge.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3H4LK = parcelRequire("3H4LK");

var $ekURY = parcelRequire("ekURY");

var $jbzmV = parcelRequire("jbzmV");

var $7eNEQ = parcelRequire("7eNEQ");

var $68JOj = parcelRequire("68JOj");

var $edqbk = parcelRequire("edqbk");
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they will be updated in the labelling system work and we want to avoid frequent UI changes.\
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $b86a3b96092178be$var$neutral300 = '#DDDEE1';
const $b86a3b96092178be$var$red300 = '#FD9891';
const $b86a3b96092178be$var$blue300 = '#8FB8F6';
const $b86a3b96092178be$var$neutral1000 = '#292A2E';
const $b86a3b96092178be$var$styles = {
    root: "_2rkolb4i _18zr1b66 _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
    added: "_bfhk1y9u _syazi7uo",
    default: "_bfhk1fkg _syazwwip",
    important: "_bfhk1366 _syazwwip",
    primary: "_bfhk1ymo _syazwwip",
    primaryInverted: "_bfhkvuon _syaz1oa5",
    removed: "_bfhk1gly _syazi7uo"
};
const $b86a3b96092178be$var$badgeValueWithNegativeNumberSupported = (children, max)=>{
    return typeof children === 'number' && typeof max === 'number' ? (0, $edqbk.formatValueWithNegativeSupport)(children, max) : children;
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $b86a3b96092178be$var$Badge = /*#__PURE__*/ (0, $4fqPo.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $3H4LK.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        // Map old appearance names to new ones
        const newAppearance = (0, $jbzmV.appearanceMapping)[appearance];
        return /*#__PURE__*/ $4fqPo.createElement((0, $68JOj.default), {
            appearance: newAppearance,
            max: max,
            style: style,
            testId: testId
        }, children);
    }
    const oldAppearance = (0, $7eNEQ.appearanceMappingToOld)[appearance];
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        style: {
            background: style === null || style === void 0 ? void 0 : style.backgroundColor,
            color: style === null || style === void 0 ? void 0 : style.color
        },
        className: (0, $ltgDR.default)([
            $b86a3b96092178be$var$styles.root,
            $b86a3b96092178be$var$styles[oldAppearance]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, $b86a3b96092178be$var$badgeValueWithNegativeNumberSupported(children, max)));
});
var $b86a3b96092178be$export$2e2bcd8739ae039 = $b86a3b96092178be$var$Badge;

});
parcelRegister("jbzmV", function(module, exports) {
$parcel$export(module.exports, "appearanceMapping", () => $caf9c14e1e4de115$export$d21bba0569254935);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $caf9c14e1e4de115$export$d21bba0569254935 = {
    added: 'success',
    removed: 'danger',
    default: 'neutral',
    primary: 'information',
    primaryInverted: 'inverse',
    important: 'danger',
    warning: 'warning',
    discovery: 'discovery',
    danger: 'danger',
    success: 'success',
    information: 'information',
    inverse: 'inverse',
    neutral: 'neutral',
    informationBold: 'informationBold',
    successBold: 'successBold',
    dangerBold: 'dangerBold',
    warningBold: 'warningBold',
    discoveryBold: 'discoveryBold'
};

});

parcelRegister("7eNEQ", function(module, exports) {
$parcel$export(module.exports, "appearanceMappingToOld", () => $15a2d122f38fa28d$export$16f8cc7ac3541e83);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $15a2d122f38fa28d$export$16f8cc7ac3541e83 = {
    added: 'added',
    removed: 'removed',
    default: 'default',
    primary: 'primary',
    primaryInverted: 'primaryInverted',
    important: 'important',
    danger: 'removed',
    success: 'added',
    information: 'primary',
    inverse: 'primaryInverted',
    neutral: 'default',
    warning: 'default',
    discovery: 'default',
    informationBold: 'primary',
    successBold: 'added',
    dangerBold: 'removed',
    warningBold: 'default',
    discoveryBold: 'default'
};

});

parcelRegister("edqbk", function(module, exports) {
$parcel$export(module.exports, "formatValueWithNegativeSupport", () => $d1c20e20c2ec9975$export$4b844743568d5983);
function $d1c20e20c2ec9975$var$getSafeValueWithNegativeSupport(value = 0) {
    const numericValue = +value;
    // NOTE: Changing below code as this causes custom fields -ve number to show up as zero in activity timeline.
    // This will ensure it renders correctly if it is a number otherwise renders 0
    // If the value is NaN, return it as is (assuming it's a non-numeric string)
    if (isNaN(numericValue)) return value;
    // Return the numeric value, allowing negative numbers
    return numericValue;
}
function $d1c20e20c2ec9975$export$4b844743568d5983(value, max) {
    const safeValue = $d1c20e20c2ec9975$var$getSafeValueWithNegativeSupport(value);
    const safeMax = $d1c20e20c2ec9975$var$getSafeValueWithNegativeSupport(max);
    let hasSafeMaxValue = false;
    if (max !== undefined) hasSafeMaxValue = true;
    if (safeMax === Infinity && safeValue === Infinity) return "\u221E";
    if (hasSafeMaxValue && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("97NTA", function(module, exports) {
$parcel$export(module.exports, "BadgeWrapper", () => $fadd6ceec59a1990$export$1a37a8b7ddf809ac);
$parcel$export(module.exports, "Container", () => $fadd6ceec59a1990$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelValueWrapper", () => $fadd6ceec59a1990$export$8f3477ca2c4ba51a);

var $9QAmg = parcelRequire("9QAmg");
const $fadd6ceec59a1990$export$1a37a8b7ddf809ac = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-1abwl2h-0"
})({
    display: 'inline-flex',
    marginLeft: "var(--ds-space-050, 4px)",
    opacity: 0.5
});
const $fadd6ceec59a1990$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-1abwl2h-1"
})({
    display: 'inline-flex',
    alignItems: 'center'
});
const $fadd6ceec59a1990$export$8f3477ca2c4ba51a = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-1abwl2h-2"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    display: 'inline-flex',
    alignItems: 'center'
});

});


parcelRegister("kAWVv", function(module, exports) {
$parcel$export(module.exports, "default", () => $c258df122c818135$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $d7mfg = parcelRequire("d7mfg");

var $cTq8x = parcelRequire("cTq8x");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");

var $dtuVb = parcelRequire("dtuVb");

var $lL3h8 = parcelRequire("lL3h8");

var $6kUaW = parcelRequire("6kUaW");

var $cqN04 = parcelRequire("cqN04");
const $c258df122c818135$var$textPadding = {
    root: "_u5f3utpp"
};
const $c258df122c818135$export$d7b370c39c0de454 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, hideSelectedIndicator: hideSelectedIndicator, triggerIcon: triggerIcon, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId, isDisabled: isDisabled, ariaLabel: ariaLabel }, ref)=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dtuVb.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6kUaW.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
        isSelected: !hideSelectedIndicator && isSelected,
        iconBefore: triggerIcon,
        testId: testId
    }, children, ":")));
    const afterTriggerIcon = onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cqN04.StyledClose), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lL3h8.ClearButton), {
        onClick: (e)=>{
            e.stopPropagation();
            onClear === null || onClear === void 0 || onClear();
        },
        label: "Remove criteria"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
        color: "currentColor",
        label: "",
        size: "small"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dtuVb.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cqN04.ButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
        appearance: isInvalid ? 'danger' : 'default',
        isSelected: !hideSelectedIndicator && (isSelected || hasValues),
        iconBefore: triggerIcon,
        iconAfter: ()=>afterTriggerIcon,
        onClick: onClick,
        ref: ref,
        testId: testId,
        "aria-expanded": isSelected,
        isDisabled: isDisabled,
        "aria-label": ariaLabel && (0, $3H4LK.fg)('jsm-accessibility-fixes') ? ariaLabel : undefined
    }, onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $c258df122c818135$var$textPadding.root
    }, children) : children)));
});
var $c258df122c818135$export$2e2bcd8739ae039 = $c258df122c818135$export$d7b370c39c0de454;

});
parcelRegister("lL3h8", function(module, exports) {
$parcel$export(module.exports, "ClearButton", () => $7c2eec8016920245$export$13ec83e50bf04290);

var $4fqPo = parcelRequire("4fqPo");

var $9RW5e = parcelRequire("9RW5e");

var $5KUnU = parcelRequire("5KUnU");
const $7c2eec8016920245$export$13ec83e50bf04290 = ({ label: label, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5KUnU.StyledClearButton), {
        ...props,
        "data-testid": "paginated-picker.ui.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
        color: "currentColor",
        label: label,
        size: "small"
    }));
$7c2eec8016920245$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $7c2eec8016920245$export$2e2bcd8739ae039 = $7c2eec8016920245$export$13ec83e50bf04290;

});
parcelRegister("5KUnU", function(module, exports) {
$parcel$export(module.exports, "StyledClearButton", () => $0c0492da029c7524$export$969a0501aa28855a);

var $9QAmg = parcelRequire("9QAmg");
const $0c0492da029c7524$export$969a0501aa28855a = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-m9cwqf-0"
})({
    background: 0,
    border: 0,
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    color: "var(--ds-text-subtlest, #6B6E76)",
    cursor: 'pointer',
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    outline: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    marginLeft: "var(--ds-space-025, 2px)",
    transition: 'background-color 200ms opacity 200ms',
    width: "var(--ds-space-300, 24px)",
    '&:hover, &:focus': {
        color: "var(--ds-text-subtle, #505258)"
    }
});

});


parcelRegister("6kUaW", function(module, exports) {
$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $c5247961cc248827$export$c7a90a9f6120efb7);

var $9QAmg = parcelRequire("9QAmg");
const $c5247961cc248827$export$c7a90a9f6120efb7 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-13besx7-0"
})({
    position: 'relative',
    animation: 'flickerAnimation 2s infinite',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes flickerAnimation': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 0.5
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 1
        }
    }
});

});

parcelRegister("cqN04", function(module, exports) {
$parcel$export(module.exports, "ButtonWrapper", () => $3c62d33379e0f019$export$d53c836cccbb0d90);
$parcel$export(module.exports, "StyledClose", () => $3c62d33379e0f019$export$cd8104a6ec6bb897);

var $9QAmg = parcelRequire("9QAmg");
const $3c62d33379e0f019$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-1bg0ktc-0"
})({
    position: 'relative'
});
const $3c62d33379e0f019$export$cd8104a6ec6bb897 = /*#__PURE__*/ (0, $9QAmg.default).div.withConfig({
    componentId: "sc-1bg0ktc-1"
})({
    background: 0,
    border: 0,
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    outline: 0,
    padding: 0,
    position: 'absolute',
    right: "var(--ds-space-negative-050, -4px)",
    top: '50%',
    marginTop: "var(--ds-space-negative-150, -12px)",
    width: "var(--ds-space-300, 24px)"
});

});





parcelRegister("lFf5e", function(module, exports) {
$parcel$export(module.exports, "default", () => $8557a5bb72bc22a0$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $8557a5bb72bc22a0$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Title of the category picker',
        id: 'sd.all.articles.result.category.filter.name'
    }
});

});



parcelRegister("43Ruj", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => (parcelRequire("7dQEO")).SearchResultNone);

var $7dQEO = parcelRequire("7dQEO");

});
parcelRegister("7dQEO", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => $2a2480d5372231fb$export$149a2f9a7f0755fb);

var $4fqPo = parcelRequire("4fqPo");

var $bAkUi = parcelRequire("bAkUi");

var $9qprA = parcelRequire("9qprA");

var $dQegt = parcelRequire("dQegt");

var $2eKV2 = parcelRequire("2eKV2");

var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");

var $3krHC = parcelRequire("3krHC");
parcelRequire("2TV9p");
var $jEoO3 = parcelRequire("jEoO3");

var $2UiQO = parcelRequire("2UiQO");

var $eFBPZ = parcelRequire("eFBPZ");
const $2a2480d5372231fb$export$149a2f9a7f0755fb = ({ term: term })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const showEmptyQueryState = term === '';
    const emptyQueryContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bAkUi))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $eFBPZ.default).noSearchQueryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        align: "center"
    }, formatMessage((0, $eFBPZ.default).noSearchQueryBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $2UiQO.searchExperience)
    }));
    const noResultsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9qprA))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $eFBPZ.default).noSearchResultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        align: "center"
    }, formatMessage((0, $eFBPZ.default).noSearchResultBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $2UiQO.searchExperience)
    }));
    return showEmptyQueryState ? emptyQueryContent : noResultsContent;
};

});
parcelRegister("bAkUi", function(module, exports) {
module.exports = new URL("../images/empty-search-query.f4548b48.svg", import.meta.url).toString();

});

parcelRegister("9qprA", function(module, exports) {
module.exports = new URL("../images/empty-search-results.00e234d0.svg", import.meta.url).toString();

});

parcelRegister("3krHC", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccess", () => $a50a9b7a75d8d1bc$export$4962f3898bd5c829);

var $4fqPo = parcelRequire("4fqPo");
const $a50a9b7a75d8d1bc$export$4962f3898bd5c829 = ({ experience: experience })=>{
    (0, $4fqPo.useLayoutEffect)(()=>{
        experience.success();
    }, [
        experience
    ]);
    return null;
};

});

parcelRegister("eFBPZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd0e118e4c3a0525$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $cd0e118e4c3a0525$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    noSearchResultTitle: {
        defaultMessage: 'We couldn\u2019t find a match for your search',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.none.no-search-result-title'
    },
    noSearchResultText: {
        defaultMessage: 'We couldn\u2019t find any matches for \u2018{ term }\u2019. Check your search for typos, or try another search term.',
        description: 'Title text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-text'
    },
    noSearchResultBody: {
        defaultMessage: 'Check your search for typos, or try another search term.',
        description: 'Body text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-body'
    },
    noSearchQueryTitle: {
        defaultMessage: 'Looking for something?',
        description: 'Title text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-title'
    },
    noSearchQueryBody: {
        defaultMessage: 'Enter your search term above to get started.',
        description: 'Body text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-body'
    }
});

});



parcelRegister("6GY1V", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => (parcelRequire("lqLJ4")).SearchBar);

var $lqLJ4 = parcelRequire("lqLJ4");

});
parcelRegister("lqLJ4", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => $c048fce88f86cabc$export$79d13b60110f33be);

var $4fqPo = parcelRequire("4fqPo");

var $cbtb0 = parcelRequire("cbtb0");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $as4kh = parcelRequire("as4kh");

var $9RW5e = parcelRequire("9RW5e");

var $8B6Ry = parcelRequire("8B6Ry");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");
parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");

var $bOOgP = parcelRequire("bOOgP");

var $PL4bf = parcelRequire("PL4bf");
parcelRequire("2TV9p");
var $jEoO3 = parcelRequire("jEoO3");
var $4azHH = parcelRequire("4azHH");

var $h83H2 = parcelRequire("h83H2");
const $c048fce88f86cabc$export$79d13b60110f33be = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [backButtonText, setBackButtonText] = (0, $4fqPo.useState)();
    const searchBarRef = (0, $4fqPo.useRef)(null);
    (0, $4fqPo.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText(entry.contentRect.width < 768 ? '' : undefined);
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            if (currentSearchBarRefRef) observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const onSearchTermChange = (0, $4fqPo.useCallback)((e)=>{
        onChange(e.target.value);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $1wDzz.useRouterActions)();
    const onBackButtonClick = (0, $4fqPo.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $4azHH.useQueryParams)();
    const onCrossIconClick = (0, $4fqPo.useCallback)(()=>{
        onChange('');
        push((0, $PL4bf.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $c048fce88f86cabc$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        gap: "space.200",
        templateColumns: "25fr 50fr 25fr",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $c048fce88f86cabc$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cbtb0.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $c048fce88f86cabc$var$textFieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bOOgP.default), {
        id: "search-bar-input",
        value: term,
        name: formatMessage((0, $h83H2.default).inputLabel),
        "aria-label": formatMessage((0, $h83H2.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $h83H2.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $c048fce88f86cabc$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "button",
            xcss: $c048fce88f86cabc$var$crossIconStyles,
            onClick: onCrossIconClick,
            "aria-label": formatMessage((0, $h83H2.default).clearSearch)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null)));
};
const $c048fce88f86cabc$var$containerStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    width: '100vw',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    height: (0, $jEoO3.SEARCH_BAR_HEIGHT),
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #EBECF0)",
    zIndex: 'modal'
});
const $c048fce88f86cabc$var$backButtonStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        marginLeft: 'space.050'
    },
    [(0, $3jKXW.media).above.xs]: {
        marginLeft: 'space.100'
    },
    [(0, $3jKXW.media).above.sm]: {
        marginLeft: 'space.200'
    }
});
const $c048fce88f86cabc$var$textFieldStyles = (0, $2m8U6.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    [(0, $3jKXW.media).above.xxs]: {
        width: '348px'
    },
    [(0, $3jKXW.media).above.xs]: {
        width: '432px'
    },
    [(0, $3jKXW.media).above.sm]: {
        width: '692px'
    },
    [(0, $3jKXW.media).above.md]: {
        width: '965px'
    }
});
const $c048fce88f86cabc$var$searchIconStyles = (0, $2m8U6.xcss)({
    padding: 'space.100'
});
const $c048fce88f86cabc$var$crossIconStyles = (0, $2m8U6.xcss)({
    background: 'transparent',
    cursor: 'pointer'
});
var $c048fce88f86cabc$export$2e2bcd8739ae039 = (0, $as4kh.default)()($c048fce88f86cabc$export$79d13b60110f33be);

});
parcelRegister("cbtb0", function(module, exports) {
$parcel$export(module.exports, "default", () => $40d8350b029c888c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $dQegt = parcelRequire("dQegt");

var $63KX8 = parcelRequire("63KX8");

var $idZXe = parcelRequire("idZXe");
const $40d8350b029c888c$var$BackButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { onClick: onClick, actionSubjectId: actionSubjectId, text: text } = props;
    const backButtonText = text ? text : formatMessage((0, $idZXe.default).backButtonText);
    return /*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.Button), {
        appearance: "subtle",
        actionSubjectId: actionSubjectId,
        onClick: onClick,
        "aria-label": backButtonText,
        iconBefore: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($63KX8))), {
            label: "",
            size: "small",
            spacing: "compact",
            color: "var(--ds-icon, #42526E)"
        }),
        "data-test-id": "back-button"
    }, backButtonText);
};
var $40d8350b029c888c$export$2e2bcd8739ae039 = $40d8350b029c888c$var$BackButton;

});
parcelRegister("63KX8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2156d9d42c2a1cee4be11481dce76dec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $469771c0f3cbe4b0$var$_react = $469771c0f3cbe4b0$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $469771c0f3cbe4b0$var$_baseNew = $469771c0f3cbe4b0$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $469771c0f3cbe4b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $469771c0f3cbe4b0$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $469771c0f3cbe4b0$var$_react.default.createElement($469771c0f3cbe4b0$var$_baseNew.default, Object.assign({
        name: "ArrowLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$469771c0f3cbe4b0$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $469771c0f3cbe4b0$var$_default = module.exports.default = $469771c0f3cbe4b0$var$ArrowLeftIcon;

});

parcelRegister("idZXe", function(module, exports) {
$parcel$export(module.exports, "default", () => $93ea88eacdb5751c$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $93ea88eacdb5751c$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    backButtonText: {
        defaultMessage: 'Back',
        description: 'Back button text',
        id: 'sd.common.back-button.text'
    }
});

});


parcelRegister("bOOgP", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6b49889a716f1f7$export$2e2bcd8739ae039);
/* text-field.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $3H4LK = parcelRequire("3H4LK");
const $f6b49889a716f1f7$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
const $f6b49889a716f1f7$var$inputMediaDisabled = null;
const $f6b49889a716f1f7$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $f6b49889a716f1f7$var$disabledStyle = {
    standard: "_1h6d187o _bfhk187o _syaz1gmx _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1gmx _80om13gf"
};
const $f6b49889a716f1f7$var$invalidStyle = null;
const $f6b49889a716f1f7$var$focusWithinStyle = {
    standard: "_1p9x1v1w _qao9r01l _q433vyy1",
    subtle: "_1p9x1v1w _qao9r01l _q433vyy1",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
const $f6b49889a716f1f7$var$hoverStyle = {
    standard: "_4cvxrsbi _irr3l4ek",
    subtle: "_4cvxrsbi _irr3l4ek",
    none: "_4cvx1j28 _irr31j28"
};
const $f6b49889a716f1f7$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6drsbi _1dqonqa1 _syazi7uo _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syazi7uo _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syazi7uo _80om1kdv _16hg1j28 _msj6gir2"
};
const $f6b49889a716f1f7$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $f6b49889a716f1f7$var$getMaxWidth = (width)=>!width ? `100%` : width in $f6b49889a716f1f7$var$widthMap ? `${$f6b49889a716f1f7$var$widthMap[width]}px` : `${+width}px`;
const $f6b49889a716f1f7$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
const $f6b49889a716f1f7$var$containerStyles = null;
const $f6b49889a716f1f7$var$containerStylesT26Shape = null;
const $f6b49889a716f1f7$var$inputDisabledStyle = null;
const $f6b49889a716f1f7$var$inputCompactStyle = null;
const $f6b49889a716f1f7$var$inputMonospacedStyle = null;
// iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textfield uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f6b49889a716f1f7$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $f6b49889a716f1f7$var$Textfield = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $4fqPo.useRef)(null);
    const handleOnFocus = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$f6b49889a716f1f7$var$analyticsParams
    });
    const handleOnBlur = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f6b49889a716f1f7$var$analyticsParams
    });
    const handleOnMouseDown = (0, $4fqPo.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $4fqPo.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        style: {
            maxWidth: `${$f6b49889a716f1f7$var$getMaxWidth(width)}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c8fhey _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnqfajl",
            (0, $3H4LK.fg)('platform-dst-shape-theme-default') && "_1tnq1qi0",
            $f6b49889a716f1f7$var$getContainerTextBgAndBorderColor[appearance],
            $f6b49889a716f1f7$var$containerStyleAppearance[appearance],
            !isDisabled && $f6b49889a716f1f7$var$focusWithinStyle[appearance],
            !isDisabled && $f6b49889a716f1f7$var$hoverStyle[appearance],
            isDisabled && $f6b49889a716f1f7$var$containerMedia.disabled,
            isDisabled && $f6b49889a716f1f7$var$disabledStyle[appearance],
            isInvalid && $f6b49889a716f1f7$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qsizbr _1dbzizbr _uk1sr01l",
            className
        ])
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $ltgDR.default)([
            "_19itidpf _11c81d4k _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr1rpy _1tn2fhey _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            isMonospaced && "_ect4zzfg _14mdzzfg",
            isCompact && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isDisabled && "_syaz1gmx _1idr1gmx",
            isDisabled && "_1fnx18qt"
        ])
    }), elemAfterInput);
});
var $f6b49889a716f1f7$export$2e2bcd8739ae039 = $f6b49889a716f1f7$var$Textfield;

});

parcelRegister("h83H2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e72493f08a4149d4$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $e72493f08a4149d4$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    inputPlaceholder: {
        defaultMessage: 'Search for help resources',
        description: 'Placeholder message for the search bar describing what they can look for',
        id: 'cv.search.search-bar.input.placeholder'
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-bar.close'
    },
    inputLabel: {
        defaultMessage: 'Search bar input',
        description: 'Label message for the search bar input',
        id: 'cv.search.search-bar.input-label'
    },
    searchIconLabel: {
        defaultMessage: 'Search icon',
        description: 'Label message for the search bar input icon',
        id: 'cv.search.search-bar.search-icon-label'
    },
    clearSearch: {
        defaultMessage: 'Clear search',
        description: 'Label for the button that clears the search input',
        id: 'cv.search.search-bar.clear-search'
    }
});

});



parcelRegister("kKF1m", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => (parcelRequire("cwSyS")).SearchResult);

var $cwSyS = parcelRequire("cwSyS");

});
parcelRegister("cwSyS", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $f3c9a0be234e6ed8$export$a2def421b23768aa);

var $aCAjK = parcelRequire("aCAjK");

var $hhKng = parcelRequire("hhKng");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $eNI4Q = parcelRequire("eNI4Q");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3Ar39 = parcelRequire("3Ar39");

var $6Sdci = parcelRequire("6Sdci");
parcelRequire("juNiE");
var $3ys9i = parcelRequire("3ys9i");
parcelRequire("2TV9p");
var $iD7Jo = parcelRequire("iD7Jo");
var $4azHH = parcelRequire("4azHH");

var $2UiQO = parcelRequire("2UiQO");
parcelRequire("hjWQl");
var $fMLwD = parcelRequire("fMLwD");
parcelRequire("43Ruj");
var $7dQEO = parcelRequire("7dQEO");
parcelRequire("5OmPt");
var $93QYW = parcelRequire("93QYW");
parcelRequire("7Th3C");
var $18IY7 = parcelRequire("18IY7");
const $f3c9a0be234e6ed8$export$e9a269813a6315a4 = ({ term: term, articlesData: articlesData, portalsData: portalsData, requestFormData: requestFormData, showAllResults: showAllResults, updateResultsCount: updateResultsCount })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const onlyRenderArticles = isCSM;
    const renderArticles = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3ys9i.default), {
            term: term,
            result: articlesData,
            showAllResults: showAllResults,
            updateResultsCount: updateResultsCount
        });
    const renderPortals = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93QYW.default), {
            term: term,
            result: portalsData,
            updateResultsCount: updateResultsCount
        });
    const renderRequestForms = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $18IY7.default), {
            term: term,
            result: requestFormData,
            updateResultsCount: updateResultsCount
        });
    if (onlyRenderArticles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fMLwD.ArticleResultsLoader), null)
    }, renderArticles());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $f3c9a0be234e6ed8$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fMLwD.ArticleResultsLoader), null)
    }, renderArticles()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fMLwD.SidePanelResultsLoader), null)
    }, renderRequestForms()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fMLwD.SidePanelResultsLoader), null)
    }, renderPortals())));
};
function $f3c9a0be234e6ed8$var$useParallelQuery(cloudId, queryTerm, portalIds, categoryIds, resultLimit, helpCenterAri) {
    const ARTICLES_AND_PORTALS_QUERY = (0, $hhKng.default);
    const REQUEST_FORM_QUERY = (0, $aCAjK.default);
    const articlesAndPortalsData = (0, $gIeP2.useLazyLoadQuery)(ARTICLES_AND_PORTALS_QUERY, {
        cloudId: cloudId,
        queryTerm: queryTerm,
        portalIds: portalIds,
        categoryIds: categoryIds,
        resultLimit: resultLimit,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const requestFormData = (0, $gIeP2.useLazyLoadQuery)(REQUEST_FORM_QUERY, {
        cloudId: cloudId,
        queryTerm: queryTerm,
        portalIds: portalIds,
        resultLimit: resultLimit
    }, {
        fetchPolicy: 'store-or-network'
    });
    return {
        articlesFragment: articlesAndPortalsData.helpObjectStore,
        portalsFragment: articlesAndPortalsData.helpObjectStore,
        requestFormFragment: requestFormData.helpObjectStore
    };
}
const $f3c9a0be234e6ed8$var$useExtractSearchParameters = ({ showAllResults: showAllResults, CSMPortalId: CSMPortalId })=>{
    const cloudId = (0, $4fqPo.useMemo)(()=>(0, $6mmHn.getCloudId)(), []);
    const { portalIds: portalIds, categoryIds: categoryIds, resultLimit: resultLimit = (0, $iD7Jo.DEFAULT_RESULTS_COUNT) } = (0, $4azHH.useQueryParams)();
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const getSelectedPortalIds = ()=>{
        if (CSMPortalId) return (0, $4azHH.getIdsArray)(CSMPortalId);
        if ((0, $4azHH.isSinglePortalSearch)(portalId)) return (0, $4azHH.getIdsArray)(portalId);
        return (0, $4azHH.getIdsArray)(portalIds);
    };
    return {
        cloudId: cloudId,
        portalIds: portalIds,
        categoryIds: categoryIds,
        portalId: portalId,
        getSelectedPortalIds: getSelectedPortalIds,
        resultLimit: showAllResults ? (0, $iD7Jo.ALL_RESULTS_COUNT) : resultLimit
    };
};
const $f3c9a0be234e6ed8$var$ParallelQueryWrapperOnResource = ({ term: term, updateResultsCount: updateResultsCount, showAllResults: showAllResults, searchParams: searchParams })=>{
    const { articlesFragment: articlesFragment, portalsFragment: portalsFragment, requestFormFragment: requestFormFragment } = $f3c9a0be234e6ed8$var$useParallelQuery(searchParams.cloudId, term, searchParams.getSelectedPortalIds(), searchParams.categoryIds, searchParams.resultLimit, (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() ? (0, $6mmHn.getHelpCenterAri)() : undefined);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f3c9a0be234e6ed8$export$e9a269813a6315a4, {
        term: term,
        articlesData: articlesFragment,
        portalsData: portalsFragment,
        requestFormData: requestFormFragment,
        showAllResults: showAllResults,
        updateResultsCount: updateResultsCount
    });
};
const $f3c9a0be234e6ed8$export$a2def421b23768aa = ({ term: term, showAllResults: showAllResults })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const CSMPortalId = isCSM ? (0, $ebpTf.getEnv)().hoistedPortalId : undefined;
    const searchParams = $f3c9a0be234e6ed8$var$useExtractSearchParameters({
        showAllResults: showAllResults,
        CSMPortalId: CSMPortalId
    });
    const [totalCount, setTotalCount] = (0, $4fqPo.useState)(-1);
    const resultsCount = (0, $4fqPo.useRef)(-1);
    const callBackCount = (0, $4fqPo.useRef)(0);
    const debouncedTerm = (0, $6Sdci.default)(term, (0, $iD7Jo.SEARCH_QUERY_DEBOUNCE_TIME));
    // Every time this callback will be called, that resource will increment callBackCount through acknowledgement
    const updateResultsCount = (0, $4fqPo.useCallback)((count, acknowledgement)=>{
        if (resultsCount.current < 0) resultsCount.current = 0;
        resultsCount.current += count;
        if (acknowledgement) callBackCount.current += acknowledgement;
        // Update state only when articles, portals and requestForms all have updated the results
        if (callBackCount.current === 3) {
            // Since callbackCount will persist across states, setting it back to 0
            callBackCount.current = 0;
            setTotalCount(resultsCount.current);
        }
    }, []);
    (0, $3Ar39.useIsoMorphicLayoutEffect)(()=>{
        // Reset count to initial state on term change
        resultsCount.current = -1;
        setTotalCount(-1);
        callBackCount.current = 0;
    }, [
        debouncedTerm
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        isCSM && (0, $2UiQO.csmSearchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            isCSM && (0, $2UiQO.csmSearchExperience).abort();
        };
    }, [
        debouncedTerm,
        isCSM
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $2UiQO.searchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $2UiQO.searchExperience).abort();
        };
    }, [
        debouncedTerm
    ]);
    const isEmptyResultsState = totalCount === 0;
    const isEmptyQueryState = debouncedTerm === '';
    const showEmptyState = isEmptyQueryState || isEmptyResultsState;
    const fallback = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fMLwD.NewSearchResultsLoader), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: fallback
    }, showEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7dQEO.SearchResultNone), {
        term: debouncedTerm
    }), !isEmptyResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f3c9a0be234e6ed8$var$ParallelQueryWrapperOnResource, {
        term: debouncedTerm,
        searchParams: searchParams,
        showAllResults: showAllResults,
        updateResultsCount: updateResultsCount
    }));
};
const $f3c9a0be234e6ed8$var$responsiveStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        gridTemplateColumns: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});

});
parcelRegister("aCAjK", function(module, exports) {
$parcel$export(module.exports, "default", () => $222a3aeb7c8327e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<68cdec17e93b8973c849641867084779>>
 * @relayHash 84089950a098de741b9cc8fe7be37f4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID af1dedc24d118e6831ee24c6433181b68321c163ef93c3578dd8d71d3a98b3be
const $222a3aeb7c8327e2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resultLimit"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultRequestFormQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v6 /*: any*/ ,
                        "concreteType": "HelpObjectStoreQueryApi",
                        "kind": "LinkedField",
                        "name": "helpObjectStore",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "requestFormsFragment"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultRequestFormQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpObjectStoreQueryApi",
                    "kind": "LinkedField",
                    "name": "helpObjectStore",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "alias": "requestForms",
                            "args": [
                                {
                                    "fields": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "entityType",
                                            "value": "REQUEST_FORM"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "helpCenterAri",
                                            "variableName": "helpCenterAri"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "portalIds",
                                            "variableName": "portalIds"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "queryTerm",
                                            "variableName": "queryTerm"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "resultLimit",
                                            "variableName": "resultLimit"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "searchHelpObjects",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "isExternal"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "searchBackend"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "searchAlgorithm"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "entityType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "iconUrl"
                                        }
                                    ],
                                    "type": "HelpObjectStoreSearchResult"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "HelpObjectStoreQueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "af1dedc24d118e6831ee24c6433181b68321c163ef93c3578dd8d71d3a98b3be",
            "metadata": {},
            "name": "searchResultRequestFormQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$222a3aeb7c8327e2$var$node.hash = "767d90ed3aed24eab0f0598281dd235e";
var $222a3aeb7c8327e2$export$2e2bcd8739ae039 = $222a3aeb7c8327e2$var$node;

});

parcelRegister("hhKng", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b390fa47c939222$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d4f03155d89e952d09b51cc4c26a59f8>>
 * @relayHash c66d23ed128edfd59ce7e96679d3138b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bdcb9c6579487db95aaa69bef286db9f90fd990a7cc1d82088e3def474d64ef
const $9b390fa47c939222$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resultLimit"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v10 = {
        "kind": "Variable",
        "name": "portalIds",
        "variableName": "portalIds"
    }, v11 = {
        "kind": "Variable",
        "name": "queryTerm",
        "variableName": "queryTerm"
    }, v12 = {
        "kind": "Variable",
        "name": "resultLimit",
        "variableName": "resultLimit"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isExternal"
    }, v14 = {
        "kind": "ScalarField",
        "name": "searchBackend"
    }, v15 = {
        "kind": "ScalarField",
        "name": "id"
    }, v16 = {
        "kind": "ScalarField",
        "name": "title"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v18 = {
        "kind": "ScalarField",
        "name": "searchAlgorithm"
    }, v19 = {
        "kind": "ScalarField",
        "name": "entityType"
    }, v20 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreQueryError"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v15 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultArticlesAndPortalsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v7 /*: any*/ ,
                        "concreteType": "HelpObjectStoreQueryApi",
                        "kind": "LinkedField",
                        "name": "helpObjectStore",
                        "plural": false,
                        "selections": [
                            v8 /*: any*/ ,
                            {
                                "kind": "FragmentSpread",
                                "name": "articlesFragment"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "portalsFragment"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultArticlesAndPortalsQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpObjectStoreQueryApi",
                    "kind": "LinkedField",
                    "name": "helpObjectStore",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "alias": "articles",
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "categoryIds",
                                            "variableName": "categoryIds"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "entityType",
                                            "value": "ARTICLE"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "searchHelpObjects",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "containerDisplayName"
                                        }
                                    ],
                                    "type": "HelpObjectStoreSearchResult"
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "portals",
                            "args": [
                                {
                                    "fields": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "Literal",
                                            "name": "entityType",
                                            "value": "PORTAL"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "searchInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "searchHelpObjects",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v15 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ],
                                    "type": "HelpObjectStoreSearchResult"
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bdcb9c6579487db95aaa69bef286db9f90fd990a7cc1d82088e3def474d64ef",
            "metadata": {},
            "name": "searchResultArticlesAndPortalsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9b390fa47c939222$var$node.hash = "dcb6be9a06f88e55999bb3fc69693157";
var $9b390fa47c939222$export$2e2bcd8739ae039 = $9b390fa47c939222$var$node;

});

parcelRegister("3Ar39", function(module, exports) {
$parcel$export(module.exports, "useMounted", () => $07945301d772ecd7$export$bce3bfec9f56c837);
$parcel$export(module.exports, "usePrevious", () => $07945301d772ecd7$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useIsoMorphicLayoutEffect", () => $07945301d772ecd7$export$3d58f1da4ac28ebc);

var $4fqPo = parcelRequire("4fqPo");
function $07945301d772ecd7$export$bce3bfec9f56c837() {
    const referenceToMounted = $4fqPo.useRef(false);
    $4fqPo.useEffect(()=>{
        if (!referenceToMounted.current) referenceToMounted.current = true;
        return ()=>{
            if (referenceToMounted.current) referenceToMounted.current = false;
        };
    }, []);
    return referenceToMounted.current;
}
function $07945301d772ecd7$export$5cae361ad82dce8b(value) {
    const referenceToValue = $4fqPo.useRef();
    $4fqPo.useEffect(()=>{
        referenceToValue.current = value;
    }, [
        value
    ]);
    return referenceToValue.current;
}
const $07945301d772ecd7$export$3d58f1da4ac28ebc = (0, $4fqPo.useLayoutEffect);

});

parcelRegister("6Sdci", function(module, exports) {
$parcel$export(module.exports, "default", () => $59190cbe2d310597$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
/**
 * If the 'value' changes multiple times in quick succession, within the specified 'delay' time frame,
 * the 'debouncedValue' only changes once and equals the latest 'value'
 */ const $59190cbe2d310597$var$useDebouncedValue = (value, delay)=>{
    const [debouncedValue, setDebouncedValue] = (0, $4fqPo.useState)(value);
    // useEffect schedules an update to 'debouncedValue' after the delay
    // if the 'value' changes before the delay, the previous timeout is cleared, and a new one is started
    (0, $4fqPo.useEffect)(()=>{
        const timeoutID = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timeoutID);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
var $59190cbe2d310597$export$2e2bcd8739ae039 = $59190cbe2d310597$var$useDebouncedValue;

});

parcelRegister("juNiE", function(module, exports) {
$parcel$export(module.exports, "Articles", () => (parcelRequire("3ys9i")).default);

var $3ys9i = parcelRequire("3ys9i");

});
parcelRegister("3ys9i", function(module, exports) {
$parcel$export(module.exports, "default", () => $6da36ff4c3d82238$export$2e2bcd8739ae039);

var $97TfB = parcelRequire("97TfB");

var $4fqPo = parcelRequire("4fqPo");

var $eQdiM = parcelRequire("eQdiM");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $2eKV2 = parcelRequire("2eKV2");

var $cTq8x = parcelRequire("cTq8x");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3krHC = parcelRequire("3krHC");
parcelRequire("gWV3r");
var $34tMT = parcelRequire("34tMT");
parcelRequire("2TV9p");
var $iD7Jo = parcelRequire("iD7Jo");
var $jEoO3 = parcelRequire("jEoO3");
var $4azHH = parcelRequire("4azHH");

var $2UiQO = parcelRequire("2UiQO");
parcelRequire("43Ruj");
var $7dQEO = parcelRequire("7dQEO");

var $RJvg9 = parcelRequire("RJvg9");
const $6da36ff4c3d82238$export$b9fde6c411c336c6 = ({ result: result, term: term, showAllResults: showAllResults, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $97TfB.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $4azHH.useQueryParams)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { resultLimit: resultLimit = showAllResults ? (0, $iD7Jo.ALL_RESULTS_COUNT) : (0, $iD7Jo.INITIAL_ARTICLES_COUNT) } = queryStringParams;
    // We fetch one more than the required count, i.e. (4+1 or 8+1), to identify if there are any more results
    // but will show only 4, 8 or max 30 results
    const [numberOfResultsShown, setNumberOfResultsShown] = (0, $4fqPo.useState)(showAllResults ? (0, $iD7Jo.ALL_RESULTS_COUNT) : resultLimit - 1);
    const showMoreArticlesButton = numberOfResultsShown < 30 && data.articles.length > numberOfResultsShown;
    const slicedArticles = data.articles.slice(0, numberOfResultsShown);
    const showSection = slicedArticles.length > 0;
    (0, $4fqPo.useEffect)(()=>{
        setNumberOfResultsShown(resultLimit - 1);
    }, [
        resultLimit
    ]);
    (0, $4fqPo.useEffect)(()=>{
        let externalResourcesCount = 0;
        let firstPartySearchPlatformResourcesCount = 0;
        let hasError = false;
        let errorMessage;
        slicedArticles.forEach((resource)=>{
            if (resource) {
                const { __typename: __typename, isExternal: isExternal, searchBackend: searchBackend, message: message } = resource;
                if (__typename === 'HelpObjectStoreSearchResult') {
                    if (isExternal) externalResourcesCount += 1;
                    if (searchBackend === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
                    if (message && !errorMessage) {
                        hasError = true;
                        errorMessage = message;
                    }
                }
            }
        });
        if (showSection && hasError) (0, $4azHH.sendSearchOperationalAnalyticEvents)({
            hasError: hasError,
            errorMessage: errorMessage,
            action: portalId ? 'KBArticleSinglePortalSearch failed' : 'KBArticleHomePageSearch failed'
        }, createAnalyticsEvent, portalId);
        if (showSection && !hasError) {
            (0, $4azHH.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'article',
                resourceCount: slicedArticles.length
            }, createAnalyticsEvent, portalId);
            (0, $4azHH.sendSearchOperationalAnalyticEvents)({
                action: portalId ? 'KBArticleSinglePortalSearch success' : 'KBArticleHomePageSearch success'
            }, createAnalyticsEvent, portalId);
        }
    // adding slicedArticles to deps array causes multiple 'rendered' events to be fired
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term,
        showSection,
        slicedArticles.length,
        createAnalyticsEvent,
        portalId,
        numberOfResultsShown
    ]);
    (0, $4fqPo.useEffect)(()=>{
        updateResultsCount(slicedArticles.length, 1);
    }, [
        term,
        slicedArticles.length,
        updateResultsCount
    ]);
    const onShowMoreClick = (0, $4fqPo.useCallback)(()=>{
        if (numberOfResultsShown <= 30) setNumberOfResultsShown(numberOfResultsShown + ((0, $iD7Jo.SHOW_MORE_RESULTS_COUNT) - resultLimit));
    }, [
        numberOfResultsShown,
        resultLimit
    ]);
    if (!showSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7dQEO.SearchResultNone), {
        term: term
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xxsmall"
    }, formatMessage((0, $RJvg9.default).articles)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.ResultList), null, slicedArticles.map((resource, index)=>{
        if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === 'HelpObjectStoreSearchResult') {
            const itemOrder = index + 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", {
                key: itemOrder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $34tMT.default), {
                itemOrder: itemOrder,
                term: term,
                showAllResults: showAllResults,
                result: resource
            }));
        }
        return null;
    })), showMoreArticlesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eQdiM.ThemedButton), {
        "data-test-id": "show-more-button",
        appearance: "link",
        actionSubjectId: "showMoreButton",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
            size: "small",
            spacing: "spacious",
            label: formatMessage((0, $RJvg9.default).showMoreIcon)
        }),
        onClick: onShowMoreClick
    }, formatMessage((0, $RJvg9.default).showMore))), isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $2UiQO.csmSearchExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $2UiQO.searchExperience)
    }));
};
var $6da36ff4c3d82238$export$2e2bcd8739ae039 = (0, $as4kh.default)()($6da36ff4c3d82238$export$b9fde6c411c336c6);

});
parcelRegister("97TfB", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0f162bee4534009$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8a45f21801ef2906deb605175450194d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f0f162bee4534009$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "categoryIds"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        },
        {
            "kind": "RootArgument",
            "name": "portalIds"
        },
        {
            "kind": "RootArgument",
            "name": "queryTerm"
        },
        {
            "kind": "RootArgument",
            "name": "resultLimit"
        }
    ],
    "kind": "Fragment",
    "name": "articlesFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "articles",
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "categoryIds",
                                "variableName": "categoryIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "entityType",
                                "value": "ARTICLE"
                            },
                            {
                                "kind": "Variable",
                                "name": "helpCenterAri",
                                "variableName": "helpCenterAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "portalIds",
                                "variableName": "portalIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "queryTerm",
                                "variableName": "queryTerm"
                            },
                            {
                                "kind": "Variable",
                                "name": "resultLimit",
                                "variableName": "resultLimit"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "searchInput"
                    }
                ],
                "kind": "LinkedField",
                "name": "searchHelpObjects",
                "plural": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isExternal"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "searchBackend"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "articleItemFragment"
                            }
                        ],
                        "type": "HelpObjectStoreSearchResult"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "HelpObjectStoreQueryError"
                    }
                ]
            },
            "action": "THROW"
        }
    ],
    "type": "HelpObjectStoreQueryApi"
};
$f0f162bee4534009$var$node.hash = "fd4183e803db1737bffaaa452be94417";
var $f0f162bee4534009$export$2e2bcd8739ae039 = $f0f162bee4534009$var$node;

});

parcelRegister("gWV3r", function(module, exports) {
$parcel$export(module.exports, "ArticleItem", () => (parcelRequire("34tMT")).default);

var $34tMT = parcelRequire("34tMT");

});
parcelRegister("34tMT", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa721b4423e451dc$export$2e2bcd8739ae039);

var $cVIDg = parcelRequire("cVIDg");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $bG6ob = parcelRequire("bG6ob");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $as4kh = parcelRequire("as4kh");

var $cnft1 = parcelRequire("cnft1");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $gWRbJ = parcelRequire("gWRbJ");

var $Y85G3 = parcelRequire("Y85G3");
parcelRequire("5yLlW");
var $4ITkB = parcelRequire("4ITkB");

var $RJvg9 = parcelRequire("RJvg9");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("aasqW");
var $6EDho = parcelRequire("6EDho");
const $aa721b4423e451dc$export$3a909d935747d7f7 = ({ itemOrder: itemOrder, result: result, term: term, showAllResults: showAllResults, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $cVIDg.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const portalIdAsNumber = (0, $4azHH.getPortalIdAsNumber)(portalId);
    const { title: title, description: description, displayLink: displayLink, isExternal: isExternal, id: id, searchBackend: searchBackend, searchAlgorithm: searchAlgorithm } = data;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cnft1))), {
        label: formatMessage((0, $RJvg9.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $4azHH.formatText)(title, term) : '';
    const highlightedDescription = description ? (0, $4azHH.formatText)(description, term) : '';
    const resourceDisplayLink = (0, $4azHH.isSinglePortalSearch)(portalIdAsNumber) && showAllResults ? `/portal/${portalIdAsNumber}/article/${id}` : (0, $Y85G3.getUpdatedDisplayLinkForArticleSearch)(displayLink);
    const linkProps = (0, $gWRbJ.urlRefsAndTarget)({
        displayLink: resourceDisplayLink,
        isAnExternalResource: isExternal
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $4azHH.sendSearchUIAnalyticEvents)({
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm,
            action: 'list-item-rendered',
            resourceType: 'article'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        portalId,
        searchAlgorithm,
        searchBackend
    ]);
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $4azHH.useVisibilityState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        key: id,
        role: "listitem",
        xcss: $aa721b4423e451dc$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $aa721b4423e451dc$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6EDho.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $aa721b4423e451dc$var$headingAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
        key: id,
        href: resourceDisplayLink,
        actionSubjectId: isExternal ? 'external-article-link' : 'article-link',
        "data-test-id": "result-link-container",
        attributes: {
            itemOrder: itemOrder,
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedTitle) : (0, $a7SRW.sanitize)(highlightedTitle)
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: [
            $aa721b4423e451dc$var$subheadingLeftAreaStyles,
            $aa721b4423e451dc$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4ITkB.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: isShortcutIconVisible ? $aa721b4423e451dc$var$headerRightAreaStylesVisible : $aa721b4423e451dc$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $aa721b4423e451dc$var$bodyAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("p", {
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedDescription) : (0, $a7SRW.sanitize)(highlightedDescription)
        }
    })))));
};
const $aa721b4423e451dc$var$ConnectedArticleItem = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $2hx7o.isLoggedIn)(state),
        themeColor: (0, $i8gmD.getThemeColor)(state)
    };
})($aa721b4423e451dc$export$3a909d935747d7f7);
var $aa721b4423e451dc$export$2e2bcd8739ae039 = (0, $as4kh.default)()($aa721b4423e451dc$var$ConnectedArticleItem);
const $aa721b4423e451dc$var$containerStyles = (0, $2m8U6.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $aa721b4423e451dc$var$iconAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'icon',
    width: 'size.300',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    textDecoration: 'none'
});
const $aa721b4423e451dc$var$headingAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $aa721b4423e451dc$var$subheadingStyles = (0, $2m8U6.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $aa721b4423e451dc$var$subheadingLeftAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $aa721b4423e451dc$var$headerRightAreaStylesInVisible = (0, $2m8U6.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $aa721b4423e451dc$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $aa721b4423e451dc$var$bodyAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});

});
parcelRegister("cVIDg", function(module, exports) {
$parcel$export(module.exports, "default", () => $65b4401b0969d5c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<20a025519de7e5c0e387bf0df049dca3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65b4401b0969d5c5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleItemFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "__typename"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "description"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "searchBackend"
        },
        {
            "kind": "ScalarField",
            "name": "searchAlgorithm"
        },
        {
            "kind": "FragmentSpread",
            "name": "resourceIconFragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "articleMetadataFragment"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$65b4401b0969d5c5$var$node.hash = "5d7a00f2cc5ab5ae9593661ae477e1bc";
var $65b4401b0969d5c5$export$2e2bcd8739ae039 = $65b4401b0969d5c5$var$node;

});

parcelRegister("a7SRW", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("1BEGf", function(module, exports) {


module.exports = window.DOMPurify || (window.DOMPurify = (parcelRequire("3kBP4")).default || (parcelRequire("3kBP4")));

});
parcelRegister("3kBP4", function(module, exports) {
/*! @license DOMPurify 3.4.1 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.1/LICENSE */ 'use strict';
const { entries: $26d094221a813868$var$entries, setPrototypeOf: $26d094221a813868$var$setPrototypeOf, isFrozen: $26d094221a813868$var$isFrozen, getPrototypeOf: $26d094221a813868$var$getPrototypeOf, getOwnPropertyDescriptor: $26d094221a813868$var$getOwnPropertyDescriptor } = Object;
let { freeze: $26d094221a813868$var$freeze, seal: $26d094221a813868$var$seal, create: $26d094221a813868$var$create } = Object; // eslint-disable-line import/no-mutable-exports
let { apply: $26d094221a813868$var$apply, construct: $26d094221a813868$var$construct } = typeof Reflect !== 'undefined' && Reflect;
if (!$26d094221a813868$var$freeze) $26d094221a813868$var$freeze = function freeze(x) {
    return x;
};
if (!$26d094221a813868$var$seal) $26d094221a813868$var$seal = function seal(x) {
    return x;
};
if (!$26d094221a813868$var$apply) $26d094221a813868$var$apply = function apply(func, thisArg) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return func.apply(thisArg, args);
};
if (!$26d094221a813868$var$construct) $26d094221a813868$var$construct = function construct(Func) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return new Func(...args);
};
const $26d094221a813868$var$arrayForEach = $26d094221a813868$var$unapply(Array.prototype.forEach);
const $26d094221a813868$var$arrayLastIndexOf = $26d094221a813868$var$unapply(Array.prototype.lastIndexOf);
const $26d094221a813868$var$arrayPop = $26d094221a813868$var$unapply(Array.prototype.pop);
const $26d094221a813868$var$arrayPush = $26d094221a813868$var$unapply(Array.prototype.push);
const $26d094221a813868$var$arraySplice = $26d094221a813868$var$unapply(Array.prototype.splice);
const $26d094221a813868$var$arrayIsArray = Array.isArray;
const $26d094221a813868$var$stringToLowerCase = $26d094221a813868$var$unapply(String.prototype.toLowerCase);
const $26d094221a813868$var$stringToString = $26d094221a813868$var$unapply(String.prototype.toString);
const $26d094221a813868$var$stringMatch = $26d094221a813868$var$unapply(String.prototype.match);
const $26d094221a813868$var$stringReplace = $26d094221a813868$var$unapply(String.prototype.replace);
const $26d094221a813868$var$stringIndexOf = $26d094221a813868$var$unapply(String.prototype.indexOf);
const $26d094221a813868$var$stringTrim = $26d094221a813868$var$unapply(String.prototype.trim);
const $26d094221a813868$var$numberToString = $26d094221a813868$var$unapply(Number.prototype.toString);
const $26d094221a813868$var$booleanToString = $26d094221a813868$var$unapply(Boolean.prototype.toString);
const $26d094221a813868$var$bigintToString = typeof BigInt === 'undefined' ? null : $26d094221a813868$var$unapply(BigInt.prototype.toString);
const $26d094221a813868$var$symbolToString = typeof Symbol === 'undefined' ? null : $26d094221a813868$var$unapply(Symbol.prototype.toString);
const $26d094221a813868$var$objectHasOwnProperty = $26d094221a813868$var$unapply(Object.prototype.hasOwnProperty);
const $26d094221a813868$var$objectToString = $26d094221a813868$var$unapply(Object.prototype.toString);
const $26d094221a813868$var$regExpTest = $26d094221a813868$var$unapply(RegExp.prototype.test);
const $26d094221a813868$var$typeErrorCreate = $26d094221a813868$var$unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */ function $26d094221a813868$var$unapply(func) {
    return function(thisArg) {
        if (thisArg instanceof RegExp) thisArg.lastIndex = 0;
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $26d094221a813868$var$apply(func, thisArg, args);
    };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */ function $26d094221a813868$var$unconstruct(Func) {
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $26d094221a813868$var$construct(Func, args);
    };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */ function $26d094221a813868$var$addToSet(set, array) {
    let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $26d094221a813868$var$stringToLowerCase;
    if ($26d094221a813868$var$setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    $26d094221a813868$var$setPrototypeOf(set, null);
    if (!$26d094221a813868$var$arrayIsArray(array)) return set;
    let l = array.length;
    while(l--){
        let element = array[l];
        if (typeof element === 'string') {
            const lcElement = transformCaseFunc(element);
            if (lcElement !== element) {
                // Config presets (e.g. tags.js, attrs.js) are immutable.
                if (!$26d094221a813868$var$isFrozen(array)) array[l] = lcElement;
                element = lcElement;
            }
        }
        set[element] = true;
    }
    return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */ function $26d094221a813868$var$cleanArray(array) {
    for(let index = 0; index < array.length; index++){
        const isPropertyExist = $26d094221a813868$var$objectHasOwnProperty(array, index);
        if (!isPropertyExist) array[index] = null;
    }
    return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */ function $26d094221a813868$var$clone(object) {
    const newObject = $26d094221a813868$var$create(null);
    for (const [property, value] of $26d094221a813868$var$entries(object)){
        const isPropertyExist = $26d094221a813868$var$objectHasOwnProperty(object, property);
        if (isPropertyExist) {
            if ($26d094221a813868$var$arrayIsArray(value)) newObject[property] = $26d094221a813868$var$cleanArray(value);
            else if (value && typeof value === 'object' && value.constructor === Object) newObject[property] = $26d094221a813868$var$clone(value);
            else newObject[property] = value;
        }
    }
    return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */ function $26d094221a813868$var$stringifyValue(value) {
    switch(typeof value){
        case 'string':
            return value;
        case 'number':
            return $26d094221a813868$var$numberToString(value);
        case 'boolean':
            return $26d094221a813868$var$booleanToString(value);
        case 'bigint':
            return $26d094221a813868$var$bigintToString ? $26d094221a813868$var$bigintToString(value) : '0';
        case 'symbol':
            return $26d094221a813868$var$symbolToString ? $26d094221a813868$var$symbolToString(value) : 'Symbol()';
        case 'undefined':
            return $26d094221a813868$var$objectToString(value);
        case 'function':
        case 'object':
            {
                if (value === null) return $26d094221a813868$var$objectToString(value);
                const valueAsRecord = value;
                const valueToString = $26d094221a813868$var$lookupGetter(valueAsRecord, 'toString');
                if (typeof valueToString === 'function') {
                    const stringified = valueToString(valueAsRecord);
                    return typeof stringified === 'string' ? stringified : $26d094221a813868$var$objectToString(stringified);
                }
                return $26d094221a813868$var$objectToString(value);
            }
        default:
            return $26d094221a813868$var$objectToString(value);
    }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */ function $26d094221a813868$var$lookupGetter(object, prop) {
    while(object !== null){
        const desc = $26d094221a813868$var$getOwnPropertyDescriptor(object, prop);
        if (desc) {
            if (desc.get) return $26d094221a813868$var$unapply(desc.get);
            if (typeof desc.value === 'function') return $26d094221a813868$var$unapply(desc.value);
        }
        object = $26d094221a813868$var$getPrototypeOf(object);
    }
    function fallbackValue() {
        return null;
    }
    return fallbackValue;
}
function $26d094221a813868$var$isRegex(value) {
    try {
        $26d094221a813868$var$regExpTest(value, '');
        return true;
    } catch (_unused) {
        return false;
    }
}
const $26d094221a813868$var$html$1 = $26d094221a813868$var$freeze([
    'a',
    'abbr',
    'acronym',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'bdi',
    'bdo',
    'big',
    'blink',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'center',
    'cite',
    'code',
    'col',
    'colgroup',
    'content',
    'data',
    'datalist',
    'dd',
    'decorator',
    'del',
    'details',
    'dfn',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'element',
    'em',
    'fieldset',
    'figcaption',
    'figure',
    'font',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'img',
    'input',
    'ins',
    'kbd',
    'label',
    'legend',
    'li',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meter',
    'nav',
    'nobr',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'search',
    'section',
    'select',
    'shadow',
    'slot',
    'small',
    'source',
    'spacer',
    'span',
    'strike',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'template',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'tr',
    'track',
    'tt',
    'u',
    'ul',
    'var',
    'video',
    'wbr'
]);
const $26d094221a813868$var$svg$1 = $26d094221a813868$var$freeze([
    'svg',
    'a',
    'altglyph',
    'altglyphdef',
    'altglyphitem',
    'animatecolor',
    'animatemotion',
    'animatetransform',
    'circle',
    'clippath',
    'defs',
    'desc',
    'ellipse',
    'enterkeyhint',
    'exportparts',
    'filter',
    'font',
    'g',
    'glyph',
    'glyphref',
    'hkern',
    'image',
    'inputmode',
    'line',
    'lineargradient',
    'marker',
    'mask',
    'metadata',
    'mpath',
    'part',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialgradient',
    'rect',
    'stop',
    'style',
    'switch',
    'symbol',
    'text',
    'textpath',
    'title',
    'tref',
    'tspan',
    'view',
    'vkern'
]);
const $26d094221a813868$var$svgFilters = $26d094221a813868$var$freeze([
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDistantLight',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussianBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence'
]);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const $26d094221a813868$var$svgDisallowed = $26d094221a813868$var$freeze([
    'animate',
    'color-profile',
    'cursor',
    'discard',
    'font-face',
    'font-face-format',
    'font-face-name',
    'font-face-src',
    'font-face-uri',
    'foreignobject',
    'hatch',
    'hatchpath',
    'mesh',
    'meshgradient',
    'meshpatch',
    'meshrow',
    'missing-glyph',
    'script',
    'set',
    'solidcolor',
    'unknown',
    'use'
]);
const $26d094221a813868$var$mathMl$1 = $26d094221a813868$var$freeze([
    'math',
    'menclose',
    'merror',
    'mfenced',
    'mfrac',
    'mglyph',
    'mi',
    'mlabeledtr',
    'mmultiscripts',
    'mn',
    'mo',
    'mover',
    'mpadded',
    'mphantom',
    'mroot',
    'mrow',
    'ms',
    'mspace',
    'msqrt',
    'mstyle',
    'msub',
    'msup',
    'msubsup',
    'mtable',
    'mtd',
    'mtext',
    'mtr',
    'munder',
    'munderover',
    'mprescripts'
]);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const $26d094221a813868$var$mathMlDisallowed = $26d094221a813868$var$freeze([
    'maction',
    'maligngroup',
    'malignmark',
    'mlongdiv',
    'mscarries',
    'mscarry',
    'msgroup',
    'mstack',
    'msline',
    'msrow',
    'semantics',
    'annotation',
    'annotation-xml',
    'mprescripts',
    'none'
]);
const $26d094221a813868$var$text = $26d094221a813868$var$freeze([
    '#text'
]);
const $26d094221a813868$var$html = $26d094221a813868$var$freeze([
    'accept',
    'action',
    'align',
    'alt',
    'autocapitalize',
    'autocomplete',
    'autopictureinpicture',
    'autoplay',
    'background',
    'bgcolor',
    'border',
    'capture',
    'cellpadding',
    'cellspacing',
    'checked',
    'cite',
    'class',
    'clear',
    'color',
    'cols',
    'colspan',
    'controls',
    'controlslist',
    'coords',
    'crossorigin',
    'datetime',
    'decoding',
    'default',
    'dir',
    'disabled',
    'disablepictureinpicture',
    'disableremoteplayback',
    'download',
    'draggable',
    'enctype',
    'enterkeyhint',
    'exportparts',
    'face',
    'for',
    'headers',
    'height',
    'hidden',
    'high',
    'href',
    'hreflang',
    'id',
    'inert',
    'inputmode',
    'integrity',
    'ismap',
    'kind',
    'label',
    'lang',
    'list',
    'loading',
    'loop',
    'low',
    'max',
    'maxlength',
    'media',
    'method',
    'min',
    'minlength',
    'multiple',
    'muted',
    'name',
    'nonce',
    'noshade',
    'novalidate',
    'nowrap',
    'open',
    'optimum',
    'part',
    'pattern',
    'placeholder',
    'playsinline',
    'popover',
    'popovertarget',
    'popovertargetaction',
    'poster',
    'preload',
    'pubdate',
    'radiogroup',
    'readonly',
    'rel',
    'required',
    'rev',
    'reversed',
    'role',
    'rows',
    'rowspan',
    'spellcheck',
    'scope',
    'selected',
    'shape',
    'size',
    'sizes',
    'slot',
    'span',
    'srclang',
    'start',
    'src',
    'srcset',
    'step',
    'style',
    'summary',
    'tabindex',
    'title',
    'translate',
    'type',
    'usemap',
    'valign',
    'value',
    'width',
    'wrap',
    'xmlns'
]);
const $26d094221a813868$var$svg = $26d094221a813868$var$freeze([
    'accent-height',
    'accumulate',
    'additive',
    'alignment-baseline',
    'amplitude',
    'ascent',
    'attributename',
    'attributetype',
    'azimuth',
    'basefrequency',
    'baseline-shift',
    'begin',
    'bias',
    'by',
    'class',
    'clip',
    'clippathunits',
    'clip-path',
    'clip-rule',
    'color',
    'color-interpolation',
    'color-interpolation-filters',
    'color-profile',
    'color-rendering',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'diffuseconstant',
    'direction',
    'display',
    'divisor',
    'dur',
    'edgemode',
    'elevation',
    'end',
    'exponent',
    'fill',
    'fill-opacity',
    'fill-rule',
    'filter',
    'filterunits',
    'flood-color',
    'flood-opacity',
    'font-family',
    'font-size',
    'font-size-adjust',
    'font-stretch',
    'font-style',
    'font-variant',
    'font-weight',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyph-name',
    'glyphref',
    'gradientunits',
    'gradienttransform',
    'height',
    'href',
    'id',
    'image-rendering',
    'in',
    'in2',
    'intercept',
    'k',
    'k1',
    'k2',
    'k3',
    'k4',
    'kerning',
    'keypoints',
    'keysplines',
    'keytimes',
    'lang',
    'lengthadjust',
    'letter-spacing',
    'kernelmatrix',
    'kernelunitlength',
    'lighting-color',
    'local',
    'marker-end',
    'marker-mid',
    'marker-start',
    'markerheight',
    'markerunits',
    'markerwidth',
    'maskcontentunits',
    'maskunits',
    'max',
    'mask',
    'mask-type',
    'media',
    'method',
    'mode',
    'min',
    'name',
    'numoctaves',
    'offset',
    'operator',
    'opacity',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'paint-order',
    'path',
    'pathlength',
    'patterncontentunits',
    'patterntransform',
    'patternunits',
    'points',
    'preservealpha',
    'preserveaspectratio',
    'primitiveunits',
    'r',
    'rx',
    'ry',
    'radius',
    'refx',
    'refy',
    'repeatcount',
    'repeatdur',
    'restart',
    'result',
    'rotate',
    'scale',
    'seed',
    'shape-rendering',
    'slope',
    'specularconstant',
    'specularexponent',
    'spreadmethod',
    'startoffset',
    'stddeviation',
    'stitchtiles',
    'stop-color',
    'stop-opacity',
    'stroke-dasharray',
    'stroke-dashoffset',
    'stroke-linecap',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke',
    'stroke-width',
    'style',
    'surfacescale',
    'systemlanguage',
    'tabindex',
    'tablevalues',
    'targetx',
    'targety',
    'transform',
    'transform-origin',
    'text-anchor',
    'text-decoration',
    'text-rendering',
    'textlength',
    'type',
    'u1',
    'u2',
    'unicode',
    'values',
    'viewbox',
    'visibility',
    'version',
    'vert-adv-y',
    'vert-origin-x',
    'vert-origin-y',
    'width',
    'word-spacing',
    'wrap',
    'writing-mode',
    'xchannelselector',
    'ychannelselector',
    'x',
    'x1',
    'x2',
    'xmlns',
    'y',
    'y1',
    'y2',
    'z',
    'zoomandpan'
]);
const $26d094221a813868$var$mathMl = $26d094221a813868$var$freeze([
    'accent',
    'accentunder',
    'align',
    'bevelled',
    'close',
    'columnalign',
    'columnlines',
    'columnspacing',
    'columnspan',
    'denomalign',
    'depth',
    'dir',
    'display',
    'displaystyle',
    'encoding',
    'fence',
    'frame',
    'height',
    'href',
    'id',
    'largeop',
    'length',
    'linethickness',
    'lquote',
    'lspace',
    'mathbackground',
    'mathcolor',
    'mathsize',
    'mathvariant',
    'maxsize',
    'minsize',
    'movablelimits',
    'notation',
    'numalign',
    'open',
    'rowalign',
    'rowlines',
    'rowspacing',
    'rowspan',
    'rspace',
    'rquote',
    'scriptlevel',
    'scriptminsize',
    'scriptsizemultiplier',
    'selection',
    'separator',
    'separators',
    'stretchy',
    'subscriptshift',
    'supscriptshift',
    'symmetric',
    'voffset',
    'width',
    'xmlns'
]);
const $26d094221a813868$var$xml = $26d094221a813868$var$freeze([
    'xlink:href',
    'xml:id',
    'xlink:title',
    'xml:space',
    'xmlns:xlink'
]);
// eslint-disable-next-line unicorn/better-regex
const $26d094221a813868$var$MUSTACHE_EXPR = $26d094221a813868$var$seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
const $26d094221a813868$var$ERB_EXPR = $26d094221a813868$var$seal(/<%[\w\W]*|[\w\W]*%>/gm);
const $26d094221a813868$var$TMPLIT_EXPR = $26d094221a813868$var$seal(/\$\{[\w\W]*/gm); // eslint-disable-line unicorn/better-regex
const $26d094221a813868$var$DATA_ATTR = $26d094221a813868$var$seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const $26d094221a813868$var$ARIA_ATTR = $26d094221a813868$var$seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const $26d094221a813868$var$IS_ALLOWED_URI = $26d094221a813868$var$seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const $26d094221a813868$var$IS_SCRIPT_OR_DATA = $26d094221a813868$var$seal(/^(?:\w+script|data):/i);
const $26d094221a813868$var$ATTR_WHITESPACE = $26d094221a813868$var$seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const $26d094221a813868$var$DOCTYPE_NAME = $26d094221a813868$var$seal(/^html$/i);
const $26d094221a813868$var$CUSTOM_ELEMENT = $26d094221a813868$var$seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
var $26d094221a813868$var$EXPRESSIONS = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ARIA_ATTR: $26d094221a813868$var$ARIA_ATTR,
    ATTR_WHITESPACE: $26d094221a813868$var$ATTR_WHITESPACE,
    CUSTOM_ELEMENT: $26d094221a813868$var$CUSTOM_ELEMENT,
    DATA_ATTR: $26d094221a813868$var$DATA_ATTR,
    DOCTYPE_NAME: $26d094221a813868$var$DOCTYPE_NAME,
    ERB_EXPR: $26d094221a813868$var$ERB_EXPR,
    IS_ALLOWED_URI: $26d094221a813868$var$IS_ALLOWED_URI,
    IS_SCRIPT_OR_DATA: $26d094221a813868$var$IS_SCRIPT_OR_DATA,
    MUSTACHE_EXPR: $26d094221a813868$var$MUSTACHE_EXPR,
    TMPLIT_EXPR: $26d094221a813868$var$TMPLIT_EXPR
});
/* eslint-disable @typescript-eslint/indent */ // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const $26d094221a813868$var$NODE_TYPE = {
    element: 1,
    text: 3,
    // Deprecated
    progressingInstruction: 7,
    comment: 8,
    document: 9
};
const $26d094221a813868$var$getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */ const $26d094221a813868$var$_createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
    if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    let suffix = null;
    const ATTR_NAME = 'data-tt-policy-suffix';
    if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) suffix = purifyHostElement.getAttribute(ATTR_NAME);
    const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
    try {
        return trustedTypes.createPolicy(policyName, {
            createHTML (html) {
                return html;
            },
            createScriptURL (scriptUrl) {
                return scriptUrl;
            }
        });
    } catch (_) {
        // Policy creation failed (most likely another DOMPurify script has
        // already run). Skip creating the policy, as this will only cause errors
        // if TT are enforced.
        console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
        return null;
    }
};
const $26d094221a813868$var$_createHooksMap = function _createHooksMap() {
    return {
        afterSanitizeAttributes: [],
        afterSanitizeElements: [],
        afterSanitizeShadowDOM: [],
        beforeSanitizeAttributes: [],
        beforeSanitizeElements: [],
        beforeSanitizeShadowDOM: [],
        uponSanitizeAttribute: [],
        uponSanitizeElement: [],
        uponSanitizeShadowNode: []
    };
};
function $26d094221a813868$var$createDOMPurify() {
    let window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $26d094221a813868$var$getGlobal();
    const DOMPurify = (root)=>$26d094221a813868$var$createDOMPurify(root);
    DOMPurify.version = '3.4.1';
    DOMPurify.removed = [];
    if (!window1 || !window1.document || window1.document.nodeType !== $26d094221a813868$var$NODE_TYPE.document || !window1.Element) {
        // Not running in a browser, provide a factory function
        // so that you can pass your own Window
        DOMPurify.isSupported = false;
        return DOMPurify;
    }
    let { document: document } = window1;
    const originalDocument = document;
    const currentScript = originalDocument.currentScript;
    const { DocumentFragment: DocumentFragment, HTMLTemplateElement: HTMLTemplateElement, Node: Node, Element: Element, NodeFilter: NodeFilter, NamedNodeMap: NamedNodeMap = window1.NamedNodeMap || window1.MozNamedAttrMap, HTMLFormElement: HTMLFormElement, DOMParser: DOMParser, trustedTypes: trustedTypes } = window1;
    const ElementPrototype = Element.prototype;
    const cloneNode = $26d094221a813868$var$lookupGetter(ElementPrototype, 'cloneNode');
    const remove = $26d094221a813868$var$lookupGetter(ElementPrototype, 'remove');
    const getNextSibling = $26d094221a813868$var$lookupGetter(ElementPrototype, 'nextSibling');
    const getChildNodes = $26d094221a813868$var$lookupGetter(ElementPrototype, 'childNodes');
    const getParentNode = $26d094221a813868$var$lookupGetter(ElementPrototype, 'parentNode');
    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
        const template = document.createElement('template');
        if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
    }
    let trustedTypesPolicy;
    let emptyHTML = '';
    const { implementation: implementation, createNodeIterator: createNodeIterator, createDocumentFragment: createDocumentFragment, getElementsByTagName: getElementsByTagName } = document;
    const { importNode: importNode } = originalDocument;
    let hooks = $26d094221a813868$var$_createHooksMap();
    /**
   * Expose whether this browser supports running the full DOMPurify.
   */ DOMPurify.isSupported = typeof $26d094221a813868$var$entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
    const { MUSTACHE_EXPR: MUSTACHE_EXPR, ERB_EXPR: ERB_EXPR, TMPLIT_EXPR: TMPLIT_EXPR, DATA_ATTR: DATA_ATTR, ARIA_ATTR: ARIA_ATTR, IS_SCRIPT_OR_DATA: IS_SCRIPT_OR_DATA, ATTR_WHITESPACE: ATTR_WHITESPACE, CUSTOM_ELEMENT: CUSTOM_ELEMENT } = $26d094221a813868$var$EXPRESSIONS;
    let { IS_ALLOWED_URI: IS_ALLOWED_URI$1 } = $26d094221a813868$var$EXPRESSIONS;
    /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */ /* allowed element names */ let ALLOWED_TAGS = null;
    const DEFAULT_ALLOWED_TAGS = $26d094221a813868$var$addToSet({}, [
        ...$26d094221a813868$var$html$1,
        ...$26d094221a813868$var$svg$1,
        ...$26d094221a813868$var$svgFilters,
        ...$26d094221a813868$var$mathMl$1,
        ...$26d094221a813868$var$text
    ]);
    /* Allowed attribute names */ let ALLOWED_ATTR = null;
    const DEFAULT_ALLOWED_ATTR = $26d094221a813868$var$addToSet({}, [
        ...$26d094221a813868$var$html,
        ...$26d094221a813868$var$svg,
        ...$26d094221a813868$var$mathMl,
        ...$26d094221a813868$var$xml
    ]);
    /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */ let CUSTOM_ELEMENT_HANDLING = Object.seal($26d094221a813868$var$create(null, {
        tagNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeNameCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        allowCustomizedBuiltInElements: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: false
        }
    }));
    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ let FORBID_TAGS = null;
    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ let FORBID_ATTR = null;
    /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */ const EXTRA_ELEMENT_HANDLING = Object.seal($26d094221a813868$var$create(null, {
        tagCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        },
        attributeCheck: {
            writable: true,
            configurable: false,
            enumerable: true,
            value: null
        }
    }));
    /* Decide if ARIA attributes are okay */ let ALLOW_ARIA_ATTR = true;
    /* Decide if custom data attributes are okay */ let ALLOW_DATA_ATTR = true;
    /* Decide if unknown protocols are okay */ let ALLOW_UNKNOWN_PROTOCOLS = false;
    /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */ let ALLOW_SELF_CLOSE_IN_ATTR = true;
    /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */ let SAFE_FOR_TEMPLATES = false;
    /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */ let SAFE_FOR_XML = true;
    /* Decide if document with <html>... should be returned */ let WHOLE_DOCUMENT = false;
    /* Track whether config is already set on this instance of DOMPurify. */ let SET_CONFIG = false;
    /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */ let FORCE_BODY = false;
    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */ let RETURN_DOM = false;
    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */ let RETURN_DOM_FRAGMENT = false;
    /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */ let RETURN_TRUSTED_TYPE = false;
    /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */ let SANITIZE_DOM = true;
    /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */ let SANITIZE_NAMED_PROPS = false;
    const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
    /* Keep element content when removing element? */ let KEEP_CONTENT = true;
    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */ let IN_PLACE = false;
    /* Allow usage of profiles like html, svg and mathMl */ let USE_PROFILES = {};
    /* Tags to ignore content of when KEEP_CONTENT is true */ let FORBID_CONTENTS = null;
    const DEFAULT_FORBID_CONTENTS = $26d094221a813868$var$addToSet({}, [
        'annotation-xml',
        'audio',
        'colgroup',
        'desc',
        'foreignobject',
        'head',
        'iframe',
        'math',
        'mi',
        'mn',
        'mo',
        'ms',
        'mtext',
        'noembed',
        'noframes',
        'noscript',
        'plaintext',
        'script',
        'style',
        'svg',
        'template',
        'thead',
        'title',
        'video',
        'xmp'
    ]);
    /* Tags that are safe for data: URIs */ let DATA_URI_TAGS = null;
    const DEFAULT_DATA_URI_TAGS = $26d094221a813868$var$addToSet({}, [
        'audio',
        'video',
        'img',
        'source',
        'image',
        'track'
    ]);
    /* Attributes safe for values like "javascript:" */ let URI_SAFE_ATTRIBUTES = null;
    const DEFAULT_URI_SAFE_ATTRIBUTES = $26d094221a813868$var$addToSet({}, [
        'alt',
        'class',
        'for',
        'id',
        'label',
        'name',
        'pattern',
        'placeholder',
        'role',
        'summary',
        'title',
        'value',
        'style',
        'xmlns'
    ]);
    const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */ let NAMESPACE = HTML_NAMESPACE;
    let IS_EMPTY_INPUT = false;
    /* Allowed XHTML+XML namespaces */ let ALLOWED_NAMESPACES = null;
    const DEFAULT_ALLOWED_NAMESPACES = $26d094221a813868$var$addToSet({}, [
        MATHML_NAMESPACE,
        SVG_NAMESPACE,
        HTML_NAMESPACE
    ], $26d094221a813868$var$stringToString);
    let MATHML_TEXT_INTEGRATION_POINTS = $26d094221a813868$var$addToSet({}, [
        'mi',
        'mo',
        'mn',
        'ms',
        'mtext'
    ]);
    let HTML_INTEGRATION_POINTS = $26d094221a813868$var$addToSet({}, [
        'annotation-xml'
    ]);
    // Certain elements are allowed in both SVG and HTML
    // namespace. We need to specify them explicitly
    // so that they don't get erroneously deleted from
    // HTML namespace.
    const COMMON_SVG_AND_HTML_ELEMENTS = $26d094221a813868$var$addToSet({}, [
        'title',
        'style',
        'font',
        'a',
        'script'
    ]);
    /* Parsing of strict XHTML documents */ let PARSER_MEDIA_TYPE = null;
    const SUPPORTED_PARSER_MEDIA_TYPES = [
        'application/xhtml+xml',
        'text/html'
    ];
    const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    let transformCaseFunc = null;
    /* Keep a reference to config to pass to hooks */ let CONFIG = null;
    /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ const formElement = document.createElement('form');
    const isRegexOrFunction = function isRegexOrFunction(testValue) {
        return testValue instanceof RegExp || testValue instanceof Function;
    };
    /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */ // eslint-disable-next-line complexity
    const _parseConfig = function _parseConfig() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (CONFIG && CONFIG === cfg) return;
        /* Shield configuration object from tampering */ if (!cfg || typeof cfg !== 'object') cfg = {};
        /* Shield configuration object from prototype pollution */ cfg = $26d094221a813868$var$clone(cfg);
        PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
        SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
        // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
        transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? $26d094221a813868$var$stringToString : $26d094221a813868$var$stringToLowerCase;
        /* Set configuration parameters */ ALLOWED_TAGS = $26d094221a813868$var$objectHasOwnProperty(cfg, 'ALLOWED_TAGS') && $26d094221a813868$var$arrayIsArray(cfg.ALLOWED_TAGS) ? $26d094221a813868$var$addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
        ALLOWED_ATTR = $26d094221a813868$var$objectHasOwnProperty(cfg, 'ALLOWED_ATTR') && $26d094221a813868$var$arrayIsArray(cfg.ALLOWED_ATTR) ? $26d094221a813868$var$addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
        ALLOWED_NAMESPACES = $26d094221a813868$var$objectHasOwnProperty(cfg, 'ALLOWED_NAMESPACES') && $26d094221a813868$var$arrayIsArray(cfg.ALLOWED_NAMESPACES) ? $26d094221a813868$var$addToSet({}, cfg.ALLOWED_NAMESPACES, $26d094221a813868$var$stringToString) : DEFAULT_ALLOWED_NAMESPACES;
        URI_SAFE_ATTRIBUTES = $26d094221a813868$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && $26d094221a813868$var$arrayIsArray(cfg.ADD_URI_SAFE_ATTR) ? $26d094221a813868$var$addToSet($26d094221a813868$var$clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR, transformCaseFunc) : DEFAULT_URI_SAFE_ATTRIBUTES;
        DATA_URI_TAGS = $26d094221a813868$var$objectHasOwnProperty(cfg, 'ADD_DATA_URI_TAGS') && $26d094221a813868$var$arrayIsArray(cfg.ADD_DATA_URI_TAGS) ? $26d094221a813868$var$addToSet($26d094221a813868$var$clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS, transformCaseFunc) : DEFAULT_DATA_URI_TAGS;
        FORBID_CONTENTS = $26d094221a813868$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && $26d094221a813868$var$arrayIsArray(cfg.FORBID_CONTENTS) ? $26d094221a813868$var$addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
        FORBID_TAGS = $26d094221a813868$var$objectHasOwnProperty(cfg, 'FORBID_TAGS') && $26d094221a813868$var$arrayIsArray(cfg.FORBID_TAGS) ? $26d094221a813868$var$addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : $26d094221a813868$var$clone({});
        FORBID_ATTR = $26d094221a813868$var$objectHasOwnProperty(cfg, 'FORBID_ATTR') && $26d094221a813868$var$arrayIsArray(cfg.FORBID_ATTR) ? $26d094221a813868$var$addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : $26d094221a813868$var$clone({});
        USE_PROFILES = $26d094221a813868$var$objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? $26d094221a813868$var$clone(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
        ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
        ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
        ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
        ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
        SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
        SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
        WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
        RETURN_DOM = cfg.RETURN_DOM || false; // Default false
        RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
        RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
        FORCE_BODY = cfg.FORCE_BODY || false; // Default false
        SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
        SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
        KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
        IN_PLACE = cfg.IN_PLACE || false; // Default false
        IS_ALLOWED_URI$1 = $26d094221a813868$var$isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : $26d094221a813868$var$IS_ALLOWED_URI; // Default regexp
        NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
        MATHML_TEXT_INTEGRATION_POINTS = $26d094221a813868$var$objectHasOwnProperty(cfg, 'MATHML_TEXT_INTEGRATION_POINTS') && cfg.MATHML_TEXT_INTEGRATION_POINTS && typeof cfg.MATHML_TEXT_INTEGRATION_POINTS === 'object' ? $26d094221a813868$var$clone(cfg.MATHML_TEXT_INTEGRATION_POINTS) : $26d094221a813868$var$addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]); // Default built-in map
        HTML_INTEGRATION_POINTS = $26d094221a813868$var$objectHasOwnProperty(cfg, 'HTML_INTEGRATION_POINTS') && cfg.HTML_INTEGRATION_POINTS && typeof cfg.HTML_INTEGRATION_POINTS === 'object' ? $26d094221a813868$var$clone(cfg.HTML_INTEGRATION_POINTS) : $26d094221a813868$var$addToSet({}, [
            'annotation-xml'
        ]); // Default built-in map
        const customElementHandling = $26d094221a813868$var$objectHasOwnProperty(cfg, 'CUSTOM_ELEMENT_HANDLING') && cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING === 'object' ? $26d094221a813868$var$clone(cfg.CUSTOM_ELEMENT_HANDLING) : $26d094221a813868$var$create(null);
        CUSTOM_ELEMENT_HANDLING = $26d094221a813868$var$create(null);
        if ($26d094221a813868$var$objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
        if ($26d094221a813868$var$objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
        if ($26d094221a813868$var$objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
        if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
        if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
        /* Parse profile info */ if (USE_PROFILES) {
            ALLOWED_TAGS = $26d094221a813868$var$addToSet({}, $26d094221a813868$var$text);
            ALLOWED_ATTR = $26d094221a813868$var$create(null);
            if (USE_PROFILES.html === true) {
                $26d094221a813868$var$addToSet(ALLOWED_TAGS, $26d094221a813868$var$html$1);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$html);
            }
            if (USE_PROFILES.svg === true) {
                $26d094221a813868$var$addToSet(ALLOWED_TAGS, $26d094221a813868$var$svg$1);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$svg);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$xml);
            }
            if (USE_PROFILES.svgFilters === true) {
                $26d094221a813868$var$addToSet(ALLOWED_TAGS, $26d094221a813868$var$svgFilters);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$svg);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$xml);
            }
            if (USE_PROFILES.mathMl === true) {
                $26d094221a813868$var$addToSet(ALLOWED_TAGS, $26d094221a813868$var$mathMl$1);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$mathMl);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, $26d094221a813868$var$xml);
            }
        }
        /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */ EXTRA_ELEMENT_HANDLING.tagCheck = null;
        EXTRA_ELEMENT_HANDLING.attributeCheck = null;
        /* Merge configuration parameters */ if ($26d094221a813868$var$objectHasOwnProperty(cfg, 'ADD_TAGS')) {
            if (typeof cfg.ADD_TAGS === 'function') EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
            else if ($26d094221a813868$var$arrayIsArray(cfg.ADD_TAGS)) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = $26d094221a813868$var$clone(ALLOWED_TAGS);
                $26d094221a813868$var$addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
        }
        if ($26d094221a813868$var$objectHasOwnProperty(cfg, 'ADD_ATTR')) {
            if (typeof cfg.ADD_ATTR === 'function') EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
            else if ($26d094221a813868$var$arrayIsArray(cfg.ADD_ATTR)) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = $26d094221a813868$var$clone(ALLOWED_ATTR);
                $26d094221a813868$var$addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
        }
        if ($26d094221a813868$var$objectHasOwnProperty(cfg, 'ADD_URI_SAFE_ATTR') && $26d094221a813868$var$arrayIsArray(cfg.ADD_URI_SAFE_ATTR)) $26d094221a813868$var$addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
        if ($26d094221a813868$var$objectHasOwnProperty(cfg, 'FORBID_CONTENTS') && $26d094221a813868$var$arrayIsArray(cfg.FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $26d094221a813868$var$clone(FORBID_CONTENTS);
            $26d094221a813868$var$addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
        }
        if ($26d094221a813868$var$objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && $26d094221a813868$var$arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
            if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = $26d094221a813868$var$clone(FORBID_CONTENTS);
            $26d094221a813868$var$addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
        }
        /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
        /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) $26d094221a813868$var$addToSet(ALLOWED_TAGS, [
            'html',
            'head',
            'body'
        ]);
        /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
            $26d094221a813868$var$addToSet(ALLOWED_TAGS, [
                'tbody'
            ]);
            delete FORBID_TAGS.tbody;
        }
        if (cfg.TRUSTED_TYPES_POLICY) {
            if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') throw $26d094221a813868$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
            if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') throw $26d094221a813868$var$typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
            // Overwrite existing TrustedTypes policy.
            trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
            // Sign local variables required by `sanitize`.
            emptyHTML = trustedTypesPolicy.createHTML('');
        } else {
            // Uninitialized policy, attempt to initialize the internal dompurify policy.
            if (trustedTypesPolicy === undefined) trustedTypesPolicy = $26d094221a813868$var$_createTrustedTypesPolicy(trustedTypes, currentScript);
            // If creating the internal policy succeeded sign internal variables.
            if (trustedTypesPolicy !== null && typeof emptyHTML === 'string') emptyHTML = trustedTypesPolicy.createHTML('');
        }
        // Prevent further manipulation of configuration.
        // Not available in IE8, Safari 5, etc.
        if ($26d094221a813868$var$freeze) $26d094221a813868$var$freeze(cfg);
        CONFIG = cfg;
    };
    /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */ const ALL_SVG_TAGS = $26d094221a813868$var$addToSet({}, [
        ...$26d094221a813868$var$svg$1,
        ...$26d094221a813868$var$svgFilters,
        ...$26d094221a813868$var$svgDisallowed
    ]);
    const ALL_MATHML_TAGS = $26d094221a813868$var$addToSet({}, [
        ...$26d094221a813868$var$mathMl$1,
        ...$26d094221a813868$var$mathMlDisallowed
    ]);
    /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */ const _checkValidNamespace = function _checkValidNamespace(element) {
        let parent = getParentNode(element);
        // In JSDOM, if we're inside shadow DOM, then parentNode
        // can be null. We just simulate parent in this case.
        if (!parent || !parent.tagName) parent = {
            namespaceURI: NAMESPACE,
            tagName: 'template'
        };
        const tagName = $26d094221a813868$var$stringToLowerCase(element.tagName);
        const parentTagName = $26d094221a813868$var$stringToLowerCase(parent.tagName);
        if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
        if (element.namespaceURI === SVG_NAMESPACE) {
            // The only way to switch from HTML namespace to SVG
            // is via <svg>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
            // The only way to switch from MathML to SVG is via`
            // svg if parent is either <annotation-xml> or MathML
            // text integration points.
            if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
            // We only allow elements that are defined in SVG
            // spec. All others are disallowed in SVG namespace.
            return Boolean(ALL_SVG_TAGS[tagName]);
        }
        if (element.namespaceURI === MATHML_NAMESPACE) {
            // The only way to switch from HTML namespace to MathML
            // is via <math>. If it happens via any other tag, then
            // it should be killed.
            if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
            // The only way to switch from SVG to MathML is via
            // <math> and HTML integration points
            if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
            // We only allow elements that are defined in MathML
            // spec. All others are disallowed in MathML namespace.
            return Boolean(ALL_MATHML_TAGS[tagName]);
        }
        if (element.namespaceURI === HTML_NAMESPACE) {
            // The only way to switch from SVG to HTML is via
            // HTML integration points, and from MathML to HTML
            // is via MathML text integration points
            if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
            if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
            // We disallow tags that are specific for MathML
            // or SVG and should never appear in HTML namespace
            return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
        }
        // For XHTML and XML documents that support custom namespaces
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
        // The code should never reach this place (this means
        // that the element somehow got namespace that is not
        // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
        // Return false just in case.
        return false;
    };
    /**
   * _forceRemove
   *
   * @param node a DOM node
   */ const _forceRemove = function _forceRemove(node) {
        $26d094221a813868$var$arrayPush(DOMPurify.removed, {
            element: node
        });
        try {
            // eslint-disable-next-line unicorn/prefer-dom-node-remove
            getParentNode(node).removeChild(node);
        } catch (_) {
            remove(node);
        }
    };
    /**
   * _removeAttribute
   *
   * @param name an Attribute name
   * @param element a DOM node
   */ const _removeAttribute = function _removeAttribute(name, element) {
        try {
            $26d094221a813868$var$arrayPush(DOMPurify.removed, {
                attribute: element.getAttributeNode(name),
                from: element
            });
        } catch (_) {
            $26d094221a813868$var$arrayPush(DOMPurify.removed, {
                attribute: null,
                from: element
            });
        }
        element.removeAttribute(name);
        // We void attribute values for unremovable "is" attributes
        if (name === 'is') {
            if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                _forceRemove(element);
            } catch (_) {}
            else try {
                element.setAttribute(name, '');
            } catch (_) {}
        }
    };
    /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */ const _initDocument = function _initDocument(dirty) {
        /* Create a HTML document */ let doc = null;
        let leadingWhitespace = null;
        if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
        else {
            /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ const matches = $26d094221a813868$var$stringMatch(dirty, /^[\r\n\t ]+/);
            leadingWhitespace = matches && matches[0];
        }
        if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
        const dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
        /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */ if (NAMESPACE === HTML_NAMESPACE) try {
            doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
        /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
            doc = implementation.createDocument(NAMESPACE, 'template', null);
            try {
                doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
            } catch (_) {
            // Syntax error if dirtyPayload is invalid xml
            }
        }
        const body = doc.body || doc.documentElement;
        if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
        /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
        return WHOLE_DOCUMENT ? doc.documentElement : body;
    };
    /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */ const _createNodeIterator = function _createNodeIterator(root) {
        return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
    };
    /**
   * _isClobbered
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */ const _isClobbered = function _isClobbered(element) {
        return element instanceof HTMLFormElement && (typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' || !(element.attributes instanceof NamedNodeMap) || typeof element.removeAttribute !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function');
    };
    /**
   * Checks whether the given object is a DOM node.
   *
   * @param value object to check whether it's a DOM node
   * @return true is object is a DOM node
   */ const _isNode = function _isNode(value) {
        return typeof Node === 'function' && value instanceof Node;
    };
    function _executeHooks(hooks, currentNode, data) {
        $26d094221a813868$var$arrayForEach(hooks, (hook)=>{
            hook.call(DOMPurify, currentNode, data, CONFIG);
        });
    }
    /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */ const _sanitizeElements = function _sanitizeElements(currentNode) {
        let content = null;
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
        /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Now let's check the element's type and name */ const tagName = transformCaseFunc(currentNode.nodeName);
        /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeElement, currentNode, {
            tagName: tagName,
            allowedTags: ALLOWED_TAGS
        });
        /* Detect mXSS attempts abusing namespace confusion */ if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && $26d094221a813868$var$regExpTest(/<[/\w!]/g, currentNode.innerHTML) && $26d094221a813868$var$regExpTest(/<[/\w!]/g, currentNode.textContent)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove risky CSS construction leading to mXSS */ if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && tagName === 'style' && _isNode(currentNode.firstElementChild)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any occurrence of processing instructions */ if (currentNode.nodeType === $26d094221a813868$var$NODE_TYPE.progressingInstruction) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === $26d094221a813868$var$NODE_TYPE.comment && $26d094221a813868$var$regExpTest(/<[/\w]/g, currentNode.data)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Remove element if anything forbids its presence */ if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
            /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName)) {
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $26d094221a813868$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
            }
            /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                const parentNode = getParentNode(currentNode) || currentNode.parentNode;
                const childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                if (childNodes && parentNode) {
                    const childCount = childNodes.length;
                    for(let i = childCount - 1; i >= 0; --i){
                        const childClone = cloneNode(childNodes[i], true);
                        parentNode.insertBefore(childClone, getNextSibling(currentNode));
                    }
                }
            }
            _forceRemove(currentNode);
            return true;
        }
        /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && $26d094221a813868$var$regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
            _forceRemove(currentNode);
            return true;
        }
        /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === $26d094221a813868$var$NODE_TYPE.text) {
            /* Get the element's text content */ content = currentNode.textContent;
            $26d094221a813868$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                content = $26d094221a813868$var$stringReplace(content, expr, ' ');
            });
            if (currentNode.textContent !== content) {
                $26d094221a813868$var$arrayPush(DOMPurify.removed, {
                    element: currentNode.cloneNode()
                });
                currentNode.textContent = content;
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeElements, currentNode, null);
        return false;
    };
    /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */ // eslint-disable-next-line complexity
    const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
        /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */ if (FORBID_ATTR[lcName]) return false;
        /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
        /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && $26d094221a813868$var$regExpTest(DATA_ATTR, lcName)) ;
        else if (ALLOW_ARIA_ATTR && $26d094221a813868$var$regExpTest(ARIA_ATTR, lcName)) ;
        else if (EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag)) ;
        else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
            if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            _isBasicCustomElement(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $26d094221a813868$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && $26d094221a813868$var$regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName, lcTag)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && $26d094221a813868$var$regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
            else return false;
        /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
        else if ($26d094221a813868$var$regExpTest(IS_ALLOWED_URI$1, $26d094221a813868$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && $26d094221a813868$var$stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
        else if (ALLOW_UNKNOWN_PROTOCOLS && !$26d094221a813868$var$regExpTest(IS_SCRIPT_OR_DATA, $26d094221a813868$var$stringReplace(value, ATTR_WHITESPACE, ''))) ;
        else if (value) return false;
        return true;
    };
    /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */ const RESERVED_CUSTOM_ELEMENT_NAMES = $26d094221a813868$var$addToSet({}, [
        'annotation-xml',
        'color-profile',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'missing-glyph'
    ]);
    /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */ const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
        return !RESERVED_CUSTOM_ELEMENT_NAMES[$26d094221a813868$var$stringToLowerCase(tagName)] && $26d094221a813868$var$regExpTest(CUSTOM_ELEMENT, tagName);
    };
    /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */ const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
        const { attributes: attributes } = currentNode;
        /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
        const hookEvent = {
            attrName: '',
            attrValue: '',
            keepAttr: true,
            allowedAttributes: ALLOWED_ATTR,
            forceKeepAttr: undefined
        };
        let l = attributes.length;
        /* Go backwards over all attributes; safely remove bad ones */ while(l--){
            const attr = attributes[l];
            const { name: name, namespaceURI: namespaceURI, value: attrValue } = attr;
            const lcName = transformCaseFunc(name);
            const initValue = attrValue;
            let value = name === 'value' ? initValue : $26d094221a813868$var$stringTrim(initValue);
            /* Execute a hook if present */ hookEvent.attrName = lcName;
            hookEvent.attrValue = value;
            hookEvent.keepAttr = true;
            hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
            _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
            value = hookEvent.attrValue;
            /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && $26d094221a813868$var$stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
                // Remove the attribute with this value
                _removeAttribute(name, currentNode);
                // Prefix the value and later re-create the attribute with the sanitized value
                value = SANITIZE_NAMED_PROPS_PREFIX + value;
            }
            // Else: already prefixed, leave the attribute alone — the prefix is
            // itself the clobbering protection, and re-applying it is incorrect.
            /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && $26d094221a813868$var$regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Make sure we cannot easily use animated hrefs, even if animations are allowed */ if (lcName === 'attributename' && $26d094221a813868$var$stringMatch(value, 'href')) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
            /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && $26d094221a813868$var$regExpTest(/\/>/i, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) $26d094221a813868$var$arrayForEach([
                MUSTACHE_EXPR,
                ERB_EXPR,
                TMPLIT_EXPR
            ], (expr)=>{
                value = $26d094221a813868$var$stringReplace(value, expr, ' ');
            });
            /* Is `value` valid for this attribute? */ const lcTag = transformCaseFunc(currentNode.nodeName);
            if (!_isValidAttribute(lcTag, lcName, value)) {
                _removeAttribute(name, currentNode);
                continue;
            }
            /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                if (namespaceURI) ;
                else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                    case 'TrustedHTML':
                        value = trustedTypesPolicy.createHTML(value);
                        break;
                    case 'TrustedScriptURL':
                        value = trustedTypesPolicy.createScriptURL(value);
                        break;
                }
            }
            /* Handle invalid data-* attribute set by try-catching it */ if (value !== initValue) try {
                if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                if (_isClobbered(currentNode)) _forceRemove(currentNode);
                else $26d094221a813868$var$arrayPop(DOMPurify.removed);
            } catch (_) {
                _removeAttribute(name, currentNode);
            }
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
    };
    /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */ const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
        let shadowNode = null;
        const shadowIterator = _createNodeIterator(fragment);
        /* Execute a hook if present */ _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
        while(shadowNode = shadowIterator.nextNode()){
            /* Execute a hook if present */ _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
            /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
            /* Check attributes next */ _sanitizeAttributes(shadowNode);
            /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(shadowNode.content);
        }
        /* Execute a hook if present */ _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
    };
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function(dirty) {
        let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let body = null;
        let importedNode = null;
        let currentNode = null;
        let returnNode = null;
        /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
        if (IS_EMPTY_INPUT) dirty = '<!-->';
        /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
            dirty = $26d094221a813868$var$stringifyValue(dirty);
            if (typeof dirty !== 'string') throw $26d094221a813868$var$typeErrorCreate('dirty is not a string, aborting');
        }
        /* Return dirty HTML if DOMPurify cannot run */ if (!DOMPurify.isSupported) return dirty;
        /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
        /* Clean up removed elements */ DOMPurify.removed = [];
        /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
        if (IN_PLACE) {
            /* Do some early pre-sanitization to avoid unsafe root nodes */ const nn = dirty.nodeName;
            if (typeof nn === 'string') {
                const tagName = transformCaseFunc(nn);
                if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw $26d094221a813868$var$typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
            }
        } else if (dirty instanceof Node) {
            /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */ body = _initDocument('<!---->');
            importedNode = body.ownerDocument.importNode(dirty, true);
            if (importedNode.nodeType === $26d094221a813868$var$NODE_TYPE.element && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
            else if (importedNode.nodeName === 'HTML') body = importedNode;
            else // eslint-disable-next-line unicorn/prefer-dom-node-append
            body.appendChild(importedNode);
        } else {
            /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
            dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /* Initialize the document to work on */ body = _initDocument(dirty);
            /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
        }
        /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
        /* Get node iterator */ const nodeIterator = _createNodeIterator(IN_PLACE ? dirty : body);
        /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
            /* Sanitize tags and elements */ _sanitizeElements(currentNode);
            /* Check attributes next */ _sanitizeAttributes(currentNode);
            /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM2(currentNode.content);
        }
        /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
        /* Return sanitized string or DOM */ if (RETURN_DOM) {
            if (SAFE_FOR_TEMPLATES) {
                body.normalize();
                let html = body.innerHTML;
                $26d094221a813868$var$arrayForEach([
                    MUSTACHE_EXPR,
                    ERB_EXPR,
                    TMPLIT_EXPR
                ], (expr)=>{
                    html = $26d094221a813868$var$stringReplace(html, expr, ' ');
                });
                body.innerHTML = html;
            }
            if (RETURN_DOM_FRAGMENT) {
                returnNode = createDocumentFragment.call(body.ownerDocument);
                while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                returnNode.appendChild(body.firstChild);
            } else returnNode = body;
            if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */ returnNode = importNode.call(originalDocument, returnNode, true);
            return returnNode;
        }
        let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
        /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && $26d094221a813868$var$regExpTest($26d094221a813868$var$DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
        /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) $26d094221a813868$var$arrayForEach([
            MUSTACHE_EXPR,
            ERB_EXPR,
            TMPLIT_EXPR
        ], (expr)=>{
            serializedHTML = $26d094221a813868$var$stringReplace(serializedHTML, expr, ' ');
        });
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };
    DOMPurify.setConfig = function() {
        let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _parseConfig(cfg);
        SET_CONFIG = true;
    };
    DOMPurify.clearConfig = function() {
        CONFIG = null;
        SET_CONFIG = false;
    };
    DOMPurify.isValidAttribute = function(tag, attr, value) {
        /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
        const lcTag = transformCaseFunc(tag);
        const lcName = transformCaseFunc(attr);
        return _isValidAttribute(lcTag, lcName, value);
    };
    DOMPurify.addHook = function(entryPoint, hookFunction) {
        if (typeof hookFunction !== 'function') return;
        $26d094221a813868$var$arrayPush(hooks[entryPoint], hookFunction);
    };
    DOMPurify.removeHook = function(entryPoint, hookFunction) {
        if (hookFunction !== undefined) {
            const index = $26d094221a813868$var$arrayLastIndexOf(hooks[entryPoint], hookFunction);
            return index === -1 ? undefined : $26d094221a813868$var$arraySplice(hooks[entryPoint], index, 1)[0];
        }
        return $26d094221a813868$var$arrayPop(hooks[entryPoint]);
    };
    DOMPurify.removeHooks = function(entryPoint) {
        hooks[entryPoint] = [];
    };
    DOMPurify.removeAllHooks = function() {
        hooks = $26d094221a813868$var$_createHooksMap();
    };
    return DOMPurify;
}
var $26d094221a813868$var$purify = $26d094221a813868$var$createDOMPurify();
module.exports = $26d094221a813868$var$purify;

});


parcelRegister("cnft1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37ca97229df724c6f3bb2fd1042c4b60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9023a172781d0e9c$var$_react = $9023a172781d0e9c$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $9023a172781d0e9c$var$_baseNew = $9023a172781d0e9c$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $9023a172781d0e9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Shortcut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shortcuts in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9023a172781d0e9c$var$ShortcutIcon = (props)=>/*#__PURE__*/ $9023a172781d0e9c$var$_react.default.createElement($9023a172781d0e9c$var$_baseNew.default, Object.assign({
        name: "ShortcutIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.25 2.25V0h1.5v2.25H16v1.5h-2.25V6h-1.5V3.75H10v-1.5zM3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8.5H15V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4.5v1.5z" clip-rule="evenodd"/>`
    }, props));
$9023a172781d0e9c$var$ShortcutIcon.displayName = 'ShortcutIcon';
var $9023a172781d0e9c$var$_default = module.exports.default = $9023a172781d0e9c$var$ShortcutIcon;

});

parcelRegister("gWRbJ", function(module, exports) {
$parcel$export(module.exports, "typeMap", () => $e5289abac5641589$export$ca0f3793b4450a5d);
$parcel$export(module.exports, "isExternalResource", () => $e5289abac5641589$export$fe3f86d8e6082cf);
$parcel$export(module.exports, "isThirdPartyArticle", () => $e5289abac5641589$export$97275da1bf1c8425);
$parcel$export(module.exports, "urlRefsAndTarget", () => $e5289abac5641589$export$a54b3eec1418fa47);

var $6bGmX = parcelRequire("6bGmX");

var $3wR8f = parcelRequire("3wR8f");
const $e5289abac5641589$export$ca0f3793b4450a5d = {
    REQUEST_FORM: 'REQUEST_FORM',
    ARTICLE: 'ARTICLE',
    EXTERNAL_RESOURCE: 'ati:cloud:jira-servicedesk:external-resource'
};
const $e5289abac5641589$export$fe3f86d8e6082cf = (entityKey)=>{
    return entityKey === $e5289abac5641589$export$ca0f3793b4450a5d.EXTERNAL_RESOURCE;
};
const $e5289abac5641589$export$97275da1bf1c8425 = (sourceType)=>{
    return (0, $6bGmX.default).checkGate('3p-integration-enabled_t5ysh') && !!sourceType && [
        'GOOGLE_DRIVE',
        'SHAREPOINT',
        'EXTERNAL_RESOURCES'
    ].includes(sourceType);
};
const $e5289abac5641589$var$getUrlForRouter = (displayLink)=>{
    return displayLink.startsWith('/') ? displayLink.replace((0, $3wR8f.getRelativeBasePath)(), '') : displayLink.replace(`${location.origin}${(0, $3wR8f.getRelativeBasePath)()}`, '');
};
const $e5289abac5641589$export$a54b3eec1418fa47 = ({ displayLink: displayLink, isAnExternalResource: isAnExternalResource })=>isAnExternalResource ? {
        href: displayLink,
        target: '_blank'
    } : {
        to: $e5289abac5641589$var$getUrlForRouter(displayLink),
        target: '_self'
    };

});

parcelRegister("5yLlW", function(module, exports) {
$parcel$export(module.exports, "ArticleMetadata", () => (parcelRequire("4ITkB")).default);

var $4ITkB = parcelRequire("4ITkB");

});
parcelRegister("4ITkB", function(module, exports) {
$parcel$export(module.exports, "default", () => $364ea3fb2964cf6f$export$2e2bcd8739ae039);

var $inY1r = parcelRequire("inY1r");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("cNbxb");
var $jXaYG = parcelRequire("jXaYG");

var $7TPEx = parcelRequire("7TPEx");

var $9m9G8 = parcelRequire("9m9G8");
const $364ea3fb2964cf6f$export$9f18a4080cf334b5 = ({ isLoggedIn: isLoggedIn, result: result })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $inY1r.default), result);
    const { id: id, displayLink: displayLink, isExternal: isExternal, containerDisplayName: containerDisplayName } = data;
    const { data: { source: source } } = (0, $jXaYG.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const confluencePageText = containerDisplayName ? formatMessage((0, $9m9G8.default).confluencePage, {
        value: containerDisplayName
    }) : '';
    const showSeparator = source && containerDisplayName;
    const externalResourceText = `${source ? source : ''} ${showSeparator ? `\u{2022}` : ''} ${containerDisplayName ? containerDisplayName : ''}`;
    const metaData = !isExternal ? confluencePageText : externalResourceText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        key: id
    }, metaData);
};
const $364ea3fb2964cf6f$var$ConnectedArticleMetadata = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $2hx7o.isLoggedIn)(state)
    };
})($364ea3fb2964cf6f$export$9f18a4080cf334b5);
var $364ea3fb2964cf6f$export$2e2bcd8739ae039 = $364ea3fb2964cf6f$var$ConnectedArticleMetadata;

});
parcelRegister("inY1r", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a52b1a3f3b801df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ca8023de15e2e3a6631bc532bdc2a159>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $8a52b1a3f3b801df$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleMetadataFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "containerDisplayName"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$8a52b1a3f3b801df$var$node.hash = "243125c226275a9fa5bff8db86192050";
var $8a52b1a3f3b801df$export$2e2bcd8739ae039 = $8a52b1a3f3b801df$var$node;

});

parcelRegister("cNbxb", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => (parcelRequire("jXaYG")).useExternalLink);

var $jXaYG = parcelRequire("jXaYG");

});
parcelRegister("jXaYG", function(module, exports) {
$parcel$export(module.exports, "useExternalLink", () => $a56ef120d482b12f$export$408a40e8acea91be);

var $4fqPo = parcelRequire("4fqPo");

var $f5tC5 = parcelRequire("f5tC5");

var $25gvn = parcelRequire("25gvn");

var $85R51 = parcelRequire("85R51");
const $a56ef120d482b12f$export$2c4a28c399ed5beb = (urls)=>{
    return (0, $25gvn.fetchObjectsFromUrls)(urls).toPromise().then((response)=>{
        return urls.reduce((ref, url, index)=>({
                ...ref,
                [url]: response[index]
            }), {});
    });
};
const $a56ef120d482b12f$var$batchedFetchIcon = (0, $85R51.default)($a56ef120d482b12f$export$2c4a28c399ed5beb, 0);
const $a56ef120d482b12f$export$7666a60147fbe378 = {};
const $a56ef120d482b12f$var$addExternalLinkToCache = (key, value)=>{
    $a56ef120d482b12f$export$7666a60147fbe378[key] = value;
};
function $a56ef120d482b12f$export$408a40e8acea91be({ isLoggedIn: isLoggedIn, link: url }) {
    const initialState = (0, $4fqPo.useMemo)(()=>({
            name: null,
            iconUrl: null,
            source: null
        }), []);
    const [data, setData] = (0, $4fqPo.useState)(initialState);
    const [isLoading, setIsLoading] = (0, $4fqPo.useState)(true);
    const markDataLoaded = (key, value)=>{
        setIsLoading(false);
        setData(value);
        $a56ef120d482b12f$var$addExternalLinkToCache(key, value);
    };
    (0, $4fqPo.useEffect)(()=>{
        let href = url;
        if (!isLoggedIn) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Try to parse the url and extract out the href
     * if it fails return null as the icon url
     */ try {
            href = new URL(url).href;
        } catch (error) {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * Origin is null for other supported url forms like `tel:` and `mail:`
     * return null so that ui can fallback to default icons
     */ if (new URL(url).origin === 'null') {
            markDataLoaded(url, initialState);
            return;
        }
        /**
     * check is there is already entry in cache
     * if yes, return the icon url
     * else, make a call to object resolver service
     */ if (Object.keys($a56ef120d482b12f$export$7666a60147fbe378).includes(href)) {
            setData($a56ef120d482b12f$export$7666a60147fbe378[href]);
            setIsLoading(false);
        } else $a56ef120d482b12f$var$batchedFetchIcon(href).then((response)=>{
            var _response$href, _response$href2, _response$href3;
            const source = (_response$href = response[href]) === null || _response$href === void 0 || (_response$href = _response$href.body.data) === null || _response$href === void 0 || (_response$href = _response$href.generator) === null || _response$href === void 0 ? void 0 : _response$href.name;
            /**
         * ORS returns old Confluence icon
         * Until the icon is updated in ORS we should use the new icon from assets
         */ const iconUrl = source === 'Confluence' ? (0, (/*@__PURE__*/$parcel$interopDefault($f5tC5))) : (_response$href2 = response[href]) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.body) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.data) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.generator) === null || _response$href2 === void 0 || (_response$href2 = _response$href2.icon) === null || _response$href2 === void 0 ? void 0 : _response$href2.url;
            markDataLoaded(href, {
                iconUrl: iconUrl,
                source: source,
                name: (_response$href3 = response[href]) === null || _response$href3 === void 0 || (_response$href3 = _response$href3.body.data) === null || _response$href3 === void 0 ? void 0 : _response$href3.name
            });
        }).catch(()=>{
            return null;
        }).finally(()=>{
            setIsLoading(false);
        });
    }, [
        initialState,
        isLoggedIn,
        url
    ]);
    return {
        data: data,
        isLoading: isLoading
    };
}

});
parcelRegister("f5tC5", function(module, exports) {
module.exports = new URL("../images/confluence-icon.3f9a0ccd.svg", import.meta.url).toString();

});

parcelRegister("25gvn", function(module, exports) {
$parcel$export(module.exports, "fetchObjectsFromUrls", () => $6b02ab01c8c6776f$export$bf4b9b9bdb5d08c9);

var $5geAe = parcelRequire("5geAe");

var $lVFX8 = parcelRequire("lVFX8");
const $6b02ab01c8c6776f$export$bf4b9b9bdb5d08c9 = (urls)=>{
    return (0, $lVFX8.post)('/gateway/api/object-resolver/resolve/batch', urls.map((url)=>({
            resourceUrl: url
        })), {
        'Content-Type': 'application/json'
    }).map(({ response: response })=>response).catch((e)=>(0, $5geAe.Observable).throw(e));
};

});



parcelRegister("9m9G8", function(module, exports) {
$parcel$export(module.exports, "default", () => $a937d80f234154dd$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $a937d80f234154dd$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Confluence page metadata text',
        id: 'cv.search.articles.metadata'
    }
});

});



parcelRegister("RJvg9", function(module, exports) {
$parcel$export(module.exports, "default", () => $e938d8cc4ad2e6e8$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $e938d8cc4ad2e6e8$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    showMore: {
        defaultMessage: 'Show more',
        description: 'Text on show more results button',
        id: 'cv.search.articles.show-more'
    },
    showMoreIcon: {
        defaultMessage: 'Show more icon',
        description: 'Text for label on show more results icon',
        id: 'cv.search.articles.show-more-icon'
    },
    shortcutIcon: {
        defaultMessage: 'Shortcut icon',
        description: 'Text for label on shortcut icon',
        id: 'cv.search.articles.shortcut-icon'
    },
    articles: {
        defaultMessage: 'Self-help resources',
        description: 'Text for section resource type in search results',
        id: 'cv.search.articles.articles'
    }
});

});

parcelRegister("aasqW", function(module, exports) {
$parcel$export(module.exports, "ResourceIcon", () => (parcelRequire("6EDho")).default);

var $6EDho = parcelRequire("6EDho");

});
parcelRegister("6EDho", function(module, exports) {
$parcel$export(module.exports, "default", () => $60e85828323877c4$export$2e2bcd8739ae039);

var $kxR7O = parcelRequire("kxR7O");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $j4lpV = parcelRequire("j4lpV");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("cNbxb");
var $jXaYG = parcelRequire("jXaYG");

var $fmxZJ = parcelRequire("fmxZJ");

var $1sKlv = parcelRequire("1sKlv");

var $17RcU = parcelRequire("17RcU");

var $84EvU = parcelRequire("84EvU");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");
const $60e85828323877c4$export$99eb8fbf40c7d2bc = ({ isLoggedIn: isLoggedIn, themeColor: themeColor, result: result })=>{
    const data = (0, $gIeP2.useFragment)((0, $kxR7O.default), result);
    const { entityType: entityType, displayLink: displayLink, iconUrl: iconUrl, isExternal: isExternal } = data;
    const { data: { iconUrl: externalResourceIconUrl }, isLoading: isIconLoading } = (0, $jXaYG.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const isValidResourceIconUrl = !!iconUrl && iconUrl !== '';
    const isValidExternalResourceIconUrl = !!externalResourceIconUrl && externalResourceIconUrl !== '';
    const getDefaultIcon = (0, $4fqPo.useMemo)(()=>{
        switch(entityType){
            case 'ARTICLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                    label: "",
                    testId: "article-icon",
                    spacing: "spacious"
                });
            case 'REQUEST_FORM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1sKlv))), {
                    label: "",
                    testId: "request-form-icon",
                    spacing: "spacious"
                });
            case 'PORTAL':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84EvU))), {
                    label: "",
                    testId: "portal-icon",
                    spacing: "spacious"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fmxZJ))), {
                    label: "",
                    testId: "question-icon",
                    spacing: "spacious"
                });
        }
    }, [
        entityType
    ]);
    const getExternalResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j4lpV.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidExternalResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "img",
            xcss: $60e85828323877c4$var$imgStyles,
            testId: "external-resource-icon",
            src: externalResourceIconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    const getResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j4lpV.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "img",
            xcss: $60e85828323877c4$var$imgStyles,
            testId: "resource-icon",
            src: iconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $60e85828323877c4$var$imgStyles,
        style: {
            color: themeColor
        }
    }, isExternal ? getExternalResourceIcon() : getResourceIcon());
};
const $60e85828323877c4$var$ConnectedResourceIcon = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $2hx7o.isLoggedIn)(state),
        themeColor: (0, $i8gmD.getThemeColor)(state)
    };
})($60e85828323877c4$export$99eb8fbf40c7d2bc);
var $60e85828323877c4$export$2e2bcd8739ae039 = $60e85828323877c4$var$ConnectedResourceIcon;
const $60e85828323877c4$var$imgStyles = (0, $2m8U6.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
});

});
parcelRegister("kxR7O", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f009f2e432cb768$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ce9515f1b70cdd442c16add72c3cfff>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f009f2e432cb768$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "resourceIconFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "entityType"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "iconUrl"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$6f009f2e432cb768$var$node.hash = "61adf56879f78dbab16536f41b38d4cf";
var $6f009f2e432cb768$export$2e2bcd8739ae039 = $6f009f2e432cb768$var$node;

});

parcelRegister("j4lpV", function(module, exports) {
$parcel$export(module.exports, "SkeletonItem", () => $e3ea57153d1cdaa0$export$fbc0ea7debdb77e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
const $e3ea57153d1cdaa0$var$shimmer = /*#__PURE__*/ (0, $el3DQ.keyframes)({
    '0%': {
        backgroundPosition: '-300px 0'
    },
    '100%': {
        backgroundPosition: '1000px 0'
    }
});
const $e3ea57153d1cdaa0$export$fbc0ea7debdb77e = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1p3akxf-0"
})`animation-duration:1.2s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-name:${$e3ea57153d1cdaa0$var$shimmer};animation-timing-function:linear;background-color:${"var(--ds-skeleton, #F4F5F7)"};background-image:linear-gradient( to right,${"var(--ds-skeleton, #F4F5F7)"} 10%,${"var(--ds-skeleton-subtle, #EBECF0)"} 20%,${"var(--ds-skeleton, #F4F5F7)"} 30% );background-repeat:no-repeat;border-radius:${({ isCircle: isCircle })=>isCircle ? '50%' : "var(--ds-radius-small, 4px)"};height:${({ height: height })=>height};width:${({ width: width })=>width};`;

});

parcelRegister("1sKlv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0eaf91608b1fc1f9ea14632557d8241d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $110c5b4f02cd4cc9$var$_react = $110c5b4f02cd4cc9$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $110c5b4f02cd4cc9$var$_baseNew = $110c5b4f02cd4cc9$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $110c5b4f02cd4cc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Dashboard".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for dashboards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $110c5b4f02cd4cc9$var$DashboardIcon = (props)=>/*#__PURE__*/ $110c5b4f02cd4cc9$var$_react.default.createElement($110c5b4f02cd4cc9$var$_baseNew.default, Object.assign({
        name: "DashboardIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.25v-11zm5.75 0v4.75h4.75V3a.5.5 0 0 0-.5-.5zm4.75 6.25H8.75v4.75H13a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$110c5b4f02cd4cc9$var$DashboardIcon.displayName = 'DashboardIcon';
var $110c5b4f02cd4cc9$var$_default = module.exports.default = $110c5b4f02cd4cc9$var$DashboardIcon;

});

parcelRegister("17RcU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a80f298c9d6e0d96eff1b09e3e1e4079>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d1fb7c1c2a94b75$var$_react = $0d1fb7c1c2a94b75$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $0d1fb7c1c2a94b75$var$_baseNew = $0d1fb7c1c2a94b75$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $0d1fb7c1c2a94b75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d1fb7c1c2a94b75$var$PageIcon = (props)=>/*#__PURE__*/ $0d1fb7c1c2a94b75$var$_react.default.createElement($0d1fb7c1c2a94b75$var$_baseNew.default, Object.assign({
        name: "PageIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$0d1fb7c1c2a94b75$var$PageIcon.displayName = 'PageIcon';
var $0d1fb7c1c2a94b75$var$_default = module.exports.default = $0d1fb7c1c2a94b75$var$PageIcon;

});

parcelRegister("84EvU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c3928c64a97db38eb981c4055c674e5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e0e1f9db7285444$var$_react = $5e0e1f9db7285444$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $5e0e1f9db7285444$var$_baseNew = $5e0e1f9db7285444$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $5e0e1f9db7285444$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Screen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: assets in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e0e1f9db7285444$var$ScreenIcon = (props)=>/*#__PURE__*/ $5e0e1f9db7285444$var$_react.default.createElement($5e0e1f9db7285444$var$_baseNew.default, Object.assign({
        name: "ScreenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H8.75v1.5H12V15H4v-1.5h3.25V12H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$5e0e1f9db7285444$var$ScreenIcon.displayName = 'ScreenIcon';
var $5e0e1f9db7285444$var$_default = module.exports.default = $5e0e1f9db7285444$var$ScreenIcon;

});







parcelRegister("hjWQl", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => (parcelRequire("fMLwD")).ArticleResultsLoader);
$parcel$export(module.exports, "SidePanelResultsLoader", () => (parcelRequire("fMLwD")).SidePanelResultsLoader);
$parcel$export(module.exports, "NewSearchResultsLoader", () => (parcelRequire("fMLwD")).NewSearchResultsLoader);

var $fMLwD = parcelRequire("fMLwD");

});
parcelRegister("fMLwD", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => $783a84523c8b1105$export$777dd415ac1ad4be);
$parcel$export(module.exports, "SidePanelResultsLoader", () => $783a84523c8b1105$export$9575789db02c1cec);
$parcel$export(module.exports, "NewSearchResultsLoader", () => $783a84523c8b1105$export$eccdfdc6bb2f83ed);

var $4fqPo = parcelRequire("4fqPo");

var $fVQGu = parcelRequire("fVQGu");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $dEWOM = parcelRequire("dEWOM");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");
parcelRequire("2TV9p");
var $jEoO3 = parcelRequire("jEoO3");
const $783a84523c8b1105$export$777dd415ac1ad4be = ()=>{
    const articleItemLoader = (0, $4fqPo.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $783a84523c8b1105$var$headingAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const resourceIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $783a84523c8b1105$var$iconAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $783a84523c8b1105$var$loadingIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 24,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const metadataContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: [
                    $783a84523c8b1105$var$subheadingLeftAreaStyles,
                    $783a84523c8b1105$var$subheadingStyles
                ],
                testId: "article-metadata-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $783a84523c8b1105$var$metadataLoadingStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const shortcutIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: [
                    $783a84523c8b1105$var$headerRightAreaStylesVisible
                ],
                testId: "shortcut-icon-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const descriptionContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $783a84523c8b1105$var$bodyAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            role: "listitem",
            xcss: $783a84523c8b1105$var$containerStyles,
            testId: "article-item-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body'
            ],
            templateColumns: "auto 1fr auto"
        }, resourceIconContainer(), linkContainer(), metadataContainer(), shortcutIconContainer(), descriptionContainer())));
    }, []);
    const articlesListLoader = (0, $4fqPo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$containerStyles,
            testId: "articles-list-loader"
        }, articleItemLoader, articleItemLoader, articleItemLoader, articleItemLoader);
    }, [
        articleItemLoader
    ]);
    const sectionHeadingLoader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, sectionHeadingLoader(), articlesListLoader, articlesListLoader);
};
const $783a84523c8b1105$export$9575789db02c1cec = ()=>{
    const resourceIconContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$sidePanelIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 24,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    const descriptionContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))));
    };
    const sidePaneItemLoader = (0, $4fqPo.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $783a84523c8b1105$var$sidePaneLinkContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
                xcss: $783a84523c8b1105$var$sidePaneLinkStyles,
                space: "space.100"
            }, resourceIconContainer(), descriptionContainer()));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$sidePanelItemStyles
        }, linkContainer());
    }, []);
    const sidePanelLoader = (0, $4fqPo.useMemo)(()=>{
        const resultTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$sidePanelStyles
        }, resultTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.ResultList), null, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader));
    }, [
        sidePaneItemLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "side-panel-results-loader",
        xcss: $783a84523c8b1105$var$sidePanelContainerStyles
    }, sidePanelLoader);
};
const $783a84523c8b1105$export$eccdfdc6bb2f83ed = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $783a84523c8b1105$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($783a84523c8b1105$export$777dd415ac1ad4be, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($783a84523c8b1105$export$9575789db02c1cec, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($783a84523c8b1105$export$9575789db02c1cec, null)));
};
const $783a84523c8b1105$export$628e0e0af087a588 = ({ numberOfSections: numberOfSections })=>{
    const resultTitle = (0, $4fqPo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.ResultTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })), []);
    const linkContainer = (0, $4fqPo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.LinkContainer), {
            actionSubjectId: "loading-link-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $783a84523c8b1105$var$searchResultLinkStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 65,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    }, []);
    // Generate sections based on numberOfSections
    const sections = (0, $4fqPo.useMemo)(()=>{
        const sectionsArray = [];
        for(let i = 0; i < numberOfSections; i++)sectionsArray.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, resultTitle, linkContainer, linkContainer));
        return sectionsArray;
    }, [
        linkContainer,
        numberOfSections,
        resultTitle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "search-results-loader"
    }, sections);
};
const $783a84523c8b1105$var$containerStyles = (0, $2m8U6.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $783a84523c8b1105$var$iconAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $783a84523c8b1105$var$headingAreaStyles = (0, $2m8U6.xcss)({
    width: '200px',
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $783a84523c8b1105$var$subheadingStyles = (0, $2m8U6.xcss)({
    width: '350px',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $783a84523c8b1105$var$subheadingLeftAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $783a84523c8b1105$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $783a84523c8b1105$var$responsiveStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        width: '100%'
    },
    [(0, $3jKXW.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});
const $783a84523c8b1105$var$bodyAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $783a84523c8b1105$var$loadingIconStyles = (0, $2m8U6.xcss)({
    width: '100%'
});
const $783a84523c8b1105$var$metadataLoadingStyles = (0, $2m8U6.xcss)({
    width: '100%'
});
const $783a84523c8b1105$var$sidePanelIconStyles = (0, $2m8U6.xcss)({
    width: 'size.200'
});
const $783a84523c8b1105$var$sidePanelDescriptionStyles = (0, $2m8U6.xcss)({
    width: '100%'
});
const $783a84523c8b1105$var$sidePaneLinkContainerStyles = (0, $2m8U6.xcss)({
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $783a84523c8b1105$var$sidePaneLinkStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $783a84523c8b1105$var$sidePanelItemStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $783a84523c8b1105$var$sidePanelContainerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    minWidth: '320px',
    width: '100%',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100'
});
const $783a84523c8b1105$var$sidePanelStyles = (0, $2m8U6.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
const $783a84523c8b1105$var$searchResultLinkStyles = (0, $2m8U6.xcss)({
    width: '100%',
    overflow: 'hidden',
    pointerEvents: 'none'
});

});


parcelRegister("5OmPt", function(module, exports) {
$parcel$export(module.exports, "Portals", () => (parcelRequire("93QYW")).default);

var $93QYW = parcelRequire("93QYW");

});
parcelRegister("93QYW", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4dee90d6baa518e$export$2e2bcd8739ae039);

var $7haPm = parcelRequire("7haPm");

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $2m8U6 = parcelRequire("2m8U6");

var $3krHC = parcelRequire("3krHC");
parcelRequire("2TV9p");
var $iD7Jo = parcelRequire("iD7Jo");
var $jEoO3 = parcelRequire("jEoO3");
var $4azHH = parcelRequire("4azHH");

var $2UiQO = parcelRequire("2UiQO");
parcelRequire("alAKG");
var $jS1Oi = parcelRequire("jS1Oi");

var $2frbN = parcelRequire("2frbN");
const $d4dee90d6baa518e$export$7083bd6220bb1bc7 = ({ result: result, term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $7haPm.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const slicedPortals = data.portals.slice(0, (0, $iD7Jo.INITIAL_PORTALS_COUNT));
    const showSection = slicedPortals.length > 0;
    (0, $4fqPo.useEffect)(()=>{
        let externalResourcesCount = 0;
        let firstPartySearchPlatformResourcesCount = 0;
        let hasError = false;
        let errorMessage;
        slicedPortals.forEach((resource)=>{
            if (resource) {
                const { __typename: __typename, isExternal: isExternal, searchBackend: searchBackend, message: message } = resource;
                if (__typename === 'HelpObjectStoreSearchResult') {
                    if (isExternal) externalResourcesCount += 1;
                    if (searchBackend === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
                    if (message && !errorMessage) {
                        hasError = true;
                        errorMessage = message;
                    }
                }
            }
        });
        if (showSection && hasError) (0, $4azHH.sendSearchOperationalAnalyticEvents)({
            hasError: hasError,
            errorMessage: errorMessage,
            action: 'portalSearchFailed'
        }, createAnalyticsEvent, portalId);
        if (showSection && !hasError) {
            (0, $4azHH.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'portal',
                resourceCount: slicedPortals.length
            }, createAnalyticsEvent, portalId);
            (0, $4azHH.sendSearchOperationalAnalyticEvents)({
                action: 'portalSearchSucceeded'
            }, createAnalyticsEvent, portalId);
        }
    // adding slicedPortals to deps array causes multiple 'rendered' events to be fired
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term,
        showSection,
        slicedPortals.length,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        updateResultsCount(slicedPortals.length, 1);
    }, [
        term,
        slicedPortals.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $d4dee90d6baa518e$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $d4dee90d6baa518e$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xxsmall"
    }, formatMessage((0, $2frbN.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.ResultList), null, slicedPortals.map((resource, index)=>{
        if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === 'HelpObjectStoreSearchResult') {
            const itemOrder = index + 1;
            const key = resource.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jS1Oi.default), {
                itemOrder: itemOrder,
                term: term,
                result: resource
            }));
        }
        return null;
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $2UiQO.searchExperience)
    }));
};
const $d4dee90d6baa518e$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $3jKXW.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $d4dee90d6baa518e$var$headingStyles = (0, $2m8U6.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $d4dee90d6baa518e$export$2e2bcd8739ae039 = (0, $as4kh.default)()($d4dee90d6baa518e$export$7083bd6220bb1bc7);

});
parcelRegister("7haPm", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8ee668e2731ab9c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9a9114b9484bf848ab8857ecfe74b0e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a8ee668e2731ab9c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        },
        {
            "kind": "RootArgument",
            "name": "portalIds"
        },
        {
            "kind": "RootArgument",
            "name": "queryTerm"
        },
        {
            "kind": "RootArgument",
            "name": "resultLimit"
        }
    ],
    "kind": "Fragment",
    "name": "portalsFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "portals",
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "entityType",
                                "value": "PORTAL"
                            },
                            {
                                "kind": "Variable",
                                "name": "helpCenterAri",
                                "variableName": "helpCenterAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "portalIds",
                                "variableName": "portalIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "queryTerm",
                                "variableName": "queryTerm"
                            },
                            {
                                "kind": "Variable",
                                "name": "resultLimit",
                                "variableName": "resultLimit"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "searchInput"
                    }
                ],
                "kind": "LinkedField",
                "name": "searchHelpObjects",
                "plural": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isExternal"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "searchBackend"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "portalItemFragment"
                            }
                        ],
                        "type": "HelpObjectStoreSearchResult"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "HelpObjectStoreQueryError"
                    }
                ]
            },
            "action": "THROW"
        }
    ],
    "type": "HelpObjectStoreQueryApi"
};
$a8ee668e2731ab9c$var$node.hash = "22057e0552bd23b16d7c902fda27442b";
var $a8ee668e2731ab9c$export$2e2bcd8739ae039 = $a8ee668e2731ab9c$var$node;

});

parcelRegister("alAKG", function(module, exports) {
$parcel$export(module.exports, "PortalItem", () => (parcelRequire("jS1Oi")).default);

var $jS1Oi = parcelRequire("jS1Oi");

});
parcelRegister("jS1Oi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccb49eb3f78919b3$export$2e2bcd8739ae039);

var $9LTrY = parcelRequire("9LTrY");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $bG6ob = parcelRequire("bG6ob");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $as4kh = parcelRequire("as4kh");

var $cnft1 = parcelRequire("cnft1");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $gWRbJ = parcelRequire("gWRbJ");

var $RJvg9 = parcelRequire("RJvg9");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("aasqW");
var $6EDho = parcelRequire("6EDho");
const $ccb49eb3f78919b3$export$dd92e87a60cfa662 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $9LTrY.default), result);
    const { title: title, displayLink: displayLink, isExternal: isExternal, id: id, searchBackend: searchBackend, searchAlgorithm: searchAlgorithm } = data;
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $4azHH.useVisibilityState)();
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cnft1))), {
        label: formatMessage((0, $RJvg9.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $4azHH.formatText)(title, term) : '';
    const linkProps = (0, $gWRbJ.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $4azHH.sendSearchUIAnalyticEvents)({
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm,
            action: 'list-item-rendered',
            resourceType: 'portal'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        portalId,
        searchAlgorithm,
        searchBackend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $ccb49eb3f78919b3$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $ccb49eb3f78919b3$var$headingStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6EDho.default), {
        result: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-portal-link' : 'portal-link',
        "data-test-id": "result-link-container",
        attributes: {
            itemOrder: itemOrder,
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedTitle) : (0, $a7SRW.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: isShortcutIconVisible ? $ccb49eb3f78919b3$var$headerRightAreaStylesVisible : $ccb49eb3f78919b3$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $ccb49eb3f78919b3$var$ConnectedPortalItem = (0, $bmgw6.default)((state)=>{
    return {
        themeColor: (0, $i8gmD.getThemeColor)(state)
    };
})($ccb49eb3f78919b3$export$dd92e87a60cfa662);
var $ccb49eb3f78919b3$export$2e2bcd8739ae039 = (0, $as4kh.default)()($ccb49eb3f78919b3$var$ConnectedPortalItem);
const $ccb49eb3f78919b3$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $ccb49eb3f78919b3$var$headingStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $ccb49eb3f78919b3$var$headerRightAreaStylesInVisible = (0, $2m8U6.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $ccb49eb3f78919b3$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("9LTrY", function(module, exports) {
$parcel$export(module.exports, "default", () => $6485f5fb9d4a7365$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b15eb0b63f2842133eb899e6b4f2e58c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6485f5fb9d4a7365$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalItemFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "__typename"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "searchBackend"
        },
        {
            "kind": "ScalarField",
            "name": "searchAlgorithm"
        },
        {
            "kind": "FragmentSpread",
            "name": "resourceIconFragment"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$6485f5fb9d4a7365$var$node.hash = "5c3ae01d5eb661e9c21aaedc4bbe3399";
var $6485f5fb9d4a7365$export$2e2bcd8739ae039 = $6485f5fb9d4a7365$var$node;

});



parcelRegister("2frbN", function(module, exports) {
$parcel$export(module.exports, "default", () => $680aef74c5aa2591$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $680aef74c5aa2591$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals'
    }
});

});



parcelRegister("7Th3C", function(module, exports) {
$parcel$export(module.exports, "RequestForms", () => (parcelRequire("18IY7")).default);

var $18IY7 = parcelRequire("18IY7");

});
parcelRegister("18IY7", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c5774a68559a6ef$export$2e2bcd8739ae039);

var $30e1k = parcelRequire("30e1k");

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $2m8U6 = parcelRequire("2m8U6");

var $3krHC = parcelRequire("3krHC");
parcelRequire("2TV9p");
var $iD7Jo = parcelRequire("iD7Jo");
var $jEoO3 = parcelRequire("jEoO3");
var $4azHH = parcelRequire("4azHH");

var $2UiQO = parcelRequire("2UiQO");
parcelRequire("203Z4");
var $i0ZVz = parcelRequire("i0ZVz");

var $fwcZQ = parcelRequire("fwcZQ");
const $8c5774a68559a6ef$export$d7562fc7136a7ea2 = ({ result: result, term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $30e1k.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const slicedRequestForms = data.requestForms.slice(0, (0, $iD7Jo.INITIAL_REQUEST_FORMS_COUNT));
    const showSection = slicedRequestForms.length > 0;
    (0, $4fqPo.useEffect)(()=>{
        let externalResourcesCount = 0;
        let firstPartySearchPlatformResourcesCount = 0;
        let hasError = false;
        let errorMessage;
        slicedRequestForms.forEach((resource)=>{
            if (resource) {
                const { __typename: __typename, isExternal: isExternal, searchBackend: searchBackend, message: message } = resource;
                if (__typename === 'HelpObjectStoreSearchResult') {
                    if (isExternal) externalResourcesCount += 1;
                    if (searchBackend === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
                    if (message && !errorMessage) {
                        hasError = true;
                        errorMessage = message;
                    }
                }
            }
        });
        if (showSection && hasError) (0, $4azHH.sendSearchOperationalAnalyticEvents)({
            hasError: hasError,
            errorMessage: errorMessage,
            action: 'requestTypeSearchFailed'
        }, createAnalyticsEvent, portalId);
        if (showSection && !hasError) {
            (0, $4azHH.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'request-form',
                resourceCount: slicedRequestForms.length
            }, createAnalyticsEvent, portalId);
            (0, $4azHH.sendSearchOperationalAnalyticEvents)({
                action: 'requestTypeSearchSucceeded'
            }, createAnalyticsEvent, portalId);
        }
    // adding slicedRequestForms to deps array causes multiple 'rendered' events to be fired
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term,
        showSection,
        slicedRequestForms.length,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        updateResultsCount(slicedRequestForms.length, 1);
    }, [
        term,
        slicedRequestForms.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $8c5774a68559a6ef$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $8c5774a68559a6ef$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xxsmall"
    }, formatMessage((0, $fwcZQ.default).requestForms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jEoO3.ResultList), null, slicedRequestForms.map((resource, index)=>{
        if ((resource === null || resource === void 0 ? void 0 : resource.__typename) === 'HelpObjectStoreSearchResult') {
            const itemOrder = index + 1;
            const key = resource.id;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", {
                key: key
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i0ZVz.default), {
                itemOrder: itemOrder,
                term: term,
                result: resource
            }));
        }
        return null;
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $2UiQO.searchExperience)
    }));
};
const $8c5774a68559a6ef$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $3jKXW.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $8c5774a68559a6ef$var$headingStyles = (0, $2m8U6.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $8c5774a68559a6ef$export$2e2bcd8739ae039 = (0, $as4kh.default)()($8c5774a68559a6ef$export$d7562fc7136a7ea2);

});
parcelRegister("30e1k", function(module, exports) {
$parcel$export(module.exports, "default", () => $50fd83b032fbd1a3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<de8e265d872b5048241f5957a857a078>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $50fd83b032fbd1a3$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "helpCenterAri"
        },
        {
            "kind": "RootArgument",
            "name": "portalIds"
        },
        {
            "kind": "RootArgument",
            "name": "queryTerm"
        },
        {
            "kind": "RootArgument",
            "name": "resultLimit"
        }
    ],
    "kind": "Fragment",
    "name": "requestFormsFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "alias": "requestForms",
                "args": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "entityType",
                                "value": "REQUEST_FORM"
                            },
                            {
                                "kind": "Variable",
                                "name": "helpCenterAri",
                                "variableName": "helpCenterAri"
                            },
                            {
                                "kind": "Variable",
                                "name": "portalIds",
                                "variableName": "portalIds"
                            },
                            {
                                "kind": "Variable",
                                "name": "queryTerm",
                                "variableName": "queryTerm"
                            },
                            {
                                "kind": "Variable",
                                "name": "resultLimit",
                                "variableName": "resultLimit"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "searchInput"
                    }
                ],
                "kind": "LinkedField",
                "name": "searchHelpObjects",
                "plural": true,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "isExternal"
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "searchBackend"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "requestFormItemFragment"
                            }
                        ],
                        "type": "HelpObjectStoreSearchResult"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "HelpObjectStoreQueryError"
                    }
                ]
            },
            "action": "THROW"
        }
    ],
    "type": "HelpObjectStoreQueryApi"
};
$50fd83b032fbd1a3$var$node.hash = "d098f3c4d3a7e8cdb062182f5fa8767d";
var $50fd83b032fbd1a3$export$2e2bcd8739ae039 = $50fd83b032fbd1a3$var$node;

});

parcelRegister("203Z4", function(module, exports) {
$parcel$export(module.exports, "RequestFormItem", () => (parcelRequire("i0ZVz")).default);

var $i0ZVz = parcelRequire("i0ZVz");

});
parcelRegister("i0ZVz", function(module, exports) {
$parcel$export(module.exports, "default", () => $86a29dc9f54f638b$export$2e2bcd8739ae039);

var $jmSvo = parcelRequire("jmSvo");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $bG6ob = parcelRequire("bG6ob");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $as4kh = parcelRequire("as4kh");

var $cnft1 = parcelRequire("cnft1");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $gWRbJ = parcelRequire("gWRbJ");

var $RJvg9 = parcelRequire("RJvg9");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("aasqW");
var $6EDho = parcelRequire("6EDho");
const $86a29dc9f54f638b$export$c5555d4e61cdd47a = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $jmSvo.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $4azHH.useVisibilityState)();
    const { title: title, displayLink: displayLink, isExternal: isExternal, id: id, searchBackend: searchBackend, searchAlgorithm: searchAlgorithm } = data;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cnft1))), {
        label: formatMessage((0, $RJvg9.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $4azHH.formatText)(title, term) : '';
    const linkProps = (0, $gWRbJ.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $4azHH.sendSearchUIAnalyticEvents)({
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm,
            action: 'list-item-rendered',
            resourceType: 'request-form'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        portalId,
        searchAlgorithm,
        searchBackend
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $86a29dc9f54f638b$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $86a29dc9f54f638b$var$headingStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6EDho.default), {
        result: data
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-request-form-link' : 'request-form-link',
        "data-test-id": "result-link-container",
        attributes: {
            itemOrder: itemOrder,
            searchBackend: searchBackend,
            searchAlgorithm: searchAlgorithm
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedTitle) : (0, $a7SRW.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: isShortcutIconVisible ? $86a29dc9f54f638b$var$headerRightAreaStylesVisible : $86a29dc9f54f638b$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $86a29dc9f54f638b$var$ConnectedRequestFormItem = (0, $bmgw6.default)((state)=>{
    return {
        themeColor: (0, $i8gmD.getThemeColor)(state)
    };
})($86a29dc9f54f638b$export$c5555d4e61cdd47a);
var $86a29dc9f54f638b$export$2e2bcd8739ae039 = (0, $as4kh.default)()($86a29dc9f54f638b$var$ConnectedRequestFormItem);
const $86a29dc9f54f638b$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $86a29dc9f54f638b$var$headingStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $86a29dc9f54f638b$var$headerRightAreaStylesInVisible = (0, $2m8U6.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $86a29dc9f54f638b$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("jmSvo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b664d208b91ded35$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14bed6ae5208842062ed15ce7f530297>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b664d208b91ded35$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestFormItemFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "__typename"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "displayLink"
            },
            "action": "THROW"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            "action": "THROW"
        },
        {
            "kind": "ScalarField",
            "name": "searchBackend"
        },
        {
            "kind": "ScalarField",
            "name": "searchAlgorithm"
        },
        {
            "kind": "FragmentSpread",
            "name": "resourceIconFragment"
        }
    ],
    "type": "HelpObjectStoreSearchResult"
};
$b664d208b91ded35$var$node.hash = "10cdab9f2a7c89157e22f583e930228c";
var $b664d208b91ded35$export$2e2bcd8739ae039 = $b664d208b91ded35$var$node;

});



parcelRegister("fwcZQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $788842e1b47ef52d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $788842e1b47ef52d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requestForms: {
        defaultMessage: 'Request forms',
        description: 'Text for section resource type in search results',
        id: 'cv.search.request-forms.request-forms'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Text for portal name in description',
        id: 'cv.search.request-forms.portal'
    }
});

});





parcelRegister("jnS9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $8957a8edab60e880$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("7LVOt");
var $db9ld = parcelRequire("db9ld");
parcelRequire("9MU8X");
var $2wESx = parcelRequire("2wESx");

var $fOeuW = parcelRequire("fOeuW");
const $8957a8edab60e880$var$selector = (0, $3yyCx.createSelector)((0, $2wESx.getAllVisiblePortals), (0, $2wESx.getfeaturedAndSortedPortalsError), (portals, featuredAndSortedPortalsError)=>({
        featuredAndSortedPortalsError: featuredAndSortedPortalsError,
        portals: portals
    }));
var $8957a8edab60e880$export$2e2bcd8739ae039 = (0, $bmgw6.default)($8957a8edab60e880$var$selector, {
    fetchPortals: (0, $db9ld.fetchFeaturedAndSortedPortalsModel)
})((0, $fOeuW.default));

});
parcelRegister("fOeuW", function(module, exports) {
$parcel$export(module.exports, "default", () => $01ab0fca0b4a8056$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
parcelRequire("8pZem");
var $ktOA2 = parcelRequire("ktOA2");

var $AVzaV = parcelRequire("AVzaV");
const $01ab0fca0b4a8056$var$ServiceDeskFilter = ({ portals: portals, portalIds: portalIds, fetchPortals: fetchPortals, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [values, _] = $4fqPo.useState(portalIds ?? []);
    $4fqPo.useEffect(()=>{
        fetchPortals({
            exploreAll: true,
            sortBy: 'POPULARITY'
        }, false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const options = $4fqPo.useMemo(()=>{
        return portals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals
    ]);
    const preSelectedOptions = $4fqPo.useMemo(()=>{
        const preselectedPortals = portals.filter((portal)=>values.find((id)=>id === portal.id.toString()));
        return preselectedPortals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals,
        values
    ]);
    return portals.length > 1 ? /*#__PURE__*/ $4fqPo.createElement((0, $ktOA2.default), {
        fieldId: "servicedesk_filter",
        fieldLabel: formatMessage((0, $AVzaV.default).portal),
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange,
        testId: "serviceDeskFilter"
    }) : null;
};
var $01ab0fca0b4a8056$export$2e2bcd8739ae039 = $01ab0fca0b4a8056$var$ServiceDeskFilter;

});
parcelRegister("AVzaV", function(module, exports) {
$parcel$export(module.exports, "default", () => $8180cc0b4749b934$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $8180cc0b4749b934$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    serviceDeskFilter: {
        defaultMessage: 'Service desk',
        description: 'Title of the service desk picker',
        id: 'sd.all.articles.result.servicedesk.filter.name'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Title of the portal picker',
        id: 'cv.search.servicedesk-filter.portal'
    }
});

});





parcelRegister("djmoH", function(module, exports) {
$parcel$export(module.exports, "SearchTextboxV2", () => (parcelRequire("8kRBt")).default);

var $8kRBt = parcelRequire("8kRBt");

});
parcelRegister("8kRBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f52e82225cab64b$export$2e2bcd8739ae039);
/* search-textbox-v2.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $aU87f = parcelRequire("aU87f");

var $63sfu = parcelRequire("63sfu");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("20isg");
var $f1dyB = parcelRequire("f1dyB");

var $ht6lp = parcelRequire("ht6lp");

var $jxKS8 = parcelRequire("jxKS8");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("fTxr1");
var $8mlxZ = parcelRequire("8mlxZ");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $8B6Ry = parcelRequire("8B6Ry");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");

var $azPf3 = parcelRequire("azPf3");

var $54jwS = parcelRequire("54jwS");

var $8s01i = parcelRequire("8s01i");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");

var $4wycM = parcelRequire("4wycM");

var $aIcRy = parcelRequire("aIcRy");

var $fj0mX = parcelRequire("fj0mX");

var $leTE5 = parcelRequire("leTE5");

var $4hXST = parcelRequire("4hXST");

var $cotym = parcelRequire("cotym");

var $85azw = parcelRequire("85azw");

var $9Q0Ul = parcelRequire("9Q0Ul");

var $9RoiU = parcelRequire("9RoiU");

var $lMF78 = parcelRequire("lMF78");

var $j0nbS = parcelRequire("j0nbS");

var $lFeJw = parcelRequire("lFeJw");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("5Sfyk");
var $2bRRM = parcelRequire("2bRRM");

var $a2JhN = parcelRequire("a2JhN");

var $j5lyj = parcelRequire("j5lyj");
const $2f52e82225cab64b$var$usePopularPortalsWithVA = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const [popularPortalsWithVA, setPopularPortalsWithVA] = (0, $4fqPo.useState)([]);
    const [isFetching, setIsFetching] = (0, $4fqPo.useState)(false);
    const cloudId = (0, $4fqPo.useMemo)(()=>(0, $6mmHn.getCloudId)(), []);
    const fetchData = (0, $4fqPo.useCallback)(async ()=>{
        setIsFetching(true);
        try {
            const { mostPopularVAsPortalData: mostPopularVAsPortalData } = await (0, $hZWMk.fetchJson)(`/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/virtualagent/mostPopularVAs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    helpCenterId: (0, $6mmHn.getHelpCenterAri)()
                })
            });
            setPopularPortalsWithVA(mostPopularVAsPortalData);
        } catch (error) {
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.UI_EVENT_TYPE),
                action: 'failed',
                actionSubjectId: 'fetchPopularPortalsWithVA'
            }).fire();
        } finally{
            setIsFetching(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        setIsFetching,
        setPopularPortalsWithVA
    ]);
    return {
        isFetching: isFetching,
        popularPortalsWithVA: popularPortalsWithVA,
        fetchData: fetchData
    };
};
const $2f52e82225cab64b$var$SearchPopupContentWithRef = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function SearchPopupContent(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, ...triggerProps } = searchPopupContentProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        ...triggerProps,
        ref: ref,
        xcss: $2f52e82225cab64b$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $azPf3.default), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $2f52e82225cab64b$var$searchBoxStyles,
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2f52e82225cab64b$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2f52e82225cab64b$var$Input, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $j5lyj.default).inputAriaLabel) : formatMessage((0, $j5lyj.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $j5lyj.default).inputPlaceholder) : formatMessage((0, $j5lyj.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        // eslint-disable-next-line @atlassian/a11y/aria-props -- ATLAS-88210
        "aria-description": formatMessage((0, $j5lyj.default).ariaDescription)
    }), (0, $4azHH.isValidSearchTerm)(inputValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isVirtualAgentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $2f52e82225cab64b$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        space: "space.100",
        alignBlock: "center"
    }, formatMessage((0, $j5lyj.default).askTheVirtualServiceAgent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aU87f))),
        alt: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, (isFetchingResults || visibleResultsCount !== 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $2f52e82225cab64b$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        space: "space.100",
        alignBlock: "center"
    }, formatMessage((0, $j5lyj.default).search), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aU87f))),
        alt: ""
    }))))))));
});
const $2f52e82225cab64b$var$SearchTextboxV2 = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $4fqPo.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $4fqPo.useState)(false);
    const [inputValue, setInputValue] = (0, $4fqPo.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $4fqPo.useState)();
    const [{ location: location }, { push: push }] = (0, $hfD9S.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $ht6lp.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $f1dyB.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $2bRRM.useInlineResultsContext)();
    const environment = (0, $gIeP2.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $2f52e82225cab64b$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $lMF78.useSubscriptionAction)();
    (0, $4fqPo.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $leTE5.useCreateConversationWithMessage)();
    const openChoicesIfPresent = (0, $4fqPo.useCallback)(()=>{
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $4azHH.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled
    ]);
    const handleInputChange = (0, $4fqPo.useCallback)((event)=>{
        const newQuery = event.target.value;
        setInputValue(newQuery);
        setIsChoiceOpen((0, $4azHH.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen
    ]);
    const onSeeSearchResults = (0, $4fqPo.useCallback)(()=>{
        if (!(0, $4azHH.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $4fqPo.useCallback)(async ()=>{
        if (!(0, $4azHH.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $bG6ob.isOmnichannelEnabledForHC)()) {
            if ((0, $bG6ob.isOmnichannelCombinedAPIEnabledForHC)()) {
                const subscriptionId = await (0, $9RoiU.generateUniqueSubscriptionID)({
                    environment: environment
                });
                const omniChannelMetaData = await (0, $cotym.fetchOmnichannelMeta)(environment);
                await (0, $4hXST.updateOmniChannelConversationMetaPromise)({
                    environment: environment,
                    subscriptionId: subscriptionId,
                    draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                    isConversationClosed: false,
                    isConversationExpired: false,
                    disableInput: false,
                    isReplyPending: false,
                    subscriptionTriggered: true,
                    subscriptionStatus: 'TRIGGERED'
                });
                const disposable = (0, $85azw.establishSubscriptionToOmnichannel)({
                    environment: environment,
                    subscriptionId: subscriptionId
                });
                setSubscriptionDisposer(disposable);
                if (omniChannelMetaData.connectionId) createConversationWithMessage({
                    subscriptionId: subscriptionId,
                    workspaceAri: (0, $6mmHn.getWorkspaceAri)(),
                    conversationContextAri: (0, $6mmHn.getHelpCenterAri)(),
                    isTestConversation: false,
                    message: inputValue.trim(),
                    connectionId: omniChannelMetaData.connectionId
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $fj0mX.initialIntentMessageHCExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $9Q0Ul.omnichannelPageLoadExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $fj0mX.initialAIMessageHCExperience).start();
            } else await (0, $4hXST.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                draftMessage: inputValue.trim()
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aIcRy.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $lFeJw.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $63sfu.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $63sfu.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $63sfu.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $4fqPo.useCallback)((event)=>{
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if (event.key === 'Enter') {
            if (!!isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $8mlxZ.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults
    ]);
    (0, $4fqPo.useEffect)(()=>{
        setIsChoiceOpen((0, $4azHH.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen
    ]);
    const [requestIdParam] = (0, $eDygx.usePathParam)('requestId');
    (0, $4fqPo.useEffect)(()=>{
        var _searchBarRef$current;
        if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && requestIdParam) return;
        (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 || _searchBarRef$current.focus();
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isVSAOnHCEnabled && (0, $bG6ob.isOmnichannelEnabledForHC)() && (0, $bG6ob.isOmnichannelCombinedAPIEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j0nbS.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a2JhN.SearchPromptPopup), {
        isOpen: isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>setIsChoiceOpen(false),
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2f52e82225cab64b$var$SearchPopupContentWithRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount
            });
        }
    }));
};
$2f52e82225cab64b$var$SearchTextboxV2.displayName = 'SearchTextboxV2';
const $2f52e82225cab64b$var$WrappedComponent = (0, $4wycM.withHelpCenterConversationStateContainer)($2f52e82225cab64b$var$SearchTextboxV2);
const $2f52e82225cab64b$var$SearchTextBoxV2withConversationContainers = (props)=>{
    const contextId = (0, $6mmHn.getHelpCenterAri)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2f52e82225cab64b$var$WrappedComponent, {
        ...props,
        contextId: contextId
    });
};
var $2f52e82225cab64b$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: (0, $748yq.ScreenName).HELP_CENTER_SEARCH
})($2f52e82225cab64b$var$SearchTextBoxV2withConversationContainers);
const $2f52e82225cab64b$var$searchBoxWrapperStyles = (0, $2m8U6.xcss)({
    position: 'relative'
});
const $2f52e82225cab64b$var$searchBoxStyles = (0, $2m8U6.xcss)({
    backgroundColor: 'color.background.input',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border.input',
    borderRadius: 'radius.small',
    ':focus-within': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2f52e82225cab64b$var$Input = /*#__PURE__*/ (0, $el3DQ.default).input.withConfig({
    componentId: "sc-5r9sil-0"
})`${(0, $5Kpwp.SEARCH_INPUT_FONT_SIZE)};${$iSWaE.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};border-radius:${"var(--ds-radius-small, 3px)"};padding:${$bpWyP.multiple(2.125).px}  ${(props)=>props.isAiAnswersEnabled ? '148px' : "var(--ds-space-600, 48px)"} ${$bpWyP.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${(0, $bG6ob.isUseHelpCenterRefresh)() ? `padding-right: ${"var(--ds-space-050, 4px)"};` : ''}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2f52e82225cab64b$var$SearchIconWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt4119w _4t3i1osq _1ltvidpf _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1wpz1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});
const $2f52e82225cab64b$var$askAiHintStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    color: 'color.text.subtle',
    top: 'space.0',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 11
});

});
parcelRegister("aU87f", function(module, exports) {
module.exports = new URL("../images/enter-icon.6e72b8c1.svg", import.meta.url).toString();

});

parcelRegister("20isg", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => (parcelRequire("f1dyB")).useSendMessage);
$parcel$export(module.exports, "useIsGenerating", () => (parcelRequire("7PrtD")).useIsGenerating);
$parcel$export(module.exports, "useIsInputEnabled", () => (parcelRequire("lekQR")).useIsInputEnabled);
$parcel$export(module.exports, "useHasMessages", () => (parcelRequire("hk7Rr")).useHasMessages);
$parcel$export(module.exports, "useStopGenerating", () => (parcelRequire("adtvq")).useStopGenerating);
$parcel$export(module.exports, "useGetMaxChars", () => (parcelRequire("gjuj3")).useGetMaxChars);
$parcel$export(module.exports, "useIsInputShown", () => (parcelRequire("gmcif")).useIsInputShown);
$parcel$export(module.exports, "useClearConversation", () => (parcelRequire("2CvLC")).useClearConversation);
$parcel$export(module.exports, "useHandOffConversation", () => (parcelRequire("7Wx9D")).useHandOffConversation);

var $f1dyB = parcelRequire("f1dyB");

var $7PrtD = parcelRequire("7PrtD");

var $lekQR = parcelRequire("lekQR");

var $hk7Rr = parcelRequire("hk7Rr");

var $adtvq = parcelRequire("adtvq");

var $gjuj3 = parcelRequire("gjuj3");

var $gmcif = parcelRequire("gmcif");

var $2CvLC = parcelRequire("2CvLC");

var $7Wx9D = parcelRequire("7Wx9D");

});
parcelRegister("f1dyB", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $be3d69945380af02$export$fe8707b58c509543);

var $aIcRy = parcelRequire("aIcRy");

var $fPpng = parcelRequire("fPpng");

var $lFeJw = parcelRequire("lFeJw");

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $ht6lp = parcelRequire("ht6lp");
const $be3d69945380af02$export$fe8707b58c509543 = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const { sendMessage: sendVirtualAgentMessage } = (0, $fPpng.useSendMessage)();
    const { addHelpseekerMessage: addAIAnswersMessage } = (0, $ht6lp.useActions)();
    const sendMessage = (message)=>{
        provider === (0, $iaq2G.ConversationProvider).AI_ANSWERS ? addAIAnswersMessage(message) : sendVirtualAgentMessage(message);
        if (provider === (0, $iaq2G.ConversationProvider).AI_ANSWERS) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $lFeJw.AIAnswerExperience).start();
        else // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $aIcRy.intentAnswerExperience).start();
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("aIcRy", function(module, exports) {
$parcel$export(module.exports, "intentAnswerExperience", () => $f72b14c0f6957f20$export$b0aa4ee2c3e0b407);
$parcel$export(module.exports, "initialIntentMessageExperience", () => $f72b14c0f6957f20$export$1bc905fb9e119ab8);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $f72b14c0f6957f20$var$intentAnswerExperienceId = 'service-management.help-center.virtual-agent.intent-message';
const $f72b14c0f6957f20$var$initialIntentMessageExperienceId = 'service-management.help-center.virtual-agent.intent-initial-message-reply';
const $f72b14c0f6957f20$export$b0aa4ee2c3e0b407 = new (0, $3odV5.UFOExperience)($f72b14c0f6957f20$var$intentAnswerExperienceId, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $f72b14c0f6957f20$export$1bc905fb9e119ab8 = new (0, $3odV5.UFOExperience)($f72b14c0f6957f20$var$initialIntentMessageExperienceId, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("fPpng", function(module, exports) {
$parcel$export(module.exports, "useSendMessage", () => $6d4a3bef8ff53162$export$fe8707b58c509543);

var $86Tyk = parcelRequire("86Tyk");

var $8ZLRy = parcelRequire("8ZLRy");

var $2QlRL = parcelRequire("2QlRL");
const $6d4a3bef8ff53162$export$fe8707b58c509543 = ()=>{
    const { addMessage: addMessage, addJiraFieldMessage: addJiraFieldMessage } = (0, $2QlRL.useActions)();
    const jiraField = (0, $2QlRL.useFieldFromLastMessage)();
    const baseUrl = (0, $2QlRL.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $86Tyk.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const sendMessage = (message)=>{
        if (jiraField && (0, $8ZLRy.isTextField)(jiraField.fieldId, requestTypeFields)) addJiraFieldMessage(jiraField.fieldId, message);
        else addMessage(message);
    };
    return {
        sendMessage: sendMessage
    };
};

});
parcelRegister("86Tyk", function(module, exports) {
$parcel$export(module.exports, "useRequestTypeFields", () => $2a54a1b759f3e45a$export$6fa5557c101e4783);

var $4fqPo = parcelRequire("4fqPo");

var $hZWMk = parcelRequire("hZWMk");

var $c6IZC = parcelRequire("c6IZC");
const $2a54a1b759f3e45a$export$6fa5557c101e4783 = ({ baseUrl: baseUrl = '' })=>{
    const { setRequestTypeFieldsMap: setRequestTypeFieldsMap, setIsLoading: setIsLoading, setError: setError } = (0, $c6IZC.useActions)();
    const fieldStore = (0, $c6IZC.useStore)();
    const requestTypeFieldPromise = (0, $c6IZC.useRequestTypeFieldPromise)();
    const getRequestTypeFieldsEndpoint = (0, $4fqPo.useCallback)((projectId, requestTypeId)=>{
        if (!requestTypeId) return '';
        const projectIdentifier = `projectId:${projectId}`;
        return `${baseUrl}/rest/servicedeskapi/servicedesk/${encodeURIComponent(projectIdentifier)}/requesttype/${encodeURIComponent(requestTypeId)}/field`;
    }, [
        baseUrl
    ]);
    const convertedRequestTypeFieldMap = (0, $4fqPo.useCallback)((response)=>{
        return new Map(response === null || response === void 0 ? void 0 : response.requestTypeFields.map((field)=>[
                field.fieldId,
                field
            ]));
    }, []);
    const fetchRequestTypeFields = (0, $4fqPo.useCallback)(async (projectId, requestTypeId)=>{
        try {
            if (!requestTypeId) throw new Error('requestTypeId is undefined');
            const response = await (0, $hZWMk.fetchJson)(getRequestTypeFieldsEndpoint(projectId, requestTypeId), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const convertedMap = convertedRequestTypeFieldMap(response);
            setRequestTypeFieldsMap(convertedMap);
            return convertedMap;
        } catch (err) {
            setError(err);
            return undefined;
        }
    }, [
        getRequestTypeFieldsEndpoint,
        convertedRequestTypeFieldMap,
        setRequestTypeFieldsMap,
        setError
    ]);
    const cacheIsInvalid = (0, $4fqPo.useCallback)((projectId, requestTypeId)=>{
        if (!fieldStore.cacheIds) return true;
        return projectId !== fieldStore.cacheIds.projectId || requestTypeId !== fieldStore.cacheIds.requestTypeId;
    }, [
        fieldStore.cacheIds
    ]);
    const fetchFieldsOrUseCache = (0, $4fqPo.useCallback)(async (projectId, requestTypeId)=>{
        if (cacheIsInvalid(projectId, requestTypeId)) {
            const request = fetchRequestTypeFields(projectId, requestTypeId);
            setIsLoading({
                projectId: projectId,
                requestTypeId: requestTypeId
            }, request);
            return request;
        }
        return requestTypeFieldPromise;
    }, [
        cacheIsInvalid,
        fetchRequestTypeFields,
        requestTypeFieldPromise,
        setIsLoading
    ]);
    return [
        {
            loading: fieldStore.loading,
            data: fieldStore.requestTypeFieldsMap,
            error: fieldStore.error
        },
        {
            fetchRequestTypeFields: fetchFieldsOrUseCache
        }
    ];
};

});
parcelRegister("c6IZC", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $2d61cf476c9dca12$export$6ccbb43953eebf8);
$parcel$export(module.exports, "useActions", () => $2d61cf476c9dca12$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useRequestTypeFieldPromise", () => $2d61cf476c9dca12$export$c9a90d3a86a18942);

var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $f0F2C = parcelRequire("f0F2C");
const $2d61cf476c9dca12$var$initialState = {
    loading: false,
    cacheIds: undefined,
    requestTypeFieldsMap: new Map()
};
const $2d61cf476c9dca12$export$b6b2c03d619b3cc5 = (0, $2RDzF.createStore)({
    initialState: $2d61cf476c9dca12$var$initialState,
    actions: $f0F2C.actions,
    name: 'requestTypeFields'
});
const $2d61cf476c9dca12$export$6ccbb43953eebf8 = (0, $iouul.createStateHook)($2d61cf476c9dca12$export$b6b2c03d619b3cc5);
const $2d61cf476c9dca12$export$bc923229a7fa61e7 = (0, $iouul.createActionsHook)($2d61cf476c9dca12$export$b6b2c03d619b3cc5);
const $2d61cf476c9dca12$export$c9a90d3a86a18942 = (0, $iouul.createStateHook)($2d61cf476c9dca12$export$b6b2c03d619b3cc5, {
    selector: (state)=>state.inFlightRequest ? state.inFlightRequest : state.requestTypeFieldsMap
});

});
parcelRegister("f0F2C", function(module, exports) {
$parcel$export(module.exports, "actions", () => $29aa74980302c96e$export$e324594224ef24da);

var $H2A0Q = parcelRequire("H2A0Q");
const $29aa74980302c96e$var$setRequestTypeFieldsMap = (requestTypeFieldsMap)=>({ setState: setState })=>{
        setState({
            requestTypeFieldsMap: requestTypeFieldsMap,
            error: undefined,
            inFlightRequest: undefined,
            loading: false
        });
    };
const $29aa74980302c96e$var$setIsLoading = (cacheIds, inFlightRequest)=>({ setState: setState })=>{
        setState({
            cacheIds: cacheIds,
            inFlightRequest: inFlightRequest,
            loading: true
        });
    };
const $29aa74980302c96e$var$setError = (e)=>({ setState: setState })=>{
        const error = e instanceof Error ? e : new Error('Unknown error');
        (0, $H2A0Q.sendErrorEvent)({
            error: error,
            actionSubject: 'fetchRequestTypeFields'
        });
        setState({
            error: error,
            loading: false
        });
    };
const $29aa74980302c96e$export$e324594224ef24da = {
    setRequestTypeFieldsMap: $29aa74980302c96e$var$setRequestTypeFieldsMap,
    setIsLoading: $29aa74980302c96e$var$setIsLoading,
    setError: $29aa74980302c96e$var$setError
};

});
parcelRegister("H2A0Q", function(module, exports) {
$parcel$export(module.exports, "sendUIEvent", () => $f06b76aa5b84e5fc$export$1aecf263098db667);
$parcel$export(module.exports, "sendTrackEvent", () => $f06b76aa5b84e5fc$export$1ba525b8a711eaac);
$parcel$export(module.exports, "sendErrorEvent", () => $f06b76aa5b84e5fc$export$c9036e6c0dcd8835);

var $gHT3x = parcelRequire("gHT3x");

var $fJQMR = parcelRequire("fJQMR");
const $f06b76aa5b84e5fc$var$getVASource = ()=>{
    return `virtualAgent${0, $gHT3x.SCREEN}`;
};
const $f06b76aa5b84e5fc$export$1aecf263098db667 = (event)=>{
    const analyticsClient = (0, $fJQMR.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendUIEvent({
        ...event,
        source: $f06b76aa5b84e5fc$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send UI analytics event ${error}`);
    });
};
const $f06b76aa5b84e5fc$export$22a3b1671f38a193 = ({ name: name, attributes: attributes })=>{
    const event = {
        name: name,
        attributes: {
            ...attributes,
            source: $f06b76aa5b84e5fc$var$getVASource()
        }
    };
    const analyticsClient = (0, $fJQMR.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendScreenEvent(event).catch((error)=>{
        throw new Error(`Failure to send screen analytics event ${error}`);
    });
};
const $f06b76aa5b84e5fc$export$1ba525b8a711eaac = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    const analyticsClient = (0, $fJQMR.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendTrackEvent({
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        source: $f06b76aa5b84e5fc$var$getVASource()
    }).catch((error)=>{
        throw new Error(`Failure to send track analytics event ${error}`);
    });
};
const $f06b76aa5b84e5fc$export$e5f89b51c6d4e36b = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $f06b76aa5b84e5fc$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        action: 'success'
    });
};
const $f06b76aa5b84e5fc$export$c9036e6c0dcd8835 = ({ error: error, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    $f06b76aa5b84e5fc$var$sendOperationalOrErrorAnalyticsEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: 'failed',
        attributes: {
            ...attributes,
            error: error
        }
    });
};
const $f06b76aa5b84e5fc$var$sendOperationalOrErrorAnalyticsEvent = ({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, action: action, attributes: attributes })=>{
    const analyticsClient = (0, $fJQMR.getAnalyticsWebClient)().getInstance();
    analyticsClient.sendOperationalEvent({
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes,
        source: $f06b76aa5b84e5fc$var$getVASource()
    }).catch((err)=>{
        throw new Error(`Failure to send operational analytics event ${err}`);
    });
};

});




parcelRegister("8ZLRy", function(module, exports) {
$parcel$export(module.exports, "SHORT_TEXT_FIELD_TYPE", () => $a6adb4759e943c17$export$4351cd1d22652b1a);
$parcel$export(module.exports, "PARAGRAPH_FIELD_TYPE", () => $a6adb4759e943c17$export$a66f2119b5091b7e);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_TYPE", () => $a6adb4759e943c17$export$dbe52b9d883d2625);
$parcel$export(module.exports, "DATE_PICKER_FIELD_TYPE", () => $a6adb4759e943c17$export$4a9ce2f29e91e07);
$parcel$export(module.exports, "getFieldType", () => $a6adb4759e943c17$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isTextField", () => $a6adb4759e943c17$export$1cda748695867c48);
const $a6adb4759e943c17$export$4351cd1d22652b1a = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $a6adb4759e943c17$export$a66f2119b5091b7e = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $a6adb4759e943c17$export$dbe52b9d883d2625 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $a6adb4759e943c17$export$4a9ce2f29e91e07 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $a6adb4759e943c17$export$b9089a6e41ed43aa = (fieldId, data)=>{
    const field = data.get(fieldId);
    if (!field) return undefined;
    if ('custom' in field.jiraSchema) return field.jiraSchema.custom;
    return undefined;
};
const $a6adb4759e943c17$export$1cda748695867c48 = (fieldId, data)=>{
    const fieldType = $a6adb4759e943c17$export$b9089a6e41ed43aa(fieldId, data);
    return fieldType === $a6adb4759e943c17$export$4351cd1d22652b1a || fieldType === $a6adb4759e943c17$export$a66f2119b5091b7e;
};

});

parcelRegister("2QlRL", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $9365d1645ac9bcac$export$4d17e2d9c5348842);
$parcel$export(module.exports, "useIsLoading", () => $9365d1645ac9bcac$export$4dface15d86304a4);
$parcel$export(module.exports, "useError", () => $9365d1645ac9bcac$export$5027865de34f9ec6);
$parcel$export(module.exports, "useBaseUrl", () => $9365d1645ac9bcac$export$d791fbc58bd47703);
$parcel$export(module.exports, "useFieldFromLastMessage", () => $9365d1645ac9bcac$export$c011746629259c11);
$parcel$export(module.exports, "useIsLastMessage", () => $9365d1645ac9bcac$export$cd2e50d12ce4b586);
$parcel$export(module.exports, "useConversationHasMessages", () => $9365d1645ac9bcac$export$400cd0867e25f460);
$parcel$export(module.exports, "useActions", () => $9365d1645ac9bcac$export$bc923229a7fa61e7);

var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $EZuu4 = parcelRequire("EZuu4");

var $cUxXd = parcelRequire("cUxXd");

var $g38d9 = parcelRequire("g38d9");
const $9365d1645ac9bcac$var$initialState = {
    conversationProvider: {
        sendMessage: ()=>Promise.reject(new Error('No conversation provider')),
        startConversation: ()=>Promise.reject(new Error('No conversation provider'))
    },
    messages: []
};
const $9365d1645ac9bcac$var$store = (0, $2RDzF.createStore)({
    actions: $EZuu4.actions,
    initialState: $9365d1645ac9bcac$var$initialState,
    name: 'Conversation',
    containedBy: (0, $cUxXd.ConversationStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            },
        onContainerUpdate: ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
                setState({
                    conversationProvider: conversationProvider,
                    portalId: portalId,
                    projectId: projectId,
                    contextId: contextId,
                    baseUrl: baseUrl,
                    isTestConversation: isTestConversation,
                    handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
                });
            }
    }
});
const $9365d1645ac9bcac$export$4d17e2d9c5348842 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (state)=>state.messages
});
const $9365d1645ac9bcac$export$4dface15d86304a4 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (state)=>state.isLoading
});
const $9365d1645ac9bcac$export$5027865de34f9ec6 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (state)=>state.error
});
const $9365d1645ac9bcac$export$d791fbc58bd47703 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (state)=>state.baseUrl
});
const $9365d1645ac9bcac$export$de966b4845cf82cc = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (0, $g38d9.getAppendicesFromLastMessage)
});
const $9365d1645ac9bcac$export$c011746629259c11 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (0, $g38d9.getJiraFieldFromLastMessage)
});
const $9365d1645ac9bcac$export$314d3fbd2eb8690 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (0, $g38d9.getLastHelpseekerMessage)
});
const $9365d1645ac9bcac$export$cd2e50d12ce4b586 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (0, $g38d9.getIsLastMessage)
});
const $9365d1645ac9bcac$export$400cd0867e25f460 = (0, $iouul.createStateHook)($9365d1645ac9bcac$var$store, {
    selector: (state)=>state.messages.length > 0
});
const $9365d1645ac9bcac$export$bc923229a7fa61e7 = (0, $iouul.createActionsHook)($9365d1645ac9bcac$var$store);

});
parcelRegister("EZuu4", function(module, exports) {
$parcel$export(module.exports, "actions", () => $7c505731187816e6$export$e324594224ef24da);

var $fvcpa = parcelRequire("fvcpa");

var $2024k = parcelRequire("2024k");

var $aqbPX = parcelRequire("aqbPX");

var $3KcGA = parcelRequire("3KcGA");

var $5sGYu = parcelRequire("5sGYu");

var $kZwKK = parcelRequire("kZwKK");
const $7c505731187816e6$export$e324594224ef24da = {
    addMessage: $2024k.addMessage,
    selectOption: $kZwKK.selectOption,
    clearConversation: $aqbPX.clearConversation,
    addJiraFieldMessage: $fvcpa.addJiraFieldMessage,
    retryLastHelpseekerMessage: $5sGYu.retryLastHelpseekerMessage,
    resetState: $3KcGA.resetState
};

});
parcelRegister("fvcpa", function(module, exports) {
$parcel$export(module.exports, "addJiraFieldMessage", () => $423895bc11907c50$export$73f4cb8f39bccbbf);

var $aIcRy = parcelRequire("aIcRy");

var $fJAml = parcelRequire("fJAml");

var $eUZZi = parcelRequire("eUZZi");
const $423895bc11907c50$export$73f4cb8f39bccbbf = (fieldId, value, messageContent)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $fJAml.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            content: messageContent || value,
            jiraField: {
                fieldId: fieldId,
                value: value
            }
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $aIcRy.intentAnswerExperience).start();
        return dispatch((0, $eUZZi.sendHelpseekerMessage)(helpseekerMessage));
    };

});
parcelRegister("fJAml", function(module, exports) {
$parcel$export(module.exports, "constructHelpseekerMessage", () => $9c18340939dcb7e0$export$8ea190576bc1c325);

var $lnthU = parcelRequire("lnthU");

var $8gbjk = parcelRequire("8gbjk");
var $fwXLN = parcelRequire("fwXLN");
const $9c18340939dcb7e0$export$8ea190576bc1c325 = (messageBody)=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId } = getState();
        const helpseekerMessage = {
            message: {
                ...messageBody,
                content: (0, $8gbjk.doc)((0, $fwXLN.paragraph)(messageBody.content))
            },
            id: `client::${(0, $lnthU.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || ''
        };
        // add user message
        setState({
            isLoading: true,
            messages: [
                ...messages,
                helpseekerMessage
            ]
        });
        return helpseekerMessage;
    };

});
parcelRegister("lnthU", function(module, exports) {

var $8FzWE = parcelRequire("8FzWE");

var $4KCVx = parcelRequire("4KCVx");
var $f90276e3fd14fcf5$var$uuid = $4KCVx;
$f90276e3fd14fcf5$var$uuid.v1 = $8FzWE;
$f90276e3fd14fcf5$var$uuid.v4 = $4KCVx;
module.exports = $f90276e3fd14fcf5$var$uuid;

});
parcelRegister("8FzWE", function(module, exports) {

var $4S4Kf = parcelRequire("4S4Kf");

var $2GPBM = parcelRequire("2GPBM");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $64fe08fe94589d64$var$_nodeId;
var $64fe08fe94589d64$var$_clockseq;
// Previous uuid creation time
var $64fe08fe94589d64$var$_lastMSecs = 0;
var $64fe08fe94589d64$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $64fe08fe94589d64$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $64fe08fe94589d64$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $64fe08fe94589d64$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $4S4Kf();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $64fe08fe94589d64$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $64fe08fe94589d64$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $64fe08fe94589d64$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $64fe08fe94589d64$var$_lastMSecs + (nsecs - $64fe08fe94589d64$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $64fe08fe94589d64$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $64fe08fe94589d64$var$_lastMSecs = msecs;
    $64fe08fe94589d64$var$_lastNSecs = nsecs;
    $64fe08fe94589d64$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $2GPBM(b);
}
module.exports = $64fe08fe94589d64$var$v1;

});
parcelRegister("4S4Kf", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $38bfe2ca40fbea46$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($38bfe2ca40fbea46$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $38bfe2ca40fbea46$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $38bfe2ca40fbea46$var$getRandomValues($38bfe2ca40fbea46$var$rnds8);
        return $38bfe2ca40fbea46$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $38bfe2ca40fbea46$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $38bfe2ca40fbea46$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $38bfe2ca40fbea46$var$rnds;
    };
}

});

parcelRegister("2GPBM", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $1f57895b08aa3f1c$var$byteToHex = [];
for(var $1f57895b08aa3f1c$var$i = 0; $1f57895b08aa3f1c$var$i < 256; ++$1f57895b08aa3f1c$var$i)$1f57895b08aa3f1c$var$byteToHex[$1f57895b08aa3f1c$var$i] = ($1f57895b08aa3f1c$var$i + 0x100).toString(16).substr(1);
function $1f57895b08aa3f1c$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $1f57895b08aa3f1c$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $1f57895b08aa3f1c$var$bytesToUuid;

});


parcelRegister("4KCVx", function(module, exports) {

var $4S4Kf = parcelRequire("4S4Kf");

var $2GPBM = parcelRequire("2GPBM");
function $3759a76c8effc9df$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $4S4Kf)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $2GPBM(rnds);
}
module.exports = $3759a76c8effc9df$var$v4;

});


parcelRegister("8gbjk", function(module, exports) {
$parcel$export(module.exports, "doc", () => $8d952b1e2e996fc8$export$2a111da947c407d2);
const $8d952b1e2e996fc8$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("fwXLN", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $7f8fda3517285ecc$export$9c206ddddb32a9b);

var $lfKh1 = parcelRequire("lfKh1");
const $7f8fda3517285ecc$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $lfKh1.createTextNodes)(content)
    });

});
parcelRegister("lfKh1", function(module, exports) {
$parcel$export(module.exports, "createTextNodes", () => $48b92259a071ed52$export$3a269a5941b62f04);

var $7mggr = parcelRequire("7mggr");
function $48b92259a071ed52$export$3a269a5941b62f04(nodes) {
    return nodes.map($48b92259a071ed52$export$72b9432ea0656b50);
}
function $48b92259a071ed52$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $7mggr.text)(str) : str;
}

});
parcelRegister("7mggr", function(module, exports) {
$parcel$export(module.exports, "text", () => $ff9611ab74db83b1$export$6f093cfa640b7166);
const $ff9611ab74db83b1$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});




parcelRegister("eUZZi", function(module, exports) {
$parcel$export(module.exports, "sendHelpseekerMessage", () => $3f40f23bbbf55974$export$78d52c3c7b67d769);

var $63sfu = parcelRequire("63sfu");

var $lFeJw = parcelRequire("lFeJw");

var $H2A0Q = parcelRequire("H2A0Q");

var $aIcRy = parcelRequire("aIcRy");

var $6s6gR = parcelRequire("6s6gR");
const $3f40f23bbbf55974$export$78d52c3c7b67d769 = (message)=>({ getState: getState, setState: setState, dispatch: dispatch }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent, abortController: abortController } = getState();
        if (!conversationId || !abortController) {
            dispatch((0, $6s6gR.sendMessageErrorHandler)());
            return;
        }
        conversationProvider.sendMessage(message, abortController.signal).then(async (response)=>{
            var _last;
            // https://data-portal.internal.atlassian.com/analytics/registry/65969
            (0, $H2A0Q.sendTrackEvent)({
                action: 'sent',
                actionSubject: 'conversationMessage',
                actionSubjectId: conversationId,
                attributes: {
                    conversationId: conversationId,
                    contextId: contextId,
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aIcRy.initialIntentMessageExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aIcRy.intentAnswerExperience).success();
            if (handleEscalateFromVirtualAgent && response.length && response[response.length - 1].conversationState === 'escalated') {
                handleEscalateFromVirtualAgent();
                return;
            }
            if ((_last = (0, $63sfu.last)(response)) !== null && _last !== void 0 && _last.shouldHandoff) {
                const { messages: messages } = getState();
                if (handleHandOff) await handleHandOff(messages, conversationId, contextId);
                const metricMetaData = {
                    contextId: contextId,
                    conversationId: conversationId,
                    handOff: true,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aIcRy.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aIcRy.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lFeJw.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lFeJw.initialAIAnswerExperience).start();
                return;
            }
            for(let i = 0; i < response.length; i++)setTimeout(()=>{
                const { messages: newMessages } = getState();
                setState({
                    messages: newMessages.concat(response[i])
                });
            }, 500 * i); // 500ms delay between each message
        }).catch(()=>{
            dispatch((0, $6s6gR.sendMessageErrorHandler)());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aIcRy.initialIntentMessageExperience).failure();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aIcRy.intentAnswerExperience).failure();
        }).finally(()=>setState({
                isLoading: false
            }));
    };

});
parcelRegister("lFeJw", function(module, exports) {
$parcel$export(module.exports, "AIAnswerExperience", () => $8c6a1530e8cf77ac$export$1b78ddffe984ff3a);
$parcel$export(module.exports, "initialAIAnswerExperience", () => $8c6a1530e8cf77ac$export$7cb0088260227065);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $8c6a1530e8cf77ac$var$AIAnswerExperienceId = 'service-management.help-center.ai-message';
const $8c6a1530e8cf77ac$var$initialAIAnswerExperienceId = 'service-management.help-center.ai-initial-message-reply';
const $8c6a1530e8cf77ac$export$1b78ddffe984ff3a = new (0, $3odV5.UFOExperience)($8c6a1530e8cf77ac$var$AIAnswerExperienceId, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $8c6a1530e8cf77ac$export$7cb0088260227065 = new (0, $3odV5.UFOExperience)($8c6a1530e8cf77ac$var$initialAIAnswerExperienceId, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("6s6gR", function(module, exports) {
$parcel$export(module.exports, "sendMessageErrorHandler", () => $547ab14becb8c6e0$export$30fe8f944e81bd35);

var $lnthU = parcelRequire("lnthU");

var $H2A0Q = parcelRequire("H2A0Q");
const $547ab14becb8c6e0$export$30fe8f944e81bd35 = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, portalId: portalId, projectId: projectId, contextId: contextId } = getState();
        // https://data-portal.internal.atlassian.com/analytics/registry/65971
        (0, $H2A0Q.sendTrackEvent)({
            action: 'failed',
            actionSubject: 'conversationSendMessage',
            actionSubjectId: conversationId || '',
            attributes: {
                conversationId: conversationId,
                contextId: contextId,
                portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
                projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString()
            }
        });
        const errorMessage = {
            id: `client::${(0, $lnthU.v4)()}`,
            timeCreated: new Date().toISOString(),
            conversationChannelId: conversationId || '',
            message: {
                authorType: 'ERROR'
            }
        };
        setState({
            messages: [
                ...messages,
                errorMessage
            ]
        });
    };

});



parcelRegister("2024k", function(module, exports) {
$parcel$export(module.exports, "addMessage", () => $f88ba53e36924ba8$export$16fdb433d434f08);

var $fJAml = parcelRequire("fJAml");

var $eUZZi = parcelRequire("eUZZi");

var $9ymjZ = parcelRequire("9ymjZ");
const $f88ba53e36924ba8$export$180697e5b334e664 = (message)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { conversationId: conversationId } = getState();
        try {
            const helpseekerMessage = dispatch((0, $fJAml.constructHelpseekerMessage)({
                authorType: 'HELPSEEKER',
                content: message
            }));
            // start new conversation if no conversation id
            if (!conversationId) {
                const newConversationId = await dispatch((0, $9ymjZ.startConversation)(helpseekerMessage));
                if (!newConversationId) throw new Error('A conversation id for this conversation already exists.');
                helpseekerMessage.conversationChannelId = newConversationId;
            }
            return dispatch((0, $eUZZi.sendHelpseekerMessage)(helpseekerMessage));
        } catch (error) {
            setState({
                isLoading: false
            });
            return undefined;
        }
    };
const $f88ba53e36924ba8$export$16fdb433d434f08 = (message)=>({ dispatch: dispatch })=>{
        dispatch($f88ba53e36924ba8$export$180697e5b334e664(message)).catch(()=>{
            return undefined;
        });
    };

});
parcelRegister("9ymjZ", function(module, exports) {
$parcel$export(module.exports, "startConversation", () => $a1b5f579760d33ef$export$263d31a093aceb09);

var $lFeJw = parcelRequire("lFeJw");

var $H2A0Q = parcelRequire("H2A0Q");

var $aIcRy = parcelRequire("aIcRy");
const $a1b5f579760d33ef$export$263d31a093aceb09 = (helpseekerMessage)=>async ({ getState: getState, setState: setState }, { conversationProvider: conversationProvider, handleHandOff: handleHandOff })=>{
        const { projectId: projectId, portalId: portalId, contextId: contextId } = getState();
        const abortController = new AbortController();
        setState({
            abortController: abortController
        });
        const handleError = (error)=>{
            // https://data-portal.internal.atlassian.com/analytics/registry/65973
            (0, $H2A0Q.sendTrackEvent)({
                action: 'failed',
                actionSubject: 'startConversation',
                attributes: {
                    contextId: contextId,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            setState({
                error: error
            });
            throw new Error(error);
        };
        try {
            const response = await conversationProvider.startConversation(abortController.signal, helpseekerMessage === null || helpseekerMessage === void 0 ? void 0 : helpseekerMessage.message);
            if (abortController.signal.aborted) return undefined;
            if (!(response !== null && response !== void 0 && response.id)) throw Error('No conversation id.');
            // https://data-portal.internal.atlassian.com/analytics/registry/65970
            (0, $H2A0Q.sendTrackEvent)({
                action: 'started',
                actionSubject: 'conversation',
                actionSubjectId: response.id,
                attributes: {
                    contextId: contextId,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                }
            });
            if (response.shouldHandoff && handleHandOff) {
                const messages = helpseekerMessage ? [
                    helpseekerMessage
                ] : [];
                const metricMetaData = {
                    contextId: contextId,
                    handOff: true,
                    conversationId: response.id,
                    projectId: projectId === null || projectId === void 0 ? void 0 : projectId.toString(),
                    portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString()
                };
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aIcRy.intentAnswerExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $aIcRy.initialIntentMessageExperience).failure({
                    metadata: metricMetaData
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lFeJw.AIAnswerExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lFeJw.initialAIAnswerExperience).start();
                return handleHandOff(messages, response.id, contextId);
            }
            setState({
                conversationId: response.id
            });
            return response.id;
        } catch (error) {
            if (error instanceof Error) return handleError(error.message);
            return handleError('Failed to start conversation.');
        }
    };

});


parcelRegister("aqbPX", function(module, exports) {
$parcel$export(module.exports, "clearConversation", () => $71a705b14018ef19$export$2c9f6ca76cd8a6bc);

var $H2A0Q = parcelRequire("H2A0Q");
const $71a705b14018ef19$export$2c9f6ca76cd8a6bc = ()=>({ getState: getState, setState: setState })=>{
        const { messages: messages, conversationId: conversationId, abortController: abortController } = getState();
        if (!messages.length && !conversationId) return;
        // https://data-portal.internal.atlassian.com/analytics/registry/69030
        (0, $H2A0Q.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'clearConversationButton'
        });
        if (abortController) abortController.abort();
        setState({
            messages: [],
            conversationId: undefined,
            isLoading: false,
            abortController: undefined
        });
    };

});

parcelRegister("3KcGA", function(module, exports) {
$parcel$export(module.exports, "resetState", () => $59a812db1a01fa77$export$8e84bad0b35de9e8);
const $59a812db1a01fa77$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { conversationProvider: conversationProvider, portalId: portalId, projectId: projectId, contextId: contextId, baseUrl: baseUrl, isTestConversation: isTestConversation, handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent })=>{
        setState({
            conversationProvider: conversationProvider,
            portalId: portalId,
            projectId: projectId,
            contextId: contextId,
            baseUrl: baseUrl,
            isTestConversation: isTestConversation,
            handleEscalateFromVirtualAgent: handleEscalateFromVirtualAgent
        });
    };

});

parcelRegister("5sGYu", function(module, exports) {
$parcel$export(module.exports, "retryLastHelpseekerMessage", () => $eea68c01bf48d38b$export$f34b435044a39700);

var $lnthU = parcelRequire("lnthU");

var $g38d9 = parcelRequire("g38d9");

var $eUZZi = parcelRequire("eUZZi");
const $eea68c01bf48d38b$export$f34b435044a39700 = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const state = getState();
        const lastMessage = (0, $g38d9.getLastHelpseekerMessage)(state);
        if (!lastMessage) return;
        const retryMessage = {
            ...lastMessage,
            id: `client::${(0, $lnthU.v4)()}`,
            timeCreated: new Date().toISOString()
        };
        setState({
            isLoading: true,
            messages: [
                ...state.messages,
                retryMessage
            ]
        });
        dispatch((0, $eUZZi.sendHelpseekerMessage)(retryMessage));
    };

});
parcelRegister("g38d9", function(module, exports) {
$parcel$export(module.exports, "getAppendicesFromLastMessage", () => $8730bfbbc0803c2e$export$3d8caa938a084e16);
$parcel$export(module.exports, "getJiraFieldFromLastMessage", () => $8730bfbbc0803c2e$export$84b2c2cda37f9350);
$parcel$export(module.exports, "getLastHelpseekerMessage", () => $8730bfbbc0803c2e$export$1596bd9bbfc2b67c);
$parcel$export(module.exports, "getIsLastMessage", () => $8730bfbbc0803c2e$export$660eeeb2ec021068);

var $63sfu = parcelRequire("63sfu");
const $8730bfbbc0803c2e$export$3d8caa938a084e16 = (state)=>{
    const lastMessage = (0, $63sfu.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) === 'AGENT') return lastMessage.message.appendices;
    return undefined;
};
const $8730bfbbc0803c2e$export$84b2c2cda37f9350 = (state)=>{
    const lastMessage = (0, $63sfu.last)(state.messages);
    if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.message.authorType) !== 'AGENT' || !(lastMessage !== null && lastMessage !== void 0 && lastMessage.message.appendices)) return undefined;
    const jiraField = lastMessage.message.appendices.find((appendix)=>appendix.type === 'JIRA_FIELD');
    return jiraField;
};
const $8730bfbbc0803c2e$export$1596bd9bbfc2b67c = (state)=>(0, $63sfu.findLast)(state.messages, (message)=>message.message.authorType === 'HELPSEEKER');
const $8730bfbbc0803c2e$export$660eeeb2ec021068 = (state, messageId)=>{
    var _findLast;
    return messageId === ((_findLast = (0, $63sfu.findLast)(state.messages)) === null || _findLast === void 0 ? void 0 : _findLast.id);
};

});


parcelRegister("kZwKK", function(module, exports) {
$parcel$export(module.exports, "selectOption", () => $a104ed2488d0ff37$export$f6a817e077493ad8);

var $aIcRy = parcelRequire("aIcRy");

var $fJAml = parcelRequire("fJAml");

var $eUZZi = parcelRequire("eUZZi");
const $a104ed2488d0ff37$export$f6a817e077493ad8 = (option)=>({ dispatch: dispatch })=>{
        const helpseekerMessage = dispatch((0, $fJAml.constructHelpseekerMessage)({
            authorType: 'HELPSEEKER',
            optionId: option.id,
            content: option.label || ''
        }));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $aIcRy.intentAnswerExperience).start();
        return dispatch((0, $eUZZi.sendHelpseekerMessage)(helpseekerMessage));
    };

});


parcelRegister("cUxXd", function(module, exports) {
$parcel$export(module.exports, "ConversationStateContainer", () => $68d0f1a59cb5a19b$export$2d1cf1e83cc748b3);

var $4CywU = parcelRequire("4CywU");
const $68d0f1a59cb5a19b$export$2d1cf1e83cc748b3 = (0, $4CywU.createContainer)();

});



parcelRegister("hwl8b", function(module, exports) {
$parcel$export(module.exports, "useProvider", () => $db6f971ae1fbd3ca$export$693cdb10cec23617);
$parcel$export(module.exports, "useIsRouting", () => $db6f971ae1fbd3ca$export$f2eec64eca530862);
$parcel$export(module.exports, "useActions", () => $db6f971ae1fbd3ca$export$bc923229a7fa61e7);

var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $iaq2G = parcelRequire("iaq2G");

var $2bgp4 = parcelRequire("2bgp4");

var $jSJB4 = parcelRequire("jSJB4");
const $db6f971ae1fbd3ca$var$initialState = {
    provider: (0, $iaq2G.ConversationProvider).VIRTUAL_AGENT,
    contextId: '',
    isRouting: false
};
const $db6f971ae1fbd3ca$var$store = (0, $2RDzF.createStore)({
    initialState: $db6f971ae1fbd3ca$var$initialState,
    actions: {
        setProvider: $2bgp4.setProvider,
        resetState: $2bgp4.resetState
    },
    name: 'VIRTUAL_AGENT_ROUTING',
    containedBy: (0, $jSJB4.RoutingStateContainer),
    handlers: {
        onInit: ()=>({ setState: setState }, { contextId: contextId })=>{
                setState({
                    contextId: contextId
                });
            }
    }
});
const $db6f971ae1fbd3ca$export$693cdb10cec23617 = (0, $iouul.createStateHook)($db6f971ae1fbd3ca$var$store, {
    selector: (state)=>state.provider
});
const $db6f971ae1fbd3ca$export$f2eec64eca530862 = (0, $iouul.createStateHook)($db6f971ae1fbd3ca$var$store, {
    selector: (state)=>state.isRouting
});
const $db6f971ae1fbd3ca$export$bc923229a7fa61e7 = (0, $iouul.createActionsHook)($db6f971ae1fbd3ca$var$store);

});
parcelRegister("iaq2G", function(module, exports) {
$parcel$export(module.exports, "ASSISTANT_MESSAGE_STATUS", () => $5840ed16f14f8281$export$75eb63d2758dd11a);
$parcel$export(module.exports, "FeedbackType", () => $5840ed16f14f8281$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ChannelMessageTypes", () => $5840ed16f14f8281$export$2468909fd00fe251);
$parcel$export(module.exports, "ConversationProvider", () => $5840ed16f14f8281$export$1c69fe0757d799c5);
var $5840ed16f14f8281$export$75eb63d2758dd11a = /*#__PURE__*/ function(ASSISTANT_MESSAGE_STATUS) {
    ASSISTANT_MESSAGE_STATUS["IDLE"] = "idle";
    ASSISTANT_MESSAGE_STATUS["LOADING_RESPONSE"] = "loadingResponse";
    ASSISTANT_MESSAGE_STATUS["AWAITING_RESPONSE"] = "awaitingResponse";
    ASSISTANT_MESSAGE_STATUS["TYPING_RESPONSE"] = "typingResponse";
    ASSISTANT_MESSAGE_STATUS["ABORTED_RESPONSE"] = "abortedResponse";
    ASSISTANT_MESSAGE_STATUS["SYNCED_RESPONSE"] = "syncedResponse";
    return ASSISTANT_MESSAGE_STATUS;
}({});
var $5840ed16f14f8281$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["POSITIVE"] = "positive";
    FeedbackType["NEGATIVE"] = "negative";
    return FeedbackType;
}({});
var $5840ed16f14f8281$export$2468909fd00fe251 = /*#__PURE__*/ function(ChannelMessageTypes) {
    ChannelMessageTypes["CHANNEL_FAILURE"] = "CHANNEL_FAILURE";
    ChannelMessageTypes["CHANNEL_EXPIRY"] = "CHANNEL_EXPIRY";
    ChannelMessageTypes["CHANNEL_CONVERSATION_OVER"] = "CHANNEL_CONVERSATION_OVER";
    return ChannelMessageTypes;
}({});
const $5840ed16f14f8281$export$1c69fe0757d799c5 = {
    VIRTUAL_AGENT: 'VIRTUAL_AGENT',
    AI_ANSWERS: 'AI_ANSWERS'
};

});

parcelRegister("2bgp4", function(module, exports) {
$parcel$export(module.exports, "setProvider", () => $6de293781556174d$export$1572b3eade6662f9);
$parcel$export(module.exports, "resetState", () => $6de293781556174d$export$8e84bad0b35de9e8);

var $iaq2G = parcelRequire("iaq2G");
const $6de293781556174d$export$1572b3eade6662f9 = (provider)=>({ setState: setState })=>setState({
            provider: provider
        });
const $6de293781556174d$export$8e84bad0b35de9e8 = ()=>({ setState: setState }, { contextId: contextId })=>{
        setState({
            contextId: contextId,
            provider: (0, $iaq2G.ConversationProvider).VIRTUAL_AGENT,
            isRouting: false
        });
    };

});

parcelRegister("jSJB4", function(module, exports) {
$parcel$export(module.exports, "RoutingStateContainer", () => $e239e90b6ae9dd86$export$92282a62d0a1b5d4);

var $4CywU = parcelRequire("4CywU");
const $e239e90b6ae9dd86$export$92282a62d0a1b5d4 = (0, $4CywU.createContainer)();

});


parcelRegister("ht6lp", function(module, exports) {
$parcel$export(module.exports, "useConversation", () => $aa7af73e7c6f4923$export$626f7ff9a7747889);
$parcel$export(module.exports, "useConversationId", () => $aa7af73e7c6f4923$export$27499dbe4de0e477);
$parcel$export(module.exports, "useConversationActions", () => $aa7af73e7c6f4923$export$325b6e88f398f098);
$parcel$export(module.exports, "useIsTesting", () => $aa7af73e7c6f4923$export$6747b41fb9e7b49a);
$parcel$export(module.exports, "useFeedbackCollectorConfig", () => $aa7af73e7c6f4923$export$f0e236cf8822a84c);
$parcel$export(module.exports, "useIsChannelErrorPresent", () => $aa7af73e7c6f4923$export$adfa38c4df66c906);
$parcel$export(module.exports, "getMessageFeedback", () => $aa7af73e7c6f4923$export$ee9551cc487e053e);
$parcel$export(module.exports, "getCsatScore", () => $aa7af73e7c6f4923$export$df253d0caf8deb0d);
$parcel$export(module.exports, "getLastMessageId", () => $aa7af73e7c6f4923$export$63f3452801f9da26);
$parcel$export(module.exports, "useIsLastAssistantMessageGenerated", () => $aa7af73e7c6f4923$export$dbf2a467a43e692a);
$parcel$export(module.exports, "useActions", () => $aa7af73e7c6f4923$export$bc923229a7fa61e7);
$parcel$export(module.exports, "useIsLastMessageFromHelpSeeker", () => $aa7af73e7c6f4923$export$c095b9ac465c114e);
$parcel$export(module.exports, "useIsFeedbackSkipped", () => $aa7af73e7c6f4923$export$d82a5ee85cfb7890);
$parcel$export(module.exports, "useIsCsatSkipped", () => $aa7af73e7c6f4923$export$df5c667a37af1373);

var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $iaq2G = parcelRequire("iaq2G");

var $dARA4 = parcelRequire("dARA4");

var $dk3XR = parcelRequire("dk3XR");
const $aa7af73e7c6f4923$var$store = (0, $2RDzF.createStore)({
    initialState: $dk3XR.initialState,
    actions: {
        fetchChannelId: $dARA4.fetchChannelId,
        startNewConversation: $dARA4.startNewConversation,
        onPipelineChange: $dARA4.onPipelineChange,
        setTesting: $dARA4.setTesting,
        setConversationScrollBarWidth: $dARA4.setConversationScrollBarWidth,
        recordFeedbackForConversation: $dARA4.recordFeedbackForConversation,
        refetchConversation: $dARA4.refetchConversation,
        addHelpseekerMessage: $dARA4.addHelpseekerMessage,
        addHelpseekerMessageOnlyForUI: $dARA4.addHelpseekerMessageOnlyForUI,
        addFeedbackResponseOnlyForUI: $dARA4.addFeedbackResponseOnlyForUI,
        addRetryMessageOnlyForUI: $dARA4.addRetryMessageOnlyForUI,
        setFeedbackCollectorConfig: $dARA4.setFeedbackCollectorConfig,
        clearConversation: $dARA4.clearConversation,
        abortConversation: $dARA4.abortConversation,
        takeOverConversationFromVA: $dARA4.takeOverConversationFromVA,
        addCsatResponseOnlyForUI: $dARA4.addCsatResponseOnlyForUI
    },
    name: 'CONVERSE'
});
const $aa7af73e7c6f4923$export$626f7ff9a7747889 = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>state.conversation
});
const $aa7af73e7c6f4923$export$27499dbe4de0e477 = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>{
        var _state$conversation;
        return (_state$conversation = state.conversation) === null || _state$conversation === void 0 ? void 0 : _state$conversation.conversationId;
    }
});
const $aa7af73e7c6f4923$export$325b6e88f398f098 = (0, $iouul.createActionsHook)($aa7af73e7c6f4923$var$store);
const $aa7af73e7c6f4923$export$6747b41fb9e7b49a = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>state.isTesting
});
const $aa7af73e7c6f4923$export$f0e236cf8822a84c = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>state.feedbackCollectorConfig
});
const $aa7af73e7c6f4923$var$findBotOrAssistantMessage = (messageId)=>(chatMessage)=>{
        return chatMessage && chatMessage.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) && chatMessage.messageMetadata.messageId === messageId;
    };
const $aa7af73e7c6f4923$export$adfa38c4df66c906 = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>{
        if (!state.conversation) return false;
        const lastMessage = state.conversation.history.slice(-1)[0];
        return (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.userType) === 'channelMessage';
    }
});
const $aa7af73e7c6f4923$export$ee9551cc487e053e = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation2;
        const message = (_state$conversation2 = state.conversation) === null || _state$conversation2 === void 0 ? void 0 : _state$conversation2.history.find($aa7af73e7c6f4923$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.messageFeedback : undefined;
    }
});
const $aa7af73e7c6f4923$export$df253d0caf8deb0d = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation3;
        const message = (_state$conversation3 = state.conversation) === null || _state$conversation3 === void 0 ? void 0 : _state$conversation3.history.find($aa7af73e7c6f4923$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.csatScore : undefined;
    }
});
const $aa7af73e7c6f4923$var$findHelpSeekerOrAssistantMessage = (chatMessage)=>{
    return chatMessage && (chatMessage.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) || chatMessage.userType === (0, $dk3XR.HELP_SEEKER_USER_TYPE));
};
const $aa7af73e7c6f4923$export$63f3452801f9da26 = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>{
        var _state$conversation4;
        const message = (_state$conversation4 = state.conversation) === null || _state$conversation4 === void 0 ? void 0 : _state$conversation4.history.filter($aa7af73e7c6f4923$var$findHelpSeekerOrAssistantMessage).at(-1);
        return message && 'messageMetadata' in message ? message.messageMetadata.messageId : undefined;
    }
});
const $aa7af73e7c6f4923$export$dbf2a467a43e692a = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>{
        const { conversation: conversation, isLoading: isLoading } = state;
        const lastMessage = conversation === null || conversation === void 0 ? void 0 : conversation.history.slice(-1)[0];
        const storeAbortController = conversation === null || conversation === void 0 ? void 0 : conversation.storeAbortController;
        if (lastMessage && lastMessage.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) && storeAbortController) {
            const { messageMetadata: { status: status } } = lastMessage;
            if (!status) return false;
            return [
                (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).IDLE,
                (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
            ].indexOf(status) !== -1 && !isLoading;
        }
        return true;
    }
});
const $aa7af73e7c6f4923$export$bc923229a7fa61e7 = (0, $iouul.createActionsHook)($aa7af73e7c6f4923$var$store);
const $aa7af73e7c6f4923$export$c095b9ac465c114e = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state)=>{
        var _state$conversation5, _state$conversation6;
        return(// After first message, conversation is an object but has no history
        // To stop the user from sending another message here, we are waiting for history array to be filled
        ((_state$conversation5 = state.conversation) === null || _state$conversation5 === void 0 ? void 0 : _state$conversation5.history.length) === 0 || ((_state$conversation6 = state.conversation) === null || _state$conversation6 === void 0 || (_state$conversation6 = _state$conversation6.history.slice(-1)[0]) === null || _state$conversation6 === void 0 ? void 0 : _state$conversation6.userType) === (0, $dk3XR.HELP_SEEKER_USER_TYPE));
    }
});
const $aa7af73e7c6f4923$export$d82a5ee85cfb7890 = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation7;
        const message = (_state$conversation7 = state.conversation) === null || _state$conversation7 === void 0 ? void 0 : _state$conversation7.history.find($aa7af73e7c6f4923$var$findBotOrAssistantMessage(messageId));
        return message ? message === null || message === void 0 ? void 0 : message.messageMetadata.isFeedbackSkipped : undefined;
    }
});
const $aa7af73e7c6f4923$export$df5c667a37af1373 = (0, $iouul.createHook)($aa7af73e7c6f4923$var$store, {
    selector: (state, messageId)=>{
        var _state$conversation8;
        const message = (_state$conversation8 = state.conversation) === null || _state$conversation8 === void 0 ? void 0 : _state$conversation8.history.find($aa7af73e7c6f4923$var$findBotOrAssistantMessage(messageId));
        return message ? message.messageMetadata.isCsatSkipped : undefined;
    }
});

});
parcelRegister("dARA4", function(module, exports) {
$parcel$export(module.exports, "fetchChannelId", () => $600fa96b6fe0da35$export$92b5f8fb222eed7e);
$parcel$export(module.exports, "startNewConversation", () => $600fa96b6fe0da35$export$ec10fd022bf0d0a1);
$parcel$export(module.exports, "addHelpseekerMessageOnlyForUI", () => $600fa96b6fe0da35$export$7d26299426387884);
$parcel$export(module.exports, "onPipelineChange", () => $600fa96b6fe0da35$export$5690758dea68962c);
$parcel$export(module.exports, "setTesting", () => $600fa96b6fe0da35$export$c0371739272785cf);
$parcel$export(module.exports, "setConversationScrollBarWidth", () => $600fa96b6fe0da35$export$3549374a7ffc1e0f);
$parcel$export(module.exports, "recordFeedbackForConversation", () => $600fa96b6fe0da35$export$d775316ddbd97650);
$parcel$export(module.exports, "refetchConversation", () => $600fa96b6fe0da35$export$f84e8215cf018fc2);
$parcel$export(module.exports, "addHelpseekerMessage", () => $600fa96b6fe0da35$export$39e5a890dd0d70ff);
$parcel$export(module.exports, "addFeedbackResponseOnlyForUI", () => $600fa96b6fe0da35$export$8bc7344bcdeb6569);
$parcel$export(module.exports, "addCsatResponseOnlyForUI", () => $600fa96b6fe0da35$export$193f22ef45a60fb9);
$parcel$export(module.exports, "addRetryMessageOnlyForUI", () => $600fa96b6fe0da35$export$2024ac9dac025c83);
$parcel$export(module.exports, "setFeedbackCollectorConfig", () => $600fa96b6fe0da35$export$5e2723610064e2d9);
$parcel$export(module.exports, "clearConversation", () => $600fa96b6fe0da35$export$2c9f6ca76cd8a6bc);
$parcel$export(module.exports, "abortConversation", () => $600fa96b6fe0da35$export$882bd6a6d00830a0);
$parcel$export(module.exports, "takeOverConversationFromVA", () => $600fa96b6fe0da35$export$9ff6f230516497d2);
/* eslint-disable @typescript-eslint/require-await */ 
var $bG6ob = parcelRequire("bG6ob");

var $8gbjk = parcelRequire("8gbjk");
var $fwXLN = parcelRequire("fwXLN");

var $8s01i = parcelRequire("8s01i");
var $2y9yg = parcelRequire("2y9yg");

var $lFeJw = parcelRequire("lFeJw");

var $iaq2G = parcelRequire("iaq2G");

var $aqfow = parcelRequire("aqfow");

var $i3tyj = parcelRequire("i3tyj");

var $50GFC = parcelRequire("50GFC");

var $k8S7p = parcelRequire("k8S7p");

var $e0gbI = parcelRequire("e0gbI");

var $dpXMD = parcelRequire("dpXMD");

var $11u9C = parcelRequire("11u9C");

var $22KlD = parcelRequire("22KlD");

var $8xa9i = parcelRequire("8xa9i");

var $eVY3Y = parcelRequire("eVY3Y");

var $4M6nx = parcelRequire("4M6nx");

var $jxKS8 = parcelRequire("jxKS8");

var $dk3XR = parcelRequire("dk3XR");
const $600fa96b6fe0da35$var$CHANNEL_EXPIRY_TIME = 300000; // 5mins
const $600fa96b6fe0da35$var$ONE_DAY = 86400000; // 24 Hours
const $600fa96b6fe0da35$var$getChannelExpiryTime = ()=>{
    return (0, $bG6ob.isAiAnswer24HourTimeoutEnabled)() ? $600fa96b6fe0da35$var$ONE_DAY : $600fa96b6fe0da35$var$CHANNEL_EXPIRY_TIME;
};
const $600fa96b6fe0da35$export$92b5f8fb222eed7e = (vaConversationId)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        try {
            var _getState$conversatio;
            const channelId = await (0, $aqfow.getChannelId)();
            const history = ((_getState$conversatio = getState().conversation) === null || _getState$conversatio === void 0 ? void 0 : _getState$conversatio.history) || [];
            dispatch($600fa96b6fe0da35$var$resetTimer(channelId));
            if (channelId) setState({
                isLoading: false,
                conversation: {
                    conversationId: channelId,
                    externalConversationId: vaConversationId,
                    history: [
                        ...history
                    ]
                }
            });
            else throw new Error('No channel id!');
        } catch (e) {
            await dispatch($600fa96b6fe0da35$var$addChannelMessage((0, $iaq2G.ChannelMessageTypes).CHANNEL_EXPIRY));
        }
    };
const $600fa96b6fe0da35$var$resetTimer = (channelId, timer = $600fa96b6fe0da35$var$getChannelExpiryTime())=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const currentTimer = getState().activeTimer;
        const analyticsClient = (0, $eVY3Y.getAnalyticsWebClient)();
        if (currentTimer) clearTimeout(currentTimer);
        const activeTimer = setTimeout(()=>{
            dispatch($600fa96b6fe0da35$var$cleanFollowUps());
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            dispatch($600fa96b6fe0da35$var$addChannelMessage((0, $iaq2G.ChannelMessageTypes).CHANNEL_EXPIRY));
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhConversationScreen',
                action: 'expired',
                actionSubject: 'conversation',
                attributes: {
                    conversationId: channelId,
                    ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
                }
            });
        }, timer);
        setState({
            activeTimer: activeTimer
        });
    };
const $600fa96b6fe0da35$export$ec10fd022bf0d0a1 = (term)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        setState({
            isLoading: true,
            conversation: {
                conversationId: null,
                history: []
            }
        });
        await dispatch($600fa96b6fe0da35$export$92b5f8fb222eed7e());
        const conversation = getState().conversation;
        if (conversation && conversation.conversationId) {
            dispatch($600fa96b6fe0da35$export$7d26299426387884(term));
            /**
     * Mark conversation start when the first conversation message is sent
     */ setState({
                conversationStartTime: Date.now()
            });
            dispatch($600fa96b6fe0da35$var$fetchConversation(term));
        }
    };
const $600fa96b6fe0da35$export$5690758dea68962c = (pipeline)=>async ({ setState: setState })=>{
        setState({
            pipeline: pipeline
        });
    };
const $600fa96b6fe0da35$export$c0371739272785cf = (isTesting)=>async ({ setState: setState })=>{
        setState({
            isTesting: isTesting
        });
    };
const $600fa96b6fe0da35$export$3549374a7ffc1e0f = (conversationScrollBarWidth)=>({ setState: setState })=>{
        setState({
            ui: {
                conversationScrollBarWidth: conversationScrollBarWidth
            }
        });
    };
const $600fa96b6fe0da35$var$addChannelMessage = (type)=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            conversationId: null,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'channelMessage',
                    messageType: type
                }
            ]
        };
        setState({
            conversation: conversation,
            isLoading: false
        });
    };
const $600fa96b6fe0da35$export$d775316ddbd97650 = (id, { feedbackLabel: feedbackLabel, feedbackType: feedbackType, detailedFeedback: detailedFeedback })=>async ({ getState: getState, setState: setState })=>{
        const analyticsClient = (0, $eVY3Y.getAnalyticsWebClient)();
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        (0, $i3tyj.storeFeedback)({
            feedbackLabel: feedbackLabel,
            channelId: conversation.conversationId,
            messageId: id,
            feedback: feedbackType === (0, $iaq2G.FeedbackType).POSITIVE ? 'LIKE' : 'DISLIKE'
        }).catch(()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            analyticsClient.sendTrackEvent({
                source: 'uhAiMateFeedbackRequest',
                action: 'feedbackRequestFailed',
                actionSubject: 'feedback',
                actionSubjectId: conversation.conversationId || '',
                attributes: {
                    isAiMate: true,
                    ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
                }
            });
        });
        const updatedConversationHistory = conversation.history.map((message)=>{
            if (message.userType === (0, $dk3XR.ASSISTANT_USER_TYPE)) {
                const { messageId: messageId } = message.messageMetadata;
                if (messageId && messageId === id) return {
                    ...message,
                    messageMetadata: {
                        ...message.messageMetadata,
                        messageFeedback: {
                            feedbackType: feedbackType,
                            feedbackLabel: feedbackLabel,
                            detailedFeedback: detailedFeedback
                        }
                    }
                };
            }
            return message;
        });
        const updatedConversation = {
            ...conversation,
            history: updatedConversationHistory
        };
        setState({
            conversation: updatedConversation
        });
    };
const $600fa96b6fe0da35$var$getDefaultErrorState = (conversation)=>{
    let updatedConversationHistory = conversation.history;
    const lastMessageUserType = conversation.history[conversation.history.length - 1].userType;
    if (lastMessageUserType === (0, $dk3XR.ASSISTANT_USER_TYPE)) updatedConversationHistory = updatedConversationHistory.slice(0, -1);
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            {
                userType: 'error'
            }
        ]
    };
};
const $600fa96b6fe0da35$export$f84e8215cf018fc2 = ()=>async ({ getState: getState, dispatch: dispatch })=>{
        var _helpSeekerMessages$m;
        const conversation = getState().conversation;
        if (!conversation || !conversation.conversationId) return;
        const history = conversation.history;
        const helpSeekerMessages = history.filter((chatMessage)=>chatMessage.userType === (0, $dk3XR.HELP_SEEKER_USER_TYPE));
        const term = (_helpSeekerMessages$m = helpSeekerMessages[helpSeekerMessages.length - 1].messageMetadata) === null || _helpSeekerMessages$m === void 0 ? void 0 : _helpSeekerMessages$m.originalQuery;
        if (term) dispatch($600fa96b6fe0da35$var$fetchConversation(term));
    };
const $600fa96b6fe0da35$var$fetchConversation = (message)=>async ({ getState: getState, setState: setState })=>{
        var _metadata, _metadata2, _metadata3, _metadata4, _metadata5, _metadata6, _metadata7;
        const { conversation: conversation } = getState();
        const analyticsClient = (0, $eVY3Y.getAnalyticsWebClient)();
        if (!conversation || !conversation.conversationId) throw new Error('No conversation!');
        if (conversation.storeAbortController) // Silently aborting if there is another operation in progress
        return;
        try {
            const { storeAbortController: storeAbortController } = (0, $8xa9i.createStoreAbortController)();
            setState({
                isLoading: true
            });
            (0, $4M6nx.sendUIEventForAskedQuestion)(analyticsClient, conversation.conversationId, conversation.history.length, message.length, conversation.externalConversationId);
            const answerId = (0, $50GFC.genIntId)();
            let assistantMessage = (0, $k8S7p.initialAssistantMessage)(answerId);
            let generator;
            let isAnswerPartAnalyticsFired = false;
            let isFallbackMessage = false;
            const startTime = performance.now();
            let finishTime;
            try {
                generator = await (0, $aqfow.sendMessageStream)(message, conversation.conversationId, storeAbortController);
            } catch (e) {
                setState({
                    conversation: $600fa96b6fe0da35$var$getDefaultErrorState(conversation)
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                analyticsClient.sendTrackEvent({
                    source: 'uhAiMateRequest',
                    action: 'streaming_fetch_failed',
                    actionSubject: 'conversation',
                    actionSubjectId: conversation.conversationId,
                    attributes: {
                        isAiMate: true,
                        ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lFeJw.initialAIAnswerExperience).failure();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $lFeJw.AIAnswerExperience).failure();
                return;
            }
            if (!generator) return;
            setState({
                conversation: {
                    ...(0, $22KlD.addAssistantMessage)(assistantMessage, conversation),
                    storeAbortController: storeAbortController
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $lFeJw.initialAIAnswerExperience).success();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $lFeJw.AIAnswerExperience).success();
            for await (const streamMessage of generator){
                if (storeAbortController.signal.aborted) break;
                const { conversation: recentConversation } = getState();
                if (!recentConversation || !recentConversation.conversationId) return;
                const { type: type, content: content } = (0, $2y9yg.getUHUpdatedMessage)(streamMessage, assistantMessage.aiMateConversationResponse.message) ?? {
                    type: ''
                };
                let metadata;
                let updatedConversation;
                let totalSources;
                let totalRequestForms;
                let totalHelpDesks;
                switch(type){
                    case 'FOLLOW_UP_QUERIES':
                        setState({
                            conversation: (0, $22KlD.updateFollowUpMessage)(recentConversation, content)
                        });
                        break;
                    case 'CONTENT_SEARCH':
                        assistantMessage = (0, $22KlD.updateKeywords)(assistantMessage, content);
                        assistantMessage = (0, $22KlD.updateAssistantMessageStatusToLoadingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $22KlD.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANALYSING_STATE':
                        assistantMessage = (0, $22KlD.updateSources)(assistantMessage, content);
                        setState({
                            conversation: (0, $22KlD.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        break;
                    case 'ANSWER_PART':
                        assistantMessage = (0, $22KlD.updateMessage)(assistantMessage, content);
                        assistantMessage = (0, $22KlD.updateAssistantMessageStatusToTypingResponse)(assistantMessage);
                        setState({
                            conversation: (0, $22KlD.replaceLastAssistantMessage)(assistantMessage, recentConversation)
                        });
                        setState({
                            isLoading: false
                        });
                        !isAnswerPartAnalyticsFired && (0, $4M6nx.sendTrackEventForAnswerStreamingStarted)(analyticsClient, conversation.conversationId, performance.now() - startTime, conversation.externalConversationId);
                        isAnswerPartAnalyticsFired = true;
                        break;
                    case 'FINAL_RESPONSE':
                        metadata = content === null || content === void 0 ? void 0 : content.message_metadata;
                        isFallbackMessage = !!((_metadata = metadata) !== null && _metadata !== void 0 && _metadata.isFallbackMessage);
                        assistantMessage = (0, $22KlD.updateFinalMessage)(assistantMessage, content, isFallbackMessage);
                        if (isFallbackMessage) {
                            var _assistantMessage$aiM, _assistantMessage$mes;
                            const retryMessage = $600fa96b6fe0da35$var$getRetryMessage((_assistantMessage$aiM = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message) === null || _assistantMessage$aiM === void 0 || (_assistantMessage$aiM = _assistantMessage$aiM.message_metadata) === null || _assistantMessage$aiM === void 0 ? void 0 : _assistantMessage$aiM.originalQuery, (_assistantMessage$mes = assistantMessage.messageMetadata) === null || _assistantMessage$mes === void 0 ? void 0 : _assistantMessage$mes.messageId, isFallbackMessage);
                            updatedConversation = (0, $22KlD.replaceLastAssistantMessage)(retryMessage, recentConversation);
                        } else updatedConversation = (0, $22KlD.replaceLastAssistantMessage)(assistantMessage, recentConversation);
                        setState({
                            conversation: updatedConversation
                        });
                        finishTime = performance.now();
                        totalSources = (0, $11u9C.getTotalSources)(content);
                        totalHelpDesks = (0, $e0gbI.getTotalHelpDesks)(content);
                        totalRequestForms = (0, $dpXMD.getTotalRequestForms)(content);
                        (0, $4M6nx.sendTrackEventForFetchedResponse)(analyticsClient, finishTime - startTime, (_metadata2 = metadata) === null || _metadata2 === void 0 ? void 0 : _metadata2.confidenceScore, (_metadata3 = metadata) === null || _metadata3 === void 0 ? void 0 : _metadata3.isFallbackMessage, (_metadata4 = metadata) === null || _metadata4 === void 0 ? void 0 : _metadata4.isConfluenceLicensedUser, (_metadata5 = metadata) === null || _metadata5 === void 0 ? void 0 : _metadata5.isVagueQuery, (_metadata6 = metadata) === null || _metadata6 === void 0 ? void 0 : _metadata6.searchResultCount, (_metadata7 = metadata) === null || _metadata7 === void 0 ? void 0 : _metadata7.totalSearchResultCount, recentConversation.conversationId, totalSources, totalHelpDesks, totalRequestForms, assistantMessage.messageMetadata.messageId, recentConversation.externalConversationId);
                        break;
                    case 'ERROR':
                        setState({
                            conversation: $600fa96b6fe0da35$var$getDefaultErrorState(recentConversation)
                        });
                        (0, $4M6nx.sendTrackEventForFailure)(analyticsClient, recentConversation.conversationId, false, recentConversation.externalConversationId);
                        break;
                    default:
                        break;
                }
            }
        } finally{
            const { conversation: currentConversation } = getState();
            setState({
                conversation: currentConversation ? {
                    ...currentConversation,
                    storeAbortController: undefined
                } : null,
                isLoading: false
            });
        }
    };
const $600fa96b6fe0da35$export$39e5a890dd0d70ff = (term)=>async ({ getState: getState, dispatch: dispatch })=>{
        var _getState$conversatio2;
        dispatch($600fa96b6fe0da35$var$resetTimer((_getState$conversatio2 = getState().conversation) === null || _getState$conversatio2 === void 0 ? void 0 : _getState$conversatio2.conversationId));
        dispatch($600fa96b6fe0da35$var$cleanFollowUps());
        dispatch($600fa96b6fe0da35$export$7d26299426387884(term));
        dispatch($600fa96b6fe0da35$var$fetchConversation(term));
    };
const $600fa96b6fe0da35$var$cleanFollowUps = ()=>({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: conversation.history.filter((item)=>item.userType !== 'followUp')
        };
        setState({
            conversation: conversation
        });
    };
const $600fa96b6fe0da35$export$7d26299426387884 = (term)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        conversation = {
            ...conversation,
            history: [
                ...conversation.history.map((message)=>{
                    if (message.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) && !message.messageMetadata.isFeedbackSkipped && !message.messageMetadata.messageFeedback) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isFeedbackSkipped: true
                        }
                    };
                    if (message.userType === (0, $dk3XR.ASSISTANT_USER_TYPE) && !message.messageMetadata.isCsatSkipped && !message.messageMetadata.csatScore) return {
                        ...message,
                        messageMetadata: {
                            ...message.messageMetadata,
                            isCsatSkipped: true
                        }
                    };
                    return message;
                }),
                {
                    userType: 'helpseeker',
                    messageContentAdf: (0, $8gbjk.doc)((0, $fwXLN.paragraph)(term)),
                    messageMetadata: {
                        originalQuery: term
                    }
                }
            ]
        };
        setState({
            conversation: conversation
        });
    };
const $600fa96b6fe0da35$export$8bc7344bcdeb6569 = (response, id, isResolved)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const responseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $8gbjk.doc)((0, $fwXLN.paragraph)(response))
        };
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(indexOfAssistantMessage + 1, 0, responseObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
        if (isResolved) {
            var _getState$conversatio3;
            dispatch($600fa96b6fe0da35$var$addCsatDropdownMessageOnlyForUI(indexOfAssistantMessage, id));
            dispatch($600fa96b6fe0da35$var$cleanFollowUps());
            dispatch($600fa96b6fe0da35$var$resetTimer((_getState$conversatio3 = getState().conversation) === null || _getState$conversatio3 === void 0 ? void 0 : _getState$conversatio3.conversationId, $600fa96b6fe0da35$var$ONE_DAY));
        }
    };
const $600fa96b6fe0da35$export$193f22ef45a60fb9 = (response, id)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        conversation.history[indexOfAssistantMessage].messageMetadata.csatScore = response.id;
        const helpseekerResponseObject = {
            userType: 'feedbackResponse',
            messageContentAdf: (0, $8gbjk.doc)((0, $fwXLN.paragraph)(response.label))
        };
        // the CSAT response will be shown after, Feedback Response: 'Yes' and CSAT Dropdown Message, so we have to hop 3 indices
        const targetIndex = indexOfAssistantMessage + 3;
        const newHistory = [
            ...conversation.history
        ];
        const closeConversationObject = {
            userType: 'channelMessage',
            messageType: (0, $iaq2G.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
        };
        newHistory.splice(targetIndex, 0, helpseekerResponseObject, closeConversationObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $600fa96b6fe0da35$var$addCsatDropdownMessageOnlyForUI = (indexOfAssistantMessage, messageId)=>async ({ getState: getState, setState: setState })=>{
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const csatDropdownMessageObject = {
            userType: 'csatDropdown',
            messageMetadata: {
                messageId: messageId
            }
        };
        const newHistory = [
            ...conversation.history
        ];
        // the CSAT Dropdown will be shown after, Feedback Response: 'Yes', so we have to hop 2 indices
        newHistory.splice(indexOfAssistantMessage + 2, 0, csatDropdownMessageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $600fa96b6fe0da35$var$getRetryMessage = (originalQuery, messageId, isFallbackMessage)=>({
        userType: 'retry',
        messageMetadata: {
            originalQuery: originalQuery,
            messageId: messageId,
            isFallbackMessage: isFallbackMessage
        }
    });
const $600fa96b6fe0da35$export$2024ac9dac025c83 = (id)=>async ({ getState: getState, setState: setState })=>{
        var _assistantMessage$aiM2, _assistantMessage$aiM3;
        let conversation = getState().conversation;
        if (!conversation) throw new Error('No conversation!');
        const indexOfAssistantMessage = conversation.history.findIndex((message)=>message.userType === 'assistant' && message.messageMetadata.messageId === id);
        if (indexOfAssistantMessage === -1) return;
        const relativeFeedbackResponseIndex = conversation.history.slice(indexOfAssistantMessage).findIndex((message)=>message.userType === 'feedbackResponse');
        const feedbackResponseIndex = relativeFeedbackResponseIndex === -1 ? -1 : relativeFeedbackResponseIndex + indexOfAssistantMessage;
        if (feedbackResponseIndex === -1) return;
        const assistantMessage = conversation.history[indexOfAssistantMessage];
        const messageObject = $600fa96b6fe0da35$var$getRetryMessage(assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM2 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message) === null || _assistantMessage$aiM2 === void 0 || (_assistantMessage$aiM2 = _assistantMessage$aiM2.message_metadata) === null || _assistantMessage$aiM2 === void 0 ? void 0 : _assistantMessage$aiM2.originalQuery, id, assistantMessage === null || assistantMessage === void 0 || (_assistantMessage$aiM3 = assistantMessage.aiMateConversationResponse) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message) === null || _assistantMessage$aiM3 === void 0 || (_assistantMessage$aiM3 = _assistantMessage$aiM3.message_metadata) === null || _assistantMessage$aiM3 === void 0 ? void 0 : _assistantMessage$aiM3.isFallbackMessage);
        const newHistory = [
            ...conversation.history
        ];
        newHistory.splice(feedbackResponseIndex + 1, 0, messageObject);
        conversation = {
            ...conversation,
            history: newHistory
        };
        setState({
            conversation: conversation
        });
    };
const $600fa96b6fe0da35$export$5e2723610064e2d9 = (isVisible, messageId)=>async ({ getState: getState, setState: setState })=>{
        const { messageId: existingMessageId } = getState().feedbackCollectorConfig;
        setState({
            feedbackCollectorConfig: {
                isVisible: isVisible,
                messageId: messageId || existingMessageId
            }
        });
    };
const $600fa96b6fe0da35$export$2c9f6ca76cd8a6bc = ()=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { activeTimer: activeTimer, conversation: conversation } = getState();
        const analyticsClient = (0, $eVY3Y.getAnalyticsWebClient)();
        const { conversationId: conversationId, externalConversationId: externalConversationId } = conversation || {};
        if (activeTimer) clearTimeout(activeTimer);
        if (conversationId) {
            dispatch($600fa96b6fe0da35$export$882bd6a6d00830a0());
            (0, $4M6nx.sendUIEventForClearConversation)(analyticsClient, conversationId, externalConversationId);
        }
        setState({
            ...(0, $dk3XR.initialState)
        });
    };
const $600fa96b6fe0da35$export$882bd6a6d00830a0 = ()=>async ({ setState: setState, getState: getState })=>{
        const { conversation: conversation } = getState();
        if (!conversation || !conversation.conversationId || !conversation.storeAbortController) return;
        const lastAssistantMessage = conversation.history.slice(-1);
        if (lastAssistantMessage !== null && lastAssistantMessage !== void 0 && lastAssistantMessage.length && lastAssistantMessage[0].userType === (0, $dk3XR.ASSISTANT_USER_TYPE)) {
            const abortedMessage = (0, $22KlD.updateAbortedAssistantMessage)(lastAssistantMessage[0]);
            setState({
                conversation: (0, $22KlD.replaceLastAssistantMessage)(abortedMessage, conversation),
                isLoading: false
            });
            conversation.storeAbortController.abort();
        }
    };
const $600fa96b6fe0da35$export$9ff6f230516497d2 = (vaConversationId, history)=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _history$find;
        setState({
            isLoading: true
        });
        await dispatch($600fa96b6fe0da35$export$92b5f8fb222eed7e(vaConversationId));
        const { conversation: conversation } = getState();
        if (!conversation) throw new Error('No conversation!');
        const originalQuery = ((_history$find = history.find((message)=>message.userType === 'helpseeker')) === null || _history$find === void 0 || (_history$find = _history$find.messageMetadata) === null || _history$find === void 0 ? void 0 : _history$find.originalQuery) || '';
        setState({
            conversationStartTime: Date.now(),
            conversation: {
                ...conversation,
                history: history
            }
        });
        dispatch($600fa96b6fe0da35$var$fetchConversation(originalQuery));
    };

});
parcelRegister("8s01i", function(module, exports) {
$parcel$export(module.exports, "ExperienceType", () => $14a1b12cd15f5a19$export$7814caf20640a89e);
var $14a1b12cd15f5a19$export$7814caf20640a89e = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["UNIFIED_HELP"] = "unified-help";
    return ExperienceType;
}({});

});

parcelRegister("2y9yg", function(module, exports) {
$parcel$export(module.exports, "getUHUpdatedMessage", () => $dbd2769944a96166$export$ed355c3a875c71ab);

var $12Vb7 = parcelRequire("12Vb7");

var $80d5v = parcelRequire("80d5v");

var $lLkhr = parcelRequire("lLkhr");
const $dbd2769944a96166$export$ed355c3a875c71ab = (streamMessage, currentMessage)=>{
    if ((0, $lLkhr.isUHTraceContentSearch)(streamMessage)) {
        var _streamMessage$messag;
        return {
            type: 'CONTENT_SEARCH',
            content: ((_streamMessage$messag = streamMessage.message) === null || _streamMessage$messag === void 0 ? void 0 : _streamMessage$messag.formulated_query) || ''
        };
    }
    if ((0, $80d5v.isUHTraceAnalyzingState)(streamMessage)) {
        var _streamMessage$messag2;
        return {
            type: 'ANALYSING_STATE',
            content: ((_streamMessage$messag2 = streamMessage.message) === null || _streamMessage$messag2 === void 0 ? void 0 : _streamMessage$messag2.sources) || ''
        };
    }
    if ((0, $12Vb7.isStreamAnswerPart)(streamMessage)) return {
        type: 'ANSWER_PART',
        content: {
            ...currentMessage,
            content: currentMessage.content.toString() + streamMessage.message.content
        }
    };
    if ((0, $12Vb7.isStreamResponse)(streamMessage)) return {
        type: 'FINAL_RESPONSE',
        content: {
            ...streamMessage.message.message
        }
    };
    if ((0, $12Vb7.isStreamError)(streamMessage)) return {
        type: 'ERROR'
    };
    if ((0, $12Vb7.isFollowUpMessage)(streamMessage)) {
        var _streamMessage$messag3;
        return {
            type: 'FOLLOW_UP_QUERIES',
            content: ((_streamMessage$messag3 = streamMessage.message.follow_ups) === null || _streamMessage$messag3 === void 0 ? void 0 : _streamMessage$messag3.map((f)=>f.text)) ?? []
        };
    }
    return null;
};

});
parcelRegister("12Vb7", function(module, exports) {
$parcel$export(module.exports, "isHumanMessage", () => $01db631b39a7e2e2$export$a69fab2afb88c2eb);
$parcel$export(module.exports, "isStreamResponse", () => $01db631b39a7e2e2$export$b4631726cbc1440a);
$parcel$export(module.exports, "isAgentResponse", () => $01db631b39a7e2e2$export$a6e5100ca2770191);
$parcel$export(module.exports, "isStreamError", () => $01db631b39a7e2e2$export$d422a2733a3b5def);
$parcel$export(module.exports, "isStreamAnswerPart", () => $01db631b39a7e2e2$export$e45102edbc73b240);
$parcel$export(module.exports, "isFollowUpMessage", () => $01db631b39a7e2e2$export$aeae5b4fda357302);

var $dbdJe = parcelRequire("dbdJe");

var $e2CiB = parcelRequire("e2CiB");
const $01db631b39a7e2e2$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $01db631b39a7e2e2$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $01db631b39a7e2e2$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $01db631b39a7e2e2$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $01db631b39a7e2e2$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $01db631b39a7e2e2$export$77c9504201bdfdea = 'PROMPT_TILE';
const $01db631b39a7e2e2$export$fb661125ffb29bd6 = (message)=>{
    return $01db631b39a7e2e2$export$a69fab2afb88c2eb(message) || $01db631b39a7e2e2$export$6f965deda7f0960c(message) || $01db631b39a7e2e2$export$b4631726cbc1440a(message);
};
const $01db631b39a7e2e2$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $01db631b39a7e2e2$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $01db631b39a7e2e2$export$a6e5100ca2770191 = (message)=>message instanceof Object && $01db631b39a7e2e2$export$6f965deda7f0960c(message.message);
const $01db631b39a7e2e2$export$5c1c15675df13ae5 = (message)=>{
    var _message$message;
    return $01db631b39a7e2e2$export$b4631726cbc1440a(message) && ((_message$message = message.message) === null || _message$message === void 0 || (_message$message = _message$message.message) === null || _message$message === void 0 ? void 0 : _message$message.async_status) === 'IN_PROGRESS';
};
const $01db631b39a7e2e2$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $01db631b39a7e2e2$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $01db631b39a7e2e2$export$1e1cf807ece63df4 = (message)=>{
    var _message$message2;
    return $01db631b39a7e2e2$export$d422a2733a3b5def(message) && ((_message$message2 = message.message) === null || _message$message2 === void 0 ? void 0 : _message$message2.message_template) === $01db631b39a7e2e2$export$c424fe9570a5f2d9;
};
const $01db631b39a7e2e2$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $01db631b39a7e2e2$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $01db631b39a7e2e2$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $01db631b39a7e2e2$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $01db631b39a7e2e2$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $01db631b39a7e2e2$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $01db631b39a7e2e2$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $01db631b39a7e2e2$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $01db631b39a7e2e2$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $01db631b39a7e2e2$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $01db631b39a7e2e2$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $01db631b39a7e2e2$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $01db631b39a7e2e2$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $01db631b39a7e2e2$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $01db631b39a7e2e2$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $01db631b39a7e2e2$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $01db631b39a7e2e2$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $01db631b39a7e2e2$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $01db631b39a7e2e2$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $01db631b39a7e2e2$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $01db631b39a7e2e2$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $01db631b39a7e2e2$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $01db631b39a7e2e2$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $01db631b39a7e2e2$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $01db631b39a7e2e2$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $01db631b39a7e2e2$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $01db631b39a7e2e2$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $01db631b39a7e2e2$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($01db631b39a7e2e2$export$7898cc38956b9052(message) || $01db631b39a7e2e2$export$bb608d13a1268633(message));
const $01db631b39a7e2e2$export$d95e474df0d530df = (message)=>{
    var _message$message3;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message3 = message.message) === null || _message$message3 === void 0 ? void 0 : _message$message3.message_template) === 'MEMORY_UPDATE';
};
const $01db631b39a7e2e2$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($01db631b39a7e2e2$export$46e0fb5e4b019a49(message)) return false;
    if ($01db631b39a7e2e2$export$cde91b49af35d559(message)) return false;
    if ($01db631b39a7e2e2$export$6f74311d40862a9f(message)) return false;
    if ($01db631b39a7e2e2$export$b65c73c7e2d8d96f(message)) return false;
    if ($01db631b39a7e2e2$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $01db631b39a7e2e2$export$682514f3a8131b98 = (message)=>{
    var _message$message4;
    return message instanceof Object && message.type === 'TRACE' && ((_message$message4 = message.message) === null || _message$message4 === void 0 ? void 0 : _message$message4.message_template) === 'THINK_DEEPER_TRIGGERED';
};
const $01db631b39a7e2e2$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $01db631b39a7e2e2$export$6275ff996073145e = (message)=>{
    var _data$message;
    if (!$01db631b39a7e2e2$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray((_data$message = data.message) === null || _data$message === void 0 ? void 0 : _data$message.content);
};
const $01db631b39a7e2e2$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $01db631b39a7e2e2$export$b8391261162989d9 = (message)=>{
    var _message$message_meta, _message$message_meta2;
    return $01db631b39a7e2e2$export$6f965deda7f0960c(message) && ((message === null || message === void 0 || (_message$message_meta = message.message_metadata) === null || _message$message_meta === void 0 ? void 0 : _message$message_meta.is_action_execution) ?? false) && (message === null || message === void 0 || (_message$message_meta2 = message.message_metadata) === null || _message$message_meta2 === void 0 ? void 0 : _message$message_meta2.action_execution_result) === 'SUCCESS';
};
const $01db631b39a7e2e2$export$1060c4fa97e34fa7 = (payloadContext)=>{
    var _payloadContext$resol;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol = payloadContext.resolution) === null || _payloadContext$resol === void 0 ? void 0 : _payloadContext$resol.type) === 'cancel';
};
const $01db631b39a7e2e2$export$6ce1ccc24e75456f = (error)=>{
    var _error$errorAttribute;
    return (0, $e2CiB.isApiError)(error) && ((_error$errorAttribute = error.errorAttributes) === null || _error$errorAttribute === void 0 ? void 0 : _error$errorAttribute.errorCode) === $01db631b39a7e2e2$export$5945515082cc2cbf;
};
const $01db631b39a7e2e2$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $01db631b39a7e2e2$export$bc96a6a479480590 = (error)=>(0, $e2CiB.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $01db631b39a7e2e2$export$f8b1b75846492611 = (error)=>(0, $e2CiB.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $dbdJe.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $01db631b39a7e2e2$export$d263dc5d64f36d48 = (error)=>{
    var _error$detail;
    return error instanceof Object && (error === null || error === void 0 || (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.type) === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $01db631b39a7e2e2$export$c424fe9570a5f2d9;
};
const $01db631b39a7e2e2$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $01db631b39a7e2e2$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $01db631b39a7e2e2$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $01db631b39a7e2e2$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $01db631b39a7e2e2$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $01db631b39a7e2e2$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $01db631b39a7e2e2$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $01db631b39a7e2e2$export$4af48296a8d61cec(payloadContext) {
    var _payloadContext$resol2;
    return (payloadContext === null || payloadContext === void 0 || (_payloadContext$resol2 = payloadContext.resolution) === null || _payloadContext$resol2 === void 0 ? void 0 : _payloadContext$resol2.type) === 'confirm';
}

});
parcelRegister("dbdJe", function(module, exports) {
$parcel$export(module.exports, "ASSISTANCE_SERVICE_ERROR_CODES", () => $78b4f4fa5c3a2aaf$export$1106bf31edf2a9b8);
const $78b4f4fa5c3a2aaf$export$e8114853eca81277 = 'ai-mate';
const $78b4f4fa5c3a2aaf$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $78b4f4fa5c3a2aaf$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};

});

parcelRegister("e2CiB", function(module, exports) {
$parcel$export(module.exports, "ApiError", () => $46cedea3279298e9$export$f2e832acab1bdd79);
$parcel$export(module.exports, "isApiError", () => $46cedea3279298e9$export$89d83cc97c52a37);
$parcel$export(module.exports, "mapErrorToApiError", () => $46cedea3279298e9$export$3c02d1a328d4d808);
class $46cedea3279298e9$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $46cedea3279298e9$export$89d83cc97c52a37 = (error)=>error instanceof $46cedea3279298e9$export$f2e832acab1bdd79;
const $46cedea3279298e9$export$3c02d1a328d4d808 = (error)=>{
    if ($46cedea3279298e9$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $46cedea3279298e9$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};

});


parcelRegister("80d5v", function(module, exports) {
$parcel$export(module.exports, "isUHTraceAnalyzingState", () => $43b1cc1e0325a051$export$b7ca9806367cbd80);
const $43b1cc1e0325a051$export$b7ca9806367cbd80 = (message)=>message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';

});

parcelRegister("lLkhr", function(module, exports) {
$parcel$export(module.exports, "isUHTraceContentSearch", () => $c28984f43c3066e8$export$a9fb9dc1a9b2c5ba);
const $c28984f43c3066e8$export$a9fb9dc1a9b2c5ba = (message)=>message.type === 'TRACE' && message.message.message_template === 'CONTENT_SEARCH';

});


parcelRegister("aqfow", function(module, exports) {
$parcel$export(module.exports, "getChannelId", () => $1e0551f7b6f7050c$export$98f3eb54b6f833b6);
$parcel$export(module.exports, "sendMessageStream", () => $1e0551f7b6f7050c$export$5dd6208dff317c60);

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $8s01i = parcelRequire("8s01i");

var $eSL4S = parcelRequire("eSL4S");

var $eVY3Y = parcelRequire("eVY3Y");

var $jxKS8 = parcelRequire("jxKS8");

var $hiEBA = parcelRequire("hiEBA");

var $jGt7P = parcelRequire("jGt7P");
const $1e0551f7b6f7050c$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $1e0551f7b6f7050c$var$helpcenterSlugHeader = {
    'X-Helpcenter-Slug': (0, $eSL4S.getSlugForHelpCenter)() ?? ''
};
const $1e0551f7b6f7050c$var$getChannelIdPath = ()=>{
    return (0, $6mmHn.getMeta)('ajs-account-type') === 'customer' && (0, $bG6ob.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel` : `/gateway/api/assist/chat/v1/channel`;
};
const $1e0551f7b6f7050c$var$getMessageStreamPath = (channelId)=>{
    return (0, $6mmHn.getMeta)('ajs-account-type') === 'customer' && (0, $bG6ob.isUnifiedHelpAddFilterForCustomerAccounts)() ? `/gateway/api/assist/ca/chat/v1/channel/${channelId}/message/stream` : `/gateway/api/assist/chat/v1/channel/${channelId}/message/stream`;
};
const $1e0551f7b6f7050c$export$98f3eb54b6f833b6 = async ()=>{
    const analyticsClient = (0, $eVY3Y.getAnalyticsWebClient)();
    let channelId = null;
    try {
        const channelResponse = await (0, $hiEBA.fetchJson)($1e0551f7b6f7050c$var$getChannelIdPath(), 'POST', {
            body: JSON.stringify({}),
            headers: $1e0551f7b6f7050c$var$commonHeaders
        });
        channelId = channelResponse.id;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetched',
            actionSubject: 'channelId',
            actionSubjectId: channelId,
            attributes: {
                ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
            }
        });
    } catch (error) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        analyticsClient.sendTrackEvent({
            source: 'uhAiMateRequest',
            action: 'fetch_failed',
            actionSubject: 'channelId',
            attributes: {
                ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
            }
        });
        channelId = null;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'portalHomeScreen',
        action: 'initiated',
        actionSubject: 'aiInteraction',
        actionSubjectId: channelId ?? '',
        attributes: {
            aiFeatureName: 'aiAnswer',
            aiInteractionID: channelId,
            aiInteractionType: 'conversationId',
            proactiveAIGenerated: 0,
            userGeneratedAI: 1
        }
    });
    return channelId;
};
const $1e0551f7b6f7050c$export$5dd6208dff317c60 = async (content, channelId, abortController)=>{
    const body = {
        content: content,
        recipient_agent_named_id: 'unified_help_agent'
    };
    const options = {
        method: 'POST',
        headers: {
            ...$1e0551f7b6f7050c$var$commonHeaders,
            'content-type': 'application/json;charset=UTF-8',
            ...$1e0551f7b6f7050c$var$helpcenterSlugHeader,
            'X-Helpcenter-Ari': (0, $6mmHn.getHelpCenterAri)()
        },
        body: JSON.stringify(body),
        signal: abortController.signal
    };
    return (0, $jGt7P.fetchStream)($1e0551f7b6f7050c$var$getMessageStreamPath(channelId), options);
};

});
parcelRegister("eVY3Y", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $9f16e36d049b01b1$export$e9ba7ef9458d1a4a);
//import AnalyticsClient, { envType, originType, userType, tenantType } from '@atlassiansox/analytics-web-client';
//@ts-ignore
//import Cookie from 'js-cookie';
//import { getMeta } from '@helpcenter/meta';

var $fJQMR = parcelRequire("fJQMR");
const $9f16e36d049b01b1$export$e9ba7ef9458d1a4a = ()=>(0, $fJQMR.getAnalyticsWebClient)().getInstance();

});

parcelRegister("jxKS8", function(module, exports) {
$parcel$export(module.exports, "getProductIdentifierAttributes", () => $d9224bcc3d1fbe8b$export$414440f1585883f4);

var $6mmHn = parcelRequire("6mmHn");
const $d9224bcc3d1fbe8b$export$414440f1585883f4 = (experienceId)=>({
        experienceId: experienceId,
        helpcenterId: (0, $6mmHn.getHelpCenterAri)().split('/').pop()
    });

});

parcelRegister("hiEBA", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $7a7efa3af512a762$export$6d71b655afe1638d);
const $7a7efa3af512a762$export$6d71b655afe1638d = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        headers: {
            ...options === null || options === void 0 ? void 0 : options.headers,
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw {
        error: new Error(`Request failed: ${response.status} ${response.statusText}`),
        status: response.status
    };
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const data = await response.json();
    return data;
};

});

parcelRegister("jGt7P", function(module, exports) {
$parcel$export(module.exports, "fetchStream", () => $e47c5eb194073202$export$93163a9030575d92);

var $aGeed = parcelRequire("aGeed");
const $e47c5eb194073202$export$93163a9030575d92 = async (path, options)=>{
    const response = await fetch(path, options);
    return (0, $aGeed.readJsonStream)(response);
};

});
parcelRegister("aGeed", function(module, exports) {
$parcel$export(module.exports, "readJsonStream", () => $3730b0804e75318c$export$1f24b2b263bcfa75);

var $3H4LK = parcelRequire("3H4LK");

var $ie7uZ = parcelRequire("ie7uZ");
async function* $3730b0804e75318c$export$1f24b2b263bcfa75(response) {
    const reader = (0, $ie7uZ.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $3H4LK.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}

});
parcelRegister("ie7uZ", function(module, exports) {
$parcel$export(module.exports, "getBufferReader", () => $7bdb809bc0204bed$export$f6383c3ea1307da9);
const $7bdb809bc0204bed$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};

});




parcelRegister("i3tyj", function(module, exports) {
$parcel$export(module.exports, "storeFeedback", () => $508c3d20aa087ff0$export$f3438d7da4ca94e9);

var $dTmww = parcelRequire("dTmww");
const $508c3d20aa087ff0$var$commonHeaders = {
    'X-Experience-Id': 'unified-help',
    'X-Product': 'jsm'
};
const $508c3d20aa087ff0$export$f3438d7da4ca94e9 = async ({ channelId: channelId, messageId: messageId, feedback: feedback, feedbackLabel: feedbackLabel })=>{
    if (!messageId) return;
    await (0, $dTmww.fetchNothing)(`/gateway/api/assist/chat/v1/channel/${channelId}/message/${messageId}/feedback`, 'PUT', {
        headers: {
            ...$508c3d20aa087ff0$var$commonHeaders,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            feedback_value: feedback,
            feedback_message: feedbackLabel
        })
    });
};

});
parcelRegister("dTmww", function(module, exports) {
$parcel$export(module.exports, "fetchNothing", () => $4c8e32390c909c05$export$734eba776b437e7e);
const $4c8e32390c909c05$export$734eba776b437e7e = async (input, method, options)=>{
    const response = await fetch(input, {
        method: method,
        ...options,
        credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`Request failed: ${response.status} ${response.statusText}`);
};

});


parcelRegister("50GFC", function(module, exports) {
$parcel$export(module.exports, "genIntId", () => $53d8ef5eb76ebea8$export$99db4f5154ec67b);
const $53d8ef5eb76ebea8$export$99db4f5154ec67b = ()=>Math.floor(Math.random() * 1000000);

});

parcelRegister("k8S7p", function(module, exports) {
$parcel$export(module.exports, "initialAssistantMessage", () => $be4c291f33484761$export$b1cea82f2a755388);

var $iaq2G = parcelRequire("iaq2G");
const $be4c291f33484761$export$b1cea82f2a755388 = (answerId)=>({
        aiMateConversationResponse: {
            message: {
                id: String(answerId),
                time_created: '',
                user_ari: '',
                role: 'assistant',
                content: '',
                plugin_invocations: []
            }
        },
        userType: 'assistant',
        messageMetadata: {
            status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
            messageId: answerId.toString()
        }
    });

});

parcelRegister("e0gbI", function(module, exports) {
$parcel$export(module.exports, "getTotalHelpDesks", () => $436e41958288a621$export$826b9b61b3b7d76d);
const $436e41958288a621$export$826b9b61b3b7d76d = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'helpDesk')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("dpXMD", function(module, exports) {
$parcel$export(module.exports, "getTotalRequestForms", () => $2f9bc5686edd5beb$export$859320f8ebb3caf3);
const $2f9bc5686edd5beb$export$859320f8ebb3caf3 = (message)=>{
    var _message$appendices;
    return (message === null || message === void 0 || (_message$appendices = message.appendices) === null || _message$appendices === void 0 || (_message$appendices = _message$appendices.filter((appendix)=>appendix.type === 'requestForm')) === null || _message$appendices === void 0 ? void 0 : _message$appendices.length) ?? 0;
};

});

parcelRegister("11u9C", function(module, exports) {
$parcel$export(module.exports, "getTotalSources", () => $566cf102e5be0c0e$export$75f436fca26bdba1);
const $566cf102e5be0c0e$export$75f436fca26bdba1 = (message)=>{
    var _message$sources;
    return (message === null || message === void 0 || (_message$sources = message.sources) === null || _message$sources === void 0 ? void 0 : _message$sources.length) ?? 0;
};

});

parcelRegister("22KlD", function(module, exports) {
$parcel$export(module.exports, "updateKeywords", () => $7a5dd59890b358e8$export$9c6f66d1d405561d);
$parcel$export(module.exports, "updateSources", () => $7a5dd59890b358e8$export$6c4da287bd77d75c);
$parcel$export(module.exports, "updateMessage", () => $7a5dd59890b358e8$export$829153c748a07de7);
$parcel$export(module.exports, "updateFinalMessage", () => $7a5dd59890b358e8$export$95204cf9f69c856a);
$parcel$export(module.exports, "addAssistantMessage", () => $7a5dd59890b358e8$export$ce06e1b90807a0c0);
$parcel$export(module.exports, "replaceLastAssistantMessage", () => $7a5dd59890b358e8$export$a1def0348b9f1873);
$parcel$export(module.exports, "updateFollowUpMessage", () => $7a5dd59890b358e8$export$9143429366a9249);
$parcel$export(module.exports, "updateAssistantMessageStatusToTypingResponse", () => $7a5dd59890b358e8$export$e1c963c90a5d08ee);
$parcel$export(module.exports, "updateAssistantMessageStatusToLoadingResponse", () => $7a5dd59890b358e8$export$c2814dbaf6592faa);
$parcel$export(module.exports, "updateAbortedAssistantMessage", () => $7a5dd59890b358e8$export$5d7bc912c91053cd);

var $iaq2G = parcelRequire("iaq2G");

var $dk3XR = parcelRequire("dk3XR");
const $7a5dd59890b358e8$export$9c6f66d1d405561d = (assistantMessage, keywords = '')=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                keywords: keywords.split('|')
            }
        }
    });
const $7a5dd59890b358e8$export$6c4da287bd77d75c = (assistantMessage, sources)=>({
        ...assistantMessage,
        messageMetadata: {
            loadingState: {
                ...assistantMessage.messageMetadata.loadingState,
                sources: sources
            }
        }
    });
const $7a5dd59890b358e8$export$829153c748a07de7 = (assistantMessage, message)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        }
    });
const $7a5dd59890b358e8$export$95204cf9f69c856a = (assistantMessage, message, isFallbackMessage)=>({
        ...assistantMessage,
        aiMateConversationResponse: {
            message: message
        },
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            isFallbackMessage: isFallbackMessage,
            messageId: message.id.toString(),
            status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).IDLE,
            showFeedback: !isFallbackMessage
        }
    });
const $7a5dd59890b358e8$export$ce06e1b90807a0c0 = (assistantMessage, conversation)=>({
        ...conversation,
        history: [
            ...conversation.history,
            assistantMessage
        ]
    });
const $7a5dd59890b358e8$export$a1def0348b9f1873 = (message, conversation)=>{
    const updatedConversationHistory = conversation.history[conversation.history.length - 1].userType === (0, $dk3XR.ASSISTANT_USER_TYPE) ? conversation.history.slice(0, -1) : conversation.history;
    return {
        ...conversation,
        history: [
            ...updatedConversationHistory,
            message
        ]
    };
};
const $7a5dd59890b358e8$export$9143429366a9249 = (conversation, queries)=>({
        ...conversation,
        history: [
            ...conversation.history,
            {
                queries: queries,
                userType: 'followUp'
            }
        ]
    });
const $7a5dd59890b358e8$export$e1c963c90a5d08ee = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE
        }
    });
const $7a5dd59890b358e8$export$c2814dbaf6592faa = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE
        }
    });
const $7a5dd59890b358e8$export$5d7bc912c91053cd = (assistantMessage)=>({
        ...assistantMessage,
        messageMetadata: {
            ...assistantMessage.messageMetadata,
            status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
        }
    });

});
parcelRegister("dk3XR", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $f784b974e6d7a21c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "ASSISTANT_USER_TYPE", () => $f784b974e6d7a21c$export$93622d3dc67e9e9b);
$parcel$export(module.exports, "HELP_SEEKER_USER_TYPE", () => $f784b974e6d7a21c$export$fa4d1d4ff5355f70);
const $f784b974e6d7a21c$export$d4c72bab9d6cc13a = {
    isLoading: false,
    conversation: null,
    searchAll: false,
    pipeline: '',
    isTesting: false,
    feedbackCollectorConfig: {
        isVisible: false,
        messageId: undefined
    },
    activeTimer: null,
    ui: {
        conversationScrollBarWidth: '0px'
    }
};
const $f784b974e6d7a21c$export$93622d3dc67e9e9b = 'assistant';
const $f784b974e6d7a21c$export$fa4d1d4ff5355f70 = 'helpseeker';

});


parcelRegister("8xa9i", function(module, exports) {
$parcel$export(module.exports, "createStoreAbortController", () => $a2bfd1c05205f4c5$export$cb6128fc3a3c8081);
const $a2bfd1c05205f4c5$export$cb6128fc3a3c8081 = ()=>{
    const abortController = new AbortController();
    const abort = ()=>{
        abortController.abort();
    };
    const signal = abortController.signal;
    return {
        storeAbortController: {
            abort: abort,
            signal: signal
        }
    };
};

});

parcelRegister("4M6nx", function(module, exports) {
$parcel$export(module.exports, "sendUIEventForAskedQuestion", () => $88137c6561352c90$export$2bf225029007d9aa);
$parcel$export(module.exports, "sendUIEventForClearConversation", () => $88137c6561352c90$export$e33202cdfb6e8294);
$parcel$export(module.exports, "sendTrackEventForAnswerStreamingStarted", () => $88137c6561352c90$export$1ad079e189e166f0);
$parcel$export(module.exports, "sendTrackEventForFetchedResponse", () => $88137c6561352c90$export$b13699b81838287b);
$parcel$export(module.exports, "sendTrackEventForFailure", () => $88137c6561352c90$export$d40db612c63a38bf);
$parcel$export(module.exports, "sendUIEventForFollowUpSelection", () => $88137c6561352c90$export$6d1d2cd3a3ab5d10);

var $8s01i = parcelRequire("8s01i");

var $jxKS8 = parcelRequire("jxKS8");
const $88137c6561352c90$export$2bf225029007d9aa = (analyticsClient, conversationId, totalMessageCount, messageLength, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'uhConversationScreen',
        action: 'asked',
        actionSubject: 'question',
        attributes: {
            conversationId: conversationId,
            messageLength: messageLength,
            totalMessageCount: totalMessageCount,
            externalConversationId: externalConversationId,
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $88137c6561352c90$export$e33202cdfb6e8294 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'clear',
        actionSubject: 'conversation',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $88137c6561352c90$export$1ad079e189e166f0 = (analyticsClient, conversationId, messageLatency, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'started',
        actionSubject: 'streaming',
        attributes: {
            messageLatency: messageLatency,
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $88137c6561352c90$export$b13699b81838287b = (analyticsClient, messageLatency, confidenceScore, isFallbackMessage, isConfluenceLicensedUser, isVagueQuery, searchResultCount, totalSearchResultCount, conversationId, totalSources, totalHelpDesk, totalRequestForm, messageId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: 'fetched',
        actionSubject: 'conversation',
        actionSubjectId: conversationId,
        attributes: {
            externalConversationId: externalConversationId,
            messageLatency: messageLatency,
            confidenceScore: confidenceScore,
            isFallbackMessage: isFallbackMessage,
            isConfluenceLicensedUser: isConfluenceLicensedUser,
            isVagueQuery: isVagueQuery,
            searchResultCount: searchResultCount,
            totalSearchResultCount: totalSearchResultCount,
            totalSources: totalSources,
            totalHelpDesk: totalHelpDesk,
            totalRequestForm: totalRequestForm,
            messageId: messageId,
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $88137c6561352c90$export$d40db612c63a38bf = (analyticsClient, channelId, isRateLimitingError, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendTrackEvent({
        source: 'uhAiMateRequest',
        action: isRateLimitingError ? 'rateLimited' : 'fetch_failed',
        actionSubject: 'conversation',
        actionSubjectId: channelId,
        attributes: {
            externalConversationId: externalConversationId,
            isAiMate: true,
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }
    });
};
const $88137c6561352c90$export$6d1d2cd3a3ab5d10 = (analyticsClient, conversationId, externalConversationId)=>{
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    analyticsClient.sendUIEvent({
        source: 'conversationScreen',
        action: 'selected',
        actionSubject: 'followUpQuery',
        attributes: {
            conversationId: conversationId,
            externalConversationId: externalConversationId,
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }
    });
};

});




parcelRegister("7PrtD", function(module, exports) {
$parcel$export(module.exports, "useIsGenerating", () => $e710fa3c31f44415$export$d04302655294f9a5);

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $ht6lp = parcelRequire("ht6lp");
const $e710fa3c31f44415$export$d04302655294f9a5 = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const [isLastAssistantMessageGenerated] = (0, $ht6lp.useIsLastAssistantMessageGenerated)();
    if (!provider || provider === (0, $iaq2G.ConversationProvider).VIRTUAL_AGENT) return false;
    return !isLastAssistantMessageGenerated;
};

});

parcelRegister("lekQR", function(module, exports) {
$parcel$export(module.exports, "useIsInputEnabled", () => $cb1a20c49861d9d9$export$335460cd33393c4b);

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $ht6lp = parcelRequire("ht6lp");
const $cb1a20c49861d9d9$export$335460cd33393c4b = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const isRouting = (0, $hwl8b.useIsRouting)();
    const [isLastMessageFromHelpSeeker] = (0, $ht6lp.useIsLastMessageFromHelpSeeker)();
    const [isLastAssistantMessageGenerated] = (0, $ht6lp.useIsLastAssistantMessageGenerated)();
    if (isRouting) return false;
    if (!provider || provider === (0, $iaq2G.ConversationProvider).VIRTUAL_AGENT) return true;
    return isLastAssistantMessageGenerated && !isLastMessageFromHelpSeeker;
};

});

parcelRegister("hk7Rr", function(module, exports) {
$parcel$export(module.exports, "useHasMessages", () => $0bb2d44c1d174db6$export$cd077d7865053739);

var $2QlRL = parcelRequire("2QlRL");

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $ht6lp = parcelRequire("ht6lp");
const $0bb2d44c1d174db6$export$cd077d7865053739 = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const [AIAnswersConversation] = (0, $ht6lp.useConversation)();
    const VAMessages = (0, $2QlRL.useMessages)();
    if (provider === (0, $iaq2G.ConversationProvider).VIRTUAL_AGENT) return VAMessages.length > 0;
    return !!AIAnswersConversation;
};

});

parcelRegister("adtvq", function(module, exports) {
$parcel$export(module.exports, "useStopGenerating", () => $7a4226a1fb235228$export$177960b8f80ddb1c);

var $hwl8b = parcelRequire("hwl8b");

var $ht6lp = parcelRequire("ht6lp");
const $7a4226a1fb235228$export$177960b8f80ddb1c = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const { abortConversation: abortConversation } = (0, $ht6lp.useActions)();
    const stopGenerating = ()=>{
        if (provider === 'AI_ANSWERS') abortConversation();
    };
    return {
        stopGenerating: stopGenerating
    };
};

});

parcelRegister("gjuj3", function(module, exports) {
$parcel$export(module.exports, "useGetMaxChars", () => $9000bd53f1a2435c$export$6fdff492f3dfb4bb);

var $lAMvj = parcelRequire("lAMvj");

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $8rCas = parcelRequire("8rCas");
const $9000bd53f1a2435c$export$6fdff492f3dfb4bb = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const { getJiraFieldMaxChars: getJiraFieldMaxChars } = (0, $lAMvj.useGetJiraFieldMaxChars)();
    const getMaxChars = ()=>{
        if (provider === (0, $iaq2G.ConversationProvider).VIRTUAL_AGENT) {
            const maxJiraFieldChars = getJiraFieldMaxChars();
            if (maxJiraFieldChars) return maxJiraFieldChars;
        }
        return 0, $8rCas.MAX_CHARS;
    };
    return {
        getMaxChars: getMaxChars
    };
};

});
parcelRegister("lAMvj", function(module, exports) {
$parcel$export(module.exports, "useGetJiraFieldMaxChars", () => $8238b9a4686caab7$export$1c551de6ec5f7e66);

var $jRR3Y = parcelRequire("jRR3Y");

var $86Tyk = parcelRequire("86Tyk");

var $8ZLRy = parcelRequire("8ZLRy");

var $2QlRL = parcelRequire("2QlRL");
const $8238b9a4686caab7$export$1c551de6ec5f7e66 = ()=>{
    const jiraField = (0, $2QlRL.useFieldFromLastMessage)();
    const baseUrl = (0, $2QlRL.useBaseUrl)();
    const [{ data: requestTypeFields }] = (0, $86Tyk.useRequestTypeFields)({
        baseUrl: baseUrl
    });
    const fieldType = jiraField && (0, $8ZLRy.getFieldType)(jiraField.fieldId, requestTypeFields);
    const getJiraFieldMaxChars = ()=>{
        if (fieldType === (0, $8ZLRy.SHORT_TEXT_FIELD_TYPE)) return 0, $jRR3Y.MAX_SHORT_TEXT_FIELD_CHARS;
        if (fieldType === (0, $8ZLRy.PARAGRAPH_FIELD_TYPE)) return 0, $jRR3Y.MAX_PARAGRAPH_FIELD_CHARS;
        return undefined;
    };
    return {
        getJiraFieldMaxChars: getJiraFieldMaxChars
    };
};

});
parcelRegister("jRR3Y", function(module, exports) {
$parcel$export(module.exports, "MAX_SHORT_TEXT_FIELD_CHARS", () => $7a03b48e150951b0$export$91e0b38c91e2cd5c);
$parcel$export(module.exports, "MAX_PARAGRAPH_FIELD_CHARS", () => $7a03b48e150951b0$export$44efb9aa2d3aca69);
$parcel$export(module.exports, "CONVERSATION_TIME_OUT", () => $7a03b48e150951b0$export$2efd43ac8eb281e1);
const $7a03b48e150951b0$export$91e0b38c91e2cd5c = 250;
const $7a03b48e150951b0$export$44efb9aa2d3aca69 = 1000;
const $7a03b48e150951b0$export$2efd43ac8eb281e1 = 120000; // 2 minutes

});


parcelRegister("8rCas", function(module, exports) {
$parcel$export(module.exports, "PIPELINE_LOCAL_STORAGE_KEY", () => $aff6a958730125b1$export$1d9b669fd4b51619);
$parcel$export(module.exports, "DEFAULT_PIPELINE", () => $aff6a958730125b1$export$dfea82974f95546a);
$parcel$export(module.exports, "LINK_CLICKED_EVENT", () => $aff6a958730125b1$export$c3919a87590ab58a);
$parcel$export(module.exports, "MAX_CHARS", () => $aff6a958730125b1$export$3fd15502aa7f615e);
const $aff6a958730125b1$export$1d9b669fd4b51619 = 'pipeline';
const $aff6a958730125b1$export$dfea82974f95546a = 'DEFAULT_PIPELINE';
const $aff6a958730125b1$export$478ff1f86cdd0b2 = 480;
const $aff6a958730125b1$export$90f94aac6f3ac32d = 744;
const $aff6a958730125b1$export$460a6c74e2815558 = 1440;
const $aff6a958730125b1$export$d7ccb212e23ab442 = 1025;
const $aff6a958730125b1$export$ba668ebd2a2d0856 = 1200;
const $aff6a958730125b1$export$c3919a87590ab58a = 'link clicked';
const $aff6a958730125b1$export$3fd15502aa7f615e = 1000;

});


parcelRegister("gmcif", function(module, exports) {
$parcel$export(module.exports, "useIsInputShown", () => $6e094fb1c0049656$export$ae7b9f18d03cb232);

var $hwl8b = parcelRequire("hwl8b");

var $ht6lp = parcelRequire("ht6lp");
const $6e094fb1c0049656$export$ae7b9f18d03cb232 = ()=>{
    const provider = (0, $hwl8b.useProvider)();
    const [isChannelErrorPresent] = (0, $ht6lp.useIsChannelErrorPresent)();
    if (provider === 'AI_ANSWERS') return !isChannelErrorPresent;
    return true;
};

});

parcelRegister("2CvLC", function(module, exports) {
$parcel$export(module.exports, "useClearConversation", () => $877e01141567d15e$export$6dc4e5ebda459b3);

var $2QlRL = parcelRequire("2QlRL");

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $ht6lp = parcelRequire("ht6lp");
const $877e01141567d15e$export$6dc4e5ebda459b3 = ()=>{
    const { clearConversation: clearAIAnswerConversation } = (0, $ht6lp.useActions)();
    const { clearConversation: clearVirtualAgentConversation } = (0, $2QlRL.useActions)();
    const { setProvider: setProvider } = (0, $hwl8b.useActions)();
    const clearConversation = ()=>{
        clearAIAnswerConversation();
        clearVirtualAgentConversation();
        setProvider((0, $iaq2G.ConversationProvider).VIRTUAL_AGENT);
    };
    return {
        clearConversation: clearConversation
    };
};

});

parcelRegister("7Wx9D", function(module, exports) {
$parcel$export(module.exports, "useHandOffConversation", () => $a6c4c57d300aa9a2$export$ad87f5d1da6cbafb);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $jFbx9 = parcelRequire("jFbx9");

var $fJQMR = parcelRequire("fJQMR");

var $hwl8b = parcelRequire("hwl8b");

var $iaq2G = parcelRequire("iaq2G");

var $ht6lp = parcelRequire("ht6lp");
const $a6c4c57d300aa9a2$export$ad87f5d1da6cbafb = ()=>{
    const { setProvider: setProvider } = (0, $hwl8b.useActions)();
    const { takeOverConversationFromVA: takeOverConversationFromVA } = (0, $ht6lp.useActions)();
    const analyticsClient = (0, $fJQMR.getAnalyticsWebClient)().getInstance();
    const sendHandOffAnalyticsEvent = (0, $4fqPo.useCallback)((conversationId, contextId)=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/70690
        analyticsClient.sendTrackEvent({
            action: 'rejected',
            actionSubject: 'inferIntent',
            actionSubjectId: 'globalInferIntentFast',
            attributes: {
                conversationId: conversationId,
                contextId: contextId
            },
            source: (0, $748yq.ScreenName).CONVERSATION_PAGE
        }).catch((error)=>{
            throw new Error(`Failure to send track analytics event ${error}`);
        });
    }, [
        analyticsClient
    ]);
    const handleHandOff = (0, $4fqPo.useCallback)(async (vaMessages, conversationId, contextId)=>{
        sendHandOffAnalyticsEvent(conversationId, contextId);
        if (!vaMessages.length || vaMessages[0].message.authorType !== 'HELPSEEKER') throw Error('Cannot hand off conversation without a helpseeker message');
        const history = vaMessages.map($a6c4c57d300aa9a2$var$transformVAMessageToAIAnswersMessage).filter((message)=>message !== null);
        await takeOverConversationFromVA(conversationId, history);
        setProvider((0, $iaq2G.ConversationProvider).AI_ANSWERS);
    }, [
        sendHandOffAnalyticsEvent,
        setProvider,
        takeOverConversationFromVA
    ]);
    return {
        handleHandOff: handleHandOff
    };
};
const $a6c4c57d300aa9a2$var$extractMessageContent = (message)=>{
    let originalContent = '';
    (0, $jFbx9.traverse)(message.content, {
        text: (node)=>{
            originalContent += node.text;
        }
    });
    return originalContent;
};
const $a6c4c57d300aa9a2$var$transformVAMessageToAIAnswersMessage = (message, index)=>{
    switch(message.message.authorType){
        case 'HELPSEEKER':
            return {
                userType: 'helpseeker',
                messageContentAdf: message.message.content,
                messageMetadata: {
                    ...index === 0 ? {
                        originalQuery: $a6c4c57d300aa9a2$var$extractMessageContent(message.message)
                    } : {}
                }
            };
        case 'AGENT':
            return {
                userType: 'assistant',
                aiMateConversationResponse: {
                    message: {
                        content: $a6c4c57d300aa9a2$var$parseMessageContent(message.message),
                        role: 'assistant',
                        id: String(index),
                        //
                        time_created: message.timeCreated,
                        user_ari: '',
                        plugin_invocations: []
                    }
                },
                messageMetadata: {
                    status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).SYNCED_RESPONSE
                }
            };
        default:
            return null;
    }
};
const $a6c4c57d300aa9a2$var$parseMessageContent = (message)=>{
    if (message.contentMimetype === 'application/json+adf') return JSON.parse(message.content);
    return message.content;
};

});


parcelRegister("fTxr1", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => (parcelRequire("8mlxZ")).ElementKeyMap);
$parcel$export(module.exports, "isMacOs", () => (parcelRequire("8mlxZ")).isMacOs);
parcelRequire("8mlxZ");

});
parcelRegister("8mlxZ", function(module, exports) {
$parcel$export(module.exports, "ElementKeyMap", () => $d6299a663367e5ad$export$6fa2af2018b3f7a3);
$parcel$export(module.exports, "isMacOs", () => $d6299a663367e5ad$export$c5e71f489eb3970b);
// oxlint-disable-next-line no-shadow
var $d6299a663367e5ad$export$6fa2af2018b3f7a3 = /*#__PURE__*/ function(ElementKeyMap) {
    ElementKeyMap["IMAGE"] = "HelpLayoutImageAtomicElement";
    ElementKeyMap["HEADING"] = "HelpLayoutHeadingAtomicElement";
    ElementKeyMap["PARAGRAPH"] = "HelpLayoutParagraphAtomicElement";
    ElementKeyMap["EDITOR"] = "HelpLayoutEditorElement";
    ElementKeyMap["SEARCH"] = "HelpLayoutSearchAtomicElement";
    ElementKeyMap["LINK_CARD"] = "HelpLayoutLinkCardCompositeElement";
    return ElementKeyMap;
}({});
const $d6299a663367e5ad$export$c5e71f489eb3970b = ()=>navigator.userAgent.includes('Mac');

});


parcelRegister("azPf3", function(module, exports) {
$parcel$export(module.exports, "default", () => $09ece68bd19cf9be$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $kwihi = parcelRequire("kwihi");
/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $09ece68bd19cf9be$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo((props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kwihi.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $09ece68bd19cf9be$export$2e2bcd8739ae039 = $09ece68bd19cf9be$var$WidthObserver;

});
parcelRegister("kwihi", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $560ba5d02b257ebb$export$ff983d2a2b6112ea);

var $4fqPo = parcelRequire("4fqPo");

var $iopXD = parcelRequire("iopXD");
const $560ba5d02b257ebb$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $iopXD.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("iopXD", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $ddc56e2439bd6314$export$2f62ee6831462844);

var $4fqPo = parcelRequire("4fqPo");
function $ddc56e2439bd6314$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("4wycM", function(module, exports) {
$parcel$export(module.exports, "withHelpCenterConversationStateContainer", () => $1229ca6157c6228a$export$8bee59b293b5a56c);

var $4fqPo = parcelRequire("4fqPo");

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
var $4g7Uv = parcelRequire("4g7Uv");
var $hfD9S = parcelRequire("hfD9S");

var $3Ar39 = parcelRequire("3Ar39");

var $hwl8b = parcelRequire("hwl8b");

var $8XC0X = parcelRequire("8XC0X");
parcelRequire("20isg");
var $2CvLC = parcelRequire("2CvLC");
var $7Wx9D = parcelRequire("7Wx9D");

var $8NszO = parcelRequire("8NszO");

var $8zkz6 = parcelRequire("8zkz6");

var $cUxXd = parcelRequire("cUxXd");

var $2QlRL = parcelRequire("2QlRL");
const $1229ca6157c6228a$export$8bee59b293b5a56c = (WrappedComponent)=>{
    const WithConversationStateContainer = (props)=>{
        const { contextId: contextId } = props;
        const [isTestConversationParam] = (0, $4g7Uv.useQueryParam)('isTestConversation');
        const [portalId] = (0, $eDygx.usePathParam)('portalId');
        const isTestConversation = isTestConversationParam === 'true';
        const { handleHandOff: handleHandOff } = (0, $7Wx9D.useHandOffConversation)();
        const conversationProvider = (0, $8NszO.useVirtualAgentConversationV2Provider)({
            isTestConversation: isTestConversation,
            contextId: contextId,
            cloudId: (0, $6mmHn.getCloudId)(),
            channelType: portalId ? (0, $8zkz6.ChannelType).Portal : (0, $8zkz6.ChannelType).HelpCenter
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cUxXd.ConversationStateContainer), {
            conversationProvider: conversationProvider,
            contextId: contextId,
            handleHandOff: handleHandOff,
            isTestConversation: isTestConversation,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1229ca6157c6228a$var$GlobalConversationStateManager, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props));
    };
    return (0, $8XC0X.withRoutingStateContainer)(WithConversationStateContainer);
};
/*
 * With react-sweet-state, we can not persistence the state of the store when there is no consumer, in this case, we have to
 * use a global state to preserve the state of the store when the consumer is unmounted, and use this component to reset
 * the state of the store when the user navigates away from the conversation page.
 */ const $1229ca6157c6228a$var$GlobalConversationStateManager = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    const { resetState: resetState } = (0, $hwl8b.useActions)();
    const { clearConversation: clearConversation } = (0, $2CvLC.useClearConversation)();
    const { resetState: resetVAState } = (0, $2QlRL.useActions)();
    (0, $3Ar39.useIsoMorphicLayoutEffect)(()=>{
        if (routerState.location.pathname !== '/conversation') {
            clearConversation();
            resetState();
            resetVAState();
        }
    }, [
        routerState.location.pathname,
        resetState,
        resetVAState,
        clearConversation
    ]);
    return null;
};

});
parcelRegister("8XC0X", function(module, exports) {
$parcel$export(module.exports, "withRoutingStateContainer", () => $b3c7628aa303948f$export$fcbcda437b73d924);

var $4fqPo = parcelRequire("4fqPo");

var $jSJB4 = parcelRequire("jSJB4");
const $b3c7628aa303948f$export$fcbcda437b73d924 = (WrappedComponent)=>{
    const WithRoutingStateContainer = (props)=>{
        const { contextId: contextId } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jSJB4.RoutingStateContainer), {
            contextId: contextId,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props));
    };
    return WithRoutingStateContainer;
};

});

parcelRegister("8NszO", function(module, exports) {
$parcel$export(module.exports, "useVirtualAgentConversationV2Provider", () => $570bfb37806bbac0$export$2e4d3c305d19e2ad);

var $4fqPo = parcelRequire("4fqPo");

var $hZWMk = parcelRequire("hZWMk");

var $8zkz6 = parcelRequire("8zkz6");
const $570bfb37806bbac0$export$2e4d3c305d19e2ad = ({ contextId: contextId, cloudId: cloudId, isTestConversation: isTestConversation, channelType: channelType, baseUrl: baseUrl = '' })=>{
    const startConversation = (0, $4fqPo.useCallback)(async (abortSignal, message)=>{
        try {
            const requestMessage = message ? {
                message: {
                    content: JSON.stringify(message.content)
                }
            } : null;
            const response = await (0, $hZWMk.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    channelType: channelType,
                    contextId: contextId,
                    createdAt: new Date().toISOString(),
                    isTestConversation: isTestConversation === true,
                    ...requestMessage
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return undefined;
            throw error;
        }
    }, [
        baseUrl,
        cloudId,
        isTestConversation,
        channelType,
        contextId
    ]);
    const sendMessage = (0, $4fqPo.useCallback)(async (message, abortSignal)=>{
        try {
            const response = await (0, $hZWMk.fetchJson)(`${baseUrl}/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v2/web/conversation/message`, {
                signal: abortSignal,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    externalSource: channelType === (0, $8zkz6.ChannelType).HelpCenter ? (0, $8zkz6.ExternalSource).Orchestrator : (0, $8zkz6.ExternalSource).Portal,
                    message: {
                        content: JSON.stringify(message.message.content),
                        optionId: message.message.optionId,
                        jiraField: message.message.jiraField
                    },
                    timeCreated: message.timeCreated,
                    conversationChannelId: message.conversationChannelId
                }),
                method: 'POST'
            });
            return response;
        } catch (error) {
            if (error instanceof DOMException) // TODO: add analytics for this
            return [];
            throw error;
        }
    }, [
        baseUrl,
        channelType,
        cloudId
    ]);
    return (0, $4fqPo.useMemo)(()=>({
            startConversation: startConversation,
            sendMessage: sendMessage
        }), [
        sendMessage,
        startConversation
    ]);
};

});
parcelRegister("8zkz6", function(module, exports) {
$parcel$export(module.exports, "ChannelType", () => $0111bbfc56d18081$export$36655de2868043ae);
$parcel$export(module.exports, "ExternalSource", () => $0111bbfc56d18081$export$ffc19e40a21f08eb);
const $0111bbfc56d18081$export$36655de2868043ae = {
    Portal: 'JSM_PORTAL',
    HelpCenter: 'JSM_HELP_CENTER',
    Widget: 'JSM_WIDGET'
};
const $0111bbfc56d18081$export$ffc19e40a21f08eb = {
    Portal: 'JSM_PORTAL',
    Orchestrator: 'JSM_ORCHESTRATOR'
};

});



parcelRegister("fj0mX", function(module, exports) {
$parcel$export(module.exports, "initialIntentMessageHCExperience", () => $2462fe7b54778f08$export$f0696c364409ed69);
$parcel$export(module.exports, "initialAIMessageHCExperience", () => $2462fe7b54778f08$export$25016be9b5cc2f74);
$parcel$export(module.exports, "omnichannelGreetingMessageExperience", () => $2462fe7b54778f08$export$c63387a0d6893aba);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $2462fe7b54778f08$export$f0696c364409ed69 = new (0, $3odV5.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message', {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $2462fe7b54778f08$export$25016be9b5cc2f74 = new (0, $3odV5.UFOExperience)('service-management.help-center.omnichannel-v2.initial-message.ai', {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $2462fe7b54778f08$export$c63387a0d6893aba = new (0, $3odV5.UFOExperience)('service-management.help-center.omnichannel.greeting-message', {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("leTE5", function(module, exports) {
$parcel$export(module.exports, "useCreateConversationWithMessage", () => $088bec2c82df7148$export$d1fc804b2f86fc4);

var $lyxy2 = parcelRequire("lyxy2");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $gIeP2 = parcelRequire("gIeP2");

var $f2UoR = parcelRequire("f2UoR");

var $8gbjk = parcelRequire("8gbjk");
var $fwXLN = parcelRequire("fwXLN");

var $fj0mX = parcelRequire("fj0mX");

var $h7Yau = parcelRequire("h7Yau");

var $4hXST = parcelRequire("4hXST");

var $cotym = parcelRequire("cotym");

var $4OiHM = parcelRequire("4OiHM");
const $088bec2c82df7148$export$d1fc804b2f86fc4 = ()=>{
    const [commitMutation, isLoading] = (0, $gIeP2.useMutation)((0, $lyxy2.default));
    const environment = (0, $gIeP2.useRelayEnvironment)();
    const handleMutationError = (0, $4fqPo.useCallback)(({ message: message, nodeId: nodeId, connectionId: connectionId, subscriptionId: subscriptionId })=>{
        (0, $4hXST.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: false
        });
        if (!(0, $bG6ob.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $cotym.deleteNodeFromConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: nodeId
        });
        const metadata = {
            connectionId: connectionId,
            subscriptionId: subscriptionId
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4OiHM.createConversationWithMessageExperience).failure({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $fj0mX.initialIntentMessageHCExperience).abort({
            metadata: metadata
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $fj0mX.initialAIMessageHCExperience).abort({
            metadata: metadata
        });
        (0, $h7Yau.addMessageToConnection)({
            message: message,
            environment: environment,
            connectionId: connectionId,
            authorType: 'CombinedAPIError'
        });
    }, [
        environment
    ]);
    const createConversationWithMessage = (0, $4fqPo.useCallback)(({ workspaceAri: workspaceAri, conversationContextAri: conversationContextAri, connectionId: connectionId, onError: onError, message: message, subscriptionId: subscriptionId, isTestConversation: isTestConversation = false })=>{
        const nodeId = (0, $f2UoR.generateUniqueClientID)();
        const content = JSON.stringify((0, $8gbjk.doc)((0, $fwXLN.paragraph)(message)));
        (0, $cotym.addOptimisticResponseToConnection)({
            environment: environment,
            nodeId: nodeId,
            content: content,
            connectionId: connectionId,
            message: message
        });
        (0, $4hXST.updateOmniChannelConversationMeta)({
            environment: environment,
            isReplyPending: true
        });
        (0, $cotym.updateMessageStatusToHelpseeker)({
            environment: environment
        });
        (0, $cotym.resetTimer)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $4OiHM.createConversationWithMessageExperience).start();
        if ((0, $bG6ob.isOmnichannelGreetingAPIEnabled)()) (0, $cotym.addGreetingMessageToConnection)({
            environment: environment,
            connectionId: connectionId,
            nodeId: (0, $f2UoR.generateUniqueClientID)()
        });
        return commitMutation({
            onCompleted: (response)=>{
                var _response$jsmChat, _response$jsmChat2, _response$jsmChat3, _responseData$convers, _responseData$convers3;
                if (!(response !== null && response !== void 0 && (_response$jsmChat = response.jsmChat) !== null && _response$jsmChat !== void 0 && (_response$jsmChat = _response$jsmChat.initializeAndSendMessage) !== null && _response$jsmChat !== void 0 && _response$jsmChat.success) || !(response !== null && response !== void 0 && (_response$jsmChat2 = response.jsmChat) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessage) !== null && _response$jsmChat2 !== void 0 && (_response$jsmChat2 = _response$jsmChat2.initializeAndSendMessageResponse) !== null && _response$jsmChat2 !== void 0 && _response$jsmChat2.conversationId)) {
                    handleMutationError({
                        nodeId: nodeId,
                        message: message,
                        connectionId: connectionId,
                        subscriptionId: subscriptionId
                    });
                    return;
                }
                const responseData = (_response$jsmChat3 = response.jsmChat) === null || _response$jsmChat3 === void 0 || (_response$jsmChat3 = _response$jsmChat3.initializeAndSendMessage) === null || _response$jsmChat3 === void 0 ? void 0 : _response$jsmChat3.initializeAndSendMessageResponse;
                (0, $4hXST.updateOmniChannelConversationMeta)({
                    environment: environment,
                    workspaceAri: workspaceAri,
                    conversationContextAri: conversationContextAri,
                    conversationId: responseData === null || responseData === void 0 ? void 0 : responseData.conversationId
                });
                (0, $cotym.clearTimer)(environment);
                if (responseData.conversationId && (_responseData$convers = responseData.conversation) !== null && _responseData$convers !== void 0 && (_responseData$convers = _responseData$convers.node) !== null && _responseData$convers !== void 0 && _responseData$convers.id) {
                    var _responseData$convers2;
                    (0, $cotym.updateRelayRecordId)({
                        environment: environment,
                        nodeId: nodeId,
                        newId: (_responseData$convers2 = responseData.conversation) === null || _responseData$convers2 === void 0 || (_responseData$convers2 = _responseData$convers2.node) === null || _responseData$convers2 === void 0 ? void 0 : _responseData$convers2.id
                    });
                }
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $4OiHM.createConversationWithMessageExperience).success({
                    metadata: {
                        subscriptionId: subscriptionId,
                        conversationId: (_responseData$convers3 = responseData.conversation) === null || _responseData$convers3 === void 0 || (_responseData$convers3 = _responseData$convers3.node) === null || _responseData$convers3 === void 0 ? void 0 : _responseData$convers3.id
                    }
                });
            },
            onError: (error)=>{
                handleMutationError({
                    nodeId: nodeId,
                    message: message,
                    connectionId: connectionId,
                    subscriptionId: subscriptionId
                });
                onError === null || onError === void 0 || onError(error);
            },
            variables: {
                workspaceAri: workspaceAri,
                conversationContextAri: conversationContextAri,
                subscriptionId: subscriptionId,
                isTestChannel: isTestConversation,
                message: content
            }
        });
    }, [
        commitMutation,
        environment,
        handleMutationError
    ]);
    return {
        isLoading: isLoading,
        createConversationWithMessage: createConversationWithMessage
    };
};

});
parcelRegister("lyxy2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a576adbbc8d42f75$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<14f2364d6978501de330e59cb80b7f3b>>
 * @relayHash 6466481040e3141b45532075b56408d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694
const $a576adbbc8d42f75$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "conversationContextAri"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isTestChannel"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "message"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subscriptionId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "channelExperienceId",
                    "value": "HELPCENTER"
                },
                {
                    "kind": "Variable",
                    "name": "conversationContextAri",
                    "variableName": "conversationContextAri"
                },
                {
                    "kind": "Variable",
                    "name": "isTestChannel",
                    "variableName": "isTestChannel"
                },
                {
                    "kind": "Variable",
                    "name": "message",
                    "variableName": "message"
                },
                {
                    "kind": "Variable",
                    "name": "subscriptionId",
                    "variableName": "subscriptionId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        },
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "workspaceAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "concreteType": "JsmChatInitializeAndSendMessageResponse",
        "kind": "LinkedField",
        "name": "initializeAndSendMessageResponse",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "conversationId"
            },
            {
                "concreteType": "JsmChatMessageEdge",
                "kind": "LinkedField",
                "name": "conversation",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsmChatCreateWebConversationMessage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "content"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "authorType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "contentType"
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "createConversationWithMessageMutation",
            "selections": [
                {
                    "concreteType": "JsmChatMutation",
                    "kind": "LinkedField",
                    "name": "jsmChat",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JsmChatInitializeAndSendMessagePayload",
                            "kind": "LinkedField",
                            "name": "initializeAndSendMessage",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ 
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b1dd5c9d9a158a325624ebe4af55ee2c9f41049eb71382692b4f832b9fa0f694",
            "metadata": {},
            "name": "createConversationWithMessageMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a576adbbc8d42f75$var$node.hash = "b29d0beea262991f003cc1fee9761127";
var $a576adbbc8d42f75$export$2e2bcd8739ae039 = $a576adbbc8d42f75$var$node;

});

parcelRegister("h7Yau", function(module, exports) {
$parcel$export(module.exports, "addMessageToConnection", () => $59cc77a793f825c4$export$8dbc74cf18f1a65e);
$parcel$export(module.exports, "addNodeToConnection", () => $59cc77a793f825c4$export$7163757da5dc49f0);
$parcel$export(module.exports, "addNodeToCurrentConnection", () => $59cc77a793f825c4$export$d88c7883f045ee5);

var $f2UoR = parcelRequire("f2UoR");

var $lnthU = parcelRequire("lnthU");
const $59cc77a793f825c4$export$8dbc74cf18f1a65e = ({ environment: environment, connectionId: connectionId, message: message, authorType: authorType })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const nodeId = `client:jsmChat:conversation:${(0, $lnthU.v4)()}:customMessage:node`;
        const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
        node.setValue(nodeId, 'id');
        node.setValue(authorType, 'authorType');
        if (message) node.setValue(message, 'content');
        node.setValue('ADF', 'contentType');
        node.setValue(null, 'appendices');
        const newEdge = (0, $f2UoR.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
        (0, $f2UoR.ConnectionHandler).insertEdgeAfter(connection, newEdge);
    });
};
const $59cc77a793f825c4$export$7163757da5dc49f0 = ({ store: store, recordId: recordId, connectionId: connectionId, edgeName: edgeName })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $f2UoR.ConnectionHandler).createEdge(store, connection, node, edgeName);
    (0, $f2UoR.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};
const $59cc77a793f825c4$export$d88c7883f045ee5 = ({ store: store, connectionId: connectionId, recordId: recordId })=>{
    const connection = store.get(connectionId);
    if (!connection) return;
    const node = store.get(recordId);
    if (!node) return;
    const newEdge = (0, $f2UoR.ConnectionHandler).createEdge(store, connection, node, 'JsmChatMessageEdge');
    (0, $f2UoR.ConnectionHandler).insertEdgeAfter(connection, newEdge);
};

});

parcelRegister("4hXST", function(module, exports) {
$parcel$export(module.exports, "updateOmniChannelConversationMeta", () => $e850933d2d8b1f62$export$8c33322c5b64f409);
$parcel$export(module.exports, "updateOmniChannelConversationMetaPromise", () => $e850933d2d8b1f62$export$b90325dd8c9d560b);

var $f2UoR = parcelRequire("f2UoR");
const $e850933d2d8b1f62$export$8c33322c5b64f409 = ({ environment: environment, ...remainingParams })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        Object.keys(remainingParams).forEach((key)=>{
            jsmChatQuery.setValue(remainingParams[key], key);
        });
    });
};
const $e850933d2d8b1f62$export$b90325dd8c9d560b = ({ environment: environment, ...remainingParams })=>{
    return new Promise((resolve)=>{
        (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            Object.keys(remainingParams).forEach((key)=>{
                jsmChatQuery.setValue(remainingParams[key], key);
            });
            resolve(undefined);
        });
    });
};

});

parcelRegister("cotym", function(module, exports) {
$parcel$export(module.exports, "cleanFollowups", () => $132a8e5c2f48852c$export$8ce7049bbf52d43c);
$parcel$export(module.exports, "createFollowupMessageNode", () => $132a8e5c2f48852c$export$2e2870a1f1e8fe34);
$parcel$export(module.exports, "generateAIResponseNodeId", () => $132a8e5c2f48852c$export$de38df1b227321b8);
$parcel$export(module.exports, "addOptimisticResponseToConnection", () => $132a8e5c2f48852c$export$fbc4600ca9d78672);
$parcel$export(module.exports, "deleteNodeFromConnection", () => $132a8e5c2f48852c$export$7da93f9af6d9769b);
$parcel$export(module.exports, "updateRelayRecordId", () => $132a8e5c2f48852c$export$1424edefd4c57a66);
$parcel$export(module.exports, "addInteractionMessageToConnection", () => $132a8e5c2f48852c$export$8c802e3a762f0d7b);
$parcel$export(module.exports, "convertInteractionMessageToErrorMessage", () => $132a8e5c2f48852c$export$e868b53e9633f590);
$parcel$export(module.exports, "resetTimer", () => $132a8e5c2f48852c$export$148d61ea341bbff7);
$parcel$export(module.exports, "clearTimer", () => $132a8e5c2f48852c$export$4ffebd63913d6ea0);
$parcel$export(module.exports, "updateLastAIConversationAbortStatus", () => $132a8e5c2f48852c$export$3c299bb7936c424a);
$parcel$export(module.exports, "updateMessageStatusToHelpseeker", () => $132a8e5c2f48852c$export$c179851fb8c72922);
$parcel$export(module.exports, "getInteractionMetaFromNode", () => $132a8e5c2f48852c$export$9a8b1bfde220a901);
$parcel$export(module.exports, "getLastHelpSeekerMessage", () => $132a8e5c2f48852c$export$7d3bdcb2e57adde1);
$parcel$export(module.exports, "setDraftMessage", () => $132a8e5c2f48852c$export$ae6e25e430bcd18b);
$parcel$export(module.exports, "handleActionParamFromSubscription", () => $132a8e5c2f48852c$export$55d3e467a155fb59);
$parcel$export(module.exports, "fetchOmnichannelMeta", () => $132a8e5c2f48852c$export$b0fec83cc7daf9d0);
$parcel$export(module.exports, "getConnectionIdFromStore", () => $132a8e5c2f48852c$export$dd1db642ae57c18e);
$parcel$export(module.exports, "addGreetingMessageToConnection", () => $132a8e5c2f48852c$export$18db76d681ccfece);

var $f2UoR = parcelRequire("f2UoR");

var $iaq2G = parcelRequire("iaq2G");

var $cN04q = parcelRequire("cN04q");

var $fj0mX = parcelRequire("fj0mX");

var $aX2Rf = parcelRequire("aX2Rf");

var $3f1Aj = parcelRequire("3f1Aj");

var $h7Yau = parcelRequire("h7Yau");
const $132a8e5c2f48852c$export$8ce7049bbf52d43c = ({ environment: environment, connectionId: connectionId })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Followup_Message') (0, $f2UoR.ConnectionHandler).deleteNode(connection, node.getDataID());
        });
    });
};
const $132a8e5c2f48852c$export$2e2870a1f1e8fe34 = (content, store)=>{
    const nodeId = (0, $f2UoR.generateUniqueClientID)();
    const followupNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    followupNode.setValue(nodeId, 'id');
    followupNode.setValue('Followup_Message', 'authorType');
    followupNode.setValue(JSON.stringify(content), 'content');
    return nodeId;
};
const $132a8e5c2f48852c$export$de38df1b227321b8 = (id)=>{
    return `client::jsmChat::aiResponse::${id}`;
};
const $132a8e5c2f48852c$export$50d7b649a01ab7a5 = ({ content: content, store: store, nodeId: nodeId, message: message })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue('Reporter', 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    node.setValue(message, 'message');
    return node;
};
const $132a8e5c2f48852c$export$fbc4600ca9d78672 = ({ environment: environment, connectionId: connectionId, content: content, nodeId: nodeId, message: message })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        $132a8e5c2f48852c$export$50d7b649a01ab7a5({
            content: content,
            store: store,
            nodeId: nodeId,
            message: message
        });
        (0, $h7Yau.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $132a8e5c2f48852c$export$7da93f9af6d9769b = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        edges.forEach((edge)=>{
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('id');
            if (authorType === nodeId) {
                (0, $f2UoR.ConnectionHandler).deleteNode(connection, node.getDataID());
                store.delete(node.getDataID());
            }
        });
    });
};
const $132a8e5c2f48852c$export$1424edefd4c57a66 = ({ environment: environment, nodeId: nodeId, newId: newId })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) node.setValue(newId, 'id');
    });
};
const $132a8e5c2f48852c$export$8c802e3a762f0d7b = ({ environment: environment, message: message, nodeId: nodeId, connectionId: connectionId, interactionMeta: interactionMeta })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const node = $132a8e5c2f48852c$export$50d7b649a01ab7a5({
            store: store,
            nodeId: nodeId,
            message: interactionMeta.message,
            content: message
        });
        node.setValue('InteractionMessage', 'authorType');
        node.setValue(JSON.stringify(interactionMeta), 'interactionFieldMeta');
        (0, $h7Yau.addNodeToConnection)({
            store: store,
            connectionId: connectionId,
            recordId: nodeId,
            edgeName: 'JsmChatMessageEdge'
        });
    });
};
const $132a8e5c2f48852c$export$e868b53e9633f590 = ({ nodeId: nodeId, environment: environment, message: message })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (node) {
            node.setValue('InteractionError', 'authorType');
            node.setValue(message, 'content');
        }
    });
};
const $132a8e5c2f48852c$export$148d61ea341bbff7 = ({ environment: environment, expiry: expiry = (0, $cN04q.CHANNEL_EXPIRY_TIME_24HRS), channelMessage: channelMessage = (0, $iaq2G.ChannelMessageTypes).CHANNEL_EXPIRY })=>{
    $132a8e5c2f48852c$export$4ffebd63913d6ea0(environment);
    const timer = setTimeout(()=>{
        (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) return;
            const channelMessageNode = $132a8e5c2f48852c$export$3c157ef8b8581f8d(store, channelMessage);
            (0, $h7Yau.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: channelMessageNode.getDataID(),
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isConversationExpired');
            const connection = store.get(connectionId);
            if (!connection) return;
            const edges = connection.getLinkedRecords('edges');
            if (!edges) return;
            edges.forEach((edge)=>{
                const node = edge.getLinkedRecord('node');
                if (!node) return;
                const authorType = node.getValue('authorType');
                if (authorType === 'Followup_Message') (0, $f2UoR.ConnectionHandler).deleteNode(connection, node.getDataID());
            });
        });
    }, expiry);
    $132a8e5c2f48852c$export$6467bd9f4ef23cb9(environment, timer);
};
const $132a8e5c2f48852c$export$6467bd9f4ef23cb9 = (environment, timer)=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(timer, 'timer');
    });
};
const $132a8e5c2f48852c$export$4ffebd63913d6ea0 = (environment)=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const timerId = jsmChatQuery.getValue('timer') ?? 0;
        clearTimeout(timerId);
    });
};
const $132a8e5c2f48852c$export$3c157ef8b8581f8d = (store, type)=>{
    const nodeId = (0, $f2UoR.generateUniqueClientID)();
    const channelMessageNode = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    channelMessageNode.setValue(nodeId, 'id');
    channelMessageNode.setValue('ChannelMessage', 'authorType');
    channelMessageNode.setValue(type, 'content');
    return channelMessageNode;
};
const $132a8e5c2f48852c$export$3c299bb7936c424a = ({ environment: environment, status: status })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        if (!connectionId) return;
        const connection = store.get(connectionId);
        if (!connection) return;
        const edges = connection.getLinkedRecords('edges');
        if (!edges) return;
        for (const edge of edges.reverse()){
            const node = edge.getLinkedRecord('node');
            if (!node) return;
            const authorType = node.getValue('authorType');
            if (authorType === 'Assistant_Message') {
                const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
                assistantMessageNode.setValue(status, 'isAborted');
                return;
            }
        }
    });
};
const $132a8e5c2f48852c$export$c179851fb8c72922 = ({ environment: environment })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue((0, $aX2Rf.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
    });
};
const $132a8e5c2f48852c$export$4941c3f3a49f3f68 = ({ environment: environment, nodeId: nodeId, action: action })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(nodeId);
        if (!node) return;
        node.setValue(action, 'action');
    });
};
const $132a8e5c2f48852c$export$9a8b1bfde220a901 = ({ environment: environment, nodeId: nodeId })=>{
    return new Promise((resolve, reject)=>{
        (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
            const node = store.get(nodeId);
            if (!node) {
                reject(new Error('No Node found'));
                return;
            }
            const interactionMeta = node === null || node === void 0 ? void 0 : node.getValue('interactionFieldMeta');
            if (!interactionMeta) {
                reject(new Error('No InteractionMeta found'));
                return;
            }
            resolve((0, $3f1Aj.parseJson)(interactionMeta));
        });
    });
};
const $132a8e5c2f48852c$export$7d3bdcb2e57adde1 = ({ environment: environment })=>{
    return new Promise((resolve, reject)=>{
        (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const connectionId = jsmChatQuery.getValue('connectionId');
            if (!connectionId) {
                reject(new Error('No ConnectionID Found'));
                return;
            }
            const connection = store.get(connectionId);
            if (!connection) {
                reject(new Error('No Connection Found'));
                return;
            }
            const edges = connection.getLinkedRecords('edges');
            if (!edges) {
                reject(new Error('No Messages Found'));
                return;
            }
            for (const edge of edges.reverse()){
                const node = edge.getLinkedRecord('node');
                const authorType = node === null || node === void 0 ? void 0 : node.getValue('authorType');
                if (authorType === 'Reporter') {
                    resolve(node === null || node === void 0 ? void 0 : node.getValue('message'));
                    return;
                }
            }
        });
    });
};
const $132a8e5c2f48852c$export$ae6e25e430bcd18b = ({ environment: environment, message: message })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(message, 'draftMessage');
    });
};
const $132a8e5c2f48852c$export$55d3e467a155fb59 = ({ action: action, environment: environment, nodeId: nodeId, connectionId: connectionId })=>{
    // oxlint-disable-next-line default-case
    switch(action){
        case 'REDIRECT_TO_SEARCH':
            $132a8e5c2f48852c$export$4941c3f3a49f3f68({
                environment: environment,
                nodeId: nodeId,
                action: action
            });
            break;
        case 'CLOSE_CONVERSATION':
            $132a8e5c2f48852c$export$148d61ea341bbff7({
                environment: environment,
                expiry: 0,
                channelMessage: (0, $iaq2G.ChannelMessageTypes).CHANNEL_CONVERSATION_OVER
            });
            break;
        case 'DISABLE_INPUT':
            if (connectionId) {
                $132a8e5c2f48852c$export$8ce7049bbf52d43c({
                    environment: environment,
                    connectionId: connectionId
                });
                $132a8e5c2f48852c$export$ede71f104937b4ea(environment, true);
            }
            break;
    }
};
const $132a8e5c2f48852c$export$ede71f104937b4ea = (environment, status)=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        jsmChatQuery.setValue(status, 'disableInput');
    });
};
const $132a8e5c2f48852c$export$b0fec83cc7daf9d0 = (environment)=>{
    return new Promise((resolve, reject)=>{
        (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            if (!root) reject(new Error('No Root Found'));
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const conversationId = jsmChatQuery.getValue('conversationId');
            const connectionId = jsmChatQuery.getValue('connectionId');
            const conversationContextAri = jsmChatQuery.getValue('conversationContextAri');
            const hasMessage = jsmChatQuery.getValue('hasMessage');
            const isReplyPending = jsmChatQuery.getValue('isReplyPending');
            const aiAnswerStatus = jsmChatQuery.getValue('aiAnswerStatus');
            const draftMessage = jsmChatQuery.getValue('draftMessage');
            const isConversationExpired = jsmChatQuery.getValue('isConversationExpired');
            const isConversationClosed = jsmChatQuery.getValue('isConversationClosed');
            const disableInput = jsmChatQuery.getValue('disableInput');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            const greetingMessage = jsmChatQuery.getValue('greetingMessage');
            const subscriptionTriggered = jsmChatQuery.getValue('subscriptionTriggered');
            subscriptionTriggered;
            resolve({
                conversationId: conversationId,
                connectionId: connectionId,
                conversationContextAri: conversationContextAri,
                hasMessage: hasMessage,
                isReplyPending: isReplyPending,
                aiAnswerStatus: aiAnswerStatus,
                draftMessage: draftMessage,
                isConversationExpired: isConversationExpired,
                isConversationClosed: isConversationClosed,
                disableInput: disableInput,
                subscriptionId: subscriptionId,
                greetingMessage: greetingMessage,
                subscriptionTriggered: subscriptionTriggered
            });
        });
    });
};
const $132a8e5c2f48852c$export$dd1db642ae57c18e = (store)=>{
    const root = store.getRoot();
    const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
    return jsmChatQuery.getValue('connectionId');
};
const $132a8e5c2f48852c$export$87805a37c19b2fb7 = ({ content: content, store: store, nodeId: nodeId, authorType: authorType })=>{
    const node = store.create(nodeId, 'JsmChatCreateWebConversationMessage');
    node.setValue(nodeId, 'id');
    node.setValue(authorType, 'authorType');
    node.setValue(content, 'content');
    node.setValue('ADF', 'contentType');
    node.setValue(null, 'appendices');
    return node;
};
const $132a8e5c2f48852c$export$18db76d681ccfece = ({ environment: environment, connectionId: connectionId, nodeId: nodeId })=>{
    (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const content = jsmChatQuery.getValue('greetingMessage') ?? '';
        const isGreetingMessageAdded = jsmChatQuery.getValue('isGreetingMessageAdded') ?? false;
        if (!isGreetingMessageAdded) {
            const authorType = content !== '' ? 'VirtualAgent' : 'GreetingMessage';
            $132a8e5c2f48852c$export$87805a37c19b2fb7({
                content: content,
                store: store,
                nodeId: nodeId,
                authorType: authorType
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $fj0mX.omnichannelGreetingMessageExperience).success({
                metadata: {
                    connectionId: connectionId,
                    conversationId: jsmChatQuery.getValue('conversationId') ?? ''
                }
            });
            (0, $h7Yau.addNodeToConnection)({
                store: store,
                connectionId: connectionId,
                recordId: nodeId,
                edgeName: 'JsmChatMessageEdge'
            });
            jsmChatQuery.setValue(true, 'isGreetingMessageAdded');
        }
    });
};

});
parcelRegister("cN04q", function(module, exports) {
$parcel$export(module.exports, "MAX_CHARS", () => $4c7a41fffaab9876$export$3fd15502aa7f615e);
$parcel$export(module.exports, "CHANNEL_EXPIRY_TIME_24HRS", () => $4c7a41fffaab9876$export$76a18595b547627f);
const $4c7a41fffaab9876$export$3fd15502aa7f615e = 1000; // Used in Input component
const $4c7a41fffaab9876$export$10482ada0e471d1d = 300000; // 5mins
const $4c7a41fffaab9876$export$76a18595b547627f = 86400000; // 24 Hrs

});

parcelRegister("aX2Rf", function(module, exports) {
$parcel$export(module.exports, "HelpSeekerMessageStatus", () => $d0c7b89abf899520$export$2cdf090c2d29ef5f);
var $d0c7b89abf899520$export$2cdf090c2d29ef5f = /*#__PURE__*/ function(HelpSeekerMessageStatus) {
    HelpSeekerMessageStatus["IDLE"] = "helpseeker_idle";
    return HelpSeekerMessageStatus;
}({});

});

parcelRegister("3f1Aj", function(module, exports) {
$parcel$export(module.exports, "parseJson", () => $eb342225540ec47b$export$18c43dcebf00e571);
$parcel$export(module.exports, "isMessageGenerated", () => $eb342225540ec47b$export$c2e15cdb6fbfcd43);

var $iaq2G = parcelRequire("iaq2G");

var $aX2Rf = parcelRequire("aX2Rf");
const $eb342225540ec47b$export$18c43dcebf00e571 = (value)=>{
    try {
        return typeof value === 'string' ? JSON.parse(value) : undefined;
    } catch (e) {
        return undefined;
    }
};
const $eb342225540ec47b$export$c2e15cdb6fbfcd43 = (status)=>{
    if (!status) return true;
    if (status === (0, $aX2Rf.HelpSeekerMessageStatus).IDLE) return true;
    return [
        (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).IDLE,
        (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE
    ].indexOf(status) !== -1;
};

});


parcelRegister("4OiHM", function(module, exports) {
$parcel$export(module.exports, "createConversationWithMessageExperience", () => $3f3d6f142d57a9ed$export$bcb43460f5483389);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $3f3d6f142d57a9ed$var$createConversationWithMessageExperienceId = 'service-management.help-center.omnichannel.combined-api';
const $3f3d6f142d57a9ed$export$bcb43460f5483389 = new (0, $3odV5.UFOExperience)($3f3d6f142d57a9ed$var$createConversationWithMessageExperienceId, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("85azw", function(module, exports) {
$parcel$export(module.exports, "establishSubscriptionToOmnichannel", () => $f9bf17242441aba2$export$190438bc49e7cd0e);

var $esNV8 = parcelRequire("esNV8");

var $bG6ob = parcelRequire("bG6ob");

var $f2UoR = parcelRequire("f2UoR");

var $43OzE = parcelRequire("43OzE");

var $H2A0Q = parcelRequire("H2A0Q");

var $fj0mX = parcelRequire("fj0mX");

var $3f1Aj = parcelRequire("3f1Aj");

var $h7Yau = parcelRequire("h7Yau");

var $3CqeZ = parcelRequire("3CqeZ");

var $4hXST = parcelRequire("4hXST");

var $cotym = parcelRequire("cotym");

var $9Q0Ul = parcelRequire("9Q0Ul");
const $f9bf17242441aba2$var$SubscriptionGL = (0, $esNV8.default);
const $f9bf17242441aba2$export$190438bc49e7cd0e = ({ environment: environment, subscriptionId: subscriptionId })=>{
    const metadata = {
        subscriptionId: subscriptionId
    };
    (0, $9Q0Ul.subscriptionConnectionExperience).start();
    return (0, $f2UoR.requestSubscription)(environment, {
        onError: (error)=>{
            if ((0, $bG6ob.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $4hXST.updateOmniChannelConversationMeta)({
                environment: environment,
                subscriptionStatus: 'FAILED'
            });
            (0, $fj0mX.initialAIMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $fj0mX.initialIntentMessageHCExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $9Q0Ul.subscriptionConnectionExperience).failure({
                metadata: {
                    ...metadata,
                    error: error.message
                }
            });
            (0, $H2A0Q.sendErrorEvent)({
                error: error,
                actionSubject: 'omnichannelSubscription',
                attributes: {
                    ...metadata
                }
            });
        },
        onNext: (data)=>{
            var _data$jsmChat, _data$jsmChat2, _data$jsmChat6, _node$content;
            if ((data === null || data === void 0 || (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.updateConversation) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.result) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__typename) === 'JsmChatWebSubscriptionEstablishedPayload') {
                if ((0, $bG6ob.isOmnichannelSubscriptionErrorpageEnabled)()) (0, $4hXST.updateOmniChannelConversationMeta)({
                    environment: environment,
                    subscriptionStatus: 'ACTIVE'
                });
                (0, $9Q0Ul.subscriptionConnectionExperience).success({
                    metadata: metadata
                });
                return;
            }
            if ((data === null || data === void 0 || (_data$jsmChat2 = data.jsmChat) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.updateConversation) === null || _data$jsmChat2 === void 0 || (_data$jsmChat2 = _data$jsmChat2.result) === null || _data$jsmChat2 === void 0 ? void 0 : _data$jsmChat2.__typename) === 'JsmChatWebConversationUpdateQueryError') {
                var _data$jsmChat3, _data$jsmChat4, _data$jsmChat5;
                (0, $H2A0Q.sendErrorEvent)({
                    error: new Error((data === null || data === void 0 || (_data$jsmChat3 = data.jsmChat) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.updateConversation) === null || _data$jsmChat3 === void 0 || (_data$jsmChat3 = _data$jsmChat3.result) === null || _data$jsmChat3 === void 0 ? void 0 : _data$jsmChat3.message) ?? 'Payload Error in Subscription'),
                    actionSubject: 'omnichannelSubscription',
                    attributes: {
                        ...metadata
                    }
                });
                (0, $fj0mX.initialIntentMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat4 = data.jsmChat) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.updateConversation) === null || _data$jsmChat4 === void 0 || (_data$jsmChat4 = _data$jsmChat4.result) === null || _data$jsmChat4 === void 0 ? void 0 : _data$jsmChat4.message) ?? 'Payload Error in Subscription'
                    }
                });
                (0, $fj0mX.initialAIMessageHCExperience).failure({
                    metadata: {
                        ...metadata,
                        error: (data === null || data === void 0 || (_data$jsmChat5 = data.jsmChat) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.updateConversation) === null || _data$jsmChat5 === void 0 || (_data$jsmChat5 = _data$jsmChat5.result) === null || _data$jsmChat5 === void 0 ? void 0 : _data$jsmChat5.message) ?? 'Payload Error in Subscription'
                    }
                });
            }
            if (!(data !== null && data !== void 0 && (_data$jsmChat6 = data.jsmChat) !== null && _data$jsmChat6 !== void 0 && (_data$jsmChat6 = _data$jsmChat6.updateConversation) !== null && _data$jsmChat6 !== void 0 && _data$jsmChat6.conversation)) {
                (0, $4hXST.updateOmniChannelConversationMeta)({
                    environment: environment,
                    isReplyPending: false
                });
                return;
            }
            const node = data.jsmChat.updateConversation.conversation.node;
            if (!node) return;
            const recordId = (0, $43OzE.getRelayDataId)(node === null || node === void 0 ? void 0 : node.id, 'JsmChatCreateWebConversationMessage');
            const action = data.jsmChat.updateConversation.action;
            (0, $cotym.handleActionParamFromSubscription)({
                action: action,
                environment: environment,
                connectionId: undefined,
                nodeId: recordId
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((_node$content = node.content) !== null && _node$content !== void 0 && _node$content.aiResponse) {
                var _node$content2;
                (0, $fj0mX.initialAIMessageHCExperience).success({
                    metadata: metadata
                });
                (0, $fj0mX.initialIntentMessageHCExperience).abort({
                    metadata: {
                        ...metadata,
                        actionSubject: 'aiReceived'
                    }
                });
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                const aiResponse = (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.aiResponse;
                const aiResponseNodeId = (0, $cotym.generateAIResponseNodeId)(recordId);
                (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
                    let aiResponseNode = store.get(aiResponseNodeId);
                    if (!aiResponseNode) {
                        aiResponseNode = store.create(aiResponseNodeId, 'JsmChatCreateWebConversationMessage');
                        aiResponseNode.setValue(aiResponseNodeId, 'id');
                        aiResponseNode.setValue('Assistant_Message', 'authorType');
                        const connectionId = (0, $cotym.getConnectionIdFromStore)(store);
                        if (connectionId) (0, $h7Yau.addNodeToCurrentConnection)({
                            store: store,
                            connectionId: connectionId,
                            recordId: aiResponseNodeId
                        });
                    }
                    store.delete(recordId);
                });
                const streamingMessages = (0, $3f1Aj.parseJson)(aiResponse);
                streamingMessages === null || streamingMessages === void 0 || streamingMessages.forEach((streamingMessage)=>{
                    (0, $3CqeZ.updateStreamingMessageInStore)({
                        environment: environment,
                        streamingMessage: streamingMessage,
                        connectionId: undefined,
                        recordId: aiResponseNodeId
                    });
                });
            } else {
                if (!action || action !== 'GREETING_MESSAGE') {
                    (0, $fj0mX.initialIntentMessageHCExperience).success({
                        metadata: metadata
                    });
                    (0, $fj0mX.initialAIMessageHCExperience).abort({
                        metadata: {
                            ...metadata,
                            actionSubject: 'intentReceived'
                        }
                    });
                }
                (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
                    const connectionId = (0, $cotym.getConnectionIdFromStore)(store);
                    if (connectionId) (0, $h7Yau.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: recordId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                });
            }
            if (!action || action !== 'GREETING_MESSAGE') (0, $4hXST.updateOmniChannelConversationMeta)({
                environment: environment,
                isReplyPending: false
            });
        },
        subscription: $f9bf17242441aba2$var$SubscriptionGL,
        variables: {
            conversationId: subscriptionId
        }
    });
};

});
parcelRegister("esNV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $7384bdabc11a4fdf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<98280c1b5202d924d397fb90d5594f34>>
 * @relayHash 66ceed11481c815b912f0ffeaa5b68cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0
const $7384bdabc11a4fdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "label"
    }, v4 = [
        {
            "concreteType": "JsmChatSubscription",
            "kind": "LinkedField",
            "name": "jsmChat",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "conversationId",
                            "variableName": "conversationId"
                        }
                    ],
                    "concreteType": "JsmChatWebSubscriptionResponse",
                    "kind": "LinkedField",
                    "name": "updateConversation",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "result",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v2 /*: any*/ 
                                    ],
                                    "type": "JsmChatWebSubscriptionEstablishedPayload"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "JsmChatWebConversationUpdateQueryError"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "concreteType": "JsmChatMessageEdge",
                            "kind": "LinkedField",
                            "name": "conversation",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "authorType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "content"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentType"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "appendices",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "requestTypeId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jiraProjectId"
                                                        }
                                                    ],
                                                    "type": "JsmChatJiraFieldAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                    "kind": "LinkedField",
                                                                    "name": "redirectAction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "baseUrl"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "query"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatOptionAppendix"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "placeholder"
                                                        },
                                                        {
                                                            "concreteType": "JsmChatAppendixActionItem",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JsmChatDropdownAppendix"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "communicationChannelSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "d34ae9e8c9280f0a73c58fb2cb42bc0412029875ab15059a0b814fd3380e50d0",
            "metadata": {},
            "name": "communicationChannelSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$7384bdabc11a4fdf$var$node.hash = "44da5305c7ec49b7ef2bab1de243b217";
var $7384bdabc11a4fdf$export$2e2bcd8739ae039 = $7384bdabc11a4fdf$var$node;

});

parcelRegister("3CqeZ", function(module, exports) {
$parcel$export(module.exports, "updateStreamingMessageInStore", () => $7ceb984457cfbbe0$export$648f4e23156d6dfe);

var $bG6ob = parcelRequire("bG6ob");

var $gIeP2 = parcelRequire("gIeP2");

var $2y9yg = parcelRequire("2y9yg");

var $iaq2G = parcelRequire("iaq2G");

var $aX2Rf = parcelRequire("aX2Rf");

var $3f1Aj = parcelRequire("3f1Aj");

var $h7Yau = parcelRequire("h7Yau");

var $cotym = parcelRequire("cotym");
const $7ceb984457cfbbe0$var$getMessageMetaFromStore = (assistantMessage, recordId)=>{
    const DEFAULT_ASSISNTANT_MESSAGE = {
        status: (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).AWAITING_RESPONSE,
        messageId: recordId
    };
    if (!assistantMessage) return DEFAULT_ASSISNTANT_MESSAGE;
    const messageMeta = assistantMessage === null || assistantMessage === void 0 ? void 0 : assistantMessage.getValue('message_metaData');
    try {
        return (0, $3f1Aj.parseJson)(messageMeta) ?? DEFAULT_ASSISNTANT_MESSAGE;
    } catch  {
        return DEFAULT_ASSISNTANT_MESSAGE;
    }
};
const $7ceb984457cfbbe0$export$648f4e23156d6dfe = ({ environment: environment, recordId: recordId, streamingMessage: streamingMessage })=>{
    (0, $gIeP2.commitLocalUpdate)(environment, (store)=>{
        const node = store.get(recordId);
        const assistantMessageNode = node === null || node === void 0 ? void 0 : node.getOrCreateLinkedRecord('assistantMessage', 'JsmChatAssistantMessage');
        const messageContent = (assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('content')) ?? '';
        const root = store.getRoot();
        const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
        const connectionId = jsmChatQuery.getValue('connectionId');
        const { type: type, content: content } = (0, $2y9yg.getUHUpdatedMessage)(streamingMessage, {
            content: messageContent,
            role: '',
            id: '0',
            time_created: '',
            user_ari: '',
            plugin_invocations: []
        }) ?? {
            type: ''
        };
        const metaData = $7ceb984457cfbbe0$var$getMessageMetaFromStore(assistantMessageNode, recordId);
        // AI Conversation can be aborted from `stopGenerating` CTA in Input Box
        const abortStatus = assistantMessageNode === null || assistantMessageNode === void 0 ? void 0 : assistantMessageNode.getValue('isAborted');
        if (abortStatus) {
            metaData.status = (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE;
            jsmChatQuery.setValue((0, $iaq2G.ASSISTANT_MESSAGE_STATUS).ABORTED_RESPONSE, 'aiAnswerStatus');
            assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
            return;
        }
        switch(type){
            case 'FOLLOW_UP_QUERIES':
                if ((0, $bG6ob.isFollowupEnabledForPortal)()) {
                    const nodeId = (0, $cotym.createFollowupMessageNode)(content, store);
                    (0, $h7Yau.addNodeToConnection)({
                        store: store,
                        connectionId: connectionId,
                        recordId: nodeId,
                        edgeName: 'JsmChatMessageEdge'
                    });
                }
                break;
            case 'CONTENT_SEARCH':
                metaData.keywords = content.split('|');
                metaData.status = (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                jsmChatQuery.setValue((0, $iaq2G.ASSISTANT_MESSAGE_STATUS).LOADING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'ANALYSING_STATE':
                metaData.sources = content;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                break;
            case 'ANSWER_PART':
                metaData.status = (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE;
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(content.content, 'content');
                jsmChatQuery.setValue((0, $iaq2G.ASSISTANT_MESSAGE_STATUS).TYPING_RESPONSE, 'aiAnswerStatus');
                break;
            case 'FINAL_RESPONSE':
                {
                    var _aiMetaData$message_m;
                    const aiMetaData = content;
                    metaData.status = (0, $iaq2G.ASSISTANT_MESSAGE_STATUS).IDLE;
                    metaData.messageId = aiMetaData.id.toString();
                    const isFallbackMessage = !!((_aiMetaData$message_m = aiMetaData.message_metadata) !== null && _aiMetaData$message_m !== void 0 && _aiMetaData$message_m.isFallbackMessage);
                    metaData.showFeedback = !isFallbackMessage;
                    metaData.isFallbackMessage = isFallbackMessage;
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(content.plugin_invocations), 'pluginInvocation');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(metaData), 'message_metaData');
                    assistantMessageNode === null || assistantMessageNode === void 0 || assistantMessageNode.setValue(JSON.stringify(aiMetaData), 'aiMateConversationResponse');
                    jsmChatQuery.setValue((0, $iaq2G.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                    if (isFallbackMessage) {
                        node === null || node === void 0 || node.setValue('Init', 'authorType');
                        jsmChatQuery.setValue((0, $aX2Rf.HelpSeekerMessageStatus).IDLE, 'aiAnswerStatus');
                    }
                    break;
                }
            case 'ERROR':
                node === null || node === void 0 || node.setValue('Assistant_Error', 'authorType');
                jsmChatQuery.setValue((0, $iaq2G.ASSISTANT_MESSAGE_STATUS).IDLE, 'aiAnswerStatus');
                node === null || node === void 0 || node.setValue(null, 'content');
                break;
            default:
                break;
        }
    });
};

});

parcelRegister("9Q0Ul", function(module, exports) {
$parcel$export(module.exports, "subscriptionConnectionExperience", () => $b87a0b020d2f8f00$export$1c1eb834db2f7128);
$parcel$export(module.exports, "omnichannelPageLoadExperience", () => $b87a0b020d2f8f00$export$4feb855a2be04fbe);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $b87a0b020d2f8f00$export$1c1eb834db2f7128 = new (0, $3odV5.UFOExperience)('service-management.help-center.omnichannel-v2.subscription-connection', {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $b87a0b020d2f8f00$export$4feb855a2be04fbe = new (0, $3odV5.UFOExperience)('service-management.help-center.omnichannel-v2.page-load', {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("9RoiU", function(module, exports) {
$parcel$export(module.exports, "generateUniqueSubscriptionID", () => $f29cd5bcae05f463$export$b84750da6cd46f95);

var $6mmHn = parcelRequire("6mmHn");

var $f2UoR = parcelRequire("f2UoR");

var $lnthU = parcelRequire("lnthU");
const $f29cd5bcae05f463$export$b84750da6cd46f95 = ({ environment: environment })=>{
    return new Promise((resolve)=>{
        (0, $f2UoR.commitLocalUpdate)(environment, (store)=>{
            const root = store.getRoot();
            const jsmChatQuery = root.getOrCreateLinkedRecord('jsmChatConversationMeta', 'JsmChatConversationMeta');
            const subscriptionId = jsmChatQuery.getValue('subscriptionId');
            if (!subscriptionId) {
                const newSubscriptionID = `ari:cloud:conversational-help:${(0, $6mmHn.getCloudId)()}:conversation/${(0, $lnthU.v4)()}`;
                jsmChatQuery.setValue(newSubscriptionID, 'subscriptionId');
                jsmChatQuery.setValue(null, 'connectionId');
                resolve(newSubscriptionID);
            }
            resolve(subscriptionId);
        });
    });
};

});

parcelRegister("lMF78", function(module, exports) {
$parcel$export(module.exports, "useSubscriptionStore", () => $53ae48d7b26cd23e$export$554946cac481f18a);
$parcel$export(module.exports, "useSubscriptionAction", () => $53ae48d7b26cd23e$export$b9e415294ecd1592);

var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $jGLAo = parcelRequire("jGLAo");
const $53ae48d7b26cd23e$var$initialState = {
    subscription: {
        dispose: ()=>undefined
    }
};
const $53ae48d7b26cd23e$var$store = (0, $2RDzF.createStore)({
    actions: $jGLAo.actions,
    initialState: $53ae48d7b26cd23e$var$initialState,
    name: 'OmnichannelSubscriptionStore'
});
const $53ae48d7b26cd23e$export$554946cac481f18a = (0, $iouul.createHook)($53ae48d7b26cd23e$var$store);
const $53ae48d7b26cd23e$export$b9e415294ecd1592 = (0, $iouul.createActionsHook)($53ae48d7b26cd23e$var$store);

});
parcelRegister("jGLAo", function(module, exports) {
$parcel$export(module.exports, "actions", () => $1b236c52a5be8db0$export$e324594224ef24da);

var $gxBa2 = parcelRequire("gxBa2");
const $1b236c52a5be8db0$export$e324594224ef24da = {
    setSubscriptionDisposer: $gxBa2.setSubscriptionDisposer
};

});
parcelRegister("gxBa2", function(module, exports) {
$parcel$export(module.exports, "setSubscriptionDisposer", () => $712859033e6bdd98$export$398a2526d7502a0f);
const $712859033e6bdd98$export$398a2526d7502a0f = (disposable)=>({ setState: setState })=>{
        setState({
            subscription: disposable
        });
    };

});



parcelRegister("j0nbS", function(module, exports) {
$parcel$export(module.exports, "OmnichannelClientConnection", () => $f239a11454bc8748$export$ca9674c8e6a24427);

var $22VjS = parcelRequire("22VjS");

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $gMSZD = parcelRequire("gMSZD");

var $63sfu = parcelRequire("63sfu");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $gIeP2 = parcelRequire("gIeP2");

var $ek2xT = parcelRequire("ek2xT");

var $4hXST = parcelRequire("4hXST");

var $3krHC = parcelRequire("3krHC");
var $7hsFm = parcelRequire("7hsFm");

var $9RoiU = parcelRequire("9RoiU");

var $iIiTs = parcelRequire("iIiTs");
const $f239a11454bc8748$export$8bbd1b8324c70f51 = ()=>{
    var _data$jsmChat;
    const metaData = (0, $ek2xT.useOmnichannelMetaQuery)();
    const subscriptionId = metaData.subscriptionId;
    (0, $7hsFm.useUFOComponentExperience)((0, $iIiTs.omnichannelGetConversationExperience));
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $22VjS.default), {
        conversationId: subscriptionId ?? '',
        isEmptyConversation: !subscriptionId
    });
    const newConnectionId = (_data$jsmChat = data.jsmChat) === null || _data$jsmChat === void 0 || (_data$jsmChat = _data$jsmChat.getWebConversation) === null || _data$jsmChat === void 0 ? void 0 : _data$jsmChat.__id;
    const environment = (0, $gIeP2.useRelayEnvironment)();
    (0, $4fqPo.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $9RoiU.generateUniqueSubscriptionID)({
            environment: environment
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $iIiTs.omnichannelGetConversationExperience).start();
    }, [
        environment
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (newConnectionId && metaData.connectionId !== newConnectionId) (0, $4hXST.updateOmniChannelConversationMeta)({
            environment: environment,
            connectionId: newConnectionId
        });
    }, [
        environment,
        metaData.connectionId,
        newConnectionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $iIiTs.omnichannelGetConversationExperience)
    });
};
const $f239a11454bc8748$export$ca9674c8e6a24427 = ({ renderError: renderError })=>{
    const onError = (0, $4fqPo.useCallback)((error)=>{
        (0, $iIiTs.omnichannelGetConversationExperience).failure({
            metadata: {
                error: error === null || error === void 0 ? void 0 : error.message,
                statusCode: error === null || error === void 0 ? void 0 : error.status
            }
        }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).CONVERSATION_PAGE,
        id: "omnichannel-helpcenter-conversation",
        onError: onError,
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f239a11454bc8748$export$8bbd1b8324c70f51, null)));
};

});
parcelRegister("22VjS", function(module, exports) {
$parcel$export(module.exports, "default", () => $760d69dc76c513ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b88b33f9954ab0bdeac663c7a0d645e2>>
 * @relayHash f6c352f48eeebb85cf0c9fbc89dbddb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319
const $760d69dc76c513ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "conversationId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isEmptyConversation"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            }
        ]
    }, v6 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "last",
            "value": 1
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "content"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "label"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": "getWebConversation",
                                    "args": [
                                        v1 /*: any*/ 
                                    ],
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "__Connection__getWebConversation_connection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "messageRendererFragment"
                                                },
                                                v3 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "omnichannelClientConnectionQuery",
            "selections": [
                {
                    "condition": "isEmptyConversation",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "concreteType": "JsmChatQuery",
                            "kind": "LinkedField",
                            "name": "jsmChat",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "JsmChatMessageConnection",
                                    "kind": "LinkedField",
                                    "name": "getWebConversation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsmChatMessageEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "concreteType": "JsmChatCreateWebConversationMessage",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "authorType"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "action"
                                                                },
                                                                {
                                                                    "concreteType": "JsmChatAssistantMessage",
                                                                    "kind": "LinkedField",
                                                                    "name": "assistantMessage",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pluginInvocation"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "aiMateConversationResponse"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "message_metaData"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "appendices",
                                                            "plural": true,
                                                            "selections": [
                                                                v2 /*: any*/ ,
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isJsmChatConversationAppendixAction"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatDropdownAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "requestTypeId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraProjectId"
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatJiraFieldAppendix"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JsmChatAppendixActionItem",
                                                                            "kind": "LinkedField",
                                                                            "name": "options",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JsmChatAppendixRedirectAction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "redirectAction",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "baseUrl"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "query"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "JsmChatOptionAppendix"
                                                                },
                                                                v4 /*: any*/ 
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        v5 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v6 /*: any*/ ,
                                    "filters": [
                                        "conversationId"
                                    ],
                                    "handle": "connection",
                                    "key": "Connection__getWebConversation",
                                    "kind": "LinkedHandle",
                                    "name": "getWebConversation"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4e8801d6cc9f23bf8354598a09093970032c0e0c52119c549c1b54f759bd1319",
            "metadata": {
                "connection": [
                    {
                        "count": null,
                        "cursor": null,
                        "direction": "backward",
                        "path": [
                            "jsmChat",
                            "getWebConversation"
                        ]
                    }
                ]
            },
            "name": "omnichannelClientConnectionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$760d69dc76c513ec$var$node.hash = "8ddd798333f81ebc8a31a378348e8046";
var $760d69dc76c513ec$export$2e2bcd8739ae039 = $760d69dc76c513ec$var$node;

});

parcelRegister("ek2xT", function(module, exports) {
$parcel$export(module.exports, "useOmnichannelMetaQuery", () => $323e5865fa0e7954$export$bc28f1e9de226671);

var $fIy8w = parcelRequire("fIy8w");

var $gIeP2 = parcelRequire("gIeP2");
const $323e5865fa0e7954$export$bc28f1e9de226671 = ()=>{
    var _data$jsmChatConversa, _data$jsmChatConversa2, _data$jsmChatConversa3, _data$jsmChatConversa4, _data$jsmChatConversa5, _data$jsmChatConversa6, _data$jsmChatConversa7, _data$jsmChatConversa8, _data$jsmChatConversa9, _data$jsmChatConversa0, _data$jsmChatConversa1, _data$jsmChatConversa10, _data$jsmChatConversa11;
    const data = (0, $gIeP2.useClientQuery)((0, $fIy8w.default), {});
    return {
        conversationId: data === null || data === void 0 || (_data$jsmChatConversa = data.jsmChatConversationMeta) === null || _data$jsmChatConversa === void 0 ? void 0 : _data$jsmChatConversa.conversationId,
        conversationContextAri: data === null || data === void 0 || (_data$jsmChatConversa2 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa2 === void 0 ? void 0 : _data$jsmChatConversa2.conversationContextAri,
        workspaceAri: data === null || data === void 0 || (_data$jsmChatConversa3 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa3 === void 0 ? void 0 : _data$jsmChatConversa3.workspaceAri,
        connectionId: data === null || data === void 0 || (_data$jsmChatConversa4 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa4 === void 0 ? void 0 : _data$jsmChatConversa4.connectionId,
        isReplyPending: !!(data !== null && data !== void 0 && (_data$jsmChatConversa5 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa5 !== void 0 && _data$jsmChatConversa5.isReplyPending),
        isConversationExpired: !!(data !== null && data !== void 0 && (_data$jsmChatConversa6 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa6 !== void 0 && _data$jsmChatConversa6.isConversationExpired),
        aiAnswerStatus: data === null || data === void 0 || (_data$jsmChatConversa7 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa7 === void 0 ? void 0 : _data$jsmChatConversa7.aiAnswerStatus,
        isConversationClosed: !!(data !== null && data !== void 0 && (_data$jsmChatConversa8 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa8 !== void 0 && _data$jsmChatConversa8.isConversationClosed),
        draftMessage: data === null || data === void 0 || (_data$jsmChatConversa9 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa9 === void 0 ? void 0 : _data$jsmChatConversa9.draftMessage,
        disableInput: !!(data !== null && data !== void 0 && (_data$jsmChatConversa0 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa0 !== void 0 && _data$jsmChatConversa0.disableInput),
        subscriptionId: data === null || data === void 0 || (_data$jsmChatConversa1 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa1 === void 0 ? void 0 : _data$jsmChatConversa1.subscriptionId,
        subscriptionTriggered: !!(data !== null && data !== void 0 && (_data$jsmChatConversa10 = data.jsmChatConversationMeta) !== null && _data$jsmChatConversa10 !== void 0 && _data$jsmChatConversa10.subscriptionTriggered),
        subscriptionStatus: (data === null || data === void 0 || (_data$jsmChatConversa11 = data.jsmChatConversationMeta) === null || _data$jsmChatConversa11 === void 0 ? void 0 : _data$jsmChatConversa11.subscriptionStatus) ?? 'NONE'
    };
};

});
parcelRegister("fIy8w", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff132d22230a6a0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9d0112a424e829068aee0ce4b184f82e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ff132d22230a6a0f$var$node = function() {
    var v0 = [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "concreteType": "JsmChatConversationMeta",
                    "kind": "LinkedField",
                    "name": "jsmChatConversationMeta",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "conversationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "conversationContextAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "workspaceAri"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "connectionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReplyPending"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationExpired"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "aiAnswerStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isConversationClosed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "draftMessage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "disableInput"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionTriggered"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionStatus"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "omnichannelMetaQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "9615b9f4fbe1d3c4564d22bfc3ed4951",
            "id": null,
            "metadata": {},
            "name": "omnichannelMetaQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff132d22230a6a0f$var$node.hash = "96778225e661ec1b102bb65714d88315";
var $ff132d22230a6a0f$export$2e2bcd8739ae039 = $ff132d22230a6a0f$var$node;

});


parcelRegister("iIiTs", function(module, exports) {
$parcel$export(module.exports, "omnichannelGetConversationExperience", () => $74c283d305fa6494$export$3ca91a525bd30f3f);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $74c283d305fa6494$var$omnichannelGetConversationExperienceId = 'service-management.help-center.omnichannel.get-conversation';
const $74c283d305fa6494$export$3ca91a525bd30f3f = new (0, $3odV5.UFOExperience)($74c283d305fa6494$var$omnichannelGetConversationExperienceId, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});


parcelRegister("a2JhN", function(module, exports) {
$parcel$export(module.exports, "SearchPromptPopup", () => $7958f69a40dbaa6a$export$392e007cdca1b718);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
var $lnVYE = parcelRequire("lnVYE");
var $krkMu = parcelRequire("krkMu");

const $7958f69a40dbaa6a$export$48d2544cca703af5 = (0, $60vf0.lazy)(()=>(parcelRequire("dsF6D")).then((module)=>module.SearchPromptPopup), {
    moduleId: "./src/view/search/search-prompt-popup/search-prompt-popup.tsx"
});
const $7958f69a40dbaa6a$export$392e007cdca1b718 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, props.trigger({
            ref: null,
            'aria-expanded': false,
            'aria-haspopup': false
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $krkMu.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7958f69a40dbaa6a$export$48d2544cca703af5, props)));
};

});
parcelRegister("dsF6D", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("g8SPw").then(()=>parcelRequire('7z512'));

});


parcelRegister("j5lyj", function(module, exports) {
$parcel$export(module.exports, "default", () => $91dcfde975f67992$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $91dcfde975f67992$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.input.clear'
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.ai'
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputAriaLabelNoAI: {
        defaultMessage: 'Search for information',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.no-ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.no-ai'
    },
    askTheVirtualServiceAgent: {
        defaultMessage: 'Ask the virtual service agent',
        description: 'Hint to the user to initiate the virtual service agent conversation',
        id: 'search.input.placeholder.ai.ask-the-virtual-service-agent'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Hint to the user to press enter to go to search results page',
        id: 'search.input.hint'
    },
    ariaDescription: {
        defaultMessage: 'Typing letters in the search input updates the search results in below data table',
        description: 'description for screen reader users when they focus on the search bar ',
        id: 'search.input.aria-description'
    }
});

});





parcelRegister("5k5F5", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsHeaderLink", () => $13e1cf6f79dd8598$export$45f0a19e0c7c461b);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $748yq = parcelRequire("748yq");

var $dQegt = parcelRequire("dQegt");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $4ck3r = parcelRequire("4ck3r");

var $1gH1z = parcelRequire("1gH1z");

var $hZrNx = parcelRequire("hZrNx");

var $5VWO6 = parcelRequire("5VWO6");
const $13e1cf6f79dd8598$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getHelpCenterTopBarTextColor), (primaryColor)=>({
        primaryColor: primaryColor
    }));
const $13e1cf6f79dd8598$var$CsmRequestsHeaderLinkDumb = ({ primaryColor: primaryColor })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { push: push, baseUrl: baseUrl } = (0, $hZrNx.useLinkPush)();
    const href = baseUrl + (0, $748yq.RoutePath).CSM_REQUESTS_LIST_PATH;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4ck3r.default), {
        shape: "circle",
        href: href,
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
                style: {
                    color: primaryColor
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1gH1z))), iconProps)),
        label: formatMessage((0, $5VWO6.default).requests),
        onClick: (event)=>{
            push((0, $748yq.RoutePath).CSM_REQUESTS_LIST_PATH, event);
        }
    });
};
const $13e1cf6f79dd8598$export$45f0a19e0c7c461b = (0, $bmgw6.default)($13e1cf6f79dd8598$var$selector, {})($13e1cf6f79dd8598$var$CsmRequestsHeaderLinkDumb);

});
parcelRegister("4ck3r", function(module, exports) {
$parcel$export(module.exports, "default", () => $e18a9b724b99435f$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.37.1 */ /* link.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $5wgou = parcelRequire("5wgou");

var $jNU2T = parcelRequire("jNU2T");

var $3H4LK = parcelRequire("3H4LK");

var $4nUcM = parcelRequire("4nUcM");

var $8Mj6h = parcelRequire("8Mj6h");

var $gFdUI = parcelRequire("gFdUI");

var $Az2gn = parcelRequire("Az2gn");

var $c6jSC = parcelRequire("c6jSC");
const $e18a9b724b99435f$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $e18a9b724b99435f$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $e18a9b724b99435f$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $e18a9b724b99435f$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _irr31afz _1di61kru"
};
const $e18a9b724b99435f$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $e18a9b724b99435f$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $e18a9b724b99435f$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $e18a9b724b99435f$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $4fqPo.useRef)(null);
    (0, $jNU2T.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ $4fqPo.createElement((0, $8Mj6h.default), {
        content: (tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) ?? label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, (triggerProps)=>/*#__PURE__*/ $4fqPo.createElement((0, $4nUcM.default), {
            ...saferRest,
            "aria-labelledby": ariaLabelledBy,
            testId: testId,
            componentName: "LinkIconButton",
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            // Shared between tooltip and native props
            onMouseOver: (e)=>{
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: (e)=>{
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: (e)=>{
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: (e)=>{
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: (e)=>{
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: (e)=>{
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            // Shared between tooltip and base props
            onClick: (event, analyticsEvent)=>{
                var _triggerProps$onClick;
                onClick === null || onClick === void 0 || onClick(event, analyticsEvent);
                triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
            },
            ref: (0, $5wgou.default)([
                localRef,
                ref,
                triggerProps.ref
            ].filter(Boolean)),
            // Base props only
            xcss: (0, $fxmw9.cx)($e18a9b724b99435f$var$styles.base, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $e18a9b724b99435f$var$styles.baseT26Shape, appearance === 'default' && $e18a9b724b99435f$var$defaultStyles.root, appearance === 'primary' && $e18a9b724b99435f$var$primaryStyles.root, appearance === 'rovo' && $e18a9b724b99435f$var$rovoStyles.root, appearance === 'discovery' && $e18a9b724b99435f$var$discoveryStyles.root, appearance === 'subtle' && $e18a9b724b99435f$var$subtleStyles.root, $e18a9b724b99435f$var$styles.linkDecorationUnset, isSelected && $e18a9b724b99435f$var$selectedStyles.root, isSelected && appearance === 'discovery' && $e18a9b724b99435f$var$selectedStyles.discovery, isDisabled && $e18a9b724b99435f$var$styles.disabled, $e18a9b724b99435f$var$styles.iconButton, spacing === 'compact' && $e18a9b724b99435f$var$styles.spacingCompact, shape === 'circle' && $e18a9b724b99435f$var$styles.circle),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            /**
       * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
       * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
       */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
            href: isDisabled ? undefined : href,
            role: isDisabled ? 'link' : undefined,
            "aria-disabled": isDisabled === true ? true : undefined
        }, /*#__PURE__*/ $4fqPo.createElement((0, $Az2gn.default), {
            type: "icon",
            isLoading: false
        }, /*#__PURE__*/ $4fqPo.createElement((0, $c6jSC.default), {
            icon: icon
        }), /*#__PURE__*/ $4fqPo.createElement((0, $gFdUI.default), null, label))));
    return /*#__PURE__*/ $4fqPo.createElement((0, $4nUcM.default), {
        ...saferRest,
        // aria-label={preventedAriaLabel}
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $5wgou.default)([
            localRef,
            ref
        ]),
        xcss: (0, $fxmw9.cx)($e18a9b724b99435f$var$styles.base, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $e18a9b724b99435f$var$styles.baseT26Shape, appearance === 'default' && $e18a9b724b99435f$var$defaultStyles.root, appearance === 'primary' && $e18a9b724b99435f$var$primaryStyles.root, appearance === 'rovo' && $e18a9b724b99435f$var$rovoStyles.root, appearance === 'discovery' && $e18a9b724b99435f$var$discoveryStyles.root, appearance === 'subtle' && $e18a9b724b99435f$var$subtleStyles.root, $e18a9b724b99435f$var$styles.linkDecorationUnset, isSelected && $e18a9b724b99435f$var$selectedStyles.root, isSelected && appearance === 'discovery' && $e18a9b724b99435f$var$selectedStyles.discovery, isDisabled && $e18a9b724b99435f$var$styles.disabled, $e18a9b724b99435f$var$styles.iconButton, spacing === 'compact' && $e18a9b724b99435f$var$styles.spacingCompact, shape === 'circle' && $e18a9b724b99435f$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }, /*#__PURE__*/ $4fqPo.createElement((0, $Az2gn.default), {
        type: "icon",
        isLoading: false
    }, /*#__PURE__*/ $4fqPo.createElement((0, $c6jSC.default), {
        icon: icon
    }), /*#__PURE__*/ $4fqPo.createElement((0, $gFdUI.default), null, label)));
};
// Workarounds to support generic types with forwardRef + memo
const $e18a9b724b99435f$var$WithRef = /*#__PURE__*/ (0, $4fqPo.forwardRef)($e18a9b724b99435f$var$LinkIconButtonBase);
/**
 * __Link Icon Button__
 *
 * Renders a link in the style of an icon button.
 *
 * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
 * - [Code](https://atlassian.design/components/button/link-icon-button/code)
 * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
 */ const $e18a9b724b99435f$var$LinkIconButton = /*#__PURE__*/ (0, $4fqPo.memo)($e18a9b724b99435f$var$WithRef);
var $e18a9b724b99435f$export$2e2bcd8739ae039 = $e18a9b724b99435f$var$LinkIconButton;

});

parcelRegister("1gH1z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e354977285efce08ec10c33c7aa547f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0ec8a8c9f6e5f784$var$_react = $0ec8a8c9f6e5f784$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $0ec8a8c9f6e5f784$var$_baseNew = $0ec8a8c9f6e5f784$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $0ec8a8c9f6e5f784$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0ec8a8c9f6e5f784$var$InboxIcon = (props)=>/*#__PURE__*/ $0ec8a8c9f6e5f784$var$_react.default.createElement($0ec8a8c9f6e5f784$var$_baseNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$0ec8a8c9f6e5f784$var$InboxIcon.displayName = 'InboxIcon';
var $0ec8a8c9f6e5f784$var$_default = module.exports.default = $0ec8a8c9f6e5f784$var$InboxIcon;

});

parcelRegister("hZrNx", function(module, exports) {
$parcel$export(module.exports, "useLinkPush", () => $33445047c9b514df$export$52eec4f7709b743e);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $ew3Bn = parcelRequire("ew3Bn");

var $54jwS = parcelRequire("54jwS");

var $ebpTf = parcelRequire("ebpTf");
const $33445047c9b514df$export$52eec4f7709b743e = ()=>{
    var _env$baseUrl;
    const env = (0, $ebpTf.getEnv)();
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const linkPush = (0, $4fqPo.useCallback)((targetUrl, event, analyticsAttributes)=>{
        if (analyticsAttributes) createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link',
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            ...analyticsAttributes
        }).fire();
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        event.preventDefault();
        push(targetUrl);
    }, [
        push,
        createAnalyticsEvent
    ]);
    return {
        push: linkPush,
        baseUrl: (_env$baseUrl = env.baseUrl) === null || _env$baseUrl === void 0 ? void 0 : _env$baseUrl.replace(/\/+$/, '')
    };
};

});

parcelRegister("5VWO6", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fc3d2a0e90402ff$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $2fc3d2a0e90402ff$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requests: {
        id: 'csm-requests-header-link.requests',
        defaultMessage: 'Requests',
        description: 'The text is shown as the label for a navigation link in the page header that takes the user to the list of their submitted customer service requests.'
    }
});

});


parcelRegister("7WK95", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("gsFvz")).default);
parcelRequire("fRDJy");
var $gsFvz = parcelRequire("gsFvz");

});
parcelRegister("fRDJy", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuV2", () => (parcelRequire("gsFvz")).default);

var $gsFvz = parcelRequire("gsFvz");

});
parcelRegister("gsFvz", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ef2ae3cf3286b87$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("1lZyB");
var $d9IdW = parcelRequire("d9IdW");

var $6Bwkd = parcelRequire("6Bwkd");

var $a4IFj = parcelRequire("a4IFj");

var $g1qUq = parcelRequire("g1qUq");

var $awU1e = parcelRequire("awU1e");

var $1CvNj = parcelRequire("1CvNj");

var $isIps = parcelRequire("isIps");

var $7AcSo = parcelRequire("7AcSo");

var $krFoK = parcelRequire("krFoK");

var $eHHQc = parcelRequire("eHHQc");

var $aeiW2 = parcelRequire("aeiW2");
parcelRequire("3XACI");
var $7yKJZ = parcelRequire("7yKJZ");
const $6ef2ae3cf3286b87$var$getCustomMenuLinksProps = (state)=>{
    const customMenuLinks = (0, $isIps.getCustomMenuLinks)(state);
    return customMenuLinks.map((menuLink)=>{
        return {
            id: menuLink.id,
            key: menuLink.key,
            label: menuLink.label,
            href: menuLink.href,
            styleClass: menuLink.styleClass
        };
    });
};
const $6ef2ae3cf3286b87$var$selector = (0, $3yyCx.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $6Bwkd.getPortalId)(state);
    const routeName = (0, $6Bwkd.getRoutename)(state);
    const portal = {
        id: portalId,
        name: (0, $awU1e.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $awU1e.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $awU1e.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $awU1e.getIsProjectSimplified)(state, portalId))
    };
    const areCustomerServiceSettingsLinksAvailable = (0, $a4IFj.getHelpCenterType)(state) === (0, $aeiW2.CUSTOMER_SERVICE_HELP_CENTER_TYPE) && !!(0, $a4IFj.getHoistedProjectKey)(state);
    return {
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: (0, $isIps.getAvatarSrc)(state),
        displayName: (0, $isIps.getDisplayName)(state),
        email: (0, $isIps.getEmail)(state),
        customMenuLinks: $6ef2ae3cf3286b87$var$getCustomMenuLinksProps(state),
        canAdministerJIRA: (0, $isIps.getCanAdministerJIRA)(state),
        canCustomiseHelpCenter: (0, $g1qUq.getCanCustomize)(state),
        pendingApprovalCount: (0, $7AcSo.getUserRequestsCounts)(state).pendingApprovalCount,
        myRequestCount: (0, $7AcSo.getUserRequestsCounts)(state).myRequestCount,
        defaultColumnSettings: (0, $1CvNj.getRequestsColumnSettings)(state),
        approvalCount: (0, $7AcSo.getUserRequestsCounts)(state).approvalCount,
        jsmAIConfigEnabled: (0, $a4IFj.getJsmAIConfigEnabled)(state),
        hoistedProjectKey: (0, $a4IFj.getHoistedProjectKey)(state),
        jiraDisplayUrl: (0, $a4IFj.getJiraDisplayUrl)(state),
        hasSiteAdministerAccess: (0, $isIps.getHasSiteAdministerAccess)(state)
    };
}, ({ portal: portal, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, avatarSrc: avatarSrc, displayName: displayName, email: email, customMenuLinks: customMenuLinks, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, routeName: routeName, defaultColumnSettings: defaultColumnSettings, pendingApprovalCount: pendingApprovalCount, myRequestCount: myRequestCount, approvalCount: approvalCount, jsmAIConfigEnabled: jsmAIConfigEnabled, hoistedProjectKey: hoistedProjectKey, jiraDisplayUrl: jiraDisplayUrl, hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        portal: portal,
        routeName: routeName,
        areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable,
        avatarSrc: avatarSrc,
        displayName: displayName,
        email: email,
        customMenuLinks: customMenuLinks,
        canAdministerJIRA: canAdministerJIRA,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        pendingApprovalCount: pendingApprovalCount,
        approvalCount: approvalCount,
        defaultColumnSettings: defaultColumnSettings,
        myRequestCount: myRequestCount,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        hoistedProjectKey: hoistedProjectKey,
        jiraDisplayUrl: jiraDisplayUrl,
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
var $6ef2ae3cf3286b87$export$2e2bcd8739ae039 = (0, $bmgw6.default)($6ef2ae3cf3286b87$var$selector, {
    onLogoutClick: (0, $d9IdW.logOutAction),
    openHelpCenterCustomizationSidebar: ()=>(0, $krFoK.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $eHHQc.customizingRequestListColumn)(true)
})((0, $7yKJZ.default));

});
parcelRegister("1lZyB", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("9pme5")).fetchCategoriesAction);
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("9VkPG")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("9VkPG")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("1LQNM")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("3vsma")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("d9IdW")).logOutAction);
parcelRequire("bZwOS");

});
parcelRegister("bZwOS", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => (parcelRequire("9VkPG")).fetchHelpCenterAction);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => (parcelRequire("9VkPG")).fetchHelpCenterBrandingAction);
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => (parcelRequire("1LQNM")).fetchOrganisationsModelAction);
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => (parcelRequire("3vsma")).fetchUserRequestsCountsAction);
$parcel$export(module.exports, "fetchCategoriesAction", () => (parcelRequire("9pme5")).fetchCategoriesAction);
$parcel$export(module.exports, "logOutAction", () => (parcelRequire("d9IdW")).logOutAction);

var $9VkPG = parcelRequire("9VkPG");

var $1LQNM = parcelRequire("1LQNM");

var $3vsma = parcelRequire("3vsma");

var $9pme5 = parcelRequire("9pme5");

var $d9IdW = parcelRequire("d9IdW");

});
parcelRegister("9VkPG", function(module, exports) {
$parcel$export(module.exports, "fetchHelpCenterAction", () => $562f504f47ca7eb0$export$61e2f9e78cb604c7);
$parcel$export(module.exports, "fetchHelpCenterBrandingAction", () => $562f504f47ca7eb0$export$42cfcdfd4935cc23);

var $2z0ou = parcelRequire("2z0ou");
const $562f504f47ca7eb0$export$5586a78b777598b9 = 'epic.model.FETCH_HELP_CENTER_MODEL';
const $562f504f47ca7eb0$export$d8cc5374b8afc050 = 'epic.model.FETCH_HELP_CENTER_BRANDING_MODEL';
const $562f504f47ca7eb0$export$61e2f9e78cb604c7 = (0, $2z0ou.buildModelsActionCreator)($562f504f47ca7eb0$export$5586a78b777598b9, 'sharedPortal');
const $562f504f47ca7eb0$export$42cfcdfd4935cc23 = (0, $2z0ou.buildModelsActionCreator)($562f504f47ca7eb0$export$d8cc5374b8afc050, 'helpCenterBranding');

});
parcelRegister("2z0ou", function(module, exports) {
$parcel$export(module.exports, "buildModelsActionCreator", () => $2283df789bddc99f$export$9f8a38b5e77ac29);
const $2283df789bddc99f$export$9f8a38b5e77ac29 = (actionType, type)=>(params = {}, options)=>({
            ...options ? {
                options: options
            } : {},
            type: actionType,
            payload: {
                type: type,
                params: params
            }
        });

});


parcelRegister("1LQNM", function(module, exports) {
$parcel$export(module.exports, "fetchOrganisationsModelAction", () => $4108ec6087356301$export$cbdd5d7a098d34a2);

var $2z0ou = parcelRequire("2z0ou");
const $4108ec6087356301$export$b60557155cf3c6c0 = 'epic.model.FETCH_ORGANISATIONS_MODEL';
const $4108ec6087356301$export$cbdd5d7a098d34a2 = (0, $2z0ou.buildModelsActionCreator)($4108ec6087356301$export$b60557155cf3c6c0, 'organisations');

});

parcelRegister("3vsma", function(module, exports) {
$parcel$export(module.exports, "fetchUserRequestsCountsAction", () => $b5e8b2bc413ebb95$export$71172847a48a08a6);

var $2z0ou = parcelRequire("2z0ou");
const $b5e8b2bc413ebb95$export$dfecf710cdf030b1 = 'epic.model.FETCH_USER_REQUESTS_COUNTS_MODEL';
const $b5e8b2bc413ebb95$export$71172847a48a08a6 = (0, $2z0ou.buildModelsActionCreator)($b5e8b2bc413ebb95$export$dfecf710cdf030b1, 'userRequestsCounts');

});

parcelRegister("9pme5", function(module, exports) {
$parcel$export(module.exports, "fetchCategoriesAction", () => $671917d3a6e0fc29$export$10813fa84276d50);
const $671917d3a6e0fc29$export$cce9a7031b65f96c = 'epic.model.FETCH_KB_CATEGORIES';
const $671917d3a6e0fc29$export$10813fa84276d50 = (projectId, portalId, meta)=>({
        type: $671917d3a6e0fc29$export$cce9a7031b65f96c,
        payload: {
            projectId: projectId,
            portalId: portalId,
            meta: meta
        }
    });

});

parcelRegister("d9IdW", function(module, exports) {
$parcel$export(module.exports, "logOutAction", () => $d561117518204321$export$1a3865346be34527);
const $d561117518204321$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
const $d561117518204321$export$1a3865346be34527 = ()=>{
    return {
        type: $d561117518204321$export$cb307dad255adf47
    };
};

});



parcelRegister("6Bwkd", function(module, exports) {
$parcel$export(module.exports, "getPortalId", () => $0461f074a0b479e2$export$79c9b12a0a57147a);
$parcel$export(module.exports, "getRoutename", () => $0461f074a0b479e2$export$6c570a1091322ad4);
const $0461f074a0b479e2$export$f71e6ac2c1d88be0 = (state)=>{
    var _state$ui, _state$ui2, _state$ui3;
    return ((_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.context.portalId) !== undefined && ((_state$ui2 = state.ui) === null || _state$ui2 === void 0 ? void 0 : _state$ui2.context.portalId) !== null && !isNaN(((_state$ui3 = state.ui) === null || _state$ui3 === void 0 ? void 0 : _state$ui3.context.portalId) || NaN);
};
const $0461f074a0b479e2$export$79c9b12a0a57147a = (state)=>{
    var _state$ui4;
    if (!$0461f074a0b479e2$export$f71e6ac2c1d88be0(state)) return undefined;
    return (_state$ui4 = state.ui) === null || _state$ui4 === void 0 ? void 0 : _state$ui4.context.portalId;
};
const $0461f074a0b479e2$export$6c570a1091322ad4 = (state)=>{
    var _state$ui5;
    return (_state$ui5 = state.ui) === null || _state$ui5 === void 0 ? void 0 : _state$ui5.context.routeName;
};

});

parcelRegister("a4IFj", function(module, exports) {
$parcel$export(module.exports, "getJsmAIConfigEnabled", () => $b42249a66317e0ba$export$a90992f5204fc247);
$parcel$export(module.exports, "getHelpCenterType", () => $b42249a66317e0ba$export$7972e6e7445f0142);
$parcel$export(module.exports, "getHoistedProjectKey", () => $b42249a66317e0ba$export$3b0fd0e16a94f75);
$parcel$export(module.exports, "getJiraDisplayUrl", () => $b42249a66317e0ba$export$9679fa5312e1354b);
const $b42249a66317e0ba$export$a90992f5204fc247 = (state)=>{
    var _state$persisted$env$;
    return !!((_state$persisted$env$ = state.persisted.env.featuredValues) !== null && _state$persisted$env$ !== void 0 && _state$persisted$env$.jsmAiConfigEnabled);
};
const $b42249a66317e0ba$export$7972e6e7445f0142 = (state)=>state.persisted.env.helpCenterType;
const $b42249a66317e0ba$export$3b0fd0e16a94f75 = (state)=>state.persisted.env.hoistedProjectKey;
const $b42249a66317e0ba$export$9679fa5312e1354b = (state)=>state.persisted.env.jiraDisplayUrl;

});

parcelRegister("g1qUq", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterBanner", () => $8eff7feb2956e826$export$3b3c747bea011f3c);
$parcel$export(module.exports, "getThemeColor", () => $8eff7feb2956e826$export$e22c5d06d177c3fa);
$parcel$export(module.exports, "getCanCustomize", () => $8eff7feb2956e826$export$eb9b5e885139dc39);

var $63sfu = parcelRequire("63sfu");

var $isIps = parcelRequire("isIps");
const $8eff7feb2956e826$export$85757b7e55ef3c9f = (state)=>{
    var _state$ui;
    return (0, $63sfu.mergeWith)({}, state.persisted.helpCenter, (_state$ui = state.ui) === null || _state$ui === void 0 ? void 0 : _state$ui.helpCenterPreview, // If the value is undefined we will instead change it to null, the reason for this is to ensure that the resulting
    // property gets replaced with null, by default mergeWith (and merge) does not replace properties if the value is undefined
    (_, srcValue)=>{
        if (srcValue === undefined) return null;
        // If the value is not specifically 'undefined' we leave it up to the default customizer to handle
        return undefined;
    });
};
const $8eff7feb2956e826$export$3b3c747bea011f3c = (state)=>{
    return $8eff7feb2956e826$export$85757b7e55ef3c9f(state).helpCenterBannerUrl;
};
const $8eff7feb2956e826$export$e22c5d06d177c3fa = (state)=>{
    return $8eff7feb2956e826$export$85757b7e55ef3c9f(state).themeColor;
};
const $8eff7feb2956e826$var$getTranslation = (state, language)=>$8eff7feb2956e826$export$85757b7e55ef3c9f(state).translations[language];
const $8eff7feb2956e826$export$bef10d4690ba4a95 = (state)=>{
    const userLocale = (0, $isIps.getLocale)(state);
    const translation = userLocale && $8eff7feb2956e826$var$getTranslation(state, userLocale);
    if (translation && translation.sharedPortalName) return translation.sharedPortalName;
    return $8eff7feb2956e826$export$85757b7e55ef3c9f(state).sharedPortalName;
};
const $8eff7feb2956e826$export$eb9b5e885139dc39 = (state)=>{
    return $8eff7feb2956e826$export$85757b7e55ef3c9f(state).canCustomizeHelpCenter;
};

});

parcelRegister("awU1e", function(module, exports) {
$parcel$export(module.exports, "getPortalOrError", () => $6b5d74d00b2c6501$export$aa66ead34639a340);
$parcel$export(module.exports, "getProjectId", () => $6b5d74d00b2c6501$export$89040d072f281f85);
$parcel$export(module.exports, "getName", () => $6b5d74d00b2c6501$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getPortalAnnouncement", () => $6b5d74d00b2c6501$export$78e1a2ab89c0908b);
$parcel$export(module.exports, "getCanAdministerProject", () => $6b5d74d00b2c6501$export$2cdfb65eda98a530);
$parcel$export(module.exports, "getIsProjectSimplified", () => $6b5d74d00b2c6501$export$5bde43fbba6edf90);
$parcel$export(module.exports, "getCategories", () => $6b5d74d00b2c6501$export$7a0f33e8df10bd94);

var $63sfu = parcelRequire("63sfu");
const $6b5d74d00b2c6501$export$baa53a1870be4bc5 = {
    __NOT_SUPPORTED__: true
};
const $6b5d74d00b2c6501$export$aa66ead34639a340 = (state, portalId)=>{
    if ((0, $63sfu.isNil)(portalId)) return undefined;
    return state.persisted.portals[portalId];
};
const $6b5d74d00b2c6501$export$e16cb606b6ef4a60 = (state, portalId)=>{
    const portal = $6b5d74d00b2c6501$export$aa66ead34639a340(state, portalId);
    if (!portal || 'error' in portal) return undefined;
    return portal;
};
const $6b5d74d00b2c6501$export$89040d072f281f85 = (state, portalId)=>{
    if ((0, $63sfu.isNil)(portalId)) return undefined;
    const portal = $6b5d74d00b2c6501$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.projectId : undefined;
};
const $6b5d74d00b2c6501$export$7d9f7e9c1c02b41e = (state, portalId)=>{
    const portal = $6b5d74d00b2c6501$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.name : undefined;
};
const $6b5d74d00b2c6501$export$78e1a2ab89c0908b = (state, portalId)=>{
    const portal = $6b5d74d00b2c6501$export$e16cb606b6ef4a60(state, portalId);
    return portal ? portal.portalAnnouncement : undefined;
};
const $6b5d74d00b2c6501$export$2cdfb65eda98a530 = (state, portalId)=>{
    const portalAnnouncement = $6b5d74d00b2c6501$export$78e1a2ab89c0908b(state, portalId);
    return portalAnnouncement ? portalAnnouncement.canAdministerProject : false;
};
const $6b5d74d00b2c6501$export$5bde43fbba6edf90 = (state, portalId)=>{
    const portal = $6b5d74d00b2c6501$export$e16cb606b6ef4a60(state, portalId);
    return portal ? !!portal.isProjectSimplified : false;
};
const $6b5d74d00b2c6501$export$7a0f33e8df10bd94 = (state, portalId)=>{
    const portal = $6b5d74d00b2c6501$export$e16cb606b6ef4a60(state, portalId);
    if (portal && portal.knowledgeBase && portal.knowledgeBase.kbCategories) {
        const categoryOrError = portal.knowledgeBase.kbCategories;
        return 'error' in categoryOrError ? [] : categoryOrError;
    }
    return undefined;
};

});

parcelRegister("1CvNj", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $3964dfcb7a240f9a$export$a5e47ac90fcdaee8);
/**
 * Request column settings selectors for accessing column configuration.
 * These selectors are designed to avoid cyclic dependencies.
 */ /**
 * Get the full requests column settings state (includes columns and statusFilter).
 */ const $3964dfcb7a240f9a$var$getRequestsColumnSettingsState = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $3964dfcb7a240f9a$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $3964dfcb7a240f9a$var$getRequestsColumnSettingsState(state);
    return settingsState.columns || [];
};

});

parcelRegister("7AcSo", function(module, exports) {
$parcel$export(module.exports, "getUserRequestsCounts", () => $8abab56b5e657299$export$be73da9c8fdefffb);
const $8abab56b5e657299$export$be73da9c8fdefffb = (state)=>{
    return state.persisted.userRequestsCounts;
};

});

parcelRegister("aeiW2", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_HELP_CENTER_TYPE", () => $791ffe9089208930$export$fc172486e4a9f1fa);
const $791ffe9089208930$export$fc172486e4a9f1fa = 'CUSTOMER_SERVICE';

});

parcelRegister("3XACI", function(module, exports) {
$parcel$export(module.exports, "AvatarMenuDumbV2", () => (parcelRequire("7yKJZ")).default);

var $7yKJZ = parcelRequire("7yKJZ");

});
parcelRegister("7yKJZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $143ecd97571c492e$export$2e2bcd8739ae039);
/* avatar-menu-dumb-v2.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $6uA6H = parcelRequire("6uA6H");

var $1HSOM = parcelRequire("1HSOM");
var $1P8FK = parcelRequire("1P8FK");

var $eiGUu = parcelRequire("eiGUu");

var $kmGir = parcelRequire("kmGir");

var $cfx3H = parcelRequire("cfx3H");

var $748yq = parcelRequire("748yq");

var $aeicL = parcelRequire("aeicL");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $1mJUv = parcelRequire("1mJUv");

var $adk9i = parcelRequire("adk9i");

var $aPtW9 = parcelRequire("aPtW9");

var $6Cmwn = parcelRequire("6Cmwn");

var $6mmHn = parcelRequire("6mmHn");

var $9ijW8 = parcelRequire("9ijW8");

var $bpWyP = parcelRequire("bpWyP");

var $kQ79X = parcelRequire("kQ79X");

var $jwb88 = parcelRequire("jwb88");

var $5Uaxl = parcelRequire("5Uaxl");
var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $fFB0R = parcelRequire("fFB0R");
var $ew3Bn = parcelRequire("ew3Bn");

var $d3YBt = parcelRequire("d3YBt");

var $aHUNw = parcelRequire("aHUNw");

var $d7mfg = parcelRequire("d7mfg");

var $6bGmX = parcelRequire("6bGmX");

var $cIQ4S = parcelRequire("cIQ4S");

var $9qmTW = parcelRequire("9qmTW");

var $hHIxn = parcelRequire("hHIxn");
var $aYVUY = parcelRequire("aYVUY");
var $2dYW6 = parcelRequire("2dYW6");
var $45ZUo = parcelRequire("45ZUo");

var $kCZZw = parcelRequire("kCZZw");

var $2nGAn = parcelRequire("2nGAn");
var $33cQv = parcelRequire("33cQv");
var $kBDWz = parcelRequire("kBDWz");

var $6hIdA = parcelRequire("6hIdA");

var $7TPEx = parcelRequire("7TPEx");
var $82vM7 = parcelRequire("82vM7");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $hDp3n = parcelRequire("hDp3n");

var $6xwRI = parcelRequire("6xwRI");

var $54jwS = parcelRequire("54jwS");

var $4oTiM = parcelRequire("4oTiM");

var $6YWkm = parcelRequire("6YWkm");

var $2KBf4 = parcelRequire("2KBf4");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $chA55 = parcelRequire("chA55");

var $wHtsq = parcelRequire("wHtsq");

var $Y85G3 = parcelRequire("Y85G3");

var $exyTO = parcelRequire("exyTO");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");

var $3krHC = parcelRequire("3krHC");
var $7hsFm = parcelRequire("7hsFm");
parcelRequire("7HEbW");
var $kupV4 = parcelRequire("kupV4");

var $3aJkj = parcelRequire("3aJkj");

var $dvLMh = parcelRequire("dvLMh");

var $gJ7ty = parcelRequire("gJ7ty");

var $5G1MC = parcelRequire("5G1MC");

var $e5VNr = parcelRequire("e5VNr");
const $143ecd97571c492e$export$c0b4c34c7506f4d = ()=>(0, $6bGmX.default).checkGate('jsm_help_center_one-click_rovo_agent');
const $143ecd97571c492e$export$e0ae4b37130667df = ({ onClose: onClose })=>{
    const { data: { extensionTitles: extensionTitles }, methods: { setExtensionToDisplay: onClick } } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext((0, $aPtW9.ForgeModalContext));
    const forgeActionLinkOnClick = (id, onClickApp)=>()=>{
            onClose('navBarForgeApp');
            return onClickApp(id);
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, extensionTitles.map(({ id: id, title: title })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            id: id,
            key: `forge-title_${id}`,
            component: $143ecd97571c492e$var$CustomButton,
            actionSubjectId: "navBarForgeApp",
            onClick: forgeActionLinkOnClick(id, onClick)
        }, title);
    }));
};
const $143ecd97571c492e$var$menuBottomSection = (onClose, isHelpCenterManagementScreen, onLogoutClick)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
        hasSeparator: true
    }, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        actionSubjectId: "navbarProfile",
        key: `bottom-menu-management-screen-navbarProfile`,
        component: $143ecd97571c492e$var$CustomAnchor,
        href: '/servicedesk/customer/user/profile',
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).profile)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        key: `bottom-menu-navbarProfile`,
        component: $143ecd97571c492e$var$CustomLink,
        to: '/user/profile',
        actionSubjectId: "navbarProfile",
        onClick: ()=>onClose('navbarProfile'),
        "data-test-id": "profile-link",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).profile)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: 'navbarLogout'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: $143ecd97571c492e$var$CustomButton,
        actionSubjectId: "navbarLogout",
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        "aria-label": 'logout',
        onClick: onLogoutClick,
        "data-test-id": "logout-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).logout))));
};
const $143ecd97571c492e$export$a552d0e5a7a35aad = ({ customMenuLinks: customMenuLinks, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        "data-test-id": "custom-menu-link"
    }, customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            key: `custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            actionSubjectId: 'custom-menu-link',
            component: $143ecd97571c492e$var$CustomAnchor,
            href: menuLink.href,
            onClick: ()=>onClose('custom-menu-link'),
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label))));
const $143ecd97571c492e$var$buildCustomMenuLinks = (customMenuLinks, onClose)=>{
    return customMenuLinks.map((menuLink)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            key: `build-custom-menu-link_${menuLink.key || ''}`,
            className: menuLink.styleClass
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            actionSubjectId: 'custom-menu-link',
            component: $143ecd97571c492e$var$CustomAnchor,
            "data-test-id": "custom-menu-link",
            key: `custom-menu-link-id_${menuLink.id || ''}`,
            onClick: ()=>onClose('custom-menu-link'),
            href: menuLink.href,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menuLink.label)));
};
const $143ecd97571c492e$var$TopMenu = (myRequestCount, onClose, pendingApprovalCount, approvalCount, isHelpCenterManagementScreen)=>{
    const customizeMenu = [
        {
            onClick: ()=>onClose('navbarUserRequests'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/requests?reporter=all&statuses=open' : '/user/requests?reporter=all&statuses=open',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).requests),
            actionSubjectId: 'navbarUserRequests',
            iconAfter: myRequestCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kmGir.default), null, myRequestCount) : undefined,
            isVisible: !(0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType),
            dataTestId: 'requests-link'
        },
        {
            onClick: ()=>onClose('navbarUserApprovals'),
            link: isHelpCenterManagementScreen ? '/servicedesk/customer/user/approvals' : '/user/approvals',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).approvals),
            actionSubjectId: 'navbarUserApprovals',
            iconAfter: pendingApprovalCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kmGir.default), null, pendingApprovalCount) : undefined,
            isVisible: approvalCount > 0 || pendingApprovalCount > 0,
            dataTestId: 'approvals-link'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isHelpCenterManagementScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            actionSubjectId: menu.actionSubjectId,
            key: `top-menu-management-screen_${menu.actionSubjectId}`,
            component: $143ecd97571c492e$var$CustomAnchor,
            href: menu.link,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            key: `top-menu_${menu.actionSubjectId}`,
            component: $143ecd97571c492e$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            iconAfter: menu.iconAfter,
            "data-test-id": menu.dataTestId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $143ecd97571c492e$var$CustomMenuItems = ({ menu: menu })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: menu.component ?? $143ecd97571c492e$var$CustomLink,
        to: menu.link,
        actionSubjectId: menu.actionSubjectId,
        onClick: menu.onClick,
        testId: menu.testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
            appearance: "new"
        }, formatMessage((0, $gJ7ty.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
            appearance: "new"
        }, formatMessage((0, $gJ7ty.default).newLozenge)), menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
            appearance: "new"
        }, formatMessage((0, $gJ7ty.default).premiumLozenge)))
    }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6xwRI.FireUIAnalytics), {
        action: "viewed",
        actionSubject: menu.actionSubjectId
    }));
};
const $143ecd97571c492e$var$CustomPressable = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $82vM7.default), {
        componentName: "link",
        xcss: $143ecd97571c492e$var$customPressableStyles,
        ...rest
    }, children);
const $143ecd97571c492e$var$EditPageLayoutWithPopUp = ({ menu: menu })=>{
    const [isOpen, setIsOpen] = (0, $4fqPo.useState)(false);
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const contentCallback = (0, $4fqPo.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $143ecd97571c492e$var$pageLayoutPremiumPopUp
        }, menu.messageDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, formatMessage(menu.messageDescription)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: 'flexibleHelpCenterTryLink'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cIQ4S))),
            appearance: "discovery",
            onClick: ()=>{
                createAnalyticsEvent({
                    actionSubjectId: 'flexibleHelpCenterTryLink',
                    action: 'clicked',
                    actionSubject: 'button',
                    analyticsType: (0, $54jwS.UI_EVENT_TYPE)
                }).fire();
                window.open((0, $Y85G3.getBillingUrl)([
                    'jira-servicedesk'
                ], (0, $6mmHn.getCloudId)()), '_blank');
            }
        }, formatMessage((0, $gJ7ty.default).pageLayoutTryItNowButton)))));
    }, [
        createAnalyticsEvent,
        formatMessage,
        menu.messageDescription
    ]);
    const triggerCallback = (0, $4fqPo.useCallback)((triggerProps)=>{
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            ...triggerProps,
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') setIsOpen((state)=>!state);
            },
            onClick: ()=>{
                setIsOpen((state)=>!state);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$CustomMenuItems, {
            menu: {
                ...menu,
                onClick: (event)=>{
                    event.preventDefault();
                }
            }
        })));
    }, [
        menu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "left-start",
        content: contentCallback,
        trigger: triggerCallback
    });
};
const $143ecd97571c492e$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).HELP_CENTER,
        id: `help-center-${menu.pbmTouchpointId}`,
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6YWkm.PremiumBenefitModalTrigger), {
        cloudId: (0, $6mmHn.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: menu.pbmTouchpointId,
        edition: (0, $ebpTf.getEnv)().edition ?? 'unknown'
    }, ({ ref: ref, props: triggerProps })=>// CustomItem doesn't forward testId to custom components, so we add it to the Box wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            ref: ref,
            ...triggerProps,
            testId: menu.testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$CustomMenuItems, {
            menu: {
                ...menu,
                component: $143ecd97571c492e$var$CustomPressable
            }
        })))));
};
const $143ecd97571c492e$var$ListItemWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        as: "li",
        xcss: $143ecd97571c492e$var$listItemStyles
    }, children);
};
const $143ecd97571c492e$export$7ed443719af866bf = ({ customizeMenu: customizeMenu = [] })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $4fqPo.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.isAnchor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            component: $143ecd97571c492e$var$CustomAnchor,
            href: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                appearance: "new"
            }, formatMessage((0, $gJ7ty.default).beta)),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: `customize-menu_spotlight_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9ijW8.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $33cQv.default), {
                name: (0, $748yq.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
                key: `customize-menu_${menu.actionSubjectId}`,
                component: $143ecd97571c492e$var$CustomLink,
                to: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                    appearance: "new"
                }, formatMessage((0, $gJ7ty.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                    appearance: "new"
                }, formatMessage((0, $gJ7ty.default).newLozenge)))
            }, menu.label))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kBDWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aeicL.default), {
            messageId: (0, $748yq.EngagementMessages).ONBOARD_VA_REPORTING,
            key: (0, $748yq.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jwb88.VaOnboardingSpotlight), {
            setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
        })))));
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: `customize-menu_custom_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(menu.customRenderer, {
            menu: menu
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            component: $143ecd97571c492e$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, menu.isBeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                appearance: "new"
            }, formatMessage((0, $gJ7ty.default).beta)), menu.isNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                appearance: "new"
            }, formatMessage((0, $gJ7ty.default).newLozenge))),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label));
    }));
};
const $143ecd97571c492e$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub)=>{
    const isHomePage = routeName === 'help-center' || routeName === 'view-homepage';
    const customizeMenu = [];
    if ((0, $bG6ob.isJsmCsMasterFlagEnabled)()) {
        const helpCenterId = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)()).helpCenterId;
        const isVisible = areCustomerServiceSettingsLinksAvailable && !!jiraDisplayUrl && !!hoistedProjectKey && !!helpCenterId && (isHomePage || isServiceHub) && canAdministerJIRA;
        const additionalMenuItems = [
            {
                isVisible: isVisible,
                isAnchor: true,
                link: `${jiraDisplayUrl ?? ''}/jira/helpcenter/projects/${hoistedProjectKey ?? ''}/settings/${helpCenterId}/details`,
                label: (0, $bG6ob.isJcsprojectTypeM3Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).customerHubSettings) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).helpCenterSettings),
                actionSubjectId: 'helpCenterSettings',
                testId: 'help-center-settings'
            }
        ];
        customizeMenu.push(...additionalMenuItems);
    }
    const hideSection = ()=>customizeMenu.every((item)=>!item.isVisible);
    if (hideSection()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$export$7ed443719af866bf, {
        customizeMenu: customizeMenu
    });
};
const $143ecd97571c492e$var$RenderHCSection = ({ setTitle: setTitle, setDescription: setDescription, setModalOpen: setModalOpen, onClick: onClick, showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells, hasSiteAdministerAccess: hasSiteAdministerAccess })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
    const manageHelpCenterPagesCustomRenderer = (0, $4fqPo.useCallback)(()=>{
        if ((0, $ebpTf.getIsHCCustomizationEnabled)()) return undefined;
        if ((0, $chA55.isPremiumUpsellExperimentEnabled)({
            hasSiteAdministerAccess: hasSiteAdministerAccess,
            isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
        })) return $143ecd97571c492e$var$PremiumBenefitsModalRenderer;
        return $143ecd97571c492e$var$EditPageLayoutWithPopUp;
    }, [
        hasSiteAdministerAccess
    ]);
    const customizeMenu = [
        {
            link: `${(0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH)}`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).manageHc),
            actionSubjectId: 'manageHelpCenter',
            isVisible: true,
            onClick: ()=>onClick('manageHelpCenter'),
            testId: 'manage-hc-link'
        },
        {
            link: (0, $ebpTf.getIsMultiHCEnabled)() ? `${0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH}?create=true` : '#',
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).createHc),
            actionSubjectId: 'createHelpCenter',
            isVisible: showAvatarMenuItemsUpsells,
            pbmTouchpointId: 'portal-avatar-menu-create-help-center',
            customRenderer: (0, $chA55.isPremiumUpsellExperimentEnabled)({
                hasSiteAdministerAccess: hasSiteAdministerAccess,
                isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
            }) ? $143ecd97571c492e$var$PremiumBenefitsModalRenderer : undefined,
            onClick: (0, $ebpTf.getIsMultiHCEnabled)() || (0, $chA55.isPremiumUpsellExperimentEnabled)({
                hasSiteAdministerAccess: hasSiteAdministerAccess,
                isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
            }) ? ()=>onClick('createHelpCenter') : ()=>{
                onClick('createHelpCenter');
                setTitle(formatMessage((0, $gJ7ty.default).onboardingTitleHCClick));
                setDescription(formatMessage((0, $gJ7ty.default).onboardingDescriptionCreateOrHcClickWithLink));
                setModalOpen(true);
            },
            testId: 'create-hc-link',
            isPremium: !(0, $ebpTf.getIsHCCustomizationEnabled)()
        },
        ...(0, $bG6ob.isCustomPagesUiEnabled)() ? [
            {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).managePages),
                actionSubjectId: 'manageHelpCenterPages',
                isVisible: showAvatarMenuItemsUpsells,
                pbmTouchpointId: 'portal-avatar-menu-landing-pages',
                onClick: ()=>onClick('manageHelpCenterPages'),
                testId: 'manage-hc-pages',
                link: `${(0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/pages`,
                isPremium: !(0, $ebpTf.getIsHCCustomizationEnabled)(),
                customRenderer: manageHelpCenterPagesCustomRenderer(),
                showSpotlight: false,
                messageDescription: (0, $gJ7ty.default).landingPagesNonPremiumDescription
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aYVUY.default), {
        id: "avatar-menu-hc-section-heading"
    }, formatMessage((0, $gJ7ty.default).helpCenter)), customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: `customize-menu_${menu.actionSubjectId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(menu.customRenderer, {
            menu: menu
        }), menu.actionSubjectId === 'manageHelpCenterPages' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6xwRI.FireUIAnalytics), {
            action: "viewed",
            actionSubject: menu.actionSubjectId
        })));
        const renderMenuItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
                key: `hc-section-menu_${menu.actionSubjectId}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
                component: $143ecd97571c492e$var$CustomAnchor,
                href: menu.link,
                actionSubjectId: menu.actionSubjectId,
                onClick: menu.onClick,
                testId: menu.testId,
                iconAfter: menu.isPremium && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                    appearance: "new"
                }, formatMessage((0, $gJ7ty.default).premiumLozenge)),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                className: "cv-exclude-from-customisation"
            }, menu.label), menu.actionSubjectId === 'createHelpCenter' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6xwRI.FireUIAnalytics), {
                action: "viewed",
                actionSubject: menu.actionSubjectId
            })));
        if (menu.showSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9ijW8.default), {
            delay: 100,
            key: menu.actionSubjectId
        }, ()=>renderMenuItem());
        return renderMenuItem();
    }));
};
const $143ecd97571c492e$var$UserProfileConnectActionLinks = (0, $exyTO.withDeferredWrmLoaded)($143ecd97571c492e$export$a552d0e5a7a35aad, (0, $cfx3H.initializeConnect));
const $143ecd97571c492e$var$AvatarMenuDumbV2 = (props)=>{
    // Reading the from useRouter even thought we are getting from props because
    // there is an unneccessary rerender happening in the component which is causing the Engagement client
    // to make an unnecessary start call
    // Keep useRouter hook call to preserve hook ordering
    (0, $hfD9S.useRouter)();
    const isHomepage = (props === null || props === void 0 ? void 0 : props.routeName) === 'help-center' || (props === null || props === void 0 ? void 0 : props.routeName) === 'view-homepage';
    (0, $7hsFm.useUFOComponentExperience)((0, $dvLMh.avatarMenuExperience));
    const isHelpCenterManagementScreen = (0, $3wR8f.getRelativeBasePath)() === (0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const basePath = (0, $eSL4S.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $4fqPo.useState)(!!props.isOpen);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $hRwKd.useQueryParams)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    // eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-react-fc
    const isSmallScreen = window.innerWidth < (0, $kQ79X.sizes).xsmall;
    // Keep the hook call to preserve hook ordering
    (0, $gIeP2.useRelayEnvironment)();
    const onOpenChange = (0, $4fqPo.useCallback)((open)=>{
        setIsOpen(open);
        // if customize is true and experience is not set, clear customize from the queryParam
        if (!open && customize === 'true' && !experience) (0, $wHtsq.clearSidebarExperienceAndCustomize)();
    }, [
        customize,
        experience
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'avatarMenu',
            version: '2',
            analyticsType: (0, $54jwS.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    const [openModal, setModalOpen] = (0, $4fqPo.useState)(false);
    // This state is used to track if the landing pages changeboarding spotlight has been viewed so that the avatar menu is not opened again on state change within same session of seeing change boarding spotlight.
    const [_, setAvatarMenuOpenedOnceForChangeboarding] = (0, $4fqPo.useState)(false);
    const [title, setTitle] = (0, $4fqPo.useState)('');
    const [description, setDescription] = (0, $4fqPo.useState)('');
    const content = ()=>{
        const { myRequestCount: myRequestCount, customMenuLinks: customMenuLinks, onLogoutClick: onLogoutClick, openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, routeName: routeName, pendingApprovalCount: pendingApprovalCount, approvalCount: approvalCount, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, avatarSrc: avatarSrc, displayName: displayName, email: email, hoistedProjectKey: hoistedProjectKey, areCustomerServiceSettingsLinksAvailable: areCustomerServiceSettingsLinksAvailable, jiraDisplayUrl: jiraDisplayUrl } = props;
        const isServiceHub = !!((0, $bG6ob.isJsmCsMasterFlagEnabled)() && hoistedProjectKey);
        const virtualAgentAllowed = (0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        const showAvatarMenuItemsUpsells = (0, $ebpTf.getIsHCCustomizationEnabled)() || Boolean(hasSiteAdministerAccess);
        const showVirtualAgentMenu = !(0, $bG6ob.isHideVsaEndpointsEnabled)() && canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && virtualAgentAllowed && !(0, $chA55.isPremiumUpsellExperimentEnabled)({
            hasSiteAdministerAccess: hasSiteAdministerAccess,
            isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
        });
        // Feature gate: jsm_help_center_one-click_rovo_agent
        // Rovo Agent menu is independent of VSA settings
        const rovoAgentAllowed = (0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent');
        const showRovoAgentMenu = canAdministerJIRA && !isServiceHub && !isSmallScreen && !(0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && rovoAgentAllowed;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$Wrapper, {
            "aria-label": formatMessage((0, $gJ7ty.default).tooltip),
            "data-testid": "avatar-menu-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2dYW6.default), {
            maxHeight: $143ecd97571c492e$var$maxHeight,
            spacing: 'cozy'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kupV4.AccountDetails), {
            avatarSrc: avatarSrc,
            displayName: displayName,
            email: email
        }), $143ecd97571c492e$var$TopMenu(myRequestCount || 0, onItemClick, pendingApprovalCount || 0, approvalCount || 0, isHelpCenterManagementScreen), !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, canAdministerJIRA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
            hasSeparator: !isSmallScreen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "ul",
            xcss: $143ecd97571c492e$var$listItemStyles,
            key: "help-center-menu",
            // @ts-ignore - aria-label is valid for ul elements
            "aria-label": formatMessage((0, $gJ7ty.default).helpCenterMenuOptions)
        }, !isSmallScreen && !isServiceHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$RenderHCSection, {
            showAvatarMenuItemsUpsells: showAvatarMenuItemsUpsells,
            setTitle: setTitle,
            setDescription: setDescription,
            setModalOpen: setModalOpen,
            onClick: onItemClick,
            hasSiteAdministerAccess: hasSiteAdministerAccess
        }), canCustomiseHelpCenter && (isHomepage || isServiceHub) && $143ecd97571c492e$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, routeName, basePath, areCustomerServiceSettingsLinksAvailable, showAvatarMenuItemsUpsells, hoistedProjectKey, jiraDisplayUrl, isServiceHub), showRovoAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: "customize-menu_rovo_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5G1MC.RovoAgentMenu), {
            onClose: onItemClick,
            component: $143ecd97571c492e$var$CustomAnchor
        })), showVirtualAgentMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ListItemWrapper, {
            key: "customize-menu_virtual_agent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e5VNr.VirtualAgentMenu), {
            onClose: onItemClick,
            component: $143ecd97571c492e$var$CustomAnchor
        })))), customMenuLinks && customMenuLinks.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
            hasSeparator: customMenuLinks && customMenuLinks.length > 0
        }, (0, $bG6ob.isWrmOptimizationsEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$UserProfileConnectActionLinks, {
            customMenuLinks: customMenuLinks,
            onClose: onItemClick
        }) : $143ecd97571c492e$var$buildCustomMenuLinks(customMenuLinks, onItemClick)) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$export$e0ae4b37130667df, {
            onClose: onItemClick
        })), $143ecd97571c492e$var$menuBottomSection(onItemClick, isHelpCenterManagementScreen, onLogoutClick)), displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
            experience: (0, $dvLMh.avatarMenuExperience)
        }));
    };
    const handleUpgradeModalNext = (0, $4fqPo.useCallback)(()=>{
        setModalOpen(false);
        window.open((0, $Y85G3.getBillingUrl)([
            'jira-servicedesk'
        ], (0, $6mmHn.getCloudId)()), '_blank');
    }, []);
    const Trigger = (0, $4fqPo.useCallback)((triggerProps)=>{
        const { avatarSrc: avatarSrc, disableAvatarMenu: disableAvatarMenu = false, pendingApprovalCount: pendingApprovalCount = 0, myRequestCount: myRequestCount = 0 } = props;
        const totalRequests = pendingApprovalCount + myRequestCount;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, !((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && (0, $bG6ob.isJsmCsMasterFlagEnabled)()) && totalRequests > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$StyledAvatarBadge, null, totalRequests), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$ProfileContainer, {
            disabled: disableAvatarMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $33cQv.default), {
            name: (0, $748yq.EngagementMessagesTarget).CHANGE_BOARDING_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d3YBt.Profile), {
            ...triggerProps,
            isDisabled: disableAvatarMenu,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aHUNw.default), {
                src: avatarSrc,
                borderColor: "var(--ds-border-inverse, #FFFFFF)"
            }),
            isSelected: isOpen,
            onClick: ()=>{
                onOpenChange(!isOpen);
            },
            "aria-label": formatMessage((0, $gJ7ty.default).tooltip),
            tooltip: formatMessage((0, $gJ7ty.default).tooltip),
            testId: "user-avatar-container-2"
        }))));
    }, [
        props,
        isOpen,
        formatMessage,
        onOpenChange
    ]);
    const renderDropdownMenu = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2nGAn.default), {
            blanketIsTinted: true,
            onBlanketClicked: ()=>setAvatarMenuOpenedOnceForChangeboarding(true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2KBf4.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
            isOpen: isOpen,
            shouldRenderToParent: true,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            zIndex: (0, $hDp3n.layers).modal(),
            content: content,
            trigger: Trigger,
            // This is required to close the open menu when clicking outside of the menu
            // A complex use case hence attaching a video of the same https://www.loom.com/share/95aa9f0112dd4e028194397e8dfeabea?sid=ef970902-843d-4b62-a578-3ec0f1f1b273
            // shouldUseCaptureOnOutsideClick
            key: 'avatar-menu-dumb-v2-popup'
        })));
    };
    const renderError = (0, $4fqPo.useCallback)((error)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dvLMh.AvatarMenuExperienceFailure), {
            message: error.message
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        onError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($143ecd97571c492e$var$AvatarMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6Cmwn.ForgeModalContextProvider), {
        type: (0, $adk9i.USER_MENU_ACTION_SECTION_MODULE)
    }, renderDropdownMenu(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1mJUv.ForgeActionModule), {
        type: (0, $adk9i.USER_MENU_ACTION_SECTION_MODULE),
        componentName: (0, $adk9i.USER_MENU_ACTION_COMPONENT)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, openModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3aJkj.UpgradeModal), {
        onNext: handleUpgradeModalNext,
        onClose: ()=>setModalOpen(false),
        title: title,
        description: description
    })));
};
$143ecd97571c492e$var$AvatarMenuDumbV2.defaultProps = {
    customMenuLinks: []
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $143ecd97571c492e$var$AvatarMenuContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_u5f3u2gc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$NoUnderlineLink = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1P8FK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$Wrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1tvnsw3": (0, $3f61e.default)($bpWyP.multiple(29.25).px),
            "--_1rpxolo": (0, $3f61e.default)($bpWyP.multiple(100).px)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1ul94vv4 _p12f15fr _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$StyledAvatarBadge = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $kmGir.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_kqswstnw _1ltvidpf _94n5idpf _1pby1kze",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$CustomLink = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = $143ecd97571c492e$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_syaz261p _b8xz168b",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$CustomButton = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1HSOM.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$CustomAnchor = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $eiGUu.HtmlAnchor), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz261p _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$ProfileContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "",
            __cmplp.disabled ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $143ecd97571c492e$var$maxHeight = `calc(100vh - ${$bpWyP.multiple(24).px}`;
const $143ecd97571c492e$var$pageLayoutPremiumPopUp = (0, $2m8U6.xcss)({
    padding: 'space.200',
    maxWidth: '256px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 'radius.xlarge',
    gap: 'space.100'
});
const $143ecd97571c492e$var$customPressableStyles = (0, $2m8U6.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $143ecd97571c492e$var$listItemStyles = (0, $2m8U6.xcss)({
    listStyleType: 'none',
    padding: 'space.0',
    margin: 'space.0'
});
var $143ecd97571c492e$export$2e2bcd8739ae039 = $143ecd97571c492e$var$AvatarMenuDumbV2;

});
parcelRegister("kmGir", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad3564fa71f1e954$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
// This is the current styling of Badge in AtlasKit. It
// has been duplicated here since AtlasKit does not allow
// color styling at the moment.
// Changed to use atlaskit/badge once https://ecosystem.atlassian.net/browse/AK-4187 resolved
// Suppressing existing violation. Please fix this.
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ad3564fa71f1e954$var$ThemedBadge = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1s9354m-0"
})`background-color:${(props)=>`var(--ds-background-selected-bold, ${props.theme.color})`};border-radius:2em;color:${(props)=>props.theme.readableTextColor};display:inline-block;font-size:12px;font-weight:normal;line-height:1;min-width:1px;padding:0.16666666666667em ${"var(--ds-space-075, 6px)"};text-align:center;`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$ad3564fa71f1e954$export$2e2bcd8739ae039 = $ad3564fa71f1e954$var$ThemedBadge;

});

parcelRegister("cfx3H", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", () => $851852a949139304$export$36d45daa6a4925b8);
$parcel$export(module.exports, "ConnectFragment", () => $851852a949139304$export$aa8ab018415f92e4);
$parcel$export(module.exports, "ConnectFragmentDumb", () => $851852a949139304$export$3cdf4f8c52fabf27);
$parcel$export(module.exports, "ConnectFragmentsDumb", () => $851852a949139304$export$93e3ab580ab70dd6);

var $bG6ob = parcelRequire("bG6ob");

var $63sfu = parcelRequire("63sfu");

var $keOG0 = parcelRequire("keOG0");

var $kXlzl = parcelRequire("kXlzl");

var $24WaN = parcelRequire("24WaN");

var $iwOiX = parcelRequire("iwOiX");

var $exyTO = parcelRequire("exyTO");

var $36Pct = parcelRequire("36Pct");

var $h6PK5 = parcelRequire("h6PK5");

var $c1L1r = parcelRequire("c1L1r");

var $hGOIV = parcelRequire("hGOIV");
const $851852a949139304$export$36d45daa6a4925b8 = (0, $63sfu.once)(()=>{
    try {
        (0, $24WaN.awaitGlobal)('connectHost', (0, $iwOiX.default));
    } catch (e) {
        (0, $keOG0.trackError)('connect.fragment.init.failed', {}, e);
        (0, $kXlzl.operationalEvent)({
            action: 'failed',
            actionSubject: 'connectFragmentInit',
            source: 'unknownSource',
            attributes: {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                errorMessage: e.message
            }
        });
    }
});
const $851852a949139304$export$aa8ab018415f92e4 = (0, $bG6ob.isWrmOptimizationsEnabled)() ? (0, $exyTO.withDeferredWrmLoaded)((0, $c1L1r.default), $851852a949139304$export$36d45daa6a4925b8) : (0, $c1L1r.default);
const $851852a949139304$export$3cdf4f8c52fabf27 = (0, $bG6ob.isWrmOptimizationsEnabled)() ? (0, $exyTO.withDeferredWrmLoaded)((0, $36Pct.default), $851852a949139304$export$36d45daa6a4925b8) : (0, $36Pct.default);
const $851852a949139304$export$93e3ab580ab70dd6 = (0, $bG6ob.isWrmOptimizationsEnabled)() ? (0, $exyTO.withDeferredWrmLoaded)((0, $h6PK5.default), $851852a949139304$export$36d45daa6a4925b8) : (0, $h6PK5.default);

});
parcelRegister("exyTO", function(module, exports) {
$parcel$export(module.exports, "withDeferredWrmLoaded", () => $66b2b4993a5b7489$export$ae0e017d29ba244d);

var $4fqPo = parcelRequire("4fqPo");

var $cjgvu = parcelRequire("cjgvu");
const $66b2b4993a5b7489$export$ae0e017d29ba244d = (Component, onLoad)=>{
    const ComponentWithDeferredWrmLoaded = (props)=>{
        const { resourcesLoaded: resourcesLoaded } = $4fqPo.useContext((0, $cjgvu.DeferredWrmResourceContext));
        $4fqPo.useEffect(()=>{
            if (resourcesLoaded) onLoad();
        }, [
            resourcesLoaded
        ]);
        if (!resourcesLoaded) return null;
        return /*#__PURE__*/ $4fqPo.createElement(Component, props);
    };
    return ComponentWithDeferredWrmLoaded;
};

});

parcelRegister("c1L1r", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b55075ca7f551be$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("g3u0z");
var $lWKdO = parcelRequire("lWKdO");

var $1v2I9 = parcelRequire("1v2I9");
parcelRequire("gU2Af");
var $5gvbl = parcelRequire("5gvbl");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $hGOIV = parcelRequire("hGOIV");
const $4b55075ca7f551be$var$selector = (0, $3yyCx.createSelector)((state, componentProps)=>{
    const { page: page, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey } = componentProps;
    const projectId = state ? (0, $95tqy.getProjectId)(state, portalId) : undefined;
    const connectFragments = (0, $5gvbl.getConnectAddonPanels)({
        state: state,
        location: location,
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey,
        pageName: page
    });
    return {
        connectFragments: connectFragments,
        projectId: projectId
    };
}, (props)=>props);
const $4b55075ca7f551be$var$ConnectFragmentWithAnalytics = (0, $apbG6.default)({
    componentName: 'ConnectFragment'
})((0, $as4kh.default)({})((0, $hGOIV.ConnectFragment)));
var $4b55075ca7f551be$export$2e2bcd8739ae039 = (0, $bmgw6.default)($4b55075ca7f551be$var$selector, {
    fetchConnectFragments: (0, $lWKdO.fetchConnectFragmentsAction),
    ...(0, $1v2I9.mapConnectDispatchToPropsBanner)
})($4b55075ca7f551be$var$ConnectFragmentWithAnalytics);

});
parcelRegister("gU2Af", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => (parcelRequire("5gvbl")).getConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => (parcelRequire("5gvbl")).getProfileConnectAddonPanels);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => (parcelRequire("5gvbl")).getProfileConnectAddonActions);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => (parcelRequire("5gvbl")).getRequestSpecificConnectAddonPanels);

var $5gvbl = parcelRequire("5gvbl");

});
parcelRegister("5gvbl", function(module, exports) {
$parcel$export(module.exports, "getConnectAddonPanels", () => $a7a95f8bc2d76725$export$be753636105743d4);
$parcel$export(module.exports, "getRequestSpecificConnectAddonPanels", () => $a7a95f8bc2d76725$export$5d04f04eeff342cb);
$parcel$export(module.exports, "getProfileConnectAddonPanels", () => $a7a95f8bc2d76725$export$e91bb9a5dede3485);
$parcel$export(module.exports, "getProfileConnectAddonActions", () => $a7a95f8bc2d76725$export$43a1e23f8855f249);
parcelRequire("kWwNi");
var $kMjJD = parcelRequire("kMjJD");
const $a7a95f8bc2d76725$export$be753636105743d4 = ({ state: state, pageName: pageName, location: location, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>{
    switch(location){
        case 'detailsPanels':
        case 'optionPanels':
            return $a7a95f8bc2d76725$export$5d04f04eeff342cb({
                state: state,
                location: location,
                requestKey: requestKey
            });
        default:
            {
                const page = state.persisted.connectFragments[(0, $kMjJD.generateKey)(pageName, portalId, requestTypeId, requestKey)];
                // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return page && page[location];
            }
    }
};
const $a7a95f8bc2d76725$export$5d04f04eeff342cb = ({ state: state, location: location, requestKey: requestKey })=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestDetailsForKey = requestKey && state && state.persisted && state.persisted.requestDetails[requestKey];
    // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return requestDetailsForKey ? requestDetailsForKey[location] : [];
};
const $a7a95f8bc2d76725$export$e91bb9a5dede3485 = (state)=>{
    return state.persisted.profileWebFragments.panels;
};
const $a7a95f8bc2d76725$export$43a1e23f8855f249 = (state)=>{
    return state.persisted.profileWebFragments.actions;
};

});




parcelRegister("aeicL", function(module, exports) {
$parcel$export(module.exports, "default", () => $18fa1a9353cd2992$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $g6Afq = parcelRequire("g6Afq");

var $75i57 = parcelRequire("75i57");
const $18fa1a9353cd2992$export$25215e4c8f710ceb = ({ coordinationClient: coordinationClient, messageId: messageId, children: children })=>{
    if (!coordinationClient) return null;
    return /*#__PURE__*/ $4fqPo.createElement((0, $g6Afq.default), {
        client: coordinationClient,
        messageId: messageId
    }, children);
};
var $18fa1a9353cd2992$export$2e2bcd8739ae039 = (0, $75i57.withCoordinationClient)($18fa1a9353cd2992$export$25215e4c8f710ceb);

});
parcelRegister("g6Afq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e28bdbdbbc37a551$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
class $e28bdbdbbc37a551$export$2e2bcd8739ae039 extends (0, $4fqPo.PureComponent) {
    static #_ = this.defaultProps = {
        fallback: null
    };
    async componentDidMount() {
        const { client: client, messageId: messageId } = this.props;
        try {
            const started = await client.start(messageId);
            if (started) // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                shouldRenderChildren: true
            });
        } catch (err) {
            // eslint-disable-next-line no-console
            console.error(`Unable to start flow message ${messageId}. ${err}`);
        }
    }
    injectStop(children) {
        return /*#__PURE__*/ (0, $4fqPo.cloneElement)(children, {
            stop: this.stop
        });
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const { shouldRenderChildren: shouldRenderChildren } = this.state;
        return shouldRenderChildren ? this.injectStop(children) : fallback;
    }
    constructor(...args){
        super(...args), this.state = {
            shouldRenderChildren: false
        }, this.stop = async ()=>{
            const { client: client, messageId: messageId } = this.props;
            try {
                await client.stop(messageId);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(`Unable to stop flow message ${messageId}. ${err}`);
            }
        };
    }
}

});


parcelRegister("1mJUv", function(module, exports) {
$parcel$export(module.exports, "ForgeActionModule", () => $3d1d393523d24354$export$3f817dccc12b0bb3);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $3d1d393523d24354$export$3f817dccc12b0bb3 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("81SU1")), {
        moduleId: "./packages/common-utils/forge-action/src/forge-action.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("81SU1", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("2V398"),
    $e46AW("6N3bQ")
]).then(()=>parcelRequire('ep8RW'));

});


parcelRegister("aPtW9", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContext", () => $89475fb5ce280221$export$7ec9d631dd0c629a);
$parcel$export(module.exports, "ForgeModalContextConsumer", () => $89475fb5ce280221$export$15f67e1b244563e3);

var $4fqPo = parcelRequire("4fqPo");

var $63sfu = parcelRequire("63sfu");
const $89475fb5ce280221$export$7ec9d631dd0c629a = /*#__PURE__*/ $4fqPo.createContext({
    data: {
        extensions: new Map(),
        extensionToDisplay: '',
        extensionTitles: []
    },
    methods: {
        setExtensionToDisplay: (0, $63sfu.noop)
    }
});
$89475fb5ce280221$export$7ec9d631dd0c629a.displayName = 'ForgeModalContext';
const $89475fb5ce280221$export$15f67e1b244563e3 = $89475fb5ce280221$export$7ec9d631dd0c629a.Consumer;

});

parcelRegister("6Cmwn", function(module, exports) {
$parcel$export(module.exports, "ForgeModalContextProvider", () => $10584da2c7ed7c82$export$35485b69e4da19ba);

var $fVQGu = parcelRequire("fVQGu");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $10584da2c7ed7c82$export$35485b69e4da19ba = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("1EhkV")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/modal-context-provider/modal-context-provider.tsx"
    }),
    LoadingSkeleton: (0, $fVQGu.AvatarLoadingSkeleton)
});

});
parcelRegister("1EhkV", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("g9jIt").then(()=>parcelRequire('cHMpb'));

});


parcelRegister("9ijW8", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cc76ccfa7229e45$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
class $1cc76ccfa7229e45$export$2e2bcd8739ae039 extends $4fqPo.Component {
    componentDidMount() {
        const renderNextAnimationFrame = ()=>{
            window.requestAnimationFrame(()=>{
                window.requestAnimationFrame(()=>{
                    this.setState({
                        render: true
                    });
                });
            });
        };
        if (this.props.delay) window.setTimeout(renderNextAnimationFrame, this.props.delay);
        else renderNextAnimationFrame();
    }
    render() {
        return this.state.render ? this.props.children() : null;
    }
    constructor(...args){
        super(...args), this.state = {
            render: false
        };
    }
}

});

parcelRegister("jwb88", function(module, exports) {
$parcel$export(module.exports, "VaOnboardingSpotlight", () => $9b88f1d93531651d$export$9900d5bc23cb734);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $9b88f1d93531651d$export$9900d5bc23cb734 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("fP692")), {
        moduleId: "./packages/common-utils/va-reporting-onboarding/src/va-reporting-onboarding.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("fP692", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("gMZda"),
    $e46AW("86ale"),
    $e46AW("8zL0E")
]).then(()=>parcelRequire('cx0Pj'));

});


parcelRegister("d3YBt", function(module, exports) {
$parcel$export(module.exports, "Profile", () => $45a97f998a5860b4$export$5120f2d0b8d4cab8);

var $4fqPo = parcelRequire("4fqPo");

var $fb9U1 = parcelRequire("fb9U1");
const $45a97f998a5860b4$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        role: "listitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fb9U1.IconButton), {
        component: component,
        href: href,
        icon: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    }));
});

});
parcelRegister("fb9U1", function(module, exports) {
$parcel$export(module.exports, "IconButton", () => $b8934544392d1b74$export$c25acd513dcc8062);

var $4fqPo = parcelRequire("4fqPo");

var $dM8x1 = parcelRequire("dM8x1");

var $8Mj6h = parcelRequire("8Mj6h");

var $6dHvo = parcelRequire("6dHvo");

var $3dG4B = parcelRequire("3dG4B");
const $b8934544392d1b74$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $6dHvo.useTheme)();
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dM8x1.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $3dG4B.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled
    }, button);
    return button;
});

});
parcelRegister("6dHvo", function(module, exports) {
$parcel$export(module.exports, "useTheme", () => $8c7c80fe73bfbeb5$export$93d4e7f90805808f);

var $4fqPo = parcelRequire("4fqPo");

var $5a0b2 = parcelRequire("5a0b2");
const $8c7c80fe73bfbeb5$export$93d4e7f90805808f = ()=>(0, $4fqPo.useContext)((0, $5a0b2.ThemeContext));

});
parcelRegister("5a0b2", function(module, exports) {
$parcel$export(module.exports, "ThemeContext", () => $ac72b9aa1fac074c$export$2c657da244d00bd6);

var $4fqPo = parcelRequire("4fqPo");

var $7JUmF = parcelRequire("7JUmF");
const $ac72b9aa1fac074c$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $4fqPo.createContext)((0, $7JUmF.defaultTheme));

});
parcelRegister("7JUmF", function(module, exports) {
$parcel$export(module.exports, "defaultTheme", () => $5d3d422ecf5eedcb$export$164de7ab8df77ef0);

var $1PoL0 = parcelRequire("1PoL0");
const $5d3d422ecf5eedcb$export$164de7ab8df77ef0 = (0, $1PoL0.atlassianTheme);

});
parcelRegister("1PoL0", function(module, exports) {
$parcel$export(module.exports, "atlassianTheme", () => $9091b6dc42809593$export$eeee8619e1b91cb0);

var $jadRT = parcelRequire("jadRT");

var $1PnOD = parcelRequire("1PnOD");
const $9091b6dc42809593$export$eeee8619e1b91cb0 = (0, $1PnOD.generateTheme)({
    name: (0, $jadRT.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});

});
parcelRegister("jadRT", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_THEME_NAME", () => $ea76d5db9abe66d2$export$2491e13b198e597d);
$parcel$export(module.exports, "default", () => $ea76d5db9abe66d2$export$2e2bcd8739ae039);
const $ea76d5db9abe66d2$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $ea76d5db9abe66d2$var$defaultThemeCopy = JSON.parse(JSON.stringify($ea76d5db9abe66d2$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$ea76d5db9abe66d2$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$ea76d5db9abe66d2$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $ea76d5db9abe66d2$export$2491e13b198e597d = 'atlassian';
var $ea76d5db9abe66d2$export$2e2bcd8739ae039 = $ea76d5db9abe66d2$var$defaultTheme;

});

parcelRegister("1PnOD", function(module, exports) {
$parcel$export(module.exports, "generateTheme", () => $e070dbc47d5e9f4d$export$2e4ecffaca289a18);

var $jadRT = parcelRequire("jadRT");

var $a9xWb = parcelRequire("a9xWb");

var $3pr06 = parcelRequire("3pr06");

var $cU5nA = parcelRequire("cU5nA");

var $fjc5L = parcelRequire("fjc5L");

var $6CT6p = parcelRequire("6CT6p");
const $e070dbc47d5e9f4d$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $e070dbc47d5e9f4d$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $e070dbc47d5e9f4d$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $6CT6p.hexToRGBA)(backgroundColor, 0.65) : (0, $fjc5L.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $cU5nA.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $cU5nA.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $6CT6p.hexToRGBA)(backgroundColor, 0.8) : (0, $fjc5L.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $cU5nA.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $fjc5L.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $cU5nA.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $fjc5L.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $cU5nA.getBoxShadow)('transparent')
        }
    };
};
const $e070dbc47d5e9f4d$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $3pr06.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $e070dbc47d5e9f4d$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $3pr06.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $jadRT.DEFAULT_THEME_NAME)) return 0, $a9xWb.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $e070dbc47d5e9f4d$var$generateButtonCSSStates($e070dbc47d5e9f4d$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $e070dbc47d5e9f4d$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $e070dbc47d5e9f4d$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $6CT6p.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $6CT6p.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $6CT6p.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $cU5nA.getBoxShadow)((0, $6CT6p.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $fjc5L.getContrastColor)(0.1, $e070dbc47d5e9f4d$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};

});
parcelRegister("a9xWb", function(module, exports) {
$parcel$export(module.exports, "defaultThemeBrandRefresh", () => $7fb342038a024ee2$export$77823bc9863eaa03);

var $jadRT = parcelRequire("jadRT");
const $7fb342038a024ee2$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $jadRT.default)));
const $7fb342038a024ee2$export$77823bc9863eaa03 = $7fb342038a024ee2$var$defaultThemeCopy;

});

parcelRegister("3pr06", function(module, exports) {
$parcel$export(module.exports, "generateTextColor", () => $c7bd9edcbe73ed80$export$10a10e7cd1193377);

var $35AxV = parcelRequire("35AxV");

var $bfLPg = parcelRequire("bfLPg");
const $c7bd9edcbe73ed80$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $bfLPg.convertHexShorthand)(color);
    return (0, $35AxV.default).contrastRatio(converted).hex;
};

});
parcelRegister("35AxV", function(module, exports) {
$parcel$export(module.exports, "default", () => $23fe3005cd754819$export$2e2bcd8739ae039);
function $23fe3005cd754819$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $23fe3005cd754819$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $23fe3005cd754819$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $23fe3005cd754819$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $23fe3005cd754819$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $23fe3005cd754819$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $23fe3005cd754819$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $23fe3005cd754819$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $23fe3005cd754819$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $23fe3005cd754819$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $23fe3005cd754819$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $23fe3005cd754819$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $23fe3005cd754819$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $23fe3005cd754819$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $23fe3005cd754819$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $23fe3005cd754819$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $23fe3005cd754819$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $23fe3005cd754819$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $23fe3005cd754819$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $23fe3005cd754819$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $23fe3005cd754819$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $23fe3005cd754819$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $23fe3005cd754819$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $23fe3005cd754819$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $23fe3005cd754819$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $23fe3005cd754819$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $23fe3005cd754819$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $23fe3005cd754819$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $23fe3005cd754819$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $23fe3005cd754819$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $23fe3005cd754819$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $23fe3005cd754819$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $23fe3005cd754819$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $23fe3005cd754819$var$fromHex_1 = $23fe3005cd754819$var$fromHex, $23fe3005cd754819$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $23fe3005cd754819$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $23fe3005cd754819$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $23fe3005cd754819$var$fromRgb_1 = $23fe3005cd754819$var$fromRgb, $23fe3005cd754819$var$fromCssRgb_1 = $23fe3005cd754819$var$fromCssRgb, $23fe3005cd754819$var$fromHsl_1 = $23fe3005cd754819$var$fromHsl, $23fe3005cd754819$var$fromCssHsl_1 = $23fe3005cd754819$var$fromCssHsl, $23fe3005cd754819$var$fromHsv_1 = $23fe3005cd754819$var$fromHsv, $23fe3005cd754819$var$fromCmyk_1 = $23fe3005cd754819$var$fromCmyk, $23fe3005cd754819$var$fromYiq_1 = $23fe3005cd754819$var$fromYiq, $23fe3005cd754819$var$fromXYZ_1 = $23fe3005cd754819$var$fromXYZ, $23fe3005cd754819$var$fromxyY_1 = $23fe3005cd754819$var$fromxyY, $23fe3005cd754819$var$fromLms_1 = $23fe3005cd754819$var$fromLms, $23fe3005cd754819$var$fromCieLab_1 = $23fe3005cd754819$var$fromCieLab, $23fe3005cd754819$var$fromCieLuv_1 = $23fe3005cd754819$var$fromCieLuv, $23fe3005cd754819$var$fromCieLch_1 = $23fe3005cd754819$var$fromCieLch, $23fe3005cd754819$var$fromHsluv = $23fe3005cd754819$var$fromCieLch$1, $23fe3005cd754819$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $23fe3005cd754819$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $23fe3005cd754819$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $23fe3005cd754819$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $23fe3005cd754819$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $23fe3005cd754819$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $23fe3005cd754819$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $23fe3005cd754819$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $23fe3005cd754819$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $23fe3005cd754819$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $23fe3005cd754819$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $23fe3005cd754819$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $23fe3005cd754819$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $23fe3005cd754819$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $23fe3005cd754819$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $23fe3005cd754819$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $23fe3005cd754819$var$fromHsluv
    }
}, $23fe3005cd754819$var$adapt_1 = $23fe3005cd754819$var$adapt, $23fe3005cd754819$var$adjacent_1 = $23fe3005cd754819$var$adjacent, $23fe3005cd754819$var$brightness_1 = $23fe3005cd754819$var$brightness, $23fe3005cd754819$var$complementary_1 = $23fe3005cd754819$var$complementary, $23fe3005cd754819$var$contrast_1 = $23fe3005cd754819$var$contrast, $23fe3005cd754819$var$contrastRatio_1 = $23fe3005cd754819$var$contrastRatio, $23fe3005cd754819$var$convert_1 = $23fe3005cd754819$var$convert, $23fe3005cd754819$var$difference_1 = $23fe3005cd754819$var$difference, $23fe3005cd754819$var$fade_1 = $23fe3005cd754819$var$fade, $23fe3005cd754819$var$greyscale_1 = $23fe3005cd754819$var$greyscale, $23fe3005cd754819$var$hue_1 = $23fe3005cd754819$var$hue, $23fe3005cd754819$var$invert_1 = $23fe3005cd754819$var$invert, $23fe3005cd754819$var$invertLightness_1 = $23fe3005cd754819$var$invertLightness, $23fe3005cd754819$var$mid_1 = $23fe3005cd754819$var$mid, $23fe3005cd754819$var$multiply_1 = $23fe3005cd754819$var$multiply, $23fe3005cd754819$var$saturation_1 = $23fe3005cd754819$var$saturation, $23fe3005cd754819$var$sepia_1 = $23fe3005cd754819$var$sepia, $23fe3005cd754819$var$shade_1 = $23fe3005cd754819$var$shade, $23fe3005cd754819$var$temperature_1 = $23fe3005cd754819$var$temperature, $23fe3005cd754819$var$tetrad_1 = $23fe3005cd754819$var$tetrad, $23fe3005cd754819$var$triad_1 = $23fe3005cd754819$var$triad, $23fe3005cd754819$var$index$2 = {
    adapt: $23fe3005cd754819$var$adapt_1,
    adjacent: $23fe3005cd754819$var$adjacent_1,
    brightness: $23fe3005cd754819$var$brightness_1,
    complementary: $23fe3005cd754819$var$complementary_1,
    contrast: $23fe3005cd754819$var$contrast_1,
    contrastRatio: $23fe3005cd754819$var$contrastRatio_1,
    convert: $23fe3005cd754819$var$convert_1,
    difference: $23fe3005cd754819$var$difference_1,
    fade: $23fe3005cd754819$var$fade_1,
    greyscale: $23fe3005cd754819$var$greyscale_1,
    hue: $23fe3005cd754819$var$hue_1,
    invert: $23fe3005cd754819$var$invert_1,
    invertLightness: $23fe3005cd754819$var$invertLightness_1,
    mid: $23fe3005cd754819$var$mid_1,
    multiply: $23fe3005cd754819$var$multiply_1,
    saturation: $23fe3005cd754819$var$saturation_1,
    sepia: $23fe3005cd754819$var$sepia_1,
    shade: $23fe3005cd754819$var$shade_1,
    temperature: $23fe3005cd754819$var$temperature_1,
    tetrad: $23fe3005cd754819$var$tetrad_1,
    triad: $23fe3005cd754819$var$triad_1
}, $23fe3005cd754819$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $23fe3005cd754819$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $23fe3005cd754819$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($23fe3005cd754819$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $23fe3005cd754819$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($23fe3005cd754819$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $23fe3005cd754819$var$api_1 = $23fe3005cd754819$var$api, $23fe3005cd754819$var$helpers = {
    getIlluminant: function(r) {
        return $23fe3005cd754819$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $23fe3005cd754819$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $23fe3005cd754819$var$index)if ($23fe3005cd754819$var$index.hasOwnProperty(e) && $23fe3005cd754819$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $23fe3005cd754819$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $23fe3005cd754819$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $23fe3005cd754819$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $23fe3005cd754819$var$constants, s));
            default:
                return null;
        }
    }
}, $23fe3005cd754819$var$helpers_1 = $23fe3005cd754819$var$helpers, $23fe3005cd754819$var$dependencies = {
    conversions: $23fe3005cd754819$var$index,
    operations: $23fe3005cd754819$var$index$2,
    helpers: $23fe3005cd754819$var$helpers_1
}, $23fe3005cd754819$var$entry = $23fe3005cd754819$var$api_1($23fe3005cd754819$var$dependencies, $23fe3005cd754819$var$constants);
var $23fe3005cd754819$export$2e2bcd8739ae039 = $23fe3005cd754819$var$entry;

});

parcelRegister("bfLPg", function(module, exports) {
$parcel$export(module.exports, "convertHexShorthand", () => $45409fc18f5d2334$export$db8d2130677f868c);
const $45409fc18f5d2334$var$hex = '[a-z0-9]';
const $45409fc18f5d2334$var$shortHandHexColorPattern = new RegExp(`#(${$45409fc18f5d2334$var$hex})(${$45409fc18f5d2334$var$hex})(${$45409fc18f5d2334$var$hex})`, 'i');
const $45409fc18f5d2334$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $45409fc18f5d2334$var$isShortHexColor = (color)=>color && color.length === 4;
const $45409fc18f5d2334$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$45409fc18f5d2334$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $45409fc18f5d2334$var$completeTriplet = (colors)=>`#${$45409fc18f5d2334$var$repeat(colors[1], 6)}`;
const $45409fc18f5d2334$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $45409fc18f5d2334$export$db8d2130677f868c = (color)=>{
    if ($45409fc18f5d2334$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($45409fc18f5d2334$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($45409fc18f5d2334$var$isTriplet(colors)) return $45409fc18f5d2334$var$completeTriplet(colors);
            else return $45409fc18f5d2334$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};

});


parcelRegister("cU5nA", function(module, exports) {
$parcel$export(module.exports, "getBoxShadow", () => $4b52268ba096e4c3$export$bba5a971afe05444);
const $4b52268ba096e4c3$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;

});

parcelRegister("fjc5L", function(module, exports) {
$parcel$export(module.exports, "getContrastColor", () => $132036df428682d8$export$77a1051494882576);

var $35AxV = parcelRequire("35AxV");

var $6CT6p = parcelRequire("6CT6p");
const $132036df428682d8$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $6CT6p.hexToRGBA)((0, $35AxV.default).contrast(contrastValue, color).hex, opacityValue);

});
parcelRegister("6CT6p", function(module, exports) {
$parcel$export(module.exports, "hexToRGBA", () => $216373d32a684158$export$7229be6d7219ee6a);

var $35AxV = parcelRequire("35AxV");
const $216373d32a684158$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $35AxV.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};

});







parcelRegister("3dG4B", function(module, exports) {
$parcel$export(module.exports, "getIconButtonTheme", () => $dfab36677281f95a$export$f32bddcb857301f3);
const $dfab36677281f95a$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});



parcelRegister("cIQ4S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9431fda47a6c2b62$var$_react = $9431fda47a6c2b62$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $9431fda47a6c2b62$var$_baseNew = $9431fda47a6c2b62$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $9431fda47a6c2b62$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9431fda47a6c2b62$var$EditionsIcon = (props)=>/*#__PURE__*/ $9431fda47a6c2b62$var$_react.default.createElement($9431fda47a6c2b62$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$9431fda47a6c2b62$var$EditionsIcon.displayName = 'EditionsIcon';
var $9431fda47a6c2b62$var$_default = module.exports.default = $9431fda47a6c2b62$var$EditionsIcon;

});

parcelRegister("hHIxn", function(module, exports) {
$parcel$export(module.exports, "default", () => $46f34004ec123e35$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9XaAY = parcelRequire("9XaAY");

var $lFnTx = parcelRequire("lFnTx");
const $46f34004ec123e35$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $46f34004ec123e35$var$CustomItem = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ component: Component, isDisabled: isDisabled = false, isSelected: isSelected = false, isTitleHeading: isTitleHeading = false, onClick: onClick, testId: testId, children: children, description: description, iconAfter: iconAfter, iconBefore: iconBefore, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest }, ref)=>{
    const onMouseDownHandler = onMouseDown;
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $4fqPo.createElement((0, $lFnTx.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        ...rest,
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ $4fqPo.createElement(Component, {
            "data-testid": testId,
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $46f34004ec123e35$var$preventEvent
            },
            onMouseDown: isDisabled ? $46f34004ec123e35$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $46f34004ec123e35$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }, children));
}));
var $46f34004ec123e35$export$2e2bcd8739ae039 = $46f34004ec123e35$var$CustomItem;

});

parcelRegister("aYVUY", function(module, exports) {
$parcel$export(module.exports, "default", () => $421eeebf7913ed2c$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $421eeebf7913ed2c$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $421eeebf7913ed2c$var$HeadingItem = /*#__PURE__*/ (0, $4fqPo.memo)(({ children: children, testId: testId, headingLevel: headingLevel = 2, id: id, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu",
            UNSAFE_className
        ]),
        ...rest
    }, children);
});
var $421eeebf7913ed2c$export$2e2bcd8739ae039 = $421eeebf7913ed2c$var$HeadingItem;

});

parcelRegister("2dYW6", function(module, exports) {
$parcel$export(module.exports, "default", () => $99860864a7f11cf8$export$2e2bcd8739ae039);
/* menu-group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $HFx74 = parcelRequire("HFx74");

var $c70rl = parcelRequire("c70rl");
const $99860864a7f11cf8$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $99860864a7f11cf8$var$MenuGroup = ({ isLoading: isLoading, maxWidth: maxWidth, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight, testId: testId, role: role, spacing: spacing = 'cozy', menuLabel: menuLabel, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest })=>/*#__PURE__*/ $4fqPo.createElement((0, $HFx74.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $4fqPo.createElement((0, $c70rl.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel,
        ...rest
    })));
var $99860864a7f11cf8$export$2e2bcd8739ae039 = $99860864a7f11cf8$var$MenuGroup;

});

parcelRegister("45ZUo", function(module, exports) {
$parcel$export(module.exports, "default", () => $df18eb39ff1ea7bd$export$2e2bcd8739ae039);
/* section.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $aYVUY = parcelRequire("aYVUY");
const $df18eb39ff1ea7bd$var$itemHeadingTopMargin = 20;
const $df18eb39ff1ea7bd$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
const $df18eb39ff1ea7bd$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
const $df18eb39ff1ea7bd$var$skeletonHeadingHeight = 8;
const $df18eb39ff1ea7bd$var$skeletonHeadingMarginOffset = 3;
const $df18eb39ff1ea7bd$var$skeletonHeadingTopMargin = $df18eb39ff1ea7bd$var$itemHeadingTopMargin + ($df18eb39ff1ea7bd$var$itemHeadingContentHeight - $df18eb39ff1ea7bd$var$skeletonHeadingHeight) - $df18eb39ff1ea7bd$var$skeletonHeadingMarginOffset;
const $df18eb39ff1ea7bd$var$sectionPaddingTopBottom = 6;
const $df18eb39ff1ea7bd$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm2lllh",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $df18eb39ff1ea7bd$var$Section = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, title: title, titleId: titleId, testId: testId, isScrollable: isScrollable, hasSeparator: hasSeparator, id: id, isList: isList = false, isSideNavSection: isSideNavSection = false, label: label, // Although this isn't defined on props it is available because we've used
// Spread props below and on the jsx element. To forcibly block usage I've
// picked it out and supressed the expected type error.
// @ts-expect-error
className: UNSAFE_className, ...rest }, ref)=>{
    const content = isList ? /*#__PURE__*/ $4fqPo.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $4fqPo.Children).map((0, $4fqPo.Children).toArray(children), (child, index)=>/*#__PURE__*/ $4fqPo.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child))) : children;
    const childrenMarkup = title !== undefined ? /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement((0, $aYVUY.default), {
        testId: testId && `${testId}--heading`,
        "aria-hidden": true,
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $ltgDR.default)([
            isSideNavSection && $df18eb39ff1ea7bd$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, content);
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ltgDR.default)([
            $df18eb39ff1ea7bd$var$styles.root,
            isScrollable ? $df18eb39ff1ea7bd$var$styles.scrollable : $df18eb39ff1ea7bd$var$styles.unscrollable,
            hasSeparator ? $df18eb39ff1ea7bd$var$styles.thinSeparator : $df18eb39ff1ea7bd$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        // NOTE: Firefox allows elements that have "overflow: auto" to gain focus (as if it had tab-index="0")
        // We have made a deliberate choice to leave this behaviour as is.
        "aria-label": title || label,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }, childrenMarkup);
});
var $df18eb39ff1ea7bd$export$2e2bcd8739ae039 = $df18eb39ff1ea7bd$var$Section;

});

parcelRegister("kCZZw", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d156ce48b1c94c2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $eO5yD = parcelRequire("eO5yD");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $8d156ce48b1c94c2$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eO5yD.default), {
        appear: true
    }, //Checking if children are undefined to prevent potential runtime errors in React 17
    props.children ?? null);
};
var $8d156ce48b1c94c2$export$2e2bcd8739ae039 = $8d156ce48b1c94c2$var$ModalTransition;

});

parcelRegister("33cQv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2934b32c8de24fd6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $4WUhv = parcelRequire("4WUhv");

var $2nGAn = parcelRequire("2nGAn");
/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $2934b32c8de24fd6$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2nGAn.TargetConsumer), null, (getTargetRef)=>{
        if (typeof children === 'function') return children({
            targetRef: getTargetRef === null || getTargetRef === void 0 ? void 0 : getTargetRef(name)
        });
        return getTargetRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4WUhv.default), {
            name: name,
            hasNodeResolver: !(0, $3H4LK.fg)('platform_design_system_team_onboarding_noderesolve'),
            getTargetRef: getTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children)) : children;
    });
$2934b32c8de24fd6$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $2934b32c8de24fd6$export$2e2bcd8739ae039 = $2934b32c8de24fd6$var$SpotlightTarget;

});
parcelRegister("4WUhv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2619a8addd2d52c6$export$2e2bcd8739ae039);
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3pvkM = parcelRequire("3pvkM");
const $2619a8addd2d52c6$var$spanStyles = null;
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {string} props.name - The name to reference from Spotlight.
 * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $2619a8addd2d52c6$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $4fqPo.useRef)(null);
    (0, $4fqPo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) {
            var _divRef$current;
            targetRef((_divRef$current = divRef.current) === null || _divRef$current === void 0 ? void 0 : _divRef$current.firstElementChild);
        }
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3pvkM))), {
        innerRef: getTargetRef(name)
    }, children);
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        ref: divRef,
        className: (0, $ltgDR.default)([
            "_1e0c1bgi"
        ])
    }, children);
};
$2619a8addd2d52c6$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $2619a8addd2d52c6$export$2e2bcd8739ae039 = $2619a8addd2d52c6$var$NodeResolverSpotlightTarget;

});
parcelRegister("3pvkM", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cfT9u = parcelRequire("cfT9u");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $27bc033506bd81cb$var$_interopRequireDefault($cfT9u).default;
    }
});
function $27bc033506bd81cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("cfT9u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8ec1aad04d1cbd8e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");
function $8ec1aad04d1cbd8e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8ec1aad04d1cbd8e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8ec1aad04d1cbd8e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8ec1aad04d1cbd8e$var$NodeResolver = function(_Component) {
    $8ec1aad04d1cbd8e$var$_inherits(NodeResolver, _Component);
    function NodeResolver() {
        $8ec1aad04d1cbd8e$var$_classCallCheck(this, NodeResolver);
        return $8ec1aad04d1cbd8e$var$_possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
    }
    $8ec1aad04d1cbd8e$var$_createClass(NodeResolver, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.props.innerRef((0, $b2Ka1.findDOMNode)(this));
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: 'render',
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}($4fqPo.Component);
module.exports.default = $8ec1aad04d1cbd8e$var$NodeResolver;

});




parcelRegister("kBDWz", function(module, exports) {
$parcel$export(module.exports, "SpotlightTransitionConsumer", () => $73460e94b993af91$export$7d63b19b854c2fe8);
$parcel$export(module.exports, "default", () => $73460e94b993af91$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");
const $73460e94b993af91$var$SpotlightTransitionContext = /*#__PURE__*/ (0, $4fqPo.createContext)({
    isOpen: true,
    onExited: (0, $c1tmZ.default)
});
// checks if children exist and are truthy
const $73460e94b993af91$var$hasChildren = (children)=>{
    var _React$Children$map;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.count(children) > 0 && (((_React$Children$map = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(children || false, (child)=>!!child)) === null || _React$Children$map === void 0 || (_React$Children$map = _React$Children$map.filter(Boolean)) === null || _React$Children$map === void 0 ? void 0 : _React$Children$map.length) || 0) > 0;
};
/**
 * __Spotlight transition__
 *
 * A spotlight transition holds onto spotlights so they can fade out when exiting the viewport.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ // eslint-disable-next-line @repo/internal/react/no-class-components
class $73460e94b993af91$var$SpotlightTransition extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    static getDerivedStateFromProps(props, state) {
        const { currentChildren: previousChildren } = state;
        const exiting = $73460e94b993af91$var$hasChildren(previousChildren) && !$73460e94b993af91$var$hasChildren(props.children);
        return {
            currentChildren: exiting ? previousChildren : props.children
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($73460e94b993af91$var$SpotlightTransitionContext.Provider, {
            value: {
                onExited: this.onExited,
                isOpen: $73460e94b993af91$var$hasChildren(this.props.children)
            }
        }, this.state.currentChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            currentChildren: undefined
        }, this.onExited = ()=>{
            this.setState({
                currentChildren: this.props.children
            });
        };
    }
}
const $73460e94b993af91$export$7d63b19b854c2fe8 = $73460e94b993af91$var$SpotlightTransitionContext.Consumer;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$73460e94b993af91$export$2e2bcd8739ae039 = $73460e94b993af91$var$SpotlightTransition;

});

parcelRegister("6xwRI", function(module, exports) {
$parcel$export(module.exports, "FireUIAnalytics", () => $0f38975317b731cf$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $0f38975317b731cf$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireScreenAnalytics", () => $0f38975317b731cf$export$2ccf161b817b43b);

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");

var $gHT3x = parcelRequire("gHT3x");

var $3IJ1B = parcelRequire("3IJ1B");
const $0f38975317b731cf$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $0f38975317b731cf$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $0f38975317b731cf$var$FireComponent extends (0, $4fqPo.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $0f38975317b731cf$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $0f38975317b731cf$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $3IJ1B.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $0f38975317b731cf$var$WithAnalytics = (0, $as4kh.default)()($0f38975317b731cf$var$FireComponent);
const $0f38975317b731cf$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0f38975317b731cf$var$WithAnalytics, {
        ...props,
        type: (0, $gHT3x.UI_EVENT_TYPE)
    });
const $0f38975317b731cf$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0f38975317b731cf$var$WithAnalytics, {
        ...props,
        type: (0, $gHT3x.TRACK_EVENT_TYPE)
    });
const $0f38975317b731cf$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0f38975317b731cf$var$WithAnalytics, {
        ...props,
        type: (0, $gHT3x.OPERATIONAL_EVENT_TYPE)
    });
const $0f38975317b731cf$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0f38975317b731cf$var$WithAnalytics, {
        ...props,
        type: (0, $gHT3x.SCREEN_EVENT_TYPE),
        eventName: "screen viewed"
    });

});

parcelRegister("4oTiM", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAri", () => $33444d212461c94b$export$a75f3c98d930b258);

var $7j3S2 = parcelRequire("7j3S2");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/help/help-center/manifest.ts
var $33444d212461c94b$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $7j3S2.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $7j3S2.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/help/help-center/index.ts
var $33444d212461c94b$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $33444d212461c94b$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $33444d212461c94b$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $33444d212461c94b$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $33444d212461c94b$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $33444d212461c94b$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $33444d212461c94b$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
};

});
parcelRegister("7j3S2", function(module, exports) {
$parcel$export(module.exports, "HelpHelpCenterAriResourceOwner", () => $551d4f5a5822eaa6$export$a4af98a27b4568ee);
$parcel$export(module.exports, "HelpHelpCenterAriResourceType", () => $551d4f5a5822eaa6$export$f6271ed6947e9084);
// src/help/help-center/types.ts
var $551d4f5a5822eaa6$export$a4af98a27b4568ee = "help", $551d4f5a5822eaa6$export$f6271ed6947e9084 = "help-center";

});


parcelRegister("6YWkm", function(module, exports) {
$parcel$export(module.exports, "PremiumBenefitModalTrigger", () => $3f6961f1c35cace0$export$6f0c4c8beb8e608a);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");

var $2KBf4 = parcelRequire("2KBf4");

var $XkxPq = parcelRequire("XkxPq");

var $1SxuZ = parcelRequire("1SxuZ");

var $3GFEl = parcelRequire("3GFEl");

var $c5LZ7 = parcelRequire("c5LZ7");

var $8v3NR = parcelRequire("8v3NR");

var $9iTnp = parcelRequire("9iTnp");

var $5gGY9 = parcelRequire("5gGY9");

var $7hs4s = parcelRequire("7hs4s");

var $hMRTL = parcelRequire("hMRTL");
const $3f6961f1c35cace0$var$PremiumBenefitModalTriggerBase = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, ...pressableProps })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $c5LZ7.useAnalytics)();
    const { onClick: originalOnClick, ...restPressableProps } = pressableProps;
    const handleOnClick = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'modalTrigger',
            actionSubjectId: 'editionBenefitsModalTrigger',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
        // Call the original onClick if it exists
        originalOnClick === null || originalOnClick === void 0 || originalOnClick(e, analyticsEvent);
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition,
        originalOnClick
    ]);
    const handleOnClose = (0, $4fqPo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismiss',
            actionSubject: 'modal',
            actionSubjectId: 'editionBenefitsModal',
            attributes: {
                touchpointId: touchpointId,
                product: product,
                edition: edition,
                variantId: variantId
            }
        });
    }, [
        sendAnalyticsEvent,
        variantId,
        touchpointId,
        product,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $XkxPq.ModalTrigger), {
        entryPoint: (0, $hMRTL.premiumEditionBenefitsModalEntryPoint),
        entryPointParams: {
            cloudId: cloudId,
            product: product
        },
        entryPointProps: {
            variantId: variantId,
            touchpointId: touchpointId,
            edition: edition,
            onClose: handleOnClose
        },
        modalProps: (0, $8v3NR.MODAL_CONFIG)
    }, ({ ref: ref })=>children ? children({
            ref: ref,
            props: {
                ...restPressableProps,
                onClick: handleOnClick
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1SxuZ.DiscoveryCTAButton), {
            ref: ref,
            buttonStyle: "default",
            ...restPressableProps,
            onClick: handleOnClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $7hs4s.messages).buttonTriggerTryItFree))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3GFEl.UiViewedEvent), {
        actionSubject: "modalTrigger",
        actionSubjectId: "editionBenefitsModalTrigger",
        attributes: {
            touchpointId: touchpointId,
            product: product,
            edition: edition,
            variantId: variantId
        }
    }));
};
const $3f6961f1c35cace0$export$6f0c4c8beb8e608a = ({ cloudId: cloudId, product: product, children: children, variantId: variantId, touchpointId: touchpointId, edition: edition, useInternalModalContextProvider: useInternalModalContextProvider, ...pressableProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5gGY9.ErrorBoundary), {
        variantId: variantId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9iTnp.IntlProvider), null, useInternalModalContextProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2KBf4.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3f6961f1c35cace0$var$PremiumBenefitModalTriggerBase, {
        cloudId: cloudId,
        product: product,
        children: children,
        variantId: variantId,
        touchpointId: touchpointId,
        edition: edition,
        ...pressableProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3f6961f1c35cace0$var$PremiumBenefitModalTriggerBase, {
        cloudId: cloudId,
        product: product,
        children: children,
        variantId: variantId,
        touchpointId: touchpointId,
        edition: edition,
        ...pressableProps
    })));
};

});
parcelRegister("2KBf4", function(module, exports) {
$parcel$export(module.exports, "ModalContextProvider", () => $066a5af82b565838$export$7c9538f5f3c365e9);

var $4fqPo = parcelRequire("4fqPo");

var $kCZZw = parcelRequire("kCZZw");

var $7JAKt = parcelRequire("7JAKt");
const $066a5af82b565838$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $4fqPo.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $4fqPo.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $066a5af82b565838$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $4fqPo.useRef)(1);
    const [modals, setModals] = (0, $4fqPo.useState)([]);
    const modalContext = (0, $4fqPo.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7JAKt.ModalContext).Provider, {
        value: modalContext
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, modals.map((modal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($066a5af82b565838$var$RenderModal, {
            key: modal.key,
            modal: modal
        }))));
}

});
parcelRegister("7JAKt", function(module, exports) {
$parcel$export(module.exports, "ModalContext", () => $d872f5c50f8b93ac$export$ab57792b9b6974a6);

var $4fqPo = parcelRequire("4fqPo");
const $d872f5c50f8b93ac$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});

});


parcelRegister("XkxPq", function(module, exports) {
$parcel$export(module.exports, "ModalTrigger", () => $0eabcdbcee8e4b00$export$fb10b32cfe19f1e);

var $4fqPo = parcelRequire("4fqPo");

var $gIeP2 = parcelRequire("gIeP2");

var $1H5vR = parcelRequire("1H5vR");

var $bjlDd = parcelRequire("bjlDd");

var $l1C4i = parcelRequire("l1C4i");

var $6OEqh = parcelRequire("6OEqh");

var $3GPsW = parcelRequire("3GPsW");

var $hj69S = parcelRequire("hj69S");

var $7JAKt = parcelRequire("7JAKt");

var $ejxuj = parcelRequire("ejxuj");

var $8mBii = parcelRequire("8mBii");
const $0eabcdbcee8e4b00$var$emptyEntryPointParams = {};
const $0eabcdbcee8e4b00$var$emptyEntryPointProps = {};
function $0eabcdbcee8e4b00$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: preloadOnFocus = true, loadingText: loadingText }) {
    const { openModal: openModal } = (0, $4fqPo.useContext)((0, $7JAKt.ModalContext));
    const environmentProvider = (0, $hj69S.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $l1C4i.useEntryPointConfig)();
    const modalRef = (0, $4fqPo.useRef)(null);
    const metricName = (0, $4fqPo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $4fqPo.useCallback)(()=>(0, $gIeP2.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $0eabcdbcee8e4b00$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $4fqPo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                var _entryPointProps$onCl;
                entryPointProps === null || entryPointProps === void 0 || (_entryPointProps$onCl = entryPointProps.onClose) === null || _entryPointProps$onCl === void 0 || _entryPointProps$onCl.call(entryPointProps, extraInformation);
                closeModal();
                dispose();
            };
            const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3GPsW.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError === null || onError === void 0 || onError({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Fallback, {
                    onClose: closeModal
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8mBii.Loading), {
                    title: title,
                    loadingText: loadingText
                }),
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $0eabcdbcee8e4b00$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return(// eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
                ...modalProps,
                ref: modalRef,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnOverlayClick),
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? (modalProps === null || modalProps === void 0 ? void 0 : modalProps.shouldCloseOnEscapePress)
            }, container, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ejxuj.FocusInsideOnLoad), {
                entryPointReference: entryPointReference,
                autoFocusRef: modalProps === null || modalProps === void 0 ? void 0 : modalProps.autoFocus,
                modalRef: modalRef
            })));
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError,
        loadingText
    ]);
    const triggerRef = (0, $6OEqh.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $1H5vR.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("l1C4i", function(module, exports) {
$parcel$export(module.exports, "useEntryPointConfig", () => $8327a82197299a44$export$dfa96f26176fa91f);

var $bY08M = parcelRequire("bY08M");

var $lNZDv = parcelRequire("lNZDv");
const $8327a82197299a44$var$DefaultUFOSegmentComponent = (0, $lNZDv.default);
const $8327a82197299a44$var$entryPointConfig = {
    PlaceholderComponent: (0, $bY08M.default),
    UFOSegmentComponent: $8327a82197299a44$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $8327a82197299a44$export$93a6801f9db838c4(overrides) {
    Object.assign($8327a82197299a44$var$entryPointConfig, overrides);
    return $8327a82197299a44$var$entryPointConfig;
}
function $8327a82197299a44$export$dfa96f26176fa91f() {
    return $8327a82197299a44$var$entryPointConfig;
}

});
parcelRegister("bY08M", function(module, exports) {
$parcel$export(module.exports, "default", () => $015fe8da6d1d3963$export$2e2bcd8739ae039);

var $5tZvl = parcelRequire("5tZvl");
var $015fe8da6d1d3963$export$2e2bcd8739ae039 = (0, $5tZvl.default);

});
parcelRegister("5tZvl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d10ae10e5240c3df$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $cijxS = parcelRequire("cijxS");

var $1Rby6 = parcelRequire("1Rby6");
var $iJ8cO = parcelRequire("iJ8cO");
function $d10ae10e5240c3df$export$2e2bcd8739ae039({ name: name, children: children, fallback: fallback = null }) {
    const waitContext = (0, $4fqPo.useContext)((0, $iJ8cO.WaitContext));
    const shouldHold = !waitContext || !!waitContext.currentValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1Rby6.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: name,
            hold: shouldHold
        })),
        name: name
    }, children);
}

});
parcelRegister("1Rby6", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => $e572c9116bc1b376$export$256c542058532d6f);

var $4fqPo = parcelRequire("4fqPo");
const $e572c9116bc1b376$var$isNodeEnvironment = ()=>{
    return typeof window === 'undefined' || window.name === 'nodejs';
};
const $e572c9116bc1b376$var$LazySuspenseContext = /*#__PURE__*/ (0, $4fqPo.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null),
    setFallback: ()=>{
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    },
    name: ''
});
const $e572c9116bc1b376$var$DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
    const { fallback: fallback, setFallback: setFallback } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext($e572c9116bc1b376$var$LazySuspenseContext);
    (0, $4fqPo.useLayoutEffect)(()=>{
        return ()=>{
            if (!outsideSuspense) setFallback(null);
        };
    }, [
        outsideSuspense,
        setFallback
    ]);
    return children(outsideSuspense ? null : fallback);
};
$e572c9116bc1b376$var$DynamicFallback.displayName = 'DynamicFallback';
const $e572c9116bc1b376$export$256c542058532d6f = ({ fallback: fallback, children: children, name: name })=>{
    const [hydrationFallback, setHydrationFallback] = (0, $4fqPo.useState)(null);
    const mountedRef = (0, $4fqPo.useRef)(false);
    (0, $4fqPo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const contextValue = (0, $4fqPo.useMemo)(()=>({
            fallback: fallback,
            setFallback: (newFallback)=>{
                if (hydrationFallback === newFallback) return;
                setHydrationFallback(newFallback);
            },
            name: name
        }), [
        fallback,
        hydrationFallback,
        name
    ]);
    const renderFallback = (outsideSuspense)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e572c9116bc1b376$var$DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (resolvedFallback)=>outsideSuspense && hydrationFallback ? hydrationFallback : resolvedFallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e572c9116bc1b376$var$LazySuspenseContext.Provider, {
        value: contextValue
    }, $e572c9116bc1b376$var$isNodeEnvironment() ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: renderFallback(false)
    }, children), (!mountedRef.current || hydrationFallback) && renderFallback(true)));
};
$e572c9116bc1b376$export$256c542058532d6f.displayName = 'LazySuspense';

});

parcelRegister("iJ8cO", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => $4e6f86fd23027c8d$export$9ba3fe09d15de47b);

var $4fqPo = parcelRequire("4fqPo");
const $4e6f86fd23027c8d$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $4fqPo.createContext)({
    subscribe: ()=>()=>{},
    currentValue: ()=>1
});

});




parcelRegister("6OEqh", function(module, exports) {
$parcel$export(module.exports, "usePressablePreloadRef", () => $8114d8009b779f4b$export$1ff47f24e06a5d2d);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $c3uGD = parcelRequire("c3uGD");
function $8114d8009b779f4b$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $4fqPo.useRef)(null);
    const eventListeners = (0, $4fqPo.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $c3uGD.useEntryPointPreload)(load);
    const clickListener = (0, $4fqPo.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $4fqPo.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $4fqPo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $4fqPo.useCallback)((element, type, callback)=>{
        const unbind = (0, $lMcEJ.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $4fqPo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}

});
parcelRegister("c3uGD", function(module, exports) {
$parcel$export(module.exports, "useEntryPointPreload", () => $2b1094deb3b70d63$export$57effc2a5e3611f);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
const $2b1094deb3b70d63$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $2b1094deb3b70d63$var$TIME_TO_INTENT = 200;
function $2b1094deb3b70d63$export$57effc2a5e3611f(load) {
    const actions = (0, $4fqPo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $3H4LK.fg)('platform_relay_preload_ensure_max_age_disposal') === false) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            if ((0, $3H4LK.fg)('platform_relay_persist_entrypoint_preloaded_data') === false) {
                var _request$preload;
                (_request$preload = request.preload) === null || _request$preload === void 0 || _request$preload.dispose();
            }
        };
        const cleanupPreload = ()=>{
            var _request$preload2;
            (_request$preload2 = request.preload) === null || _request$preload2 === void 0 || _request$preload2.dispose();
            // Only remove the max age timeout when the component is cleaned up.
            if (typeof request.preloadMaxAgeTimeout === 'number' && (0, $3H4LK.fg)('platform_relay_preload_ensure_max_age_disposal')) {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const loadReference = ()=>{
            var _request$preload3;
            if (request.load) return request.load;
            const reference = ((_request$preload3 = request.preload) === null || _request$preload3 === void 0 ? void 0 : _request$preload3.reference) ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    var _request$preload4;
                    delete request.preloadMaxAgeTimeout;
                    (_request$preload4 = request.preload) === null || _request$preload4 === void 0 || _request$preload4.dispose();
                }, $2b1094deb3b70d63$var$PRELOAD_MAX_AGE);
            }, $2b1094deb3b70d63$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            cleanupPreload: cleanupPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
    // Dispose preload and clear timeouts when component unmounts
    // or when `load` identity changes (new actions object created).
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            if ((0, $3H4LK.fg)('platform_relay_persist_entrypoint_preloaded_data')) actions.cleanupPreload();
        };
    }, [
        actions
    ]);
    return actions;
}

});


parcelRegister("3GPsW", function(module, exports) {
$parcel$export(module.exports, "InternalEntryPointContainer", () => $26f002150cd7f7df$export$5d4dc37edd8a3adb);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $gIeP2 = parcelRequire("gIeP2");

var $9ifhy = parcelRequire("9ifhy");

var $kuznb = parcelRequire("kuznb");

var $l1C4i = parcelRequire("l1C4i");
function $26f002150cd7f7df$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $l1C4i.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $9ifhy.useUFOReportError)();
    const onError = (0, $4fqPo.useCallback)((error, errorInfo)=>{
        onErrorLocal === null || onErrorLocal === void 0 || onErrorLocal({
            error: error,
            errorInfo: errorInfo
        });
        (0, $kuznb.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) ?? 'Unknown error',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $4fqPo.useCallback)(({ error: error })=>{
        const onClose = (runtimeProps === null || runtimeProps === void 0 ? void 0 : runtimeProps.onClose) ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BYXH4.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(PlaceholderComponent, {
        name: placeholderName ?? 'internal-internal-entry-point-container',
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gIeP2.EntryPointContainer), {
        entryPointReference: entryPointReference,
        props: runtimeProps
    })));
}
function $26f002150cd7f7df$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $l1C4i.useEntryPointConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(UFOSegmentComponent, {
        name: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($26f002150cd7f7df$var$InternalEntryPointContainerInner, props));
}

});
parcelRegister("9ifhy", function(module, exports) {
$parcel$export(module.exports, "useUFOReportError", () => $45763dc230cbb166$export$75d40f522062f923);

var $gE3od = parcelRequire("gE3od");

var $c62a8 = parcelRequire("c62a8");
function $45763dc230cbb166$export$75d40f522062f923() {
    const ufoContext = (0, $gE3od.useInteractionContext)();
    const reportError = (error)=>{
        const interaction = (0, $c62a8.getActiveInteraction)();
        if (interaction !== null && interaction !== void 0 && interaction.id) (0, $c62a8.addError)(interaction.id, error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack, error.forcedError);
        else (0, $c62a8.addErrorToAll)(error.name, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, error.name, error.errorMessage, error.errorStack);
    };
    return reportError;
}

});

parcelRegister("kuznb", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $d07d709035897421$export$b33b857ad1d9900e);

var $3H4LK = parcelRequire("3H4LK");
const $d07d709035897421$var$buffer = [];
let $d07d709035897421$var$push = (payload)=>{
    $d07d709035897421$var$buffer.push(payload);
};
function $d07d709035897421$export$b33b857ad1d9900e(payload) {
    $d07d709035897421$var$push(payload);
}
function $d07d709035897421$export$abd5747ea77ecab9(handler) {
    if ((0, $3H4LK.fg)('moving_jira_entry-points_api_under_platform')) {
        $d07d709035897421$var$push = handler;
        $d07d709035897421$var$buffer.forEach((payload)=>handler(payload));
        $d07d709035897421$var$buffer.length = 0;
    }
}

});


parcelRegister("hj69S", function(module, exports) {
$parcel$export(module.exports, "AtlassianRelayEnvironmentProvider", () => $09f003b0fdca7742$export$6c22afad970ad5ac);
$parcel$export(module.exports, "ConditionalRelayEnvironmentProvider", () => $09f003b0fdca7742$export$2f6292af3d34630d);
$parcel$export(module.exports, "useRelayEnvironmentProvider", () => $09f003b0fdca7742$export$e237a628f59c9f4e);

var $4fqPo = parcelRequire("4fqPo");

var $gIeP2 = parcelRequire("gIeP2");

var $byZGc = parcelRequire("byZGc");
function $09f003b0fdca7742$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gIeP2.RelayEnvironmentProvider), {
        environment: (0, $byZGc.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $09f003b0fdca7742$export$43b1f3e917d65526 = $09f003b0fdca7742$export$6c22afad970ad5ac;
const $09f003b0fdca7742$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $4fqPo.useContext)((0, $gIeP2.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($09f003b0fdca7742$export$6c22afad970ad5ac, null, children);
};
function $09f003b0fdca7742$export$e237a628f59c9f4e() {
    const environment = (0, $gIeP2.useRelayEnvironment)();
    return (0, $4fqPo.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}

});
parcelRegister("byZGc", function(module, exports) {
$parcel$export(module.exports, "__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__", () => $0974ee7ca245d5a9$export$df54517d175e6d6b);

var $3H4LK = parcelRequire("3H4LK");

var $f8vTV = parcelRequire("f8vTV");

var $9D98s = parcelRequire("9D98s");

var $i6Ob0 = parcelRequire("i6Ob0");
const $0974ee7ca245d5a9$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $0974ee7ca245d5a9$export$4a639ebead870a0c = new (0, $i6Ob0.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $0974ee7ca245d5a9$export$df54517d175e6d6b = (0, $f8vTV.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $0974ee7ca245d5a9$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                var _response$extensions;
                const requestId = response === null || response === void 0 || (_response$extensions = response.extensions) === null || _response$extensions === void 0 || (_response$extensions = _response$extensions.gateway) === null || _response$extensions === void 0 ? void 0 : _response$extensions.request_id;
                (0, $9D98s.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $3H4LK.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $9D98s.isStepUpAuthError)(errors);
                    // Guard against SSR: window is not defined in server-side rendering environments.
                    // RelayEnvironmentProvider is used by platform components (e.g. GlobalSideNavigation)
                    // during SSR — validateResponse may be called during renderToString where window
                    // does not exist. Without this guard, a step-up auth error would throw
                    // ReferenceError and crash the entire SSR render.
                    if (hasStepUpAuthError && stepUpUrl && typeof window !== 'undefined') window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $0974ee7ca245d5a9$export$4a639ebead870a0c,
        // Use typeof window === 'undefined' for SSR detection rather than globalThis.__SERVER__.
        // __SERVER__ is set in tests but not in Bifrost's actual SSR environment (it's set in
        // init() which runs after module evaluation). typeof window === 'undefined' is the
        // standard pattern and correctly identifies both Bifrost SSR and test environments.
        isServer: typeof window === 'undefined'
    }
});

});
parcelRegister("9D98s", function(module, exports) {
$parcel$export(module.exports, "captureErrors", () => $30610d01b69be470$export$7a973c0ff390eb47);
$parcel$export(module.exports, "isStepUpAuthError", () => $30610d01b69be470$export$60fba4117567a49b);

var $2OOKU = parcelRequire("2OOKU");
const $30610d01b69be470$var$errorCollector = new Map();
const $30610d01b69be470$export$da396ad2a542b095 = 120000; // 2min
const $30610d01b69be470$var$scheduleCleanup = (key)=>{
    setTimeout(()=>{
        $30610d01b69be470$var$errorCollector.delete(key);
    }, $30610d01b69be470$export$da396ad2a542b095);
};
const $30610d01b69be470$export$c211170518c6d0f6 = (key = (0, $2OOKU.v4)())=>{
    $30610d01b69be470$var$errorCollector.set(key, []);
    $30610d01b69be470$var$scheduleCleanup(key);
    return key;
};
const $30610d01b69be470$export$e0491a0d974dadfa = (key)=>{
    const errors = $30610d01b69be470$var$errorCollector.get(key);
    $30610d01b69be470$var$errorCollector.delete(key);
    return errors || [];
};
const $30610d01b69be470$export$7a973c0ff390eb47 = (errors, meta)=>{
    if (errors) $30610d01b69be470$var$errorCollector.forEach((value, key)=>{
        $30610d01b69be470$var$errorCollector.set(key, [
            ...value,
            {
                errors: errors,
                meta: meta
            }
        ]);
    });
};
const $30610d01b69be470$export$1724ecfee73c4768 = (errors)=>{
    if (errors.length > 0) return errors.some((error)=>error.message.startsWith('Auth category: UNAUTHENTICATED'));
    return false;
};
const $30610d01b69be470$export$60fba4117567a49b = (errors)=>{
    var _stepUpError$extensio;
    const stepUpError = errors.find((error)=>{
        var _error$extensions, _error$extensions2;
        return error.message.startsWith('Step-up authentication is required.') && ((_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode) === 303 && ((_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.stepUpUrl);
    });
    return {
        hasStepUpAuthError: !!stepUpError,
        stepUpUrl: (stepUpError === null || stepUpError === void 0 || (_stepUpError$extensio = stepUpError.extensions) === null || _stepUpError$extensio === void 0 ? void 0 : _stepUpError$extensio.stepUpUrl) ?? undefined
    };
};

});

parcelRegister("i6Ob0", function(module, exports) {
$parcel$export(module.exports, "SSRQueryResponseCache", () => $f1a4cc9e3d6cfbb1$export$be21c283b097d175);

var $f2UoR = parcelRequire("f2UoR");
function $f1a4cc9e3d6cfbb1$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $f2UoR.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $f1a4cc9e3d6cfbb1$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $f1a4cc9e3d6cfbb1$export$be21c283b097d175 extends (0, $f2UoR.QueryResponseCache) {
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        var _window, _window2, _window3;
        super({
            size: size,
            ttl: ttl
        });
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 || (_window = _window.SPA_STATE) === null || _window === void 0 ? void 0 : _window[cacheName]) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.SKELETON_NAVIGATION) === null || _window2 === void 0 ? void 0 : _window2[cacheName]) || ((_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.__PLATFORM_SSR_AGG_CACHE__) === null || _window3 === void 0 ? void 0 : _window3[cacheName]) || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback === null || timeoutCallback === void 0 || timeoutCallback(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $f1a4cc9e3d6cfbb1$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
}

});



parcelRegister("ejxuj", function(module, exports) {
$parcel$export(module.exports, "FocusInsideOnLoad", () => $890dad04b799ae9e$export$eb58c1f6b41ee511);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $c1tmZ = parcelRequire("c1tmZ");

var $5ax9w = parcelRequire("5ax9w");
const $890dad04b799ae9e$var$FocusInsideOnLoadInner = ({ autoFocusRef: autoFocusRef, entryPointReference: entryPointReference, modalRef: modalRef })=>{
    // Suspends until the entry point's module has finished loading. The result
    // is intentionally unused — this call exists purely to gate the mount of
    // this component on the load completing.
    entryPointReference.getComponent();
    (0, $4fqPo.useEffect)(()=>{
        // Fence for if container element doesn't exist, but this is effectively not
        // possible.
        if (!modalRef.current) return;
        // If ref provided, use that first. Else find first focusable element or
        // container if not exists
        if (autoFocusRef !== null && autoFocusRef !== void 0 && autoFocusRef.current) {
            autoFocusRef.current.focus();
            return;
        }
        const firstFocusable = (0, $5ax9w.getFirstFocusable)({
            container: modalRef.current
        });
        if (firstFocusable) {
            firstFocusable.focus();
            return;
        }
        modalRef.current.focus();
    }, [
        autoFocusRef,
        modalRef
    ]);
    return null;
};
const $890dad04b799ae9e$var$renderNothing = ()=>null;
const $890dad04b799ae9e$export$eb58c1f6b41ee511 = ({ entryPointReference: entryPointReference, autoFocusRef: autoFocusRef, modalRef: modalRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BYXH4.ErrorBoundary), {
        FallbackComponent: $890dad04b799ae9e$var$renderNothing,
        onError: (0, $c1tmZ.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Suspense, {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($890dad04b799ae9e$var$FocusInsideOnLoadInner, {
        entryPointReference: entryPointReference,
        autoFocusRef: autoFocusRef,
        modalRef: modalRef
    })));

});

parcelRegister("8mBii", function(module, exports) {
$parcel$export(module.exports, "Loading", () => $e73501c0e2de57f7$export$669f6ea7d267feaf);

var $4fqPo = parcelRequire("4fqPo");

var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $isBvF = parcelRequire("isBvF");
var $6zx4f = parcelRequire("6zx4f");

var $5E02Z = parcelRequire("5E02Z");
var $ekURY = parcelRequire("ekURY");

var $5qWT2 = parcelRequire("5qWT2");
const $e73501c0e2de57f7$export$669f6ea7d267feaf = ({ loadingText: loadingText, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $isBvF.default), {
        hasCloseButton: true
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6zx4f.default), null, title) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5E02Z.default), {
        space: "space.400",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        size: "large",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), {
        color: "color.text.subtle"
    }, loadingText ?? 'Loading dialog content...'))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null));

});
parcelRegister("gbw4j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $c3c222bf3c9d2006$export$2e2bcd8739ae039);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $f2YSn = parcelRequire("f2YSn");
const $c3c222bf3c9d2006$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $c3c222bf3c9d2006$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $f2YSn.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ])
    }, children);
};
var $c3c222bf3c9d2006$export$2e2bcd8739ae039 = $c3c222bf3c9d2006$var$ModalFooter;

});

parcelRegister("isBvF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $187161bb4a87f634$export$2e2bcd8739ae039);
/* modal-header.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $2UMA8 = parcelRequire("2UMA8");

var $dhbAl = parcelRequire("dhbAl");

var $f2YSn = parcelRequire("f2YSn");
const $187161bb4a87f634$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $187161bb4a87f634$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $f2YSn.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`;
    // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            $187161bb4a87f634$var$styles.header
        ])
    }, shouldShowCloseButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $187161bb4a87f634$var$styles.flex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dhbAl.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
        justifyContent: "start",
        alignItems: "center",
        xcss: $187161bb4a87f634$var$styles.titleContainer
    }, children)) : children);
};
var $187161bb4a87f634$export$2e2bcd8739ae039 = $187161bb4a87f634$var$ModalHeader;

});
parcelRegister("dhbAl", function(module, exports) {
$parcel$export(module.exports, "CloseButton", () => $5cbe81458e0d4cb5$export$de65de8213222d10);

var $4fqPo = parcelRequire("4fqPo");

var $21P09 = parcelRequire("21P09");

var $9RW5e = parcelRequire("9RW5e");
const $5cbe81458e0d4cb5$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $21P09.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });

});


parcelRegister("6zx4f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b04601842394fc95$export$2e2bcd8739ae039);
/* modal-title.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $geWWn = parcelRequire("geWWn");

var $klZKM = parcelRequire("klZKM");

var $f2YSn = parcelRequire("f2YSn");
const $b04601842394fc95$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $b04601842394fc95$var$iconStyles = null;
const $b04601842394fc95$var$titleStyles = null;
const $b04601842394fc95$var$textStyles = null;
const $b04601842394fc95$var$truncatedTextStyles = null;
const $b04601842394fc95$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($geWWn))) : (0, (/*@__PURE__*/$parcel$interopDefault($klZKM)));
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement(Icon, {
        label: appearance,
        color: $b04601842394fc95$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $b04601842394fc95$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $f2YSn.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ $4fqPo.createElement("h1", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $4fqPo.createElement($b04601842394fc95$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $4fqPo.createElement("span", {
        id: titleId,
        "data-testid": testId && `${testId}-text`,
        className: (0, $ltgDR.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _11c81af2 _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $b04601842394fc95$export$2e2bcd8739ae039 = $b04601842394fc95$var$ModalTitle;

});



parcelRegister("1SxuZ", function(module, exports) {
$parcel$export(module.exports, "DiscoveryCTAButton", () => $bab1a21161c1e128$export$1f81fec3cd5490ae);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $cIQ4S = parcelRequire("cIQ4S");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");
var $Cp2Ub = parcelRequire("Cp2Ub");
var $iqiKs = parcelRequire("iqiKs");
const $bab1a21161c1e128$var$styles = {
    base: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko12b0 _v5649dqc _1e0c116y _u5f3utpp _19bvu2gc _ca0qidpf _n3tdidpf _1bah1h6o _4cvr1h6o _1bsb1ns9 _o5721q9c",
    baseT26Shape: "_2rko1qi0",
    defaultSpacing: "_1tkezwfg",
    compactSpacing: "_1tke1tcg",
    default: "_syaz15cr _bfhkya33 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31af5 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _1di66cze",
    inverted: "_189ee4h9 _1dqonqa1 _1h6d1hqq _syazdv2p _bfhkvuon _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3kca2 _30l3dv2p _1nrm1r31 _c2waglyw _1iohnqa1 _1di61jbm",
    subtle: "_bfhksm61 _syazqmo9 _o5721q9c _irr3kca2 _1di61jbm",
    contentContainer: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    iconContainer: "_1e0c1txw _1bsb1tcg _4t3i1tcg _1bah1h6o _4cvr1h6o"
};
const $bab1a21161c1e128$export$1f81fec3cd5490ae = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ buttonStyle: buttonStyle, children: children, spacing: spacing, ...buttonProps }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iqiKs.default), {
        ref: ref,
        ...buttonProps,
        xcss: (0, $fxmw9.cx)($bab1a21161c1e128$var$styles.base, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $bab1a21161c1e128$var$styles.baseT26Shape, buttonStyle === 'default' && $bab1a21161c1e128$var$styles.default, buttonStyle === 'inverted' && $bab1a21161c1e128$var$styles.inverted, buttonStyle === 'subtle' && $bab1a21161c1e128$var$styles.subtle, spacing === 'compact' ? $bab1a21161c1e128$var$styles.compactSpacing : $bab1a21161c1e128$var$styles.defaultSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $bab1a21161c1e128$var$styles.contentContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $bab1a21161c1e128$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cIQ4S))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), null, children)));
});

});

parcelRegister("3GFEl", function(module, exports) {
$parcel$export(module.exports, "UiViewedEvent", () => $48e91f15b28d4888$export$d0a9edec5c713764);

var $4fqPo = parcelRequire("4fqPo");

var $c5LZ7 = parcelRequire("c5LZ7");
function $48e91f15b28d4888$export$d0a9edec5c713764({ actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $c5LZ7.useAnalytics)();
    const hasSent = (0, $4fqPo.useRef)(false);
    (0, $4fqPo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}

});
parcelRegister("c5LZ7", function(module, exports) {
$parcel$export(module.exports, "useAnalytics", () => $ba623a5a0ecf461d$export$e955abb82869dc84);
$parcel$export(module.exports, "useOperationalAnalytics", () => $ba623a5a0ecf461d$export$18e9461e904f638a);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("lkz0W");
var $6niD6 = parcelRequire("6niD6");

var $l2sHq = parcelRequire("l2sHq");
var $ew3Bn = parcelRequire("ew3Bn");
const $ba623a5a0ecf461d$export$85183a312807388d = (0, $6niD6.FabricChannel).growth;
const $ba623a5a0ecf461d$export$38cd8db2db178f58 = {
    packageName: '@atlassian/edition-benefits-modal',
    source: 'editionBenefitsModal'
};
const $ba623a5a0ecf461d$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    return context.reduce((acc, x)=>{
        if (x.attributes) return {
            ...acc,
            ...x.attributes
        };
        return {
            ...acc,
            ...x ?? {}
        };
    }, {});
};
const $ba623a5a0ecf461d$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const sendAnalyticsEvent = (0, $4fqPo.useCallback)((payload)=>{
        if (payload instanceof (0, $l2sHq.default)) {
            const contextAttributes = $ba623a5a0ecf461d$export$d97c97ed77ff09e8(payload.context);
            payload.update({
                ...payload.payload,
                attributes: {
                    ...contextAttributes,
                    ...payload.payload.attributes,
                    ...$ba623a5a0ecf461d$export$38cd8db2db178f58
                }
            }).fire($ba623a5a0ecf461d$export$85183a312807388d);
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    ...$ba623a5a0ecf461d$export$38cd8db2db178f58
                }
            });
            const contextAttributes = $ba623a5a0ecf461d$export$d97c97ed77ff09e8(event.context);
            event.update({
                attributes: {
                    ...contextAttributes,
                    ...event.payload.attributes
                }
            }).fire($ba623a5a0ecf461d$export$85183a312807388d);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent
    };
};
function $ba623a5a0ecf461d$export$18e9461e904f638a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    return (0, $4fqPo.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...$ba623a5a0ecf461d$export$38cd8db2db178f58,
                ...attributes
            }
        });
        const contextAttributes = $ba623a5a0ecf461d$export$d97c97ed77ff09e8(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire($ba623a5a0ecf461d$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
}

});


parcelRegister("8v3NR", function(module, exports) {
$parcel$export(module.exports, "MODAL_CONFIG", () => $9af3d7ef60854fcc$export$310af821ace1b0a4);
$parcel$export(module.exports, "SERVICE_COLLECTION_PRICING_PAGE_URL", () => $9af3d7ef60854fcc$export$73d1ac3f0d282717);
$parcel$export(module.exports, "JSM_PRICING_PAGE_URL", () => $9af3d7ef60854fcc$export$f3616073c30968f9);
$parcel$export(module.exports, "INCIDENTS_SLACK_INTEGRATION_VIDEO_URL", () => $9af3d7ef60854fcc$export$6a49267b3da8f732);
const $9af3d7ef60854fcc$export$310af821ace1b0a4 = {
    width: 'x-large',
    shouldScrollInViewport: true
};
const $9af3d7ef60854fcc$export$73d1ac3f0d282717 = 'https://www.atlassian.com/collections/service/pricing';
const $9af3d7ef60854fcc$export$fe159292463016ac = '/admin/billing';
const $9af3d7ef60854fcc$export$f37bcc6aa76a1720 = '/jira/settings/products/jira-service-desk-configuration/storage-management';
const $9af3d7ef60854fcc$export$5911f793141d3670 = 'https://support.atlassian.com/subscriptions-and-billing/docs/cancel-a-subscription/';
const $9af3d7ef60854fcc$export$f3616073c30968f9 = 'http://www.atlassian.com/software/jira/service-management/product-pricing';
const $9af3d7ef60854fcc$export$6a49267b3da8f732 = `https://www.youtube.com/embed/cljyGRFV2fo?rel=0&modestbranding=1`;
const $9af3d7ef60854fcc$export$920cf1ad9b0dbb52 = '0ce0f1da-1c46-4bff-9a32-d1128cfbca68';

});

parcelRegister("9iTnp", function(module, exports) {
$parcel$export(module.exports, "IntlProvider", () => $ea4d9161ce772b9f$export$480518999dfc4151);

var $4fqPo = parcelRequire("4fqPo");

var $lGhvw = parcelRequire("lGhvw");

var $bdszq = parcelRequire("bdszq");

var $eMhYS = parcelRequire("eMhYS");

var $lB3Qz = parcelRequire("lB3Qz");

var $4RbcG = parcelRequire("4RbcG");
const $ea4d9161ce772b9f$var$defaultMessagesWithStandardBenefits = {
    ...(0, $eMhYS.defaultLocale),
    ...(0, $4RbcG.standardBenefitsFallbackMessages),
    ...(0, $bdszq.examplesSectionFallbackMessages),
    ...(0, $lB3Qz.popupFallbackMessages)
};
const $ea4d9161ce772b9f$export$480518999dfc4151 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lGhvw.default), {
        defaultMessages: $ea4d9161ce772b9f$var$defaultMessagesWithStandardBenefits,
        loaderFn: (0, $eMhYS.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("lGhvw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c1873db37d1ea92$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $99BhM = parcelRequire("99BhM");

var $gAVxT = parcelRequire("gAVxT");

var $k3O8b = parcelRequire("k3O8b");
function $6c1873db37d1ea92$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $k3O8b.useSafeIntl)();
    const messages = (0, $gAVxT.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $4fqPo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $99BhM.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
}

});
parcelRegister("gAVxT", function(module, exports) {
$parcel$export(module.exports, "useMessages", () => $0c30eabddd35b328$export$4d17e2d9c5348842);

var $4fqPo = parcelRequire("4fqPo");

var $6eaTq = parcelRequire("6eaTq");
function $0c30eabddd35b328$export$4d17e2d9c5348842(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $4fqPo.useState)((0, $6eaTq.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $4fqPo.useRef)(localeState.locale);
    (0, $4fqPo.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
}

});
parcelRegister("6eaTq", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LOCALE_STATE", () => $762cd5eef6a634cc$export$79618bef82c02d4c);
const $762cd5eef6a634cc$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};

});


parcelRegister("k3O8b", function(module, exports) {
$parcel$export(module.exports, "useSafeIntl", () => $bdbe1298e276e110$export$f752ac21ea3960a5);

var $4fqPo = parcelRequire("4fqPo");

var $atQYF = parcelRequire("atQYF");
var $fckbz = parcelRequire("fckbz");
var $3rTf2 = parcelRequire("3rTf2");

var $6eaTq = parcelRequire("6eaTq");
// Prevents memory leaks
const $bdbe1298e276e110$var$cache = (0, $fckbz.createIntlCache)();
const $bdbe1298e276e110$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $4fqPo.useContext)((0, $3rTf2.Context));
    if (!context) return (0, $atQYF.createIntl)((0, $6eaTq.DEFAULT_LOCALE_STATE), $bdbe1298e276e110$var$cache);
    return context;
};

});


parcelRegister("bdszq", function(module, exports) {
$parcel$export(module.exports, "examplesSectionFallbackMessages", () => $52469bf7c197ef73$export$7ea3822e86d2fcfd);

var $4DKZH = parcelRequire("4DKZH");
function $52469bf7c197ef73$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $52469bf7c197ef73$export$7ea3822e86d2fcfd = Object.fromEntries(Object.values((0, $4DKZH.examplesSectionMessages)).filter($52469bf7c197ef73$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("4DKZH", function(module, exports) {
$parcel$export(module.exports, "examplesSectionMessages", () => $76ad4972cb7b2af2$export$1edce390ed9bf8d2);

var $6BhDL = parcelRequire("6BhDL");
const $76ad4972cb7b2af2$export$1edce390ed9bf8d2 = (0, $6BhDL.defineMessages)({
    incidentsVideoIframeTitle: {
        id: '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title',
        defaultMessage: 'YouTube video player',
        description: 'Accessible title for the incidents Slack integration YouTube embed iframe'
    }
});

});


parcelRegister("eMhYS", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $fde44f8bca439656$export$d7f512c98c859244);
$parcel$export(module.exports, "fetchMessagesForLocale", () => $fde44f8bca439656$export$2b153a2030b0feb2);

var $4O14Q = parcelRequire("4O14Q");

var $9ik61 = parcelRequire("9ik61");
const $fde44f8bca439656$export$d7f512c98c859244 = (0, $9ik61.default);
const $fde44f8bca439656$var$localeMap = {
    pt: 'pt_BR',
    'pt-PT': 'pt_BR',
    'en-AU': 'en_GB'
};
const $fde44f8bca439656$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($fde44f8bca439656$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (!targetLocale) throw new Error('No mapped locale');
        const messages = await (0, $4O14Q.locales)[targetLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await (0, $4O14Q.locales)[parentLocale]();
        return messages.default;
    } catch  {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return $fde44f8bca439656$export$d7f512c98c859244;
};

});
parcelRegister("4O14Q", function(module, exports) {
$parcel$export(module.exports, "locales", () => $483abf3d57cdc392$export$df1c34db1371eeed);





























const $483abf3d57cdc392$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("b1IHR")),
    da: ()=>(parcelRequire("2GLg1")),
    de: ()=>(parcelRequire("4nlcW")),
    en_GB: ()=>(parcelRequire("4irGH")),
    en_ZZ: ()=>(parcelRequire("6o9gy")),
    en: ()=>Promise.resolve((parcelRequire("9ik61"))),
    es: ()=>(parcelRequire("98o1X")),
    fi: ()=>(parcelRequire("yIDrI")),
    fr: ()=>(parcelRequire("k1jgF")),
    hr: ()=>(parcelRequire("4NiiO")),
    hu: ()=>(parcelRequire("1hAoM")),
    it: ()=>(parcelRequire("hrtuv")),
    ja: ()=>(parcelRequire("fiZtW")),
    ko: ()=>(parcelRequire("kvyiH")),
    nb: ()=>(parcelRequire("1qQfK")),
    nl: ()=>(parcelRequire("g8DkN")),
    pl: ()=>(parcelRequire("5egqv")),
    pt_BR: ()=>(parcelRequire("cnDRB")),
    ru: ()=>(parcelRequire("2JvFX")),
    sl: ()=>(parcelRequire("kVjXz")),
    sr_RS: ()=>(parcelRequire("6EHVV")),
    sr_YR: ()=>(parcelRequire("gYFjg")),
    sv: ()=>(parcelRequire("5aYub")),
    th: ()=>(parcelRequire("50iGc")),
    tr: ()=>(parcelRequire("kQw7P")),
    uk: ()=>(parcelRequire("7DVwU")),
    vi: ()=>(parcelRequire("65x9i")),
    zh_TW: ()=>(parcelRequire("7693i")),
    zh: ()=>(parcelRequire("6FLCG"))
};

});
parcelRegister("b1IHR", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("g1a54").then(()=>parcelRequire('e31aX'));

});

parcelRegister("2GLg1", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("c2qsw").then(()=>parcelRequire('dZj5p'));

});

parcelRegister("4nlcW", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lbRjq").then(()=>parcelRequire('9hVHT'));

});

parcelRegister("4irGH", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("eRVXk").then(()=>parcelRequire('fwXIa'));

});

parcelRegister("6o9gy", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("ajCko").then(()=>parcelRequire('mBn27'));

});

parcelRegister("9ik61", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $06cf59fbd72a7f09$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $bP2YF = parcelRequire("bP2YF");
var $06cf59fbd72a7f09$export$2e2bcd8739ae039 = (0, $bP2YF.default);

});
parcelRegister("bP2YF", function(module, exports) {
$parcel$export(module.exports, "default", () => $13324e54f1c847ba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $13324e54f1c847ba$export$2e2bcd8739ae039 = {
    '@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.bradley': 'Bradley',
    '@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.knowledgeArticle': 'Knowledge article',
    '@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.rovo': 'Rovo',
    '@atlassian/edition-benefits-modal.aiKnowledgeServiceTeam.rovoServiceAgent': 'Rovo service agent',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.bradley': 'Bradley',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.csm01': 'CSM-01',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.customerServiceAgent': 'Customer service agent',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.customerSupportRequest': 'Customer support request',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.resolved': 'Resolved',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.rovo': 'Rovo',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.rovoServiceAgent': 'Rovo service agent',
    '@atlassian/edition-benefits-modal.assetsCSMAIFormsIllustration.slash': '/',
    '@atlassian/edition-benefits-modal.assetsCSMSupportCompanionIllustration.request': 'Request',
    '@atlassian/edition-benefits-modal.assetsCSMSupportCompanionIllustration.supportCompanion': 'Support Companion',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.active': 'ACTIVE',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.app': 'App',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.objectGraph': 'Object graph',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.owningTeam': 'Owning team',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.percentage': '300%',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.request': 'Request',
    '@atlassian/edition-benefits-modal.assetsOpsTeamIllustration.service': 'Service',
    '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later': 'Maybe later',
    '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free': 'Try it free',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1': '<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2': '<strong>Customize your help center</strong> to match your brand.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3': '<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1': 'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2': 'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3': '<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1': 'Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.',
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2': "Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
    '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3': 'Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.',
    '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization': 'Try advanced Help Center customization with Premium',
    '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration': 'Resolve incidents with AI in Slack, try Premium now',
    '@atlassian/edition-benefits-modal.benefits-section.link.pricing': 'See more Premium features and pricing',
    '@atlassian/edition-benefits-modal.benefits-section.subtitle': "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    '@atlassian/edition-benefits-modal.button-trigger.open-modal': 'Open modal',
    '@atlassian/edition-benefits-modal.examples-section.incidents-video.iframe-title': 'YouTube video player',
    '@atlassian/edition-benefits-modal.features-section.buttons.premium.maybe-later': 'Maybe later',
    '@atlassian/edition-benefits-modal.features-section.buttons.premium.try-it-free': 'Try it free',
    '@atlassian/edition-benefits-modal.features-section.buttons.request-access': 'Request access',
    '@atlassian/edition-benefits-modal.features-section.buttons.request-access-error-description': "Your request couldn't be sent. Please try again.",
    '@atlassian/edition-benefits-modal.features-section.buttons.request-access-error-title': 'Something went wrong',
    '@atlassian/edition-benefits-modal.features-section.buttons.request-access-requested': 'Access requested',
    '@atlassian/edition-benefits-modal.features-section.buttons.request-access-success-description': "A request has been sent to your organization admin. You'll receive a notification if they grant you access.",
    '@atlassian/edition-benefits-modal.features-section.buttons.request-access-success-title': 'Access requested',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.add-payment-details': 'Add payment details',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-ai-enabled-forms': 'Explore handoff',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-assets': 'Explore Assets',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-automations': 'Explore Automations',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-customer-service-agent': 'Explore Customer service agent',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-knowledge-base': 'Explore Knowledge base',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-ops-agent': 'Explore Rovo Ops agent',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-service-agent': 'Explore Rovo Service agent',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.explore-rovo-support-companion': 'Explore Support Companion',
    '@atlassian/edition-benefits-modal.features-section.buttons.standard.invite-more-agents': 'Invite more agents',
    '@atlassian/edition-benefits-modal.features-section.description.help-center-customization': "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    '@atlassian/edition-benefits-modal.features-section.description.incidents-slack-integration': "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    '@atlassian/edition-benefits-modal.features-section.description.workforce-optimization': "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
    '@atlassian/edition-benefits-modal.features-section.header.help-center-customization': 'Try advanced Help Center customization with Premium',
    '@atlassian/edition-benefits-modal.features-section.header.incidents-slack-integration': 'Resolve incidents with AI in Slack, try Premium now',
    '@atlassian/edition-benefits-modal.features-section.header.standard-modal': 'Explore your Standard trial',
    '@atlassian/edition-benefits-modal.features-section.header.workforce-optimization': 'Auto routing powered by agent schedules and capacity',
    '@atlassian/edition-benefits-modal.features-section.link.pricing': 'See more Premium features and pricing',
    '@atlassian/edition-benefits-modal.features-section.request-access-warning.icon-label': 'Information',
    '@atlassian/edition-benefits-modal.features-section.request-access-warning.text': 'You must be a Customer Service Management user to access the AI customer service agent.',
    '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free': 'Try it free',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.at': '@',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.major-incident': 'MAJOR INCIDENT',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.raised-a': 'Raised a',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.rovo': 'Rovo',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.rovo-ops': 'Rovo Ops',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.summary': 'Summary',
    '@atlassian/edition-benefits-modal.rovo-ops-agent-ops-team.what-you-can-do-next': 'What you can do next',
    '@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.bradley': 'Bradley',
    '@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.helpCenter': 'Help center',
    '@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.resolved': 'Resolved',
    '@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.rovo': 'Rovo',
    '@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.rovoServiceAgent': 'Rovo service agent',
    '@atlassian/edition-benefits-modal.rovoServiceAgentServiceTeam.slash': '/',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link': 'cancel anytime.',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content': 'Add your payment details by <strong>{date}</strong> to continue using {edition}. {plansLink}',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user': 'To continue using {edition}, contact your billing admin to add payment details before your trial ends on <strong>{billingDate}</strong>.',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date': 'To continue using {edition}, contact your billing admin to add payment details before your trial ends.',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered': 'Your {edition} trial ends on <strong>{billingDate}</strong>.',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date': 'Your {edition} trial is ending soon.',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date': 'Add your payment details before your trial ends to continue using {edition}. {plansLink}',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered': "You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}",
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date': "You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}",
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link': 'See all plans.',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link': 'See plans',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details': 'Add payment details',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.close': 'Close',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms': 'Explore AI enabled Forms',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets': 'Explore Assets',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations': 'Explore Automations',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent': 'Explore Customer service agent',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base': 'Explore Knowledge base',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent': 'Explore Rovo Ops agent',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent': 'Explore Rovo Service agent',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion': 'Explore Rovo Support Companion',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents': 'Invite more agents',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description': 'Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description': 'Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description': 'Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description': 'Scale your support with <strong>unlimited support agents</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description': 'See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description': 'Move forward faster with <strong>10x Automation rule runs</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description': 'Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description': 'Scale your support with <strong>unlimited support agents</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description': 'Keep your requests moving with <strong>10x Automation rule runs</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description': 'Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description': 'Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description': 'Scale your support with <strong>unlimited support agents</strong>',
    '@atlassian/edition-benefits-modal.standard-benefits-modal.title': 'Explore your trial',
    '@atlassian/edition-benefits-modal.unlimitedAgentsServiceTeam.request': 'Request',
    '@atlassian/growth.edition-benefits-modal.automtion-service-team.automation': 'Automation',
    '@atlassian/growth.edition-benefits-modal.automtion-service-team.automation-runs': 'automation runs',
    '@atlassian/growth.edition-benefits-modal.automtion-service-team.x10': 'x10',
    '@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.customer': 'Customer',
    '@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.customerServiceAgent': 'Customer service agent',
    '@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.resolved': 'Resolved',
    '@atlassian/growth.edition-benefits-modal.csmCustomerServiceAgent.support': 'Support',
    'edition-benefits-modal.edition-benefits-popup.auto-upgrade.title': "You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
    'edition-benefits-modal.edition-benefits-popup.direct-trial.title': "You're on a free trial of our {edition} plan",
    'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details': "You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
    'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date': "You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
    'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details': 'Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.',
    'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date': 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
    'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details': "You won't be charged until your next billing date. <a>See plans</a>.",
    'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details': 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
    'edition-benefits-modal.edition-benefits-popup.manual-trial.title': 'Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started',
    'edition-benefits-modal.edition-benefits-popup.primary-button': 'Explore {edition}',
    'edition-benefits-modal.edition-benefits-popup.secondary-button': 'Add payment details'
};

});


parcelRegister("98o1X", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("eUj7E").then(()=>parcelRequire('5ELHn'));

});

parcelRegister("yIDrI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7Z2Re").then(()=>parcelRequire('dZakb'));

});

parcelRegister("k1jgF", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9rhXF").then(()=>parcelRequire('gQP42'));

});

parcelRegister("4NiiO", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("e1JyC").then(()=>parcelRequire('8Qhsm'));

});

parcelRegister("1hAoM", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7fiwD").then(()=>parcelRequire('9icOa'));

});

parcelRegister("hrtuv", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7jL2V").then(()=>parcelRequire('9tbVU'));

});

parcelRegister("fiZtW", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("g9hjg").then(()=>parcelRequire('jNcNb'));

});

parcelRegister("kvyiH", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("3liBY").then(()=>parcelRequire('4Fu3p'));

});

parcelRegister("1qQfK", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("i1MBk").then(()=>parcelRequire('d34tg'));

});

parcelRegister("g8DkN", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("89JOS").then(()=>parcelRequire('4iWGf'));

});

parcelRegister("5egqv", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("hgxtU").then(()=>parcelRequire('avQqv'));

});

parcelRegister("cnDRB", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("DANRI").then(()=>parcelRequire('jaAdS'));

});

parcelRegister("2JvFX", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gJCV3").then(()=>parcelRequire('d4Frk'));

});

parcelRegister("kVjXz", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1Caq2").then(()=>parcelRequire('5lB5d'));

});

parcelRegister("6EHVV", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("vf1lg").then(()=>parcelRequire('biCOb'));

});

parcelRegister("gYFjg", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1fqDt").then(()=>parcelRequire('41sVV'));

});

parcelRegister("5aYub", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("ajHxf").then(()=>parcelRequire('2JDbS'));

});

parcelRegister("50iGc", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("i6DPV").then(()=>parcelRequire('fX5ei'));

});

parcelRegister("kQw7P", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8TL35").then(()=>parcelRequire('7zYpD'));

});

parcelRegister("7DVwU", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fnctn").then(()=>parcelRequire('56QfG'));

});

parcelRegister("65x9i", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("jNpnn").then(()=>parcelRequire('eV4AK'));

});

parcelRegister("7693i", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bKZEb").then(()=>parcelRequire('j81yv'));

});

parcelRegister("6FLCG", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("cn7QM").then(()=>parcelRequire('b5cCO'));

});



parcelRegister("lB3Qz", function(module, exports) {
$parcel$export(module.exports, "popupFallbackMessages", () => $347e19e10cddf2df$export$a16b273775b597f7);

var $kjabF = parcelRequire("kjabF");
function $347e19e10cddf2df$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $347e19e10cddf2df$export$a16b273775b597f7 = Object.fromEntries(Object.values((0, $kjabF.messages)).filter($347e19e10cddf2df$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("kjabF", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1eb827dec2e874ad$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $1eb827dec2e874ad$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    starPopupAutoUpgradeTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.auto-upgrade.title',
        defaultMessage: "You've been upgraded to a {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan",
        description: 'Edition awareness button popup title'
    },
    starPopupManualTrialTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.manual-trial.title',
        defaultMessage: 'Your {trialDaysLeft, plural, one {# day} other {# days}} free trial of our {edition} plan has started',
        description: 'Edition awareness button popup title'
    },
    starPopupDirectTrialTitle: {
        id: 'edition-benefits-modal.edition-benefits-popup.direct-trial.title',
        defaultMessage: "You're on a free trial of our {edition} plan",
        description: 'Edition awareness button popup title'
    },
    starPopupDisclaimerWithoutPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details',
        defaultMessage: 'Add your payment details by <strong>{nextBillingDate}</strong> to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer'
    },
    starPopupDisclaimerWithoutPaymentDetailsNoDate: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-without-payment-details-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer for billing admins without payment details when next billing date is unavailable'
    },
    starPopupEndUserDisclaimerWithoutPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-without-payment-details',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. <a>See all plans</a>.',
        description: 'Edition awareness button popup disclaimer for end users without payment details when next billing date is unavailable'
    },
    starPopupPrimaryButton: {
        id: 'edition-benefits-modal.edition-benefits-popup.primary-button',
        defaultMessage: 'Explore {edition}',
        description: 'Edition awareness button popup primary button to explore the edition'
    },
    starPopupSecondaryButton: {
        id: 'edition-benefits-modal.edition-benefits-popup.secondary-button',
        defaultMessage: 'Add payment details',
        description: 'Edition awareness button popup secondary button to add payment details'
    },
    starPopupDisclaimerWithPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details',
        defaultMessage: "You won't be charged until your next billing date on <strong>{nextBillingDate}</strong>. <a>See plans</a> or <b>cancel anytime</b>.",
        description: 'Edition awareness button popup disclaimer'
    },
    starPopupDisclaimerWithPaymentDetailsNoDate: {
        id: 'edition-benefits-modal.edition-benefits-popup.disclaimer-with-payment-details-no-date',
        defaultMessage: "You won't be charged until your next billing date. <a>See plans</a> or <b>cancel anytime</b>.",
        description: 'Edition awareness button popup disclaimer for billing admins with payment details when next billing date is unavailable'
    },
    starPopupEndUserDisclaimerWithPaymentDetails: {
        id: 'edition-benefits-modal.edition-benefits-popup.end-user.disclaimer-with-payment-details',
        defaultMessage: "You won't be charged until your next billing date. <a>See plans</a>.",
        description: 'Edition awareness button popup disclaimer for end users with payment details when next billing date is unavailable'
    }
});

});


parcelRegister("4RbcG", function(module, exports) {
$parcel$export(module.exports, "standardBenefitsFallbackMessages", () => $003f0e00a10addfd$export$188a81d8a9b070a0);

var $jcIeu = parcelRequire("jcIeu");
function $003f0e00a10addfd$var$isMessageDescriptor(value) {
    return typeof value === 'object' && value !== null && 'id' in value && 'defaultMessage' in value;
}
const $003f0e00a10addfd$export$188a81d8a9b070a0 = Object.fromEntries(Object.values((0, $jcIeu.standardMessages)).filter($003f0e00a10addfd$var$isMessageDescriptor).map((d)=>{
    const msg = d.defaultMessage;
    return [
        d.id,
        typeof msg === 'string' ? msg : String(msg)
    ];
}));

});
parcelRegister("jcIeu", function(module, exports) {
$parcel$export(module.exports, "standardMessages", () => $b434aa9ec5de514b$export$e196fa8d430d87b);

var $6BhDL = parcelRequire("6BhDL");
const $b434aa9ec5de514b$export$e196fa8d430d87b = (0, $6BhDL.defineMessages)({
    closeButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.close',
        defaultMessage: 'Close',
        description: 'Aria-label for the close button in the edition benefits modal'
    },
    standardBenefitsModalTitle: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.title',
        defaultMessage: 'Explore your trial',
        description: 'Title for the standard benefits modal'
    },
    standardBenefitsModalBillingContent: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content',
        defaultMessage: 'Add your payment details by <strong>{date}</strong> to continue using {edition}. {plansLink}',
        description: "Billing content for the standard benefits modal. {plansLink} is the \u201CSee all plans\u201D link to pricing."
    },
    standardBenefitsModalBillingContentNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-no-date',
        defaultMessage: 'Add your payment details before your trial ends to continue using {edition}. {plansLink}',
        description: 'Billing content when billing date is unavailable. {edition} is the plan name; {plansLink} is the plans link.'
    },
    standardBenefitsModalBillingPlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-plans-link',
        defaultMessage: 'See all plans.',
        description: "Link label for the billing line \u201CSee all plans\u201D in the standard benefits modal"
    },
    standardBenefitsModalBillingContentPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered',
        defaultMessage: 'You won\u2019t be charged until your next billing date on <strong>{billingDate}</strong>. {plansLink} or {cancelLink}',
        description: 'Billing line when payment details are on file. {billingDate} is the next billing date; {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingContentPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-payment-entered-no-date',
        defaultMessage: 'You won\u2019t be charged until your next billing date. {plansLink} or {cancelLink}',
        description: 'Billing line when payment is on file but billing date is unavailable. {plansLink} and {cancelLink} are inline links.'
    },
    standardBenefitsModalBillingSeePlansLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-see-plans-link',
        defaultMessage: 'See plans',
        description: "Link label \u201CSee plans\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingCancelAnytimeLink: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-cancel-anytime-link',
        defaultMessage: 'cancel anytime.',
        description: "Link label \u201Ccancel anytime.\u201D in the payment-entered billing line"
    },
    standardBenefitsModalBillingContentEndUserPaymentEntered: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered',
        defaultMessage: 'Your {edition} trial ends on <strong>{billingDate}</strong>.',
        description: 'Billing line for end users (non-billing admins) with payment on file and a known billing date.'
    },
    standardBenefitsModalBillingContentEndUserPaymentEnteredNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-payment-entered-no-date',
        defaultMessage: 'Your {edition} trial is ending soon.',
        description: 'Billing line for end users (non-billing admins) with payment on file when billing date is unavailable.'
    },
    standardBenefitsModalBillingContentEndUser: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user',
        defaultMessage: 'To continue using {edition}, contact your billing admin to add payment details before your trial ends on <strong>{billingDate}</strong>.',
        description: 'Billing line for end users (non-billing admins) without payment details and a known billing date.'
    },
    standardBenefitsModalBillingContentEndUserNoDate: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.billing-content-end-user-no-date',
        defaultMessage: 'To continue using {edition}, contact your billing admin to add payment details before your trial ends.',
        description: 'Billing line for end users (non-billing admins) without payment details when billing date is unavailable.'
    },
    standardBenefitsModalAddPaymentDetailsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.add-payment-details',
        defaultMessage: 'Add payment details',
        description: 'Text for the add payment details button in the standard benefits modal'
    },
    standardBenefitsModalExploreRovoServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-service-agent',
        defaultMessage: 'Explore Rovo Service agent',
        description: 'Text for the explore Rovo Service agent button in the standard benefits modal'
    },
    standardBenefitsModalExploreKnowledgeBaseButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-knowledge-base',
        defaultMessage: 'Explore Knowledge base',
        description: 'Text for the explore Knowledge base primary button when that feature is selected'
    },
    standardBenefitsModalExploreAutomationsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-automations',
        defaultMessage: 'Explore Automations',
        description: 'Text for the explore Automations primary button when that feature is selected'
    },
    standardBenefitsModalInviteMoreAgentsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.invite-more-agents',
        defaultMessage: 'Invite more agents',
        description: 'Text for the invite more agents primary button when unlimited agents is selected'
    },
    // CTA — CSM
    standardBenefitsModalExploreCustomerServiceAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-customer-service-agent',
        defaultMessage: 'Explore Customer service agent',
        description: 'Primary CTA when Customer service agent feature is selected (CSM)'
    },
    standardBenefitsModalExploreRovoSupportCompanionButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-support-companion',
        defaultMessage: 'Explore Rovo Support Companion',
        description: 'Primary CTA when Rovo Support Companion feature is selected (CSM)'
    },
    standardBenefitsModalExploreAiEnabledFormsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-ai-enabled-forms',
        defaultMessage: 'Explore AI enabled Forms',
        description: 'Primary CTA when AI enabled Forms feature is selected (CSM)'
    },
    // CTA — Ops
    standardBenefitsModalExploreRovoOpsAgentButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-rovo-ops-agent',
        defaultMessage: 'Explore Rovo Ops agent',
        description: 'Primary CTA when Rovo Ops agent feature is selected (Ops)'
    },
    standardBenefitsModalExploreAssetsButton: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.button.explore-assets',
        defaultMessage: 'Explore Assets',
        description: 'Primary CTA when Assets feature is selected (Ops)'
    },
    // Feature: Service Teams
    serviceTeamsFeatureRovoAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.rovo-service-agents.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Service agent</strong> to resolve requests faster',
        description: 'Description for the Rovo Service Agents feature'
    },
    serviceTeamsFeatureKnowledgeBaseDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.knowledge-base.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written Knowledge Base articles</strong>',
        description: 'Description for the Knowledge Base feature'
    },
    serviceTeamsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.automation-rules.description',
        defaultMessage: 'Keep your requests moving with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation Rules feature'
    },
    jsmTeamsFeatureSupportArticlesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.support-articles.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written support articles</strong>',
        description: 'Description for the Knowledge Base feature in storage limits variant (service teams)'
    },
    jsmTeamsFeatureStorageLimitsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.storage-limits.description',
        defaultMessage: '<strong>250 GB storage</strong> to support your customers',
        description: 'Description for the Storage Limits feature (service teams)'
    },
    serviceTeamsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.service-teams.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited Agents feature'
    },
    // Feature: CSM
    csmFeatureCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.customer-service-agent.description',
        defaultMessage: 'Use an <strong>AI customer service agent</strong> to resolve requests and reduce team workload',
        description: 'Description for the Customer service agent feature (CSM)'
    },
    csmFeatureRovoSupportCompanionDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.rovo-support-companion.description',
        defaultMessage: 'Use <strong>Rovo Support Companion</strong> to help your team find solutions and draft responses',
        description: 'Description for the Rovo Support Companion feature (CSM)'
    },
    csmFeatureAiEnabledFormsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.ai-enabled-forms.description',
        defaultMessage: 'Enable <strong>handoff</strong> so your AI agent can seamlessly escalate to your team when needed',
        description: 'Description for the handoff feature (CSM)'
    },
    csmFeatureStorageCustomerServiceAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-customer-service-agent.description',
        defaultMessage: 'Use <strong>AI-powered Customer Service agent</strong> to deflect common requests and resolve them faster',
        description: 'Description for the Customer Service agent feature in storage limits variant (CSM)'
    },
    csmFeatureSupportArticlesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.support-articles.description',
        defaultMessage: 'Power your Rovo agent with <strong>AI written support articles</strong>',
        description: 'Description for the Knowledge Base feature in storage limits variant (CSM)'
    },
    csmFeatureStorageLimitsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.storage-limits.description',
        defaultMessage: '<strong>250 GB storage</strong> to support your customers',
        description: 'Description for the Storage Limits feature (CSM)'
    },
    csmFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.csm.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited agents feature (CSM)'
    },
    // Feature: Ops
    opsFeatureRovoOpsAgentDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.rovo-ops-agent.description',
        defaultMessage: 'Use AI-powered <strong>Rovo Ops agent</strong> to get AI summaries and next steps for incidents',
        description: 'Description for the Rovo Ops agent feature (Ops)'
    },
    opsFeatureAssetsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.assets.description',
        defaultMessage: 'See impacted business critical objects for rapid root cause analysis with <strong>Assets</strong>',
        description: 'Description for the Assets feature (Ops)'
    },
    opsFeatureAutomationRulesDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.automation-rules.description',
        defaultMessage: 'Move forward faster with <strong>10x Automation rule runs</strong>',
        description: 'Description for the Automation rule runs feature (Ops)'
    },
    opsFeatureUnlimitedAgentsDescription: {
        id: '@atlassian/edition-benefits-modal.standard-benefits-modal.feature.ops.unlimited-agents.description',
        defaultMessage: 'Scale your support with <strong>unlimited support agents</strong>',
        description: 'Description for the Unlimited agents feature (Ops)'
    }
});

});



parcelRegister("5gGY9", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $35b5bcf86de8c591$export$e926676385687eaf);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $gE3od = parcelRequire("gE3od");

var $c62a8 = parcelRequire("c62a8");

var $bB0tG = parcelRequire("bB0tG");
const $35b5bcf86de8c591$export$e926676385687eaf = ({ children: children, variantId: variantId })=>{
    const handleOnError = (0, $bB0tG.useErrorAnalytics)({
        variantId: variantId
    });
    const ufoContext = (0, $gE3od.useInteractionContext)();
    const onError = (0, $4fqPo.useCallback)((error, errorInfo)=>{
        const interaction = (0, $c62a8.getActiveInteraction)();
        handleOnError(error, errorInfo);
        if (interaction && ufoContext) (0, $c62a8.addError)(interaction === null || interaction === void 0 ? void 0 : interaction.id, error.name, ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack, 'interaction error', error.message, error.stack);
        else (0, $c62a8.addErrorToAll)(`ErrorBoundary:edition-benefits-modal${variantId ? `:${variantId}` : ''}`, (ufoContext === null || ufoContext === void 0 ? void 0 : ufoContext.labelStack) || null, 'interaction error', error.message);
    }, [
        handleOnError,
        variantId,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BYXH4.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null)
    }, children);
};

});
parcelRegister("bB0tG", function(module, exports) {
$parcel$export(module.exports, "useErrorAnalytics", () => $967127070f7217ac$export$e2d4523bbccd2343);

var $4fqPo = parcelRequire("4fqPo");

var $c5LZ7 = parcelRequire("c5LZ7");
/**
 * Errors which we ignore from SLO reporting to ensure we're only reporting on actionable errors
 */ const $967127070f7217ac$var$nonSLOErrors = [
    /**
 * These occur when the fetch request fails (usually due to network being offline)
 */ /failed to fetch/i,
    /**
 * These occur when the fetch request fails due to a server response (e.g. 401)
 */ /Error server response:/i
];
function $967127070f7217ac$var$isSLOError(error) {
    // Just checks that none of our non-SLO errors match the error
    return !$967127070f7217ac$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $967127070f7217ac$export$e2d4523bbccd2343({ variantId: variantId } = {}) {
    const sendOperationalEvent = (0, $c5LZ7.useOperationalAnalytics)();
    return (0, $4fqPo.useCallback)((error, errorInfo)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-benefits-modal.edition-benefits-modal',
            attributes: {
                variantId: variantId,
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                componentStack: errorInfo.componentStack,
                isSLOError: $967127070f7217ac$var$isSLOError(error)
            }
        });
    }, [
        sendOperationalEvent,
        variantId
    ]);
}

});


parcelRegister("7hs4s", function(module, exports) {
$parcel$export(module.exports, "messages", () => $834987d4cb8c1c8b$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $834987d4cb8c1c8b$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    benefitsSectionButtonMaybeLater: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.maybe-later',
        defaultMessage: 'Maybe later',
        description: 'Button in the edition benefits modal that allows the user to dismiss the upgrade prompt and return to it later.'
    },
    benefitsSectionButtonTryItFree: {
        id: '@atlassian/edition-benefits-modal.benefits-section.button.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Primary call-to-action button in the edition benefits modal that initiates a free trial of Premium features.'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature1',
        defaultMessage: '<strong>Reduce confusion for audiences</strong> with distinct help centers, landing pages and request types.',
        description: 'Text for first feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature2',
        defaultMessage: '<strong>Customise your help center</strong> to match your brand.',
        description: 'Text for second feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextHelpCenterCustomizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.help-center-customization.feature3',
        defaultMessage: '<strong>Help customers self-serve</strong> with knowledge base articles and custom rich content.',
        description: 'Text for third feature in help-center-customization variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature1',
        defaultMessage: 'Coordinate fast with <strong>automatically created Slack channels</strong> with the right people',
        description: 'Text for first feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature2',
        defaultMessage: 'Stay on top of key events with <strong>AI-generated incident summaries and timelines</strong>',
        description: 'Text for second feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextIncidentsSlackIntegrationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.incidents-slack-integration.feature3',
        defaultMessage: '<strong>Take actions from the Slack chat</strong> and sync key updates back to the incident',
        description: 'Text for third feature in incidents-slack-integration variant'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature1: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature1',
        defaultMessage: 'Scheduling ensures the right people work at the right time, improving coverage and balancing workloads.',
        description: 'Workforce Optimization feature row: scheduling'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature2: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature2',
        defaultMessage: "Capacity utilization shows each agent's usage, helping you easily spot and fix overload or underuse.",
        description: 'Workforce Optimization feature row: capacity utilization'
    },
    benefitsSectionFeatureTextWorkforceOptimizationFeature3: {
        id: '@atlassian/edition-benefits-modal.benefits-section.feature.text.workforce-optimization.feature3',
        defaultMessage: 'Unlock auto routing that uses real-time capacity and schedules to improve coverage, cut costs, and boost SLAs.',
        description: 'Workforce Optimization feature row: real-time auto routing'
    },
    benefitsSectionHeadingHelpCenterCustomization: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.help-center-customization',
        defaultMessage: 'Try advanced Help Center customisation with Premium',
        description: 'Heading for help-center-customization variant'
    },
    benefitsSectionHeadingIncidentsSlackIntegration: {
        id: '@atlassian/edition-benefits-modal.benefits-section.heading.incidents-slack-integration',
        defaultMessage: 'Resolve incidents with AI in Slack, try Premium now',
        description: 'Heading for incidents-slack-integration variant'
    },
    benefitsSectionLinkPricing: {
        id: '@atlassian/edition-benefits-modal.benefits-section.link.pricing',
        defaultMessage: 'See more Premium features and pricing',
        description: 'Link in the edition benefits modal that navigates the user to a page listing Premium features and their pricing.'
    },
    benefitsSectionSubtitle: {
        id: '@atlassian/edition-benefits-modal.benefits-section.subtitle',
        defaultMessage: "Get a 30-day free trial of Premium features. We'll remind you before your trial ends, cancel anytime.",
        description: 'Subtitle displayed in the benefits section of the edition benefits modal, explaining the free trial offer for Premium features.'
    },
    buttonTriggerOpenModal: {
        id: '@atlassian/edition-benefits-modal.button-trigger.open-modal',
        defaultMessage: 'Open modal',
        description: 'Text for the button that opens the edition benefits modal'
    },
    buttonTriggerTryItFree: {
        id: '@atlassian/edition-benefits-modal.premium-benefits-modal.try-it-free',
        defaultMessage: 'Try it free',
        description: 'Button text for to trigger opening the premium benefits modal'
    }
});

});

parcelRegister("hMRTL", function(module, exports) {
$parcel$export(module.exports, "premiumEditionBenefitsModalEntryPoint", () => $a649fd00fed614f7$export$262ed5b18480f6c7);

var $gYlSU = parcelRequire("gYlSU");

var $iMQOx = parcelRequire("iMQOx");

var $1G4Ci = parcelRequire("1G4Ci");

var $d8xub = parcelRequire("d8xub");

const $a649fd00fed614f7$export$262ed5b18480f6c7 = (0, $iMQOx.createEntryPoint)({
    root: (0, $gYlSU.JSResourceForInteraction)(()=>(parcelRequire("czPkf")), {
        moduleId: 'edition-benefits-modal-premium-benefits-modal'
    }),
    getPreloadProps: ({ cloudId: cloudId, product: product })=>({
            queries: {
                premiumBenefitsModalQuery: {
                    parameters: (0, $d8xub.default),
                    variables: {
                        cloudId: cloudId,
                        hamsProductKey: (0, $1G4Ci.getHamsKey)(product)
                    }
                }
            },
            extraProps: {
                product: product
            }
        })
});

});
parcelRegister("gYlSU", function(module, exports) {
$parcel$export(module.exports, "JSResourceForInteraction", () => $1366304219ba04cd$export$e83743682263315a);

var $cUG45 = parcelRequire("cUG45");

var $8yBiH = parcelRequire("8yBiH");

var $lcLJ6 = parcelRequire("lcLJ6");
const $1366304219ba04cd$var$cache = (0, $cUG45.createCache)(new Map());
/** Message when a string path reaches runtime (expected: build rewrites it to a loader). */ const $1366304219ba04cd$var$RUNTIME_STRING_ERROR = "JSResourceForInteraction was called with a string path at runtime. Ensure @atlassian/react-async-transformer is applied to transform this to a dynamic import.";
function $1366304219ba04cd$export$e83743682263315a(loaderOrPath, opts) {
    if (typeof loaderOrPath === 'string') throw new Error(`${$1366304219ba04cd$var$RUNTIME_STRING_ERROR} String path: ${JSON.stringify(loaderOrPath)}`);
    return $1366304219ba04cd$var$cache.get(opts.moduleId, ()=>(0, $8yBiH.PreloadableJSResource)(()=>(0, $lcLJ6.postTask)(loaderOrPath, {
                priority: 'user-visible'
            }), opts));
}

});
parcelRegister("cUG45", function(module, exports) {
$parcel$export(module.exports, "createCache", () => $d451ff082b8e9273$export$cf6fa0bbcc94b912);
function $d451ff082b8e9273$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}

});

parcelRegister("8yBiH", function(module, exports) {
$parcel$export(module.exports, "PreloadableJSResource", () => $60a221ed9fc85cfb$export$4fe5fba5bb1d3c09);

var $g3ujV = parcelRequire("g3ujV");
function $60a221ed9fc85cfb$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $g3ujV.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}

});
parcelRegister("g3ujV", function(module, exports) {
$parcel$export(module.exports, "JSResource", () => $057a8a593b6f7d77$export$148e45a6d4b4d65);

var $f595c = parcelRequire("f595c");

var $a8mpW = parcelRequire("a8mpW");

var $lDsU4 = parcelRequire("lDsU4");
function $057a8a593b6f7d77$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $a8mpW.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $a8mpW.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners){
                var _listener$onError;
                (_listener$onError = listener.onError) === null || _listener$onError === void 0 || _listener$onError.call(listener, error);
            }
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $f595c.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $a8mpW.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $lDsU4.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError === null || onError === void 0 || onError(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}

});
parcelRegister("f595c", function(module, exports) {
$parcel$export(module.exports, "generateId", () => $61774f1844255ef7$export$567fc7097e064344);
let $61774f1844255ef7$var$id = 100000;
function $61774f1844255ef7$export$567fc7097e064344() {
    $61774f1844255ef7$var$id += 1;
    return $61774f1844255ef7$var$id.toString();
}

});

parcelRegister("a8mpW", function(module, exports) {
$parcel$export(module.exports, "eventEmitter", () => $2e996df64afc3772$export$10dc3edfc20c8ff);
function $2e996df64afc3772$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $2e996df64afc3772$export$10dc3edfc20c8ff = $2e996df64afc3772$var$createEventEmitter();

});

parcelRegister("lDsU4", function(module, exports) {
$parcel$export(module.exports, "isJSModuleWithDefaultExport", () => $15915618a2c2961c$export$3b514faac3ba993c);
function $15915618a2c2961c$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}

});



parcelRegister("lcLJ6", function(module, exports) {
$parcel$export(module.exports, "postTask", () => $8159aa6097f2e510$export$13c9d02ca54955a3);
async function $8159aa6097f2e510$var$toPromise(callback) {
    return callback();
}
function $8159aa6097f2e510$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $8159aa6097f2e510$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $8159aa6097f2e510$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("aOcvD")).then(()=>$8159aa6097f2e510$var$getScheduler(globalThis).postTask(callback, options));
        return $8159aa6097f2e510$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}

});
parcelRegister("aOcvD", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("k1WXq").then(()=>parcelRequire('as0Tl'));

});



parcelRegister("iMQOx", function(module, exports) {
$parcel$export(module.exports, "createEntryPoint", () => $d053219559d27981$export$fa00dd5c1a75592f);
/* eslint-disable @typescript-eslint/ban-types */ function $d053219559d27981$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}

});

parcelRegister("1G4Ci", function(module, exports) {
$parcel$export(module.exports, "getHamsKey", () => $df25cd93d07717b5$export$291d012eb0744b34);
const $df25cd93d07717b5$var$ProductKeyToHAMSMap = {
    ['jira']: 'jira-software',
    ['jira-service-management']: 'jira-servicedesk',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['confluence']: 'confluence',
    ['jira-customer-service']: 'jira-customer-service'
};
const $df25cd93d07717b5$export$291d012eb0744b34 = (product)=>{
    return $df25cd93d07717b5$var$ProductKeyToHAMSMap[product];
};

});

parcelRegister("d8xub", function(module, exports) {
$parcel$export(module.exports, "default", () => $cfdfcd2a3855415b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f71f4408d1068bddb46758e4ae198ef1>>
 * @relayHash 0364ebf04a149c5cd5b923316a2324ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845

var $f2UoR = parcelRequire("f2UoR");
const $cfdfcd2a3855415b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hamsProductKey"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "hamsProductKey",
            "variableName": "hamsProductKey"
        }
    ], v3 = [
        {
            "kind": "Literal",
            "name": "offeringName",
            "value": "Premium"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "premiumBenefitsModalQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "args": v3 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ],
                                                    "storageKey": "changeOfferingV2(offeringName:\"Premium\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "67130027b1ddb3aab997061035952a486c3519596e6aaf454bc81d9896725845",
            "metadata": {},
            "name": "premiumBenefitsModalQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cfdfcd2a3855415b$var$node.hash = "0854408facd8d9c64a16089df4b3226a";
(0, $f2UoR.PreloadableQueryRegistry).set($cfdfcd2a3855415b$var$node.params.id, $cfdfcd2a3855415b$var$node);
var $cfdfcd2a3855415b$export$2e2bcd8739ae039 = $cfdfcd2a3855415b$var$node;

});

parcelRegister("czPkf", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("ixH4T"),
    $e46AW("8cdrC"),
    $e46AW("d2mFO"),
    $e46AW("b56zU"),
    $e46AW("83e22"),
    $e46AW("6wsXT")
]).then(()=>parcelRequire('9mFpU'));

});



parcelRegister("chA55", function(module, exports) {
$parcel$export(module.exports, "isPremiumUpsellExperimentEnabled", () => $cc435627fb04be9c$export$c62fce3d3e7c8a8b);

var $6bGmX = parcelRequire("6bGmX");
const $cc435627fb04be9c$export$c62fce3d3e7c8a8b = ({ hasSiteAdministerAccess: hasSiteAdministerAccess, isHCCustomizationEnabled: isHCCustomizationEnabled })=>{
    if (!hasSiteAdministerAccess || isHCCustomizationEnabled) return false;
    // Main Experiment
    return (0, $6bGmX.default).getExperimentValue('jsmgrowth-296_improving_premium_upsell_in_portal', 'isEnabled', false);
};

});

parcelRegister("wHtsq", function(module, exports) {
$parcel$export(module.exports, "clearSidebarExperienceAndCustomize", () => $9f2bd05ed99e2a78$export$4367df47a43e5f96);

var $PL4bf = parcelRequire("PL4bf");
const $9f2bd05ed99e2a78$export$47b19daccaa881f2 = ()=>{
    return (0, $PL4bf.get)('experience');
};
const $9f2bd05ed99e2a78$export$4367df47a43e5f96 = ()=>{
    (0, $PL4bf.set)({
        customize: undefined,
        experience: undefined
    });
};

});

parcelRegister("fmz0C", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => (parcelRequire("74muP")).ARTICLES_RESULT_LIMIT);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => (parcelRequire("74muP")).INITIAL_ARTICLES_LIMIT);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => (parcelRequire("74muP")).PORTALS_RESULT_LIMIT);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => (parcelRequire("74muP")).REQUEST_FORMS_NEW_LIMIT);
$parcel$export(module.exports, "REQUEST_FORMS_RESULT_LIMIT", () => (parcelRequire("74muP")).REQUEST_FORMS_RESULT_LIMIT);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => (parcelRequire("74muP")).SEARCH_QUERY_DEBOUNCE_TIME);
$parcel$export(module.exports, "DropdownOptionList", () => (parcelRequire("bywGP")).DropdownOptionList);
$parcel$export(module.exports, "Img", () => (parcelRequire("bywGP")).Img);
$parcel$export(module.exports, "InlineResultLink", () => (parcelRequire("bywGP")).InlineResultLink);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => (parcelRequire("bywGP")).InlineResultsHeadingWrapper);
$parcel$export(module.exports, "ResultList", () => (parcelRequire("bywGP")).ResultList);
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => (parcelRequire("bywGP")).SEARCH_BAR_HEIGHT);
$parcel$export(module.exports, "formatText", () => (parcelRequire("hRwKd")).formatText);
$parcel$export(module.exports, "formatToCleanText", () => (parcelRequire("hRwKd")).formatToCleanText);
$parcel$export(module.exports, "getIdsArray", () => (parcelRequire("hRwKd")).getIdsArray);
$parcel$export(module.exports, "getPortalIdAsNumber", () => (parcelRequire("hRwKd")).getPortalIdAsNumber);
$parcel$export(module.exports, "isSinglePortalSearch", () => (parcelRequire("hRwKd")).isSinglePortalSearch);
$parcel$export(module.exports, "isValidSearchTerm", () => (parcelRequire("hRwKd")).isValidSearchTerm);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => (parcelRequire("hRwKd")).sendSearchOperationalAnalyticEvents);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => (parcelRequire("hRwKd")).sendSearchUIAnalyticEvents);
$parcel$export(module.exports, "useQueryParams", () => (parcelRequire("hRwKd")).useQueryParams);
$parcel$export(module.exports, "useVisibilityState", () => (parcelRequire("hRwKd")).useVisibilityState);
parcelRequire("74muP");
parcelRequire("bywGP");
parcelRequire("hRwKd");

});
parcelRegister("74muP", function(module, exports) {
$parcel$export(module.exports, "ARTICLES_RESULT_LIMIT", () => $3da9e9a234d896bc$export$38c99458b97d4d4);
$parcel$export(module.exports, "PORTALS_RESULT_LIMIT", () => $3da9e9a234d896bc$export$d687c15f4e8fd960);
$parcel$export(module.exports, "REQUEST_FORMS_RESULT_LIMIT", () => $3da9e9a234d896bc$export$fc1850b34254ac28);
$parcel$export(module.exports, "INITIAL_ARTICLES_LIMIT", () => $3da9e9a234d896bc$export$f63f00916950640a);
$parcel$export(module.exports, "SEARCH_QUERY_DEBOUNCE_TIME", () => $3da9e9a234d896bc$export$95aa4d213e66754b);
$parcel$export(module.exports, "REQUEST_FORMS_NEW_LIMIT", () => $3da9e9a234d896bc$export$16da0cbbeac3310c);
const $3da9e9a234d896bc$export$38c99458b97d4d4 = 30;
const $3da9e9a234d896bc$export$d687c15f4e8fd960 = 5;
const $3da9e9a234d896bc$export$fc1850b34254ac28 = 5;
const $3da9e9a234d896bc$export$f63f00916950640a = 10;
const $3da9e9a234d896bc$export$95aa4d213e66754b = 300;
const $3da9e9a234d896bc$export$16da0cbbeac3310c = 15;

});

parcelRegister("bywGP", function(module, exports) {
$parcel$export(module.exports, "SEARCH_BAR_HEIGHT", () => $00b78f9150da2fce$export$9ac4f4162406e081);
$parcel$export(module.exports, "ResultList", () => $00b78f9150da2fce$export$7ebf7682ef098fb8);
$parcel$export(module.exports, "Img", () => $00b78f9150da2fce$export$cc7b5f925acc71d3);
$parcel$export(module.exports, "InlineResultsHeadingWrapper", () => $00b78f9150da2fce$export$a8317adc66cb9be6);
$parcel$export(module.exports, "InlineResultLink", () => $00b78f9150da2fce$export$5a34ff55d4e5e484);
$parcel$export(module.exports, "DropdownOptionList", () => $00b78f9150da2fce$export$b5e293376cc6b1ce);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $1P8FK = parcelRequire("1P8FK");
const $00b78f9150da2fce$export$9ac4f4162406e081 = "var(--ds-space-1000, 80px)";
const $00b78f9150da2fce$export$7ebf7682ef098fb8 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $00b78f9150da2fce$export$cc7b5f925acc71d3 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt4pxbi _1bsb1epz",
            __cmplp.className
        ])
    });
});
const $00b78f9150da2fce$export$a8317adc66cb9be6 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19bvpxbi",
            __cmplp.className
        ])
    });
});
const $00b78f9150da2fce$export$5a34ff55d4e5e484 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1P8FK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_4bfu1snc _1hmsagmp _ajmmvv82 _zulputpp _1reo15vq _18m915vq _1rjc12x7 _18zrpxbi _1e0c1txw _2lx2vrvc _1bsb1osq _syazwm8e _4cvr1h6o _vchhusvi _80omtlke _49pcnqa1 _1hvwdkaa _nt75xr8a _irr34mfv _1di61dty",
            __cmplp.className
        ])
    });
});
const $00b78f9150da2fce$export$b5e293376cc6b1ce = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _1pfhu2gc _1eg6idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hRwKd", function(module, exports) {
$parcel$export(module.exports, "formatText", () => $fe0dd440d0fbee45$export$905fe28a7c283e1d);
$parcel$export(module.exports, "formatToCleanText", () => $fe0dd440d0fbee45$export$519cc8c1640d01b8);
$parcel$export(module.exports, "useQueryParams", () => $fe0dd440d0fbee45$export$b37ee0d76c6d2fbc);
$parcel$export(module.exports, "isSinglePortalSearch", () => $fe0dd440d0fbee45$export$3bdd4cf348080703);
$parcel$export(module.exports, "getPortalIdAsNumber", () => $fe0dd440d0fbee45$export$c36431be801010b);
$parcel$export(module.exports, "isValidSearchTerm", () => $fe0dd440d0fbee45$export$34d09b0baed7315d);
$parcel$export(module.exports, "getIdsArray", () => $fe0dd440d0fbee45$export$b78190df63b1b0c4);
$parcel$export(module.exports, "sendSearchUIAnalyticEvents", () => $fe0dd440d0fbee45$export$c8b38685f22f1bb2);
$parcel$export(module.exports, "sendSearchOperationalAnalyticEvents", () => $fe0dd440d0fbee45$export$653243929c3168a8);
$parcel$export(module.exports, "useVisibilityState", () => $fe0dd440d0fbee45$export$54299a3c81f5425);

var $4fqPo = parcelRequire("4fqPo");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $3lnPx = parcelRequire("3lnPx");

var $hH1ci = parcelRequire("hH1ci");

var $jJnx5 = parcelRequire("jJnx5");

var $c5Ksk = parcelRequire("c5Ksk");

var $4i2V5 = parcelRequire("4i2V5");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
const $fe0dd440d0fbee45$export$437ad40c783f9f71 = (queryStringParams)=>{
    const { portalIds: selectedPortalIds } = queryStringParams;
    if (!selectedPortalIds) return [];
    return Array.isArray(selectedPortalIds) ? selectedPortalIds : [
        selectedPortalIds
    ];
};
const $fe0dd440d0fbee45$export$596cf762087ae00e = (queryStringParams)=>{
    const { categoryIds: selectedCategoryIds } = queryStringParams;
    if (!selectedCategoryIds) return [];
    return Array.isArray(selectedCategoryIds) ? selectedCategoryIds : [
        selectedCategoryIds
    ];
};
const $fe0dd440d0fbee45$export$905fe28a7c283e1d = (text = '', term = '')=>(0, $c5Ksk.default)(text, term).replace(/@@@hl@@@/g, '<strong>').replace(/@@@endhl@@@/g, '</strong>');
const $fe0dd440d0fbee45$export$519cc8c1640d01b8 = (text = '', term = '')=>(0, $c5Ksk.default)(text, term).replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
const $fe0dd440d0fbee45$export$b37ee0d76c6d2fbc = ()=>{
    const [{ location: location }, _] = (0, $hfD9S.useRouter)();
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $4fqPo.useMemo)(()=>{
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return (0, (/*@__PURE__*/$parcel$interopDefault($4i2V5))).parse(location.search);
    }, [
        location.search
    ]);
    const portalIds = (0, $4fqPo.useMemo)(()=>$fe0dd440d0fbee45$export$437ad40c783f9f71(queryStringParams), [
        queryStringParams
    ]);
    const categoryIds = (0, $4fqPo.useMemo)(()=>$fe0dd440d0fbee45$export$596cf762087ae00e(queryStringParams), [
        queryStringParams
    ]);
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
        ...queryStringParams,
        portalIds: portalIds,
        categoryIds: categoryIds
    };
};
const $fe0dd440d0fbee45$export$3bdd4cf348080703 = (portalId)=>portalId !== undefined && $fe0dd440d0fbee45$export$c36431be801010b(portalId) !== 0;
const $fe0dd440d0fbee45$export$34d09b0baed7315d = (term)=>Boolean(term && term.trim() !== '');
const $fe0dd440d0fbee45$export$c36431be801010b = (portalId)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($jJnx5)))(portalId);
};
const $fe0dd440d0fbee45$export$b78190df63b1b0c4 = (ids)=>{
    if (ids) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3lnPx)))(ids) || (0, (/*@__PURE__*/$parcel$interopDefault($hH1ci)))(ids)) return [
            ids.toString()
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($3Tp9Q)))(ids) ? ids : [];
    }
    return [];
};
const $fe0dd440d0fbee45$export$c8b38685f22f1bb2 = (eventProperties, createAnalyticsEvent, portalId, isInlineResult)=>{
    if (isInlineResult) eventProperties.actionSubjectId = 'inlineResult';
    else eventProperties.actionSubjectId = portalId ? 'singlePortal' : 'portalHomePage';
    createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'UI',
        actionSubjectId: eventProperties.actionSubjectId,
        ...eventProperties
    }).fire();
};
const $fe0dd440d0fbee45$export$653243929c3168a8 = (eventProperties, createAnalyticsEvent, portalId)=>{
    const statusCode = eventProperties.statusCode;
    if (statusCode !== 403 && statusCode !== 429) createAnalyticsEvent && createAnalyticsEvent({
        analyticsType: 'OPERATIONAL',
        actionSubjectId: portalId ? 'singlePortal' : 'portalHomePage',
        ...eventProperties
    }).fire();
};
const $fe0dd440d0fbee45$export$54299a3c81f5425 = ()=>{
    const [isHovered, setIsHovered] = (0, $4fqPo.useState)(false);
    const [isFocused, setIsFocused] = (0, $4fqPo.useState)(false);
    const [isShortcutIconVisible, setIsShortcutIconVisible] = (0, $4fqPo.useState)(false);
    return {
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsShortcutIconVisible: setIsShortcutIconVisible,
        isShortcutIconVisible: isHovered || isFocused || isShortcutIconVisible
    };
};

});


parcelRegister("7HEbW", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => (parcelRequire("kupV4")).AccountDetails);

var $kupV4 = parcelRequire("kupV4");

});
parcelRegister("kupV4", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $25ef5932aff83a27$export$66e04d0aacdb3b2);
/* account-details.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $aHUNw = parcelRequire("aHUNw");

var $aBwmQ = parcelRequire("aBwmQ");
var $45ZUo = parcelRequire("45ZUo");
const $25ef5932aff83a27$export$66e04d0aacdb3b2 = ({ avatarSrc: avatarSrc, displayName: displayName, email: email })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($25ef5932aff83a27$var$NonInteractiveLinkItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($25ef5932aff83a27$var$ProfileWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($25ef5932aff83a27$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aHUNw.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($25ef5932aff83a27$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($25ef5932aff83a27$var$DisplayName, null, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("small", null, email)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $25ef5932aff83a27$var$NonInteractiveLinkItem = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $aBwmQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_lcxvglyw _syaz261p",
            __cmplp.className
        ])
    });
});
const $25ef5932aff83a27$var$ProfileWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $25ef5932aff83a27$var$AvatarWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $25ef5932aff83a27$var$DisplayName = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_vwz4gktf",
            __cmplp.className
        ])
    });
});
const $25ef5932aff83a27$var$DetailsWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_2lx29ee3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aBwmQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $73f6f99bcaa0a10e$export$2e2bcd8739ae039);
/* link-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $koPKk = parcelRequire("koPKk");

var $9XaAY = parcelRequire("9XaAY");

var $lFnTx = parcelRequire("lFnTx");
const $73f6f99bcaa0a10e$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $73f6f99bcaa0a10e$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
const $73f6f99bcaa0a10e$var$preventEvent = (e)=>{
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ const $73f6f99bcaa0a10e$var$LinkItem = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { children: children, href: href, description: description, iconAfter: iconAfter, iconBefore: iconBefore, isDisabled: isDisabled = false, isSelected: isSelected = false, onClick: onClick, testId: testId, onMouseDown: onMouseDown, shouldTitleWrap: shouldTitleWrap, shouldDescriptionWrap: shouldDescriptionWrap, className: UNSAFE_className, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable: UNSAFE_isDraggable, interactionName: interactionName, ...rest } = props;
    const onMouseDownHandler = onMouseDown;
    const RouterLink = (0, $koPKk.default)();
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e)=>{
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    const isExternal = typeof href === 'string' && $73f6f99bcaa0a10e$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $73f6f99bcaa0a10e$var$IS_NON_HTTP_BASED.test(href);
    const isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ const isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $4fqPo.createElement((0, $lFnTx.default), {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && `${testId}--primitive`
    }, ({ children: children, className: className })=>/*#__PURE__*/ $4fqPo.createElement(Component, {
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item",
            ...rest,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            // @ts-expect-error
            href: isDisabled ? undefined : href,
            ...UNSAFE_isDraggable ? {} : {
                draggable: false,
                onDragStart: $73f6f99bcaa0a10e$var$preventEvent
            },
            onMouseDown: isDisabled ? $73f6f99bcaa0a10e$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $73f6f99bcaa0a10e$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }, children));
}));
var $73f6f99bcaa0a10e$export$2e2bcd8739ae039 = $73f6f99bcaa0a10e$var$LinkItem;

});



parcelRegister("3aJkj", function(module, exports) {
$parcel$export(module.exports, "UpgradeModal", () => $748dc125f2084f41$export$72c362f751994d32);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $748dc125f2084f41$export$72c362f751994d32 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("jVCBu")), {
        moduleId: "./packages/help-center/layout/menu/src/ui/upgrade-modal/upgrade-modal.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("jVCBu", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8qm14").then(()=>parcelRequire('kXTP8'));

});


parcelRegister("dvLMh", function(module, exports) {
$parcel$export(module.exports, "avatarMenuExperience", () => $a8dcf8647fc5c412$export$90a7234d224ce2c4);
$parcel$export(module.exports, "AvatarMenuExperienceFailure", () => $a8dcf8647fc5c412$export$2d5d3fcf414ca903);

var $4fqPo = parcelRequire("4fqPo");

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $a8dcf8647fc5c412$export$90a7234d224ce2c4 = new (0, $3odV5.UFOExperience)((0, $hWlSg.avatarMenuExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $a8dcf8647fc5c412$export$2d5d3fcf414ca903 = (props)=>{
    (0, $4fqPo.useEffect)(()=>{
        // Since experience failure function is returning a promise, just executing it without waiting for it to resolve
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        $a8dcf8647fc5c412$export$90a7234d224ce2c4.failure({
            metadata: props
        });
    }, [
        props
    ]);
    return null;
};

});

parcelRegister("gJ7ty", function(module, exports) {
$parcel$export(module.exports, "default", () => $68066f18a52a675d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $68066f18a52a675d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user requests section.',
        id: 'avatar.menu.v2.header.requests'
    },
    requestListHeading: {
        defaultMessage: 'REQUESTS LIST',
        description: 'Requests list header in menu request subsection',
        id: 'avatar.menu.v2.header.requests-list'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in menu request subsection',
        id: 'avatar.menu.v2.header.manage-column'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user approvals section.',
        id: 'avatar.menu.v2.header.approvals'
    },
    profile: {
        defaultMessage: 'Profile',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the user profile page.',
        id: 'avatar.menu.v2.header.profile'
    },
    logout: {
        defaultMessage: 'Log out',
        description: 'The text is shown on the log out button in the avatar drop-down menu that signs the user out of their account.',
        id: 'avatar.menu.v2.logout'
    },
    pageLayout: {
        defaultMessage: 'Page layout',
        description: 'Topics and Portals in avatar drop-down menu',
        id: 'avatar.menu.v2.topic'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in avatar drop-down menu',
        id: 'avatar.menu.v2.label.beta'
    },
    newLozenge: {
        defaultMessage: 'New',
        description: 'BeNewta lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.newLozenge'
    },
    topicsAndPortals: {
        defaultMessage: 'Topics and portals',
        description: 'Topics and Portals in avatar drop-down menu when advanced customization enabled',
        id: 'avatar.menu.v2.topics.and.portals'
    },
    look: {
        defaultMessage: 'Look and feel',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the look and feel customization settings.',
        id: 'avatar.menu.v2.look'
    },
    announcement: {
        defaultMessage: 'Announcements',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the announcements settings page.',
        id: 'avatar.menu.v2.announcement'
    },
    signIn: {
        defaultMessage: 'Log in message',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the log in message customization settings.',
        id: 'avatar.menu.v2.signIn'
    },
    helpCenterSettings: {
        defaultMessage: 'Service hub settings',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the service hub settings page.',
        id: 'avatar.menu.v2.helpCenterSettings'
    },
    customerHubSettings: {
        defaultMessage: 'Customer experience settings',
        description: 'Customer experience settings navigation item',
        id: 'avatar.menu.v2.customerHubSettings'
    },
    tooltip: {
        defaultMessage: 'Profile and settings',
        description: 'The text is shown as a tooltip when the user hovers over the avatar icon, indicating it opens the profile and settings menu.',
        id: 'avatar.profile.v2.tooltip'
    },
    reporting: {
        defaultMessage: 'Performance',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the Performance reporting page.',
        id: 'avatar.menu.v2.reporting'
    },
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'The text is shown as a navigation menu item in the avatar drop-down menu that links to the virtual service agent configuration page.',
        id: 'avatar.menu.v2.virtualServiceAgent'
    },
    portalAnnouncement: {
        defaultMessage: 'Announcements',
        description: 'announcement item in menu portal subsection',
        id: 'avatar.menu.v2.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Portal groups',
        description: 'portal groups item in menu portal subsection',
        id: 'avatar.menu.v2.requestTypeGroup'
    },
    portal: {
        defaultMessage: 'PORTAL',
        description: 'Portal heading for menu portal subsection',
        id: 'avatar.menu.v2.portal.section'
    },
    helpCenter: {
        defaultMessage: 'HELP CENTER',
        description: 'Help Center heading for menu multi hc subsection',
        id: 'avatar.menu.v2.helpCenter.section'
    },
    onboardingDescriptionCreateOrHcClickWithLink: {
        defaultMessage: 'Upgrade to Jira Service Management Premium to create and manage multiple help centers on your site and ',
        description: 'Upgrade modal description a help center is clicked or create a help center is clicked',
        id: 'uh.home.downgrade.modal.description.create.or.hc.with.link'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    onboardingTitleHCClick: {
        defaultMessage: 'Serve different audiences with multiple help centers',
        description: 'Upgrade modal title when help center is clicked',
        id: 'uh.home.downgrade.modal.title.hc'
    },
    freeStandardAdminsChangeBoardingHeading: {
        defaultMessage: 'Your help center settings have moved here',
        description: 'Heading text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.heading'
    },
    freeStandardAdminsChangeBoardingContent: {
        defaultMessage: 'Manage profile settings, view your requests, and customize your help center from here.',
        description: 'Content for topics Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.content'
    },
    freeStandardAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Free Standard Admins Change Boarding',
        id: 'sd.topic.filter.free.and.standard.changeboarding.button'
    },
    singlePortalScreenAdminsChangeBoardingHeading: {
        defaultMessage: 'Your portal settings have moved here',
        description: 'Heading text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.heading.'
    },
    singlePortalScreenAdminsChangeBoardingContent: {
        defaultMessage: 'Access your requests, profile settings, and customize the portal experience from here',
        description: 'Content for topics Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.content'
    },
    singlePortalScreenAdminsChangeBoardingButton: {
        defaultMessage: 'OK',
        description: 'Button text for Single Portal Screen Admins Change Boarding',
        id: 'sd.topic.filter.single.portal.screen.admins.changeboarding.button'
    },
    manageHc: {
        defaultMessage: 'View all help centers',
        description: 'Message for navigating to hc-management screen in avatar menu',
        id: 'avatar.menu.v2.manageHc'
    },
    managePages: {
        defaultMessage: 'Landing pages',
        description: 'Message for navigating to landing pages screen in avatar menu',
        id: 'avatar.menu.v2.help.center.pages'
    },
    rovoAgent: {
        defaultMessage: 'Rovo Agent',
        description: 'Label for create cutomized rovo agent button in avatar menue which is used to create a customized rovo agent',
        id: 'avatar.menu.v2.rovoAgent'
    },
    createHc: {
        defaultMessage: 'Create a help center',
        description: 'Label for create help center button in avatar menu which is used to navigate to the help center management page',
        id: 'avatar.menu.v2.createHc'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.description'
    },
    pageLayoutTryItNowButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'avatar.menu.v2.pageLayout.premium.try.it.now.button'
    },
    premiumLozenge: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge in avatar drop-down menu',
        id: 'avatar.menu.v2.label.premium.lozenge'
    },
    landingPagesNonPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create landing pages in a help center.',
        description: 'Non premium description for landing pages',
        id: 'avatar.menu.v2.landing.pages.non.premium.customer.description'
    },
    helpCenterMenuOptions: {
        defaultMessage: 'Help center menu options',
        description: 'Aria label for help center menu navigation list',
        id: 'avatar.menu.v2.helpCenter.menu.options'
    }
});

});

parcelRegister("5G1MC", function(module, exports) {
$parcel$export(module.exports, "RovoAgentMenu", () => $995b8975d0a33246$export$6cf91bfbf0fffa69);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $6mmHn = parcelRequire("6mmHn");

var $5Uaxl = parcelRequire("5Uaxl");
var $dQegt = parcelRequire("dQegt");

var $9qmTW = parcelRequire("9qmTW");

var $hHIxn = parcelRequire("hHIxn");

var $4oTiM = parcelRequire("4oTiM");

var $gJ7ty = parcelRequire("gJ7ty");
const $995b8975d0a33246$export$6cf91bfbf0fffa69 = ({ onClose: onClose, component: component })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarRovoAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        key: "customize-menu_navBarRovoAgent",
        component: component,
        href: `${(0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/rovo-agent`,
        actionSubjectId: "navBarRovoAgent",
        onClick: handleClick,
        testId: "rovo-agent-link",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
            appearance: "new"
        }, formatMessage((0, $gJ7ty.default).newLozenge)),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "cv-exclude-from-customisation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).rovoAgent));
};

});

parcelRegister("e5VNr", function(module, exports) {
$parcel$export(module.exports, "VirtualAgentMenu", () => $4c77dc980b97c3ed$export$3d3173207fec7a12);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $aeicL = parcelRequire("aeicL");

var $6mmHn = parcelRequire("6mmHn");

var $9ijW8 = parcelRequire("9ijW8");

var $jwb88 = parcelRequire("jwb88");

var $5Uaxl = parcelRequire("5Uaxl");

var $hHIxn = parcelRequire("hHIxn");

var $33cQv = parcelRequire("33cQv");
var $kBDWz = parcelRequire("kBDWz");

var $4oTiM = parcelRequire("4oTiM");

var $gJ7ty = parcelRequire("gJ7ty");
const $4c77dc980b97c3ed$export$3d3173207fec7a12 = ({ onClose: onClose, component: component })=>{
    const [showVaReportingOnboardingSpotlight, setShowVaReportingOnboardingSpotlight] = (0, $4fqPo.useState)(true);
    const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
    const handleClick = ()=>onClose('navBarVirtualAgent');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9ijW8.default), null, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $33cQv.default), {
            name: (0, $748yq.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT,
            key: "navBarVirtualAgent"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            key: `customize-menu_navBarVirtualAgent`,
            component: component,
            href: `${(0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH)}/${helpCenterId}/virtual-agent`,
            actionSubjectId: "navBarVirtualAgent",
            onClick: handleClick,
            testId: "virtual-agent-link",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $gJ7ty.default).virtualServiceAgent)))), showVaReportingOnboardingSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kBDWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aeicL.default), {
        messageId: (0, $748yq.EngagementMessages).ONBOARD_VA_REPORTING,
        key: (0, $748yq.EngagementMessagesTarget).REPORTING_ONBOARDING_SPOTLIGHT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jwb88.VaOnboardingSpotlight), {
        setShowVaReportingOnboardingSpotlight: setShowVaReportingOnboardingSpotlight
    }))));
};

});






parcelRegister("5Z4uE", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $191b893f850376e7$export$6e8ea24b15199873);

var $4fqPo = parcelRequire("4fqPo");
function $191b893f850376e7$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("jgUOz", function(module, exports) {
$parcel$export(module.exports, "Search", () => (parcelRequire("eOmbo")).default);

var $eOmbo = parcelRequire("eOmbo");

});
parcelRegister("eOmbo", function(module, exports) {
$parcel$export(module.exports, "default", () => $7996065aaf6eaec0$export$2e2bcd8739ae039);

var $iu3aL = parcelRequire("iu3aL");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("1lZyB");
var $9VkPG = parcelRequire("9VkPG");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $3Zmh8 = parcelRequire("3Zmh8");

var $ibOOf = parcelRequire("ibOOf");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("dMwUq");
var $gi2k1 = parcelRequire("gi2k1");
parcelRequire("gNfyY");
var $5lxa8 = parcelRequire("5lxa8");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("fk79P");
var $GAyRP = parcelRequire("GAyRP");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $bqq79 = parcelRequire("bqq79");

var $3Ar39 = parcelRequire("3Ar39");

var $fZppw = parcelRequire("fZppw");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");
parcelRequire("4dnPm");
var $93CBq = parcelRequire("93CBq");
parcelRequire("hynD4");
var $7LncL = parcelRequire("7LncL");
parcelRequire("91vmt");
var $eyl0q = parcelRequire("eyl0q");
parcelRequire("gCjjr");
var $kRO8E = parcelRequire("kRO8E");
const $7996065aaf6eaec0$export$4b85d3515bd863a5 = ({ term: term, trigger: trigger, isOpen: isOpen, onSearch: onSearch, onClose: onClose, onOpen: onOpen, resetSearch: resetSearch, fetchHelpCenter: fetchHelpCenter, fetchPortals: fetchPortals, disableSearch: disableSearch, isVSAOnHCEnabled: isVSAOnHCEnabled })=>{
    const searchButtonRef = (0, $4fqPo.useRef)(null);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $hRwKd.isSinglePortalSearch)(portalId)) fetchPortals({
            id: (0, $hRwKd.getPortalIdAsNumber)(portalId),
            expand: [
                'kbs',
                'reqTypes',
                'reqGroups',
                'orderMapping'
            ]
        });
    }, [
        portalId,
        fetchHelpCenter,
        fetchPortals
    ]);
    const onReturnFocus = (0, $4fqPo.useCallback)((_)=>{
        //FocusLock trap is still active due to that we deffer setting focus with zero-timeout
        setTimeout(()=>{
            var _searchButtonRef$curr;
            searchButtonRef === null || searchButtonRef === void 0 || (_searchButtonRef$curr = searchButtonRef.current) === null || _searchButtonRef$curr === void 0 || _searchButtonRef$curr.focus();
        }, 0);
        return true;
    }, []);
    (0, $4fqPo.useEffect)(()=>()=>{
            resetSearch();
        }, [
        resetSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eyl0q.default), {
        isOpen: isOpen,
        term: term,
        portalId: portalId,
        onSearch: onSearch,
        onClose: onClose,
        onReturnFocus: onReturnFocus,
        isVSAOnHCEnabled: isVSAOnHCEnabled
    }), trigger === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $GAyRP.default), {
        ref: searchButtonRef,
        shown: isOpen,
        onClick: onOpen,
        disableSearch: disableSearch
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, !isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93CBq.InlineResultsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kRO8E.default), {
        term: term,
        disableSearch: disableSearch,
        isVSAOnHCEnabled: !!isVSAOnHCEnabled
    }))));
};
const $7996065aaf6eaec0$var$SearchWithVirtualAgentAvailability = (props)=>{
    var _data$helpCenter, _data$helpCenter2, _data$virtualAgent;
    const { queryReference: queryReference, ...rest } = props;
    const data = (0, $gIeP2.usePreloadedQuery)((0, $iu3aL.default), props.queryReference);
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7996065aaf6eaec0$export$4b85d3515bd863a5, rest);
    const isVirtualAgentEnabled = ((_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.virtualAgentEnabled) ?? false;
    const isVirtualAgentAvailable = (0, $bG6ob.isVAOnHelpCenterGAEnabled)() ? ((_data$virtualAgent = data.virtualAgent) === null || _data$virtualAgent === void 0 ? void 0 : _data$virtualAgent.virtualAgentAvailability) ?? false : true;
    const isVSAOnHCEnabled = isVirtualAgentEnabled && isVirtualAgentAvailable;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7996065aaf6eaec0$export$4b85d3515bd863a5, {
        isVSAOnHCEnabled: isVSAOnHCEnabled,
        ...rest
    });
};
const $7996065aaf6eaec0$export$ab176425b2a52b00 = (props)=>{
    const { userLoggedIn: userLoggedIn } = props;
    const { queryReference: queryReference, refresh: refresh } = (0, $fZppw.useRelayResource)((0, $3Zmh8.searchComponentVirtualAgentResource));
    const prevUserLoggedInState = (0, $3Ar39.usePrevious)(userLoggedIn);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        if ((0, $6bGmX.default).checkGate('jsd-search-router-login-logic-removal') && !prevUserLoggedInState && userLoggedIn) // fire refresh only if user has logged in same session, e.g., Portal only customer login
        refresh();
    }, [
        prevUserLoggedInState,
        userLoggedIn,
        refresh
    ]);
    const renderError = (0, $4fqPo.useCallback)(()=>{
        // We fallback to non-VSA search if there is an error occurs in this loader, All the other errors should be handled by the SearchErrorBoundary default renderError
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7LncL.default), {
            id: "help-center-search"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7996065aaf6eaec0$export$4b85d3515bd863a5, props));
    }, [
        props
    ]);
    if (!queryReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7LncL.default), {
        id: "help-center-search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7996065aaf6eaec0$export$4b85d3515bd863a5, props));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7LncL.default), {
        id: "help-center-search",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7996065aaf6eaec0$export$4b85d3515bd863a5, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($7996065aaf6eaec0$var$SearchWithVirtualAgentAvailability, {
        queryReference: queryReference,
        ...props
    })));
};
const $7996065aaf6eaec0$var$selector = (0, $3yyCx.createSelector)((0, $5lxa8.getShown), (0, $5lxa8.getTerm), (0, $2hx7o.isLoggedIn), (shown, term, userLoggedIn)=>({
        term: term,
        userLoggedIn: userLoggedIn,
        isOpen: shown
    }));
const $7996065aaf6eaec0$var$ConnectedSearch = (0, $bmgw6.default)($7996065aaf6eaec0$var$selector, {
    onOpen: ()=>(0, $gi2k1.showSearch)(true),
    onClose: ()=>(0, $gi2k1.showSearch)(false),
    onSearch: (term)=>(0, $gi2k1.updateSearch)(term, {}),
    resetSearch: (0, $gi2k1.resetSearch),
    fetchPortals: (0, $lXazD.fetchPortalAction),
    fetchHelpCenter: (0, $9VkPG.fetchHelpCenterAction)
})((0, $bqq79.PortalAnalyticsModal)((0, $748yq.ScreenName).HELP_CENTER_SEARCH)(// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
(0, $ibOOf.default)((0, $apbG6.default)({
    component: (0, $748yq.ScreenName).HELP_CENTER_SEARCH
})((0, $as4kh.default)()($7996065aaf6eaec0$export$ab176425b2a52b00)))));
var $7996065aaf6eaec0$export$2e2bcd8739ae039 = $7996065aaf6eaec0$var$ConnectedSearch;

});
parcelRegister("4dnPm", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => (parcelRequire("93CBq")).InlineResultsContextProvider);
$parcel$export(module.exports, "useInlineResultsContext", () => (parcelRequire("93CBq")).useInlineResultsContext);

var $93CBq = parcelRequire("93CBq");

});
parcelRegister("93CBq", function(module, exports) {
$parcel$export(module.exports, "InlineResultsContextProvider", () => $15e848936781d8d5$export$55d16b7f4336c4d7);
$parcel$export(module.exports, "useInlineResultsContext", () => $15e848936781d8d5$export$243a7c3fd4b96b3e);

var $4fqPo = parcelRequire("4fqPo");
const $15e848936781d8d5$var$InlineResultsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(null);
const $15e848936781d8d5$export$55d16b7f4336c4d7 = ({ children: children })=>{
    const [resultsCount, setResultsCount] = (0, $4fqPo.useState)(null);
    const updateSearchResultsCount = (0, $4fqPo.useCallback)((resourceType, resourceCount)=>setResultsCount((state)=>({
                ...state,
                [resourceType]: resourceCount
            })), [
        setResultsCount
    ]);
    const clearSearchResultsCount = (0, $4fqPo.useCallback)(()=>setResultsCount(null), [
        setResultsCount
    ]);
    const contextValue = (0, $4fqPo.useMemo)(()=>({
            resultsCount: resultsCount,
            clearSearchResultsCount: clearSearchResultsCount,
            updateSearchResultsCount: updateSearchResultsCount
        }), [
        resultsCount,
        clearSearchResultsCount,
        updateSearchResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($15e848936781d8d5$var$InlineResultsContext.Provider, {
        value: contextValue
    }, children);
};
const $15e848936781d8d5$export$243a7c3fd4b96b3e = ()=>{
    const context = (0, $4fqPo.useContext)($15e848936781d8d5$var$InlineResultsContext);
    if (!context) throw new Error('useInlineResultsContext must be used within InlineResultsContextProvider');
    return context;
};

});


parcelRegister("hynD4", function(module, exports) {
$parcel$export(module.exports, "SearchErrorBoundary", () => (parcelRequire("7LncL")).default);

var $7LncL = parcelRequire("7LncL");

});
parcelRegister("7LncL", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d3248ae50385855$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gMSZD = parcelRequire("gMSZD");

var $63sfu = parcelRequire("63sfu");

var $eSL4S = parcelRequire("eSL4S");

var $3OiWH = parcelRequire("3OiWH");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");
parcelRequire("44kdQ");
var $fcvpD = parcelRequire("fcvpD");

var $d9wEN = parcelRequire("d9wEN");
const $1d3248ae50385855$var$SearchErrorBoundary = ({ screenName: screenName, id: id, children: children, renderError: renderError })=>{
    /**
   * If any error unrecoverable occurs inside search
   * 1. It should fail the entire experience - UFO
   * 2. Return null by default
   * 3. Send error payload to sentry and analytics - through ErrorBoundary
   * 4. Pass reason for the failure using UFO
   */ const markExperienceFailed = (0, $4fqPo.useCallback)((error)=>{
        if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) {
            const metadata = {
                id: id,
                error: error === null || error === void 0 ? void 0 : error.message,
                failureEvent: screenName
            };
            (0, $d9wEN.searchExperience).failure({
                metadata: metadata
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
            if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) (0, $d9wEN.csmSearchExperience).failure({
                metadata: metadata
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
            (0, $d9wEN.inlineSearchExperience).failure({
                metadata: metadata
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
        }
    }, [
        id,
        screenName
    ]);
    const defaultRenderError = (0, $4fqPo.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fcvpD.default), null);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: screenName,
        id: id,
        renderError: renderError ? renderError : defaultRenderError,
        onError: markExperienceFailed
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(children));
};
var $1d3248ae50385855$export$2e2bcd8739ae039 = (0, $3OiWH.default)($1d3248ae50385855$var$SearchErrorBoundary);

});
parcelRegister("44kdQ", function(module, exports) {
$parcel$export(module.exports, "SearchResultError", () => (parcelRequire("fcvpD")).default);

var $fcvpD = parcelRequire("fcvpD");

});
parcelRegister("fcvpD", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fa42874b861ef61$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $8Gf3q = parcelRequire("8Gf3q");

var $6MV1v = parcelRequire("6MV1v");

var $dQegt = parcelRequire("dQegt");

var $2eKV2 = parcelRequire("2eKV2");

var $4hIeL = parcelRequire("4hIeL");

var $Y85G3 = parcelRequire("Y85G3");
parcelRequire("fmz0C");
var $bywGP = parcelRequire("bywGP");

var $kmspM = parcelRequire("kmspM");
const $2fa42874b861ef61$var$SearchResultError = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6MV1v)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xsmall"
    }, formatMessage((0, $kmspM.default).searchErrorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("p", {
        style: {
            textAlign: 'center'
        }
    }, formatMessage((0, $kmspM.default).searchErrorText, {
        helpCenterLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Gf3q.default), {
            to: (0, $Y85G3.getHelpCenterUrl)(),
            actionSubjectId: "helpCenterLink"
        }, formatMessage((0, $kmspM.default).helpCenter))
    })));
};
var $2fa42874b861ef61$export$2e2bcd8739ae039 = $2fa42874b861ef61$var$SearchResultError;

});
parcelRegister("kmspM", function(module, exports) {
$parcel$export(module.exports, "default", () => $65c132c39341fdea$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $65c132c39341fdea$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    searchErrorTitle: {
        defaultMessage: 'We couldn\u2019t load your search results',
        description: 'Text to tell the user that there was an error while conducting a search',
        id: 'cv.search.error.title'
    },
    searchErrorText: {
        defaultMessage: 'Refresh the page and try again. Or go back to the { helpCenterLink }.',
        description: 'Text to tell the user how to proceed after there is an error while searching',
        id: 'cv.search.error.message'
    },
    helpCenter: {
        defaultMessage: 'help center',
        description: 'Text to render help center link',
        id: 'cv.search.error.help-center'
    }
});

});



parcelRegister("d9wEN", function(module, exports) {
$parcel$export(module.exports, "searchExperience", () => $ba906edca61eda5f$export$478fc2b872b7df27);
$parcel$export(module.exports, "csmSearchExperience", () => $ba906edca61eda5f$export$c32ff69c6cd0bb0b);
$parcel$export(module.exports, "inlineSearchExperience", () => $ba906edca61eda5f$export$e3eaed2128f58e6a);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $ba906edca61eda5f$export$478fc2b872b7df27 = new (0, $3odV5.UFOExperience)((0, $hWlSg.searchExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageLoad
});
const $ba906edca61eda5f$export$c32ff69c6cd0bb0b = new (0, $3odV5.UFOExperience)('csm-help-center-search', {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $ba906edca61eda5f$export$e3eaed2128f58e6a = new (0, $3odV5.UFOExperience)((0, $hWlSg.inlineSearchExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});



parcelRegister("91vmt", function(module, exports) {
$parcel$export(module.exports, "SearchModal", () => (parcelRequire("eyl0q")).default);

var $eyl0q = parcelRequire("eyl0q");

});
parcelRegister("eyl0q", function(module, exports) {
$parcel$export(module.exports, "default", () => $3dbf7cdac550bcc2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $awU1e = parcelRequire("awU1e");

var $isIps = parcelRequire("isIps");

var $6mmHn = parcelRequire("6mmHn");

var $fpChy = parcelRequire("fpChy");

var $4i2V5 = parcelRequire("4i2V5");

var $88P4u = parcelRequire("88P4u");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $c3Vmk = parcelRequire("c3Vmk");

var $93stz = parcelRequire("93stz");

var $7biT4 = parcelRequire("7biT4");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $dEWOM = parcelRequire("dEWOM");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $2vWb1 = parcelRequire("2vWb1");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3nV5N = parcelRequire("3nV5N");

var $ja75a = parcelRequire("ja75a");

var $j276L = parcelRequire("j276L");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");
var $bywGP = parcelRequire("bywGP");
parcelRequire("1ld2c");
var $i0Itl = parcelRequire("i0Itl");
parcelRequire("j14jX");
var $lavtP = parcelRequire("lavtP");
parcelRequire("fzWrE");
var $55ilz = parcelRequire("55ilz");

var $j7yBu = parcelRequire("j7yBu");
const $3dbf7cdac550bcc2$var$SearchModal = ({ isOpen: isOpen, term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, isLoggedIn: isLoggedIn, portalId: portalId, projectId: projectId, onSearch: onSearch, onClose: onClose, onReturnFocus: onReturnFocus })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const showSearchResults = (0, $hRwKd.isValidSearchTerm)(term);
    const scope = portalId ? 'portal' : 'helpCenter';
    const cloudId = (0, $6mmHn.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $3nV5N.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const isVirtualAgentAvailableForPortal = scope === 'portal' && isVirtualAgentAvailableForProject;
    const isVirtualAgentAvailableForHelpCenter = scope === 'helpCenter' && isVSAOnHCEnabled;
    const isVirtualAgentAvailable = isVirtualAgentAvailableForPortal || isVirtualAgentAvailableForHelpCenter;
    const onKeyUp = (0, $4fqPo.useCallback)((event)=>{
        if (event.key === 'Escape') onClose();
    }, [
        onClose
    ]);
    const [{ location: location }, { replace: replace }] = (0, $hfD9S.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $hRwKd.useQueryParams)();
    const { portalIds: portalIds, categoryIds: categoryIds } = queryStringParams;
    const portalIdAsNumber = (0, $hRwKd.getPortalIdAsNumber)(portalId);
    const showCategoryFilter = (0, $hRwKd.isSinglePortalSearch)(portalIdAsNumber);
    const onServiceDeskFilterChange = (0, $4fqPo.useCallback)((options)=>{
        const selectedPortalIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($4i2V5))).stringify({
            ...queryStringParams,
            portalIds: selectedPortalIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const onCategoryFilterChange = (0, $4fqPo.useCallback)((options)=>{
        const selectedCategoryIds = options.map((option)=>option.value);
        const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($4i2V5))).stringify({
            ...queryStringParams,
            categoryIds: selectedCategoryIds
        });
        replace(`${location.pathname}?${queryString}`);
    }, [
        location.pathname,
        queryStringParams,
        replace
    ]);
    const renderResults = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
            gap: "space.200",
            templateColumns: "1fr",
            alignItems: "center",
            xcss: $3dbf7cdac550bcc2$var$responsiveStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null), showSearchResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), null, isVirtualAgentAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $3dbf7cdac550bcc2$var$virtualBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ja75a.VirtualAgentBanner), {
            cloudId: cloudId,
            portalId: portalId
        })), !isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
            xcss: $3dbf7cdac550bcc2$var$filterStyles
        }, showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j276L.default), {
            onChange: onCategoryFilterChange,
            portalId: portalIdAsNumber,
            projectId: projectId,
            categoryIds: categoryIds
        }), !showCategoryFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j7yBu.default), {
            onChange: onServiceDeskFilterChange,
            portalIds: portalIds
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $55ilz.SearchResult), {
            term: term
        })) : // Show empty query state if invalid search term
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i0Itl.SearchResultNone), {
            term: term
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93stz.default), {
        duration: "small",
        entranceDirection: "bottom"
    }, (fadeInProps)=>isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7biT4.default), {
            zIndex: (0, $2vWb1.layers).dialog()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            ...fadeInProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            style: {
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: '0px',
                left: '0px'
            },
            role: "dialog",
            "aria-modal": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $88P4u.default), {
            autoFocus: true,
            returnFocus: onReturnFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fpChy.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c3Vmk.default), {
            shouldAllowClickThrough: false,
            isTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $2m8U6.xcss)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                height: `calc(100% - ${(0, $bywGP.SEARCH_BAR_HEIGHT)})`
            }),
            onKeyUp: onKeyUp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lavtP.SearchBar), {
            term: term,
            onChange: onSearch,
            onClose: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            id: "dynamic-search-result",
            "aria-live": "polite",
            "aria-atomic": "true",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            xcss: (0, $2m8U6.xcss)({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
                top: (0, $bywGP.SEARCH_BAR_HEIGHT),
                backgroundColor: 'elevation.surface.overlay',
                paddingTop: 'space.300',
                paddingBottom: 'space.200',
                overflow: 'auto'
            })
        }, renderResults())))))));
};
var $3dbf7cdac550bcc2$export$2e2bcd8739ae039 = (0, $bmgw6.default)((0, $3yyCx.createSelector)((0, $isIps.isLoggedIn), (state, { portalId: portalId })=>({
        portalId: portalId,
        projectId: (0, $awU1e.getProjectId)(state, (0, $hRwKd.getPortalIdAsNumber)(portalId))
    }), (isLoggedIn, { portalId: portalId, projectId: projectId })=>({
        isLoggedIn: isLoggedIn,
        portalId: portalId,
        projectId: projectId
    })))($3dbf7cdac550bcc2$var$SearchModal);
const $3dbf7cdac550bcc2$var$virtualBannerStyles = (0, $2m8U6.xcss)({
    marginBottom: 'space.200'
});
const $3dbf7cdac550bcc2$var$filterStyles = (0, $2m8U6.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.300'
});
const $3dbf7cdac550bcc2$var$responsiveStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        gridTemplateColumns: '1fr 965px 1fr',
        marginLeft: 'space.0',
        marginRight: 'space.0'
    }
});

});
parcelRegister("j276L", function(module, exports) {
$parcel$export(module.exports, "default", () => $54f4c0e05c2c06ce$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("1lZyB");
var $9pme5 = parcelRequire("9pme5");

var $awU1e = parcelRequire("awU1e");

var $1TfHm = parcelRequire("1TfHm");
const $54f4c0e05c2c06ce$var$selector = (0, $3yyCx.createSelector)((state, props)=>(0, $awU1e.getCategories)(state, props.portalId), (maybeCategories)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories
    };
});
const $54f4c0e05c2c06ce$var$CategoryFilter = (0, $bmgw6.default)($54f4c0e05c2c06ce$var$selector, {
    fetchCategories: (0, $9pme5.fetchCategoriesAction)
})((0, $1TfHm.default));
var $54f4c0e05c2c06ce$export$2e2bcd8739ae039 = $54f4c0e05c2c06ce$var$CategoryFilter;

});
parcelRegister("1TfHm", function(module, exports) {
$parcel$export(module.exports, "default", () => $030801a1ac395db4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
parcelRequire("3jNvt");
var $8Dgv1 = parcelRequire("8Dgv1");

var $78X9c = parcelRequire("78X9c");
const $030801a1ac395db4$var$CategoryFilter = ({ portalId: portalId, fetchCategories: fetchCategories, categories: categories, categoryIds: categoryIds, onChange: onChange, projectId: projectId })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [values, _] = $4fqPo.useState(categoryIds ?? []);
    $4fqPo.useEffect(()=>{
        if (!projectId || !portalId) return;
        fetchCategories(projectId, portalId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectId,
        portalId
    ]);
    const options = $4fqPo.useMemo(()=>{
        return categories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories
    ]);
    const preSelectedOptions = $4fqPo.useMemo(()=>{
        const preselectedCategories = categories.filter((category)=>values.find((id)=>id === category.id));
        return preselectedCategories.map((category)=>({
                optionType: 'option',
                value: category.id,
                label: category.name
            }));
    }, [
        categories,
        values
    ]);
    return categories.length > 1 ? /*#__PURE__*/ $4fqPo.createElement((0, $8Dgv1.default), {
        fieldId: "category_filter",
        fieldLabel: formatMessage((0, $78X9c.default).categoryFilter),
        testId: "categoryFilter",
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange
    }) : null;
};
var $030801a1ac395db4$export$2e2bcd8739ae039 = $030801a1ac395db4$var$CategoryFilter;

});
parcelRegister("3jNvt", function(module, exports) {
$parcel$export(module.exports, "SimplePicker", () => (parcelRequire("8Dgv1")).default);

var $8Dgv1 = parcelRequire("8Dgv1");

});
parcelRegister("8Dgv1", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1e3892518b9d3a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6dMTP = parcelRequire("6dMTP");

var $63sfu = parcelRequire("63sfu");

var $fFB0R = parcelRequire("fFB0R");
const $9b1e3892518b9d3a$export$a250605dcad5aca0 = (str, toMatch)=>{
    if (!str) return false;
    return toMatch ? str.toLowerCase().includes(toMatch.toLowerCase()) : true;
};
const $9b1e3892518b9d3a$export$60d56ed3961c839c = (0, $63sfu.memoize)((options, searchText)=>{
    if ((0, $63sfu.isEmpty)(searchText)) return options;
    const filteredOptions = [];
    for (const option of options)if ($9b1e3892518b9d3a$export$a250605dcad5aca0(option.label, searchText)) filteredOptions.push(option);
    return filteredOptions;
}, (...args)=>JSON.stringify(args));
const $9b1e3892518b9d3a$var$Picker = ({ options: options, preSelectedOptions: preSelectedOptions, onChange: onChange, fieldId: fieldId, testId: testId, fieldLabel: fieldLabel })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const [selectedValues, setSelectedValues] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(preSelectedOptions ?? []);
    const onPickerTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        setIsOpen(true);
    }, []);
    const onClose = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        setIsOpen(false);
    }, []);
    const onFilterChange = (0, $4fqPo.useCallback)((selectedOptions)=>{
        onChange(selectedOptions);
        setSelectedValues(selectedOptions);
    }, [
        onChange
    ]);
    const onFilterClearValues = (0, $4fqPo.useCallback)(()=>{
        onChange([]);
        setSelectedValues([]);
    }, [
        onChange
    ]);
    const onLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((search, _enableFullList, _showFullList, _showMore, _lastOption, cb)=>{
        const filteredOptions = $9b1e3892518b9d3a$export$60d56ed3961c839c(options, search);
        cb({
            options: filteredOptions,
            totalCount: filteredOptions.length
        });
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: fieldId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6dMTP.default), {
        fieldId: fieldId,
        fieldLabel: fieldLabel,
        isOpen: isOpen,
        value: selectedValues,
        enablePagination: false,
        onOpen: onOpen,
        onClose: onClose,
        onChange: onFilterChange,
        onLoadOptions: onLoadOptions,
        onClearValues: onFilterClearValues,
        onPickerTriggerClick: onPickerTriggerClick,
        testId: testId
    }));
};
var $9b1e3892518b9d3a$export$2e2bcd8739ae039 = $9b1e3892518b9d3a$var$Picker;

});


parcelRegister("78X9c", function(module, exports) {
$parcel$export(module.exports, "default", () => $6775d567b9afd6f4$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $6775d567b9afd6f4$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    categoryFilter: {
        defaultMessage: 'Category',
        description: 'Title of the category picker',
        id: 'sd.all.articles.result.category.filter.name'
    }
});

});



parcelRegister("1ld2c", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => (parcelRequire("i0Itl")).SearchResultNone);

var $i0Itl = parcelRequire("i0Itl");

});
parcelRegister("i0Itl", function(module, exports) {
$parcel$export(module.exports, "SearchResultNone", () => $b26f19ef31ea916d$export$149a2f9a7f0755fb);

var $4fqPo = parcelRequire("4fqPo");

var $bAkUi = parcelRequire("bAkUi");

var $9qprA = parcelRequire("9qprA");

var $dQegt = parcelRequire("dQegt");

var $2eKV2 = parcelRequire("2eKV2");

var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");

var $3krHC = parcelRequire("3krHC");
parcelRequire("fmz0C");
var $bywGP = parcelRequire("bywGP");

var $d9wEN = parcelRequire("d9wEN");

var $8cGwZ = parcelRequire("8cGwZ");
const $b26f19ef31ea916d$export$149a2f9a7f0755fb = ({ term: term })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    if (term === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bAkUi))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $8cGwZ.default).noSearchQueryTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        align: "center"
    }, formatMessage((0, $8cGwZ.default).noSearchQueryBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $d9wEN.searchExperience)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.Img), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9qprA))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $8cGwZ.default).noSearchResultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        align: "center"
    }, formatMessage((0, $8cGwZ.default).noSearchResultBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $d9wEN.searchExperience)
    }));
};

});
parcelRegister("8cGwZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7188330c2a868928$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $7188330c2a868928$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    noSearchResultTitle: {
        defaultMessage: 'We couldn\u2019t find a match for your search',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.none.no-search-result-title'
    },
    noSearchResultText: {
        defaultMessage: 'We couldn\u2019t find any matches for \u2018{ term }\u2019. Check your search for typos, or try another search term.',
        description: 'Title text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-text'
    },
    noSearchResultBody: {
        defaultMessage: 'Check your search for typos, or try another search term.',
        description: 'Body text to tell the user how to proceed after finding no search results',
        id: 'cv.search.none.no-search-result-body'
    },
    noSearchQueryTitle: {
        defaultMessage: 'Looking for something?',
        description: 'Title text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-title'
    },
    noSearchQueryBody: {
        defaultMessage: 'Enter your search term above to get started.',
        description: 'Body text to tell the user how to proceed when search query in search bar is empty',
        id: 'cv.search.none.no-search-query-body'
    }
});

});



parcelRegister("j14jX", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => (parcelRequire("lavtP")).SearchBar);

var $lavtP = parcelRequire("lavtP");

});
parcelRegister("lavtP", function(module, exports) {
$parcel$export(module.exports, "SearchBar", () => $b340d60c832834b7$export$79d13b60110f33be);

var $4fqPo = parcelRequire("4fqPo");

var $cbtb0 = parcelRequire("cbtb0");

var $63sfu = parcelRequire("63sfu");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $9RW5e = parcelRequire("9RW5e");

var $8B6Ry = parcelRequire("8B6Ry");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");
parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");

var $bOOgP = parcelRequire("bOOgP");

var $PL4bf = parcelRequire("PL4bf");
parcelRequire("fmz0C");
var $bywGP = parcelRequire("bywGP");
var $74muP = parcelRequire("74muP");
var $hRwKd = parcelRequire("hRwKd");

var $dxsfB = parcelRequire("dxsfB");
const $b340d60c832834b7$export$79d13b60110f33be = ({ term: term, onChange: onChange, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [backButtonText, setBackButtonText] = (0, $4fqPo.useState)();
    const searchBarRef = (0, $4fqPo.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, $4fqPo.useState)(term);
    (0, $4fqPo.useEffect)(()=>{
        let observer;
        const currentSearchBarRefRef = searchBarRef.current;
        if (window.ResizeObserver) {
            observer = new window.ResizeObserver((entries)=>{
                for (const entry of entries)setBackButtonText(entry.contentRect.width < 768 ? '' : undefined);
            });
            if (currentSearchBarRefRef) observer.observe(currentSearchBarRefRef);
        }
        return ()=>{
            if (currentSearchBarRefRef) observer.unobserve(currentSearchBarRefRef);
        };
    }, []);
    const debouncedOnChangeMethod = (0, $4fqPo.useMemo)(()=>(0, $63sfu.debounce)((value)=>{
            onChange(value);
        }, (0, $74muP.SEARCH_QUERY_DEBOUNCE_TIME)), [
        onChange
    ]);
    const onSearchTermChange = (0, $4fqPo.useCallback)((e)=>{
        setSearchQuery(e.target.value);
        if ((0, $6bGmX.default).checkGate('debounce_change_in_portal_search')) debouncedOnChangeMethod(e.target.value);
        else onChange(e.target.value);
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'changed',
            actionSubject: 'searchTermValue',
            actionSubjectId: 'searchTerm'
        }).fire();
    }, [
        createAnalyticsEvent,
        debouncedOnChangeMethod,
        onChange
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            analyticsType: 'UI',
            action: 'rendered',
            actionSubject: 'searchBarTextField',
            actionSubjectId: 'searchBar'
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const { goBack: goBack, push: push } = (0, $1wDzz.useRouterActions)();
    const onBackButtonClick = (0, $4fqPo.useCallback)(()=>{
        goBack();
    }, [
        goBack
    ]);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const queryStringParams = (0, $hRwKd.useQueryParams)();
    const onCrossIconClick = (0, $4fqPo.useCallback)(()=>{
        setSearchQuery('');
        onChange('');
        push((0, $PL4bf.addParamsToUrl)('', {
            ...queryStringParams,
            q: ''
        }));
    }, [
        onChange,
        push,
        queryStringParams
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $b340d60c832834b7$var$containerStyles,
        ref: searchBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        gap: "space.200",
        templateColumns: "25fr 50fr 25fr",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b340d60c832834b7$var$backButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cbtb0.default), {
        text: backButtonText,
        actionSubjectId: "closeSearch",
        onClick: onBackButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b340d60c832834b7$var$textFieldStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bOOgP.default), {
        id: "search-bar-input",
        value: searchQuery,
        name: formatMessage((0, $dxsfB.default).inputLabel),
        "aria-label": formatMessage((0, $dxsfB.default).inputPlaceholder),
        onChange: onSearchTermChange,
        placeholder: formatMessage((0, $dxsfB.default).inputPlaceholder),
        "aria-describedby": "dynamic-search-result",
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $b340d60c832834b7$var$searchIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "button",
            "aria-label": formatMessage((0, $dxsfB.default).clearLabel),
            xcss: $b340d60c832834b7$var$crossIconStyles,
            onClick: onCrossIconClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
            label: formatMessage((0, $dxsfB.default).clearLabel),
            spacing: "spacious",
            color: "var(--ds-icon, #42526E)"
        })),
        // Disabling existing violations, should be fixed when revisited.
        autoFocus: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null)));
};
const $b340d60c832834b7$var$containerStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    width: '100vw',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    height: (0, $bywGP.SEARCH_BAR_HEIGHT),
    backgroundColor: 'elevation.surface.overlay',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid',
    borderBottomColor: "var(--ds-border, #EBECF0)",
    zIndex: 'modal'
});
const $b340d60c832834b7$var$backButtonStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        marginLeft: 'space.050'
    },
    [(0, $3jKXW.media).above.xs]: {
        marginLeft: 'space.100'
    },
    [(0, $3jKXW.media).above.sm]: {
        marginLeft: 'space.200'
    }
});
const $b340d60c832834b7$var$textFieldStyles = (0, $2m8U6.xcss)({
    height: 'space.500',
    marginLeft: 'space.100',
    marginRight: 'space.100',
    background: 'transparent',
    [(0, $3jKXW.media).above.xxs]: {
        width: '348px'
    },
    [(0, $3jKXW.media).above.xs]: {
        width: '432px'
    },
    [(0, $3jKXW.media).above.sm]: {
        width: '692px'
    },
    [(0, $3jKXW.media).above.md]: {
        width: '965px'
    }
});
const $b340d60c832834b7$var$searchIconStyles = (0, $2m8U6.xcss)({
    padding: 'space.100'
});
const $b340d60c832834b7$var$crossIconStyles = (0, $2m8U6.xcss)({
    background: 'transparent',
    cursor: 'pointer'
});
var $b340d60c832834b7$export$2e2bcd8739ae039 = (0, $as4kh.default)()($b340d60c832834b7$export$79d13b60110f33be);

});
parcelRegister("dxsfB", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fceaaf0047f9aff$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $7fceaaf0047f9aff$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    inputPlaceholder: {
        defaultMessage: 'Search for help resources',
        description: 'Placeholder message for the search bar describing what they can look for',
        id: 'cv.search.search-bar.input.placeholder'
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-bar.close'
    },
    inputLabel: {
        defaultMessage: 'Search bar input',
        description: 'Label message for the search bar input',
        id: 'cv.search.search-bar.input-label'
    },
    searchIconLabel: {
        defaultMessage: 'Search icon',
        description: 'Label message for the search bar input icon',
        id: 'cv.search.search-bar.search-icon-label'
    },
    clearLabel: {
        defaultMessage: 'clear',
        description: 'Label for the clear button which clears the search input',
        id: 'cv.search.search-bar.clear-label'
    }
});

});



parcelRegister("fzWrE", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => (parcelRequire("55ilz")).SearchResult);

var $55ilz = parcelRequire("55ilz");

});
parcelRegister("55ilz", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $63272f8df014ef34$export$a2def421b23768aa);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $eNI4Q = parcelRequire("eNI4Q");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3Ar39 = parcelRequire("3Ar39");

var $6Sdci = parcelRequire("6Sdci");
parcelRequire("4Z0wN");
var $jo8D0 = parcelRequire("jo8D0");
parcelRequire("fmz0C");
var $74muP = parcelRequire("74muP");

var $d9wEN = parcelRequire("d9wEN");
parcelRequire("esdqh");
var $axkkq = parcelRequire("axkkq");
parcelRequire("1ld2c");
var $i0Itl = parcelRequire("i0Itl");
parcelRequire("dlViU");
var $h3DZp = parcelRequire("h3DZp");
parcelRequire("iSdoA");
var $9VNKz = parcelRequire("9VNKz");
const $63272f8df014ef34$export$e9a269813a6315a4 = ({ term: term, updateResultsCount: updateResultsCount })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const onlyRenderArticles = isCSM;
    if (onlyRenderArticles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $axkkq.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jo8D0.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $63272f8df014ef34$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $axkkq.ArticleResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jo8D0.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $axkkq.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9VNKz.default), {
        term: term,
        updateResultsCount: updateResultsCount
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $axkkq.SidePanelResultsLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h3DZp.default), {
        term: term,
        updateResultsCount: updateResultsCount
    }))));
};
const $63272f8df014ef34$export$a2def421b23768aa = ({ term: term })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const [totalCount, setTotalCount] = (0, $4fqPo.useState)(-1);
    const resultsCount = (0, $4fqPo.useRef)(-1);
    const callBackCount = (0, $4fqPo.useRef)(0);
    const debouncedTerm = (0, $6Sdci.default)(term, (0, $74muP.SEARCH_QUERY_DEBOUNCE_TIME));
    // Every time this callback will be called, that resource will increment callBackCount through acknowledgement
    const updateResultsCount = (0, $4fqPo.useCallback)((count, acknowledgement)=>{
        if (resultsCount.current < 0) resultsCount.current = 0;
        resultsCount.current += count;
        if (acknowledgement) callBackCount.current += acknowledgement;
        // Update state only when articles, portals and requestForms all have updated the results
        if (callBackCount.current === 3) {
            // Since callbackCount will persist across states, setting it back to 0
            callBackCount.current = 0;
            setTotalCount(resultsCount.current);
        }
    }, []);
    (0, $3Ar39.useIsoMorphicLayoutEffect)(()=>{
        // Reset count to initial state on term change
        resultsCount.current = -1;
        setTotalCount(-1);
        callBackCount.current = 0;
    }, [
        debouncedTerm
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        isCSM ? (0, $d9wEN.csmSearchExperience).start() : (0, $d9wEN.searchExperience).start();
        return ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            isCSM ? (0, $d9wEN.csmSearchExperience).abort() : (0, $d9wEN.searchExperience).abort();
        };
    }, [
        debouncedTerm,
        isCSM
    ]);
    const isEmptyResultsState = totalCount === 0;
    const isEmptyQueryState = debouncedTerm === '';
    const showEmptyState = isEmptyQueryState || isEmptyResultsState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $axkkq.SearchResultsLoader), null)
    }, showEmptyState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i0Itl.SearchResultNone), {
        term: debouncedTerm
    }), !isEmptyResultsState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($63272f8df014ef34$export$e9a269813a6315a4, {
        term: term,
        updateResultsCount: updateResultsCount
    }));
};
const $63272f8df014ef34$var$responsiveStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        gridTemplateColumns: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});

});
parcelRegister("4Z0wN", function(module, exports) {
$parcel$export(module.exports, "Articles", () => (parcelRequire("jo8D0")).default);

var $jo8D0 = parcelRequire("jo8D0");

});
parcelRegister("jo8D0", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd5df8963d6ad999$export$2e2bcd8739ae039);

var $h8ONT = parcelRequire("h8ONT");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $eQdiM = parcelRequire("eQdiM");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $2eKV2 = parcelRequire("2eKV2");

var $cTq8x = parcelRequire("cTq8x");

var $3H4LK = parcelRequire("3H4LK");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $b0RoQ = parcelRequire("b0RoQ");

var $3krHC = parcelRequire("3krHC");
parcelRequire("8Arhd");
var $92TSs = parcelRequire("92TSs");
parcelRequire("fmz0C");
var $74muP = parcelRequire("74muP");
var $hRwKd = parcelRequire("hRwKd");
var $bywGP = parcelRequire("bywGP");

var $d9wEN = parcelRequire("d9wEN");
parcelRequire("1ld2c");
var $i0Itl = parcelRequire("i0Itl");

var $3fKec = parcelRequire("3fKec");
const $fd5df8963d6ad999$export$b9fde6c411c336c6 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const CSMPortalId = isCSM ? (0, $ebpTf.getEnv)().hoistedPortalId : undefined;
    const { portalIds: portalIds, categoryIds: categoryIds } = (0, $hRwKd.useQueryParams)();
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const getSelectedPortalIds = ()=>{
        if (CSMPortalId) return (0, $hRwKd.getIdsArray)(CSMPortalId);
        if ((0, $hRwKd.isSinglePortalSearch)(portalId)) return (0, $hRwKd.getIdsArray)(portalId);
        return (0, $hRwKd.getIdsArray)(portalIds);
    };
    const cloudId = (0, $6mmHn.getCloudId)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $h8ONT.default), {
        cloudId: cloudId,
        categoryIds: categoryIds,
        queryTerm: term,
        portalIds: getSelectedPortalIds(),
        helpCenterAri: (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() ? (0, $6mmHn.getHelpCenterAri)() : undefined,
        limit: (0, $74muP.ARTICLES_RESULT_LIMIT),
        highlight: true,
        isSourceSystemEnabled: (0, $6bGmX.default).checkGate('3p-integration-enabled_t5ysh') || (0, $6bGmX.default).checkGate('kb-cross-site-enabled')
    });
    const [numberOfResultsShown, setNumberOfResultsShown] = (0, $4fqPo.useState)((0, $74muP.INITIAL_ARTICLES_LIMIT));
    const articles = (0, $4fqPo.useMemo)(()=>{
        var _data$helpObjectStore;
        return ((_data$helpObjectStore = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreArticleSearchResults' ? data.helpObjectStore_searchArticles.results : [];
    }, [
        data.helpObjectStore_searchArticles
    ]);
    const numOfResults = articles.length;
    const hasMoreResults = numOfResults > numberOfResultsShown;
    const showMoreArticlesButton = numberOfResultsShown < 30 && hasMoreResults;
    const slicedArticles = articles.slice(0, numberOfResultsShown) || [];
    const showSection = numOfResults > 0;
    const sourceSystem = (0, $4fqPo.useMemo)(()=>articles.reduce((records, item)=>{
            const currentSourceSystem = item.sourceSystem;
            const value = currentSourceSystem ? records[currentSourceSystem] ?? 0 : 0;
            return {
                ...records,
                ...currentSourceSystem && {
                    [currentSourceSystem]: value + 1
                }
            };
        }, {}), [
        articles
    ]);
    (0, $4fqPo.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreArticleSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchArticles.results.forEach((article)=>{
                if (article) {
                    const { metadata: metadata } = article;
                    const { searchStrategy: searchStrategy } = metadata;
                    const isExternal = article.sourceSystem === 'EXTERNAL';
                    if (isExternal) externalResourcesCount += 1;
                    if (searchStrategy === 'CONTENT_SEARCH') firstPartySearchPlatformResourcesCount += 1;
                }
            });
            (0, $hRwKd.sendSearchOperationalAnalyticEvents)({
                sourceSystem: sourceSystem,
                action: portalId ? 'KBArticleSinglePortalSearch success' : 'KBArticleHomePageSearch success',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $hRwKd.sendSearchUIAnalyticEvents)({
                sourceSystem: sourceSystem,
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'article',
                resourceCount: data.helpObjectStore_searchArticles.results.length,
                totalCount: data.helpObjectStore_searchArticles.totalCount
            }, createAnalyticsEvent, portalId);
        }
    }, [
        showSection,
        createAnalyticsEvent,
        portalId,
        sourceSystem,
        data
    ]);
    (0, $4fqPo.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchArticles) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchArticles;
            (0, $hRwKd.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                action: portalId ? 'KBArticleSinglePortalSearch failed' : 'KBArticleHomePageSearch failed',
                statusCode: extensions.length > 0 ? extensions[0].statusCode : undefined,
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        updateResultsCount(slicedArticles.length, 1);
    }, [
        term,
        slicedArticles.length,
        updateResultsCount
    ]);
    const onShowMoreClick = ()=>{
        if (numberOfResultsShown < 30) setNumberOfResultsShown((0, $74muP.ARTICLES_RESULT_LIMIT));
    };
    if (!showSection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i0Itl.SearchResultNone), {
        term: term
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $3fKec.default).articles)), (0, $3H4LK.fg)('3p-integration-enabled_t5ysh') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $b0RoQ.ThirdPartyCardConnector), {
        type: "card",
        connectors: [
            'googleDrive',
            'sharepoint'
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.ResultList), {
        role: "list"
    }, slicedArticles.map((resource, index)=>{
        const itemOrder = index + 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", {
            key: itemOrder
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $92TSs.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    })), showMoreArticlesButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eQdiM.ThemedButton), {
        "data-test-id": "show-more-button",
        appearance: "link",
        actionSubjectId: "showMoreButton",
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
            size: "small",
            spacing: "spacious",
            label: formatMessage((0, $3fKec.default).showMoreIcon)
        }),
        onClick: onShowMoreClick
    }, formatMessage((0, $3fKec.default).showMore))), isCSM && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $d9wEN.csmSearchExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $d9wEN.searchExperience)
    }));
};
var $fd5df8963d6ad999$export$2e2bcd8739ae039 = (0, $as4kh.default)()($fd5df8963d6ad999$export$b9fde6c411c336c6);

});
parcelRegister("h8ONT", function(module, exports) {
$parcel$export(module.exports, "default", () => $e84d181ab3eb53e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1721f64acd5bfb357c7a70051aa8f6af>>
 * @relayHash 0d77121bf6717adbc116ac50a5fadabf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b
const $e84d181ab3eb53e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "categoryIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "highlight"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSourceSystemEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalIds"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v8 = [
        {
            "kind": "Variable",
            "name": "categoryIds",
            "variableName": "categoryIds"
        },
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "highlight",
            "variableName": "highlight"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalIds",
            "variableName": "portalIds"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v11 = {
        "concreteType": "HelpObjectStoreArticleMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "sourceSystem"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v15 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "condition": "isSourceSystemEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "isSourceSystemEnabled",
                                                    "variableName": "isSourceSystemEnabled"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "articleItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "articlesSearchQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "HelpObjectStoreArticleSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "ari"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "containerName"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreArticleSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b62240a7619322882f8f23d6f0911bdbc6f9542e80e88756d3b426e4aad97b8b",
            "metadata": {},
            "name": "articlesSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e84d181ab3eb53e0$var$node.hash = "21465f36d9753aacb064065974751749";
var $e84d181ab3eb53e0$export$2e2bcd8739ae039 = $e84d181ab3eb53e0$var$node;

});

parcelRegister("b0RoQ", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyCardConnector", () => $ba456db877c8fe99$export$3ebb74b46e82b89e);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $ba456db877c8fe99$export$3ebb74b46e82b89e = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazy)(()=>(parcelRequire("j0uqC")), {
        moduleId: "./packages/help-center/thirdparty-connectors/src/ui/connectors/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("j0uqC", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("a7HJk").then(()=>parcelRequire('gpz4i'));

});


parcelRegister("8Arhd", function(module, exports) {
$parcel$export(module.exports, "ArticleItem", () => (parcelRequire("92TSs")).default);

var $92TSs = parcelRequire("92TSs");

});
parcelRegister("92TSs", function(module, exports) {
$parcel$export(module.exports, "default", () => $531a070bcc4a92d6$export$2e2bcd8739ae039);

var $hCrCM = parcelRequire("hCrCM");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $g1qUq = parcelRequire("g1qUq");

var $isIps = parcelRequire("isIps");

var $bG6ob = parcelRequire("bG6ob");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $cnft1 = parcelRequire("cnft1");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $2R2ud = parcelRequire("2R2ud");

var $eSL4S = parcelRequire("eSL4S");

var $gYxoS = parcelRequire("gYxoS");

var $ebpTf = parcelRequire("ebpTf");

var $gWRbJ = parcelRequire("gWRbJ");
parcelRequire("fvIyk");
var $dRxRg = parcelRequire("dRxRg");

var $3fKec = parcelRequire("3fKec");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");
parcelRequire("8U13k");
var $2gwke = parcelRequire("2gwke");
const $531a070bcc4a92d6$export$3a909d935747d7f7 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $hCrCM.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const { title: title, excerpt: excerpt, displayLink: displayLink, metadata: metadata, ari: ari, sourceSystem: sourceSystem } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const isExternal = sourceSystem === 'EXTERNAL';
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cnft1))), {
        label: formatMessage((0, $3fKec.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $hRwKd.formatText)(title, term) : '';
    const highlightedDescription = excerpt ? (0, $hRwKd.formatText)(excerpt, term) : '';
    const displayLinkWithSource = (0, $gYxoS.addSourceToUrl)(displayLink, 'search', (0, $gYxoS.is3pOrExternalSource)(sourceSystem));
    const linkProps = (0, $gWRbJ.urlRefsAndTarget)({
        displayLink: displayLinkWithSource,
        isAnExternalResource: (0, $gYxoS.is3pOrExternalSource)(sourceSystem)
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $hRwKd.sendSearchUIAnalyticEvents)({
            sourceSystem: sourceSystem,
            ari: ari,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'article'
        }, createAnalyticsEvent, portalId);
    }, [
        ari,
        createAnalyticsEvent,
        portalId,
        searchStrategy,
        sourceSystem
    ]);
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $hRwKd.useVisibilityState)();
    const isJcsSearchExperienceEnabled = (0, $6bGmX.default).checkGate('jcs_search_experience');
    const disableMetadata = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && isJcsSearchExperienceEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        key: ari,
        xcss: $531a070bcc4a92d6$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        columnGap: "space.150",
        templateAreas: [
            'icon heading header-right',
            'icon subheading-left header-right',
            '. body body'
        ],
        templateColumns: "auto 1fr auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $531a070bcc4a92d6$var$iconAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2gwke.default), {
        displayLink: displayLink,
        entityType: "ARTICLE",
        sourceSystem: sourceSystem,
        isExternal: isExternal,
        variant: "tile"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $531a070bcc4a92d6$var$headingAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
        key: ari,
        actionSubjectId: isExternal ? 'external-article-link' : 'article-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            ari: ari,
            itemOrder: itemOrder,
            searchStrategy: searchStrategy,
            sourceSystem: sourceSystem,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            color: (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2R2ud.generateThemeBranding)(themeColor).color900 : themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedTitle) : (0, $a7SRW.sanitize)(highlightedTitle)
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: [
            $531a070bcc4a92d6$var$subheadingLeftAreaStyles,
            $531a070bcc4a92d6$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, !disableMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dRxRg.default), {
        result: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: isShortcutIconVisible ? $531a070bcc4a92d6$var$headerRightAreaStylesVisible : $531a070bcc4a92d6$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: disableMetadata ? $531a070bcc4a92d6$var$jcsBodyAreaStyles : $531a070bcc4a92d6$var$bodyAreaStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("p", {
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedDescription) : (0, $a7SRW.sanitize)(highlightedDescription)
        }
    })))));
};
const $531a070bcc4a92d6$var$ConnectedArticleItem = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $isIps.isLoggedIn)(state),
        themeColor: (0, $g1qUq.getThemeColor)(state)
    };
})($531a070bcc4a92d6$export$3a909d935747d7f7);
var $531a070bcc4a92d6$export$2e2bcd8739ae039 = (0, $as4kh.default)()($531a070bcc4a92d6$var$ConnectedArticleItem);
const $531a070bcc4a92d6$var$containerStyles = (0, $2m8U6.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $531a070bcc4a92d6$var$iconAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'icon',
    width: 'size.300',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    textDecoration: 'none'
});
const $531a070bcc4a92d6$var$headingAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $531a070bcc4a92d6$var$subheadingStyles = (0, $2m8U6.xcss)({
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $531a070bcc4a92d6$var$subheadingLeftAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $531a070bcc4a92d6$var$headerRightAreaStylesInVisible = (0, $2m8U6.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $531a070bcc4a92d6$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $531a070bcc4a92d6$var$bodyAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $531a070bcc4a92d6$var$jcsBodyAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'body',
    marginTop: 'space.0',
    overflowWrap: 'break-word'
});

});
parcelRegister("hCrCM", function(module, exports) {
$parcel$export(module.exports, "default", () => $98047a5fe8f3b7fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e955bfb536b6c8db2982e28cab94e966>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98047a5fe8f3b7fb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isSourceSystemEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "articleItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "excerpt"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "condition": "isSourceSystemEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sourceSystem"
                }
            ]
        },
        {
            "concreteType": "HelpObjectStoreArticleMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "articleMetadataFragmentV2"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$98047a5fe8f3b7fb$var$node.hash = "7da1cbe6e7f48ee2d870a75fe8f1d82c";
var $98047a5fe8f3b7fb$export$2e2bcd8739ae039 = $98047a5fe8f3b7fb$var$node;

});

parcelRegister("gYxoS", function(module, exports) {
$parcel$export(module.exports, "addSourceToUrl", () => $cd4632aa87045cdc$export$cae9c63f58ebbe6f);
$parcel$export(module.exports, "is3pOrExternalSource", () => $cd4632aa87045cdc$export$d1565b01286b6c95);

var $6bGmX = parcelRequire("6bGmX");

var $PL4bf = parcelRequire("PL4bf");
const $cd4632aa87045cdc$export$cae9c63f58ebbe6f = (url, source, shouldReturnUrlWithoutSource = false)=>{
    if (shouldReturnUrlWithoutSource || !(0, $6bGmX.default).checkGate('jsm_kb_source_value_in_query_param')) return url;
    return (0, $PL4bf.addParamsToUrl)(url, {
        source: source
    });
};
const $cd4632aa87045cdc$export$d1565b01286b6c95 = (sourceSystem)=>{
    return sourceSystem === 'EXTERNAL' || sourceSystem === 'SHAREPOINT' || sourceSystem === 'GOOGLE_DRIVE';
};

});

parcelRegister("fvIyk", function(module, exports) {
$parcel$export(module.exports, "ArticleMetadata", () => (parcelRequire("dRxRg")).default);

var $dRxRg = parcelRequire("dRxRg");

});
parcelRegister("dRxRg", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c754e66dc0e97a9$export$2e2bcd8739ae039);

var $bR0AB = parcelRequire("bR0AB");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $isIps = parcelRequire("isIps");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("cNbxb");
var $jXaYG = parcelRequire("jXaYG");

var $7TPEx = parcelRequire("7TPEx");

var $7dJXx = parcelRequire("7dJXx");
const $6c754e66dc0e97a9$export$9f18a4080cf334b5 = ({ isLoggedIn: isLoggedIn, result: result })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $bR0AB.default), result);
    const { ari: ari, displayLink: displayLink, sourceSystem: sourceSystem, containerName: containerName } = data;
    const isExternal = sourceSystem === 'EXTERNAL';
    const { data: { source: source } } = (0, $jXaYG.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const confluencePageText = containerName ? formatMessage((0, $7dJXx.default).confluencePage, {
        value: containerName
    }) : '';
    const showSeparator = source && containerName;
    const externalResourceParts = [
        source || '',
        showSeparator ? "\u2022" : '',
        containerName || ''
    ].filter(Boolean);
    const externalResourceText = externalResourceParts.join(' ');
    const metaData = !isExternal ? confluencePageText : externalResourceText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        key: ari
    }, metaData);
};
const $6c754e66dc0e97a9$var$ConnectedArticleMetadata = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $isIps.isLoggedIn)(state)
    };
})($6c754e66dc0e97a9$export$9f18a4080cf334b5);
var $6c754e66dc0e97a9$export$2e2bcd8739ae039 = $6c754e66dc0e97a9$var$ConnectedArticleMetadata;

});
parcelRegister("bR0AB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c1e06e2726d9186$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ed87ad72d807d002234b458a7dcc7707>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2c1e06e2726d9186$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "articleMetadataFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "ari"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "kind": "ScalarField",
            "name": "containerName"
        },
        {
            "kind": "ScalarField",
            "name": "sourceSystem"
        }
    ],
    "type": "HelpObjectStoreArticleSearchResult"
};
$2c1e06e2726d9186$var$node.hash = "4c3cfc8aeff9894de53a0b5480f56516";
var $2c1e06e2726d9186$export$2e2bcd8739ae039 = $2c1e06e2726d9186$var$node;

});

parcelRegister("7dJXx", function(module, exports) {
$parcel$export(module.exports, "default", () => $db7f3669c9271a32$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $db7f3669c9271a32$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    confluencePage: {
        defaultMessage: 'Confluence page in {value}',
        description: 'Confluence page metadata text',
        id: 'cv.search.articles.metadata'
    }
});

});



parcelRegister("3fKec", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdc479d49aa67c99$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $bdc479d49aa67c99$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    showMore: {
        defaultMessage: 'Show more',
        description: 'Text on show more results button',
        id: 'cv.search.articles.show-more'
    },
    showMoreIcon: {
        defaultMessage: 'Show more icon',
        description: 'Text for label on show more results icon',
        id: 'cv.search.articles.show-more-icon'
    },
    shortcutIcon: {
        defaultMessage: 'Shortcut icon',
        description: 'Text for label on shortcut icon',
        id: 'cv.search.articles.shortcut-icon'
    },
    articles: {
        defaultMessage: 'Self-help resources',
        description: 'Text for section resource type in search results',
        id: 'cv.search.articles.articles'
    }
});

});

parcelRegister("8U13k", function(module, exports) {
$parcel$export(module.exports, "ResourceIcon", () => (parcelRequire("2gwke")).default);

var $2gwke = parcelRequire("2gwke");

});
parcelRegister("2gwke", function(module, exports) {
$parcel$export(module.exports, "default", () => $da31e3f32f128ace$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $g1qUq = parcelRequire("g1qUq");

var $isIps = parcelRequire("isIps");

var $j4lpV = parcelRequire("j4lpV");
parcelRequire("cNbxb");
var $jXaYG = parcelRequire("jXaYG");

var $6bGmX = parcelRequire("6bGmX");

var $fmR1G = parcelRequire("fmR1G");

var $fmxZJ = parcelRequire("fmxZJ");

var $1sKlv = parcelRequire("1sKlv");

var $17RcU = parcelRequire("17RcU");

var $84EvU = parcelRequire("84EvU");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $2R2ud = parcelRequire("2R2ud");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $6yAF4 = parcelRequire("6yAF4");
const $da31e3f32f128ace$export$99eb8fbf40c7d2bc = ({ entityType: entityType, displayLink: displayLink, isLoggedIn: isLoggedIn, isExternal: isExternal, themeColor: themeColor, iconUrl: iconUrl, sourceSystem: sourceSystem, variant: variant = 'default' })=>{
    const { data: { iconUrl: externalResourceIconUrl }, isLoading: isIconLoading } = (0, $jXaYG.useExternalLink)({
        isLoggedIn: isLoggedIn,
        link: displayLink
    });
    const isValidResourceIconUrl = !!iconUrl;
    const isValidExternalResourceIconUrl = !!externalResourceIconUrl && externalResourceIconUrl !== '';
    const getDefaultIcon = (0, $4fqPo.useMemo)(()=>{
        switch(entityType){
            case 'ARTICLE':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                    label: "",
                    testId: "article-icon",
                    spacing: "spacious"
                });
            case 'REQUEST_FORM':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1sKlv))), {
                    label: "",
                    testId: "request-form-icon",
                    spacing: "spacious"
                });
            case 'PORTAL':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84EvU))), {
                    label: "",
                    testId: "portal-icon",
                    spacing: "spacious"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fmxZJ))), {
                    label: "",
                    testId: "question-icon",
                    spacing: "spacious"
                });
        }
    }, [
        entityType
    ]);
    const getThirdPartyIcon = (0, $4fqPo.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6yAF4.IntegrationProviderMeta).sharepoint.icon, {
            label: "sharepoint"
        });
        if (sourceSystem === 'GOOGLE_DRIVE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6yAF4.IntegrationProviderMeta).googleDrive.icon, {
            label: "googledrive"
        });
        return null;
    }, [
        sourceSystem
    ]);
    const getThirdPartyIconComponent = (0, $4fqPo.useMemo)(()=>{
        if (sourceSystem === 'SHAREPOINT') return (0, $6yAF4.IntegrationProviderMeta).sharepoint.icon;
        if (sourceSystem === 'GOOGLE_DRIVE') return (0, $6yAF4.IntegrationProviderMeta).googleDrive.icon;
        return null;
    }, [
        sourceSystem
    ]);
    const shouldUseArticleIconTile = (0, $6bGmX.default).checkGate('jsm_kb_team_26_changes') && variant === 'tile' && entityType === 'ARTICLE' && !isExternal && !isIconLoading && !isValidResourceIconUrl;
    const getExternalResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j4lpV.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidExternalResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "img",
            xcss: $da31e3f32f128ace$var$imgStyles,
            testId: "external-resource-icon",
            src: externalResourceIconUrl,
            alt: ""
        });
        return getDefaultIcon;
    };
    const getResourceIcon = ()=>{
        if (isIconLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j4lpV.SkeletonItem), {
            height: '24px',
            width: '24px'
        });
        if (isValidResourceIconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            as: "img",
            xcss: $da31e3f32f128ace$var$imgStyles,
            testId: "resource-icon",
            src: iconUrl,
            alt: ""
        });
        return getThirdPartyIcon ?? getDefaultIcon;
    };
    if (shouldUseArticleIconTile) {
        const ThirdPartyIconInTile = ({ label: label })=>{
            if (getThirdPartyIcon) return getThirdPartyIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                label: label
            });
        };
        const IconComponent = getThirdPartyIconComponent ? ThirdPartyIconInTile : (0, (/*@__PURE__*/$parcel$interopDefault($17RcU)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $da31e3f32f128ace$var$iconTileStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fmR1G.IconTile), {
            appearance: "blue",
            icon: IconComponent,
            label: "Article icon",
            size: "medium",
            testId: "article-icon-tile"
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $da31e3f32f128ace$var$imgStyles,
        style: {
            color: (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $2R2ud.generateThemeBranding)(themeColor).color900 : themeColor
        }
    }, isExternal ? getExternalResourceIcon() : getResourceIcon());
};
const $da31e3f32f128ace$var$ConnectedResourceIcon = (0, $bmgw6.default)((state)=>{
    return {
        isLoggedIn: (0, $isIps.isLoggedIn)(state),
        themeColor: (0, $g1qUq.getThemeColor)(state)
    };
})($da31e3f32f128ace$export$99eb8fbf40c7d2bc);
var $da31e3f32f128ace$export$2e2bcd8739ae039 = $da31e3f32f128ace$var$ConnectedResourceIcon;
const $da31e3f32f128ace$var$imgStyles = (0, $2m8U6.xcss)({
    width: 'size.200',
    height: 'size.200',
    objectFit: 'contain'
});
const $da31e3f32f128ace$var$iconTileStyles = (0, $2m8U6.xcss)({
    width: 'size.300',
    height: 'size.300',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});

});
parcelRegister("fmR1G", function(module, exports) {
/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */ 
var $g1ak7 = parcelRequire("g1ak7");

const $b3020afd4f7ab543$var$_inlined0 = (()=>{
    const module1 = {
        exports: {}
    };
    const exports = module1.exports;
    (function() {
        /**
     * Shim for the removed @atlaskit/icon default export (legacy Icon base component).
     *
     * This provides a lightweight replacement for the legacy Icon component that
     * was removed in DSP-24550. Instead of wrapping the glyph in a span with
     * complex styling, it simply renders the glyph component directly, passing
     * through relevant props.
     *
     * This is NOT a public API — it exists solely to unblock the removal of
     * deprecated icon APIs from @atlaskit/icon.
     */ const React = (parcelRequire("4fqPo"));
        function Icon(props) {
            const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor, testId: testId, label: label } = props;
            if (Glyph) return React.createElement(Glyph, {
                role: label ? 'img' : 'presentation',
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                fill: primaryColor || 'currentColor'
            });
            if (dangerouslySetGlyph) return React.createElement('span', {
                dangerouslySetInnerHTML: {
                    __html: dangerouslySetGlyph
                },
                role: label ? 'img' : undefined,
                'aria-label': label || undefined,
                'aria-hidden': label ? undefined : 'true',
                'data-testid': testId,
                style: {
                    display: 'inline-block',
                    lineHeight: 1,
                    color: primaryColor || 'currentColor'
                }
            });
            return null;
        }
        Icon.displayName = 'Icon';
        module1.exports = Icon;
    })();
    return module1.exports;
})();
module.exports = Object.assign({}, $g1ak7, {
    default: $b3020afd4f7ab543$var$_inlined0
});
if ($g1ak7.__esModule) Object.defineProperty(module.exports, '__esModule', {
    value: true
});

});
parcelRegister("g1ak7", function(module, exports) {
$parcel$export(module.exports, "IconNew", () => (parcelRequire("1yi8B")).default);
$parcel$export(module.exports, "size", () => (parcelRequire("c62Jb")).sizeMap);
$parcel$export(module.exports, "sizes", () => (parcelRequire("c62Jb")).sizes);
$parcel$export(module.exports, "Skeleton", () => (parcelRequire("fFdQ7")).default);
$parcel$export(module.exports, "IconTile", () => (parcelRequire("iq27P")).default);

var $1yi8B = parcelRequire("1yi8B");

var $c62Jb = parcelRequire("c62Jb");

var $fFdQ7 = parcelRequire("fFdQ7");

var $iq27P = parcelRequire("iq27P");

});
parcelRegister("c62Jb", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $580e10761cdd5caa$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "sizeMap", () => $580e10761cdd5caa$export$7bd66fc94c81bf84);
const $580e10761cdd5caa$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $580e10761cdd5caa$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $580e10761cdd5caa$export$62ad7b0c781000e9 = {
    small: {
        width: $580e10761cdd5caa$export$c647cb0ee6e282fe.small,
        height: $580e10761cdd5caa$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $580e10761cdd5caa$export$c647cb0ee6e282fe.medium,
        height: $580e10761cdd5caa$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $580e10761cdd5caa$export$c647cb0ee6e282fe.large,
        height: $580e10761cdd5caa$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $580e10761cdd5caa$export$c647cb0ee6e282fe.xlarge,
        height: $580e10761cdd5caa$export$c647cb0ee6e282fe.xlarge
    }
};

});

parcelRegister("fFdQ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $c63230abb5c2f240$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $c63230abb5c2f240$var$skeletonStyles = null;
const $c63230abb5c2f240$var$subtleOpacityStyles = null;
const $c63230abb5c2f240$var$strongOpacityStyles = null;
const $c63230abb5c2f240$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
/**
 * __Skeleton__
 */ const $c63230abb5c2f240$var$Skeleton = /*#__PURE__*/ (0, $4fqPo.memo)(function Skeleton({ testId: testId, size: size = 'medium', color: color = 'currentColor', weight: weight = 'normal' }) {
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId,
        style: {
            backgroundColor: color
        },
        className: (0, $ltgDR.default)([
            "_2rko1qll _1e0c1o8l",
            weight === 'strong' ? "_tzy4clii" : "_tzy4nh7s",
            $c63230abb5c2f240$var$sizeStyles[size]
        ])
    });
});
var $c63230abb5c2f240$export$2e2bcd8739ae039 = $c63230abb5c2f240$var$Skeleton;

});

parcelRegister("iq27P", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b4d8141f64a400f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $3r9t6 = parcelRequire("3r9t6");

var $7Ioqj = parcelRequire("7Ioqj");
function $8b4d8141f64a400f$export$2e2bcd8739ae039(props) {
    if (props.shape === 'circle' && ((0, $3H4LK.fg)('platform_dst_icon_tile_circle_replacement') || (0, $3H4LK.fg)('platform_dst_icon_tile_circle_replacement_stage2'))) return props.UNSAFE_circleReplacementComponent;
    else if (props.shape === 'circle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7Ioqj.default), {
        appearance: props.appearance,
        icon: props.icon,
        label: props.label,
        shape: 'circle',
        size: props.size,
        testId: props.testId,
        UNSAFE_circleReplacementComponent: props.UNSAFE_circleReplacementComponent
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3r9t6.default), {
        appearance: props.appearance,
        icon: props.icon,
        label: props.label,
        shape: props.shape,
        size: props.size,
        testId: props.testId
    });
}

});
parcelRegister("3r9t6", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8043818a7af19b5$export$2e2bcd8739ae039);
/* icon-tile.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $hf6F2 = parcelRequire("hf6F2");
// Icon color mapping for Tile-based icons
const $a8043818a7af19b5$var$iconColorMap = {
    blue: "_syaz6txe",
    blueBold: "_syaz1q3r",
    gray: "_syazdgkc",
    grayBold: "_syaz5w2r",
    green: "_syaz17hp",
    greenBold: "_syaz1q3r",
    lime: "_syaz8645",
    limeBold: "_syaz1q3r",
    magenta: "_syazv8hk",
    magentaBold: "_syaz1q3r",
    orange: "_syaz1j6y",
    orangeBold: "_syaz1q3r",
    purple: "_syazuq3u",
    purpleBold: "_syaz1q3r",
    red: "_syaznbxb",
    redBold: "_syaz1q3r",
    teal: "_syaz8uof",
    tealBold: "_syaz1q3r",
    yellow: "_syaz1oqg",
    yellowBold: "_syaz1q3r"
};
const $a8043818a7af19b5$var$iconWrapperStyles = {
    root: "_vwz4idpf"
};
// Background color mapping for Tile component
const $a8043818a7af19b5$var$backgroundColorMap = {
    blue: undefined,
    blueBold: 'color.background.accent.blue.subtle',
    gray: undefined,
    grayBold: 'color.background.neutral.bold',
    green: undefined,
    greenBold: 'color.background.accent.green.subtle',
    lime: undefined,
    limeBold: 'color.background.accent.lime.subtle',
    magenta: undefined,
    magentaBold: 'color.background.accent.magenta.subtle',
    orange: undefined,
    orangeBold: 'color.background.accent.orange.subtle',
    purple: undefined,
    purpleBold: 'color.background.accent.purple.subtle',
    red: undefined,
    redBold: 'color.background.accent.red.subtle',
    teal: undefined,
    tealBold: 'color.background.accent.teal.subtle',
    yellow: undefined,
    yellowBold: 'color.background.accent.yellow.subtle'
};
function $a8043818a7af19b5$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'medium', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ $4fqPo.createElement((0, $hf6F2.default), {
        size: size,
        backgroundColor: $a8043818a7af19b5$var$backgroundColorMap[appearance],
        label: label,
        testId: testId
    }, /*#__PURE__*/ $4fqPo.createElement("span", {
        className: (0, $ltgDR.default)([
            $a8043818a7af19b5$var$iconColorMap[appearance],
            $a8043818a7af19b5$var$iconWrapperStyles.root
        ])
    }, /*#__PURE__*/ $4fqPo.createElement(ExpandedIcon, {
        color: "currentColor",
        label: "",
        shouldScale: true
    })));
}

});
parcelRegister("hf6F2", function(module, exports) {
$parcel$export(module.exports, "default", () => $6154803a8cf35f4a$export$2e2bcd8739ae039);
/* tile.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $6154803a8cf35f4a$var$styles = {
    root: "_2rkol0p1 _1reo15vq _18m915vq _kqswh2mm _1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1o9zidpf _16jlidpf _1ul9idpf _1tkeidpf _s7n4nkob",
    border: "_189ee4h9 _1dqonqa1 _1h6d1l7x",
    inset: "_1iia1wug _bna71wug _1xjx1wug _17521wug",
    nonInset: "_1qwg1osq _mezj1osq _e2oo1osq _w8l51osq _1iia1osq _bna71osq _1xjx1osq _17521osq"
};
const $6154803a8cf35f4a$var$sizeMap = {
    xxsmall: "_1bsb7vkz _4t3i7vkz _1wyb19bv",
    xsmall: "_1bsbgktf _4t3igktf _1wyb1crf",
    small: "_1bsb1tcg _4t3i1tcg _1wybdlk8",
    medium: "_1bsbzwfg _4t3izwfg _1wyb7vkz",
    large: "_1bsb1ylp _4t3i1ylp _1wybgktf",
    xlarge: "_1bsbckbl _4t3ickbl _1wyb1tcg"
};
const $6154803a8cf35f4a$var$insetSizeMap = {
    xxsmall: "_1qwg19bv _mezj19bv _e2oo19bv _w8l519bv _5ile19el _1hdc19el _1pc719el _pkax19el",
    xsmall: "_1qwg1crf _mezj1crf _e2oo1crf _w8l51crf _5ilemccc _1hdcmccc _1pc7mccc _pkaxmccc",
    small: "_1qwgdlk8 _mezjdlk8 _e2oodlk8 _w8l5dlk8 _5ilewk7l _1hdcwk7l _1pc7wk7l _pkaxwk7l",
    medium: "_1qwg7vkz _mezj7vkz _e2oo7vkz _w8l57vkz _5ile1gpt _1hdc1gpt _1pc71gpt _pkax1gpt",
    large: "_1qwggktf _mezjgktf _e2oogktf _w8l5gktf _5ile1txs _1hdc1txs _1pc71txs _pkax1txs",
    xlarge: "_1qwg1tcg _mezj1tcg _e2oo1tcg _w8l51tcg _5ilea982 _1hdca982 _1pc7a982 _pkaxa982"
};
const $6154803a8cf35f4a$var$backgroundColorMap = {
    white: "_bfhku67f",
    black: "_bfhkr3uz",
    transparent: "_bfhk1j28",
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.information': "_bfhk19ip",
    'color.background.information.bold': "_bfhkx4w0"
};
function $6154803a8cf35f4a$export$2e2bcd8739ae039(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $ltgDR.default)([
            $6154803a8cf35f4a$var$styles.root,
            $6154803a8cf35f4a$var$sizeMap[size],
            isInset ? $6154803a8cf35f4a$var$styles.inset : $6154803a8cf35f4a$var$styles.nonInset,
            isInset && $6154803a8cf35f4a$var$insetSizeMap[size],
            $6154803a8cf35f4a$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $6154803a8cf35f4a$var$styles.border
        ])
    }, children);
}

});


parcelRegister("7Ioqj", function(module, exports) {
$parcel$export(module.exports, "default", () => $af860d7bdb6432cc$export$2e2bcd8739ae039);
/* icon-tile-old.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $af860d7bdb6432cc$var$sizeCrossCompatibleMap = {
    xsmall: '20',
    small: '24',
    medium: '32',
    large: '40',
    xlarge: '48'
};
const $af860d7bdb6432cc$var$sizeMap = {
    '20': "_1bsbgktf _4t3igktf",
    '24': "_1bsb1tcg _4t3i1tcg",
    '32': "_1bsbzwfg _4t3izwfg",
    '40': "_1bsb1ylp _4t3i1ylp",
    '48': "_1bsbckbl _4t3ickbl"
};
const $af860d7bdb6432cc$var$appearanceMap = {
    grayBold: "_bfhk1i45 _syaz5w2r",
    limeBold: "_bfhktde4 _syaz5w2r",
    greenBold: "_bfhk1e5c _syaz5w2r",
    blueBold: "_bfhk16e3 _syaz5w2r",
    redBold: "_bfhkuibq _syaz5w2r",
    purpleBold: "_bfhkya33 _syaz5w2r",
    magentaBold: "_bfhkc3uk _syaz5w2r",
    tealBold: "_bfhk2c8p _syaz5w2r",
    orangeBold: "_bfhk1qg1 _syaz5w2r",
    yellowBold: "_bfhk1vop _syaz5w2r",
    gray: "_bfhk7qp0 _syaz1diz",
    lime: "_bfhkz2ec _syaz8645",
    orange: "_bfhk165s _syaz1j6y",
    magenta: "_bfhkv9ra _syazv8hk",
    green: "_bfhk1wnw _syaz17hp",
    blue: "_bfhk1dy8 _syaz6txe",
    red: "_bfhk1rtt _syaznbxb",
    purple: "_bfhk1nm4 _syazuq3u",
    teal: "_bfhk1a17 _syaz8uof",
    yellow: "_bfhk1773 _syaz1oqg"
};
const $af860d7bdb6432cc$var$shapeMap = {
    square: "_2rko12b0",
    circle: "_2rko1rr0"
};
const $af860d7bdb6432cc$var$iconTileStyles = null;
function $af860d7bdb6432cc$export$2e2bcd8739ae039(props) {
    const { icon: Icon, label: label, appearance: appearance, size: size = 'medium', shape: shape = 'square', testId: testId } = props;
    const ExpandedIcon = Icon;
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_1e0c116y _vchhusvi _4cvr1h6o _1bah1h6o _1wybidpf",
            $af860d7bdb6432cc$var$appearanceMap[appearance],
            $af860d7bdb6432cc$var$sizeMap[$af860d7bdb6432cc$var$sizeCrossCompatibleMap[size]],
            $af860d7bdb6432cc$var$shapeMap[shape]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement(ExpandedIcon, {
        color: "currentColor",
        label: label,
        spacing: "spacious",
        shouldScale: true
    }));
}

});




parcelRegister("6yAF4", function(module, exports) {
$parcel$export(module.exports, "getThirdPartyConnectionStatusEndpoint", () => $a8cd63f18d191ca7$export$b6b331ef111f4609);
$parcel$export(module.exports, "IntegrationProviderMeta", () => $a8cd63f18d191ca7$export$3b0a1c80b07fd43a);

var $cpnsI = parcelRequire("cpnsI");

var $6ODyO = parcelRequire("6ODyO");
const $a8cd63f18d191ca7$export$b6b331ef111f4609 = ()=>`/gateway/api/third-party-configuration/connected-data-sources`;
const $a8cd63f18d191ca7$export$3b0a1c80b07fd43a = {
    sharepoint: {
        name: 'SharePoint',
        icon: (0, $6ODyO.default),
        integrationId: 'ari:cloud:platform::integration/microsoft',
        type: 'sharepoint-connector'
    },
    googleDrive: {
        name: 'Google Drive',
        icon: (0, $cpnsI.default),
        integrationId: 'ari:cloud:platform::integration/google',
        type: 'google-drive-connector'
    }
};

});
parcelRegister("cpnsI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e227e7063133166f$export$2e2bcd8739ae039);
/* google-drive-icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $e227e7063133166f$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $e227e7063133166f$var$GoogleDriveIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $4fqPo.createElement("svg", {
        width: "20",
        height: "18",
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $ltgDR.default)([
            size && $e227e7063133166f$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
        fill: "#3777E3"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
        fill: "#FFCF63"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
        fill: "#11A861"
    }));
/**
 * __GoogleDriveIcon__
 */ const $e227e7063133166f$var$GoogleDriveIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement($e227e7063133166f$var$GoogleDriveIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $e227e7063133166f$export$2e2bcd8739ae039 = $e227e7063133166f$var$GoogleDriveIcon;

});

parcelRegister("6ODyO", function(module, exports) {
$parcel$export(module.exports, "default", () => $91628a69eca9d734$export$2e2bcd8739ae039);
/* sharepoint-icon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $91628a69eca9d734$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $91628a69eca9d734$var$SharePointIconGlyph = ({ ariaLabel: ariaLabel, testId: testId, size: size })=>/*#__PURE__*/ $4fqPo.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: (0, $ltgDR.default)([
            size && $91628a69eca9d734$var$sizeStyles[size]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        clipPath: "url(#clip0_271_181641)"
    }, /*#__PURE__*/ $4fqPo.createElement("g", {
        clipPath: "url(#clip1_271_181641)"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        opacity: "0.1",
        d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
        fill: "black"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        opacity: "0.2",
        d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        opacity: "0.2",
        d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        opacity: "0.2",
        d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
        fill: "black"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
        fill: "white"
    }))), /*#__PURE__*/ $4fqPo.createElement("defs", null, /*#__PURE__*/ $4fqPo.createElement("clipPath", {
        id: "clip0_271_181641"
    }, /*#__PURE__*/ $4fqPo.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    })), /*#__PURE__*/ $4fqPo.createElement("clipPath", {
        id: "clip1_271_181641"
    }, /*#__PURE__*/ $4fqPo.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
/**
 * __SharePointIcon__
 */ const $91628a69eca9d734$var$SharePointIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement($91628a69eca9d734$var$SharePointIconGlyph, {
        ariaLabel: label,
        testId: testId
    });
var $91628a69eca9d734$export$2e2bcd8739ae039 = $91628a69eca9d734$var$SharePointIcon;

});








parcelRegister("esdqh", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => (parcelRequire("axkkq")).ArticleResultsLoader);
$parcel$export(module.exports, "SidePanelResultsLoader", () => (parcelRequire("axkkq")).SidePanelResultsLoader);
$parcel$export(module.exports, "NewSearchResultsLoader", () => (parcelRequire("axkkq")).SearchResultsLoader);

var $axkkq = parcelRequire("axkkq");

});
parcelRegister("axkkq", function(module, exports) {
$parcel$export(module.exports, "ArticleResultsLoader", () => $867be6b891037450$export$777dd415ac1ad4be);
$parcel$export(module.exports, "SidePanelResultsLoader", () => $867be6b891037450$export$9575789db02c1cec);
$parcel$export(module.exports, "SearchResultsLoader", () => $867be6b891037450$export$628e0e0af087a588);

var $4fqPo = parcelRequire("4fqPo");

var $fVQGu = parcelRequire("fVQGu");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $dEWOM = parcelRequire("dEWOM");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");
parcelRequire("fmz0C");
var $bywGP = parcelRequire("bywGP");
const $867be6b891037450$export$777dd415ac1ad4be = ()=>{
    const articleItemLoader = (0, $4fqPo.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $867be6b891037450$var$headingAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const resourceIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $867be6b891037450$var$iconAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $867be6b891037450$var$loadingIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 24,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const metadataContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: [
                    $867be6b891037450$var$subheadingLeftAreaStyles,
                    $867be6b891037450$var$subheadingStyles
                ],
                testId: "article-metadata-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $867be6b891037450$var$metadataLoadingStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 10,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        const shortcutIconContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: [
                    $867be6b891037450$var$headerRightAreaStylesVisible
                ],
                testId: "shortcut-icon-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            }));
        };
        const descriptionContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $867be6b891037450$var$bodyAreaStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            })));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            role: "listitem",
            xcss: $867be6b891037450$var$containerStyles,
            testId: "article-item-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body'
            ],
            templateColumns: "auto 1fr auto"
        }, resourceIconContainer(), linkContainer(), metadataContainer(), shortcutIconContainer(), descriptionContainer())));
    }, []);
    const articlesListLoader = (0, $4fqPo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            role: "list",
            xcss: $867be6b891037450$var$containerStyles,
            testId: "articles-list-loader"
        }, articleItemLoader, articleItemLoader, articleItemLoader, articleItemLoader);
    }, [
        articleItemLoader
    ]);
    const sectionHeadingLoader = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, sectionHeadingLoader(), articlesListLoader, articlesListLoader);
};
const $867be6b891037450$export$9575789db02c1cec = ()=>{
    const resourceIconContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $867be6b891037450$var$iconAreaStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $867be6b891037450$var$sidePanelIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 24,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    const descriptionContainer = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $867be6b891037450$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $867be6b891037450$var$sidePanelDescriptionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            height: 20,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        }))));
    };
    const sidePaneItemLoader = (0, $4fqPo.useMemo)(()=>{
        const linkContainer = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $867be6b891037450$var$sidePaneLinkContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
                xcss: $867be6b891037450$var$sidePaneLinkStyles,
                space: "space.100"
            }, resourceIconContainer(), descriptionContainer()));
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $867be6b891037450$var$sidePanelItemStyles
        }, linkContainer());
    }, []);
    const sidePanelLoader = (0, $4fqPo.useMemo)(()=>{
        const resultTitle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
                height: 20,
                backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $867be6b891037450$var$sidePanelStyles
        }, resultTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.ResultList), {
            role: "list"
        }, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader, sidePaneItemLoader));
    }, [
        sidePaneItemLoader
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "side-panel-results-loader",
        xcss: $867be6b891037450$var$sidePanelContainerStyles
    }, sidePanelLoader);
};
const $867be6b891037450$export$628e0e0af087a588 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        gap: "space.400",
        templateColumns: "1fr",
        xcss: $867be6b891037450$var$responsiveStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($867be6b891037450$export$777dd415ac1ad4be, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($867be6b891037450$export$9575789db02c1cec, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($867be6b891037450$export$9575789db02c1cec, null)));
};
const $867be6b891037450$var$containerStyles = (0, $2m8U6.xcss)({
    padding: 'space.100',
    marginLeft: 'space.negative.100',
    marginRight: 'space.negative.100',
    borderRadius: 'radius.small'
});
const $867be6b891037450$var$iconAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $867be6b891037450$var$headingAreaStyles = (0, $2m8U6.xcss)({
    width: '200px',
    gridArea: 'heading',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-large, normal)"
});
const $867be6b891037450$var$subheadingStyles = (0, $2m8U6.xcss)({
    width: '350px',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '12px',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'clip',
    overflowClipMargin: '5px'
});
const $867be6b891037450$var$subheadingLeftAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px'
});
const $867be6b891037450$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    gridArea: 'header-right',
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $867be6b891037450$var$responsiveStyles = (0, $2m8U6.xcss)({
    [(0, $3jKXW.media).above.xxs]: {
        gridTemplateColumns: '1fr',
        width: '100%'
    },
    [(0, $3jKXW.media).above.md]: {
        gridTemplateColumns: '638px 287px'
    }
});
const $867be6b891037450$var$bodyAreaStyles = (0, $2m8U6.xcss)({
    gridArea: 'body',
    marginTop: 'space.100',
    overflowWrap: 'break-word'
});
const $867be6b891037450$var$loadingIconStyles = (0, $2m8U6.xcss)({
    width: '100%'
});
const $867be6b891037450$var$metadataLoadingStyles = (0, $2m8U6.xcss)({
    width: '100%'
});
const $867be6b891037450$var$sidePanelIconStyles = (0, $2m8U6.xcss)({
    width: 'size.200'
});
const $867be6b891037450$var$sidePanelDescriptionStyles = (0, $2m8U6.xcss)({
    width: '100%'
});
const $867be6b891037450$var$sidePaneLinkContainerStyles = (0, $2m8U6.xcss)({
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $867be6b891037450$var$sidePaneLinkStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $867be6b891037450$var$sidePanelItemStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $867be6b891037450$var$sidePanelContainerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    minWidth: '320px',
    width: '100%',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100'
});
const $867be6b891037450$var$sidePanelStyles = (0, $2m8U6.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});

});


parcelRegister("dlViU", function(module, exports) {
$parcel$export(module.exports, "Portals", () => (parcelRequire("h3DZp")).default);

var $h3DZp = parcelRequire("h3DZp");

});
parcelRegister("h3DZp", function(module, exports) {
$parcel$export(module.exports, "default", () => $88c81a673bb5a9c1$export$2e2bcd8739ae039);

var $4at4M = parcelRequire("4at4M");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $2m8U6 = parcelRequire("2m8U6");

var $3krHC = parcelRequire("3krHC");
parcelRequire("fmz0C");
var $74muP = parcelRequire("74muP");
var $bywGP = parcelRequire("bywGP");
var $hRwKd = parcelRequire("hRwKd");

var $d9wEN = parcelRequire("d9wEN");
parcelRequire("eLmbu");
var $fh8UK = parcelRequire("fh8UK");

var $kFqvk = parcelRequire("kFqvk");
const $88c81a673bb5a9c1$export$7083bd6220bb1bc7 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const cloudId = (0, $6mmHn.getCloudId)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $4at4M.default), {
        cloudId: cloudId,
        queryTerm: term,
        helpCenterAri: (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() ? (0, $6mmHn.getHelpCenterAri)() : undefined,
        limit: (0, $74muP.PORTALS_RESULT_LIMIT)
    });
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const portals = ((_data$helpObjectStore = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStorePortalSearchResults' ? data.helpObjectStore_searchPortals.results : [];
    const showSection = portals.length > 0;
    (0, $4fqPo.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStorePortalSearchResults') {
            const externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchPortals.results.forEach((portal)=>{
                if (portal.metadata.searchStrategy === 'SEARCH_PLATFORM') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $hRwKd.sendSearchOperationalAnalyticEvents)({
                action: 'portalSearchSucceeded',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $hRwKd.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'portal',
                resourceCount: data.helpObjectStore_searchPortals.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchPortals) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchPortals;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $hRwKd.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                is4XXFailure: is4XXFailure,
                statusCode: statusCode,
                action: 'portalSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        updateResultsCount(portals.length, 1);
    }, [
        term,
        portals.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $88c81a673bb5a9c1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $88c81a673bb5a9c1$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $kFqvk.default).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.ResultList), {
        role: "list"
    }, portals.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fh8UK.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $d9wEN.searchExperience)
    }));
};
const $88c81a673bb5a9c1$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $3jKXW.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $88c81a673bb5a9c1$var$headingStyles = (0, $2m8U6.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $88c81a673bb5a9c1$export$2e2bcd8739ae039 = (0, $as4kh.default)()($88c81a673bb5a9c1$export$7083bd6220bb1bc7);

});
parcelRegister("4at4M", function(module, exports) {
$parcel$export(module.exports, "default", () => $9851b209a0a42e0b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0b5f48857c921e08b0faf15fc282bb1>>
 * @relayHash b4c5cb2add64b92e5fa0a81f307c32d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1
const $9851b209a0a42e0b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "concreteType": "HelpObjectStorePortalMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "message"
    }, v9 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v10 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "portalsSearchQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchPortals",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStorePortalSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStorePortalSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d9f8850f70c76ffcbcce7f2698b51dd8a8d50e7e457be551f94df33714abf2a1",
            "metadata": {},
            "name": "portalsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9851b209a0a42e0b$var$node.hash = "5fbada5df4e3a5676426867e2805de0f";
var $9851b209a0a42e0b$export$2e2bcd8739ae039 = $9851b209a0a42e0b$var$node;

});

parcelRegister("eLmbu", function(module, exports) {
$parcel$export(module.exports, "PortalItem", () => (parcelRequire("fh8UK")).default);

var $fh8UK = parcelRequire("fh8UK");

});
parcelRegister("fh8UK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccd7974ce65c2d37$export$2e2bcd8739ae039);

var $2bAEb = parcelRequire("2bAEb");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $g1qUq = parcelRequire("g1qUq");

var $bG6ob = parcelRequire("bG6ob");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $gWRbJ = parcelRequire("gWRbJ");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");
parcelRequire("8U13k");
var $2gwke = parcelRequire("2gwke");
const $ccd7974ce65c2d37$export$dd92e87a60cfa662 = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const data = (0, $gIeP2.useFragment)((0, $2bAEb.default), result);
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { searchStrategy: searchStrategy } = metadata;
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $hRwKd.useVisibilityState)();
    const highlightedTitle = title ? (0, $hRwKd.formatText)(title, term) : '';
    const linkProps = (0, $gWRbJ.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: false
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $hRwKd.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'portal'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $ccd7974ce65c2d37$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: [
            $ccd7974ce65c2d37$var$headingStyles,
            $ccd7974ce65c2d37$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2gwke.default), {
        entityType: "PORTAL",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
        key: id,
        actionSubjectId: 'portal-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedTitle) : (0, $a7SRW.sanitize)(highlightedTitle)
        }
    })))));
};
const $ccd7974ce65c2d37$var$ConnectedPortalItem = (0, $bmgw6.default)((state)=>{
    return {
        themeColor: (0, $g1qUq.getThemeColor)(state)
    };
})($ccd7974ce65c2d37$export$dd92e87a60cfa662);
var $ccd7974ce65c2d37$export$2e2bcd8739ae039 = (0, $as4kh.default)()($ccd7974ce65c2d37$var$ConnectedPortalItem);
const $ccd7974ce65c2d37$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $ccd7974ce65c2d37$var$headingStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $ccd7974ce65c2d37$var$headingAlignmentStyles = (0, $2m8U6.xcss)({
    alignItems: 'center'
});

});
parcelRegister("2bAEb", function(module, exports) {
$parcel$export(module.exports, "default", () => $83f22ad0706d6dbb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<401e38e258ab2a07d01ca48a65a435ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83f22ad0706d6dbb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStorePortalMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStorePortalSearchResult"
};
$83f22ad0706d6dbb$var$node.hash = "e844983974d9732ca3ef706885375f3f";
var $83f22ad0706d6dbb$export$2e2bcd8739ae039 = $83f22ad0706d6dbb$var$node;

});



parcelRegister("kFqvk", function(module, exports) {
$parcel$export(module.exports, "default", () => $dad94f70e39d20f3$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $dad94f70e39d20f3$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    portals: {
        defaultMessage: 'Portals',
        description: 'Text for section resource type in search results',
        id: 'cv.search.portals.portals'
    }
});

});



parcelRegister("iSdoA", function(module, exports) {
$parcel$export(module.exports, "RequestForms", () => (parcelRequire("9VNKz")).default);

var $9VNKz = parcelRequire("9VNKz");

});
parcelRegister("9VNKz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b71fd27041bfa670$export$2e2bcd8739ae039);

var $hFFIN = parcelRequire("hFFIN");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $2m8U6 = parcelRequire("2m8U6");

var $3krHC = parcelRequire("3krHC");
parcelRequire("fmz0C");
var $74muP = parcelRequire("74muP");
var $bywGP = parcelRequire("bywGP");
var $hRwKd = parcelRequire("hRwKd");

var $d9wEN = parcelRequire("d9wEN");
parcelRequire("hE50p");
var $iaskX = parcelRequire("iaskX");

var $gMnhr = parcelRequire("gMnhr");
const $b71fd27041bfa670$export$d7562fc7136a7ea2 = ({ term: term, updateResultsCount: updateResultsCount, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _data$helpObjectStore;
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const cloudId = (0, $6mmHn.getCloudId)();
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $hFFIN.default), {
        cloudId: cloudId,
        portalId: portalId,
        queryTerm: term,
        helpCenterAri: (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() ? (0, $6mmHn.getHelpCenterAri)() : undefined,
        limit: (0, $6bGmX.default).checkGate('jsm_request_type_limit_update_spike') ? (0, $74muP.REQUEST_FORMS_NEW_LIMIT) : (0, $74muP.REQUEST_FORMS_RESULT_LIMIT)
    });
    const requestForms = ((_data$helpObjectStore = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore === void 0 ? void 0 : _data$helpObjectStore.__typename) === 'HelpObjectStoreRequestTypeSearchResults' ? data.helpObjectStore_searchRequestTypes.results : [];
    const showSection = requestForms.length > 0;
    (0, $4fqPo.useEffect)(()=>{
        var _data$helpObjectStore2;
        if (((_data$helpObjectStore2 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore2 === void 0 ? void 0 : _data$helpObjectStore2.__typename) === 'HelpObjectStoreRequestTypeSearchResults') {
            let externalResourcesCount = 0;
            let firstPartySearchPlatformResourcesCount = 0;
            data.helpObjectStore_searchRequestTypes.results.forEach((requestForm)=>{
                const { metadata: metadata } = requestForm;
                const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
                if (isExternal) externalResourcesCount += 1;
                if (searchStrategy === 'SEARCH_PLATFORM_KEYWORD_BASED') firstPartySearchPlatformResourcesCount += 1;
            });
            (0, $hRwKd.sendSearchOperationalAnalyticEvents)({
                action: 'requestTypeSearchSucceeded',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
            if (showSection) (0, $hRwKd.sendSearchUIAnalyticEvents)({
                externalResourcesCount: externalResourcesCount,
                firstPartySearchPlatformResourcesCount: firstPartySearchPlatformResourcesCount,
                action: 'rendered',
                resourceType: 'request-form',
                resourceCount: data.helpObjectStore_searchRequestTypes.results.length
            }, createAnalyticsEvent, portalId);
        }
    }, [
        term,
        showSection,
        data,
        createAnalyticsEvent,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        var _data$helpObjectStore3;
        if (((_data$helpObjectStore3 = data.helpObjectStore_searchRequestTypes) === null || _data$helpObjectStore3 === void 0 ? void 0 : _data$helpObjectStore3.__typename) === 'HelpObjectStoreSearchError') {
            const { extensions: extensions, message: errorMessage } = data.helpObjectStore_searchRequestTypes;
            const statusCode = extensions.length > 0 ? extensions[0].statusCode : undefined;
            const is4XXFailure = statusCode && statusCode >= 400 && statusCode < 500 ? true : false;
            (0, $hRwKd.sendSearchOperationalAnalyticEvents)({
                errorMessage: errorMessage,
                statusCode: statusCode,
                is4XXFailure: is4XXFailure,
                action: 'requestTypeSearchFailed',
                errorType: extensions.length > 0 ? extensions[0].errorType : undefined
            }, createAnalyticsEvent, portalId);
        }
    }, [
        createAnalyticsEvent,
        data,
        portalId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        updateResultsCount(requestForms.length, 1);
    }, [
        term,
        requestForms.length,
        updateResultsCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, showSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b71fd27041bfa670$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b71fd27041bfa670$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "xxsmall",
        as: "h2"
    }, formatMessage((0, $gMnhr.default).requestForms))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bywGP.ResultList), {
        role: "list"
    }, requestForms.map((resource, index)=>{
        const itemOrder = index + 1;
        const key = resource.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", {
            key: key
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iaskX.default), {
            itemOrder: itemOrder,
            term: term,
            result: resource
        }));
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $d9wEN.searchExperience)
    }));
};
const $b71fd27041bfa670$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    paddingTop: 'space.250',
    paddingRight: 'space.150',
    paddingBottom: 'space.150',
    paddingLeft: 'space.150',
    gap: 'space.150',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    rowGap: 'space.100',
    [(0, $3jKXW.media).above.xxs]: {
        marginLeft: 'space.100',
        marginRight: 'space.100',
        width: '1fr'
    },
    [(0, $3jKXW.media).above.md]: {
        marginLeft: 'space.0',
        marginRight: 'space.0',
        width: '320px'
    }
});
const $b71fd27041bfa670$var$headingStyles = (0, $2m8U6.xcss)({
    width: '100%',
    paddingRight: 'space.100',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100'
});
var $b71fd27041bfa670$export$2e2bcd8739ae039 = (0, $as4kh.default)()($b71fd27041bfa670$export$d7562fc7136a7ea2);

});
parcelRegister("hFFIN", function(module, exports) {
$parcel$export(module.exports, "default", () => $9126c798cfa86253$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c730a03ebb5021ead8eb56adb78276ae>>
 * @relayHash 4db5964fda1ef7ad6bb403c6a9420d56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9
const $9126c798cfa86253$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "portalId",
            "variableName": "portalId"
        },
        {
            "kind": "Variable",
            "name": "queryTerm",
            "variableName": "queryTerm"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpObjectStoreRequestTypeMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isExternal"
            },
            {
                "kind": "ScalarField",
                "name": "searchStrategy"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "requestFormItemFragmentV2"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "requestFormsSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                                    "kind": "LinkedField",
                                    "name": "results",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayLink"
                                        }
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreRequestTypeSearchResults"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "HelpObjectStoreSearchError"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9",
            "metadata": {},
            "name": "requestFormsSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9126c798cfa86253$var$node.hash = "6a4749a62d9236563bcbeca7d18c02eb";
var $9126c798cfa86253$export$2e2bcd8739ae039 = $9126c798cfa86253$var$node;

});

parcelRegister("hE50p", function(module, exports) {
$parcel$export(module.exports, "RequestFormItem", () => (parcelRequire("iaskX")).default);

var $iaskX = parcelRequire("iaskX");

});
parcelRegister("iaskX", function(module, exports) {
$parcel$export(module.exports, "default", () => $3354b292866c2e16$export$2e2bcd8739ae039);

var $m5m40 = parcelRequire("m5m40");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $g1qUq = parcelRequire("g1qUq");

var $bG6ob = parcelRequire("bG6ob");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $as4kh = parcelRequire("as4kh");

var $cnft1 = parcelRequire("cnft1");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $gWRbJ = parcelRequire("gWRbJ");

var $3fKec = parcelRequire("3fKec");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");
parcelRequire("8U13k");
var $2gwke = parcelRequire("2gwke");
const $3354b292866c2e16$export$c5555d4e61cdd47a = ({ itemOrder: itemOrder, result: result, term: term, themeColor: themeColor, createAnalyticsEvent: createAnalyticsEvent })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $m5m40.default), result);
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    const { isShortcutIconVisible: isShortcutIconVisible, setIsHovered: setIsHovered, setIsFocused: setIsFocused } = (0, $hRwKd.useVisibilityState)();
    const { title: title, displayLink: displayLink, id: id, metadata: metadata } = data;
    const { isExternal: isExternal, searchStrategy: searchStrategy } = metadata;
    const shortcutIcon = isExternal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cnft1))), {
        label: formatMessage((0, $3fKec.default).shortcutIcon),
        size: "medium",
        spacing: "compact"
    }) : null;
    const highlightedTitle = title ? (0, $hRwKd.formatText)(title, term) : '';
    const linkProps = (0, $gWRbJ.urlRefsAndTarget)({
        displayLink: displayLink,
        isAnExternalResource: isExternal
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $hRwKd.sendSearchUIAnalyticEvents)({
            id: id,
            portalId: portalId,
            searchAlgorithm: searchStrategy,
            action: 'list-item-rendered',
            resourceType: 'request-form'
        }, createAnalyticsEvent, portalId);
    }, [
        createAnalyticsEvent,
        id,
        portalId,
        searchStrategy
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $3354b292866c2e16$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: [
            $3354b292866c2e16$var$headingStyles,
            $3354b292866c2e16$var$headingAlignmentStyles
        ],
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2gwke.default), {
        entityType: "REQUEST_FORM",
        displayLink: displayLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
        key: id,
        actionSubjectId: isExternal ? 'external-request-form-link' : 'request-form-link',
        "data-test-id": "result-link-container",
        "aria-label": title,
        attributes: {
            id: id,
            itemOrder: itemOrder,
            searchAlgorithm: searchStrategy,
            isEventFromPortal: !!portalId
        },
        ...linkProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        style: {
            color: themeColor
        },
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(highlightedTitle) : (0, $a7SRW.sanitize)(highlightedTitle)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: isShortcutIconVisible ? $3354b292866c2e16$var$headerRightAreaStylesVisible : $3354b292866c2e16$var$headerRightAreaStylesInVisible,
        testId: "search-result-shortcut-icon"
    }, shortcutIcon)));
};
const $3354b292866c2e16$var$ConnectedRequestFormItem = (0, $bmgw6.default)((state)=>{
    return {
        themeColor: (0, $g1qUq.getThemeColor)(state)
    };
})($3354b292866c2e16$export$c5555d4e61cdd47a);
var $3354b292866c2e16$export$2e2bcd8739ae039 = (0, $as4kh.default)()($3354b292866c2e16$var$ConnectedRequestFormItem);
const $3354b292866c2e16$var$containerStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%',
    padding: 'space.100',
    gap: 'space.150',
    borderRadius: 'radius.small'
});
const $3354b292866c2e16$var$headingStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    width: '100%'
});
const $3354b292866c2e16$var$headingAlignmentStyles = (0, $2m8U6.xcss)({
    alignItems: 'center'
});
const $3354b292866c2e16$var$headerRightAreaStylesInVisible = (0, $2m8U6.xcss)({
    display: 'flex',
    opacity: 0,
    alignItems: 'flex-start',
    justifyContent: 'flex-end'
});
const $3354b292866c2e16$var$headerRightAreaStylesVisible = (0, $2m8U6.xcss)({
    display: 'flex',
    opacity: 1,
    alignItems: 'flex-start'
});

});
parcelRegister("m5m40", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ae300d4287764b5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<32278cf5dc0e7086ec41d31040a6e7d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4ae300d4287764b5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "requestFormItemFragmentV2",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "displayLink"
        },
        {
            "concreteType": "HelpObjectStoreRequestTypeMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isExternal"
                },
                {
                    "kind": "ScalarField",
                    "name": "searchStrategy"
                }
            ]
        }
    ],
    "type": "HelpObjectStoreRequestTypeSearchResult"
};
$4ae300d4287764b5$var$node.hash = "3676027039798345dde34e2948999172";
var $4ae300d4287764b5$export$2e2bcd8739ae039 = $4ae300d4287764b5$var$node;

});



parcelRegister("gMnhr", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4b2cc0850c02bc$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $fe4b2cc0850c02bc$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requestForms: {
        defaultMessage: 'Request forms',
        description: 'Text for section resource type in search results',
        id: 'cv.search.request-forms.request-forms'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Text for portal name in description',
        id: 'cv.search.request-forms.portal'
    }
});

});





parcelRegister("j7yBu", function(module, exports) {
$parcel$export(module.exports, "default", () => $83ce6d3ff9766db7$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("7LVOt");
var $db9ld = parcelRequire("db9ld");
parcelRequire("9MU8X");
var $2wESx = parcelRequire("2wESx");

var $6y8WZ = parcelRequire("6y8WZ");
const $83ce6d3ff9766db7$var$selector = (0, $3yyCx.createSelector)((0, $2wESx.getAllVisiblePortals), (0, $2wESx.getfeaturedAndSortedPortalsError), (portals, featuredAndSortedPortalsError)=>({
        featuredAndSortedPortalsError: featuredAndSortedPortalsError,
        portals: portals
    }));
var $83ce6d3ff9766db7$export$2e2bcd8739ae039 = (0, $bmgw6.default)($83ce6d3ff9766db7$var$selector, {
    fetchPortals: (0, $db9ld.fetchFeaturedAndSortedPortalsModel)
})((0, $6y8WZ.default));

});
parcelRegister("6y8WZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d73a582f771217e7$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");
parcelRequire("3jNvt");
var $8Dgv1 = parcelRequire("8Dgv1");

var $kOPXc = parcelRequire("kOPXc");
const $d73a582f771217e7$var$ServiceDeskFilter = ({ portals: portals, portalIds: portalIds, fetchPortals: fetchPortals, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [values, _] = $4fqPo.useState(portalIds ?? []);
    $4fqPo.useEffect(()=>{
        fetchPortals({
            exploreAll: true,
            sortBy: 'POPULARITY'
        }, false);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const options = $4fqPo.useMemo(()=>{
        return portals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals
    ]);
    const preSelectedOptions = $4fqPo.useMemo(()=>{
        const preselectedPortals = portals.filter((portal)=>values.find((id)=>id === portal.id.toString()));
        return preselectedPortals.map((portal)=>({
                optionType: 'option',
                value: portal.id.toString(),
                label: portal.name
            }));
    }, [
        portals,
        values
    ]);
    return portals.length > 1 ? /*#__PURE__*/ $4fqPo.createElement((0, $8Dgv1.default), {
        fieldId: "servicedesk_filter",
        fieldLabel: formatMessage((0, $kOPXc.default).portal),
        options: options,
        preSelectedOptions: preSelectedOptions,
        onChange: onChange,
        testId: "serviceDeskFilter"
    }) : null;
};
var $d73a582f771217e7$export$2e2bcd8739ae039 = $d73a582f771217e7$var$ServiceDeskFilter;

});
parcelRegister("kOPXc", function(module, exports) {
$parcel$export(module.exports, "default", () => $791074cbd6eea9db$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $791074cbd6eea9db$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    serviceDeskFilter: {
        defaultMessage: 'Service desk',
        description: 'Title of the service desk picker',
        id: 'sd.all.articles.result.servicedesk.filter.name'
    },
    portal: {
        defaultMessage: 'Portal',
        description: 'Title of the portal picker',
        id: 'cv.search.servicedesk-filter.portal'
    }
});

});





parcelRegister("gCjjr", function(module, exports) {
$parcel$export(module.exports, "SearchTextboxV2", () => (parcelRequire("kRO8E")).default);

var $kRO8E = parcelRequire("kRO8E");

});
parcelRegister("kRO8E", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b81e761643b3d3e$export$2e2bcd8739ae039);
/* search-textbox-v2.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $aU87f = parcelRequire("aU87f");

var $63sfu = parcelRequire("63sfu");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("20isg");
var $f1dyB = parcelRequire("f1dyB");

var $ht6lp = parcelRequire("ht6lp");

var $jxKS8 = parcelRequire("jxKS8");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("fTxr1");
var $8mlxZ = parcelRequire("8mlxZ");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $6bGmX = parcelRequire("6bGmX");

var $8B6Ry = parcelRequire("8B6Ry");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");

var $azPf3 = parcelRequire("azPf3");

var $54jwS = parcelRequire("54jwS");

var $8s01i = parcelRequire("8s01i");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");

var $4wycM = parcelRequire("4wycM");

var $aIcRy = parcelRequire("aIcRy");

var $fj0mX = parcelRequire("fj0mX");

var $leTE5 = parcelRequire("leTE5");

var $4hXST = parcelRequire("4hXST");

var $cotym = parcelRequire("cotym");

var $85azw = parcelRequire("85azw");

var $9Q0Ul = parcelRequire("9Q0Ul");

var $9RoiU = parcelRequire("9RoiU");

var $lMF78 = parcelRequire("lMF78");

var $j0nbS = parcelRequire("j0nbS");

var $lFeJw = parcelRequire("lFeJw");
parcelRequire("fmz0C");
var $hRwKd = parcelRequire("hRwKd");
parcelRequire("4dnPm");
var $93CBq = parcelRequire("93CBq");

var $2U2KN = parcelRequire("2U2KN");

var $4nKF4 = parcelRequire("4nKF4");
const $1b81e761643b3d3e$var$usePopularPortalsWithVA = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const [popularPortalsWithVA, setPopularPortalsWithVA] = (0, $4fqPo.useState)([]);
    const [isFetching, setIsFetching] = (0, $4fqPo.useState)(false);
    const cloudId = (0, $4fqPo.useMemo)(()=>(0, $6mmHn.getCloudId)(), []);
    const fetchData = (0, $4fqPo.useCallback)(async ()=>{
        setIsFetching(true);
        try {
            const { mostPopularVAsPortalData: mostPopularVAsPortalData } = await (0, $hZWMk.fetchJson)(`/gateway/api/jsm/virtual-agent/cloudId/${cloudId}/public/api/v1/virtualagent/mostPopularVAs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    helpCenterId: (0, $6mmHn.getHelpCenterAri)()
                })
            });
            setPopularPortalsWithVA(mostPopularVAsPortalData);
        } catch (error) {
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.UI_EVENT_TYPE),
                action: 'failed',
                actionSubjectId: 'fetchPopularPortalsWithVA'
            }).fire();
        } finally{
            setIsFetching(false);
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        setIsFetching,
        setPopularPortalsWithVA
    ]);
    return {
        isFetching: isFetching,
        popularPortalsWithVA: popularPortalsWithVA,
        fetchData: fetchData
    };
};
// Extracted component to reduce duplication
const $1b81e761643b3d3e$var$SearchHintWithEnterIcon = ({ message: message, isVisible: isVisible })=>{
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $1b81e761643b3d3e$var$askAiHintStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        space: "space.100",
        alignBlock: "center"
    }, message, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aU87f))),
        alt: ""
    })));
};
const $1b81e761643b3d3e$var$SearchPopupContentWithRef = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function SearchPopupContent(searchPopupContentProps, ref) {
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { setSearchBoxWidth: setSearchBoxWidth, searchBarRef: searchBarRef, isChoiceOpen: isChoiceOpen, isVirtualAgentEnabled: isVirtualAgentEnabled, openChoicesIfPresent: openChoicesIfPresent, handleKeyDown: handleKeyDown, handleInputChange: handleInputChange, inputValue: inputValue, disableSearch: disableSearch, isFetchingResults: isFetchingResults, visibleResultsCount: visibleResultsCount, ...triggerProps } = searchPopupContentProps;
    const isShapeThemeDefaultEnabled = (0, $6bGmX.default).checkGate('platform-dst-shape-theme-default');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        ...triggerProps,
        ref: ref,
        xcss: $1b81e761643b3d3e$var$searchBoxWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $azPf3.default), {
        setWidth: setSearchBoxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: [
            $1b81e761643b3d3e$var$searchBoxStyles,
            isShapeThemeDefaultEnabled && $1b81e761643b3d3e$var$searchBoxShapeThemeStyles
        ],
        style: {
            // We need to manually use different token fallbacks here because the contrast isn't good enough with the default ones, while Portal is not yet using tokens. xcss doesn't allow specifying a token(...) as a value hence needing to use style prop
            // These should be removed once Portal has finished migrating to using tokens
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            borderColor: "var(--ds-border-input, #dee0e4)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            backgroundColor: "var(--ds-background-input, white)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1b81e761643b3d3e$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
        spacing: "spacious",
        color: "var(--ds-icon-subtle, #6B778C)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1b81e761643b3d3e$var$Input, {
        "data-testid": "search-textbox-v2",
        type: "text",
        autoComplete: "off",
        innerRef: searchBarRef,
        autoFocus: isChoiceOpen,
        spellCheck: false,
        isAiAnswersEnabled: isVirtualAgentEnabled,
        "aria-label": isVirtualAgentEnabled ? formatMessage((0, $4nKF4.default).inputAriaLabel) : formatMessage((0, $4nKF4.default).inputAriaLabelNoAI),
        placeholder: isVirtualAgentEnabled ? formatMessage((0, $4nKF4.default).inputPlaceholder) : formatMessage((0, $4nKF4.default).inputPlaceholderNoAI),
        onClick: ()=>openChoicesIfPresent(),
        onFocus: (event)=>{
            // When coming from another focus element (meaning tabbing forwards or backwards)
            // We can't always open choices because that would trigger if you're in the popup menu and press 'Escape'
            // This focuses the text input so by re-opening the menu we'd be causing another A11Y issue
            if (event.relatedTarget != null) openChoicesIfPresent();
        },
        onChange: handleInputChange,
        onKeyDown: handleKeyDown,
        value: inputValue,
        disabled: disableSearch,
        // eslint-disable-next-line @atlassian/a11y/aria-props -- ATLAS-88210
        "aria-description": formatMessage((0, $4nKF4.default).ariaDescription)
    }), (0, $hRwKd.isValidSearchTerm)(inputValue) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1b81e761643b3d3e$var$SearchHintWithEnterIcon, {
        message: isVirtualAgentEnabled ? formatMessage((0, $4nKF4.default).askTheVirtualServiceAgent) : formatMessage((0, $4nKF4.default).search),
        isVisible: isVirtualAgentEnabled || isFetchingResults || visibleResultsCount !== 0
    }))));
});
const $1b81e761643b3d3e$var$SearchTextboxV2 = ({ term: term, isVSAOnHCEnabled: isVSAOnHCEnabled, disableSearch: disableSearch })=>{
    const searchBarRef = (0, $4fqPo.useRef)(null);
    const [isChoiceOpen, setIsChoiceOpen] = (0, $4fqPo.useState)(false);
    const [inputValue, setInputValue] = (0, $4fqPo.useState)(term);
    const [searchBoxWidth, setSearchBoxWidth] = (0, $4fqPo.useState)();
    const [{ location: location }, { push: push }] = (0, $hfD9S.useRouter)();
    const { startNewConversation: startNewConversation } = (0, $ht6lp.useConversationActions)();
    const { sendMessage: sendMessage } = (0, $f1dyB.useSendMessage)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { resultsCount: resultsCount } = (0, $93CBq.useInlineResultsContext)();
    const environment = (0, $gIeP2.useRelayEnvironment)();
    const { popularPortalsWithVA: popularPortalsWithVA, fetchData: fetchPopularPortalsWithVA, isFetching: isFetchingPopularPortalsWithVA } = $1b81e761643b3d3e$var$usePopularPortalsWithVA();
    const { setSubscriptionDisposer: setSubscriptionDisposer } = (0, $lMF78.useSubscriptionAction)();
    (0, $4fqPo.useEffect)(()=>{
        if (isVSAOnHCEnabled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchPopularPortalsWithVA();
    }, [
        isVSAOnHCEnabled,
        fetchPopularPortalsWithVA
    ]);
    const { createConversationWithMessage: createConversationWithMessage } = (0, $leTE5.useCreateConversationWithMessage)();
    const openChoicesIfPresent = (0, $4fqPo.useCallback)(()=>{
        setIsChoiceOpen(isVSAOnHCEnabled || (0, $hRwKd.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen,
        isVSAOnHCEnabled
    ]);
    const handleInputChange = (0, $4fqPo.useCallback)((event)=>{
        const newQuery = event.target.value;
        setInputValue(newQuery);
        setIsChoiceOpen((0, $hRwKd.isValidSearchTerm)(newQuery));
    }, [
        setInputValue,
        setIsChoiceOpen
    ]);
    const onSeeSearchResults = (0, $4fqPo.useCallback)(()=>{
        if (!(0, $hRwKd.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'allResults',
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }).fire();
        push(`${location.pathname}?q=${inputValue.trim()}`);
    }, [
        inputValue,
        createAnalyticsEvent,
        push,
        location.pathname
    ]);
    const onAskAtlassianIntelligence = (0, $4fqPo.useCallback)(async ()=>{
        if (!(0, $hRwKd.isValidSearchTerm)(inputValue)) return;
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'selected',
            actionSubjectId: 'askAtlassianIntelligence',
            ...(0, $jxKS8.getProductIdentifierAttributes)((0, $8s01i.ExperienceType).UNIFIED_HELP)
        }).fire();
        if ((0, $bG6ob.isOmnichannelEnabledForHC)()) {
            if ((0, $bG6ob.isOmnichannelCombinedAPIEnabledForHC)()) {
                const subscriptionId = await (0, $9RoiU.generateUniqueSubscriptionID)({
                    environment: environment
                });
                const omniChannelMetaData = await (0, $cotym.fetchOmnichannelMeta)(environment);
                await (0, $4hXST.updateOmniChannelConversationMetaPromise)({
                    environment: environment,
                    subscriptionId: subscriptionId,
                    draftMessage: !omniChannelMetaData.connectionId ? inputValue.trim() : undefined,
                    isConversationClosed: false,
                    isConversationExpired: false,
                    disableInput: false,
                    isReplyPending: false,
                    subscriptionTriggered: true,
                    subscriptionStatus: 'TRIGGERED'
                });
                const disposable = (0, $85azw.establishSubscriptionToOmnichannel)({
                    environment: environment,
                    subscriptionId: subscriptionId
                });
                setSubscriptionDisposer(disposable);
                if (omniChannelMetaData.connectionId) createConversationWithMessage({
                    subscriptionId: subscriptionId,
                    workspaceAri: (0, $6mmHn.getWorkspaceAri)(),
                    conversationContextAri: (0, $6mmHn.getHelpCenterAri)(),
                    isTestConversation: false,
                    message: inputValue.trim(),
                    connectionId: omniChannelMetaData.connectionId
                });
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $fj0mX.initialIntentMessageHCExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $9Q0Ul.omnichannelPageLoadExperience).start();
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                (0, $fj0mX.initialAIMessageHCExperience).start();
            } else await (0, $4hXST.updateOmniChannelConversationMetaPromise)({
                environment: environment,
                draftMessage: inputValue.trim()
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            push('/conversation');
            return;
        }
        if (isVSAOnHCEnabled) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $aIcRy.initialIntentMessageExperience).start();
            sendMessage(inputValue.trim());
        } else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $lFeJw.initialAIAnswerExperience).start();
            startNewConversation(inputValue.trim());
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        push('/conversation');
    }, [
        inputValue,
        createAnalyticsEvent,
        isVSAOnHCEnabled,
        push,
        environment,
        setSubscriptionDisposer,
        createConversationWithMessage,
        sendMessage,
        startNewConversation
    ]);
    const visibleResultsCount = ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) || 0) + ((resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm) || 0);
    const isFetchingResults = !((0, $63sfu.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.article) && (0, $63sfu.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.portal) && (0, $63sfu.isNumber)(resultsCount === null || resultsCount === void 0 ? void 0 : resultsCount.requestForm));
    const handleKeyDown = (0, $4fqPo.useCallback)((event)=>{
        const canShowSearchResults = isFetchingResults || visibleResultsCount > 0;
        if ((0, $6bGmX.default).checkGate('jsm_hc_search_composing_fix') && event.nativeEvent.isComposing) return;
        if (event.key === 'Enter') {
            if (!!isVSAOnHCEnabled) {
                if ((event.metaKey || !(0, $8mlxZ.isMacOs)() && event.ctrlKey) && canShowSearchResults) onSeeSearchResults();
                else // eslint-disable-next-line @typescript-eslint/no-floating-promises
                onAskAtlassianIntelligence();
            } else if (canShowSearchResults) // If the search results are still fetched, resultsCount will be null
            onSeeSearchResults();
        }
    }, [
        visibleResultsCount,
        isFetchingResults,
        isVSAOnHCEnabled,
        onAskAtlassianIntelligence,
        onSeeSearchResults
    ]);
    (0, $4fqPo.useEffect)(()=>{
        setIsChoiceOpen((0, $hRwKd.isValidSearchTerm)(inputValue));
    }, [
        inputValue,
        setIsChoiceOpen
    ]);
    const [requestIdParam] = (0, $eDygx.usePathParam)('requestId');
    (0, $4fqPo.useEffect)(()=>{
        var _searchBarRef$current;
        if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && requestIdParam) return;
        (_searchBarRef$current = searchBarRef.current) === null || _searchBarRef$current === void 0 || _searchBarRef$current.focus();
    }, [
        requestIdParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isVSAOnHCEnabled && (0, $bG6ob.isOmnichannelEnabledForHC)() && (0, $bG6ob.isOmnichannelCombinedAPIEnabledForHC)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j0nbS.OmnichannelClientConnection), null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2U2KN.SearchPromptPopup), {
        isOpen: isChoiceOpen,
        isFetchingPopularPortalsWithVA: isFetchingPopularPortalsWithVA,
        popularPortalsWithVA: popularPortalsWithVA,
        onClose: ()=>setIsChoiceOpen(false),
        searchBoxWidth: searchBoxWidth,
        searchQuery: inputValue,
        onSelectSearchResults: onSeeSearchResults,
        isAiAnswersEnabled: !!isVSAOnHCEnabled,
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1b81e761643b3d3e$var$SearchPopupContentWithRef, {
                ...triggerProps,
                setSearchBoxWidth: setSearchBoxWidth,
                searchBarRef: searchBarRef,
                isChoiceOpen: isChoiceOpen,
                isVirtualAgentEnabled: !!isVSAOnHCEnabled,
                openChoicesIfPresent: openChoicesIfPresent,
                handleKeyDown: handleKeyDown,
                handleInputChange: handleInputChange,
                inputValue: inputValue,
                disableSearch: disableSearch,
                isFetchingResults: isFetchingResults,
                visibleResultsCount: visibleResultsCount
            });
        }
    }));
};
$1b81e761643b3d3e$var$SearchTextboxV2.displayName = 'SearchTextboxV2';
const $1b81e761643b3d3e$var$WrappedComponent = (0, $4wycM.withHelpCenterConversationStateContainer)($1b81e761643b3d3e$var$SearchTextboxV2);
const $1b81e761643b3d3e$var$SearchTextBoxV2withConversationContainers = (props)=>{
    const contextId = (0, $6mmHn.getHelpCenterAri)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1b81e761643b3d3e$var$WrappedComponent, {
        ...props,
        contextId: contextId
    });
};
var $1b81e761643b3d3e$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: (0, $748yq.ScreenName).HELP_CENTER_SEARCH
})($1b81e761643b3d3e$var$SearchTextBoxV2withConversationContainers);
const $1b81e761643b3d3e$var$searchBoxWrapperStyles = (0, $2m8U6.xcss)({
    position: 'relative'
});
const $1b81e761643b3d3e$var$searchBoxStyles = (0, $2m8U6.xcss)({
    backgroundColor: 'color.background.input',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border.input',
    borderRadius: 'radius.small',
    ':focus-within': {
        outlineStyle: 'solid',
        outlineWidth: 'border.width.focused',
        outlineColor: 'color.border.focused'
    }
});
const $1b81e761643b3d3e$var$searchBoxShapeThemeStyles = (0, $2m8U6.xcss)({
    borderRadius: 'radius.medium'
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1b81e761643b3d3e$var$Input = /*#__PURE__*/ (0, $el3DQ.default).input.withConfig({
    componentId: "sc-d7rq06-0"
})`${(0, $5Kpwp.SEARCH_INPUT_FONT_SIZE)};${$iSWaE.placeholder("var(--ds-text-subtlest, #6B778C)")};background-color:${"var(--ds-background-input, white)"};${()=>(0, $6bGmX.default).checkGate('platform-dst-shape-theme-default') ? `border-radius: ${"var(--ds-radius-medium, 6px)"};` : ''} padding:${$bpWyP.multiple(2.125).px}  ${(props)=>props.isAiAnswersEnabled ? '148px' : "var(--ds-space-600, 48px)"} ${$bpWyP.multiple(2.125).px} ${"var(--ds-space-050, 4px)"};flex-grow:1;border:0;outline:none;color:${"var(--ds-text, #172B4D)"};@media not all and (min-width:30rem){${(0, $bG6ob.isUseHelpCenterRefresh)() ? `padding-right: ${"var(--ds-space-050, 4px)"};` : ''}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1b81e761643b3d3e$var$SearchIconWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt4119w _4t3i1osq _1ltvidpf _154iidpf _94n5idpf _1e0c1txw _4cvr1h6o _1wpz1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});
const $1b81e761643b3d3e$var$askAiHintStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    position: 'absolute',
    padding: 'space.150',
    right: 'space.0',
    color: 'color.text.subtle',
    top: 'space.0',
    bottom: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 11
});

});
parcelRegister("2U2KN", function(module, exports) {
$parcel$export(module.exports, "SearchPromptPopup", () => $420f5d841e164781$export$392e007cdca1b718);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
var $lnVYE = parcelRequire("lnVYE");
var $krkMu = parcelRequire("krkMu");

const $420f5d841e164781$export$48d2544cca703af5 = (0, $60vf0.lazy)(()=>(parcelRequire("9meOw")).then((module)=>module.SearchPromptPopup), {
    moduleId: "./packages/help-center/search/src/search-prompt-popup/search-prompt-popup.tsx"
});
const $420f5d841e164781$export$392e007cdca1b718 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, props.trigger({
            ref: null,
            'aria-expanded': false,
            'aria-haspopup': false
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $krkMu.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($420f5d841e164781$export$48d2544cca703af5, props)));
};

});
parcelRegister("9meOw", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("cvn7W").then(()=>parcelRequire('7O2ol'));

});


parcelRegister("4nKF4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2cbea8cc49c5044$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $b2cbea8cc49c5044$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.input.clear'
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.ai'
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputAriaLabelNoAI: {
        defaultMessage: 'Search for information',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.input.label.no-ai'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.input.placeholder.no-ai'
    },
    askTheVirtualServiceAgent: {
        defaultMessage: 'Ask the virtual service agent',
        description: 'Hint to the user to initiate the virtual service agent conversation',
        id: 'search.input.placeholder.ai.ask-the-virtual-service-agent'
    },
    search: {
        defaultMessage: 'Search',
        description: 'Hint to the user to press enter to go to search results page',
        id: 'search.input.hint'
    },
    ariaDescription: {
        defaultMessage: 'Typing letters in the search input updates the search results in below data table',
        description: 'description for screen reader users when they focus on the search bar ',
        id: 'search.input.aria-description'
    }
});

});





parcelRegister("2A86r", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenu", () => (parcelRequire("3qvcg")).default);

var $3qvcg = parcelRequire("3qvcg");

});
parcelRegister("3qvcg", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba591db1211272ba$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $krFoK = parcelRequire("krFoK");

var $eHHQc = parcelRequire("eHHQc");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("2hwtL");
var $8JE6B = parcelRequire("8JE6B");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("70QmW");
var $38kx3 = parcelRequire("38kx3");
const $ba591db1211272ba$var$selector = (0, $3yyCx.createSelector)((state)=>{
    var _getPortalAnnouncemen;
    const portalId = (0, $h1MVT.getPortalId)(state);
    const portal = {
        id: portalId,
        name: (0, $95tqy.getName)(state, portalId),
        canEditAnnouncement: Boolean((_getPortalAnnouncemen = (0, $95tqy.getPortalAnnouncement)(state, portalId)) === null || _getPortalAnnouncemen === void 0 ? void 0 : _getPortalAnnouncemen.canEditAnnouncement),
        isProjectAdmin: Boolean((0, $95tqy.getCanAdministerProject)(state, portalId)),
        isProjectSimplified: Boolean((0, $95tqy.getIsProjectSimplified)(state, portalId))
    };
    return {
        portal: portal,
        canAdministerJIRA: (0, $2hx7o.getCanAdministerJIRA)(state),
        hasSiteAdministerAccess: (0, $2hx7o.getHasSiteAdministerAccess)(state),
        canCustomiseHelpCenter: (0, $i8gmD.getCanCustomize)(state),
        defaultColumnSettings: (0, $8JE6B.getRequestsColumnSettings)(state),
        jsmAIConfigEnabled: (0, $2mzxy.getJsmAIConfigEnabled)(state),
        projectKey: (0, $95tqy.getProjectKey)(state, portalId)
    };
}, ({ portal: portal, canAdministerJIRA: canAdministerJIRA, hasSiteAdministerAccess: hasSiteAdministerAccess, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, jsmAIConfigEnabled: jsmAIConfigEnabled, projectKey: projectKey })=>({
        portal: portal,
        canAdministerJIRA: canAdministerJIRA,
        hasSiteAdministerAccess: hasSiteAdministerAccess,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        defaultColumnSettings: defaultColumnSettings,
        jsmAIConfigEnabled: jsmAIConfigEnabled,
        projectKey: projectKey
    }));
var $ba591db1211272ba$export$2e2bcd8739ae039 = (0, $bmgw6.default)($ba591db1211272ba$var$selector, {
    openHelpCenterCustomizationSidebar: ()=>(0, $krFoK.editingHelpCenter)(true),
    openRequestListCustomizationSidebar: ()=>(0, $eHHQc.customizingRequestListColumn)(true)
})((0, $38kx3.default));

});
parcelRegister("2hwtL", function(module, exports) {
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => (parcelRequire("8JE6B")).getEnabledRequestsColumnSettings);
$parcel$export(module.exports, "getRequestsColumnSettings", () => (parcelRequire("8JE6B")).getRequestsColumnSettings);
$parcel$export(module.exports, "getStatusFilter", () => (parcelRequire("8JE6B")).getStatusFilter);
$parcel$export(module.exports, "isSaveInProgress", () => (parcelRequire("8JE6B")).isSaveInProgress);
$parcel$export(module.exports, "isCustomizing", () => (parcelRequire("8JE6B")).isCustomizing);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => (parcelRequire("8JE6B")).getOrderedRequestsColumnSettings);
$parcel$export(module.exports, "isReOrdering", () => (parcelRequire("8JE6B")).isReOrdering);

var $8JE6B = parcelRequire("8JE6B");

});
parcelRegister("8JE6B", function(module, exports) {
$parcel$export(module.exports, "getRequestsColumnSettings", () => $506f284d40104068$export$a5e47ac90fcdaee8);
$parcel$export(module.exports, "getStatusFilter", () => $506f284d40104068$export$118cb57d68780367);
$parcel$export(module.exports, "getEnabledRequestsColumnSettings", () => $506f284d40104068$export$821f60d0d1e0f967);
$parcel$export(module.exports, "isSaveInProgress", () => $506f284d40104068$export$2b75ac2de7a23db1);
$parcel$export(module.exports, "isCustomizing", () => $506f284d40104068$export$ce3eed7c98304744);
$parcel$export(module.exports, "isReOrdering", () => $506f284d40104068$export$f63ec727b3081523);
$parcel$export(module.exports, "getOrderedRequestsColumnSettings", () => $506f284d40104068$export$3e30ecdbb6a12b60);

var $3yyCx = parcelRequire("3yyCx");

var $kXlzl = parcelRequire("kXlzl");
const $506f284d40104068$export$29021bb8222c3223 = (state)=>{
    return state.persisted.requestsColumnSettings || {
        columns: [],
        statusFilter: undefined
    };
};
const $506f284d40104068$export$a5e47ac90fcdaee8 = (state)=>{
    const settingsState = $506f284d40104068$export$29021bb8222c3223(state);
    return settingsState.columns || [];
};
const $506f284d40104068$export$118cb57d68780367 = (state)=>{
    const settingsState = $506f284d40104068$export$29021bb8222c3223(state);
    return settingsState.statusFilter;
};
const $506f284d40104068$export$821f60d0d1e0f967 = (0, $3yyCx.createSelector)($506f284d40104068$export$a5e47ac90fcdaee8, (requestsColumnSettings)=>{
    return requestsColumnSettings.filter((column)=>column.isEnabled);
});
const $506f284d40104068$export$20bb0d907fbbe433 = (state)=>{
    if (!state.ui.requestsColumnSettings) return true;
    return Boolean(state.ui.requestsColumnSettings.isLoading);
};
const $506f284d40104068$export$2b75ac2de7a23db1 = (state)=>{
    var _state$ui$requestsCol;
    return Boolean((_state$ui$requestsCol = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol === void 0 ? void 0 : _state$ui$requestsCol.isSaveInProgress);
};
const $506f284d40104068$export$ce3eed7c98304744 = (state)=>{
    var _state$ui$requestsCol2;
    return Boolean((_state$ui$requestsCol2 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol2 === void 0 ? void 0 : _state$ui$requestsCol2.isCustomizing);
};
const $506f284d40104068$export$f63ec727b3081523 = (state)=>{
    var _state$ui$requestsCol3;
    return Boolean((_state$ui$requestsCol3 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol3 === void 0 ? void 0 : _state$ui$requestsCol3.isReOrdering);
};
const $506f284d40104068$export$c7b5b7c6c2c6936 = (state)=>{
    var _state$ui$requestsCol4;
    return (_state$ui$requestsCol4 = state.ui.requestsColumnSettings) === null || _state$ui$requestsCol4 === void 0 ? void 0 : _state$ui$requestsCol4.columnsOrder;
};
const $506f284d40104068$export$3e30ecdbb6a12b60 = (0, $3yyCx.createSelector)($506f284d40104068$export$821f60d0d1e0f967, $506f284d40104068$export$c7b5b7c6c2c6936, (enabledColumnSettings, columnsOrder)=>{
    if (columnsOrder && columnsOrder.length > 0) return columnsOrder.map((index)=>enabledColumnSettings === null || enabledColumnSettings === void 0 ? void 0 : enabledColumnSettings[index]);
    const filteredColumns = enabledColumnSettings.filter((column)=>column.order);
    if (filteredColumns.length > 0) return filteredColumns.sort((a, b)=>{
        if (a.order && b.order) return a.order - b.order;
        return 1;
    });
    /*
   * We fire analytics when enabledColumnSettings is not empty (to filter out noise) and filteredColumns
   * is empty implying that order is prop is undefined for all the columns. This is an erroneous state
   * since we expect at least one column to have order prop defined. If this happens, we return enabledColumnSettings
   * as is.
   */ if (enabledColumnSettings && enabledColumnSettings.length > 0) (0, $kXlzl.operationalEvent)({
        action: 'emptyOrderedRequestColumnSettingsReceived',
        actionSubject: 'request-list-filters-and-table',
        source: 'RequestList'
    });
    return enabledColumnSettings;
});

});


parcelRegister("70QmW", function(module, exports) {
$parcel$export(module.exports, "CustomiseMenuDumb", () => (parcelRequire("38kx3")).default);

var $38kx3 = parcelRequire("38kx3");

});
parcelRegister("38kx3", function(module, exports) {
$parcel$export(module.exports, "default", () => $04d97dd9de31aa8e$export$2e2bcd8739ae039);
/* customise-menu-dumb.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $1HSOM = parcelRequire("1HSOM");
var $1P8FK = parcelRequire("1P8FK");

var $kW9l8 = parcelRequire("kW9l8");

var $748yq = parcelRequire("748yq");

var $aeicL = parcelRequire("aeicL");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $bpWyP = parcelRequire("bpWyP");

var $kQ79X = parcelRequire("kQ79X");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("7BEQF");
var $fcd6D = parcelRequire("fcd6D");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");

var $fFB0R = parcelRequire("fFB0R");
var $ew3Bn = parcelRequire("ew3Bn");

var $bdWMd = parcelRequire("bdWMd");

var $9qmTW = parcelRequire("9qmTW");

var $hHIxn = parcelRequire("hHIxn");
var $2dYW6 = parcelRequire("2dYW6");
var $45ZUo = parcelRequire("45ZUo");

var $2nGAn = parcelRequire("2nGAn");
var $33cQv = parcelRequire("33cQv");

var $6hIdA = parcelRequire("6hIdA");

var $7TPEx = parcelRequire("7TPEx");
var $82vM7 = parcelRequire("82vM7");
var $2m8U6 = parcelRequire("2m8U6");

var $hDp3n = parcelRequire("hDp3n");

var $6xwRI = parcelRequire("6xwRI");

var $54jwS = parcelRequire("54jwS");

var $6YWkm = parcelRequire("6YWkm");

var $2KBf4 = parcelRequire("2KBf4");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $chA55 = parcelRequire("chA55");
parcelRequire("5MfFQ");
var $aXskD = parcelRequire("aXskD");

var $gmDVa = parcelRequire("gmDVa");

var $9oFog = parcelRequire("9oFog");
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope
const $04d97dd9de31aa8e$var$isSmallScreen = window.innerWidth < (0, $kQ79X.sizes).xsmall;
const $04d97dd9de31aa8e$var$CustomPressable = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $82vM7.default), {
        componentName: "link",
        xcss: $04d97dd9de31aa8e$var$customPressableStyles,
        ...rest
    }, children);
};
const $04d97dd9de31aa8e$var$PremiumBenefitsModalRenderer = ({ menu: menu })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).HELP_CENTER,
        id: "help-center-customise-menu-edit-page-layout",
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6YWkm.PremiumBenefitModalTrigger), {
        cloudId: (0, $6mmHn.getCloudId)(),
        product: "jira-service-management",
        variantId: "help-center-customization",
        touchpointId: "portal-customise-menu-edit-page-layout",
        edition: (0, $ebpTf.getEnv)().edition ?? 'unknown'
    }, ({ ref: ref, props: triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            ref: ref,
            ...triggerProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: menu.actionSubjectId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            component: $04d97dd9de31aa8e$var$CustomPressable,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label)))));
};
const $04d97dd9de31aa8e$var$CustomizeLinks = (onClose, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomePage, basePath, handleHideSpotlight, hasSiteAdministerAccess)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const isCsmHelpCenter = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    const showPortalReorderButton = !isCsmHelpCenter && isHomePage && canAdministerJIRA && !$04d97dd9de31aa8e$var$isSmallScreen;
    const navbarHideAndReorderCustomRenderer = (0, $4fqPo.useCallback)(()=>{
        if ((0, $ebpTf.getIsHCCustomizationEnabled)()) return undefined;
        if ((0, $chA55.isPremiumUpsellExperimentEnabled)({
            hasSiteAdministerAccess: hasSiteAdministerAccess,
            isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
        })) return $04d97dd9de31aa8e$var$PremiumBenefitsModalRenderer;
        return 0, $gmDVa.default;
    }, [
        hasSiteAdministerAccess
    ]);
    const customizeMenu = [
        {
            link: `${basePath}?customize=true&experience=help-center-announcement`,
            label: formatMessage((0, $9oFog.default).announcement),
            actionSubjectId: 'navbarAnnouncement',
            isVisible: isHomePage && !$04d97dd9de31aa8e$var$isSmallScreen,
            onClick: ()=>onClick('navbarAnnouncement'),
            testId: 'announcement-link'
        },
        {
            link: `${basePath}?customize=true&experience=theme`,
            label: formatMessage((0, $9oFog.default).look),
            actionSubjectId: 'navbarLookAndFeel',
            isVisible: isHomePage && canAdministerJIRA,
            onClick: ()=>onClick('navbarLookAndFeel'),
            testId: 'look-and-feel-link'
        },
        {
            link: `${basePath}?customize=true&experience=login-announcement`,
            label: formatMessage((0, $9oFog.default).logInMessage),
            actionSubjectId: 'navbarLoginAnnouncement',
            isVisible: isHomePage && canAdministerJIRA && !$04d97dd9de31aa8e$var$isSmallScreen,
            onClick: ()=>onClick('navbarLoginAnnouncement'),
            testId: 'login-announcement-link'
        },
        {
            link: '/settings/portal-reorder',
            label: (0, $bG6ob.isAdvancedCustomizationEditPageEnabled)() ? formatMessage((0, $9oFog.default).topicsAndPortals) : formatMessage((0, $9oFog.default).pageLayout),
            actionSubjectId: 'navbarPortalReorder',
            isVisible: showPortalReorderButton,
            onClick: ()=>onClick('navbarPortalReorder'),
            testId: 'topics-link'
        },
        {
            link: '/edit',
            label: formatMessage((0, $9oFog.default).pageLayout),
            actionSubjectId: 'navbarHideAndReorder',
            isVisible: showEditLayoutButton,
            onClick: ()=>onClick('navbarHideAndReorder', !(0, $ebpTf.getIsHCCustomizationEnabled)() && (0, $chA55.isPremiumUpsellExperimentEnabled)({
                    hasSiteAdministerAccess: hasSiteAdministerAccess,
                    isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
                })),
            testId: 'hide-and-reorder-link',
            showSpotlight: true,
            customRenderer: navbarHideAndReorderCustomRenderer(),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, (0, $ebpTf.getIsHCCustomizationEnabled)() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                appearance: "new"
            }, formatMessage((0, $9oFog.default).premium)))
        }
    ];
    const onClick = (actionSubjectId, closeSidebar)=>{
        onClose(actionSubjectId);
        if (!closeSidebar) openHelpCenterCustomizationSidebar();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        if (menu.customRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(menu.customRenderer, {
            key: `customize-menu_${menu.actionSubjectId}`,
            menu: menu
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $33cQv.default), {
            name: (0, $748yq.EngagementMessagesTarget).CHANGE_BOARDING_CUSTOMISE_BUTTON_SPOTLIGHT
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            key: `customize-menu_${menu.actionSubjectId}`,
            component: $04d97dd9de31aa8e$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            onClick: menu.onClick,
            testId: menu.testId,
            iconAfter: menu.iconAfter,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label)), menu.showSpotlight && (0, $bG6ob.isCustomiseDropDownChangeBoardingEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aeicL.default), {
            messageId: (0, $748yq.EngagementMessages).CHANGE_BOARD_CUSTOMISE_BUTTON
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kW9l8.ChangeBoardingSingleSpotlight), {
            target: (0, $748yq.EngagementMessagesTarget).CHANGE_BOARDING_CUSTOMISE_BUTTON_SPOTLIGHT,
            analyticsSubject: "customiseButtonChangeBoarding",
            messageId: (0, $748yq.EngagementMessages).CHANGE_BOARD_CUSTOMISE_BUTTON,
            contentText: formatMessage((0, $9oFog.default).changeBoardingText),
            buttonText: formatMessage((0, $9oFog.default).changeBoardingButtonText),
            dialogPlacement: "bottom right",
            targetBgColor: "var(--ds-surface-raised, #FFFFFF)",
            onHideSpotlight: handleHideSpotlight
        })));
    }));
};
const $04d97dd9de31aa8e$var$PortalLinks = ({ onClose: onClose, canCustomiseHelpCenter: canCustomiseHelpCenter, portal: portal, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    if (!portal) return null;
    const { isProjectSimplified: isProjectSimplified, isProjectAdmin: isProjectAdmin, canEditAnnouncement: canEditAnnouncement } = portal;
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const shouldRenderConfigurePortal = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length) && (0, $bG6ob.isCortopv2ExperimentEnabledWithExposure)(true);
    const shouldRenderCustomizeRequestTypes = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length) && (0, $bG6ob.isCortopv2ExperimentEnabledWithExposure)(true);
    const shouldRenderCustomizePortalGroups = ()=>isProjectAdmin && !isProjectSimplified && (projectKey === null || projectKey === void 0 ? void 0 : projectKey.length) && (0, $bG6ob.isCortopv2ExperimentEnabledWithExposure)(true);
    const customizeMenu = [
        {
            link: '?customize=true&experience=add-announcement',
            onClick: ()=>onClose('navbarPortalAnnouncement'),
            label: formatMessage((0, $9oFog.default).portalAnnouncement),
            actionSubjectId: 'navbarPortalAnnouncement',
            isVisible: canEditAnnouncement || shouldRenderAsPortalAnnouncement()
        },
        {
            link: '?customize=true&experience=request-groups',
            onClick: ()=>onClose('navbarRequestTypeGroup'),
            label: formatMessage((0, $9oFog.default).portalRequestTypeGroup),
            actionSubjectId: 'navbarRequestTypeGroup',
            isVisible: isProjectAdmin && isProjectSimplified && !shouldRenderAsPortalAnnouncement()
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings`,
            onClick: ()=>onClose('navbarConfigurePortal'),
            label: formatMessage((0, $9oFog.default).configurePortal),
            actionSubjectId: 'navbarConfigurePortal',
            isVisible: shouldRenderConfigurePortal(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/${isProjectSimplified ? 'issuetypes' : 'request-types'}/`,
            onClick: ()=>onClose('navbarCustomizeRequestTypes'),
            label: formatMessage((0, $9oFog.default).customizeRequestTypes),
            actionSubjectId: 'navbarCustomizeRequestTypes',
            isVisible: shouldRenderCustomizeRequestTypes(),
            target: '_blank'
        },
        {
            // eslint-disable-next-line rulesdir/do-not-manually-build-jsm-agent-view-url
            href: `/jira/servicedesk/projects/${projectKey ?? ''}/settings/portal-settings/portal-groups`,
            onClick: ()=>onClose('navbarManagePortalGroups'),
            label: formatMessage((0, $9oFog.default).managePortalGroups),
            actionSubjectId: 'navbarManagePortalGroups',
            isVisible: shouldRenderCustomizePortalGroups(),
            target: '_blank'
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), null, customizeMenu.map(({ isVisible: isVisible, actionSubjectId: actionSubjectId, onClick: onClick, link: link, href: href, label: label, target: target })=>{
        if (!isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            key: `portal-link_${actionSubjectId}`,
            component: $04d97dd9de31aa8e$var$CustomLink,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            ...link ? {
                to: link
            } : {},
            ...href ? {
                href: href
            } : {},
            testId: `portal-link_${actionSubjectId}`,
            // Made this check of menu.target === '_blank' to avoid the eslint error
            target: target === '_blank' ? '_blank' : '_self',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, label);
    }));
};
const $04d97dd9de31aa8e$var$CustomPageLinks = ({ showEditCustomPages: showEditCustomPages })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [{ match: match }] = (0, $hfD9S.useRouter)();
    const pageId = match.params.id || '';
    const customizeMenu = [
        {
            link: `/page/edit/${pageId}`,
            label: formatMessage((0, $9oFog.default).pageLayout),
            actionSubjectId: 'navbarEditCustomPage',
            isVisible: showEditCustomPages
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), null, customizeMenu.map((menu)=>{
        if (!menu.isVisible) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
            key: `custom-page-link_${menu.actionSubjectId}`,
            component: $04d97dd9de31aa8e$var$CustomLink,
            to: menu.link,
            actionSubjectId: menu.actionSubjectId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: "cv-exclude-from-customisation"
        }, menu.label);
    }));
};
const $04d97dd9de31aa8e$var$RequestList = (onClose, openRequestListCustomizationSidebar)=>{
    const onClick = (actionSubjectId)=>{
        onClose(actionSubjectId);
        openRequestListCustomizationSidebar();
    };
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: $04d97dd9de31aa8e$var$CustomButton,
        actionSubjectId: "navbarUserRequestListCustomize",
        "aria-label": formatMessage((0, $9oFog.default).customizeRequestList),
        onClick: ()=>onClick('navbarUserRequestListCustomize'),
        "data-test-id": "requests-list-page-link"
    }, formatMessage((0, $9oFog.default).customizeRequestList)));
};
const $04d97dd9de31aa8e$var$CustomiseMenu = (props)=>{
    const [{ route: route }] = (0, $hfD9S.useRouter)();
    const { name: routeName } = route;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $4azHH.useQueryParams)();
    (0, $4fqPo.useEffect)(()=>{
        // if customize is true and experience is not set, open the customise menu
        if (customize === 'true' && !experience) setIsOpen(true);
    }, [
        customize,
        experience
    ]);
    const isHomepage = routeName === 'help-center' || routeName === 'view-homepage';
    const isCustomPage = routeName === (0, $748yq.RouteName).VIEW_CUSTOM_PAGE;
    const showEditCustomPageButton = (0, $bG6ob.isCustomPagesUiEnabled)() && props.canAdministerJIRA && !$04d97dd9de31aa8e$var$isSmallScreen && isCustomPage;
    const showEditLayoutButtonUpsell = (0, $ebpTf.getIsHCCustomizationEnabled)() || (props.hasSiteAdministerAccess ?? false);
    const showEditLayoutButton = (0, $bG6ob.isAdvancedCustomizationEditPageEnabled)() && isHomepage && props.canAdministerJIRA && !$04d97dd9de31aa8e$var$isSmallScreen && showEditLayoutButtonUpsell;
    const isHelpCenterManagementScreen = (0, $3wR8f.getRelativeBasePath)() === (0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH);
    const basePath = (0, $eSL4S.isAdvancedHelpCenter)() ? '/' : '/portals';
    const [isOpen, setIsOpen] = (0, $4fqPo.useState)(!!props.isOpen);
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const handleHideSpotlight = (0, $4fqPo.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const onOpenChange = (0, $4fqPo.useCallback)((open)=>{
        setIsOpen(open);
    }, []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const setCustomiseSidebarTrigger = (0, $fcd6D.useSetCustomiseSidebarTrigger)();
    const onItemClick = (actionSubjectId)=>{
        if (actionSubjectId && createAnalyticsEvent) createAnalyticsEvent({
            actionSubjectId: actionSubjectId,
            action: 'clicked',
            actionSubject: 'customizeMenu',
            analyticsType: (0, $54jwS.UI_EVENT_TYPE)
        }).fire();
        setIsOpen(false);
    };
    const allowRouteList = [
        'help-center',
        'view-homepage',
        'portal-home',
        'requests-list',
        (0, $bG6ob.isCustomPagesUiEnabled)() ? (0, $748yq.RouteName).VIEW_CUSTOM_PAGE : undefined
    ];
    const hideCustomizeButton = ()=>{
        var _props$portal, _props$portal2;
        return !allowRouteList.includes(routeName) || isHelpCenterManagementScreen || isHomepage && !props.canCustomiseHelpCenter || //Hide for Agents with Edit Permission in mobile view
        isHomepage && props.canCustomiseHelpCenter && !props.canAdministerJIRA && $04d97dd9de31aa8e$var$isSmallScreen || routeName === 'portal-home' && !((_props$portal = props.portal) !== null && _props$portal !== void 0 && _props$portal.isProjectAdmin || (_props$portal2 = props.portal) !== null && _props$portal2 !== void 0 && _props$portal2.canEditAnnouncement) || routeName === 'requests-list' && !props.canAdministerJIRA || (0, $bG6ob.isCustomPagesUiEnabled)() && isCustomPage && !props.canAdministerJIRA;
    };
    const content = ()=>{
        const { openHelpCenterCustomizationSidebar: openHelpCenterCustomizationSidebar, openRequestListCustomizationSidebar: openRequestListCustomizationSidebar, canAdministerJIRA: canAdministerJIRA, canCustomiseHelpCenter: canCustomiseHelpCenter, defaultColumnSettings: defaultColumnSettings, portal: portal, projectKey: projectKey, hasSiteAdministerAccess: hasSiteAdministerAccess } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $04d97dd9de31aa8e$var$popupContainerStyles,
            "aria-label": formatMessage((0, $9oFog.default).customizeAriaLabel),
            testId: 'customize-menu-content',
            role: "group"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2dYW6.default), {
            maxHeight: $04d97dd9de31aa8e$var$maxHeight,
            spacing: 'cozy'
        }, !isHelpCenterManagementScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, canCustomiseHelpCenter && isHomepage && $04d97dd9de31aa8e$var$CustomizeLinks(onItemClick, openHelpCenterCustomizationSidebar, canAdministerJIRA, showEditLayoutButton, isHomepage, basePath, handleHideSpotlight, hasSiteAdministerAccess), routeName === 'portal-home' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($04d97dd9de31aa8e$var$PortalLinks, {
            onClose: onItemClick,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            portal: portal,
            projectKey: projectKey
        }), routeName === 'requests-list' && canAdministerJIRA && Boolean(defaultColumnSettings === null || defaultColumnSettings === void 0 ? void 0 : defaultColumnSettings.length) && $04d97dd9de31aa8e$var$RequestList(onItemClick, openRequestListCustomizationSidebar), isCustomPage && showEditCustomPageButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($04d97dd9de31aa8e$var$CustomPageLinks, {
            showEditCustomPages: showEditCustomPageButton
        }))), showEditLayoutButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6xwRI.FireUIAnalytics), {
            action: "viewed",
            actionSubject: "editPageLayout"
        }));
    };
    const Trigger = (0, $4fqPo.useCallback)(({ ref: ref, ...triggerProps })=>{
        const combinedRef = (element)=>{
            if (typeof ref === 'function') ref(element);
            else if (ref && typeof ref === 'object' && 'current' in ref) ref.current = element;
            setCustomiseSidebarTrigger === null || setCustomiseSidebarTrigger === void 0 || setCustomiseSidebarTrigger(element);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            role: "listitem"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aXskD.default), {
            label: formatMessage((0, $9oFog.default).customizeBtnLabel),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bdWMd))), {
                label: "customise",
                size: "small",
                spacing: "spacious"
            }),
            disabled: props.disableCustomiseMenu,
            onClick: ()=>{
                onOpenChange(!isOpen);
                createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'navbarCustomise',
                    analyticsType: (0, $54jwS.UI_EVENT_TYPE)
                }).fire();
            },
            forwardedRef: combinedRef,
            ...triggerProps
        }));
    }, [
        formatMessage,
        props.disableCustomiseMenu,
        onOpenChange,
        isOpen,
        createAnalyticsEvent,
        setCustomiseSidebarTrigger
    ]);
    const renderDropdownMenu = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2nGAn.default), {
            blanketIsTinted: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2KBf4.ModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
            isOpen: isOpen,
            onClose: ()=>onOpenChange(false),
            placement: "bottom-end",
            shouldRenderToParent: true,
            zIndex: (0, $hDp3n.layers).modal(),
            content: content,
            trigger: Trigger,
            key: 'customise-menu-dumb-popup'
        })));
    if (hideCustomizeButton()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $04d97dd9de31aa8e$var$CustomiseBtnWrapperStyles
    }, renderDropdownMenu());
};
const $04d97dd9de31aa8e$var$CustomiseBtnWrapperStyles = (0, $2m8U6.xcss)({
    marginRight: 'space.100',
    marginLeft: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04d97dd9de31aa8e$var$NoUnderlineLink = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1P8FK.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1nrm1r31 _1a3b1r31 _9oik1r31 _5bd61r31 _1ydc1r31 _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
});
const $04d97dd9de31aa8e$var$popupContainerStyles = (0, $2m8U6.xcss)({
    minWidth: '234px',
    maxWidth: '800px',
    color: 'color.text'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04d97dd9de31aa8e$var$CustomLink = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = $04d97dd9de31aa8e$var$NoUnderlineLink, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_syaz261p _1y3i1r31 _92x4glyw _109f1o36 _b8xz168b",
            __cmplp.className
        ])
    });
});
const $04d97dd9de31aa8e$var$customPressableStyles = (0, $2m8U6.xcss)({
    color: 'color.text',
    backgroundColor: 'color.background.neutral.subtle',
    width: '100%',
    padding: 'space.100',
    paddingInline: 'space.200',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $04d97dd9de31aa8e$var$CustomButton = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = (0, $1HSOM.Button), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_11q7261p _ca0qc4v4 _u5f31gpt _n3tdc4v4 _19bv1gpt _syaz16l4 _1bsbaq80 _4cvr1s23 _j6xtkjgq _1du2kjgq _19lckjgq _1x4lkjgq _utpwkjgq _9h8h16l4 _f8pj16l4 _30l316l4 _ysv716l4 _105316l4",
            __cmplp.className
        ])
    });
});
const $04d97dd9de31aa8e$var$maxHeight = `calc(100vh - ${$bpWyP.multiple(24).px}`;
var $04d97dd9de31aa8e$export$2e2bcd8739ae039 = $04d97dd9de31aa8e$var$CustomiseMenu;

});
parcelRegister("kW9l8", function(module, exports) {
$parcel$export(module.exports, "ChangeBoardingSingleSpotlight", () => $4e881d3e35090a87$export$5c8339440f10c2f);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $4e881d3e35090a87$export$5c8339440f10c2f = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("kt6Jl")), {
        moduleId: "./packages/common-utils/change-boarding-single-spotlight/src/change-boarding-single-spotlight.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("kt6Jl", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("86ale"),
    $e46AW("ccn17")
]).then(()=>parcelRequire('kQ6vl'));

});


parcelRegister("bdWMd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b33f6cea30c30d4bb688045632d4c251>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82be806e259f25ce$var$_react = $82be806e259f25ce$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $82be806e259f25ce$var$_baseNew = $82be806e259f25ce$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $82be806e259f25ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PaintBrush".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82be806e259f25ce$var$PaintBrushIcon = (props)=>/*#__PURE__*/ $82be806e259f25ce$var$_react.default.createElement($82be806e259f25ce$var$_baseNew.default, Object.assign({
        name: "PaintBrushIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5.75A.75.75 0 0 1 3.25 0h9.5a.75.75 0 0 1 .75.75V9a2 2 0 0 1-2 2H10v3a2 2 0 1 1-4 0v-3H4.5a2 2 0 0 1-2-2zM7.5 11v3a.5.5 0 0 0 1 0v-3zM4 1.5v5h8v-5h-1.5V4H9V1.5H7V3H5.5V1.5zM12 8H4v1a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 12 9z" clip-rule="evenodd"/>`
    }, props));
$82be806e259f25ce$var$PaintBrushIcon.displayName = 'PaintBrushIcon';
var $82be806e259f25ce$var$_default = module.exports.default = $82be806e259f25ce$var$PaintBrushIcon;

});

parcelRegister("5MfFQ", function(module, exports) {
$parcel$export(module.exports, "DynamicThemingButton", () => (parcelRequire("aXskD")).default);

var $aXskD = parcelRequire("aXskD");

});
parcelRegister("aXskD", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b93fdaf095612a4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $9Ix81 = parcelRequire("9Ix81");
var $2m8U6 = parcelRequire("2m8U6");

var $7TPEx = parcelRequire("7TPEx");

var $e2Zgo = parcelRequire("e2Zgo");
function $5b93fdaf095612a4$var$DynamicThemingButton({ label: label, ariaLabel: ariaLabel, themeColor: themeColor, disabled: disabled, icon: icon, onClick: onClick, forwardedRef: forwardedRef, textColor: textColor, customStyles: customStyles = {}, ...customProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        ...customProps,
        ref: forwardedRef,
        disabled: disabled,
        "aria-label": ariaLabel ? ariaLabel : label,
        as: "button",
        onClick: onClick,
        xcss: $5b93fdaf095612a4$var$buttonStyles,
        style: {
            backgroundImage: `linear-gradient(
                to right,
                rgba(255, 255, 255, 0.8),
                rgba(255, 255, 255, 0.8)
            ),
            linear-gradient(to right, ${themeColor}, ${themeColor})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customStyles
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
        gap: "space.050",
        alignItems: "center"
    }, icon, textColor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        color: textColor,
        as: "span"
    }, label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        as: "span"
    }, label)));
}
const $5b93fdaf095612a4$var$buttonStyles = (0, $2m8U6.xcss)({
    position: 'relative',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    borderRadius: 'radius.full',
    borderColor: 'color.border.inverse',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    color: 'color.text',
    cursor: 'pointer',
    height: '36px',
    '::after': {
        content: '""',
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        bottom: 'space.0',
        left: 'space.0',
        borderRadius: 'radius.full',
        background: `${"var(--ds-interaction-hovered, rgba(9, 30, 66, 0.60))"}`,
        opacity: 0,
        pointerEvents: 'none'
    },
    ':hover::after': {
        opacity: 0.6,
        transition: 'opacity 200ms'
    },
    ':active': {
        transform: 'scale(0.97)',
        transition: 'transform 50ms'
    },
    ':disabled': {
        pointerEvents: 'none'
    }
});
const $5b93fdaf095612a4$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
var $5b93fdaf095612a4$export$2e2bcd8739ae039 = (0, $bmgw6.default)($5b93fdaf095612a4$var$selector, {})($5b93fdaf095612a4$var$DynamicThemingButton);

});


parcelRegister("gmDVa", function(module, exports) {
$parcel$export(module.exports, "default", () => $0e84707498b242a7$export$2e2bcd8739ae039);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

var $0e84707498b242a7$export$2e2bcd8739ae039 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("8hnnL")), {
        moduleId: "./src/view/layout/edit-page-layout-with-popup/edit-page-layout-with-popup.tsx"
    })
});

});
parcelRegister("8hnnL", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fAmjO").then(()=>parcelRequire('M8owE'));

});


parcelRegister("9oFog", function(module, exports) {
$parcel$export(module.exports, "default", () => $e368e9c0086d9fb8$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $e368e9c0086d9fb8$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    customizeBtnLabel: {
        defaultMessage: 'Customize',
        description: 'Button label for customize button beside avatar menu in header to open list of customization options in a popup',
        id: 'customize.menu.header.customizeBtnLabel'
    },
    customizeRequestList: {
        defaultMessage: 'Manage columns',
        description: 'Manage columns item in customize menu in request list screen',
        id: 'customize.menu.header.manage-column'
    },
    pageLayout: {
        defaultMessage: 'Edit page layout',
        description: 'Edit page layout item in customize drop-down menu',
        id: 'customize.menu.header.pageLayout'
    },
    beta: {
        defaultMessage: 'Beta',
        description: 'Beta lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.beta'
    },
    premium: {
        defaultMessage: 'Premium',
        description: 'Premium lozenge for flexi HC in customize drop-down menu',
        id: 'customize.menu.header.label.premium'
    },
    changeBoardingText: {
        defaultMessage: 'Make your help content stand out. Reorder or hide sections, and customize your home page with rich content for different audiences.',
        description: 'Text for describing the change boarding of customize button',
        id: 'customize.menu.header.pageLayout.change.board'
    },
    changeBoardingButtonText: {
        defaultMessage: 'OK',
        description: 'Text to close the change boarding of the customize button',
        id: 'customize.menu.header.pageLayout.change.board.ok'
    },
    topicsAndPortals: {
        defaultMessage: 'Manage topics and portals',
        description: 'Manage Topics and Portals item in customize drop-down menu when advanced customization enabled',
        id: 'customize.menu.header.topicsAndPortals'
    },
    look: {
        defaultMessage: 'Customize look and feel',
        description: 'Customize look and feel item in customize menu',
        id: 'customize.menu.header.look'
    },
    announcement: {
        defaultMessage: 'Manage announcements',
        description: 'Announcement item in customize menu',
        id: 'customize.menu.header.announcement'
    },
    logInMessage: {
        defaultMessage: 'Add login page message',
        description: 'Add login page message item in customize menu',
        id: 'customize.menu.header.logInMessage'
    },
    customizeAriaLabel: {
        defaultMessage: 'Customization options',
        description: 'Aria label for screen readers while opening customize pop up menu from customize button in header',
        id: 'customize.menu.header.customizeAriaLabel'
    },
    portalAnnouncement: {
        defaultMessage: 'Manage announcements',
        description: 'Manage announcement item in customize menu in portal screen',
        id: 'customize.menu.header.portalAnnouncement'
    },
    portalRequestTypeGroup: {
        defaultMessage: 'Organize portal groups',
        description: 'Organize portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.requestTypeGroup'
    },
    pageLayoutPremiumDescription: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to edit sections in your home page layout.',
        description: 'Description for premium suggestion of feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.description'
    },
    pageLayoutTryButton: {
        defaultMessage: 'Try it now',
        description: 'Button to try the premium feature Page Layout',
        id: 'customize.menu.header.pageLayout.premium.try.button'
    },
    configurePortal: {
        defaultMessage: 'Configure portal',
        description: 'Configure portal item in customize menu for portal screen',
        id: 'customize.menu.header.configurePortal'
    },
    customizeRequestTypes: {
        defaultMessage: 'Customize request types',
        description: 'Customize request types item in customize menu for portal screen',
        id: 'customize.menu.header.customizeRequestTypes'
    },
    managePortalGroups: {
        defaultMessage: 'Manage portal groups',
        description: 'Manage portal groups item in customize menu for portal screen',
        id: 'customize.menu.header.managePortalGroups'
    }
});

});





parcelRegister("ggiKZ", function(module, exports) {
$parcel$export(module.exports, "VirtualServiceAgentHeader", () => (parcelRequire("7i0Yg")).default);

var $7i0Yg = parcelRequire("7i0Yg");

});
parcelRegister("7i0Yg", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0ca561c7948964$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("2WwoJ");
var $ltiec = parcelRequire("ltiec");
parcelRequire("9oOr9");
var $3DB5G = parcelRequire("3DB5G");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("6GIzL");
var $j77Sg = parcelRequire("j77Sg");
const $6f0ca561c7948964$var$selector = (0, $3yyCx.createSelector)((state, { portalId: portalId })=>{
    const isJiraAdmin = Boolean((0, $2hx7o.getCanAdministerJIRA)(state));
    const projectId = portalId && (0, $95tqy.getProjectId)(state, (0, $4azHH.getPortalIdAsNumber)(portalId));
    const isChatSideBarOpen = (0, $3DB5G.isChatSideBarOpen)(state);
    const isProjectAdmin = (0, $95tqy.getCanAdministerProject)(state, (0, $4azHH.getPortalIdAsNumber)(portalId));
    return {
        isJiraAdmin: isJiraAdmin,
        projectId: projectId,
        isChatSideBarOpen: isChatSideBarOpen,
        isProjectAdmin: isProjectAdmin
    };
}, ({ isJiraAdmin: isJiraAdmin, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, isProjectAdmin: isProjectAdmin })=>({
        isJiraAdmin: isJiraAdmin,
        projectId: projectId,
        isChatSideBarOpen: isChatSideBarOpen,
        isProjectAdmin: isProjectAdmin
    }));
const $6f0ca561c7948964$var$mapDispatchToProps = {
    openChatSideBar: $ltiec.openChatSideBar,
    closeChatSideBar: $ltiec.closeChatSideBar
};
var $6f0ca561c7948964$export$2e2bcd8739ae039 = (0, $bmgw6.default)($6f0ca561c7948964$var$selector, $6f0ca561c7948964$var$mapDispatchToProps)((0, $j77Sg.default));

});
parcelRegister("9oOr9", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => (parcelRequire("3DB5G")).isChatSideBarOpen);

var $3DB5G = parcelRequire("3DB5G");

});
parcelRegister("3DB5G", function(module, exports) {
$parcel$export(module.exports, "isChatSideBarOpen", () => $5b33d2d06ad2c80d$export$d16875019bc5532b);
const $5b33d2d06ad2c80d$export$d16875019bc5532b = (state)=>state.ui.chatDetails.isChatSideBarOpen;

});


parcelRegister("6GIzL", function(module, exports) {
$parcel$export(module.exports, "VirtualServiceAgentHeaderDumb", () => (parcelRequire("j77Sg")).default);

var $j77Sg = parcelRequire("j77Sg");

});
parcelRegister("j77Sg", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4a5e8bc0f045f6c$export$2e2bcd8739ae039);

var $29z3m = parcelRequire("29z3m");

var $8Y01c = parcelRequire("8Y01c");

var $4fqPo = parcelRequire("4fqPo");

var $6uA6H = parcelRequire("6uA6H");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
var $hfD9S = parcelRequire("hfD9S");

var $ew3Bn = parcelRequire("ew3Bn");

var $7Guod = parcelRequire("7Guod");

var $cz6zo = parcelRequire("cz6zo");
var $gHT3x = parcelRequire("gHT3x");

var $4oTiM = parcelRequire("4oTiM");

var $WVSzu = parcelRequire("WVSzu");

var $3wR8f = parcelRequire("3wR8f");

var $3nV5N = parcelRequire("3nV5N");
parcelRequire("5MfFQ");
var $aXskD = parcelRequire("aXskD");

var $eyafN = parcelRequire("eyafN");
const $f4a5e8bc0f045f6c$var$VirtualServiceAgentButton = ({ onClick: onClick, label: label, isChatSideBarOpen: isChatSideBarOpen })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: (0, $748yq.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $gHT3x.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aXskD.default), {
        customStyles: isChatSideBarOpen ? {
            borderColor: "var(--ds-border-focused, #0C66E4)",
            borderWidth: "var(--ds-border-width, 1px)",
            color: "var(--ds-text-accent-blue, #0C66E4)" // this is for the icon color
        } : {},
        label: label,
        textColor: isChatSideBarOpen ? 'color.text.accent.blue' : undefined,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Guod))), {
            label: formatMessage((0, $eyafN.default).virtualServiceAgent)
        }),
        onClick: onClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
};
const $f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderForPortal = ({ cloudId: cloudId, portalId: portalId, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBar, closeChatSideBar: closeChatSideBar, isProjectAdmin: isProjectAdmin })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [{ route: route }] = (0, $hfD9S.useRouter)();
    const { isVirtualAgentEnabled: isVirtualAgentAvailableForProject } = (0, $3nV5N.useVirtualAgentAvailability)({
        cloudId: cloudId,
        projectId: projectId,
        isLoggedIn: true // this component has a check to only show for logged in users
    });
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $gHT3x.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentChatButton',
            attributes: {
                source: 'portal'
            }
        }).fire();
        if ((0, $bG6ob.isVsaAdoptionPortalChatSideBarEnabled)() && route.name === 'portal-home' && !isProjectAdmin) {
            if (isChatSideBarOpen) closeChatSideBar === null || closeChatSideBar === void 0 || closeChatSideBar();
            else openChatSideBar === null || openChatSideBar === void 0 || openChatSideBar();
        } else (0, $3wR8f.default).push(`/portal/${portalId}/conversation`);
    };
    if (isVirtualAgentAvailableForProject && (0, $bG6ob.isVsaAdoptionHeaderChatButtonEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: (0, $748yq.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $gHT3x.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f4a5e8bc0f045f6c$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $eyafN.default).chat),
        isChatSideBarOpen: isChatSideBarOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
    return null;
};
const $f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderForHelpCenter = ({ cloudId: cloudId })=>{
    var _virtualAgentEnabledD, _virtualAgentEnabledD2;
    const helpCenterAri = (0, $6mmHn.getHelpCenterAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const virtualAgentEnabledData = (0, $gIeP2.useLazyLoadQuery)((0, $8Y01c.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const isVirtualAgentEnabled = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD = virtualAgentEnabledData.helpCenter) === null || _virtualAgentEnabledD === void 0 || (_virtualAgentEnabledD = _virtualAgentEnabledD.helpCenterById) === null || _virtualAgentEnabledD === void 0 ? void 0 : _virtualAgentEnabledD.__typename) === 'HelpCenter' && virtualAgentEnabledData.helpCenter.helpCenterById.virtualAgentEnabled;
    const isVirtualAgentAvailable = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD2 = virtualAgentEnabledData.virtualAgent) === null || _virtualAgentEnabledD2 === void 0 ? void 0 : _virtualAgentEnabledD2.virtualAgentAvailability) ?? false;
    const isHelpSeekerWithVSAEnabled = (0, $bG6ob.isVsaAdoptionHeaderChatButtonEnabled)() && isVirtualAgentAvailable && isVirtualAgentEnabled;
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $gHT3x.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentChatButton',
            attributes: {
                source: 'help-center'
            }
        }).fire();
        (0, $3wR8f.default).push(`/conversation`);
    };
    if (isHelpSeekerWithVSAEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: (0, $748yq.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $gHT3x.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f4a5e8bc0f045f6c$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $eyafN.default).chat)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
    return null;
};
const $f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderForAdmin = ({ cloudId: cloudId, isJiraAdmin: isJiraAdmin })=>{
    var _virtualAgentEnabledD3;
    const helpCenterAri = (0, $6mmHn.getHelpCenterAri)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const virtualAgentEnabledData = (0, $gIeP2.useLazyLoadQuery)((0, $29z3m.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const isVirtualAgentEnabled = (virtualAgentEnabledData === null || virtualAgentEnabledData === void 0 || (_virtualAgentEnabledD3 = virtualAgentEnabledData.helpCenter) === null || _virtualAgentEnabledD3 === void 0 || (_virtualAgentEnabledD3 = _virtualAgentEnabledD3.helpCenterById) === null || _virtualAgentEnabledD3 === void 0 ? void 0 : _virtualAgentEnabledD3.__typename) === 'HelpCenter' && virtualAgentEnabledData.helpCenter.helpCenterById.virtualAgentEnabled;
    const adminWithoutVSAEnabled = isJiraAdmin && !isVirtualAgentEnabled && (0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
    const handleVirtualAgentMenuClick = ()=>{
        createAnalyticsEvent({
            analyticsType: (0, $gHT3x.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'virtualServiceAgentButton',
            attributes: {
                source: 'admin'
            }
        }).fire();
        const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse(helpCenterAri);
        window.location.href = `${window.location.origin}${0, $748yq.HELP_CENTERS_MANAGEMENT_BASE_PATH}/${helpCenterId}/virtual-agent`;
    };
    if (adminWithoutVSAEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: (0, $748yq.ScreenName).VIRTUAL_SERVICE_AGENT_HEADER,
        sourceType: (0, $gHT3x.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f4a5e8bc0f045f6c$var$VirtualServiceAgentButton, {
        onClick: handleVirtualAgentMenuClick,
        label: formatMessage((0, $eyafN.default).virtualServiceAgent)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
    return null;
};
const $f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderDumbWrapper = ({ isJiraAdmin: isJiraAdmin, projectId: projectId, isChatSideBarOpen: isChatSideBarOpen, openChatSideBar: openChatSideBar, closeChatSideBar: closeChatSideBar, isProjectAdmin: isProjectAdmin })=>{
    const cloudId = (0, $6mmHn.getCloudId)();
    const [portalId] = (0, $eDygx.usePathParam)('portalId');
    if ((0, $bG6ob.isHideVsaEndpointsEnabled)()) return null;
    if (isJiraAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderForAdmin, {
        cloudId: cloudId,
        isJiraAdmin: true
    });
    // at this point all the users are help seekers and are logged in
    // we have no special checks for project admins, they continue to see the button in the header just like help seekers would
    if (portalId) {
        // this is different that portalId && projectId because we don't want to render the
        // button for a help seeker in portal if projectId is not present
        // if we do && it would get into the the help center header
        // we want it to explicitly render null if projectId is not present but portalId is present
        // better to not render anything in this case than to render the button that redirects to the help center conversation page
        if (projectId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderForPortal, {
            cloudId: cloudId,
            portalId: portalId,
            projectId: projectId,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBar,
            closeChatSideBar: closeChatSideBar,
            isProjectAdmin: isProjectAdmin
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderForHelpCenter, {
        cloudId: cloudId
    });
};
var $f4a5e8bc0f045f6c$export$2e2bcd8739ae039 = $f4a5e8bc0f045f6c$var$VirtualServiceAgentHeaderDumbWrapper;

});
parcelRegister("29z3m", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d412a4397ebedca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c90bbc512e8be1204d2829ae63d46af6>>
 * @relayHash c5303cbd99f5030deeec59f886b004b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8306c73b12cbb2fd42063f0cdc6ebda1c4dc6066b8a39cfe989704e07c87159a
const $7d412a4397ebedca$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8306c73b12cbb2fd42063f0cdc6ebda1c4dc6066b8a39cfe989704e07c87159a",
            "metadata": {},
            "name": "virtualServiceAgentHeaderDumbAdminQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7d412a4397ebedca$var$node.hash = "df656a96c8dae6a7e885b60eda19f0f6";
var $7d412a4397ebedca$export$2e2bcd8739ae039 = $7d412a4397ebedca$var$node;

});

parcelRegister("8Y01c", function(module, exports) {
$parcel$export(module.exports, "default", () => $c862f1756d519254$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bba8f04573f8cc2476ac20fe7544388b>>
 * @relayHash 75458db796a70398a51779635b8c2433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e
const $c862f1756d519254$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "concreteType": "VirtualAgentQueryApi",
        "kind": "LinkedField",
        "name": "virtualAgent",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "containerId",
                        "variableName": "helpCenterAri"
                    }
                ],
                "kind": "ScalarField",
                "name": "virtualAgentAvailability"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v5 /*: any*/ 
            ]
        },
        "params": {
            "id": "25f1b41bf2ec626b2ef8a3ffd2c0b9de551e7d64a42397225ada96dd8440972e",
            "metadata": {},
            "name": "virtualServiceAgentHeaderDumbHelpCenterQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c862f1756d519254$var$node.hash = "e1e97ac63a001c8e98b3e9b2c21c9fc4";
var $c862f1756d519254$export$2e2bcd8739ae039 = $c862f1756d519254$var$node;

});

parcelRegister("cz6zo", function(module, exports) {
$parcel$export(module.exports, "ContextWrapper", () => $f172b701258245b7$export$34282a1f95511a11);

var $4fqPo = parcelRequire("4fqPo");

var $esuIC = parcelRequire("esuIC");

var $4CTsu = parcelRequire("4CTsu");

var $fFB0R = parcelRequire("fFB0R");
const $f172b701258245b7$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4CTsu)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($esuIC))));
};
const $f172b701258245b7$export$34282a1f95511a11 = (props)=>{
    const data = $f172b701258245b7$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, props.children));
};

});

parcelRegister("eyafN", function(module, exports) {
$parcel$export(module.exports, "default", () => $81889140a9c6a536$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $81889140a9c6a536$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    virtualServiceAgent: {
        defaultMessage: 'Virtual service agent',
        description: 'Text message for virtual service agent header button',
        id: 'virtual-service-agent-header.virtual-service-agent.title'
    },
    chat: {
        defaultMessage: 'Chat',
        description: 'Text message for chat header button',
        id: 'virtual-service-agent-header.chat.title'
    }
});

});





parcelRegister("K1VQU", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5d16f3f0f22f9b1$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $a5d16f3f0f22f9b1$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    login: {
        defaultMessage: 'Log in',
        description: 'Text message for header in Customer Portal when a user is not logged in',
        id: 'cv.login.title'
    },
    helpCenter: {
        defaultMessage: 'Help Center',
        description: 'Text message for header in Customer Portal when a user is logged in',
        id: 'cv.help.center.title'
    }
});

});





parcelRegister("8zo3m", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => (parcelRequire("f1dKT")).default);

var $f1dKT = parcelRequire("f1dKT");

});
parcelRegister("f1dKT", function(module, exports) {
$parcel$export(module.exports, "default", () => $04b30bef993df60c$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $f4IfF = parcelRequire("f4IfF");

var $5eCdR = parcelRequire("5eCdR");

var $3dLJl = parcelRequire("3dLJl");

var $k16VK = parcelRequire("k16VK");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $jnk5P = parcelRequire("jnk5P");
const $04b30bef993df60c$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getHelpCenterBrandingLoader), (0, $2hx7o.isUserLoaded), (isBrandingLoaded, userLoaded)=>({
        isBrandingLoaded: isBrandingLoaded,
        isUserLoaded: userLoaded
    }));
var $04b30bef993df60c$export$2e2bcd8739ae039 = (0, $bmgw6.default)($04b30bef993df60c$var$selector, {
    fetchBranding: (0, $5eCdR.fetchHelpCenterBrandingAction),
    fetchUser: (0, $f4IfF.fetchUserModelAction),
    fetchOrganisations: (0, $3dLJl.fetchOrganisationsModelAction),
    fetchUserRequestsCounts: (0, $k16VK.fetchUserRequestsCountsAction)
})((0, $jnk5P.PrefetchBrandingModel));

});
parcelRegister("jnk5P", function(module, exports) {
$parcel$export(module.exports, "PrefetchBrandingModel", () => $8fa00e3b2e127475$export$f08bae07abcc5a9d);

var $4fqPo = parcelRequire("4fqPo");

var $eSL4S = parcelRequire("eSL4S");
class $8fa00e3b2e127475$export$f08bae07abcc5a9d extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidMount() {
        if (!(0, $eSL4S.isHelpCentersManagement)() && !this.props.isBrandingLoaded) this.props.fetchBranding();
        if (!this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchOrganisations();
            this.props.fetchUserRequestsCounts();
        }
    }
    componentDidUpdate(prevProps) {
        // If we haven't loaded the user yet and we've moved from an
        // anonymous route to a normal route, go fetch the user.
        if (!this.props.isUserLoaded && prevProps.isAnonymous && !this.props.isAnonymous) {
            this.props.fetchUser();
            this.props.fetchUserRequestsCounts();
        }
    }
    render() {
        return null;
    }
}

});





parcelRegister("bYk9e", function(module, exports) {
$parcel$export(module.exports, "AnnouncementBanner", () => (parcelRequire("hVqlO")).default);

var $hVqlO = parcelRequire("hVqlO");

});
parcelRegister("hVqlO", function(module, exports) {
$parcel$export(module.exports, "default", () => $54b2790c7cfe275f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $el3DQ = parcelRequire("el3DQ");

var $dLWpD = parcelRequire("dLWpD");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("b0F8E");
var $awGaB = parcelRequire("awGaB");

var $6bGmX = parcelRequire("6bGmX");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $cijxS = parcelRequire("cijxS");

var $hzxL3 = parcelRequire("hzxL3");
const $54b2790c7cfe275f$var$Announcement = ({ announcement: announcement, hasTopBarBeenSplit: hasTopBarBeenSplit, isPortalLoaded: isPortalLoaded, appearance: contentAppearance })=>{
    const [{ route: route }] = (0, $hfD9S.useRouter)();
    const { name: name } = route;
    const whiteListedRouteNames = [
        'portal-home',
        'request-create'
    ];
    const AnnouncementInnerContainerDeprecated = /*#__PURE__*/ (0, $4fqPo.memo)(({ children: children })=>{
        const hide = contentAppearance === 'none';
        const appearance = contentAppearance || 'normal';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hzxL3.GridContentWrapper), {
            appearance: appearance,
            hide: hide
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($54b2790c7cfe275f$var$PaperInnerContainer, {
            "data-testid": "paper-inner-container"
        }, children));
    });
    AnnouncementInnerContainerDeprecated.displayName = 'AnnouncementInnerContainer';
    const AnnouncementInnerContainer = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        const Component = ({ children: children })=>{
            const hide = contentAppearance === 'none';
            const appearance = contentAppearance || 'normal';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hzxL3.GridContentWrapper), {
                appearance: appearance,
                hide: hide
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($54b2790c7cfe275f$var$PaperInnerContainer, {
                "data-testid": "paper-inner-container"
            }, children));
        };
        Component.displayName = 'AnnouncementInnerContainer';
        return Component;
    }, [
        contentAppearance
    ]);
    if ((0, $bG6ob.isIncreasedFlexibilityEnabled)() && hasTopBarBeenSplit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && (0, $6bGmX.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $54b2790c7cfe275f$var$announcementContainer,
        testId: 'increased-flexibility-container'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dLWpD.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $6bGmX.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, !isPortalLoaded && !announcement && whiteListedRouteNames.includes(name) && (0, $6bGmX.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: "grid-announcement-banner-loading"
    }), !!announcement && whiteListedRouteNames.includes(name) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dLWpD.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: (0, $6bGmX.default).checkGate('help_center_ttvc_hydration_resolve') ? AnnouncementInnerContainer : AnnouncementInnerContainerDeprecated
    }));
};
const $54b2790c7cfe275f$var$selector = (0, $3yyCx.createSelector)((state)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    const portal = (0, $95tqy.getPortal)(state, portalId);
    const announcement = (0, $95tqy.getPortalAnnouncement)(state, portalId);
    return {
        announcement: announcement,
        isPortalLoaded: Boolean(portal)
    };
}, (0, $i8gmD.getHelpCenterTopBarSplitFlag), ({ announcement: announcement, isPortalLoaded: isPortalLoaded }, hasTopBarBeenSplit)=>{
    return {
        announcement: announcement,
        hasTopBarBeenSplit: hasTopBarBeenSplit,
        isPortalLoaded: isPortalLoaded
    };
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $54b2790c7cfe275f$var$PaperInnerContainer = /*#__PURE__*/ (0, $el3DQ.default)((0, $awGaB.PaperContent)).withConfig({
    componentId: "sc-117mmoe-0"
})({
    paddingTop: 0
});
const $54b2790c7cfe275f$var$announcementContainer = (0, $2m8U6.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100',
    marginLeft: 'space.400',
    marginRight: 'space.400',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    // make sure extra margin is not added in case announcement is not present
    ':empty': {
        display: 'none'
    }
});
var $54b2790c7cfe275f$export$2e2bcd8739ae039 = (0, $bmgw6.default)($54b2790c7cfe275f$var$selector)($54b2790c7cfe275f$var$Announcement);

});
parcelRegister("dLWpD", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c8c512db227172e$export$2e2bcd8739ae039);

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $73iwv = parcelRequire("73iwv");
var $8c8c512db227172e$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    componentName: 'banner'
})((0, $as4kh.default)()((0, $73iwv.default)));

});
parcelRegister("73iwv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7cf52076c8285b5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bpWyP = parcelRequire("bpWyP");

var $54jwS = parcelRequire("54jwS");

var $lh2vS = parcelRequire("lh2vS");

var $7gcjp = parcelRequire("7gcjp");
/**
 * This is used for the clamping logic inside the announcement.
 * It is VERY brittle and WILL break if you change font-size/line-height
 * inside the announcement. Watch out!
 */ const $b7cf52076c8285b5$var$SINGLE_LINE_TITLE_HEIGHT = 23;
/**
 * This component will have big problems if/when we do SSR. Be careful out there.
 */ class $b7cf52076c8285b5$var$AnnouncementBanner extends $4fqPo.Component {
    static #_ = this.defaultProps = {
        InnerContainerComponent: $4fqPo.Fragment
    };
    componentDidMount() {
        // On mount we will calculate the height of the header/message and set isExpandable accordingly.
        // This will only be set once (on mount) - if we eventually want to dynamically update this we
        // will want to implement a componentDidUpdate() method, check if header/message changed, and
        // recalculate.
        this.calculateIfExpandable();
    }
    fireAnalytics(action) {
        const { createAnalyticsEvent: createAnalyticsEvent, actionSubjectId: actionSubjectId } = this.props;
        const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
        if (createAnalyticsEvent) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubjectId: actionSubjectId,
                action: action,
                analyticsType: (0, $54jwS.UI_EVENT_TYPE),
                attributes: {
                    messageCharCount: messageCharCount,
                    titleCharCount: headerCharCount
                }
            });
            analyticsEvent.fire();
        }
    }
    calculateIfExpandable() {
        let isExpandable = false;
        // If advanced customization is enabled and the layout is in edit mode, the banner should not be expandable.
        if (this.props.isLayoutInEditMode) {
            this.setState({
                isExpandable: false,
                isExpanded: true
            });
            return;
        }
        if (this.headerRef || this.messageRef) {
            const headerHeight = this.headerRef && (0, $lh2vS.getBoundingBox)(this.headerRef).height || 0;
            const messageHeight = this.messageRef && (0, $lh2vS.getBoundingBox)(this.messageRef).height || 0;
            const headerOverOneLine = headerHeight > $b7cf52076c8285b5$var$SINGLE_LINE_TITLE_HEIGHT;
            const messageOverOneLine = messageHeight > (0, $bpWyP.SINGLE_LINE_PARAGRAPH_HEIGHT);
            isExpandable = headerOverOneLine || messageOverOneLine;
        }
        // The announcement banner is expanded by default.
        this.setState({
            isExpandable: isExpandable,
            isExpanded: true
        });
    }
    render() {
        const { header: header, messageHtml: messageHtml, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isLayoutInEditMode: isLayoutInEditMode, isLayoutInPreviewMode: isLayoutInPreviewMode, removePadding: removePadding } = this.props;
        const { isExpanded: isExpanded, isExpandable: isExpandable } = this.state;
        return /*#__PURE__*/ $4fqPo.createElement((0, $7gcjp.default), {
            header: header,
            isExpanded: isExpanded,
            isExpandable: isExpandable,
            messageHtml: messageHtml,
            onHeaderRef: this.onHeaderRef,
            onMessageRef: this.onMessageRef,
            expandBanner: this.expandBanner,
            shrinkBanner: this.collapseBanner,
            InnerContainerComponent: InnerContainerComponent,
            removeBgColor: removeBgColor,
            isCursorGrab: isLayoutInEditMode && isLayoutInPreviewMode === false,
            removePadding: removePadding
        });
    }
    constructor(...args){
        super(...args), this.state = {
            // We expand the announcement banner initially so we can calculate if it is expandable or not on mount.
            isExpanded: true,
            isExpandable: false
        }, this.onHeaderRef = (refNode)=>{
            this.headerRef = refNode;
            this.calculateIfExpandable();
        }, this.onMessageRef = (refNode)=>{
            this.messageRef = refNode;
            this.calculateIfExpandable();
        }, this.expandBanner = ()=>{
            const { onExpandClicked: onExpandClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onExpandClicked && onExpandClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('expanded');
            this.setState({
                isExpanded: true
            });
        }, this.collapseBanner = ()=>{
            const { onCollapseClicked: onCollapseClicked } = this.props;
            const { headerCharCount: headerCharCount, messageCharCount: messageCharCount } = this.getAnnouncementCharCounts();
            onCollapseClicked && onCollapseClicked(headerCharCount, messageCharCount);
            this.fireAnalytics('collapsed');
            this.setState({
                isExpanded: false
            });
        }, /**
   * This will return char counts for the header and message. It uses inner text so it can ignore
   * HTML markup in the calculation.
   */ this.getAnnouncementCharCounts = ()=>{
            const headerCharCount = this.headerRef && this.headerRef.innerText ? this.headerRef.innerText.length : undefined;
            const messageCharCount = this.messageRef && this.messageRef.innerText ? this.messageRef.innerText.length : undefined;
            return {
                headerCharCount: headerCharCount,
                messageCharCount: messageCharCount
            };
        };
    }
}
var $b7cf52076c8285b5$export$2e2bcd8739ae039 = $b7cf52076c8285b5$var$AnnouncementBanner;

});
parcelRegister("lh2vS", function(module, exports) {
$parcel$export(module.exports, "getBoundingBox", () => $d98af2e5c1fa6a45$export$895c5e634403eaa7);
$parcel$export(module.exports, "getElementHeight", () => $d98af2e5c1fa6a45$export$8e0f1520ce23a388);
$parcel$export(module.exports, "blur", () => $d98af2e5c1fa6a45$export$2cc7ff91bcacba5e);
$parcel$export(module.exports, "focus", () => $d98af2e5c1fa6a45$export$d7ddd398f22d79ef);
const $d98af2e5c1fa6a45$export$895c5e634403eaa7 = (element)=>element.getBoundingClientRect();
const $d98af2e5c1fa6a45$export$8e0f1520ce23a388 = (element)=>element.clientHeight;
function $d98af2e5c1fa6a45$export$2cc7ff91bcacba5e(id) {
    const element = document.getElementById(id);
    if (element) element.blur();
}
function $d98af2e5c1fa6a45$export$d7ddd398f22d79ef(id) {
    const element = document.getElementById(id);
    if (element) element.focus();
}

});

parcelRegister("7gcjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $087d28bf5faae66b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eAfqk = parcelRequire("eAfqk");

var $2xGi5 = parcelRequire("2xGi5");

var $4W9tu = parcelRequire("4W9tu");

var $iSWaE = parcelRequire("iSWaE");

var $brRRh = parcelRequire("brRRh");

var $efDRU = parcelRequire("efDRU");

var $cTq8x = parcelRequire("cTq8x");

var $aO0yS = parcelRequire("aO0yS");

var $53KkL = parcelRequire("53KkL");
class $087d28bf5faae66b$export$76695f5f5a9db4b2 extends $4fqPo.Component {
    renderChevrons() {
        const { isExpandable: isExpandable, isExpanded: isExpanded, intl: intl } = this.props;
        if (isExpandable) return /*#__PURE__*/ $4fqPo.createElement($087d28bf5faae66b$export$281662cd1c27e560, {
            type: "button",
            "aria-expanded": isExpanded,
            "aria-controls": "announcement-message",
            "aria-label": intl.formatMessage((0, $53KkL.default).view),
            onClick: this.handleClick,
            "data-testid": "view-announcement-btn"
        }, isExpanded ? /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aO0yS))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronUpIcon",
            label: ""
        }) : /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
            size: "small",
            spacing: "spacious",
            testId: "chevronDownIcon",
            label: ""
        }));
        return null;
    }
    render() {
        const { isExpanded: isExpanded, header: header, messageHtml: messageHtml, onMessageRef: onMessageRef, onHeaderRef: onHeaderRef, className: className, InnerContainerComponent: InnerContainerComponent, removeBgColor: removeBgColor, isCursorGrab: isCursorGrab, removePadding: removePadding } = this.props;
        const rootProps = {
            role: 'region',
            'aria-labelledby': 'announcement-header',
            skipFocus: true
        };
        if (!!header || !!messageHtml) return /*#__PURE__*/ $4fqPo.createElement($087d28bf5faae66b$export$be92b6f5f03c0fe9, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            removeBgColor: removeBgColor,
            isExpanded: isExpanded,
            isCursorGrab: isCursorGrab,
            ...rootProps
        }, /*#__PURE__*/ $4fqPo.createElement(InnerContainerComponent, null, /*#__PURE__*/ $4fqPo.createElement($087d28bf5faae66b$var$Container, {
            removePadding: removePadding
        }, /*#__PURE__*/ $4fqPo.createElement($087d28bf5faae66b$export$758c5636f09cf302, {
            onClick: this.stopPropagationForLinks,
            onKeyDown: this.stopPropagationForLinks
        }, header && /*#__PURE__*/ $4fqPo.createElement($087d28bf5faae66b$export$f99233281efd08a0, {
            id: "announcement-header",
            "data-testid": "announcement-banner-header",
            innerRef: onHeaderRef,
            isExpanded: isExpanded
        }, header), messageHtml && /*#__PURE__*/ $4fqPo.createElement($087d28bf5faae66b$export$f69c19e57285b83a, {
            id: "announcement-message",
            innerRef: onMessageRef,
            isExpanded: isExpanded,
            dangerouslySetInnerHTML: {
                __html: messageHtml
            }
        })), this.renderChevrons())));
        return null;
    }
    constructor(...args){
        super(...args), this.handleClick = ()=>{
            const { isExpanded: isExpanded, shrinkBanner: shrinkBanner, expandBanner: expandBanner } = this.props;
            isExpanded ? shrinkBanner() : expandBanner();
        }, /**
   * This will stop propagation for any anchor element clicked or key pressed.
   * If we see a need for this elsewhere - this could be a good generic component with minimal lines
   * of code.
   */ this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') e.stopPropagation();
        };
    }
}
var $087d28bf5faae66b$export$2e2bcd8739ae039 = (0, $efDRU.default)($087d28bf5faae66b$export$76695f5f5a9db4b2);
/**
 * Watch out! Changing anything that will affect height (fontsize, padding, etc) in here will
 * break the clamping logic inside announcement-banner.tsx (look for SINGLE_LINE_TITLE_HEIGHT).
 * If you change anything here make sure it still works!
 */ // eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $087d28bf5faae66b$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-sxf8hv-0"
})`display:flex;justify-content:space-between;padding-top:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};padding-bottom:${(props)=>props.removePadding ? 'initial' : "var(--ds-space-300, 24px)"};`;
const $087d28bf5faae66b$export$f2e4196c0d2b5bb8 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-sxf8hv-1"
})`flex-shrink:0;${$2xGi5.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut},${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};border-radius:50%;}`;
const $087d28bf5faae66b$export$281662cd1c27e560 = /*#__PURE__*/ (0, $el3DQ.default).button.withConfig({
    componentId: "sc-sxf8hv-2"
})`flex-shrink:0;border:none;background:transparent;align-self:flex-start;cursor:pointer;${$2xGi5.fromSmall.css`
        /* Apply margin from mobile, when on a small viewport we want a bit of padding between the right edge and the icon. */
        margin-left: ${"var(--ds-space-100, 8px)"};
    `};svg{transition:background-color ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut},${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};border-radius:50%;}&:focus-visible,&:hover{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $087d28bf5faae66b$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $el3DQ.default)((0, $eAfqk.default)).withConfig({
    componentId: "sc-sxf8hv-3"
})`${$iSWaE.borderRadius};${(props)=>$iSWaE.applyIf(!props.removeBgColor, $iSWaE.subtleThemeColorBackground)};${$4W9tu.regular};display:block;width:100%;text-align:left;transition:color ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};color:${"var(--ds-text, #172B4D)"};box-sizing:border-box;overflow:hidden;&:focus-visible,&:hover ${$087d28bf5faae66b$export$f2e4196c0d2b5bb8}{svg{background-color:${"var(--ds-background-input, #172B4D)"};color:${"var(--ds-text-inverse, #FFFFFF)"};opacity:0.7;}}`;
const $087d28bf5faae66b$export$f99233281efd08a0 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-sxf8hv-4"
})`${$4W9tu.medium};${(props)=>$iSWaE.applyIf(!props.isExpanded, $iSWaE.clamp)};margin-bottom:${"var(--ds-space-100, 8px)"};font-weight:600;`;
const $087d28bf5faae66b$export$f69c19e57285b83a = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-sxf8hv-5"
})`${(props)=>$iSWaE.applyIf(!props.isExpanded, $iSWaE.multiLineClamp(1))}`;
const $087d28bf5faae66b$export$758c5636f09cf302 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-sxf8hv-6"
})`display:flex;flex-direction:column;width:100%;overflow:hidden;flex-shrink:0;`;

});
parcelRegister("eAfqk", function(module, exports) {
$parcel$export(module.exports, "default", () => $51660b36e37d5860$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4wUcz = parcelRequire("4wUcz");
class $51660b36e37d5860$export$2e2bcd8739ae039 extends $4fqPo.Component {
    render() {
        const { children: children, disabled: disabled, isExpanded: isExpanded, isCursorGrab: isCursorGrab, role: role, skipFocus: skipFocus, className: className = '' } = this.props;
        const skipFocusStyle = skipFocus ? ' no-focus' : '';
        const fakeBtnClassName = className + skipFocusStyle;
        return /*#__PURE__*/ $4fqPo.createElement((0, $4wUcz.default), {
            "data-testid": "fake-button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: fakeBtnClassName,
            role: role || 'button',
            tabIndex: disabled || skipFocus ? -1 : 0,
            onClick: this.handleClick,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            "aria-disabled": disabled,
            "aria-hidden": disabled,
            "aria-expanded": isExpanded ? true : false,
            isCursorGrab: isCursorGrab
        }, children);
    }
    constructor(...args){
        super(...args), this.stopPropagationForLinks = (e)=>{
            const target = e.target;
            if (target.tagName === 'A') {
                e.stopPropagation();
                return true;
            }
            return false;
        }, this.handleKeyDown = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === 'Enter') onClick && onClick(e);
            else if (e.key === ' ') // Prevent default so scrolling doesn't happen when we press spacebar.
            e.preventDefault();
        }, this.handleClick = (e)=>{
            if (this.stopPropagationForLinks(e)) return;
            this.props.onClick && this.props.onClick(e);
        }, this.handleKeyUp = (e)=>{
            const { onClick: onClick } = this.props;
            if (this.stopPropagationForLinks(e)) return;
            if (e.key === ' ') onClick && onClick(e);
        };
    }
}

});
parcelRegister("4wUcz", function(module, exports) {
$parcel$export(module.exports, "default", () => $3198e1e6f9e10a36$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $iSWaE = parcelRequire("iSWaE");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3198e1e6f9e10a36$var$FakeButtonContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1kveg5f-0"
})`${$iSWaE.focusRing.default};display:inline-block;${(props)=>props.skipFocus ? 'cursor: default' : 'cursor: pointer'};&.no-focus,&[aria-disabled='true']{${$iSWaE.focusRing.none};${(props)=>props.isCursorGrab ? 'cursor: grab' : 'cursor: default'};}`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$3198e1e6f9e10a36$export$2e2bcd8739ae039 = $3198e1e6f9e10a36$var$FakeButtonContainer;

});


parcelRegister("53KkL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e490e5d2f0f47a9d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $e490e5d2f0f47a9d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    expand: {
        defaultMessage: 'Expand announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.expand'
    },
    shrink: {
        defaultMessage: 'Shrink announcement',
        description: 'Label for shrinking the announcement.',
        id: 'sd.common.announcement.shrink'
    },
    view: {
        defaultMessage: 'View announcement',
        description: 'Label for viewing the announcement.',
        id: 'sd.common.announcement.view'
    }
});

});




parcelRegister("hzxL3", function(module, exports) {
$parcel$export(module.exports, "SkipToMainContent", () => $d0b9b8fdddcfed38$export$5a2051bae734c99d);
$parcel$export(module.exports, "GridContentWrapper", () => $d0b9b8fdddcfed38$export$2e1fb94eeb76eca0);
$parcel$export(module.exports, "default", () => $d0b9b8fdddcfed38$export$2e2bcd8739ae039);
/* grid-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $3H4LK = parcelRequire("3H4LK");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $2m8U6 = parcelRequire("2m8U6");
parcelRequire("4r1vU");
var $9OTKp = parcelRequire("9OTKp");

var $awGaB = parcelRequire("awGaB");

var $fFlza = parcelRequire("fFlza");
const $d0b9b8fdddcfed38$export$5a2051bae734c99d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9OTKp.MainContentSkipLinkWrapper), null, (0, $3H4LK.fg)('do_not_use_banner_colour_for_hyperlinks') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "skip-to-main-content",
        xcss: $d0b9b8fdddcfed38$var$mainContentSkipLinkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            "_43ds1ohs _oxk41ohs"
        ])
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "skip-to-main-content",
        xcss: $d0b9b8fdddcfed38$var$mainContentSkipLinkStyles
    }, children));
const $d0b9b8fdddcfed38$export$2e1fb94eeb76eca0 = ({ children: children, appearance: appearance, hide: hide })=>{
    const gridWidth = (0, $fFlza.getContentWidth)(appearance);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "grid-content-wrapper",
        xcss: $d0b9b8fdddcfed38$var$staticWrapperStyles,
        style: {
            maxWidth: hide ? '100%' : gridWidth
        }
    }, children);
};
const $d0b9b8fdddcfed38$var$GridContainer = ({ children: children, isCSM: isCSM, hideSkipToMainContent: hideSkipToMainContent, appearance: contentAppearance })=>{
    const hide = contentAppearance === 'none';
    const appearance = contentAppearance || 'normal';
    // A11Y-29321: when enabled, the footer is rendered outside the `<main>` landmark (WCAG 1.3.1).
    // `margin-top: auto` keeps it pinned to the bottom of the flex column.
    const footerOutsideMain = (0, $bG6ob.isJsdFooterOutsideMainLandmarkEnabled)();
    if (appearance === 'note') {
        const noteContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.NoteContent), {
            appearance: appearance,
            hide: hide,
            "data-testid": "note-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.NoteBackground), {
            "data-testid": "note-background"
        }, children), !footerOutsideMain && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.StyledFooter), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $d0b9b8fdddcfed38$var$noteContainerStyles
        }, footerOutsideMain ? // Footer rendered outside the `<main>` note card, pinned to the bottom.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $d0b9b8fdddcfed38$var$noteColumnStyles
        }, noteContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $d0b9b8fdddcfed38$var$footerAtBottomStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.StyledFooter), null))) : noteContent);
    }
    const footer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.StyledFooter), {
        isCSM: isCSM
    });
    const mainAndFooter = footerOutsideMain ? // Footer rendered as a sibling of the `<main>` landmark (outside it), pinned to the bottom.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $d0b9b8fdddcfed38$var$mainColumnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($d0b9b8fdddcfed38$export$5a2051bae734c99d, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $d0b9b8fdddcfed38$var$footerAtBottomStyles
    }, footer)) : // Legacy behaviour: the footer is rendered inside the `<main>` landmark.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($d0b9b8fdddcfed38$export$5a2051bae734c99d, null, children, footer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        as: "section",
        xcss: $d0b9b8fdddcfed38$var$sectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($d0b9b8fdddcfed38$export$2e1fb94eeb76eca0, {
        appearance: appearance,
        hide: hide
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        xcss: $d0b9b8fdddcfed38$var$gridContainerStyles,
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        xcss: $d0b9b8fdddcfed38$var$gridItemStyles
    }, hideSkipToMainContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children, footer) : mainAndFooter))));
};
const $d0b9b8fdddcfed38$var$wrapperStyles = null;
const $d0b9b8fdddcfed38$var$sectionStyles = (0, $2m8U6.xcss)({
    flex: 1
});
const $d0b9b8fdddcfed38$var$staticWrapperStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    margin: '0 auto'
});
const $d0b9b8fdddcfed38$var$gridContainerStyles = (0, $2m8U6.xcss)({
    flex: 1,
    gridTemplateColumns: 'repeat(12, 1fr)'
});
const $d0b9b8fdddcfed38$var$gridItemStyles = (0, $2m8U6.xcss)({
    gridColumn: 'span 12'
});
const $d0b9b8fdddcfed38$var$mainContentSkipLinkStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
// A11Y-29321: flex column holding the `<main>` landmark and the footer as siblings so the footer
// can sit outside `<main>` while staying pinned to the bottom of the page.
const $d0b9b8fdddcfed38$var$mainColumnStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
const $d0b9b8fdddcfed38$var$noteColumnStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    minHeight: '100%'
});
// A11Y-29321: pins the footer to the bottom of the flex column while it sits outside `<main>`.
const $d0b9b8fdddcfed38$var$footerAtBottomStyles = (0, $2m8U6.xcss)({
    marginTop: 'auto'
});
const $d0b9b8fdddcfed38$var$noteContainerStyles = (0, $2m8U6.xcss)({
    position: 'relative',
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});
var $d0b9b8fdddcfed38$export$2e2bcd8739ae039 = $d0b9b8fdddcfed38$var$GridContainer;

});
parcelRegister("fFlza", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $b31cea6ab4358220$export$f61abf052f87399f);
// 800px is normal width
const $b31cea6ab4358220$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $b31cea6ab4358220$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $b31cea6ab4358220$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $b31cea6ab4358220$var$GRID_XXWIDE_WIDTH = '1200px';
const $b31cea6ab4358220$var$GRID_NOTE_WIDTH = '480px';
const $b31cea6ab4358220$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $b31cea6ab4358220$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $b31cea6ab4358220$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $b31cea6ab4358220$var$GRID_WIDE_WIDTH;
        case 'note':
            return $b31cea6ab4358220$var$GRID_NOTE_WIDTH;
        default:
            return $b31cea6ab4358220$var$GRID_NORMAL_WIDTH;
    }
};

});




parcelRegister("fbqkx", function(module, exports) {
$parcel$export(module.exports, "GridContainer", () => (parcelRequire("hzxL3")).default);
$parcel$export(module.exports, "SkipToMainContent", () => (parcelRequire("hzxL3")).SkipToMainContent);

var $hzxL3 = parcelRequire("hzxL3");

});



parcelRegister("951Ke", function(module, exports) {
$parcel$export(module.exports, "BannerWithPaperLayoutDumb", () => (parcelRequire("dxTw2")).default);

var $dxTw2 = parcelRequire("dxTw2");

});
parcelRegister("dxTw2", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ba4ddd30b1f1200$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $fVQGu = parcelRequire("fVQGu");

var $dXHSc = parcelRequire("dXHSc");
parcelRequire("6uBMs");
var $93uvS = parcelRequire("93uvS");
parcelRequire("9im5N");
var $hvxv7 = parcelRequire("hvxv7");
parcelRequire("7BEQF");
var $1gHGC = parcelRequire("1gHGC");

var $5Kpwp = parcelRequire("5Kpwp");
parcelRequire("eSizR");
var $aOk5W = parcelRequire("aOk5W");
parcelRequire("b0F8E");
var $37N7U = parcelRequire("37N7U");
parcelRequire("8zo3m");
var $f1dKT = parcelRequire("f1dKT");

var $7zOGv = parcelRequire("7zOGv");

var $fNSBJ = parcelRequire("fNSBJ");
var $iHhPj = parcelRequire("iHhPj");

var $cijxS = parcelRequire("cijxS");

var $eSL4S = parcelRequire("eSL4S");
const $3ba4ddd30b1f1200$var$PageLayoutContentWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iHhPj.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fNSBJ.default), null, children));
/**
 * Paper in this context is the floating paper that is ontop of the banner.
 * Banner will have the background image chosen by the admin as well as the
 * theme color as background color.
 */ const $3ba4ddd30b1f1200$var$BannerWithPaperLayoutDumb = ({ children: children, paperAppearance: paperAppearance, isAnonymous: isAnonymous, removeHeader: removeHeader, headerless: headerless, hideSearchButton: hideSearchButton, helpCenterBanner: helpCenterBanner, path: path, searchShown: searchShown, isBrandingLoaded: isBrandingLoaded, prefetchBrandingModel: prefetchBrandingModel, hideBanner: hideBanner, isCSM: isCSM })=>{
    const showBannerWithLoader = ()=>{
        if (isBrandingLoaded) return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$Banner, {
            imageSrc: helpCenterBanner
        });
        return !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "banner-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$LoadingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVQGu.LoadingSkeleton), {
            "data-testid": "banner-skeleton",
            height: (0, $5Kpwp.BANNER_HEIGHT).unitless,
            backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$PageLayoutContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$SidebarPusherRoot, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$export$36525627ce333d44, {
        flipKey: searchShown,
        portalKey: "search"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93uvS.default), {
        className: "px-paper-layout"
    }), (0, $eSL4S.isKoshEnabledForDefaultHelpCenter)() ? showBannerWithLoader() : !hideBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$Banner, {
        imageSrc: helpCenterBanner
    }), prefetchBrandingModel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f1dKT.default), {
        isAnonymous: isAnonymous
    }) : null, !removeHeader && !headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aOk5W.default), {
        isAnonymous: isAnonymous,
        logoTextColor: "banner",
        hideSearchButton: hideSearchButton,
        showThemedBackground: false,
        isModelCallPrefetched: prefetchBrandingModel
    }), !removeHeader && headerless && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$EmptyHeader, {
        "data-testid": "empty-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ba4ddd30b1f1200$var$PaperContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $37N7U.default), {
        appearance: paperAppearance,
        pageKey: path,
        isCSM: isCSM
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7zOGv.AutoHeightBody), null)))));
};
var $3ba4ddd30b1f1200$export$2e2bcd8739ae039 = $3ba4ddd30b1f1200$var$BannerWithPaperLayoutDumb;
const $3ba4ddd30b1f1200$var$CONTAINER_MIN_HEIGHT = '100vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ba4ddd30b1f1200$var$SidebarPusherRoot = /*#__PURE__*/ (0, $el3DQ.default)((0, $1gHGC.default)).withConfig({
    componentId: "sc-ku2ur3-0"
})`display:flex;flex-direction:column;width:100%;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ba4ddd30b1f1200$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ku2ur3-1"
})`position:relative;overflow-x:hidden;display:flex;flex-direction:column;min-height:${$3ba4ddd30b1f1200$var$CONTAINER_MIN_HEIGHT};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ba4ddd30b1f1200$var$PaperContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ku2ur3-2"
})`position:relative;display:flex;flex:1 1 auto;overflow:hidden;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ba4ddd30b1f1200$var$Banner = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ku2ur3-3"
})`position:absolute;top:0;left:0;right:0;height:${(0, $5Kpwp.BANNER_HEIGHT).px};z-index:${$dXHSc.banner};background-color:${(props)=>`var(--ds-background-brand-bold, ${props.theme.color})`};background-image:${(props)=>!!props.imageSrc ? `url(${props.imageSrc})` : 'none'};background-size:cover;background-repeat:no-repeat;background-position:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ba4ddd30b1f1200$var$LoadingContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ku2ur3-4"
})`position:absolute;top:0;left:0;right:0;height:${(0, $5Kpwp.BANNER_HEIGHT).px};z-index:${$dXHSc.banner};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $3ba4ddd30b1f1200$var$EmptyHeader = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ku2ur3-5"
})`height:${(0, $5Kpwp.HEADER_HEIGHT)}px;width:100%;`;
const $3ba4ddd30b1f1200$export$36525627ce333d44 = /*#__PURE__*/ (0, $el3DQ.default)((0, $hvxv7.Flipper)).withConfig({
    componentId: "sc-ku2ur3-6"
})`display:flex;flex-direction:column;`;

});


parcelRegister("e2QHY", function(module, exports) {
$parcel$export(module.exports, "withLayoutRoute", () => (parcelRequire("7aI9q")).default);

var $7aI9q = parcelRequire("7aI9q");

});
parcelRegister("7aI9q", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0a6a17a421f3130$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $ibOOf = parcelRequire("ibOOf");

var $4i2V5 = parcelRequire("4i2V5");
parcelRequire("l8iRu");
var $dCuc5 = parcelRequire("dCuc5");
parcelRequire("VQKxQ");
var $6Wtq0 = parcelRequire("6Wtq0");

var $1cuRr = parcelRequire("1cuRr");

var $eHkSG = parcelRequire("eHkSG");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");
parcelRequire("2JItN");
var $gUo1i = parcelRequire("gUo1i");
/**
 * This will return a component which will pass the Layout and children into a <Route />.
 * It will capture all path params and set them into redux, as well as providing them to withPathParams() higher order component.
 * @param Layout Layout component we're wrapping.
 */ function $b0a6a17a421f3130$var$withLayoutRoute(Layout) {
    return class LayoutRoute extends $4fqPo.Component {
        render() {
            const LayoutWithChildren = this.LayoutWithChildren;
            return /*#__PURE__*/ $4fqPo.createElement((0, $dCuc5.RouterSubscriber), null, (routerState)=>{
                return /*#__PURE__*/ $4fqPo.createElement(LayoutWithChildren, routerState);
            });
        }
        constructor(...args){
            super(...args), // Create an instance Component to pass down react router props to ChildrenComponent as well block
            // any extraneous rendering from query params updating.
            this.LayoutWithChildren = (0, $gUo1i.default)((innerRouteProps)=>{
                const { renderError: renderError, layoutProps: layoutProps, path: path, isFooterHidden: isFooterHidden, screenName: screenName, component: ChildrenComponent } = this.props;
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const query = $4i2V5.parse(innerRouteProps.location.search);
                const component = /*#__PURE__*/ $4fqPo.createElement((0, $ibOOf.PathParamsProvider), {
                    params: innerRouteProps.match.params
                }, /*#__PURE__*/ $4fqPo.createElement((0, $1cuRr.OnboardingProvider), {
                    query: query
                }, /*#__PURE__*/ $4fqPo.createElement(Layout, {
                    ...layoutProps,
                    path: path,
                    isFooterHidden: isFooterHidden
                }, /*#__PURE__*/ $4fqPo.createElement((0, $60sOE.default), {
                    screenName: screenName,
                    renderError: renderError
                }, /*#__PURE__*/ $4fqPo.createElement(ChildrenComponent, innerRouteProps)))), /*#__PURE__*/ $4fqPo.createElement((0, $6Wtq0.default), innerRouteProps));
                return screenName ? /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
                    screenName: screenName,
                    screenId: innerRouteProps.match.url
                }, component) : component;
            }, ()=>this.props.reRenderOnQueryParameterChanges || []);
        }
    };
}
var $b0a6a17a421f3130$export$2e2bcd8739ae039 = $b0a6a17a421f3130$var$withLayoutRoute;

});
parcelRegister("VQKxQ", function(module, exports) {
$parcel$export(module.exports, "ContextSetter", () => (parcelRequire("6Wtq0")).default);

var $6Wtq0 = parcelRequire("6Wtq0");

});
parcelRegister("6Wtq0", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc0cdd82acb1c841$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");
parcelRequire("lCNLa");
var $cwmBL = parcelRequire("cwmBL");
class $fc0cdd82acb1c841$export$28f8b4e4081c59b0 extends $4fqPo.Component {
    updateContextAction(props) {
        const { location: location, match: match, route: route } = props;
        const pathParams = match && match.params || {};
        const pathname = location && location.pathname;
        const routeName = route.name;
        props.updateContextAction({
            pathParams: pathParams,
            pathname: pathname,
            routeName: routeName
        });
    }
    // eslint-disable-next-line react/no-deprecated
    componentWillUpdate(nextProps) {
        this.updateContextAction(nextProps);
    }
    // We use componentDidMount (instead of componentWillMount) here because we need the mount method to be
    // called after all the previous ContextSetters have been unmounted.
    componentDidMount() {
        this.updateContextAction(this.props);
    }
    componentWillUnmount() {
        this.props.clearContextAction();
    }
    render() {
        return null;
    }
}
var $fc0cdd82acb1c841$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, {
    updateContextAction: $cwmBL.updateContextAction,
    clearContextAction: $cwmBL.clearContextAction
})($fc0cdd82acb1c841$export$28f8b4e4081c59b0);

});


parcelRegister("1cuRr", function(module, exports) {
$parcel$export(module.exports, "OnboardingProvider", () => $5fbd32d77fff1caf$export$54ba648a75d332de);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $ibOOf = parcelRequire("ibOOf");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $2jpwX = parcelRequire("2jpwX");

var $jEaUx = parcelRequire("jEaUx");
const $5fbd32d77fff1caf$var$mapStateToProps = (state, props)=>({
        projectId: (0, $95tqy.getProjectId)(state, (0, $2jpwX.toNumber)(props.portalId)),
        showRequestTypeOnboarding: (0, $95tqy.getCanAdministerProject)(state, (0, $2jpwX.toNumber)(props.portalId))
    });
const $5fbd32d77fff1caf$export$54ba648a75d332de = (0, $ibOOf.default)((0, $bmgw6.default)($5fbd32d77fff1caf$var$mapStateToProps)((0, $jEaUx.default)));

});
parcelRegister("jEaUx", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2daba9302d948e4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $k8p3D = parcelRequire("k8p3D");
const $d2daba9302d948e4$export$19b38316c9e7b045 = /*#__PURE__*/ $4fqPo.createContext({
    isLoading: true,
    isRequestCreated: false,
    isDemoProject: false
});
const $d2daba9302d948e4$export$87a388960a322f14 = $d2daba9302d948e4$export$19b38316c9e7b045.Consumer;
class $d2daba9302d948e4$export$2e2bcd8739ae039 extends $4fqPo.Component {
    async componentDidMount() {
        await this.fetchOnboarding();
    }
    async componentDidUpdate(prevProps) {
        const projectIdChanged = prevProps.projectId !== this.props.projectId;
        if (projectIdChanged) await this.fetchOnboarding();
    }
    render() {
        const { children: children, query: query } = this.props;
        const { isLoading: isLoading, isDemoProject: isDemoProject } = this.state;
        const isRequestCreated = !!query.created;
        return /*#__PURE__*/ $4fqPo.createElement($d2daba9302d948e4$export$19b38316c9e7b045.Provider, {
            value: {
                isLoading: isLoading,
                isDemoProject: isDemoProject,
                isRequestCreated: isRequestCreated
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: true,
            isDemoProject: false
        }, /**
   * fetchOnboarding()
   * This method should fetch all onboarding and then set the results appropriately.
   * Remember: Only one onboarding should be shown at a time.
   */ this.fetchOnboarding = async ()=>{
            // Extend this later to fetch all onboarding sources.
            const { projectId: projectId, showRequestTypeOnboarding: showRequestTypeOnboarding } = this.props;
            if (!projectId) return;
            let newState = {};
            if (showRequestTypeOnboarding) {
                const isDemoProject = await (0, $k8p3D.getIsDemoProject)(projectId);
                newState = {
                    ...newState,
                    isDemoProject: isDemoProject,
                    isLoading: false
                };
            }
            this.setState(newState);
        };
    }
}

});
parcelRegister("k8p3D", function(module, exports) {
$parcel$export(module.exports, "getIsDemoProject", () => $6ecce156c59b3581$export$2156daeb7d24c1fc);

var $lVFX8 = parcelRequire("lVFX8");

var $b0T1M = parcelRequire("b0T1M");

var $3wR8f = parcelRequire("3wR8f");
const $6ecce156c59b3581$export$2156daeb7d24c1fc = (projectId)=>{
    const uri = `${(0, $3wR8f.contextPath)}/rest/internal/latest/frontendconfig/properties?projectId=${projectId}&project=isDemo`;
    return (0, $lVFX8.get)(uri).map((ajaxResponse)=>{
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (ajaxResponse.response && ajaxResponse.response.project) // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return !!ajaxResponse.response.project.isDemo;
        return false;
    }).catch(()=>(0, $b0T1M.Observable).of(false)).toPromise();
};

});



parcelRegister("2JItN", function(module, exports) {
$parcel$export(module.exports, "withIgnoreQueryParamUpdates", () => (parcelRequire("gUo1i")).default);

var $gUo1i = parcelRequire("gUo1i");

});
parcelRegister("gUo1i", function(module, exports) {
$parcel$export(module.exports, "default", () => $61a2a3d3ca278a74$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $63sfu = parcelRequire("63sfu");

var $4i2V5 = parcelRequire("4i2V5");
/**
 * Higher order component which implements a shouldComponentUpdate() to block re-rendering if only the query
 * param updated from the react router props.
 * @param renderChild Render function that will return JSX.
 * @param whiteListedQueryParametersSupplier
 */ const $61a2a3d3ca278a74$var$withIgnoreQueryParamUpdates = (renderChild, whiteListedQueryParametersSupplier)=>{
    return class GeneratedLayout extends $4fqPo.Component {
        areWhiteListedQueryParametersDifferent(search, nextSearch) {
            const whiteListedQueryParameters = whiteListedQueryParametersSupplier();
            if (whiteListedQueryParameters.length > 0) {
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedSearch = $4i2V5.parse(search);
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                const parsedNextSearch = $4i2V5.parse(nextSearch);
                let i = 0;
                for(i; i < whiteListedQueryParameters.length; i++){
                    const whiteListedProp = whiteListedQueryParameters[i];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const value = parsedSearch[whiteListedProp];
                    // Suppressing existing violation. Please fix this.
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    const nextValue = parsedNextSearch[whiteListedProp];
                    if (value !== nextValue) return true;
                }
            }
            return false;
        }
        shouldComponentUpdate(nextProps) {
            const { location: location, ...remainingProps } = this.props;
            const { location: nextLocation, ...remainingNextProps } = nextProps;
            const nonQueryLocationChanged = GeneratedLayout.hasNonQueryLocationChanged(location, nextLocation);
            if (nonQueryLocationChanged) return true;
            if (!(0, $63sfu.isEqual)(remainingProps, remainingNextProps)) return true;
            return this.areWhiteListedQueryParametersDifferent(location.search, nextLocation.search);
        }
        static hasNonQueryLocationChanged(location, nextLocation) {
            const { search: search, ...remainingLocationProps } = location;
            const { search: nextSearch, ...remainingNextLocationProps } = nextLocation;
            // If any props other than query parameter changed then we will update
            return !(0, $63sfu.isEqual)(remainingLocationProps, remainingNextLocationProps);
        }
        render() {
            return renderChild(this.props);
        }
    };
};
var $61a2a3d3ca278a74$export$2e2bcd8739ae039 = $61a2a3d3ca278a74$var$withIgnoreQueryParamUpdates;

});







parcelRegister("5fDAd", function(module, exports) {
$parcel$export(module.exports, "UiModificationsContainer", () => $1d999e16bc9124f8$export$1834060b93715de7);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $3gtF5 = parcelRequire("3gtF5");

var $lsxWh = parcelRequire("lsxWh");

var $a7h0I = parcelRequire("a7h0I");
const $1d999e16bc9124f8$export$1834060b93715de7 = ({ children: children })=>{
    return (0, $bG6ob.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3gtF5.BaseUiModificationsContainer), {
        scope: (0, $lsxWh.REQUEST_CREATE_VIEW_TYPE),
        viewType: (0, $lsxWh.REQUEST_CREATE_VIEW_TYPE),
        viewConfiguration: (0, $a7h0I.RequestCreateViewConfiguration)
    }, children) : children;
};

});
parcelRegister("3gtF5", function(module, exports) {
$parcel$export(module.exports, "BaseUiModificationsContainer", () => $b87b4b4db3d3a218$export$8b7a045f60eb9797);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $33BOA = parcelRequire("33BOA");

var $gMd07 = parcelRequire("gMd07");

var $iunpX = parcelRequire("iunpX");
const $b87b4b4db3d3a218$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType, viewConfiguration: viewConfiguration })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    (0, $iunpX.useLoadViewConfiguration)(viewType, viewConfiguration);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMd07.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $33BOA.UiModificationContextContainer), {
        scope: scope
    }, children));
};

});
parcelRegister("33BOA", function(module, exports) {
$parcel$export(module.exports, "store", () => $26993e9a902fec76$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $26993e9a902fec76$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $26993e9a902fec76$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $26993e9a902fec76$export$5eb9c167b683d125);

var $iouul = parcelRequire("iouul");
var $4CywU = parcelRequire("4CywU");
var $2RDzF = parcelRequire("2RDzF");
const $26993e9a902fec76$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $26993e9a902fec76$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($26993e9a902fec76$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $26993e9a902fec76$export$6f57813fe9f31bf9 = (0, $2RDzF.createStore)({
    name: 'issue-adjustments-context',
    initialState: $26993e9a902fec76$var$initialState,
    actions: $26993e9a902fec76$export$e324594224ef24da
});
const $26993e9a902fec76$export$a12f82a132dee079 = (0, $iouul.createHook)($26993e9a902fec76$export$6f57813fe9f31bf9);
const $26993e9a902fec76$export$358ad850b2f6d6fe = (0, $iouul.createStateHook)($26993e9a902fec76$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $26993e9a902fec76$export$4f2729981f4b81d2 = (0, $iouul.createActionsHook)($26993e9a902fec76$export$6f57813fe9f31bf9);
const $26993e9a902fec76$export$5eb9c167b683d125 = (0, $4CywU.createContainer)($26993e9a902fec76$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("gMd07", function(module, exports) {
$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $e22df8a998f5b2e8$export$b087a12fbb84e8ac);

var $4CywU = parcelRequire("4CywU");

var $7pCjT = parcelRequire("7pCjT");
const $e22df8a998f5b2e8$export$b087a12fbb84e8ac = (0, $4CywU.createContainer)((0, $7pCjT.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("7pCjT", function(module, exports) {
$parcel$export(module.exports, "store", () => $655771c21ec2506b$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedFields", () => $655771c21ec2506b$export$c76e674a29843e21);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $655771c21ec2506b$export$cb9a014ec14556d8);

var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $8BdtR = parcelRequire("8BdtR");

var $fI645 = parcelRequire("fI645");

var $h3pDv = parcelRequire("h3pDv");

var $8Hrvn = parcelRequire("8Hrvn");

var $9NF3C = parcelRequire("9NF3C");

var $hZku7 = parcelRequire("hZku7");

var $64KZH = parcelRequire("64KZH");

var $jy9dp = parcelRequire("jy9dp");

var $gSWVm = parcelRequire("gSWVm");

var $5CB4W = parcelRequire("5CB4W");

var $gBbL4 = parcelRequire("gBbL4");

var $5Hoj2 = parcelRequire("5Hoj2");

var $3U90i = parcelRequire("3U90i");

var $7EW1F = parcelRequire("7EW1F");

var $cggCb = parcelRequire("cggCb");
const $655771c21ec2506b$var$name = 'issue-adjustments';
const $655771c21ec2506b$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $655771c21ec2506b$var$triggerFieldInitializationKey, viewType: $655771c21ec2506b$var$scopedViewType, numberOfSupportedFields: $655771c21ec2506b$var$numberOfSupportedFields, ...$655771c21ec2506b$var$stateForResetAllFields } = $655771c21ec2506b$export$d4c72bab9d6cc13a;
const $655771c21ec2506b$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5CB4W.processChange,
    setFieldValue: $5Hoj2.setFieldValue,
    initializeField: $hZku7.initializeField,
    initializeFields: $hZku7.initializeFields,
    startFieldsInitialisationTimeout: $9NF3C.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $9NF3C.successFieldsInitalisation,
    registerFields: $gBbL4.registerFields,
    unregisterFields: $gBbL4.unregisterFields,
    updateFields: $7EW1F.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($655771c21ec2506b$var$stateForResetAllFields);
        },
    setError: $8Hrvn.setError,
    resetError: $8Hrvn.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
   * This is used to block onInit for specific case like Issue View background refresh loading.
   */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $8BdtR.setAppErrors,
    resetAppErrors: $8BdtR.resetAppErrors,
    addAppsErrors: $8BdtR.addAppsErrors,
    initializeNoScreenTab: $64KZH.initializeNoScreenTab,
    initializeScreenTabs: $jy9dp.initializeScreenTabs,
    updateScreenTabs: $cggCb.updateScreenTabs,
    updateActiveScreenTab: $3U90i.updateActiveScreenTab,
    detectAppliedChangesConflicts: $fI645.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $h3pDv.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $h3pDv.collectFieldsAppliedChangesHistory,
    setNotification: $gSWVm.setNotification,
    resetNotification: $gSWVm.resetNotification
};
const $655771c21ec2506b$export$6f57813fe9f31bf9 = (0, $2RDzF.createStore)({
    name: $655771c21ec2506b$var$name,
    initialState: $655771c21ec2506b$export$d4c72bab9d6cc13a,
    actions: $655771c21ec2506b$export$e324594224ef24da
});
const $655771c21ec2506b$export$37792a602e748c08 = (0, $iouul.createHook)($655771c21ec2506b$export$6f57813fe9f31bf9);
const $655771c21ec2506b$var$stableEmptyFieldFromIframe = {};
const $655771c21ec2506b$export$c76e674a29843e21 = (0, $iouul.createHook)($655771c21ec2506b$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $655771c21ec2506b$export$df4b0714e8177e0e = (0, $iouul.createHook)($655771c21ec2506b$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>{
        var _state$appliedChanges;
        return ((_state$appliedChanges = state.appliedChanges) === null || _state$appliedChanges === void 0 ? void 0 : _state$appliedChanges[fieldId]) || $655771c21ec2506b$var$stableEmptyFieldFromIframe;
    }
});
const $655771c21ec2506b$export$cb9a014ec14556d8 = (0, $iouul.createActionsHook)($655771c21ec2506b$export$6f57813fe9f31bf9);
const $655771c21ec2506b$export$677b3e34bd14c681 = (0, $iouul.createHook)($655771c21ec2506b$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("8BdtR", function(module, exports) {
$parcel$export(module.exports, "setAppErrors", () => $17d4c12ebadc3a3e$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $17d4c12ebadc3a3e$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $17d4c12ebadc3a3e$export$24c821207687a907);
const $17d4c12ebadc3a3e$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $17d4c12ebadc3a3e$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $17d4c12ebadc3a3e$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("fI645", function(module, exports) {
$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $cbdbec65258dae17$export$90d94f20d157e756);

var $cM1tn = parcelRequire("cM1tn");

var $jM2Ed = parcelRequire("jM2Ed");

var $8BdtR = parcelRequire("8BdtR");

var $gSWVm = parcelRequire("gSWVm");

var $8hiAg = parcelRequire("8hiAg");
const $cbdbec65258dae17$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $cbdbec65258dae17$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $cbdbec65258dae17$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $cbdbec65258dae17$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $cbdbec65258dae17$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId === null || appliedChangesHistoryChangeId === void 0 ? void 0 : appliedChangesHistoryChangeId.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $jM2Ed.ON_INIT_CHANGE_ID) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $8hiAg.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $8BdtR.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $gSWVm.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("cM1tn", function(module, exports) {
$parcel$export(module.exports, "fireOperationalEvent", () => $420fd39fdbf7ad04$export$a1fb57756f0de62b);

var $jQXWT = parcelRequire("jQXWT");

var $gHT3x = parcelRequire("gHT3x");

var $60Y3D = parcelRequire("60Y3D");
const $420fd39fdbf7ad04$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $jQXWT.default)((0, $60Y3D.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $gHT3x.OPERATIONAL_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});
parcelRegister("60Y3D", function(module, exports) {
$parcel$export(module.exports, "UI_MODIFICATIONS_ANALYTICS_CHANNEL", () => $e8e8350bda175b1c$export$8280e5c6104c5b40);
const $e8e8350bda175b1c$export$8280e5c6104c5b40 = 'ui-modifications';

});


parcelRegister("jM2Ed", function(module, exports) {
$parcel$export(module.exports, "ON_INIT_CHANGE_ID", () => $e1051541e0678771$export$415cc1afa6445f90);
$parcel$export(module.exports, "UI_MODIFICATIONS_MODULE", () => $e1051541e0678771$export$811b7f067a43b422);
const $e1051541e0678771$export$415cc1afa6445f90 = 'onInitChangeId';
const $e1051541e0678771$export$811b7f067a43b422 = 'jira:uiModifications';

});

parcelRegister("gSWVm", function(module, exports) {
$parcel$export(module.exports, "setNotification", () => $8efbac757dfa1e95$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $8efbac757dfa1e95$export$caafa3945f199bc7);
const $8efbac757dfa1e95$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $8efbac757dfa1e95$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("8hiAg", function(module, exports) {
$parcel$export(module.exports, "collectConflicts", () => $affce7d663e3c0c4$export$a06103ec99e4e394);

var $f6zHi = parcelRequire("f6zHi");

var $6fUbn = parcelRequire("6fUbn");

var $iIf9n = parcelRequire("iIf9n");

var $iaYH8 = parcelRequire("iaYH8");
const $affce7d663e3c0c4$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $affce7d663e3c0c4$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $iaYH8.SCREEN_TABS_HISTORY_TYPE)) return {
            type: (0, $6fUbn.MULTIPLE_APPS_CONFLICT),
            cause: (0, $6fUbn.MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$affce7d663e3c0c4$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $iIf9n.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $6fUbn.MULTIPLE_APPS_CONFLICT),
            cause: (0, $6fUbn.MULTIPLE_APPS_CONFLICT_CAUSE_FIELD),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$affce7d663e3c0c4$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $affce7d663e3c0c4$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($f6zHi)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $affce7d663e3c0c4$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
parcelRegister("f6zHi", function(module, exports) {

var $6NHeY = parcelRequire("6NHeY");

var $hPAS9 = parcelRequire("hPAS9");

var $6KLcn = parcelRequire("6KLcn");

var $4RdXx = parcelRequire("4RdXx");

var $9rlIO = parcelRequire("9rlIO");

var $1Sp10 = parcelRequire("1Sp10");

var $imSIk = parcelRequire("imSIk");

var $bA7AA = parcelRequire("bA7AA");
/** Used to compose bitmasks for cloning. */ var $aff31b521c34ac80$var$CLONE_DEEP_FLAG = 1, $aff31b521c34ac80$var$CLONE_FLAT_FLAG = 2, $aff31b521c34ac80$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $aff31b521c34ac80$var$omit = $imSIk(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $6NHeY(paths, function(path) {
        path = $4RdXx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $9rlIO(object, $bA7AA(object), result);
    if (isDeep) result = $hPAS9(result, $aff31b521c34ac80$var$CLONE_DEEP_FLAG | $aff31b521c34ac80$var$CLONE_FLAT_FLAG | $aff31b521c34ac80$var$CLONE_SYMBOLS_FLAG, $1Sp10);
    var length = paths.length;
    while(length--)$6KLcn(result, paths[length]);
    return result;
});
module.exports = $aff31b521c34ac80$var$omit;

});
parcelRegister("hPAS9", function(module, exports) {

var $cPeOR = parcelRequire("cPeOR");

var $kaQmj = parcelRequire("kaQmj");

var $3gXGs = parcelRequire("3gXGs");

var $9K2zS = parcelRequire("9K2zS");

var $1JaGE = parcelRequire("1JaGE");

var $jULUM = parcelRequire("jULUM");

var $1ae9m = parcelRequire("1ae9m");

var $b3kjo = parcelRequire("b3kjo");

var $1Qt4Z = parcelRequire("1Qt4Z");

var $abLGa = parcelRequire("abLGa");

var $bA7AA = parcelRequire("bA7AA");

var $4L1Ez = parcelRequire("4L1Ez");

var $2IsKj = parcelRequire("2IsKj");

var $SBRUl = parcelRequire("SBRUl");

var $iFB7V = parcelRequire("iFB7V");

var $3Tp9Q = parcelRequire("3Tp9Q");

var $gJsvo = parcelRequire("gJsvo");

var $a11Df = parcelRequire("a11Df");

var $p4u5f = parcelRequire("p4u5f");

var $js84z = parcelRequire("js84z");

var $ggedu = parcelRequire("ggedu");

var $f9RRo = parcelRequire("f9RRo");
/** Used to compose bitmasks for cloning. */ var $cfb3cd321451e43e$var$CLONE_DEEP_FLAG = 1, $cfb3cd321451e43e$var$CLONE_FLAT_FLAG = 2, $cfb3cd321451e43e$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cfb3cd321451e43e$var$argsTag = '[object Arguments]', $cfb3cd321451e43e$var$arrayTag = '[object Array]', $cfb3cd321451e43e$var$boolTag = '[object Boolean]', $cfb3cd321451e43e$var$dateTag = '[object Date]', $cfb3cd321451e43e$var$errorTag = '[object Error]', $cfb3cd321451e43e$var$funcTag = '[object Function]', $cfb3cd321451e43e$var$genTag = '[object GeneratorFunction]', $cfb3cd321451e43e$var$mapTag = '[object Map]', $cfb3cd321451e43e$var$numberTag = '[object Number]', $cfb3cd321451e43e$var$objectTag = '[object Object]', $cfb3cd321451e43e$var$regexpTag = '[object RegExp]', $cfb3cd321451e43e$var$setTag = '[object Set]', $cfb3cd321451e43e$var$stringTag = '[object String]', $cfb3cd321451e43e$var$symbolTag = '[object Symbol]', $cfb3cd321451e43e$var$weakMapTag = '[object WeakMap]';
var $cfb3cd321451e43e$var$arrayBufferTag = '[object ArrayBuffer]', $cfb3cd321451e43e$var$dataViewTag = '[object DataView]', $cfb3cd321451e43e$var$float32Tag = '[object Float32Array]', $cfb3cd321451e43e$var$float64Tag = '[object Float64Array]', $cfb3cd321451e43e$var$int8Tag = '[object Int8Array]', $cfb3cd321451e43e$var$int16Tag = '[object Int16Array]', $cfb3cd321451e43e$var$int32Tag = '[object Int32Array]', $cfb3cd321451e43e$var$uint8Tag = '[object Uint8Array]', $cfb3cd321451e43e$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cfb3cd321451e43e$var$uint16Tag = '[object Uint16Array]', $cfb3cd321451e43e$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cfb3cd321451e43e$var$cloneableTags = {};
$cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$argsTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$arrayTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$arrayBufferTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$dataViewTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$boolTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$dateTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$float32Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$float64Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$int8Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$int16Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$int32Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$mapTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$numberTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$objectTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$regexpTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$setTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$stringTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$symbolTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$uint8Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$uint8ClampedTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$uint16Tag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$uint32Tag] = true;
$cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$errorTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$funcTag] = $cfb3cd321451e43e$var$cloneableTags[$cfb3cd321451e43e$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cfb3cd321451e43e$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cfb3cd321451e43e$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cfb3cd321451e43e$var$CLONE_FLAT_FLAG, isFull = bitmask & $cfb3cd321451e43e$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$p4u5f(value)) return value;
    var isArr = $3Tp9Q(value);
    if (isArr) {
        result = $2IsKj(value);
        if (!isDeep) return $1ae9m(value, result);
    } else {
        var tag = $4L1Ez(value), isFunc = tag == $cfb3cd321451e43e$var$funcTag || tag == $cfb3cd321451e43e$var$genTag;
        if ($gJsvo(value)) return $jULUM(value, isDeep);
        if (tag == $cfb3cd321451e43e$var$objectTag || tag == $cfb3cd321451e43e$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $iFB7V(value);
            if (!isDeep) return isFlat ? $1Qt4Z(value, $1JaGE(result, value)) : $b3kjo(value, $9K2zS(result, value));
        } else {
            if (!$cfb3cd321451e43e$var$cloneableTags[tag]) return object ? value : {};
            result = $SBRUl(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $cPeOR);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($js84z(value)) value.forEach(function(subValue) {
        result.add($cfb3cd321451e43e$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($a11Df(value)) value.forEach(function(subValue, key) {
        result.set(key, $cfb3cd321451e43e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $bA7AA : $abLGa : isFlat ? $f9RRo : $ggedu;
    var props = isArr ? undefined : keysFunc(value);
    $kaQmj(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $3gXGs(result, key, $cfb3cd321451e43e$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cfb3cd321451e43e$var$baseClone;

});
parcelRegister("kaQmj", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $eafd5b3880e1eafa$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $eafd5b3880e1eafa$var$arrayEach;

});

parcelRegister("9K2zS", function(module, exports) {

var $9rlIO = parcelRequire("9rlIO");

var $ggedu = parcelRequire("ggedu");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $717a68c7916b494e$var$baseAssign(object, source) {
    return object && $9rlIO(source, $ggedu(source), object);
}
module.exports = $717a68c7916b494e$var$baseAssign;

});

parcelRegister("1JaGE", function(module, exports) {

var $9rlIO = parcelRequire("9rlIO");

var $f9RRo = parcelRequire("f9RRo");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $142248a3b394a607$var$baseAssignIn(object, source) {
    return object && $9rlIO(source, $f9RRo(source), object);
}
module.exports = $142248a3b394a607$var$baseAssignIn;

});

parcelRegister("b3kjo", function(module, exports) {

var $9rlIO = parcelRequire("9rlIO");

var $e8E0v = parcelRequire("e8E0v");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $80bfbb041b509b2c$var$copySymbols(source, object) {
    return $9rlIO(source, $e8E0v(source), object);
}
module.exports = $80bfbb041b509b2c$var$copySymbols;

});

parcelRegister("1Qt4Z", function(module, exports) {

var $9rlIO = parcelRequire("9rlIO");

var $2CpCu = parcelRequire("2CpCu");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $1581345a946d98d6$var$copySymbolsIn(source, object) {
    return $9rlIO(source, $2CpCu(source), object);
}
module.exports = $1581345a946d98d6$var$copySymbolsIn;

});

parcelRegister("2IsKj", function(module, exports) {
/** Used for built-in method references. */ var $1fa5fd2b856fae7a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1fa5fd2b856fae7a$var$hasOwnProperty = $1fa5fd2b856fae7a$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $1fa5fd2b856fae7a$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $1fa5fd2b856fae7a$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $1fa5fd2b856fae7a$var$initCloneArray;

});

parcelRegister("SBRUl", function(module, exports) {

var $hE540 = parcelRequire("hE540");

var $j2LNu = parcelRequire("j2LNu");

var $kES4Q = parcelRequire("kES4Q");

var $6hnXL = parcelRequire("6hnXL");

var $VUNjX = parcelRequire("VUNjX");
/** `Object#toString` result references. */ var $0a426b26e0f36d7a$var$boolTag = '[object Boolean]', $0a426b26e0f36d7a$var$dateTag = '[object Date]', $0a426b26e0f36d7a$var$mapTag = '[object Map]', $0a426b26e0f36d7a$var$numberTag = '[object Number]', $0a426b26e0f36d7a$var$regexpTag = '[object RegExp]', $0a426b26e0f36d7a$var$setTag = '[object Set]', $0a426b26e0f36d7a$var$stringTag = '[object String]', $0a426b26e0f36d7a$var$symbolTag = '[object Symbol]';
var $0a426b26e0f36d7a$var$arrayBufferTag = '[object ArrayBuffer]', $0a426b26e0f36d7a$var$dataViewTag = '[object DataView]', $0a426b26e0f36d7a$var$float32Tag = '[object Float32Array]', $0a426b26e0f36d7a$var$float64Tag = '[object Float64Array]', $0a426b26e0f36d7a$var$int8Tag = '[object Int8Array]', $0a426b26e0f36d7a$var$int16Tag = '[object Int16Array]', $0a426b26e0f36d7a$var$int32Tag = '[object Int32Array]', $0a426b26e0f36d7a$var$uint8Tag = '[object Uint8Array]', $0a426b26e0f36d7a$var$uint8ClampedTag = '[object Uint8ClampedArray]', $0a426b26e0f36d7a$var$uint16Tag = '[object Uint16Array]', $0a426b26e0f36d7a$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $0a426b26e0f36d7a$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $0a426b26e0f36d7a$var$arrayBufferTag:
            return $hE540(object);
        case $0a426b26e0f36d7a$var$boolTag:
        case $0a426b26e0f36d7a$var$dateTag:
            return new Ctor(+object);
        case $0a426b26e0f36d7a$var$dataViewTag:
            return $j2LNu(object, isDeep);
        case $0a426b26e0f36d7a$var$float32Tag:
        case $0a426b26e0f36d7a$var$float64Tag:
        case $0a426b26e0f36d7a$var$int8Tag:
        case $0a426b26e0f36d7a$var$int16Tag:
        case $0a426b26e0f36d7a$var$int32Tag:
        case $0a426b26e0f36d7a$var$uint8Tag:
        case $0a426b26e0f36d7a$var$uint8ClampedTag:
        case $0a426b26e0f36d7a$var$uint16Tag:
        case $0a426b26e0f36d7a$var$uint32Tag:
            return $VUNjX(object, isDeep);
        case $0a426b26e0f36d7a$var$mapTag:
            return new Ctor;
        case $0a426b26e0f36d7a$var$numberTag:
        case $0a426b26e0f36d7a$var$stringTag:
            return new Ctor(object);
        case $0a426b26e0f36d7a$var$regexpTag:
            return $kES4Q(object);
        case $0a426b26e0f36d7a$var$setTag:
            return new Ctor;
        case $0a426b26e0f36d7a$var$symbolTag:
            return $6hnXL(object);
    }
}
module.exports = $0a426b26e0f36d7a$var$initCloneByTag;

});
parcelRegister("j2LNu", function(module, exports) {

var $hE540 = parcelRequire("hE540");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $ddd347c7c6fdde3b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $hE540(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $ddd347c7c6fdde3b$var$cloneDataView;

});

parcelRegister("kES4Q", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $f0a17da5bb9ad58b$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $f0a17da5bb9ad58b$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $f0a17da5bb9ad58b$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $f0a17da5bb9ad58b$var$cloneRegExp;

});

parcelRegister("6hnXL", function(module, exports) {

var $aizG2 = parcelRequire("aizG2");
/** Used to convert symbols to primitives and strings. */ var $4926eb243fb482b4$var$symbolProto = $aizG2 ? $aizG2.prototype : undefined, $4926eb243fb482b4$var$symbolValueOf = $4926eb243fb482b4$var$symbolProto ? $4926eb243fb482b4$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $4926eb243fb482b4$var$cloneSymbol(symbol) {
    return $4926eb243fb482b4$var$symbolValueOf ? Object($4926eb243fb482b4$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $4926eb243fb482b4$var$cloneSymbol;

});


parcelRegister("a11Df", function(module, exports) {

var $8jyXd = parcelRequire("8jyXd");

var $gujh9 = parcelRequire("gujh9");

var $8WiT0 = parcelRequire("8WiT0");
/* Node.js helper references. */ var $74ab43755ed837b8$var$nodeIsMap = $8WiT0 && $8WiT0.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $74ab43755ed837b8$var$isMap = $74ab43755ed837b8$var$nodeIsMap ? $gujh9($74ab43755ed837b8$var$nodeIsMap) : $8jyXd;
module.exports = $74ab43755ed837b8$var$isMap;

});
parcelRegister("8jyXd", function(module, exports) {

var $4L1Ez = parcelRequire("4L1Ez");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $60db363be14cf885$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $60db363be14cf885$var$baseIsMap(value) {
    return $5eSIk(value) && $4L1Ez(value) == $60db363be14cf885$var$mapTag;
}
module.exports = $60db363be14cf885$var$baseIsMap;

});


parcelRegister("js84z", function(module, exports) {

var $7xBKQ = parcelRequire("7xBKQ");

var $gujh9 = parcelRequire("gujh9");

var $8WiT0 = parcelRequire("8WiT0");
/* Node.js helper references. */ var $e296e4ef09a7484e$var$nodeIsSet = $8WiT0 && $8WiT0.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e296e4ef09a7484e$var$isSet = $e296e4ef09a7484e$var$nodeIsSet ? $gujh9($e296e4ef09a7484e$var$nodeIsSet) : $7xBKQ;
module.exports = $e296e4ef09a7484e$var$isSet;

});
parcelRegister("7xBKQ", function(module, exports) {

var $4L1Ez = parcelRequire("4L1Ez");

var $5eSIk = parcelRequire("5eSIk");
/** `Object#toString` result references. */ var $57d8e6c1d15e8f8b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $57d8e6c1d15e8f8b$var$baseIsSet(value) {
    return $5eSIk(value) && $4L1Ez(value) == $57d8e6c1d15e8f8b$var$setTag;
}
module.exports = $57d8e6c1d15e8f8b$var$baseIsSet;

});



parcelRegister("6KLcn", function(module, exports) {

var $4RdXx = parcelRequire("4RdXx");

var $dZ56i = parcelRequire("dZ56i");

var $4YLSh = parcelRequire("4YLSh");

var $fOiJD = parcelRequire("fOiJD");
/** Used for built-in method references. */ var $4eaba69df011956c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4eaba69df011956c$var$hasOwnProperty = $4eaba69df011956c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $4eaba69df011956c$var$baseUnset(object, path) {
    path = $4RdXx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $fOiJD(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$4eaba69df011956c$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $4YLSh(object, path);
    return obj == null || delete obj[$fOiJD($dZ56i(path))];
}
module.exports = $4eaba69df011956c$var$baseUnset;

});
parcelRegister("4YLSh", function(module, exports) {

var $goyLi = parcelRequire("goyLi");

var $iX8US = parcelRequire("iX8US");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $3a01e6e9c2a24ece$var$parent(object, path) {
    return path.length < 2 ? object : $goyLi(object, $iX8US(path, 0, -1));
}
module.exports = $3a01e6e9c2a24ece$var$parent;

});
parcelRegister("iX8US", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $dcc4a74f2cbe74e6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $dcc4a74f2cbe74e6$var$baseSlice;

});



parcelRegister("1Sp10", function(module, exports) {

var $hUF1A = parcelRequire("hUF1A");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $15de3d13a3c35a4d$var$customOmitClone(value) {
    return $hUF1A(value) ? undefined : value;
}
module.exports = $15de3d13a3c35a4d$var$customOmitClone;

});

parcelRegister("imSIk", function(module, exports) {

var $gB8hB = parcelRequire("gB8hB");

var $5JCo3 = parcelRequire("5JCo3");

var $epdYk = parcelRequire("epdYk");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $d5f4b91ac519e833$var$flatRest(func) {
    return $epdYk($5JCo3(func, undefined, $gB8hB), func + '');
}
module.exports = $d5f4b91ac519e833$var$flatRest;

});


parcelRegister("6fUbn", function(module, exports) {
$parcel$export(module.exports, "SCREENTABS_VALIDATION_ERROR", () => $a8a822df03b7f339$export$fd26696d109785a0);
$parcel$export(module.exports, "FIELD_VALIDATION_ERROR", () => $a8a822df03b7f339$export$d1996cb46a690190);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT", () => $a8a822df03b7f339$export$2a3fdceaae2188d5);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_FIELD", () => $a8a822df03b7f339$export$e4ac32edd5da2ee7);
$parcel$export(module.exports, "MULTIPLE_APPS_CONFLICT_CAUSE_SCREENTABS", () => $a8a822df03b7f339$export$877da1000325f8b5);
const $a8a822df03b7f339$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $a8a822df03b7f339$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $a8a822df03b7f339$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $a8a822df03b7f339$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $a8a822df03b7f339$export$e4ac32edd5da2ee7 = 'FIELD';
const $a8a822df03b7f339$export$877da1000325f8b5 = 'SCREENTABS';

});

parcelRegister("iIf9n", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $665ab81224f6b434$export$e1cc7da28a1c4bb7);
const $665ab81224f6b434$var$SET_NAME_METHOD = 'setName';
const $665ab81224f6b434$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $665ab81224f6b434$var$SET_VISIBLE_METHOD = 'setVisible';
const $665ab81224f6b434$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $665ab81224f6b434$var$SET_VALUE_METHOD = 'setValue';
const $665ab81224f6b434$var$SET_REQUIRED_METHOD = 'setRequired';
const $665ab81224f6b434$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $665ab81224f6b434$export$8325709d137b2606 = {
    fieldName: $665ab81224f6b434$var$SET_NAME_METHOD,
    description: $665ab81224f6b434$var$SET_DESCRIPTION_METHOD,
    isVisible: $665ab81224f6b434$var$SET_VISIBLE_METHOD,
    isReadOnly: $665ab81224f6b434$var$SET_READ_ONLY_METHOD,
    value: $665ab81224f6b434$var$SET_VALUE_METHOD,
    isRequired: $665ab81224f6b434$var$SET_REQUIRED_METHOD,
    optionsVisibility: $665ab81224f6b434$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $665ab81224f6b434$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $665ab81224f6b434$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("iaYH8", function(module, exports) {
$parcel$export(module.exports, "SCREEN_TABS_HISTORY_TYPE", () => $671c6c910a7ee9fe$export$f674b7a3bbd94b5);
$parcel$export(module.exports, "FIELD_HISTORY_TYPE", () => $671c6c910a7ee9fe$export$4a9f236a0db33834);
const $671c6c910a7ee9fe$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $671c6c910a7ee9fe$export$4a9f236a0db33834 = 'FIELD';

});



parcelRegister("h3pDv", function(module, exports) {
$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $ca859e7f28af2f29$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $ca859e7f28af2f29$export$7d0f534e5b16dcc9);

var $iaYH8 = parcelRequire("iaYH8");

var $djQjR = parcelRequire("djQjR");
const $ca859e7f28af2f29$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    var _appliedChangesHistor;
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = ((_appliedChangesHistor = appliedChangesHistoryChangeId.apps) === null || _appliedChangesHistor === void 0 ? void 0 : _appliedChangesHistor[appId]) ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $ca859e7f28af2f29$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $ca859e7f28af2f29$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $iaYH8.SCREEN_TABS_HISTORY_TYPE)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $ca859e7f28af2f29$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $djQjR.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $ca859e7f28af2f29$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("djQjR", function(module, exports) {
$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $cab1ea914b16b367$export$8a23b3e9a1749620);

var $iaYH8 = parcelRequire("iaYH8");
const $cab1ea914b16b367$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $iaYH8.FIELD_HISTORY_TYPE)
        };
        return acc;
    }, {});
};
const $cab1ea914b16b367$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $cab1ea914b16b367$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("8Hrvn", function(module, exports) {
$parcel$export(module.exports, "setError", () => $61bc10b9f654dc9b$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $61bc10b9f654dc9b$export$7e5930c6217b1d4e);
const $61bc10b9f654dc9b$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $61bc10b9f654dc9b$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("9NF3C", function(module, exports) {
$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $24563cde266bb4b1$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $24563cde266bb4b1$export$cf768a695e83eefa);

var $cM1tn = parcelRequire("cM1tn");

var $2hC9Y = parcelRequire("2hC9Y");

var $8Hrvn = parcelRequire("8Hrvn");
const $24563cde266bb4b1$var$getTimeout = ()=>50000;
const $24563cde266bb4b1$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $24563cde266bb4b1$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $24563cde266bb4b1$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($24563cde266bb4b1$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $24563cde266bb4b1$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $24563cde266bb4b1$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($24563cde266bb4b1$var$isFieldInitialisationComplete(status) || (0, $2hC9Y.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $8Hrvn.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $24563cde266bb4b1$var$getTimeout(),
                fieldsInitializationTime: $24563cde266bb4b1$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $24563cde266bb4b1$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($24563cde266bb4b1$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $24563cde266bb4b1$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("2hC9Y", function(module, exports) {
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $a5678139469a866c$export$4cadeedb8c3f31f7);

var $6VEbB = parcelRequire("6VEbB");
const $a5678139469a866c$export$4cadeedb8c3f31f7 = (0, $6VEbB.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("hZku7", function(module, exports) {
$parcel$export(module.exports, "initializeField", () => $8361ee6619a32b69$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $8361ee6619a32b69$export$4a6b4707110b0552);

var $1FeZZ = parcelRequire("1FeZZ");
const $8361ee6619a32b69$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $1FeZZ.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $8361ee6619a32b69$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata === null || metadata === void 0 ? void 0 : metadata.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $1FeZZ.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("1FeZZ", function(module, exports) {
$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $c88594696457e484$export$50806045b617d116);

var $8MIxg = parcelRequire("8MIxg");

var $bjzpQ = parcelRequire("bjzpQ");
const $c88594696457e484$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        var _getSupportedFieldCon;
        const valueTransformer = (_getSupportedFieldCon = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.internalToPublicTransformers.value;
        if (valueTransformer) /**
       * We trust that the internal field data is in the correct shape.
       * Data that is in the incorrect shape will result in error events
       * being logged for further investigation. In this error case we will
       * pass `null` as the value to unblock onInit for the apps
       *
       * The `fieldRenderer` passed to the `valueTransformer` is used only for
       * rich text fields and will be `undefined` for most of the executions
       */ value = valueTransformer(internalFieldValue, fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $8MIxg.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("8MIxg", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => $748d38723e34d495$export$a27c21aa3ed8f0f1);
parcelRequire("aU7k1");
var $k554N = parcelRequire("k554N");

var $juiRU = parcelRequire("juiRU");
const $748d38723e34d495$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $748d38723e34d495$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, analyticsViewType: analyticsViewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $juiRU.getErrorType)(error);
    // Name the event after the canonical viewType (when given) so overlay traffic
    // lands in the same bucket; the real viewType still goes into attributes below.
    const packageName = `${analyticsViewType ?? viewType}jiraUiModifications`;
    (0, $k554N.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $748d38723e34d495$export$1bee4e6be783dd26(error.message) : error.message,
            viewType: // Keep the real viewType in attributes so we know where the error came from.
            viewType,
            ...attributes
        }
    });
};

});
parcelRegister("aU7k1", function(module, exports) {
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("k554N")).default);
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => (parcelRequire("k554N")).initialiseErrorAnalyticsClient);

var $9JJ6l = parcelRequire("9JJ6l");

var $k554N = parcelRequire("k554N");

var $7S2MH = parcelRequire("7S2MH");

});
parcelRegister("9JJ6l", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $1f779e06b176a745$export$f5282963edea4a68);

var $8lhO5 = parcelRequire("8lhO5");
const $1f779e06b176a745$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $8lhO5.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $1f779e06b176a745$export$f5282963edea4a68 = (location, error, details = {})=>(0, $8lhO5.default).captureException(location, error, details);

});
parcelRegister("8lhO5", function(module, exports) {
$parcel$export(module.exports, "default", () => $f31b4edf6d72bd99$export$2e2bcd8739ae039);
// This is the only file that should directly import Raven.

var $ePuex = parcelRequire("ePuex");
var $KhyL6 = parcelRequire("KhyL6");
var $lVVcj = parcelRequire("lVVcj");

var $2rNTr = parcelRequire("2rNTr");
var $d2KhB = parcelRequire("d2KhB");
var $fjXh4 = parcelRequire("fjXh4");
var $8lQwm = parcelRequire("8lQwm");

var $1qNjk = parcelRequire("1qNjk");
const $f31b4edf6d72bd99$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($1qNjk)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $f31b4edf6d72bd99$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $f31b4edf6d72bd99$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $f31b4edf6d72bd99$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $f31b4edf6d72bd99$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $KhyL6.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $f31b4edf6d72bd99$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$f31b4edf6d72bd99$var$getFilteredIntegrations(integrations),
                new $d2KhB.Dedupe(),
                new $fjXh4.ExtraErrorData(),
                new $8lQwm.Transaction(),
                new $2rNTr.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $lVVcj.init({
        ...defaultConfig,
        ...config
    });
    try {
        $ePuex.setExtras(getExtraContext());
    } catch (e) {
        $ePuex.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $f31b4edf6d72bd99$var$tags = [
    'packageName',
    'teamName'
];
const $f31b4edf6d72bd99$var$captureException = (location, error, details)=>{
    $ePuex.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($f31b4edf6d72bd99$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $ePuex.captureException(error);
};
const $f31b4edf6d72bd99$var$sentryErrorHandler = {
    installGlobalHandler: $f31b4edf6d72bd99$var$installGlobalHandler,
    captureException: $f31b4edf6d72bd99$var$captureException
};
var $f31b4edf6d72bd99$export$2e2bcd8739ae039 = $f31b4edf6d72bd99$var$sentryErrorHandler;

});
parcelRegister("2rNTr", function(module, exports) {
$parcel$export(module.exports, "CaptureConsole", () => $1c84ce2a872e4d5a$export$25a43cb5b5c58c08);
parcelRequire("6AxhP");
var $jXuA5 = parcelRequire("jXuA5");
var $f1NKK = parcelRequire("f1NKK");
var $8rVYd = parcelRequire("8rVYd");
var $fNmkX = parcelRequire("fNmkX");
var $lLenz = parcelRequire("lLenz");
var $1c84ce2a872e4d5a$var$global = (0, $8rVYd.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $1c84ce2a872e4d5a$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $jXuA5.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $1c84ce2a872e4d5a$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $1c84ce2a872e4d5a$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $f1NKK.fill)($1c84ce2a872e4d5a$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $lLenz.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $fNmkX.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $fNmkX.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($1c84ce2a872e4d5a$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();

});

parcelRegister("d2KhB", function(module, exports) {
$parcel$export(module.exports, "Dedupe", () => $97ef5d11a5ba3d4c$export$688d98c249d31ad3);
parcelRequire("6AxhP");
var $jXuA5 = parcelRequire("jXuA5");

var $l8b6O = parcelRequire("l8b6O");
/** Deduplication filter */ var $97ef5d11a5ba3d4c$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($97ef5d11a5ba3d4c$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $l8b6O.IS_DEBUG_BUILD) && (0, $jXuA5.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $97ef5d11a5ba3d4c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($97ef5d11a5ba3d4c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($97ef5d11a5ba3d4c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $97ef5d11a5ba3d4c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$97ef5d11a5ba3d4c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$97ef5d11a5ba3d4c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $97ef5d11a5ba3d4c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $97ef5d11a5ba3d4c$var$_getExceptionFromEvent(previousEvent);
    var currentException = $97ef5d11a5ba3d4c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$97ef5d11a5ba3d4c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$97ef5d11a5ba3d4c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $97ef5d11a5ba3d4c$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $97ef5d11a5ba3d4c$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $97ef5d11a5ba3d4c$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $97ef5d11a5ba3d4c$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $97ef5d11a5ba3d4c$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $97ef5d11a5ba3d4c$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}

});
parcelRegister("l8b6O", function(module, exports) {
$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $f622f64f2f2d4636$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $f622f64f2f2d4636$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("fjXh4", function(module, exports) {
$parcel$export(module.exports, "ExtraErrorData", () => $b2769c027170a0ea$export$56d961ef3a52a072);

var $d8KcD = parcelRequire("d8KcD");
parcelRequire("6AxhP");
var $g71FP = parcelRequire("g71FP");
var $jXuA5 = parcelRequire("jXuA5");
var $3Fm3S = parcelRequire("3Fm3S");

var $l8b6O = parcelRequire("l8b6O");
/** Patch toString calls to return proper name for wrapped functions */ var $b2769c027170a0ea$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $d8KcD.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $g71FP.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $d8KcD.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $3Fm3S.normalize)(errorData, this._options.depth);
            if ((0, $g71FP.isPlainObject)(normalizedErrorData)) contexts = (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $d8KcD.__assign)({}, normalizedErrorData), _a));
            return (0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $d8KcD.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $g71FP.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $d8KcD.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $g71FP.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $l8b6O.IS_DEBUG_BUILD) && (0, $jXuA5.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();

});

parcelRegister("8lQwm", function(module, exports) {
$parcel$export(module.exports, "Transaction", () => $614906748be86410$export$febc5573c75cefb0);
/** Add node transaction to the event */ var $614906748be86410$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();

});



parcelRegister("k554N", function(module, exports) {
$parcel$export(module.exports, "initialiseErrorAnalyticsClient", () => $f6cc687afcad3650$export$d4079397f9611138);
$parcel$export(module.exports, "default", () => $f6cc687afcad3650$export$2e2bcd8739ae039);

var $iLkO5 = parcelRequire("iLkO5");

var $4CTsu = parcelRequire("4CTsu");

var $eeiwC = parcelRequire("eeiwC");
var $3IJ1B = parcelRequire("3IJ1B");

var $9JJ6l = parcelRequire("9JJ6l");
let $f6cc687afcad3650$var$analyticsClient;
const $f6cc687afcad3650$export$d4079397f9611138 = (client)=>{
    $f6cc687afcad3650$var$analyticsClient = client;
};
const $f6cc687afcad3650$export$bf406c01a195b215 = ()=>{
    $f6cc687afcad3650$var$analyticsClient = undefined;
};
const $f6cc687afcad3650$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $eeiwC.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($4CTsu)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($iLkO5))));
        if (event && event.context) {
            const fullEvent = (0, $eeiwC.extractAWCDataFromEvent)(event);
            (0, $9JJ6l.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $9JJ6l.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $3IJ1B.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($f6cc687afcad3650$var$analyticsClient && $f6cc687afcad3650$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $f6cc687afcad3650$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $9JJ6l.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $f6cc687afcad3650$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $f6cc687afcad3650$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $f6cc687afcad3650$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $f6cc687afcad3650$export$2e2bcd8739ae039 = $f6cc687afcad3650$var$fireErrorAnalytics;

});

parcelRegister("7S2MH", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");

var $k554N = parcelRequire("k554N");
class $bd9ce2571d4646be$var$CatchAndReportErrors extends (0, $4fqPo.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $k554N.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children);
    }
}
const $bd9ce2571d4646be$var$reportingErrorBoundary = (0, $as4kh.default)()($bd9ce2571d4646be$var$CatchAndReportErrors);
var $bd9ce2571d4646be$export$2e2bcd8739ae039 = $bd9ce2571d4646be$var$reportingErrorBoundary;

});


parcelRegister("juiRU", function(module, exports) {
$parcel$export(module.exports, "getErrorType", () => $a4f5868dba7f3184$export$e19f9f08a6d79fd2);

var $7Z15Y = parcelRequire("7Z15Y");
const $a4f5868dba7f3184$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $a4f5868dba7f3184$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $a4f5868dba7f3184$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $a4f5868dba7f3184$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $a4f5868dba7f3184$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $a4f5868dba7f3184$export$89a175d4190df42e = 'Invoke value functions failed:';
const $a4f5868dba7f3184$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $a4f5868dba7f3184$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $a4f5868dba7f3184$var$BAD_REQUEST = 400;
const $a4f5868dba7f3184$var$REQUEST_TIMEOUT = 408;
const $a4f5868dba7f3184$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $a4f5868dba7f3184$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>{
        var _error$stack;
        return Boolean(typeof error === 'object' && error.name === 'TimeoutError' && ((_error$stack = error.stack) === null || _error$stack === void 0 ? void 0 : _error$stack.includes(timedOutResource)));
    };
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $a4f5868dba7f3184$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = (match === null || match === void 0 ? void 0 : match[1]) ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $a4f5868dba7f3184$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($a4f5868dba7f3184$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $a4f5868dba7f3184$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($a4f5868dba7f3184$export$89a175d4190df42e, 'i');
    /**
   * In case when we get bad request(400) from the BE it should be treated as an app error as there
   * are many ways to fail the value function
   */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $a4f5868dba7f3184$var$BAD_REQUEST;
    /**
   * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
   * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
   */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $a4f5868dba7f3184$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
   * 	Whole message:
   *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
   */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
   * 	Whole message:
   *	Invoke value functions failed: Error server response: 429
   */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $a4f5868dba7f3184$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($a4f5868dba7f3184$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($a4f5868dba7f3184$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $7Z15Y.isClientFetchError)(error)) return $a4f5868dba7f3184$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("7Z15Y", function(module, exports) {
$parcel$export(module.exports, "isClientFetchError", () => $27c9ccffa63ff92c$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $27c9ccffa63ff92c$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $27c9ccffa63ff92c$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $27c9ccffa63ff92c$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $27c9ccffa63ff92c$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $27c9ccffa63ff92c$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($27c9ccffa63ff92c$export$3876cb851aa46193.includes(error.name) || $27c9ccffa63ff92c$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($27c9ccffa63ff92c$export$3876cb851aa46193.includes(error.cause.name) || $27c9ccffa63ff92c$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("bjzpQ", function(module, exports) {
$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $e8c18fd86f4e04f8$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $e8c18fd86f4e04f8$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $e8c18fd86f4e04f8$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $e8c18fd86f4e04f8$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $e8c18fd86f4e04f8$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $e8c18fd86f4e04f8$export$ef45e4471aa21b27);

var $8MIxg = parcelRequire("8MIxg");

var $iunpX = parcelRequire("iunpX");
const $e8c18fd86f4e04f8$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $e8c18fd86f4e04f8$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $iunpX.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $e8c18fd86f4e04f8$export$e48d55f9cf9962ce(viewType) {
    return (0, $iunpX.getViewConfiguration)(viewType) !== undefined;
}
function $e8c18fd86f4e04f8$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $e8c18fd86f4e04f8$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$e8c18fd86f4e04f8$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $8MIxg.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $e8c18fd86f4e04f8$export$e4330d77fd93d1de = (viewType)=>$e8c18fd86f4e04f8$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $e8c18fd86f4e04f8$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e8c18fd86f4e04f8$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $e8c18fd86f4e04f8$export$20eabd2b3ada6bf3(viewType) {
    return $e8c18fd86f4e04f8$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $e8c18fd86f4e04f8$export$b768d6a95f7a930(context) {
    return $e8c18fd86f4e04f8$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $e8c18fd86f4e04f8$export$b0297573c90085aa(viewType) {
    return $e8c18fd86f4e04f8$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $e8c18fd86f4e04f8$export$c0728caa743a409e(viewType) {
    return $e8c18fd86f4e04f8$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $e8c18fd86f4e04f8$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $e8c18fd86f4e04f8$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("iunpX", function(module, exports) {
$parcel$export(module.exports, "getViewConfiguration", () => $34bca605c98029a1$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $34bca605c98029a1$export$f0022a21ccd1f6be);

var $4fqPo = parcelRequire("4fqPo");
const $34bca605c98029a1$var$VIEW_CONFIGURATIONS = new Map();
const $34bca605c98029a1$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$34bca605c98029a1$var$VIEW_CONFIGURATIONS.has(viewType)) $34bca605c98029a1$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $34bca605c98029a1$export$176b6e68da08ffa2 = (viewType)=>$34bca605c98029a1$var$VIEW_CONFIGURATIONS.get(viewType);
const $34bca605c98029a1$export$e8091eff40c4f16e = ()=>{
    $34bca605c98029a1$var$VIEW_CONFIGURATIONS.clear();
};
const $34bca605c98029a1$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    /**
   * Uses useMemo to load view configuration during the first render, before mount.
   */ (0, $4fqPo.useMemo)(()=>{
        $34bca605c98029a1$export$cda1ad403b37fe70(viewType, new configurationClass());
    }, [
        viewType,
        configurationClass
    ]);
};

});




parcelRegister("64KZH", function(module, exports) {
$parcel$export(module.exports, "initializeNoScreenTab", () => $86b385c7aacfe551$export$93459ad9bfd6c380);
const $86b385c7aacfe551$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("jy9dp", function(module, exports) {
$parcel$export(module.exports, "initializeScreenTabs", () => $a1b565bd4ff239a7$export$7f7be235f64f029b);
const $a1b565bd4ff239a7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs === null || internalScreenTabs === void 0 ? void 0 : internalScreenTabs.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("5CB4W", function(module, exports) {
$parcel$export(module.exports, "processChange", () => $b8d2bad8838cbeea$export$352dfcce04d66748);

var $6h9f5 = parcelRequire("6h9f5");

var $bjzpQ = parcelRequire("bjzpQ");

var $cJbyt = parcelRequire("cJbyt");
const $b8d2bad8838cbeea$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        var _internalFormMetadata, _getSupportedFieldCon;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = (_internalFormMetadata = internalFormMetadata[fieldId]) === null || _internalFormMetadata === void 0 ? void 0 : _internalFormMetadata.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (_getSupportedFieldCon = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $cJbyt.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
   * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
   * Otherwise, UIM app may not be notified about every single change.
   */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($6h9f5)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("6h9f5", function(module, exports) {

var $lOV73 = parcelRequire("lOV73");
/** Used to generate unique IDs. */ var $491b7ff0faa0834a$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $491b7ff0faa0834a$var$uniqueId(prefix) {
    var id = ++$491b7ff0faa0834a$var$idCounter;
    return $lOV73(prefix) + id;
}
module.exports = $491b7ff0faa0834a$var$uniqueId;

});

parcelRegister("cJbyt", function(module, exports) {
$parcel$export(module.exports, "calculateNextFormValue", () => $6b9842f3724b0462$export$25441a03bb8f1cb0);

var $2186w = parcelRequire("2186w");

var $1FeZZ = parcelRequire("1FeZZ");
const $6b9842f3724b0462$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    var _formData$fieldId;
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $1FeZZ.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = (_formData$fieldId = formData[fieldId]) === null || _formData$fieldId === void 0 ? void 0 : _formData$fieldId.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($2186w)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("gBbL4", function(module, exports) {
$parcel$export(module.exports, "registerFields", () => $6e60f49bd983dd2e$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $6e60f49bd983dd2e$export$1ca69a85bb7273de);

var $f6zHi = parcelRequire("f6zHi");

var $1qNjk = parcelRequire("1qNjk");
const $6e60f49bd983dd2e$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($1qNjk)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $6e60f49bd983dd2e$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($f6zHi)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("5Hoj2", function(module, exports) {
$parcel$export(module.exports, "setFieldValue", () => $38e0fc7dc23f285a$export$6556d46d2662453c);

var $cJbyt = parcelRequire("cJbyt");
const $38e0fc7dc23f285a$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
   * We can set new field value only if the field was initialized.
   * This checks the field metedata that indicates the successfull initialization.
   */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $cJbyt.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("3U90i", function(module, exports) {
$parcel$export(module.exports, "updateActiveScreenTab", () => $92951403981041d1$export$21363496760d39cd);
const $92951403981041d1$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("7EW1F", function(module, exports) {
$parcel$export(module.exports, "updateFields", () => $7d2a24e2692a8684$export$cceae62fd4d1ef0a);

var $iLkO5 = parcelRequire("iLkO5");

var $cM1tn = parcelRequire("cM1tn");

var $jBMwY = parcelRequire("jBMwY");

var $34ioR = parcelRequire("34ioR");

var $4nCmv = parcelRequire("4nCmv");

var $cGeNv = parcelRequire("cGeNv");

var $fDEdx = parcelRequire("fDEdx");

var $3vTAP = parcelRequire("3vTAP");

var $gBVLh = parcelRequire("gBVLh");

var $8BdtR = parcelRequire("8BdtR");

var $h3pDv = parcelRequire("h3pDv");

var $3vGZ8 = parcelRequire("3vGZ8");
const $7d2a24e2692a8684$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, lastProcessedChange: lastProcessedChange } = getState();
        let isSameFieldValueChanged = false;
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $cGeNv.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $8BdtR.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $jBMwY.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY)]: internalMetadata.allowedValues,
                [(0, $jBMwY.LOOKUP_SOURCE_USERS_ASYNC_DATA)]: lookupDataFromApi[0, $jBMwY.LOOKUP_SOURCE_USERS_ASYNC_DATA],
                [(0, $jBMwY.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA)]: lookupDataFromApi[0, $jBMwY.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $3vGZ8.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $gBVLh.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges === null || fieldsChanges === void 0 ? void 0 : fieldsChanges[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fDEdx.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            isSameFieldValueChanged = (0, $34ioR.checkSameFieldValueChanged)(fieldsChanges, lastProcessedChange, changeId);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges,
                isSameFieldValueChanged: isSameFieldValueChanged
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($iLkO5)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iLkO5)))(errorsByField)) throw new (0, $4nCmv.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $3vTAP.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $h3pDv.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
parcelRegister("jBMwY", function(module, exports) {
$parcel$export(module.exports, "LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY", () => $750126a29274c5ce$export$a1cacdcf198da901);
$parcel$export(module.exports, "LOOKUP_SOURCE_USERS_ASYNC_DATA", () => $750126a29274c5ce$export$3a106242c8f57ac2);
$parcel$export(module.exports, "LOOKUP_SOURCE_PROJECTS_ASYNC_DATA", () => $750126a29274c5ce$export$e10d4d251d909c59);
$parcel$export(module.exports, "AUTOMATIC_ID", () => $750126a29274c5ce$export$f5d5f6bb902f1027);
const $750126a29274c5ce$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $750126a29274c5ce$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $750126a29274c5ce$export$e10d4d251d909c59 = 'LOOKUP_SOURCE_PROJECTS_ASYNC_DATA';
const $750126a29274c5ce$export$f5d5f6bb902f1027 = '-1';
const $750126a29274c5ce$export$106087dcfd4fb129 = 100;

});

parcelRegister("34ioR", function(module, exports) {
$parcel$export(module.exports, "checkSameFieldValueChanged", () => $353a5808a8206965$export$4027d961191df7c3);
function $353a5808a8206965$export$4027d961191df7c3(fieldsChanges, lastProcessedChange, changeId) {
    if (fieldsChanges && (lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.changeId) === changeId) {
        const fid = lastProcessedChange === null || lastProcessedChange === void 0 ? void 0 : lastProcessedChange.fieldId;
        const change = fieldsChanges[fid];
        return !!change && change.hasOwnProperty('value');
    }
    return false;
}

});

parcelRegister("4nCmv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $a6a318748a43e362$export$9e8b5e552e255163);

var $7PG1r = parcelRequire("7PG1r");
class $a6a318748a43e362$export$9e8b5e552e255163 extends (0, $7PG1r.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("7PG1r", function(module, exports) {
$parcel$export(module.exports, "UiModificationsValidationError", () => $a257fa53a04cd629$export$6e8165c81a6a65df);
class $a257fa53a04cd629$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("cGeNv", function(module, exports) {
$parcel$export(module.exports, "fieldWasRegistered", () => $73ef92807245566c$export$fbe9157c12cb4e7b);
const $73ef92807245566c$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>{
    var _registeredFields$app;
    return !!((_registeredFields$app = registeredFields[appId]) !== null && _registeredFields$app !== void 0 && (_registeredFields$app = _registeredFields$app[changeId]) !== null && _registeredFields$app !== void 0 && _registeredFields$app.includes(fieldId));
};

});

parcelRegister("fDEdx", function(module, exports) {
$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $9bc4c8fef956e098$export$460820f27643954e);

var $bjzpQ = parcelRequire("bjzpQ");
const $9bc4c8fef956e098$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("3vTAP", function(module, exports) {
$parcel$export(module.exports, "prepareErrorsArray", () => $810b74f738334429$export$e1fce51bc5be90b7);
const $810b74f738334429$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("gBVLh", function(module, exports) {
$parcel$export(module.exports, "transformFieldToIframe", () => $039000fdfea0fec0$export$aa453854f74fab);

var $8MIxg = parcelRequire("8MIxg");

var $bjzpQ = parcelRequire("bjzpQ");
const $039000fdfea0fec0$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $8MIxg.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers !== null && fieldInternalToPublicTransformers !== void 0 && fieldInternalToPublicTransformers.optionsVisibility) try {
        const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers === null || fieldInternalToPublicTransformers === void 0 ? void 0 : fieldInternalToPublicTransformers.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $8MIxg.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("3vGZ8", function(module, exports) {
$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $c63853713f999f66$export$d14f85c01e334a1);

var $iLkO5 = parcelRequire("iLkO5");

var $cLHRt = parcelRequire("cLHRt");

var $bjzpQ = parcelRequire("bjzpQ");

var $6fUbn = parcelRequire("6fUbn");

var $iIf9n = parcelRequire("iIf9n");

var $hQkmi = parcelRequire("hQkmi");

var $hYKCW = parcelRequire("hYKCW");
const $c63853713f999f66$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    const fieldConfiguration = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $hQkmi.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $hQkmi.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $cLHRt.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $6fUbn.FIELD_VALIDATION_ERROR),
                        method: (0, $iIf9n.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hYKCW.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($iLkO5)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hYKCW.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("cLHRt", function(module, exports) {
$parcel$export(module.exports, "FieldValueLookupError", () => $49365879de27e9bf$export$73c2f0689b6c4a5a);
class $49365879de27e9bf$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("hQkmi", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $5c45d252117dbcc2$export$ee79e3ab53b8db79);
const $5c45d252117dbcc2$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hYKCW", function(module, exports) {
$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e99c71df37f971fb$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e99c71df37f971fb$export$ddd005554aecd409);
const $e99c71df37f971fb$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e99c71df37f971fb$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("cggCb", function(module, exports) {
$parcel$export(module.exports, "updateScreenTabs", () => $e2736bc1bc7ac6fb$export$131c67fd312b8a11);

var $1j0gv = parcelRequire("1j0gv");

var $orVeD = parcelRequire("orVeD");

var $h3pDv = parcelRequire("h3pDv");

var $bei1l = parcelRequire("bei1l");
const $e2736bc1bc7ac6fb$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $bei1l.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $bei1l.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $h3pDv.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $1j0gv.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $bei1l.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $orVeD.toScreenTabsValidationError))
        });
    };

});
parcelRegister("1j0gv", function(module, exports) {
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $722bac30052b49ec$export$faf1f1824ee0a136);

var $7PG1r = parcelRequire("7PG1r");
class $722bac30052b49ec$export$faf1f1824ee0a136 extends (0, $7PG1r.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("orVeD", function(module, exports) {
$parcel$export(module.exports, "toScreenTabsValidationError", () => $cd28bbcee5388223$export$b2675440ade984fb);

var $6fUbn = parcelRequire("6fUbn");
const $cd28bbcee5388223$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $6fUbn.SCREENTABS_VALIDATION_ERROR)
    });

});

parcelRegister("bei1l", function(module, exports) {
$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $d0941795bb7ea180$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $d0941795bb7ea180$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $d0941795bb7ea180$export$62d63af83dac7315);
const $d0941795bb7ea180$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $d0941795bb7ea180$var$isValidScreenTabId = (internalScreenTabs, id)=>$d0941795bb7ea180$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $d0941795bb7ea180$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $d0941795bb7ea180$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $d0941795bb7ea180$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$d0941795bb7ea180$var$isValidScreenTabId(internalScreenTabs, id) && $d0941795bb7ea180$var$isValidScreenTabIsVisible(isVisible) && $d0941795bb7ea180$var$isValidScreenTabIsActive(isActive);
const $d0941795bb7ea180$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($d0941795bb7ea180$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $d0941795bb7ea180$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($d0941795bb7ea180$var$isValidScreenTabIsActive(isActive) && isActive && $d0941795bb7ea180$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $d0941795bb7ea180$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    var _screenTabsInternalUp;
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof ((_screenTabsInternalUp = screenTabsInternalUpdated[0]) === null || _screenTabsInternalUp === void 0 ? void 0 : _screenTabsInternalUp.isActive) !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $d0941795bb7ea180$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$d0941795bb7ea180$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($d0941795bb7ea180$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($d0941795bb7ea180$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $d0941795bb7ea180$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    screenTabsFromApp.forEach((tab)=>{
        if (!$d0941795bb7ea180$var$isValidScreenTabData(internalScreenTabs, tab)) {
            if (!$d0941795bb7ea180$var$isValidScreenTabId(internalScreenTabs, tab.id)) errors.push(`Screen tab with id ${tab.id} does not exist in the current view.`);
            if (!$d0941795bb7ea180$var$isValidScreenTabIsVisible(tab.isVisible)) errors.push(`Visible state for tab with id ${tab.id} should be a boolean.`);
            if (!$d0941795bb7ea180$var$isValidScreenTabIsActive(tab.isActive)) errors.push(`Active state for tab with id ${tab.id} should be a boolean.`);
        }
    });
    if (screenTabsFromApp.reduce($d0941795bb7ea180$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($d0941795bb7ea180$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("lsxWh", function(module, exports) {
$parcel$export(module.exports, "REQUEST_CREATE_VIEW_TYPE", () => $e09133e2d1d28c8d$export$f5706508058e3b54);
const $e09133e2d1d28c8d$export$f5706508058e3b54 = 'JSMRequestCreate';

});

parcelRegister("a7h0I", function(module, exports) {
$parcel$export(module.exports, "RequestCreateViewConfiguration", () => $9370c20f8762150d$export$4193c77f3bdf79ba);

var $h9L3N = parcelRequire("h9L3N");

var $jE04u = parcelRequire("jE04u");

var $6bGmX = parcelRequire("6bGmX");

var $jBMwY = parcelRequire("jBMwY");

var $6S4ZY = parcelRequire("6S4ZY");

var $bXFdW = parcelRequire("bXFdW");

var $e15Dw = parcelRequire("e15Dw");

var $dolCK = parcelRequire("dolCK");

var $1Nhsz = parcelRequire("1Nhsz");

var $3grTu = parcelRequire("3grTu");

var $7CtOF = parcelRequire("7CtOF");

var $83u1M = parcelRequire("83u1M");

var $g8EKv = parcelRequire("g8EKv");

var $3J6SV = parcelRequire("3J6SV");

var $1o0qW = parcelRequire("1o0qW");

var $3nyVH = parcelRequire("3nyVH");

var $8Lwxf = parcelRequire("8Lwxf");

var $gg4Bp = parcelRequire("gg4Bp");

var $h84GV = parcelRequire("h84GV");

var $gAthg = parcelRequire("gAthg");

var $ZA0ms = parcelRequire("ZA0ms");

var $9MwOS = parcelRequire("9MwOS");

var $gTqbb = parcelRequire("gTqbb");
const $9370c20f8762150d$export$b3302682bd74b905 = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_embedded_request_page');
const $9370c20f8762150d$export$97cf619b5c503901 = ()=>(0, $6bGmX.default).checkGate('uim_jsm_textfield_support');
const $9370c20f8762150d$export$3d9060e51ab7079e = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_multi_select_support');
const $9370c20f8762150d$export$5377338157c93a4a = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_number_field_support');
const $9370c20f8762150d$export$ca4e8050793caa6 = ()=>(0, $6bGmX.default).checkGate('uim_jsm_duedate_support');
const $9370c20f8762150d$export$a3127feadc5f63ef = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_datetime_field_support');
const $9370c20f8762150d$export$682d85ee096f07a9 = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_textarea_support');
const $9370c20f8762150d$export$120971fff910541d = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_description_support');
const $9370c20f8762150d$export$b738c6acf33d051a = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_cascading_select_support');
const $9370c20f8762150d$export$1df7079ae40c80e4 = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_datepicker_field_support');
const $9370c20f8762150d$export$fe4ccb1b2f4366aa = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_labels_support');
const $9370c20f8762150d$export$d16c700a701ab994 = ()=>(0, $6bGmX.default).checkGate('ditto_uim_jsm_user_picker_support');
class $9370c20f8762150d$export$4193c77f3bdf79ba {
    getAnalytics() {
        return this.analytics;
    }
    /**
   * On other views in Jira, we check if we support a specific project type available from execution context
   * Here, in JSM, there is nothing specific available from Execution Context that we should check
   */ isExecutionContextSupported() {
        return true;
    }
    getConsentMessage() {
        return (0, $9MwOS.default).obligatoryUimRequestCreateConsentMessage;
    }
    getSupportedTriggerPointsConfiguration() {
        if ($9370c20f8762150d$export$b3302682bd74b905()) return new Set([
            (0, $3grTu.DEFAULT),
            (0, $3grTu.EMBEDDED_REQUEST_CREATE)
        ]);
        return new Set([
            (0, $3grTu.DEFAULT)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $1Nhsz.stopTTI,
            cancelTTI: $1Nhsz.cancelTTI,
            markIframeLoad: $1Nhsz.markIframeLoad,
            markFieldsRegistered: $1Nhsz.markFieldsRegistered,
            markOnInitResolved: $1Nhsz.markOnInitResolved
        };
        /**
   * memoizeOne is used to avoid recreating the config objects.
   */ this.getSupportedFieldsConfiguration = (0, $jE04u.default)(()=>{
            const commonFieldValidators = (0, $6S4ZY.getCommonFieldValidators)();
            return {
                [(0, $3grTu.SUMMARY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $e15Dw.validateSingleLineTextValue)
                    },
                    publicToInternalTransformers: {},
                    internalToPublicTransformers: {
                        value: (0, $h84GV.singleLineTextFieldGetValueTransformer)
                    },
                    emitChangeOn: 'blur',
                    modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                },
                [(0, $3grTu.SELECT_CF_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $bXFdW.selectSetValueValidator),
                        optionsVisibility: (0, $dolCK.validateSetOptionsVisibilityRule)
                    },
                    publicToInternalTransformers: {
                        value: (0, $gg4Bp.selectSetValueTransformer),
                        optionsVisibility: (0, $gg4Bp.transformSelectSetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $gg4Bp.selectGetValueTransformer),
                        optionsVisibility: (0, $gg4Bp.transformSelectGetOptionsVisibility)
                    },
                    lookupSource: (0, $jBMwY.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    emitChangeOn: 'change',
                    modifyValueToBasic: (0, $gg4Bp.modifySelectValueToBasic)
                },
                ...$9370c20f8762150d$export$97cf619b5c503901() && {
                    [(0, $3grTu.TEXT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $e15Dw.validateSingleLineTextValue)
                        },
                        publicToInternalTransformers: {},
                        internalToPublicTransformers: {
                            value: (0, $h84GV.singleLineTextFieldGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$5377338157c93a4a() && {
                    [(0, $3grTu.NUMBER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $3nyVH.validateNumberValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $3nyVH.transformNumberToInternalValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $3nyVH.transformNumberToPublicValue)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$3d9060e51ab7079e() && {
                    [(0, $3grTu.MULTI_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $1o0qW.validateMultiCheckboxSetValue),
                            optionsVisibility: (0, $dolCK.validateSetOptionsVisibilityRule)
                        },
                        publicToInternalTransformers: {
                            value: (0, $1o0qW.multiCheckboxSetValueTransformer),
                            optionsVisibility: (0, $1o0qW.multiCheckboxSetOptionsVisibilityTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $1o0qW.multiCheckboxGetValueTransformer),
                            optionsVisibility: (0, $1o0qW.multiCheckboxGetOptionsVisibilityTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $jBMwY.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        propertyMapping: {
                            optionsVisibility: 'options'
                        },
                        modifyValueToBasic: (0, $1o0qW.modifyMultiSelectValueToBasic)
                    }
                },
                [(0, $3grTu.PRIORITY_TYPE)]: {
                    publicShapeValidators: {
                        ...commonFieldValidators,
                        value: (0, $8Lwxf.validatePrioritySetValue),
                        optionsVisibility: (0, $gTqbb.validateSetOptionsVisibility)
                    },
                    publicToInternalTransformers: {
                        value: (0, $8Lwxf.prioritySetValueTransformer),
                        optionsVisibility: (0, $8Lwxf.prioritySetOptionsVisibility)
                    },
                    internalToPublicTransformers: {
                        value: (0, $8Lwxf.priorityGetValueTransformer),
                        optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    },
                    emitChangeOn: 'change',
                    lookupSource: (0, $jBMwY.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                    initializeFieldPropertyMapping: {
                        allowedValues: 'options',
                        value: 'defaultValue'
                    },
                    propertyMapping: {
                        optionsVisibility: 'options'
                    },
                    modifyValueToBasic: (0, $8Lwxf.modifyPriorityValueToBasic)
                },
                ...$9370c20f8762150d$export$ca4e8050793caa6() && {
                    [(0, $3grTu.DUE_DATE_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $83u1M.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $83u1M.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $83u1M.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$a3127feadc5f63ef() && {
                    [(0, $3grTu.DATETIME_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $g8EKv.validateDateTimePickerSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $g8EKv.transformDateTimePickerSetValue)
                        },
                        internalToPublicTransformers: {
                            value: (0, $g8EKv.transformDateTimePickerGetValue)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$682d85ee096f07a9() && {
                    [(0, $3grTu.TEXT_AREA_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $gAthg.validateTextAreaValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $gAthg.textAreaSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $gAthg.textAreaGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$120971fff910541d() && {
                    [(0, $3grTu.DESCRIPTION_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $gAthg.validateTextAreaValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $gAthg.textAreaSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $gAthg.textAreaGetValueTransformer)
                        },
                        emitChangeOn: 'blur',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$b738c6acf33d051a() && {
                    [(0, $3grTu.CASCADING_SELECT_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $7CtOF.validateCascadingSelectSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $7CtOF.transformSetValueCascadingSelect)
                        },
                        internalToPublicTransformers: {
                            value: (0, $7CtOF.transformGetValueCascadingSelect)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $jBMwY.LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY),
                        initializeFieldPropertyMapping: {
                            allowedValues: 'options',
                            value: 'defaultValue'
                        },
                        modifyValueToBasic: (0, $7CtOF.transformValueToBasicCascadingSelect)
                    }
                },
                ...$9370c20f8762150d$export$1df7079ae40c80e4() && {
                    [(0, $3grTu.DATEPICKER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $83u1M.datePickerSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $83u1M.datePickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $83u1M.datePickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        modifyValueToBasic: (0, (/*@__PURE__*/$parcel$interopDefault($h9L3N)))
                    }
                },
                ...$9370c20f8762150d$export$fe4ccb1b2f4366aa() && {
                    [(0, $3grTu.LABELS_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $3J6SV.labelsSetValueValidator)
                        },
                        publicToInternalTransformers: {
                            value: (0, $3J6SV.labelsSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $3J6SV.labelsGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        initializeFieldPropertyMapping: {
                            value: 'defaultLabels'
                        },
                        modifyValueToBasic: (0, $3J6SV.modifyLabelsValueToBasic)
                    }
                },
                ...$9370c20f8762150d$export$d16c700a701ab994() && {
                    [(0, $3grTu.USER_CF_TYPE)]: {
                        publicShapeValidators: {
                            ...commonFieldValidators,
                            value: (0, $ZA0ms.validateUserPickerSetValue)
                        },
                        publicToInternalTransformers: {
                            value: (0, $ZA0ms.userPickerSetValueTransformer)
                        },
                        internalToPublicTransformers: {
                            value: (0, $ZA0ms.userPickerGetValueTransformer)
                        },
                        emitChangeOn: 'change',
                        lookupSource: (0, $jBMwY.LOOKUP_SOURCE_USERS_ASYNC_DATA),
                        initializeFieldPropertyMapping: {
                            value: 'defaultUser'
                        },
                        modifyValueToBasic: (0, $ZA0ms.modifyUserPickerValueToBasic)
                    }
                }
            };
        });
        this.getSupportedFieldTypes = (0, $jE04u.default)(()=>{
            const supportedFieldTypes = [
                (0, $3grTu.SUMMARY_TYPE),
                (0, $3grTu.SELECT_CF_TYPE),
                (0, $3grTu.USER_CF_TYPE),
                (0, $3grTu.TEXT_CF_TYPE),
                (0, $3grTu.TEXT_AREA_CF_TYPE),
                (0, $3grTu.DESCRIPTION_TYPE),
                (0, $3grTu.NUMBER_CF_TYPE),
                (0, $3grTu.MULTI_SELECT_CF_TYPE),
                (0, $3grTu.PRIORITY_TYPE),
                (0, $3grTu.DATETIME_CF_TYPE),
                (0, $3grTu.DUE_DATE_TYPE),
                (0, $3grTu.CASCADING_SELECT_CF_TYPE),
                (0, $3grTu.DATEPICKER_CF_TYPE),
                (0, $3grTu.LABELS_TYPE)
            ];
            return supportedFieldTypes;
        });
        // Note: should be removed by bumping @atlassian/ui-modifications-core to the next minor version. Behavior will default to being true.
        this.isScreenTabsSupportEnabled = ()=>true;
    }
}

});
parcelRegister("6S4ZY", function(module, exports) {
$parcel$export(module.exports, "getCommonFieldValidators", () => $9e019b221a65b7d2$export$68248012b0fecf7d);
const $9e019b221a65b7d2$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $9e019b221a65b7d2$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $9e019b221a65b7d2$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    return true;
};

});

parcelRegister("bXFdW", function(module, exports) {
$parcel$export(module.exports, "selectSetValueValidator", () => $f4adfc057ef36c2f$export$c02b1c2a574ca4c7);

var $7aIb2 = parcelRequire("7aIb2");

var $eBPD7 = parcelRequire("eBPD7");
const $f4adfc057ef36c2f$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $eBPD7.isNotEmptyString)(value);
const $f4adfc057ef36c2f$export$f22935386c756879 = (value)=>value === null || (0, $eBPD7.isNotEmptyString)(value) && (0, $7aIb2.isAriResourceIdValid)(value);

});
parcelRegister("7aIb2", function(module, exports) {
$parcel$export(module.exports, "isAriResourceIdValid", () => $08f9ccf2740d17ee$export$4d1e9901084f3bf6);

var $eLW5g = parcelRequire("eLW5g");
const $08f9ccf2740d17ee$var$CLOUD_ID_MOCK = 'cloud-id';
const $08f9ccf2740d17ee$var$ACTIVATION_ID_MOCK = 'activation-id';
const $08f9ccf2740d17ee$var$FIELD_ID_MOCK = 'field-1';
const $08f9ccf2740d17ee$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $eLW5g.JiraIssueFieldOptionAri).create({
            siteId: $08f9ccf2740d17ee$var$CLOUD_ID_MOCK,
            activationId: $08f9ccf2740d17ee$var$ACTIVATION_ID_MOCK,
            fieldId: $08f9ccf2740d17ee$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("eLW5g", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $ac1282bb3e1c1392$export$e3bc1ec22f941fbe);

var $9yN7O = parcelRequire("9yN7O");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/jira/issue-field-option/manifest.ts
var $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9yN7O.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $9yN7O.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/,
        optionId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $ac1282bb3e1c1392$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $ac1282bb3e1c1392$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("9yN7O", function(module, exports) {
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $6f5d6537dd021bbe$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $6f5d6537dd021bbe$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $6f5d6537dd021bbe$export$eb4f4cf0880fe5a8 = "jira", $6f5d6537dd021bbe$export$4bec333360908e78 = "issue-field-option";

});



parcelRegister("eBPD7", function(module, exports) {
$parcel$export(module.exports, "isNotEmptyString", () => $7b1d9e6715f9ca15$export$582443c7ead02173);
const $7b1d9e6715f9ca15$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});


parcelRegister("e15Dw", function(module, exports) {
$parcel$export(module.exports, "validateSingleLineTextValue", () => $08119433bd880e5f$export$88db43fe998a9953);
const $08119433bd880e5f$export$88db43fe998a9953 = (value)=>typeof value === 'string';

});

parcelRegister("dolCK", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $1afc4996595bdaec$export$cb8a43658ea03ec7);

var $p4u5f = parcelRequire("p4u5f");

var $eBPD7 = parcelRequire("eBPD7");
const $1afc4996595bdaec$export$cb8a43658ea03ec7 = (optionsVisibility)=>(0, (/*@__PURE__*/$parcel$interopDefault($p4u5f)))(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $eBPD7.isNotEmptyString));

});

parcelRegister("1Nhsz", function(module, exports) {
$parcel$export(module.exports, "startScreenTTIWithUIModifications", () => $7547c65abcd83f4b$export$750bc2c2ef1a94b6);
$parcel$export(module.exports, "stopTTI", () => $7547c65abcd83f4b$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $7547c65abcd83f4b$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $7547c65abcd83f4b$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $7547c65abcd83f4b$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $7547c65abcd83f4b$export$d86f4868694f2aa7);

var $hn5Pa = parcelRequire("hn5Pa");
const $7547c65abcd83f4b$export$376630eeb367a07a = (0, $hn5Pa.metrics).interaction({
    key: 'request-create-tti-with-ui-modifications',
    timings: [
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $7547c65abcd83f4b$export$750bc2c2ef1a94b6 = ()=>{
    $7547c65abcd83f4b$export$376630eeb367a07a.start();
};
const $7547c65abcd83f4b$export$30ca4c461fab486c = (customData)=>{
    $7547c65abcd83f4b$export$376630eeb367a07a.stop({
        customData: customData
    });
};
const $7547c65abcd83f4b$export$27f2445288b528c = ()=>{
    $7547c65abcd83f4b$export$376630eeb367a07a.cancel();
};
const $7547c65abcd83f4b$export$7a2709fc1e33401a = ()=>{
    $7547c65abcd83f4b$export$376630eeb367a07a.mark('iframe-load');
};
const $7547c65abcd83f4b$export$cf3893335c93e33b = ()=>{
    $7547c65abcd83f4b$export$376630eeb367a07a.mark('fields-registered');
};
const $7547c65abcd83f4b$export$d86f4868694f2aa7 = ()=>{
    $7547c65abcd83f4b$export$376630eeb367a07a.mark('oninit-resolved');
};

});

parcelRegister("3grTu", function(module, exports) {
$parcel$export(module.exports, "SUMMARY_TYPE", () => $956bae7e1322abda$export$907219511d14ba3d);
$parcel$export(module.exports, "SELECT_CF_TYPE", () => $956bae7e1322abda$export$22ac48a51c014e4b);
$parcel$export(module.exports, "USER_CF_TYPE", () => $956bae7e1322abda$export$c491a4b98394028e);
$parcel$export(module.exports, "TEXT_CF_TYPE", () => $956bae7e1322abda$export$68c7e01d5460d298);
$parcel$export(module.exports, "TEXT_AREA_CF_TYPE", () => $956bae7e1322abda$export$39cd48613b53ce2f);
$parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", () => $956bae7e1322abda$export$c5d13ea26562d57a);
$parcel$export(module.exports, "PRIORITY_TYPE", () => $956bae7e1322abda$export$34740f8d07d23ac0);
$parcel$export(module.exports, "NUMBER_CF_TYPE", () => $956bae7e1322abda$export$c7faa96db185cfc6);
$parcel$export(module.exports, "DATETIME_CF_TYPE", () => $956bae7e1322abda$export$42d097f7b1622ef1);
$parcel$export(module.exports, "DUE_DATE_TYPE", () => $956bae7e1322abda$export$b159f8b8f27aae4c);
$parcel$export(module.exports, "DESCRIPTION_TYPE", () => $956bae7e1322abda$export$5e7324042f1d6b31);
$parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", () => $956bae7e1322abda$export$c3c9f8a8a8dc0b30);
$parcel$export(module.exports, "DATEPICKER_CF_TYPE", () => $956bae7e1322abda$export$69c9cc9ff399807f);
$parcel$export(module.exports, "LABELS_TYPE", () => $956bae7e1322abda$export$43b6e33ec70f2272);
$parcel$export(module.exports, "DEFAULT", () => $956bae7e1322abda$export$e6952b12ade67489);
$parcel$export(module.exports, "EMBEDDED_REQUEST_CREATE", () => $956bae7e1322abda$export$75d9313789677296);
const $956bae7e1322abda$export$907219511d14ba3d = 'summary';
const $956bae7e1322abda$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $956bae7e1322abda$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $956bae7e1322abda$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $956bae7e1322abda$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $956bae7e1322abda$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $956bae7e1322abda$export$34740f8d07d23ac0 = 'priority';
const $956bae7e1322abda$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $956bae7e1322abda$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $956bae7e1322abda$export$b159f8b8f27aae4c = 'duedate';
const $956bae7e1322abda$export$5e7324042f1d6b31 = 'description';
const $956bae7e1322abda$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $956bae7e1322abda$export$69c9cc9ff399807f = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $956bae7e1322abda$export$43b6e33ec70f2272 = 'labels';
const $956bae7e1322abda$export$e6952b12ade67489 = 'default';
const $956bae7e1322abda$export$75d9313789677296 = 'embedded-request-create';

});

parcelRegister("7CtOF", function(module, exports) {
$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $2a1144fe61af9041$export$2d586ab6ce4d7126);
$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $2a1144fe61af9041$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $2a1144fe61af9041$export$47e9770ed0d1c344);
$parcel$export(module.exports, "normalizeCascadingSelectValue", () => $2a1144fe61af9041$export$e9eb61f6a3bc0438);
$parcel$export(module.exports, "transformValueToBasicCascadingSelect", () => $2a1144fe61af9041$export$4fe225ca7554ff11);

var $cLHRt = parcelRequire("cLHRt");

var $eBPD7 = parcelRequire("eBPD7");

var $6bGmX = parcelRequire("6bGmX");
const $2a1144fe61af9041$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.value === parentId);
    if (!foundOption) throw new (0, $cLHRt.FieldValueLookupError)();
    const childOption = childId !== null && foundOption.children ? foundOption.children.find((child)=>child.value === childId) || null : null;
    const value = {
        parent: foundOption,
        children: childOption
    };
    return value;
};
const $2a1144fe61af9041$export$2d586ab6ce4d7126 = (value)=>{
    return value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $eBPD7.isNotEmptyString)(value.parentId) && ((0, $eBPD7.isNotEmptyString)(value.childId) || value.childId === null);
};
const $2a1144fe61af9041$export$905a8d55c641a71e = (value, lookupData)=>{
    if (value === null || value.parentId === null) return null;
    const cascadingSelectValue = $2a1144fe61af9041$var$findCascadingSelectLookupValues(lookupData, value.parentId, value.childId);
    return {
        primaryValue: cascadingSelectValue.parent,
        children: cascadingSelectValue.children
    };
};
const $2a1144fe61af9041$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue || (0, $6bGmX.default).checkGate('ditto_fix_getvalue_empty_state') && !cascadingValue.primaryValue) return null;
    const { primaryValue: primaryValue, children: children } = cascadingValue;
    return {
        parent: {
            id: primaryValue.value,
            value: primaryValue.label
        },
        child: children ? {
            id: children.value,
            value: children.label
        } : null
    };
};
const $2a1144fe61af9041$export$e9eb61f6a3bc0438 = (value)=>{
    var _children, _value$primaryValue;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    // If it's already NestedFieldValueType (string-based primaryValue)
    if (typeof value.primaryValue === 'string' || value.primaryValue === null) return value;
    // If it's object-based, extract string values
    const childrenValue = (_children = value.children) === null || _children === void 0 ? void 0 : _children.value;
    return {
        primaryValue: ((_value$primaryValue = value.primaryValue) === null || _value$primaryValue === void 0 ? void 0 : _value$primaryValue.value) || null,
        children: childrenValue || null
    };
};
const $2a1144fe61af9041$export$4fe225ca7554ff11 = (value)=>{
    var _value$primaryValue2, _value$children;
    if (!value) return {
        primaryValue: null,
        children: null
    };
    return {
        primaryValue: ((_value$primaryValue2 = value.primaryValue) === null || _value$primaryValue2 === void 0 ? void 0 : _value$primaryValue2.value) || null,
        children: ((_value$children = value.children) === null || _value$children === void 0 ? void 0 : _value$children.value) || null
    };
};

});

parcelRegister("83u1M", function(module, exports) {
$parcel$export(module.exports, "datePickerSetValueValidator", () => $0f3d9f88d8ce0efb$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $0f3d9f88d8ce0efb$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $0f3d9f88d8ce0efb$export$e844c6ac3a5cbef7);

var $bqJEq = parcelRequire("bqJEq");
var $aS86U = parcelRequire("aS86U");
var $4HSmX = parcelRequire("4HSmX");
var $5ivfK = parcelRequire("5ivfK");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $0f3d9f88d8ce0efb$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $4HSmX.default)(date, dateFormat, new Date());
    return (0, $aS86U.default)(parsedDate);
};
const $0f3d9f88d8ce0efb$export$c003579a97a2459e = (value)=>value === null || $0f3d9f88d8ce0efb$var$dateHasExpectedFormat(value);
const $0f3d9f88d8ce0efb$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $0f3d9f88d8ce0efb$export$e844c6ac3a5cbef7 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $5ivfK.default)(value);
    if ((0, $aS86U.default)(parsedDate)) return (0, $bqJEq.default)(parsedDate, 'yyyy-MM-dd');
    return null;
};

});
parcelRegister("4HSmX", function(module, exports) {
$parcel$export(module.exports, "default", () => $36d55a2bba9dafab$export$2e2bcd8739ae039);

var $5WRll = parcelRequire("5WRll");

var $9MotD = parcelRequire("9MotD");

var $atEHZ = parcelRequire("atEHZ");

var $glZPY = parcelRequire("glZPY");

var $2L8Oe = parcelRequire("2L8Oe");

var $lCPDc = parcelRequire("lCPDc");

var $lO7AZ = parcelRequire("lO7AZ");

var $cfem5 = parcelRequire("cfem5");

var $ejtMj = parcelRequire("ejtMj");

var $gaR4O = parcelRequire("gaR4O");

var $9hhlF = parcelRequire("9hhlF");

var $8oMB0 = parcelRequire("8oMB0");

var $JPlQL = parcelRequire("JPlQL");

var $lUVDS = parcelRequire("lUVDS");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $36d55a2bba9dafab$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $36d55a2bba9dafab$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $36d55a2bba9dafab$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $36d55a2bba9dafab$var$doubleQuoteRegExp = /''/g;
var $36d55a2bba9dafab$var$notWhitespaceRegExp = /\S/;
var $36d55a2bba9dafab$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $36d55a2bba9dafab$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $9hhlF.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $lUVDS.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $atEHZ.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $gaR4O.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $gaR4O.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $2L8Oe.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $8oMB0.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($36d55a2bba9dafab$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $lO7AZ.default)) {
            var longFormatter = (0, $lO7AZ.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($36d55a2bba9dafab$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $9MotD.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ejtMj.isProtectedWeekYearToken)(token)) (0, $ejtMj.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ejtMj.isProtectedDayOfYearToken)(token)) (0, $ejtMj.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $JPlQL.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($36d55a2bba9dafab$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $36d55a2bba9dafab$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $5WRll.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $36d55a2bba9dafab$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $2L8Oe.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $glZPY.default)(date, (0, $cfem5.default)(date));
    var flags = {};
    var _iterator2 = (0, $9MotD.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $lCPDc.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $36d55a2bba9dafab$var$cleanEscapedString(input) {
    return input.match($36d55a2bba9dafab$var$escapedStringRegExp)[1].replace($36d55a2bba9dafab$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("9MotD", function(module, exports) {
$parcel$export(module.exports, "default", () => $71eb955b77817029$export$2e2bcd8739ae039);

var $3E59X = parcelRequire("3E59X");
function $71eb955b77817029$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $3E59X.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("3E59X", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a791c22c6bd878d$export$2e2bcd8739ae039);

var $2x82P = parcelRequire("2x82P");
function $2a791c22c6bd878d$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $2x82P.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $2x82P.default)(r, a) : void 0;
    }
}

});
parcelRegister("2x82P", function(module, exports) {
$parcel$export(module.exports, "default", () => $1d84e758f0d8034c$export$2e2bcd8739ae039);
function $1d84e758f0d8034c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("lCPDc", function(module, exports) {
$parcel$export(module.exports, "default", () => $fbe532769e68141b$export$2e2bcd8739ae039);
function $fbe532769e68141b$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("8oMB0", function(module, exports) {
$parcel$export(module.exports, "ValueSetter", () => $61d642c5bb6eba19$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $61d642c5bb6eba19$export$5aaf7ff7f09ea4ee);

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $6YQ3e = parcelRequire("6YQ3e");
var $61d642c5bb6eba19$var$TIMEZONE_UNIT_PRIORITY = 10;
var $61d642c5bb6eba19$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $3bjbz.default)(this, Setter);
        (0, $6YQ3e.default)(this, "priority", void 0);
        (0, $6YQ3e.default)(this, "subPriority", 0);
    }
    (0, $gw1d9.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $61d642c5bb6eba19$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $almdz.default)(ValueSetter, _Setter);
    var _super = (0, $1brCd.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $3bjbz.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $gw1d9.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($61d642c5bb6eba19$export$81d53e3678089a6);
var $61d642c5bb6eba19$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $almdz.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $1brCd.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $3bjbz.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this2), "priority", $61d642c5bb6eba19$var$TIMEZONE_UNIT_PRIORITY);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $gw1d9.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($61d642c5bb6eba19$export$81d53e3678089a6);

});
parcelRegister("almdz", function(module, exports) {
$parcel$export(module.exports, "default", () => $787d1994b3a83b20$export$2e2bcd8739ae039);

var $kqSvQ = parcelRequire("kqSvQ");
function $787d1994b3a83b20$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $kqSvQ.default)(t, e);
}

});

parcelRegister("1brCd", function(module, exports) {
$parcel$export(module.exports, "default", () => $0dcc3d57642bafe0$export$2e2bcd8739ae039);

var $5MFWU = parcelRequire("5MFWU");

var $4y14Y = parcelRequire("4y14Y");

var $c7u3f = parcelRequire("c7u3f");
function $0dcc3d57642bafe0$export$2e2bcd8739ae039(t) {
    var r = (0, $4y14Y.default)();
    return function() {
        var e, o = (0, $5MFWU.default)(t);
        if (r) {
            var s = (0, $5MFWU.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $c7u3f.default)(this, e);
    };
}

});
parcelRegister("5MFWU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4361f9a8d6fa3e45$export$2e2bcd8739ae039);
function $4361f9a8d6fa3e45$export$2e2bcd8739ae039(t) {
    return $4361f9a8d6fa3e45$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4361f9a8d6fa3e45$export$2e2bcd8739ae039(t);
}

});

parcelRegister("4y14Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $34fb2cb022cf2eaf$export$2e2bcd8739ae039);
function $34fb2cb022cf2eaf$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($34fb2cb022cf2eaf$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("c7u3f", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d2d730e8347a39c$export$2e2bcd8739ae039);

var $5WRll = parcelRequire("5WRll");

var $evzgG = parcelRequire("evzgG");
function $8d2d730e8347a39c$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5WRll.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $evzgG.default)(t);
}

});


parcelRegister("3bjbz", function(module, exports) {
$parcel$export(module.exports, "default", () => $2511480ad066e709$export$2e2bcd8739ae039);
function $2511480ad066e709$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("gw1d9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c060930467288271$export$2e2bcd8739ae039);

var $92oSb = parcelRequire("92oSb");
function $c060930467288271$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $92oSb.default)(o.key), o);
    }
}
function $c060930467288271$export$2e2bcd8739ae039(e, r, t) {
    return r && $c060930467288271$var$_defineProperties(e.prototype, r), t && $c060930467288271$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});


parcelRegister("JPlQL", function(module, exports) {
$parcel$export(module.exports, "parsers", () => $089c096800e2b09a$export$19131010e7fd8373);

var $eRIbS = parcelRequire("eRIbS");

var $an20y = parcelRequire("an20y");

var $hOSUi = parcelRequire("hOSUi");

var $iHk8o = parcelRequire("iHk8o");

var $eGKkp = parcelRequire("eGKkp");

var $jWjPm = parcelRequire("jWjPm");

var $eBhVy = parcelRequire("eBhVy");

var $3au6a = parcelRequire("3au6a");

var $2z2lP = parcelRequire("2z2lP");

var $88dOG = parcelRequire("88dOG");

var $j8N43 = parcelRequire("j8N43");

var $i76ag = parcelRequire("i76ag");

var $jJSOP = parcelRequire("jJSOP");

var $k9HdL = parcelRequire("k9HdL");

var $fE4ol = parcelRequire("fE4ol");

var $bZafM = parcelRequire("bZafM");

var $bsEDn = parcelRequire("bsEDn");

var $53anm = parcelRequire("53anm");

var $drPks = parcelRequire("drPks");

var $9oHaT = parcelRequire("9oHaT");

var $jImC0 = parcelRequire("jImC0");

var $jm8TM = parcelRequire("jm8TM");

var $fElFu = parcelRequire("fElFu");

var $5bbTH = parcelRequire("5bbTH");

var $lEXoD = parcelRequire("lEXoD");

var $bgkw3 = parcelRequire("bgkw3");

var $iU6cD = parcelRequire("iU6cD");

var $kQ28d = parcelRequire("kQ28d");

var $8EIvr = parcelRequire("8EIvr");

var $5RGIg = parcelRequire("5RGIg");

var $hxdMI = parcelRequire("hxdMI");
var $089c096800e2b09a$export$19131010e7fd8373 = {
    G: new (0, $eRIbS.EraParser)(),
    y: new (0, $an20y.YearParser)(),
    Y: new (0, $hOSUi.LocalWeekYearParser)(),
    R: new (0, $iHk8o.ISOWeekYearParser)(),
    u: new (0, $eGKkp.ExtendedYearParser)(),
    Q: new (0, $jWjPm.QuarterParser)(),
    q: new (0, $eBhVy.StandAloneQuarterParser)(),
    M: new (0, $3au6a.MonthParser)(),
    L: new (0, $2z2lP.StandAloneMonthParser)(),
    w: new (0, $88dOG.LocalWeekParser)(),
    I: new (0, $j8N43.ISOWeekParser)(),
    d: new (0, $i76ag.DateParser)(),
    D: new (0, $jJSOP.DayOfYearParser)(),
    E: new (0, $k9HdL.DayParser)(),
    e: new (0, $fE4ol.LocalDayParser)(),
    c: new (0, $bZafM.StandAloneLocalDayParser)(),
    i: new (0, $bsEDn.ISODayParser)(),
    a: new (0, $53anm.AMPMParser)(),
    b: new (0, $drPks.AMPMMidnightParser)(),
    B: new (0, $9oHaT.DayPeriodParser)(),
    h: new (0, $jImC0.Hour1to12Parser)(),
    H: new (0, $jm8TM.Hour0to23Parser)(),
    K: new (0, $fElFu.Hour0To11Parser)(),
    k: new (0, $5bbTH.Hour1To24Parser)(),
    m: new (0, $lEXoD.MinuteParser)(),
    s: new (0, $bgkw3.SecondParser)(),
    S: new (0, $iU6cD.FractionOfSecondParser)(),
    X: new (0, $kQ28d.ISOTimezoneWithZParser)(),
    x: new (0, $8EIvr.ISOTimezoneParser)(),
    t: new (0, $5RGIg.TimestampSecondsParser)(),
    T: new (0, $hxdMI.TimestampMillisecondsParser)()
};

});
parcelRegister("eRIbS", function(module, exports) {
$parcel$export(module.exports, "EraParser", () => $ad284b3a6a1e2d15$export$8e5a1d3f85a9688);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");
var $ad284b3a6a1e2d15$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(EraParser, _Parser);
    var _super = (0, $1brCd.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $3bjbz.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 140);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $gTaQz.Parser));

});
parcelRegister("gTaQz", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $c4ba3259126858fd$export$7acfa6ed01010e37);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $6YQ3e = parcelRequire("6YQ3e");

var $8oMB0 = parcelRequire("8oMB0");
var $c4ba3259126858fd$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $3bjbz.default)(this, Parser);
        (0, $6YQ3e.default)(this, "incompatibleTokens", void 0);
        (0, $6YQ3e.default)(this, "priority", void 0);
        (0, $6YQ3e.default)(this, "subPriority", void 0);
    }
    (0, $gw1d9.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $8oMB0.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("an20y", function(module, exports) {
$parcel$export(module.exports, "YearParser", () => $78cd9c17df59d5f6$export$48d352de7cd4a988);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $78cd9c17df59d5f6$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(YearParser, _Parser);
    var _super = (0, $1brCd.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $3bjbz.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 130);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $loCUM.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $loCUM.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $gTaQz.Parser));

});
parcelRegister("loCUM", function(module, exports) {
$parcel$export(module.exports, "mapValue", () => $f93a068ee919c058$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $f93a068ee919c058$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $f93a068ee919c058$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $f93a068ee919c058$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $f93a068ee919c058$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $f93a068ee919c058$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $f93a068ee919c058$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $f93a068ee919c058$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $f93a068ee919c058$export$3d50627710b84d75);

var $9vorW = parcelRequire("9vorW");

var $aAelP = parcelRequire("aAelP");
function $f93a068ee919c058$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $f93a068ee919c058$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $f93a068ee919c058$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $9vorW.millisecondsInHour) + minutes * (0, $9vorW.millisecondsInMinute) + seconds * (0, $9vorW.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $f93a068ee919c058$export$d931c43c4608a164(dateString) {
    return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).anyDigitsSigned, dateString);
}
function $f93a068ee919c058$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).singleDigit, dateString);
        case 2:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).twoDigits, dateString);
        case 3:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).threeDigits, dateString);
        case 4:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).fourDigits, dateString);
        default:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $f93a068ee919c058$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388((0, $aAelP.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $f93a068ee919c058$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $f93a068ee919c058$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $f93a068ee919c058$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $f93a068ee919c058$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("9vorW", function(module, exports) {
$parcel$export(module.exports, "millisecondsInMinute", () => $6eb9f97cc15075c2$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $6eb9f97cc15075c2$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $6eb9f97cc15075c2$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $6eb9f97cc15075c2$export$dfd9b671c89acc8e = 7;
var $6eb9f97cc15075c2$export$3913210603d8e9ae = 365.2425;
var $6eb9f97cc15075c2$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $6eb9f97cc15075c2$export$91246f0b9bd9beff = 60000;
var $6eb9f97cc15075c2$export$7f72910d6dfd237a = 3600000;
var $6eb9f97cc15075c2$export$397c2d5776aa9055 = 1000;
var $6eb9f97cc15075c2$export$4dec998e48f9c246 = -$6eb9f97cc15075c2$export$81caae6e1cc7a622;
var $6eb9f97cc15075c2$export$f2f5ae5a8e2d8f9f = 60;
var $6eb9f97cc15075c2$export$3c58128db900d44e = 3;
var $6eb9f97cc15075c2$export$80d7e435f744f319 = 12;
var $6eb9f97cc15075c2$export$4db7641526e3241f = 4;
var $6eb9f97cc15075c2$export$698aec755e92c695 = 3600;
var $6eb9f97cc15075c2$export$a77c1a7ebebe2a5a = 60;
var $6eb9f97cc15075c2$export$815a9362476d2fe3 = $6eb9f97cc15075c2$export$698aec755e92c695 * 24;
var $6eb9f97cc15075c2$export$34804a017b31e2fe = $6eb9f97cc15075c2$export$815a9362476d2fe3 * 7;
var $6eb9f97cc15075c2$export$7271e9e3478110d1 = $6eb9f97cc15075c2$export$815a9362476d2fe3 * $6eb9f97cc15075c2$export$3913210603d8e9ae;
var $6eb9f97cc15075c2$export$8e6600bbdee7dabb = $6eb9f97cc15075c2$export$7271e9e3478110d1 / 12;
var $6eb9f97cc15075c2$export$be1dccf2de902d31 = $6eb9f97cc15075c2$export$8e6600bbdee7dabb * 3;

});

parcelRegister("aAelP", function(module, exports) {
$parcel$export(module.exports, "numericPatterns", () => $7b4865fe8d2905a0$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $7b4865fe8d2905a0$export$a7ee192b982af9c1);
var $7b4865fe8d2905a0$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $7b4865fe8d2905a0$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("hOSUi", function(module, exports) {
$parcel$export(module.exports, "LocalWeekYearParser", () => $cf91b294758fd6b5$export$b8ef38dfcf05d5db);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");

var $e9vT2 = parcelRequire("e9vT2");

var $k8T8Q = parcelRequire("k8T8Q");
var $cf91b294758fd6b5$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $1brCd.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $3bjbz.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 130);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $loCUM.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $e9vT2.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $loCUM.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $k8T8Q.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $k8T8Q.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $gTaQz.Parser));

});

parcelRegister("iHk8o", function(module, exports) {
$parcel$export(module.exports, "ISOWeekYearParser", () => $d9cbdc6a55d74f00$export$951d1df011fde06f);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");

var $azmnV = parcelRequire("azmnV");
var $d9cbdc6a55d74f00$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $1brCd.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $3bjbz.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 130);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $loCUM.parseNDigitsSigned)(4, dateString);
                return (0, $loCUM.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $azmnV.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $gTaQz.Parser));

});

parcelRegister("eGKkp", function(module, exports) {
$parcel$export(module.exports, "ExtendedYearParser", () => $ab18ecc2f15a0076$export$bad9d2ea38e8f1a);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $ab18ecc2f15a0076$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(ExtendedYearParser, _Parser);
    var _super = (0, $1brCd.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $3bjbz.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 130);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $loCUM.parseNDigitsSigned)(4, dateString);
                return (0, $loCUM.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $gTaQz.Parser));

});

parcelRegister("jWjPm", function(module, exports) {
$parcel$export(module.exports, "QuarterParser", () => $e842d066290adbfc$export$5cb0f701186dde1d);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $e842d066290adbfc$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(QuarterParser, _Parser);
    var _super = (0, $1brCd.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $3bjbz.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 120);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $gTaQz.Parser));

});

parcelRegister("eBhVy", function(module, exports) {
$parcel$export(module.exports, "StandAloneQuarterParser", () => $aa126d5a16122d45$export$300c0c2990e20e6d);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $aa126d5a16122d45$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $1brCd.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $3bjbz.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 120);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $gTaQz.Parser));

});

parcelRegister("3au6a", function(module, exports) {
$parcel$export(module.exports, "MonthParser", () => $24e9a72d7a9ebb7f$export$400dd8b40ef138a3);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $loCUM = parcelRequire("loCUM");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");
var $24e9a72d7a9ebb7f$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(MonthParser, _Parser);
    var _super = (0, $1brCd.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $3bjbz.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 110);
        return _this;
    }
    (0, $gw1d9.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $loCUM.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $gTaQz.Parser));

});

parcelRegister("2z2lP", function(module, exports) {
$parcel$export(module.exports, "StandAloneMonthParser", () => $1de0ac8cb7ac48f5$export$1d7eaa53eaa5deba);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $1de0ac8cb7ac48f5$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $1brCd.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $3bjbz.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 110);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $loCUM.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $gTaQz.Parser));

});

parcelRegister("88dOG", function(module, exports) {
$parcel$export(module.exports, "LocalWeekParser", () => $5eb9c9bccef1b9bb$export$c4005ffc174e07c0);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");

var $jdJTu = parcelRequire("jdJTu");

var $k8T8Q = parcelRequire("k8T8Q");
var $5eb9c9bccef1b9bb$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(LocalWeekParser, _Parser);
    var _super = (0, $1brCd.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $3bjbz.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 100);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $k8T8Q.default)((0, $jdJTu.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $gTaQz.Parser));

});
parcelRegister("jdJTu", function(module, exports) {
$parcel$export(module.exports, "default", () => $dfe2d4cc37cabef4$export$2e2bcd8739ae039);

var $gaR4O = parcelRequire("gaR4O");

var $2L8Oe = parcelRequire("2L8Oe");

var $lPn0o = parcelRequire("lPn0o");

var $9hhlF = parcelRequire("9hhlF");
function $dfe2d4cc37cabef4$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $9hhlF.default)(2, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var week = (0, $gaR4O.default)(dirtyWeek);
    var diff = (0, $lPn0o.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("j8N43", function(module, exports) {
$parcel$export(module.exports, "ISOWeekParser", () => $def4d2d23ef5970b$export$6fc8dbedd560a6af);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");

var $31ilI = parcelRequire("31ilI");

var $azmnV = parcelRequire("azmnV");
var $def4d2d23ef5970b$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(ISOWeekParser, _Parser);
    var _super = (0, $1brCd.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $3bjbz.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 100);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $azmnV.default)((0, $31ilI.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $gTaQz.Parser));

});
parcelRegister("31ilI", function(module, exports) {
$parcel$export(module.exports, "default", () => $232fb2de6f30a3fc$export$2e2bcd8739ae039);

var $gaR4O = parcelRequire("gaR4O");

var $2L8Oe = parcelRequire("2L8Oe");

var $bXwHl = parcelRequire("bXwHl");

var $9hhlF = parcelRequire("9hhlF");
function $232fb2de6f30a3fc$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $9hhlF.default)(2, arguments);
    var date = (0, $2L8Oe.default)(dirtyDate);
    var isoWeek = (0, $gaR4O.default)(dirtyISOWeek);
    var diff = (0, $bXwHl.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("i76ag", function(module, exports) {
$parcel$export(module.exports, "DateParser", () => $d2fda9928090b235$export$e8d4b28a20981dd2);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $loCUM = parcelRequire("loCUM");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");
var $d2fda9928090b235$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $d2fda9928090b235$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $d2fda9928090b235$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(DateParser, _Parser);
    var _super = (0, $1brCd.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $3bjbz.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 90);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "subPriority", 1);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $loCUM.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $d2fda9928090b235$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $d2fda9928090b235$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $gTaQz.Parser));

});

parcelRegister("jJSOP", function(module, exports) {
$parcel$export(module.exports, "DayOfYearParser", () => $e5ecbe2a20c16993$export$6cfe0d613455f615);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $e5ecbe2a20c16993$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(DayOfYearParser, _Parser);
    var _super = (0, $1brCd.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $3bjbz.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 90);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "subpriority", 1);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $loCUM.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $gTaQz.Parser));

});

parcelRegister("k9HdL", function(module, exports) {
$parcel$export(module.exports, "DayParser", () => $eac62cb82851b080$export$1b03c8b76262f7bd);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $c263U = parcelRequire("c263U");
var $eac62cb82851b080$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(DayParser, _Parser);
    var _super = (0, $1brCd.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $3bjbz.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 90);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $c263U.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $gTaQz.Parser));

});
parcelRegister("c263U", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c2a5fb6c5811b7f$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");

var $gaR4O = parcelRequire("gaR4O");

var $lUVDS = parcelRequire("lUVDS");
function $8c2a5fb6c5811b7f$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $9hhlF.default)(2, arguments);
    var defaultOptions = (0, $lUVDS.getDefaultOptions)();
    var weekStartsOn = (0, $gaR4O.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $2L8Oe.default)(dirtyDate);
    var day = (0, $gaR4O.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("fE4ol", function(module, exports) {
$parcel$export(module.exports, "LocalDayParser", () => $b63dff8438f2351f$export$44d1c127ab42c480);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");

var $c263U = parcelRequire("c263U");
var $b63dff8438f2351f$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(LocalDayParser, _Parser);
    var _super = (0, $1brCd.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $3bjbz.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 90);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $loCUM.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $c263U.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $gTaQz.Parser));

});

parcelRegister("bZafM", function(module, exports) {
$parcel$export(module.exports, "StandAloneLocalDayParser", () => $8b9d5854424eb64e$export$e447a647caaaec1d);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");

var $c263U = parcelRequire("c263U");
var $8b9d5854424eb64e$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $1brCd.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $3bjbz.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 90);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $loCUM.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $c263U.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $gTaQz.Parser));

});

parcelRegister("bsEDn", function(module, exports) {
$parcel$export(module.exports, "ISODayParser", () => $8581d44e2c7cae95$export$693fb1e525095b2a);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");

var $hzEIU = parcelRequire("hzEIU");
var $8581d44e2c7cae95$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(ISODayParser, _Parser);
    var _super = (0, $1brCd.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $3bjbz.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 90);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $loCUM.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $loCUM.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $loCUM.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $loCUM.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $hzEIU.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $gTaQz.Parser));

});
parcelRegister("hzEIU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccb54b568206c064$export$2e2bcd8739ae039);

var $2L8Oe = parcelRequire("2L8Oe");

var $9hhlF = parcelRequire("9hhlF");

var $gaR4O = parcelRequire("gaR4O");
function $ccb54b568206c064$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $9hhlF.default)(2, arguments);
    var day = (0, $gaR4O.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $2L8Oe.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("53anm", function(module, exports) {
$parcel$export(module.exports, "AMPMParser", () => $3ad547f93e317e99$export$8d1e08492351df91);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $3ad547f93e317e99$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(AMPMParser, _Parser);
    var _super = (0, $1brCd.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $3bjbz.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 80);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $loCUM.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $gTaQz.Parser));

});

parcelRegister("drPks", function(module, exports) {
$parcel$export(module.exports, "AMPMMidnightParser", () => $9ca59cdd5f2629d8$export$73ca2bd0a17d273);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $9ca59cdd5f2629d8$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $1brCd.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $3bjbz.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 80);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $loCUM.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $gTaQz.Parser));

});

parcelRegister("9oHaT", function(module, exports) {
$parcel$export(module.exports, "DayPeriodParser", () => $6d77d88bee82d451$export$bb9212adf05373db);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $6d77d88bee82d451$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(DayPeriodParser, _Parser);
    var _super = (0, $1brCd.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $3bjbz.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 80);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $loCUM.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $gTaQz.Parser));

});

parcelRegister("jImC0", function(module, exports) {
$parcel$export(module.exports, "Hour1to12Parser", () => $e5a3aaa8c5b30e3e$export$8a04050a727a1756);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $e5a3aaa8c5b30e3e$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(Hour1to12Parser, _Parser);
    var _super = (0, $1brCd.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $3bjbz.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 70);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $gTaQz.Parser));

});

parcelRegister("jm8TM", function(module, exports) {
$parcel$export(module.exports, "Hour0to23Parser", () => $e176f977c86ecf67$export$e56f4dea2c3e56dd);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $e176f977c86ecf67$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(Hour0to23Parser, _Parser);
    var _super = (0, $1brCd.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $3bjbz.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 70);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $gTaQz.Parser));

});

parcelRegister("fElFu", function(module, exports) {
$parcel$export(module.exports, "Hour0To11Parser", () => $b64b6650861f845f$export$cbbe855312f87d77);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $b64b6650861f845f$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(Hour0To11Parser, _Parser);
    var _super = (0, $1brCd.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $3bjbz.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 70);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $gTaQz.Parser));

});

parcelRegister("5bbTH", function(module, exports) {
$parcel$export(module.exports, "Hour1To24Parser", () => $3c573564fb89814d$export$6008046d2b34b6a5);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $3c573564fb89814d$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(Hour1To24Parser, _Parser);
    var _super = (0, $1brCd.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $3bjbz.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 70);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $gTaQz.Parser));

});

parcelRegister("lEXoD", function(module, exports) {
$parcel$export(module.exports, "MinuteParser", () => $fc4b68442db178e0$export$2b52670d9e2be53);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $fc4b68442db178e0$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(MinuteParser, _Parser);
    var _super = (0, $1brCd.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $3bjbz.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 60);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $gTaQz.Parser));

});

parcelRegister("bgkw3", function(module, exports) {
$parcel$export(module.exports, "SecondParser", () => $83311a6647b0bd35$export$94d46d540cf1366a);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $83311a6647b0bd35$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(SecondParser, _Parser);
    var _super = (0, $1brCd.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $3bjbz.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 50);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $loCUM.parseNumericPattern)((0, $aAelP.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $loCUM.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $gTaQz.Parser));

});

parcelRegister("iU6cD", function(module, exports) {
$parcel$export(module.exports, "FractionOfSecondParser", () => $dc3244b3b92bdcfa$export$b8e6f8b2d70893b1);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $dc3244b3b92bdcfa$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $1brCd.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $3bjbz.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 30);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $loCUM.mapValue)((0, $loCUM.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $gTaQz.Parser));

});

parcelRegister("kQ28d", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $f2ba5145d8642e7e$export$104d901d49fea29b);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $f2ba5145d8642e7e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $1brCd.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $3bjbz.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 10);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $gTaQz.Parser));

});

parcelRegister("8EIvr", function(module, exports) {
$parcel$export(module.exports, "ISOTimezoneParser", () => $64d495210c69cb1c$export$12910e5204b52b9);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $aAelP = parcelRequire("aAelP");

var $loCUM = parcelRequire("loCUM");
var $64d495210c69cb1c$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $1brCd.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $3bjbz.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 10);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $gw1d9.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $loCUM.parseTimezonePattern)((0, $aAelP.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $gTaQz.Parser));

});

parcelRegister("5RGIg", function(module, exports) {
$parcel$export(module.exports, "TimestampSecondsParser", () => $445308dd7ae32c4a$export$2cd8bf877a05e96);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $445308dd7ae32c4a$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $1brCd.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $3bjbz.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 40);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $gw1d9.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $loCUM.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $gTaQz.Parser));

});

parcelRegister("hxdMI", function(module, exports) {
$parcel$export(module.exports, "TimestampMillisecondsParser", () => $cc403613900c98d4$export$6d8f69c6906d6368);

var $3bjbz = parcelRequire("3bjbz");

var $gw1d9 = parcelRequire("gw1d9");

var $evzgG = parcelRequire("evzgG");

var $almdz = parcelRequire("almdz");

var $1brCd = parcelRequire("1brCd");

var $6YQ3e = parcelRequire("6YQ3e");

var $gTaQz = parcelRequire("gTaQz");

var $loCUM = parcelRequire("loCUM");
var $cc403613900c98d4$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $almdz.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $1brCd.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $3bjbz.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "priority", 20);
        (0, $6YQ3e.default)((0, $evzgG.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $gw1d9.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $loCUM.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $gTaQz.Parser));

});



parcelRegister("5ivfK", function(module, exports) {
$parcel$export(module.exports, "default", () => $3db6e068a7302466$export$2e2bcd8739ae039);

var $9vorW = parcelRequire("9vorW");

var $9hhlF = parcelRequire("9hhlF");

var $gaR4O = parcelRequire("gaR4O");
function $3db6e068a7302466$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $9hhlF.default)(1, arguments);
    var additionalDigits = (0, $gaR4O.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $3db6e068a7302466$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $3db6e068a7302466$var$parseYear(dateStrings.date, additionalDigits);
        date = $3db6e068a7302466$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $3db6e068a7302466$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $3db6e068a7302466$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $3db6e068a7302466$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $3db6e068a7302466$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $3db6e068a7302466$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $3db6e068a7302466$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $3db6e068a7302466$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($3db6e068a7302466$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($3db6e068a7302466$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($3db6e068a7302466$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $3db6e068a7302466$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $3db6e068a7302466$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $3db6e068a7302466$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($3db6e068a7302466$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $3db6e068a7302466$var$parseDateUnit(captures[1]);
    var month = $3db6e068a7302466$var$parseDateUnit(captures[2]) - 1;
    var day = $3db6e068a7302466$var$parseDateUnit(captures[3]);
    var week = $3db6e068a7302466$var$parseDateUnit(captures[4]);
    var dayOfWeek = $3db6e068a7302466$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$3db6e068a7302466$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $3db6e068a7302466$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$3db6e068a7302466$var$validateDate(year, month, day) || !$3db6e068a7302466$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $3db6e068a7302466$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $3db6e068a7302466$var$parseTime(timeString) {
    var captures = timeString.match($3db6e068a7302466$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $3db6e068a7302466$var$parseTimeUnit(captures[1]);
    var minutes = $3db6e068a7302466$var$parseTimeUnit(captures[2]);
    var seconds = $3db6e068a7302466$var$parseTimeUnit(captures[3]);
    if (!$3db6e068a7302466$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $9vorW.millisecondsInHour) + minutes * (0, $9vorW.millisecondsInMinute) + seconds * 1000;
}
function $3db6e068a7302466$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $3db6e068a7302466$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($3db6e068a7302466$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$3db6e068a7302466$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $9vorW.millisecondsInHour) + minutes * (0, $9vorW.millisecondsInMinute));
}
function $3db6e068a7302466$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $3db6e068a7302466$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $3db6e068a7302466$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $3db6e068a7302466$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($3db6e068a7302466$var$daysInMonths[month] || ($3db6e068a7302466$var$isLeapYearIndex(year) ? 29 : 28));
}
function $3db6e068a7302466$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($3db6e068a7302466$var$isLeapYearIndex(year) ? 366 : 365);
}
function $3db6e068a7302466$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $3db6e068a7302466$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $3db6e068a7302466$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});


parcelRegister("g8EKv", function(module, exports) {
$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $b8b6acb6b1bf04d6$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $b8b6acb6b1bf04d6$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $b8b6acb6b1bf04d6$export$4cb6c79fda4a9c74);

var $bqJEq = parcelRequire("bqJEq");
var $gaqdL = parcelRequire("gaqdL");
var $aS86U = parcelRequire("aS86U");
var $5ivfK = parcelRequire("5ivfK");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $b8b6acb6b1bf04d6$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $b8b6acb6b1bf04d6$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $gaqdL.default)(fullDate, $b8b6acb6b1bf04d6$var$formatString) && (0, $aS86U.default)((0, $5ivfK.default)(fullDate));
};
const $b8b6acb6b1bf04d6$export$7930ddff407505cc = (value)=>{
    return value === null || $b8b6acb6b1bf04d6$export$a886f5166a4d311e(value);
};
const $b8b6acb6b1bf04d6$export$e81204f19744e19f = (publicValue)=>{
    return publicValue === null ? '' : publicValue;
};
const $b8b6acb6b1bf04d6$export$4cb6c79fda4a9c74 = (value)=>{
    if (!value) return null;
    const parsedDate = (0, $5ivfK.default)(value);
    if ((0, $aS86U.default)(parsedDate)) return (0, $bqJEq.default)(parsedDate, $b8b6acb6b1bf04d6$var$formatString);
    return null;
};

});
parcelRegister("gaqdL", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc51eb73103133ca$export$2e2bcd8739ae039);

var $4HSmX = parcelRequire("4HSmX");

var $aS86U = parcelRequire("aS86U");

var $9hhlF = parcelRequire("9hhlF");
function $bc51eb73103133ca$export$2e2bcd8739ae039(dateString, formatString, options) {
    (0, $9hhlF.default)(2, arguments);
    return (0, $aS86U.default)((0, $4HSmX.default)(dateString, formatString, new Date(), options));
}

});


parcelRegister("3J6SV", function(module, exports) {
$parcel$export(module.exports, "labelsSetValueValidator", () => $0f0e5d40624b651c$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $0f0e5d40624b651c$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $0f0e5d40624b651c$export$b0b12fd0b1cd9d3a);
$parcel$export(module.exports, "modifyLabelsValueToBasic", () => $0f0e5d40624b651c$export$627e5994af99713c);
const $0f0e5d40624b651c$export$e67b5652c846b5f = (value)=>Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $0f0e5d40624b651c$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            label: label,
            value: label
        }));
const $0f0e5d40624b651c$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);
const $0f0e5d40624b651c$export$627e5994af99713c = (data)=>{
    if (Array.isArray(data)) return data.map((item)=>item.value);
    return [];
};

});

parcelRegister("1o0qW", function(module, exports) {
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $669f821b2987e9da$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $669f821b2987e9da$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $669f821b2987e9da$export$6d15ce1cc0bdffe7);
$parcel$export(module.exports, "multiCheckboxSetOptionsVisibilityTransformer", () => $669f821b2987e9da$export$e9bad46ddf6f220a);
$parcel$export(module.exports, "multiCheckboxGetOptionsVisibilityTransformer", () => $669f821b2987e9da$export$2873e4aff600baf0);
$parcel$export(module.exports, "modifyMultiSelectValueToBasic", () => $669f821b2987e9da$export$1c5664946e66ba46);

var $7aIb2 = parcelRequire("7aIb2");

var $eBPD7 = parcelRequire("eBPD7");
const $669f821b2987e9da$export$106087dcfd4fb129 = 100;
const $669f821b2987e9da$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.length <= $669f821b2987e9da$export$106087dcfd4fb129 && value.every((0, $eBPD7.isNotEmptyString));
const $669f821b2987e9da$export$45b7d122d1400fe0 = (value)=>Array.isArray(value) && value.length <= $669f821b2987e9da$export$106087dcfd4fb129 && value.every((val)=>(0, $eBPD7.isNotEmptyString)(val) && (0, $7aIb2.isAriResourceIdValid)(val));
const $669f821b2987e9da$export$9ba1ee83cc9456ba = (optionIds, options)=>{
    const selectedOptions = options.filter((option)=>optionIds.includes(option.value));
    return selectedOptions;
};
const $669f821b2987e9da$export$6d15ce1cc0bdffe7 = (selectedOptionData)=>{
    return selectedOptionData.map((option)=>{
        return {
            id: option.value,
            value: option === null || option === void 0 ? void 0 : option.label
        };
    });
};
const $669f821b2987e9da$export$e9bad46ddf6f220a = (optionsVisibility, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
};
const $669f821b2987e9da$export$2873e4aff600baf0 = (optionsVisibility, lookupValues)=>{
    const filteredLookupValues = lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>optionsVisibility.isVisible ? optionsVisibility.options.includes(value) : !optionsVisibility.options.includes(value));
    return {
        options: (filteredLookupValues === null || filteredLookupValues === void 0 ? void 0 : filteredLookupValues.map(({ value: value })=>value)) ?? [],
        isVisible: optionsVisibility.isVisible
    };
};
const $669f821b2987e9da$export$1c5664946e66ba46 = (selectedOptions)=>(selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 0 ? selectedOptions.map((option)=>option.value) : [];

});

parcelRegister("3nyVH", function(module, exports) {
$parcel$export(module.exports, "validateNumberValue", () => $19344c34bdda93dc$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "transformNumberToInternalValue", () => $19344c34bdda93dc$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $19344c34bdda93dc$export$8bdc28b51a4acc44);
const $19344c34bdda93dc$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $19344c34bdda93dc$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $19344c34bdda93dc$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);

});

parcelRegister("8Lwxf", function(module, exports) {
$parcel$export(module.exports, "validatePrioritySetValue", () => $c3a8dda5b0a6ee8e$export$feb916d6d9ca4953);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $c3a8dda5b0a6ee8e$export$c6ef424ead917b72);
$parcel$export(module.exports, "prioritySetOptionsVisibility", () => $c3a8dda5b0a6ee8e$export$28c18b75fec0308d);
$parcel$export(module.exports, "priorityGetValueTransformer", () => $c3a8dda5b0a6ee8e$export$a3dcdeebcccb44cd);
$parcel$export(module.exports, "modifyPriorityValueToBasic", () => $c3a8dda5b0a6ee8e$export$8be86fe3b85cdd48);

var $eBPD7 = parcelRequire("eBPD7");
const $c3a8dda5b0a6ee8e$export$feb916d6d9ca4953 = (value)=>(0, $eBPD7.isNotEmptyString)(value);
const $c3a8dda5b0a6ee8e$export$c6ef424ead917b72 = (optionId, options)=>{
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $c3a8dda5b0a6ee8e$export$28c18b75fec0308d = ({ options: options, isVisible: isVisible }, lookupValues)=>{
    return lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
};
const $c3a8dda5b0a6ee8e$export$a3dcdeebcccb44cd = (data)=>{
    if (!data) return null;
    return {
        id: data.value,
        name: data.label
    };
};
const $c3a8dda5b0a6ee8e$export$8be86fe3b85cdd48 = (data)=>data === null || data === void 0 ? void 0 : data.value;

});

parcelRegister("gg4Bp", function(module, exports) {
$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $26d31b61d27837f1$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $26d31b61d27837f1$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $26d31b61d27837f1$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $26d31b61d27837f1$export$fd4db924c90bd0e2);
$parcel$export(module.exports, "modifySelectValueToBasic", () => $26d31b61d27837f1$export$24495edee70b381);
const $26d31b61d27837f1$export$81990085f8ab114b = ({ options: options, isVisible: isVisible }, lookupValues)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.filter(({ value: value })=>isVisible ? options.includes(value) : !options.includes(value));
const $26d31b61d27837f1$export$7c7ca81813eb0f65 = ({ options: options, isVisible: isVisible }, lookupValues)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues === null || lookupValues === void 0 ? void 0 : lookupValues.some((val)=>val.value === option))
    });
const $26d31b61d27837f1$export$136c42b919fdec83 = (optionId, options)=>{
    if (optionId === null) return null;
    const option = options === null || options === void 0 ? void 0 : options.find((item)=>item.value === optionId);
    return option;
};
const $26d31b61d27837f1$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $26d31b61d27837f1$export$24495edee70b381 = (selectedOption)=>{
    if (selectedOption === null) return null;
    return selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
};

});

parcelRegister("h84GV", function(module, exports) {
$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $711426206baaf48c$export$161c77b6b09fc494);
const $711426206baaf48c$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("gAthg", function(module, exports) {
$parcel$export(module.exports, "validateTextAreaValue", () => $88ef7a8099b577be$export$af1bd7b4775c21f5);
$parcel$export(module.exports, "textAreaGetValueTransformer", () => $88ef7a8099b577be$export$f8779084d2efe971);
$parcel$export(module.exports, "textAreaSetValueTransformer", () => $88ef7a8099b577be$export$b26179f27360223b);

var $4LFiR = parcelRequire("4LFiR");

var $bpwJt = parcelRequire("bpwJt");

var $9PG3O = parcelRequire("9PG3O");

var $6bGmX = parcelRequire("6bGmX");
const $88ef7a8099b577be$export$c7bf565312b59b06 = 'atlassian-wiki-renderer';
const $88ef7a8099b577be$export$af1bd7b4775c21f5 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    if (fieldRenderer === $88ef7a8099b577be$export$c7bf565312b59b06) {
        var _extra$currentField;
        return (0, $9PG3O.isValidADF)({
            newValue: value,
            currentValue: (_extra$currentField = extra.currentField) === null || _extra$currentField === void 0 ? void 0 : _extra$currentField.value
        });
    }
    return Promise.resolve(typeof value === 'string');
};
const $88ef7a8099b577be$export$f8779084d2efe971 = (value, fieldRenderer)=>{
    if (value === undefined || (0, $6bGmX.default).checkGate('ditto_fix_getvalue_empty_state') && !value) return fieldRenderer === $88ef7a8099b577be$export$c7bf565312b59b06 ? (0, $4LFiR.getEmptyADF)() : '';
    try {
        return (0, $bpwJt.parseAdf)(value);
    } catch (e) {
        return value;
    }
};
const $88ef7a8099b577be$export$b26179f27360223b = (value)=>{
    // Check if value is string, if not convert it to string
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
};

});
parcelRegister("4LFiR", function(module, exports) {
$parcel$export(module.exports, "getEmptyADF", () => $212e6f219d74733e$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
const $212e6f219d74733e$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});

parcelRegister("9PG3O", function(module, exports) {
$parcel$export(module.exports, "isValidADF", () => $378c8634d3fc45b6$export$94ea512f7afe62e4);

var $2dQcq = parcelRequire("2dQcq");

var $2186w = parcelRequire("2186w");

var $8gbjk = parcelRequire("8gbjk");

var $jFbx9 = parcelRequire("jFbx9");

const $378c8634d3fc45b6$var$getADFValidator = async ()=>{
    const { validator: validator } = await (parcelRequire("867H4"));
    return validator;
};
const $378c8634d3fc45b6$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $jFbx9.traverse)(adf, {
            media: (node)=>{
                var _node$attrs, _node$attrs2;
                if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.type) === 'external' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url) !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $378c8634d3fc45b6$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $378c8634d3fc45b6$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($2dQcq)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($2186w))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $8gbjk.doc)(...foundDiffNodes);
    return $378c8634d3fc45b6$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $378c8634d3fc45b6$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue })=>{
    const validator = await $378c8634d3fc45b6$var$getADFValidator();
    const validate = validator();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $378c8634d3fc45b6$export$6f13dd7501a16a00(newValue, currentValue);
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("2dQcq", function(module, exports) {

var $dPvaM = parcelRequire("dPvaM");

var $6h4BD = parcelRequire("6h4BD");

var $5wqj6 = parcelRequire("5wqj6");

var $fw4D7 = parcelRequire("fw4D7");

var $dZ56i = parcelRequire("dZ56i");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $19e549656582bd12$var$differenceWith = $5wqj6(function(array, values) {
    var comparator = $dZ56i(values);
    if ($fw4D7(comparator)) comparator = undefined;
    return $fw4D7(array) ? $dPvaM(array, $6h4BD(values, 1, $fw4D7, true), undefined, comparator) : [];
});
module.exports = $19e549656582bd12$var$differenceWith;

});
parcelRegister("dPvaM", function(module, exports) {

var $2QZKx = parcelRequire("2QZKx");

var $9F02t = parcelRequire("9F02t");

var $9E4uy = parcelRequire("9E4uy");

var $6NHeY = parcelRequire("6NHeY");

var $gujh9 = parcelRequire("gujh9");

var $a1q04 = parcelRequire("a1q04");
/** Used as the size to enable large array optimizations. */ var $a11838133bd445b2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $a11838133bd445b2$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $9F02t, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $6NHeY(values, $gujh9(iteratee));
    if (comparator) {
        includes = $9E4uy;
        isCommon = false;
    } else if (values.length >= $a11838133bd445b2$var$LARGE_ARRAY_SIZE) {
        includes = $a1q04;
        isCommon = false;
        values = new $2QZKx(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $a11838133bd445b2$var$baseDifference;

});


parcelRegister("867H4", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("cwkCg").then(()=>parcelRequire('1H9a7'));

});



parcelRegister("ZA0ms", function(module, exports) {
$parcel$export(module.exports, "validateUserPickerSetValue", () => $f04239cd4ae4735b$export$3dc07da29c05fcd);
$parcel$export(module.exports, "userPickerSetValueTransformer", () => $f04239cd4ae4735b$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $f04239cd4ae4735b$export$e87b0f36be178543);
$parcel$export(module.exports, "modifyUserPickerValueToBasic", () => $f04239cd4ae4735b$export$ef961f8b571be395);

var $cLHRt = parcelRequire("cLHRt");
var $66L7M = parcelRequire("66L7M");

var $eBPD7 = parcelRequire("eBPD7");

var $6bGmX = parcelRequire("6bGmX");
/**
 * Finds a user in the lookup data by their account ID.
 *
 * @param lookupData - Array of users to search through
 * @param accountId - The account ID to search for
 * @returns The matching user object or null if not found
 */ const $f04239cd4ae4735b$var$findUserLookupValue = (lookupData, accountId)=>{
    if (!lookupData || !Array.isArray(lookupData)) return null;
    return lookupData.find((user)=>user.accountId === accountId) || null;
};
const $f04239cd4ae4735b$export$3dc07da29c05fcd = (value)=>value === null || (0, $eBPD7.isNotEmptyString)(value) && (0, $66L7M.isNotAutomaticId)(value);
const $f04239cd4ae4735b$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundUser = $f04239cd4ae4735b$var$findUserLookupValue(lookupValues || [], value);
    if (!foundUser) throw new (0, $cLHRt.FieldValueLookupError)(`Could not find user with accountId: ${value}`);
    return {
        label: foundUser.name,
        email: '',
        // Email not available in LookupUser, update this once we have a way to get the email
        iconUrl: foundUser.picture,
        accountId: foundUser.accountId,
        value: foundUser.accountId
    };
};
const $f04239cd4ae4735b$export$e87b0f36be178543 = (value)=>{
    if (!value || (0, $6bGmX.default).checkGate('ditto_fix_getvalue_empty_state') && !value.accountId) return null;
    return {
        accountId: value.accountId
    };
};
const $f04239cd4ae4735b$export$ef961f8b571be395 = (value)=>{
    if (!value) return null;
    return value.accountId;
};

});
parcelRegister("66L7M", function(module, exports) {
$parcel$export(module.exports, "isNotAutomaticId", () => $8f90ba863a2be546$export$ab4c3a3c49d7add);

var $jBMwY = parcelRequire("jBMwY");
const $8f90ba863a2be546$export$ab4c3a3c49d7add = (value)=>value !== (0, $jBMwY.AUTOMATIC_ID);

});


parcelRegister("9MwOS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d33a7aac27961d8$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var // TODO: to be refined in https://ecosystem-platform.atlassian.net/browse/UIM-2463
$5d33a7aac27961d8$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    obligatoryUimRequestCreateConsentMessage: {
        id: 'ui-modifications-fields-configuration.common.utils.views.request-create.obligatory-uim-request-create-consent-message',
        defaultMessage: 'You must allow "{appTitle}" to access your Atlassian products to create this work item.',
        description: 'When a user opens a context the first time, we require that they give consent for their data otherwise they cannot get the UIM`s applied'
    }
});

});

parcelRegister("gTqbb", function(module, exports) {
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $fa00c7910a059858$export$973aead813665e25);

var $dolCK = parcelRequire("dolCK");
const $fa00c7910a059858$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $fa00c7910a059858$export$973aead813665e25 = (optionsVisibility)=>(0, $dolCK.validateSetOptionsVisibilityRule)(optionsVisibility) && $fa00c7910a059858$export$914c7f5212c4c649(optionsVisibility);

});



parcelRegister("a8eAa", function(module, exports) {
$parcel$export(module.exports, "portalReorderRoute", () => $c087cd2b349b31c7$export$f321c3c48e8f4288);
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");

var $corqd = parcelRequire("corqd");

var $3YInn = parcelRequire("3YInn");
const $c087cd2b349b31c7$export$f321c3c48e8f4288 = (shouldLoadHelpEditTopicsResource = false)=>{
    const resources = [];
    if (shouldLoadHelpEditTopicsResource) resources.push((0, $3YInn.helpEditTopicsResource));
    resources.push((0, $3YInn.hiddenSectionWarningResource));
    return {
        resources: resources,
        path: '/settings/portal-reorder',
        exact: true,
        component: (0, $lM7Z9.withRouter)((0, $corqd.PortalReorderingRoute)),
        name: 'portal-reorder'
    };
};

});
parcelRegister("corqd", function(module, exports) {
$parcel$export(module.exports, "PortalReorderingRoute", () => $f556c5c4a77dd861$export$d8bb1160246519d9);
$parcel$export(module.exports, "callToActionUrlText", () => $f556c5c4a77dd861$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $f556c5c4a77dd861$export$5342e2a00fe6d647);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $748yq = parcelRequire("748yq");

var $gi5ak = parcelRequire("gi5ak");

var $dQegt = parcelRequire("dQegt");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");
parcelRequire("evK9u");
var $a8nBS = parcelRequire("a8nBS");

var $lAMwM = parcelRequire("lAMwM");
parcelRequire("jyAe6");
var $1SIHv = parcelRequire("1SIHv");

const $f556c5c4a77dd861$export$73a0508c941788d6 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cfihf")), {
        moduleId: "./src/view/portal-reorder-experience/hocs.tsx"
    }),
    LoadingSkeleton: (0, $1SIHv.default),
    loadingPosition: 'fill-container'
});
const $f556c5c4a77dd861$var$PORTAL_REORDERING_PATH = '/settings/portal-reorder';
const $f556c5c4a77dd861$export$d8bb1160246519d9 = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: $f556c5c4a77dd861$var$PORTAL_REORDERING_PATH
    }), (0, $3RiO6.default)({
        message: formatMessage((0, $lAMwM.default).authPageMessage),
        callToActionText: formatMessage((0, $lAMwM.default).callToActionUrlText),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a8nBS.default), {
            path: $f556c5c4a77dd861$var$PORTAL_REORDERING_PATH,
            component: $f556c5c4a77dd861$export$73a0508c941788d6,
            screenName: (0, $748yq.ScreenName).PORTAL_REORDER_SETTINGS
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
$f556c5c4a77dd861$export$d8bb1160246519d9.displayName = 'PortalReorderingRoute';
const $f556c5c4a77dd861$export$d96795d242b62963 = (0, $lAMwM.default).callToActionUrlText;
const $f556c5c4a77dd861$export$5342e2a00fe6d647 = (0, $lAMwM.default).authPageMessage;

});
parcelRegister("6QlXC", function(module, exports) {
$parcel$export(module.exports, "withOnlyJiraAdmin", () => (parcelRequire("3RiO6")).default);

var $3RiO6 = parcelRequire("3RiO6");

});
parcelRegister("3RiO6", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b2e0e17ef4ffb3e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $748yq = parcelRequire("748yq");

var $MM3bs = parcelRequire("MM3bs");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("aHmOa");
var $hJsSa = parcelRequire("hJsSa");
const $3b2e0e17ef4ffb3e$var$selector = (0, $3yyCx.createSelector)((0, $2hx7o.getCanAdministerJIRA), (canAdministerJira)=>({
        canAdministerJira: canAdministerJira
    }));
const $3b2e0e17ef4ffb3e$var$connector = (0, $bmgw6.default)($3b2e0e17ef4ffb3e$var$selector, null);
const $3b2e0e17ef4ffb3e$var$withOnlyJiraAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { canAdministerJira: canAdministerJira } = props;
            if (canAdministerJira) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $4fqPo.createElement((0, $hJsSa.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $4fqPo.createElement((0, $MM3bs.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $748yq.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $3b2e0e17ef4ffb3e$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyJiraAdmin';
        return ConnectedComponent;
    };
var $3b2e0e17ef4ffb3e$export$2e2bcd8739ae039 = $3b2e0e17ef4ffb3e$var$withOnlyJiraAdmin;

});


parcelRegister("3va4S", function(module, exports) {
$parcel$export(module.exports, "withOnlyLoggedIn", () => (parcelRequire("8MkVk")).default);

var $8MkVk = parcelRequire("8MkVk");

});
parcelRegister("8MkVk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c167b96aefc20308$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $81eJ3 = parcelRequire("81eJ3");

var $Y85G3 = parcelRequire("Y85G3");
const $c167b96aefc20308$var$selector = (0, $3yyCx.createSelector)((0, $2hx7o.isLoggedIn), (isLoggedIn)=>({
        isLoggedIn: isLoggedIn
    }));
const $c167b96aefc20308$var$connector = (0, $bmgw6.default)($c167b96aefc20308$var$selector, null);
const $c167b96aefc20308$var$withOnlyLoggedIn = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isLoggedIn: isLoggedIn } = props;
            if (isLoggedIn) // @ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props);
            const { redirectUrl: redirectUrl } = options;
            const loginUrl = (0, $Y85G3.getLoginUrl)({
                redirectUrl: redirectUrl,
                isAbsolute: false
            });
            return /*#__PURE__*/ $4fqPo.createElement((0, $81eJ3.Redirect), {
                to: loginUrl
            });
        };
        const ConnectedComponent = $c167b96aefc20308$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyLoggedIn';
        return ConnectedComponent;
    };
var $c167b96aefc20308$export$2e2bcd8739ae039 = $c167b96aefc20308$var$withOnlyLoggedIn;

});
parcelRegister("81eJ3", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $1ba98595676e6300$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "PushRedirectWithState", () => $1ba98595676e6300$export$e3f5537ca0fe1626);
$parcel$export(module.exports, "PushRedirect", () => $1ba98595676e6300$export$74676119665a0bf8);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("l8iRu");
var $1UKKy = parcelRequire("1UKKy");
var $lM7Z9 = parcelRequire("lM7Z9");
const $1ba98595676e6300$export$2d8d895a0a0f636e = (props)=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $1UKKy.Redirect), props);
};
const $1ba98595676e6300$export$e3f5537ca0fe1626 = (0, $lM7Z9.withRouter)(({ history: history, to: to, state: state })=>{
    (0, $4fqPo.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to, state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        to,
        state
    ]);
    return null;
});
const $1ba98595676e6300$export$74676119665a0bf8 = (0, $lM7Z9.withRouter)(({ history: history, to: to })=>{
    (0, $4fqPo.useEffect)(()=>{
        // @ts-ignore the history is provided by the router
        history.push(to);
    }, [
        history,
        to
    ]);
    return null;
});

});



parcelRegister("evK9u", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("a8nBS")).default);
parcelRequire("bTdbE");
var $a8nBS = parcelRequire("a8nBS");

});
parcelRegister("bTdbE", function(module, exports) {
$parcel$export(module.exports, "SplashLayoutRoute", () => (parcelRequire("a8nBS")).default);

var $a8nBS = parcelRequire("a8nBS");

});
parcelRegister("a8nBS", function(module, exports) {
$parcel$export(module.exports, "default", () => $6919c0e479cb0612$export$2e2bcd8739ae039);
/* splash-layout.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $fNSBJ = parcelRequire("fNSBJ");
var $iHhPj = parcelRequire("iHhPj");
parcelRequire("4r1vU");
var $9OTKp = parcelRequire("9OTKp");

var $7zOGv = parcelRequire("7zOGv");
parcelRequire("e2QHY");
var $7aI9q = parcelRequire("7aI9q");
const $6919c0e479cb0612$export$2400592c1982dcfe = ({ children: children, isFooterHidden: isFooterHidden })=>/*#__PURE__*/ $4fqPo.createElement((0, $iHhPj.default), {
        testId: "page-layout"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $fNSBJ.default), null, /*#__PURE__*/ $4fqPo.createElement($6919c0e479cb0612$var$StyledContent, null, /*#__PURE__*/ $4fqPo.createElement("main", null, /*#__PURE__*/ $4fqPo.createElement((0, $9OTKp.MainContentSkipLinkWrapper), null, children)), !isFooterHidden && /*#__PURE__*/ $4fqPo.createElement((0, $7zOGv.StyledFooter), {
        sticky: false
    }))));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6919c0e479cb0612$var$StyledContent = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
var $6919c0e479cb0612$export$2e2bcd8739ae039 = (0, $7aI9q.default)($6919c0e479cb0612$export$2400592c1982dcfe);

});



parcelRegister("lAMwM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea97a19303d014da$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $ea97a19303d014da$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    limitErrorFlagTitle: {
        defaultMessage: "You\u2019ve already featured {limit, plural, one {# portal} other {# portals}}",
        description: 'Limit error flag title',
        id: 'cv.portal.reordering.experience.limit.error.title.v2'
    },
    limitErrorFlagDescription: {
        defaultMessage: 'Remove a portal from the featured section to add another one.',
        description: 'Limit error flag description',
        id: 'cv.portal.reordering.experience.limit.error.description.v2'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'cv.portal.reordering.experience.un.auth.action.text'
    },
    portalSectionHeader: {
        defaultMessage: 'Portals',
        description: 'This section divides the topic from the service desk edit section',
        id: 'cv.portal.reordering.experience.service.desk.section.header.text'
    },
    publishTopicsErrorTitle: {
        defaultMessage: "We couldn\u2019t publish your changes",
        description: 'Title of the message shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.title'
    },
    publishTopicsErrorDescription: {
        defaultMessage: 'Refresh the page and try publishing again.',
        description: 'Description of the message shown shown when publishing fails',
        id: 'cv.portal.reordering.experience.topics.publish.error.description'
    },
    portalsHiddenWarningTitle: {
        defaultMessage: 'Portals are hidden from your home page',
        description: 'Warning title when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.title'
    },
    portalsHiddenWarningDescription: {
        defaultMessage: 'The portals section on your home page is hidden. Edit page layout to show portals on the home page.',
        description: 'Warning description when the portals section is hidden.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.description'
    },
    editPageLayoutAction: {
        defaultMessage: 'Edit page layout',
        description: 'Action to show the portals section.',
        id: 'cv.portal.reordering.experience.portals.hidden.warning.action'
    }
});

});

parcelRegister("jyAe6", function(module, exports) {
$parcel$export(module.exports, "PortalReorderExperienceLoader", () => (parcelRequire("1SIHv")).default);

var $1SIHv = parcelRequire("1SIHv");

});
parcelRegister("1SIHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e4ec01626264820$export$2e2bcd8739ae039);
/* portal-reorder-experience-loader.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $bvB7a = parcelRequire("bvB7a");

var $63sfu = parcelRequire("63sfu");

var $efDRU = parcelRequire("efDRU");
parcelRequire("01ByE");
var $b6E8k = parcelRequire("b6E8k");
parcelRequire("3Bugx");
var $dKoXn = parcelRequire("dKoXn");
parcelRequire("hDsaL");
var $7Oj2h = parcelRequire("7Oj2h");

var $93Vf4 = parcelRequire("93Vf4");

var $7K78T = parcelRequire("7K78T");
const $6e4ec01626264820$export$1b7c65f90ce5d7ad = (props)=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $93Vf4.Wrapper), null, /*#__PURE__*/ $4fqPo.createElement((0, $dKoXn.default), {
        isDirty: false,
        openPublishPrompt: (0, $63sfu.noop),
        openCancelPrompt: (0, $63sfu.noop)
    }), /*#__PURE__*/ $4fqPo.createElement((0, $93Vf4.ExperienceContainer), null, props.error ? /*#__PURE__*/ $4fqPo.createElement($6e4ec01626264820$var$LoaderContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $bvB7a.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($6e4ec01626264820$var$FeaturedPortalsWrapper, null, /*#__PURE__*/ $4fqPo.createElement("h2", null, props.intl.formatMessage((0, $7K78T.default).featuredPortalsTitle)), /*#__PURE__*/ $4fqPo.createElement((0, $93Vf4.CardsContainer), null, Array.from({
        length: 3
    }).map((_, index)=>/*#__PURE__*/ $4fqPo.createElement((0, $b6E8k.default), {
            key: index,
            isFeatured: true
        })))), /*#__PURE__*/ $4fqPo.createElement($6e4ec01626264820$var$UnFeaturedPortalsWrapper, null, /*#__PURE__*/ $4fqPo.createElement((0, $7Oj2h.default), {
        isDisabled: true,
        value: "POPULARITY",
        onChange: (0, $63sfu.noop)
    }), /*#__PURE__*/ $4fqPo.createElement((0, $93Vf4.CardsContainer), null, Array.from({
        length: 9
    }).map((_, index)=>/*#__PURE__*/ $4fqPo.createElement((0, $b6E8k.default), {
            key: index,
            isFeatured: true
        })))))));
};
var $6e4ec01626264820$export$2e2bcd8739ae039 = (0, $efDRU.default)($6e4ec01626264820$export$1b7c65f90ce5d7ad);
const $6e4ec01626264820$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $6e4ec01626264820$var$LoaderContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1tken9zg",
            __cmplp.className
        ])
    });
});
const $6e4ec01626264820$var$UnFeaturedPortalsWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $6e4ec01626264820$var$FeaturedPortalsWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_n7zl1dd9 _19pkpxbi _13jwangw _1n46ze3t _1gnpu2gc _7e5b1jfw _1advidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("01ByE", function(module, exports) {
$parcel$export(module.exports, "ProjectCardSkeleton", () => (parcelRequire("b6E8k")).default);

var $b6E8k = parcelRequire("b6E8k");

});
parcelRegister("b6E8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $572de6ec6c795099$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $j4lpV = parcelRequire("j4lpV");

var $bpWyP = parcelRequire("bpWyP");

var $hyXmz = parcelRequire("hyXmz");

var $gUZCV = parcelRequire("gUZCV");

var $eVQfr = parcelRequire("eVQfr");
parcelRequire("cpp0j");
var $cVlRK = parcelRequire("cVlRK");
parcelRequire("8nMQt");
var $2MKHy = parcelRequire("2MKHy");
parcelRequire("1OWhn");
var $cVlRK = parcelRequire("cVlRK");
var $1OWhn = parcelRequire("1OWhn");
const $572de6ec6c795099$var$ProjectsCardSkeleton = ({ isBasic: isBasic, isFeatured: isFeatured })=>{
    return /*#__PURE__*/ $4fqPo.createElement($572de6ec6c795099$var$Root, {
        "data-testid": 'project-card-skeleton'
    }, /*#__PURE__*/ $4fqPo.createElement((0, $cVlRK.Container), {
        hasIcon: true
    }, !isBasic && isFeatured && /*#__PURE__*/ $4fqPo.createElement($572de6ec6c795099$var$ActionsLeft, null, /*#__PURE__*/ $4fqPo.createElement((0, $2MKHy.DragHandlerWrapper), null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyXmz))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $cVlRK.IconContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: $bpWyP.multiple(6).px,
        height: $bpWyP.multiple(6).px
    })), /*#__PURE__*/ $4fqPo.createElement((0, $cVlRK.Content), null, /*#__PURE__*/ $4fqPo.createElement($572de6ec6c795099$var$NameWrapper, null, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: $bpWyP.multiple(11).px,
        height: (0, $1OWhn.titleSkeletonHeight)
    })), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: $bpWyP.multiple(18).px,
        height: "14px"
    })), !isBasic && /*#__PURE__*/ $4fqPo.createElement($572de6ec6c795099$var$Actions, null, isFeatured ? /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gUZCV))), {
        label: "star-filled-icon",
        size: "medium"
    })) : /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eVQfr))), {
        label: "start-icon",
        size: "medium"
    }))));
};
var $572de6ec6c795099$export$2e2bcd8739ae039 = $572de6ec6c795099$var$ProjectsCardSkeleton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $572de6ec6c795099$var$Root = /*#__PURE__*/ (0, $el3DQ.default).li.withConfig({
    componentId: "sc-12n7yik-0"
})`${(0, $cVlRK.cardStyle)} ${(0, $2MKHy.cardGutterStyle)} border:solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #DFE1E6)"};background-color:${"var(--ds-surface-raised, #FFFFFF)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $572de6ec6c795099$var$NameWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-12n7yik-1"
})`margin-bottom:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $572de6ec6c795099$var$Actions = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-12n7yik-2"
})`display:flex;flex-direction:column;align-items:center;position:absolute;color:${"var(--ds-skeleton, #F4F5F7)"};top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-100, 8px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $572de6ec6c795099$var$ActionsLeft = /*#__PURE__*/ (0, $el3DQ.default)($572de6ec6c795099$var$Actions).withConfig({
    componentId: "sc-12n7yik-3"
})`position:initial;width:${$bpWyP.multiple(5).px};margin-top:-${$bpWyP.multiple(6).px};`;

});
parcelRegister("hyXmz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::976c79b56a8fa85b795a69d54376c6cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc93a8e52e511ab2$var$_react = $cc93a8e52e511ab2$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $cc93a8e52e511ab2$var$_baseNew = $cc93a8e52e511ab2$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $cc93a8e52e511ab2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc93a8e52e511ab2$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $cc93a8e52e511ab2$var$_react.default.createElement($cc93a8e52e511ab2$var$_baseNew.default, Object.assign({
        name: "DragHandleVerticalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$cc93a8e52e511ab2$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $cc93a8e52e511ab2$var$_default = module.exports.default = $cc93a8e52e511ab2$var$DragHandleVerticalIcon;

});

parcelRegister("gUZCV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::230a74b5beecd6089e40fb6fd34c20ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c511ae193415d6bc$var$_react = $c511ae193415d6bc$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $c511ae193415d6bc$var$_baseNew = $c511ae193415d6bc$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $c511ae193415d6bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c511ae193415d6bc$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c511ae193415d6bc$var$_react.default.createElement($c511ae193415d6bc$var$_baseNew.default, Object.assign({
        name: "StarStarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c511ae193415d6bc$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c511ae193415d6bc$var$_default = module.exports.default = $c511ae193415d6bc$var$StarStarredIcon;

});

parcelRegister("eVQfr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1160d31b57f6ed551c99a3d7adfc3c7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $adeeeaf1aef2b642$var$_react = $adeeeaf1aef2b642$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $adeeeaf1aef2b642$var$_baseNew = $adeeeaf1aef2b642$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $adeeeaf1aef2b642$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarUnstarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starring or favoriting objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $adeeeaf1aef2b642$var$StarUnstarredIcon = (props)=>/*#__PURE__*/ $adeeeaf1aef2b642$var$_react.default.createElement($adeeeaf1aef2b642$var$_baseNew.default, Object.assign({
        name: "StarUnstarredIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/>`
    }, props));
$adeeeaf1aef2b642$var$StarUnstarredIcon.displayName = 'StarUnstarredIcon';
var $adeeeaf1aef2b642$var$_default = module.exports.default = $adeeeaf1aef2b642$var$StarUnstarredIcon;

});

parcelRegister("cpp0j", function(module, exports) {
$parcel$export(module.exports, "PortalCard", () => (parcelRequire("dzrJw")).default);
$parcel$export(module.exports, "PortalName", () => (parcelRequire("cVlRK")).PortalName);
$parcel$export(module.exports, "cardStyle", () => (parcelRequire("cVlRK")).cardStyle);
$parcel$export(module.exports, "PortalCardContainer", () => (parcelRequire("cVlRK")).Container);

var $dzrJw = parcelRequire("dzrJw");

var $cVlRK = parcelRequire("cVlRK");

});
parcelRegister("dzrJw", function(module, exports) {
$parcel$export(module.exports, "default", () => $1265f1d0806380f6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $a3bgj = parcelRequire("a3bgj");

var $bG6ob = parcelRequire("bG6ob");

var $4na5O = parcelRequire("4na5O");

var $2xGi5 = parcelRequire("2xGi5");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $brRRh = parcelRequire("brRRh");

var $dXHSc = parcelRequire("dXHSc");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");
parcelRequire("i7I7b");
var $lrgoy = parcelRequire("lrgoy");

var $fFB0R = parcelRequire("fFB0R");
var $ew3Bn = parcelRequire("ew3Bn");

var $54jwS = parcelRequire("54jwS");

var $ebpTf = parcelRequire("ebpTf");

var $3TeDY = parcelRequire("3TeDY");

var $cVlRK = parcelRequire("cVlRK");
var $1265f1d0806380f6$var$_customPurify$addHook, $1265f1d0806380f6$var$_customPurifyIsomorph;
const $1265f1d0806380f6$export$6448f23ea2cffe7b = (0, (/*@__PURE__*/$parcel$interopDefault($a7SRW)))();
const $1265f1d0806380f6$export$292d791731e624a3 = $1BEGf;
($1265f1d0806380f6$var$_customPurify$addHook = $1265f1d0806380f6$export$6448f23ea2cffe7b.addHook) === null || $1265f1d0806380f6$var$_customPurify$addHook === void 0 || $1265f1d0806380f6$var$_customPurify$addHook.call($1265f1d0806380f6$export$6448f23ea2cffe7b, 'afterSanitizeAttributes', (node)=>{
    if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT') node.setAttribute('tabIndex', '-1');
});
($1265f1d0806380f6$var$_customPurifyIsomorph = $1265f1d0806380f6$export$292d791731e624a3.addHook) === null || $1265f1d0806380f6$var$_customPurifyIsomorph === void 0 || $1265f1d0806380f6$var$_customPurifyIsomorph.call($1265f1d0806380f6$export$292d791731e624a3, 'afterSanitizeAttributes', (node)=>{
    if (node.tagName === 'A' || node.tagName === 'BUTTON' || node.tagName === 'INPUT') node.setAttribute('tabIndex', '-1');
});
const $1265f1d0806380f6$var$PortalCard = ({ onClick: onClick, index: index, id: id, portalName: portalName, description: description, portalUrl: portalUrl, iconUrl: iconUrl, openInNewTab: openInNewTab })=>{
    const [isPageInEditMode] = (0, $lrgoy.useIsPageInEditMode)();
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const hasIcon = !!iconUrl;
    const hasPortalUrl = !!portalUrl;
    const hasDescription = !!description;
    const hasOnlyPortalName = !description && !iconUrl;
    const memoizedOnClick = $4fqPo.useCallback(()=>{
        const event = createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubjectId: 'portal'
        });
        event.context.push({
            componentName: 'link',
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        });
        event.fire();
        if (openInNewTab) {
            const { baseUrl: baseUrl } = (0, $ebpTf.getEnv)();
            (0, $3TeDY.open)(`${baseUrl}${portalUrl}`, '_blank');
        } else push(portalUrl);
        onClick && onClick(index);
    }, [
        createAnalyticsEvent,
        index,
        hasIcon,
        hasPortalUrl,
        hasDescription,
        id,
        push,
        portalUrl,
        onClick,
        openInNewTab
    ]);
    let sanitizedDescription = '';
    if ((0, $bG6ob.isIsomorphicDompurifyLibUsed)()) sanitizedDescription = $1265f1d0806380f6$export$292d791731e624a3.sanitize(description || '');
    else sanitizedDescription = $1265f1d0806380f6$export$6448f23ea2cffe7b.sanitize(description || '');
    const content = /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$Container, {
        hasIcon: hasIcon
    }, !!iconUrl && /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$IconContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $a3bgj.default), {
        src: iconUrl,
        alt: '',
        draggable: "false"
    })), /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$Content, null, /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$PortalName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: portalName
    }, portalName), !!description && /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$Description, {
        title: description,
        dangerouslySetInnerHTML: {
            __html: sanitizedDescription
        }
    })));
    const portalCardContent = /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$CardRoot, {
        "aria-label": portalName,
        onClick: memoizedOnClick,
        "data-test-id": `portal:${portalName}`,
        role: "link"
    }, content);
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            attributes: {
                index: index,
                hasIcon: hasIcon,
                hasPortalUrl: hasPortalUrl,
                hasDescription: hasDescription,
                portalId: id
            }
        }
    }, isPageInEditMode ? /*#__PURE__*/ $4fqPo.createElement($1265f1d0806380f6$var$RootWhenEditingLayout, null, content) : portalCardContent);
};
var $1265f1d0806380f6$export$2e2bcd8739ae039 = $1265f1d0806380f6$var$PortalCard;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$PortalName = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ob3s3l-0"
})`${$4W9tu.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $bpWyP.multiple(2).unitless;
    return $iSWaE.multiLineClamp(lines, lineHeight);
}};${$2xGi5.fromXSmall.css`
        ${$4W9tu.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $bpWyP.multiple(7.5).px : $bpWyP.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$Description = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ob3s3l-1"
})`${$4W9tu.xsmall};${$iSWaE.multiLineClamp(3, $bpWyP.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$bpWyP.multiple(2.25).px};${$2xGi5.fromXSmall.css`
        ${$4W9tu.regular};
        line-height: ${$bpWyP.multiple(2.5).px};
        max-height: ${$bpWyP.multiple(7.5).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$Content = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ob3s3l-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $1265f1d0806380f6$var$CardRoot = /*#__PURE__*/ (0, $el3DQ.default)((0, $4na5O.InteractiveElement)).withConfig({
    componentId: "sc-ob3s3l-3"
})`${(0, $cVlRK.cardStyle)} ${$iSWaE.raiseUpOnHoverOrFocus()};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$dXHSc.portalCardLayout};text-decoration:none;}cursor:pointer;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$RootWhenEditingLayout = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ob3s3l-4"
})`${(0, $cVlRK.cardStyle)} box-shadow:${`var(--ds-shadow-raised, ${`0 1px 1px rgba(9, 30, 66, 0.25), 0 0 1px 1px rgba(9, 30, 66, 0.13)`})`};background-color:${"var(--ds-surface-raised, #FFFFFF)"};transition:transform ${$brRRh.speedMs.fast}ms ${$brRRh.timingFunctions.easeInOut};&:hover,&:focus{z-index:${$dXHSc.portalCardLayout};text-decoration:none;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$IconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ob3s3l-5"
})`${$iSWaE.flexCenter};height:${$bpWyP.multiple(5).px};width:${$bpWyP.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$2xGi5.fromXSmall.css`
        height: ${$bpWyP.multiple(6).px};
        width: ${$bpWyP.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$largePadding = /*#__PURE__*/ (0, $el3DQ.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$2xGi5.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$smallPadding = /*#__PURE__*/ (0, $el3DQ.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$2xGi5.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1265f1d0806380f6$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-ob3s3l-6"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $1265f1d0806380f6$var$smallPadding : $1265f1d0806380f6$var$largePadding};`;

});
parcelRegister("a3bgj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d1a08ce71193844$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $2d1a08ce71193844$var$AutoScaledImage = /*#__PURE__*/ (0, $el3DQ.default).img.withConfig({
    componentId: "sc-1gbtcy6-0"
})`height:100%;width:${({ inheritWidth: inheritWidth })=>inheritWidth ? 'inherit' : '100%'};object-fit:${(props)=>props.objectFit || 'contain'};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$2d1a08ce71193844$export$2e2bcd8739ae039 = $2d1a08ce71193844$var$AutoScaledImage;

});

parcelRegister("4na5O", function(module, exports) {
$parcel$export(module.exports, "InteractiveElement", () => $d3de2175fa95dc3e$export$c0db965635c41eb6);

var $4fqPo = parcelRequire("4fqPo");
const $d3de2175fa95dc3e$export$c0db965635c41eb6 = ({ onClick: onClick, children: children, role: role = 'button', tagName: TagName = 'div', ...props })=>{
    const handleKeyDown = (0, $4fqPo.useCallback)((event)=>{
        // Runs onClick on space and enter key press for accessibility
        if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            onClick && onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(TagName, {
        tabIndex: 0,
        role: role,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        ...props
    }, children);
};
var $d3de2175fa95dc3e$export$2e2bcd8739ae039 = $d3de2175fa95dc3e$export$c0db965635c41eb6;

});

parcelRegister("i7I7b", function(module, exports) {
$parcel$export(module.exports, "useConfigPanelUI", () => (parcelRequire("lrgoy")).useConfigPanelUI);
$parcel$export(module.exports, "useDeletedModulesCount", () => (parcelRequire("lrgoy")).useDeletedModulesCount);
$parcel$export(module.exports, "useElementRenderer", () => (parcelRequire("lrgoy")).useElementRenderer);
$parcel$export(module.exports, "useIsDirty", () => (parcelRequire("lrgoy")).useIsDirty);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => (parcelRequire("lrgoy")).useIsPageInBrandingPreviewMode);
$parcel$export(module.exports, "useIsPageInEditMode", () => (parcelRequire("lrgoy")).useIsPageInEditMode);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => (parcelRequire("lrgoy")).useIsPageInPreviewMode);
$parcel$export(module.exports, "useIsPublishDisabled", () => (parcelRequire("lrgoy")).useIsPublishDisabled);
$parcel$export(module.exports, "useIsPublishing", () => (parcelRequire("lrgoy")).useIsPublishing);
$parcel$export(module.exports, "useLayoutActions", () => (parcelRequire("lrgoy")).useLayoutActions);
$parcel$export(module.exports, "useLayoutConfig", () => (parcelRequire("lrgoy")).useLayoutConfig);
$parcel$export(module.exports, "useLayoutIds", () => (parcelRequire("lrgoy")).useLayoutIds);
$parcel$export(module.exports, "useMediaConfig", () => (parcelRequire("lrgoy")).useMediaConfig);
$parcel$export(module.exports, "usePageType", () => (parcelRequire("lrgoy")).usePageType);
$parcel$export(module.exports, "useReorderedModulesCount", () => (parcelRequire("lrgoy")).useReorderedModulesCount);
$parcel$export(module.exports, "useSectionPicker", () => (parcelRequire("lrgoy")).useSectionPicker);
$parcel$export(module.exports, "useSelectedPrimitive", () => (parcelRequire("lrgoy")).useSelectedPrimitive);
parcelRequire("lrgoy");

});
parcelRegister("lrgoy", function(module, exports) {
$parcel$export(module.exports, "LayoutBuilderContainer", () => $c7fe4f45455b7f28$export$b4aab0ffc58aaa5);
$parcel$export(module.exports, "useIsPageInEditMode", () => $c7fe4f45455b7f28$export$7be577f8255e624c);
$parcel$export(module.exports, "useIsPageInPreviewMode", () => $c7fe4f45455b7f28$export$20672b722d2aa4d4);
$parcel$export(module.exports, "useSectionPicker", () => $c7fe4f45455b7f28$export$1672d32e0a0e6fce);
$parcel$export(module.exports, "useSelectedPrimitive", () => $c7fe4f45455b7f28$export$66366b49ee6cbaa2);
$parcel$export(module.exports, "useIsPublishing", () => $c7fe4f45455b7f28$export$b9b3eff0a656013d);
$parcel$export(module.exports, "useIsPublishDisabled", () => $c7fe4f45455b7f28$export$122ac12905cb91a9);
$parcel$export(module.exports, "useIsDirty", () => $c7fe4f45455b7f28$export$9b9cd7e7602f602f);
$parcel$export(module.exports, "useMediaConfig", () => $c7fe4f45455b7f28$export$7f746b47c356effa);
$parcel$export(module.exports, "useIsPageInBrandingPreviewMode", () => $c7fe4f45455b7f28$export$dbe8a2a3e19e92cf);
$parcel$export(module.exports, "useLayoutConfig", () => $c7fe4f45455b7f28$export$6bc9f3ef36ce1121);
$parcel$export(module.exports, "useLayoutIds", () => $c7fe4f45455b7f28$export$5fb152f2612e3297);
$parcel$export(module.exports, "useElementRenderer", () => $c7fe4f45455b7f28$export$68c713430d820919);
$parcel$export(module.exports, "useDeletedModulesCount", () => $c7fe4f45455b7f28$export$2056c520eb48ec8b);
$parcel$export(module.exports, "useReorderedModulesCount", () => $c7fe4f45455b7f28$export$4010704f08b334ba);
$parcel$export(module.exports, "useConfigPanelUI", () => $c7fe4f45455b7f28$export$7eebf066d70abd18);
$parcel$export(module.exports, "usePageType", () => $c7fe4f45455b7f28$export$4ca74c2ebe5e7020);
$parcel$export(module.exports, "useLayoutActions", () => $c7fe4f45455b7f28$export$1069bba51f142634);

var $bG6ob = parcelRequire("bG6ob");

var $4CywU = parcelRequire("4CywU");
var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");
var $nljJW = parcelRequire("nljJW");

var $ebpTf = parcelRequire("ebpTf");

var $lo2dc = parcelRequire("lo2dc");

var $95v1b = parcelRequire("95v1b");
if ((0, $ebpTf.getEnv)().environment !== (0, $ebpTf.EnvType).PROD) (0, $nljJW.default).devtools = true;
const $c7fe4f45455b7f28$export$c78554af6dbb181d = ()=>{
    return (0, $bG6ob.isIncreasedFlexibilityEnabled)() ? {
        hideCatalogue: false,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: true,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    } : {
        hideCatalogue: true,
        canAddNewSections: true,
        canAddNewSubSections: false,
        canInteractWithSubSections: false,
        canInteractWithElements: false,
        canDeleteSections: true,
        newSectionCanOnlyAddEditor: true
    };
};
const $c7fe4f45455b7f28$var$emptyLayoutId = {
    sectionId: undefined,
    elementId: undefined
};
const $c7fe4f45455b7f28$export$1cb7963f0d33db7c = {
    HelpLayoutHeroElement: $c7fe4f45455b7f28$var$emptyLayoutId,
    HelpLayoutAnnouncementElement: $c7fe4f45455b7f28$var$emptyLayoutId,
    HelpLayoutTopicsListElement: $c7fe4f45455b7f28$var$emptyLayoutId,
    HelpLayoutPortalsListElement: $c7fe4f45455b7f28$var$emptyLayoutId,
    HelpLayoutSuggestedRequestFormsListElement: $c7fe4f45455b7f28$var$emptyLayoutId,
    HelpLayoutForgeElement: [],
    HelpLayoutConnectElement: []
};
const $c7fe4f45455b7f28$export$d4c72bab9d6cc13a = {
    layoutIds: $c7fe4f45455b7f28$export$1cb7963f0d33db7c,
    isPageInEditMode: false,
    isPageInPreviewMode: false,
    isPageInBrandingPreviewMode: false,
    isPublishing: false,
    isPublishDisabled: true,
    isDirty: false,
    mediaConfig: {},
    deletedModulesCount: 0,
    reorderedModulesCount: 0,
    screenName: undefined,
    experience: undefined,
    traceId: undefined,
    events: {
        selected: undefined,
        hovered: undefined,
        dragged: undefined,
        sectionPickerId: undefined
    },
    configPanel: {
        ui: null
    },
    config: $c7fe4f45455b7f28$export$c78554af6dbb181d()
};
const $c7fe4f45455b7f28$export$6f57813fe9f31bf9 = (0, $2RDzF.createStore)({
    initialState: $c7fe4f45455b7f28$export$d4c72bab9d6cc13a,
    actions: $lo2dc.actions,
    name: 'LayoutBuilderStore'
});
const $c7fe4f45455b7f28$export$13f23e293cec2ec3 = ()=>({ setState: setState }, { configPanelUI: configPanelUI, editMode: editMode, ElementRenderer: ElementRenderer, screenName: screenName, experience: experience, traceId: traceId, mediaConfig: mediaConfig, pageType: pageType, config: config = {}, events: events = {} })=>{
        setState({
            events: events,
            mediaConfig: mediaConfig,
            ElementRenderer: ElementRenderer,
            screenName: screenName,
            experience: experience,
            traceId: traceId,
            pageType: (0, $bG6ob.isCustomPagesUiEnabled)() ? pageType : undefined,
            isPageInEditMode: editMode,
            isPageInPreviewMode: false,
            config: {
                ...$c7fe4f45455b7f28$export$c78554af6dbb181d(),
                ...config
            },
            configPanel: {
                ui: configPanelUI
            }
        });
    };
const $c7fe4f45455b7f28$export$b4aab0ffc58aaa5 = (0, $4CywU.createContainer)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    onInit: $c7fe4f45455b7f28$export$13f23e293cec2ec3,
    displayName: 'LayoutBuilderContainer'
});
const $c7fe4f45455b7f28$export$7be577f8255e624c = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getIsPageInEditMode)
});
const $c7fe4f45455b7f28$export$20672b722d2aa4d4 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getIsPageInPreviewMode)
});
const $c7fe4f45455b7f28$export$1672d32e0a0e6fce = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getSectionPickerId)
});
const $c7fe4f45455b7f28$export$66366b49ee6cbaa2 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getSelectedPrimitive)
});
const $c7fe4f45455b7f28$export$b9b3eff0a656013d = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getIsPublishing)
});
const $c7fe4f45455b7f28$export$122ac12905cb91a9 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getIsPublishDisabled)
});
const $c7fe4f45455b7f28$export$9b9cd7e7602f602f = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getIsDirty)
});
const $c7fe4f45455b7f28$export$7f746b47c356effa = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getMediaConfig)
});
const $c7fe4f45455b7f28$export$dbe8a2a3e19e92cf = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getIsPageInBrandingPreviewMode)
});
const $c7fe4f45455b7f28$export$6bc9f3ef36ce1121 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getLayoutConfig)
});
const $c7fe4f45455b7f28$export$5fb152f2612e3297 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getLayoutIds)
});
const $c7fe4f45455b7f28$export$68c713430d820919 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getElementRenderer)
});
const $c7fe4f45455b7f28$export$2056c520eb48ec8b = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (state)=>state.deletedModulesCount
});
const $c7fe4f45455b7f28$export$4010704f08b334ba = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (state)=>state.reorderedModulesCount
});
const $c7fe4f45455b7f28$export$7eebf066d70abd18 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (0, $95v1b.getConfigPanelUI)
});
const $c7fe4f45455b7f28$export$4ca74c2ebe5e7020 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageType
});
const $c7fe4f45455b7f28$export$1069bba51f142634 = (0, $iouul.createHook)($c7fe4f45455b7f28$export$6f57813fe9f31bf9);

});
parcelRegister("lo2dc", function(module, exports) {
$parcel$export(module.exports, "actions", () => $6fc44c8a27a1bd68$export$e324594224ef24da);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("fW8eZ");
var $cHUW4 = parcelRequire("cHUW4");
const $6fc44c8a27a1bd68$export$eed4cbff0d0952a0 = ()=>({ getState: getState, setState: setState })=>{
        var _currentState$events$, _currentState$events$2;
        const currentState = getState();
        const pageDataId = (_currentState$events$ = currentState.events.selected) === null || _currentState$events$ === void 0 || (_currentState$events$ = _currentState$events$.path[0]) === null || _currentState$events$ === void 0 ? void 0 : _currentState$events$.dataId;
        setState({
            events: {
                hovered: undefined,
                selected: (0, $bG6ob.isIncreasedFlexibilityEnabled)() && pageDataId ? {
                    dataId: pageDataId,
                    path: ((_currentState$events$2 = currentState.events.selected) === null || _currentState$events$2 === void 0 ? void 0 : _currentState$events$2.path.slice(0, 1)) || []
                } : undefined,
                sectionPickerId: undefined
            },
            configPanel: {
                ui: (0, $bG6ob.isIncreasedFlexibilityEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cHUW4.ConfigPanelEmptyState), null)
            }
        });
    };
const $6fc44c8a27a1bd68$export$2b82c83704d16f1e = (dataId, path)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                selected: {
                    dataId: dataId,
                    path: path
                }
            }
        });
    };
const $6fc44c8a27a1bd68$export$63f1a53b56db7e60 = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                hovered: dataId
            }
        });
    };
const $6fc44c8a27a1bd68$export$703359b98869d7ca = (dataId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                dragged: dataId
            }
        });
    };
const $6fc44c8a27a1bd68$export$f03c06073cab57c8 = (sectionId)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            events: {
                hovered: undefined,
                selected: undefined,
                sectionPickerId: sectionId
            }
        });
    };
const $6fc44c8a27a1bd68$export$7cc839743e7817e1 = (isPublishing)=>({ setState: setState })=>{
        setState({
            isPublishing: isPublishing
        });
    };
const $6fc44c8a27a1bd68$export$e1757f155540af7b = (isPublishDisabled)=>({ setState: setState })=>{
        setState({
            isPublishDisabled: isPublishDisabled
        });
    };
const $6fc44c8a27a1bd68$export$12e1d22d39b53fc8 = (isDirty)=>({ setState: setState })=>{
        setState({
            isDirty: isDirty
        });
    };
const $6fc44c8a27a1bd68$export$8170ce9a15707844 = (isPageInBrandingPreviewMode)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isPageInBrandingPreviewMode: isPageInBrandingPreviewMode
        });
    };
const $6fc44c8a27a1bd68$export$6c5886565b08070e = (sectionId, elementId, typename)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (typename === 'HelpLayoutForgeElement' || typename === 'HelpLayoutConnectElement') {
            const updatedLayoutIds = {
                ...currentState.layoutIds
            };
            updatedLayoutIds[typename] = [
                ...updatedLayoutIds[typename] || [],
                {
                    sectionId: sectionId,
                    elementId: elementId
                }
            ];
            setState({
                ...currentState,
                layoutIds: updatedLayoutIds
            });
            return;
        }
        setState({
            ...currentState,
            layoutIds: {
                ...currentState.layoutIds,
                [typename]: {
                    sectionId: sectionId,
                    elementId: elementId
                }
            }
        });
    };
const $6fc44c8a27a1bd68$export$18ae1b41966470b5 = ()=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentPreviewMode = currentState.isPageInPreviewMode;
        setState({
            ...currentState,
            isPageInPreviewMode: !currentPreviewMode
        });
    };
const $6fc44c8a27a1bd68$export$59e3de019265ab87 = (deletedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            deletedModulesCount: deletedModulesCount
        });
    };
const $6fc44c8a27a1bd68$export$dd986587ada0d176 = (ui)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            configPanel: {
                ui: ui
            }
        });
    };
const $6fc44c8a27a1bd68$export$de05f3d90acd4969 = (reorderedModulesCount)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            reorderedModulesCount: reorderedModulesCount
        });
    };
const $6fc44c8a27a1bd68$export$20a1a9b113e6ba3a = (mediaConfig)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            mediaConfig: mediaConfig
        });
    };
const $6fc44c8a27a1bd68$export$e324594224ef24da = {
    markPageSelected: $6fc44c8a27a1bd68$export$eed4cbff0d0952a0,
    markSelected: $6fc44c8a27a1bd68$export$2b82c83704d16f1e,
    markHovered: $6fc44c8a27a1bd68$export$63f1a53b56db7e60,
    markDragged: $6fc44c8a27a1bd68$export$703359b98869d7ca,
    markSectionDialogOpen: $6fc44c8a27a1bd68$export$f03c06073cab57c8,
    markIsPublishing: $6fc44c8a27a1bd68$export$7cc839743e7817e1,
    markIsPublishDisabled: $6fc44c8a27a1bd68$export$e1757f155540af7b,
    markIsDirty: $6fc44c8a27a1bd68$export$12e1d22d39b53fc8,
    markBrandingPreviewMode: $6fc44c8a27a1bd68$export$8170ce9a15707844,
    setLayoutId: $6fc44c8a27a1bd68$export$6c5886565b08070e,
    togglePreviewMode: $6fc44c8a27a1bd68$export$18ae1b41966470b5,
    setDeletedModulesCount: $6fc44c8a27a1bd68$export$59e3de019265ab87,
    setReorderedModulesCount: $6fc44c8a27a1bd68$export$de05f3d90acd4969,
    setMediaConfig: $6fc44c8a27a1bd68$export$20a1a9b113e6ba3a,
    setConfigPanelUI: $6fc44c8a27a1bd68$export$dd986587ada0d176
};

});
parcelRegister("fW8eZ", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => (parcelRequire("cHUW4")).ConfigPanelEmptyState);

var $cHUW4 = parcelRequire("cHUW4");

});
parcelRegister("cHUW4", function(module, exports) {
$parcel$export(module.exports, "ConfigPanelEmptyState", () => $ca9e5cda4d310d46$export$2fdc624ef67f147b);

var $4fqPo = parcelRequire("4fqPo");

var $jtbQm = parcelRequire("jtbQm");

var $dQegt = parcelRequire("dQegt");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $5FWil = parcelRequire("5FWil");
const $ca9e5cda4d310d46$export$2fdc624ef67f147b = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "medium",
        as: "h3"
    }, formatMessage((0, $5FWil.default).emptyConfigPanelHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $ca9e5cda4d310d46$var$emptyConfigPanelStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jtbQm))),
        alt: formatMessage((0, $5FWil.default).emptyConfigPanelImageAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        align: "center",
        as: "p"
    }, formatMessage((0, $5FWil.default).emptyConfigPanelText, {
        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("b", null, chunks)
    }))));
};
const $ca9e5cda4d310d46$var$emptyConfigPanelStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 'space.400',
    gap: 'space.200'
});

});
parcelRegister("jtbQm", function(module, exports) {
module.exports = new URL("../images/config-panel-default.4e21e8e2.svg", import.meta.url).toString();

});

parcelRegister("5FWil", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb31247468464eff$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $eb31247468464eff$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    emptyConfigPanelHeading: {
        defaultMessage: 'Edit page layout',
        description: 'Heading to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.heading'
    },
    emptyConfigPanelText: {
        defaultMessage: 'Pages are made of horizontal blocks called <b>sections</b> to which you can add <b>rich content.</b> Select an existing section or add a new one to get started.',
        description: 'Text to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.text'
    },
    emptyConfigPanelImageAltText: {
        defaultMessage: 'The config panel is empty',
        description: 'Alt text for image to be displayed when no section is selected in the layout builder',
        id: 'cv.portal.customization.config.panel.empty.image.alt'
    }
});

});




parcelRegister("95v1b", function(module, exports) {
$parcel$export(module.exports, "getIsPageInEditMode", () => $eb9e17156c28a299$export$31efc24b85422f28);
$parcel$export(module.exports, "getIsPageInPreviewMode", () => $eb9e17156c28a299$export$b16c6dd5c9190b1a);
$parcel$export(module.exports, "getSectionPickerId", () => $eb9e17156c28a299$export$c00ca6bc45704b1a);
$parcel$export(module.exports, "getSelectedPrimitive", () => $eb9e17156c28a299$export$12c45f99974b2f6);
$parcel$export(module.exports, "getIsPublishing", () => $eb9e17156c28a299$export$114b0b1eb879caeb);
$parcel$export(module.exports, "getIsPublishDisabled", () => $eb9e17156c28a299$export$8626e45ed1d507a4);
$parcel$export(module.exports, "getIsDirty", () => $eb9e17156c28a299$export$4b1964ee9ad6f220);
$parcel$export(module.exports, "getMediaConfig", () => $eb9e17156c28a299$export$e0c7d660f7459c46);
$parcel$export(module.exports, "getIsPageInBrandingPreviewMode", () => $eb9e17156c28a299$export$5f742d52a7bee27e);
$parcel$export(module.exports, "getLayoutConfig", () => $eb9e17156c28a299$export$61bd5e607ff26d43);
$parcel$export(module.exports, "getLayoutIds", () => $eb9e17156c28a299$export$c3b66d8cabe26730);
$parcel$export(module.exports, "getElementRenderer", () => $eb9e17156c28a299$export$21591c7e677a0342);
$parcel$export(module.exports, "getConfigPanelUI", () => $eb9e17156c28a299$export$eab87a6b2cabf1fe);
const $eb9e17156c28a299$export$31efc24b85422f28 = (state)=>state.isPageInEditMode;
const $eb9e17156c28a299$export$b16c6dd5c9190b1a = (state)=>state.isPageInPreviewMode;
const $eb9e17156c28a299$export$c00ca6bc45704b1a = (state)=>state.events.sectionPickerId;
const $eb9e17156c28a299$export$12c45f99974b2f6 = (state)=>state.events.selected;
const $eb9e17156c28a299$export$114b0b1eb879caeb = (state)=>state.isPublishing;
const $eb9e17156c28a299$export$8626e45ed1d507a4 = (state)=>state.isPublishDisabled;
const $eb9e17156c28a299$export$4b1964ee9ad6f220 = (state)=>state.isDirty;
const $eb9e17156c28a299$export$e0c7d660f7459c46 = (state)=>state.mediaConfig;
const $eb9e17156c28a299$export$5f742d52a7bee27e = (state)=>state.isPageInBrandingPreviewMode;
const $eb9e17156c28a299$export$61bd5e607ff26d43 = (state)=>state.config;
const $eb9e17156c28a299$export$c3b66d8cabe26730 = (state)=>state.layoutIds;
const $eb9e17156c28a299$export$21591c7e677a0342 = (state)=>state.ElementRenderer;
const $eb9e17156c28a299$export$eab87a6b2cabf1fe = (state)=>state.configPanel.ui;

});



parcelRegister("cVlRK", function(module, exports) {
$parcel$export(module.exports, "PortalName", () => $4604138a418a3600$export$388673bc95b650ac);
$parcel$export(module.exports, "Description", () => $4604138a418a3600$export$393edc798c47379d);
$parcel$export(module.exports, "Content", () => $4604138a418a3600$export$7c6e2c02157bb7d2);
$parcel$export(module.exports, "cardStyle", () => $4604138a418a3600$export$20fbd02c8b16da77);
$parcel$export(module.exports, "IconContainer", () => $4604138a418a3600$export$8f314e512d92575f);
$parcel$export(module.exports, "Container", () => $4604138a418a3600$export$42a852a2b6b56249);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $2xGi5 = parcelRequire("2xGi5");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $dXHSc = parcelRequire("dXHSc");
const $4604138a418a3600$export$388673bc95b650ac = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ics84-0"
})`${$4W9tu.h400};max-width:100%;margin-top:0;margin-bottom:${"var(--ds-space-050, 4px)"};${(props)=>{
    const lines = props.hasOnlyPortalName ? 3 : 1;
    const lineHeight = $bpWyP.multiple(2).unitless;
    return $iSWaE.multiLineClamp(lines, lineHeight);
}};${$2xGi5.fromXSmall.css`
        ${$4W9tu.h500};
        margin-top: 0;
        margin-bottom: ${"var(--ds-space-100, 8px)"};
        max-height: ${(props)=>props.hasOnlyPortalName ? $bpWyP.multiple(7.5).px : $bpWyP.multiple(2.5).px};
    `};&{color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};}`;
const $4604138a418a3600$export$393edc798c47379d = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ics84-1"
})`${$4W9tu.xsmall};${$iSWaE.multiLineClamp(3, $bpWyP.multiple(2.25).unitless)};max-width:100%;color:${"var(--ds-text, #172B4D)"};line-height:${$bpWyP.multiple(2.25).px};${$2xGi5.fromXSmall.css`
        ${$4W9tu.regular};
        line-height: ${$bpWyP.multiple(2.5).px};
        max-height: ${$bpWyP.multiple(7.5).px};
    `};`;
const $4604138a418a3600$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ics84-2"
})`overflow:hidden;width:100%;height:100%;display:flex;flex-direction:column;align-items:flex-start;justify-content:center;`;
const $4604138a418a3600$export$20fbd02c8b16da77 = /*#__PURE__*/ (0, $el3DQ.css)`${$iSWaE.borderRadius};${$iSWaE.focusRing.default};box-sizing:border-box;display:block;position:relative;height:${$bpWyP.multiple(14).px};width:${$bpWyP.multiple(33).px};z-index:${$dXHSc.portalCardLayout};${$2xGi5.fromXSmall.css`
    height: ${$bpWyP.multiple(18).px};
    width: ${$bpWyP.multiple(42).px};
`};`;
const $4604138a418a3600$export$8f314e512d92575f = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ics84-3"
})`${$iSWaE.flexCenter};height:${$bpWyP.multiple(5).px};width:${$bpWyP.multiple(5).px};flex-shrink:0;margin-right:${"var(--ds-space-200, 16px)"};${$2xGi5.fromXSmall.css`
        height: ${$bpWyP.multiple(6).px};
        width: ${$bpWyP.multiple(6).px};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4604138a418a3600$var$largePadding = /*#__PURE__*/ (0, $el3DQ.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"};${$2xGi5.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-400, 32px)"};
    `};`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4604138a418a3600$var$smallPadding = /*#__PURE__*/ (0, $el3DQ.css)`padding:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"};${$2xGi5.fromXSmall.css`
        padding: ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-300, 24px)"};
    `};`;
const $4604138a418a3600$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-3ics84-4"
})`display:flex;width:100%;height:100%;box-sizing:border-box;align-items:center;justify-content:flex-start;${(props)=>props.hasIcon ? $4604138a418a3600$var$smallPadding : $4604138a418a3600$var$largePadding};`;

});



parcelRegister("8nMQt", function(module, exports) {
$parcel$export(module.exports, "ProjectCard", () => (parcelRequire("gAmPH")).default);
$parcel$export(module.exports, "Overlay", () => (parcelRequire("2MKHy")).Overlay);
$parcel$export(module.exports, "DragHandlerWrapper", () => (parcelRequire("2MKHy")).DragHandlerWrapper);
$parcel$export(module.exports, "cardGutterStyle", () => (parcelRequire("2MKHy")).cardGutterStyle);
$parcel$export(module.exports, "Root", () => (parcelRequire("2MKHy")).Root);
$parcel$export(module.exports, "Wrapper", () => (parcelRequire("2MKHy")).Wrapper);

var $gAmPH = parcelRequire("gAmPH");

var $2MKHy = parcelRequire("2MKHy");

});
parcelRegister("gAmPH", function(module, exports) {
$parcel$export(module.exports, "default", () => $86aa4641eb3754d5$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");
parcelRequire("9MU8X");
var $2wESx = parcelRequire("2wESx");

var $2MKHy = parcelRequire("2MKHy");
const $86aa4641eb3754d5$var$mapStateToProps = (state)=>{
    return {
        isPortalHidingEnabled: (0, $2wESx.getIsPortalHidingEnabled)(state)
    };
};
var $86aa4641eb3754d5$export$2e2bcd8739ae039 = (0, $bmgw6.default)($86aa4641eb3754d5$var$mapStateToProps)((0, $2MKHy.default));

});
parcelRegister("2MKHy", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $08283d289599aeab$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "Root", () => $08283d289599aeab$export$be92b6f5f03c0fe9);
$parcel$export(module.exports, "DragHandlerWrapper", () => $08283d289599aeab$export$5761cab24db81fb9);
$parcel$export(module.exports, "ScreenReaderInstruction", () => $08283d289599aeab$export$a5ddd0c37fc6764f);
$parcel$export(module.exports, "default", () => $08283d289599aeab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "cardGutterStyle", () => $08283d289599aeab$export$c83f43d52281dc9d);
$parcel$export(module.exports, "Overlay", () => $08283d289599aeab$export$c6fdb837b070b4ff);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $a3bgj = parcelRequire("a3bgj");

var $2xGi5 = parcelRequire("2xGi5");

var $7L1Sn = parcelRequire("7L1Sn");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");

var $dXHSc = parcelRequire("dXHSc");

var $efDRU = parcelRequire("efDRU");
parcelRequire("bvitG");
var $1G6Fq = parcelRequire("1G6Fq");

var $hyXmz = parcelRequire("hyXmz");

var $dO3eH = parcelRequire("dO3eH");

var $jBqdP = parcelRequire("jBqdP");

var $gUZCV = parcelRequire("gUZCV");

var $eVQfr = parcelRequire("eVQfr");
parcelRequire("cpp0j");
var $cVlRK = parcelRequire("cVlRK");

var $cVlRK = parcelRequire("cVlRK");

var $gzUXg = parcelRequire("gzUXg");
const $08283d289599aeab$export$bacf8f04493bf68c = ({ id: id, name: name, description: description, iconUrl: iconUrl, isFeatured: isFeatured, isDropped: isDropped, className: className, intl: intl, hiddenFromHomeScreen: hiddenFromHomeScreen, hideActionButtons: hideActionButtons, isPortalHidingEnabled: isPortalHidingEnabled, onToggleFeatured: onToggleFeatured, onToggleVisibility: onToggleVisibility })=>{
    const hasIcon = !!iconUrl;
    const hasOnlyPortalName = !description && !iconUrl;
    const onFeaturedStarClick = $4fqPo.useCallback(()=>{
        onToggleFeatured && onToggleFeatured(id, !isFeatured);
    }, [
        id,
        isFeatured,
        onToggleFeatured
    ]);
    const onVisibilityIconClick = $4fqPo.useCallback(()=>{
        onToggleVisibility && onToggleVisibility(id, !hiddenFromHomeScreen);
    }, [
        id,
        hiddenFromHomeScreen,
        onToggleVisibility
    ]);
    const rootProps = isFeatured ? {
        isDropped: isDropped,
        isFeatured: true
    } : {
        isFeatured: false
    };
    const featuredProjectToolTip = intl.formatMessage((0, $gzUXg.default).featuredProjectTooltip);
    const unFeaturedProjectToolTip = intl.formatMessage((0, $gzUXg.default).unFeaturedProjectTooltip);
    const visibleProjectTooltip = intl.formatMessage((0, $gzUXg.default).visibleProjectTooltip);
    const hiddenProjectTooltip = intl.formatMessage((0, $gzUXg.default).hiddenProjectTooltip);
    const featureToolTip = {
        highlightedMessage: featuredProjectToolTip,
        unHighlightedMessage: unFeaturedProjectToolTip
    };
    const featureAriaLabel = {
        highlightedLabel: featuredProjectToolTip,
        unHighlightedLabel: unFeaturedProjectToolTip
    };
    const visibilityToolTip = {
        highlightedMessage: visibleProjectTooltip,
        unHighlightedMessage: hiddenProjectTooltip
    };
    const visibilityAriaLabel = {
        highlightedLabel: visibleProjectTooltip,
        unHighlightedLabel: hiddenProjectTooltip
    };
    const ariaAttributes = isFeatured ? {
        tabIndex: 0,
        role: 'button',
        'aria-labelledby': `project-card-content-${id}`,
        'aria-roledescription': 'Draggable item',
        'aria-describedby': 'featured-portals-screen-reader-description'
    } : {};
    return /*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$export$e6dfd72ab29f8598, {
        "data-test-id": isFeatured ? `featured-card-${id}` : null,
        "data-testid": isFeatured ? `featured-card-${id}` : 'unfeatured-card',
        ...className ? {
            className: className
        } : {},
        ...ariaAttributes
    }, /*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$export$be92b6f5f03c0fe9, rootProps, /*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$var$Container, {
        hasIcon: hasIcon,
        isDraggable: isFeatured
    }, isFeatured && /*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$export$5761cab24db81fb9, null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyXmz))), {
        label: "drag-handler",
        size: "medium",
        spacing: "spacious"
    })), hasIcon && /*#__PURE__*/ $4fqPo.createElement((0, $cVlRK.IconContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $a3bgj.default), {
        src: iconUrl,
        alt: "icon"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $cVlRK.Content), {
        id: `project-card-content-${id}`
    }, /*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$var$ProjectName, {
        hasOnlyPortalName: hasOnlyPortalName,
        title: name
    }, name), !!description && /*#__PURE__*/ $4fqPo.createElement((0, $cVlRK.Description), {
        title: description,
        dangerouslySetInnerHTML: {
            __html: description
        }
    })), !hideActionButtons && /*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$var$Actions, null, isPortalHidingEnabled && (!isFeatured || hiddenFromHomeScreen) && /*#__PURE__*/ $4fqPo.createElement((0, $1G6Fq.default), {
        isHighlighted: !hiddenFromHomeScreen,
        highlightHandler: onVisibilityIconClick,
        toolTip: visibilityToolTip,
        ariaLabel: visibilityAriaLabel,
        actionSubjectId: hiddenFromHomeScreen ? 'hiddenCard' : 'visibleCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jBqdP))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dO3eH)))
        }
    }), (!isPortalHidingEnabled || !hiddenFromHomeScreen) && /*#__PURE__*/ $4fqPo.createElement((0, $1G6Fq.default), {
        isHighlighted: isFeatured,
        highlightHandler: onFeaturedStarClick,
        toolTip: featureToolTip,
        ariaLabel: featureAriaLabel,
        actionSubjectId: isFeatured ? 'featuredCard' : 'unFeaturedCard',
        icon: {
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            HighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gUZCV))),
            // @ts-ignore TS(2322) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Type 'NamedExoticComponent<IconProps>' is not assi... Remove this comment to see the full error message
            UnHighlightedIcon: (0, (/*@__PURE__*/$parcel$interopDefault($eVQfr)))
        },
        color: {
            highlightedColor: "var(--ds-background-accent-yellow-subtler, #FFC400)"
        }
    })))));
};
const $08283d289599aeab$export$a5ddd0c37fc6764f = ({ intl: intl })=>/*#__PURE__*/ $4fqPo.createElement($08283d289599aeab$var$SortableCardDescription, {
        id: "featured-portals-screen-reader-description"
    }, intl.formatMessage((0, $gzUXg.default).screenReaderInstructionsForReordering));
var $08283d289599aeab$export$2e2bcd8739ae039 = /*#__PURE__*/ $4fqPo.memo((0, $efDRU.default)($08283d289599aeab$export$bacf8f04493bf68c));
const $08283d289599aeab$export$c83f43d52281dc9d = /*#__PURE__*/ (0, $el3DQ.css)`margin:${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"};${$2xGi5.fromLarge.css`
margin: ${"var(--ds-space-200, 16px)"} ${$bpWyP.multiple(4.75).px};
`}`;
const $08283d289599aeab$var$rootBackgroundColor = (props)=>props.isDropped ? "var(--ds-surface-raised-pressed, #DEEBFF)" : "var(--ds-surface-raised, #FFFFFF)";
const $08283d289599aeab$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1tkctfp-0"
})`${(0, $cVlRK.cardStyle)} ${(props)=>props.isFeatured ? $iSWaE.raiseUpOnHoverOrFocus((0, $7L1Sn.newElevationsFromDesignSystems).e100, (0, $7L1Sn.newElevationsFromDesignSystems).e200) : (0, $7L1Sn.newElevationsFromDesignSystems).e100};${(props)=>$iSWaE.applyIf(!Boolean(props.isFeatured), 'z-index: 0;')} background-color:${$08283d289599aeab$var$rootBackgroundColor};user-select:none;${(props)=>props.isFeatured && !props.isDropped && (0, $el3DQ.css)({
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #F4F5F7)"
        }
    })};&:hover,&:focus{z-index:${$dXHSc.portalCardLayout};text-decoration:none;}&::after{cursor:${(props)=>{
    return props.isFeatured ? 'grab' : 'auto';
}};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08283d289599aeab$var$Actions = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1tkctfp-1"
})`display:flex;flex-direction:row;align-items:center;position:absolute;top:${"var(--ds-space-100, 8px)"};right:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08283d289599aeab$var$Container = /*#__PURE__*/ (0, $el3DQ.default)((0, $cVlRK.Container)).withConfig({
    componentId: "sc-1tkctfp-2"
})`padding-right:${$bpWyP.multiple(5.5).px};${({ isDraggable: isDraggable })=>isDraggable ? `padding-left: ${"var(--ds-space-500, 40px)"}` : ''};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08283d289599aeab$var$ProjectName = /*#__PURE__*/ (0, $el3DQ.default)((0, $cVlRK.PortalName)).withConfig({
    componentId: "sc-1tkctfp-3"
})`color:${"var(--ds-text, #172B4D)"};`;
const $08283d289599aeab$var$boxShadow = `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} rgba(0, 0, 0, 0.15)`;
const $08283d289599aeab$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $el3DQ.default).li.withConfig({
    componentId: "sc-1tkctfp-4"
})`${$08283d289599aeab$export$c83f43d52281dc9d} touch-action:none;list-style:none;&:focus{${$iSWaE.focusRing.default};& ${$08283d289599aeab$export$be92b6f5f03c0fe9}{&:hover{transform:translate3d(0,0,0);}}}&.sortable-helper{cursor:grabbing !important;pointer-events:auto !important;list-style:none;${$08283d289599aeab$export$be92b6f5f03c0fe9}{background-color:${$08283d289599aeab$var$rootBackgroundColor};&::after{cursor:grabbing;}&:hover{cursor:grabbing;background-color:${"var(--ds-surface-raised, #FFFFFF)"};}box-shadow:${`var(--ds-shadow-overlay, ${$08283d289599aeab$var$boxShadow})`};}}`;
const $08283d289599aeab$export$5761cab24db81fb9 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1tkctfp-5"
})`left:${"var(--ds-space-050, 4px)"};position:absolute;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08283d289599aeab$var$SortableCardDescription = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1tkctfp-6"
})`display:none;`;
const $08283d289599aeab$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1tkctfp-7"
})`${(0, $cVlRK.cardStyle)} ${$08283d289599aeab$export$c83f43d52281dc9d} background-color:${(props)=>props.show ? "var(--ds-background-selected-hovered, #B3D4FF)" : "var(--ds-surface-raised, transparent)"};opacity:0.3;transition:all 0.2s;`;

});
parcelRegister("bvitG", function(module, exports) {
$parcel$export(module.exports, "Highlighter", () => (parcelRequire("1G6Fq")).default);

var $1G6Fq = parcelRequire("1G6Fq");

});
parcelRegister("1G6Fq", function(module, exports) {
$parcel$export(module.exports, "default", () => $b650e9bafe3ae1dc$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $1HSOM = parcelRequire("1HSOM");

var $dXHSc = parcelRequire("dXHSc");

var $8Mj6h = parcelRequire("8Mj6h");
const $b650e9bafe3ae1dc$export$7cc17c9bd3240823 = ({ isHighlighted: isHighlighted, highlightHandler: highlightHandler, toolTip: toolTip, ariaLabel: ariaLabel, actionSubjectId: actionSubjectId, icon: icon, color: color })=>{
    const toolTipMessage = isHighlighted ? toolTip.highlightedMessage : toolTip.unHighlightedMessage;
    const ariaLabelContent = isHighlighted ? ariaLabel.highlightedLabel : ariaLabel.unHighlightedLabel;
    const { HighlightedIcon: HighlightedIcon, UnHighlightedIcon: UnHighlightedIcon } = icon;
    return /*#__PURE__*/ $4fqPo.createElement($b650e9bafe3ae1dc$var$HighlighterButtonContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $8Mj6h.default), {
        content: toolTipMessage,
        position: "top",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.Button), {
        type: "button",
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "project-card-action-button",
        onClick: highlightHandler,
        actionSubjectId: actionSubjectId,
        iconBefore: isHighlighted ? /*#__PURE__*/ $4fqPo.createElement(HighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.highlightedColor,
            size: "medium"
        }) : /*#__PURE__*/ $4fqPo.createElement(UnHighlightedIcon, {
            label: ariaLabelContent,
            color: color === null || color === void 0 ? void 0 : color.unHighlightedColor,
            size: "medium"
        })
    })));
};
var $b650e9bafe3ae1dc$export$2e2bcd8739ae039 = /*#__PURE__*/ $4fqPo.memo($b650e9bafe3ae1dc$export$7cc17c9bd3240823);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b650e9bafe3ae1dc$var$HighlighterButtonContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1h5r30-0"
})`background:transparent;border:0;cursor:pointer;z-index:${(0, $dXHSc.layer)};`;

});


parcelRegister("jBqdP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5543a1bcdfd8c47fe735784b0d385448>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e455d02676862d0b$var$_react = $e455d02676862d0b$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $e455d02676862d0b$var$_baseNew = $e455d02676862d0b$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $e455d02676862d0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e455d02676862d0b$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $e455d02676862d0b$var$_react.default.createElement($e455d02676862d0b$var$_baseNew.default, Object.assign({
        name: "EyeOpenFilledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$e455d02676862d0b$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $e455d02676862d0b$var$_default = module.exports.default = $e455d02676862d0b$var$EyeOpenFilledIcon;

});

parcelRegister("gzUXg", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed97cacc45b1121d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $ed97cacc45b1121d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    featuredProjectTooltip: {
        defaultMessage: 'Remove from featured section',
        description: 'Tootip message when hovered on remove from featured button',
        id: 'cv.portal.reordering.experience.featured.card.tooltip'
    },
    unFeaturedProjectTooltip: {
        defaultMessage: 'Feature this portal',
        description: 'Tootip message when hovered on feature portal button',
        id: 'cv.portal.reordering.experience.unfeatured.card.tooltip'
    },
    visibleProjectTooltip: {
        defaultMessage: 'Hide from home page',
        description: 'Tootip message when hovered on hide button',
        id: 'cv.portal.reordering.experience.shown.card.tooltip.non-final'
    },
    hiddenProjectTooltip: {
        defaultMessage: 'Show on home page',
        description: 'Tootip message when hovered on show project button',
        id: 'cv.portal.reordering.experience.hidden.card.tooltip.non-final'
    },
    screenReaderInstructionsForReordering: {
        defaultMessage: 'Press space to pick up a portal. Use the up and down arrow keys to move it to a new position. Press space or enter to drop it in a new position, or press escape to cancel',
        description: 'message to be readout by screen reader when a project card is focused',
        id: 'cv.portal.reordering.experience.screen.reader.instruction'
    }
});

});




parcelRegister("1OWhn", function(module, exports) {
$parcel$export(module.exports, "titleSkeletonHeight", () => $acde72bca7077e92$export$627219b6093d39c1);
$parcel$export(module.exports, "IconContainer", () => (parcelRequire("cVlRK")).IconContainer);
$parcel$export(module.exports, "Content", () => (parcelRequire("cVlRK")).Content);
$parcel$export(module.exports, "Container", () => (parcelRequire("cVlRK")).Container);

var $cVlRK = parcelRequire("cVlRK");
const $acde72bca7077e92$export$627219b6093d39c1 = '21px';

});



parcelRegister("3Bugx", function(module, exports) {
$parcel$export(module.exports, "ActionBarWithButtonsStateless", () => (parcelRequire("dKoXn")).default);

var $dKoXn = parcelRequire("dKoXn");

});
parcelRegister("dKoXn", function(module, exports) {
$parcel$export(module.exports, "default", () => $1eff6c3105da3eb7$export$2e2bcd8739ae039);
/* action-bar-with-buttons-stateless.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $1HSOM = parcelRequire("1HSOM");

var $bpWyP = parcelRequire("bpWyP");

var $efDRU = parcelRequire("efDRU");

var $h7u63 = parcelRequire("h7u63");

var $2eKV2 = parcelRequire("2eKV2");

var $33cQv = parcelRequire("33cQv");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $bofsM = parcelRequire("bofsM");
const $1eff6c3105da3eb7$export$f749d3fa2628ac53 = ({ intl: intl, isDirty: isDirty, openCancelPrompt: openCancelPrompt, openPublishPrompt: openPublishPrompt })=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $33cQv.default), {
        name: "portal-reordering-action-buttons"
    }, /*#__PURE__*/ $4fqPo.createElement($1eff6c3105da3eb7$var$ButtonContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $h7u63.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.Button), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: "portal-reordering-cancel-button",
        onClick: openCancelPrompt,
        actionSubjectId: "cancelPortalsReorder",
        "data-test-id": "cancel-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $bofsM.default).cancelButtonLabel)), /*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.Button), {
        appearance: "primary",
        isDisabled: !isDirty,
        onClick: openPublishPrompt,
        actionSubjectId: "publishPortalsReorder",
        "data-test-id": "publish-portal-reorder-experience-action-bar"
    }, intl.formatMessage((0, $bofsM.default).publishButtonLabel)))));
};
class $1eff6c3105da3eb7$export$ec006b65f267cb6c extends $4fqPo.Component {
    renderHeading() {
        const { intl: intl } = this.props;
        if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) return intl.formatMessage((0, $bofsM.default).actionBarTitleCSM);
        return intl.formatMessage((0, $bofsM.default).actionBarTitleNew);
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement($1eff6c3105da3eb7$var$Wrapper, null, /*#__PURE__*/ $4fqPo.createElement($1eff6c3105da3eb7$var$PageHeaderWrapper, null, /*#__PURE__*/ $4fqPo.createElement($1eff6c3105da3eb7$var$PageHeader, null, /*#__PURE__*/ $4fqPo.createElement($1eff6c3105da3eb7$var$Title, null, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
            size: "medium",
            as: "div"
        }, this.renderHeading())), /*#__PURE__*/ $4fqPo.createElement($1eff6c3105da3eb7$export$f749d3fa2628ac53, this.props)), children));
    }
}
var $1eff6c3105da3eb7$export$2e2bcd8739ae039 = (0, $efDRU.default)($1eff6c3105da3eb7$export$ec006b65f267cb6c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1eff6c3105da3eb7$var$Wrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "header", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_16qs1viy _1pby16oo _154iidpf _1ltvidpf _1bsb1osq _kqsw1n9t _bfhk1bhr _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $1eff6c3105da3eb7$var$PageHeaderWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1jphezo": (0, $3f61e.default)($bpWyP.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt4zdiv _1bsb1osq _1bah1h6o _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $1eff6c3105da3eb7$var$ButtonContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_b2vlsk": (0, $3f61e.default)($bpWyP.multiple(96).px)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt41b66 _p12feuys",
            __cmplp.className
        ])
    });
});
const $1eff6c3105da3eb7$var$Title = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19pkidpf _otyrpxbi _19zoidpf",
            __cmplp.className
        ])
    });
});
const $1eff6c3105da3eb7$var$PageHeader = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_18s8r2fv _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1yb4 _tyxhvrvc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h7u63", function(module, exports) {
$parcel$export(module.exports, "default", () => $798d31472fa3b014$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");
function $798d31472fa3b014$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $798d31472fa3b014$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $798d31472fa3b014$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $798d31472fa3b014$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("bofsM", function(module, exports) {
$parcel$export(module.exports, "default", () => $733b5b5ef45754ab$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $733b5b5ef45754ab$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    actionBarTitle: {
        defaultMessage: 'Edit home page layout',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title'
    },
    actionBarTitleNew: {
        defaultMessage: 'Manage topics and portals',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title.topics.portals'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    actionBarTitleCSM: {
        defaultMessage: 'Manage topics',
        description: 'Title for portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.title-csm.topics.portals'
    },
    cancelButtonLabel: {
        defaultMessage: 'Cancel',
        description: 'Label of cancel button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.cancel'
    },
    publishButtonLabel: {
        defaultMessage: 'Publish layout',
        description: 'Label of publish button of portal reorder experience action bar',
        id: 'sd.portal.reorder.experience.action.bar.with.buttons.button.publish'
    }
});

});



parcelRegister("hDsaL", function(module, exports) {
$parcel$export(module.exports, "SortByFilter", () => (parcelRequire("7Oj2h")).default);

var $7Oj2h = parcelRequire("7Oj2h");

});
parcelRegister("7Oj2h", function(module, exports) {
$parcel$export(module.exports, "default", () => $8279f52d911411e8$export$2e2bcd8739ae039);
/* sort-by-filter.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $2QDnI = parcelRequire("2QDnI");

var $bpWyP = parcelRequire("bpWyP");

var $efDRU = parcelRequire("efDRU");

var $2eKV2 = parcelRequire("2eKV2");

var $33cQv = parcelRequire("33cQv");

var $bevln = parcelRequire("bevln");
const $8279f52d911411e8$var$selectCustomStyle = {
    container: (provided)=>({
            ...provided,
            marginLeft: "var(--ds-space-200, 16px)",
            width: $bpWyP.multiple(18).px
        })
};
const $8279f52d911411e8$export$38d77f5667d0a049 = ({ intl: intl, isDisabled: isDisabled, value: value, shouldHideLabel: shouldHideLabel, onChange: onChange })=>{
    const sortBySelectOptions = {
        ALPHABETICALLY: intl.formatMessage((0, $bevln.default).alphabeticOption),
        POPULARITY: intl.formatMessage((0, $bevln.default).popularityOption)
    };
    const options = Object.entries(sortBySelectOptions).map(([key, label])=>({
            label: label,
            value: key
        }));
    const sortByChange = $4fqPo.useCallback((option)=>{
        if (option && option.value !== value) onChange(option.value);
    }, [
        onChange,
        value
    ]);
    return /*#__PURE__*/ $4fqPo.createElement((0, $33cQv.default), {
        name: "sort-by-filter"
    }, /*#__PURE__*/ $4fqPo.createElement($8279f52d911411e8$var$FilterWrapper, null, /*#__PURE__*/ $4fqPo.createElement($8279f52d911411e8$var$FilterContent, null, !shouldHideLabel && /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ $4fqPo.createElement("label", {
        htmlFor: "sort-by-filter"
    }, intl.formatMessage((0, $bevln.default).sortByFilterLabel))), /*#__PURE__*/ $4fqPo.createElement((0, $2QDnI.Select), {
        classNamePrefix: "portal-reorder-experience-sort-by-filter",
        actionSubjectId: "sortByFilter",
        value: {
            value: value,
            label: sortBySelectOptions[value]
        },
        options: options,
        styles: $8279f52d911411e8$var$selectCustomStyle,
        isSearchable: false,
        isDisabled: isDisabled,
        onChange: sortByChange,
        inputId: "sort-by-filter",
        instanceId: "sort-by-filter"
    }))));
};
var $8279f52d911411e8$export$2e2bcd8739ae039 = /*#__PURE__*/ $4fqPo.memo((0, $efDRU.default)($8279f52d911411e8$export$38d77f5667d0a049));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8279f52d911411e8$var$FilterWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8vhf38": (0, $3f61e.default)($bpWyP.multiple(28).px)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1bsb1sn1 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _18u0mgjw",
            __cmplp.className
        ])
    });
});
const $8279f52d911411e8$var$FilterContent = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _4cvr1h6o _18u01jfw _89vyidpf _5rvhidpf _32nkidpf _wws0idpf _nw4oangw _1t2qnoz8 _r5bjidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2QDnI", function(module, exports) {
$parcel$export(module.exports, "Select", () => $6afe4dc912699ac9$export$ef9b1a59e592288f);

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");

var $lv3so = parcelRequire("lv3so");
class $6afe4dc912699ac9$export$ef9b1a59e592288f extends $4fqPo.PureComponent {
    render() {
        const { actionSubjectId: actionSubjectId, ...selectProps } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: actionSubjectId
            }
        }, /*#__PURE__*/ $4fqPo.createElement((0, $lv3so.default), selectProps));
    }
}

});

parcelRegister("bevln", function(module, exports) {
$parcel$export(module.exports, "default", () => $0203cf7422321a3a$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $0203cf7422321a3a$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    sortByFilterLabel: {
        defaultMessage: 'Sort by',
        description: 'Label for the sort by filter',
        id: 'cv.portal.reordering.experience.sortBy.filter.label'
    },
    popularityOption: {
        defaultMessage: 'Popularity',
        description: 'Label for the sort by popularity option',
        id: 'cv.portal.reordering.experience.sortBy.filter.popularity.label'
    },
    alphabeticOption: {
        defaultMessage: 'Name: A to Z',
        description: 'Label for the sort by alphabetical option',
        id: 'cv.portal.reordering.experience.sortBy.filter.alphabetical.label'
    }
});

});



parcelRegister("93Vf4", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $d06421fde2b3ee0e$export$e6dfd72ab29f8598);
$parcel$export(module.exports, "ExperienceContainer", () => $d06421fde2b3ee0e$export$4d17725865d2ba3c);
$parcel$export(module.exports, "CardsContainer", () => $d06421fde2b3ee0e$export$8e547173d545e862);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $bpWyP = parcelRequire("bpWyP");

var $hTMzE = parcelRequire("hTMzE");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d06421fde2b3ee0e$var$HEADER_HEIGHT = `${$bpWyP.multiple(10).px}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d06421fde2b3ee0e$var$WRAPPER_MIN_HEIGHT = `calc(100vh - ${(0, $hTMzE.FOOTER_HEIGHT)}px - ${$d06421fde2b3ee0e$var$HEADER_HEIGHT})`;
const $d06421fde2b3ee0e$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ans5n9": (0, $3f61e.default)($d06421fde2b3ee0e$var$WRAPPER_MIN_HEIGHT)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1yt41r39 _1tke1j5i _138y1jfw",
            __cmplp.className
        ])
    });
});
const $d06421fde2b3ee0e$export$4d17725865d2ba3c = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1ebxqrc": (0, $3f61e.default)($bpWyP.multiple(42).px),
            "--_1l8apj8": (0, $3f61e.default)($bpWyP.multiple(90).px),
            "--_1jphezo": (0, $3f61e.default)($bpWyP.multiple(145).px)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq _kqswh2mm _19pk1ejb _p12ffptw _hclcjj99 _1gvm1xkz",
            __cmplp.className
        ])
    });
});
const $d06421fde2b3ee0e$export$8e547173d545e862 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1aqg72h": (0, $3f61e.default)($bpWyP.multiple(-5).px)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_18s81u5k _19itg9nf _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _1n261g80 _kqswh2mm _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7K78T", function(module, exports) {
$parcel$export(module.exports, "default", () => $c73afe78dd2100ad$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $c73afe78dd2100ad$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    featuredPortalsTitle: {
        defaultMessage: 'Featured',
        description: 'Title for featured portals loader section',
        id: 'cv.portal.reordering.experience.loader.featured.portals.title'
    }
});

});



parcelRegister("cfihf", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("fC1qB"),
    $e46AW("eUxjk"),
    $e46AW("lgGph"),
    $e46AW("e5MH2"),
    $e46AW("gxk6F"),
    $e46AW("kACqZ"),
    $e46AW("ejayw"),
    $e46AW("5YgJY"),
    $e46AW("8t8wM"),
    $e46AW("g07kR"),
    $e46AW("3vdHc"),
    $e46AW("bZLDd"),
    $e46AW("3elKB"),
    $e46AW("h8xPI"),
    $e46AW("gyBk8"),
    $e46AW("91QvV"),
    $e46AW("j8KVB"),
    $e46AW("6BKvM"),
    $e46AW("9d6FU"),
    $e46AW("hqv7X"),
    $e46AW("mZL55"),
    $e46AW("eahZ0"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("5gfrx")
]).then(()=>parcelRequire('6B2nz'));

});


parcelRegister("3YInn", function(module, exports) {
$parcel$export(module.exports, "helpEditTopicsResource", () => $30d13bff6dd6234f$export$8b5129935a2eae3c);
$parcel$export(module.exports, "hiddenSectionWarningResource", () => $30d13bff6dd6234f$export$79066689501876c);

var $aIDHt = parcelRequire("aIDHt");

var $iakYM = parcelRequire("iakYM");

var $fZppw = parcelRequire("fZppw");
const $30d13bff6dd6234f$export$8b5129935a2eae3c = (0, $fZppw.createRelayResource)({
    type: 'EDIT_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $aIDHt.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});
const $30d13bff6dd6234f$export$79066689501876c = (0, $fZppw.createRelayResource)({
    type: 'HIDDEN_LAYOUT_SECTION_WARNING',
    getQuery: (_, { cloudId: cloudId, layoutAri: layoutAri })=>({
            parameters: (0, $iakYM.default),
            variables: {
                cloudId: cloudId,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("aIDHt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f16dfdacd9a581b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<79f064f566608c64fe4afe3c780b232c>>
 * @relayHash 2b93fcbc8c19a342658c7aff002a8cd2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1
const $0f16dfdacd9a581b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "sortableTopicsContainerFragment"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "hiddenTopicsExpandedFragment"
                                        },
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "editableTopicFragment"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsEditQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 3
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "totalCount"
                                                        }
                                                    ],
                                                    "storageKey": "items(first:3)"
                                                },
                                                {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__id"
                                                        },
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "order"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "14bdc72513794c74130122dbd5c9ab89491bd3dc5b3c409327e6af76a3e179e1",
            "metadata": {},
            "name": "topicsEditQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0f16dfdacd9a581b$var$node.hash = "ccda9262ffa2b20f017478c5ac8b7353";
var $0f16dfdacd9a581b$export$2e2bcd8739ae039 = $0f16dfdacd9a581b$var$node;

});

parcelRegister("iakYM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c69664d921a9d7ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1517e57be5d4aea1e7182378d54efdc1>>
 * @relayHash 186c8bbb9834e8623ccdc1e2f59099c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78
const $c69664d921a9d7ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "layoutAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v3 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hidden"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v2 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "HelpLayoutSectionConnection",
                                                "kind": "LinkedField",
                                                "name": "sections",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "HelpLayoutSectionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSection",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v3 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "HelpLayoutSubsection",
                                                                        "kind": "LinkedField",
                                                                        "name": "subsections",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "elements",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v4 /*: any*/ 
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hiddenLayoutSectionWarningQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayout"
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2142ab880cb9a1bcdef32af52fc36c4d15d5daa1abf06762a41cb0d1779b9a78",
            "metadata": {},
            "name": "hiddenLayoutSectionWarningQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c69664d921a9d7ab$var$node.hash = "f2fd5d711a9bee2d942b12cdd41c9d79";
var $c69664d921a9d7ab$export$2e2bcd8739ae039 = $c69664d921a9d7ab$var$node;

});





parcelRegister("l1IDP", function(module, exports) {
$parcel$export(module.exports, "EditHomepageResource", () => $2e9cea5fe463aa16$export$d2163513c58dfe58);

var $kcKhl = parcelRequire("kcKhl");

var $fZppw = parcelRequire("fZppw");
const $2e9cea5fe463aa16$export$d2163513c58dfe58 = (0, $fZppw.createRelayResource)({
    type: 'EDIT_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $kcKhl.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("kcKhl", function(module, exports) {
$parcel$export(module.exports, "default", () => $44739e73e140be13$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc193c28620f19e9e2a3bf0ccfdbe58c>>
 * @relayHash ad74923ce0dec1a5cb4cfa4f5f744883
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d91929959ff50eafacd64f6d6506eb821d89cb761e10f280645b0283e2665051
const $44739e73e140be13$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v7 = {
        "alias": "layoutId",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpLayoutSubsectionConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "span"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "adf"
    }, v10 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v11 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v12 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v20 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "useLayoutServiceVisualConfigData",
                "selections": v21 /*: any*/ ,
                "argumentDefinitions": []
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "useGlobalSettings"
    }, v24 = [
        v22 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "expandButtonTextColor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "forgeElementPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "forgeElementType"
    }, v28 = {
        "kind": "ScalarField",
        "name": "connectElementPage"
    }, v29 = {
        "kind": "ScalarField",
        "name": "connectElementType"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v34 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v35 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v36 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v37 = [
        v33 /*: any*/ ,
        v34 /*: any*/ ,
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "args": v32 /*: any*/ ,
        "concreteType": "HelpLayoutMediaConfig",
        "kind": "LinkedField",
        "name": "mediaConfig",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v39 = [
        v14 /*: any*/ ,
        v13 /*: any*/ 
    ], v40 = {
        "kind": "ScalarField",
        "name": "id"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            v40 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v42 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v43 = {
        "kind": "ScalarField",
        "name": "key"
    }, v44 = {
        "kind": "ScalarField",
        "name": "name"
    }, v45 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v46 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v47 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v48 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v43 /*: any*/ 
        ]
    }, v49 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v50 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v51 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v52 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHomepageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalBrandingSettingsPanelFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutBuilderFragment"
                                            },
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "useLayoutServiceFragment",
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpLayoutSectionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "HelpLayoutSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "HelpLayoutSubsection",
                                                                                "kind": "LinkedField",
                                                                                "name": "subsections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v8 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "elements",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceEditorElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v9 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutEditorElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceHeroElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v23 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutHeroElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceAnnouncementElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceTopicsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutTopicsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceListOfPortalsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v25 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceForgeElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v26 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutForgeElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceConnectElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            v29 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutConnectElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceBreadcrumbElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutBreadcrumbElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v22 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v22 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v31 /*: any*/ 
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        v38 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "elementsCatalogueFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHomepageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v41 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v37 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v40 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v35 /*: any*/ ,
                                                                                                        v34 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v36 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v42 /*: any*/ ,
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v40 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v45 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v40 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        },
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v45 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v49 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v50 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v40 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v44 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v48 /*: any*/ ,
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v48 /*: any*/ ,
                                                                                        v52 /*: any*/ ,
                                                                                        v51 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extensions",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCode"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v41 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v40 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v41 /*: any*/ 
                            ]
                        },
                        v38 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v42 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v36 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d91929959ff50eafacd64f6d6506eb821d89cb761e10f280645b0283e2665051",
            "metadata": {},
            "name": "editHomepageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$44739e73e140be13$var$node.hash = "76a98be18ada7d4f36ce6c2f7f9559d6";
var $44739e73e140be13$export$2e2bcd8739ae039 = $44739e73e140be13$var$node;

});


parcelRegister("6RZw4", function(module, exports) {
$parcel$export(module.exports, "EditHomepageV2Resource", () => $49a289e1f07b7702$export$3e8c7fe01574cb7a);

var $l95eV = parcelRequire("l95eV");

var $fZppw = parcelRequire("fZppw");
const $49a289e1f07b7702$export$3e8c7fe01574cb7a = (0, $fZppw.createRelayResource)({
    type: 'EDIT_HOMEPAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri, layoutAri: layoutAri })=>{
        return {
            parameters: (0, $l95eV.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                layoutAri: layoutAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("l95eV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d1c2f6b09486485e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bf616c28e62c7c65a524ac219b76e27>>
 * @relayHash 212a5d5e632802bde54e59d17573c070
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 79f56f1ec11b4cd0e0c952f194e9e5a31cfa81fc6ead00da309b64fc3ef6f1a6
const $d1c2f6b09486485e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "layoutAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "layoutAri"
        }
    ], v7 = {
        "alias": "layoutId",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "HelpLayoutSubsectionConfig",
        "kind": "LinkedField",
        "name": "config",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "span"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "adf"
    }, v10 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v11 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v12 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "url"
    }, v15 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v18 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v19 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v20 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "InlineDataFragmentSpread",
                "name": "useLayoutServiceVisualConfigData",
                "selections": v21 /*: any*/ ,
                "argumentDefinitions": []
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "useGlobalSettings"
    }, v24 = [
        v22 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "expandButtonTextColor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "forgeElementPage"
    }, v27 = {
        "kind": "ScalarField",
        "name": "forgeElementType"
    }, v28 = {
        "kind": "ScalarField",
        "name": "connectElementPage"
    }, v29 = {
        "kind": "ScalarField",
        "name": "connectElementType"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v31 = {
        "kind": "ClientExtension",
        "selections": [
            v30 /*: any*/ 
        ]
    }, v32 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v33 = [
        v14 /*: any*/ ,
        v13 /*: any*/ 
    ], v34 = {
        "kind": "ScalarField",
        "name": "id"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v36 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v37 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v38 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v39 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v40 = [
        v36 /*: any*/ ,
        v37 /*: any*/ ,
        v38 /*: any*/ ,
        v39 /*: any*/ 
    ], v41 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v42 = {
        "kind": "ScalarField",
        "name": "key"
    }, v43 = {
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v45 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v46 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v12 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v47 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v41 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v48 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v49 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": v33 /*: any*/ 
    }, v50 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": v21 /*: any*/ 
    }, v51 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "globalBrandingSettingsPanelFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v4 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v6 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layout",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "pageBuilderFragment"
                                            },
                                            {
                                                "kind": "InlineDataFragmentSpread",
                                                "name": "useLayoutServiceFragment",
                                                "selections": [
                                                    v7 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpLayoutSectionConnection",
                                                        "kind": "LinkedField",
                                                        "name": "sections",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "HelpLayoutSectionEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "HelpLayoutSection",
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "HelpLayoutSubsection",
                                                                                "kind": "LinkedField",
                                                                                "name": "subsections",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    v8 /*: any*/ ,
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "elements",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v5 /*: any*/ ,
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceEditorElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v9 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutEditorElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceHeroElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v23 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutHeroElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceAnnouncementElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceTopicsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutTopicsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceListOfPortalsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v25 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutPortalsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceSuggestedRequestFormsElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceForgeElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v26 /*: any*/ ,
                                                                                                            v27 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutForgeElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceConnectElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            v28 /*: any*/ ,
                                                                                                            v29 /*: any*/ ,
                                                                                                            v22 /*: any*/ 
                                                                                                        ],
                                                                                                        "type": "HelpLayoutConnectElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            },
                                                                                            {
                                                                                                "kind": "InlineDataFragmentSpread",
                                                                                                "name": "useLayoutServiceBreadcrumbElementData",
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": v24 /*: any*/ ,
                                                                                                        "type": "HelpLayoutBreadcrumbElement"
                                                                                                    }
                                                                                                ],
                                                                                                "argumentDefinitions": []
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    v22 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            v22 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v31 /*: any*/ 
                                                ],
                                                "argumentDefinitions": []
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "pageBuilderMediaConfigFragment"
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "elementsCatalogueFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHomepageV2Query",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layout",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v34 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v8 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v5 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v32 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        v37 /*: any*/ ,
                                                                                                        v36 /*: any*/ ,
                                                                                                        v39 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v41 /*: any*/ ,
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v15 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v18 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v31 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v44 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v25 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v34 /*: any*/ ,
                                                                                                v45 /*: any*/ ,
                                                                                                v43 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v5 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "message"
                                                                                        },
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v5 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v44 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v31 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v46 /*: any*/ ,
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v48 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v18 /*: any*/ ,
                                                                                                v17 /*: any*/ ,
                                                                                                v16 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                v20 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v34 /*: any*/ ,
                                                                                        v47 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v43 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v47 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v27 /*: any*/ ,
                                                                                        v26 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v28 /*: any*/ ,
                                                                                        v29 /*: any*/ ,
                                                                                        v47 /*: any*/ ,
                                                                                        v51 /*: any*/ ,
                                                                                        v50 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "extensions",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v5 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "statusCode"
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v31 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v42 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v34 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v31 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v31 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v30 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        v31 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v35 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v40 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v41 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v32 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v37 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v39 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "79f56f1ec11b4cd0e0c952f194e9e5a31cfa81fc6ead00da309b64fc3ef6f1a6",
            "metadata": {},
            "name": "editHomepageV2Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$d1c2f6b09486485e$var$node.hash = "a727ab2637500ee1215ac6f7895b25c2";
var $d1c2f6b09486485e$export$2e2bcd8739ae039 = $d1c2f6b09486485e$var$node;

});


parcelRegister("3NY3t", function(module, exports) {
$parcel$export(module.exports, "brandingResource", () => $1392689efc9ff7b5$export$407a6849bf62b25c);
/*
These resources are a temporary solution to help with the server side rendering of multi help center home page.
This module will not be needed, once we move to the Flexible home page built on top of the Layout system.
*/ 
var $5eCdR = parcelRequire("5eCdR");

var $1hcn6 = parcelRequire("1hcn6");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");

var $f2UoR = parcelRequire("f2UoR");
parcelRequire("7LVOt");
var $db9ld = parcelRequire("db9ld");

var $fMnJn = parcelRequire("fMnJn");

var $j4t7D = parcelRequire("j4t7D");

var $8t8PZ = parcelRequire("8t8PZ");

var $fZppw = parcelRequire("fZppw");
const $1392689efc9ff7b5$export$407a6849bf62b25c = (0, $f03OU.createResource)({
    type: 'RELAY_HELP_CENTER_BRANDING',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $f2UoR.getRequest)((0, $8t8PZ.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $1hcn6.store).dispatch((0, $5eCdR.fetchHelpCenterBrandingAction)());
        return Promise.resolve(null);
    }
});
const $1392689efc9ff7b5$export$19af4b0b8cda6b11 = (0, $f03OU.createResource)({
    type: 'RELAY_HELP_CENTER_PORTALS',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $f2UoR.getRequest)((0, $j4t7D.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $1hcn6.store).dispatch((0, $db9ld.fetchFeaturedAndSortedPortalsModel)({}, false));
        return Promise.resolve(null);
    }
});
const $1392689efc9ff7b5$export$b08096b7aea23d43 = (0, $fZppw.createRelayResource)({
    type: 'HELP_CENTER_TOPICS',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $fMnJn.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("fMnJn", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e2b892201115733$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d0932329082ebc356c0b0ebaf8fd46cc>>
 * @relayHash da0c9595f56db7cf97a352c0fe8277b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364
const $5e2b892201115733$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "topicId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "properties"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "message"
    }, v8 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v12 = [
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ 
    ], v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicFragment"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "topicsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterTopic",
                                            "kind": "LinkedField",
                                            "name": "topics",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "concreteType": "HelpCenterTopicItemConnection",
                                                    "kind": "LinkedField",
                                                    "name": "items",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItemEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterTopicItem",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "data",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v6 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpCenterHelpObject"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v9 /*: any*/ ,
                                                                                        v10 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpObjectStoreIcon",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "icon",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrlV2"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v11 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpObjectStoreRequestForm"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreArticle"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": v12 /*: any*/ ,
                                                                                    "type": "HelpObjectStoreChannel"
                                                                                },
                                                                                v13 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "ari"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b7883769238bba805019b6324fac9ba641e017f9e265528d401031a571fd364",
            "metadata": {},
            "name": "topicsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5e2b892201115733$var$node.hash = "6c3fee571c0b47bf0526627e402d85f8";
var $5e2b892201115733$export$2e2bcd8739ae039 = $5e2b892201115733$var$node;

});


parcelRegister("8tUJD", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("kgse0"),
    $e46AW("fC1qB"),
    $e46AW("e5MH2"),
    $e46AW("3vdHc"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("y3gER")
]).then(()=>parcelRequire('lyMoC'));

});

parcelRegister("4HBoM", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("kgse0"),
    $e46AW("fC1qB"),
    $e46AW("e5MH2"),
    $e46AW("3vdHc"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("9g6Ln")
]).then(()=>parcelRequire('uXEa5'));

});

parcelRegister("8aZES", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("fC1qB"),
    $e46AW("eUxjk"),
    $e46AW("lgGph"),
    $e46AW("e5MH2"),
    $e46AW("gxk6F"),
    $e46AW("ejayw"),
    $e46AW("5YgJY"),
    $e46AW("8t8wM"),
    $e46AW("g07kR"),
    $e46AW("3vdHc"),
    $e46AW("bZLDd"),
    $e46AW("3elKB"),
    $e46AW("h8xPI"),
    $e46AW("91QvV"),
    $e46AW("j8KVB"),
    $e46AW("958rd"),
    $e46AW("6BKvM"),
    $e46AW("9d6FU"),
    $e46AW("hqv7X"),
    $e46AW("mZL55"),
    $e46AW("eahZ0"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("aOjLG")
]).then(()=>parcelRequire('eLiWT'));

});

parcelRegister("gmLeS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("fC1qB"),
    $e46AW("eUxjk"),
    $e46AW("lgGph"),
    $e46AW("e5MH2"),
    $e46AW("gxk6F"),
    $e46AW("ejayw"),
    $e46AW("5YgJY"),
    $e46AW("8t8wM"),
    $e46AW("g07kR"),
    $e46AW("3vdHc"),
    $e46AW("bZLDd"),
    $e46AW("3elKB"),
    $e46AW("h8xPI"),
    $e46AW("91QvV"),
    $e46AW("j8KVB"),
    $e46AW("958rd"),
    $e46AW("6BKvM"),
    $e46AW("9d6FU"),
    $e46AW("hqv7X"),
    $e46AW("mZL55"),
    $e46AW("eahZ0"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("3gZFw")
]).then(()=>parcelRequire('14qie'));

});


parcelRegister("dfMEw", function(module, exports) {
$parcel$export(module.exports, "aiAnswerRoute", () => $6d2d44a75cb939f5$export$aa89d187b9409394);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $MM3bs = parcelRequire("MM3bs");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");

var $k7H93 = parcelRequire("k7H93");

var $lVKPZ = parcelRequire("lVKPZ");

var $eHkSG = parcelRequire("eHkSG");

var $3wR8f = parcelRequire("3wR8f");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");
const $6d2d44a75cb939f5$var$RenderAiAnswerRoute = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eHkSG.default), {
        screenName: (0, $748yq.ScreenName).AI_ANSWER,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60sOE.default), {
        screenName: (0, $748yq.ScreenName).AI_ANSWER,
        renderError: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $MM3bs.default), {
                error: {
                    status: 500,
                    message: formatMessage((0, $lVKPZ.default).genericErrorMessage),
                    callToActionUrl: '/servicedesk/customer/portals'.replace((0, $3wR8f.getBaseName)(), ''),
                    callToActionText: formatMessage((0, $lVKPZ.default).genericRedirectMessage)
                }
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $k7H93.AiAnswerFeedbackPage), null)));
};
const $6d2d44a75cb939f5$var$route = {
    name: (0, $748yq.ScreenName).AI_ANSWER,
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/:requestKey/aianswer`,
    exact: true,
    component: $6d2d44a75cb939f5$var$RenderAiAnswerRoute
};
const $6d2d44a75cb939f5$var$screenName = (0, $748yq.ScreenName).AI_ANSWER;
const $6d2d44a75cb939f5$export$aa89d187b9409394 = (0, $bp9tj.createRouteWithLayout)($6d2d44a75cb939f5$var$route, $6d2d44a75cb939f5$var$screenName, (0, $1XMNp.anonymousScreenLayout));

});
parcelRegister("k7H93", function(module, exports) {
$parcel$export(module.exports, "AiAnswerFeedbackPage", () => $361446028cc5246f$export$589a347fe318e529);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $361446028cc5246f$export$589a347fe318e529 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("ij2Oe")), {
        moduleId: "./packages/virtual-agent/ai-answer/src/ui/ai-answer-feedback-page/hocs.tsx"
    })
});

});
parcelRegister("ij2Oe", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("eNoIp"),
    $e46AW("krjdG")
]).then(()=>parcelRequire('3OYzD'));

});


parcelRegister("lVKPZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $14f3d7c835df0375$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $14f3d7c835df0375$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpfulPageHeading: {
        id: 'ai-answer.feedback-form.helpful-page-heading',
        defaultMessage: 'Awesome!',
        description: 'Heading for the feedback form helpful page'
    },
    helpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.helpful-page-sub-heading',
        defaultMessage: 'Glad we could help.',
        description: 'Subheading for the feedback form helpful page'
    },
    nonHelpfulPageHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-heading',
        defaultMessage: "Sorry, it wasn\u2019t helpful.",
        description: 'Heading for the feedback form non-helpful page'
    },
    nonHelpfulPageSubHeading: {
        id: 'ai-answer.feedback-form.non-helpful-page-sub-heading',
        defaultMessage: "We're working on your request.",
        description: 'Subheading for the feedback form non-helpful page'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    additionalFeedbackCTALabel: {
        id: 'ai-answer.feedback-form.additional-feedback-label',
        defaultMessage: 'Give additional feedback',
        description: 'Label for the additional feedback button'
    },
    feedbackTitle: {
        id: 'ai-answer.feedback-form.feedback-title',
        defaultMessage: 'Help us improve',
        description: 'The text is shown as the title heading of the feedback dialog that appears when a user wants to provide feedback on an AI-generated answer.'
    },
    sendFeedbackLabel: {
        defaultMessage: 'Send Feedback',
        description: 'Feedback dialog Submit button label',
        id: 'ai-answer.feedback-form.feedback-submit-button-label'
    },
    cancelLabel: {
        defaultMessage: 'Cancel',
        description: 'Feedback dialog cancel button label',
        id: 'ai-answer.feedback-form.feedback-cancel-button-label'
    },
    contactLabel: {
        defaultMessage: 'Contact me for more details about this feedback',
        description: 'Feedback dialog can contact label',
        id: 'ai-answer.feedback-form.feedback-can-contact-label'
    },
    summary: {
        defaultMessage: 'Summary',
        description: 'Feedback dialog summary label',
        id: 'ai-answer.feedback-form.feedback-summary'
    },
    subHeading: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Feedback dialog sub heading',
        id: 'ai-answer.feedback-form.feedback-sub-heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-heading'
    },
    genericRedirectMessage: {
        defaultMessage: 'Go to the portal.',
        description: 'Generic redirect link message when something could not be loaded',
        id: 'ai-answer.feedback-form.generic-redirect-message'
    },
    summaryPlaceholder: {
        defaultMessage: "Let us know what's on your mind",
        description: 'Message which will be shown inside the summary text field',
        id: 'ai-answer.feedback-form.feedback-summary-placeholder'
    },
    enrolInResearchLabel: {
        defaultMessage: "I'd like to participate in product research",
        description: 'Message which will be shown next to the enrol in research checkbox',
        id: 'ai-answer.feedback-form.feedback-enrol-in-research-label'
    }
});

});


parcelRegister("7XSXo", function(module, exports) {
$parcel$export(module.exports, "approvalsRoute", () => $90ed17d855fb6c84$export$ee55f71d9820cd66);

var $748yq = parcelRequire("748yq");

var $7fGQw = parcelRequire("7fGQw");

var $bp9tj = parcelRequire("bp9tj");
const $90ed17d855fb6c84$var$route = {
    name: 'user-approvals',
    path: `/user/approvals`,
    exact: true,
    component: (0, $7fGQw.ApprovalList)
};
const $90ed17d855fb6c84$var$screenName = (0, $748yq.ScreenName).APPROVAL_LIST;
const $90ed17d855fb6c84$var$paperAppearance = 'wide';
const $90ed17d855fb6c84$var$layoutProps = {
    paperAppearance: $90ed17d855fb6c84$var$paperAppearance,
    fadeInSearchModal: true
};
const $90ed17d855fb6c84$export$ee55f71d9820cd66 = (0, $bp9tj.createRouteWithLayout)($90ed17d855fb6c84$var$route, $90ed17d855fb6c84$var$screenName, $90ed17d855fb6c84$var$layoutProps);

});
parcelRegister("7fGQw", function(module, exports) {
$parcel$export(module.exports, "ApprovalList", () => $10d1643c00583d96$export$dfa534f59b1c1487);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $10d1643c00583d96$export$dfa534f59b1c1487 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("eb40E")), {
        moduleId: "./src/view/approval-list/approval-list.tsx"
    })
});

});
parcelRegister("eb40E", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("87Mdk").then(()=>parcelRequire('jNgsU'));

});



parcelRegister("j7rgu", function(module, exports) {
$parcel$export(module.exports, "consentFormRoute", () => $35ff2a4213867e19$export$f978586bc0d52692);

var $748yq = parcelRequire("748yq");

var $bMxH1 = parcelRequire("bMxH1");

var $bp9tj = parcelRequire("bp9tj");
const $35ff2a4213867e19$var$consentForm = {
    resources: [],
    name: 'consent-form',
    path: `/user/consent`,
    exact: true,
    component: (0, $bMxH1.ConsentForm)
};
const $35ff2a4213867e19$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true
};
const $35ff2a4213867e19$export$f978586bc0d52692 = (0, $bp9tj.createRouteWithLayout)($35ff2a4213867e19$var$consentForm, (0, $748yq.ScreenName).CONSENT_FORM_PAGE, $35ff2a4213867e19$var$layoutProps);

});
parcelRegister("bMxH1", function(module, exports) {
$parcel$export(module.exports, "ConsentForm", () => $4963581353d6fd48$export$723d7f2fb08b9d80);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $4963581353d6fd48$export$723d7f2fb08b9d80 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("xkdjh")), {
        moduleId: "./src/view/consent-form/hocs.tsx"
    })
});

});
parcelRegister("xkdjh", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("d83OQ").then(()=>parcelRequire('JC1vz'));

});



parcelRegister("6JaEN", function(module, exports) {
$parcel$export(module.exports, "csmContactUsRoute", () => $c2bfd623395839a0$export$3979346dcb7ef96d);

var $748yq = parcelRequire("748yq");

var $5xTRR = parcelRequire("5xTRR");

var $HunEp = parcelRequire("HunEp");

var $bp9tj = parcelRequire("bp9tj");
const $c2bfd623395839a0$var$contactUs = {
    resources: [
        (0, $HunEp.mediaUploadCredentialsResource)
    ],
    name: (0, $748yq.RouteName).CSM_CONTACT_US_PAGE,
    path: (0, $748yq.RoutePath).CSM_CONTACT_US_PATH,
    exact: true,
    component: (0, $5xTRR.CsmContactUs)
};
const $c2bfd623395839a0$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $c2bfd623395839a0$export$3979346dcb7ef96d = (0, $bp9tj.createRouteWithLayout)($c2bfd623395839a0$var$contactUs, (0, $748yq.ScreenName).CSM_CONTACT_US, $c2bfd623395839a0$var$layoutProps);

});
parcelRegister("5xTRR", function(module, exports) {
$parcel$export(module.exports, "CsmContactUs", () => $21b32afbe8f0bcc0$export$961253a0ef353f1);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $21b32afbe8f0bcc0$export$961253a0ef353f1 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("aq7dm")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/ui/csm-contact-us.tsx"
    })
});

});
parcelRegister("aq7dm", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("7imz9"),
    $e46AW("1LYbr"),
    $e46AW("EdvSx"),
    $e46AW("fq0LN"),
    $e46AW("ibPpH"),
    $e46AW("dariE"),
    $e46AW("1nzUi"),
    $e46AW("1qVH8"),
    $e46AW("2PHdy"),
    $e46AW("98Vtx"),
    $e46AW("9d6FU"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("45caK"),
    $e46AW("4biYi"),
    $e46AW("7ddpr")
]).then(()=>parcelRequire('60pyO'));

});


parcelRegister("HunEp", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $e978e4696776f724$export$fac4b16282dd90f6);

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");

var $4oTiM = parcelRequire("4oTiM");

var $hZWMk = parcelRequire("hZWMk");
const $e978e4696776f724$export$fac4b16282dd90f6 = (0, $f03OU.createResource)({
    type: 'MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-upload-credentials`,
    getData: async ()=>{
        const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
        return (0, $hZWMk.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});


parcelRegister("ebomm", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $5ed819469c4f55d0$export$3dddbf9f405aac5c);

var $748yq = parcelRequire("748yq");

var $hmYfB = parcelRequire("hmYfB");

var $bp9tj = parcelRequire("bp9tj");
parcelRequire("9zzR4");
var $gUaaB = parcelRequire("gUaaB");

var $3NY3t = parcelRequire("3NY3t");
const $5ed819469c4f55d0$export$3dddbf9f405aac5c = (name = (0, $748yq.RouteName).VIEW_CUSTOM_PAGE, path = (0, $748yq.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $3NY3t.brandingResource),
        (0, $hmYfB.ViewCustomPageResource)
    ];
    return (0, $bp9tj.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: (0, $gUaaB.ViewCustomPageWithAiAgent),
        resources: [
            (0, $hmYfB.ViewCustomPageResource)
        ]
    }, (0, $748yq.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true
    });
};

});
parcelRegister("hmYfB", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPageResource", () => $117713cb19a40cdc$export$15c85a1b3a2577c9);

var $6mmHn = parcelRequire("6mmHn");

var $8llkI = parcelRequire("8llkI");

var $fZppw = parcelRequire("fZppw");

var $f8xuY = parcelRequire("f8xuY");
const $117713cb19a40cdc$export$15c85a1b3a2577c9 = (0, $fZppw.createRelayResource)({
    type: 'VIEW_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id || '';
        const helpCenterPageAri = (0, $8llkI.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $6mmHn.getActivationId)()
        }).toString();
        return {
            parameters: (0, $f8xuY.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri,
                filter: {
                    isEditMode: false
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("8llkI", function(module, exports) {
$parcel$export(module.exports, "HelpPageAri", () => $6130d53a95158c37$export$7855a3c68b5a0b04);

var $kTief = parcelRequire("kTief");

var $7NdII = parcelRequire("7NdII");

var $bwYEm = parcelRequire("bwYEm");
// src/help/page/manifest.ts
var $6130d53a95158c37$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $kTief.HelpPageAriResourceOwner),
    resourceType: (0, $kTief.HelpPageAriResourceType),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $6130d53a95158c37$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $7NdII.RegisteredAri) {
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6130d53a95158c37$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $6130d53a95158c37$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6130d53a95158c37$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $6130d53a95158c37$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $bwYEm.AriParser).fromOpts(derivedOpts, $6130d53a95158c37$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $bwYEm.AriParser).fromString(maybeAri, $6130d53a95158c37$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
};

});
parcelRegister("kTief", function(module, exports) {
$parcel$export(module.exports, "HelpPageAriResourceOwner", () => $f357158a63b2d3a4$export$b6fe1f05324d51ea);
$parcel$export(module.exports, "HelpPageAriResourceType", () => $f357158a63b2d3a4$export$e6c9af890e88f3eb);
// src/help/page/types.ts
var $f357158a63b2d3a4$export$b6fe1f05324d51ea = "help", $f357158a63b2d3a4$export$e6c9af890e88f3eb = "page";

});


parcelRegister("f8xuY", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3c5ff19eec0c71d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a8716921b8ad1a3339f001341db72213>>
 * @relayHash e15342ecc9d5d6d6fa16dbd150a7b3d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0584ba15db65176e105b407e15300f519202ee96f3cabce1e1cd9dd5ec97bb4
const $f3c5ff19eec0c71d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v8 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "HelpCenterPageDescription",
        "kind": "LinkedField",
        "name": "description",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "QueryError"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v18 = {
        "kind": "ScalarField",
        "name": "key"
    }, v19 = {
        "kind": "ScalarField",
        "name": "name"
    }, v20 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v21 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v22 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "titleColor"
            }
        ]
    }, v23 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v18 /*: any*/ 
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v25 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v27 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v28 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "url"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v8 /*: any*/ ,
                                            "action": "THROW"
                                        },
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v12 /*: any*/ ,
                                "kind": "LinkedField",
                                "name": "layoutByParentId",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "layoutViewRendererFragment"
                                            }
                                        ],
                                        "type": "HelpLayout"
                                    },
                                    v11 /*: any*/ 
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "viewCustomPageQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ],
                                    "type": "HelpCenterPage"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "parentAri",
                                                                                                            "variableName": "helpCenterAri"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaCollectionName"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaToken"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "mediaUrl"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "asapIssuer"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                v18 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v6 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                v19 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v13 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v24 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v20 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v25 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v22 /*: any*/ ,
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "foregroundColor"
                                                                                                },
                                                                                                v26 /*: any*/ ,
                                                                                                v27 /*: any*/ ,
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v13 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v19 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v23 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                v16 /*: any*/ ,
                                                                                v25 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "horizontalAlignment"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "verticalAlignment"
                                                                                                },
                                                                                                v25 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v25 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v24 /*: any*/ 
                                                                    ]
                                                                },
                                                                v6 /*: any*/ ,
                                                                v10 /*: any*/ ,
                                                                v25 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "sections(first:10)"
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "layoutRendererFragment_sections",
                                            "kind": "LinkedHandle",
                                            "name": "sections"
                                        },
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v15 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c0584ba15db65176e105b407e15300f519202ee96f3cabce1e1cd9dd5ec97bb4",
            "metadata": {},
            "name": "viewCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f3c5ff19eec0c71d$var$node.hash = "eb1a4ed7177899c5f9bd15d20468d07f";
var $f3c5ff19eec0c71d$export$2e2bcd8739ae039 = $f3c5ff19eec0c71d$var$node;

});


parcelRegister("9zzR4", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => (parcelRequire("gUaaB")).ViewCustomPage);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => (parcelRequire("gUaaB")).ViewCustomPageWithAiAgent);
$parcel$export(module.exports, "EditCustomPage", () => (parcelRequire("62E5R")).EditCustomPage);

var $gUaaB = parcelRequire("gUaaB");

var $62E5R = parcelRequire("62E5R");

});
parcelRegister("gUaaB", function(module, exports) {
$parcel$export(module.exports, "ViewCustomPage", () => $70b7a0b0e56e5b4f$export$445268d8b5206a5d);
$parcel$export(module.exports, "ViewCustomPageWithAiAgent", () => $70b7a0b0e56e5b4f$export$e4a1d2bae0fd7812);

var $4fqPo = parcelRequire("4fqPo");

var $6nes2 = parcelRequire("6nes2");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $70b7a0b0e56e5b4f$export$445268d8b5206a5d = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("5iXL7")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/view-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), null)
});

const $70b7a0b0e56e5b4f$export$e4a1d2bae0fd7812 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("jMKuW")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/view-custom-page/csm-variants/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), null)
});

});
parcelRegister("5iXL7", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("kgse0"),
    $e46AW("fC1qB"),
    $e46AW("e5MH2"),
    $e46AW("3vdHc"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("4VP2c")
]).then(()=>parcelRequire('ljqCZ'));

});

parcelRegister("jMKuW", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("kgse0"),
    $e46AW("fC1qB"),
    $e46AW("e5MH2"),
    $e46AW("3vdHc"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("4VP2c"),
    $e46AW("c6JhV")
]).then(()=>parcelRequire('fvTgN'));

});


parcelRegister("62E5R", function(module, exports) {
$parcel$export(module.exports, "EditCustomPage", () => $b5c89bcf21f53418$export$7fc1d63603c0df32);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6nes2 = parcelRequire("6nes2");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("kZndO");
var $1iSZL = parcelRequire("1iSZL");

const $b5c89bcf21f53418$export$7fc1d63603c0df32 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("f3JiZ")), {
        moduleId: "./packages/help-center/custom-pages/src/ui/edit-custom-page/edit-custom-page.tsx"
    }),
    LoadingSkeleton: ()=>(0, $bG6ob.isIncreasedFlexibilityEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1iSZL.default), {
            showActionBar: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6nes2.default), {
            showActionBar: true
        })
});

});
parcelRegister("f3JiZ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("fC1qB"),
    $e46AW("eUxjk"),
    $e46AW("lgGph"),
    $e46AW("e5MH2"),
    $e46AW("gxk6F"),
    $e46AW("ejayw"),
    $e46AW("5YgJY"),
    $e46AW("8t8wM"),
    $e46AW("g07kR"),
    $e46AW("3vdHc"),
    $e46AW("bZLDd"),
    $e46AW("3elKB"),
    $e46AW("h8xPI"),
    $e46AW("91QvV"),
    $e46AW("j8KVB"),
    $e46AW("958rd"),
    $e46AW("6BKvM"),
    $e46AW("9d6FU"),
    $e46AW("hqv7X"),
    $e46AW("mZL55"),
    $e46AW("eahZ0"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("77KZv")
]).then(()=>parcelRequire('giIWP'));

});




parcelRegister("1gJdX", function(module, exports) {
$parcel$export(module.exports, "csmFolderRoute", () => $e13bd19889e8ebe2$export$27c939ab49e382d2);

var $748yq = parcelRequire("748yq");

var $gQncq = parcelRequire("gQncq");

var $lG4t7 = parcelRequire("lG4t7");

var $cfump = parcelRequire("cfump");

var $bp9tj = parcelRequire("bp9tj");
const $e13bd19889e8ebe2$var$folder = {
    resources: [
        (0, $cfump.CsmFolderResource),
        (0, $lG4t7.CsmEmptyFolderResource)
    ],
    name: (0, $748yq.RouteName).CSM_FOLDER_PAGE,
    path: (0, $748yq.RoutePath).CSM_FOLDER_PATH,
    exact: true,
    component: (0, $gQncq.CsmFolder)
};
const $e13bd19889e8ebe2$var$layoutProps = {
    isAnonymous: false,
    paperAppearance: 'wide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
};
const $e13bd19889e8ebe2$export$27c939ab49e382d2 = (0, $bp9tj.createRouteWithLayout)($e13bd19889e8ebe2$var$folder, (0, $748yq.ScreenName).CSM_FOLDER, $e13bd19889e8ebe2$var$layoutProps);

});
parcelRegister("gQncq", function(module, exports) {
$parcel$export(module.exports, "CsmFolder", () => $84c029390c4341bd$export$56c9caef0ff41b5c);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $84c029390c4341bd$export$56c9caef0ff41b5c = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("WPQrk")), {
        moduleId: "./packages/customer-service/csm-folder/src/ui/csm-folder.tsx"
    })
});

});
parcelRegister("WPQrk", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fEhC9").then(()=>parcelRequire('jGOv3'));

});


parcelRegister("lG4t7", function(module, exports) {
$parcel$export(module.exports, "CsmEmptyFolderResource", () => $b18e056dfaec8996$export$acacebd3c63c516);

var $fZppw = parcelRequire("fZppw");

var $lSPnb = parcelRequire("lSPnb");

var $7ESaj = parcelRequire("7ESaj");
const $b18e056dfaec8996$export$acacebd3c63c516 = (0, $fZppw.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $lSPnb.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $7ESaj.MAX_ITEMS_PER_PAGE),
                input: {
                    articleIds: [
                        pageId
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("lSPnb", function(module, exports) {
$parcel$export(module.exports, "default", () => $cba9738860f0435c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b395b2f764ccd459bcc11cb4b79c1761>>
 * @relayHash be67b91b3b5b3d2fbcf3fcc898595c20
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365
const $cba9738860f0435c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "emptyStateRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "emptyStateQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "EmptyStateRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "77d32be1adc668a563832822a7038f9af4ea4a8a9da78288bd51d46e9d72d365",
            "metadata": {},
            "name": "emptyStateQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$cba9738860f0435c$var$node.hash = "0f924812359a442723962628434695a3";
var $cba9738860f0435c$export$2e2bcd8739ae039 = $cba9738860f0435c$var$node;

});

parcelRegister("7ESaj", function(module, exports) {
$parcel$export(module.exports, "MAX_ITEMS_PER_PAGE", () => $b83a3341696a506b$export$e7a0dcb737d8e4ee);
const $b83a3341696a506b$export$e7a0dcb737d8e4ee = 24;

});


parcelRegister("cfump", function(module, exports) {
$parcel$export(module.exports, "CsmFolderResource", () => $ce4a7042e95f0afc$export$c37e0f6e8d7653a0);

var $fZppw = parcelRequire("fZppw");

var $kPoDr = parcelRequire("kPoDr");

var $7ESaj = parcelRequire("7ESaj");
const $ce4a7042e95f0afc$var$ANCESTORS = 'ANCESTORS';
const $ce4a7042e95f0afc$export$c37e0f6e8d7653a0 = (0, $fZppw.createRelayResource)({
    type: 'CSM_FOLDER',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.folderId || '';
        return {
            parameters: (0, $kPoDr.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                first: (0, $7ESaj.MAX_ITEMS_PER_PAGE),
                input: {
                    parentId: Number(pageId),
                    expand: [
                        $ce4a7042e95f0afc$var$ANCESTORS
                    ]
                }
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("kPoDr", function(module, exports) {
$parcel$export(module.exports, "default", () => $39f30a8b2dfe22b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43c8e81c575a3396484c86e6516d58b4>>
 * @relayHash ccd2cd57b96d01e796a5305915df0306
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7bcbd9ccb0157071106ad1f289719ca9ee0c599161c648ce22c5d3f7ff53c17
const $39f30a8b2dfe22b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "mainCsmFolderItemsRenderer_data"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "contentType"
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleRelative",
                                                    "kind": "LinkedField",
                                                    "name": "ancestors",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpObjectStoreArticleURLInfo",
                                                    "kind": "LinkedField",
                                                    "name": "urlInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "shareUrl"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "HelpObjectStoreSupportSiteArticleSearchResult"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "helpCenterAri",
                        "cloudId",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "CsmFolderItemsRenderer__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "e7bcbd9ccb0157071106ad1f289719ca9ee0c599161c648ce22c5d3f7ff53c17",
            "metadata": {},
            "name": "csmFolderSearchArticlesForSupportSiteQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$39f30a8b2dfe22b2$var$node.hash = "4e2df91a41eb5d8ce8ae2f48a0e1068e";
var $39f30a8b2dfe22b2$export$2e2bcd8739ae039 = $39f30a8b2dfe22b2$var$node;

});



parcelRegister("l9QNW", function(module, exports) {
$parcel$export(module.exports, "csmViewKbPageRoute", () => $baf10c016b229660$export$ef20b2dba68d2a8);
$parcel$export(module.exports, "csmViewArticleRoute", () => $baf10c016b229660$export$b346ad0264655ca1);
$parcel$export(module.exports, "csmViewCrossSiteArticleRoute", () => $baf10c016b229660$export$cfb51b854559f2b3);

var $748yq = parcelRequire("748yq");

var $drarL = parcelRequire("drarL");

var $bp9tj = parcelRequire("bp9tj");
const $baf10c016b229660$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $drarL.CsmArticle)
};
const $baf10c016b229660$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $drarL.CsmArticle)
};
const $baf10c016b229660$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $drarL.CsmArticle)
};
const $baf10c016b229660$var$layoutProps = {
    paperAppearance: 'xxwide',
    fadeInSearchModal: true
};
const $baf10c016b229660$export$ef20b2dba68d2a8 = (0, $bp9tj.createRouteWithLayout)($baf10c016b229660$var$viewKbPage, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $baf10c016b229660$var$layoutProps);
const $baf10c016b229660$export$b346ad0264655ca1 = (0, $bp9tj.createRouteWithLayout)($baf10c016b229660$var$viewArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $baf10c016b229660$var$layoutProps);
const $baf10c016b229660$export$cfb51b854559f2b3 = (0, $bp9tj.createRouteWithLayout)($baf10c016b229660$var$viewCrossSiteArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $baf10c016b229660$var$layoutProps);

});
parcelRegister("drarL", function(module, exports) {
$parcel$export(module.exports, "CsmArticle", () => $6e70ccca4fb48516$export$630a6bc855af0b24);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $6e70ccca4fb48516$export$630a6bc855af0b24 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("2AZKp")), {
        moduleId: "./src/view/article/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("2AZKp", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("8nKoT"),
    $e46AW("2dP4h"),
    $e46AW("iAUjM")
]).then(()=>parcelRequire('2YxAq'));

});



parcelRegister("7qo7n", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListRoute", () => $16a580877345471e$export$416674a9ebdb2ee0);
$parcel$export(module.exports, "csmRequestDetailsRoute", () => $16a580877345471e$export$c1779627ae2c6baa);

var $748yq = parcelRequire("748yq");

var $4M8D7 = parcelRequire("4M8D7");

var $BWSXY = parcelRequire("BWSXY");

var $eeyLA = parcelRequire("eeyLA");

var $tijOD = parcelRequire("tijOD");

var $aAvAT = parcelRequire("aAvAT");

var $liVpL = parcelRequire("liVpL");

var $6jGQR = parcelRequire("6jGQR");

var $bp9tj = parcelRequire("bp9tj");
const $16a580877345471e$export$416674a9ebdb2ee0 = (0, $bp9tj.createRouteWithLayout)({
    name: (0, $748yq.RouteName).CSM_REQUESTS_LIST_PAGE,
    path: (0, $748yq.RoutePath).CSM_REQUESTS_LIST_PATH,
    exact: true,
    component: (0, $liVpL.CsmRequestsList),
    resources: [
        (0, $6jGQR.csmRequestsListQueryResource)
    ]
}, (0, $748yq.ScreenName).CSM_REQUESTS_LIST, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true
});
const $16a580877345471e$export$c1779627ae2c6baa = (0, $bp9tj.createRouteWithLayout)({
    name: (0, $748yq.RouteName).CSM_REQUEST_DETAILS_PAGE,
    path: (0, $748yq.RoutePath).CSM_REQUEST_DETAILS_PATH,
    exact: true,
    component: (0, $aAvAT.AsyncCsmRequestDetails),
    resources: [
        (0, $4M8D7.csmRequestDetailsQueryResource),
        (0, $tijOD.requestConversationResource),
        (0, $BWSXY.mediaReadCredentialsResource),
        (0, $eeyLA.mediaUploadCredentialsResource)
    ]
}, (0, $748yq.ScreenName).CSM_REQUEST_DETAILS, {
    isAnonymous: false,
    paperAppearance: 'xxwide',
    fadeInSearchModal: true,
    prefetchBrandingModel: true,
    hideBanner: true
});

});
parcelRegister("4M8D7", function(module, exports) {
$parcel$export(module.exports, "csmRequestDetailsQueryResource", () => $ad4847bccaa717cb$export$54cc49ad6240b8cc);

var $6mmHn = parcelRequire("6mmHn");

var $fZppw = parcelRequire("fZppw");

var $jfafM = parcelRequire("jfafM");
const $ad4847bccaa717cb$export$54cc49ad6240b8cc = (0, $fZppw.createRelayResource)({
    type: 'CSM_REQUEST_DETAILS_QUERY',
    getQuery: ({ match: { params: { requestKey: requestKey } } }, { cloudId: cloudId })=>({
            parameters: (0, $jfafM.default),
            variables: {
                cloudId: cloudId,
                issueKey: requestKey ?? '',
                helpCenterId: (0, $6mmHn.getMeta)('help-center-ari') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("jfafM", function(module, exports) {
$parcel$export(module.exports, "default", () => $397a7123663e0d58$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b55be660807c06b30d7a3412375654d>>
 * @relayHash 87fc003a5d1f1c9ffac49d87bec9b59c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 86863967df2e8bab3425653ee4615d62dc716f4fa34e05addbea4dbaf34e071c
const $397a7123663e0d58$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterId",
            "variableName": "helpCenterId"
        },
        {
            "kind": "Variable",
            "name": "issueKey",
            "variableName": "issueKey"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "question"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v4 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "requestByIssueKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_csmRequestDetails"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "formView_csmRequestDetails"
                                                }
                                            ],
                                            "type": "CustomerServiceRequest"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "throwOnQueryError_csmCommon"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestDetailsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "requestByIssueKey",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "summary"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "createdOn"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalStatus"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCategoryName"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reporterDisplayName"
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestSharedOrganization",
                                            "kind": "LinkedField",
                                            "name": "sharedOrganizations",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestParticipant",
                                            "kind": "LinkedField",
                                            "name": "participants",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "displayName"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "CustomerServiceRequestFormDataConnection",
                                            "kind": "LinkedField",
                                            "name": "formData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestFormDataEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "textAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "adfAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryRichTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "multiSelectTextAnswer"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryMultiSelectField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fileIds"
                                                                        }
                                                                    ],
                                                                    "type": "CustomerServiceRequestFormEntryAttachmentField"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CustomerServiceRequest"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "identifier"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "86863967df2e8bab3425653ee4615d62dc716f4fa34e05addbea4dbaf34e071c",
            "metadata": {},
            "name": "csmRequestDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$397a7123663e0d58$var$node.hash = "811d1d3a63923fde18bd9ef571ef1a78";
var $397a7123663e0d58$export$2e2bcd8739ae039 = $397a7123663e0d58$var$node;

});


parcelRegister("BWSXY", function(module, exports) {
$parcel$export(module.exports, "mediaReadCredentialsResource", () => $55b1253d6ab3ceb3$export$bb777640a2b36f94);

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");

var $4oTiM = parcelRequire("4oTiM");

var $hZWMk = parcelRequire("hZWMk");
const $55b1253d6ab3ceb3$export$bb777640a2b36f94 = (0, $f03OU.createResource)({
    type: 'MEDIA_READ_CREDENTIALS_RESOURCE',
    getKey: ()=>`media-read-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
        return (0, $hZWMk.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/read`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("eeyLA", function(module, exports) {
$parcel$export(module.exports, "mediaUploadCredentialsResource", () => $aac1e0e89bff64a3$export$fac4b16282dd90f6);

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");

var $4oTiM = parcelRequire("4oTiM");

var $hZWMk = parcelRequire("hZWMk");
const $aac1e0e89bff64a3$export$fac4b16282dd90f6 = (0, $f03OU.createResource)({
    type: 'CSM_MEDIA_UPLOAD_CREDENTIALS_RESOURCE',
    getKey: ()=>`csm-media-upload-credentials`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
        return (0, $hZWMk.fetchJson)(`/rest/jcs/internal/1/support-site/${helpCenterId}/issue/${match.params.requestKey || ''}/media/credentials/upload`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 600000 // 10 minutes
});

});

parcelRegister("tijOD", function(module, exports) {
$parcel$export(module.exports, "requestConversationResource", () => $04a948a1e53943fa$export$9062b1d7764a6617);

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");

var $4oTiM = parcelRequire("4oTiM");

var $hZWMk = parcelRequire("hZWMk");
const $04a948a1e53943fa$export$9062b1d7764a6617 = (0, $f03OU.createResource)({
    type: 'REQUEST_CONVERSATION_RESOURCE',
    getKey: ()=>`request-conversation`,
    getData: async ({ match: match })=>{
        const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse((0, $6mmHn.getHelpCenterAri)());
        return (0, $hZWMk.fetchJson)(`/gateway/api/jsm/csm/api/v1/request/form/helpcenter/${helpCenterId}/conversation/history?issueIdOrKey=${match.params.requestKey || ''}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json'
            }
        });
    },
    maxAge: 0
});

});

parcelRegister("aAvAT", function(module, exports) {
$parcel$export(module.exports, "AsyncCsmRequestDetails", () => $92bad761362c9ad4$export$c654e93ddb89d705);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $92bad761362c9ad4$export$c654e93ddb89d705 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("6aisL")), {
        moduleId: "./packages/customer-service/csm-request-details/src/ui/csm-request-details.tsx"
    })
});

});
parcelRegister("6aisL", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5YgJY"),
    $e46AW("jQ0w0"),
    $e46AW("iV1EX"),
    $e46AW("3fKXj"),
    $e46AW("h1M4k"),
    $e46AW("3vgBs"),
    $e46AW("co70a"),
    $e46AW("5lbRq")
]).then(()=>parcelRequire('9WS6I'));

});


parcelRegister("liVpL", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsList", () => $bbfb24cb858e685a$export$790b773cc5ea9295);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $bbfb24cb858e685a$export$790b773cc5ea9295 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("loDx3")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/ui/csm-requests-list.tsx"
    })
});

});
parcelRegister("loDx3", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5gUlY"),
    $e46AW("iV1EX"),
    $e46AW("jNeMP"),
    $e46AW("jZPNc"),
    $e46AW("h0QLI")
]).then(()=>parcelRequire('8z6Xa'));

});


parcelRegister("6jGQR", function(module, exports) {
$parcel$export(module.exports, "csmRequestsListQueryResource", () => $a8b93555f98395a3$export$a6363e566cdd7bae);

var $6mmHn = parcelRequire("6mmHn");

var $fZppw = parcelRequire("fZppw");

var $kAJeR = parcelRequire("kAJeR");

var $7QcDD = parcelRequire("7QcDD");
const $a8b93555f98395a3$export$a6363e566cdd7bae = (0, $fZppw.createRelayResource)({
    type: 'CSM_REQUESTS_LIST_QUERY',
    getQuery: (_, { cloudId: cloudId })=>({
            parameters: (0, $7QcDD.default),
            variables: {
                cloudId: cloudId,
                accountId: (0, $6mmHn.getMeta)('account-id') ?? '',
                helpCenterId: (0, $6mmHn.getMeta)('help-center-ari') ?? '',
                count: (0, $kAJeR.PAGINATION_SIZE)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("kAJeR", function(module, exports) {
$parcel$export(module.exports, "PAGINATION_SIZE", () => $94b649688271d616$export$cb638d1fae624fbf);
const $94b649688271d616$export$cb638d1fae624fbf = 30;

});

parcelRegister("7QcDD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c238217de4f97e4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3b404f8656ccaa83cc2aeccfbc9a6fb9>>
 * @relayHash 9331238d6daa0e888a8631024ba79a1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b3ad4ebead07d72559a6eecf04e71a666af53a070bc8f2476448a98b75cbeca
const $7c238217de4f97e4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v5 = {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = {
        "kind": "Variable",
        "name": "filter",
        "variableName": "filter"
    }, v8 = {
        "kind": "Variable",
        "name": "helpCenterId",
        "variableName": "helpCenterId"
    }, v9 = [
        v6 /*: any*/ 
    ], v10 = [
        v8 /*: any*/ 
    ], v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "CustomerServiceExternalStatus",
                "kind": "LinkedField",
                "name": "externalStatuses",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "externalLabel"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "jiraStatusIds"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "statusCategory"
                    }
                ]
            }
        ],
        "type": "CustomerServiceExternalStatusesResponse"
    }, v12 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v13 = {
        "kind": "ScalarField",
        "name": "message"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            v13 /*: any*/ 
        ],
        "type": "QueryError"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v16 = [
        v7 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        },
        v8 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "requestsTable_csmRequestsList"
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "csmRequestsListQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "CustomerServiceQueryApi",
                    "kind": "LinkedField",
                    "name": "customerService",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v5 /*: any*/ 
                            ],
                            "kind": "LinkedField",
                            "name": "individualByAccountId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v16 /*: any*/ ,
                                            "concreteType": "CustomerServiceRequestConnection",
                                            "kind": "LinkedField",
                                            "name": "requests",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "CustomerServiceRequestEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceRequest",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusKey"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "externalStatus"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusCategoryName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "reporterDisplayName"
                                                                },
                                                                {
                                                                    "concreteType": "CustomerServiceRequestSharedOrganization",
                                                                    "kind": "LinkedField",
                                                                    "name": "sharedOrganizations",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "name"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "createdOn"
                                                                },
                                                                v17 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v16 /*: any*/ ,
                                            "filters": [
                                                "helpCenterId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "requestsTable_requests",
                                            "kind": "LinkedHandle",
                                            "name": "requests"
                                        }
                                    ],
                                    "type": "CustomerServiceIndividual"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "errorType"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v17 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "externalStatusesByHelpCenterId",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                v11 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9b3ad4ebead07d72559a6eecf04e71a666af53a070bc8f2476448a98b75cbeca",
            "metadata": {},
            "name": "csmRequestsListQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7c238217de4f97e4$var$node.hash = "cb6332bdb26c3936c3393e7e0eb0eafc";
var $7c238217de4f97e4$export$2e2bcd8739ae039 = $7c238217de4f97e4$var$node;

});



parcelRegister("cYDr2", function(module, exports) {
$parcel$export(module.exports, "csmUserProfileRoute", () => $1659356501ae39f6$export$e41fe4b9d1161823);

var $748yq = parcelRequire("748yq");

var $7PD2P = parcelRequire("7PD2P");

var $bp9tj = parcelRequire("bp9tj");
const $1659356501ae39f6$var$viewUserProfilePage = {
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: (0, $7PD2P.CsmUserProfile)
};
const $1659356501ae39f6$export$e41fe4b9d1161823 = (0, $bp9tj.createRouteWithLayout)($1659356501ae39f6$var$viewUserProfilePage, (0, $748yq.ScreenName).USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true
});

});
parcelRegister("7PD2P", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfile", () => $514f45a4776374fe$export$3d0c667f8fc698fc);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $514f45a4776374fe$export$3d0c667f8fc698fc = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("7dG0R")), {
        moduleId: "./src/view/user-profile/csm-variants/csm-variants.tsx"
    })
});

});
parcelRegister("7dG0R", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("1oLOq"),
    $e46AW("6BOeo")
]).then(()=>parcelRequire('7fNAx'));

});



parcelRegister("3zvSe", function(module, exports) {
$parcel$export(module.exports, "getViewCustomPageRoute", () => $eb877a4c9441144a$export$3dddbf9f405aac5c);
$parcel$export(module.exports, "getEditCustomPageRoute", () => $eb877a4c9441144a$export$c998bed8122ef3dd);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $748yq = parcelRequire("748yq");

var $dFPQj = parcelRequire("dFPQj");

var $hmYfB = parcelRequire("hmYfB");

var $bG6ob = parcelRequire("bG6ob");

var $dQegt = parcelRequire("dQegt");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");
parcelRequire("evK9u");
var $a8nBS = parcelRequire("a8nBS");
parcelRequire("8zo3m");
var $f1dKT = parcelRequire("f1dKT");

var $corqd = parcelRequire("corqd");

var $bp9tj = parcelRequire("bp9tj");
parcelRequire("9zzR4");
var $62E5R = parcelRequire("62E5R");
var $gUaaB = parcelRequire("gUaaB");

var $3NY3t = parcelRequire("3NY3t");
const $eb877a4c9441144a$export$3dddbf9f405aac5c = (name = (0, $748yq.RouteName).VIEW_CUSTOM_PAGE, path = (0, $748yq.RoutePath).VIEW_CUSTOM_PAGE)=>{
    const viewCustomPageSSRResources = [
        (0, $3NY3t.brandingResource),
        (0, $hmYfB.ViewCustomPageResource)
    ];
    return (0, $bp9tj.createRouteWithLayout)({
        name: name,
        path: path,
        exact: true,
        component: (0, $gUaaB.ViewCustomPage),
        resources: [
            (0, $hmYfB.ViewCustomPageResource)
        ]
    }, (0, $748yq.ScreenName).VIEW_CUSTOM_PAGE, {
        paperAppearance: 'none',
        fadeInSearchModal: true,
        hideSearchButton: true,
        hideBanner: true,
        removeHeader: true,
        prefetchBrandingModel: true,
        hideSkipToMainContent: true
    });
};
const $eb877a4c9441144a$export$366de07628c8a4b = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: props.location.pathname
    }), (0, $3RiO6.default)({
        message: formatMessage((0, $corqd.authPageMessage)),
        callToActionText: formatMessage((0, $corqd.callToActionUrlText)),
        callToActionUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a8nBS.default), {
            path: (0, $748yq.RoutePath).EDIT_CUSTOM_PAGE,
            component: (0, $62E5R.EditCustomPage),
            screenName: (0, $748yq.ScreenName).EDIT_CUSTOM_PAGE,
            isFooterHidden: (0, $bG6ob.isIncreasedFlexibilityEnabled)()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f1dKT.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props));
};
const $eb877a4c9441144a$export$c998bed8122ef3dd = (name = (0, $748yq.RouteName).EDIT_CUSTOM_PAGE, path = (0, $748yq.RoutePath).EDIT_CUSTOM_PAGE)=>{
    const editHomePageRoute = {
        name: name,
        path: path,
        exact: true,
        component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo($eb877a4c9441144a$export$366de07628c8a4b),
        resources: [
            (0, $dFPQj.EditCustomPageResource)
        ]
    };
    return editHomePageRoute;
};

});
parcelRegister("dFPQj", function(module, exports) {
$parcel$export(module.exports, "EditCustomPageResource", () => $31f02bbe243d7f1c$export$bb1f5be367194159);

var $6mmHn = parcelRequire("6mmHn");

var $8llkI = parcelRequire("8llkI");

var $fZppw = parcelRequire("fZppw");

var $lxuyl = parcelRequire("lxuyl");
const $31f02bbe243d7f1c$export$bb1f5be367194159 = (0, $fZppw.createRelayResource)({
    type: 'EDIT_CUSTOM_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const pageId = match.params.id;
        if (!pageId) throw Error('No page id for custom page.');
        const helpCenterPageAri = (0, $8llkI.HelpPageAri).create({
            pageId: pageId,
            activationId: (0, $6mmHn.getActivationId)()
        }).toString();
        return {
            parameters: (0, $lxuyl.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                helpCenterPageAri: helpCenterPageAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("lxuyl", function(module, exports) {
$parcel$export(module.exports, "default", () => $40fef4934d37332a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<afecf275bf1b1f87e33cdaf8ea455f40>>
 * @relayHash cac39a5aff5256ed1e3f136528873758
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cef9c5e37d4002685f206f54e0b958adb8cf7bb43e38583cc6a57589c4fd1d31
const $40fef4934d37332a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterPageAri"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "helpCenterPageAri",
            "variableName": "helpCenterPageAri"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "FragmentSpread",
                "name": "handleQueryErrorFragment"
            }
        ],
        "type": "QueryError"
    }, v10 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v11 = [
        v10 /*: any*/ 
    ], v12 = [
        v10 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterPageAri"
        }
    ], v13 = [
        {
            "kind": "Variable",
            "name": "parentAri",
            "variableName": "helpCenterAri"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "message"
    }, v15 = {
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "statusCode"
            }
        ]
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v14 /*: any*/ ,
            v15 /*: any*/ 
        ],
        "type": "QueryError"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v18 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v19 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v20 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v22 = [
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v24 = {
        "kind": "ScalarField",
        "name": "key"
    }, v25 = {
        "kind": "ScalarField",
        "name": "horizontalAlignment"
    }, v26 = {
        "kind": "ScalarField",
        "name": "verticalAlignment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v28 = {
        "kind": "ClientExtension",
        "selections": [
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "fileId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "url"
    }, v31 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "backgroundType"
    }, v33 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v34 = {
        "kind": "ScalarField",
        "name": "foregroundColor"
    }, v35 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v36 = {
        "kind": "ScalarField",
        "name": "titleColor"
    }, v37 = {
        "kind": "ScalarField",
        "name": "name"
    }, v38 = {
        "kind": "ScalarField",
        "name": "logo"
    }, v39 = {
        "kind": "ScalarField",
        "name": "portalId"
    }, v40 = {
        "concreteType": "HelpLayoutAlignmentSettings",
        "kind": "LinkedField",
        "name": "alignment",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v41 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v36 /*: any*/ ,
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ 
        ]
    }, v42 = {
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v43 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isHelpLayoutVisualEntity"
    }, v44 = {
        "concreteType": "HelpLayoutBackgroundImage",
        "kind": "LinkedField",
        "name": "backgroundImage",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v29 /*: any*/ 
        ]
    }, v45 = {
        "concreteType": "HelpLayoutVisualConfig",
        "kind": "LinkedField",
        "name": "visualConfig",
        "plural": false,
        "selections": [
            v40 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v46 = {
        "kind": "ScalarField",
        "name": "isInstalled"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": v11 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "mediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "globalBrandingSettingsPanelMediaConfigFragment"
                                    }
                                ]
                            },
                            "action": "THROW"
                        }
                    ]
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v3 /*: any*/ ,
                        "concreteType": "HelpLayoutQueryApi",
                        "kind": "LinkedField",
                        "name": "helpLayout",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v12 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "layoutByParentId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "pageBuilderFragment"
                                                }
                                            ],
                                            "type": "HelpLayout"
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v13 /*: any*/ ,
                                    "concreteType": "HelpLayoutMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "mediaConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "pageBuilderMediaConfigFragment"
                                        }
                                    ]
                                },
                                "action": "THROW"
                            },
                            {
                                "kind": "LinkedField",
                                "name": "elementTypes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "elementsCatalogueFragment"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editCustomPageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterPageById",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                v7 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v11 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "HelpLayoutQueryApi",
                    "kind": "LinkedField",
                    "name": "helpLayout",
                    "plural": false,
                    "selections": [
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "layoutByParentId",
                            "plural": false,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "HelpLayoutSectionConnection",
                                            "kind": "LinkedField",
                                            "name": "sections",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpLayoutSectionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpLayoutSection",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpLayoutSubsection",
                                                                    "kind": "LinkedField",
                                                                    "name": "subsections",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpLayoutSubsectionConfig",
                                                                            "kind": "LinkedField",
                                                                            "name": "config",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "span"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "elements",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "TypeDiscriminator",
                                                                                    "abstractKey": "__isHelpLayoutElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "adf"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": v13 /*: any*/ ,
                                                                                                    "concreteType": "HelpLayoutMediaConfig",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mediaConfig",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v19 /*: any*/ ,
                                                                                                        v18 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v23 /*: any*/ ,
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutAlignmentSettings",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "alignment",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v26 /*: any*/ ,
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v31 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v34 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v28 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutEditorElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutPortalCard",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "portals",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "description"
                                                                                                },
                                                                                                v38 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "isFeatured"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "expandButtonTextColor"
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutPortalsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutRequestForm",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "suggestedRequestTypes",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "descriptionHtml"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "portalName"
                                                                                                },
                                                                                                v5 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                v37 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "iconUrl"
                                                                                                },
                                                                                                v8 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutSuggestedRequestFormsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "header"
                                                                                        },
                                                                                        v14 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutAnnouncementElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutTopic",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "topics",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicId"
                                                                                                },
                                                                                                v35 /*: any*/ ,
                                                                                                {
                                                                                                    "concreteType": "HelpLayoutTopicItem",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "items",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "title"
                                                                                                        },
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "displayLink"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "entityKey"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "helpObjectType"
                                                                                                        },
                                                                                                        v28 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "topicName"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        v41 /*: any*/ ,
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutTopicsListElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "useGlobalSettings"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "homePageTitle"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "userLanguageTag"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "showCSMAISearchTrigger"
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpLayoutVisualConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "visualConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v34 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v32 /*: any*/ ,
                                                                                                v44 /*: any*/ ,
                                                                                                v40 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v36 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v5 /*: any*/ ,
                                                                                        v42 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutHeroElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutBreadcrumb",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "items",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "relativeUrl"
                                                                                                },
                                                                                                v37 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutBreadcrumbElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementType"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "forgeElementPage"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutForgeElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementPage"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "connectElementType"
                                                                                        },
                                                                                        v42 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        v45 /*: any*/ 
                                                                                    ],
                                                                                    "type": "HelpLayoutConnectElement"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "identifier"
                                                                                        },
                                                                                        v15 /*: any*/ 
                                                                                    ],
                                                                                    "type": "QueryError"
                                                                                },
                                                                                v28 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAtomicElementType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "elementType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v24 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpLayoutNoContentElement"
                                                                                },
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v5 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "visualConfig",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "HelpLayoutAlignmentSettings",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "alignment",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v28 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "HelpLayoutVisualEntity",
                                                                            "abstractKey": "__isHelpLayoutVisualEntity"
                                                                        },
                                                                        v28 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpLayoutVisualConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "visualConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v36 /*: any*/ 
                                                                    ]
                                                                },
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v27 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataId",
                                                                            "kind": "ScalarField",
                                                                            "name": "__id"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "layoutId",
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        v28 /*: any*/ 
                                    ],
                                    "type": "HelpLayout"
                                },
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        {
                            "args": v13 /*: any*/ ,
                            "concreteType": "HelpLayoutMediaConfig",
                            "kind": "LinkedField",
                            "name": "mediaConfig",
                            "plural": false,
                            "selections": v22 /*: any*/ 
                        },
                        {
                            "kind": "LinkedField",
                            "name": "elementTypes",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpLayoutElementType"
                                },
                                v23 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "atomicKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "args": v13 /*: any*/ ,
                                            "concreteType": "HelpLayoutMediaConfig",
                                            "kind": "LinkedField",
                                            "name": "mediaConfig",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpLayoutAtomicElementType"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": "compositeKey",
                                            "kind": "ScalarField",
                                            "name": "key"
                                        }
                                    ],
                                    "type": "HelpLayoutCompositeElementType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cef9c5e37d4002685f206f54e0b958adb8cf7bb43e38583cc6a57589c4fd1d31",
            "metadata": {},
            "name": "editCustomPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$40fef4934d37332a$var$node.hash = "ced1fe6aab72feb794e7063ba7fe32c0";
var $40fef4934d37332a$export$2e2bcd8739ae039 = $40fef4934d37332a$var$node;

});



parcelRegister("47xIg", function(module, exports) {
$parcel$export(module.exports, "TOPIC_BASE_PATH", () => $9e687e9410c45cc8$export$fcfe7b179287e200);
$parcel$export(module.exports, "editTopicRoute", () => $9e687e9410c45cc8$export$60c0f814fe4b3a12);
$parcel$export(module.exports, "addTopicRoute", () => $9e687e9410c45cc8$export$9d8f7fd5bc61f52f);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $748yq = parcelRequire("748yq");

var $efDRU = parcelRequire("efDRU");
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");

var $jOB0E = parcelRequire("jOB0E");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");
parcelRequire("evK9u");
var $a8nBS = parcelRequire("a8nBS");

var $corqd = parcelRequire("corqd");

var $4MG2m = parcelRequire("4MG2m");
const $9e687e9410c45cc8$export$fcfe7b179287e200 = `/topic`;
const $9e687e9410c45cc8$var$ADD_TOPIC_PATH = `${$9e687e9410c45cc8$export$fcfe7b179287e200}/add`;
const $9e687e9410c45cc8$var$EDIT_TOPIC_PATH = `${$9e687e9410c45cc8$export$fcfe7b179287e200}/edit/:id`;
const $9e687e9410c45cc8$export$7285959833dc0185 = (0, $efDRU.default)((props)=>{
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: props.location.pathname
    }), (0, $3RiO6.default)({
        message: props.intl.formatMessage((0, $corqd.authPageMessage)),
        callToActionText: props.intl.formatMessage((0, $corqd.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a8nBS.default), {
            path: $9e687e9410c45cc8$var$EDIT_TOPIC_PATH,
            component: (0, $jOB0E.EditTopicPage),
            screenName: (0, $748yq.ScreenName).EDIT_TOPIC
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props);
});
const $9e687e9410c45cc8$export$60c0f814fe4b3a12 = {
    name: (0, $748yq.ScreenName).EDIT_TOPIC,
    path: $9e687e9410c45cc8$var$EDIT_TOPIC_PATH,
    exact: true,
    component: (0, $lM7Z9.withRouter)($9e687e9410c45cc8$export$7285959833dc0185),
    resources: [
        (0, $4MG2m.editTopicResource)
    ]
};
const $9e687e9410c45cc8$export$9d8f7fd5bc61f52f = {
    name: (0, $748yq.ScreenName).EDIT_TOPIC,
    path: $9e687e9410c45cc8$var$ADD_TOPIC_PATH,
    exact: true,
    component: (0, $lM7Z9.withRouter)($9e687e9410c45cc8$export$7285959833dc0185),
    resources: [
        (0, $4MG2m.editTopicResource)
    ]
};

});
parcelRegister("jOB0E", function(module, exports) {
$parcel$export(module.exports, "EditTopicPage", () => $5445a9adf01d3ed7$export$167706eed2563765);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

var $eeI5u = parcelRequire("eeI5u");

const $5445a9adf01d3ed7$export$167706eed2563765 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("fiTYe")).then((module)=>{
            const { registerHelpObjectEpicsAndReducers: registerHelpObjectEpicsAndReducers } = module;
            registerHelpObjectEpicsAndReducers();
            return module.default;
        }), {
        moduleId: "./src/topics/src/ui/edit-topic/main.tsx"
    }),
    LoadingSkeleton: (0, $eeI5u.EditTopicLoader)
});

});
parcelRegister("eeI5u", function(module, exports) {
$parcel$export(module.exports, "EditTopicLoader", () => $a1bb940f55307c99$export$c00c0ab43fa4f914);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bvB7a = parcelRequire("bvB7a");
var $fVQGu = parcelRequire("fVQGu");

var $bpWyP = parcelRequire("bpWyP");

var $7TPEx = parcelRequire("7TPEx");

var $5qWT2 = parcelRequire("5qWT2");

var $jcahE = parcelRequire("jcahE");
const $a1bb940f55307c99$export$c00c0ab43fa4f914 = (props)=>{
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, props.error ? /*#__PURE__*/ $4fqPo.createElement($a1bb940f55307c99$var$LoaderContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $bvB7a.ChunkLoadErrorMessage), null)) : /*#__PURE__*/ $4fqPo.createElement((0, $jcahE.Container), null, /*#__PURE__*/ $4fqPo.createElement((0, $jcahE.TopicContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingInline: "space.500"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $jcahE.SpinnerWrapper), null, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        size: 'medium'
    })))), /*#__PURE__*/ $4fqPo.createElement((0, $jcahE.HelpObjectContainer), null, /*#__PURE__*/ $4fqPo.createElement($a1bb940f55307c99$var$Row, null, /*#__PURE__*/ $4fqPo.createElement((0, $fVQGu.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $4fqPo.createElement($a1bb940f55307c99$var$Row, null, /*#__PURE__*/ $4fqPo.createElement((0, $fVQGu.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })), /*#__PURE__*/ $4fqPo.createElement($a1bb940f55307c99$var$Row, null, /*#__PURE__*/ $4fqPo.createElement((0, $fVQGu.LoadingSkeleton), {
        height: 40,
        backgroundColor: "var(--ds-skeleton-subtle, #F4F5F7)"
    })))));
};
const $a1bb940f55307c99$var$LOADER_MIN_HEIGHT = '75vh';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a1bb940f55307c99$var$LoaderContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-16axg55-0"
})`min-height:${$a1bb940f55307c99$var$LOADER_MIN_HEIGHT};display:flex;align-items:center;justify-content:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a1bb940f55307c99$var$Row = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-16axg55-1"
})`margin-top:${"var(--ds-space-200, 16px)"};width:${$bpWyP.multiple(50).px};`;

});
parcelRegister("jcahE", function(module, exports) {
$parcel$export(module.exports, "Container", () => $1e453834dd52d5c7$export$42a852a2b6b56249);
$parcel$export(module.exports, "TopicContainer", () => $1e453834dd52d5c7$export$3906a519f454d518);
$parcel$export(module.exports, "HelpObjectContainer", () => $1e453834dd52d5c7$export$7e8e7bb92ce298ab);
$parcel$export(module.exports, "SpinnerWrapper", () => $1e453834dd52d5c7$export$52b4dfd89a6b3a1b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $iSWaE = parcelRequire("iSWaE");

var $hTMzE = parcelRequire("hTMzE");
const $1e453834dd52d5c7$var$topicContainerWidth = '70%';
const $1e453834dd52d5c7$var$topicContainerMinHeight = `calc(100vh - ${(0, $hTMzE.FOOTER_HEIGHT)}px)`;
const $1e453834dd52d5c7$var$helpObjectContainerWidth = '30%';
const $1e453834dd52d5c7$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-7u94c0-0"
})`display:flex;flex-wrap:wrap;justify-content:space-between;border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};`;
const $1e453834dd52d5c7$export$3906a519f454d518 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-7u94c0-1"
})`width:${$1e453834dd52d5c7$var$topicContainerWidth};padding:${"var(--ds-space-400, 32px)"} ${"var(--ds-space-1000, 80px)"};background-color:${"var(--ds-surface, #FFFFFF)"};border-right:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #EBECF0)"};box-sizing:border-box;min-height:${$1e453834dd52d5c7$var$topicContainerMinHeight};`;
const $1e453834dd52d5c7$export$7e8e7bb92ce298ab = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-7u94c0-2"
})`width:${$1e453834dd52d5c7$var$helpObjectContainerWidth};box-sizing:border-box;padding:${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"};`;
const $1e453834dd52d5c7$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-7u94c0-3"
})`${$iSWaE.flexCenter};margin-top:${"var(--ds-space-400, 32px)"};`;

});


parcelRegister("fiTYe", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("55OMz"),
    $e46AW("3vdHc"),
    $e46AW("hIEoX"),
    $e46AW("9lL54"),
    $e46AW("3LMle")
]).then(()=>parcelRequire('i8HdY'));

});


parcelRegister("4MG2m", function(module, exports) {
$parcel$export(module.exports, "editTopicResource", () => $3af2aa784a1b746e$export$414824bab2e11c29);

var $aIDHt = parcelRequire("aIDHt");

var $fZppw = parcelRequire("fZppw");
const $3af2aa784a1b746e$export$414824bab2e11c29 = (0, $fZppw.createRelayResource)({
    type: 'EDIT_TOPIC',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>({
            parameters: (0, $aIDHt.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});


parcelRegister("jYI2M", function(module, exports) {
$parcel$export(module.exports, "getEmbedCreateRequestRoute", () => $b304f2423339d960$export$ed25ec64c8131f29);
$parcel$export(module.exports, "embedSinglePortalRoute", () => $b304f2423339d960$export$f8f6af866fe5eb29);
$parcel$export(module.exports, "embedKBArticleRoute", () => $b304f2423339d960$export$50b320f40299497c);
$parcel$export(module.exports, "embedFeaturedPortalsRoute", () => $b304f2423339d960$export$89cf0aa4f08ce120);
$parcel$export(module.exports, "embedLoginSuccessRoute", () => $b304f2423339d960$export$a493105cf7e63414);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $cwZKZ = parcelRequire("cwZKZ");

var $bpWyP = parcelRequire("bpWyP");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
var $lM7Z9 = parcelRequire("lM7Z9");
parcelRequire("VQKxQ");
var $6Wtq0 = parcelRequire("6Wtq0");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");

var $6bGmX = parcelRequire("6bGmX");

var $eHkSG = parcelRequire("eHkSG");
const $b304f2423339d960$export$2e9e2f006c89796d = (WrappedComponent, screenName)=>{
    const ComponentWithEmbeddedPage = (props)=>{
        const [routerState] = (0, $hfD9S.useRouter)();
        const { basePath: basePath, ...routeContext } = routerState;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eHkSG.default), {
            screenName: screenName,
            screenId: routeContext.match.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60sOE.default), {
            screenName: screenName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b304f2423339d960$var$EmbedComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6Wtq0.default), routeContext), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
            isEmbeddedRoute: true,
            ...routeContext,
            ...props
        }))));
    };
    return ComponentWithEmbeddedPage;
};

// Route for embeddable request create page
const $b304f2423339d960$var$AsyncEmbedCreateRequestPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("iRBH4")), {
        moduleId: "./src/view/request-create-page/embed-request-create-page/index.tsx"
    })
});
const $b304f2423339d960$export$ed25ec64c8131f29 = ()=>({
        name: 'embed-request-create',
        path: `/embeds/portal/:portalId/create/:requestTypeId`,
        exact: true,
        component: (0, $lM7Z9.withRouter)($b304f2423339d960$export$2e9e2f006c89796d($b304f2423339d960$var$AsyncEmbedCreateRequestPage, (0, $748yq.ScreenName).EMBED_REQUEST_CREATE)),
        resources: (0, $bG6ob.isUiModificationsSupportEnabled)() && !(0, $6bGmX.default).checkGate('ditto_uim_root_query_rest') ? [
            (0, $cwZKZ.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE)
        ] : []
    });

// Route for embeddable single portal page
const $b304f2423339d960$var$AsyncEmbedSinglePortalPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("e8ktD")), {
        moduleId: "./src/view/help-center/help-center-content/embed-single-portal/index.tsx"
    })
});
const $b304f2423339d960$export$f8f6af866fe5eb29 = {
    name: 'embed-single-portal',
    path: `/embeds/portal/:portalId`,
    exact: true,
    component: (0, $lM7Z9.withRouter)($b304f2423339d960$export$2e9e2f006c89796d($b304f2423339d960$var$AsyncEmbedSinglePortalPage, (0, $748yq.ScreenName).EMBED_SINGLE_PORTAL))
};

// Route for embeddable knowledge base article page
const $b304f2423339d960$var$AsyncEmbedKBArticlePage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cnCIt")), {
        moduleId: "./src/view/article/embed-kb-article/index.tsx"
    })
});
const $b304f2423339d960$export$50b320f40299497c = {
    name: 'embed-kb-article',
    path: `/embeds/portal/:portalId/:topic?/:categoryId?/:article/:articleId`,
    exact: true,
    component: (0, $lM7Z9.withRouter)($b304f2423339d960$export$2e9e2f006c89796d($b304f2423339d960$var$AsyncEmbedKBArticlePage, (0, $748yq.ScreenName).EMBED_KB_ARTICLE))
};

// Route for embeddable featured portals page
const $b304f2423339d960$var$AsyncEmbedFeaturedPortalsPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("llkqV")), {
        moduleId: "./src/view/help-center/embed-featured-portals/index.tsx"
    })
});
const $b304f2423339d960$export$89cf0aa4f08ce120 = {
    name: 'embed-featured-portals',
    path: `/embeds/portals`,
    exact: true,
    component: (0, $lM7Z9.withRouter)($b304f2423339d960$export$2e9e2f006c89796d($b304f2423339d960$var$AsyncEmbedFeaturedPortalsPage, (0, $748yq.ScreenName).EMBED_FEATURED_PORTALS))
};

// Route for embedded login success page
const $b304f2423339d960$var$AsyncEmbedLoginSuccessPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("9ZkA0")), {
        moduleId: "./src/view/login/embed-login-success/index.tsx"
    })
});
const $b304f2423339d960$export$a493105cf7e63414 = {
    name: 'embed-login-success',
    path: `/embeds/login-success`,
    exact: true,
    component: (0, $lM7Z9.withRouter)($b304f2423339d960$export$2e9e2f006c89796d($b304f2423339d960$var$AsyncEmbedLoginSuccessPage, (0, $748yq.ScreenName).EMBED_LOGIN_SUCCESS))
};
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b304f2423339d960$var$EmbedComponentWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-168unha-0"
})`display:flex;flex-direction:column;min-height:100%;border:${$bpWyP.multiple(1 / 8).px} solid ${"var(--ds-border-bold, #EBECF0)"};border-radius:${$bpWyP.multiple(3 / 8).px};box-sizing:border-box;`;

});
parcelRegister("iRBH4", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1Habm").then(()=>parcelRequire('2OQXy'));

});

parcelRegister("e8ktD", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("fC1qB"),
    $e46AW("38x9B")
]).then(()=>parcelRequire('fd0fy'));

});

parcelRegister("cnCIt", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lUrX8").then(()=>parcelRequire('aPn3M'));

});

parcelRegister("llkqV", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("45caK"),
    $e46AW("6u9oa")
]).then(()=>parcelRequire('1uTS2'));

});

parcelRegister("9ZkA0", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("eTo26").then(()=>parcelRequire('djiDM'));

});


parcelRegister("18hBH", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterRoute", () => $f3692c76102ba276$export$4e7002b7e4a938bc);

var $748yq = parcelRequire("748yq");

var $bTtiN = parcelRequire("bTtiN");
const $f3692c76102ba276$export$4e7002b7e4a938bc = ()=>{
    const name = 'help-center';
    const path = '/portals';
    const screenName = (0, $748yq.ScreenName).HELP_CENTER;
    return (0, $bTtiN.getFlexiHelpCenterRoute)(name, path, screenName);
};

});

parcelRegister("9bbBv", function(module, exports) {
$parcel$export(module.exports, "viewKbPageRoute", () => $1148b96054979940$export$7770cb0c6ff06b3a);
$parcel$export(module.exports, "viewAllSearchResultsRoute", () => $1148b96054979940$export$b9392cfe93dd18c7);
$parcel$export(module.exports, "viewPortalAllSearchResultsRoute", () => $1148b96054979940$export$ecf8460d0ec6e97);
$parcel$export(module.exports, "viewPortalKnowledgeCategoryRoute", () => $1148b96054979940$export$4704dfed5640c7f);
$parcel$export(module.exports, "viewPortalCategoryArticleRoute", () => $1148b96054979940$export$c875ec1eb313d3e6);
$parcel$export(module.exports, "viewPortalArticleRoute", () => $1148b96054979940$export$ad9d4a1dd23783b4);
$parcel$export(module.exports, "viewArticleRoute", () => $1148b96054979940$export$95b4792c2f78259d);
$parcel$export(module.exports, "viewCrossSitePortalArticleRoute", () => $1148b96054979940$export$d549c8909c9cf794);
$parcel$export(module.exports, "viewCrossSiteArticleRoute", () => $1148b96054979940$export$10ea759d4b0b4d21);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");
var $lM7Z9 = parcelRequire("lM7Z9");

var $W39nK = parcelRequire("W39nK");
parcelRequire("VQKxQ");
var $6Wtq0 = parcelRequire("6Wtq0");

var $kRXI4 = parcelRequire("kRXI4");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");

var $3H4LK = parcelRequire("3H4LK");

var $eHkSG = parcelRequire("eHkSG");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");

const $1148b96054979940$var$AllSearchResultsV1 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("fAQfJ")), {
        moduleId: "./src/view/search/all-results/index.tsx"
    })
});

const $1148b96054979940$var$AllSearchResults = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("d1VDU")), {
        moduleId: "./packages/help-center/search/src/all-results/index.tsx"
    })
});
const $1148b96054979940$var$RenderKnowledgeCategoryRoute = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
        screenName: (0, $748yq.ScreenName).KNOWLEDGE_CATEGORY,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $4fqPo.createElement((0, $60sOE.default), {
        screenName: (0, $748yq.ScreenName).KNOWLEDGE_CATEGORY
    }, /*#__PURE__*/ $4fqPo.createElement((0, $kRXI4.KnowledgeCategory), routeContext)));
};
const $1148b96054979940$var$RenderArticlesSearchRoute = ()=>{
    const [routerState] = (0, $hfD9S.useRouter)();
    const { basePath: basePath, ...routeContext } = routerState;
    return /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
        screenName: (0, $748yq.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS,
        screenId: routeContext.match.url
    }, /*#__PURE__*/ $4fqPo.createElement((0, $60sOE.default), {
        screenName: (0, $748yq.ScreenName).KNOWLEDGE_ALL_SEARCH_RESULTS
    }, /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $6Wtq0.default), routeContext), (0, $3H4LK.fg)('helpcenter_search_api_changes') ? /*#__PURE__*/ $4fqPo.createElement($1148b96054979940$var$AllSearchResults, routeContext) : /*#__PURE__*/ $4fqPo.createElement($1148b96054979940$var$AllSearchResultsV1, routeContext))));
};
const $1148b96054979940$export$319de0a85a85b4cd = (isArticleView)=>{
    return isArticleView ? 'xxwide' : 'xwide';
};
const $1148b96054979940$var$viewKbPage = {
    resources: [],
    name: 'view-kb-page',
    path: '/kb/view/:pageId',
    exact: true,
    component: (0, $W39nK.Article)
};
const $1148b96054979940$var$portalKnowledgeCategory = {
    resources: [],
    name: 'view-portal-kb-category',
    path: `/portal/:portalId/topic/:categoryId`,
    exact: true,
    component: $1148b96054979940$var$RenderKnowledgeCategoryRoute
};
const $1148b96054979940$var$viewPortalCategoryArticle = {
    resources: [],
    name: 'view-portal-kb-category-article',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/topic/:categoryId/article/:articleId`,
    exact: true,
    component: (0, $W39nK.Article)
};
const $1148b96054979940$var$viewPortalArticle = {
    resources: [],
    name: 'view-portal-kb-article',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
    exact: true,
    component: (0, $W39nK.Article)
};
const $1148b96054979940$var$viewArticle = {
    resources: [],
    name: 'view-kb-article',
    path: `/article/:articleId`,
    exact: true,
    component: (0, $W39nK.Article)
};
const $1148b96054979940$var$viewCrossSitePortalArticle = {
    resources: [],
    name: 'view-portal-cross-site-kb-article',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $W39nK.Article)
};
const $1148b96054979940$var$viewCrossSiteArticle = {
    resources: [],
    name: 'view-kb-cross-site-article',
    path: `/cloudId/:cloudId/article/:articleId`,
    exact: true,
    component: (0, $W39nK.Article)
};
const $1148b96054979940$var$viewAllSearchResults = {
    resources: [],
    name: 'view-all-search-results',
    path: `/articles/search`,
    exact: true,
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration,@atlaskit/platform/no-module-level-eval
    component: (0, $3H4LK.fg)('helpcenter_search_api_changes') ? $1148b96054979940$var$AllSearchResults : $1148b96054979940$var$AllSearchResultsV1
};
const $1148b96054979940$var$viewPortalAllSearchResults = {
    resources: [],
    name: 'view-portal-all-search-results',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/articles/search`,
    exact: true,
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration,@atlaskit/platform/no-module-level-eval
    component: (0, $3H4LK.fg)('helpcenter_search_api_changes') ? $1148b96054979940$var$AllSearchResults : $1148b96054979940$var$AllSearchResultsV1
};
const $1148b96054979940$var$categoryLayoutProps = {
    paperAppearance: $1148b96054979940$export$319de0a85a85b4cd(false),
    fadeInSearchModal: true
};
const $1148b96054979940$var$layoutProps = {
    paperAppearance: $1148b96054979940$export$319de0a85a85b4cd(true),
    fadeInSearchModal: true
};
const $1148b96054979940$export$7770cb0c6ff06b3a = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$viewKbPage, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $1148b96054979940$var$layoutProps);
const $1148b96054979940$export$b9392cfe93dd18c7 = {
    ...$1148b96054979940$var$viewAllSearchResults,
    component: (0, $lM7Z9.withRouter)($1148b96054979940$var$RenderArticlesSearchRoute)
};
const $1148b96054979940$export$ecf8460d0ec6e97 = {
    ...$1148b96054979940$var$viewPortalAllSearchResults,
    component: (0, $lM7Z9.withRouter)($1148b96054979940$var$RenderArticlesSearchRoute)
};
const $1148b96054979940$export$4704dfed5640c7f = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$portalKnowledgeCategory, (0, $748yq.ScreenName).KNOWLEDGE_CATEGORY, $1148b96054979940$var$categoryLayoutProps);
const $1148b96054979940$export$c875ec1eb313d3e6 = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$viewPortalCategoryArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $1148b96054979940$var$layoutProps);
const $1148b96054979940$export$ad9d4a1dd23783b4 = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$viewPortalArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $1148b96054979940$var$layoutProps);
const $1148b96054979940$export$95b4792c2f78259d = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$viewArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $1148b96054979940$var$layoutProps);
const $1148b96054979940$export$d549c8909c9cf794 = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$viewCrossSitePortalArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $1148b96054979940$var$layoutProps);
const $1148b96054979940$export$10ea759d4b0b4d21 = (0, $bp9tj.createRouteWithLayout)($1148b96054979940$var$viewCrossSiteArticle, (0, $748yq.ScreenName).KNOWLEDGE_ARTICLE, $1148b96054979940$var$layoutProps);

});
parcelRegister("W39nK", function(module, exports) {
$parcel$export(module.exports, "Article", () => $2361ea4aaf6fe756$export$89693000420c0acd);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $2361ea4aaf6fe756$export$89693000420c0acd = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("51B5m")), {
        moduleId: "./src/view/article/hocs.tsx"
    })
});

});
parcelRegister("51B5m", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("2dP4h"),
    $e46AW("8nKoT")
]).then(()=>parcelRequire('3yinQ'));

});


parcelRegister("kRXI4", function(module, exports) {
$parcel$export(module.exports, "KnowledgeCategory", () => $b0ec2027ddfa5b8e$export$b0a220e8bdf61c72);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $6bGmX = parcelRequire("6bGmX");

var $5s0wd = parcelRequire("5s0wd");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("6wpg8");
var $8NDRb = parcelRequire("8NDRb");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $5Lnit = parcelRequire("5Lnit");
const $b0ec2027ddfa5b8e$var$mapStateToProps = (state, props)=>{
    let portalId;
    let categoryId;
    if (props.match.params) {
        portalId = Number(props.match.params.portalId);
        categoryId = props.match.params.categoryId;
    }
    const showRequestCreateButton = (0, $95tqy.canCreateRequest)(state, portalId);
    const portal = (0, $95tqy.getPortalOrError)(state, portalId);
    const portalName = (0, $95tqy.getName)(state, portalId);
    const projectId = (0, $95tqy.getProjectId)(state, portalId);
    const shouldFetchPortalOnMount = !portal;
    const portalLink = (0, $95tqy.getPortalLink)(state, portalId);
    const categoryOrError = (0, $95tqy.getCategory)(state, portalId, categoryId);
    const articlesOrError = (0, $8NDRb.getArticles)(state, categoryId);
    const category = !!categoryOrError && 'name' in categoryOrError ? categoryOrError : undefined;
    // we show a different loading spinner specifically for articles,
    // this way we can still display the user the category information and the bread-crumbs as soon as we have that data
    const isArticlesLoading = !articlesOrError;
    const portalError = !!portal && 'error' in portal ? portal : undefined;
    const articleFetchError = !!articlesOrError && 'error' in articlesOrError ? articlesOrError : undefined;
    let error;
    if (!!portalError) error = portalError;
    // any errors that occur when fetching categories will be available in articleFetchError
    // as the two calls are combined on initial page load
    if (!!articleFetchError && !isArticlesLoading) error = articleFetchError;
    const portalOnlyPageLoading = (0, $6bGmX.default).checkGate('help_center_kb_category_page_portal_only_loading');
    let isLoading = !portal || !categoryOrError && !error;
    if (portalOnlyPageLoading) isLoading = !portal;
    const articles = Array.isArray(articlesOrError) ? articlesOrError : undefined;
    return {
        portalId: portalId,
        categoryId: categoryId,
        projectId: projectId,
        category: category,
        articles: articles,
        portalName: portalName,
        isLoading: isLoading,
        isArticlesLoading: isArticlesLoading,
        shouldFetchPortalOnMount: shouldFetchPortalOnMount,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        error: error ? error.error : undefined
    };
};
const $b0ec2027ddfa5b8e$export$b0a220e8bdf61c72 = (0, $bmgw6.default)($b0ec2027ddfa5b8e$var$mapStateToProps, {
    fetchPortal: (0, $lXazD.fetchPortalAction),
    fetchArticles: (0, $5s0wd.fetchArticlesAction)
})((0, $5Lnit.default));

});
parcelRegister("6wpg8", function(module, exports) {
$parcel$export(module.exports, "getArticle", () => (parcelRequire("8NDRb")).getArticle);
$parcel$export(module.exports, "getArticles", () => (parcelRequire("8NDRb")).getArticles);
$parcel$export(module.exports, "getArticleTitle", () => (parcelRequire("8NDRb")).getArticleTitle);
parcelRequire("8NDRb");

});
parcelRegister("8NDRb", function(module, exports) {
$parcel$export(module.exports, "getArticles", () => $5d5afe6daa2850e6$export$59baee6c0c5ecafe);
$parcel$export(module.exports, "getArticle", () => $5d5afe6daa2850e6$export$f8c0d0a39b0d7d4e);
$parcel$export(module.exports, "getArticleTitle", () => $5d5afe6daa2850e6$export$7aa4b20764201f2f);
const $5d5afe6daa2850e6$export$59baee6c0c5ecafe = (state, categoryId)=>{
    if (!categoryId) return undefined;
    const articleState = state.persisted.kbArticles;
    if (articleState.articles[categoryId] && articleState.articles[categoryId].error) return articleState.articles[categoryId].error;
    return articleState.articles[categoryId] ? articleState.articles[categoryId].articles : undefined;
};
const $5d5afe6daa2850e6$export$f8c0d0a39b0d7d4e = (state, id)=>!!id ? state.persisted.kbArticles.legacyArticles[id] : undefined;
const $5d5afe6daa2850e6$export$7aa4b20764201f2f = (state, id)=>{
    const article = $5d5afe6daa2850e6$export$f8c0d0a39b0d7d4e(state, id);
    if (!article || 'error' in article) return undefined;
    return article.title;
};

});


parcelRegister("5Lnit", function(module, exports) {
$parcel$export(module.exports, "default", () => $f24b9ade6f87e003$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $9Ut8d = parcelRequire("9Ut8d");

var $MM3bs = parcelRequire("MM3bs");

var $efDRU = parcelRequire("efDRU");
parcelRequire("8dHmf");
var $9tNgd = parcelRequire("9tNgd");
parcelRequire("63kyL");
var $2TkKH = parcelRequire("2TkKH");
parcelRequire("b0F8E");
var $awGaB = parcelRequire("awGaB");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $54jwS = parcelRequire("54jwS");
parcelRequire("djvS4");
var $c593E = parcelRequire("c593E");

var $e3UHj = parcelRequire("e3UHj");
class $f24b9ade6f87e003$export$b0a220e8bdf61c72 extends $4fqPo.Component {
    componentDidMount() {
        const { shouldFetchPortalOnMount: shouldFetchPortalOnMount, fetchPortal: fetchPortal, fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        if (shouldFetchPortalOnMount && portalId) fetchPortal({
            id: portalId,
            expand: [
                'reqTypes',
                'reqGroups',
                'orderMapping',
                'kbs'
            ]
        });
        if (portalId && projectId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { fetchArticles: fetchArticles, portalId: portalId, projectId: projectId, categoryId: categoryId, category: category } = this.props;
        const shouldFetchArticles = !prevProps.projectId && projectId;
        if (shouldFetchArticles && projectId && portalId && categoryId) {
            const meta = this.getFailureAnalyticsEvent();
            fetchArticles({
                projectId: projectId,
                portalId: portalId,
                categoryId: categoryId,
                meta: meta,
                categoryDataRequired: !category
            });
        }
    }
    renderInnerContent() {
        const { category: category, articles: articles, portalId: portalId, isArticlesLoading: isArticlesLoading, portalName: portalName, portalLink: portalLink, showRequestCreateButton: showRequestCreateButton } = this.props;
        if (!category || !portalId || !portalName) return null;
        const attributes = (articles || []).reduce((attr, article)=>({
                featured: attr.featured + (article.isFeatured ? 1 : 0),
                total: attr.total + 1
            }), {
            featured: 0,
            total: 0
        });
        return /*#__PURE__*/ $4fqPo.createElement((0, $54jwS.AnalyticsContext), {
            attributes: attributes
        }, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.PaperContent), null, /*#__PURE__*/ $4fqPo.createElement((0, $2TkKH.default), {
            subHeading: category.name,
            description: category.description,
            portalId: portalId,
            categoryId: category.id
        }), /*#__PURE__*/ $4fqPo.createElement((0, $c593E.default), {
            portalLink: portalLink,
            portalId: portalId,
            portalName: portalName,
            categoryId: category.id,
            articles: articles,
            showRequestCreateButton: showRequestCreateButton,
            isLoading: isArticlesLoading
        })));
    }
    render() {
        const { category: category, portalName: portalName, intl: intl, isLoading: isLoading } = this.props;
        const pageTitle = category && portalName ? intl.formatMessage((0, $e3UHj.default).categoryDocumentTitle, {
            portalName: portalName,
            categoryName: category.name
        }) : undefined;
        return /*#__PURE__*/ $4fqPo.createElement((0, $9Ut8d.default), {
            title: pageTitle
        }, /*#__PURE__*/ $4fqPo.createElement((0, $9tNgd.default), {
            isLoading: isLoading
        }, this.renderInnerContent()));
    }
    constructor(...args){
        super(...args), this.getFailureAnalyticsEvent = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'articlesFetch failed',
                    analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE)
                })
            };
        };
    }
}
var $f24b9ade6f87e003$export$2e2bcd8739ae039 = (0, $MM3bs.withErrorPage)((0, $efDRU.default)((0, $apbG6.default)({
    componentName: 'KbCategory'
})((0, $as4kh.default)()($f24b9ade6f87e003$export$b0a220e8bdf61c72))));

});
parcelRegister("8dHmf", function(module, exports) {
$parcel$export(module.exports, "LoadingContainer", () => (parcelRequire("9tNgd")).default);

var $9tNgd = parcelRequire("9tNgd");

});
parcelRegister("9tNgd", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc8db7446a76a8c5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bvB7a = parcelRequire("bvB7a");

var $cijxS = parcelRequire("cijxS");
class $dc8db7446a76a8c5$export$2e2bcd8739ae039 extends $4fqPo.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, interactionName: interactionName, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const loader = /*#__PURE__*/ $4fqPo.createElement((0, $bvB7a.default), {
            isLoading: true,
            loadingPosition: loadingPosition,
            interactionName: interactionName
        });
        if (!isLoading) return children;
        return enableUFOHold ? /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
            name: ufoHoldName
        }, loader) : loader;
    }
}

});


parcelRegister("63kyL", function(module, exports) {
$parcel$export(module.exports, "PaperHeader", () => (parcelRequire("2TkKH")).default);

var $2TkKH = parcelRequire("2TkKH");

});
parcelRegister("2TkKH", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7d8c12b643f5278$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $a3bgj = parcelRequire("a3bgj");
parcelRequire("TJzAt");
var $3EXrJ = parcelRequire("3EXrJ");

var $bIaqo = parcelRequire("bIaqo");

var $2eKV2 = parcelRequire("2eKV2");

var $fwSzd = parcelRequire("fwSzd");
const $a7d8c12b643f5278$var$headerDescription = (description, dangerouslyAllowHtmlInDescription)=>dangerouslyAllowHtmlInDescription ? /*#__PURE__*/ $4fqPo.createElement((0, $bIaqo.Description), {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }) : /*#__PURE__*/ $4fqPo.createElement((0, $bIaqo.Description), null, description);
const $a7d8c12b643f5278$var$PaperHeader = ({ subHeading: subHeading, description: description, logoUrl: logoUrl, showRequestsInBreadcrumbs: showRequestsInBreadcrumbs, dangerouslyAllowHtmlInDescription: dangerouslyAllowHtmlInDescription, dataTestId: dataTestId, ...props })=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": dataTestId
    }, /*#__PURE__*/ $4fqPo.createElement((0, $3EXrJ.default), {
        ...props,
        showRequests: showRequestsInBreadcrumbs
    }), /*#__PURE__*/ $4fqPo.createElement((0, $bIaqo.SubHeadingContainer), null, !!logoUrl && /*#__PURE__*/ $4fqPo.createElement((0, $bIaqo.IconContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $a3bgj.default), {
        src: logoUrl,
        alt: ""
    })), /*#__PURE__*/ $4fqPo.createElement("div", null, /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
            size: "large",
            as: "h1"
        }, subHeading)
    }, /*#__PURE__*/ $4fqPo.createElement((0, $bIaqo.SubHeading), null, subHeading)))), !!description && $a7d8c12b643f5278$var$headerDescription(description, dangerouslyAllowHtmlInDescription));
};
var $a7d8c12b643f5278$export$2e2bcd8739ae039 = $a7d8c12b643f5278$var$PaperHeader;

});
parcelRegister("TJzAt", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbs", () => (parcelRequire("3EXrJ")).default);

var $3EXrJ = parcelRequire("3EXrJ");

});
parcelRegister("3EXrJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $29b1737508117efd$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $ibOOf = parcelRequire("ibOOf");
parcelRequire("2tSqN");
var $fdC0k = parcelRequire("fdC0k");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("6wpg8");
var $8NDRb = parcelRequire("8NDRb");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $2jpwX = parcelRequire("2jpwX");
parcelRequire("1SoOQ");
var $c9iAO = parcelRequire("c9iAO");
const $29b1737508117efd$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getSharedPortalName), (state, props)=>{
    return (0, $95tqy.getName)(state, (0, $2jpwX.toNumber)(props.portalId)) ?? (0, $fdC0k.getPortalNameFromBranding)(state);
}, (state, props)=>{
    const category = (0, $95tqy.getCategory)(state, (0, $2jpwX.toNumber)(props.portalId), props.categoryId);
    return !!category && 'name' in category ? category.name : undefined;
}, (state, props)=>{
    return (0, $8NDRb.getArticleTitle)(state, props.articleId);
}, (sharedPortalName, portalName, categoryName, articleTitle)=>({
        sharedPortalName: sharedPortalName,
        portalName: portalName,
        categoryName: categoryName,
        articleTitle: articleTitle
    }));
const $29b1737508117efd$export$5646050d516e06bc = (0, $bmgw6.default)($29b1737508117efd$var$selector)((0, $c9iAO.default));
var $29b1737508117efd$export$2e2bcd8739ae039 = (0, $ibOOf.default)($29b1737508117efd$export$5646050d516e06bc);

});
parcelRegister("2tSqN", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => (parcelRequire("fdC0k")).getPortalNameFromBranding);

var $fdC0k = parcelRequire("fdC0k");

});
parcelRegister("fdC0k", function(module, exports) {
$parcel$export(module.exports, "getPortalNameFromBranding", () => $281b533a21168f9a$export$b81ba060d3a3afb3);
const $281b533a21168f9a$export$b81ba060d3a3afb3 = (state)=>{
    var _state$persisted$bran;
    if ((_state$persisted$bran = state.persisted.branding) !== null && _state$persisted$bran !== void 0 && _state$persisted$bran.name) return state.persisted.branding.name;
    return undefined;
};

});


parcelRegister("1SoOQ", function(module, exports) {
$parcel$export(module.exports, "BreadCrumbsDumb", () => (parcelRequire("c9iAO")).default);

var $c9iAO = parcelRequire("c9iAO");

});
parcelRegister("c9iAO", function(module, exports) {
$parcel$export(module.exports, "default", () => $5e4753d00521132b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $as21I = parcelRequire("as21I");

var $efDRU = parcelRequire("efDRU");

var $ex668 = parcelRequire("ex668");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $Y85G3 = parcelRequire("Y85G3");

var $7wou4 = parcelRequire("7wou4");
const $5e4753d00521132b$export$a1a3354a8b2c8731 = ({ sharedPortalName: sharedPortalName, portalName: portalName, categoryName: categoryName, articleTitle: articleTitle, portalId: portalId, categoryId: categoryId, articleId: articleId, showRequests: showRequests, intl: intl, requestKey: requestKey, requestUrl: requestUrl, additionalBreadCrumbs: additionalBreadCrumbs })=>{
    const requestCreateBreadcrumb = showRequests ? intl.formatMessage((0, $7wou4.default).raiseRequestBreadcrumb) : undefined;
    const isCSM = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    return /*#__PURE__*/ $4fqPo.createElement((0, $ex668.default), {
        label: intl.formatMessage((0, $7wou4.default).breadcrumbsLabel)
    }, /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        to: (0, $Y85G3.getHelpCenterUrl)(),
        name: !isCSM ? sharedPortalName : intl.formatMessage((0, $7wou4.default).breadcrumbsHome),
        isFirstCrumb: true,
        actionSubjectId: "helpCenterBreadcrumb"
    }, !isCSM && portalId !== undefined && // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
    /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        to: `/portal/${portalId}`,
        name: portalName,
        actionSubjectId: "portalBreadcrumb"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        to: requestUrl || '',
        name: requestKey,
        actionSubjectId: "requestBreadcrumb",
        testId: "requestKey"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        to: `/portal/${portalId}/group/-1`,
        name: requestCreateBreadcrumb,
        actionSubjectId: "requestCreateBreadcrumb"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}`,
        name: categoryName,
        actionSubjectId: "categoryBreadcrumb"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/topic/${categoryId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        to: `/portal/${portalId}/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $as21I.default), {
        to: `/article/${articleId}`,
        name: articleTitle,
        actionSubjectId: "articleBreadcrumb"
    }), additionalBreadCrumbs === null || additionalBreadCrumbs === void 0 ? void 0 : additionalBreadCrumbs.map((breadCrumb)=>breadCrumb)));
};
var $5e4753d00521132b$export$2e2bcd8739ae039 = (0, $efDRU.default)($5e4753d00521132b$export$a1a3354a8b2c8731);

});
parcelRegister("as21I", function(module, exports) {
$parcel$export(module.exports, "default", () => $9841f926b68e185f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eiGUu = parcelRequire("eiGUu");

var $1P8FK = parcelRequire("1P8FK");

var $c8Rqg = parcelRequire("c8Rqg");

var $4W9tu = parcelRequire("4W9tu");

var $8Gf3q = parcelRequire("8Gf3q");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $fwSzd = parcelRequire("fwSzd");
/**
 * This is a nestable bread crumb component, it will render the first component with a valid name.
 * It itself will also not render if the name is not valid.
 */ const $9841f926b68e185f$var$BreadCrumbDumb = ({ name: name, to: to, children: children, isFirstCrumb: isFirstCrumb, actionSubjectId: actionSubjectId, testId: testId, tabIndex: tabIndex, onClick: onClick, disableTheme: disableTheme = false })=>{
    const isCSMTypographyMigrationEnabled = (0, $fwSzd.useIsCSMTypographyMigrationEnabled)();
    if (!name) return null;
    let child;
    $4fqPo.Children.forEach(children, (element)=>{
        // Short circuit if there is already a match
        if (child) return;
        if (element && /*#__PURE__*/ $4fqPo.isValidElement(element)) {
            const { name: childName } = element.props;
            if (childName) child = element;
        }
    });
    let linkComponent;
    if (to.startsWith('/')) {
        let RootLinkComponent = disableTheme ? $9841f926b68e185f$var$RootLinkDisabledTheme : $9841f926b68e185f$var$RootLink;
        if (isCSMTypographyMigrationEnabled) RootLinkComponent = disableTheme ? $9841f926b68e185f$var$RootLinkDisabledTheme : $9841f926b68e185f$var$RootLinkWithToken;
        linkComponent = /*#__PURE__*/ $4fqPo.createElement(RootLinkComponent, {
            to: to,
            actionSubjectId: actionSubjectId,
            "data-test-id": testId,
            "aria-current": child ? 'false' : 'page',
            tabIndex: tabIndex,
            onClick: onClick
        }, name);
    } else {
        let ExternalLinkComponent = disableTheme ? $9841f926b68e185f$var$ExternalLinkDisabledTheme : $9841f926b68e185f$var$ExternalLink;
        if (isCSMTypographyMigrationEnabled) ExternalLinkComponent = disableTheme ? $9841f926b68e185f$var$ExternalLinkDisabledTheme : $9841f926b68e185f$var$ExternalLinkWithToken;
        const externalLinkProps = {
            tabIndex: tabIndex,
            actionSubjectId: actionSubjectId,
            onClick: onClick,
            href: to,
            'data-test-id': testId,
            'aria-current': child ? 'false' : 'page'
        };
        linkComponent = /*#__PURE__*/ $4fqPo.createElement(ExternalLinkComponent, externalLinkProps, name);
    }
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        as: 'li',
        xcss: [
            $9841f926b68e185f$var$breadCrumbContainer,
            isFirstCrumb ? undefined : $9841f926b68e185f$var$breadCrumbSeparator
        ]
    }, linkComponent), child);
};
var $9841f926b68e185f$export$2e2bcd8739ae039 = $9841f926b68e185f$var$BreadCrumbDumb;
const $9841f926b68e185f$var$breadCrumbContainer = (0, $2m8U6.xcss)({
    display: 'flex',
    listStyle: 'none',
    alignItems: 'center',
    margin: 'space.0'
});
const $9841f926b68e185f$var$breadCrumbSeparator = (0, $2m8U6.xcss)({
    '::before': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: 'space.0',
        paddingInline: 'space.075',
        textAlign: 'center',
        lineHeight: '1.5em',
        color: 'color.text'
    }
});
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9841f926b68e185f$var$RootLink = /*#__PURE__*/ (0, $el3DQ.default)((0, $8Gf3q.default)).withConfig({
    componentId: "sc-1t2enhc-0"
})`${$4W9tu.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9841f926b68e185f$var$RootLinkWithToken = /*#__PURE__*/ (0, $el3DQ.default)((0, $8Gf3q.default)).withConfig({
    componentId: "sc-1t2enhc-1"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9841f926b68e185f$var$ExternalLink = /*#__PURE__*/ (0, $el3DQ.default)((0, $c8Rqg.default)).withConfig({
    componentId: "sc-1t2enhc-2"
})`${$4W9tu.h200};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9841f926b68e185f$var$ExternalLinkWithToken = /*#__PURE__*/ (0, $el3DQ.default)((0, $c8Rqg.default)).withConfig({
    componentId: "sc-1t2enhc-3"
})`font:${"var(--ds-font-body, normal 400 0.875rem/1.25rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $9841f926b68e185f$var$RootLinkDisabledTheme = /*#__PURE__*/ (0, $el3DQ.default)((0, $1P8FK.Link)).withConfig({
    componentId: "sc-1t2enhc-4"
})`margin:0;color:unset !important;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled
const $9841f926b68e185f$var$ExternalLinkDisabledTheme = /*#__PURE__*/ (0, $el3DQ.default)((0, $eiGUu.HtmlAnchor)).withConfig({
    componentId: "sc-1t2enhc-5"
})`margin:0;color:unset !important;`;

});
parcelRegister("c8Rqg", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdf995409b9dd7f0$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $eiGUu = parcelRequire("eiGUu");
const $bdf995409b9dd7f0$export$1d567c320f4763bc = /*#__PURE__*/ (0, $el3DQ.css)`color:${(props)=>`var(--ds-link, ${props.theme.color})`};&:hover{color:${(props)=>`var(--ds-link, ${props.theme.color})`};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $bdf995409b9dd7f0$var$ExternalThemedLink = /*#__PURE__*/ (0, $el3DQ.default)((0, $eiGUu.HtmlAnchor)).withConfig({
    componentId: "sc-ckmeb1-0"
})`${$bdf995409b9dd7f0$export$1d567c320f4763bc};`;
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Disabled to rollout go/ui-styling-standard tooling, please resolve
$bdf995409b9dd7f0$export$2e2bcd8739ae039 = $bdf995409b9dd7f0$var$ExternalThemedLink;

});


parcelRegister("ex668", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e6e396b78fc129f$export$2e2bcd8739ae039);
/* breadcrumbs.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $5wgou = parcelRequire("5wgou");

var $c1tmZ = parcelRequire("c1tmZ");

var $7OrJ6 = parcelRequire("7OrJ6");

var $ew8ze = parcelRequire("ew8ze");
const $2e6e396b78fc129f$var$defaultMaxItems = 8;
const $2e6e396b78fc129f$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $2e6e396b78fc129f$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $2e6e396b78fc129f$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children;
const $2e6e396b78fc129f$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: undefined,
    packageVersion: undefined
};
const $2e6e396b78fc129f$var$noop = (0, $c1tmZ.default);
const $2e6e396b78fc129f$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $2e6e396b78fc129f$var$breadcrumbStyles = null;
const $2e6e396b78fc129f$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $2e6e396b78fc129f$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $2e6e396b78fc129f$var$noop, analyticsContext: analyticsContext, label: label = $2e6e396b78fc129f$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $2e6e396b78fc129f$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $4fqPo.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $4fqPo.useState)(false);
    const wrapperRef = (0, $4fqPo.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $2e6e396b78fc129f$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $4fqPo.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($2e6e396b78fc129f$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $ew8ze.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$2e6e396b78fc129f$var$analyticsAttributes
    });
    const childrenArray = $2e6e396b78fc129f$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7OrJ6.default), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("nav", {
        "aria-label": label,
        ref: (0, $5wgou.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("ol", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1n261g80 _syaz1rpy _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t"
        ])
    }, breadcrumbsItems));
});
const $2e6e396b78fc129f$var$Breadcrumbs = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2e6e396b78fc129f$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        ref: ref,
        testId: testId
    })));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2e6e396b78fc129f$export$2e2bcd8739ae039 = $2e6e396b78fc129f$var$Breadcrumbs;

});
parcelRegister("7OrJ6", function(module, exports) {
$parcel$export(module.exports, "default", () => $493837896e4e4bf6$export$2e2bcd8739ae039);
/* ellipsis-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $c1tmZ = parcelRequire("c1tmZ");

var $iqiKs = parcelRequire("iqiKs");
const $493837896e4e4bf6$var$noop = (0, $c1tmZ.default);
const $493837896e4e4bf6$var$itemWrapperStyles = null;
const $493837896e4e4bf6$var$styles = {
    root: "_11c8fhey _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _zulp1b66 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _bfhksm61 _syaz1rpy _1e0c116y _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1rpy _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31rpy _9h8hi7uo"
};
const $493837896e4e4bf6$var$EllipsisItem = /*#__PURE__*/ (0, $4fqPo.memo)(({ label: label, onClick: onClick = $493837896e4e4bf6$var$noop, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("li", {
        className: (0, $ltgDR.default)([
            "_1e0c1txw _vchhusvi _p12f1osq _4t3iubh0 _2lx2vrvc _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _5nddv77o _1j1pu2gc _1dsou2gc _toskidpf _15621n76 _191d1h6o"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $iqiKs.default), {
        "aria-label": label,
        onClick: onClick,
        xcss: $493837896e4e4bf6$var$styles.root,
        testId: testId
    }, "\u2026")));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$493837896e4e4bf6$export$2e2bcd8739ae039 = $493837896e4e4bf6$var$EllipsisItem;

});

parcelRegister("ew8ze", function(module, exports) {
$parcel$export(module.exports, "useOnRevealed", () => $f8718d977a6b9542$export$e9c4922b2ecf808a);

var $4fqPo = parcelRequire("4fqPo");

var $3kJNY = parcelRequire("3kJNY");
function $f8718d977a6b9542$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $3kJNY.default)(isExpanded);
    (0, $4fqPo.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});


parcelRegister("7wou4", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d18f1fd29d38f53$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $8d18f1fd29d38f53$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    breadcrumbsLabel: {
        id: 'cv.portal.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'The accessible label for the breadcrumb navigation container shown at the top of the portal page.'
    },
    raiseRequestBreadcrumb: {
        defaultMessage: 'Raise a request',
        description: 'Breadcrumb item to go to select a request group of a portal',
        id: 'cv.portal.breadcrumbs.raise.request'
    },
    breadcrumbsHome: {
        defaultMessage: 'Home',
        description: 'Generic label for the first entry of the breadcrumbs for Service hub',
        id: 'cv.portal.breadcrumbs.home'
    }
});

});





parcelRegister("bIaqo", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $28ece38ceaeeff49$export$8f314e512d92575f);
$parcel$export(module.exports, "SubHeadingContainer", () => $28ece38ceaeeff49$export$c8db0106bd269e8c);
$parcel$export(module.exports, "SubHeading", () => $28ece38ceaeeff49$export$210dc657affc8afd);
$parcel$export(module.exports, "Description", () => $28ece38ceaeeff49$export$393edc798c47379d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $2xGi5 = parcelRequire("2xGi5");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");
const $28ece38ceaeeff49$var$ICON_SIZE_MOBILE = $bpWyP.multiple(4.5).unitless;
const $28ece38ceaeeff49$var$ICON_SIZE_DESKTOP = $bpWyP.multiple(6.25).unitless;
const $28ece38ceaeeff49$var$MARGIN_RIGHT = "var(--ds-space-200, 16px)";
const $28ece38ceaeeff49$var$SUBHEADING_MARGIN_TOP_MOBILE = "var(--ds-space-200, 16px)";
const $28ece38ceaeeff49$var$SUBHEADING_MARGIN_TOP_DESKTOP = "var(--ds-space-100, 8px)";
const $28ece38ceaeeff49$var$DESCRIPTION_MARGIN_TOP_MOBILE = "var(--ds-space-100, 8px)";
const $28ece38ceaeeff49$export$8f314e512d92575f = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-69w8vc-0"
})`${$iSWaE.flexCenter};height:${$28ece38ceaeeff49$var$ICON_SIZE_MOBILE}px;width:${$28ece38ceaeeff49$var$ICON_SIZE_MOBILE}px;margin-right:${$28ece38ceaeeff49$var$MARGIN_RIGHT};flex-shrink:0;${$2xGi5.fromXSmall.css`
        height: ${$28ece38ceaeeff49$var$ICON_SIZE_DESKTOP}px;
        width: ${$28ece38ceaeeff49$var$ICON_SIZE_DESKTOP}px;
    `};`;
const $28ece38ceaeeff49$export$c8db0106bd269e8c = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-69w8vc-1"
})`display:flex;justify-content:flex-start;align-items:center;margin-top:${$28ece38ceaeeff49$var$SUBHEADING_MARGIN_TOP_MOBILE};${$2xGi5.fromXSmall.css`
        margin-top: ${$28ece38ceaeeff49$var$SUBHEADING_MARGIN_TOP_DESKTOP};
    `};`;
const $28ece38ceaeeff49$export$210dc657affc8afd = /*#__PURE__*/ (0, $el3DQ.default).h1.withConfig({
    componentId: "sc-69w8vc-2"
})`${$4W9tu.h700};${$iSWaE.breakWord};margin:0;`;
const $28ece38ceaeeff49$export$393edc798c47379d = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-69w8vc-3"
})`display:block;color:${"var(--ds-text, #172B4D)"};margin-top:${$28ece38ceaeeff49$var$DESCRIPTION_MARGIN_TOP_MOBILE};width:100%;`;

});



parcelRegister("djvS4", function(module, exports) {
$parcel$export(module.exports, "ArticleList", () => (parcelRequire("c593E")).default);

var $c593E = parcelRequire("c593E");

});
parcelRegister("c593E", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bcb3ae0a781a350$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $8Gf3q = parcelRequire("8Gf3q");

var $5Uaxl = parcelRequire("5Uaxl");
parcelRequire("hy5Bl");
var $dkLWp = parcelRequire("dkLWp");
parcelRequire("8dHmf");
var $9tNgd = parcelRequire("9tNgd");
parcelRequire("4b5rY");
var $annK7 = parcelRequire("annK7");

var $fFB0R = parcelRequire("fFB0R");

var $WVSzu = parcelRequire("WVSzu");
parcelRequire("7OcIi");
var $8LcMX = parcelRequire("8LcMX");

var $hZJtW = parcelRequire("hZJtW");
const $1bcb3ae0a781a350$export$cf74bb99f97bf995 = (portalId, categoryId, articles, opts)=>{
    return /*#__PURE__*/ $4fqPo.createElement("section", null, opts.showHeading && /*#__PURE__*/ $4fqPo.createElement($1bcb3ae0a781a350$export$72d7ca7a5d1d4807, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), opts.isFeatured ? (0, $hZJtW.default).featuredArticlesHeading : (0, $hZJtW.default).moreArticlesHeading)), /*#__PURE__*/ $4fqPo.createElement($1bcb3ae0a781a350$export$9d0ad9ba52d8bb58, null, articles.map((article)=>{
        const { title: title, summaryExcerpt: summaryExcerpt, id: articleId } = article;
        return /*#__PURE__*/ $4fqPo.createElement((0, $8LcMX.default), {
            portalId: portalId,
            categoryId: categoryId,
            articleId: articleId,
            key: articleId,
            title: title,
            summaryExcerpt: summaryExcerpt,
            isFeatured: opts.isFeatured
        });
    })));
};
/**
 * ArticleList comes with forced top margin because of the featured vs. non featured articles
 * groupings. Take this into consideration when using in places no under knowledge category page.
 */ const $1bcb3ae0a781a350$var$ArticleList = ({ articles: articles, portalName: portalName, portalId: portalId, portalLink: portalLink, categoryId: categoryId, showRequestCreateButton: showRequestCreateButton, isLoading: isLoading })=>{
    const featuredArticles = articles ? articles.filter((article)=>article.isFeatured) : [];
    const regularArticles = articles ? articles.filter((article)=>!article.isFeatured) : [];
    const hasRegularArticles = regularArticles.length > 0;
    const hasFeaturedArticles = featuredArticles.length > 0;
    const hasAnyArticles = hasRegularArticles || hasFeaturedArticles;
    const containerHasExtraMargin = hasRegularArticles && hasFeaturedArticles || !hasAnyArticles;
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: {
            attributes: {
                numberOfArticles: articles && articles.length
            }
        }
    }, /*#__PURE__*/ $4fqPo.createElement($1bcb3ae0a781a350$export$79927783e7566f41, {
        marginTop: containerHasExtraMargin
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9tNgd.default), {
        isLoading: isLoading,
        loadingPosition: "fill-container"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), hasFeaturedArticles && $1bcb3ae0a781a350$export$cf74bb99f97bf995(portalId, categoryId, featuredArticles, {
        isFeatured: true,
        showHeading: hasRegularArticles
    }), hasRegularArticles && $1bcb3ae0a781a350$export$cf74bb99f97bf995(portalId, categoryId, regularArticles, {
        isFeatured: false,
        showHeading: hasFeaturedArticles
    }), !hasAnyArticles && /*#__PURE__*/ $4fqPo.createElement($1bcb3ae0a781a350$export$aff2890a94825ec8, null, /*#__PURE__*/ $4fqPo.createElement($1bcb3ae0a781a350$export$4ba49fb37bbab46d, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $hZJtW.default).articlesEmptyStateText)), /*#__PURE__*/ $4fqPo.createElement((0, $8Gf3q.default), {
        to: `/portal/${portalId}`,
        actionSubjectId: "backToPortal"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
        ...(0, $hZJtW.default).categoriesEmptyStateLink,
        values: {
            portalName: portalName
        }
    }))), showRequestCreateButton && /*#__PURE__*/ $4fqPo.createElement((0, $annK7.default), {
        to: portalLink
    }))));
};
var $1bcb3ae0a781a350$export$2e2bcd8739ae039 = $1bcb3ae0a781a350$var$ArticleList;
const $1bcb3ae0a781a350$export$4ba49fb37bbab46d = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ejyd2g-0"
})`${$4W9tu.regular};margin-bottom:${"var(--ds-space-100, 8px)"};`;
const $1bcb3ae0a781a350$export$9d0ad9ba52d8bb58 = /*#__PURE__*/ (0, $el3DQ.default).ol.withConfig({
    componentId: "sc-1ejyd2g-1"
})`margin:0 -${(0, $dkLWp.GROUP_BOX_PADDING_LEFT_RIGHT)};padding:0;`;
const $1bcb3ae0a781a350$export$72d7ca7a5d1d4807 = /*#__PURE__*/ (0, $el3DQ.default).h2.withConfig({
    componentId: "sc-1ejyd2g-2"
})`${$4W9tu.h500};`;
const $1bcb3ae0a781a350$export$79927783e7566f41 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ejyd2g-3"
})`margin-top:${(props)=>props.marginTop ? "var(--ds-space-200, 16px)" : 0};> *{margin-top:${"var(--ds-space-200, 16px)"};}`;
const $1bcb3ae0a781a350$export$aff2890a94825ec8 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ejyd2g-4"
})`margin-bottom:${"var(--ds-space-500, 40px)"};`;

});
parcelRegister("hy5Bl", function(module, exports) {
$parcel$export(module.exports, "GroupBox", () => (parcelRequire("iZUrV")).default);
$parcel$export(module.exports, "GroupBoxLink", () => (parcelRequire("fjJCg")).default);
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => (parcelRequire("dkLWp")).GROUP_BOX_PADDING_LEFT_RIGHT);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => (parcelRequire("dkLWp")).GROUP_BOX_PADDING_TOP_BOTTOM);

var $iZUrV = parcelRequire("iZUrV");
parcelRequire("ekk8I");
var $fjJCg = parcelRequire("fjJCg");

var $dkLWp = parcelRequire("dkLWp");

});
parcelRegister("iZUrV", function(module, exports) {
$parcel$export(module.exports, "default", () => $da40b140b1cffbed$export$2e2bcd8739ae039);
/* group-box.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $a3bgj = parcelRequire("a3bgj");

var $2eKV2 = parcelRequire("2eKV2");

var $dkLWp = parcelRequire("dkLWp");
const $da40b140b1cffbed$var$GroupBox = ({ heading: heading, description: description, icon: icon, editRequestTypeOnRequestList: editRequestTypeOnRequestList, headingAs: headingAs = 'h3', isAriaHidden: isAriaHidden = false, lineClamp: lineClamp = 0, ...props })=>{
    const showEditRequestButton = !!editRequestTypeOnRequestList;
    const ariaHidden = isAriaHidden ? undefined : true;
    const content = showEditRequestButton ? /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_kqswh2mm"
        ])
    }, heading && /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description), /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-edit-overlay": "true",
        className: (0, $ltgDR.default)([
            "_kqswstnw _1xi2ze3t _154ize3t _tzy4idpf"
        ])
    }, editRequestTypeOnRequestList)) : /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, heading && /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        size: "xsmall",
        as: headingAs
    }, /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.HeadingContent), {
        lineClamp: !!lineClamp
    }, heading)), /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.Description), {
        "aria-hidden": ariaHidden,
        lineClamp: lineClamp
    }, description));
    return /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.StyledIconCardLayout), {
        ...props,
        leftIcon: icon && /*#__PURE__*/ ($4fqPo.isValidElement(icon) ? icon : /*#__PURE__*/ $4fqPo.createElement((0, $a3bgj.default), {
            src: icon,
            alt: ""
        })),
        content: content
    });
};
const $da40b140b1cffbed$var$GroupBoxWithAdditionalButtonLayout = null;
const $da40b140b1cffbed$var$OverlayButtonLayout = null;
var $da40b140b1cffbed$export$2e2bcd8739ae039 = $da40b140b1cffbed$var$GroupBox;

});
parcelRegister("dkLWp", function(module, exports) {
$parcel$export(module.exports, "GROUP_BOX_PADDING_LEFT_RIGHT", () => $228a9673f82917be$export$5ff888af59e97bf4);
$parcel$export(module.exports, "GROUP_BOX_PADDING_TOP_BOTTOM", () => $228a9673f82917be$export$2968d5852daac253);
$parcel$export(module.exports, "StyledIconCardLayout", () => $228a9673f82917be$export$66f468dd3258e073);
$parcel$export(module.exports, "HeadingContent", () => $228a9673f82917be$export$5cb6fad052f5d74e);
$parcel$export(module.exports, "Description", () => $228a9673f82917be$export$393edc798c47379d);
$parcel$export(module.exports, "StyledLink", () => $228a9673f82917be$export$9048d548939551ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $1P8FK = parcelRequire("1P8FK");

var $4W9tu = parcelRequire("4W9tu");

var $iSWaE = parcelRequire("iSWaE");
parcelRequire("ibcO1");
var $4wVTY = parcelRequire("4wVTY");
const $228a9673f82917be$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT = "var(--ds-space-200, 16px)";
const $228a9673f82917be$export$5ff888af59e97bf4 = "var(--ds-space-300, 24px)";
const $228a9673f82917be$export$2968d5852daac253 = "var(--ds-space-300, 24px)";
const $228a9673f82917be$export$66f468dd3258e073 = /*#__PURE__*/ (0, $el3DQ.default)((0, $4wVTY.default)).withConfig({
    componentId: "sc-1p6gmq3-0"
})`padding:${$228a9673f82917be$export$2968d5852daac253} ${(props)=>props.containerPadding === 'tight' ? $228a9673f82917be$var$GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT : $228a9673f82917be$export$5ff888af59e97bf4};`;
const $228a9673f82917be$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1p6gmq3-1"
})`${$4W9tu.h400};${(props)=>$iSWaE.applyIf(props.lineClamp, $iSWaE.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $228a9673f82917be$export$5cb6fad052f5d74e = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1p6gmq3-2"
})`${(props)=>$iSWaE.applyIf(props.lineClamp, $iSWaE.clamp)};color:${(props)=>`var(--ds-text-brand, ${props.theme.color})`};margin:0;`;
const $228a9673f82917be$export$393edc798c47379d = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1p6gmq3-3"
})`${(props)=>$iSWaE.applyIf(props.lineClamp > 0, /*
    We use multiline clamp so we avoid descriptions that have multi paragraphs looking like this:
    Clamped...
    Clamped...
    Clamped...
*/ $iSWaE.multiLineClamp(props.lineClamp))};color:${"var(--ds-text, #172B4D)"};margin-top:${"var(--ds-space-050, 4px)"};`;
const $228a9673f82917be$export$9048d548939551ee = /*#__PURE__*/ (0, $el3DQ.default)((0, $1P8FK.Link)).withConfig({
    componentId: "sc-1p6gmq3-4"
})`${$iSWaE.borderRadius};display:block;background-color:${(props)=>props.selected ? "var(--ds-surface-raised, #F4F5F7)" : 'inherit'};&:hover,&:focus-visible{text-decoration:none;background-color:${"var(--ds-surface-raised-hovered, #F4F5F7)"};}&:hover [data-edit-overlay]{opacity:1;}&:focus{text-decoration:none;}`;

});
parcelRegister("ibcO1", function(module, exports) {
$parcel$export(module.exports, "IconCardLayout", () => (parcelRequire("4wVTY")).default);

var $4wVTY = parcelRequire("4wVTY");

});
parcelRegister("4wVTY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a89efc13c7adf1fc$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $63sfu = parcelRequire("63sfu");
const $a89efc13c7adf1fc$var$DEFAULT_RESULT_PADDING = "var(--ds-space-200, 16px)";
const $a89efc13c7adf1fc$var$DEFAULT_ICON_SIZE = "var(--ds-space-400, 32px)";
const $a89efc13c7adf1fc$var$DEFAULT_ICON_MARGIN = "var(--ds-space-200, 16px)";
const $a89efc13c7adf1fc$var$getSpaceValueWithDefault = (defaultSpacing, value, customSpacing)=>{
    if (!(0, $63sfu.isNil)(value)) return `${value}px`;
    return customSpacing || defaultSpacing;
};
const $a89efc13c7adf1fc$var$IconCardLayout = ({ leftIcon: leftIcon, rightIcon: rightIcon, content: content, iconSize: iconSize, iconMargin: iconMargin, padding: padding, alignItems: alignItems, className: className, centerAlignLeftIcon: centerAlignLeftIcon, centerAlignRightIcon: centerAlignRightIcon, dataTestId: dataTestId, customStyling: customStyling })=>{
    const { iconSize: customIconSize, iconMargin: customIconMargin, padding: customPadding } = customStyling || {};
    const iconSizeWithDefault = $a89efc13c7adf1fc$var$getSpaceValueWithDefault($a89efc13c7adf1fc$var$DEFAULT_ICON_SIZE, iconSize, customIconSize);
    const iconMarginWithDefault = $a89efc13c7adf1fc$var$getSpaceValueWithDefault($a89efc13c7adf1fc$var$DEFAULT_ICON_MARGIN, iconMargin, customIconMargin);
    const paddingWithDefault = $a89efc13c7adf1fc$var$getSpaceValueWithDefault($a89efc13c7adf1fc$var$DEFAULT_RESULT_PADDING, padding, customPadding);
    return /*#__PURE__*/ $4fqPo.createElement($a89efc13c7adf1fc$var$ResultContainer, {
        "data-test-id": dataTestId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        padding: paddingWithDefault,
        align: alignItems || 'center'
    }, leftIcon && /*#__PURE__*/ $4fqPo.createElement($a89efc13c7adf1fc$var$IconContainer, {
        iconMargin: iconMarginWithDefault,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignLeftIcon
    }, leftIcon), /*#__PURE__*/ $4fqPo.createElement($a89efc13c7adf1fc$var$ResultContentContainer, null, content), rightIcon && /*#__PURE__*/ $4fqPo.createElement($a89efc13c7adf1fc$var$IconContainer, {
        iconMargin: $a89efc13c7adf1fc$var$DEFAULT_ICON_MARGIN,
        iconSize: iconSizeWithDefault,
        isCenterAlignIcon: centerAlignRightIcon,
        right: true
    }, rightIcon));
};
var $a89efc13c7adf1fc$export$2e2bcd8739ae039 = $a89efc13c7adf1fc$var$IconCardLayout;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a89efc13c7adf1fc$var$ResultContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-fn7rhf-0"
})`display:flex;width:100%;box-sizing:border-box;align-items:${(props)=>props.align};padding:0 ${(props)=>props.padding};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a89efc13c7adf1fc$var$IconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-fn7rhf-1"
})`display:flex;align-items:center;justify-content:center;width:${(props)=>props.iconSize};align-self:flex-start;margin-top:${"var(--ds-space-050, 4px)"};flex-shrink:0;${(props)=>props.isCenterAlignIcon && `margin: auto`};${(props)=>props.right ? `margin-left: ${props.iconMargin}` : `margin-right: ${props.iconMargin}`};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $a89efc13c7adf1fc$var$ResultContentContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-fn7rhf-2"
})`width:100%;`;

});




parcelRegister("ekk8I", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("fjJCg")).default);

var $fjJCg = parcelRequire("fjJCg");

});
parcelRegister("fjJCg", function(module, exports) {
$parcel$export(module.exports, "default", () => $98050a8cd9ca45ae$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("i7I7b");
var $lrgoy = parcelRequire("lrgoy");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $3TeDY = parcelRequire("3TeDY");

var $iZUrV = parcelRequire("iZUrV");

var $dkLWp = parcelRequire("dkLWp");
const $98050a8cd9ca45ae$var$isExternalLink = (target)=>{
    return target instanceof HTMLElement && target.className.includes('external-link');
};
const $98050a8cd9ca45ae$var$handleExternalLink = (e)=>{
    e.preventDefault();
    (0, $3TeDY.open)(e.target.toString(), '_blank');
};
const $98050a8cd9ca45ae$var$GroupBoxLink = ({ className: className, selected: selected, onClick: onClick, target: target, dataTestId: dataTestId, actionSubjectId: actionSubjectId, ...rest })=>{
    const [isPageInEditMode] = (0, $lrgoy.useIsPageInEditMode)();
    const tabIndex = isPageInEditMode ? -1 : undefined;
    const handleClick = $4fqPo.useCallback((e)=>{
        if (isPageInEditMode) return;
        if ($98050a8cd9ca45ae$var$isExternalLink(e.target)) {
            $98050a8cd9ca45ae$var$handleExternalLink(e);
            return;
        }
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    if ('to' in rest) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
        // oxlint-disable-next-line no-shadow
        const { to: to, editRequestTypeOnRequestList: editRequestTypeOnRequestList, ...forGroupBox } = rest;
        const showEditRequestTypeButton = !isPageInEditMode && !!editRequestTypeOnRequestList;
        const contentWithTo = showEditRequestTypeButton ? /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId
        }, /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), {
            ...forGroupBox,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        })) : /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.StyledLink), {
            selected: !!selected,
            to: to,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: handleClick,
            target: target,
            actionSubjectId: actionSubjectId,
            "data-test-id": dataTestId,
            tabIndex: tabIndex
        }, /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), forGroupBox));
        return isPageInEditMode ? /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
            xcss: $98050a8cd9ca45ae$var$disabledLink
        }, contentWithTo) : contentWithTo;
    }
    const { href: href, ...forGroupBox } = rest;
    const content = /*#__PURE__*/ $4fqPo.createElement((0, $dkLWp.StyledLink), {
        selected: !!selected,
        href: href,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        onClick: handleClick,
        target: target,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        tabIndex: tabIndex
    }, /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), forGroupBox));
    return isPageInEditMode ? /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        xcss: $98050a8cd9ca45ae$var$disabledLink
    }, content) : content;
};
const $98050a8cd9ca45ae$var$disabledLink = (0, $2m8U6.xcss)({
    pointerEvents: 'none'
});
var $98050a8cd9ca45ae$export$2e2bcd8739ae039 = $98050a8cd9ca45ae$var$GroupBoxLink;

});



parcelRegister("4b5rY", function(module, exports) {
$parcel$export(module.exports, "RaiseRequestLink", () => (parcelRequire("annK7")).default);

var $annK7 = parcelRequire("annK7");

});
parcelRegister("annK7", function(module, exports) {
$parcel$export(module.exports, "default", () => $b89c5f65dd924f7d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $5Uaxl = parcelRequire("5Uaxl");
parcelRequire("4Jfiz");
var $keu8x = parcelRequire("keu8x");
parcelRequire("hy5Bl");
var $dkLWp = parcelRequire("dkLWp");

var $bRnDz = parcelRequire("bRnDz");
const $b89c5f65dd924f7d$var$RaiseRequestLink = ({ to: to, isEmbeddedRoute: isEmbeddedRoute, ...props })=>/*#__PURE__*/ $4fqPo.createElement((0, $keu8x.default), {
        to: to,
        padding: 0,
        actionSubjectId: "requestCreateLink",
        target: isEmbeddedRoute ? '_blank' : undefined,
        ...props
    }, /*#__PURE__*/ $4fqPo.createElement($b89c5f65dd924f7d$var$MessageContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $bRnDz.default).raiseRequestText)));
var $b89c5f65dd924f7d$export$2e2bcd8739ae039 = $b89c5f65dd924f7d$var$RaiseRequestLink;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $b89c5f65dd924f7d$var$MessageContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-r621zd-0"
})`padding:${(0, $dkLWp.GROUP_BOX_PADDING_TOP_BOTTOM)} ${(0, $dkLWp.GROUP_BOX_PADDING_LEFT_RIGHT)};`;

});
parcelRegister("4Jfiz", function(module, exports) {
$parcel$export(module.exports, "CardLink", () => (parcelRequire("keu8x")).default);

var $keu8x = parcelRequire("keu8x");

});
parcelRegister("keu8x", function(module, exports) {
$parcel$export(module.exports, "default", () => $aee920480400cb4a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("i7I7b");
var $lrgoy = parcelRequire("lrgoy");

var $bB8Fv = parcelRequire("bB8Fv");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $6KBOx = parcelRequire("6KBOx");
const $aee920480400cb4a$var$CardLink = ({ children: children, to: to, padding: padding, className: className, appearance: appearance, actionSubjectId: actionSubjectId, dataTestId: dataTestId, target: target, onClick: onClick })=>{
    const [isPageInEditMode] = (0, $lrgoy.useIsPageInEditMode)();
    const handleClick = $4fqPo.useCallback(()=>{
        if (isPageInEditMode) return;
        onClick === null || onClick === void 0 || onClick();
    }, [
        isPageInEditMode,
        onClick
    ]);
    const content = /*#__PURE__*/ $4fqPo.createElement((0, $6KBOx.Card), {
        to: to,
        padding: padding,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        className: className,
        appearance: appearance,
        actionSubjectId: actionSubjectId,
        "data-test-id": dataTestId,
        target: target,
        onClick: handleClick,
        tabIndex: isPageInEditMode ? -1 : undefined
    }, /*#__PURE__*/ $4fqPo.createElement((0, $6KBOx.Container), null, children, /*#__PURE__*/ $4fqPo.createElement((0, $6KBOx.IconContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bB8Fv))), {
        size: "small",
        spacing: "spacious",
        label: "",
        "aria-hidden": "true",
        color: "var(--ds-text, #172B4D)"
    }))));
    return isPageInEditMode ? /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        xcss: $aee920480400cb4a$var$disabledCard
    }, content) : content;
};
$aee920480400cb4a$var$CardLink.defaultProps = {
    appearance: 'gray'
};
const $aee920480400cb4a$var$disabledCard = (0, $2m8U6.xcss)({
    pointerEvents: 'none'
});
var $aee920480400cb4a$export$2e2bcd8739ae039 = $aee920480400cb4a$var$CardLink;

});
parcelRegister("bB8Fv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbc9eb298cfdac722b50cf5246108693>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8719dfcb6bae7fa6$var$_react = $8719dfcb6bae7fa6$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $8719dfcb6bae7fa6$var$_baseNew = $8719dfcb6bae7fa6$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $8719dfcb6bae7fa6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8719dfcb6bae7fa6$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $8719dfcb6bae7fa6$var$_react.default.createElement($8719dfcb6bae7fa6$var$_baseNew.default, Object.assign({
        name: "ChevronRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z"/>`
    }, props));
$8719dfcb6bae7fa6$var$ChevronRightIcon.displayName = 'ChevronRightIcon';
var $8719dfcb6bae7fa6$var$_default = module.exports.default = $8719dfcb6bae7fa6$var$ChevronRightIcon;

});

parcelRegister("6KBOx", function(module, exports) {
$parcel$export(module.exports, "Container", () => $2030b96309aed567$export$42a852a2b6b56249);
$parcel$export(module.exports, "IconContainer", () => $2030b96309aed567$export$8f314e512d92575f);
$parcel$export(module.exports, "Card", () => $2030b96309aed567$export$60332b2344f7fe41);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $iSWaE = parcelRequire("iSWaE");
parcelRequire("dPosN");
var $acKOi = parcelRequire("acKOi");
const $2030b96309aed567$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-15f4chr-0"
})`display:flex;align-items:center;justify-content:space-between;`;
const $2030b96309aed567$export$8f314e512d92575f = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-15f4chr-1"
})`margin-right:${"var(--ds-space-100, 8px)"};`;
const $2030b96309aed567$export$60332b2344f7fe41 = /*#__PURE__*/ (0, $el3DQ.default)((0, $acKOi.LinkCard)).withConfig({
    componentId: "sc-15f4chr-2"
})`${$iSWaE.borderRadius};background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised, #FAFBFC)" : "var(--ds-surface-raised, #FFFFFF)"};padding:${(props)=>props.padding !== undefined ? `${props.padding}px` : "var(--ds-space-200, 16px)"};span{color:${"var(--ds-text, #172B4D)"};}&:hover{background:${(props)=>props.appearance === 'gray' ? "var(--ds-surface-raised-hovered, #FAFBFC)" : "var(--ds-surface-raised-hovered, #FFFFFF)"};}`;

});
parcelRegister("dPosN", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => (parcelRequire("acKOi")).LinkCard);

var $acKOi = parcelRequire("acKOi");

});
parcelRegister("acKOi", function(module, exports) {
$parcel$export(module.exports, "LinkCard", () => $384d9a3cd8d94281$export$2c381a86421d5abf);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");

var $1P8FK = parcelRequire("1P8FK");

var $7L1Sn = parcelRequire("7L1Sn");

var $iSWaE = parcelRequire("iSWaE");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $384d9a3cd8d94281$var$linkCardBase = /*#__PURE__*/ (0, $el3DQ.css)`${$iSWaE.raiseUpOnHoverOrFocus((0, $7L1Sn.newElevationsFromDesignSystems).e100, (0, $7L1Sn.newElevationsFromDesignSystems).e200)};${$iSWaE.borderRadius};${$iSWaE.focusRing.default};display:block;background-color:${"var(--ds-surface-raised, #FFFFFF)"};:hover,:focus{text-decoration:none;}`;
const $384d9a3cd8d94281$export$2c381a86421d5abf = /*#__PURE__*/ (0, $el3DQ.default)((0, $1P8FK.Link)).withConfig({
    componentId: "sc-axlah-0"
})`${$384d9a3cd8d94281$var$linkCardBase};`;

});





parcelRegister("bRnDz", function(module, exports) {
$parcel$export(module.exports, "default", () => $0035ac0138cbf300$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $0035ac0138cbf300$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    raiseRequestText: {
        defaultMessage: 'Need to raise a request? Contact us.',
        description: 'Card button text to raise request',
        id: 'sd.customerview.portal.card.button.text'
    }
});

});



parcelRegister("7OcIi", function(module, exports) {
$parcel$export(module.exports, "ArticleListItem", () => (parcelRequire("8LcMX")).default);

var $8LcMX = parcelRequire("8LcMX");

});
parcelRegister("8LcMX", function(module, exports) {
$parcel$export(module.exports, "default", () => $466eae8bdf190f6b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bpWyP = parcelRequire("bpWyP");

var $iSWaE = parcelRequire("iSWaE");
parcelRequire("hy5Bl");
var $fjJCg = parcelRequire("fjJCg");

var $fFB0R = parcelRequire("fFB0R");

var $aA5GW = parcelRequire("aA5GW");
const $466eae8bdf190f6b$var$ArticleListItem = ({ portalId: portalId, categoryId: categoryId, articleId: articleId, title: title, summaryExcerpt: summaryExcerpt, onClick: onClick })=>{
    const articleUrl = `/portal/${portalId}/topic/${categoryId}/article/${articleId}`;
    const analyticData = {
        attributes: {
            articleId: articleId,
            portalId: portalId,
            categoryId: categoryId
        }
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
        data: analyticData
    }, /*#__PURE__*/ $4fqPo.createElement($466eae8bdf190f6b$var$ListItem, null, /*#__PURE__*/ $4fqPo.createElement((0, $fjJCg.default), {
        actionSubjectId: "article",
        to: articleUrl,
        onClick: onClick,
        heading: title,
        description: /*#__PURE__*/ $4fqPo.createElement($466eae8bdf190f6b$export$ef81c5adc5a715ed, {
            dangerouslySetInnerHTML: {
                __html: summaryExcerpt
            }
        }),
        icon: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aA5GW))), {
            label: "",
            "aria-hidden": "true",
            size: "medium",
            color: "var(--ds-icon, #42526E)",
            spacing: "spacious"
        }),
        lineClamp: 2
    })));
};
var $466eae8bdf190f6b$export$2e2bcd8739ae039 = $466eae8bdf190f6b$var$ArticleListItem;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $466eae8bdf190f6b$var$ListItem = /*#__PURE__*/ (0, $el3DQ.default).li.withConfig({
    componentId: "sc-1u8m6l-0"
})`margin:0;list-style:none;`;
const $466eae8bdf190f6b$export$ef81c5adc5a715ed = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-1u8m6l-1"
})`${$iSWaE.multiLineClamp(2, $bpWyP.multiple(2.5).unitless)};margin:0;`;

});
parcelRegister("aA5GW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::240d2a2d2ecd17e4d685f807cd1b54f8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b41ae6f604da29f$var$_react = $7b41ae6f604da29f$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $7b41ae6f604da29f$var$_baseNew = $7b41ae6f604da29f$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $7b41ae6f604da29f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7b41ae6f604da29f$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $7b41ae6f604da29f$var$_react.default.createElement($7b41ae6f604da29f$var$_baseNew.default, Object.assign({
        name: "BookWithBookmarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$7b41ae6f604da29f$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $7b41ae6f604da29f$var$_default = module.exports.default = $7b41ae6f604da29f$var$BookWithBookmarkIcon;

});



parcelRegister("hZJtW", function(module, exports) {
$parcel$export(module.exports, "default", () => $c53e4df8b611eb49$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $c53e4df8b611eb49$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    featuredArticlesHeading: {
        defaultMessage: 'Featured articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.featured-articles.heading'
    },
    moreArticlesHeading: {
        defaultMessage: 'More articles',
        description: 'Heading for the featured articles section.',
        id: 'cv.categories.page.more-articles.heading'
    },
    articlesEmptyStateText: {
        defaultMessage: 'There are no articles in this category yet. Try another category, or raise a request below.',
        description: 'The text is shown as the body message in the empty state of the article list on a knowledge category page, displayed when no articles exist in the selected category.',
        id: 'cv.categories.page.no.articles.message'
    },
    categoriesEmptyStateLink: {
        defaultMessage: 'Back to {portalName}',
        description: 'The text is shown as a back navigation link in the empty state of the article list on a knowledge category page. The placeholder {portalName} will be substituted with the name of the current portal.',
        id: 'cv.categories.page.no.articles.back.link'
    }
});

});



parcelRegister("e3UHj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a3372f24c9ffd41$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $3a3372f24c9ffd41$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    categoryDocumentTitle: {
        defaultMessage: '{portalName} - {categoryName}',
        description: 'Document title for portal article topics page',
        id: 'cv.categories.page.title'
    }
});

});



parcelRegister("fAQfJ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("llcAd").then(()=>parcelRequire('7yhIV'));

});

parcelRegister("d1VDU", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8KbwM").then(()=>parcelRequire('l49oO'));

});


parcelRegister("8xPh7", function(module, exports) {
$parcel$export(module.exports, "loginRoute", () => $9a31b74fd7358aae$export$798bfdbebc5ea68e);
$parcel$export(module.exports, "portalLoginRoute", () => $9a31b74fd7358aae$export$e338715dbbd45865);

var $748yq = parcelRequire("748yq");
parcelRequire("82pLF");
var $31gDG = parcelRequire("31gDG");

var $6bGmX = parcelRequire("6bGmX");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");

var $6bsub = parcelRequire("6bsub");
var $jcK59 = parcelRequire("jcK59");
const $9a31b74fd7358aae$var$resources = (0, $6bGmX.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? [
    (0, $jcK59.waitingBrandingResource),
    (0, $6bsub.loginAnnouncementsCardResource)
] : [];
const $9a31b74fd7358aae$var$portalLogin = {
    resources: $9a31b74fd7358aae$var$resources,
    name: 'portal-login',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/login`,
    exact: true,
    component: (0, $31gDG.default)
};
const $9a31b74fd7358aae$var$login = {
    resources: $9a31b74fd7358aae$var$resources,
    name: 'login',
    path: (0, $1XMNp.LOGIN_ROUTE),
    exact: true,
    component: (0, $31gDG.default)
};
const $9a31b74fd7358aae$var$screenName = (0, $748yq.ScreenName).LOGIN;
const $9a31b74fd7358aae$var$layoutProps = (0, $6bGmX.default).checkGate('jsm_multi_helpcenter_login_ssr_improvements') ? {
    ...(0, $1XMNp.anonymousScreenLayout),
    prefetchBrandingModel: true
} : (0, $1XMNp.anonymousScreenLayout);
const $9a31b74fd7358aae$export$798bfdbebc5ea68e = (0, $bp9tj.createRouteWithLayout)($9a31b74fd7358aae$var$login, $9a31b74fd7358aae$var$screenName, $9a31b74fd7358aae$var$layoutProps);
const $9a31b74fd7358aae$export$e338715dbbd45865 = (0, $bp9tj.createRouteWithLayout)($9a31b74fd7358aae$var$portalLogin, $9a31b74fd7358aae$var$screenName, $9a31b74fd7358aae$var$layoutProps);

});
parcelRegister("82pLF", function(module, exports) {
$parcel$export(module.exports, "Login", () => (parcelRequire("31gDG")).default);

var $31gDG = parcelRequire("31gDG");

});
parcelRegister("31gDG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c9e92d54e15bb75$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $ibOOf = parcelRequire("ibOOf");

var $1MLMt = parcelRequire("1MLMt");

var $gb0lQ = parcelRequire("gb0lQ");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("6jcXZ");
var $3R99L = parcelRequire("3R99L");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("26KqF");
var $1oHWL = parcelRequire("1oHWL");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("6LpYP");
var $kR2PX = parcelRequire("kR2PX");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $1VbK5 = parcelRequire("1VbK5");
const $5c9e92d54e15bb75$var$selector = (0, $3yyCx.createSelector)((state)=>(0, $i8gmD.getSharedPortalName)(state), (state)=>(0, $kR2PX.getLogin)(state), (state)=>(0, $kR2PX.getIsLoginLoaded)(state), (state)=>(0, $1oHWL.getResetUrl)(state), (state)=>(0, $2hx7o.isLoggedIn)(state), (state)=>(0, $kR2PX.getLoginUIState)(state), (state)=>(0, $2mzxy.getIsAnonymousEnabled)(state), (helpCenterName, loginModel, loaded, resetUrl, isUserLoggedIn, loginUIState, isAnonymousEnabled)=>({
        helpCenterName: helpCenterName,
        loginModel: loginModel,
        resetUrl: resetUrl,
        loginUIState: loginUIState,
        isAnonymousEnabled: isAnonymousEnabled,
        isLoggedIn: isUserLoggedIn,
        isLoading: !loaded
    }));
var $5c9e92d54e15bb75$export$2e2bcd8739ae039 = (0, $bmgw6.default)($5c9e92d54e15bb75$var$selector, {
    resetLogin: $8o5VQ.resetLogin,
    fetchLoginModel: $gb0lQ.fetchLoginModel,
    checkLoginActionSuccess: $8o5VQ.checkLoginActionSuccess,
    fetchForgotPasswordModel: $1MLMt.fetchForgotPasswordModel,
    successfullyLoggedInAction: (0, $3R99L.successfullyLoggedIn),
    onExitTestMode: (0, $8o5VQ.exitTestModeAction)
})((0, $apbG6.default)({
    component: 'login'
})((0, $as4kh.default)()((0, $ibOOf.default)((0, $1VbK5.default)))));

});
parcelRegister("26KqF", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => (parcelRequire("1oHWL")).getResetUrl);

var $1oHWL = parcelRequire("1oHWL");

});
parcelRegister("1oHWL", function(module, exports) {
$parcel$export(module.exports, "getResetUrl", () => $db7d5a99d5e64e0e$export$8f4db1396a1458f2);
const $db7d5a99d5e64e0e$var$getForgotPasswordOrError = (state)=>{
    return state.persisted.forgotPassword;
};
const $db7d5a99d5e64e0e$export$8f4db1396a1458f2 = (state)=>{
    const data = $db7d5a99d5e64e0e$var$getForgotPasswordOrError(state);
    return data && 'forgotPassword' in data && data.forgotPassword ? data.forgotPassword.resetUrl : undefined;
};

});


parcelRegister("6LpYP", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => (parcelRequire("kR2PX")).getLogin);
$parcel$export(module.exports, "getIsLoginLoaded", () => (parcelRequire("kR2PX")).getIsLoginLoaded);
$parcel$export(module.exports, "getLoginUIState", () => (parcelRequire("kR2PX")).getLoginUIState);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => (parcelRequire("kR2PX")).getIsFailedLoginAttempt);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => (parcelRequire("kR2PX")).getLoginAnnouncementLocale);

var $kR2PX = parcelRequire("kR2PX");

});
parcelRegister("kR2PX", function(module, exports) {
$parcel$export(module.exports, "getLogin", () => $71136a13c73cea6a$export$b91571cfe9876bf7);
$parcel$export(module.exports, "getLoginAnnouncementLocale", () => $71136a13c73cea6a$export$30a66755de1b0435);
$parcel$export(module.exports, "getIsLoginLoaded", () => $71136a13c73cea6a$export$b8e9d5ecaaf5cf65);
$parcel$export(module.exports, "getLoginUIState", () => $71136a13c73cea6a$export$3751fae82567dd3f);
$parcel$export(module.exports, "getIsFailedLoginAttempt", () => $71136a13c73cea6a$export$bd53bde676b5f183);
const $71136a13c73cea6a$var$getLoginOrError = (state)=>{
    return state.persisted.login;
};
const $71136a13c73cea6a$export$b91571cfe9876bf7 = (state)=>{
    const data = $71136a13c73cea6a$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? data.login : undefined;
};
const $71136a13c73cea6a$export$30a66755de1b0435 = (state)=>{
    var _data$login;
    const data = $71136a13c73cea6a$var$getLoginOrError(state);
    return data && 'login' in data && data.login ? (_data$login = data.login) === null || _data$login === void 0 ? void 0 : _data$login.loginAnnouncementLocale : undefined;
};
const $71136a13c73cea6a$export$b8e9d5ecaaf5cf65 = (state)=>{
    const login = $71136a13c73cea6a$export$b91571cfe9876bf7(state);
    return login !== undefined;
};
const $71136a13c73cea6a$export$3751fae82567dd3f = (state)=>{
    return state.ui.login;
};
const $71136a13c73cea6a$export$9fd495314b248bd5 = (state)=>{
    return $71136a13c73cea6a$export$3751fae82567dd3f(state).error;
};
const $71136a13c73cea6a$export$bd53bde676b5f183 = (state)=>{
    const loginUIState = $71136a13c73cea6a$export$3751fae82567dd3f(state);
    return $71136a13c73cea6a$export$9fd495314b248bd5(state) !== undefined || loginUIState.loginAttemptResponse !== undefined && !loginUIState.loginAttemptResponse.loginSucceeded;
};

});


parcelRegister("1VbK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f1382e485508a54$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $6uA6H = parcelRequire("6uA6H");

var $748yq = parcelRequire("748yq");

var $9Ut8d = parcelRequire("9Ut8d");

var $bG6ob = parcelRequire("bG6ob");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $8Gf3q = parcelRequire("8Gf3q");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $efDRU = parcelRequire("efDRU");
parcelRequire("4d0HX");
var $3KGZN = parcelRequire("3KGZN");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");

var $lPGvK = parcelRequire("lPGvK");

var $fFB0R = parcelRequire("fFB0R");

var $2eKV2 = parcelRequire("2eKV2");

var $e2Zgo = parcelRequire("e2Zgo");

var $g6gA9 = parcelRequire("g6gA9");

var $cijxS = parcelRequire("cijxS");

var $54jwS = parcelRequire("54jwS");

var $eSL4S = parcelRequire("eSL4S");

var $eHkSG = parcelRequire("eHkSG");

var $fwSzd = parcelRequire("fwSzd");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $3TeDY = parcelRequire("3TeDY");

var $g01X2 = parcelRequire("g01X2");

var $jeiAx = parcelRequire("jeiAx");

var $cuI6M = parcelRequire("cuI6M");

var $Y85G3 = parcelRequire("Y85G3");

var $ly1SE = parcelRequire("ly1SE");
parcelRequire("lzaX3");
var $hcjJC = parcelRequire("hcjJC");
parcelRequire("i77IN");
var $evjMw = parcelRequire("evjMw");
parcelRequire("3PuQ6");
var $360DG = parcelRequire("360DG");
parcelRequire("72XWM");
var $1YvAz = parcelRequire("1YvAz");
parcelRequire("lb6pJ");
var $jtu9m = parcelRequire("jtu9m");
parcelRequire("gD5QM");
var $14GJF = parcelRequire("14GJF");

var $9gBNa = parcelRequire("9gBNa");
/**
 * Check if loginAnnouncement is present
 */ const $8f1382e485508a54$var$isAnnouncementPresent = (loginModel)=>{
    if (!loginModel) return false;
    const { loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage } = loginModel;
    return (0, $jeiAx.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
};
const $8f1382e485508a54$var$getLoginAnnouncementText = (loginAnnouncementMessage)=>{
    return /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$var$LoginAnnouncementBody, {
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(loginAnnouncementMessage) : (0, $a7SRW.sanitize)(loginAnnouncementMessage)
        }
    });
};
const $8f1382e485508a54$export$f20e6faa97f704fb = ({ loginAnnouncementSubject: loginAnnouncementSubject, loginAnnouncementMessage: loginAnnouncementMessage })=>/*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$var$LoginAnnouncementContainer, null, loginAnnouncementSubject ? /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
            size: "small"
        }, loginAnnouncementSubject)
    }, /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$var$LoginAnnouncementTitle, null, loginAnnouncementSubject)) : null, loginAnnouncementMessage ? $8f1382e485508a54$var$getLoginAnnouncementText(loginAnnouncementMessage) : null);
class $8f1382e485508a54$export$21a94553ffa41578 extends $4fqPo.Component {
    componentDidMount() {
        const { isLoading: isLoading, resetUrl: resetUrl, loginUIState: loginUIState } = this.props;
        const ssoCustomerMethod = loginUIState.authInfo.authMethods.get((0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
        if (isLoading) this.props.fetchLoginModel();
        if (!resetUrl) this.props.fetchForgotPasswordModel();
        if (loginUIState.authInfo.authMethods.size === 0) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: true,
            redirectUrlIsMissing: false
        });
        else if (ssoCustomerMethod && ssoCustomerMethod.redirectLink === undefined) this.fireLoginFailedOperationalEvent({
            noMethodsAvailable: false,
            redirectUrlIsMissing: true
        });
    }
    getNavigationTiming() {
        var _globalThis$performan, _globalThis$performan2;
        return (_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 || (_globalThis$performan2 = _globalThis$performan.getEntriesByType) === null || _globalThis$performan2 === void 0 || (_globalThis$performan2 = _globalThis$performan2.call(_globalThis$performan, 'navigation')) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2[0];
    }
    render() {
        const { isLoggedIn: isLoggedIn, portalId: portalId } = this.props;
        const navigation = this.getNavigationTiming();
        if (isLoggedIn) return /*#__PURE__*/ $4fqPo.createElement((0, $cuI6M.RedirectLoggedInUser), {
            portalId: portalId
        });
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: {
                attributes: {
                    isSsoTestMode: (0, $Y85G3.getSsoTestModeParamFromUrl)(new URLSearchParams((0, $3TeDY.search)()))
                }
            }
        }, /*#__PURE__*/ $4fqPo.createElement((0, $g6gA9.default), {
            data: {
                isFromRedirect: navigation ? navigation.redirectCount > 0 : undefined,
                redirectCount: navigation ? navigation.redirectCount : undefined,
                isDefaultHelpCenter: (0, $eSL4S.isDefaultHelpCenter)()
            }
        }), /*#__PURE__*/ $4fqPo.createElement("div", {
            "data-test-id": "login-page.wrapper"
        }, this.renderLoginPage()));
    }
    constructor(...args){
        super(...args), this.fireLoginFailedOperationalEvent = (attributes)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const { noMethodsAvailable: noMethodsAvailable, redirectUrlIsMissing: redirectUrlIsMissing } = attributes;
            if (createAnalyticsEvent) createAnalyticsEvent({
                analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
                actionSubject: 'login',
                action: 'failed',
                attributes: {
                    noMethodsAvailable: noMethodsAvailable,
                    redirectUrlIsMissing: redirectUrlIsMissing
                }
            }).fire();
        }, this.getJITContinueParam = ()=>{
            const { destination: destination, isAbsolute: isAbsolute } = (0, $Y85G3.parseLoginSignupRedirectUrlParams)();
            const prefix = destination && isAbsolute ? '' : `${(0, $3TeDY.origin)()}${(0, $3wR8f.getBaseName)()}/aa-redirect?from=portalLoginJitSignup`;
            return `${prefix}`;
        }, this.resetHasLoginPageUpdated = ()=>{
            this.props.resetLogin(this.props.loginUIState.email);
        }, this.renderForgotPasswordConfirmation = ()=>{
            const { isLoading: isLoading, loginUIState: loginUIState, helpCenterName: helpCenterName, resetUrl: resetUrl } = this.props;
            return /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
                screenName: (0, $748yq.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $4fqPo.createElement((0, $60sOE.default), {
                screenName: (0, $748yq.ScreenName).LOGIN_FORGOT_PASSWORD_CONFIRMATION
            }, /*#__PURE__*/ $4fqPo.createElement((0, $3KGZN.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $4fqPo.createElement((0, $evjMw.default), {
                email: loginUIState.email,
                helpCenterName: helpCenterName,
                resetUrl: resetUrl || '',
                onBackButtonClick: this.resetHasLoginPageUpdated
            }))));
        }, this.renderSsoTestModeErrorPage = ()=>{
            const { isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
                screenName: (0, $748yq.ScreenName).LOGIN_SSO_TEST_MODE_ERROR
            }, /*#__PURE__*/ $4fqPo.createElement((0, $3KGZN.NoteContent), {
                isLoading: isLoading
            }, /*#__PURE__*/ $4fqPo.createElement((0, $hcjJC.default), null)));
        }, this.renderSingleSignOn = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $g01X2.AuthMethodType).ATLASSIAN_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
                        screenName: (0, $748yq.ScreenName).LOGIN_SINGLE_SIGN_ON
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $jtu9m.default), {
                        redirectUrl: redirectLink,
                        email: loginUIState.email
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.resetToCustomerPasswordLogin = ()=>{
            this.props.checkLoginActionSuccess((0, $g01X2.LoginType).CUSTOMER_ACCOUNT_LOGIN, {
                accountStage: (0, $g01X2.AccountStageType).LOGIN,
                authMethods: new Map([
                    [
                        (0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD,
                        {}
                    ]
                ])
            });
        }, this.renderSingleSignOnCustomer = ()=>{
            const { loginUIState: loginUIState } = this.props;
            const ssoMethod = loginUIState.authInfo.authMethods.get((0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_SSO);
            if (ssoMethod) {
                const { redirectLink: redirectLink } = ssoMethod;
                const passwordLoginAvailable = loginUIState.authInfo.authMethods.has((0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
                const singleSignOnSupplier = ()=>/*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
                        screenName: (0, $748yq.ScreenName).LOGIN_SINGLE_SIGN_ON_CUSTOMER
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $14GJF.default), {
                        email: loginUIState.email,
                        redirectLink: redirectLink,
                        passwordLoginAvailable: passwordLoginAvailable,
                        onContinueWithPassword: this.resetToCustomerPasswordLogin
                    }));
                return this.renderWithTitleAndFooter(singleSignOnSupplier);
            }
            return undefined;
        }, this.renderLoginPasswordForm = ()=>{
            return /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
                screenName: (0, $748yq.ScreenName).LOGIN_PASSWORD
            }, this.renderLoginForm());
        }, this.renderLoginForm = ()=>{
            const { resetUrl: resetUrl, loginUIState: loginUIState, portalId: portalId } = this.props;
            const formSupplier = (loginModel)=>/*#__PURE__*/ $4fqPo.createElement((0, $1YvAz.default), {
                    portalId: portalId,
                    contactAdminLink: loginModel.contactAdminLink,
                    resetUrl: resetUrl || '',
                    loginUIState: loginUIState,
                    canResetPassword: loginModel.canReset,
                    continueParam: (0, $Y85G3.getContinueParam)(portalId)
                });
            return this.renderWithTitleAndFooter(formSupplier);
        }, this.renderFooter = ()=>{
            const { intl: intl, isAnonymousEnabled: isAnonymousEnabled, loginUIState: loginUIState, helpCenterName: helpCenterName } = this.props;
            return isAnonymousEnabled && !loginUIState.atlassianAccountCheckPerformed && /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$var$FooterContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $8Gf3q.default), {
                to: (0, $Y85G3.getHelpCenterUrl)(),
                actionSubjectId: "helpCenterLink",
                onClick: (e)=>{
                    // This is ugly but we want to do a full page load (not an SPA load/transition)
                    // to allow the backend to make the decision about where we should end up.
                    // If CSM DOES NOT allow anonymous access but Jira Admin settings DOES, then
                    // an SPA transition will lead to a blank homepage as the backend actually
                    // wants to redirect the user to the login page.
                    e.preventDefault();
                    (0, $3TeDY.assign)((0, $ebpTf.getEnv)().baseUrl);
                }
            }, intl.formatMessage((0, $9gBNa.default).helpCenterLink, {
                helpCenterName: helpCenterName
            })));
        }, this.renderBackButton = ()=>{
            const { intl: intl } = this.props;
            const buttonText = intl.formatMessage((0, $9gBNa.default).backButton);
            return /*#__PURE__*/ $4fqPo.createElement((0, $ly1SE.default), {
                appearance: "link",
                actionSubjectId: "returnToLogin",
                onClick: this.resetHasLoginPageUpdated
            }, buttonText);
        }, this.getLoginAnnouncementCard = ()=>{
            const { loginModel: loginModel } = this.props;
            if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)()) // render new login announcement with relay fetch
            return /*#__PURE__*/ $4fqPo.createElement((0, $360DG.default), null);
            if (loginModel && $8f1382e485508a54$var$isAnnouncementPresent(loginModel)) // render old login announcement card with model
            return /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$export$f20e6faa97f704fb, {
                loginAnnouncementSubject: loginModel.loginAnnouncementSubject,
                loginAnnouncementMessage: loginModel.loginAnnouncementMessage
            });
            return null;
        }, // oxlint-disable-next-line no-shadow
        this.getContent = (componentSupplier)=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading, loginModel: loginModel, loginUIState: loginUIState } = this.props;
            let description = intl.formatMessage((0, $9gBNa.default).description);
            if (loginUIState.atlassianAccountCheckPerformed) {
                if (loginUIState.authInfo.authMethods.has((0, $g01X2.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) switch(loginUIState.authInfo.accountStage){
                    case (0, $g01X2.AccountStageType).SIGNUP:
                        description = intl.formatMessage((0, $9gBNa.default).useAtlassianAccountSignup);
                        break;
                    case (0, $g01X2.AccountStageType).LOGIN:
                    default:
                        description = intl.formatMessage((0, $9gBNa.default).useAtlassianAccountLogin);
                        break;
                }
                else description = intl.formatMessage((0, $9gBNa.default).descriptionLogin);
            }
            const loginAnnouncementCard = this.getLoginAnnouncementCard();
            if (!isLoading && loginModel) return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, loginUIState.atlassianAccountCheckPerformed && this.renderBackButton(), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$export$8faa746ec8bdfab3, null, helpCenterName)), !loginUIState.atlassianAccountCheckPerformed ? loginAnnouncementCard : null, /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                    size: "medium"
                }, description)
            }, /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$var$LoginDescription, null, description)), /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$var$LoginFormContainer, null, componentSupplier(loginModel)), this.renderFooter());
            return /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
                name: "render-login-page-loading"
            });
        }, this.renderWithTitleAndFooter = (componentSupplier)=>{
            const { isLoading: isLoading } = this.props;
            const content = this.getContent(componentSupplier);
            const urlParams = new URLSearchParams((0, $3TeDY.search)());
            const ssoTest = urlParams.get((0, $g01X2.QUERY_PARAM_SSO_TEST));
            return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, ssoTest === 'true' ? /*#__PURE__*/ $4fqPo.createElement((0, $lPGvK.SsoTestModeBanner), null) : null, /*#__PURE__*/ $4fqPo.createElement((0, $3KGZN.NoteContent), {
                isLoading: isLoading
            }, content));
        }, this.isInvalidFedRampLogin = ()=>{
            const isPasswordLoginDisabledByEnv = !(0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login');
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.isInvalidIcLogin = ()=>{
            const isPasswordLoginDisabledByEnv = !(0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-password-login');
            return isPasswordLoginDisabledByEnv && this.noAuthMethodOrOnlyHasPasswordAuthMethod();
        }, this.noAuthMethodOrOnlyHasPasswordAuthMethod = ()=>{
            const { loginUIState: loginUIState } = this.props;
            return loginUIState.authInfo.authMethods.size === 0 || loginUIState.authInfo.authMethods.size === 1 && loginUIState.authInfo.authMethods.has((0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_PASSWORD);
        }, this.renderNoLoginMethodPage = ()=>{
            const { intl: intl, helpCenterName: helpCenterName, isLoading: isLoading } = this.props;
            return /*#__PURE__*/ $4fqPo.createElement((0, $3KGZN.NoteContent), {
                isLoading: isLoading
            }, this.renderBackButton(), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                    size: "large"
                }, helpCenterName)
            }, /*#__PURE__*/ $4fqPo.createElement($8f1382e485508a54$export$8faa746ec8bdfab3, null, helpCenterName)), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), null, intl.formatMessage((0, $9gBNa.default).noLoginMethodWarningContent))
            }, /*#__PURE__*/ $4fqPo.createElement("p", null, intl.formatMessage((0, $9gBNa.default).noLoginMethodWarningContent))));
        }, this.renderLoginPage = ()=>{
            const { intl: intl, loginUIState: loginUIState } = this.props;
            let loginPage;
            if (loginUIState.showPasswordConfirmation) loginPage = this.renderForgotPasswordConfirmation();
            else if (loginUIState.authInfo.authMethods.has((0, $g01X2.AuthMethodType).CUSTOMER_ACCOUNT_SSO)) loginPage = this.renderSingleSignOnCustomer();
            else if (loginUIState.authInfo.authMethods.has((0, $g01X2.AuthMethodType).ATLASSIAN_ACCOUNT_SSO)) loginPage = this.renderSingleSignOn();
            else if (loginUIState.showSsoTestModeErrorPage) loginPage = this.renderSsoTestModeErrorPage();
            else if (loginUIState.atlassianAccountCheckPerformed) {
                if (this.isInvalidFedRampLogin() || this.isInvalidIcLogin()) loginPage = this.renderNoLoginMethodPage();
                else loginPage = this.renderLoginPasswordForm();
            } else loginPage = this.renderLoginForm();
            return /*#__PURE__*/ $4fqPo.createElement((0, $9Ut8d.default), {
                title: intl.formatMessage((0, $9gBNa.default).documentTitle)
            }, loginPage);
        };
    }
}
var $8f1382e485508a54$export$2e2bcd8739ae039 = (0, $efDRU.default)($8f1382e485508a54$export$21a94553ffa41578);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f1382e485508a54$var$LoginDescription = /*#__PURE__*/ (0, $el3DQ.default).h2.withConfig({
    componentId: "sc-1ifnvh3-0"
})`${(0, $4W9tu.h600)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f1382e485508a54$var$LoginFormContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ifnvh3-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f1382e485508a54$var$FooterContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ifnvh3-2"
})`margin-top:${"var(--ds-space-400, 32px)"};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f1382e485508a54$var$LoginAnnouncementContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ifnvh3-3"
})`padding-bottom:${"var(--ds-space-200, 16px)"};border-bottom:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f1382e485508a54$var$LoginAnnouncementTitle = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ifnvh3-4"
})`${(0, $4W9tu.h500)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $8f1382e485508a54$var$LoginAnnouncementBody = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1ifnvh3-5"
})`margin-top:${"var(--ds-space-100, 8px)"};max-width:${$bpWyP.multiple(42).px};overflow-wrap:break-word;`;
const $8f1382e485508a54$export$8faa746ec8bdfab3 = /*#__PURE__*/ (0, $el3DQ.default).h1.withConfig({
    componentId: "sc-1ifnvh3-6"
})`${(0, $4W9tu.h700)};`;

});
parcelRegister("4d0HX", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => (parcelRequire("3KGZN")).NoteContent);

var $3KGZN = parcelRequire("3KGZN");

});
parcelRegister("3KGZN", function(module, exports) {
$parcel$export(module.exports, "NoteContent", () => $17d8c8daf3e5d590$export$fe2e0d4376bdc305);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bpWyP = parcelRequire("bpWyP");
parcelRequire("8dHmf");
var $9tNgd = parcelRequire("9tNgd");
class $17d8c8daf3e5d590$export$fe2e0d4376bdc305 extends $4fqPo.Component {
    render() {
        return /*#__PURE__*/ $4fqPo.createElement($17d8c8daf3e5d590$var$NoteContentContainer, {
            isCentered: this.props.isCentered,
            "data-testid": "note-content-container"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $9tNgd.default), {
            isLoading: this.props.isLoading,
            loadingPosition: "fill-container"
        }, this.props.children));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $17d8c8daf3e5d590$var$NoteContentContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-x5t5ez-0"
})`margin:${"var(--ds-space-800, 64px)"};max-width:${$bpWyP.multiple(44).px};text-align:${(props)=>props.isCentered ? 'center' : 'start'};`;

});


parcelRegister("lPGvK", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeBanner", () => $8dbbcb842210ec1e$export$c5b94d186c592c02);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $8dbbcb842210ec1e$export$c5b94d186c592c02 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cpkUq")), {
        moduleId: "./src/view/sso-test-mode-banner/hocs.tsx"
    })
});

});
parcelRegister("cpkUq", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("ewcmz").then(()=>parcelRequire('64C4E'));

});


parcelRegister("g6gA9", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5a4e5399e3c1811$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addUFOCustomData", () => $f5a4e5399e3c1811$export$d12f56a472cdbe6c);

var $4fqPo = parcelRequire("4fqPo");

var $gE3od = parcelRequire("gE3od");

var $87Bg8 = parcelRequire("87Bg8");

var $c62a8 = parcelRequire("c62a8");
function $f5a4e5399e3c1811$export$2e2bcd8739ae039({ data: data }) {
    const interactionContext = (0, $4fqPo.useContext)((0, $gE3od.default));
    (0, $4fqPo.useMemo)(()=>{
        if (!interactionContext) return;
        if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $f5a4e5399e3c1811$export$d12f56a472cdbe6c(data) {
    const interactionId = (0, $87Bg8.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === 'function') (0, $c62a8.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $c62a8.addCustomData)(currentInteractionId, [], data);
}

});

parcelRegister("jeiAx", function(module, exports) {
$parcel$export(module.exports, "isValidAnnouncement", () => $1e21aac3276a4fb9$export$12ee192c1d1082df);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_TITLE_LIMIT", () => $1e21aac3276a4fb9$export$6cca6da7b99ee46e);
$parcel$export(module.exports, "DEFAULT_LANG_ANNOUNCEMENT_MESSAGE_LIMIT", () => $1e21aac3276a4fb9$export$24036c5b680cb85);
const $1e21aac3276a4fb9$export$12ee192c1d1082df = (header, message)=>header !== '' || message !== '';
const $1e21aac3276a4fb9$export$6cca6da7b99ee46e = 50;
const $1e21aac3276a4fb9$export$24036c5b680cb85 = 480;

});

parcelRegister("cuI6M", function(module, exports) {
$parcel$export(module.exports, "RedirectLoggedInUser", () => $275423fb53e78562$export$b883ffb676ea4071);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $3TeDY = parcelRequire("3TeDY");

var $81eJ3 = parcelRequire("81eJ3");

var $Y85G3 = parcelRequire("Y85G3");
const $275423fb53e78562$export$b883ffb676ea4071 = ({ portalId: portalId })=>{
    const { destination: destination } = (0, $Y85G3.parseLoginSignupRedirectUrlParams)();
    if ((0, $bG6ob.isHubsEnabledInHelpCenter)() && (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) || (0, $eSL4S.getIsHelpHub)()) {
        if (destination && (0, $3TeDY.isValidLocation)(destination)) {
            const relativeUrl = (0, $Y85G3.convertAbsoluteUrlToRelativeUrl)(destination);
            const redirectPath = `${(0, $3wR8f.getRelativeBasePath)()}${relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`}`;
            (0, $3TeDY.replace)(redirectPath);
        } else if (destination && decodeURIComponent(destination).startsWith('//')) (0, $3TeDY.replace)((0, $3wR8f.getRelativeBasePath)());
        else {
            const redirectPath = `${(0, $3wR8f.getRelativeBasePath)()}${destination ? `/${destination}` : ''}`;
            (0, $3TeDY.replace)(redirectPath);
        }
        return null;
    }
    if (destination) {
        if ((0, $3TeDY.isValidLocation)(destination)) {
            const relativeUrl = (0, $Y85G3.convertAbsoluteUrlToRelativeUrl)(destination);
            (0, $3TeDY.assign)(relativeUrl);
            return null;
        }
        if (decodeURIComponent(destination).startsWith('//')) {
            (0, $3TeDY.assign)((0, $Y85G3.getHelpCenterUrl)());
            return null;
        }
    }
    if ($275423fb53e78562$var$shouldExecuteFullPageReload(destination)) {
        // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        (0, $3TeDY.replace)(`${(0, $3wR8f.getRelativeBasePath)()}/${destination}`);
        return null;
    }
    const relativeDestination = `/${destination || (0, $Y85G3.getDefaultDestination)(portalId)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $81eJ3.Redirect), {
        to: relativeDestination
    });
};
const $275423fb53e78562$var$fullPageReloadPathsRegexs = [
    /^request\/[0-9]+\/attachment\/[0-9]+[/]?(\?.*)?$/,
    /^request\/[0-9]+\/attachment\/[0-9]+\/thumbnail[/]?(\?.*)?$/
];
/**
 * Some URLs, even though they start with /servicedesk/customer, don't have any specific component mapped to that route.
 * When customers account log in the portal will simply do an SPA redirection and it will end up in 404
 * This method will allow for these "special" URLs to execute a full page reload after a customer account logs in.
 */ const $275423fb53e78562$var$shouldExecuteFullPageReload = (destination)=>{
    if (destination) return $275423fb53e78562$var$fullPageReloadPathsRegexs.some((regex)=>regex.test(destination));
    return false;
};

});

parcelRegister("ly1SE", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b3ce8e043f077d1$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eQdiM = parcelRequire("eQdiM");

var $63KX8 = parcelRequire("63KX8");
const $0b3ce8e043f077d1$var$ThemedBackButton = (props)=>{
    const { children: children, onClick: onClick, actionSubjectId: actionSubjectId, appearance: appearance } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0b3ce8e043f077d1$var$BackButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eQdiM.ThemedButton), {
        iconBefore: // Icon is decorative — adjacent button text already conveys the label
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63KX8))), {
            spacing: "spacious",
            label: ""
        }),
        appearance: appearance,
        spacing: "compact",
        actionSubjectId: actionSubjectId,
        onClick: onClick
    }, children));
};
var $0b3ce8e043f077d1$export$2e2bcd8739ae039 = $0b3ce8e043f077d1$var$ThemedBackButton;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0b3ce8e043f077d1$var$BackButtonWrapper = /*#__PURE__*/ (0, $el3DQ.default).span.withConfig({
    componentId: "sc-x420oi-0"
})`margin-left:${"var(--ds-space-negative-200, -16px)"};`;

});

parcelRegister("lzaX3", function(module, exports) {
$parcel$export(module.exports, "SsoTestModeErrorPage", () => (parcelRequire("hcjJC")).default);

var $hcjJC = parcelRequire("hcjJC");

});
parcelRegister("hcjJC", function(module, exports) {
$parcel$export(module.exports, "default", () => $edf478a5ff3f8c10$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $8Gf3q = parcelRequire("8Gf3q");

var $iEknj = parcelRequire("iEknj");

var $dQegt = parcelRequire("dQegt");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");
var $e2Zgo = parcelRequire("e2Zgo");

var $WVSzu = parcelRequire("WVSzu");

var $fwSzd = parcelRequire("fwSzd");

var $2swTK = parcelRequire("2swTK");
const $edf478a5ff3f8c10$var$LEARN_MORE_LINK = 'https://support.atlassian.com/jira-service-management-cloud/docs/test-single-sign-on-for-customer-login/';
const $edf478a5ff3f8c10$var$CaSsoTestModeErrorPage = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ $4fqPo.createElement($edf478a5ff3f8c10$var$Container, {
        "data-test-id": "ca-sso-test-mode-error-screen-container"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), /*#__PURE__*/ $4fqPo.createElement($edf478a5ff3f8c10$var$IconContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $iEknj.default), null)), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
            paddingBlockEnd: "space.050"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
            size: "medium"
        }, formatMessage((0, $2swTK.default).title)))
    }, /*#__PURE__*/ $4fqPo.createElement($edf478a5ff3f8c10$var$Title, null, formatMessage((0, $2swTK.default).title))), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), null, formatMessage((0, $2swTK.default).instructionMessage))
    }, /*#__PURE__*/ $4fqPo.createElement("p", null, formatMessage((0, $2swTK.default).instructionMessage))), /*#__PURE__*/ $4fqPo.createElement((0, $8Gf3q.default), {
        actionSubjectId: "learnMoreSsoTestMode",
        href: $edf478a5ff3f8c10$var$LEARN_MORE_LINK,
        target: "_blank"
    }, formatMessage((0, $2swTK.default).learnMoreLinkLabel)));
};
var $edf478a5ff3f8c10$export$2e2bcd8739ae039 = $edf478a5ff3f8c10$var$CaSsoTestModeErrorPage;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $edf478a5ff3f8c10$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1q5wzvf-0"
})`text-align:center;> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $edf478a5ff3f8c10$var$Title = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1q5wzvf-1"
})`${(0, $4W9tu.h600)};margin-bottom:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $edf478a5ff3f8c10$var$IconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1q5wzvf-2"
})`width:${$bpWyP.multiple(10.5).px};margin:0 auto ${"var(--ds-space-300, 24px)"} auto;`;

});
parcelRegister("2swTK", function(module, exports) {
$parcel$export(module.exports, "default", () => $78ebdcb683418d54$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $78ebdcb683418d54$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    learnMoreLinkLabel: {
        defaultMessage: 'Learn more about testing single sign-on',
        description: 'label for learn more link for sso test mode failure',
        id: 'cv.login.ca.sso.test.mode.error.learn.more.label'
    },
    instructionMessage: {
        defaultMessage: 'Turn on the single sign-on test mode in your Authentication settings.',
        description: 'message with instruction for SSO test mode',
        id: 'cv.login.ca.sso.test.mode.error.instruction.message'
    },
    title: {
        defaultMessage: 'Single Sign-on test mode is disabled',
        description: 'title for SSO test mode error page',
        id: 'cv.login.ca.sso.test.mode.error.title'
    }
});

});



parcelRegister("i77IN", function(module, exports) {
$parcel$export(module.exports, "ForgotPasswordConfirmation", () => (parcelRequire("evjMw")).default);

var $evjMw = parcelRequire("evjMw");

});
parcelRegister("evjMw", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd6cb58d81502f89$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $gBYjj = parcelRequire("gBYjj");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");

var $5vgaT = parcelRequire("5vgaT");
var $fd6cb58d81502f89$export$2e2bcd8739ae039 = (0, $bmgw6.default)((state)=>({
        baseUrl: (0, $2mzxy.getBaseUrl)(state)
    }), {
    resetLoginAction: (0, $8o5VQ.resetLogin),
    onResendLinkError: (0, $gBYjj.handleAjaxError),
    onResendSuccess: (0, $gBYjj.showSuccessFlag)
})((0, $5vgaT.default));

});
parcelRegister("5vgaT", function(module, exports) {
$parcel$export(module.exports, "default", () => $56a542c8455b3928$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $eQdiM = parcelRequire("eQdiM");

var $5Uaxl = parcelRequire("5Uaxl");
var $efDRU = parcelRequire("efDRU");

var $kV63N = parcelRequire("kV63N");

var $ly1SE = parcelRequire("ly1SE");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");
var $e2Zgo = parcelRequire("e2Zgo");

var $WVSzu = parcelRequire("WVSzu");

var $fwSzd = parcelRequire("fwSzd");

var $Y85G3 = parcelRequire("Y85G3");

var $9gBNa = parcelRequire("9gBNa");

var $awtoK = parcelRequire("awtoK");
class $56a542c8455b3928$export$3ed80e0e31a57da extends $4fqPo.Component {
    render() {
        return /*#__PURE__*/ $4fqPo.createElement($56a542c8455b3928$var$Container, {
            "data-test-id": "forgot-password-container"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), this.renderContent());
    }
    constructor(...args){
        super(...args), this.state = {
            isSendingForgotPasswordEmail: false
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $Y85G3.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onResendButtonClick = ()=>{
            this.setState({
                isSendingForgotPasswordEmail: true
            });
            const redirectUrl = this.getRedirectUrl(this.props.baseUrl);
            (0, $kV63N.forgotPassword)(this.props.resetUrl, this.props.email, redirectUrl).toPromise().then(()=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendSuccess((0, $awtoK.default).resendSuccessMessage, {
                    emailAddress: this.props.email
                });
            }).catch((err)=>{
                this.setState({
                    isSendingForgotPasswordEmail: false
                });
                this.props.onResendLinkError(err);
            });
        }, this.renderContent = ()=>{
            const { intl: intl, email: email, helpCenterName: helpCenterName, onBackButtonClick: onBackButtonClick } = this.props;
            return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $ly1SE.default), {
                appearance: "link",
                onClick: onBackButtonClick,
                actionSubjectId: "returnToLogin"
            }, intl.formatMessage((0, $9gBNa.default).backButton)), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                    paddingBlockEnd: "space.300"
                }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                    size: "large"
                }, helpCenterName))
            }, /*#__PURE__*/ $4fqPo.createElement($56a542c8455b3928$var$Title, null, helpCenterName)), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                    size: "medium"
                }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $awtoK.default).checkYourEmail))
            }, /*#__PURE__*/ $4fqPo.createElement($56a542c8455b3928$var$Subtitle, null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $awtoK.default).checkYourEmail))), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), null, intl.formatMessage((0, $awtoK.default).emailHasBeenSentMessage, {
                    emailAddress: email
                }))
            }, /*#__PURE__*/ $4fqPo.createElement("div", null, intl.formatMessage((0, $awtoK.default).emailHasBeenSentMessage, {
                emailAddress: email
            }))), /*#__PURE__*/ $4fqPo.createElement((0, $eQdiM.ThemedButton), {
                appearance: 'primary',
                onClick: this.onResendButtonClick,
                actionSubjectId: "returnToLogin",
                shouldFitContainer: true,
                isLoading: this.state.isSendingForgotPasswordEmail
            }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $awtoK.default).resendResetPasswordLinkLabel)));
        };
    }
}
var $56a542c8455b3928$export$2e2bcd8739ae039 = (0, $efDRU.default)($56a542c8455b3928$export$3ed80e0e31a57da);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $56a542c8455b3928$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-11c9vcd-0"
})`> *{margin-bottom:${"var(--ds-space-300, 24px)"};}> *:last-child{margin-bottom:0;}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $56a542c8455b3928$var$Title = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-11c9vcd-1"
})`${(0, $4W9tu.h700)};margin-bottom:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $56a542c8455b3928$var$Subtitle = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-11c9vcd-2"
})`${(0, $4W9tu.h600)};`;

});
parcelRegister("9gBNa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d81b85e5a5238528$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $d81b85e5a5238528$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    documentTitle: {
        defaultMessage: 'Customer Login - Help Center',
        description: 'Login page document title',
        id: 'cv.login.document.title'
    },
    header: {
        defaultMessage: 'Log in to {helpCenterName}',
        description: 'Page header',
        id: 'cv.login.header'
    },
    helpCenterLink: {
        defaultMessage: 'Go to { helpCenterName } home page',
        description: 'Text for link that redirects to the portals home page',
        id: 'cv.login.helpcenter.link'
    },
    description: {
        defaultMessage: 'Enter your email to log in or sign up',
        description: 'Description shown about the initial login screen',
        id: 'cv.login.description'
    },
    descriptionLogin: {
        defaultMessage: 'Log in to continue',
        description: 'Description shown after email check is customer login',
        id: 'cv.login.description.login'
    },
    useAtlassianAccountLogin: {
        defaultMessage: 'Use Atlassian account to log in',
        description: 'Description shown when login form is in atlassian SSO state',
        id: 'cv.login.use.atlassian.account.log.in'
    },
    useAtlassianAccountSignup: {
        defaultMessage: 'Use Atlassian account to sign up',
        description: 'Description shown when login form is in atlassian JIT state',
        id: 'cv.login.use.atlassian.account.sign.up'
    },
    backButton: {
        defaultMessage: 'Back',
        description: 'Button text for navigating back in the login screen',
        id: 'cv.login.back.button'
    },
    noLoginMethodWarningContent: {
        defaultMessage: 'Access to the help center is unavailable. Try again later or contact your admin for assistance.',
        description: 'No available login method warning content',
        id: 'cv.login.no.login.method.warning.content'
    }
});

});

parcelRegister("awtoK", function(module, exports) {
$parcel$export(module.exports, "default", () => $574bc4a2a86b420a$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $574bc4a2a86b420a$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    checkYourEmail: {
        defaultMessage: 'Check your email to reset your password',
        description: 'Help text to tell user check their mailbox for reset password email',
        id: 'cv.login.forgot.password.check.your.email'
    },
    emailHasBeenSentMessage: {
        defaultMessage: "We've sent a reset password link to {emailAddress}",
        description: 'A help text to inform the user that email has been sent',
        id: 'cv.login.forgot.password.email.has.been.sent'
    },
    resendResetPasswordLinkLabel: {
        defaultMessage: 'Resend reset password link',
        description: 'label for Resend reset password link button',
        id: 'cv.login.forgot.password.resend.button.label'
    },
    resendSuccessMessage: {
        defaultMessage: 'Email sent to {emailAddress}',
        description: 'email sent success message',
        id: 'cv.login.forgot.password.resend.success.flag.message'
    }
});

});




parcelRegister("3PuQ6", function(module, exports) {
$parcel$export(module.exports, "LoginAnnouncement", () => (parcelRequire("360DG")).default);

var $360DG = parcelRequire("360DG");

});
parcelRegister("360DG", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbd724ee4d3fb883$export$2e2bcd8739ae039);

var $eLaJd = parcelRequire("eLaJd");

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $bpWyP = parcelRequire("bpWyP");

var $a7SRW = parcelRequire("a7SRW");

var $1BEGf = parcelRequire("1BEGf");

var $gIeP2 = parcelRequire("gIeP2");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $jeiAx = parcelRequire("jeiAx");
// Since LoginAnnouncement epic is made for home page which get messages as plain text, we can't use this epic for our use case, hence we are using useLazyLoadQuery to get the data using graphql query
const $dbd724ee4d3fb883$var$LoginAnnouncement = ()=>{
    var _data$helpCenter, _data$helpCenter2;
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $eLaJd.default), {
        helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
        cloudId: (0, $6mmHn.getCloudId)()
    });
    const responseTypeName = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.__typename;
    if (responseTypeName !== 'HelpCenter') // not displaying anything if the response is not of type HelpCenter
    return null;
    // As confirmed by the backend team, there will be only one login announcement for now, hence using the first element
    const announcementDetails = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.announcements) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.loginAnnouncements) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2[0];
    const loginAnnouncementSubject = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.name) ?? '';
    const loginAnnouncementMessage = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.description) ?? '';
    const loginAnnouncementDescriptionType = (announcementDetails === null || announcementDetails === void 0 ? void 0 : announcementDetails.descriptionType) ?? '';
    const isAnnouncementValid = (0, $jeiAx.isValidAnnouncement)(loginAnnouncementSubject, loginAnnouncementMessage);
    if (!isAnnouncementValid) // not displaying anything if the announcement is not valid or the description type is not WIKI_MARKUP
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $dbd724ee4d3fb883$var$loginAnnouncementContainerStyles
    }, loginAnnouncementSubject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "small"
    }, loginAnnouncementSubject) : null, loginAnnouncementMessage && loginAnnouncementDescriptionType === 'WIKI_MARKUP' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $dbd724ee4d3fb883$var$loginAnnouncementBodyStyles,
        dangerouslySetInnerHTML: {
            __html: (0, $bG6ob.isIsomorphicDompurifyLibUsed)() ? (0, $1BEGf.sanitize)(loginAnnouncementMessage) : (0, $a7SRW.sanitize)(loginAnnouncementMessage)
        }
    }) : null);
};
const $dbd724ee4d3fb883$var$LoginAnnouncementLoader = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).LOGIN,
        id: 'login-announcements'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($dbd724ee4d3fb883$var$LoginAnnouncement, null)));
};
var $dbd724ee4d3fb883$export$2e2bcd8739ae039 = $dbd724ee4d3fb883$var$LoginAnnouncementLoader;
const $dbd724ee4d3fb883$var$loginAnnouncementContainerStyles = (0, $2m8U6.xcss)({
    marginTop: 'space.300',
    paddingBottom: 'space.200',
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"}`
});
const $dbd724ee4d3fb883$var$loginAnnouncementBodyStyles = (0, $2m8U6.xcss)({
    marginTop: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    maxWidth: $bpWyP.multiple(42).px,
    overflowWrap: 'break-word'
});

});
parcelRegister("eLaJd", function(module, exports) {
$parcel$export(module.exports, "default", () => $970ba87ec34e9893$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3d45b845761ae33b6af2ca93974f3307>>
 * @relayHash 81efd7e37c8c0c5533e02b03e01e4763
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2
const $970ba87ec34e9893$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterAnnouncements",
        "kind": "LinkedField",
        "name": "announcements",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterAnnouncement",
                "kind": "LinkedField",
                "name": "loginAnnouncements",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "descriptionType"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "loginAnnouncementsCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "3bb061da4730c40a436a93422bb41d959c3d9096b82b057c2c588b7f9da0d6b2",
            "metadata": {},
            "name": "loginAnnouncementsCardQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$970ba87ec34e9893$var$node.hash = "263cd15a061b12291f170e7431e9e440";
var $970ba87ec34e9893$export$2e2bcd8739ae039 = $970ba87ec34e9893$var$node;

});



parcelRegister("72XWM", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => (parcelRequire("1YvAz")).default);

var $1YvAz = parcelRequire("1YvAz");

});
parcelRegister("1YvAz", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8c7a3282a3afd37$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");
parcelRequire("8bE9a");
var $8o5VQ = parcelRequire("8o5VQ");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("6LpYP");
var $kR2PX = parcelRequire("kR2PX");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $kxpSp = parcelRequire("kxpSp");
var $c8c7a3282a3afd37$export$2e2bcd8739ae039 = (0, $bmgw6.default)((state)=>({
        loginAnnouncementLocale: (0, $kR2PX.getLoginAnnouncementLocale)(state),
        baseUrl: (0, $2mzxy.getBaseUrl)(state)
    }), {
    changeEmailInputAction: (0, $8o5VQ.changeEmailInput),
    checkLoginActionAction: (0, $8o5VQ.checkLoginAction),
    forgotPasswordAction: (0, $8o5VQ.forgotPassword),
    createPasswordAction: (0, $8o5VQ.createPassword),
    loginAttemptAction: (0, $8o5VQ.loginAttempt),
    resetLoginAction: (0, $8o5VQ.resetLogin)
})((0, $apbG6.default)({
    componentName: 'loginForm'
})((0, $as4kh.default)()((0, $kxpSp.LoginForm))));

});
parcelRegister("kxpSp", function(module, exports) {
$parcel$export(module.exports, "LoginForm", () => $79dc24fe9dfce063$export$1f58f750f20f344b);

var $4fqPo = parcelRequire("4fqPo");

var $iLkO5 = parcelRequire("iLkO5");

var $bG6ob = parcelRequire("bG6ob");

var $kV63N = parcelRequire("kV63N");

var $lh2vS = parcelRequire("lh2vS");

var $3wR8f = parcelRequire("3wR8f");

var $3TeDY = parcelRequire("3TeDY");

var $Y85G3 = parcelRequire("Y85G3");

var $Y85G3 = parcelRequire("Y85G3");
parcelRequire("jAF9X");
var $2uZg5 = parcelRequire("2uZg5");

var $gJUDb = parcelRequire("gJUDb");
// eslint-disable-next-line no-useless-escape
const $79dc24fe9dfce063$var$EMAIL_PATTERN = /.+\@.+\..+/;
class $79dc24fe9dfce063$export$1f58f750f20f344b extends $4fqPo.Component {
    buildAuthDataRequest() {
        const isInIframe = window.self !== window.top;
        const { destination: destination, isAbsolute: isAbsolute } = (0, $Y85G3.parseLoginSignupRedirectUrlParams)();
        const prefix = destination && isAbsolute ? '' : `${(0, $3wR8f.getBaseName)()}/`;
        const redirectUrl = `${prefix}${destination || this.getDefaultDestination()}`;
        const params = new URLSearchParams((0, $3TeDY.search)());
        return isInIframe && (0, $bG6ob.isJsmPortalRovoIntegrationEnabled)() ? {
            ssoTest: (0, $Y85G3.getSsoTestModeParamFromUrl)(params),
            redirectTo: '/servicedesk/customer/embeds/login-success',
            absoluteRedirectUrl: false
        } : {
            ssoTest: (0, $Y85G3.getSsoTestModeParamFromUrl)(params),
            redirectTo: redirectUrl,
            absoluteRedirectUrl: isAbsolute
        };
    }
    render() {
        var _loginUIState$loginAt;
        const { canResetPassword: canResetPassword, loginUIState: loginUIState, contactAdminLink: contactAdminLink, loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        const { validEmail: validEmail, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit, password: password } = this.state;
        return /*#__PURE__*/ $4fqPo.createElement((0, $2uZg5.default), {
            isSubmitting: loginUIState.isSubmitting,
            isSendingForgotPasswordEmail: loginUIState.isSendingForgotPasswordEmail,
            isSendingCreatePasswordEmail: loginUIState.isSendingCreatePasswordEmail,
            onSubmit: this.onSubmit,
            onEmailFieldChange: this.onEmailFieldChange,
            onPasswordChange: this.onPasswordChange,
            validEmail: validEmail,
            isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit,
            email: loginUIState.email,
            password: password,
            loginError: this.getLoginError(),
            atlassianAccountCheckPerformed: loginUIState.atlassianAccountCheckPerformed,
            loginFailure: (_loginUIState$loginAt = loginUIState.loginAttemptResponse) === null || _loginUIState$loginAt === void 0 ? void 0 : _loginUIState$loginAt.error,
            showLoginConsentError: loginUIState.showLoginConsentErrorPage,
            createAnalyticsEvent: this.props.createAnalyticsEvent,
            onEmailFieldFocus: this.onEmailFieldFocus,
            onForgotPasswordLinkClick: this.onForgotPasswordLinkClick,
            onCreatePasswordLinkClick: this.onCreatePasswordLinkClick,
            contactAdminLink: contactAdminLink,
            canResetPassword: canResetPassword,
            loginAnnouncementLocale: loginAnnouncementLocale
        });
    }
    constructor(...args){
        super(...args), this.state = {
            password: '',
            validEmail: true,
            isPasswordEmptyOnSubmit: false
        }, this.onEmailFieldChange = (email)=>{
            this.props.changeEmailInputAction(email);
        }, this.onEmailFieldFocus = ()=>{
            if (!this.props.loginUIState.email) this.props.resetLoginAction(this.props.loginUIState.email);
        }, this.onPasswordChange = (password)=>{
            this.setState({
                password: password
            });
        }, this.validateEmail = ()=>{
            const validEmail = $79dc24fe9dfce063$var$EMAIL_PATTERN.test(this.props.loginUIState.email);
            this.setState({
                validEmail: validEmail
            });
            return validEmail;
        }, this.onSubmit = ()=>{
            if (this.validateEmail()) {
                const { loginUIState: loginUIState, loginAttemptAction: loginAttemptAction, checkLoginActionAction: checkLoginActionAction, createAnalyticsEvent: createAnalyticsEvent, continueParam: continueParam } = this.props;
                const authData = this.buildAuthDataRequest();
                const { password: password } = this.state;
                if (loginUIState.atlassianAccountCheckPerformed) {
                    const isPasswordEmptyOnSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($iLkO5)))(password);
                    this.setState({
                        isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit
                    });
                    if (!isPasswordEmptyOnSubmit) loginAttemptAction({
                        password: password,
                        continueParam: continueParam,
                        email: loginUIState.email.trim()
                    });
                } else checkLoginActionAction(loginUIState.email.trim(), this.props.portalId, authData, createAnalyticsEvent);
            } else (0, $lh2vS.focus)('user-email');
        }, this.getDefaultDestination = ()=>{
            const { portalId: portalId } = this.props;
            if (portalId) return `portal/${portalId}`;
            return 'portals';
        }, this.getRedirectUrl = (baseUrl)=>{
            return (0, $Y85G3.getRedirectUrlForSignupAndResetPasswordRequestParam)(baseUrl);
        }, this.onForgotPasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, forgotPasswordAction: forgotPasswordAction, resetUrl: resetUrl, baseUrl: baseUrl } = this.props;
            const redirectUrl = this.getRedirectUrl(baseUrl);
            forgotPasswordAction(resetUrl, loginUIState.email.trim(), redirectUrl);
        }, this.onCreatePasswordLinkClick = ()=>{
            const { loginUIState: loginUIState, createPasswordAction: createPasswordAction, resetUrl: resetUrl } = this.props;
            createPasswordAction(resetUrl, loginUIState.email.trim());
        }, this.getLoginError = ()=>{
            const { error: error, loginAttemptResponse: loginAttemptResponse } = this.props.loginUIState;
            if (error) return error.description;
            const loginFailure = loginAttemptResponse === null || loginAttemptResponse === void 0 ? void 0 : loginAttemptResponse.error;
            if (loginFailure) switch(loginFailure.errorType){
                case (0, $kV63N.LoginAttemptErrorType).INVALID_CREDENTIALS:
                    return (0, $gJUDb.default).invalidLogin;
                case (0, $kV63N.LoginAttemptErrorType).ACCOUNT_LOCKED_ERROR:
                    return (0, $gJUDb.default).accountLocked;
                case (0, $kV63N.LoginAttemptErrorType).MISC_LOGIN_ERROR:
                default:
                    return (0, $gJUDb.default).miscLoginError;
            }
            return undefined;
        };
    }
}

});
parcelRegister("jAF9X", function(module, exports) {
$parcel$export(module.exports, "LoginFormStateless", () => (parcelRequire("2uZg5")).default);

var $2uZg5 = parcelRequire("2uZg5");

});
parcelRegister("2uZg5", function(module, exports) {
$parcel$export(module.exports, "default", () => $d24a80e59a587cd4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eQdiM = parcelRequire("eQdiM");

var $5Uaxl = parcelRequire("5Uaxl");
var $efDRU = parcelRequire("efDRU");

var $kV63N = parcelRequire("kV63N");
parcelRequire("a0HIf");
var $f0qQ5 = parcelRequire("f0qQ5");
parcelRequire("c71sY");
var $jwI0L = parcelRequire("jwI0L");
parcelRequire("5yD7X");
var $lJn7w = parcelRequire("lJn7w");
parcelRequire("7pXnH");
var $i14ap = parcelRequire("i14ap");

var $fFB0R = parcelRequire("fFB0R");

var $e2Zgo = parcelRequire("e2Zgo");

var $kQ4cG = parcelRequire("kQ4cG");

var $54jwS = parcelRequire("54jwS");

var $WVSzu = parcelRequire("WVSzu");

var $lh2vS = parcelRequire("lh2vS");

var $fwSzd = parcelRequire("fwSzd");

var $3wR8f = parcelRequire("3wR8f");

var $3TeDY = parcelRequire("3TeDY");

var $f1NTg = parcelRequire("f1NTg");
const $d24a80e59a587cd4$var$USER_EMAIL_ID = 'user-email';
const $d24a80e59a587cd4$var$SUBMIT_BUTTON_ID = 'login-button';
const $d24a80e59a587cd4$var$USER_PASSWORD_ID = 'user-password';
class $d24a80e59a587cd4$export$464b5747f72597dd extends $4fqPo.Component {
    getForm() {
        return /*#__PURE__*/ $4fqPo.createElement($d24a80e59a587cd4$var$Form, {
            id: "login-form",
            "data-testid": "login-form",
            onSubmit: this.onSubmit
        }, this.getLoginError(), this.getLoginConsentError(), this.getEmailField(), this.getPasswordField(), this.getSubmitButton());
    }
    render() {
        const { loginAnnouncementLocale: loginAnnouncementLocale } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: loginAnnouncementLocale ? {
                attributes: {
                    loginAnnouncementLocale: loginAnnouncementLocale
                }
            } : {}
        }, this.getForm(), this.getForgotPasswordLink(), this.getSetPasswordLink(), /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null));
    }
    constructor(...args){
        super(...args), this.onSubmit = (event)=>{
            if (event) event.preventDefault();
            // We need to do this here in order to work on chrome. Calling this method on password field focus
            // had no effect.
            this.blurEmailFieldAndFocusSubmitButton();
            this.cleanErrorCodeFromParams();
            this.props.onSubmit();
        }, this.blurEmailFieldAndFocusSubmitButton = ()=>{
            /*
     * We need to blur the email field this way because when typing an email clicking the submit button after (for checking atlassian account)
     * does not blur the email field on Chrome and Edge. So after clicking the button it looks like the email and password field have the focus.
     * There is no way to reference the html element on @atlaskit/textfield that's why we use document.getElementById .
     */ (0, $lh2vS.blur)($d24a80e59a587cd4$var$USER_EMAIL_ID);
            /*
     * In order to create an understandable focus state on errors (and it will be the same one when using keyboard or clicking the button)
     * we need to focus the button after calling blur on the email text field.
     */ (0, $lh2vS.focus)($d24a80e59a587cd4$var$SUBMIT_BUTTON_ID);
        }, this.cleanErrorCodeFromParams = ()=>{
            const params = new URLSearchParams((0, $3TeDY.search)());
            if (params.has('error_code')) {
                params.delete('error_code');
                (0, $3wR8f.default).replace({
                    search: params.toString()
                });
            }
        }, this.onEmailFieldChange = (_, email)=>{
            this.props.onEmailFieldChange(email);
        }, this.onPasswordChange = (password)=>{
            this.props.onPasswordChange(password);
        }, this.getEmailErrorMessage = ()=>{
            if (this.props.validEmail) return undefined;
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $f1NTg.default).invalidEmailError);
        }, this.getPasswordErrorMessage = ()=>{
            const { intl: intl } = this.props;
            if (this.props.isPasswordEmptyOnSubmit) return intl.formatMessage((0, $f1NTg.default).emptyPasswordError);
            return intl.formatMessage((0, $f1NTg.default).incorrectPasswordError);
        }, this.getPasswordField = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, password: password, intl: intl, loginFailure: loginFailure, isPasswordEmptyOnSubmit: isPasswordEmptyOnSubmit } = this.props;
            if (atlassianAccountCheckPerformed) {
                const isInvalid = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) === (0, $kV63N.LoginAttemptErrorType).INVALID_CREDENTIALS || isPasswordEmptyOnSubmit;
                const passwordLabelAndPlaceholder = intl.formatMessage((0, $f1NTg.default).passwordLabelAndPlaceholder);
                return /*#__PURE__*/ $4fqPo.createElement((0, $jwI0L.default), {
                    label: passwordLabelAndPlaceholder,
                    htmlFor: $d24a80e59a587cd4$var$USER_PASSWORD_ID
                }, /*#__PURE__*/ $4fqPo.createElement((0, $i14ap.default), {
                    id: $d24a80e59a587cd4$var$USER_PASSWORD_ID,
                    testId: $d24a80e59a587cd4$var$USER_PASSWORD_ID,
                    value: password,
                    onChange: this.onPasswordChange,
                    isDisabled: isSubmitting || isSendingForgotPasswordEmail,
                    errorMessage: this.getPasswordErrorMessage(),
                    isInvalid: isInvalid,
                    hideStrengthMeter: true,
                    autoFocus: true
                }));
            }
            return undefined;
        }, this.getButtonText = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, intl: intl } = this.props;
            if (!atlassianAccountCheckPerformed) return intl.formatMessage((0, $f1NTg.default).nextButton);
            return intl.formatMessage((0, $f1NTg.default).continueButton);
        }, this.getSetPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onCreatePasswordLinkClick: onCreatePasswordLinkClick, isSubmitting: isSubmitting, isSendingCreatePasswordEmail: isSendingCreatePasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword && onCreatePasswordLinkClick) return /*#__PURE__*/ $4fqPo.createElement($d24a80e59a587cd4$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $4fqPo.createElement("div", null, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $f1NTg.default).dontHavePasswordText)), /*#__PURE__*/ $4fqPo.createElement((0, $eQdiM.ThemedButton), {
                id: "set-password-link",
                testId: "set-password-link",
                appearance: "link",
                onClick: onCreatePasswordLinkClick,
                actionSubjectId: "createPassword",
                isDisabled: isSubmitting,
                isLoading: isSendingCreatePasswordEmail
            }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $f1NTg.default).createPasswordLink)));
            return undefined;
        }, this.getForgotPasswordLink = ()=>{
            const { atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, canResetPassword: canResetPassword, onForgotPasswordLinkClick: onForgotPasswordLinkClick, intl: intl, isSubmitting: isSubmitting, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail } = this.props;
            if (atlassianAccountCheckPerformed && canResetPassword) {
                const linkText = intl.formatMessage((0, $f1NTg.default).resetPasswordLink);
                return /*#__PURE__*/ $4fqPo.createElement($d24a80e59a587cd4$var$ForgotPasswordLinkContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $eQdiM.ThemedButton), {
                    id: "forgot-password-link",
                    testId: "forgot-password-link",
                    appearance: "link",
                    onClick: onForgotPasswordLinkClick,
                    actionSubjectId: "forgotPassword",
                    isDisabled: isSubmitting,
                    isLoading: isSendingForgotPasswordEmail
                }, linkText));
            }
            return undefined;
        }, this.getLoginError = ()=>{
            return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, this.getErrorFromParams(), this.getLoginErrorOnSubmitting());
        }, this.getLoginConsentError = ()=>{
            if (this.props.showLoginConsentError) {
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                createAnalyticsEvent && createAnalyticsEvent({
                    analyticsType: (0, $54jwS.UI_EVENT_TYPE),
                    action: 'viewed',
                    actionSubjectId: `showConsentError`
                }).fire();
                return /*#__PURE__*/ $4fqPo.createElement((0, $kQ4cG.default), {
                    appearance: "warning",
                    testId: "login-consent-error"
                }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $f1NTg.default).loginConsentErrorMessage));
            }
            return undefined;
        }, this.getLoginErrorOnSubmitting = ()=>{
            const { intl: intl, loginError: loginError, loginFailure: loginFailure, contactAdminLink: contactAdminLink } = this.props;
            const notInvalidCredentials = (loginFailure === null || loginFailure === void 0 ? void 0 : loginFailure.errorType) !== (0, $kV63N.LoginAttemptErrorType).INVALID_CREDENTIALS;
            if (loginError && notInvalidCredentials) return /*#__PURE__*/ $4fqPo.createElement("div", {
                "aria-live": "assertive",
                role: "alert"
            }, /*#__PURE__*/ $4fqPo.createElement((0, $kQ4cG.default), {
                appearance: "error",
                testId: "login-error-on-submit-section"
            }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
                ...loginError,
                values: {
                    contactAdminLink: /*#__PURE__*/ $4fqPo.createElement($d24a80e59a587cd4$export$8ffc1cb9f69665da, {
                        dangerouslySetInnerHTML: {
                            __html: contactAdminLink
                        }
                    }),
                    forgotPasswordLink: /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                        migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), {
                            weight: "semibold"
                        }, intl.formatMessage((0, $f1NTg.default).resetPasswordLinkInlineBold))
                    }, /*#__PURE__*/ $4fqPo.createElement("strong", null, intl.formatMessage((0, $f1NTg.default).resetPasswordLinkInlineBold)))
                }
            })));
            return undefined;
        }, this.getErrorFromParams = ()=>{
            const { intl: intl } = this.props;
            const params = new URLSearchParams((0, $3TeDY.search)());
            const errorCode = params.get('error_code');
            if (errorCode) {
                const errorMessage = errorCode === 'access_denied' ? intl.formatMessage((0, $f1NTg.default).accessDeniedErrorCodeMessage) : intl.formatMessage((0, $f1NTg.default).defaultErrorCodeMessage);
                return /*#__PURE__*/ $4fqPo.createElement((0, $kQ4cG.default), {
                    appearance: "error"
                }, errorMessage);
            }
            return undefined;
        }, this.getEmailField = ()=>{
            const { intl: intl, isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed, email: email, onEmailFieldFocus: onEmailFieldFocus } = this.props;
            return /*#__PURE__*/ $4fqPo.createElement((0, $f0qQ5.default), {
                name: 'login-email-field'
            }, /*#__PURE__*/ $4fqPo.createElement((0, $lJn7w.default), {
                id: $d24a80e59a587cd4$var$USER_EMAIL_ID,
                shouldFitContainer: true,
                label: intl.formatMessage((0, $f1NTg.default).emailLabel),
                onChange: this.onEmailFieldChange,
                errorMessage: this.getEmailErrorMessage(),
                ariaDescribedby: "field-error",
                disabled: isSubmitting || isSendingForgotPasswordEmail || atlassianAccountCheckPerformed,
                defaultValue: email,
                onFocus: onEmailFieldFocus,
                autoComplete: "email",
                autoFocus: !this.props.showLoginConsentError
            }));
        }, this.getSubmitButton = ()=>{
            const { isSendingForgotPasswordEmail: isSendingForgotPasswordEmail, isSubmitting: isSubmitting, atlassianAccountCheckPerformed: atlassianAccountCheckPerformed } = this.props;
            const buttonText = this.getButtonText();
            const buttonActionSubjectId = atlassianAccountCheckPerformed ? 'submitLoginForm' : 'checkLoginEmail';
            return /*#__PURE__*/ $4fqPo.createElement((0, $eQdiM.ThemedButton), {
                id: $d24a80e59a587cd4$var$SUBMIT_BUTTON_ID,
                testId: $d24a80e59a587cd4$var$SUBMIT_BUTTON_ID,
                type: "submit",
                appearance: "primary",
                shouldFitContainer: true,
                isLoading: isSubmitting,
                isDisabled: isSendingForgotPasswordEmail,
                actionSubjectId: buttonActionSubjectId
            }, buttonText);
        };
    }
}
var $d24a80e59a587cd4$export$2e2bcd8739ae039 = (0, $efDRU.default)($d24a80e59a587cd4$export$464b5747f72597dd);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d24a80e59a587cd4$var$Form = /*#__PURE__*/ (0, $el3DQ.default).form.withConfig({
    componentId: "sc-1wf191w-0"
})`#login-button{margin-top:${"var(--ds-space-300, 24px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d24a80e59a587cd4$var$ForgotPasswordLinkContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1wf191w-1"
})`margin-top:${"var(--ds-space-300, 24px)"};text-align:center;`;
const $d24a80e59a587cd4$export$8ffc1cb9f69665da = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1wf191w-2"
})`display:inline;`;

});
parcelRegister("a0HIf", function(module, exports) {
$parcel$export(module.exports, "DisableViewUntilMount", () => (parcelRequire("f0qQ5")).default);

var $f0qQ5 = parcelRequire("f0qQ5");

});
parcelRegister("f0qQ5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5c30216611a8aec$export$2e2bcd8739ae039);
/* disable-view-until-mount.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");
const $b5c30216611a8aec$var$DisableViewUntilMount = ({ children: children, name: name })=>{
    const componentPointerCssVar = `--pointer-events-${name}`;
    $4fqPo.useEffect(()=>{
        // Upgrading @atlaskit/platform; fix these violations.
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        document.documentElement.style.setProperty(componentPointerCssVar, 'none');
    }, [
        componentPointerCssVar
    ]);
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": `disable-view-until-mount`,
        className: (0, $ltgDR.default)([
            "_1bsb1osq"
        ])
    }, children, /*#__PURE__*/ $4fqPo.createElement("div", {
        style: {
            // @ts-ignore // because we want to use a dynamic css variable
            pointerEvents: `var(${componentPointerCssVar}, auto)`
        },
        className: (0, $ltgDR.default)([
            "_1bsb1osq _4t3i1osq _kqswstnw _154iidpf _1ltvidpf _80omv00u"
        ])
    }));
};
var $b5c30216611a8aec$export$2e2bcd8739ae039 = $b5c30216611a8aec$var$DisableViewUntilMount;
const $b5c30216611a8aec$var$componentWrapper = null;
const $b5c30216611a8aec$var$loaderWrapper = null;

});


parcelRegister("c71sY", function(module, exports) {
$parcel$export(module.exports, "FieldBase", () => (parcelRequire("jwI0L")).default);

var $jwI0L = parcelRequire("jwI0L");

});
parcelRegister("jwI0L", function(module, exports) {
$parcel$export(module.exports, "default", () => $120e277bedac8432$export$2e2bcd8739ae039);
/* field-base.tsx generated by @compiled/babel-plugin v0.37.1 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $6bGmX = parcelRequire("6bGmX");

var $i2DVD = parcelRequire("i2DVD");
var $eBKht = parcelRequire("eBKht");

var $geWWn = parcelRequire("geWWn");

var $ekURY = parcelRequire("ekURY");

var $fwSzd = parcelRequire("fwSzd");
parcelRequire("r7v2x");
var $6lIMY = parcelRequire("6lIMY");
const $120e277bedac8432$var$ERROR_MESSAGE_ICON_A11Y_ISSUE = 'error_message_icon_a11y_issue';
const $120e277bedac8432$var$isErrorMessageIconA11yIssueEnabled = ()=>(0, $6bGmX.default).checkGate($120e277bedac8432$var$ERROR_MESSAGE_ICON_A11Y_ISSUE);
const $120e277bedac8432$var$FieldBase = ({ label: label, labelId: labelId, required: required, errorMessage: errorMessage, description: description, children: children, noLabel: noLabel, htmlFor: htmlFor, tooltip: tooltip })=>{
    const isCSMTypographyMigrationEnabled = (0, $fwSzd.useIsCSMTypographyMigrationEnabled)();
    const isErrorMessageIconEnabled = $120e277bedac8432$var$isErrorMessageIconA11yIssueEnabled();
    const renderField = ()=>noLabel ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($120e277bedac8432$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i2DVD.Label), {
            htmlFor: htmlFor,
            id: labelId
        }, label, required && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eBKht.default), null), isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            className: (0, $ltgDR.default)([
                "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), null, "(required)")) : // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($120e277bedac8432$var$RequiredMessage, null, "(required)")), tooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, tooltip))), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-test-id": `request-field-${htmlFor}`
    }, renderField(), !!errorMessage && (isCSMTypographyMigrationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            "_19pk1b66 _syaz1tmw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), {
        size: "small",
        color: "color.text.danger",
        testId: "field-error-text",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, isErrorMessageIconEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($120e277bedac8432$var$ErrorText, {
        "data-test-id": "field-error",
        id: "field-error",
        role: "status",
        "aria-live": "assertive"
    }, isErrorMessageIconEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            "_2hwx1b66 _1e0c116y _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        label: "error",
        size: "small",
        color: "var(--ds-text-danger, #AE2E24)"
    })), errorMessage))), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6lIMY.default), {
        id: `${htmlFor}-field-description`
    }, description));
};
var $120e277bedac8432$export$2e2bcd8739ae039 = $120e277bedac8432$var$FieldBase;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $120e277bedac8432$var$ErrorText = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-1tyod05-0"
})`${$4W9tu.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $120e277bedac8432$var$FieldContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_19pkpxbi _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $120e277bedac8432$var$errorIconWrapperCSS = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $120e277bedac8432$var$RequiredMessage = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1reo15vq _18m915vq _ogto7mnp _4t3it94y _kqswstnw _o5721q9c _1bsbt94y _p6m71wug _1chs1wug _1h2r1wug _umy61wug _106tstnw _11f21wug",
            __cmplp.className
        ])
    });
});
const $120e277bedac8432$var$requireMessageCSS = null;
const $120e277bedac8432$var$errorMessageCSS = null;

});
parcelRegister("r7v2x", function(module, exports) {
$parcel$export(module.exports, "FieldDescription", () => (parcelRequire("6lIMY")).default);

var $6lIMY = parcelRequire("6lIMY");

});
parcelRegister("6lIMY", function(module, exports) {
$parcel$export(module.exports, "default", () => $55aa46d360ffdccd$export$2e2bcd8739ae039);
/* field-description.tsx generated by @compiled/babel-plugin v0.37.1 */ // Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @compiled/jsx-pragma

var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $eAfqk = parcelRequire("eAfqk");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $efDRU = parcelRequire("efDRU");

var $bYnzD = parcelRequire("bYnzD");

var $6bGmX = parcelRequire("6bGmX");

var $ekURY = parcelRequire("ekURY");

var $azPf3 = parcelRequire("azPf3");

var $lh2vS = parcelRequire("lh2vS");

var $fwSzd = parcelRequire("fwSzd");

var $3beVp = parcelRequire("3beVp");
class $55aa46d360ffdccd$export$873ced4623a3149c extends $4fqPo.PureComponent {
    componentDidMount() {
        this.checkIfShouldCollapse();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.children !== this.props.children) this.checkIfShouldCollapse();
    }
    render() {
        const { intl: intl } = this.props;
        const { shouldCollapse: shouldCollapse, isOpen: isOpen } = this.state;
        const removeWidthObserver = (0, $6bGmX.default).checkGate('remove_widthobserver_from_field_description');
        return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, removeWidthObserver ? null : /*#__PURE__*/ $4fqPo.createElement((0, $azPf3.default), {
            setWidth: this.checkIfShouldCollapse
        }), shouldCollapse ? /*#__PURE__*/ $4fqPo.createElement($55aa46d360ffdccd$export$b7e78554be83b35d, {
            onClick: this.onToggle
        }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bYnzD))), {
            expanded: isOpen,
            collapsedHeight: `${$55aa46d360ffdccd$export$4ea46454a0bad5c3}px`
        }, this.renderHelpText()), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
            migratedComponent: /*#__PURE__*/ $4fqPo.createElement("div", {
                className: (0, $ltgDR.default)([
                    "_syaz131l"
                ])
            }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
                size: "small",
                color: "color.text.subtlest",
                weight: "medium"
            }, intl.formatMessage(isOpen ? (0, $3beVp.default).showLess : (0, $3beVp.default).showMore)))
        }, /*#__PURE__*/ $4fqPo.createElement($55aa46d360ffdccd$export$5f734e3a73651e57, null, intl.formatMessage(isOpen ? (0, $3beVp.default).showLess : (0, $3beVp.default).showMore)))) : this.renderHelpText());
    }
    constructor(...args){
        super(...args), this.state = {
            shouldCollapse: false,
            isOpen: false
        }, this.helpTextRef = /*#__PURE__*/ $4fqPo.createRef(), this.checkIfShouldCollapse = ()=>{
            if (this.helpTextRef.current && (0, $lh2vS.getElementHeight)(this.helpTextRef.current) > $55aa46d360ffdccd$export$4ea46454a0bad5c3) this.setState({
                shouldCollapse: true
            });
            else if (this.state.shouldCollapse) this.setState({
                shouldCollapse: false
            });
        }, this.onToggle = (e)=>{
            e.preventDefault();
            this.setState((prevState)=>({
                    isOpen: !prevState.isOpen
                }));
        }, this.renderHelpText = ()=>{
            const { children: children, id: id } = this.props;
            if (typeof children === 'string') return /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement($55aa46d360ffdccd$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef,
                    dangerouslySetInnerHTML: {
                        __html: children
                    }
                })
            }, /*#__PURE__*/ $4fqPo.createElement($55aa46d360ffdccd$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef,
                dangerouslySetInnerHTML: {
                    __html: children
                }
            }));
            return /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement($55aa46d360ffdccd$export$29708599cbdda103, {
                    id: id,
                    innerRef: this.helpTextRef
                }, children)
            }, /*#__PURE__*/ $4fqPo.createElement($55aa46d360ffdccd$export$a67c0bc59081311a, {
                id: id,
                innerRef: this.helpTextRef
            }, children));
        };
    }
}
var $55aa46d360ffdccd$export$2e2bcd8739ae039 = (0, $efDRU.default)($55aa46d360ffdccd$export$873ced4623a3149c);
const $55aa46d360ffdccd$export$a67c0bc59081311a = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-mimyi-0"
})`${$4W9tu.xsmall};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $55aa46d360ffdccd$export$29708599cbdda103 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-mimyi-1"
})`font:${"var(--ds-font-heading-xsmall, normal 600 0.875rem/1rem ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-subtlest, #6B778C)"};`;
const $55aa46d360ffdccd$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $el3DQ.default).span.withConfig({
    componentId: "sc-mimyi-2"
})`${$4W9tu.xsmall};color:${"var(--ds-text-subtlest, #6B778C)"};font-weight:500;`;
const $55aa46d360ffdccd$var$buttonTextCSS = null;
const $55aa46d360ffdccd$export$b7e78554be83b35d = /*#__PURE__*/ (0, $el3DQ.default)((0, $eAfqk.default)).withConfig({
    componentId: "sc-mimyi-3"
})`display:block;`;
const $55aa46d360ffdccd$export$4ea46454a0bad5c3 = $bpWyP.multiple(4.5).unitless;

});
parcelRegister("bYnzD", function(module, exports) {
"use strict";

var $5gh7j = parcelRequire("5gh7j");

var $2OGX7 = parcelRequire("2OGX7");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8b7795898ec081e6$var$_objectWithoutProperties2 = $5gh7j((parcelRequire("48ELM")));

var $8b7795898ec081e6$var$_classCallCheck2 = $5gh7j((parcelRequire("wJpxj")));

var $8b7795898ec081e6$var$_createClass2 = $5gh7j((parcelRequire("SCgxb")));

var $8b7795898ec081e6$var$_assertThisInitialized2 = $5gh7j((parcelRequire("4iqe3")));

var $8b7795898ec081e6$var$_inherits2 = $5gh7j((parcelRequire("1xgWo")));

var $8b7795898ec081e6$var$_possibleConstructorReturn2 = $5gh7j((parcelRequire("irneV")));

var $8b7795898ec081e6$var$_getPrototypeOf2 = $5gh7j((parcelRequire("70DnU")));

var $8b7795898ec081e6$var$_defineProperty2 = $5gh7j((parcelRequire("dS6Sc")));

var $8b7795898ec081e6$var$React = $8b7795898ec081e6$var$_interopRequireWildcard((parcelRequire("4fqPo")));

var $8b7795898ec081e6$var$_propTypes = $5gh7j((parcelRequire("4S7MC")));

var $8b7795898ec081e6$var$_getTransitionTimeMs = $5gh7j((parcelRequire("cFFYI")));

var $lhXNe = parcelRequire("lhXNe");
var $8b7795898ec081e6$var$_excluded = [
    "allowOverflowWhenOpen",
    "children",
    "collapsedHeight",
    "eagerRender",
    "expanded",
    "heightTransition",
    "onChangeEnd"
];
function $8b7795898ec081e6$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8b7795898ec081e6$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8b7795898ec081e6$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $2OGX7(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $8b7795898ec081e6$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8b7795898ec081e6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8b7795898ec081e6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8b7795898ec081e6$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $8b7795898ec081e6$var$_defineProperty2["default"])(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8b7795898ec081e6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8b7795898ec081e6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8b7795898ec081e6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $8b7795898ec081e6$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $8b7795898ec081e6$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8b7795898ec081e6$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $8b7795898ec081e6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8b7795898ec081e6$var$SmoothCollapse = /*#__PURE__*/ function(_React$Component) {
    (0, $8b7795898ec081e6$var$_inherits2["default"])(SmoothCollapse, _React$Component);
    var _super = $8b7795898ec081e6$var$_createSuper(SmoothCollapse);
    function SmoothCollapse(props) {
        var _this;
        (0, $8b7795898ec081e6$var$_classCallCheck2["default"])(this, SmoothCollapse);
        _this = _super.call(this, props);
        (0, $8b7795898ec081e6$var$_defineProperty2["default"])((0, $8b7795898ec081e6$var$_assertThisInitialized2["default"])(_this), "_removeTransitionEndListener", function() {});
        (0, $8b7795898ec081e6$var$_defineProperty2["default"])((0, $8b7795898ec081e6$var$_assertThisInitialized2["default"])(_this), "_main", /*#__PURE__*/ $8b7795898ec081e6$var$React.createRef());
        (0, $8b7795898ec081e6$var$_defineProperty2["default"])((0, $8b7795898ec081e6$var$_assertThisInitialized2["default"])(_this), "_inner", /*#__PURE__*/ $8b7795898ec081e6$var$React.createRef());
        (0, $8b7795898ec081e6$var$_defineProperty2["default"])((0, $8b7795898ec081e6$var$_assertThisInitialized2["default"])(_this), "_onNextTransitionEnd", function(el, callback) {
            _this._removeTransitionEndListener();
            var listener = function listener() {
                _this._removeTransitionEndListener();
                callback();
            };
            var timeout;
            _this._removeTransitionEndListener = function() {
                _this._removeTransitionEndListener = function() {};
                clearTimeout(timeout);
                el.removeEventListener('transitionend', listener);
            }; // Wait until the transitionend event, or until a timer goes off in
            // case the event doesn't fire because the browser doesn't support it
            // or the element is hidden before it happens. The timer is a little
            // longer than the transition is supposed to take to make sure we don't
            // cut the animation early while it's still going if the browser is
            // running it just a little slow.
            el.addEventListener('transitionend', listener);
            var ms = (0, $8b7795898ec081e6$var$_getTransitionTimeMs["default"])(_this.props.heightTransition) * 1.1 + 500;
            timeout = setTimeout(listener, ms);
        });
        _this.state = {
            renderInner: props.expanded || SmoothCollapse._visibleWhenClosed(props),
            closing: false,
            fullyClosed: !props.expanded,
            height: props.expanded ? 'auto' : props.collapsedHeight
        };
        return _this;
    }
    (0, $8b7795898ec081e6$var$_createClass2["default"])(SmoothCollapse, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._removeTransitionEndListener();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                if (!prevProps.expanded && this.props.expanded) {
                    this._removeTransitionEndListener();
                    var mainEl = this._main.current;
                    var innerEl = this._inner.current;
                    if (!mainEl || !innerEl) throw new Error('Should not happen'); // Set the collapser to the target height instead of auto so that it
                    // animates correctly. Then switch it to 'auto' after the animation so
                    // that it flows correctly if the page is resized.
                    var targetHeight = "".concat(innerEl.clientHeight, "px");
                    this.setState({
                        height: targetHeight
                    });
                    this._onNextTransitionEnd(mainEl, function() {
                        _this2.setState({
                            height: 'auto'
                        }, function() {
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                } else if (prevProps.expanded && !this.props.expanded) {
                    this._removeTransitionEndListener();
                    if (!this._inner.current) throw new Error('Should not happen');
                    this.setState({
                        height: "".concat(this._inner.current.clientHeight, "px")
                    }, function() {
                        var mainEl = _this2._main.current;
                        if (!mainEl) throw new Error('Should not happen');
                        mainEl.clientHeight; // force the page layout
                        _this2.setState({
                            height: _this2.props.collapsedHeight,
                            closing: true
                        });
                        _this2._onNextTransitionEnd(mainEl, function() {
                            _this2.setState({
                                closing: false,
                                fullyClosed: true
                            });
                            if (_this2.props.onChangeEnd) _this2.props.onChangeEnd();
                        });
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var visibleWhenClosed = SmoothCollapse._visibleWhenClosed(this.props);
                var _this$props = this.props, allowOverflowWhenOpen = _this$props.allowOverflowWhenOpen, children = _this$props.children, collapsedHeight = _this$props.collapsedHeight, eagerRender = _this$props.eagerRender, expanded = _this$props.expanded, heightTransition = _this$props.heightTransition, onChangeEnd = _this$props.onChangeEnd, props = (0, $8b7795898ec081e6$var$_objectWithoutProperties2["default"])(_this$props, $8b7795898ec081e6$var$_excluded);
                var _this$state = this.state, height = _this$state.height, fullyClosed = _this$state.fullyClosed, renderInner = _this$state.renderInner;
                var innerEl = renderInner ? /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                    ref: this._inner,
                    style: {
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden'
                    },
                    children: children
                }) : null;
                return /*#__PURE__*/ (0, $lhXNe.jsx)("div", $8b7795898ec081e6$var$_objectSpread($8b7795898ec081e6$var$_objectSpread({}, props), {}, {
                    ref: this._main,
                    style: {
                        height: height,
                        overflow: allowOverflowWhenOpen && height === 'auto' ? 'visible' : 'hidden',
                        display: fullyClosed && !visibleWhenClosed ? 'none' : null,
                        transition: "height ".concat(heightTransition)
                    },
                    children: innerEl
                }));
            }
        }
    ], [
        {
            key: "_visibleWhenClosed",
            value: function _visibleWhenClosed(props) {
                return props.eagerRender || parseFloat(props.collapsedHeight) !== 0;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (props.expanded && (state.closing || state.fullyClosed)) return {
                    closing: false,
                    fullyClosed: false,
                    renderInner: true
                };
                else if (!props.expanded && (state.closing || state.fullyClosed) && state.height !== props.collapsedHeight) return {
                    height: props.collapsedHeight,
                    renderInner: state.renderInner || SmoothCollapse._visibleWhenClosed(props)
                };
                return null;
            }
        }
    ]);
    return SmoothCollapse;
}($8b7795898ec081e6$var$React.Component);
module.exports["default"] = $8b7795898ec081e6$var$SmoothCollapse;
(0, $8b7795898ec081e6$var$_defineProperty2["default"])($8b7795898ec081e6$var$SmoothCollapse, "propTypes", {
    expanded: $8b7795898ec081e6$var$_propTypes["default"].bool.isRequired,
    onChangeEnd: $8b7795898ec081e6$var$_propTypes["default"].func,
    collapsedHeight: $8b7795898ec081e6$var$_propTypes["default"].string,
    heightTransition: $8b7795898ec081e6$var$_propTypes["default"].string,
    className: $8b7795898ec081e6$var$_propTypes["default"].string,
    allowOverflowWhenOpen: $8b7795898ec081e6$var$_propTypes["default"].bool,
    eagerRender: $8b7795898ec081e6$var$_propTypes["default"].bool
});
(0, $8b7795898ec081e6$var$_defineProperty2["default"])($8b7795898ec081e6$var$SmoothCollapse, "defaultProps", {
    collapsedHeight: '0',
    heightTransition: '.25s ease',
    className: '',
    allowOverflowWhenOpen: false,
    eagerRender: false
});

});
parcelRegister("48ELM", function(module, exports) {

var $f75CH = parcelRequire("f75CH");
function $303788c2431a182f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f75CH(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $303788c2431a182f$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("wJpxj", function(module, exports) {
function $062636ed7e9d945b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $062636ed7e9d945b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("SCgxb", function(module, exports) {

var $cYwRP = parcelRequire("cYwRP");
function $0a42ba06fc9db927$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $cYwRP(o.key), o);
    }
}
function $0a42ba06fc9db927$var$_createClass(e, r, t) {
    return r && $0a42ba06fc9db927$var$_defineProperties(e.prototype, r), t && $0a42ba06fc9db927$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $0a42ba06fc9db927$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1xgWo", function(module, exports) {

var $lRG9C = parcelRequire("lRG9C");
function $11e60396bf2f7187$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $lRG9C(t, e);
}
module.exports = $11e60396bf2f7187$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("irneV", function(module, exports) {

var $2OGX7 = parcelRequire("2OGX7");
var $d6ccc68578a31c1f$var$_typeof = $2OGX7.default;

var $4iqe3 = parcelRequire("4iqe3");
function $d6ccc68578a31c1f$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $d6ccc68578a31c1f$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $4iqe3(t);
}
module.exports = $d6ccc68578a31c1f$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("70DnU", function(module, exports) {
function $51a71574bac4cee6$var$_getPrototypeOf(t) {
    return module.exports = $51a71574bac4cee6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $51a71574bac4cee6$var$_getPrototypeOf(t);
}
module.exports = $51a71574bac4cee6$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cFFYI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $9399e05d1e902ab7$var$getTransitionTimeMs;
function $9399e05d1e902ab7$var$getTransitionTimeMs(heightTransition) {
    var m = /(\d+(?:\.\d+)?|\.\d+)(m?s)\b/i.exec(heightTransition);
    if (!m) throw new Error('Could not parse time from transition value');
    return Number(m[1]) * (m[2].length === 1 ? 1000 : 1);
}

});


parcelRegister("3beVp", function(module, exports) {
$parcel$export(module.exports, "default", () => $942fa9e0b5be304e$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $942fa9e0b5be304e$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    showMore: {
        defaultMessage: 'Show more...',
        description: 'Button action text to expand a form fields description',
        id: 'cv.field-base.description.show-more'
    },
    showLess: {
        defaultMessage: 'Show less...',
        description: 'Button action text to collapse a form fields description',
        id: 'cv.field-base.description.show-less'
    }
});

});





parcelRegister("5yD7X", function(module, exports) {
$parcel$export(module.exports, "TextField", () => (parcelRequire("lJn7w")).default);
$parcel$export(module.exports, "ControlledTextField", () => (parcelRequire("lJn7w")).ControlledTextField);

var $lJn7w = parcelRequire("lJn7w");

});
parcelRegister("lJn7w", function(module, exports) {
$parcel$export(module.exports, "default", () => $72193cf1cd8c1a10$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ControlledTextField", () => $72193cf1cd8c1a10$export$befa4be8e9119768);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $63sfu = parcelRequire("63sfu");
parcelRequire("c71sY");
var $jwI0L = parcelRequire("jwI0L");

var $6bGmX = parcelRequire("6bGmX");

var $bOOgP = parcelRequire("bOOgP");
parcelRequire("2J8RS");
var $7x7Qw = parcelRequire("7x7Qw");
const $72193cf1cd8c1a10$var$ariaRequiredToTextFieldEnabled = ()=>{
    return (0, $6bGmX.default).checkGate('add_aria-required_to_text_field_');
};
class $72193cf1cd8c1a10$export$2e2bcd8739ae039 extends $4fqPo.PureComponent {
    static #_ = this.defaultProps = {
        shouldFitContainer: true,
        type: 'text'
    };
    render() {
        const { id: id, testId: testId, label: label, required: required, defaultValue: defaultValue, description: description, errorMessage: errorMessage, maxLength: maxLength, disabled: disabled, render: render, placeholder: placeholder, isLabelHidden: isLabelHidden, type: type, autoFocus: autoFocus, value: value, onFocus: onFocus, onKeyDown: onKeyDown, ariaDescribedby: ariaDescribedby, autoComplete: autoComplete, ariaLabelledby: ariaLabelledby, tooltip: tooltip, isInvalid: isInvalidProp } = this.props;
        const isInvalid = isInvalidProp || !(0, $63sfu.isEmpty)(errorMessage);
        const inputType = type;
        /** Currently to match the legacy behavior in some cases we are passing both value and defaultValue
     * there will be a sentry alert to either use controlled or uncontrolled but not both
     * to prevent this we only pass one of value or defaultValue
     * such scenarios can be avoided once we clean the legacy code
     * when cleaning up feature flag see if this can be removed
     */ const isValueDefined = typeof value === 'string';
        const textFieldValueProps = isValueDefined ? {
            value: value
        } : {
            defaultValue: defaultValue
        };
        const ariaDescribedByText = ariaDescribedby || `${id}-field-description ${isInvalid ? 'field-error' : ''}`;
        const ariaLabelledByText = ariaLabelledby || `${id}-label`;
        const field = /*#__PURE__*/ $4fqPo.createElement((0, $bOOgP.default), {
            id: id,
            testId: testId,
            name: id,
            "aria-describedby": ariaDescribedByText,
            "aria-labelledby": ariaLabelledByText,
            "aria-invalid": isInvalid,
            ...$72193cf1cd8c1a10$var$ariaRequiredToTextFieldEnabled() ? {
                'aria-required': required
            } : {},
            ...textFieldValueProps,
            onChange: this.onChange,
            isInvalid: isInvalid,
            isDisabled: disabled,
            placeholder: placeholder,
            type: inputType,
            maxLength: maxLength,
            autoFocus: autoFocus,
            onFocus: onFocus,
            onBlur: this.onBlur,
            onKeyDown: onKeyDown,
            autoComplete: autoComplete
        });
        return /*#__PURE__*/ $4fqPo.createElement((0, $jwI0L.default), {
            htmlFor: id,
            label: label,
            required: required,
            description: description,
            errorMessage: errorMessage,
            noLabel: isLabelHidden,
            labelId: `${id}-label`,
            ...(0, $bG6ob.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, render ? render(field) : field);
    }
    constructor(...args){
        super(...args), this.inputRef = /*#__PURE__*/ $4fqPo.createRef(), //TODO - We need to find a better way to add focus to input field when there is an error. This should be done in the form component. https://hello.jira.atlassian.cloud/browse/CHANNELSUI-258
        this.onChange = (e)=>{
            if (this.props.onChange) this.props.onChange(this.props.id, e.target.value, false, {
                rawObject: e,
                rawValue: e.target.value
            });
        }, this.onBlur = (e)=>{
            if (this.props.onFieldBlurredByUser) this.props.onFieldBlurredByUser({
                field: this.props.id,
                value: e.target.value,
                additionalFieldData: {
                    rawObject: e,
                    rawValue: e.target.value
                }
            });
            if (this.props.onBlur) this.props.onBlur();
        };
    }
}
const $72193cf1cd8c1a10$export$befa4be8e9119768 = (0, $7x7Qw.withControlledFormComponentValue)((_field, value)=>value)($72193cf1cd8c1a10$export$2e2bcd8739ae039);

});
parcelRegister("2J8RS", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => (parcelRequire("7x7Qw")).withControlledFormComponentValue);

var $7x7Qw = parcelRequire("7x7Qw");

});
parcelRegister("7x7Qw", function(module, exports) {
$parcel$export(module.exports, "withControlledFormComponentValue", () => $7098cdb4725df97c$export$cd499d091f6810cd);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $6HAlT = parcelRequire("6HAlT");
function $7098cdb4725df97c$export$cd499d091f6810cd(mapOnChangeValue, valueTransformer) {
    return (FormComponent)=>class ControlledFormComponentWrapper extends $4fqPo.PureComponent {
            static #_ = this.displayName = 'ControlledFormComponentWrapper';
            componentDidUpdate(prevProps, prevState) {
                // Handle valueOverride changes (UI Modifications)
                if (this.checkIsValueOverride() && this.props.valueOverride !== prevProps.valueOverride && this.props.valueOverride !== prevState.controlledValue) this.setState({
                    controlledValue: this.props.valueOverride
                });
                // Handle external value changes (native automation rules, form resets, etc.)
                if ((0, $bG6ob.isMultiSelectEnabled)() && this.props.value !== prevProps.value && this.props.value !== prevState.controlledValue && !this.checkIsValueOverride()) this.setState({
                    controlledValue: this.props.value
                });
            }
            render() {
                const { defaultValue: _1, value: _2, valueOverride: _3, onChange: _4, ...remainingProps } = this.props;
                if ((0, $bG6ob.isUiModificationsSupportEnabled)()) {
                    const transformedValue = valueTransformer ? valueTransformer(this.state.controlledValue) : this.state.controlledValue;
                    const componentProps = {
                        ...remainingProps,
                        value: transformedValue,
                        onChange: this.onChange,
                        shouldReplaceValue: this.checkIsValueOverride()
                    };
                    return /*#__PURE__*/ $4fqPo.createElement((0, $6HAlT.FieldDecoratorAsync), {
                        Component: FormComponent,
                        componentProps: componentProps
                    });
                }
                return /*#__PURE__*/ $4fqPo.createElement(FormComponent, {
                    ...remainingProps,
                    value: this.state.controlledValue,
                    onChange: this.onChange
                });
            }
            constructor(...args){
                super(...args), this.checkIsValueOverride = ()=>{
                    if (this.props.valueOverride === null || this.props.valueOverride === '' || this.props.valueOverride) return true;
                    return false;
                }, this.state = {
                    controlledValue: this.checkIsValueOverride() ? this.props.valueOverride : this.props.defaultValue
                }, this.onChange = (...args)=>{
                    var _this$props$onChange, _this$props;
                    this.setState({
                        controlledValue: mapOnChangeValue(...args)
                    });
                    (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, ...args);
                };
            }
        };
}

});
parcelRegister("6HAlT", function(module, exports) {
$parcel$export(module.exports, "FieldDecoratorAsync", () => $0bf05713e228fc7c$export$7bf1fdc8d847e1ea);

var $4fqPo = parcelRequire("4fqPo");

var $bjzpQ = parcelRequire("bjzpQ");
var $33BOA = parcelRequire("33BOA");

var $lsxWh = parcelRequire("lsxWh");

var $fa2DX = parcelRequire("fa2DX");
const $0bf05713e228fc7c$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const isUiModificationsEnabled = (0, $33BOA.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, componentProps);
    if (!isUiModificationsEnabled) return undecoratedComponent;
    if (!(0, $bjzpQ.isFieldTypeSupported)((0, $lsxWh.REQUEST_CREATE_VIEW_TYPE), componentProps.jiraFieldType ?? componentProps.id)) return undecoratedComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fa2DX.EnabledFieldDecorator), {
        componentProps: componentProps,
        Component: Component
    });
};
const $0bf05713e228fc7c$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $4fqPo.memo)($0bf05713e228fc7c$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("fa2DX", function(module, exports) {
$parcel$export(module.exports, "EnabledFieldDecorator", () => $9b7fa745d14d4432$export$a39682472306ffd4);

var $4fqPo = parcelRequire("4fqPo");

var $2FJtM = parcelRequire("2FJtM");

var $i2ACo = parcelRequire("i2ACo");
const $9b7fa745d14d4432$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { id: id } = componentProps;
    const isBusy = (0, $i2ACo.useFieldIsBusy)(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
        ...componentProps,
        ...isBusy ? {
            disabled: true,
            isDisabled: true,
            tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2FJtM.FieldBusyIndicator), {
                fieldId: id
            })
        } : {}
    });
};
const $9b7fa745d14d4432$export$a39682472306ffd4 = /*#__PURE__*/ (0, $4fqPo.memo)($9b7fa745d14d4432$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("2FJtM", function(module, exports) {
$parcel$export(module.exports, "FieldBusyIndicator", () => $314c3f11c7db6235$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4MCQn = parcelRequire("4MCQn");

var $h8dHw = parcelRequire("h8dHw");

var $5qWT2 = parcelRequire("5qWT2");

var $8Mj6h = parcelRequire("8Mj6h");

var $9mrKk = parcelRequire("9mrKk");
const $314c3f11c7db6235$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $4fqPo.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const loadingMessage = formatMessage((0, $9mrKk.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($314c3f11c7db6235$export$4e31364808fb7483, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h8dHw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        testId: indicatorId,
        size: "small"
    }))));
});
$314c3f11c7db6235$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator';
const $314c3f11c7db6235$export$4e31364808fb7483 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h8dHw", function(module, exports) {
$parcel$export(module.exports, "default", () => $37141eaa5df5a13a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1ZSmH = parcelRequire("1ZSmH");
function $37141eaa5df5a13a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1ZSmH.default), props);
}

});
parcelRegister("1ZSmH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c735ac4a609d5a54$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $9XaAY = parcelRequire("9XaAY");
/**
 * Prevent a subtree from holding up an interaction
 * Use this when you have a component which loads in late, but
 * isn't considered to be a breach of SLO
 *
 * ```js
 * <App>
 *   <Main />
 *   <Sidebar>
 *     <UFOIgnoreHolds>
 *       <InsightsButton />
 *     </UFOIgnoreHolds>
 *   </Sidebar>
 * </App>
 * ```
 *
 * Has an `ignore` prop, to allow you to use it conditionally
 * Has a `reason` prop, to specify why the hold is being ignored
 */ const $c735ac4a609d5a54$var$UFOIgnoreHolds = ({ children: children, ignore: ignore = true })=>{
    const parentContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const ignoredInteractionContext = (0, $4fqPo.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9XaAY.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
};
$c735ac4a609d5a54$var$UFOIgnoreHolds.displayName = 'UFOIgnoreHolds';
var $c735ac4a609d5a54$export$2e2bcd8739ae039 = $c735ac4a609d5a54$var$UFOIgnoreHolds;

});


parcelRegister("9mrKk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e66445091b3921a2$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $e66445091b3921a2$var$_default_1 = (0, $6BhDL.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        id: 'issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content',
        defaultMessage: 'Loading UI modifications...',
        description: 'A tooltip message showed on UI modifications loading icon on each loading field'
    }
});
var $e66445091b3921a2$export$2e2bcd8739ae039 = $e66445091b3921a2$var$_default_1;

});


parcelRegister("i2ACo", function(module, exports) {
$parcel$export(module.exports, "useFieldIsBusy", () => $e708f631d1851705$export$b4ae28da91c35ed4);

var $bmfYr = parcelRequire("bmfYr");

var $2FyXQ = parcelRequire("2FyXQ");

var $22Yf6 = parcelRequire("22Yf6");
const $e708f631d1851705$export$b4ae28da91c35ed4 = (fieldId)=>{
    const [isBusyData] = (0, $22Yf6.useFieldIsProcessing)(fieldId);
    const uimConsentMap = (0, $bmfYr.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $2FyXQ.UIM_CONSENT_REQUIRED));
};

});
parcelRegister("bmfYr", function(module, exports) {
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $1fb0d80425f4c2c8$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $1fb0d80425f4c2c8$export$2a5a8f1570c161c6);

var $6VEbB = parcelRequire("6VEbB");
var $iouul = parcelRequire("iouul");

var $33BOA = parcelRequire("33BOA");

var $2FyXQ = parcelRequire("2FyXQ");
const $1fb0d80425f4c2c8$var$selectOverallConsentStatus = (0, $6VEbB.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $2FyXQ.UIM_CONSENT_REQUIRED)) ? (0, $2FyXQ.UIM_CONSENT_REQUIRED) : (0, $2FyXQ.UIM_CONSENT_CONSENTED));
const $1fb0d80425f4c2c8$export$e2c526d2c1843a0e = (0, $iouul.createStateHook)((0, $33BOA.store), {
    selector: $1fb0d80425f4c2c8$var$selectOverallConsentStatus
});
const $1fb0d80425f4c2c8$export$7700bb22109a011e = (0, $iouul.createStateHook)((0, $33BOA.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $2FyXQ.UIM_CONSENT_UNKNOWN)
});
const $1fb0d80425f4c2c8$export$2a5a8f1570c161c6 = (0, $iouul.createStateHook)((0, $33BOA.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("2FyXQ", function(module, exports) {
$parcel$export(module.exports, "UIM_CONSENT_UNKNOWN", () => $47ece79969807fe7$export$39d15f3568f5a72c);
$parcel$export(module.exports, "UIM_CONSENT_REQUIRED", () => $47ece79969807fe7$export$d67d63332ce3ce38);
$parcel$export(module.exports, "UIM_CONSENT_CONSENTED", () => $47ece79969807fe7$export$45ca911896c5084f);
const $47ece79969807fe7$export$39d15f3568f5a72c = 'unknown';
const $47ece79969807fe7$export$d67d63332ce3ce38 = 'required';
const $47ece79969807fe7$export$45ca911896c5084f = 'consented';

});


parcelRegister("22Yf6", function(module, exports) {
$parcel$export(module.exports, "useFieldIsProcessing", () => $b91dda2ed1d71806$export$7fa63f8479e2806a);

var $5j9vJ = parcelRequire("5j9vJ");

var $iouul = parcelRequire("iouul");
var $6VEbB = parcelRequire("6VEbB");

var $7pCjT = parcelRequire("7pCjT");
const $b91dda2ed1d71806$export$9076a5ac331011bb = (0, $6VEbB.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($5j9vJ)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $b91dda2ed1d71806$export$7fa63f8479e2806a = (0, $iouul.createHook)((0, $7pCjT.store), {
    selector: $b91dda2ed1d71806$export$9076a5ac331011bb
});

});








parcelRegister("7pXnH", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => (parcelRequire("i14ap")).default);

var $i14ap = parcelRequire("i14ap");

});
parcelRegister("i14ap", function(module, exports) {
$parcel$export(module.exports, "PasswordField", () => $48e806252bb3cd3c$export$65ed9482db2257fa);
$parcel$export(module.exports, "default", () => $48e806252bb3cd3c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $1HSOM = parcelRequire("1HSOM");

var $efDRU = parcelRequire("efDRU");
parcelRequire("j4tAH");
var $i8o1I = parcelRequire("i8o1I");

var $dO3eH = parcelRequire("dO3eH");

var $jBqdP = parcelRequire("jBqdP");

var $bOOgP = parcelRequire("bOOgP");

var $8Mj6h = parcelRequire("8Mj6h");
parcelRequire("2P0Zg");
var $cQ310 = parcelRequire("cQ310");

var $8iGCq = parcelRequire("8iGCq");
class $48e806252bb3cd3c$export$65ed9482db2257fa extends $4fqPo.Component {
    render() {
        const { autoFocus: autoFocus, intl: intl, id: id, maxLength: maxLength, value: value, isDisabled: isDisabled, isInvalid: isInvalid, weakPasswords: weakPasswords, errorMessage: errorMessage, hideStrengthMeter: hideStrengthMeter, testId: testId, onKeyDown: onKeyDown } = this.props;
        const { showPassword: showPassword } = this.state;
        const passwordFieldType = showPassword ? 'text' : 'password';
        const shouldRenderStrengthMeter = !hideStrengthMeter;
        return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $bOOgP.default), {
            id: id,
            testId: testId,
            type: passwordFieldType,
            maxLength: maxLength,
            onChange: this.onChange,
            isDisabled: isDisabled,
            autoFocus: autoFocus,
            isInvalid: isInvalid,
            value: value,
            elemAfterInput: this.renderShowHideButton(),
            onKeyDown: onKeyDown
        }), isInvalid && errorMessage && /*#__PURE__*/ $4fqPo.createElement((0, $cQ310.default), {
            errorMessage: errorMessage
        }), shouldRenderStrengthMeter && /*#__PURE__*/ $4fqPo.createElement((0, $i8o1I.default), {
            intl: intl,
            password: value,
            scoreWords: weakPasswords
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            showPassword: false
        }, this.onChange = (e)=>{
            this.props.onChange(e.target.value);
        }, this.onShowPasswordToggle = ()=>{
            this.setState((prevState)=>({
                    showPassword: !prevState.showPassword
                }));
        }, this.renderShowHideButton = ()=>{
            const { intl: intl, isDisabled: isDisabled } = this.props;
            const { showPassword: showPassword } = this.state;
            const buttonActionPrefix = showPassword ? 'hide' : 'show';
            const togglePasswordButtonDescription = showPassword ? intl.formatMessage((0, $8iGCq.default).hidePassword) : intl.formatMessage((0, $8iGCq.default).showPassword);
            const icon = showPassword ? /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jBqdP))), {
                spacing: "spacious",
                testId: "watch-filled-icon",
                label: togglePasswordButtonDescription
            }) : /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dO3eH))), {
                spacing: "spacious",
                testId: "watch-icon",
                label: togglePasswordButtonDescription
            });
            return /*#__PURE__*/ $4fqPo.createElement((0, $8Mj6h.default), {
                content: togglePasswordButtonDescription
            }, /*#__PURE__*/ $4fqPo.createElement((0, $1HSOM.Button), {
                actionSubjectId: `${buttonActionPrefix}-password`,
                appearance: "subtle",
                isDisabled: isDisabled,
                onClick: this.onShowPasswordToggle,
                iconBefore: /*#__PURE__*/ $4fqPo.createElement($48e806252bb3cd3c$var$IconContainer, null, icon)
            }));
        };
    }
}
var $48e806252bb3cd3c$export$2e2bcd8739ae039 = (0, $efDRU.default)($48e806252bb3cd3c$export$65ed9482db2257fa);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $48e806252bb3cd3c$var$IconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-19v26xn-0"
})`padding-right:${"var(--ds-space-025, 2px)"};margin-left:${"var(--ds-space-negative-025, -2px)"};`;

});
parcelRegister("j4tAH", function(module, exports) {
$parcel$export(module.exports, "AsyncLoadedPasswordStrengthMeter", () => (parcelRequire("i8o1I")).default);

var $i8o1I = parcelRequire("i8o1I");

});
parcelRegister("i8o1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $1293d68773c148fa$export$2e2bcd8739ae039);
/**
 * Heavily inspired by https://stash.atlassian.com/projects/AID/repos/aid-frontend/browse/src/components/PasswordStrengthMeter.tsx.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $63sfu = parcelRequire("63sfu");

var $jpdXS = parcelRequire("jpdXS");

var $gdGyH = parcelRequire("gdGyH");

var $2q6NB = parcelRequire("2q6NB");
const $1293d68773c148fa$var$passwordAnalyzerUrl = 'https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.4.2/zxcvbn.js';
const $1293d68773c148fa$var$splitter = /\W+/;
const $1293d68773c148fa$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS = 200;
class $1293d68773c148fa$export$eebfb7c0549090 extends $4fqPo.Component {
    render() {
        const { score: score } = this.state;
        const strengthText = this.getStrengthTextForScore(score);
        return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($1293d68773c148fa$export$bbc6c6369b38e3d1, {
            "data-testid": "password-strength-bar",
            score: score
        }, /*#__PURE__*/ $4fqPo.createElement($1293d68773c148fa$var$Dividers, null)), /*#__PURE__*/ $4fqPo.createElement($1293d68773c148fa$export$8d13340382210b65, {
            "data-testid": "password-strength-hint"
        }, strengthText));
    }
    constructor(...args){
        super(...args), this.state = {
            score: null
        }, this.calculateScoreDebounced = (0, $63sfu.debounce)(()=>{
            const { password: password, scoreWords: scoreWords, zxcvbn: passwordAnalyzer } = this.props;
            const result = passwordAnalyzer && password ? passwordAnalyzer(password, scoreWords) : null;
            this.setState({
                score: result ? result.score : null
            });
        }, $1293d68773c148fa$var$STRENGTH_SCORE_DEBOUNCE_IN_MILLIS), this.componentDidUpdate = (prevProps)=>{
            if (this.props.password === prevProps.password) return;
            if (!this.props.password) {
                this.setState({
                    score: null
                });
                return;
            }
            this.calculateScoreDebounced();
        }, this.getStrengthTextForScore = (score)=>{
            const { intl: intl, password: password, zxcvbn: passwordAnalyzer } = this.props;
            if (!password) return '';
            if (password.length < (0, $gdGyH.MIN_PASSWORD_LENGTH_IN_CHARS)) return this.props.intl.formatMessage((0, $2q6NB.default).passwordInvalid);
            if (!passwordAnalyzer) return intl.formatMessage((0, $2q6NB.default).passwordStrengthUnavailable);
            return score !== null ? this.mapScoreToStrengthText(score) : '';
        }, this.mapScoreToStrengthText = (score)=>{
            let strengthText;
            switch(score){
                case 0:
                    strengthText = (0, $2q6NB.default).passwordStrengthLevel0;
                    break;
                case 1:
                    strengthText = (0, $2q6NB.default).passwordStrengthLevel1;
                    break;
                case 2:
                    strengthText = (0, $2q6NB.default).passwordStrengthLevel2;
                    break;
                case 3:
                    strengthText = (0, $2q6NB.default).passwordStrengthLevel3;
                    break;
                case 4:
                    strengthText = (0, $2q6NB.default).passwordStrengthLevel4;
                    break;
                default:
                    strengthText = (0, $2q6NB.default).passwordStrengthUnavailable;
            }
            return this.props.intl.formatMessage(strengthText);
        };
    }
}
const $1293d68773c148fa$export$6672436889ec70b1 = (0, $jpdXS.default)($1293d68773c148fa$var$passwordAnalyzerUrl, {
    globalName: 'zxcvbn'
})($1293d68773c148fa$export$eebfb7c0549090);
var $1293d68773c148fa$export$2e2bcd8739ae039 = $1293d68773c148fa$export$6672436889ec70b1;
const $1293d68773c148fa$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $1293d68773c148fa$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($1293d68773c148fa$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($1293d68773c148fa$var$splitter).reduce($1293d68773c148fa$var$addUnique, arr), deduped);
}
const $1293d68773c148fa$var$leftPercentage = '19%';
const $1293d68773c148fa$var$rightPercentage = '19%';
const $1293d68773c148fa$var$leftPercentageAfter = '30%';
const $1293d68773c148fa$var$rightPercentageAfter = '30%';
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $1293d68773c148fa$var$Dividers = /*#__PURE__*/ (0, $el3DQ.default).span.withConfig({
    componentId: "sc-2owkvn-0"
})`border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;left:${$1293d68773c148fa$var$leftPercentage};position:absolute;right:${$1293d68773c148fa$var$rightPercentage};top:0;&::after{border-left:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};border-right:5px solid ${"var(--ds-border-inverse, #FFFFFF)"};bottom:0;content:'';left:${$1293d68773c148fa$var$leftPercentageAfter};position:absolute;right:${$1293d68773c148fa$var$rightPercentageAfter};top:0;}`;
const $1293d68773c148fa$var$barWidths = [
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $1293d68773c148fa$var$barColours = [
    "var(--ds-chart-danger-bold, #BF2600)",
    "var(--ds-chart-danger, #FF5630)",
    "var(--ds-chart-warning, #FFAB00)",
    "var(--ds-chart-success, #36B37E)",
    "var(--ds-chart-success-bold, #00875A)"
];
const $1293d68773c148fa$export$bbc6c6369b38e3d1 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-2owkvn-1"
})`background:${"var(--ds-chart-neutral, #DFE1E6)"};height:${$bpWyP.multiple(0.25).px};margin-top:${"var(--ds-space-075, 6px)"};position:relative;&::before{background-color:${(props)=>props.score === null ? "var(--ds-chart-neutral, #DFE1E6)" : $1293d68773c148fa$var$barColours[props.score]};bottom:0;content:'';left:0;position:absolute;top:0;transition:all 0.2s ease-out;width:${(props)=>props.score === null ? 0 : $1293d68773c148fa$var$barWidths[props.score]};}`;
const $1293d68773c148fa$export$8d13340382210b65 = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-2owkvn-2"
})`color:${"var(--ds-text-subtlest, #8993A4)"};${$4W9tu.small} height:${$bpWyP.multiple(2).px};line-height:${$bpWyP.multiple(2).px};margin-top:${"var(--ds-space-050, 4px)"};position:relative;text-align:center;`;

});
parcelRegister("jpdXS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e20b2f417d5e655e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");

var $cpFTT = parcelRequire("cpFTT");
function $e20b2f417d5e655e$var$_extends() {
    $e20b2f417d5e655e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e20b2f417d5e655e$var$_extends.apply(this, arguments);
}
function $e20b2f417d5e655e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e20b2f417d5e655e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e20b2f417d5e655e$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $e20b2f417d5e655e$var$idCount = 0;
function $e20b2f417d5e655e$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $e20b2f417d5e655e$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $e20b2f417d5e655e$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $e20b2f417d5e655e$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $e20b2f417d5e655e$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $e20b2f417d5e655e$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $4fqPo.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $4fqPo.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $4fqPo.forwardRef)(function(props, ref) {
            return (0, $4fqPo.createElement)(AsyncScriptLoader, $e20b2f417d5e655e$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($4S7MC))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($cpFTT)))(ForwardedComponent, WrappedComponent);
    };
}

});

parcelRegister("2q6NB", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbc6f30dc3c4572f$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $cbc6f30dc3c4572f$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    passwordInvalid: {
        id: 'password.invalid.password.size',
        description: 'Displayed when the user has entered a password shorter than 8 characters',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel0: {
        id: 'password.strength.level.0',
        description: 'Displayed when the user has entered a weak password',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        description: 'Displayed when the user has entered a fair (not very good) password',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        description: 'Displayed when the user has entered a good password',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        description: 'Displayed when the user has entered a strong password',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        description: 'Displayed when the user has entered a very strong password',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        description: 'Displayed when the password strength cannot be determined due to an error',
        defaultMessage: 'Password strength unavailable'
    }
});

});



parcelRegister("2P0Zg", function(module, exports) {
$parcel$export(module.exports, "ErrorIndication", () => (parcelRequire("cQ310")).default);

var $cQ310 = parcelRequire("cQ310");

});
parcelRegister("cQ310", function(module, exports) {
$parcel$export(module.exports, "default", () => $db63d7951d568e2a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $efDRU = parcelRequire("efDRU");

var $geWWn = parcelRequire("geWWn");

var $e2Zgo = parcelRequire("e2Zgo");

var $fwSzd = parcelRequire("fwSzd");
const $db63d7951d568e2a$var$ErrorIndication = ({ errorMessage: errorMessage, intl: intl })=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
        migratedComponent: /*#__PURE__*/ $4fqPo.createElement($db63d7951d568e2a$var$ContainerV2, null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
            label: "error",
            color: "var(--ds-icon-danger, #BF2600)",
            size: "small"
        }), /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), {
            size: "small",
            color: "color.text.danger"
        }, typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)))
    }, /*#__PURE__*/ $4fqPo.createElement($db63d7951d568e2a$var$Container, null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        label: "error",
        color: "var(--ds-icon-danger, #BF2600)",
        size: "small"
    }), typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)));
};
var $db63d7951d568e2a$export$2e2bcd8739ae039 = (0, $efDRU.default)($db63d7951d568e2a$var$ErrorIndication);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $db63d7951d568e2a$var$ContainerV2 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-xau1xe-0"
})`margin-top:${"var(--ds-space-050, 4px)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $db63d7951d568e2a$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-xau1xe-1"
})`${$4W9tu.small};margin-top:${"var(--ds-space-050, 4px)"};color:${"var(--ds-text-danger, #BF2600)"};display:flex;align-items:center;gap:${"var(--ds-space-050, 4px)"};`;

});


parcelRegister("8iGCq", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fec79e453c051ae$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $5fec79e453c051ae$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    label: {
        defaultMessage: 'Password',
        description: 'Label for password field',
        id: 'password.field.label'
    },
    showPassword: {
        defaultMessage: 'Show',
        description: 'Label for show password button',
        id: 'password.show.button.label'
    },
    hidePassword: {
        defaultMessage: 'Hide',
        description: 'Label for hide password button',
        id: 'password.hide.button.label'
    }
});

});



parcelRegister("kQ4cG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5344c81c4a5d60d7$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $21P09 = parcelRequire("21P09");

var $2eKV2 = parcelRequire("2eKV2");

var $9RW5e = parcelRequire("9RW5e");

var $3H4LK = parcelRequire("3H4LK");

var $Cp2Ub = parcelRequire("Cp2Ub");
var $5E02Z = parcelRequire("5E02Z");

var $fM6CG = parcelRequire("fM6CG");
const $5344c81c4a5d60d7$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    containerT26Shape: "_2rko1mok",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c8fhey _syazi7uo",
    actionsContainer: "_11c8fhey",
    dismissButtonContainer: "_1pfh1i6y"
};
const $5344c81c4a5d60d7$var$appearanceStyles = {
    information: "_bfhk19ip",
    warning: "_bfhk1917",
    error: "_bfhk1gly",
    success: "_bfhk1y9u",
    discovery: "_bfhk6vm6"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $5344c81c4a5d60d7$var$SectionMessage = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, headingLevel: headingLevel = 'h2', icon: icon, isDismissible: isDismissible, onDismiss: onDismiss, testId: testId }, ref) {
    const [dismissed, setDismissed] = (0, $4fqPo.useState)(false);
    const handleDismiss = (0, $4fqPo.useCallback)(()=>{
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $fM6CG.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, $4fqPo.Fragment) ? actions.props.children : actions;
    const actionsArray = (0, $4fqPo.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $4fqPo.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $ltgDR.default)([
            $5344c81c4a5d60d7$var$sectionMessageStyles.container,
            (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $5344c81c4a5d60d7$var$sectionMessageStyles.containerT26Shape,
            $5344c81c4a5d60d7$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $5344c81c4a5d60d7$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $4fqPo.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        // props for new icon
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), {
        space: "space.100",
        testId: testId && `${testId}--content`,
        xcss: $5344c81c4a5d60d7$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        as: headingLevel,
        size: "small"
    }, title), /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $5344c81c4a5d60d7$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        // Only use a list role if more than one action is present
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $5344c81c4a5d60d7$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
        /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action)))), isDismissible && /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $5344c81c4a5d60d7$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $21P09.default), {
        testId: testId && `${testId}--dismiss-button`,
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$5344c81c4a5d60d7$var$SectionMessage.displayName = 'SectionMessage';
var $5344c81c4a5d60d7$export$2e2bcd8739ae039 = $5344c81c4a5d60d7$var$SectionMessage;

});
parcelRegister("fM6CG", function(module, exports) {
$parcel$export(module.exports, "getAppearanceIconStyles", () => $2fa92e349a8cd317$export$e9b82d2e21ac0c1f);

var $4fqPo = parcelRequire("4fqPo");

var $brNR6 = parcelRequire("brNR6");

var $geWWn = parcelRequire("geWWn");

var $bNwNQ = parcelRequire("bNwNQ");

var $3RpuA = parcelRequire("3RpuA");

var $klZKM = parcelRequire("klZKM");
const $2fa92e349a8cd317$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, #E9F2FE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))),
        primaryIconColor: "var(--ds-icon-information, #357DE8)"
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, #FFF5DB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($klZKM))),
        primaryIconColor: "var(--ds-icon-warning, #E06C00)"
    },
    error: {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($geWWn))),
        primaryIconColor: "var(--ds-icon-danger, #C9372C)"
    },
    success: {
        backgroundColor: "var(--ds-background-success, #EFFFD6)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))),
        primaryIconColor: "var(--ds-icon-success, #6A9A23)"
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, #F8EEFE)",
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($brNR6))),
        primaryIconColor: "var(--ds-icon-discovery, #AF59E1)"
    }
};
function $2fa92e349a8cd317$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $2fa92e349a8cd317$var$appearanceIconSchema[appearance] || $2fa92e349a8cd317$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ primaryColor: primaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(appearanceIconStyles.Icon, {
            color: primaryColor,
            spacing: "spacious",
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("brNR6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b3613c7e18556761a1c0b5ad2c9a88f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8558e398a606d415$var$_react = $8558e398a606d415$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $8558e398a606d415$var$_baseNew = $8558e398a606d415$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $8558e398a606d415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusDiscovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8558e398a606d415$var$StatusDiscoveryIcon = (props)=>/*#__PURE__*/ $8558e398a606d415$var$_react.default.createElement($8558e398a606d415$var$_baseNew.default, Object.assign({
        name: "StatusDiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10.5 15.06v-3.81a.75.75 0 0 1 .75-.75h3.81z"/><path fill="currentcolor" fill-rule="evenodd" d="M13 1a2 2 0 0 1 2 2v6h-4.75C9.56 9 9 9.56 9 10.25V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zM4 9h3V7.5H4zm0-5v1.5h7V4z" clip-rule="evenodd"/>`
    }, props));
$8558e398a606d415$var$StatusDiscoveryIcon.displayName = 'StatusDiscoveryIcon';
var $8558e398a606d415$var$_default = module.exports.default = $8558e398a606d415$var$StatusDiscoveryIcon;

});



parcelRegister("f1NTg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a3825505c69d8cf$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $1a3825505c69d8cf$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    resetPasswordLink: {
        defaultMessage: 'Reset password',
        description: 'Text of the reset password link',
        id: 'cv.login.reset.password.link'
    },
    resetPasswordLinkInlineBold: {
        defaultMessage: 'Reset Password',
        description: 'Text of the reset password which is inline bold',
        id: 'cv.login.reset.password.link.bold'
    },
    createPasswordLink: {
        defaultMessage: 'Create password',
        description: "Text to create password for customers who haven't yet set a password",
        id: 'cv.login.create.a.password.link'
    },
    dontHavePasswordText: {
        defaultMessage: "Don't have a password?",
        description: "Text to prompt user if they don't already have a password due to a new account",
        id: 'cv.login.dont.have.password.text'
    },
    nextButton: {
        defaultMessage: 'Next',
        description: 'Next button label',
        id: 'cv.next.button.label'
    },
    continueButton: {
        defaultMessage: 'Continue',
        description: 'Continue button label',
        id: 'cv.continue.button.label'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for login email field',
        id: 'cv.login.page.email.label'
    },
    passwordLabelAndPlaceholder: {
        defaultMessage: 'Password',
        description: 'Placeholder and label for login password field',
        id: 'cv.signup.page.password'
    },
    invalidEmailError: {
        defaultMessage: 'Enter a valid email address and try again.',
        description: 'Error shown when the email does not have the correct format.',
        id: 'sd.login.error.invalid.email.error'
    },
    incorrectPasswordError: {
        defaultMessage: 'Incorrect password. Try again',
        description: 'Error shown when the password is incorrect.',
        id: 'sd.login.error.incorrect.password'
    },
    emptyPasswordError: {
        defaultMessage: 'You must enter your password to log in',
        description: 'Error shown when the password is empty',
        id: 'sd.login.error.empty.password'
    },
    accessDeniedErrorCodeMessage: {
        defaultMessage: "You can\u2019t continue with single sign-on. Try again.",
        description: 'Error shown when receiving access deny error code from identity.',
        id: 'sd.login.errorcode.access.denied'
    },
    defaultErrorCodeMessage: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error shown when the receiving other error code',
        id: 'sd.login.errorcode.default'
    },
    loginConsentErrorMessage: {
        defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later',
        description: 'Error shown when the FedRAMP user failed to consent and got redirected to the login page',
        id: 'sd.login.consent.fail.error'
    }
});

});



parcelRegister("gJUDb", function(module, exports) {
$parcel$export(module.exports, "default", () => $be42baf9f04861ca$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $be42baf9f04861ca$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    invalidLogin: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Message to show that email or password are incorrect and that the user should try again.',
        id: 'sd.login.error.invalid.login.unified'
    },
    accountLocked: {
        defaultMessage: "For security reasons, we've temporarily locked this account due to multiple unsuccessful login attempts. To regain access, select {forgotPasswordLink} to reset your password.",
        description: 'Error message if the account is locked.',
        id: 'sd.login.account.locked.unified'
    },
    miscLoginError: {
        defaultMessage: 'Something went wrong while trying to log you in. Try again.',
        description: 'Error message for any not classified errors.',
        id: 'sd.login.error.misc.unified'
    }
});

});




parcelRegister("lb6pJ", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOn", () => (parcelRequire("jtu9m")).default);

var $jtu9m = parcelRequire("jtu9m");

});
parcelRegister("jtu9m", function(module, exports) {
$parcel$export(module.exports, "default", () => $9052cf5ce1590a60$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bG6ob = parcelRequire("bG6ob");

var $4W9tu = parcelRequire("4W9tu");

var $eQdiM = parcelRequire("eQdiM");

var $8Gf3q = parcelRequire("8Gf3q");

var $5Uaxl = parcelRequire("5Uaxl");
var $efDRU = parcelRequire("efDRU");
parcelRequire("5yD7X");
var $lJn7w = parcelRequire("lJn7w");

var $6bGmX = parcelRequire("6bGmX");

var $2eKV2 = parcelRequire("2eKV2");

var $7TPEx = parcelRequire("7TPEx");
var $e2Zgo = parcelRequire("e2Zgo");

var $WVSzu = parcelRequire("WVSzu");

var $fwSzd = parcelRequire("fwSzd");

var $aUp2V = parcelRequire("aUp2V");
class $9052cf5ce1590a60$export$b77dc1349d86cfac extends $4fqPo.Component {
    componentDidMount() {
        this.setState({
            isInIframe: window.self !== window.top
        });
    }
    render() {
        return /*#__PURE__*/ $4fqPo.createElement($9052cf5ce1590a60$var$Container, null, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), this.getSSOFormContent(), /*#__PURE__*/ $4fqPo.createElement($9052cf5ce1590a60$var$ButtonContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $eQdiM.ThemedButton), {
            id: "login-button",
            "data-test-id": "login-sso-button",
            appearance: "primary",
            shouldFitContainer: true,
            actionSubjectId: "submitLoginSSO",
            href: this.getSSOUrl(),
            target: this.state.isInIframe && (0, $bG6ob.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
            rel: this.state.isInIframe && (0, $bG6ob.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
            autoFocus: true
        }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $aUp2V.default).continueWithAtlassianAccountButton))), this.getAtlassianAccountInfoSection());
    }
    constructor(...args){
        super(...args), this.state = {
            isInIframe: false
        }, this.getSSOUrl = ()=>{
            return this.props.redirectUrl;
        }, this.getSSOFormContent = ()=>{
            const { intl: intl, email: email } = this.props;
            return /*#__PURE__*/ $4fqPo.createElement((0, $lJn7w.default), {
                id: "user-email",
                shouldFitContainer: true,
                label: intl.formatMessage((0, $aUp2V.default).emailLabel),
                disabled: true,
                defaultValue: email
            });
        }, this.getAtlassianAccountInfoSection = ()=>{
            const { intl: intl } = this.props;
            const URI = 'https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/';
            const supportLink = /*#__PURE__*/ $4fqPo.createElement((0, $8Gf3q.default), {
                actionSubjectId: "learnMoreAtlassianAccount",
                href: URI,
                target: "_blank",
                id: "sso-login-learn-more-link",
                "aria-labelledby": "sso-login-learn-more-link sso-login-atlassian-account-heading"
            }, intl.formatMessage((0, $aUp2V.default).atlassianAccountInfoLink));
            return /*#__PURE__*/ $4fqPo.createElement($9052cf5ce1590a60$var$InfoSectionContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                    paddingBlockStart: "space.300"
                }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
                    size: "xsmall"
                }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $aUp2V.default).atlassianAccountInfoTitle)))
            }, /*#__PURE__*/ $4fqPo.createElement($9052cf5ce1590a60$var$InfoSectionTitle, {
                role: "heading",
                "aria-level": 3,
                id: "sso-login-atlassian-account-heading"
            }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $aUp2V.default).atlassianAccountInfoTitle))), /*#__PURE__*/ $4fqPo.createElement((0, $fwSzd.UseTypographyMigratedComponent), {
                migratedComponent: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                    paddingBlockStart: "space.050"
                }, /*#__PURE__*/ $4fqPo.createElement((0, $e2Zgo.default), null, (0, $6bGmX.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
                    ...(0, $aUp2V.default).atlassianAccountInfoContentAppify,
                    values: {
                        supportLink: supportLink
                    }
                }) : /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
                    ...(0, $aUp2V.default).atlassianAccountInfoContent,
                    values: {
                        supportLink: supportLink
                    }
                })))
            }, /*#__PURE__*/ $4fqPo.createElement($9052cf5ce1590a60$var$InfoSectionContent, null, (0, $6bGmX.default).checkGate('jsm_rename_product_to_app') ? /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
                ...(0, $aUp2V.default).atlassianAccountInfoContentAppify,
                values: {
                    supportLink: supportLink
                }
            }) : /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), {
                ...(0, $aUp2V.default).atlassianAccountInfoContent,
                values: {
                    supportLink: supportLink
                }
            }))));
        };
    }
}
var $9052cf5ce1590a60$export$2e2bcd8739ae039 = (0, $efDRU.default)($9052cf5ce1590a60$export$b77dc1349d86cfac);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9052cf5ce1590a60$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-qruqqd-0"
})`text-align:left;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9052cf5ce1590a60$var$ButtonContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-qruqqd-1"
})`margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9052cf5ce1590a60$var$InfoSectionContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-qruqqd-2"
})`margin-top:${"var(--ds-space-300, 24px)"};border-top:${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, rgba(9, 30, 66, 0.14))"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9052cf5ce1590a60$var$InfoSectionTitle = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-qruqqd-3"
})`${(0, $4W9tu.h400)};margin-top:${"var(--ds-space-300, 24px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9052cf5ce1590a60$var$InfoSectionContent = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-qruqqd-4"
})`margin-top:${"var(--ds-space-050, 4px)"};`;

});
parcelRegister("aUp2V", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e502bb2fa84a1a5$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $8e502bb2fa84a1a5$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    continueWithAtlassianAccountButton: {
        defaultMessage: 'Continue with Atlassian account',
        description: 'The redirect button text for login with single sign-on',
        id: 'cv.login.sso.button.text'
    },
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for login email field',
        id: 'cv.login.sso.email.label'
    },
    atlassianAccountInfoTitle: {
        defaultMessage: 'Your Atlassian account',
        description: 'Title of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.title'
    },
    atlassianAccountInfoContent: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian products. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content'
    },
    atlassianAccountInfoContentAppify: {
        defaultMessage: 'Make things easier by using one account across all of your Atlassian apps. {supportLink}',
        description: 'Content of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.content-appify'
    },
    atlassianAccountInfoLink: {
        defaultMessage: 'Learn more',
        description: 'Learn more link of atlassian account info section',
        id: 'cv.login.sso.atlassian.account.info.link'
    }
});

});



parcelRegister("gD5QM", function(module, exports) {
$parcel$export(module.exports, "LoginSingleSignOnCustomer", () => (parcelRequire("14GJF")).default);

var $14GJF = parcelRequire("14GJF");

});
parcelRegister("14GJF", function(module, exports) {
$parcel$export(module.exports, "default", () => $23011616a9ce0aee$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $bG6ob = parcelRequire("bG6ob");

var $bpWyP = parcelRequire("bpWyP");

var $eQdiM = parcelRequire("eQdiM");

var $dQegt = parcelRequire("dQegt");
parcelRequire("5yD7X");
var $lJn7w = parcelRequire("lJn7w");

var $WVSzu = parcelRequire("WVSzu");

var $04VZk = parcelRequire("04VZk");

var $gz5Nl = parcelRequire("gz5Nl");
const $23011616a9ce0aee$var$LoginSingleSignOnCustomer = (props)=>{
    const { email: email, redirectLink: redirectLink, passwordLoginAvailable: passwordLoginAvailable, onContinueWithPassword: onContinueWithPassword } = props;
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [isInIframe, setIsInIframe] = (0, $4fqPo.useState)(false);
    (0, $4fqPo.useEffect)(()=>{
        setIsInIframe(window.self !== window.top);
    }, []);
    const getContinueWithPasswordLink = ()=>{
        return passwordLoginAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($23011616a9ce0aee$var$FooterContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eQdiM.ThemedButton), {
            appearance: "link",
            actionSubjectId: "continueWithPassword",
            onClick: onContinueWithPassword
        }, formatMessage((0, $gz5Nl.default).continueWithPasswordButton))) : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($23011616a9ce0aee$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lJn7w.default), {
        id: "user-email",
        shouldFitContainer: true,
        label: formatMessage((0, $gz5Nl.default).emailLabel),
        disabled: true,
        defaultValue: email
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $04VZk.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eQdiM.ThemedButton), {
        id: "continue-with-customer-sso-button",
        appearance: "primary",
        shouldFitContainer: true,
        actionSubjectId: "continueWithCustomerSSO",
        isDisabled: redirectLink === undefined,
        href: redirectLink,
        target: isInIframe && (0, $bG6ob.isJsmPortalRovoIntegrationEnabled)() ? '_blank' : undefined,
        rel: isInIframe && (0, $bG6ob.isJsmPortalRovoIntegrationEnabled)() ? 'opener' : undefined,
        autoFocus: true
    }, formatMessage((0, $gz5Nl.default).continueWithSingleSignOnButton))), getContinueWithPasswordLink());
};
var $23011616a9ce0aee$export$2e2bcd8739ae039 = $23011616a9ce0aee$var$LoginSingleSignOnCustomer;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $23011616a9ce0aee$var$FooterContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-t9atao-0"
})`margin-top:${$bpWyP.multiple(4.25).px};text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $23011616a9ce0aee$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-t9atao-1"
})`text-align:left;`;

});
parcelRegister("04VZk", function(module, exports) {
$parcel$export(module.exports, "ButtonContainer", () => $2160f4b72d66b30f$export$eddf54ea3db8d0f0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve

var $el3DQ = parcelRequire("el3DQ");
const $2160f4b72d66b30f$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-mrwmoh-0"
})`margin-top:${"var(--ds-space-300, 24px)"};`;

});

parcelRegister("gz5Nl", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd6334e40562470b$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $dd6334e40562470b$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    emailLabel: {
        defaultMessage: 'Email address',
        description: 'Label for login email field',
        id: 'cv.login.sso.customer.email.label'
    },
    continueWithPasswordButton: {
        defaultMessage: 'Continue with password',
        description: 'The button text for customer account login using password',
        id: 'cv.login.sso.customer.password.link.text'
    },
    continueWithSingleSignOnButton: {
        defaultMessage: 'Continue with single sign-on',
        description: 'The redirect button text for customer account login using single sign-on',
        id: 'cv.login.sso.customer.button.text'
    }
});

});






parcelRegister("6bsub", function(module, exports) {
$parcel$export(module.exports, "loginAnnouncementsCardResource", () => $382bcb0bdc0fa73a$export$978d7819e59e352f);

var $eLaJd = parcelRequire("eLaJd");

var $fZppw = parcelRequire("fZppw");
const $382bcb0bdc0fa73a$export$978d7819e59e352f = (0, $fZppw.createRelayResource)({
    type: 'HELP_CENTER_LOGIN_ANNOUNCEMENTS_CARD',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $eLaJd.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});

parcelRegister("jcK59", function(module, exports) {
$parcel$export(module.exports, "waitingBrandingResource", () => $1af0bee6ce114f61$export$e5e5917f15b57d37);

var $5eCdR = parcelRequire("5eCdR");

var $1hcn6 = parcelRequire("1hcn6");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");

var $f2UoR = parcelRequire("f2UoR");

var $8t8PZ = parcelRequire("8t8PZ");
const $1af0bee6ce114f61$export$d23b87ed2b78c76d = 3000;
/**
 * Returns true when the branding data fetch has completed — either successfully or with an error.
 * The `isBrandingLoaded` flag is set by `updateHCBrandingLoaderAction(true)` which is dispatched
 * on both success and error paths in the epic.
 */ const $1af0bee6ce114f61$var$isBrandingResolved = (state)=>{
    return state.persisted.helpCenter.isBrandingLoaded === true;
};
const $1af0bee6ce114f61$export$3ba04cf2ed97ffdc = ()=>{
    return new Promise((resolve)=>{
        // Check if branding data is already in the store (e.g. from initialModel/SSR bootstrap)
        if ($1af0bee6ce114f61$var$isBrandingResolved((0, $1hcn6.store).getState())) {
            resolve(null);
            return;
        }
        // Safety timeout: resolve even if the epic silently fails, so we don't block SSR forever.
        // We capture the unsubscribe function reference via a mutable object so we can use it in the timeout.
        const subscription = {};
        const timeoutId = setTimeout(()=>{
            var _subscription$unsubsc;
            (_subscription$unsubsc = subscription.unsubscribe) === null || _subscription$unsubsc === void 0 || _subscription$unsubsc.call(subscription);
            resolve(null);
        }, $1af0bee6ce114f61$export$d23b87ed2b78c76d);
        subscription.unsubscribe = (0, $1hcn6.store).subscribe(()=>{
            const state = (0, $1hcn6.store).getState();
            if ($1af0bee6ce114f61$var$isBrandingResolved(state)) {
                var _subscription$unsubsc2;
                clearTimeout(timeoutId);
                (_subscription$unsubsc2 = subscription.unsubscribe) === null || _subscription$unsubsc2 === void 0 || _subscription$unsubsc2.call(subscription);
                resolve(null);
            }
        });
    });
};
const $1af0bee6ce114f61$export$e5e5917f15b57d37 = (0, $f03OU.createResource)({
    type: 'RELAY_HELP_CENTER_BRANDING',
    getKey: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const request = (0, $f2UoR.getRequest)((0, $8t8PZ.default));
        const params = request.params;
        return `${String(params.id)}${JSON.stringify({
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        })}`;
    },
    getData: ()=>{
        (0, $1hcn6.store).dispatch((0, $5eCdR.fetchHelpCenterBrandingAction)());
        return $1af0bee6ce114f61$export$3ba04cf2ed97ffdc();
    }
});

});


parcelRegister("hnpj5", function(module, exports) {
$parcel$export(module.exports, "portalAccessForbiddenRoute", () => $83a51c375d761afb$export$51c7ebad0d50c69a);

var $748yq = parcelRequire("748yq");
parcelRequire("6veMO");
var $85nQv = parcelRequire("85nQv");

var $bp9tj = parcelRequire("bp9tj");
const $83a51c375d761afb$var$layoutProps = {
    isAnonymous: true,
    hideSearchButton: true,
    paperAppearance: 'normal',
    fadeInSearchModal: true,
    headerless: true
};
const $83a51c375d761afb$export$51c7ebad0d50c69a = (0, $bp9tj.createRouteWithLayout)({
    name: 'portal-access-forbidden',
    path: '/user/forbidden',
    exact: true,
    component: (0, $85nQv.default),
    resources: []
}, (0, $748yq.ScreenName).PORTAL_ACCESS_FORBIDDEN, $83a51c375d761afb$var$layoutProps);

});
parcelRegister("6veMO", function(module, exports) {
$parcel$export(module.exports, "PortalAccessForbidden", () => (parcelRequire("85nQv")).default);

var $85nQv = parcelRequire("85nQv");

});
parcelRegister("85nQv", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e48269f493fc967$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $6I6vt = parcelRequire("6I6vt");
const $6e48269f493fc967$var$selector = (0, $3yyCx.createSelector)((state)=>(0, $2hx7o.isLoggedIn)(state), (state)=>(0, $2hx7o.getUserState)(state), (isUserLoggedIn, userState)=>({
        isUserLoggedIn: isUserLoggedIn,
        userEmail: userState.email || ''
    }));
var $6e48269f493fc967$export$2e2bcd8739ae039 = (0, $bmgw6.default)($6e48269f493fc967$var$selector)((0, $6I6vt.default));

});
parcelRegister("6I6vt", function(module, exports) {
$parcel$export(module.exports, "default", () => $24976e71b8136c01$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $9Ut8d = parcelRequire("9Ut8d");

var $4W9tu = parcelRequire("4W9tu");

var $bpWyP = parcelRequire("bpWyP");

var $8Gf3q = parcelRequire("8Gf3q");

var $93CI1 = parcelRequire("93CI1");

var $5Uaxl = parcelRequire("5Uaxl");
var $dQegt = parcelRequire("dQegt");
parcelRequire("b0F8E");
var $awGaB = parcelRequire("awGaB");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $81eJ3 = parcelRequire("81eJ3");

var $Y85G3 = parcelRequire("Y85G3");

var $iZHYq = parcelRequire("iZHYq");
const $24976e71b8136c01$var$PortalAccessForbidden = ({ isUserLoggedIn: isUserLoggedIn, userEmail: userEmail })=>{
    const callToActionUrl = 'https://start.atlassian.com/';
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const isCSMHelpCenterEnabled = (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType);
    if (!isUserLoggedIn) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $81eJ3.Redirect), {
        to: (0, $Y85G3.getHelpCenterUrl)()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ut8d.default), {
        title: formatMessage((0, $iZHYq.default).documentTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($24976e71b8136c01$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($24976e71b8136c01$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93CI1.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($24976e71b8136c01$var$Message, null, formatMessage((0, $iZHYq.default).errorHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($24976e71b8136c01$var$Description, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), {
        ...isCSMHelpCenterEnabled ? (0, $iZHYq.default).errorDescriptionTextV2 : (0, $iZHYq.default).errorDescriptionText,
        values: {
            userEmail: userEmail,
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("br", null)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($24976e71b8136c01$var$AnchorContainer, {
        actionSubjectId: "redirectToAtlassianStart",
        href: callToActionUrl
    }, formatMessage((0, $iZHYq.default).callToActionText)))));
};
var $24976e71b8136c01$export$2e2bcd8739ae039 = $24976e71b8136c01$var$PortalAccessForbidden;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24976e71b8136c01$var$Container = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-98kmq7-0"
})`display:flex;flex-flow:column wrap;align-items:center;margin-top:${"var(--ds-space-600, 48px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24976e71b8136c01$var$IconContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-98kmq7-1"
})`width:${$bpWyP.multiple(14).px};margin-bottom:${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24976e71b8136c01$var$Message = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-98kmq7-2"
})`${$4W9tu.h600};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24976e71b8136c01$var$Description = /*#__PURE__*/ (0, $el3DQ.default).p.withConfig({
    componentId: "sc-98kmq7-3"
})`${$4W9tu.regular};margin:0 0 ${"var(--ds-space-100, 8px)"} 0;text-align:center;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $24976e71b8136c01$var$AnchorContainer = /*#__PURE__*/ (0, $el3DQ.default)((0, $8Gf3q.default)).withConfig({
    componentId: "sc-98kmq7-4"
})`text-align:center;`;

});
parcelRegister("iZHYq", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9e221c1d74dbaba$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $f9e221c1d74dbaba$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    documentTitle: {
        defaultMessage: 'No access',
        description: 'Document title for user with no access to portal',
        id: 'cv.portal.forbidden.access.document.title'
    },
    errorHeading: {
        defaultMessage: 'No access',
        description: 'Error heading for user with no portal access',
        id: 'cv.portal.forbidden.access.error.heading'
    },
    errorDescriptionText: {
        defaultMessage: "It seems that your account {userEmail} doesn't have access to the help center.{br}Try contacting your admins to grant you permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text'
    },
    errorDescriptionTextV2: {
        defaultMessage: "Your account {userEmail} doesn't have access to this website, help center, or hub.{br}Contact your admin(s) to request access permissions.",
        description: 'Error description for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description.text.v2'
    },
    callToActionText: {
        defaultMessage: 'Go to Atlassian Start',
        description: 'Next action link label for user with no portal access',
        id: 'cv.portal.forbidden.access.error.action.link.label'
    }
});

});





parcelRegister("6WWzZ", function(module, exports) {
$parcel$export(module.exports, "getPortalHomeRoutes", () => $8c32a5ed12a6a94b$export$87f7f4cc1cadb13a);

var $bG6ob = parcelRequire("bG6ob");

var $cwZKZ = parcelRequire("cwZKZ");
parcelRequire("bOzoe");
var $dayto = parcelRequire("dayto");

var $6bGmX = parcelRequire("6bGmX");

var $bp9tj = parcelRequire("bp9tj");
const $8c32a5ed12a6a94b$var$getRoute = ()=>({
        name: 'portal-home',
        path: `/portal/:portalId/:group?/:requestGroupId?/:create?/:requestTypeId?`,
        exact: true,
        component: (0, $dayto.default),
        getUFONameBasedOnRouteMatch: (routerState)=>{
            const { requestTypeId: requestTypeId } = routerState.params;
            if (requestTypeId) return 'request-create';
            return 'portal-home';
        },
        resources: (0, $bG6ob.isUiModificationsSupportEnabled)() && !(0, $6bGmX.default).checkGate('ditto_uim_root_query_rest') ? [
            (0, $cwZKZ.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE)
        ] : []
    });
const $8c32a5ed12a6a94b$var$paperAppearance = 'xxwide';
const $8c32a5ed12a6a94b$var$layoutProps = {
    paperAppearance: $8c32a5ed12a6a94b$var$paperAppearance,
    fadeInSearchModal: true
};
const $8c32a5ed12a6a94b$export$87f7f4cc1cadb13a = ()=>(0, $bp9tj.createRouteWithLayout)($8c32a5ed12a6a94b$var$getRoute(), undefined, $8c32a5ed12a6a94b$var$layoutProps);

});
parcelRegister("bOzoe", function(module, exports) {
$parcel$export(module.exports, "PortalHome", () => (parcelRequire("dayto")).default);

var $dayto = parcelRequire("dayto");

});
parcelRegister("dayto", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ac93e008eb9824c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("i92zu");
var $f1dzi = parcelRequire("f1dzi");

var $748yq = parcelRequire("748yq");

var $f4IfF = parcelRequire("f4IfF");

var $jz05t = parcelRequire("jz05t");
parcelRequire("2WwoJ");
var $ltiec = parcelRequire("ltiec");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("7Aj7n");
var $3SWp7 = parcelRequire("3SWp7");
parcelRequire("95qI5");
var $aEVH2 = parcelRequire("aEVH2");
parcelRequire("9oOr9");
var $3DB5G = parcelRequire("3DB5G");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("ci1CE");
var $xK07M = parcelRequire("xK07M");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $6bGmX = parcelRequire("6bGmX");

var $54jwS = parcelRequire("54jwS");

var $kXlzl = parcelRequire("kXlzl");

var $eHkSG = parcelRequire("eHkSG");

var $3TeDY = parcelRequire("3TeDY");

var $2jpwX = parcelRequire("2jpwX");

var $wHtsq = parcelRequire("wHtsq");

var $5fDAd = parcelRequire("5fDAd");
parcelRequire("l7YB5");
var $60sOE = parcelRequire("60sOE");
parcelRequire("97GnZ");
var $iEbNP = parcelRequire("iEbNP");
const $6ac93e008eb9824c$export$3fbf10a15d6b2168 = (screenLocation)=>(0, $3TeDY.pathname)().endsWith(screenLocation);
class $6ac93e008eb9824c$export$2521bdc6772d1464 extends $4fqPo.Component {
    // Anonymous users were historically blocked because Forge did not support anonymous access
    // for UI modifications. The forge_anonymous_access_for_uim_jsm_portal gate enables that
    // support so anonymous users can also receive UI modifications on the JSM portal.
    canFetchUiModifications() {
        const { isLoggedIn: isLoggedIn } = this.props;
        return (0, $6bGmX.default).checkGate('ditto_uim_root_query_rest') && (isLoggedIn || (0, $6bGmX.default).checkGate('forge_anonymous_access_for_uim_jsm_portal'));
    }
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchUser: fetchUser, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, requestTypeId: requestTypeId, categories: categories } = this.props;
        const analytics = this.getViewSinglePortalAnalyticsEvents();
        if (portalId) {
            fetchPortal({
                id: portalId,
                expand: [
                    'kbs',
                    'orderMapping',
                    'reqGroups',
                    'reqTypes',
                    'analyticsContext',
                    'categories'
                ]
            }, analytics);
            if (requestTypeId) {
                if (!this.props.requestCreateModelLoaded) fetchRequestCreate({
                    portalId: portalId,
                    id: requestTypeId
                });
                if (this.canFetchUiModifications()) fetchUiModifications({
                    portalId: portalId,
                    requestTypeId: requestTypeId
                });
            }
            // FSD-2541: required to re-fetch user model inorder to send correct analytics remove in clean-up task FSD-2881
            fetchUser();
            if (!categories) this.tryFetchCategories();
        }
    }
    componentDidUpdate(prevProps) {
        const { projectId: projectId, requestTypeId: requestTypeId, portalId: portalId, fetchRequestCreate: fetchRequestCreate, fetchUiModifications: fetchUiModifications, kbEnabled: kbEnabled } = this.props;
        const projectUpdated = prevProps.projectId !== projectId;
        const kbEnabledUpdated = !prevProps.kbEnabled && kbEnabled;
        const requestTypeUpdated = prevProps.requestTypeId !== requestTypeId;
        const portalUpdated = prevProps.portalId !== portalId;
        if (projectUpdated || kbEnabledUpdated) this.tryFetchCategories();
        if (portalId && requestTypeId && (portalUpdated || requestTypeUpdated)) {
            fetchRequestCreate({
                portalId: portalId,
                id: requestTypeId
            });
            if (this.canFetchUiModifications()) fetchUiModifications({
                portalId: portalId,
                requestTypeId: requestTypeId
            });
        }
    }
    getScreenName() {
        const { requestTypeId: requestTypeId, requestGroupId: requestGroupId } = this.props;
        let screenName;
        if (requestTypeId) screenName = (0, $748yq.ScreenName).REQUEST_CREATE;
        else if (requestGroupId === -1) screenName = (0, $748yq.ScreenName).REQUEST_GROUP_LIST;
        else if (requestGroupId) screenName = (0, $748yq.ScreenName).REQUEST_GROUP;
        else screenName = (0, $748yq.ScreenName).PORTAL_HOME;
        return screenName;
    }
    render() {
        const { sideBarOpen: sideBarOpen } = this.state;
        const { portalName: portalName, requestTypeName: requestTypeName, isLoading: isLoading, error: error, announcement: announcement, canEditAnnouncement: canEditAnnouncement, portalId: portalId, projectId: projectId, categories: categories, requestTypeId: requestTypeId, requestGroupId: requestGroupId, isProjectSimplified: isProjectSimplified, isAtlassianManagedAccount: isAtlassianManagedAccount, isProjectAdmin: isProjectAdmin, canCustomiseHelpCenter: canCustomiseHelpCenter, requestTypeBelongsToGroup: requestTypeBelongsToGroup, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, isChatSideBarOpen: isChatSideBarOpen, hasProformaForm: hasProformaForm, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction } = this.props;
        const screenName = this.getScreenName();
        return /*#__PURE__*/ $4fqPo.createElement((0, $eHkSG.default), {
            screenName: screenName,
            screenId: requestTypeId || requestGroupId || portalId
        }, /*#__PURE__*/ $4fqPo.createElement((0, $60sOE.default), {
            screenName: screenName
        }, /*#__PURE__*/ $4fqPo.createElement((0, $f1dzi.default), {
            name: (0, $748yq.ExperienceName).REQUEST_CREATE
        }, /*#__PURE__*/ $4fqPo.createElement((0, $5fDAd.UiModificationsContainer), null, /*#__PURE__*/ $4fqPo.createElement((0, $iEbNP.default), {
            portalName: portalName,
            portalId: portalId,
            projectId: projectId,
            requestTypeName: requestTypeName,
            requestTypeId: requestTypeId,
            requestGroupId: requestGroupId,
            loading: isLoading,
            sideBarOpen: sideBarOpen,
            toggleSidebar: this.toggleSideBar,
            announcement: announcement,
            canEditAnnouncement: canEditAnnouncement,
            categories: categories,
            isProjectSimplified: isProjectSimplified,
            canCustomiseHelpCenter: canCustomiseHelpCenter,
            isProjectAdmin: isProjectAdmin,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            requestTypeBelongsToGroup: requestTypeBelongsToGroup,
            isBrandingLoaded: isBrandingLoaded,
            isLoggedIn: isLoggedIn,
            screenName: screenName,
            isChatSideBarOpen: isChatSideBarOpen,
            openChatSideBar: openChatSideBarAction,
            closeChatSideBar: closeChatSideBarAction,
            hasProformaForm: hasProformaForm,
            ...error
        })))));
    }
    constructor(...args){
        super(...args), this.state = {
            sideBarOpen: false
        }, this.tryFetchCategories = ()=>{
            const { portalId: portalId, kbEnabled: kbEnabled, projectId: projectId, categoriesLoaded: categoriesLoaded, fetchCategories: fetchCategories } = this.props;
            if (kbEnabled && projectId && portalId && !categoriesLoaded) {
                const meta = this.getAnalyticsEvents();
                fetchCategories(projectId, portalId, meta);
            }
        }, this.getAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            return {
                analyticsSuccessEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories success',
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent === null || createAnalyticsEvent === void 0 ? void 0 : createAnalyticsEvent({
                    action: 'fetchCategories error',
                    analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE)
                })
            };
        }, this.getViewSinglePortalAnalyticsEvents = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return {
                analyticsSuccessEvent: createAnalyticsEvent({
                    action: (0, $kXlzl.AnalyticsTrackActions).FETCHED,
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                }),
                analyticsFailureEvent: createAnalyticsEvent({
                    action: (0, $kXlzl.AnalyticsTrackActions).FETCHED_FAILURE,
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    actionSubject: 'PortalHome'
                })
            };
            return {};
        }, this.toggleSideBar = (value)=>{
            this.setState({
                sideBarOpen: value !== undefined ? value : !this.state.sideBarOpen
            });
            // this.props.location.pathname is used to check if the user is on the same page
            if (value === false && $6ac93e008eb9824c$export$3fbf10a15d6b2168(this.props.location.pathname)) (0, $wHtsq.clearSidebarExperienceAndCustomize)();
        };
    }
}
const $6ac93e008eb9824c$var$selector = (0, $3yyCx.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const portalId = (0, $2jpwX.toNumber)(portalIdAsString);
    const kbEnabled = portalId && (0, $95tqy.getIsKbEnabled)(state, portalId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestTypeId = props.match.params && (0, $2jpwX.toNumber)(props.match.params.requestTypeId);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const requestGroupId = props.match.params && (0, $2jpwX.toNumber)(props.match.params.requestGroupId);
    const portalName = portalId ? (0, $95tqy.getName)(state, portalId) : undefined;
    const requestType = portalId && requestTypeId ? (0, $95tqy.getPortalRequestType)(state, portalId, requestTypeId) : undefined;
    const requestTypeName = requestType ? requestType.name : undefined;
    const requestTypeBelongsToGroup = portalId && requestGroupId && requestTypeId && (0, $95tqy.getIsRequestTypeBelongsToGroup)(state, portalId, requestGroupId, requestTypeId);
    const requestCreateModelLoaded = portalId && requestTypeId && !!(0, $xK07M.getRequestCreate)(state, portalId, requestTypeId);
    let hasProformaForm = false;
    if (portalId && requestTypeId) hasProformaForm = (0, $xK07M.getRequestTypeHasProformaForm)(state, portalId, requestTypeId);
    return {
        portalId: portalId,
        portalName: portalName,
        kbEnabled: kbEnabled,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        requestTypeBelongsToGroup: requestTypeBelongsToGroup,
        requestCreateModelLoaded: requestCreateModelLoaded,
        hasProformaForm: hasProformaForm,
        isAtlassianManagedAccount: (0, $2hx7o.isAtlassianAccountManaged)(state),
        isLoggedIn: (0, $2hx7o.isLoggedIn)(state),
        categories: (0, $95tqy.getCategories)(state, portalId),
        portal: (0, $95tqy.getPortalOrError)(state, portalId),
        projectId: (0, $95tqy.getProjectId)(state, portalId),
        announcement: (0, $95tqy.getPortalAnnouncement)(state, portalId),
        isProjectAdmin: (0, $95tqy.getCanAdministerProject)(state, portalId),
        canCustomiseHelpCenter: (0, $i8gmD.getCanCustomize)(state),
        isProjectSimplified: (0, $95tqy.getIsProjectSimplified)(state, portalId),
        isBrandingLoaded: (0, $i8gmD.getHelpCenterBrandingLoader)(state),
        isChatSideBarOpen: (0, $3DB5G.isChatSideBarOpen)(state)
    };
}, ({ portalId: portalId, portal: portal, announcement: announcement, requestTypeId: requestTypeId, requestGroupId: requestGroupId, portalName: portalName, hasProformaForm: hasProformaForm, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, requestCreateModelLoaded: requestCreateModelLoaded, isAtlassianManagedAccount: isAtlassianManagedAccount, projectId: projectId, kbEnabled: kbEnabled, categories: categories, isProjectAdmin: isProjectAdmin, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isChatSideBarOpen: isChatSideBarOpen })=>{
    let isLoading = false;
    /**
   * Categories details are required only for single portal screen and not on portal groups / request create form screen (i.e when requestGroupId is present in the URL)
   */ if (requestGroupId) isLoading = Boolean(!portal);
    else isLoading = Boolean(!portal || kbEnabled && !categories);
    const categoriesOrUndefined = Array.isArray(categories) ? categories : undefined;
    return {
        portalId: portalId,
        portalName: portalName,
        requestTypeId: requestTypeId,
        requestGroupId: requestGroupId,
        requestTypeName: requestTypeName,
        projectId: projectId,
        announcement: announcement,
        isLoading: isLoading,
        canCustomiseHelpCenter: canCustomiseHelpCenter,
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        isBrandingLoaded: isBrandingLoaded,
        isLoggedIn: isLoggedIn,
        isChatSideBarOpen: isChatSideBarOpen,
        hasProformaForm: hasProformaForm,
        requestTypeBelongsToGroup: Boolean(requestTypeBelongsToGroup),
        requestCreateModelLoaded: Boolean(requestCreateModelLoaded),
        kbEnabled: Boolean(kbEnabled),
        categories: categoriesOrUndefined,
        isProjectAdmin: Boolean(isProjectAdmin),
        isProjectSimplified: Boolean(isProjectSimplified),
        categoriesLoaded: !!categories,
        error: portal && 'error' in portal ? portal : undefined,
        canEditAnnouncement: announcement ? announcement.canEditAnnouncement : undefined
    };
});
var $6ac93e008eb9824c$export$2e2bcd8739ae039 = (0, $bmgw6.default)($6ac93e008eb9824c$var$selector, {
    openChatSideBar: $ltiec.openChatSideBar,
    closeChatSideBar: $ltiec.closeChatSideBar,
    fetchPortal: (0, $lXazD.fetchPortalAction),
    fetchUser: (0, $f4IfF.fetchUserModelAction),
    fetchCategories: (0, $jz05t.fetchCategoriesAction),
    fetchRequestCreate: (0, $3SWp7.fetchRequestCreateAction),
    fetchUiModifications: (0, $aEVH2.fetchUiModificationsAction)
})((0, $apbG6.default)({
    componentName: 'PortalHome'
})((0, $as4kh.default)()($6ac93e008eb9824c$export$2521bdc6772d1464)));

});
parcelRegister("i92zu", function(module, exports) {
$parcel$export(module.exports, "withExperience", () => $16c6d91dff89bd0a$export$7733b94414b7dcb7);
$parcel$export(module.exports, "Experience", () => (parcelRequire("f1dzi")).default);

var $4fqPo = parcelRequire("4fqPo");

var $f1dzi = parcelRequire("f1dzi");
const $16c6d91dff89bd0a$export$7733b94414b7dcb7 = (experienceName)=>(WrappedComponent)=>// upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
        // eslint-disable-next-line react/display-name
        (props)=>{
            const Component = WrappedComponent;
            return /*#__PURE__*/ $4fqPo.createElement((0, $f1dzi.default), {
                name: experienceName
            }, /*#__PURE__*/ $4fqPo.createElement(Component, props));
        };

});

parcelRegister("ci1CE", function(module, exports) {
$parcel$export(module.exports, "getFormName", () => (parcelRequire("xK07M")).getFormName);
$parcel$export(module.exports, "getFormInstructions", () => (parcelRequire("xK07M")).getFormInstructions);
$parcel$export(module.exports, "getIconUrl", () => (parcelRequire("xK07M")).getIconUrl);
$parcel$export(module.exports, "getRequestCreate", () => (parcelRequire("xK07M")).getRequestCreate);
$parcel$export(module.exports, "getProjectId", () => (parcelRequire("xK07M")).getProjectId);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("xK07M")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("xK07M")).getIssueTypeId);
$parcel$export(module.exports, "getRequestCreateOrError", () => (parcelRequire("xK07M")).getRequestCreateOrError);
$parcel$export(module.exports, "getCanCreateUsers", () => (parcelRequire("xK07M")).getCanCreateUsers);
$parcel$export(module.exports, "getDateFormat", () => (parcelRequire("xK07M")).getDateFormat);
$parcel$export(module.exports, "getDateTimeFormat", () => (parcelRequire("xK07M")).getDateTimeFormat);
$parcel$export(module.exports, "getFirstDay", () => (parcelRequire("xK07M")).getFirstDay);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => (parcelRequire("xK07M")).getUseISO8601WeekNumbers);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => (parcelRequire("xK07M")).getOrganisationsForCurrentUser);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => (parcelRequire("xK07M")).getRequestTypeHasProformaForm);
$parcel$export(module.exports, "getProformaTemplateForm", () => (parcelRequire("xK07M")).getProformaTemplateForm);
$parcel$export(module.exports, "getIsProformaFormDirty", () => (parcelRequire("xK07M")).getIsProformaFormDirty);
$parcel$export(module.exports, "getIsPrefillPending", () => (parcelRequire("xK07M")).getIsPrefillPending);

var $xK07M = parcelRequire("xK07M");

});
parcelRegister("xK07M", function(module, exports) {
$parcel$export(module.exports, "getRequestCreate", () => $c3c28660f2f8a5a6$export$15c8c5e17b9baa02);
$parcel$export(module.exports, "getFormName", () => $c3c28660f2f8a5a6$export$fbe1ca2f3d088136);
$parcel$export(module.exports, "getIconUrl", () => $c3c28660f2f8a5a6$export$89d1c740383224f4);
$parcel$export(module.exports, "getFormInstructions", () => $c3c28660f2f8a5a6$export$76982f53d034f6b1);
$parcel$export(module.exports, "getRequestCreateOrError", () => $c3c28660f2f8a5a6$export$16e5e434a1b5c95e);
$parcel$export(module.exports, "getProjectId", () => $c3c28660f2f8a5a6$export$89040d072f281f85);
$parcel$export(module.exports, "getIssueType", () => $c3c28660f2f8a5a6$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $c3c28660f2f8a5a6$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getCanCreateUsers", () => $c3c28660f2f8a5a6$export$cbe7d03f30fd0cb4);
$parcel$export(module.exports, "getDateFormat", () => $c3c28660f2f8a5a6$export$fa96065c64444af6);
$parcel$export(module.exports, "getDateTimeFormat", () => $c3c28660f2f8a5a6$export$c9c87e313820bd4c);
$parcel$export(module.exports, "getFirstDay", () => $c3c28660f2f8a5a6$export$456eb4e172ef8704);
$parcel$export(module.exports, "getUseISO8601WeekNumbers", () => $c3c28660f2f8a5a6$export$defea3d86e4ab71a);
$parcel$export(module.exports, "getOrganisationsForCurrentUser", () => $c3c28660f2f8a5a6$export$fb4f9a76e583ce63);
$parcel$export(module.exports, "getRequestTypeHasProformaForm", () => $c3c28660f2f8a5a6$export$740668767bebf9a);
$parcel$export(module.exports, "getProformaTemplateForm", () => $c3c28660f2f8a5a6$export$9cb4f66aa30e267a);
$parcel$export(module.exports, "getIsProformaFormDirty", () => $c3c28660f2f8a5a6$export$cd859d45f5982e2);
$parcel$export(module.exports, "getIsPrefillPending", () => $c3c28660f2f8a5a6$export$c1f5b3a2b47daad);
const $c3c28660f2f8a5a6$export$830c804e8d921bba = (state, portalId, requestTypeId)=>{
    if (!portalId || !requestTypeId) return undefined;
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.form;
};
const $c3c28660f2f8a5a6$export$fbe1ca2f3d088136 = (state, portalId, requestTypeId)=>{
    const form = $c3c28660f2f8a5a6$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.name;
};
const $c3c28660f2f8a5a6$export$aa9648d61391326c = (state, portalId, requestTypeId)=>{
    const form = $c3c28660f2f8a5a6$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.intro;
};
const $c3c28660f2f8a5a6$export$89d1c740383224f4 = (state, portalId, requestTypeId)=>{
    const form = $c3c28660f2f8a5a6$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.iconUrl;
};
const $c3c28660f2f8a5a6$export$76982f53d034f6b1 = (state, portalId, requestTypeId)=>{
    const form = $c3c28660f2f8a5a6$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.instructions;
};
const $c3c28660f2f8a5a6$export$d5523731e7fe4ded = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.fields;
};
const $c3c28660f2f8a5a6$export$b87c6f04552c18ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiUploadToken;
};
const $c3c28660f2f8a5a6$export$ddddbd1696231d6a = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.mediaApiError;
};
const $c3c28660f2f8a5a6$export$15c8c5e17b9baa02 = (state, portalId, requestTypeId)=>{
    const data = $c3c28660f2f8a5a6$export$16e5e434a1b5c95e(state, portalId, requestTypeId);
    return data && 'error' in data ? undefined : data;
};
const $c3c28660f2f8a5a6$export$16e5e434a1b5c95e = (state, portalId, requestTypeId)=>{
    const id = `${portalId}/${requestTypeId}`;
    return state.persisted.requestCreate[id];
};
const $c3c28660f2f8a5a6$export$89040d072f281f85 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.projectId;
};
const $c3c28660f2f8a5a6$export$ed2455632bf977ef = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueType;
};
const $c3c28660f2f8a5a6$export$110c9a4a16c5b8c9 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.issueTypeId;
};
const $c3c28660f2f8a5a6$export$36651d42b0b3e63 = (state, portalId, requestTypeId)=>{
    const form = $c3c28660f2f8a5a6$export$830c804e8d921bba(state, portalId, requestTypeId);
    return !!form && form.captchaEnabled && !!form.sitekey;
};
const $c3c28660f2f8a5a6$export$490b07b05dbf5ae5 = (state, portalId, requestTypeId)=>{
    const form = $c3c28660f2f8a5a6$export$830c804e8d921bba(state, portalId, requestTypeId);
    return form && form.captchaEnabled ? form.sitekey : undefined;
};
const $c3c28660f2f8a5a6$export$cbe7d03f30fd0cb4 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate && !!requestCreate.canCreateUsers;
};
const $c3c28660f2f8a5a6$export$fa96065c64444af6 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateFormat;
};
const $c3c28660f2f8a5a6$export$c9c87e313820bd4c = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.dateTimeFormat;
};
const $c3c28660f2f8a5a6$export$456eb4e172ef8704 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.firstDay;
};
const $c3c28660f2f8a5a6$export$defea3d86e4ab71a = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return requestCreate && requestCreate.useISO8601WeekNumbers;
};
const $c3c28660f2f8a5a6$export$fb4f9a76e583ce63 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!requestCreate ? requestCreate.organisationsForCurrentUser : [];
};
const $c3c28660f2f8a5a6$export$2808eba338b2ae16 = (state, portalId, requestTypeId)=>{
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && requestCreate.projectHasProformaForms);
};
const $c3c28660f2f8a5a6$export$740668767bebf9a = (state, portalId, requestTypeId)=>{
    var _requestCreate$profor;
    const requestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId);
    return !!(requestCreate !== null && requestCreate !== void 0 && (_requestCreate$profor = requestCreate.proforma) !== null && _requestCreate$profor !== void 0 && _requestCreate$profor.formExists);
};
const $c3c28660f2f8a5a6$export$9cb4f66aa30e267a = (state, portalId, requestTypeId)=>{
    var _getRequestCreate;
    const proformaTemplateForm = (_getRequestCreate = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) === null || _getRequestCreate === void 0 ? void 0 : _getRequestCreate.proformaTemplateForm;
    if (!proformaTemplateForm || Object.keys(proformaTemplateForm).length === 0) return undefined;
    return proformaTemplateForm;
};
const $c3c28660f2f8a5a6$export$cd859d45f5982e2 = (state, portalId, requestTypeId)=>{
    var _getRequestCreate2;
    return !!((_getRequestCreate2 = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate2 !== void 0 && _getRequestCreate2.proformaFormIsDirty);
};
const $c3c28660f2f8a5a6$export$c1f5b3a2b47daad = (state, portalId, requestTypeId)=>{
    var _getRequestCreate3;
    return !!((_getRequestCreate3 = $c3c28660f2f8a5a6$export$15c8c5e17b9baa02(state, portalId, requestTypeId)) !== null && _getRequestCreate3 !== void 0 && _getRequestCreate3.prefillPending);
};

});


parcelRegister("97GnZ", function(module, exports) {
$parcel$export(module.exports, "PortalHomeDumb", () => (parcelRequire("iEbNP")).default);

var $iEbNP = parcelRequire("iEbNP");

});
parcelRegister("iEbNP", function(module, exports) {
$parcel$export(module.exports, "default", () => $55bffb4e53a0e316$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $dLWpD = parcelRequire("dLWpD");

var $hGOIV = parcelRequire("hGOIV");

var $748yq = parcelRequire("748yq");

var $9Ut8d = parcelRequire("9Ut8d");

var $gMSZD = parcelRequire("gMSZD");

var $MM3bs = parcelRequire("MM3bs");

var $bG6ob = parcelRequire("bG6ob");

var $adk9i = parcelRequire("adk9i");

var $6mmHn = parcelRequire("6mmHn");

var $efDRU = parcelRequire("efDRU");
parcelRequire("aPBSl");
var $lnVYE = parcelRequire("lnVYE");

var $cqJNf = parcelRequire("cqJNf");

var $gOVB5 = parcelRequire("gOVB5");
parcelRequire("btHpW");
var $lPAG2 = parcelRequire("lPAG2");
var $kPEgj = parcelRequire("kPEgj");
parcelRequire("14pOA");
var $6sduf = parcelRequire("6sduf");
parcelRequire("8dHmf");
var $9tNgd = parcelRequire("9tNgd");
parcelRequire("7BEQF");
var $fcd6D = parcelRequire("fcd6D");
parcelRequire("lrbl6");
var $kpi5T = parcelRequire("kpi5T");

var $e1Tq1 = parcelRequire("e1Tq1");

var $8XB1g = parcelRequire("8XB1g");

var $cfDDl = parcelRequire("cfDDl");
parcelRequire("b0F8E");
var $awGaB = parcelRequire("awGaB");

var $89jUj = parcelRequire("89jUj");
parcelRequire("3haKT");
var $b0SRU = parcelRequire("b0SRU");

var $1co7K = parcelRequire("1co7K");

var $44UVd = parcelRequire("44UVd");

var $2qWEd = parcelRequire("2qWEd");

var $7UuIc = parcelRequire("7UuIc");

var $fFB0R = parcelRequire("fFB0R");

var $6bGmX = parcelRequire("6bGmX");

var $7TPEx = parcelRequire("7TPEx");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $2m8U6 = parcelRequire("2m8U6");

var $cijxS = parcelRequire("cijxS");

var $gnwNl = parcelRequire("gnwNl");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $81eJ3 = parcelRequire("81eJ3");

var $a0OAr = parcelRequire("a0OAr");

var $3nV5N = parcelRequire("3nV5N");

var $ja75a = parcelRequire("ja75a");

var $gyfNo = parcelRequire("gyfNo");
parcelRequire("jVjjC");
var $d2GTs = parcelRequire("d2GTs");
var $7Kgqq = parcelRequire("7Kgqq");
var $bLf1t = parcelRequire("bLf1t");

var $3nE6H = parcelRequire("3nE6H");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
parcelRequire("1PLAd");
var $3TxBc = parcelRequire("3TxBc");

var $hg03Q = parcelRequire("hg03Q");
const $55bffb4e53a0e316$var$validateRequestGroupIdPresent = (requestGroupId)=>{
    if (requestGroupId === -1) return false;
    return !!requestGroupId;
};
const $55bffb4e53a0e316$var$getConnectPageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $hGOIV.REQUEST_CREATE;
    return 0, $hGOIV.PORTAL_HOME;
};
const $55bffb4e53a0e316$var$getForgePageType = (requestTypeId)=>{
    if (requestTypeId) return 0, $adk9i.FORGE_REQUEST_CREATE;
    return 0, $adk9i.FORGE_PORTAL_HOME;
};
const $55bffb4e53a0e316$var$getPortalHomeTitle = ({ intl: intl, portalName: portalName, requestTypeName: requestTypeName, requestGroupId: requestGroupId })=>{
    if (requestTypeName) return intl.formatMessage((0, $hg03Q.default).requestTypePageTitle, {
        portalName: portalName,
        requestTypeName: requestTypeName
    });
    if (requestGroupId) return intl.formatMessage((0, $hg03Q.default).portalGroupPageTitle, {
        portalName: portalName
    });
    return intl.formatMessage((0, $hg03Q.default).portalPageTitle, {
        portalName: portalName
    });
};
const $55bffb4e53a0e316$var$PortalHome = ({ intl: intl, requestTypeName: requestTypeName, requestTypeBelongsToGroup: requestTypeBelongsToGroup, portalName: portalName, portalId: portalId, projectId: projectId, loading: loading, requestTypeId: requestTypeId, requestGroupId: requestGroupId, sideBarOpen: sideBarOpen, announcement: announcement, categories: categories, canEditAnnouncement: canEditAnnouncement, isProjectSimplified: isProjectSimplified, isBrandingLoaded: isBrandingLoaded, isLoggedIn: isLoggedIn, canCustomiseHelpCenter: canCustomiseHelpCenter, isProjectAdmin: isProjectAdmin, isAtlassianManagedAccount: isAtlassianManagedAccount, toggleSidebar: toggleSidebar, screenName: screenName, isChatSideBarOpen: isChatSideBarOpen, hasProformaForm: hasProformaForm, openChatSideBar: openChatSideBarAction, closeChatSideBar: closeChatSideBarAction })=>{
    const customiseSidebarTriggerRef = (0, $fcd6D.useCustomiseSidebarTriggerRef)();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { [(0, $7Kgqq.REFERRER_QUERY_PARAM)]: referrer } = (0, $4azHH.useQueryParams)();
    const [isSubmitting, setIsSubmitting] = (0, $4fqPo.useState)(false);
    const openSidebar = (0, $4fqPo.useCallback)(()=>toggleSidebar(true), [
        toggleSidebar
    ]);
    const closeSidebar = (0, $4fqPo.useCallback)(()=>toggleSidebar(false), [
        toggleSidebar
    ]);
    const openChatSidebarCallback = (0, $4fqPo.useCallback)(()=>openChatSideBarAction === null || openChatSideBarAction === void 0 ? void 0 : openChatSideBarAction(), [
        openChatSideBarAction
    ]);
    const closeChatSidebarCallback = (0, $4fqPo.useCallback)(()=>closeChatSideBarAction === null || closeChatSideBarAction === void 0 ? void 0 : closeChatSideBarAction(), [
        closeChatSideBarAction
    ]);
    const onSubmit = (0, $4fqPo.useCallback)(()=>setIsSubmitting(true), [
        setIsSubmitting
    ]);
    const onSubmitComplete = (0, $4fqPo.useCallback)(()=>setIsSubmitting(false), [
        setIsSubmitting
    ]);
    const shouldRenderAsPortalAnnouncement = ()=>{
        // for simplified projects, render side bar as announcement for agents with permission
        if (isProjectSimplified && !isProjectAdmin && canEditAnnouncement) return true;
        // in classic projects render sidebar as announcement for users who can't modify helpcenter, but can edit announcements
        if (!isProjectSimplified && !canCustomiseHelpCenter && canEditAnnouncement) return true;
        return false;
    };
    const renderVsaChatSidebar = ()=>{
        if (!portalId || !isChatSideBarOpen) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $89jUj.LazyVirtualServiceAgentChatSidebar), {
            isOpen: true,
            onOpen: openChatSidebarCallback,
            onClose: closeChatSidebarCallback,
            portalId: portalId
        }));
    };
    const renderSidebar = ()=>{
        if (!canEditAnnouncement) return null;
        if ((0, $eSL4S.isKoshEnabledForDefaultHelpCenter)() && !isBrandingLoaded) // since check in shouldRenderAsPortalAnnouncement is dependent on "canCustomiseHelpCenter" which is coming from helpCenter model, we need to make sure branding relay call is completed
        return null;
        // Render the new 'next-gen' side bar, either as just the Announcement for agents with permission or with all customisation features available for admins
        if (shouldRenderAsPortalAnnouncement()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1co7K.LazyPortalSettingsAnnouncementSidebar), {
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnVYE.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $44UVd.LazyPortalSettingsSidebar), {
            isProjectSimplified: isProjectSimplified,
            isOpen: sideBarOpen,
            onOpen: openSidebar,
            onClose: closeSidebar,
            triggerRef: customiseSidebarTriggerRef
        }));
    };
    const key = String(requestTypeId);
    const title = portalName && $55bffb4e53a0e316$var$getPortalHomeTitle({
        intl: intl,
        portalName: portalName,
        requestTypeName: requestTypeName,
        requestGroupId: requestGroupId
    });
    const shouldRenderDropdown = !!requestGroupId || !categories || !categories.length;
    const shouldShowRequestsInBreadcrumbs = !!shouldRenderDropdown && categories && !!categories.length;
    const isExternalLinksVisible = projectId && !$55bffb4e53a0e316$var$validateRequestGroupIdPresent(requestGroupId) && !requestTypeId;
    const shouldShowSkeleton = projectId && requestTypeId; // show only on request create page (for now)
    const LoadingIndicator = shouldShowSkeleton ? (0, $kpi5T.SkeletonLoadingContainer) : (0, $9tNgd.default);
    const cloudId = (0, $6mmHn.getCloudId)();
    const { isVirtualAgentEnabled: isVirtualAgentEnabled, isLoading: isVirtualAgentLoading } = (0, $3nV5N.useVirtualAgentAvailability)({
        isLoggedIn: isLoggedIn,
        cloudId: cloudId,
        projectId: projectId
    });
    const shouldShowLearnByDoingExperimentBanner = (0, $bLf1t.shouldShowLearnByDoingBanner)(isProjectAdmin, referrer);
    if ((0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $81eJ3.Redirect), {
        to: '/'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ut8d.default), {
        title: title,
        ignoreBaseTitle: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LoadingIndicator, {
        isLoading: loading,
        enableUFOHold: true,
        ufoHoldName: "portal-home-dumb-fallback"
    }, loading && !announcement && !(0, $bG6ob.isUseHelpCenterRefresh)() && (0, $6bGmX.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: "announcement-banner-loading"
    }), !!announcement && !(0, $bG6ob.isUseHelpCenterRefresh)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dLWpD.default), {
        actionSubjectId: "portalAnnouncementBanner",
        header: announcement.userLanguageHeader,
        messageHtml: announcement.userLanguageMessageWiki,
        InnerContainerComponent: $55bffb4e53a0e316$var$AnnouncementInnerContainer
    }), requestGroupId && portalId && requestTypeId && !requestTypeBelongsToGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $81eJ3.Redirect), {
        to: `/portal/${portalId}/group/${requestGroupId}`,
        push: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            attributes: {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                [(0, $7Kgqq.REFERRER_QUERY_PARAM)]: referrer
            }
        }
    }, shouldShowLearnByDoingExperimentBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        testId: "learn-by-doing-container",
        xcss: $55bffb4e53a0e316$var$LearnByDoingContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d2GTs.default), {
        screenName: screenName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $awGaB.PaperContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gyfNo.UiModificationsEntryPoint), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3TxBc.default), {
        showRequestsInBreadcrumbs: shouldShowRequestsInBreadcrumbs
    }), projectId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cqJNf.BlockedAppsBanner), {
        page: $55bffb4e53a0e316$var$getForgePageType(requestTypeId),
        isAtlassianManagedAccount: isAtlassianManagedAccount,
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kPEgj.default), {
        page: $55bffb4e53a0e316$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cfDDl.ForgeHeaderModule), {
        page: $55bffb4e53a0e316$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    }), isVirtualAgentLoading && (0, $6bGmX.default).checkGate('add_ufo_holds_to_request_create_form') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
        name: "virtual-agent-banner-loading"
    }), isVirtualAgentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $55bffb4e53a0e316$var$virtualBannerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ja75a.VirtualAgentBanner), {
        cloudId: cloudId,
        portalId: portalId
    })), !requestGroupId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($55bffb4e53a0e316$export$b1b1a7643a727bbc, {
        portalId: portalId
    }), shouldRenderDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($55bffb4e53a0e316$export$a096e20ba94bf2ce, {
        autoFocus: true,
        portalId: portalId,
        requestGroupId: requestGroupId,
        requestTypeId: requestTypeId,
        isDisabled: isSubmitting
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $b0SRU.default), {
        portalId: portalId,
        requestTypeId: requestTypeId
    }), (0, $6bGmX.default).checkGate('chunk_for_request_create_form_with_proform') && hasProformaForm ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7UuIc.RequestCreateFormWithProforma), {
        portalId: portalId,
        requestTypeId: requestTypeId,
        key: key,
        onSubmit: onSubmit,
        onSubmitComplete: onSubmitComplete
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2qWEd.RequestCreateForm), {
        portalId: portalId,
        requestTypeId: requestTypeId,
        key: key,
        onSubmit: onSubmit,
        onSubmitComplete: onSubmitComplete
    }), isExternalLinksVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($55bffb4e53a0e316$var$ExternalLinksListWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e1Tq1.ExternalLinks), {
        projectId: projectId
    })), (0, $6bGmX.default).checkGate('rovo_service_agent_widget_experience') && projectId && isAtlassianManagedAccount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3nE6H.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: (0, $gnwNl.JiraProjectAri).create({
            projectId: projectId.toString(),
            siteId: cloudId
        }).toString(),
        surface: "PORTAL"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lPAG2.default), {
        page: $55bffb4e53a0e316$var$getConnectPageType(requestTypeId),
        portalId: portalId,
        requestTypeId: requestTypeId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8XB1g.ForgeFooterModule), {
        page: $55bffb4e53a0e316$var$getForgePageType(requestTypeId),
        projectId: projectId,
        requestTypeId: requestTypeId,
        portalId: portalId
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).HELP_CENTER_CUSTOMIZE_ANNOUNCEMENT_SIDEBAR,
        id: 'portal-home-sidebar'
    }, sideBarOpen && renderSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).HELP_CENTER_VSA_CHAT_SIDEBAR,
        id: 'portal-home-vsa-chat-sidebar'
    }, isChatSideBarOpen && renderVsaChatSidebar()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a0OAr.SidebarToggle), {
        openSidebar: openSidebar,
        closeSidebar: closeSidebar
    })));
};
const $55bffb4e53a0e316$export$22ca00a6007ba086 = (0, $MM3bs.withErrorPage)($55bffb4e53a0e316$var$PortalHome, {
    isEmptyTraceIdLogExcluded: true
});
var $55bffb4e53a0e316$export$2e2bcd8739ae039 = (0, $efDRU.default)($55bffb4e53a0e316$export$22ca00a6007ba086);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $55bffb4e53a0e316$var$AnnouncementInnerContainer = /*#__PURE__*/ (0, $el3DQ.default)((0, $awGaB.PaperContent)).withConfig({
    componentId: "sc-1lc3w8v-0"
})`padding-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $55bffb4e53a0e316$var$ExternalLinksListWrapper = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1lc3w8v-1"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $55bffb4e53a0e316$export$a096e20ba94bf2ce = /*#__PURE__*/ (0, $el3DQ.default)((0, $6sduf.default)).withConfig({
    componentId: "sc-1lc3w8v-2"
})`margin:${"var(--ds-space-400, 32px)"} 0 ${"var(--ds-space-100, 8px)"};position:relative;`;
const $55bffb4e53a0e316$export$b1b1a7643a727bbc = /*#__PURE__*/ (0, $el3DQ.default)((0, $gOVB5.CategoryList)).withConfig({
    componentId: "sc-1lc3w8v-3"
})`margin-top:${"var(--ds-space-400, 32px)"};`;
const $55bffb4e53a0e316$var$virtualBannerStyles = (0, $2m8U6.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.200'
});
const $55bffb4e53a0e316$var$LearnByDoingContainerStyles = (0, $2m8U6.xcss)({
    height: '266px',
    display: 'none',
    [(0, $3jKXW.media).above.md]: {
        display: 'flex'
    }
});

});
parcelRegister("cqJNf", function(module, exports) {
$parcel$export(module.exports, "BlockedAppsBanner", () => $2eae24be6ea0be0f$export$757c2c7994b73daa);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("6Thom");
var $5HHec = parcelRequire("5HHec");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $fkaUt = parcelRequire("fkaUt");

var $apbG6 = parcelRequire("apbG6");
const $2eae24be6ea0be0f$var$blockedAppsBannerSelector = (0, $3yyCx.createSelector)((0, $5HHec.getBlockedAppsBannerStatePortal), (0, $5HHec.getBlockedAppsBannerStateRequestView), (0, $5HHec.getBlockedAppsBannerStateCreateRequest), (0, $2hx7o.getAccountId), (portal, viewRequest, createRequest, accountId)=>{
    return {
        accountId: accountId,
        blockedAppsBannerState: {
            portal: portal,
            view_request: viewRequest,
            create_request: createRequest
        }
    };
});
const $2eae24be6ea0be0f$export$757c2c7994b73daa = (0, $bmgw6.default)($2eae24be6ea0be0f$var$blockedAppsBannerSelector)((0, $apbG6.default)({
    componentName: 'blockedAppBanner'
})((0, $fkaUt.default)));

});
parcelRegister("6Thom", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => (parcelRequire("5HHec")).getBlockedAppsBannerStatePortal);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => (parcelRequire("5HHec")).getBlockedAppsBannerStateCreateRequest);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => (parcelRequire("5HHec")).getBlockedAppsBannerStateRequestView);

var $5HHec = parcelRequire("5HHec");

});
parcelRegister("5HHec", function(module, exports) {
$parcel$export(module.exports, "getBlockedAppsBannerStatePortal", () => $bbf9cddf22af85f9$export$5d00eff3ead4a783);
$parcel$export(module.exports, "getBlockedAppsBannerStateRequestView", () => $bbf9cddf22af85f9$export$5e1a47e73ae7249);
$parcel$export(module.exports, "getBlockedAppsBannerStateCreateRequest", () => $bbf9cddf22af85f9$export$4b185f1cda5a42b9);
const $bbf9cddf22af85f9$export$5d00eff3ead4a783 = (state)=>{
    return state.persisted.blockedAppsBanner.portal || state.persisted.blockedAppsBanner.connect.portal;
};
const $bbf9cddf22af85f9$export$5e1a47e73ae7249 = (state)=>{
    return state.persisted.blockedAppsBanner.view_request || state.persisted.blockedAppsBanner.connect.view_request;
};
const $bbf9cddf22af85f9$export$4b185f1cda5a42b9 = (state)=>{
    return state.persisted.blockedAppsBanner.create_request || state.persisted.blockedAppsBanner.connect.create_request;
};

});


parcelRegister("fkaUt", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1bb59a5d76da16d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $adk9i = parcelRequire("adk9i");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");

var $6bGmX = parcelRequire("6bGmX");

var $kQ4cG = parcelRequire("kQ4cG");
var $3wvwn = parcelRequire("3wvwn");

var $54jwS = parcelRequire("54jwS");

var $jhBPy = parcelRequire("jhBPy");

var $Y85G3 = parcelRequire("Y85G3");

var $57t79 = parcelRequire("57t79");
const $e1bb59a5d76da16d$export$6db1cbf096e6afb2 = 'sd.portal.blocked.apps.banner.learnMore';
const $e1bb59a5d76da16d$export$f35e1704e0ced261 = 'sd.portal.blocked.apps.banner.doNotShow';
const $e1bb59a5d76da16d$var$getStyles = (page)=>{
    if (page === (0, $adk9i.FORGE_REQUEST_DETAILS)) return {
        marginBottom: `${"var(--ds-space-300, 24px)"}`
    };
    return {
        marginTop: `${"var(--ds-space-300, 24px)"}`
    };
};
const $e1bb59a5d76da16d$export$1cac45d8ffd5ecc3 = (accountId, projectId)=>{
    return `showBlockedAppsBanner-${projectId}-${accountId}`;
};
const $e1bb59a5d76da16d$var$BlockedAppsBannerComponent = ({ blockedAppsBannerState: blockedAppsBannerState, page: page, projectId: projectId, isAtlassianManagedAccount: isAtlassianManagedAccount, accountId: accountId })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const [showBannerForProject, setShowBannerForProject] = (0, $4fqPo.useState)(false);
    const doNotShowClickHandler = (0, $4fqPo.useCallback)(()=>{
        if (accountId) (0, $jhBPy.setLocalStorageItem)($e1bb59a5d76da16d$export$1cac45d8ffd5ecc3(accountId, projectId), 'false');
        setShowBannerForProject(false);
    }, [
        accountId,
        projectId
    ]);
    const learnMoreUrl = (0, $4fqPo.useMemo)(()=>{
        return (0, $Y85G3.getLearnMoreUrl)();
    }, []);
    const isBannerCondtionsSatisfied = // @ts-ignore
    !!blockedAppsBannerState && !!blockedAppsBannerState[page] && isAtlassianManagedAccount && showBannerForProject;
    (0, $4fqPo.useEffect)(()=>{
        if (accountId) {
            const showBannerStatus = (0, $jhBPy.getLocalStorageItem)($e1bb59a5d76da16d$export$1cac45d8ffd5ecc3(accountId, projectId));
            if (showBannerStatus && showBannerStatus === 'false') setShowBannerForProject(false);
            else setShowBannerForProject(true);
        }
    }, [
        accountId,
        projectId
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (isBannerCondtionsSatisfied) {
            const event = createAnalyticsEvent({
                analyticsType: (0, $54jwS.UI_EVENT_TYPE),
                action: 'viewed',
                actionSubject: 'blockedAppBanner',
                attributes: {
                    page: page,
                    userType: isAtlassianManagedAccount ? 'isAtlassianManagedAccount' : 'customer'
                }
            });
            event.fire();
        }
    }, [
        createAnalyticsEvent,
        isBannerCondtionsSatisfied,
        accountId,
        projectId,
        isAtlassianManagedAccount,
        page
    ]);
    if (isBannerCondtionsSatisfied) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        style: $e1bb59a5d76da16d$var$getStyles(page)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kQ4cG.default), {
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3wvwn.default), {
                testId: $e1bb59a5d76da16d$export$6db1cbf096e6afb2,
                href: learnMoreUrl,
                key: $e1bb59a5d76da16d$export$6db1cbf096e6afb2
            }, formatMessage((0, $57t79.default).learnMore)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3wvwn.default), {
                testId: $e1bb59a5d76da16d$export$f35e1704e0ced261,
                onClick: doNotShowClickHandler,
                key: $e1bb59a5d76da16d$export$f35e1704e0ced261
            }, formatMessage((0, $57t79.default).doNotShow))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("p", null, (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $57t79.default).bannerDescriptionGalaxia) : formatMessage((0, $57t79.default).bannerDescription)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null);
};
var $e1bb59a5d76da16d$export$2e2bcd8739ae039 = $e1bb59a5d76da16d$var$BlockedAppsBannerComponent;

});
parcelRegister("3wvwn", function(module, exports) {
$parcel$export(module.exports, "default", () => $275eca65d1af1dcf$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.37.1 */ /* section-message-action.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $lszf6 = parcelRequire("lszf6");

var $fxmw9 = parcelRequire("fxmw9");

var $iByhD = parcelRequire("iByhD");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");
var $iqiKs = parcelRequire("iqiKs");
const $275eca65d1af1dcf$var$styles = {
    common: "_11c8fhey",
    anchor: "_k48pi7a9",
    pressable: "_syaz13af _k48p1wq8 _bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz",
    pressableT26Shape: "_2rkolb4i"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $275eca65d1af1dcf$var$SectionMessageAction = /*#__PURE__*/ (0, $4fqPo.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent, target: target }) {
    if (!linkComponent) {
        if (href) return /*#__PURE__*/ $4fqPo.createElement("span", {
            className: (0, $ltgDR.default)([
                $275eca65d1af1dcf$var$styles.common,
                $275eca65d1af1dcf$var$styles.anchor
            ])
        }, /*#__PURE__*/ $4fqPo.createElement((0, $iByhD.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            target: target
        }, children));
        if (onClick) return /*#__PURE__*/ $4fqPo.createElement((0, $iqiKs.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $fxmw9.cx)($275eca65d1af1dcf$var$styles.common, $275eca65d1af1dcf$var$styles.pressable, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $275eca65d1af1dcf$var$styles.pressableT26Shape)
        }, children);
        return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
            as: "span",
            testId: testId,
            xcss: $275eca65d1af1dcf$var$styles.common
        }, children);
    }
    // TODO: Remove this once the deprecated `linkComponent` prop is removed.
    return onClick || href ? /*#__PURE__*/ $4fqPo.createElement((0, $lszf6.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, children);
});
var $275eca65d1af1dcf$export$2e2bcd8739ae039 = $275eca65d1af1dcf$var$SectionMessageAction;

});

parcelRegister("57t79", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a2c042714e865d7$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $8a2c042714e865d7$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    bannerDescription: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this project through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description'
    },
    bannerDescriptionGalaxia: {
        defaultMessage: "Can\u2019t find something? Some apps are blocked by your admin in this space through a data security policy.",
        description: 'The description of blocked apps banner',
        id: 'sd.portal.blocked.app.banner.description-galaxia'
    },
    doNotShow: {
        defaultMessage: "Don't show again",
        description: 'Do not show again link. When the user clicks on this, he will not see the blocked apps banner again',
        id: 'sd.portal.blocked.app.banner.doNotShow'
    },
    learnMore: {
        defaultMessage: 'View blocked apps',
        description: 'This is a link that the users can click to view the blocked apps',
        id: 'sd.portal.blocked.app.banner.learnMore'
    }
});

});



parcelRegister("gOVB5", function(module, exports) {
$parcel$export(module.exports, "CategoryList", () => $18f1f1f7747844ce$export$79717968ed9ae6cd);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");

var $6lolU = parcelRequire("6lolU");
const $18f1f1f7747844ce$var$selector = (0, $3yyCx.createSelector)((state, props)=>(0, $95tqy.getCategories)(state, props.portalId), (state, props)=>(0, $95tqy.getIsKbEnabled)(state, props.portalId), (state, props)=>(0, $95tqy.getPortalLink)(state, props.portalId), (state, props)=>(0, $95tqy.canCreateRequest)(state, props.portalId), (maybeCategories, enabled, portalLink, showRequestCreateButton)=>{
    const categories = Array.isArray(maybeCategories) ? maybeCategories : [];
    return {
        categories: categories,
        portalLink: portalLink,
        showRequestCreateButton: showRequestCreateButton,
        hidden: !enabled
    };
});
const $18f1f1f7747844ce$export$79717968ed9ae6cd = (0, $bmgw6.default)($18f1f1f7747844ce$var$selector)((0, $6lolU.default));

});
parcelRegister("6lolU", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e4f1a753be7db79$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");

var $5Uaxl = parcelRequire("5Uaxl");
parcelRequire("hy5Bl");
var $dkLWp = parcelRequire("dkLWp");
parcelRequire("4b5rY");
var $annK7 = parcelRequire("annK7");

var $fFB0R = parcelRequire("fFB0R");

var $aA5GW = parcelRequire("aA5GW");

var $WVSzu = parcelRequire("WVSzu");
parcelRequire("2kMhI");
var $5sMBM = parcelRequire("5sMBM");

var $1zDie = parcelRequire("1zDie");
class $9e4f1a753be7db79$export$2e2bcd8739ae039 extends $4fqPo.Component {
    static #_ = this.defaultProps = {
        portalId: undefined,
        categories: []
    };
    render() {
        const { portalId: portalId, categories: categories, portalLink: portalLink, hidden: hidden, cardLinkAppearance: cardLinkAppearance, className: className, showRequestCreateButton: showRequestCreateButton, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        if (hidden || !portalId || categories.length === 0) return null;
        const analyticData = {
            attributes: {
                numberOfCategories: categories.length
            }
        };
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: analyticData
        }, /*#__PURE__*/ $4fqPo.createElement($9e4f1a753be7db79$export$be92b6f5f03c0fe9, {
            className: className
        }, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), /*#__PURE__*/ $4fqPo.createElement($9e4f1a753be7db79$var$CategorySectionTitle, null, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aA5GW))), {
            spacing: "spacious",
            label: "",
            "aria-hidden": "true",
            color: "var(--ds-icon, #42526E)"
        }), /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $1zDie.default).kbCategorySectionTitle)), /*#__PURE__*/ $4fqPo.createElement($9e4f1a753be7db79$var$CategoryItems, null, categories.map((category)=>/*#__PURE__*/ $4fqPo.createElement($9e4f1a753be7db79$var$CategoryItemContainer, {
                key: category.id
            }, /*#__PURE__*/ $4fqPo.createElement((0, $5sMBM.default), {
                portalId: portalId,
                category: category,
                isEmbeddedRoute: isEmbeddedRoute
            })))), showRequestCreateButton && /*#__PURE__*/ $4fqPo.createElement((0, $annK7.default), {
            appearance: cardLinkAppearance,
            to: portalLink,
            isEmbeddedRoute: isEmbeddedRoute
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9e4f1a753be7db79$var$CategorySectionTitle = /*#__PURE__*/ (0, $el3DQ.default).h2.withConfig({
    componentId: "sc-12gjrid-0"
})`${$4W9tu.h500};display:flex;align-items:center;font-weight:600;margin-bottom:0;> :first-child{margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9e4f1a753be7db79$var$CategoryItems = /*#__PURE__*/ (0, $el3DQ.default).ul.withConfig({
    componentId: "sc-12gjrid-1"
})`padding:0;margin:0 -${(0, $dkLWp.GROUP_BOX_PADDING_LEFT_RIGHT)} ${"var(--ds-space-200, 16px)"};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $9e4f1a753be7db79$var$CategoryItemContainer = /*#__PURE__*/ (0, $el3DQ.default).li.withConfig({
    componentId: "sc-12gjrid-2"
})`padding:0;margin:0;list-style:none;`;
const $9e4f1a753be7db79$export$be92b6f5f03c0fe9 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-12gjrid-3"
})`flex:1 1 auto;`;

});
parcelRegister("2kMhI", function(module, exports) {
$parcel$export(module.exports, "CategoryItem", () => (parcelRequire("5sMBM")).default);

var $5sMBM = parcelRequire("5sMBM");

});
parcelRegister("5sMBM", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a94ca0946738b14$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("ekk8I");
var $fjJCg = parcelRequire("fjJCg");

var $fFB0R = parcelRequire("fFB0R");
class $8a94ca0946738b14$export$2e2bcd8739ae039 extends $4fqPo.Component {
    render() {
        const { category: category, portalId: portalId, onClick: onClick, className: className, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        const analyticData = {
            attributes: {
                portalId: portalId,
                categoryId: category.id
            }
        };
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: analyticData
        }, /*#__PURE__*/ $4fqPo.createElement((0, $fjJCg.default), {
            actionSubjectId: "category",
            to: `/portal/${portalId}/topic/${category.id}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
            className: className,
            onClick: onClick,
            heading: category.name,
            headingAs: "div",
            isAriaHidden: true,
            description: category.description,
            lineClamp: 2,
            target: isEmbeddedRoute ? '_blank' : undefined
        }));
    }
}

});


parcelRegister("1zDie", function(module, exports) {
$parcel$export(module.exports, "default", () => $9e4ac7b46ccdee1e$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $9e4ac7b46ccdee1e$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    kbCategorySectionTitle: {
        defaultMessage: 'Learn more about',
        description: 'Section title for a section that shows a list of knowledge base categories',
        id: 'cv.portal.home.kb.category.section.title'
    }
});

});



parcelRegister("btHpW", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("kPEgj")).default);
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("lPAG2")).default);
/*
  Previously a distinction was made between the single portal and request-create pages when rendering connect fragments.
  In Portal X, the portal home and request create page display the same connect fragments.
*/ parcelRequire("bKGi5");
var $kPEgj = parcelRequire("kPEgj");
parcelRequire("ay94x");
var $lPAG2 = parcelRequire("lPAG2");

});
parcelRegister("bKGi5", function(module, exports) {
$parcel$export(module.exports, "HeaderConnectFragments", () => (parcelRequire("kPEgj")).default);

var $kPEgj = parcelRequire("kPEgj");

});
parcelRegister("kPEgj", function(module, exports) {
$parcel$export(module.exports, "default", () => $424f6dc33f69d3b6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $cfx3H = parcelRequire("cfx3H");
var $hGOIV = parcelRequire("hGOIV");
const $424f6dc33f69d3b6$var$HeaderConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $cfx3H.ConnectFragment), {
        page: page,
        location: (0, $hGOIV.HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }), /*#__PURE__*/ $4fqPo.createElement((0, $cfx3H.ConnectFragment), {
        page: page,
        location: (0, $hGOIV.SUB_HEADER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $424f6dc33f69d3b6$export$2e2bcd8739ae039 = $424f6dc33f69d3b6$var$HeaderConnectFragments;

});


parcelRegister("ay94x", function(module, exports) {
$parcel$export(module.exports, "FooterConnectFragments", () => (parcelRequire("lPAG2")).default);

var $lPAG2 = parcelRequire("lPAG2");

});
parcelRegister("lPAG2", function(module, exports) {
$parcel$export(module.exports, "default", () => $08a6ce065544dd67$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $cfx3H = parcelRequire("cfx3H");
var $hGOIV = parcelRequire("hGOIV");
const $08a6ce065544dd67$var$FooterConnectFragments = ({ page: page, portalId: portalId, requestTypeId: requestTypeId, requestKey: requestKey })=>/*#__PURE__*/ $4fqPo.createElement($08a6ce065544dd67$var$ConnectFooterContainer, null, /*#__PURE__*/ $4fqPo.createElement((0, $cfx3H.ConnectFragment), {
        page: page,
        location: (0, $hGOIV.FOOTER),
        portalId: portalId,
        requestTypeId: requestTypeId,
        requestKey: requestKey
    }));
var $08a6ce065544dd67$export$2e2bcd8739ae039 = $08a6ce065544dd67$var$FooterConnectFragments;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $08a6ce065544dd67$var$ConnectFooterContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1lbb1kc-0"
})`padding-top:0;padding-bottom:0;`;

});



parcelRegister("14pOA", function(module, exports) {
$parcel$export(module.exports, "FormPicker", () => (parcelRequire("6sduf")).default);

var $6sduf = parcelRequire("6sduf");

});
parcelRegister("6sduf", function(module, exports) {
$parcel$export(module.exports, "default", () => $539979573d0a39c2$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("9MU8X");
var $2wESx = parcelRequire("2wESx");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("1GNRo");
var $NdV92 = parcelRequire("NdV92");
const $539979573d0a39c2$var$getRequestTypes = (state, props)=>(0, $95tqy.getPortalRequestTypes)(state, props.portalId);
const $539979573d0a39c2$var$getRequestGroups = (state, props)=>(0, $95tqy.getPortalRequestGroups)(state, props.portalId);
const $539979573d0a39c2$var$getIsSimplifiedPortal = (state, props)=>Boolean((0, $95tqy.getIsProjectSimplified)(state, props.portalId));
const $539979573d0a39c2$var$getPortalProjectKey = (state, props)=>{
    const projectKey = (0, $95tqy.getProjectKey)(state, props === null || props === void 0 ? void 0 : props.portalId);
    return (projectKey === null || projectKey === void 0 ? void 0 : projectKey.toString()) || '';
};
const $539979573d0a39c2$var$getIsProjectAdmin = (state, props)=>{
    return Boolean((0, $95tqy.getCanAdministerProject)(state, props.portalId));
};
const $539979573d0a39c2$var$getIsJiraAdmin = (state, _)=>{
    return Boolean((0, $2hx7o.getCanAdministerJIRA)(state));
};
const $539979573d0a39c2$var$getRequestTypeNameById = (id, requestTypes)=>{
    const requestType = requestTypes.find((reqType)=>reqType.id === id);
    return requestType ? {
        name: requestType.name,
        id: requestType.id
    } : undefined;
};
const $539979573d0a39c2$var$getRequestTypeNames = (groupReqTypes = [], portalReqGroups)=>groupReqTypes.map((id)=>$539979573d0a39c2$var$getRequestTypeNameById(id, portalReqGroups)).filter(Boolean);
const $539979573d0a39c2$var$populateRequestTypeNames = (portalReqTypes)=>(requestGroup)=>({
            ...requestGroup,
            reqTypes: $539979573d0a39c2$var$getRequestTypeNames(requestGroup.reqTypes, portalReqTypes)
        });
const $539979573d0a39c2$var$selector = (0, $3yyCx.createSelector)($539979573d0a39c2$var$getRequestGroups, $539979573d0a39c2$var$getRequestTypes, (0, $2wESx.getPortals), $539979573d0a39c2$var$getIsSimplifiedPortal, $539979573d0a39c2$var$getPortalProjectKey, $539979573d0a39c2$var$getIsProjectAdmin, $539979573d0a39c2$var$getIsJiraAdmin, (requestGroups, requestTypes, allPortals, isProjectSimplified, projectKey, isProjectAdmin, isJiraAdmin)=>({
        requestTypes: requestTypes,
        isProjectSimplified: isProjectSimplified,
        projectKey: projectKey,
        isProjectAdmin: isProjectAdmin,
        isJiraAdmin: isJiraAdmin,
        requestGroups: requestGroups.map($539979573d0a39c2$var$populateRequestTypeNames(requestTypes)),
        // displayLinkWhenNoGroups will only return true if portals data is already populated. If this page is accessed by direct link, it'll return false.
        // As it's such an edge case, it was decided that's enough.
        displayLinkWhenNoGroups: Object.keys(allPortals).length > 1
    }));
var $539979573d0a39c2$export$2e2bcd8739ae039 = (0, $bmgw6.default)($539979573d0a39c2$var$selector)((0, $NdV92.default));

});
parcelRegister("1GNRo", function(module, exports) {
$parcel$export(module.exports, "FormPickerDumb", () => (parcelRequire("NdV92")).default);

var $NdV92 = parcelRequire("NdV92");

});
parcelRegister("NdV92", function(module, exports) {
$parcel$export(module.exports, "default", () => $e76315c592603ed6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $8Gf3q = parcelRequire("8Gf3q");

var $5Uaxl = parcelRequire("5Uaxl");
var $efDRU = parcelRequire("efDRU");
parcelRequire("02nar");
var $kq5ef = parcelRequire("kq5ef");
var $8rh8n = parcelRequire("8rh8n");
var $jxE1P = parcelRequire("jxE1P");

var $WVSzu = parcelRequire("WVSzu");

var $3wR8f = parcelRequire("3wR8f");

var $PL4bf = parcelRequire("PL4bf");
parcelRequire("jVjjC");
var $7Kgqq = parcelRequire("7Kgqq");
parcelRequire("88X73");
var $hFGSG = parcelRequire("hFGSG");
parcelRequire("eGoPi");
var $ijs5b = parcelRequire("ijs5b");

var $6UVVC = parcelRequire("6UVVC");
class $e76315c592603ed6$export$600c4eef2a10987b extends $4fqPo.Component {
    static #_ = this.defaultProps = {
        // Required to explicitly set this to false by default as the <AutoFocus />
        // component will focus when it is `undefined`.
        autoFocus: false
    };
    render() {
        const { requestGroupId: requestGroupId, requestTypeId: requestTypeId, portalId: portalId, requestGroups: requestGroups, isDisabled: isDisabled, className: className, intl: intl, hideLabels: hideLabels, autoFocus: autoFocus, cardLinkAppearance: cardLinkAppearance, displayLinkWhenNoGroups: displayLinkWhenNoGroups, isEmbeddedRoute: isEmbeddedRoute, isCSM: isCSM, isProjectSimplified: isProjectSimplified, projectKey: projectKey, isProjectAdmin: isProjectAdmin } = this.props;
        const hasSingleRequestGroup = requestGroups.length === 1;
        const hasRequestGroup = requestGroups.length > 0;
        // If a group id is passed through that isn't actually inside the request groups array we make it undefined
        const matchingRequestGroupId = !!requestGroups.find((group)=>group.id === requestGroupId) ? requestGroupId : undefined;
        // If there is only one element in the request groups array we force it to be selected.
        const selectedRequestGroupId = hasSingleRequestGroup ? requestGroups[0].id : matchingRequestGroupId;
        const requestTypesForGroup = this.getRequestTypesForSelectedRequestGroup(selectedRequestGroupId);
        // If a type id is passed through that isn't actually inside the request types array we make it undefined
        const selectedRequestTypeId = !!requestTypesForGroup.find((requestType)=>Number(requestType.id) === Number(requestTypeId)) ? requestTypeId : undefined;
        const { customizePortalButtonsGroup: customizePortalButtonsGroup, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.getAdditionButtonsForCortopv2Experiment(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId);
        return hasRequestGroup ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $4fqPo.createElement("div", {
            className: className
        }, hasSingleRequestGroup || /*#__PURE__*/ $4fqPo.createElement((0, $hFGSG.default), {
            autoFocus: autoFocus && !selectedRequestGroupId,
            portalId: portalId,
            requestGroups: requestGroups,
            label: !!hideLabels ? '' : intl.formatMessage((0, $6UVVC.default).requestGroupSelectLabel),
            value: selectedRequestGroupId,
            onChange: this.selectRequestGroup,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            ...!!customizePortalButtonsGroup && {
                customizePortalButtonsGroup: customizePortalButtonsGroup
            }
        }), !!requestTypesForGroup.length && /*#__PURE__*/ $4fqPo.createElement($e76315c592603ed6$export$d9d410f2d2df162e, {
            hasTopMargin: !hasSingleRequestGroup,
            autoFocus: autoFocus && !!selectedRequestGroupId,
            portalId: portalId,
            requestGroupId: selectedRequestGroupId,
            label: this.getStyledRequestTypeSelectLabel(),
            requestTypes: requestTypesForGroup,
            value: selectedRequestTypeId,
            onChange: this.selectRequestType,
            disabled: isDisabled,
            cardLinkAppearance: cardLinkAppearance,
            isEmbeddedRoute: isEmbeddedRoute,
            isCSM: isCSM,
            headingAs: "div",
            ...!!editRequestTypeOnRequestForm && {
                editRequestTypeOnRequestForm: editRequestTypeOnRequestForm
            },
            ...!!editRequestTypeOnRequestList && {
                editRequestTypeOnRequestList: editRequestTypeOnRequestList
            }
        })) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $4fqPo.createElement("div", {
            className: className
        }, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $6UVVC.default).emptyStateMessage), ' ', displayLinkWhenNoGroups && /*#__PURE__*/ $4fqPo.createElement((0, $8Gf3q.default), {
            actionSubjectId: "tryAnotherServiceDesk",
            to: "/portals"
        }, /*#__PURE__*/ $4fqPo.createElement((0, $5Uaxl.default), (0, $6UVVC.default).tryAnotherServiceProjectLink)));
    }
    getAdditionButtonsForCortopv2Experiment(isProjectAdmin, isProjectSimplified, projectKey, selectedRequestTypeId, selectedRequestGroupId) {
        if (!(0, $bG6ob.isCortopv2ExperimentTGEnabled)()) return {
            customizePortalButtonsGroup: null,
            editRequestTypeOnRequestForm: null,
            editRequestTypeOnRequestList: null
        };
        const shouldShowAdditionalPortalLinks = ()=>isProjectAdmin && !isProjectSimplified && (0, $bG6ob.isCortopv2ExperimentEnabledWithExposure)(true);
        const customizePortalButtonsGroup = projectKey !== null && projectKey !== void 0 && projectKey.length && shouldShowAdditionalPortalLinks() ? /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
            id: "customize-portal-button-group",
            renderError: ()=>null
        }, /*#__PURE__*/ $4fqPo.createElement((0, $kq5ef.default), {
            projectKey: projectKey
        })) : null;
        const editRequestTypeOnRequestForm = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestTypeId && shouldShowAdditionalPortalLinks() ? /*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
            id: "edit-request-type-button",
            renderError: ()=>null
        }, /*#__PURE__*/ $4fqPo.createElement((0, $8rh8n.default), {
            projectKey: projectKey,
            requestTypeId: selectedRequestTypeId
        })) : null;
        const editRequestTypeOnRequestList = projectKey !== null && projectKey !== void 0 && projectKey.length && !!selectedRequestGroupId && shouldShowAdditionalPortalLinks() ? (requestTypeIdForListItem)=>/*#__PURE__*/ $4fqPo.createElement((0, $gMSZD.default), {
                id: "edit-request-type-button",
                renderError: ()=>null
            }, /*#__PURE__*/ $4fqPo.createElement((0, $jxE1P.default), {
                projectKey: projectKey,
                requestTypeId: requestTypeIdForListItem
            })) : null;
        return {
            customizePortalButtonsGroup: customizePortalButtonsGroup,
            editRequestTypeOnRequestForm: editRequestTypeOnRequestForm,
            editRequestTypeOnRequestList: editRequestTypeOnRequestList
        };
    }
    constructor(...args){
        super(...args), this.getRequestTypesForSelectedRequestGroup = (requestGroupId)=>{
            const { requestTypes: requestTypes, requestGroups: requestGroups } = this.props;
            if (requestGroupId) {
                const selectedRequestGroup = requestGroups.find((requestGroup)=>requestGroup.id === requestGroupId);
                if (selectedRequestGroup) return selectedRequestGroup.reqTypes.map((reqType)=>requestTypes.find((rt)=>rt.id === reqType.id)).filter(Boolean);
            }
            return [];
        }, this.selectRequestGroup = (id)=>{
            // If id is undefined we push back to the /:portalId/group/-1 route.
            // This covers the case if there are article categories on the portal.
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            const referrer = $PL4bf.get((0, $7Kgqq.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            (0, $3wR8f.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${this.props.portalId}/group/${id || '-1'}`,
                search: shouldAddReferrer ? `?${0, $7Kgqq.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.selectRequestType = (id)=>{
            const { requestGroups: requestGroups, portalId: portalId, requestGroupId: requestGroupId } = this.props;
            const hasSingleRequestGroup = requestGroups.length === 1;
            const groupId = hasSingleRequestGroup ? requestGroups[0].id : requestGroupId;
            const referrer = $PL4bf.get((0, $7Kgqq.REFERRER_QUERY_PARAM));
            const shouldAddReferrer = referrer && referrer !== 'undefined';
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
            (0, $3wR8f.default).push({
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                pathname: `/portal/${portalId}/group/${groupId}${id ? `/create/${id}` : ''}`,
                search: shouldAddReferrer ? `?${0, $7Kgqq.REFERRER_QUERY_PARAM}=${referrer}` : ''
            });
        }, this.getStyledRequestTypeSelectLabel = ()=>{
            const { hideLabels: hideLabels, intl: intl, isCSM: isCSM } = this.props;
            if (!!hideLabels) return '';
            if (isCSM) return intl.formatMessage((0, $6UVVC.default).CSMRequestTypeSelectLabel);
            return intl.formatMessage((0, $6UVVC.default).requestTypeSelectLabel);
        };
    }
}
var $e76315c592603ed6$export$2e2bcd8739ae039 = (0, $efDRU.default)($e76315c592603ed6$export$600c4eef2a10987b);
const $e76315c592603ed6$export$d9d410f2d2df162e = /*#__PURE__*/ (0, $el3DQ.default)((0, $ijs5b.default)).withConfig({
    componentId: "sc-1hnffkr-0"
})`margin-top:${(props)=>props.hasTopMargin ? "var(--ds-space-400, 32px)" : 0};`;

});
parcelRegister("02nar", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("kq5ef")).default);
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("8rh8n")).default);
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("jxE1P")).default);
parcelRequire("4WT5m");
var $kq5ef = parcelRequire("kq5ef");
parcelRequire("92OCU");
var $8rh8n = parcelRequire("8rh8n");
parcelRequire("fLJhv");
var $jxE1P = parcelRequire("jxE1P");

});
parcelRegister("4WT5m", function(module, exports) {
$parcel$export(module.exports, "CustomizePortalButtonGroup", () => (parcelRequire("kq5ef")).default);

var $kq5ef = parcelRequire("kq5ef");

});
parcelRegister("kq5ef", function(module, exports) {
$parcel$export(module.exports, "default", () => $60e2af8a5d2b0885$export$2e2bcd8739ae039);
/* customize-portal-button-group.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $1JcfR = parcelRequire("1JcfR");

var $l7ubX = parcelRequire("l7ubX");

var $2UMA8 = parcelRequire("2UMA8");
var $ekURY = parcelRequire("ekURY");

var $54jwS = parcelRequire("54jwS");

var $Y85G3 = parcelRequire("Y85G3");

var $2Qgcq = parcelRequire("2Qgcq");
const $60e2af8a5d2b0885$var$CustomizePortalButtonGroup = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { projectKey: projectKey } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const onClickManagePortalGroups = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'managePortalGroupsButton',
            action: 'clicked',
            actionSubject: 'CustomizePortalButtonGroup',
            analyticsType: (0, $54jwS.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $2UMA8.default), {
        gap: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1JcfR.default), {
        href: (0, $Y85G3.getPortalGroupSettingsUrl)(projectKey),
        appearance: "subtle",
        target: "_blank",
        testId: "manage-portal-groups-button",
        onClick: onClickManagePortalGroups,
        iconBefore: $60e2af8a5d2b0885$var$CustomizePortalButtonFolderOpenIcon
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $2Qgcq.default).managePortalGroupsLabel)))));
};
const $60e2af8a5d2b0885$var$CustomizePortalButtonFolderOpenIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($l7ubX))), {
        ...iconProps,
        label: formatMessage((0, $2Qgcq.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $60e2af8a5d2b0885$var$ButtonStyles = null;
var $60e2af8a5d2b0885$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'CustomizePortalButtonGroup'
})($60e2af8a5d2b0885$var$CustomizePortalButtonGroup);

});
parcelRegister("1JcfR", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb46fa368214a860$export$2e2bcd8739ae039);
/* link.tsx generated by @compiled/babel-plugin v0.37.1 */ /* link.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $5wgou = parcelRequire("5wgou");

var $jNU2T = parcelRequire("jNU2T");

var $3H4LK = parcelRequire("3H4LK");

var $4nUcM = parcelRequire("4nUcM");

var $Az2gn = parcelRequire("Az2gn");

var $c6jSC = parcelRequire("c6jSC");
const $fb46fa368214a860$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhk187o _syaz1gmx _aetrglyw _irr3187o _30l31gmx _1di6187o _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgutpp _gy1p12x7",
    buttonIconAfter: "_y4tiutpp _gy1p12x7",
    fullWidth: "_1bsb1osq"
};
const $fb46fa368214a860$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $fb46fa368214a860$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $fb46fa368214a860$var$rovoStyles = {
    root: "_bfhklqh9 _syaz15cr _105315cr _f8pj15cr _irr31afz _1di61kru"
};
const $fb46fa368214a860$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $fb46fa368214a860$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $fb46fa368214a860$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $fb46fa368214a860$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $fb46fa368214a860$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $fb46fa368214a860$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $4fqPo.useRef)(null);
    (0, $jNU2T.default)(localRef, autoFocus);
    const combinedRef = (0, $5wgou.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $4fqPo.createElement((0, $4nUcM.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        /**
   * Disable link in an accessible way using `href`, `role`, and `aria-disabled`.
   * @see https://a11y-guidelines.orange.com/en/articles/disable-elements/#disable-a-link
   */ // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $fxmw9.cx)($fb46fa368214a860$var$styles.base, (0, $3H4LK.fg)('platform-dst-shape-theme-default') && $fb46fa368214a860$var$styles.baseT26Shape, appearance === 'default' && $fb46fa368214a860$var$defaultStyles.root, appearance === 'primary' && $fb46fa368214a860$var$primaryStyles.root, appearance === 'rovo' && $fb46fa368214a860$var$rovoStyles.root, appearance === 'warning' && $fb46fa368214a860$var$warningStyles.root, appearance === 'danger' && $fb46fa368214a860$var$dangerStyles.root, appearance === 'discovery' && $fb46fa368214a860$var$discoveryStyles.root, appearance === 'subtle' && $fb46fa368214a860$var$subtleStyles.root, $fb46fa368214a860$var$styles.linkDecorationUnset, isSelected && $fb46fa368214a860$var$selectedStyles.root, isSelected && appearance === 'danger' && $fb46fa368214a860$var$selectedStyles.danger, isSelected && appearance === 'warning' && $fb46fa368214a860$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $fb46fa368214a860$var$selectedStyles.discovery, isDisabled && $fb46fa368214a860$var$styles.disabled, spacing === 'compact' && $fb46fa368214a860$var$styles.spacingCompact, hasIconBefore && $fb46fa368214a860$var$styles.buttonIconBefore, hasIconAfter && $fb46fa368214a860$var$styles.buttonIconAfter, shouldFitContainer && $fb46fa368214a860$var$styles.fullWidth)
    }, iconBefore && /*#__PURE__*/ $4fqPo.createElement((0, $Az2gn.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $4fqPo.createElement((0, $c6jSC.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $4fqPo.createElement((0, $Az2gn.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $4fqPo.createElement((0, $Az2gn.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $4fqPo.createElement((0, $c6jSC.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $fb46fa368214a860$var$LinkButton = /*#__PURE__*/ (0, $4fqPo.forwardRef)($fb46fa368214a860$var$LinkButtonBase);
$fb46fa368214a860$var$LinkButton.displayName = 'LinkButton';
var $fb46fa368214a860$export$2e2bcd8739ae039 = $fb46fa368214a860$var$LinkButton;

});

parcelRegister("l7ubX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6405c70debcc4f4b2a8d477842ac4ae>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f601abe5565146be$var$_react = $f601abe5565146be$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $f601abe5565146be$var$_baseNew = $f601abe5565146be$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $f601abe5565146be$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f601abe5565146be$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $f601abe5565146be$var$_react.default.createElement($f601abe5565146be$var$_baseNew.default, Object.assign({
        name: "FolderOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$f601abe5565146be$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $f601abe5565146be$var$_default = module.exports.default = $f601abe5565146be$var$FolderOpenIcon;

});

parcelRegister("2Qgcq", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a1b2c08c9447b71$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $7a1b2c08c9447b71$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    managePortalGroupsLabel: {
        defaultMessage: 'Manage portal groups',
        description: 'Button text to Navigate user to Manage Portal Groups in JSM',
        id: 'help-center.app.common.customize-portal-buttons.manage-portal-groups-label'
    },
    editRequestTypeLabel: {
        defaultMessage: 'Edit request type',
        description: 'Button text to Navigate user to Request Type editor in JSM',
        id: 'help-center.app.common.customize-portal-buttons.edit-request-type-label '
    }
});

});



parcelRegister("92OCU", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeButton", () => (parcelRequire("8rh8n")).default);

var $8rh8n = parcelRequire("8rh8n");

});
parcelRegister("8rh8n", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b0650756e99ecb6$export$2e2bcd8739ae039);
/* edit-request-type-button.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $1JcfR = parcelRequire("1JcfR");

var $eYQBU = parcelRequire("eYQBU");

var $2UMA8 = parcelRequire("2UMA8");
var $ekURY = parcelRequire("ekURY");

var $54jwS = parcelRequire("54jwS");

var $Y85G3 = parcelRequire("Y85G3");

var $2Qgcq = parcelRequire("2Qgcq");
const $3b0650756e99ecb6$var$EditRequestTypeButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const onClickButton = ()=>{
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $54jwS.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $2UMA8.default), {
        gap: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _4t3i1ns9"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1JcfR.default), {
        href: (0, $Y85G3.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-button",
        onClick: onClickButton,
        iconBefore: $3b0650756e99ecb6$var$EditRequestTypeButtonEditIcon
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $2Qgcq.default).editRequestTypeLabel)))));
};
const $3b0650756e99ecb6$var$EditRequestTypeButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYQBU))), {
        ...iconProps,
        label: formatMessage((0, $2Qgcq.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #44546F)"
    });
};
const $3b0650756e99ecb6$var$ButtonStyles = null;
var $3b0650756e99ecb6$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'EditRequestTypeButton'
})($3b0650756e99ecb6$var$EditRequestTypeButton);

});
parcelRegister("eYQBU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::63ac376f9836d1894f72051899adf679>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae7f7aa003eb9a48$var$_react = $ae7f7aa003eb9a48$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $ae7f7aa003eb9a48$var$_baseNew = $ae7f7aa003eb9a48$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $ae7f7aa003eb9a48$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ae7f7aa003eb9a48$var$EditIcon = (props)=>/*#__PURE__*/ $ae7f7aa003eb9a48$var$_react.default.createElement($ae7f7aa003eb9a48$var$_baseNew.default, Object.assign({
        name: "EditIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$ae7f7aa003eb9a48$var$EditIcon.displayName = 'EditIcon';
var $ae7f7aa003eb9a48$var$_default = module.exports.default = $ae7f7aa003eb9a48$var$EditIcon;

});



parcelRegister("fLJhv", function(module, exports) {
$parcel$export(module.exports, "EditRequestTypeHoverButton", () => (parcelRequire("jxE1P")).default);

var $jxE1P = parcelRequire("jxE1P");

});
parcelRegister("jxE1P", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d56ca006ce66608$export$2e2bcd8739ae039);
/* edit-request-type-hover-button.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $1JcfR = parcelRequire("1JcfR");

var $eYQBU = parcelRequire("eYQBU");

var $ekURY = parcelRequire("ekURY");

var $54jwS = parcelRequire("54jwS");

var $Y85G3 = parcelRequire("Y85G3");

var $2Qgcq = parcelRequire("2Qgcq");
const $9d56ca006ce66608$var$EditRequestTypeHoverButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { projectKey: projectKey, requestTypeId: requestTypeId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const onClickButton = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            actionSubjectId: 'EditRequestTypeHoverButton',
            action: 'clicked',
            actionSubject: 'button',
            analyticsType: (0, $54jwS.UI_EVENT_TYPE)
        }).fire();
    };
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2rko12b0 _1dqonqa1 _1h6d6t9l _189ee4h9 _vchhusvi"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1JcfR.default), {
        href: (0, $Y85G3.getRequestTypeSettingsUrl)(projectKey, requestTypeId),
        appearance: "subtle",
        target: "_blank",
        testId: "edit-request-type-hover-button",
        onClick: onClickButton,
        spacing: 'compact',
        shouldFitContainer: true,
        iconBefore: $9d56ca006ce66608$var$EditRequestTypeHoverButtonEditIcon
    }, /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $2Qgcq.default).editRequestTypeLabel))));
};
const $9d56ca006ce66608$var$EditRequestTypeHoverButtonEditIcon = (iconProps)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eYQBU))), {
        ...iconProps,
        label: formatMessage((0, $2Qgcq.default).managePortalGroupsLabel),
        spacing: "none",
        color: "var(--ds-icon, #505258)"
    });
};
const $9d56ca006ce66608$var$ButtonStyles = null;
var $9d56ca006ce66608$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'EditRequestTypeHoverButton'
})($9d56ca006ce66608$var$EditRequestTypeHoverButton);

});



parcelRegister("jVjjC", function(module, exports) {
$parcel$export(module.exports, "LearnByDoing", () => (parcelRequire("d2GTs")).default);
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => (parcelRequire("bLf1t")).shouldShowLearnByDoingBanner);
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => (parcelRequire("7Kgqq")).REFERRER_QUERY_PARAM);

var $d2GTs = parcelRequire("d2GTs");

var $bLf1t = parcelRequire("bLf1t");

var $7Kgqq = parcelRequire("7Kgqq");

});
parcelRegister("d2GTs", function(module, exports) {
$parcel$export(module.exports, "default", () => $4548b01c5eac1e36$export$2e2bcd8739ae039);

var $el3DQ = parcelRequire("el3DQ");

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $gMSZD = parcelRequire("gMSZD");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $51FsQ = parcelRequire("51FsQ");

var $1JcfR = parcelRequire("1JcfR");

var $2eKV2 = parcelRequire("2eKV2");

var $5T5mg = parcelRequire("5T5mg");

var $3H4LK = parcelRequire("3H4LK");

var $7TPEx = parcelRequire("7TPEx");
var $9Ix81 = parcelRequire("9Ix81");
var $dEWOM = parcelRequire("dEWOM");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $54jwS = parcelRequire("54jwS");

var $8OZ4K = parcelRequire("8OZ4K");

var $5i4qe = parcelRequire("5i4qe");
var $4548b01c5eac1e36$export$8400747e4d4d02ee = /*#__PURE__*/ function(StepNumber) {
    StepNumber[StepNumber["STEP1"] = 0] = "STEP1";
    StepNumber[StepNumber["STEP2"] = 1] = "STEP2";
    StepNumber[StepNumber["STEP3"] = 2] = "STEP3";
    return StepNumber;
}({});
const $4548b01c5eac1e36$var$LearnByDoing = ({ projectRedirectionLink: projectRedirectionLink, screenName: screenName })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const getStepNumber = ()=>{
        let step;
        if (screenName === (0, $748yq.ScreenName).PORTAL_HOME || screenName === (0, $748yq.ScreenName).REQUEST_GROUP) step = 0;
        else if (screenName === (0, $748yq.ScreenName).REQUEST_CREATE) step = 1;
        else if (screenName === (0, $748yq.ScreenName).REQUEST_DETAILS) step = 2;
        else step = -1;
        return step;
    };
    (0, $4fqPo.useEffect)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'viewed',
            actionSubject: 'learnByDoing',
            attributes: {
                screenName: screenName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        screenName
    ]);
    const stepNumber = getStepNumber();
    const steps = (0, $4fqPo.useMemo)(()=>[
            {
                stepNumber: 0,
                title: formatMessage((0, $5i4qe.default).chooseRequestTypeHeading),
                description: formatMessage((0, $5i4qe.default).chooseRequestTypeDesc)
            },
            {
                stepNumber: 1,
                title: formatMessage((0, $5i4qe.default).sendExampleRequestHeading),
                description: formatMessage((0, $5i4qe.default).sendExampleRequestDesc)
            },
            {
                stepNumber: 2,
                title: formatMessage((0, $5i4qe.default).requestCreatedHeading),
                description: formatMessage(// Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration
                (0, $3H4LK.fg)('itsm-project-renaming') ? (0, $5i4qe.default).requestCreatedDescGalaxia : (0, $5i4qe.default).requestCreatedDesc)
            }
        ], [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $51FsQ.default), null, stepNumber >= 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        alignInline: "center",
        alignBlock: "center",
        xcss: $4548b01c5eac1e36$var$LearnByDoingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
        xcss: $4548b01c5eac1e36$var$LearnByDoingStyles,
        direction: "column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "medium"
    }, formatMessage((0, $5i4qe.default).learnByDoingDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
        xcss: $4548b01c5eac1e36$var$LearnByDoingFlowStyle
    }, steps.map((step, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
            xcss: [
                $4548b01c5eac1e36$var$LearnByDoingStepDefaultStyle,
                index === stepNumber && $4548b01c5eac1e36$var$LearnByDoingStepActiveStyle,
                index < stepNumber && $4548b01c5eac1e36$var$LearnByDoingStepDisableStyle
            ],
            key: `step-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
            xcss: [
                $4548b01c5eac1e36$var$StepNumberContainerDefaultStyle,
                index === stepNumber && $4548b01c5eac1e36$var$StepNumberContainerActiveStyle,
                index < stepNumber && $4548b01c5eac1e36$var$StepNumberContainerDisableStyle
            ]
        }, index >= stepNumber ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
            alignItems: "center",
            xcss: [
                $4548b01c5eac1e36$var$headingContainerStepNumberDefaultStyles,
                index === stepNumber && $4548b01c5eac1e36$var$headingContainerStepNumberActiveStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($4548b01c5eac1e36$var$_StyledBox, null, step.stepNumber + 1)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5T5mg))), {
            label: "success",
            color: "var(--ds-icon-accent-green, #189864)",
            spacing: "spacious"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
            xcss: $4548b01c5eac1e36$var$ContentStyle,
            direction: "column"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
            size: "small"
        }, step.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $4548b01c5eac1e36$var$descriptionStyles
        }, step.description), index === steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
            xcss: $4548b01c5eac1e36$var$QueuesRedirectButtonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1JcfR.default), {
            href: projectRedirectionLink ?? '#',
            appearance: "discovery",
            isDisabled: !projectRedirectionLink,
            testId: "project-redirect-link",
            analyticsContext: {
                actionSubjectId: 'learnByDoingRedirect'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
            weight: "medium",
            color: !projectRedirectionLink ? 'color.text.disabled' : 'color.text.inverse'
        }, formatMessage((0, $5i4qe.default).queuesRedirectLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Ix81.default), {
            xcss: $4548b01c5eac1e36$var$nextStepImageStyle
        }, index !== steps.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($8OZ4K))),
            alt: ""
        })));
    })))));
};
const $4548b01c5eac1e36$var$LearnByDoingWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: "learnByDoing",
        id: "create-request",
        renderError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($4548b01c5eac1e36$var$LearnByDoing, props));
};
var $4548b01c5eac1e36$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'LearnByDoing'
})($4548b01c5eac1e36$var$LearnByDoingWithErrorBoundary);
const $4548b01c5eac1e36$var$LearnByDoingWrapper = (0, $2m8U6.xcss)({
    width: 'auto',
    position: 'absolute',
    right: 'space.400',
    left: 'space.400',
    height: '266px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.large'
});
const $4548b01c5eac1e36$var$LearnByDoingStyles = (0, $2m8U6.xcss)({
    display: 'none',
    width: '100%',
    maxWidth: '1200px',
    gap: 'space.200',
    paddingBlock: 'space.300',
    paddingInline: 'space.300',
    borderRadius: 'radius.small',
    [(0, $3jKXW.media).above.md]: {
        display: 'flex'
    },
    [(0, $3jKXW.media).above.lg]: {
        // Max valid space token space.1000 = 80px, have to use px to make it correctly aligned
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingRight: '108px',
        // @ts-expect-error - TODO should use token here, https://product-fabric.atlassian.net/browse/EDF-2517
        paddingLeft: '88px'
    }
});
const $4548b01c5eac1e36$var$LearnByDoingFlowStyle = (0, $2m8U6.xcss)({
    width: '100%',
    gap: 'space.500',
    [(0, $3jKXW.media).above.lg]: {
        gap: 'space.600'
    }
});
const $4548b01c5eac1e36$var$LearnByDoingStepDefaultStyle = (0, $2m8U6.xcss)({
    gap: 'space.150',
    padding: 'space.200',
    backgroundColor: 'color.background.input',
    borderRadius: 'radius.small',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    minHeight: '150px',
    position: 'relative',
    flex: '1 1 0px',
    [(0, $3jKXW.media).above.lg]: {
        gap: 'space.200'
    }
});
const $4548b01c5eac1e36$var$LearnByDoingStepActiveStyle = (0, $2m8U6.xcss)({
    backgroundColor: 'color.background.input',
    borderWidth: 'border.width.selected',
    borderStyle: 'solid',
    borderColor: 'color.border.discovery'
});
const $4548b01c5eac1e36$var$LearnByDoingStepDisableStyle = (0, $2m8U6.xcss)({
    backgroundColor: 'color.background.discovery',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border'
});
const $4548b01c5eac1e36$var$StepNumberContainerDefaultStyle = (0, $2m8U6.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    width: '40px',
    height: '40px',
    backgroundColor: 'color.background.discovery',
    borderRadius: 'radius.full',
    gap: 'space.100',
    alignItems: 'center',
    justifyContent: 'center'
});
const $4548b01c5eac1e36$var$StepNumberContainerActiveStyle = (0, $2m8U6.xcss)({
    backgroundColor: 'color.background.discovery.bold'
});
const $4548b01c5eac1e36$var$StepNumberContainerDisableStyle = (0, $2m8U6.xcss)({
    backgroundColor: 'color.background.success'
});
const $4548b01c5eac1e36$var$headingContainerStepNumberDefaultStyles = (0, $2m8U6.xcss)({
    height: "var(--ds-space-250, 20px)",
    color: 'color.text.discovery'
});
const $4548b01c5eac1e36$var$headingContainerStepNumberActiveStyles = (0, $2m8U6.xcss)({
    color: 'color.text.inverse'
});
const $4548b01c5eac1e36$var$stepNumberStyles = (0, $2m8U6.xcss)({
    font: 'font.heading.small'
});
const $4548b01c5eac1e36$var$nextStepImageStyle = (0, $2m8U6.xcss)({
    zIndex: 'card',
    position: 'absolute',
    top: 'space.300',
    right: '-52px',
    [(0, $3jKXW.media).above.lg]: {
        right: '-60px'
    }
});
const $4548b01c5eac1e36$var$ContentStyle = (0, $2m8U6.xcss)({
    width: '100%',
    gap: 'space.050'
});
const $4548b01c5eac1e36$var$descriptionStyles = (0, $2m8U6.xcss)({
    color: 'color.text.subtle',
    font: 'font.body'
});
const $4548b01c5eac1e36$var$QueuesRedirectButtonStyles = (0, $2m8U6.xcss)({
    width: 'fit-content',
    marginTop: 'space.050'
});
var $4548b01c5eac1e36$var$_StyledBox = /*#__PURE__*/ /*#__PURE__*/ (0, $el3DQ.default)((0, $7TPEx.default)).withConfig({
    componentId: "sc-1fng6fm-0"
}).withConfig({
    componentId: "sc-1fng6fm-1"
})`${$4548b01c5eac1e36$var$stepNumberStyles}`;

});
parcelRegister("51FsQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b565eb920a637ee9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gt3rg = parcelRequire("gt3rg");

var $gIxDT = parcelRequire("gIxDT");

var $c7uHc = parcelRequire("c7uHc");

var $7N9xJ = parcelRequire("7N9xJ");

var $9yc6l = parcelRequire("9yc6l");
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $b565eb920a637ee9$var$AppProvider({ children: children, defaultColorMode: defaultColorMode = 'light', defaultTheme: defaultTheme, routerLinkComponent: routerLinkComponent, UNSAFE_isThemingDisabled: UNSAFE_isThemingDisabled }) {
    const isInsideAppProvider = (0, $9yc6l.useIsInsideAppProvider)();
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    const routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c7uHc.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gIxDT.InsideAppProviderContext).Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gt3rg.AppProviderThemingEnabledContext).Provider, {
        value: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7N9xJ.default), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider)));
}
var $b565eb920a637ee9$export$2e2bcd8739ae039 = $b565eb920a637ee9$var$AppProvider;

});

parcelRegister("5T5mg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf60af7e41b379d3a36d6fe455c57ca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44963ecd1deba7a6$var$_react = $44963ecd1deba7a6$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $44963ecd1deba7a6$var$_baseNew = $44963ecd1deba7a6$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $44963ecd1deba7a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44963ecd1deba7a6$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $44963ecd1deba7a6$var$_react.default.createElement($44963ecd1deba7a6$var$_baseNew.default, Object.assign({
        name: "CheckMarkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$44963ecd1deba7a6$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $44963ecd1deba7a6$var$_default = module.exports.default = $44963ecd1deba7a6$var$CheckMarkIcon;

});

parcelRegister("8OZ4K", function(module, exports) {
module.exports = new URL("../images/vector.dd7c71e0.svg", import.meta.url).toString();

});

parcelRegister("5i4qe", function(module, exports) {
$parcel$export(module.exports, "default", () => $55ffaac0bcc14019$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $55ffaac0bcc14019$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    learnByDoingDesc: {
        id: 'help-center.learn-by-doing.create-request.description',
        defaultMessage: 'Welcome to the portal! Try raising a request like your customers.',
        description: 'Description for Learn By Doing create Request component'
    },
    chooseRequestTypeHeading: {
        id: 'help-center.learn-by-doing.choose-request-type.heading',
        defaultMessage: 'Choose a request type',
        description: 'Heading for choosing a request type in Learn By Doing component'
    },
    chooseRequestTypeDesc: {
        id: 'help-center.learn-by-doing.choose-request-type.description',
        defaultMessage: 'Request types represent what your team can help customers with.',
        description: 'The text is shown as a description below the "Choose a request type" heading in the Learn By Doing onboarding component, explaining what request types are.'
    },
    sendExampleRequestHeading: {
        id: 'help-center.learn-by-doing.send-example-request.heading',
        defaultMessage: 'Send an example request',
        description: 'Heading for sending an example request in Learn By Doing component'
    },
    sendExampleRequestDesc: {
        id: 'help-center.learn-by-doing.send-example-request.description',
        defaultMessage: 'Fill out the request details, then send it off!',
        description: 'The text is shown as a description below the "Send an example request" heading in the Learn By Doing onboarding component, guiding the user to fill out and submit the example request form.'
    },
    requestCreatedHeading: {
        id: 'help-center.learn-by-doing.request-created.heading',
        defaultMessage: 'Manage request as an agent',
        description: 'Heading after request is created in Learn By Doing component'
    },
    requestCreatedDesc: {
        id: 'help-center.learn-by-doing.request-created.description',
        defaultMessage: 'Assign, add comments and resolve this request in your project.',
        description: 'The text is shown as a description in the Learn By Doing component after a request is created, telling the agent to manage the request in their project.'
    },
    requestCreatedDescGalaxia: {
        id: 'help-center.learn-by-doing.request-created.description-galaxia',
        defaultMessage: 'Assign, add comments and resolve this request in your space.',
        description: 'The text is shown as a description in the Learn By Doing component after a request is created in a Galaxia space, telling the agent to manage the request in their space.'
    },
    queuesRedirectLabel: {
        id: 'help-center.learn-by-doing.queues-redirect.label',
        defaultMessage: 'Go to agent view',
        description: 'The text is shown on a button in the Learn By Doing component after a request is created, redirecting the agent to the queues (agent view) to manage incoming requests.'
    }
});

});


parcelRegister("bLf1t", function(module, exports) {
$parcel$export(module.exports, "shouldShowLearnByDoingBanner", () => $0d9e98aba10daff7$export$54a369ffec06fa13);

var $7Kgqq = parcelRequire("7Kgqq");
const $0d9e98aba10daff7$export$54a369ffec06fa13 = (isProjectAdmin, referrer = '')=>isProjectAdmin && (referrer === (0, $7Kgqq.GETTING_STARTED_PAGE_LEARN_BY_DOING) || referrer === (0, $7Kgqq.YOUR_WORK) || referrer === (0, $7Kgqq.SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE));

});
parcelRegister("7Kgqq", function(module, exports) {
$parcel$export(module.exports, "REFERRER_QUERY_PARAM", () => $c68bebdf304625ef$export$7640e1e223f51f1a);
$parcel$export(module.exports, "SETTINGS_OVERVIEW_PAGE_CREATE_REQUEST_NUDGE", () => $c68bebdf304625ef$export$95ca3e9dccd62856);
$parcel$export(module.exports, "GETTING_STARTED_PAGE_LEARN_BY_DOING", () => $c68bebdf304625ef$export$952482a78309d288);
$parcel$export(module.exports, "YOUR_WORK", () => $c68bebdf304625ef$export$3461424d6e65d62d);
const $c68bebdf304625ef$export$7640e1e223f51f1a = 'referrer';
const $c68bebdf304625ef$export$95ca3e9dccd62856 = 'overviewCreateRequest';
const $c68bebdf304625ef$export$952482a78309d288 = 'gettingStartedPageLearnByDoing';
const $c68bebdf304625ef$export$3461424d6e65d62d = 'yourWork';

});



parcelRegister("88X73", function(module, exports) {
$parcel$export(module.exports, "RequestGroupSelect", () => (parcelRequire("hFGSG")).default);

var $hFGSG = parcelRequire("hFGSG");

});
parcelRegister("hFGSG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7964b23c5d43ff3$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4W9tu = parcelRequire("4W9tu");
parcelRequire("31eVp");
var $lbGhX = parcelRequire("lbGhX");

var $fFB0R = parcelRequire("fFB0R");

var $1NaJ3 = parcelRequire("1NaJ3");

var $PL4bf = parcelRequire("PL4bf");
parcelRequire("jVjjC");
var $7Kgqq = parcelRequire("7Kgqq");
class $d7964b23c5d43ff3$export$2e2bcd8739ae039 extends $4fqPo.PureComponent {
    getRedirectionUrl(requestGroupid, portalId) {
        const referrer = $PL4bf.get((0, $7Kgqq.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        return `/portal/${portalId}/group/${requestGroupid}${shouldAddReferrer ? `?${0, $7Kgqq.REFERRER_QUERY_PARAM}=${referrer}` : ''}`;
    }
    getOptions() {
        const { requestGroups: requestGroups, portalId: portalId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestGroups.map((requestGroup)=>({
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                to: this.getRedirectionUrl(requestGroup === null || requestGroup === void 0 ? void 0 : requestGroup.id, portalId),
                value: requestGroup.id,
                label: requestGroup.name,
                description: /*#__PURE__*/ $4fqPo.createElement($d7964b23c5d43ff3$var$RequestTypeList, null, this.formatReqGroupNames(requestGroup.reqTypes)),
                dataTestId: `request-group:${requestGroup.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    formatReqGroupNames(reqTypes) {
        return reqTypes.map((rt)=>rt.name).join(', ');
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, ...props } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: 'requestTypeGroups',
                attributes: {
                    portalId: props.portalId,
                    numberOfRequestTypeGroups: props.requestGroups.length
                }
            }
        }, /*#__PURE__*/ $4fqPo.createElement((0, $lbGhX.default), {
            id: "request-group-select",
            actionSubjectId: "requestTypeGroupSelect",
            itemActionSubjectId: "requestTypeGroup",
            listAppearance: "card",
            selectAppearance: "simple",
            label: label,
            labelIcon: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NaJ3))), {
                spacing: "spacious",
                label: '',
                "aria-hidden": "true",
                color: "var(--ds-icon, #42526E)"
            }),
            options: this.getOptions(),
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props
        }));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $d7964b23c5d43ff3$var$RequestTypeList = /*#__PURE__*/ (0, $el3DQ.default).span.withConfig({
    componentId: "sc-1iqgmfs-0"
})`${$4W9tu.small};`;

});
parcelRegister("31eVp", function(module, exports) {
$parcel$export(module.exports, "GroupBoxSelect", () => (parcelRequire("lbGhX")).default);

var $lbGhX = parcelRequire("lbGhX");

});
parcelRegister("lbGhX", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f24da1022198368$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $2QDnI = parcelRequire("2QDnI");

var $4W9tu = parcelRequire("4W9tu");

var $iSWaE = parcelRequire("iSWaE");
parcelRequire("lyAWA");
var $iaxbG = parcelRequire("iaxbG");
parcelRequire("4Jfiz");
var $keu8x = parcelRequire("keu8x");

var $9Ix81 = parcelRequire("9Ix81");
var $2m8U6 = parcelRequire("2m8U6");

var $WVSzu = parcelRequire("WVSzu");

var $cwDMg = parcelRequire("cwDMg");
parcelRequire("hy5Bl");
var $iZUrV = parcelRequire("iZUrV");
var $fjJCg = parcelRequire("fjJCg");
class $4f24da1022198368$export$2e2bcd8739ae039 extends $4fqPo.PureComponent {
    static #_ = this.defaultProps = {
        listAppearance: 'default',
        selectAppearance: 'default'
    };
    getValue() {
        const { value: value, options: options } = this.props;
        if (value) return options.find((option)=>option.value === value);
        return null;
    }
    renderSmallLabel() {
        const { id: id, label: label, editRequestTypeOnRequestForm: editRequestTypeOnRequestForm } = this.props;
        const HeaderComponent = $4f24da1022198368$export$105792bf13c50cea;
        return !!editRequestTypeOnRequestForm ? /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $4f24da1022198368$var$labelSmallStylesWrapper
        }, /*#__PURE__*/ $4fqPo.createElement(HeaderComponent, {
            isCORTOPSExperimentEnabled: true
        }, /*#__PURE__*/ $4fqPo.createElement("label", {
            htmlFor: id
        }, label)), editRequestTypeOnRequestForm) : /*#__PURE__*/ $4fqPo.createElement(HeaderComponent, null, /*#__PURE__*/ $4fqPo.createElement("label", {
            htmlFor: id
        }, label));
    }
    renderBigLabel() {
        const { id: id, label: label, labelIcon: labelIcon, customizePortalButtonsGroup: customizePortalButtonsGroup } = this.props;
        const HeaderComponent = $4f24da1022198368$export$2e1776684c14bc89;
        return !!customizePortalButtonsGroup ? /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: $4f24da1022198368$var$labelStylesWrapper
        }, /*#__PURE__*/ $4fqPo.createElement(HeaderComponent, {
            isCORTOPSExperimentEnabled: true
        }, /*#__PURE__*/ $4fqPo.createElement($4f24da1022198368$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, /*#__PURE__*/ $4fqPo.createElement("span", null, label))), customizePortalButtonsGroup) : /*#__PURE__*/ $4fqPo.createElement(HeaderComponent, null, /*#__PURE__*/ $4fqPo.createElement($4f24da1022198368$var$LabelWithIcon, {
            htmlFor: id
        }, labelIcon, /*#__PURE__*/ $4fqPo.createElement("span", null, label)));
    }
    renderAsSelect(optionValue) {
        const { id: id, disabled: disabled, options: options, autoFocus: autoFocus, actionSubjectId: actionSubjectId } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, this.renderSmallLabel(), /*#__PURE__*/ $4fqPo.createElement((0, $2QDnI.Select), {
            actionSubjectId: actionSubjectId,
            inputId: id,
            autoFocus: autoFocus,
            options: options,
            onChange: this.onChange,
            value: optionValue,
            // Upgrading @atlaskit/platform; fix these violations.
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            menuPortalTarget: document.body,
            formatOptionLabel: this.formatOptionLabel,
            isDisabled: disabled,
            menuPlacement: "auto",
            // We want the selected option to be visible so customers can read the description if they desire.
            hideSelectedOptions: false,
            isSearchable: false,
            styles: {
                control: (supplied, { isFocused: isFocused })=>({
                        ...supplied,
                        // Don't allow flex children to wrap, since we reset styles of
                        // the value container we need this.
                        flexWrap: 'nowrap',
                        // Suppressing existing violation. Please fix this.
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        ':hover': {
                            // @ts-ignore TS(7053) TypeScript upgrade 5.1.6, please fix this violation when you revisit this code.: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                            ...supplied[':hover'],
                            backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)",
                            borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtler, #EBECF0)"
                        },
                        backgroundColor: isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)",
                        borderColor: isFocused ? "var(--ds-border-focused, #4C9AFF)" : "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
                    }),
                valueContainer: ()=>({
                        // We apply our own styles here.
                        //
                        // Overflow hidden so the children show their ellipsis if needed.
                        overflow: 'hidden'
                    }),
                singleValue: ()=>({
                        // We apply our own styles here.
                        //
                        // Since the value is a flex child set its width to 100% so it only
                        // takes up the given space.
                        width: '100%'
                    }),
                option: (_, state)=>({
                        // We apply our own styles here.
                        backgroundColor: state.isFocused ? "var(--ds-surface-hovered, #F4F5F7)" : undefined,
                        cursor: 'pointer',
                        padding: 0,
                        margin: 0,
                        width: '100%'
                    }),
                menu: (styles)=>({
                        ...styles,
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            }
        }));
    }
    renderAsList(optionValue) {
        const { options: options, autoFocus: autoFocus, listAppearance: listAppearance, renderItem: renderItem } = this.props;
        const hasSelectedSingleValue = options.length === 1 && optionValue === options[0];
        return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $WVSzu.FireScreenEventOnMount), null), hasSelectedSingleValue ? this.renderSmallLabel() : this.renderBigLabel(), /*#__PURE__*/ $4fqPo.createElement($4f24da1022198368$export$54c2e3dc7acea9f5, {
            offsetMargin: listAppearance === 'default' && !hasSelectedSingleValue
        }, options.map((option, index)=>{
            const content = this.renderListItemContent(option, optionValue === option, hasSelectedSingleValue);
            return /*#__PURE__*/ $4fqPo.createElement((0, $iaxbG.AutoFocus), {
                key: option.value,
                isEnabled: autoFocus && index === 0
            }, /*#__PURE__*/ $4fqPo.createElement($4f24da1022198368$var$ListItem, {
                withMargin: listAppearance === 'card'
            }, renderItem && !hasSelectedSingleValue ? renderItem(content, index) : content));
        })));
    }
    renderListItemContent(option, isSelected, hasSelectedSingleValue) {
        const { listAppearance: listAppearance, cardLinkAppearance: cardLinkAppearance, itemActionSubjectId: itemActionSubjectId, editRequestTypeOnRequestList: editRequestTypeOnRequestList } = this.props;
        switch(listAppearance){
            case 'card':
                return /*#__PURE__*/ $4fqPo.createElement((0, $keu8x.default), {
                    to: option.to,
                    padding: 0,
                    appearance: cardLinkAppearance,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target
                }, /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    lineClamp: isSelected ? 1 : 0
                }));
            case 'default':
            default:
                return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, isSelected ? /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), {
                    icon: option.iconUrl,
                    heading: option.label,
                    description: option.description,
                    dataTestId: option.dataTestId,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0
                }) : /*#__PURE__*/ $4fqPo.createElement((0, $fjJCg.default), {
                    icon: option.iconUrl,
                    to: option.to,
                    heading: option.label,
                    description: option.description,
                    // oxlint-disable-next-line no-nested-ternary
                    lineClamp: isSelected ? hasSelectedSingleValue ? 0 : 1 : 0,
                    selected: isSelected,
                    actionSubjectId: itemActionSubjectId,
                    dataTestId: option.dataTestId,
                    target: option.target,
                    ...!!editRequestTypeOnRequestList && {
                        editRequestTypeOnRequestList: editRequestTypeOnRequestList(option.value)
                    }
                }));
        }
    }
    render() {
        const { className: className, options: options } = this.props;
        const value = this.getValue();
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling, please resolve
        /*#__PURE__*/ $4fqPo.createElement("div", {
            className: className
        }, options.length > 1 && value ? this.renderAsSelect(value) : this.renderAsList(value)));
    }
    constructor(...args){
        super(...args), this.formatOptionLabel = (option, context)=>{
            const { headingAs: headingAs } = this.props;
            switch(this.props.selectAppearance){
                case 'simple':
                    if (context.context === 'menu') return /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), {
                        containerPadding: "tight",
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description
                    });
                    return /*#__PURE__*/ $4fqPo.createElement($4f24da1022198368$var$SimpleSelectOption, null, option.label);
                case 'default':
                default:
                    return /*#__PURE__*/ $4fqPo.createElement((0, $iZUrV.default), {
                        containerPadding: "tight",
                        headingAs: headingAs,
                        icon: option.iconUrl,
                        heading: option.label,
                        description: option.description,
                        lineClamp: context.context === 'value' ? 1 : 0
                    });
            }
        }, this.onChange = (optionValue)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            return (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, (_toSingleSelectValue = (0, $cwDMg.toSingleSelectValue)(optionValue)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value);
        };
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f24da1022198368$var$ListItem = /*#__PURE__*/ (0, $el3DQ.default).li.withConfig({
    componentId: "sc-h09otw-0"
})`display:block;${(props)=>$iSWaE.applyIf(!!props.withMargin, // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
    (0, $el3DQ.css)`&:not(:last-child){margin-bottom:${"var(--ds-space-400, 32px)"};}`)};`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f24da1022198368$var$LabelWithIcon = /*#__PURE__*/ (0, $el3DQ.default).label.withConfig({
    componentId: "sc-h09otw-1"
})`display:flex;align-items:center;> :not(:last-child){margin-right:${"var(--ds-space-100, 8px)"};}`;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f24da1022198368$var$SimpleSelectOption = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-h09otw-2"
})`margin-left:${"var(--ds-space-100, 8px)"};`;
const $4f24da1022198368$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN = "var(--ds-space-negative-200, -16px)";
const $4f24da1022198368$var$GROUP_BOX_SELECT_PADDING_INLINE = "var(--ds-space-negative-300, -24px)";
const $4f24da1022198368$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $el3DQ.default).ul.withConfig({
    componentId: "sc-h09otw-3"
})`margin:${(props)=>props.offsetMargin ? `${$4f24da1022198368$var$GROUP_BOX_SELECT_LIST_TOP_MARGIN} ${$4f24da1022198368$var$GROUP_BOX_SELECT_PADDING_INLINE} 0` : '0'};padding:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f24da1022198368$var$selectHeaderStyles = /*#__PURE__*/ (0, $el3DQ.css)`${$4W9tu.h500};display:block;margin-top:0;margin-bottom:${(props)=>props.isCORTOPSExperimentEnabled ? 0 : "var(--ds-space-200, 16px)"};`;
const $4f24da1022198368$export$2e1776684c14bc89 = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-h09otw-4"
})`${$4f24da1022198368$var$selectHeaderStyles}`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f24da1022198368$var$smallSelectHeaderBaseStyles = /*#__PURE__*/ (0, $el3DQ.css)`${$4W9tu.h500};display:block;margin-top:0;`;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4f24da1022198368$var$smallSelectHeaderStyles = /*#__PURE__*/ (0, $el3DQ.css)`${$4f24da1022198368$var$smallSelectHeaderBaseStyles};${$4W9tu.h200};margin-top:0;margin-bottom:${(props)=>props.isCORTOPSExperimentEnabled ? 0 : "var(--ds-space-050, 4px)"};`;
const $4f24da1022198368$export$105792bf13c50cea = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-h09otw-5"
})`${$4f24da1022198368$var$smallSelectHeaderStyles}`;
const $4f24da1022198368$var$labelStylesWrapper = (0, $2m8U6.xcss)({
    marginBottom: 'space.200'
});
const $4f24da1022198368$var$labelSmallStylesWrapper = (0, $2m8U6.xcss)({
    marginBottom: 'space.100'
});

});
parcelRegister("lyAWA", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => (parcelRequire("iaxbG")).AutoFocus);

var $iaxbG = parcelRequire("iaxbG");

});
parcelRegister("iaxbG", function(module, exports) {
$parcel$export(module.exports, "AutoFocus", () => $6d0556d2aaed25df$export$9d8c528bc52bedf6);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");
class $6d0556d2aaed25df$export$9d8c528bc52bedf6 extends $4fqPo.Component {
    static #_ = this.defaultProps = {
        isEnabled: true
    };
    componentDidMount() {
        const { isEnabled: isEnabled } = this.props;
        // If we haven't yet triggered the focus we will focus on the ref if available
        if (isEnabled && !this.focused) {
            // eslint-disable-next-line react/no-find-dom-node
            const el = (0, $b2Ka1.findDOMNode)(this);
            if (el) {
                el.focus();
                this.focused = true;
            }
        }
    }
    render() {
        const { children: children } = this.props;
        return $4fqPo.Children.only(children);
    }
}

});


parcelRegister("cwDMg", function(module, exports) {
$parcel$export(module.exports, "toSingleSelectValue", () => $19e66a9d2b28b091$export$e6e136d0998f71a);
$parcel$export(module.exports, "toMultiSelectValue", () => $19e66a9d2b28b091$export$f3f3cd2c513af530);
const $19e66a9d2b28b091$export$e6e136d0998f71a = (value)=>{
    if (value == null) return value;
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return Array.isArray(value) ? value[0] : value;
};
const $19e66a9d2b28b091$export$f3f3cd2c513af530 = (value)=>{
    if (value == null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
};

});



parcelRegister("1NaJ3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba6b12c8d889bd288c998a8deb3aaaee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $14e2afecc6e33e03$var$_react = $14e2afecc6e33e03$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $14e2afecc6e33e03$var$_baseNew = $14e2afecc6e33e03$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $14e2afecc6e33e03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Send".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sending messages in Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $14e2afecc6e33e03$var$SendIcon = (props)=>/*#__PURE__*/ $14e2afecc6e33e03$var$_react.default.createElement($14e2afecc6e33e03$var$_baseNew.default, Object.assign({
        name: "SendIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 1.22a.75.75 0 0 1 .173.79l-5 13.5a.75.75 0 0 1-1.361.1l-2.895-5.307L.391 7.408A.75.75 0 0 1 .49 6.047l13.5-5a.75.75 0 0 1 .79.173M7.177 9.884l1.942 3.56 3.237-8.74zm4.118-6.24L2.556 6.881l3.56 1.942z" clip-rule="evenodd"/>`
    }, props));
$14e2afecc6e33e03$var$SendIcon.displayName = 'SendIcon';
var $14e2afecc6e33e03$var$_default = module.exports.default = $14e2afecc6e33e03$var$SendIcon;

});



parcelRegister("eGoPi", function(module, exports) {
$parcel$export(module.exports, "RequestTypeSelect", () => (parcelRequire("ijs5b")).default);

var $ijs5b = parcelRequire("ijs5b");

});
parcelRegister("ijs5b", function(module, exports) {
$parcel$export(module.exports, "default", () => $4718b9b6fbacd22c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");
parcelRequire("6nOoq");
var $7Cw9S = parcelRequire("7Cw9S");
parcelRequire("31eVp");
var $lbGhX = parcelRequire("lbGhX");

var $fFB0R = parcelRequire("fFB0R");

var $PL4bf = parcelRequire("PL4bf");
parcelRequire("jVjjC");
var $7Kgqq = parcelRequire("7Kgqq");
class $4718b9b6fbacd22c$export$2e2bcd8739ae039 extends $4fqPo.PureComponent {
    getOptions() {
        const referrer = $PL4bf.get((0, $7Kgqq.REFERRER_QUERY_PARAM));
        const shouldAddReferrer = referrer && referrer !== 'undefined';
        const { requestTypes: requestTypes, portalId: portalId, requestGroupId: requestGroupId, isEmbeddedRoute: isEmbeddedRoute } = this.props;
        return requestTypes.map((requestType)=>({
                value: Number(requestType.id),
                label: requestType.name,
                description: /*#__PURE__*/ $4fqPo.createElement($4718b9b6fbacd22c$var$RequestTypeDescription, {
                    dangerouslySetInnerHTML: {
                        __html: requestType.descriptionHtml
                    }
                }),
                iconUrl: requestType.iconUrl,
                // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                to: `/portal/${portalId}/group/${requestGroupId}/create/${requestType.id}${shouldAddReferrer ? `?${0, $7Kgqq.REFERRER_QUERY_PARAM}=${referrer}` : ''}`,
                dataTestId: `request-type:${requestType.name}`,
                target: isEmbeddedRoute ? '_blank' : undefined
            }));
    }
    getCSMOptions() {
        const { requestTypes: requestTypes } = this.props;
        return requestTypes.map((requestType)=>({
                value: requestType.name,
                label: requestType.name
            }));
    }
    getCSMValue(value) {
        const { requestTypes: requestTypes } = this.props;
        if (!value) return {
            value: '',
            label: ''
        };
        const requestType = requestTypes.find((requestTypeOption)=>Number(requestTypeOption.id) === value);
        return {
            value: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || '',
            label: (requestType === null || requestType === void 0 ? void 0 : requestType.name) || ''
        };
    }
    render() {
        const { label: label, onChange: onChange, value: value, disabled: disabled, isCSM: isCSM, headingAs: headingAs, ...props } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $fFB0R.default), {
            data: {
                actionSubjectId: 'requestTypes',
                attributes: {
                    portalId: props.portalId,
                    requestGroupId: props.requestGroupId,
                    numberOfRequestTypes: props.requestTypes.length
                }
            }
        }, /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, isCSM ? /*#__PURE__*/ $4fqPo.createElement((0, $7Cw9S.default), {
            id: "request-type-select",
            label: label,
            options: this.getCSMOptions(),
            defaultValue: this.getCSMValue(value),
            disabled: !!disabled
        }) : /*#__PURE__*/ $4fqPo.createElement((0, $lbGhX.default), {
            id: "request-type-select",
            actionSubjectId: "requestTypeSelect",
            itemActionSubjectId: "requestType",
            label: label,
            options: this.getOptions(),
            headingAs: headingAs,
            onChange: onChange,
            value: value,
            disabled: !!disabled,
            ...props
        })));
    }
}
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $4718b9b6fbacd22c$var$RequestTypeDescription = /*#__PURE__*/ (0, $el3DQ.default).span.withConfig({
    componentId: "sc-1qcxsi7-0"
})`p{display:inline;}`;

});
parcelRegister("6nOoq", function(module, exports) {
$parcel$export(module.exports, "SingleSelectField", () => (parcelRequire("7Cw9S")).default);
/** This is the single select form component type  */ 
var $7Cw9S = parcelRequire("7Cw9S");

});
parcelRegister("7Cw9S", function(module, exports) {
$parcel$export(module.exports, "default", () => $79d97d371042172a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $45M9n = parcelRequire("45M9n");

var $cwDMg = parcelRequire("cwDMg");
class $79d97d371042172a$var$SingleFieldSelect extends $4fqPo.PureComponent {
    componentDidMount() {
        // JDW-2280 - this is required to make url filling (e.g. ?customfield_10343=10657) work
        if (this.props.defaultValue) this.onChange(this.props.defaultValue);
    }
    render() {
        const { disabled: disabled, ...otherProps } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $45M9n.FormSingleSelect), {
            ...otherProps,
            onChange: this.onChange,
            isDisabled: disabled
        });
    }
    constructor(...args){
        super(...args), this.onChange = (option, meta)=>{
            var _this$props$onChange, _this$props, _toSingleSelectValue;
            (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, this.props.id, ((_toSingleSelectValue = (0, $cwDMg.toSingleSelectValue)(option)) === null || _toSingleSelectValue === void 0 ? void 0 : _toSingleSelectValue.value) ?? '', false, {
                rawObject: meta ?? {},
                rawValue: option
            });
        };
    }
}
var $79d97d371042172a$export$2e2bcd8739ae039 = $79d97d371042172a$var$SingleFieldSelect;

});
parcelRegister("45M9n", function(module, exports) {
$parcel$export(module.exports, "FieldSingleSelect", () => $ca539b4ff273dee9$export$a63157f03e4869bc);
$parcel$export(module.exports, "FormSingleSelect", () => $ca539b4ff273dee9$export$6440c30e7d5bd2b2);
$parcel$export(module.exports, "FormAsyncSingleSelect", () => $ca539b4ff273dee9$export$1232b3d2b9045cfb);
$parcel$export(module.exports, "FormAsyncCreatableSingleSelect", () => $ca539b4ff273dee9$export$5e090ccc28fd7327);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("1HQps");
var $h0jiB = parcelRequire("h0jiB");
parcelRequire("2J8RS");
var $7x7Qw = parcelRequire("7x7Qw");

var $5Z4uE = parcelRequire("5Z4uE");

var $9uLAg = parcelRequire("9uLAg");

var $iADZa = parcelRequire("iADZa");
const $ca539b4ff273dee9$export$a63157f03e4869bc = (0, $iADZa.default)((0, $h0jiB.ThemedSelect));
const $ca539b4ff273dee9$var$FieldAsyncSingleSelect = (0, $iADZa.default)((0, $h0jiB.ThemedAsyncSelect));
const $ca539b4ff273dee9$var$FieldAsyncCreatableSingleSelect = (0, $iADZa.default)((0, $h0jiB.ThemedAsyncCreatableSelect));
class $ca539b4ff273dee9$var$FormAsyncCreatableSingleSelectBase extends $4fqPo.PureComponent {
    render() {
        return /*#__PURE__*/ $4fqPo.createElement($ca539b4ff273dee9$var$FieldAsyncCreatableSingleSelect, {
            ...this.props,
            onCreateOption: this.onCreateOption
        });
    }
    constructor(...args){
        super(...args), this.onCreateOption = (input)=>{
            const { onChange: onChange, showNewLabelForCreatedValues: showNewLabelForCreatedValues } = this.props;
            const newOption = {
                value: input,
                label: input,
                isNew: showNewLabelForCreatedValues
            };
            onChange === null || onChange === void 0 || onChange(newOption, {
                action: 'create-option',
                option: newOption
            });
        };
    }
}
const $ca539b4ff273dee9$var$ControlledFieldAsyncSingleSelect = (0, $7x7Qw.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $4fqPo.createElement($ca539b4ff273dee9$var$FieldAsyncSingleSelect, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $ca539b4ff273dee9$var$ControlledFormAsyncCreatableSingleSelectBase = (0, $7x7Qw.withControlledFormComponentValue)((option)=>option)((props)=>/*#__PURE__*/ $4fqPo.createElement($ca539b4ff273dee9$var$FormAsyncCreatableSingleSelectBase, {
        ...props,
        isMulti: false,
        isClearable: true
    }));
const $ca539b4ff273dee9$export$6440c30e7d5bd2b2 = (0, $7x7Qw.withControlledFormComponentValue)((option)=>option)($ca539b4ff273dee9$export$a63157f03e4869bc);
const $ca539b4ff273dee9$export$1232b3d2b9045cfb = (0, $5Z4uE.componentWithCondition)(()=>(0, $bG6ob.isUserPickerSupportEnabled)(), $ca539b4ff273dee9$var$ControlledFieldAsyncSingleSelect, (0, $9uLAg.default)($ca539b4ff273dee9$var$FieldAsyncSingleSelect));
const $ca539b4ff273dee9$export$5e090ccc28fd7327 = (0, $5Z4uE.componentWithCondition)(()=>(0, $bG6ob.isUserPickerSupportEnabled)(), $ca539b4ff273dee9$var$ControlledFormAsyncCreatableSingleSelectBase, (0, $9uLAg.default)($ca539b4ff273dee9$var$FormAsyncCreatableSingleSelectBase));

});
parcelRegister("1HQps", function(module, exports) {
$parcel$export(module.exports, "ThemedSelect", () => (parcelRequire("h0jiB")).ThemedSelect);
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => (parcelRequire("h0jiB")).ThemedAsyncCreatableSelect);
$parcel$export(module.exports, "ThemedAsyncSelect", () => (parcelRequire("h0jiB")).ThemedAsyncSelect);

var $h0jiB = parcelRequire("h0jiB");

});
parcelRegister("h0jiB", function(module, exports) {
$parcel$export(module.exports, "ThemedAsyncCreatableSelect", () => $6d2436b2df1e7816$export$6ed24baf80289e3c);
$parcel$export(module.exports, "ThemedAsyncSelect", () => $6d2436b2df1e7816$export$ffdb66031dcf42ea);
$parcel$export(module.exports, "ThemedSelect", () => $6d2436b2df1e7816$export$336563657ba327fe);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $4xDjq = parcelRequire("4xDjq");
var $1sSeA = parcelRequire("1sSeA");
var $1f5L8 = parcelRequire("1f5L8");
var $2QDnI = parcelRequire("2QDnI");
function $6d2436b2df1e7816$var$withThemeSelect(Component) {
    class ThemedSelectWrapper extends $4fqPo.PureComponent {
        render() {
            const { theme: theme, styles: externalStyles = {}, ...selectProps } = this.props;
            const customStyles = {
                // This is to ensure the multi select options stay within the container without overflowing
                valueContainer: (styles)=>({
                        ...styles,
                        width: '100%',
                        overflow: 'hidden'
                    }),
                // This is used to apply our theming
                option: (styles, { isFocused: isFocused, isSelected: isSelected })=>{
                    const themed = theme;
                    const optionFocusBackground = isFocused ? "var(--ds-background-neutral-subtle-hovered, #F4F5F7)" : null;
                    const backgroundColor = isSelected ? themed.lightColor : optionFocusBackground;
                    return {
                        ...styles,
                        backgroundColor: backgroundColor,
                        ':active': {
                            backgroundColor: themed.lightColor
                        },
                        color: "var(--ds-text, #172B4D)"
                    };
                },
                // This is to ensure long select options doesn't cause a horizontal scroll bar to appear in the select menu
                menu: (styles)=>({
                        ...styles,
                        'word-wrap': 'break-word',
                        'overflow-y': 'hidden',
                        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)"
                    })
            };
            return /*#__PURE__*/ $4fqPo.createElement(Component, {
                placeholder: "",
                // Upgrading @atlaskit/platform; fix these violations.
                // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage, @atlassian/ssr-linting/no-dom-globals-in-react-cc-render
                menuPortalTarget: document.body,
                menuPlacement: "auto",
                ...selectProps,
                styles: {
                    ...externalStyles,
                    ...customStyles
                }
            });
        }
    }
    return (0, $el3DQ.withTheme)(ThemedSelectWrapper);
}
const $6d2436b2df1e7816$export$6ed24baf80289e3c = $6d2436b2df1e7816$var$withThemeSelect((0, $4xDjq.AsyncCreatableSelect));
const $6d2436b2df1e7816$export$1692d6296f3148ba = $6d2436b2df1e7816$var$withThemeSelect((0, $1f5L8.CreatableSelect));
const $6d2436b2df1e7816$export$ffdb66031dcf42ea = $6d2436b2df1e7816$var$withThemeSelect((0, $1sSeA.AsyncSelect));
const $6d2436b2df1e7816$export$336563657ba327fe = $6d2436b2df1e7816$var$withThemeSelect((0, $2QDnI.Select));

});
parcelRegister("4xDjq", function(module, exports) {
$parcel$export(module.exports, "AsyncCreatableSelect", () => $ad9f600226e72c62$export$c0b2520fe082e4aa);

var $aGNJI = parcelRequire("aGNJI");

var $fD39j = parcelRequire("fD39j");
const $ad9f600226e72c62$export$c0b2520fe082e4aa = (0, $fD39j.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $aGNJI.default));

});
parcelRegister("aGNJI", function(module, exports) {
$parcel$export(module.exports, "default", () => $da3c05d9770fb431$export$2e2bcd8739ae039);

var $dtA1b = parcelRequire("dtA1b");

var $cOaLL = parcelRequire("cOaLL");
const $da3c05d9770fb431$var$AsyncCreatableSelect = (0, $cOaLL.default)((0, $dtA1b.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$da3c05d9770fb431$export$2e2bcd8739ae039 = $da3c05d9770fb431$var$AsyncCreatableSelect;

});
parcelRegister("dtA1b", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2b8065415a5ff0a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5VSzD = parcelRequire("5VSzD");

var $k4MJ3 = parcelRequire("k4MJ3");

var $cn2lZ = parcelRequire("cn2lZ");

var $2QceZ = parcelRequire("2QceZ");
const $c2b8065415a5ff0a$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $k4MJ3.default)(props);
    const creatableProps = (0, $2QceZ.default)(stateManagerProps);
    const selectProps = (0, $cn2lZ.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5VSzD.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c2b8065415a5ff0a$export$2e2bcd8739ae039 = $c2b8065415a5ff0a$var$AsyncCreatableSelect;

});
parcelRegister("cn2lZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $13d670b9ab3a6c91$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dRl9j = parcelRequire("dRl9j");
var $izn4k = parcelRequire("izn4k");

var $iZBgo = parcelRequire("iZBgo");

var $ezTdO = parcelRequire("ezTdO");
const $13d670b9ab3a6c91$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $13d670b9ab3a6c91$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$13d670b9ab3a6c91$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$13d670b9ab3a6c91$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $13d670b9ab3a6c91$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $13d670b9ab3a6c91$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $13d670b9ab3a6c91$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $13d670b9ab3a6c91$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $izn4k.getOptionValue), getOptionLabel: getOptionLabel = (0, $dRl9j.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $4fqPo.useMemo)(()=>isValidNewOption(inputValue, (0, $iZBgo.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $4fqPo.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $4fqPo.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $ezTdO.valueTernary)(isMulti, [
                    ...(0, $iZBgo.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});




parcelRegister("1sSeA", function(module, exports) {
$parcel$export(module.exports, "AsyncSelect", () => $00a215fb6d9bb229$export$aca05dd54e009a80);

var $9tIWC = parcelRequire("9tIWC");

var $fD39j = parcelRequire("fD39j");
const $00a215fb6d9bb229$export$aca05dd54e009a80 = (0, $fD39j.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $9tIWC.default));

});
parcelRegister("9tIWC", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bd3615c342de948$export$2e2bcd8739ae039);

var $7o9pt = parcelRequire("7o9pt");

var $cOaLL = parcelRequire("cOaLL");
const $2bd3615c342de948$var$AsyncSelect = (0, $cOaLL.default)((0, $7o9pt.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2bd3615c342de948$export$2e2bcd8739ae039 = $2bd3615c342de948$var$AsyncSelect;

});


parcelRegister("1f5L8", function(module, exports) {
$parcel$export(module.exports, "CreatableSelect", () => $6c5455d36e79c890$export$4d213c67c76d12fa);

var $9Ep2V = parcelRequire("9Ep2V");

var $fD39j = parcelRequire("fD39j");
const $6c5455d36e79c890$export$4d213c67c76d12fa = (0, $fD39j.default)('select', {
    onChange: ()=>({
            action: 'changed'
        })
})((0, $9Ep2V.default));

});
parcelRegister("9Ep2V", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd06abba1cbe701c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ 
var $33PWv = parcelRequire("33PWv");

var $cOaLL = parcelRequire("cOaLL");
const $bd06abba1cbe701c$var$CreatableSelect = (0, $cOaLL.default)((0, $33PWv.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bd06abba1cbe701c$export$2e2bcd8739ae039 = $bd06abba1cbe701c$var$CreatableSelect;

});
parcelRegister("33PWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2fc3871b0470817$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5VSzD = parcelRequire("5VSzD");

var $cn2lZ = parcelRequire("cn2lZ");

var $2QceZ = parcelRequire("2QceZ");
const $b2fc3871b0470817$var$CreatableSelect = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const creatableProps = (0, $2QceZ.default)(props);
    const selectProps = (0, $cn2lZ.default)(creatableProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5VSzD.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b2fc3871b0470817$export$2e2bcd8739ae039 = $b2fc3871b0470817$var$CreatableSelect;

});





parcelRegister("9uLAg", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd3273216c5d2936$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $cd3273216c5d2936$var$withControlledValueSingleSelect(SelectComponent) {
    return class ControlledValueSingleSelectWrapper extends $4fqPo.PureComponent {
        static #_ = this.displayName = 'ControlledValueSingleSelectWrapper';
        render() {
            return /*#__PURE__*/ $4fqPo.createElement(SelectComponent, {
                ...this.props,
                isMulti: false,
                value: this.state.selectedOption,
                onChange: this.onChange,
                isClearable: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                selectedOption: this.props.defaultValue
            }, this.onChange = (option, context)=>{
                var _this$props$onChange, _this$props;
                this.setState({
                    selectedOption: option
                });
                // Suppressing existing violation. Please fix this.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                (_this$props$onChange = (_this$props = this.props).onChange) === null || _this$props$onChange === void 0 || _this$props$onChange.call(_this$props, option, context);
            };
        }
    };
}
var $cd3273216c5d2936$export$2e2bcd8739ae039 = $cd3273216c5d2936$var$withControlledValueSingleSelect;

});

parcelRegister("iADZa", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb3a5e50ed79fe34$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("c71sY");
var $jwI0L = parcelRequire("jwI0L");
function $fb3a5e50ed79fe34$var$withFieldBase(SelectComponent) {
    const wrappedComponent = (props)=>{
        const { label: label, required: required, errorMessage: errorMessage, description: description, id: id, tooltip: tooltip, ...otherProps } = props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $jwI0L.default), {
            htmlFor: id,
            label: label,
            required: required,
            errorMessage: errorMessage,
            description: description,
            ...(0, $bG6ob.isUiModificationsSupportEnabled)() ? {
                tooltip: tooltip
            } : null
        }, /*#__PURE__*/ $4fqPo.createElement(SelectComponent, {
            ...otherProps,
            inputId: id,
            "aria-describedby": `${id}-field-description`,
            validationState: !!errorMessage ? 'error' : 'default'
        }));
    };
    return wrappedComponent;
}
var $fb3a5e50ed79fe34$export$2e2bcd8739ae039 = $fb3a5e50ed79fe34$var$withFieldBase;

});






parcelRegister("6UVVC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4805400ea76d1017$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $4805400ea76d1017$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requestGroupSelectLabel: {
        defaultMessage: 'Contact us about',
        description: 'Label shown for selecting a request group',
        id: 'sd.portal.request.group.select'
    },
    requestTypeSelectLabel: {
        defaultMessage: 'What can we help you with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.request.type.select'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    CSMRequestTypeSelectLabel: {
        defaultMessage: 'What do you need help with?',
        description: 'Label shown for picking a request type',
        id: 'sd.portal.csm.request.type.select'
    },
    emptyStateMessage: {
        defaultMessage: "There's nothing in this portal yet.",
        description: 'This message is shown, when there are no configured request groups for service project',
        id: 'sd.jsm.portal.empty.request.type'
    },
    tryAnotherServiceProjectLink: {
        defaultMessage: 'Go to the help center',
        description: 'This link is shown, when there are no configured request groups for current service project and there are other service projects available',
        id: 'sd.jsm.portal.empty.sd.link'
    }
});

});





parcelRegister("lrbl6", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => (parcelRequire("kpi5T")).SkeletonLoadingContainer);

var $kpi5T = parcelRequire("kpi5T");

});
parcelRegister("kpi5T", function(module, exports) {
$parcel$export(module.exports, "SkeletonLoadingContainer", () => $48c1aa0abd3742c8$export$ed074b591cb3b239);

var $4fqPo = parcelRequire("4fqPo");

var $bvB7a = parcelRequire("bvB7a");
parcelRequire("b0F8E");
var $awGaB = parcelRequire("awGaB");

var $cijxS = parcelRequire("cijxS");
class $48c1aa0abd3742c8$export$ed074b591cb3b239 extends $4fqPo.Component {
    static #_ = this.defaultProps = {
        loadingPosition: 'fill-container'
    };
    render() {
        const { children: children, loadingPosition: loadingPosition, isLoading: isLoading, enableUFOHold: enableUFOHold, ufoHoldName: ufoHoldName } = this.props;
        const skeleton = /*#__PURE__*/ $4fqPo.createElement((0, $bvB7a.SkeletonLoadingWrapper), {
            isLoading: true,
            loadingPosition: loadingPosition
        });
        return isLoading ? /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.PaperContent), null, enableUFOHold ? /*#__PURE__*/ $4fqPo.createElement((0, $cijxS.default), {
            name: ufoHoldName
        }, skeleton) : skeleton) : children;
    }
}

});


parcelRegister("e1Tq1", function(module, exports) {
$parcel$export(module.exports, "ExternalLinks", () => $23a0ca5ab97195f8$export$7c6fdaf98295312b);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $23a0ca5ab97195f8$export$7c6fdaf98295312b = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("l1LBG")), {
        moduleId: "./src/view/external-links/external-links.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("l1LBG", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("3vdHc"),
    $e46AW("dRixu")
]).then(()=>parcelRequire('fc4xm'));

});


parcelRegister("8XB1g", function(module, exports) {
$parcel$export(module.exports, "ForgeFooterModule", () => $0c87966cc30373e5$export$c664a1597302ef11);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $0c87966cc30373e5$export$c664a1597302ef11 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("1OXx4")), {
        moduleId: "./src/view/forge-ui/portal-footer/portal-footer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("1OXx4", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fQ9ZO").then(()=>parcelRequire('dyAqo'));

});


parcelRegister("cfDDl", function(module, exports) {
$parcel$export(module.exports, "ForgeHeaderModule", () => $3e04e0646f78bb5f$export$8010fd64cd5cfdb9);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $3e04e0646f78bb5f$export$8010fd64cd5cfdb9 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("j9bGr")), {
        moduleId: "./src/view/forge-ui/portal-header/portal-header.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("j9bGr", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("i93Hc").then(()=>parcelRequire('2EB7g'));

});


parcelRegister("89jUj", function(module, exports) {
$parcel$export(module.exports, "LazyVirtualServiceAgentChatSidebar", () => $96fb48575e14c247$export$5ab8ce8fb542ac03);
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $96fb48575e14c247$export$5ab8ce8fb542ac03 = (0, $60vf0.lazy)(()=>(parcelRequire("2kzIT")), {
    moduleId: "./src/view/layout/virtual-service-agent-chat-sidebar/virtual-service-agent-chat-sidebar.tsx"
});

});
parcelRegister("2kzIT", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("hma0F"),
    $e46AW("4xkV0"),
    $e46AW("epuCh"),
    $e46AW("hRvNP"),
    $e46AW("8BSvf"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("8eMUr"),
    $e46AW("9vY2V"),
    $e46AW("035bM"),
    $e46AW("cotMj"),
    $e46AW("7zgcz"),
    $e46AW("b56zU"),
    $e46AW("aHrLh"),
    $e46AW("4YETx"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("jEsv4"),
    $e46AW("488RH"),
    $e46AW("4biYi"),
    $e46AW("fG06h"),
    $e46AW("co70a"),
    $e46AW("5jpjH"),
    $e46AW("eNoIp"),
    $e46AW("9CrMY")
]).then(()=>parcelRequire('k6i6Q'));

});


parcelRegister("3haKT", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpText", () => (parcelRequire("b0SRU")).default);

var $b0SRU = parcelRequire("b0SRU");

});
parcelRegister("b0SRU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d07af49ea513736e$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("lpNzz");
var $b4aG4 = parcelRequire("b4aG4");
const $d07af49ea513736e$var$selector = (0, $3yyCx.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    const requestType = (0, $95tqy.getPortalRequestType)(state, portalId, requestTypeId);
    return requestType && requestType.helpTextHtml;
}, (helpText)=>({
        helpText: helpText
    }));
var $d07af49ea513736e$export$2e2bcd8739ae039 = (0, $bmgw6.default)($d07af49ea513736e$var$selector)((0, $b4aG4.default));

});
parcelRegister("lpNzz", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormHelpTextDumb", () => (parcelRequire("b4aG4")).default);

var $b4aG4 = parcelRequire("b4aG4");

});
parcelRegister("b4aG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec4dec42b26eec64$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");
parcelRequire("fsGOD");
var $boHcd = parcelRequire("boHcd");
class $ec4dec42b26eec64$var$RequestCreateFormHelpTextDumb extends $4fqPo.Component {
    render() {
        return /*#__PURE__*/ $4fqPo.createElement((0, $boHcd.default), {
            in: !!this.props.helpText
        }, /*#__PURE__*/ $4fqPo.createElement($ec4dec42b26eec64$var$HelpTextContainer, {
            dangerouslySetInnerHTML: {
                __html: this.props.helpText
            }
        }));
    }
}
var $ec4dec42b26eec64$export$2e2bcd8739ae039 = $ec4dec42b26eec64$var$RequestCreateFormHelpTextDumb;
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $ec4dec42b26eec64$var$HelpTextContainer = /*#__PURE__*/ (0, $el3DQ.default).div.withConfig({
    componentId: "sc-1u76lr1-0"
})`margin-top:${"var(--ds-space-200, 16px)"};margin-bottom:${"var(--ds-space-100, 8px)"};a{text-decoration:underline;}`;

});
parcelRegister("fsGOD", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("boHcd")).default);
parcelRequire("eIOM1");
var $boHcd = parcelRequire("boHcd");

});
parcelRegister("eIOM1", function(module, exports) {
$parcel$export(module.exports, "Fade", () => (parcelRequire("boHcd")).default);

var $boHcd = parcelRequire("boHcd");

});
parcelRegister("boHcd", function(module, exports) {
$parcel$export(module.exports, "default", () => $351a3bd87365457a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $el3DQ = parcelRequire("el3DQ");

var $brRRh = parcelRequire("brRRh");

var $2MK3g = parcelRequire("2MK3g");
// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $351a3bd87365457a$var$Container = /*#__PURE__*/ (0, $el3DQ.default).span.withConfig({
    componentId: "sc-10ahj68-0"
})`${$brRRh.fadeInOut($brRRh.speedMs.fast)};`;
/**
 * This is for ease of use fade in/out. This will add an extra <span> around the children to do the
 * animating. If you need finer grained control, or don't want the extra span markup, use <Transition />
 * and our transition mixins directly.
 */ const $351a3bd87365457a$var$Fade = ({ children: children, appear: appear, in: show })=>/*#__PURE__*/ $4fqPo.createElement((0, $2MK3g.default), {
        timeout: $brRRh.speedMs.fast,
        in: show,
        mountOnEnter: true,
        unmountOnExit: true,
        appear: appear
    }, (state)=>/*#__PURE__*/ $4fqPo.createElement($351a3bd87365457a$var$Container, {
            state: state
        }, children));
var $351a3bd87365457a$export$2e2bcd8739ae039 = $351a3bd87365457a$var$Fade;

});







parcelRegister("1co7K", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsAnnouncementSidebar", () => $98a1c973c97a37b8$export$454a2c99809e1b66);
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $98a1c973c97a37b8$export$454a2c99809e1b66 = (0, $60vf0.lazy)(()=>(parcelRequire("4QjtI")), {
    moduleId: "./src/view/portal-settings-announcement-sidebar/portal-settings-announcement-sidebar.tsx"
});

});
parcelRegister("4QjtI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("bN9PN"),
    $e46AW("k4QXr"),
    $e46AW("7sKJw"),
    $e46AW("jgekn"),
    $e46AW("9d6FU"),
    $e46AW("2Zb1K")
]).then(()=>parcelRequire('ds7cI'));

});


parcelRegister("44UVd", function(module, exports) {
$parcel$export(module.exports, "LazyPortalSettingsSidebar", () => $f6cd1cd89a6f2774$export$4bdb57f5e35140ab);
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $f6cd1cd89a6f2774$export$4bdb57f5e35140ab = (0, $60vf0.lazy)(()=>(parcelRequire("6cTcZ")), {
    moduleId: "./src/view/portal-settings-sidebar/portal-settings-sidebar.tsx"
});

});
parcelRegister("6cTcZ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("bN9PN"),
    $e46AW("k4QXr"),
    $e46AW("55OMz"),
    $e46AW("7sKJw"),
    $e46AW("jgekn"),
    $e46AW("958rd"),
    $e46AW("9d6FU"),
    $e46AW("hIEoX"),
    $e46AW("9lL54"),
    $e46AW("k2Z1V"),
    $e46AW("gWY7T")
]).then(()=>parcelRequire('9D4gh'));

});


parcelRegister("2qWEd", function(module, exports) {
$parcel$export(module.exports, "RequestCreateForm", () => $9d106392b6ed356d$export$23aadacdae45e79);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $9d106392b6ed356d$var$loader = (0, $60vf0.lazyForPaint)(()=>{
    return (parcelRequire("ll459"));
}, {
    ssr: true,
    moduleId: "./src/view/request-create-form/hocs.tsx"
});
const $9d106392b6ed356d$export$23aadacdae45e79 = (0, $gi5ak.default)({
    loader: $9d106392b6ed356d$var$loader
});

});
parcelRegister("ll459", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("ibPpH"),
    $e46AW("5YgJY"),
    $e46AW("gtuk5"),
    $e46AW("5fJ5v"),
    $e46AW("1nzUi"),
    $e46AW("aBuAd"),
    $e46AW("jZPNc"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("kgNSH"),
    $e46AW("45caK"),
    $e46AW("3vgBs"),
    $e46AW("cDliv")
]).then(()=>parcelRequire('59I0k'));

});


parcelRegister("7UuIc", function(module, exports) {
$parcel$export(module.exports, "RequestCreateFormWithProforma", () => $82f4c5d56652a941$export$4265d8dac3a1f25);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $82f4c5d56652a941$var$loader = (0, $60vf0.lazyForPaint)(()=>{
    return (parcelRequire("kbgLU"));
}, {
    moduleId: "./src/view/request-create-form/request-create-form-with-proforma/request-create-form-with-proforma.tsx"
});
const $82f4c5d56652a941$export$4265d8dac3a1f25 = (0, $gi5ak.default)({
    loader: $82f4c5d56652a941$var$loader
});

});
parcelRegister("kbgLU", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("1LYbr"),
    $e46AW("EdvSx"),
    $e46AW("fq0LN"),
    $e46AW("dariE"),
    $e46AW("9d6FU"),
    $e46AW("l6MtR"),
    $e46AW("ibPpH"),
    $e46AW("5YgJY"),
    $e46AW("gtuk5"),
    $e46AW("5fJ5v"),
    $e46AW("1nzUi"),
    $e46AW("aBuAd"),
    $e46AW("jZPNc"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("kgNSH"),
    $e46AW("45caK"),
    $e46AW("3vgBs"),
    $e46AW("cDliv"),
    $e46AW("WZK8F")
]).then(()=>parcelRequire('9ZPoZ'));

});


parcelRegister("a0OAr", function(module, exports) {
$parcel$export(module.exports, "SidebarToggle", () => $df923f39f3933928$export$d1b4e884a11aa0f2);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2TV9p");
var $4azHH = parcelRequire("4azHH");
const $df923f39f3933928$export$d1b4e884a11aa0f2 = ({ openSidebar: openSidebar, closeSidebar: closeSidebar })=>{
    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { customize: customize, experience: experience } = (0, $4azHH.useQueryParams)();
    $4fqPo.useEffect(()=>{
        if (customize === 'true' && !!experience) openSidebar === null || openSidebar === void 0 || openSidebar();
        else closeSidebar === null || closeSidebar === void 0 || closeSidebar();
    }, [
        customize,
        openSidebar,
        closeSidebar,
        experience
    ]);
    return null;
};

});

parcelRegister("gyfNo", function(module, exports) {
$parcel$export(module.exports, "UiModificationsEntryPoint", () => $119908142be85a46$export$c89b83ae4e6840b3);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $cwZKZ = parcelRequire("cwZKZ");
parcelRequire("fRkFZ");
var $g9Cuz = parcelRequire("g9Cuz");

var $6bGmX = parcelRequire("6bGmX");

var $fJQMR = parcelRequire("fJQMR");

var $fZppw = parcelRequire("fZppw");

var $iUKVW = parcelRequire("iUKVW");
var $8MIxg = parcelRequire("8MIxg");

var $2jhlA = parcelRequire("2jhlA");
var $bFigR = parcelRequire("bFigR");

var $lsxWh = parcelRequire("lsxWh");

var $3grTu = parcelRequire("3grTu");

var $h0osM = parcelRequire("h0osM");
// TODO: add memo to the below component
const $119908142be85a46$var$EntryPointWithRelay = ({ portalId: portalId, requestTypeId: requestTypeId, triggerPointKey: triggerPointKey })=>{
    const executionContextKey = portalId && requestTypeId ? `${portalId}-${requestTypeId}` : null;
    const cloudId = (0, $6mmHn.getCloudId)();
    const activationId = (0, $6mmHn.getActivationId)();
    const { queryReference: queryReference } = (0, $fZppw.useRelayResource)((0, $cwZKZ.UI_MODIFICATIONS_JSM_REQUEST_CREATE_RESOURCE));
    const executionContext = (0, $4fqPo.useMemo)(()=>{
        if (!portalId || !requestTypeId) return null;
        return {
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        };
    }, [
        portalId,
        requestTypeId
    ]);
    const triggerPointKeyVal = triggerPointKey ?? (0, $3grTu.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2jhlA.UiModificationsRoot), {
        executionContext: executionContext,
        queryReference: queryReference,
        cloudId: cloudId,
        activationId: activationId,
        executionContextKey: executionContextKey,
        triggerPointKey: triggerPointKeyVal,
        ForgeAppRenderer: (0, $h0osM.ForgeAppRenderer)
    });
};
/**
 * Entry point component that uses Redux data (behind feature flag ditto_uim_root_query_rest)
 */ const $119908142be85a46$var$EntryPointWithReduxData = ({ portalId: portalId, requestTypeId: requestTypeId, triggerPointKey: triggerPointKey, uiModifications: uiModifications, uiModificationsError: uiModificationsError })=>{
    const executionContextKey = portalId && requestTypeId ? `${portalId}-${requestTypeId}` : null;
    const cloudId = (0, $6mmHn.getCloudId)();
    const activationId = (0, $6mmHn.getActivationId)();
    // Fire analytics when there's an error fetching UI modifications
    (0, $4fqPo.useEffect)(()=>{
        if (uiModificationsError) (0, $8MIxg.fireErrorAnalytics)({
            error: new Error(uiModificationsError),
            id: 'fetchUiModificationsFailure',
            viewType: (0, $lsxWh.REQUEST_CREATE_VIEW_TYPE),
            attributes: {
                portalId: portalId,
                requestTypeId: requestTypeId
            }
        });
    }, [
        uiModificationsError,
        portalId,
        requestTypeId
    ]);
    const executionContext = (0, $4fqPo.useMemo)(()=>{
        if (!portalId || !requestTypeId) return null;
        return {
            portal: {
                id: portalId
            },
            request: {
                typeId: requestTypeId
            }
        };
    }, [
        portalId,
        requestTypeId
    ]);
    // Wrap Redux data in { jira: ... } structure expected by platform component
    const wrappedUiModificationsData = (0, $4fqPo.useMemo)(()=>{
        if (!uiModifications) return {
            jira: {
                forge: {
                    uiModificationsExtensions: []
                },
                uiModifications: []
            }
        };
        return {
            jira: uiModifications
        };
    }, [
        uiModifications
    ]);
    const triggerPointKeyVal = triggerPointKey ?? (0, $3grTu.DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bFigR.UiModificationsRootWithData), {
        executionContext: executionContext,
        uiModificationsData: wrappedUiModificationsData,
        cloudId: cloudId,
        activationId: activationId,
        executionContextKey: executionContextKey,
        triggerPointKey: triggerPointKeyVal,
        ForgeAppRenderer: (0, $h0osM.ForgeAppRenderer)
    });
};
const $119908142be85a46$var$selector = (0, $3yyCx.createSelector)((state, props)=>{
    const { portalId: portalId, requestTypeId: requestTypeId } = props;
    let uiModifications;
    let uiModificationsError;
    if (portalId && requestTypeId) {
        uiModifications = (0, $g9Cuz.getUiModificationsData)(state, portalId, requestTypeId);
        uiModificationsError = (0, $g9Cuz.getUiModificationsError)(state, portalId, requestTypeId);
    }
    return {
        portalId: portalId,
        requestTypeId: requestTypeId,
        uiModifications: uiModifications,
        uiModificationsError: uiModificationsError,
        triggerPointKey: props.triggerPointKey
    };
}, (selectorData)=>selectorData);
const $119908142be85a46$var$EntryPointRedux = (0, $bmgw6.default)($119908142be85a46$var$selector)($119908142be85a46$var$EntryPointWithReduxData);
const $119908142be85a46$var$EntryPoint = (props)=>{
    if ((0, $6bGmX.default).checkGate('ditto_uim_root_query_rest')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($119908142be85a46$var$EntryPointRedux, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($119908142be85a46$var$EntryPointWithRelay, props);
};
const $119908142be85a46$export$c89b83ae4e6840b3 = (props)=>{
    return (0, $bG6ob.isUiModificationsSupportEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        id: "uiModifications",
        packageName: "jsmUiModificationsViewRequestCreate"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iUKVW.AnalyticsListener), {
        analyticsWebClient: (0, $fJQMR.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($119908142be85a46$var$EntryPoint, props))) : null;
};

});
parcelRegister("fRkFZ", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => (parcelRequire("g9Cuz")).getUiModificationsData);
$parcel$export(module.exports, "getUiModificationsError", () => (parcelRequire("g9Cuz")).getUiModificationsError);

var $g9Cuz = parcelRequire("g9Cuz");

});
parcelRegister("g9Cuz", function(module, exports) {
$parcel$export(module.exports, "getUiModificationsData", () => $49efd16d70d66f5b$export$3f2ec852b79889c8);
$parcel$export(module.exports, "getUiModificationsError", () => $49efd16d70d66f5b$export$a973ad30babc208b);
const $49efd16d70d66f5b$var$buildStoreKey = (portalId, requestTypeId)=>`${portalId}/${requestTypeId}`;
const $49efd16d70d66f5b$export$77a087943aa778c9 = (state, portalId, requestTypeId)=>{
    var _state$persisted$uiMo;
    const storeKey = $49efd16d70d66f5b$var$buildStoreKey(portalId, requestTypeId);
    return (_state$persisted$uiMo = state.persisted.uiModifications) === null || _state$persisted$uiMo === void 0 ? void 0 : _state$persisted$uiMo[storeKey];
};
const $49efd16d70d66f5b$export$3f2ec852b79889c8 = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn;
    return (_getUiModificationsEn = $49efd16d70d66f5b$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn === void 0 ? void 0 : _getUiModificationsEn.data;
};
const $49efd16d70d66f5b$export$a973ad30babc208b = (state, portalId, requestTypeId)=>{
    var _getUiModificationsEn2;
    return (_getUiModificationsEn2 = $49efd16d70d66f5b$export$77a087943aa778c9(state, portalId, requestTypeId)) === null || _getUiModificationsEn2 === void 0 ? void 0 : _getUiModificationsEn2.error;
};

});


parcelRegister("iUKVW", function(module, exports) {
$parcel$export(module.exports, "AnalyticsListener", () => $dca5138ab5bf2ed1$export$22edec767217cd60);

var $4fqPo = parcelRequire("4fqPo");

var $73FZL = parcelRequire("73FZL");

var $eeiwC = parcelRequire("eeiwC");
var $gHT3x = parcelRequire("gHT3x");
parcelRequire("aU7k1");
var $k554N = parcelRequire("k554N");

var $60Y3D = parcelRequire("60Y3D");
const $dca5138ab5bf2ed1$export$7329bcdc3edcd90e = (event, client)=>{
    switch(event.type){
        case 0, $gHT3x.OPERATIONAL_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
            break;
        case 0, $gHT3x.TRACK_EVENT_TYPE:
            Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
            break;
    }
};
const $dca5138ab5bf2ed1$export$eee20638634729b3 = (analyticsWebClient)=>(event)=>{
        const eventData = (0, $eeiwC.extractAWCDataFromEvent)(event);
        $dca5138ab5bf2ed1$export$7329bcdc3edcd90e({
            type: eventData.type,
            ...eventData.payload
        }, analyticsWebClient);
    };
const $dca5138ab5bf2ed1$export$22edec767217cd60 = ({ children: children, analyticsWebClient: analyticsWebClient })=>{
    const onEvent = (0, $4fqPo.useMemo)(()=>$dca5138ab5bf2ed1$export$eee20638634729b3(analyticsWebClient), [
        analyticsWebClient
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const initClient = async ()=>{
            const client = await analyticsWebClient;
            (0, $k554N.initialiseErrorAnalyticsClient)(client);
        };
        initClient();
    }, [
        analyticsWebClient
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $73FZL.default), {
        onEvent: onEvent,
        channel: (0, $60Y3D.UI_MODIFICATIONS_ANALYTICS_CHANNEL)
    }, children);
};

});

parcelRegister("2jhlA", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRoot", () => $d9d99c1cede83676$export$da1a4f52b34addd2);

var $ks84T = parcelRequire("ks84T");

var $4fqPo = parcelRequire("4fqPo");

var $gIeP2 = parcelRequire("gIeP2");

var $bY08M = parcelRequire("bY08M");

var $a6Pk7 = parcelRequire("a6Pk7");
const $d9d99c1cede83676$export$da1a4f52b34addd2 = (props)=>{
    const { queryReference: queryReference } = props;
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bY08M.default), {
        name: "ui-modifications-root-query",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($d9d99c1cede83676$var$RootQuery, {
        ...props,
        queryReference: queryReference
    }));
};
const $d9d99c1cede83676$var$RootQuery = (props)=>{
    const { queryReference: queryReference, ...restProps } = props;
    const data = (0, $gIeP2.usePreloadedQuery)((0, $ks84T.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a6Pk7.UiModificationsRootFragment), {
        ...restProps,
        fragmentRef: data
    });
};

});
parcelRegister("a6Pk7", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootFragment", () => $edd05bc884f6920f$export$c460318ed1ecaf23);

var $9RFdg = parcelRequire("9RFdg");

var $4fqPo = parcelRequire("4fqPo");

var $gIeP2 = parcelRequire("gIeP2");

var $fFB0R = parcelRequire("fFB0R");

var $33BOA = parcelRequire("33BOA");

var $eD73h = parcelRequire("eD73h");

var $ezZWZ = parcelRequire("ezZWZ");

var $5Uk5u = parcelRequire("5Uk5u");

var $bjzpQ = parcelRequire("bjzpQ");

var $5rcC8 = parcelRequire("5rcC8");

var $8hvNc = parcelRequire("8hvNc");

var $h3Yqq = parcelRequire("h3Yqq");

var $7ND3l = parcelRequire("7ND3l");
const $edd05bc884f6920f$export$c460318ed1ecaf23 = (props)=>{
    const executionContext = (0, $7ND3l.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $ezZWZ.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $33BOA.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $bjzpQ.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $bjzpQ.isExecutionContextSupported)(executionContext);
    (0, $4fqPo.useEffect)(()=>{
        // `executionContextKey` has to be the dependency of the useEffect
        // to set the shouldUiModificationsLoad state according to context changes
        // that is represented by the `executionContextKey`
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($edd05bc884f6920f$var$RootFragmentWithCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
/**
 * It is separated from
 * - `UiModificationsRootFragment` to run cleanup only when we know that we want to render UIM
 * - `RootFragment` to run cleanup imidiately without awaiting for the new Relay data when context changed
 */ const $edd05bc884f6920f$var$RootFragmentWithCleanup = (props)=>{
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $h3Yqq.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $4fqPo.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $4fqPo.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eD73h.ExecutionContextProvider), {
        value: executionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uk5u.TenantContextProvider), {
        value: tenantContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($edd05bc884f6920f$var$RootFragment, props))));
};
const $edd05bc884f6920f$var$RootFragment = ({ fragmentRef: fragmentRef, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    const response = (0, $gIeP2.useFragment)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $9RFdg.default), /* eslint-enable @atlassian/relay/unused-fields */ fragmentRef);
    const appsToRender = (0, $8hvNc.useAppsToRender)({
        data: response,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5rcC8.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});
parcelRegister("9RFdg", function(module, exports) {
$parcel$export(module.exports, "default", () => $015a0c6a8a37601a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<baa1aaa50bf33119a4147ac5c7847167>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $015a0c6a8a37601a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "forgeExtensionRenderingContext"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "uiModificationsContext"
            }
        ],
        "kind": "Fragment",
        "name": "fragment_AtlassianUiModificationsCore_RootFragment",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "context",
                                    "variableName": "uiModificationsContext"
                                }
                            ],
                            "concreteType": "JiraAppUiModifications",
                            "kind": "LinkedField",
                            "name": "uiModifications",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "appEnvId"
                                },
                                {
                                    "concreteType": "JiraUiModification",
                                    "kind": "LinkedField",
                                    "name": "uiModifications",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "data"
                                        }
                                    ]
                                }
                            ]
                        },
                        "action": "NONE"
                    },
                    {
                        "concreteType": "JiraForgeQuery",
                        "kind": "LinkedField",
                        "name": "forge",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "alias": "uiModificationsExtensions",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudId",
                                            "variableName": "cloudId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "context",
                                            "variableName": "forgeExtensionRenderingContext"
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "types",
                                            "value": [
                                                "jira:uiModifications"
                                            ]
                                        }
                                    ],
                                    "concreteType": "JiraForgeExtension",
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": true,
                                    "selections": [
                                        v0 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "appVersion"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "installationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "environmentKey"
                                        },
                                        {
                                            "concreteType": "JiraForgeExtensionLicense",
                                            "kind": "LinkedField",
                                            "name": "license",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "active"
                                                },
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "supportEntitlementNumber"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "trialEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subscriptionEndDate"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEvaluation"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "billingPeriod"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "ccpEntitlementSlug"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "capabilitySet"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "properties"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "scopes"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "concreteType": "JiraForgeAppEgressDeclaration",
                                            "kind": "LinkedField",
                                            "name": "egress",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "addresses"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "category"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "inScopeEUD"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraForgeInstallationConfigExtension",
                                            "kind": "LinkedField",
                                            "name": "installationConfig",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "consentUrl"
                                        },
                                        {
                                            "concreteType": "JiraUserAppAccess",
                                            "kind": "LinkedField",
                                            "name": "userAccess",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasAccess"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "enabled"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hiddenBy"
                                        }
                                    ]
                                },
                                "action": "NONE"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$015a0c6a8a37601a$var$node.hash = "ff48dbe4ed2ab636d857ff6d8fc8b30f";
var $015a0c6a8a37601a$export$2e2bcd8739ae039 = $015a0c6a8a37601a$var$node;

});

parcelRegister("eD73h", function(module, exports) {
$parcel$export(module.exports, "useExecutionContext", () => $08d6ac7d46e1d457$export$b0467ce6d1ed861f);
$parcel$export(module.exports, "ExecutionContextProvider", () => $08d6ac7d46e1d457$export$14f2a780bc6de643);

var $4fqPo = parcelRequire("4fqPo");
const $08d6ac7d46e1d457$export$7f8a924805594460 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $08d6ac7d46e1d457$export$b0467ce6d1ed861f = ()=>{
    const executionContext = (0, $4fqPo.useContext)($08d6ac7d46e1d457$export$7f8a924805594460);
    if (executionContext === null) throw new Error('executionContext value is null');
    return executionContext;
};
const $08d6ac7d46e1d457$export$14f2a780bc6de643 = ({ children: children, value: value })=>{
    if (!value) throw new Error('ExecutionContextProvider requires a value');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($08d6ac7d46e1d457$export$7f8a924805594460.Provider, {
        value: value
    }, children);
};

});

parcelRegister("ezZWZ", function(module, exports) {
$parcel$export(module.exports, "useViewType", () => $a03e236c02f02168$export$1568c16ff8af07a3);

var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");
const $a03e236c02f02168$export$1568c16ff8af07a3 = (0, $iouul.createStateHook)((0, $7pCjT.store), {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    selector: (state)=>state.viewType
});

});

parcelRegister("5Uk5u", function(module, exports) {
$parcel$export(module.exports, "useTenantContext", () => $2eff59b9745b7cbd$export$28e7c557f4d454d9);
$parcel$export(module.exports, "TenantContextProvider", () => $2eff59b9745b7cbd$export$e32355e80a92030c);

var $4fqPo = parcelRequire("4fqPo");
const $2eff59b9745b7cbd$var$TenantContext = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $2eff59b9745b7cbd$export$28e7c557f4d454d9 = ()=>{
    const tenantContext = (0, $4fqPo.useContext)($2eff59b9745b7cbd$var$TenantContext);
    if (tenantContext === null) throw new Error('tenantContext value is null');
    return tenantContext;
};
const $2eff59b9745b7cbd$export$e32355e80a92030c = ({ children: children, value: value })=>{
    if (!value) throw new Error('TenantContextProvider requires a value');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2eff59b9745b7cbd$var$TenantContext.Provider, {
        value: value
    }, children);
};

});

parcelRegister("5rcC8", function(module, exports) {
$parcel$export(module.exports, "AppsRenderer", () => $845129848cfe8fc3$export$d013b75640a90b27);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");

var $lhBYC = parcelRequire("lhBYC");

var $aNpmd = parcelRequire("aNpmd");

var $7RXLN = parcelRequire("7RXLN");
const $845129848cfe8fc3$export$d013b75640a90b27 = ({ ForgeAppRenderer: ForgeAppRenderer, apps: apps })=>{
    const [triggerFieldInitializationKey] = (0, $aNpmd.useTriggerFieldInitialization)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, apps.map(({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig })=>{
        const { appId: appId, environmentId: envId } = (0, $lhBYC.parseExtensionId)(forgeExtension.id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
            key: `${forgeExtension.id}-${triggerFieldInitializationKey}`,
            data: {
                attributes: {
                    appId: appId,
                    envId: envId
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7RXLN.SingleAppRenderer), {
            forgeExtension: forgeExtension,
            uiModificationsConfig: uiModificationsConfig,
            ForgeAppRenderer: ForgeAppRenderer
        }));
    }));
};

});
parcelRegister("lhBYC", function(module, exports) {
$parcel$export(module.exports, "parseExtensionId", () => $fbf2bc43e3838a09$export$bae42cbaf7fa3e1b);

var $9EDa8 = parcelRequire("9EDa8");
const $fbf2bc43e3838a09$export$bae42cbaf7fa3e1b = (extensionId)=>{
    const ari = (0, $9EDa8.parse)(extensionId);
    const [appId, environmentId, groupId, moduleKey] = ari.resourceId.split('/');
    return {
        appId: appId,
        environmentId: environmentId,
        groupId: groupId,
        moduleKey: moduleKey
    };
};

});
parcelRegister("9EDa8", function(module, exports) {
"use strict";
var $70763a55d841a481$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $70763a55d841a481$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gPOON = parcelRequire("gPOON");

$70763a55d841a481$var$__export((parcelRequire("bw5rj")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $70763a55d841a481$var$InvalidAriError = /** @class */ function(_super) {
    $70763a55d841a481$var$__extends(InvalidAriError, _super);
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $70763a55d841a481$var$InvalidAriError;
function $70763a55d841a481$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $70763a55d841a481$var$basicCharConstraint = $gPOON.pattern(/^[a-z][a-z.-]*$/);
var $70763a55d841a481$var$resourceOwnerConstraints = [
    $gPOON.lengthBetween(3, 255),
    $70763a55d841a481$var$basicCharConstraint
];
var $70763a55d841a481$var$resourceTypeConstraints = [
    $gPOON.lengthBetween(3, 255),
    $70763a55d841a481$var$basicCharConstraint
];
var $70763a55d841a481$var$cloudIdConstraints = [
    $gPOON.lengthBetween(36, 255)
];
var $70763a55d841a481$var$siteResourceType = 'site';
var $70763a55d841a481$var$resourceIdChars = /[\w-._~:@#]/.source;
var $70763a55d841a481$var$resourceIdConstraints = [
    $gPOON.pattern(new RegExp("^" + $70763a55d841a481$var$resourceIdChars + "+(/" + $70763a55d841a481$var$resourceIdChars + "*)*(;v=" + $70763a55d841a481$var$resourceIdChars + "*)*$"))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $70763a55d841a481$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $70763a55d841a481$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $70763a55d841a481$var$ResourceIdentifier = /** @class */ function() {
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ function ResourceIdentifier(values) {
        var _a = $70763a55d841a481$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $70763a55d841a481$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $70763a55d841a481$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $70763a55d841a481$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $70763a55d841a481$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $70763a55d841a481$var$parse(decodeURIComponent(encodedAriString));
    };
    /**
     * Converts this Ari to a string.
     */ ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $70763a55d841a481$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $70763a55d841a481$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    };
    /**
     * Converts this object to its json representation
     */ ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    };
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    };
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    };
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ ResourceIdentifier.prototype.matches = function(other) {
        return $70763a55d841a481$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $70763a55d841a481$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $70763a55d841a481$var$siteResourceType && !!other.resourceType || $70763a55d841a481$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $70763a55d841a481$var$siteResourceType && !!other.resourceType || $70763a55d841a481$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $70763a55d841a481$var$siteResourceType && !cloudId) return new $gPOON.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $gPOON.validateField(this, 'resourceOwner', $70763a55d841a481$var$resourceOwnerConstraints),
            $gPOON.validateField(this, 'resourceType', $70763a55d841a481$var$resourceTypeConstraints),
            $gPOON.validateField(this, 'resourceId', $70763a55d841a481$var$resourceIdConstraints),
            $gPOON.validateField(this, 'cloudId', $70763a55d841a481$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $70763a55d841a481$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $70763a55d841a481$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $70763a55d841a481$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $70763a55d841a481$var$parse(ariString) {
    return $70763a55d841a481$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $70763a55d841a481$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $70763a55d841a481$var$parseEncoded(encodedAriString) {
    return $70763a55d841a481$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $70763a55d841a481$var$parseEncoded;

});
parcelRegister("gPOON", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c418d43b1b2a3f58$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $c418d43b1b2a3f58$var$LengthConstraint;
var $c418d43b1b2a3f58$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $c418d43b1b2a3f58$var$RegexConstraint;
var $c418d43b1b2a3f58$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $c418d43b1b2a3f58$var$GeneralValidationError;
var $c418d43b1b2a3f58$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $c418d43b1b2a3f58$var$ConstraintViolation;
function $c418d43b1b2a3f58$var$lengthBetween(min, max) {
    return new $c418d43b1b2a3f58$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $c418d43b1b2a3f58$var$lengthBetween;
function $c418d43b1b2a3f58$var$pattern(regex) {
    return new $c418d43b1b2a3f58$var$RegexConstraint(regex);
}
module.exports.pattern = $c418d43b1b2a3f58$var$pattern;
function $c418d43b1b2a3f58$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $c418d43b1b2a3f58$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $c418d43b1b2a3f58$var$validateField;

});

parcelRegister("bw5rj", function(module, exports) {
"use strict";
var $8626e708ae9f61f4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c9IDF = parcelRequire("c9IDF");
var $8626e708ae9f61f4$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($8626e708ae9f61f4$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $8626e708ae9f61f4$var$AppFamilyAriError = /** @class */ function(_super) {
    $8626e708ae9f61f4$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $8626e708ae9f61f4$var$AppFamilyAriError;
var $8626e708ae9f61f4$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $8626e708ae9f61f4$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($8626e708ae9f61f4$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $8626e708ae9f61f4$var$NotAppFamilyAriError;
var $8626e708ae9f61f4$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $8626e708ae9f61f4$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($8626e708ae9f61f4$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $8626e708ae9f61f4$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $8626e708ae9f61f4$var$parseAppAri(ari) {
    return $c9IDF.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $8626e708ae9f61f4$var$parseAppAri;
function $8626e708ae9f61f4$var$createAppAri(json) {
    return new $c9IDF.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $8626e708ae9f61f4$var$createAppAri;

});
parcelRegister("c9IDF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bw5rj = parcelRequire("bw5rj");

var $9EDa8 = parcelRequire("9EDa8");
var $8d98f3a178cf703f$var$versionPrefix = ';v=';
var $8d98f3a178cf703f$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $bw5rj.AppFamilyAri.resourceOwner) throw new $bw5rj.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $bw5rj.AppFamilyAri.resourceOwner);
        if (!resourceType || $bw5rj.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $bw5rj.NotAppFamilyAriError(ari, "resourceType must be one of " + $bw5rj.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $bw5rj.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($8d98f3a178cf703f$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($8d98f3a178cf703f$var$versionPrefix) > versionIndex) throw new $bw5rj.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($8d98f3a178cf703f$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($8d98f3a178cf703f$var$stripToUndefined);
        if (segments.length > 4) throw new $bw5rj.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $bw5rj.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $bw5rj.AppFamilyAri.extensionGroupResourceType || resourceType === $bw5rj.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $bw5rj.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $bw5rj.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $bw5rj.AppFamilyAri.extensionResourceType);
        else if (resourceType === $bw5rj.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $bw5rj.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $bw5rj.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $bw5rj.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $bw5rj.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $bw5rj.AppFamilyAri.environmentResourceType);
        else if (resourceType === $bw5rj.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $bw5rj.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $bw5rj.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $bw5rj.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $bw5rj.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $8d98f3a178cf703f$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9EDa8.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bw5rj.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9EDa8.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bw5rj.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9EDa8.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bw5rj.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9EDa8.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bw5rj.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $8d98f3a178cf703f$var$AppFamilyAriImpl;
function $8d98f3a178cf703f$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});




parcelRegister("aNpmd", function(module, exports) {
$parcel$export(module.exports, "useTriggerFieldInitialization", () => $8b337094f65e675f$export$1c69013aaf9112f0);
// eslint-disable-next-line import/order

var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");
const $8b337094f65e675f$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $8b337094f65e675f$export$1c69013aaf9112f0 = (0, $iouul.createHook)((0, $7pCjT.store), {
    selector: $8b337094f65e675f$var$selectTriggerFieldInitializationKey
});

});

parcelRegister("7RXLN", function(module, exports) {
$parcel$export(module.exports, "SingleAppRenderer", () => $9651db53d39bdf24$export$53c5b0cb268c246d);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $bY08M = parcelRequire("bY08M");

var $lhBYC = parcelRequire("lhBYC");

var $bmfYr = parcelRequire("bmfYr");

var $2FyXQ = parcelRequire("2FyXQ");

var $eD73h = parcelRequire("eD73h");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $bjzpQ = parcelRequire("bjzpQ");

var $8Ez9y = parcelRequire("8Ez9y");

var $b2KVU = parcelRequire("b2KVU");

var $9rrYY = parcelRequire("9rrYY");

var $gpNIj = parcelRequire("gpNIj");

var $3Mljd = parcelRequire("3Mljd");
const $9651db53d39bdf24$export$53c5b0cb268c246d = ({ forgeExtension: forgeExtension, uiModificationsConfig: uiModificationsConfig, ForgeAppRenderer: ForgeAppRenderer })=>{
    const { scopes: moduleScopes, id: moduleId } = forgeExtension;
    const { setError: setError } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const viewType = (0, $ezZWZ.useViewType)();
    const executionContext = (0, $eD73h.useExecutionContext)();
    const extensionData = (0, $4fqPo.useMemo)(()=>(0, $3Mljd.buildExtensionData)(executionContext), [
        executionContext
    ]);
    const { appId: appId } = (0, $lhBYC.parseExtensionId)(moduleId);
    // This hook can be removed and replaced with `onTimeout` from LazyIframe once
    // https://ecosystem.atlassian.net/browse/BUILD-1617 is done. For now it approximates an
    // iframe timeout if the iframe doesn't use the custom bridge method needed by @forge/jira-bridge
    const { setLoadingComplete: setLoadingComplete } = (0, $b2KVU.useIframeTimeout)({
        forgeExtension: forgeExtension
    });
    const { customBridgeMethods: customBridgeMethods } = (0, $8Ez9y.useCustomBridgeMethods)({
        onBridgeCommunicationReceived: setLoadingComplete,
        uiModifications: uiModificationsConfig,
        moduleScopes: moduleScopes,
        appId: appId
    });
    const requiredScopesFound = (0, $9rrYY.useScopeChecks)(moduleScopes);
    const currentUIModificationsConsentStatus = (0, $bmfYr.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    (0, $4fqPo.useEffect)(()=>{
        if (!requiredScopesFound) {
            setError({
                errorCode: 'SCOPES_MISSING_ERROR_CODE'
            });
            setLoadingComplete();
            (0, $bjzpQ.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        requiredScopesFound,
        setError,
        setLoadingComplete,
        viewType
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (currentUIModificationsConsentStatus === (0, $2FyXQ.UIM_CONSENT_REQUIRED)) {
            setLoadingComplete();
            (0, $bjzpQ.getAnalytics)(viewType).cancelTTI();
        }
    }, [
        currentUIModificationsConsentStatus,
        setLoadingComplete,
        viewType
    ]);
    const consentProps = (0, $gpNIj.useThreeLOPromptProps)({
        forgeExtension: forgeExtension
    });
    if (!requiredScopesFound) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bY08M.default), {
        name: "single-frame-iframe",
        fallback: null,
        key: moduleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ForgeAppRenderer, {
        extension: forgeExtension,
        extensionData: extensionData,
        customBridgeMethods: customBridgeMethods,
        onIframeLoad: (0, $bjzpQ.getAnalytics)(viewType).markIframeLoad,
        isIframeResizable: false,
        isIframeHidden: true,
        ...consentProps
    }));
};

});
parcelRegister("8Ez9y", function(module, exports) {
$parcel$export(module.exports, "useCustomBridgeMethods", () => $7fd8175124d98f8a$export$88571489e690a256);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $jM2Ed = parcelRequire("jM2Ed");

var $8NxRl = parcelRequire("8NxRl");

var $k1Tu9 = parcelRequire("k1Tu9");

var $jxOvD = parcelRequire("jxOvD");

var $48kXT = parcelRequire("48kXT");

var $lHh3V = parcelRequire("lHh3V");

var $eZbrr = parcelRequire("eZbrr");
const $7fd8175124d98f8a$export$88571489e690a256 = ({ onBridgeCommunicationReceived: onBridgeCommunicationReceived, uiModifications: uiModifications, moduleScopes: moduleScopes = [], appId: appId })=>{
    const { onInitPromise: onInitPromise } = (0, $48kXT.useOnInit)({
        moduleScopes: moduleScopes
    });
    const subscribeToChanges = (0, $k1Tu9.useOnChangeSubscription)({
        uiModifications: uiModifications,
        moduleScopes: moduleScopes
    });
    const submit = (0, $eZbrr.useSubmit)({
        moduleScopes: moduleScopes,
        appId: appId
    });
    const registerFields = (0, $lHh3V.useRegisterFields)({
        appId: appId
    });
    const onBridgeError = (0, $8NxRl.useOnBridgeError)({
        appId: appId
    });
    const subscribeToErrors = (0, $jxOvD.useOnErrorSubscription)({
        appId: appId
    });
    const getInternalAPI = (0, $4fqPo.useCallback)(()=>{
        onBridgeCommunicationReceived === null || onBridgeCommunicationReceived === void 0 || onBridgeCommunicationReceived();
        return {
            data: {
                onInitChangeId: (0, $jM2Ed.ON_INIT_CHANGE_ID),
                uiModifications: uiModifications,
                featureFlags: {
                    // keep as true, we will also need to do the forge-bridge clean-up
                    // and wait for some period of time so the users will migrate to the version without this FG.
                    'forge-ui-modifications-screentabs_qoa33': true
                }
            },
            actions: {
                getOnInitData: ()=>onInitPromise,
                subscribeToChanges: subscribeToChanges,
                submit: submit,
                registerFields: registerFields,
                onBridgeError: onBridgeError,
                subscribeToErrors: subscribeToErrors
            }
        };
    }, [
        onBridgeCommunicationReceived,
        uiModifications,
        subscribeToChanges,
        submit,
        registerFields,
        onInitPromise,
        onBridgeError,
        subscribeToErrors
    ]);
    const customBridgeMethods = (0, $4fqPo.useMemo)(()=>({
            getUiModificationsInternalAPI: getInternalAPI
        }), // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
    // because the bridge consumes only the first version of it, if so clear the array deps to be [].
    [
        getInternalAPI
    ]);
    return {
        customBridgeMethods: customBridgeMethods
    };
};

});
parcelRegister("8NxRl", function(module, exports) {
$parcel$export(module.exports, "useOnBridgeError", () => $f6757b77aae0387d$export$7b14c142027ef2e2);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $p4u5f = parcelRequire("p4u5f");

var $8MIxg = parcelRequire("8MIxg");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $bjzpQ = parcelRequire("bjzpQ");

var $eYcAs = parcelRequire("eYcAs");
const $f6757b77aae0387d$var$isValidPayload = (payload)=>payload !== undefined && (0, (/*@__PURE__*/$parcel$interopDefault($p4u5f)))(payload) && (0, $eYcAs.BRIDGE_ERROR_TYPES).includes(payload.error) && (!payload.changeId || typeof payload.changeId === 'string');
const $f6757b77aae0387d$export$7b14c142027ef2e2 = ({ appId: appId })=>{
    const { setError: setError, unregisterFields: unregisterFields } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const viewType = (0, $ezZWZ.useViewType)();
    return (0, $4fqPo.useCallback)((payload)=>{
        if (!$f6757b77aae0387d$var$isValidPayload(payload)) return;
        const { changeId: changeId, error: error, cause: cause } = payload;
        if (changeId) unregisterFields({
            changeId: changeId,
            appId: appId
        });
        setError({
            errorCode: 'ON_BRIDGE_ERROR_ERROR_CODE'
        });
        (0, $bjzpQ.getAnalytics)(viewType).stopTTI({
            completionStatus: 'error',
            viewType: viewType
        });
        const UIMLoggableError = new Error(`An ${error} occurred in the UI Modifications code in the Jira Bridge`, {
            cause: cause
        });
        (0, $8MIxg.fireErrorAnalytics)({
            error: UIMLoggableError,
            id: 'UIModificationsJiraBridge',
            viewType: viewType,
            attributes: {
                type: error,
                cause: cause
            }
        });
    }, [
        setError,
        unregisterFields,
        viewType,
        appId
    ]);
};

});
parcelRegister("eYcAs", function(module, exports) {
$parcel$export(module.exports, "BRIDGE_ERROR_TYPES", () => $3e6c3ca0c3eeaef1$export$7845535459d8a620);
const $3e6c3ca0c3eeaef1$export$6634aa68b37142fc = 'onInitError';
const $3e6c3ca0c3eeaef1$export$7ab66e58aded6116 = 'subscribeToChangesError';
const $3e6c3ca0c3eeaef1$export$3018e0c759270938 = 'getApiError';
const $3e6c3ca0c3eeaef1$export$7845535459d8a620 = [
    $3e6c3ca0c3eeaef1$export$6634aa68b37142fc,
    $3e6c3ca0c3eeaef1$export$7ab66e58aded6116,
    $3e6c3ca0c3eeaef1$export$3018e0c759270938
];

});


parcelRegister("k1Tu9", function(module, exports) {
$parcel$export(module.exports, "useOnChangeSubscription", () => $724c020b67224abd$export$785e6020792a124f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $cM1tn = parcelRequire("cM1tn");

var $1S4mU = parcelRequire("1S4mU");

var $amyIs = parcelRequire("amyIs");

var $ezZWZ = parcelRequire("ezZWZ");

var $90swm = parcelRequire("90swm");

var $fv4ea = parcelRequire("fv4ea");
const $724c020b67224abd$export$785e6020792a124f = ({ uiModifications: uiModifications, moduleScopes: moduleScopes })=>{
    const viewType = (0, $ezZWZ.useViewType)();
    const notifyAppRef = (0, $4fqPo.useRef)(null);
    const { lastProcessedChange: lastProcessedChange } = (0, $amyIs.useLastProcessedChange)();
    const { currentFormState: currentFormState, currentScreenTabsState: currentScreenTabsState } = (0, $1S4mU.useCurrentFormState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    /**
   * Single ref for all data that must be up-to-date but not trigger notification.
   */ const dataRef = (0, $4fqPo.useRef)({
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    });
    dataRef.current = {
        currentFormState: currentFormState,
        currentScreenTabsState: currentScreenTabsState,
        uiModifications: uiModifications,
        moduleScopes: moduleScopes,
        viewType: viewType
    };
    (0, $4fqPo.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if (notifyApp === null || lastProcessedChange === null) return;
        const changeId = lastProcessedChange.changeId;
        notifyApp({
            changedFieldId: lastProcessedChange.fieldId,
            changeId: changeId,
            currentFormState: (0, $90swm.filterFormDataBasedOnScopes)(dataRef.current.currentFormState, dataRef.current.viewType, dataRef.current.moduleScopes),
            currentScreenTabsState: (0, $fv4ea.filterScreenTabsBasedOnReadScopes)(dataRef.current.moduleScopes, dataRef.current.currentScreenTabsState),
            uiModifications: dataRef.current.uiModifications
        });
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'change',
                viewType: dataRef.current.viewType
            }
        });
    }, [
        viewType,
        createAnalyticsEvent,
        lastProcessedChange
    ]);
    return (0, $4fqPo.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("1S4mU", function(module, exports) {
$parcel$export(module.exports, "useCurrentFormState", () => $6d20284a4fc024ab$export$655680d54d70050d);

var $6VEbB = parcelRequire("6VEbB");
var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");
const $6d20284a4fc024ab$var$stableEmpty = {};
const $6d20284a4fc024ab$var$stableEmptyScreenTabsArrray = [];
const $6d20284a4fc024ab$var$selectCurrentFormState = (0, $6VEbB.createSelector)((state)=>state.formData, (state)=>state.screenTabs, (formData, screenTabs)=>{
    if (formData !== null) return {
        currentFormState: formData,
        currentScreenTabsState: screenTabs || $6d20284a4fc024ab$var$stableEmptyScreenTabsArrray
    };
    return {
        currentFormState: $6d20284a4fc024ab$var$stableEmpty,
        currentScreenTabsState: $6d20284a4fc024ab$var$stableEmptyScreenTabsArrray
    };
});
const $6d20284a4fc024ab$export$655680d54d70050d = (0, $iouul.createStateHook)((0, $7pCjT.store), {
    selector: $6d20284a4fc024ab$var$selectCurrentFormState
});

});

parcelRegister("amyIs", function(module, exports) {
$parcel$export(module.exports, "useLastProcessedChange", () => $892e6ee29f1f924d$export$e5124fbd2a3221d);

var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");
const $892e6ee29f1f924d$export$e5124fbd2a3221d = (0, $iouul.createStateHook)((0, $7pCjT.store), {
    // We need to wrap the selected slice of state to overcome react-sweet-state useHook with selector issue.
    // We rely on the strict equality of lastUserTriggeredChange (the structure of this object
    // will not change on consecutive updates to a given field but the reference will)
    // https://github.com/atlassian/react-sweet-state/issues/167
    selector: (state)=>({
            lastProcessedChange: state.lastProcessedChange
        })
});

});

parcelRegister("90swm", function(module, exports) {
$parcel$export(module.exports, "filterFormDataBasedOnScopes", () => $66015eacc6265ab7$export$cd9f8248b807046e);
$parcel$export(module.exports, "filterFieldsChangesBasedOnScopes", () => $66015eacc6265ab7$export$51fbc854b278b1ff);

var $bjzpQ = parcelRequire("bjzpQ");
const $66015eacc6265ab7$export$4596199abc4d582e = (viewType, fieldType, moduleScopes)=>{
    var _getSupportedFieldCon;
    const fieldRequiredScopes = (_getSupportedFieldCon = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType)) === null || _getSupportedFieldCon === void 0 ? void 0 : _getSupportedFieldCon.requiredScopes;
    if (!fieldRequiredScopes) return true;
    const includeCoarseScopes = ()=>fieldRequiredScopes.coarse.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
    const includeGranularScopes = ()=>fieldRequiredScopes.granular.length && // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - requiredScope is not types on CI somehow
        fieldRequiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
    return includeCoarseScopes() || includeGranularScopes();
};
const $66015eacc6265ab7$export$cd9f8248b807046e = (formData, viewType, moduleScopes)=>{
    const formDataAsArray = Object.entries(formData);
    const filteredFormDataArray = formDataAsArray.filter(([_, value])=>{
        if (!(value !== null && value !== void 0 && value.fieldType)) return false;
        const { fieldType: fieldType } = value;
        return $66015eacc6265ab7$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFormDataArray);
};
const $66015eacc6265ab7$export$51fbc854b278b1ff = (fieldsChanges, formData, viewType, moduleScopes)=>{
    const fieldsChangesAsArray = Object.entries(fieldsChanges);
    const filteredFieldsChangesArray = fieldsChangesAsArray.filter(([fieldId])=>{
        const field = formData[fieldId];
        const fieldType = field === null || field === void 0 ? void 0 : field.fieldType;
        if (!fieldType) return false;
        return $66015eacc6265ab7$export$4596199abc4d582e(viewType, fieldType, moduleScopes);
    });
    return Object.fromEntries(filteredFieldsChangesArray);
};

});

parcelRegister("fv4ea", function(module, exports) {
$parcel$export(module.exports, "filterScreenTabsBasedOnReadScopes", () => $22cf10b4f26322a5$export$e0e73d6641eefd01);
$parcel$export(module.exports, "moduleIncludesScreenTabsWriteScopes", () => $22cf10b4f26322a5$export$6a622a0cc96dcad7);

var $cM1tn = parcelRequire("cM1tn");

var $gKs5m = parcelRequire("gKs5m");
const $22cf10b4f26322a5$var$includeCoarseScopes = (requiredScopes, moduleScopes)=>requiredScopes.coarse.length > 0 && requiredScopes.coarse.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $22cf10b4f26322a5$var$includeGranularScopes = (requiredScopes, moduleScopes)=>requiredScopes.granular.length > 0 && requiredScopes.granular.every((requiredScope)=>moduleScopes.includes(requiredScope));
const $22cf10b4f26322a5$export$e0e73d6641eefd01 = (moduleScopes, screenTabs)=>{
    if ($22cf10b4f26322a5$var$includeCoarseScopes((0, $gKs5m.baseRequiredReadScopes), moduleScopes) || $22cf10b4f26322a5$var$includeGranularScopes((0, $gKs5m.baseRequiredReadScopes), moduleScopes)) return screenTabs;
    return [];
};
const $22cf10b4f26322a5$export$6a622a0cc96dcad7 = (viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)=>{
    if ($22cf10b4f26322a5$var$includeCoarseScopes((0, $gKs5m.baseRequiredWriteScopes), moduleScopes) || $22cf10b4f26322a5$var$includeGranularScopes((0, $gKs5m.baseRequiredWriteScopes), moduleScopes)) return true;
    if (Array.isArray(screenTabsChanges) && screenTabsChanges.length > 0) (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'missingScope',
        actionSubject: 'jiraUiModifications.screenTabs',
        attributes: {
            access: 'write',
            viewType: viewType
        }
    });
    return false;
};

});
parcelRegister("gKs5m", function(module, exports) {
$parcel$export(module.exports, "baseRequiredReadScopes", () => $b31f53840d1834b3$export$a6bf7d335c3c7d7f);
$parcel$export(module.exports, "baseRequiredWriteScopes", () => $b31f53840d1834b3$export$1f346456d218ce0a);
// for reference: https://developer.atlassian.com/cloud/jira/platform/rest/v3/api-group-screen-tabs/#api-group-screen-tabs
const $b31f53840d1834b3$export$a6bf7d335c3c7d7f = {
    granular: [
        'read:screen-tab:jira'
    ],
    coarse: [
        'read:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};
const $b31f53840d1834b3$export$1f346456d218ce0a = {
    granular: [
        'write:screen-tab:jira'
    ],
    coarse: [
        'write:jira-work',
        'manage:jira-configuration',
        'manage:jira-project'
    ]
};

});



parcelRegister("jxOvD", function(module, exports) {
$parcel$export(module.exports, "useOnErrorSubscription", () => $7583285b286bcf6b$export$97d35fd8c60375e4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $5j9vJ = parcelRequire("5j9vJ");

var $ew3Bn = parcelRequire("ew3Bn");

var $cM1tn = parcelRequire("cM1tn");

var $6u67Z = parcelRequire("6u67Z");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");
const $7583285b286bcf6b$export$97d35fd8c60375e4 = ({ appId: appId })=>{
    const viewType = (0, $ezZWZ.useViewType)();
    const notifyAppRef = (0, $4fqPo.useRef)(null);
    const { appErrors: appErrors } = (0, $6u67Z.useAppErrors)({
        appId: appId
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { resetAppErrors: resetAppErrors } = (0, $7pCjT.useIssueAdjustmentsActions)();
    (0, $4fqPo.useEffect)(()=>{
        const notifyApp = notifyAppRef.current;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($5j9vJ)))(appId) || notifyApp === null || appErrors === null) return;
        notifyApp({
            errors: appErrors
        });
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'appError',
                viewType: viewType
            }
        });
        resetAppErrors({
            appId: appId
        });
    }, [
        createAnalyticsEvent,
        resetAppErrors,
        appErrors,
        appId,
        viewType
    ]);
    return (0, $4fqPo.useCallback)((callback)=>{
        notifyAppRef.current = callback;
    }, []);
};

});
parcelRegister("6u67Z", function(module, exports) {
$parcel$export(module.exports, "useAppErrors", () => $1d8889518266a5a9$export$535312244836989b);

var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");
const $1d8889518266a5a9$export$535312244836989b = (0, $iouul.createStateHook)((0, $7pCjT.store), {
    selector: (state, { appId: appId })=>({
            appErrors: state.appsErrors[appId] ?? null
        })
});

});


parcelRegister("48kXT", function(module, exports) {
$parcel$export(module.exports, "useOnInit", () => $4a70b9bbce5230d7$export$e09230681aa762b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $cM1tn = parcelRequire("cM1tn");

var $1LxrH = parcelRequire("1LxrH");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $bjzpQ = parcelRequire("bjzpQ");

var $90swm = parcelRequire("90swm");

var $fv4ea = parcelRequire("fv4ea");
const $4a70b9bbce5230d7$var$successTabsInitialisation = (createAnalyticsEvent, viewType, screenTabsData)=>{
    if (screenTabsData.length) (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.screenTabsInitialization',
        attributes: {
            initializedTabsCount: screenTabsData.length,
            viewType: viewType
        }
    });
};
const $4a70b9bbce5230d7$export$e09230681aa762b4 = ({ moduleScopes: moduleScopes })=>{
    const resolveOnInitPromise = (0, $4fqPo.useRef)(null);
    const viewType = (0, $ezZWZ.useViewType)();
    const publicUIMDataForApp = (0, $1LxrH.useReadyPublicDataForOnInit)({
        viewType: viewType
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { successFieldsInitalisation: successFieldsInitalisation } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const onInitPromise = (0, $4fqPo.useMemo)(()=>{
        const promise = new Promise((resolve)=>{
            resolveOnInitPromise.current = resolve;
        });
        promise.then(()=>{
            // It cleans the resolveOnInitPromise to avoid calling the body
            // of the below useEffect after the onInit being resolved once.
            resolveOnInitPromise.current = null;
        });
        return promise;
    }, []);
    (0, $4fqPo.useEffect)(()=>{
        const handleChange = resolveOnInitPromise.current;
        if (publicUIMDataForApp === null || handleChange === null) return;
        const payload = {
            currentFormState: (0, $90swm.filterFormDataBasedOnScopes)(publicUIMDataForApp.formData, viewType, moduleScopes),
            currentScreenTabsState: (0, $fv4ea.filterScreenTabsBasedOnReadScopes)(moduleScopes, publicUIMDataForApp.screenTabsData)
        };
        handleChange(payload);
        successFieldsInitalisation({
            createAnalyticsEvent: createAnalyticsEvent
        });
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.appNotification',
            attributes: {
                lifecycleEvent: 'init',
                viewType: viewType
            }
        });
        $4a70b9bbce5230d7$var$successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
        (0, $bjzpQ.getAnalytics)(viewType).markOnInitResolved();
    }, [
        successFieldsInitalisation,
        createAnalyticsEvent,
        publicUIMDataForApp,
        moduleScopes,
        viewType
    ]);
    return {
        onInitPromise: onInitPromise
    };
};

});
parcelRegister("1LxrH", function(module, exports) {
$parcel$export(module.exports, "useReadyPublicDataForOnInit", () => $0855de6a6b36288e$export$484a467ba25fea19);

var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");

var $2hC9Y = parcelRequire("2hC9Y");
const $0855de6a6b36288e$export$484a467ba25fea19 = (0, $iouul.createStateHook)((0, $7pCjT.store), {
    selector: (0, $2hC9Y.selectReadyPublicDataForOnInit)
});

});


parcelRegister("lHh3V", function(module, exports) {
$parcel$export(module.exports, "useRegisterFields", () => $40801924e9111e6e$export$fe9a0f40214d6955);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $bjzpQ = parcelRequire("bjzpQ");
const $40801924e9111e6e$export$fe9a0f40214d6955 = ({ appId: appId })=>{
    const { setError: setError, registerFields: registerFields } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const viewType = (0, $ezZWZ.useViewType)();
    return (0, $4fqPo.useCallback)(async ({ fields: fields, changeId: changeId })=>{
        try {
            // We want to register only fields that are strings.
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const validFieldIds = fields.filter((fieldId)=>typeof fieldId === 'string');
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            if (typeof changeId === 'string') registerFields({
                changeId: changeId,
                fieldsToBeRegistered: validFieldIds,
                appId: appId
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_REGISTER_FIELDS_ERROR_CODE'
            });
            throw err;
        } finally{
            (0, $bjzpQ.getAnalytics)(viewType).markFieldsRegistered();
        }
    }, [
        appId,
        registerFields,
        setError,
        viewType
    ]);
};

});

parcelRegister("eZbrr", function(module, exports) {
$parcel$export(module.exports, "useSubmit", () => $0bb5f743a3723233$export$47c85c6e3a081d3);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");

var $ew3Bn = parcelRequire("ew3Bn");

var $3H4LK = parcelRequire("3H4LK");

var $8MIxg = parcelRequire("8MIxg");
var $cM1tn = parcelRequire("cM1tn");
var $4bd70 = parcelRequire("4bd70");

var $jM2Ed = parcelRequire("jM2Ed");

var $34ioR = parcelRequire("34ioR");

var $eD73h = parcelRequire("eD73h");

var $7upYi = parcelRequire("7upYi");

var $chPvB = parcelRequire("chPvB");

var $amyIs = parcelRequire("amyIs");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $7PG1r = parcelRequire("7PG1r");

var $5Uk5u = parcelRequire("5Uk5u");

var $bjzpQ = parcelRequire("bjzpQ");

var $fv4ea = parcelRequire("fv4ea");

var $kM60e = parcelRequire("kM60e");

var $lQhrj = parcelRequire("lQhrj");
const $0bb5f743a3723233$export$47c85c6e3a081d3 = ({ moduleScopes: moduleScopes, appId: appId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { updateFields: updateFields, setError: setError, unregisterFields: unregisterFields, setAppErrors: setAppErrors, updateScreenTabs: updateScreenTabs, detectAppliedChangesConflicts: detectAppliedChangesConflicts } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const viewType = (0, $ezZWZ.useViewType)();
    const getAsyncLookupData = (0, $7upYi.useLookupFieldData)();
    const getFilteredFieldChangesBasedOnScope = (0, $lQhrj.useFilterFieldChangesBasedOnScope)(moduleScopes);
    const tenantContext = (0, $5Uk5u.useTenantContext)();
    const executionContext = (0, $eD73h.useExecutionContext)();
    const environment = (0, $gIeP2.useRelayEnvironment)();
    const getValidatedFieldsChanges = (0, $kM60e.useFieldsChangesValidation)();
    const { lastProcessedChange: lastProcessedChange } = (0, $amyIs.useLastProcessedChange)();
    const lastChangedProcessRef = (0, $4fqPo.useRef)(lastProcessedChange);
    const formMetadata = (0, $chPvB.useFormMetadata)();
    const formMetadataRef = (0, $4fqPo.useRef)(formMetadata);
    formMetadataRef.current = formMetadata;
    (0, $4fqPo.useEffect)(()=>{
        lastChangedProcessRef.current = lastProcessedChange;
    }, [
        lastProcessedChange
    ]);
    const intl = (0, $4MCQn.default)();
    const getFieldAttributesForAnalytics = (0, $4fqPo.useCallback)((fieldsChanges)=>{
        try {
            const fieldAttributes = [];
            for(const fieldId in fieldsChanges){
                var _formMetadataRef$curr;
                if ((_formMetadataRef$curr = formMetadataRef.current) !== null && _formMetadataRef$curr !== void 0 && _formMetadataRef$curr[fieldId]) {
                    const { fieldType: fieldType } = formMetadataRef.current[fieldId];
                    const attributes = Object.keys(fieldsChanges[fieldId]);
                    fieldAttributes.push({
                        fieldType: fieldType,
                        attributes: attributes
                    });
                }
            }
            return JSON.stringify(fieldAttributes);
        // oxlint-disable-next-line no-unused-vars
        } catch (_error) {
            return 'NULL';
        }
    }, []);
    return (0, $4fqPo.useCallback)(async ({ fieldsChanges: fieldsChangesUnnormalized, screenTabsChanges: screenTabsChanges, changeId: changeId })=>{
        let isSameFieldValueChanged = false;
        let fieldType = null;
        // When the gate is on, name the event after the canonical viewType (so overlay
        // traffic lands in the same bucket) and move the real viewType into attributes
        // so we still know exactly where we are.
        const isAnalyticsViewTypeEnabled = (0, $3H4LK.fg)('uim-analytics-view-type-attribute');
        const analyticsViewType = isAnalyticsViewTypeEnabled && executionContext.analyticsViewType ? executionContext.analyticsViewType : viewType;
        try {
            var _lastChangedProcessRe, _formMetadataRef$curr2;
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await updateFields({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: // TODO: We should pass validatedFieldsChanges instead of fieldsChanges, UIM-2214
                lookupDataFromApi,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                appId: appId,
                intl: intl,
                createAnalyticsEvent: createAnalyticsEvent
            });
            if (screenTabsChanges && (0, $fv4ea.moduleIncludesScreenTabsWriteScopes)(viewType, createAnalyticsEvent, moduleScopes, screenTabsChanges)) updateScreenTabs({
                screenTabsChanges: screenTabsChanges,
                appId: appId,
                changeId: changeId
            });
            detectAppliedChangesConflicts({
                appId: appId,
                changeId: changeId
            });
            (0, $bjzpQ.getAnalytics)(viewType).stopTTI({
                completionStatus: 'success',
                viewType: viewType
            });
            isSameFieldValueChanged = (0, $34ioR.checkSameFieldValueChanged)(fieldsChanges, lastChangedProcessRef.current, changeId);
            if ((_lastChangedProcessRe = lastChangedProcessRef.current) !== null && _lastChangedProcessRe !== void 0 && _lastChangedProcessRe.fieldId && (_formMetadataRef$curr2 = formMetadataRef.current) !== null && _formMetadataRef$curr2 !== void 0 && _formMetadataRef$curr2[lastChangedProcessRef.current.fieldId]) {
                const fieldId = lastChangedProcessRef.current.fieldId;
                const { fieldType: fieldTypeFromFormMetadata } = formMetadataRef.current[fieldId];
                fieldType = fieldTypeFromFormMetadata;
            }
            (0, $4bd70.fireTrackEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: `${analyticsViewType}jiraUiModificationsUseSubmit`,
                attributes: {
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $jM2Ed.ON_INIT_CHANGE_ID),
                    fieldType: fieldType,
                    submittedFields: getFieldAttributesForAnalytics(fieldsChanges),
                    ...isAnalyticsViewTypeEnabled && {
                        viewType: viewType
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setError({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            });
            (0, $bjzpQ.getAnalytics)(viewType).stopTTI({
                completionStatus: 'error',
                viewType: viewType
            });
            if (err instanceof (0, $7PG1r.UiModificationsValidationError)) {
                (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'failed',
                    actionSubject: 'jiraUiModifications.changesValidation',
                    attributes: {
                        type: err.validationErrorType,
                        ...err.attributes,
                        viewType: viewType
                    }
                });
                // Setting app errors to pass them to the onErrorCallback
                setAppErrors({
                    errors: err.attributes.errors,
                    appId: appId
                });
                return;
            }
            (0, $8MIxg.fireErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                analyticsViewType: analyticsViewType,
                attributes: {
                    errorCause: err === null || err === void 0 ? void 0 : err.cause,
                    isSameFieldValueChanged: isSameFieldValueChanged,
                    isOnInit: changeId === (0, $jM2Ed.ON_INIT_CHANGE_ID),
                    fieldType: fieldType
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            unregisterFields({
                changeId: changeId,
                appId: appId
            });
        }
    }, [
        getFilteredFieldChangesBasedOnScope,
        getValidatedFieldsChanges,
        getAsyncLookupData,
        updateFields,
        tenantContext,
        executionContext,
        environment,
        appId,
        intl,
        viewType,
        createAnalyticsEvent,
        moduleScopes,
        updateScreenTabs,
        detectAppliedChangesConflicts,
        setError,
        setAppErrors,
        unregisterFields,
        getFieldAttributesForAnalytics
    ]);
};

});
parcelRegister("4bd70", function(module, exports) {
$parcel$export(module.exports, "fireTrackEvent", () => $1ad8fd114aa9f5fd$export$574d2f19a52d67ca);

var $jQXWT = parcelRequire("jQXWT");

var $gHT3x = parcelRequire("gHT3x");

var $60Y3D = parcelRequire("60Y3D");
const $1ad8fd114aa9f5fd$export$574d2f19a52d67ca = (createAnalyticsEvent, eventPayload)=>{
    (0, $jQXWT.default)((0, $60Y3D.UI_MODIFICATIONS_ANALYTICS_CHANNEL))({
        ...eventPayload,
        analyticsType: (0, $gHT3x.TRACK_EVENT_TYPE)
    })(createAnalyticsEvent);
};

});

parcelRegister("7upYi", function(module, exports) {
$parcel$export(module.exports, "useLookupFieldData", () => $2d83810551c3f494$export$d43e9e394c54e784);

var $4fqPo = parcelRequire("4fqPo");

var $1qNjk = parcelRequire("1qNjk");

var $gIeP2 = parcelRequire("gIeP2");

var $ew3Bn = parcelRequire("ew3Bn");

var $jBMwY = parcelRequire("jBMwY");

var $66L7M = parcelRequire("66L7M");

var $aDxyy = parcelRequire("aDxyy");

var $d3fZJ = parcelRequire("d3fZJ");

var $57BeY = parcelRequire("57BeY");

var $chPvB = parcelRequire("chPvB");

var $ezZWZ = parcelRequire("ezZWZ");

var $5Uk5u = parcelRequire("5Uk5u");

var $bjzpQ = parcelRequire("bjzpQ");
const $2d83810551c3f494$export$d43e9e394c54e784 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $5Uk5u.useTenantContext)();
    const environment = (0, $gIeP2.useRelayEnvironment)();
    const formMetadata = (0, $chPvB.useFormMetadata)();
    const formMetadataRef = (0, $4fqPo.useRef)(formMetadata);
    const viewType = (0, $ezZWZ.useViewType)();
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    return (0, $4fqPo.useCallback)(async (fieldsChanges)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const lookupData = {};
        const asyncFieldsValues = Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldData])=>{
            if (!formMetadataRef.current[fieldId]) return acc;
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValue = fieldData.value;
            const supportedFieldsConfiguration = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType);
            const lookupSource = supportedFieldsConfiguration === null || supportedFieldsConfiguration === void 0 ? void 0 : supportedFieldsConfiguration.lookupSource;
            const isUserLookupField = lookupSource === (0, $jBMwY.LOOKUP_SOURCE_USERS_ASYNC_DATA);
            const isProjectLookupField = lookupSource === (0, $jBMwY.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA);
            if (isUserLookupField && fieldValue && (0, $66L7M.isNotAutomaticId)(fieldValue)) {
                const currentAccountIds = acc.accountIds ? [
                    ...acc.accountIds
                ] : [];
                const newAccountIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.accountIds = [
                    ...currentAccountIds,
                    ...newAccountIds
                ];
            }
            if (isProjectLookupField && fieldValue) {
                const currentProjectIds = acc.projectIds ? [
                    ...acc.projectIds
                ] : [];
                const newProjectIds = Array.isArray(fieldValue) ? fieldValue : [
                    fieldValue
                ];
                acc.projectIds = [
                    ...currentProjectIds,
                    ...newProjectIds
                ];
            }
            /** Add extra checks to add other lookup type e.g. issues lookup */ return acc;
        }, {});
        let users = [];
        let projects = [];
        if (asyncFieldsValues.accountIds) {
            const uniqueAccountIds = (0, (/*@__PURE__*/$parcel$interopDefault($1qNjk)))(asyncFieldsValues.accountIds);
            users = await (0, $57BeY.fetchUsers)(environment, uniqueAccountIds, createAnalyticsEvent);
        }
        if (asyncFieldsValues.projectIds) {
            const uniqueProjectIds = (0, (/*@__PURE__*/$parcel$interopDefault($1qNjk)))(asyncFieldsValues.projectIds);
            // Convert numeric project IDs to ARIs before fetching
            // GraphQL expects ARIs like "ari:cloud:jira:{cloudId}:project/10001", not plain "10001"
            const projectAris = (0, $aDxyy.convertProjectIdsToAris)(uniqueProjectIds, cloudId);
            projects = await (0, $d3fZJ.fetchProjects)(environment, projectAris, createAnalyticsEvent);
        }
        lookupData[0, $jBMwY.LOOKUP_SOURCE_USERS_ASYNC_DATA] = users;
        lookupData[0, $jBMwY.LOOKUP_SOURCE_PROJECTS_ASYNC_DATA] = projects;
        return lookupData;
    }, [
        createAnalyticsEvent,
        viewType,
        environment,
        cloudId
    ]);
};

});
parcelRegister("aDxyy", function(module, exports) {
$parcel$export(module.exports, "convertProjectIdsToAris", () => $75adce7f2a48c699$export$2a73bd4f6cc71a00);
/**
 * Converts a project ID to a Jira project ARI.
 *
 * @param projectId - The project ID (numeric string like "10001" or already an ARI)
 * @param cloudId - The cloud/tenant ID
 * @returns The full project ARI in format "ari:cloud:jira:{cloudId}:project/{projectId}"
 *
 * @example
 * ```typescript
 * convertProjectIdToAri("10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001"
 *
 * convertProjectIdToAri("ari:cloud:jira:abc-123-def:project/10001", "abc-123-def")
 * // returns: "ari:cloud:jira:abc-123-def:project/10001" (unchanged)
 * ```
 */ const $75adce7f2a48c699$export$fee909b034ddb326 = (projectId, cloudId)=>{
    // If already an ARI, return as-is
    if (projectId.startsWith('ari:')) return projectId;
    // Convert numeric project ID to ARI format
    return `ari:cloud:jira:${cloudId}:project/${projectId}`;
};
const $75adce7f2a48c699$export$2a73bd4f6cc71a00 = (projectIds, cloudId)=>{
    return projectIds.map((id)=>$75adce7f2a48c699$export$fee909b034ddb326(id, cloudId));
};

});

parcelRegister("d3fZJ", function(module, exports) {
$parcel$export(module.exports, "fetchProjects", () => $abe894b91209bc7b$export$f0d2ca471cdb99b0);

var $e3ZXH = parcelRequire("e3ZXH");

var $gIeP2 = parcelRequire("gIeP2");

var $cM1tn = parcelRequire("cM1tn");

var $gwkYa = parcelRequire("gwkYa");
const $abe894b91209bc7b$export$f0d2ca471cdb99b0 = async (environment, projectIds, createAnalyticsEvent)=>{
    try {
        var _response$jira;
        const apiStartTime = performance.now();
        const response = await (0, $gIeP2.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $e3ZXH.default), {
            projectIds: projectIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && (_response$jira = response.jira) !== null && _response$jira !== void 0 && _response$jira.jiraProjects)) throw new (0, $gwkYa.ErrorWithStatusCode)('[fetch-projects service] [fetchProjectsQuery]: Property jira.jiraProjects does not exist.', {
            cause: 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY'
        }, 'FETCH_PROJECTS_MISSING_PROJECTS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchProjects',
            attributes: {
                projectsAPILatency: apiLatencyMs
            }
        });
        return response.jira.jiraProjects.filter((project)=>project !== null && project !== undefined && project.projectId !== null && project.projectId !== undefined).map((project)=>{
            var _project$avatar;
            return {
                // Use projectId (numeric ID like "10001"), not id (ARI)
                id: project.projectId,
                key: project.key,
                name: project.name,
                avatarUrls: {
                    '48x48': ((_project$avatar = project.avatar) === null || _project$avatar === void 0 ? void 0 : _project$avatar.large) || ''
                }
            };
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_PROJECTS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("e3ZXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $82cfa1dc11465b59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63bd7a4e2ee2e0f9a2be5f0889617550>>
 * @relayHash 8dddd1ce7676474299e324ca788770e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e
const $82cfa1dc11465b59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectIds"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ids",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "jiraProjects",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "projectId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchProjectsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "a35fab1f4b197bcbd5d89a2b7aad018babad3896f53037c9777e0ba46e3a367e",
            "metadata": {},
            "name": "fetchProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$82cfa1dc11465b59$var$node.hash = "bfbd83d6cfdfb7072506c62a347912b6";
var $82cfa1dc11465b59$export$2e2bcd8739ae039 = $82cfa1dc11465b59$var$node;

});

parcelRegister("gwkYa", function(module, exports) {
$parcel$export(module.exports, "ErrorWithStatusCode", () => $e93cc85d489e122d$export$13144d723cf04c);
class $e93cc85d489e122d$export$13144d723cf04c extends Error {
    constructor(message, options, statusCode){
        super(message, options);
        this.statusCode = statusCode;
    }
}

});


parcelRegister("57BeY", function(module, exports) {
$parcel$export(module.exports, "fetchUsers", () => $85a088fd65899a79$export$2bb8333a9210be15);

var $k2FEz = parcelRequire("k2FEz");

var $gIeP2 = parcelRequire("gIeP2");

var $cM1tn = parcelRequire("cM1tn");

var $gwkYa = parcelRequire("gwkYa");
const $85a088fd65899a79$export$2bb8333a9210be15 = async (environment, accountIds, createAnalyticsEvent)=>{
    try {
        const apiStartTime = performance.now();
        const response = await (0, $gIeP2.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields */ (0, $k2FEz.default), {
            accountIds: accountIds
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!(response !== null && response !== void 0 && response.users)) throw new (0, $gwkYa.ErrorWithStatusCode)('[fetch-users service] [fetchUsersQuery]: Property users does not exist.', {
            cause: 'FETCH_USERS_MISSING_USERS_PROPERTY'
        }, 'FETCH_USERS_MISSING_USERS_PROPERTY');
        const apiLatencyMs = Math.floor(performance.now() - apiStartTime);
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModificationsFetchUsers',
            attributes: {
                usersAPILatency: apiLatencyMs
            }
        });
        return [
            ...response.users
        ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        if (!err.cause) err.cause = 'FETCH_USERS_UNKNOWN_ERROR';
        throw err;
    }
};

});
parcelRegister("k2FEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $b37f9adf6230576d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e70547764e67b037edaf0816b6f4ec77>>
 * @relayHash 8d49f086e404cd774990851cc2a7daa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def
const $b37f9adf6230576d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v4 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "f065e1026f784b8accb52074af7bd36e6b06fbe4ba5e8c7e5a6d71afec948def",
            "metadata": {},
            "name": "fetchUsersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b37f9adf6230576d$var$node.hash = "55c7a5d564d3036b3714730d97d87482";
var $b37f9adf6230576d$export$2e2bcd8739ae039 = $b37f9adf6230576d$var$node;

});


parcelRegister("chPvB", function(module, exports) {
$parcel$export(module.exports, "useFormMetadata", () => $43a77a7547416828$export$863414fa128cb7ef);

var $6VEbB = parcelRequire("6VEbB");
var $iouul = parcelRequire("iouul");

var $7pCjT = parcelRequire("7pCjT");
const $43a77a7547416828$var$selectFormMetadata = (0, $6VEbB.createSelector)((state)=>state.internalFormMetadata, (metadata)=>metadata);
const $43a77a7547416828$export$863414fa128cb7ef = (0, $iouul.createStateHook)((0, $7pCjT.store), {
    selector: $43a77a7547416828$var$selectFormMetadata
});

});


parcelRegister("kM60e", function(module, exports) {
$parcel$export(module.exports, "useFieldsChangesValidation", () => $6f5db73a53d7a4fb$export$e3505fcc03e08574);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $1S4mU = parcelRequire("1S4mU");

var $chPvB = parcelRequire("chPvB");

var $ezZWZ = parcelRequire("ezZWZ");

var $4nCmv = parcelRequire("4nCmv");

var $kFxfH = parcelRequire("kFxfH");
const $6f5db73a53d7a4fb$var$filterInvalidResults = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $6f5db73a53d7a4fb$var$mapValidResultsToFieldChangesMap = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true) {
            const { data: { fieldId: fieldId, fieldData: fieldData } } = result;
            acc[fieldId] = fieldData;
        }
        return acc;
    }, {});
const $6f5db73a53d7a4fb$export$e3505fcc03e08574 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const formMetadata = (0, $chPvB.useFormMetadata)();
    const formMetadataRef = (0, $4fqPo.useRef)(formMetadata);
    const viewType = (0, $ezZWZ.useViewType)();
    const { currentFormState: currentFormState } = (0, $1S4mU.useCurrentFormState)();
    const currentFormStateRef = (0, $4fqPo.useRef)(currentFormState);
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ formMetadataRef.current = formMetadata;
    currentFormStateRef.current = currentFormState;
    return (0, $4fqPo.useCallback)(async (fieldsChanges)=>{
        const fieldsChangesValidationResult = await Promise.all(Object.entries(fieldsChanges).filter(([fieldId])=>{
            return formMetadataRef.current[fieldId] !== undefined;
        }).map(async ([fieldId, fieldData])=>{
            const { fieldType: fieldType } = formMetadataRef.current[fieldId];
            const fieldValidationResult = await (0, $kFxfH.validateFieldChanges)({
                fieldType: fieldType,
                fieldId: fieldId,
                viewType: viewType,
                createAnalyticsEvent: createAnalyticsEvent,
                fieldMetadata: formMetadataRef.current[fieldId],
                currentField: currentFormStateRef.current[fieldId],
                fieldFromIframe: fieldData
            });
            if (fieldValidationResult.isValid === false) return fieldValidationResult;
            return {
                ...fieldValidationResult,
                data: {
                    fieldId: fieldId,
                    fieldData: fieldData
                }
            };
        }));
        const failedValidationResults = $6f5db73a53d7a4fb$var$filterInvalidResults(fieldsChangesValidationResult);
        if (failedValidationResults.length) throw new (0, $4nCmv.UiModificationsFieldsValidationError)('Validation failed', {
            errors: failedValidationResults.flatMap((result)=>result.errors)
        });
        return $6f5db73a53d7a4fb$var$mapValidResultsToFieldChangesMap(fieldsChangesValidationResult);
    }, [
        createAnalyticsEvent,
        viewType
    ]);
};

});
parcelRegister("kFxfH", function(module, exports) {
$parcel$export(module.exports, "validateFieldChanges", () => $5e52d5b6795c2a9b$export$a2b7ddd7c3d0703a);

var $bjzpQ = parcelRequire("bjzpQ");

var $4DdnT = parcelRequire("4DdnT");

var $hlB8j = parcelRequire("hlB8j");
const $5e52d5b6795c2a9b$export$a2b7ddd7c3d0703a = async ({ fieldType: fieldType, fieldId: fieldId, currentField: currentField, fieldFromIframe: fieldFromIframe, fieldMetadata: fieldMetadata, viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fieldConfiguration = (0, $bjzpQ.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldValidators = fieldConfiguration === null || fieldConfiguration === void 0 ? void 0 : fieldConfiguration.publicShapeValidators;
    if (!fieldFromIframe || !fieldValidators) return 0, $4DdnT.VALID_RESULT;
    const validatorsArray = Object.entries(fieldValidators);
    const fieldValidationResults = await Promise.all(validatorsArray.map(async ([propertyName, validate])=>{
        if ((0, $hlB8j.isFieldPropertyName)(fieldFromIframe, propertyName)) {
            const propertyValue = fieldFromIframe[propertyName];
            const validationResult = await validate(propertyValue, fieldMetadata, createAnalyticsEvent, {
                currentField: currentField,
                viewType: viewType
            });
            return (0, $hlB8j.prepareValidationResult)({
                validationResult: validationResult,
                fieldId: fieldId,
                fieldType: fieldType,
                propertyName: propertyName
            });
        }
        return 0, $4DdnT.VALID_RESULT;
    }));
    const invalidValidationResult = (0, $hlB8j.filterInvalidResults)(fieldValidationResults);
    if (invalidValidationResult.length > 0) return {
        isValid: false,
        errors: invalidValidationResult.map((result)=>result.error)
    };
    return 0, $4DdnT.VALID_RESULT;
};

});
parcelRegister("4DdnT", function(module, exports) {
$parcel$export(module.exports, "VALID_RESULT", () => $e55a098f804928d1$export$ee79e3ab53b8db79);
const $e55a098f804928d1$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hlB8j", function(module, exports) {
$parcel$export(module.exports, "prepareValidationResult", () => $f1d3f07594be1e72$export$971a38960a5f1064);
$parcel$export(module.exports, "filterInvalidResults", () => $f1d3f07594be1e72$export$ddd005554aecd409);
$parcel$export(module.exports, "isFieldPropertyName", () => $f1d3f07594be1e72$export$fd744b06c9068a9e);

var $6fUbn = parcelRequire("6fUbn");

var $iIf9n = parcelRequire("iIf9n");

var $4DdnT = parcelRequire("4DdnT");
const $f1d3f07594be1e72$var$prepareValidationResultByBooleanValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    if (validationResult === false) return {
        isValid: false,
        error: {
            type: (0, $6fUbn.FIELD_VALIDATION_ERROR),
            method: (0, $iIf9n.mapFieldPropertyToApiMethod)(propertyName),
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $4DdnT.VALID_RESULT;
};
const $f1d3f07594be1e72$var$prepareValidationResultByExtendedValue = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType })=>{
    if (validationResult.isValid === false) return {
        isValid: false,
        error: {
            type: (0, $6fUbn.FIELD_VALIDATION_ERROR),
            method: validationResult.error.method,
            message: validationResult.error.message,
            fieldId: fieldId,
            fieldType: fieldType
        }
    };
    return 0, $4DdnT.VALID_RESULT;
};
const $f1d3f07594be1e72$export$971a38960a5f1064 = ({ validationResult: validationResult, fieldId: fieldId, fieldType: fieldType, propertyName: propertyName })=>{
    // We will remove the boolean check and old method after changing all validators to return objects
    if (typeof validationResult === 'boolean') return $f1d3f07594be1e72$var$prepareValidationResultByBooleanValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType,
        propertyName: propertyName
    });
    return $f1d3f07594be1e72$var$prepareValidationResultByExtendedValue({
        validationResult: validationResult,
        fieldId: fieldId,
        fieldType: fieldType
    });
};
const $f1d3f07594be1e72$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);
const $f1d3f07594be1e72$export$fd744b06c9068a9e = (fieldFromIframe, propertyName)=>Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName);

});



parcelRegister("lQhrj", function(module, exports) {
$parcel$export(module.exports, "useFilterFieldChangesBasedOnScope", () => $5aa412bcc8f39e91$export$2ee317ef8ccc699f);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $1S4mU = parcelRequire("1S4mU");

var $ezZWZ = parcelRequire("ezZWZ");

var $90swm = parcelRequire("90swm");
const $5aa412bcc8f39e91$export$2ee317ef8ccc699f = (moduleScopes)=>{
    const { currentFormState: currentFormState } = (0, $1S4mU.useCurrentFormState)();
    const currentFormStateRef = (0, $4fqPo.useRef)(currentFormState);
    const viewType = (0, $ezZWZ.useViewType)();
    /**
   * We want to have an up-to-date data when this hook's
   * returned function is being called in useSubmit callback function
   * thats why we keep it in a ref object
   */ currentFormStateRef.current = currentFormState;
    return (0, $4fqPo.useCallback)((fieldChanges)=>(0, $90swm.filterFieldsChangesBasedOnScopes)(fieldChanges, currentFormStateRef.current, viewType, moduleScopes), [
        moduleScopes,
        viewType
    ]);
};

});



parcelRegister("b2KVU", function(module, exports) {
$parcel$export(module.exports, "useIframeTimeout", () => $7cd28625f3f337d7$export$39fbc0513eb03420);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $1nPqj = parcelRequire("1nPqj");

var $ew3Bn = parcelRequire("ew3Bn");

var $cM1tn = parcelRequire("cM1tn");

var $ezZWZ = parcelRequire("ezZWZ");
const $7cd28625f3f337d7$export$45f7ef64ce535ffd = 12000;
const $7cd28625f3f337d7$export$39fbc0513eb03420 = ({ forgeExtension: forgeExtension })=>{
    const timeoutRef = (0, $4fqPo.useRef)(undefined);
    const callbackRef = (0, $4fqPo.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($1nPqj))));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const viewType = (0, $ezZWZ.useViewType)();
    const onTimeout = (0, $4fqPo.useCallback)(()=>{
        const { id: id } = forgeExtension;
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'failed',
            actionSubject: 'jiraUiModifications.iframeTimeout',
            attributes: {
                timeoutAfter: `${$7cd28625f3f337d7$export$45f7ef64ce535ffd / 1000}s`,
                extensionId: id,
                viewType: viewType
            }
        });
    }, [
        forgeExtension,
        viewType,
        createAnalyticsEvent
    ]);
    (0, $4fqPo.useEffect)(()=>{
        callbackRef.current = onTimeout;
    }, [
        onTimeout
    ]);
    const setLoadingComplete = (0, $4fqPo.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
    }, []);
    (0, $4fqPo.useEffect)(()=>{
        // For details on why we need to evaluate the callback in this way, see
        // https://www.joshwcomeau.com/snippets/react-hooks/use-timeout/#explanation
        // tl;dr: it allows the latest version of `onTimeout` to be called, without
        // needing to cancel and start a new timer each time dependencies change
        const callback = ()=>callbackRef.current();
        timeoutRef.current = setTimeout(callback, $7cd28625f3f337d7$export$45f7ef64ce535ffd);
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    return {
        setLoadingComplete: setLoadingComplete
    };
};

});

parcelRegister("9rrYY", function(module, exports) {
$parcel$export(module.exports, "useScopeChecks", () => $fa5bba708b69275d$export$5b312a37a22a70a8);

var $lgnVH = parcelRequire("lgnVH");
const $fa5bba708b69275d$export$5b312a37a22a70a8 = (appInstallationScopes)=>{
    if (appInstallationScopes) {
        const appHasAllRequiredCoarseScopes = (0, $lgnVH.REQUIRED_COARSE_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
        if (appHasAllRequiredCoarseScopes) return true;
        return (0, $lgnVH.REQUIRED_GRANULAR_SCOPES).every((requiredScope)=>appInstallationScopes.includes(requiredScope));
    }
    return false;
};

});
parcelRegister("lgnVH", function(module, exports) {
$parcel$export(module.exports, "REQUIRED_GRANULAR_SCOPES", () => $c846338504598c8d$export$81920d3428c141d1);
$parcel$export(module.exports, "REQUIRED_COARSE_SCOPES", () => $c846338504598c8d$export$bdf22b2c717ce672);
// https://hello.atlassian.net/wiki/spaces/unbx/pages/1732638810/RFC+Set+of+scopes+to+be+required+in+UI+modifications+extension+point+in+GIC+location
const $c846338504598c8d$export$81920d3428c141d1 = [
    'read:project:jira',
    'read:issue-type:jira',
    'read:user-configuration:jira',
    'read:user:jira',
    'read:issue:jira',
    'read:priority:jira',
    'read:label:jira',
    'read:license:jira',
    'read:field:jira',
    'read:field-configuration:jira',
    'write:field-configuration:jira',
    'write:field.default-value:jira',
    'write:field:jira'
];
const $c846338504598c8d$export$bdf22b2c717ce672 = [
    'manage:jira-configuration',
    'read:jira-user',
    'read:jira-work',
    'write:jira-work'
];

});


parcelRegister("gpNIj", function(module, exports) {
$parcel$export(module.exports, "useThreeLOPromptProps", () => $0691ddbc371c4d36$export$cb62ba9a2eb7a0b4);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $ew3Bn = parcelRequire("ew3Bn");

var $lhBYC = parcelRequire("lhBYC");

var $cM1tn = parcelRequire("cM1tn");

var $33BOA = parcelRequire("33BOA");

var $bmfYr = parcelRequire("bmfYr");

var $2FyXQ = parcelRequire("2FyXQ");

var $ezZWZ = parcelRequire("ezZWZ");

var $bjzpQ = parcelRequire("bjzpQ");
const $0691ddbc371c4d36$export$cb62ba9a2eb7a0b4 = ({ forgeExtension: forgeExtension })=>{
    const [hasBeenTracked, setHasBeenTracked] = (0, $4fqPo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { setUIModificationsConsentStatus: setUIModificationsConsentStatus } = (0, $33BOA.useAdjustmentsContextActions)();
    const { appId: appId } = (0, $lhBYC.parseExtensionId)(forgeExtension.id);
    const viewType = (0, $ezZWZ.useViewType)();
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const currentUIModificationsConsentStatus = (0, $bmfYr.useUIModificationsConsentStatusForApp)({
        appId: appId
    });
    const onConsentSuccess = (0, $4fqPo.useCallback)(()=>{
        setUIModificationsConsentStatus({
            appId: appId,
            status: (0, $2FyXQ.UIM_CONSENT_CONSENTED)
        });
        (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'cleared',
            actionSubject: 'jiraUiModificationsObligatoryConsent'
        });
    }, [
        appId,
        createAnalyticsEvent,
        setUIModificationsConsentStatus
    ]);
    const onConsentInitialization = (0, $4fqPo.useCallback)(()=>{
        if (currentUIModificationsConsentStatus === (0, $2FyXQ.UIM_CONSENT_UNKNOWN)) {
            setUIModificationsConsentStatus({
                appId: appId,
                status: (0, $2FyXQ.UIM_CONSENT_REQUIRED)
            });
            if (!hasBeenTracked) {
                (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'triggered',
                    actionSubject: 'jiraUiModifications.obligatoryConsent',
                    attributes: {
                        viewType: viewType
                    }
                });
                setHasBeenTracked(true);
            }
        }
    }, [
        appId,
        currentUIModificationsConsentStatus,
        setUIModificationsConsentStatus,
        hasBeenTracked,
        viewType,
        createAnalyticsEvent
    ]);
    const consentMessage = (0, $4fqPo.useMemo)(()=>{
        return formatMessage((0, $bjzpQ.getConsentMessage)(viewType), {
            appTitle: forgeExtension.properties.title
        });
    }, [
        formatMessage,
        forgeExtension.properties.title,
        viewType
    ]);
    const threeLOPromptComponentPropsMethods = (0, $4fqPo.useMemo)(()=>({
            onConsentSuccess: onConsentSuccess,
            onConsentInitialization: onConsentInitialization,
            consentMessage: consentMessage
        }), [
        onConsentSuccess,
        onConsentInitialization,
        consentMessage
    ]);
    return threeLOPromptComponentPropsMethods;
};

});

parcelRegister("3Mljd", function(module, exports) {
$parcel$export(module.exports, "buildExtensionData", () => $a43284d09cd04a55$export$141a9933f8885d99);

var $jM2Ed = parcelRequire("jM2Ed");
const $a43284d09cd04a55$export$141a9933f8885d99 = (executionContext)=>{
    return {
        type: (0, $jM2Ed.UI_MODIFICATIONS_MODULE),
        ...executionContext
    };
};

});



parcelRegister("8hvNc", function(module, exports) {
$parcel$export(module.exports, "useAppsToRender", () => $4b552fb88107c8a8$export$bef357953bcc2428);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $cM1tn = parcelRequire("cM1tn");

var $33BOA = parcelRequire("33BOA");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $7G8Dc = parcelRequire("7G8Dc");

var $etqZq = parcelRequire("etqZq");
const $4b552fb88107c8a8$export$bef357953bcc2428 = (payload)=>{
    var _data$jira3, _data$jira4, _data$jira6, _data$jira9, _data$jira0;
    const { data: data, executionContextKey: executionContextKey } = payload;
    const { startFieldsInitialisationTimeout: startFieldsInitialisationTimeout } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const { setAdjustmentsAreEnabled: setAdjustmentsAreEnabled, setHasFinishedLoading: setHasFinishedLoading } = (0, $33BOA.useAdjustmentsContextActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const viewType = (0, $ezZWZ.useViewType)();
    const configuredApps = (0, $4fqPo.useMemo)(()=>{
        var _data$jira, _data$jira2;
        return (0, $etqZq.getConfiguredApps)((_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.uiModificationsExtensions, (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.uiModifications);
    }, [
        (_data$jira3 = data.jira) === null || _data$jira3 === void 0 || (_data$jira3 = _data$jira3.forge) === null || _data$jira3 === void 0 ? void 0 : _data$jira3.uiModificationsExtensions,
        (_data$jira4 = data.jira) === null || _data$jira4 === void 0 ? void 0 : _data$jira4.uiModifications
    ]);
    const appsToRender = (0, $4fqPo.useMemo)(()=>{
        return configuredApps.slice(0, (0, $7G8Dc.MAX_NUMBER_OF_UIM_APPS));
    }, [
        configuredApps
    ]);
    (0, $4fqPo.useEffect)(()=>{
        var _data$jira5;
        if (((_data$jira5 = data.jira) === null || _data$jira5 === void 0 ? void 0 : _data$jira5.uiModifications) !== undefined) setHasFinishedLoading(true);
    }, [
        setHasFinishedLoading,
        (_data$jira6 = data.jira) === null || _data$jira6 === void 0 ? void 0 : _data$jira6.uiModifications
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (appsToRender.length > 0) {
            setAdjustmentsAreEnabled(true);
            startFieldsInitialisationTimeout({
                createAnalyticsEvent: createAnalyticsEvent
            });
        }
    }, [
        appsToRender,
        setAdjustmentsAreEnabled,
        startFieldsInitialisationTimeout,
        createAnalyticsEvent
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const configuredAppsCount = configuredApps.length;
        if (configuredAppsCount >= 1) {
            var _data$jira7, _data$jira8;
            (0, $cM1tn.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'success',
                actionSubject: 'jiraUiModifications.configuredAppsPerContext',
                attributes: {
                    forgeModulesCount: (_data$jira7 = data.jira) === null || _data$jira7 === void 0 || (_data$jira7 = _data$jira7.forge) === null || _data$jira7 === void 0 ? void 0 : _data$jira7.uiModificationsExtensions.length,
                    uimConfiguredAppCount: (_data$jira8 = data.jira) === null || _data$jira8 === void 0 ? void 0 : _data$jira8.uiModifications.length,
                    configuredAndInstalledApps: configuredAppsCount,
                    areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
                    viewType: viewType
                }
            });
        }
    }, [
        // `executionContextKey` is required to track events when execution context changed
        executionContextKey,
        viewType,
        createAnalyticsEvent,
        configuredApps.length,
        (_data$jira9 = data.jira) === null || _data$jira9 === void 0 || (_data$jira9 = _data$jira9.forge) === null || _data$jira9 === void 0 ? void 0 : _data$jira9.uiModificationsExtensions.length,
        (_data$jira0 = data.jira) === null || _data$jira0 === void 0 ? void 0 : _data$jira0.uiModifications.length
    ]);
    return appsToRender;
};

});
parcelRegister("7G8Dc", function(module, exports) {
$parcel$export(module.exports, "MAX_NUMBER_OF_UIM_APPS", () => $eee3e0b61f86937d$export$575c2f3c7fe81caa);
const $eee3e0b61f86937d$export$575c2f3c7fe81caa = 5;

});

parcelRegister("etqZq", function(module, exports) {
$parcel$export(module.exports, "getConfiguredApps", () => $36401da36e8e37f3$export$6ead423ef319ea49);

var $gwla2 = parcelRequire("gwla2");
const $36401da36e8e37f3$var$STABLE_EMPTY_ARRAY = [];
const $36401da36e8e37f3$export$6ead423ef319ea49 = (forgeExtensions, uiModificationsConfigs)=>{
    if (!forgeExtensions || !uiModificationsConfigs) return $36401da36e8e37f3$var$STABLE_EMPTY_ARRAY;
    // Put modules in the HashMap for a fast search & get by appEnvId
    const modulesHashMap = (0, $gwla2.normalizeExtensions)(forgeExtensions);
    return uiModificationsConfigs.filter((configuration)=>!!modulesHashMap[configuration.appEnvId]).map((configuration)=>({
            forgeExtension: modulesHashMap[configuration.appEnvId],
            uiModificationsConfig: configuration.uiModifications.map(({ id: id, data: data })=>({
                    id: id,
                    data: data
                }))
        }));
};

});
parcelRegister("gwla2", function(module, exports) {
$parcel$export(module.exports, "normalizeExtensions", () => $a20d255a69aa0a64$export$7e2e604b6166a087);

var $lhBYC = parcelRequire("lhBYC");
const $a20d255a69aa0a64$export$7e2e604b6166a087 = (forgeExtensions)=>forgeExtensions.reduce((accumulator, current)=>{
        const { appId: appId, environmentId: envId } = (0, $lhBYC.parseExtensionId)(current.id);
        const combinedAppEnvId = `${appId}/${envId}`;
        // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
        // and integration code is deterministic (if you add a new IA module,
        // the 1st one will be rendered, not the last one)
        if (!accumulator[combinedAppEnvId]) accumulator[combinedAppEnvId] = current;
        return accumulator;
    }, {});

});



parcelRegister("h3Yqq", function(module, exports) {
$parcel$export(module.exports, "useContextCleanup", () => $2f336ba11c71fdcd$export$c704babd3a8c2350);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $33BOA = parcelRequire("33BOA");

var $ezZWZ = parcelRequire("ezZWZ");

var $7pCjT = parcelRequire("7pCjT");

var $bjzpQ = parcelRequire("bjzpQ");
const $2f336ba11c71fdcd$export$c704babd3a8c2350 = (payload)=>{
    const { executionContextKey: executionContextKey, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = payload;
    const { resetAllFields: resetAllFields, triggerFieldInitialization: triggerFieldInitialization, setNumberOfSupportedFields: setNumberOfSupportedFields } = (0, $7pCjT.useIssueAdjustmentsActions)();
    const { resetAdjustmentContext: resetAdjustmentContext } = (0, $33BOA.useAdjustmentsContextActions)();
    const viewType = (0, $ezZWZ.useViewType)();
    (0, $4fqPo.useEffect)(()=>{
        if (numberOfSupportedFields !== undefined) setNumberOfSupportedFields(numberOfSupportedFields);
        return ()=>setNumberOfSupportedFields(0);
    }, [
        numberOfSupportedFields,
        setNumberOfSupportedFields
    ]);
    (0, $4fqPo.useEffect)(()=>{
        triggerFieldInitialization();
        return resetAllFields;
    // Whenever the executionContextKey is changed, or the resetFormFieldsCounter
    // is incremented ("create another issue" GIC) we want to reset any data in our store.
    // For "create another issue" `resetFormFieldsCounter` we trigger re-initialization of field data.
    }, [
        executionContextKey,
        resetFormFieldsCounter,
        resetAllFields,
        triggerFieldInitialization
    ]);
    (0, $4fqPo.useEffect)(()=>()=>{
            resetAdjustmentContext();
            (0, $bjzpQ.getAnalytics)(viewType).cancelTTI();
        }, // When executionContextKey is changed we reset the AdjustmentsContext because
    // other executionContextKey may not be configured to run UI modifications
    [
        executionContextKey,
        resetAdjustmentContext,
        viewType
    ]);
};

});

parcelRegister("7ND3l", function(module, exports) {
$parcel$export(module.exports, "useEnrichedExecutionContext", () => $40a9215e18064c91$export$649da33b72723913);

var $4fqPo = parcelRequire("4fqPo");

var $ezZWZ = parcelRequire("ezZWZ");
const $40a9215e18064c91$export$649da33b72723913 = ({ executionContext: executionContext })=>{
    const viewType = (0, $ezZWZ.useViewType)();
    const enrichedExecutionContext = (0, $4fqPo.useMemo)(()=>{
        return executionContext && {
            ...executionContext,
            viewType: viewType
        };
    }, [
        executionContext,
        viewType
    ]);
    return enrichedExecutionContext;
};

});



parcelRegister("bFigR", function(module, exports) {
$parcel$export(module.exports, "UiModificationsRootWithData", () => $c119d159824b8911$export$56d75038a9162ad6);
// react-magnetic-di - temporary comment, for auto dependency injection in tests

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");

var $33BOA = parcelRequire("33BOA");

var $eD73h = parcelRequire("eD73h");

var $ezZWZ = parcelRequire("ezZWZ");

var $5Uk5u = parcelRequire("5Uk5u");

var $bjzpQ = parcelRequire("bjzpQ");

var $5rcC8 = parcelRequire("5rcC8");

var $8hvNc = parcelRequire("8hvNc");

var $h3Yqq = parcelRequire("h3Yqq");

var $7ND3l = parcelRequire("7ND3l");
const $c119d159824b8911$export$56d75038a9162ad6 = (props)=>{
    const executionContext = (0, $7ND3l.useEnrichedExecutionContext)({
        executionContext: props.executionContext
    });
    const { executionContextKey: executionContextKey, triggerPointKey: triggerPointKey } = props;
    const viewType = (0, $ezZWZ.useViewType)();
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $33BOA.useAdjustmentsContextActions)();
    const shouldLoad = executionContext && executionContextKey && (0, $bjzpQ.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $bjzpQ.isExecutionContextSupported)(executionContext);
    (0, $4fqPo.useEffect)(()=>{
        if (shouldLoad) setShouldUiModificationsLoad(shouldLoad ? 'yes' : 'no');
    }, [
        setShouldUiModificationsLoad,
        shouldLoad,
        executionContextKey
    ]);
    if (!shouldLoad) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($c119d159824b8911$var$RootWithDataCleanup, {
        ...props,
        executionContext: executionContext,
        executionContextKey: executionContextKey
    });
};
const $c119d159824b8911$var$RootWithDataCleanup = (props)=>{
    const { cloudId: cloudId, activationId: activationId, executionContextKey: executionContextKey, triggerPointKey: triggerPointKey, executionContext: executionContext, numberOfSupportedFields: numberOfSupportedFields, resetFormFieldsCounter: resetFormFieldsCounter } = props;
    (0, $h3Yqq.useContextCleanup)({
        executionContextKey: executionContextKey,
        numberOfSupportedFields: numberOfSupportedFields,
        resetFormFieldsCounter: resetFormFieldsCounter
    });
    const tenantContext = (0, $4fqPo.useMemo)(()=>({
            cloudId: cloudId,
            activationId: activationId
        }), [
        cloudId,
        activationId
    ]);
    const analyticsContextData = (0, $4fqPo.useMemo)(()=>({
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }), [
        triggerPointKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eD73h.ExecutionContextProvider), {
        value: executionContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uk5u.TenantContextProvider), {
        value: tenantContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($c119d159824b8911$var$RootWithData, props))));
};
const $c119d159824b8911$var$RootWithData = ({ uiModificationsData: uiModificationsData, ForgeAppRenderer: ForgeAppRenderer, executionContextKey: executionContextKey })=>{
    const appsToRender = (0, $8hvNc.useAppsToRender)({
        data: uiModificationsData,
        executionContextKey: executionContextKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5rcC8.AppsRenderer), {
        apps: appsToRender,
        ForgeAppRenderer: ForgeAppRenderer
    });
};

});

parcelRegister("h0osM", function(module, exports) {
$parcel$export(module.exports, "ForgeAppRenderer", () => $15e6c478a9ec1e29$export$6eef17fe5fde390c);

var $4fqPo = parcelRequire("4fqPo");

var $a2jJG = parcelRequire("a2jJG");

var $adk9i = parcelRequire("adk9i");

var $cPybr = parcelRequire("cPybr");

var $6yrxM = parcelRequire("6yrxM");
const $15e6c478a9ec1e29$export$6eef17fe5fde390c = (props)=>{
    const { extension: extension, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cPybr.ExtensionPointProvider), {
        extensionType: (0, $adk9i.UI_MODIFICATIONS)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6yrxM.Renderer), {
        ...restProps,
        extension: extension,
        contextTokenType: (0, $a2jJG.ContextTokenType).JIRA
    }));
};

});
parcelRegister("a2jJG", function(module, exports) {
$parcel$export(module.exports, "ALLOWED", () => $4032a76e3ddbec1b$export$b4c0bb1de45ab46c);
$parcel$export(module.exports, "BLOCKED", () => $4032a76e3ddbec1b$export$c2dfa6e96815ac6b);
$parcel$export(module.exports, "EXTENSION", () => $4032a76e3ddbec1b$export$8a7e8af112e5972a);
$parcel$export(module.exports, "ContextTokenType", () => $4032a76e3ddbec1b$export$70a9026332abd115);
$parcel$export(module.exports, "AtlassianHelpConfigAccountType", () => $4032a76e3ddbec1b$export$5ea1c090b459f41f);
const $4032a76e3ddbec1b$export$b4c0bb1de45ab46c = 'ALLOWED';
const $4032a76e3ddbec1b$export$c2dfa6e96815ac6b = 'BLOCKED';
const $4032a76e3ddbec1b$export$8a7e8af112e5972a = 'extension';
var $4032a76e3ddbec1b$export$70a9026332abd115 = /*#__PURE__*/ function(ContextTokenType) {
    ContextTokenType["JSM"] = "JSM";
    ContextTokenType["JIRA"] = "JIRA";
    return ContextTokenType;
}({});
var $4032a76e3ddbec1b$export$5ea1c090b459f41f = /*#__PURE__*/ function(AtlassianHelpConfigAccountType) {
    AtlassianHelpConfigAccountType["ATLASSIAN"] = "atlassian";
    AtlassianHelpConfigAccountType["CUSTOMER"] = "customer";
    AtlassianHelpConfigAccountType["ANONYMOUS"] = "anonymous";
    return AtlassianHelpConfigAccountType;
}({});

});

parcelRegister("cPybr", function(module, exports) {
$parcel$export(module.exports, "ExtensionPointProvider", () => $9e7d0aed262ebf1d$export$80b99728bc3dad9);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $9e7d0aed262ebf1d$export$80b99728bc3dad9 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("1r8Tk")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/extension-point-provider/extension-point-provider.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("1r8Tk", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("lhX6O"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("36Dod")
]).then(()=>parcelRequire('gX9dM'));

});


parcelRegister("6yrxM", function(module, exports) {
$parcel$export(module.exports, "Renderer", () => $3f014a7ac00243d2$export$88530751e3977073);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $3f014a7ac00243d2$export$88530751e3977073 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("diCgW")), {
        moduleId: "./packages/common-utils/forge-ui-utils/src/renderer/renderer.tsx"
    }),
    LoadingSkeleton: ()=>null
});

});
parcelRegister("diCgW", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("d2mFO"),
    $e46AW("159fS"),
    $e46AW("cotMj"),
    $e46AW("lzaIj"),
    $e46AW("83e22"),
    $e46AW("8oU5a"),
    $e46AW("lESQD"),
    $e46AW("eahZ0"),
    $e46AW("6JXPa"),
    $e46AW("dItcg"),
    $e46AW("2V398"),
    $e46AW("co70a"),
    $e46AW("lhX6O"),
    $e46AW("5jpjH"),
    $e46AW("iWjeZ"),
    $e46AW("3bc5b")
]).then(()=>parcelRequire('hLwAy'));

});




parcelRegister("3nE6H", function(module, exports) {
$parcel$export(module.exports, "RovoServiceAgentWidgetInjector", () => $8998bf4d1ea53902$export$19e4074f6781b5f7);

var $4fqPo = parcelRequire("4fqPo");

var $gMSZD = parcelRequire("gMSZD");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");

var $edOls = parcelRequire("edOls");
var $h1mlL = parcelRequire("h1mlL");

var $geWWn = parcelRequire("geWWn");

var $lNZDv = parcelRequire("lNZDv");

var $cz6zo = parcelRequire("cz6zo");
var $3IJ1B = parcelRequire("3IJ1B");
var $gHT3x = parcelRequire("gHT3x");

var $dvNUn = parcelRequire("dvNUn");
var $gPrbw = parcelRequire("gPrbw");

var $4s4c2 = parcelRequire("4s4c2");

var $6Jm5z = parcelRequire("6Jm5z");
const $8998bf4d1ea53902$var$InjectRovoServiceAgentWidgetScript = /*#__PURE__*/ (0, $4fqPo.memo)(function RovoServiceAgentWidget({ siteId: siteId, widgetId: widgetId, surface: surface }) {
    const [error, setError] = (0, $4fqPo.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { locale: locale } = (0, $dQegt.default)();
    const handleOnOpen = (0, $4fqPo.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88552
        (0, $3IJ1B.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget opened');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClose = (0, $4fqPo.useCallback)(()=>{
        // https://data-portal.internal.atlassian.com/analytics/registry/88553
        (0, $3IJ1B.fireUIAnalytics)(createAnalyticsEvent({}), 'rovoServiceAgentWidget closed');
    }, [
        createAnalyticsEvent
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const loadScript = async ()=>{
            const startTime = performance.now();
            try {
                setError(null);
                await (0, $6Jm5z.loadRovoWidgetSDKScript)({
                    siteId: siteId,
                    widgetId: widgetId,
                    surface: surface,
                    locale: locale,
                    onOpen: handleOnOpen,
                    onClose: handleOnClose
                });
                // Measure widget load time (non-blocking, fire-and-forget)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $3IJ1B.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration
                    }
                }), 'rovoServiceAgentWidget scriptLoaded');
            } catch (err) {
                // Measure failed load time (non-blocking)
                const loadDuration = Math.round(performance.now() - startTime);
                (0, $3IJ1B.fireOperationalAnalytics)(createAnalyticsEvent({
                    attributes: {
                        surface: surface,
                        duration: loadDuration,
                        error: err instanceof Error ? err.message : 'Unknown error'
                    }
                }), 'rovoServiceAgentWidget scriptFailed');
                setError(err instanceof Error ? err : new Error('Failed to load widget script'));
            }
        };
        // The error handler is inside loadScript, so we don't need to handle it here
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loadScript();
    }, [
        widgetId,
        siteId,
        handleOnClose,
        handleOnOpen,
        surface,
        locale,
        createAnalyticsEvent
    ]);
    (0, $4fqPo.useEffect)(()=>{
        return ()=>{
            (0, $6Jm5z.cleanupRovoWidgetSDKScript)();
        };
    }, []);
    if (error) throw error;
    // Return null without blocking UFO experience - widget loads asynchronously
    return null;
});
const $8998bf4d1ea53902$export$19e4074f6781b5f7 = ({ siteId: siteId, widgetId: widgetId, surface: surface })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const renderError = (0, $4fqPo.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h1mlL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $edOls.default), {
            id: "rovo-widget-error-flag",
            appearance: "error",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
                label: ""
            }),
            title: formatMessage((0, $4s4c2.default).widgetErrorTitle),
            description: formatMessage((0, $4s4c2.default).widgetErrorDescription),
            testId: "rovo-widget-error-flag"
        }));
    }, [
        formatMessage
    ]);
    // RSA widget script (https://<site>/rovo/widget/script.js) is not deployed
    // on FedRAMP or Isolated Cloud tenants, so do not attempt to inject it there.
    if ((0, $dvNUn.isFedRamp)() || (0, $gPrbw.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lNZDv.default), {
        name: "rovo-service-agent-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: "rovo-service-agent",
        id: "widget-injector",
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: "rovoServiceAgent",
        sourceType: (0, $gHT3x.MODAL),
        attributes: {
            siteId: siteId,
            widgetId: widgetId,
            surface: surface
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($8998bf4d1ea53902$var$InjectRovoServiceAgentWidgetScript, {
        siteId: siteId,
        widgetId: widgetId,
        surface: surface
    }))));
};

});
parcelRegister("4s4c2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bce28486c6bc5b28$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $bce28486c6bc5b28$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    widgetErrorTitle: {
        id: 'rovo.service-agent.widget.error-boundary.title.non-final',
        defaultMessage: 'Rovo Service Agent widget unavailable',
        description: 'Title for the error flag for when the widget failed to load'
    },
    widgetErrorDescription: {
        id: 'rovo.service-agent.widget.error-boundary.description.non-final',
        defaultMessage: 'The Rovo Service Agent failed to load. Please refresh the page to try again.',
        description: 'Description for the error flag for when the widget failed to load'
    }
});

});

parcelRegister("6Jm5z", function(module, exports) {
$parcel$export(module.exports, "loadRovoWidgetSDKScript", () => $6a4e716108fe9ccc$export$7547b32d5aede92f);
$parcel$export(module.exports, "cleanupRovoWidgetSDKScript", () => $6a4e716108fe9ccc$export$8b3a5cba31576b8a);
let $6a4e716108fe9ccc$var$promise = null;
const $6a4e716108fe9ccc$var$SCRIPT_ID = 'rovo-service-agent-widget-script';
const $6a4e716108fe9ccc$export$7bcdf693772d0a65 = ()=>{
    const q = function WidgetQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};
const $6a4e716108fe9ccc$export$2319c1f51535cb1c = ()=>{
    if (typeof window === 'undefined') throw new Error('Failed to load CSM SDK: window is undefined');
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    if (!body) throw new Error('Document body not found');
};
const $6a4e716108fe9ccc$export$e0c468a317b25666 = (onOpen, onClose)=>{
    if (typeof window.ROVO_WIDGET === 'undefined') {
        window.ROVO_WIDGET = $6a4e716108fe9ccc$export$7bcdf693772d0a65();
        if (onOpen) window.ROVO_WIDGET('onOpen', onOpen);
        if (onClose) window.ROVO_WIDGET('onClose', onClose);
        window.ROVO_WIDGET('open');
    }
};
const $6a4e716108fe9ccc$export$bb8c6503cfd42bb6 = ()=>{
    return !!(window.ROVO_WIDGET && !('__q__' in window.ROVO_WIDGET));
};
const $6a4e716108fe9ccc$export$8e6c9489c906e450 = (siteId, widgetId, surface, locale)=>{
    const site = window.location.hostname;
    const src = new URL(`https://${site}/rovo/widget/script.js`);
    src.searchParams.set('siteId', siteId);
    src.searchParams.set('site', site);
    src.searchParams.set('widgetId', widgetId);
    src.searchParams.set('surface', surface);
    src.searchParams.set('locale', locale);
    return src.toString();
};
const $6a4e716108fe9ccc$export$9b542085e8be8f80 = (resolve, reject)=>{
    if ($6a4e716108fe9ccc$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
    else if (window.ROVO_WIDGET && '__q__' in window.ROVO_WIDGET) {
        $6a4e716108fe9ccc$export$57f8607478cbbab6();
        if ($6a4e716108fe9ccc$export$bb8c6503cfd42bb6()) resolve(window.ROVO_WIDGET);
        else {
            $6a4e716108fe9ccc$var$promise = null;
            reject(new Error('SDK failed to initialize properly - still in queue mode'));
        }
    } else {
        $6a4e716108fe9ccc$var$promise = null;
        reject(new Error('Failed to load ROVO_WIDGET SDK script: window.ROVO_WIDGET is undefined'));
    }
};
const $6a4e716108fe9ccc$export$c20f7df29b9552b6 = (reject)=>{
    $6a4e716108fe9ccc$var$promise = null;
    reject(new Error('Failed to load ROVO_WIDGET SDK script: onerror'));
};
const $6a4e716108fe9ccc$export$a8c9f8edf0911bff = (scriptURL, resolve, reject)=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    script.id = $6a4e716108fe9ccc$var$SCRIPT_ID;
    script.onerror = ()=>$6a4e716108fe9ccc$export$c20f7df29b9552b6(reject);
    script.onload = ()=>$6a4e716108fe9ccc$export$9b542085e8be8f80(resolve, reject);
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const body = document.querySelector('body');
    body === null || body === void 0 || body.appendChild(script);
};
const $6a4e716108fe9ccc$export$57f8607478cbbab6 = ()=>{
    if (window.ROVO_WIDGET_REINIT) window.ROVO_WIDGET_REINIT();
};
const $6a4e716108fe9ccc$export$7547b32d5aede92f = ({ siteId: siteId, widgetId: widgetId, surface: surface, locale: locale, onOpen: onOpen, onClose: onClose })=>{
    if (!$6a4e716108fe9ccc$var$promise) $6a4e716108fe9ccc$var$promise = new Promise((resolve, reject)=>{
        try {
            $6a4e716108fe9ccc$export$2319c1f51535cb1c();
            $6a4e716108fe9ccc$export$e0c468a317b25666(onOpen, onClose);
            // If SDK is already loaded (not a queue), resolve immediately
            if ($6a4e716108fe9ccc$export$bb8c6503cfd42bb6()) {
                resolve(window.ROVO_WIDGET);
                return;
            }
            const scriptURL = $6a4e716108fe9ccc$export$8e6c9489c906e450(siteId, widgetId, surface, locale);
            $6a4e716108fe9ccc$export$a8c9f8edf0911bff(scriptURL, resolve, reject);
        } catch (error) {
            reject(error);
        }
    });
    return $6a4e716108fe9ccc$var$promise;
};
const $6a4e716108fe9ccc$export$8b3a5cba31576b8a = ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const scriptElement = document.getElementById($6a4e716108fe9ccc$var$SCRIPT_ID);
    if (scriptElement) // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.body.removeChild(scriptElement);
    if (window.ROVO_WIDGET_CLEANUP) window.ROVO_WIDGET_CLEANUP();
    if (window.ROVO_WIDGET) delete window.ROVO_WIDGET;
    // Reset the tracking variables
    $6a4e716108fe9ccc$var$promise = null;
};

});


parcelRegister("1PLAd", function(module, exports) {
$parcel$export(module.exports, "HeaderSinglePortalMode", () => (parcelRequire("3TxBc")).default);

var $3TxBc = parcelRequire("3TxBc");

});
parcelRegister("3TxBc", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b4782569d54d456$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("8XdUW");
var $h1MVT = parcelRequire("h1MVT");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("63kyL");
var $2TkKH = parcelRequire("2TkKH");
const $9b4782569d54d456$var$getPortalName = (state)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    return portalId ? (0, $95tqy.getName)(state, portalId) : undefined;
};
const $9b4782569d54d456$var$getPortalDescription = (state)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    return portalId ? (0, $95tqy.getDescription)(state, portalId) : undefined;
};
const $9b4782569d54d456$var$getPortalLogoUrl = (state)=>{
    const portalId = (0, $h1MVT.getPortalId)(state);
    return portalId ? (0, $95tqy.getLogoUrl)(state, portalId) : undefined;
};
const $9b4782569d54d456$var$selector = (0, $3yyCx.createSelector)($9b4782569d54d456$var$getPortalName, $9b4782569d54d456$var$getPortalDescription, $9b4782569d54d456$var$getPortalLogoUrl, (portalName, portalDescription, portalLogoUrl)=>({
        subHeading: portalName,
        description: portalDescription,
        logoUrl: portalLogoUrl,
        dangerouslyAllowHtmlInDescription: true
    }));
var $9b4782569d54d456$export$2e2bcd8739ae039 = (0, $bmgw6.default)($9b4782569d54d456$var$selector)((0, $2TkKH.default));

});


parcelRegister("hg03Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c8ab56c8ae36d2b$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $0c8ab56c8ae36d2b$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    addAnnoucement: {
        defaultMessage: 'Add announcement',
        description: 'Text for add announcement button',
        id: 'cv.portal.home.add.announcement.button'
    },
    editAnnouncement: {
        defaultMessage: 'Edit announcement',
        description: 'Text for edit announcement button',
        id: 'cv.portal.home.edit.announcement.button'
    },
    requestTypePageTitle: {
        defaultMessage: '{requestTypeName} - {portalName} - Jira Service Management',
        description: 'Page title for portal page when customer selected a request type form',
        id: 'sd.jsm.customerview.request.type.selected.portal.page.title'
    },
    portalPageTitle: {
        defaultMessage: '{portalName} - Jira Service Management',
        description: 'Page title for portal landing page',
        id: 'sd.jsm.customerview.portal.page.title'
    },
    portalGroupPageTitle: {
        defaultMessage: '{portalName} - Raise a request - Jira Service Management',
        description: 'Page title for portal group page',
        id: 'sd.jsm.customerview.portal.group.page.title'
    }
});

});






parcelRegister("3Qwj5", function(module, exports) {
$parcel$export(module.exports, "requestApprovalRoute", () => $faadda67769a5bf0$export$bcdc6af6b60bfb08);

var $748yq = parcelRequire("748yq");

var $dedFH = parcelRequire("dedFH");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");
const $faadda67769a5bf0$var$route = {
    name: 'request-approval',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/:requestKey/approval/:approvalId/:decision`,
    exact: true,
    component: (0, $dedFH.RequestApproval)
};
const $faadda67769a5bf0$var$screenName = (0, $748yq.ScreenName).REQUEST_APPROVAL;
const $faadda67769a5bf0$var$paperAppearance = 'normal';
const $faadda67769a5bf0$var$layoutProps = {
    ...(0, $1XMNp.anonymousScreenLayout),
    paperAppearance: $faadda67769a5bf0$var$paperAppearance
};
const $faadda67769a5bf0$export$bcdc6af6b60bfb08 = (0, $bp9tj.createRouteWithLayout)($faadda67769a5bf0$var$route, $faadda67769a5bf0$var$screenName, $faadda67769a5bf0$var$layoutProps);

});
parcelRegister("dedFH", function(module, exports) {
$parcel$export(module.exports, "RequestApproval", () => $f90dc3043f8d8628$export$741ffb1ed280e417);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $f90dc3043f8d8628$export$741ffb1ed280e417 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("jfzhI")), {
        moduleId: "./src/view/request-approval/hocs.tsx"
    })
});

});
parcelRegister("jfzhI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("kRKbf").then(()=>parcelRequire('jb0gl'));

});



parcelRegister("6FTHb", function(module, exports) {
$parcel$export(module.exports, "requestDetailsRoute", () => $b71483868975c252$export$c7023f3ff27ad6e1);

var $748yq = parcelRequire("748yq");
parcelRequire("d4hdo");
var $HSg4L = parcelRequire("HSg4L");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");
const $b71483868975c252$var$route = {
    name: 'request-details',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/:requestKey`,
    exact: true,
    component: (0, $HSg4L.default)
};
const $b71483868975c252$var$screenName = (0, $748yq.ScreenName).REQUEST_DETAILS;
const $b71483868975c252$var$paperAppearance = 'xxwide';
const $b71483868975c252$var$layoutProps = {
    paperAppearance: $b71483868975c252$var$paperAppearance,
    hideSearchButton: false,
    fadeInSearchModal: true
};
const $b71483868975c252$export$c7023f3ff27ad6e1 = (0, $bp9tj.createRouteWithLayout)($b71483868975c252$var$route, $b71483868975c252$var$screenName, $b71483868975c252$var$layoutProps);

});
parcelRegister("d4hdo", function(module, exports) {
$parcel$export(module.exports, "RequestDetails", () => (parcelRequire("HSg4L")).default);

var $HSg4L = parcelRequire("HSg4L");

});
parcelRegister("HSg4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $2187842687b218db$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $ibOOf = parcelRequire("ibOOf");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("cKnoq");
var $gEejF = parcelRequire("gEejF");
parcelRequire("2tSqN");
var $fdC0k = parcelRequire("fdC0k");
parcelRequire("gU2Af");
var $5gvbl = parcelRequire("5gvbl");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("kj8tT");
var $kVy9t = parcelRequire("kVy9t");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $2YYyL = parcelRequire("2YYyL");

var $2jpwX = parcelRequire("2jpwX");

var $gB5qu = parcelRequire("gB5qu");
const $2187842687b218db$var$selector = (0, $3yyCx.createSelector)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $95tqy.getPortal)(state, (0, $2jpwX.toNumber)(props.match.params.portalId)), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $kVy9t.getRequestDetails)(state, props.match.params.requestKey), // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
(state, props)=>(0, $kVy9t.getError)(state, props.match.params.requestKey), (state, props)=>{
    return (0, $95tqy.getName)(state, Number(props.match.params.portalId)) ?? (0, $fdC0k.getPortalNameFromBranding)(state);
}, (state, props)=>(0, $2YYyL.getIssueAnalyticsContext)(state, Number(props.match.params.portalId)), (state)=>(0, $2hx7o.isAtlassianAccountManaged)(state), (state, props)=>(0, $5gvbl.getRequestSpecificConnectAddonPanels)({
        state: state,
        location: 'detailsPanels',
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        requestKey: props.match.params.requestKey
    }), (state, props)=>{
    return Boolean((0, $95tqy.getCanAdministerProject)(state, Number(props.match.params.portalId)));
}, (portal, requestDetails, persistedError, portalName, issueAnalyticsContext, isManagedAccount, connectPanels, isProjectAdmin)=>({
        portal: portal,
        requestDetails: requestDetails,
        issueAnalyticsContext: issueAnalyticsContext,
        portalName: portalName,
        isProjectAdmin: isProjectAdmin,
        isAtlassianManagedAccount: isManagedAccount,
        ...persistedError,
        hasConnectPanels: connectPanels && connectPanels.length > 0,
        isLoading: requestDetails === undefined && persistedError === undefined
    }));
var $2187842687b218db$export$2e2bcd8739ae039 = (0, $bmgw6.default)($2187842687b218db$var$selector, {
    fetchPortal: (0, $lXazD.fetchPortalAction),
    fetchRequestDetails: (0, $gEejF.fetchRequestDetailsModel),
    changeSubscriptionAction: (0, $gEejF.changeSubscription)
})((0, $ibOOf.default)((0, $gB5qu.default)));

});
parcelRegister("kj8tT", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => (parcelRequire("kVy9t")).getRequestDetails);
$parcel$export(module.exports, "getError", () => (parcelRequire("kVy9t")).getError);
$parcel$export(module.exports, "isTransitionDialogVisible", () => (parcelRequire("kVy9t")).isTransitionDialogVisible);
$parcel$export(module.exports, "isTransactionInProgress", () => (parcelRequire("kVy9t")).isTransactionInProgress);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => (parcelRequire("kVy9t")).getReadMediaApiCredentials);
$parcel$export(module.exports, "getTransitionFailure", () => (parcelRequire("kVy9t")).getTransitionFailure);
$parcel$export(module.exports, "getCommentIsSubmitting", () => (parcelRequire("kVy9t")).getCommentIsSubmitting);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => (parcelRequire("kVy9t")).getCommentBeingSubmitted);
$parcel$export(module.exports, "getReporter", () => (parcelRequire("kVy9t")).getReporter);
$parcel$export(module.exports, "getParticipants", () => (parcelRequire("kVy9t")).getParticipants);
$parcel$export(module.exports, "getOrganisations", () => (parcelRequire("kVy9t")).getOrganisations);
$parcel$export(module.exports, "getCanRemoveParticipants", () => (parcelRequire("kVy9t")).getCanRemoveParticipants);
$parcel$export(module.exports, "getCanSearchParticipants", () => (parcelRequire("kVy9t")).getCanSearchParticipants);
$parcel$export(module.exports, "getCanShareRequest", () => (parcelRequire("kVy9t")).getCanShareRequest);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => (parcelRequire("kVy9t")).getCanSubmitWithEmailAddress);
$parcel$export(module.exports, "getInProgressApprovalAction", () => (parcelRequire("kVy9t")).getInProgressApprovalAction);
$parcel$export(module.exports, "getCanAddComment", () => (parcelRequire("kVy9t")).getCanAddComment);
$parcel$export(module.exports, "getCanExport", () => (parcelRequire("kVy9t")).getCanExport);
$parcel$export(module.exports, "getIssueType", () => (parcelRequire("kVy9t")).getIssueType);
$parcel$export(module.exports, "getIssueTypeId", () => (parcelRequire("kVy9t")).getIssueTypeId);
$parcel$export(module.exports, "getIssueKey", () => (parcelRequire("kVy9t")).getIssueKey);
$parcel$export(module.exports, "getIssueId", () => (parcelRequire("kVy9t")).getIssueId);

var $kVy9t = parcelRequire("kVy9t");

});
parcelRegister("kVy9t", function(module, exports) {
$parcel$export(module.exports, "getRequestDetails", () => $642de0093ec17aca$export$76e59470e6bca129);
$parcel$export(module.exports, "getError", () => $642de0093ec17aca$export$e1599abf47b5b568);
$parcel$export(module.exports, "isTransactionInProgress", () => $642de0093ec17aca$export$5e8f929af64a353a);
$parcel$export(module.exports, "getTransitionFailure", () => $642de0093ec17aca$export$a047f9f9384611fe);
$parcel$export(module.exports, "getReadMediaApiCredentials", () => $642de0093ec17aca$export$cef4d2d501c0dcdb);
$parcel$export(module.exports, "getCommentIsSubmitting", () => $642de0093ec17aca$export$c18738b22e944190);
$parcel$export(module.exports, "getCommentBeingSubmitted", () => $642de0093ec17aca$export$706d262046c8358f);
$parcel$export(module.exports, "getReporter", () => $642de0093ec17aca$export$e8105f4fd5ecc593);
$parcel$export(module.exports, "getParticipants", () => $642de0093ec17aca$export$ccadfc093764e9cd);
$parcel$export(module.exports, "getOrganisations", () => $642de0093ec17aca$export$17495f9c20464b8);
$parcel$export(module.exports, "getCanSubmitWithEmailAddress", () => $642de0093ec17aca$export$c1d23959dfbf9e60);
$parcel$export(module.exports, "getCanSearchParticipants", () => $642de0093ec17aca$export$1fb693409140fdf8);
$parcel$export(module.exports, "getCanShareRequest", () => $642de0093ec17aca$export$bd1011b4c5e87dfc);
$parcel$export(module.exports, "getCanRemoveParticipants", () => $642de0093ec17aca$export$8e53e7bfa4b4035a);
$parcel$export(module.exports, "getCanAddComment", () => $642de0093ec17aca$export$71d5372270878818);
$parcel$export(module.exports, "isTransitionDialogVisible", () => $642de0093ec17aca$export$5d33edbc6a385b);
$parcel$export(module.exports, "getInProgressApprovalAction", () => $642de0093ec17aca$export$55685a606a2adcb4);
$parcel$export(module.exports, "getIssueType", () => $642de0093ec17aca$export$ed2455632bf977ef);
$parcel$export(module.exports, "getIssueTypeId", () => $642de0093ec17aca$export$110c9a4a16c5b8c9);
$parcel$export(module.exports, "getIssueKey", () => $642de0093ec17aca$export$4a030f6192bebe03);
$parcel$export(module.exports, "getIssueId", () => $642de0093ec17aca$export$b4dd560abafd1fae);
$parcel$export(module.exports, "getCanExport", () => $642de0093ec17aca$export$eda75b639af011cf);
const $642de0093ec17aca$var$getRequestDetailsOrError = (state, requestKey)=>{
    if (requestKey && state.persisted.requestDetails) return state.persisted.requestDetails[requestKey];
    return undefined;
};
const $642de0093ec17aca$export$76e59470e6bca129 = (state, requestKey)=>{
    const data = $642de0093ec17aca$var$getRequestDetailsOrError(state, requestKey);
    return $642de0093ec17aca$var$isError(data) ? undefined : data;
};
const $642de0093ec17aca$var$isError = (data)=>data !== undefined && 'error' in data;
const $642de0093ec17aca$export$e1599abf47b5b568 = (state, requestKey)=>{
    const data = $642de0093ec17aca$var$getRequestDetailsOrError(state, requestKey);
    return $642de0093ec17aca$var$isError(data) ? data : undefined;
};
const $642de0093ec17aca$export$5e8f929af64a353a = (state, transactionId)=>{
    const { inProgressTransitionId: inProgressTransitionId } = state.ui.requestDetails;
    return inProgressTransitionId !== undefined && inProgressTransitionId === transactionId;
};
const $642de0093ec17aca$export$a047f9f9384611fe = (state)=>{
    return state.ui.requestDetails.transitionFailure;
};
const $642de0093ec17aca$export$cef4d2d501c0dcdb = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.readFileMediaCredentials : undefined;
};
const $642de0093ec17aca$export$c18738b22e944190 = (state)=>{
    return state.ui.requestDetails.commentSubmitting;
};
const $642de0093ec17aca$export$706d262046c8358f = (state)=>{
    return state.ui.requestDetails.commentBeingSubmitted;
};
const $642de0093ec17aca$export$e8105f4fd5ecc593 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.reporter : undefined;
};
const $642de0093ec17aca$export$ccadfc093764e9cd = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.participants : undefined;
};
const $642de0093ec17aca$export$17495f9c20464b8 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.organisations : undefined;
};
const $642de0093ec17aca$export$c1d23959dfbf9e60 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSubmitWithEmailAddress : false;
};
const $642de0093ec17aca$export$1fb693409140fdf8 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canSearchParticipants : false;
};
const $642de0093ec17aca$export$bd1011b4c5e87dfc = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canShareRequest : false;
};
const $642de0093ec17aca$export$8e53e7bfa4b4035a = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canRemoveParticipants : false;
};
const $642de0093ec17aca$export$71d5372270878818 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.canAddComment : false;
};
const $642de0093ec17aca$export$5d33edbc6a385b = (state, id)=>{
    return state.ui.requestDetails.visibleTransitionDialog === id;
};
const $642de0093ec17aca$export$55685a606a2adcb4 = (state)=>{
    return state.ui.requestDetails.inProgressApprovalAction;
};
const $642de0093ec17aca$export$d23b1708046e514c = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return !!(requestDetails !== null && requestDetails !== void 0 && requestDetails.hasProformaForm);
};
const $642de0093ec17aca$export$ed2455632bf977ef = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueTypeName;
};
const $642de0093ec17aca$export$110c9a4a16c5b8c9 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issueType;
};
const $642de0093ec17aca$export$4a030f6192bebe03 = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.key;
};
const $642de0093ec17aca$export$b4dd560abafd1fae = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails && requestDetails.issue.id;
};
const $642de0093ec17aca$export$eda75b639af011cf = (state, requestKey)=>{
    const requestDetails = $642de0093ec17aca$export$76e59470e6bca129(state, requestKey);
    return requestDetails ? requestDetails.issue.canExport : false;
};

});


parcelRegister("2YYyL", function(module, exports) {
$parcel$export(module.exports, "getIssueAnalyticsContext", () => $4a402605a549f9cf$export$fe0282397d97e2a6);
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
const $4a402605a549f9cf$export$fe0282397d97e2a6 = (state, portalId)=>({
        user: {
            getAgentForPortal: ()=>(0, $2hx7o.getAgentForPortal)(state),
            getAccountId: ()=>(0, $2hx7o.getAccountId)(state)
        },
        portal: {
            getPortalAnnouncement: ()=>({
                    getCanAdministerProject: ()=>(0, $95tqy.getCanAdministerProject)(state, portalId)
                })
        }
    });

});

parcelRegister("gB5qu", function(module, exports) {
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_RESULT_QUERY_PARAM", () => $e2f44f027a44cb90$export$491313a4e8829a1a);
$parcel$export(module.exports, "APPROVAL_BY_EMAIL_QUERY_PARAM_SUCCESS", () => $e2f44f027a44cb90$export$fddfe2b6ca9cfe5c);
$parcel$export(module.exports, "default", () => $e2f44f027a44cb90$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $MM3bs = parcelRequire("MM3bs");

var $efDRU = parcelRequire("efDRU");

var $kXlzl = parcelRequire("kXlzl");

var $PL4bf = parcelRequire("PL4bf");
parcelRequire("jVjjC");
var $7Kgqq = parcelRequire("7Kgqq");
var $bLf1t = parcelRequire("bLf1t");
parcelRequire("edbe7");
var $hhubI = parcelRequire("hhubI");

var $7EbRj = parcelRequire("7EbRj");

var $esYUU = parcelRequire("esYUU");
const $e2f44f027a44cb90$export$491313a4e8829a1a = 'approval';
const $e2f44f027a44cb90$export$fddfe2b6ca9cfe5c = '200';
class $e2f44f027a44cb90$export$1ec22ccbfe26843b extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidMount() {
        const { portalId: portalId, fetchPortal: fetchPortal, fetchRequestDetails: fetchRequestDetails, requestKey: key } = this.props;
        fetchRequestDetails({
            key: key,
            portalId: Number(portalId)
        });
        fetchPortal({
            id: Number(portalId),
            expand: [
                'analyticsContext'
            ]
        });
        this.trackIssueViewed();
        this.setState({
            isApprovalError: this.checkIfApprovalError()
        });
    }
    componentDidUpdate(prevProps) {
        const { portal: portal, requestDetails: requestDetails } = this.props;
        if (portal && portal.analyticAttributes && requestDetails && !requestDetails.userMentionedDuringRequestCreation) {
            if (!prevProps.portal || !prevProps.portal.analyticAttributes || !prevProps.requestDetails) this.trackIssueViewed();
            else if (portal.id !== prevProps.portal.id || requestDetails.issue.id !== prevProps.requestDetails.issue.id) this.trackIssueViewed();
        }
    }
    trackIssueViewed() {
        const { portal: portal, requestDetails: requestDetails, issueAnalyticsContext: issueAnalyticsContext } = this.props;
        if (!portal || !portal.analyticAttributes || !requestDetails) return;
        const { issue: issue, issueType: issueType, workflowTransitions: workflowTransitions } = requestDetails;
        const { requestTypeId: requestTypeId, id: issueId } = issue;
        const customerTransitionIds = workflowTransitions ? workflowTransitions.map((transition)=>transition.id) : undefined;
        (0, $kXlzl.trackIssueEvent)({
            issueId: issueId,
            projectId: String(portal.projectId),
            action: 'viewed',
            attributes: {
                customerTransitionIds: customerTransitionIds,
                numberOfCustomerTransitionIds: customerTransitionIds && customerTransitionIds.length,
                portalId: String(portal.id),
                issueTypeId: issueType,
                requestTypeId: String(requestTypeId),
                ...portal.analyticAttributes
            }
        }, issueAnalyticsContext.user, issueAnalyticsContext.portal);
    }
    render() {
        var _this$props$portal, _requestDetails$appro2;
        const { isApprovalError: isApprovalError } = this.state;
        const { requestDetails: requestDetails, isLoading: isLoading, portalName: portalName, requestKey: requestKey, portal: portal, hasConnectPanels: hasConnectPanels, isProjectAdmin: isProjectAdmin } = this.props;
        const serviceDeskId = Number(portal === null || portal === void 0 ? void 0 : portal.serviceDeskId);
        const portalId = Number(this.props.portalId);
        const projectId = Number(portal === null || portal === void 0 ? void 0 : portal.projectId);
        const projectKey = (_this$props$portal = this.props.portal) === null || _this$props$portal === void 0 ? void 0 : _this$props$portal.projectKey;
        const isAtlassianManagedAccount = this.props.isAtlassianManagedAccount;
        const shouldShowLearnByDoingExperimentBanner = (0, $bLf1t.shouldShowLearnByDoingBanner)(isProjectAdmin, $PL4bf.get((0, $7Kgqq.REFERRER_QUERY_PARAM)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isApprovalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hhubI.default), {
            approvalError: this.getApprovalError(),
            hasDecision: (requestDetails === null || requestDetails === void 0 || (_requestDetails$appro2 = requestDetails.approvalStatus[0]) === null || _requestDetails$appro2 === void 0 || (_requestDetails$appro2 = _requestDetails$appro2.decision) === null || _requestDetails$appro2 === void 0 ? void 0 : _requestDetails$appro2.decision) !== undefined,
            onDismissError: this.onDismissError
        }) : [], /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $esYUU.default), {
            requestDetails: requestDetails,
            isLoading: isLoading,
            isAtlassianManagedAccount: isAtlassianManagedAccount,
            serviceDeskId: serviceDeskId,
            portalId: portalId,
            projectId: projectId,
            requestKey: requestKey,
            onNotificationChange: this.onNotificationChange,
            portalName: portalName,
            hasConnectPanels: hasConnectPanels,
            detailsHiddenOnInitialView: !!this.detailsHiddenOnInitialView,
            activityItemsHiddenOnInitialView: !!this.activityItemsHiddenOnInitialView,
            removeOldParticipantsAndReporterFromComment: this.removeOldParticipantsAndReporterFromComment,
            projectKey: projectKey,
            shouldShowLearnByDoingExperimentBanner: shouldShowLearnByDoingExperimentBanner
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isApprovalError: false
        }, this.onNotificationChange = (shouldSubscribe)=>{
            const { requestDetails: requestDetails, changeSubscriptionAction: changeSubscriptionAction } = this.props;
            if (requestDetails) changeSubscriptionAction(requestDetails.key, requestDetails.issue.id, shouldSubscribe);
        }, this.checkIfApprovalError = ()=>{
            return !!$PL4bf.get($e2f44f027a44cb90$export$491313a4e8829a1a) && $PL4bf.get($e2f44f027a44cb90$export$491313a4e8829a1a) !== $e2f44f027a44cb90$export$fddfe2b6ca9cfe5c;
        }, this.getApprovalError = ()=>{
            return this.checkIfApprovalError() ? $PL4bf.get($e2f44f027a44cb90$export$491313a4e8829a1a) : undefined;
        }, this.onDismissError = ()=>{
            this.setState({
                isApprovalError: false
            });
        }, this.removeOldParticipantsAndReporterFromComment = (accountIds)=>{
            const requestDetails = this.props.requestDetails;
            if (requestDetails) {
                const { participants: participants, reporter: reporter } = requestDetails;
                /* Removing user mentions which should not be added as request participants */ (reporter === null || reporter === void 0 ? void 0 : reporter.accountId) && accountIds.delete(reporter === null || reporter === void 0 ? void 0 : reporter.accountId);
                participants.forEach((participant)=>accountIds.delete(participant.accountId));
            }
            return accountIds;
        }, this.getFlagTitleAndDescription = ()=>{
            var _requestDetails$appro;
            // Error messages for approve by email
            const { intl: intl, requestDetails: requestDetails } = this.props;
            const decision = requestDetails === null || requestDetails === void 0 || (_requestDetails$appro = requestDetails.approvalStatus[0]) === null || _requestDetails$appro === void 0 || (_requestDetails$appro = _requestDetails$appro.decision) === null || _requestDetails$appro === void 0 ? void 0 : _requestDetails$appro.decision;
            switch($PL4bf.get($e2f44f027a44cb90$export$491313a4e8829a1a)){
                case '400':
                    if (decision) // if decision already made
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    // if misspelling in url
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    // if approver has been removed as approver by admin
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription403)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitleDefault, {
                            value: $PL4bf.get($e2f44f027a44cb90$export$491313a4e8829a1a) ?? ''
                        }),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $e2f44f027a44cb90$export$2e2bcd8739ae039 = (0, $MM3bs.withErrorPage)((0, $efDRU.default)($e2f44f027a44cb90$export$1ec22ccbfe26843b));

});
parcelRegister("edbe7", function(module, exports) {
$parcel$export(module.exports, "ApprovalErrorFlag", () => (parcelRequire("hhubI")).default);

var $hhubI = parcelRequire("hhubI");

});
parcelRegister("hhubI", function(module, exports) {
$parcel$export(module.exports, "default", () => $173a6a508e87e304$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $efDRU = parcelRequire("efDRU");

var $edOls = parcelRequire("edOls");
var $h1mlL = parcelRequire("h1mlL");

var $hMwsV = parcelRequire("hMwsV");

var $7EbRj = parcelRequire("7EbRj");
class $173a6a508e87e304$export$15f2320c01f1c048 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { approvalError: approvalError, onDismissError: onDismissError, intl: intl } = this.props;
        const { title: title, description: description } = this.getFlagTitleAndDescription();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h1mlL.default), {
            onDismissed: onDismissError
        }, approvalError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $edOls.default), {
            id: "approve-by-email-fail-approve-error-flag",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMwsV))), {
                spacing: "spacious",
                color: "var(--ds-icon-danger, #BF2600)",
                label: ""
            }),
            title: title,
            description: description,
            actions: [
                {
                    content: intl.formatMessage((0, $7EbRj.default).dismiss),
                    onClick: ()=>onDismissError()
                }
            ]
        }) : []);
    }
    constructor(...args){
        super(...args), this.getFlagTitleAndDescription = ()=>{
            const { intl: intl, hasDecision: hasDecision, approvalError: approvalError } = this.props;
            switch(approvalError){
                case '400':
                    if (hasDecision) return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle400_2),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription400_2)
                    };
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle400_1),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription400_1, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("b", null, chunks)
                        })
                    };
                case '403':
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle403),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription403)
                    };
                case '404':
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle404),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription404)
                    };
                case '409':
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitle409),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescription409)
                    };
                default:
                    return {
                        title: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagTitleDefault, {}),
                        description: intl.formatMessage((0, $7EbRj.default).approvalByEmailErrorFlagDescriptionDefault, {
                            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("b", null, chunks)
                        })
                    };
            }
        };
    }
}
var $173a6a508e87e304$export$2e2bcd8739ae039 = (0, $efDRU.default)($173a6a508e87e304$export$15f2320c01f1c048);

});
parcelRegister("7EbRj", function(module, exports) {
$parcel$export(module.exports, "default", () => $caaff3a1aa5dfe09$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $caaff3a1aa5dfe09$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    dismiss: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss error flag message',
        id: 'cv.request.details.approve.by.email.approval.error.dismiss.flag.message'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_1: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_1: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page.',
        description: 'Description for the flag when there is a 400 error, type 1 (misspelling in url)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_1'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagTitle400_2: {
        defaultMessage: 'You no longer need to approve or decline',
        description: 'Title for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.title400_2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    approvalByEmailErrorFlagDescription400_2: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 400 error, type 2 (approval already completed)',
        id: 'cv.request.details.approve.by.email.approval.error.description400_2'
    },
    approvalByEmailErrorFlagTitle403: {
        defaultMessage: 'You need permission to approve this request',
        description: 'Title for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.title401'
    },
    approvalByEmailErrorFlagDescription403: {
        defaultMessage: `Ask your admin if you\u{2019}re on the approvers list, or check that you\u{2019}re logged in with the right account.`,
        description: 'Description for the flag when there is a 403 error',
        id: 'cv.request.details.approve.by.email.approval.error.description401'
    },
    approvalByEmailErrorFlagTitle404: {
        defaultMessage: `We couldn\u{2019}t update the request`,
        description: 'Title for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.title404'
    },
    approvalByEmailErrorFlagDescription404: {
        defaultMessage: 'This request no longer needs approval. It may have been updated or deleted.',
        description: 'Description for the flag when there is a 404 error',
        id: 'cv.request.details.approve.by.email.approval.error.description404'
    },
    approvalByEmailErrorFlagTitle409: {
        defaultMessage: 'Approval not required',
        description: 'Title for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.title409'
    },
    approvalByEmailErrorFlagDescription409: {
        defaultMessage: 'This request has already been approved or declined.',
        description: 'Description for the flag when there is a 409 error',
        id: 'cv.request.details.approve.by.email.approval.error.description409'
    },
    approvalByEmailErrorFlagTitleDefault: {
        defaultMessage: "We couldn't record your selection",
        description: 'Title for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.title.default'
    },
    approvalByEmailErrorFlagDescriptionDefault: {
        defaultMessage: 'Select <b>Approve</b> or <b>Decline</b> on this page if available, or try again later.',
        description: 'Description for the flag when there is a an error not already accounted for',
        id: 'cv.request.details.approve.by.email.approval.error.description.default'
    }
});

});



parcelRegister("esYUU", function(module, exports) {
$parcel$export(module.exports, "default", () => $e619613e305e77e1$export$2e2bcd8739ae039);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $e619613e305e77e1$var$loader = (0, $60vf0.lazyForPaint)(()=>(parcelRequire("hj3KS")), {
    moduleId: "./src/view/request-details/request-details-stateless/request-details-stateless.tsx"
});
var $e619613e305e77e1$export$2e2bcd8739ae039 = (0, $gi5ak.default)({
    loader: $e619613e305e77e1$var$loader
});

});
parcelRegister("hj3KS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5YgJY"),
    $e46AW("gtuk5"),
    $e46AW("jQ0w0"),
    $e46AW("7sKJw"),
    $e46AW("958rd"),
    $e46AW("45caK"),
    $e46AW("3vgBs"),
    $e46AW("83e22"),
    $e46AW("8oU5a"),
    $e46AW("lESQD"),
    $e46AW("eahZ0"),
    $e46AW("co70a"),
    $e46AW("9nrlJ")
]).then(()=>parcelRequire('k9BfE'));

});






parcelRegister("k05Lp", function(module, exports) {
$parcel$export(module.exports, "userSignupRoute", () => $905c5eea94ea1bc1$export$6c53daec3917ca4f);
$parcel$export(module.exports, "userResetPasswordRoute", () => $905c5eea94ea1bc1$export$a1ff4b1e673ba98c);
$parcel$export(module.exports, "userCompleteSignupRoute", () => $905c5eea94ea1bc1$export$61da5e60a0c99a8a);
$parcel$export(module.exports, "userCheckMailRoute", () => $905c5eea94ea1bc1$export$934c0e27338aac46);
$parcel$export(module.exports, "portalSignupRoute", () => $905c5eea94ea1bc1$export$766487cfd72c58e6);
$parcel$export(module.exports, "portalResetPasswordRoute", () => $905c5eea94ea1bc1$export$a52bd3b0b1b1499b);
$parcel$export(module.exports, "portalCompleteSignupRoute", () => $905c5eea94ea1bc1$export$c0d26476c776bd62);
$parcel$export(module.exports, "portalInvitedSignupRoute", () => $905c5eea94ea1bc1$export$124a02da2ab0bcaf);

var $748yq = parcelRequire("748yq");

var $3YrC4 = parcelRequire("3YrC4");

var $5vlcS = parcelRequire("5vlcS");

var $kg4nY = parcelRequire("kg4nY");

var $c3u3c = parcelRequire("c3u3c");

var $ap4D5 = parcelRequire("ap4D5");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");
const $905c5eea94ea1bc1$var$userSignup = {
    resources: [],
    name: 'user-signup',
    path: `/user/signup`,
    exact: true,
    component: (0, $c3u3c.SignUp)
};
const $905c5eea94ea1bc1$var$userResetPassword = {
    resources: [],
    name: 'user-reset-password',
    path: `/user/resetpassword`,
    exact: true,
    component: (0, $kg4nY.ResetPassword)
};
const $905c5eea94ea1bc1$var$userCompleteSignup = {
    resources: [],
    name: 'user-complete-signup',
    path: `/user/complete-signup`,
    exact: true,
    component: (0, $3YrC4.CompleteSignup)
};
const $905c5eea94ea1bc1$var$userCheckMail = {
    resources: [],
    name: 'user-checkmail',
    path: `/user/check-email`,
    exact: true,
    component: (0, $ap4D5.CheckEmail)
};
const $905c5eea94ea1bc1$var$portalSignup = {
    resources: [],
    name: 'portal-signup',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/signup`,
    exact: true,
    component: (0, $c3u3c.SignUp)
};
const $905c5eea94ea1bc1$var$portalResetPassword = {
    resources: [],
    name: 'portal-reset-password',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
    exact: true,
    component: (0, $kg4nY.ResetPassword)
};
const $905c5eea94ea1bc1$var$portalCompleteSignup = {
    resources: [],
    name: 'portal-complete-signup',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
    exact: true,
    component: (0, $3YrC4.CompleteSignup)
};
const $905c5eea94ea1bc1$var$portalInvitedSignup = {
    resources: [],
    name: 'portal-invited-signup',
    path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
    exact: true,
    component: (0, $5vlcS.InvitedSignUp)
};
const $905c5eea94ea1bc1$var$signUpScreenName = (0, $748yq.ScreenName).SIGNUP;
const $905c5eea94ea1bc1$export$6c53daec3917ca4f = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$userSignup, $905c5eea94ea1bc1$var$signUpScreenName, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$a1ff4b1e673ba98c = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$userResetPassword, (0, $748yq.ScreenName).RESET_PASSWORD, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$61da5e60a0c99a8a = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$userCompleteSignup, (0, $748yq.ScreenName).COMPLETE_SIGNUP, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$934c0e27338aac46 = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$userCheckMail, (0, $748yq.ScreenName).CHECK_EMAIL, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$766487cfd72c58e6 = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$portalSignup, $905c5eea94ea1bc1$var$signUpScreenName, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$a52bd3b0b1b1499b = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$portalResetPassword, (0, $748yq.ScreenName).RESET_PASSWORD, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$c0d26476c776bd62 = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$portalCompleteSignup, (0, $748yq.ScreenName).COMPLETE_SIGNUP, (0, $1XMNp.anonymousScreenLayout));
const $905c5eea94ea1bc1$export$124a02da2ab0bcaf = (0, $bp9tj.createRouteWithLayout)($905c5eea94ea1bc1$var$portalInvitedSignup, (0, $748yq.ScreenName).INVITED_SIGNUP, (0, $1XMNp.anonymousScreenLayout));

});
parcelRegister("3YrC4", function(module, exports) {
$parcel$export(module.exports, "CompleteSignup", () => $221a2622620bbfb8$export$372770c8487ebcca);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $221a2622620bbfb8$export$372770c8487ebcca = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("fRQrS")), {
        moduleId: "./src/view/complete-signup/hocs.tsx"
    })
});

});
parcelRegister("fRQrS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4m0E7").then(()=>parcelRequire('6avxT'));

});


parcelRegister("5vlcS", function(module, exports) {
$parcel$export(module.exports, "InvitedSignUp", () => $4db9448059a0e522$export$b6f2cb2bcdfbfdb9);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $4db9448059a0e522$export$b6f2cb2bcdfbfdb9 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("bUQQ8")), {
        moduleId: "./src/view/invited-sign-up/hocs.tsx"
    })
});

});
parcelRegister("bUQQ8", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4MeHQ").then(()=>parcelRequire('7ycJ0'));

});


parcelRegister("kg4nY", function(module, exports) {
$parcel$export(module.exports, "ResetPassword", () => $75c44a5db8ad908a$export$a4c3d56613a57187);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $75c44a5db8ad908a$export$a4c3d56613a57187 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cNL90")), {
        moduleId: "./src/view/reset-password/hocs.tsx"
    })
});

});
parcelRegister("cNL90", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("jrr2S").then(()=>parcelRequire('l4wOq'));

});


parcelRegister("c3u3c", function(module, exports) {
$parcel$export(module.exports, "SignUp", () => $4134a242a9428826$export$4ee457d816cea81a);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $4134a242a9428826$export$4ee457d816cea81a = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("ijCJF")), {
        moduleId: "./src/view/sign-up/hocs.tsx"
    })
});

});
parcelRegister("ijCJF", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("2Lpm3").then(()=>parcelRequire('iO5Fd'));

});


parcelRegister("ap4D5", function(module, exports) {
$parcel$export(module.exports, "CheckEmail", () => $f7197b6fc4a70613$export$fd89248056ed5439);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $f7197b6fc4a70613$export$fd89248056ed5439 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("8QkSg")), {
        moduleId: "./src/view/sign-up-check-email/hocs.tsx"
    })
});

});
parcelRegister("8QkSg", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lYcM1").then(()=>parcelRequire('6oPke'));

});



parcelRegister("jddke", function(module, exports) {
$parcel$export(module.exports, "getViewTopicRoute", () => $d47a2b821d4d484c$export$8c8c8d8cda238e84);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $yLYo1 = parcelRequire("yLYo1");

var $2jDnS = parcelRequire("2jDnS");

var $bp9tj = parcelRequire("bp9tj");
var $fZppw = parcelRequire("fZppw");

var $foWpz = parcelRequire("foWpz");
const $d47a2b821d4d484c$var$PageLoader = ()=>{
    const [{ match: { params: { id: id } } }] = (0, $hfD9S.useRouter)();
    (0, $yLYo1.default)(id);
    const { queryReference: queryReference } = (0, $fZppw.useRelayResource)((0, $foWpz.viewTopicResource));
    if (!queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2jDnS.ViewTopic), {
        topicId: id,
        queryReference: queryReference
    });
};
const $d47a2b821d4d484c$export$8c8c8d8cda238e84 = ()=>{
    const paperAppearance = (0, $bG6ob.isUseHelpCenterRefresh)() ? 'xwide' : 'normal';
    const layoutProps = {
        paperAppearance: paperAppearance,
        fadeInSearchModal: true
    };
    return (0, $bp9tj.createRouteWithLayout)({
        name: 'view-topic',
        path: '/topic/:id',
        exact: true,
        component: $d47a2b821d4d484c$var$PageLoader,
        resources: [
            (0, $foWpz.viewTopicResource)
        ]
    }, (0, $748yq.ScreenName).VIEW_TOPIC, layoutProps);
};

});
parcelRegister("2jDnS", function(module, exports) {
$parcel$export(module.exports, "ViewTopic", () => $34cc5c95265700ff$export$8036aeb45d373d7d);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $34cc5c95265700ff$var$loader = (0, $60vf0.lazyForPaint)(()=>(parcelRequire("jutCO")), {
    moduleId: "./src/view/topic/topic.tsx"
});
const $34cc5c95265700ff$export$8036aeb45d373d7d = (0, $gi5ak.default)({
    loader: $34cc5c95265700ff$var$loader
});

});
parcelRegister("jutCO", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("3vdHc"),
    $e46AW("avMio")
]).then(()=>parcelRequire('1RbVo'));

});


parcelRegister("foWpz", function(module, exports) {
$parcel$export(module.exports, "viewTopicResource", () => $c77873c7bc3b9f0a$export$425f51060493cc67);

var $1lTGx = parcelRequire("1lTGx");

var $fZppw = parcelRequire("fZppw");
const $c77873c7bc3b9f0a$export$425f51060493cc67 = (0, $fZppw.createRelayResource)({
    type: 'VIEW_TOPIC',
    getQuery: ({ match: { params: { id: id } } }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $1lTGx.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                topicId: String(id)
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("1lTGx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f25300100312bba3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04f0af7279f78d72dbeae49d34853aac>>
 * @relayHash ebbdf9e39eabac61b9f8917e5b0cac0d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1
const $f25300100312bba3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "topicId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "description"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v6 = {
        "kind": "ScalarField",
        "name": "entityKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "topicQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "helpCenterTopic_HelpCenterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "topicQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "helpCenterAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "topicId",
                                    "variableName": "topicId"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterTopicById",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "args": v3 /*: any*/ ,
                                            "concreteType": "HelpCenterTopicItemConnection",
                                            "kind": "LinkedField",
                                            "name": "items",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterTopicItemEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterTopicItem",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "ari"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v1 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isHelpCenterHelpObject"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "HelpObjectStoreIcon",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "icon",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "iconUrl"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreRequestForm"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreArticle"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v4 /*: any*/ ,
                                                                                v2 /*: any*/ ,
                                                                                v5 /*: any*/ ,
                                                                                v6 /*: any*/ ,
                                                                                v7 /*: any*/ 
                                                                            ],
                                                                            "type": "HelpObjectStoreChannel"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ 
                                                                            ],
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        }
                                                                    ]
                                                                },
                                                                v1 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "items(first:10)"
                                        },
                                        {
                                            "args": v3 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "mainHelpObjectsList_HelpCenterTopic_items",
                                            "kind": "LinkedHandle",
                                            "name": "items"
                                        }
                                    ],
                                    "type": "HelpCenterTopic"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "statusCode"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "eedf2118595dd8d898ad076ceca26fa45ca7388997a647bde47c19cb9867baf1",
            "metadata": {},
            "name": "topicQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f25300100312bba3$var$node.hash = "aad6fa68f7fdec1c20c0311c482bf40f";
var $f25300100312bba3$export$2e2bcd8739ae039 = $f25300100312bba3$var$node;

});



parcelRegister("dq1KB", function(module, exports) {
$parcel$export(module.exports, "userVerifyEmailRoute", () => $cf3c7296587f6c2d$export$421ececb54aacf4e);

var $748yq = parcelRequire("748yq");

var $fGnLE = parcelRequire("fGnLE");

var $bp9tj = parcelRequire("bp9tj");

var $1XMNp = parcelRequire("1XMNp");
const $cf3c7296587f6c2d$var$userVerifyEmail = {
    resources: [],
    name: 'verify-email',
    path: `/user/verify-email`,
    exact: true,
    component: (0, $fGnLE.VerifyEmail)
};
const $cf3c7296587f6c2d$export$421ececb54aacf4e = (0, $bp9tj.createRouteWithLayout)($cf3c7296587f6c2d$var$userVerifyEmail, (0, $748yq.ScreenName).VERIFY_EMAIL, (0, $1XMNp.anonymousScreenLayout));

});
parcelRegister("fGnLE", function(module, exports) {
$parcel$export(module.exports, "VerifyEmail", () => $89c0563b543a54ef$export$3d3197b723615cc);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $89c0563b543a54ef$export$3d3197b723615cc = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("l1Hny")), {
        moduleId: "./src/view/verify-email/hocs.tsx"
    })
});

});
parcelRegister("l1Hny", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7LVWx").then(()=>parcelRequire('aemps'));

});



parcelRegister("4we4O", function(module, exports) {
$parcel$export(module.exports, "UFOWatcher", () => $c5dfab4719717a32$export$261b8a18a570aef7);

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $c62a8 = parcelRequire("c62a8");

var $7QaVt = parcelRequire("7QaVt");

var $e8T4h = parcelRequire("e8T4h");

var $iOZbf = parcelRequire("iOZbf");

var $1Nhsz = parcelRequire("1Nhsz");
const $c5dfab4719717a32$var$INTERESTING_RESOURCE_PATTERNS = [
    {
        spanLabel: 'jsapi.js',
        regEx: /\/jsapi\.js/
    },
    {
        spanLabel: 'challenge.js',
        regEx: /\/challenge\.js/
    },
    {
        spanLabel: 'vendor-react.chunk.js',
        regEx: /\/vendor-react\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-vendor.chunk.js',
        regEx: /\/servicedesk-vendor\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-atlaskit.chunk.js',
        regEx: /\/servicedesk-atlaskit\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'compiled-css.chunk.js',
        regEx: /\/compiled-css\.chunk\..{0,64}js/
    },
    {
        spanLabel: 'servicedesk-customerportal.bundle.js',
        regEx: /\/servicedesk-customerportal\.bundle\..{0,64}js/
    }
];
function $c5dfab4719717a32$var$addResourceTimingsToUFO() {
    var _globalThis$performan, _globalThis$performan2;
    ((_globalThis$performan = globalThis.performance) === null || _globalThis$performan === void 0 ? void 0 : _globalThis$performan.getEntriesByType) && Array.from((_globalThis$performan2 = globalThis.performance) === null || _globalThis$performan2 === void 0 ? void 0 : _globalThis$performan2.getEntriesByType('resource')).forEach((entry)=>{
        for (const resource of $c5dfab4719717a32$var$INTERESTING_RESOURCE_PATTERNS)if (resource.regEx.test(entry.name)) (0, $c62a8.addSpanToAll)('fetch', resource.spanLabel, [
            {
                name: 'custom-network'
            },
            {
                name: 'resources'
            }
        ], entry.startTime, entry.startTime + entry.duration);
    });
}
const $c5dfab4719717a32$export$261b8a18a570aef7 = ()=>{
    const isInitial = (0, $4fqPo.useRef)(true);
    const [routerState] = (0, $hfD9S.useRouter)();
    const route = routerState.route;
    const match = routerState.match;
    let ufoName = (0, $7QaVt.default)(route).toLowerCase();
    if ('getUFONameBasedOnRouteMatch' in route && route.getUFONameBasedOnRouteMatch instanceof Function) ufoName = route.getUFONameBasedOnRouteMatch(match);
    const lastUFOName = (0, $4fqPo.useRef)(ufoName);
    if (ufoName) {
        if ((0, $bG6ob.isUiModificationsSupportEnabled)() && ufoName === (0, $748yq.ExperienceName).REQUEST_CREATE) (0, $1Nhsz.startScreenTTIWithUIModifications)();
        if (isInitial.current) {
            $c5dfab4719717a32$var$addResourceTimingsToUFO();
            (0, $e8T4h.default)(ufoName);
            isInitial.current = false;
        }
        if (lastUFOName.current !== ufoName && !isInitial.current) {
            lastUFOName.current = ufoName;
            (0, $iOZbf.default)(ufoName);
        }
    }
    return null;
};

});
parcelRegister("7QaVt", function(module, exports) {
$parcel$export(module.exports, "default", () => $05637b858a98b157$export$2e2bcd8739ae039);
function $05637b858a98b157$var$getUFORouteName(route) {
    if (route.ufoName != null) return route.ufoName;
    return route.name;
}
var $05637b858a98b157$export$2e2bcd8739ae039 = $05637b858a98b157$var$getUFORouteName;

});

parcelRegister("e8T4h", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5a44f70fd2606ea$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2OOKU = parcelRequire("2OOKU");

var $4Bdcb = parcelRequire("4Bdcb");

var $jFknK = parcelRequire("jFknK");

var $bqHVm = parcelRequire("bqHVm");

var $87Bg8 = parcelRequire("87Bg8");

var $c62a8 = parcelRequire("c62a8");

var $eFsN4 = parcelRequire("eFsN4");
const $d5a44f70fd2606ea$var$AWAITING_PAGELOAD_NAME = 'awaiting_pageload_name';
function $d5a44f70fd2606ea$var$traceUFOPageLoad(ufoName, routeName = ufoName) {
    if (!(0, $jFknK.isUFOEnabled)()) return;
    const activeInteraction = (0, $c62a8.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $eFsN4.default).current = routeName || null;
    const rate = ufoName ? (0, $jFknK.getInteractionRate)(ufoName, 'page_load') : 1;
    const enabledBySamplingRate = (0, $4Bdcb.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const newId = (0, $2OOKU.v4)();
        (0, $87Bg8.DefaultInteractionID).current = newId;
        (0, $c62a8.addNewInteraction)(newId, ufoName || '', 'page_load', 0, rate, null, routeName, (0, $bqHVm.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $c62a8.addHoldByID)(newId, [], $d5a44f70fd2606ea$var$AWAITING_PAGELOAD_NAME, $d5a44f70fd2606ea$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === 'page_load') // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $c62a8.abort)(activeInteraction.id, 'excluded_by_sampling');
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === 'page_load') {
        (0, $c62a8.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $c62a8.removeHoldByID)(activeInteraction.id, $d5a44f70fd2606ea$var$AWAITING_PAGELOAD_NAME);
    }
}
var $d5a44f70fd2606ea$export$2e2bcd8739ae039 = $d5a44f70fd2606ea$var$traceUFOPageLoad;
function $d5a44f70fd2606ea$export$d0f99433cd4f4028(ufoName, routeName = ufoName) {
    if (!(0, $jFknK.isUFOEnabled)()) return;
    const interaction = (0, $c62a8.getActiveInteraction)();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    if (ufoName) {
        const rate = (0, $jFknK.getInteractionRate)(ufoName, 'page_load');
        (0, $c62a8.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $4Bdcb.default)(rate)) (0, $eFsN4.default).current = ufoName;
        else (0, $c62a8.abort)(interaction.id, 'excluded_by_sampling');
    }
    (0, $c62a8.removeHoldByID)(interaction.id, $d5a44f70fd2606ea$var$AWAITING_PAGELOAD_NAME);
}

});

parcelRegister("iOZbf", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8a4a73c93520a2c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2OOKU = parcelRequire("2OOKU");

var $4Bdcb = parcelRequire("4Bdcb");

var $jFknK = parcelRequire("jFknK");

var $bqHVm = parcelRequire("bqHVm");

var $87Bg8 = parcelRequire("87Bg8");

var $c62a8 = parcelRequire("c62a8");

var $eFsN4 = parcelRequire("eFsN4");

var $8MlAL = parcelRequire("8MlAL");
function $b8a4a73c93520a2c$var$traceUFOTransition(ufoName, routeName = ufoName) {
    if (!(0, $jFknK.isUFOEnabled)()) return;
    const pressInteractionsList = (0, $jFknK.getDoNotAbortActivePressInteractionOnTransition)();
    const interaction = (0, $c62a8.getActiveInteraction)();
    if (pressInteractionsList && interaction) {
        if (pressInteractionsList.includes(interaction.ufoName)) return;
    }
    (0, $c62a8.abortAll)('transition', ufoName ?? undefined);
    if (ufoName) {
        (0, $eFsN4.default).current = ufoName;
        const rate = (0, $jFknK.getInteractionRate)(ufoName, 'transition');
        if ((0, $4Bdcb.default)(rate)) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const newId = (0, $2OOKU.v4)();
            (0, $8MlAL.setInteractionActiveTrace)(newId);
            (0, $87Bg8.DefaultInteractionID).current = newId;
            (0, $c62a8.addNewInteraction)(newId, ufoName, 'transition', performance.now(), rate, null, routeName, (0, $bqHVm.getActiveTrace)());
        }
    }
}
function $b8a4a73c93520a2c$export$369f0ded13ce6c50() {
    const interactionId = (0, $4fqPo.useContext)((0, $87Bg8.default));
    const capturedInteractionId = interactionId.current;
    (0, $4fqPo.useEffect)(()=>{
        // If we have a current interaction set...
        if (capturedInteractionId != null) {
            let cancel = requestAnimationFrame(()=>{
                cancel = requestAnimationFrame(()=>{
                    if (capturedInteractionId === interactionId.current) (0, $c62a8.tryComplete)(capturedInteractionId);
                });
            });
            (0, $c62a8.addOnCancelCallback)(capturedInteractionId, ()=>{
                cancelAnimationFrame(cancel);
            });
        }
    }, [
        capturedInteractionId,
        interactionId
    ]);
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b8a4a73c93520a2c$export$2e2bcd8739ae039 = $b8a4a73c93520a2c$var$traceUFOTransition;

});
parcelRegister("8MlAL", function(module, exports) {
$parcel$export(module.exports, "setInteractionActiveTrace", () => $a8ce4023c884bcce$export$f2e521e495a88544);

var $bqHVm = parcelRequire("bqHVm");

var $84ura = parcelRequire("84ura");
function $a8ce4023c884bcce$export$f2e521e495a88544(newId) {
    (0, $bqHVm.setActiveTrace)(newId.replace(/-/g, ''), (0, $84ura.generateSpanId)(), 'transition');
}

});
parcelRegister("84ura", function(module, exports) {
$parcel$export(module.exports, "generateSpanId", () => $6dce5e073a9ff23b$export$295213bc4d0c54ad);
function $6dce5e073a9ff23b$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), ()=>Math.floor(Math.random() * 16).toString(16)).join('');
}

});




parcelRegister("fpAYG", function(module, exports) {
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => (parcelRequire("gQA2V")).getAnonymousRequestSuccessRouteWithHubShell);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => (parcelRequire("gQA2V")).getCheckEmailRouteWithHubShell);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => (parcelRequire("gQA2V")).getCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmContactUsRouteWithHubShell);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmFolderRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmViewArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmViewCrossSiteArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmViewCrossSitePortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => (parcelRequire("gQA2V")).getCsmViewPortalArticleRouteWithHubShell);
$parcel$export(module.exports, "getHubCustompageRoute", () => (parcelRequire("gQA2V")).getHubCustompageRoute);
$parcel$export(module.exports, "getHubHomepageRoute", () => (parcelRequire("gQA2V")).getHubHomepageRoute);
$parcel$export(module.exports, "getHubPortalPageRoute", () => (parcelRequire("gQA2V")).getHubPortalPageRoute);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => (parcelRequire("gQA2V")).getHubUserProfileRouteWithHubShell);
$parcel$export(module.exports, "getHubViewArticleRoute", () => (parcelRequire("gQA2V")).getHubViewArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => (parcelRequire("gQA2V")).getHubViewCrossSiteArticleRoute);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => (parcelRequire("gQA2V")).getHubViewCrossSitePortalArticleRoute);
$parcel$export(module.exports, "getHubViewKbRoute", () => (parcelRequire("gQA2V")).getHubViewKbRoute);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => (parcelRequire("gQA2V")).getHubViewPortalArticleRoute);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => (parcelRequire("gQA2V")).getJsmApprovalsRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => (parcelRequire("gQA2V")).getJsmRequestApprovalRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => (parcelRequire("gQA2V")).getJsmRequestDetailsRouteWithHubShell);
$parcel$export(module.exports, "getJsmRequestsListRouteWithHubShell", () => (parcelRequire("gQA2V")).getJsmRequestsListRouteWithHubShell);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => (parcelRequire("gQA2V")).getLoginRouteWithHubShell);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => (parcelRequire("gQA2V")).getNotFoundRouteWithHubShell);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => (parcelRequire("gQA2V")).getPortalAccessForbiddenRouteWithHubShell);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => (parcelRequire("gQA2V")).getPortalCompleteSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => (parcelRequire("gQA2V")).getPortalInvitedSignupRouteWithHubShell);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => (parcelRequire("gQA2V")).getPortalLoginRouteWithHubShell);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => (parcelRequire("gQA2V")).getPortalResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => (parcelRequire("gQA2V")).getPortalSignupRouteWithHubShell);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => (parcelRequire("gQA2V")).getRequestCreateRouteWithHubShell);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => (parcelRequire("gQA2V")).getRequestFeedbackRouteWithHubShell);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => (parcelRequire("gQA2V")).getResetPasswordRouteWithHubShell);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => (parcelRequire("gQA2V")).getSignupRouteWithHubShell);
$parcel$export(module.exports, "getSurveyRouteWithHubShell", () => (parcelRequire("gQA2V")).getSurveyRouteWithHubShell);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => (parcelRequire("gQA2V")).getUnsubscribeRouteWithHubShell);
parcelRequire("gQA2V");

});
parcelRegister("gQA2V", function(module, exports) {
$parcel$export(module.exports, "getHubHomepageRoute", () => $f11299c3eaea92ba$export$3b1658f4569bf0ca);
$parcel$export(module.exports, "getHubCustompageRoute", () => $f11299c3eaea92ba$export$737d1198516688ea);
$parcel$export(module.exports, "getHubPortalPageRoute", () => $f11299c3eaea92ba$export$561a9432cf020904);
$parcel$export(module.exports, "getCsmUserProfileRouteWithHubShell", () => $f11299c3eaea92ba$export$2a2a6f715f782520);
$parcel$export(module.exports, "getCsmRequestsListRouteWithHubShell", () => $f11299c3eaea92ba$export$2a6efc2e2d50dd68);
$parcel$export(module.exports, "getCsmContactUsRouteWithHubShell", () => $f11299c3eaea92ba$export$d59699c7220ea7d4);
$parcel$export(module.exports, "getNotFoundRouteWithHubShell", () => $f11299c3eaea92ba$export$c8e491027fcd76d5);
$parcel$export(module.exports, "getCsmFolderRouteWithHubShell", () => $f11299c3eaea92ba$export$7e31411194771e76);
$parcel$export(module.exports, "getCsmRequestDetailsRouteWithHubShell", () => $f11299c3eaea92ba$export$eb078274575814fa);
$parcel$export(module.exports, "getCsmViewPortalArticleRouteWithHubShell", () => $f11299c3eaea92ba$export$8628a4d0641114fc);
$parcel$export(module.exports, "getHubViewPortalArticleRoute", () => $f11299c3eaea92ba$export$d23db2e306b7fa10);
$parcel$export(module.exports, "getPortalAccessForbiddenRouteWithHubShell", () => $f11299c3eaea92ba$export$df37fdf84c1e0c73);
$parcel$export(module.exports, "getCsmViewArticleRouteWithHubShell", () => $f11299c3eaea92ba$export$9bd8f060725abce6);
$parcel$export(module.exports, "getHubViewArticleRoute", () => $f11299c3eaea92ba$export$215c0eb21c8c9bbd);
$parcel$export(module.exports, "getHubViewKbRoute", () => $f11299c3eaea92ba$export$fe3b3b72e1ee1e3);
$parcel$export(module.exports, "getCsmViewCrossSitePortalArticleRouteWithHubShell", () => $f11299c3eaea92ba$export$276f7d60ee8fa12a);
$parcel$export(module.exports, "getHubViewCrossSitePortalArticleRoute", () => $f11299c3eaea92ba$export$3e0c0cee1ca6ead0);
$parcel$export(module.exports, "getHubViewCrossSiteArticleRoute", () => $f11299c3eaea92ba$export$a2895ad4defdb0c4);
$parcel$export(module.exports, "getCsmViewCrossSiteArticleRouteWithHubShell", () => $f11299c3eaea92ba$export$3677170bee4c0cc5);
$parcel$export(module.exports, "getLoginRouteWithHubShell", () => $f11299c3eaea92ba$export$c80d2e838cbb1b16);
$parcel$export(module.exports, "getPortalLoginRouteWithHubShell", () => $f11299c3eaea92ba$export$a60f6f9ee1a764cc);
$parcel$export(module.exports, "getSignupRouteWithHubShell", () => $f11299c3eaea92ba$export$d0572cd96b5c4ab4);
$parcel$export(module.exports, "getPortalSignupRouteWithHubShell", () => $f11299c3eaea92ba$export$cfbf23f65634d193);
$parcel$export(module.exports, "getCompleteSignupRouteWithHubShell", () => $f11299c3eaea92ba$export$ab61a9d90fe1a668);
$parcel$export(module.exports, "getPortalCompleteSignupRouteWithHubShell", () => $f11299c3eaea92ba$export$af956eb6d34eabf5);
$parcel$export(module.exports, "getResetPasswordRouteWithHubShell", () => $f11299c3eaea92ba$export$ec03abb34db753b9);
$parcel$export(module.exports, "getPortalResetPasswordRouteWithHubShell", () => $f11299c3eaea92ba$export$176415cbffecf519);
$parcel$export(module.exports, "getCheckEmailRouteWithHubShell", () => $f11299c3eaea92ba$export$f8feb17b3d1c6ff8);
$parcel$export(module.exports, "getPortalInvitedSignupRouteWithHubShell", () => $f11299c3eaea92ba$export$30dd11011e9a2dff);
$parcel$export(module.exports, "getUnsubscribeRouteWithHubShell", () => $f11299c3eaea92ba$export$1b17db464925ac22);
$parcel$export(module.exports, "getRequestFeedbackRouteWithHubShell", () => $f11299c3eaea92ba$export$dafd7c818cd58b07);
$parcel$export(module.exports, "getAnonymousRequestSuccessRouteWithHubShell", () => $f11299c3eaea92ba$export$a02fb894ac2280da);
$parcel$export(module.exports, "getRequestCreateRouteWithHubShell", () => $f11299c3eaea92ba$export$1914f2b2604a5e33);
$parcel$export(module.exports, "getHubUserProfileRouteWithHubShell", () => $f11299c3eaea92ba$export$a5c23db41dcff27e);
$parcel$export(module.exports, "getJsmRequestDetailsRouteWithHubShell", () => $f11299c3eaea92ba$export$aa08b576762efb0a);
$parcel$export(module.exports, "getJsmRequestsListRouteWithHubShell", () => $f11299c3eaea92ba$export$603e83da51603bdd);
$parcel$export(module.exports, "getJsmApprovalsRouteWithHubShell", () => $f11299c3eaea92ba$export$dbe932e8b71d8b83);
$parcel$export(module.exports, "getJsmRequestApprovalRouteWithHubShell", () => $f11299c3eaea92ba$export$b5d541e9feeaef7e);
$parcel$export(module.exports, "getSurveyRouteWithHubShell", () => $f11299c3eaea92ba$export$44fc575b237ca256);

var $4fqPo = parcelRequire("4fqPo");

var $6mmHn = parcelRequire("6mmHn");

var $ibOOf = parcelRequire("ibOOf");
parcelRequire("5FSYN");
var $cBf1I = parcelRequire("cBf1I");

var $drarL = parcelRequire("drarL");

var $3YrC4 = parcelRequire("3YrC4");

var $5vlcS = parcelRequire("5vlcS");
parcelRequire("82pLF");
var $31gDG = parcelRequire("31gDG");
parcelRequire("6veMO");
var $85nQv = parcelRequire("85nQv");

var $kg4nY = parcelRequire("kg4nY");

var $c3u3c = parcelRequire("c3u3c");

var $ap4D5 = parcelRequire("ap4D5");

var $6bGmX = parcelRequire("6bGmX");

var $4oTiM = parcelRequire("4oTiM");

var $ceL4r = parcelRequire("ceL4r");

var $b9Veq = parcelRequire("b9Veq");

var $lG4t7 = parcelRequire("lG4t7");

var $cfump = parcelRequire("cfump");

var $4M8D7 = parcelRequire("4M8D7");

var $BWSXY = parcelRequire("BWSXY");

var $eeyLA = parcelRequire("eeyLA");

var $tijOD = parcelRequire("tijOD");

var $aAvAT = parcelRequire("aAvAT");

var $7kIOS = parcelRequire("7kIOS");

var $gIpMs = parcelRequire("gIpMs");

var $6jGQR = parcelRequire("6jGQR");

var $HunEp = parcelRequire("HunEp");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $9mQxZ = parcelRequire("9mQxZ");

var $fjVNf = parcelRequire("fjVNf");
parcelRequire("jgUOz");
var $eOmbo = parcelRequire("eOmbo");

var $a1gz8 = parcelRequire("a1gz8");

var $fVVtD = parcelRequire("fVVtD");

var $1hcn6 = parcelRequire("1hcn6");

var $7fGQw = parcelRequire("7fGQw");

var $W39nK = parcelRequire("W39nK");
parcelRequire("clJ4z");
var $l9neZ = parcelRequire("l9neZ");
parcelRequire("aqBAS");
var $jmhVl = parcelRequire("jmhVl");

var $dedFH = parcelRequire("dedFH");
parcelRequire("d4hdo");
var $HSg4L = parcelRequire("HSg4L");

var $cwVD2 = parcelRequire("cwVD2");

var $bVASc = parcelRequire("bVASc");

var $6hzbh = parcelRequire("6hzbh");

var $3s5vo = parcelRequire("3s5vo");

var $3FOgc = parcelRequire("3FOgc");

var $dWTpx = parcelRequire("dWTpx");
const $f11299c3eaea92ba$var$helpCenterAri = (0, $6mmHn.getHelpCenterAri)();
const $f11299c3eaea92ba$var$renderAvatarMenuOptions = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jmhVl.HubAvatarMenuOptions), null);
};
const $f11299c3eaea92ba$var$createHubRouteProps = (shouldRenderRightNavActions)=>{
    var _initialModelState$us, _initialModelState$us2, _initialModelState$us3, _initialModelState$us4;
    const initialModelState = (0, $9mQxZ.default)();
    const renderRightNavActions = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOmbo.default), {
            trigger: "icon"
        });
    };
    const isHelpHub = (0, $eSL4S.getIsHelpHub)();
    return {
        renderRightNavActions: shouldRenderRightNavActions ? renderRightNavActions : undefined,
        renderAvatarMenuOptions: isHelpHub ? $f11299c3eaea92ba$var$renderAvatarMenuOptions : undefined,
        user: {
            email: ((_initialModelState$us = initialModelState.user) === null || _initialModelState$us === void 0 ? void 0 : _initialModelState$us.email) || '',
            displayName: ((_initialModelState$us2 = initialModelState.user) === null || _initialModelState$us2 === void 0 ? void 0 : _initialModelState$us2.displayName) || '',
            avatarSrc: ((_initialModelState$us3 = initialModelState.user) === null || _initialModelState$us3 === void 0 || (_initialModelState$us3 = _initialModelState$us3.avatars) === null || _initialModelState$us3 === void 0 ? void 0 : _initialModelState$us3.xlarge) || '',
            isJiraAdmin: ((_initialModelState$us4 = initialModelState.user) === null || _initialModelState$us4 === void 0 ? void 0 : _initialModelState$us4.canAdministerJIRA) || false,
            id: ''
        },
        env: {
            helpCenterAri: $f11299c3eaea92ba$var$helpCenterAri,
            cloudId: (0, $6mmHn.getCloudId)(),
            helpCenterId: $f11299c3eaea92ba$var$helpCenterAri && $f11299c3eaea92ba$var$helpCenterAri !== 'null' ? (0, $4oTiM.HelpHelpCenterAri).parse($f11299c3eaea92ba$var$helpCenterAri).helpCenterId : '',
            jiraDisplayUrl: (0, $ebpTf.getJiraDisplayUrl)(),
            hoistedProjectKey: (0, $ebpTf.getHoistedProjectKey)() || '',
            relativeBaseUrl: (0, $3wR8f.getRelativeBasePath)()
        },
        featureFlags: {
            enable_rovo_in_help_hubs: isHelpHub && (0, $6bGmX.default).checkGate('enable_rovo_in_help_hubs'),
            hub_component_upgrade: isHelpHub && (0, $6bGmX.default).checkGate('hub_component_upgrade'),
            hub_editor_floating_toolbar: isHelpHub && (0, $6bGmX.default).checkGate('hub_editor_floating_toolbar'),
            'portal-pages-in-hub': isHelpHub && (0, $6bGmX.default).checkGate('portal-pages-in-hub'),
            // Product-level flag that opts a hub surface into advanced theming
            // v2. Today only JSM Help Hubs are opted in; the platform-level
            // `hub-advanced-theming` Statsig gate AND-combines with this so
            // rollout is independently controlled from both sides.
            'advanced-theming-in-hub': isHelpHub && (0, $6bGmX.default).checkGate('advanced-theming-in-jsm')
        },
        actions: {
            onLogoutClick: ()=>{
                const action = (0, $fVVtD.logOutAction)();
                (0, $1hcn6.store).dispatch(action);
                return action;
            }
        }
    };
};
const $f11299c3eaea92ba$var$createRouteWithHubShell = (...args)=>{
    const [props, component, ...restArgs] = args;
    return (0, $a1gz8.createRouteWithHubShell)(props, (0, $fjVNf.withSetThemeColorInRedux)((0, $ibOOf.withPathParamProvider)(component)), ...restArgs);
};
const $f11299c3eaea92ba$export$3b1658f4569bf0ca = ()=>(0, $a1gz8.createHubHomepageRoute)($f11299c3eaea92ba$var$createHubRouteProps(false));
const $f11299c3eaea92ba$export$737d1198516688ea = ()=>(0, $a1gz8.createHubCustomPageRoute)($f11299c3eaea92ba$var$createHubRouteProps(true));
const $f11299c3eaea92ba$export$561a9432cf020904 = ()=>(0, $a1gz8.createHubPortalPageRoute)($f11299c3eaea92ba$var$createHubRouteProps(true));
const $f11299c3eaea92ba$export$2a2a6f715f782520 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $3s5vo.CsmUserProfileForHubs), (0, $dWTpx.HUB_ROUTES).USER_PROFILE.path, (0, $dWTpx.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $f11299c3eaea92ba$export$2a6efc2e2d50dd68 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $7kIOS.CsmRequestsListForHubs), (0, $dWTpx.HUB_ROUTES).CSM_REQUESTS_LIST.path, (0, $dWTpx.HUB_ROUTES).CSM_REQUESTS_LIST.name, [
        (0, $6jGQR.csmRequestsListQueryResource)
    ], 'full-width');
const $f11299c3eaea92ba$export$d59699c7220ea7d4 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $ceL4r.CsmContactUsForHubs), (0, $dWTpx.HUB_ROUTES).CSM_CONTACT_US.path, (0, $dWTpx.HUB_ROUTES).CSM_CONTACT_US.name, [
        (0, $HunEp.mediaUploadCredentialsResource)
    ], 'full-width');
const $f11299c3eaea92ba$export$c8e491027fcd76d5 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $cBf1I.NotFoundPage), (0, $dWTpx.HUB_ROUTES).NOT_FOUND.path, (0, $dWTpx.HUB_ROUTES).NOT_FOUND.name, [], 'normal');
const $f11299c3eaea92ba$export$7e31411194771e76 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $b9Veq.CsmFolderForHubs), (0, $dWTpx.HUB_ROUTES).CSM_FOLDER.path, (0, $dWTpx.HUB_ROUTES).CSM_FOLDER.name, [
        (0, $cfump.CsmFolderResource),
        (0, $lG4t7.CsmEmptyFolderResource)
    ], 'full-width');
const $f11299c3eaea92ba$export$eb078274575814fa = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $aAvAT.AsyncCsmRequestDetails), (0, $dWTpx.HUB_ROUTES).CSM_REQUEST_DETAILS.path, (0, $dWTpx.HUB_ROUTES).CSM_REQUEST_DETAILS.name, [
        (0, $4M8D7.csmRequestDetailsQueryResource),
        (0, $tijOD.requestConversationResource),
        (0, $BWSXY.mediaReadCredentialsResource),
        (0, $eeyLA.mediaUploadCredentialsResource)
    ], 'xxwide');
const $f11299c3eaea92ba$var$articlePageWidth = (0, $6bGmX.default).checkGate('fix_kb_article_scroll') ? 'wide' : 'normal';
const $f11299c3eaea92ba$export$8628a4d0641114fc = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $drarL.CsmArticle), (0, $dWTpx.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], $f11299c3eaea92ba$var$articlePageWidth);
const $f11299c3eaea92ba$export$d23db2e306b7fa10 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $W39nK.Article), (0, $dWTpx.HUB_ROUTES).VIEW_PORTAL_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_PORTAL_ARTICLE.name, [], $f11299c3eaea92ba$var$articlePageWidth);
const $f11299c3eaea92ba$export$df37fdf84c1e0c73 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $85nQv.default), (0, $dWTpx.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.path, (0, $dWTpx.HUB_ROUTES).PORTAL_ACCESS_FORBIDDEN.name, [], 'normal');
const $f11299c3eaea92ba$export$9bd8f060725abce6 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $drarL.CsmArticle), (0, $dWTpx.HUB_ROUTES).VIEW_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_ARTICLE.name, [], 'full-width');
const $f11299c3eaea92ba$export$215c0eb21c8c9bbd = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $W39nK.Article), (0, $dWTpx.HUB_ROUTES).VIEW_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_ARTICLE.name, [], 'normal');
const $f11299c3eaea92ba$export$fe3b3b72e1ee1e3 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        appearance: 'full-width'
    }, (0, $W39nK.Article), (0, $dWTpx.HUB_ROUTES).VIEW_KB_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_KB_ARTICLE.name, [], 'normal');
const $f11299c3eaea92ba$export$276f7d60ee8fa12a = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $drarL.CsmArticle), (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $f11299c3eaea92ba$export$3e0c0cee1ca6ead0 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $W39nK.Article), (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_PORTAL_ARTICLE.name, [], 'normal');
const $f11299c3eaea92ba$export$a2895ad4defdb0c4 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $W39nK.Article), (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $f11299c3eaea92ba$export$3677170bee4c0cc5 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $drarL.CsmArticle), (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.path, (0, $dWTpx.HUB_ROUTES).VIEW_CROSS_SITE_ARTICLE.name, [], 'normal');
const $f11299c3eaea92ba$export$c80d2e838cbb1b16 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $31gDG.default), null)), (0, $dWTpx.HUB_ROUTES).LOGIN.path, (0, $dWTpx.HUB_ROUTES).LOGIN.name, [], 'note');
const $f11299c3eaea92ba$export$a60f6f9ee1a764cc = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $31gDG.default), null)), (0, $dWTpx.HUB_ROUTES).PORTAL_LOGIN.path, (0, $dWTpx.HUB_ROUTES).PORTAL_LOGIN.name, [], 'note');
const $f11299c3eaea92ba$export$d0572cd96b5c4ab4 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c3u3c.SignUp), routeProps)), (0, $dWTpx.HUB_ROUTES).SIGNUP.path, (0, $dWTpx.HUB_ROUTES).SIGNUP.name, [], 'note');
const $f11299c3eaea92ba$export$cfbf23f65634d193 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c3u3c.SignUp), routeProps)), (0, $dWTpx.HUB_ROUTES).PORTAL_SIGNUP.path, (0, $dWTpx.HUB_ROUTES).PORTAL_SIGNUP.name, [], 'note');
const $f11299c3eaea92ba$export$ab61a9d90fe1a668 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3YrC4.CompleteSignup), routeProps)), (0, $dWTpx.HUB_ROUTES).COMPLETE_SIGNUP.path, (0, $dWTpx.HUB_ROUTES).COMPLETE_SIGNUP.name, [], 'note');
const $f11299c3eaea92ba$export$af956eb6d34eabf5 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3YrC4.CompleteSignup), routeProps)), (0, $dWTpx.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.path, (0, $dWTpx.HUB_ROUTES).PORTAL_COMPLETE_SIGNUP.name, [], 'note');
const $f11299c3eaea92ba$export$ec03abb34db753b9 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kg4nY.ResetPassword), routeProps)), (0, $dWTpx.HUB_ROUTES).RESET_PASSWORD.path, (0, $dWTpx.HUB_ROUTES).RESET_PASSWORD.name, [], 'note');
const $f11299c3eaea92ba$export$176415cbffecf519 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kg4nY.ResetPassword), routeProps)), (0, $dWTpx.HUB_ROUTES).PORTAL_RESET_PASSWORD.path, (0, $dWTpx.HUB_ROUTES).PORTAL_RESET_PASSWORD.name, [], 'note');
const $f11299c3eaea92ba$export$f8feb17b3d1c6ff8 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, (routeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ap4D5.CheckEmail), {
            ...routeProps,
            isLoading: false
        })), (0, $dWTpx.HUB_ROUTES).CHECK_EMAIL.path, (0, $dWTpx.HUB_ROUTES).CHECK_EMAIL.name, [], 'note');
const $f11299c3eaea92ba$export$30dd11011e9a2dff = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(false),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: true
        }
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l9neZ.HubAnonymousLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5vlcS.InvitedSignUp), null)), (0, $dWTpx.HUB_ROUTES).PORTAL_INVITED_SIGNUP.path, (0, $dWTpx.HUB_ROUTES).PORTAL_INVITED_SIGNUP.name, [], 'note');
const $f11299c3eaea92ba$export$1b17db464925ac22 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $6hzbh.Unsubscribe), (0, $dWTpx.HUB_ROUTES).UNSUBSCRIBE.path, (0, $dWTpx.HUB_ROUTES).UNSUBSCRIBE.name, [], 'note');
const $f11299c3eaea92ba$export$dafd7c818cd58b07 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $cwVD2.RequestFeedback), (0, $dWTpx.HUB_ROUTES).REQUEST_FEEDBACK.path, (0, $dWTpx.HUB_ROUTES).REQUEST_FEEDBACK.name, [], 'note');
const $f11299c3eaea92ba$export$a02fb894ac2280da = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $cBf1I.RenderCreateAnonymousSuccess), (0, $dWTpx.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.path, (0, $dWTpx.HUB_ROUTES).ANONYMOUS_REQUEST_SUCCESS.name, [], 'xxwide');
const $f11299c3eaea92ba$export$1914f2b2604a5e33 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $cBf1I.RenderRequestCreateForHubs), (0, $dWTpx.HUB_ROUTES).REQUEST_CREATE.path, (0, $dWTpx.HUB_ROUTES).REQUEST_CREATE.name, [], 'full-width');
const $f11299c3eaea92ba$export$a5c23db41dcff27e = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $3FOgc.UserProfileForHubs), (0, $dWTpx.HUB_ROUTES).USER_PROFILE.path, (0, $dWTpx.HUB_ROUTES).USER_PROFILE.name, [], 'full-width');
const $f11299c3eaea92ba$export$aa08b576762efb0a = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $HSg4L.default), (0, $dWTpx.HUB_ROUTES).JSM_REQUEST_DETAILS.path, (0, $dWTpx.HUB_ROUTES).JSM_REQUEST_DETAILS.name, [], 'xxwide');
const $f11299c3eaea92ba$export$603e83da51603bdd = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell(/**
 * TODO: The banner text has to be internationalized
 */ {
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: 'Requests',
            isAnonymousRoute: false
        }
    }, (0, $bVASc.RequestList), (0, $dWTpx.HUB_ROUTES).JSM_REQUESTS_LIST.path, (0, $dWTpx.HUB_ROUTES).JSM_REQUESTS_LIST.name, [], 'xxwide');
const $f11299c3eaea92ba$export$dbe932e8b71d8b83 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: 'Approvals',
            isAnonymousRoute: false
        }
    }, (0, $7fGQw.ApprovalList), (0, $dWTpx.HUB_ROUTES).JSM_APPROVALS.path, (0, $dWTpx.HUB_ROUTES).JSM_APPROVALS.name, [], 'xxwide');
const $f11299c3eaea92ba$export$b5d541e9feeaef7e = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell({
        ...$f11299c3eaea92ba$var$createHubRouteProps(true),
        layout: {
            showBanner: true,
            bannerText: '',
            isAnonymousRoute: false
        }
    }, (0, $dedFH.RequestApproval), (0, $dWTpx.HUB_ROUTES).JSM_REQUEST_APPROVAL.path, (0, $dWTpx.HUB_ROUTES).JSM_REQUEST_APPROVAL.name, [], 'xxwide');
const $f11299c3eaea92ba$export$44fc575b237ca256 = ()=>$f11299c3eaea92ba$var$createRouteWithHubShell($f11299c3eaea92ba$var$createHubRouteProps(true), (0, $gIpMs.AsyncSurveyDetails), (0, $dWTpx.HUB_ROUTES).SURVEY.path, (0, $dWTpx.HUB_ROUTES).SURVEY.name, [], 'xxwide');

});
parcelRegister("ceL4r", function(module, exports) {
$parcel$export(module.exports, "CsmContactUsForHubs", () => $5a70db49360d419c$export$18dcede65e3972a9);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $5a70db49360d419c$export$18dcede65e3972a9 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("gCo4t")), {
        moduleId: "./packages/customer-service/csm-contact-us/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("gCo4t", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("7imz9"),
    $e46AW("1LYbr"),
    $e46AW("EdvSx"),
    $e46AW("fq0LN"),
    $e46AW("ibPpH"),
    $e46AW("dariE"),
    $e46AW("1nzUi"),
    $e46AW("1qVH8"),
    $e46AW("2PHdy"),
    $e46AW("98Vtx"),
    $e46AW("9d6FU"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("45caK"),
    $e46AW("4biYi"),
    $e46AW("7ddpr"),
    $e46AW("jQ8UC")
]).then(()=>parcelRequire('8Et35'));

});


parcelRegister("b9Veq", function(module, exports) {
$parcel$export(module.exports, "CsmFolderForHubs", () => $aa078a767a015ff0$export$46d643ae94fd657a);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $aa078a767a015ff0$export$46d643ae94fd657a = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("2dhtQ")), {
        moduleId: "./packages/customer-service/csm-folder/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("2dhtQ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("fEhC9"),
    $e46AW("jtv93")
]).then(()=>parcelRequire('7l8c5'));

});


parcelRegister("7kIOS", function(module, exports) {
$parcel$export(module.exports, "CsmRequestsListForHubs", () => $403699fe51233578$export$3f37ab3da4f058a);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $403699fe51233578$export$3f37ab3da4f058a = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("as1Q8")), {
        moduleId: "./packages/customer-service/csm-requests-list/src/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("as1Q8", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5gUlY"),
    $e46AW("iV1EX"),
    $e46AW("jNeMP"),
    $e46AW("jZPNc"),
    $e46AW("h0QLI"),
    $e46AW("h2wsn")
]).then(()=>parcelRequire('j8gFH'));

});


parcelRegister("gIpMs", function(module, exports) {
$parcel$export(module.exports, "AsyncSurveyDetails", () => $8d84098b437583f2$export$b01dbc7a6c5c4fed);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $8d84098b437583f2$export$b01dbc7a6c5c4fed = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("h8o8n")), {
        moduleId: "./packages/surveys/src/Survey.tsx"
    })
});

});
parcelRegister("h8o8n", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("7imz9"),
    $e46AW("1LYbr"),
    $e46AW("ibPpH"),
    $e46AW("dariE"),
    $e46AW("1nzUi"),
    $e46AW("kvSeU"),
    $e46AW("98Vtx"),
    $e46AW("9d6FU"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("4biYi"),
    $e46AW("dItcg"),
    $e46AW("6d2TU")
]).then(()=>parcelRequire('jUor4'));

});


parcelRegister("fjVNf", function(module, exports) {
$parcel$export(module.exports, "withSetThemeColorInRedux", () => $68c270cd6f7cc5c3$export$e14001b3f71f56fc);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $9wmEV = parcelRequire("9wmEV");
const $68c270cd6f7cc5c3$export$e14001b3f71f56fc = (InnerComponent)=>{
    const Component = (props)=>{
        const { bannerBackgroundColor: bannerBackgroundColor, setThemeColor: setThemeColor } = props;
        $4fqPo.useEffect(()=>{
            if (bannerBackgroundColor) setThemeColor({
                themeColor: bannerBackgroundColor
            });
        }, [
            bannerBackgroundColor,
            setThemeColor
        ]);
        return /*#__PURE__*/ $4fqPo.createElement(InnerComponent, props);
    };
    return (0, $bmgw6.default)(null, {
        setThemeColor: (0, $9wmEV.updateHCThemeColorAction)
    })(Component);
};

});

parcelRegister("a1gz8", function(module, exports) {
$parcel$export(module.exports, "createHubHomepageRoute", () => $7563a42f5fc2382e$export$5dafaf7a5091e51);
$parcel$export(module.exports, "createHubCustomPageRoute", () => $7563a42f5fc2382e$export$394540a667e798bf);
$parcel$export(module.exports, "createHubPortalPageRoute", () => $7563a42f5fc2382e$export$c7ef2adac2336d4a);
$parcel$export(module.exports, "createRouteWithHubShell", () => $7563a42f5fc2382e$export$bf7b7ea558d32a05);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $lhXNe = parcelRequire("lhXNe");

var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");

var $3H4LK = parcelRequire("3H4LK");

var $cijxS = parcelRequire("cijxS");

var $lNZDv = parcelRequire("lNZDv");

var $5qWT2 = parcelRequire("5qWT2");

var $chtqr = parcelRequire("chtqr");
var $eNlzS = parcelRequire("eNlzS");
var $36H9J = parcelRequire("36H9J");
var $askEH = parcelRequire("askEH");

var $cRPo9 = parcelRequire("cRPo9");

var $71qeF = parcelRequire("71qeF");

var $2QadH = parcelRequire("2QadH");

var $bjYUA = parcelRequire("bjYUA");

var $hF8ms = parcelRequire("hF8ms");

var $6pgZt = parcelRequire("6pgZt");
const $7563a42f5fc2382e$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc",
    root: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1txw _2lx21bp4 _1tke1osq _1bsb1osq"
};
const $7563a42f5fc2382e$export$74c90840fe177d0a = {
    component: (0, $bjYUA.HubApp),
    exact: true,
    name: (0, $6pgZt.HUB_ROUTE_NAME),
    resources: [
        (0, $71qeF.hubBootstrapResource),
        (0, $71qeF.hubPageResource)
    ],
    path: (0, $6pgZt.HUB_ROUTE_PATH)
};
const $7563a42f5fc2382e$export$ccad182393585435 = {
    component: (0, $bjYUA.HubApp),
    exact: true,
    name: (0, $6pgZt.HUB_CUSTOM_PAGE_ROUTE_NAME),
    resources: [
        (0, $71qeF.hubBootstrapResource),
        (0, $71qeF.hubPageResource)
    ],
    path: (0, $6pgZt.HUB_CUSTOM_PAGE_ROUTE_PATH)
};
const $7563a42f5fc2382e$var$isSupportSiteHeaderlessEnabled = ()=>typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('headerless') === 'true' && (0, $3H4LK.fg)('csm-support-site-headerless-query-param');
const $7563a42f5fc2382e$export$5dafaf7a5091e51 = (hubAppProps)=>{
    const HubAppComponent = ()=>{
        return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $bjYUA.HubApp), {
            ...hubAppProps,
            headerless: $7563a42f5fc2382e$var$isSupportSiteHeaderlessEnabled(),
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$7563a42f5fc2382e$export$74c90840fe177d0a,
        component: HubAppComponent
    };
};
const $7563a42f5fc2382e$export$8b1ac9e5cb498cd8 = ()=>{
    const hubRoute = $7563a42f5fc2382e$export$5dafaf7a5091e51((0, $askEH.mockHubRouteProps));
    return {
        ...hubRoute,
        path: (0, $6pgZt.HUB_PREVIEW_ROUTE_PATH),
        name: (0, $6pgZt.HUB_PREVIEW_ROUTE_NAME)
    };
};
const $7563a42f5fc2382e$export$394540a667e798bf = (hubAppProps)=>{
    const HubCustomPageComponent = ()=>{
        return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $bjYUA.HubApp), {
            ...hubAppProps,
            headerless: $7563a42f5fc2382e$var$isSupportSiteHeaderlessEnabled(),
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$7563a42f5fc2382e$export$ccad182393585435,
        component: HubCustomPageComponent
    };
};
const $7563a42f5fc2382e$export$c6260de3189c8f50 = {
    component: (0, $bjYUA.HubApp),
    exact: true,
    name: (0, $6pgZt.HUB_PORTAL_PAGE_ROUTE_NAME),
    resources: [
        (0, $71qeF.hubBootstrapResource),
        (0, $71qeF.hubPageResource)
    ],
    path: (0, $6pgZt.HUB_PORTAL_PAGE_ROUTE_PATH)
};
const $7563a42f5fc2382e$export$c7ef2adac2336d4a = (hubAppProps)=>{
    const HubPortalPageComponent = ()=>{
        return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $bjYUA.HubApp), {
            ...hubAppProps,
            showPageNameAsHubDocumentTitle: true
        });
    };
    return {
        ...$7563a42f5fc2382e$export$c6260de3189c8f50,
        component: HubPortalPageComponent
    };
};
const $7563a42f5fc2382e$export$bf7b7ea558d32a05 = (hubAppProps, InnerComponent, path, name, resources, componentWidth)=>{
    const Component = ()=>{
        const { queryReference: hubBootstrapQueryReference } = (0, $2QadH.useRelayResource)((0, $71qeF.hubBootstrapResource));
        if (!hubBootstrapQueryReference) return null;
        const InnerComponentWithRouter = (0, $lM7Z9.withRouter)(InnerComponent);
        const ComponentWithBannerBackgroundColor = (0, $hF8ms.withBannerBackgroundColor)(InnerComponentWithRouter);
        const cloudId = hubBootstrapQueryReference.variables.cloudId;
        return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $lNZDv.default), {
            name: "hub-shell",
            children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $36H9J.HubErrorBoundary), {
                shouldForceError: true,
                id: "route-with-hub-shell",
                packageName: "@atlassian/hub",
                fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $chtqr.GenericErrorPage), {}),
                operationNames: [
                    'hubBootstrapWrapperQuery'
                ],
                children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                        name: "hub-shell-loader",
                        children: /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                            className: (0, $ltgDR.default)([
                                $7563a42f5fc2382e$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $5qWT2.default), {
                                size: 'large'
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $eNlzS.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        ...hubAppProps,
                        cloudId: cloudId,
                        children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cRPo9.HubAppShell), {
                            children: /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                                style: {
                                    maxWidth: (0, $hF8ms.getContentWidth)(componentWidth)
                                },
                                className: (0, $ltgDR.default)([
                                    $7563a42f5fc2382e$var$styles.root
                                ]),
                                children: /*#__PURE__*/ (0, $lhXNe.jsx)(ComponentWithBannerBackgroundColor, {})
                            })
                        })
                    })
                })
            })
        });
    };
    return {
        component: Component,
        exact: true,
        name: name,
        path: path,
        resources: [
            (0, $71qeF.hubBootstrapResource),
            ...resources
        ]
    };
};

});
parcelRegister("chtqr", function(module, exports) {
$parcel$export(module.exports, "GenericErrorPage", () => $dd8c2f153ef3fc14$export$5d76009b056f3e5d);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $hCKuP = parcelRequire("hCKuP");

var $2eKV2 = parcelRequire("2eKV2");

var $5E02Z = parcelRequire("5E02Z");
var $ekURY = parcelRequire("ekURY");

var $4amZM = parcelRequire("4amZM");

var $cN0LS = parcelRequire("cN0LS");
const $dd8c2f153ef3fc14$var$styles = {
    image: "_1bsbclpc",
    root: "_4t3i1osq _n3tdxncg",
    content: "_y3gn1h6o _p12f1dup"
};
const $dd8c2f153ef3fc14$export$5d76009b056f3e5d = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $dd8c2f153ef3fc14$var$styles.root
    }, /*#__PURE__*/ $4fqPo.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4amZM))),
        alt: "error page",
        className: (0, $ltgDR.default)([
            $dd8c2f153ef3fc14$var$styles.image
        ])
    }), /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $dd8c2f153ef3fc14$var$styles.content
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), {
        space: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        size: "xlarge"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $cN0LS.default).genericErrorHeading)), /*#__PURE__*/ $4fqPo.createElement((0, $ekURY.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $cN0LS.default).genericErrorDescription)))));
};

});
parcelRegister("4amZM", function(module, exports) {
module.exports = new URL("../images/error-icon.fcea7b28.svg", import.meta.url).toString();

});

parcelRegister("cN0LS", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e5b70aa3a1096ad$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $8e5b70aa3a1096ad$var$_default_1 = (0, $6BhDL.defineMessages)({
    genericErrorHeading: {
        id: 'company-hub.generic-error-page.heading',
        defaultMessage: "We're on it",
        description: 'The text is shown as the main heading on the generic error page displayed when an unexpected error occurs in a Company Hub page, reassuring users that the issue is being addressed.'
    },
    genericErrorDescription: {
        id: 'company-hub.generic-error-page.description',
        defaultMessage: 'An unexpected error has occured when processing your request. Our team is working to get things back up and running.',
        description: 'The text is shown as the body paragraph on the generic error page in Company Hub, explaining to users that an unexpected error occurred and the team is working to restore functionality.'
    }
});
var $8e5b70aa3a1096ad$export$2e2bcd8739ae039 = $8e5b70aa3a1096ad$var$_default_1;

});


parcelRegister("eNlzS", function(module, exports) {
$parcel$export(module.exports, "HubBootstrap", () => $2ec9a2879781c443$export$caae1ac058a7a032);
$parcel$export(module.exports, "HubBootstrapWrapper", () => $2ec9a2879781c443$export$5f7521758ed90a1b);

var $3sFpN = parcelRequire("3sFpN");

var $bj3Qb = parcelRequire("bj3Qb");

var $bRFDi = parcelRequire("bRFDi");

var $4fqPo = parcelRequire("4fqPo");

var $gIeP2 = parcelRequire("gIeP2");

var $3H4LK = parcelRequire("3H4LK");

var $Bq10O = parcelRequire("Bq10O");

var $5Vuy8 = parcelRequire("5Vuy8");

var $65BSy = parcelRequire("65BSy");

var $iySE3 = parcelRequire("iySE3");

var $immYM = parcelRequire("immYM");
/**
 * Narrows the page-scoped media config returned by the bootstrap fragment
 * (where every field is nullable due to `@skip(if: $skipPageMediaConfig)`) to
 * the non-nullable shape expected by `HubContext.pageMediaConfig`. Returns
 * `undefined` when any required field is missing so the caller can omit the
 * key from the context value entirely.
 */ const $2ec9a2879781c443$var$getPageMediaConfigFromBootstrap = (input)=>{
    if (!input) return undefined;
    const { asapIssuer: asapIssuer, mediaCollectionName: mediaCollectionName, mediaToken: mediaToken, mediaUrl: mediaUrl } = input;
    if (asapIssuer == null || mediaCollectionName == null || mediaToken == null || mediaUrl == null) return undefined;
    return {
        asapIssuer: asapIssuer,
        mediaCollectionName: mediaCollectionName,
        mediaToken: mediaToken,
        mediaUrl: mediaUrl
    };
};
const $2ec9a2879781c443$export$caae1ac058a7a032 = ({ bootstrapQueryReference: bootstrapQueryReference, tenantContextsQueryReference: tenantContextsQueryReference, children: children, cloudId: cloudId, isInPreviewMode: isInPreviewMode = false, ...props })=>{
    var _tenantData$tenantCon, _data$helpCenterById, _branding$colors, _branding$colors2, _data$helpCenterById2;
    // `skipPageMediaConfig` defaults to `false` so callers that don't pass it
    // fall back to the original behavior of fetching pageMediaConfig in the
    // bootstrap. The wrapper query passes a value derived from the fix flag.
    const data = (0, $gIeP2.useFragment)((0, $bRFDi.default), bootstrapQueryReference);
    const tenantData = (0, $gIeP2.useFragment)((0, $bj3Qb.default), tenantContextsQueryReference);
    const cloudUrl = ((_tenantData$tenantCon = tenantData.tenantContexts) === null || _tenantData$tenantCon === void 0 || (_tenantData$tenantCon = _tenantData$tenantCon[0]) === null || _tenantData$tenantCon === void 0 ? void 0 : _tenantData$tenantCon.cloudUrl) ?? window.location.origin;
    if (!data.helpCenterById) throw new Error('Help center not found');
    const branding = (_data$helpCenterById = data.helpCenterById) === null || _data$helpCenterById === void 0 ? void 0 : _data$helpCenterById.helpCenterBranding;
    const logo = branding === null || branding === void 0 ? void 0 : branding.logo;
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? undefined;
    // BE persists the secondary brand color as `secondaryColor` on
    // HelpCenterBrandingColors. We expose it on the FE context as `accent`
    // to match the existing HubThemingContext / panel terminology (admin
    // label is "Accent color"). The bridge happens here at the data
    // boundary.
    const accentColor = (branding === null || branding === void 0 || (_branding$colors2 = branding.colors) === null || _branding$colors2 === void 0 ? void 0 : _branding$colors2.secondaryColor) ?? undefined;
    const fileId = (logo === null || logo === void 0 ? void 0 : logo.fileId) || '';
    const url = (logo === null || logo === void 0 ? void 0 : logo.url) || '';
    const hubType = ((_data$helpCenterById2 = data.helpCenterById) === null || _data$helpCenterById2 === void 0 ? void 0 : _data$helpCenterById2.type) || '';
    // Convert the logo to a base64 data URL so the signed token embedded in the
    // original URL never expires while the user has the page open.
    const [logoUrl, setLogoUrl] = (0, $4fqPo.useState)(url);
    const prevUrlRef = (0, $4fqPo.useRef)(url);
    if (prevUrlRef.current !== url) {
        prevUrlRef.current = url;
        setLogoUrl(url);
    }
    (0, $4fqPo.useEffect)(()=>{
        if (!url || !(0, $3H4LK.fg)('csm_brand_entity_url_fix')) return;
        let cancelled = false;
        fetch(url).then((res)=>res.blob()).then((blob)=>new Promise((resolve, reject)=>{
                const reader = new FileReader();
                reader.onload = ()=>resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            })).then((base64)=>{
            if (!cancelled) setLogoUrl(base64);
        }).catch(()=>{
        // Silently fall back to the original signed URL if the fetch fails.
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        url
    ]);
    const navigationBar = (branding === null || branding === void 0 ? void 0 : branding.navigationBar) ?? null;
    const navStyleOptions = (0, $4fqPo.useMemo)(()=>({
            options: navigationBar ? (0, $immYM.mapApiToNavigationOptions)(navigationBar, primaryColor) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        primaryColor
    ]);
    // When the fix flag is ON, `pageMediaConfig` is omitted from the bootstrap
    // and is instead provided by the page-scoped `Hub` (read mode) and `HubInfo`
    // (edit mode) components via a nested `HubContext.Provider`. When the flag
    // is OFF the bootstrap still fetches it (via `$pageAri`) and provides it
    // here as before.
    const bootstrapPageMediaConfig = (0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media') ? undefined : $2ec9a2879781c443$var$getPageMediaConfigFromBootstrap(data.pageMediaConfig);
    // Memoize the context value so that consumers (e.g. `Hub`) receive a stable
    // reference across re-renders. Without this, every render of `HubBootstrap`
    // produces a new object literal, causing all `useHubContext()` consumers to
    // re-render even when nothing meaningful has changed. This is especially
    // important for the `useMemo` in `Hub` that merges `pageMediaConfig` into
    // the context — its deps array includes `hubContext`, so it needs a stable
    // input to avoid recomputing on every render.
    const hubContextValue = (0, $4fqPo.useMemo)(()=>({
            ...bootstrapPageMediaConfig ? {
                pageMediaConfig: bootstrapPageMediaConfig
            } : {},
            hubMediaConfig: data.hubMediaConfig,
            branding: {
                logo: {
                    fileId: fileId,
                    url: (0, $3H4LK.fg)('csm_brand_entity_url_fix') ? logoUrl : url
                },
                colors: {
                    primary: primaryColor || (0, $Bq10O.DEFAULT_BRANDING_COLOR),
                    // `accent` is intentionally NOT defaulted here — the
                    // HubThemingProvider owns the FE-side default so a single
                    // constant governs both "no BE field set" (returns null)
                    // and "outside HubBootstrap entirely" (Confluence/CSM)
                    // cases. Passing `undefined` lets the provider's
                    // `branding?.colors?.accent ?? DEFAULT_ACCENT` shortcut
                    // kick in either way.
                    ...accentColor ? {
                        accent: accentColor
                    } : {}
                }
            },
            layout: props.layout,
            user: props.user,
            env: props.env,
            actions: props.actions,
            containerStyling: props.containerStyling,
            renderAvatarMenuOptions: props.renderAvatarMenuOptions,
            renderRightNavActions: props.renderRightNavActions,
            featureFlags: props.featureFlags,
            headerless: props.headerless,
            cloudId: cloudId,
            cloudUrl: cloudUrl,
            hubType: hubType,
            isInPreviewMode: isInPreviewMode
        }), [
        bootstrapPageMediaConfig,
        data.hubMediaConfig,
        fileId,
        url,
        logoUrl,
        primaryColor,
        accentColor,
        props.layout,
        props.user,
        props.env,
        props.actions,
        props.containerStyling,
        props.renderAvatarMenuOptions,
        props.renderRightNavActions,
        props.featureFlags,
        props.headerless,
        cloudId,
        cloudUrl,
        hubType,
        isInPreviewMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iySE3.HubContext).Provider, {
        value: hubContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Vuy8.HubThemingProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $65BSy.NavigationStyleContext).Provider, {
        value: navStyleOptions
    }, children)));
};
const $2ec9a2879781c443$export$5f7521758ed90a1b = ({ children: children, queryReference: queryReference, ...props })=>{
    const data = (0, $gIeP2.usePreloadedQuery)((0, $3sFpN.default), queryReference);
    if (!data.helpCenter) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2ec9a2879781c443$export$caae1ac058a7a032, {
        bootstrapQueryReference: data.helpCenter,
        tenantContextsQueryReference: data,
        ...props
    }, children);
};

});
parcelRegister("3sFpN", function(module, exports) {
$parcel$export(module.exports, "default", () => $76b3353073d01735$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1fafbe3f5e59cfa1cc79ff36d14da926>>
 * @relayHash f7e88b121b5e2b46eeaa31ff8cc92d5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf8db5c270af2d039d8f9d28d2367431567cbf17cfe6383d2d8ed25721e15a0a
const $76b3353073d01735$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPageMediaConfig"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v7 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "pageAri",
                                    "variableName": "pageAri"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "skipPageMediaConfig",
                                    "variableName": "skipPageMediaConfig"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubBootstrapWrapperQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v7 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v8 /*: any*/ 
                        },
                        {
                            "condition": "skipPageMediaConfig",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "pageMediaConfig",
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "ari",
                                            "variableName": "pageAri"
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "concreteType": "HelpCenterMediaConfig",
                                    "kind": "LinkedField",
                                    "name": "hubMediaConfig",
                                    "plural": false,
                                    "selections": v8 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterNavigationBar",
                                                    "kind": "LinkedField",
                                                    "name": "navigationBar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "backgroundColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderColor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "borderType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cornerRadius"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "padding"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "positionType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "textColor"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bf8db5c270af2d039d8f9d28d2367431567cbf17cfe6383d2d8ed25721e15a0a",
            "metadata": {},
            "name": "hubBootstrapWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$76b3353073d01735$var$node.hash = "174240bce1a74f3153918fadfb8c8cce";
var $76b3353073d01735$export$2e2bcd8739ae039 = $76b3353073d01735$var$node;

});

parcelRegister("bj3Qb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d99d0d4666821e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<042bc6b2c3f711f749a6f3aaf17ffbc2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d99d0d4666821e8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "hubEditMode"
        }
    ],
    "kind": "Fragment",
    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference",
    "selections": [
        {
            "condition": "hubEditMode",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "items": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudIds.0",
                                    "variableName": "cloudId"
                                }
                            ],
                            "kind": "ListValue",
                            "name": "cloudIds"
                        }
                    ],
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "cloudUrl"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$4d99d0d4666821e8$var$node.hash = "951df66590a0cca5f7516d267ed12179";
var $4d99d0d4666821e8$export$2e2bcd8739ae039 = $4d99d0d4666821e8$var$node;

});

parcelRegister("bRFDi", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a8d5f51bf83c811$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e95f7b5441b0c2944d444abf2f88edfa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5a8d5f51bf83c811$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v1 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v2 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v4 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "hubAri"
            },
            {
                "kind": "RootArgument",
                "name": "operationType"
            },
            {
                "defaultValue": "",
                "kind": "LocalArgument",
                "name": "pageAri"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "skipPageMediaConfig"
            }
        ],
        "kind": "Fragment",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "ari",
                            "variableName": "hubAri"
                        },
                        v0 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterMediaConfig",
                    "kind": "LinkedField",
                    "name": "hubMediaConfig",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v2 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v4 /*: any*/ ,
                            "action": "THROW"
                        }
                    ]
                },
                "action": "THROW"
            },
            {
                "condition": "skipPageMediaConfig",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "alias": "pageMediaConfig",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "ari",
                                "variableName": "pageAri"
                            },
                            v0 /*: any*/ 
                        ],
                        "concreteType": "HelpCenterMediaConfig",
                        "kind": "LinkedField",
                        "name": "hubMediaConfig",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "helpCenterAri",
                        "variableName": "hubAri"
                    }
                ],
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "type"
                            },
                            {
                                "concreteType": "HelpCenterBranding",
                                "kind": "LinkedField",
                                "name": "helpCenterBranding",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLogo",
                                        "kind": "LinkedField",
                                        "name": "logo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "fileId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterBrandingColors",
                                        "kind": "LinkedField",
                                        "name": "colors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "primary"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "secondaryColor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "HelpCenterNavigationBar",
                                        "kind": "LinkedField",
                                        "name": "navigationBar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "backgroundColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderColor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "borderType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cornerRadius"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "padding"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "positionType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "textColor"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "type": "HelpCenter"
                    }
                ]
            }
        ],
        "type": "HelpCenterQueryApi"
    };
}();
$5a8d5f51bf83c811$var$node.hash = "628107f16d7ff5141bb75ac8541413ce";
var $5a8d5f51bf83c811$export$2e2bcd8739ae039 = $5a8d5f51bf83c811$var$node;

});

parcelRegister("Bq10O", function(module, exports) {
$parcel$export(module.exports, "SPOTLIGHT_EXTENSION_TYPE", () => $209d8163208fa12c$export$df3c2062a081a534);
$parcel$export(module.exports, "SECTION_EXTENSION_TYPE", () => $209d8163208fa12c$export$4454075c4322ae47);
$parcel$export(module.exports, "RESOURCE_TILES_EXTENSION_TYPE", () => $209d8163208fa12c$export$2dd5fc71941a6787);
$parcel$export(module.exports, "DEFAULT_BRANDING_COLOR", () => $209d8163208fa12c$export$8e1a1e8b8109dbf3);
$parcel$export(module.exports, "HUB_PRIMARY_COLOR_CSS_VAR", () => $209d8163208fa12c$export$8161b1f4e2928fa0);
$parcel$export(module.exports, "HUB_PRIMARY_TEXT_COLOR_CSS_VAR", () => $209d8163208fa12c$export$94d2a2331edd895d);
$parcel$export(module.exports, "HUB_PRIMARY_LINK_COLOR_CSS_VAR", () => $209d8163208fa12c$export$64de52c9db8240f6);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT", () => $209d8163208fa12c$export$4c91e7265b76e3a1);
$parcel$export(module.exports, "HUB_LOGO_HEIGHT_LEGACY", () => $209d8163208fa12c$export$d713f99e5e84a256);
$parcel$export(module.exports, "SENTRY_DSN", () => $209d8163208fa12c$export$6faa4a850bc4d0ce);
$parcel$export(module.exports, "UNKNOWN_TAG", () => $209d8163208fa12c$export$ea77880e3935182d);
$parcel$export(module.exports, "NETWORK_ERROR_CODE", () => $209d8163208fa12c$export$c7f012c6e67c4217);
const $209d8163208fa12c$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $209d8163208fa12c$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $209d8163208fa12c$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $209d8163208fa12c$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $209d8163208fa12c$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $209d8163208fa12c$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $209d8163208fa12c$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $209d8163208fa12c$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $209d8163208fa12c$export$8e1a1e8b8109dbf3 = '#DDDEE1';
const $209d8163208fa12c$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $209d8163208fa12c$export$94d2a2331edd895d = '--hub-primary-text-color';
const $209d8163208fa12c$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $209d8163208fa12c$export$4c91e7265b76e3a1 = '32px';
const $209d8163208fa12c$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $209d8163208fa12c$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $209d8163208fa12c$export$ea77880e3935182d = 'unknown';
const $209d8163208fa12c$export$c7f012c6e67c4217 = 0;

});

parcelRegister("5Vuy8", function(module, exports) {
$parcel$export(module.exports, "HubThemingProvider", () => $484f5859a79c85d3$export$637b3c4e057a01d3);
$parcel$export(module.exports, "useHubTheming", () => $484f5859a79c85d3$export$33bfea475043649c);

var $4fqPo = parcelRequire("4fqPo");

var $ex2l8 = parcelRequire("ex2l8");
var $2n0rH = parcelRequire("2n0rH");

var $2R2ud = parcelRequire("2R2ud");

var $Bq10O = parcelRequire("Bq10O");

var $iySE3 = parcelRequire("iySE3");

var $4B9vJ = parcelRequire("4B9vJ");
var $fHA58 = parcelRequire("fHA58");

var $cnYDK = parcelRequire("cnYDK");

var $63H5p = parcelRequire("63H5p");
const $484f5859a79c85d3$var$DEFAULT_PRIMARY = '#0052CC';
const $484f5859a79c85d3$export$a6017cadbc9d9217 = '#DCDFE4'; // matches `color.border`
const $484f5859a79c85d3$export$29b411f689221690 = '#758195'; // matches `color.border.bold`
// Neutral light gray. Used as the day-0 accent when neither the BE has
// a stored `secondaryColor` nor the admin has picked one in the panel.
// Matches `color.border` so accent-derived shades stay visually muted
// until the admin opts in to a colorful accent.
const $484f5859a79c85d3$var$DEFAULT_ACCENT = '#DDDEE1';
const $484f5859a79c85d3$var$HubThemingContext = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $484f5859a79c85d3$var$readableHubTextColor = (color)=>(0, $2n0rH.readableTextColor)(color, '@atlassian/company-hub-common');
const $484f5859a79c85d3$export$637b3c4e057a01d3 = ({ children: children })=>{
    var _branding$colors, _branding$colors2;
    const { branding: branding } = (0, $iySE3.useHubContext)();
    const isEnabled = (0, $63H5p.useIsAdvancedThemingEnabled)();
    const primaryColor = (branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary) ?? $484f5859a79c85d3$var$DEFAULT_PRIMARY;
    // Accent comes from the BE (`HelpCenterBrandingColors.secondaryColor`,
    // mapped to `branding.colors.accent` at the bootstrap boundary). If the
    // BE returns nothing — pre-v2 hubs, non-help-center hosts, fresh tenants
    // — we fall through to `DEFAULT_ACCENT`. The panel persists changes via
    // the same Relay mutation path that primary uses, so the picker's
    // `value` prop and the provider's `accentColor` here stay in lockstep
    // via the next bootstrap re-render. No FE-side state needed.
    const accentColor = (branding === null || branding === void 0 || (_branding$colors2 = branding.colors) === null || _branding$colors2 === void 0 ? void 0 : _branding$colors2.accent) ?? $484f5859a79c85d3$var$DEFAULT_ACCENT;
    const palette = (0, $fHA58.useHubBrandPalette)({
        primary: primaryColor,
        accent: accentColor
    });
    const primaryTextColor = (0, $4fqPo.useMemo)(()=>$484f5859a79c85d3$var$readableHubTextColor(primaryColor), [
        primaryColor
    ]);
    const primaryLinkColor = (0, $4fqPo.useMemo)(()=>(0, $2R2ud.generateThemeBranding)(primaryColor).color900, [
        primaryColor
    ]);
    // `defaultParameters` and `brandBackgroundColorMap` deliberately split on
    // `isEnabled` so consumers (CommonHubExtensionsDependenciesProvider, the
    // extension config panels) can keep reading from `useHubTheming()` without
    // branching themselves. When the gate is OFF we restore the pre-v2 shape
    // exactly: legacy CSS-var refs in default params (consumed by
    // setHubBrandingStyle's writes) and a single-knownColor swatch grid built
    // from `branding.colors.primary` so the picker still shows the brand swatch.
    //
    // When ON, the wrapper div below emits `--hub-color-*` vars, and
    // `defaultParameters.backgroundColor` is a `var(--hub-color-primary-200)`
    // reference rather than a hex literal. The renderer drops the var ref into
    // inline style; the cascade resolves it against the wrapper. This means
    // brand-color edits trigger a CSS-only repaint — no React re-render in the
    // consumer is needed for the new color to apply.
    const defaultParameters = (0, $4fqPo.useMemo)(()=>isEnabled ? // Gate ON: delegate to the shared resolver, passing the palette so
        // it returns `var(--hub-color-primary-200)` + the WCAG-readable
        // text color computed against that shade.
        {
            ...(0, $cnYDK.getHubDefaultParameters)({
                palette: palette
            }),
            textColor: primaryTextColor
        } : // Gate OFF: same resolver with no palette → legacy `var(--hub-*)`
        // chain that resolves against setHubBrandingStyle's writes on <html>.
        (0, $cnYDK.getHubDefaultParameters)(), [
        isEnabled,
        palette,
        primaryTextColor
    ]);
    // When ON: feed every shade of both palette families into the picker plus
    // universal white/black so the swatch grid surfaces all 22 colors.
    // When OFF: original single-color shape — knownColors holds the legacy
    // CSS-var string (matches master so the picker's strict-equality check
    // highlights the swatch for pre-v2 ADFs that store the same string).
    const brandBackgroundColorMap = (0, $4fqPo.useMemo)(()=>isEnabled ? (0, $ex2l8.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                '#FFFFFF',
                '#000000'
            ]
        }) : (0, $ex2l8.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        }), [
        isEnabled,
        palette,
        defaultParameters
    ]);
    // Border picker swatches: same 20 brand palette + 4 neutrals
    // (white, color.border, color.border.bold, black). We pass the resolved
    // hex values for color.border / color.border.bold so the swatches paint
    // correctly; admin-side translation back to the token reference happens
    // at picker-onChange time in the consumer (see border field code).
    const brandBorderColorMap = (0, $4fqPo.useMemo)(()=>isEnabled ? (0, $ex2l8.createBuiltInColorMap)({
            knownColors: [
                ...Object.values(palette),
                '#FFFFFF',
                $484f5859a79c85d3$export$a6017cadbc9d9217,
                $484f5859a79c85d3$export$29b411f689221690,
                '#000000'
            ]
        }) : (0, $ex2l8.createBuiltInColorMap)({
            knownColors: [
                defaultParameters.backgroundColor
            ]
        }), [
        isEnabled,
        palette,
        defaultParameters
    ]);
    const value = (0, $4fqPo.useMemo)(()=>({
            isAdvancedThemingEnabled: isEnabled,
            primaryColor: primaryColor,
            accentColor: accentColor,
            primaryTextColor: primaryTextColor,
            primaryLinkColor: primaryLinkColor,
            palette: palette,
            defaultParameters: defaultParameters,
            brandBackgroundColorMap: brandBackgroundColorMap,
            brandBorderColorMap: brandBorderColorMap
        }), [
        isEnabled,
        primaryColor,
        accentColor,
        primaryTextColor,
        primaryLinkColor,
        palette,
        defaultParameters,
        brandBackgroundColorMap,
        brandBorderColorMap
    ]);
    // Wrapper div emits the entire palette as inline `style` so the 20
    // `--hub-color-*` custom properties land in the SSR HTML and resolve on
    // first paint — no useEffect, no `document.documentElement.setProperty`,
    // no flash of unthemed content. Everything inside the wrapper inherits the
    // vars through the normal CSS cascade.
    //
    // `display: contents` tells the browser to render the wrapper's children
    // but skip generating a box for the wrapper itself, so it is invisible to
    // flex/grid/positioning. Without it, the wrapper would introduce a
    // `display: block` box that could break ancestor layouts (extra flex item,
    // extra grid cell, broken percentage heights, etc.). We get CSS-var
    // scoping + a DOM marker for devtools without any layout side-effect.
    // The cascade still works — `display: contents` does not stop custom
    // properties from being inherited by descendants.
    //
    // Wrapper always emits the full palette + legacy vars, regardless of the
    // gate state. This matters when an admin edits under v2 ON and then toggles
    // the FF off — their persisted ADFs reference `--hub-color-primary-*` and
    // would resolve to `unset` (white) without the wrapper providing the vars.
    // Always emitting keeps a flag flip non-destructive while the resolver and
    // picker still gate their *behavior* on `isAdvancedThemingEnabled`.
    //
    // Legacy compat vars (`--hub-primary-color` / `--hub-primary-text-color` /
    // `--hub-primary-link-color`) are also always emitted so pre-v2 ADFs that
    // reference them render with the exact same colors as before the v2 flip
    // (the input hex verbatim, WCAG-readable text, and
    // `generateThemeBranding(...).color900` link tint). Matches
    // `setHubBrandingStyle`'s semantics so admins with already-customised hubs
    // see no visual change post-flip.
    const wrapperStyle = (0, $4fqPo.useMemo)(()=>({
            display: 'contents',
            ...$484f5859a79c85d3$var$buildPaletteStyle(palette),
            [(0, $Bq10O.HUB_PRIMARY_COLOR_CSS_VAR)]: primaryColor,
            [(0, $Bq10O.HUB_PRIMARY_TEXT_COLOR_CSS_VAR)]: primaryTextColor,
            [(0, $Bq10O.HUB_PRIMARY_LINK_COLOR_CSS_VAR)]: primaryLinkColor
        }), [
        palette,
        primaryColor,
        primaryTextColor,
        primaryLinkColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($484f5859a79c85d3$var$HubThemingContext.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-hub-theme-root": "",
        style: wrapperStyle
    }, children));
};
/**
 * Build the inline-style object emitted on the wrapper div from the palette.
 * Returns 20 entries of the form `{ '--hub-color-primary-200': '#B3D4FF' }`.
 *
 * Kept outside the provider so the entry-set construction is testable in
 * isolation and not entangled with React rendering.
 */ const $484f5859a79c85d3$var$buildPaletteStyle = (palette)=>{
    const out = {};
    for (const ref of Object.keys(palette))out[(0, $4B9vJ.HUB_COLOR_CSS_VARS)[ref]] = palette[ref];
    return out;
};
const $484f5859a79c85d3$export$33bfea475043649c = ()=>{
    return (0, $4fqPo.useContext)($484f5859a79c85d3$var$HubThemingContext) ?? undefined;
};

});
parcelRegister("ex2l8", function(module, exports) {
$parcel$export(module.exports, "createBuiltInColorMap", () => $f189fb88d4722e26$export$a4af15b2fa34f34e);

var $9sQ7a = parcelRequire("9sQ7a");

var $60dRU = parcelRequire("60dRU");
const $f189fb88d4722e26$export$a4af15b2fa34f34e = ({ knownColors: knownColors, allColors: allColors, humanReadableColors: humanReadableColors, getResponsiveColor: getResponsiveColor })=>{
    knownColors = knownColors.map((color)=>color.toLowerCase());
    const knownTokens = knownColors.map((color)=>(0, $9sQ7a.extractToken)(color));
    if (!allColors) allColors = knownColors;
    else allColors = allColors.map((color)=>color.toLowerCase());
    const allTokens = allColors.map((color)=>(0, $9sQ7a.extractToken)(color));
    const humanReadableColorsMap = humanReadableColors ? new Map([
        ...(0, $60dRU.allHumanReadableColors).entries(),
        ...humanReadableColors.entries()
    ]) : (0, $60dRU.allHumanReadableColors);
    return {
        knownColors: knownColors,
        knownTokens: knownTokens,
        allColors: allColors,
        allTokens: allTokens,
        humanReadableColors: humanReadableColorsMap,
        getResponsiveColor: getResponsiveColor || ((color)=>color)
    };
};

});
parcelRegister("9sQ7a", function(module, exports) {
$parcel$export(module.exports, "isValidColor", () => $a88fa4541c2b8b94$export$35fa9d266cdb6f09);
$parcel$export(module.exports, "convertLegacyColor", () => $a88fa4541c2b8b94$export$b2b344a3caf230bf);
$parcel$export(module.exports, "extractToken", () => $a88fa4541c2b8b94$export$5039139b891079e8);
$parcel$export(module.exports, "getSanitizedColor", () => $a88fa4541c2b8b94$export$d16dc80c78f978b3);
$parcel$export(module.exports, "toHexColor", () => $a88fa4541c2b8b94$export$342249704b28d862);
$parcel$export(module.exports, "isReadable", () => $a88fa4541c2b8b94$export$3fe5b5ca1e6a6a28);
$parcel$export(module.exports, "getMostReadableColor", () => $a88fa4541c2b8b94$export$21e0b327e0d86beb);

var $bKq6R = parcelRequire("bKq6R");
/* regular expressions obtained from CssColourValidator.java
 * CssColourValidator runs in legacy Color Scheme on updateSiteLookAndFeel mutation
 * instead of validating on Save, we are now validating as user enters custom input
 */ const $a88fa4541c2b8b94$var$VAR_MATCH = new RegExp('^var\\((\\-\\-[a-zA-Z0-9\\-_]+)\\s*(,(.+))?\\)$');
const $a88fa4541c2b8b94$var$SHORT_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){3}$');
const $a88fa4541c2b8b94$var$LONG_NUMERIC_MATCH = new RegExp('^#([\\da-fA-F]){6}$');
const $a88fa4541c2b8b94$var$RGB_MATCH = new RegExp('^rgb\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*\\)$');
const $a88fa4541c2b8b94$var$PERC_MATCH = new RegExp('^rgb\\((\\d+)%,\\s*(\\d+)%,\\s*(\\d+)%\\)$');
const $a88fa4541c2b8b94$var$RGBA_MATCH = new RegExp('^rgba\\(\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*(0|[1-9]\\d?|1\\d\\d?|2[0-4]\\d|25[0-5])\\s*,\\s*((0.[0-9]*)|[01])\\s*\\)$');
const $a88fa4541c2b8b94$var$HSL_MATCH = new RegExp('^hsl\\(\\s*(0|[1-9]\\d?|[12]\\d\\d|3[0-5]\\d)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*,\\s*((0|[1-9]\\d?|100)%)\\s*\\)$');
/* evaluates validity for any incoming colors from 1) siteConfiguration query 2) custom input field
 * until hsla and named color conversion errors are handled properly in app-navigation, we return the default Atlassian theme as in getSanitizedColor fn
 * it is an existing pattern under useNavigationTheme to return the theme as means of error handling
 * once resolved, this isValidColor can validate for HSLA_MATCH and NAMED_COLOR_MATCH
 */ function $a88fa4541c2b8b94$var$isValidVarColor(color) {
    const matches = $a88fa4541c2b8b94$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$;
        const fallback = (_matches$ = matches[3]) === null || _matches$ === void 0 ? void 0 : _matches$.trim();
        if (fallback) {
            // If fallback is another var() call, validate it recursively
            if (fallback.startsWith('var(')) return $a88fa4541c2b8b94$var$isValidVarColor(fallback);
            // Otherwise validate as a regular color
            return $a88fa4541c2b8b94$export$35fa9d266cdb6f09(fallback, false);
        }
        // If there's a comma but no fallback (like "var(--token, )"), it's invalid
        if (matches[2] && !fallback) return false;
        return true;
    }
    return false;
}
function $a88fa4541c2b8b94$export$35fa9d266cdb6f09(color, isVarColorAllowed = true) {
    return isVarColorAllowed && $a88fa4541c2b8b94$var$isValidVarColor(color) || $a88fa4541c2b8b94$var$SHORT_NUMERIC_MATCH.test(color) || $a88fa4541c2b8b94$var$LONG_NUMERIC_MATCH.test(color) || $a88fa4541c2b8b94$var$RGB_MATCH.test(color) || $a88fa4541c2b8b94$var$PERC_MATCH.test(color) || $a88fa4541c2b8b94$var$RGBA_MATCH.test(color) || $a88fa4541c2b8b94$var$HSL_MATCH.test(color);
}
function $a88fa4541c2b8b94$export$b2b344a3caf230bf(color) {
    if (!$a88fa4541c2b8b94$export$35fa9d266cdb6f09(color)) return (0, $bKq6R.default)('invalid');
    const colorCode = $a88fa4541c2b8b94$var$extractColorCode(color);
    return (0, $bKq6R.default)(colorCode);
}
/* simply extracts the color code from given color string.
 * If color is tokenized, either computes or extracts fallback hex value
 * Else return color as is
 */ function $a88fa4541c2b8b94$var$extractColorCode(color) {
    const matches = $a88fa4541c2b8b94$var$VAR_MATCH.exec(color);
    if (matches) {
        var _matches$2;
        const fallback = (_matches$2 = matches[3]) === null || _matches$2 === void 0 ? void 0 : _matches$2.trim();
        const token = matches[1].toLowerCase();
        // SSR guard
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const compiledTokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
            // If we have a computed value, return it
            if (compiledTokenValue) return compiledTokenValue;
        }
        // If there's a fallback, process it recursively
        if (fallback) {
            // If fallback is another var() call, extract from it recursively
            if (fallback.startsWith('var(')) return $a88fa4541c2b8b94$var$extractColorCode(fallback);
            // Otherwise return the fallback as is
            return fallback;
        }
        // No computed value and no fallback
        return '';
    }
    return color;
}
function $a88fa4541c2b8b94$export$5039139b891079e8(color = '') {
    const matches = $a88fa4541c2b8b94$var$VAR_MATCH.exec(color);
    return (matches === null || matches === void 0 ? void 0 : matches[1].toLowerCase()) ?? color;
}
function $a88fa4541c2b8b94$export$d16dc80c78f978b3({ allColors: allColors, allTokens: allTokens, knownColors: knownColors }, color = '') {
    const index = allTokens.indexOf($a88fa4541c2b8b94$export$5039139b891079e8(color));
    if (index !== -1) return allColors[index];
    if (!$a88fa4541c2b8b94$export$35fa9d266cdb6f09(color)) return knownColors[0];
    return color;
}
function $a88fa4541c2b8b94$export$342249704b28d862(color) {
    const converted = $a88fa4541c2b8b94$export$b2b344a3caf230bf(color);
    if (converted.isValid()) return converted.toHexString();
    return color;
}
function $a88fa4541c2b8b94$export$3fe5b5ca1e6a6a28(backgroundColor, highlightColor) {
    const backgroundCode = $a88fa4541c2b8b94$var$extractColorCode(backgroundColor);
    const highlightCode = $a88fa4541c2b8b94$var$extractColorCode(highlightColor);
    return (0, $bKq6R.default).isReadable(backgroundCode, highlightCode);
}
function $a88fa4541c2b8b94$export$21e0b327e0d86beb(color) {
    color = $a88fa4541c2b8b94$var$extractColorCode(color);
    return (0, $bKq6R.default).mostReadable(color, [
        '#000000',
        '#ffffff'
    ]).toHexString();
}
function $a88fa4541c2b8b94$export$bf60f520e1f9cbf8(color1, color2) {
    return $a88fa4541c2b8b94$var$extractColorCode(color1) === $a88fa4541c2b8b94$var$extractColorCode(color2);
}

});
parcelRegister("bKq6R", function(module, exports) {
$parcel$export(module.exports, "default", () => $88d83e6bde6b519a$export$2e2bcd8739ae039);
// This file is autogenerated. It's used to publish ESM to npm.
function $88d83e6bde6b519a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $88d83e6bde6b519a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $88d83e6bde6b519a$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $88d83e6bde6b519a$var$trimLeft = /^\s+/;
var $88d83e6bde6b519a$var$trimRight = /\s+$/;
function $88d83e6bde6b519a$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $88d83e6bde6b519a$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $88d83e6bde6b519a$export$2e2bcd8739ae039)) return new $88d83e6bde6b519a$export$2e2bcd8739ae039(color, opts);
    var rgb = $88d83e6bde6b519a$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$88d83e6bde6b519a$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $88d83e6bde6b519a$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $88d83e6bde6b519a$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $88d83e6bde6b519a$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $88d83e6bde6b519a$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $88d83e6bde6b519a$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $88d83e6bde6b519a$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $88d83e6bde6b519a$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($88d83e6bde6b519a$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($88d83e6bde6b519a$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($88d83e6bde6b519a$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($88d83e6bde6b519a$var$bound01(this._r, 255) * 100) + "%, " + Math.round($88d83e6bde6b519a$var$bound01(this._g, 255) * 100) + "%, " + Math.round($88d83e6bde6b519a$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($88d83e6bde6b519a$var$bound01(this._r, 255) * 100) + "%, " + Math.round($88d83e6bde6b519a$var$bound01(this._g, 255) * 100) + "%, " + Math.round($88d83e6bde6b519a$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $88d83e6bde6b519a$var$hexNames[$88d83e6bde6b519a$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $88d83e6bde6b519a$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $88d83e6bde6b519a$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $88d83e6bde6b519a$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $88d83e6bde6b519a$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($88d83e6bde6b519a$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($88d83e6bde6b519a$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($88d83e6bde6b519a$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($88d83e6bde6b519a$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($88d83e6bde6b519a$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($88d83e6bde6b519a$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($88d83e6bde6b519a$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($88d83e6bde6b519a$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($88d83e6bde6b519a$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($88d83e6bde6b519a$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($88d83e6bde6b519a$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($88d83e6bde6b519a$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($88d83e6bde6b519a$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$88d83e6bde6b519a$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($88d83e6bde6b519a$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $88d83e6bde6b519a$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $88d83e6bde6b519a$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $88d83e6bde6b519a$var$stringInputToObject(color);
    if ($88d83e6bde6b519a$var$_typeof(color) == "object") {
        if ($88d83e6bde6b519a$var$isValidCSSUnit(color.r) && $88d83e6bde6b519a$var$isValidCSSUnit(color.g) && $88d83e6bde6b519a$var$isValidCSSUnit(color.b)) {
            rgb = $88d83e6bde6b519a$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($88d83e6bde6b519a$var$isValidCSSUnit(color.h) && $88d83e6bde6b519a$var$isValidCSSUnit(color.s) && $88d83e6bde6b519a$var$isValidCSSUnit(color.v)) {
            s = $88d83e6bde6b519a$var$convertToPercentage(color.s);
            v = $88d83e6bde6b519a$var$convertToPercentage(color.v);
            rgb = $88d83e6bde6b519a$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($88d83e6bde6b519a$var$isValidCSSUnit(color.h) && $88d83e6bde6b519a$var$isValidCSSUnit(color.s) && $88d83e6bde6b519a$var$isValidCSSUnit(color.l)) {
            s = $88d83e6bde6b519a$var$convertToPercentage(color.s);
            l = $88d83e6bde6b519a$var$convertToPercentage(color.l);
            rgb = $88d83e6bde6b519a$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $88d83e6bde6b519a$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $88d83e6bde6b519a$var$rgbToRgb(r, g, b) {
    return {
        r: $88d83e6bde6b519a$var$bound01(r, 255) * 255,
        g: $88d83e6bde6b519a$var$bound01(g, 255) * 255,
        b: $88d83e6bde6b519a$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $88d83e6bde6b519a$var$rgbToHsl(r, g, b) {
    r = $88d83e6bde6b519a$var$bound01(r, 255);
    g = $88d83e6bde6b519a$var$bound01(g, 255);
    b = $88d83e6bde6b519a$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $88d83e6bde6b519a$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $88d83e6bde6b519a$var$bound01(h, 360);
    s = $88d83e6bde6b519a$var$bound01(s, 100);
    l = $88d83e6bde6b519a$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $88d83e6bde6b519a$var$rgbToHsv(r, g, b) {
    r = $88d83e6bde6b519a$var$bound01(r, 255);
    g = $88d83e6bde6b519a$var$bound01(g, 255);
    b = $88d83e6bde6b519a$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $88d83e6bde6b519a$var$hsvToRgb(h, s, v) {
    h = $88d83e6bde6b519a$var$bound01(h, 360) * 6;
    s = $88d83e6bde6b519a$var$bound01(s, 100);
    v = $88d83e6bde6b519a$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $88d83e6bde6b519a$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $88d83e6bde6b519a$var$pad2(Math.round(r).toString(16)),
        $88d83e6bde6b519a$var$pad2(Math.round(g).toString(16)),
        $88d83e6bde6b519a$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $88d83e6bde6b519a$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $88d83e6bde6b519a$var$pad2(Math.round(r).toString(16)),
        $88d83e6bde6b519a$var$pad2(Math.round(g).toString(16)),
        $88d83e6bde6b519a$var$pad2(Math.round(b).toString(16)),
        $88d83e6bde6b519a$var$pad2($88d83e6bde6b519a$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $88d83e6bde6b519a$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $88d83e6bde6b519a$var$pad2($88d83e6bde6b519a$var$convertDecimalToHex(a)),
        $88d83e6bde6b519a$var$pad2(Math.round(r).toString(16)),
        $88d83e6bde6b519a$var$pad2(Math.round(g).toString(16)),
        $88d83e6bde6b519a$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$88d83e6bde6b519a$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(color1).toRgbString() == $88d83e6bde6b519a$export$2e2bcd8739ae039(color2).toRgbString();
};
$88d83e6bde6b519a$export$2e2bcd8739ae039.random = function() {
    return $88d83e6bde6b519a$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $88d83e6bde6b519a$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $88d83e6bde6b519a$var$clamp01(hsl.s);
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(hsl);
}
function $88d83e6bde6b519a$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $88d83e6bde6b519a$var$clamp01(hsl.s);
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(hsl);
}
function $88d83e6bde6b519a$var$_greyscale(color) {
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(color).desaturate(100);
}
function $88d83e6bde6b519a$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $88d83e6bde6b519a$var$clamp01(hsl.l);
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(hsl);
}
function $88d83e6bde6b519a$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(rgb);
}
function $88d83e6bde6b519a$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $88d83e6bde6b519a$var$clamp01(hsl.l);
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $88d83e6bde6b519a$var$_spin(color, amount) {
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $88d83e6bde6b519a$var$_complement(color) {
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(hsl);
}
function $88d83e6bde6b519a$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $88d83e6bde6b519a$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($88d83e6bde6b519a$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $88d83e6bde6b519a$var$_splitcomplement(color) {
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $88d83e6bde6b519a$export$2e2bcd8739ae039(color),
        $88d83e6bde6b519a$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $88d83e6bde6b519a$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $88d83e6bde6b519a$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $88d83e6bde6b519a$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($88d83e6bde6b519a$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $88d83e6bde6b519a$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $88d83e6bde6b519a$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($88d83e6bde6b519a$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$88d83e6bde6b519a$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $88d83e6bde6b519a$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $88d83e6bde6b519a$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $88d83e6bde6b519a$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$88d83e6bde6b519a$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $88d83e6bde6b519a$export$2e2bcd8739ae039(color1);
    var c2 = $88d83e6bde6b519a$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$88d83e6bde6b519a$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $88d83e6bde6b519a$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $88d83e6bde6b519a$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$88d83e6bde6b519a$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $88d83e6bde6b519a$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $88d83e6bde6b519a$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($88d83e6bde6b519a$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $88d83e6bde6b519a$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $88d83e6bde6b519a$var$names = $88d83e6bde6b519a$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $88d83e6bde6b519a$var$hexNames = $88d83e6bde6b519a$export$2e2bcd8739ae039.hexNames = $88d83e6bde6b519a$var$flip($88d83e6bde6b519a$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $88d83e6bde6b519a$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $88d83e6bde6b519a$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $88d83e6bde6b519a$var$bound01(n, max) {
    if ($88d83e6bde6b519a$var$isOnePointZero(n)) n = "100%";
    var processPercent = $88d83e6bde6b519a$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $88d83e6bde6b519a$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $88d83e6bde6b519a$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $88d83e6bde6b519a$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $88d83e6bde6b519a$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $88d83e6bde6b519a$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $88d83e6bde6b519a$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $88d83e6bde6b519a$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $88d83e6bde6b519a$var$convertHexToDecimal(h) {
    return $88d83e6bde6b519a$var$parseIntFromHex(h) / 255;
}
var $88d83e6bde6b519a$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $88d83e6bde6b519a$var$isValidCSSUnit(color) {
    return !!$88d83e6bde6b519a$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $88d83e6bde6b519a$var$stringInputToObject(color) {
    color = color.replace($88d83e6bde6b519a$var$trimLeft, "").replace($88d83e6bde6b519a$var$trimRight, "").toLowerCase();
    var named = false;
    if ($88d83e6bde6b519a$var$names[color]) {
        color = $88d83e6bde6b519a$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $88d83e6bde6b519a$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $88d83e6bde6b519a$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $88d83e6bde6b519a$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $88d83e6bde6b519a$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $88d83e6bde6b519a$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $88d83e6bde6b519a$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $88d83e6bde6b519a$var$matchers.hex8.exec(color)) return {
        r: $88d83e6bde6b519a$var$parseIntFromHex(match[1]),
        g: $88d83e6bde6b519a$var$parseIntFromHex(match[2]),
        b: $88d83e6bde6b519a$var$parseIntFromHex(match[3]),
        a: $88d83e6bde6b519a$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $88d83e6bde6b519a$var$matchers.hex6.exec(color)) return {
        r: $88d83e6bde6b519a$var$parseIntFromHex(match[1]),
        g: $88d83e6bde6b519a$var$parseIntFromHex(match[2]),
        b: $88d83e6bde6b519a$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $88d83e6bde6b519a$var$matchers.hex4.exec(color)) return {
        r: $88d83e6bde6b519a$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $88d83e6bde6b519a$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $88d83e6bde6b519a$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $88d83e6bde6b519a$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $88d83e6bde6b519a$var$matchers.hex3.exec(color)) return {
        r: $88d83e6bde6b519a$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $88d83e6bde6b519a$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $88d83e6bde6b519a$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $88d83e6bde6b519a$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}

});


parcelRegister("60dRU", function(module, exports) {
$parcel$export(module.exports, "allHumanReadableColors", () => $e2d26cb7be4b9b53$export$37744bda14f72c19);

var $4CHF4 = parcelRequire("4CHF4");
const $e2d26cb7be4b9b53$export$37744bda14f72c19 = new Map([
    // background colors
    [
        "var(--ds-surface-overlay, #FFFFFF)".toLowerCase(),
        (0, $4CHF4.colorNames).defaultWhite
    ],
    [
        "var(--ds-background-accent-blue-subtlest, #E9F2FE)".toLowerCase(),
        (0, $4CHF4.colorNames).lightBlue
    ],
    [
        "var(--ds-background-accent-purple-subtlest, #F8EEFE)".toLowerCase(),
        (0, $4CHF4.colorNames).lightPurple
    ],
    [
        "var(--ds-background-accent-magenta-subtlest, #FFECF8)".toLowerCase(),
        (0, $4CHF4.colorNames).lightMagenta
    ],
    [
        "var(--ds-background-accent-red-subtlest, #FFECEB)".toLowerCase(),
        (0, $4CHF4.colorNames).lightRed
    ],
    [
        "var(--ds-background-accent-orange-subtlest, #FFF5DB)".toLowerCase(),
        (0, $4CHF4.colorNames).lightOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtlest, #FEF7C8)".toLowerCase(),
        (0, $4CHF4.colorNames).lightYellow
    ],
    [
        "var(--ds-background-accent-lime-subtlest, #EFFFD6)".toLowerCase(),
        (0, $4CHF4.colorNames).lightLime
    ],
    [
        "var(--ds-background-accent-green-subtlest, #DCFFF1)".toLowerCase(),
        (0, $4CHF4.colorNames).lightGreen
    ],
    [
        "var(--ds-background-accent-teal-subtlest, #E7F9FF)".toLowerCase(),
        (0, $4CHF4.colorNames).lightTeal
    ],
    [
        "var(--ds-background-accent-gray-subtler, #DDDEE1)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleGray
    ],
    [
        "var(--ds-background-accent-blue-subtler, #CFE1FD)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleBlue
    ],
    [
        "var(--ds-background-accent-purple-subtler, #EED7FC)".toLowerCase(),
        (0, $4CHF4.colorNames).subtlePurple
    ],
    [
        "var(--ds-background-accent-magenta-subtler, #FDD0EC)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleMagenta
    ],
    [
        "var(--ds-background-accent-red-subtler, #FFD5D2)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleRed
    ],
    [
        "var(--ds-background-accent-orange-subtler, #FCE4A6)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleOrange
    ],
    [
        "var(--ds-background-accent-yellow-subtler, #F5E989)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleYellow
    ],
    [
        "var(--ds-background-accent-lime-subtler, #D3F1A7)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleLime
    ],
    [
        "var(--ds-background-accent-green-subtler, #BAF3DB)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleGreen
    ],
    [
        "var(--ds-background-accent-teal-subtler, #C6EDFB)".toLowerCase(),
        (0, $4CHF4.colorNames).subtleTeal
    ],
    [
        "var(--ds-background-accent-gray-subtle, #8C8F97)".toLowerCase(),
        (0, $4CHF4.colorNames).gray
    ],
    [
        "var(--ds-background-accent-blue-subtle, #669DF1)".toLowerCase(),
        (0, $4CHF4.colorNames).blue
    ],
    [
        "var(--ds-background-accent-purple-subtle, #C97CF4)".toLowerCase(),
        (0, $4CHF4.colorNames).purple
    ],
    [
        "var(--ds-background-accent-magenta-subtle, #E774BB)".toLowerCase(),
        (0, $4CHF4.colorNames).magenta
    ],
    [
        "var(--ds-background-accent-red-subtle, #F87168)".toLowerCase(),
        (0, $4CHF4.colorNames).red
    ],
    [
        "var(--ds-background-accent-orange-subtle, #FCA700)".toLowerCase(),
        (0, $4CHF4.colorNames).orange
    ],
    [
        "var(--ds-background-accent-yellow-subtle, #EED12B)".toLowerCase(),
        (0, $4CHF4.colorNames).yellow
    ],
    [
        "var(--ds-background-accent-lime-subtle, #94C748)".toLowerCase(),
        (0, $4CHF4.colorNames).lime
    ],
    [
        "var(--ds-background-accent-green-subtle, #4BCE97)".toLowerCase(),
        (0, $4CHF4.colorNames).green
    ],
    [
        "var(--ds-background-accent-teal-subtle, #6CC3E0)".toLowerCase(),
        (0, $4CHF4.colorNames).teal
    ],
    [
        "var(--ds-text-brand, #1868DB)".toLowerCase(),
        (0, $4CHF4.colorNames).defaultBlue
    ],
    [
        "var(--ds-background-accent-gray-bolder, #6B6E76)".toLowerCase(),
        (0, $4CHF4.colorNames).boldGray
    ],
    [
        "var(--ds-background-accent-blue-bolder, #1868DB)".toLowerCase(),
        (0, $4CHF4.colorNames).boldBlue
    ],
    [
        "var(--ds-background-accent-purple-bolder, #964AC0)".toLowerCase(),
        (0, $4CHF4.colorNames).boldPurple
    ],
    [
        "var(--ds-background-accent-magenta-bolder, #AE4787)".toLowerCase(),
        (0, $4CHF4.colorNames).boldMagenta
    ],
    [
        "var(--ds-background-accent-red-bolder, #C9372C)".toLowerCase(),
        (0, $4CHF4.colorNames).boldRed
    ],
    [
        "var(--ds-background-accent-orange-bolder, #BD5B00)".toLowerCase(),
        (0, $4CHF4.colorNames).boldOrange
    ],
    [
        "var(--ds-background-accent-yellow-bolder, #946F00)".toLowerCase(),
        (0, $4CHF4.colorNames).boldYellow
    ],
    [
        "var(--ds-background-accent-lime-bolder, #5B7F24)".toLowerCase(),
        (0, $4CHF4.colorNames).boldLime
    ],
    [
        "var(--ds-background-accent-green-bolder, #1F845A)".toLowerCase(),
        (0, $4CHF4.colorNames).boldGreen
    ],
    [
        "var(--ds-background-accent-teal-bolder, #227D9B)".toLowerCase(),
        (0, $4CHF4.colorNames).boldTeal
    ],
    // text colors
    [
        "var(--ds-text, #292A2E)".toLowerCase(),
        (0, $4CHF4.colorNames).boldGray
    ],
    [
        "var(--ds-text-accent-blue-bolder, #123263)".toLowerCase(),
        (0, $4CHF4.colorNames).boldBlue
    ],
    [
        "var(--ds-text-accent-purple-bolder, #48245D)".toLowerCase(),
        (0, $4CHF4.colorNames).boldPurple
    ],
    [
        "var(--ds-text-accent-magenta-bolder, #50253F)".toLowerCase(),
        (0, $4CHF4.colorNames).boldMagenta
    ],
    [
        "var(--ds-text-accent-red-bolder, #5D1F1A)".toLowerCase(),
        (0, $4CHF4.colorNames).boldRed
    ],
    [
        "var(--ds-text-accent-orange-bolder, #693200)".toLowerCase(),
        (0, $4CHF4.colorNames).boldOrange
    ],
    [
        "var(--ds-text-accent-yellow-bolder, #533F04)".toLowerCase(),
        (0, $4CHF4.colorNames).boldYellow
    ],
    [
        "var(--ds-text-accent-lime-bolder, #37471F)".toLowerCase(),
        (0, $4CHF4.colorNames).boldLime
    ],
    [
        "var(--ds-text-accent-green-bolder, #164B35)".toLowerCase(),
        (0, $4CHF4.colorNames).boldGreen
    ],
    [
        "var(--ds-text-accent-teal-bolder, #164555)".toLowerCase(),
        (0, $4CHF4.colorNames).boldTeal
    ],
    [
        "var(--ds-text-subtle, #505258)".toLowerCase(),
        (0, $4CHF4.colorNames).gray
    ],
    [
        "var(--ds-text-accent-blue, #1558BC)".toLowerCase(),
        (0, $4CHF4.colorNames).blue
    ],
    [
        "var(--ds-text-accent-purple, #803FA5)".toLowerCase(),
        (0, $4CHF4.colorNames).purple
    ],
    [
        "var(--ds-text-accent-magenta, #943D73)".toLowerCase(),
        (0, $4CHF4.colorNames).magenta
    ],
    [
        "var(--ds-text-accent-red, #AE2E24)".toLowerCase(),
        (0, $4CHF4.colorNames).red
    ],
    [
        "var(--ds-text-accent-orange, #9E4C00)".toLowerCase(),
        (0, $4CHF4.colorNames).orange
    ],
    [
        "var(--ds-text-accent-yellow, #7F5F01)".toLowerCase(),
        (0, $4CHF4.colorNames).yellow
    ],
    [
        "var(--ds-text-accent-lime, #4C6B1F)".toLowerCase(),
        (0, $4CHF4.colorNames).lime
    ],
    [
        "var(--ds-text-accent-green, #216E4E)".toLowerCase(),
        (0, $4CHF4.colorNames).green
    ],
    [
        "var(--ds-text-accent-teal, #206A83)".toLowerCase(),
        (0, $4CHF4.colorNames).teal
    ],
    [
        "var(--ds-text-inverse, #FFFFFF)".toLowerCase(),
        (0, $4CHF4.colorNames).white
    ],
    // border colors
    [
        "var(--ds-border-accent-blue, #357DE8)".toLowerCase(),
        (0, $4CHF4.colorNames).blue
    ],
    [
        "var(--ds-border-accent-purple, #AF59E1)".toLowerCase(),
        (0, $4CHF4.colorNames).purple
    ],
    [
        "var(--ds-border-accent-magenta, #CD519D)".toLowerCase(),
        (0, $4CHF4.colorNames).magenta
    ],
    [
        "var(--ds-border-accent-red, #E2483D)".toLowerCase(),
        (0, $4CHF4.colorNames).red
    ],
    [
        "var(--ds-border-accent-orange, #E06C00)".toLowerCase(),
        (0, $4CHF4.colorNames).orange
    ],
    [
        "var(--ds-border-accent-yellow, #B38600)".toLowerCase(),
        (0, $4CHF4.colorNames).yellow
    ],
    [
        "var(--ds-border-accent-lime, #6A9A23)".toLowerCase(),
        (0, $4CHF4.colorNames).lime
    ],
    [
        "var(--ds-border-accent-green, #22A06B)".toLowerCase(),
        (0, $4CHF4.colorNames).green
    ],
    [
        "var(--ds-border-accent-teal, #2898BD)".toLowerCase(),
        (0, $4CHF4.colorNames).teal
    ],
    [
        "var(--ds-border-inverse, #FFFFFF)".toLowerCase(),
        (0, $4CHF4.colorNames).white
    ],
    [
        "var(--ds-border-accent-gray, #7D818A)".toLowerCase(),
        (0, $4CHF4.colorNames).gray
    ]
]);

});
parcelRegister("4CHF4", function(module, exports) {
$parcel$export(module.exports, "colorNames", () => $337138071efbf17c$export$88bbe6beac980300);

var $6BhDL = parcelRequire("6BhDL");
const $337138071efbf17c$export$88bbe6beac980300 = (0, $6BhDL.defineMessages)({
    defaultWhite: {
        id: 'company-hub.color-picker.default-white',
        description: 'Name of default white color',
        defaultMessage: 'Default white'
    },
    white: {
        id: 'company-hub.color-picker.white',
        description: 'Name of white color',
        defaultMessage: 'White'
    },
    lightGray: {
        id: 'company-hub.color-picker.light-gray',
        description: 'Name of light gray color',
        defaultMessage: 'Light gray'
    },
    lightBlue: {
        id: 'company-hub.color-picker.light-blue',
        description: 'Name of light blue color',
        defaultMessage: 'Light blue'
    },
    lightPurple: {
        id: 'company-hub.color-picker.light-purple',
        description: 'Name of light purple color',
        defaultMessage: 'Light purple'
    },
    lightMagenta: {
        id: 'company-hub.color-picker.light-magenta',
        description: 'Name of light magenta color',
        defaultMessage: 'Light magenta'
    },
    lightRed: {
        id: 'company-hub.color-picker.light-red',
        description: 'Name of light red color',
        defaultMessage: 'Light red'
    },
    lightOrange: {
        id: 'company-hub.color-picker.light-orange',
        description: 'Name of light orange color',
        defaultMessage: 'Light orange'
    },
    lightYellow: {
        id: 'company-hub.color-picker.light-yellow',
        description: 'Name of light yellow color',
        defaultMessage: 'Light yellow'
    },
    lightLime: {
        id: 'company-hub.color-picker.light-lime',
        description: 'Name of light lime color',
        defaultMessage: 'Light lime'
    },
    lightGreen: {
        id: 'company-hub.color-picker.light-green',
        description: 'Name of light green color',
        defaultMessage: 'Light green'
    },
    lightTeal: {
        id: 'company-hub.color-picker.light-teal',
        description: 'Name of light teal color',
        defaultMessage: 'Light teal'
    },
    subtleGray: {
        id: 'company-hub.color-picker.subtle-gray',
        description: 'Name of subtle gray color',
        defaultMessage: 'Subtle gray'
    },
    subtleBlue: {
        id: 'company-hub.color-picker.subtle-blue',
        description: 'Name of subtle blue color',
        defaultMessage: 'Subtle blue'
    },
    subtlePurple: {
        id: 'company-hub.color-picker.subtle-purple',
        description: 'Name of subtle purple color',
        defaultMessage: 'Subtle purple'
    },
    subtleMagenta: {
        id: 'company-hub.color-picker.subtle-magenta',
        description: 'Name of subtle magenta color',
        defaultMessage: 'Subtle magenta'
    },
    subtleRed: {
        id: 'company-hub.color-picker.subtle-red',
        description: 'Name of subtle red color',
        defaultMessage: 'Subtle red'
    },
    subtleOrange: {
        id: 'company-hub.color-picker.subtle-orange',
        description: 'Name of subtle orange color',
        defaultMessage: 'Subtle orange'
    },
    subtleYellow: {
        id: 'company-hub.color-picker.subtle-yellow',
        description: 'Name of subtle yellow color',
        defaultMessage: 'Subtle yellow'
    },
    subtleLime: {
        id: 'company-hub.color-picker.subtle-lime',
        description: 'Name of subtle lime color',
        defaultMessage: 'Subtle lime'
    },
    subtleGreen: {
        id: 'company-hub.color-picker.subtle-green',
        description: 'Name of subtle green color',
        defaultMessage: 'Subtle green'
    },
    subtleTeal: {
        id: 'company-hub.color-picker.subtle-teal',
        description: 'Name of subtle teal color',
        defaultMessage: 'Subtle teal'
    },
    gray: {
        id: 'company-hub.color-picker.gray',
        description: 'Name of gray color',
        defaultMessage: 'Gray'
    },
    blue: {
        id: 'company-hub.color-picker.blue',
        description: 'Name of blue color',
        defaultMessage: 'Blue'
    },
    purple: {
        id: 'company-hub.color-picker.purple',
        description: 'Name of purple color',
        defaultMessage: 'Purple'
    },
    magenta: {
        id: 'company-hub.color-picker.magenta',
        description: 'Name of magenta color',
        defaultMessage: 'Magenta'
    },
    red: {
        id: 'company-hub.color-picker.red',
        description: 'Name of red color',
        defaultMessage: 'Red'
    },
    orange: {
        id: 'company-hub.color-picker.orange',
        description: 'Name of orange color',
        defaultMessage: 'Orange'
    },
    yellow: {
        id: 'company-hub.color-picker.yellow',
        description: 'Name of yellow color',
        defaultMessage: 'Yellow'
    },
    lime: {
        id: 'company-hub.color-picker.lime',
        description: 'Name of lime color',
        defaultMessage: 'Lime'
    },
    green: {
        id: 'company-hub.color-picker.green',
        description: 'Name of green color',
        defaultMessage: 'Green'
    },
    teal: {
        id: 'company-hub.color-picker.teal',
        description: 'Name of teal color',
        defaultMessage: 'Teal'
    },
    boldGray: {
        id: 'company-hub.color-picker.bold-gray',
        description: 'Name of bold gray color',
        defaultMessage: 'Bold gray'
    },
    boldBlue: {
        id: 'company-hub.color-picker.bold-blue',
        description: 'Name of bold blue color',
        defaultMessage: 'Bold blue'
    },
    boldPurple: {
        id: 'company-hub.color-picker.bold-purple',
        description: 'Name of bold purple color',
        defaultMessage: 'Bold purple'
    },
    boldMagenta: {
        id: 'company-hub.color-picker.bold-magenta',
        description: 'Name of bold magenta color',
        defaultMessage: 'Bold magenta'
    },
    boldRed: {
        id: 'company-hub.color-picker.bold-red',
        description: 'Name of bold red color',
        defaultMessage: 'Bold red'
    },
    boldOrange: {
        id: 'company-hub.color-picker.bold-orange',
        description: 'Name of bold orange color',
        defaultMessage: 'Bold orange'
    },
    boldYellow: {
        id: 'company-hub.color-picker.bold-yellow',
        description: 'Name of bold yellow color',
        defaultMessage: 'Bold yellow'
    },
    boldLime: {
        id: 'company-hub.color-picker.bold-lime',
        description: 'Name of bold lime color',
        defaultMessage: 'Bold lime'
    },
    boldGreen: {
        id: 'company-hub.color-picker.bold-green',
        description: 'Name of bold green color',
        defaultMessage: 'Bold green'
    },
    boldTeal: {
        id: 'company-hub.color-picker.bold-teal',
        description: 'Name of bold teal color',
        defaultMessage: 'Bold teal'
    },
    defaultBlue: {
        id: 'company-hub.color-picker.default-blue',
        description: 'Name of default blue color',
        defaultMessage: 'Default blue'
    }
});

});



parcelRegister("2n0rH", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $7931f8e050219994$export$3d31854eb05903e0);

var $1ciM6 = parcelRequire("1ciM6");
parcelRequire("aU7k1");
var $k554N = parcelRequire("k554N");

var $9sQ7a = parcelRequire("9sQ7a");
const $7931f8e050219994$export$3d31854eb05903e0 = (color, packageName)=>{
    try {
        // Convert to HEX as polished's getLuminance only accepts HEX colors
        const hexColor = (0, $9sQ7a.toHexColor)(color);
        return (0, $1ciM6.getLuminance)(hexColor) > 0.5 ? "var(--ds-text, #292A2E)" : "var(--ds-text-inverse, #FFFFFF)";
    } catch (error) {
        (0, $k554N.default)({
            error: error instanceof Error ? error : new Error(`Color luminance calculation failed for color: ${color}`),
            meta: {
                id: 'readableTextColor',
                packageName: packageName
            }
        });
        // Fallback to text color
        return "var(--ds-text, #292A2E)";
    }
};

});
parcelRegister("1ciM6", function(module, exports) {
$parcel$export(module.exports, "getLuminance", () => $0df579c090667fd3$export$c852d90bf7403b62);
//      
// @private
function $0df579c090667fd3$var$capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
//      
var $0df579c090667fd3$var$positionMap = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function $0df579c090667fd3$var$generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return '' + acc + $0df579c090667fd3$var$capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
    return property === joinedProperty ? '' + property + position : joinedProperty;
}
function $0df579c090667fd3$var$generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[$0df579c090667fd3$var$generateProperty(property, $0df579c090667fd3$var$positionMap[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * A helper that enables shorthand for direction based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $0df579c090667fd3$export$4fc00c04dd60af95(property) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === undefined ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === undefined ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === undefined ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return $0df579c090667fd3$var$generateStyles(property, valuesWithDefaults);
}
//      
function $0df579c090667fd3$var$endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
//      
/**
 * Strip the unit from a given CSS value, returning just the number. (or the original value if an invalid string was passed)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function $0df579c090667fd3$export$ef04e38dc423904(value) {
    var unitlessValue = parseFloat(value);
    if (isNaN(unitlessValue)) return value;
    return unitlessValue;
}
//      
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var $0df579c090667fd3$var$pxtoFactory = function pxtoFactory(to) {
    return function(pxval) {
        var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!$0df579c090667fd3$var$endsWith(pxval, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
            newPxval = $0df579c090667fd3$export$ef04e38dc423904(pxval);
        }
        if (typeof base === 'string') {
            if (!$0df579c090667fd3$var$endsWith(base, 'px')) throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
            newBase = $0df579c090667fd3$export$ef04e38dc423904(base);
        }
        if (typeof newPxval === 'string') throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
        if (typeof newBase === 'string') throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
        return '' + newPxval / newBase + to;
    };
};
//      
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var $0df579c090667fd3$export$c63c6f932822f543 = /*#__PURE__*/ $0df579c090667fd3$var$pxtoFactory('em');
//      
var $0df579c090667fd3$var$ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function $0df579c090667fd3$export$c82a8a23c9e8bdb6(steps) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';
    if (typeof steps !== 'number') throw new Error('Please provide a number of steps to the modularScale helper.');
    if (typeof ratio === 'string' && !$0df579c090667fd3$var$ratioNames[ratio]) throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
    var realBase = typeof base === 'string' ? $0df579c090667fd3$export$ef04e38dc423904(base) : base;
    var realRatio = typeof ratio === 'string' ? $0df579c090667fd3$var$ratioNames[ratio] : ratio;
    if (typeof realBase === 'string') throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
    return realBase * Math.pow(realRatio, steps) + 'em';
}
//      
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var $0df579c090667fd3$export$fb1897a40d146f7f = /*#__PURE__*/ $0df579c090667fd3$var$pxtoFactory('rem');
//      
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function $0df579c090667fd3$export$8c467e8859fdef13() {
    var _ref;
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';
    var pseudoSelector = parent + '::after';
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
//      
/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function $0df579c090667fd3$export$a5b94313d6908893() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';
    return {
        display: 'inline-block',
        maxWidth: width,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
}
//      
/** */ function $0df579c090667fd3$var$generateFileReferences(fontFilePath, fileFormats) {
    var fileFontReferences = fileFormats.map(function(format) {
        return 'url("' + fontFilePath + '.' + format + '")';
    });
    return fileFontReferences.join(', ');
}
function $0df579c090667fd3$var$generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return 'local("' + font + '")';
    });
    return localFontReferences.join(', ');
}
function $0df579c090667fd3$var$generateSources(fontFilePath, localFonts, fileFormats) {
    var fontReferences = [];
    if (localFonts) fontReferences.push($0df579c090667fd3$var$generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push($0df579c090667fd3$var$generateFileReferences(fontFilePath, fileFormats));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function $0df579c090667fd3$export$566c6c2ff0443c7(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === undefined ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, localFonts = _ref.localFonts, unicodeRange = _ref.unicodeRange;
    // Error Handling
    if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
    if (!fontFilePath && !localFonts) throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
    if (localFonts && !Array.isArray(localFonts)) throw new Error('fontFace expects localFonts to be an array.');
    if (!Array.isArray(fileFormats)) throw new Error('fontFace expects fileFormats to be an array.');
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: $0df579c090667fd3$var$generateSources(fontFilePath, localFonts, fileFormats),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight
        }
    };
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
//      
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function $0df579c090667fd3$export$27bef6389954e24d() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
//      
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function $0df579c090667fd3$export$36e2157ae4e3cbdd() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
//      
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function $0df579c090667fd3$export$e79006618d7c6cc3() {
    var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
var $0df579c090667fd3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $0df579c090667fd3$var$taggedTemplateLiteralLoose = function(strings, raw) {
    strings.raw = raw;
    return strings;
};
var $0df579c090667fd3$var$_opinionatedRules;
var $0df579c090667fd3$var$_abbrTitle;
var $0df579c090667fd3$var$_unopinionatedRules;
//      
var $0df579c090667fd3$var$opinionatedRules = ($0df579c090667fd3$var$_opinionatedRules = {
    html: {
        fontFamily: 'sans-serif'
    },
    body: {
        margin: '0'
    }
}, $0df579c090667fd3$var$_opinionatedRules['a:active,\n  a:hover'] = {
    outlineWidth: '0'
}, $0df579c090667fd3$var$_opinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    fontFamily: 'sans-serif',
    fontSize: '100%',
    lineHeight: '1.15'
}, $0df579c090667fd3$var$_opinionatedRules);
var $0df579c090667fd3$var$unopinionatedRules = ($0df579c090667fd3$var$_unopinionatedRules = {
    html: {
        lineHeight: '1.15',
        textSizeAdjust: '100%'
    }
}, $0df579c090667fd3$var$_unopinionatedRules['article,\n  aside,\n  footer,\n  header,\n  nav,\n  section'] = {
    display: 'block'
}, $0df579c090667fd3$var$_unopinionatedRules.h1 = {
    fontSize: '2em',
    margin: '0.67em 0'
}, $0df579c090667fd3$var$_unopinionatedRules['figcaption,\n  figure,\n  main'] = {
    display: 'block'
}, $0df579c090667fd3$var$_unopinionatedRules.figure = {
    margin: '1em 40px'
}, $0df579c090667fd3$var$_unopinionatedRules.hr = {
    boxSizing: 'content-box',
    height: '0',
    overflow: 'visible'
}, $0df579c090667fd3$var$_unopinionatedRules.pre = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $0df579c090667fd3$var$_unopinionatedRules.a = {
    'background-color': 'transparent',
    '-webkit-text-decoration-skip': 'objects'
}, $0df579c090667fd3$var$_unopinionatedRules['abbr[title]'] = ($0df579c090667fd3$var$_abbrTitle = {
    borderBottom: 'none',
    textDecoration: 'underline'
}, $0df579c090667fd3$var$_abbrTitle['textDecoration'] = 'underline dotted', $0df579c090667fd3$var$_abbrTitle), $0df579c090667fd3$var$_unopinionatedRules['b,\n  strong'] = {
    fontWeight: 'inherit'
}, $0df579c090667fd3$var$_unopinionatedRules['code,\n  kbd,\n  samp'] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
}, $0df579c090667fd3$var$_unopinionatedRules.dfn = {
    fontStyle: 'italic'
}, $0df579c090667fd3$var$_unopinionatedRules.mark = {
    backgroundColor: '#ff0',
    color: '#000'
}, $0df579c090667fd3$var$_unopinionatedRules.small = {
    fontSize: '80%'
}, $0df579c090667fd3$var$_unopinionatedRules['sub,\n  sup'] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
}, $0df579c090667fd3$var$_unopinionatedRules.sub = {
    bottom: '-0.25em'
}, $0df579c090667fd3$var$_unopinionatedRules.sup = {
    top: '-0.5em'
}, $0df579c090667fd3$var$_unopinionatedRules['audio,\n  video'] = {
    display: 'inline-block'
}, $0df579c090667fd3$var$_unopinionatedRules['audio:not([controls])'] = {
    display: 'none',
    height: '0'
}, $0df579c090667fd3$var$_unopinionatedRules.img = {
    borderStyle: 'none'
}, $0df579c090667fd3$var$_unopinionatedRules['svg:not(:root)'] = {
    overflow: 'hidden'
}, $0df579c090667fd3$var$_unopinionatedRules['button,\n  input,\n  optgroup,\n  select,\n  textarea'] = {
    margin: '0'
}, $0df579c090667fd3$var$_unopinionatedRules['button,\n  input'] = {
    overflow: 'visible'
}, $0df579c090667fd3$var$_unopinionatedRules['button,\n  select'] = {
    textTransform: 'none'
}, $0df579c090667fd3$var$_unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
    '-webkit-appearance': 'button'
}, $0df579c090667fd3$var$_unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
    borderStyle: 'none',
    padding: '0'
}, $0df579c090667fd3$var$_unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
    outline: '1px dotted ButtonText'
}, $0df579c090667fd3$var$_unopinionatedRules.fieldset = {
    border: '1px solid #c0c0c0',
    margin: '0 2px',
    padding: '0.35em 0.625em 0.75em'
}, $0df579c090667fd3$var$_unopinionatedRules.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
}, $0df579c090667fd3$var$_unopinionatedRules.progress = {
    display: 'inline-block',
    verticalAlign: 'baseline'
}, $0df579c090667fd3$var$_unopinionatedRules.textarea = {
    overflow: 'auto'
}, $0df579c090667fd3$var$_unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
    boxSizing: 'border-box',
    padding: '0'
}, $0df579c090667fd3$var$_unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
    height: 'auto'
}, $0df579c090667fd3$var$_unopinionatedRules['[type="search"]'] = {
    '-webkit-appearance': 'textfield',
    outlineOffset: '-2px'
}, $0df579c090667fd3$var$_unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
    '-webkit-appearance': 'none'
}, $0df579c090667fd3$var$_unopinionatedRules['::-webkit-file-upload-button'] = {
    '-webkit-appearance': 'button',
    font: 'inherit'
}, $0df579c090667fd3$var$_unopinionatedRules['details,\n  menu'] = {
    display: 'block'
}, $0df579c090667fd3$var$_unopinionatedRules.summary = {
    display: 'list-item'
}, $0df579c090667fd3$var$_unopinionatedRules.canvas = {
    display: 'inline-block'
}, $0df579c090667fd3$var$_unopinionatedRules.template = {
    display: 'none'
}, $0df579c090667fd3$var$_unopinionatedRules['[hidden]'] = {
    display: 'none'
}, $0df579c090667fd3$var$_unopinionatedRules);
function $0df579c090667fd3$var$mergeRules(baseRules, additionalRules) {
    var mergedRules = $0df579c090667fd3$var$_extends({}, baseRules);
    Object.keys(additionalRules).forEach(function(key) {
        if (mergedRules[key]) mergedRules[key] = $0df579c090667fd3$var$_extends({}, mergedRules[key], additionalRules[key]);
        else mergedRules[key] = $0df579c090667fd3$var$_extends({}, additionalRules[key]);
    });
    return mergedRules;
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   fontFamily: 'sans-serif',
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function $0df579c090667fd3$export$a3295358bff77e(excludeOpinionated) {
    if (excludeOpinionated) return $0df579c090667fd3$var$unopinionatedRules;
    return $0df579c090667fd3$var$mergeRules($0df579c090667fd3$var$unopinionatedRules, $0df579c090667fd3$var$opinionatedRules);
}
//      
/**
 * CSS to style the placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */ function $0df579c090667fd3$export$c7187bbd1a7a9244(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';
    return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = $0df579c090667fd3$var$_extends({}, styles), _ref[parent + ':-moz-placeholder'] = $0df579c090667fd3$var$_extends({}, styles), _ref[parent + '::-moz-placeholder'] = $0df579c090667fd3$var$_extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = $0df579c090667fd3$var$_extends({}, styles), _ref;
}
var $0df579c090667fd3$var$_templateObject = /*#__PURE__*/ $0df579c090667fd3$var$taggedTemplateLiteralLoose([
    'radial-gradient(',
    '',
    '',
    '',
    ')'
], [
    'radial-gradient(',
    '',
    '',
    '',
    ')'
]);
//      
/** */ function $0df579c090667fd3$var$parseFallback(colorStops) {
    return colorStops[0].split(' ')[0];
}
function $0df579c090667fd3$var$constructGradientValue(literals) {
    var template = '';
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        // Adds leading coma if properties preceed color-stops
        if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
            template = template.slice(0, -1);
            template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        // No trailing space if color-stops is the only param provided
        } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
        else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
    return template.trim();
}
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function $0df579c090667fd3$export$3922d1ccb8631cd8(_ref) {
    var colorStops = _ref.colorStops, extent = _ref.extent, fallback = _ref.fallback, position = _ref.position, shape = _ref.shape;
    if (!colorStops || colorStops.length < 2) throw new Error('radialGradient requries at least 2 color-stops to properly render.');
    return {
        backgroundColor: fallback || $0df579c090667fd3$var$parseFallback(colorStops),
        backgroundImage: $0df579c090667fd3$var$constructGradientValue($0df579c090667fd3$var$_templateObject, position, shape, extent, colorStops.join(', '))
    };
}
//      
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function $0df579c090667fd3$export$19389033401d366a(filename, backgroundSize) {
    var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';
    var _ref;
    var retinaFilename = arguments[3];
    var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';
    if (!filename) throw new Error('Please supply a filename to retinaImage() as the first argument.');
    // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;
    return _ref = {
        backgroundImage: 'url(' + filename + '.' + ext + ')'
    }, _ref[$0df579c090667fd3$export$e79006618d7c6cc3()] = {
        backgroundImage: 'url(' + rFilename + ')',
        backgroundSize: backgroundSize
    }, _ref;
}
//      
/**
 * CSS to style the selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */ function $0df579c090667fd3$export$7c69810f7b8835c9(styles) {
    var _ref;
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return _ref = {}, _ref[parent + '::-moz-selection'] = $0df579c090667fd3$var$_extends({}, styles), _ref[parent + '::selection'] = $0df579c090667fd3$var$_extends({}, styles), _ref;
}
//      
/* eslint-disable key-spacing */ var $0df579c090667fd3$var$functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
function $0df579c090667fd3$export$61210fa83792a81(timingFunction) {
    return $0df579c090667fd3$var$functionsMap[timingFunction];
}
//      
/** */ var $0df579c090667fd3$var$getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    switch(pointingDirection){
        case 'top':
            return '0 ' + width / 2 + 'px ' + height + 'px ' + width / 2 + 'px';
        case 'left':
            return height / 2 + 'px ' + width + 'px ' + height / 2 + 'px 0';
        case 'bottom':
            return height + 'px ' + width / 2 + 'px 0 ' + width / 2 + 'px';
        case 'right':
            return height / 2 + 'px 0 ' + height / 2 + 'px ' + width + 'px';
        default:
            throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
    }
};
// needed for border-color
var $0df579c090667fd3$var$reverseDirection = {
    left: 'Right',
    right: 'Left',
    top: 'Bottom',
    bottom: 'Top'
};
function $0df579c090667fd3$export$9eed783d03e0135c(_ref) {
    var _ref2;
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;
    var unitlessHeight = parseFloat(height);
    var unitlessWidth = parseFloat(width);
    if (isNaN(unitlessHeight) || isNaN(unitlessWidth)) throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
    return _ref2 = {
        borderColor: backgroundColor,
        width: '0',
        height: '0',
        borderWidth: $0df579c090667fd3$var$getBorderWidth(pointingDirection, unitlessHeight, unitlessWidth),
        borderStyle: 'solid'
    }, _ref2['border' + $0df579c090667fd3$var$reverseDirection[pointingDirection] + 'Color'] = foregroundColor + ' !important', _ref2;
}
//      
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function $0df579c090667fd3$export$dca3d8ad656c34d2() {
    var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
//      
function $0df579c090667fd3$var$colorToInt(color) {
    return Math.round(color * 255);
}
function $0df579c090667fd3$var$convertToInt(red, green, blue) {
    return $0df579c090667fd3$var$colorToInt(red) + "," + $0df579c090667fd3$var$colorToInt(green) + "," + $0df579c090667fd3$var$colorToInt(blue);
}
function $0df579c090667fd3$var$hslToRgb(hue, saturation, lightness) {
    var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $0df579c090667fd3$var$convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
    // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = hue % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
//      
var $0df579c090667fd3$var$namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
function $0df579c090667fd3$var$nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return $0df579c090667fd3$var$namedColorMap[normalizedColorName] ? '#' + $0df579c090667fd3$var$namedColorMap[normalizedColorName] : color;
}
//      
var $0df579c090667fd3$var$hexRegex = /^#[a-fA-F0-9]{6}$/;
var $0df579c090667fd3$var$reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var $0df579c090667fd3$var$rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var $0df579c090667fd3$var$rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var $0df579c090667fd3$var$hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var $0df579c090667fd3$var$hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $0df579c090667fd3$export$2f48baff6995707a(color) {
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    var normalizedColor = $0df579c090667fd3$var$nameToHex(color);
    if (normalizedColor.match($0df579c090667fd3$var$hexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match($0df579c090667fd3$var$reducedHexRegex)) return {
        red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
    var rgbMatched = $0df579c090667fd3$var$rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt('' + rgbMatched[1], 10),
        green: parseInt('' + rgbMatched[2], 10),
        blue: parseInt('' + rgbMatched[3], 10)
    };
    var rgbaMatched = $0df579c090667fd3$var$rgbaRegex.exec(normalizedColor);
    if (rgbaMatched) return {
        red: parseInt('' + rgbaMatched[1], 10),
        green: parseInt('' + rgbaMatched[2], 10),
        blue: parseInt('' + rgbaMatched[3], 10),
        alpha: parseFloat('' + rgbaMatched[4])
    };
    var hslMatched = $0df579c090667fd3$var$hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt('' + hslMatched[1], 10);
        var saturation = parseInt('' + hslMatched[2], 10) / 100;
        var lightness = parseInt('' + hslMatched[3], 10) / 100;
        var rgbColorString = 'rgb(' + $0df579c090667fd3$var$hslToRgb(hue, saturation, lightness) + ')';
        var hslRgbMatched = $0df579c090667fd3$var$rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
        return {
            red: parseInt('' + hslRgbMatched[1], 10),
            green: parseInt('' + hslRgbMatched[2], 10),
            blue: parseInt('' + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = $0df579c090667fd3$var$hslaRegex.exec(normalizedColor);
    if (hslaMatched) {
        var _hue = parseInt('' + hslaMatched[1], 10);
        var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
        var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
        var _rgbColorString = 'rgb(' + $0df579c090667fd3$var$hslToRgb(_hue, _saturation, _lightness) + ')';
        var _hslRgbMatched = $0df579c090667fd3$var$rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
        return {
            red: parseInt('' + _hslRgbMatched[1], 10),
            green: parseInt('' + _hslRgbMatched[2], 10),
            blue: parseInt('' + _hslRgbMatched[3], 10),
            alpha: parseFloat('' + hslaMatched[4])
        };
    }
    throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
//      
function $0df579c090667fd3$var$rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue = void 0;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
//      
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */ function $0df579c090667fd3$export$1286688e1b3fde9c(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return $0df579c090667fd3$var$rgbToHsl($0df579c090667fd3$export$2f48baff6995707a(color));
}
//      
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var $0df579c090667fd3$var$reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
//      
function $0df579c090667fd3$var$numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function $0df579c090667fd3$export$8972dc0e6ad9238f(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return $0df579c090667fd3$var$reduceHexValue('#' + $0df579c090667fd3$var$numberToHex(value) + $0df579c090667fd3$var$numberToHex(green) + $0df579c090667fd3$var$numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return $0df579c090667fd3$var$reduceHexValue('#' + $0df579c090667fd3$var$numberToHex(value.red) + $0df579c090667fd3$var$numberToHex(value.green) + $0df579c090667fd3$var$numberToHex(value.blue));
    throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function $0df579c090667fd3$export$4e46ac54fc82cf3b(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = $0df579c090667fd3$export$2f48baff6995707a(firstValue);
        return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? $0df579c090667fd3$export$8972dc0e6ad9238f(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? $0df579c090667fd3$export$8972dc0e6ad9238f(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
    throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}
//      
function $0df579c090667fd3$var$colorToHex(color) {
    return $0df579c090667fd3$var$numberToHex(Math.round(color * 255));
}
function $0df579c090667fd3$var$convertToHex(red, green, blue) {
    return $0df579c090667fd3$var$reduceHexValue('#' + $0df579c090667fd3$var$colorToHex(red) + $0df579c090667fd3$var$colorToHex(green) + $0df579c090667fd3$var$colorToHex(blue));
}
function $0df579c090667fd3$var$hslToHex(hue, saturation, lightness) {
    return $0df579c090667fd3$var$hslToRgb(hue, saturation, lightness, $0df579c090667fd3$var$convertToHex);
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function $0df579c090667fd3$export$8f4a7c0bb78e6ea8(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return $0df579c090667fd3$var$hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return $0df579c090667fd3$var$hslToHex(value.hue, value.saturation, value.lightness);
    throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}
//      
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function $0df579c090667fd3$export$810b04175080204c(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? $0df579c090667fd3$var$hslToHex(value, saturation, lightness) : 'rgba(' + $0df579c090667fd3$var$hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? $0df579c090667fd3$var$hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + $0df579c090667fd3$var$hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
    throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}
//      
var $0df579c090667fd3$var$isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $0df579c090667fd3$var$isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var $0df579c090667fd3$var$isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var $0df579c090667fd3$var$isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
var $0df579c090667fd3$var$errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function $0df579c090667fd3$export$42fe740cdf79b2df(color) {
    if (typeof color !== 'object') throw new Error($0df579c090667fd3$var$errMsg);
    if ($0df579c090667fd3$var$isRgba(color)) return $0df579c090667fd3$export$4e46ac54fc82cf3b(color);
    if ($0df579c090667fd3$var$isRgb(color)) return $0df579c090667fd3$export$8972dc0e6ad9238f(color);
    if ($0df579c090667fd3$var$isHsla(color)) return $0df579c090667fd3$export$810b04175080204c(color);
    if ($0df579c090667fd3$var$isHsl(color)) return $0df579c090667fd3$export$8f4a7c0bb78e6ea8(color);
    throw new Error($0df579c090667fd3$var$errMsg);
}
//      
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function $0df579c090667fd3$var$curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : $0df579c090667fd3$var$curried(f, length, combined);
    };
}
// eslint-disable-next-line no-redeclare
function $0df579c090667fd3$var$curry(f) {
    // eslint-disable-line no-redeclare
    return $0df579c090667fd3$var$curried(f, f.length, []);
}
//      
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue(180, 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue(180, 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function $0df579c090667fd3$var$adjustHue(degree, color) {
    var hslColor = $0df579c090667fd3$export$1286688e1b3fde9c(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, hslColor, {
        hue: (hslColor.hue + degree) % 360
    }));
}
var $0df579c090667fd3$export$2b372a09365374d6 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$adjustHue);
//      
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $0df579c090667fd3$export$bd4f6f7e1823bc9e(color) {
    var hslColor = $0df579c090667fd3$export$1286688e1b3fde9c(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
//      
function $0df579c090667fd3$var$guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
//      
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken(0.2, 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken(0.2, 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function $0df579c090667fd3$var$darken(amount, color) {
    var hslColor = $0df579c090667fd3$export$1286688e1b3fde9c(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, hslColor, {
        lightness: $0df579c090667fd3$var$guard(0, 1, hslColor.lightness - amount)
    }));
}
var $0df579c090667fd3$export$4b073707ff63303 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$darken);
//      
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function $0df579c090667fd3$var$desaturate(amount, color) {
    var hslColor = $0df579c090667fd3$export$1286688e1b3fde9c(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, hslColor, {
        saturation: $0df579c090667fd3$var$guard(0, 1, hslColor.saturation - amount)
    }));
}
var $0df579c090667fd3$export$fb75607d98509d9 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$desaturate);
//      
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function $0df579c090667fd3$export$c852d90bf7403b62(color) {
    var rgbColor = $0df579c090667fd3$export$2f48baff6995707a(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
//      
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function $0df579c090667fd3$export$6f416a6db2dfcd5c(color) {
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, $0df579c090667fd3$export$1286688e1b3fde9c(color), {
        saturation: 0
    }));
}
//      
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function $0df579c090667fd3$export$6897c284b6f9f4dc(color) {
    // parse color string to rgb
    var value = $0df579c090667fd3$export$2f48baff6995707a(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
//      
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function $0df579c090667fd3$var$lighten(amount, color) {
    var hslColor = $0df579c090667fd3$export$1286688e1b3fde9c(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, hslColor, {
        lightness: $0df579c090667fd3$var$guard(0, 1, hslColor.lightness + amount)
    }));
}
var $0df579c090667fd3$export$c0816ed86df316af = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$lighten);
//      
/**
 * Mixes two colors together by calculating the average of each of the RGB components.
 *
 * By default the weight is 0.5 meaning that half of the first color and half the second
 * color should be used. Optionally the weight can be modified by providing a number
 * as the first argument. 0.25 means that a quarter of the first color and three quarters
 * of the second color should be used.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix(0.5, 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function $0df579c090667fd3$var$mix() {
    var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
    var color = arguments[1];
    var otherColor = arguments[2];
    var parsedColor1 = $0df579c090667fd3$export$2f48baff6995707a(color);
    var color1 = $0df579c090667fd3$var$_extends({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = $0df579c090667fd3$export$2f48baff6995707a(otherColor);
    var color2 = $0df579c090667fd3$var$_extends({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    });
    var alphaDelta = color1.alpha - color2.alpha;
    var x = weight * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha + (color2.alpha - color1.alpha) * (weight / 1.0)
    };
    return $0df579c090667fd3$export$4e46ac54fc82cf3b(mixedColor);
}
var $0df579c090667fd3$export$2c9e8a9632a706b2 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$mix);
//      
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify(0.5, 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify(0.5, 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function $0df579c090667fd3$var$opacify(amount, color) {
    var parsedColor = $0df579c090667fd3$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $0df579c090667fd3$var$_extends({}, parsedColor, {
        alpha: $0df579c090667fd3$var$guard(0, 1, (alpha * 100 + amount * 100) / 100)
    });
    return $0df579c090667fd3$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $0df579c090667fd3$export$f4f50e3877dd0530 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$opacify);
//      
/**
 * Selects black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */ function $0df579c090667fd3$var$readableColor(color) {
    return $0df579c090667fd3$export$c852d90bf7403b62(color) > 0.179 ? '#000' : '#fff';
}
var $0df579c090667fd3$export$61654c1796c44811 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$readableColor);
//      
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate(0.2, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate(0.2, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function $0df579c090667fd3$var$saturate(amount, color) {
    var hslColor = $0df579c090667fd3$export$1286688e1b3fde9c(color);
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, hslColor, {
        saturation: $0df579c090667fd3$var$guard(0, 1, hslColor.saturation + amount)
    }));
}
var $0df579c090667fd3$export$5fcac96f5a87e3db = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$saturate);
//      
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue(244, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue(244, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function $0df579c090667fd3$var$setHue(hue, color) {
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, $0df579c090667fd3$export$1286688e1b3fde9c(color), {
        hue: hue
    }));
}
var $0df579c090667fd3$export$3bf58ce3e497a846 = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$setHue);
//      
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function $0df579c090667fd3$var$setLightness(lightness, color) {
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, $0df579c090667fd3$export$1286688e1b3fde9c(color), {
        lightness: lightness
    }));
}
var $0df579c090667fd3$export$7ef5d725337b805d = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$setLightness);
//      
/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation(0.75, 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation(0.75, 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function $0df579c090667fd3$var$setSaturation(saturation, color) {
    return $0df579c090667fd3$export$42fe740cdf79b2df($0df579c090667fd3$var$_extends({}, $0df579c090667fd3$export$1286688e1b3fde9c(color), {
        saturation: saturation
    }));
}
var $0df579c090667fd3$export$b40fe421ea7a4f7e = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$setSaturation);
//      
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function $0df579c090667fd3$var$shade(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to shade, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $0df579c090667fd3$export$2c9e8a9632a706b2(percentage, color, 'rgb(0, 0, 0)');
}
var $0df579c090667fd3$export$3e32adda0df4ef5d = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$shade);
//      
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function $0df579c090667fd3$var$tint(percentage, color) {
    if (typeof percentage !== 'number' || percentage > 1 || percentage < -1) throw new Error('Passed an incorrect argument to tint, please pass a percentage less than or equal to 1 and larger than or equal to -1.');
    if (typeof color !== 'string') throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
    return $0df579c090667fd3$export$2c9e8a9632a706b2(percentage, color, 'rgb(255, 255, 255)');
}
var $0df579c090667fd3$export$fc176dd65a27d98b = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$tint);
//      
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize(0.5, 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize(0.5, 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function $0df579c090667fd3$var$transparentize(amount, color) {
    var parsedColor = $0df579c090667fd3$export$2f48baff6995707a(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = $0df579c090667fd3$var$_extends({}, parsedColor, {
        alpha: $0df579c090667fd3$var$guard(0, 1, (alpha * 100 - amount * 100) / 100)
    });
    return $0df579c090667fd3$export$4e46ac54fc82cf3b(colorWithAlpha);
}
var $0df579c090667fd3$export$d11da87e55cc498f = /*#__PURE__*/ $0df579c090667fd3$var$curry($0df579c090667fd3$var$transparentize);
//      
/** */ /**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function $0df579c090667fd3$export$ecad260a8a5fef4f() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
        if (Array.isArray(arg) && arg.length > 8) throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
//      
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function $0df579c090667fd3$export$c7de706fee81cfb4() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function $0df579c090667fd3$export$d041fef2b78b7906() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function $0df579c090667fd3$export$e7fb0694ba2404fc() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
        'borderColor'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function $0df579c090667fd3$export$7a57f79000377ca2(side, radius) {
    var uppercaseSide = $0df579c090667fd3$var$capitalizeString(side);
    if (!radius && radius !== 0) throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
    }
    throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function $0df579c090667fd3$export$4d0a7f76ad443516() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
        'borderStyle'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function $0df579c090667fd3$export$12879c7697ed953d() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
        'borderWidth'
    ].concat(values));
}
//      
function $0df579c090667fd3$var$generateSelectors(template, state) {
    var stateSuffix = state ? ':' + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function $0df579c090667fd3$var$statefulSelectors(states, template, stateMap) {
    if (!template) throw new Error('You must provide a template to this method.');
    if (states.length === 0) return $0df579c090667fd3$var$generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new Error('You passed an unsupported selector state to this method.');
        selectors.push($0df579c090667fd3$var$generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
//      
var $0df579c090667fd3$var$stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $0df579c090667fd3$var$template(state) {
    return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function $0df579c090667fd3$export$bbea856fdb3e3c5f() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $0df579c090667fd3$var$statefulSelectors(states, $0df579c090667fd3$var$template, $0df579c090667fd3$var$stateMap);
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function $0df579c090667fd3$export$7ede87f9b603dd3c() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
        'margin'
    ].concat(values));
}
//      
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function $0df579c090667fd3$export$6f98e8eaf0be1996() {
    for(var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
        'padding'
    ].concat(values));
}
//      
var $0df579c090667fd3$var$positionMap$1 = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function $0df579c090667fd3$export$5880b8b5730aff45(positionKeyword) {
    for(var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if ($0df579c090667fd3$var$positionMap$1.indexOf(positionKeyword) >= 0) return $0df579c090667fd3$var$_extends({
        position: positionKeyword
    }, $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
        ''
    ].concat(values)));
    else {
        var firstValue = positionKeyword; // in this case position is actually the first value
        return $0df579c090667fd3$export$4fc00c04dd60af95.apply(undefined, [
            '',
            firstValue
        ].concat(values));
    }
}
//      
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function $0df579c090667fd3$export$346677f925de839c(height) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;
    return {
        height: height,
        width: width
    };
}
//      
var $0df579c090667fd3$var$stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function $0df579c090667fd3$var$template$1(state) {
    return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function $0df579c090667fd3$export$baad927ee93ccf9c() {
    for(var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return $0df579c090667fd3$var$statefulSelectors(states, $0df579c090667fd3$var$template$1, $0df579c090667fd3$var$stateMap$1);
}
//      
/**
 * Shorthand that accepts any number of transition values as parameters for creating a single transition statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 * }
 */ function $0df579c090667fd3$export$622eca585e740ed5() {
    for(var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        transition: properties.join(', ')
    };
}

});


parcelRegister("iySE3", function(module, exports) {
$parcel$export(module.exports, "getMediaProvider", () => $f53361248259d678$export$98e696b66f6bbf2b);
$parcel$export(module.exports, "HubContext", () => $f53361248259d678$export$6a5aa704056d141b);
$parcel$export(module.exports, "useHubContext", () => $f53361248259d678$export$ac8576a9912be18c);

var $4fqPo = parcelRequire("4fqPo");

var $4oTiM = parcelRequire("4oTiM");
var $8llkI = parcelRequire("8llkI");
const $f53361248259d678$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $f53361248259d678$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl, isUploadMediaConfigRequired)=>{
    const authProvider = $f53361248259d678$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl);
    return {
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: authProvider,
            useSha256ForUploads: true
        },
        ...isUploadMediaConfigRequired && {
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        }
    };
};
const $f53361248259d678$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $f53361248259d678$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $f53361248259d678$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $8llkI.HelpPageAri).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $f53361248259d678$export$6a5aa704056d141b = (0, $4fqPo.createContext)(null);
const $f53361248259d678$export$ac8576a9912be18c = ()=>{
    const context = (0, $4fqPo.useContext)($f53361248259d678$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};

});

parcelRegister("4B9vJ", function(module, exports) {
$parcel$export(module.exports, "HUB_COLOR_CSS_VARS", () => $1f53bcaf54086fb6$export$6e4a1de0ca7c3086);
/**
 * Centralised registry of `--hub-*` CSS custom-property names emitted by
 * `<HubThemingProvider>`'s wrapper `<div>`. These are the **only** v2 CSS-var
 * names extension code references — never hand-write `--hub-*` strings at the
 * call site.
 *
 * Why centralised:
 *   • Single rename point — change a name here, every consumer follows.
 *   • Type-safe lookup via `PaletteRef` — typo "primary.150" fails the build.
 *   • `resolveAdfColor` derives its `var(--hub-color-...)` output from this
 *     registry, so the renderer never sees raw var-name strings.
 *
 * Naming convention:
 *   --hub-color-{family}-{shade}    → e.g. --hub-color-primary-200
 *   --hub-color-{semantic}          → e.g. --hub-color-text-on-primary
 *   --hub-radius-{slot}             → reserved for future radius work
 *   --hub-space-{slot}              → reserved for future density work
 *
 * The wrapper div emits the registry as inline `style` so the values are
 * present in the SSR HTML on first paint — no useEffect, no setProperty.
 */ const $1f53bcaf54086fb6$var$SHADES = [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '1000'
];
const $1f53bcaf54086fb6$var$FAMILIES = [
    'primary',
    'accent'
];
const $1f53bcaf54086fb6$var$buildColorVarMap = ()=>{
    const out = {};
    for (const family of $1f53bcaf54086fb6$var$FAMILIES)for (const shade of $1f53bcaf54086fb6$var$SHADES){
        const ref = `${family}.${shade}`;
        out[ref] = `--hub-color-${family}-${shade}`;
    }
    return out;
};
const $1f53bcaf54086fb6$export$6e4a1de0ca7c3086 = Object.freeze($1f53bcaf54086fb6$var$buildColorVarMap());
const $1f53bcaf54086fb6$export$83d6614a5062fafa = Object.freeze({
    color: $1f53bcaf54086fb6$export$6e4a1de0ca7c3086
});

});

parcelRegister("fHA58", function(module, exports) {
$parcel$export(module.exports, "useHubBrandPalette", () => $ef1ba1f09e724172$export$52531ed83ceae9ec);

var $4fqPo = parcelRequire("4fqPo");

var $9BE4A = parcelRequire("9BE4A");
const $ef1ba1f09e724172$export$52531ed83ceae9ec = (inputs)=>{
    const { primary: primary, accent: accent } = inputs;
    return (0, $4fqPo.useMemo)(()=>(0, $9BE4A.generateHubBrandPalette)({
            primary: primary,
            accent: accent
        }), [
        primary,
        accent
    ]);
};

});
parcelRegister("9BE4A", function(module, exports) {
$parcel$export(module.exports, "generateHubBrandPalette", () => $730eb4f7b7acb0c8$export$fb2e77ab23c1ab27);
/**
 * Build a 20-shade `HubBrandPalette` from a (primary, accent) brand colour
 * pair, per §4.1 of the Advanced Theming v2 design.
 *
 * Implementation note: this is a thin wrapper around the existing CSM colour
 * theme generator (which is also what `setHubBrandingStyle` already uses).
 * That generator runs the same Material-HCT-based 10-step ramp algorithm as
 * `@atlaskit/tokens`'s internal `generateColors`, but is exposed via a public
 * entry-point and is already a hubs dependency, so we don't have to duplicate
 * the colour science.
 *
 * Pure and synchronous — safe to call during render, including SSR.
 */ 
var $2R2ud = parcelRequire("2R2ud");
const $730eb4f7b7acb0c8$var$SHADES = [
    [
        '100',
        'color100'
    ],
    [
        '200',
        'color200'
    ],
    [
        '300',
        'color300'
    ],
    [
        '400',
        'color400'
    ],
    [
        '500',
        'color500'
    ],
    [
        '600',
        'color600'
    ],
    [
        '700',
        'color700'
    ],
    [
        '800',
        'color800'
    ],
    [
        '900',
        'color900'
    ],
    [
        '1000',
        'color1000'
    ]
];
const $730eb4f7b7acb0c8$var$buildFamily = (family, hex)=>{
    const ramp = (0, $2R2ud.generateThemeBranding)(hex);
    const out = {};
    for (const [shade, rampKey] of $730eb4f7b7acb0c8$var$SHADES){
        const key = `${family}.${shade}`;
        out[key] = ramp[rampKey];
    }
    return out;
};
const $730eb4f7b7acb0c8$export$fb2e77ab23c1ab27 = ({ primary: primary, accent: accent })=>{
    return {
        ...$730eb4f7b7acb0c8$var$buildFamily('primary', primary),
        ...$730eb4f7b7acb0c8$var$buildFamily('accent', accent)
    };
};

});


parcelRegister("cnYDK", function(module, exports) {
$parcel$export(module.exports, "getHubDefaultParameters", () => $b81d0d78017b1eff$export$25a6d2da841ddb1d);

var $2n0rH = parcelRequire("2n0rH");

var $Bq10O = parcelRequire("Bq10O");

var $3HJqh = parcelRequire("3HJqh");
var $4B9vJ = parcelRequire("4B9vJ");
/**
 * Day-0 default shade that bespoke extensions inherit through
 * `CommonHubExtensionsDependenciesProvider` when an extension hasn't pinned a
 * background of its own. Kept local to this resolver — it is intentionally
 * decoupled from `ELEMENT_DEFAULTS` because the per-element map is the
 * source-of-truth for *named* element slots (e.g. `callout.bg`), whereas this
 * is the resolver's own generic fallback shared across every extension.
 */ const $b81d0d78017b1eff$var$DEFAULT_HUB_BACKGROUND_SHADE = 'primary.200';
/**
 * Optional inputs that opt the default-parameters resolution into the
 * advanced-theming palette path. When `palette` is supplied, the bespoke-
 * element background defaults to the brand `primary.200` shade resolved from
 * that palette (per §4.2 of the Advanced Theming v2 design). When `palette`
 * is absent, behaviour is identical to the legacy single-brand-color path.
 */ /**
 * Per-element bg shade overrides. When an extension wants a different default
 * shade than the resolver's generic `primary.200`, it's mapped here. Keys
 * match the `ELEMENT_DEFAULTS` map; values are the slot suffix to look up.
 */ const $b81d0d78017b1eff$var$ELEMENT_BG_SHADE = {
    section: (0, $3HJqh.ELEMENT_DEFAULTS)['section.bg']
};
/**
 * Per-element icon-color shade overrides. Currently only JSM Help renders an
 * icon; values are looked up in `ELEMENT_DEFAULTS`.
 */ const $b81d0d78017b1eff$var$ELEMENT_ICON_SHADE = {
    'jsm-help': (0, $3HJqh.ELEMENT_DEFAULTS)['jsm-help.icon']
};
const $b81d0d78017b1eff$export$25a6d2da841ddb1d = (options = {})=>{
    if (options.palette) {
        const bgShade = options.element && $b81d0d78017b1eff$var$ELEMENT_BG_SHADE[options.element] || $b81d0d78017b1eff$var$DEFAULT_HUB_BACKGROUND_SHADE;
        const iconShade = options.element && $b81d0d78017b1eff$var$ELEMENT_ICON_SHADE[options.element];
        // Gate ON:
        //   - bg = CSS-var ref so the cascade tracks brand-color edits via the
        //     <HubThemingProvider> wrapper's inline `style`.
        //   - text = WCAG-readable black/white computed against the resolved
        //     bg hex. Stored as a literal so it remains correct even when
        //     admin overrides bg per-element (the auto-transition hook in
        //     the panel handles per-element flips at edit time).
        //   - icon = CSS-var ref (only when element opts in via ELEMENT_ICON_SHADE).
        return {
            backgroundColor: `var(${(0, $4B9vJ.HUB_COLOR_CSS_VARS)[bgShade]})`,
            textColor: (0, $2n0rH.readableTextColor)(options.palette[bgShade], '@atlassian/company-hub-common'),
            isAdvancedThemingEnabled: true,
            ...iconShade ? {
                iconColor: `var(${(0, $4B9vJ.HUB_COLOR_CSS_VARS)[iconShade]}, ${options.palette[iconShade]})`
            } : {}
        };
    }
    return {
        backgroundColor: `var(${0, $Bq10O.HUB_PRIMARY_COLOR_CSS_VAR}, ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"})`,
        textColor: `var(${0, $Bq10O.HUB_PRIMARY_TEXT_COLOR_CSS_VAR}, ${"var(--ds-text, #292A2E)"})`,
        isAdvancedThemingEnabled: false
    };
};

});
parcelRegister("3HJqh", function(module, exports) {
$parcel$export(module.exports, "ELEMENT_DEFAULTS", () => $e6a813e31db010c5$export$6d3cb81378fd614a);
/**
 * Element-default contract — see §4.2 of the Advanced Theming v2 design.
 *
 * Maps an element-color-slot key to a palette token reference. Day 0 only
 * defines bespoke-extension *background* slots, all pointing at `primary.200`,
 * which gives every bespoke element a coherent themed default while the rest
 * of the override / picker UX is built out.
 */ const $e6a813e31db010c5$export$6d3cb81378fd614a = {
    // Bespoke extensions — backgrounds (day 0).
    'callout.bg': 'primary.200',
    'cards.bg': 'primary.200',
    'carousel.bg': 'primary.200',
    'spotlight.bg': 'primary.200',
    'jsm-help.bg': 'primary.200',
    // JSM Help icon — bold brand tone for visibility against the light bg.
    'jsm-help.icon': 'primary.800',
    // Sections use a lighter accent tint to differentiate from bespoke extension cards.
    'section.bg': 'accent.100'
};

});


parcelRegister("63H5p", function(module, exports) {
$parcel$export(module.exports, "useIsAdvancedThemingEnabled", () => $a70de2626ac3178a$export$13ab96420d94e773);
/**
 * Returns `true` when advanced theming v2 should be active for the current
 * hub render, `false` otherwise.
 *
 * Advanced theming is gated by **both** of:
 *
 *   1. The product-level flag, exposed via `useHubContext().featureFlags
 *      ['advanced-theming-in-hub']`. The product (e.g. help-center) sets this
 *      `true` only for surfaces it has opted in (today: JSM Help Hubs only).
 *   2. The platform-level Statsig gate `hub-advanced-theming`, owned by the
 *      hubs platform team to control rollout independently of the product.
 *
 * AND-gating both lets either side hold the rollout independently — the
 * product can still keep the feature off for itself even if the platform
 * gate flips on, and vice versa. Pure read of context + statsig — SSR-safe.
 *
 * Cross-host safety: this hook tolerates a missing `<HubContextProvider>` and
 * returns `false` in that case. Confluence Company Hub and similar surfaces
 * that don't mount `HubBootstrap` (and therefore don't mount `HubContext`)
 * cannot be in a theming-enabled tree by definition, so returning `false`
 * is both safe and correct.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $iySE3 = parcelRequire("iySE3");
const $a70de2626ac3178a$export$13ab96420d94e773 = ()=>{
    var _ctx$featureFlags;
    const ctx = (0, $4fqPo.useContext)((0, $iySE3.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub). Theming
    // is help-center-only — return false without throwing.
    return false;
    const productFlag = ((_ctx$featureFlags = ctx.featureFlags) === null || _ctx$featureFlags === void 0 ? void 0 : _ctx$featureFlags['advanced-theming-in-hub']) === true;
    return productFlag && (0, $3H4LK.fg)('hub-advanced-theming');
};

});


parcelRegister("65BSy", function(module, exports) {
$parcel$export(module.exports, "NavigationStyleContext", () => $ba9e1c3335beffee$export$2c6067e95d1be081);
$parcel$export(module.exports, "useNavigationStyle", () => $ba9e1c3335beffee$export$ce205152a61c4e11);

var $4fqPo = parcelRequire("4fqPo");
const $ba9e1c3335beffee$var$noop = ()=>{};
const $ba9e1c3335beffee$export$2c6067e95d1be081 = (0, $4fqPo.createContext)({
    options: null,
    setOptions: $ba9e1c3335beffee$var$noop
});
const $ba9e1c3335beffee$export$ce205152a61c4e11 = ()=>(0, $4fqPo.useContext)($ba9e1c3335beffee$export$2c6067e95d1be081);

});

parcelRegister("immYM", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_NAVIGATION_OPTIONS", () => $02e05a12e63d96c2$export$cfca0f39600e333c);
$parcel$export(module.exports, "getDefaultNavigationOptions", () => $02e05a12e63d96c2$export$5046aed2fe45af56);
$parcel$export(module.exports, "mapApiToNavigationOptions", () => $02e05a12e63d96c2$export$b35e3817d72db278);

var $2n0rH = parcelRequire("2n0rH");
const $02e05a12e63d96c2$var$readableTextColor = (color)=>(0, $2n0rH.readableTextColor)(color, '@atlassian/company-hub-common');
const $02e05a12e63d96c2$export$cfca0f39600e333c = {
    padding: true,
    fixedAtTop: false,
    backgroundColor: '#FFFFFF',
    textColor: '#172B4D',
    borderColor: '#DFE1E6',
    borderType: 'NO_BORDER',
    cornerRadius: 8
};
function $02e05a12e63d96c2$export$5046aed2fe45af56(brandColor) {
    if (!brandColor) return $02e05a12e63d96c2$export$cfca0f39600e333c;
    return {
        ...$02e05a12e63d96c2$export$cfca0f39600e333c,
        backgroundColor: brandColor,
        textColor: $02e05a12e63d96c2$var$readableTextColor(brandColor)
    };
}
function $02e05a12e63d96c2$export$b35e3817d72db278(apiData, brandColor) {
    const defaults = $02e05a12e63d96c2$export$5046aed2fe45af56(brandColor);
    if (!apiData) return defaults;
    return {
        padding: apiData.padding ?? defaults.padding,
        fixedAtTop: apiData.positionType === 'FIXED',
        backgroundColor: apiData.backgroundColor ?? defaults.backgroundColor,
        textColor: apiData.textColor ?? defaults.textColor,
        borderColor: apiData.borderColor ?? defaults.borderColor,
        borderType: apiData.borderType === 'BOTTOM_BORDER' ? 'BOTTOM_BORDER' : apiData.borderType === 'ALL_BORDER' ? 'ALL_BORDER' : 'NO_BORDER',
        cornerRadius: apiData.cornerRadius ?? defaults.cornerRadius
    };
}

});


parcelRegister("36H9J", function(module, exports) {
$parcel$export(module.exports, "HubErrorBoundary", () => $bbf7cf1225ce5440$export$ba2f52e216142b3d);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $3H4LK = parcelRequire("3H4LK");

var $9ifhy = parcelRequire("9ifhy");
parcelRequire("aU7k1");
var $k554N = parcelRequire("k554N");

var $cK5Pl = parcelRequire("cK5Pl");
const $bbf7cf1225ce5440$var$isFetchClientError = (err)=>{
    return (err === null || err === void 0 ? void 0 : err.status) < 500;
};
const $bbf7cf1225ce5440$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError, operationNames: operationNames })=>{
    const logError = (0, $9ifhy.useUFOReportError)();
    const onError = (error)=>{
        if ($bbf7cf1225ce5440$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        // react-ufo does not expose a dedicated traceId/attribute field, so the trace ID is
        // appended to the error message. fireErrorAnalytics additionally receives it as an attribute.
        let traceId;
        if (operationNames && (0, $3H4LK.fg)('hub_error_analytics_trace_id')) {
            const traceIds = operationNames.flatMap((name)=>(0, $cK5Pl.getTraceIds)(name));
            traceId = traceIds.find(Boolean);
        }
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: traceId ? `${error.message} (traceId: ${traceId})` : error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $k554N.default)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                },
                attributes: traceId ? {
                    traceId: traceId
                } : undefined
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BYXH4.ErrorBoundary), {
        onError: onError,
        fallback: fallback
    }, children);
};

});

parcelRegister("askEH", function(module, exports) {
$parcel$export(module.exports, "mockHubRouteProps", () => $97518a9f87cae372$export$427679abd9cc3708);

var $4fqPo = parcelRequire("4fqPo");
const $97518a9f87cae372$export$60332b2344f7fe41 = ({ url: url = '', onError: onError = (_error)=>{}, children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": `smart-card-${url}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("button", {
        onClick: ()=>onError({
                status: 'not_found'
            })
    }, "Trigger not_found error status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("button", {
        onClick: ()=>onError({
                status: 'unauthorized'
            })
    }, "Trigger unauthorized error status"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("button", {
        onClick: ()=>onError({
                status: 'forbidden'
            })
    }, "Trigger forbidden error status"), children);
const $97518a9f87cae372$export$7b5e1b7f9a325b6 = $97518a9f87cae372$export$60332b2344f7fe41;
const $97518a9f87cae372$export$2e4ce4ce734f69e1 = ({ primary: primary = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, primary.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            key: name
        }, "Primary metadata: ", name)));
const $97518a9f87cae372$export$50a6a2d597e669c = ({ children: children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null) })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, "CustomBlock", children);
const $97518a9f87cae372$export$fff1c9c894fd3e9c = ({ overrideUrl: overrideUrl = 'NONE' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, "Preview: ", overrideUrl);
const $97518a9f87cae372$export$ababd1478ac17bc0 = ({ text: text = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, "Snippet: ", text);
const $97518a9f87cae372$export$ccf187e9bb6e68c = ({ metadata: metadata = [], text: text = '' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, !!text ? text : 'TitleBlock', metadata.map(({ name: name })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            key: name
        }, "Metadata: ", name)));
const $97518a9f87cae372$export$427679abd9cc3708 = {
    actions: {
        onLogoutClick: ()=>({
                type: 'epic.logout.LOG_OUT'
            })
    },
    env: {
        cloudId: '17554ffe-ef18-4562-8222-e295e81a46bb',
        helpCenterAri: 'ari:cloud:help::help-center/5b32ba66-fea2-4010-893d-278bfac050bc/5e67e6f9-7753-41fa-811b-55cb9fd71897',
        helpCenterId: '5e67e6f9-7753-41fa-811b-55cb9fd71897',
        hoistedProjectKey: 'TR',
        hubEditMode: false,
        jiraDisplayUrl: '/',
        relativeBaseUrl: '/'
    },
    layout: {
        bannerText: '',
        isAnonymousRoute: false,
        showBanner: false
    },
    user: {
        avatarSrc: '',
        displayName: 'test_name',
        email: 'test@atlassian.com',
        id: 'some_random_id',
        isJiraAdmin: false
    }
};

});

parcelRegister("cRPo9", function(module, exports) {
$parcel$export(module.exports, "HubAppShell", () => $72cd79e5401010af$export$647b3ff790ea59d4);
/* main.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");

var $Pxq7i = parcelRequire("Pxq7i");
var $iySE3 = parcelRequire("iySE3");
var $65BSy = parcelRequire("65BSy");
var $dUnMv = parcelRequire("dUnMv");

var $5Vuy8 = parcelRequire("5Vuy8");

var $djXz1 = parcelRequire("djXz1");

var $K665K = parcelRequire("K665K");
const $72cd79e5401010af$var$containerStyles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    container: "_19itglyw _1reo1wug _18m91wug _vchhusvi _r06hglyw _kqswh2mm _bfhkhp5a _1tke1osq _1e0c1txw _2lx21bp4 _1bzh1gj0 _5cd81gj0",
    childrenWrapper: "_n3tdoahv",
    childrenWrapperEditMode: "_16jlkb7n _1tkeidpf"
};
const $72cd79e5401010af$export$647b3ff790ea59d4 = ({ children: children, isEditMode: isEditMode = false, hideNavbar: hideNavbar = false })=>{
    const { layout: layout, containerStyling: containerStyling, headerless: headerless } = (0, $iySE3.useHubContext)();
    const { options: navStyle } = (0, $65BSy.useNavigationStyle)();
    const fixedNavBarStyling = navStyle !== null && navStyle !== void 0 && navStyle.fixedAtTop ? {
        height: '100%'
    } : {};
    const isHeaderless = headerless && (0, $3H4LK.fg)('csm-support-site-headerless-query-param');
    const showBanner = layout === null || layout === void 0 ? void 0 : layout.showBanner;
    const shouldApplyContainerStyling = (0, $3H4LK.fg)('enable-jsm-in-hubs');
    // Default hardcoded styles (used when feature flag is disabled for backward compatibility)
    const defaultContainerStyling = {
        borderRadius: "var(--ds-radius-large, 8px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    };
    // Apply containerStyling from props if feature flag is enabled, otherwise use hardcoded defaults
    const appliedContainerStyling = shouldApplyContainerStyling ? containerStyling : defaultContainerStyling;
    const hubContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(null);
    (0, $dUnMv.useUnsetGlobalTheme)(isEditMode ? hubContainerRef.current : null); // for view mode we don't need to unset the global theme
    // useHubTheming returns undefined outside <HubThemingProvider>, but
    // HubAppShell is always mounted inside HubBootstrap → provider is in tree.
    const { primaryColor: primaryColor, isAdvancedThemingEnabled: isAdvancedThemingEnabled } = (0, $5Vuy8.useHubTheming)();
    // Legacy theming path: when the v2 gate is OFF we restore the pre-v2
    // behaviour by writing the `--hub-primary-*` CSS vars into the document so
    // existing ADFs (which encode `var(--hub-primary-color, ...)` strings) and
    // chrome that consumes the same vars continue to look correct. When the
    // gate is ON the palette + adapter outputs from `useHubTheming()` drive
    // every consumer directly, so this effect is a no-op.
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        if (isAdvancedThemingEnabled) return undefined;
        return (0, $Pxq7i.setHubBrandingStyle)({
            primaryColor: primaryColor
        });
    }, [
        isAdvancedThemingEnabled,
        primaryColor
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $72cd79e5401010af$var$containerStyles.container,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic styles passed from outside via containerStyling prop
        style: {
            ...appliedContainerStyling,
            ...fixedNavBarStyling
        },
        ref: hubContainerRef
    }, !isHeaderless && !hideNavbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $K665K.Navbar), {
        isEditMode: isEditMode
    }), showBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            $72cd79e5401010af$var$containerStyles.bannerContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $djXz1.Banner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: isEditMode ? $72cd79e5401010af$var$containerStyles.childrenWrapperEditMode : $72cd79e5401010af$var$containerStyles.childrenWrapper,
        testId: "hub-app-shell-children-wrapper"
    }, children));
};

});
parcelRegister("Pxq7i", function(module, exports) {
$parcel$export(module.exports, "setHubBrandingStyle", () => $56eb2a4a4dc5a1ea$export$202bcc6267a600cb);

var $2n0rH = parcelRequire("2n0rH");
var $9sQ7a = parcelRequire("9sQ7a");

var $2R2ud = parcelRequire("2R2ud");
parcelRequire("aU7k1");
var $k554N = parcelRequire("k554N");

var $Bq10O = parcelRequire("Bq10O");
const $56eb2a4a4dc5a1ea$var$readableTextColor = (color)=>{
    return (0, $2n0rH.readableTextColor)(color, '@atlassian/company-hub-common');
};
const $56eb2a4a4dc5a1ea$export$202bcc6267a600cb = ({ primaryColor: primaryColor, targetElement: targetElement })=>{
    const primaryColorToUse = primaryColor || (0, $Bq10O.DEFAULT_BRANDING_COLOR);
    const finalTargetElement = targetElement || document.documentElement;
    try {
        // Convert to HEX for functions that require it (getLuminance, generateThemeBranding)
        const hexPrimaryColor = (0, $9sQ7a.toHexColor)(primaryColorToUse);
        const primaryTextColor = $56eb2a4a4dc5a1ea$var$readableTextColor(hexPrimaryColor);
        // Keep original format for CSS custom property (works with any valid CSS color)
        finalTargetElement.style.setProperty((0, $Bq10O.HUB_PRIMARY_COLOR_CSS_VAR), primaryColorToUse);
        finalTargetElement.style.setProperty((0, $Bq10O.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), primaryTextColor);
        // generateThemeBranding expects HEX colors
        const themeColours = (0, $2R2ud.generateThemeBranding)(hexPrimaryColor);
        finalTargetElement.style.setProperty((0, $Bq10O.HUB_PRIMARY_LINK_COLOR_CSS_VAR), themeColours.color900);
    } catch (error) {
        (0, $k554N.default)({
            error: error instanceof Error ? error : new Error(`Hub branding style processing failed for color: ${primaryColorToUse}`),
            meta: {
                id: 'setHubBrandingStyle',
                packageName: '@atlassian/company-hub-common'
            }
        });
        // Fallback to default branding if color processing fails
        finalTargetElement.style.setProperty((0, $Bq10O.HUB_PRIMARY_COLOR_CSS_VAR), (0, $Bq10O.DEFAULT_BRANDING_COLOR));
        finalTargetElement.style.setProperty((0, $Bq10O.HUB_PRIMARY_TEXT_COLOR_CSS_VAR), "var(--ds-text, #292A2E)");
    }
    return ()=>{
        finalTargetElement.style.removeProperty((0, $Bq10O.HUB_PRIMARY_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $Bq10O.HUB_PRIMARY_TEXT_COLOR_CSS_VAR));
        finalTargetElement.style.removeProperty((0, $Bq10O.HUB_PRIMARY_LINK_COLOR_CSS_VAR));
    };
};

});

parcelRegister("dUnMv", function(module, exports) {
$parcel$export(module.exports, "useUnsetGlobalTheme", () => $400df87539c35f02$export$8726d385cd3f733);

var $4fqPo = parcelRequire("4fqPo");

var $1dHhP = parcelRequire("1dHhP");
var $a1GvG = parcelRequire("a1GvG");
const $400df87539c35f02$export$8726d385cd3f733 = (targetElement, idsToUnset = [
    'light',
    'dark',
    'spacing'
])=>{
    const { colorMode: colorMode, dark: dark, light: light, spacing: spacing, typography: typography, UNSAFE_themeOptions: UNSAFE_themeOptions } = (0, $a1GvG.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        if (targetElement) (0, $1dHhP.default)().then((themeStyles)=>{
            themeStyles.forEach((themeStyle)=>{
                if (idsToUnset.includes(themeStyle.id)) {
                    const allCssVariables = themeStyle.css.match(/--[\w-]+/g); // output => ['--ds-text', '--ds-text-accent-lime']
                    allCssVariables === null || allCssVariables === void 0 || allCssVariables.forEach((cssVariable)=>{
                        targetElement.style.setProperty(cssVariable, 'initial');
                    });
                }
            });
        });
    }, [
        targetElement,
        idsToUnset,
        colorMode,
        dark,
        light,
        spacing,
        typography,
        UNSAFE_themeOptions
    ]);
};

});
parcelRegister("1dHhP", function(module, exports) {
$parcel$export(module.exports, "default", () => $334c61b1c4fae7be$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $4iNyp = parcelRequire("4iNyp");
var $ddktr = parcelRequire("ddktr");

var $6dibU = parcelRequire("6dibU");

var $eXiv5 = parcelRequire("eXiv5");

var $ju2x3 = parcelRequire("ju2x3");

var $48UmD = parcelRequire("48UmD");

/**
 * Takes an object containing theme preferences, and returns an array of objects for use in applying styles to the document head.
 * Only supplies the color themes necessary for initial render, based on the current themeState. I.e. if in light mode, dark mode themes are not returned.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.motion The motion theme to be applied.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns A Promise of an object array, containing theme IDs, data-attributes to attach to the theme, and the theme CSS.
 * If an error is encountered while loading themes, the themes array will be empty.
 */ const $334c61b1c4fae7be$var$getThemeStyles = async (preferences)=>{
    let themePreferences;
    let themeOverridePreferences = [];
    if (preferences === 'all') {
        themePreferences = (0, $4iNyp.themeIdsWithOverrides);
        // CLEANUP: Remove
        if (!(0, $3H4LK.fg)('platform_increased-contrast-themes')) themePreferences = themePreferences.filter((n)=>n !== 'light-increased-contrast' && n !== 'dark-increased-contrast');
    } else {
        const themeState = {
            colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $ddktr.themeStateDefaults)['colorMode'],
            contrastMode: (preferences === null || preferences === void 0 ? void 0 : preferences.contrastMode) || (0, $ddktr.themeStateDefaults)['contrastMode'],
            dark: (preferences === null || preferences === void 0 ? void 0 : preferences.dark) || (0, $ddktr.themeStateDefaults)['dark'],
            light: (preferences === null || preferences === void 0 ? void 0 : preferences.light) || (0, $ddktr.themeStateDefaults)['light'],
            motion: (preferences === null || preferences === void 0 ? void 0 : preferences.motion) || (0, $ddktr.themeStateDefaults)['motion'](),
            shape: (preferences === null || preferences === void 0 ? void 0 : preferences.shape) || (0, $ddktr.themeStateDefaults)['shape'](),
            spacing: (preferences === null || preferences === void 0 ? void 0 : preferences.spacing) || (0, $ddktr.themeStateDefaults)['spacing'],
            typography: (preferences === null || preferences === void 0 ? void 0 : preferences.typography) || (0, $ddktr.themeStateDefaults)['typography']
        };
        themePreferences = (0, $eXiv5.getThemePreferences)(themeState);
        themeOverridePreferences = (0, $6dibU.getThemeOverridePreferences)(themeState);
    }
    const results = await Promise.all([
        ...[
            ...themePreferences,
            ...themeOverridePreferences
        ].map(async (themeId)=>{
            try {
                const css = await (0, $48UmD.loadThemeCss)(themeId);
                return {
                    id: themeId,
                    attrs: {
                        'data-theme': themeId
                    },
                    css: css
                };
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
        }),
        // Add custom themes if they're present
        (async (_preferences$UNSAFE_t)=>{
            if (preferences !== 'all' && preferences !== null && preferences !== void 0 && preferences.UNSAFE_themeOptions && (0, $ju2x3.isValidBrandHex)(preferences === null || preferences === void 0 || (_preferences$UNSAFE_t = preferences.UNSAFE_themeOptions) === null || _preferences$UNSAFE_t === void 0 ? void 0 : _preferences$UNSAFE_t.brandColor)) try {
                const { getCustomThemeStyles: getCustomThemeStyles } = await (parcelRequire("iUTA2"));
                const customThemeStyles = await getCustomThemeStyles({
                    colorMode: (preferences === null || preferences === void 0 ? void 0 : preferences.colorMode) || (0, $ddktr.themeStateDefaults)['colorMode'],
                    UNSAFE_themeOptions: preferences === null || preferences === void 0 ? void 0 : preferences.UNSAFE_themeOptions
                });
                return customThemeStyles;
            } catch  {
                // Return undefined if there's an error loading it, will be filtered out later.
                return undefined;
            }
            return undefined;
        })()
    ]);
    return results.flat().filter((theme)=>theme !== undefined);
};
var $334c61b1c4fae7be$export$2e2bcd8739ae039 = $334c61b1c4fae7be$var$getThemeStyles;

});


parcelRegister("djXz1", function(module, exports) {
$parcel$export(module.exports, "Banner", () => $f004d58d4929b27b$export$3b4e64e77073e307);
$parcel$export(module.exports, "withHubBanner", () => $f004d58d4929b27b$export$c5c3e0c2fc948b49);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $5E02Z = parcelRequire("5E02Z");

var $Bq10O = parcelRequire("Bq10O");
var $36H9J = parcelRequire("36H9J");
var $iySE3 = parcelRequire("iySE3");

var $4idFV = parcelRequire("4idFV");
const $f004d58d4929b27b$var$styles = {
    bannerContainer: "_19bv1ejb _u5f31ejb _n3td1ejb",
    textContainer: "_4t3i8vuz _19pk1epz _otyr1epz",
    textContainerWidth: "_1bsb1vuk",
    bannerText: "_k48pwu06 _1wybckbl _vwz48vuz",
    bannerTextTruncation: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _y3gn1h6o",
    container: "_2rko12b0"
};
const $f004d58d4929b27b$var$BannerContent = ({ bannerText: bannerText })=>{
    const { branding: branding, layout: layout } = (0, $iySE3.useHubContext)();
    const bannerBackgroundColour = branding.colors.primary;
    const title = bannerText ? bannerText : layout === null || layout === void 0 ? void 0 : layout.bannerText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: bannerBackgroundColour
        },
        "data-testid": "banner",
        className: (0, $ltgDR.default)([
            $f004d58d4929b27b$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5E02Z.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            $f004d58d4929b27b$var$styles.textContainer,
            (0, $3H4LK.fg)('enable-jsm-in-hubs') && $f004d58d4929b27b$var$styles.textContainerWidth
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": "banner-text",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            color: (0, $4idFV.readableTextColor)(bannerBackgroundColour)
        },
        className: (0, $ltgDR.default)([
            $f004d58d4929b27b$var$styles.bannerText,
            (0, $3H4LK.fg)('enable-jsm-in-hubs') && $f004d58d4929b27b$var$styles.bannerTextTruncation
        ])
    }, title || ''))));
};
// Fallback banner shown when BannerContent fails to render
const $f004d58d4929b27b$var$BannerFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            backgroundColor: (0, $Bq10O.DEFAULT_BRANDING_COLOR)
        },
        "data-testid": "banner-fallback",
        className: (0, $ltgDR.default)([
            $f004d58d4929b27b$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5E02Z.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            $f004d58d4929b27b$var$styles.textContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            color: "var(--ds-text, #292A2E)"
        },
        className: (0, $ltgDR.default)([
            $f004d58d4929b27b$var$styles.bannerText
        ])
    }))));
const $f004d58d4929b27b$export$3b4e64e77073e307 = ({ bannerText: bannerText })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $36H9J.HubErrorBoundary), {
        packageName: "@atlassian/hub-app-shell",
        id: "banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f004d58d4929b27b$var$BannerFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f004d58d4929b27b$var$BannerContent, {
        bannerText: bannerText
    }));
};
const $f004d58d4929b27b$export$c5c3e0c2fc948b49 = (InnerComponent)=>{
    const ComponentWithHubBanner = (props)=>{
        const { bannerText: bannerText, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            className: (0, $ltgDR.default)([
                $f004d58d4929b27b$var$styles.bannerContainer
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f004d58d4929b27b$export$3b4e64e77073e307, {
            bannerText: bannerText
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(InnerComponent, rest));
    };
    return ComponentWithHubBanner;
};

});
parcelRegister("4idFV", function(module, exports) {
$parcel$export(module.exports, "readableTextColor", () => $4e1af8ea5f89be20$export$3d31854eb05903e0);

var $2n0rH = parcelRequire("2n0rH");
const $4e1af8ea5f89be20$export$3d31854eb05903e0 = (color)=>{
    return (0, $2n0rH.readableTextColor)(color, '@atlassian/hub-app-shell');
};

});


parcelRegister("K665K", function(module, exports) {
$parcel$export(module.exports, "Navbar", () => $408b5183f3d7cade$export$42cfbb80f7861e77);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");
parcelRequire("l8iRu");
var $bdubZ = parcelRequire("bdubZ");
var $1wDzz = parcelRequire("1wDzz");

var $d3YBt = parcelRequire("d3YBt");

var $aHUNw = parcelRequire("aHUNw");

var $d7mfg = parcelRequire("d7mfg");
var $21P09 = parcelRequire("21P09");

var $fxmw9 = parcelRequire("fxmw9");

var $aKTuH = parcelRequire("aKTuH");

var $1gH1z = parcelRequire("1gH1z");

var $6hIdA = parcelRequire("6hIdA");

var $7fscZ = parcelRequire("7fscZ");
var $2UMA8 = parcelRequire("2UMA8");

var $adEth = parcelRequire("adEth");
var $iySE3 = parcelRequire("iySE3");
var $65BSy = parcelRequire("65BSy");

var $93SGd = parcelRequire("93SGd");

var $jGnVL = parcelRequire("jGnVL");

var $h3HMc = parcelRequire("h3HMc");
const $408b5183f3d7cade$var$styles = {
    navbar: "_ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    navbarUpdated: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    navBarDisabled: "_lcxvglyw",
    logoContainer: "_zulpu2gc _1e0c1txw _4cvr1h6o",
    rightSection: "_zulputpp _1e0c1txw _4cvr1h6o"
};
const $408b5183f3d7cade$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false })=>{
    var _hubContext$layout;
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $4fqPo.useState)(false);
    const hubContext = (0, $iySE3.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $65BSy.useNavigationStyle)();
    const isNavBarUpdated = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.hub_component_upgrade) ?? false;
    const dynamicStyle = (0, $4fqPo.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`;
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navStyle.textColor,
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius}px` : '0',
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            zIndex: navStyle.fixedAtTop ? 1 : undefined,
            marginTop: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginLeft: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginRight: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginBottom: "var(--ds-space-300, 24px)",
            // we always add a margin bottom to the navbar
            transition: 'margin 0.3s ease, border-radius 0.3s ease, top 0.3s ease'
        };
    }, [
        navStyle
    ]);
    const iconColor = isNavBarUpdated ? navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor : undefined;
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = ((_hubContext$layout = hubContext.layout) === null || _hubContext$layout === void 0 ? void 0 : _hubContext$layout.isAnonymousRoute) || false;
    const handleInboxClick = (0, $4fqPo.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $4fqPo.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $4fqPo.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        "data-testId": "navbar",
        xcss: (0, $fxmw9.cx)(isNavBarUpdated ? $408b5183f3d7cade$var$styles.navbarUpdated : $408b5183f3d7cade$var$styles.navbar, isEditMode && $408b5183f3d7cade$var$styles.navBarDisabled),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic navigation styles from context
        style: isNavBarUpdated ? dynamicStyle : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $408b5183f3d7cade$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bdubZ.default), {
        to: !isAnonymousRoute ? '/' : '/user/login'
    }, logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("img", {
        height: (0, $adEth.getHubLogoHeight)(hubType),
        src: logoUrl,
        alt: formatMessage((0, $jGnVL.default).hubLogo)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $21P09.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aKTuH))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $jGnVL.default).hubLogo),
        color: navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor
    }))), !isAnonymousRoute && email && isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h3HMc.NavLinks), {
        textColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.textColor,
        backgroundColor: navStyle === null || navStyle === void 0 ? void 0 : navStyle.backgroundColor
    }), !isAnonymousRoute && email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $408b5183f3d7cade$var$styles.rightSection
    }, !isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, renderRightNavActions && renderRightNavActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $21P09.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1gH1z))), {
                ...iconProps,
                color: iconColor
            }),
        label: "User requests",
        onClick: handleInboxClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d3YBt.Profile), {
                ...triggerProps,
                tooltip: "Profile and settings",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aHUNw.default), {
                    appearance: "circle",
                    size: "medium",
                    src: avatarSrc
                }),
                onClick: handleProfileClick
            }),
        shouldRenderToParent: true,
        placement: "bottom-end",
        isOpen: isAvatarMenuOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $93SGd.AvatarMenu), null),
        onClose: handleAvatarMenuClose
    })), !isAnonymousRoute && !email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bdubZ.default), {
        to: `/user/login`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), null, formatMessage((0, $jGnVL.default).login)))));
};

});
parcelRegister("aKTuH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fd36682bcf7d93c8d6a4f8218f4f4e2d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d493f418fc74abf$var$_react = $7d493f418fc74abf$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $7d493f418fc74abf$var$_baseNew = $7d493f418fc74abf$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $7d493f418fc74abf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d493f418fc74abf$var$HomeIcon = (props)=>/*#__PURE__*/ $7d493f418fc74abf$var$_react.default.createElement($7d493f418fc74abf$var$_baseNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$7d493f418fc74abf$var$HomeIcon.displayName = 'HomeIcon';
var $7d493f418fc74abf$var$_default = module.exports.default = $7d493f418fc74abf$var$HomeIcon;

});

parcelRegister("adEth", function(module, exports) {
$parcel$export(module.exports, "getHubLogoHeight", () => $63de4c22b97fbc65$export$8eeba3862e4455cf);

var $Bq10O = parcelRequire("Bq10O");
const $63de4c22b97fbc65$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $Bq10O.HUB_LOGO_HEIGHT;
    // CSM hubs always use new height
    if (hubType === 'CUSTOMER_SERVICE') return 0, $Bq10O.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for other hub types
    return 0, $Bq10O.HUB_LOGO_HEIGHT_LEGACY;
};

});

parcelRegister("93SGd", function(module, exports) {
$parcel$export(module.exports, "AvatarMenu", () => $45c01a98b564deb7$export$f7f58290278dd286);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4MCQn = parcelRequire("4MCQn");
parcelRequire("l8iRu");
var $bdubZ = parcelRequire("bdubZ");
var $hfD9S = parcelRequire("hfD9S");

var $aRYa1 = parcelRequire("aRYa1");
var $hHIxn = parcelRequire("hHIxn");
var $aBwmQ = parcelRequire("aBwmQ");
var $2dYW6 = parcelRequire("2dYW6");
var $45ZUo = parcelRequire("45ZUo");

var $3H4LK = parcelRequire("3H4LK");

var $iySE3 = parcelRequire("iySE3");

var $bU34A = parcelRequire("bU34A");

var $3c2ay = parcelRequire("3c2ay");
const $45c01a98b564deb7$var$styles = {
    menu: "_1bsbnpok"
};
const $45c01a98b564deb7$export$f7f58290278dd286 = ()=>{
    const hubContext = (0, $iySE3.useHubContext)();
    const [{ match: match }] = (0, $hfD9S.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const shouldUseConsumerAvatarMenu = (0, $3H4LK.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $45c01a98b564deb7$var$styles.menu
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2dYW6.default), {
        spacing: "cozy"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $45ZUo.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $bU34A.AccountDetails), null)), consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ $4fqPo.createElement((0, $45ZUo.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $4fqPo.createElement((0, $aBwmQ.default), {
        href: csmEditorUrl,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $3c2ay.default).editSite))), /*#__PURE__*/ $4fqPo.createElement((0, $45ZUo.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $4fqPo.createElement((0, $hHIxn.default), {
        component: (0, $bdubZ.default),
        to: `/user/profile`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Disabled to rollout go/ui-styling-standard tooling
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $3c2ay.default).profile)), /*#__PURE__*/ $4fqPo.createElement((0, $aRYa1.default), {
        onClick: onLogoutClick
    }, formatMessage((0, $3c2ay.default).logout)))));
};

});
parcelRegister("bU34A", function(module, exports) {
$parcel$export(module.exports, "AccountDetails", () => $375c374ff5c610f0$export$66e04d0aacdb3b2);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $aHUNw = parcelRequire("aHUNw");

var $2UMA8 = parcelRequire("2UMA8");
var $Cp2Ub = parcelRequire("Cp2Ub");
var $5E02Z = parcelRequire("5E02Z");

var $iySE3 = parcelRequire("iySE3");
const $375c374ff5c610f0$var$styles = {
    displayName: "_11c8fhey",
    root: "_ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi",
    emailText: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1bsb1osq _1e0c1o8l _p12f1lit"
};
const $375c374ff5c610f0$export$66e04d0aacdb3b2 = ()=>{
    const { user: user } = (0, $iySE3.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $375c374ff5c610f0$var$styles.root
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $Cp2Ub.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2UMA8.default), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $aHUNw.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), null, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $375c374ff5c610f0$var$styles.displayName
        ])
    }, displayName), /*#__PURE__*/ $4fqPo.createElement("small", {
        className: (0, $ltgDR.default)([
            $375c374ff5c610f0$var$styles.emailText
        ])
    }, email))));
};

});

parcelRegister("3c2ay", function(module, exports) {
$parcel$export(module.exports, "default", () => $91cce97a22f7bc71$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $91cce97a22f7bc71$var$_default_1 = (0, $6BhDL.defineMessages)({
    editSite: {
        id: 'hub-app-shell.avatar-menu.edit-site',
        defaultMessage: 'Edit site',
        description: 'The text is shown as a drop-down menu item in the avatar menu, allowing the site administrator to navigate to the site editing interface.'
    },
    profile: {
        id: 'hub-app-shell.avatar-menu.profile',
        defaultMessage: 'Profile',
        description: 'The text is shown as a drop-down menu item in the avatar menu, allowing the current user to navigate to their profile page.'
    },
    logout: {
        id: 'hub-app-shell.avatar-menu.logout',
        defaultMessage: 'Logout',
        description: 'The text is shown as a drop-down menu item in the avatar menu that, when clicked, signs the current user out of the application.'
    }
});
var $91cce97a22f7bc71$export$2e2bcd8739ae039 = $91cce97a22f7bc71$var$_default_1;

});


parcelRegister("jGnVL", function(module, exports) {
$parcel$export(module.exports, "default", () => $476d5d4088f53b74$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $476d5d4088f53b74$var$_default_1 = (0, $6BhDL.defineMessages)({
    hubLogo: {
        id: 'company-hub.hub-app-shell.navbar.hub.logo',
        defaultMessage: 'Support home',
        description: 'The accessible label for the Hub logo link in the navigation bar, which navigates to the support home page when clicked.'
    },
    login: {
        id: 'company-hub.hub-app-shell.navbar.hub.log-in',
        defaultMessage: 'Log in',
        description: 'The text is shown on a button in the navigation bar that allows unauthenticated users to sign in to the help center.'
    }
});
var $476d5d4088f53b74$export$2e2bcd8739ae039 = $476d5d4088f53b74$var$_default_1;

});

parcelRegister("h3HMc", function(module, exports) {
$parcel$export(module.exports, "NavLinks", () => $3ffc14507afb2ec5$export$b615cd9717379c80);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $CTdYQ = parcelRequire("CTdYQ");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $lszf6 = parcelRequire("lszf6");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");
var $Cp2Ub = parcelRequire("Cp2Ub");
var $3Ln0N = parcelRequire("3Ln0N");

var $cijxS = parcelRequire("cijxS");

var $iySE3 = parcelRequire("iySE3");

var $jEG2h = parcelRequire("jEG2h");

var $8j0RE = parcelRequire("8j0RE");

var $36WrK = parcelRequire("36WrK");

var $87JWL = parcelRequire("87JWL");
const $3ffc14507afb2ec5$var$styles = {
    countBadge: "_2rkopb1k _4t3igktf _1ul9gktf _1e0c116y _4cvr1h6o _1bah1h6o _bfhk1aqn _syaz15cr _19bv1b66 _u5f31b66"
};
// Module-level cache so repeated mount/unmount cycles don't re-trigger the
// network request when the data has already been fetched for this hub.
// Only used when hubs_fix_rerendering_bootstrap_page_media is ON.
const $3ffc14507afb2ec5$var$requestCountCache = new Map();
const $3ffc14507afb2ec5$var$getCacheKey = (cloudUrl, helpCenterAri)=>`${cloudUrl}::${helpCenterAri}`;
const $3ffc14507afb2ec5$export$7a00ed33b23e6d4d = ()=>{
    $3ffc14507afb2ec5$var$requestCountCache.clear();
};
const $3ffc14507afb2ec5$var$NavLinkItems = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    var _data$helpCenter;
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = (0, $iySE3.useHubContext)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $CTdYQ.default), {
        cloudId: cloudId,
        hubAri: helpCenterAri
    });
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterRef = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.__typename) === 'HelpCenter' ? helpCenterById : null;
    const handleHomeClick = (0, $4fqPo.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $4fqPo.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $4fqPo.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
        testId: "nav-links",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        appearance: "subtle",
        onClick: handleHomeClick,
        style: {
            color: textColor
        }
    }, formatMessage((0, $8j0RE.default).home)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $87JWL.PortalDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        appearance: "subtle",
        onClick: handleRequestsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $8j0RE.default).requests), requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $3ffc14507afb2ec5$var$styles.countBadge
    }, requestCount.request))), (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        appearance: "subtle",
        onClick: handleApprovalsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $8j0RE.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $3ffc14507afb2ec5$var$styles.countBadge
    }, requestCount.pendingApprovals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $36WrK.MoreDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }));
};
const $3ffc14507afb2ec5$export$b615cd9717379c80 = ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    var _UNSAFE_useMediaQuery;
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $iySE3.useHubContext)();
    const [requestCount, setRequestCount] = (0, $4fqPo.useState)(()=>(0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media') ? $3ffc14507afb2ec5$var$requestCountCache.get($3ffc14507afb2ec5$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null);
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media')) {
            const cacheKey = $3ffc14507afb2ec5$var$getCacheKey(cloudUrl, helpCenterAri);
            const cached = $3ffc14507afb2ec5$var$requestCountCache.get(cacheKey);
            (0, $jEG2h.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                // Always refresh both the request and approvals counts from the
                // latest API response. The Approvals tab is rendered only when
                // `approvals > 0`, so updating to a fresh value of 0 will
                // correctly remove the tab when there is nothing to show.
                const next = {
                    approvals: data.userRequestsCounts.approvalsCount,
                    pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                    request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                };
                $3ffc14507afb2ec5$var$requestCountCache.set(cacheKey, next);
                setRequestCount(next);
            }).catch(()=>{
                if (cached) // Keep showing the cached values on refresh failure.
                return;
                // fallback count to zero if request count API fails on first load
                const fallback = {
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                };
                $3ffc14507afb2ec5$var$requestCountCache.set(cacheKey, fallback);
                setRequestCount(fallback);
            });
        } else (0, $jEG2h.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
            setRequestCount({
                approvals: data.userRequestsCounts.approvalsCount,
                pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                pendingApprovals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    const isBelowSm = ((_UNSAFE_useMediaQuery = (0, $3Ln0N.UNSAFE_useMediaQuery)('below.sm')) === null || _UNSAFE_useMediaQuery === void 0 ? void 0 : _UNSAFE_useMediaQuery.matches) ?? false;
    if (isBelowSm) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "nav-links-loader"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3ffc14507afb2ec5$var$NavLinkItems, {
        textColor: textColor,
        backgroundColor: backgroundColor,
        requestCount: requestCount
    }));
};

});
parcelRegister("CTdYQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d79e236d9c31aba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7b1a123d3618f7a9632022151735c34b>>
 * @relayHash e3ab3c07799a07e48aa007432a9e01ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 514323f1394cfa2b2152df0caef6ade5d66a70e35ad4643bcac9ab5b68b507b4
const $4d79e236d9c31aba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "hubAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "moreDropdown_AtlassianHubAppShell"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "alias": "customPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": [],
                                                        "type": "CUSTOM"
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterPageName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "514323f1394cfa2b2152df0caef6ade5d66a70e35ad4643bcac9ab5b68b507b4",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$4d79e236d9c31aba$var$node.hash = "5c0f53cb85dff35888c9656687817b29";
var $4d79e236d9c31aba$export$2e2bcd8739ae039 = $4d79e236d9c31aba$var$node;

});

parcelRegister("jEG2h", function(module, exports) {
$parcel$export(module.exports, "getRequestCount", () => $0e5f17c0f337872e$export$9aabeb09177df765);
const $0e5f17c0f337872e$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $0e5f17c0f337872e$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$0e5f17c0f337872e$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};

});

parcelRegister("8j0RE", function(module, exports) {
$parcel$export(module.exports, "default", () => $261e611fc574b39d$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $261e611fc574b39d$var$messages = (0, $6BhDL.defineMessages)({
    downIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.down-icon',
        defaultMessage: 'Open dropdown',
        description: 'Accessible label for the chevron-down icon button in the company hub navbar that opens a navigation dropdown.'
    },
    home: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.home',
        defaultMessage: 'Home',
        description: 'Text shown as the Home navigation link in the company hub top navbar, taking users to the hub home page.'
    },
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more',
        defaultMessage: 'More',
        description: 'Text shown as the More navigation link in the company hub top navbar, opening a dropdown with additional custom pages.'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals page'
    },
    requests: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.requests',
        defaultMessage: 'Requests',
        description: 'Text shown as the Requests navigation link in the company hub top navbar, taking users to their submitted support requests.'
    },
    approvals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.approvals',
        defaultMessage: 'Approvals',
        description: 'Navigation link label for user approvals'
    }
});
var $261e611fc574b39d$export$2e2bcd8739ae039 = $261e611fc574b39d$var$messages;

});

parcelRegister("36WrK", function(module, exports) {
$parcel$export(module.exports, "MoreDropdown", () => $866a148ee0a25efc$export$6d7fd1d1521d3638);

var $dm8u0 = parcelRequire("dm8u0");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $lszf6 = parcelRequire("lszf6");

var $845jN = parcelRequire("845jN");
var $4G75r = parcelRequire("4G75r");
var $kvfxL = parcelRequire("kvfxL");

var $cTq8x = parcelRequire("cTq8x");

var $17RcU = parcelRequire("17RcU");

var $8llkI = parcelRequire("8llkI");

var $c1Bvc = parcelRequire("c1Bvc");
const $866a148ee0a25efc$export$6d7fd1d1521d3638 = ({ queryRef: queryRef, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const data = (0, $gIeP2.useFragment)((0, $dm8u0.default), queryRef);
    const customPages = data === null || data === void 0 ? void 0 : data.customPages;
    if (!customPages || customPages.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $845jN.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
                    label: formatMessage((0, $c1Bvc.default).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $c1Bvc.default).more)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvfxL.default), null, customPages.map((page)=>{
        var _page$name;
        const pageId = page !== null && page !== void 0 && page.id ? (0, $8llkI.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4G75r.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                label: formatMessage((0, $c1Bvc.default).pageIconLabel)
            }),
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page === null || page === void 0 || (_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default);
    })));
};

});
parcelRegister("dm8u0", function(module, exports) {
$parcel$export(module.exports, "default", () => $246cf7cd2fc5788a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0b420321b8f0e6761b0f1e413d38c4e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $246cf7cd2fc5788a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$246cf7cd2fc5788a$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $246cf7cd2fc5788a$export$2e2bcd8739ae039 = $246cf7cd2fc5788a$var$node;

});

parcelRegister("845jN", function(module, exports) {
$parcel$export(module.exports, "default", () => $c277519c8f0ded86$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $d7mfg = parcelRequire("d7mfg");

var $hXq6r = parcelRequire("hXq6r");

var $5wgou = parcelRequire("5wgou");

var $c1tmZ = parcelRequire("c1tmZ");

var $4Vke2 = parcelRequire("4Vke2");

var $4W5Hj = parcelRequire("4W5Hj");

var $cTq8x = parcelRequire("cTq8x");

var $fK4in = parcelRequire("fK4in");

var $3H4LK = parcelRequire("3H4LK");

var $6hIdA = parcelRequire("6hIdA");

var $2vWb1 = parcelRequire("2vWb1");

var $6THwA = parcelRequire("6THwA");

var $e51Wt = parcelRequire("e51Wt");

var $60xtw = parcelRequire("60xtw");

var $9LoOY = parcelRequire("9LoOY");

var $gE7zb = parcelRequire("gE7zb");

var $7XUgP = parcelRequire("7XUgP");
const $c277519c8f0ded86$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $c277519c8f0ded86$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $c277519c8f0ded86$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$c277519c8f0ded86$var$opposites[crossAxis]}`,
            `${$c277519c8f0ded86$var$opposites[mainAxis]}-${crossAxis}`,
            `${$c277519c8f0ded86$var$opposites[mainAxis]}`,
            `${$c277519c8f0ded86$var$opposites[mainAxis]}-${$c277519c8f0ded86$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$c277519c8f0ded86$var$opposites[mainAxis]}`,
        `${$c277519c8f0ded86$var$opposites[mainAxis]}-start`,
        `${$c277519c8f0ded86$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $c277519c8f0ded86$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ function $c277519c8f0ded86$var$DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $c1tmZ.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $2vWb1.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $4Vke2.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $4fqPo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $4fqPo.useState)(false);
    const id = (0, $7XUgP.default)();
    const itemRef = (0, $gE7zb.default)();
    const { currentLevel: currentLevel } = (0, $fK4in.useLayering)();
    const fallbackPlacements = (0, $4fqPo.useMemo)(()=>$c277519c8f0ded86$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $4fqPo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $4fqPo.useCallback)((event, currentLevel)=>{
        var _event$target$closest, _event$target;
        const isTabLeftOrEscapeKey = $c277519c8f0ded86$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $hXq6r.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $c277519c8f0ded86$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $hXq6r.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, `[id^=${(0, $7XUgP.PREFIX)}] [aria-haspopup]`)) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($c277519c8f0ded86$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $hXq6r.KEY_LEFT))) requestAnimationFrame(()=>{
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $4W5Hj.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $4fqPo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $c1tmZ.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $c1tmZ.default;
        return (0, $lMcEJ.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $7XUgP.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $hXq6r.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $hXq6r.KEY_SPACE) || e.key === (0, $hXq6r.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $hXq6r.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9LoOY.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $5wgou.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
                ...bindFocus,
                ref: (0, $5wgou.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e51Wt.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $60xtw.default), {
                spacing: spacing,
                maxHeight: $c277519c8f0ded86$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children))
    }));
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $c277519c8f0ded86$var$DropdownMenu = (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $c1tmZ.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $3H4LK.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6THwA.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($c277519c8f0ded86$var$DropdownMenuLegacy, props);
};
var $c277519c8f0ded86$export$2e2bcd8739ae039 = $c277519c8f0ded86$var$DropdownMenu;

});
parcelRegister("4Vke2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a830d3dcc3677bc2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $a830d3dcc3677bc2$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $4fqPo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $4fqPo.useRef)(isControlled);
    (0, $4fqPo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $4fqPo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("4W5Hj", function(module, exports) {
$parcel$export(module.exports, "default", () => $4813b3f3e589983b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $4813b3f3e589983b$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $4fqPo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $4fqPo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $4fqPo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("6THwA", function(module, exports) {
$parcel$export(module.exports, "default", () => $c15392ba9ed79ae2$export$2e2bcd8739ae039);
/* dropdown-menu-top-layer.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $lMcEJ = parcelRequire("lMcEJ");

var $d7mfg = parcelRequire("d7mfg");

var $hXq6r = parcelRequire("hXq6r");

var $5wgou = parcelRequire("5wgou");

var $c1tmZ = parcelRequire("c1tmZ");

var $4Vke2 = parcelRequire("4Vke2");

var $4W5Hj = parcelRequire("4W5Hj");

var $cTq8x = parcelRequire("cTq8x");

var $2dYW6 = parcelRequire("2dYW6");

var $5qWT2 = parcelRequire("5qWT2");

var $R17QT = parcelRequire("R17QT");

var $eKwwy = parcelRequire("eKwwy");

var $9VLm8 = parcelRequire("9VLm8");

var $1v8Ej = parcelRequire("1v8Ej");

var $jC6gp = parcelRequire("jC6gp");

var $jJne7 = parcelRequire("jJne7");

var $ldc2k = parcelRequire("ldc2k");

var $9LoOY = parcelRequire("9LoOY");

var $5ax9w = parcelRequire("5ax9w");
var $k5tnP = parcelRequire("k5tnP");
var $jNZTS = parcelRequire("jNZTS");
const $c15392ba9ed79ae2$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $c15392ba9ed79ae2$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k",
    menuContent: "_2rkofajl _bfhk1bhr _16qs130s"
};
const $c15392ba9ed79ae2$var$animation = (0, $R17QT.slideAndFade)();
/**
 * Determines whether a trigger interaction was keyboard-initiated.
 *
 * Keyboard signals:
 * - `type === 'keydown'` (native KeyboardEvent from ArrowDown handler)
 * - `clientX/clientY === 0` (assistive technology click)
 * - `detail === 0` (keyboard-activated click via Enter/Space)
 */ function $c15392ba9ed79ae2$var$isKeyboardTriggered(event) {
    if (event.type === 'keydown') return true;
    if ('clientX' in event && (event.clientX === 0 || event.clientY === 0)) return true;
    if (event.detail === 0) return true;
    return false;
}
/**
 * Loading indicator for the dropdown menu.
 */ function $c15392ba9ed79ae2$var$LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        role: "menuitem",
        className: (0, $ltgDR.default)([
            $c15392ba9ed79ae2$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
}
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $c15392ba9ed79ae2$var$DropdownMenuTopLayer({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $c1tmZ.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $4Vke2.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $4fqPo.useRef)(null);
    const popoverRef = (0, $4fqPo.useRef)(null);
    const menuRef = (0, $4fqPo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $4fqPo.useState)(false);
    const popoverId = (0, $jJne7.usePopoverId)();
    const topLayerPlacement = (0, $4fqPo.useMemo)(()=>(0, $9VLm8.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    (0, $jC6gp.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $ldc2k.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    });
    // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $4fqPo.useCallback)(({ reason: _reason })=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    // Trigger click handling.
    const handleTriggerClicked = (0, $4fqPo.useCallback)((event)=>{
        const newValue = !isLocalOpen;
        setTriggeredUsingKeyboard($c15392ba9ed79ae2$var$isKeyboardTriggered(event));
        setLocalIsOpen(newValue);
        // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: newValue,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $4W5Hj.default)();
    // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $4fqPo.useEffect)(()=>{
        var _triggerRef$current;
        if (!isFocused || isLocalOpen) return 0, $c1tmZ.default;
        // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = ((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.closest('[role="menu"]')) != null;
        return (0, $lMcEJ.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $hXq6r.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $hXq6r.KEY_SPACE) || e.key === (0, $hXq6r.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    // Arrow navigation.
    // useArrowNavigation handles ArrowUp/Down, Home/End, and Tab-to-close
    // by querying focusable elements in the menu DOM container.
    const handleArrowClose = (0, $4fqPo.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    const handleNestedOpen = (0, $4fqPo.useCallback)(({ trigger: trigger })=>{
        trigger.click();
    }, []);
    const handleNestedClose = (0, $4fqPo.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    (0, $jNZTS.useArrowNavigation)({
        containerRef: menuRef,
        onClose: handleArrowClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleNestedClose,
        isEnabled: isLocalOpen,
        filter: (0, $k5tnP.isAtCurrentMenuLevel)
    });
    // Auto-focus first item on open.
    (0, $4fqPo.useEffect)(()=>{
        if (!isLocalOpen || !isTriggeredUsingKeyboard && !autoFocus) return;
        requestAnimationFrame(()=>{
            const menu = menuRef.current;
            if (!menu) return;
            const firstItem = (0, $5ax9w.getFirstFocusable)({
                container: menu
            });
            firstItem === null || firstItem === void 0 || firstItem.focus();
        });
    }, [
        isLocalOpen,
        isTriggeredUsingKeyboard,
        autoFocus
    ]);
    // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $4fqPo.useCallback)((e)=>{
        var _target$closest;
        const target = e.target;
        const menuItem = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio';
        // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $eKwwy.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    });
    // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes;
    const renderTrigger = ()=>{
        const setRef = (node)=>{
            triggerRef.current = node;
        };
        const combinedRef = (0, $5wgou.default)([
            setRef
        ]);
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            ...bindFocus,
            triggerRef: combinedRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ $4fqPo.createElement((0, $d7mfg.default), {
            ...bindFocus,
            ref: combinedRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName
        }, trigger);
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $9LoOY.default), null, renderTrigger(), /*#__PURE__*/ $4fqPo.createElement((0, $1v8Ej.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        animate: $c15392ba9ed79ae2$var$animation,
        placement: topLayerPlacement,
        testId: testId && `${testId}--content`
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        ref: menuRef,
        className: (0, $ltgDR.default)([
            $c15392ba9ed79ae2$var$styles.menuContent
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2dYW6.default), {
        isLoading: isLoading,
        maxHeight: $c15392ba9ed79ae2$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-wrapper--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $4fqPo.createElement($c15392ba9ed79ae2$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--menu-wrapper--loading-indicator`
    }) : children))));
}
var $c15392ba9ed79ae2$export$2e2bcd8739ae039 = $c15392ba9ed79ae2$var$DropdownMenuTopLayer;

});
parcelRegister("9LoOY", function(module, exports) {
$parcel$export(module.exports, "default", () => $c04fbff82dee3904$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $cvhRZ = parcelRequire("cvhRZ");
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $c04fbff82dee3904$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $4fqPo.useRef)({});
    const context = (0, $4fqPo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cvhRZ.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $c04fbff82dee3904$export$2e2bcd8739ae039 = $c04fbff82dee3904$var$SelectionStore;

});
parcelRegister("cvhRZ", function(module, exports) {
$parcel$export(module.exports, "SelectionStoreContext", () => $dd07da91574cf73c$export$756f795847463ebd);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");
const $dd07da91574cf73c$export$756f795847463ebd = /*#__PURE__*/ (0, $4fqPo.createContext)({
    setItemState: (0, $c1tmZ.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $c1tmZ.default),
    getGroupState: ()=>({})
});

});


parcelRegister("k5tnP", function(module, exports) {
$parcel$export(module.exports, "isAtCurrentMenuLevel", () => $66dcb442540d73a5$export$f1bba0ef464d60af);
const $66dcb442540d73a5$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $66dcb442540d73a5$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $66dcb442540d73a5$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $66dcb442540d73a5$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($66dcb442540d73a5$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $66dcb442540d73a5$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}

});

parcelRegister("jNZTS", function(module, exports) {
$parcel$export(module.exports, "useArrowNavigation", () => $e15d7d135ea55c40$export$23dfbae28e0cc453);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $564zZ = parcelRequire("564zZ");

var $hXq6r = parcelRequire("hXq6r");

var $5ax9w = parcelRequire("5ax9w");

var $l3xB8 = parcelRequire("l3xB8");

var $eW0Yp = parcelRequire("eW0Yp");
const $e15d7d135ea55c40$var$menuScope = '[role="menu"]';
function $e15d7d135ea55c40$export$23dfbae28e0cc453({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $4fqPo.useCallback)((event)=>{
        var _getDocument;
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (_getDocument = (0, $564zZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($e15d7d135ea55c40$var$menuScope) !== container) return;
        }
        if (event.key === (0, $hXq6r.KEY_DOWN)) {
            var _getNextFocusable;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable = (0, $eW0Yp.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })) === null || _getNextFocusable === void 0 || _getNextFocusable.focus();
            return;
        }
        if (event.key === (0, $hXq6r.KEY_UP)) {
            var _getNextFocusable2;
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (_getNextFocusable2 = (0, $eW0Yp.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })) === null || _getNextFocusable2 === void 0 || _getNextFocusable2.focus();
            return;
        }
        if (event.key === (0, $hXq6r.KEY_HOME)) {
            var _getFirstFocusable;
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (_getFirstFocusable = (0, $5ax9w.getFirstFocusable)({
                container: container,
                filter: filter
            })) === null || _getFirstFocusable === void 0 || _getFirstFocusable.focus();
            return;
        }
        if (event.key === (0, $hXq6r.KEY_END)) {
            var _getLastFocusable;
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (_getLastFocusable = (0, $l3xB8.getLastFocusable)({
                container: container,
                filter: filter
            })) === null || _getLastFocusable === void 0 || _getLastFocusable.focus();
            return;
        }
        if (event.key === (0, $hXq6r.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                var _container$parentElem;
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = ((_container$parentElem = container.parentElement) === null || _container$parentElem === void 0 ? void 0 : _container$parentElem.closest($e15d7d135ea55c40$var$menuScope)) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const container = containerRef.current;
        if (!container || !isEnabled) return;
        return (0, $lMcEJ.bind)(container, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
}

});


parcelRegister("e51Wt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae4d5ef82933eda6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $fK4in = parcelRequire("fK4in");

var $gOeRJ = parcelRequire("gOeRJ");

var $jO2U1 = parcelRequire("jO2U1");
/**
 * Focus manager logic.
 */ const $ae4d5ef82933eda6$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $4fqPo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $4fqPo.useState)(0);
    const registerMode = (0, $4fqPo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $4fqPo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $fK4in.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $4fqPo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $4fqPo.useEffect)(()=>(0, $lMcEJ.bind)(window, {
            type: 'keydown',
            listener: (0, $gOeRJ.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jO2U1.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $ae4d5ef82933eda6$export$2e2bcd8739ae039 = $ae4d5ef82933eda6$var$FocusManager;

});
parcelRegister("gOeRJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f340349aba6de60$export$2e2bcd8739ae039);

var $hXq6r = parcelRequire("hXq6r");

var $3H4LK = parcelRequire("3H4LK");

var $7XUgP = parcelRequire("7XUgP");
const $2f340349aba6de60$var$actionMap = {
    [(0, $hXq6r.KEY_DOWN)]: 'next',
    [(0, $hXq6r.KEY_UP)]: 'prev',
    [(0, $hXq6r.KEY_HOME)]: 'first',
    [(0, $hXq6r.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $2f340349aba6de60$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $2f340349aba6de60$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $2f340349aba6de60$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>{
            var _document$activeEleme;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $3H4LK.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest(`[id^=${(0, $7XUgP.PREFIX)}]`));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $hXq6r.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $hXq6r.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $hXq6r.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $hXq6r.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $2f340349aba6de60$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $2f340349aba6de60$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $2f340349aba6de60$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $2f340349aba6de60$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $2f340349aba6de60$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("7XUgP", function(module, exports) {
$parcel$export(module.exports, "PREFIX", () => $f58f3ee59bd078b6$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $f58f3ee59bd078b6$export$2e2bcd8739ae039);

var $a4Rr2 = parcelRequire("a4Rr2");
const $f58f3ee59bd078b6$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $f58f3ee59bd078b6$export$2e2bcd8739ae039() {
    const id = (0, $a4Rr2.useId)();
    return `${$f58f3ee59bd078b6$export$8a682ae47622dbb9}${id}`;
}

});


parcelRegister("jO2U1", function(module, exports) {
$parcel$export(module.exports, "FocusManagerContext", () => $fb05335f7d7b1813$export$f18c1d4fc7326096);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");
const $fb05335f7d7b1813$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $c1tmZ.default)
});

});


parcelRegister("60xtw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6aed13e8e56c4da$export$2e2bcd8739ae039);
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $2dYW6 = parcelRequire("2dYW6");

var $3H4LK = parcelRequire("3H4LK");

var $7fscZ = parcelRequire("7fscZ");

var $5qWT2 = parcelRequire("5qWT2");

var $8SB0n = parcelRequire("8SB0n");

var $67Cpv = parcelRequire("67Cpv");

var $jO2U1 = parcelRequire("jO2U1");
const $d6aed13e8e56c4da$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $d6aed13e8e56c4da$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $d6aed13e8e56c4da$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $5qWT2.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $d6aed13e8e56c4da$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $4fqPo.useContext)((0, $jO2U1.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $8SB0n.default)(menuItem) || (0, $67Cpv.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $4fqPo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $3H4LK.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $4fqPo.createElement((0, $2dYW6.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $4fqPo.createElement($d6aed13e8e56c4da$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $d6aed13e8e56c4da$export$2e2bcd8739ae039 = $d6aed13e8e56c4da$var$MenuWrapper;

});
parcelRegister("8SB0n", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ebad94b420ed2e6$export$2e2bcd8739ae039);
function $2ebad94b420ed2e6$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("67Cpv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7345c0ba8de224b0$export$2e2bcd8739ae039);
function $7345c0ba8de224b0$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("gE7zb", function(module, exports) {
$parcel$export(module.exports, "default", () => $968be698a7844b33$export$2e2bcd8739ae039);
// eslint-disable-next-line sort-imports

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $jO2U1 = parcelRequire("jO2U1");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $968be698a7844b33$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $4fqPo.useContext)((0, $jO2U1.FocusManagerContext));
    const itemRef = (0, $4fqPo.useRef)(null);
    (0, $4fqPo.useEffect)(()=>{
        if (hasPopup && (0, $3H4LK.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $968be698a7844b33$export$2e2bcd8739ae039 = $968be698a7844b33$var$useRegisterItemWithFocusManager;

});


parcelRegister("4G75r", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0b46d9fc20df7f1$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5wgou = parcelRequire("5wgou");

var $aRYa1 = parcelRequire("aRYa1");

var $hHIxn = parcelRequire("hHIxn");

var $aBwmQ = parcelRequire("aBwmQ");

var $gE7zb = parcelRequire("gE7zb");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $b0b46d9fc20df7f1$var$DropdownMenuItem = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $gE7zb.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $4fqPo.useCallback)((event)=>{
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5wgou.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aBwmQ.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5wgou.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aRYa1.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5wgou.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
});
var $b0b46d9fc20df7f1$export$2e2bcd8739ae039 = $b0b46d9fc20df7f1$var$DropdownMenuItem;

});

parcelRegister("kvfxL", function(module, exports) {
$parcel$export(module.exports, "default", () => $54db0995c398340f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $45ZUo = parcelRequire("45ZUo");

var $jQHL2 = parcelRequire("jQHL2");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $54db0995c398340f$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $a4Rr2.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jQHL2.default), {
        id: titleId,
        title: title
    }), children);
});
var $54db0995c398340f$export$2e2bcd8739ae039 = $54db0995c398340f$var$DropdownMenuItemGroup;

});
parcelRegister("jQHL2", function(module, exports) {
$parcel$export(module.exports, "default", () => $695a5173697174ab$export$2e2bcd8739ae039);
/* group-title.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");
const $695a5173697174ab$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $695a5173697174ab$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $695a5173697174ab$var$styles.heading
    }, title);
var $695a5173697174ab$export$2e2bcd8739ae039 = $695a5173697174ab$var$GroupTitle;

});


parcelRegister("c1Bvc", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2537363e53f1c1$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $fa2537363e53f1c1$var$messages = (0, $6BhDL.defineMessages)({
    more: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more',
        defaultMessage: 'More',
        description: 'Navigation link label for the more dropdown showing custom pages'
    },
    moreDownIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.chevron-down',
        defaultMessage: 'Open more dropdown',
        description: 'Accessible label for the chevron-down icon button in the company hub navbar that opens the More navigation dropdown listing custom pages.'
    },
    pageIconLabel: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label',
        defaultMessage: 'Page icon',
        description: 'Label for the page icon in the more dropdown'
    }
});
var $fa2537363e53f1c1$export$2e2bcd8739ae039 = $fa2537363e53f1c1$var$messages;

});


parcelRegister("87JWL", function(module, exports) {
$parcel$export(module.exports, "PortalDropdown", () => $3522d2ffc0590956$export$32e0c0d1c2f88773);

var $dd5w5 = parcelRequire("dd5w5");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $lszf6 = parcelRequire("lszf6");

var $845jN = parcelRequire("845jN");
var $4G75r = parcelRequire("4G75r");
var $kvfxL = parcelRequire("kvfxL");

var $cTq8x = parcelRequire("cTq8x");

var $17RcU = parcelRequire("17RcU");

var $ajF8H = parcelRequire("ajF8H");
const $3522d2ffc0590956$export$32e0c0d1c2f88773 = ({ queryRef: queryRef, textColor: textColor })=>{
    var _data$portals;
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const data = (0, $gIeP2.useFragment)((0, $dd5w5.default), queryRef);
    const portalPages = data === null || data === void 0 || (_data$portals = data.portals) === null || _data$portals === void 0 ? void 0 : _data$portals.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (hasSinglePortal) {
        var _portalPages$2;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
            appearance: "subtle",
            onClick: ()=>{
                var _portalPages$;
                push(`/portal/${(_portalPages$ = portalPages[0]) === null || _portalPages$ === void 0 ? void 0 : _portalPages$.id}`);
            },
            style: {
                color: textColor
            }
        }, (_portalPages$2 = portalPages[0]) === null || _portalPages$2 === void 0 ? void 0 : _portalPages$2.name);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $845jN.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
                    label: formatMessage((0, $ajF8H.default).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $ajF8H.default).portals)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvfxL.default), null, portalPages === null || portalPages === void 0 ? void 0 : portalPages.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4G75r.default), {
            key: portal === null || portal === void 0 ? void 0 : portal.id,
            onClick: ()=>{
                push(`/portal/${portal === null || portal === void 0 ? void 0 : portal.id}`);
            },
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                label: formatMessage((0, $ajF8H.default).pageIcon)
            })
        }, portal === null || portal === void 0 ? void 0 : portal.name))));
};

});
parcelRegister("dd5w5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0aa4e8e2f574f45e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f1bffc73ab190c3ed149645d865f273>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0aa4e8e2f574f45e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$0aa4e8e2f574f45e$var$node.hash = "9321e563780af8e8cdc6d16d81e1564c";
var $0aa4e8e2f574f45e$export$2e2bcd8739ae039 = $0aa4e8e2f574f45e$var$node;

});

parcelRegister("ajF8H", function(module, exports) {
$parcel$export(module.exports, "default", () => $50919281a303cd5c$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $50919281a303cd5c$var$messages = (0, $6BhDL.defineMessages)({
    pageIcon: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon',
        defaultMessage: 'Page icon',
        description: 'The accessible label for the page icon displayed next to portal navigation items in the portals drop-down in the navbar.'
    },
    portalDownIcon: {
        defaultMessage: 'Open portals dropdown',
        description: 'The accessible label for the chevron-down icon on the button that opens the portals drop-down in the navbar navigation.',
        id: 'company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down'
    },
    portals: {
        id: 'company-hub.hub-app-shell.navbar.nav-links.portals',
        defaultMessage: 'Portals',
        description: 'Navigation link label for the portals dropdown'
    }
});
var $50919281a303cd5c$export$2e2bcd8739ae039 = $50919281a303cd5c$var$messages;

});





parcelRegister("71qeF", function(module, exports) {
$parcel$export(module.exports, "hubBootstrapResource", () => $6c0091620ffeb021$export$8ce4230d96a2a267);
$parcel$export(module.exports, "hubPageResource", () => $6c0091620ffeb021$export$6d8c7b8b2daae34c);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */ 
var $3H4LK = parcelRequire("3H4LK");

var $3sFpN = parcelRequire("3sFpN");
var $askEH = parcelRequire("askEH");

var $6pgZt = parcelRequire("6pgZt");

var $gplQ0 = parcelRequire("gplQ0");

var $2QadH = parcelRequire("2QadH");
const $6c0091620ffeb021$var$getPageIdFromRouteParams = (match, routeName)=>{
    if (routeName === (0, $6pgZt.HUB_PORTAL_PAGE_ROUTE_NAME) && (0, $3H4LK.fg)('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.id || '';
};
const $6c0091620ffeb021$export$8ce4230d96a2a267 = (0, $2QadH.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $6pgZt.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $6c0091620ffeb021$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $askEH.mockHubRouteProps).env.cloudId && (0, $askEH.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $askEH.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $askEH.mockHubRouteProps).env.helpCenterAri;
        }
        const skipPageMediaConfig = (0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media');
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                // Always pass `$pageAri` so the query variable is always
                // defined; when `$skipPageMediaConfig` is true the field is
                // skipped by the GraphQL `@skip` directive and the value is
                // not sent to the server.
                pageAri: (0, $2QadH.getPageAri)(helpCenterAriDerived, pageId),
                operationType: 'READ',
                hubEditMode: false,
                skipPageMediaConfig: // When true, the bootstrap fragment skips `pageMediaConfig`
                // (via `@skip`) so the query stays page-agnostic and is not
                // refetched on every page navigation.
                skipPageMediaConfig
            },
            query: (0, $3sFpN.default),
            options: {
                fetchPolicy: 'store-or-network'
            },
            environment: relayEnvironment
        };
    }
});
const $6c0091620ffeb021$export$6d8c7b8b2daae34c = (0, $2QadH.createRelayResource)({
    getQuery: ({ match: match, route: route }, { cloudId: cloudId, helpCenterAri: helpCenterAri, relayEnvironment: relayEnvironment })=>{
        const isPreview = (route === null || route === void 0 ? void 0 : route.name) === (0, $6pgZt.HUB_PREVIEW_ROUTE_NAME);
        const pageId = $6c0091620ffeb021$var$getPageIdFromRouteParams(match, route === null || route === void 0 ? void 0 : route.name);
        let cloudIdDerived = cloudId;
        let helpCenterAriDerived = helpCenterAri;
        if (isPreview && (0, $askEH.mockHubRouteProps).env.cloudId && (0, $askEH.mockHubRouteProps).env.helpCenterAri) {
            cloudIdDerived = (0, $askEH.mockHubRouteProps).env.cloudId;
            helpCenterAriDerived = (0, $askEH.mockHubRouteProps).env.helpCenterAri;
        }
        return {
            variables: {
                cloudId: cloudIdDerived,
                hubAri: helpCenterAriDerived,
                pageAri: (0, $2QadH.getPageAri)(helpCenterAriDerived, pageId),
                operationType: 'READ'
            },
            environment: relayEnvironment,
            query: (0, $gplQ0.default),
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("6pgZt", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTE_NAME", () => $80b585a54ff1cf75$export$b4255e69eefe642e);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_NAME", () => $80b585a54ff1cf75$export$35619d8059a56474);
$parcel$export(module.exports, "HUB_PREVIEW_ROUTE_PATH", () => $80b585a54ff1cf75$export$a1b29fc86625d058);
$parcel$export(module.exports, "HUB_ROUTE_PATH", () => $80b585a54ff1cf75$export$2735e29305134506);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_NAME", () => $80b585a54ff1cf75$export$da6ac9e48027aa54);
$parcel$export(module.exports, "HUB_CUSTOM_PAGE_ROUTE_PATH", () => $80b585a54ff1cf75$export$7815c1f7abc1c129);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_NAME", () => $80b585a54ff1cf75$export$54ede43f7406f46f);
$parcel$export(module.exports, "HUB_PORTAL_PAGE_ROUTE_PATH", () => $80b585a54ff1cf75$export$c7f93458584dce24);
const $80b585a54ff1cf75$export$b4255e69eefe642e = 'hub';
const $80b585a54ff1cf75$export$35619d8059a56474 = 'hub-preview';
const $80b585a54ff1cf75$export$a1b29fc86625d058 = '/s/:cloudId/hubs/:hubId/preview';
const $80b585a54ff1cf75$export$2735e29305134506 = '/';
const $80b585a54ff1cf75$export$da6ac9e48027aa54 = 'hub-custom-page';
const $80b585a54ff1cf75$export$7815c1f7abc1c129 = '/page/:id/:title?';
const $80b585a54ff1cf75$export$54ede43f7406f46f = 'hub-portal-page';
const $80b585a54ff1cf75$export$c7f93458584dce24 = '/portal/:portalId';

});

parcelRegister("gplQ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $bdc956cf4b687320$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9858828dd3c92e2cd7b5ddb353e45c04>>
 * @relayHash cac609f1b5adb1f7064582d6b4625938
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a13d887198ace35559a154088759b25831e249f357b45ff223bab473c6dcb26
const $bdc956cf4b687320$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "ari",
            "variableName": "pageAri"
        },
        {
            "kind": "Variable",
            "name": "operationType",
            "variableName": "operationType"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "asapIssuer"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mediaCollectionName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "mediaToken"
    }, v9 = {
        "kind": "ScalarField",
        "name": "mediaUrl"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "id"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "HelpCenterName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "backgroundColor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "borderColor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "borderType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "cornerRadius"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "padding"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "positionType"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "textColor"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "fields": [
                            {
                                "items": [
                                    {
                                        "kind": "Variable",
                                        "name": "ids.0",
                                        "variableName": "pageAri"
                                    }
                                ],
                                "kind": "ListValue",
                                "name": "ids"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                    }
                ],
                "concreteType": "HelpCenterPage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "concreteType": "HelpCenterPageName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": v12 /*: any*/ 
                    },
                    {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterLayoutAdf",
                                "kind": "LinkedField",
                                "name": "layoutAdf",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "HelpCenterLayoutAdfContentConnection",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "HelpCenterLayoutAdfContent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "content"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "pageMediaConfig",
                                "args": v5 /*: any*/ ,
                                "concreteType": "HelpCenterMediaConfig",
                                "kind": "LinkedField",
                                "name": "hubMediaConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": v6 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v7 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v8 /*: any*/ ,
                                        "action": "THROW"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": v9 /*: any*/ ,
                                        "action": "THROW"
                                    }
                                ]
                            },
                            "action": "THROW"
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "pageMediaConfig",
                            "args": v5 /*: any*/ ,
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v13 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5a13d887198ace35559a154088759b25831e249f357b45ff223bab473c6dcb26",
            "metadata": {},
            "name": "hubQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bdc956cf4b687320$var$node.hash = "f2cb8e8955c5be850861a0d8de520f37";
var $bdc956cf4b687320$export$2e2bcd8739ae039 = $bdc956cf4b687320$var$node;

});

parcelRegister("2QadH", function(module, exports) {
$parcel$export(module.exports, "createRelayResource", () => $fc5d9870e6434937$export$1cc887c62079ea32);
$parcel$export(module.exports, "useRelayResource", () => $fc5d9870e6434937$export$42ca7b248c7aaee);
$parcel$export(module.exports, "getPageAri", () => $fc5d9870e6434937$export$9e8d72642057ad79);

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $f03OU = parcelRequire("f03OU");
var $cpzpY = parcelRequire("cpzpY");

var $3H4LK = parcelRequire("3H4LK");

var $4oTiM = parcelRequire("4oTiM");
var $8llkI = parcelRequire("8llkI");

var $21JLS = parcelRequire("21JLS");

var $byZGc = parcelRequire("byZGc");

var $cK5Pl = parcelRequire("cK5Pl");
function $fc5d9870e6434937$var$createCacheKey(query, variables) {
    const queryId = 'cacheID' in query.params ? query.params.cacheID : query.params.id;
    return `relay-${queryId}-${query.params.name}-${JSON.stringify(variables ?? {})}`;
}
const $fc5d9870e6434937$export$1cc887c62079ea32 = ({ getQuery: getQuery })=>(0, $f03OU.createResource)({
        type: 'RELAY_RESOURCE_TYPE',
        getKey: (routerContext, customContext)=>{
            const { query: query, variables: variables, cacheKey: cacheKey } = getQuery(routerContext, customContext);
            return cacheKey ?? $fc5d9870e6434937$var$createCacheKey(query, variables);
        },
        getData: (routerContext, customContext)=>{
            const { query: query, variables: variables, options: options, environment: environment } = getQuery(routerContext, customContext);
            const relayEnvironment = (0, $3H4LK.fg)('company_hub_single_relay_environment') ? environment : undefined;
            if ((0, $3H4LK.fg)('hub_error_analytics_trace_id')) (0, $cK5Pl.startCapturingTraceIds)(query.params.name);
            const queryReference = (0, $gIeP2.loadQuery)(relayEnvironment ?? (0, $byZGc.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__), query, variables ?? {}, options);
            return Promise.resolve(queryReference);
        }
    });
const $fc5d9870e6434937$export$42ca7b248c7aaee = (resource)=>{
    const { data: queryReference } = (0, $cpzpY.useResource)(resource);
    return {
        queryReference: queryReference
    };
};
const $fc5d9870e6434937$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $4oTiM.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $fc5d9870e6434937$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $fc5d9870e6434937$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    const resolvedPageId = pageId || helpCenterId;
    if ((0, $21JLS.isPortalPage)(resolvedPageId) && helpCenterId) return (0, $21JLS.buildPortalPageAri)(helpCenterAri, resolvedPageId);
    return (0, $8llkI.HelpPageAri).create({
        activationId: activationId,
        pageId: resolvedPageId
    }).toString() || '';
};

});
parcelRegister("21JLS", function(module, exports) {
$parcel$export(module.exports, "HubPageType", () => $f77a4e7a25afd233$export$dbf470ddbd9b58b6);
$parcel$export(module.exports, "isPortalPage", () => $f77a4e7a25afd233$export$646dda995799f7d5);
$parcel$export(module.exports, "getPortalIdFromPageId", () => $f77a4e7a25afd233$export$fef05bffd39d3ca1);
$parcel$export(module.exports, "buildPortalPageAri", () => $f77a4e7a25afd233$export$9d2b62eb20639695);
$parcel$export(module.exports, "isHomePageByAri", () => $f77a4e7a25afd233$export$c0ca1e0679075a3);
$parcel$export(module.exports, "resolveCurrentPage", () => $f77a4e7a25afd233$export$bec70b043200c466);
// eslint-disable-next-line no-restricted-imports

var $4oTiM = parcelRequire("4oTiM");
var $8llkI = parcelRequire("8llkI");
const $f77a4e7a25afd233$var$PORTAL_PAGE_PREFIX = 'portal_page-';
const $f77a4e7a25afd233$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null' && (0, $4oTiM.HelpHelpCenterAri).check(helpCenterAri)) {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // Silently fail for invalid ARIs
    }
};
var $f77a4e7a25afd233$export$dbf470ddbd9b58b6 = /*#__PURE__*/ function(HubPageType) {
    /** The hub's home/landing page */ HubPageType["HOME"] = "HOME";
    /** A custom page created in the hub editor */ HubPageType["CUSTOM"] = "CUSTOM";
    /** A portal page backed by a JSM portal */ HubPageType["PORTAL"] = "PORTAL";
    return HubPageType;
}({});
const $f77a4e7a25afd233$export$c246174f38c9bde7 = (pageId)=>{
    if (!pageId) return "HOME";
    if (pageId.startsWith($f77a4e7a25afd233$var$PORTAL_PAGE_PREFIX)) return "PORTAL";
    return "CUSTOM";
};
const $f77a4e7a25afd233$export$646dda995799f7d5 = (pageId)=>$f77a4e7a25afd233$export$c246174f38c9bde7(pageId) === "PORTAL";
const $f77a4e7a25afd233$export$fef05bffd39d3ca1 = (pageId)=>{
    if (!$f77a4e7a25afd233$export$646dda995799f7d5(pageId)) return '';
    return pageId.slice($f77a4e7a25afd233$var$PORTAL_PAGE_PREFIX.length);
};
const $f77a4e7a25afd233$export$9d2b62eb20639695 = (helpCenterAri, portalPageId)=>{
    const meta = $f77a4e7a25afd233$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return '';
    const { activationId: activationId, helpCenterId: helpCenterId } = meta;
    return `ari:cloud:help::page/${activationId}/${portalPageId}/${helpCenterId}`;
};
const $f77a4e7a25afd233$export$c0ca1e0679075a3 = (parsedPageId, helpCenterAri)=>{
    const meta = $f77a4e7a25afd233$var$getSafeHelpCenterIdMeta(helpCenterAri);
    if (!meta) return false;
    return parsedPageId === meta.helpCenterId;
};
const $f77a4e7a25afd233$export$bec70b043200c466 = (pageId, filteredPages, helpCenterAri, currentPageName)=>{
    const pageType = $f77a4e7a25afd233$export$c246174f38c9bde7(pageId);
    if (pageType === "PORTAL") return {
        pageType: pageType,
        isHomePage: false,
        pageAri: $f77a4e7a25afd233$export$9d2b62eb20639695(helpCenterAri, pageId),
        pageName: currentPageName || ''
    };
    if (pageType === "CUSTOM") {
        const matchedPage = filteredPages.find((page)=>{
            var _page$name;
            return ((_page$name = page.name) === null || _page$name === void 0 ? void 0 : _page$name.default) && (0, $8llkI.HelpPageAri).parse(page.id).pageId === pageId;
        });
        if (matchedPage) {
            var _matchedPage$name;
            return {
                pageType: pageType,
                isHomePage: false,
                pageAri: matchedPage.id,
                pageName: ((_matchedPage$name = matchedPage.name) === null || _matchedPage$name === void 0 ? void 0 : _matchedPage$name.default) || ''
            };
        }
    }
    return {
        pageType: "HOME",
        isHomePage: true,
        pageAri: '',
        pageName: ''
    };
};

});



parcelRegister("bjYUA", function(module, exports) {
$parcel$export(module.exports, "HubApp", () => $2a6e42544dfb0163$export$44db4a416180c024);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $lhXNe = parcelRequire("lhXNe");

var $gplQ0 = parcelRequire("gplQ0");

var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");

var $irmNM = parcelRequire("irmNM");

var $glWLN = parcelRequire("glWLN");

var $3H4LK = parcelRequire("3H4LK");

var $cijxS = parcelRequire("cijxS");

var $5qWT2 = parcelRequire("5qWT2");

var $cz6zo = parcelRequire("cz6zo");
var $6xwRI = parcelRequire("6xwRI");
var $gHT3x = parcelRequire("gHT3x");

var $fVpeT = parcelRequire("fVpeT");

var $chtqr = parcelRequire("chtqr");
var $iySE3 = parcelRequire("iySE3");
var $6cpNP = parcelRequire("6cpNP");
var $eNlzS = parcelRequire("eNlzS");
var $36H9J = parcelRequire("36H9J");
var $65BSy = parcelRequire("65BSy");

var $immYM = parcelRequire("immYM");

var $emdL0 = parcelRequire("emdL0");
var $3XewR = parcelRequire("3XewR");

var $cRPo9 = parcelRequire("cRPo9");

var $5GXt7 = parcelRequire("5GXt7");

var $hdGEL = parcelRequire("hdGEL");

var $hj69S = parcelRequire("hj69S");

var $aGzFq = parcelRequire("aGzFq");

var $71qeF = parcelRequire("71qeF");

var $2QadH = parcelRequire("2QadH");

var $7PTaH = parcelRequire("7PTaH");

var $ca43F = parcelRequire("ca43F");

var $gAHz7 = parcelRequire("gAHz7");
const $2a6e42544dfb0163$var$styles = {
    spinnerContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1kxc"
};
const $2a6e42544dfb0163$var$HubInner = ({ appearance: appearance = 'full-page', parsedAdf: parsedAdf, mediaProvider: mediaProvider, providerFactory: providerFactory, extensionHandlers: extensionHandlers, helpCenterData: helpCenterData })=>{
    var _helpCenterData$pages;
    return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $glWLN.MediaClientProvider), {
        clientConfig: mediaProvider.viewMediaClientConfig,
        children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $hdGEL.default), {
            document: parsedAdf,
            appearance: appearance,
            dataProviders: providerFactory,
            product: (0, $6cpNP.helpCenterTypeToProduct)((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || ''),
            additionalExtensionHandlers: extensionHandlers,
            contentId: (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$pages = helpCenterData.pages) === null || _helpCenterData$pages === void 0 || (_helpCenterData$pages = _helpCenterData$pages[0]) === null || _helpCenterData$pages === void 0 ? void 0 : _helpCenterData$pages.id) || '',
            PropsProvider: (0, $fVpeT.CommonHubExtensionsDependenciesProvider)
        })
    });
};
const $2a6e42544dfb0163$var$Hub = ({ queryReference: queryReference, appearance: appearance = 'full-page', showPageNameAsHubDocumentTitle: showPageNameAsHubDocumentTitle = false })=>{
    var _data$helpCenter, _data$helpCenter2, _helpCenterData$pages2, _helpCenterData$pages3, _helpCenterData$pages4, _helpCenterData$helpC, _branding$colors;
    // When the fix flag is ON, `HubAppShell` is rendered one level up in
    // `HubApp` so it stays mounted across page navigations. When the flag is
    // OFF, `Hub` renders `HubAppShell` itself (original behaviour).
    const hubContext = (0, $iySE3.useHubContext)();
    if (!hubContext) throw new Error('HubContext not found. HubBootstrap must be used as a parent component.');
    const { user: user, cloudId: cloudId, env: { helpCenterAri: helpCenterAri } } = hubContext;
    // When the fix flag is ON, `pageMediaConfig` is fetched here (page-scoped)
    // so the bootstrap query stays page-agnostic and is not refetched on every
    // page navigation. When the flag is OFF, `pageMediaConfig` is skipped here
    // and remains on the bootstrap query as before.
    /* eslint-disable @atlassian/relay/unused-fields */ const data = (0, $gIeP2.usePreloadedQuery)((0, $gplQ0.default), queryReference);
    /* eslint-enable @atlassian/relay/unused-fields */ // When the fix flag is ON, read `pageMediaConfig` from the page-scoped
    // hubQuery result. When OFF, it comes from the bootstrap via `hubContext`.
    const pageMediaConfigFromQuery = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.pageMediaConfig;
    const pageMediaConfigFromContext = hubContext.pageMediaConfig;
    const pageMediaConfig = (0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media') ? pageMediaConfigFromQuery : pageMediaConfigFromContext;
    if (!pageMediaConfig) throw new Error('pageMediaConfig not found');
    const { mediaCollectionName: mediaCollectionName, asapIssuer: asapIssuer, mediaToken: mediaToken, mediaUrl: mediaUrl } = pageMediaConfig;
    const helpCenterData = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById;
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'QueryError') throw new Error(`QueryError in hub query: ${helpCenterData.message}`);
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) !== 'HelpCenter') throw new Error('HelpCenter not found in hub query');
    const helpCenterType = (helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.type) || '';
    const title = showPageNameAsHubDocumentTitle && (_helpCenterData$pages2 = helpCenterData.pages) !== null && _helpCenterData$pages2 !== void 0 && (_helpCenterData$pages2 = _helpCenterData$pages2[0]) !== null && _helpCenterData$pages2 !== void 0 && (_helpCenterData$pages2 = _helpCenterData$pages2.name) !== null && _helpCenterData$pages2 !== void 0 && _helpCenterData$pages2.default ? (_helpCenterData$pages3 = helpCenterData.pages) === null || _helpCenterData$pages3 === void 0 || (_helpCenterData$pages3 = _helpCenterData$pages3[0]) === null || _helpCenterData$pages3 === void 0 || (_helpCenterData$pages3 = _helpCenterData$pages3.name) === null || _helpCenterData$pages3 === void 0 ? void 0 : _helpCenterData$pages3.default : '';
    const mediaProvider = (0, $iySE3.getMediaProvider)(mediaCollectionName, asapIssuer, mediaToken, mediaUrl);
    const emojiProvider = (0, $5GXt7.getEmojiProvider)({
        cloudId: queryReference.variables.cloudId,
        // NOTE: id is not yet available in the user object, but will be in the near future
        // as per https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/186871/overview#comment-659373408.
        // userId is optional for getEmojiProvider so just leaving this here for now.
        userId: user.id
    });
    const providerFactory = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        return (0, $irmNM.default).create({
            mediaProvider: Promise.resolve(mediaProvider),
            emojiProvider: Promise.resolve(emojiProvider)
        });
    }, [
        mediaProvider,
        emojiProvider
    ]);
    const layoutAdf = ((_helpCenterData$pages4 = helpCenterData.pages) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4[0]) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.pageLayout) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.layoutAdf) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.content) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.edges) === null || _helpCenterData$pages4 === void 0 || (_helpCenterData$pages4 = _helpCenterData$pages4.map((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.content;
    })) === null || _helpCenterData$pages4 === void 0 ? void 0 : _helpCenterData$pages4.join('')) || '{}';
    const parsedAdf = JSON.parse(layoutAdf);
    // Use product extension handlers hook to get additional handlers for the product
    const extensionHandlers = (0, $aGzFq.useProductExtensionHandlers)({
        contentId: queryReference.variables.hubAri,
        PropsProvider: (0, $fVpeT.CommonHubExtensionsDependenciesProvider),
        product: helpCenterType
    });
    const environment = (0, $hj69S.useRelayEnvironmentProvider)().getEnvironment({});
    const aiWidgetProviderQueryReference = (0, $4fqPo.useMemo)(()=>{
        if (helpCenterType !== 'CUSTOMER_SERVICE') return null;
        return (0, $gIeP2.loadQuery)(environment, (0, $3XewR.default), {
            cloudId: cloudId,
            helpCenterAri: helpCenterAri
        });
    }, [
        helpCenterType,
        environment,
        cloudId,
        helpCenterAri
    ]);
    const navigationBar = (helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.navigationBar) ?? null;
    const { branding: branding } = (0, $iySE3.useHubContext)();
    const brandColor = branding === null || branding === void 0 || (_branding$colors = branding.colors) === null || _branding$colors === void 0 ? void 0 : _branding$colors.primary;
    const navStyleOptions = (0, $4fqPo.useMemo)(()=>({
            options: navigationBar ? (0, $immYM.mapApiToNavigationOptions)(navigationBar, brandColor) : null,
            setOptions: ()=>void 0
        }), [
        navigationBar,
        brandColor
    ]);
    // When the fix flag is ON, re-provide `HubContext` with `pageMediaConfig`
    // from the page-scoped query so descendants can read it via
    // `useHubContext()` without a separate hook. When the flag is OFF the
    // bootstrap already set `pageMediaConfig` on the context, so no
    // re-provision is needed.
    const hubContextWithPageMedia = (0, $4fqPo.useMemo)(()=>({
            ...hubContext,
            pageMediaConfig: pageMediaConfig
        }), [
        hubContext,
        pageMediaConfig
    ]);
    const inner = /*#__PURE__*/ (0, $lhXNe.jsx)((0, $65BSy.NavigationStyleContext).Provider, {
        value: navStyleOptions,
        children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $ca43F.HubsDocumentTitle), {
            title: title,
            shouldRenderDocumentTitle: showPageNameAsHubDocumentTitle,
            children: /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $lhXNe.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lhXNe.jsx)($2a6e42544dfb0163$var$HubInner, {
                        appearance: appearance,
                        parsedAdf: parsedAdf,
                        mediaProvider: mediaProvider,
                        providerFactory: providerFactory,
                        extensionHandlers: extensionHandlers,
                        helpCenterData: helpCenterData
                    }),
                    /*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
                        fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                            name: "ai-corner-agent-renderer-loader"
                        }),
                        children: aiWidgetProviderQueryReference && /*#__PURE__*/ (0, $lhXNe.jsx)((0, $BYXH4.ErrorBoundary), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $emdL0.AiWidgetProvider), {
                                queryReference: aiWidgetProviderQueryReference,
                                children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $7PTaH.AiCornerAgentRenderer), {})
                            })
                        })
                    })
                ]
            })
        })
    });
    // When the fix flag is ON, wrap with a HubContext.Provider that merges
    // in the page-scoped `pageMediaConfig`. When OFF, restore the original
    // behaviour: render `HubAppShell` here (wrapping `inner`) and use the
    // bootstrap context which already has `pageMediaConfig`.
    return (0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media') ? /*#__PURE__*/ (0, $lhXNe.jsx)((0, $iySE3.HubContext).Provider, {
        value: hubContextWithPageMedia,
        children: inner
    }) : /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cRPo9.HubAppShell), {
        children: inner
    });
};
const $2a6e42544dfb0163$export$44db4a416180c024 = (props)=>{
    const { appearance: appearance = 'full-page' } = props;
    const { queryReference: hubPageQueryReference } = (0, $2QadH.useRelayResource)((0, $71qeF.hubPageResource));
    const { queryReference: hubBootstrapQueryReference } = (0, $2QadH.useRelayResource)((0, $71qeF.hubBootstrapResource));
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    if (!hubPageQueryReference || !hubBootstrapQueryReference) return null;
    const cloudId = hubBootstrapQueryReference.variables.cloudId;
    return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $36H9J.HubErrorBoundary), {
        packageName: "hub",
        id: "hub-page",
        fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $chtqr.GenericErrorPage), {}),
        shouldForceError: true,
        operationNames: [
            'hubBootstrapWrapperQuery'
        ],
        children: /*#__PURE__*/ (0, $lhXNe.jsxs)((0, $cz6zo.ContextWrapper), {
            sourceType: (0, $gHT3x.SCREEN),
            sourceName: "hub",
            children: [
                /*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
                    fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                        name: "hub-loader",
                        children: /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                            className: (0, $ltgDR.default)([
                                $2a6e42544dfb0163$var$styles.spinnerContainer
                            ]),
                            children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $5qWT2.default), {
                                size: "large",
                                label: formatMessage((0, $gAHz7.default).hubLoadingSpinnerLabel)
                            })
                        })
                    }),
                    children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $eNlzS.HubBootstrapWrapper), {
                        queryReference: hubBootstrapQueryReference,
                        cloudId: cloudId,
                        ...props,
                        children: (0, $3H4LK.fg)('hubs_fix_rerendering_bootstrap_page_media') ? // Flag ON: HubAppShell lives outside Hub so the app
                        // shell is not remounted on every page navigation.
                        /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cRPo9.HubAppShell), {
                            children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
                                fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                                    name: "hub-loader",
                                    children: /*#__PURE__*/ (0, $lhXNe.jsx)("div", {
                                        className: (0, $ltgDR.default)([
                                            $2a6e42544dfb0163$var$styles.spinnerContainer
                                        ]),
                                        children: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $5qWT2.default), {
                                            size: "large",
                                            label: formatMessage((0, $gAHz7.default).hubLoadingSpinnerLabel)
                                        })
                                    })
                                }),
                                children: /*#__PURE__*/ (0, $lhXNe.jsx)($2a6e42544dfb0163$var$Hub, {
                                    appearance: appearance,
                                    queryReference: hubPageQueryReference,
                                    showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle
                                })
                            })
                        }) : // Flag OFF: original behaviour — Hub renders HubAppShell
                        // internally on every page render.
                        /*#__PURE__*/ (0, $lhXNe.jsx)($2a6e42544dfb0163$var$Hub, {
                            appearance: appearance,
                            queryReference: hubPageQueryReference,
                            showPageNameAsHubDocumentTitle: props === null || props === void 0 ? void 0 : props.showPageNameAsHubDocumentTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $lhXNe.jsx)((0, $6xwRI.FireScreenAnalytics), {})
            ]
        })
    });
};

});
parcelRegister("irmNM", function(module, exports) {
$parcel$export(module.exports, "default", () => $0868d323953a5809$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $0868d323953a5809$var$isUndefined(x) {
    return x === undefined;
}
class $0868d323953a5809$export$2e2bcd8739ae039 {
    static create(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providers) {
        const providerFactory = new $0868d323953a5809$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$0868d323953a5809$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
        return provider;
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("fVpeT", function(module, exports) {
$parcel$export(module.exports, "CommonHubExtensionsDependenciesProvider", () => $62143739d8b72a14$export$93e984eb90009a17);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $Av0cs = parcelRequire("Av0cs");
var $1IhY5 = parcelRequire("1IhY5");
var $dYpMK = parcelRequire("dYpMK");
var $iySE3 = parcelRequire("iySE3");

var $5Vuy8 = parcelRequire("5Vuy8");
const $62143739d8b72a14$export$93e984eb90009a17 = ({ children: children })=>{
    var _branding$colors;
    const { cloudId: cloudId, cloudUrl: cloudUrl, pageMediaConfig: pageMediaConfig, hubMediaConfig: hubMediaConfig, env: env, branding: branding, user: user } = (0, $iySE3.useHubContext)();
    const { hoistedProjectKey: hoistedProjectKey } = env;
    // Advanced theming v2: read derived theming literals from HubThemingContext.
    // The provider is mounted at the HubAppShell level so every consumer reaches
    // the same memoised palette / defaults / swatch map — and the values are
    // SSR-safe hex literals (no --hub-* CSS vars).
    // useHubTheming returns undefined outside the provider, but this provider is
    // only mounted by help-center inside HubBootstrap → provider is in tree.
    // NOTE: must run BEFORE the pageMediaConfig guard below — Rules of Hooks
    // require the same number of hook calls on every render.
    const { defaultParameters: defaultParameters, brandBackgroundColorMap: brandBackgroundColorMap } = (0, $5Vuy8.useHubTheming)();
    // When the fix flag is ON, `pageMediaConfig` is provided by the `Hub`
    // component (via `hubQuery`) via a nested `HubContext.Provider`. When the
    // flag is OFF it comes from the bootstrap. Either way it must be present
    // by the time this provider renders; if it is missing the consumer is
    // mounted in an unsupported position.
    if (!pageMediaConfig) throw new Error("CommonHubExtensionsDependenciesProvider requires `pageMediaConfig` on the HubContext. Ensure this provider is rendered as a descendant of the `Hub` component.");
    const authProvider = (0, $4fqPo.useCallback)(()=>Promise.resolve({
            asapIssuer: pageMediaConfig.asapIssuer,
            token: pageMediaConfig.mediaToken,
            baseUrl: pageMediaConfig.mediaUrl
        }), [
        pageMediaConfig
    ]);
    const createEditorMediaProvider = (0, $4fqPo.useCallback)(async ({ onUploadRejection: onUploadRejection })=>{
        const mediaProvider = {
            uploadParams: {
                collection: pageMediaConfig.mediaCollectionName,
                onUploadRejection: onUploadRejection
            },
            viewMediaClientConfig: {
                authProvider: authProvider
            },
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        };
        return mediaProvider;
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const useMediaConfig = (0, $4fqPo.useCallback)(({ imageSrc: imageSrc })=>{
        return {
            authProvider: authProvider,
            collection: pageMediaConfig.mediaCollectionName,
            fileId: imageSrc
        };
    }, [
        authProvider,
        pageMediaConfig
    ]);
    const contextValue = {
        smartCardProviderComponent: undefined,
        isTargetAudience: ()=>false,
        useSegmentationTargetGroups: ()=>({}),
        isCompanyHub: true,
        // need to pass this true to enable company hub specific extensions
        enableLinkInputInMediaPicker: true,
        cloudId: cloudId,
        cloudUrl: cloudUrl,
        hoistedProjectKey: hoistedProjectKey,
        helpCenterAri: env.helpCenterAri,
        isAdminHubAIEnabled: false,
        linkPickerConfig: {
            linkPickerPlugins: []
        },
        userId: (0, $3H4LK.fg)('fix_user_context_in_hubs') ? user.id : '',
        customMediaConfig: hubMediaConfig,
        createEditorMediaProvider: createEditorMediaProvider,
        useMediaConfig: useMediaConfig,
        branding: {
            ...branding,
            defaultParameters: defaultParameters,
            hideDefaultColorPalette: !!(branding !== null && branding !== void 0 && (_branding$colors = branding.colors) !== null && _branding$colors !== void 0 && _branding$colors.primary),
            brandBackgroundColorMap: brandBackgroundColorMap
        },
        hideExtensionBorders: true,
        showConfigPreambleSupportLink: false,
        enableTargeting: false,
        enableUnifiedSearchFeatures: (0, $3H4LK.fg)('enable_dynamic_cards_for_gday'),
        enableSmartCardsFields: false,
        experienceStopComponent: (0, $Av0cs.HubErrorLogger),
        submitError: (0, $1IhY5.logException)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dYpMK.ProductDependenciesContext).Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("Av0cs", function(module, exports) {
$parcel$export(module.exports, "HubErrorLogger", () => $8d83da51934cdc24$export$9ef862d41b8c7d0f);

var $4fqPo = parcelRequire("4fqPo");

var $9ifhy = parcelRequire("9ifhy");
const $8d83da51934cdc24$export$9ef862d41b8c7d0f = ({ error: error, shouldForceError: shouldForceError })=>{
    const logError = (0, $9ifhy.useUFOReportError)();
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        logError({
            name: (error === null || error === void 0 ? void 0 : error.name) || 'unknown',
            errorMessage: (error === null || error === void 0 ? void 0 : error.message) || '',
            errorStack: (error === null || error === void 0 ? void 0 : error.stack) || '',
            forcedError: shouldForceError
        });
    }, [
        logError,
        error,
        shouldForceError
    ]);
    return null;
};

});

parcelRegister("1IhY5", function(module, exports) {
$parcel$export(module.exports, "logException", () => $e562fa4f158d2e5a$export$f86b2a1a2ce291b3);

var $Bq10O = parcelRequire("Bq10O");
let $e562fa4f158d2e5a$var$Sentry;
const $e562fa4f158d2e5a$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $e562fa4f158d2e5a$export$668f31ea3127f48f = window.BUILD_KEY;

const $e562fa4f158d2e5a$export$f553e8b08ef59d31 = async ()=>{
    if (!$e562fa4f158d2e5a$var$Sentry) $e562fa4f158d2e5a$var$Sentry = Promise.resolve((parcelRequire("8c8XG"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $Bq10O.SENTRY_DSN),
            attachStacktrace: true,
            release: $e562fa4f158d2e5a$export$668f31ea3127f48f || (0, $Bq10O.UNKNOWN_TAG),
            environment: $e562fa4f158d2e5a$export$57570b1603cf6adb()
        });
        return SentryModule;
    }).catch(()=>{});
    return $e562fa4f158d2e5a$var$Sentry;
};
const $e562fa4f158d2e5a$export$f86b2a1a2ce291b3 = async (error)=>{
    try {
        const SentryClient = await $e562fa4f158d2e5a$export$f553e8b08ef59d31();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('product', 'hub');
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};

});
parcelRegister("8c8XG", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $5f766555c3d43ae7$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("75VFm")));

var $d8KcD = parcelRequire("d8KcD");

var $hDt7s = parcelRequire("hDt7s");

var $iwFaq = parcelRequire("iwFaq");
parcelRequire("kzlYU");
var $gLjeB = parcelRequire("gLjeB");

var $loMvo = parcelRequire("loMvo");

var $75VFm = parcelRequire("75VFm");
var $5f766555c3d43ae7$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $5f766555c3d43ae7$var$_window = (0, $gLjeB.getGlobalObject)();
if ($5f766555c3d43ae7$var$_window.Sentry && $5f766555c3d43ae7$var$_window.Sentry.Integrations) $5f766555c3d43ae7$var$windowIntegrations = $5f766555c3d43ae7$var$_window.Sentry.Integrations;
var $5f766555c3d43ae7$export$99d02219d259eb94 = (0, $d8KcD.__assign)((0, $d8KcD.__assign)((0, $d8KcD.__assign)({}, $5f766555c3d43ae7$var$windowIntegrations), (0, $iwFaq)), $loMvo);
$parcel$exportWildcard(module.exports, $hDt7s);

});
parcelRegister("hDt7s", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("ahlU2")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("1Isls")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("ePuex")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("ePuex")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("ePuex")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("ePuex")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("ePuex")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("KhyL6")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("KhyL6")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("KhyL6")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("KhyL6")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("1Isls")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("c8vCZ")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("ePuex")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("l9dIb")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("ePuex")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("ePuex")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("ePuex")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("ePuex")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("ePuex")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("ePuex")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("ePuex")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("3LPRs")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("fIcQk")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("dY1vR")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("dY1vR")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("lVVcj")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("lVVcj")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("lVVcj")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("lVVcj")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("lVVcj")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("lVVcj")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("lVVcj")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("lVVcj")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("lVVcj")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("ghfia")).SDK_NAME);

var $ahlU2 = parcelRequire("ahlU2");

var $ePuex = parcelRequire("ePuex");
var $1Isls = parcelRequire("1Isls");
var $KhyL6 = parcelRequire("KhyL6");
var $l9dIb = parcelRequire("l9dIb");
var $c8vCZ = parcelRequire("c8vCZ");

var $3LPRs = parcelRequire("3LPRs");

var $fIcQk = parcelRequire("fIcQk");

var $dY1vR = parcelRequire("dY1vR");

var $lVVcj = parcelRequire("lVVcj");

var $ghfia = parcelRequire("ghfia");

});
parcelRegister("ghfia", function(module, exports) {
$parcel$export(module.exports, "SDK_NAME", () => $bd9a1889782a930b$export$ca61d37259221480);
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $bd9a1889782a930b$export$ca61d37259221480 = 'sentry.javascript.browser';

});


parcelRegister("loMvo", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("iMRuB")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("k5dhX")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("3uF9Q")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("kWwDh")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("cbP8C")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("dhEHm")).Dedupe);

var $iMRuB = parcelRequire("iMRuB");

var $k5dhX = parcelRequire("k5dhX");

var $3uF9Q = parcelRequire("3uF9Q");

var $kWwDh = parcelRequire("kWwDh");

var $cbP8C = parcelRequire("cbP8C");

var $dhEHm = parcelRequire("dhEHm");

});

parcelRegister("75VFm", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("iiUL0")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("71od0")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("7feBg")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("I9px3")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("4YhAB")).makeNewXHRTransport);

var $iiUL0 = parcelRequire("iiUL0");

var $71od0 = parcelRequire("71od0");

var $7feBg = parcelRequire("7feBg");

var $I9px3 = parcelRequire("I9px3");

var $4YhAB = parcelRequire("4YhAB");

});



parcelRegister("dYpMK", function(module, exports) {
$parcel$export(module.exports, "ProductDependenciesContext", () => $48302c680caf1b31$export$49e1053dfc41d188);
$parcel$export(module.exports, "useProductDependencies", () => $48302c680caf1b31$export$8dcbb40932065737);

var $4fqPo = parcelRequire("4fqPo");
const $48302c680caf1b31$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $48302c680caf1b31$export$774887fcc3922763 = ({ children: children, ...props })=>{
    const defaultValue = (0, $4fqPo.useContext)($48302c680caf1b31$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($48302c680caf1b31$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
function $48302c680caf1b31$export$8dcbb40932065737() {
    const ctx = (0, $4fqPo.useContext)($48302c680caf1b31$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
}

});


parcelRegister("6cpNP", function(module, exports) {
$parcel$export(module.exports, "helpCenterTypeToProduct", () => $a3ae22e08da34cfc$export$cf749f9c25e568e8);
const $a3ae22e08da34cfc$export$cf749f9c25e568e8 = (helpCenterType)=>{
    switch(helpCenterType){
        case 'CUSTOMER_SERVICE':
            return 'CSM';
        case 'HELP_HUB':
            return 'JSM';
        default:
            return 'CSM';
    }
};

});

parcelRegister("emdL0", function(module, exports) {
$parcel$export(module.exports, "AiWidgetProvider", () => $cc921f4cffe604a4$export$963f3fe63ca0f1aa);

var $3XewR = parcelRequire("3XewR");

var $4fqPo = parcelRequire("4fqPo");

var $gIeP2 = parcelRequire("gIeP2");

var $36H9J = parcelRequire("36H9J");
var $iySE3 = parcelRequire("iySE3");

var $qe1mk = parcelRequire("qe1mk");

var $47wMl = parcelRequire("47wMl");
/**
 * Provides AI widget config via context when available.
 * On query failure or invalid data, it falls back to rendering children only.
 */ const $cc921f4cffe604a4$var$AiWidgetProviderInner = ({ queryReference: queryReference, children: children })=>{
    var _data$helpCenter;
    const { cloudId: siteId } = (0, $iySE3.useHubContext)();
    const data = (0, $gIeP2.usePreloadedQuery)((0, $3XewR.default), queryReference);
    const primaryColor = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterById) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.helpCenterBranding) === null || _data$helpCenter === void 0 || (_data$helpCenter = _data$helpCenter.colors) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.primary;
    const widgetConfig = data.csmAi_getSupportWidget;
    const supportWidgetConfig = (0, $4fqPo.useMemo)(()=>{
        if (!widgetConfig || !widgetConfig.id || !widgetConfig.theme || !primaryColor || !siteId) return null;
        return {
            siteId: siteId,
            widgetId: widgetConfig.id,
            widgetTheme: {
                primaryColor: primaryColor,
                radius: (0, $qe1mk.handleWidgetRadiusType)(widgetConfig.theme.radius),
                space: (0, $qe1mk.handleWidgetSpaceType)(widgetConfig.theme.space),
                chatBubbleVariant: (0, $qe1mk.handleChatBubbleVariant)(widgetConfig.theme.chatColor),
                widgetButtonVariant: (0, $qe1mk.handleWidgetButtonVariant)(widgetConfig.theme.colorVibeVariant),
                attribution: null
            },
            widgetPosition: (0, $qe1mk.handleWidgetPosition)(widgetConfig.position),
            isEnabled: Boolean(widgetConfig.isEnabled)
        };
    }, [
        widgetConfig,
        primaryColor,
        siteId
    ]);
    if (!supportWidgetConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $47wMl.AiWidgetConfigProvider), {
        supportWidgetConfig: supportWidgetConfig
    }, children);
};
const $cc921f4cffe604a4$export$963f3fe63ca0f1aa = ({ queryReference: queryReference, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $36H9J.HubErrorBoundary), {
        packageName: "@atlassian/csm-ai-search-trigger",
        id: "AiWidgetProvider",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($cc921f4cffe604a4$var$AiWidgetProviderInner, {
        queryReference: queryReference
    }, children));
};

});
parcelRegister("3XewR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7068e3049a528b5d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a2eb8409e14d8125227a3ef3f45225d9>>
 * @relayHash d24b4ad1a97ccd24bce6bb96d6c01dac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c
const $7068e3049a528b5d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiWidgetProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "2e88bfb638882023f3cc1a09ab0c61a86c228f3bc54710b3f1082519e7e4a32c",
            "metadata": {},
            "name": "aiWidgetProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7068e3049a528b5d$var$node.hash = "cc0a8c3c2e0c2ac2a4e32f0440175bfe";
var $7068e3049a528b5d$export$2e2bcd8739ae039 = $7068e3049a528b5d$var$node;

});

parcelRegister("qe1mk", function(module, exports) {
$parcel$export(module.exports, "handleWidgetRadiusType", () => $10a3fef70e8a5a84$export$21feeed55533391b);
$parcel$export(module.exports, "handleWidgetSpaceType", () => $10a3fef70e8a5a84$export$882cd7667f1dc36b);
$parcel$export(module.exports, "handleWidgetPosition", () => $10a3fef70e8a5a84$export$565c45f827c88f12);
$parcel$export(module.exports, "handleChatBubbleVariant", () => $10a3fef70e8a5a84$export$8d7135a196764ba5);
$parcel$export(module.exports, "handleWidgetButtonVariant", () => $10a3fef70e8a5a84$export$1e1d4315fa0edb5);
const $10a3fef70e8a5a84$export$21feeed55533391b = (radius)=>{
    switch(radius){
        case 'ROUNDED':
            return 'rounded';
        case 'SHARP':
            return 'sharp';
        case 'NORMAL':
        default:
            return 'normal';
    }
};
const $10a3fef70e8a5a84$export$882cd7667f1dc36b = (space)=>{
    switch(space){
        case 'COSY':
            return 'cosy';
        case 'GENEROUS':
            return 'generous';
        case 'COMFORTABLE':
        default:
            return 'comfortable';
    }
};
const $10a3fef70e8a5a84$export$565c45f827c88f12 = (position)=>{
    switch(position){
        case 'CENTER':
            return 'CENTER';
        case 'CORNER':
        default:
            return 'CORNER';
    }
};
const $10a3fef70e8a5a84$export$8d7135a196764ba5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'default';
    }
};
const $10a3fef70e8a5a84$export$1e1d4315fa0edb5 = (variant)=>{
    switch(variant){
        case 'LIGHT':
            return 'light';
        case 'DARK':
            return 'dark';
        case 'VIBRANT':
            return 'vibrant';
        case 'DEFAULT':
        default:
            return 'dark';
    }
};

});

parcelRegister("47wMl", function(module, exports) {
$parcel$export(module.exports, "AiWidgetConfigProvider", () => $5ef54a0f3c36541d$export$6e44feab0c163a95);
$parcel$export(module.exports, "useOptionalAiWidgetConfig", () => $5ef54a0f3c36541d$export$ab391f3a63cacd0);
$parcel$export(module.exports, "useAiWidgetConfig", () => $5ef54a0f3c36541d$export$91842e2b4fccaca6);

var $4fqPo = parcelRequire("4fqPo");
const $5ef54a0f3c36541d$var$AiWidgetConfigContext = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $5ef54a0f3c36541d$export$6e44feab0c163a95 = ({ supportWidgetConfig: supportWidgetConfig, children: children })=>{
    const [value] = (0, $4fqPo.useState)({
        supportWidgetConfig: supportWidgetConfig
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5ef54a0f3c36541d$var$AiWidgetConfigContext.Provider, {
        value: value
    }, children);
};
const $5ef54a0f3c36541d$export$ab391f3a63cacd0 = ()=>{
    return (0, $4fqPo.useContext)($5ef54a0f3c36541d$var$AiWidgetConfigContext);
};
const $5ef54a0f3c36541d$export$91842e2b4fccaca6 = ()=>{
    const contextValue = (0, $4fqPo.useContext)($5ef54a0f3c36541d$var$AiWidgetConfigContext);
    if (!contextValue) throw new Error('useSuppportWidgetConfig must be used within a AiWidgetConfigProvider');
    return contextValue;
};

});


parcelRegister("5GXt7", function(module, exports) {
$parcel$export(module.exports, "getEmojiProvider", () => $035201c7f0cdaaf1$export$8210f5f78c0bcf27);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $gOwLM = parcelRequire("gOwLM");

var $dit2x = parcelRequire("dit2x");
const $035201c7f0cdaaf1$var$BASE_URL = '/gateway/api/emoji';
const $035201c7f0cdaaf1$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$035201c7f0cdaaf1$var$BASE_URL}/standard`
        },
        {
            url: `${$035201c7f0cdaaf1$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$035201c7f0cdaaf1$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $035201c7f0cdaaf1$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? '';
    const disableUpload = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload) ?? false;
    const emojiSSRConfigString = extraConfig !== null && extraConfig !== void 0 && extraConfig.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $035201c7f0cdaaf1$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($gOwLM)))((extraConfig)=>{
    const cloudId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.cloudId) ?? '';
    const userId = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.userId) ?? undefined;
    const disableUpload = extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.disableUpload;
    const emojiSSRConfig = (extraConfig === null || extraConfig === void 0 ? void 0 : extraConfig.emojiSSRConfig) ?? undefined;
    const emojiConfig = $035201c7f0cdaaf1$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $dit2x.default)(emojiConfig);
}, $035201c7f0cdaaf1$var$resolverOfMemoize);
const $035201c7f0cdaaf1$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($gOwLM)))((extraConfig)=>{
    const emojiResource = $035201c7f0cdaaf1$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $035201c7f0cdaaf1$var$resolverOfMemoize);

});
parcelRegister("dit2x", function(module, exports) {
$parcel$export(module.exports, "supportsUploadFeature", () => $42e68fa34a746f03$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $42e68fa34a746f03$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");
parcelRequire("bmlEo");
var $kIsb0 = parcelRequire("kIsb0");
var $bmlEo = parcelRequire("bmlEo");

var $kTZWy = parcelRequire("kTZWy");

var $34lPY = parcelRequire("34lPY");

var $l8Hvo = parcelRequire("l8Hvo");

var $cdgs8 = parcelRequire("cdgs8");

var $jAzfF = parcelRequire("jAzfF");

var $958kb = parcelRequire("958kb");

var $5aeTt = parcelRequire("5aeTt");

var $kjnfk = parcelRequire("kjnfk");

var $2UatR = parcelRequire("2UatR");

var $judSF = parcelRequire("judSF");
const $42e68fa34a746f03$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $42e68fa34a746f03$export$b5efafc6dd611ec5 extends (0, $kIsb0.AbstractResource) {
    constructor(config){
        super(), this.activeLoaders = 0, this.initialLoaders = 0, this.retries = new Map(), this.isInitialised = false, this.fetchOnDemand = false, this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        }, this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        }, this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        const rewriteEmojiGatewayPath = (url)=>url.replace('/gateway/api/emoji', '/gateway/api/elements/emoji');
        const stargateEmojiPathEnabled = (0, $3H4LK.fg)('use-elements-stargate-emoji-path');
        const singleEmojiApi = config.singleEmojiApi;
        const optimisticImageApi = config.optimisticImageApi;
        this.emojiProviderConfig = stargateEmojiPathEnabled ? {
            ...config,
            providers: config.providers.map((provider)=>({
                    ...provider,
                    url: rewriteEmojiGatewayPath(provider.url)
                })),
            singleEmojiApi: singleEmojiApi ? {
                ...singleEmojiApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(singleEmojiApi.getUrl(emojiId))
            } : undefined,
            optimisticImageApi: optimisticImageApi ? {
                ...optimisticImageApi,
                getUrl: (emojiId)=>rewriteEmojiGatewayPath(optimisticImageApi.getUrl(emojiId))
            } : undefined
        } : config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $cdgs8.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
   * Get the emoji provider from Emoji Resource
   * @returns Promise<EmojiProvider>
   */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $34lPY.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $2UatR.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $kTZWy.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $2UatR.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $958kb.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $2UatR.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $2UatR.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $34lPY.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $958kb.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $jAzfF.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $jAzfF.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $jAzfF.ProviderTypes).ATLASSIAN;
        return (0, $jAzfF.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $5aeTt.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $kjnfk.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $l8Hvo.isPromise)(done)) return done.then(()=>{
                    (0, $34lPY.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $34lPY.default)('Failed to prime siteEmojiResource');
                });
                else (0, $34lPY.default)('Already primed siteEmojiResource');
            } else (0, $34lPY.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $l8Hvo.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $kTZWy.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
   *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
   */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $l8Hvo.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $l8Hvo.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $l8Hvo.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $2UatR.ufoExperiences)['emoji-searched'].start();
        (0, $2UatR.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: (query === null || query === void 0 ? void 0 : query.length) || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $2UatR.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: (options === null || options === void 0 ? void 0 : options.source) || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    /**
   * Synchronously reads the emoji type from the local cache for the given emojiId.
   * Returns `undefined` when the emoji is not in the cache or no repository is initialised.
   * This is a pure cache read — no network requests are made.
   */ getCachedEmojiType(emojiId) {
        if (!this.isRepositoryAvailable(this.emojiRepository)) return undefined;
        const { id: id, shortName: shortName } = emojiId;
        if (id) {
            const emoji = this.emojiRepository.findById(id);
            if (emoji) return emoji.type;
        }
        if (shortName) {
            const result = this.emojiRepository.findByShortName(shortName);
            if (result && !('then' in result)) return result.type;
        }
        return undefined;
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
   * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
   * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
   * for the purposes of tracking the frequency of use.
   *
   * @param emoji The full description of the emoji to record usage for.
   */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $l8Hvo.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $bmlEo.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $cdgs8.default)('localStorage')) try {
            window.localStorage.setItem((0, $kTZWy.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $42e68fa34a746f03$export$2e2bcd8739ae039 extends $42e68fa34a746f03$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false, timeout = (0, $3H4LK.fg)('increase-emoji-client-upload-timeout') ? 30000 : 12000) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            const uploadPromise = this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
            return (0, $judSF.promiseWithTimeout)(uploadPromise, timeout, 'uploadCustomEmoji timed out');
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("bmlEo", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("kIsb0")).AbstractResource);
$parcel$export(module.exports, "utils", () => $d2a38ad3fbe36602$export$eab97d15b1788b8d);
parcelRequire("24Yyp");
parcelRequire("kIsb0");

var $iS79f = parcelRequire("iS79f");

var $4dJSj = parcelRequire("4dJSj");
const $d2a38ad3fbe36602$export$eab97d15b1788b8d = $iS79f;
const $d2a38ad3fbe36602$export$3b4c04cf7dad0e50 = $4dJSj;

});
parcelRegister("24Yyp", function(module, exports) {
$parcel$export(module.exports, "buildCredentials", () => $89ab091ef8299ca9$export$2ac26f1ab7eda637);
const $89ab091ef8299ca9$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("kIsb0", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => $e077aa6c5eff65d2$export$4529f10aed0950d4);
class $e077aa6c5eff65d2$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("iS79f", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => $214a65a699f7467d$export$4f34edf253146101);
$parcel$export(module.exports, "requestService", () => $214a65a699f7467d$export$97bfde5a702aaeca);

var $bqHVm = parcelRequire("bqHVm");

var $24Yyp = parcelRequire("24Yyp");

var $8EFE4 = parcelRequire("8EFE4");
const $214a65a699f7467d$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $214a65a699f7467d$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $214a65a699f7467d$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
const $214a65a699f7467d$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $8EFE4.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $8EFE4.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $8EFE4.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $24Yyp.buildCredentials)(secOptions);
    const ignoreResponsePayload = (options === null || options === void 0 ? void 0 : options.ignoreResponsePayload) || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $bqHVm.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options !== null && options !== void 0 && options.reportTracingHeaders) {
            const tracingHeaders = $214a65a699f7467d$export$4f34edf253146101(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $214a65a699f7467d$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});
parcelRegister("8EFE4", function(module, exports) {
$parcel$export(module.exports, "defaultRequestServiceOptions", () => $d5bd51a7aa140301$export$160dbda113bfad3b);
$parcel$export(module.exports, "buildUrl", () => $d5bd51a7aa140301$export$b5cd97dee32de81d);
$parcel$export(module.exports, "buildHeaders", () => $d5bd51a7aa140301$export$7d6ed858a91629c3);
const $d5bd51a7aa140301$export$160dbda113bfad3b = {};
const $d5bd51a7aa140301$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $d5bd51a7aa140301$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $d5bd51a7aa140301$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $d5bd51a7aa140301$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $d5bd51a7aa140301$var$addToHeaders(headers, secOptions.headers);
    return headers;
};

});


parcelRegister("4dJSj", function(module, exports) {
$parcel$export(module.exports, "requestServiceMultipart", () => $f49764b0516c682c$export$8b13532c81e8ac89);

var $kykZf = parcelRequire("kykZf");

var $24Yyp = parcelRequire("24Yyp");

var $8EFE4 = parcelRequire("8EFE4");

var $bqHVm = parcelRequire("bqHVm");
const $f49764b0516c682c$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $8EFE4.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $8EFE4.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $8EFE4.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $24Yyp.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $bqHVm.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $kykZf.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $f49764b0516c682c$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};

});
parcelRegister("kykZf", function(module, exports) {
$parcel$export(module.exports, "meros", () => $ef6743331782ec5a$export$74e0a034be2368c7);
var $ef6743331782ec5a$var$e = new TextDecoder;
async function $ef6743331782ec5a$export$74e0a034be2368c7(t, n) {
    if (!t.ok || !t.body || t.bodyUsed) return t;
    let i = t.headers.get("content-type");
    if (!i || !~i.indexOf("multipart/")) return t;
    let l = i.indexOf("boundary="), r = "-";
    if (~l) {
        let e = l + 9, t = i.indexOf(";", e);
        r = i.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(t, n, i) {
        let l, r, d, o = t.getReader(), a = !i || !i.multiple, f = n.length, s = "", c = [];
        try {
            let t;
            e: for(; !(t = await o.read()).done;){
                let i = $ef6743331782ec5a$var$e.decode(t.value);
                l = s.length, s += i;
                let o = i.indexOf(n);
                for(~o ? l += o : l = s.indexOf(n), c = []; ~l;){
                    let e = s.slice(0, l), t = s.slice(l + f);
                    if (r) {
                        let n = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", n), l = !1, r = e.slice(n, i > -1 ? void 0 : i), o = String(e.slice(0, n)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; d = o[--s]; d = d.split(": "), f[d.shift().toLowerCase()] = d.join(": "));
                        if (d = f["content-type"], d && ~d.indexOf("application/json")) try {
                            r = JSON.parse(r), l = !0;
                        } catch (e) {}
                        if (d = {
                            headers: f,
                            body: r,
                            json: l
                        }, a ? yield d : c.push(d), "--" === t.slice(0, 2)) break e;
                    } else n = "\r\n" + n, r = f += 2;
                    s = t, l = s.indexOf(n);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(t.body, `--${r}`, n);
}

});



parcelRegister("kTZWy", function(module, exports) {
$parcel$export(module.exports, "customCategory", () => $72a953ea7cfef42f$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $72a953ea7cfef42f$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $72a953ea7cfef42f$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $72a953ea7cfef42f$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $72a953ea7cfef42f$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $72a953ea7cfef42f$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $72a953ea7cfef42f$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $72a953ea7cfef42f$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $72a953ea7cfef42f$export$1a817f1886276c6d);
$parcel$export(module.exports, "scaledEmojiHeightH1", () => $72a953ea7cfef42f$export$2e7088017339c92);
$parcel$export(module.exports, "scaledEmojiHeightH2", () => $72a953ea7cfef42f$export$4cb591b57c224c0);
$parcel$export(module.exports, "scaledEmojiHeightH3", () => $72a953ea7cfef42f$export$b31a41e904161dc1);
$parcel$export(module.exports, "scaledEmojiHeightH4", () => $72a953ea7cfef42f$export$7dd039b460c61389);
$parcel$export(module.exports, "denseEmojiHeightH1", () => $72a953ea7cfef42f$export$96ee6614460413a0);
$parcel$export(module.exports, "denseEmojiHeightH2", () => $72a953ea7cfef42f$export$103771a4cd74af90);
$parcel$export(module.exports, "denseEmojiHeightH3", () => $72a953ea7cfef42f$export$5cc2afcf38309ce9);
$parcel$export(module.exports, "denseEmojiHeightH4", () => $72a953ea7cfef42f$export$9a9984214a4bd724);
$parcel$export(module.exports, "defaultEmojiHeight", () => $72a953ea7cfef42f$export$3f99ac31dc0406db);
$parcel$export(module.exports, "defaultDenseEmojiHeight", () => $72a953ea7cfef42f$export$8efb414216030943);
$parcel$export(module.exports, "defaultInlineEmojiHeight", () => $72a953ea7cfef42f$export$4adebc94e462aea5);
$parcel$export(module.exports, "emojiPickerWidth", () => $72a953ea7cfef42f$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $72a953ea7cfef42f$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $72a953ea7cfef42f$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerListHeight", () => $72a953ea7cfef42f$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerListHeightNew", () => $72a953ea7cfef42f$export$9f36457335d8859f);
$parcel$export(module.exports, "localStoragePrefix", () => $72a953ea7cfef42f$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $72a953ea7cfef42f$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "selectedProductivityColorStorageKey", () => $72a953ea7cfef42f$export$ec5e3f6f684720d7);
$parcel$export(module.exports, "defaultCategories", () => $72a953ea7cfef42f$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $72a953ea7cfef42f$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $72a953ea7cfef42f$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $72a953ea7cfef42f$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $72a953ea7cfef42f$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $72a953ea7cfef42f$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $72a953ea7cfef42f$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $72a953ea7cfef42f$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $72a953ea7cfef42f$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $72a953ea7cfef42f$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $72a953ea7cfef42f$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $72a953ea7cfef42f$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $72a953ea7cfef42f$export$66cabad5e268b05e);
const $72a953ea7cfef42f$export$5e4e3d1c3e43156a = 'CUSTOM';
const $72a953ea7cfef42f$export$78ccdc4be403c468 = 'FREQUENT';
const $72a953ea7cfef42f$export$2c4b04c3aacdf1b3 = 'SITE';
const $72a953ea7cfef42f$export$1b0258512be88334 = 'SEARCH';
const $72a953ea7cfef42f$export$42b510423367f354 = 'USER_CUSTOM';
const $72a953ea7cfef42f$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $72a953ea7cfef42f$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $72a953ea7cfef42f$export$8ac325bfd32359b0 = 'data:';
const $72a953ea7cfef42f$export$a330961542edfe6f = 'delete-emoji';
const $72a953ea7cfef42f$export$1a817f1886276c6d = 100000;
const $72a953ea7cfef42f$export$2e7088017339c92 = 28;
const $72a953ea7cfef42f$export$4cb591b57c224c0 = 26;
const $72a953ea7cfef42f$export$b31a41e904161dc1 = 24;
const $72a953ea7cfef42f$export$7dd039b460c61389 = 22;
const $72a953ea7cfef42f$export$96ee6614460413a0 = 24.25;
const $72a953ea7cfef42f$export$103771a4cd74af90 = 22.25;
const $72a953ea7cfef42f$export$5cc2afcf38309ce9 = 20.25;
const $72a953ea7cfef42f$export$9a9984214a4bd724 = 18.25;
const $72a953ea7cfef42f$export$3f99ac31dc0406db = 20;
const $72a953ea7cfef42f$export$8efb414216030943 = 16.25;
const $72a953ea7cfef42f$export$4adebc94e462aea5 = 16;
const $72a953ea7cfef42f$export$d171dc12fee2b1da = 350;
const $72a953ea7cfef42f$export$c10ac8125a260041 = 80;
const $72a953ea7cfef42f$export$5248fb9e0cccc41f = 'medium';
const $72a953ea7cfef42f$export$94f75d625e7801d3 = 260;
const $72a953ea7cfef42f$export$7ed599d166d65aea = 295;
const $72a953ea7cfef42f$export$7722b8e9522021df = $72a953ea7cfef42f$export$7ed599d166d65aea - 58; // picker height - actions height
const $72a953ea7cfef42f$export$9f36457335d8859f = $72a953ea7cfef42f$export$7ed599d166d65aea - 102; // picker height - actions height - preview height
const $72a953ea7cfef42f$export$e218e5cb105a0e22 = 54;
const $72a953ea7cfef42f$export$e67f617938b111f1 = $72a953ea7cfef42f$export$7ed599d166d65aea + $72a953ea7cfef42f$export$e218e5cb105a0e22;
const $72a953ea7cfef42f$export$e394a0c530ae5631 = 'fabric.emoji';
const $72a953ea7cfef42f$export$79ee4ef84c545f8f = `${$72a953ea7cfef42f$export$e394a0c530ae5631}.selectedTone`;
const $72a953ea7cfef42f$export$ec5e3f6f684720d7 = `${$72a953ea7cfef42f$export$e394a0c530ae5631}.selectedProductivityColor`;
const $72a953ea7cfef42f$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $72a953ea7cfef42f$export$70f9e5bc10d7eac = /*#__PURE__*/ function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
    return KeyboardKeys;
}({});
var $72a953ea7cfef42f$export$1c4f2adc1f8e19d3 = /*#__PURE__*/ function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
    return KeyboardNavigationDirection;
}({});
const $72a953ea7cfef42f$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $72a953ea7cfef42f$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $72a953ea7cfef42f$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $72a953ea7cfef42f$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $72a953ea7cfef42f$export$4f0ee90b28d6efc5 = 0;
const $72a953ea7cfef42f$export$9f7de4293d27f3aa = 50;
const $72a953ea7cfef42f$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $72a953ea7cfef42f$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $72a953ea7cfef42f$export$2829f3ec323f8ec0 = 8;
const $72a953ea7cfef42f$export$ce3a0e7d2d7d6ba2 = 5;
const $72a953ea7cfef42f$export$858e8dc100a97278 = 150;
const $72a953ea7cfef42f$export$83aab2ae64548423 = 20;
const $72a953ea7cfef42f$export$66cabad5e268b05e = 100;

});

parcelRegister("34lPY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a64282bce75f3ab9$export$2e2bcd8739ae039);
let $a64282bce75f3ab9$var$debugEnabled = false;
let $a64282bce75f3ab9$var$stacktracesEnabled = false;
function $a64282bce75f3ab9$export$748ada60eaf985cc(enable) {
    $a64282bce75f3ab9$var$debugEnabled = enable;
}
function $a64282bce75f3ab9$export$4f7017086af31c25(enable) {
    $a64282bce75f3ab9$var$stacktracesEnabled = enable;
}
function $a64282bce75f3ab9$export$2a858f450a2f66d() {
    if ($a64282bce75f3ab9$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $a64282bce75f3ab9$export$2e2bcd8739ae039(msg, ...args) {
    if ($a64282bce75f3ab9$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("l8Hvo", function(module, exports) {
$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $eef44a084f2a958f$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $eef44a084f2a958f$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $eef44a084f2a958f$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $eef44a084f2a958f$export$979133dc1df141c6);
$parcel$export(module.exports, "isUnicodeRepresentation", () => $eef44a084f2a958f$export$607f0d89b8881fb4);
$parcel$export(module.exports, "isPromise", () => $eef44a084f2a958f$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $eef44a084f2a958f$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $eef44a084f2a958f$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $eef44a084f2a958f$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $eef44a084f2a958f$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $eef44a084f2a958f$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $eef44a084f2a958f$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $eef44a084f2a958f$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $eef44a084f2a958f$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $eef44a084f2a958f$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $eef44a084f2a958f$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $eef44a084f2a958f$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $eef44a084f2a958f$export$4bcbf61cb6832a8e);

var $bIKgK = parcelRequire("bIKgK");

var $kTZWy = parcelRequire("kTZWy");
const $eef44a084f2a958f$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $eef44a084f2a958f$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $eef44a084f2a958f$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $eef44a084f2a958f$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $eef44a084f2a958f$export$607f0d89b8881fb4 = (rep)=>!!(rep && rep.unicodeEmoji);
const $eef44a084f2a958f$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $eef44a084f2a958f$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $eef44a084f2a958f$export$a7e82c67204c73a1 = (emoji)=>$eef44a084f2a958f$export$979133dc1df141c6(emoji.representation);
const $eef44a084f2a958f$export$7720a4954d6f75f8 = (rep)=>$eef44a084f2a958f$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $kTZWy.dataURLPrefix)) === 0;
const $eef44a084f2a958f$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $kTZWy.customCategory) && $eef44a084f2a958f$export$7720a4954d6f75f8(emoji.representation);
const $eef44a084f2a958f$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $eef44a084f2a958f$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $eef44a084f2a958f$export$dddfba07c16c94d2 = (key)=>key in (0, $bIKgK.messages);
const $eef44a084f2a958f$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $eef44a084f2a958f$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $eef44a084f2a958f$export$8d7d3de6b5b305d1(emoji);
};
const $eef44a084f2a958f$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $eef44a084f2a958f$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($eef44a084f2a958f$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $eef44a084f2a958f$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $eef44a084f2a958f$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $eef44a084f2a958f$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$eef44a084f2a958f$export$979133dc1df141c6(mediaRepresentation) && !$eef44a084f2a958f$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $eef44a084f2a958f$export$979133dc1df141c6(mediaRepresentation) ? $eef44a084f2a958f$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $eef44a084f2a958f$export$979133dc1df141c6(mediaAltRepresentation) ? $eef44a084f2a958f$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $eef44a084f2a958f$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $eef44a084f2a958f$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $eef44a084f2a958f$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("bIKgK", function(module, exports) {
$parcel$export(module.exports, "messages", () => $cd6f4bad7069d46d$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $cd6f4bad7069d46d$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Heading text shown at the top of the emoji removal confirmation dialog, prompting the user to confirm removing the selected custom emoji.'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Body text shown inside the emoji removal confirmation dialog. The placeholder {emojiShortName} will be substituted with the short name (e.g. ":smile:") of the replacement emoji.'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Label for the primary action button in the emoji removal confirmation dialog that confirms and executes the removal.'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Label for the button in the emoji picker that opens the custom emoji upload panel, allowing users to add their own emoji.'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiNameLabel: {
        id: 'fabric.emoji.name.label',
        defaultMessage: 'Emoji name',
        description: 'Label for the emoji name input field in the custom emoji upload panel'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select an image file for their emoji.'
    },
    emojiChooseFileDndTitle: {
        id: 'fabric.emoji.choose.file.dnd.title',
        defaultMessage: 'Select or drop an image',
        description: 'Label for the file chooser button in the custom emoji upload panel where users select or drag and drop an image file for their emoji.'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectColorButtonAriaLabelText: {
        id: 'fabric.emoji.select.color.ariaLabel',
        defaultMessage: 'Productivity emoji color selector',
        description: 'Message indicating the purpose of the color selection button and the selected color'
    },
    emojiSelectColorListAriaLabelText: {
        id: 'fabric.emoji.select.color.list.ariaLabel',
        defaultMessage: 'Productivity emoji colour selector',
        description: 'Message indicating the purpose of the productivity emoji color list selector'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Section heading shown above the emoji preview area in the custom emoji upload panel.'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Success text shown in the emoji preview area after the user uploads a new emoji image. The placeholder {emoji} will be substituted with the rendered emoji image.'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'Label for the submit button in the custom emoji upload panel that saves the new emoji to the workspace.'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'Label for the button in the custom emoji upload panel that retries a previously failed upload attempt.'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'Label for the cancel button in the custom emoji upload panel that dismisses the panel without saving.'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text shown inside the emoji search input field in the emoji picker before the user types a query.'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'Accessible label for the emoji name search input field in the emoji picker, used by screen readers.'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status.count',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Category heading label shown in the emoji picker category bar when displaying results from a search query.'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Label for the Frequent category tab in the emoji picker, showing recently used emojis.'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Label for the People category tab in the emoji picker, showing face and person emojis.'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Label for the Nature category tab in the emoji picker, showing animal and nature emojis.'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Label for the Food and Drink category tab in the emoji picker.'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Label for the Activity category tab in the emoji picker, showing sports and activity emojis.'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Label for the Travel and Places category tab in the emoji picker, showing location and travel emojis.'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Label for the Objects category tab in the emoji picker, showing everyday object emojis.'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Label for the Symbols category tab in the emoji picker, showing symbol and sign emojis.'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Label for the Flags category tab in the emoji picker, showing country and regional flag emojis.'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Atlassian & productivity',
        description: 'Label for the Atlassian and productivity category tab in the emoji picker, showing Atlassian product and productivity emojis.'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'Label for the Your Uploads category tab in the emoji picker, showing custom emojis uploaded by the current user.'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'Label for the All Uploads category tab in the emoji picker, showing all custom emojis uploaded across the workspace.'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails due to an error.'
    },
    emojiUploadTimeout: {
        id: 'fabric.emoji.error.upload.timeout',
        defaultMessage: 'Upload timed out',
        description: 'Error message shown in the custom emoji upload panel when the image upload fails because it timed out.'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiUnsupportedFileType: {
        id: 'fabric.emoji.error.unsupported.file.type',
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji.",
        description: 'Error message shown when the selected emoji upload file type is not supported'
    },
    emojiDuplicateName: {
        id: 'fabric.emoji.error.duplicate.name',
        defaultMessage: 'An emoji with this name exists already',
        description: 'Error message shown when the user tries to upload an emoji with a name that already exists in the custom emoji set'
    },
    emojiPickerNoResults: {
        id: 'fabric.emoji.picker.no.results',
        defaultMessage: 'No results',
        description: 'Heading shown in the emoji picker when a search query returns no matching emojis.'
    },
    emojiPickerAddCustomEmoji: {
        id: 'fabric.emoji.picker.add.custom.emoji',
        defaultMessage: 'Add custom emoji',
        description: 'Label for the button shown in the emoji picker no-results screen that opens the custom emoji upload panel.'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Accessible aria-label for the emoji picker dialog, used by screen readers to identify the picker.'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    changeEmojiShortnameButtonLabel: {
        id: 'fabric.emoji.change.shortname.button.label',
        defaultMessage: 'Change emoji, currently {shortName}',
        description: 'Aria label for the button in page title used to change emoji'
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("cdgs8", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c1d33675c3a7b0$export$2e2bcd8739ae039);
function $53c1d33675c3a7b0$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("jAzfF", function(module, exports) {
$parcel$export(module.exports, "SearchSort", () => $a7bf4e6e5dd5f7c4$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $a7bf4e6e5dd5f7c4$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $a7bf4e6e5dd5f7c4$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $a7bf4e6e5dd5f7c4$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $a7bf4e6e5dd5f7c4$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $a7bf4e6e5dd5f7c4$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $a7bf4e6e5dd5f7c4$export$482549d945a3723);
var $a7bf4e6e5dd5f7c4$export$a15e9a4340d08b2e = /*#__PURE__*/ function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
    return SearchSort;
}({});
var $a7bf4e6e5dd5f7c4$export$db41220f541db607 = /*#__PURE__*/ function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
    return SearchSourceTypes;
}({});
var $a7bf4e6e5dd5f7c4$export$bf337c9223e5c8b = /*#__PURE__*/ function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
    return ProviderTypes;
}({});
var $a7bf4e6e5dd5f7c4$export$d0d1c9cd31a11a64 = /*#__PURE__*/ function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
    return UfoExperienceName;
}({});
var $a7bf4e6e5dd5f7c4$export$122ce5c8fda96269 = /*#__PURE__*/ function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
    return UfoComponentName;
}({});
var $a7bf4e6e5dd5f7c4$export$265ee18146a6885e = /*#__PURE__*/ function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
    return UfoEmojiTimingsKeys;
}({});
var $a7bf4e6e5dd5f7c4$export$482549d945a3723 = /*#__PURE__*/ function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
    return UfoEmojiTimings;
}({});

});

parcelRegister("958kb", function(module, exports) {
$parcel$export(module.exports, "default", () => $3774eda170879939$export$2e2bcd8739ae039);

var $6Rmzc = parcelRequire("6Rmzc");
class $3774eda170879939$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
   * Returns a promise with an array of Emoji from all providers.
   */ loadEmoji() {
        const emojisPromise = (0, $6Rmzc.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $6Rmzc.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("6Rmzc", function(module, exports) {
$parcel$export(module.exports, "emojiRequest", () => $a7c55e318db14aba$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $a7c55e318db14aba$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $a7c55e318db14aba$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $a7c55e318db14aba$export$b7e9058f156d8d19);

var $bmlEo = parcelRequire("bmlEo");

var $4mqcS = parcelRequire("4mqcS");

var $jAzfF = parcelRequire("jAzfF");

var $l8Hvo = parcelRequire("l8Hvo");

var $34lPY = parcelRequire("34lPY");

var $3H4LK = parcelRequire("3H4LK");

var $7YytE = parcelRequire("7YytE");
const $a7c55e318db14aba$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $a7c55e318db14aba$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $a7c55e318db14aba$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $bmlEo.utils).requestService(serviceConfig, requestOptions);
};
const $a7c55e318db14aba$var$calculateScale = (getRatio)=>{
    if ((0, $4mqcS.expValEquals)('platform_editor_emoji_default_scale', 'isEnabled', true)) {
        // retina display
        if (getRatio() > 1) return {
            scale: 'XXXHDPI',
            altScale: 'XXXHDPI'
        };
        // default set used for desktop
        return {
            altScale: 'XXXHDPI'
        };
    }
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $a7c55e318db14aba$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $a7c55e318db14aba$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$a7c55e318db14aba$var$calculateScale($a7c55e318db14aba$export$d39ce20a37bba061).altScale];
};
const $a7c55e318db14aba$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $a7c55e318db14aba$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $l8Hvo.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $l8Hvo.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($a7c55e318db14aba$export$db05e6ae1fd416af(imagePath, meta)) return (0, $l8Hvo.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $34lPY.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $a7c55e318db14aba$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $a7c55e318db14aba$export$55077db3efc820aa($a7c55e318db14aba$export$4a0301d636367e1d(altReps), meta);
};
const $a7c55e318db14aba$var$denormaliseStandardRepresentation = (emoji, meta)=>{
    const unicodeEmoji = (0, $7YytE.emojiIdToEmoji)(emoji.id);
    const useUnicodeRepresentation = !!(emoji.id && emoji.type === (0, $jAzfF.ProviderTypes).STANDARD && unicodeEmoji && (0, $3H4LK.fg)('platform_twemoji_removal_unicode_emojis'));
    return useUnicodeRepresentation ? {
        unicodeEmoji: unicodeEmoji
    } : $a7c55e318db14aba$export$55077db3efc820aa(emoji.representation, meta);
};
const $a7c55e318db14aba$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: _representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $a7c55e318db14aba$var$denormaliseStandardRepresentation(skin, meta),
            altRepresentation: $a7c55e318db14aba$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $a7c55e318db14aba$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $a7c55e318db14aba$var$denormaliseStandardRepresentation(emoji, emojiData.meta);
        const altRepresentation = $a7c55e318db14aba$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $a7c55e318db14aba$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: _representation, skinVariations: _skinVariations, altRepresentations: _altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $l8Hvo.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $a7c55e318db14aba$var$getHeight = (fitToHeight)=>$a7c55e318db14aba$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $a7c55e318db14aba$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $a7c55e318db14aba$var$getHeight(fitToHeight) > emoji.representation.height);

});
parcelRegister("4mqcS", function(module, exports) {
$parcel$export(module.exports, "expValEquals", () => $b775660c054d6e9b$export$45abdb3f977b5b14);

var $6nD91 = parcelRequire("6nD91");
function $b775660c054d6e9b$export$45abdb3f977b5b14(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $6nD91.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, true);
}

});
parcelRegister("6nD91", function(module, exports) {
$parcel$export(module.exports, "expValEqualsInternal", () => $0f5c17eff99b5c31$export$58e581060588c6bb);

var $6bGmX = parcelRequire("6bGmX");

var $lLCH0 = parcelRequire("lLCH0");

var $dzlHl = parcelRequire("dzlHl");

var $cdqux = parcelRequire("cdqux");
// This internal representation doesn't currently support productKeys
// the way expVal(...) does, this adds temporary support for some keys while
// we determine our preferred approach forward
const $0f5c17eff99b5c31$var$allowsProductKeys = [
    'cc-maui-experiment'
];
function $0f5c17eff99b5c31$export$58e581060588c6bb(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, experimentExposure) {
    var _editorExperimentsCon;
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $cdqux._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $cdqux._overrides)[experimentName] === experimentExpectedValue;
    // If client is not initialized, we compare with the default value
    if (!(0, $6bGmX.default).initializeCompleted()) return experimentDefaultValue === experimentExpectedValue;
    // Typescript is complaining here about accessing the productKeys property
    const experimentKeyName = $0f5c17eff99b5c31$var$allowsProductKeys.includes(experimentName) ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ((_editorExperimentsCon = (0, $dzlHl.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 || (_editorExperimentsCon = _editorExperimentsCon.productKeys) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon[0, $cdqux._product]) ?? experimentName : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $6bGmX.default).getExperimentValue(experimentKeyName, experimentParam, experimentDefaultValue, {
        fireExperimentExposure: experimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $6bGmX.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $lLCH0.addFeatureFlagAccessed)(`${experimentKeyName}:${experimentParam}`, experimentValue);
    return experimentValue === experimentExpectedValue;
}

});
parcelRegister("dzlHl", function(module, exports) {
$parcel$export(module.exports, "disallowsProductKeys", () => $57d6d67d0fe1eb62$export$5c897d5297c5b7fd);
$parcel$export(module.exports, "editorExperimentsConfig", () => $57d6d67d0fe1eb62$export$6cbb856f286b07ef);
/* eslint-disable perfectionist/sort-object-types */ /* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6b46y = parcelRequire("6b46y");
const $57d6d67d0fe1eb62$export$5c897d5297c5b7fd = [
    'platform_editor_block_menu',
    'platform_editor_blocks',
    'platform_editor_controls',
    'platform_editor_preview_panel_linking_exp',
    'platform_synced_block',
    'smart_link_confluence_short_link_analytics',
    'platform_editor_static_css',
    'advanced_layouts',
    'single_column_layouts',
    'platform_editor_preview_panel_responsiveness',
    'platform_editor_toolbar_aifc',
    'platform_editor_ignore_metadata_connection_errors',
    'comment_on_bodied_extensions'
];
const $57d6d67d0fe1eb62$export$6cbb856f286b07ef = {
    // new format to avoid collisions with other users when updating the file
    // Added 2026-06-09
    remix_button_right_margin_hover: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_button_right_margin_hover'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Editor Platform experiments
    // lwoollard experiments
    // Added 2026-02-11
    ai_speech_to_text_in_editor: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'ai_speech_to_text_in_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-21
    cwr_page_tree_auto_finalize: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_page_tree_auto_finalize'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-08
    aifc_space_typesettings: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc_space_typesettings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 22-12-2025
    confluence_load_editor_title_on_transition: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_load_editor_title_on_transition'
        },
        param: 'contentPlaceholder',
        defaultValue: false
    }),
    // Added 02-12-2025
    cc_fix_hydration_ttvc: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_fix_hydration_ttvc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    'editor_a11y__enghealth-46814_fy26': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y__enghealth-46814_fy26'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 03-09-2025
    cc_editor_interactivity_monitoring: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_interactivity_monitoring'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-03
    editor_tinymce_full_width_mode: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_tinymce_full_width_mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 05-03-2026
    platform_editor_ai_headingautocomplete: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_headingautocomplete'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_remove_important_in_render_ext: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_important_in_render_ext'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-10
    confluence_max_width_content_appearance: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_content_appearance'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-15
    confluence_max_width_breakout_extension_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_max_width_breakout_extension_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_quick_insert_embeds: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_quick_insert_embeds'
        },
        param: 'cohort',
        values: [
            'control',
            'prioritizeLinkInQIM',
            'prioritizeEmbedInQIM'
        ],
        defaultValue: 'control'
    }),
    confluence_remix_icon_right_side: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_remix_icon_right_side'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_editor_insm_doc_size_stats: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_doc_size_stats'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    cc_editor_fix_insm_inp_buffer: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_editor_fix_insm_inp_buffer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    cwr_blank_object_experiment: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr_blank_object_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    rovo_remix_experience_context: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'rovo_remix_experience_context'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    'agent-managed_blocks_mvp': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'agent-managed_blocks_mvp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    'databases-native-embeds-v2': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'databases-native-embeds-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-30
    cc_editor_insm_outlier_events: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_insm_outlier_events'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-7
    platform_editor_table_sticky_header_patch_10: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_10'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-17
    platform_editor_renderer_extension_width_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_extension_width_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    platform_editor_table_col_insert: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_col_insert',
            jira: 'platform_editor_table_col_insert'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_media_reliability_observability: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_observability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_media_external_badge_bbc_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_external_badge_bbc_fix',
            bitbucket: 'platform_editor_media_external_badge_bbc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-20
    platform_editor_annotations_sync_on_docchange: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_annotations_sync_on_docchange'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-27
    platform_editor_reduce_noisy_steps_ncs: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_reduce_noisy_steps_ncs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-boolean': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_react19_migration: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_react19_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_per_plugin_error_boundary: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_per_plugin_error_boundary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    'company_hub_carousel_thumbnails-refactor': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'company_hub_carousel_thumbnails-refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05 - gates DOM mutation observer for experience tracking (toolbar + block menu)
    platform_editor_experience_tracking_observer: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_experience_tracking_observer',
            jira: 'platform_editor_experience_tracking_observer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-26
    platform_editor_prevent_toolbar_layout_shifts: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_toolbar_layout_shifts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_paste_actions_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_editor_ssr_streaming: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_ssr_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_controls_reliable_anchor: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_reliable_anchor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls',
            jira: 'platform_editor_controls_jira'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-03-02
    platform_editor_inline_card_dispatch_guard: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_inline_card_dispatch_guard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_agent_mentions: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_agent_mentions',
            jira: 'platform_editor_agent_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-31
    platform_editor_lovability_suppress_toolbar_event: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_suppress_toolbar_event',
            jira: 'platform_editor_lovability_suppress_toolbar_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-02
    platform_editor_layout_keywords: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_keywords',
            jira: 'platform_editor_layout_keywords'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_display_mode_in_to_dom: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_display_mode_in_to_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-10
    platform_editor_no_cursor_on_edit_page_init: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_no_cursor_on_edit_page_init'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-12
    platform_editor_confluence_base_preset: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_confluence_base_preset'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_clean_up_widget_mark_logic: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_clean_up_widget_mark_logic',
            jira: 'platform_editor_clean_up_widget_mark_logic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_code_block_q4_lovability: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_q4_lovability',
            jira: 'platform_editor_code_block_q4_lovability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-14
    platform_editor_debounce_portal_provider: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_debounce_portal_provider'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_renderer_shadow_observer_cleanup: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_renderer_shadow_observer_cleanup',
            confluence: 'platform_editor_renderer_shadow_observer_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-08 - Jira work sync description comment summary
    'jira-work-sync-desc-comment-summary': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-work-sync-desc-comment-summary'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-15
    platform_editor_breakout_resizing: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_resizing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-17
    platform_editor_aifc_sync_block_stream_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_sync_block_stream_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-17-03
    platform_editor_media_name_fallback: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    platform_editor_media_name_fallback_viewer_card: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_name_fallback_viewer_card'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-05
    platform_editor_block_controls_perf_optimization: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_controls_perf_optimization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-16
    platform_editor_enable_single_player_step_merging: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enable_single_player_step_merging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_hide_overflow_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_hide_overflow_menu',
            jira: 'platform_editor_toolbar_hide_overflow_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-02
    platform_editor_code_block_fold_gutter: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_code_block_fold_gutter'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-24
    platform_editor_find_and_replace_improvements: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_find_and_replace_improvements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-06-26
    platform_editor_feedback_mandatory_rating: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_feedback_mandatory_rating'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-15
    platform_editor_preview_panel_responsiveness: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_preview_panels_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_preview_panel_linking_exp: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_preview_panel_linking_exp_conf',
            jira: 'platform_editor_preview_panel_linking_exp_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-05
    platform_editor_table_update_table_ref: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_update_table_ref'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27
    platform_editor_table_excerpts_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_excerpts_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-17
    platform_hover_card_preview_panel: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_hover_card_preview_panel',
            jira: 'platform_hover_card_preview_panel'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-09-17
    // Added 2025-11-25
    smart_link_confluence_short_link_analytics: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'smart-link-confluence-short-link-analytics',
            jira: 'smart-link-confluence-short-link-analytics'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-30 (QS-9895)
    linking_platform_track_non_primary_3p_clicks: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'linking_platform_track_non_primary_3p_clicks',
            jira: 'linking_platform_track_non_primary_3p_clicks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025--8-05
    platform_editor_block_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_block_menu',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-09
    platform_editor_blocks: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocks_conf',
            jira: 'platform_editor_blocks_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-23
    //Added 2025-07-16
    platform_editor_toolbar_aifc: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_aifc_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-31
    platform_editor_breakout_interaction_rerender: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_breakout_interaction_rerender'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_comment_editor_border_radius: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_editor_border_radius'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-26
    platform_editor_perf_lint_cleanup: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_perf_lint_cleanup'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-07-30
    platform_editor_blocktaskitem_node_tenantid: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_node_tenantid'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-08
    platform_editor_blocktaskitem_patch_1: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blocktaskitem_patch_1'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-11
    platform_editor_native_embeds: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_embeds'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_native_anchor_with_dnd: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_native_anchor_with_dnd'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    'editor-a11y-fy26-keyboard-move-row-column': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor-a11y-fy26-keyboard-move-row-column',
            jira: 'editor-a11y-fy26-keyboard-move-row-column'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-28
    editor_enable_image_alignment_in_expand: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_enable_image_alignment_in_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-05
    platform_editor_august_a11y: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_august_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-10
    platform_synced_block: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block',
            jira: 'platform_synced_block_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_synced_block_use_new_source_nodeview: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_synced_block_use_new_source_nodeview',
            jira: 'platform_synced_block_use_new_source_nodeview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-08-18
    platform_editor_locale_datepicker: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_locale_datepicker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-16
    platform_editor_prevent_taskitem_remount: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_prevent_taskitem_remount'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-08
    platform_editor_table_toolbar_perf_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_toolbar_perf_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-09-01
    cc_editor_ai_content_mode: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_editor_ai_content_mode'
        },
        param: 'variant',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-01-09
    platform_editor_render_bodied_extension_as_inline: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_render_bodied_extension_as_inline'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-03
    platform_editor_ai_quick_prompt_iw_cc: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_quick_prompt_iw_cc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-04
    confluence_compact_text_format: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_compact_text_format'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_abort_ufo_on_user_interaction: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_abort_ufo_on_user_interaction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-10
    platform_use_llm_space_recommendations: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_use_llm_space_recommendations'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-01
    // Added 2025-10-13
    platform_editor_media_error_analytics: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_error_analytics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-22
    platform_editor_remove_bidi_char_warning: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_bidi_char_warning'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-27
    platform_editor_table_sticky_header_improvements: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_improvements'
        },
        param: 'cohort',
        values: [
            'control',
            'test_with_overflow',
            'test_without_overflow'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-11-04
    platform_editor_disable_lazy_load_media: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_disable_lazy_load_media'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-10-29
    platform_editor_lovability_inline_code: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_inline_code'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-05
    platform_editor_lovability_emoji_scaling: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_emoji_scaling'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_flex_based_centering: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flex_based_centering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    editor_a11y_7152_profile_card_tab_order: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_7152_profile_card_tab_order'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-11-19
    platform_editor_lovability_navigation_fixes: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_navigation_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-17 - 3P auth Rovo actions on smart link hover card (boolean: isEnabled)
    platform_sl_3p_auth_rovo_action: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_action',
            jira: 'platform_sl_3p_auth_rovo_action'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-27 — Pre-auth unauthorised inline hover card UX
    platform_sl_3p_preauth_better_hovercard: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_better_hovercard',
            jira: 'platform_sl_3p_preauth_better_hovercard'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-29 — Inline rovo action on resolved inline smart links
    platform_sl_3p_auth_inline_tailored_cta: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_inline_tailored_cta',
            jira: 'platform_sl_3p_auth_inline_tailored_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16 — Use link-extractors inline icon extraction for Confluence 1P/3P connection byline
    confluence_1p_and_3p_connection_byline_experiment: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_1p_and_3p_connection_byline_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21 — Post-auth GDrive Smart Link to Rovo Chat auto-open
    platform_sl_3p_post_auth_chat_open_exp: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_post_auth_chat_open_exp',
            jira: 'platform_sl_3p_post_auth_chat_open_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-29 — Social proof inline CTA for unauthorised 3P inline smart links
    platform_sl_3p_preauth_social_proof_inline_cta: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_preauth_social_proof_inline_cta',
            jira: 'platform_sl_3p_preauth_social_proof_inline_cta'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01 — Block card rovo action on resolved block card smart links in confluence
    platform_sl_3p_auth_rovo_block_card_confluence: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_sl_3p_auth_rovo_block_card_confluence'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-23
    platform_editor_to_use_pmr_for_collab_edit_none_ic: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_to_use_pmr_for_collab_edit_none_ic'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-16
    platform_editor_inline_media_replacement: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_inline_media_replacement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-08
    platform_editor_add_image_editing: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_add_image_editing'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_toolbar_submenu_open_click: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_toolbar_submenu_open_click'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-30
    platform_editor_table_sticky_header_patch_9: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_sticky_header_patch_9'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-13
    platform_editor_hide_extension_renderer_support: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hide_extension_renderer_support'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-12-22
    platform_editor_sample_renderer_rendered_event: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sample_renderer_rendered_event'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-21
    platform_editor_copy_link_a11y_inconsistency_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_copy_link_a11y_inconsistency_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-25
    platform_editor_expand_paste_in_comment_editor: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_expand_paste_in_comment_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-16
    platform_editor_ai_fix_insert_after_selection: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_insert_after_selection'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-07
    platform_editor_ai_move_node: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_move_node'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-27 - AI create-page expand collapse fix
    platform_editor_aifc_expand_collapses_oncreate_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_aifc_expand_collapses_oncreate_fix',
            jira: 'platform_editor_aifc_expand_collapses_oncreate_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_ai_loading_responsive_width: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_loading_responsive_width',
            jira: 'platform_editor_ai_loading_responsive_width'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-22
    platform_editor_nested_drag_handle_icon: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_drag_handle_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-23
    collab_bypass_out_of_sync_period_experiment: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'collab_bypass_out_of_sync_period_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-16
    platform_editor_ignore_metadata_connection_errors: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_collab_provider_suppress_metadata_errors'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-18
    platform_editor_table_a11y_eslint_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_a11y_eslint_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-29
    platform_editor_renderer_toolbar_updates: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_toolbar_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-30
    platform_editor_fix_cross_origin_editor_focus: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_cross_origin_editor_focus'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_comment_rovoinlinechat_improvement: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_rovoinlinechat_improvement'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    confluence_ttvc_inline_extensions: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_ttvc_inline_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-03
    platform_editor_enghealth_a11y_jan_fixes: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_enghealth_a11y_jan_fixes'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-05
    cc_fd_db_top_editor_toolbar: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_db_top_editor_toolbar'
        },
        param: 'cohort',
        values: [
            'control',
            'new-description',
            'orig-description'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-04-02
    cc_fd_cwr_quick_insert: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'cc_fd_cwr_quick_insert'
        },
        param: 'cohort',
        values: [
            'control',
            'slot-four',
            'slot-two'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-02-05 - A11Y-10416
    editor_a11y_role_textbox: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_a11y_role_textbox'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-01-28
    platform_editor_smartlink_local_cache: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_smartlink_local_cache'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    platform_rovo_page_comment_selector_full_width: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_page_comment_selector_full_width'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_bodiedextension_layoutshift_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_bodiedextension_layoutshift_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_fix_advanced_codeblocks_crlf_patch: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_advanced_codeblocks_crlf_patch',
            jira: 'platform_editor_fix_advanced_codeblocks_crlf_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    cc_page_experiences_editor_image_generation: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_editor_image_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-17
    cc_page_experiences_premium_macros_img_generation: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_page_experiences_premium_macros_img_generation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-02
    aifc_page_create_with_rovo_include_infographics: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'aifc_page_create_with_rovo_include_infographics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-23
    'cc-maui-experiment': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-experiment',
            jira: 'jira_maui_remix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    'cc-maui-ai-edit-loading-experiment': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-maui-ai-edit-loading-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    'cc-mui-slides-experiment': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-mui-slides-experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    confluence_frontend_cwr_outcome_type_picker: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_frontend_cwr_outcome_type_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    cfe_cwr_outcome_picker_respect_site_settings: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cfe_cwr_outcome_picker_respect_site_settings'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-12
    prompt_tile_content_type_localizaiton: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'prompt_tile_content_type_localizaiton'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    confluence_fe_cwr_outcome_picker_prompt_autoselect: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_cwr_outcome_picker_prompt_autoselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    'cwr-modal-ui-refresh': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-modal-ui-refresh'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    'cc-disambiguation-in-cwr': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-disambiguation-in-cwr'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    'cwr-reduce-prompt-suggestion-max-chars': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-reduce-prompt-suggestion-max-chars'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    'cwr-staging-area-close-as-minimize-button': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cwr-staging-area-close-as-minimize-button'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-12
    platform_editor_a11y_escape_link_dialog: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_escape_link_dialog',
            jira: 'platform_editor_a11y_escape_link_dialog'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_expand_icon: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_expand_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_panel_icon: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_panel_icon'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_vc90_transition_mentions: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vc90_transition_mentions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-19
    platform_editor_flexible_list_indentation: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_indentation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_flexible_list_schema: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_flexible_list_schema'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-24
    platform_editor_emoji_default_scale: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_emoji_default_scale',
            jira: 'platform_editor_emoji_default_scale'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_teamoji_26_refresh_emoji_picker: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_teamoji_26_refresh_emoji_picker',
            jira: 'platform_teamoji_26_refresh_emoji_picker'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-26
    platform_editor_toolbar_update_jira_config: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_toolbar_update_jira_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-02-27
    platform_editor_early_exit_return_draft: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_early_exit_return_draft'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-02
    platform_editor_discarded_unified_analytic_events: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_discarded_unified_analytic_events',
            jira: 'platform_editor_discarded_unified_analytic_events'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    platform_editor_appearance_shared_state: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_appearance_shared_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_ai_blockmenu_integration: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_blockmenu_integration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-26
    platform_editor_remix_in_block_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remix_in_block_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-19 — fix table text length calculation for Remix/Improve Writing hero prompts
    remix_iw_block_menu_table_calc_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'remix_iw_block_menu_table_calc_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added for space shortcut plugin: when on, space shortcut is not added if AI opt-in is not enabled
    platform_editor_ai_aifc_space_shortcut_patch: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_aifc_space_shortcut_patch'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    platform_editor_rovobutton_smartlink_toolbar_exp: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_rovobutton_smartlink_toolbar_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-02
    platform_editor_ai_smartlink_toolbar_v2_exp: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_smartlink_toolbar_v2_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_a11y_scrollable_region: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_a11y_scrollable_region'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-04
    confluence_fe_renderer_inline_node_mark_color_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_renderer_inline_node_mark_color_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-05
    cc_drag_and_drop_smart_link_from_content_to_tree: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_drag_and_drop_smart_link_from_content_to_tree'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_small_font_size: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_small_font_size',
            jira: 'platform_editor_small_font_size'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_diff_plugin_extended: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_diff_plugin_extended'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-10
    platform_editor_fix_media_toolbar_border_dropdown: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_media_toolbar_border_dropdown'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-06
    platform_editor_single_player_expand: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_player_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_auto_convert: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_auto_convert'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_fit_to_content_on_demand: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_fit_to_content_on_demand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-09
    platform_editor_remove_collab_step_metrics: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_remove_collab_step_metrics'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_editor_centre_content_on_find: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_editor_centre_content_on_find'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    platform_editor_close_expand_find: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_close_expand_find'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-24
    platform_editor_table_ref_optimisation: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_ref_optimisation'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-20
    platform_editor_chromeless_expand_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_chromeless_expand_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_ai_normalized_telemetry: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_normalized_telemetry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-13
    platform_editor_misaligned_ai_screens_firefox_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_misaligned_ai_screens_firefox_fix',
            jira: 'platform_editor_misaligned_ai_screens_firefox_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_stricter_panelcolor_typecheck: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_stricter_panelcolor_typecheck'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-15
    platform_editor_sync_block_ssr_config: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_sync_block_ssr_config'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-06
    confluence_fe_create_page_suggestion: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_create_page_suggestion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-18
    platform_editor_selection_toolbar_block_handle: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_selection_toolbar_block_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-23
    confluence_toc_nav_a11y: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_toc_nav_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-25
    platform_editor_improve_preset_builder_logging: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_improve_preset_builder_logging'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_user_preference_override: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_user_preference_override'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    'cc-markdown-mode': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc-markdown-mode'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_spotlight_migration: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_spotlight_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-30
    platform_editor_ai_xstate_migration: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_xstate_migration'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    platform_editor_ai_multi_format_streaming: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_multi_format_streaming'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-03-31
    platform_editor_dnd_accessibility_fixes_expand: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_dnd_accessibility_fixes_expand'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_expand_content_a11y: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_expand_content_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-15
    platform_editor_ai_no_stream_skip_pacer: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_no_stream_skip_pacer'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_layout_column_resize_handle: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_resize_handle'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-07
    platform_editor_layout_column_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_layout_column_valign_rendering: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_column_valign_rendering'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21
    platform_editor_layout_typeahead_reorder: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_layout_typeahead_reorder',
            jira: 'platform_editor_layout_typeahead_reorder'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-09
    platform_editor_fix_selection_wrapped_media_embed: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_selection_wrapped_media_embed',
            jira: 'platform_editor_fix_selection_wrapped_media_embed'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-11
    platform_editor_external_embed_grid_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_external_embed_grid_fix',
            jira: 'platform_editor_external_embed_grid_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    cc_fd_wb_jira_quick_insert_experiment: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'cc_fd_wb_jira_quick_insert_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    improve_3p_smart_link_resolve_rate: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'improve_3p_smart_link_resolve_rate'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    platform_editor_hydration_skip_react_portal: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_hydration_skip_react_portal'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-08
    platform_editor_drag_handle_keyboard_a11y: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_drag_handle_keyboard_a11y'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-01
    show_mentions_in_suggest_reply: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'show_mentions_in_suggest_reply'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-28
    platform_editor_use_markdown_plus_parser: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_markdown_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_use_html_plus_parser: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-10
    platform_editor_static_css: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    platform_editor_core_static_css: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_core_non_ecc_static_css: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_non_ecc_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_renderer_static_css: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_renderer_static_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-12
    platform_editor_media_reliability_enhancements: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_media_reliability_enhancements'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_table_q4_loveability: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_q4_loveability',
            jira: 'platform_editor_table_q4_loveability'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11
    platform_editor_table_menu_updates: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_menu_updates',
            jira: 'platform_editor_table_menu_updates'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-02
    platform_editor_macro_placeholder_array_guard: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_macro_placeholder_array_guard',
            jira: 'platform_editor_macro_placeholder_array_guard'
        },
        param: 'isEnabled',
        defaultValue: true
    }),
    platform_editor_table_close_cell_menu_on_move_exp: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_close_cell_menu_on_move_exp',
            jira: 'platform_editor_table_close_cell_menu_on_move_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-14
    platform_editor_ai_rename_add_polish: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_rename_add_polish'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-16
    cc_dnd_smart_link_changeboard_platform_css: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_dnd_smart_link_changeboard_platform_css'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-22
    platform_editor_ai_screen_layout_refactor: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_screen_layout_refactor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-23
    work_item_modernization: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'work_item_modernization'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21
    platform_editor_fix_a11y_tab_focus_insertion_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_a11y_tab_focus_insertion_menu',
            jira: 'platform_editor_fix_a11y_tab_focus_insertion_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    confluence_fe_disable_comment_if_offline_fix: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_fe_disable_comment_if_offline_fix'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-22
    platform_editor_korean_characters_split: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_korean_characters_split'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-24
    platform_editor_ai_fix_error_discard_screen: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_fix_error_discard_screen'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-05
    editor_synced_block_perf: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_synced_block_perf'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-17
    platform_editor_ai_template_localids: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_template_localids'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-20
    platform_editor_ai_tablecell_localids: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_tablecell_localids'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-05
    fix_copy_paste_external_media_renderer_to_editor: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'fix_copy_paste_external_media_renderer_to_editor',
            jira: 'fix_copy_paste_external_media_renderer_to_editor'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-04-30
    platform_editor_insert_menu_ai: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_insert_menu_ai',
            jira: 'platform_editor_insert_menu_ai'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_paste_actions_menu_v2: (0, $6b46y.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_paste_actions_menu_v2',
            jira: 'platform_editor_paste_actions_menu_v2'
        },
        param: 'variant',
        values: [
            'control',
            'hasSpellingAndGrammar',
            'hasAltAiActions'
        ],
        defaultValue: 'control'
    }),
    // Added 2026-05-04
    platform_editor_show_diff_fix_missing_attrs: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_show_diff_fix_missing_attrs'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01 — Social proof experiment for unauthorized 3P block cards
    social_proof_3p_unauth_block_exp: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'social_proof_3p_unauth_block_exp',
            jira: 'social_proof_3p_unauth_block_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-06
    'jira-smart-replies-v2': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            jira: 'jira-smart-replies-v2'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_replace_doc/setup
    platform_editor_ai_replace_doc: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_replace_doc'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-18
    platform_editor_nest_table_in_panel: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nest_table_in_panel'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_table_in_panel_paste_fallback: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_table_in_panel_paste_fallback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-20
    platform_editor_default_toolbar_state: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_default_toolbar_state'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_rovo_support_create_inline_comment: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_rovo_support_create_inline_comment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-15
    platform_editor_fix_sticky_header_malfunction: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_fix_sticky_header_malfunction'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-10
    confluence_editor_paste_3p_link_actions_menu: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_paste_3p_link_actions_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-19
    platform_editor_ai_improve_formatting_toolbar: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_improve_formatting_toolbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    'a11y-fixes-week4-may-2026': (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'a11y-fixes-week4-may-2026',
            jira: 'a11y-fixes-week4-may-2026'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-21
    fix_free_gen_prompt_bar_position: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'fix_free_gen_prompt_bar_position'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-25
    // HTML+ v2 incremental tool-call streaming contract — gates the new
    // PartialStreamParserV2 / ToolCallProcessorV2 / AdfChunkStrategyV2 stack
    // in `@atlassian/editor-rovo-bridge`, the `replaceValue` orchestrator
    // action, and the `toolCallsStreaming.supportsProvisionalToolCalls`
    // capability advert on `PageContentCommandResult`.
    platform_editor_use_html_plus_streaming_parser: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_use_html_plus_streaming_parser'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    platform_editor_wide_slash_trigger: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_wide_slash_trigger'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-05-11 — [CCI-15904] New AIFC Editor Experience (Full Page Staging Area + Post Stream Review Toolbar)
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_ai_new_aifc_editor_experience/setup
    platform_editor_ai_new_aifc_editor_experience: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_new_aifc_editor_experience'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    // Gates the `GhostIconWave` animation primitive in
    // `@atlassian/rovo-platform-ui-components` — rendered as a loading cue on
    // Confluence's 3p-in-CWR (Rovo) surfaces. When off the primitive renders
    // nothing.
    confluence_3p_in_cwr_ghost_icons: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-16
    // Gates UI tweaks to the 3p-in-CWR ghost icons (inner icon opacity and the
    // "connect apps" tooltip copy) in the Rovo chat sources pill. When off the
    // existing ghost-icon styling and tooltip are used.
    confluence_3p_in_cwr_ghost_icons_ui_tweaks: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_3p_in_cwr_ghost_icons_ui_tweaks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-01
    platform_editor_lovability_text_bg_color: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_lovability_text_bg_color',
            jira: 'platform_editor_lovability_text_bg_color'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-08
    cc_ai_insert_to_page_rovo_chat_experiment: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_ai_insert_to_page_rovo_chat_experiment'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2026-06-15
    platform_editor_menu_radius_update: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_menu_radius_update',
            jira: 'platform_editor_menu_radius_update'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    cc_smarts_heading_autocomplete_migration: (0, $6b46y.createBooleanExperiment)({
        productKeys: {
            confluence: 'cc_smarts_heading_autocomplete_migration'
        },
        param: 'useCcSmarts',
        defaultValue: false
    })
};

});
parcelRegister("6b46y", function(module, exports) {
$parcel$export(module.exports, "createBooleanExperiment", () => $570cd2409a473612$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $570cd2409a473612$export$fb89e8a786694d1);

var $1aIb4 = parcelRequire("1aIb4");
function $570cd2409a473612$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $1aIb4.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $570cd2409a473612$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        // Maintains the tuple
        typeGuard: (0, $1aIb4.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("1aIb4", function(module, exports) {
$parcel$export(module.exports, "isBoolean", () => $b4753b7d68da9edc$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $b4753b7d68da9edc$export$a9a18ae5ba42aeab);

var $3TFEq = parcelRequire("3TFEq");
var $b4753b7d68da9edc$var$_process, $b4753b7d68da9edc$var$_process2;
function $b4753b7d68da9edc$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $b4753b7d68da9edc$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
   * This is used by test utils to get the variants when running describe.each
   */ if ($b4753b7d68da9edc$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $b4753b7d68da9edc$var$IS_TESTING_ENV = typeof $3TFEq !== 'undefined' && ((($b4753b7d68da9edc$var$_process = $3TFEq) === null || $b4753b7d68da9edc$var$_process === void 0 || ($b4753b7d68da9edc$var$_process = $b4753b7d68da9edc$var$_process.env) === null || $b4753b7d68da9edc$var$_process === void 0 ? void 0 : $b4753b7d68da9edc$var$_process.NODE_ENV) === 'test' || (($b4753b7d68da9edc$var$_process2 = $3TFEq) === null || $b4753b7d68da9edc$var$_process2 === void 0 || ($b4753b7d68da9edc$var$_process2 = $b4753b7d68da9edc$var$_process2.env) === null || $b4753b7d68da9edc$var$_process2 === void 0 ? void 0 : $b4753b7d68da9edc$var$_process2.JEST_WORKER_ID) !== undefined);

});



parcelRegister("cdqux", function(module, exports) {
$parcel$export(module.exports, "_overrides", () => $6a5e4a9a93132eb8$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $6a5e4a9a93132eb8$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $6a5e4a9a93132eb8$export$cf7305fc65acbf0d);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $dzlHl = parcelRequire("dzlHl");

var $2j4WE = parcelRequire("2j4WE");
let $6a5e4a9a93132eb8$export$e5d73bf4f8e2ae96 = {};
let $6a5e4a9a93132eb8$export$4e849416bb5c5b52 = {};
let $6a5e4a9a93132eb8$export$cf7305fc65acbf0d;
function $6a5e4a9a93132eb8$export$1c2b6dbf79eb3560(product, /**
 * Overrides are used to set the group of an experiment for testing purposes.
 * This is useful when you want to test a specific experiment group.
 */ groupOverrides, /**
 * Param overrides are used to set the experiment parameters for testing purposes.
 * This is useful when you want to tweak the experiment parameters for testing.
 */ paramOverrides, options) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $dzlHl.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $6a5e4a9a93132eb8$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    if (product === 'test' && !(options !== null && options !== void 0 && options.disableTestOverrides)) {
        // Enforce expectation - file overrides, then global overrides, then default to true for boolean
        // experiments, then last result use the default value
        const testOverrides = Object.fromEntries(Object.entries((0, $dzlHl.editorExperimentsConfig)).map(([key, value])=>{
            var _groupOverrides;
            const defaultValue = typeof value.defaultValue === 'boolean' ? true : value.defaultValue;
            return [
                key,
                ((_groupOverrides = groupOverrides) === null || _groupOverrides === void 0 ? void 0 : _groupOverrides[key]) ?? (0, $2j4WE.testMultivariateOverrides)[key] ?? (0, $2j4WE.testBooleanOverrides)[key] ?? defaultValue
            ];
        }));
        $6a5e4a9a93132eb8$export$e5d73bf4f8e2ae96 = testOverrides;
    }
    $6a5e4a9a93132eb8$export$cf7305fc65acbf0d = product;
    $6a5e4a9a93132eb8$export$4e849416bb5c5b52 = paramOverrides || {};
}

});
parcelRegister("2j4WE", function(module, exports) {
$parcel$export(module.exports, "testMultivariateOverrides", () => $6e660408ba73fcf4$export$7e849a84a00ffd1c);
$parcel$export(module.exports, "testBooleanOverrides", () => $6e660408ba73fcf4$export$54960937bb713f97);
const $6e660408ba73fcf4$export$7e849a84a00ffd1c = {
    'example-multivariate': 'one',
    'platform_editor_ai-prompts-placeholder': 'control',
    platform_editor_controls: 'control',
    cc_editor_ai_content_mode: 'control',
    platform_hover_card_preview_panel: 'control',
    smart_link_confluence_short_link_analytics: 'control',
    cc_editor_insm_outlier_events: 'test',
    platform_editor_table_sticky_header_improvements: 'test_with_overflow',
    cc_fd_db_top_editor_toolbar: 'control',
    cc_fd_cwr_quick_insert: 'control',
    platform_editor_paste_actions_menu_v2: 'control',
    confluence_quick_insert_embeds: 'control'
};
const $6e660408ba73fcf4$export$54960937bb713f97 = {
    'cc-maui-ai-edit-loading-experiment': true,
    social_proof_3p_unauth_block_exp: false,
    linking_platform_track_non_primary_3p_clicks: false,
    platform_sl_3p_auth_rovo_action: false,
    platform_sl_3p_preauth_better_hovercard: true,
    cwr_blank_object_experiment: false,
    platform_editor_feedback_mandatory_rating: false,
    platform_editor_preview_panel_responsiveness: false,
    platform_editor_toolbar_aifc: false,
    'test-new-experiments-package': false,
    platform_editor_exp_lazy_node_views: false,
    platform_renderer_table_sticky_scrollbar: false,
    platform_editor_prevent_toolbar_layout_shifts: false,
    comment_on_bodied_extensions: false,
    advanced_layouts: false,
    single_column_layouts: false,
    platform_editor_ai_unsplash_page_header: false,
    platform_editor_blockquote_in_text_formatting_menu: false,
    platform_editor_ai_edit_response_in_preview: false,
    platform_editor_offline_editing_web: false,
    platform_editor_tables_drag_and_drop: false,
    platform_editor_tables_table_selector: false,
    platform_renderer_fix_analytics_memo_callback: false,
    platform_editor_no_cursor_on_edit_page_init: false,
    'jira-work-sync-desc-comment-summary': false,
    platform_editor_breakout_resizing: false,
    platform_editor_block_controls_perf_optimization: false,
    platform_editor_enable_single_player_step_merging: false,
    platform_editor_find_and_replace_improvements: false,
    platform_editor_reduce_noisy_steps_ncs: false,
    confluence_compact_text_format: false,
    platform_editor_paste_actions_menu: false,
    platform_editor_diff_plugin_extended: false,
    platform_editor_ai_rename_add_polish: false,
    platform_editor_table_fit_to_content_on_demand: false,
    platform_editor_table_fit_to_content_auto_convert: false,
    platform_editor_table_q4_loveability: false,
    platform_editor_table_menu_updates: false,
    platform_editor_core_static_css: false,
    'cwr-modal-ui-refresh': false,
    'cc-disambiguation-in-cwr': false,
    'cwr-reduce-prompt-suggestion-max-chars': false,
    'cwr-staging-area-close-as-minimize-button': false,
    prompt_tile_content_type_localizaiton: false,
    // [CCI-15904] New AIFC Editor Experience — AND-gated with
    // `platform_editor_ai_xstate_migration` (see `isNewAifcExperienceEnabled`
    // in `editor-plugin-ai/src/ui/utils/new-aifc-experience-enabled.ts`).
    // (afm-ai-pr-review-bot #2) The previous comment incorrectly referenced
    // `platform_editor_ai_replace_doc` as the AND partner; the unrelated
    // `platform_editor_ai_replace_doc: false` override has been removed since
    // it does not gate this feature.
    platform_editor_ai_new_aifc_editor_experience: false,
    cc_page_experiences_editor_image_generation: false
};

});




parcelRegister("7YytE", function(module, exports) {
$parcel$export(module.exports, "emojiIdToEmoji", () => $a3cdba64ca101b0f$export$ad632d8144af7c7b);

var $3H4LK = parcelRequire("3H4LK");
const $a3cdba64ca101b0f$var$KEYCAP_COMBINING = 0x20e3;
const $a3cdba64ca101b0f$var$VARIATION_SELECTOR_16 = 0xfe0f;
const $a3cdba64ca101b0f$var$VARIATION_SELECTOR_15 = 0xfe0e;
// Text-presentation-default emoji: BMP characters (U+0000–U+FFFF) that are
// valid emoji but lack the Emoji_Presentation property render as text without
// U+FE0F. Supplementary-plane characters (U+10000+) always render as emoji
// regardless of the Emoji_Presentation property, so we skip those.
//
// This set is derived from Unicode 14.0 emoji-data.txt: all BMP code points
// that have the Emoji property but NOT the Emoji_Presentation property.
// Using an explicit lookup table avoids the \p{} Unicode property escape
// syntax (TS1501) which requires a specific TypeScript build target.
const $a3cdba64ca101b0f$var$TEXT_DEFAULT_EMOJI = new Set([
    0x0023,
    0x002a,
    0x0030,
    0x0031,
    0x0032,
    0x0033,
    0x0034,
    0x0035,
    0x0036,
    0x0037,
    0x0038,
    0x0039,
    0x00a9,
    0x00ae,
    0x203c,
    0x2049,
    0x2122,
    0x2139,
    0x2194,
    0x2195,
    0x2196,
    0x2197,
    0x2198,
    0x2199,
    0x21a9,
    0x21aa,
    0x2328,
    0x23cf,
    0x23ed,
    0x23ee,
    0x23ef,
    0x23f1,
    0x23f2,
    0x23f8,
    0x23f9,
    0x23fa,
    0x24c2,
    0x25aa,
    0x25ab,
    0x25b6,
    0x25c0,
    0x25fb,
    0x25fc,
    0x2600,
    0x2601,
    0x2602,
    0x2603,
    0x2604,
    0x260e,
    0x2611,
    0x2618,
    0x261d,
    0x2620,
    0x2622,
    0x2623,
    0x2626,
    0x262a,
    0x262e,
    0x262f,
    0x2638,
    0x2639,
    0x263a,
    0x2640,
    0x2642,
    0x265f,
    0x2660,
    0x2663,
    0x2665,
    0x2666,
    0x2668,
    0x267b,
    0x267e,
    0x2692,
    0x2694,
    0x2695,
    0x2696,
    0x2697,
    0x2699,
    0x269b,
    0x269c,
    0x26a0,
    0x26a7,
    0x26b0,
    0x26b1,
    0x26c8,
    0x26cf,
    0x26d1,
    0x26d3,
    0x26e9,
    0x26f0,
    0x26f1,
    0x26f4,
    0x26f7,
    0x26f8,
    0x26f9,
    0x2702,
    0x2708,
    0x2709,
    0x270c,
    0x270d,
    0x270f,
    0x2712,
    0x2714,
    0x2716,
    0x271d,
    0x2721,
    0x2733,
    0x2734,
    0x2744,
    0x2747,
    0x2763,
    0x2764,
    0x27a1,
    0x2934,
    0x2935,
    0x2b05,
    0x2b06,
    0x2b07,
    0x3030,
    0x303d,
    0x3297,
    0x3299
]);
function $a3cdba64ca101b0f$export$ad632d8144af7c7b(id) {
    if (!id) return undefined;
    const segments = id.split('-');
    const codePoints = [];
    for (const segment of segments){
        if (!/^[0-9a-fA-F]+$/.test(segment)) return undefined;
        const cp = parseInt(segment, 16);
        // Valid Unicode scalar values: 0x0000–0x10FFFF, excluding surrogates 0xD800–0xDFFF
        if (isNaN(cp) || cp < 0 || cp > 0x10ffff || cp >= 0xd800 && cp <= 0xdfff) return undefined;
        codePoints.push(cp);
    }
    if (codePoints.length === 0) return undefined;
    const processedCodePoints = [];
    for(let i = 0; i < codePoints.length; i++){
        const cp = codePoints[i];
        const next = codePoints[i + 1];
        processedCodePoints.push(cp);
        // Insert U+FE0F before U+20E3 if not already present.
        // Keycap sequences: digit/# /* followed by U+20E3 need U+FE0F between them.
        if (next === $a3cdba64ca101b0f$var$KEYCAP_COMBINING && cp !== $a3cdba64ca101b0f$var$VARIATION_SELECTOR_16) processedCodePoints.push($a3cdba64ca101b0f$var$VARIATION_SELECTOR_16);
    }
    // Text-presentation-default emoji: characters that are valid emoji but whose
    // default rendering is text (e.g. ☪ ☺ ☢ etc.) must be followed by
    // U+FE0F (VARIATION SELECTOR-16) to force emoji presentation.
    if ((0, $3H4LK.fg)('platform_twemoji_removal_unicode_emojis')) {
        const lastCodePoint = processedCodePoints[processedCodePoints.length - 1];
        const alreadyHasVariationSelector = lastCodePoint === $a3cdba64ca101b0f$var$VARIATION_SELECTOR_16 || lastCodePoint === $a3cdba64ca101b0f$var$VARIATION_SELECTOR_15 || // Keycap sequences end with U+20E3 — they already have U+FE0F inserted inline
        // and must not have another variation selector appended at the end.
        lastCodePoint === $a3cdba64ca101b0f$var$KEYCAP_COMBINING;
        if (!alreadyHasVariationSelector) {
            const baseCodePoint = codePoints[0];
            if (codePoints.length === 1 && baseCodePoint <= 0xffff && $a3cdba64ca101b0f$var$TEXT_DEFAULT_EMOJI.has(baseCodePoint)) processedCodePoints.push($a3cdba64ca101b0f$var$VARIATION_SELECTOR_16);
        }
    }
    try {
        return String.fromCodePoint(...processedCodePoints);
    } catch  {
        return undefined;
    }
}

});



parcelRegister("5aeTt", function(module, exports) {
$parcel$export(module.exports, "getEmojiVariation", () => $2b63d59885b2b6fb$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $2b63d59885b2b6fb$export$2e2bcd8739ae039);

var $lyp9s = parcelRequire("lyp9s");

var $kTZWy = parcelRequire("kTZWy");

var $l8Hvo = parcelRequire("l8Hvo");

var $jAzfF = parcelRequire("jAzfF");

var $cmlbg = parcelRequire("cmlbg");

var $9pkwf = parcelRequire("9pkwf");

var $kDIfl = parcelRequire("kDIfl");

var $3H4LK = parcelRequire("3H4LK");

var $4S0CO = parcelRequire("4S0CO");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $2b63d59885b2b6fb$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $cmlbg.tokenizerRegex).lastIndex = 0;
        while((match = (0, $cmlbg.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $2b63d59885b2b6fb$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $l8Hvo.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$2b63d59885b2b6fb$var$addAllVariants(variation, fnKey, map));
    }
};
const $2b63d59885b2b6fb$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $2b63d59885b2b6fb$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $2b63d59885b2b6fb$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $l8Hvo.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $2b63d59885b2b6fb$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
const $2b63d59885b2b6fb$var$teamojiRefreshExperimentName = 'platform_teamoji_26_refresh_emoji_picker';
class $2b63d59885b2b6fb$export$2e2bcd8739ae039 {
    static #_ = this.defaultEmojiWeight = 1000000;
    constructor(emojis, usageTracker){
        this.fullSearchReady = false;
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
   * Returns all available (and searchable) emoji in some default order.
   */ all() {
        const options = {
            sort: (0, $jAzfF.SearchSort).None
        };
        return this.search('', options);
    }
    /**
   * Text search of emoji shortName and name field for suitable matches.
   *
   * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
   *
   * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
   * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
   * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
   */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $2b63d59885b2b6fb$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.getSearchIndex().search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
   * Returns all emoji with matching shortName
   */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
   * Returns the first matching emoji matching the shortName, or null if none found.
   */ findByShortName(shortName) {
        return $2b63d59885b2b6fb$var$findByKey(this.shortNameMap, shortName);
    }
    /**
   * Returns the first matching emoji matching the id, or null if none found.
   */ findById(id) {
        return $2b63d59885b2b6fb$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $kTZWy.frequentCategory)) return this.getFrequentlyUsed();
        else if ((0, $4S0CO.expVal)($2b63d59885b2b6fb$var$teamojiRefreshExperimentName, 'isEnabled', false) && categoryId === 'ATLASSIAN') return this.all().emojis.filter((emoji)=>emoji.type === 'ATLASSIAN');
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.getSearchIndex().addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
   * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
   * there are none.
   *
   * @param options optional settings to be applied to the set of frequently used emoji
   */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
   * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
   * in sorting, etc).
   *
   * @param emoji the emoji that was just used
   */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $kTZWy.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $kTZWy.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $2b63d59885b2b6fb$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $jAzfF.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $jAzfF.SearchSort).Default) comparator = (0, $9pkwf.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $jAzfF.SearchSort).UsageFrequency) comparator = (0, $9pkwf.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $2b63d59885b2b6fb$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $kDIfl.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        if (!(0, $3H4LK.fg)('platform_index_emoji_just_in_time')) this.initSearchIndex();
    }
    /**
   * Optimisation to initialise all map member variables in single loop over emojis
   */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(this.getDynamicCategoryForEmoji(emoji, (0, $4S0CO.expVal)($2b63d59885b2b6fb$var$teamojiRefreshExperimentName, 'isEnabled', false)));
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $kTZWy.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $kTZWy.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $lyp9s.Search)('id');
        this.fullSearch.tokenizer = new $2b63d59885b2b6fb$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $lyp9s.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        if ((0, $4S0CO.expVal)($2b63d59885b2b6fb$var$teamojiRefreshExperimentName, 'isEnabled', false)) this.fullSearch.addIndex('keywords');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
        this.fullSearchReady = true;
    }
    getSearchIndex() {
        if (!this.fullSearchReady) this.initSearchIndex();
        return this.fullSearch;
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $2b63d59885b2b6fb$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $2b63d59885b2b6fb$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $2b63d59885b2b6fb$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $2b63d59885b2b6fb$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = this.getDynamicCategoryForEmoji(emoji, (0, $4S0CO.expVal)($2b63d59885b2b6fb$var$teamojiRefreshExperimentName, 'isEnabled', false));
        if ((0, $kTZWy.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
    getDynamicCategoryForEmoji(emoji, isTeamojiRefreshEnabled) {
        const category = (0, $l8Hvo.getCategoryId)(emoji);
        if (isTeamojiRefreshEnabled && emoji.type === 'ATLASSIAN' && category !== (0, $kTZWy.frequentCategory)) return 'ATLASSIAN';
        return category;
    }
}

});
parcelRegister("lyp9s", function(module, exports) {
$parcel$export(module.exports, "UnorderedSearchIndex", () => $fb104883a3afef47$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $fb104883a3afef47$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $fb104883a3afef47$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $fb104883a3afef47$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $fb104883a3afef47$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $fb104883a3afef47$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $fb104883a3afef47$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $fb104883a3afef47$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $fb104883a3afef47$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    };
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $fb104883a3afef47$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $fb104883a3afef47$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    };
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $fb104883a3afef47$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $fb104883a3afef47$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($fb104883a3afef47$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $fb104883a3afef47$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $fb104883a3afef47$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$fb104883a3afef47$export$eeaf491a400e882a.constructor = false;
$fb104883a3afef47$export$eeaf491a400e882a.hasOwnProperty = false;
$fb104883a3afef47$export$eeaf491a400e882a.isPrototypeOf = false;
$fb104883a3afef47$export$eeaf491a400e882a.propertyIsEnumerable = false;
$fb104883a3afef47$export$eeaf491a400e882a.toLocaleString = false;
$fb104883a3afef47$export$eeaf491a400e882a.toString = false;
$fb104883a3afef47$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $fb104883a3afef47$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$fb104883a3afef47$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $fb104883a3afef47$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fb104883a3afef47$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fb104883a3afef47$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fb104883a3afef47$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $fb104883a3afef47$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $fb104883a3afef47$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $fb104883a3afef47$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $fb104883a3afef47$export$147e8ac43c84713a();
        this._tokenizer = new $fb104883a3afef47$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    };
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    };
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    };
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    };
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $fb104883a3afef47$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $fb104883a3afef47$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $fb104883a3afef47$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $fb104883a3afef47$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $fb104883a3afef47$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $fb104883a3afef47$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    };
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("cmlbg", function(module, exports) {
$parcel$export(module.exports, "tokenizerRegex", () => $ef871232f520d719$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $ef871232f520d719$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("9pkwf", function(module, exports) {
$parcel$export(module.exports, "createSearchEmojiComparator", () => $f2623922c4f86b9a$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $f2623922c4f86b9a$export$1bd055808eeccb4e);

var $kTZWy = parcelRequire("kTZWy");

var $l8Hvo = parcelRequire("l8Hvo");
function $f2623922c4f86b9a$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $f2623922c4f86b9a$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $f2623922c4f86b9a$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $f2623922c4f86b9a$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $f2623922c4f86b9a$export$587c775915dc4869(textQuery, 'shortName'), new $f2623922c4f86b9a$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($f2623922c4f86b9a$export$165e96ceead77edd.Instance, $f2623922c4f86b9a$export$30ce221e1adf48c1.Instance);
    const comparator = new $f2623922c4f86b9a$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $f2623922c4f86b9a$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $f2623922c4f86b9a$export$a8052d0852821684(new $f2623922c4f86b9a$export$55e24837a4bf653(orderedIds), new $f2623922c4f86b9a$export$a7f7a0b04013a8a8(), $f2623922c4f86b9a$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $f2623922c4f86b9a$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $f2623922c4f86b9a$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $f2623922c4f86b9a$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $f2623922c4f86b9a$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $f2623922c4f86b9a$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $f2623922c4f86b9a$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
   * Get the ordinal representing the position of this emoji.
   *
   * @param id the id of the emoji
   */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $l8Hvo.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $kTZWy.MAX_ORDINAL;
    }
}
class $f2623922c4f86b9a$export$587c775915dc4869 {
    /**
   * @param query the query to match
   * @param propertyToCompare the property of EmojiDescription to check for query within
   */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $kTZWy.MAX_ORDINAL);
        return score === -1 ? (0, $kTZWy.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $f2623922c4f86b9a$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $kTZWy.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $kTZWy.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $f2623922c4f86b9a$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("kDIfl", function(module, exports) {
$parcel$export(module.exports, "UsageFrequencyTracker", () => $2036ff08f843928f$export$3f86810331c44209);

var $l8Hvo = parcelRequire("l8Hvo");

var $kTZWy = parcelRequire("kTZWy");

var $liMdp = parcelRequire("liMdp");

var $9BxOE = parcelRequire("9BxOE");

var $cdgs8 = parcelRequire("cdgs8");
class $2036ff08f843928f$export$3f86810331c44209 {
    static #_ = this.queueOptions = {
        storage: (0, $cdgs8.default)('localStorage') ? window.localStorage : undefined,
        storagePrefix: (0, $kTZWy.localStoragePrefix),
        maxDuplicates: 25,
        minUniqueItems: 5
    };
    constructor(useStorageIfPossible = true){
        const options = $2036ff08f843928f$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $9BxOE.default)(queueOptions);
        } else this.queue = new (0, $liMdp.default)(options);
        this.gateway = new $2036ff08f843928f$export$a0e1fa6601cae894(10);
    }
    /**
   * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
   * count on getOrder() reflecting this usage immediately.
   *
   * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
   */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $l8Hvo.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
   * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
   * are no usages then an empty array will be returned.
   */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
   * Exposed for testing only. Clear any recorded usage.
   */ clear() {
        this.queue.clear();
    }
}
class $2036ff08f843928f$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
   * Run the supplied function if the count of already submitted work allows it. Drop the work
   * if it's not allowed to run.
   *
   * Will return true if the function has been submitted or false if it was not submitted.
   */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("liMdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $2444f1a3b2bbf553$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $2444f1a3b2bbf553$export$2e2bcd8739ae039 {
    /**
   * Construct a new DuplicateLimitedQueue.
   *
   * @param options the options for this queue.
   */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
   * @param item the item to add to the queue.
   */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items in the queue, ordered by how often they are duplicated. The items with the
   * most duplicates come first in the returned Array.
   *
   * If there are no items in the queue then an empty Array will be returned.
   */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue.
   */ clear() {
        this.createEmptyState();
    }
    /**
   * A more efficient mechanism for adding multiple items. Ordering is only performed once all
   * the items have been added.
   *
   * @param items the items to be enqueued, which happens in their presented order.
   */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
   * Return the items currently stored in the queue.
   */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
   * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
   * performed by this enqueuing. You must trigger that manually if required.
   *
   * @param item the item to be queued
   */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
   * Get an array of items from the queue ordered by how often they are duplicated in the queue.
   */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
   * Walk the list of items and remove the first occurrence of the matching item.
   *
   * @param item the item to be removed.
   */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
   * Remove the first item from the queue and update the itemCountMap accordingly.
   * @return the item add the front of the queue or undefined if the queue is empty
   */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
   * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
   * @param item the item to be added to the queue
   */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("9BxOE", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b2b225806260e98$export$2e2bcd8739ae039);

var $liMdp = parcelRequire("liMdp");

var $34lPY = parcelRequire("34lPY");
class $1b2b225806260e98$export$2e2bcd8739ae039 extends (0, $liMdp.default) {
    static #_ = this.storageKey = 'lastUsed';
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$1b2b225806260e98$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
   * Enqueue the supplied item and also persist the new contents of the queue to storage.
   *
   * @param item the item to be enqueued
   */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
   * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
   */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
   * Initialise the queue contents from the configured Storage. If there is no data found in
   * storage then the queue will have no items added. Likewise, a failure to read or parse stored
   * data will be swallowed and no items are added to the queue.
   */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $34lPY.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
   * Save the current items in the queue, overwriting any previously stored queue.
   * Any failure in saving will be silently ignored with the likely outcome that any previous
   * saved items will remain unchanged in storage.
   */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $34lPY.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});


parcelRegister("4S0CO", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $ce194aba5839106d$export$9db1624a8af791a4);
$parcel$export(module.exports, "expValNoExposure", () => $ce194aba5839106d$export$94f132839aec533f);

var $6bGmX = parcelRequire("6bGmX");

var $3H4LK = parcelRequire("3H4LK");

var $lLCH0 = parcelRequire("lLCH0");

var $dzlHl = parcelRequire("dzlHl");

var $cdqux = parcelRequire("cdqux");
function $ce194aba5839106d$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    var _paramOverrides2, _experimentConfig$pro;
    const experimentConfig = (0, $dzlHl.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $cdqux._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $cdqux._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (_paramOverrides2 = (0, $cdqux._paramOverrides)[experimentName]) === null || _paramOverrides2 === void 0 ? void 0 : _paramOverrides2[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $6bGmX.default).initializeCompleted()) return defaultValue;
    if (!(0, $cdqux._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $cdqux._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    const resolvedExperimentKey = !(0, $dzlHl.disallowsProductKeys).includes(experimentName) && (0, $3H4LK.fg)('platform_editor_experiments_use_product_keys') ? experimentKey : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $6bGmX.default).getExperimentValue(resolvedExperimentKey, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $6bGmX.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $lLCH0.addFeatureFlagAccessed)(`${resolvedExperimentKey}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $ce194aba5839106d$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $ce194aba5839106d$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
  * Use to check a any param value for an experiment without firing an exposure event
  *
  * **Note**: this will return the default value when the experiment;
  * - is not being served to the client (ie. pre start)
  * - or is not configured in experiments-config
  *
  * @example
  * ```ts
  * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
  * await new Promise(res => setTimeout(res, delay)
  * ```
  */ 
function $ce194aba5839106d$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $ce194aba5839106d$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});


parcelRegister("kjnfk", function(module, exports) {
$parcel$export(module.exports, "default", () => $af43e784fb9b8779$export$2e2bcd8739ae039);

var $bmlEo = parcelRequire("bmlEo");

var $dZ5TE = parcelRequire("dZ5TE");

var $l8Hvo = parcelRequire("l8Hvo");

var $1nO4s = parcelRequire("1nO4s");

var $6Rmzc = parcelRequire("6Rmzc");

var $l0Xql = parcelRequire("l0Xql");

var $34lPY = parcelRequire("34lPY");
const $af43e784fb9b8779$export$6f3a08dea02a7b2b = 0.95;
class $af43e784fb9b8779$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $bmlEo.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $l8Hvo.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $6Rmzc.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $l8Hvo.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $l8Hvo.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $l0Xql.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $1nO4s.default)(this.tokenManager);
    }
    /**
   * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
   */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $l8Hvo.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $l8Hvo.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
   * Will load media emoji, returning a new EmojiDescription if, for example,
   * the URL has changed.
   */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $l8Hvo.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $l8Hvo.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $34lPY.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $dZ5TE.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $af43e784fb9b8779$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing' || state.status === 'processed') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $34lPY.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
   * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
   * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
   * completes with failure then the Promise will resolve to false.
   */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $6Rmzc.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $6Rmzc.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $34lPY.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
   * Calls to site-scoped EmojiResource to delete emoji
   * @param emoji media emoji to delete
   * @returns Promise.resolve() if success and Promise.reject() for failure
   */ deleteEmoji(emoji) {
        if (!(0, $l8Hvo.isMediaEmoji)(emoji) && !(0, $l8Hvo.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $bmlEo.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("1nO4s", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7baebc6aeea831b$export$2e2bcd8739ae039);

var $l8Hvo = parcelRequire("l8Hvo");

var $3gFjo = parcelRequire("3gFjo");

var $34lPY = parcelRequire("34lPY");

var $kU2in = parcelRequire("kU2in");
const $d7baebc6aeea831b$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $d7baebc6aeea831b$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $d7baebc6aeea831b$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $34lPY.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $d7baebc6aeea831b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $l8Hvo.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($d7baebc6aeea831b$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $d7baebc6aeea831b$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $d7baebc6aeea831b$var$maxImageSize = 10000;
class $d7baebc6aeea831b$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $34lPY.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $kU2in.LRUMap)($d7baebc6aeea831b$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $d7baebc6aeea831b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $l8Hvo.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $l8Hvo.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $l8Hvo.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $d7baebc6aeea831b$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $34lPY.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $d7baebc6aeea831b$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $34lPY.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $3gFjo.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $d7baebc6aeea831b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $l8Hvo.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $l8Hvo.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $l8Hvo.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $d7baebc6aeea831b$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $d7baebc6aeea831b$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $d7baebc6aeea831b$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("3gFjo", function(module, exports) {
$parcel$export(module.exports, "default", () => $110706ac4f5edb37$export$2e2bcd8739ae039);

var $j0sjQ = parcelRequire("j0sjQ");
const $110706ac4f5edb37$var$defaultConcurrentDownloadLimit = 16;
const $110706ac4f5edb37$var$backoffMaxDelayInMillis = 600;
const $110706ac4f5edb37$var$defaultMaxRetriesOnNotFound = 2;
class $110706ac4f5edb37$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $110706ac4f5edb37$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $110706ac4f5edb37$var$defaultMaxRetriesOnNotFound) {
        return (0, $j0sjQ.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($110706ac4f5edb37$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("j0sjQ", function(module, exports) {
$parcel$export(module.exports, "getNaturalImageSize", () => $2d0ad50defeb3337$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $2d0ad50defeb3337$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $2d0ad50defeb3337$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $2d0ad50defeb3337$export$f8e7886bc155c2e6);
const $2d0ad50defeb3337$var$maxEmojiSizeInBytes = 1048576;
const $2d0ad50defeb3337$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $2d0ad50defeb3337$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $2d0ad50defeb3337$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $2d0ad50defeb3337$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $2d0ad50defeb3337$var$isWebpSupported;
const $2d0ad50defeb3337$export$c5a964eb84c7fca8 = ()=>{
    if ($2d0ad50defeb3337$var$isWebpSupported !== undefined) return Promise.resolve($2d0ad50defeb3337$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $2d0ad50defeb3337$var$isWebpSupported = img.height === 2;
            resolve($2d0ad50defeb3337$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $2d0ad50defeb3337$export$f8e7886bc155c2e6 = ()=>$2d0ad50defeb3337$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("l0Xql", function(module, exports) {
$parcel$export(module.exports, "default", () => $f55c3eb20276e633$export$2e2bcd8739ae039);

var $bmlEo = parcelRequire("bmlEo");
const $f55c3eb20276e633$export$866c20c059277b6 = 30;
class $f55c3eb20276e633$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $f55c3eb20276e633$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $bmlEo.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("2UatR", function(module, exports) {
$parcel$export(module.exports, "ufoExperiences", () => $e9a042ab1a2ef143$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $e9a042ab1a2ef143$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $e9a042ab1a2ef143$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $e9a042ab1a2ef143$export$1466212a1606133);

var $jAzfF = parcelRequire("jAzfF");

var $exG7B = parcelRequire("exG7B");
var $fF3Qb = parcelRequire("fF3Qb");
var $dvcMh = parcelRequire("dvcMh");

var $1M76V = parcelRequire("1M76V");
const $e9a042ab1a2ef143$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $fF3Qb.ExperienceTypes).Load,
        performanceType: (0, $fF3Qb.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $e9a042ab1a2ef143$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $fF3Qb.ExperienceTypes).Experience,
        performanceType: (0, $fF3Qb.ExperiencePerformanceTypes).InlineResult
    };
};
const $e9a042ab1a2ef143$var$customEmojiTimings = [
    {
        key: (0, $jAzfF.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $jAzfF.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $jAzfF.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $jAzfF.UfoEmojiTimings).METADATA_START,
        endMark: (0, $jAzfF.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $jAzfF.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $jAzfF.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $jAzfF.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $jAzfF.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $jAzfF.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $jAzfF.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $jAzfF.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $jAzfF.UfoEmojiTimings).ONLOAD_END
    }
];
const $e9a042ab1a2ef143$export$615f888019c45765 = {
    'emoji-rendered': new (0, $exG7B.ConcurrentExperience)((0, $jAzfF.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $jAzfF.UfoComponentName).EMOJI
        },
        type: (0, $fF3Qb.ExperienceTypes).Operation,
        performanceType: (0, $fF3Qb.ExperiencePerformanceTypes).Custom,
        timings: $e9a042ab1a2ef143$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $exG7B.ConcurrentExperience)((0, $jAzfF.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $e9a042ab1a2ef143$var$createRenderExperience((0, $jAzfF.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $dvcMh.UFOExperience)((0, $jAzfF.UfoExperienceName).EMOJI_PICKER_OPENED, $e9a042ab1a2ef143$var$createRenderExperience((0, $jAzfF.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $dvcMh.UFOExperience)((0, $jAzfF.UfoExperienceName).EMOJI_SELECTION_RECORDED, $e9a042ab1a2ef143$var$createInlineExperience((0, $jAzfF.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $dvcMh.UFOExperience)((0, $jAzfF.UfoExperienceName).EMOJI_UPLOADED, $e9a042ab1a2ef143$var$createInlineExperience((0, $jAzfF.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $dvcMh.UFOExperience)((0, $jAzfF.UfoExperienceName).EMOJI_SEARCHED, $e9a042ab1a2ef143$var$createInlineExperience((0, $jAzfF.UfoComponentName).EMOJI_PICKER))
};
const $e9a042ab1a2ef143$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $1M76V.withSampling)($e9a042ab1a2ef143$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $e9a042ab1a2ef143$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $e9a042ab1a2ef143$export$1466212a1606133 = (providerType)=>{
    return (0, $1M76V.withSampling)($e9a042ab1a2ef143$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("exG7B", function(module, exports) {
$parcel$export(module.exports, "ConcurrentExperience", () => $ece98ccf02d4685d$export$ac1cddfee07ba6ac);

var $jCDss = parcelRequire("jCDss");

var $dvcMh = parcelRequire("dvcMh");
class $ece98ccf02d4685d$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $dvcMh.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $jCDss.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("jCDss", function(module, exports) {
$parcel$export(module.exports, "ufolog", () => $9e5af0c14a9c4fd3$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $9e5af0c14a9c4fd3$export$d53d07b6034c4560);
class $9e5af0c14a9c4fd3$var$UFOLogger {
    static #_ = this.UFOprefix = "[ufo\uD83D\uDEF8]";
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($9e5af0c14a9c4fd3$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($9e5af0c14a9c4fd3$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $9e5af0c14a9c4fd3$export$4ab84f6f04f6566d = new $9e5af0c14a9c4fd3$var$UFOLogger();
const $9e5af0c14a9c4fd3$export$b4958caff08a0960 = (...args)=>{
    $9e5af0c14a9c4fd3$export$4ab84f6f04f6566d.log(...args);
};
const $9e5af0c14a9c4fd3$export$d53d07b6034c4560 = (...args)=>{
    $9e5af0c14a9c4fd3$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("dvcMh", function(module, exports) {
$parcel$export(module.exports, "UFOExperience", () => $98f4ac03f40ea31f$export$c00d22927c60484a);

var $j2K1l = parcelRequire("j2K1l");
class $98f4ac03f40ea31f$export$c00d22927c60484a extends (0, $j2K1l.UFOAbstractExperience) {
}

});
parcelRegister("j2K1l", function(module, exports) {
$parcel$export(module.exports, "UFOAbstractExperience", () => $c7c15964d7423c57$export$d31c89db257648c);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2OOKU = parcelRequire("2OOKU");

var $83cck = parcelRequire("83cck");

var $lu2TF = parcelRequire("lu2TF");

var $jCDss = parcelRequire("jCDss");

var $jL33p = parcelRequire("jL33p");

var $4ikfp = parcelRequire("4ikfp");

var $D8Vag = parcelRequire("D8Vag");

var $3QcKz = parcelRequire("3QcKz");

var $kp7Me = parcelRequire("kp7Me");

var $8gM5h = parcelRequire("8gM5h");

var $fF3Qb = parcelRequire("fF3Qb");
const $c7c15964d7423c57$var$getPageVisibleState = ()=>{
    return !(0, $3QcKz.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $4ikfp.PageVisibleState).VISIBLE : (0, $4ikfp.PageVisibleState).HIDDEN;
};
const $c7c15964d7423c57$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $D8Vag.roundPerfNow)();
};
class $c7c15964d7423c57$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $kp7Me.UFOExperienceState).NOT_STARTED;
        this.instanceId = null; // for concurrent
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $4ikfp.PageVisibleState).MIXED;
            (0, $jL33p.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $c7c15964d7423c57$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $fF3Qb.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $fF3Qb.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $jCDss.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $8gM5h.canTransition)(this.state, newState)) {
            (0, $jCDss.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $kp7Me.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $c7c15964d7423c57$export$c753e8669d30c8ad(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $2OOKU.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $c7c15964d7423c57$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $lu2TF.getGlobalEventStream)().push((0, $lu2TF.unsubscribeEvent)((0, $4ikfp.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $jCDss.ufolog)('this.parent', this.parent);
                (0, $lu2TF.getGlobalEventStream)().push((0, $lu2TF.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $jCDss.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $jCDss.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $kp7Me.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $c7c15964d7423c57$var$getPageVisibleState();
            (0, $jL33p.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $jCDss.ufolog)('subscribed', this.id);
                (0, $lu2TF.getGlobalEventStream)().push((0, $lu2TF.subscribeEvent)((0, $4ikfp.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $4ikfp.FMP_MARK) && name !== (0, $4ikfp.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $jCDss.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $c7c15964d7423c57$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $kp7Me.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $4ikfp.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $4ikfp.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $jCDss.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
        if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
        (0, $jL33p.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $kp7Me.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $kp7Me.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $kp7Me.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $jCDss.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $83cck.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
parcelRegister("83cck", function(module, exports) {
$parcel$export(module.exports, "UFO_EXPERIMENTAL_BUILD_VERSION", () => $cb3b256730e854db$export$2295b861f318254a);
// temp solution until we can get it automated
const $cb3b256730e854db$export$2295b861f318254a = '0.1.5';

});

parcelRegister("lu2TF", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventStream", () => $8b53619435ebd32b$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $8b53619435ebd32b$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $8b53619435ebd32b$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $8b53619435ebd32b$export$7c957416596ca127);

var $jCDss = parcelRequire("jCDss");

var $4ikfp = parcelRequire("4ikfp");
const $8b53619435ebd32b$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $8b53619435ebd32b$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $8b53619435ebd32b$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $8b53619435ebd32b$export$c1522520b417b066 = (eventStream)=>{
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $jCDss.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $8b53619435ebd32b$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $4ikfp.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $8b53619435ebd32b$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $4ikfp.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $8b53619435ebd32b$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $4ikfp.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("4ikfp", function(module, exports) {
$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $0743bd7ad006da01$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $0743bd7ad006da01$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $0743bd7ad006da01$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $0743bd7ad006da01$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $0743bd7ad006da01$export$837e0f79a8056912);
var $0743bd7ad006da01$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $0743bd7ad006da01$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $0743bd7ad006da01$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $0743bd7ad006da01$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $0743bd7ad006da01$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $0743bd7ad006da01$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $0743bd7ad006da01$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $0743bd7ad006da01$export$9f2bf58999404c75 = 'fmp';
const $0743bd7ad006da01$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("jL33p", function(module, exports) {
$parcel$export(module.exports, "visibilityChangeObserver", () => $54d752d395e4c7c3$export$13e680397ec8f3eb);

var $3QcKz = parcelRequire("3QcKz");
class $54d752d395e4c7c3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $3QcKz.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $54d752d395e4c7c3$export$13e680397ec8f3eb = new $54d752d395e4c7c3$var$VisibilityChangeObserver();

});
parcelRegister("3QcKz", function(module, exports) {
$parcel$export(module.exports, "isWindowObjectAvailable", () => $032ab92621464e0f$export$15e172712955e18f);
const $032ab92621464e0f$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("D8Vag", function(module, exports) {
$parcel$export(module.exports, "roundPerfNow", () => $9044034011802158$export$5f490af6b2b115cf);
const $9044034011802158$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("kp7Me", function(module, exports) {
$parcel$export(module.exports, "UFOExperienceState", () => $a728b7b1fc7b2c73$export$81b70111112841a0);
const $a728b7b1fc7b2c73$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("8gM5h", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $fe44a8abf57eb58e$export$178881f329fdb81f);

var $kp7Me = parcelRequire("kp7Me");
const $fe44a8abf57eb58e$var$UFOStateAvailableTransitions = {
    [(0, $kp7Me.UFOExperienceState).NOT_STARTED.id]: [
        (0, $kp7Me.UFOExperienceState).STARTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).STARTED.id]: [
        (0, $kp7Me.UFOExperienceState).IN_PROGRESS.id,
        (0, $kp7Me.UFOExperienceState).BLOCKED.id,
        (0, $kp7Me.UFOExperienceState).SUCCEEDED.id,
        (0, $kp7Me.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $kp7Me.UFOExperienceState).FAILED.id,
        (0, $kp7Me.UFOExperienceState).ABORTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $kp7Me.UFOExperienceState).BLOCKED.id,
        (0, $kp7Me.UFOExperienceState).SUCCEEDED.id,
        (0, $kp7Me.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $kp7Me.UFOExperienceState).FAILED.id,
        (0, $kp7Me.UFOExperienceState).ABORTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).BLOCKED.id]: [
        (0, $kp7Me.UFOExperienceState).RECOVERED.id,
        (0, $kp7Me.UFOExperienceState).ABORTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).RECOVERED.id]: [
        (0, $kp7Me.UFOExperienceState).STARTED.id,
        (0, $kp7Me.UFOExperienceState).SUCCEEDED.id,
        (0, $kp7Me.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $kp7Me.UFOExperienceState).FAILED.id,
        (0, $kp7Me.UFOExperienceState).ABORTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).SUCCEEDED.id]: [
        (0, $kp7Me.UFOExperienceState).STARTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $kp7Me.UFOExperienceState).SUCCEEDED.id,
        (0, $kp7Me.UFOExperienceState).FAILED.id,
        (0, $kp7Me.UFOExperienceState).ABORTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).FAILED.id]: [
        (0, $kp7Me.UFOExperienceState).STARTED.id
    ],
    [(0, $kp7Me.UFOExperienceState).ABORTED.id]: [
        (0, $kp7Me.UFOExperienceState).STARTED.id
    ]
};
const $fe44a8abf57eb58e$export$178881f329fdb81f = (state1, state2)=>{
    return $fe44a8abf57eb58e$var$UFOStateAvailableTransitions[state1.id] && $fe44a8abf57eb58e$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("fF3Qb", function(module, exports) {
$parcel$export(module.exports, "ExperienceTypes", () => $543ebc8b369e256d$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $543ebc8b369e256d$export$cc26007c03242fff);
var $543ebc8b369e256d$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $543ebc8b369e256d$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

});




parcelRegister("1M76V", function(module, exports) {
$parcel$export(module.exports, "withSampling", () => $4274a81afd01b580$export$dc2f0946255b3f89);
const $4274a81afd01b580$export$c7c4959fece2f3ec = {};
const $4274a81afd01b580$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($4274a81afd01b580$export$c7c4959fece2f3ec))delete $4274a81afd01b580$export$c7c4959fece2f3ec[prop];
};
const $4274a81afd01b580$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $4274a81afd01b580$var$hasSampledFromStart = (experience)=>{
    if (!$4274a81afd01b580$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $4274a81afd01b580$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $4274a81afd01b580$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $4274a81afd01b580$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$4274a81afd01b580$export$c7c4959fece2f3ec[ufoExperience.id]) $4274a81afd01b580$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $4274a81afd01b580$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $4274a81afd01b580$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $4274a81afd01b580$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $4274a81afd01b580$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $4274a81afd01b580$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$4274a81afd01b580$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});


parcelRegister("judSF", function(module, exports) {
$parcel$export(module.exports, "promiseWithTimeout", () => $4175bfc39fe8d678$export$a9cd205a244d9f54);
function $4175bfc39fe8d678$export$a9cd205a244d9f54(promise, timeout, errorMessage = 'Timed out') {
    // Create a promise that rejects after the specified timeout
    const timeoutPromise = new Promise((_, reject)=>setTimeout(()=>reject(new Error(errorMessage)), timeout));
    // Use Promise.race to race the provided promise against the timeout promise
    return Promise.race([
        promise,
        timeoutPromise
    ]);
}

});



parcelRegister("hdGEL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea2720068e588867$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $xC4iY = parcelRequire("xC4iY");

var $irmNM = parcelRequire("irmNM");

var $7NU1B = parcelRequire("7NU1B");
var $iL69Q = parcelRequire("iL69Q");

var $437I1 = parcelRequire("437I1");

var $g4aMt = parcelRequire("g4aMt");
var $gVPbZ = parcelRequire("gVPbZ");

var $ia1kt = parcelRequire("ia1kt");

var $7BAwD = parcelRequire("7BAwD");

var $gXYVI = parcelRequire("gXYVI");
const $ea2720068e588867$export$8f69873d7d6eec35 = (props)=>{
    const { product: product, additionalExtensionHandlers: additionalExtensionHandlers = {}, PropsProvider: PropsProvider, contentId: contentId, dataProviders: dataProviders } = props;
    const [sectionsProvider, setSectionsProvider] = (0, $4fqPo.useState)(null);
    const intl = (0, $4MCQn.default)();
    const hubExtensionHandlers = (0, $gXYVI.useHubExtensionHandlers)({
        contentId: contentId,
        PropsProvider: PropsProvider
    });
    const allExtensionHandlers = (0, $4fqPo.useMemo)(()=>{
        return {
            ...hubExtensionHandlers,
            ...additionalExtensionHandlers
        };
    }, [
        hubExtensionHandlers,
        additionalExtensionHandlers
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const loadSectionsProvider = async ()=>{
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $g4aMt.ExtensionMode).RENDERER,
                getSectionExtensionContents: $ia1kt.getSectionExtensionContents
            };
            const defaultExtensionInstanceProps = {
                intl: intl,
                contentId: contentId
            };
            const sectionsProviderInstance = await (0, $7BAwD.sectionExtensionProvider)(defaultExtensionProviderProps);
            const sectionsProvider = await sectionsProviderInstance(defaultExtensionInstanceProps);
            setSectionsProvider(sectionsProvider);
        };
        loadSectionsProvider();
    }, [
        contentId,
        intl,
        PropsProvider
    ]);
    const providerFactory = (0, $4fqPo.useMemo)(()=>{
        const factory = dataProviders || (0, $irmNM.default).create({});
        if (sectionsProvider) factory.setProvider('extensionProvider', Promise.resolve((0, $xC4iY.default)([
            sectionsProvider
        ])));
        return factory;
    }, [
        sectionsProvider,
        dataProviders
    ]);
    const smartCardClient = (0, $4fqPo.useMemo)(()=>new (0, $7NU1B.default)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gVPbZ.HubRendererWrapper), {
        "data-testid": "hub-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iL69Q.SmartCardProvider), {
        product: product,
        client: smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $437I1.RendererWithAnalytics), {
        ...props,
        allowCustomPanels: true,
        media: {
            allowLinking: true
        },
        extensionHandlers: allExtensionHandlers,
        // dataProviders supplies the extension provider factory which enables section extensions to be rendered within the hub
        dataProviders: providerFactory,
        adfStage: "stage0"
    })));
};
var $ea2720068e588867$export$2e2bcd8739ae039 = $ea2720068e588867$export$8f69873d7d6eec35;

});
parcelRegister("xC4iY", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd25f8722bfbb464$export$2e2bcd8739ae039);

var $l12Qf = parcelRequire("l12Qf");
var /**
 * Allow to run methods from the `ExtensionProvider` interface across all providers seamlessly.
 * This handles promise racing and discards rejected promises safely.
 */ $cd25f8722bfbb464$export$2e2bcd8739ae039 = (extensionProviders)=>{
    let providersCache = [];
    const { invokeSingle: invokeSingle, invokeList: invokeList } = (0, $l12Qf.default)(extensionProviders);
    return {
        getExtensions () {
            return invokeList('getExtensions');
        },
        async preload () {
            if (providersCache.length === 0) providersCache = await Promise.all(extensionProviders.map((provider)=>Promise.resolve(provider)));
            await Promise.all(providersCache.map((provider)=>{
                var _provider$preload;
                return provider === null || provider === void 0 || (_provider$preload = provider.preload) === null || _provider$preload === void 0 ? void 0 : _provider$preload.call(provider);
            }));
        },
        getPreloadedExtension (type, key) {
            if (providersCache.length === 0) // preload() has not been called yet
            return;
            for (const provider of providersCache)try {
                var _provider$getPreloade;
                const result = provider === null || provider === void 0 || (_provider$getPreloade = provider.getPreloadedExtension) === null || _provider$getPreloade === void 0 ? void 0 : _provider$getPreloade.call(provider, type, key);
                if (result) return result;
            } catch  {
            // Not every provider will implement this method.
            // In that case we would get error from other providers in the loop
            // and undefined from that particular provider.
            // We can safely ignore it and fallback to the async getExtension when nothing was found.
            }
        },
        getExtension (type, key) {
            return invokeSingle('getExtension', [
                type,
                key
            ]);
        },
        search (keyword) {
            return invokeList('search', [
                keyword
            ]);
        },
        getAutoConverter () {
            return invokeList('getAutoConverter');
        }
    };
};

});
parcelRegister("l12Qf", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee8806cd7a1e628d$export$2e2bcd8739ae039);

var $03VyC = parcelRequire("03VyC");

var $4UGD5 = parcelRequire("4UGD5");
const $ee8806cd7a1e628d$var$flatten = (arr)=>[].concat(...arr);
var /**
 * Allow to run methods from the given provider interface across all providers seamlessly.
 * Handles promise racing and discards rejected promises safely.
 */ $ee8806cd7a1e628d$export$2e2bcd8739ae039 = (providers)=>{
    if (providers.length === 0) throw new Error('At least one provider must be provided');
    const getFulfilledProviders = async ()=>{
        const results = await (0, $03VyC.waitForAllPromises)(providers.map((result)=>Promise.resolve(result)));
        // Filter out null/undefined providers to prevent errors when calling methods on them
        return (0, $03VyC.getOnlyFulfilled)(results).filter((provider)=>provider != null);
    };
    const runInAllProviders = async (mapFunction)=>{
        return (await getFulfilledProviders()).map((provider)=>mapFunction(provider));
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const createCallback = (methodName, args)=>(provider)=>{
            const method = provider[methodName];
            if (typeof method === 'function') return method.apply(provider, args);
            throw new Error(`"${String(methodName)}" isn't a function of the provider`);
        };
    /**
   * Run a method from the provider which expects to return a single item
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeSingle = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        return (0, $4UGD5.waitForFirstFulfilledPromise)(await runInAllProviders(callback));
    };
    /**
   * Run a method in the provider which expectes to return a list of items
   * @param methodName
   * @param args
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const invokeList = async (methodName, args)=>{
        const callback = createCallback(methodName, args);
        const results = await (0, $03VyC.waitForAllPromises)(await runInAllProviders(callback));
        const fulfilledResults = (0, $03VyC.getOnlyFulfilled)(results);
        return $ee8806cd7a1e628d$var$flatten(fulfilledResults).filter((result)=>result);
    };
    return {
        invokeSingle: invokeSingle,
        invokeList: invokeList
    };
};

});
parcelRegister("03VyC", function(module, exports) {
$parcel$export(module.exports, "waitForAllPromises", () => $68e996f6e21f2ae9$export$b43fdcffd84b7b0f);
$parcel$export(module.exports, "getOnlyFulfilled", () => $68e996f6e21f2ae9$export$b7581cbf0e22e36b);

var $bQe6l = parcelRequire("bQe6l");
const $68e996f6e21f2ae9$var$isFullfilled = (result)=>result.status === (0, $bQe6l.ResultStatus).FULFILLED;
const $68e996f6e21f2ae9$var$markFullfilled = (value)=>({
        status: (0, $bQe6l.ResultStatus).FULFILLED,
        value: value
    });
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $68e996f6e21f2ae9$var$markRejected = (error)=>({
        status: (0, $bQe6l.ResultStatus).FAILED,
        reason: error
    });
const $68e996f6e21f2ae9$export$b43fdcffd84b7b0f = (promises)=>{
    return Promise.all(promises.map((result)=>result.then($68e996f6e21f2ae9$var$markFullfilled).catch($68e996f6e21f2ae9$var$markRejected)));
};
const $68e996f6e21f2ae9$export$b7581cbf0e22e36b = (results)=>results.filter($68e996f6e21f2ae9$var$isFullfilled).map((result)=>result.value); // eslint-disable-next-line @atlaskit/editor/no-re-export
 // eslint-disable-next-line @atlaskit/editor/no-re-export

});
parcelRegister("bQe6l", function(module, exports) {
$parcel$export(module.exports, "ResultStatus", () => $e2fea7ea5c52ee02$export$7103a54af3e45080);
var $e2fea7ea5c52ee02$export$7103a54af3e45080 = /*#__PURE__*/ function(ResultStatus) {
    ResultStatus["FULFILLED"] = "fulfilled";
    ResultStatus["FAILED"] = "failed";
    return ResultStatus;
}({});

});


parcelRegister("4UGD5", function(module, exports) {
$parcel$export(module.exports, "waitForFirstFulfilledPromise", () => $434894a9ffdc315a$export$cb8861b0e3f3dd6f);
/**
 * Will resolve on the first fulfilled promise and disregard the remaining ones. Similar to `Promise.race` but won't
 * care about rejected promises.
 * @param promises
 */ const $434894a9ffdc315a$export$cb8861b0e3f3dd6f = (promises)=>{
    const rejectReasons = [];
    return new Promise((resolve, reject)=>{
        promises.forEach((promise)=>promise.then((value)=>{
                if (typeof value === 'undefined' || value === null) throw new Error(`Result was not found but the method didn't reject/throw. Please ensure that it doesn't return null or undefined.`);
                resolve(value);
            }).catch((reason)=>{
                rejectReasons.push(reason);
                if (rejectReasons.length === promises.length) reject(reason);
            }));
    });
};

});



parcelRegister("7NU1B", function(module, exports) {
$parcel$export(module.exports, "default", () => $f72105623927eb28$export$2e2bcd8739ae039);

var $dasBT = parcelRequire("dasBT");

var $9PHfZ = parcelRequire("9PHfZ");

var $7RvFN = parcelRequire("7RvFN");

var $3xXTF = parcelRequire("3xXTF");
var $7W6cx = parcelRequire("7W6cx");
var $21gEn = parcelRequire("21gEn");
var $3CEuh = parcelRequire("3CEuh");

var $7rbHY = parcelRequire("7rbHY");

var $kU2in = parcelRequire("kU2in");

var $PxLKT = parcelRequire("PxLKT");

var $3H4LK = parcelRequire("3H4LK");
const $f72105623927eb28$var$MAX_BATCH_SIZE = 50;
const $f72105623927eb28$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $f72105623927eb28$var$URL_RESPONSE_CACHE_SIZE = 100;
const $f72105623927eb28$export$d6a66073b5d79eb3 = new (0, $kU2in.LRUMap)($f72105623927eb28$var$URL_RESPONSE_CACHE_SIZE);
class $f72105623927eb28$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($PxLKT)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $3CEuh.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $3CEuh.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $7rbHY.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
       * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
       * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
       */ 'origin-timezone': Intl === null || Intl === void 0 ? void 0 : Intl.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $3CEuh.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $3CEuh.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $7rbHY.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>resource.resourceUrl);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $7W6cx.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7RvFN)))({
            limit: 1,
            interval: $f72105623927eb28$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dasBT)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $f72105623927eb28$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($7RvFN)))({
            limit: 1,
            interval: $f72105623927eb28$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($dasBT)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $f72105623927eb28$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $3xXTF.InvalidUrlError)(error);
        }
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        const loader = this.getLoader(hostname);
        const isInlineOptEnabled = appearance !== undefined && (0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization');
        // Include appearance in cache key when feature flag is enabled and appearance is specified
        const cacheKey = isInlineOptEnabled ? `${url}|${appearance}` : url;
        let responsePromise;
        responsePromise = $f72105623927eb28$export$d6a66073b5d79eb3.get(cacheKey);
        if (!responsePromise || force) {
            if ((0, $3H4LK.fg)('platform_linking_force_no_cache_smart_card_client')) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    // Pass appearance to ORS when feature flag is enabled
                    ...isInlineOptEnabled ? {
                        appearance: appearance
                    } : {}
                });
            } else responsePromise = loader.load(url);
            $f72105623927eb28$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $f72105623927eb28$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $7rbHY.isSuccessfulResponse)(response) || (0, $21gEn.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $f72105623927eb28$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $7rbHY.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($9PHfZ)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $7rbHY.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $7rbHY.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($9PHfZ)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $7rbHY.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $3CEuh.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $3CEuh.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $7rbHY.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $3CEuh.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response !== null && response !== void 0 && response.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $3xXTF.NetworkError)) return new (0, $3xXTF.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $3xXTF.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $3xXTF.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $3xXTF.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $3xXTF.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $3xXTF.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("9PHfZ", function(module, exports) {
// Packages

var $290Cf = parcelRequire("290Cf");
function $728a6e63f7cb8860$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $290Cf.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $728a6e63f7cb8860$var$retry;

});
parcelRegister("290Cf", function(module, exports) {

module.exports = (parcelRequire("hJL37"));

});
parcelRegister("hJL37", function(module, exports) {

var $j0lDn = parcelRequire("j0lDn");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $j0lDn(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("j0lDn", function(module, exports) {
function $dd5ecc81df180858$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $dd5ecc81df180858$var$RetryOperation;
$dd5ecc81df180858$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$dd5ecc81df180858$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$dd5ecc81df180858$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$dd5ecc81df180858$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$dd5ecc81df180858$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$dd5ecc81df180858$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$dd5ecc81df180858$var$RetryOperation.prototype.start = $dd5ecc81df180858$var$RetryOperation.prototype.try;
$dd5ecc81df180858$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$dd5ecc81df180858$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$dd5ecc81df180858$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("7RvFN", function(module, exports) {
'use strict';
class $5b960d43df5ede75$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $5b960d43df5ede75$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $5b960d43df5ede75$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $5b960d43df5ede75$var$pThrottle;
module.exports.AbortError = $5b960d43df5ede75$var$AbortError;

});

parcelRegister("3xXTF", function(module, exports) {
$parcel$export(module.exports, "APIError", () => $fdd7f51d2e9eacb9$export$3e5b797e39668f84);
$parcel$export(module.exports, "InvalidUrlError", () => $fdd7f51d2e9eacb9$export$19fa02dd69bd4efd);
$parcel$export(module.exports, "NetworkError", () => $fdd7f51d2e9eacb9$export$bae979e68e4dc802);
class $fdd7f51d2e9eacb9$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
class $fdd7f51d2e9eacb9$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
class $fdd7f51d2e9eacb9$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}

});

parcelRegister("7W6cx", function(module, exports) {
$parcel$export(module.exports, "getBaseUrl", () => $c3b96c39bea9f81c$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $c3b96c39bea9f81c$export$dc37652c1696f231);
const $c3b96c39bea9f81c$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $c3b96c39bea9f81c$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $c3b96c39bea9f81c$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $c3b96c39bea9f81c$export$e2b040f052407032 = {
    dev: $c3b96c39bea9f81c$var$devBaseUrl,
    development: $c3b96c39bea9f81c$var$devBaseUrl,
    stg: $c3b96c39bea9f81c$var$stgBaseUrl,
    staging: $c3b96c39bea9f81c$var$stgBaseUrl,
    prd: $c3b96c39bea9f81c$var$prodBaseUrl,
    prod: $c3b96c39bea9f81c$var$prodBaseUrl,
    production: $c3b96c39bea9f81c$var$prodBaseUrl
};
const $c3b96c39bea9f81c$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? $c3b96c39bea9f81c$var$prodBaseUrl;
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $c3b96c39bea9f81c$export$e2b040f052407032 ? $c3b96c39bea9f81c$export$e2b040f052407032[envKey] : $c3b96c39bea9f81c$var$prodBaseUrl;
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $c3b96c39bea9f81c$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $c3b96c39bea9f81c$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $c3b96c39bea9f81c$export$2e2bcd8739ae039 = $c3b96c39bea9f81c$export$e2b040f052407032;

});

parcelRegister("21gEn", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $5bb263ca3f9e3f33$export$b70265791d2079d4);
const $5bb263ca3f9e3f33$var$getStatusForNotFoundVisibility = (meta)=>{
    var _meta$requestAccess;
    const accessType = (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $5bb263ca3f9e3f33$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $5bb263ca3f9e3f33$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});

parcelRegister("3CEuh", function(module, exports) {
$parcel$export(module.exports, "request", () => $f6b8b3334dcda48a$export$b5fe3f66a567bec0);

var $3xXTF = parcelRequire("3xXTF");
const $f6b8b3334dcda48a$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $f6b8b3334dcda48a$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $f6b8b3334dcda48a$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses !== null && statuses !== void 0 && statuses.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $3xXTF.NetworkError)(error);
        throw error;
    }
}

});

parcelRegister("7rbHY", function(module, exports) {
$parcel$export(module.exports, "isSuccessfulResponse", () => $3f26848eccb35cdc$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $3f26848eccb35cdc$export$bea7bee8a87e7c52);
const $3f26848eccb35cdc$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $3f26848eccb35cdc$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("PxLKT", function(module, exports) {

var $kUeJo = parcelRequire("kUeJo");

var $ffi5e = parcelRequire("ffi5e");
/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $09aef5678953e5a0$var$uniqBy(array, iteratee) {
    return array && array.length ? $ffi5e(array, $kUeJo(iteratee, 2)) : [];
}
module.exports = $09aef5678953e5a0$var$uniqBy;

});


parcelRegister("iL69Q", function(module, exports) {
$parcel$export(module.exports, "SmartCardProvider", () => $610eeb0245e0b144$export$497ecb0280204df4);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $8Snhx = parcelRequire("8Snhx");

var $lc40q = parcelRequire("lc40q");

var $2oVC7 = parcelRequire("2oVC7");
var $dg1TL = parcelRequire("dg1TL");

var $fRlBb = parcelRequire("fRlBb");

var $bbk8d = parcelRequire("bbk8d");

var $5ILcO = parcelRequire("5ILcO");

var $3H4LK = parcelRequire("3H4LK");

var $7NU1B = parcelRequire("7NU1B");
const $610eeb0245e0b144$export$97eec7ea3e925862 = 'atlaskit-smart-card:external-auth-completed';
function $610eeb0245e0b144$export$497ecb0280204df4({ storeOptions: storeOptions, bridgeProduct: bridgeProduct, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product, shouldControlDataExport: shouldControlDataExport, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, rovoOptions: rovoOptions, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct }) {
    const parentContext = (0, $4fqPo.useContext)((0, $5ILcO.SmartCardContext));
    const defaultInitialState = (0, $4fqPo.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $4fqPo.useMemo)(()=>{
        return (0, $8Snhx.default)((0, $bbk8d.cardReducer), initialState);
    }, [
        initialState
    ]);
    const client = (0, $4fqPo.useMemo)(()=>{
        const c = customClient || new (0, $7NU1B.default)();
        if (product && c.setProduct) c.setProduct(product);
        return c;
    }, [
        customClient,
        product
    ]);
    // Listen for external auth completion events and re-resolve any matching unauthorized cards in this store.
    // Used as guardrail killswitch for synchronized-post-office-and-smartcard-auth-exp in Post Office
    (0, $4fqPo.useEffect)(()=>{
        if (typeof window === 'undefined' || !(0, $3H4LK.fg)('navx-smartcard-auth-event-listener-killswitch-fg')) return;
        const handler = (event)=>{
            var _detail$extensionKeys;
            const detail = event.detail;
            if (!(detail !== null && detail !== void 0 && (_detail$extensionKeys = detail.extensionKeys) !== null && _detail$extensionKeys !== void 0 && _detail$extensionKeys.length)) return;
            const targetKeys = new Set(detail.extensionKeys);
            const state = store.getState();
            for (const url of Object.keys(state)){
                var _cardState$details;
                const cardState = state[url];
                if (!cardState || cardState.status !== 'unauthorized') continue;
                const cardExtensionKey = (_cardState$details = cardState.details) === null || _cardState$details === void 0 || (_cardState$details = _cardState$details.meta) === null || _cardState$details === void 0 ? void 0 : _cardState$details.key;
                if (!cardExtensionKey || !targetKeys.has(cardExtensionKey)) continue;
                // Fetch fresh data from ORS and dispatch new payload data
                client.fetchData(url, true).then((response)=>{
                    store.dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_RELOADING), {
                        url: url
                    }, response, undefined, undefined, true));
                }, (err)=>{
                    store.dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_ERROR), {
                        url: url
                    }, undefined, err, undefined, true));
                });
            }
        };
        window.addEventListener($610eeb0245e0b144$export$97eec7ea3e925862, handler);
        return ()=>{
            window.removeEventListener($610eeb0245e0b144$export$97eec7ea3e925862, handler);
        };
    }, [
        store,
        client
    ]);
    const providerValue = (0, $4fqPo.useMemo)(()=>{
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, _platform)=>{
            const cardState = (0, $dg1TL.getUrl)(store, url);
            return cardState.details ? (0, $fRlBb.extractSmartLinkEmbed)(cardState.details) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            bridgeProduct: bridgeProduct,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product,
            shouldControlDataExport: shouldControlDataExport,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            rovoOptions: rovoOptions,
            xpcProduct: xpcProduct,
            xpcSubProduct: xpcSubProduct
        };
    }, [
        customAuthFlow,
        bridgeProduct,
        client,
        isAdminHubAIEnabled,
        isPreviewPanelAvailable,
        openPreviewPanel,
        product,
        renderers,
        shouldControlDataExport,
        rovoOptions,
        store,
        xpcProduct,
        xpcSubProduct
    ]);
    const value = (0, $4fqPo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lc40q)))({}, parentContext || providerValue, {
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel
        }), [
        parentContext,
        providerValue,
        isPreviewPanelAvailable,
        openPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5ILcO.SmartCardContext).Provider, {
        value: value
    }, children);
}
var $610eeb0245e0b144$export$2e2bcd8739ae039 = $610eeb0245e0b144$export$497ecb0280204df4;

});
parcelRegister("2oVC7", function(module, exports) {
$parcel$export(module.exports, "ACTION_PENDING", () => $958ab02a99e41d05$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $958ab02a99e41d05$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $958ab02a99e41d05$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $958ab02a99e41d05$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $958ab02a99e41d05$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $958ab02a99e41d05$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $958ab02a99e41d05$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $958ab02a99e41d05$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $958ab02a99e41d05$export$6e470aad5ba8952e = 'pending';
const $958ab02a99e41d05$export$9a6a932a0a39498e = 'resolving';
const $958ab02a99e41d05$export$63ec8bc7a8a75482 = 'resolved';
const $958ab02a99e41d05$export$b8cfaa842c9ab487 = 'reloading';
const $958ab02a99e41d05$export$6d8ed3f9433dd372 = 'errored';
const $958ab02a99e41d05$export$cfbbb7126bc8a0c6 = 'fallback';
const $958ab02a99e41d05$export$76b5c1aca20759c6 = 'preload';
const $958ab02a99e41d05$export$2c5edb971b673330 = 'metadata';
const $958ab02a99e41d05$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("dg1TL", function(module, exports) {
$parcel$export(module.exports, "getUrl", () => $64f418d44487fd4e$export$94df0e59ebebf4a7);
const $64f418d44487fd4e$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fRlBb", function(module, exports) {
$parcel$export(module.exports, "extractUrlFromIconJsonLd", () => $fbc762445023dab4$export$67f3d92c824fd850);
$parcel$export(module.exports, "extractType", () => $fbc762445023dab4$export$2e9ae379995d99e3);
$parcel$export(module.exports, "extractAri", () => $fbc762445023dab4$export$be18a6294fd426ec);
$parcel$export(module.exports, "extractLink", () => $fbc762445023dab4$export$63f54cf4c5883620);
$parcel$export(module.exports, "extractTitle", () => $fbc762445023dab4$export$b05803156e5015b6);
$parcel$export(module.exports, "extractProvider", () => $fbc762445023dab4$export$a832871718466647);
$parcel$export(module.exports, "extractProviderIcon", () => $fbc762445023dab4$export$6fb636a2ac885215);
$parcel$export(module.exports, "isConfluenceGenerator", () => $fbc762445023dab4$export$38df542ff03a4183);
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $fbc762445023dab4$export$c471ae5fddcf1392);
$parcel$export(module.exports, "extractMembers", () => $fbc762445023dab4$export$6281d080d62a0719);
$parcel$export(module.exports, "extractPersonAssignedTo", () => $fbc762445023dab4$export$38a0979ebf273662);
$parcel$export(module.exports, "extractPersonCreatedBy", () => $fbc762445023dab4$export$a66235cba0c9d11a);
$parcel$export(module.exports, "extractPersonOwnedBy", () => $fbc762445023dab4$export$19ee667f3f7a6ec3);
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $fbc762445023dab4$export$8a2d1ed7e6f336f0);
$parcel$export(module.exports, "extractImage", () => $fbc762445023dab4$export$4c753a1297cb9805);
$parcel$export(module.exports, "extractPreview", () => $fbc762445023dab4$export$4b0d98b1b7f6d115);
$parcel$export(module.exports, "extractEntity", () => $fbc762445023dab4$export$8beff7405d020ddf);
$parcel$export(module.exports, "isEntityPresent", () => $fbc762445023dab4$export$c7168210b81d9383);
$parcel$export(module.exports, "extractEntityProvider", () => $fbc762445023dab4$export$ad879f2c9d5100a0);
$parcel$export(module.exports, "extractEntityIcon", () => $fbc762445023dab4$export$19346520e937a99f);
$parcel$export(module.exports, "extractSmartLinkTitle", () => $fbc762445023dab4$export$3eda18658b66108);
$parcel$export(module.exports, "extractSmartLinkUrl", () => $fbc762445023dab4$export$7ba9b12c6a1b73de);
$parcel$export(module.exports, "extractSmartLinkAri", () => $fbc762445023dab4$export$16b02be3e2bb31ad);
$parcel$export(module.exports, "extractSmartLinkEmbed", () => $fbc762445023dab4$export$864b719baf5d744d);
$parcel$export(module.exports, "extractSmartLinkProvider", () => $fbc762445023dab4$export$ff753ed519e96e9e);
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $fbc762445023dab4$export$7a685df468cbf38f);
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $fbc762445023dab4$export$75047940e157fd1f);
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $fbc762445023dab4$export$242875b46118beb2);
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $fbc762445023dab4$export$41fc716e1bc2dc90);
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $fbc762445023dab4$export$7f099a839071a190);
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $fbc762445023dab4$export$96ed4c1b14ac210a);

var $4fqPo = parcelRequire("4fqPo");

var $OSEp1 = parcelRequire("OSEp1");

var $l59Pd = parcelRequire("l59Pd");

var $d543D = parcelRequire("d543D");

var $3H4LK = parcelRequire("3H4LK");

var $4xi6h = parcelRequire("4xi6h");
function $fbc762445023dab4$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $fbc762445023dab4$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $fbc762445023dab4$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $fbc762445023dab4$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $fbc762445023dab4$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $fbc762445023dab4$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $fbc762445023dab4$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $fbc762445023dab4$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $fbc762445023dab4$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $fbc762445023dab4$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $fbc762445023dab4$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof (jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.summary) === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $fbc762445023dab4$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    var _jsonLd$name;
    if (!jsonLd) return undefined;
    const name = (_jsonLd$name = jsonLd.name) === null || _jsonLd$name === void 0 ? void 0 : _jsonLd$name.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $fbc762445023dab4$export$efdbd45f3e77a161(jsonLd);
    const type = $fbc762445023dab4$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name === null || name === void 0 ? void 0 : name.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $fbc762445023dab4$export$3185b99040f72cfd = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'name' in details.data && details.data.name || undefined;
const $fbc762445023dab4$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $fbc762445023dab4$export$67f3d92c824fd850(context.icon),
                type: $fbc762445023dab4$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $fbc762445023dab4$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $3H4LK.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $fbc762445023dab4$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $4xi6h.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l59Pd.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $3H4LK.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $4xi6h.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d543D.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $3H4LK.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return $fbc762445023dab4$export$67f3d92c824fd850(icon);
    return undefined;
};
const $fbc762445023dab4$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $fbc762445023dab4$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $fbc762445023dab4$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$38df542ff03a4183 = (id)=>{
    return id === (0, $4xi6h.CONFLUENCE_GENERATOR_ID);
};
const $fbc762445023dab4$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $fbc762445023dab4$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $fbc762445023dab4$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $fbc762445023dab4$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $fbc762445023dab4$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $fbc762445023dab4$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$fbc762445023dab4$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $fbc762445023dab4$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $fbc762445023dab4$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $fbc762445023dab4$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($fbc762445023dab4$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $fbc762445023dab4$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($fbc762445023dab4$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $fbc762445023dab4$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $fbc762445023dab4$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $fbc762445023dab4$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $fbc762445023dab4$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $fbc762445023dab4$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $fbc762445023dab4$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.preview;
    const isSupported = $fbc762445023dab4$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $fbc762445023dab4$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $fbc762445023dab4$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $fbc762445023dab4$export$8beff7405d020ddf = (response)=>response === null || response === void 0 ? void 0 : response.entityData;
const $fbc762445023dab4$export$c7168210b81d9383 = (response)=>Boolean($fbc762445023dab4$export$8beff7405d020ddf(response));
const $fbc762445023dab4$var$extractEntityEmbedUrl = (response)=>{
    const entity = $fbc762445023dab4$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl) === 'string' ? entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl : undefined;
};
const $fbc762445023dab4$export$ad879f2c9d5100a0 = (response)=>{
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) return undefined;
    if ((0, $3H4LK.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $fbc762445023dab4$export$19346520e937a99f(response);
        if (entityIcon) return {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $4xi6h.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l59Pd.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $3H4LK.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $4xi6h.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d543D.JiraIcon), {
                appearance: "brand",
                ...(0, $3H4LK.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $3H4LK.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $fbc762445023dab4$export$19346520e937a99f = (response)=>{
    if ((0, $3H4LK.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $fbc762445023dab4$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $OSEp1.isBaseEntity)(entity)) return undefined;
        if ((0, $OSEp1.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $OSEp1.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $fbc762445023dab4$export$8beff7405d020ddf(response);
        let url;
        if (entity) {
            var _response$meta$genera;
            url = 'iconUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.iconUrl) === 'string' ? entity.iconUrl : response === null || response === void 0 || (_response$meta$genera = response.meta.generator) === null || _response$meta$genera === void 0 || (_response$meta$genera = _response$meta$genera.icon) === null || _response$meta$genera === void 0 ? void 0 : _response$meta$genera.url;
        }
        return {
            url: url,
            label: entity === null || entity === void 0 ? void 0 : entity.displayName
        };
    }
};
const $fbc762445023dab4$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity;
        return (_extractEntity = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    return $fbc762445023dab4$export$b05803156e5015b6(response === null || response === void 0 ? void 0 : response.data, removeTextHighlightingFromTitle);
};
const $fbc762445023dab4$export$7ba9b12c6a1b73de = (response)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity2;
        return (_extractEntity2 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity2 === void 0 ? void 0 : _extractEntity2.url;
    }
    return $fbc762445023dab4$export$63f54cf4c5883620(response === null || response === void 0 ? void 0 : response.data);
};
const $fbc762445023dab4$export$16b02be3e2bb31ad = (response)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity3, _extractEntity4;
        return ((_extractEntity3 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity3 === void 0 ? void 0 : _extractEntity3.ari) || ((_extractEntity4 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity4 === void 0 ? void 0 : _extractEntity4.thirdPartyAri);
    }
    const data = response === null || response === void 0 ? void 0 : response.data;
    return $fbc762445023dab4$export$be18a6294fd426ec(data);
};
const $fbc762445023dab4$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $fbc762445023dab4$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $fbc762445023dab4$export$4b0d98b1b7f6d115(response === null || response === void 0 ? void 0 : response.data, 'web', iframeUrlType);
};
const $fbc762445023dab4$export$ff753ed519e96e9e = (response)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) return $fbc762445023dab4$export$ad879f2c9d5100a0(response);
    return (response === null || response === void 0 ? void 0 : response.data) && $fbc762445023dab4$export$a832871718466647(response === null || response === void 0 ? void 0 : response.data);
};
const $fbc762445023dab4$export$7a685df468cbf38f = (response)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity5;
        return (_extractEntity5 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity5 === void 0 ? void 0 : _extractEntity5.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && $fbc762445023dab4$export$e1226a5e0bbbf862(response.data);
};
const $fbc762445023dab4$export$75047940e157fd1f = (response)=>{
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity6;
        return (_extractEntity6 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity6 === void 0 ? void 0 : _extractEntity6.lastUpdatedAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && $fbc762445023dab4$export$7fc2f5e6f9d22ae7(response.data);
};
const $fbc762445023dab4$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity7;
        return (_extractEntity7 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity7 === void 0 || (_extractEntity7 = _extractEntity7.createdBy) === null || _extractEntity7 === void 0 ? void 0 : _extractEntity7.displayName;
    }
    const persons = $fbc762445023dab4$export$a66235cba0c9d11a(response.data);
    return !!(persons !== null && persons !== void 0 && persons.length) ? persons[0].name : undefined;
};
const $fbc762445023dab4$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        const entity = $fbc762445023dab4$export$8beff7405d020ddf(response);
        const owners = entity === null || entity === void 0 ? void 0 : entity.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $fbc762445023dab4$export$a66235cba0c9d11a(response.data);
};
const $fbc762445023dab4$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _extractEntity8;
        return (_extractEntity8 = $fbc762445023dab4$export$8beff7405d020ddf(response)) === null || _extractEntity8 === void 0 || (_extractEntity8 = _extractEntity8.lastUpdatedBy) === null || _extractEntity8 === void 0 ? void 0 : _extractEntity8.displayName;
    }
    const person = $fbc762445023dab4$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $fbc762445023dab4$export$96ed4c1b14ac210a = (response)=>{
    var _response$data;
    if ($fbc762445023dab4$export$c7168210b81d9383(response)) {
        var _entity$exportLinks;
        const entity = $fbc762445023dab4$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity === null || entity === void 0 || (_entity$exportLinks = entity.exportLinks) === null || _entity$exportLinks === void 0 ? void 0 : _entity$exportLinks[0].url : undefined;
    }
    return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data['atlassian:downloadUrl'];
};

});
parcelRegister("OSEp1", function(module, exports) {
$parcel$export(module.exports, "isBaseEntity", () => $50e674b2df591715$export$12af7c5462954d1e);
$parcel$export(module.exports, "isDesignEntity", () => $50e674b2df591715$export$8dc9be81b5b6266b);
$parcel$export(module.exports, "isDocumentEntity", () => $50e674b2df591715$export$32c06ee7e0e9b79e);
const $50e674b2df591715$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $50e674b2df591715$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $50e674b2df591715$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $50e674b2df591715$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $50e674b2df591715$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $50e674b2df591715$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $50e674b2df591715$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $50e674b2df591715$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $50e674b2df591715$var$asRecord = (value)=>value;
const $50e674b2df591715$export$12af7c5462954d1e = (value)=>$50e674b2df591715$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $50e674b2df591715$export$8dc9be81b5b6266b = (value)=>$50e674b2df591715$export$12af7c5462954d1e(value) && $50e674b2df591715$var$isOneOf($50e674b2df591715$var$DESIGN_STATUSES, $50e674b2df591715$var$asRecord(value).status) && $50e674b2df591715$var$isOneOf($50e674b2df591715$var$DESIGN_TYPES, $50e674b2df591715$var$asRecord(value).type);
const $50e674b2df591715$export$f16c4076686c1f5b = (value)=>{
    if (!$50e674b2df591715$export$12af7c5462954d1e(value)) return false;
    const entity = $50e674b2df591715$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $50e674b2df591715$var$isObject(remoteLink) && $50e674b2df591715$var$isOneOf($50e674b2df591715$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $50e674b2df591715$export$791f1b4852e2a184 = (value)=>$50e674b2df591715$export$12af7c5462954d1e(value) && $50e674b2df591715$var$isObject($50e674b2df591715$var$asRecord(value)['atlassian:project']);
const $50e674b2df591715$export$162dad7a1238d377 = (value)=>{
    if (!$50e674b2df591715$export$12af7c5462954d1e(value)) return false;
    const entity = $50e674b2df591715$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $50e674b2df591715$var$isObject(workItem) && typeof workItem.status === 'string' && $50e674b2df591715$var$isOneOf($50e674b2df591715$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $50e674b2df591715$export$32c06ee7e0e9b79e = (value)=>{
    if (!$50e674b2df591715$export$12af7c5462954d1e(value)) return false;
    const entityType = $50e674b2df591715$var$asRecord(value).type;
    return $50e674b2df591715$var$isObject(entityType) && (entityType.category === undefined || $50e674b2df591715$var$isOneOf($50e674b2df591715$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($50e674b2df591715$var$isOneOf($50e674b2df591715$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $50e674b2df591715$export$33e8c1bbf9148b0e = (value)=>$50e674b2df591715$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $50e674b2df591715$export$6c20afe8743cb761 = (value)=>$50e674b2df591715$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $50e674b2df591715$export$fe785532d894f833 = (value)=>$50e674b2df591715$export$12af7c5462954d1e(value) && !$50e674b2df591715$export$8dc9be81b5b6266b(value) && !$50e674b2df591715$export$f16c4076686c1f5b(value) && !$50e674b2df591715$export$791f1b4852e2a184(value) && !$50e674b2df591715$export$162dad7a1238d377(value) && !$50e674b2df591715$export$32c06ee7e0e9b79e(value) && !$50e674b2df591715$export$33e8c1bbf9148b0e(value) && !$50e674b2df591715$export$6c20afe8743cb761(value);
const $50e674b2df591715$export$47565ffe58e56845 = (value)=>$50e674b2df591715$export$12af7c5462954d1e(value) && ($50e674b2df591715$export$8dc9be81b5b6266b(value) || $50e674b2df591715$export$f16c4076686c1f5b(value) || $50e674b2df591715$export$791f1b4852e2a184(value) || $50e674b2df591715$export$162dad7a1238d377(value) || $50e674b2df591715$export$32c06ee7e0e9b79e(value) || $50e674b2df591715$export$33e8c1bbf9148b0e(value) || $50e674b2df591715$export$6c20afe8743cb761(value) || $50e674b2df591715$export$fe785532d894f833(value));

});

parcelRegister("l59Pd", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $ed1e475746eb184f$export$68f3db7f6af48bcb);

var $25hWk = parcelRequire("25hWk");

var $b8Op0 = parcelRequire("b8Op0");

var $d3EAZ = parcelRequire("d3EAZ");
const $ed1e475746eb184f$export$68f3db7f6af48bcb = (0, $b8Op0.createFeatureFlaggedComponent)((0, $d3EAZ.ConfluenceIcon), (0, $25hWk.ConfluenceIcon));

});
parcelRegister("25hWk", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $bec99a2f4ce5243f$export$68f3db7f6af48bcb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $bec99a2f4ce5243f$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>
</svg>
`;
const $bec99a2f4ce5243f$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>
</svg>
`;
function $bec99a2f4ce5243f$export$68f3db7f6af48bcb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $bec99a2f4ce5243f$var$svg,
        customThemeSvg: $bec99a2f4ce5243f$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("kvW6F", function(module, exports) {
$parcel$export(module.exports, "IconWrapper", () => $c9f357f5da591a1b$export$be58b4326e23250f);
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3H4LK = parcelRequire("3H4LK");

var $a1GvG = parcelRequire("a1GvG");
const $c9f357f5da591a1b$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $c9f357f5da591a1b$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $c9f357f5da591a1b$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $c9f357f5da591a1b$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $c9f357f5da591a1b$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $c9f357f5da591a1b$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $c9f357f5da591a1b$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $c9f357f5da591a1b$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $c9f357f5da591a1b$export$be58b4326e23250f({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $ltgDR.default)([
            $c9f357f5da591a1b$var$styles.root,
            $c9f357f5da591a1b$var$sizeMap[size],
            colorMode === 'dark' ? $c9f357f5da591a1b$var$dataCenterDarkAppearanceMap[appearance] : $c9f357f5da591a1b$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $c9f357f5da591a1b$var$rovoDarkAppearanceMap[appearance] : $c9f357f5da591a1b$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $c9f357f5da591a1b$var$cloudDarkAppearanceMap[appearance] : $c9f357f5da591a1b$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $3H4LK.fg)('assets-platform-branding') || (0, $3H4LK.fg)('assets-platform-branding-with-confluence')) && $c9f357f5da591a1b$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("b8Op0", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedComponent", () => $b8aba0a1806f323f$export$e30d2ddc605f6bb);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
const $b8aba0a1806f323f$export$e30d2ddc605f6bb = (LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: shouldUseNewLogoDesign, ...props })=>{
        if ((0, $3H4LK.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(NewComponent, {
            size: size || 'medium',
            ...props
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LegacyComponent, {
            size: size,
            ...props
        });
    };
};

});

parcelRegister("d3EAZ", function(module, exports) {
$parcel$export(module.exports, "ConfluenceIcon", () => $89e1b4c78c779a00$export$68f3db7f6af48bcb);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $89e1b4c78c779a00$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $89e1b4c78c779a00$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $89e1b4c78c779a00$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("iUUwu", function(module, exports) {
$parcel$export(module.exports, "defaultLogoParams", () => $51d4c2e27039f407$export$438460117ae6b7ee);
$parcel$export(module.exports, "legacyDefaultLogoParams", () => $51d4c2e27039f407$export$793fba32aed8942a);
const $51d4c2e27039f407$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
const $51d4c2e27039f407$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
};

});

parcelRegister("2zg7q", function(module, exports) {
$parcel$export(module.exports, "default", () => $93900b388f8956fe$export$2e2bcd8739ae039);
/* wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $93900b388f8956fe$var$CSS_VAR_COLOR = '--logo-color';
const $93900b388f8956fe$var$CSS_VAR_FILL = '--logo-fill';
const $93900b388f8956fe$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ const $93900b388f8956fe$var$Wrapper = ({ label: label, svg: svg, size: size, appearance: appearance, iconColor: iconColor, textColor: textColor, testId: userDefinedTestId, ...rest })=>{
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    const shouldApplyStopColor = appearance === undefined;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        style: {
            [$93900b388f8956fe$var$CSS_VAR_COLOR]: iconColor,
            [$93900b388f8956fe$var$CSS_VAR_FILL]: textColor
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        },
        ...rest,
        className: (0, $ltgDR.default)([
            $93900b388f8956fe$var$styles.root,
            shouldApplyStopColor && $93900b388f8956fe$var$styles.stop,
            size && $93900b388f8956fe$var$styles[size]
        ])
    });
};
var $93900b388f8956fe$export$2e2bcd8739ae039 = $93900b388f8956fe$var$Wrapper;

});

parcelRegister("dy27o", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearance", () => $d4f9dcd9254efb79$export$bbacc3980e0f3029);
const $d4f9dcd9254efb79$export$bbacc3980e0f3029 = (appearance, colorMode)=>{
    let iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});



parcelRegister("d543D", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $70c809a3637e6df6$export$ef8e5f836dd989d3);
$parcel$export(module.exports, "AssetsIcon", () => $70c809a3637e6df6$export$d89497e7f33ca6f5);
$parcel$export(module.exports, "ChatIcon", () => $70c809a3637e6df6$export$52cd484a7ef4f2b9);
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $70c809a3637e6df6$export$6da5aa77c402ba0f);
$parcel$export(module.exports, "FeedbackIcon", () => $70c809a3637e6df6$export$34420f0520b19b1d);
$parcel$export(module.exports, "GoalsIcon", () => $70c809a3637e6df6$export$9eb74917ea768ed4);
$parcel$export(module.exports, "HomeIcon", () => $70c809a3637e6df6$export$92c8767b874048d);
$parcel$export(module.exports, "HubIcon", () => $70c809a3637e6df6$export$80b8b269d8b5014e);
$parcel$export(module.exports, "ProjectsIcon", () => $70c809a3637e6df6$export$5ed3e1bb3b04fc02);
$parcel$export(module.exports, "RovoDevIcon", () => $70c809a3637e6df6$export$8b784b3227531b3e);
$parcel$export(module.exports, "SearchIcon", () => $70c809a3637e6df6$export$82eafebb825fc23f);
$parcel$export(module.exports, "StudioIcon", () => $70c809a3637e6df6$export$290a0f24614cde9f);
$parcel$export(module.exports, "TalentIcon", () => $70c809a3637e6df6$export$4b05688514531169);
$parcel$export(module.exports, "TeamsIcon", () => $70c809a3637e6df6$export$1bcbc9c337da86da);
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $70c809a3637e6df6$export$c42ad8a0b925c762);
$parcel$export(module.exports, "BitbucketIcon", () => $70c809a3637e6df6$export$5fc1066e677788d4);
$parcel$export(module.exports, "CompassIcon", () => $70c809a3637e6df6$export$f7857fe64d7161d9);
$parcel$export(module.exports, "DxIcon", () => $70c809a3637e6df6$export$9951d02c2d848122);
$parcel$export(module.exports, "ConfluenceIcon", () => $70c809a3637e6df6$export$68f3db7f6af48bcb);
$parcel$export(module.exports, "ConfluenceLogo", () => $70c809a3637e6df6$export$1b2e4fe6ef471556);
$parcel$export(module.exports, "JiraIcon", () => $70c809a3637e6df6$export$c4b5b1f965d8b3eb);
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $70c809a3637e6df6$export$21bfbeb62fdcce8d);
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $70c809a3637e6df6$export$3c6158790f5e01c4);
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $70c809a3637e6df6$export$dabef2be6cd28c20);
$parcel$export(module.exports, "LoomIcon", () => $70c809a3637e6df6$export$8d789f76fde3e05);
$parcel$export(module.exports, "OpsgenieIcon", () => $70c809a3637e6df6$export$eeccc49dc7a12d9f);
$parcel$export(module.exports, "StatuspageIcon", () => $70c809a3637e6df6$export$f3f5aa321d88adf9);
$parcel$export(module.exports, "TrelloIcon", () => $70c809a3637e6df6$export$4384da9b8b140bf4);
$parcel$export(module.exports, "RovoIcon", () => $70c809a3637e6df6$export$e23ae35269442b4f);
$parcel$export(module.exports, "GuardIcon", () => $70c809a3637e6df6$export$3f95fcfdc25a741d);
$parcel$export(module.exports, "FocusIcon", () => $70c809a3637e6df6$export$1e02e7298035a77c);

var $6LM5J = parcelRequire("6LM5J");
var $6IQJU = parcelRequire("6IQJU");

var $8Bt9m = parcelRequire("8Bt9m");
var $5nsB3 = parcelRequire("5nsB3");

var $1N1VJ = parcelRequire("1N1VJ");
var $dzEtG = parcelRequire("dzEtG");

var $l5jOx = parcelRequire("l5jOx");
var $7w7xx = parcelRequire("7w7xx");

var $9PGSb = parcelRequire("9PGSb");
var $9d0fw = parcelRequire("9d0fw");

var $gMXb1 = parcelRequire("gMXb1");
var $8WyRl = parcelRequire("8WyRl");

var $b2yTo = parcelRequire("b2yTo");
var $261xW = parcelRequire("261xW");

var $8cF97 = parcelRequire("8cF97");
var $eK5qe = parcelRequire("eK5qe");

var $7B2vG = parcelRequire("7B2vG");
var $dsyKh = parcelRequire("dsyKh");

var $25hWk = parcelRequire("25hWk");
var $4qdRd = parcelRequire("4qdRd");

var $6jQeG = parcelRequire("6jQeG");
var $e6ujL = parcelRequire("e6ujL");

var $59Y1E = parcelRequire("59Y1E");
var $lPNGZ = parcelRequire("lPNGZ");

var $5jBkP = parcelRequire("5jBkP");
var $aab0r = parcelRequire("aab0r");

var $d6zyI = parcelRequire("d6zyI");

var $aAI9D = parcelRequire("aAI9D");
var $2fq1P = parcelRequire("2fq1P");

var $loazT = parcelRequire("loazT");
var $hJRpk = parcelRequire("hJRpk");

var $fyppA = parcelRequire("fyppA");
var $hCnhq = parcelRequire("hCnhq");

var $7ajx3 = parcelRequire("7ajx3");
var $dRjS1 = parcelRequire("dRjS1");

var $d2gdv = parcelRequire("d2gdv");
var $ltNZ9 = parcelRequire("ltNZ9");

var $fKoME = parcelRequire("fKoME");
var $7aeNf = parcelRequire("7aeNf");

var $lmU4O = parcelRequire("lmU4O");
var $dfvAF = parcelRequire("dfvAF");

var $cvt5Y = parcelRequire("cvt5Y");

var $62Wck = parcelRequire("62Wck");
var $leEYy = parcelRequire("leEYy");

var $amvEl = parcelRequire("amvEl");
var $5h2HX = parcelRequire("5h2HX");

var $b7Nnf = parcelRequire("b7Nnf");
var $Lxdki = parcelRequire("Lxdki");

var $2sbSv = parcelRequire("2sbSv");
var $iiSQA = parcelRequire("iiSQA");

var $bHvjj = parcelRequire("bHvjj");
var $iyiu8 = parcelRequire("iyiu8");

var $afexM = parcelRequire("afexM");

var $9vPA3 = parcelRequire("9vPA3");
var $a6uNi = parcelRequire("a6uNi");

var $46Dt1 = parcelRequire("46Dt1");
var $0515y = parcelRequire("0515y");

var $hWaEm = parcelRequire("hWaEm");
var $ipCSx = parcelRequire("ipCSx");

var $iRvWA = parcelRequire("iRvWA");
var $56gzG = parcelRequire("56gzG");

var $3XKAU = parcelRequire("3XKAU");
var $3LvpE = parcelRequire("3LvpE");

var $hzyuh = parcelRequire("hzyuh");
var $b0HsC = parcelRequire("b0HsC");

var $1bPI8 = parcelRequire("1bPI8");
var $eWtvW = parcelRequire("eWtvW");

var $aBDTu = parcelRequire("aBDTu");
var $7YfWH = parcelRequire("7YfWH");

var $54S9z = parcelRequire("54S9z");
var $lWzWe = parcelRequire("lWzWe");

var $6eUDD = parcelRequire("6eUDD");
var $8v32d = parcelRequire("8v32d");

var $6qGjk = parcelRequire("6qGjk");
var $iyBEd = parcelRequire("iyBEd");

var $3llr8 = parcelRequire("3llr8");
var $fupeO = parcelRequire("fupeO");

var $gnyHa = parcelRequire("gnyHa");
var $3kOIs = parcelRequire("3kOIs");

var $b8Op0 = parcelRequire("b8Op0");

var $8PMQK = parcelRequire("8PMQK");

var $i2crb = parcelRequire("i2crb");
var $1Xtu6 = parcelRequire("1Xtu6");

var $hiDtH = parcelRequire("hiDtH");
var $4D0F8 = parcelRequire("4D0F8");

var $2qk4y = parcelRequire("2qk4y");
var $7kWUo = parcelRequire("7kWUo");

var $kX5ZZ = parcelRequire("kX5ZZ");
var $6xhB1 = parcelRequire("6xhB1");

var $2X5Rj = parcelRequire("2X5Rj");
var $lPKVu = parcelRequire("lPKVu");

var $d3EAZ = parcelRequire("d3EAZ");
var $lh1Qu = parcelRequire("lh1Qu");

var $ijOSX = parcelRequire("ijOSX");
var $erp1f = parcelRequire("erp1f");

var $8DBpt = parcelRequire("8DBpt");
var $2FopA = parcelRequire("2FopA");

var $fQhtW = parcelRequire("fQhtW");
var $9tqsh = parcelRequire("9tqsh");

var $eNLXd = parcelRequire("eNLXd");
var $19h8Z = parcelRequire("19h8Z");

var $eTafg = parcelRequire("eTafg");
var $50GFn = parcelRequire("50GFn");

var $9CRbo = parcelRequire("9CRbo");
var $7pdCN = parcelRequire("7pdCN");

var $2gbp9 = parcelRequire("2gbp9");
var $6LxUG = parcelRequire("6LxUG");

var $aB2vm = parcelRequire("aB2vm");
var $hxZPt = parcelRequire("hxZPt");

var $fCGbk = parcelRequire("fCGbk");
var $7jVcv = parcelRequire("7jVcv");

var $01aTx = parcelRequire("01aTx");
var $jn7YU = parcelRequire("jn7YU");

var $dzrID = parcelRequire("dzrID");
var $lhzSc = parcelRequire("lhzSc");

var $2P2qs = parcelRequire("2P2qs");
var $e6ZcJ = parcelRequire("e6ZcJ");




var $lEFyQ = parcelRequire("lEFyQ");

var $1y0uJ = parcelRequire("1y0uJ");

var $kDNxG = parcelRequire("kDNxG");

var $fABNK = parcelRequire("fABNK");

var $jb0Si = parcelRequire("jb0Si");
const $70c809a3637e6df6$export$ef8e5f836dd989d3 = (0, $jb0Si.tempSizeWrapper)((0, $6LM5J.AdminIcon));
const $70c809a3637e6df6$export$ebcd30672e67406 = (0, $jb0Si.tempSizeWrapper)((0, $6IQJU.AdminLogoCS));
const $70c809a3637e6df6$export$af3460f51ce3602a = (0, $jb0Si.tempSizeWrapper)((0, $1N1VJ.AnalyticsIcon));
const $70c809a3637e6df6$export$c8415b6abe4a8587 = (0, $jb0Si.tempSizeWrapper)((0, $dzEtG.AnalyticsLogoCS));
const $70c809a3637e6df6$export$d89497e7f33ca6f5 = (0, $jb0Si.tempSizeWrapper)((0, $l5jOx.AssetsIcon));
const $70c809a3637e6df6$export$48ca930f3071e3e4 = (0, $jb0Si.tempSizeWrapper)((0, $7w7xx.AssetsLogoCS));
const $70c809a3637e6df6$export$52cd484a7ef4f2b9 = (0, $jb0Si.tempSizeWrapper)((0, $8cF97.ChatIcon));
const $70c809a3637e6df6$export$9ca9881809919df8 = (0, $jb0Si.tempSizeWrapper)((0, $eK5qe.ChatLogoCS));
const $70c809a3637e6df6$export$6da5aa77c402ba0f = (0, $jb0Si.tempSizeWrapper)((0, $5jBkP.CustomerServiceManagementIcon));
const $70c809a3637e6df6$export$abc95e6180bb1d88 = (0, $jb0Si.tempSizeWrapper)((0, $aab0r.CustomerServiceManagementLogoCS));
const $70c809a3637e6df6$export$34420f0520b19b1d = (0, $jb0Si.tempSizeWrapper)((0, $aAI9D.FeedbackIcon));
const $70c809a3637e6df6$export$c9696eb3c34c5a96 = (0, $jb0Si.tempSizeWrapper)((0, $2fq1P.FeedbackLogoCS));
const $70c809a3637e6df6$export$9eb74917ea768ed4 = (0, $jb0Si.tempSizeWrapper)((0, $fyppA.GoalsIcon));
const $70c809a3637e6df6$export$d2577aa28451395f = (0, $jb0Si.tempSizeWrapper)((0, $hCnhq.GoalsLogoCS));
const $70c809a3637e6df6$export$92c8767b874048d = (0, $jb0Si.tempSizeWrapper)((0, $d2gdv.HomeIcon));
const $70c809a3637e6df6$export$d5648119d5b68e90 = (0, $jb0Si.tempSizeWrapper)((0, $ltNZ9.HomeLogoCS));
const $70c809a3637e6df6$export$80b8b269d8b5014e = (0, $jb0Si.tempSizeWrapper)((0, $fKoME.HubIcon));
const $70c809a3637e6df6$export$fc9bd6687b80fe3b = (0, $jb0Si.tempSizeWrapper)((0, $7aeNf.HubLogoCS));
const $70c809a3637e6df6$export$5ed3e1bb3b04fc02 = (0, $jb0Si.tempSizeWrapper)((0, $hWaEm.ProjectsIcon));
const $70c809a3637e6df6$export$aeefab651bcf2338 = (0, $jb0Si.tempSizeWrapper)((0, $ipCSx.ProjectsLogoCS));
const $70c809a3637e6df6$export$8b784b3227531b3e = (0, $jb0Si.tempSizeWrapper)((0, $3XKAU.RovoDevIcon));
const $70c809a3637e6df6$export$f0750468d67c6902 = (0, $jb0Si.tempSizeWrapper)((0, $3LvpE.RovoDevLogoCS));
const $70c809a3637e6df6$export$813cff80931d9dbf = (0, $jb0Si.tempSizeWrapper)((0, $hzyuh.RovoDevAgentIcon));
const $70c809a3637e6df6$export$409b7a5b7f180eba = (0, $jb0Si.tempSizeWrapper)((0, $b0HsC.RovoDevAgentLogoCS));
const $70c809a3637e6df6$export$b12fec207e8537a8 = (0, $jb0Si.tempSizeWrapper)((0, $cvt5Y.JiraCodingAgentIcon));
const $70c809a3637e6df6$export$82eafebb825fc23f = (0, $jb0Si.tempSizeWrapper)((0, $aBDTu.SearchIcon));
const $70c809a3637e6df6$export$e4c5487c9a8ae3b1 = (0, $jb0Si.tempSizeWrapper)((0, $7YfWH.SearchLogoCS));
const $70c809a3637e6df6$export$290a0f24614cde9f = (0, $jb0Si.tempSizeWrapper)((0, $6eUDD.StudioIcon));
const $70c809a3637e6df6$export$8aceb78c659789b6 = (0, $jb0Si.tempSizeWrapper)((0, $8v32d.StudioLogoCS));
const $70c809a3637e6df6$export$4b05688514531169 = (0, $jb0Si.tempSizeWrapper)((0, $6qGjk.TalentIcon));
const $70c809a3637e6df6$export$4f6453e012279f89 = (0, $jb0Si.tempSizeWrapper)((0, $iyBEd.TalentLogoCS));
const $70c809a3637e6df6$export$1bcbc9c337da86da = (0, $jb0Si.tempSizeWrapper)((0, $3llr8.TeamsIcon));
const $70c809a3637e6df6$export$9b1a0a0c574cec2a = (0, $jb0Si.tempSizeWrapper)((0, $fupeO.TeamsLogoCS));
const $70c809a3637e6df6$export$e812398311cab9a3 = (0, $jb0Si.tempSizeWrapper)((0, $9PGSb.BambooIcon));
const $70c809a3637e6df6$export$765f5afcc1a5a7e3 = (0, $jb0Si.tempSizeWrapper)((0, $9d0fw.BambooLogoCS));
const $70c809a3637e6df6$export$d3ab16bbf4f954ee = (0, $jb0Si.tempSizeWrapper)((0, $b2yTo.BitbucketDataCenterIcon));
const $70c809a3637e6df6$export$36044946916e84a0 = (0, $jb0Si.tempSizeWrapper)((0, $261xW.BitbucketDataCenterLogoCS));
const $70c809a3637e6df6$export$53305f1f2855d3be = (0, $jb0Si.tempSizeWrapper)((0, $6jQeG.ConfluenceDataCenterIcon));
const $70c809a3637e6df6$export$5e06396bce773a3 = (0, $jb0Si.tempSizeWrapper)((0, $e6ujL.ConfluenceDataCenterLogoCS));
const $70c809a3637e6df6$export$eaf73f391f7103bd = (0, $jb0Si.tempSizeWrapper)((0, $59Y1E.CrowdIcon));
const $70c809a3637e6df6$export$6128b385660fd3c6 = (0, $jb0Si.tempSizeWrapper)((0, $lPNGZ.CrowdLogoCS));
const $70c809a3637e6df6$export$f8455b5667a3ee0c = (0, $jb0Si.tempSizeWrapper)((0, $62Wck.JiraDataCenterIcon));
const $70c809a3637e6df6$export$eb152ab3801b2ae3 = (0, $jb0Si.tempSizeWrapper)((0, $leEYy.JiraDataCenterLogoCS));
const $70c809a3637e6df6$export$65fae0eaf343f2ca = (0, $jb0Si.tempSizeWrapper)((0, $2sbSv.JiraServiceManagementDataCenterIcon));
const $70c809a3637e6df6$export$fffc0d480fb1ebf1 = (0, $jb0Si.tempSizeWrapper)((0, $iiSQA.JiraServiceManagementDataCenterLogoCS));
const $70c809a3637e6df6$export$74517ed253186308 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $hiDtH.AtlassianAdministrationIcon), (0, $6LM5J.AdminIcon));
const $70c809a3637e6df6$export$833abe6c2ce5ebfd = (0, $b8Op0.createFeatureFlaggedComponent)((0, $4D0F8.AtlassianAdministrationLogo), (0, $6IQJU.AdminLogoCS));
const $70c809a3637e6df6$export$84109e099492cb5f = (0, $b8Op0.createFeatureFlaggedComponent)((0, $i2crb.AtlassianAdminIcon), (0, $6LM5J.AdminIcon));
const $70c809a3637e6df6$export$f845d9b9254f0541 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $1Xtu6.AtlassianAdminLogo), (0, $6IQJU.AdminLogoCS));
const $70c809a3637e6df6$export$c42ad8a0b925c762 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $2qk4y.AtlassianAnalyticsIcon), (0, $1N1VJ.AnalyticsIcon));
const $70c809a3637e6df6$export$e6470bfc39010cc4 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $7kWUo.AtlassianAnalyticsLogo), (0, $dzEtG.AnalyticsLogoCS));
const $70c809a3637e6df6$export$5fc1066e677788d4 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $kX5ZZ.BitbucketIcon), (0, $gMXb1.BitbucketIcon));
const $70c809a3637e6df6$export$bd40525f5333524b = (0, $b8Op0.createFeatureFlaggedComponent)((0, $6xhB1.BitbucketLogo), (0, $8WyRl.BitbucketLogoCS));
const $70c809a3637e6df6$export$f7857fe64d7161d9 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $2X5Rj.CompassIcon), (0, $7B2vG.CompassIcon));
const $70c809a3637e6df6$export$eb7d748e4f9c9676 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $lPKVu.CompassLogo), (0, $dsyKh.CompassLogoCS));
const $70c809a3637e6df6$export$9951d02c2d848122 = (0, $jb0Si.tempSizeWrapper)((0, $d6zyI.DxIcon));
const $70c809a3637e6df6$export$68f3db7f6af48bcb = (0, $b8Op0.createFeatureFlaggedComponent)((0, $d3EAZ.ConfluenceIcon), (0, $25hWk.ConfluenceIcon));
const $70c809a3637e6df6$export$1b2e4fe6ef471556 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $lh1Qu.ConfluenceLogo), (0, $4qdRd.ConfluenceLogoCS));
const $70c809a3637e6df6$export$70a0c2f5862937b6 = (0, $jb0Si.tempSizeWrapper)((0, $8Bt9m.AlignIcon));
const $70c809a3637e6df6$export$1b8596b4b0ef673b = (0, $jb0Si.tempSizeWrapper)((0, $5nsB3.AlignLogoCS));
const $70c809a3637e6df6$export$407687b2dd89cc68 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $eNLXd.JiraAlignIcon), (0, $8Bt9m.AlignIcon));
const $70c809a3637e6df6$export$ee11e928d3d045fd = (0, $b8Op0.createFeatureFlaggedComponent)((0, $19h8Z.JiraAlignLogo), (0, $5nsB3.AlignLogoCS));
const $70c809a3637e6df6$export$c4b5b1f965d8b3eb = (0, $b8Op0.createFeatureFlaggedComponent)((0, $fQhtW.JiraIcon), (0, $lmU4O.JiraIcon));
const $70c809a3637e6df6$export$17d3acb0b4379d02 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $9tqsh.JiraLogo), (0, $dfvAF.JiraLogoCS));
const $70c809a3637e6df6$export$21bfbeb62fdcce8d = (0, $b8Op0.createFeatureFlaggedComponent)((0, $eTafg.JiraProductDiscoveryIcon), (0, $amvEl.JiraProductDiscoveryIcon));
const $70c809a3637e6df6$export$c49a2b642fe9eef4 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $50GFn.JiraProductDiscoveryLogo), (0, $5h2HX.JiraProductDiscoveryLogoCS));
const $70c809a3637e6df6$export$3c6158790f5e01c4 = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)((0, $9CRbo.JiraServiceManagementIcon), (0, $b7Nnf.JiraServiceManagementIcon));
const $70c809a3637e6df6$export$dabef2be6cd28c20 = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)((0, $7pdCN.JiraServiceManagementLogo), (0, $Lxdki.JiraServiceManagementLogoCS));
const $70c809a3637e6df6$export$8d789f76fde3e05 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $2gbp9.LoomIcon), (0, $bHvjj.LoomIcon));
const $70c809a3637e6df6$export$94e206806e36c2ec = (0, $b8Op0.createFeatureFlaggedComponent)((0, $6LxUG.LoomLogo), (0, $iyiu8.LoomLogoCS));
const $70c809a3637e6df6$export$1bf47cdade1a9fcb = (0, $b8Op0.createFeatureFlaggedComponent)((0, $aB2vm.LoomAttributionIcon), (0, $bHvjj.LoomIcon));
const $70c809a3637e6df6$export$6e87ce8d41eda665 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $hxZPt.LoomAttributionLogo), (0, $afexM.LoomAttributionLogoCS));
const $70c809a3637e6df6$export$e84e925618e0e5bc = (0, $jb0Si.tempSizeWrapper)((0, $a6uNi.LoomInternalLogoCS));
const $70c809a3637e6df6$export$1940ba72c868b663 = (0, $jb0Si.tempSizeWrapper)((0, $9vPA3.LoomInternalIcon));
const $70c809a3637e6df6$export$eeccc49dc7a12d9f = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)((0, $fCGbk.OpsgenieIcon), (0, $46Dt1.OpsgenieIcon));
const $70c809a3637e6df6$export$a1c6484cdecc2c4b = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)((0, $7jVcv.OpsgenieLogo), (0, $0515y.OpsgenieLogoCS));
const $70c809a3637e6df6$export$f3f5aa321d88adf9 = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)((0, $dzrID.StatuspageIcon), (0, $54S9z.StatuspageIcon));
const $70c809a3637e6df6$export$bb4ae5b41b43be04 = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)((0, $lhzSc.StatuspageLogo), (0, $lWzWe.StatuspageLogoCS));
const $70c809a3637e6df6$export$4384da9b8b140bf4 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $2P2qs.TrelloIcon), (0, $gnyHa.TrelloIcon));
const $70c809a3637e6df6$export$60e26212f3b61a28 = (0, $b8Op0.createFeatureFlaggedComponent)((0, $e6ZcJ.TrelloLogo), (0, $3kOIs.TrelloLogoCS));
const $70c809a3637e6df6$export$e23ae35269442b4f = (0, $fABNK.createFeatureFlaggedRovoComponent)((0, $01aTx.RovoIcon), (0, $iRvWA.RovoIcon), (0, $1bPI8.RovoHexIcon));
const $70c809a3637e6df6$export$a0f6cb8061290bbb = (0, $fABNK.createFeatureFlaggedRovoComponent)((0, $jn7YU.RovoLogo), (0, $56gzG.RovoLogoCS), (0, $eWtvW.RovoHexLogoCS));
const $70c809a3637e6df6$export$3f95fcfdc25a741d = (0, $b8Op0.createFeatureFlaggedComponent)((0, $8DBpt.GuardIcon), (0, $7ajx3.GuardIcon));
const $70c809a3637e6df6$export$a4a891d202775deb = (0, $b8Op0.createFeatureFlaggedComponent)((0, $2FopA.GuardLogo), (0, $dRjS1.GuardLogoCS));
const $70c809a3637e6df6$export$1e02e7298035a77c = (0, $b8Op0.createFeatureFlaggedComponent)((0, $ijOSX.FocusIcon), (0, $loazT.FocusIcon));
const $70c809a3637e6df6$export$33908560ea1b226d = (0, $b8Op0.createFeatureFlaggedComponent)((0, $erp1f.FocusLogo), (0, $hJRpk.FocusLogoCS));

});
parcelRegister("6LM5J", function(module, exports) {
$parcel$export(module.exports, "AdminIcon", () => $19046e6afff85b33$export$ef8e5f836dd989d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $19046e6afff85b33$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>
</svg>
`;
function $19046e6afff85b33$export$ef8e5f836dd989d3({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $19046e6afff85b33$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6IQJU", function(module, exports) {
$parcel$export(module.exports, "AdminLogoCS", () => $b839678a579db479$export$61afcb38c001e19);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b839678a579db479$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>
</svg>
`;
function $b839678a579db479$export$61afcb38c001e19({ size: size, appearance: appearance = 'brand', label: label = 'Admin', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $b839678a579db479$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("9J5zS", function(module, exports) {
$parcel$export(module.exports, "LogoWrapper", () => $b07880a23ca6d009$export$f827d3c5a9c3f644);
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3H4LK = parcelRequire("3H4LK");

var $a1GvG = parcelRequire("a1GvG");
const $b07880a23ca6d009$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
const $b07880a23ca6d009$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
const $b07880a23ca6d009$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b07880a23ca6d009$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b07880a23ca6d009$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b07880a23ca6d009$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b07880a23ca6d009$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b07880a23ca6d009$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $b07880a23ca6d009$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
const $b07880a23ca6d009$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
const $b07880a23ca6d009$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $b07880a23ca6d009$export$f827d3c5a9c3f644({ appearance: appearance = 'brand', size: size = 'small', svg: svg, customThemeSvg: customThemeSvg, label: label, testId: userDefinedTestId, iconColor: customIconColor, textColor: customTextColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        // If the label is provided an empty string, we want to remove the element from the accessibility tree.
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // We are using dangerouslySetInnerHTML here to tell React not to track changes to the SVG elements.
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $ltgDR.default)([
            $b07880a23ca6d009$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $b07880a23ca6d009$var$logoTextColorMap[colorMode ?? 'light'],
            $b07880a23ca6d009$var$sizeMap[size],
            colorMode === 'dark' ? $b07880a23ca6d009$var$textDarkAppearanceMap[appearance] : $b07880a23ca6d009$var$textLightAppearanceMap[appearance],
            colorMode === 'dark' ? $b07880a23ca6d009$var$dataCenterDarkAppearanceMap[appearance] : $b07880a23ca6d009$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $b07880a23ca6d009$var$rovoDarkAppearanceMap[appearance] : $b07880a23ca6d009$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $b07880a23ca6d009$var$cloudDarkAppearanceMap[appearance] : $b07880a23ca6d009$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $3H4LK.fg)('assets-platform-branding') || (0, $3H4LK.fg)('assets-platform-branding-with-confluence')) && $b07880a23ca6d009$var$styles.TEMP_assets
        ])
    });
}

});


parcelRegister("8Bt9m", function(module, exports) {
$parcel$export(module.exports, "AlignIcon", () => $a3341fdab0fd820e$export$70a0c2f5862937b6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a3341fdab0fd820e$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>
</svg>
`;
function $a3341fdab0fd820e$export$70a0c2f5862937b6({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $a3341fdab0fd820e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5nsB3", function(module, exports) {
$parcel$export(module.exports, "AlignLogoCS", () => $214d6eb0fb344f86$export$8b5103382c06639c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $214d6eb0fb344f86$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>
</svg>
`;
function $214d6eb0fb344f86$export$8b5103382c06639c({ size: size, appearance: appearance = 'brand', label: label = 'Align', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $214d6eb0fb344f86$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1N1VJ", function(module, exports) {
$parcel$export(module.exports, "AnalyticsIcon", () => $acec35038979861c$export$af3460f51ce3602a);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $acec35038979861c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>
</svg>
`;
function $acec35038979861c$export$af3460f51ce3602a({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $acec35038979861c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dzEtG", function(module, exports) {
$parcel$export(module.exports, "AnalyticsLogoCS", () => $db41a90023781529$export$f0bac2b7ac3e3504);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $db41a90023781529$var$svg = `<svg height="100%" viewBox="0 0 161 32">
    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>
</svg>
`;
function $db41a90023781529$export$f0bac2b7ac3e3504({ size: size, appearance: appearance = 'brand', label: label = 'Analytics', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $db41a90023781529$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("l5jOx", function(module, exports) {
$parcel$export(module.exports, "AssetsIcon", () => $7c10956df941d46c$export$d89497e7f33ca6f5);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $7c10956df941d46c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>
</svg>
`;
const $7c10956df941d46c$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>
</svg>
`;
function $7c10956df941d46c$export$d89497e7f33ca6f5({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $7c10956df941d46c$var$svg,
        customThemeSvg: $7c10956df941d46c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7w7xx", function(module, exports) {
$parcel$export(module.exports, "AssetsLogoCS", () => $d88ed27df6ef3773$export$81c47abe19675c4c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d88ed27df6ef3773$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>
</svg>
`;
function $d88ed27df6ef3773$export$81c47abe19675c4c({ size: size, appearance: appearance = 'brand', label: label = 'Assets', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $d88ed27df6ef3773$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9PGSb", function(module, exports) {
$parcel$export(module.exports, "BambooIcon", () => $98e6509e86290811$export$e812398311cab9a3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $98e6509e86290811$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>
</svg>
`;
function $98e6509e86290811$export$e812398311cab9a3({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $98e6509e86290811$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9d0fw", function(module, exports) {
$parcel$export(module.exports, "BambooLogoCS", () => $0242263ed935824d$export$7c51958462d750e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $0242263ed935824d$var$svg = `<svg height="100%" viewBox="0 0 154 32">
    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>
</svg>
`;
function $0242263ed935824d$export$7c51958462d750e({ size: size, appearance: appearance = 'brand', label: label = 'Bamboo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $0242263ed935824d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gMXb1", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $ff9959e787bc7815$export$5fc1066e677788d4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ff9959e787bc7815$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $ff9959e787bc7815$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
function $ff9959e787bc7815$export$5fc1066e677788d4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $ff9959e787bc7815$var$svg,
        customThemeSvg: $ff9959e787bc7815$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8WyRl", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogoCS", () => $9f9baf82978be5a2$export$f7ef5e5488e4b430);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $9f9baf82978be5a2$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>
</svg>
`;
function $9f9baf82978be5a2$export$f7ef5e5488e4b430({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $9f9baf82978be5a2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b2yTo", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterIcon", () => $2e6dc848b40cbec1$export$d3ab16bbf4f954ee);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2e6dc848b40cbec1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>
</svg>
`;
function $2e6dc848b40cbec1$export$d3ab16bbf4f954ee({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $2e6dc848b40cbec1$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("261xW", function(module, exports) {
$parcel$export(module.exports, "BitbucketDataCenterLogoCS", () => $8826d0ff5e2b2856$export$cc55e2a4c4b40552);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $8826d0ff5e2b2856$var$svg = `<svg height="100%" viewBox="0 0 166 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>
</svg>
`;
function $8826d0ff5e2b2856$export$cc55e2a4c4b40552({ size: size, appearance: appearance = 'brand', label: label = 'Bitbucket Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $8826d0ff5e2b2856$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8cF97", function(module, exports) {
$parcel$export(module.exports, "ChatIcon", () => $10c4b8e4e365860b$export$52cd484a7ef4f2b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2ff2e36e1653e53734b97e7db9892da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $10c4b8e4e365860b$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>
</svg>
`;
function $10c4b8e4e365860b$export$52cd484a7ef4f2b9({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $10c4b8e4e365860b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eK5qe", function(module, exports) {
$parcel$export(module.exports, "ChatLogoCS", () => $64848bb350d17fa2$export$a529e78951cd6709);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c1cf578ed3b2b56aa2f85ac93abd2ba>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $64848bb350d17fa2$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>
</svg>
`;
function $64848bb350d17fa2$export$a529e78951cd6709({ size: size, appearance: appearance = 'brand', label: label = 'Chat', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $64848bb350d17fa2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7B2vG", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $f2740b94be1810c4$export$f7857fe64d7161d9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $f2740b94be1810c4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
function $f2740b94be1810c4$export$f7857fe64d7161d9({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $f2740b94be1810c4$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dsyKh", function(module, exports) {
$parcel$export(module.exports, "CompassLogoCS", () => $153879840909732c$export$a16f50a81d183ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $153879840909732c$var$svg = `<svg height="100%" viewBox="0 0 162 32">
    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>
</svg>
`;
function $153879840909732c$export$a16f50a81d183ce({ size: size, appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $153879840909732c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4qdRd", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogoCS", () => $9d89e7aeec78acef$export$a88b0b0da9ef63ce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $9d89e7aeec78acef$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>
</svg>
`;
function $9d89e7aeec78acef$export$a88b0b0da9ef63ce({ size: size, appearance: appearance = 'brand', label: label = 'Confluence', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $9d89e7aeec78acef$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6jQeG", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterIcon", () => $e146c3e00cfbea17$export$53305f1f2855d3be);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e146c3e00cfbea17$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>
</svg>
`;
function $e146c3e00cfbea17$export$53305f1f2855d3be({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $e146c3e00cfbea17$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("e6ujL", function(module, exports) {
$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", () => $423110e9202f95b8$export$b3e508cb103e1f93);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $423110e9202f95b8$var$svg = `<svg height="100%" viewBox="0 0 188 32">
    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>
</svg>
`;
function $423110e9202f95b8$export$b3e508cb103e1f93({ size: size, appearance: appearance = 'brand', label: label = 'Confluence Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $423110e9202f95b8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("59Y1E", function(module, exports) {
$parcel$export(module.exports, "CrowdIcon", () => $a47fe81e887123c3$export$eaf73f391f7103bd);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a47fe81e887123c3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>
</svg>
`;
function $a47fe81e887123c3$export$eaf73f391f7103bd({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $a47fe81e887123c3$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lPNGZ", function(module, exports) {
$parcel$export(module.exports, "CrowdLogoCS", () => $24dbdc2fdeed1505$export$3c371bdbcdfcdce);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $24dbdc2fdeed1505$var$svg = `<svg height="100%" viewBox="0 0 126 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>
</svg>
`;
function $24dbdc2fdeed1505$export$3c371bdbcdfcdce({ size: size, appearance: appearance = 'brand', label: label = 'Crowd', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $24dbdc2fdeed1505$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5jBkP", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementIcon", () => $16bebd966f1697fb$export$6da5aa77c402ba0f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $16bebd966f1697fb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>
</svg>
`;
const $16bebd966f1697fb$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>
</svg>
`;
function $16bebd966f1697fb$export$6da5aa77c402ba0f({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $16bebd966f1697fb$var$svg,
        customThemeSvg: $16bebd966f1697fb$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aab0r", function(module, exports) {
$parcel$export(module.exports, "CustomerServiceManagementLogoCS", () => $487daa5ec40e5af9$export$f597f0f7fadce0b9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $487daa5ec40e5af9$var$svg = `<svg height="100%" viewBox="0 0 456 32">
    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>
</svg>
`;
function $487daa5ec40e5af9$export$f597f0f7fadce0b9({ size: size, appearance: appearance = 'brand', label: label = 'Customer Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $487daa5ec40e5af9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d6zyI", function(module, exports) {
$parcel$export(module.exports, "DxIcon", () => $be849c4b419c7c82$export$9951d02c2d848122);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $be849c4b419c7c82$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>
    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>
</svg>
`;
function $be849c4b419c7c82$export$9951d02c2d848122({ size: size, appearance: appearance = 'brand', label: label = 'Dx', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $be849c4b419c7c82$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aAI9D", function(module, exports) {
$parcel$export(module.exports, "FeedbackIcon", () => $2eb986b5027ce4f6$export$34420f0520b19b1d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43275811237134a9433985263fbf7530>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $2eb986b5027ce4f6$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#c97cf4)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z"/>
</svg>
`;
function $2eb986b5027ce4f6$export$34420f0520b19b1d({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $2eb986b5027ce4f6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2fq1P", function(module, exports) {
$parcel$export(module.exports, "FeedbackLogoCS", () => $bff28922024edf47$export$bbccafb125ebd50c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5e0dda3588cef089e80240144a089b0a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $bff28922024edf47$var$svg = `<svg height="100%" viewBox="0 0 169 32">
    <path fill="var(--text-color, #1e1f21)" d="M157.894 25.334h-2.638V3.59h2.638v13.585L164.487 10h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.177zm-5.648-2.761v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.489s1.656 5.49 5.674 5.49c1.564 0 2.545-.215 3.496-.553m-26.118-4.906c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.638v15.333zm-16.09-7.666c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.502-4.478 4.906v1.227c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.698H107.4V3.592h2.637v9.17c.982-2.025 2.822-3.068 5.183-3.068 4.079 0 6.133 3.466 6.133 7.974 0 4.324-2.146 7.973-6.44 7.973m-22.806-7.974c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.508 1.963-4.508 5.52m8.678 7.666v-2.76c-.981 2.024-2.821 3.067-5.182 3.067-4.08 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.013 4.876 3.006V3.59h2.638v21.743zM80.502 12.085c-2.79 0-4.201 1.81-4.477 4.478h8.555c-.153-2.852-1.44-4.478-4.078-4.478M86.39 24.72c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.625 3.282 6.625 7.943v1.196H76.055c.368 2.607 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zM64.42 12.085c-2.79 0-4.202 1.81-4.477 4.478h8.556c-.154-2.852-1.442-4.478-4.08-4.478m5.888 12.635c-1.258.675-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.238-7.943 4.722 0 6.623 3.282 6.623 7.943v1.196H59.974c.368 2.607 2.055 4.293 5.674 4.293 1.778 0 3.28-.337 4.66-.828zm-15.679-6.9H45.49v7.514h-2.76V5.186h12.94v2.637H45.49v7.36h9.138z"/>
    <rect width="32" height="32" fill="var(--tile-color,#c97cf4)" rx="8"/>
    <path fill="var(--icon-color, #101214)" d="M13.333 12.667h3.334V20h-3.334zm4.667-6h3.333v18.666H18zm4.667 4H26v10.666h-3.333zm-14 0H12v10.666H8.667zM4 14h3.333v4.666H4z"/>
</svg>
`;
function $bff28922024edf47$export$bbccafb125ebd50c({ size: size, appearance: appearance = 'brand', label: label = 'Feedback', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $bff28922024edf47$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("loazT", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $8a5da8097d022b34$export$1e02e7298035a77c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $8a5da8097d022b34$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>
</svg>
`;
function $8a5da8097d022b34$export$1e02e7298035a77c({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $8a5da8097d022b34$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hJRpk", function(module, exports) {
$parcel$export(module.exports, "FocusLogoCS", () => $c0147217f9611cc7$export$3a6e8b37e069a69d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $c0147217f9611cc7$var$svg = `<svg height="100%" viewBox="0 0 117 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>
</svg>
`;
function $c0147217f9611cc7$export$3a6e8b37e069a69d({ size: size, appearance: appearance = 'brand', label: label = 'Focus', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $c0147217f9611cc7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fyppA", function(module, exports) {
$parcel$export(module.exports, "GoalsIcon", () => $e87da9ef2d2ebcef$export$9eb74917ea768ed4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e87da9ef2d2ebcef$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
function $e87da9ef2d2ebcef$export$9eb74917ea768ed4({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $e87da9ef2d2ebcef$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hCnhq", function(module, exports) {
$parcel$export(module.exports, "GoalsLogoCS", () => $6368af31953fcb7a$export$c527a545aa426db3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $6368af31953fcb7a$var$svg = `<svg height="100%" viewBox="0 0 116 32">
    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>
</svg>
`;
function $6368af31953fcb7a$export$c527a545aa426db3({ size: size, appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $6368af31953fcb7a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7ajx3", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $76ab7cb05582dc20$export$3f95fcfdc25a741d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $76ab7cb05582dc20$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
function $76ab7cb05582dc20$export$3f95fcfdc25a741d({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $76ab7cb05582dc20$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dRjS1", function(module, exports) {
$parcel$export(module.exports, "GuardLogoCS", () => $4d9d8109f489da89$export$2b896c4d595a4331);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4d9d8109f489da89$var$svg = `<svg height="100%" viewBox="0 0 120 32">
    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>
</svg>
`;
function $4d9d8109f489da89$export$2b896c4d595a4331({ size: size, appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $4d9d8109f489da89$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d2gdv", function(module, exports) {
$parcel$export(module.exports, "HomeIcon", () => $ba52903dfc64dd05$export$92c8767b874048d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ba52903dfc64dd05$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>
</svg>
`;
function $ba52903dfc64dd05$export$92c8767b874048d({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $ba52903dfc64dd05$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ltNZ9", function(module, exports) {
$parcel$export(module.exports, "HomeLogoCS", () => $7a9c5e335f7616b5$export$8b6b7f1b1b2367d3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7a9c5e335f7616b5$var$svg = `<svg height="100%" viewBox="0 0 121 32">
    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>
</svg>
`;
function $7a9c5e335f7616b5$export$8b6b7f1b1b2367d3({ size: size, appearance: appearance = 'brand', label: label = 'Home', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $7a9c5e335f7616b5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fKoME", function(module, exports) {
$parcel$export(module.exports, "HubIcon", () => $e7e1773f3a74aa19$export$80b8b269d8b5014e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e7e1773f3a74aa19$var$svg = `<svg height="100%" viewBox="0 0 32 32">
    <g clip-path="url(#clip0_95164_16219)">
        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
        <g clip-path="url(#clip1_95164_16219)">
            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
        </g>
    </g>
    <defs>
        <clipPath id="clip0_95164_16219">
            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>
        </clipPath>
        <clipPath id="clip1_95164_16219">
            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>
        </clipPath>
    </defs>
</svg>
`;
function $e7e1773f3a74aa19$export$80b8b269d8b5014e({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $e7e1773f3a74aa19$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7aeNf", function(module, exports) {
$parcel$export(module.exports, "HubLogoCS", () => $438d6221413db9bc$export$7a38180641471460);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $438d6221413db9bc$var$svg = `<svg height="100%" viewBox="0 0 95 32">
    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>
</svg>
`;
function $438d6221413db9bc$export$7a38180641471460({ size: size, appearance: appearance = 'brand', label: label = 'Hub', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $438d6221413db9bc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lmU4O", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $0c20ed380c272527$export$c4b5b1f965d8b3eb);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $0c20ed380c272527$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>
</svg>
`;
const $0c20ed380c272527$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>
</svg>
`;
function $0c20ed380c272527$export$c4b5b1f965d8b3eb({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $0c20ed380c272527$var$svg,
        customThemeSvg: $0c20ed380c272527$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dfvAF", function(module, exports) {
$parcel$export(module.exports, "JiraLogoCS", () => $4eeed09a0c91c4c1$export$bf4c5f97b468e8d6);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4eeed09a0c91c4c1$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function $4eeed09a0c91c4c1$export$bf4c5f97b468e8d6({ size: size, appearance: appearance = 'brand', label: label = 'Jira', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $4eeed09a0c91c4c1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cvt5Y", function(module, exports) {
$parcel$export(module.exports, "JiraCodingAgentIcon", () => $c9e38f3fb16db2a0$export$b12fec207e8537a8);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a4a56eeee9c8594a65687d2ede86d87f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c9e38f3fb16db2a0$var$svg = `<svg height="100%" viewBox="0 0 55 55">
    <path fill="var(--tile-color,#1868db)" d="M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z"/>
    <path fill="var(--icon-color, white)" d="M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z"/>
</svg>
`;
function $c9e38f3fb16db2a0$export$b12fec207e8537a8({ size: size, appearance: appearance = 'brand', label: label = 'Jira Coding Agent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $c9e38f3fb16db2a0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("62Wck", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterIcon", () => $dd7661c2ea9b2113$export$f8455b5667a3ee0c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $dd7661c2ea9b2113$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>
</svg>
`;
function $dd7661c2ea9b2113$export$f8455b5667a3ee0c({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $dd7661c2ea9b2113$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("leEYy", function(module, exports) {
$parcel$export(module.exports, "JiraDataCenterLogoCS", () => $96109b173e818a28$export$3224b07bc93ef23e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $96109b173e818a28$var$svg = `<svg height="100%" viewBox="0 0 83 32">
    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>
</svg>
`;
function $96109b173e818a28$export$3224b07bc93ef23e({ size: size, appearance: appearance = 'brand', label: label = 'Jira Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $96109b173e818a28$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("amvEl", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $578ab0df3c57af01$export$21bfbeb62fdcce8d);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $578ab0df3c57af01$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>
</svg>
`;
const $578ab0df3c57af01$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>
</svg>
`;
function $578ab0df3c57af01$export$21bfbeb62fdcce8d({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $578ab0df3c57af01$var$svg,
        customThemeSvg: $578ab0df3c57af01$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5h2HX", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", () => $35cf2980886192d6$export$602140a6a10b02bf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $35cf2980886192d6$var$svg = `<svg height="100%" viewBox="0 0 327 32">
    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>
</svg>
`;
function $35cf2980886192d6$export$602140a6a10b02bf({ size: size, appearance: appearance = 'brand', label: label = 'Jira Product Discovery', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $35cf2980886192d6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b7Nnf", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $35432403f89af5c4$export$3c6158790f5e01c4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $35432403f89af5c4$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>
</svg>
`;
const $35432403f89af5c4$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>
</svg>
`;
function $35432403f89af5c4$export$3c6158790f5e01c4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $35432403f89af5c4$var$svg,
        customThemeSvg: $35432403f89af5c4$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("Lxdki", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogoCS", () => $c98e3ae64b1296b8$export$de148263c75d2bc1);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $c98e3ae64b1296b8$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $c98e3ae64b1296b8$export$de148263c75d2bc1({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $c98e3ae64b1296b8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2sbSv", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", () => $ba03defdfad8af17$export$65fae0eaf343f2ca);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ba03defdfad8af17$var$svg = `<svg height="100%" viewBox="0 0 25 24">
    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>
    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>
</svg>
`;
function $ba03defdfad8af17$export$65fae0eaf343f2ca({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $ba03defdfad8af17$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iiSQA", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", () => $2b34fa939036101d$export$f64bc7a7f04428d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $2b34fa939036101d$var$svg = `<svg height="100%" viewBox="0 0 372 32">
    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>
    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>
    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>
    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>
</svg>
`;
function $2b34fa939036101d$export$f64bc7a7f04428d0({ size: size, appearance: appearance = 'brand', label: label = 'Jira Service Management Data Center', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $2b34fa939036101d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bHvjj", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $73abb0cb1c085be8$export$8d789f76fde3e05);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $73abb0cb1c085be8$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $73abb0cb1c085be8$export$8d789f76fde3e05({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $73abb0cb1c085be8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iyiu8", function(module, exports) {
$parcel$export(module.exports, "LoomLogoCS", () => $7cb397db37b88c31$export$78c0b4d8be34c9b2);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $7cb397db37b88c31$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function $7cb397db37b88c31$export$78c0b4d8be34c9b2({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $7cb397db37b88c31$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("afexM", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogoCS", () => $3fe29fa641e96f0f$export$68d7391318cdef11);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $3fe29fa641e96f0f$var$svg = `<svg height="100%" viewBox="0 0 100 32">
    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>
</svg>
`;
function $3fe29fa641e96f0f$export$68d7391318cdef11({ size: size, appearance: appearance = 'brand', label: label = 'Loom Attribution', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $3fe29fa641e96f0f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9vPA3", function(module, exports) {
$parcel$export(module.exports, "LoomInternalIcon", () => $e0a77c548f0679c1$export$38c7b37a3e5e8d70);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $e0a77c548f0679c1$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
function $e0a77c548f0679c1$export$38c7b37a3e5e8d70({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $e0a77c548f0679c1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("a6uNi", function(module, exports) {
$parcel$export(module.exports, "LoomInternalLogoCS", () => $504c249fe5a83508$export$71743a944cb62e48);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $504c249fe5a83508$var$svg = `<svg height="100%" viewBox="0 0 103 32">
    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>
    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>
</svg>
`;
function $504c249fe5a83508$export$71743a944cb62e48({ size: size, appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $504c249fe5a83508$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("46Dt1", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $78e67ac2c84b3a62$export$eeccc49dc7a12d9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $78e67ac2c84b3a62$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>
</svg>
`;
function $78e67ac2c84b3a62$export$eeccc49dc7a12d9f({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $78e67ac2c84b3a62$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("0515y", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogoCS", () => $ce7bbe1169bfc8f9$export$a5b9122e89b32ad3);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $ce7bbe1169bfc8f9$var$svg = `<svg height="100%" viewBox="0 0 164 32">
    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>
</svg>
`;
function $ce7bbe1169bfc8f9$export$a5b9122e89b32ad3({ size: size, appearance: appearance = 'brand', label: label = 'Opsgenie', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $ce7bbe1169bfc8f9$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hWaEm", function(module, exports) {
$parcel$export(module.exports, "ProjectsIcon", () => $d4189eaaed0885bb$export$5ed3e1bb3b04fc02);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $d4189eaaed0885bb$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>
</svg>
`;
function $d4189eaaed0885bb$export$5ed3e1bb3b04fc02({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $d4189eaaed0885bb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ipCSx", function(module, exports) {
$parcel$export(module.exports, "ProjectsLogoCS", () => $5e0db55d65d59979$export$e3d1678155aaab99);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $5e0db55d65d59979$var$svg = `<svg height="100%" viewBox="0 0 145 32">
    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>
</svg>
`;
function $5e0db55d65d59979$export$e3d1678155aaab99({ size: size, appearance: appearance = 'brand', label: label = 'Projects', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $5e0db55d65d59979$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iRvWA", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $a2a6b960da16c695$export$e23ae35269442b4f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $a2a6b960da16c695$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>
    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>
</svg>
`;
function $a2a6b960da16c695$export$e23ae35269442b4f({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $a2a6b960da16c695$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("56gzG", function(module, exports) {
$parcel$export(module.exports, "RovoLogoCS", () => $cb9a887fa031c339$export$b0e15f0a1c9f4c55);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $cb9a887fa031c339$var$svg = `<svg height="100%" viewBox="0 0 106 32">
    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function $cb9a887fa031c339$export$b0e15f0a1c9f4c55({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $cb9a887fa031c339$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3XKAU", function(module, exports) {
$parcel$export(module.exports, "RovoDevIcon", () => $b4cac5f98eec88d2$export$8b784b3227531b3e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $b4cac5f98eec88d2$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>
    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>
</svg>
`;
function $b4cac5f98eec88d2$export$8b784b3227531b3e({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $b4cac5f98eec88d2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3LvpE", function(module, exports) {
$parcel$export(module.exports, "RovoDevLogoCS", () => $1736e2b3ea769904$export$4145bd793c9ed1d0);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $1736e2b3ea769904$var$svg = `<svg height="100%" viewBox="0 0 165 32">
    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>
    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>
</svg>
`;
function $1736e2b3ea769904$export$4145bd793c9ed1d0({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $1736e2b3ea769904$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hzyuh", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentIcon", () => $14468391d4360b05$export$813cff80931d9dbf);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $14468391d4360b05$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>
</svg>
`;
function $14468391d4360b05$export$813cff80931d9dbf({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $14468391d4360b05$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("b0HsC", function(module, exports) {
$parcel$export(module.exports, "RovoDevAgentLogoCS", () => $b9887960c8bead38$export$58747af448450872);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $b9887960c8bead38$var$svg = `<svg height="100%" viewBox="0 0 160 32">
    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>
</svg>
`;
function $b9887960c8bead38$export$58747af448450872({ size: size, appearance: appearance = 'brand', label: label = 'Rovo Dev Agent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $b9887960c8bead38$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1bPI8", function(module, exports) {
$parcel$export(module.exports, "RovoHexIcon", () => $301db9a489c7146a$export$9e62346a60cfb459);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $301db9a489c7146a$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
function $301db9a489c7146a$export$9e62346a60cfb459({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $301db9a489c7146a$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eWtvW", function(module, exports) {
$parcel$export(module.exports, "RovoHexLogoCS", () => $9268b5fc2834fa48$export$5e38d02efdb45577);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $9268b5fc2834fa48$var$svg = `<svg height="100%" viewBox="0 0 102 32">
    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>
</svg>
`;
function $9268b5fc2834fa48$export$5e38d02efdb45577({ size: size, appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $9268b5fc2834fa48$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("aBDTu", function(module, exports) {
$parcel$export(module.exports, "SearchIcon", () => $40d12676a0d5da15$export$82eafebb825fc23f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11b64b046e775d05a59a39754fdeaf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $40d12676a0d5da15$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>
</svg>
`;
function $40d12676a0d5da15$export$82eafebb825fc23f({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $40d12676a0d5da15$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7YfWH", function(module, exports) {
$parcel$export(module.exports, "SearchLogoCS", () => $060c18520f3f68ee$export$fa08cbfe393f2a68);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::151d3b961b465b2b1ef70ce5cd1da70c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $060c18520f3f68ee$var$svg = `<svg height="100%" viewBox="0 0 130 32">
    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>
</svg>
`;
function $060c18520f3f68ee$export$fa08cbfe393f2a68({ size: size, appearance: appearance = 'brand', label: label = 'Search', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $060c18520f3f68ee$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("54S9z", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $bbec51966f219b1c$export$f3f5aa321d88adf9);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $bbec51966f219b1c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>
</svg>
`;
function $bbec51966f219b1c$export$f3f5aa321d88adf9({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $bbec51966f219b1c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("lWzWe", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogoCS", () => $521939139e78456f$export$2bc88a281410ffa7);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $521939139e78456f$var$svg = `<svg height="100%" viewBox="0 0 192 32">
    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>
</svg>
`;
function $521939139e78456f$export$2bc88a281410ffa7({ size: size, appearance: appearance = 'brand', label: label = 'Statuspage', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $521939139e78456f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6eUDD", function(module, exports) {
$parcel$export(module.exports, "StudioIcon", () => $db5cb3a4e6876b21$export$290a0f24614cde9f);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab3266b216390c79d8a1dc3be47de23d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $db5cb3a4e6876b21$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>
</svg>
`;
function $db5cb3a4e6876b21$export$290a0f24614cde9f({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $db5cb3a4e6876b21$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8v32d", function(module, exports) {
$parcel$export(module.exports, "StudioLogoCS", () => $e2e0f528a31ff75e$export$273fd56580e523ae);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f3562c122e709e76d7d20dd81b620288>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $e2e0f528a31ff75e$var$svg = `<svg height="100%" viewBox="0 0 124 32">
    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>
    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>
</svg>
`;
function $e2e0f528a31ff75e$export$273fd56580e523ae({ size: size, appearance: appearance = 'brand', label: label = 'Studio', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $e2e0f528a31ff75e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6qGjk", function(module, exports) {
$parcel$export(module.exports, "TalentIcon", () => $c877893176a647b7$export$4b05688514531169);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $c877893176a647b7$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>
</svg>
`;
function $c877893176a647b7$export$4b05688514531169({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $c877893176a647b7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iyBEd", function(module, exports) {
$parcel$export(module.exports, "TalentLogoCS", () => $f6e9b259de36e9ae$export$1b3979d995ebbc6e);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $f6e9b259de36e9ae$var$svg = `<svg height="100%" viewBox="0 0 122 32">
    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>
</svg>
`;
function $f6e9b259de36e9ae$export$1b3979d995ebbc6e({ size: size, appearance: appearance = 'brand', label: label = 'Talent', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $f6e9b259de36e9ae$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3llr8", function(module, exports) {
$parcel$export(module.exports, "TeamsIcon", () => $ca44d4398ae41a56$export$1bcbc9c337da86da);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $ca44d4398ae41a56$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>
</svg>
`;
function $ca44d4398ae41a56$export$1bcbc9c337da86da({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $ca44d4398ae41a56$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fupeO", function(module, exports) {
$parcel$export(module.exports, "TeamsLogoCS", () => $d693f225e724f62f$export$bfd8d1c4da84ce71);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $d693f225e724f62f$var$svg = `<svg height="100%" viewBox="0 0 127 32">
    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>
</svg>
`;
function $d693f225e724f62f$export$bfd8d1c4da84ce71({ size: size, appearance: appearance = 'brand', label: label = 'Teams', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $d693f225e724f62f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("gnyHa", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $7f21125bba0d4f97$export$4384da9b8b140bf4);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $kvW6F = parcelRequire("kvW6F");
// `height` is set to 100% to allow the SVG to scale with the parent element
const $7f21125bba0d4f97$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $7f21125bba0d4f97$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
function $7f21125bba0d4f97$export$4384da9b8b140bf4({ iconColor: iconColor, size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvW6F.IconWrapper), {
        svg: $7f21125bba0d4f97$var$svg,
        customThemeSvg: $7f21125bba0d4f97$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3kOIs", function(module, exports) {
$parcel$export(module.exports, "TrelloLogoCS", () => $4df02c21f4f76609$export$1b13139dfc0336af);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $9J5zS = parcelRequire("9J5zS");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
const $4df02c21f4f76609$var$svg = `<svg height="100%" viewBox="0 0 113 32">
    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>
    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>
    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>
</svg>
`;
function $4df02c21f4f76609$export$1b13139dfc0336af({ size: size, appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9J5zS.LogoWrapper), {
        svg: $4df02c21f4f76609$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8PMQK", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", () => $d2348e087c1e77e2$export$436fcf6e31fbacea);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
const $d2348e087c1e77e2$export$436fcf6e31fbacea = (LegacyComponent, NewComponent)=>{
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return ({ size: size, shouldUseNewLogoDesign: shouldUseNewLogoDesign, ...props })=>{
        if ((0, $3H4LK.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(NewComponent, {
            size: size || 'medium',
            ...props
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(LegacyComponent, {
            size: size,
            ...props
        });
    };
};

});

parcelRegister("i2crb", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminIcon", () => $7df28b14b9bf33f2$export$84109e099492cb5f);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $7df28b14b9bf33f2$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $7df28b14b9bf33f2$export$84109e099492cb5f = ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        svg: $7df28b14b9bf33f2$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1Xtu6", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdminLogo", () => $efa948257387181c$export$f845d9b9254f0541);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $efa948257387181c$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 295 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $efa948257387181c$export$f845d9b9254f0541 = ({ appearance: appearance, label: label = 'Atlassian Admin', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $efa948257387181c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hiDtH", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationIcon", () => $1d84e2d29eb7faa0$export$74517ed253186308);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $1d84e2d29eb7faa0$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $1d84e2d29eb7faa0$export$74517ed253186308 = ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        svg: $1d84e2d29eb7faa0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4D0F8", function(module, exports) {
$parcel$export(module.exports, "AtlassianAdministrationLogo", () => $bc5eca73633da11b$export$833abe6c2ce5ebfd);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $bc5eca73633da11b$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 404 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"
        fill="${colors.textColor}"
      />
      <path
        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $bc5eca73633da11b$export$833abe6c2ce5ebfd = ({ appearance: appearance, label: label = 'Atlassian Administration', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $bc5eca73633da11b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2qk4y", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsIcon", () => $0c7be60bd893b21f$export$c42ad8a0b925c762);

var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $llSHA = parcelRequire("llSHA");
const $0c7be60bd893b21f$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $llSHA.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient id="${id}-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-b" id="${id}-c" x1="20.595" x2="20.595" y2="22"/>
    <linearGradient xlink:href="#${id}-b" id="${id}-d" x1="36.595" x2="36.595" y2="20"/>
  </defs>
  <path d="M10.595 30h4v10h-4z" fill="url(#${id}-a)"/>
  <path d="M26.595 27h4v13h-4z" fill="url(#${id}-b)"/>
  <path d="M18.595 22h4v18h-4z" fill="url(#${id}-c)"/>
  <path d="M34.595 20h4v20h-4z" fill="url(#${id}-d)"/>
  <path fill="${colors.iconColor}" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />
</svg>`;
};
const $0c7be60bd893b21f$export$c42ad8a0b925c762 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $iUUwu.defaultLogoParams).size, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    const id = (0, $a4Rr2.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $0c7be60bd893b21f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});
parcelRegister("llSHA", function(module, exports) {
$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", () => $2a40497f5ae50789$export$362a25f017e2bc8a);
// TODO: This is where we need to add tokens for all appearance color values
const $2a40497f5ae50789$export$362a25f017e2bc8a = (appearance, colorMode)=>{
    let iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = '#0052CC';
            iconGradientStop = '#2684FF';
            iconColor = '#2684FF';
            textColor = "var(--ds-text, #292A2E)";
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = '#0052CC';
            break;
        case 'neutral':
            iconGradientStart = '#344563';
            iconGradientStop = '#7A869A';
            iconColor = '#7A869A';
            textColor = '#505F79';
            atlassianLogoTextColor = '#505F79';
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};

});


parcelRegister("7kWUo", function(module, exports) {
$parcel$export(module.exports, "AtlassianAnalyticsLogo", () => $9a4e4678dad7ff66$export$e6470bfc39010cc4);

var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $llSHA = parcelRequire("llSHA");
const $9a4e4678dad7ff66$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $llSHA.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <linearGradient id="${id}-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">
      <stop offset="0" stop-color="${colors.iconGradientStart}"/>
      <stop offset="1" stop-color="${colors.iconGradientStop}"/>
    </linearGradient>
    <linearGradient xlink:href="#${id}-a" id="${id}-b" x1="463.285" x2="463.285" y2="27"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-c" x1="455.285" x2="455.285" y2="22"/>
    <linearGradient xlink:href="#${id}-a" id="${id}-d" x1="471.285" x2="471.285" y2="20"/>
  </defs>
  <g fill="${colors.atlassianLogoTextColor}">
    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>
  </g>
  <g fill="${colors.textColor}">
    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>
  </g>
  <path fill="url(#${id}-a)" d="M445.285 30h4v10h-4z"/>
  <path fill="url(#${id}-b)" d="M461.285 27h4v13h-4z"/>
  <path fill="url(#${id}-c)" d="M453.285 22h4v18h-4z"/>
  <path fill="url(#${id}-d)" d="M469.285 20h4v20h-4z"/>
  <path fill="${colors.iconColor}" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>
</svg>`;
};
const $9a4e4678dad7ff66$export$e6470bfc39010cc4 = ({ appearance: appearance, label: label = 'Atlassian Analytics', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    const id = (0, $a4Rr2.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $9a4e4678dad7ff66$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kX5ZZ", function(module, exports) {
$parcel$export(module.exports, "BitbucketIcon", () => $554f0e82916ce192$export$5fc1066e677788d4);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $554f0e82916ce192$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $554f0e82916ce192$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $554f0e82916ce192$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6xhB1", function(module, exports) {
$parcel$export(module.exports, "BitbucketLogo", () => $9cc5b14b6bba5320$export$bd40525f5333524b);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $9cc5b14b6bba5320$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <path fill=${colors.iconColor} d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>
        <path fill=${colors.textColor} d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>
      </svg>`;
};
const $9cc5b14b6bba5320$export$bd40525f5333524b = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9cc5b14b6bba5320$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2X5Rj", function(module, exports) {
$parcel$export(module.exports, "CompassIcon", () => $98c69a7b5b0bf07e$export$f7857fe64d7161d9);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $98c69a7b5b0bf07e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $98c69a7b5b0bf07e$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $98c69a7b5b0bf07e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lPKVu", function(module, exports) {
$parcel$export(module.exports, "CompassLogo", () => $f72c0aee7353e8d9$export$eb7d748e4f9c9676);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $f72c0aee7353e8d9$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
    <path fill=${colors.iconColor} d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>
    <path fill="${colors.textColor}" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>
  </svg>`;
};
const $f72c0aee7353e8d9$export$eb7d748e4f9c9676 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f72c0aee7353e8d9$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lh1Qu", function(module, exports) {
$parcel$export(module.exports, "ConfluenceLogo", () => $a1d2d6c433abc7fe$export$1b2e4fe6ef471556);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $a1d2d6c433abc7fe$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>
      <path fill="${colors.textColor}" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>
    </svg>
    `;
};
const $a1d2d6c433abc7fe$export$1b2e4fe6ef471556 = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a1d2d6c433abc7fe$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ijOSX", function(module, exports) {
$parcel$export(module.exports, "FocusIcon", () => $7d5ae1fdeb34b273$export$1e02e7298035a77c);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $7d5ae1fdeb34b273$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>
		</svg>
		`;
};
const $7d5ae1fdeb34b273$export$1e02e7298035a77c = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $7d5ae1fdeb34b273$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("erp1f", function(module, exports) {
$parcel$export(module.exports, "FocusLogo", () => $c76ef8e4f6cb52b4$export$33908560ea1b226d);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $c76ef8e4f6cb52b4$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
		<path fill="${colors.iconColor}" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>
		<path fill="${colors.textColor}" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>
		<path fill="${colors.textColor}" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>
		<path fill="${colors.textColor}" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>
		<path fill="${colors.textColor}" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>
		<path fill="${colors.textColor}" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>
		</svg>
		`;
};
const $c76ef8e4f6cb52b4$export$33908560ea1b226d = ({ appearance: appearance, label: label = 'Focus', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $c76ef8e4f6cb52b4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8DBpt", function(module, exports) {
$parcel$export(module.exports, "GuardIcon", () => $e867f896d4e19e9e$export$3f95fcfdc25a741d);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $e867f896d4e19e9e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
      <path
        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"
        fill="${colors.iconColor}"
      />
    </svg>`;
};
const $e867f896d4e19e9e$export$3f95fcfdc25a741d = ({ appearance: appearance, label: label = 'Guard', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        svg: $e867f896d4e19e9e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2FopA", function(module, exports) {
$parcel$export(module.exports, "GuardLogo", () => $f61b591f111043f4$export$a4a891d202775deb);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $f61b591f111043f4$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">
      <path
        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"
        fill="${colors.iconColor}"
      />
      <path
        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $f61b591f111043f4$export$a4a891d202775deb = ({ appearance: appearance, label: label = 'Guard', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f61b591f111043f4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fQhtW", function(module, exports) {
$parcel$export(module.exports, "JiraIcon", () => $0fabd08565aa5b0e$export$c4b5b1f965d8b3eb);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $0fabd08565aa5b0e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
    </svg>`;
};
const $0fabd08565aa5b0e$export$c4b5b1f965d8b3eb = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $0fabd08565aa5b0e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9tqsh", function(module, exports) {
$parcel$export(module.exports, "JiraLogo", () => $105b7eb7641f2812$export$17d3acb0b4379d02);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $105b7eb7641f2812$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>
      <path fill="${colors.textColor}" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>
    </svg>`;
};
const $105b7eb7641f2812$export$17d3acb0b4379d02 = ({ appearance: appearance, label: label = 'Jira', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $105b7eb7641f2812$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eNLXd", function(module, exports) {
$parcel$export(module.exports, "JiraAlignIcon", () => $e328b42ad3a99018$export$407687b2dd89cc68);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $e328b42ad3a99018$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="${colors.iconColor}"
      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"
    />
  </svg>`;
};
const $e328b42ad3a99018$export$407687b2dd89cc68 = ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $e328b42ad3a99018$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("19h8Z", function(module, exports) {
$parcel$export(module.exports, "JiraAlignLogo", () => $5983156d9c9e6127$export$ee11e928d3d045fd);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $5983156d9c9e6127$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="${colors.iconColor}"/>
      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="${colors.textColor}"/>
    </svg>
  `;
};
const $5983156d9c9e6127$export$ee11e928d3d045fd = ({ appearance: appearance, label: label = 'Jira Align', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5983156d9c9e6127$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("eTafg", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryIcon", () => $01bb639cc3bd1f0e$export$21bfbeb62fdcce8d);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $01bb639cc3bd1f0e$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>
    </svg>`;
};
const $01bb639cc3bd1f0e$export$21bfbeb62fdcce8d = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $01bb639cc3bd1f0e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("50GFn", function(module, exports) {
$parcel$export(module.exports, "JiraProductDiscoveryLogo", () => $f8cf957b58920fa1$export$c49a2b642fe9eef4);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $f8cf957b58920fa1$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />
      <path fill="${colors.textColor}" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $f8cf957b58920fa1$export$c49a2b642fe9eef4 = ({ appearance: appearance, label: label = 'Jira Product Discovery', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f8cf957b58920fa1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9CRbo", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementIcon", () => $89e38fe97867dd12$export$3c6158790f5e01c4);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $89e38fe97867dd12$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>
    </svg>`;
};
const $89e38fe97867dd12$export$3c6158790f5e01c4 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $89e38fe97867dd12$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7pdCN", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementLogo", () => $5b190abc5d8c561f$export$dabef2be6cd28c20);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $5b190abc5d8c561f$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />
      <path fill=${colors.textColor} d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />
    </svg>`;
};
const $5b190abc5d8c561f$export$dabef2be6cd28c20 = ({ appearance: appearance, label: label = 'Jira Service Management', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $5b190abc5d8c561f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2gbp9", function(module, exports) {
$parcel$export(module.exports, "LoomIcon", () => $b80896eb454c1ac7$export$8d789f76fde3e05);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $9r3S6 = parcelRequire("9r3S6");
const $b80896eb454c1ac7$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9r3S6.getColorsForLoom)(appearance, colorMode);
    return `<svg
    fill="none"
    height="32"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-hidden="true"
  >
    <path
      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"
      fill="${colors.iconColor}"
    />
  </svg>`;
};
const $b80896eb454c1ac7$export$8d789f76fde3e05 = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $b80896eb454c1ac7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("9r3S6", function(module, exports) {
$parcel$export(module.exports, "getColorsForLoom", () => $b4de0b0c0ac212d6$export$7818df200941dbbf);

var $dy27o = parcelRequire("dy27o");

const $b4de0b0c0ac212d6$export$7818df200941dbbf = (appearance, colorMode)=>{
    let iconColor = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode).iconColor;
    let textColor = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});


parcelRegister("6LxUG", function(module, exports) {
$parcel$export(module.exports, "LoomLogo", () => $05405e3489a48be4$export$94e206806e36c2ec);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $9r3S6 = parcelRequire("9r3S6");
const $05405e3489a48be4$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9r3S6.getColorsForLoom)(appearance, colorMode);
    return `<svg
      fill="none"
      height="32"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 98 32"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"
        fill="${colors.iconColor}"
      />
      <path
        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $05405e3489a48be4$export$94e206806e36c2ec = ({ appearance: appearance, label: label = 'Loom', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $05405e3489a48be4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("aB2vm", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionIcon", () => $c43778b081382286$export$1bf47cdade1a9fcb);

var $4fqPo = parcelRequire("4fqPo");

var $iUUwu = parcelRequire("iUUwu");

var $2gbp9 = parcelRequire("2gbp9");
const $c43778b081382286$export$1bf47cdade1a9fcb = ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2gbp9.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("hxZPt", function(module, exports) {
$parcel$export(module.exports, "LoomAttributionLogo", () => $57d6a4c8998d5a71$export$6e87ce8d41eda665);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $9r3S6 = parcelRequire("9r3S6");
const $57d6a4c8998d5a71$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $9r3S6.getColorsForLoom)(appearance, colorMode);
    return `<svg
		fill="none"
		height="32"
		xmlns="http://www.w3.org/2000/svg"
		focusable="false"
		aria-hidden="true"
		viewBox="0 0 88 32"
	>
		<path
			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"
			fill="${colors.iconColor}"
		/>
		<path
			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"
			fill="${colors.textColor}"
		/>
	</svg>`;
};
const $57d6a4c8998d5a71$export$6e87ce8d41eda665 = ({ appearance: appearance, label: label = 'Loom Attribution', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $57d6a4c8998d5a71$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fCGbk", function(module, exports) {
$parcel$export(module.exports, "OpsgenieIcon", () => $17b3ea9a63a2f109$export$eeccc49dc7a12d9f);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $17b3ea9a63a2f109$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
    </svg>`;
};
const $17b3ea9a63a2f109$export$eeccc49dc7a12d9f = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        svg: $17b3ea9a63a2f109$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7jVcv", function(module, exports) {
$parcel$export(module.exports, "OpsgenieLogo", () => $791ec1c63e00c421$export$a1c6484cdecc2c4b);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $791ec1c63e00c421$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>
      <path fill="${colors.textColor}" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />
    </svg>`;
};
const $791ec1c63e00c421$export$a1c6484cdecc2c4b = ({ appearance: appearance, label: label = 'Opsgenie', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $791ec1c63e00c421$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("01aTx", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", () => $a7a246f70c6daa50$export$e23ae35269442b4f);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $a7a246f70c6daa50$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">
    <g fill="${colors.iconColor}" fill-rule="evenodd">
      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>
      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>
    </g>
  </svg>`;
};
const $a7a246f70c6daa50$export$e23ae35269442b4f = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        svg: $a7a246f70c6daa50$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jn7YU", function(module, exports) {
$parcel$export(module.exports, "RovoLogo", () => $377f7631275a2773$export$a0f6cb8061290bbb);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $377f7631275a2773$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"
        fill="${colors.iconColor}"
        fillRule="evenodd"
      />
      <path
        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"
        fill="${colors.textColor}"
      />
    </svg>`;
};
const $377f7631275a2773$export$a0f6cb8061290bbb = ({ appearance: appearance, label: label = 'Rovo', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $377f7631275a2773$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("dzrID", function(module, exports) {
$parcel$export(module.exports, "StatuspageIcon", () => $2a48df8da2b189b8$export$f3f5aa321d88adf9);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $2a48df8da2b189b8$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>
    </svg>`;
};
const $2a48df8da2b189b8$export$f3f5aa321d88adf9 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $2a48df8da2b189b8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lhzSc", function(module, exports) {
$parcel$export(module.exports, "StatuspageLogo", () => $6c2fe3589c74b151$export$bb4ae5b41b43be04);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $6c2fe3589c74b151$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />
      <path fill="${colors.textColor}" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />
    </svg>`;
};
const $6c2fe3589c74b151$export$bb4ae5b41b43be04 = ({ appearance: appearance, label: label = 'Statuspage', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $6c2fe3589c74b151$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2P2qs", function(module, exports) {
$parcel$export(module.exports, "TrelloIcon", () => $d677e0c42385d485$export$4384da9b8b140bf4);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $d677e0c42385d485$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $d677e0c42385d485$export$4384da9b8b140bf4 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $d677e0c42385d485$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("e6ZcJ", function(module, exports) {
$parcel$export(module.exports, "TrelloLogo", () => $887f1bc2ac0ac4c6$export$60e26212f3b61a28);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $887f1bc2ac0ac4c6$var$svg = ({ appearance: appearance, iconColor: iconColor, textColor: textColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>
      <path fill="${colors.textColor}" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>
    </svg>`;
};
const $887f1bc2ac0ac4c6$export$60e26212f3b61a28 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $887f1bc2ac0ac4c6$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lEFyQ", function(module, exports) {
$parcel$export(module.exports, "JiraWorkManagementIcon", () => $fb950d61ed74b21a$export$7330b9fc5718fd30);

var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $llSHA = parcelRequire("llSHA");
const $fb950d61ed74b21a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $iUUwu.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $iUUwu.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $llSHA.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
    <svg
      fill="none"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient
        id="${id}"
        gradientUnits="userSpaceOnUse"
        x1="13.9485"
        x2="20.7792"
        y1="20.2388"
        y2="11.8277"
      >
        <stop offset="0" stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} />
        <stop offset="100%" stop-color="${colors.iconGradientStop}" />
      </linearGradient>
      <path
        d="m18.3893 7-3.4257 13.1867c4.3592 1.2052 7.8383-.3558 9.1709-5.4802l1.9988-7.6973z"
        fill="url(#${id})"
      />
      <path
      fill="${colors.iconColor}"
      d="m13.7566 24.8265 3.4257-13.1866c-4.3623-1.196-7.8383.3649-9.17087 5.4985l-2.01143 7.6881z"
      />
    </svg>`;
};
const $fb950d61ed74b21a$export$7330b9fc5718fd30 = ({ appearance: appearance, label: label = 'Jira Work Management', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    const id = (0, $a4Rr2.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $fb950d61ed74b21a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("1y0uJ", function(module, exports) {
$parcel$export(module.exports, "AtlassianIcon", () => $a8e95271f16008fb$export$8a485e2e7ed91e8f);

var $4fqPo = parcelRequire("4fqPo");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $dy27o = parcelRequire("dy27o");
const $a8e95271f16008fb$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $dy27o.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.795.334.666.584.791 1.167.791h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251"/>
    </svg>`;
};
const $a8e95271f16008fb$export$8a485e2e7ed91e8f = ({ appearance: appearance, label: label = 'Atlassian', size: size = (0, $iUUwu.defaultLogoParams).size, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor, testId: testId })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $a8e95271f16008fb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("kDNxG", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwareIcon", () => $dd0195e4b3dad4a7$export$c3835feba2a66e67);

var $4fqPo = parcelRequire("4fqPo");

var $a4Rr2 = parcelRequire("a4Rr2");

var $a1GvG = parcelRequire("a1GvG");

var $iUUwu = parcelRequire("iUUwu");

var $2zg7q = parcelRequire("2zg7q");

var $llSHA = parcelRequire("llSHA");
const $dd0195e4b3dad4a7$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode, id)=>{
    let colors = {
        iconGradientStart: (0, $iUUwu.legacyDefaultLogoParams).iconGradientStart,
        iconGradientStop: (0, $iUUwu.legacyDefaultLogoParams).iconGradientStart,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $llSHA.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return `
  <svg viewBox="0 0 32 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">
    <defs>
      <linearGradient x1="108.695%" x2="12.439%" y1="-14.936%" y2="45.215%" id="${id}-1">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
      <linearGradient x1="0%" x2="91.029%" y1="118.55%" y2="63.971%" id="${id}-2">
        <stop stop-color="${colors.iconGradientStart}" ${colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : ''} offset="0%"></stop>
        <stop stop-color="${colors.iconGradientStop}" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill-rule="nonzero">
      <path fill="${colors.iconColor}" d="M15.9669691 29.3616152C17.2195568 28.1097726 17.9233158 26.4114623 17.9233158 24.6405626 17.9233158 22.8696629 17.2195568 21.1713527 15.9669691 19.91951L7.26805808 11.2489111 3.31143376 15.2055354C2.89743442 15.6200502 2.89743442 16.291565 3.31143376 16.7060799L15.9669691 29.3616152zM28.6225045 15.2055354L15.9669691 2.55 15.9280399 2.58892922C13.3485687 5.19994003 13.3612164 9.40374108 15.9563521 11.9991833L24.6623412 20.6662432 28.6225045 16.7060799C29.0365039 16.291565 29.0365039 15.6200502 28.6225045 15.2055354z" />
      <path fill="url(#${id}-1" d="M15.9669691,11.9921053 C13.3718335,9.39666304 13.3591857,5.19286199 15.938657,2.58185118 L6.91061706,11.6063521 L11.6316697,16.3274047 L15.9669691,11.9921053 Z" />
      <path fill="url(#${id}-2" d="M20.2951906,15.5912886 L15.9669691,19.91951 C17.2195568,21.1713527 17.9233158,22.8696629 17.9233158,24.6405626 C17.9233158,26.4114623 17.2195568,28.1097726 15.9669691,29.3616152 L25.0162432,20.3123412 L20.2951906,15.5912886 Z" />
    </g>
  </svg>`;
};
const $dd0195e4b3dad4a7$export$c3835feba2a66e67 = ({ appearance: appearance, label: label = 'Jira Software', size: size = (0, $iUUwu.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $iUUwu.defaultLogoParams).iconColor, textColor: textColor = (0, $iUUwu.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    const id = (0, $a4Rr2.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2zg7q.default), {
        appearance: appearance,
        label: label,
        svg: $dd0195e4b3dad4a7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("fABNK", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlaggedRovoComponent", () => $d63f84ab6b777186$export$2469203854060337);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $8PMQK = parcelRequire("8PMQK");

var $jb0Si = parcelRequire("jb0Si");

const $d63f84ab6b777186$export$2469203854060337 = (LegacyComponent, NewComponent, NewHexComponent)=>{
    const RovoHexWrapped = (0, $jb0Si.tempSizeWrapper)(NewHexComponent);
    const RovoServiceCollectionWrapped = (0, $8PMQK.createFeatureFlaggedServiceCollectionComponent)(LegacyComponent, NewComponent);
    return ({ shouldUseHexLogo: shouldUseHexLogo, ...props })=>{
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $3H4LK.fg)('platform-logo-rebrand-rovo-hex') || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(RovoServiceCollectionWrapped, props);
    };
};
const $d63f84ab6b777186$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira-coding-agent',
        type: 'new',
        category: 'agent',
        skipLogo: true
    },
    {
        name: 'rovo',
        type: 'rovo-hex',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'dx',
        type: 'new',
        category: 'app',
        skipLogo: true
    },
    {
        name: 'rovo-dev',
        type: 'new',
        category: 'app'
    },
    {
        name: 'rovo-dev-agent',
        type: 'new',
        category: 'agent'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'feedback',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
const $d63f84ab6b777186$export$62e1212796a86b1b = $d63f84ab6b777186$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'program' && !logo.skipExample).map((logo)=>logo.name);
const $d63f84ab6b777186$export$e0dee4a765830f4d = $d63f84ab6b777186$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'app' && !logo.skipExample).map((logo)=>logo.name);
const $d63f84ab6b777186$export$a13ce90e90d7bfc1 = $d63f84ab6b777186$export$172fd793eb6ecac4.filter((logo)=>logo.category === 'agent' && !logo.skipExample).map((logo)=>logo.name) || [];
const $d63f84ab6b777186$export$516fce44c502c1d3 = $d63f84ab6b777186$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'legacy');
const $d63f84ab6b777186$export$b805fae8e798ed39 = $d63f84ab6b777186$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'migration');
const $d63f84ab6b777186$export$3f9abd26214cd85f = $d63f84ab6b777186$export$172fd793eb6ecac4.filter((logo)=>logo.type === 'new');

});
parcelRegister("jb0Si", function(module, exports) {
$parcel$export(module.exports, "tempSizeWrapper", () => $9d73bcbf77912cc7$export$667425256e2e7296);

var $4fqPo = parcelRequire("4fqPo");
const $9d73bcbf77912cc7$export$667425256e2e7296 = (NewComponent)=>{
    return ({ size: size, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(NewComponent, {
            size: size || 'medium',
            ...props
        });
    };
};

});



parcelRegister("4xi6h", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $7e72d36ca23cbd27$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $7e72d36ca23cbd27$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $7e72d36ca23cbd27$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $7e72d36ca23cbd27$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $7e72d36ca23cbd27$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $7e72d36ca23cbd27$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $7e72d36ca23cbd27$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $7e72d36ca23cbd27$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $7e72d36ca23cbd27$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $7e72d36ca23cbd27$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $7e72d36ca23cbd27$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $7e72d36ca23cbd27$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "SmartLinkSize", () => $7e72d36ca23cbd27$export$51f13ced115cbdae);
$parcel$export(module.exports, "IconType", () => $7e72d36ca23cbd27$export$13ff1290a9e22e77);
const $7e72d36ca23cbd27$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $7e72d36ca23cbd27$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $7e72d36ca23cbd27$export$84a73a0383f58180 = 'JiraTask';
const $7e72d36ca23cbd27$export$c6c83963a9378a67 = 'JiraSubTask';
const $7e72d36ca23cbd27$export$58af3c426c111a6d = 'JiraStory';
const $7e72d36ca23cbd27$export$ac9898a63417219e = 'JiraBug';
const $7e72d36ca23cbd27$export$54db5e3fb12e39cd = 'JiraEpic';
const $7e72d36ca23cbd27$export$2f54a5a217202c85 = 'JiraIncident';
const $7e72d36ca23cbd27$export$d097371052bfc411 = 'JiraServiceRequest';
const $7e72d36ca23cbd27$export$efd9452ad16c6676 = 'JiraChange';
const $7e72d36ca23cbd27$export$2e7e70abb5d81f67 = 'JiraProblem';
const $7e72d36ca23cbd27$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $7e72d36ca23cbd27$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $7e72d36ca23cbd27$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});

});


parcelRegister("bbk8d", function(module, exports) {
$parcel$export(module.exports, "cardReducer", () => $402a8243347d6d82$export$3c7c3113a97b6492);

var $2oVC7 = parcelRequire("2oVC7");
var $21gEn = parcelRequire("21gEn");
const $402a8243347d6d82$var$isCardAction = (action)=>{
    return [
        (0, $2oVC7.ACTION_PENDING),
        (0, $2oVC7.ACTION_RESOLVING),
        (0, $2oVC7.ACTION_RESOLVED),
        (0, $2oVC7.ACTION_RELOADING),
        (0, $2oVC7.ACTION_ERROR),
        (0, $2oVC7.ACTION_ERROR_FALLBACK),
        (0, $2oVC7.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $402a8243347d6d82$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $21gEn.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $402a8243347d6d82$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $2oVC7.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $2oVC7.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $2oVC7.ACTION_RESOLVED:
            return $402a8243347d6d82$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $2oVC7.ACTION_RELOADING:
            return $402a8243347d6d82$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $2oVC7.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $2oVC7.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $2oVC7.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $402a8243347d6d82$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$402a8243347d6d82$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $402a8243347d6d82$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});

parcelRegister("5ILcO", function(module, exports) {
$parcel$export(module.exports, "SmartCardContext", () => $08835b62811d4a74$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $08835b62811d4a74$export$e1d190b530cf0ee9);
$parcel$export(module.exports, "useSmartCardContext", () => $08835b62811d4a74$export$10e9cca30e50f657);
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $08835b62811d4a74$export$797e3658f090919c);
$parcel$export(module.exports, "EditorSmartCardProvider", () => $08835b62811d4a74$export$2a29ca11e08dc129);

var $4fqPo = parcelRequire("4fqPo");

const $08835b62811d4a74$export$156b523e63b4f63a = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);
function $08835b62811d4a74$export$e1d190b530cf0ee9() {
    const context = (0, $4fqPo.useContext)($08835b62811d4a74$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $08835b62811d4a74$export$10e9cca30e50f657 = ()=>$08835b62811d4a74$var$useContextMemoized($08835b62811d4a74$export$156b523e63b4f63a);
const $08835b62811d4a74$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $08835b62811d4a74$export$10e9cca30e50f657();
    if (!(cardContext !== null && cardContext !== void 0 && cardContext.value)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children);
};
function $08835b62811d4a74$var$useContextMemoized(reactContext) {
    const value = (0, $4fqPo.useContext)(reactContext);
    const context = (0, $4fqPo.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $08835b62811d4a74$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $08835b62811d4a74$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Provider, {
        value: cardContext.value
    }, children);
};
var $08835b62811d4a74$export$2e2bcd8739ae039 = $08835b62811d4a74$export$156b523e63b4f63a;

});


parcelRegister("437I1", function(module, exports) {
$parcel$export(module.exports, "RendererWithAnalytics", () => $e583da8b181b1ba2$export$af81ffb59b6ef0dd);
$parcel$export(module.exports, "default", () => $e583da8b181b1ba2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $eevQH = parcelRequire("eevQH");

var $irmNM = parcelRequire("irmNM");
var $gScSr = parcelRequire("gScSr");

var $bGK06 = parcelRequire("bGK06");
var $1cagQ = parcelRequire("1cagQ");
var $84REQ = parcelRequire("84REQ");
var $ag3hq = parcelRequire("ag3hq");
var $feY6v = parcelRequire("feY6v");

var $hdn08 = parcelRequire("hdn08");

var $lqVX7 = parcelRequire("lqVX7");

var $cpSqr = parcelRequire("cpSqr");

var $emduD = parcelRequire("emduD");

var $vTwlu = parcelRequire("vTwlu");

var $dlTjh = parcelRequire("dlTjh");

var $jRnuf = parcelRequire("jRnuf");

var $awtxt = parcelRequire("awtxt");

var $jzosZ = parcelRequire("jzosZ");
var $aheLh = parcelRequire("aheLh");
var $5TyuV = parcelRequire("5TyuV");

var $3H4LK = parcelRequire("3H4LK");

var $6niD6 = parcelRequire("6niD6");
parcelRequire("8lHWD");
var $dQ0Pl = parcelRequire("dQ0Pl");

var $f0GG4 = parcelRequire("f0GG4");

var $b97Tz = parcelRequire("b97Tz");

var $3izZW = parcelRequire("3izZW");

var $hvgSB = parcelRequire("hvgSB");
var $6x4pz = parcelRequire("6x4pz");

var $cS0SO = parcelRequire("cS0SO");

var $dQtpO = parcelRequire("dQtpO");

var $1z761 = parcelRequire("1z761");

var $4trry = parcelRequire("4trry");

var $bUvFG = parcelRequire("bUvFG");

var $djnMX = parcelRequire("djnMX");

var $eCph8 = parcelRequire("eCph8");

var $j7Id3 = parcelRequire("j7Id3");

var $6XdSn = parcelRequire("6XdSn");

var $8sZ3k = parcelRequire("8sZ3k");

var $f5eyN = parcelRequire("f5eyN");

var $amo05 = parcelRequire("amo05");

var $aZdJ3 = parcelRequire("aZdJ3");

var $kNCrc = parcelRequire("kNCrc");

var $3Aw44 = parcelRequire("3Aw44");

var $fcoDc = parcelRequire("fcoDc");

var $AmJJl = parcelRequire("AmJJl");

var $jITpP = parcelRequire("jITpP");

var $8jG2i = parcelRequire("8jG2i");

var $6zDDB = parcelRequire("6zDDB");

var $crjVg = parcelRequire("crjVg");

var $fKAdP = parcelRequire("fKAdP");

var $4ubSX = parcelRequire("4ubSX");

var $4mqcS = parcelRequire("4mqcS");

var $cFHQz = parcelRequire("cFHQz");
function $e583da8b181b1ba2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e583da8b181b1ba2$export$47b2879ca9bbf67a = 2000;
const $e583da8b181b1ba2$export$1b622068be977101 = 3000;
// we want to calculate all the table widths (which causes reflows) after the renderer has finished loading to mitigate performance impact
const $e583da8b181b1ba2$var$TABLE_INFO_TIMEOUT = 10000;
const $e583da8b181b1ba2$var$RENDER_EVENT_SAMPLE_RATE = 0.2;
const $e583da8b181b1ba2$var$packageName = undefined;
const $e583da8b181b1ba2$var$packageVersion = undefined;
const $e583da8b181b1ba2$var$setAsQueryContainerStyles = {
    name: "3qfej8",
    styles: "container-name:ak-renderer-wrapper;container-type:inline-size"
};
const $e583da8b181b1ba2$var$handleMouseTripleClickInTables = (event)=>{
    var _parentElement, _parentElement2;
    const browser = (0, $cpSqr.getBrowserInfo)();
    if (browser.ios || browser.android) return;
    const badBrowser = browser.chrome || browser.safari;
    const tripleClick = event.detail >= 3;
    if (!(badBrowser && tripleClick)) return;
    const selection = window.getSelection();
    if (!selection) return;
    const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
    const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
    if (!rangeSelection) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const tableCell = target.closest('td,th');
    const clickedInCell = Boolean(tableCell);
    if (!clickedInCell) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const anchorInCell = tableCell.contains(anchorNode);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const focusInCell = tableCell.contains(focusNode);
    const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
    if (!selectionStartsOrEndsOutsideClickedCell) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const elementToSelect = anchorInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement = anchorNode.parentElement) === null || _parentElement === void 0 ? void 0 : _parentElement.closest('div,p') : focusInCell ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (_parentElement2 = focusNode.parentElement) === null || _parentElement2 === void 0 ? void 0 : _parentElement2.closest('div,p') : tableCell;
    if (elementToSelect) selection.selectAllChildren(elementToSelect);
};
/**
 * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
 * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
 * renderer out for the editor).
 * @param event Click event anywhere inside renderer
 * @param props
 * @param mouseDownSelection
 * @example
 */ const $e583da8b181b1ba2$var$handleWrapperOnClick = (event, props, mouseDownSelection)=>{
    var _props$eventHandlers;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const targetElement = event.target;
    $e583da8b181b1ba2$var$handleMouseTripleClickInTables(event);
    // ED-14862: When a user triple clicks to select a line of content inside a
    // a table cell, but the browser incorrectly moves the selection start or end into
    // a different table cell, we manually set the selection back to within the original
    // table cell the user intended to target
    if (!((_props$eventHandlers = props.eventHandlers) !== null && _props$eventHandlers !== void 0 && _props$eventHandlers.onUnhandledClick)) return;
    if (!(targetElement instanceof window.Element)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rendererWrapper = event.currentTarget;
    const isInteractiveElementInTree = (0, $djnMX.findInTree)(targetElement, rendererWrapper, (0, $aZdJ3.isInteractiveElement));
    if (isInteractiveElementInTree) return;
    // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
    // This logic originated in jira-frontend:
    // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
    // The selection is required to be checked in `onMouseDown` and here. If not here, a new
    // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
    // return an empty selection, which will erroneously fire onUnhandledClick.
    const windowSelection = window.getSelection();
    const selection = windowSelection !== null ? windowSelection.toString() : undefined;
    const hasSelection = selection && selection.length !== 0;
    const hasSelectionMouseDown = mouseDownSelection.current && mouseDownSelection.current.length !== 0;
    const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
    if (allowEditBasedOnSelection) props.eventHandlers.onUnhandledClick(event);
};
const $e583da8b181b1ba2$export$c49fe2316038f3c2 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const mouseDownSelection = (0, $4fqPo.useRef)(undefined);
    const providerFactory = (0, $4fqPo.useMemo)(()=>props.dataProviders || new (0, $irmNM.default)(), [
        props.dataProviders
    ]);
    const { nestedRendererType: nestedRendererType } = (0, $bUvFG.useRendererContext)();
    const createRendererContext = (0, $4fqPo.useMemo)(()=>(featureFlags, isTopLevelRenderer)=>{
            const normalizedFeatureFlags = (0, $b97Tz.normalizeFeatureFlags)(featureFlags);
            return {
                featureFlags: normalizedFeatureFlags,
                isTopLevelRenderer: isTopLevelRenderer === undefined,
                nestedRendererType: // Propagate nestedRendererType into the inner RendererContextProvider so that
                // React components inside the renderer (e.g. Colgroup) can read it via
                // useRendererContext(). Without this, the inner provider overwrites the outer
                // AKRendererWrapper context and nestedRendererType becomes undefined.
                nestedRendererType
            };
        }, [
        nestedRendererType
    ]);
    const fireAnalyticsEventOld = (0, $4fqPo.useCallback)((event)=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        if (createAnalyticsEvent) {
            const channel = (0, $6niD6.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        props
    ]);
    const fireAnalyticsEventNew = (0, $4fqPo.useCallback)((event)=>{
        if (createAnalyticsEvent) {
            const channel = (0, $6niD6.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsEvent = (0, $hdn08.editorExperiment)('platform_renderer_fix_analytics_memo_callback', true, {
        exposure: true
    }) ? fireAnalyticsEventNew : fireAnalyticsEventOld;
    const deriveSerializerProps = (0, $4fqPo.useCallback)((props)=>{
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = createRendererContext(props.featureFlags, props.isTopLevelRenderer);
        return {
            startPos: props.startPos ?? 0,
            providers: providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.shouldRemoveEmptySpaceAroundContent ? (0, $6zDDB.removeEmptySpaceAroundContent)(props.document) : props.document,
                schema: props.schema,
                ...props.rendererContext,
                nestedRendererType: nestedRendererType
            },
            appearance: props.appearance,
            contentMode: props.contentMode,
            onSetLinkTarget: props.onSetLinkTarget,
            disableHeadingIDs: props.disableHeadingIDs,
            headingIdPrefix: props.headingIdPrefix,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            extensionViewportSizes: props.extensionViewportSizes,
            getExtensionHeight: props.getExtensionHeight,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            allowWindowedCodeBlock: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.allowWindowedCodeBlock,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isPresentational: props.UNSTABLE_isPresentational,
            textHighlighter: props.textHighlighter || props.UNSTABLE_textHighlighter,
            allowTableAlignment: props.UNSTABLE_allowTableAlignment,
            allowTableResizing: props.UNSTABLE_allowTableResizing,
            disableTableOverflowShadow: props.disableTableOverflowShadow,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption,
            shouldDisplayExtensionAsInline: props.shouldDisplayExtensionAsInline
        };
    }, [
        createRendererContext,
        providerFactory,
        fireAnalyticsEvent,
        nestedRendererType
    ]);
    const serializer = (0, $crjVg.useMemoFromPropsDerivative)((serializerProps)=>{
        var _props$createSerializ;
        return ((_props$createSerializ = props.createSerializer) === null || _props$createSerializ === void 0 ? void 0 : _props$createSerializ.call(props, serializerProps)) ?? new (0, $hvgSB.default)(serializerProps);
    }, deriveSerializerProps, props);
    const localRef = (0, $4fqPo.useRef)(null);
    const editorRef = props.innerRef || localRef;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $4fqPo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($3izZW)))(), []);
    const renderedMeasurementDistortedDurationMonitor = (0, $4fqPo.useMemo)(()=>(0, $dlTjh.getDistortedDurationMonitor)(), []);
    // we are doing this to ensure it runs as
    // early as possible in the React lifecycle
    // to avoid any other side effects
    const measureStarted = (0, $4fqPo.useRef)(false);
    const startAnalyticsMeasure = ()=>{
        (0, $vTwlu.startMeasure)(`Renderer Render Time: ${id}`);
    };
    if (!measureStarted.current) {
        startAnalyticsMeasure();
        measureStarted.current = true;
    }
    const anchorLinkAnalytics = (0, $4fqPo.useCallback)(()=>{
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const disableHeadingIDs = props.disableHeadingIDs;
        if (!disableHeadingIDs && hash && editorRef && editorRef.current instanceof HTMLElement) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- anchor navigation uses document.getElementById for hash targets
            const anchorLinkElement = document.getElementById(hash);
            if (anchorLinkElement && editorRef.current.contains(anchorLinkElement)) fireAnalyticsEvent({
                action: (0, $f0GG4.ACTION).VIEWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $dQtpO.PLATFORM).WEB,
                    mode: (0, $dQtpO.MODE).RENDERER
                },
                eventType: (0, $f0GG4.EVENT_TYPE).UI
            });
        }
    }, [
        props.disableHeadingIDs,
        editorRef,
        fireAnalyticsEvent
    ]);
    const getSchema = (0, $4fqPo.useMemo)(()=>{
        return (schema, adfStage)=>{
            if (schema) return schema;
            return (0, $eevQH.getSchemaBasedOnStage)(adfStage);
        };
    }, []);
    const onMouseDownEditView = ()=>{
        const windowSelection = window.getSelection();
        mouseDownSelection.current = windowSelection !== null ? windowSelection.toString() : undefined;
    };
    const { dataProviders: dataProviders, analyticsEventSeverityTracking: analyticsEventSeverityTracking } = props;
    (0, $4fqPo.useEffect)(()=>{
        let rafID;
        let heightWidthAnalyticsSetTimeoutID;
        let heightWidthAnalyticsRicID;
        let heightWidthAnalyticsRafID;
        const handleAnalytics = ()=>{
            fireAnalyticsEvent({
                action: (0, $f0GG4.ACTION).STARTED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
                attributes: {
                    platform: (0, $dQtpO.PLATFORM).WEB
                },
                eventType: (0, $f0GG4.EVENT_TYPE).UI
            });
            rafID = requestAnimationFrame(()=>{
                (0, $vTwlu.stopMeasure)(`Renderer Render Time: ${id}`, (duration)=>{
                    const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $5TyuV.shouldForceTracking)();
                    const severity = !!forceSeverityTracking || analyticsEventSeverityTracking !== null && analyticsEventSeverityTracking !== void 0 && analyticsEventSeverityTracking.enabled ? (0, $aheLh.getAnalyticsEventSeverity)(duration, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityNormalThreshold) ?? $e583da8b181b1ba2$export$47b2879ca9bbf67a, (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.severityDegradedThreshold) ?? $e583da8b181b1ba2$export$1b622068be977101) : undefined;
                    const isTTRTrackingExplicitlyDisabled = (analyticsEventSeverityTracking === null || analyticsEventSeverityTracking === void 0 ? void 0 : analyticsEventSeverityTracking.enabled) === false;
                    if (!isTTRTrackingExplicitlyDisabled) {
                        const event = {
                            action: (0, $f0GG4.ACTION).RENDERED,
                            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
                            attributes: {
                                platform: (0, $dQtpO.PLATFORM).WEB,
                                duration: duration,
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                distortedDuration: renderedMeasurementDistortedDurationMonitor.distortedDuration,
                                ttfb: (0, $jRnuf.getResponseEndTime)(),
                                nodes: (0, $kNCrc.countNodes)(props.document),
                                nestedRendererType: (0, $hdn08.editorExperiment)('platform_synced_block', true) ? nestedRendererType : undefined,
                                severity: severity
                            },
                            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
                        };
                        fireAnalyticsEvent(event);
                        if ((0, $4mqcS.expValEquals)('platform_editor_sample_renderer_rendered_event', 'isEnabled', true) && Math.random() < $e583da8b181b1ba2$var$RENDER_EVENT_SAMPLE_RATE) fireAnalyticsEvent({
                            ...event,
                            action: (0, $f0GG4.ACTION).RENDERED_SAMPLED
                        });
                    }
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    renderedMeasurementDistortedDurationMonitor.cleanup();
                });
                anchorLinkAnalytics();
            });
            // send statistics about the heights/widths of the tables on the page for alerting
            heightWidthAnalyticsSetTimeoutID = setTimeout(()=>{
                const requestIdleCallbackFn = ()=>{
                    var _props$innerRef;
                    const renderer = (_props$innerRef = props.innerRef) === null || _props$innerRef === void 0 || (_props$innerRef = _props$innerRef.current) === null || _props$innerRef === void 0 ? void 0 : _props$innerRef.querySelector('.ak-renderer-document');
                    if (renderer) {
                        const payload = (0, $cFHQz.getWidthInfoPayload)(renderer);
                        if (payload) fireAnalyticsEvent(payload);
                        if ((0, $3H4LK.fg)('platform_editor_table_height_analytics_event')) {
                            const payloadHeight = (0, $cFHQz.getHeightInfoPayload)(renderer);
                            if (payloadHeight) fireAnalyticsEvent(payloadHeight);
                        }
                    }
                };
                if (window && typeof window.requestIdleCallback === 'function') heightWidthAnalyticsRicID = window.requestIdleCallback(requestIdleCallbackFn);
                else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                heightWidthAnalyticsRafID = window.requestAnimationFrame(requestIdleCallbackFn);
            }, $e583da8b181b1ba2$var$TABLE_INFO_TIMEOUT);
        };
        handleAnalytics();
        return ()=>{
            if (rafID) window.cancelAnimationFrame(rafID);
            if (heightWidthAnalyticsSetTimeoutID) window.clearTimeout(heightWidthAnalyticsSetTimeoutID);
            if (heightWidthAnalyticsRafID) window.cancelAnimationFrame(heightWidthAnalyticsRafID);
            if (heightWidthAnalyticsRicID) window.cancelIdleCallback(heightWidthAnalyticsRicID);
            // if this is the ProviderFactory which was created in constructor
            // it's safe to destroy it on Renderer unmount
            // updated to match existing class component
            if (!dataProviders) providerFactory.destroy();
        };
    // we are going to ignore this because I'm doing this on purpose
    // having a dependency array means we run stopMeasure twice per render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const rendererContext = (0, $4fqPo.useMemo)(()=>({
            ...createRendererContext(props.featureFlags, props.isTopLevelRenderer),
            timeZone: props.timeZone
        }), [
        props.featureFlags,
        props.isTopLevelRenderer,
        createRendererContext,
        props.timeZone
    ]);
    (0, $awtxt.useScrollToBlock)(editorRef, props.document, props.scrollToBlock);
    try {
        var _props$media;
        const schema = getSchema(props.schema, props.adfStage);
        const allowTableInPanel = (0, $emduD.isPanelNestingTableSupported)(schema);
        const validationOverrides = allowTableInPanel ? {
            ...props.validationOverrides,
            allowTableInPanel: true
        } : props.validationOverrides;
        const { result: result, stat: stat, pmDoc: pmDoc } = (0, $6x4pz.renderDocument)(props.shouldRemoveEmptySpaceAroundContent ? (0, $6zDDB.removeEmptySpaceAroundContent)(props.document) : props.document, serializer, schema, props.adfStage, props.useSpecBasedValidator, id, fireAnalyticsEvent, props.unsupportedContentLevelsTracking, props.appearance, props.includeNodesCountInStats, props.skipValidation, validationOverrides);
        if (props.onComplete) props.onComplete(stat);
        const rendererOutput = /*#__PURE__*/ (0, $lqVX7.jsx)((0, $bUvFG.RendererContextProvider), {
            value: rendererContext
        }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $6XdSn.ActiveHeaderIdProvider), {
            value: (0, $4trry.getActiveHeadingId)(props.allowHeadingAnchorLinks)
        }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $cS0SO.default).Provider, {
            // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                fireAnalyticsEvent: (event)=>fireAnalyticsEvent(event)
            }
        }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $j7Id3.Provider), null, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $gScSr.ProviderFactoryProvider), {
            value: providerFactory
        }, /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowNestedHeaderLinks: (0, $4trry.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            allowColumnSorting: props.allowColumnSorting,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowPlaceholderText: props.allowPlaceholderText,
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            innerRef: editorRef,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$e583da8b181b1ba2$var$handleWrapperOnClick(event, props, mouseDownSelection),
            onMouseDown: onMouseDownEditView,
            ssr: (_props$media = props.media) === null || _props$media === void 0 ? void 0 : _props$media.ssr,
            isInsideOfInlineExtension: props.isInsideOfInlineExtension,
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            shouldRemoveEmptySpaceAroundContent: props.shouldRemoveEmptySpaceAroundContent,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, props.enableSsrInlineScripts || props.noOpSSRInlineScript ? /*#__PURE__*/ (0, $lqVX7.jsx)((0, $amo05.BreakoutSSRInlineScript), {
            noOpSSRInlineScript: Boolean(props.noOpSSRInlineScript)
        }) : null, /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$var$RendererActionsInternalUpdater, {
            doc: pmDoc,
            schema: schema,
            onAnalyticsEvent: fireAnalyticsEvent
        }, result)))))));
        const rendererResult = props.truncated ? /*#__PURE__*/ (0, $lqVX7.jsx)((0, $fcoDc.TruncatedWrapper), {
            height: props.maxHeight,
            fadeHeight: props.fadeOutHeight
        }, rendererOutput) : rendererOutput;
        return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, rendererResult);
    } catch (e) {
        if (props.onError) props.onError(e);
        return /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$var$RendererWrapper, {
            allowAnnotations: props.allowAnnotations,
            appearance: props.appearance,
            contentMode: props.contentMode || 'standard',
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowDownloadCodeBlock: props.allowDownloadCodeBlock,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowPlaceholderText: props.allowPlaceholderText,
            allowColumnSorting: props.allowColumnSorting,
            allowNestedHeaderLinks: (0, $4trry.isNestedHeaderLinksEnabled)(props.allowHeadingAnchorLinks),
            useBlockRenderForCodeBlock: rendererContext.featureFlags.useBlockRenderForCodeBlock ?? true,
            addTelepointer: props.addTelepointer,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (event)=>$e583da8b181b1ba2$var$handleWrapperOnClick(event, props, mouseDownSelection),
            isTopLevelRenderer: rendererContext.isTopLevelRenderer,
            allowRendererContainerStyles: props.allowRendererContainerStyles
        }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $84REQ.default), null));
    }
};
const $e583da8b181b1ba2$var$RendererFunctionalComponentMemoized = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo($e583da8b181b1ba2$export$c49fe2316038f3c2);
const $e583da8b181b1ba2$var$RendererFunctionalComponentWithPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo((props)=>{
    // If nodeComponents are provided, we don't remove portal from props and use context instead,
    // because we can't guarantee compatibility with existing Atlaskit Renderer consumers.
    if (props.nodeComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e583da8b181b1ba2$var$RendererFunctionalComponentMemoized, props);
    const { portal: portal, ...propsWithoutPortal } = props;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $fKAdP.PortalContext).Provider, {
        value: portal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e583da8b181b1ba2$export$c49fe2316038f3c2, propsWithoutPortal));
});
function $e583da8b181b1ba2$export$88530751e3977073(props) {
    const { startPos: startPos } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext((0, $8sZ3k.AnnotationsPositionContext));
    const { isTopLevelRenderer: isTopLevelRenderer } = (0, $bUvFG.useRendererContext)();
    const { skipValidation: skipValidation, allowNestedTables: allowNestedTables } = (0, $4fqPo.useContext)((0, $AmJJl.ValidationContext)) || {};
    const validationOverrides = (0, $4fqPo.useMemo)(()=>({
            allowNestedTables: allowNestedTables
        }), [
        allowNestedTables
    ]);
    return /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$var$RendererFunctionalComponentWithPortalContext, {
        ...props,
        startPos: startPos,
        isTopLevelRenderer: props.isTopLevelRenderer ?? isTopLevelRenderer,
        skipValidation: skipValidation,
        validationOverrides: validationOverrides
    });
}
const $e583da8b181b1ba2$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo((props)=>/*#__PURE__*/ (0, $lqVX7.jsx)((0, $dQ0Pl.FabricEditorAnalyticsContext), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        data: {
            appearance: (0, $jzosZ.getAnalyticsAppearance)(props.appearance),
            packageName: $e583da8b181b1ba2$var$packageName,
            packageVersion: $e583da8b181b1ba2$var$packageVersion,
            componentName: 'renderer',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($3izZW)))()
        }
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $feY6v.WithCreateAnalyticsEvent), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $f5eyN.ErrorBoundary), {
                component: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $1cagQ.IntlErrorBoundary), null, /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $e583da8b181b1ba2$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, contentMode: contentMode, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, allowRendererContainerStyles: allowRendererContainerStyles } = props;
    const createTelepointer = ()=>{
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- telepointer span for collaborative presence
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $3Aw44.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(true);
    const { nestedRendererType: nestedRendererType } = (0, $bUvFG.useRendererContext)();
    (0, $4fqPo.useEffect)(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef !== null && innerRef !== void 0 && innerRef.current) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation, _index)=>{
                    var _mutation$addedNodes$, _mutation$removedNode;
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $3Aw44.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $3Aw44.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                    /**
           * When streaming ADF content, we may receive mutations where nodes get
           * replaced, rather than have characterData updated.
           *
           * Telepointer changes will also cause a childList mutation, so we manually ignore it.
           * Telepointer changes are always a singular node-adds or node-removes.
           */ if (mutation.type === 'childList' && !(mutation.addedNodes.length === 1 && ((_mutation$addedNodes$ = mutation.addedNodes[0]) === null || _mutation$addedNodes$ === void 0 ? void 0 : _mutation$addedNodes$.id) === (0, $3Aw44.TELEPOINTER_ID) || mutation.removedNodes.length === 1 && ((_mutation$removedNode = mutation.removedNodes[0]) === null || _mutation$removedNode === void 0 ? void 0 : _mutation$removedNode.id) === (0, $3Aw44.TELEPOINTER_ID))) {
                        const lastChild = renderer.lastChild;
                        if (lastChild) {
                            /**
               * We want to place telepointer inside content (which has data-renderer-start-pos) and
               * inside lines in codeblocks (which have data-ds--code--row).
               */ const contentElements = lastChild.querySelectorAll('[data-renderer-start-pos],[data-ds--code--row]');
                            const lastElement = contentElements[contentElements.length - 1];
                            const oldTelepointer = renderer.querySelector(`#${(0, $3Aw44.TELEPOINTER_ID)}`);
                            if (lastElement) {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastElement === null || lastElement === void 0 || lastElement.appendChild(createTelepointer());
                            } else {
                                oldTelepointer === null || oldTelepointer === void 0 || oldTelepointer.remove();
                                lastChild === null || lastChild === void 0 || lastChild.appendChild(createTelepointer());
                            }
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    const renderer = /*#__PURE__*/ (0, $lqVX7.jsx)((0, $ag3hq.WidthProvider), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop -- legacy renderer wrapper appearance classes
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $bGK06.BaseTheme), {
        baseFontSize: (0, $8jG2i.getBaseFontSize)(appearance, contentMode)
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $1z761.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $jITpP.RendererStyleContainer), {
        innerRef: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        appearance: appearance,
        contentMode: contentMode,
        allowNestedHeaderLinks: allowNestedHeaderLinks,
        allowColumnSorting: !!allowColumnSorting,
        useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
        allowAnnotations: props.allowAnnotations,
        allowTableResizing: allowTableResizing,
        allowRendererContainerStyles: allowRendererContainerStyles,
        isInsideSyncBlock: nestedRendererType === 'syncedBlock'
    }, children))));
    // We can only make the wrapper div query container when we have a known width.
    // This is also required for SSR to work correctly. As WidthProvider/WithConsumer will not have the correct width during SSR.
    //
    // allowRendererContainerStyles is not needed for comment container styling as container should always be set for comments
    if (appearance === 'comment' && isTopLevelRenderer && (0, $3H4LK.fg)('platform-ssr-table-resize')) return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $e583da8b181b1ba2$var$setAsQueryContainerStyles
    }, renderer);
    // We are setting this wrapper div as query container conditionally.
    // Only apply container-type = inline-size when having a known width in full-page/full-width/comment mode.
    // Otherwise when appearance is unspecified the renderer size is decided by the content.
    // In this case we can't set the container-type = inline-size as it will collapse width to 0.
    return (appearance === 'full-page' || appearance === 'full-width' || ((0, $4ubSX.expValEqualsNoExposure)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && appearance === 'max') && // In case of having excerpt-include on page there are multiple renderers nested.
    // Make sure only the root renderer is set to be query container.
    isTopLevelRenderer && allowRendererContainerStyles && (0, $3H4LK.fg)('platform-ssr-table-resize') ? /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $e583da8b181b1ba2$var$setAsQueryContainerStyles
    }, renderer) : renderer;
});
const $e583da8b181b1ba2$var$RootRendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(null);
function $e583da8b181b1ba2$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const rootRendererContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext($e583da8b181b1ba2$var$RootRendererContext);
    const actions = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const rendererRef = (0, $4fqPo.useRef)(null);
    // This doc is used by the renderer actions when applying comments to the document.
    // (via hand crafted steps based on non prosemirror based position calculations)
    // It is set to the root renderer's doc as otherwise the resulting document will
    // be incorrect (nested renderers use a fake document which represents a subset
    // of the actual document).
    let _doc;
    if ((0, $hdn08.editorExperiment)('comment_on_bodied_extensions', true) && rootRendererContextValue) // If rootRendererContextValue is set -- we are inside a nested renderer
    // and should always use the doc from the root renderer
    _doc = rootRendererContextValue.doc;
    else // If rootRendererContextValue is not set -- we are in the root renderer
    // and set the doc to the current doc.
    _doc = doc;
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (_doc) actions._privateRegisterRenderer(rendererRef, _doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        _doc,
        onAnalyticsEvent
    ]);
    if ((0, $hdn08.editorExperiment)('comment_on_bodied_extensions', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$var$RootRendererContext.Provider, {
        value: {
            doc: _doc
        }
    }, children));
    return children;
}
// Usage notes:
// Used by Confluence for nested renderers
// For the View page renderer - see RendererWithAnalytics
const $e583da8b181b1ba2$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(null);
    const innerRef = props.innerRef || localRef;
    // @see https://hello.jira.atlassian.cloud/browse/EDITOR-3389
    if (props.appearance === 'max' && !(0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) && !(0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) props.appearance = 'full-width';
    if (!allowAnnotations) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $eCph8.RendererActionsContext), null, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8sZ3k.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $lqVX7.jsx)($e583da8b181b1ba2$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $e583da8b181b1ba2$export$2e2bcd8739ae039 = $e583da8b181b1ba2$var$RendererWithAnnotationSelection;

});
parcelRegister("eevQH", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $e8714a501495e590$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $e8714a501495e590$export$1db618b7b2275ea1);

var $jE04u = parcelRequire("jE04u");

var $4a4SQ = parcelRequire("4a4SQ");
var $3p8n7 = parcelRequire("3p8n7");
var $garxK = parcelRequire("garxK");
var $clekI = parcelRequire("clekI");

var $gK3R6 = parcelRequire("gK3R6");
const $e8714a501495e590$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'panel_c1',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'fontSize',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $e8714a501495e590$export$e4e3ac1fa64862db = $e8714a501495e590$var$getDefaultSchemaConfig();
const $e8714a501495e590$export$fd147e7d448dea03 = (0, $jE04u.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $e8714a501495e590$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $garxK.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $3p8n7.multiBodiedExtension),
        extensionFrame: (0, $3p8n7.extensionFrame),
        expand: (0, $4a4SQ.expandWithNestedExpand),
        table: (0, $clekI.tableWithNestedTable),
        tableRow: (0, $clekI.tableRowWithNestedTable),
        tableCell: (0, $clekI.tableCellWithNestedTableStage0),
        tableHeader: (0, $clekI.tableHeaderWithNestedTableStage0)
    };
    return (0, $gK3R6.createSchema)(defaultSchemaConfig);
});
const $e8714a501495e590$export$1db618b7b2275ea1 = $e8714a501495e590$export$fd147e7d448dea03();

});
parcelRegister("4a4SQ", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => $bdaa4935951dbce5$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => $bdaa4935951dbce5$export$2ae5e7565ff9ffa6);
$parcel$export(module.exports, "toJSON", () => $bdaa4935951dbce5$export$54fd2c36b5cc6731);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
function $bdaa4935951dbce5$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $bdaa4935951dbce5$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $bdaa4935951dbce5$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $bdaa4935951dbce5$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $bdaa4935951dbce5$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $bdaa4935951dbce5$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $bdaa4935951dbce5$export$7b80cba28d10b2c1 = (0, $32AI7.expand)($bdaa4935951dbce5$var$nodeSpecOptions);
const $bdaa4935951dbce5$export$2ae5e7565ff9ffa6 = (0, $32AI7.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $bdaa4935951dbce5$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $bdaa4935951dbce5$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $bdaa4935951dbce5$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $bdaa4935951dbce5$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $bdaa4935951dbce5$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});
parcelRegister("32AI7", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $0bc67ac545a10bce$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $0bc67ac545a10bce$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $0bc67ac545a10bce$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockTaskItem", () => $0bc67ac545a10bce$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $0bc67ac545a10bce$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedSyncBlock", () => $0bc67ac545a10bce$export$e92c7e4302dd4371);
$parcel$export(module.exports, "bulletList", () => $0bc67ac545a10bce$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $0bc67ac545a10bce$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $0bc67ac545a10bce$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $0bc67ac545a10bce$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $0bc67ac545a10bce$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $0bc67ac545a10bce$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $0bc67ac545a10bce$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $0bc67ac545a10bce$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $0bc67ac545a10bce$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $0bc67ac545a10bce$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $0bc67ac545a10bce$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $0bc67ac545a10bce$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $0bc67ac545a10bce$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $0bc67ac545a10bce$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $0bc67ac545a10bce$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $0bc67ac545a10bce$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $0bc67ac545a10bce$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $0bc67ac545a10bce$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $0bc67ac545a10bce$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $0bc67ac545a10bce$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $0bc67ac545a10bce$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $0bc67ac545a10bce$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $0bc67ac545a10bce$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $0bc67ac545a10bce$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $0bc67ac545a10bce$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $0bc67ac545a10bce$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $0bc67ac545a10bce$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $0bc67ac545a10bce$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $0bc67ac545a10bce$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $0bc67ac545a10bce$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $0bc67ac545a10bce$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $0bc67ac545a10bce$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $0bc67ac545a10bce$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $0bc67ac545a10bce$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $0bc67ac545a10bce$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $0bc67ac545a10bce$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $0bc67ac545a10bce$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelC1", () => $0bc67ac545a10bce$export$63a5585d8a5426ad);
$parcel$export(module.exports, "paragraph", () => $0bc67ac545a10bce$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $0bc67ac545a10bce$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $0bc67ac545a10bce$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $0bc67ac545a10bce$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "syncBlock", () => $0bc67ac545a10bce$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $0bc67ac545a10bce$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $0bc67ac545a10bce$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $0bc67ac545a10bce$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $0bc67ac545a10bce$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $0bc67ac545a10bce$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $0bc67ac545a10bce$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $0bc67ac545a10bce$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $0bc67ac545a10bce$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $0bc67ac545a10bce$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $0bc67ac545a10bce$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $0bc67ac545a10bce$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $0bc67ac545a10bce$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $0bc67ac545a10bce$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $bNAQ5 = parcelRequire("bNAQ5");
const $0bc67ac545a10bce$export$c4c2f833baaebdb8 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0bc67ac545a10bce$export$67dc04e652a298ca = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $0bc67ac545a10bce$export$199922e5af8e9a6 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $0bc67ac545a10bce$export$16018c61064a18df = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$27903d543b563e39 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0bc67ac545a10bce$export$e7320d153c538837 = (0, $bNAQ5.createPMNodeSpecFactory)({
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $0bc67ac545a10bce$export$e92c7e4302dd4371 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | panel_c1 | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $0bc67ac545a10bce$export$a140c94e5ea26bee = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$8e3c2dfdc4f0453d = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $0bc67ac545a10bce$export$7bb0d5c671655cc4 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $0bc67ac545a10bce$export$e4f1c66d84049f8b = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        },
        wrap: {
            default: null
        },
        hideLineNumbers: {
            default: false
        }
    },
    code: true,
    defining: true
});
const $0bc67ac545a10bce$export$daf889beb5092f95 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $0bc67ac545a10bce$export$e6e4878f43c27cab = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0bc67ac545a10bce$export$3e6d667072febc87 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $0bc67ac545a10bce$export$324d90190a8b822a = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$47988d68fe575725 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$6959e16eeff859b4 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $0bc67ac545a10bce$export$62d45a65fb43d95e = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$2a111da947c407d2 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment breakout'
});
const $0bc67ac545a10bce$export$be4283d9a1cb1ff6 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$a19185d1233fc4b2 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$f5574b5d45fc2112 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$9f77e0932fb78f72 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0bc67ac545a10bce$export$7e3788972005cc72 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0bc67ac545a10bce$export$1b45514b112dd749 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$a8baf338431a691 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$b555be60c7703afb = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fontSize fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $0bc67ac545a10bce$export$371da9dd35aba193 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $0bc67ac545a10bce$export$46e4a324ac90507f = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$1b0c1557b234fa00 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$85461f751c457cc2 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$2b380a0f7e250af1 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$5c452ff88e35e47d = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $0bc67ac545a10bce$export$cbf8224b64e0d942 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0bc67ac545a10bce$export$2f4e72b9459914ad = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $0bc67ac545a10bce$export$16b353b2649bd8d9 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$b3b1e36c2105006d = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$ab76e7c03cd6f650 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fontSize alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $0bc67ac545a10bce$export$b3b6a70a7fa4a5be = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $0bc67ac545a10bce$export$cdae19acb0a520fd = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $0bc67ac545a10bce$export$206007566ca0aca5 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $0bc67ac545a10bce$export$76c7e83ecc9cdf05 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$987d49ffe1b0900f = (0, $bNAQ5.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$2855e964765eac9 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $0bc67ac545a10bce$export$38bab695e3f720f1 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$969fe3781ca15058 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $0bc67ac545a10bce$export$8d067f22dc2d1254 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$7e767666f2ce108a = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$4bd9a38995f6bf50 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'dataConsumer link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$db83999c14438df4 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$46f790bd65f760d0 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$750e45819f66d9d0 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $0bc67ac545a10bce$export$63cadbf5f4296627 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0bc67ac545a10bce$export$f03786aa6312d1e4 = (0, $bNAQ5.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $0bc67ac545a10bce$export$a5dc81035676e7a = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$21f42ab9b6679f44 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$63a5585d8a5426ad = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension | table)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$9c206ddddb32a9b = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$4f98472e6dc14293 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$b0710a201beac6b2 = (0, $bNAQ5.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$ea332b61641b0588 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$a1f41dc4901771f8 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$c7187bbd1a7a9244 = (0, $bNAQ5.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $0bc67ac545a10bce$export$fbeb3a3956e8a3c7 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $0bc67ac545a10bce$export$471f7ae5c4103ae1 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$b6ce52be8d7a261 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$faab0ca9701d7048 = (0, $bNAQ5.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$9852986a3ec5f6a0 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0bc67ac545a10bce$export$ce086a560a1d05f5 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $0bc67ac545a10bce$export$e1e720e5f4603e6a = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0bc67ac545a10bce$export$abf39ca178940ff3 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $0bc67ac545a10bce$export$48884d2a5190dc73 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0bc67ac545a10bce$export$2a5a518232fa1a97 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'fontSize alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        },
        valign: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $0bc67ac545a10bce$export$ce666bf02318c957 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $0bc67ac545a10bce$export$7d657479499397 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $0bc67ac545a10bce$export$6d8b0ef52e2e6390 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$375b6afcc5f4d291 = (0, $bNAQ5.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $0bc67ac545a10bce$export$6f093cfa640b7166 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0bc67ac545a10bce$export$5ea06bc686c59dc2 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0bc67ac545a10bce$export$93256a4c17b33a82 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline'
});
const $0bc67ac545a10bce$export$a12828d0f14a2762 = (0, $bNAQ5.createPMNodeSpecFactory)({});
const $0bc67ac545a10bce$export$44b79b0979d0f0f7 = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $0bc67ac545a10bce$export$310ebe0d80122e9b = (0, $bNAQ5.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("bNAQ5", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", () => $afb4df6f4dd1f54b$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $afb4df6f4dd1f54b$export$cf5823ed4e9f4c6f);
const $afb4df6f4dd1f54b$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $afb4df6f4dd1f54b$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});


parcelRegister("h8ouc", function(module, exports) {
$parcel$export(module.exports, "generateUuid", () => $e81c26dae964ffa5$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $e81c26dae964ffa5$export$31b40729666a4ae0);
const $e81c26dae964ffa5$export$1c3aefb711c3a4cc = ()=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $e81c26dae964ffa5$var$staticValue = false;
const $e81c26dae964ffa5$export$31b40729666a4ae0 = {
    setStatic (value) {
        $e81c26dae964ffa5$var$staticValue = value;
    },
    generate () {
        return $e81c26dae964ffa5$var$staticValue || $e81c26dae964ffa5$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("3p8n7", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", () => $5c730830e3b79cb0$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $5c730830e3b79cb0$export$c3c04d555a8b9013);

var $fgugZ = parcelRequire("fgugZ");

var $32AI7 = parcelRequire("32AI7");
const $5c730830e3b79cb0$export$4fdcae991fd743e7 = (0, $32AI7.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true',
            // Frames are hidden by default and the active frame is revealed via CSS.
            // Using an inline style ensures frames are invisible from the moment
            // ProseMirror inserts them into the DOM, preventing a flash of all
            // frames before the styles are injected.
            style: 'display:none'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $5c730830e3b79cb0$export$c3c04d555a8b9013 = (0, $32AI7.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $fgugZ.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("fgugZ", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", () => $989a4aa7f8138fe4$export$1765e2758fc47004);
const $989a4aa7f8138fe4$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $989a4aa7f8138fe4$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $989a4aa7f8138fe4$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("garxK", function(module, exports) {
$parcel$export(module.exports, "layoutSection", () => $9c5f07debd3b3539$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $9c5f07debd3b3539$export$4f9d8f623ff17117);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => $9c5f07debd3b3539$export$d9d3c69a64270b13);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => $9c5f07debd3b3539$export$64facded20dfd85c);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $9c5f07debd3b3539$export$b3b6a70a7fa4a5be = (0, $32AI7.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $9c5f07debd3b3539$export$cdae19acb0a520fd = (0, $32AI7.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $9c5f07debd3b3539$export$4f9d8f623ff17117 = (0, $32AI7.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $9c5f07debd3b3539$export$d9d3c69a64270b13 = (0, $32AI7.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $h8ouc.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $9c5f07debd3b3539$export$64facded20dfd85c = (0, $32AI7.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $h8ouc.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("clekI", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", () => $da7aa667d814e868$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $da7aa667d814e868$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $da7aa667d814e868$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $da7aa667d814e868$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $da7aa667d814e868$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $da7aa667d814e868$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $da7aa667d814e868$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $da7aa667d814e868$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $da7aa667d814e868$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $da7aa667d814e868$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $da7aa667d814e868$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $da7aa667d814e868$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $da7aa667d814e868$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $da7aa667d814e868$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $da7aa667d814e868$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $da7aa667d814e868$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $da7aa667d814e868$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $da7aa667d814e868$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $da7aa667d814e868$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $da7aa667d814e868$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $da7aa667d814e868$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $da7aa667d814e868$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $da7aa667d814e868$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRowWithLocalId", () => $da7aa667d814e868$export$c8f0853ac97552c9);
$parcel$export(module.exports, "tableCellWithLocalId", () => $da7aa667d814e868$export$db76cfd28a574029);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => $da7aa667d814e868$export$b82d2b1d8824143d);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => $da7aa667d814e868$export$27926e30c8a74147);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => $da7aa667d814e868$export$e9fd700fafee293a);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => $da7aa667d814e868$export$7928c3aeb4cd2213);
$parcel$export(module.exports, "tableCellStage0", () => $da7aa667d814e868$export$7ffdb7030e2f2223);
$parcel$export(module.exports, "tableHeaderStage0", () => $da7aa667d814e868$export$53c69bb0cddd9750);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => $da7aa667d814e868$export$10671ff6b5f3bd84);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => $da7aa667d814e868$export$69bdb7ac5d810d92);

var $8hmyV = parcelRequire("8hmyV");

var $356mi = parcelRequire("356mi");

var $h8ouc = parcelRequire("h8ouc");

var $9DIXD = parcelRequire("9DIXD");

var $32AI7 = parcelRequire("32AI7");

var $4eGM7 = parcelRequire("4eGM7");
const $da7aa667d814e868$export$9cfceb893b24742a = 'pm-table';
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $da7aa667d814e868$var$COL_WIDTH_ATTR_REGEX = /^\d+(,\d+)*$/u;
const $da7aa667d814e868$export$69cb4c3f80383763 = `${$da7aa667d814e868$export$9cfceb893b24742a}-cell-content-wrap`;
const $da7aa667d814e868$export$7b07d37d879c957f = `${$da7aa667d814e868$export$9cfceb893b24742a}-header-content-wrap`;
const $da7aa667d814e868$export$8dd42a84cd52da07 = `${$da7aa667d814e868$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $da7aa667d814e868$export$5e26a5c19f0865d8 = `${$da7aa667d814e868$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $da7aa667d814e868$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $356mi.N20).toLocaleLowerCase();
const $da7aa667d814e868$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && $da7aa667d814e868$var$COL_WIDTH_ATTR_REGEX.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $356mi.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $356mi.isRgb)(backgroundColor)) {
        const result = (0, $356mi.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    const valign = (0, $4eGM7.parseValign)(dom.getAttribute('data-valign'));
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        },
        ...valign && {
            valign: valign
        }
    };
};
// these are for test only
let $da7aa667d814e868$var$testGlobalTheme;
const $da7aa667d814e868$export$fd7e0dd2b74807f7 = (theme)=>{
    $da7aa667d814e868$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $da7aa667d814e868$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($da7aa667d814e868$var$testGlobalTheme) return {
        colorMode: $da7aa667d814e868$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $da7aa667d814e868$var$cssVariablePattern = /^var\(--.*\)$/u;
const $da7aa667d814e868$export$363c8dda799bfe9c = (node)=>{
    var _node$attrs;
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $da7aa667d814e868$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $da7aa667d814e868$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $356mi.isRgb)(background) && (0, $356mi.rgbToHex)(background) ? (0, $356mi.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $8hmyV.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $da7aa667d814e868$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($da7aa667d814e868$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $9DIXD.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $da7aa667d814e868$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $da7aa667d814e868$export$7b07d37d879c957f;
    else attrs.class = $da7aa667d814e868$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    if (node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
const $da7aa667d814e868$export$219b7f492ad209f8 = new Map();
const $da7aa667d814e868$export$95e9c925fbf01d1c = (0, $356mi.hexToRgba)((0, $356mi.N800), 0.12) || (0, $356mi.N0);
const $da7aa667d814e868$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $356mi.N0),
        'White'
    ],
    [
        (0, $356mi.B50),
        'Light blue'
    ],
    [
        (0, $356mi.T50),
        'Light teal'
    ],
    [
        (0, $356mi.G50),
        'Light green'
    ],
    [
        (0, $356mi.Y50),
        'Light yellow'
    ],
    [
        (0, $356mi.R50),
        'Light red'
    ],
    [
        (0, $356mi.P50),
        'Light purple'
    ],
    [
        (0, $356mi.N20),
        'Light gray'
    ],
    [
        (0, $356mi.B75),
        'Blue'
    ],
    [
        (0, $356mi.T75),
        'Teal'
    ],
    [
        (0, $356mi.G75),
        'Green'
    ],
    [
        (0, $356mi.Y75),
        'Yellow'
    ],
    [
        (0, $356mi.R75),
        'Red'
    ],
    [
        (0, $356mi.P75),
        'Purple'
    ],
    [
        (0, $356mi.N60),
        'Gray'
    ],
    [
        (0, $356mi.B100),
        'Dark blue'
    ],
    [
        (0, $356mi.T100),
        'Dark teal'
    ],
    [
        (0, $356mi.G200),
        'Dark green'
    ],
    [
        (0, $356mi.Y200),
        'Dark yellow'
    ],
    [
        (0, $356mi.R100),
        'Dark red'
    ],
    [
        (0, $356mi.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $da7aa667d814e868$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $da7aa667d814e868$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
const $da7aa667d814e868$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                var _dom$parentElement;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $h8ouc.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $da7aa667d814e868$var$createTableSpec = ()=>(0, $32AI7.table)($da7aa667d814e868$var$tableNodeSpecOptions);
const $da7aa667d814e868$export$9852986a3ec5f6a0 = $da7aa667d814e868$var$createTableSpec();
const $da7aa667d814e868$export$90e634fbace1f0c4 = $da7aa667d814e868$var$createTableSpec();
const $da7aa667d814e868$export$3862de5c8c9098cf = $da7aa667d814e868$var$createTableSpec();
const $da7aa667d814e868$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $da7aa667d814e868$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$da7aa667d814e868$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $da7aa667d814e868$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $da7aa667d814e868$export$ce666bf02318c957 = (0, $32AI7.tableRow)($da7aa667d814e868$var$tableRowNodeSpecOptions);
const $da7aa667d814e868$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    },
    valign: {
        default: null,
        optional: true
    }
};
const $da7aa667d814e868$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$da7aa667d814e868$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $da7aa667d814e868$export$363c8dda799bfe9c(node),
            0
        ]
};
const $da7aa667d814e868$export$e1e720e5f4603e6a = (0, $32AI7.tableCell)($da7aa667d814e868$var$tableCellNodeSpecOptions);
const $da7aa667d814e868$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($da7aa667d814e868$var$cellAttrs[key] && $da7aa667d814e868$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $da7aa667d814e868$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $da7aa667d814e868$export$43977bde391e007(dom, {
                    background: $da7aa667d814e868$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $da7aa667d814e868$export$363c8dda799bfe9c(node),
            0
        ]
};
const $da7aa667d814e868$export$48884d2a5190dc73 = (0, $32AI7.tableHeader)($da7aa667d814e868$var$tableHeaderNodeSpecOptions);
const $da7aa667d814e868$export$2af48797a1010bb1 = $da7aa667d814e868$export$2ac34c099660f1a8;
const $da7aa667d814e868$export$ce086a560a1d05f5 = (0, $32AI7.tableWithNestedTable)($da7aa667d814e868$var$tableNodeSpecOptions);
const $da7aa667d814e868$export$7d657479499397 = (0, $32AI7.tableRowWithNestedTable)($da7aa667d814e868$var$tableRowNodeSpecOptions);
const $da7aa667d814e868$export$abf39ca178940ff3 = (0, $32AI7.tableCellWithNestedTable)($da7aa667d814e868$var$tableCellNodeSpecOptions);
const $da7aa667d814e868$export$2a5a518232fa1a97 = (0, $32AI7.tableHeaderWithNestedTable)($da7aa667d814e868$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $da7aa667d814e868$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
const $da7aa667d814e868$export$c8f0853ac97552c9 = (0, $32AI7.tableRow)($da7aa667d814e868$var$tableRowNodeSpecOptionsWithLocalId);
const $da7aa667d814e868$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $da7aa667d814e868$export$43977bde391e007(dom, {
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $da7aa667d814e868$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $da7aa667d814e868$export$db76cfd28a574029 = (0, $32AI7.tableCell)($da7aa667d814e868$var$tableCellNodeSpecOptionsWithLocalId);
const $da7aa667d814e868$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $da7aa667d814e868$export$43977bde391e007(dom, {
                    background: $da7aa667d814e868$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $da7aa667d814e868$export$363c8dda799bfe9c(node),
            0
        ]
};
const $da7aa667d814e868$export$b82d2b1d8824143d = (0, $32AI7.tableHeader)($da7aa667d814e868$var$tableHeaderNodeSpecOptionsWithLocalId);
const $da7aa667d814e868$export$27926e30c8a74147 = (0, $32AI7.tableRowWithNestedTable)($da7aa667d814e868$var$tableRowNodeSpecOptionsWithLocalId);
const $da7aa667d814e868$export$e9fd700fafee293a = (0, $32AI7.tableCellWithNestedTable)($da7aa667d814e868$var$tableCellNodeSpecOptionsWithLocalId);
const $da7aa667d814e868$export$7928c3aeb4cd2213 = (0, $32AI7.tableHeaderWithNestedTable)($da7aa667d814e868$var$tableHeaderNodeSpecOptionsWithLocalId);
const $da7aa667d814e868$export$7ffdb7030e2f2223 = $da7aa667d814e868$export$db76cfd28a574029;
const $da7aa667d814e868$export$53c69bb0cddd9750 = $da7aa667d814e868$export$b82d2b1d8824143d;
const $da7aa667d814e868$export$10671ff6b5f3bd84 = $da7aa667d814e868$export$e9fd700fafee293a;
const $da7aa667d814e868$export$69bdb7ac5d810d92 = $da7aa667d814e868$export$7928c3aeb4cd2213;

});
parcelRegister("8hmyV", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $05a0ea8427a37cd8$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $05a0ea8427a37cd8$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $05a0ea8427a37cd8$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $05a0ea8427a37cd8$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $05a0ea8427a37cd8$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $05a0ea8427a37cd8$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $05a0ea8427a37cd8$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $05a0ea8427a37cd8$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $05a0ea8427a37cd8$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $05a0ea8427a37cd8$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)',
    /** lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** lime - medium */ '#6A9A23': 'var(--ds-icon-accent-lime, #6A9A23)',
    /** lime - strong */ '#4C6B1F': 'var(--ds-text-accent-lime, #4C6B1F)',
    /** orange - light */ '#FCE4A6': 'var(--ds-background-accent-orange-subtler, #FCE4A6)',
    /** orange - medium */ '#E06C00': 'var(--ds-icon-accent-orange, #E06C00)',
    /** orange - strong */ '#9E4C00': 'var(--ds-text-accent-orange, #9E4C00)',
    /** magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** magenta - medium */ '#CD519D': 'var(--ds-icon-accent-magenta, #CD519D)',
    /** magenta - strong */ '#943D73': 'var(--ds-text-accent-magenta, #943D73)',
    /** yellow - medium */ '#B38600': 'var(--ds-icon-accent-yellow, #B38600)',
    /** yellow - strong */ '#7F5F01': 'var(--ds-text-accent-yellow, #7F5F01)'
};
function $05a0ea8427a37cd8$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $05a0ea8427a37cd8$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $05a0ea8427a37cd8$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)',
    /** Blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** Green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)'
};
function $05a0ea8427a37cd8$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = hexColor ? $05a0ea8427a37cd8$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $05a0ea8427a37cd8$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("356mi", function(module, exports) {
$parcel$export(module.exports, "R50", () => $b34b0d666a81e090$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $b34b0d666a81e090$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $b34b0d666a81e090$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $b34b0d666a81e090$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $b34b0d666a81e090$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $b34b0d666a81e090$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $b34b0d666a81e090$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $b34b0d666a81e090$export$5aae31392d72caaa);
$parcel$export(module.exports, "Yellow200", () => $b34b0d666a81e090$export$fc857b6f8771648a);
$parcel$export(module.exports, "Y400", () => $b34b0d666a81e090$export$59619663aa6500fb);
$parcel$export(module.exports, "Y600", () => $b34b0d666a81e090$export$8d067e56aec921ba);
$parcel$export(module.exports, "Y800", () => $b34b0d666a81e090$export$880b9499608823af);
$parcel$export(module.exports, "G50", () => $b34b0d666a81e090$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $b34b0d666a81e090$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $b34b0d666a81e090$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $b34b0d666a81e090$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $b34b0d666a81e090$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $b34b0d666a81e090$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $b34b0d666a81e090$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $b34b0d666a81e090$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $b34b0d666a81e090$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $b34b0d666a81e090$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $b34b0d666a81e090$export$f72948ef771f6f15);
$parcel$export(module.exports, "L600", () => $b34b0d666a81e090$export$b118f20869cce368);
$parcel$export(module.exports, "L800", () => $b34b0d666a81e090$export$4d2dfdfde6a26b06);
$parcel$export(module.exports, "N0", () => $b34b0d666a81e090$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $b34b0d666a81e090$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $b34b0d666a81e090$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $b34b0d666a81e090$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $b34b0d666a81e090$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $b34b0d666a81e090$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $b34b0d666a81e090$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $b34b0d666a81e090$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $b34b0d666a81e090$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $b34b0d666a81e090$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $b34b0d666a81e090$export$a19f0c33186f7767);
$parcel$export(module.exports, "M600", () => $b34b0d666a81e090$export$3bff0a0c68537008);
$parcel$export(module.exports, "M800", () => $b34b0d666a81e090$export$aedcf6658caf5ad6);
$parcel$export(module.exports, "O200", () => $b34b0d666a81e090$export$51716a84e62e022c);
$parcel$export(module.exports, "Orange200", () => $b34b0d666a81e090$export$a0fa9fa6bfbb29d1);
$parcel$export(module.exports, "O600", () => $b34b0d666a81e090$export$65becf92d294645b);
$parcel$export(module.exports, "O800", () => $b34b0d666a81e090$export$d50a5202329f668e);
$parcel$export(module.exports, "P50", () => $b34b0d666a81e090$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $b34b0d666a81e090$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $b34b0d666a81e090$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $b34b0d666a81e090$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $b34b0d666a81e090$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $b34b0d666a81e090$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $b34b0d666a81e090$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $b34b0d666a81e090$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $b34b0d666a81e090$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $b34b0d666a81e090$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $b34b0d666a81e090$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $b34b0d666a81e090$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $b34b0d666a81e090$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $b34b0d666a81e090$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $b34b0d666a81e090$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $b34b0d666a81e090$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgba", () => $b34b0d666a81e090$export$9665a07d9187b414);
// @ts-ignore
// eslint-disable-next-line import/no-namespace

var $dvHTq = parcelRequire("dvHTq");
const $b34b0d666a81e090$export$4b84fd0e2c617bd = '#FFEBE6';
const $b34b0d666a81e090$export$b34b069eff244586 = '#FFBDAD';
const $b34b0d666a81e090$export$be802dd0d8b57f35 = '#FF8F73';
const $b34b0d666a81e090$export$4a7404f376229999 = '#FF5630';
const $b34b0d666a81e090$export$2010d0fb4295b346 = '#DE350B';
const $b34b0d666a81e090$export$2837b5a1a71d5c02 = '#BF2600';
const $b34b0d666a81e090$export$8d9596b529bbb9cf = '#FFFAE6';
const $b34b0d666a81e090$export$41060a744ab0b7ae = '#FFF0B3';
const $b34b0d666a81e090$export$5aae31392d72caaa = '#FFC400';
const $b34b0d666a81e090$export$fc857b6f8771648a = '#F8E6A0';
const $b34b0d666a81e090$export$59619663aa6500fb = '#FF991F';
const $b34b0d666a81e090$export$874739ea9e379ab6 = '#FF8B00';
const $b34b0d666a81e090$export$8d067e56aec921ba = '#B38600';
const $b34b0d666a81e090$export$880b9499608823af = '#7F5F01';
const $b34b0d666a81e090$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $b34b0d666a81e090$export$69a3bf21b9686c2b = '#ABF5D1';
const $b34b0d666a81e090$export$747d86715d4175de = '#57D9A3';
const $b34b0d666a81e090$export$940e1f69e873f202 = '#36B37E';
const $b34b0d666a81e090$export$a49394138f7b8e85 = '#00875A';
const $b34b0d666a81e090$export$6fa04827ac68a4fb = '#006644';
const $b34b0d666a81e090$export$226de0355ed012f8 = '#DEEBFF';
const $b34b0d666a81e090$export$8c13c2ee36917869 = '#B3D4FF';
const $b34b0d666a81e090$export$ecfc1dff386a3e7a = '#4C9AFF';
const $b34b0d666a81e090$export$b3de0ae08da2ce64 = '#0052CC';
const $b34b0d666a81e090$export$a6ee3d71bc067634 = '#0747A6';
const $b34b0d666a81e090$export$f72948ef771f6f15 = '#D3F1A7';
const $b34b0d666a81e090$export$b118f20869cce368 = '#6A9A23';
const $b34b0d666a81e090$export$4d2dfdfde6a26b06 = '#4C6B1F';
const $b34b0d666a81e090$export$29a4f05edc054374 = '#FFFFFF';
const $b34b0d666a81e090$export$9fdfb749e33cdf97 = '#F4F5F7';
const $b34b0d666a81e090$export$3e51e8f1440314ba = '#EBECF0';
const $b34b0d666a81e090$export$1ce2d1575d444ceb = '#DFE1E6';
const $b34b0d666a81e090$export$8754fc7e6d8b3000 = '#C1C7D0';
const $b34b0d666a81e090$export$c2e91cbeada39b8b = '#B3BAC5';
const $b34b0d666a81e090$export$eaa8c8a70ac22806 = '#97A0AF';
const $b34b0d666a81e090$export$7c87d337fb91a97d = '#8993A4';
const $b34b0d666a81e090$export$f563ee71e9ee74cd = '#6B778C';
const $b34b0d666a81e090$export$e2ef2124cf4024b1 = '#5E6C84';
const $b34b0d666a81e090$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $b34b0d666a81e090$export$13609db0e6812ab8 = '#091E4224';
const $b34b0d666a81e090$export$c39c0fe0f26207ae = '#42526E';
const $b34b0d666a81e090$export$7090862dc3038a9f = '#758195';
const $b34b0d666a81e090$export$7d61b15e0da132af = '#172B4D';
const $b34b0d666a81e090$export$f78789c8b01753cd = '#172B4D';
const $b34b0d666a81e090$export$a19f0c33186f7767 = '#FDD0EC';
const $b34b0d666a81e090$export$3bff0a0c68537008 = '#CD519D';
const $b34b0d666a81e090$export$aedcf6658caf5ad6 = '#943D73';
const $b34b0d666a81e090$export$51716a84e62e022c = '#FEDEC8';
const $b34b0d666a81e090$export$a0fa9fa6bfbb29d1 = '#FCE4A6';
const $b34b0d666a81e090$export$65becf92d294645b = '#E06C00';
const $b34b0d666a81e090$export$d50a5202329f668e = '#9E4C00';
const $b34b0d666a81e090$export$363e4475840015bb = '#EAE6FF';
const $b34b0d666a81e090$export$4b0a4417ed59760f = '#C0B6F2';
const $b34b0d666a81e090$export$6011520a64d9a187 = '#998DD9';
const $b34b0d666a81e090$export$a7175d4e9206bc80 = '#DFD8FD';
const $b34b0d666a81e090$export$b48405b95304b5a1 = '#6554C0';
const $b34b0d666a81e090$export$c71e4279dd54a18d = '#5243AA';
const $b34b0d666a81e090$export$147899de772240ec = '#403294';
const $b34b0d666a81e090$export$2cf711fe14c66f06 = '#E6FCFF';
const $b34b0d666a81e090$export$7a8f4d33f6f9772c = '#B3F5FF';
const $b34b0d666a81e090$export$776c9c497ef08533 = '#79E2F2';
const $b34b0d666a81e090$export$69cb3ca10c1e330e = '#C6EDFB';
const $b34b0d666a81e090$export$9dc1ef0f3f48059b = '#00B8D9';
const $b34b0d666a81e090$export$6036577f95c3877e = '#008DA6';
function $b34b0d666a81e090$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($b34b0d666a81e090$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($b34b0d666a81e090$export$e698776ec826343(color)) return $b34b0d666a81e090$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $dvHTq.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $dvHTq.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $dvHTq.default[color];
        else if ($dvHTq && $dvHTq[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $dvHTq[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $b34b0d666a81e090$export$5a544e13ad4e1fa5(color) {
    if (!$b34b0d666a81e090$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $b34b0d666a81e090$export$9665a07d9187b414(rawColor, alpha) {
    const color = $b34b0d666a81e090$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $b34b0d666a81e090$export$34d09c4a771c46ef(value) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $b34b0d666a81e090$var$IS_RGB_REGEX = /rgba?\(/u;
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $b34b0d666a81e090$var$IS_HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/u;
function $b34b0d666a81e090$export$e698776ec826343(color) {
    return $b34b0d666a81e090$var$IS_RGB_REGEX.test(color);
}
function $b34b0d666a81e090$export$8a9b6341a7c96bc(color) {
    return $b34b0d666a81e090$var$IS_HEX_REGEX.test(color);
}

});
parcelRegister("dvHTq", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("9DIXD", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", () => $b17dcc2b8a4a9723$export$a5065c3b8aacaf99);
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $b17dcc2b8a4a9723$var$SHORTHAND_HEX_REGEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/iu;
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $b17dcc2b8a4a9723$var$FULL_HEX_REGEX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu;
const $b17dcc2b8a4a9723$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $b17dcc2b8a4a9723$var$expandShorthandHex = (input)=>input.replace($b17dcc2b8a4a9723$var$SHORTHAND_HEX_REGEX, (m, r, g, b)=>r + r + g + g + b + b);
const $b17dcc2b8a4a9723$var$rgbFromHex = (input)=>{
    const fullHex = $b17dcc2b8a4a9723$var$expandShorthandHex(input);
    const result = $b17dcc2b8a4a9723$var$FULL_HEX_REGEX.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $b17dcc2b8a4a9723$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $b17dcc2b8a4a9723$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $b17dcc2b8a4a9723$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $b17dcc2b8a4a9723$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $b17dcc2b8a4a9723$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $b17dcc2b8a4a9723$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $b17dcc2b8a4a9723$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $b17dcc2b8a4a9723$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $b17dcc2b8a4a9723$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $b17dcc2b8a4a9723$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $b17dcc2b8a4a9723$var$rgbToLch = (rgb)=>$b17dcc2b8a4a9723$var$labToLch($b17dcc2b8a4a9723$var$xyzToLab($b17dcc2b8a4a9723$var$rgbToXyz(rgb)));
const $b17dcc2b8a4a9723$var$lchToRgb = (lch)=>$b17dcc2b8a4a9723$var$xyzToRgb($b17dcc2b8a4a9723$var$labToXyz($b17dcc2b8a4a9723$var$lchToLab(lch)));
const $b17dcc2b8a4a9723$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $b17dcc2b8a4a9723$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $b17dcc2b8a4a9723$var$rgbToLch(rgb);
    lch.l = $b17dcc2b8a4a9723$var$clamp(newPercent, 0, 100);
    return $b17dcc2b8a4a9723$var$rgbToHex($b17dcc2b8a4a9723$var$lchToRgb(lch));
};
const $b17dcc2b8a4a9723$var$getLightness = (color)=>{
    const rgb = $b17dcc2b8a4a9723$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $b17dcc2b8a4a9723$var$rgbToLch(rgb);
    return lch.l;
};
const $b17dcc2b8a4a9723$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $b17dcc2b8a4a9723$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $b17dcc2b8a4a9723$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});

parcelRegister("4eGM7", function(module, exports) {
$parcel$export(module.exports, "parseValign", () => $4a90c7c93463b3d5$export$80408efb85c33a7a);
const $4a90c7c93463b3d5$export$80408efb85c33a7a = (raw)=>{
    switch(raw){
        case 'top':
        case 'middle':
        case 'bottom':
            return raw;
        default:
            return undefined;
    }
};

});


parcelRegister("gK3R6", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $15da9c3e7c5a0112$export$5f4ce795563f4211);

var $7p5u4 = parcelRequire("7p5u4");

var $bar7S = parcelRequire("bar7S");

var $dshZO = parcelRequire("dshZO");

var $420HY = parcelRequire("420HY");
var $6ctpG = parcelRequire("6ctpG");
var $6GNGR = parcelRequire("6GNGR");
var $9r6IO = parcelRequire("9r6IO");
var $4sanW = parcelRequire("4sanW");
var $iaS5j = parcelRequire("iaS5j");
var $6fsbB = parcelRequire("6fsbB");
var $4u3vK = parcelRequire("4u3vK");
var $4MDQR = parcelRequire("4MDQR");
var $ePkTL = parcelRequire("ePkTL");
var $d04vw = parcelRequire("d04vw");
var $9tBsB = parcelRequire("9tBsB");
var $dwqYv = parcelRequire("dwqYv");
var $ao8yJ = parcelRequire("ao8yJ");
var $ebKEa = parcelRequire("ebKEa");
var $aTvYw = parcelRequire("aTvYw");
var $2M4vR = parcelRequire("2M4vR");
var $8aNkC = parcelRequire("8aNkC");
var $9dUmA = parcelRequire("9dUmA");
var $jWiTr = parcelRequire("jWiTr");
var $grhaY = parcelRequire("grhaY");

var $6YskE = parcelRequire("6YskE");
var $43GOy = parcelRequire("43GOy");
var $a99AW = parcelRequire("a99AW");
var $5s4YT = parcelRequire("5s4YT");
var $8EdAG = parcelRequire("8EdAG");
var $9DaXy = parcelRequire("9DaXy");
var $1rzDq = parcelRequire("1rzDq");
var $gFlMH = parcelRequire("gFlMH");
var $bUXVW = parcelRequire("bUXVW");
var $2fO2k = parcelRequire("2fO2k");
var $gVA9a = parcelRequire("gVA9a");
var $1WTWd = parcelRequire("1WTWd");
var $1Kym8 = parcelRequire("1Kym8");
var $8FRQe = parcelRequire("8FRQe");
var $beODP = parcelRequire("beODP");
var $5fTUY = parcelRequire("5fTUY");
var $4a4SQ = parcelRequire("4a4SQ");
var $cFm3k = parcelRequire("cFm3k");
var $9Y1m8 = parcelRequire("9Y1m8");
var $4p5eD = parcelRequire("4p5eD");
var $3p8n7 = parcelRequire("3p8n7");
var $dvPmQ = parcelRequire("dvPmQ");
var $fzauD = parcelRequire("fzauD");
var $cYDNc = parcelRequire("cYDNc");
var $hMy1x = parcelRequire("hMy1x");
var $d8hbR = parcelRequire("d8hbR");
var $atOwT = parcelRequire("atOwT");
var $garxK = parcelRequire("garxK");
var $gN2eH = parcelRequire("gN2eH");
var $0585H = parcelRequire("0585H");
var $jd5NI = parcelRequire("jd5NI");
var $gPg9H = parcelRequire("gPg9H");
var $1lZPC = parcelRequire("1lZPC");
var $aRXZh = parcelRequire("aRXZh");
var $2lECo = parcelRequire("2lECo");
var $aZvqc = parcelRequire("aZvqc");
var $1yeB0 = parcelRequire("1yeB0");
var $6KpcC = parcelRequire("6KpcC");
var $kN7jZ = parcelRequire("kN7jZ");
var $6WkNC = parcelRequire("6WkNC");
var $6s3pT = parcelRequire("6s3pT");
var $clekI = parcelRequire("clekI");
var $6DOrW = parcelRequire("6DOrW");
var $gRNnW = parcelRequire("gRNnW");
var $4FwVM = parcelRequire("4FwVM");
var $ejaRu = parcelRequire("ejaRu");
var $ieg9J = parcelRequire("ieg9J");
function $15da9c3e7c5a0112$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $15da9c3e7c5a0112$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $15da9c3e7c5a0112$var$markGroupDeclarations = [
    $15da9c3e7c5a0112$var$groupDeclaration((0, $bar7S.COLOR)),
    $15da9c3e7c5a0112$var$groupDeclaration((0, $bar7S.FONT_STYLE)),
    $15da9c3e7c5a0112$var$groupDeclaration((0, $bar7S.SEARCH_QUERY)),
    $15da9c3e7c5a0112$var$groupDeclaration((0, $bar7S.LINK))
];
const $15da9c3e7c5a0112$var$markGroupDeclarationsNames = $15da9c3e7c5a0112$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $15da9c3e7c5a0112$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $8FRQe.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $1yeB0.paragraph)
    },
    {
        name: 'text',
        spec: (0, $gRNnW.text)
    },
    {
        name: 'bulletList',
        spec: (0, $8EdAG.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $aZvqc.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $gN2eH.listItem)
    },
    {
        name: 'heading',
        spec: (0, $fzauD.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $cFm3k.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $1rzDq.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $9Y1m8.extendedPanel)(true)
    },
    {
        name: 'panel_c1',
        spec: (0, $9Y1m8.extendedPanelC1)(true)
    },
    {
        name: 'rule',
        spec: (0, $kN7jZ.rule)
    },
    {
        name: 'image',
        spec: (0, $cYDNc.image)
    },
    {
        name: 'mention',
        spec: (0, $aRXZh.mention)
    },
    {
        name: 'caption',
        spec: (0, $9DaXy.caption)
    },
    {
        name: 'media',
        spec: (0, $0585H.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $jd5NI.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $1lZPC.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $gPg9H.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $6KpcC.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $garxK.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $atOwT.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $dvPmQ.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $5fTUY.emoji)
    },
    {
        name: 'table',
        spec: (0, $clekI.table)
    },
    {
        name: 'tableCell',
        spec: (0, $clekI.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $clekI.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $clekI.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $gFlMH.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $2fO2k.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $bUXVW.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $1Kym8.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $1WTWd.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $6DOrW.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $43GOy.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $43GOy.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $gVA9a.date)
    },
    {
        name: 'status',
        spec: (0, $6WkNC.status)
    },
    {
        name: 'expand',
        spec: (0, $4a4SQ.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $2lECo.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $4p5eD.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $d8hbR.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $a99AW.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $3p8n7.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $3p8n7.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $hMy1x.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $6YskE.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $beODP.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $6s3pT.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $5s4YT.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $4FwVM.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $ejaRu.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $ieg9J.unsupportedInline)
    }
];
const $15da9c3e7c5a0112$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $dwqYv.link)
    },
    {
        name: 'em',
        spec: (0, $4MDQR.em)
    },
    {
        name: 'strong',
        spec: (0, $ebKEa.strong)
    },
    {
        name: 'textColor',
        spec: (0, $2M4vR.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $6GNGR.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $ao8yJ.strike)
    },
    {
        name: 'subsup',
        spec: (0, $aTvYw.subsup)
    },
    {
        name: 'underline',
        spec: (0, $9dUmA.underline)
    },
    {
        name: 'code',
        spec: (0, $iaS5j.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $8aNkC.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $420HY.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $6ctpG.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $6fsbB.confluenceInlineComment)
    },
    ...$15da9c3e7c5a0112$var$markGroupDeclarations,
    {
        name: 'fontSize',
        spec: (0, $ePkTL.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $4sanW.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $4u3vK.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $d04vw.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $9tBsB.indentation)
    },
    {
        name: 'border',
        spec: (0, $9r6IO.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jWiTr.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $grhaY.unsupportedNodeAttribute)
    }
];
function $15da9c3e7c5a0112$export$2d0c32a809131488() {
    const nodes = $15da9c3e7c5a0112$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $15da9c3e7c5a0112$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $15da9c3e7c5a0112$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($15da9c3e7c5a0112$var$markGroupDeclarationsNames);
    let nodes = $15da9c3e7c5a0112$var$addItems($15da9c3e7c5a0112$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $15da9c3e7c5a0112$var$addItems($15da9c3e7c5a0112$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $dshZO.sanitizeNodes)(nodes, marks);
    return new (0, $7p5u4.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $15da9c3e7c5a0112$export$c77b6d30da5276a1 = true;

});
parcelRegister("7p5u4", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $563f1f37d3d42df1$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $563f1f37d3d42df1$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $563f1f37d3d42df1$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $563f1f37d3d42df1$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $563f1f37d3d42df1$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $563f1f37d3d42df1$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $563f1f37d3d42df1$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $563f1f37d3d42df1$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $563f1f37d3d42df1$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $563f1f37d3d42df1$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $563f1f37d3d42df1$export$3476b78f8f5a8b72);

var $j1vZB = parcelRequire("j1vZB");
function $563f1f37d3d42df1$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $563f1f37d3d42df1$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $563f1f37d3d42df1$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $563f1f37d3d42df1$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $563f1f37d3d42df1$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $563f1f37d3d42df1$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $563f1f37d3d42df1$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $563f1f37d3d42df1$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $563f1f37d3d42df1$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $563f1f37d3d42df1$var$retIndex(0, pos);
        if (pos == this.size) return $563f1f37d3d42df1$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $563f1f37d3d42df1$var$retIndex(i + 1, end);
                return $563f1f37d3d42df1$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $563f1f37d3d42df1$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $563f1f37d3d42df1$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $563f1f37d3d42df1$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $563f1f37d3d42df1$export$ffb0004e005737fa.empty;
        if (nodes instanceof $563f1f37d3d42df1$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $563f1f37d3d42df1$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $563f1f37d3d42df1$export$ffb0004e005737fa.empty = new $563f1f37d3d42df1$export$ffb0004e005737fa([], 0);
const $563f1f37d3d42df1$var$found = {
    index: 0,
    offset: 0
};
function $563f1f37d3d42df1$var$retIndex(index, offset) {
    $563f1f37d3d42df1$var$found.index = index;
    $563f1f37d3d42df1$var$found.offset = offset;
    return $563f1f37d3d42df1$var$found;
}
function $563f1f37d3d42df1$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$563f1f37d3d42df1$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$563f1f37d3d42df1$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $563f1f37d3d42df1$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $563f1f37d3d42df1$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
        if (marks instanceof $563f1f37d3d42df1$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $563f1f37d3d42df1$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $563f1f37d3d42df1$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $563f1f37d3d42df1$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $563f1f37d3d42df1$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $563f1f37d3d42df1$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $563f1f37d3d42df1$export$b3f2e2de3a8baa1e($563f1f37d3d42df1$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $563f1f37d3d42df1$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $563f1f37d3d42df1$export$b3f2e2de3a8baa1e($563f1f37d3d42df1$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $563f1f37d3d42df1$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $563f1f37d3d42df1$export$b3f2e2de3a8baa1e.empty = new $563f1f37d3d42df1$export$b3f2e2de3a8baa1e($563f1f37d3d42df1$export$ffb0004e005737fa.empty, 0, 0);
function $563f1f37d3d42df1$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($563f1f37d3d42df1$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $563f1f37d3d42df1$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $563f1f37d3d42df1$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $563f1f37d3d42df1$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $563f1f37d3d42df1$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $563f1f37d3d42df1$export$6de0e778727af3f2("Inconsistent open depths");
    return $563f1f37d3d42df1$var$replaceOuter($from, $to, slice, 0);
}
function $563f1f37d3d42df1$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $563f1f37d3d42df1$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $563f1f37d3d42df1$var$close(node, $563f1f37d3d42df1$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $563f1f37d3d42df1$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $563f1f37d3d42df1$var$prepareSliceForReplace(slice, $from);
        return $563f1f37d3d42df1$var$close(node, $563f1f37d3d42df1$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $563f1f37d3d42df1$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $563f1f37d3d42df1$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $563f1f37d3d42df1$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $563f1f37d3d42df1$var$checkJoin(node, $after.node(depth));
    return node;
}
function $563f1f37d3d42df1$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $563f1f37d3d42df1$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $563f1f37d3d42df1$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$563f1f37d3d42df1$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $563f1f37d3d42df1$var$addNode($end.nodeBefore, target);
}
function $563f1f37d3d42df1$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $563f1f37d3d42df1$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $563f1f37d3d42df1$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $563f1f37d3d42df1$var$joinable($end, $to, depth + 1);
    let content = [];
    $563f1f37d3d42df1$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $563f1f37d3d42df1$var$checkJoin(openStart, openEnd);
        $563f1f37d3d42df1$var$addNode($563f1f37d3d42df1$var$close(openStart, $563f1f37d3d42df1$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $563f1f37d3d42df1$var$addNode($563f1f37d3d42df1$var$close(openStart, $563f1f37d3d42df1$var$replaceTwoWay($from, $start, depth + 1)), content);
        $563f1f37d3d42df1$var$addRange($start, $end, depth, content);
        if (openEnd) $563f1f37d3d42df1$var$addNode($563f1f37d3d42df1$var$close(openEnd, $563f1f37d3d42df1$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $563f1f37d3d42df1$var$addRange($to, null, depth, content);
    return new $563f1f37d3d42df1$export$ffb0004e005737fa(content);
}
function $563f1f37d3d42df1$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $563f1f37d3d42df1$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $563f1f37d3d42df1$var$joinable($from, $to, depth + 1);
        $563f1f37d3d42df1$var$addNode($563f1f37d3d42df1$var$close(type, $563f1f37d3d42df1$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $563f1f37d3d42df1$var$addRange($to, null, depth, content);
    return new $563f1f37d3d42df1$export$ffb0004e005737fa(content);
}
function $563f1f37d3d42df1$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($563f1f37d3d42df1$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $563f1f37d3d42df1$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $563f1f37d3d42df1$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $563f1f37d3d42df1$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $563f1f37d3d42df1$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $563f1f37d3d42df1$var$resolveCache.set(doc, cache = new $563f1f37d3d42df1$var$ResolveCache);
        let result = cache.elts[cache.i] = $563f1f37d3d42df1$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $563f1f37d3d42df1$var$resolveCacheSize;
        return result;
    }
}
class $563f1f37d3d42df1$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $563f1f37d3d42df1$var$resolveCacheSize = 12, $563f1f37d3d42df1$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $563f1f37d3d42df1$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $563f1f37d3d42df1$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $563f1f37d3d42df1$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $563f1f37d3d42df1$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $563f1f37d3d42df1$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $563f1f37d3d42df1$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $563f1f37d3d42df1$var$emptyAttrs) && $563f1f37d3d42df1$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $563f1f37d3d42df1$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $563f1f37d3d42df1$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $563f1f37d3d42df1$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $563f1f37d3d42df1$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $563f1f37d3d42df1$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $563f1f37d3d42df1$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $563f1f37d3d42df1$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $563f1f37d3d42df1$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $563f1f37d3d42df1$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $563f1f37d3d42df1$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$563f1f37d3d42df1$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $563f1f37d3d42df1$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$563f1f37d3d42df1$export$85c928794f8d04d4.prototype.text = undefined;
class $563f1f37d3d42df1$var$TextNode extends $563f1f37d3d42df1$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $563f1f37d3d42df1$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $563f1f37d3d42df1$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $563f1f37d3d42df1$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $563f1f37d3d42df1$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $563f1f37d3d42df1$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $563f1f37d3d42df1$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $563f1f37d3d42df1$export$364ed450558d7ec4.empty;
        let expr = $563f1f37d3d42df1$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $563f1f37d3d42df1$var$dfa($563f1f37d3d42df1$var$nfa(expr));
        $563f1f37d3d42df1$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $563f1f37d3d42df1$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $563f1f37d3d42df1$export$364ed450558d7ec4.empty = new $563f1f37d3d42df1$export$364ed450558d7ec4(true);
class $563f1f37d3d42df1$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $563f1f37d3d42df1$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($563f1f37d3d42df1$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $563f1f37d3d42df1$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($563f1f37d3d42df1$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $563f1f37d3d42df1$var$parseExprSubscript(stream) {
    let expr = $563f1f37d3d42df1$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $563f1f37d3d42df1$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $563f1f37d3d42df1$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $563f1f37d3d42df1$var$parseExprRange(stream, expr) {
    let min = $563f1f37d3d42df1$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $563f1f37d3d42df1$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $563f1f37d3d42df1$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $563f1f37d3d42df1$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $563f1f37d3d42df1$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $563f1f37d3d42df1$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $563f1f37d3d42df1$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $563f1f37d3d42df1$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $563f1f37d3d42df1$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($563f1f37d3d42df1$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $563f1f37d3d42df1$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($563f1f37d3d42df1$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $563f1f37d3d42df1$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $563f1f37d3d42df1$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($563f1f37d3d42df1$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $563f1f37d3d42df1$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $563f1f37d3d42df1$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $563f1f37d3d42df1$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $563f1f37d3d42df1$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $563f1f37d3d42df1$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $563f1f37d3d42df1$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $563f1f37d3d42df1$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $563f1f37d3d42df1$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $563f1f37d3d42df1$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $563f1f37d3d42df1$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $563f1f37d3d42df1$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $563f1f37d3d42df1$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $563f1f37d3d42df1$export$ffb0004e005737fa.from(content), $563f1f37d3d42df1$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $563f1f37d3d42df1$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $563f1f37d3d42df1$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $563f1f37d3d42df1$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $563f1f37d3d42df1$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($563f1f37d3d42df1$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $563f1f37d3d42df1$export$85c928794f8d04d4(this, attrs, content.append(after), $563f1f37d3d42df1$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $563f1f37d3d42df1$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $563f1f37d3d42df1$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $563f1f37d3d42df1$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $563f1f37d3d42df1$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $563f1f37d3d42df1$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $563f1f37d3d42df1$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $563f1f37d3d42df1$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $563f1f37d3d42df1$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $563f1f37d3d42df1$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $563f1f37d3d42df1$export$c9d15bcfc6d42044(this, $563f1f37d3d42df1$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $563f1f37d3d42df1$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $563f1f37d3d42df1$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $563f1f37d3d42df1$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $j1vZB.default).from(spec.nodes), instanceSpec.marks = (0, $j1vZB.default).from(spec.marks || {}), this.nodes = $563f1f37d3d42df1$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $563f1f37d3d42df1$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $563f1f37d3d42df1$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $563f1f37d3d42df1$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $563f1f37d3d42df1$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $563f1f37d3d42df1$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $563f1f37d3d42df1$var$TextNode(type, type.defaultAttrs, text, $563f1f37d3d42df1$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $563f1f37d3d42df1$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $563f1f37d3d42df1$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $563f1f37d3d42df1$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $563f1f37d3d42df1$var$isTagRule(rule) {
    return rule.tag != null;
}
function $563f1f37d3d42df1$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $563f1f37d3d42df1$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($563f1f37d3d42df1$var$isTagRule(rule)) this.tags.push(rule);
            else if ($563f1f37d3d42df1$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $563f1f37d3d42df1$var$ParseContext(this, options, false);
        context.addAll(dom, $563f1f37d3d42df1$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $563f1f37d3d42df1$var$ParseContext(this, options, true);
        context.addAll(dom, $563f1f37d3d42df1$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $563f1f37d3d42df1$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($563f1f37d3d42df1$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $563f1f37d3d42df1$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $563f1f37d3d42df1$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $563f1f37d3d42df1$export$1059c6e7d2ce5669(schema, $563f1f37d3d42df1$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $563f1f37d3d42df1$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $563f1f37d3d42df1$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $563f1f37d3d42df1$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $563f1f37d3d42df1$var$OPT_PRESERVE_WS = 1, $563f1f37d3d42df1$var$OPT_PRESERVE_WS_FULL = 2, $563f1f37d3d42df1$var$OPT_OPEN_LEFT = 4;
function $563f1f37d3d42df1$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $563f1f37d3d42df1$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $563f1f37d3d42df1$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $563f1f37d3d42df1$var$OPT_PRESERVE_WS | $563f1f37d3d42df1$var$OPT_PRESERVE_WS_FULL : base & ~$563f1f37d3d42df1$var$OPT_OPEN_LEFT;
}
class $563f1f37d3d42df1$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $563f1f37d3d42df1$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($563f1f37d3d42df1$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $563f1f37d3d42df1$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $563f1f37d3d42df1$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($563f1f37d3d42df1$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$563f1f37d3d42df1$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $563f1f37d3d42df1$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $563f1f37d3d42df1$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $563f1f37d3d42df1$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $563f1f37d3d42df1$var$NodeContext(topNode.type, topNode.attrs, $563f1f37d3d42df1$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $563f1f37d3d42df1$var$NodeContext(null, null, $563f1f37d3d42df1$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $563f1f37d3d42df1$var$NodeContext(parser.schema.topNodeType, null, $563f1f37d3d42df1$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $563f1f37d3d42df1$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $563f1f37d3d42df1$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($563f1f37d3d42df1$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $563f1f37d3d42df1$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $563f1f37d3d42df1$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($563f1f37d3d42df1$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $563f1f37d3d42df1$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $563f1f37d3d42df1$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $563f1f37d3d42df1$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $563f1f37d3d42df1$var$OPT_OPEN_LEFT;
        let applyMarks = $563f1f37d3d42df1$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $563f1f37d3d42df1$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $563f1f37d3d42df1$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $563f1f37d3d42df1$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $563f1f37d3d42df1$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $563f1f37d3d42df1$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $563f1f37d3d42df1$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $563f1f37d3d42df1$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $563f1f37d3d42df1$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $563f1f37d3d42df1$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $563f1f37d3d42df1$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $563f1f37d3d42df1$var$renderSpec($563f1f37d3d42df1$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $563f1f37d3d42df1$var$renderSpec($563f1f37d3d42df1$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $563f1f37d3d42df1$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $563f1f37d3d42df1$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $563f1f37d3d42df1$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $563f1f37d3d42df1$var$gatherToDOM(schema.marks);
    }
}
function $563f1f37d3d42df1$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $563f1f37d3d42df1$var$doc(options) {
    return options.document || window.document;
}
const $563f1f37d3d42df1$var$suspiciousAttributeCache = new WeakMap();
function $563f1f37d3d42df1$var$suspiciousAttributes(attrs) {
    let value = $563f1f37d3d42df1$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $563f1f37d3d42df1$var$suspiciousAttributeCache.set(attrs, value = $563f1f37d3d42df1$var$suspiciousAttributesInner(attrs));
    return value;
}
function $563f1f37d3d42df1$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $563f1f37d3d42df1$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $563f1f37d3d42df1$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $563f1f37d3d42df1$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("j1vZB", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd96ed64a8abdf92$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $dd96ed64a8abdf92$var$OrderedMap(content) {
    this.content = content;
}
$dd96ed64a8abdf92$var$OrderedMap.prototype = {
    constructor: $dd96ed64a8abdf92$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $dd96ed64a8abdf92$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $dd96ed64a8abdf92$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $dd96ed64a8abdf92$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $dd96ed64a8abdf92$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $dd96ed64a8abdf92$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $dd96ed64a8abdf92$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $dd96ed64a8abdf92$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $dd96ed64a8abdf92$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $dd96ed64a8abdf92$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $dd96ed64a8abdf92$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$dd96ed64a8abdf92$var$OrderedMap.from = function(value) {
    if (value instanceof $dd96ed64a8abdf92$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $dd96ed64a8abdf92$var$OrderedMap(content);
};
var $dd96ed64a8abdf92$export$2e2bcd8739ae039 = $dd96ed64a8abdf92$var$OrderedMap;

});


parcelRegister("bar7S", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", () => $8f6650cbd670d434$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $8f6650cbd670d434$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $8f6650cbd670d434$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $8f6650cbd670d434$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $8f6650cbd670d434$export$4498a6080fed604c = 'fontStyle';
const $8f6650cbd670d434$export$f8e8a5f34f6ea725 = 'searchQuery';
const $8f6650cbd670d434$export$b395009ca7f092c7 = 'link';
const $8f6650cbd670d434$export$9b982809044276a6 = 'color';
const $8f6650cbd670d434$export$470d0905851e47a1 = 'alignment';
const $8f6650cbd670d434$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("dshZO", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", () => $80a8152a5e88dfda$export$daf54fed04c8fb77);
function $80a8152a5e88dfda$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $80a8152a5e88dfda$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $80a8152a5e88dfda$var$sanitizeNodeSpecContent(nodes, rawContent) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = Array.from(new Set(contentKeys.filter((contentKey)=>!$80a8152a5e88dfda$var$isContentSupported(nodes, contentKey)))).sort((a, b)=>b.length - a.length);
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$80a8152a5e88dfda$var$sanitizedContent(newContent, nodeName), rawContent);
}
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $80a8152a5e88dfda$var$WORD_CHAR_REGEX = /\w/u;
function $80a8152a5e88dfda$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match($80a8152a5e88dfda$var$WORD_CHAR_REGEX)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    // Ignored via go/ees019
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $80a8152a5e88dfda$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("420HY", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", () => $28b14eed76766451$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $28b14eed76766451$export$8e53000a4ec837);

var $WniZw = parcelRequire("WniZw");
const $28b14eed76766451$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $28b14eed76766451$export$8e53000a4ec837 = (0, $WniZw.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("WniZw", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $69b93331d38b40e8$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $69b93331d38b40e8$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $69b93331d38b40e8$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $69b93331d38b40e8$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $69b93331d38b40e8$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $69b93331d38b40e8$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $69b93331d38b40e8$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $69b93331d38b40e8$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $69b93331d38b40e8$export$c63c6f932822f543);
$parcel$export(module.exports, "fontSize", () => $69b93331d38b40e8$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $69b93331d38b40e8$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $69b93331d38b40e8$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $69b93331d38b40e8$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $69b93331d38b40e8$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $69b93331d38b40e8$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $69b93331d38b40e8$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $69b93331d38b40e8$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $69b93331d38b40e8$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $69b93331d38b40e8$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $69b93331d38b40e8$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $69b93331d38b40e8$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $bNAQ5 = parcelRequire("bNAQ5");
const $69b93331d38b40e8$export$8e53000a4ec837 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $69b93331d38b40e8$export$8512c9afa7b24c3b = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $69b93331d38b40e8$export$8c5a050822fd698c = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $69b93331d38b40e8$export$1edee58a52776cd9 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $69b93331d38b40e8$export$89015c65f1c75e3f = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $69b93331d38b40e8$export$6565f9f03506010b = (0, $bNAQ5.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $69b93331d38b40e8$export$f3b72f8fc4684ecd = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $69b93331d38b40e8$export$3024f02c495408d6 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $69b93331d38b40e8$export$c63c6f932822f543 = (0, $bNAQ5.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $69b93331d38b40e8$export$85e3c3ca0c6fb93 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    }
});
const $69b93331d38b40e8$export$f00aeb236b6f05af = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $69b93331d38b40e8$export$480c699bd4ec0d86 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $69b93331d38b40e8$export$9c30223ca0a664fb = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $69b93331d38b40e8$export$4899a95d70ec5056 = (0, $bNAQ5.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $69b93331d38b40e8$export$59ae2c325a998f89 = (0, $bNAQ5.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $69b93331d38b40e8$export$b3401ee80eb31041 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $69b93331d38b40e8$export$32f78bffcd82ff28 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $69b93331d38b40e8$export$20af3dabbb5538df = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $69b93331d38b40e8$export$425327af25286e5e = (0, $bNAQ5.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $69b93331d38b40e8$export$30d78d5eb6719bb8 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $69b93331d38b40e8$export$a316dc07ff5182a2 = (0, $bNAQ5.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("6ctpG", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", () => $8eddb6535bfdfaff$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $8eddb6535bfdfaff$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $8eddb6535bfdfaff$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $8eddb6535bfdfaff$export$8512c9afa7b24c3b);

var $WniZw = parcelRequire("WniZw");
var $8eddb6535bfdfaff$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $8eddb6535bfdfaff$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $8eddb6535bfdfaff$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $8eddb6535bfdfaff$export$8512c9afa7b24c3b = (0, $WniZw.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$8eddb6535bfdfaff$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("6GNGR", function(module, exports) {
$parcel$export(module.exports, "backgroundColorPalette", () => $e1e94af980eed910$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColorPaletteNew", () => $e1e94af980eed910$export$5e11ef3de07e2b1);
$parcel$export(module.exports, "backgroundColor", () => $e1e94af980eed910$export$8c5a050822fd698c);

var $WniZw = parcelRequire("WniZw");

var $356mi = parcelRequire("356mi");

var $8hmyV = parcelRequire("8hmyV");

var $9DIXD = parcelRequire("9DIXD");

var $2M4vR = parcelRequire("2M4vR");
const $e1e94af980eed910$var$colorArrayPalette = [
    [
        (0, $356mi.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $356mi.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $356mi.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $356mi.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $356mi.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $356mi.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $356mi.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $e1e94af980eed910$var$colorArrayPaletteNew = [
    [
        (0, $356mi.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $356mi.B75),
        'Blue'
    ],
    // token: color.background.accent.blue.subtler
    [
        (0, $356mi.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $356mi.G75),
        'Green'
    ],
    // token: color.background.accent.green.subtler
    [
        (0, $356mi.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $356mi.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $356mi.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $356mi.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $356mi.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $e1e94af980eed910$export$14ec3f21a268e497 = new Map();
$e1e94af980eed910$var$colorArrayPalette.forEach(([color, label])=>$e1e94af980eed910$export$14ec3f21a268e497.set(color.toLowerCase(), label));
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $e1e94af980eed910$var$RGB_PREFIX_BG_COLOR_REGEX = /^rgb/iu;
const $e1e94af980eed910$export$5e11ef3de07e2b1 = new Map();
$e1e94af980eed910$var$colorArrayPaletteNew.forEach(([color, label])=>$e1e94af980eed910$export$5e11ef3de07e2b1.set(color.toLowerCase(), label));
const $e1e94af980eed910$export$8c5a050822fd698c = (0, $WniZw.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($e1e94af980eed910$var$RGB_PREFIX_BG_COLOR_REGEX)) hexColor = (0, $356mi.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $e1e94af980eed910$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $e1e94af980eed910$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $8hmyV.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $2M4vR.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $9DIXD.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("2M4vR", function(module, exports) {
$parcel$export(module.exports, "colorPalette", () => $187485a0a49b7008$export$569885e57444f84a);
$parcel$export(module.exports, "colorPaletteNew", () => $187485a0a49b7008$export$dee1d8a8cb3ab555);
$parcel$export(module.exports, "getGlobalTheme", () => $187485a0a49b7008$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $187485a0a49b7008$export$32f78bffcd82ff28);

var $WniZw = parcelRequire("WniZw");

var $8hmyV = parcelRequire("8hmyV");

var $356mi = parcelRequire("356mi");

var $9DIXD = parcelRequire("9DIXD");
// used for extended palette in text color picker
const $187485a0a49b7008$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $356mi.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $356mi.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $356mi.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $356mi.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $356mi.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $356mi.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $356mi.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $356mi.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $356mi.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $356mi.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $356mi.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $356mi.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $356mi.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $356mi.N0),
        'White'
    ],
    [
        (0, $356mi.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $356mi.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $356mi.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $356mi.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $356mi.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $356mi.P50),
        'Light purple'
    ] // Lavender secret
];
// experiment: platform_editor_lovability_text_bg_color
const $187485a0a49b7008$var$colorArrayPaletteNew = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $356mi.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $356mi.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $356mi.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $356mi.L800),
        'Dark lime'
    ],
    [
        (0, $356mi.Y800),
        'Dark yellow'
    ],
    [
        (0, $356mi.O800),
        'Dark orange'
    ],
    [
        (0, $356mi.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $356mi.M800),
        'Dark magenta'
    ],
    [
        (0, $356mi.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $356mi.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $356mi.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $356mi.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $356mi.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $356mi.L600),
        'Lime'
    ],
    [
        (0, $356mi.Y600),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $356mi.O600),
        'Orange'
    ],
    [
        (0, $356mi.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $356mi.M600),
        'Magenta'
    ],
    [
        (0, $356mi.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $356mi.N0),
        'White'
    ],
    [
        (0, $356mi.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $356mi.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $356mi.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $356mi.L200),
        'Light lime'
    ],
    [
        (0, $356mi.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $356mi.Orange200),
        'Light orange'
    ],
    [
        (0, $356mi.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $356mi.M200),
        'Light magenta'
    ],
    [
        (0, $356mi.P50),
        'Light purple'
    ] // Lavender secret
];
const $187485a0a49b7008$export$569885e57444f84a = new Map();
const $187485a0a49b7008$export$dee1d8a8cb3ab555 = new Map();
const $187485a0a49b7008$export$81e5ed9e84fe2e28 = $187485a0a49b7008$export$569885e57444f84a;
$187485a0a49b7008$var$colorArrayPalette.forEach(([color, label])=>$187485a0a49b7008$export$569885e57444f84a.set(color.toLowerCase(), label));
$187485a0a49b7008$var$colorArrayPaletteNew.forEach(([color, label])=>$187485a0a49b7008$export$dee1d8a8cb3ab555.set(color.toLowerCase(), label));
// these are for test only
let $187485a0a49b7008$var$testGlobalTheme;
const $187485a0a49b7008$export$fd7e0dd2b74807f7 = (theme)=>{
    $187485a0a49b7008$var$testGlobalTheme = theme;
};
const $187485a0a49b7008$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($187485a0a49b7008$var$testGlobalTheme) return {
        colorMode: $187485a0a49b7008$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $187485a0a49b7008$var$RGB_PREFIX_TEXT_COLOR_REGEX = /^rgb/iu;
const $187485a0a49b7008$export$32f78bffcd82ff28 = (0, $WniZw.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match($187485a0a49b7008$var$RGB_PREFIX_TEXT_COLOR_REGEX)) hexColor = (0, $356mi.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $187485a0a49b7008$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $187485a0a49b7008$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $8hmyV.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($187485a0a49b7008$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $9DIXD.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});


parcelRegister("9r6IO", function(module, exports) {
$parcel$export(module.exports, "borderColorPalette", () => $e004971717e02e3c$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $e004971717e02e3c$export$1edee58a52776cd9);

var $WniZw = parcelRequire("WniZw");

var $8hmyV = parcelRequire("8hmyV");

var $356mi = parcelRequire("356mi");
const $e004971717e02e3c$var$borderColorArrayPalette = [
    [
        (0, $356mi.N300A),
        'Subtle gray'
    ],
    [
        (0, $356mi.N600),
        'Gray'
    ],
    [
        (0, $356mi.N1000),
        'Bold gray'
    ]
];
const $e004971717e02e3c$export$e4e044c989c86ca7 = new Map();
$e004971717e02e3c$var$borderColorArrayPalette.forEach(([color, label])=>$e004971717e02e3c$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $e004971717e02e3c$export$1edee58a52776cd9 = (0, $WniZw.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $e004971717e02e3c$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $8hmyV.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("4sanW", function(module, exports) {
$parcel$export(module.exports, "breakout", () => $c304783790b4fcd1$export$89015c65f1c75e3f);

var $WniZw = parcelRequire("WniZw");
const $c304783790b4fcd1$var$allowedTypes = [
    'wide',
    'full-width'
];
const $c304783790b4fcd1$export$89015c65f1c75e3f = (0, $WniZw.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $c304783790b4fcd1$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("iaS5j", function(module, exports) {
$parcel$export(module.exports, "code", () => $4829fe12f7d09a33$export$6565f9f03506010b);

var $WniZw = parcelRequire("WniZw");
const $4829fe12f7d09a33$export$6565f9f03506010b = (0, $WniZw.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("6fsbB", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", () => $97595cc673e643cd$export$f3b72f8fc4684ecd);

var $WniZw = parcelRequire("WniZw");
const $97595cc673e643cd$export$f3b72f8fc4684ecd = (0, $WniZw.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("4u3vK", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", () => $b8dfebe0ef11bf2e$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $b8dfebe0ef11bf2e$export$54fd2c36b5cc6731);

var $WniZw = parcelRequire("WniZw");

var $k7OVS = parcelRequire("k7OVS");
const $b8dfebe0ef11bf2e$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $k7OVS.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $b8dfebe0ef11bf2e$export$3024f02c495408d6 = (0, $WniZw.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$b8dfebe0ef11bf2e$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $b8dfebe0ef11bf2e$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("k7OVS", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", () => $aacecb62a885274c$export$c296e2d4365c37a5);
const $aacecb62a885274c$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("4MDQR", function(module, exports) {
$parcel$export(module.exports, "em", () => $4902159af81d6504$export$c63c6f932822f543);

var $WniZw = parcelRequire("WniZw");
const $4902159af81d6504$var$emDOM = [
    'em'
];
const $4902159af81d6504$export$c63c6f932822f543 = (0, $WniZw.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $4902159af81d6504$var$emDOM;
    }
});

});

parcelRegister("ePkTL", function(module, exports) {
$parcel$export(module.exports, "fontSize", () => $6b9ae71e4c8f0418$export$85e3c3ca0c6fb93);

var $WniZw = parcelRequire("WniZw");
const $6b9ae71e4c8f0418$var$allowedSizes = [
    'small'
];
const $6b9ae71e4c8f0418$export$85e3c3ca0c6fb93 = (0, $WniZw.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $6b9ae71e4c8f0418$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});

});

parcelRegister("d04vw", function(module, exports) {
$parcel$export(module.exports, "fragment", () => $9aff038db013ecb0$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $9aff038db013ecb0$export$54fd2c36b5cc6731);

var $WniZw = parcelRequire("WniZw");

var $k7OVS = parcelRequire("k7OVS");
const $9aff038db013ecb0$var$parseFragment = (maybeValue)=>{
    if (!(0, $k7OVS.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $9aff038db013ecb0$export$f00aeb236b6f05af = (0, $WniZw.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$9aff038db013ecb0$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $9aff038db013ecb0$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("9tBsB", function(module, exports) {
$parcel$export(module.exports, "indentation", () => $1aefa79171a34c9b$export$480c699bd4ec0d86);

var $WniZw = parcelRequire("WniZw");
const $1aefa79171a34c9b$export$480c699bd4ec0d86 = (0, $WniZw.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("dwqYv", function(module, exports) {
$parcel$export(module.exports, "link", () => $d3c29d786696ccf9$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $d3c29d786696ccf9$export$54fd2c36b5cc6731);

var $WniZw = parcelRequire("WniZw");

var $kZuij = parcelRequire("kZuij");
const $d3c29d786696ccf9$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $kZuij.isSafeUrl)(href)) return false;
        if ((0, $kZuij.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $kZuij.normalizeUrl)(href);
        return attrs;
    };
const $d3c29d786696ccf9$export$9c30223ca0a664fb = (0, $WniZw.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $d3c29d786696ccf9$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $d3c29d786696ccf9$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $kZuij.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $d3c29d786696ccf9$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $d3c29d786696ccf9$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($d3c29d786696ccf9$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("kZuij", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $267edb1b82cd6e7e$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $267edb1b82cd6e7e$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $267edb1b82cd6e7e$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $267edb1b82cd6e7e$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $267edb1b82cd6e7e$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $267edb1b82cd6e7e$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $jVatr = parcelRequire("jVatr");
const $267edb1b82cd6e7e$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $267edb1b82cd6e7e$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url === null || url === void 0 ? void 0 : url.trim();
    if (urlTrimmed === undefined) return true;
    if (urlTrimmed.length === 0) return true;
    return $267edb1b82cd6e7e$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $267edb1b82cd6e7e$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($jVatr)))();
$267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $267edb1b82cd6e7e$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/u
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.add('tel:', $267edb1b82cd6e7e$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.add('file:', $267edb1b82cd6e7e$var$urlWithoutSpacesValidator);
$267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $267edb1b82cd6e7e$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $267edb1b82cd6e7e$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$267edb1b82cd6e7e$var$tlds.push($267edb1b82cd6e7e$var$tlds2Char);
$267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.tlds($267edb1b82cd6e7e$var$tlds, false);
const $267edb1b82cd6e7e$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
const $267edb1b82cd6e7e$export$6f7d7761b97f967 = (text)=>{
    if (!$267edb1b82cd6e7e$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match($267edb1b82cd6e7e$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($267edb1b82cd6e7e$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $267edb1b82cd6e7e$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $267edb1b82cd6e7e$export$6f7d7761b97f967(str);
    if (!match.length) match = $267edb1b82cd6e7e$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $267edb1b82cd6e7e$export$6535eb414fa2c8b6(url) {
    const match = $267edb1b82cd6e7e$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $267edb1b82cd6e7e$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("jVatr", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $e80b7717d371b7ad$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $e80b7717d371b7ad$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $e80b7717d371b7ad$var$isString(obj) {
    return $e80b7717d371b7ad$var$_class(obj) === '[object String]';
}
function $e80b7717d371b7ad$var$isObject(obj) {
    return $e80b7717d371b7ad$var$_class(obj) === '[object Object]';
}
function $e80b7717d371b7ad$var$isRegExp(obj) {
    return $e80b7717d371b7ad$var$_class(obj) === '[object RegExp]';
}
function $e80b7717d371b7ad$var$isFunction(obj) {
    return $e80b7717d371b7ad$var$_class(obj) === '[object Function]';
}
function $e80b7717d371b7ad$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $e80b7717d371b7ad$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $e80b7717d371b7ad$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $e80b7717d371b7ad$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $e80b7717d371b7ad$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $e80b7717d371b7ad$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $e80b7717d371b7ad$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $e80b7717d371b7ad$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $e80b7717d371b7ad$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $e80b7717d371b7ad$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $e80b7717d371b7ad$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("hI8Ae"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($e80b7717d371b7ad$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($e80b7717d371b7ad$var$isObject(val)) {
            if ($e80b7717d371b7ad$var$isRegExp(val.validate)) compiled.validate = $e80b7717d371b7ad$var$createValidator(val.validate);
            else if ($e80b7717d371b7ad$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($e80b7717d371b7ad$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $e80b7717d371b7ad$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($e80b7717d371b7ad$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $e80b7717d371b7ad$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($e80b7717d371b7ad$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $e80b7717d371b7ad$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $e80b7717d371b7ad$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $e80b7717d371b7ad$var$createMatch(self, shift) {
    var match = new $e80b7717d371b7ad$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $e80b7717d371b7ad$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $e80b7717d371b7ad$var$LinkifyIt)) return new $e80b7717d371b7ad$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($e80b7717d371b7ad$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $e80b7717d371b7ad$var$assign({}, $e80b7717d371b7ad$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $e80b7717d371b7ad$var$assign({}, $e80b7717d371b7ad$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $e80b7717d371b7ad$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $e80b7717d371b7ad$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $e80b7717d371b7ad$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $e80b7717d371b7ad$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($e80b7717d371b7ad$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($e80b7717d371b7ad$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $e80b7717d371b7ad$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $e80b7717d371b7ad$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $e80b7717d371b7ad$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $e80b7717d371b7ad$var$LinkifyIt;

});
parcelRegister("hI8Ae", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("d8vDr")).source;
    re.src_Cc = (parcelRequire("dTprp")).source;
    re.src_Z = (parcelRequire("bQFV9")).source;
    re.src_P = (parcelRequire("hc4yV")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("d8vDr", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("dTprp", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("bQFV9", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("hc4yV", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("ao8yJ", function(module, exports) {
$parcel$export(module.exports, "strike", () => $37749a8882c3be19$export$4899a95d70ec5056);

var $WniZw = parcelRequire("WniZw");
const $37749a8882c3be19$export$4899a95d70ec5056 = (0, $WniZw.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("ebKEa", function(module, exports) {
$parcel$export(module.exports, "strong", () => $1a89960e67965681$export$59ae2c325a998f89);

var $WniZw = parcelRequire("WniZw");
const $1a89960e67965681$var$strongDOM = [
    'strong'
];
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $1a89960e67965681$var$BOLD_FONT_WEIGHT_REGEX = /^(bold(er)?|[5-9]\d{2,})$/u;
const $1a89960e67965681$export$59ae2c325a998f89 = (0, $WniZw.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || $1a89960e67965681$var$BOLD_FONT_WEIGHT_REGEX.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $1a89960e67965681$var$strongDOM;
    }
});

});

parcelRegister("aTvYw", function(module, exports) {
$parcel$export(module.exports, "subsup", () => $ffe9567196f7e030$export$b3401ee80eb31041);

var $WniZw = parcelRequire("WniZw");
function $ffe9567196f7e030$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $ffe9567196f7e030$export$b3401ee80eb31041 = (0, $WniZw.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$ffe9567196f7e030$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$ffe9567196f7e030$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("8aNkC", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", () => $59ba02e33488895b$export$20af3dabbb5538df);

var $WniZw = parcelRequire("WniZw");

var $356mi = parcelRequire("356mi");
const $59ba02e33488895b$export$20af3dabbb5538df = (0, $WniZw.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $356mi.B400)}`
            }
        ];
    }
});

});

parcelRegister("9dUmA", function(module, exports) {
$parcel$export(module.exports, "underline", () => $f91ead1ba4de93f5$export$425327af25286e5e);

var $WniZw = parcelRequire("WniZw");
const $f91ead1ba4de93f5$export$425327af25286e5e = (0, $WniZw.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jWiTr", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", () => $42453654590bf966$export$30d78d5eb6719bb8);

var $WniZw = parcelRequire("WniZw");
const $42453654590bf966$export$30d78d5eb6719bb8 = (0, $WniZw.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("grhaY", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $bb36ff9d9449bb84$export$a316dc07ff5182a2);

var $WniZw = parcelRequire("WniZw");
const $bb36ff9d9449bb84$export$a316dc07ff5182a2 = (0, $WniZw.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("6YskE", function(module, exports) {
$parcel$export(module.exports, "blockCard", () => $7091ef8c098ff49b$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockCardWithLocalId", () => $7091ef8c098ff49b$export$9894f24949f094e5);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $7091ef8c098ff49b$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $7091ef8c098ff49b$export$c4c2f833baaebdb8 = (0, $32AI7.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$7091ef8c098ff49b$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$7091ef8c098ff49b$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
const $7091ef8c098ff49b$export$9894f24949f094e5 = (0, $32AI7.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$7091ef8c098ff49b$var$getCommonAttributesFromDom(dom),
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$7091ef8c098ff49b$var$getCommonAttributesFromDom(dom),
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2, _node$attrs3;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("43GOy", function(module, exports) {
$parcel$export(module.exports, "taskItem", () => $6008f910a20558b2$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "blockTaskItem", () => $6008f910a20558b2$export$16018c61064a18df);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
const $6008f910a20558b2$export$6d8b0ef52e2e6390 = (0, $32AI7.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $h8ouc.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $6008f910a20558b2$export$16018c61064a18df = (0, $32AI7.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $h8ouc.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("a99AW", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", () => $bb5eadc73ab31e67$export$27903d543b563e39);

var $fgugZ = parcelRequire("fgugZ");

var $32AI7 = parcelRequire("32AI7");
const $bb5eadc73ab31e67$export$27903d543b563e39 = (0, $32AI7.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fgugZ.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5s4YT", function(module, exports) {
$parcel$export(module.exports, "bodiedSyncBlock", () => $3b3cc53ec2135059$export$e92c7e4302dd4371);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $3b3cc53ec2135059$export$e92c7e4302dd4371 = (0, $32AI7.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $h8ouc.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});

});

parcelRegister("8EdAG", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", () => $1f93d7a741c2f519$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $1f93d7a741c2f519$export$a140c94e5ea26bee);
$parcel$export(module.exports, "bulletListWithLocalId", () => $1f93d7a741c2f519$export$dfd406053b2bab40);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
const $1f93d7a741c2f519$export$5f25a39efab3b58b = '.ak-ul';
const $1f93d7a741c2f519$export$a140c94e5ea26bee = (0, $32AI7.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $1f93d7a741c2f519$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $1f93d7a741c2f519$export$dfd406053b2bab40 = (0, $32AI7.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $1f93d7a741c2f519$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9DaXy", function(module, exports) {
$parcel$export(module.exports, "caption", () => $c592ea625ca0e785$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "captionWithLocalId", () => $c592ea625ca0e785$export$b5d01ee303c467aa);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $c592ea625ca0e785$export$8e3c2dfdc4f0453d = (0, $32AI7.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $c592ea625ca0e785$export$b5d01ee303c467aa = (0, $32AI7.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-caption': 'true'
        };
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1rzDq", function(module, exports) {
$parcel$export(module.exports, "codeBlock", () => $69d73a49ee43b610$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $69d73a49ee43b610$export$54fd2c36b5cc6731);
$parcel$export(module.exports, "codeBlockWithLocalId", () => $69d73a49ee43b610$export$3f75de798a0b5356);

var $7p5u4 = parcelRequire("7p5u4");

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $69d73a49ee43b610$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $69d73a49ee43b610$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $69d73a49ee43b610$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $69d73a49ee43b610$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $69d73a49ee43b610$var$LANGUAGE_CLASS_REGEX = /(?:^|\s)language-([^\s]+)/u;
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $69d73a49ee43b610$var$TRAILING_NEWLINE_REGEX = /\n$/u;
const $69d73a49ee43b610$var$extractLanguageFromClass = (className)=>{
    const result = $69d73a49ee43b610$var$LANGUAGE_CLASS_REGEX.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $69d73a49ee43b610$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace($69d73a49ee43b610$var$TRAILING_NEWLINE_REGEX, '');
    return dom;
};
function $69d73a49ee43b610$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $69d73a49ee43b610$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $69d73a49ee43b610$export$7bb0d5c671655cc4 = (0, $32AI7.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $69d73a49ee43b610$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $69d73a49ee43b610$var$getLanguageFromEditorStyle(dom.parentElement) || $69d73a49ee43b610$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $69d73a49ee43b610$var$removeLastNewLine(dom);
                const wrapAttr = dom.getAttribute('data-wrap');
                const isCopiedFromEditor = Boolean(dom.closest('[data-pm-slice]') || dom.hasAttribute('data-pm-slice'));
                // Default external HTML paste to wrapped when data-wrap is absent, but preserve
                // unwrapped editor-origin paste when copied content has data-pm-slice.
                const wrap = wrapAttr === null ? !isCopiedFromEditor : wrapAttr !== 'false';
                const hideLineNumbers = dom.getAttribute('data-hide-line-numbers') === 'true';
                return {
                    language: language,
                    wrap: wrap,
                    hideLineNumbers: hideLineNumbers,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {
                    wrap: true
                };
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $69d73a49ee43b610$var$parseCodeFromHtml(domNode);
                return code ? (0, $7p5u4.Fragment).from(schema.text(code)) : (0, $7p5u4.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {
                    wrap: true
                };
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {
                    wrap: true
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        // Always serialize data-wrap explicitly (both true and false) so that
        // editor-to-editor paste can distinguish intentional wrap:false from
        // absent data-wrap (which parseDOM defaults to wrap:true for external HTML).
        attrs['data-wrap'] = node.attrs.wrap ? 'true' : 'false';
        if (node.attrs.hideLineNumbers) attrs['data-hide-line-numbers'] = 'true';
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $69d73a49ee43b610$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            if (key === 'wrap' && node.attrs.wrap === null) return memo;
            if (key === 'hideLineNumbers' && !node.attrs.hideLineNumbers) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $69d73a49ee43b610$export$3f75de798a0b5356 = (0, $32AI7.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $69d73a49ee43b610$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $69d73a49ee43b610$var$getLanguageFromEditorStyle(dom.parentElement) || $69d73a49ee43b610$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $69d73a49ee43b610$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $69d73a49ee43b610$var$parseCodeFromHtml(domNode);
                return code ? (0, $7p5u4.Fragment).from(schema.text(code)) : (0, $7p5u4.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const attrs = {};
        if ((node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("gFlMH", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", () => $ffc97aa25a56b264$export$daf889beb5092f95);

var $32AI7 = parcelRequire("32AI7");
const $ffc97aa25a56b264$var$name = 'confluenceJiraIssue';
const $ffc97aa25a56b264$export$daf889beb5092f95 = (0, $32AI7.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$ffc97aa25a56b264$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $ffc97aa25a56b264$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("bUXVW", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $d040c232beda349a$export$e6e4878f43c27cab);

var $32AI7 = parcelRequire("32AI7");
const $d040c232beda349a$var$name = 'confluenceUnsupportedBlock';
const $d040c232beda349a$export$e6e4878f43c27cab = (0, $32AI7.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $d040c232beda349a$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$d040c232beda349a$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("2fO2k", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $bca9289b6bfd61a5$export$3e6d667072febc87);

var $32AI7 = parcelRequire("32AI7");
const $bca9289b6bfd61a5$var$name = 'confluenceUnsupportedInline';
const $bca9289b6bfd61a5$export$3e6d667072febc87 = (0, $32AI7.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $bca9289b6bfd61a5$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$bca9289b6bfd61a5$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("gVA9a", function(module, exports) {
$parcel$export(module.exports, "date", () => $c2f23a1f22081280$export$324d90190a8b822a);
$parcel$export(module.exports, "dateWithLocalId", () => $c2f23a1f22081280$export$a6a035390e3921b2);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $c2f23a1f22081280$export$324d90190a8b822a = (0, $32AI7.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $c2f23a1f22081280$export$a6a035390e3921b2 = (0, $32AI7.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("1WTWd", function(module, exports) {
$parcel$export(module.exports, "decisionItem", () => $6aa719000f119756$export$6959e16eeff859b4);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
const $6aa719000f119756$export$6959e16eeff859b4 = (0, $32AI7.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $h8ouc.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1Kym8", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", () => $d17a49ce4544f5ac$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $d17a49ce4544f5ac$export$62d45a65fb43d95e);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
const $d17a49ce4544f5ac$var$name = 'decisionList';
const $d17a49ce4544f5ac$export$a5393ce68c2ff601 = `[data-node-type="${$d17a49ce4544f5ac$var$name}"]`;
const $d17a49ce4544f5ac$export$62d45a65fb43d95e = (0, $32AI7.decisionList)({
    parseDOM: [
        {
            tag: `ol${$d17a49ce4544f5ac$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $d17a49ce4544f5ac$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8FRQe", function(module, exports) {
$parcel$export(module.exports, "doc", () => $edb4eb1ffe63104d$export$2a111da947c407d2);

var $32AI7 = parcelRequire("32AI7");
const $edb4eb1ffe63104d$export$2a111da947c407d2 = (0, $32AI7.doc)({});

});

parcelRegister("beODP", function(module, exports) {
$parcel$export(module.exports, "embedCard", () => $e7ad477453a0b6e5$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "embedCardWithLocalId", () => $e7ad477453a0b6e5$export$36734475a7f6fd3e);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $e7ad477453a0b6e5$export$be4283d9a1cb1ff6 = (0, $32AI7.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $e7ad477453a0b6e5$export$36734475a7f6fd3e = (0, $32AI7.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("5fTUY", function(module, exports) {
$parcel$export(module.exports, "emoji", () => $a98347372929371b$export$a19185d1233fc4b2);
$parcel$export(module.exports, "emojiWithLocalId", () => $a98347372929371b$export$ebb3b3c7a0ac9936);

var $fhbzd = parcelRequire("fhbzd");

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $a98347372929371b$export$a19185d1233fc4b2 = (0, $32AI7.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $a98347372929371b$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $a98347372929371b$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $a98347372929371b$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $fhbzd.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $fhbzd.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $a98347372929371b$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $a98347372929371b$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $a98347372929371b$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $a98347372929371b$export$ebb3b3c7a0ac9936 = (0, $32AI7.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $a98347372929371b$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $a98347372929371b$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $a98347372929371b$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $fhbzd.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $fhbzd.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $a98347372929371b$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $a98347372929371b$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $a98347372929371b$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("fhbzd", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", () => $d8d93bfee76be487$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $d8d93bfee76be487$export$441f8b58f5790a68);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $d8d93bfee76be487$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $d8d93bfee76be487$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $d8d93bfee76be487$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $d8d93bfee76be487$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $d8d93bfee76be487$export$f61e93bda2a8b420(acName) {
    const emojiData = $d8d93bfee76be487$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $d8d93bfee76be487$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $d8d93bfee76be487$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$d8d93bfee76be487$var$acNameToEmojiMap[acName] ? $d8d93bfee76be487$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($d8d93bfee76be487$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $d8d93bfee76be487$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$d8d93bfee76be487$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $d8d93bfee76be487$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $d8d93bfee76be487$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($d8d93bfee76be487$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $d8d93bfee76be487$var$getAcNameFromShortName(shortName);
        if (possibleName in $d8d93bfee76be487$var$acNameToEmojiMap) return possibleName;
    }
    return $d8d93bfee76be487$export$bc94e44ec0e7bd82(id) || $d8d93bfee76be487$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("cFm3k", function(module, exports) {
$parcel$export(module.exports, "blockquote", () => $320dda4c9268eb6b$export$67dc04e652a298ca);
$parcel$export(module.exports, "extendedBlockquote", () => $320dda4c9268eb6b$export$70a64939da3e8455);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => $320dda4c9268eb6b$export$950ebf43f3364a0f);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $320dda4c9268eb6b$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $320dda4c9268eb6b$export$67dc04e652a298ca = (0, $32AI7.blockquoteLegacy)($320dda4c9268eb6b$var$nodeSpecOptions);
const $320dda4c9268eb6b$export$70a64939da3e8455 = (0, $32AI7.blockquote)($320dda4c9268eb6b$var$nodeSpecOptions);
const $320dda4c9268eb6b$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
const $320dda4c9268eb6b$export$950ebf43f3364a0f = (0, $32AI7.blockquote)($320dda4c9268eb6b$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("9Y1m8", function(module, exports) {
$parcel$export(module.exports, "PanelType", () => $42422af935bb4fe0$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $42422af935bb4fe0$export$ce20b13564211141);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => $42422af935bb4fe0$export$855c3c67c9c9ebaf);
$parcel$export(module.exports, "extendedPanelC1", () => $42422af935bb4fe0$export$c158ac2988d2f011);
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => $42422af935bb4fe0$export$9c65e35ecb68f683);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
var $42422af935bb4fe0$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $42422af935bb4fe0$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
const $42422af935bb4fe0$var$getParseDOMAttrs = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $h8ouc.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === "custom" ? "info" : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $42422af935bb4fe0$var$createPanelNodeSpecOptions = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$42422af935bb4fe0$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = $42422af935bb4fe0$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $42422af935bb4fe0$export$ce20b13564211141 = (allowCustomPanel)=>(0, $32AI7.panel)($42422af935bb4fe0$var$createPanelNodeSpecOptions(allowCustomPanel));
const $42422af935bb4fe0$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $32AI7.panel)($42422af935bb4fe0$var$createPanelNodeSpecOptions(allowCustomPanel, true));
const $42422af935bb4fe0$export$c158ac2988d2f011 = (allowCustomPanel)=>(0, $32AI7.panelC1)($42422af935bb4fe0$var$createPanelNodeSpecOptions(allowCustomPanel));
const $42422af935bb4fe0$export$9c65e35ecb68f683 = (allowCustomPanel)=>(0, $32AI7.panelC1)($42422af935bb4fe0$var$createPanelNodeSpecOptions(allowCustomPanel, true));

});

parcelRegister("4p5eD", function(module, exports) {
$parcel$export(module.exports, "extension", () => $6dda1314e3343541$export$1b45514b112dd749);

var $fgugZ = parcelRequire("fgugZ");

var $32AI7 = parcelRequire("32AI7");
const $6dda1314e3343541$export$1b45514b112dd749 = (0, $32AI7.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fgugZ.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("dvPmQ", function(module, exports) {
$parcel$export(module.exports, "hardBreak", () => $c0408e2edc2523d9$export$371da9dd35aba193);

var $32AI7 = parcelRequire("32AI7");
const $c0408e2edc2523d9$export$371da9dd35aba193 = (0, $32AI7.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("fzauD", function(module, exports) {
$parcel$export(module.exports, "heading", () => $2ff5dbc60d933c51$export$46e4a324ac90507f);

var $32AI7 = parcelRequire("32AI7");
const $2ff5dbc60d933c51$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $2ff5dbc60d933c51$export$46e4a324ac90507f = (0, $32AI7.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $2ff5dbc60d933c51$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $2ff5dbc60d933c51$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $2ff5dbc60d933c51$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $2ff5dbc60d933c51$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $2ff5dbc60d933c51$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $2ff5dbc60d933c51$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("cYDNc", function(module, exports) {
$parcel$export(module.exports, "image", () => $c0b38e40cc234f93$export$5c452ff88e35e47d);

var $32AI7 = parcelRequire("32AI7");
const $c0b38e40cc234f93$export$5c452ff88e35e47d = (0, $32AI7.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("hMy1x", function(module, exports) {
$parcel$export(module.exports, "inlineCard", () => $5f10e75594556b07$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineCardWithLocalId", () => $5f10e75594556b07$export$7ed775fc743eadd1);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $5f10e75594556b07$export$cbf8224b64e0d942 = (0, $32AI7.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $5f10e75594556b07$export$7ed775fc743eadd1 = (0, $32AI7.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $h8ouc.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("d8hbR", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", () => $b81e74eebb89d9e3$export$16b353b2649bd8d9);

var $fgugZ = parcelRequire("fgugZ");

var $32AI7 = parcelRequire("32AI7");
const $b81e74eebb89d9e3$export$16b353b2649bd8d9 = (0, $32AI7.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $fgugZ.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("atOwT", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", () => $d3bdc6b594cd3933$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => $d3bdc6b594cd3933$export$b2e27d292505bac2);
$parcel$export(module.exports, "layoutColumnStage0", () => $d3bdc6b594cd3933$export$f8cda4c28dab3f58);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");

var $hdn08 = parcelRequire("hdn08");

var $4eGM7 = parcelRequire("4eGM7");
const $d3bdc6b594cd3933$var$setColumnAttributes = (node, { withLocalId: withLocalId = false } = {})=>{
    const attrs = {
        'data-layout-column': 'true'
    };
    const { width: width, valign: valign, localId: localId } = node.attrs;
    if (width) {
        const baseStyle = `flex-basis: ${width}%`;
        const columnWidthVar = (0, $hdn08.editorExperiment)('platform_editor_layout_column_resize_handle', true) ? `; --column-width: ${width}%` : '';
        attrs['style'] = baseStyle + columnWidthVar;
        attrs['data-column-width'] = `${width}`;
    }
    if (valign) attrs['data-valign'] = valign;
    if (withLocalId && localId) attrs['data-local-id'] = localId;
    return attrs;
};
const $d3bdc6b594cd3933$var$getColumnAttrs = ({ withLocalId: withLocalId = false } = {})=>(domNode)=>{
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = domNode;
        const base = {
            width: Number(dom.getAttribute('data-column-width')) || undefined,
            ...withLocalId && {
                localId: (0, $h8ouc.uuid).generate()
            }
        };
        const valign = (0, $4eGM7.parseValign)(dom.getAttribute('data-valign'));
        return valign ? {
            ...base,
            valign: valign
        } : base;
    };
// We need to apply an attribute to the innermost child to help ProseMirror
// identify its boundaries better.
const $d3bdc6b594cd3933$var$LAYOUT_CONTENT_ATTRS = {
    'data-layout-content': 'true'
};
const $d3bdc6b594cd3933$export$ab76e7c03cd6f650 = (0, $32AI7.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $d3bdc6b594cd3933$var$getColumnAttrs()
        }
    ],
    toDOM (node) {
        return [
            'div',
            $d3bdc6b594cd3933$var$setColumnAttributes(node),
            [
                'div',
                $d3bdc6b594cd3933$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $d3bdc6b594cd3933$export$b2e27d292505bac2 = (0, $32AI7.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: $d3bdc6b594cd3933$var$getColumnAttrs({
                withLocalId: true
            })
        }
    ],
    toDOM (node) {
        return [
            'div',
            $d3bdc6b594cd3933$var$setColumnAttributes(node, {
                withLocalId: true
            }),
            [
                'div',
                $d3bdc6b594cd3933$var$LAYOUT_CONTENT_ATTRS,
                0
            ]
        ];
    }
});
const $d3bdc6b594cd3933$export$f8cda4c28dab3f58 = $d3bdc6b594cd3933$export$b2e27d292505bac2;

});
parcelRegister("hdn08", function(module, exports) {
$parcel$export(module.exports, "editorExperiment", () => $df24f89a8891543f$export$9b7cf3b74f250027);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6bGmX = parcelRequire("6bGmX");

var $lLCH0 = parcelRequire("lLCH0");

var $dzlHl = parcelRequire("dzlHl");

var $cdqux = parcelRequire("cdqux");
function $df24f89a8891543f$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    var _experimentConfig$pro;
    const experimentConfig = (0, $dzlHl.editorExperimentsConfig)[experimentName];
    if ((0, $cdqux._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $cdqux._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $cdqux._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $cdqux._product];
    if (!experimentKey) {
        var _editorExperimentsCon;
        // This will be hit in the case of an experiment not being set up for the product
        return ((_editorExperimentsCon = (0, $dzlHl.editorExperimentsConfig)[experimentName]) === null || _editorExperimentsCon === void 0 ? void 0 : _editorExperimentsCon.defaultValue) === expectedExperimentValue;
    }
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $6bGmX.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    if (// When cleaning this gate up -- `calling where the experiments have the product key set`
    // in __tests__/experiments should be updated (as it's had the count bumped to include these).
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $6bGmX.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting', 'isEnabled', false)) (0, $lLCH0.addFeatureFlagAccessed)(`${experimentName}:${experimentConfig.param}`, experimentValue);
    return expectedExperimentValue === experimentValue;
}
function $df24f89a8891543f$export$92316ae898e357eb(experimentName, paramName, options) {
    var _paramOverrides$exper;
    if (((_paramOverrides$exper = (0, $cdqux._paramOverrides)[experimentName]) === null || _paramOverrides$exper === void 0 ? void 0 : _paramOverrides$exper[paramName]) !== undefined) // This will be hit in the case of a test setting an override
    return (0, $cdqux._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $6bGmX.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});


parcelRegister("gN2eH", function(module, exports) {
$parcel$export(module.exports, "listItem", () => $40f8d8cc050564f6$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithLocalId", () => $40f8d8cc050564f6$export$483d52f09158e61c);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $40f8d8cc050564f6$export$76c7e83ecc9cdf05 = (0, $32AI7.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $40f8d8cc050564f6$export$483d52f09158e61c = (0, $32AI7.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("0585H", function(module, exports) {
$parcel$export(module.exports, "copyPrivateAttributes", () => $a4b4b014d2c19172$export$111130fa8968d741);
$parcel$export(module.exports, "createMediaSpec", () => $a4b4b014d2c19172$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "media", () => $a4b4b014d2c19172$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $a4b4b014d2c19172$export$54fd2c36b5cc6731);

var $356mi = parcelRequire("356mi");

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $a4b4b014d2c19172$export$bb3fe706be61f640 = {
    ...(0, $32AI7.media)({}).attrs
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $a4b4b014d2c19172$var$PRIVATE_ATTR_PREFIX_REGEX = /^__/u;
const $a4b4b014d2c19172$export$f84fdfb973c05bd8 = (str)=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $a4b4b014d2c19172$export$111130fa8968d741 = (from, to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
const $a4b4b014d2c19172$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    const key = $a4b4b014d2c19172$export$f84fdfb973c05bd8(k).replace($a4b4b014d2c19172$var$PRIVATE_ATTR_PREFIX_REGEX, '');
                    const value = // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $h8ouc.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $356mi.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $a4b4b014d2c19172$export$111130fa8968d741(node.attrs, attrs, attributes, (key)=>`data-${$a4b4b014d2c19172$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $32AI7.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $32AI7.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $h8ouc.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
const $a4b4b014d2c19172$export$987d49ffe1b0900f = $a4b4b014d2c19172$export$35bdbf5bc8caa677($a4b4b014d2c19172$export$bb3fe706be61f640, false, false);
const $a4b4b014d2c19172$export$8446e47a4c7fd000 = $a4b4b014d2c19172$export$35bdbf5bc8caa677({
    ...$a4b4b014d2c19172$export$bb3fe706be61f640,
    localId: {
        default: (0, $h8ouc.uuid).generate()
    }
}, false, true);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $a4b4b014d2c19172$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $a4b4b014d2c19172$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $a4b4b014d2c19172$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $a4b4b014d2c19172$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($a4b4b014d2c19172$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("jd5NI", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", () => $b0a91a571584ee94$export$2855e964765eac9);

var $32AI7 = parcelRequire("32AI7");
const $b0a91a571584ee94$export$2855e964765eac9 = (0, $32AI7.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("gPg9H", function(module, exports) {
$parcel$export(module.exports, "mediaInline", () => $5b88406b5bc633b3$export$38bab695e3f720f1);

var $0585H = parcelRequire("0585H");

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
const $5b88406b5bc633b3$export$38bab695e3f720f1 = (0, $0585H.createMediaSpec)((0, $32AI7.mediaInline)({}).attrs, true);
const $5b88406b5bc633b3$export$aea8e9c496505c61 = (0, $0585H.createMediaSpec)({
    ...(0, $32AI7.mediaInline)({}).attrs,
    localId: {
        default: (0, $h8ouc.uuid).generate()
    }
}, true, true);

});

parcelRegister("1lZPC", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", () => $12dcf3835f40eb9f$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $12dcf3835f40eb9f$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $12dcf3835f40eb9f$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $12dcf3835f40eb9f$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $12dcf3835f40eb9f$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => $12dcf3835f40eb9f$export$75376a385837c942);
$parcel$export(module.exports, "toJSON", () => $12dcf3835f40eb9f$export$54fd2c36b5cc6731);

var $7KmQB = parcelRequire("7KmQB");

var $k7OVS = parcelRequire("k7OVS");

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $12dcf3835f40eb9f$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $12dcf3835f40eb9f$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $k7OVS.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $h8ouc.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $7KmQB.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs;
            attrs['data-local-id'] = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $7KmQB.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $32AI7.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $32AI7.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $32AI7.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $32AI7.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $12dcf3835f40eb9f$export$969fe3781ca15058 = $12dcf3835f40eb9f$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $12dcf3835f40eb9f$export$d35e6c006d4abdfb = $12dcf3835f40eb9f$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $12dcf3835f40eb9f$export$9c58e19811ce4cf5 = $12dcf3835f40eb9f$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $12dcf3835f40eb9f$export$7e767666f2ce108a = $12dcf3835f40eb9f$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $12dcf3835f40eb9f$export$75376a385837c942 = $12dcf3835f40eb9f$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
const $12dcf3835f40eb9f$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("7KmQB", function(module, exports) {
$parcel$export(module.exports, "WidthType", () => $7d6afb3785858452$export$4d41558722ac7eed);
var $7d6afb3785858452$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("aRXZh", function(module, exports) {
$parcel$export(module.exports, "mention", () => $0efb3b1c60510562$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $0efb3b1c60510562$export$54fd2c36b5cc6731);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
var $0efb3b1c60510562$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $0efb3b1c60510562$export$db83999c14438df4 = (0, $32AI7.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $0efb3b1c60510562$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $0efb3b1c60510562$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $0efb3b1c60510562$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $h8ouc.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($0efb3b1c60510562$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $0efb3b1c60510562$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $0efb3b1c60510562$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($0efb3b1c60510562$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("2lECo", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", () => $f1454b4ff0d79c40$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => $f1454b4ff0d79c40$export$b854197485aa1fa0);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
function $f1454b4ff0d79c40$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $h8ouc.uuid).generate() : undefined
    };
}
const $f1454b4ff0d79c40$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$f1454b4ff0d79c40$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$f1454b4ff0d79c40$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $f1454b4ff0d79c40$export$63cadbf5f4296627 = (0, $32AI7.nestedExpand)($f1454b4ff0d79c40$var$nestedExpandFactoryOptions);
const $f1454b4ff0d79c40$export$b854197485aa1fa0 = (0, $32AI7.nestedExpand)({
    ...$f1454b4ff0d79c40$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$f1454b4ff0d79c40$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$f1454b4ff0d79c40$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$f1454b4ff0d79c40$var$getExpandAttrs(domNode, true)
        }
    ]
});

});

parcelRegister("aZvqc", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", () => $3c2d8105587d8854$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $3c2d8105587d8854$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithLocalId", () => $3c2d8105587d8854$export$8157adc5747ec436);
$parcel$export(module.exports, "orderedListWithOrder", () => $3c2d8105587d8854$export$b9ab759e8298198f);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => $3c2d8105587d8854$export$2ea3505d41d7525d);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
const $3c2d8105587d8854$export$4e7125c7ff595be5 = '.ak-ol';
const $3c2d8105587d8854$export$a5dc81035676e7a = (0, $32AI7.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $3c2d8105587d8854$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $3c2d8105587d8854$export$8157adc5747ec436 = (0, $32AI7.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const attrs = {
            class: $3c2d8105587d8854$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3c2d8105587d8854$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $3c2d8105587d8854$export$b9ab759e8298198f = (0, $32AI7.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $3c2d8105587d8854$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs2;
        const start = $3c2d8105587d8854$var$resolveStart(node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $3c2d8105587d8854$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $3c2d8105587d8854$export$2ea3505d41d7525d = (0, $32AI7.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $h8ouc.uuid).generate();
                if (startDOMAttr) {
                    const start = $3c2d8105587d8854$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs3, _node$attrs4;
        const start = $3c2d8105587d8854$var$resolveStart(node === null || node === void 0 || (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $3c2d8105587d8854$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 || (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1yeB0", function(module, exports) {
$parcel$export(module.exports, "paragraph", () => $01648a93686c9b54$export$9c206ddddb32a9b);

var $32AI7 = parcelRequire("32AI7");
const $01648a93686c9b54$export$9c206ddddb32a9b = (0, $32AI7.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs;
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $01648a93686c9b54$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 || (_paragraph$attrs = _paragraph$attrs.localId) === null || _paragraph$attrs === void 0 ? void 0 : _paragraph$attrs.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("6KpcC", function(module, exports) {
$parcel$export(module.exports, "placeholder", () => $6bed929ee28ecb50$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "placeholderWithLocalId", () => $6bed929ee28ecb50$export$6205248609a8f7a0);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $6bed929ee28ecb50$export$c7187bbd1a7a9244 = (0, $32AI7.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $6bed929ee28ecb50$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $6bed929ee28ecb50$export$6205248609a8f7a0 = (0, $32AI7.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $6bed929ee28ecb50$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("kN7jZ", function(module, exports) {
$parcel$export(module.exports, "rule", () => $f8b83e5c9b40839e$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "ruleWithLocalId", () => $f8b83e5c9b40839e$export$bf3ef6fb6ad90e7);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $f8b83e5c9b40839e$var$hrDOM = [
    'hr'
];
const $f8b83e5c9b40839e$export$fbeb3a3956e8a3c7 = (0, $32AI7.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $f8b83e5c9b40839e$var$hrDOM;
    }
});
const $f8b83e5c9b40839e$export$bf3ef6fb6ad90e7 = (0, $32AI7.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("6WkNC", function(module, exports) {
$parcel$export(module.exports, "status", () => $f75b3d644c8925ac$export$471f7ae5c4103ae1);

var $h8ouc = parcelRequire("h8ouc");

var $32AI7 = parcelRequire("32AI7");
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $f75b3d644c8925ac$var$NEWLINE_REGEX = /\n/u;
const $f75b3d644c8925ac$export$471f7ae5c4103ae1 = (0, $32AI7.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace($f75b3d644c8925ac$var$NEWLINE_REGEX, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = dom.getAttribute('data-text') || textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $h8ouc.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("6s3pT", function(module, exports) {
$parcel$export(module.exports, "syncBlock", () => $1a1d83993f031a20$export$faab0ca9701d7048);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $1a1d83993f031a20$export$faab0ca9701d7048 = (0, $32AI7.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $h8ouc.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("6DOrW", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", () => $8467e3f40aa866e3$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $8467e3f40aa866e3$export$375b6afcc5f4d291);

var $32AI7 = parcelRequire("32AI7");

var $h8ouc = parcelRequire("h8ouc");
const $8467e3f40aa866e3$var$name = 'actionList';
const $8467e3f40aa866e3$export$c0ec71adb7a18fb2 = `[data-node-type="${$8467e3f40aa866e3$var$name}"]`;
const $8467e3f40aa866e3$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$8467e3f40aa866e3$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $h8ouc.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $8467e3f40aa866e3$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $8467e3f40aa866e3$export$375b6afcc5f4d291 = (0, $32AI7.taskList)($8467e3f40aa866e3$var$taskListParseDOMAndToDOM);

});

parcelRegister("gRNnW", function(module, exports) {
$parcel$export(module.exports, "text", () => $470996e27c1eb0af$export$6f093cfa640b7166);

var $32AI7 = parcelRequire("32AI7");
const $470996e27c1eb0af$export$6f093cfa640b7166 = (0, $32AI7.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("4FwVM", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdc492acca94f7e4$export$2e2bcd8739ae039);
const $cdc492acca94f7e4$var$name = 'unknownBlock';
var $cdc492acca94f7e4$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $cdc492acca94f7e4$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$cdc492acca94f7e4$var$name}"]`
        }
    ]
};

});

parcelRegister("ejaRu", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", () => $3d42e52763b76176$export$44b79b0979d0f0f7);

var $32AI7 = parcelRequire("32AI7");
const $3d42e52763b76176$export$44b79b0979d0f0f7 = (0, $32AI7.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("ieg9J", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", () => $7a2b387fc2fbe9f1$export$310ebe0d80122e9b);

var $32AI7 = parcelRequire("32AI7");
const $7a2b387fc2fbe9f1$export$310ebe0d80122e9b = (0, $32AI7.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("gScSr", function(module, exports) {
$parcel$export(module.exports, "ProviderFactoryProvider", () => $7fc91a6ca5e59b6b$export$617c134b25cc4265);
$parcel$export(module.exports, "useProviderFactory", () => $7fc91a6ca5e59b6b$export$a3af4b6980aa23b5);
$parcel$export(module.exports, "useProvider", () => $7fc91a6ca5e59b6b$export$693cdb10cec23617);
$parcel$export(module.exports, "useProviderLayout", () => $7fc91a6ca5e59b6b$export$6fde1d0d81db98e1);

var $4fqPo = parcelRequire("4fqPo");

var $irmNM = parcelRequire("irmNM");
const $7fc91a6ca5e59b6b$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(new (0, $irmNM.default)());
const $7fc91a6ca5e59b6b$export$617c134b25cc4265 = $7fc91a6ca5e59b6b$var$ProviderFactoryContext.Provider;
const $7fc91a6ca5e59b6b$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext($7fc91a6ca5e59b6b$var$ProviderFactoryContext);
const $7fc91a6ca5e59b6b$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState();
    const providerFactory = $7fc91a6ca5e59b6b$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};
const $7fc91a6ca5e59b6b$export$6fde1d0d81db98e1 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState();
    const providerFactory = $7fc91a6ca5e59b6b$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useLayoutEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("bGK06", function(module, exports) {
$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $96084c4df442eb46$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $96084c4df442eb46$export$a1a213d350ca51ca);

var $4fqPo = parcelRequire("4fqPo");

var $gOfqU = parcelRequire("gOfqU");

var $faPFq = parcelRequire("faPFq");

var $ag3hq = parcelRequire("ag3hq");
function $96084c4df442eb46$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $96084c4df442eb46$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $4fqPo.useMemo)(()=>({
            baseFontSize: baseFontSize || 14,
            layoutMaxWidth: (0, $faPFq.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gOfqU.a), {
        theme: memoizedTheme
    }, children);
}
function $96084c4df442eb46$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ag3hq.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($96084c4df442eb46$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children)));
}

});
parcelRegister("faPFq", function(module, exports) {
$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $53c2053160767b95$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorFullPageDenseFontSize", () => $53c2053160767b95$export$24495b314f307191);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $53c2053160767b95$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $53c2053160767b95$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $53c2053160767b95$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $53c2053160767b95$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $53c2053160767b95$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $53c2053160767b95$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $53c2053160767b95$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $53c2053160767b95$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $53c2053160767b95$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $53c2053160767b95$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $53c2053160767b95$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $53c2053160767b95$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $53c2053160767b95$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $53c2053160767b95$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $53c2053160767b95$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $53c2053160767b95$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $53c2053160767b95$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $53c2053160767b95$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableContainerBg", () => $53c2053160767b95$export$d0fb376c4d4be9e2);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $53c2053160767b95$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $53c2053160767b95$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $53c2053160767b95$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $53c2053160767b95$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorMaxWidthLayoutWidth", () => $53c2053160767b95$export$c0f7d71e10d277e9);
$parcel$export(module.exports, "akEditorMaxLayoutWidth", () => $53c2053160767b95$export$45eb0f5135abf6f1);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $53c2053160767b95$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $53c2053160767b95$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $53c2053160767b95$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $53c2053160767b95$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorGutterPaddingReduced", () => $53c2053160767b95$export$aae87d25ced827bb);
$parcel$export(module.exports, "akEditorFullPageNarrowBreakout", () => $53c2053160767b95$export$cccda66937c91e4c);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $53c2053160767b95$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $53c2053160767b95$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $53c2053160767b95$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $53c2053160767b95$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $53c2053160767b95$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $53c2053160767b95$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $53c2053160767b95$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $53c2053160767b95$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $53c2053160767b95$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $53c2053160767b95$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $53c2053160767b95$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $53c2053160767b95$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $53c2053160767b95$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $53c2053160767b95$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $53c2053160767b95$export$e88f6c898960b391);
$parcel$export(module.exports, "layoutBreakpointWidth", () => $53c2053160767b95$export$e5c605f2b2a12b00);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $53c2053160767b95$export$1d0d506416d457f1);
$parcel$export(module.exports, "scaledBlockNodesVerticalMargin", () => $53c2053160767b95$export$53030af820b542f5);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $53c2053160767b95$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $53c2053160767b95$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $53c2053160767b95$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $53c2053160767b95$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorFullPageToolbarHeight", () => $53c2053160767b95$export$d1343597f3b52d83);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $53c2053160767b95$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $53c2053160767b95$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $53c2053160767b95$export$59733a9f61449b25);
$parcel$export(module.exports, "relativeSizeToBaseFontSize", () => $53c2053160767b95$export$46715ac1fbd9e64e);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $53c2053160767b95$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $53c2053160767b95$export$42608c013398a830);

var $3H4LK = parcelRequire("3H4LK");

var $hdn08 = parcelRequire("hdn08");
const $53c2053160767b95$export$fe6b0b821a0e9067 = 16;
const $53c2053160767b95$export$24495b314f307191 = 13;
const $53c2053160767b95$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $53c2053160767b95$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $53c2053160767b95$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
const $53c2053160767b95$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $53c2053160767b95$export$f0e953d95429ca1 = '12px';
const $53c2053160767b95$export$a309dbdeca0adb1a = '2px 4px';
const $53c2053160767b95$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $53c2053160767b95$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $53c2053160767b95$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $53c2053160767b95$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $53c2053160767b95$export$d2715266dd4a1fd1 = 20;
const $53c2053160767b95$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
const $53c2053160767b95$export$8dac549e32469ac4 = 1;
const $53c2053160767b95$export$befaaae517e3d864 = 2;
const $53c2053160767b95$export$6e1e1996c4e8cc51 = `${$53c2053160767b95$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #1868DB)"}`;
const $53c2053160767b95$export$b6a59ac3a19b6343 = `0 0 0 ${$53c2053160767b95$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #1868DB)"}`;
const $53c2053160767b95$export$37e178ca41c198ca = `0 0 0 ${$53c2053160767b95$export$befaaae517e3d864}px ${"var(--ds-border-selected, #1868DB)"}`;
const $53c2053160767b95$export$4a007c22e25e31f6 = 0.3;
const $53c2053160767b95$export$f35cc48f3398ab79 = 1;
const $53c2053160767b95$export$b46cda584c619451 = 2;
const $53c2053160767b95$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $53c2053160767b95$export$321ddd2f049dd12 = $53c2053160767b95$export$6bed85de54b5de42 + 1;
const $53c2053160767b95$export$daeac9b8422ac3c2 = 2;
const $53c2053160767b95$export$501d46e11ed5bf73 = 500;
const $53c2053160767b95$export$6817b4b6a5ef78f1 = 400;
const $53c2053160767b95$export$93768eb72dec48ce = $53c2053160767b95$export$501d46e11ed5bf73 + 10;
const $53c2053160767b95$export$c0aec4e0896849a0 = $53c2053160767b95$export$93768eb72dec48ce - 5;
const $53c2053160767b95$export$5886f057e4f21fe4 = $53c2053160767b95$export$6817b4b6a5ef78f1 + 5;
const $53c2053160767b95$export$6e85faa46d537a3f = 11;
const $53c2053160767b95$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $53c2053160767b95$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $53c2053160767b95$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $53c2053160767b95$export$95e9a0285b97474d = '#2C333A';
const $53c2053160767b95$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
const $53c2053160767b95$export$76b5e653883e5290 = '3px';
const $53c2053160767b95$export$d0fb376c4d4be9e2 = '--table-container-bg';
const $53c2053160767b95$export$6d85fe8177a50c0c = 0.5;
const $53c2053160767b95$export$fad19f16d3f953a3 = 680;
const $53c2053160767b95$export$9db045950eedb49f = 760;
const $53c2053160767b95$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $53c2053160767b95$export$f580e3d28d0986de = 1800;
const $53c2053160767b95$export$c0f7d71e10d277e9 = 4000;
const $53c2053160767b95$export$9d5488b5afad62bf = 1792;
const $53c2053160767b95$export$45eb0f5135abf6f1 = 4000;
const $53c2053160767b95$export$37df10057d36a0e5 = 42;
const $53c2053160767b95$export$437293c5e9fc2703 = 96;
const $53c2053160767b95$export$6e0f4d52efd3d2d = 32;
const $53c2053160767b95$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $3H4LK.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $hdn08.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $53c2053160767b95$export$aae87d25ced827bb = 24;
const $53c2053160767b95$export$cccda66937c91e4c = 600;
const $53c2053160767b95$export$efe8561bbd3f74d2 = 720;
const $53c2053160767b95$export$e4d39a9e8607c1d3 = 48;
const $53c2053160767b95$export$43946f2400ab6f1f = 128;
const $53c2053160767b95$export$558438ae7fd4b8ce = 12;
const $53c2053160767b95$export$6beb98d32d4ca149 = 4;
const $53c2053160767b95$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $53c2053160767b95$export$5edb4f38c3eacb1a = 1024;
const $53c2053160767b95$export$e60820063058ed59 = 1.33;
const $53c2053160767b95$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $53c2053160767b95$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $53c2053160767b95$export$fb15fade89f67217 = $53c2053160767b95$export$f35cc48f3398ab79 * 99;
const $53c2053160767b95$export$847030921e9d5a40 = 12;
const $53c2053160767b95$export$40eb41ab799f0329 = 1.714;
const $53c2053160767b95$export$e271312fc7124aec = '1px';
const $53c2053160767b95$export$d29cb2c31fcbb7c5 = 2;
const $53c2053160767b95$export$688a6dc01e760755 = 320;
const $53c2053160767b95$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $53c2053160767b95$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $53c2053160767b95$export$e88f6c898960b391 = $53c2053160767b95$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $53c2053160767b95$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $53c2053160767b95$export$1d0d506416d457f1 = '0.75rem';
const $53c2053160767b95$export$53030af820b542f5 = '0.75em';
const $53c2053160767b95$export$e683ef42725d1713 = 680;
const $53c2053160767b95$export$226c784ba04bd04b = 480;
const $53c2053160767b95$export$214ff00e5618d86c = 20;
const $53c2053160767b95$export$c82675fa56f2eefd = '56px';
const $53c2053160767b95$var$DEFAULT_FONT_SIZE = 14;
const $53c2053160767b95$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? (0, $hdn08.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $3H4LK.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $hdn08.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $53c2053160767b95$export$d1343597f3b52d83 = 40;
const $53c2053160767b95$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $53c2053160767b95$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $53c2053160767b95$var$DEFAULT_FONT_SIZE;
const $53c2053160767b95$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$53c2053160767b95$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $53c2053160767b95$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $53c2053160767b95$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$53c2053160767b95$export$fe6b0b821a0e9067})`;
};
const $53c2053160767b95$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $53c2053160767b95$export$9369fd010fa0ddd6 = 0;
const $53c2053160767b95$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$53c2053160767b95$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $53c2053160767b95$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $53c2053160767b95$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
const $53c2053160767b95$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];

});

parcelRegister("ag3hq", function(module, exports) {
$parcel$export(module.exports, "getBreakpoint", () => $f7bbe8f0ae880a10$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $f7bbe8f0ae880a10$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $f7bbe8f0ae880a10$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $f7bbe8f0ae880a10$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $f7bbe8f0ae880a10$export$7921e18173e8c666);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $jE04u = parcelRequire("jE04u");

var $c1P93 = parcelRequire("c1P93");

var $azPf3 = parcelRequire("azPf3");

var $xDcse = parcelRequire("xDcse");
function $f7bbe8f0ae880a10$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f7bbe8f0ae880a10$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $f7bbe8f0ae880a10$var$SCROLLBAR_WIDTH = 30;
function $f7bbe8f0ae880a10$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $f7bbe8f0ae880a10$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $f7bbe8f0ae880a10$export$1eb095b00b926404(width)
    };
}
const $f7bbe8f0ae880a10$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext($f7bbe8f0ae880a10$export$31a4966bffb9ac98());
const $f7bbe8f0ae880a10$var$Provider = $f7bbe8f0ae880a10$export$27e39f636459b9f.Provider;
const $f7bbe8f0ae880a10$export$5d8538aa831b6ebb = $f7bbe8f0ae880a10$export$27e39f636459b9f.Consumer;
const $f7bbe8f0ae880a10$export$df154c49e93b2ac2 = (0, $jE04u.default)(()=>{
    var _document$body;
    return (0, $xDcse.isSSR)() ? 0 : ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.offsetWidth) ?? 0;
});
const $f7bbe8f0ae880a10$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, $4fqPo.useContext)($f7bbe8f0ae880a10$export$27e39f636459b9f);
    const [width, setWidth] = (0, $4fqPo.useState)($f7bbe8f0ae880a10$export$df154c49e93b2ac2);
    const widthRef = (0, $4fqPo.useRef)(width);
    const isMountedRef = (0, $4fqPo.useRef)(true);
    const providerValue = (0, $4fqPo.useMemo)(()=>$f7bbe8f0ae880a10$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, $4fqPo.useMemo)(()=>{
        return (0, $c1P93.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $f7bbe8f0ae880a10$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            widthRef.current = nextWidth;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $f7bbe8f0ae880a10$var$styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $azPf3.default), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $lqVX7.jsx)($f7bbe8f0ae880a10$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children);
};

});
parcelRegister("xDcse", function(module, exports) {
$parcel$export(module.exports, "isSSR", () => $4d6db641ef88d370$export$48d7c418edadb60c);

var $3TFEq = parcelRequire("3TFEq");
function $4d6db641ef88d370$export$48d7c418edadb60c() {
    try {
        return Boolean(// In most places there is no document when running on server-side
        typeof document === 'undefined' || // When SSRing editor with full cycle mode we define the document
        // Check Confluence specific environment variable
        typeof $3TFEq !== 'undefined' && undefined);
    } catch (e) {
        // Catch possible error that might occur and just return false
        return false;
    }
}

});



parcelRegister("1cagQ", function(module, exports) {
$parcel$export(module.exports, "IntlErrorBoundary", () => $9e997571f18eb1f6$export$7df0749115d18d19);

var $4fqPo = parcelRequire("4fqPo");

var $99BhM = parcelRequire("99BhM");
const $9e997571f18eb1f6$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $9e997571f18eb1f6$var$isMissingIntlProviderInAncestryError = (err)=>{
    var _err$toString;
    return err === null || err === void 0 || (_err$toString = err.toString()) === null || _err$toString === void 0 ? void 0 : _err$toString.includes('<IntlProvider> needs to exist in the component ancestry');
};
class $9e997571f18eb1f6$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidCatch(error, _errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($9e997571f18eb1f6$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $99BhM.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("84REQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $30d37de685129e8c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $3rTf2 = parcelRequire("3rTf2");

var $faPFq = parcelRequire("faPFq");

var $kLLw5 = parcelRequire("kLLw5");

var $8Mj6h = parcelRequire("8Mj6h");

var $f0GG4 = parcelRequire("f0GG4");

var $6cooD = parcelRequire("6cooD");

var $2kuA8 = parcelRequire("2kuA8");

var $gr4P1 = parcelRequire("gr4P1");
const $30d37de685129e8c$var$blockNodeStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $faPFq.relativeFontSizeToBase16)(14),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $30d37de685129e8c$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $gr4P1.getUnsupportedContent)((0, $6cooD.unsupportedContentMessages).unsupportedBlockContent, (0, $6cooD.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $6cooD.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $4fqPo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $4fqPo.useCallback)(()=>dispatchAnalyticsEvent && (0, $2kuA8.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $f0GG4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $30d37de685129e8c$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mj6h.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kLLw5))), {
        label: "?"
    })))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $30d37de685129e8c$var$_default_1 = (0, $3rTf2.default)($30d37de685129e8c$var$UnsupportedBlockNode);
var $30d37de685129e8c$export$2e2bcd8739ae039 = $30d37de685129e8c$var$_default_1;

});
parcelRegister("kLLw5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1ed0e3a69509af8$var$_react = $f1ed0e3a69509af8$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $f1ed0e3a69509af8$var$_baseNew = $f1ed0e3a69509af8$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $f1ed0e3a69509af8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1ed0e3a69509af8$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $f1ed0e3a69509af8$var$_react.default.createElement($f1ed0e3a69509af8$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$f1ed0e3a69509af8$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $f1ed0e3a69509af8$var$_default = module.exports.default = $f1ed0e3a69509af8$var$QuestionCircleIcon;

});

parcelRegister("f0GG4", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $9e201d732fe587a7$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $9e201d732fe587a7$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $9e201d732fe587a7$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "MEDIA_INSERT_TAB", () => $9e201d732fe587a7$export$9395e0d0ae49956f);
$parcel$export(module.exports, "INSERT_MEDIA_VIA", () => $9e201d732fe587a7$export$9b31fa32ae3f8051);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $9e201d732fe587a7$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $9e201d732fe587a7$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $9e201d732fe587a7$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $9e201d732fe587a7$export$9f0b2adf3cfd71b7);
var $9e201d732fe587a7$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $9e201d732fe587a7$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPLAYED"] = "displayed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INSERT_ATTEMPTED"] = "insertAttempted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LANGUAGE_AUTO_DETECTED"] = "languageAutoDetected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["ACCEPTED"] = "accepted";
    ACTION["NO_DIFF_FOUND"] = "noDiffFound";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["TRIGGERED"] = "triggered";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERED_SAMPLED"] = "renderedSampled";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["CONTAINER_NODE_TRANSFORMED"] = "containerNodeTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    // remove this enum when cleaning up platform_editor_remove_collab_step_metrics
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_FOLDING"] = "toggleCodeFolding";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TOGGLE_CODE_BLOCK_LINE_NUMBERS"] = "toggleCodeBlockLineNumbers";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    // fired when the on-device autocomplete LLM finishes loading/starting
    ACTION["LOCAL_MODEL_LOADED"] = "localModelLoaded";
    // fired when the on-device autocomplete LLM fails to load/start
    ACTION["LOCAL_MODEL_LOAD_FAILED"] = "localModelLoadFailed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $9e201d732fe587a7$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    INPUT_METHOD["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    INPUT_METHOD["REMIX"] = "remix";
    INPUT_METHOD["REMIX_FROM_MEDIA_INSERTS"] = "remixFromMediaInserts";
    return INPUT_METHOD;
}({});
var $9e201d732fe587a7$export$9395e0d0ae49956f = /*#__PURE__*/ function(MEDIA_INSERT_TAB) {
    MEDIA_INSERT_TAB["CREATE"] = "create";
    MEDIA_INSERT_TAB["LINK"] = "link";
    MEDIA_INSERT_TAB["UPLOAD"] = "upload";
    return MEDIA_INSERT_TAB;
}({});
var $9e201d732fe587a7$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $9e201d732fe587a7$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $9e201d732fe587a7$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["EXTENSION_AS_INLINE"] = "extensionAsInline";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LAYOUT_COLUMN_MENU"] = "layoutColumnMenu";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["AI_QUICK_PROMPT"] = "aiQuickPrompt";
    ACTION_SUBJECT["AI_AUTOCOMPLETE"] = "aiAutocomplete";
    ACTION_SUBJECT["AI_SUGGESTIONS"] = "aiSuggestions";
    ACTION_SUBJECT["CONTEXTUAL_TYPEAHEAD"] = "contextualTypeahead";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["PASTE_ACTIONS_MENU"] = "pasteActionsMenu";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    ACTION_SUBJECT["NATIVE_EMBED"] = "nativeEmbed";
    ACTION_SUBJECT["NATIVE_EMBED_FALLBACK"] = "nativeEmbedFallback";
    return ACTION_SUBJECT;
}({});
var $9e201d732fe587a7$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_REMIX_BUTTON"] = "aiRemixButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_SMALL_TEXT"] = "smallText";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LAYOUT_COLUMN"] = "layoutColumn";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["SMART_LINK_ROVO_BUTTON"] = "smartLinkRovoButton";
    ACTION_SUBJECT_ID["SMART_LINK_SUMMARIZE_BUTTON"] = "smartLinkSummarizeButton";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_INFO_ORPHANED"] = "syncedBlockSourceInfoOrphaned";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CACHE_DELETION_FORCED"] = "syncedBlockCacheDeletionForced";
    ACTION_SUBJECT_ID["UNSUPPORTED_SURFACE"] = "unsupportedSurface";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    ACTION_SUBJECT_ID["SNIPPET"] = "snippet";
    return ACTION_SUBJECT_ID;
}({});
var $9e201d732fe587a7$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $9e201d732fe587a7$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("6cooD", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentMessages", () => $10028cf764263366$export$32ec96484dd3ba39);

var $6BhDL = parcelRequire("6BhDL");
const $10028cf764263366$export$32ec96484dd3ba39 = (0, $6BhDL.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'The text is shown as an inline label in the editor when a content node type is not supported for display. It appears alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'The text is shown as a block-level message in the editor when a content block type is not supported for display. It appears centered within a dashed border container alongside a question mark icon that provides more details via a tooltip.'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'The text is shown as tooltip content when the user hovers over the question mark icon on an unsupported content node in the editor. It reassures users that unsupported content will not be lost when they edit and save the document.'
    }
});

});

parcelRegister("2kuA8", function(module, exports) {
$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $83c4187482f932ae$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $83c4187482f932ae$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $83c4187482f932ae$export$3a34598135e7219b);

var $f0GG4 = parcelRequire("f0GG4");
const $83c4187482f932ae$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $83c4187482f932ae$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $83c4187482f932ae$var$sanitizeMarks = (marks = [])=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $83c4187482f932ae$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $83c4187482f932ae$var$sanitizeAttributes = (attrs = {})=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$83c4187482f932ae$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $83c4187482f932ae$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $f0GG4.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $f0GG4.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $83c4187482f932ae$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $83c4187482f932ae$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $f0GG4.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $83c4187482f932ae$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $f0GG4.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $f0GG4.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $f0GG4.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $83c4187482f932ae$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$83c4187482f932ae$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $83c4187482f932ae$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $83c4187482f932ae$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $83c4187482f932ae$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $83c4187482f932ae$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $f0GG4.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $f0GG4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $f0GG4.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $83c4187482f932ae$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $83c4187482f932ae$var$trackUnsupportedContentTooltipActionFor((0, $f0GG4.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("gr4P1", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $b2555179a921f0b9$export$d4ded51d0f0bd2df);
function $b2555179a921f0b9$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("feY6v", function(module, exports) {
$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $897c008fa991faf2$export$9ac3d19711324187);

var $4fqPo = parcelRequire("4fqPo");

var $as4kh = parcelRequire("as4kh");
const $897c008fa991faf2$export$9ac3d19711324187 = (0, $as4kh.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("cpSqr", function(module, exports) {
$parcel$export(module.exports, "getBrowserInfo", () => $f52840363eb08a48$export$6c724a6ffa2dc3e1);

var $jE04u = parcelRequire("jE04u");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$IE_EDGE_REGEX = /\sedg\//i;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$IE_EDGE2_REGEX = /edg([ea]|ios)/i;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$INTERNET_EXPLORER_REGEX = /msie|trident/i;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$MAC_REGEX = /Mac/;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$WINDOWS_REGEX = /Windows|Win\d+/i;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$IE_EDGE_VERSION_REGEX = /\sedg\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$IE_EDGE2_VERSION_REGEX = /edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$IE_VERSION_REGEX = /(?:msie |rv:)(\d+(\.?_?\d+)+)/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$GECKO_REGEX = /gecko\/\d/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$CHROME_REGEX = /Chrome\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$ANDROID_REGEX = /Android \d/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$APPLE_WEBKIT_REGEX = /AppleWebKit/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$MOBILE_REGEX = /Mobile\/\w+/;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$SAFARI_REGEX = /safari|applewebkit/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$SAFARI_VERSION_REGEX = /Version\/([0-9\._]+).*Safari/;
// eslint-disable-next-line require-unicode-regexp
const $f52840363eb08a48$var$WEBKIT_REGEX = /(apple)?webkit/i;
const $f52840363eb08a48$var$getFirstMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[1] || '';
};
const $f52840363eb08a48$var$getSecondMatch = (regexp, ua)=>{
    const match = ua.match(regexp);
    return match && match.length > 0 && match[2] || '';
};
// Helper functions to safely access browser properties
const $f52840363eb08a48$var$getSafeUserAgent = ()=>{
    var _window$navigator;
    if (typeof window === 'undefined') return undefined;
    // Fallback to navigator.userAgent with proper null checking
    return (_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;
};
const $f52840363eb08a48$var$getSafePlatform = ()=>{
    var _window$navigator2;
    if (typeof window === 'undefined') return undefined;
    return (_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.platform;
};
const $f52840363eb08a48$var$hasIntersectionObserver = ()=>{
    return typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};
const $f52840363eb08a48$var$hasResizeObserver = ()=>{
    return typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
};
const $f52840363eb08a48$export$6c724a6ffa2dc3e1 = (0, $jE04u.default)(()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {
        mac: false,
        windows: false,
        ie: false,
        ie_version: 0,
        gecko: false,
        gecko_version: 0,
        chrome: false,
        chrome_version: 0,
        android: false,
        ios: false,
        webkit: false,
        safari: false,
        safari_version: 0,
        supportsIntersectionObserver: false,
        supportsResizeObserver: false
    };
    const userAgent = $f52840363eb08a48$var$getSafeUserAgent();
    const platform = $f52840363eb08a48$var$getSafePlatform();
    if (userAgent) {
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        const ieEdge = $f52840363eb08a48$var$IE_EDGE_REGEX.test(userAgent);
        const ieEdge2 = $f52840363eb08a48$var$IE_EDGE2_REGEX.test(userAgent);
        const internetExplorer = $f52840363eb08a48$var$INTERNET_EXPLORER_REGEX.test(userAgent);
        // Ideally we should use userAgent instead of platform, but we have lots of keymap tests failure when we change it
        // So leave it as is for now.
        result.mac = platform && $f52840363eb08a48$var$MAC_REGEX.test(platform);
        // Previously relied on navigator.userAgentData?.platform and userAgent, now used only userAgent
        result.windows = $f52840363eb08a48$var$WINDOWS_REGEX.test(userAgent);
        // used userAgent rather than relying on documentMode
        const ie = ieEdge || ieEdge2 || internetExplorer;
        result.ie = ie;
        // inspired from https://github.com/bowser-js/bowser/blob/master/src/parser-browsers.js
        result.ie_version = ieEdge ? parseInt($f52840363eb08a48$var$getFirstMatch($f52840363eb08a48$var$IE_EDGE_VERSION_REGEX, userAgent), 10) : ieEdge2 ? parseInt($f52840363eb08a48$var$getSecondMatch($f52840363eb08a48$var$IE_EDGE2_VERSION_REGEX, userAgent), 10) : parseInt($f52840363eb08a48$var$getFirstMatch($f52840363eb08a48$var$IE_VERSION_REGEX, userAgent), 10);
        result.gecko = !ie && $f52840363eb08a48$var$GECKO_REGEX.test(userAgent);
        result.gecko_version = parseInt((userAgent.match($f52840363eb08a48$var$FIREFOX_VERSION_REGEX) || [])[1], 10);
        result.chrome = !ie && $f52840363eb08a48$var$CHROME_REGEX.test(userAgent);
        result.chrome_version = parseInt((userAgent.match($f52840363eb08a48$var$CHROME_VERSION_REGEX) || [])[1], 10);
        result.android = $f52840363eb08a48$var$ANDROID_REGEX.test(userAgent);
        result.ios = !ie && $f52840363eb08a48$var$APPLE_WEBKIT_REGEX.test(userAgent) && $f52840363eb08a48$var$MOBILE_REGEX.test(userAgent);
        // Previously relied on navigator.vendor, now used userAgent
        result.safari = !result.chrome && !result.ie && !result.gecko && !result.android && !userAgent.includes('CriOS') && !userAgent.includes('FxiOS') && $f52840363eb08a48$var$SAFARI_REGEX.test(userAgent);
        result.safari_version = parseInt((userAgent.match($f52840363eb08a48$var$SAFARI_VERSION_REGEX) || [])[1], 10);
        // Previously we relied on documentElement.style.WebkitAppearance, now changed to userAgent
        result.webkit = $f52840363eb08a48$var$WEBKIT_REGEX.test(userAgent);
        result.supportsIntersectionObserver = $f52840363eb08a48$var$hasIntersectionObserver();
        result.supportsResizeObserver = $f52840363eb08a48$var$hasResizeObserver();
    }
    return result;
});

});

parcelRegister("emduD", function(module, exports) {
$parcel$export(module.exports, "isPanelNestingTableSupported", () => $fd28176c84c03779$export$da873e3c90937d2a);

var $4mqcS = parcelRequire("4mqcS");
const $fd28176c84c03779$export$da873e3c90937d2a = (schema)=>{
    var _panel_c1$contentMatc;
    const { table: table, panel_c1: panel_c1 } = schema.nodes;
    if (!table || !panel_c1) return false;
    // Confirm the PM schema actually allows table inside panel_c1
    const panelC1CanContainTable = ((_panel_c1$contentMatc = panel_c1.contentMatch.matchType(table)) === null || _panel_c1$contentMatc === void 0 ? void 0 : _panel_c1$contentMatc.validEnd) === true;
    return panelC1CanContainTable && (0, $4mqcS.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
};

});

parcelRegister("vTwlu", function(module, exports) {
$parcel$export(module.exports, "startMeasure", () => $f68afd2e6a25e0ab$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $f68afd2e6a25e0ab$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $f68afd2e6a25e0ab$export$6f766653554dac02);
$parcel$export(module.exports, "isMeasuring", () => $f68afd2e6a25e0ab$export$b0a51f9f0047ea32);

var $7LVfy = parcelRequire("7LVfy");
const $f68afd2e6a25e0ab$var$measureMap = new Map();
function $f68afd2e6a25e0ab$export$b62aa2130c86b59b(measureName) {
    if (!(0, $7LVfy.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $f68afd2e6a25e0ab$var$measureMap.set(measureName, performance.now());
}
function $f68afd2e6a25e0ab$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $7LVfy.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $f68afd2e6a25e0ab$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $f68afd2e6a25e0ab$export$6f766653554dac02(measureName);
    }
}
function $f68afd2e6a25e0ab$export$6f766653554dac02(measureName) {
    if (!(0, $7LVfy.isPerformanceAPIAvailable)()) return;
    $f68afd2e6a25e0ab$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
function $f68afd2e6a25e0ab$export$b0a51f9f0047ea32(measureName) {
    if (!(0, $7LVfy.isPerformanceAPIAvailable)()) return false;
    return $f68afd2e6a25e0ab$var$measureMap.get(measureName) !== undefined;
}

});
parcelRegister("7LVfy", function(module, exports) {
$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $077e86c0f2c619f5$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => (parcelRequire("5HQYw")).isPerformanceObserverAvailable);

var $5HQYw = parcelRequire("5HQYw");
let $077e86c0f2c619f5$var$hasRequiredPerformanceAPIs;
function $077e86c0f2c619f5$export$b5717a625dd4a3eb() {
    if ($077e86c0f2c619f5$var$hasRequiredPerformanceAPIs === undefined) $077e86c0f2c619f5$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $077e86c0f2c619f5$var$hasRequiredPerformanceAPIs;
}
function $077e86c0f2c619f5$export$4370ec0f52022f66() {
    return (0, $5HQYw.isPerformanceObserverAvailable)() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});
parcelRegister("5HQYw", function(module, exports) {
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $f2c9a65b6c840201$export$48995af1e77d8643);
function $f2c9a65b6c840201$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}

});



parcelRegister("dlTjh", function(module, exports) {
$parcel$export(module.exports, "getDistortedDurationMonitor", () => $2d741ea45fe46c3d$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $2d741ea45fe46c3d$export$267ed650a5d21ae6);

var $7LVfy = parcelRequire("7LVfy");
const $2d741ea45fe46c3d$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
     * Cleans up the document visibility event listener
     */ cleanup () {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $2d741ea45fe46c3d$export$267ed650a5d21ae6(/**
 * Unique name for the measurement
 *
 * Important: if multiple measureRender events are fired at the same time
 * with the same measure name -- the result will not be correct.
 */ measureName, /**
 * Call back fired when the measurement completes.
 *
 * Note: when this function is called when the Document.visibilityState is not
 * visible -- the duration is likely to be misleading/inaccurate. This is due
 * to the measurements use of the `requestAnimationFrame` api which only fires
 * when the Document.visibilityState is visible.
 */ onMeasureComplete) {
    if (!(0, $7LVfy.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    const distortedDurationMonitor = $2d741ea45fe46c3d$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});

parcelRegister("jRnuf", function(module, exports) {
$parcel$export(module.exports, "getResponseEndTime", () => $80a4bbd7cf3504c2$export$92d097a1155bbe27);

var $7LVfy = parcelRequire("7LVfy");
function $80a4bbd7cf3504c2$export$92d097a1155bbe27() {
    if (!(0, $7LVfy.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("awtxt", function(module, exports) {
$parcel$export(module.exports, "useScrollToBlock", () => $d8e1eba8013efaf7$export$81bdbc2b3f1c95ef);

var $4fqPo = parcelRequire("4fqPo");

var $564zZ = parcelRequire("564zZ");

var $7lGDA = parcelRequire("7lGDA");
var $g2kC6 = parcelRequire("g2kC6");
var $9NsdY = parcelRequire("9NsdY");
var $Ne8A9 = parcelRequire("Ne8A9");
var $1yuNq = parcelRequire("1yuNq");

var $3H4LK = parcelRequire("3H4LK");

var $hLSAE = parcelRequire("hLSAE");
const $d8e1eba8013efaf7$export$81bdbc2b3f1c95ef = (containerRef, adfDoc, scrollToBlock)=>{
    const { waitForStability: waitForStability, cleanup: cleanupStability } = (0, $hLSAE.useStableScroll)({
        stabilityWaitTime: 750,
        maxStabilityWaitTime: 10000
    });
    (0, $4fqPo.useEffect)(()=>{
        var _getDocument;
        // Only run in browser environment.
        if (typeof window === 'undefined' || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return;
        // Parse hash fragment for block ID (format: #block-{localId}).
        const hash = window.location.hash;
        const defaultPrefixWithHash = `#${(0, $7lGDA.DEFAULT_BLOCK_LINK_HASH_PREFIX)}`;
        const blockId = hash && hash.startsWith(defaultPrefixWithHash) ? hash.slice(defaultPrefixWithHash.length) : null;
        if (!blockId) return;
        let retryCount = 0;
        const maxRetries = 40;
        const retryInterval = 250;
        let intervalId = null;
        let hasScrolled = false;
        let cancelExpandAndScroll = null;
        const scrollToElement = ()=>{
            // Step 1: Search the ADF document for the node with the given blockId.
            // This works even if the node is hidden inside a collapsed expand.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $g2kC6.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) // Node not found in ADF document.
            return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Step 2: If the node has expand parents, we need to expand them first.
            if (expandParentLocalIds.length > 0) {
                // Find the expand elements in the DOM using their localIds.
                // Note: We need to expand from outermost to innermost.
                let allExpandsFound = true;
                let anyExpandsCollapsed = false;
                for (const expandLocalId of expandParentLocalIds){
                    const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                    if (!expandContainer) {
                        // Expand not found in DOM yet (shouldn't happen but handle it).
                        allExpandsFound = false;
                        break;
                    }
                    // Check if this expand is collapsed.
                    if ((0, $1yuNq.isExpandCollapsed)(expandContainer)) {
                        anyExpandsCollapsed = true;
                        // Expand it.
                        (0, $9NsdY.expandElement)(expandContainer);
                        // After expanding, we need to retry to handle nested expands.
                        // The DOM needs time to update.
                        return false; // Will retry after interval.
                    }
                }
                if (!allExpandsFound) // Retry later when expands are in DOM.
                return false;
                // All parent expands are now open (or we just expanded one and need to wait).
                if (anyExpandsCollapsed) // Just expanded something, wait for DOM update.
                return false;
            }
            // Step 3: Now the target element should be visible in the DOM, find it and scroll.
            const element = (0, $Ne8A9.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) // Element still not in DOM, retry.
            return false;
            // Element found and all parent expands are open! Use the utility to scroll.
            // (This will handle any final edge cases and do the actual scrolling).
            // Capture cleanup function to cancel pending timeouts.
            if ((0, $3H4LK.fg)('platform_editor_block_menu_v2_patch_4')) cancelExpandAndScroll = (0, $g2kC6.expandAllParentsThenScroll)(element, 0, (el)=>{
                if (scrollToBlock) scrollToBlock(el);
                else el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
            else cancelExpandAndScroll = (0, $g2kC6.expandAllParentsThenScroll)(element);
            return true;
        };
        const performScroll = ()=>{
            if (hasScrolled) return;
            // Try to scroll to element.
            if (scrollToElement()) {
                hasScrolled = true;
                cleanup();
            }
        };
        const attemptScroll = ()=>{
            retryCount++;
            // Try to find the element first.
            if (!adfDoc || !(containerRef !== null && containerRef !== void 0 && containerRef.current)) return false;
            const nodeWithExpandParents = (0, $g2kC6.findNodeWithExpandParents)(adfDoc, blockId);
            if (!nodeWithExpandParents) return false;
            const { expandParentLocalIds: expandParentLocalIds } = nodeWithExpandParents;
            // Check if all expands are expanded and element exists.
            let allReady = true;
            if (expandParentLocalIds.length > 0) for (const expandLocalId of expandParentLocalIds){
                const expandContainer = containerRef.current.querySelector(`[data-local-id="${expandLocalId}"]`);
                if (!expandContainer) {
                    allReady = false;
                    break;
                }
                if ((0, $1yuNq.isExpandCollapsed)(expandContainer)) {
                    (0, $9NsdY.expandElement)(expandContainer);
                    allReady = false;
                    break;
                }
            }
            const element = (0, $Ne8A9.getLocalIdSelector)(blockId, containerRef.current);
            if (!element) allReady = false;
            // If everything is ready, start monitoring for stability.
            if (allReady) {
                if (intervalId) {
                    clearInterval(intervalId);
                    intervalId = null;
                }
                waitForStability(containerRef.current, performScroll);
                return true;
            }
            // Stop retrying if we've exceeded max retries.
            if (retryCount >= maxRetries) {
                cleanup();
                return false;
            }
            return false;
        };
        const cleanup = ()=>{
            if (intervalId) {
                clearInterval(intervalId);
                intervalId = null;
            }
            cleanupStability();
            // Cancel any pending expand and scroll operations.
            if (cancelExpandAndScroll) {
                cancelExpandAndScroll();
                cancelExpandAndScroll = null;
            }
        };
        // Try to scroll immediately.
        if (attemptScroll()) return cleanup;
        if (((_getDocument = (0, $564zZ.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.readyState) === 'complete') // Document is already ready, try a few more times with delays.
        // This handles cases where elements are added after document ready.
        intervalId = setInterval(()=>{
            attemptScroll();
        }, retryInterval);
        else // Document not ready yet, wait for it and then retry.
        intervalId = setInterval(()=>{
            var _getDocument2;
            if (((_getDocument2 = (0, $564zZ.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.readyState) === 'complete') attemptScroll();
            else if (retryCount >= maxRetries) cleanup();
            else retryCount++;
        }, retryInterval);
        // Cleanup function.
        return cleanup;
    // Intentionally not including adfDoc in the dependency array to avoid unnecessary re-renders.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        containerRef,
        waitForStability,
        cleanupStability,
        scrollToBlock
    ]);
};

});
parcelRegister("7lGDA", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_BLOCK_LINK_HASH_PREFIX", () => $806db990f9c3391f$export$18a71eb9fe4307bc);
$parcel$export(module.exports, "createBlockLinkHashValue", () => $806db990f9c3391f$export$7d28ccc9eddf2197);
const $806db990f9c3391f$export$18a71eb9fe4307bc = 'block-';
const $806db990f9c3391f$export$d7e471f6502a69e2 = (hash, prefix = $806db990f9c3391f$export$18a71eb9fe4307bc)=>{
    if (!hash || !prefix) return false;
    // Match either UUID format (8-4-4-4-12) or short hex ID format (exactly 12 hex chars without dashes).
    // Ignored via go/ees019
    const uuidRegex = new RegExp(`^#?${prefix}[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$`, 'iu');
    // Ignored via go/ees019
    const shortIdRegex = new RegExp(`^#?${prefix}[0-9a-f]{12}$`, 'iu');
    return uuidRegex.test(hash) || shortIdRegex.test(hash);
};
const $806db990f9c3391f$export$c95c8d5e0fd74b32 = (hash, prefix = $806db990f9c3391f$export$18a71eb9fe4307bc)=>{
    if (!$806db990f9c3391f$export$d7e471f6502a69e2(hash, prefix)) return null;
    // Remove leading # if present, then remove the prefix.
    const normalized = hash.startsWith('#') ? hash.slice(1) : hash;
    return normalized.slice(prefix.length);
};
const $806db990f9c3391f$export$7d28ccc9eddf2197 = (blockId, prefix = $806db990f9c3391f$export$18a71eb9fe4307bc)=>{
    return `${prefix}${blockId}`;
};

});

parcelRegister("g2kC6", function(module, exports) {
$parcel$export(module.exports, "findNodeWithExpandParents", () => $9d8c74d0833fc8a7$export$e070f925e0e65bbc);
$parcel$export(module.exports, "expandAllParentsThenScroll", () => $9d8c74d0833fc8a7$export$9d8f3695c9ce7da0);
/**
 * Shared utilities for scrolling to block elements with expand node support.
 * Used by both Confluence's useScrollOnUrlChange and platform renderer's useScrollToBlock.
 */ 
var $9NsdY = parcelRequire("9NsdY");

var $1yuNq = parcelRequire("1yuNq");

var $gR9dj = parcelRequire("gR9dj");

function $9d8c74d0833fc8a7$export$e070f925e0e65bbc(adfDoc, targetLocalId) {
    let result;
    /**
   * Recursive helper to traverse the ADF document and track expand ancestors.
   * We use recursion to properly maintain the expand ancestor stack.
   */ const traverse = (node, expandAncestors)=>{
        var _node$attrs, _node$attrs2;
        // If we already found the target, stop traversing
        if (result) return false;
        // Check if this is the target node by localId
        if ((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) === targetLocalId) {
            result = {
                expandParentLocalIds: [
                    ...expandAncestors
                ] // Copy the array
            };
            return false; // Stop traversing
        }
        // Check if this node is an expand or nestedExpand
        const isExpand = (node === null || node === void 0 ? void 0 : node.type) === 'expand' || (node === null || node === void 0 ? void 0 : node.type) === 'nestedExpand';
        const newExpandAncestors = isExpand && node !== null && node !== void 0 && (_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.localId ? [
            ...expandAncestors,
            node.attrs.localId
        ] : expandAncestors;
        // Traverse children if they exist
        if (node !== null && node !== void 0 && node.content && Array.isArray(node.content)) for (const child of node.content){
            if (result || !child) break;
            traverse(child, newExpandAncestors);
        }
        return !result; // Continue if we haven't found it yet
    };
    // Start traversal from the root
    traverse(adfDoc, []);
    return result;
}
const $9d8c74d0833fc8a7$export$4fc3b03d60a46096 = (element, maxDepth = (0, $gR9dj.SCROLL_TO_BLOCK_TIMING).MAX_EXPAND_DEPTH)=>{
    const expands = [];
    let currentElement = element;
    let depth = 0;
    while(currentElement && depth < maxDepth){
        // Look for expand container - handles both "expand" and "nestedExpand" types
        const expandContainer = currentElement.closest('[data-node-type="expand"], [data-node-type="nestedExpand"]');
        if (!expandContainer || expands.includes(expandContainer)) break;
        expands.push(expandContainer);
        currentElement = expandContainer.parentElement;
        depth++;
    }
    // Return in reverse order so we expand from outermost to innermost
    return expands.reverse();
};
const $9d8c74d0833fc8a7$export$9d8f3695c9ce7da0 = (element, attempt = 0, scrollFn)=>{
    const { MAX_EXPAND_DEPTH: MAX_EXPAND_DEPTH, MAX_ATTEMPTS: MAX_ATTEMPTS, DOM_UPDATE_DELAY: DOM_UPDATE_DELAY, RETRY_DELAY: RETRY_DELAY } = (0, $gR9dj.SCROLL_TO_BLOCK_TIMING);
    const doScroll = scrollFn ?? ((el)=>el.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        }));
    // Store timeout ID and nested cleanup function so they can be cancelled.
    let timeoutId = null;
    let nestedCleanup = null;
    // Cleanup function that cancels pending timeout and any nested operations.
    const cleanup = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
        if (nestedCleanup) {
            nestedCleanup();
            nestedCleanup = null;
        }
    };
    // Guard against element being disconnected from DOM or exceeding max attempts.
    if (attempt >= MAX_ATTEMPTS || !element.isConnected) {
        // Max attempts reached or element disconnected, scroll anyway.
        if (element.isConnected) doScroll(element);
        return cleanup;
    }
    try {
        // Step 1: Find all parent expands (outermost to innermost).
        const parentExpands = $9d8c74d0833fc8a7$export$4fc3b03d60a46096(element, MAX_EXPAND_DEPTH);
        // Step 2: Find any collapsed expands (filter out disconnected elements).
        const collapsedExpands = parentExpands.filter((expandContainer)=>expandContainer.isConnected && (0, $1yuNq.isExpandCollapsed)(expandContainer));
        if (collapsedExpands.length === 0) {
            // All expands are open (or there are no expands), scroll to element.
            doScroll(element);
            return cleanup;
        }
        // Step 3: Expand ONLY the outermost collapsed expand first.
        // This is critical for nested expands - we must expand parent before child.
        const outermostCollapsed = collapsedExpands[0];
        try {
            const expanded = (0, $9NsdY.expandElement)(outermostCollapsed);
            if (expanded) // Successfully expanded, wait briefly for DOM update then recurse to handle any nested expands.
            // Note: There's no animation, but we need a minimal delay for DOM/React updates.
            timeoutId = setTimeout(()=>{
                try {
                    // Verify element is still connected before proceeding.
                    if (!element.isConnected) return;
                    // Recurse to handle any nested collapsed expands or retry if still collapsed.
                    nestedCleanup = $9d8c74d0833fc8a7$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
                } catch  {
                    // Fallback to simple scroll on error.
                    if (element.isConnected) doScroll(element);
                }
            }, DOM_UPDATE_DELAY);
            else // Failed to expand, retry with longer delay.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $9d8c74d0833fc8a7$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        } catch  {
            // Retry on error.
            timeoutId = setTimeout(()=>{
                if (element.isConnected) nestedCleanup = $9d8c74d0833fc8a7$export$9d8f3695c9ce7da0(element, attempt + 1, scrollFn);
            }, RETRY_DELAY);
        }
    } catch  {
        // Fallback to simple scroll on error.
        if (element.isConnected) doScroll(element);
    }
    return cleanup;
};

});
parcelRegister("9NsdY", function(module, exports) {
$parcel$export(module.exports, "expandElement", () => $760135387ecf6e9f$export$280ec17414a50cdd);
/**
 * Expand a collapsed expand node by clicking its toggle button.
 *
 * This function finds the toggle button with aria-expanded="false" and programmatically
 * clicks it to expand the node. It does not wait for the expansion to complete.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the toggle button was found and clicked, false otherwise.
 */ const $760135387ecf6e9f$export$280ec17414a50cdd = (expandContainer)=>{
    // Find and click the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded="false"]');
    if (toggleButton && toggleButton instanceof HTMLElement) {
        toggleButton.click();
        return true;
    }
    return false;
};

});

parcelRegister("1yuNq", function(module, exports) {
$parcel$export(module.exports, "isExpandCollapsed", () => $3d5778aeb3f309da$export$785b8bfd794fa7b6);
/**
 * Check if an expand node is currently collapsed.
 *
 * Uses two methods to determine collapse state:
 * 1. First checks aria-expanded attribute on the toggle button (most reliable).
 * 2. Falls back to checking content div visibility via computed styles.
 *
 * @param expandContainer - The expand container element.
 * @returns True if the expand is collapsed, false if expanded or state cannot be determined.
 */ const $3d5778aeb3f309da$export$785b8bfd794fa7b6 = (expandContainer)=>{
    // Check for aria-expanded attribute on the toggle button
    const toggleButton = expandContainer.querySelector('[aria-expanded]');
    if (toggleButton && toggleButton instanceof HTMLElement) return toggleButton.getAttribute('aria-expanded') === 'false';
    // Fallback: check if content div is hidden using the actual class name
    const contentDiv = expandContainer.querySelector('.ak-editor-expand__content');
    if (contentDiv && contentDiv instanceof HTMLElement) {
        const computedStyle = window.getComputedStyle(contentDiv);
        return computedStyle.display === 'none' || computedStyle.visibility === 'hidden' || contentDiv.hidden;
    }
    return false;
};

});

parcelRegister("gR9dj", function(module, exports) {
$parcel$export(module.exports, "SCROLL_TO_BLOCK_TIMING", () => $e2b27e14f6c0a7e9$export$7f8747c9df4cadcb);
/**
 * Timing constants for expand animation and DOM update delays.
 * These values are tuned for the expand component's behavior and React's update cycle.
 */ const $e2b27e14f6c0a7e9$export$7f8747c9df4cadcb = {
    /** Minimal delay for DOM/React updates after expanding (no animation in expand component). */ DOM_UPDATE_DELAY: 50,
    /** Delay when expand operation fails and needs retry. */ RETRY_DELAY: 100,
    /** Maximum number of retry attempts before giving up and scrolling anyway. */ MAX_ATTEMPTS: 5,
    /** Maximum depth of nested expands to search (prevents infinite loops). */ MAX_EXPAND_DEPTH: 2
};

});


parcelRegister("Ne8A9", function(module, exports) {
$parcel$export(module.exports, "getLocalIdSelector", () => $16fdf189108fda65$export$94a68fcf7c5634d2);

var $3H4LK = parcelRequire("3H4LK");
const $16fdf189108fda65$export$94a68fcf7c5634d2 = (localId, container)=>{
    // Check if the element with data-local-id exists
    let element = container.querySelector(`[data-local-id="${localId}"]`);
    if (element) return element;
    // Special case for decision lists and task lists which already have localId
    element = container.querySelector(`[data-decision-list-local-id="${localId}"]`);
    if (element) return element;
    element = container.querySelector(`[data-task-list-local-id="${localId}"]`);
    if (element) return element;
    // Special case for tables which use data-table-local-id
    element = container.querySelector(`[data-table-local-id="${localId}"]`);
    if (element) {
        if ((0, $3H4LK.fg)('platform_editor_block_menu_v2_patch_4')) return element.parentElement; // return table wrapper instead of table div, so the height calculation is correct
        return element;
    }
    // Special case for extension, smart cards and media which use lowercase localid
    element = container.querySelector(`[localid="${localId}"]`);
    if (element) return element;
    return null;
};

});

parcelRegister("hLSAE", function(module, exports) {
$parcel$export(module.exports, "useStableScroll", () => $4f23f536942d9c89$export$3325eba9424d3c32);

var $4fqPo = parcelRequire("4fqPo");
const $4f23f536942d9c89$export$3325eba9424d3c32 = (options = {})=>{
    const { stabilityWaitTime: stabilityWaitTime = 200, maxStabilityWaitTime: maxStabilityWaitTime = 10000 } = options;
    const stabilityTimeoutRef = (0, $4fqPo.useRef)(null);
    const resizeObserverRef = (0, $4fqPo.useRef)(null);
    const lastStableTimeRef = (0, $4fqPo.useRef)(0);
    const onStableCallbackRef = (0, $4fqPo.useRef)(null);
    const cleanup = (0, $4fqPo.useCallback)(()=>{
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        if (resizeObserverRef.current) {
            resizeObserverRef.current.disconnect();
            resizeObserverRef.current = null;
        }
        onStableCallbackRef.current = null;
        lastStableTimeRef.current = 0;
    }, []);
    const scheduleStabilityCheck = (0, $4fqPo.useCallback)(()=>{
        // Clear any existing stability timeout.
        if (stabilityTimeoutRef.current) {
            clearTimeout(stabilityTimeoutRef.current);
            stabilityTimeoutRef.current = null;
        }
        // Check if we've exceeded the maximum stability wait time.
        const now = Date.now();
        if (lastStableTimeRef.current === 0) lastStableTimeRef.current = now;
        else if (now - lastStableTimeRef.current > maxStabilityWaitTime) {
            // We've waited too long for stability, call the callback now.
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
            return;
        }
        // Set a timeout to call the callback after the stability wait time.
        stabilityTimeoutRef.current = setTimeout(()=>{
            if (onStableCallbackRef.current) {
                onStableCallbackRef.current();
                cleanup();
            }
        }, stabilityWaitTime);
    }, [
        stabilityWaitTime,
        maxStabilityWaitTime,
        cleanup
    ]);
    const waitForStability = (0, $4fqPo.useCallback)((container, onStable)=>{
        // Clean up any existing observer
        cleanup();
        // Store the callback
        onStableCallbackRef.current = onStable;
        // Check if ResizeObserver is available
        if (typeof ResizeObserver === 'undefined') {
            // Fallback: just call the callback after the stability wait time
            stabilityTimeoutRef.current = setTimeout(()=>{
                if (onStableCallbackRef.current) {
                    onStableCallbackRef.current();
                    cleanup();
                }
            }, stabilityWaitTime);
            return;
        }
        // Create a ResizeObserver to monitor the container for size changes.
        resizeObserverRef.current = new ResizeObserver(()=>{
            // Container size changed, reset stability timer.
            scheduleStabilityCheck();
        });
        resizeObserverRef.current.observe(container);
        // Start the initial stability check
        scheduleStabilityCheck();
    }, [
        stabilityWaitTime,
        scheduleStabilityCheck,
        cleanup
    ]);
    return {
        waitForStability: waitForStability,
        cleanup: cleanup
    };
};

});


parcelRegister("jzosZ", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsAppearance", () => $9403e32d8dc8f315$export$be87849653b93e6b);

var $dQ0Pl = parcelRequire("dQ0Pl");
const $9403e32d8dc8f315$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $dQ0Pl.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $dQ0Pl.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $dQ0Pl.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $dQ0Pl.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $dQ0Pl.EDITOR_APPEARANCE_CONTEXT).MOBILE;
        case 'max':
            return (0, $dQ0Pl.EDITOR_APPEARANCE_CONTEXT).MAX;
    }
};

});

parcelRegister("aheLh", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $53463545a8b30022$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $53463545a8b30022$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "analyticsEventKey", () => $53463545a8b30022$export$288273ee3e3b6132);
$parcel$export(module.exports, "getBreakpointKey", () => $53463545a8b30022$export$afdcbbd112676ca8);
$parcel$export(module.exports, "getAnalyticsAppearance", () => (parcelRequire("jzosZ")).getAnalyticsAppearance);

var $jzosZ = parcelRequire("jzosZ");

var $lrcc4 = parcelRequire("lrcc4");

var $iqXpe = parcelRequire("iqXpe");
const $53463545a8b30022$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${(0, $jzosZ.getAnalyticsAppearance)(editorAppearance)}` : '_unknown';
const $53463545a8b30022$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return (0, $lrcc4.SEVERITY).DEGRADED;
    if (duration > degradedThreshold) return (0, $lrcc4.SEVERITY).BLOCKING;
    return (0, $lrcc4.SEVERITY).NORMAL;
};
const $53463545a8b30022$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';
const $53463545a8b30022$var$EDITOR_BREAKPOINT_WIDTH = {
    S: 760,
    M: 1600,
    L: Infinity
};
const $53463545a8b30022$var$TABLE_BREAKPOINT_KEYS = Object.keys($53463545a8b30022$var$EDITOR_BREAKPOINT_WIDTH);
const $53463545a8b30022$export$afdcbbd112676ca8 = (width)=>{
    return $53463545a8b30022$var$TABLE_BREAKPOINT_KEYS.find((key)=>width <= $53463545a8b30022$var$EDITOR_BREAKPOINT_WIDTH[key]) || 'L';
};

});
parcelRegister("lrcc4", function(module, exports) {
$parcel$export(module.exports, "SEVERITY", () => $86b4118feb3bc7ef$export$6a6bef12562cd865);
var $86b4118feb3bc7ef$export$6a6bef12562cd865 = /*#__PURE__*/ function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
    return SEVERITY;
}({});

});

parcelRegister("iqXpe", function(module, exports) {
$parcel$export(module.exports, "findInsertLocation", () => $337801536ed90bd1$export$d770b562ead089d8);

var $b0juN = parcelRequire("b0juN");

var $f4roI = parcelRequire("f4roI");

var $8s2GQ = parcelRequire("8s2GQ");
function $337801536ed90bd1$export$d770b562ead089d8(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    if (selection instanceof (0, $b0juN.NodeSelection)) return selection.node.type.name;
    if (selection instanceof (0, $8s2GQ.CellSelection)) return schema.nodes.table.name;
    // Text selection
    const parentNodeInfo = (0, $f4roI.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}

});
parcelRegister("b0juN", function(module, exports) {
$parcel$export(module.exports, "Selection", () => $802ed1406d91ee56$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $802ed1406d91ee56$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $802ed1406d91ee56$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $802ed1406d91ee56$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $802ed1406d91ee56$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $802ed1406d91ee56$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $802ed1406d91ee56$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $802ed1406d91ee56$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $802ed1406d91ee56$export$1692d8b0e89cecc3);

var $7p5u4 = parcelRequire("7p5u4");

var $2fkcs = parcelRequire("2fkcs");
const $802ed1406d91ee56$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $802ed1406d91ee56$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $802ed1406d91ee56$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7p5u4.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7p5u4.Slice).empty : content);
            if (i == 0) $802ed1406d91ee56$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $802ed1406d91ee56$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $802ed1406d91ee56$export$c2b25f346d19bcbb($pos) : $802ed1406d91ee56$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $802ed1406d91ee56$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $802ed1406d91ee56$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $802ed1406d91ee56$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $802ed1406d91ee56$var$findSelectionIn(doc, doc, 0, 0, 1) || new $802ed1406d91ee56$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $802ed1406d91ee56$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $802ed1406d91ee56$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $802ed1406d91ee56$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $802ed1406d91ee56$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $802ed1406d91ee56$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $802ed1406d91ee56$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$802ed1406d91ee56$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $802ed1406d91ee56$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $802ed1406d91ee56$var$warnedAboutTextSelection = false;
function $802ed1406d91ee56$var$checkTextSelection($pos) {
    if (!$802ed1406d91ee56$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $802ed1406d91ee56$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $802ed1406d91ee56$export$c2b25f346d19bcbb extends $802ed1406d91ee56$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $802ed1406d91ee56$var$checkTextSelection($anchor);
        $802ed1406d91ee56$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $802ed1406d91ee56$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $802ed1406d91ee56$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7p5u4.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7p5u4.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $802ed1406d91ee56$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $802ed1406d91ee56$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $802ed1406d91ee56$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $802ed1406d91ee56$export$52baac22726c72bf.findFrom($head, bias, true) || $802ed1406d91ee56$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $802ed1406d91ee56$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($802ed1406d91ee56$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $802ed1406d91ee56$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $802ed1406d91ee56$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$802ed1406d91ee56$export$52baac22726c72bf.jsonID("text", $802ed1406d91ee56$export$c2b25f346d19bcbb);
class $802ed1406d91ee56$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $802ed1406d91ee56$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $802ed1406d91ee56$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $802ed1406d91ee56$export$e2940151ac854c0b extends $802ed1406d91ee56$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $802ed1406d91ee56$export$52baac22726c72bf.near($pos);
        return new $802ed1406d91ee56$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $802ed1406d91ee56$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $802ed1406d91ee56$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $802ed1406d91ee56$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $802ed1406d91ee56$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$802ed1406d91ee56$export$e2940151ac854c0b.prototype.visible = false;
$802ed1406d91ee56$export$52baac22726c72bf.jsonID("node", $802ed1406d91ee56$export$e2940151ac854c0b);
class $802ed1406d91ee56$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $802ed1406d91ee56$var$TextBookmark(pos, pos) : new $802ed1406d91ee56$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $802ed1406d91ee56$export$e2940151ac854c0b.isSelectable(node)) return new $802ed1406d91ee56$export$e2940151ac854c0b($pos);
        return $802ed1406d91ee56$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $802ed1406d91ee56$export$c15d9ba76bdbcd95 extends $802ed1406d91ee56$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7p5u4.Slice).empty) {
        if (content == (0, $7p5u4.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $802ed1406d91ee56$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $802ed1406d91ee56$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $802ed1406d91ee56$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $802ed1406d91ee56$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $802ed1406d91ee56$var$AllBookmark;
    }
}
$802ed1406d91ee56$export$52baac22726c72bf.jsonID("all", $802ed1406d91ee56$export$c15d9ba76bdbcd95);
const $802ed1406d91ee56$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $802ed1406d91ee56$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $802ed1406d91ee56$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $802ed1406d91ee56$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $802ed1406d91ee56$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $802ed1406d91ee56$export$e2940151ac854c0b.isSelectable(child)) return $802ed1406d91ee56$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $802ed1406d91ee56$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $2fkcs.ReplaceStep) || step instanceof (0, $2fkcs.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($802ed1406d91ee56$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $802ed1406d91ee56$var$UPDATED_SEL = 1, $802ed1406d91ee56$var$UPDATED_MARKS = 2, $802ed1406d91ee56$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $802ed1406d91ee56$export$febc5573c75cefb0 extends (0, $2fkcs.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $802ed1406d91ee56$var$UPDATED_SEL) & ~$802ed1406d91ee56$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $802ed1406d91ee56$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $802ed1406d91ee56$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7p5u4.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $802ed1406d91ee56$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$802ed1406d91ee56$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7p5u4.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($802ed1406d91ee56$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $802ed1406d91ee56$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $802ed1406d91ee56$var$UPDATED_SCROLL) > 0;
    }
}
function $802ed1406d91ee56$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $802ed1406d91ee56$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $802ed1406d91ee56$var$bind(desc.init, self);
        this.apply = $802ed1406d91ee56$var$bind(desc.apply, self);
    }
}
const $802ed1406d91ee56$var$baseFields = [
    new $802ed1406d91ee56$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $802ed1406d91ee56$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $802ed1406d91ee56$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $802ed1406d91ee56$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $802ed1406d91ee56$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $802ed1406d91ee56$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $802ed1406d91ee56$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $802ed1406d91ee56$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $802ed1406d91ee56$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $802ed1406d91ee56$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $802ed1406d91ee56$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $802ed1406d91ee56$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $802ed1406d91ee56$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $802ed1406d91ee56$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $802ed1406d91ee56$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $802ed1406d91ee56$var$Configuration(config.schema, config.plugins);
        let instance = new $802ed1406d91ee56$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7p5u4.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $802ed1406d91ee56$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $802ed1406d91ee56$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $802ed1406d91ee56$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $802ed1406d91ee56$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $802ed1406d91ee56$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $802ed1406d91ee56$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $802ed1406d91ee56$var$keys = Object.create(null);
function $802ed1406d91ee56$var$createKey(name) {
    if (name in $802ed1406d91ee56$var$keys) return name + "$" + ++$802ed1406d91ee56$var$keys[name];
    $802ed1406d91ee56$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $802ed1406d91ee56$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $802ed1406d91ee56$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("2fkcs", function(module, exports) {
$parcel$export(module.exports, "StepMap", () => $1a2ca6c1673c16f0$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $1a2ca6c1673c16f0$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $1a2ca6c1673c16f0$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $1a2ca6c1673c16f0$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $1a2ca6c1673c16f0$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $1a2ca6c1673c16f0$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $1a2ca6c1673c16f0$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $1a2ca6c1673c16f0$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $1a2ca6c1673c16f0$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $1a2ca6c1673c16f0$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $1a2ca6c1673c16f0$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $1a2ca6c1673c16f0$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $1a2ca6c1673c16f0$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $1a2ca6c1673c16f0$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $1a2ca6c1673c16f0$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $1a2ca6c1673c16f0$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $1a2ca6c1673c16f0$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $1a2ca6c1673c16f0$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $1a2ca6c1673c16f0$export$626399c38172f669);
$parcel$export(module.exports, "DocAttrStep", () => $1a2ca6c1673c16f0$export$f50707b396300ac9);
$parcel$export(module.exports, "Transform", () => $1a2ca6c1673c16f0$export$563a914cafbdc389);

var $7p5u4 = parcelRequire("7p5u4");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $1a2ca6c1673c16f0$var$lower16 = 0xffff;
const $1a2ca6c1673c16f0$var$factor16 = Math.pow(2, 16);
function $1a2ca6c1673c16f0$var$makeRecover(index, offset) {
    return index + offset * $1a2ca6c1673c16f0$var$factor16;
}
function $1a2ca6c1673c16f0$var$recoverIndex(value) {
    return value & $1a2ca6c1673c16f0$var$lower16;
}
function $1a2ca6c1673c16f0$var$recoverOffset(value) {
    return (value - (value & $1a2ca6c1673c16f0$var$lower16)) / $1a2ca6c1673c16f0$var$factor16;
}
const $1a2ca6c1673c16f0$var$DEL_BEFORE = 1, $1a2ca6c1673c16f0$var$DEL_AFTER = 2, $1a2ca6c1673c16f0$var$DEL_ACROSS = 4, $1a2ca6c1673c16f0$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $1a2ca6c1673c16f0$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $1a2ca6c1673c16f0$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($1a2ca6c1673c16f0$var$DEL_BEFORE | $1a2ca6c1673c16f0$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($1a2ca6c1673c16f0$var$DEL_AFTER | $1a2ca6c1673c16f0$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $1a2ca6c1673c16f0$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $1a2ca6c1673c16f0$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty) return $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $1a2ca6c1673c16f0$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $1a2ca6c1673c16f0$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $1a2ca6c1673c16f0$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $1a2ca6c1673c16f0$var$DEL_AFTER : pos == end ? $1a2ca6c1673c16f0$var$DEL_BEFORE : $1a2ca6c1673c16f0$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $1a2ca6c1673c16f0$var$DEL_SIDE;
                return new $1a2ca6c1673c16f0$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $1a2ca6c1673c16f0$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $1a2ca6c1673c16f0$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $1a2ca6c1673c16f0$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty : new $1a2ca6c1673c16f0$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty = new $1a2ca6c1673c16f0$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $1a2ca6c1673c16f0$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $1a2ca6c1673c16f0$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $1a2ca6c1673c16f0$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $1a2ca6c1673c16f0$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $1a2ca6c1673c16f0$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $1a2ca6c1673c16f0$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $1a2ca6c1673c16f0$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $1a2ca6c1673c16f0$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $1a2ca6c1673c16f0$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $1a2ca6c1673c16f0$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $1a2ca6c1673c16f0$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $1a2ca6c1673c16f0$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7p5u4.ReplaceError)) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $1a2ca6c1673c16f0$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($1a2ca6c1673c16f0$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7p5u4.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $1a2ca6c1673c16f0$export$d24ba56b0e3464a9 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $1a2ca6c1673c16f0$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $1a2ca6c1673c16f0$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $1a2ca6c1673c16f0$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $1a2ca6c1673c16f0$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("addMark", $1a2ca6c1673c16f0$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $1a2ca6c1673c16f0$export$94150db1311f67a9 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $1a2ca6c1673c16f0$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $1a2ca6c1673c16f0$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $1a2ca6c1673c16f0$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $1a2ca6c1673c16f0$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("removeMark", $1a2ca6c1673c16f0$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $1a2ca6c1673c16f0$export$adefd16c402fee4e extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $1a2ca6c1673c16f0$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $1a2ca6c1673c16f0$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $1a2ca6c1673c16f0$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $1a2ca6c1673c16f0$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("addNodeMark", $1a2ca6c1673c16f0$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $1a2ca6c1673c16f0$export$fdf7d1dc10724da2 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $1a2ca6c1673c16f0$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $1a2ca6c1673c16f0$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("removeNodeMark", $1a2ca6c1673c16f0$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $1a2ca6c1673c16f0$export$5c860b2e74034756 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $1a2ca6c1673c16f0$var$contentBetween(doc, this.from, this.to)) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $1a2ca6c1673c16f0$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $1a2ca6c1673c16f0$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $1a2ca6c1673c16f0$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $1a2ca6c1673c16f0$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7p5u4.Slice).empty : new (0, $7p5u4.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $1a2ca6c1673c16f0$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7p5u4.Slice).empty : new (0, $7p5u4.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $1a2ca6c1673c16f0$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$5c860b2e74034756(json.from, json.to, (0, $7p5u4.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("replace", $1a2ca6c1673c16f0$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $1a2ca6c1673c16f0$export$444ba800d6024a98 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($1a2ca6c1673c16f0$var$contentBetween(doc, this.from, this.gapFrom) || $1a2ca6c1673c16f0$var$contentBetween(doc, this.gapTo, this.to))) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $1a2ca6c1673c16f0$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $1a2ca6c1673c16f0$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $1a2ca6c1673c16f0$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7p5u4.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("replaceAround", $1a2ca6c1673c16f0$export$444ba800d6024a98);
function $1a2ca6c1673c16f0$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $1a2ca6c1673c16f0$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $1a2ca6c1673c16f0$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $1a2ca6c1673c16f0$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $1a2ca6c1673c16f0$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7p5u4.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $1a2ca6c1673c16f0$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $1a2ca6c1673c16f0$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $1a2ca6c1673c16f0$export$5c860b2e74034756(cur, end, (0, $7p5u4.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $1a2ca6c1673c16f0$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $1a2ca6c1673c16f0$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7p5u4.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7p5u4.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $1a2ca6c1673c16f0$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $1a2ca6c1673c16f0$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$1a2ca6c1673c16f0$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $1a2ca6c1673c16f0$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7p5u4.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7p5u4.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7p5u4.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7p5u4.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $1a2ca6c1673c16f0$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7p5u4.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $1a2ca6c1673c16f0$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $1a2ca6c1673c16f0$var$findWrappingOutside(range, nodeType);
    let inner = around && $1a2ca6c1673c16f0$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($1a2ca6c1673c16f0$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($1a2ca6c1673c16f0$var$withAttrs));
}
function $1a2ca6c1673c16f0$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $1a2ca6c1673c16f0$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $1a2ca6c1673c16f0$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $1a2ca6c1673c16f0$var$wrap(tr, range, wrappers) {
    let content = (0, $7p5u4.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7p5u4.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $1a2ca6c1673c16f0$export$444ba800d6024a98(start, end, start, end, new (0, $7p5u4.Slice)(content, 0, 0), wrappers.length, true));
}
function $1a2ca6c1673c16f0$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $1a2ca6c1673c16f0$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $1a2ca6c1673c16f0$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $1a2ca6c1673c16f0$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $1a2ca6c1673c16f0$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $1a2ca6c1673c16f0$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $1a2ca6c1673c16f0$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $1a2ca6c1673c16f0$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $1a2ca6c1673c16f0$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $1a2ca6c1673c16f0$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $1a2ca6c1673c16f0$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $1a2ca6c1673c16f0$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $1a2ca6c1673c16f0$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7p5u4.Fragment).empty, after = (0, $7p5u4.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7p5u4.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7p5u4.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $1a2ca6c1673c16f0$export$5c860b2e74034756(pos, pos, new (0, $7p5u4.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $1a2ca6c1673c16f0$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $1a2ca6c1673c16f0$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $1a2ca6c1673c16f0$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $1a2ca6c1673c16f0$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $1a2ca6c1673c16f0$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $1a2ca6c1673c16f0$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $1a2ca6c1673c16f0$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $1a2ca6c1673c16f0$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $1a2ca6c1673c16f0$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $1a2ca6c1673c16f0$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $1a2ca6c1673c16f0$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $7p5u4.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $1a2ca6c1673c16f0$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $1a2ca6c1673c16f0$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $1a2ca6c1673c16f0$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $1a2ca6c1673c16f0$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7p5u4.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($1a2ca6c1673c16f0$var$fitsTrivially($from, $to, slice)) return new $1a2ca6c1673c16f0$export$5c860b2e74034756(from, to, slice);
    return new $1a2ca6c1673c16f0$var$Fitter($from, $to, slice).fit();
}
function $1a2ca6c1673c16f0$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $1a2ca6c1673c16f0$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7p5u4.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7p5u4.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7p5u4.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $1a2ca6c1673c16f0$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $1a2ca6c1673c16f0$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $1a2ca6c1673c16f0$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7p5u4.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $1a2ca6c1673c16f0$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7p5u4.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $1a2ca6c1673c16f0$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($1a2ca6c1673c16f0$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $1a2ca6c1673c16f0$var$addToFragment(this.placed, frontierDepth, (0, $7p5u4.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7p5u4.Slice).empty : new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$1a2ca6c1673c16f0$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $1a2ca6c1673c16f0$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $1a2ca6c1673c16f0$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $1a2ca6c1673c16f0$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $1a2ca6c1673c16f0$var$addToFragment(this.placed, this.depth, (0, $7p5u4.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7p5u4.Fragment).empty, true);
        if (add.childCount) this.placed = $1a2ca6c1673c16f0$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $1a2ca6c1673c16f0$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($1a2ca6c1673c16f0$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $1a2ca6c1673c16f0$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($1a2ca6c1673c16f0$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $1a2ca6c1673c16f0$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $1a2ca6c1673c16f0$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $1a2ca6c1673c16f0$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7p5u4.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $1a2ca6c1673c16f0$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$1a2ca6c1673c16f0$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $1a2ca6c1673c16f0$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $1a2ca6c1673c16f0$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $1a2ca6c1673c16f0$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($1a2ca6c1673c16f0$var$fitsTrivially($from, $to, slice)) return tr.step(new $1a2ca6c1673c16f0$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $1a2ca6c1673c16f0$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $1a2ca6c1673c16f0$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7p5u4.Slice)($1a2ca6c1673c16f0$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $1a2ca6c1673c16f0$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($1a2ca6c1673c16f0$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7p5u4.Fragment).empty, true));
    }
    return fragment;
}
function $1a2ca6c1673c16f0$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $1a2ca6c1673c16f0$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(node), 0, 0));
}
function $1a2ca6c1673c16f0$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $1a2ca6c1673c16f0$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $1a2ca6c1673c16f0$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $1a2ca6c1673c16f0$export$626399c38172f669 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $1a2ca6c1673c16f0$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $1a2ca6c1673c16f0$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("attr", $1a2ca6c1673c16f0$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $1a2ca6c1673c16f0$export$f50707b396300ac9 extends $1a2ca6c1673c16f0$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $1a2ca6c1673c16f0$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $1a2ca6c1673c16f0$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $1a2ca6c1673c16f0$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $1a2ca6c1673c16f0$export$f50707b396300ac9(json.attr, json.value);
    }
}
$1a2ca6c1673c16f0$export$fd55ce593607084a.jsonID("docAttr", $1a2ca6c1673c16f0$export$f50707b396300ac9);
/**
@internal
*/ let $1a2ca6c1673c16f0$export$88cc3a1dfce48dd3 = class extends Error {
};
$1a2ca6c1673c16f0$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$1a2ca6c1673c16f0$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$1a2ca6c1673c16f0$export$88cc3a1dfce48dd3.prototype.constructor = $1a2ca6c1673c16f0$export$88cc3a1dfce48dd3;
$1a2ca6c1673c16f0$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $1a2ca6c1673c16f0$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $1a2ca6c1673c16f0$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $1a2ca6c1673c16f0$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7p5u4.Slice).empty) {
        let step = $1a2ca6c1673c16f0$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7p5u4.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $1a2ca6c1673c16f0$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $1a2ca6c1673c16f0$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $1a2ca6c1673c16f0$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $1a2ca6c1673c16f0$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $1a2ca6c1673c16f0$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $1a2ca6c1673c16f0$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $1a2ca6c1673c16f0$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $1a2ca6c1673c16f0$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $1a2ca6c1673c16f0$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $1a2ca6c1673c16f0$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $1a2ca6c1673c16f0$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7p5u4.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $1a2ca6c1673c16f0$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $1a2ca6c1673c16f0$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $1a2ca6c1673c16f0$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $1a2ca6c1673c16f0$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $1a2ca6c1673c16f0$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});


parcelRegister("f4roI", function(module, exports) {
$parcel$export(module.exports, "removeParentNodeOfType", () => $af8c7b5b60b5e8ff$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $af8c7b5b60b5e8ff$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $af8c7b5b60b5e8ff$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $af8c7b5b60b5e8ff$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $af8c7b5b60b5e8ff$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $af8c7b5b60b5e8ff$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $af8c7b5b60b5e8ff$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $af8c7b5b60b5e8ff$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $af8c7b5b60b5e8ff$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $af8c7b5b60b5e8ff$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $af8c7b5b60b5e8ff$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $af8c7b5b60b5e8ff$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $af8c7b5b60b5e8ff$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $af8c7b5b60b5e8ff$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $af8c7b5b60b5e8ff$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $af8c7b5b60b5e8ff$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $af8c7b5b60b5e8ff$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $af8c7b5b60b5e8ff$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $af8c7b5b60b5e8ff$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $af8c7b5b60b5e8ff$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $af8c7b5b60b5e8ff$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $af8c7b5b60b5e8ff$export$96bb9476c7c69f39);
$parcel$export(module.exports, "findChildrenByMark", () => $af8c7b5b60b5e8ff$export$c01a9e7ec615e821);
$parcel$export(module.exports, "contains", () => $af8c7b5b60b5e8ff$export$2344b14b097df817);
// src/selection.ts

var $b0juN = parcelRequire("b0juN");

var $7p5u4 = parcelRequire("7p5u4");
var $af8c7b5b60b5e8ff$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $af8c7b5b60b5e8ff$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $af8c7b5b60b5e8ff$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $af8c7b5b60b5e8ff$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $af8c7b5b60b5e8ff$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $af8c7b5b60b5e8ff$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $af8c7b5b60b5e8ff$export$7d6e4e6663186878 = (tr)=>{
    if ($af8c7b5b60b5e8ff$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $af8c7b5b60b5e8ff$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $af8c7b5b60b5e8ff$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($af8c7b5b60b5e8ff$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $7p5u4.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $7p5u4.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $af8c7b5b60b5e8ff$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $b0juN.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $af8c7b5b60b5e8ff$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $b0juN.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $af8c7b5b60b5e8ff$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $7p5u4.Node) && node.type && node.type.spec.selectable);
var $af8c7b5b60b5e8ff$var$shouldSelectNode = (node)=>$af8c7b5b60b5e8ff$var$isSelectableNode(node) && node.type.isLeaf;
var $af8c7b5b60b5e8ff$var$setSelection = (node, pos, tr)=>{
    if ($af8c7b5b60b5e8ff$var$shouldSelectNode(node)) return tr.setSelection(new (0, $b0juN.NodeSelection)(tr.doc.resolve(pos)));
    return $af8c7b5b60b5e8ff$export$1df6d14df6b0b758(pos)(tr);
};
var $af8c7b5b60b5e8ff$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $af8c7b5b60b5e8ff$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($af8c7b5b60b5e8ff$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $af8c7b5b60b5e8ff$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($af8c7b5b60b5e8ff$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $af8c7b5b60b5e8ff$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $af8c7b5b60b5e8ff$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $af8c7b5b60b5e8ff$var$setSelection(content, pos, tr);
            }
        }
        if ($af8c7b5b60b5e8ff$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $af8c7b5b60b5e8ff$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $af8c7b5b60b5e8ff$var$cloneTr($af8c7b5b60b5e8ff$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($af8c7b5b60b5e8ff$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $af8c7b5b60b5e8ff$var$cloneTr($af8c7b5b60b5e8ff$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $af8c7b5b60b5e8ff$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $af8c7b5b60b5e8ff$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $af8c7b5b60b5e8ff$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $af8c7b5b60b5e8ff$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$af8c7b5b60b5e8ff$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $af8c7b5b60b5e8ff$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $af8c7b5b60b5e8ff$var$cloneTr(tr.setSelection((0, $b0juN.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $af8c7b5b60b5e8ff$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $af8c7b5b60b5e8ff$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $af8c7b5b60b5e8ff$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $af8c7b5b60b5e8ff$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $b0juN.NodeSelection);
};
var $af8c7b5b60b5e8ff$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $af8c7b5b60b5e8ff$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $af8c7b5b60b5e8ff$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($af8c7b5b60b5e8ff$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $af8c7b5b60b5e8ff$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $af8c7b5b60b5e8ff$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $af8c7b5b60b5e8ff$var$cloneTr(tr);
        }
        return tr;
    };
var $af8c7b5b60b5e8ff$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $7p5u4.Fragment) ? content : (0, $7p5u4.Fragment).from(content));
};
var $af8c7b5b60b5e8ff$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $af8c7b5b60b5e8ff$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $af8c7b5b60b5e8ff$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $7p5u4.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $7p5u4.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $af8c7b5b60b5e8ff$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $af8c7b5b60b5e8ff$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $af8c7b5b60b5e8ff$export$fe09644e3bc6166b($from, predicate);
    };
var $af8c7b5b60b5e8ff$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $af8c7b5b60b5e8ff$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $af8c7b5b60b5e8ff$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $af8c7b5b60b5e8ff$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $af8c7b5b60b5e8ff$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$af8c7b5b60b5e8ff$export$dc159056ffdb4c76(predicate)(selection);
    };
var $af8c7b5b60b5e8ff$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $af8c7b5b60b5e8ff$export$dc159056ffdb4c76((node)=>$af8c7b5b60b5e8ff$var$equalNodeType(nodeType, node))(selection);
    };
var $af8c7b5b60b5e8ff$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $af8c7b5b60b5e8ff$export$fe09644e3bc6166b($pos, (node)=>$af8c7b5b60b5e8ff$var$equalNodeType(nodeType, node));
};
var $af8c7b5b60b5e8ff$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $af8c7b5b60b5e8ff$export$178ecaf80f45fdb6((node)=>$af8c7b5b60b5e8ff$var$equalNodeType(nodeType, node))(selection);
    };
var $af8c7b5b60b5e8ff$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $af8c7b5b60b5e8ff$export$8556d79fa8189214((node)=>$af8c7b5b60b5e8ff$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $af8c7b5b60b5e8ff$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($af8c7b5b60b5e8ff$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($af8c7b5b60b5e8ff$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $af8c7b5b60b5e8ff$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $b0juN.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $af8c7b5b60b5e8ff$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $af8c7b5b60b5e8ff$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $af8c7b5b60b5e8ff$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $af8c7b5b60b5e8ff$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $af8c7b5b60b5e8ff$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $af8c7b5b60b5e8ff$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $af8c7b5b60b5e8ff$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $af8c7b5b60b5e8ff$export$ddc1620722e25671 = (node, descend = true)=>{
    return $af8c7b5b60b5e8ff$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $af8c7b5b60b5e8ff$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $af8c7b5b60b5e8ff$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $af8c7b5b60b5e8ff$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $af8c7b5b60b5e8ff$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $af8c7b5b60b5e8ff$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $af8c7b5b60b5e8ff$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $af8c7b5b60b5e8ff$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $af8c7b5b60b5e8ff$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $af8c7b5b60b5e8ff$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$af8c7b5b60b5e8ff$export$96bb9476c7c69f39(node, nodeType).length;
};

});

parcelRegister("8s2GQ", function(module, exports) {
$parcel$export(module.exports, "CellSelection", () => $07763fcc531d8c96$export$831cc7e2a83afa94);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $7p5u4 = parcelRequire("7p5u4");

var $b0juN = parcelRequire("b0juN");

var $86VAR = parcelRequire("86VAR");

var $fssdk = parcelRequire("fssdk");

var $cdnhs = parcelRequire("cdnhs");

var $9s8Rt = parcelRequire("9s8Rt");

var $drnJr = parcelRequire("drnJr");

var $g8Dll = parcelRequire("g8Dll");
class $07763fcc531d8c96$export$831cc7e2a83afa94 extends (0, $b0juN.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $drnJr.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $cdnhs.pointsAtCell)($anchorCell) && (0, $cdnhs.pointsAtCell)($headCell) && (0, $g8Dll.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $07763fcc531d8c96$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $07763fcc531d8c96$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $07763fcc531d8c96$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $b0juN.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $fssdk.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $9s8Rt.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        attrs = (0, $9s8Rt.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            const rowNode = table.child(row).copy((0, $7p5u4.Fragment).from(rowContent));
            rows.push(rowNode);
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $7p5u4.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7p5u4.Slice).empty : content);
        }
        const sel = (0, $b0juN.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $7p5u4.Slice)((0, $7p5u4.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $fssdk.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $fssdk.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $07763fcc531d8c96$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $fssdk.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        const maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $07763fcc531d8c96$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell, reverse = false) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $fssdk.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return reverse ? new $07763fcc531d8c96$export$831cc7e2a83afa94($calculatedHeadCell, $calculatedAnchorCell) : new $07763fcc531d8c96$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $07763fcc531d8c96$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $07763fcc531d8c96$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $86VAR.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $b0juN.Selection).jsonID('cell', $07763fcc531d8c96$export$831cc7e2a83afa94);

});
parcelRegister("86VAR", function(module, exports) {
$parcel$export(module.exports, "CellBookmark", () => $cafa193e8a47de95$export$ca751a6394ad160e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $b0juN = parcelRequire("b0juN");

var $g8Dll = parcelRequire("g8Dll");
class $cafa193e8a47de95$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $cafa193e8a47de95$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $g8Dll.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $b0juN.Selection).fromJSON(doc, data);
        }
        return (0, $b0juN.Selection).near($headCell, 1);
    }
}

});
parcelRegister("g8Dll", function(module, exports) {
$parcel$export(module.exports, "isInTable", () => $fc470749879c6522$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $fc470749879c6522$export$debd62b44eb7e281);
function $fc470749879c6522$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $fc470749879c6522$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("fssdk", function(module, exports) {
$parcel$export(module.exports, "Rect", () => $4057ec14afa7bd09$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $4057ec14afa7bd09$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $4057ec14afa7bd09$export$493da463fed0a57a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $4057ec14afa7bd09$var$readFromCache, $4057ec14afa7bd09$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    const cache = new WeakMap();
    $4057ec14afa7bd09$var$readFromCache = (key)=>cache.get(key);
    $4057ec14afa7bd09$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cache = [];
    const cacheSize = 10;
    let cachePos = 0;
    $4057ec14afa7bd09$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $4057ec14afa7bd09$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $4057ec14afa7bd09$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $4057ec14afa7bd09$export$d8cd393a71edca79 = /*#__PURE__*/ function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
    return TableProblemTypes;
}({});
const $4057ec14afa7bd09$export$c60fae4049791eae = 140;
class $4057ec14afa7bd09$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            const curPos = this.map[i];
            if (curPos !== pos) continue;
            const left = i % this.width;
            const top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $4057ec14afa7bd09$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        const { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        const { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        const { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $4057ec14afa7bd09$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        const result = [];
        const seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            const index = row * this.width + col;
            const pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            const rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                const rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        const parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $4057ec14afa7bd09$var$readFromCache(table) || $4057ec14afa7bd09$var$addToCache(table, $4057ec14afa7bd09$var$computeMap(table));
    }
}
// Compute a table map.
function $4057ec14afa7bd09$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    const width = $4057ec14afa7bd09$var$findWidth(table);
    const height = table.childCount;
    const map = [];
    const colWidths = [];
    let mapPos = 0, problems = null;
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        const rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            const cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                const start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    const colW = colwidth && colwidth[w];
                    if (colW) {
                        const widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        const expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    const mapByRow = Array(height);
    const mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    const tableMap = new $4057ec14afa7bd09$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($4057ec14afa7bd09$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $4057ec14afa7bd09$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $4057ec14afa7bd09$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        const rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            const prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                const cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            const cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $4057ec14afa7bd09$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    const seen = {};
    for(let i = 0; i < map.map.length; i++){
        const pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        const node = table.nodeAt(pos);
        let updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            const col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $4057ec14afa7bd09$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4057ec14afa7bd09$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    const result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("cdnhs", function(module, exports) {
$parcel$export(module.exports, "pointsAtCell", () => $fe5278d88753ec66$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $fe5278d88753ec66$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $fe5278d88753ec66$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $fe5278d88753ec66$export$172699367bb25225);
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $fssdk = parcelRequire("fssdk");
function $fe5278d88753ec66$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $fe5278d88753ec66$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $fe5278d88753ec66$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $fe5278d88753ec66$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $fssdk.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("9s8Rt", function(module, exports) {
$parcel$export(module.exports, "removeColSpan", () => $529118aba6cf79d0$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $529118aba6cf79d0$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $529118aba6cf79d0$export$147ee78a1321ac36);
function $529118aba6cf79d0$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $529118aba6cf79d0$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $529118aba6cf79d0$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $529118aba6cf79d0$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("drnJr", function(module, exports) {
$parcel$export(module.exports, "getCellSelectionRanges", () => $881f936152d96ccf$export$a60a444208fd5099);

var $b0juN = parcelRequire("b0juN");

var $fssdk = parcelRequire("fssdk");
function $881f936152d96ccf$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $fssdk.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $b0juN.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});




parcelRegister("5TyuV", function(module, exports) {
$parcel$export(module.exports, "shouldForceTracking", () => $f1742a5291f0563c$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $f1742a5291f0563c$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("b97Tz", function(module, exports) {
$parcel$export(module.exports, "normalizeFeatureFlags", () => $4da43d52001a1d52$export$f1485fc4974593c0);

var $kxu6m = parcelRequire("kxu6m");

var $drGUX = parcelRequire("drGUX");

var $g3rxO = parcelRequire("g3rxO");
const $4da43d52001a1d52$var$EMPTY = {};
function $4da43d52001a1d52$var$isObjectFlagKey(key, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && (objectFlagKeys === null || objectFlagKeys === void 0 ? void 0 : objectFlagKeys.includes(key)));
}
function $4da43d52001a1d52$var$isValidJSONObject(value) {
    try {
        const result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $4da43d52001a1d52$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $4da43d52001a1d52$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($4da43d52001a1d52$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($kxu6m)))(e[0]), e[1], options === null || options === void 0 ? void 0 : options.objectFlagKeys) && $4da43d52001a1d52$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($drGUX)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($kxu6m)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($4da43d52001a1d52$var$isObjectFlagKey(key, value, options === null || options === void 0 ? void 0 : options.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}

});
parcelRegister("kxu6m", function(module, exports) {

var $2JCBT = parcelRequire("2JCBT");

var $cus39 = parcelRequire("cus39");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ef3e3d475bcbe714$var$camelCase = $cus39(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $2JCBT(word) : word);
});
module.exports = $ef3e3d475bcbe714$var$camelCase;

});
parcelRegister("2JCBT", function(module, exports) {

var $lOV73 = parcelRequire("lOV73");

var $e11hy = parcelRequire("e11hy");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $1fddbbe8718ef853$var$capitalize(string) {
    return $e11hy($lOV73(string).toLowerCase());
}
module.exports = $1fddbbe8718ef853$var$capitalize;

});
parcelRegister("e11hy", function(module, exports) {

var $7SOLO = parcelRequire("7SOLO");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $a3422748478d68a1$var$upperFirst = $7SOLO('toUpperCase');
module.exports = $a3422748478d68a1$var$upperFirst;

});
parcelRegister("7SOLO", function(module, exports) {

var $9lsi8 = parcelRequire("9lsi8");

var $beBIq = parcelRequire("beBIq");

var $3Rpjf = parcelRequire("3Rpjf");

var $lOV73 = parcelRequire("lOV73");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $5bd4f56ea10c6816$var$createCaseFirst(methodName) {
    return function(string) {
        string = $lOV73(string);
        var strSymbols = $beBIq(string) ? $3Rpjf(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $9lsi8(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $5bd4f56ea10c6816$var$createCaseFirst;

});
parcelRegister("9lsi8", function(module, exports) {

var $iX8US = parcelRequire("iX8US");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $6cdc05512571a05d$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $iX8US(array, start, end);
}
module.exports = $6cdc05512571a05d$var$castSlice;

});

parcelRegister("beBIq", function(module, exports) {
/** Used to compose unicode character classes. */ var $82de420d69b8bf5f$var$rsAstralRange = '\\ud800-\\udfff', $82de420d69b8bf5f$var$rsComboMarksRange = '\\u0300-\\u036f', $82de420d69b8bf5f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $82de420d69b8bf5f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $82de420d69b8bf5f$var$rsComboRange = $82de420d69b8bf5f$var$rsComboMarksRange + $82de420d69b8bf5f$var$reComboHalfMarksRange + $82de420d69b8bf5f$var$rsComboSymbolsRange, $82de420d69b8bf5f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $82de420d69b8bf5f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $82de420d69b8bf5f$var$reHasUnicode = RegExp('[' + $82de420d69b8bf5f$var$rsZWJ + $82de420d69b8bf5f$var$rsAstralRange + $82de420d69b8bf5f$var$rsComboRange + $82de420d69b8bf5f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $82de420d69b8bf5f$var$hasUnicode(string) {
    return $82de420d69b8bf5f$var$reHasUnicode.test(string);
}
module.exports = $82de420d69b8bf5f$var$hasUnicode;

});

parcelRegister("3Rpjf", function(module, exports) {

var $5kMy5 = parcelRequire("5kMy5");

var $beBIq = parcelRequire("beBIq");

var $fWQbR = parcelRequire("fWQbR");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2cf9f447c7e722c2$var$stringToArray(string) {
    return $beBIq(string) ? $fWQbR(string) : $5kMy5(string);
}
module.exports = $2cf9f447c7e722c2$var$stringToArray;

});
parcelRegister("5kMy5", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3e247ac3169c2c86$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $3e247ac3169c2c86$var$asciiToArray;

});

parcelRegister("fWQbR", function(module, exports) {
/** Used to compose unicode character classes. */ var $b9c4c1b975d5956b$var$rsAstralRange = '\\ud800-\\udfff', $b9c4c1b975d5956b$var$rsComboMarksRange = '\\u0300-\\u036f', $b9c4c1b975d5956b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $b9c4c1b975d5956b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $b9c4c1b975d5956b$var$rsComboRange = $b9c4c1b975d5956b$var$rsComboMarksRange + $b9c4c1b975d5956b$var$reComboHalfMarksRange + $b9c4c1b975d5956b$var$rsComboSymbolsRange, $b9c4c1b975d5956b$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $b9c4c1b975d5956b$var$rsAstral = '[' + $b9c4c1b975d5956b$var$rsAstralRange + ']', $b9c4c1b975d5956b$var$rsCombo = '[' + $b9c4c1b975d5956b$var$rsComboRange + ']', $b9c4c1b975d5956b$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $b9c4c1b975d5956b$var$rsModifier = '(?:' + $b9c4c1b975d5956b$var$rsCombo + '|' + $b9c4c1b975d5956b$var$rsFitz + ')', $b9c4c1b975d5956b$var$rsNonAstral = '[^' + $b9c4c1b975d5956b$var$rsAstralRange + ']', $b9c4c1b975d5956b$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $b9c4c1b975d5956b$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $b9c4c1b975d5956b$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $b9c4c1b975d5956b$var$reOptMod = $b9c4c1b975d5956b$var$rsModifier + '?', $b9c4c1b975d5956b$var$rsOptVar = '[' + $b9c4c1b975d5956b$var$rsVarRange + ']?', $b9c4c1b975d5956b$var$rsOptJoin = '(?:' + $b9c4c1b975d5956b$var$rsZWJ + '(?:' + [
    $b9c4c1b975d5956b$var$rsNonAstral,
    $b9c4c1b975d5956b$var$rsRegional,
    $b9c4c1b975d5956b$var$rsSurrPair
].join('|') + ')' + $b9c4c1b975d5956b$var$rsOptVar + $b9c4c1b975d5956b$var$reOptMod + ')*', $b9c4c1b975d5956b$var$rsSeq = $b9c4c1b975d5956b$var$rsOptVar + $b9c4c1b975d5956b$var$reOptMod + $b9c4c1b975d5956b$var$rsOptJoin, $b9c4c1b975d5956b$var$rsSymbol = '(?:' + [
    $b9c4c1b975d5956b$var$rsNonAstral + $b9c4c1b975d5956b$var$rsCombo + '?',
    $b9c4c1b975d5956b$var$rsCombo,
    $b9c4c1b975d5956b$var$rsRegional,
    $b9c4c1b975d5956b$var$rsSurrPair,
    $b9c4c1b975d5956b$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $b9c4c1b975d5956b$var$reUnicode = RegExp($b9c4c1b975d5956b$var$rsFitz + '(?=' + $b9c4c1b975d5956b$var$rsFitz + ')|' + $b9c4c1b975d5956b$var$rsSymbol + $b9c4c1b975d5956b$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $b9c4c1b975d5956b$var$unicodeToArray(string) {
    return string.match($b9c4c1b975d5956b$var$reUnicode) || [];
}
module.exports = $b9c4c1b975d5956b$var$unicodeToArray;

});





parcelRegister("cus39", function(module, exports) {

var $lsrYY = parcelRequire("lsrYY");

var $iEPcP = parcelRequire("iEPcP");

var $bRyxq = parcelRequire("bRyxq");
/** Used to compose unicode capture groups. */ var $917e0b7751f84041$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $917e0b7751f84041$var$reApos = RegExp($917e0b7751f84041$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $917e0b7751f84041$var$createCompounder(callback) {
    return function(string) {
        return $lsrYY($bRyxq($iEPcP(string).replace($917e0b7751f84041$var$reApos, '')), callback, '');
    };
}
module.exports = $917e0b7751f84041$var$createCompounder;

});
parcelRegister("lsrYY", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $f9f1eb3f8db79e3b$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $f9f1eb3f8db79e3b$var$arrayReduce;

});

parcelRegister("iEPcP", function(module, exports) {

var $7Vwws = parcelRequire("7Vwws");

var $lOV73 = parcelRequire("lOV73");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $d953aed4c9dee2a4$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $d953aed4c9dee2a4$var$rsComboMarksRange = '\\u0300-\\u036f', $d953aed4c9dee2a4$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $d953aed4c9dee2a4$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $d953aed4c9dee2a4$var$rsComboRange = $d953aed4c9dee2a4$var$rsComboMarksRange + $d953aed4c9dee2a4$var$reComboHalfMarksRange + $d953aed4c9dee2a4$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $d953aed4c9dee2a4$var$rsCombo = '[' + $d953aed4c9dee2a4$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $d953aed4c9dee2a4$var$reComboMark = RegExp($d953aed4c9dee2a4$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $d953aed4c9dee2a4$var$deburr(string) {
    string = $lOV73(string);
    return string && string.replace($d953aed4c9dee2a4$var$reLatin, $7Vwws).replace($d953aed4c9dee2a4$var$reComboMark, '');
}
module.exports = $d953aed4c9dee2a4$var$deburr;

});
parcelRegister("7Vwws", function(module, exports) {

var $g8Xxz = parcelRequire("g8Xxz");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $5c57158cdb2dd159$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $5c57158cdb2dd159$var$deburrLetter = $g8Xxz($5c57158cdb2dd159$var$deburredLetters);
module.exports = $5c57158cdb2dd159$var$deburrLetter;

});
parcelRegister("g8Xxz", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $bc0b9436a158d495$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $bc0b9436a158d495$var$basePropertyOf;

});



parcelRegister("bRyxq", function(module, exports) {

var $83Jli = parcelRequire("83Jli");

var $2ydUL = parcelRequire("2ydUL");

var $lOV73 = parcelRequire("lOV73");

var $bcUjr = parcelRequire("bcUjr");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $8a2f6f84ba914127$var$words(string, pattern, guard) {
    string = $lOV73(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2ydUL(string) ? $bcUjr(string) : $83Jli(string);
    return string.match(pattern) || [];
}
module.exports = $8a2f6f84ba914127$var$words;

});
parcelRegister("83Jli", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $5de1c6a02dc0a43e$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $5de1c6a02dc0a43e$var$asciiWords(string) {
    return string.match($5de1c6a02dc0a43e$var$reAsciiWord) || [];
}
module.exports = $5de1c6a02dc0a43e$var$asciiWords;

});

parcelRegister("2ydUL", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1db98cdc8e2f05a7$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1db98cdc8e2f05a7$var$hasUnicodeWord(string) {
    return $1db98cdc8e2f05a7$var$reHasUnicodeWord.test(string);
}
module.exports = $1db98cdc8e2f05a7$var$hasUnicodeWord;

});

parcelRegister("bcUjr", function(module, exports) {
/** Used to compose unicode character classes. */ var $828c7f38c09b786b$var$rsAstralRange = '\\ud800-\\udfff', $828c7f38c09b786b$var$rsComboMarksRange = '\\u0300-\\u036f', $828c7f38c09b786b$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $828c7f38c09b786b$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $828c7f38c09b786b$var$rsComboRange = $828c7f38c09b786b$var$rsComboMarksRange + $828c7f38c09b786b$var$reComboHalfMarksRange + $828c7f38c09b786b$var$rsComboSymbolsRange, $828c7f38c09b786b$var$rsDingbatRange = '\\u2700-\\u27bf', $828c7f38c09b786b$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $828c7f38c09b786b$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $828c7f38c09b786b$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $828c7f38c09b786b$var$rsPunctuationRange = '\\u2000-\\u206f', $828c7f38c09b786b$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $828c7f38c09b786b$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $828c7f38c09b786b$var$rsVarRange = '\\ufe0e\\ufe0f', $828c7f38c09b786b$var$rsBreakRange = $828c7f38c09b786b$var$rsMathOpRange + $828c7f38c09b786b$var$rsNonCharRange + $828c7f38c09b786b$var$rsPunctuationRange + $828c7f38c09b786b$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $828c7f38c09b786b$var$rsApos = "['\u2019]", $828c7f38c09b786b$var$rsBreak = '[' + $828c7f38c09b786b$var$rsBreakRange + ']', $828c7f38c09b786b$var$rsCombo = '[' + $828c7f38c09b786b$var$rsComboRange + ']', $828c7f38c09b786b$var$rsDigits = '\\d+', $828c7f38c09b786b$var$rsDingbat = '[' + $828c7f38c09b786b$var$rsDingbatRange + ']', $828c7f38c09b786b$var$rsLower = '[' + $828c7f38c09b786b$var$rsLowerRange + ']', $828c7f38c09b786b$var$rsMisc = '[^' + $828c7f38c09b786b$var$rsAstralRange + $828c7f38c09b786b$var$rsBreakRange + $828c7f38c09b786b$var$rsDigits + $828c7f38c09b786b$var$rsDingbatRange + $828c7f38c09b786b$var$rsLowerRange + $828c7f38c09b786b$var$rsUpperRange + ']', $828c7f38c09b786b$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $828c7f38c09b786b$var$rsModifier = '(?:' + $828c7f38c09b786b$var$rsCombo + '|' + $828c7f38c09b786b$var$rsFitz + ')', $828c7f38c09b786b$var$rsNonAstral = '[^' + $828c7f38c09b786b$var$rsAstralRange + ']', $828c7f38c09b786b$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $828c7f38c09b786b$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $828c7f38c09b786b$var$rsUpper = '[' + $828c7f38c09b786b$var$rsUpperRange + ']', $828c7f38c09b786b$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $828c7f38c09b786b$var$rsMiscLower = '(?:' + $828c7f38c09b786b$var$rsLower + '|' + $828c7f38c09b786b$var$rsMisc + ')', $828c7f38c09b786b$var$rsMiscUpper = '(?:' + $828c7f38c09b786b$var$rsUpper + '|' + $828c7f38c09b786b$var$rsMisc + ')', $828c7f38c09b786b$var$rsOptContrLower = '(?:' + $828c7f38c09b786b$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $828c7f38c09b786b$var$rsOptContrUpper = '(?:' + $828c7f38c09b786b$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $828c7f38c09b786b$var$reOptMod = $828c7f38c09b786b$var$rsModifier + '?', $828c7f38c09b786b$var$rsOptVar = '[' + $828c7f38c09b786b$var$rsVarRange + ']?', $828c7f38c09b786b$var$rsOptJoin = '(?:' + $828c7f38c09b786b$var$rsZWJ + '(?:' + [
    $828c7f38c09b786b$var$rsNonAstral,
    $828c7f38c09b786b$var$rsRegional,
    $828c7f38c09b786b$var$rsSurrPair
].join('|') + ')' + $828c7f38c09b786b$var$rsOptVar + $828c7f38c09b786b$var$reOptMod + ')*', $828c7f38c09b786b$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $828c7f38c09b786b$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $828c7f38c09b786b$var$rsSeq = $828c7f38c09b786b$var$rsOptVar + $828c7f38c09b786b$var$reOptMod + $828c7f38c09b786b$var$rsOptJoin, $828c7f38c09b786b$var$rsEmoji = '(?:' + [
    $828c7f38c09b786b$var$rsDingbat,
    $828c7f38c09b786b$var$rsRegional,
    $828c7f38c09b786b$var$rsSurrPair
].join('|') + ')' + $828c7f38c09b786b$var$rsSeq;
/** Used to match complex or compound words. */ var $828c7f38c09b786b$var$reUnicodeWord = RegExp([
    $828c7f38c09b786b$var$rsUpper + '?' + $828c7f38c09b786b$var$rsLower + '+' + $828c7f38c09b786b$var$rsOptContrLower + '(?=' + [
        $828c7f38c09b786b$var$rsBreak,
        $828c7f38c09b786b$var$rsUpper,
        '$'
    ].join('|') + ')',
    $828c7f38c09b786b$var$rsMiscUpper + '+' + $828c7f38c09b786b$var$rsOptContrUpper + '(?=' + [
        $828c7f38c09b786b$var$rsBreak,
        $828c7f38c09b786b$var$rsUpper + $828c7f38c09b786b$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $828c7f38c09b786b$var$rsUpper + '?' + $828c7f38c09b786b$var$rsMiscLower + '+' + $828c7f38c09b786b$var$rsOptContrLower,
    $828c7f38c09b786b$var$rsUpper + '+' + $828c7f38c09b786b$var$rsOptContrUpper,
    $828c7f38c09b786b$var$rsOrdUpper,
    $828c7f38c09b786b$var$rsOrdLower,
    $828c7f38c09b786b$var$rsDigits,
    $828c7f38c09b786b$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $828c7f38c09b786b$var$unicodeWords(string) {
    return string.match($828c7f38c09b786b$var$reUnicodeWord) || [];
}
module.exports = $828c7f38c09b786b$var$unicodeWords;

});




parcelRegister("drGUX", function(module, exports) {

var $cus39 = parcelRequire("cus39");
/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */ var $9c9f168a389d0db2$var$kebabCase = $cus39(function(result, word, index) {
    return result + (index ? '-' : '') + word.toLowerCase();
});
module.exports = $9c9f168a389d0db2$var$kebabCase;

});

parcelRegister("g3rxO", function(module, exports) {
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $f1b20c2e0e188dbf$export$6d018dd0f6cbebcb);
function $f1b20c2e0e188dbf$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});


parcelRegister("hvgSB", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff270d3750da371c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $7p5u4 = parcelRequire("7p5u4");

var $4mqcS = parcelRequire("4mqcS");

var $hdn08 = parcelRequire("hdn08");
parcelRequire("7xvRa");
var $7Xlc3 = parcelRequire("7Xlc3");
var $7xvRa = parcelRequire("7xvRa");

var $9Y3l4 = parcelRequire("9Y3l4");

var $4trry = parcelRequire("4trry");

var $c4WmR = parcelRequire("c4WmR");

var $ltgAj = parcelRequire("ltgAj");
var $aaZSg = parcelRequire("aaZSg");

var $f4roI = parcelRequire("f4roI");

var $3H4LK = parcelRequire("3H4LK");

var $djnMX = parcelRequire("djnMX");

var $kgsrD = parcelRequire("kgsrD");
var $8YRWY = parcelRequire("8YRWY");

var $bSm7J = parcelRequire("bSm7J");

var $dn2ZZ = parcelRequire("dn2ZZ");

var $dOBEw = parcelRequire("dOBEw");

var $gptJr = parcelRequire("gptJr");

var $e3v0G = parcelRequire("e3v0G");

var $bEUKa = parcelRequire("bEUKa");
function $ff270d3750da371c$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $7p5u4.MarkType) && prev && prev.type instanceof (0, $7p5u4.MarkType) && Array.isArray(prev.content) && (0, $aaZSg.isSameMark)(prev, markOrNode)) prev.content = $ff270d3750da371c$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $ff270d3750da371c$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
   * The reason we have this extra array here is because we need to generate the same unique
   * heading id for 2 different nodes: headers and expands (check the implementation of
   * `getUniqueHeadingId` for more info).
   *
   * We will eventually need to refactor the current approach to generate unique ids
   * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
   */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowDownloadCodeBlock = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.standaloneBackgroundColorMarks = [];
        this.inlinePositions = new Set();
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = (node.type.name === 'taskItem' || node.type.name === 'blockTaskItem' && (0, $4mqcS.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true)) && node.attrs.state !== 'DONE' || // If blockTaskItem is in the schema, check if the parent of the current node
            // is an incomplete task item, because blockTaskItems can have nested nodes
            node.type.schema.nodes.blockTaskItem && (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.parentIsIncompleteTask) === true && (0, $4mqcS.expValEquals)('platform_editor_blocktaskitem_node_tenantid', 'isEnabled', true);
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $7xvRa.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>{
                    var _n$type;
                    return ((_n$type = n.type) === null || _n$type === void 0 ? void 0 : _n$type.name) !== 'mediaSingle';
                }) && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $8YRWY.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $kgsrD.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $kgsrD.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node === null || node === void 0 ? void 0 : node.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bSm7J.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: false
            } : {};
            // Add deepLinkTarget for link marks
            const linkSpecificProps = mark.type.name === 'link' ? {
                onSetLinkTarget: this.onSetLinkTarget
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                ...linkSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        if ((0, $hdn08.editorExperiment)('comment_on_bodied_extensions', true)) {
            this.initStartPos = init.startPos || 1;
            this.startPos = init.startPos || 1;
        } else {
            this.initStartPos = 1;
            this.startPos = 1;
        }
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.contentMode = init.contentMode;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.headingIdPrefix = init.headingIdPrefix;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowDownloadCodeBlock = init.allowDownloadCodeBlock;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.extensionViewportSizes = init.extensionViewportSizes;
        this.getExtensionHeight = init.getExtensionHeight;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.allowTableAlignment = init.allowTableAlignment;
        this.allowTableResizing = init.allowTableResizing;
        this.allowFixedColumnWidthOption = init.allowFixedColumnWidthOption;
        this.isPresentational = init.isPresentational;
        this.disableTableOverflowShadow = init.disableTableOverflowShadow;
        this.onSetLinkTarget = init.onSetLinkTarget;
        this.shouldDisplayExtensionAsInline = init.shouldDisplayExtensionAsInline;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = this.initStartPos;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node, path);
            case 'extension':
            case 'bodiedExtension':
                return this.getExtensionProps(node, path);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'inlineCard':
                return this.getInlineCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'nestedExpand':
                if ((0, $3H4LK.fg)('hot-121622_lazy_load_expand_content')) return this.getExpandProps(node, path);
                return this.getProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            case 'panel_c1':
                if ((0, $4mqcS.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return this.getPanelProps(node);
                return this.getProps(node, path);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props = {}, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    target = this.allowSelectAllTrap ? (0, $7Xlc3.DocWithSelectAllTrap) : (0, $7Xlc3.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, this.getChildNodes(fragment).map((node, index)=>{
            if ((0, $7xvRa.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        this.standaloneBackgroundColorMarks.push(...(0, $e3v0G.getStandaloneBackgroundColorMarks)(content));
        return $ff270d3750da371c$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, _index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $7xvRa.isTextNode)(mark)) {
            const serializeContent = (childMark, _index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            const isStandalone = this.standaloneBackgroundColorMarks.some((m)=>mark.eq(m));
            return this.renderMark((0, $8YRWY.toReact)(mark), {
                ...this.getMarkProps(mark, parentMark.path),
                isStandalone: isStandalone
            }, markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9Y3l4.default), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $gptJr.segmentText)(mark.text, this.textHighlighter);
        return (0, $dOBEw.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NodeComponent, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content));
    }
    renderMark(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MarkComponent, props, key, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content) {
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content));
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        const isInsideOfBlockNode = (0, $dn2ZZ.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $dn2ZZ.insideMultiBodiedExtension)(path, node.type.schema);
        const isInsideOfTable = (0, $dn2ZZ.insideTable)(path, node.type.schema);
        const isStickySafeCenteringEnabled = (0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const isInsideBreakoutExpand = !isStickySafeCenteringEnabled && (0, $4mqcS.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dn2ZZ.insideBreakoutExpand)(path);
        const stickyHeaders = isStickySafeCenteringEnabled ? !isInsideOfTable ? this.stickyHeaders : undefined : !isInsideOfTable && !(0, $dn2ZZ.insideBreakoutLayout)(path) && !isInsideBreakoutExpand ? this.stickyHeaders : undefined;
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $c4WmR.getColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension,
            allowTableAlignment: this.allowTableAlignment,
            allowTableResizing: this.allowTableResizing,
            // eslint-disable-next-line @atlaskit/platform/valid-gate-name
            isPresentational: (0, $3H4LK.fg)('platform_renderer_isPresentational') ? this.isPresentational : false,
            disableTableOverflowShadow: this.disableTableOverflowShadow,
            allowFixedColumnWidthOption: this.allowFixedColumnWidthOption
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $dn2ZZ.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        var _this$media, _this$media2, _this$media3, _this$media4;
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>{
            var _n$type2;
            return ((_n$type2 = n.type) === null || _n$type2 === void 0 ? void 0 : _n$type2.name) === 'mediaSingle';
        });
        // Only check path for bodiedSyncBlock; syncBlock uses RendererContext
        const nestedUnder = (0, $hdn08.editorExperiment)('platform_synced_block', true) ? (0, $dn2ZZ.getNestedUnderNodes)(path, [
            'bodiedSyncBlock'
        ]) : undefined;
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: (_this$media = this.media) === null || _this$media === void 0 ? void 0 : _this$media.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper,
            enableSyncMediaCard: (_this$media2 = this.media) === null || _this$media2 === void 0 ? void 0 : _this$media2.enableSyncMediaCard,
            mediaViewerExtensions: (_this$media3 = this.media) === null || _this$media3 === void 0 ? void 0 : _this$media3.mediaViewerExtensions,
            fallbackMediaNameFetcher: (_this$media4 = this.media) === null || _this$media4 === void 0 ? void 0 : _this$media4.fallbackMediaNameFetcher,
            nestedUnder: nestedUnder
        };
    }
    getExtensionProps(node, path = []) {
        var _this$getExtensionHei;
        return {
            ...this.getProps(node, path),
            extensionViewportSizes: this.extensionViewportSizes,
            nodeHeight: (_this$getExtensionHei = this.getExtensionHeight) === null || _this$getExtensionHei === void 0 ? void 0 : _this$getExtensionHei.call(this, node),
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        };
    }
    getEmojiProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $dn2ZZ.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0,
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getInlineCardProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            onSetLinkTarget: this.onSetLinkTarget
        };
    }
    getMediaGroupProps(node) {
        var _this$media5, _this$media6;
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: (_this$media5 = this.media) === null || _this$media5 === void 0 ? void 0 : _this$media5.enableDownloadButton,
            ssr: (_this$media6 = this.media) === null || _this$media6 === void 0 ? void 0 : _this$media6.ssr
        };
    }
    getMediaInlineProps(node) {
        var _this$media7, _this$media8;
        return {
            ...this.getProps(node),
            ssr: (_this$media7 = this.media) === null || _this$media7 === void 0 ? void 0 : _this$media7.ssr,
            fallbackMediaNameFetcher: (_this$media8 = this.media) === null || _this$media8 === void 0 ? void 0 : _this$media8.fallbackMediaNameFetcher
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = false;
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        const startPos = this.startPos + path.length;
        return {
            asInline: this.inlinePositions.has(startPos) ? 'on' : undefined,
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowDownloadCodeBlock: this.allowDownloadCodeBlock,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            rendererContentMode: this.contentMode,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': startPos
            },
            startPos: startPos,
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $4trry.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, _path = []) {
        let loadBodyContent = false;
        if ((0, $3H4LK.fg)('hot-121622_lazy_load_expand_content')) {
            const annotations = (0, $f4roI.findChildrenByMark)(node, node.type.schema.marks.annotation, true);
            // Force rendering children if there are inline comments to support comments navigation
            // which relies on the HTML node to be present.
            loadBodyContent = annotations.some((annotation)=>{
                return annotation.node.marks.some((mark)=>mark.attrs.annotationType === 'inlineComment');
            });
        }
        // Only compute searchText when the browser find experiment is enabled,
        // to avoid unnecessary node.textContent string allocations per expand node.
        const searchText = (0, $4mqcS.expValEquals)('platform_editor_close_expand_find', 'isEnabled', true) ? node.textContent : undefined;
        if (!(0, $4trry.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return {
            ...this.getProps(node),
            loadBodyContent: loadBodyContent,
            searchText: searchText
        };
        const nestedHeaderIds = (0, $f4roI.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds,
            loadBodyContent: loadBodyContent,
            searchText: searchText
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const nodeContent = node.content.toJSON()// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc, node)=>acc.concat((0, $djnMX.getText)(node) || ''), '').trim()// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/\s/g, '-');
        if (!nodeContent) return;
        const uniqueId = this.getUniqueHeadingId(nodeContent, headingIds);
        return this.headingIdPrefix ? `${this.headingIdPrefix}-${uniqueId}` : uniqueId;
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    getChildNodes(fragment) {
        let children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        children = (0, $7xvRa.mergeTextNodes)(children);
        if (!!this.shouldDisplayExtensionAsInline && (0, $4mqcS.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true)) (0, $bEUKa.markBlockAsInline)({
            nodes: children,
            onMark: ({ pos: pos })=>{
                this.inlinePositions.add(pos);
            },
            parentPos: this.startPos,
            shouldDisplayExtensionAsInline: this.shouldDisplayExtensionAsInline
        });
        return children;
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $ltgAj.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $ff270d3750da371c$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }, node);
        }));
    }
}

});
parcelRegister("7xvRa", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $6cb0e5d8d08831e3$export$aff6291803939b05);
$parcel$export(module.exports, "toReact", () => $6cb0e5d8d08831e3$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $6cb0e5d8d08831e3$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $6cb0e5d8d08831e3$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $6cb0e5d8d08831e3$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("7Xlc3")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("7Xlc3")).DocWithSelectAllTrap);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $jk6Pl = parcelRequire("jk6Pl");

var $84REQ = parcelRequire("84REQ");
var $1mOuU = parcelRequire("1mOuU");

var $3H4LK = parcelRequire("3H4LK");

var $eLojr = parcelRequire("eLojr");

var $44yOH = parcelRequire("44yOH");

var $csFuI = parcelRequire("csFuI");

var $i81Rt = parcelRequire("i81Rt");

var $kitQl = parcelRequire("kitQl");

var $7Xlc3 = parcelRequire("7Xlc3");

var $fjrog = parcelRequire("fjrog");

var $KhEWC = parcelRequire("KhEWC");

var $8BaBv = parcelRequire("8BaBv");

var $43AXx = parcelRequire("43AXx");

var $6i8Nh = parcelRequire("6i8Nh");

var $f72cs = parcelRequire("f72cs");

var $iTo2x = parcelRequire("iTo2x");

var $f7NN2 = parcelRequire("f7NN2");

var $kTO13 = parcelRequire("kTO13");

var $8kzB9 = parcelRequire("8kzB9");

var $277As = parcelRequire("277As");

var $lTSuC = parcelRequire("lTSuC");

var $eevY3 = parcelRequire("eevY3");

var $3dShV = parcelRequire("3dShV");

var $doc9I = parcelRequire("doc9I");

var $1a8Fk = parcelRequire("1a8Fk");

const $6cb0e5d8d08831e3$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("jXhCg")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("3Ew8z")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("aGKTb")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("ScMt4")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("k7gnN")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("kOA8Q")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("gorzw")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("3xDjI")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("9vjDg")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("dLYiZ")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("7j0li")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("Os2Ma")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("ac6O3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("6euVV")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("eK1h3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("2Jr8f")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("9oCd9")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("1yiYR")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("ayo6G")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$var$SyncBlockLoader = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("8yk39")).then((mod)=>mod.default),
    loading: ()=>null
});

const $6cb0e5d8d08831e3$var$BodiedSyncBlock = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: ()=>(parcelRequire("fJ25g")).then((mod)=>mod.default),
    loading: ()=>null
});
const $6cb0e5d8d08831e3$export$3931063f6a5f290e = {
    blockquote: (0, $eLojr.default),
    bulletList: (0, $kitQl.default),
    blockCard: $6cb0e5d8d08831e3$export$d18ccd25c0d2c6b0,
    caption: (0, $f7NN2.default),
    date: $6cb0e5d8d08831e3$export$6341f9a885713487,
    decisionItem: $6cb0e5d8d08831e3$export$b6f73a2b0b0de599,
    decisionList: $6cb0e5d8d08831e3$export$b458dfa720128865,
    doc: (0, $7Xlc3.default),
    emoji: $6cb0e5d8d08831e3$export$56cc48506ff790a,
    extension: (0, $fjrog.default),
    bodiedExtension: (0, $44yOH.default),
    multiBodiedExtension: (0, $csFuI.default),
    extensionFrame: (0, $i81Rt.default),
    hardBreak: (0, $KhEWC.default),
    heading: (0, $8BaBv.default),
    inlineCard: $6cb0e5d8d08831e3$export$aff6291803939b05,
    inlineExtension: (0, $43AXx.default),
    layoutSection: (0, $6i8Nh.default),
    layoutColumn: (0, $f72cs.default),
    listItem: (0, $iTo2x.default),
    media: $6cb0e5d8d08831e3$export$7fc53215244aec38,
    mediaGroup: $6cb0e5d8d08831e3$export$d7858be3df00d59,
    mediaInline: $6cb0e5d8d08831e3$export$462ea7c2a1c4cb1f,
    mediaSingle: $6cb0e5d8d08831e3$export$888d74bc001c3a5d,
    mention: $6cb0e5d8d08831e3$export$e891316fea657d90,
    orderedList: (0, $kTO13.default),
    panel: $6cb0e5d8d08831e3$export$2ddb90ad54e5f587,
    panel_c1: $6cb0e5d8d08831e3$export$2ddb90ad54e5f587,
    paragraph: (0, $8kzB9.default),
    placeholder: (0, $277As.default),
    rule: (0, $lTSuC.default),
    status: $6cb0e5d8d08831e3$export$96e9906d6d93a972,
    taskItem: $6cb0e5d8d08831e3$export$27c4189b8be1bf93,
    taskList: $6cb0e5d8d08831e3$export$771a55a10b0a40ae,
    table: (0, $eevY3.default),
    tableCell: (0, $3dShV.TableCell),
    tableHeader: (0, $3dShV.TableHeader),
    tableRow: (0, $doc9I.default),
    unknownBlock: (0, $1a8Fk.default),
    unsupportedBlock: (0, $84REQ.default),
    unsupportedInline: (0, $1mOuU.default),
    expand: $6cb0e5d8d08831e3$export$49bd1dfb0ad29c40,
    syncBlock: $6cb0e5d8d08831e3$var$SyncBlockLoader,
    bodiedSyncBlock: $6cb0e5d8d08831e3$var$BodiedSyncBlock,
    nestedExpand: $6cb0e5d8d08831e3$export$49bd1dfb0ad29c40,
    embedCard: $6cb0e5d8d08831e3$export$6789d7ecdc77631b,
    blockTaskItem: $6cb0e5d8d08831e3$export$27c4189b8be1bf93
};
const $6cb0e5d8d08831e3$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && (flags === null || flags === void 0 ? void 0 : flags.allowSelectAllTrap) === true) return 0, $7Xlc3.DocWithSelectAllTrap;
    if (!(0, $3H4LK.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return $6cb0e5d8d08831e3$export$a22ee8f907eecb5f;
            return $6cb0e5d8d08831e3$export$6c415d1fdae3dfdb;
        }
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$6cb0e5d8d08831e3$export$3931063f6a5f290e,
        ...nodeComponents
    };
    if ((0, $3H4LK.fg)('jfp-magma-ssr-iv-editor-codeblock')) {
        if (node.type.name === 'codeBlock') {
            if ((flags === null || flags === void 0 ? void 0 : flags.allowWindowedCodeBlock) === true) return nodes.windowedCodeBlock ?? $6cb0e5d8d08831e3$export$a22ee8f907eecb5f;
            return nodes.codeBlock ?? $6cb0e5d8d08831e3$export$6c415d1fdae3dfdb;
        }
    }
    nodes['multiBodiedExtension'] = (0, $csFuI.default);
    return nodes[node.type.name];
};
const $6cb0e5d8d08831e3$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$6cb0e5d8d08831e3$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $6cb0e5d8d08831e3$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $6cb0e5d8d08831e3$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $6cb0e5d8d08831e3$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $6cb0e5d8d08831e3$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6cb0e5d8d08831e3$var$whitespaceRegex = /^\s*$/;
const $6cb0e5d8d08831e3$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $6cb0e5d8d08831e3$var$isEmojiBlock(node.content);
};
const $6cb0e5d8d08831e3$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($6cb0e5d8d08831e3$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("jk6Pl", function(module, exports) {
'use strict';
var $e1152e4bfa8cbb15$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $e1152e4bfa8cbb15$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e1152e4bfa8cbb15$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e1152e4bfa8cbb15$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $4fqPo = parcelRequire("4fqPo");

var $4S7MC = parcelRequire("4S7MC");
var $e1152e4bfa8cbb15$var$ALL_INITIALIZERS = [];
var $e1152e4bfa8cbb15$var$READY_INITIALIZERS = [];
function $e1152e4bfa8cbb15$var$isWebpackReady(getModuleIds) {
    if ((typeof __webpack_modules__ === 'undefined' ? 'undefined' : $e1152e4bfa8cbb15$var$_typeof(__webpack_modules__)) !== 'object') return false;
    return getModuleIds().every(function(moduleId) {
        return typeof moduleId !== 'undefined' && typeof __webpack_modules__[moduleId] !== 'undefined';
    });
}
function $e1152e4bfa8cbb15$var$load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function $e1152e4bfa8cbb15$var$loadMap(obj) {
    var state = {
        loading: false,
        loaded: {},
        error: null
    };
    var promises = [];
    try {
        Object.keys(obj).forEach(function(key) {
            var result = $e1152e4bfa8cbb15$var$load(obj[key]);
            if (!result.loading) {
                state.loaded[key] = result.loaded;
                state.error = result.error;
            } else state.loading = true;
            promises.push(result.promise);
            result.promise.then(function(res) {
                state.loaded[key] = res;
            }).catch(function(err) {
                state.error = err;
            });
        });
    } catch (err) {
        state.error = err;
    }
    state.promise = Promise.all(promises).then(function(res) {
        state.loading = false;
        return res;
    }).catch(function(err) {
        state.loading = false;
        throw err;
    });
    return state;
}
function $e1152e4bfa8cbb15$var$resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function $e1152e4bfa8cbb15$var$render(loaded, props) {
    return $4fqPo.createElement($e1152e4bfa8cbb15$var$resolve(loaded), props);
}
function $e1152e4bfa8cbb15$var$createLoadableComponent(loadFn, options) {
    var _class, _temp;
    if (!options.loading) throw new Error('react-loadable requires a `loading` component');
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        render: $e1152e4bfa8cbb15$var$render,
        webpack: null,
        modules: null
    }, options);
    var res = null;
    function init() {
        if (!res) res = loadFn(opts.loader);
        return res.promise;
    }
    $e1152e4bfa8cbb15$var$ALL_INITIALIZERS.push(init);
    if (typeof opts.webpack === 'function') $e1152e4bfa8cbb15$var$READY_INITIALIZERS.push(function() {
        if ($e1152e4bfa8cbb15$var$isWebpackReady(opts.webpack)) return init();
    });
    return _temp = _class = function(_React$Component) {
        $e1152e4bfa8cbb15$var$_inherits(LoadableComponent, _React$Component);
        function LoadableComponent(props) {
            $e1152e4bfa8cbb15$var$_classCallCheck(this, LoadableComponent);
            var _this = $e1152e4bfa8cbb15$var$_possibleConstructorReturn(this, _React$Component.call(this, props));
            init();
            _this.state = {
                error: res.error,
                pastDelay: false,
                timedOut: false,
                loading: res.loading,
                loaded: res.loaded
            };
            return _this;
        }
        LoadableComponent.preload = function preload() {
            return init();
        };
        // renamed from componentWillMount See https://fb.me/react-unsafe-component-lifecycles
        LoadableComponent.prototype.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
            var _this2 = this;
            this._mounted = true;
            if (this.context.loadable && Array.isArray(opts.modules)) opts.modules.forEach(function(moduleName) {
                _this2.context.loadable.report(moduleName);
            });
            if (!res.loading) return;
            if (typeof opts.delay === 'number') this._delay = setTimeout(function() {
                _this2.setState({
                    pastDelay: true
                });
            }, opts.delay);
            if (typeof opts.timeout === 'number') this._timeout = setTimeout(function() {
                _this2.setState({
                    timedOut: true
                });
            }, opts.timeout);
            var update = function update() {
                if (!_this2._mounted) return;
                _this2.setState({
                    error: res.error,
                    loaded: res.loaded,
                    loading: res.loading
                });
                _this2._clearTimeouts();
            };
            res.promise.then(function() {
                update();
            }).catch(function(err) {
                update();
                throw err;
            });
        };
        LoadableComponent.prototype.componentWillUnmount = function componentWillUnmount() {
            this._mounted = false;
            this._clearTimeouts();
        };
        LoadableComponent.prototype._clearTimeouts = function _clearTimeouts() {
            clearTimeout(this._delay);
            clearTimeout(this._timeout);
        };
        LoadableComponent.prototype.render = function render() {
            if (this.state.loading || this.state.error) return $4fqPo.createElement(opts.loading, {
                isLoading: this.state.loading,
                pastDelay: this.state.pastDelay,
                timedOut: this.state.timedOut,
                error: this.state.error
            });
            else if (this.state.loaded) return opts.render(this.state.loaded, this.props);
            else return null;
        };
        return LoadableComponent;
    }($4fqPo.Component), _class.contextTypes = {
        loadable: $4S7MC.shape({
            report: $4S7MC.func.isRequired
        })
    }, _temp;
}
function $e1152e4bfa8cbb15$var$Loadable(opts) {
    return $e1152e4bfa8cbb15$var$createLoadableComponent($e1152e4bfa8cbb15$var$load, opts);
}
function $e1152e4bfa8cbb15$var$LoadableMap(opts) {
    if (typeof opts.render !== 'function') throw new Error('LoadableMap requires a `render(loaded, props)` function');
    return $e1152e4bfa8cbb15$var$createLoadableComponent($e1152e4bfa8cbb15$var$loadMap, opts);
}
$e1152e4bfa8cbb15$var$Loadable.Map = $e1152e4bfa8cbb15$var$LoadableMap;
var $e1152e4bfa8cbb15$var$Capture = function(_React$Component2) {
    $e1152e4bfa8cbb15$var$_inherits(Capture, _React$Component2);
    function Capture() {
        $e1152e4bfa8cbb15$var$_classCallCheck(this, Capture);
        return $e1152e4bfa8cbb15$var$_possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
    }
    Capture.prototype.getChildContext = function getChildContext() {
        return {
            loadable: {
                report: this.props.report
            }
        };
    };
    Capture.prototype.render = function render() {
        return $4fqPo.Children.only(this.props.children);
    };
    return Capture;
}($4fqPo.Component);
$e1152e4bfa8cbb15$var$Capture.propTypes = {
    report: $4S7MC.func.isRequired
};
$e1152e4bfa8cbb15$var$Capture.childContextTypes = {
    loadable: $4S7MC.shape({
        report: $4S7MC.func.isRequired
    }).isRequired
};
$e1152e4bfa8cbb15$var$Loadable.Capture = $e1152e4bfa8cbb15$var$Capture;
function $e1152e4bfa8cbb15$var$flushInitializers(initializers) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init());
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) return $e1152e4bfa8cbb15$var$flushInitializers(initializers);
    });
}
$e1152e4bfa8cbb15$var$Loadable.preloadAll = function() {
    return new Promise(function(resolve, reject) {
        $e1152e4bfa8cbb15$var$flushInitializers($e1152e4bfa8cbb15$var$ALL_INITIALIZERS).then(resolve, reject);
    });
};
$e1152e4bfa8cbb15$var$Loadable.preloadReady = function() {
    return new Promise(function(resolve, reject) {
        // We always will resolve, errors should be handled within loading UIs.
        $e1152e4bfa8cbb15$var$flushInitializers($e1152e4bfa8cbb15$var$READY_INITIALIZERS).then(resolve, resolve);
    });
};
module.exports = $e1152e4bfa8cbb15$var$Loadable;

});

parcelRegister("1mOuU", function(module, exports) {
$parcel$export(module.exports, "default", () => $50a32f86fd7f1cc0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $3rTf2 = parcelRequire("3rTf2");

var $faPFq = parcelRequire("faPFq");

var $kLLw5 = parcelRequire("kLLw5");

var $8Mj6h = parcelRequire("8Mj6h");

var $f0GG4 = parcelRequire("f0GG4");

var $6cooD = parcelRequire("6cooD");

var $2kuA8 = parcelRequire("2kuA8");

var $gr4P1 = parcelRequire("gr4P1");
const $50a32f86fd7f1cc0$var$inlineNodeStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    alignItems: 'center',
    background: "var(--ds-background-disabled, #0515240F)",
    border: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-disabled, #0515240F)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $faPFq.relativeFontSizeToBase16)(14),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $50a32f86fd7f1cc0$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $gr4P1.getUnsupportedContent)((0, $6cooD.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $6cooD.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $4fqPo.useRef)({
        padding: '4px'
    });
    const originalNodeType = node === null || node === void 0 ? void 0 : node.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $4fqPo.useCallback)(()=>dispatchAnalyticsEvent && (0, $2kuA8.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $f0GG4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        css: $50a32f86fd7f1cc0$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mj6h.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kLLw5))), {
        label: "?"
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $50a32f86fd7f1cc0$var$_default_1 = (0, $3rTf2.default)($50a32f86fd7f1cc0$var$UnsupportedInlineNode);
var $50a32f86fd7f1cc0$export$2e2bcd8739ae039 = $50a32f86fd7f1cc0$var$_default_1;

});

parcelRegister("eLojr", function(module, exports) {
$parcel$export(module.exports, "default", () => $96215cfa1da5b838$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $96215cfa1da5b838$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("blockquote", {
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("44yOH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e40015c633b2cce$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $fjrog = parcelRequire("fjrog");

var $f5eyN = parcelRequire("f5eyN");

var $jLTyB = parcelRequire("jLTyB");

var $49Bjt = parcelRequire("49Bjt");

var $f0GG4 = parcelRequire("f0GG4");

var $8sZ3k = parcelRequire("8sZ3k");

var $AmJJl = parcelRequire("AmJJl");
const $1e40015c633b2cce$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType, parameters: parameters, extensionViewportSizes: extensionViewportSizes, localId: localId, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline, fireAnalyticsEvent: fireAnalyticsEvent } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children)// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const validationContextValue = (0, $4fqPo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f5eyN.ErrorBoundary), {
        component: (0, $49Bjt.ACTION_SUBJECT).RENDERER,
        componentId: (0, $f0GG4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8sZ3k.AnnotationsPositionContext).Provider, {
        value: {
            startPos: props.startPos + 1
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $AmJJl.ValidationContextProvider), {
        value: validationContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jLTyB.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ node: node, result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $fjrog.renderExtension)(result, layout, {
                isTopLevel: path.length < 1,
                rendererAppearance: props.rendererAppearance,
                fireAnalyticsEvent: fireAnalyticsEvent
            }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $fjrog.renderExtension)(children, layout, {
            isTopLevel: path.length < 1,
            rendererAppearance: props.rendererAppearance,
            fireAnalyticsEvent: fireAnalyticsEvent
        }, removeOverflow, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, undefined, localId, shouldDisplayExtensionAsInline, node);
    }))));
};
var $1e40015c633b2cce$export$2e2bcd8739ae039 = $1e40015c633b2cce$var$BodiedExtension;

});
parcelRegister("fjrog", function(module, exports) {
$parcel$export(module.exports, "renderExtension", () => $07b83bce9667e34c$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $07b83bce9667e34c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $4fqPo = parcelRequire("4fqPo");

var $f0GG4 = parcelRequire("f0GG4");

var $jLTyB = parcelRequire("jLTyB");

var $2qSQf = parcelRequire("2qSQf");
var $ag3hq = parcelRequire("ag3hq");

var $7VVBW = parcelRequire("7VVBW");

var $jANeU = parcelRequire("jANeU");

var $4mqcS = parcelRequire("4mqcS");

var $g0CJe = parcelRequire("g0CJe");

var $3H4LK = parcelRequire("3H4LK");
function $07b83bce9667e34c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $07b83bce9667e34c$var$viewportSizes = [
    'small',
    'medium',
    'default',
    'large',
    'xlarge'
];
// Mirrors sizes from https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/forge/xen-editor-provider/src/render/renderers/ForgeUIExtension.tsx
const $07b83bce9667e34c$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $07b83bce9667e34c$var$getViewportSize = (extensionId, extensionViewportSizes)=>{
    if (!Array.isArray(extensionViewportSizes) || !extensionId) return;
    const extension = extensionViewportSizes.find((extension)=>extension.extensionId === extensionId);
    if (extension) {
        const viewportSize = extension.viewportSize && $07b83bce9667e34c$var$viewportSizes.includes(extension.viewportSize) ? extension.viewportSize : 'default';
        return $07b83bce9667e34c$var$macroHeights[viewportSize];
    }
};
const $07b83bce9667e34c$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
/**
 * Fires an analytics event once on mount when a bodied extension is rendered as an inline element.
 * The node is stored in a ref to avoid re-firing if the node reference changes.
 */ const $07b83bce9667e34c$var$FireExtensionAsInlineAnalytics = ({ fireAnalyticsEvent: fireAnalyticsEvent, node: node })=>{
    const nodeRef = (0, $4fqPo.useRef)(node);
    (0, $4fqPo.useEffect)(()=>{
        fireAnalyticsEvent({
            action: (0, $f0GG4.ACTION).RENDERED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).EXTENSION_AS_INLINE,
            actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            attributes: {
                extensionKey: nodeRef.current.extensionKey,
                extensionType: nodeRef.current.extensionType
            },
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
        });
    }, [
        fireAnalyticsEvent
    ]);
    return null;
};
const $07b83bce9667e34c$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow, extensionId, extensionViewportSizes, nodeHeight, localId, shouldDisplayExtensionAsInline, node, isInsideOfInlineExtension)=>{
    const overflowContainerClass = !removeOverflow ? (0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true, rendererAppearance: rendererAppearance, fireAnalyticsEvent: fireAnalyticsEvent } = options || {};
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jANeU.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    /**
   * To reduce cumulative layout shift, we check installed manifest values (viewportSize) for Forge and extension node parameters
   * for Connect (legacy). As Connect is being phased out, we want Forge to also start to store its expected height
   * in node parameters, especially for dynamic content macros. LegacyMacroStyledElements implements logic similar to here
   * as the extension handler in CFE for legacy macros and Connect.
   */ const viewportSize = $07b83bce9667e34c$var$getViewportSize(extensionId, extensionViewportSizes);
    const extensionHeight = nodeHeight || viewportSize;
    const isInline = (shouldDisplayExtensionAsInline === null || shouldDisplayExtensionAsInline === void 0 ? void 0 : shouldDisplayExtensionAsInline(node)) && (0, $4mqcS.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true);
    const inlineClassName = isInline ? (0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE : '';
    const asInlineAnalytics = isInline && fireAnalyticsEvent && node ? /*#__PURE__*/ (0, $lqVX7.jsx)($07b83bce9667e34c$var$FireExtensionAsInlineAnalytics, {
        fireAnalyticsEvent: fireAnalyticsEvent,
        node: node
    }) : null;
    if ((0, $4mqcS.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const extensionDiv = /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jANeU.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                width: isInline ? undefined : ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                (0, $g0CJe.calcBreakoutWidthCss)(layout) : (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : extensionHeight && `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-testid": "extension--wrapper",
            "data-node-type": "extension",
            "data-top-level": isTopLevel || undefined
        }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $jANeU.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $3H4LK.fg)('platform_fix_macro_renders_in_layouts') && $07b83bce9667e34c$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass && (0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jANeU.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jANeU.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    }
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $ag3hq.WidthConsumer), null, ({ width: width })=>{
        const extensionDiv = /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jANeU.RendererCssClassName).EXTENSION} ${inlineClassName} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isInline ? undefined : ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $7VVBW.calcBreakoutWidth)(layout, width) : (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                minHeight: isInline ? undefined : `${extensionHeight}px`
            },
            "data-layout": layout,
            "data-local-id": localId,
            "data-top-level": isTopLevel || undefined
        }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            tabIndex: options.tabIndex,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: `${(0, $jANeU.RendererCssClassName).EXTENSION_INNER_WRAPPER} ${overflowContainerClass}`,
            css: [
                !isInsideOfInlineExtension && (0, $3H4LK.fg)('platform_fix_macro_renders_in_layouts') && $07b83bce9667e34c$var$containerStyle
            ]
        }, asInlineAnalytics, content));
        return centerAlignClass && (0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) ? /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jANeU.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jANeU.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, extensionDiv) : extensionDiv;
    });
};
const $07b83bce9667e34c$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [], extensionViewportSizes: extensionViewportSizes, parameters: parameters, nodeHeight: nodeHeight, localId: localId, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $jLTyB.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(result)) return $07b83bce9667e34c$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames,
                tabIndex: props.tabIndex,
                rendererAppearance: props.rendererAppearance
            }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $07b83bce9667e34c$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames,
            tabIndex: props.tabIndex,
            rendererAppearance: props.rendererAppearance
        }, undefined, parameters === null || parameters === void 0 ? void 0 : parameters.extensionId, extensionViewportSizes, nodeHeight, localId, undefined, undefined, isInsideOfInlineExtension);
    });
};
const $07b83bce9667e34c$var$_default_1 = (0, $2qSQf.default)($07b83bce9667e34c$var$Extension, {
    overflowSelector: `.${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});
var $07b83bce9667e34c$export$2e2bcd8739ae039 = $07b83bce9667e34c$var$_default_1;

});
parcelRegister("jLTyB", function(module, exports) {
$parcel$export(module.exports, "default", () => $95485cbf84267439$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $4fqPo = parcelRequire("4fqPo");

var $jE04u = parcelRequire("jE04u");

var $wuhiB = parcelRequire("wuhiB");

var $8EivP = parcelRequire("8EivP");

var $h8UjM = parcelRequire("h8UjM");
function $95485cbf84267439$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $95485cbf84267439$var$inlineExtensionStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // 0px margin top is important here.
    // When running on server-side emotion will generate style tags before elements.
    // This caused packages/editor/editor-common/src/styles/shared/block-marks.ts to override the margin-top.
    // However as soon as the styles are extracted to <head> it adds back the margin.
    // The timing is tricky as it happens to be when UFO collects the dimension for the placeholder for TTVC calculation.
    // This resulted 1px mismatch on the image. Further cause everything on page to shift by 1px.
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `0px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
const $95485cbf84267439$var$plainTextMacroStyle = {
    name: "1b7osz4",
    styles: "display:inline;vertical-align:baseline;[data-macro-body]{display:inline;}"
};
function $95485cbf84267439$export$2e2bcd8739ae039(props) {
    const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions, children: children } = props;
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>(0, $jE04u.default)((0, $wuhiB.getNodeRenderer)), []);
    const [extensionProvider, setExtensionProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(null);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleProvider = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((_name, providerPromise)=>{
        providerPromise && providerPromise.then((provider)=>{
            if (isMounted.current) setExtensionProvider(provider);
        });
    }, []);
    const renderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((extensionProvider)=>{
        var _marks$find, _node$parameters;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        const node = {
            type: type,
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content || text,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        const isPlainTextMacro = Boolean(node === null || node === void 0 || (_node$parameters = node.parameters) === null || _node$parameters === void 0 || (_node$parameters = _node$parameters.macroParams) === null || _node$parameters === void 0 ? void 0 : _node$parameters.__bodyContent);
        let result = null;
        try {
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $h8UjM.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, rendererContext.adDoc);
            }
            if (!result && extensionProvider) {
                const NodeRenderer = localGetNodeRenderer(extensionProvider, extensionType, extensionKey);
                if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $lqVX7.jsx)(NodeRenderer, {
                    node: node,
                    actions: actions
                });
                else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $lqVX7.jsx)($95485cbf84267439$export$f41ccc3bd3324832, {
                    isPlainTextMacro: isPlainTextMacro
                }, /*#__PURE__*/ (0, $lqVX7.jsx)(NodeRenderer, {
                    node: node
                }));
                else result = /*#__PURE__*/ (0, $lqVX7.jsx)(NodeRenderer, {
                    node: node
                });
            }
        } catch  {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return children({
            node: node,
            result: result
        });
    }, [
        actions,
        children,
        content,
        extensionHandlers,
        extensionKey,
        extensionType,
        localGetNodeRenderer,
        localId,
        marks,
        parameters,
        rendererContext === null || rendererContext === void 0 ? void 0 : rendererContext.adDoc,
        text,
        type
    ]);
    const setupAndRenderExtensionNode = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((providers)=>{
        if (!extensionProvider && providers.extensionProvider) handleProvider('extensionProvider', providers.extensionProvider);
        return renderExtensionNode(extensionProvider);
    }, [
        extensionProvider,
        handleProvider,
        renderExtensionNode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    if (!props.providers) return setupAndRenderExtensionNode({});
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8EivP.WithProviders), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        providerFactory: props.providers,
        renderNode: setupAndRenderExtensionNode
    });
}
const $95485cbf84267439$export$f41ccc3bd3324832 = ({ children: children, isPlainTextMacro: isPlainTextMacro, ssrPlaceholder: ssrPlaceholder, ssrPlaceholderReplace: ssrPlaceholderReplace })=>{
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `inline-extension-renderer ${isPlainTextMacro ? 'plain-text-macro' : ''}`,
        css: [
            $95485cbf84267439$var$inlineExtensionStyle,
            isPlainTextMacro && $95485cbf84267439$var$plainTextMacroStyle
        ],
        "data-ssr-placeholder": ssrPlaceholder,
        "data-ssr-placeholder-replace": ssrPlaceholderReplace
    }, children);
};

});
parcelRegister("wuhiB", function(module, exports) {
$parcel$export(module.exports, "getExtensionModuleNode", () => $5078c0a3d95b6b1b$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $5078c0a3d95b6b1b$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $5078c0a3d95b6b1b$export$67a7d49db68d30a0);

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $jk6Pl = parcelRequire("jk6Pl");

var $3H4LK = parcelRequire("3H4LK");

var $dnMMv = parcelRequire("dnMMv");

var $5geMn = parcelRequire("5geMn");

var $52OZ9 = parcelRequire("52OZ9");

var $6ajJq = parcelRequire("6ajJq");

function $5078c0a3d95b6b1b$var$getNodeFromManifest(// eslint-disable-next-line @typescript-eslint/no-explicit-any
manifest, extKey, nodeKey, extensionType, extensionKey) {
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $5078c0a3d95b6b1b$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $dnMMv.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    return $5078c0a3d95b6b1b$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
}
function $5078c0a3d95b6b1b$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey) {
    var _extensionProvider$ge;
    const [extKey, nodeKey] = (0, $dnMMv.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = extensionProvider === null || extensionProvider === void 0 || (_extensionProvider$ge = extensionProvider.getPreloadedExtension) === null || _extensionProvider$ge === void 0 ? void 0 : _extensionProvider$ge.call(extensionProvider, extensionType, extKey);
    if (manifest) return $5078c0a3d95b6b1b$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey);
    else return extensionProvider.getExtension(extensionType, extKey).then((manifest)=>$5078c0a3d95b6b1b$var$getNodeFromManifest(manifest, extKey, nodeKey, extensionType, extensionKey));
}
async function $5078c0a3d95b6b1b$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $5078c0a3d95b6b1b$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $5078c0a3d95b6b1b$var$isUnknownConfluenceMacroWithBody(extensionNode) {
    var _extensionNode$parame;
    return extensionNode !== null && extensionNode.type === 'extension' && extensionNode.extensionType === 'com.atlassian.confluence.macro.core' && !!((_extensionNode$parame = extensionNode.parameters) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.macroParams) !== null && _extensionNode$parame !== void 0 && (_extensionNode$parame = _extensionNode$parame.__bodyContent) !== null && _extensionNode$parame !== void 0 && _extensionNode$parame.value);
}
function $5078c0a3d95b6b1b$var$ExtensionLoading(props) {
    const intl = (0, $4MCQn.default)();
    const extensionNode = props.node;
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        if (props.error && props.showUnknownMacroPlaceholder && extensionNode && $5078c0a3d95b6b1b$var$isUnknownConfluenceMacroWithBody(extensionNode) && (0, $3H4LK.fg)('tinymce_display_unknown_macro_body_content')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6ajJq.UnknownMacroPlaceholder), {
            extensionNode: extensionNode
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", null, intl.formatMessage((0, $5geMn.messages).extensionLoadingError));
    } else return null;
}
function $5078c0a3d95b6b1b$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
        loader: ()=>{
            const maybePromise = $5078c0a3d95b6b1b$export$903681ffb5af37a7(extensionProvider, extensionType, extensionKey);
            if (maybePromise instanceof Promise) return maybePromise.then((node)=>(0, $dnMMv.resolveImport)(node.render()));
            else {
                var _renderSync, _ref;
                const preloaded = maybePromise === null || maybePromise === void 0 || (_renderSync = (_ref = maybePromise).renderSync) === null || _renderSync === void 0 ? void 0 : _renderSync.call(_ref);
                // Only product implemented preloading will return sync result
                // However the out-of-box won't handle this. Confluence uses a custom implementation
                return preloaded ? (0, $3H4LK.fg)('platform_editor_extension_renderer_promise_fix') ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Promise.resolve((0, $52OZ9.resolveImportSync)(preloaded)) : // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $52OZ9.resolveImportSync)(preloaded) : (0, $dnMMv.resolveImport)(maybePromise.render());
            }
        },
        // react-loadable passes all props from <NodeRenderer> to the loading component at runtime,
        // but its TypeScript types only expect LoadingComponentProps. We cast here because
        // ExtensionLoading accepts additional props (node, showUnknownMacroPlaceholder) that
        // react-loadable will pass through but doesn't know about in its type definitions.
        loading: $5078c0a3d95b6b1b$var$ExtensionLoading
    });
}

});
parcelRegister("dnMMv", function(module, exports) {
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_TYPE", () => $4f2087de3700cb59$export$862c0e8acc7585d7);
$parcel$export(module.exports, "NATIVE_EMBED_EXTENSION_KEY", () => $4f2087de3700cb59$export$b343a94058bea058);
$parcel$export(module.exports, "AGENT_MANAGED_EXTENSION_KEY", () => $4f2087de3700cb59$export$e400f4d17a615c24);
$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $4f2087de3700cb59$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $4f2087de3700cb59$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $4f2087de3700cb59$export$d69c9b451c47653b);

var $eMJ2w = parcelRequire("eMJ2w");

var $52OZ9 = parcelRequire("52OZ9");
const $4f2087de3700cb59$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $4f2087de3700cb59$export$862c0e8acc7585d7 = 'com.atlassian.confluence.macro.core';
const $4f2087de3700cb59$export$b343a94058bea058 = 'native-embed';
const $4f2087de3700cb59$export$e400f4d17a615c24 = 'agent-managed-block';
const $4f2087de3700cb59$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $4f2087de3700cb59$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
function $4f2087de3700cb59$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $4f2087de3700cb59$export$33863d887d6f4bfd(action, manifest);
}
const $4f2087de3700cb59$export$d69c9b451c47653b = async (importPromise)=>{
    return (0, $52OZ9.resolveImportSync)(await importPromise);
};
function $4f2087de3700cb59$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = (0, $eMJ2w.buildExtensionKeyAndNodeKey)(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});
parcelRegister("eMJ2w", function(module, exports) {
$parcel$export(module.exports, "buildExtensionKeyAndNodeKey", () => $c04d54a9a22310c5$export$5f3eb042babacbbd);
const $c04d54a9a22310c5$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};

});

parcelRegister("52OZ9", function(module, exports) {
$parcel$export(module.exports, "resolveImportSync", () => $19fcee531cea41a0$export$dca2026e63034304);
const $19fcee531cea41a0$export$dca2026e63034304 = (importedModule)=>{
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};

});


parcelRegister("5geMn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $8016437d44b3da6e$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");

const $8016437d44b3da6e$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    edit: {
        id: 'fabric.editor.edit',
        defaultMessage: 'Edit',
        description: 'The text is shown as a button label in the extension context menu. Triggers opening the properties editor for the selected extension to modify its configuration.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting an extension linked to a data consumer.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'Label for a checkbox in a confirm modal that allows the user to also delete connected elements when deleting an extension.'
    },
    saveIndicator: {
        id: 'fabric.editor.extensions.config-panel.save-indicator',
        defaultMessage: 'All changes are always autosaved',
        description: 'Informational message displayed in the extension configuration panel to reassure users that their changes are being saved automatically without requiring manual save action.'
    },
    panelLoadingError: {
        id: 'fabric.editor.extensions.config-panel.loading-error.non-final',
        defaultMessage: 'We ran into a bit of trouble. Refresh to try again.',
        description: 'Error message displayed when the extension configuration panel fails to load. Instructs users to refresh the page to attempt loading the panel again.'
    },
    extensionLoadingError: {
        id: 'fabric.editor.extension.loading-error',
        defaultMessage: 'Error loading the extension!',
        description: 'Error message displayed when an extension fails to load in the editor. Indicates a problem occurred during the extension initialization or rendering process.'
    },
    unknownMacroPlaceholderAriaLabel: {
        id: 'fabric.editor.extension.unknownMacroPlaceholderAriaLabel',
        defaultMessage: 'Unknown macro placeholder',
        description: 'Accessible label for the unknown macro fallback block shown when a Confluence macro cannot be resolved.'
    },
    unknownMacroHeader: {
        id: 'fabric.editor.extension.unknownMacroHeader',
        defaultMessage: "Unknown macro: ''{macroTitle}''",
        description: 'Header text for an unresolved Confluence macro placeholder.'
    }
});

});

parcelRegister("6ajJq", function(module, exports) {
$parcel$export(module.exports, "UnknownMacroPlaceholder", () => $1c759622f4c950e1$export$414b5225f50e455b);
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4MCQn = parcelRequire("4MCQn");

var $4mqcS = parcelRequire("4mqcS");

var $5geMn = parcelRequire("5geMn");
// Unknown macro placeholder styling aligned with Legacy Content Macro (LCM) for consistent look
const $1c759622f4c950e1$var$neutralBorder = "var(--ds-background-neutral, #0515240F)";
const $1c759622f4c950e1$var$unknownMacroContainerStyles = null;
// Match LCM header exactly: lcmHeaderStyles from LegacyContentHeader/index.tsx
const $1c759622f4c950e1$var$unknownMacroHeaderStyles = null;
// Match LCM content area: white surface, text color inherits
const $1c759622f4c950e1$var$unknownMacroBodyStyles = null;
const $1c759622f4c950e1$var$unknownMacroPreStyles = null;
const $1c759622f4c950e1$var$formatParam = (key, param)=>{
    const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
    return `${key} = ${value}`;
};
const $1c759622f4c950e1$var$EMPTY_MACRO_PARAMS = {};
function $1c759622f4c950e1$export$414b5225f50e455b({ extensionNode: extensionNode }) {
    var _extensionNode$parame, _extensionNode$parame2, _extensionNode$parame3, _extensionNode$parame4;
    const intl = (0, $4MCQn.default)();
    const macroTitle = ((_extensionNode$parame = extensionNode.parameters) === null || _extensionNode$parame === void 0 || (_extensionNode$parame = _extensionNode$parame.macroMetadata) === null || _extensionNode$parame === void 0 ? void 0 : _extensionNode$parame.title) || extensionNode.extensionKey;
    const bodyContent = (_extensionNode$parame2 = extensionNode.parameters) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.macroParams) === null || _extensionNode$parame2 === void 0 || (_extensionNode$parame2 = _extensionNode$parame2.__bodyContent) === null || _extensionNode$parame2 === void 0 ? void 0 : _extensionNode$parame2.value;
    const macroParamsOld = ((_extensionNode$parame3 = extensionNode.parameters) === null || _extensionNode$parame3 === void 0 ? void 0 : _extensionNode$parame3.macroParams) ?? {};
    const macroParams = ((_extensionNode$parame4 = extensionNode.parameters) === null || _extensionNode$parame4 === void 0 ? void 0 : _extensionNode$parame4.macroParams) ?? $1c759622f4c950e1$var$EMPTY_MACRO_PARAMS;
    const formatParamInline = (key, param)=>{
        const value = String((param === null || param === void 0 ? void 0 : param.value) ?? '').trim();
        return `${key} = ${value}`;
    };
    const memoizedVisibleParams = (0, $4fqPo.useMemo)(()=>Object.entries(macroParams).filter(([key])=>!key.startsWith('_')).map(([key, param])=>$1c759622f4c950e1$var$formatParam(key, param)).join(' | '), [
        macroParams
    ]);
    const visibleParams = (0, $4mqcS.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedVisibleParams : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    Object.entries(macroParamsOld).filter(([key])=>!key.startsWith('_')).map(([key, param])=>formatParamInline(key, param)).join(' | ');
    const headerText = visibleParams ? `${intl.formatMessage((0, $5geMn.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    })} | ${visibleParams}` : intl.formatMessage((0, $5geMn.messages).unknownMacroHeader, {
        macroTitle: macroTitle
    });
    return /*#__PURE__*/ $4fqPo.createElement("section", {
        "aria-label": intl.formatMessage((0, $5geMn.messages).unknownMacroPlaceholderAriaLabel),
        className: (0, $ltgDR.default)([
            "_19it1tra _2rko12b0 _1reo15vq _18m915vq _bfhkhp5a"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2rko14xi _11c8wadc _n7zlbjo2 _bfhki8nm _ca0qu2gc _u5f3pxbi _n3td1b66 _19bvpxbi _kqswh2mm _154i1n1a"
        ])
    }, headerText), /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhkvuon _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("pre", {
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey _o5721jtm _1nmz1hna _6z24egat"
        ])
    }, bodyContent)));
}

});


parcelRegister("8EivP", function(module, exports) {
$parcel$export(module.exports, "WithProviders", () => $a8b40cf8c238d98b$export$d498ee8be33e096f);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $4fqPo = parcelRequire("4fqPo");
class $a8b40cf8c238d98b$export$d498ee8be33e096f extends (0, $4fqPo.PureComponent) {
    static #_ = this.displayName = 'WithProviders';
    constructor(props){
        super(props), this.mounted = false, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProviderIfMounted = (name, provider)=>{
            if (!this.mounted) return;
            this.handleProvider(name, provider);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        this.mounted = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const providers = {};
        this.props.providers.forEach((name)=>{
            const providerPromise = props.providerFactory.subscribe(name, this.handleProviderIfMounted);
            providers[name] = providerPromise;
        });
        this.state = {
            providers: providers
        };
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProviderIfMounted);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("h8UjM", function(module, exports) {
$parcel$export(module.exports, "getExtensionRenderer", () => $e5120ab0c5324812$export$9214452ef07eda7);
function $e5120ab0c5324812$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("2qSQf", function(module, exports) {
$parcel$export(module.exports, "shadowClassNames", () => $51b59393b4331703$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $51b59393b4331703$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $96Ayf = parcelRequire("96Ayf");

var $6pavR = parcelRequire("6pavR");
const $51b59393b4331703$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $51b59393b4331703$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $96Ayf.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            var _this$props, _this$props2;
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            const classNames = [
                !((_this$props = this.props) !== null && _this$props !== void 0 && _this$props.disableTableOverflowShadow) && showRightShadow && $51b59393b4331703$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                !((_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.disableTableOverflowShadow) && showLeftShadow && $51b59393b4331703$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $6pavR.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            /**
       * The widths have already been calculated to determine
       * showRightShadow and showLeftShadow. If either is true,
       * then the content is scrollable and we need to set the
       * tabIndex to 0 to allow the user to scroll the content
       * for a11y purposes.
       */ const hasOverflowScroll = showRightShadow || showLeftShadow;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
                handleRef: this.handleContainer,
                tabIndex: hasOverflowScroll ? 0 : undefined,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.overflowContainerWidth = 0, this.state = {
                showLeftShadow: false,
                showRightShadow: false
            }, this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            }, this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            }, this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            }, this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            }, this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    if ($51b59393b4331703$var$isElementNode(scrollableElement)) width += scrollableElement.scrollWidth;
                }
                return width;
            }, this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}
// Helper function to check if the passed node is of Element class
function $51b59393b4331703$var$isElementNode(node) {
    return node.nodeType === 1;
}

});
parcelRegister("96Ayf", function(module, exports) {
$parcel$export(module.exports, "ShadowObserver", () => $7a67134d670bde39$export$51a5b28e4fb2dba2);

var $4mqcS = parcelRequire("4mqcS");

var $bYkNj = parcelRequire("bYkNj");

var $6pavR = parcelRequire("6pavR");
const $7a67134d670bde39$var$requestIdleCallback = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.requestIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $7a67134d670bde39$var$cancelIdleCallback = (id)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return window.cancelIdleCallback ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $7a67134d670bde39$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            [(0, $bYkNj.ShadowKeys).SHOW_LEFT_SHADOW]: false,
            [(0, $bYkNj.ShadowKeys).SHOW_RIGHT_SHADOW]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add((0, $6pavR.shadowObserverClassNames).SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add((0, $6pavR.shadowObserverClassNames).SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $7a67134d670bde39$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains((0, $6pavR.shadowObserverClassNames).SENTINEL_LEFT)) this.shadowStates[(0, $bYkNj.ShadowKeys).SHOW_LEFT_SHADOW] = !entry.isIntersecting;
                if (entry.target.classList.contains((0, $6pavR.shadowObserverClassNames).SENTINEL_RIGHT)) this.shadowStates[(0, $bYkNj.ShadowKeys).SHOW_RIGHT_SHADOW] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $7a67134d670bde39$var$cancelIdleCallback(this.requestCallbackId);
        }
        if ((0, $4mqcS.expValEquals)('platform_editor_renderer_shadow_observer_cleanup', 'isEnabled', true)) {
            var _this$sentinels$left, _this$sentinels$right;
            (_this$sentinels$left = this.sentinels.left) === null || _this$sentinels$left === void 0 || _this$sentinels$left.remove();
            (_this$sentinels$right = this.sentinels.right) === null || _this$sentinels$right === void 0 || _this$sentinels$right.remove();
            this.sentinels = {};
        }
    }
}

});
parcelRegister("bYkNj", function(module, exports) {
$parcel$export(module.exports, "ShadowKeys", () => $c856953dc3f7e2ce$export$ebeea2fe2e93862e);
var $c856953dc3f7e2ce$export$ebeea2fe2e93862e = /*#__PURE__*/ function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
    return ShadowKeys;
}({});

});

parcelRegister("6pavR", function(module, exports) {
$parcel$export(module.exports, "shadowObserverClassNames", () => $3c68ac8c28b298c5$export$1cbe0bb16052178d);
const $3c68ac8c28b298c5$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};

});



parcelRegister("7VVBW", function(module, exports) {
$parcel$export(module.exports, "breakoutConsts", () => $dc20837017e5a344$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $dc20837017e5a344$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $dc20837017e5a344$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $dc20837017e5a344$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $dc20837017e5a344$export$c377853ecdd53e5b);

var $faPFq = parcelRequire("faPFq");

var $bGK06 = parcelRequire("bGK06");

var $ag3hq = parcelRequire("ag3hq");

var $5c6Du = parcelRequire("5c6Du");




const $dc20837017e5a344$export$ead1fecec2ecf57c = {
    padding: (0, $faPFq.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $faPFq.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $faPFq.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $faPFq.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $faPFq.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $bGK06.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $ag3hq.getBreakpoint,
    /**
   * This function can return percentage value or px value depending upon the inputs
   */ calcBreakoutWidth: (breakoutConsts)=>(layout, containerWidth, padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            switch(layout){
                case 'full-width':
                    return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                case 'wide':
                    if (effectiveFullWidth <= 0) return '100%';
                    const wideWidth = breakoutConsts.calcWideWidth(breakoutConsts)(containerWidth, undefined, undefined, padding);
                    if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, breakoutConsts.fullWidthLayoutWidth)}px`;
                    return wideWidth;
                default:
                    return '100%';
            }
        },
    calcBreakoutWithCustomWidth: (breakoutConsts)=>(mode, width, editorContainerWidth)=>{
            if (width !== null && width > 0) {
                const effectiveFullWidth = editorContainerWidth - breakoutConsts.padding;
                // if below 0 then expect we're rendering in SSR
                return `${Math.min(width, effectiveFullWidth)}px`;
            }
            return breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, editorContainerWidth);
        },
    calcLineLength: (breakoutConsts)=>()=>breakoutConsts.defaultLayoutWidth,
    calcWideWidth: (breakoutConsts)=>(containerWidth = breakoutConsts.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
            const effectiveFullWidth = containerWidth - (padding ?? breakoutConsts.padding);
            const layoutMaxWidth = breakoutConsts.mapBreakpointToLayoutMaxWidth(breakoutConsts.getBreakpoint(containerWidth));
            const wideWidth = Math.min(Math.ceil(layoutMaxWidth * breakoutConsts.wideScaleRatio), effectiveFullWidth);
            return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
        }
};
const $dc20837017e5a344$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $dc20837017e5a344$export$ead1fecec2ecf57c.calcBreakoutWidth($dc20837017e5a344$export$ead1fecec2ecf57c)(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $faPFq.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $faPFq.akEditorWideLayoutWidth;
        default:
            return $dc20837017e5a344$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($dc20837017e5a344$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $dc20837017e5a344$export$86325001fe8f3adc = $dc20837017e5a344$export$ead1fecec2ecf57c.calcWideWidth($dc20837017e5a344$export$ead1fecec2ecf57c);
const $dc20837017e5a344$export$5f4502874a28dfce = $dc20837017e5a344$export$ead1fecec2ecf57c.calcBreakoutWidth($dc20837017e5a344$export$ead1fecec2ecf57c);
const $dc20837017e5a344$export$ccc0a02edddeed39 = $dc20837017e5a344$export$ead1fecec2ecf57c.calcBreakoutWithCustomWidth($dc20837017e5a344$export$ead1fecec2ecf57c);
function $dc20837017e5a344$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $dc20837017e5a344$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $5c6Du.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $faPFq.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $faPFq.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $dc20837017e5a344$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $5c6Du.parsePx)($dc20837017e5a344$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}

});
parcelRegister("5c6Du", function(module, exports) {
$parcel$export(module.exports, "parsePx", () => $dfbb72b9717cd7ee$export$b0eef8cd00b29d5c);
/**
 * Util for converting a css pixel size value to a number (of pixels).
 *
 * ie.
 * ```ts
 * const pixels = parsePx('10px')
 * //    ^$ const pixels: number
 * ```
 * * ```ts
 * const pixels = parsePx('10')
 * //    ^$ const pixels: number | undefined
 * ```
 */ // At time of writting prettier would strip the extend here.
// prettier-ignore
function $dfbb72b9717cd7ee$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}

});


parcelRegister("jANeU", function(module, exports) {
$parcel$export(module.exports, "RendererCssClassName", () => $dc5448002d0d0556$export$91f3bbbf974496e2);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $dc5448002d0d0556$var$clPrefix = 'ak-renderer-';
const $dc5448002d0d0556$export$91f3bbbf974496e2 = {
    FLEX_CENTER_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}flex-center-wrapper`,
    DOCUMENT: `${$dc5448002d0d0556$var$clPrefix}document`,
    EXTENSION: `${$dc5448002d0d0556$var$clPrefix}extension`,
    EXTENSION_AS_INLINE: `${$dc5448002d0d0556$var$clPrefix}extension-as-inline`,
    EXTENSION_CENTER_ALIGN: `${$dc5448002d0d0556$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$dc5448002d0d0556$var$clPrefix}extension-overflow-container`,
    EXTENSION_INNER_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}extension-inner-wrapper`,
    /** Wrapper for center-aligned extensions/MBE; margin here so it participates in collapse */ STICKY_SAFE_CENTER_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}sticky-safe-center-wrapper`,
    /** Wrapper for center-aligned embed card (wide/full-width); margin here so it participates in collapse */ EMBED_CARD_CENTER_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}embed-card-center-wrapper`,
    /** Wrapper for center-aligned block card datasource (wide/full-width); margin here so it participates in collapse */ BLOCK_CARD_DATASOURCE_CENTER_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}block-card-datasource-center-wrapper`,
    /** Outer flex wrapper for sticky-safe breakout (has vertical margin); zero margin when first in doc */ STICKY_SAFE_BREAKOUT_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}sticky-safe-breakout-wrapper`,
    /** Flex item in sticky-safe breakout; zero first/last child margin so flex container height matches legacy */ STICKY_SAFE_BREAKOUT_INNER: `${$dc5448002d0d0556$var$clPrefix}sticky-safe-breakout-inner`,
    NUMBER_COLUMN: `${$dc5448002d0d0556$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$dc5448002d0d0556$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$dc5448002d0d0556$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$dc5448002d0d0556$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});

parcelRegister("g0CJe", function(module, exports) {
$parcel$export(module.exports, "calcBreakoutWidthCss", () => $1ad2e9de42c2bc80$export$87eeb477611c8fe);
const $1ad2e9de42c2bc80$export$87eeb477611c8fe = (layout)=>{
    if (layout === 'full-width') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--full-width-layout-width))';
    if (layout === 'wide') return 'min(var(--ak-editor--breakout-container-without-gutter-width), var(--ak-editor--breakout-wide-layout-width))';
    return '100%';
};

});


parcelRegister("f5eyN", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $d9802a6c2eeffb85$export$e926676385687eaf);

var $4fqPo = parcelRequire("4fqPo");

var $f0GG4 = parcelRequire("f0GG4");

var $6niD6 = parcelRequire("6niD6");

var $cgAqn = parcelRequire("cgAqn");

var $dQtpO = parcelRequire("dQtpO");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $d9802a6c2eeffb85$var$FAILED_TO_EXECUTE_REGEX = /Failed to execute.*on 'Node'.*/;
class $d9802a6c2eeffb85$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $6niD6.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $f0GG4.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $dQtpO.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`,
                componentStack: (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.componentStack) || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $cgAqn.logException)(error, {
            location: 'renderer'
        });
        const matchesPattern = $d9802a6c2eeffb85$var$FAILED_TO_EXECUTE_REGEX.test(error.message);
        if (matchesPattern) {
            this.fireAnalyticsEvent({
                action: (0, $f0GG4.ACTION).CAUGHT_DOM_ERROR,
                actionSubject: this.props.component,
                actionSubjectId: this.props.componentId,
                eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    platform: (0, $dQtpO.PLATFORM).WEB,
                    errorMessage: `${additionalInfo}${error === null || error === void 0 ? void 0 : error.message}`
                }
            });
            this.setState((prevState)=>({
                    domError: true,
                    domErrorCount: prevState.domErrorCount + 1
                }));
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, {
            key: this.state.domErrorCount
        }, this.props.children);
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false,
            domError: false,
            domErrorCount: 0
        };
    }
}

});
parcelRegister("cgAqn", function(module, exports) {
$parcel$export(module.exports, "logException", () => $f0b0881f599b4cfa$export$f86b2a1a2ce291b3);

var $8c8XG = parcelRequire("8c8XG");

var $3H4LK = parcelRequire("3H4LK");

var $38An3 = parcelRequire("38An3");

var $9kLK4 = parcelRequire("9kLK4");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f0b0881f599b4cfa$var$NETWORK_ERROR_REGEX = /^network error/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f0b0881f599b4cfa$var$NETWORK_FAILURE_REGEX = /^network failure/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f0b0881f599b4cfa$var$RESIZE_OBSERVER_LOOP_REGEX = /ResizeObserver loop completed with undelivered notifications/;
const $f0b0881f599b4cfa$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $f0b0881f599b4cfa$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $f0b0881f599b4cfa$var$packageVersion = undefined;
const $f0b0881f599b4cfa$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $f0b0881f599b4cfa$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await Promise.resolve((parcelRequire("8c8XG")));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("1c0np"));
        const breadcrumbsIntegration = (0, $3H4LK.fg)('platform_editor_sentry_breadcrumbs') ? new (0, $8c8XG.Integrations).Breadcrumbs({
            // only enable breadcrumbs for dom (UI clicks and inputs)
            // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
            dom: {
                serializeAttribute: (0, $9kLK4.SERIALIZABLE_ATTRIBUTES)
            },
            fetch: false,
            xhr: false,
            console: false,
            history: false,
            sentry: false
        }) : undefined;
        const sentryOptions = {
            dsn: (0, $38An3.isFedRamp)() ? undefined : $f0b0881f599b4cfa$var$SENTRY_DSN,
            release: `${$f0b0881f599b4cfa$var$packageName}@${$f0b0881f599b4cfa$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            beforeBreadcrumb: (0, $3H4LK.fg)('platform_editor_sentry_breadcrumbs') ? (0, $9kLK4.normaliseSentryBreadcrumbs) : undefined,
            ignoreErrors: [
                // Network issues
                $f0b0881f599b4cfa$var$NETWORK_ERROR_REGEX,
                $f0b0881f599b4cfa$var$NETWORK_FAILURE_REGEX,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                $f0b0881f599b4cfa$var$RESIZE_OBSERVER_LOOP_REGEX
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    ...breadcrumbsIntegration ? [
                        breadcrumbsIntegration
                    ] : [],
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $f0b0881f599b4cfa$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        // @ts-ignore - TypeScript 5.9.2 upgrade
        hub.bindClient(client);
        hub.withScope((scope)=>{
            var _buildInfo;
            scope.setTags({
                // Jira environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-bundler': window.BUNDLER_VERSION,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-variant': window.BUILD_VARIANT,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                'confluence-frontend-version': (_buildInfo = window.__buildInfo) === null || _buildInfo === void 0 ? void 0 : _buildInfo.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        // @ts-ignore - TypeScript 5.9.2 upgrade
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("38An3", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", () => $b076da69d22ba526$export$64d6499adf9b2e51);
const $b076da69d22ba526$var$FEDRAMP_MODERATE = 'fedramp-moderate';
// Ignored via go/ees005
/* eslint-disable require-unicode-regexp */ const $b076da69d22ba526$var$FEDRAMP_HOSTNAME_REGEX = /atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/;
function $b076da69d22ba526$export$64d6499adf9b2e51() {
    var _global$location;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $b076da69d22ba526$var$FEDRAMP_MODERATE;
    const matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match($b076da69d22ba526$var$FEDRAMP_HOSTNAME_REGEX);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("9kLK4", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $e84d8b22077313eb$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $e84d8b22077313eb$export$6f14342128c6eaa4);
const $e84d8b22077313eb$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $e84d8b22077313eb$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$e84d8b22077313eb$export$b5bdb04ea16a02e3
];
const $e84d8b22077313eb$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$e84d8b22077313eb$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gmu');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $e84d8b22077313eb$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($e84d8b22077313eb$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $e84d8b22077313eb$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category !== null && category !== void 0 && category.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $e84d8b22077313eb$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("1c0np", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bVqMb").then(()=>parcelRequire('4JQG7'));

});


parcelRegister("dQtpO", function(module, exports) {
$parcel$export(module.exports, "PLATFORM", () => $85319fc5f0f03520$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $85319fc5f0f03520$export$e48589d9e4824227);
var $85319fc5f0f03520$export$88c4881e092abcaf = /*#__PURE__*/ function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
    return PLATFORM;
}({});
var $85319fc5f0f03520$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $85319fc5f0f03520$var$RESOLVE_METHOD = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}($85319fc5f0f03520$var$RESOLVE_METHOD || {});

});


parcelRegister("49Bjt", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", () => $88b4ab0293fc589e$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $88b4ab0293fc589e$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $88b4ab0293fc589e$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $88b4ab0293fc589e$export$9957974f8b4d8f74);
var $88b4ab0293fc589e$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $88b4ab0293fc589e$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInfo";
    return ACTION;
}({});
var $88b4ab0293fc589e$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    return ACTION_SUBJECT;
}({});
var $88b4ab0293fc589e$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_DOWNLOAD"] = "codeBlockDownload";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    return ACTION_SUBJECT_ID;
}({});

});

parcelRegister("8sZ3k", function(module, exports) {
$parcel$export(module.exports, "AnnotationsPositionContext", () => $e1e688780253d5be$export$8c8c3e12db6c0591);
$parcel$export(module.exports, "AnnotationsWrapper", () => $e1e688780253d5be$export$cef0157dd42cbb3f);

var $4fqPo = parcelRequire("4fqPo");

var $6ctpG = parcelRequire("6ctpG");

var $3psvv = parcelRequire("3psvv");

var $ln2Rs = parcelRequire("ln2Rs");

var $2wRng = parcelRequire("2wRng");

var $7M6hH = parcelRequire("7M6hH");

var $lsmh1 = parcelRequire("lsmh1");

var $ew3Bn = parcelRequire("ew3Bn");

var $afZ8o = parcelRequire("afZ8o");

var $8gaUl = parcelRequire("8gaUl");

var $huEyE = parcelRequire("huEyE");
const $e1e688780253d5be$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    (0, $7M6hH.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    });
    return null;
});
const $e1e688780253d5be$export$8c8c3e12db6c0591 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext({
    startPos: 1
});
const $e1e688780253d5be$export$7121915072388536 = (props)=>{
    var _providers$inlineComm;
    const { children: children, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    const providers = (0, $4fqPo.useContext)((0, $2wRng.ProvidersContext));
    const updateSubscriber = providers && providers.inlineComment && providers.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $lsmh1.useAnnotationStateByTypeEvent)({
        type: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2wRng.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $afZ8o.AnnotationRangeProvider), {
        allowCommentsOnMedia: (providers === null || providers === void 0 || (_providers$inlineComm = providers.inlineComment) === null || _providers$inlineComm === void 0 ? void 0 : _providers$inlineComm.allowCommentsOnMedia) ?? false,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8gaUl.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ln2Rs.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        isNestedRender: isNestedRender
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e1e688780253d5be$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3psvv.AnnotationView), {
        isNestedRender: isNestedRender,
        createAnalyticsEvent: createAnalyticsEvent
    }), children))));
};
const $e1e688780253d5be$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete } = props;
    if (!isNestedRender && annotationProvider !== null && annotationProvider !== void 0 && annotationProvider.annotationManager) {
        var _annotationProvider$i;
        // We need to ensure there is a single instance of the annotation manager for the whole document
        // and that it is the same instance for all annotations.
        // This is because the annotation manager is responsible for managing the state of ALL annotations.
        // This includes annotations inside extensions.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2wRng.ProvidersContext).Provider, {
            value: annotationProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $huEyE.AnnotationManagerProvider), {
            annotationManager: annotationProvider.annotationManager,
            updateSubscriber: (annotationProvider === null || annotationProvider === void 0 || (_annotationProvider$i = annotationProvider.inlineComment) === null || _annotationProvider$i === void 0 ? void 0 : _annotationProvider$i.updateSubscriber) ?? undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e1e688780253d5be$export$7121915072388536, {
            rendererRef: rendererRef,
            adfDocument: adfDocument,
            isNestedRender: isNestedRender,
            onLoadComplete: onLoadComplete
        }, children)));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2wRng.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e1e688780253d5be$export$7121915072388536, {
        rendererRef: rendererRef,
        adfDocument: adfDocument,
        isNestedRender: isNestedRender,
        onLoadComplete: onLoadComplete
    }, children));
};

});
parcelRegister("3psvv", function(module, exports) {
$parcel$export(module.exports, "AnnotationView", () => $47586835b9de1b99$export$41cd4a02859c2806);

var $4fqPo = parcelRequire("4fqPo");

var $2wRng = parcelRequire("2wRng");

var $lsmh1 = parcelRequire("lsmh1");

var $eCph8 = parcelRequire("eCph8");
const $47586835b9de1b99$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $4fqPo.useContext)((0, $2wRng.ProvidersContext));
    const actionContext = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const viewComponentProps = (0, $lsmh1.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isNestedRender: props.isNestedRender
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $4fqPo.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $4fqPo.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});
parcelRegister("2wRng", function(module, exports) {
$parcel$export(module.exports, "ProvidersContext", () => $d8a1c93683b39419$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $d8a1c93683b39419$export$aafe46a36ef535ba);

var $4fqPo = parcelRequire("4fqPo");
const $d8a1c93683b39419$export$6a26b015ac619737 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $d8a1c93683b39419$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $4fqPo.createContext)({});

});

parcelRegister("lsmh1", function(module, exports) {
$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $e730857776fed9ab$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $e730857776fed9ab$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $e730857776fed9ab$export$26cf539704e444c1);

var $4fqPo = parcelRequire("4fqPo");

var $2SqHb = parcelRequire("2SqHb");

var $6ctpG = parcelRequire("6ctpG");

var $f0GG4 = parcelRequire("f0GG4");

var $6niD6 = parcelRequire("6niD6");

var $huEyE = parcelRequire("huEyE");
const $e730857776fed9ab$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $4fqPo.useState)({});
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $huEyE.useAnnotationManagerDispatch)();
    const { annotations: annotations } = (0, $huEyE.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            return ()=>{
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
            };
        }
    }, [
        states,
        type,
        updateSubscriber,
        dispatch,
        isAnnotationManagerEnabled
    ]);
    const annotationMarkStates = (0, $4fqPo.useMemo)(()=>{
        return Object.values(annotations).reduce((acc, curr)=>{
            return {
                ...acc,
                [curr.id]: curr.markState
            };
        }, {});
    }, [
        annotations
    ]);
    if (isAnnotationManagerEnabled) return annotationMarkStates;
    else return states;
};
const $e730857776fed9ab$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $4fqPo.useState)(false);
    const [isHovered, setIsHovered] = (0, $4fqPo.useState)(false);
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentHoveredAnnotationId: currentHoveredAnnotationId } = (0, $huEyE.useAnnotationManagerState)();
    const { annotationManager: annotationManager } = (0, $huEyE.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const callbackForHoveredAnnotation = (payload)=>{
            setIsHovered(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
        };
        const removeHoverEffect = ()=>{
            setIsHovered(false);
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, removeHoverEffect);
            return ()=>{
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, callbackForHoveredAnnotation);
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, removeHoverEffect);
            };
        }
    }, [
        id,
        updateSubscriber,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return {
        hasFocus: currentSelectedAnnotationId === id,
        isHovered: currentHoveredAnnotationId === id
    };
    else return {
        hasFocus: hasFocus,
        isHovered: isHovered
    };
};
const $e730857776fed9ab$var$NO_ANNOTATION_SELECTED = {
    annotations: [],
    clickElementTarget: undefined
};
const $e730857776fed9ab$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $4fqPo.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isNestedRender: isNestedRender } = props;
    const { annotationManager: annotationManager } = (0, $huEyE.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    const { currentSelectedAnnotationId: currentSelectedAnnotationId, currentSelectedMarkRef: currentSelectedMarkRef } = (0, $huEyE.useAnnotationManagerState)();
    const selectedAnnotation = (0, $4fqPo.useMemo)(()=>{
        return currentSelectedAnnotationId && currentSelectedMarkRef && currentSelectedMarkRef.id === currentSelectedAnnotationId ? {
            annotations: [
                {
                    id: currentSelectedAnnotationId,
                    type: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
                }
            ],
            clickElementTarget: currentSelectedMarkRef
        } : // This is a constant to represent the case when no annotation is selected.
        // When creating a new annotation, currentSelectedAnnotationId and currentSelectedMarkRef will be set one after another,
        // if this isn't a const, it will cause useMemo to return two different "empty" objects and causes infinite re-renders.
        $e730857776fed9ab$var$NO_ANNOTATION_SELECTED;
    }, [
        currentSelectedAnnotationId,
        currentSelectedMarkRef
    ]);
    (0, $4fqPo.useLayoutEffect)(()=>{
        if (!updateSubscriber || isNestedRender) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).VIEWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    targetNodeType: eventTargetType,
                    method: viewMethod
                }
            }).fire((0, $6niD6.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
        };
        if (!isAnnotationManagerEnabled) {
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            return ()=>{
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
                updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
            };
        }
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isNestedRender,
        isAnnotationManagerEnabled
    ]);
    if (isAnnotationManagerEnabled) return isNestedRender ? null : selectedAnnotation;
    else return annotationClickEvent;
};

});
parcelRegister("2SqHb", function(module, exports) {
$parcel$export(module.exports, "AnnotationUpdateEvent", () => $dd8c072fe2dd8803$export$c1c4b33b4e7b1c70);

var $fRMcu = parcelRequire("fRMcu");
var $dd8c072fe2dd8803$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $dd8c072fe2dd8803$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($fRMcu)))();
    }
}

});

parcelRegister("huEyE", function(module, exports) {
$parcel$export(module.exports, "AnnotationManagerProvider", () => $fb79d462e8c00eeb$export$f21fb05766361bb3);
$parcel$export(module.exports, "useAnnotationManagerState", () => $fb79d462e8c00eeb$export$654a1fb45487f838);
$parcel$export(module.exports, "useAnnotationManagerDispatch", () => $fb79d462e8c00eeb$export$12cbbb89fb7702d0);

var $4fqPo = parcelRequire("4fqPo");

var $6ctpG = parcelRequire("6ctpG");

var $2SqHb = parcelRequire("2SqHb");

var $eCph8 = parcelRequire("eCph8");
const $fb79d462e8c00eeb$var$initState = {
    isDrafting: false,
    draftId: undefined,
    draftMarkRef: undefined,
    draftActionResult: undefined,
    annotations: {},
    currentSelectedAnnotationId: undefined,
    currentSelectedMarkRef: undefined,
    currentHoveredAnnotationId: undefined
};
const $fb79d462e8c00eeb$var$AnnotationManagerStateContext = /*#__PURE__*/ (0, $4fqPo.createContext)($fb79d462e8c00eeb$var$initState);
const $fb79d462e8c00eeb$var$AnnotationManagerDispatchContext = /*#__PURE__*/ (0, $4fqPo.createContext)({
    annotationManager: undefined,
    dispatch: ()=>{}
});
function $fb79d462e8c00eeb$var$reducer(state, action) {
    switch(action.type){
        case 'reset':
            return {
                ...state,
                ...$fb79d462e8c00eeb$var$initState
            };
        case 'loadAnnotation':
            {
                const currentIds = Object.keys(state.annotations);
                const uids = Array.from(new Set(currentIds.concat(action.data.map((a)=>a.id))));
                const updates = [];
                for (const id of uids){
                    var _state$annotations$id, _state$annotations$id2;
                    const loadedAnnotation = action.data.find((a)=>a.id === id);
                    if (!loadedAnnotation && ((_state$annotations$id = state.annotations[id]) === null || _state$annotations$id === void 0 ? void 0 : _state$annotations$id.markState) === (0, $6ctpG.AnnotationMarkStates).ACTIVE) {
                        // If the annotation is not in the loaded data, we need to remove it from the state. However,
                        // rather then removing it, we will set the mark state to resolved. This is to align it better with
                        // how the editor works.
                        updates.push({
                            id: id,
                            markState: (0, $6ctpG.AnnotationMarkStates).RESOLVED
                        });
                        continue;
                    }
                    if (!!(loadedAnnotation !== null && loadedAnnotation !== void 0 && loadedAnnotation.markState) && ((_state$annotations$id2 = state.annotations[id]) === null || _state$annotations$id2 === void 0 ? void 0 : _state$annotations$id2.markState) !== loadedAnnotation.markState) {
                        updates.push({
                            id: id,
                            markState: loadedAnnotation.markState
                        });
                        continue;
                    }
                }
                if (updates.length > 0) return {
                    ...state,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'updateAnnotation':
            {
                const current = state.annotations[action.data.id];
                const { id: id, selected: selected, hovered: hovered, markState: markState = current === null || current === void 0 ? void 0 : current.markState } = action.data;
                const updates = [];
                // If the annotation is not currently in the state, we need to add it to the state.
                if (!current) updates.push({
                    id: id,
                    markState: markState ?? (0, $6ctpG.AnnotationMarkStates).ACTIVE
                });
                // The goal of the following is to enforce a single selection and a single hover state across all annotations.
                let nextSelectedId = state.currentSelectedAnnotationId;
                if (selected && nextSelectedId !== id) nextSelectedId = id;
                // If the annotation is currently selected and it's being unselected, we need to remove it from the
                // current selected annotation id.
                if (selected === false && nextSelectedId === id) nextSelectedId = undefined;
                let nextHoveredId = state.currentHoveredAnnotationId;
                if (hovered && nextHoveredId !== id) nextHoveredId = id;
                // If the annotation is currently hovered and it's being unhovered, we need to remove it from the
                // current hovered annotation id.
                if (hovered === false && nextHoveredId === id) nextHoveredId = undefined;
                // If the annotations mark state is not the same as the current mark state, we need to update it.
                if ((current === null || current === void 0 ? void 0 : current.markState) !== markState) {
                    updates.push({
                        id: id,
                        markState: markState ?? (0, $6ctpG.AnnotationMarkStates).ACTIVE
                    });
                    // If the annotation is currently selected and it's being resolved, then we need to remove it from the
                    // current selected annotation id also.
                    if (markState === (0, $6ctpG.AnnotationMarkStates).RESOLVED && nextSelectedId === id) nextSelectedId = undefined;
                }
                if (updates.length > 0 || nextSelectedId !== state.currentSelectedAnnotationId || nextHoveredId !== state.currentHoveredAnnotationId) return {
                    ...state,
                    currentSelectedAnnotationId: nextSelectedId,
                    currentHoveredAnnotationId: nextHoveredId,
                    annotations: updates.reduce((nextAnnotations, update)=>{
                        return {
                            ...nextAnnotations,
                            [update.id]: {
                                ...nextAnnotations[update.id],
                                ...update
                            }
                        };
                    }, state.annotations)
                };
                return state;
            }
        case 'resetSelectedAnnotation':
            if (state.currentSelectedAnnotationId !== undefined) return {
                ...state,
                currentSelectedAnnotationId: undefined,
                currentSelectedMarkRef: undefined
            };
            return state;
        case 'resetHoveredAnnotation':
            if (state.currentHoveredAnnotationId !== undefined) return {
                ...state,
                currentHoveredAnnotationId: undefined
            };
            return state;
        case 'setDrafting':
            if (state.isDrafting !== action.data.isDrafting || state.draftId !== action.data.draftId || state.draftActionResult !== action.data.draftActionResult) // XXX: When a draft is open the current selected annotation should no longer be selected. We need
            // to decide what is better UX,
            // 1 - do we want to deselct the selected annotation on draft open, if so then when draft is closed the s
            // selected annotation will not come back
            // 2 - do we want to still allow the selected annotation to be selected when draft is open, however the underlying
            // mark style just shows the annotation as not selected when a draft is active. Then when a draft closes
            // we can reopen the previous selected annotation.
            return {
                ...state,
                isDrafting: action.data.isDrafting,
                draftId: action.data.draftId,
                draftActionResult: action.data.draftActionResult
            };
            return state;
        case 'setDraftMarkRef':
            if (state.draftMarkRef !== action.data.draftMarkRef) return {
                ...state,
                draftMarkRef: action.data.draftMarkRef
            };
            return state;
        case 'setSelectedMarkRef':
            if (state.currentSelectedMarkRef !== action.data.markRef) return {
                ...state,
                currentSelectedMarkRef: action.data.markRef
            };
            return state;
    }
}
const $fb79d462e8c00eeb$export$f21fb05766361bb3 = ({ children: children, annotationManager: annotationManager, updateSubscriber: updateSubscriber })=>{
    const [state, dispatch] = (0, $4fqPo.useReducer)($fb79d462e8c00eeb$var$reducer, $fb79d462e8c00eeb$var$initState);
    const actionContext = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    (0, $4fqPo.useEffect)(()=>{
        const getDraft = ()=>{
            if (!state.isDrafting || !state.draftActionResult || !state.draftMarkRef || !state.draftId) return {
                success: false,
                reason: 'draft-not-started'
            };
            return {
                success: true,
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('getDraft', getDraft);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('getDraft', getDraft);
        };
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    // We need to watch for the draft mark element to exist, so we can inform any listeners that the draft has been started
    // and give them a reference to the element
    (0, $4fqPo.useEffect)(()=>{
        if (state.isDrafting && state.draftId && state.draftMarkRef && state.draftActionResult) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'draftAnnotationStarted',
            data: {
                inlineNodeTypes: state.draftActionResult.inlineNodeTypes ?? [],
                targetElement: state.draftMarkRef,
                actionResult: {
                    step: state.draftActionResult.step,
                    doc: state.draftActionResult.doc,
                    inlineNodeTypes: state.draftActionResult.inlineNodeTypes,
                    targetNodeType: state.draftActionResult.targetNodeType,
                    originalSelection: state.draftActionResult.originalSelection,
                    numMatches: state.draftActionResult.numMatches,
                    matchIndex: state.draftActionResult.matchIndex,
                    pos: state.draftActionResult.pos
                }
            }
        });
    }, [
        annotationManager,
        state.draftId,
        state.isDrafting,
        state.draftMarkRef,
        state.draftActionResult
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const setIsAnnotationSelected = (id, isSelected)=>{
            var _state$annotations;
            if (state.isDrafting) return {
                success: false,
                reason: 'draft-in-progress'
            };
            if (!((_state$annotations = state.annotations) !== null && _state$annotations !== void 0 && _state$annotations[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            // the annotation is currently not selected and is being selected
            if (id !== state.currentSelectedAnnotationId && isSelected) {
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true
                    }
                });
                dispatch({
                    type: 'setSelectedMarkRef',
                    data: {
                        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- resolve mark node by id in the document
                        markRef: document.getElementById(id) || undefined
                    }
                });
            } else if (id === state.currentSelectedAnnotationId && !isSelected) dispatch({
                type: 'resetSelectedAnnotation'
            });
            return {
                success: true,
                isSelected: isSelected
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelected);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelected);
        };
    }, [
        annotationManager,
        state.isDrafting,
        state.annotations,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    const prevSelectedAnnotationId = (0, $4fqPo.useRef)(undefined);
    (0, $4fqPo.useEffect)(()=>{
        if (prevSelectedAnnotationId.current) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: prevSelectedAnnotationId.current,
                isSelected: false,
                inlineNodeTypes: []
            }
        });
        prevSelectedAnnotationId.current = state.currentSelectedAnnotationId;
    }, [
        state.currentSelectedAnnotationId,
        annotationManager
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (state.currentSelectedAnnotationId && state.currentSelectedMarkRef && state.currentSelectedMarkRef.id === state.currentSelectedAnnotationId) annotationManager === null || annotationManager === void 0 || annotationManager.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: state.currentSelectedAnnotationId,
                isSelected: true,
                inlineNodeTypes: []
            }
        });
    }, [
        annotationManager,
        state.currentSelectedAnnotationId,
        state.currentSelectedMarkRef
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const setIsAnnotationHovered = (id, isHovered)=>{
            var _state$annotations2;
            if (!((_state$annotations2 = state.annotations) !== null && _state$annotations2 !== void 0 && _state$annotations2[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: id,
                    hovered: isHovered
                }
            });
            return {
                success: true,
                isHovered: isHovered
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHovered);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHovered);
        };
    }, [
        annotationManager,
        state.annotations
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const clearAnnotation = (id)=>{
            var _state$annotations3;
            if (!((_state$annotations3 = state.annotations) !== null && _state$annotations3 !== void 0 && _state$annotations3[id])) return {
                success: false,
                reason: 'id-not-valid'
            };
            const result = actionContext.deleteAnnotation(id, (0, $6ctpG.AnnotationTypes).INLINE_COMMENT);
            if (!result) return {
                success: false,
                reason: 'clear-failed'
            };
            const { step: step, doc: doc } = result;
            return {
                success: true,
                actionResult: {
                    step: step,
                    doc: doc
                }
            };
        };
        annotationManager === null || annotationManager === void 0 || annotationManager.hook('clearAnnotation', clearAnnotation);
        return ()=>{
            annotationManager === null || annotationManager === void 0 || annotationManager.unhook('clearAnnotation', clearAnnotation);
        };
    }, [
        annotationManager,
        state.annotations,
        actionContext
    ]);
    /**
   * This is a temporary solution to ensure that the annotation manager state is in sync with the
   * old updateSubscriber. The updateSubscriber will eventually be deprecated and the state will be managed
   * by the annotation manager itself.
   */ (0, $4fqPo.useEffect)(()=>{
        const onSetAnnotationState = (payload)=>{
            if (!payload) return;
            Object.values(payload).forEach((annotation)=>{
                if (annotation.id && annotation.annotationType === (0, $6ctpG.AnnotationTypes).INLINE_COMMENT) dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: annotation.id,
                        markState: annotation.state ?? undefined
                    }
                });
            });
        };
        const onAnnotationSelected = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    selected: true
                }
            });
        };
        const onAnnotationHovered = (payload)=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: payload.annotationId,
                    hovered: true
                }
            });
        };
        const onAnnotationSelectedRemoved = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        const onAnnotationHoveredRemoved = ()=>{
            dispatch({
                type: 'resetHoveredAnnotation'
            });
        };
        const onAnnotationClick = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: _eventTargetType, viewMethod: _viewMethod })=>{
            dispatch({
                type: 'updateAnnotation',
                data: {
                    id: annotationIds[0],
                    selected: true
                }
            });
            dispatch({
                type: 'setSelectedMarkRef',
                data: {
                    markRef: eventTarget
                }
            });
        };
        const onAnnotationDeselect = ()=>{
            dispatch({
                type: 'resetSelectedAnnotation'
            });
        };
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
        updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.on((0, $2SqHb.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        return ()=>{
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_STATE, onSetAnnotationState);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, onAnnotationSelected);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_HOVERED, onAnnotationHovered);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, onAnnotationSelectedRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).REMOVE_ANNOTATION_HOVERED, onAnnotationHoveredRemoved);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, onAnnotationClick);
            updateSubscriber === null || updateSubscriber === void 0 || updateSubscriber.off((0, $2SqHb.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, onAnnotationDeselect);
        };
    }, [
        updateSubscriber
    ]);
    const dispatchData = (0, $4fqPo.useMemo)(()=>({
            annotationManager: annotationManager,
            dispatch: dispatch
        }), [
        annotationManager,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($fb79d462e8c00eeb$var$AnnotationManagerStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($fb79d462e8c00eeb$var$AnnotationManagerDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $fb79d462e8c00eeb$export$654a1fb45487f838 = ()=>{
    return (0, $4fqPo.useContext)($fb79d462e8c00eeb$var$AnnotationManagerStateContext);
};
const $fb79d462e8c00eeb$export$12cbbb89fb7702d0 = ()=>{
    return (0, $4fqPo.useContext)($fb79d462e8c00eeb$var$AnnotationManagerDispatchContext);
};

});
parcelRegister("eCph8", function(module, exports) {
$parcel$export(module.exports, "RendererContext", () => $dc8b2fab93058f34$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $dc8b2fab93058f34$export$66feffbad722f9d4);
/* eslint-disable jsdoc/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $ew3Bn = parcelRequire("ew3Bn");
parcelRequire("lkz0W");
var $6niD6 = parcelRequire("6niD6");

var $f0GG4 = parcelRequire("f0GG4");

var $eACNl = parcelRequire("eACNl");
const $dc8b2fab93058f34$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(new (0, $eACNl.default)());
function $dc8b2fab93058f34$export$66feffbad722f9d4({ children: children, context: context }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const actions = (0, $4fqPo.useMemo)(()=>new (0, $eACNl.default)(true), []);
    // Remove this eventually when root cause is assessed
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.count(children) > 1 && (0, $3H4LK.fg)('confluence_frontend_fix_view_page_slo')) // Send event when we get more than 1 child
    try {
        throw new Error('Too many children');
    } catch (e) {
        const { stack: stack } = e;
        createAnalyticsEvent({
            eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
            action: 'rendered',
            actionSubject: 'multipleChildren',
            actionSubjectId: 'rendererActionsContext',
            attributes: {
                numChildren: (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.count(children),
                stackTrace: stack
            }
        }).fire((0, $6niD6.FabricChannel).editor);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($dc8b2fab93058f34$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, $3H4LK.fg)('confluence_frontend_fix_view_page_slo') ? (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(children) : children);
}
const $dc8b2fab93058f34$export$d5fcf151601331bc = $dc8b2fab93058f34$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("eACNl", function(module, exports) {
$parcel$export(module.exports, "default", () => $293600e9f91b127f$export$2e2bcd8739ae039);

var $6ctpG = parcelRequire("6ctpG");

var $4CcLg = parcelRequire("4CcLg");

var $khjyi = parcelRequire("khjyi");

var $b0juN = parcelRequire("b0juN");

var $f0GG4 = parcelRequire("f0GG4");

var $2fkcs = parcelRequire("2fkcs");

var $3H4LK = parcelRequire("3H4LK");

var $6VM75 = parcelRequire("6VM75");

var $kHvo2 = parcelRequire("kHvo2");

var $eAoF9 = parcelRequire("eAoF9");

var $7JtwR = parcelRequire("7JtwR");
class $293600e9f91b127f$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $khjyi.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
   * Validate whether we can create an annotation between two positions
   */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        const currentSelection = (0, $b0juN.TextSelection).create(this.doc, from, to);
        if ((0, $4CcLg.isEmptyTextSelectionRenderer)(currentSelection, this.schema)) return false;
        const result = (0, $4CcLg.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
        return result;
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $2fkcs.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $2fkcs.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $f0GG4.ACTION).DELETED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $2fkcs.RemoveMarkStep) ? (0, $kHvo2.getRendererRangeInlineNodeNames)({
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, _annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $6VM75.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $6VM75.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRangeAnnotatable(range) {
        try {
            var _startContainer$paren, _endContainer$parentE;
            if (!range) return false;
            const { startContainer: startContainer, endContainer: endContainer } = range;
            if ((_startContainer$paren = startContainer.parentElement) !== null && _startContainer$paren !== void 0 && _startContainer$paren.closest('.ak-renderer-extension') || (_endContainer$parentE = endContainer.parentElement) !== null && _endContainer$parentE !== void 0 && _endContainer$parentE.closest('.ak-renderer-extension')) return false;
            return this.isValidAnnotationRange(range);
        } catch  {
            // isValidAnnotationRange can fail when called inside nested renderers.
            // while isRendererWithinRange guards against this to some degree -- the classnames
            // are controlled by product -- and we don't have platform guarantees on them.
            //
            // Currently there is a mix of logic across the platform and confluence on determining
            // positions that are annotatable. This is a defensive check to ensure we don't throw an error
            // in cases where the range is not valid.
            return false;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * This is replaced by `isRangeAnnotatable`.
   *
   * @deprecated
   **/ isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
   * Note: False indicates that the selection not able to be calculated.
   */ getPositionFromRange(range) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $6VM75.getPosFromRange)(range);
    }
    getSelectionContext() {
        return (0, $7JtwR.getSelectionContext)({
            doc: this.doc,
            schema: this.schema
        });
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $6VM75.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $4CcLg.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        // As part of fix for RAP, `from` points to the position right before media node
        // hence, -1 is not needed
        const beforeNodePos = from;
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if ((possibleNode === null || possibleNode === void 0 ? void 0 : possibleNode.type.name) === 'media') {
            targetNodeType = 'media';
            step = new (0, $2fkcs.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $6VM75.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $eAoF9.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $kHvo2.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            ancestorNodeTypes: (0, $kHvo2.getRendererRangeAncestorNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            targetNodeType: targetNodeType
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $eAoF9.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Do not forget to remove `undefined` when the `editor_inline_comments_on_inline_nodes` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $4CcLg.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("4CcLg", function(module, exports) {
$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $4e8df1de115a1b8a$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $4e8df1de115a1b8a$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $4e8df1de115a1b8a$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $4e8df1de115a1b8a$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $4e8df1de115a1b8a$export$35054451202ed5d9);
$parcel$export(module.exports, "getRangeAncestorNodeNames", () => $4e8df1de115a1b8a$export$2a160f09551a3adc);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $4e8df1de115a1b8a$export$8261bc1f662f3f6e);
$parcel$export(module.exports, "getAnnotationMarksForPos", () => $4e8df1de115a1b8a$export$bb1945a828f2864b);
$parcel$export(module.exports, "isEmptyTextSelection", () => $4e8df1de115a1b8a$export$2efbc6d84ea0fbec);
$parcel$export(module.exports, "isEmptyTextSelectionRenderer", () => $4e8df1de115a1b8a$export$a35880e7ecdcf47b);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $6ctpG = parcelRequire("6ctpG");

var $3H4LK = parcelRequire("3H4LK");
const $4e8df1de115a1b8a$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !(parent !== null && parent !== void 0 && parent.type.allowsMarkType(schema.marks.annotation))) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $4e8df1de115a1b8a$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    const annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $4e8df1de115a1b8a$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $4e8df1de115a1b8a$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $4e8df1de115a1b8a$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($4e8df1de115a1b8a$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $4e8df1de115a1b8a$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        doc.nodesBetween(pos.from, pos.to, (node)=>{
            if (node.isInline) nodeNames.add(node.type.name);
        });
        // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
        const sortedNames = [
            ...nodeNames
        ].sort();
        return sortedNames;
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $4e8df1de115a1b8a$export$2a160f09551a3adc({ doc: doc, pos: pos }) {
    if (!(0, $3H4LK.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const nodeNames = new Set();
    try {
        // For a range, we can get ancestors at both from and to positions
        // or just use the from position if you want ancestors at the start
        const resolvedFromPos = doc.resolve(pos.from);
        const resolvedToPos = doc.resolve(pos.to);
        // Collect ancestors at the 'from' position
        for(let depth = resolvedFromPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedFromPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        // Use nodesBetween to collect parent types without additional resolve() calls
        // This isn't as precise as calling resolve() on each parent, but it's a lot faster
        // and should hopefully provide a good approximation of the ancestor nodes
        const seenParents = new Set();
        doc.nodesBetween(pos.from, pos.to, (_node, _nodePos, parent)=>{
            // Collect parent chain using the parent parameter
            const currentParent = parent;
            if (!!currentParent && !seenParents.has(currentParent)) {
                seenParents.add(currentParent);
                nodeNames.add(currentParent.type.name);
            // Note: We can't easily get the parent's parent from this context
            // without additional resolve calls, so this approach has limitations
            }
            return true;
        });
        // Optionally collect ancestors at the 'to' position if different
        // This ensures we capture all ancestor contexts across the range
        if (pos.from !== pos.to) for(let depth = resolvedToPos.depth; depth > 0; depth--){
            const ancestorNode = resolvedToPos.node(depth);
            nodeNames.add(ancestorNode.type.name);
        }
        return [
            ...nodeNames
        ];
    } catch  {
        // Some callers have existing gaps where the positions are not valid,
        // and so when called in the current document can throw an error if out of range.
        //
        // This is a defensive check to ensure we don't throw an error in those cases.
        return undefined;
    }
}
function $4e8df1de115a1b8a$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, _pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}
function $4e8df1de115a1b8a$export$bb1945a828f2864b(pos) {
    const annotationMarks = pos.marks().filter((mark)=>mark.type === pos.doc.type.schema.marks.annotation);
    return annotationMarks;
}
function $4e8df1de115a1b8a$export$2efbc6d84ea0fbec(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for not a text or nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type !== text || !node.textContent) hasContent = true;
        return !hasContent;
    });
    return !hasContent;
}
function $4e8df1de115a1b8a$export$a35880e7ecdcf47b(selection, schema) {
    const { text: text, paragraph: paragraph } = schema.nodes;
    let hasContent = false;
    selection.content().content.descendants((node)=>{
        // for empty paragraph - consider empty (nothing to comment on)
        if (node.type === paragraph && !node.content.size) return false;
        // for inline elements - consider nonempty
        if (node.type !== text && node.type.isInline) hasContent = true;
        // for nonempty text - consider nonempty (can comment if the node is supported for annotations)
        if (node.type === text && !!node.textContent) hasContent = true;
        // for other non-text nodes - continue descending
        return !hasContent;
    });
    return !hasContent;
}

});

parcelRegister("khjyi", function(module, exports) {
$parcel$export(module.exports, "nodeToJSON", () => $3ce9bdb3cca39f10$export$3a858d3babd60825);
$parcel$export(module.exports, "JSONTransformer", () => $3ce9bdb3cca39f10$export$98cb1d9308d0944d);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2186w = parcelRequire("2186w");

var $1rzDq = parcelRequire("1rzDq");
var $4u3vK = parcelRequire("4u3vK");
var $4a4SQ = parcelRequire("4a4SQ");
var $d04vw = parcelRequire("d04vw");
var $dwqYv = parcelRequire("dwqYv");
var $1lZPC = parcelRequire("1lZPC");
var $0585H = parcelRequire("0585H");
var $aRXZh = parcelRequire("aRXZh");
var $clekI = parcelRequire("clekI");

var $eevQH = parcelRequire("eevQH");

var $l2KXw = parcelRequire("l2KXw");

var $izEqX = parcelRequire("izEqX");
var $3ce9bdb3cca39f10$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $3ce9bdb3cca39f10$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $3ce9bdb3cca39f10$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $3ce9bdb3cca39f10$var$isCodeBlock = $3ce9bdb3cca39f10$var$isType('codeBlock');
const $3ce9bdb3cca39f10$var$isMediaNode = $3ce9bdb3cca39f10$var$isType('media');
const $3ce9bdb3cca39f10$var$isMediaInline = $3ce9bdb3cca39f10$var$isType('mediaInline');
const $3ce9bdb3cca39f10$var$isMediaSingleNode = $3ce9bdb3cca39f10$var$isType('mediaSingle');
const $3ce9bdb3cca39f10$var$isMentionNode = $3ce9bdb3cca39f10$var$isType('mention');
const $3ce9bdb3cca39f10$var$isParagraph = $3ce9bdb3cca39f10$var$isType('paragraph');
const $3ce9bdb3cca39f10$var$isHeading = $3ce9bdb3cca39f10$var$isType('heading');
const $3ce9bdb3cca39f10$var$isTable = $3ce9bdb3cca39f10$var$isType('table');
const $3ce9bdb3cca39f10$var$isTableCell = $3ce9bdb3cca39f10$var$isType('tableCell');
const $3ce9bdb3cca39f10$var$isTableHeader = $3ce9bdb3cca39f10$var$isType('tableHeader');
const $3ce9bdb3cca39f10$var$isLinkMark = $3ce9bdb3cca39f10$var$isType('link');
const $3ce9bdb3cca39f10$var$isUnsupportedMark = $3ce9bdb3cca39f10$var$isType('unsupportedMark');
const $3ce9bdb3cca39f10$var$isUnsupportedNodeAttributeMark = $3ce9bdb3cca39f10$var$isType('unsupportedNodeAttribute');
const $3ce9bdb3cca39f10$var$isExpand = $3ce9bdb3cca39f10$var$isType('expand');
const $3ce9bdb3cca39f10$var$isNestedExpand = $3ce9bdb3cca39f10$var$isType('nestedExpand');
const $3ce9bdb3cca39f10$var$isUnsupportedNode = (node)=>$3ce9bdb3cca39f10$var$isType('unsupportedBlock')(node) || $3ce9bdb3cca39f10$var$isType('unsupportedInline')(node);
const $3ce9bdb3cca39f10$var$isDataConsumer = $3ce9bdb3cca39f10$var$isType('dataConsumer');
const $3ce9bdb3cca39f10$var$isFragmentMark = $3ce9bdb3cca39f10$var$isType('fragment');
const $3ce9bdb3cca39f10$var$isHardBreak = $3ce9bdb3cca39f10$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3ce9bdb3cca39f10$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $3ce9bdb3cca39f10$var$filterNull(current);
    }
    return output;
};
const $3ce9bdb3cca39f10$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $3ce9bdb3cca39f10$var$emptyDoc = $3ce9bdb3cca39f10$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ const $3ce9bdb3cca39f10$export$3a858d3babd60825 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($3ce9bdb3cca39f10$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($3ce9bdb3cca39f10$var$isMediaNode(node)) obj.attrs = (0, $0585H.toJSON)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isMediaSingleNode(node)) obj.attrs = (0, $1lZPC.toJSON)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isMediaInline(node)) obj.attrs = (0, $0585H.toJSON)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isMentionNode(node)) obj.attrs = (0, $aRXZh.toJSON)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isCodeBlock(node)) obj.attrs = (0, $1rzDq.toJSON)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isTable(node)) obj.attrs = (0, $clekI.tableToJSON)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isTableCell(node)) obj.attrs = (0, $clekI.toJSONTableCell)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isTableHeader(node)) obj.attrs = (0, $clekI.toJSONTableHeader)(node).attrs;
    else if ($3ce9bdb3cca39f10$var$isExpand(node) || $3ce9bdb3cca39f10$var$isNestedExpand(node)) obj.attrs = (0, $4a4SQ.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $3ce9bdb3cca39f10$var$filterNull(obj.attrs);
    if ($3ce9bdb3cca39f10$var$isMentionNode(node) && mentionMap) {
        var _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = ((_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($3ce9bdb3cca39f10$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $3ce9bdb3cca39f10$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($3ce9bdb3cca39f10$export$3a858d3babd60825(child, mentionMap));
    });
    if ($3ce9bdb3cca39f10$var$isParagraph(node) || $3ce9bdb3cca39f10$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($3ce9bdb3cca39f10$var$isUnsupportedMark(mark)) return $3ce9bdb3cca39f10$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($3ce9bdb3cca39f10$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($3ce9bdb3cca39f10$var$isLinkMark(mark)) return (0, $dwqYv.toJSON)(mark);
            else if ($3ce9bdb3cca39f10$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                const serialised = (0, $4u3vK.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($3ce9bdb3cca39f10$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $d04vw.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($3ce9bdb3cca39f10$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$3ce9bdb3cca39f10$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $3ce9bdb3cca39f10$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $l2KXw.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $3ce9bdb3cca39f10$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $3ce9bdb3cca39f10$export$98cb1d9308d0944d {
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $eevQH.defaultSchema), mentionMap){
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $izEqX.sanitizeNode)($3ce9bdb3cca39f10$export$3a858d3babd60825(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($2186w)))(content, $3ce9bdb3cca39f10$var$emptyDoc.content)) return $3ce9bdb3cca39f10$var$createDocFromContent([]);
        return $3ce9bdb3cca39f10$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $eevQH.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($3ce9bdb3cca39f10$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $izEqX.sanitizeNode)($3ce9bdb3cca39f10$export$3a858d3babd60825(node, this.mentionMap));
    }
}
function $3ce9bdb3cca39f10$export$1c4065b3a9f04cf2(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}

});
parcelRegister("l2KXw", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", () => $36dca51524b263e7$export$28e4e3c024cce988);
const $36dca51524b263e7$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $36dca51524b263e7$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $36dca51524b263e7$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $36dca51524b263e7$var$defaultAllowOverrideBehaviour;
        default:
            return $36dca51524b263e7$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("izEqX", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", () => $eb2bd8e78bfee5b6$export$48b382180baf8e88);

var $cMDK4 = parcelRequire("cMDK4");

var $jFbx9 = parcelRequire("jFbx9");

var $geHRD = parcelRequire("geHRD");
const $eb2bd8e78bfee5b6$var$hasNestedTable = (tableCellNode)=>{
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some((node)=>(node === null || node === void 0 ? void 0 : node.type) === 'table');
};
function $eb2bd8e78bfee5b6$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $jFbx9.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $geHRD.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($eb2bd8e78bfee5b6$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $cMDK4.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($eb2bd8e78bfee5b6$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $cMDK4.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        panel_c1: (node)=>({
                ...node,
                type: 'panel'
            }),
        emoji: (0, $geHRD.removeNonAnnotationMarks),
        mention: (0, $geHRD.removeNonAnnotationMarks),
        date: (0, $geHRD.removeNonAnnotationMarks),
        hardBreak: (0, $geHRD.removeMarks),
        inlineCard: (0, $geHRD.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("cMDK4", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", () => $e1d697203d6e9cd4$export$18544d0b5f43e4a1);
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", () => $e1d697203d6e9cd4$export$8a334a7d9fe120ec);

var $jFbx9 = parcelRequire("jFbx9");

var $ip0RI = parcelRequire("ip0RI");

var $8Wxro = parcelRequire("8Wxro");
const $e1d697203d6e9cd4$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $e1d697203d6e9cd4$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $e1d697203d6e9cd4$export$f45e7335ec874bfe = (extensionNode)=>{
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $e1d697203d6e9cd4$var$NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $e1d697203d6e9cd4$var$NESTED_TABLE_EXTENSION_KEY;
};
const $e1d697203d6e9cd4$var$transformNestedTableExtension = (nestedTableExtension)=>{
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        const adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $8Wxro.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
const $e1d697203d6e9cd4$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jFbx9.traverse)(adf, {
        extension: (node)=>{
            if ($e1d697203d6e9cd4$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $e1d697203d6e9cd4$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $e1d697203d6e9cd4$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        var _tableCellNode$conten;
        return {
            ...tableCellNode,
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map((childNode)=>{
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $ip0RI.extension)({
                    extensionType: $e1d697203d6e9cd4$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $e1d697203d6e9cd4$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $8Wxro.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("ip0RI", function(module, exports) {
$parcel$export(module.exports, "extension", () => $fdb668d461b85ad4$export$1b45514b112dd749);
const $fdb668d461b85ad4$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });

});

parcelRegister("8Wxro", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", () => $d403d10b33d71d8b$export$3d8e8d2182f13924);
/** NodeNestingTransformError  */ class $d403d10b33d71d8b$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}

});


parcelRegister("geHRD", function(module, exports) {
$parcel$export(module.exports, "removeMarks", () => $5f99201dc894867f$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $5f99201dc894867f$export$8cae9126fc577085);
function $5f99201dc894867f$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $5f99201dc894867f$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});



parcelRegister("6VM75", function(module, exports) {
$parcel$export(module.exports, "getStartPos", () => $208845db9467d9ad$export$aabc9b13a308cc43);
$parcel$export(module.exports, "findParent", () => $208845db9467d9ad$export$25245567f53f158f);
$parcel$export(module.exports, "getPosFromRange", () => $208845db9467d9ad$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $208845db9467d9ad$export$74899f7e5acb5cd3);
/* eslint-disable jsdoc/require-jsdoc -- internal step helpers */ 
var $3H4LK = parcelRequire("3H4LK");

var $2fkcs = parcelRequire("2fkcs");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $208845db9467d9ad$var$MEDIA_OR_MEDIA_SINGLE_REGEX = /media|mediaSingle/;
function $208845db9467d9ad$export$aabc9b13a308cc43(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $208845db9467d9ad$var$getNodeType = (element)=>element.dataset.nodeType;
function $208845db9467d9ad$var$isPositionPointer(element) {
    return $208845db9467d9ad$export$aabc9b13a308cc43(element) > -1;
}
function $208845db9467d9ad$export$25245567f53f158f(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $208845db9467d9ad$export$9d1d5d87ae7da22f(parentElement)) return null;
    if ($208845db9467d9ad$var$isPositionPointer(parentElement)) return parentElement;
    return $208845db9467d9ad$export$25245567f53f158f(parentElement);
}
function $208845db9467d9ad$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $208845db9467d9ad$export$9d1d5d87ae7da22f(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $208845db9467d9ad$var$findMediaParent(parentElement);
}
function $208845db9467d9ad$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($208845db9467d9ad$export$9d1d5d87ae7da22f(parentElement) || !parentElement) return null;
    if ($208845db9467d9ad$var$isPositionPointer(parentElement)) return element;
    return $208845db9467d9ad$var$findParentBeforePointer(parentElement);
}
function $208845db9467d9ad$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $208845db9467d9ad$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $208845db9467d9ad$var$isHighlightTextNode(node) {
    var _dataset;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return !!(node !== null && node !== void 0 && (_dataset = node.dataset) !== null && _dataset !== void 0 && _dataset.highlighted);
}
function $208845db9467d9ad$var$isNodeInlineMark(node) {
    return $208845db9467d9ad$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $208845db9467d9ad$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $208845db9467d9ad$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $208845db9467d9ad$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
   * This checks if the element has any descendents with the data-inline-card
   * attribute set to 'true'. If it does, we should not consider it as an
   * inline text mark.
   **/ if ($208845db9467d9ad$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $208845db9467d9ad$var$hasInlineNodeDescendant(node) {
    if ($208845db9467d9ad$var$isElementNode(node)) {
        if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($208845db9467d9ad$var$hasInlineNodeDescendant);
    }
    return false;
}
function $208845db9467d9ad$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev.nodeType === Node.COMMENT_NODE) {
            // Comment nodes should not result in the position being
            // incremented, so we skip them.
            prev = prev.previousSibling;
            continue;
        }
        if (prev && ($208845db9467d9ad$var$isTextNode(prev) || $208845db9467d9ad$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) {
                if ($208845db9467d9ad$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($208845db9467d9ad$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $208845db9467d9ad$export$9d1d5d87ae7da22f(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $208845db9467d9ad$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) {
        var _node$parentElement;
        const startPosAncestor = (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.closest('[data-renderer-start-pos');
        const potentialParent = (0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor !== null && startPosAncestor !== void 0 && startPosAncestor.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10) + 1;
            else return parseInt((startPosAncestor === null || startPosAncestor === void 0 ? void 0 : startPosAncestor.getAttribute('data-renderer-start-pos')) || '-1', 10);
        }
    }
    /**
   * If anchor node is an element (e.g. after a triple click) the anchorOffset
   * is the number of child nodes preceding the anchor.
   * https://developer.mozilla.org/en-US/docs/Web/API/Selection/anchorOffset
   *
   * For end pos we calculate the number of characters by stepping through
   * each of the node's children.
   */ if (node instanceof HTMLElement && $208845db9467d9ad$var$isPositionPointer(node)) {
        if (findEnd) {
            let count = $208845db9467d9ad$export$aabc9b13a308cc43(node);
            const children = node.childNodes;
            for(let i = 0; i < offset; i++){
                var _children$i;
                count += ((_children$i = children[i]) === null || _children$i === void 0 || (_children$i = _children$i.textContent) === null || _children$i === void 0 ? void 0 : _children$i.length) || 1;
            }
            return count;
        }
        return $208845db9467d9ad$export$aabc9b13a308cc43(node) + offset;
    }
    const parent = $208845db9467d9ad$export$25245567f53f158f(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $208845db9467d9ad$export$aabc9b13a308cc43(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $208845db9467d9ad$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!($208845db9467d9ad$var$isNodeInlineTextMark(preParentPointer) || $208845db9467d9ad$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($208845db9467d9ad$var$isElementInlineMark(preParentPointer) || $208845db9467d9ad$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $208845db9467d9ad$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $208845db9467d9ad$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $208845db9467d9ad$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $208845db9467d9ad$export$243cdddc5b21d8c1(range) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $208845db9467d9ad$export$25245567f53f158f(startContainer);
    // Video hover targets return media single, not media, thus, the extra check in condition.
    const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && $208845db9467d9ad$var$MEDIA_OR_MEDIA_SINGLE_REGEX.test($208845db9467d9ad$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
    if (isMediaOrMediaSingle) {
        let pos;
        const mediaSingleElement = $208845db9467d9ad$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $208845db9467d9ad$var$findMediaParent(possibleMediaOrMediaSingleElement);
        if (mediaSingleElement) pos = $208845db9467d9ad$export$aabc9b13a308cc43(mediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $208845db9467d9ad$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $208845db9467d9ad$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $208845db9467d9ad$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $2fkcs.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("kHvo2", function(module, exports) {
$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $e86a7ef58aba7790$export$b0ea72d31617ccea);
$parcel$export(module.exports, "getRendererRangeAncestorNodeNames", () => $e86a7ef58aba7790$export$1726c23d64498b6);

var $4CcLg = parcelRequire("4CcLg");

var $3H4LK = parcelRequire("3H4LK");
function $e86a7ef58aba7790$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $4CcLg.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}
function $e86a7ef58aba7790$export$1726c23d64498b6({ actions: actions, pos: pos }) {
    if (!(0, $3H4LK.fg)('cc_comments_log_draft_annotation_ancestor_nodes')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const ancestorNodeNames = (0, $4CcLg.getRangeAncestorNodeNames)({
        doc: doc,
        pos: pos
    });
    return ancestorNodeNames;
}

});

parcelRegister("eAoF9", function(module, exports) {
$parcel$export(module.exports, "getIndexMatch", () => $336429a842680bd5$export$fb7dab895a0d310e);
function $336429a842680bd5$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $336429a842680bd5$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $336429a842680bd5$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $336429a842680bd5$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("7JtwR", function(module, exports) {
$parcel$export(module.exports, "getSelectionContext", () => $05e626d6221dd5af$export$3726c4866ce829b5);

var $b0juN = parcelRequire("b0juN");

var $jO6GS = parcelRequire("jO6GS");
var $b2X6u = parcelRequire("b2X6u");

var $6VM75 = parcelRequire("6VM75");
const $05e626d6221dd5af$export$3726c4866ce829b5 = ({ doc: doc, schema: schema })=>{
    if (!doc || !schema) return null;
    const selection = document.getSelection();
    if (!selection || selection.type !== 'Range' || selection.rangeCount !== 1) return null;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return null;
    const startNode = (0, $6VM75.findParent)(range.startContainer);
    const endNode = (0, $6VM75.findParent)(range.endContainer);
    if (!startNode || !endNode) return null;
    const startPos = (0, $6VM75.getStartPos)(startNode);
    const endPos = (0, $6VM75.getStartPos)(endNode);
    if (startPos === null || endPos === null) return null;
    const pos = (0, $6VM75.getPosFromRange)(range);
    if (!pos) return null;
    const from = Math.min(pos.from, pos.to);
    const to = Math.max(pos.from, pos.to);
    if (from === to) return null;
    let pmSelection;
    try {
        pmSelection = (0, $b0juN.TextSelection).create(doc, from, to);
    } catch  {
        return null;
    }
    const startIndex = from - startPos;
    const endIndex = to - endPos;
    if (startIndex < 0 || endIndex < 0) return null;
    const selectionFragment = (0, $jO6GS.getFragmentsFromSelection)(pmSelection);
    const localIds = (0, $b2X6u.getLocalIdsFromSelection)(pmSelection);
    return {
        localIds: localIds,
        selectionFragment: selectionFragment,
        selectionMarkdown: null,
        startIndex: startIndex,
        endIndex: endIndex
    };
};

});
parcelRegister("jO6GS", function(module, exports) {
$parcel$export(module.exports, "getFragmentsFromSelection", () => $dd33570055072163$export$dae3dcae007fe30);

var $khjyi = parcelRequire("khjyi");

var $8IckC = parcelRequire("8IckC");
const $dd33570055072163$export$dae3dcae007fe30 = (selection)=>{
    if (!selection || selection.empty) return null;
    const slice = (0, $8IckC.getSliceFromSelection)(selection);
    const content = slice.content;
    const fragment = [];
    content.forEach((node)=>{
        fragment.push((0, $khjyi.nodeToJSON)(node));
    });
    return fragment;
};

});
parcelRegister("8IckC", function(module, exports) {
$parcel$export(module.exports, "getSliceFromSelection", () => $672a621e80803f53$export$4fd509032ef7561b);

var $7p5u4 = parcelRequire("7p5u4");

var $b0juN = parcelRequire("b0juN");


const $672a621e80803f53$var$listDepth = 3;
const $672a621e80803f53$export$8701765a689d47ab = ($from, $to)=>{
    // Block level lists
    const listParents = [
        'bulletList',
        'orderedList'
    ];
    if ($from.depth >= $672a621e80803f53$var$listDepth && $to.depth >= $672a621e80803f53$var$listDepth && $from.depth === $to.depth) {
        var _greatGrandparentFrom, _greatGrandparentFrom2;
        // Get grandparents (from)
        const grandparentFrom = $from.node($from.depth - 1);
        const greatGrandparentFrom = $from.node($from.depth - 2);
        // Get grandparents (to)
        const grandparentTo = $to.node($from.depth - 1);
        const greatGrandparentTo = $to.node($from.depth - 2);
        if (greatGrandparentTo.eq(greatGrandparentFrom) && listParents.includes(greatGrandparentFrom.type.name) && // Selection covers entire list
        (_greatGrandparentFrom = greatGrandparentFrom.firstChild) !== null && _greatGrandparentFrom !== void 0 && _greatGrandparentFrom.eq(grandparentFrom) && (_greatGrandparentFrom2 = greatGrandparentFrom.lastChild) !== null && _greatGrandparentFrom2 !== void 0 && _greatGrandparentFrom2.eq(grandparentTo)) return true;
    }
    return false;
};
const $672a621e80803f53$export$4fd509032ef7561b = (selection)=>{
    const { from: from, to: to } = selection;
    if (from === to) return (0, $7p5u4.Fragment).empty;
    let frag = (0, $7p5u4.Fragment).empty;
    const sortedRanges = [
        ...selection.ranges.slice()
    ].sort((a, b)=>a.$from.pos - b.$from.pos);
    for (const range of sortedRanges){
        const { $from: $from, $to: $to } = range;
        const to = $to.pos;
        const depth = // If we're in a text selection, and share the parent node across the anchor->head
        // make the depth the parent node
        selection instanceof (0, $b0juN.TextSelection) && $from.parent.eq($to.parent) ? Math.max(0, $from.sharedDepth(to) - 1) : $from.sharedDepth(to);
        let finalDepth = depth;
        // For block-level lists (non-nested) specifically use the selection
        if ($672a621e80803f53$export$8701765a689d47ab($from, $to)) finalDepth = $from.depth - $672a621e80803f53$var$listDepth;
        const start = $from.start(finalDepth);
        const node = $from.node(finalDepth);
        const content = node.content.cut($from.pos - start, $to.pos - start);
        frag = frag.append(content);
    }
    return frag;
};

});


parcelRegister("b2X6u", function(module, exports) {
$parcel$export(module.exports, "getLocalIdsFromSelection", () => $1aa6347903366d48$export$9ce8378d786d4035);

var $b0juN = parcelRequire("b0juN");

var $8s2GQ = parcelRequire("8s2GQ");

var $3H4LK = parcelRequire("3H4LK");

var $8IckC = parcelRequire("8IckC");
const $1aa6347903366d48$export$9ce8378d786d4035 = (selection)=>{
    if (!selection) return null;
    if (selection instanceof (0, $b0juN.NodeSelection)) {
        if ((0, $3H4LK.fg)('platform_editor_ai_selection_local_ids')) {
            var _selection$node$attrs;
            const ids = [];
            const rootLocalId = (_selection$node$attrs = selection.node.attrs) === null || _selection$node$attrs === void 0 ? void 0 : _selection$node$attrs.localId;
            if (rootLocalId) ids.push(rootLocalId);
            selection.node.descendants((node)=>{
                var _node$attrs;
                if (node.isInline) return false;
                const localId = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId;
                if (localId) ids.push(localId);
            });
            return ids;
        }
        return [
            selection.node.attrs.localId
        ];
    } else if (selection instanceof (0, $8s2GQ.CellSelection)) {
        if ((0, $3H4LK.fg)('platform_editor_ai_selection_local_ids')) {
            const ids = [];
            const ancestorIds = new Set();
            // Collect localIds from each selected cell and its descendants
            selection.forEachCell((cellNode, cellPos)=>{
                var _cellNode$attrs;
                const cellLocalId = (_cellNode$attrs = cellNode.attrs) === null || _cellNode$attrs === void 0 ? void 0 : _cellNode$attrs.localId;
                if (cellLocalId) ids.push(cellLocalId);
                cellNode.descendants((node)=>{
                    var _node$attrs2;
                    if (node.isInline) return false;
                    const localId = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId;
                    if (localId) ids.push(localId);
                });
                // Collect ancestor localIds (row, table) separately
                const $cell = selection.$anchorCell.doc.resolve(cellPos + 1);
                for(let depth = $cell.depth - 1; depth >= 1; depth--){
                    var _ancestor$attrs;
                    const ancestor = $cell.node(depth);
                    const localId = (_ancestor$attrs = ancestor.attrs) === null || _ancestor$attrs === void 0 ? void 0 : _ancestor$attrs.localId;
                    if (localId) ancestorIds.add(localId);
                }
            });
            const uniqueIds = new Set(ids);
            const uniqueAncestors = [
                ...ancestorIds
            ].filter((id)=>!uniqueIds.has(id));
            return [
                ...uniqueIds,
                ...uniqueAncestors
            ];
        }
    } else if (selection.empty) return [
        selection.$from.parent.attrs.localId
    ];
    const slice = (0, $8IckC.getSliceFromSelection)(selection);
    const content = slice.content;
    const ids = [];
    content.forEach((node)=>{
        var _node$attrs3;
        const localId = (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId;
        if (localId) ids.push(localId);
    });
    return ids;
};

});







parcelRegister("ln2Rs", function(module, exports) {
$parcel$export(module.exports, "AnnotationsContextWrapper", () => $c55bfd94de7e6978$export$787af8a111ff3c03);

var $4fqPo = parcelRequire("4fqPo");

var $2wRng = parcelRequire("2wRng");

var $hKnlh = parcelRequire("hKnlh");

var $9oPOT = parcelRequire("9oPOT");
const $c55bfd94de7e6978$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $4fqPo.useContext)((0, $2wRng.ProvidersContext));
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hKnlh.RangeValidator), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        component: hoverComponent
    }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9oPOT.SelectionRangeValidator), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectionComponent: selectionComponent
    }));
};

});
parcelRegister("hKnlh", function(module, exports) {
$parcel$export(module.exports, "RangeValidator", () => $3f1e8e0e3066c2fe$export$6d8376a902cb8aa7);

var $4fqPo = parcelRequire("4fqPo");

var $3xoMd = parcelRequire("3xoMd");

var $eCph8 = parcelRequire("eCph8");

var $afZ8o = parcelRequire("afZ8o");

var $8gaUl = parcelRequire("8gaUl");
const $3f1e8e0e3066c2fe$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $afZ8o.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $afZ8o.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $8gaUl.useAnnotationHoverContext)();
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3xoMd.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$3f1e8e0e3066c2fe$export$6d8376a902cb8aa7.displayName = 'HoverRangeValidator';

});
parcelRegister("3xoMd", function(module, exports) {
$parcel$export(module.exports, "Mounter", () => $21399b02f3adb01d$export$2109cd350bcf6eda);

var $4fqPo = parcelRequire("4fqPo");

var $6ctpG = parcelRequire("6ctpG");

var $exUVq = parcelRequire("exUVq");

var $6niD6 = parcelRequire("6niD6");

var $f0GG4 = parcelRequire("f0GG4");

var $eCph8 = parcelRequire("eCph8");

var $afZ8o = parcelRequire("afZ8o");
const $21399b02f3adb01d$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteHoverToDraft: promoteHoverToDraft, clearHoverDraft: clearHoverDraft } = (0, $afZ8o.useAnnotationRangeDispatch)();
    const { hoverDraftDocumentPosition: hoverDraftDocumentPosition } = (0, $afZ8o.useAnnotationRangeState)();
    const actions = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const onCreateCallback = (0, $4fqPo.useCallback)((annotationId)=>{
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!isAnnotationAllowed || !positionToAnnotate || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $f0GG4.ACTION).INSERTED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $f0GG4.EVENT_TYPE).TRACK
        }).fire((0, $6niD6.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        hoverDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $4fqPo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $4fqPo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK
            }).fire((0, $6niD6.FabricChannel).editor);
            return false;
        }
        promoteHoverToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).OPENED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $6niD6.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $exUVq.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = hoverDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK
            }).fire((0, $6niD6.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        promoteHoverToDraft,
        hoverDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $4fqPo.useCallback)(()=>{
        clearHoverDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearHoverDraft
    ]);
    const onCloseCallback = (0, $4fqPo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $f0GG4.ACTION).CLOSED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $6niD6.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});
parcelRegister("exUVq", function(module, exports) {
$parcel$export(module.exports, "dataAttributes", () => $154fb707317840f6$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $154fb707317840f6$export$e14699d956e87e73);
/* eslint-disable @atlaskit/platform/no-direct-document-usage -- draft selection uses document range APIs */ const $154fb707317840f6$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $154fb707317840f6$var$buildDataAttributesQuery = (pos)=>{
    const a = $154fb707317840f6$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $154fb707317840f6$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($154fb707317840f6$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("afZ8o", function(module, exports) {
$parcel$export(module.exports, "AnnotationRangeProvider", () => $f779bdd8cc79f809$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $f779bdd8cc79f809$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $f779bdd8cc79f809$export$708fc397e2b6f08d);

var $4fqPo = parcelRequire("4fqPo");
const $f779bdd8cc79f809$var$initialState = {
    type: null,
    selectionRange: null,
    hoverRange: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
};
function $f779bdd8cc79f809$var$reducer(state, action) {
    switch(action.type){
        case 'clearSelection':
            if (state.selectionRange !== null) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type
            };
            return state;
        case 'clearHover':
            if (state.hoverRange !== null) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type
            };
            return state;
        case 'setSelection':
            if (state.selectionRange !== action.range) return {
                ...state,
                selectionRange: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.hoverRange !== action.range) return {
                ...state,
                hoverRange: action.range,
                type: 'hover'
            };
            return state;
        case 'promoteSelectionToDraft':
            // we should only promote the range to a draft if the current range type is a selection
            // we should also store the promotion type, so that a clear will not accidently clear the draft of a
            // different type
            if (state.selectionDraftRange !== state.selectionRange) return {
                ...state,
                selectionRange: null,
                type: state.type === 'selection' ? null : state.type,
                selectionDraftRange: state.selectionRange,
                selectionDraftDocumentPosition: action.position
            };
            return state;
        case 'promoteHoverToDraft':
            if (state.hoverDraftRange !== state.hoverRange) return {
                ...state,
                hoverRange: null,
                type: state.type === 'hover' ? null : state.type,
                hoverDraftRange: state.hoverRange,
                hoverDraftDocumentPosition: action.position
            };
            return state;
        case 'clearSelectionDraft':
            if (state.selectionDraftRange !== null) return {
                ...state,
                selectionDraftRange: null,
                selectionDraftDocumentPosition: null
            };
            return state;
        case 'clearHoverDraft':
            if (state.hoverDraftRange !== null) return {
                ...state,
                hoverDraftRange: null,
                hoverDraftDocumentPosition: null
            };
            return state;
    }
}
const $f779bdd8cc79f809$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    range: null,
    type: null,
    selectionDraftRange: null,
    hoverDraftRange: null,
    selectionDraftDocumentPosition: null,
    hoverDraftDocumentPosition: null
});
const $f779bdd8cc79f809$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    clearSelectionRange: ()=>{},
    clearHoverRange: ()=>{},
    setSelectionRange: ()=>{},
    promoteSelectionToDraft: ()=>{},
    promoteHoverToDraft: ()=>{},
    clearSelectionDraft: ()=>{},
    clearHoverDraft: ()=>{}
});
const $f779bdd8cc79f809$export$7cf774ce920e4bbd = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ selectionRange: selectionRange, hoverRange: hoverRange, type: type, selectionDraftRange: selectionDraftRange, selectionDraftDocumentPosition: selectionDraftDocumentPosition, hoverDraftRange: hoverDraftRange, hoverDraftDocumentPosition: hoverDraftDocumentPosition }, dispatch] = (0, $4fqPo.useReducer)($f779bdd8cc79f809$var$reducer, $f779bdd8cc79f809$var$initialState);
    const clearSelectionRange = (0, $4fqPo.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearHoverRange = (0, $4fqPo.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setSelectionRange = (0, $4fqPo.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setHoverTarget = (0, $4fqPo.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        if (!mediaNode) return;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- range for media hover highlight
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const promoteSelectionToDraft = (0, $4fqPo.useCallback)((position)=>{
        dispatch({
            type: 'promoteSelectionToDraft',
            position: position
        });
    }, []);
    const clearSelectionDraft = (0, $4fqPo.useCallback)(()=>{
        dispatch({
            type: 'clearSelectionDraft'
        });
    }, []);
    const promoteHoverToDraft = (0, $4fqPo.useCallback)((position)=>{
        dispatch({
            type: 'promoteHoverToDraft',
            position: position
        });
    }, []);
    const clearHoverDraft = (0, $4fqPo.useCallback)(()=>{
        dispatch({
            type: 'clearHoverDraft'
        });
    }, []);
    const stateData = (0, $4fqPo.useMemo)(()=>{
        return {
            // We techinically have two ranges, however we only want to expose one of them at a time, because only one draft
            // can be active at a time. The type of range is used to determine which range is active.
            range: type === 'selection' ? selectionRange : hoverRange,
            type: type,
            selectionDraftRange: selectionDraftRange,
            hoverDraftRange: hoverDraftRange,
            selectionDraftDocumentPosition: selectionDraftDocumentPosition,
            hoverDraftDocumentPosition: hoverDraftDocumentPosition
        };
    }, [
        selectionRange,
        hoverRange,
        type,
        selectionDraftRange,
        selectionDraftDocumentPosition,
        hoverDraftRange,
        hoverDraftDocumentPosition
    ]);
    const dispatchData = (0, $4fqPo.useMemo)(()=>({
            clearSelectionRange: clearSelectionRange,
            clearHoverRange: clearHoverRange,
            setSelectionRange: setSelectionRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined,
            promoteSelectionToDraft: promoteSelectionToDraft,
            promoteHoverToDraft: promoteHoverToDraft,
            clearSelectionDraft: clearSelectionDraft,
            clearHoverDraft: clearHoverDraft
        }), [
        allowCommentsOnMedia,
        clearSelectionRange,
        clearHoverRange,
        setSelectionRange,
        setHoverTarget,
        promoteSelectionToDraft,
        promoteHoverToDraft,
        clearSelectionDraft,
        clearHoverDraft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f779bdd8cc79f809$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f779bdd8cc79f809$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
const $f779bdd8cc79f809$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia, isNestedRender: isNestedRender })=>{
    /*
   * If this is a nested render, we do not provide the context
   * because it has already been provided higher up the component tree
   * and we need the original context to create annotations on extensions.
   */ return isNestedRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($f779bdd8cc79f809$export$7cf774ce920e4bbd, {
        allowCommentsOnMedia: allowCommentsOnMedia
    }, children);
};
const $f779bdd8cc79f809$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $4fqPo.useContext)($f779bdd8cc79f809$export$145b9bb655c3d220);
};
const $f779bdd8cc79f809$export$708fc397e2b6f08d = ()=>{
    return (0, $4fqPo.useContext)($f779bdd8cc79f809$export$efb0d1c8cbaac647);
};

});


parcelRegister("8gaUl", function(module, exports) {
$parcel$export(module.exports, "AnnotationHoverContext", () => $092ce413fb6a3f9f$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $092ce413fb6a3f9f$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $092ce413fb6a3f9f$export$c288883964405c82);

var $4fqPo = parcelRequire("4fqPo");
const $092ce413fb6a3f9f$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $4fqPo.createContext)({
    isWithinRange: false
});
const $092ce413fb6a3f9f$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $4fqPo.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $092ce413fb6a3f9f$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $4fqPo.useState)(false);
    const timeoutHandler = (0, $4fqPo.useRef)();
    const cancelTimeout = (0, $4fqPo.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $4fqPo.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $4fqPo.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $4fqPo.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($092ce413fb6a3f9f$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($092ce413fb6a3f9f$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $092ce413fb6a3f9f$export$a02bfcbbbf920306 = ()=>{
    return (0, $4fqPo.useContext)($092ce413fb6a3f9f$var$AnnotationHoverStateContext);
};
const $092ce413fb6a3f9f$export$c288883964405c82 = ()=>{
    return (0, $4fqPo.useContext)($092ce413fb6a3f9f$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("9oPOT", function(module, exports) {
$parcel$export(module.exports, "SelectionRangeValidator", () => $4224776e02f7d842$export$74435b85e23b84d9);

var $4fqPo = parcelRequire("4fqPo");

var $5iRY2 = parcelRequire("5iRY2");

var $1qjen = parcelRequire("1qjen");

var $eCph8 = parcelRequire("eCph8");
const $4224776e02f7d842$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const [type, range, draftRange, clearRange] = (0, $5iRY2.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const selectionRange = type === 'selection' ? range : null;
    // !!! the draft range will become invalid after the mark DOM is inserted
    if (!selectionRange && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1qjen.SelectionInlineCommentMounter), {
        range: selectionRange,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        createAnalyticsEvent: createAnalyticsEvent
    });
};
$4224776e02f7d842$export$74435b85e23b84d9.displayName = 'SelectionRangeValidator';

});
parcelRegister("5iRY2", function(module, exports) {
$parcel$export(module.exports, "useUserSelectionRange", () => $b17015efcf23c3d8$export$47201332e612f5a4);

var $4fqPo = parcelRequire("4fqPo");

var $afZ8o = parcelRequire("afZ8o");

var $krI4A = parcelRequire("krI4A");

var $huEyE = parcelRequire("huEyE");
const $b17015efcf23c3d8$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $4fqPo.useRef)();
    const { clearSelectionRange: clearSelectionRange, setSelectionRange: setSelectionRange } = (0, $afZ8o.useAnnotationRangeDispatch)();
    const { range: range, type: type, selectionDraftRange: selectionDraftRange } = (0, $afZ8o.useAnnotationRangeState)();
    const { annotationManager: annotationManager } = (0, $huEyE.useAnnotationManagerDispatch)();
    const lastRangeRef = (0, $4fqPo.useRef)(null);
    const isAnnotationManagerEnabled = !!annotationManager;
    const onSelectionChange = (0, $4fqPo.useCallback)((_event)=>{
        if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
        selectionTimeoutRef.current = setTimeout(()=>{
            const sel = document.getSelection();
            if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) {
                lastRangeRef.current = null; // Clear last range if selection is invalid
                if (isAnnotationManagerEnabled) clearSelectionRange();
                return;
            }
            let _range = sel.getRangeAt(0);
            // Skip if the selection hasn't changed
            if (lastRangeRef.current && _range.compareBoundaryPoints(Range.START_TO_START, lastRangeRef.current) === 0 && _range.compareBoundaryPoints(Range.END_TO_END, lastRangeRef.current) === 0) return;
            if (rendererDOM && (0, $krI4A.isRangeInsideOfRendererContainer)(rendererDOM, _range)) {
                const { startContainer: startContainer, endContainer: endContainer } = _range;
                const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
                if (isTripleClick) {
                    let p = startContainer;
                    while(p && p.nodeName !== 'P' && p !== rendererDOM)p = p.parentNode;
                    if (p && p.nodeName === 'P' && p instanceof Element) {
                        const range = document.createRange();
                        range.selectNodeContents(p);
                        sel.removeAllRanges();
                        sel.addRange(range);
                        _range = sel.getRangeAt(0);
                    }
                }
                setSelectionRange(_range.cloneRange());
                lastRangeRef.current = _range;
            }
        }, 100);
    }, [
        rendererDOM,
        setSelectionRange,
        clearSelectionRange,
        isAnnotationManagerEnabled
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('selectionchange', onSelectionChange);
            clearSelectionRange();
        };
    }, [
        rendererDOM,
        onSelectionChange,
        clearSelectionRange
    ]);
    return [
        type,
        range,
        selectionDraftRange,
        clearSelectionRange
    ];
};

});
parcelRegister("krI4A", function(module, exports) {
$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $1c9db68eb91e2248$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $1c9db68eb91e2248$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("1qjen", function(module, exports) {
$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $60da2d1b21061a4f$export$ca7741472ed8ba00);

var $4fqPo = parcelRequire("4fqPo");

var $3izZW = parcelRequire("3izZW");

var $6ctpG = parcelRequire("6ctpG");

var $3H4LK = parcelRequire("3H4LK");

var $exUVq = parcelRequire("exUVq");

var $6niD6 = parcelRequire("6niD6");

var $f0GG4 = parcelRequire("f0GG4");

var $kHvo2 = parcelRequire("kHvo2");

var $eCph8 = parcelRequire("eCph8");

var $huEyE = parcelRequire("huEyE");

var $afZ8o = parcelRequire("afZ8o");
const $60da2d1b21061a4f$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const { promoteSelectionToDraft: promoteSelectionToDraft, clearSelectionDraft: clearSelectionDraft } = (0, $afZ8o.useAnnotationRangeDispatch)();
    const { selectionDraftDocumentPosition: selectionDraftDocumentPosition } = (0, $afZ8o.useAnnotationRangeState)();
    const actions = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const { isDrafting: isDrafting, draftId: draftId } = (0, $huEyE.useAnnotationManagerState)();
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $huEyE.useAnnotationManagerDispatch)();
    const inlineNodeTypes = (0, $4fqPo.useMemo)(()=>{
        if (!actions.isRangeAnnotatable(range)) return undefined;
        return (0, $kHvo2.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $4fqPo.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        // !!! at this point, the documentPosition can be the wrong position if the user select something else
        const positionToAnnotate = selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $f0GG4.ACTION).INSERTED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $f0GG4.EVENT_TYPE).TRACK
        }).fire((0, $6niD6.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        createAnalyticsEvent,
        inlineNodeTypes,
        selectionDraftDocumentPosition
    ]);
    const createIndexCallback = (0, $4fqPo.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $4fqPo.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes,
                    documentPosition: documentPosition,
                    isAnnotationAllowed: isAnnotationAllowed
                },
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK
            }).fire((0, $6niD6.FabricChannel).editor);
            return false;
        }
        promoteSelectionToDraft(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).OPENED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $6niD6.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $exUVq.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        // at this point, the documentPosition is the position that the user has selected,
        // not the selectionDraftDocumentPosition
        // because the documentPosition is not promoted to selectionDraftDocumentPosition yet
        // use platform_editor_comments_api_manager here so we can clear the code path when the flag is removed
        const positionToAnnotate = (0, $3H4LK.fg)('platform_editor_comments_api_manager') ? documentPosition : selectionDraftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $f0GG4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    positionToAnnotate: positionToAnnotate,
                    applyAnnotationMissing: !applyAnnotation,
                    annotationId: options.annotationId
                },
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK
            }).fire((0, $6niD6.FabricChannel).editor);
            return false;
        }
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $6ctpG.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation);
    }, [
        documentPosition,
        isAnnotationAllowed,
        createAnalyticsEvent,
        applyAnnotation,
        actions,
        range,
        inlineNodeTypes,
        promoteSelectionToDraft,
        selectionDraftDocumentPosition
    ]);
    const removeDraftModeCallback = (0, $4fqPo.useCallback)(()=>{
        clearSelectionDraft();
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearSelectionDraft
    ]);
    const onCloseCallback = (0, $4fqPo.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $f0GG4.ACTION).CLOSED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $6niD6.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (annotationManager) {
            const allowAnnotation = ()=>{
                if (isDrafting) return false;
                return isAnnotationAllowed;
            };
            annotationManager.hook('allowAnnotation', allowAnnotation);
            return ()=>{
                annotationManager.unhook('allowAnnotation', allowAnnotation);
            };
        }
    }, [
        annotationManager,
        isAnnotationAllowed,
        isDrafting
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (annotationManager) {
            const startDraft = ()=>{
                // if there is a draft in progress, we ignore it and start a new draft
                // this is because clearing the draft will remove the mark node from the DOM, which will cause the selection range to be invalid
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const id = (0, (/*@__PURE__*/$parcel$interopDefault($3izZW)))();
                const result = applyDraftModeCallback({
                    annotationId: id,
                    keepNativeSelection: false
                });
                if (!result) return {
                    success: false,
                    reason: 'invalid-range'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: true,
                        draftId: id,
                        draftActionResult: result
                    }
                });
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return {
                    success: true,
                    // We cannot get a ref to the target element here
                    // because the draft is not yet applied to the DOM
                    targetElement: undefined,
                    inlineNodeTypes: result.inlineNodeTypes ?? [],
                    actionResult: {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    }
                };
            };
            annotationManager.hook('startDraft', startDraft);
            return ()=>{
                annotationManager.unhook('startDraft', startDraft);
            };
        }
    }, [
        annotationManager,
        isDrafting,
        applyDraftModeCallback,
        actions,
        range,
        dispatch
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (annotationManager) {
            const clearDraft = ()=>{
                if (!isDrafting) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                onCloseCallback();
                return {
                    success: true
                };
            };
            annotationManager.hook('clearDraft', clearDraft);
            return ()=>{
                annotationManager.unhook('clearDraft', clearDraft);
            };
        }
    }, [
        annotationManager,
        onCloseCallback,
        isDrafting,
        dispatch
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (annotationManager) {
            const applyDraft = (id)=>{
                if (!isDrafting || !draftId) return {
                    success: false,
                    reason: 'draft-not-started'
                };
                const result = onCreateCallback(id);
                if (!result) return {
                    success: false,
                    reason: 'range-no-longer-exists'
                };
                onCloseCallback();
                dispatch({
                    type: 'setDrafting',
                    data: {
                        isDrafting: false,
                        draftId: undefined,
                        draftActionResult: undefined
                    }
                });
                dispatch({
                    type: 'updateAnnotation',
                    data: {
                        id: id,
                        selected: true,
                        markState: (0, $6ctpG.AnnotationMarkStates).ACTIVE
                    }
                });
                return {
                    success: true,
                    targetElement: undefined,
                    actionResult: id !== draftId ? {
                        step: result.step,
                        doc: result.doc,
                        inlineNodeTypes: result.inlineNodeTypes,
                        targetNodeType: result.targetNodeType,
                        originalSelection: result.originalSelection,
                        numMatches: result.numMatches,
                        matchIndex: result.matchIndex,
                        pos: result.pos
                    } : undefined
                };
            };
            annotationManager.hook('applyDraft', applyDraft);
            return ()=>{
                annotationManager.unhook('applyDraft', applyDraft);
            };
        }
    }, [
        annotationManager,
        onCreateCallback,
        onCloseCallback,
        isDrafting,
        draftId,
        dispatch
    ]);
    // Please remove this NOP function when the flag platform_editor_comments_api_manager is removed.
    const nop = (0, $4fqPo.useMemo)(()=>()=>false, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: annotationManager ? nop : onCloseCallback,
        onCreate: annotationManager ? nop : onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: annotationManager ? nop : applyDraftModeCallback,
        removeDraftMode: annotationManager ? nop : removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("7M6hH", function(module, exports) {
$parcel$export(module.exports, "useLoadAnnotations", () => $b6338c0332d33919$export$39f7c1a861a0d41c);

var $4fqPo = parcelRequire("4fqPo");

var $2SqHb = parcelRequire("2SqHb");

var $2wRng = parcelRequire("2wRng");

var $eCph8 = parcelRequire("eCph8");

var $huEyE = parcelRequire("huEyE");
const $b6338c0332d33919$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender, onLoadComplete: onLoadComplete })=>{
    const actions = (0, $4fqPo.useContext)((0, $eCph8.RendererContext));
    const providers = (0, $4fqPo.useContext)((0, $2wRng.ProvidersContext));
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $huEyE.useAnnotationManagerDispatch)();
    const isAnnotationManagerEnabled = !!annotationManager;
    (0, $4fqPo.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) {
            if (!isNestedRender) // inlineCommentGetState handles empty lists gracefully. It has a side-effect of clearing state, which is why this call is needed
            inlineCommentGetState([], isNestedRender);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: 0
            });
            return;
        }
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            if (isAnnotationManagerEnabled) dispatch({
                type: 'loadAnnotation',
                data: Object.keys(payload).map((id)=>({
                        id: id,
                        markState: payload[id].state ?? undefined
                    }))
            });
            else updateSubscriberInlineComment.emit((0, $2SqHb.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
            onLoadComplete && onLoadComplete({
                numberOfUnresolvedInlineComments: data.filter((data)=>data.state === 'active').length
            });
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender,
        onLoadComplete,
        dispatch,
        isAnnotationManagerEnabled
    ]);
};

});


parcelRegister("AmJJl", function(module, exports) {
$parcel$export(module.exports, "ValidationContext", () => $de64941cdfb456c2$export$d452675449e81987);
$parcel$export(module.exports, "ValidationContextProvider", () => $de64941cdfb456c2$export$5b655fe45447a548);

var $4fqPo = parcelRequire("4fqPo");
const $de64941cdfb456c2$export$d452675449e81987 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $de64941cdfb456c2$export$5b655fe45447a548 = $de64941cdfb456c2$export$d452675449e81987.Provider;

});


parcelRegister("csFuI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a18df51f7ee6b6f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives, @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lqVX7 = parcelRequire("lqVX7");

var $4fqPo = parcelRequire("4fqPo");

var $ag3hq = parcelRequire("ag3hq");

var $jANeU = parcelRequire("jANeU");

var $7VVBW = parcelRequire("7VVBW");

var $4VzEX = parcelRequire("4VzEX");

var $dnWws = parcelRequire("dnWws");

var $4mqcS = parcelRequire("4mqcS");

var $g0CJe = parcelRequire("g0CJe");
function $5a18df51f7ee6b6f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5a18df51f7ee6b6f$var$containerStyles = {
    name: "hwppun",
    styles: "&:first-child > .ak-renderer-extension{margin-top:0;}&:first-child > .ak-renderer-sticky-safe-center-wrapper{margin-top:0;}"
};
const $5a18df51f7ee6b6f$var$MultiBodiedExtensionChildrenContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lqVX7.jsx)("article", {
        "data-testid": "multiBodiedExtension--frames"
    }, children);
};
const $5a18df51f7ee6b6f$var$MultiBodiedExtensionNavigation = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lqVX7.jsx)("nav", {
        "data-testid": "multiBodiedExtension-navigation"
    }, children);
};
const $5a18df51f7ee6b6f$var$MultiBodiedExtensionWrapperLegacy = ({ width: width, path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jANeU.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jANeU.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $7VVBW.calcBreakoutWidth)(layout, width) : (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $5a18df51f7ee6b6f$var$MultiBodiedExtensionWrapperNext = ({ path: path, layout: layout, rendererAppearance: rendererAppearance, children: children })=>{
    const isTopLevel = path.length < 1;
    // we should only use custom layout for full-page appearance
    const canUseCustomLayout = (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? rendererAppearance === 'full-page' : true;
    const isCustomLayout = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && canUseCustomLayout;
    const centerAlignClass = isCustomLayout ? (0, $jANeU.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    // This hierarchy is copied from regular extension (see extension.tsx)
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $jANeU.RendererCssClassName).EXTENSION} ${centerAlignClass}`,
        style: {
            width: ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? isCustomLayout : isTopLevel) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g0CJe.calcBreakoutWidthCss)(layout) : (0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? undefined : '100%'
        },
        "data-layout": layout,
        "data-testid": "multiBodiedExtension--wrapper-renderer",
        "data-top-level": isTopLevel || undefined
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
    }, children));
};
const $5a18df51f7ee6b6f$var$MultiBodiedExtension = (props)=>{
    var _extensionContext$pri;
    const { children: children, layout: layout = 'default', path: path = [], parameters: parameters, extensionType: extensionType, extensionKey: extensionKey, extensionHandlers: extensionHandlers, content: content, marks: marks, localId: localId, rendererAppearance: rendererAppearance } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $4fqPo.useState)(0);
    const { loading: loading, extensionContext: extensionContext } = (0, $dnWws.useMultiBodiedExtensionContext)({
        extensionHandlers: extensionHandlers,
        extensionType: extensionType,
        extensionKey: extensionKey
    });
    const actions = (0, $4VzEX.useMultiBodiedExtensionActions)({
        updateActiveChild: setActiveChildIndex,
        children: children,
        childrenContainer: /*#__PURE__*/ (0, $lqVX7.jsx)($5a18df51f7ee6b6f$var$MultiBodiedExtensionChildrenContainer, null, children),
        allowBodiedOverride: extensionContext === null || extensionContext === void 0 || (_extensionContext$pri = extensionContext.privateProps) === null || _extensionContext$pri === void 0 ? void 0 : _extensionContext$pri.__allowBodiedOverride
    });
    const renderContent = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback(()=>{
        var _marks$find;
        if (loading || !extensionContext) return null;
        const { NodeRenderer: NodeRenderer, privateProps: privateProps } = extensionContext;
        const fragmentLocalId = marks === null || marks === void 0 || (_marks$find = marks.find((m)=>m.type.name === 'fragment')) === null || _marks$find === void 0 || (_marks$find = _marks$find.attrs) === null || _marks$find === void 0 ? void 0 : _marks$find.localId;
        const node = {
            type: 'multiBodiedExtension',
            extensionKey: extensionKey,
            extensionType: extensionType,
            parameters: parameters,
            content: content,
            localId: localId,
            fragmentLocalId: fragmentLocalId
        };
        if (privateProps.__allowBodiedOverride) return /*#__PURE__*/ (0, $lqVX7.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        });
        else return /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, $lqVX7.jsx)($5a18df51f7ee6b6f$var$MultiBodiedExtensionNavigation, null, /*#__PURE__*/ (0, $lqVX7.jsx)(NodeRenderer, {
            node: node,
            actions: actions
        })), /*#__PURE__*/ (0, $lqVX7.jsx)($5a18df51f7ee6b6f$var$MultiBodiedExtensionChildrenContainer, null, children));
    }, [
        loading,
        extensionContext,
        marks,
        extensionKey,
        extensionType,
        parameters,
        content,
        localId,
        actions,
        children
    ]);
    // make the frame visible
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    const containerActiveFrameStyles = /*#__PURE__*/ (0, $lqVX7.css)("& [data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){display:block;}");
    if ((0, $4mqcS.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)) {
        const isTopLevel = path.length < 1;
        const useCenterWrapper = isTopLevel && [
            'wide',
            'full-width'
        ].includes(layout) && (0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
        const wrapper = /*#__PURE__*/ (0, $lqVX7.jsx)($5a18df51f7ee6b6f$var$MultiBodiedExtensionWrapperNext, {
            layout: layout,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return /*#__PURE__*/ (0, $lqVX7.jsx)("section", {
            css: [
                $5a18df51f7ee6b6f$var$containerStyles,
                containerActiveFrameStyles
            ],
            "data-testid": "multiBodiedExtension--container",
            "data-multiBodiedExtension-container": true,
            "data-active-child-index": activeChildIndex,
            "data-layout": layout,
            "data-local-id": localId,
            "data-node-type": "multiBodiedExtension"
        }, useCenterWrapper ? /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jANeU.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jANeU.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper);
    }
    const isTopLevel = path.length < 1;
    const useCenterWrapper = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) && (0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("section", {
        css: [
            $5a18df51f7ee6b6f$var$containerStyles,
            containerActiveFrameStyles
        ],
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex,
        "data-layout": layout,
        "data-local-id": localId
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $ag3hq.WidthConsumer), null, ({ width: width })=>{
        const wrapper = /*#__PURE__*/ (0, $lqVX7.jsx)($5a18df51f7ee6b6f$var$MultiBodiedExtensionWrapperLegacy, {
            layout: layout,
            width: width,
            path: path,
            rendererAppearance: rendererAppearance
        }, renderContent());
        return useCenterWrapper ? /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jANeU.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER + ' ' + (0, $jANeU.RendererCssClassName).FLEX_CENTER_WRAPPER
        }, wrapper) : wrapper;
    }));
};
var $5a18df51f7ee6b6f$export$2e2bcd8739ae039 = $5a18df51f7ee6b6f$var$MultiBodiedExtension;

});
parcelRegister("4VzEX", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $e41bbb98a1e04fd1$export$3c7139d93ecb4f1f);

var $4fqPo = parcelRequire("4fqPo");
const $e41bbb98a1e04fd1$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, children: children, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        return {
            changeActive (index) {
                if (!Number.isInteger(index)) return false;
                updateActiveChild(index);
                return true;
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children && Array.isArray(children) ? children.length : 0;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            removeChild (_index) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            reorderChildren (_fromIndex, _toIndex) {
                return false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            updateParameters (_parameters) {
                return false;
            },
            getChildren () {
                return [];
            },
            getChildrenContainer () {
                return allowBodiedOverride ? childrenContainer : null;
            }
        };
    }, [
        updateActiveChild,
        children,
        allowBodiedOverride,
        childrenContainer
    ]);
};

});

parcelRegister("dnWws", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionContext", () => $322aef89066760a3$export$e55394818db35473);

var $4fqPo = parcelRequire("4fqPo");

var $jE04u = parcelRequire("jE04u");

var $wuhiB = parcelRequire("wuhiB");

var $gScSr = parcelRequire("gScSr");

var $h8UjM = parcelRequire("h8UjM");

var $3H4LK = parcelRequire("3H4LK");
const $322aef89066760a3$var$getExtensionHandlerNode = (extensionHandler)=>{
    return ({ node: node, doc: doc, actions: actions })=>{
        return extensionHandler(node, doc, actions);
    };
};
const $322aef89066760a3$export$e55394818db35473 = ({ extensionHandlers: extensionHandlers, extensionType: extensionType, extensionKey: extensionKey })=>{
    const isMounted = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(true);
    const localGetNodeRenderer = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>(0, $jE04u.default)((0, $wuhiB.getNodeRenderer)), []);
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [privateProps, setPrivateProps] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState();
    const providerPromise = (0, $gScSr.useProvider)('extensionProvider');
    const ExtensionHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        const extensionHandler = extensionHandlers && extensionHandlers[extensionType] && (0, $h8UjM.getExtensionRenderer)(extensionHandlers[extensionType]);
        if (extensionHandler) return $322aef89066760a3$var$getExtensionHandlerNode(extensionHandler);
        return null;
    }, [
        extensionHandlers,
        extensionType
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        if (providerPromise) providerPromise.then((p)=>{
            if (isMounted.current) setProvider(p);
            return (0, $wuhiB.getExtensionModuleNodePrivateProps)(p, extensionType, extensionKey);
        }).then((pr)=>{
            if (isMounted.current) setPrivateProps(pr);
        });
    }, [
        providerPromise,
        extensionType,
        extensionKey
    ]);
    const ExtensionProviderNode = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        if (!provider) return null;
        return localGetNodeRenderer(provider, extensionType, extensionKey);
    }, [
        provider,
        extensionType,
        extensionKey,
        localGetNodeRenderer
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        if (ExtensionHandlerNode && (0, $3H4LK.fg)('confluence_frontend_native_tabs_extension')) return {
            extensionContext: {
                NodeRenderer: ExtensionHandlerNode,
                privateProps: {
                    __allowBodiedOverride: true
                }
            },
            loading: false
        };
        if (!provider || !ExtensionProviderNode || !privateProps) return {
            extensionContext: null,
            loading: true
        };
        return {
            extensionContext: {
                NodeRenderer: ExtensionProviderNode,
                privateProps: privateProps
            },
            loading: false
        };
    }, [
        ExtensionHandlerNode,
        provider,
        ExtensionProviderNode,
        privateProps
    ]);
};

});


parcelRegister("i81Rt", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9a1fcece1212dd8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lqVX7 = parcelRequire("lqVX7");
const $c9a1fcece1212dd8$var$containerCSS = /*#__PURE__*/ (0, $lqVX7.css)({
    padding: `${"var(--ds-space-100, 8px)"}`,
    minHeight: '100px',
    // by default all frames are hidden, this style is overridden in multiBodiedExtensions for active frame
    display: 'none'
});
const $c9a1fcece1212dd8$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: [
            $c9a1fcece1212dd8$var$containerCSS
        ],
        "data-extension-frame": "true"
    }, props.children);
};
var $c9a1fcece1212dd8$export$2e2bcd8739ae039 = $c9a1fcece1212dd8$var$ExtensionFrame;

});

parcelRegister("kitQl", function(module, exports) {
$parcel$export(module.exports, "default", () => $87f74009a0fb00cd$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $8EdAG = parcelRequire("8EdAG");

var $7n8vF = parcelRequire("7n8vF");
function $87f74009a0fb00cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8EdAG.bulletListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $7n8vF.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("7n8vF", function(module, exports) {
$parcel$export(module.exports, "getListIndentLevel", () => $adced45b3f1bb45e$export$75aa84e85754623e);
function $adced45b3f1bb45e$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("7Xlc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $34006e17916cb1fd$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $34006e17916cb1fd$export$41121a410ca2f650);

var $4fqPo = parcelRequire("4fqPo");

var $jANeU = parcelRequire("jANeU");

var $5P5wX = parcelRequire("5P5wX");
function $34006e17916cb1fd$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $jANeU.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $34006e17916cb1fd$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ref: (0, $5P5wX.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jANeU.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("5P5wX", function(module, exports) {
$parcel$export(module.exports, "useSelectAllTrap", () => $afc78c9aa3c5ae86$export$98871b245ee25215);

var $f0GG4 = parcelRequire("f0GG4");

var $4fqPo = parcelRequire("4fqPo");

var $cS0SO = parcelRequire("cS0SO");

var $eeyS8 = parcelRequire("eeyS8");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $afc78c9aa3c5ae86$var$MAC_PLATFORM_REGEX = /Mac/;
const $afc78c9aa3c5ae86$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext((0, $cS0SO.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef();
    const mac = typeof navigator !== 'undefined' ? $afc78c9aa3c5ae86$var$MAC_PLATFORM_REGEX.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((e)=>{
        var _e$target, _e$target$matches;
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $eeyS8.ElementSelection).fromWindow();
        const isInput = (_e$target = e.target) === null || _e$target === void 0 || (_e$target$matches = _e$target.matches) === null || _e$target$matches === void 0 ? void 0 : _e$target$matches.call(_e$target, 'input');
        if (elementSelection.eq(caught.current) || isInput) {
            fireAnalyticsEvent({
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                action: (0, $f0GG4.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                action: (0, $f0GG4.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useCallback((e)=>{
        var _ref$current;
        clicked.current = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.contains(e.target)) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useEffect(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('keydown', onKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', onClick);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('keydown', onKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("cS0SO", function(module, exports) {
$parcel$export(module.exports, "default", () => $aabe95619031b9c4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $aabe95619031b9c4$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $aabe95619031b9c4$export$2e2bcd8739ae039 = $aabe95619031b9c4$var$AnalyticsContext;

});

parcelRegister("eeyS8", function(module, exports) {
$parcel$export(module.exports, "ElementSelection", () => $8c21f6bc6b15e7cf$export$6e6724d89f27411);
class $8c21f6bc6b15e7cf$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            var _this$range, _this$range2;
            const startMatches = ((_this$range = this.range) === null || _this$range === void 0 ? void 0 : _this$range.compareBoundaryPoints(Range.START_TO_START, selection.range)) === 0;
            const endMatches = ((_this$range2 = this.range) === null || _this$range2 === void 0 ? void 0 : _this$range2.compareBoundaryPoints(Range.END_TO_END, selection.range)) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        var _this$range3;
        return el.contains(((_this$range3 = this.range) === null || _this$range3 === void 0 ? void 0 : _this$range3.commonAncestorContainer) ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $8c21f6bc6b15e7cf$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $8c21f6bc6b15e7cf$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("KhEWC", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfe4c4683b3cab16$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $bfe4c4683b3cab16$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("br", null);
};
var $bfe4c4683b3cab16$export$2e2bcd8739ae039 = $bfe4c4683b3cab16$var$HardBreak;

});

parcelRegister("8BaBv", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b2a2a28cd83b620$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $c62a8 = parcelRequire("c62a8");

var $f0GG4 = parcelRequire("f0GG4");

var $gFdUI = parcelRequire("gFdUI");

var $4mqcS = parcelRequire("4mqcS");

var $cS0SO = parcelRequire("cS0SO");

var $moN97 = parcelRequire("moN97");

var $i0d0i = parcelRequire("i0d0i");

var $lqVX7 = parcelRequire("lqVX7");
function $5b2a2a28cd83b620$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5b2a2a28cd83b620$var$RENDERER_HEADING_WRAPPER = 'renderer-heading-wrapper';
const $5b2a2a28cd83b620$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $5b2a2a28cd83b620$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
const $5b2a2a28cd83b620$var$wrapperStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $5b2a2a28cd83b620$var$getHeadingAnchorLinksConfig = (allowHeadingAnchorLinks)=>typeof allowHeadingAnchorLinks === 'object' ? allowHeadingAnchorLinks : undefined;
function $5b2a2a28cd83b620$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, getHeadingLink: getHeadingLink, level: level, headingId: headingId, hideFromScreenReader: hideFromScreenReader }) {
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $cS0SO.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, $lqVX7.jsx)((0, $i0d0i.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $f0GG4.ACTION).CLICKED,
                    actionSubject: (0, $f0GG4.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $f0GG4.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $f0GG4.EVENT_TYPE).UI
                });
                return (0, $moN97.copyTextToClipboard)((getHeadingLink === null || getHeadingLink === void 0 ? void 0 : getHeadingLink(headingId)) ?? $5b2a2a28cd83b620$var$getCurrentUrlWithHash(headingId));
            },
            hideFromScreenReader: hideFromScreenReader,
            headingId: headingId
        }));
}
/**
 * Old heading structure (before a11y fix):
 * - headning anchor is rendered INSIDE the heading element
 * - A duplicate anchor is rendered in VisuallyHidden for screen readers
 * - The visible button has hideFromScreenReader={true}
 *
 */ function $5b2a2a28cd83b620$var$HeadingWithDuplicateAnchor(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $5b2a2a28cd83b620$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $5b2a2a28cd83b620$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $c62a8.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, $lqVX7.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: (0, $4mqcS.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true) ? -1 : undefined
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: true
    }))), /*#__PURE__*/ (0, $lqVX7.jsx)((0, $gFdUI.default), {
        testId: "visually-hidden-heading-anchor"
    }, showAnchorLink && headingId && /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId
    })));
}
/**
 * New heading structure (a11y fix):
 * - Heading anchor is rendered OUTSIDE the heading element in a .renderer-heading-wrapper div
 * - Uses data-level attribute for CSS styling
 * - Better accessibility: heading contains only text, button is a sibling
 */ function $5b2a2a28cd83b620$var$HeadingWithWrapper(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible, localId: localId, asInline: asInline } = props;
    const HX = `h${props.level}`;
    const mouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(false);
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $5b2a2a28cd83b620$var$hasRightAlignmentMark(marks);
    const headingAnchorLinksConfig = $5b2a2a28cd83b620$var$getHeadingAnchorLinksConfig(allowHeadingAnchorLinks);
    const enableNestedHeaderLinks = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.allowNestedHeaderLinks;
    const getHeadingLink = headingAnchorLinksConfig === null || headingAnchorLinksConfig === void 0 ? void 0 : headingAnchorLinksConfig.getHeadingLink;
    const headingIdToUse = invisible ? undefined : headingId;
    const mouseEnterHandler = ()=>{
        if (showAnchorLink && !mouseEntered.current) {
            // Abort TTVC calculation when the mouse hovers over heading. Hovering over
            // heading render heading anchor and inline comment buttons. These user-induced
            // DOM changes are valid reasons to abort the TTVC calculation.
            (0, $c62a8.abortAll)('new_interaction');
            mouseEntered.current = true;
        }
    };
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $5b2a2a28cd83b620$var$RENDERER_HEADING_WRAPPER,
        "data-testid": $5b2a2a28cd83b620$var$RENDERER_HEADING_WRAPPER,
        "data-level": props.level,
        css: $5b2a2a28cd83b620$var$wrapperStyles
    }, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }), /*#__PURE__*/ (0, $lqVX7.jsx)(HX, {
        id: headingIdToUse,
        "data-local-id": localId,
        "data-renderer-start-pos": dataAttributes['data-renderer-start-pos'],
        "data-as-inline": asInline,
        onMouseEnter: mouseEnterHandler,
        tabIndex: (0, $4mqcS.expValEquals)('confluence_toc_nav_a11y', 'isEnabled', true) ? -1 : undefined
    }, props.children), showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        getHeadingLink: getHeadingLink,
        headingId: headingId,
        hideFromScreenReader: false
    }));
}
/**
 * Gated Heading component:
 * - When platform_editor_copy_link_a11y_inconsistency_fix experiment is enabled,
 *   returns HeadingWithWrapper (new a11y-improved structure)
 * - Otherwise returns HeadingWithDuplicateAnchor (old structure)
 */ function $5b2a2a28cd83b620$var$Heading({ allowHeadingAnchorLinks: allowHeadingAnchorLinks, children: children, dataAttributes: dataAttributes, headingId: headingId, invisible: invisible, level: level, localId: localId, marks: marks, nodeType: nodeType, showAnchorLink: showAnchorLink, serializer: serializer, asInline: asInline }) {
    if ((0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true)) return /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$HeadingWithWrapper, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
    return /*#__PURE__*/ (0, $lqVX7.jsx)($5b2a2a28cd83b620$var$HeadingWithDuplicateAnchor, {
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        dataAttributes: dataAttributes,
        headingId: headingId,
        invisible: invisible,
        level: level,
        localId: localId,
        marks: marks,
        nodeType: nodeType,
        serializer: serializer,
        showAnchorLink: showAnchorLink,
        asInline: asInline
    }, children);
}
var $5b2a2a28cd83b620$export$2e2bcd8739ae039 = $5b2a2a28cd83b620$var$Heading;

});
parcelRegister("moN97", function(module, exports) {
$parcel$export(module.exports, "copyTextToClipboard", () => $e1e011657c1ec4d6$export$f980440e1ab4537d);
const $e1e011657c1ec4d6$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});

parcelRegister("i0d0i", function(module, exports) {
$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $5a94dd239a21de65$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $5a94dd239a21de65$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $3rTf2 = parcelRequire("3rTf2");

var $6SePM = parcelRequire("6SePM");

var $4mqcS = parcelRequire("4mqcS");

var $8Mj6h = parcelRequire("8Mj6h");

var $jiYbW = parcelRequire("jiYbW");
function $5a94dd239a21de65$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5a94dd239a21de65$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $5a94dd239a21de65$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        ...rest,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $5a94dd239a21de65$export$3c9cedc52604835d,
        ref: ref
    }, children);
});
const $5a94dd239a21de65$var$copyAnchorButtonStyles = {
    name: "x4slh0",
    styles: "display:inline;outline:none;background-color:transparent;border:none;color:var(--ds-icon, #292A2E);cursor:pointer;right:0"
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $5a94dd239a21de65$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).PureComponent {
    constructor(props){
        super(props), this.state = {
            tooltipMessage: '',
            isClicked: false
        }, // Stable reference for Tooltip content prop to avoid recreating on each render
        this.renderTooltipContent = ({ update: update })=>{
            this._tooltipUpdate = update;
            return this.state.tooltipMessage;
        }, this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 - investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            }, ()=>{
                // Reposition tooltip after content change (replaces the key-based remount)
                if ((0, $4mqcS.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) {
                    var _this$_tooltipUpdate;
                    (_this$_tooltipUpdate = this._tooltipUpdate) === null || _this$_tooltipUpdate === void 0 || _this$_tooltipUpdate.call(this);
                }
            });
        }, this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $jiYbW.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        }, this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $jiYbW.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch  {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        }, this.resetMessage = ()=>{
            const tooltip = (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? (0, $jiYbW.headingAnchorLinkMessages).copyLinkToClipboard : (0, $jiYbW.headingAnchorLinkMessages).copyHeadingLinkToClipboard;
            this.setTooltipState(tooltip);
        }, this.renderAnchorButton = ()=>{
            const { hideFromScreenReader: hideFromScreenReader = false, headingId: headingId } = this.props;
            const labelledBy = (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? this.props.intl.formatMessage((0, $jiYbW.headingAnchorLinkMessages).copyHeadingLinkLabelledBy, {
                copyLink: this.copyLinkId,
                heading: headingId
            }) : headingId;
            const tabIndex = (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? 0 : hideFromScreenReader ? undefined : -1;
            return /*#__PURE__*/ (0, $lqVX7.jsx)("button", {
                "data-testid": "anchor-button",
                id: this.copyLinkId,
                css: $5a94dd239a21de65$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onBlur: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-hidden": hideFromScreenReader,
                tabIndex: tabIndex,
                "aria-label": hideFromScreenReader ? undefined : this.state.tooltipMessage,
                "aria-labelledby": hideFromScreenReader ? undefined : labelledBy,
                type: "button"
            }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6SePM))), {
                label: this.getCopyAriaLabel(),
                color: this.state.isClicked ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)"
            }));
        };
        this.copyLinkId = (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? crypto.randomUUID() : undefined;
    }
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) {
            if ((0, $4mqcS.expValEquals)('a11y-fixes-week4-may-2026', 'isEnabled', true)) // Fix for A11Y-30972: Use content as a function with update callback so
            // the Tooltip repositions without unmounting (which caused focus loss).
            // @see https://hello.jira.atlassian.cloud/browse/A11Y-30972
            return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mj6h.default), {
                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                tag: $5a94dd239a21de65$var$CopyAnchorWrapperWithRef,
                content: this.renderTooltipContent,
                position: "top",
                delay: 0,
                isScreenReaderAnnouncementDisabled: (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
            // We set the key to the message to ensure it remounts when the message
            // changes, so that it correctly repositions.
            // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
            return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mj6h.default), {
                // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
                tag: $5a94dd239a21de65$var$CopyAnchorWrapperWithRef,
                content: tooltipMessage,
                position: "top",
                delay: 0,
                key: tooltipMessage,
                isScreenReaderAnnouncementDisabled: (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? true : false
            }, this.renderAnchorButton());
        }
        return this.renderAnchorButton();
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $5a94dd239a21de65$var$_default_1 = (0, $3rTf2.default)($5a94dd239a21de65$var$HeadingAnchor);
var $5a94dd239a21de65$export$2e2bcd8739ae039 = $5a94dd239a21de65$var$_default_1;

});
parcelRegister("6SePM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f51e3026bdf0966f56fca36d1a42e0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $50134affa023734c$var$_react = $50134affa023734c$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $50134affa023734c$var$_baseNew = $50134affa023734c$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $50134affa023734c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $50134affa023734c$var$LinkIcon = (props)=>/*#__PURE__*/ $50134affa023734c$var$_react.default.createElement($50134affa023734c$var$_baseNew.default, Object.assign({
        name: "LinkIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$50134affa023734c$var$LinkIcon.displayName = 'LinkIcon';
var $50134affa023734c$var$_default = module.exports.default = $50134affa023734c$var$LinkIcon;

});

parcelRegister("jiYbW", function(module, exports) {
$parcel$export(module.exports, "headingAnchorLinkMessages", () => $db45d3d2a3a883b5$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $db45d3d2a3a883b5$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $db45d3d2a3a883b5$export$9f52c375a6ef34fc);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $6BhDL = parcelRequire("6BhDL");
const $db45d3d2a3a883b5$export$74bada844422036d = (0, $6BhDL.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Tooltip and aria-label for the button that copies an anchor link to a heading in the rendered document to the clipboard.'
    },
    copyLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLinkTo',
        defaultMessage: 'Copy link to',
        description: 'Copy heading link to clipboard. Will be used as part of a 2-part a11y label ("Copy link to", "{heading text}")'
    },
    copyHeadingLinkLabelledBy: {
        id: 'fabric.editor.headingLink.copyAnchorLinkLabelledBy',
        defaultMessage: '{copyLink} {heading}',
        description: 'The order in which to read the parts of the aria-labelledby for the copy heading link button depending on the grammar of the language. {copyLink} will be replaced with the "Copy link to" text and {heading} will be replaced with the actual heading text'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly on the copy button after the heading anchor link has been successfully copied to the clipboard.'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'Aria label for the copy link button displayed next to a heading. Used by screen readers to describe the button that copies the heading anchor link to the clipboard.'
    }
});
const $db45d3d2a3a883b5$export$c79ebc36348824d1 = (0, $6BhDL.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'Accessible label for a table column sort indicator when no sorting is applied to that column.'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $db45d3d2a3a883b5$export$9f52c375a6ef34fc = (0, $6BhDL.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});



parcelRegister("43AXx", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8561ced16b451e9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $jLTyB = parcelRequire("jLTyB");
const $a8561ced16b451e9$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jLTyB.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", null, text || 'inlineExtension');
    }));
};
var $a8561ced16b451e9$export$2e2bcd8739ae039 = $a8561ced16b451e9$var$InlineExtension;

});

parcelRegister("6i8Nh", function(module, exports) {
$parcel$export(module.exports, "default", () => $63e81df754da9952$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $hdn08 = parcelRequire("hdn08");
function $63e81df754da9952$export$2e2bcd8739ae039(props) {
    var _props$content;
    return (0, $hdn08.editorExperiment)('advanced_layouts', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: "layout-section-container",
        "data-local-id": props.localId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-layout-section": true,
        "data-layout-columns": props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
    }, props.children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-layout-section": true,
        "data-local-id": props.localId
    }, props.children);
}

});

parcelRegister("f72cs", function(module, exports) {
$parcel$export(module.exports, "default", () => $b135635f89ded244$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2TUMI = parcelRequire("2TUMI");

var $4mqcS = parcelRequire("4mqcS");

var $e0lTC = parcelRequire("e0lTC");

var $deelI = parcelRequire("deelI");
const $b135635f89ded244$var$LayoutSectionMigration = (0, $2TUMI.componentWithCondition)(()=>(0, $4mqcS.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $e0lTC.LayoutSectionCompiled), (0, $deelI.LayoutSectionEmotion));
function $b135635f89ded244$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b135635f89ded244$var$LayoutSectionMigration, props);
}

});
parcelRegister("e0lTC", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionCompiled", () => $5b3357550f966ee9$export$417b5700bb65fae1);
/* layoutColumn-compiled.tsx generated by @compiled/babel-plugin v0.37.1 */ /**
 * Compiled branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $ag3hq = parcelRequire("ag3hq");

var $3H4LK = parcelRequire("3H4LK");

var $4ubSX = parcelRequire("4ubSX");
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $5b3357550f966ee9$var$clearNextSiblingMarginTopStyle = null;
const $5b3357550f966ee9$var$verticalAlignMiddleStyles = null;
const $5b3357550f966ee9$var$verticalAlignBottomStyles = null;
const $5b3357550f966ee9$var$multipleWrappedImagesStyle = null;
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $5b3357550f966ee9$var$clearNextSiblingBlockMarkMarginTopStyle = null;
const $5b3357550f966ee9$export$417b5700bb65fae1 = (props)=>{
    const isLayoutColumnMenuEnabled = (0, $4ubSX.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true);
    // Pure rollout gate: no A/B exposure analysis is planned for this rendering switch.
    const isLayoutColumnValignRenderingEnabled = (0, $4ubSX.expValEqualsNoExposure)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        className: (0, $ltgDR.default)([
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && "_1e0c1txw _2lx21bp4 _1bah1h6o",
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && "_1e0c1txw _2lx21bp4 _1bahesu3",
            (0, $3H4LK.fg)('platform_editor_fix_media_in_renderer') && "_1tihidpf _12kpidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ag3hq.WidthProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            "_1skbgrf3",
            "_19segrf3 _1ki1grf3 _bmdegrf3 _166hgrf3 _7g1ogrf3 _sk2jgrf3 _hgeogrf3"
        ])
    }), props.children));
};

});
parcelRegister("4ubSX", function(module, exports) {
$parcel$export(module.exports, "expValEqualsNoExposure", () => $f6c5608f7e6d977e$export$63eebf86443a0a61);

var $6nD91 = parcelRequire("6nD91");
function $f6c5608f7e6d977e$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $6nD91.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}

});


parcelRegister("deelI", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionEmotion", () => $89ba87f740b93883$export$2cc1a43fb56df180);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `layoutColumn.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $ag3hq = parcelRequire("ag3hq");

var $3H4LK = parcelRequire("3H4LK");

var $4ubSX = parcelRequire("4ubSX");
function $89ba87f740b93883$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// localized styles, was from clearNextSiblingMarginTopStyle in @atlaskit/editor-common/ui
const $89ba87f740b93883$var$clearNextSiblingMarginTopStyle = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $89ba87f740b93883$var$verticalAlignMiddleStyles = {
    name: "16mmcnu",
    styles: "display:flex;flex-direction:column;justify-content:center"
};
const $89ba87f740b93883$var$verticalAlignBottomStyles = {
    name: "igeqly",
    styles: "display:flex;flex-direction:column;justify-content:flex-end"
};
const $89ba87f740b93883$var$multipleWrappedImagesStyle = {
    name: "y2yz5o",
    styles: "& [class*=\"image-wrap-\"] + [class*=\"image-wrap-\"], & [class*=\"image-wrap-\"]:has( + [class*=\"image-wrap-\"]){margin-top:0;}"
};
// localized styles, was from clearNextSiblingBlockMarkMarginTopStyle in @atlaskit/editor-common/ui
const $89ba87f740b93883$var$clearNextSiblingBlockMarkMarginTopStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`+ .fabric-editor-block-mark > p,
	  + .fabric-editor-block-mark > h1,
	  + .fabric-editor-block-mark > h2,
	  + .fabric-editor-block-mark > h3,
	  + .fabric-editor-block-mark > h4,
	  + .fabric-editor-block-mark > h5,
	  + .fabric-editor-block-mark > h6
	`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});
const $89ba87f740b93883$export$2cc1a43fb56df180 = (props)=>{
    const isLayoutColumnMenuEnabled = (0, $4ubSX.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true);
    // Pure rollout gate: no A/B exposure analysis is planned for this rendering switch.
    const isLayoutColumnValignRenderingEnabled = (0, $4ubSX.expValEqualsNoExposure)('platform_editor_layout_column_valign_rendering', 'isEnabled', true);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        "data-valign": props.valign,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- flexBasis is dynamic
        style: {
            flexBasis: `${props.width}%`
        },
        css: [
            // Keep separate: Compiled crashes on ternary/object lookup here.
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'middle' && $89ba87f740b93883$var$verticalAlignMiddleStyles,
            (isLayoutColumnValignRenderingEnabled || isLayoutColumnMenuEnabled) && props.valign === 'bottom' && $89ba87f740b93883$var$verticalAlignBottomStyles,
            (0, $3H4LK.fg)('platform_editor_fix_media_in_renderer') && $89ba87f740b93883$var$multipleWrappedImagesStyle
        ]
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $ag3hq.WidthProvider), null, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: [
            $89ba87f740b93883$var$clearNextSiblingMarginTopStyle,
            $89ba87f740b93883$var$clearNextSiblingBlockMarkMarginTopStyle
        ]
    }), props.children));
};

});


parcelRegister("iTo2x", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea89d5c380301f04$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $ea89d5c380301f04$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("li", null, props.children);
}

});

parcelRegister("f7NN2", function(module, exports) {
$parcel$export(module.exports, "default", () => $c377605a8e269bd4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $jpOSt = parcelRequire("jpOSt");
const $c377605a8e269bd4$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jpOSt.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $c377605a8e269bd4$export$2e2bcd8739ae039 = $c377605a8e269bd4$var$RenderCaption;

});
parcelRegister("jpOSt", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc497f5586bf9291$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $3rTf2 = parcelRequire("3rTf2");

var $7TPEx = parcelRequire("7TPEx");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $4Jfh8 = parcelRequire("4Jfh8");
function $bc497f5586bf9291$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bc497f5586bf9291$var$captionWrapperStyle = {
    name: "4iruax",
    styles: "margin-top:var(--ds-space-100, 8px);text-align:center;position:relative;color:var(--ds-text-subtle, #505258)"
};
const $bc497f5586bf9291$var$placeholderStyle = (0, $2m8U6.xcss)({
    color: 'color.text.subtlest',
    position: 'absolute',
    top: 'space.0',
    width: '100%'
});
class $bc497f5586bf9291$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $bc497f5586bf9291$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $lqVX7.jsx)((0, $7TPEx.default), {
            xcss: $bc497f5586bf9291$var$placeholderStyle
        }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $e2Zgo.default), null, formatMessage((0, $4Jfh8.messages).placeholder))) : null, children);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $bc497f5586bf9291$var$_default_1 = (0, $3rTf2.default)($bc497f5586bf9291$export$f7feb87190a94c76);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$bc497f5586bf9291$export$2e2bcd8739ae039 = $bc497f5586bf9291$var$_default_1;

});
parcelRegister("4Jfh8", function(module, exports) {
$parcel$export(module.exports, "messages", () => $888647893b4375f1$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $888647893b4375f1$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("kTO13", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9d05197360d3f02$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $aZvqc = parcelRequire("aZvqc");

var $1X0CD = parcelRequire("1X0CD");

var $bTXsV = parcelRequire("bTXsV");
var $bpQNT = parcelRequire("bpQNT");

var $7n8vF = parcelRequire("7n8vF");
function $c9d05197360d3f02$export$2e2bcd8739ae039(props) {
    var _props$content;
    const extraProps = {};
    const itemCounterDigitsSize = (0, $bTXsV.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props === null || props === void 0 || (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 1) extraProps.style = (0, $1X0CD.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $bpQNT.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $aZvqc.orderedListSelector).substr(1),
        "data-local-id": props.localId,
        "data-indent-level": props.path ? (0, $7n8vF.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});
parcelRegister("1X0CD", function(module, exports) {
$parcel$export(module.exports, "listItemCounterPadding", () => $259e6d8f49058028$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $259e6d8f49058028$export$6d31fdb1d74cee3e);
const $259e6d8f49058028$export$bafd6beec0797f87 = 24;
var $259e6d8f49058028$var$CSS_VAR_NAMES = /*#__PURE__*/ function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
    return CSS_VAR_NAMES;
}($259e6d8f49058028$var$CSS_VAR_NAMES || {});
const $259e6d8f49058028$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 2) {
        // When there are 2 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $259e6d8f49058028$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $259e6d8f49058028$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $259e6d8f49058028$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $259e6d8f49058028$var$stringifyStyle(style);
    return style;
}

});

parcelRegister("bTXsV", function(module, exports) {
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $f8d7f118ff9ff65a$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $f8d7f118ff9ff65a$export$320582fc14ba1e0f);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.

var $bpQNT = parcelRequire("bpQNT");




const $f8d7f118ff9ff65a$export$8ef94ae42a3729bd = 1;
const $f8d7f118ff9ff65a$export$cbefb5b89ef0719f = (orderedListNode)=>{
    var _orderedListNode$attr;
    const order = orderedListNode === null || orderedListNode === void 0 || (_orderedListNode$attr = orderedListNode.attrs) === null || _orderedListNode$attr === void 0 ? void 0 : _orderedListNode$attr.order;
    return (0, $bpQNT.resolveOrder)(order) ?? $f8d7f118ff9ff65a$export$8ef94ae42a3729bd;
};
const $f8d7f118ff9ff65a$export$320582fc14ba1e0f = (options)=>{
    var _String;
    const order = (0, $bpQNT.resolveOrder)(options.order) ?? $f8d7f118ff9ff65a$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return (_String = String(largestCounter)) === null || _String === void 0 || (_String = _String.split('.')) === null || _String === void 0 || (_String = _String[0]) === null || _String === void 0 ? void 0 : _String.length;
};

});
parcelRegister("bpQNT", function(module, exports) {
$parcel$export(module.exports, "resolveOrder", () => $d9d070b6b675340c$export$d445360e2a3c026b);
// resolve "order" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveStart"
// in packages/editor/adf-schema/src/schema/nodes/ordered-list.ts
const $d9d070b6b675340c$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};

});



parcelRegister("8kzB9", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9834a653328a2bb$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bZNJ9 = parcelRequire("bZNJ9");
function $f9834a653328a2bb$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes, localId: localId, asInline: asInline }) {
    return(// ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("p", {
        ...dataAttributes,
        "data-local-id": localId,
        "data-as-inline": asInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bZNJ9.default), null, children)));
}

});
parcelRegister("bZNJ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d88fed49467b92b5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $d88fed49467b92b5$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, "\xa0");
    return children;
}

});


parcelRegister("277As", function(module, exports) {
$parcel$export(module.exports, "default", () => $e461080801e8dc81$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $e461080801e8dc81$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", null);
}

});

parcelRegister("lTSuC", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ed02468e5f37669$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $6ed02468e5f37669$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("hr", {
        role: "presentation"
    });
}

});

parcelRegister("eevY3", function(module, exports) {
$parcel$export(module.exports, "isTableResizingEnabled", () => $0432df581865143c$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "isStickyScrollbarEnabled", () => $0432df581865143c$export$bdb2dadcb04aad50);
$parcel$export(module.exports, "default", () => $0432df581865143c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $3HHms = parcelRequire("3HHms");
var $7akLL = parcelRequire("7akLL");

var $62h3c = parcelRequire("62h3c");

var $2qSQf = parcelRequire("2qSQf");
var $ag3hq = parcelRequire("ag3hq");

var $3H4LK = parcelRequire("3H4LK");

var $7qM0R = parcelRequire("7qM0R");
var $kOyOM = parcelRequire("kOyOM");
var $3WKW8 = parcelRequire("3WKW8");
var $1VYpW = parcelRequire("1VYpW");

var $4jnEE = parcelRequire("4jnEE");

var $faPFq = parcelRequire("faPFq");

var $28mV9 = parcelRequire("28mV9");

var $hdn08 = parcelRequire("hdn08");

var $3Aw44 = parcelRequire("3Aw44");

var $3dShV = parcelRequire("3dShV");

var $j7Id3 = parcelRequire("j7Id3");

var $wlKwA = parcelRequire("wlKwA");

var $8odkJ = parcelRequire("8odkJ");

var $5ZBYr = parcelRequire("5ZBYr");

var $e2SI5 = parcelRequire("e2SI5");

var $kgAJc = parcelRequire("kgAJc");

var $4mqcS = parcelRequire("4mqcS");

var $ldXaf = parcelRequire("ldXaf");

var $fBO6K = parcelRequire("fBO6K");
const $0432df581865143c$export$eec82c0a93aa66d9 = (appearance)=>(0, $5ZBYr.isFullWidthOrFullPageAppearance)(appearance) || (0, $5ZBYr.isCommentAppearance)(appearance);
const $0432df581865143c$export$bdb2dadcb04aad50 = (appearance)=>(0, $5ZBYr.isFullWidthOrFullPageAppearance)(appearance) && (0, $hdn08.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $0432df581865143c$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $4jnEE.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $3WKW8.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $kOyOM.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $0432df581865143c$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $0432df581865143c$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $0432df581865143c$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $0432df581865143c$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $0432df581865143c$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $0432df581865143c$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $3dShV.TableHeader);
    return children.every((node)=>node.type === (0, $3dShV.TableHeader));
};
/**
 * This TableWrapper component was created to make sure that the aria-label can be
 * internationalized without needing to add `intl` to the TableContainer.
 *
 * <TableWrapper wrapperRef={ref} onScroll={handleScroll} stickyHeaders={config}>
 *   <Table>...</Table>
 * </TableWrapper>
 */ const $0432df581865143c$var$TableWrapper = ({ children: children, wrapperRef: wrapperRef, onScroll: onScroll, stickyHeaders: stickyHeaders, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const isScrollableRegion = tabIndex !== undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER,
        ref: wrapperRef,
        onScroll: stickyHeaders ? onScroll : undefined,
        // Adding tabIndex here because this is a scrollable container and it needs to be focusable so keyboard users can scroll it.
        // eslint-disable-next-line @atlassian/a11y/no-noninteractive-tabindex
        tabIndex: tabIndex,
        role: isScrollableRegion ? 'region' : undefined,
        "aria-label": isScrollableRegion ? formatMessage((0, $62h3c.messages).tableScrollRegion) : undefined
    }, children);
};
const $0432df581865143c$export$940095e914312886 = (node, children)=>{
    return $0432df581865143c$export$28daf78feed5098c(children) && node && node.firstChild && !$0432df581865143c$export$42f5658c8e0092da(node.firstChild);
};
class $0432df581865143c$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    /**
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            var _this$props$stickyHea;
            this.overflowParent = (0, $wlKwA.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $0432df581865143c$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $e2SI5.TableStickyScrollbar)(this.wrapperRef.current);
    }
    /**
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) {
            var _this$props$stickyHea2;
            this.overflowParent = (0, $wlKwA.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
        } else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    /**
   *
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $3HHms.tableMarginTop) - (0, $wlKwA.tableStickyPadding);
    }
    /**
   *
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   *
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   *
   * @example
   */ render() {
        var _this$tableRef$curren;
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $faPFq.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const fullPageRendererWidthCSS = (0, $hdn08.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $3Aw44.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return [
                isRenderWidthValid ? Math.min((0, $faPFq.akEditorFullWidthLayoutWidth), renderWidth) : (0, $faPFq.akEditorFullWidthLayoutWidth),
                `min(${(0, $faPFq.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return [
                isRenderWidthValid ? Math.min((0, $faPFq.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $faPFq.akEditorMaxWidthLayoutWidth),
                `min(${(0, $faPFq.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`
            ];
            else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) {
                const tableContainerWidth = (0, $28mV9.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? renderWidth : tableContainerWidth,
                    renderWidthCSS
                ];
            } else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $28mV9.getTableContainerWidth)(tableNode);
                return [
                    isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth,
                    `min(${tableContainerWidth}px, ${renderWidthCSS})`
                ];
            }
        };
        const [tableWidth, tableWidthCSS] = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $faPFq.akEditorFullWidthLayoutWidth), renderWidth) : (0, $faPFq.akEditorFullWidthLayoutWidth);
        const fullWidthLineLengthCSS = `min(${(0, $faPFq.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLength = isRenderWidthValid ? Math.min((0, $faPFq.akEditorMaxWidthLayoutWidth), renderWidth) : (0, $faPFq.akEditorMaxWidthLayoutWidth);
        const maxWidthLineLengthCSS = `min(${(0, $faPFq.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const commentLineLength = isRenderWidthValid ? renderWidth : lineLengthFixedWidth;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $5ZBYr.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLength = (0, $5ZBYr.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : (0, $5ZBYr.isMaxWidthAppearance)(rendererAppearance) && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLength : isCommentAppearanceAndTableAlignmentEnabled ? commentLineLength : lineLengthFixedWidth;
        const lineLengthCSS = (0, $5ZBYr.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $5ZBYr.isMaxWidthAppearance)(rendererAppearance) && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        // Setting fixTableSSRResizing to false while FG logic is true in tableNew
        const fixTableSSRResizing = false;
        const tableWidthNew = fixTableSSRResizing ? (0, $28mV9.getTableContainerWidth)(tableNode) : tableWidth;
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $5ZBYr.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $5ZBYr.isFullWidthAppearance)(rendererAppearance) || ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && (0, $5ZBYr.isMaxWidthAppearance)(rendererAppearance) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) {
            left = (tableWidth - lineLength) / 2;
            leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        }
        if (fixTableSSRResizing) {
            if (!shouldCalculateLeftForAlignment && (0, $5ZBYr.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
            // When the screen is super wide we want table to break out.
            // However if screen is smaller than 760px. We want table align to left.
            leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        } else if (!shouldCalculateLeftForAlignment && (0, $5ZBYr.isFullPageAppearance)(rendererAppearance) && tableWidthNew > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if ((rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max') && fixTableSSRResizing) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $faPFq.akEditorDefaultLayoutWidth) ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? fixTableSSRResizing ? `calc(${tableWidthCSS})` : tableWidth : 'inherit';
        const isContentModeTable = (0, $ldXaf.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $fBO6K.isContentModeSupported)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfTable
        }) && (0, $4mqcS.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        let style;
        if (fixTableSSRResizing) style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        else style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': `${renderWidth}px`
            },
            width: finalTableContainerWidth,
            left: left,
            marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, $0432df581865143c$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && $0432df581865143c$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $wlKwA.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0432df581865143c$var$TableWrapper, {
            wrapperRef: this.wrapperRef,
            onScroll: this.props.stickyHeaders ? this.onWrapperScrolled : undefined,
            stickyHeaders: stickyHeaders,
            tabIndex: this.props.tabIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8odkJ.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing,
            isPresentational: isPresentational,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, this.grabFirstRowRef(children))), $0432df581865143c$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
            ref: this.stickyScrollbarRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)",
                // MAX_BROWSER_SCROLLBAR_HEIGHT
                // Follow editor to hide by default so it does not show empty gap in SSR
                // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: fixTableSSRResizing ? 'none' : 'block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: '100%'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            style: {
                width: (_this$tableRef$curren = this.tableRef.current) === null || _this$tableRef$curren === void 0 ? void 0 : _this$tableRef$curren.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $0432df581865143c$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kgAJc.RefSyncBlockFakeBorders), {
            isNumberColumnEnabled: isNumberColumnEnabled
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.overflowParent = null, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $wlKwA.tableStickyPadding);
            const tableTop = $0432df581865143c$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $0432df581865143c$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $0432df581865143c$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $0432df581865143c$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    /**
   *
   * @example
   */ render() {
        const { children: children } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children);
        const orderedChildren = (0, $7qM0R.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0432df581865143c$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $0432df581865143c$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $1VYpW.hasMergedCell)(tableNode)) return $0432df581865143c$export$100baa0f10804e6e($0432df581865143c$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $0432df581865143c$export$28daf78feed5098c(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0432df581865143c$var$TableWithShadowsAndContainerStyles = (0, $2qSQf.default)((0, $kgAJc.TableProcessorWithContainerStyles), {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0432df581865143c$var$TableWithShadows = (0, $2qSQf.default)($0432df581865143c$export$91e0997fd3f75d56, {
    /**
   * The :scope is in reference to table container and we are selecting only
   * direct children that match the table node wrapper selector, not their
   * descendants.
   */ overflowSelector: `:scope > .${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $0432df581865143c$var$TableWithWidth = (props)=>{
    if ((0, $3H4LK.fg)('platform-ssr-table-resize')) {
        var _props$columnWidths;
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        ((_props$columnWidths = props.columnWidths) === null || _props$columnWidths === void 0 ? void 0 : _props$columnWidths.reduce((total, val)=>total + val, 0)) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0432df581865143c$var$TableWithShadowsAndContainerStyles, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kgAJc.TableProcessorWithContainerStyles), props);
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ag3hq.WidthConsumer), null, ({ width: width })=>{
        var _props$columnWidths2;
        const renderWidth = props.rendererAppearance === 'full-page' ? width - (0, $3Aw44.FullPagePadding) * 2 : width;
        const colWidthsSum = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        ((_props$columnWidths2 = props.columnWidths) === null || _props$columnWidths2 === void 0 ? void 0 : _props$columnWidths2.reduce((total, val)=>total + val, 0)) || 0;
        if (colWidthsSum || props.allowTableResizing) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0432df581865143c$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0432df581865143c$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props
        });
    });
};
const $0432df581865143c$var$_default_1 = (0, $j7Id3.withSmartCardStorage)($0432df581865143c$var$TableWithWidth);
var $0432df581865143c$export$2e2bcd8739ae039 = $0432df581865143c$var$_default_1;

});
parcelRegister("3HHms", function(module, exports) {
$parcel$export(module.exports, "tableMarginTop", () => $d8876d6b2218acb4$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableCellMinWidth", () => $d8876d6b2218acb4$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $d8876d6b2218acb4$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $d8876d6b2218acb4$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $d8876d6b2218acb4$export$e56b8ca552b280f6);
$parcel$export(module.exports, "tableControlsSpacing", () => $d8876d6b2218acb4$export$880976487022eb5);
$parcel$export(module.exports, "tableSharedStyle", () => $d8876d6b2218acb4$export$c2bf8eea75aa9302);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $faPFq = parcelRequire("faPFq");
var $bngWB = parcelRequire("bngWB");

var $3H4LK = parcelRequire("3H4LK");

var $4mqcS = parcelRequire("4mqcS");

var $4ubSX = parcelRequire("4ubSX");

var $cpSqr = parcelRequire("cpSqr");

var $4LRBs = parcelRequire("4LRBs");

var $3Ipi0 = parcelRequire("3Ipi0");

var $7akLL = parcelRequire("7akLL");

function $d8876d6b2218acb4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8876d6b2218acb4$export$808015ab1dd6897a = 24;
const $d8876d6b2218acb4$export$afe1899c3eea9823 = 16;
const $d8876d6b2218acb4$export$910bf0d22c3d10f2 = 14;
const $d8876d6b2218acb4$export$a43e30915fab3ccf = 8;
const $d8876d6b2218acb4$export$531f77930bf508de = 48;
const $d8876d6b2218acb4$export$c60fae4049791eae = 140;
const $d8876d6b2218acb4$export$72aad729077aa0fb = 1;
const $d8876d6b2218acb4$export$e56b8ca552b280f6 = 8;
const $d8876d6b2218acb4$export$bba39e724bc39451 = 6;
const $d8876d6b2218acb4$export$e5ff276883773ffd = 8;
const $d8876d6b2218acb4$export$880976487022eb5 = $d8876d6b2218acb4$export$808015ab1dd6897a + $d8876d6b2218acb4$export$e5ff276883773ffd - $d8876d6b2218acb4$export$72aad729077aa0fb;
/* first block node has 0 top margin */ var $d8876d6b2218acb4$var$_ref = {
    name: "qubt66",
    styles: ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}"
};
var $d8876d6b2218acb4$var$_ref2 = {
    name: "1fct7qz",
    styles: ">:nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span)){margin-top:0;}"
};
const $d8876d6b2218acb4$var$firstNodeWithNotMarginTop = ()=>(0, $3H4LK.fg)('platform_editor_nested_dnd_styles_changes') ? $d8876d6b2218acb4$var$_ref2 : $d8876d6b2218acb4$var$_ref;
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
/**
 * The style is mirrored in:
 * - packages/editor/renderer/src/ui/Renderer/RendererStyleContainer.tsx ( seems outdated )
 * - packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
 *
 * If you are updating this, please also update the above files.
 *
 * @deprecated This Emotion-based style function is being phased out as part of the
 * `platform_editor_core_static_css` experiment migration to Compiled CSS. While the experiment
 * is running, any changes here MUST also be reflected in `EditorContentContainer-compiled.tsx`
 * (look for `tableSharedStyle`, `tableSharedStyle_with_*`, `tableSharedStyle_without_*` entries
 * in the `editorContentStyles` cssMap). Failure to do so will cause visual regressions when the
 * compiled version is active.
 */ const $d8876d6b2218acb4$export$c2bf8eea75aa9302 = ()=>{
    const browser = (0, $cpSqr.getBrowserInfo)();
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
    return /*#__PURE__*/ (0, $lqVX7.css)((0, $3Ipi0.tableCellBackgroundStyleOverride)(), " .", (0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;", (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Fake side borders are not needed when the rounded overlay owns the outer border. */
				.${(0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER},
				.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER} {
					display: none;
				}
					` : `.${(0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER},
			.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				display: block;
				width: 1px;
				height: calc(100% - ${"var(--ds-space-300, 24px)"});
				background: ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				position: absolute;
				top: ${"var(--ds-space-300, 24px)"};
			}
			.${(0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
				right: 0;
			}
			.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER} {
				left: 0;
			}
			.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true'] {
				left: ${(0, $faPFq.akEditorTableNumberColumnWidth) - 1}px;
			}`, ";.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", (0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $faPFq.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", (0, $7akLL.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", (0, $7akLL.TableSharedCssClassName).TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", (0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", (0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}", (0, $3H4LK.fg)('platform_editor_bordered_panel_nested_in_table') ? `.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} .ak-editor-panel {
			border: ${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"};
		}` : '', ".", (0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER, ">table,.", (0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER, ">table,.", (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;", (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Keep a transparent border so the collapsed border model reserves the same 1px slot
			   on the table edge; the ::after overlay draws the visible rounded border instead. */
			border: ${$d8876d6b2218acb4$export$72aad729077aa0fb}px solid transparent;` : `border: ${$d8876d6b2218acb4$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
			border-left-color: transparent;
			border-right-color: transparent;`, " table-layout:fixed;font-size:1em;width:100%;", (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `position: relative;

			/* Table-width outer-border owner for overflow-safe rounded corners. */
			&::after {
				content: '';
				position: absolute;
				inset: -0.5px;
				border: ${$d8876d6b2218acb4$export$72aad729077aa0fb}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
				border-radius: ${"var(--ds-radius-xlarge, 12px)"};
				pointer-events: none;
				z-index: 1;
			}` : '', " &[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, #00000000);}>tbody>tr>th,>tbody>tr>td{min-width:", $d8876d6b2218acb4$export$531f77930bf508de, "px;font-weight:var(--ds-font-weight-regular, 400);vertical-align:top;", (0, $4ubSX.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) ? `&[data-valign='middle'] {
								vertical-align: middle;
							}
							&[data-valign='bottom'] {
								vertical-align: bottom;
							}` : '', " border:1px solid var(--ds-background-accent-gray-subtler, #DDDEE1);border-right-width:0;border-bottom-width:0;padding:var(--ds-space-100, 8px);", browser.gecko || browser.ie || browser.mac && browser.chrome ? 'background-clip: padding-box;' : '', " ", $d8876d6b2218acb4$var$firstNodeWithNotMarginTop(), " th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}>tbody>tr>td{background-color:var(--ds-surface, #FFFFFF);}", (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* Let the wrapper overlay own the outer table perimeter.
				   data-reaches-* attributes are set by the TableCell node view. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top] {
					border-top-color: transparent;
				}

				> tbody > tr > th[data-reaches-left],
				> tbody > tr > td[data-reaches-left] {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-left]::after {
					border-left-color: transparent;
				}

				> tbody > tr > td[data-reaches-bottom]::after,
				> tbody > tr > th[data-reaches-bottom]::after {
					border-bottom-color: transparent;
				}

				/* The rounded-table overlay owns transparent perimeter borders.
				   Paint edge cell backgrounds into that reserved border area so coloured
				   first/last rows do not show the page background through 1px seams. */
				> tbody > tr > th[data-reaches-top],
				> tbody > tr > td[data-reaches-top],
				> tbody > tr > th[data-reaches-bottom],
				> tbody > tr > td[data-reaches-bottom] {
					background-clip: border-box;
				}` : '', " th{background-color:var(--ds-background-accent-gray-subtlest, #F0F1F2);text-align:left;", (0, $4mqcS.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? '&:not(.danger)' : '&:not([style]):not(.danger)', "{.", (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, #FFFFFF);:not(.", (0, $faPFq.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, #0B120E24);}.", (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $bngWB.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, #0515240F);}.", (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, #0515240F);}>[data-ds--code--code-block]{background-image:", (0, $bngWB.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, #0515240F)!important;/* selector lives inside @atlaskit/code */--ds--code--line-number-bg-color:var(--ds-background-neutral, #0515240F);}}}}}}", (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `/* When the number column is enabled, the left visual edge belongs to the number column.
		   Remove the left border-radius and left border from the table's ::after overlay
		   so it doesn't double-up or round where the number column already provides that edge. */
		.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true'] {
			> .${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table::after,
			> .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table::after {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
				border-left-color: transparent;
			}
		}` : '', ";");
};

});
parcelRegister("bngWB", function(module, exports) {
$parcel$export(module.exports, "overflowShadow", () => $94ded6f5f2386f0e$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");
const $94ded6f5f2386f0e$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $lqVX7.css)();
};

});

parcelRegister("4LRBs", function(module, exports) {
$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $0a36c3054a01cc8a$export$42659c26f026f6ea);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $0a36c3054a01cc8a$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]',
    CODEBLOCK_CONTENT_WRAPPED: 'code-content--wrapped',
    CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET: 'code-content__line-number--wrapped'
};

});

parcelRegister("3Ipi0", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $a87bffb3e002459a$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $bz1wP = parcelRequire("bz1wP");
const $a87bffb3e002459a$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $lqVX7.css)((0, $bz1wP.mapBackgroundColors)());

});
parcelRegister("bz1wP", function(module, exports) {
$parcel$export(module.exports, "mapBackgroundColors", () => $2ae45db5594ae84b$export$35c9e86e192acb85);

var $clekI = parcelRequire("clekI");

var $lqByf = parcelRequire("lqByf");
const $2ae45db5594ae84b$export$35c9e86e192acb85 = ()=>{
    let cssString = '';
    (0, $clekI.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $lqByf.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};

});
parcelRegister("lqByf", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $1a7eecb106532d9e$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $1a7eecb106532d9e$export$a270511a0e7fd61a);
// This import will be stripped on build

var $1FAyp = parcelRequire("1FAyp");
function $1a7eecb106532d9e$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1a7eecb106532d9e$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.token : undefined;
}
function $1a7eecb106532d9e$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1a7eecb106532d9e$export$2462741d70e6a62f[hexColor.toUpperCase()];
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $1a7eecb106532d9e$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #669DF1)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E7F9FF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #C6EDFB)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #6CC3E0)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #DCFFF1)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #BAF3DB)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #4BCE97)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #F5E989)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FCA700)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFECEB)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFD5D2)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #F87168)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #F8EEFE)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #EED7FC)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #C97CF4)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $1FAyp.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F0F1F2)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $1FAyp.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #8C8F97)" // source for hex code was legacy token N60,
    }
};

});
parcelRegister("1FAyp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef00752fef209463$export$2e2bcd8739ae039);


var $at1js = parcelRequire("at1js");

var $3TFEq = parcelRequire("3TFEq");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $ef00752fef209463$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $at1js.default)[tokenId];
    let tokenValue = fallback;
    typeof $3TFEq;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $ef00752fef209463$export$2e2bcd8739ae039 = $ef00752fef209463$var$getTokenValue;

});
parcelRegister("at1js", function(module, exports) {
$parcel$export(module.exports, "default", () => $7191bdfd94ca2859$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f64d7a1e3392b669ad5c7bfd53c7403>>
 * @codegenCommand yarn build tokens
 */ const $7191bdfd94ca2859$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $7191bdfd94ca2859$export$2e2bcd8739ae039 = $7191bdfd94ca2859$var$tokens;

});





parcelRegister("7akLL", function(module, exports) {
$parcel$export(module.exports, "TableSharedCssClassName", () => $dca5d75c98c4210e$export$c096bca5477eb7ad);

var $clekI = parcelRequire("clekI");
const $dca5d75c98c4210e$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $clekI.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $clekI.tablePrefixSelector)}-wrapper`,
    TABLE_NODE_WRAPPER_NO_OVERFLOW: `${(0, $clekI.tablePrefixSelector)}-wrapper-no-overflow`,
    TABLE_SCROLL_INLINE_SHADOW: `${(0, $clekI.tablePrefixSelector)}-scroll-inline-shadow`,
    TABLE_RIGHT_BORDER: `${(0, $clekI.tablePrefixSelector)}-right-border`,
    TABLE_LEFT_BORDER: `${(0, $clekI.tablePrefixSelector)}-left-border`,
    TABLE_LEFT_SHADOW: `${(0, $clekI.tablePrefixSelector)}-with-left-shadow`,
    TABLE_NATIVE_STICKY: `${(0, $clekI.tablePrefixSelector)}-row-native-sticky`,
    TABLE_RIGHT_SHADOW: `${(0, $clekI.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $clekI.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $clekI.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $clekI.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $clekI.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $clekI.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $clekI.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $clekI.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $clekI.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $clekI.tablePrefixSelector)}-shadow-sentinel-right`,
    TABLE_STICKY: `${(0, $clekI.tablePrefixSelector)}-sticky`,
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $clekI.tableCellContentDomSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_CELL_WRAPPER: (0, $clekI.tableCellSelector),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    TABLE_HEADER_CELL_WRAPPER: (0, $clekI.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $clekI.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $clekI.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $clekI.tablePrefixSelector)}-resizer-container`,
    TABLE_VIEW_CONTENT_WRAP: 'tableView-content-wrap'
};

});


parcelRegister("62h3c", function(module, exports) {
$parcel$export(module.exports, "messages", () => $fc82274b77da9c2e$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $fc82274b77da9c2e$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    tableScrollRegion: {
        id: 'fabric.editor.tableScrollRegion',
        defaultMessage: 'Table scroll region',
        description: 'Label for the scrollable region of a table, used for accessibility purposes.'
    },
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'The text is shown as a menu item in the table options dropdown when the user wants to collapse a table by wrapping it inside an expand element.'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip text shown when hovering over the table width resize handle. Indicates users can drag to adjust the table width.'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table columns to delete them. The message adapts for singular or plural columns.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Label for the table context menu item that inserts a new empty row directly above the currently selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Label for the table context menu item that inserts a new empty row directly below the currently selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Label for the table menu item that moves the selected column(s) one position to the left. The placeholder {0} is the number of columns being moved and controls the plural form.'
    },
    moveColumnLeftHelpDialogLabel: {
        id: 'fabric.editor.moveColumnLeftHelpDialogLabel',
        defaultMessage: 'Move column left',
        description: 'Description of a keymap that moves one column or multiple columns left, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Label for the table menu item that moves the selected column(s) one position to the right. The placeholder {0} is the number of columns being moved and controls the plural form.'
    },
    moveColumnRightHelpDialogLabel: {
        id: 'fabric.editor.moveColumnRightHelpDialogLabel',
        defaultMessage: 'Move column right',
        description: 'Description of a keymap that moves one column or multiple columns right, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Label for the table menu item that moves the selected row(s) one position upward. The placeholder {0} is the number of rows being moved and controls the plural form.'
    },
    moveRowUpHelpDialogLabel: {
        id: 'fabric.editor.moveRowUpHelpDialogLabel',
        defaultMessage: 'Move row up',
        description: 'Description of a keymap that moves one row or multiple rows up, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Label for the table menu item that moves the selected row(s) one position downward. The placeholder {0} is the number of rows being moved and controls the plural form.'
    },
    moveRowDownHelpDialogLabel: {
        id: 'fabric.editor.moveRowDownHelpDialogLabel',
        defaultMessage: 'Move row down',
        description: 'Description of a keymap that moves one row or multiple rows down, this is in the help dialog and can be simpler than the puralisation version'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table rows to delete them. The message adapts for singular or plural rows.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    numberedRows: {
        id: 'fabrid.editor.numberedRows',
        defaultMessage: 'Numbered rows',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'Text prefix shown at the start of a confirmation dialog message when the user is about to delete a linked element in the editor.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'The text is shown as a checkbox label in a confirmation dialog when the user is about to delete an element that has connected extensions.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    cellAlignment: {
        id: 'fabric.editor.table.cellAlignment',
        defaultMessage: 'Alignment',
        description: 'Label for a nested menu that aligns content vertically inside a table cell.'
    },
    cellAlignmentTop: {
        id: 'fabric.editor.table.cellAlignmentTop',
        defaultMessage: 'Top',
        description: 'Label for an option that aligns table cell content to the top.'
    },
    cellAlignmentMiddle: {
        id: 'fabric.editor.table.cellAlignmentMiddle',
        defaultMessage: 'Middle',
        description: 'Label for an option that aligns table cell content to the middle.'
    },
    cellAlignmentBottom: {
        id: 'fabric.editor.table.cellAlignmentBottom',
        defaultMessage: 'Bottom',
        description: 'Label for an option that aligns table cell content to the bottom.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'The text is shown as a menu item in the cell options menu when the user selects multiple table cells to merge them into a single cell.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'The text is shown as a menu item in the cell options menu when the user wants to split a previously merged table cell back into individual cells.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Label for the table column menu item that sorts the column alphabetically in ascending (A to Z) order.'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Label for the table column menu item that sorts the column alphabetically in descending (Z to A) order.'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Label for the table column menu item that sorts numerical or date column values in increasing order.'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Label for the table column menu item that sorts numerical or date column values in decreasing order.'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    fitToContent: {
        id: 'fabric.editor.fitToContent',
        defaultMessage: `Fit to content`,
        description: `Resize table columns to fit their content`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    dragHandleZone: {
        id: 'fabric.editor.dragHandleZone',
        defaultMessage: 'Activate drag handle zone',
        description: 'The drag handle zone to trigger the drag handle to move the row/column within the table.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Label for the button in the table toolbar that switches the table to full-width display mode, expanding it to fill the page width.'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the center of the page.'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the left side of the page.'
    }
});

});

parcelRegister("7qM0R", function(module, exports) {
$parcel$export(module.exports, "compose", () => $d17afeca9f8bd610$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $d17afeca9f8bd610$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("kOyOM", function(module, exports) {
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $8099279ad115c897$export$69fbfaf01f2fd534);
function $8099279ad115c897$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}

});

parcelRegister("3WKW8", function(module, exports) {
$parcel$export(module.exports, "createCompareNodes", () => $14778d11fc8368f3$export$49215374a8bec29c);

var $3H4LK = parcelRequire("3H4LK");

var $4jnEE = parcelRequire("4jnEE");

var $i2o6c = parcelRequire("i2o6c");
function $14778d11fc8368f3$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $14778d11fc8368f3$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $14778d11fc8368f3$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1)// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .replace(/\p{Number}/gu, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!(stringNumber !== null && stringNumber !== void 0 && stringNumber.length)) return acc;
            const maybeANumber = $14778d11fc8368f3$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $14778d11fc8368f3$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $14778d11fc8368f3$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: (0, $i2o6c.ContentType).LINK,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: (0, $i2o6c.ContentType).NUMBER,
        value: normalizedText
    };
    return {
        type: (0, $i2o6c.ContentType).TEXT,
        value: normalizedText ?? text
    };
}
function $14778d11fc8368f3$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
        Get Meta value from the first child if the cell is of type
          * Heading (Any cell where the text is set to a heading type)
          * Paragraph (Normal text)
       */ case 'heading':
        case 'paragraph':
            return $14778d11fc8368f3$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: (0, $i2o6c.ContentType).LINK,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: (0, $i2o6c.ContentType).LINK,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $14778d11fc8368f3$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: (0, $i2o6c.ContentType).STATUS,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: (0, $i2o6c.ContentType).DATE,
                    value: timestamp
                };
            }
        case 'mention':
            {
                const text = firstChild.attrs.text || '';
                return {
                    type: (0, $i2o6c.ContentType).MENTION,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $14778d11fc8368f3$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $14778d11fc8368f3$export$49215374a8bec29c = (options, order = (0, $4jnEE.SortOrder).ASC)=>{
    const normalizeTextParser = $14778d11fc8368f3$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $14778d11fc8368f3$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $14778d11fc8368f3$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
        Donot switch the order (Asec or Desc) if either node is null.
        This will ensure that empty cells are always at the bottom during sorting.
      */ if (metaNodeA === null || metaNodeB === null) return $14778d11fc8368f3$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $4jnEE.SortOrder).DESC ? -1 : 1) * $14778d11fc8368f3$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $14778d11fc8368f3$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if ((0, $3H4LK.fg)('platform_editor_fix_mixed_types_column_sort')) {
        if (metaNodeA.type === (0, $i2o6c.ContentType).TEXT && metaNodeB.type === (0, $i2o6c.ContentType).NUMBER || metaNodeA.type === (0, $i2o6c.ContentType).NUMBER && metaNodeB.type === (0, $i2o6c.ContentType).TEXT) return $14778d11fc8368f3$var$compareValue(String(metaNodeA.value), String(metaNodeB.value));
    }
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $14778d11fc8368f3$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("4jnEE", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $1fb90240069ad491$export$7ae723045d45777a);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2SqHb = parcelRequire("2SqHb");

var $lXbrJ = parcelRequire("lXbrJ");

var $eiidY = parcelRequire("eiidY");

var $h6aYx = parcelRequire("h6aYx");

var $2ookx = parcelRequire("2ookx");

var $82sBI = parcelRequire("82sBI");

var $4iFJw = parcelRequire("4iFJw");
var $1fb90240069ad491$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
    return SortOrder;
}({});

});
parcelRegister("lXbrJ", function(module, exports) {
$parcel$export(module.exports, "ToolbarSize", () => $ad1792ab9a60a4c5$export$ed55211407a9423);
var $ad1792ab9a60a4c5$export$ed55211407a9423 = /*#__PURE__*/ function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
    return ToolbarSize;
}({});

});

parcelRegister("eiidY", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidths", () => $2631130f1561bee4$export$423b5e8c92d477b9);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ var $2631130f1561bee4$export$423b5e8c92d477b9 = /*#__PURE__*/ function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
    return ToolbarWidths;
}({});

});

parcelRegister("h6aYx", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $1215e0b4edbf4e3a$export$63ca43752be70b90);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
/** @deprecated
 * To be removed as part of ED-25129 in favour of ToolbarWidthsFullPageNext along with references
 * to platform_editor_toolbar_responsive_fixes feature gate
 */ var $1215e0b4edbf4e3a$export$63ca43752be70b90 = /*#__PURE__*/ function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
    return ToolbarWidthsFullPage;
}({});

});

parcelRegister("2ookx", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsFullPageNext", () => $18a437891173a414$export$501a79d885598191);
var $18a437891173a414$export$501a79d885598191 = /*#__PURE__*/ function(ToolbarWidthsFullPageNext) {
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XXL"] = 1200] = "XXL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["XL"] = 992] = "XL";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["L"] = 768] = "L";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["M"] = 576] = "M";
    ToolbarWidthsFullPageNext[ToolbarWidthsFullPageNext["S"] = 410] = "S";
    return ToolbarWidthsFullPageNext;
}({});

});

parcelRegister("82sBI", function(module, exports) {
$parcel$export(module.exports, "ToolbarWidthsNext", () => $b301f9e90547c37e$export$3f050002d3df641b);
var $b301f9e90547c37e$export$3f050002d3df641b = /*#__PURE__*/ function(ToolbarWidthsNext) {
    ToolbarWidthsNext[ToolbarWidthsNext["XXL"] = 768] = "XXL";
    ToolbarWidthsNext[ToolbarWidthsNext["XL"] = 576] = "XL";
    ToolbarWidthsNext[ToolbarWidthsNext["L"] = 460] = "L";
    ToolbarWidthsNext[ToolbarWidthsNext["M"] = 450] = "M";
    ToolbarWidthsNext[ToolbarWidthsNext["S"] = 410] = "S";
    return ToolbarWidthsNext;
}({});

});

parcelRegister("4iFJw", function(module, exports) {
$parcel$export(module.exports, "DIRECTION", () => $acc7ab51faf5bb33$export$9106728c49045482);
var $acc7ab51faf5bb33$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});

});


parcelRegister("i2o6c", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $dee7680481b8fe67$export$e2e108cbe2e4f865);
var $dee7680481b8fe67$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
    return ContentType;
}({});

});


parcelRegister("1VYpW", function(module, exports) {
$parcel$export(module.exports, "hasMergedCell", () => $b6129fc8e5e25ec8$export$f9d610bfbb78949b);
function $b6129fc8e5e25ec8$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}

});

parcelRegister("28mV9", function(module, exports) {
$parcel$export(module.exports, "layoutToWidth", () => $6f314693357b1fef$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $6f314693357b1fef$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $6f314693357b1fef$export$3930799be057b305);

var $f4roI = parcelRequire("f4roI");

var $faPFq = parcelRequire("faPFq");

var $3H4LK = parcelRequire("3H4LK");

var $dNnYN = parcelRequire("dNnYN");

var $8DBXG = parcelRequire("8DBXG");

var $3HHms = parcelRequire("3HHms");

var $7VVBW = parcelRequire("7VVBW");
const $6f314693357b1fef$var$GRID_SIZE = 8;
const $6f314693357b1fef$var$NESTED_DND_GUTTER_OFFSET = 8;
const $6f314693357b1fef$var$NESTED_DND_MARGIN_OFFSET = 12;
const $6f314693357b1fef$export$9b77d38feba5446 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    default: (0, $faPFq.akEditorDefaultLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    wide: (0, $faPFq.akEditorWideLayoutWidth),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    'full-width': (0, $faPFq.akEditorFullWidthLayoutWidth)
};
const $6f314693357b1fef$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    var _contextPanelPluginKe, _contextPanelPluginKe2;
    if (!pos) return;
    const node = $6f314693357b1fef$export$84f6ca4f6812e69a(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    const breakoutWidth = breakoutMark ? breakoutMark.attrs.width : undefined;
    let parentWidth = $6f314693357b1fef$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled, breakoutWidth);
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return state['contextPanelPluginKey$'];
        }
    };
    switch(node.type){
        case schema.nodes.layoutSection:
            // Calculate width of parent layout column when
            // Parallel layout with viewport greater than 1024px
            // OR side panel of an extension is open and change the node width to smaller than containerWidth
            if (containerWidth.width > (0, $faPFq.gridMediumMaxWidth) || ((_contextPanelPluginKe = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe === void 0 ? void 0 : _contextPanelPluginKe.contents.length) > 0 && ((_contextPanelPluginKe2 = contextPanelPluginKey.getState(state)) === null || _contextPanelPluginKe2 === void 0 ? void 0 : _contextPanelPluginKe2.contents[0]) !== undefined) {
                // margin between sections
                parentWidth -= (0, $3H4LK.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $8DBXG.LAYOUT_SECTION_MARGIN) + $6f314693357b1fef$var$NESTED_DND_MARGIN_OFFSET + 2) * (node.childCount - 1) : ((0, $8DBXG.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1);
                const $pos = state.doc.resolve(pos);
                const column = (0, $f4roI.findParentNodeOfTypeClosestToPos)($pos, [
                    state.schema.nodes.layoutColumn
                ]);
                if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
                parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
            }
            // account for the padding of the parent node
            parentWidth -= (0, $3H4LK.fg)('platform_editor_nested_dnd_styles_changes') ? ((0, $8DBXG.LAYOUT_COLUMN_PADDING) + $6f314693357b1fef$var$NESTED_DND_GUTTER_OFFSET) * 2 : (0, $8DBXG.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $dNnYN.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $dNnYN.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.expand:
            // padding
            parentWidth -= $6f314693357b1fef$var$GRID_SIZE * 2;
            // gutter offset
            parentWidth += $6f314693357b1fef$var$GRID_SIZE * 3;
            // padding right
            parentWidth -= $6f314693357b1fef$var$GRID_SIZE;
            // padding left
            parentWidth -= $6f314693357b1fef$var$GRID_SIZE * 4 - $6f314693357b1fef$var$GRID_SIZE / 2;
            break;
        case schema.nodes.tableCell:
        case schema.nodes.tableHeader:
            // Calculate the available column width
            if (Array.isArray(node.attrs.colwidth)) parentWidth = node.attrs.colwidth.slice(0, node.attrs.colspan).reduce((sum, width)=>sum + width, 0);
            // Compensate for padding
            parentWidth -= (0, $3HHms.tableCellPadding) * 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $6f314693357b1fef$export$84f6ca4f6812e69a = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $f4roI.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand,
        state.schema.nodes.tableCell,
        state.schema.nodes.tableHeader,
        state.schema.nodes.bodiedSyncBlock
    ]);
    return parent ? parent.node : null;
};
const $6f314693357b1fef$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled, breakoutWidth)=>{
    if (breakoutWidth) return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, breakoutWidth) : // container width minus breakout padding
    // --ak-editor--breakout-full-page-guttering-padding = (--ak-editor--large-gutter-padding * 2) + --ak-editor--default-gutter-padding
    Math.min(containerWidth.width - ((0, $faPFq.akEditorGutterPaddingDynamic)() * 2 + (0, $faPFq.akEditorGutterPadding)), breakoutWidth);
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $faPFq.akEditorFullWidthLayoutWidth)) : (0, $7VVBW.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $6f314693357b1fef$export$3930799be057b305 = (node)=>{
    if (node !== null && node !== void 0 && node.attrs.width) return node.attrs.width;
    return $6f314693357b1fef$export$9b77d38feba5446[node === null || node === void 0 ? void 0 : node.attrs.layout] || (0, $faPFq.akEditorDefaultLayoutWidth);
};
const $6f314693357b1fef$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $6f314693357b1fef$export$3930799be057b305(node) - offset;
    return $6f314693357b1fef$export$3930799be057b305(node);
};

});
parcelRegister("dNnYN", function(module, exports) {
$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $83f0563ccd313fd2$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $83f0563ccd313fd2$export$91624ec52c59c24c);
const $83f0563ccd313fd2$export$f5ecdce4c60ff98b = 8;
const $83f0563ccd313fd2$export$5ac5087fe1217160 = $83f0563ccd313fd2$export$f5ecdce4c60ff98b * 2;
const $83f0563ccd313fd2$export$91624ec52c59c24c = 12;

});

parcelRegister("8DBXG", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $057c8304cbca4386$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $057c8304cbca4386$export$a1bb91aa2d5fcce8);
const $057c8304cbca4386$export$cd04f19842abff0 = 8;
const $057c8304cbca4386$export$a1bb91aa2d5fcce8 = $057c8304cbca4386$export$cd04f19842abff0 * 1.5;
const $057c8304cbca4386$export$e5ee675b2c7e739b = 50;

});


parcelRegister("3Aw44", function(module, exports) {
$parcel$export(module.exports, "FullPagePadding", () => $237d7c31de6d384d$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $237d7c31de6d384d$export$74b525449cc7cbd1);
const $237d7c31de6d384d$export$12fd658e5eef0d79 = 32;
const $237d7c31de6d384d$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';

});

parcelRegister("3dShV", function(module, exports) {
$parcel$export(module.exports, "TableHeader", () => $3815bf50a0b742fa$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $3815bf50a0b742fa$export$1e4baea7053fc0e3);

var $4fqPo = parcelRequire("4fqPo");

var $9DIXD = parcelRequire("9DIXD");
var $clekI = parcelRequire("clekI");

var $a1GvG = parcelRequire("a1GvG");

var $4jnEE = parcelRequire("4jnEE");

var $lqByf = parcelRequire("lqByf");

var $kk2Qe = parcelRequire("kk2Qe");

var $dQtpO = parcelRequire("dQtpO");

var $f0GG4 = parcelRequire("f0GG4");

var $jANeU = parcelRequire("jANeU");

var $4MCQn = parcelRequire("4MCQn");

var $jiYbW = parcelRequire("jiYbW");

var $4mqcS = parcelRequire("4mqcS");

var $4ubSX = parcelRequire("4ubSX");
const $3815bf50a0b742fa$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $3815bf50a0b742fa$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $4jnEE.SortOrder).NO_ORDER:
            return (0, $4jnEE.SortOrder).ASC;
        case (0, $4jnEE.SortOrder).ASC:
            return (0, $4jnEE.SortOrder).DESC;
        case (0, $4jnEE.SortOrder).DESC:
            return (0, $4jnEE.SortOrder).NO_ORDER;
    }
    return (0, $4jnEE.SortOrder).NO_ORDER;
};
const $3815bf50a0b742fa$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $jiYbW.tableCellMessages);
    switch(currentSortOrder){
        case (0, $4jnEE.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $4jnEE.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $4jnEE.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $3815bf50a0b742fa$var$getDataAttributes = (colwidth, background, cellEdgeProps, valign)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    if ((0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesTop) attrs['data-reaches-top'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesBottom) attrs['data-reaches-bottom'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesLeft) attrs['data-reaches-left'] = true;
        if (cellEdgeProps !== null && cellEdgeProps !== void 0 && cellEdgeProps.reachesRight) attrs['data-reaches-right'] = true;
    }
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    if (valign && (0, $4ubSX.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) attrs['data-valign'] = valign;
    return attrs;
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3815bf50a0b742fa$var$cssVariablePattern = /^var\(--.*\)$/;
const $3815bf50a0b742fa$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode, valign: valign })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $lqByf.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else if (/**
     * There was previously a bug in dark mode where we would attempt to invert
     * a design token in `getDarkModeLCHColor` causing issues.
     * If it's a design token we should return it as is.
     */ $3815bf50a0b742fa$var$cssVariablePattern.test(background)) style.backgroundColor = background;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $9DIXD.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    if (valign && (0, $4ubSX.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true)) style.verticalAlign = valign;
    return style;
};
const $3815bf50a0b742fa$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $a1GvG.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort, reachesTop: reachesTop, reachesBottom: reachesBottom, reachesLeft: reachesLeft, reachesRight: reachesRight, valign: valign } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $clekI.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $3815bf50a0b742fa$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode,
                valign: valign
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$3815bf50a0b742fa$var$getDataAttributes(colwidth, background, {
                reachesTop: reachesTop,
                reachesBottom: reachesBottom,
                reachesLeft: reachesLeft,
                reachesRight: reachesRight
            }, valign),
            "aria-sort": ariaSort
        }, children);
    };
};
const $3815bf50a0b742fa$var$TH = $3815bf50a0b742fa$var$getWithCellProps('th');
const $3815bf50a0b742fa$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $4MCQn.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $4jnEE.SortOrder).NO_ORDER ? (0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $3815bf50a0b742fa$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            className: (0, $jANeU.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kk2Qe.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$3815bf50a0b742fa$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $3815bf50a0b742fa$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $f0GG4.ACTION).SORT_COLUMN,
                    actionSubject: (0, $f0GG4.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $dQtpO.PLATFORM).WEB,
                        mode: (0, $dQtpO.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $f0GG4.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $f0GG4.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $dQtpO.PLATFORM).WEB,
                    mode: (0, $dQtpO.MODE).RENDERER
                },
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK
            });
        }
    };
};
const $3815bf50a0b742fa$export$f850895b287ef28e = $3815bf50a0b742fa$export$cfca40ca5c56a38e($3815bf50a0b742fa$var$TH);
const $3815bf50a0b742fa$var$TD = $3815bf50a0b742fa$var$getWithCellProps('td');
const $3815bf50a0b742fa$export$1e4baea7053fc0e3 = $3815bf50a0b742fa$var$TD;

});
parcelRegister("kk2Qe", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef654b9ba508de3a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $3rTf2 = parcelRequire("3rTf2");

var $4mqcS = parcelRequire("4mqcS");

var $8Mj6h = parcelRequire("8Mj6h");

var $4jnEE = parcelRequire("4jnEE");

var $9HI3q = parcelRequire("9HI3q");

var $jcizi = parcelRequire("jcizi");

var $cLasY = parcelRequire("cLasY");

var $hKSJD = parcelRequire("hKSJD");

var $9Kotp = parcelRequire("9Kotp");
function $ef654b9ba508de3a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $ef654b9ba508de3a$var$buttonStyles = /*#__PURE__*/ (0, $lqVX7.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:var(--ds-border-width-selected, 2px) solid var(--ds-border, #0B120E24);border-radius:var(--ds-radius-small, 4px);background-color:var(--ds-surface-overlay, #FFFFFF);justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:var(--ds-surface-overlay-hovered, #F0F1F2);}&:active{background-color:var(--ds-surface-overlay-pressed, #DDDEE1);}&.", (0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $ef654b9ba508de3a$var$iconWrapperStyles = /*#__PURE__*/ (0, $lqVX7.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", (0, $9Kotp.StatusClassNames).DESC, "{transform:rotate(-180deg);}&.", (0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $ef654b9ba508de3a$var$iconStyles = {
    name: "3kmdk1",
    styles: "height:100%;width:2px;border-radius:var(--ds-radius-full, 9999px);background:var(--ds-icon, #292A2E);user-select:none;&::before, &::after{background:var(--ds-icon, #292A2E);content:'';height:2px;width:6px;position:absolute;border-radius:var(--ds-radius-full, 9999px);}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $ef654b9ba508de3a$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $4jnEE.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${(0, $9Kotp.StatusClassNames).SORTING_NOT_ALLOWED} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $4jnEE.SortOrder).ASC:
            return `${(0, $9Kotp.StatusClassNames).ASC} ${activeStatusClass}`;
        case (0, $4jnEE.SortOrder).DESC:
            return `${(0, $9Kotp.StatusClassNames).DESC} ${activeStatusClass}`;
        default:
            return `${(0, $9Kotp.StatusClassNames).NO_ORDER} ${activeStatusClass}`;
    }
};
const $ef654b9ba508de3a$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $hKSJD.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $4jnEE.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $4jnEE.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $4jnEE.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $ef654b9ba508de3a$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $cLasY.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $4jnEE.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $4jnEE.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $4jnEE.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $ef654b9ba508de3a$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME)} ${sortOrdered !== (0, $4jnEE.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME}__not-allowed `}`;
    const content = $ef654b9ba508de3a$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $ef654b9ba508de3a$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mj6h.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $ef654b9ba508de3a$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        "aria-hidden": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, (0, $4mqcS.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, $lqVX7.jsx)((0, $jcizi.NewSortingIcon), {
        sortOrdered: sortOrdered
    }) : /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $ef654b9ba508de3a$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $ef654b9ba508de3a$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: [
            $ef654b9ba508de3a$var$iconStyles
        ]
    }))));
};
const $ef654b9ba508de3a$var$_default_1 = (0, $3rTf2.default)($ef654b9ba508de3a$var$SortingIcon);
var $ef654b9ba508de3a$export$2e2bcd8739ae039 = $ef654b9ba508de3a$var$_default_1;

});
parcelRegister("9HI3q", function(module, exports) {
$parcel$export(module.exports, "SORTABLE_COLUMN_ICON_CLASSNAME", () => $6b30f636e11688cc$export$bd4f24d8b1e86b23);
const $6b30f636e11688cc$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;

});

parcelRegister("jcizi", function(module, exports) {
$parcel$export(module.exports, "NewSortingIcon", () => $96b2c6c7e4d3916a$export$4be21af7f864512e);
/* NewSortingIcon.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $9dBRD = parcelRequire("9dBRD");
var $laXi0 = parcelRequire("laXi0");

var $4jnEE = parcelRequire("4jnEE");
const $96b2c6c7e4d3916a$var$newIconWrapperStyles = {
    base: "_v5642l60 _1bsb7vkz _4t3i7vkz _1e0c1txw _1bah1h6o _4cvr1h6o _8hrz1qre",
    inactive: "_tzy415iw"
};
const $96b2c6c7e4d3916a$export$4be21af7f864512e = ({ sortOrdered: sortOrdered })=>{
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            $96b2c6c7e4d3916a$var$newIconWrapperStyles.base,
            sortOrdered === (0, $4jnEE.SortOrder).NO_ORDER && $96b2c6c7e4d3916a$var$newIconWrapperStyles.inactive
        ])
    }, sortOrdered === (0, $4jnEE.SortOrder).DESC ? /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9dBRD))), {
        spacing: "none",
        label: ""
    }) : /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($laXi0))), {
        spacing: "none",
        label: ""
    }));
};

});
parcelRegister("9dBRD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61f2cd3b3ce75546535a34edc6c6a407>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b62b2f883028889$var$_react = $6b62b2f883028889$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $6b62b2f883028889$var$_baseNew = $6b62b2f883028889$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $6b62b2f883028889$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b62b2f883028889$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $6b62b2f883028889$var$_react.default.createElement($6b62b2f883028889$var$_baseNew.default, Object.assign({
        name: "SortAscendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$6b62b2f883028889$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $6b62b2f883028889$var$_default = module.exports.default = $6b62b2f883028889$var$SortAscendingIcon;

});

parcelRegister("laXi0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa40f37165b56c780c43a081b97fc51>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f6a885ccfc4c109e$var$_react = $f6a885ccfc4c109e$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $f6a885ccfc4c109e$var$_baseNew = $f6a885ccfc4c109e$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $f6a885ccfc4c109e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f6a885ccfc4c109e$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $f6a885ccfc4c109e$var$_react.default.createElement($f6a885ccfc4c109e$var$_baseNew.default, Object.assign({
        name: "SortDescendingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$f6a885ccfc4c109e$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $f6a885ccfc4c109e$var$_default = module.exports.default = $f6a885ccfc4c109e$var$SortDescendingIcon;

});


parcelRegister("cLasY", function(module, exports) {
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $53880ac89a2ad12c$export$f142573f51a67577);

var $6BhDL = parcelRequire("6BhDL");
const $53880ac89a2ad12c$export$f142573f51a67577 = (0, $6BhDL.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});

parcelRegister("hKSJD", function(module, exports) {
$parcel$export(module.exports, "sortingIconMessages", () => $e893c329564a8891$export$458c50917513cd1a);

var $6BhDL = parcelRequire("6BhDL");
const $e893c329564a8891$export$458c50917513cd1a = (0, $6BhDL.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from A to Z (ascending order).'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Label shown on a table column header sort button to sort the column alphabetically from Z to A (descending order).'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'Label shown on a table column header sort button to remove any active sorting and restore the default column order.'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        // eslint-disable-next-line @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'Warning message shown in a table column header when sorting cannot be applied because the table contains merged cells.'
    }
});

});

parcelRegister("9Kotp", function(module, exports) {
$parcel$export(module.exports, "StatusClassNames", () => $d3c9c0fe9146c6a5$export$c3618f310f725028);
var $d3c9c0fe9146c6a5$export$c3618f310f725028 = /*#__PURE__*/ function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
    return StatusClassNames;
}({});

});



parcelRegister("j7Id3", function(module, exports) {
$parcel$export(module.exports, "Provider", () => $2d721acc6fd94000$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $2d721acc6fd94000$export$65e2d5a272a382b0);

var $4fqPo = parcelRequire("4fqPo");
const $2d721acc6fd94000$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(new Map());
const $2d721acc6fd94000$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2d721acc6fd94000$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $2d721acc6fd94000$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/prefer-stateless-function
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2d721acc6fd94000$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};

});

parcelRegister("wlKwA", function(module, exports) {
$parcel$export(module.exports, "tableStickyPadding", () => $96047be3c9cc0a85$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $96047be3c9cc0a85$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $96047be3c9cc0a85$export$e97bc6692974bd0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $7akLL = parcelRequire("7akLL");

var $faPFq = parcelRequire("faPFq");

var $4mqcS = parcelRequire("4mqcS");

var $8odkJ = parcelRequire("8odkJ");

var $lNiZQ = parcelRequire("lNiZQ");
function $96047be3c9cc0a85$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $96047be3c9cc0a85$export$3de6413b528017ca = 8;
const $96047be3c9cc0a85$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// increasing specificity to override external renderer wrapper styles targeting div[mode='stick']
const $96047be3c9cc0a85$var$suppressExternalStickStyles = {
    name: "1uqt4xf",
    styles: "&.fixed-table-div-custom-table-resizing[mode='stick']{background:var(--ds-surface-overlay, #FFFFFF);}"
};
// refactored based on fixedTableDivStaticStyles
// TODO: DSP-4123 - Quality ticket
const $96047be3c9cc0a85$var$fixedTableDivStaticStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    zIndex: 'var(--ak-renderer-sticky-header-zindex)',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: 0,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        tr: {
            background: "var(--ds-surface, #FFFFFF)"
        }
    },
    borderTop: `${$96047be3c9cc0a85$export$3de6413b528017ca}px solid ${"var(--ds-surface, #FFFFFF)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: `0 6px 4px -4px ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "div[data-expanded='false'] &": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
        top: '0px',
        height: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "&.fixed-table-div-custom-table-resizing[mode='stick']": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: 'var(--ak-renderer-sticky-header-zindex)'
    }
});
const $96047be3c9cc0a85$var$FixedTableDiv = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, allowTableResizing: allowTableResizing } = props;
    let stickyHeaderZIndex;
    if (allowTableResizing) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $faPFq.akEditorStickyHeaderZIndex);
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: allowTableResizing ? 'fixed-table-div-custom-table-resizing' : '',
        css: [
            $96047be3c9cc0a85$var$fixedTableDivStaticStyles,
            $96047be3c9cc0a85$var$modeSpecficStyles === null || $96047be3c9cc0a85$var$modeSpecficStyles === void 0 ? void 0 : $96047be3c9cc0a85$var$modeSpecficStyles[mode],
            (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $96047be3c9cc0a85$var$suppressExternalStickStyles
        ],
        style: {
            '--ak-renderer-sticky-header-zindex': stickyHeaderZIndex,
            width: `${wrapperWidth}px`,
            top: typeof top === 'number' ? `${top}px` : undefined
        }
    }, props.children);
};
const $96047be3c9cc0a85$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance, allowTableResizing: allowTableResizing, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if (allowTableResizing) styles = /*#__PURE__*/ (0, $lqVX7.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $lqVX7.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $lqVX7.jsx)($96047be3c9cc0a85$var$FixedTableDiv, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        allowTableResizing: allowTableResizing
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: fixTableSSRResizing ? 0 : ''
        }
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8odkJ.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        fixTableSSRResizing: fixTableSSRResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $lNiZQ.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 * @param table
 * @param defaultScrollRootId
 * @example
 */ function $96047be3c9cc0a85$var$findHorizontalOverflowScrollParent(table, defaultScrollRootId) {
    let parent = table;
    if (!parent) return null;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
        if (!!defaultScrollRootId && parent.id === defaultScrollRootId) // If a defaultScrollRootId was specified and we reached the element with this id without finding a closer
        // scroll parent, use this element as the scroll parent
        return parent;
    }
    return null;
}
class $96047be3c9cc0a85$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    /**
   *
   * @param el
   * @param defaultScrollRootId
   * @example
   */ static fromElement(el, defaultScrollRootId) {
        return new $96047be3c9cc0a85$export$e97bc6692974bd0b($96047be3c9cc0a85$var$findHorizontalOverflowScrollParent(el, defaultScrollRootId) || window);
    }
    /**
   *
   */ get isElement() {
        return this.ref instanceof HTMLElement;
    }
    /**
   *
   */ get id() {
        if (this.ref instanceof HTMLElement) return this.ref.id;
        return '';
    }
    /**
   *
   */ get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    addEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.addEventListener(type, cb, ...args);
    }
    /**
   *
   * @param type
   * @param cb
   * @param {...any} args
   * @example
   */ // Ignored via go/ees005
    removeEventListener(type, cb, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ...args) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("8odkJ", function(module, exports) {
$parcel$export(module.exports, "Table", () => $8012a24be124f9c9$export$54ec01a60f47d33d);

var $4fqPo = parcelRequire("4fqPo");

var $9m4OW = parcelRequire("9m4OW");

var $28mV9 = parcelRequire("28mV9");

var $faPFq = parcelRequire("faPFq");

var $3H4LK = parcelRequire("3H4LK");

var $4mqcS = parcelRequire("4mqcS");

var $ldXaf = parcelRequire("ldXaf");

var $fBO6K = parcelRequire("fBO6K");
const $8012a24be124f9c9$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableResizing: allowTableResizing, isPresentational: isPresentational, fixTableSSRResizing: fixTableSSRResizing = false, allowFixedColumnWidthOption: allowFixedColumnWidthOption = false })=>{
    var _tableNode$attrs;
    let tableWidth = tableNode ? (0, $28mV9.getTableContainerWidth)(tableNode) : (0, $faPFq.akEditorDefaultLayoutWidth);
    let tableColumnWidths = columnWidths;
    if (rendererAppearance === 'comment' && allowTableResizing && tableNode && !((_tableNode$attrs = tableNode.attrs) !== null && _tableNode$attrs !== void 0 && _tableNode$attrs.width)) tableWidth = 'inherit';
    if (rendererAppearance === 'comment' && !allowTableResizing) // in the case we have css container stylings,
    // we don't need to calculate width here as this
    // is done via css
    {
        if (!(0, $3H4LK.fg)('platform-ssr-table-resize')) tableWidth = renderWidth;
    }
    // for columns that are evenly distributed, do not return `colgroup` since existing table containerQuery
    // scales up the columns width. This ensures columns always have 42px.
    if (rendererAppearance === 'comment') {
        if ((0, $3H4LK.fg)('platform-ssr-table-resize')) tableColumnWidths = columnWidths && (0, $9m4OW.colWidthSum)(columnWidths) ? columnWidths : undefined;
    }
    const tableLayout = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout;
    const tableDisplayMode = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.displayMode;
    const isContentMode = (0, $ldXaf.isTableInContentMode)({
        tableNode: tableNode,
        isSupported: (0, $fBO6K.isContentModeSupported)({
            allowTableResizing: allowTableResizing,
            rendererAppearance: rendererAppearance
        }),
        isTableNested: isInsideOfBlockNode || isInsideOfTable
    }) && (0, $4mqcS.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("table", {
        ...(0, $3H4LK.fg)('platform_renderer_isPresentational') && {
            role: isPresentational ? 'presentation' : undefined
        },
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        "data-initial-width-mode": isContentMode ? 'content' : undefined,
        ref: innerRef,
        style: {
            marginTop: fixTableSSRResizing ? '0px' : ''
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9m4OW.Colgroup), {
        columnWidths: tableColumnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isInsideOfTable: isInsideOfTable,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("tbody", null, children));
});

});
parcelRegister("9m4OW", function(module, exports) {
$parcel$export(module.exports, "colWidthSum", () => $70ec231b289139f8$export$2d9bdaa5b8cd99f0);
$parcel$export(module.exports, "Colgroup", () => $70ec231b289139f8$export$89efc2d0ceeaa030);

var $4fqPo = parcelRequire("4fqPo");

var $3HHms = parcelRequire("3HHms");

var $ag3hq = parcelRequire("ag3hq");

var $faPFq = parcelRequire("faPFq");

var $28mV9 = parcelRequire("28mV9");

var $fBBEr = parcelRequire("fBBEr");

var $bUvFG = parcelRequire("bUvFG");

var $3H4LK = parcelRequire("3H4LK");

var $4mqcS = parcelRequire("4mqcS");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $70ec231b289139f8$var$MAX_SCALING_PERCENT = 0.3;
const $70ec231b289139f8$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $70ec231b289139f8$var$isTableColumnResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $70ec231b289139f8$var$fixColumnWidth = ({ columnWidth: columnWidth, zeroWidthColumnsCount: zeroWidthColumnsCount, scaleDownPercent: scaleDownPercent, skipMinWidth: skipMinWidth })=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) {
        const scaled = Math.floor((1 - scaleDownPercent) * columnWidth);
        return skipMinWidth ? scaled : Math.max(scaled, (0, $3HHms.tableCellMinWidth));
    }
    const adjusted = columnWidth - (0, $3HHms.tableCellBorderWidth);
    if (skipMinWidth) return adjusted;
    return Math.max(adjusted, zeroWidthColumnsCount ? (0, $faPFq.akEditorTableLegacyCellMinWidth) : (0, $3HHms.tableCellMinWidth));
};
const $70ec231b289139f8$var$calcScalePercent = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale, isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const noNumColumnScalePercent = renderWidth / tableWidth;
    // when numbered column is enabled, we need to calculate the scale percent without the akEditorTableNumberColumnWidth
    // As numbered column width is not scaled down
    const numColumnScalePercent = (renderWidth - (0, $faPFq.akEditorTableNumberColumnWidth)) / (tableWidth - (0, $faPFq.akEditorTableNumberColumnWidth));
    const diffPercent = 1 - noNumColumnScalePercent;
    return diffPercent < maxScale ? isNumberColumnEnabled ? 1 - numColumnScalePercent : diffPercent : maxScale;
};
const $70ec231b289139f8$export$2d9bdaa5b8cd99f0 = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
/**
 * Returns the data-column available width: total width minus the fixed number column if enabled.
 */ const $70ec231b289139f8$var$getDataColumnWidth = (totalWidth, isNumberColumnEnabled)=>isNumberColumnEnabled ? totalWidth - (0, $faPFq.akEditorTableNumberColumnWidth) : totalWidth;
/**
 * Scales column widths proportionally to fit within availableWidth, matching the editor's
 * scaleTableTo(): floors each column to the nearest pixel, then redistributes any rounding
 * remainder to the first column that can absorb it without going below tableCellMinWidth.
 */ const $70ec231b289139f8$var$scaleColumnsToWidth = (columnWidths, availableWidth)=>{
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    const scaleFactor = availableWidth / rawTotalWidth;
    const scaledWidths = columnWidths.map((colWidth)=>Math.max(Math.floor(colWidth * scaleFactor), (0, $3HHms.tableCellMinWidth)));
    const totalScaled = scaledWidths.reduce((sum, w)=>sum + w, 0);
    const diff = availableWidth - totalScaled;
    if (diff !== 0 && Math.abs(diff) < (0, $3HHms.tableCellMinWidth)) {
        for(let i = 0; i < scaledWidths.length; i++)if (scaledWidths[i] + diff > (0, $3HHms.tableCellMinWidth)) {
            scaledWidths[i] += diff;
            break;
        }
    }
    return scaledWidths.map((width)=>({
            width: `${width}px`
        }));
};
/**
 * Computes column widths for tables inside sync blocks, matching the editor's scaleTableTo() exactly.
 * Returns null if not inside a sync block.
 *
 * For nested tables (isInsideOfTable=true), we use getTableContainerWidth(tableNode) as the
 * reference — the width the editor saved, which already accounts for the parent cell's available
 * space (colwidth minus tableCellPadding * 2). This matches bodiedSyncBlock where isRendererNested=false,
 * so renderScaleDownColgroup uses getTableContainerWidth(tableNode). For syncBlock the nested
 * renderer has isRendererNested=true, which incorrectly overrides tableContainerWidth with renderWidth
 * (the full container), causing overflow by 2 * tableCellPadding (16px).
 */ const $70ec231b289139f8$var$renderSyncBlockColgroup = ({ isInsideOfSyncBlock: isInsideOfSyncBlock, isInsideOfTable: isInsideOfTable, tableNode: tableNode, columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidthProp, contextWidth: contextWidth })=>{
    if (!isInsideOfSyncBlock) return null;
    const rawTotalWidth = columnWidths.reduce((sum, w)=>sum + w, 0);
    if (isInsideOfTable) return null;
    // SSR / first client render before WidthObserver measures. Output % of original ADF
    // proportions so columns are stable — the CSS container query (100cqw) handles actual
    // scaling width. We key off renderWidthProp alone because WidthProvider initialises with
    // document.body.offsetWidth (non-zero on the client), so contextWidth > 0 even before
    // WidthObserver has measured the real container, which would skip this branch and produce
    // column widths scaled to the full viewport.
    if (renderWidthProp <= 0) {
        const fullTableWidth = isNumberColumnEnabled ? rawTotalWidth + (0, $faPFq.akEditorTableNumberColumnWidth) : rawTotalWidth;
        return columnWidths.map((colWidth)=>({
                width: `${colWidth / fullTableWidth * 100}%`
            }));
    }
    // contextWidth measures the sync block content area. Subtract 2 to match the editor's
    // getParentNodeWidth() border offset. Fall back to renderWidthProp for the non-CSS path.
    const effectiveRenderWidth = contextWidth > 0 ? contextWidth - 2 : renderWidthProp;
    const availableWidth = $70ec231b289139f8$var$getDataColumnWidth(effectiveRenderWidth, isNumberColumnEnabled);
    // Only scale down if the table is actually wider than the available space.
    // If the table fits, return original widths with the same tableCellBorderWidth (2px) adjustment
    // that renderScaleDownColgroup applies via fixColumnWidth's no-scale path.
    if (availableWidth >= rawTotalWidth) return columnWidths.map((colWidth)=>({
            width: `${Math.max(colWidth - (0, $3HHms.tableCellBorderWidth), (0, $3HHms.tableCellMinWidth))}px`
        }));
    // Cap scaling at MAX_SCALING_PERCENT (30%), matching renderScaleDownColgroup's calcScalePercent.
    //
    // Both `availableWidth` and `rawTotalWidth` are already in data-column space (number column
    // excluded via getDataColumnWidth), so `diffPercent = 1 - availableWidth / rawTotalWidth` is
    // equivalent to calcScalePercent's `numColumnScalePercent` path when isNumberColumnEnabled,
    // and to the `noNumColumnScalePercent` path otherwise. We express the cap as a target width
    // (clampedAvailableWidth) rather than a scale-down percentage, but the result is the same:
    // columns are scaled by at most MAX_SCALING_PERCENT (30%).
    const diffPercent = 1 - availableWidth / rawTotalWidth;
    const clampedAvailableWidth = diffPercent <= $70ec231b289139f8$var$MAX_SCALING_PERCENT ? availableWidth : Math.floor(rawTotalWidth * (1 - $70ec231b289139f8$var$MAX_SCALING_PERCENT));
    return $70ec231b289139f8$var$scaleColumnsToWidth(columnWidths, clampedAvailableWidth);
};
const $70ec231b289139f8$var$renderScaleDownColgroup = (props)=>{
    var _props$tableNode;
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, allowTableResizing: allowTableResizing, isTopLevelRenderer: isTopLevelRenderer, isInsideOfSyncBlock: isInsideOfSyncBlock } = props;
    const skipMinWidth = !!(isInsideOfTable && isInsideOfSyncBlock);
    if (!columnWidths || columnWidths.every((width)=>width === 0) && (0, $3H4LK.fg)('platform_editor_numbered_column_in_include')) return [];
    const tableColumnResized = $70ec231b289139f8$var$isTableColumnResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    // This is a fix for ED-23259
    // Some extensions (for ex: Page Properties or Excerpt) do not renderer tables directly inside themselves. They use ReactRenderer.
    // So if we add a check like isInsideExtension (similar to exising isInsideBlockNode), it will fail, and to the only way to learn
    // if the table is rendered inside another node, is to check if the Renderer itself is nested.
    const isRendererNested = isTopLevelRenderer === false;
    // appearance == comment && allowTableResizing && !tableNode?.attrs.width, means it is a comment
    // appearance == comment && !allowTableResizing && !tableNode?.attrs.width, means it is a inline comment
    // When comment and inline comment table width inherits from the parent container, we want tableContainerWidth === renderWidth
    // Tables with numbered columns inside of extensions cannot use the renderWidth when it is 0. In this case, it should
    // explicitly use the width coming from the table node as the final table container width.
    const tableContainerWidth = rendererAppearance === 'comment' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) || isRendererNested && (!(0, $3H4LK.fg)('platform_fix_nested_num_column_scaling') || !isNumberColumnEnabled) ? renderWidth : (0, $28mV9.getTableContainerWidth)(tableNode);
    if (allowTableResizing && !isInsideOfBlockNode && !isInsideOfTable && !isinsideMultiBodiedExtension && !tableColumnResized) {
        // when no columns are resized, each column should have equal width, equals to tableWidth / noOfColumns
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $faPFq.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableColumnResized) return null;
    const sumOfColumns = $70ec231b289139f8$export$2d9bdaa5b8cd99f0(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = isTableScalingEnabled && isNumberColumnEnabled && tableColumnResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const calculatedTableContainerWidth = rendererAppearance === 'comment' ? sumOfColumns : tableContainerWidth;
        const scalePercentage = +((calculatedTableContainerWidth - (0, $faPFq.akEditorTableNumberColumnWidth)) / calculatedTableContainerWidth);
        const targetMaxWidth = calculatedTableContainerWidth - (0, $faPFq.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (calculatedTableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $3HHms.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $3HHms.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $faPFq.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $faPFq.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && ((_props$tableNode = props.tableNode) === null || _props$tableNode === void 0 ? void 0 : _props$tableNode.attrs.displayMode) === 'fixed';
    const maxScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && rendererAppearance === 'comment' ? $70ec231b289139f8$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $70ec231b289139f8$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $faPFq.akEditorTableLegacyCellMinWidth) ? (0, $faPFq.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) {
        const shouldTable100ScaleDown = rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width);
        scaleDownPercent = $70ec231b289139f8$var$calcScalePercent({
            renderWidth: renderWidth,
            tableWidth: tableWidth,
            maxScale: (0, $3H4LK.fg)('platform-ssr-table-resize') ? maxScalingPercent : shouldTable100ScaleDown ? 1 : maxScalingPercent,
            isNumberColumnEnabled: isNumberColumnEnabled
        });
    }
    if (isNumberColumnEnabled && (tableWidth < maxTableWidth || maxTableWidth === 0)) {
        const fixedColWidths = targetWidths.map((width)=>$70ec231b289139f8$var$fixColumnWidth({
                columnWidth: width,
                zeroWidthColumnsCount: zeroWidthColumnsCount,
                scaleDownPercent: scaleDownPercent,
                skipMinWidth: skipMinWidth
            }) || cellMinWidth);
        const sumFixedColumnWidths = $70ec231b289139f8$export$2d9bdaa5b8cd99f0(fixedColWidths);
        return fixedColWidths.map((colWidth)=>{
            const width = Math.max(colWidth, cellMinWidth);
            if (colWidth > (0, $faPFq.akEditorTableCellMinWidth)) // To make sure the numbered column isn't scaled, use
            // percentages for the other columns.
            // Calculate the percentage based on the sum of the fixed column widths
            return {
                width: `${width / sumFixedColumnWidths * 100}%`
            };
            else {
                // If the column is equal to or less than the minimum cell width, we need to return a fixed pixel width.
                // This is to prevent columns being scaled below the minimum cell width.
                const style = width ? {
                    width: `${width}px`
                } : {};
                return style;
            }
        });
    }
    return targetWidths.map((colWidth)=>{
        const width = $70ec231b289139f8$var$fixColumnWidth({
            columnWidth: colWidth,
            zeroWidthColumnsCount: zeroWidthColumnsCount,
            scaleDownPercent: scaleDownPercent,
            skipMinWidth: skipMinWidth
        }) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $70ec231b289139f8$export$89efc2d0ceeaa030 = (props)=>{
    const { isTopLevelRenderer: isTopLevelRenderer, nestedRendererType: nestedRendererType } = (0, $bUvFG.useRendererContext)();
    const { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const { width: contextWidth } = (0, $4fqPo.useContext)((0, $ag3hq.WidthContext));
    const flags = (0, $fBBEr.useFeatureFlags)();
    if (!columnWidths) return null;
    const isTableFixedColumnWidthsOptionEnabled = ((0, $3H4LK.fg)('platform_editor_table_fixed_column_width_prop') ? props.allowFixedColumnWidthOption : flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption) ?? false;
    // For referenced sync blocks, nestedRendererType='syncedBlock' is set via RendererContextProvider
    // in AKRendererWrapper. ReactSerializer is a class and cannot read React context, so we detect
    // it here in the Colgroup component via useRendererContext() instead of prop-drilling.
    const isInsideOfSyncBlock = nestedRendererType === 'syncedBlock';
    // renderSyncBlockColgroup returns null when not applicable (flag off, SSR, not a sync block),
    // in which case ?? falls back to the standard renderScaleDownColgroup path.
    const colStyles = $70ec231b289139f8$var$renderSyncBlockColgroup({
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isInsideOfTable: !!props.isInsideOfTable,
        tableNode: props.tableNode,
        columnWidths: columnWidths,
        isNumberColumnEnabled: !!isNumberColumnEnabled,
        renderWidth: props.renderWidth,
        contextWidth: contextWidth
    }) ?? $70ec231b289139f8$var$renderScaleDownColgroup({
        ...props,
        isTopLevelRenderer: isTopLevelRenderer,
        isInsideOfSyncBlock: isInsideOfSyncBlock,
        isTableScalingEnabled: props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || props.rendererAppearance === 'comment',
        isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled && (props.rendererAppearance === 'full-page' || props.rendererAppearance === 'full-width' || props.rendererAppearance === 'max' && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)))
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $faPFq.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("col", {
            key: idx,
            style: style
        })));
};

});
parcelRegister("fBBEr", function(module, exports) {
$parcel$export(module.exports, "useFeatureFlags", () => $e2e94e436fa7ca45$export$90335b3ff08f335);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $bUvFG = parcelRequire("bUvFG");
const $e2e94e436fa7ca45$export$90335b3ff08f335 = ()=>{
    var _useRendererContext;
    return (_useRendererContext = (0, $bUvFG.useRendererContext)()) === null || _useRendererContext === void 0 ? void 0 : _useRendererContext.featureFlags;
};

});
parcelRegister("bUvFG", function(module, exports) {
$parcel$export(module.exports, "useRendererContext", () => $2a98443aae8da904$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $2a98443aae8da904$export$ca5df47902194781);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $4fqPo = parcelRequire("4fqPo");
const $2a98443aae8da904$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext({});
const $2a98443aae8da904$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useContext($2a98443aae8da904$var$RendererContext);
const $2a98443aae8da904$export$ca5df47902194781 = $2a98443aae8da904$var$RendererContext.Provider;

});



parcelRegister("ldXaf", function(module, exports) {
$parcel$export(module.exports, "hasTableBeenResized", () => $0cdbf2e5a188cc1a$export$8c07f44cea64e3c7);
$parcel$export(module.exports, "isTableInContentMode", () => $0cdbf2e5a188cc1a$export$90b9840b2d94b80a);

var $4ubSX = parcelRequire("4ubSX");

var $4uWnq = parcelRequire("4uWnq");
const $0cdbf2e5a188cc1a$export$8c07f44cea64e3c7 = (tableNode)=>tableNode.attrs.width !== null || (0, $4uWnq.hasTableColumnBeenResized)(tableNode);
const $0cdbf2e5a188cc1a$export$90b9840b2d94b80a = ({ tableNode: tableNode, isSupported: isSupported, isTableNested: isTableNested })=>{
    if (!(0, $4ubSX.expValEqualsNoExposure)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) return false;
    if (!tableNode || isTableNested) return false;
    return isSupported && !$0cdbf2e5a188cc1a$export$8c07f44cea64e3c7(tableNode) && tableNode.attrs.layout === 'align-start';
};

});
parcelRegister("4uWnq", function(module, exports) {
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $83e08fe049940619$export$b44a013e4f554514);
const $83e08fe049940619$export$b44a013e4f554514 = (tableNode)=>{
    const firstRow = tableNode.content.firstChild;
    if (!firstRow) return false;
    for(let i = 0; i < firstRow.childCount; i++){
        if (firstRow.child(i).attrs.colwidth) return true;
    }
    return false;
};

});


parcelRegister("fBO6K", function(module, exports) {
$parcel$export(module.exports, "isContentModeSupported", () => $cbd7f39e68caf050$export$e217d2a535d6ae45);
const $cbd7f39e68caf050$export$e217d2a535d6ae45 = ({ allowTableResizing: allowTableResizing, rendererAppearance: rendererAppearance })=>{
    return !!allowTableResizing && (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max');
};

});


parcelRegister("lNiZQ", function(module, exports) {
$parcel$export(module.exports, "recursivelyInjectProps", () => $eb1f7e71b9b0a4d7$export$40e12ce8e0a76b0c);

var $4fqPo = parcelRequire("4fqPo");
function $eb1f7e71b9b0a4d7$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, {
            children: $eb1f7e71b9b0a4d7$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("5ZBYr", function(module, exports) {
$parcel$export(module.exports, "isFullWidthAppearance", () => $d13a2494ca41e0f5$export$c0112b8340d4924b);
$parcel$export(module.exports, "isMaxWidthAppearance", () => $d13a2494ca41e0f5$export$ab050440a1241762);
$parcel$export(module.exports, "isFullPageAppearance", () => $d13a2494ca41e0f5$export$a64737a81cde10b4);
$parcel$export(module.exports, "isCommentAppearance", () => $d13a2494ca41e0f5$export$f77d2ff45b2c53ed);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $d13a2494ca41e0f5$export$33331a99fac775a1);
const $d13a2494ca41e0f5$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $d13a2494ca41e0f5$export$ab050440a1241762 = (appearance)=>appearance === 'max';
const $d13a2494ca41e0f5$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $d13a2494ca41e0f5$export$f77d2ff45b2c53ed = (appearance)=>appearance === 'comment';
const $d13a2494ca41e0f5$export$33331a99fac775a1 = (appearance)=>$d13a2494ca41e0f5$export$a64737a81cde10b4(appearance) || $d13a2494ca41e0f5$export$c0112b8340d4924b(appearance) || $d13a2494ca41e0f5$export$ab050440a1241762(appearance);

});

parcelRegister("e2SI5", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $1331849abe9ca431$export$8c072780619cfc83);

var $7akLL = parcelRequire("7akLL");

var $3H4LK = parcelRequire("3H4LK");
class $1331849abe9ca431$export$8c072780619cfc83 {
    constructor(wrapper){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.init();
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        var _this$wrapper$parentE, _this$wrapper$parentE2;
        if (!this.wrapper) return;
        const scrollbarContainers = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelectorAll(`.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @atlaskit/platform/valid-gate-name
        this.stickyScrollbarContainerElement = (0, $3H4LK.fg)('platform_editor_querySelector_fix_table_renderer') ? scrollbarContainers === null || scrollbarContainers === void 0 ? void 0 : scrollbarContainers.item(scrollbarContainers.length - 1) : (_this$wrapper$parentE2 = this.wrapper.parentElement) === null || _this$wrapper$parentE2 === void 0 ? void 0 : _this$wrapper$parentE2.querySelector(`.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        var _this$wrapper, _this$wrapper2, _this$wrapper3;
        this.rendererScrollableElement = window.document;
        if (!this.rendererScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                if (target.classList.contains((0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.rendererScrollableElement
        });
        const bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/platform/valid-gate-name
        this.sentinels.bottom = (0, $3H4LK.fg)('platform_editor_querySelector_fix_table_renderer') ? // eslint-disable-next-line @atlaskit/editor/no-as-casting
        bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1) : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = (_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.parentElement) === null || _this$wrapper3 === void 0 || (_this$wrapper3 = _this$wrapper3.getElementsByClassName((0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.intersectionObserver.observe(el));
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        var _entry$rootBounds;
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) || 0);
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        var _entry$rootBounds2;
        const sentinelIsBelowScrollArea = (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.bottom) || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'hidden') this.stickyScrollbarContainerElement.style.visibility = 'hidden';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.visibility !== 'visible') this.stickyScrollbarContainerElement.style.visibility = 'visible';
    }
}

});

parcelRegister("kgAJc", function(module, exports) {
$parcel$export(module.exports, "RefSyncBlockFakeBorders", () => $c6c6980b8243009d$export$c8a6e9aeff774364);
$parcel$export(module.exports, "TableProcessorWithContainerStyles", () => $c6c6980b8243009d$export$827f89182557f335);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/enforce-style-prop, @repo/internal/react/no-class-components */ 
var $4fqPo = parcelRequire("4fqPo");

var $3HHms = parcelRequire("3HHms");
var $7akLL = parcelRequire("7akLL");

var $28mV9 = parcelRequire("28mV9");

var $3Aw44 = parcelRequire("3Aw44");

var $3H4LK = parcelRequire("3H4LK");

var $jANeU = parcelRequire("jANeU");

var $7qM0R = parcelRequire("7qM0R");
var $kOyOM = parcelRequire("kOyOM");
var $3WKW8 = parcelRequire("3WKW8");
var $1VYpW = parcelRequire("1VYpW");

var $4jnEE = parcelRequire("4jnEE");

var $faPFq = parcelRequire("faPFq");

var $hdn08 = parcelRequire("hdn08");

var $3dShV = parcelRequire("3dShV");

var $wlKwA = parcelRequire("wlKwA");

var $8odkJ = parcelRequire("8odkJ");

var $5ZBYr = parcelRequire("5ZBYr");

var $e2SI5 = parcelRequire("e2SI5");

var $bUvFG = parcelRequire("bUvFG");

var $4mqcS = parcelRequire("4mqcS");

var $ldXaf = parcelRequire("ldXaf");

var $fBO6K = parcelRequire("fBO6K");
const $c6c6980b8243009d$var$stickyContainerBaseStyles = {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    height: "var(--ds-space-250, 20px)",
    // MAX_BROWSER_SCROLLBAR_HEIGHT
    // Follow editor to hide by default so it does not show empty gap in SSR
    // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/master/platform/packages/editor/editor-plugin-table/src/nodeviews/TableComponent.tsx#957
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    display: 'block',
    width: '100%'
};
const $c6c6980b8243009d$var$stickyContainerAdditionalStyles = {
    visibility: 'hidden',
    overflowX: 'auto',
    position: 'sticky',
    bottom: "var(--ds-space-0, 0px)",
    zIndex: 1
};
const $c6c6980b8243009d$export$eec82c0a93aa66d9 = (appearance)=>(0, $5ZBYr.isFullWidthOrFullPageAppearance)(appearance) || (0, $5ZBYr.isCommentAppearance)(appearance);
const $c6c6980b8243009d$export$bdb2dadcb04aad50 = (appearance)=>(0, $5ZBYr.isFullWidthOrFullPageAppearance)(appearance) && (0, $hdn08.editorExperiment)('platform_renderer_table_sticky_scrollbar', true, {
        exposure: true
    });
const $c6c6980b8243009d$export$334894231c46c1a5 = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $4jnEE.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $3WKW8.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $kOyOM.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $c6c6980b8243009d$export$42f5658c8e0092da = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $c6c6980b8243009d$export$f422245984b0eda7 = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $c6c6980b8243009d$export$7c141112f3c89f11 = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $c6c6980b8243009d$export$89f3188e1adc30d5 = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $c6c6980b8243009d$export$100baa0f10804e6e = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $c6c6980b8243009d$export$28daf78feed5098c = (rows)=>{
    if (!rows.length) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $3dShV.TableHeader);
    return children.every((node)=>node.type === (0, $3dShV.TableHeader));
};
const $c6c6980b8243009d$export$940095e914312886 = (node, children)=>{
    return $c6c6980b8243009d$export$28daf78feed5098c(children) && node && node.firstChild && !$c6c6980b8243009d$export$42f5658c8e0092da(node.firstChild);
};
/**
 * Fake left/right borders rendered as direct children of TABLE_CONTAINER
 * (the non-scrolling parent of the horizontally scrolling TABLE_NODE_WRAPPER).
 *
 * The visible styling for these divs lives in `tableFakeBorderStyles`
 * (`renderer/src/ui/Renderer/RendererStyleContainer.tsx`), which is itself
 * gated on `editorExperiment('platform_synced_block', true)` AND
 * `isInsideSyncBlock`.
 *
 * Shared between `renderer/src/react/nodes/table.tsx` and
 * `renderer/src/react/nodes/tableNew.tsx` so the two stay in sync.
 */ const $c6c6980b8243009d$var$TableFakeBorders = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-left-border"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER,
        "data-with-numbered-table": isNumberColumnEnabled ? 'true' : undefined,
        "data-testid": "table-right-border"
    }));
const $c6c6980b8243009d$export$c8a6e9aeff774364 = ({ isNumberColumnEnabled: isNumberColumnEnabled })=>{
    const { nestedRendererType: nestedRendererType } = (0, $bUvFG.useRendererContext)();
    const isInsideOfRefSyncBlock = nestedRendererType === 'syncedBlock';
    if (!isInsideOfRefSyncBlock || !(0, $hdn08.editorExperiment)('platform_synced_block', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($c6c6980b8243009d$var$TableFakeBorders, {
        isNumberColumnEnabled: isNumberColumnEnabled
    });
};
class $c6c6980b8243009d$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    /**
   * Checks if this table is inside a nested renderer (e.g. Include Page macro)
   * by looking for multiple .ak-renderer-document ancestors in the DOM.
   * The result is cached since a table's position in the DOM tree is stable after mount.
   */ isInsideNestedRenderer() {
        if (this._isInsideNestedRenderer !== null) return this._isInsideNestedRenderer;
        if (!this.containerRef) return false;
        let docAncestorCount = 0;
        let el = this.containerRef.parentElement;
        while(el){
            if (el.classList.contains((0, $jANeU.RendererCssClassName).DOCUMENT)) {
                docAncestorCount++;
                if (docAncestorCount >= 2) {
                    this._isInsideNestedRenderer = true;
                    return true;
                }
            }
            el = el.parentElement;
        }
        this._isInsideNestedRenderer = false;
        return false;
    }
    /**
   * Checks if this table is inside a table cell in the DOM. The result is cached
   * since a table's position in the DOM tree is stable after mount.
   */ isInsideTableCell() {
        if (this._isInsideTableCell !== null) return this._isInsideTableCell;
        if (!this.containerRef) return false;
        this._isInsideTableCell = Boolean(this.containerRef.closest('td, th'));
        return this._isInsideTableCell;
    }
    isInsideTableContext() {
        return Boolean(this.props.isInsideOfTable || this.isInsideTableCell());
    }
    /**
   * For tables inside nested renderers (e.g. Include Page macro), the parent
   * renderer's CSS override forces width:100%!important and left:0!important
   * which overrides the inline styles set by this component. Using
   * style.setProperty with 'important' priority on inline styles beats
   * stylesheet !important rules per the CSS cascade.
   *
   * Tables that are nested inside another table need to remain constrained by
   * their table-cell context. Do not promote their width to inline !important,
   * otherwise nested tables rendered through macros such as Excerpt Include can
   * overflow and overlap adjacent cells.
   *
   * Top-level tables in nested renderers still preserve their saved width, but
   * are capped to their containing block so wide tables do not escape constrained
   * macro bodies such as Excerpt Include panels.
   *
   * Uses lastComputedStyle (populated during render) rather than reading from
   * element.style, because React may remove properties from the DOM when their
   * values transition to undefined between renders.
   */ applyNestedRendererTableFix() {
        if (!this.containerRef || !(0, $3H4LK.fg)('platform_nested_table_style_override')) return;
        if (!this.isInsideNestedRenderer() || this.isInsideTableContext()) return;
        const { width: width, left: left, marginLeft: marginLeft } = this.lastComputedStyle;
        const style = this.containerRef.style;
        style.setProperty('width', width || 'auto', 'important');
        style.setProperty('max-width', '100%', 'important');
        style.setProperty('left', left || 'auto', 'important');
        style.setProperty('margin-left', marginLeft || '0', 'important');
    }
    /**
   * Starts observing table dimensions and wires sticky header/scrollbar behavior after mount.
   *
   * @example
   */ componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            var _this$props$stickyHea;
            this.overflowParent = (0, $wlKwA.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea = this.props.stickyHeaders) === null || _this$props$stickyHea === void 0 ? void 0 : _this$props$stickyHea.defaultScrollRootId_DO_NOT_USE);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
        if (this.wrapperRef.current && $c6c6980b8243009d$export$bdb2dadcb04aad50(this.props.rendererAppearance)) this.stickyScrollbar = new (0, $e2SI5.TableStickyScrollbar)(this.wrapperRef.current);
        this.applyNestedRendererTableFix();
    }
    /**
   * Updates sticky header wiring and scroll synchronization after prop or state changes.
   *
   * @param prevProps
   * @param prevState
   * @example
   */ componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) {
            var _this$props$stickyHea2;
            this.overflowParent = (0, $wlKwA.OverflowParent).fromElement(this.tableRef.current, (_this$props$stickyHea2 = this.props.stickyHeaders) === null || _this$props$stickyHea2 === void 0 ? void 0 : _this$props$stickyHea2.defaultScrollRootId_DO_NOT_USE);
        } else if (!this.props.stickyHeaders && this.overflowParent) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
        // React re-applies the style prop on every render, which overwrites the
        // !important priorities set at mount time. Re-apply after each update.
        this.applyNestedRendererTableFix();
    }
    /**
   * Calculates the top offset used when the sticky header is pinned to the table bottom.
   */ get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $3HHms.tableMarginTop) - (0, $wlKwA.tableStickyPadding);
    }
    /**
   * Determines whether sticky header positioning should include the default scroll root offset.
   */ get shouldAddOverflowParentOffsetTop_DO_NOT_USE() {
        // IF the StickyHeaderConfig specifies that the default scroll root offsetTop should be added
        // AND the StickyHeaderConfig specifies a default scroll root id
        // AND the OverflowParent is the corresponding element
        // THEN we should add the OverflowParent offset top (RETURN TRUE)
        return this.props.stickyHeaders && !!this.props.stickyHeaders.shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE && !!this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE && this.overflowParent && this.overflowParent.id === this.props.stickyHeaders.defaultScrollRootId_DO_NOT_USE;
    }
    /**
   * Resolves the top position for the sticky header based on the current sticky mode.
   */ get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                const offsetTop = this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
                if (typeof offsetTop === 'number' && this.shouldAddOverflowParentOffsetTop_DO_NOT_USE) {
                    const overflowParentOffsetTop = this.overflowParent ? this.overflowParent.top : 0;
                    return offsetTop + overflowParentOffsetTop;
                } else return offsetTop;
            default:
                return undefined;
        }
    }
    /**
   * Renders the table container, sticky header, table content, sticky scrollbar, and synced block borders.
   *
   * @example
   */ render() {
        var _this$tableRef$curren;
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, isPresentational: isPresentational, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $faPFq.akEditorDefaultLayoutWidth);
        let updatedLayout;
        const fullPageRendererWidthCSS = (0, $hdn08.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? 'calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)' : `100cqw - ${0, $3Aw44.FullPagePadding}px * 2`;
        const renderWidthCSS = rendererAppearance === 'full-page' ? fullPageRendererWidthCSS : `100cqw`;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'max' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) return `min(${0, $faPFq.akEditorMaxWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'full-width' && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return `min(${0, $faPFq.akEditorFullWidthLayoutWidth}px, ${renderWidthCSS})`;
            else if (rendererAppearance === 'comment' && allowTableResizing && !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width)) return renderWidthCSS;
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $28mV9.getTableContainerWidth)(tableNode);
                return `min(${tableContainerWidth}px, ${renderWidthCSS})`;
            }
        };
        const tableWidthCSS = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start' && allowTableAlignment;
        const fullWidthLineLengthCSS = `min(${(0, $faPFq.akEditorFullWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const maxWidthLineLengthCSS = `min(${(0, $faPFq.akEditorMaxWidthLayoutWidth)}px, ${renderWidthCSS})`;
        const isCommentAppearanceAndTableAlignmentEnabled = (0, $5ZBYr.isCommentAppearance)(rendererAppearance) && allowTableAlignment;
        const lineLengthCSS = (0, $5ZBYr.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLengthCSS : (0, $5ZBYr.isMaxWidthAppearance)(rendererAppearance) && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) ? maxWidthLineLengthCSS : isCommentAppearanceAndTableAlignmentEnabled ? renderWidthCSS : `${lineLengthFixedWidth}px`;
        const tableWidthNew = (0, $28mV9.getTableContainerWidth)(tableNode);
        const shouldCalculateLeftForAlignment = !isInsideOfBlockNode && !isInsideOfTable && isTableAlignStart && ((0, $5ZBYr.isFullPageAppearance)(rendererAppearance) && tableWidthNew <= lineLengthFixedWidth || (0, $5ZBYr.isFullWidthAppearance)(rendererAppearance) || (0, $5ZBYr.isMaxWidthAppearance)(rendererAppearance) && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) || isCommentAppearanceAndTableAlignmentEnabled);
        let leftCSS;
        if (shouldCalculateLeftForAlignment) leftCSS = `(${tableWidthCSS} - ${lineLengthCSS}) / 2`;
        if (!shouldCalculateLeftForAlignment && (0, $5ZBYr.isFullPageAppearance)(rendererAppearance)) // Note tableWidthCSS here is the renderer width
        // When the screen is super wide we want table to break out.
        // However if screen is smaller than 760px. We want table align to left.
        leftCSS = `min(0px, ${lineLengthCSS} - ${tableWidthCSS}) / 2`;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !(tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode !== null && tableNode !== void 0 && tableNode.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        let finalTableContainerWidth = allowTableResizing ? tableWidthNew : 'inherit';
        // We can only use CSS to determine the width when we have a known width in container.
        // When appearance is full-page, full-width or comment we use CSS based width calculation.
        // Otherwise it's fixed table width (customized width) or inherit.
        if (rendererAppearance === 'full-page' || rendererAppearance === 'full-width' || rendererAppearance === 'max' && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) finalTableContainerWidth = allowTableResizing ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && !allowTableAlignment) // If table alignment is disabled and table width is akEditorDefaultLayoutWidth = 760,
        // it is most likely a table created before "Support Table in Comments" FF was enabled
        // and we would see a bug ED-24795. A table created before "Support Table in Comments",
        // should inhirit the width of the renderer container.
        // !NOTE: it a table resized to 760 is copied from 'full-page' editor and pasted in comment editor
        // where (allowTableResizing && !allowTableAlignment), the table will loose 760px width.
        finalTableContainerWidth = tableNode !== null && tableNode !== void 0 && tableNode.attrs.width && (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width) !== (0, $faPFq.akEditorDefaultLayoutWidth) ? `calc(${tableWidthCSS})` : 'inherit';
        if (rendererAppearance === 'comment' && allowTableResizing && allowTableAlignment) // If table alignment is enabled and layout is not 'align-start' or 'center', we are loading a table that was
        // created before "Support Table in Comments" FF was enabled. So the table should have the same width as renderer container
        // instead of 760 that was set on tableNode when the table had been published.
        finalTableContainerWidth = ((tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'align-start' || (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout) === 'center') && tableNode !== null && tableNode !== void 0 && tableNode.attrs.width ? `calc(${tableWidthCSS})` : 'inherit';
        const isContentModeTable = (0, $ldXaf.isTableInContentMode)({
            tableNode: tableNode,
            isSupported: (0, $fBO6K.isContentModeSupported)({
                allowTableResizing: allowTableResizing,
                rendererAppearance: rendererAppearance
            }),
            isTableNested: isInsideOfBlockNode || isInsideOfTable
        }) && (0, $4mqcS.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
        const style = {
            ...isContentModeTable && {
                '--renderer-table-max-width': renderWidthCSS
            },
            width: finalTableContainerWidth,
            left: leftCSS ? `calc(${leftCSS})` : undefined,
            marginLeft: shouldCalculateLeftForAlignment && leftCSS !== undefined ? `calc(-1 * (${leftCSS}))` : undefined
        };
        // Store computed style values for applyNestedRendererTableFix() to use.
        // Reading from props rather than the DOM ensures correctness when React
        // removes properties (transitions from set to undefined) between renders.
        this.lastComputedStyle = {
            width: typeof style.width === 'number' ? `${style.width}px` : style.width,
            left: style.left,
            marginLeft: style.marginLeft
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            "data-testid": "table-container",
            ref: this.setContainerRef,
            style: style
        }, $c6c6980b8243009d$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
            "data-testid": "sticky-scrollbar-sentinel-top"
        }), stickyHeaders && tableNode && !isContentModeTable && $c6c6980b8243009d$export$940095e914312886(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $wlKwA.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: "inherit",
            renderWidth: 0,
            layout: layout,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            allowTableResizing: allowTableResizing,
            fixTableSSRResizing: true,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            "data-number-column": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.isNumberColumnEnabled,
            "data-layout": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.layout,
            "data-autosize": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.__autoSize,
            "data-table-local-id": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId,
            "data-table-width": tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.width,
            "data-vc": "table-node-wrapper",
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8odkJ.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            renderWidth: 0,
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            allowTableResizing: allowTableResizing,
            isPresentational: isPresentational,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption
        }, this.grabFirstRowRef(children))), $c6c6980b8243009d$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}${(0, $3H4LK.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '-view-page' : ''}`,
            ref: this.stickyScrollbarRef,
            "data-vc": "table-sticky-scrollbar-container",
            style: (0, $3H4LK.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? {
                ...$c6c6980b8243009d$var$stickyContainerBaseStyles,
                ...$c6c6980b8243009d$var$stickyContainerAdditionalStyles
            } : $c6c6980b8243009d$var$stickyContainerBaseStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            style: {
                width: (0, $3H4LK.fg)('confluence_frontend_table_scrollbar_ttvc_fix') ? '100%' : (_this$tableRef$curren = this.tableRef.current) === null || _this$tableRef$curren === void 0 ? void 0 : _this$tableRef$curren.clientWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%'
            }
        })), $c6c6980b8243009d$export$bdb2dadcb04aad50(this.props.rendererAppearance) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
            "data-testid": "sticky-scrollbar-sentinel-bottom"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($c6c6980b8243009d$export$c8a6e9aeff774364, {
            isNumberColumnEnabled: isNumberColumnEnabled
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        }, this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.stickyScrollbarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.overflowParent = null, this.updatedLayout = 'custom', this.containerRef = null, this._isInsideNestedRenderer = null, this._isInsideTableCell = null, // Stores the last computed style values from render() for use by applyNestedRendererTableFix().
        // This avoids reading from the DOM which can be stale when React removes properties between renders.
        this.lastComputedStyle = {}, this.resizeObserver = null, this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        }, /**
   * Callback ref that captures the container DOM element and also forwards
   * to the handleRef prop from the overflow shadow HOC.
   */ this.setContainerRef = (el)=>{
            if (this.containerRef !== el) {
                this._isInsideNestedRenderer = null;
                this._isInsideTableCell = null;
            }
            this.containerRef = el;
            const { handleRef: handleRef } = this.props;
            if (typeof handleRef === 'function') handleRef(el);
            else if (handleRef && typeof handleRef === 'object') // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            handleRef.current = el;
        }, this.componentWillUnmount = ()=>{
            if (this.overflowParent) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
            if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        }, this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        }, this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $wlKwA.tableStickyPadding);
            const tableTop = $c6c6980b8243009d$export$f422245984b0eda7(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $c6c6980b8243009d$export$7c141112f3c89f11(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $c6c6980b8243009d$export$89f3188e1adc30d5(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        }, this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        }, this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
            if (this.stickyScrollbarRef.current) this.stickyScrollbarRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        }, this.grabFirstRowRef = (children)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
const $c6c6980b8243009d$var$getCellEdgePropsByCellOffset = (tableNode, isNumberColumnEnabled)=>{
    const cellEdgePropsByCellOffset = new Map();
    const cellRightByCellOffset = new Map();
    const occupiedGrid = [];
    let tableWidth = 0;
    let cellOffset = 0;
    tableNode.forEach((rowNode, _rowOffset, rowIndex)=>{
        occupiedGrid[rowIndex] = occupiedGrid[rowIndex] ?? [];
        let columnIndex = 0;
        cellOffset += 1;
        rowNode.forEach((cellNode)=>{
            while(occupiedGrid[rowIndex][columnIndex])columnIndex += 1;
            const colspan = cellNode.attrs.colspan || 1;
            const rowspan = cellNode.attrs.rowspan || 1;
            const cellLeft = columnIndex;
            const cellRight = cellLeft + colspan;
            const cellTop = rowIndex;
            const cellBottom = cellTop + rowspan;
            for(let row = cellTop; row < cellBottom; row += 1){
                occupiedGrid[row] = occupiedGrid[row] ?? [];
                for(let column = cellLeft; column < cellRight; column += 1)occupiedGrid[row][column] = true;
            }
            tableWidth = Math.max(tableWidth, cellRight);
            cellRightByCellOffset.set(cellOffset, cellRight);
            cellEdgePropsByCellOffset.set(cellOffset, {
                reachesBottom: cellBottom >= tableNode.childCount,
                // With number column enabled, PM column 0 is not visually leftmost and must not get `data-reaches-left`.
                reachesLeft: cellLeft === 0 && !isNumberColumnEnabled,
                reachesRight: false,
                reachesTop: cellTop === 0
            });
            columnIndex = cellRight;
            cellOffset += cellNode.nodeSize;
        });
        cellOffset += 1;
    });
    cellRightByCellOffset.forEach((cellRight, currentCellOffset)=>{
        const edgeProps = cellEdgePropsByCellOffset.get(currentCellOffset);
        if (edgeProps) edgeProps.reachesRight = cellRight >= tableWidth;
    });
    return cellEdgePropsByCellOffset;
};
const $c6c6980b8243009d$var$addTableCellEdgeProps = (rows, tableNode, isNumberColumnEnabled)=>{
    try {
        if (!tableNode) return rows;
        const cellEdgePropsByCellOffset = $c6c6980b8243009d$var$getCellEdgePropsByCellOffset(tableNode, isNumberColumnEnabled);
        let cellOffset = 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(rows, (row, rowIndex)=>{
            const rowNode = tableNode.child(rowIndex);
            cellOffset += 1;
            let cellIndex = 0;
            const rowChildren = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(row.props.children, (child)=>{
                if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child)) return child;
                const cellNode = rowNode.child(cellIndex);
                const edgeProps = cellEdgePropsByCellOffset.get(cellOffset);
                cellIndex += 1;
                cellOffset += cellNode.nodeSize;
                return edgeProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, edgeProps) : child;
            });
            cellOffset += 1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(row, undefined, rowChildren);
        });
    } catch  {
        // Renderer can receive malformed historical ADF. If the table shape cannot
        // be described safely, keep rendering without rounded edge metadata.
        return rows;
    }
};
class $c6c6980b8243009d$export$827f89182557f335 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    /**
   * Renders processed table children inside the table container.
   *
   * @example
   */ render() {
        const { allowColumnSorting: allowColumnSorting, allowFixedColumnWidthOption: allowFixedColumnWidthOption, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, children: children, columnWidths: columnWidths, disableTableOverflowShadow: disableTableOverflowShadow, handleRef: handleRef, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isInsideOfBlockNode: isInsideOfBlockNode, isInsideOfTable: isInsideOfTable, isNumberColumnEnabled: isNumberColumnEnabled, isPresentational: isPresentational, layout: layout, rendererAppearance: rendererAppearance, renderWidth: renderWidth, shadowClassNames: shadowClassNames, smartCardStorage: smartCardStorage, stickyHeaders: stickyHeaders, tabIndex: tabIndex, tableNode: tableNode } = this.props;
        if (!children) return null;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children);
        const childrenWithTableEdgeProps = (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $c6c6980b8243009d$var$addTableCellEdgeProps(childrenArray, tableNode, isNumberColumnEnabled) : childrenArray;
        const orderedChildren = (0, $7qM0R.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenWithTableEdgeProps);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($c6c6980b8243009d$export$f2c3aea42b2a048f, {
            allowColumnSorting: allowColumnSorting,
            allowFixedColumnWidthOption: allowFixedColumnWidthOption,
            allowTableAlignment: allowTableAlignment,
            allowTableResizing: allowTableResizing,
            columnWidths: columnWidths,
            disableTableOverflowShadow: disableTableOverflowShadow,
            handleRef: handleRef,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideOfTable: isInsideOfTable,
            isNumberColumnEnabled: isNumberColumnEnabled,
            isPresentational: isPresentational,
            layout: layout,
            rendererAppearance: rendererAppearance,
            renderWidth: renderWidth,
            shadowClassNames: shadowClassNames,
            smartCardStorage: smartCardStorage,
            stickyHeaders: stickyHeaders,
            tabIndex: tabIndex,
            tableNode: tableNode
        }, orderedChildren);
    }
    constructor(...args){
        super(...args), this.state = {
            tableOrderStatus: undefined
        }, // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $c6c6980b8243009d$export$28daf78feed5098c(childrenArray) && tableNode && !(0, $1VYpW.hasMergedCell)(tableNode)) return $c6c6980b8243009d$export$100baa0f10804e6e($c6c6980b8243009d$export$334894231c46c1a5(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        }, this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $c6c6980b8243009d$export$28daf78feed5098c(rows);
            const lastRowIndex = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.count(rows) - 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1,
                    isFirstRow: index === 0,
                    isLastRow: index === lastRowIndex
                });
            });
        };
    }
}

});


parcelRegister("doc9I", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd44074fe6f0f3e8$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $7qM0R = parcelRequire("7qM0R");

var $4jnEE = parcelRequire("4jnEE");

var $jANeU = parcelRequire("jANeU");
class $dd44074fe6f0f3e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { children: children, innerRef: innerRef, isFirstRow: isFirstRow, isLastRow: isLastRow } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("td", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $jANeU.RendererCssClassName).NUMBER_COLUMN,
            "data-reaches-left": true,
            "data-reaches-top": isFirstRow || undefined,
            "data-reaches-bottom": isLastRow || undefined
        }, this.props.index), (0, $7qM0R.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args), this.state = {
            colGroupWidths: []
        }, this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            const isHeaderRow = !rowIndex;
            if (allowColumnSorting && isHeaderRow) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child)) {
                    const { tableOrderStatus: tableOrderStatus } = this.props;
                    let sortOrdered = (0, $4jnEE.SortOrder).NO_ORDER;
                    if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $4jnEE.SortOrder).NO_ORDER;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, {
                        columnIndex: index,
                        onSorting: this.props.onSorting,
                        sortOrdered: sortOrdered,
                        isHeaderRow: isHeaderRow
                    });
                }
            });
            return childrenArray;
        }, this.addColGroupWidth = (childrenArray)=>{
            var _this$state$colGroupW;
            if ((_this$state$colGroupW = this.state.colGroupWidths) !== null && _this$state$colGroupW !== void 0 && _this$state$colGroupW.length) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("1a8Fk", function(module, exports) {
$parcel$export(module.exports, "default", () => $33461ece96902768$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $33461ece96902768$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("jXhCg", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("c0hLJ"),
    $e46AW("aqGGv"),
    $e46AW("b0zf2"),
    $e46AW("7b5VU")
]).then(()=>parcelRequire('1tCBN'));

});

parcelRegister("3Ew8z", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("eP28U"),
    $e46AW("c0hLJ"),
    $e46AW("aqGGv"),
    $e46AW("b0zf2"),
    $e46AW("78Rpa")
]).then(()=>parcelRequire('hPSj0'));

});

parcelRegister("aGKTb", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("6nB5Y").then(()=>parcelRequire('crc6N'));

});

parcelRegister("ScMt4", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("bvOcx"),
    $e46AW("k4pzI")
]).then(()=>parcelRequire('9rW2I'));

});

parcelRegister("k7gnN", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("iyVke").then(()=>parcelRequire('3POi2'));

});

parcelRegister("kOA8Q", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("joOrj"),
    $e46AW("1pJMB")
]).then(()=>parcelRequire('a6Sd4'));

});

parcelRegister("gorzw", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gLfmG").then(()=>parcelRequire('lAgmh'));

});

parcelRegister("3xDjI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("32KtW").then(()=>parcelRequire('eminX'));

});

parcelRegister("9vjDg", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5oKYR"),
    $e46AW("42LMy")
]).then(()=>parcelRequire('ehp0G'));

});

parcelRegister("dLYiZ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("gMZda"),
    $e46AW("1gEcS"),
    $e46AW("5oKYR"),
    $e46AW("42LMy"),
    $e46AW("5STgD")
]).then(()=>parcelRequire('iuG9m'));

});

parcelRegister("7j0li", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("j32MG"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("035bM"),
    $e46AW("cotMj"),
    $e46AW("7zgcz"),
    $e46AW("b56zU"),
    $e46AW("aHrLh"),
    $e46AW("4YETx"),
    $e46AW("lH74q"),
    $e46AW("lfS7q"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("jEsv4"),
    $e46AW("4OnzC"),
    $e46AW("6uXie"),
    $e46AW("7LczY"),
    $e46AW("cOm2H"),
    $e46AW("ciaTj"),
    $e46AW("fG06h"),
    $e46AW("83e22"),
    $e46AW("8ejoP"),
    $e46AW("c2Z1S"),
    $e46AW("8Tn4T")
]).then(()=>parcelRequire('j8xJU'));

});

parcelRegister("Os2Ma", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("j32MG"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("035bM"),
    $e46AW("cotMj"),
    $e46AW("7zgcz"),
    $e46AW("b56zU"),
    $e46AW("aHrLh"),
    $e46AW("4YETx"),
    $e46AW("lH74q"),
    $e46AW("lfS7q"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("jEsv4"),
    $e46AW("4OnzC"),
    $e46AW("6uXie"),
    $e46AW("7LczY"),
    $e46AW("cOm2H"),
    $e46AW("ciaTj"),
    $e46AW("fG06h"),
    $e46AW("83e22"),
    $e46AW("8ejoP")
]).then(()=>parcelRequire('6OwfR'));

});

parcelRegister("ac6O3", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("j32MG"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("035bM"),
    $e46AW("cotMj"),
    $e46AW("7zgcz"),
    $e46AW("b56zU"),
    $e46AW("aHrLh"),
    $e46AW("4YETx"),
    $e46AW("lH74q"),
    $e46AW("lfS7q"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("jEsv4"),
    $e46AW("4OnzC"),
    $e46AW("6uXie"),
    $e46AW("7LczY"),
    $e46AW("cOm2H"),
    $e46AW("ciaTj"),
    $e46AW("fG06h"),
    $e46AW("83e22"),
    $e46AW("8ejoP"),
    $e46AW("c2Z1S")
]).then(()=>parcelRequire('2GGsF'));

});

parcelRegister("6euVV", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("2Wroe"),
    $e46AW("5uglX"),
    $e46AW("D7k7p"),
    $e46AW("dk5B5"),
    $e46AW("k2Z1V"),
    $e46AW("gUXXw"),
    $e46AW("awglf"),
    $e46AW("3vgBs"),
    $e46AW("kRgVv")
]).then(()=>parcelRequire('6o4om'));

});

parcelRegister("eK1h3", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("98Vtx"),
    $e46AW("dRuSG")
]).then(()=>parcelRequire('jO1SR'));

});

parcelRegister("2Jr8f", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("bmjWX"),
    $e46AW("2Wroe"),
    $e46AW("5uglX"),
    $e46AW("D7k7p"),
    $e46AW("dk5B5"),
    $e46AW("k2Z1V"),
    $e46AW("gUXXw"),
    $e46AW("awglf"),
    $e46AW("3vgBs"),
    $e46AW("9OTEl")
]).then(()=>parcelRequire('4TToL'));

});

parcelRegister("9oCd9", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("aiEeX").then(()=>parcelRequire('goxJg'));

});

parcelRegister("1yiYR", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("6BKvM"),
    $e46AW("7D12E"),
    $e46AW("co70a"),
    $e46AW("670Zw")
]).then(()=>parcelRequire('6p0Mh'));

});

parcelRegister("ayo6G", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1h3oe").then(()=>parcelRequire('6AC01'));

});

parcelRegister("8yk39", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7TBwC").then(()=>parcelRequire('a4Xzv'));

});

parcelRegister("fJ25g", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9o8yk").then(()=>parcelRequire('7aK0o'));

});


parcelRegister("9Y3l4", function(module, exports) {
$parcel$export(module.exports, "default", () => $32d70184bca3075e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $l1mmm = parcelRequire("l1mmm");
const $32d70184bca3075e$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l1mmm.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $32d70184bca3075e$export$2e2bcd8739ae039 = $32d70184bca3075e$var$TextWrapper;

});
parcelRegister("l1mmm", function(module, exports) {
$parcel$export(module.exports, "TextWithAnnotationDraft", () => $de27b4870640cfa7$export$69a4e0ac39aaf9b7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $iaGyY = parcelRequire("iaGyY");

var $6WnFq = parcelRequire("6WnFq");

var $8Cw1g = parcelRequire("8Cw1g");

var $exUVq = parcelRequire("exUVq");

var $gptJr = parcelRequire("gptJr");

var $dOBEw = parcelRequire("dOBEw");

var $huEyE = parcelRequire("huEyE");

var $afZ8o = parcelRequire("afZ8o");
// Localized AnnotationSharedCSSByState().common and AnnotationSharedCSSByState().focus
const $de27b4870640cfa7$var$markStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
    cursor: 'pointer',
    padding: '1px 0 2px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.card), &:has([data-inline-card])': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.date-lozenger-container)': {
        paddingTop: "var(--ds-space-025, 2px)"
    },
    background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
});
const $de27b4870640cfa7$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    const { dispatch: dispatch } = (0, $huEyE.useAnnotationManagerDispatch)();
    const markRef = (0, $4fqPo.useCallback)((node)=>{
        dispatch({
            type: 'setDraftMarkRef',
            data: {
                draftMarkRef: node ?? undefined
            }
        });
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $exUVq.dataAttributes)(draftPosition),
        css: $de27b4870640cfa7$var$markStyles,
        ref: markRef
    }, children);
};
const $de27b4870640cfa7$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $iaGyY.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $iaGyY.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $iaGyY.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $de27b4870640cfa7$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $de27b4870640cfa7$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $gptJr.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $lqVX7.jsx)($de27b4870640cfa7$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $dOBEw.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, {
            key: index
        }, (0, $dOBEw.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from)));
    });
};
const $de27b4870640cfa7$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const { selectionDraftDocumentPosition: nextDraftPosition } = (0, $afZ8o.useAnnotationRangeState)();
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $8Cw1g.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $6WnFq.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $gptJr.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, (0, $dOBEw.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $iaGyY.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $gptJr.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $lqVX7.jsx)($de27b4870640cfa7$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $dOBEw.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $6WnFq.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $6WnFq.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $gptJr.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, (0, $dOBEw.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $de27b4870640cfa7$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, components);
};

});
parcelRegister("iaGyY", function(module, exports) {
$parcel$export(module.exports, "InsertDraftPosition", () => $e684c59b2ef4bb5e$export$c1bd4813440b4505);
var $e684c59b2ef4bb5e$export$c1bd4813440b4505 = /*#__PURE__*/ function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
    return InsertDraftPosition;
}({});

});

parcelRegister("6WnFq", function(module, exports) {
$parcel$export(module.exports, "findTextString", () => $6575b7376005df3d$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $6575b7376005df3d$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $6575b7376005df3d$export$1059bfc467f4f55d);

var $4fqPo = parcelRequire("4fqPo");
const $6575b7376005df3d$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($6575b7376005df3d$var$isReactElement(childNode) && childNode.props.children) result = $6575b7376005df3d$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $6575b7376005df3d$var$isReactElement(child) {
    return !!child.type;
}
const $6575b7376005df3d$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $6575b7376005df3d$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("8Cw1g", function(module, exports) {
$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $72ef33c46c2466cb$export$b1baddbd5f289877);

var $iaGyY = parcelRequire("iaGyY");
const $72ef33c46c2466cb$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $iaGyY.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $iaGyY.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $iaGyY.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $iaGyY.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("gptJr", function(module, exports) {
$parcel$export(module.exports, "segmentText", () => $61daa204e15b8a67$export$93301b6f1ff0b0c3);
function $61daa204e15b8a67$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("dOBEw", function(module, exports) {
$parcel$export(module.exports, "renderTextSegments", () => $ff77f60f6bbd5945$export$8a20fd0614851c5f);

var $4fqPo = parcelRequire("4fqPo");
function $ff77f60f6bbd5945$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter === null || textHighlighter === void 0 ? void 0 : textHighlighter.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
            "data-highlighted": true,
            "data-vc": "highlighted-text",
            key: `${segment.text}_${startPos}_${idx}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}

});



parcelRegister("4trry", function(module, exports) {
$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $3f86be5c74fee0e7$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $3f86be5c74fee0e7$export$acb253d79d72af92);
function $3f86be5c74fee0e7$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $3f86be5c74fee0e7$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$3f86be5c74fee0e7$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("c4WmR", function(module, exports) {
$parcel$export(module.exports, "getColumnWidths", () => $f6f0d7645c309c6a$export$e54c9225ca52acc);
$parcel$export(module.exports, "calcTableColumnWidths", () => $f6f0d7645c309c6a$export$98951d3cdcfd364b);



function $f6f0d7645c309c6a$export$e54c9225ca52acc(node) {
    let tableColumnWidths = [];
    node.forEach((row)=>{
        const currentTableWidth = [];
        row.forEach((cell)=>{
            const { colspan: colspan, colwidth: colwidth } = cell.attrs;
            // column has been resized, colWidth will be an array, can safely take values even if cell is merged
            if (Array.isArray(colwidth)) currentTableWidth.push(...colwidth);
            else if (colspan !== undefined && colspan > 1) currentTableWidth.push(...Array(colspan).fill(0));
            else currentTableWidth.push(0);
        });
        if (currentTableWidth.length > tableColumnWidths.length) tableColumnWidths = currentTableWidth;
    });
    return tableColumnWidths;
}
function $f6f0d7645c309c6a$export$98951d3cdcfd364b(node) {
    const firstRow = node.firstChild;
    const tableColumnWidths = [];
    if (firstRow) firstRow.forEach((cell)=>{
        const { colspan: colspan, colwidth: colwidth } = cell.attrs;
        // column has been resized, colWidth will be an array, can safely take values even if cell is merged
        if (Array.isArray(colwidth)) tableColumnWidths.push(...colwidth);
        else if (colspan > 1) tableColumnWidths.push(...Array(colspan).fill(0));
        else tableColumnWidths.push(0);
    });
    return tableColumnWidths;
}

});

parcelRegister("ltgAj", function(module, exports) {
$parcel$export(module.exports, "getMarksByOrder", () => $4af94e8344a79cd1$export$99a33ed044c278ae);
$parcel$export(module.exports, "getValidDocument", () => $4af94e8344a79cd1$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $4af94e8344a79cd1$export$81b20b6c83a56bd);

var $h8ouc = parcelRequire("h8ouc");
var $lgtru = parcelRequire("lgtru");
var $kZuij = parcelRequire("kZuij");
var $9Y1m8 = parcelRequire("9Y1m8");

var $eevQH = parcelRequire("eevQH");

var $3H4LK = parcelRequire("3H4LK");

var $hdn08 = parcelRequire("hdn08");

var $eSOxG = parcelRequire("eSOxG");

var $evHqk = parcelRequire("evHqk");


const $4af94e8344a79cd1$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>(0, $evHqk.markOrder).indexOf(a.type.name) - (0, $evHqk.markOrder).indexOf(b.type.name));
};
const $4af94e8344a79cd1$export$fb80336a7e408cb3 = (doc, schema = (0, $eevQH.defaultSchema), adfStage = 'final')=>{
    const node = $4af94e8344a79cd1$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $4af94e8344a79cd1$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $4af94e8344a79cd1$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $lgtru.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $4af94e8344a79cd1$export$fafd4f799ee68da0 = (content, schema = (0, $eevQH.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$4af94e8344a79cd1$export$81b20b6c83a56bd(node, schema, adfStage));
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4af94e8344a79cd1$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4af94e8344a79cd1$var$RELATIVE_LINK = /^\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4af94e8344a79cd1$var$ANCHOR_LINK = /^#/;
const $4af94e8344a79cd1$var$flattenUnknownBlockTree = (node, schema = (0, $eevQH.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    for(let i = 0; i < node.content.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($4af94e8344a79cd1$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$4af94e8344a79cd1$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $4af94e8344a79cd1$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $kZuij.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
   * Find leaf nodes and join them. If leaf nodes' parent node is the same node
   * join with a blank space, otherwise they are children of different branches, i.e.
   * we need to join them with a hardBreak node
   */ return {
        type: 'unknownBlock',
        content: $4af94e8344a79cd1$var$flattenUnknownBlockTree(node)
    };
};
const $4af94e8344a79cd1$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $4af94e8344a79cd1$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $4af94e8344a79cd1$export$81b20b6c83a56bd = (originalNode, schema = (0, $eevQH.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $4af94e8344a79cd1$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $4af94e8344a79cd1$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $kZuij.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $kZuij.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $kZuij.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $kZuij.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $kZuij.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $kZuij.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $4af94e8344a79cd1$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $4af94e8344a79cd1$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $4af94e8344a79cd1$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                const paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                const { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $4af94e8344a79cd1$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        const headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $4af94e8344a79cd1$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $9Y1m8.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $h8ouc.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $h8ouc.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $h8ouc.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $h8ouc.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'blockTaskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $h8ouc.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: (attrs === null || attrs === void 0 ? void 0 : attrs.localId) || (0, $h8ouc.generateUuid)(),
                        width: (attrs === null || attrs === void 0 ? void 0 : attrs.width) || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $4af94e8344a79cd1$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
        case 'syncBlock':
            if (attrs && attrs.resourceId && (0, $hdn08.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $h8ouc.generateUuid)()
                },
                marks: marks
            };
            else return $4af94e8344a79cd1$export$b9908ef75cad1e0e(node);
        case 'bodiedSyncBlock':
            if (attrs && attrs.resourceId && Array.isArray(content) && content.length > 0 && (0, $hdn08.editorExperiment)('platform_synced_block', true)) return {
                type: type,
                attrs: {
                    resourceId: attrs.resourceId,
                    localId: attrs.localId || (0, $h8ouc.generateUuid)()
                },
                marks: marks,
                content: content
            };
            else return $4af94e8344a79cd1$export$b9908ef75cad1e0e(node);
    }
    return $4af94e8344a79cd1$export$b9908ef75cad1e0e(node);
};
const $4af94e8344a79cd1$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$4af94e8344a79cd1$var$RELATIVE_LINK.test(linkHref) && !$4af94e8344a79cd1$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $kZuij.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ((0, $eSOxG.isSubSupType)(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $4af94e8344a79cd1$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $4af94e8344a79cd1$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("lgtru", function(module, exports) {
$parcel$export(module.exports, "inlineNodes", () => $2a20ccaff379ed47$export$b1f729c6af6f2a6e);
// eslint-disable-next-line import/no-namespace

var $2aJ3F = parcelRequire("2aJ3F");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a20ccaff379ed47$var$typedNodes = $2aJ3F;
const $2a20ccaff379ed47$export$b1f729c6af6f2a6e = new Set(Object.keys($2a20ccaff379ed47$var$typedNodes).filter((key)=>$2a20ccaff379ed47$var$typedNodes[key] && $2a20ccaff379ed47$var$typedNodes[key].group === 'inline'));

});
parcelRegister("2aJ3F", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("4a4SQ")).expandWithNestedExpand);
$parcel$export(module.exports, "expandWithNestedExpandLocalId", () => (parcelRequire("4a4SQ")).expandWithNestedExpandLocalId);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("4a4SQ")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("gFlMH")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("bUXVW")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("2fO2k")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("8FRQe")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("cFm3k")).blockquote);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("cFm3k")).extendedBlockquote);
$parcel$export(module.exports, "extendedBlockquoteWithLocalId", () => (parcelRequire("cFm3k")).extendedBlockquoteWithLocalId);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("8EdAG")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("8EdAG")).bulletListSelector);
$parcel$export(module.exports, "bulletListWithLocalId", () => (parcelRequire("8EdAG")).bulletListWithLocalId);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("1rzDq")).codeBlock);
$parcel$export(module.exports, "codeBlockWithLocalId", () => (parcelRequire("1rzDq")).codeBlockWithLocalId);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("1rzDq")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("dvPmQ")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("fzauD")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("kN7jZ")).rule);
$parcel$export(module.exports, "ruleWithLocalId", () => (parcelRequire("kN7jZ")).ruleWithLocalId);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("aZvqc")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("aZvqc")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithLocalId", () => (parcelRequire("aZvqc")).orderedListWithLocalId);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("aZvqc")).orderedListWithOrder);
$parcel$export(module.exports, "orderedListWithOrderAndLocalId", () => (parcelRequire("aZvqc")).orderedListWithOrderAndLocalId);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("1yeB0")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5fTUY")).emoji);
$parcel$export(module.exports, "emojiWithLocalId", () => (parcelRequire("5fTUY")).emojiWithLocalId);
$parcel$export(module.exports, "image", () => (parcelRequire("cYDNc")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("aRXZh")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("aRXZh")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("gN2eH")).listItem);
$parcel$export(module.exports, "listItemWithLocalId", () => (parcelRequire("gN2eH")).listItemWithLocalId);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("9Y1m8")).extendedPanel);
$parcel$export(module.exports, "extendedPanelWithLocalId", () => (parcelRequire("9Y1m8")).extendedPanelWithLocalId);
$parcel$export(module.exports, "extendedPanelC1", () => (parcelRequire("9Y1m8")).extendedPanelC1);
$parcel$export(module.exports, "extendedPanelC1WithLocalId", () => (parcelRequire("9Y1m8")).extendedPanelC1WithLocalId);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("9Y1m8")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("gRNnW")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("4FwVM")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("9DaXy")).caption);
$parcel$export(module.exports, "captionWithLocalId", () => (parcelRequire("9DaXy")).captionWithLocalId);
$parcel$export(module.exports, "media", () => (parcelRequire("0585H")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("0585H")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("0585H")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("jd5NI")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("gPg9H")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("1lZPC")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("1lZPC")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("1lZPC")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("1lZPC")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("1lZPC")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleFullWithLocalId", () => (parcelRequire("1lZPC")).mediaSingleFullWithLocalId);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("1lZPC")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("clekI")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("clekI")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("clekI")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("clekI")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("clekI")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableCellStage0", () => (parcelRequire("clekI")).tableCellStage0);
$parcel$export(module.exports, "tableHeaderStage0", () => (parcelRequire("clekI")).tableHeaderStage0);
$parcel$export(module.exports, "tableCellWithNestedTableStage0", () => (parcelRequire("clekI")).tableCellWithNestedTableStage0);
$parcel$export(module.exports, "tableHeaderWithNestedTableStage0", () => (parcelRequire("clekI")).tableHeaderWithNestedTableStage0);
$parcel$export(module.exports, "tableRowWithLocalId", () => (parcelRequire("clekI")).tableRowWithLocalId);
$parcel$export(module.exports, "tableCellWithLocalId", () => (parcelRequire("clekI")).tableCellWithLocalId);
$parcel$export(module.exports, "tableHeaderWithLocalId", () => (parcelRequire("clekI")).tableHeaderWithLocalId);
$parcel$export(module.exports, "tableRowWithNestedTableWithLocalId", () => (parcelRequire("clekI")).tableRowWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableCellWithNestedTableWithLocalId", () => (parcelRequire("clekI")).tableCellWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableHeaderWithNestedTableWithLocalId", () => (parcelRequire("clekI")).tableHeaderWithNestedTableWithLocalId);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("clekI")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("clekI")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("clekI")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("clekI")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("clekI")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("clekI")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("clekI")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("clekI")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("clekI")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("clekI")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("clekI")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("clekI")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("clekI")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("clekI")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("clekI")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("clekI")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("clekI")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("clekI")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("1Kym8")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("1Kym8")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("1WTWd")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("6DOrW")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("6DOrW")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("43GOy")).taskItem);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("43GOy")).blockTaskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("gVA9a")).date);
$parcel$export(module.exports, "dateWithLocalId", () => (parcelRequire("gVA9a")).dateWithLocalId);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("6KpcC")).placeholder);
$parcel$export(module.exports, "placeholderWithLocalId", () => (parcelRequire("6KpcC")).placeholderWithLocalId);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("garxK")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithLocalId", () => (parcelRequire("garxK")).layoutSectionWithLocalId);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("garxK")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutSectionWithSingleColumnLocalId", () => (parcelRequire("garxK")).layoutSectionWithSingleColumnLocalId);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("atOwT")).layoutColumn);
$parcel$export(module.exports, "layoutColumnStage0", () => (parcelRequire("atOwT")).layoutColumnStage0);
$parcel$export(module.exports, "layoutColumnWithLocalId", () => (parcelRequire("atOwT")).layoutColumnWithLocalId);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("hMy1x")).inlineCard);
$parcel$export(module.exports, "inlineCardWithLocalId", () => (parcelRequire("hMy1x")).inlineCardWithLocalId);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("6YskE")).blockCard);
$parcel$export(module.exports, "blockCardWithLocalId", () => (parcelRequire("6YskE")).blockCardWithLocalId);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("ejaRu")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("ieg9J")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("6WkNC")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("2lECo")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithLocalId", () => (parcelRequire("2lECo")).nestedExpandWithLocalId);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("beODP")).embedCard);
$parcel$export(module.exports, "embedCardWithLocalId", () => (parcelRequire("beODP")).embedCardWithLocalId);
$parcel$export(module.exports, "extension", () => (parcelRequire("4p5eD")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("d8hbR")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("a99AW")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("3p8n7")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("3p8n7")).multiBodiedExtension);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("6s3pT")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("5s4YT")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4a4SQ = parcelRequire("4a4SQ");

var $gFlMH = parcelRequire("gFlMH");

var $bUXVW = parcelRequire("bUXVW");

var $2fO2k = parcelRequire("2fO2k");

var $8FRQe = parcelRequire("8FRQe");

var $cFm3k = parcelRequire("cFm3k");

var $8EdAG = parcelRequire("8EdAG");

var $1rzDq = parcelRequire("1rzDq");

var $dvPmQ = parcelRequire("dvPmQ");

var $fzauD = parcelRequire("fzauD");

var $kN7jZ = parcelRequire("kN7jZ");

var $aZvqc = parcelRequire("aZvqc");

var $1yeB0 = parcelRequire("1yeB0");

var $5fTUY = parcelRequire("5fTUY");

var $cYDNc = parcelRequire("cYDNc");

var $aRXZh = parcelRequire("aRXZh");

var $gN2eH = parcelRequire("gN2eH");

var $9Y1m8 = parcelRequire("9Y1m8");

var $gRNnW = parcelRequire("gRNnW");

var $4FwVM = parcelRequire("4FwVM");

var $9DaXy = parcelRequire("9DaXy");

var $0585H = parcelRequire("0585H");

var $jd5NI = parcelRequire("jd5NI");

var $gPg9H = parcelRequire("gPg9H");

var $1lZPC = parcelRequire("1lZPC");

var $clekI = parcelRequire("clekI");

var $1Kym8 = parcelRequire("1Kym8");

var $1WTWd = parcelRequire("1WTWd");

var $6DOrW = parcelRequire("6DOrW");

var $43GOy = parcelRequire("43GOy");

var $gVA9a = parcelRequire("gVA9a");

var $6KpcC = parcelRequire("6KpcC");

var $garxK = parcelRequire("garxK");

var $atOwT = parcelRequire("atOwT");

var $hMy1x = parcelRequire("hMy1x");

var $6YskE = parcelRequire("6YskE");

var $ejaRu = parcelRequire("ejaRu");

var $ieg9J = parcelRequire("ieg9J");

var $6WkNC = parcelRequire("6WkNC");

var $2lECo = parcelRequire("2lECo");

var $beODP = parcelRequire("beODP");

var $4p5eD = parcelRequire("4p5eD");

var $d8hbR = parcelRequire("d8hbR");

var $a99AW = parcelRequire("a99AW");

var $3p8n7 = parcelRequire("3p8n7");

var $6s3pT = parcelRequire("6s3pT");

var $5s4YT = parcelRequire("5s4YT");

});


parcelRegister("eSOxG", function(module, exports) {
$parcel$export(module.exports, "isSubSupType", () => $64d1ff350091084b$export$30f8aa4cc1f8c1cb);
const $64d1ff350091084b$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};

});

parcelRegister("evHqk", function(module, exports) {
$parcel$export(module.exports, "markOrder", () => $6537cefd1e512aaf$export$62d5811a2955c1d8);
/*
 * It's important that this order follows the marks rank defined here:
 * https://product-fabric.atlassian.net/wiki/spaces/ETEMP/pages/11174043/Atlassian+Document+Format+-+Internal+documentation#Rank
 */ const $6537cefd1e512aaf$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];

});


parcelRegister("aaZSg", function(module, exports) {
$parcel$export(module.exports, "isSameMark", () => $917425a2f817796a$export$b1304404bdc42b7a);
const $917425a2f817796a$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};

});

parcelRegister("djnMX", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", () => $b4c28d6e2c690ffb$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $b4c28d6e2c690ffb$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $b4c28d6e2c690ffb$export$eee20638634729b3);
$parcel$export(module.exports, "findInTree", () => $b4c28d6e2c690ffb$export$38b61ebf4950cd39);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $eevQH = parcelRequire("eevQH");

var $khjyi = parcelRequire("khjyi");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b4c28d6e2c690ffb$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $b4c28d6e2c690ffb$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $eevQH.defaultSchema));
        this.encode = $b4c28d6e2c690ffb$var$createEncoder(transformer, new (0, $khjyi.JSONTransformer)());
    }
}
const $b4c28d6e2c690ffb$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $b4c28d6e2c690ffb$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $b4c28d6e2c690ffb$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $b4c28d6e2c690ffb$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});

parcelRegister("kgsrD", function(module, exports) {
$parcel$export(module.exports, "isAnnotationMark", () => $9a4648aa63764ded$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $9a4648aa63764ded$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6ctpG = parcelRequire("6ctpG");

var $lLdHD = parcelRequire("lLdHD");
const $9a4648aa63764ded$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $9a4648aa63764ded$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $6ctpG.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lLdHD.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        id: id,
        ...data
    }, children));
};
var $9a4648aa63764ded$export$2e2bcd8739ae039 = $9a4648aa63764ded$var$AnnotationComponent;

});
parcelRegister("lLdHD", function(module, exports) {
$parcel$export(module.exports, "MarkElement", () => $ad43812005ccc74f$export$f3069f755c1eba0b);

var $4fqPo = parcelRequire("4fqPo");

var $6ctpG = parcelRequire("6ctpG");

var $2SqHb = parcelRequire("2SqHb");

var $eoEWl = parcelRequire("eoEWl");

var $6xftu = parcelRequire("6xftu");

var $hZqTd = parcelRequire("hZqTd");

var $lsmh1 = parcelRequire("lsmh1");

var $2wRng = parcelRequire("2wRng");

var $huEyE = parcelRequire("huEyE");
const $ad43812005ccc74f$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $hZqTd.useInlineCommentSubscriberContext)();
    const states = (0, $4fqPo.useContext)((0, $2wRng.InlineCommentsStateContext));
    const { hasFocus: hasFocus, isHovered: isHovered } = (0, $lsmh1.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $4fqPo.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const { dispatch: dispatch, annotationManager: annotationManager } = (0, $huEyE.useAnnotationManagerDispatch)();
    const onClick = (0, $4fqPo.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        if (annotationManager) {
            if (hasFocus) {
                dispatch({
                    type: 'resetSelectedAnnotation'
                });
                return;
            }
            annotationManager.checkPreemptiveGate().then((canSelect)=>{
                if (canSelect) {
                    // if there is a draft, clear it first
                    annotationManager === null || annotationManager === void 0 || annotationManager.clearDraft();
                    // use setIsAnnotationSelected won't work here if there is a draft in progress
                    // so we need to use dispatch to update the state directly
                    dispatch({
                        type: 'updateAnnotation',
                        data: {
                            id: annotationIds[0],
                            selected: true
                        }
                    });
                    dispatch({
                        type: 'setSelectedMarkRef',
                        data: {
                            markRef: eventTarget
                        }
                    });
                }
            }).catch((_error)=>{
            // TODO: EDITOR-595 - An error occurred while checking the preemptive gate. We should report this error.
            });
        } else updateSubscriber.emit((0, $2SqHb.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel,
        dispatch,
        annotationManager,
        hasFocus
    ]);
    const activeParentIds = (0, $6xftu.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $6ctpG.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eoEWl.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        isHovered: isHovered,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("eoEWl", function(module, exports) {
$parcel$export(module.exports, "MarkComponent", () => $7e40cb98a7d6ecd5$export$4f5a51511304fdd0);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $6ctpG = parcelRequire("6ctpG");

var $3H4LK = parcelRequire("3H4LK");

var $4MCQn = parcelRequire("4MCQn");

var $jiYbW = parcelRequire("jiYbW");

var $huEyE = parcelRequire("huEyE");
const $7e40cb98a7d6ecd5$var$markStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    color: 'inherit',
    backgroundColor: 'unset',
    WebkitTapHighlightColor: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6ctpG.AnnotationMarkStates).ACTIVE}']`]: {
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
            // TODO: DSP-4147 - Annotation shadow
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
            cursor: 'pointer'
        }
    }
});
const $7e40cb98a7d6ecd5$var$markStylesLayeringFix = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6ctpG.AnnotationMarkStates).ACTIVE}']`]: {
        // Only apply transparency to nested marks when parent is focused
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"] mark': {
            backgroundColor: 'transparent'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.fabric-background-color-mark &[data-has-focus="true"], &[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7e40cb98a7d6ecd5$var$markStylesWithUpdatedShadow = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6ctpG.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7e40cb98a7d6ecd5$var$markStylesWithInlineComments = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6ctpG.AnnotationMarkStates).ACTIVE}']`]: {
        // was from common in AnnotationSharedCSSByState().common
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        padding: `1px 0 ${"var(--ds-space-025, 2px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.card), &:has([data-inline-card])': {
            padding: '5px 0 3px 0'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:has(.date-lozenger-container)': {
            paddingTop: "var(--ds-space-025, 2px)"
        },
        // was from blur in AnnotationSharedCSSByState().blur
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&[data-has-focus="true"]': {
            background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
const $7e40cb98a7d6ecd5$var$markStylesWithCommentsPanel = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
    [`&[data-mark-annotation-state='${(0, $6ctpG.AnnotationMarkStates).ACTIVE}']`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&[data-is-hovered="true"]:not([data-has-focus="true"])': {
            background: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
            borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
            boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
        }
    }
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $7e40cb98a7d6ecd5$var$MOBILE_USER_AGENT_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
const $7e40cb98a7d6ecd5$var$isMobile = ()=>{
    return $7e40cb98a7d6ecd5$var$MOBILE_USER_AGENT_REGEX.test(navigator.userAgent);
};
const $7e40cb98a7d6ecd5$var$accessibilityStylesNew = /*#__PURE__*/ (0, $lqVX7.css)({
    '&::before, &::after': {
        clipPath: 'inset(100%)',
        clip: 'rect(1px, 1px, 1px, 1px)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    '&::before': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-startmarker)'
        ]
    },
    '&::after': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
        content: [
            'var(--ak-renderer-annotation-endmarker)'
        ]
    }
});
const $7e40cb98a7d6ecd5$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, isHovered: isHovered, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const intl = (0, $4MCQn.default)();
    const annotationIds = (0, $4fqPo.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const { annotationManager: annotationManager, dispatch: dispatch } = (0, $huEyE.useAnnotationManagerDispatch)();
    const { currentSelectedAnnotationId: currentSelectedAnnotationId } = (0, $huEyE.useAnnotationManagerState)();
    const isAnnotationManagerEnabled = !!annotationManager;
    // after creating a new annotation, we need to set the markRef to the new mark
    const markRef = (0, $4fqPo.useCallback)((node)=>{
        if (id === currentSelectedAnnotationId && node) dispatch({
            type: 'setSelectedMarkRef',
            data: {
                markRef: node
            }
        });
    }, [
        dispatch,
        id,
        currentSelectedAnnotationId
    ]);
    const onMarkClick = (0, $4fqPo.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $6ctpG.AnnotationMarkStates).ACTIVE) return;
        if ((0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        if (isAnnotationManagerEnabled) // currentTarget is the right element if there are multiple overlapping annotations
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.currentTarget,
            annotationIds: annotationIds
        });
        else // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state,
        isAnnotationManagerEnabled
    ]);
    const onMarkEnter = (evt)=>{
        var _document$activeEleme;
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- keyboard focus for mark / Enter handling
        const focusedElementTag = (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus,
        'data-is-hovered': isHovered
    };
    const desktopAccessibilityAttributes = $7e40cb98a7d6ecd5$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    };
    const accessibility = state !== (0, $6ctpG.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    return (0, $lqVX7.jsx)(useBlockLevel ? 'div' : 'mark', {
        ref: id === currentSelectedAnnotationId ? markRef : undefined,
        id: id,
        [(0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $7e40cb98a7d6ecd5$var$markStyles,
                $7e40cb98a7d6ecd5$var$markStylesLayeringFix,
                (0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') && $7e40cb98a7d6ecd5$var$markStylesWithInlineComments,
                $7e40cb98a7d6ecd5$var$markStylesWithCommentsPanel,
                !$7e40cb98a7d6ecd5$var$isMobile() && $7e40cb98a7d6ecd5$var$accessibilityStylesNew,
                $7e40cb98a7d6ecd5$var$markStylesWithUpdatedShadow
            ],
            style: {
                '--ak-renderer-annotation-startmarker': `"${intl.formatMessage((0, $jiYbW.inlineCommentMessages).contentRendererInlineCommentMarkerStart)}"`,
                '--ak-renderer-annotation-endmarker': `"${intl.formatMessage((0, $jiYbW.inlineCommentMessages).contentRendererInlineCommentMarkerEnd)}"`
            }
        }
    }, children);
};

});

parcelRegister("6xftu", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentsFilter", () => $b5fc881ca5737f2f$export$8e7d47f9e38ad4f1);

var $4fqPo = parcelRequire("4fqPo");

var $2wRng = parcelRequire("2wRng");
const $b5fc881ca5737f2f$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $4fqPo.useContext)((0, $2wRng.InlineCommentsStateContext));
    return (0, $4fqPo.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("hZqTd", function(module, exports) {
$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $2a6e2705cffd7f3f$export$b46737175cffd396);

var $4fqPo = parcelRequire("4fqPo");

var $2wRng = parcelRequire("2wRng");
const $2a6e2705cffd7f3f$export$b46737175cffd396 = ()=>{
    const providers = (0, $4fqPo.useContext)((0, $2wRng.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("8YRWY", function(module, exports) {
$parcel$export(module.exports, "toReact", () => $0656bd4efab5845f$export$d4334b129116aad7);
/* eslint-disable @atlaskit/editor/no-re-export */ // Mapping file

var $bSm7J = parcelRequire("bSm7J");

var $7RDkG = parcelRequire("7RDkG");

var $lgsSq = parcelRequire("lgsSq");

var $coAxj = parcelRequire("coAxj");

var $4pNp9 = parcelRequire("4pNp9");

var $80ADx = parcelRequire("80ADx");

var $fx4io = parcelRequire("fx4io");

var $j0Ulr = parcelRequire("j0Ulr");

var $cwmYV = parcelRequire("cwmYV");

var $jnwnE = parcelRequire("jnwnE");

var $4wnEE = parcelRequire("4wnEE");

var $eGb4w = parcelRequire("eGb4w");

var $bNpnv = parcelRequire("bNpnv");

var $7574F = parcelRequire("7574F");

var $brTO7 = parcelRequire("brTO7");

var $7RAx6 = parcelRequire("7RAx6");

var $kgsrD = parcelRequire("kgsrD");

var $lFgdu = parcelRequire("lFgdu");

var $3VcXG = parcelRequire("3VcXG");

var $9LbqE = parcelRequire("9LbqE");
const $0656bd4efab5845f$export$c00d967a0f56fdb7 = {
    code: (0, $bSm7J.default),
    em: (0, $7RDkG.default),
    link: (0, $lgsSq.default),
    strike: (0, $coAxj.default),
    strong: (0, $4pNp9.default),
    subsup: (0, $80ADx.default),
    textColor: (0, $fx4io.default),
    backgroundColor: (0, $j0Ulr.default),
    underline: (0, $cwmYV.default),
    annotation: (0, $kgsrD.default),
    border: (0, $lFgdu.default),
    fontSize: (0, $3VcXG.default),
    // Stage0
    confluenceInlineComment: (0, $9LbqE.default),
    breakout: (0, $jnwnE.default),
    alignment: (0, $4wnEE.default),
    indentation: (0, $eGb4w.default),
    unsupportedMark: (0, $bNpnv.default),
    unsupportedNodeAttribute: (0, $7574F.default),
    dataConsumer: (0, $brTO7.default),
    fragment: (0, $7RAx6.default)
};
const $0656bd4efab5845f$export$d4334b129116aad7 = (mark)=>{
    return $0656bd4efab5845f$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bSm7J", function(module, exports) {
$parcel$export(module.exports, "isCodeMark", () => $28eeea8dbf994930$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $28eeea8dbf994930$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $3rTf2 = parcelRequire("3rTf2");

var $8OKZI = parcelRequire("8OKZI");

var $8e3AL = parcelRequire("8e3AL");
const $28eeea8dbf994930$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $28eeea8dbf994930$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $8e3AL.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8OKZI.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $28eeea8dbf994930$var$_default_1 = (0, $3rTf2.default)($28eeea8dbf994930$export$7cea6ffa7022e85f);
var $28eeea8dbf994930$export$2e2bcd8739ae039 = $28eeea8dbf994930$var$_default_1;

});
parcelRegister("8OKZI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aacd93833b97041$export$2e2bcd8739ae039);
/* code.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $adj0g = parcelRequire("adj0g");

var $ckfNZ = parcelRequire("ckfNZ");
const $3aacd93833b97041$var$styles = {
    base: "_ca0qyh40 _u5f3m5ip _n3tdyh40 _19bvm5ip _2rkofajl _11c819w5 _1reo1wug _18m91wug _1dqoglyw _1e0c1nu9 _bfhk187e _16d9qvcn _syazi7uo _vwz41kw7 _1i4q1hna _o5721jtm"
};
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $3aacd93833b97041$var$Code = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props;
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3aacd93833b97041$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip
    }, children) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $ltgDR.default)([
            $3aacd93833b97041$var$styles.base
        ])
    }, decoratedChildren);
}));
function $3aacd93833b97041$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $ckfNZ.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $adj0g.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($3aacd93833b97041$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3aacd93833b97041$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, replacedChildren);
}
function $3aacd93833b97041$var$isReactElement(child) {
    return !!child.type;
}
$3aacd93833b97041$var$Code.displayName = 'Code';
var $3aacd93833b97041$export$2e2bcd8739ae039 = $3aacd93833b97041$var$Code;

});
parcelRegister("adj0g", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5e3b438b50c74a2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $8Mj6h = parcelRequire("8Mj6h");

var $i3Yk9 = parcelRequire("i3Yk9");
function $a5e3b438b50c74a2$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: label,
        tag: $a5e3b438b50c74a2$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i3Yk9.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i3Yk9.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, shouldSkip ? null : bidiCharacter);
}
const $a5e3b438b50c74a2$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("i3Yk9", function(module, exports) {
$parcel$export(module.exports, "Decorator", () => $0f9c9c95e9877cfc$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $gFdUI = parcelRequire("gFdUI");
const $0f9c9c95e9877cfc$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $0f9c9c95e9877cfc$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $0f9c9c95e9877cfc$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true",
        className: (0, $ltgDR.default)([
            $0f9c9c95e9877cfc$var$decoration.root
        ])
    }, children), /*#__PURE__*/ $4fqPo.createElement((0, $gFdUI.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ $4fqPo.createElement("mark", null, bidiCharacterCode)));
}
function $0f9c9c95e9877cfc$var$getBidiCharacterCode(bidiCharacter) {
    var _bidiCharacter$codePo;
    const bidiCharacterCode = (_bidiCharacter$codePo = bidiCharacter.codePointAt(0)) === null || _bidiCharacter$codePo === void 0 ? void 0 : _bidiCharacter$codePo.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("ckfNZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd38dd8982e15976$export$2e2bcd8739ae039);

var $79Gem = parcelRequire("79Gem");
function $cd38dd8982e15976$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $79Gem.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});
parcelRegister("79Gem", function(module, exports) {
$parcel$export(module.exports, "bidiCharacterRegex", () => $26a42a9ed94c52db$export$ecb256e6a1f5ee7e);
const $26a42a9ed94c52db$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;

});



parcelRegister("8e3AL", function(module, exports) {
$parcel$export(module.exports, "codeBidiWarningMessages", () => $c9f7fdbb9f61f52f$export$42bb270d1224182);

var $6BhDL = parcelRequire("6BhDL");
const $c9f7fdbb9f61f52f$export$42bb270d1224182 = (0, $6BhDL.defineMessages)({
    /**
   * Message taken from
   * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
   */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});


parcelRegister("7RDkG", function(module, exports) {
$parcel$export(module.exports, "default", () => $17da714295c6a675$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $17da714295c6a675$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("lgsSq", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8ffd1705a23c764$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2TUMI = parcelRequire("2TUMI");

var $djnMX = parcelRequire("djnMX");

var $dQtpO = parcelRequire("dQtpO");

var $f0GG4 = parcelRequire("f0GG4");

var $4mqcS = parcelRequire("4mqcS");

var $fFB0R = parcelRequire("fFB0R");

var $1OLal = parcelRequire("1OLal");

var $gs4ys = parcelRequire("gs4ys");
const $e8ffd1705a23c764$var$LinkUrlMigration = (0, $2TUMI.componentWithCondition)(()=>(0, $4mqcS.expValEquals)('platform_editor_renderer_static_css', 'isEnabled', true), (0, $1OLal.LinkUrlCompiled), (0, $gs4ys.LinkUrlEmotion));
function $e8ffd1705a23c764$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, onSetLinkTarget: onSetLinkTarget, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    let actualTarget = target;
    if (onSetLinkTarget && href) try {
        actualTarget = onSetLinkTarget(href) ?? actualTarget;
    } catch (error) {
    // eslint-disable-line no-unused-vars
    // If URL parsing fails, use the original target
    }
    const anchorProps = {
        href: href,
        target: actualTarget,
        title: href
    };
    if (actualTarget === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $djnMX.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e8ffd1705a23c764$var$LinkUrlMigration, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $f0GG4.ACTION).VISITED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).LINK,
                eventType: (0, $f0GG4.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $dQtpO.PLATFORM).WEB,
                    mode: (0, $dQtpO.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes,
        isLinkComponent: true,
        enableResolve: true
    }, props.children));
}

});
parcelRegister("1OLal", function(module, exports) {
$parcel$export(module.exports, "LinkUrlCompiled", () => $0f23bd22d24f54b7$export$10ae7cf734c9da69);
/* link-compiled.tsx generated by @compiled/babel-plugin v0.37.1 */ /**
 * Compiled branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $d5ghN = parcelRequire("d5ghN");
const $0f23bd22d24f54b7$var$anchorStyles = null;
const $0f23bd22d24f54b7$export$10ae7cf734c9da69 = (props)=>/*#__PURE__*/ $4fqPo.createElement((0, $d5ghN.default), {
        ...props,
        className: (0, $ltgDR.default)([
            "_syaz13af _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
        ])
    });

});
parcelRegister("d5ghN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f64ebbefda7d830$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $apbG6 = parcelRequire("apbG6");

var $fOGqc = parcelRequire("fOGqc");

var $jbFbK = parcelRequire("jbFbK");

var $a9W5R = parcelRequire("a9W5R");

var $iDZHE = parcelRequire("iDZHE");

var $8cRtQ = parcelRequire("8cRtQ");
const $7f64ebbefda7d830$var$PACKAGE_DATA = {
    packageName: undefined,
    packageVersion: undefined,
    componentName: 'linkUrl'
};
const $7f64ebbefda7d830$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $8cRtQ.useLinkWarningModal)();
    const Link = enableResolve ? (0, $a9W5R.HyperlinkWithSmartLinkResolver) : (0, $jbFbK.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fOGqc.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Link, {
        href: href,
        testId: testId,
        isLinkComponent: isLinkComponent,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iDZHE.default), linkWarningModalProps));
};
const $7f64ebbefda7d830$var$_default_1 = (0, $apbG6.default)($7f64ebbefda7d830$var$PACKAGE_DATA)($7f64ebbefda7d830$var$LinkUrl);
var $7f64ebbefda7d830$export$2e2bcd8739ae039 = $7f64ebbefda7d830$var$_default_1;

});
parcelRegister("fOGqc", function(module, exports) {
$parcel$export(module.exports, "LinkAnalyticsContext", () => $b02d22246caea44e$export$9458cdec663b9ff1);

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");
const $b02d22246caea44e$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("jbFbK", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8359a4cd5ad05d5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $iByhD = parcelRequire("iByhD");

var $1obm7 = parcelRequire("1obm7");
const $b8359a4cd5ad05d5$var$Anchor = (0, $1obm7.withLinkClickedEvent)('a');
const $b8359a4cd5ad05d5$export$8c0773eab230d49e = (0, $1obm7.withLinkClickedEvent)((0, $iByhD.default));
const $b8359a4cd5ad05d5$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $b8359a4cd5ad05d5$export$8c0773eab230d49e : $b8359a4cd5ad05d5$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $b8359a4cd5ad05d5$export$2e2bcd8739ae039 = $b8359a4cd5ad05d5$var$Hyperlink;

});
parcelRegister("1obm7", function(module, exports) {
$parcel$export(module.exports, "fireLinkClickedEvent", () => $fce836794d7320ff$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $fce836794d7320ff$export$263352d59c0c5966);

var $4fqPo = parcelRequire("4fqPo");

var $jzPTP = parcelRequire("jzPTP");

var $7eP9h = parcelRequire("7eP9h");

var $4mqcS = parcelRequire("4mqcS");

var $hLsK4 = parcelRequire("hLsK4");

var $fShv5 = parcelRequire("fShv5");
const $fce836794d7320ff$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $fce836794d7320ff$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $fce836794d7320ff$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $fce836794d7320ff$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $jzPTP.browser)();
    /**
   * If the link/parent is content editable then left click won't have typical effect
   */ if ($fce836794d7320ff$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $fce836794d7320ff$var$linkClickedEventOld = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $fce836794d7320ff$var$linkClickedEventWithShortLink = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented, isConfluenceShortLink: isConfluenceShortLink })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    });
const $fce836794d7320ff$export$880d2168464029dd = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $fce836794d7320ff$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $fce836794d7320ff$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $fce836794d7320ff$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $fce836794d7320ff$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $fce836794d7320ff$export$fb40cb818618aeeb = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $fce836794d7320ff$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $fce836794d7320ff$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $fce836794d7320ff$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    let isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    const linkClickedEventResult = $fce836794d7320ff$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $fce836794d7320ff$export$7fedc699766c16de = (0, $7eP9h.functionWithCondition)(()=>(0, $4mqcS.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test'), // 12/17/2025: Clean up this feature gate once it's out in prod for 2 weeks - https://product-fabric.atlassian.net/browse/CCPERMS-5030
$fce836794d7320ff$export$fb40cb818618aeeb, $fce836794d7320ff$export$880d2168464029dd);
const $fce836794d7320ff$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $fce836794d7320ff$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides === null || overrides === void 0 ? void 0 : overrides.nonPrivacySafeAttributes
            }
        }).fire((0, $fShv5.ANALYTICS_CHANNEL));
    };
const $fce836794d7320ff$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $fce836794d7320ff$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $hLsK4.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $hLsK4.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$fce836794d7320ff$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("jzPTP", function(module, exports) {
$parcel$export(module.exports, "browser", () => $115d50752cd65dba$export$3f2684e5d7cb1006);
const $115d50752cd65dba$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $115d50752cd65dba$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $115d50752cd65dba$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $115d50752cd65dba$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $115d50752cd65dba$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $115d50752cd65dba$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $115d50752cd65dba$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $115d50752cd65dba$var$result.android = /Android \d/.test(navigator.userAgent);
    $115d50752cd65dba$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $115d50752cd65dba$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $115d50752cd65dba$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $115d50752cd65dba$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $115d50752cd65dba$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $115d50752cd65dba$export$3f2684e5d7cb1006() {
    return $115d50752cd65dba$var$result;
}

});

parcelRegister("7eP9h", function(module, exports) {
$parcel$export(module.exports, "functionWithCondition", () => $c29bb9db97668cac$export$af3c0e82a18fc057);
$parcel$export(module.exports, "functionUnionWithCondition", () => $c29bb9db97668cac$export$c41c28c1d883fcd5);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $c29bb9db97668cac$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $c29bb9db97668cac$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $c29bb9db97668cac$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});

parcelRegister("hLsK4", function(module, exports) {
$parcel$export(module.exports, "useLinkClicked", () => $3eb1bd10d6755d1e$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $3eb1bd10d6755d1e$export$df67f318ded0283c);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $1obm7 = parcelRequire("1obm7");
var $3eb1bd10d6755d1e$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $3eb1bd10d6755d1e$export$5993d3ca6c85f774 = (handler, predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    return (0, $4fqPo.useCallback)((...args)=>{
        const [event] = args;
        handler === null || handler === void 0 || handler.apply(null, args);
        if (!predicate || predicate !== null && predicate !== void 0 && predicate(event)) (0, $1obm7.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $3eb1bd10d6755d1e$var$isNotLeftClick = (event)=>event.button !== 0;
const $3eb1bd10d6755d1e$export$df67f318ded0283c = (onMouseDown)=>{
    return $3eb1bd10d6755d1e$export$5993d3ca6c85f774(onMouseDown, $3eb1bd10d6755d1e$var$isNotLeftClick);
};

});

parcelRegister("fShv5", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $d86cadce2a7647fc$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $d86cadce2a7647fc$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $d86cadce2a7647fc$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $d86cadce2a7647fc$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $d86cadce2a7647fc$export$b91e0203b928470c);
const $d86cadce2a7647fc$export$85183a312807388d = 'media';
const $d86cadce2a7647fc$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: '',
    packageVersion: ''
};
var $d86cadce2a7647fc$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $d86cadce2a7647fc$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $d86cadce2a7647fc$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $d86cadce2a7647fc$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $d86cadce2a7647fc$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($d86cadce2a7647fc$export$85183a312807388d);
};

});



parcelRegister("a9W5R", function(module, exports) {
$parcel$export(module.exports, "HyperlinkWithSmartLinkResolver", () => $0b62866b43883d33$export$1fdb4f77fe528a52);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $3rTf2 = parcelRequire("3rTf2");

var $3H4LK = parcelRequire("3H4LK");

var $4mqcS = parcelRequire("4mqcS");

var $4ubSX = parcelRequire("4ubSX");

var $50n6s = parcelRequire("50n6s");

var $jcuFs = parcelRequire("jcuFs");

var $3twpn = parcelRequire("3twpn");

var $if4Mo = parcelRequire("if4Mo");

var $jHQ5C = parcelRequire("jHQ5C");

var $dQ6d5 = parcelRequire("dQ6d5");

var $8Ckj1 = parcelRequire("8Ckj1");

var $jbFbK = parcelRequire("jbFbK");
const $0b62866b43883d33$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT = 'linking_platform_track_non_primary_3p_clicks';
const $0b62866b43883d33$var$HyperlinkFallbackComponent = ()=>null;
const $0b62866b43883d33$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $3twpn.default)(props === null || props === void 0 ? void 0 : props.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $if4Mo.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(DefaultComponent, props);
    };
const $0b62866b43883d33$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { state: state } = (0, $jcuFs.default)({
        href: props.href || ''
    });
    const thirdPartyARI = (0, $50n6s.getThirdPartyARI)(state === null || state === void 0 ? void 0 : state.details);
    const firstPartyIdentifier = (0, $50n6s.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $3H4LK.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $8Ckj1.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = (state === null || state === void 0 ? void 0 : state.status) === 'resolved' && fire3PClickEvent && (0, $3H4LK.fg)('platform_smartlink_3pclick_analytics');
    const onClick = (0, $4fqPo.useCallback)((e)=>{
        // button === 0 is left-click, see
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (shouldFire3PClickEvent && (e === null || e === void 0 ? void 0 : e.button) === 0) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent();
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    // Fire experiment exposure once per surface mount, not on every re-render.
    (0, $4fqPo.useEffect)(()=>{
        if (shouldFire3PClickEvent) (0, $4mqcS.expValEquals)($0b62866b43883d33$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true);
    }, [
        shouldFire3PClickEvent
    ]);
    const onAuxClick = (0, $4fqPo.useCallback)((e)=>{
        // isAuxClick guards against Windows right-clicks firing onAuxClick with button === 2.
        if ((0, $jHQ5C.isAuxClick)(e) && shouldFire3PClickEvent && (0, $4ubSX.expValEqualsNoExposure)($0b62866b43883d33$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true)) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onContextMenu = (0, $4fqPo.useCallback)((_e)=>{
        if (shouldFire3PClickEvent && (0, $4ubSX.expValEqualsNoExposure)($0b62866b43883d33$var$TRACK_NON_PRIMARY_3P_CLICKS_EXPERIMENT, 'isEnabled', true)) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jbFbK.default), {
        ...props,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    });
};
const $0b62866b43883d33$export$1fdb4f77fe528a52 = (0, $BYXH4.withErrorBoundary)($0b62866b43883d33$var$withValidator((0, $3rTf2.default)((0, $dQ6d5.default)($0b62866b43883d33$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $jbFbK.default)), {
    FallbackComponent: $0b62866b43883d33$var$HyperlinkFallbackComponent
});

});
parcelRegister("50n6s", function(module, exports) {
$parcel$export(module.exports, "getByDefinitionId", () => $3f78d804447e19f6$export$f75b0b690ab4dfb9);
$parcel$export(module.exports, "getClickUrl", () => $3f78d804447e19f6$export$cf3c5acf9e9d0f02);
$parcel$export(module.exports, "getDefinitionId", () => $3f78d804447e19f6$export$46fa3e7718c82e41);
$parcel$export(module.exports, "getExtensionKey", () => $3f78d804447e19f6$export$218d96312e385949);
$parcel$export(module.exports, "getObjectAri", () => $3f78d804447e19f6$export$81164c1570bcd038);
$parcel$export(module.exports, "getThirdPartyARI", () => $3f78d804447e19f6$export$e029950864672b4);
$parcel$export(module.exports, "getFirstPartyIdentifier", () => $3f78d804447e19f6$export$48b4e58cdb8031ba);
$parcel$export(module.exports, "getObjectName", () => $3f78d804447e19f6$export$5615361d76a8be5);
$parcel$export(module.exports, "getObjectIconUrl", () => $3f78d804447e19f6$export$bcf275804417edda);
$parcel$export(module.exports, "getResourceType", () => $3f78d804447e19f6$export$16c0ebb0de9b767b);
$parcel$export(module.exports, "getServices", () => $3f78d804447e19f6$export$a009e3a1163d46fb);
$parcel$export(module.exports, "isFinalState", () => $3f78d804447e19f6$export$d590d08942abc17a);
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $3f78d804447e19f6$export$3f9446bb21b945a0);

var $3H4LK = parcelRequire("3H4LK");

var $6L6gw = parcelRequire("6L6gw");
const $3f78d804447e19f6$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $3f78d804447e19f6$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $6L6gw.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $3f78d804447e19f6$export$46fa3e7718c82e41 = (details)=>{
    var _details$meta;
    return details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId;
};
const $3f78d804447e19f6$export$218d96312e385949 = (details)=>{
    var _details$meta2;
    return details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key;
};
const $3f78d804447e19f6$export$81164c1570bcd038 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $3f78d804447e19f6$export$e029950864672b4 = (details)=>{
    if ((0, $3H4LK.fg)('platform_smartlink_3pclick_analytics')) {
        if (details !== null && details !== void 0 && details.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details !== null && details !== void 0 && details.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $3f78d804447e19f6$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $3H4LK.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $3f78d804447e19f6$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $3f78d804447e19f6$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $3f78d804447e19f6$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $3f78d804447e19f6$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $3f78d804447e19f6$export$5615361d76a8be5 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'name' in details.data && details.data.name || undefined;
const $3f78d804447e19f6$export$bcf275804417edda = (details)=>{
    if (details !== null && details !== void 0 && details.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $3f78d804447e19f6$export$16c0ebb0de9b767b = (details)=>{
    var _details$meta3;
    return details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.resourceType;
};
const $3f78d804447e19f6$export$e2005c9600188ac7 = (details)=>{
    var _details$meta4;
    return details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.product;
};
const $3f78d804447e19f6$export$f8fdefc70357968e = (details)=>{
    var _details$meta5;
    return details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.subproduct;
};
const $3f78d804447e19f6$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $3f78d804447e19f6$export$ac5d414b1ebfab5a = (details)=>details && $3f78d804447e19f6$export$cd41ae544cfc2a65(details) && $3f78d804447e19f6$export$795910f5f15a9633(details);
const $3f78d804447e19f6$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $3f78d804447e19f6$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $3f78d804447e19f6$export$a752a116d184ffbd = (details)=>{
    var _details$meta6;
    return details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 || (_details$meta6 = _details$meta6.requestAccess) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.accessType;
};
const $3f78d804447e19f6$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $3f78d804447e19f6$export$66805b16d2a1da7c = (details)=>details === null || details === void 0 ? void 0 : details.datasources;
const $3f78d804447e19f6$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $3f78d804447e19f6$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $3f78d804447e19f6$export$3f9446bb21b945a0 = (details)=>!!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);
// Helper function to extract page ID from standard Confluence page URLs
const $3f78d804447e19f6$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $3f78d804447e19f6$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $3f78d804447e19f6$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $3f78d804447e19f6$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};

});
parcelRegister("6L6gw", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $0a628dbbeb356700$export$c81497d3681f24f4);
const $0a628dbbeb356700$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("jcuFs", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c47338804eaf0fc$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2OOKU = parcelRequire("2OOKU");

var $agHzq = parcelRequire("agHzq");

var $6TDb2 = parcelRequire("6TDb2");

var $izEe5 = parcelRequire("izEe5");

var $50n6s = parcelRequire("50n6s");

var $jZHYG = parcelRequire("jZHYG");

var $2wB1j = parcelRequire("2wB1j");
const $1c47338804eaf0fc$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $4fqPo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2OOKU)))());
    const state = (0, $jZHYG.useSmartCardState)(href);
    const definitionId = (0, $50n6s.getDefinitionId)(state.details);
    const extensionKey = (0, $50n6s.getExtensionKey)(state.details);
    const resourceType = (0, $50n6s.getResourceType)(state.details);
    const actions = (0, $izEe5.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $2wB1j.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $agHzq.useAnalyticsEvents)();
    (0, $4fqPo.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $4fqPo.useEffect)(()=>{
        $6TDb2.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            $6TDb2.create(id, state.status);
            if (state.status === 'resolved') {
                var _measure$getMeasure;
                fireEvent('operational.hyperlink.resolved', {
                    definitionId: definitionId ?? null,
                    extensionKey: extensionKey ?? null,
                    resourceType: resourceType ?? null,
                    duration: ((_measure$getMeasure = $6TDb2.getMeasure(id, state.status)) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) ?? null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $1c47338804eaf0fc$export$2e2bcd8739ae039 = $1c47338804eaf0fc$var$useResolveHyperlink;

});
parcelRegister("agHzq", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $ced9931127156210$export$5bf35293e545f20c);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::ac0d75fa9e8d43c947e88f47ba1267aa>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $aq0Si = parcelRequire("aq0Si");

var $4UoFp = parcelRequire("4UoFp");
const $ced9931127156210$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const fireEvent = (0, $4fqPo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4UoFp.default)(...params));
        event.fire((0, $aq0Si.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};

});
parcelRegister("aq0Si", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $3cea09a2cd0d0e9b$export$3f072f06b90c3985);
const $3cea09a2cd0d0e9b$export$3f072f06b90c3985 = 'media';

});

parcelRegister("4UoFp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7dce9d072e3bc87$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::268e746266cde1271e40a794eb774cf3>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $a7dce9d072e3bc87$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $a7dce9d072e3bc87$export$2e2bcd8739ae039 = $a7dce9d072e3bc87$var$createEventPayload;

});


parcelRegister("6TDb2", function(module, exports) {
$parcel$export(module.exports, "clearMarks", () => $6d6b17608cdacd22$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $6d6b17608cdacd22$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $6d6b17608cdacd22$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $6d6b17608cdacd22$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $6d6b17608cdacd22$export$185802fd694ee1f5);
const $6d6b17608cdacd22$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $6d6b17608cdacd22$var$hasPerformanceAPIAvailable = $6d6b17608cdacd22$var$isPerformanceAPIAvailable();
const $6d6b17608cdacd22$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $6d6b17608cdacd22$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $6d6b17608cdacd22$export$1a717feb4df1a945 = (id)=>{
    if ($6d6b17608cdacd22$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $6d6b17608cdacd22$export$de42547d395c8271 = (id)=>{
    if ($6d6b17608cdacd22$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $6d6b17608cdacd22$var$getMark = (id, status)=>{
    if ($6d6b17608cdacd22$var$hasPerformanceAPIAvailable) {
        const name = $6d6b17608cdacd22$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $6d6b17608cdacd22$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($6d6b17608cdacd22$var$hasPerformanceAPIAvailable) {
        const name = $6d6b17608cdacd22$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $6d6b17608cdacd22$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($6d6b17608cdacd22$var$hasPerformanceAPIAvailable) {
        const name = $6d6b17608cdacd22$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $6d6b17608cdacd22$export$185802fd694ee1f5 = (id, status)=>{
    if ($6d6b17608cdacd22$var$hasPerformanceAPIAvailable) {
        const name = $6d6b17608cdacd22$export$984df7f61dd7928f(id, status);
        const measure = $6d6b17608cdacd22$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $6d6b17608cdacd22$var$getMark(id, 'pending');
            const endMark = $6d6b17608cdacd22$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("izEe5", function(module, exports) {
$parcel$export(module.exports, "useSmartCardActions", () => $11aaf8d8d3c7ecd1$export$f7c340395f31e832);

var $4fqPo = parcelRequire("4fqPo");

var $fRlBb = parcelRequire("fRlBb");

var $5ILcO = parcelRequire("5ILcO");

var $2oVC7 = parcelRequire("2oVC7");

var $aJb31 = parcelRequire("aJb31");

var $3H4LK = parcelRequire("3H4LK");

var $645XO = parcelRequire("645XO");

var $1M97K = parcelRequire("1M97K");

var $4mqcS = parcelRequire("4mqcS");

var $agHzq = parcelRequire("agHzq");

var $bjIO7 = parcelRequire("bjIO7");

var $igKiU = parcelRequire("igKiU");

var $4Wmbl = parcelRequire("4Wmbl");

var $feSIj = parcelRequire("feSIj");

var $50n6s = parcelRequire("50n6s");

var $eiylg = parcelRequire("eiylg");

var $ek3rC = parcelRequire("ek3rC");

var $i66n7 = parcelRequire("i66n7");
const $11aaf8d8d3c7ecd1$var$POST_AUTH_CHAT_EXTENSION_KEY = 'google-object-provider';
// Smart Card resolver key differs from the consumer-facing Rovo payload key.
const $11aaf8d8d3c7ecd1$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY = 'google-drive';
const $11aaf8d8d3c7ecd1$var$SMART_LINK_3P_POST_AUTH_SOURCE = 'smart-link-3p-post-auth';
const $11aaf8d8d3c7ecd1$var$getPostAuthChatPayloadId = ()=>{
    if (typeof crypto !== 'undefined') {
        if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        if (typeof crypto.getRandomValues === 'function') {
            const values = new Uint32Array(4);
            crypto.getRandomValues(values);
            return `smart-link-post-auth-chat-${Array.from(values, (value)=>value.toString(16)).join('-')}`;
        }
    }
    return `smart-link-post-auth-chat-${Date.now()}`;
};
const $11aaf8d8d3c7ecd1$var$sendPostAuthChatOpenMessage = (url, documentTitle)=>{
    var _window$parent;
    if (typeof window === 'undefined' || typeof ((_window$parent = window.parent) === null || _window$parent === void 0 ? void 0 : _window$parent.postMessage) !== 'function') return;
    const payload = {
        type: 'chat-smartlink-3p-post-auth-launch',
        source: $11aaf8d8d3c7ecd1$var$SMART_LINK_3P_POST_AUTH_SOURCE,
        openChat: true,
        openChatMode: 'mini-modal',
        data: {
            extensionKey: $11aaf8d8d3c7ecd1$var$POST_AUTH_CHAT_PAYLOAD_EXTENSION_KEY,
            provider: 'Google Drive',
            projectContext: {
                projectId: url,
                projectName: documentTitle ?? 'Google Drive',
                projectUrl: url
            }
        }
    };
    window.parent.postMessage({
        eventType: (0, $1M97K.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: $11aaf8d8d3c7ecd1$var$getPostAuthChatPayloadId()
    }, '*');
};
const $11aaf8d8d3c7ecd1$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $i66n7.default)();
    const invokeClientAction = (0, $ek3rC.default)({});
    const { fireEvent: fireEvent } = (0, $agHzq.useAnalyticsEvents)();
    const useActionFlagsGated = (0, $645XO.functionWithFG)('platform_sl_connect_account_flag', (0, $eiylg.default), (0, $igKiU.noop));
    const flags = useActionFlagsGated();
    const { store: store, rovoOptions: rovoOptions } = (0, $5ILcO.useSmartLinkContext)();
    const rovoOptionsRef = (0, $4fqPo.useRef)(rovoOptions);
    rovoOptionsRef.current = rovoOptions;
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $4fqPo.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $bjIO7.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $4fqPo.useCallback)((metadataStatus)=>{
        dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    // Original resolve function — signature kept intact for maximum safety when FG is off.
    const resolve = (0, $4fqPo.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id
        }), [
        id,
        resolveUrl,
        url
    ]);
    // New resolve function accepting ResolveUrlParams (minus 'id' which is closed over).
    // Used when FG is enabled to pass appearance to ORS.
    const resolveNew = (0, $4fqPo.useCallback)(async (params = {})=>{
        const { url: resourceUrl = url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, appearance: appearance } = params;
        return resolveUrl({
            url: resourceUrl,
            isReloading: isReloading,
            isMetadataRequest: isMetadataRequest,
            id: id,
            appearance: appearance
        });
    }, [
        id,
        resolveUrl,
        url
    ]);
    /**
   * Register a smart link for resolution.
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ const register = (0, $4fqPo.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_RESOLVING), {
                url: url
            }));
            // Always set metadataStatus to 'pending' during registration to prevent
            // loadMetadata from firing a duplicate concurrent fetch if a hover card
            // mounts while registration is in-flight. This matches pre-PR behaviour.
            setMetadataStatus('pending');
        }
        if ((0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization')) return resolveNew({
            url: url,
            appearance: appearance
        });
        return resolve(url);
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $4fqPo.useCallback)((appearance)=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $50n6s.getDefinitionId)(details);
        if ((0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization')) {
            if (definitionId) (0, $50n6s.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolveNew({
                    url: reloadUrl,
                    isReloading: true,
                    appearance: appearance
                }));
            else resolveNew({
                url: url,
                isReloading: true,
                appearance: appearance
            });
        } else if (definitionId) (0, $50n6s.getByDefinitionId)(definitionId, getState()).map((reloadUrl)=>resolve(reloadUrl, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve,
        resolveNew
    ]);
    /**
   * Load metadata for hover card preview.
   * This always requests 'block' appearance to get full data including summary.
   *
   * Inline optimized and SSR-resolved links keep metadataStatus pending until hover
   * requests the full block response.
   */ const loadMetadata = (0, $4fqPo.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        const needsBlockData = metadataStatus === undefined || metadataStatus === 'pending' && (0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization');
        if (needsBlockData) {
            setMetadataStatus('pending');
            if ((0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization')) // Always request 'block' appearance for hover card metadata to get full data
            return resolveNew({
                url: url,
                isMetadataRequest: true,
                appearance: 'block'
            });
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        resolveNew,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $4fqPo.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $50n6s.getDefinitionId)(details);
        const extensionKey = (0, $50n6s.getExtensionKey)(details);
        const isSupportedPostAuthChatExtensionKey = extensionKey === $11aaf8d8d3c7ecd1$var$POST_AUTH_CHAT_EXTENSION_KEY;
        const services = (0, $50n6s.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $aJb31.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $feSIj.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                // Post-auth Chat onboarding: auto-open Rovo Chat mini-modal with the
                // authed 3P link as context, for supported providers (e.g. Google Drive).
                // Provider eligibility is derived from the pre-auth SmartLink state.
                const isEligibleForPostAuthChat = status === 'unauthorized' && isSupportedPostAuthChatExtensionKey && (0, $3H4LK.fg)('platform_sl_3p_post_auth_chat_open_fg') && (0, $4Wmbl.getIsRovoChatEnabled)(rovoOptionsRef.current);
                // Experiment check: fires exposure for both control and treatment.
                // Only reached after eligibility preconditions + kill switch pass, so
                // exposure is counted for the triggered eligible pool.
                const isPostAuthChatTreatment = isEligibleForPostAuthChat && (0, $4mqcS.expValEquals)('platform_sl_3p_post_auth_chat_open_exp', 'isEnabled', true);
                if (status === 'unauthorized' && !isPostAuthChatTreatment) {
                    if ((0, $3H4LK.fg)('platform_sl_connect_account_flag')) {
                        const provider = (0, $fRlBb.extractSmartLinkProvider)(details);
                        flags === null || flags === void 0 || flags.showConnectFlag({
                            id: `smart-link-connect-success-${extensionKey}`,
                            provider: provider
                        });
                    }
                }
                reload();
                if (isPostAuthChatTreatment) $11aaf8d8d3c7ecd1$var$sendPostAuthChatOpenMessage(url, (0, $fRlBb.extractSmartLinkTitle)(details));
            }, (err)=>{
                (0, $feSIj.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent,
        flags,
        url
    ]);
    const invoke = (0, $4fqPo.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $4fqPo.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};

});
parcelRegister("aJb31", function(module, exports) {
$parcel$export(module.exports, "auth", () => $1f3c30d404f669bb$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("alV18")).AuthError);

var $alV18 = parcelRequire("alV18");

var $7lagl = parcelRequire("7lagl");
function $1f3c30d404f669bb$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $7lagl.isOfTypeAuthError)(errorType)) reject(new (0, $alV18.AuthError)(data.message, errorType));
                    else reject(new (0, $alV18.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $alV18.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("alV18", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => $df439dd199608b81$export$145273558d58e0ac);
class $df439dd199608b81$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("7lagl", function(module, exports) {
$parcel$export(module.exports, "isOfTypeAuthError", () => $8bd2950c1031e24e$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $8bd2950c1031e24e$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("645XO", function(module, exports) {
$parcel$export(module.exports, "functionWithFG", () => $8122cb338625a9a0$export$53903226fff06fbb);

var $3H4LK = parcelRequire("3H4LK");

var $7eP9h = parcelRequire("7eP9h");
const $8122cb338625a9a0$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $7eP9h.functionWithCondition)(()=>(0, $3H4LK.fg)(featureFlagName), functionTrue, functionFalse);

});

parcelRegister("1M97K", function(module, exports) {
$parcel$export(module.exports, "ROVO_POST_MESSAGE_EVENT_TYPE", () => $18c1737c2ff53486$export$cabfb6cc8c48b099);
$parcel$export(module.exports, "useRovoPostMessageToPubsub", () => $18c1737c2ff53486$export$5340cc94dd0ecbea);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $hY7Fx = parcelRequire("hY7Fx");
const $18c1737c2ff53486$export$cabfb6cc8c48b099 = 'rovo-post-message';
const $18c1737c2ff53486$export$25a11ea4740a334 = 'rovo-post-message-ack';
// allow subdomains of these domains
const $18c1737c2ff53486$var$allowedSubdomains = [
    '.jira-dev.com',
    '.jira.atlassian.cloud',
    '.atlassian.com',
    '.atlassian.net',
    '.atl-paas.net'
];
const $18c1737c2ff53486$var$allowedOrigins = [
    'bitbucket.org',
    'trello.com'
];
const $18c1737c2ff53486$export$c9fe6aef04e3544f = (origin)=>{
    if (!origin) return false;
    const url = new URL(origin);
    const hostname = url.hostname;
    return hostname === 'localhost' || url.protocol === 'https:' && ($18c1737c2ff53486$var$allowedSubdomains.some((subdomain)=>hostname.endsWith(subdomain)) || $18c1737c2ff53486$var$allowedOrigins.includes(hostname));
};
const $18c1737c2ff53486$export$e5e1a9c59c299631 = ()=>{
    const publish = (0, $hY7Fx.usePublish)('ai-mate');
    (0, $4fqPo.useEffect)(()=>{
        const handlerUnbind = (0, $lMcEJ.bind)(window, {
            type: 'message',
            listener: (event)=>{
                if (!$18c1737c2ff53486$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType === $18c1737c2ff53486$export$cabfb6cc8c48b099) {
                    var _event$source;
                    const eventData = event.data;
                    const ackPayload = {
                        eventType: $18c1737c2ff53486$export$25a11ea4740a334,
                        payloadId: eventData.payloadId
                    };
                    (_event$source = event.source) === null || _event$source === void 0 || _event$source.postMessage(ackPayload, {
                        targetOrigin: '*'
                    });
                    publish(event.data.payload);
                }
            }
        });
        return handlerUnbind;
    }, [
        publish
    ]);
    return null;
};
const $18c1737c2ff53486$var$TIMEOUT_WAIT_FOR_ACK = 100;
const $18c1737c2ff53486$export$5340cc94dd0ecbea = ()=>{
    const onAcknowledgeTimeoutTimeoutRef = (0, $4fqPo.useRef)(null);
    const [isWaitingForAck, setIsWaitingForAck] = (0, $4fqPo.useState)(false);
    (0, $4fqPo.useEffect)(()=>{
        const handlerUnbind = (0, $lMcEJ.bind)(window, {
            type: 'message',
            // handler for acknowledgment from parent
            listener: (event)=>{
                if (!$18c1737c2ff53486$export$c9fe6aef04e3544f(event.origin)) return;
                if (event.data.eventType !== $18c1737c2ff53486$export$25a11ea4740a334 || onAcknowledgeTimeoutTimeoutRef.current === null) return;
                const eventData = event.data;
                // if the parent acknowledges different payload (e.g. from different hook instance)
                // disregard the event
                if (eventData.payloadId !== onAcknowledgeTimeoutTimeoutRef.current.lastPayloadId) return;
                // Clear the onAcknowledgeTimeoutTimeout if acknowledgment is received
                clearTimeout(onAcknowledgeTimeoutTimeoutRef.current.timeout);
                onAcknowledgeTimeoutTimeoutRef.current = null;
                setIsWaitingForAck(false);
            }
        });
        return handlerUnbind;
    }, []);
    const publishWithPostMessage = (0, $4fqPo.useCallback)(({ targetWindow: targetWindow = window.parent, payload: payload, onAcknowledgeTimeout: onAcknowledgeTimeout })=>{
        if (!targetWindow) return;
        const payloadId = Math.floor(Math.random() * 1e6).toString();
        targetWindow.postMessage({
            eventType: $18c1737c2ff53486$export$cabfb6cc8c48b099,
            payload: payload,
            payloadId: payloadId
        }, '*');
        // waiting for acknowledgment from parent
        // if no acknowledgment is received, call onAcknowledgeTimeout
        setIsWaitingForAck(true);
        const timeout = window.setTimeout(()=>{
            onAcknowledgeTimeout({
                payload: payload
            });
            onAcknowledgeTimeoutTimeoutRef.current = null;
            setIsWaitingForAck(false);
        }, $18c1737c2ff53486$var$TIMEOUT_WAIT_FOR_ACK);
        onAcknowledgeTimeoutTimeoutRef.current = {
            timeout: timeout,
            lastPayloadId: payloadId
        };
    }, []);
    return {
        publishWithPostMessage: publishWithPostMessage,
        isWaitingForAck: isWaitingForAck
    };
};

});
parcelRegister("hY7Fx", function(module, exports) {
$parcel$export(module.exports, "usePublish", () => $2690236438c1272d$export$d55c81786220731c);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
const $2690236438c1272d$var$MAX_CONSUMED_EVENT_KEYS = 5000;
const $2690236438c1272d$var$ignoredTriggerLatestEvents = new Set([
    'editor-context-payload',
    'agent-changed',
    // Internal signals that must never overwrite the publish queue — they would
    // cause `triggerLatest` subscribers (e.g. PubSubListener) to replay them
    // instead of the real action event (e.g. open-browse-agent-modal) that
    // originally opened the chat.
    'smartlinks-subscription-changed',
    'smartlinks-context-payload'
]);
const $2690236438c1272d$var$isIgnoredForTriggerLatest = (type)=>{
    if ($2690236438c1272d$var$ignoredTriggerLatestEvents.has(type)) return true;
    return type === 'set-message-context' && (0, $3H4LK.fg)('rovo_chat_fix_cold_start_prompt_insertion');
};
const $2690236438c1272d$var$createPubSub = ()=>{
    let subscribedEvents = {};
    let publishQueue = {};
    let wildcardEvents = [];
    let consumedEventKeys = new Set();
    let consumedEventKeyQueue = [];
    let subIdCounter = 0;
    let eventIdCounter = 0;
    const generateSubId = ()=>{
        subIdCounter += 1;
        return subIdCounter.toString();
    };
    const createEvent = (payload)=>{
        eventIdCounter += 1;
        return {
            id: eventIdCounter.toString(),
            payload: payload
        };
    };
    const rememberConsumedEventKey = (claimKey)=>{
        consumedEventKeys.add(claimKey);
        consumedEventKeyQueue = [
            ...consumedEventKeyQueue,
            claimKey
        ];
        if (consumedEventKeyQueue.length > $2690236438c1272d$var$MAX_CONSUMED_EVENT_KEYS) {
            const [oldestClaimKey, ...remainingClaimKeys] = consumedEventKeyQueue;
            consumedEventKeyQueue = remainingClaimKeys;
            if (oldestClaimKey) consumedEventKeys.delete(oldestClaimKey);
        }
    };
    const claimConsumeOnceEvent = ({ event: event, consumeOnceKey: consumeOnceKey })=>{
        if (!event.payload.consumeOnce || !consumeOnceKey) return true;
        const claimKey = `${consumeOnceKey}:${event.id}`;
        if (consumedEventKeys.has(claimKey)) return false;
        rememberConsumedEventKey(claimKey);
        return true;
    };
    const subscribe = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
        const events = subscribedEvents[topic] ?? [];
        const subId = generateSubId();
        const subExists = events.some(({ id: id })=>id === subId);
        const callbackWithConsumption = (event)=>{
            if (!claimConsumeOnceEvent({
                event: event,
                consumeOnceKey: consumeOnceKey
            })) return;
            callback(event.payload);
        };
        // Push to Topic stack if not already there
        if (!subExists) {
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: [
                    ...events,
                    {
                        callback: callbackWithConsumption,
                        id: subId
                    }
                ]
            };
            // If this Topic already has a published event and `triggerLatest` is true, trigger the callback then clear the publishQueue for that Topic
            if (triggerLatest && !!publishQueue[topic]) {
                const event = publishQueue[topic];
                callbackWithConsumption(event);
                delete publishQueue[topic];
            }
        }
        return ()=>{
            // Remove from Topic stack
            subscribedEvents = {
                ...subscribedEvents,
                [topic]: (subscribedEvents[topic] || []).filter(({ id: id })=>id !== subId)
            };
        };
    };
    const subscribeAll = (callback)=>{
        const subId = wildcardEvents.length.toString();
        wildcardEvents = [
            ...wildcardEvents,
            {
                callback: callback,
                id: subId
            }
        ];
        return ()=>{
            wildcardEvents = wildcardEvents.filter(({ id: id })=>id !== subId);
        };
    };
    const publish = (topic, payload)=>{
        const event = createEvent(payload);
        /**
     * Log that this Topic received a published event, regardless of whether it has subscribers or not.
     * This ensures new subscribers can trigger their callback if `triggerLatest` is true, and the event hasn't already been triggered.
     */ // This `ignoredTriggerLatestEvents` is a quick fix to prevent triggering the latest event for certain events
        if (!$2690236438c1272d$var$isIgnoredForTriggerLatest(payload.type)) publishQueue[topic] = event;
        // Notify `subscribeAll` subscribers as they are Topic agnostic
        wildcardEvents.forEach(({ callback: callback })=>callback(event.payload));
        const topicSubs = subscribedEvents[topic] || [];
        // If there are no subscribers for this Topic, nothing to do.
        if (!topicSubs.length) return;
        // Notify all Topic subscribers of this event
        topicSubs.forEach(({ callback: callback })=>callback(event));
    };
    const flushQueue = ()=>{
        publishQueue = {};
    };
    return {
        subscribe: subscribe,
        subscribeAll: subscribeAll,
        publish: publish,
        flushQueue: flushQueue
    };
};
const $2690236438c1272d$var$pubSub = $2690236438c1272d$var$createPubSub();
const $2690236438c1272d$var$usePubSub = ()=>{
    return $2690236438c1272d$var$pubSub;
};
const $2690236438c1272d$export$d3d523392640272 = ({ topic: topic, triggerLatest: triggerLatest, consumeOnceKey: consumeOnceKey }, callback)=>{
    const { subscribe: subscribe } = $2690236438c1272d$var$usePubSub();
    const callbackRef = (0, $4fqPo.useRef)(callback);
    callbackRef.current = callback;
    (0, $4fqPo.useEffect)(()=>{
        const unsubscribe = subscribe({
            topic: topic,
            triggerLatest: triggerLatest,
            consumeOnceKey: consumeOnceKey
        }, (...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        topic,
        consumeOnceKey
    ]);
};
const $2690236438c1272d$export$2570c8aa24b6d327 = (callback)=>{
    const { subscribeAll: subscribeAll } = $2690236438c1272d$var$usePubSub();
    const callbackRef = (0, $4fqPo.useRef)(callback);
    callbackRef.current = callback;
    (0, $4fqPo.useEffect)(()=>{
        const unsubscribe = subscribeAll((...args)=>callbackRef.current(...args));
        return unsubscribe;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
};
const $2690236438c1272d$var$useFlushOnUnmount = (active = false)=>{
    const { flushQueue: flushQueue } = $2690236438c1272d$var$usePubSub();
    (0, $4fqPo.useLayoutEffect)(()=>{
        return ()=>{
            if (active) flushQueue();
        };
    }, [
        active,
        flushQueue
    ]);
};
const $2690236438c1272d$export$d55c81786220731c = (topic)=>{
    const { publish: publish } = $2690236438c1272d$var$usePubSub();
    const publishFn = (0, $4fqPo.useCallback)((payload)=>publish(topic, payload), [
        publish,
        topic
    ]);
    return publishFn;
};
const $2690236438c1272d$export$60959659b2c22881 = ({ topic: topic, triggerLatest: triggerLatest, onEvent: onEvent, flushQueueOnUnmount: flushQueueOnUnmount, consumeOnceKey: consumeOnceKey })=>{
    $2690236438c1272d$export$d3d523392640272({
        topic: topic,
        triggerLatest: triggerLatest,
        consumeOnceKey: consumeOnceKey
    }, onEvent);
    $2690236438c1272d$var$useFlushOnUnmount(flushQueueOnUnmount);
    return null;
};

});


parcelRegister("bjIO7", function(module, exports) {
$parcel$export(module.exports, "CONTENT_URL_SECURITY_AND_PERMISSIONS", () => $c0c37431817b9d0b$export$5c881701926acbef);
$parcel$export(module.exports, "CONTENT_URL_3P_ACCOUNT_AUTH", () => $c0c37431817b9d0b$export$93d67ab022d9f8d2);
$parcel$export(module.exports, "CONTENT_URL_AI", () => $c0c37431817b9d0b$export$70d24f0465ae60f8);
$parcel$export(module.exports, "CONTENT_URL_ROVO", () => $c0c37431817b9d0b$export$c36142a78ab570c5);
$parcel$export(module.exports, "CONTENT_URL_AI_TROUBLESHOOTING", () => $c0c37431817b9d0b$export$a3ed5c4e9d9599b7);
$parcel$export(module.exports, "CONTENT_URL_ACCEPTABLE_USE_POLICY", () => $c0c37431817b9d0b$export$73b198e73554a323);
$parcel$export(module.exports, "SmartLinkAlignment", () => $c0c37431817b9d0b$export$8910bf86027fe6be);
$parcel$export(module.exports, "SmartLinkDirection", () => $c0c37431817b9d0b$export$60831686b0574c86);
$parcel$export(module.exports, "SmartLinkPosition", () => $c0c37431817b9d0b$export$d58e6377644d1dcf);
$parcel$export(module.exports, "SmartLinkSize", () => $c0c37431817b9d0b$export$51f13ced115cbdae);
$parcel$export(module.exports, "SmartLinkStatus", () => $c0c37431817b9d0b$export$61cff06be26816f);
$parcel$export(module.exports, "SmartLinkTheme", () => $c0c37431817b9d0b$export$aed0f1e801ad691f);
$parcel$export(module.exports, "SmartLinkInternalTheme", () => $c0c37431817b9d0b$export$9aafec380d7005da);
$parcel$export(module.exports, "SmartLinkWidth", () => $c0c37431817b9d0b$export$19c60054ee783de6);
$parcel$export(module.exports, "ElementName", () => $c0c37431817b9d0b$export$d65b168331104a46);
$parcel$export(module.exports, "ActionName", () => $c0c37431817b9d0b$export$9c95d6e1614bad84);
$parcel$export(module.exports, "InternalActionName", () => $c0c37431817b9d0b$export$4871a84b35cf8eb9);
$parcel$export(module.exports, "IconType", () => $c0c37431817b9d0b$export$13ff1290a9e22e77);
$parcel$export(module.exports, "MediaType", () => $c0c37431817b9d0b$export$483c11740a902fcd);
$parcel$export(module.exports, "MediaPlacement", () => $c0c37431817b9d0b$export$f9f4737e25ab90fa);
$parcel$export(module.exports, "CardAction", () => $c0c37431817b9d0b$export$f40b7e0b762b928b);
$parcel$export(module.exports, "CardDisplay", () => $c0c37431817b9d0b$export$6ca4ef8b3dc2c804);
const $c0c37431817b9d0b$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $c0c37431817b9d0b$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $c0c37431817b9d0b$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $c0c37431817b9d0b$export$c36142a78ab570c5 = 'https://www.atlassian.com/trust/ai';
const $c0c37431817b9d0b$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $c0c37431817b9d0b$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $c0c37431817b9d0b$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $c0c37431817b9d0b$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $c0c37431817b9d0b$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $c0c37431817b9d0b$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $c0c37431817b9d0b$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $c0c37431817b9d0b$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $c0c37431817b9d0b$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $c0c37431817b9d0b$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $c0c37431817b9d0b$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $c0c37431817b9d0b$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    ActionName["RovoChatAction"] = "RovoChatAction";
    return ActionName;
}({});
var $c0c37431817b9d0b$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $c0c37431817b9d0b$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $c0c37431817b9d0b$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $c0c37431817b9d0b$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $c0c37431817b9d0b$export$f40b7e0b762b928b = /*#__PURE__*/ function(CardAction) {
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["RovoChatAction"] = "RovoChatAction";
    CardAction["ViewAction"] = "ViewAction";
    return CardAction;
}({});
var $c0c37431817b9d0b$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});

});

parcelRegister("igKiU", function(module, exports) {
$parcel$export(module.exports, "isSpecialEvent", () => $a24324061dc8e74e$export$efca2c4705678489);
$parcel$export(module.exports, "isSpecialKey", () => $a24324061dc8e74e$export$d8de0cd37d316fdf);
$parcel$export(module.exports, "isSpecialClick", () => $a24324061dc8e74e$export$5b1771037ab7c451);
$parcel$export(module.exports, "getIconForFileType", () => $a24324061dc8e74e$export$4d685c85ebc7a1e3);
$parcel$export(module.exports, "getLazyIcons", () => $a24324061dc8e74e$export$92d31eb5326761b6);
$parcel$export(module.exports, "getIframeSandboxAttribute", () => $a24324061dc8e74e$export$9b7e6a102056a387);
$parcel$export(module.exports, "handleOnClick", () => $a24324061dc8e74e$export$ffccab2ae3d093ef);
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $a24324061dc8e74e$export$6c837641a9ab03cb);
$parcel$export(module.exports, "importWithRetry", () => $a24324061dc8e74e$export$aacbf48ace518c5a);
$parcel$export(module.exports, "downloadUrl", () => $a24324061dc8e74e$export$8a96edb1c96563f4);
$parcel$export(module.exports, "openUrl", () => $a24324061dc8e74e$export$a238cfe4a10e6279);
$parcel$export(module.exports, "getPreviewUrlWithTheme", () => $a24324061dc8e74e$export$4470f298c61a79da);
$parcel$export(module.exports, "isIconSizeLarge", () => $a24324061dc8e74e$export$d2b8fb9e780e17e7);
$parcel$export(module.exports, "isProfileType", () => $a24324061dc8e74e$export$6a4545d6b336c401);
$parcel$export(module.exports, "noop", () => $a24324061dc8e74e$export$8793edee2d425525);

var $4fqPo = parcelRequire("4fqPo");

var $jk6Pl = parcelRequire("jk6Pl");

var $3H4LK = parcelRequire("3H4LK");

var $19LYE = parcelRequire("19LYE");

var $bjIO7 = parcelRequire("bjIO7");

var $45Nst = parcelRequire("45Nst");
const $a24324061dc8e74e$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ($a24324061dc8e74e$export$e6c5ffa684aac4d7() || $a24324061dc8e74e$export$d8de0cd37d316fdf(evt) || $a24324061dc8e74e$export$5b1771037ab7c451(evt));
const $a24324061dc8e74e$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;
const $a24324061dc8e74e$export$d8de0cd37d316fdf = (event)=>{
    return (0, $3H4LK.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};
const $a24324061dc8e74e$export$5b1771037ab7c451 = (event)=>event.button === 1;
const $a24324061dc8e74e$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    let icon = $a24324061dc8e74e$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    if ((0, $3H4LK.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || ''; // NAVX-4354: Combine into const [importCb] = icon; above
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
























































































const $a24324061dc8e74e$export$92d31eb5326761b6 = ()=>{
    return {
        // IconTile wrappers (@atlaskit/icon/core/* wrapped in <IconTile> with color)
        [(0, $bjIO7.IconType).Document]: {
            default: ()=>(parcelRequire("5ZDYd"))
        },
        [(0, $bjIO7.IconType).Audio]: {
            default: ()=>(parcelRequire("icHzD"))
        },
        [(0, $bjIO7.IconType).Code]: {
            default: ()=>(parcelRequire("lgItD"))
        },
        [(0, $bjIO7.IconType).File]: {
            default: ()=>(parcelRequire("egVEX"))
        },
        [(0, $bjIO7.IconType).Folder]: {
            default: ()=>(parcelRequire("5lgpe"))
        },
        [(0, $bjIO7.IconType).Generic]: {
            default: ()=>(parcelRequire("egVEX"))
        },
        [(0, $bjIO7.IconType).Image]: {
            default: ()=>(parcelRequire("iVwfb"))
        },
        [(0, $bjIO7.IconType).Presentation]: {
            default: ()=>(parcelRequire("dUEum"))
        },
        [(0, $bjIO7.IconType).Spreadsheet]: {
            default: ()=>(parcelRequire("3zYnp"))
        },
        [(0, $bjIO7.IconType).Video]: {
            default: ()=>(parcelRequire("2anlg"))
        },
        // @atlaskit/icon/core/* (plain monochrome icons)
        [(0, $bjIO7.IconType).Project]: {
            default: ()=>(parcelRequire("5Svu6"))
        },
        [(0, $bjIO7.IconType).Template]: {
            default: ()=>(parcelRequire("8w0z5"))
        },
        [(0, $bjIO7.IconType).Forbidden]: {
            default: ()=>(parcelRequire("e4EE0"))
        },
        [(0, $bjIO7.IconType).Default]: {
            default: ()=>Promise.resolve((parcelRequire("6SePM")))
        },
        [(0, $bjIO7.IconType).Error]: {
            default: ()=>Promise.resolve((parcelRequire("geWWn")))
        },
        // @atlaskit/icon/core/* (badge icons)
        [(0, $bjIO7.IconType).Attachment]: {
            default: ()=>(parcelRequire("2bujp"))
        },
        [(0, $bjIO7.IconType).CheckItem]: {
            default: ()=>(parcelRequire("ceZLP"))
        },
        [(0, $bjIO7.IconType).Component]: {
            default: ()=>(parcelRequire("i7pQh"))
        },
        [(0, $bjIO7.IconType).Comment]: {
            default: ()=>Promise.resolve((parcelRequire("fmxZJ")))
        },
        [(0, $bjIO7.IconType).View]: {
            default: ()=>Promise.resolve((parcelRequire("dO3eH")))
        },
        [(0, $bjIO7.IconType).React]: {
            default: ()=>(parcelRequire("3oCsr"))
        },
        [(0, $bjIO7.IconType).Vote]: {
            default: ()=>Promise.resolve((parcelRequire("cf3Ro")))
        },
        [(0, $bjIO7.IconType).PriorityUndefined]: {
            default: ()=>Promise.resolve((parcelRequire("kLLw5")))
        },
        [(0, $bjIO7.IconType).ProgrammingLanguage]: {
            default: ()=>(parcelRequire("5q1Oa"))
        },
        [(0, $bjIO7.IconType).Subscriber]: {
            default: ()=>(parcelRequire("5Svu6"))
        },
        [(0, $bjIO7.IconType).SubTasksProgress]: {
            default: ()=>(parcelRequire("5iE8p"))
        },
        // @atlaskit/icon-file-type/glyph/* (file type icons with 16/24 size variants)
        [(0, $bjIO7.IconType).Archive]: {
            default: ()=>(parcelRequire("1JAAo")),
            large: ()=>(parcelRequire("g7lEx"))
        },
        [(0, $bjIO7.IconType).Executable]: {
            default: ()=>(parcelRequire("eaLZB")),
            large: ()=>Promise.resolve((parcelRequire("cgueQ")))
        },
        [(0, $bjIO7.IconType).GIF]: {
            default: ()=>(parcelRequire("eXP74")),
            large: ()=>Promise.resolve((parcelRequire("b65bV")))
        },
        [(0, $bjIO7.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("jzVjz")),
            large: ()=>Promise.resolve((parcelRequire("45le2")))
        },
        [(0, $bjIO7.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("8vS9B")),
            large: ()=>Promise.resolve((parcelRequire("26k2s")))
        },
        [(0, $bjIO7.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("atZZL")),
            large: ()=>Promise.resolve((parcelRequire("3Gf6m")))
        },
        [(0, $bjIO7.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hWqTj")),
            large: ()=>Promise.resolve((parcelRequire("1e2Z3")))
        },
        [(0, $bjIO7.IconType).MSExcel]: {
            default: ()=>(parcelRequire("3rzat")),
            large: ()=>Promise.resolve((parcelRequire("sUYLF")))
        },
        [(0, $bjIO7.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("elUGu")),
            large: ()=>Promise.resolve((parcelRequire("iy9ZB")))
        },
        [(0, $bjIO7.IconType).MSWord]: {
            default: ()=>(parcelRequire("kEc81")),
            large: ()=>Promise.resolve((parcelRequire("cKwxD")))
        },
        [(0, $bjIO7.IconType).PDF]: {
            default: ()=>(parcelRequire("g6Jde")),
            large: ()=>Promise.resolve((parcelRequire("iud6e")))
        },
        [(0, $bjIO7.IconType).Sketch]: {
            default: ()=>(parcelRequire("lMew0")),
            large: ()=>Promise.resolve((parcelRequire("aHBFf")))
        },
        // Keep blog/live-document out of the lazy map on purpose.
        // These icons should be present in SSR markup so hydration does not cause
        // a visible empty-state-then-pop-in transition in Smart Link consumers.
        [(0, $bjIO7.IconType).Branch]: {
            default: ()=>(parcelRequire("2emIj")),
            large: ()=>(parcelRequire("e8RtS")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Commit]: {
            default: ()=>(parcelRequire("gxhHW")),
            large: ()=>(parcelRequire("9kd32")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).PullRequest]: {
            default: ()=>(parcelRequire("iPQSU")),
            large: ()=>(parcelRequire("bZ2tR")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Repo]: {
            default: ()=>(parcelRequire("bKThA")),
            large: ()=>(parcelRequire("i3fur")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Bug]: {
            default: ()=>(parcelRequire("3T7Zd")),
            large: ()=>(parcelRequire("4ppKC")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Change]: {
            default: ()=>(parcelRequire("g85Yx")),
            large: ()=>(parcelRequire("i9YT2")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Epic]: {
            default: ()=>(parcelRequire("b8QXm")),
            large: ()=>(parcelRequire("9nIMK")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Incident]: {
            default: ()=>(parcelRequire("klCgN")),
            large: ()=>(parcelRequire("lTyNH")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Problem]: {
            default: ()=>(parcelRequire("aO3bo")),
            large: ()=>(parcelRequire("3ZiCy")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).ServiceRequest]: {
            default: ()=>(parcelRequire("YccdC")),
            large: ()=>(parcelRequire("9DAFt")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Story]: {
            default: ()=>(parcelRequire("cUgLS")),
            large: ()=>(parcelRequire("di33d")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).SubTask]: {
            default: ()=>(parcelRequire("dslMo")),
            large: ()=>(parcelRequire("3GvOQ")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        [(0, $bjIO7.IconType).Task]: {
            default: ()=>(parcelRequire("2zsrl")),
            large: ()=>(parcelRequire("cZHYQ")).then((module)=>({
                        default: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(module.default, {
                                ...props,
                                size: "small"
                            })
                    }))
        },
        // @atlaskit/logo/* (product logos)
        [(0, $bjIO7.IconType).Confluence]: {
            default: ()=>Promise.resolve((parcelRequire("l59Pd"))).then(({ ConfluenceIcon: ConfluenceIcon })=>({
                        default: ConfluenceIcon
                    }))
        },
        [(0, $bjIO7.IconType).Jira]: {
            default: ()=>(parcelRequire("fQ0Fn")).then(({ JiraIcon: JiraIcon })=>({
                        default: JiraIcon
                    }))
        },
        // Local priority icons (custom SVG components)
        [(0, $bjIO7.IconType).PriorityBlocker]: {
            default: ()=>(parcelRequire("hHn9R"))
        },
        [(0, $bjIO7.IconType).PriorityCritical]: {
            default: ()=>(parcelRequire("jeHgm"))
        },
        [(0, $bjIO7.IconType).PriorityHigh]: {
            default: ()=>(parcelRequire("iRwxH"))
        },
        [(0, $bjIO7.IconType).PriorityHighest]: {
            default: ()=>(parcelRequire("8to1x"))
        },
        [(0, $bjIO7.IconType).PriorityLow]: {
            default: ()=>(parcelRequire("iIYnH"))
        },
        [(0, $bjIO7.IconType).PriorityLowest]: {
            default: ()=>(parcelRequire("hYpp3"))
        },
        [(0, $bjIO7.IconType).PriorityMajor]: {
            default: ()=>(parcelRequire("ey0JO"))
        },
        [(0, $bjIO7.IconType).PriorityMedium]: {
            default: ()=>(parcelRequire("lHqd0"))
        },
        [(0, $bjIO7.IconType).PriorityMinor]: {
            default: ()=>(parcelRequire("j9bwv"))
        },
        [(0, $bjIO7.IconType).PriorityTrivial]: {
            default: ()=>(parcelRequire("cOLKu"))
        }
    };
};
const $a24324061dc8e74e$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $45Nst.default)(fileFormat);
    if (!(iconDescriptor !== null && iconDescriptor !== void 0 && iconDescriptor.icon)) return null;
    const lazyIcons = $a24324061dc8e74e$export$92d31eb5326761b6();
    if ((0, $3H4LK.fg)('platform_navx_smart_link_icon_label_a11y')) {
        var _lazyIcons$iconDescri;
        return [
            (_lazyIcons$iconDescri = lazyIcons[iconDescriptor.icon]) === null || _lazyIcons$iconDescri === void 0 ? void 0 : _lazyIcons$iconDescri.default,
            iconDescriptor.label ?? ''
        ];
    } else {
        var _lazyIcons$iconDescri2;
        return [
            (_lazyIcons$iconDescri2 = lazyIcons[iconDescriptor.icon]) === null || _lazyIcons$iconDescri2 === void 0 ? void 0 : _lazyIcons$iconDescri2.default
        ];
    }
};
const $a24324061dc8e74e$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
const $a24324061dc8e74e$export$ffccab2ae3d093ef = (handler)=>(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handler();
    };
const $a24324061dc8e74e$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';
const $a24324061dc8e74e$export$e772c8ff12451969 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $a24324061dc8e74e$export$aacbf48ace518c5a = async (importFn, retries = 2, interval = 500)=>{
    try {
        return await importFn();
    } catch (error) {
        if (error.name === 'ChunkLoadError' && retries > 0) {
            await $a24324061dc8e74e$export$e772c8ff12451969(interval);
            return $a24324061dc8e74e$export$aacbf48ace518c5a(importFn, retries - 1, interval);
        } else throw error;
    }
};
const $a24324061dc8e74e$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const $a24324061dc8e74e$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};
const $a24324061dc8e74e$export$4470f298c61a79da = (previewUrl, themeState)=>{
    try {
        const url = new URL(previewUrl);
        url.searchParams.append('themeState', (0, $19LYE.themeObjectToString)(themeState));
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $a24324061dc8e74e$export$d2b8fb9e780e17e7 = (size)=>size && [
        (0, $bjIO7.SmartLinkSize).Large,
        (0, $bjIO7.SmartLinkSize).XLarge
    ].includes(size);
const $a24324061dc8e74e$export$6a4545d6b336c401 = (type)=>!!(type && type.includes('Profile'));
const $a24324061dc8e74e$export$8793edee2d425525 = ()=>undefined;

});
parcelRegister("45Nst", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e62b095eb983d4d$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $bjIO7 = parcelRequire("bjIO7");
const $2e62b095eb983d4d$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $3H4LK.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return getIconDescriptor((0, $bjIO7.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $bjIO7.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $bjIO7.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $bjIO7.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $bjIO7.IconType).Spreadsheet, 'spreadsheet');
        // Google Drive
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $bjIO7.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $bjIO7.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $bjIO7.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $bjIO7.IconType).GoogleSlides, 'google slide');
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $bjIO7.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $bjIO7.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $bjIO7.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $bjIO7.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $bjIO7.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $bjIO7.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $bjIO7.IconType).Video, 'video');
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $bjIO7.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $bjIO7.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $bjIO7.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $bjIO7.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
            return getIconDescriptor((0, $bjIO7.IconType).Generic, 'file');
        case 'application/invision.prototype':
            return getIconDescriptor((0, $bjIO7.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $2e62b095eb983d4d$export$2e2bcd8739ae039 = $2e62b095eb983d4d$var$extractFileFormatIcon;

});

parcelRegister("5ZDYd", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fG06h").then(()=>parcelRequire('43GHM'));

});

parcelRegister("icHzD", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("aOHBz").then(()=>parcelRequire('f65aV'));

});

parcelRegister("lgItD", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("55cCr"),
    $e46AW("3aaFR")
]).then(()=>parcelRequire('lSKr1'));

});

parcelRegister("egVEX", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("ciaTj").then(()=>parcelRequire('jp3V1'));

});

parcelRegister("5lgpe", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("khIAp").then(()=>parcelRequire('4XjGI'));

});

parcelRegister("iVwfb", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fXOMh").then(()=>parcelRequire('32woJ'));

});

parcelRegister("dUEum", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("cOm2H").then(()=>parcelRequire('eGEtI'));

});

parcelRegister("3zYnp", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7LczY").then(()=>parcelRequire('k8O49'));

});

parcelRegister("2anlg", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fufFI").then(()=>parcelRequire('9EtDy'));

});

parcelRegister("5Svu6", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("83e22").then(()=>parcelRequire('eDUjR'));

});

parcelRegister("8w0z5", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4biYi").then(()=>parcelRequire('9XU79'));

});

parcelRegister("e4EE0", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("3vgBs").then(()=>parcelRequire('3NIi1'));

});

parcelRegister("2bujp", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("3JJAU").then(()=>parcelRequire('7Izyt'));

});

parcelRegister("ceZLP", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("5lIrP").then(()=>parcelRequire('8rivj'));

});

parcelRegister("i7pQh", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4sv3G").then(()=>parcelRequire('hD4KT'));

});

parcelRegister("3oCsr", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("2dP4h").then(()=>parcelRequire('9Y8dl'));

});

parcelRegister("cf3Ro", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e99e14c8b447540$var$_react = $8e99e14c8b447540$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $8e99e14c8b447540$var$_baseNew = $8e99e14c8b447540$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $8e99e14c8b447540$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e99e14c8b447540$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $8e99e14c8b447540$var$_react.default.createElement($8e99e14c8b447540$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$8e99e14c8b447540$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $8e99e14c8b447540$var$_default = module.exports.default = $8e99e14c8b447540$var$ArrowUpIcon;

});

parcelRegister("5q1Oa", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("55cCr").then(()=>parcelRequire('aFwoK'));

});

parcelRegister("5iE8p", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("7XFFI").then(()=>parcelRequire('Tb8q1'));

});

parcelRegister("1JAAo", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("awglf").then(()=>parcelRequire('anpFP'));

});

parcelRegister("g7lEx", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gUXXw").then(()=>parcelRequire('hjttB'));

});

parcelRegister("eaLZB", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9kjnU").then(()=>parcelRequire('aNPbB'));

});

parcelRegister("eXP74", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("26Bsm").then(()=>parcelRequire('Tq24d'));

});

parcelRegister("jzVjz", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("fjHzU").then(()=>parcelRequire('8BzOu'));

});

parcelRegister("8vS9B", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("crzQE").then(()=>parcelRequire('4GBur'));

});

parcelRegister("atZZL", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1J5dh").then(()=>parcelRequire('hJd6A'));

});

parcelRegister("hWqTj", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("d5ZbN").then(()=>parcelRequire('4km98'));

});

parcelRegister("3rzat", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("iSq7B").then(()=>parcelRequire('cGMN2'));

});

parcelRegister("elUGu", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bFOCe").then(()=>parcelRequire('5Nh34'));

});

parcelRegister("kEc81", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("aLLhO").then(()=>parcelRequire('6dZYJ'));

});

parcelRegister("g6Jde", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4cxH6").then(()=>parcelRequire('4kTWh'));

});

parcelRegister("lMew0", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bgXnm").then(()=>parcelRequire('SXIeQ'));

});

parcelRegister("2emIj", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bvhV0").then(()=>parcelRequire('goCBS'));

});

parcelRegister("e8RtS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("4OnzC"),
    $e46AW("fxoOs")
]).then(()=>parcelRequire('1w97m'));

});

parcelRegister("gxhHW", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("476T1").then(()=>parcelRequire('eOk1Y'));

});

parcelRegister("9kd32", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("lwKlt"),
    $e46AW("k3SUA")
]).then(()=>parcelRequire('doVkD'));

});

parcelRegister("iPQSU", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("dA0JF").then(()=>parcelRequire('elLtF'));

});

parcelRegister("bZ2tR", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("lfS7q"),
    $e46AW("9Kw95")
]).then(()=>parcelRequire('ihy0N'));

});

parcelRegister("bKThA", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4yIAv").then(()=>parcelRequire('glurT'));

});

parcelRegister("i3fur", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("55cCr"),
    $e46AW("lOvF3")
]).then(()=>parcelRequire('ekcJu'));

});

parcelRegister("3T7Zd", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("5WiAu").then(()=>parcelRequire('aUPuE'));

});

parcelRegister("4ppKC", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("lH74q"),
    $e46AW("5lElG")
]).then(()=>parcelRequire('14y1Q'));

});

parcelRegister("g85Yx", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4FIm0").then(()=>parcelRequire('i7cdf'));

});

parcelRegister("i9YT2", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("ajGT4"),
    $e46AW("eRPTm")
]).then(()=>parcelRequire('eC5Gc'));

});

parcelRegister("b8QXm", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("do8NJ").then(()=>parcelRequire('7B3Z4'));

});

parcelRegister("9nIMK", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("arTJv"),
    $e46AW("iMbPB")
]).then(()=>parcelRequire('eYyjp'));

});

parcelRegister("klCgN", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gQTdR").then(()=>parcelRequire('3z0Px'));

});

parcelRegister("lTyNH", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("eT6SQ"),
    $e46AW("2ZGfQ")
]).then(()=>parcelRequire('1lm00'));

});

parcelRegister("aO3bo", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("6c3I1").then(()=>parcelRequire('dLHUR'));

});

parcelRegister("3ZiCy", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5GKhl"),
    $e46AW("hCb2y")
]).then(()=>parcelRequire('aKlVO'));

});

parcelRegister("YccdC", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bXVvO").then(()=>parcelRequire('7bGQL'));

});

parcelRegister("9DAFt", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8hPW6").then(()=>parcelRequire('5l83B'));

});

parcelRegister("cUgLS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("4BQhG").then(()=>parcelRequire('36EYa'));

});

parcelRegister("di33d", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("gbFue"),
    $e46AW("dADJX")
]).then(()=>parcelRequire('bclzk'));

});

parcelRegister("dslMo", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gb66x").then(()=>parcelRequire('g6i3a'));

});

parcelRegister("3GvOQ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("7XFFI"),
    $e46AW("3ewqG")
]).then(()=>parcelRequire('jQDnJ'));

});

parcelRegister("2zsrl", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("cyycD").then(()=>parcelRequire('5Fn7v'));

});

parcelRegister("cZHYQ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("5lIrP"),
    $e46AW("6mXhx")
]).then(()=>parcelRequire('jWGi1'));

});

parcelRegister("fQ0Fn", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("iBDpP").then(()=>parcelRequire('5kizu'));

});

parcelRegister("hHn9R", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lzKvy").then(()=>parcelRequire('6ZTk5'));

});

parcelRegister("jeHgm", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9gSHc").then(()=>parcelRequire('lDuYY'));

});

parcelRegister("iRwxH", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("gEqxu").then(()=>parcelRequire('2i39B'));

});

parcelRegister("8to1x", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("c6YQf").then(()=>parcelRequire('lsSzD'));

});

parcelRegister("iIYnH", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("isn7i").then(()=>parcelRequire('i7gnt'));

});

parcelRegister("hYpp3", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8hulO").then(()=>parcelRequire('e9KQu'));

});

parcelRegister("ey0JO", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("faXRz").then(()=>parcelRequire('cotbl'));

});

parcelRegister("lHqd0", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("dcmPU").then(()=>parcelRequire('hsauN'));

});

parcelRegister("j9bwv", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("6pbXb").then(()=>parcelRequire('aojpe'));

});

parcelRegister("cOLKu", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("e6E2Q").then(()=>parcelRequire('5v63w'));

});


parcelRegister("4Wmbl", function(module, exports) {
$parcel$export(module.exports, "getIsRovoChatEnabled", () => $2a413c8bb19f985f$export$e9a534e68169723d);
const $2a413c8bb19f985f$export$e9a534e68169723d = (rovoConfig)=>rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoEnabled && rovoConfig !== null && rovoConfig !== void 0 && rovoConfig.isRovoLLMEnabled ? true : false;

});

parcelRegister("feSIj", function(module, exports) {
$parcel$export(module.exports, "startUfoExperience", () => $21b092551b4cf618$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $21b092551b4cf618$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $21b092551b4cf618$export$8dda83bafca11b77);
$parcel$export(module.exports, "addMetadataToExperience", () => $21b092551b4cf618$export$4084c0df4a03a6af);

var $exG7B = parcelRequire("exG7B");
var $fF3Qb = parcelRequire("fF3Qb");
const $21b092551b4cf618$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $fF3Qb.ExperienceTypes).Experience,
    performanceType: (0, $fF3Qb.ExperiencePerformanceTypes).InlineResult
};
const $21b092551b4cf618$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $fF3Qb.ExperienceTypes).Load,
    performanceType: (0, $fF3Qb.ExperiencePerformanceTypes).PageSegmentLoad
};
const $21b092551b4cf618$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $fF3Qb.ExperienceTypes).Experience,
    performanceType: (0, $fF3Qb.ExperiencePerformanceTypes).InlineResult
};
const $21b092551b4cf618$var$ufoExperiences = {
    'smart-link-rendered': new (0, $exG7B.ConcurrentExperience)('smart-link-rendered', $21b092551b4cf618$var$renderExperience),
    'smart-link-authenticated': new (0, $exG7B.ConcurrentExperience)('smart-link-authenticated', $21b092551b4cf618$var$inlineExperience),
    'smart-link-action-invocation': new (0, $exG7B.ConcurrentExperience)('smart-link-action-invocation', $21b092551b4cf618$var$inlineExperience),
    'smart-link-ai-summary': new (0, $exG7B.ConcurrentExperience)('smart-link-ai-summary', $21b092551b4cf618$var$aiExperience)
};
const $21b092551b4cf618$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $21b092551b4cf618$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $21b092551b4cf618$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $21b092551b4cf618$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $21b092551b4cf618$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $21b092551b4cf618$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $21b092551b4cf618$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $21b092551b4cf618$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};

});

parcelRegister("eiylg", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc7c54b8df589881$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $aCmbs = parcelRequire("aCmbs");

var $9wX56 = parcelRequire("9wX56");

var $hs0RG = parcelRequire("hs0RG");
const $bc7c54b8df589881$var$FLAG_ICON_SIZE = '16px';
const $bc7c54b8df589881$var$renderIcon = (iconUrlOrElement)=>{
    if (!iconUrlOrElement) return;
    const icon = iconUrlOrElement && typeof iconUrlOrElement === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9wX56.default), {
        height: $bc7c54b8df589881$var$FLAG_ICON_SIZE,
        testId: "sl-flag",
        url: iconUrlOrElement,
        width: $bc7c54b8df589881$var$FLAG_ICON_SIZE
    }) : iconUrlOrElement;
    return icon;
};
// Safe wrapper — returns null if IntlProvider is not in the tree
const $bc7c54b8df589881$var$useIntlSafe = ()=>{
    try {
        return (0, $4MCQn.default)();
    } catch  {
        return null;
    }
};
const $bc7c54b8df589881$var$useActionFlags = ()=>{
    const intl = $bc7c54b8df589881$var$useIntlSafe();
    const showConnectFlag = (0, $4fqPo.useCallback)(({ provider: provider, ...flagArgs } = {})=>{
        if (!intl) return;
        const context = (provider === null || provider === void 0 ? void 0 : provider.text) ?? intl.formatMessage((0, $aCmbs.messages).connect_link_account_success_flag_title_default);
        (0, $hs0RG.showFlag)({
            icon: $bc7c54b8df589881$var$renderIcon(provider === null || provider === void 0 ? void 0 : provider.icon),
            title: intl.formatMessage((0, $aCmbs.messages).connect_link_account_success_flag_title, {
                context: context
            }),
            description: intl.formatMessage((0, $aCmbs.messages).connect_link_account_success_flag_description),
            ...flagArgs
        });
    }, [
        intl
    ]);
    return (0, $4fqPo.useMemo)(()=>({
            showConnectFlag: showConnectFlag
        }), [
        showConnectFlag
    ]);
};
var $bc7c54b8df589881$export$2e2bcd8739ae039 = $bc7c54b8df589881$var$useActionFlags;

});
parcelRegister("aCmbs", function(module, exports) {
$parcel$export(module.exports, "messages", () => $9b61fb0f4399b171$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $9b61fb0f4399b171$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: 'Title for a section or menu containing available actions for a resource.'
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Button label that allows the user to add and connect a new external account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_generic_rebrand: {
        id: 'fabric.linking.ai_summary_error_generic_rebrand',
        defaultMessage: "Rovo isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    change_status: {
        id: 'fabric.linking.change_status',
        defaultMessage: 'Change status: {status}',
        description: 'Aria label for the button to change the status of a linked resource.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'Cancel the current action or close the modal.'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Text shown in a lozenge badge on a smart link or card to indicate the feature is currently in beta.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: 'Label for a button or icon that closes the currently open modal dialog or overlay screen.'
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Heading shown at the top of the link safety warning modal, prompting the user to verify a potentially unsafe link before proceeding.'
    },
    compass_applied_components_count: {
        id: 'compass.applied_components_count.non-final',
        defaultMessage: 'Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}',
        description: 'Indicates the number of components the resource is applied to.'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_link_account_success_flag_description: {
        id: 'fabric.linking.connect_link_account_success_flag_description.non-final',
        defaultMessage: 'Shared links now display rich previews.',
        description: 'Shown in a flag after user successfully connect 3P account and Smart Link reload with metadata'
    },
    connect_link_account_success_flag_title: {
        id: 'fabric.linking.connect_link_account_success_flag_title.non-final',
        defaultMessage: '{context} is connected',
        description: 'Shown in a flag after user successfully connect 3P account. {context} is the name of link provider, e.g. Google, Figma, etc.'
    },
    connect_link_account_success_flag_title_default: {
        id: 'fabric.linking.connect_link_account_success_flag_title_default.non-final',
        defaultMessage: 'Smart Link',
        description: 'Default context for connect_link_account_success_flag_title when link provider name (Google, Figma, etc.) is not provided'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_inline_social_proof: {
        id: 'fabric.linking.connect_inline_social_proof',
        defaultMessage: 'Connect',
        description: 'Shown on a button for unauthorised inline smart links when the social proof inline CTA experiment is active. Replaces the longer "Connect your {context} account" label.'
    },
    social_proof_inline_cta_tag_high_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_with_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees {context} previews',
        description: 'Social-proof tag pill beside the shortcut "Connect" on an unauthorised inline smart link when adoption is not in the exploratory range. {connectedPct} is the approximate share seeing previews for the integration; {context} is the provider display name.'
    },
    social_proof_inline_cta_tag_high_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_high_no_context',
        defaultMessage: '<b>{connectedPct}%</b> of your team sees richer previews',
        description: 'Social-proof tag pill when adoption is above the exploratory threshold and no provider display name is available; {connectedPct} is the approximate share seeing richer previews.'
    },
    social_proof_inline_cta_tag_low_with_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_with_context',
        defaultMessage: 'Your team sees richer {context} previews',
        description: 'Social-proof tag pill when share is below the percentage headline threshold; shown only when a provider display name is available. Omit the pill entirely when personalization is unavailable or the provider name is unknown.'
    },
    social_proof_inline_cta_tag_low_no_context: {
        id: 'fabric.linking.social_proof_inline_cta_tag_low_no_context',
        defaultMessage: 'Your team sees richer previews',
        description: 'Social-proof tag pill for the case when neither percentage nor provider display name are available.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'Label for a button that advances the user to the next step, e.g. in the link safety warning modal flow.'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: 'Action to copy the URL of the link to the clipboard.'
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Confirmation text shown briefly after the user copies a URL to the clipboard using the copy link action.'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Label for the delete action in a smart link or card action menu, allowing the user to remove the linked item.'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: 'Label for the download action in a smart link or card action menu, initiating a file download.'
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: "Tooltip or description text for the download action, explaining it saves the file to the user's local storage."
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Label for the download file action in a smart link or card action menu, allowing the user to save the linked file locally.'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Label for the AI summarize action in a smart link or hover card action menu, allowing the user to generate an AI summary of the linked content.'
    },
    ai_summary_action_rebrand: {
        id: 'fabric.linking.ai_summary_action_rebrand',
        defaultMessage: 'Summarize with Rovo',
        description: 'Label for the AI summarize action in a smart link or hover card action menu, allowing the user to generate an AI summary of the linked content.'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    ai_summary_action_description_rebrand: {
        id: 'fabric.linking.ai_summary_action_description_rebrand',
        defaultMessage: 'Summarize the content of this link using Rovo.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Label for the edit action in a smart link or card action menu, allowing the user to modify the linked item.'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Label for the follow button on a smart link card, allowing the user to subscribe to updates for the linked project or resource.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Tooltip or description text for the follow project button, explaining that clicking it enables notifications for the project.'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Label for the follow project button on a smart link card, allowing the user to subscribe to updates for the linked Atlassian project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Tooltip or description text for the follow goal button, explaining that clicking it enables notifications for updates to the goal.'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Label for the follow goal button on a smart link card, allowing the user to subscribe to updates for the linked Atlas goal.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'Label for a navigation button that returns the user to the previous step or screen in a modal flow.'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira issue in Jira.'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Label for the action button on a smart link card that opens the linked resource in a new browser tab.'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    owned_by_override: {
        id: 'fabric.linking.owned_by_override',
        defaultMessage: 'By {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Tooltip or description text for the preview action on a smart link card, explaining it opens a full-screen embed preview of the linked content.'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_modal: {
        id: 'fabric.linking.preview_modal',
        defaultMessage: 'Open preview modal',
        description: 'Button used to view a modal view of your content without needing to navigate to it.'
    },
    preview_panel: {
        id: 'fabric.linking.preview_panel',
        defaultMessage: 'Open preview panel',
        description: 'Button used to view a side panel view of your content without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Label for the button that closes the embed preview modal dialog on a smart link card.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Blocker priority.'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Critical priority.'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has High priority.'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Highest priority.'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Low priority.'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Lowest priority.'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Major priority.'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Medium priority.'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Minor priority.'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Label for a priority badge on a Jira issue smart link card indicating the issue has Trivial priority.'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Label for a priority badge on a Jira issue smart link card when the priority level is not defined or unknown.'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Text shown on a smart link card displaying the estimated reading time. The placeholder {context} is substituted with the number of minutes.'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Label for a retry button shown on a smart link card after an error, allowing the user to attempt the failed action again.'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: "Label for a save button on a smart link card or action, confirming and persisting the user's changes."
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Label for a button shown on a smart link error state, prompting the user to retry the failed load or action.'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Warning message shown in the link safety modal. The placeholder {unsafeLinkText} is substituted with the suspicious link text, and <a> wraps the actual destination URL.'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    rovo_actions_explore: {
        id: 'fabric.linking.rovo_actions_explore-non-final',
        defaultMessage: 'Explore',
        description: 'Label for the Rovo Actions button that allows users to explore AI actions for a link'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Label for the unfollow button on a smart link card, allowing the user to stop receiving updates for the linked project or resource.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Tooltip or description for the unfollow project button, explaining that clicking it stops project update notifications.'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Label for the unfollow project button on a smart link card, allowing the user to stop following the linked Atlassian project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Tooltip or description for the unfollow goal button, explaining that clicking it stops notifications for the linked Atlas goal.'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Label for the unfollow goal button on a smart link card, allowing the user to stop following the linked Atlas goal.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewInProvider: {
        id: 'fabric.linking.viewinprovider',
        defaultMessage: 'View in {providerName}',
        description: 'We have a link in our preview modals to the original document. This text tells the user where it will open'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'Generic error message shown on a smart link card when an unspecified error occurs and no more specific message is available.'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Related links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls',
        defaultMessage: 'View recent links',
        description: 'Action to view related links to the given resource'
    },
    related_links_view_related_links: {
        id: 'fabric.linking.related_links_view_related_links',
        defaultMessage: 'View related links',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found in',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes links to',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_title: {
        id: 'fabric.linking.related_links_modal_error_title',
        defaultMessage: `We're having trouble loading related links`,
        description: 'Heading shown in the related links modal when related links fail to load due to a network or server error.'
    },
    related_links_modal_unavailable_title: {
        id: 'fabric.linking.related_links_modal_unavailable_title',
        defaultMessage: `We couldn't find any related links`,
        description: 'Heading shown in the related links modal when no related links are available for the current resource.'
    },
    related_links_modal_error_description: {
        id: 'fabric.linking.related_links_modal_error_description',
        defaultMessage: 'Check your connection or refresh the page to try again',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_description: {
        id: 'fabric.linking.related_links_modal_unavailable_description',
        defaultMessage: 'We continuously review and add related links for updated pages or other content types',
        description: 'Informs the user that there was a problem loading related links'
    },
    join_to_viewIssueTermRefresh: {
        id: 'fabric.linking.join_to_view-issue-term-refresh',
        defaultMessage: 'Join {context} to view this work item',
        description: 'Allows the user join the product or service immediately'
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: 'fabric.linking.open_issue_in_jira-issue-term-refresh',
        defaultMessage: 'Open work item in Jira',
        description: 'Label for the action button on a smart link card that opens the linked Jira work item in Jira (issue term refresh variant).'
    },
    request_access_to_viewIssueTermRefresh: {
        id: 'fabric.linking.request_access_to_view-issue-term-refresh',
        defaultMessage: 'Request access to {context} to view this work item',
        description: 'Allows the user to request access to a product or service'
    },
    status_change_permission_errorIssueTermRefresh: {
        id: 'fabric.linking.status_change_permission_error-issue-term-refresh',
        defaultMessage: "You don\u2019t have permission to transition this work item. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    team_members_count: {
        id: 'fabric.linking.team_members_count',
        defaultMessage: '{context} members',
        description: 'Text shown on a smart link card displaying the number of members in a team. The placeholder {context} is substituted with the member count.'
    },
    user_attributes: {
        id: 'fabric.linking.user_attributes',
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{context}',
        description: 'Displays user attributes like role, department, location, and pronouns'
    },
    follow_project_descriptionGalaxia: {
        id: 'fabric.linking.follow_project_description-galaxia',
        defaultMessage: 'Follow to get notifications on this space',
        description: 'Tooltip or description for the follow space button (Galaxia variant), explaining that clicking it enables notifications for the Confluence space.'
    },
    follow_project_errorGalaxia: {
        id: 'fabric.linking.follow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to follow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    unfollow_project_descriptionGalaxia: {
        id: 'fabric.linking.unfollow_project_description-galaxia',
        defaultMessage: 'Unfollow to stop receiving space notifications',
        description: 'Tooltip or description for the unfollow space button (Galaxia variant), explaining that clicking it stops notifications for the Confluence space.'
    },
    unfollow_project_errorGalaxia: {
        id: 'fabric.linking.unfollow_project_error-galaxia',
        defaultMessage: 'We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    connect_unauthorised_account_description_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description-appify',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider-appify',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian apps.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    learn_more_about_connecting_account_appify: {
        id: 'fabric.linking.learn_more_about_connecting_account-appify',
        defaultMessage: 'Learn more about connecting your account to Atlassian apps.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: 'fabric.linking.learn_more_about_connecting_account_experiment_short',
        defaultMessage: 'Turn your URLs into rich, interactive previews.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    rovo_summary_loading: {
        id: 'fabric.linking.rovo_summary.loading.non-final',
        defaultMessage: 'Rovo is thinking',
        description: 'Shown when a Rovo summary is loading, indicating that the AI is generating a summary for the user.'
    },
    ai_disclaimer: {
        id: 'fabric.linking.rovo_summary.ai_disclaimer.non-final',
        defaultMessage: 'Uses AI. Verify Results.',
        description: 'Shown on a Rovo summary to indicate that the summary was generated by AI and should be verified by the user for accuracy.'
    },
    rovo_unauthorised_title: {
        id: 'fabric.linking.rovo_unauthorised.title',
        defaultMessage: 'Get smarter workflows by connecting your {context} account',
        description: 'Banner headline in Rovo unauthorised hover card header. {context} is the third-party provider name (e.g. Google).'
    },
    rovo_unauthorised_title_no_provider: {
        id: 'fabric.linking.rovo_unauthorised.title_no_provider',
        defaultMessage: 'Get smarter workflows by connecting your account',
        description: 'Banner headline in Rovo unauthorised hover card header when the provider name is unknown.'
    },
    rovo_unauthorised_feature_clear_link_names: {
        id: 'fabric.linking.rovo_unauthorised.feature.clear_link_names',
        defaultMessage: 'Turn long URLs into clear link names',
        description: 'First feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_understand_linked_docs: {
        id: 'fabric.linking.rovo_unauthorised.feature.understand_linked_docs',
        defaultMessage: 'Understand linked docs in seconds',
        description: 'Second feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_feature_go_deeper_smart_suggestions: {
        id: 'fabric.linking.rovo_unauthorised.feature.go_deeper_smart_suggestions',
        defaultMessage: 'Go deeper with smart suggestions',
        description: 'Third feature bullet in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_connect_account: {
        id: 'fabric.linking.rovo_unauthorised.connect_account',
        defaultMessage: 'Connect',
        description: 'Primary action button in Rovo unauthorised hover card.'
    },
    rovo_unauthorised_not_now: {
        id: 'fabric.linking.rovo_unauthorised.not_now',
        defaultMessage: 'Maybe later',
        description: 'Secondary action in Rovo unauthorised hover card.'
    },
    rovo_prompt_context_generic: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'page',
        description: 'The location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_generic_plural: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'pages',
        description: 'The site-wide location the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page.non-final',
        defaultMessage: 'Confluence page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_confluence_page_short: {
        id: 'fabric.linking.rovo_prompt_context_confluence_page_short.non-final',
        defaultMessage: 'page',
        description: 'The Confluence page the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item.non-final',
        defaultMessage: 'Jira work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_context_jira_work_item_short: {
        id: 'fabric.linking.rovo_prompt_context_jira_work_item_short.non-final',
        defaultMessage: 'work item',
        description: 'The Jira work item the user see Smart Link in, to be used as the {context} for Rovo prompt message'
    },
    rovo_prompt_button_recommend_other_sources: {
        id: 'fabric.linking.rovo_prompt_button_recommend_other_sources.non-final',
        defaultMessage: 'Recommend other sources',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_recommend_other_sources: {
        id: 'fabric.linking.rovo_prompt_message_recommend_other_sources.non-final',
        defaultMessage: "<p>From this <a>{url}</a> and the {context} I\u2019m viewing now as context:</p><ul><li><p>Search across all sources I can access for items that discuss <b>similar concepts, themes, or problems</b>, or that <b>reference similar or closely related sources</b> (including links to the same or related pages, issues, or docs).</p></li><li><p>Return the results as a list or table with columns: <code>Item</code>, <code>Type</code>, <code>Short summary</code>, and <code>Why it\u2019s similar</code>.</p></li><li><p>For each result, give a one\u2011sentence <b>Short summary</b> of what the item is about.</p></li><li><p>In <b>Why it\u2019s similar</b>, briefly explain (in a phrase or short sentence) what makes it related to this Smart Link and/or the item I\u2019m viewing (for example: same project, similar decision, shared requirements, overlapping stakeholders, similar metrics, or referencing related docs).</p></li><li><p>Order the list from <b>most to least relevant</b> based on Rovo\u2019s assessment of semantic similarity to both the Smart Link target and the current item.  Prioritize items that I do not own or have not contributed to.</p></li><li><p>If there are more than 5 results, show the <b>5 most relevant</b> and state how many additional items you found.</p></li></ul>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_show_other_mentions: {
        id: 'fabric.linking.rovo_prompt_button_show_other_mentions.non-final',
        defaultMessage: 'Show other mentions',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_show_other_mentions: {
        id: 'fabric.linking.rovo_prompt_message_show_other_mentions.non-final',
        defaultMessage: "<p>From <a>{url}</a> and the {context} I\u2019m viewing now:</p><ul><li><p>Search across all Confluence pages and Jira work items I can access for other items that contain this exact Smart Link (same underlying URL/resource).</p></li><li><p>List all matching items in a table with columns: <code>Item</code>, <code>Type</code>, <code>Short summary</code>, <code>How this item uses the link</code>, and <code>Relevance to current item</code>.</p></li><li><p>For <code>Short summary</code>, give a one\u2011sentence description of what the {context} is about.</p></li><li><p>For <code>How this item uses the link</code>, briefly explain the role this link plays there (e.g., decision doc, background context, implementation details, status update).</p></li><li><p>For <code>Relevance to current item</code>, compare each item to the {context} I\u2019m viewing now and label it <code>High</code>, <code>Medium</code>, or <code>Low</code> relevance, with a short reason (a phrase or single clause).</p></li><li><p>If there are more than 15 matches, show the 15 most relevant and tell me how many additional matches exist.</p></li></ul>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_suggest_improvement: {
        id: 'fabric.linking.rovo_prompt_button_suggest_improvement.non-final',
        defaultMessage: 'Suggest {context} improvement',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_suggest_improvement: {
        id: 'fabric.linking.rovo_prompt_message_suggest_improvement.non-final',
        defaultMessage: "<p>Using the {context} I\u2019m viewing now, plus all files and links referenced in it (including <a>{url}</a>):</p><ul><li><p>Identify unclear reasoning, missing context, or contradictions between the item and its linked files.</p></li><li><p>Call out any places where assumptions are not backed up by data or prior docs.</p></li><li><p>Stay concise: summarize your findings in <b>no more than three short paragraphs of content listed as bullets</b> of no more than a couple of sentences long focused only on the two points above.</p></li><li><p>After presenting that summary, <b>ask me explicitly</b> if I want you to go deeper. Only if I say yes, then:</p><ul><li><p>Suggest concrete rewrites (bullets or short paragraphs) to make the argument clearer, more concise, and better aligned with the supporting files.</p></li><li><p>Propose 3\u20135 follow\u2011up edits or additions that would make this item and its linked docs \u201Cshare\u2011ready\u201D for stakeholders.</p></li></ul></li></ul>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_message_summarize: {
        id: 'fabric.linking.rovo_prompt_message_summarize.non-final',
        defaultMessage: '<p>Summarize the main ideas and key points of <a>{url}</a> in 3-5 clear, complete bullet points (markdown list).</p><p>Preserve important details such as names, dates, and key decisions.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_button_ask_rovo.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'The name of the action to open Rovo Chat and ask a question in relation to current Smart Link'
    },
    rovo_prompt_message_ask_rovo_anything: {
        id: 'fabric.linking.rovo_prompt_message_ask_rovo_anything.non-final',
        defaultMessage: '`I have a question about this linked item` {url}',
        description: "The placeholder prompt message pre-filled in Rovo Chat input. {url} refers to the Smart Link URL. This is not auto-submitted \u2014 the user types their question."
    },
    rovo_prompt_button_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_button_highlight_relevant_content.non-final',
        defaultMessage: `Highlight what's relevant`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_highlight_relevant_content: {
        id: 'fabric.linking.rovo_prompt_message_highlight_relevant_content.non-final',
        defaultMessage: "<p>Based on this linked item (<a>{url}</a>) and the {context} I'm currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {context} refers to the content the user triggered from, e.g. Confluence page or Jira work item. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_trends.non-final',
        defaultMessage: `Identify key trends`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_trends: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_trends.non-final',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key trends, anomalies, and headline numbers. Call out anything increasing/decreasing significantly, noteworthy comparisons, and any risks or opportunities the data suggests.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_button_identify_key_points.non-final',
        defaultMessage: `Identify key points`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_identify_key_points: {
        id: 'fabric.linking.rovo_prompt_message_identify_key_points.non-final',
        defaultMessage: '<p>From this <a>{url}</a>, identify the key points, proposals, and decisions. Focus on what someone skimming the deck should know in order to understand the main message.</p>',
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_button_find_open_questions.non-final',
        defaultMessage: `Find open questions`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_find_open_questions: {
        id: 'fabric.linking.rovo_prompt_message_find_open_questions.non-final',
        defaultMessage: "<p>Look at this <a>{url}</a> and list any open questions, unresolved decisions, or asks that still need follow\u2011up. Group them by owner if possible and keep it concise.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_key_highlights: {
        id: 'fabric.linking.rovo_prompt_button_find_open_questions.non-final',
        defaultMessage: `Key highlights`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_key_highlights: {
        id: 'fabric.linking.rovo_prompt_message_find_open_questions.non-final',
        defaultMessage: "<p>Based on this <a>{url}</a> and the page or ticket I\u2019m currently viewing, highlight the parts of the linked content that are most relevant to this work. Explain briefly why each part is relevant.</p>",
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_chat_action_section_header: {
        id: 'fabric.linking.rovo_chat_action_section_header.non-final',
        defaultMessage: 'Ask Rovo',
        description: 'Heading shown above the Rovo prompt action buttons in the smart link hover card, alongside the Rovo logo, to introduce the AI prompt suggestions.'
    },
    rovo_prompt_button_summarize_this: {
        id: 'fabric.linking.rovo_prompt_button_summarize_this.non-final',
        defaultMessage: 'Summarize this for me',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_ask_a_specific_question: {
        id: 'fabric.linking.rovo_prompt_button_ask_a_specific_question.non-final',
        defaultMessage: 'Ask a specific question',
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_button_show_me_whats_relevant: {
        id: 'fabric.linking.rovo_prompt_button_show_me_whats_relevant.non-final',
        defaultMessage: `Show me what's relevant`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_summarize_document: {
        id: 'fabric.linking.rovo_prompt_message_summarize_document.non-final',
        defaultMessage: `<p>Summarize this doc <a>{url}</a> into a concise, easy-to-scan overview. Adapt to whatever the content is and focus on the main ideas, important decisions, key updates, and next steps, only include these if they exist; don't mention their absence. Avoid unnecessary detail, repetition, or formatting commentary. Write in plain language and optimize for a quick 5\u{2013}10 second read</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_message_summarize_presentation: {
        id: 'fabric.linking.rovo_prompt_message_summarize_presentation.non-final',
        defaultMessage: `<p>Summarize this Google Slides deck <a>{url}</a> into a concise executive overview. Focus on the tldr, key findings, decisions, metrics, risks, and next steps, if there are any. Use a short executive summary followed by 2-3 bullet points. Avoid slide-by-slide narration, design details, repetition, and filler.</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_explain_code: {
        id: 'fabric.linking.rovo_prompt_button_explain_code.non-final',
        defaultMessage: `Explain`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_explain_code: {
        id: 'fabric.linking.rovo_prompt_message_explain_code.non-final',
        defaultMessage: `<p>Explain this code, pull request, or commit <a>{url}</a> in clear, plain language for a non-technical audience.</p><p>Cover:</p><ol><li><strong>Purpose</strong> \u{2014} What problem does it solve or what goal does it achieve?</li><li><strong>How it works</strong> \u{2014} High-level mechanics (no implementation detail unless critical to understanding).</li><li><strong>Why</strong> \u{2014} Motivation for the change or design choice.</li><li><strong>Impact</strong> \u{2014} Key behavior changes, risks, or downstream effects worth noting.</li></ol><p>Constraints:</p><ul><li>3\u{2013}5 sentences or 100\u{2013}150 words max.</li><li>Omit sections with nothing meaningful to say.</li><li>Prefer concrete language over abstract descriptions (e.g., "speeds up page load by caching results" over "improves performance").</li></ul>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_catch_up: {
        id: 'fabric.linking.rovo_prompt_button_catch_up.non-final',
        defaultMessage: `Catch up`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_catch_up: {
        id: 'fabric.linking.rovo_prompt_message_catch_up.non-final',
        defaultMessage: `<p>Catch me up on the latest {provider} conversations or channel activity in <a>{url}</a> from the last two weeks. If there's no activity in the past two weeks, expand the window to the most recent 30 days (or until meaningful activity is found). Summarize the most important updates, decisions, and discussions so the user can quickly understand what they missed. Focus on key changes, unresolved questions, and any action items or follow-ups. Prioritize recent messages with the most activity. Keep the response concise \u{2014} ideally 80\u{2013}150 words or a short set of 3\u{2013}5 key bullets.</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. {provider} is the 3P app name (Please make sure all html tags remain the same.)'
    },
    rovo_prompt_button_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_button_salesforce_prep.non-final',
        defaultMessage: `Prep`,
        description: 'The name of the action to send prompt message to Rovo Chat in relation to current Smart Link'
    },
    rovo_prompt_message_salesforce_prep: {
        id: 'fabric.linking.rovo_prompt_message_salesforce_prep.non-final',
        defaultMessage: `<p>Prep me for this Salesforce record <a>{url}</a>. What's the current state, what's the recent activity, what risks or opportunities should I be aware of, and what would be useful to know before a conversation about it?</p>`,
        description: 'The prompt message to send to Rovo Chat. {url} refers to Smart Link that the user triggers this action from. (Please make sure all html tags remain the same.)'
    },
    // TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    pre_auth_block_social_proof_not_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_not_low',
        defaultMessage: '<b>{percentage}%</b> of your team sees <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when 30% or more of the tenant has connected the provider. {percentage} is a number, {provider} is the 3P app name (e.g. OneDrive).'
    },
    pre_auth_block_social_proof_low: {
        id: 'fabric.linking.pre_auth_block_social_proof_low',
        defaultMessage: 'Your team sees richer <b>{provider}</b> previews.',
        description: 'Social proof message shown on unauthorized 3P block cards when less than 30% of the tenant has connected the provider. {provider} is the 3P app name (e.g. OneDrive).'
    }
});

});

parcelRegister("9wX56", function(module, exports) {
$parcel$export(module.exports, "default", () => $52fb6b3203f54325$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $6BhDL = parcelRequire("6BhDL");
var $4MCQn = parcelRequire("4MCQn");

var $29qqc = parcelRequire("29qqc");

var $3H4LK = parcelRequire("3H4LK");

var $17gSn = parcelRequire("17gSn");
const $52fb6b3203f54325$var$styles = {
    roundImg: "_2rko1rr0"
};
const $52fb6b3203f54325$var$messages = (0, $6BhDL.defineMessages)({
    imageAltText: {
        id: 'smart-link.image-icon.altText',
        defaultMessage: 'Link Icon',
        description: 'Alternative text for the link icon image displayed on a flexible smart link card, used by screen readers and when the image cannot be rendered.'
    }
});
const $52fb6b3203f54325$var$ImageIcon = ({ label: label, defaultIcon: defaultIcon, testId: testId, url: url, width: width, height: height, appearance: appearance = 'square', onError: onError, onLoad: onLoad, hideLoadingSkeleton: hideLoadingSkeleton = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $4fqPo.useState)(false);
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    // If url changes, reset state
    (0, $4fqPo.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        url
    ]);
    if (hasImageErrored) return defaultIcon;
    if (hideLoadingSkeleton) return /*#__PURE__*/ $4fqPo.createElement("img", {
        src: url,
        "data-testid": `${testId}-image`,
        alt: (0, $3H4LK.fg)('platform_navx_smart_link_icon_label_a11y') ? (label === null || label === void 0 ? void 0 : label.trim()) ?? '' : '',
        style: {
            width: width,
            height: height
        },
        onError: ()=>setHasImageErrored(true),
        className: (0, $ltgDR.default)([
            appearance === 'round' && $52fb6b3203f54325$var$styles.roundImg
        ])
    });
    else return /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($29qqc))), {
        src: url,
        loading: /*#__PURE__*/ $4fqPo.createElement((0, $17gSn.LoadingSkeleton), {
            testId: `${testId}-loading`,
            width: width,
            height: height
        }),
        loaded: /*#__PURE__*/ $4fqPo.createElement("img", {
            src: url,
            "data-testid": `${testId}-image`,
            alt: (0, $3H4LK.fg)('platform_navx_smart_link_icon_label_a11y') ? (label === null || label === void 0 ? void 0 : label.trim()) ?? '' : formatMessage($52fb6b3203f54325$var$messages.imageAltText),
            style: {
                width: width,
                height: height
            },
            className: (0, $ltgDR.default)([
                appearance === 'round' && $52fb6b3203f54325$var$styles.roundImg
            ])
        }),
        errored: defaultIcon,
        onError: onError,
        onLoad: onLoad
    });
};
var $52fb6b3203f54325$export$2e2bcd8739ae039 = $52fb6b3203f54325$var$ImageIcon;

});
parcelRegister("29qqc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1910eacb7a30a31f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $4fqPo = parcelRequire("4fqPo");
var $1910eacb7a30a31f$var$React = $1910eacb7a30a31f$var$_interopRequireWildcard($4fqPo);
function $1910eacb7a30a31f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1910eacb7a30a31f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1910eacb7a30a31f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1910eacb7a30a31f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $1910eacb7a30a31f$var$loading(image) {
    return {
        image: image,
        isLoaded: false,
        isErrored: false
    };
}
function $1910eacb7a30a31f$var$loaded() {
    return {
        isLoaded: true
    };
}
function $1910eacb7a30a31f$var$errored() {
    return {
        isErrored: true
    };
}
function $1910eacb7a30a31f$var$hasPropsChanged(prevProps, nextProps) {
    var prevSrc = prevProps.src;
    var nextSrc = nextProps.src;
    return prevSrc !== nextSrc;
}
var $1910eacb7a30a31f$var$ImageRenderer = function(_React$Component) {
    $1910eacb7a30a31f$var$_inherits(ImageRenderer, _React$Component);
    function ImageRenderer() {
        var _ref;
        var _temp, _this, _ret;
        $1910eacb7a30a31f$var$_classCallCheck(this, ImageRenderer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $1910eacb7a30a31f$var$_possibleConstructorReturn(this, (_ref = ImageRenderer.__proto__ || Object.getPrototypeOf(ImageRenderer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            isLoaded: false,
            isErrored: false
        }, _this.handleLoad = function() {
            var onLoad = _this.props.onLoad;
            _this.unload();
            _this.setState($1910eacb7a30a31f$var$loaded(), function() {
                if (onLoad) onLoad();
            });
        }, _this.handleError = function() {
            var onError = _this.props.onError;
            _this.unload();
            _this.setState($1910eacb7a30a31f$var$errored(), function() {
                if (onError) onError();
            });
        }, _temp), $1910eacb7a30a31f$var$_possibleConstructorReturn(_this, _ret);
    }
    $1910eacb7a30a31f$var$_createClass(ImageRenderer, [
        {
            key: 'load',
            value: function load() {
                var src = this.props.src;
                var image = this.state.image;
                if (image) {
                    image.onload = this.handleLoad;
                    image.onerror = this.handleError;
                    image.src = src;
                }
            }
        },
        {
            key: 'unload',
            value: function unload() {
                var image = this.state.image;
                if (image) {
                    image.onload = undefined;
                    image.onerror = undefined;
                }
            }
        },
        {
            key: 'componentWillMount',
            value: function componentWillMount() {
                if (typeof window === 'undefined') return;
                this.setState($1910eacb7a30a31f$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.load();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if ($1910eacb7a30a31f$var$hasPropsChanged(this.props, nextProps)) this.setState($1910eacb7a30a31f$var$loading(new Image()));
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps) {
                if ($1910eacb7a30a31f$var$hasPropsChanged(prevProps, this.props)) {
                    this.unload();
                    this.load();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.unload();
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, loading = _props.loading, loaded = _props.loaded, errored = _props.errored, children = _props.children;
                var _state = this.state, image = _state.image, isLoaded = _state.isLoaded, isErrored = _state.isErrored;
                if (isLoaded && loaded) return loaded;
                if (isErrored && errored) return errored;
                if (!isLoaded && !isErrored && loading) return loading;
                if (children) return children({
                    image: isLoaded ? image : undefined,
                    loaded: isLoaded,
                    errored: isErrored
                });
                return null;
            }
        }
    ]);
    return ImageRenderer;
}($1910eacb7a30a31f$var$React.Component);
module.exports.default = $1910eacb7a30a31f$var$ImageRenderer;

});

parcelRegister("17gSn", function(module, exports) {
$parcel$export(module.exports, "LoadingSkeleton", () => $6b3bd5577ce367fb$export$44c18d210d5de37b);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $6b3bd5577ce367fb$var$animationNameStyles = null;
const $6b3bd5577ce367fb$var$loadingSkeletonStyle = null;
const $6b3bd5577ce367fb$export$44c18d210d5de37b = ({ testId: testId, width: width, height: height })=>{
    return /*#__PURE__*/ $4fqPo.createElement("span", {
        "data-testid": testId,
        style: {
            width: width,
            height: height
        },
        className: (0, $ltgDR.default)([
            "_2rkolb4i _uiztglyw _bfhkvkf5 _1itkfj9x _12vemgnk _1lrw6rms _1e0c1o8l _5sag9cwz _1o51q7pw _tip812c5 _j7hqqkar _1pglp3kn"
        ])
    });
};

});


parcelRegister("hs0RG", function(module, exports) {
$parcel$export(module.exports, "showFlag", () => $cbb771d89d98d8a3$export$e12b2cc6b75b006b);
/**
 * Smart Link flag module — imperative singleton pattern.
 *
 * ## Why not a React context provider?
 *
 * The natural approach would be to render a `<FlagProvider>` inside the Card
 * component tree, managing flag state via React context. This was the original
 * implementation. However, it caused a critical bug:
 *
 * When a parent component of smart card changed, either swap or unmount,
 * it unmounts the entire card subtree including `FlagsProvider`.
 * Any flag that was visible at that moment is instantly destroyed and lost.
 *
 * ## Why an injected React root?
 *
 * This module manages a persistent `FlagGroup` at `document.body` via its own
 * `createRoot` — completely independent of any card component tree. The root is created
 * lazily on the first `showFlag` call and kept alive indefinitely, re-rendering with
 * the current flags array on every change.
 *
 * Benefits:
 * - Flags survive any card unmount/remount cycle
 * - No provider needed anywhere in the component tree
 * - Works identically for all card paths (Card, CardSSR)
 * - Same pattern as `EmbedModal/utils.tsx` but for a persistent group
 *
 * Usage: import `showFlag` and call it directly — no provider needed.
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $5F0K9 = parcelRequire("5F0K9");

var $99BhM = parcelRequire("99BhM");

var $h1mlL = parcelRequire("h1mlL");

var $25gao = parcelRequire("25gao");

var $3H4LK = parcelRequire("3H4LK");

var $8ipnO = parcelRequire("8ipnO");
const $cbb771d89d98d8a3$var$FLAG_GROUP_MOUNT_POINT_ID = 'smart-link-flags-mount';
// ---------------------------------------------------------------------------
// Module-level singleton state
// Lives for the entire page session — independent of any React component tree.
//
// The sequence:
// 1. ensureRoot()
//    └── flushSync(() => root.render(<empty FlagGroup>))
//        └── ExitingPersistence mounts with appear=false
//        └── pendingFirstRender = true
//
// 2. showFlag() detects pendingFirstRender=true
//    └── pendingFirstRender = false
//    └── setTimeout(0, () => renderToRoot())
//        ← deferred: runs AFTER useEffect fires
//
// 3. [async] ExitingPersistence's useEffect fires
//    └── appear flips false → true
//
// 4. [async] setTimeout(0) fires → renderToRoot()
//    └── FlagGroup receives flag as new child
//    └── ExitingPersistence sees new child with appear=true → ANIMATES
// ---------------------------------------------------------------------------
let $cbb771d89d98d8a3$var$flagGroupState = [];
let $cbb771d89d98d8a3$var$root = null;
// True after ensureRoot() creates a new root but before ExitingPersistence's useEffect
// has flipped `appear` to true. While pending, the first renderToRoot is deferred via
// setTimeout so that the enter animation fires correctly.
let $cbb771d89d98d8a3$var$pendingFirstRender = false;
const $cbb771d89d98d8a3$var$removeFlag = (id)=>{
    $cbb771d89d98d8a3$var$flagGroupState = $cbb771d89d98d8a3$var$flagGroupState.filter((f)=>f.id !== id);
    $cbb771d89d98d8a3$var$renderToRoot();
};
const $cbb771d89d98d8a3$var$renderToRoot = ()=>{
    if (!$cbb771d89d98d8a3$var$root) return;
    $cbb771d89d98d8a3$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $99BhM.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h1mlL.default), {
        onDismissed: $cbb771d89d98d8a3$var$removeFlag
    }, $cbb771d89d98d8a3$var$flagGroupState.map((flagProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8ipnO.default), {
            borderRadius: (0, $3H4LK.fg)('platform-dst-shape-theme-default') ? 'large' : 'small',
            isVisible: true,
            key: flagProps.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $25gao.default), {
            ...flagProps,
            key: flagProps.id
        }));
    }))));
};
const $cbb771d89d98d8a3$var$ensureRoot = ()=>{
    if ($cbb771d89d98d8a3$var$root !== null || typeof document === 'undefined') return;
    let container = document.getElementById($cbb771d89d98d8a3$var$FLAG_GROUP_MOUNT_POINT_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = $cbb771d89d98d8a3$var$FLAG_GROUP_MOUNT_POINT_ID;
        document.body.appendChild(container);
    }
    $cbb771d89d98d8a3$var$root = (0, $5F0K9.createRoot)(container);
    const locale = typeof navigator !== 'undefined' ? navigator.language || 'en' : 'en';
    // Render an empty FlagGroup immediately so React has a "before" state to diff against.
    // Without this, the first flag has no previous render to compare to — React mounts it
    // directly and the FlagGroup animation library sees it as "already present" rather than
    // "just entered", skipping the slide-in animation.
    // Subsequent flags always have the previous (possibly empty) render to diff against,
    // which is why they animate correctly.
    const renderEmptyFlagGroup = ()=>$cbb771d89d98d8a3$var$root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $99BhM.default), {
            locale: locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h1mlL.default), {
            onDismissed: $cbb771d89d98d8a3$var$removeFlag
        })));
    // Use flushSync to synchronously commit an empty FlagGroup before any flag is added.
    // This mounts ExitingPersistence (inside FlagGroup) in an empty state so that when the
    // first flag arrives (deferred via setTimeout below), ExitingPersistence recognises it
    // as a genuinely new child and runs the slide-in animation.
    try {
        (0, $b2Ka1.flushSync)(renderEmptyFlagGroup);
    } catch  {
        // flushSync cannot be called during React rendering or from a lifecycle (e.g. useEffect).
        // We try it and fall back to a regular async render if React throws — in that case the
        // first flag may appear without a slide-in animation, but all subsequent flags will
        // animate correctly (ExitingPersistence will have mounted and flipped appear=true by then).
        renderEmptyFlagGroup();
    }
    // After flushSync commits the empty FlagGroup, ExitingPersistence's useEffect runs
    // asynchronously to flip `appear` from false → true (enabling enter animations).
    // We store a pending flag to signal that the first renderToRoot should be deferred.
    $cbb771d89d98d8a3$var$pendingFirstRender = true;
};
const $cbb771d89d98d8a3$export$e12b2cc6b75b006b = (options)=>{
    const flagProps = {
        ...options,
        id: options.id || crypto.randomUUID()
    };
    const index = $cbb771d89d98d8a3$var$flagGroupState.findIndex((f)=>f.id === flagProps.id);
    if (index === -1) $cbb771d89d98d8a3$var$flagGroupState = [
        flagProps,
        ...$cbb771d89d98d8a3$var$flagGroupState
    ];
    else $cbb771d89d98d8a3$var$flagGroupState = $cbb771d89d98d8a3$var$flagGroupState.map((f, i)=>i === index ? flagProps : f);
    $cbb771d89d98d8a3$var$ensureRoot();
    if ($cbb771d89d98d8a3$var$pendingFirstRender) {
        // ensureRoot() just created a new root and committed an empty FlagGroup via flushSync.
        // ExitingPersistence's useEffect (which flips `appear` false→true) runs asynchronously
        // after the commit. We defer renderToRoot via setTimeout(0) to ensure that useEffect
        // has already fired before the flag is added — only then will ExitingPersistence
        // treat it as a new entering child and run the slide-in animation.
        $cbb771d89d98d8a3$var$pendingFirstRender = false;
        setTimeout(()=>{
            $cbb771d89d98d8a3$var$renderToRoot();
        }, 0);
    } else $cbb771d89d98d8a3$var$renderToRoot();
};
const $cbb771d89d98d8a3$export$3dd8302481493c99 = ()=>{
    $cbb771d89d98d8a3$var$flagGroupState = [];
    $cbb771d89d98d8a3$var$pendingFirstRender = false;
    if ($cbb771d89d98d8a3$var$root) {
        $cbb771d89d98d8a3$var$root.unmount();
        $cbb771d89d98d8a3$var$root = null;
    }
    if (typeof document !== 'undefined') {
        var _document$getElementB;
        (_document$getElementB = document.getElementById($cbb771d89d98d8a3$var$FLAG_GROUP_MOUNT_POINT_ID)) === null || _document$getElementB === void 0 || _document$getElementB.remove();
    }
};

});
parcelRegister("8ipnO", function(module, exports) {
$parcel$export(module.exports, "default", () => $c85fbdd9a1c41cb6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $3H4LK = parcelRequire("3H4LK");

var $a1GvG = parcelRequire("a1GvG");

var $7bEFV = parcelRequire("7bEFV");

var $8r1gF = parcelRequire("8r1gF");
const $c85fbdd9a1c41cb6$var$contentStyles = null;
const $c85fbdd9a1c41cb6$var$contentStylesPrismVisible = null;
const $c85fbdd9a1c41cb6$var$animatedSvgContainerStyles = {
    true: "_v564fs5d _tzy4kb7n",
    false: "_v564fs5d _tzy4idpf"
};
const $c85fbdd9a1c41cb6$var$borderRadiusStyles = {
    large: "_2rko1mok",
    small: "_2rko12b0"
};
const $c85fbdd9a1c41cb6$var$popupContainerStyles = null;
const $c85fbdd9a1c41cb6$var$AIPrism = ({ borderRadius: borderRadius = 'large', children: children, isGlowing: isGlowing = true, isMoving: isMoving = true, isVisible: isVisible, testId: testId })=>{
    const { colorMode: colorMode = 'light' } = (0, $a1GvG.default)();
    return /*#__PURE__*/ $4fqPo.createElement((0, $7bEFV.default), {
        palette: (0, $8r1gF.AI_BORDER_PALETTE)[colorMode] ?? (0, $8r1gF.AI_BORDER_PALETTE).light,
        isGlowing: isGlowing,
        isMoving: isMoving,
        testId: testId,
        className: (0, $ltgDR.default)([
            $c85fbdd9a1c41cb6$var$animatedSvgContainerStyles[isVisible ? 'true' : 'false'],
            (0, $3H4LK.fg)('platform_sl_connect_account_flag') && $c85fbdd9a1c41cb6$var$borderRadiusStyles[borderRadius]
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2rko1mok _bfhk1bhr _16qs130s",
            "_v5649spz",
            isVisible && "_16qs1aef"
        ])
    }, children));
};
var $c85fbdd9a1c41cb6$export$2e2bcd8739ae039 = $c85fbdd9a1c41cb6$var$AIPrism;

});
parcelRegister("7bEFV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4b7877f0628387d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $awxFc = parcelRequire("awxFc");
const $a4b7877f0628387d$var$borderContainerStyles = null;
const $a4b7877f0628387d$var$borderContentStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $a4b7877f0628387d$var$AIGlowingBorder = ({ children: children, palette: palette, isMoving: isMoving = true, isGlowing: isGlowing, testId: testId, className: className })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1bsb1ns9"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $awxFc.default), {
        palette: palette,
        isMoving: isMoving,
        className: className
    }), isGlowing && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ $4fqPo.createElement((0, $awxFc.default), {
        palette: palette,
        isMoving: isMoving,
        isGlowing: true,
        className: className
    }), /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_2rko1mok _16jlkb7n _1pbykb7n"
        ])
    }, children, " "));
var $a4b7877f0628387d$export$2e2bcd8739ae039 = $a4b7877f0628387d$var$AIGlowingBorder;

});
parcelRegister("awxFc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c53e2d987e6872b$export$2e2bcd8739ae039);
/* animated-svg-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
let $3c53e2d987e6872b$var$namespaceUUID = 0;
const $3c53e2d987e6872b$var$svgStyles = null;
const $3c53e2d987e6872b$var$blurredStyles = null;
const $3c53e2d987e6872b$var$notBlurredStyles = null;
/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */ const $3c53e2d987e6872b$var$AnimatedSvgContainer = ({ palette: palette, isMoving: isMoving, isGlowing: isGlowing, className: className })=>{
    const svgRef = (0, $4fqPo.useRef)(null);
    const namespaceId = (0, $4fqPo.useRef)();
    if (namespaceId.current === undefined) {
        namespaceId.current = $3c53e2d987e6872b$var$namespaceUUID;
        $3c53e2d987e6872b$var$namespaceUUID += 1;
    }
    (0, $4fqPo.useEffect)(()=>{
        if (isMoving) {
            const svg = svgRef.current;
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg === null || svg === void 0 || svg.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isMoving
    ]);
    return /*#__PURE__*/ $4fqPo.createElement("svg", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_2rko19bv _kqswstnw",
            isGlowing ? "_1bsb1wgc _4t3i1wgc _154i1b66 _1ltv1b66 _kdam1rfl _w6ng15vq _t9ec161g" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            className
        ]),
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $4fqPo.createElement("defs", null, /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    })), /*#__PURE__*/ $4fqPo.createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0",
        stopColor: palette.blue
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.25",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.5",
        stopColor: palette.yellow
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "0.75",
        stopColor: palette.teal
    }), /*#__PURE__*/ $4fqPo.createElement("stop", {
        offset: "1",
        stopColor: palette.blue
    }))), /*#__PURE__*/ $4fqPo.createElement("g", {
        strokeWidth: "8"
    }, /*#__PURE__*/ $4fqPo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ $4fqPo.createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    })));
};
var $3c53e2d987e6872b$export$2e2bcd8739ae039 = $3c53e2d987e6872b$var$AnimatedSvgContainer;

});


parcelRegister("8r1gF", function(module, exports) {
$parcel$export(module.exports, "AI_BORDER_PALETTE", () => $9b5843e447e078fe$export$23b7b83c7063ccfe);
const $9b5843e447e078fe$export$3088ed82e2905d1e = {
    blueUniqueGradientLight: '#00ACF8',
    blueUniqueGradientDark: '#008BD2',
    blue1000: '#092957',
    blue800: '#0055CC',
    blue700: '#0C66E4',
    blue600: '#1D7AFC',
    blue500: '#388BFF',
    blue300: '#85B8FF',
    blue200: '#CCE0FF',
    blue100: '#E9F2FF',
    teal500: '#37B4C3',
    teal300: '#8BDBE5',
    yellow500: '#CF9F02',
    yellow200: '#F8E6A0',
    red800: '#AE2A19',
    red600: '#E34935',
    orange500: '#F18D13',
    orange300: '#FEC57B'
};
const $9b5843e447e078fe$export$23b7b83c7063ccfe = {
    dark: {
        blue: $9b5843e447e078fe$export$3088ed82e2905d1e.blue800,
        teal: $9b5843e447e078fe$export$3088ed82e2905d1e.teal500,
        yellow: $9b5843e447e078fe$export$3088ed82e2905d1e.yellow500
    },
    light: {
        blue: $9b5843e447e078fe$export$3088ed82e2905d1e.blue600,
        teal: $9b5843e447e078fe$export$3088ed82e2905d1e.teal300,
        yellow: $9b5843e447e078fe$export$3088ed82e2905d1e.yellow200
    }
};

});




parcelRegister("ek3rC", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4177f17418af0b1$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2OOKU = parcelRequire("2OOKU");

var $agHzq = parcelRequire("agHzq");

var $6TDb2 = parcelRequire("6TDb2");

var $feSIj = parcelRequire("feSIj");
const $a4177f17418af0b1$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $a4177f17418af0b1$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $agHzq.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $4fqPo.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, prompt: prompt, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($2OOKU)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $6TDb2.mark(markName, 'pending');
        try {
            var _measure$getMeasure;
            // Begin UFO experience
            (0, $feSIj.startUfoExperience)($a4177f17418af0b1$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType,
                prompt: prompt
            });
            // Invoke action
            const result = await actionFn();
            $6TDb2.mark(markName, 'resolved');
            (0, $feSIj.succeedUfoExperience)($a4177f17418af0b1$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_measure$getMeasure = $6TDb2.getMeasure(markName, 'resolved')) === null || _measure$getMeasure === void 0 ? void 0 : _measure$getMeasure.duration) ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            var _measure$getMeasure2;
            $6TDb2.mark(markName, 'errored');
            (0, $feSIj.failUfoExperience)($a4177f17418af0b1$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err === null || err === void 0 ? void 0 : err.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: ((_measure$getMeasure2 = $6TDb2.getMeasure(markName, 'errored')) === null || _measure$getMeasure2 === void 0 ? void 0 : _measure$getMeasure2.duration) ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $a4177f17418af0b1$export$2e2bcd8739ae039 = $a4177f17418af0b1$var$useInvokeClientAction;

});

parcelRegister("i66n7", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e91cc5f5d367951$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $fRlBb = parcelRequire("fRlBb");

var $5ILcO = parcelRequire("5ILcO");

var $3H4LK = parcelRequire("3H4LK");

var $bjIO7 = parcelRequire("bjIO7");

var $feSIj = parcelRequire("feSIj");

var $arHge = parcelRequire("arHge");
const $2e91cc5f5d367951$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $5ILcO.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $arHge.default)();
    return (0, $4fqPo.useCallback)(async (params)=>{
        const { url: url, isReloading: isReloading = false, isMetadataRequest: isMetadataRequest = false, id: id = '', appearance: appearance } = params;
        const { details: details } = getState()[url] || {
            status: (0, $bjIO7.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $fRlBb.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) {
            const metadataStatus = appearance === 'inline' && !isMetadataRequest && (0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization') ? 'pending' : undefined;
            return connections.client.fetchData(url, isReloading, appearance).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest, metadataStatus)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        } else (0, $feSIj.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $2e91cc5f5d367951$export$2e2bcd8739ae039 = $2e91cc5f5d367951$var$useResolve;

});
parcelRegister("arHge", function(module, exports) {
$parcel$export(module.exports, "default", () => $b105c659326a18a4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $b2Ka1 = parcelRequire("b2Ka1");

var $5ILcO = parcelRequire("5ILcO");

var $2oVC7 = parcelRequire("2oVC7");
var $3xXTF = parcelRequire("3xXTF");
var $21gEn = parcelRequire("21gEn");

var $3H4LK = parcelRequire("3H4LK");

var $bjIO7 = parcelRequire("bjIO7");

var $btL6i = parcelRequire("btL6i");

var $lBsst = parcelRequire("lBsst");
const $b105c659326a18a4$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $5ILcO.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $4fqPo.useCallback)((url, metadataStatus)=>{
        dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $4fqPo.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $bjIO7.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_RESOLVED), {
            url: url
        }, (0, $btL6i.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $4fqPo.useCallback)((resourceUrl, response, isReloading, isMetadataRequest, metadataStatus = 'resolved')=>{
        // Some optimized resolves intentionally leave metadata pending so hover can fetch it.
        setMetadataStatus(resourceUrl, (0, $3H4LK.fg)('platform_smartlink_inline_resolve_optimization') ? metadataStatus : 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $2oVC7.cardAction)((0, $2oVC7.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $4fqPo.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest, metadataStatus)=>{
        if (!resourceUrl) return;
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $21gEn.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $3xXTF.APIError)('fallback', hostname, (0, $lBsst.ERROR_MESSAGE_OAUTH)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $3xXTF.APIError)('fatal', hostname, (0, $lBsst.ERROR_MESSAGE_FATAL)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $3xXTF.APIError)('error', hostname, (0, $lBsst.ERROR_MESSAGE_METADATA)), response, isMetadataRequest);
            return;
        }
        /**
     * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
     * more info:
     * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
     * https://react-redux.js.org/api/batch
     */ (0, $b2Ka1.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest, metadataStatus);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $4fqPo.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $b105c659326a18a4$export$2e2bcd8739ae039 = $b105c659326a18a4$var$useResponse;

});
parcelRegister("btL6i", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $671292b63907cc35$export$2796a804c6e44f63);
$parcel$export(module.exports, "getUnauthorizedJsonLd", () => $671292b63907cc35$export$b9482e0f6d365cc7);
$parcel$export(module.exports, "getForbiddenJsonLd", () => $671292b63907cc35$export$e32193033a594efb);
const $671292b63907cc35$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $671292b63907cc35$export$2796a804c6e44f63 = ()=>$671292b63907cc35$var$emptyData;
const $671292b63907cc35$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$671292b63907cc35$var$emptyData
        }
    });
const $671292b63907cc35$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$671292b63907cc35$var$emptyData
        }
    });

});

parcelRegister("lBsst", function(module, exports) {
$parcel$export(module.exports, "ERROR_MESSAGE_OAUTH", () => $5153d3e166ba91c4$export$3e81ce851ffda0ad);
$parcel$export(module.exports, "ERROR_MESSAGE_FATAL", () => $5153d3e166ba91c4$export$45e7dda0d43d7f55);
$parcel$export(module.exports, "ERROR_MESSAGE_METADATA", () => $5153d3e166ba91c4$export$338f7d9ccca1975d);
const $5153d3e166ba91c4$export$297c39c8b9bfca0 = 'resolving';
const $5153d3e166ba91c4$export$b64a888338c24e0e = 'errored';
const $5153d3e166ba91c4$export$677b6edfa0002c70 = 'fallback';
const $5153d3e166ba91c4$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $5153d3e166ba91c4$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $5153d3e166ba91c4$export$338f7d9ccca1975d = 'Error resolving metadata.';

});




parcelRegister("jZHYG", function(module, exports) {
$parcel$export(module.exports, "useSmartCardState", () => $e460940af3864d30$export$b0444d00ba7313c6);

var $gCoJE = parcelRequire("gCoJE");

var $5ILcO = parcelRequire("5ILcO");
const $e460940af3864d30$var$PENDING_STATE = {
    status: 'pending'
};
function $e460940af3864d30$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $5ILcO.useSmartLinkContext)();
    const cardState = (0, $gCoJE.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $e460940af3864d30$var$PENDING_STATE;
}

});

parcelRegister("2wB1j", function(module, exports) {
$parcel$export(module.exports, "useScheduledRegister", () => $4f984f05513d53c6$export$db80d61271e4d5af);
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $4fqPo = parcelRequire("4fqPo");
const $4f984f05513d53c6$var$batchQueue = new Map();
const $4f984f05513d53c6$var$batchTimeouts = new Map();
const $4f984f05513d53c6$var$BATCH_DELAY = 250;
const $4f984f05513d53c6$var$executeBatch = (hostname)=>{
    const items = $4f984f05513d53c6$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $4f984f05513d53c6$var$batchQueue.delete(hostname);
    $4f984f05513d53c6$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $4f984f05513d53c6$var$addToBatch = (hostname, item)=>{
    if (!$4f984f05513d53c6$var$batchQueue.has(hostname)) $4f984f05513d53c6$var$batchQueue.set(hostname, []);
    $4f984f05513d53c6$var$batchQueue.get(hostname).push(item);
    if ($4f984f05513d53c6$var$batchTimeouts.has(hostname)) clearTimeout($4f984f05513d53c6$var$batchTimeouts.get(hostname));
    $4f984f05513d53c6$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $4f984f05513d53c6$var$executeBatch(hostname);
    }, $4f984f05513d53c6$var$BATCH_DELAY));
};
const $4f984f05513d53c6$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $4fqPo.useRef)(false);
    const scheduledRegister = (0, $4fqPo.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $4f984f05513d53c6$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};

});


parcelRegister("3twpn", function(module, exports) {
$parcel$export(module.exports, "default", () => $77446d78e6c757f4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5ILcO = parcelRequire("5ILcO");
const $77446d78e6c757f4$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $77446d78e6c757f4$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $77446d78e6c757f4$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $77446d78e6c757f4$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $4fqPo.useContext)((0, $5ILcO.SmartCardContext));
    return hasSmartCardProvider && $77446d78e6c757f4$export$aa45d36a96427452(href);
};
var $77446d78e6c757f4$export$2e2bcd8739ae039 = $77446d78e6c757f4$var$useResolveHyperlinkValidator;

});

parcelRegister("if4Mo", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsUtils", () => $fb94ee2364a6f1fd$export$853798cf89e90693);
$parcel$export(module.exports, "useSmartLinkAnalyticsContext", () => $fb94ee2364a6f1fd$export$ac28ada90c4970b7);
$parcel$export(module.exports, "SmartLinkAnalyticsContext", () => $fb94ee2364a6f1fd$export$eaff10f7ec59c455);

var $4fqPo = parcelRequire("4fqPo");

var $fFB0R = parcelRequire("fFB0R");

var $bU0EV = parcelRequire("bU0EV");

var $5ILcO = parcelRequire("5ILcO");

var $dg1TL = parcelRequire("dg1TL");

var $3H4LK = parcelRequire("3H4LK");

var $jZHYG = parcelRequire("jZHYG");

var $fShv5 = parcelRequire("fShv5");
const $fb94ee2364a6f1fd$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2;
    return {
        definitionId: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.definitionId) ?? null,
        resourceType: (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.resourceType) ?? null,
        ...(0, $bU0EV.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    };
};
const $fb94ee2364a6f1fd$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const resolvedAttributes = $fb94ee2364a6f1fd$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $fShv5.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $fb94ee2364a6f1fd$export$853798cf89e90693 = ()=>{
    const { store: store } = (0, $5ILcO.useSmartLinkContext)();
    const getByUrl = (0, $4fqPo.useCallback)((url, props)=>{
        const state = store ? (0, $dg1TL.getUrl)(store, url) : undefined;
        return $fb94ee2364a6f1fd$var$getSmartLinkAnalyticsContext({
            display: props === null || props === void 0 ? void 0 : props.display,
            id: props === null || props === void 0 ? void 0 : props.id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: props === null || props === void 0 ? void 0 : props.source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        store
    ]);
    return (0, $4fqPo.useMemo)(()=>({
            getByUrl: getByUrl
        }), [
        getByUrl
    ]);
};
const $fb94ee2364a6f1fd$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $5ILcO.useSmartLinkContext)();
    const state = store ? (0, $dg1TL.getUrl)(store, url) : undefined;
    return (0, $4fqPo.useMemo)(()=>{
        return $fb94ee2364a6f1fd$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        display,
        id,
        source,
        state === null || state === void 0 ? void 0 : state.details,
        state === null || state === void 0 ? void 0 : state.status,
        url,
        state === null || state === void 0 ? void 0 : state.error
    ]);
};
const $fb94ee2364a6f1fd$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $jZHYG.useSmartCardState)(url);
    const data = $fb94ee2364a6f1fd$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $3H4LK.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: data
    }, children);
};

});
parcelRegister("bU0EV", function(module, exports) {
$parcel$export(module.exports, "getResolvedAttributes", () => $2c26405ea88b615b$export$7243431f5325a7b);

var $21gEn = parcelRequire("21gEn");

var $kH584 = parcelRequire("kH584");

var $3H4LK = parcelRequire("3H4LK");
const $2c26405ea88b615b$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    var _details$meta, _details$meta2, _details$meta3, _details$meta4, _details$meta5, _details$meta6, _details$meta7, _details$meta8, _details$meta9, _details$meta0, _details$meta1;
    const status = linkStatus ?? (details && (0, $21gEn.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $kH584.getDisplayCategory)(status);
    return {
        status: status ?? null,
        statusDetails: (details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 || (_details$meta = _details$meta.requestAccess) === null || _details$meta === void 0 ? void 0 : _details$meta.accessType) ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $3H4LK.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? (details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key) ?? (error === null || error === void 0 ? void 0 : error.extensionKey) ?? null : (details === null || details === void 0 || (_details$meta3 = details.meta) === null || _details$meta3 === void 0 ? void 0 : _details$meta3.key) ?? null,
        destinationTenantId: (details === null || details === void 0 || (_details$meta4 = details.meta) === null || _details$meta4 === void 0 ? void 0 : _details$meta4.tenantId) ?? null,
        destinationActivationId: (details === null || details === void 0 || (_details$meta5 = details.meta) === null || _details$meta5 === void 0 ? void 0 : _details$meta5.activationId) ?? null,
        destinationContainerId: (details === null || details === void 0 || (_details$meta6 = details.meta) === null || _details$meta6 === void 0 ? void 0 : _details$meta6.containerId) ?? null,
        destinationCategory: (details === null || details === void 0 || (_details$meta7 = details.meta) === null || _details$meta7 === void 0 ? void 0 : _details$meta7.category) ?? null,
        destinationProduct: (details === null || details === void 0 || (_details$meta8 = details.meta) === null || _details$meta8 === void 0 ? void 0 : _details$meta8.product) ?? null,
        destinationSubproduct: (details === null || details === void 0 || (_details$meta9 = details.meta) === null || _details$meta9 === void 0 ? void 0 : _details$meta9.subproduct) ?? null,
        destinationObjectId: (details === null || details === void 0 || (_details$meta0 = details.meta) === null || _details$meta0 === void 0 ? void 0 : _details$meta0.objectId) ?? null,
        destinationObjectType: (details === null || details === void 0 || (_details$meta1 = details.meta) === null || _details$meta1 === void 0 ? void 0 : _details$meta1.resourceType) ?? null,
        canBeDatasource: ((details === null || details === void 0 ? void 0 : details.datasources) || []).length > 0
    };
};

});
parcelRegister("kH584", function(module, exports) {
$parcel$export(module.exports, "getDisplayCategory", () => $e90f1fd9684ddabf$export$28ddbae335bd80b5);
const $e90f1fd9684ddabf$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};

});



parcelRegister("jHQ5C", function(module, exports) {
$parcel$export(module.exports, "isAuxClick", () => $b687c49d88f02d52$export$15213acd7ac7d39a);
$parcel$export(module.exports, "getAnchorAttributesFromEvent", () => $b687c49d88f02d52$export$bd1e92a09497f497);
$parcel$export(module.exports, "updateAnchorHref", () => $b687c49d88f02d52$export$9853bee72613d48f);
const $b687c49d88f02d52$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};
const $b687c49d88f02d52$export$bd1e92a09497f497 = (event)=>{
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLAnchorElement)) return {
        href: undefined,
        target: '_self'
    };
    return {
        href: currentTarget.href,
        target: currentTarget.target || '_self'
    };
};
const $b687c49d88f02d52$export$9853bee72613d48f = (event, href)=>{
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;
    event.currentTarget.href = href;
};

});

parcelRegister("dQ6d5", function(module, exports) {
$parcel$export(module.exports, "default", () => $af1627c171decf73$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $99BhM = parcelRequire("99BhM");
/**
 * HOC to wrap component with IntlProvider if not available
 */ const $af1627c171decf73$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, props);
        return props !== null && props !== void 0 && props.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $99BhM.default), {
            locale: "en"
        }, content);
    };
var $af1627c171decf73$export$2e2bcd8739ae039 = $af1627c171decf73$var$withIntlProvider;

});

parcelRegister("8Ckj1", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $362022ed4db084a2$export$ed70996d478e16d3);
$parcel$export(module.exports, "useFire3PWorkflowsClickEvent", () => $362022ed4db084a2$export$e682245dc886cff2);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $fShv5 = parcelRequire("fShv5");
function $362022ed4db084a2$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ const events = (0, $4fqPo.useMemo)(()=>new (0, $fShv5.SmartLinkEvents)(), []);
    return events;
}
function $362022ed4db084a2$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    return ({ isAuxClick: isAuxClick = false, isContextMenu: isContextMenu = false } = {})=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier,
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}

});


parcelRegister("iDZHE", function(module, exports) {
$parcel$export(module.exports, "default", () => $21328473fd1ac8ec$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $hCKuP = parcelRequire("hCKuP");
var $3rTf2 = parcelRequire("3rTf2");
var $99BhM = parcelRequire("99BhM");

var $lszf6 = parcelRequire("lszf6");

var $iByhD = parcelRequire("iByhD");

var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $isBvF = parcelRequire("isBvF");
var $6zx4f = parcelRequire("6zx4f");
var $kCZZw = parcelRequire("kCZZw");

var $aCmbs = parcelRequire("aCmbs");
const $21328473fd1ac8ec$var$breakWordsCss = null;
const $21328473fd1ac8ec$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $4fqPo.createElement((0, $kCZZw.default), null, isOpen && /*#__PURE__*/ $4fqPo.createElement((0, $bjlDd.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $isBvF.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $4fqPo.createElement((0, $6zx4f.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $aCmbs.messages).check_this_link))), /*#__PURE__*/ $4fqPo.createElement((0, $dOhHl.default), null, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), {
        ...(0, $aCmbs.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $4fqPo.createElement((0, $iByhD.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $gbw4j.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $lszf6.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $aCmbs.messages).go_back)), /*#__PURE__*/ $4fqPo.createElement((0, $lszf6.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $aCmbs.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $4fqPo.createElement((0, $99BhM.default), {
        locale: "en"
    }, content);
};
const $21328473fd1ac8ec$var$_default_1 = (0, $3rTf2.default)($21328473fd1ac8ec$var$WarningModal, {
    enforceContext: false
});
var $21328473fd1ac8ec$export$2e2bcd8739ae039 = $21328473fd1ac8ec$var$_default_1;

});

parcelRegister("8cRtQ", function(module, exports) {
$parcel$export(module.exports, "useLinkWarningModal", () => $3a15f3b4c7037ba4$export$32b76c003683c2ec);

var $4fqPo = parcelRequire("4fqPo");

var $ew3Bn = parcelRequire("ew3Bn");

var $5qbnd = parcelRequire("5qbnd");

var $fShv5 = parcelRequire("fShv5");
const $3a15f3b4c7037ba4$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $3a15f3b4c7037ba4$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $4fqPo.useState)(null);
    const [url, setUrl] = (0, $4fqPo.useState)(null);
    const [isOpen, setIsOpen] = (0, $4fqPo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $fShv5.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $fShv5.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $5qbnd.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $3a15f3b4c7037ba4$var$toUrl(href, window.location.origin);
        const linkTextUrl = $3a15f3b4c7037ba4$var$toUrl(normalisedUrlFromLinkText, hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = (hrefUrl === null || hrefUrl === void 0 ? void 0 : hrefUrl.origin) === currentAtlassianProductOrigin && (linkTextUrl === null || linkTextUrl === void 0 ? void 0 : linkTextUrl.origin) === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("5qbnd", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", () => $b3afb3caf732bdae$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $b3afb3caf732bdae$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $jVatr = parcelRequire("jVatr");
const $b3afb3caf732bdae$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($jVatr)))();
$b3afb3caf732bdae$var$linkify.add('sourcetree:', 'http:');
$b3afb3caf732bdae$var$linkify.add('jamfselfservice:', 'http:');
$b3afb3caf732bdae$var$linkify.add('notes:', 'http:');
const $b3afb3caf732bdae$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $b3afb3caf732bdae$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$b3afb3caf732bdae$var$tlds.push($b3afb3caf732bdae$var$tlds2Char);
$b3afb3caf732bdae$var$linkify.tlds($b3afb3caf732bdae$var$tlds, false);
const $b3afb3caf732bdae$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $b3afb3caf732bdae$var$normaliseLinkHref = (url)=>{
    const match = $b3afb3caf732bdae$var$getLinkMatch(url);
    return match && match.url || null;
};
const $b3afb3caf732bdae$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $b3afb3caf732bdae$export$6f7d7761b97f967(str);
    if (!match.length) match = $b3afb3caf732bdae$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $b3afb3caf732bdae$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $b3afb3caf732bdae$export$6f7d7761b97f967 = (text)=>{
    const matches = [];
    if (!$b3afb3caf732bdae$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($b3afb3caf732bdae$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($b3afb3caf732bdae$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};
const $b3afb3caf732bdae$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $b3afb3caf732bdae$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $b3afb3caf732bdae$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($b3afb3caf732bdae$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $b3afb3caf732bdae$var$normaliseLinkHref(urlWithoutNewlines);
}

});




parcelRegister("gs4ys", function(module, exports) {
$parcel$export(module.exports, "LinkUrlEmotion", () => $f6f1c995085ba66a$export$bcc8540ceca8fa1c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /**
 * Emotion branch of the `platform_editor_static_css` experiment.
 * Used via `componentWithCondition` in `link.tsx`.
 *
 * Cleanup: delete this file once the experiment has shipped.
 */ 
var $lqVX7 = parcelRequire("lqVX7");

var $d5ghN = parcelRequire("d5ghN");
function $f6f1c995085ba66a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6f1c995085ba66a$var$anchorStyles = {
    name: "sa5fy1",
    styles: "color:var(--ds-link, #1868DB);&:hover{color:var(--ds-link, #1868DB);text-decoration:underline;}&:active{color:var(--ds-link-pressed, #1558BC);}"
};
const $f6f1c995085ba66a$export$bcc8540ceca8fa1c = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $lqVX7.jsx)((0, $d5ghN.default), {
        css: $f6f1c995085ba66a$var$anchorStyles,
        ...props
    });

});


parcelRegister("coAxj", function(module, exports) {
$parcel$export(module.exports, "default", () => $327d7cb987294aa5$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $327d7cb987294aa5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        ...props.dataAttributes,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            textDecoration: 'line-through'
        }
    }, props.children);
}

});

parcelRegister("4pNp9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4a96cc6c0e12a5b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $d4a96cc6c0e12a5b$export$2e2bcd8739ae039(props) {
    // ignore the eslint warning Text primitive does not support dataAttributes
    // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/design-system/use-primitives-text
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("80ADx", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9f40bab92c9ca6d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
const $b9f40bab92c9ca6d$var$isSub = (type)=>{
    return type === 'sub';
};
function $b9f40bab92c9ca6d$export$2e2bcd8739ae039(props) {
    if ($b9f40bab92c9ca6d$var$isSub(props.type)) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("sub", props.dataAttributes, props.children);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("fx4io", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a8c32b9626bde9c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $9DIXD = parcelRequire("9DIXD");

var $5bCMl = parcelRequire("5bCMl");

var $a1GvG = parcelRequire("a1GvG");
function $6a8c32b9626bde9c$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $5bCMl.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $5bCMl.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $9DIXD.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $4fqPo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("5bCMl", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $8d4cd7401d2f344e$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $8d4cd7401d2f344e$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $8d4cd7401d2f344e$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $8d4cd7401d2f344e$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #357DE8)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #1558BC)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #2898BD)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #206A83)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #22A06B)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #216E4E)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FCA700)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #E06C00)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #C9372C)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #AE2E24)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #AF59E1)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #803FA5)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #7D818A)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #292A2E)",
    // source for hex code was legacy token N800
    // lime
    /** lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** lime - medium */ ['#6A9A23']: "var(--ds-icon-accent-lime, #6A9A23)",
    /** lime - strong */ ['#4C6B1F']: "var(--ds-text-accent-lime, #4C6B1F)",
    // orange
    /** orange - light */ ['#FCE4A6']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** orange - medium */ ['#E06C00']: "var(--ds-icon-accent-orange, #E06C00)",
    /** orange - strong */ ['#9E4C00']: "var(--ds-text-accent-orange, #9E4C00)",
    // magenta
    /** magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** magenta - medium */ ['#CD519D']: "var(--ds-icon-accent-magenta, #CD519D)",
    /** magenta - strong */ ['#943D73']: "var(--ds-text-accent-magenta, #943D73)",
    // yellow
    /** yellow - medium */ ['#B38600']: "var(--ds-icon-accent-yellow, #B38600)",
    /** yellow - strong */ ['#7F5F01']: "var(--ds-text-accent-yellow, #7F5F01)"
};

});


parcelRegister("j0Ulr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4410bcce4e64869$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $9DIXD = parcelRequire("9DIXD");

var $9wQkl = parcelRequire("9wQkl");

var $a1GvG = parcelRequire("a1GvG");
function $a4410bcce4e64869$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $a1GvG.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $9wQkl.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $9DIXD.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $4fqPo.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    if (props.isStandalone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        "data-block-mark": props.dataAttributes['data-block-mark'],
        "data-renderer-mark": props.dataAttributes['data-renderer-mark'],
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "background-color-padding-left background-color-padding-right"
    }, props.children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("9wQkl", function(module, exports) {
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $dcd48820991fb73f$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $dcd48820991fb73f$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ ['#F8E6A0']: "var(--ds-background-accent-yellow-subtler, #F5E989)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #EED7FC)",
    /** Blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    /** Green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #BAF3DB)"
};
function $dcd48820991fb73f$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $dcd48820991fb73f$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("cwmYV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ffe2533760b274d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $4ffe2533760b274d$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("jnwnE", function(module, exports) {
$parcel$export(module.exports, "default", () => $19b362d85cd55fc8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lqVX7 = parcelRequire("lqVX7");

var $faPFq = parcelRequire("faPFq");

var $hdn08 = parcelRequire("hdn08");

var $4mqcS = parcelRequire("4mqcS");

var $jANeU = parcelRequire("jANeU");
function $19b362d85cd55fc8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Legacy centering (breaks position: sticky in nested content).
const $19b362d85cd55fc8$var$legacyWrapperStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $faPFq.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
const $19b362d85cd55fc8$var$flexWrapperStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $faPFq.blockNodesVerticalMargin)} 0`
});
// Flex item: no vertical margin so flex container height = content height (matches legacy single-wrapper height).
// flexShrink: 0 so the inner div keeps its width (matches legacy behaviour; flex items default to flex-shrink: 1).
const $19b362d85cd55fc8$var$innerWrapperStyles = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $19b362d85cd55fc8$var$getWidth = (width, mode)=>{
    if ((0, $hdn08.editorExperiment)('advanced_layouts', true) && width) return `min(${width}px, var(--ak-editor--breakout-container-without-gutter-width))`;
    else {
        if ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) {
            if (mode === 'max' || typeof width === 'number' && width >= (0, $faPFq.akEditorFullWidthLayoutWidth)) return `min(${0, $faPFq.akEditorMaxLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        }
        if (mode === 'full-width') return `min(${0, $faPFq.akEditorFullWidthLayoutWidth}px, var(--ak-editor--breakout-container-without-gutter-width))`;
        if (mode === 'wide') return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor--breakout-container-without-gutter-width))`;
    }
};
function $19b362d85cd55fc8$export$2e2bcd8739ae039(props) {
    const width = $19b362d85cd55fc8$var$getWidth('width' in props ? props.width : null, props.mode);
    const useStickySafeCentering = (0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true);
    if (useStickySafeCentering) return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $jANeU.RendererCssClassName).STICKY_SAFE_BREAKOUT_WRAPPER + ' ' + (0, $jANeU.RendererCssClassName).FLEX_CENTER_WRAPPER,
        css: $19b362d85cd55fc8$var$flexWrapperStyles
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $19b362d85cd55fc8$var$innerWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `${(0, $jANeU.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} fabric-editor-breakout-mark fabric-editor-block-mark`,
        "data-mode": props.mode,
        ...(0, $hdn08.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: width
        }
    }, props.children));
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $19b362d85cd55fc8$var$legacyWrapperStyles,
        "data-mode": props.mode,
        ...(0, $hdn08.editorExperiment)('advanced_layouts', true) && {
            'data-has-width': !!props.width,
            'data-width': props.width
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: $19b362d85cd55fc8$var$getWidth('width' in props ? props.width : null, props.mode)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-breakout-mark fabric-editor-block-mark"
    }, props.children);
}

});

parcelRegister("4wnEE", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfb92724e947ec94$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $420HY = parcelRequire("420HY");
const $bfb92724e947ec94$var$MarkWrapper = (props)=>{
    const dataAlign = props['data-align'] ? (0, $420HY.alignmentPositionMap)[props['data-align']] : undefined;
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        style: {
            textAlign: dataAlign
        },
        ...props
    }, props.children);
};
function $bfb92724e947ec94$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lqVX7.jsx)($bfb92724e947ec94$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("eGb4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $c27942c9b8ae710b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $c27942c9b8ae710b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}

});

parcelRegister("bNpnv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f3896e60a5e49ec$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $2f3896e60a5e49ec$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("7574F", function(module, exports) {
$parcel$export(module.exports, "default", () => $4251246f30dc7700$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $4251246f30dc7700$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("brTO7", function(module, exports) {
$parcel$export(module.exports, "default", () => $87b1f23642498d55$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $87b1f23642498d55$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrapperElement, {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("7RAx6", function(module, exports) {
$parcel$export(module.exports, "default", () => $25c529761031a3d9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $25c529761031a3d9$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("lFgdu", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bbed71b0f77aba8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $lqVX7 = parcelRequire("lqVX7");
function $9bbed71b0f77aba8$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("3VcXG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b333913c80bcf5ad$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $b333913c80bcf5ad$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-font-size",
        "data-font-size": props.fontSize
    }, props.children);
}

});

parcelRegister("9LbqE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9cb7d840302870c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
class $e9cb7d840302870c$export$2e2bcd8739ae039 extends (0, $4fqPo.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}

});


parcelRegister("dn2ZZ", function(module, exports) {
$parcel$export(module.exports, "insideBreakoutLayout", () => $2bdc171fb24c70e2$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBreakoutExpand", () => $2bdc171fb24c70e2$export$3e763fd7277c58c5);
$parcel$export(module.exports, "insideBlockNode", () => $2bdc171fb24c70e2$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $2bdc171fb24c70e2$export$9f1e9347b0411934);
$parcel$export(module.exports, "insideTable", () => $2bdc171fb24c70e2$export$244bf4b32387ef62);
$parcel$export(module.exports, "getNestedUnderNodes", () => $2bdc171fb24c70e2$export$a8df1f99c673fa27);
const $2bdc171fb24c70e2$var$isLayoutNode = (node)=>node.type.name === 'layoutSection';
const $2bdc171fb24c70e2$var$isExpandNode = (node)=>node.type.name === 'expand';
const $2bdc171fb24c70e2$var$hasBreakOutMark = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $2bdc171fb24c70e2$export$d7bc71cca336a3b = (path)=>path.some((item)=>$2bdc171fb24c70e2$var$isLayoutNode(item) && $2bdc171fb24c70e2$var$hasBreakOutMark(item));
const $2bdc171fb24c70e2$export$3e763fd7277c58c5 = (path)=>path.some((item)=>$2bdc171fb24c70e2$var$isExpandNode(item) && $2bdc171fb24c70e2$var$hasBreakOutMark(item));
const $2bdc171fb24c70e2$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $2bdc171fb24c70e2$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};
const $2bdc171fb24c70e2$export$244bf4b32387ef62 = (path, schema)=>{
    const { nodes: { table: table } } = schema;
    return path.some((n)=>n.type === table);
};
const $2bdc171fb24c70e2$export$a8df1f99c673fa27 = (path, nodeTypeNames)=>{
    for (const node of path){
        if (nodeTypeNames.includes(node.type.name)) return node.type.name;
    }
    return undefined;
};

});

parcelRegister("e3v0G", function(module, exports) {
$parcel$export(module.exports, "getStandaloneBackgroundColorMarks", () => $3bf0ba310537bcd0$export$eeb66772b38d7581);

var $hvgSB = parcelRequire("hvgSB");
const $3bf0ba310537bcd0$export$eeb66772b38d7581 = (content)=>{
    const standaloneMarks = [];
    // keep track of the previous node's state
    let prev = {
        selfSpaceOnTheRight: true // initial value to handle leading BackgroundColor
    };
    let prevNode = null;
    // Iterates through each node in the content array.
    // Tracks if the previous node had a backgroundColor mark and if it ended with a space.
    // If a backgroundColor mark is followed by a text node that starts with a space,
    // and the previous node ended with a space, the previous backgroundColor mark is considered standalone.
    // At the end, flushes any remaining node that meets the standalone criteria.
    for(let i = 0; i < content.length; i++){
        const node = content[i];
        const nodeMarks = (0, $hvgSB.default).getMarks(node);
        const isBackgroundColor = nodeMarks.some((m)=>m.type.name === 'backgroundColor');
        let selfSpaceOnTheLeft = false;
        let selfSpaceOnTheRight = false;
        if (node.text) {
            selfSpaceOnTheLeft = node.text.startsWith(' ');
            selfSpaceOnTheRight = node.text.endsWith(' ');
        }
        if (isBackgroundColor) {
            prevNode = node;
            prev = {
                selfSpaceOnTheRight: false,
                hasBackgroundColor: true,
                spaceToTheLeft: prev !== null && prev.selfSpaceOnTheRight
            };
        } else {
            // If prev exists, check for standalone logic
            if (prev && prev.hasBackgroundColor && prevNode) // If prev had space on the left and current is a TextNode and has space on the left
            {
                if (prev.spaceToTheLeft && selfSpaceOnTheLeft) {
                    const mark = (0, $hvgSB.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
                    if (mark) standaloneMarks.push(mark);
                }
            }
            prevNode = null;
            prev = {
                selfSpaceOnTheRight: selfSpaceOnTheRight,
                hasBackgroundColor: false
            };
        }
    }
    if (prevNode) {
        if (prev && prev.hasBackgroundColor && prev.spaceToTheLeft) {
            const mark = (0, $hvgSB.default).getMarks(prevNode).find((m)=>m.type.name === 'backgroundColor');
            if (mark) standaloneMarks.push(mark);
        }
    }
    return standaloneMarks;
};

});

parcelRegister("bEUKa", function(module, exports) {
$parcel$export(module.exports, "markBlockAsInline", () => $3034a632d687043e$export$3a88c97d9b0d8d1c);
function $3034a632d687043e$export$3a88c97d9b0d8d1c({ nodes: nodes, onMark: onMark, parentPos: parentPos, shouldDisplayExtensionAsInline: shouldDisplayExtensionAsInline }) {
    if (!nodes || nodes.length === 0 || nodes[0].isInline) return;
    function isInlineBodiedExtension(node) {
        var _node$attrs, _node$attrs2, _node$attrs3, _node$attrs4;
        return Boolean((node === null || node === void 0 ? void 0 : node.type.name) === 'bodiedExtension' && shouldDisplayExtensionAsInline({
            type: node.type.name,
            extensionKey: (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionKey,
            extensionType: (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionType,
            parameters: (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.parameters,
            content: node.content,
            localId: (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId
        }));
    }
    try {
        let prevPos = parentPos;
        let pos = parentPos;
        let prevTextBlockType;
        for (const [index, node] of nodes.entries()){
            const prevNode = nodes[index - 1];
            // textblock + inlinedBodiedExtension
            if (prevNode !== null && prevNode !== void 0 && prevNode.isTextblock && isInlineBodiedExtension(node)) onMark({
                pos: prevPos
            });
            else if (isInlineBodiedExtension(prevNode) && node.isTextblock && (!prevTextBlockType || node.type === prevTextBlockType)) onMark({
                pos: pos
            });
            if (!isInlineBodiedExtension(node)) prevTextBlockType = node.isTextblock ? node.type : undefined;
            prevPos = pos;
            pos += node.nodeSize;
        }
    } catch  {}
}

});


parcelRegister("6x4pz", function(module, exports) {
$parcel$export(module.exports, "renderDocument", () => $070f31342a5cf23c$export$59a54f98b9753d5c);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $eevQH = parcelRequire("eevQH");

var $7pxNy = parcelRequire("7pxNy");
var $6H5aI = parcelRequire("6H5aI");
var $4UFgs = parcelRequire("4UFgs");
var $cMDK4 = parcelRequire("cMDK4");

var $f0GG4 = parcelRequire("f0GG4");

var $2kuA8 = parcelRequire("2kuA8");
var $66an8 = parcelRequire("66an8");

var $ltgAj = parcelRequire("ltgAj");

var $3H4LK = parcelRequire("3H4LK");

var $4mqcS = parcelRequire("4mqcS");

var $jE04u = parcelRequire("jE04u");

var $dQtpO = parcelRequire("dQtpO");

var $lmPm1 = parcelRequire("lmPm1");

var $kNCrc = parcelRequire("kNCrc");
const $070f31342a5cf23c$var$SUPPORTS_HIRES_TIMER_API = !!(typeof window !== 'undefined' && window.performance && performance.now);
const $070f31342a5cf23c$var$withStopwatch = (cb)=>{
    const startTime = $070f31342a5cf23c$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $070f31342a5cf23c$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $070f31342a5cf23c$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $4UFgs.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $f0GG4.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
        });
        result = skipValidation ? transformedAdf || doc : (0, $66an8.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent, validationOverrides);
    } else result = (0, $ltgAj.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    // Convert nested-table extensions into nested tables
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $cMDK4.transformNestedTablesIncomingDocument)(result);
        if (isTransformed) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $f0GG4.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
                eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $f0GG4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $dQtpO.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
            }
        });
    }
    // Upgrade panel → panel_c1 where the schema allows it
    if (result && (0, $4mqcS.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $6H5aI.transformContainerNodes)(result, schema);
        if (isTransformed && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $f0GG4.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
                eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            result = transformedAdf;
        }
    } catch (e) {
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $f0GG4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $dQtpO.PLATFORM).WEB,
                errorStack: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel to panel_c1' : undefined}`
            }
        });
    }
    if (result && !(0, $4mqcS.expValEquals)('cc-maui-experiment', 'isEnabled', true) && !(0, $3H4LK.fg)('platform_native_embeds_rollout_non_maui_experience') && (0, $3H4LK.fg)('platform_editor_native_embeds_fallback_transform')) {
        const { transformedAdf: transformedAdf, hasValidTransform: hasValidTransform } = (0, $7pxNy.nativeEmbedsFallbackTransform)(result, schema);
        if (hasValidTransform && transformedAdf) {
            dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
                action: (0, $f0GG4.ACTION).NATIVE_EMBEDS_TRANSFORMED,
                actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
                eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
            });
            result = transformedAdf;
        }
    }
    return result;
};
const $070f31342a5cf23c$var$memoValidation = (0, $jE04u.default)($070f31342a5cf23c$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ newSkipValidation, newValidationOverrides] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator, , /* ignoring dispatchAnalyticsEvent */ oldSkipValidation, oldValidationOverrides] = lastArgs;
    return $070f31342a5cf23c$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator && newSkipValidation === oldSkipValidation && newValidationOverrides === oldValidationOverrides;
});
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $070f31342a5cf23c$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $070f31342a5cf23c$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $070f31342a5cf23c$var$memoSerializeFragment = (0, $jE04u.default)($070f31342a5cf23c$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $070f31342a5cf23c$var$areDocsEqual(newDoc, oldDoc);
});
const $070f31342a5cf23c$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $f0GG4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $dQtpO.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $070f31342a5cf23c$var$memoCreateNodeAndCheck = (0, $jE04u.default)($070f31342a5cf23c$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $070f31342a5cf23c$var$areDocsEqual(newDoc, oldDoc);
});
const $070f31342a5cf23c$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $eevQH.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance, includeNodesCountInStats, skipValidation, validationOverrides)=>{
    const stat = {
        sanitizeTime: 0
    };
    if ((0, $3H4LK.fg)('platform_editor_renderer_rm_usespecbasedvalidator')) useSpecBasedValidator = true;
    const { output: validDoc, time: sanitizeTime } = $070f31342a5cf23c$var$withStopwatch(()=>{
        return $070f31342a5cf23c$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent, skipValidation, validationOverrides);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $070f31342a5cf23c$var$withStopwatch(()=>{
        return $070f31342a5cf23c$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $070f31342a5cf23c$var$withStopwatch(()=>{
        return $070f31342a5cf23c$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $2kuA8.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking !== null && unsupportedContentLevelsTracking !== void 0 && unsupportedContentLevelsTracking.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $lmPm1.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    if (includeNodesCountInStats) stat.nodesCount = (0, $kNCrc.countNodes)(doc);
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("7pxNy", function(module, exports) {
$parcel$export(module.exports, "nativeEmbedsFallbackTransform", () => $332516c768f7a4e8$export$fdee1e5f1664414c);

var $jFbx9 = parcelRequire("jFbx9");

var $hf7pc = parcelRequire("hf7pc");
const $332516c768f7a4e8$var$NATIVE_EMBED_EXTENSION_KEY = 'native-embed';
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows an `embedCard` child. Returns an empty set if the
 * schema does not declare an `embedCard` node.
 */ const $332516c768f7a4e8$var$getEmbedCardAllowedParentTypes = (schema)=>{
    const embedCardType = schema.nodes.embedCard;
    if (!embedCardType) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes)){
        var _nodeType$contentMatc;
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(embedCardType)) allowed.add(nodeType.name);
    }
    return allowed;
};
const $332516c768f7a4e8$export$fdee1e5f1664414c = (adf, schema)=>{
    const embedCardAllowedParentTypes = $332516c768f7a4e8$var$getEmbedCardAllowedParentTypes(schema);
    const isEmbedCardAllowedInParent = (parent)=>{
        var _parent$node;
        const parentType = parent === null || parent === void 0 || (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type;
        return parentType ? embedCardAllowedParentTypes.has(parentType) : false;
    };
    let didTransform = false;
    const transformedAdf = (0, $jFbx9.traverse)(adf, {
        extension: (node, parent)=>{
            var _node$attrs, _node$attrs2;
            if (((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs['extensionKey'].split(':')[0]) !== $332516c768f7a4e8$var$NATIVE_EMBED_EXTENSION_KEY) return node;
            const url = (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2['parameters']) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.macroParams) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.url) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.value;
            if (!url) {
                didTransform = true;
                return false;
            }
            didTransform = true;
            if (isEmbedCardAllowedInParent(parent)) return {
                type: 'embedCard',
                attrs: {
                    url: url,
                    layout: 'center'
                }
            };
            return {
                type: 'paragraph',
                content: [
                    {
                        type: 'inlineCard',
                        attrs: {
                            url: url
                        }
                    }
                ]
            };
        }
    });
    if (didTransform && transformedAdf) try {
        const validate = (0, $hf7pc.validator)();
        const { valid: valid } = validate(transformedAdf);
        if (!valid) // Transformed ADF is invalid – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    } catch  {
        // Validation threw – fall back to the original document
        return {
            transformedAdf: adf,
            hasValidTransform: false
        };
    }
    return {
        transformedAdf: transformedAdf,
        hasValidTransform: didTransform
    };
};

});
parcelRegister("hf7pc", function(module, exports) {
$parcel$export(module.exports, "validator", () => $10c6ff830688aca8$export$956325f45c5d174a);

var $2vYga = parcelRequire("2vYga");

var $lAoLJ = parcelRequire("lAoLJ");

var $5uGR9 = parcelRequire("5uGR9");

var $4RXyg = parcelRequire("4RXyg");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $10c6ff830688aca8$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
           * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
           * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
           */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $10c6ff830688aca8$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Checks if a spec is a variant spec.
 * A variant spec is an array where the first element is a string (base spec name)
 * and the second element is a ValidatorSpec object { props: { ... } }
 */ const $10c6ff830688aca8$var$isVariant = (spec)=>typeof spec === 'object' && !!spec && 0 in spec && 1 in spec && typeof spec[0] === 'string' && typeof spec[1] === 'object';
function $10c6ff830688aca8$export$a49afc9edc88765c(nodes, marks) {
    const variantOverrides = $10c6ff830688aca8$var$getVariantSpecOverrides();
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys($2vYga).reduce((newSpecs, k)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let spec = {
            ...$2vYga[k]
        };
        if ($10c6ff830688aca8$var$isVariant(spec) && Object.values(variantOverrides).includes(k)) // When the spec is a variant it will be in the form of ['base_spec_name', { props: { ... } }]
        // The actual validator spec of the variant will be the second item in the array
        spec = {
            ...spec[1]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $lAoLJ.isString)(spec.props.content)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                spec.props.content = $2vYga[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
           * Flatten
           *
           * Input:
           * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
           *
           * Output:
           * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
           */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items.map((item)=>(0, $lAoLJ.isString)(item) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Array.isArray($2vYga[item]) ? // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    $2vYga[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>// Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        Array.isArray($2vYga[subItem]) ? // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        $2vYga[subItem] : (0, $lAoLJ.isString)(subItem) ? subItem : // Now `NoMark` produces `items: []`, should be fixed in generator
                        [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                var _subItem$;
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && (_subItem$ = subItem[1]) !== null && _subItem$ !== void 0 && (_subItem$ = _subItem$.props) !== null && _subItem$ !== void 0 && (_subItem$ = _subItem$.content) !== null && _subItem$ !== void 0 && _subItem$.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
        * TODO: Probably try something like immer, but it's 3.3kb gzipped.
        * Not worth it just for this.
        */ [
                            subItem[0],
                            $10c6ff830688aca8$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $10c6ff830688aca8$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $10c6ff830688aca8$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $10c6ff830688aca8$export$66c739158ef99a42(spec, value) {
    if (!(0, $lAoLJ.isDefined)(value)) return !!spec.optional;
    if ($10c6ff830688aca8$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $10c6ff830688aca8$var$partitionObject(spec.props, (key, subSpec)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            $10c6ff830688aca8$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $lAoLJ.isDefined)(spec.type)) return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $lAoLJ.isBoolean)(value);
        case 'number':
            return (0, $lAoLJ.isNumber)(value) && ((0, $lAoLJ.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $lAoLJ.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $lAoLJ.isInteger)(value) && ((0, $lAoLJ.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $lAoLJ.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $lAoLJ.isDefined)((0, $4RXyg.validatorFnMap)[rule]) && (0, $4RXyg.validatorFnMap)[rule](value);
            return (0, $lAoLJ.isString)(value) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            ((0, $lAoLJ.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $lAoLJ.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $lAoLJ.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$10c6ff830688aca8$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$10c6ff830688aca8$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $lAoLJ.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $10c6ff830688aca8$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $10c6ff830688aca8$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $10c6ff830688aca8$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $10c6ff830688aca8$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else {
        var _parentSpec$props;
        return errorCallback({
            ...child
        }, {
            code: 'INVALID_CONTENT',
            message: message,
            meta: {
                parentType: parentSpec === null || parentSpec === void 0 || (_parentSpec$props = parentSpec.props) === null || _parentSpec$props === void 0 || (_parentSpec$props = _parentSpec$props.type) === null || _parentSpec$props === void 0 ? void 0 : _parentSpec$props.values[0]
            }
        }, $10c6ff830688aca8$var$getUnsupportedOptions(parentSpec));
    }
};
const $10c6ff830688aca8$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $10c6ff830688aca8$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $10c6ff830688aca8$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
/**
 * Returns a map of base spec names to a preferred variant spec that should be used
 * in their place during validation. Implemented as a getter function so that entries
 * can be conditionally included behind feature gates.
 *
 * WARNING: The variant spec must be a strict superset of the base spec, i.e. any content valid
 * under the base spec must also be valid under the variant.
 */ const $10c6ff830688aca8$var$getVariantSpecOverrides = ()=>{
    return {};
};
/**
 * Replaces base validator specs with their designated variant overrides.
 */ const $10c6ff830688aca8$var$applyVariantSpecOverrides = (validatorSpecs)=>{
    Object.entries($10c6ff830688aca8$var$getVariantSpecOverrides()).forEach(([base, variant])=>{
        const baseSpec = validatorSpecs[base];
        const variantOverride = validatorSpecs[variant];
        if (baseSpec !== null && baseSpec !== void 0 && baseSpec.props && variantOverride !== null && variantOverride !== void 0 && variantOverride.props && typeof baseSpec.props === 'object' && typeof variantOverride.props === 'object') // Merge variant overrides INTO the base spec
        baseSpec.props = {
            ...baseSpec.props,
            // keeps type, attrs, marks, etc.
            ...variantOverride.props // overrides content (and anything else the variant changes)
        };
    });
};
function $10c6ff830688aca8$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $10c6ff830688aca8$export$a49afc9edc88765c(nodes, marks);
    $10c6ff830688aca8$var$applyVariantSpecOverrides(validatorSpecs);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        if (!allowed) for (const allowed of (0, $5uGR9.extractAllowedContent)(validatorSpecs, entity)){
            const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
            if (validationResult.valid) return {
                entity: validationResult.entity,
                valid: validationResult.valid
            };
        }
        // If `allowed` was provided or we haven't passed yet, return the initial result
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        const newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $10c6ff830688aca8$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $10c6ff830688aca8$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $10c6ff830688aca8$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $10c6ff830688aca8$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $lAoLJ.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.text) {
            if ((0, $lAoLJ.isDefined)(prevEntity.text) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            !$10c6ff830688aca8$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (validatorSpec.props.content && prevEntity.content) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $lAoLJ.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $lAoLJ.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $lAoLJ.makeArray)(validatorSpec.props.attrs);
            /**
       * Attrs can be union type so try each path
       * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
       * Gotcha: It will always report the last failure.
       */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $10c6ff830688aca8$var$partitionObject(attrOption.props, (key, spec)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const valueToValidate = prevEntity.attrs[key];
                    return $10c6ff830688aca8$export$66c739158ef99a42(spec, valueToValidate);
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $10c6ff830688aca8$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $10c6ff830688aca8$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $10c6ff830688aca8$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    attributes) {
        const message = $10c6ff830688aca8$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        const invalidValues = {};
        // eslint-disable-next-line guard-for-in
        for(const invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $10c6ff830688aca8$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        const result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $10c6ff830688aca8$var$partitionObject(prevEntity, (k)=>// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $lAoLJ.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $lAoLJ.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        const specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $10c6ff830688aca8$var$partitionObject(validatorSpec.props, (k, v)=>{
            var _validatorSpec$requir;
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !((_validatorSpec$requir = validatorSpec.required) !== null && _validatorSpec$requir !== void 0 && _validatorSpec$requir.includes(k)) : typeof v === 'object' && v !== null && 'optional' in v ? v.optional : false;
            return isOptional || (0, $lAoLJ.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $10c6ff830688aca8$var$unsupportedMarkContent(// Ignored via go/ees005
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $lAoLJ.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $lAoLJ.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $10c6ff830688aca8$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
             * When there's multiple possible branches try all of them.
             * If all of them fails, throw the first one.
             * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
             */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $10c6ff830688aca8$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("2vYga", function(module, exports) {
$parcel$export(module.exports, "alignment", () => (parcelRequire("a1nmo")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("a1nmo")).annotation);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("a1nmo")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("a1nmo")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("a1nmo")).block_content);
$parcel$export(module.exports, "blockRootOnly", () => (parcelRequire("a1nmo")).blockRootOnly);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("a1nmo")).blockquote);
$parcel$export(module.exports, "blockTaskItem", () => (parcelRequire("a1nmo")).blockTaskItem);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("a1nmo")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("a1nmo")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("a1nmo")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("a1nmo")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("a1nmo")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("a1nmo")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("a1nmo")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("a1nmo")).codeBlock);
$parcel$export(module.exports, "codeBlock_root_only", () => (parcelRequire("a1nmo")).codeBlock_root_only);
$parcel$export(module.exports, "text_with_no_marks", () => (parcelRequire("a1nmo")).text_with_no_marks);
$parcel$export(module.exports, "confluenceInlineComment", () => (parcelRequire("a1nmo")).confluenceInlineComment);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("a1nmo")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("a1nmo")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("a1nmo")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("a1nmo")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("a1nmo")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("a1nmo")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("a1nmo")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("a1nmo")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("a1nmo")).expand);
$parcel$export(module.exports, "expand_root_only", () => (parcelRequire("a1nmo")).expand_root_only);
$parcel$export(module.exports, "extension", () => (parcelRequire("a1nmo")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("a1nmo")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("a1nmo")).extension_with_marks);
$parcel$export(module.exports, "fontSize", () => (parcelRequire("a1nmo")).fontSize);
$parcel$export(module.exports, "fragment", () => (parcelRequire("a1nmo")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("a1nmo")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("a1nmo")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("a1nmo")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("a1nmo")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("a1nmo")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("a1nmo")).indentation);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("a1nmo")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("a1nmo")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("a1nmo")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_content", () => (parcelRequire("a1nmo")).inline_content);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("a1nmo")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("a1nmo")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("a1nmo")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("a1nmo")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("a1nmo")).link);
$parcel$export(module.exports, "listItem", () => (parcelRequire("a1nmo")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("a1nmo")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("a1nmo")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("a1nmo")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("a1nmo")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("a1nmo")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("a1nmo")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("a1nmo")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("a1nmo")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("a1nmo")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("a1nmo")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("a1nmo")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("a1nmo")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a1nmo")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("a1nmo")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("a1nmo")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("a1nmo")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_font_size", () => (parcelRequire("a1nmo")).paragraph_with_font_size);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("a1nmo")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("a1nmo")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("a1nmo")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("a1nmo")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("a1nmo")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("a1nmo")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("a1nmo")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("a1nmo")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("a1nmo")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("a1nmo")).tableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("a1nmo")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("a1nmo")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("a1nmo")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("a1nmo")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("a1nmo")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("a1nmo")).textColor);
$parcel$export(module.exports, "text_code_inline", () => (parcelRequire("a1nmo")).text_code_inline);
$parcel$export(module.exports, "text_formatted", () => (parcelRequire("a1nmo")).text_formatted);
$parcel$export(module.exports, "text_link_inline", () => (parcelRequire("a1nmo")).text_link_inline);
$parcel$export(module.exports, "underline", () => (parcelRequire("a1nmo")).underline);
$parcel$export(module.exports, "syncBlock", () => (parcelRequire("a1nmo")).syncBlock);
$parcel$export(module.exports, "bodiedSyncBlock", () => (parcelRequire("a1nmo")).bodiedSyncBlock);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $a1nmo = parcelRequire("a1nmo");

});
parcelRegister("a1nmo", function(module, exports) {
$parcel$export(module.exports, "alignment", () => $2184d18a998bc887$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $2184d18a998bc887$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $2184d18a998bc887$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $2184d18a998bc887$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $2184d18a998bc887$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $2184d18a998bc887$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $2184d18a998bc887$export$ebb5393736e9ba23);
$parcel$export(module.exports, "blockTaskItem", () => $2184d18a998bc887$export$16018c61064a18df);
$parcel$export(module.exports, "bodiedExtension", () => $2184d18a998bc887$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $2184d18a998bc887$export$ee052cc5b2356e83);
$parcel$export(module.exports, "bodiedSyncBlock", () => $2184d18a998bc887$export$e92c7e4302dd4371);
$parcel$export(module.exports, "border", () => $2184d18a998bc887$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $2184d18a998bc887$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $2184d18a998bc887$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $2184d18a998bc887$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $2184d18a998bc887$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $2184d18a998bc887$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $2184d18a998bc887$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $2184d18a998bc887$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $2184d18a998bc887$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $2184d18a998bc887$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $2184d18a998bc887$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $2184d18a998bc887$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $2184d18a998bc887$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $2184d18a998bc887$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $2184d18a998bc887$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $2184d18a998bc887$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $2184d18a998bc887$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $2184d18a998bc887$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $2184d18a998bc887$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $2184d18a998bc887$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $2184d18a998bc887$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fontSize", () => $2184d18a998bc887$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fragment", () => $2184d18a998bc887$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $2184d18a998bc887$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $2184d18a998bc887$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $2184d18a998bc887$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $2184d18a998bc887$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $2184d18a998bc887$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $2184d18a998bc887$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $2184d18a998bc887$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $2184d18a998bc887$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $2184d18a998bc887$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $2184d18a998bc887$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $2184d18a998bc887$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $2184d18a998bc887$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $2184d18a998bc887$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $2184d18a998bc887$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $2184d18a998bc887$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $2184d18a998bc887$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $2184d18a998bc887$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $2184d18a998bc887$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $2184d18a998bc887$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $2184d18a998bc887$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $2184d18a998bc887$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $2184d18a998bc887$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $2184d18a998bc887$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $2184d18a998bc887$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $2184d18a998bc887$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $2184d18a998bc887$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $2184d18a998bc887$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $2184d18a998bc887$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $2184d18a998bc887$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $2184d18a998bc887$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $2184d18a998bc887$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $2184d18a998bc887$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_font_size", () => $2184d18a998bc887$export$f745a1f9fa5e1ca8);
$parcel$export(module.exports, "paragraph_with_indentation", () => $2184d18a998bc887$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $2184d18a998bc887$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $2184d18a998bc887$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $2184d18a998bc887$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $2184d18a998bc887$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $2184d18a998bc887$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $2184d18a998bc887$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $2184d18a998bc887$export$b3401ee80eb31041);
$parcel$export(module.exports, "syncBlock", () => $2184d18a998bc887$export$faab0ca9701d7048);
$parcel$export(module.exports, "table", () => $2184d18a998bc887$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $2184d18a998bc887$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $2184d18a998bc887$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $2184d18a998bc887$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $2184d18a998bc887$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $2184d18a998bc887$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $2184d18a998bc887$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $2184d18a998bc887$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $2184d18a998bc887$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $2184d18a998bc887$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $2184d18a998bc887$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $2184d18a998bc887$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $2184d18a998bc887$export$425327af25286e5e);
const $2184d18a998bc887$export$8e53000a4ec837 = {
    props: {
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        }
    }
};
const $2184d18a998bc887$export$8512c9afa7b24c3b = {
    props: {
        attrs: {
            props: {
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                },
                id: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        }
    }
};
const $2184d18a998bc887$export$8c5a050822fd698c = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        }
    }
};
const $2184d18a998bc887$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
const $2184d18a998bc887$export$c4c2f833baaebdb8 = {
    props: {
        attrs: [
            {
                props: {
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    layout: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        optional: true,
                        type: 'string',
                        validatorFn: 'safeUrl'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $2184d18a998bc887$export$67dc04e652a298ca = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        }
    }
};
const $2184d18a998bc887$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $2184d18a998bc887$export$16018c61064a18df = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'blockTaskItem'
            ]
        }
    }
};
const $2184d18a998bc887$export$27903d543b563e39 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        }
    }
};
const $2184d18a998bc887$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$e92c7e4302dd4371 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'paragraph_with_no_marks',
                    'blockCard',
                    'blockquote',
                    'bulletList',
                    'codeBlock',
                    'decisionList',
                    'embedCard',
                    'expand',
                    'heading',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'heading_with_no_marks',
                    'layoutSection',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'mediaGroup',
                    'mediaSingle',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaSingle_width_type',
                    'orderedList',
                    'panel',
                    'rule',
                    'table',
                    'taskList'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bodiedSyncBlock'
            ]
        }
    }
};
const $2184d18a998bc887$export$1edee58a52776cd9 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                },
                size: {
                    maximum: 3,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        }
    }
};
const $2184d18a998bc887$export$89015c65f1c75e3f = {
    props: {
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        }
    }
};
const $2184d18a998bc887$export$a140c94e5ea26bee = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        }
    }
};
const $2184d18a998bc887$export$8e3c2dfdc4f0453d = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        }
    }
};
const $2184d18a998bc887$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $2184d18a998bc887$export$7bb0d5c671655cc4 = {
    props: {
        attrs: {
            optional: true,
            props: {
                hideLineNumbers: {
                    optional: true,
                    type: 'boolean'
                },
                language: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                uniqueId: {
                    optional: true,
                    type: 'string'
                },
                wrap: {
                    optional: true,
                    type: 'boolean'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        }
    }
};
const $2184d18a998bc887$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$f3b72f8fc4684ecd = {
    props: {
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        }
    }
};
const $2184d18a998bc887$export$3024f02c495408d6 = {
    props: {
        attrs: {
            props: {
                sources: {
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1,
                    type: 'array'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        }
    }
};
const $2184d18a998bc887$export$324d90190a8b822a = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        }
    }
};
const $2184d18a998bc887$export$6959e16eeff859b4 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        }
    }
};
const $2184d18a998bc887$export$62d45a65fb43d95e = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'decisionItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        }
    }
};
const $2184d18a998bc887$export$2a111da947c407d2 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only',
                    'syncBlock',
                    'bodiedSyncBlock'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        }
    }
};
const $2184d18a998bc887$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $2184d18a998bc887$export$be4283d9a1cb1ff6 = {
    props: {
        attrs: {
            props: {
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                originalHeight: {
                    optional: true,
                    type: 'number'
                },
                originalWidth: {
                    optional: true,
                    type: 'number'
                },
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        }
    }
};
const $2184d18a998bc887$export$a19185d1233fc4b2 = {
    props: {
        attrs: {
            props: {
                id: {
                    optional: true,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                shortName: {
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        }
    }
};
const $2184d18a998bc887$export$9f77e0932fb78f72 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        }
    }
};
const $2184d18a998bc887$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$1b45514b112dd749 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        }
    }
};
const $2184d18a998bc887$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$4fdcae991fd743e7 = {
    props: {
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        }
    }
};
const $2184d18a998bc887$export$85e3c3ca0c6fb93 = {
    props: {
        attrs: {
            props: {
                fontSize: {
                    type: 'enum',
                    values: [
                        'small'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fontSize'
            ]
        }
    }
};
const $2184d18a998bc887$export$f00aeb236b6f05af = {
    props: {
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        }
    }
};
const $2184d18a998bc887$export$371da9dd35aba193 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'enum',
                    values: [
                        '\n'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        }
    }
};
const $2184d18a998bc887$export$46e4a324ac90507f = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                },
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        }
    }
};
const $2184d18a998bc887$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'alignment'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                items: [
                    'indentation'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$480c699bd4ec0d86 = {
    props: {
        attrs: {
            props: {
                level: {
                    maximum: 6,
                    minimum: 1,
                    type: 'number'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        }
    }
};
const $2184d18a998bc887$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $2184d18a998bc887$export$cbf8224b64e0d942 = {
    props: {
        attrs: [
            {
                props: {
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $2184d18a998bc887$export$16b353b2649bd8d9 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        }
    }
};
const $2184d18a998bc887$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$ab76e7c03cd6f650 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                },
                width: {
                    maximum: 100,
                    minimum: 0,
                    type: 'number'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'block_content'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        }
    }
};
const $2184d18a998bc887$export$b3b6a70a7fa4a5be = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                'layoutColumn'
            ],
            maxItems: 3,
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        }
    }
};
const $2184d18a998bc887$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 3,
                minItems: 2,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                optional: true,
                props: {
                    columnRuleStyle: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'solid'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    }
                }
            },
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'layoutColumn'
                ],
                maxItems: 5,
                minItems: 1,
                type: 'array'
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$9c30223ca0a664fb = {
    props: {
        attrs: {
            props: {
                collection: {
                    optional: true,
                    type: 'string'
                },
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                id: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        }
    }
};
const $2184d18a998bc887$export$76c7e83ecc9cdf05 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_font_size',
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        }
    }
};
const $2184d18a998bc887$export$987d49ffe1b0900f = {
    props: {
        attrs: [
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    occurrenceKey: {
                        minLength: 1,
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            },
            {
                props: {
                    alt: {
                        optional: true,
                        type: 'string'
                    },
                    height: {
                        optional: true,
                        type: 'number'
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    url: {
                        type: 'string'
                    },
                    width: {
                        optional: true,
                        type: 'number'
                    }
                }
            }
        ],
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $2184d18a998bc887$export$2855e964765eac9 = {
    props: {
        content: {
            allowUnsupportedBlock: true,
            items: [
                'media'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        }
    }
};
const $2184d18a998bc887$export$38bab695e3f720f1 = {
    props: {
        attrs: {
            props: {
                alt: {
                    optional: true,
                    type: 'string'
                },
                collection: {
                    type: 'string'
                },
                data: {
                    optional: true,
                    type: 'object'
                },
                height: {
                    optional: true,
                    type: 'number'
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                type: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ]
                },
                url: {
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        marks: {
            items: [
                [
                    'dataConsumer',
                    'link',
                    'annotation',
                    'border'
                ]
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        }
    }
};
const $2184d18a998bc887$export$969fe3781ca15058 = {
    props: {
        attrs: [
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        maximum: 100,
                        minimum: 0,
                        optional: true,
                        type: 'number'
                    },
                    widthType: {
                        optional: true,
                        type: 'enum',
                        values: [
                            'percentage'
                        ]
                    }
                }
            },
            {
                props: {
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    localId: {
                        optional: true,
                        type: 'string'
                    },
                    width: {
                        minimum: 0,
                        type: 'number'
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    }
                }
            }
        ],
        marks: {
            items: [
                'link'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        }
    }
};
const $2184d18a998bc887$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                maxItems: 2,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                allowUnsupportedBlock: true,
                items: [
                    'media'
                ],
                maxItems: 1,
                minItems: 1,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$db83999c14438df4 = {
    props: {
        attrs: {
            props: {
                accessLevel: {
                    optional: true,
                    type: 'string'
                },
                id: {
                    type: 'string'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    optional: true,
                    type: 'string'
                },
                userType: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ]
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        }
    }
};
const $2184d18a998bc887$export$c3c04d555a8b9013 = {
    props: {
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                parameters: {
                    optional: true,
                    type: 'object'
                },
                text: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                'extensionFrame'
            ],
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        }
    }
};
const $2184d18a998bc887$export$63cadbf5f4296627 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                title: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: 'nestedExpand_content',
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $2184d18a998bc887$export$9584f52f3ebd5d7e = {
    allowUnsupportedBlock: true,
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_font_size',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    type: 'array'
};
const $2184d18a998bc887$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'paragraph_with_font_size',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $2184d18a998bc887$export$a5dc81035676e7a = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                order: {
                    minimum: 0,
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'listItem'
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        }
    }
};
const $2184d18a998bc887$export$21f42ab9b6679f44 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                panelColor: {
                    optional: true,
                    type: 'string'
                },
                panelIcon: {
                    optional: true,
                    type: 'string'
                },
                panelIconId: {
                    optional: true,
                    type: 'string'
                },
                panelIconText: {
                    optional: true,
                    type: 'string'
                },
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_font_size',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        }
    }
};
const $2184d18a998bc887$export$9c206ddddb32a9b = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        }
    }
};
const $2184d18a998bc887$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'alignment'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$f745a1f9fa5e1ca8 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    'fontSize'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                items: [
                    [
                        'fontSize',
                        'indentation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$c7187bbd1a7a9244 = {
    props: {
        attrs: {
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        }
    }
};
const $2184d18a998bc887$export$fbeb3a3956e8a3c7 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $2184d18a998bc887$export$471f7ae5c4103ae1 = {
    props: {
        attrs: {
            props: {
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                style: {
                    optional: true,
                    type: 'string'
                },
                text: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        }
    }
};
const $2184d18a998bc887$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $2184d18a998bc887$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $2184d18a998bc887$export$b3401ee80eb31041 = {
    props: {
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        }
    }
};
const $2184d18a998bc887$export$faab0ca9701d7048 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                resourceId: {
                    type: 'string'
                }
            }
        },
        marks: {
            items: [
                'breakout'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'syncBlock'
            ]
        }
    }
};
const $2184d18a998bc887$export$9852986a3ec5f6a0 = {
    props: {
        attrs: {
            optional: true,
            props: {
                displayMode: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ]
                },
                isNumberColumnEnabled: {
                    optional: true,
                    type: 'boolean'
                },
                layout: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ]
                },
                localId: {
                    minLength: 1,
                    optional: true,
                    type: 'string'
                },
                width: {
                    optional: true,
                    type: 'number'
                }
            }
        },
        content: {
            items: [
                'tableRow'
            ],
            minItems: 1,
            type: 'array'
        },
        marks: {
            items: [
                'fragment'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        }
    }
};
const $2184d18a998bc887$export$e1e720e5f4603e6a = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $2184d18a998bc887$export$48884d2a5190dc73 = {
    props: {
        attrs: {
            optional: true,
            props: {
                background: {
                    optional: true,
                    type: 'string'
                },
                colspan: {
                    optional: true,
                    type: 'number'
                },
                colwidth: {
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true,
                    type: 'array'
                },
                localId: {
                    optional: true,
                    type: 'string'
                },
                rowspan: {
                    optional: true,
                    type: 'number'
                },
                valign: {
                    optional: true,
                    type: 'enum',
                    values: [
                        'top',
                        'middle',
                        'bottom'
                    ]
                }
            }
        },
        content: {
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        }
    },
    required: [
        'content'
    ]
};
const $2184d18a998bc887$export$ce666bf02318c957 = {
    props: {
        attrs: {
            optional: true,
            props: {
                localId: {
                    optional: true,
                    type: 'string'
                }
            }
        },
        content: {
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ],
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        }
    }
};
const $2184d18a998bc887$export$6d8b0ef52e2e6390 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            allowUnsupportedInline: true,
            items: [
                'inline_content'
            ],
            optional: true,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        }
    }
};
const $2184d18a998bc887$export$375b6afcc5f4d291 = {
    props: {
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            allowUnsupportedBlock: true,
            items: [
                [
                    'taskItem',
                    'taskList',
                    'blockTaskItem'
                ]
            ],
            minItems: 1,
            type: 'array'
        },
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        }
    }
};
const $2184d18a998bc887$export$6f093cfa640b7166 = {
    props: {
        marks: {
            items: [],
            optional: true,
            type: 'array'
        },
        text: {
            minLength: 1,
            type: 'string'
        },
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        }
    }
};
const $2184d18a998bc887$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor'
                    ]
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                items: [
                    'link'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                items: [],
                maxItems: 0,
                optional: true,
                type: 'array'
            }
        }
    }
];
const $2184d18a998bc887$export$32f78bffcd82ff28 = {
    props: {
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        },
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        }
    }
};
const $2184d18a998bc887$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});


parcelRegister("lAoLJ", function(module, exports) {
$parcel$export(module.exports, "isDefined", () => $036a4084b1fc0499$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $036a4084b1fc0499$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $036a4084b1fc0499$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $036a4084b1fc0499$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $036a4084b1fc0499$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $036a4084b1fc0499$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $036a4084b1fc0499$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $036a4084b1fc0499$export$7b85fd78dd236198);
const $036a4084b1fc0499$export$4e62c701997796c1 = (x)=>x != null;
const $036a4084b1fc0499$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $036a4084b1fc0499$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $036a4084b1fc0499$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $036a4084b1fc0499$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $036a4084b1fc0499$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $036a4084b1fc0499$export$784d13d8ee351f07 = (source, dest, key)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dest[key] = source[key];
    return dest;
};
const $036a4084b1fc0499$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("5uGR9", function(module, exports) {
$parcel$export(module.exports, "extractAllowedContent", () => $804dfbdda6415d3e$export$7d2123bc001cdbf8);
function $804dfbdda6415d3e$export$7d2123bc001cdbf8(validatorSpecs, entity) {
    // Filter out content type + irrelevant nodes
    const potentialAllowedContent = Object.entries(validatorSpecs).filter((item)=>{
        const [node, value] = item;
        if ($804dfbdda6415d3e$var$isValidatorSpec(value)) return node === entity.type;
        const [nodeName, spec] = [
            value[0],
            value[1]
        ];
        if (typeof spec === 'string' || typeof spec !== 'object') return false;
        return nodeName === entity.type;
    });
    // Keep types such as `mediaSingle_full` which contain additional spec information
    const contentArray = potentialAllowedContent.map((allowedContent)=>{
        if ($804dfbdda6415d3e$var$isValidatorSpec(allowedContent)) return undefined;
        const value = allowedContent[1];
        return !$804dfbdda6415d3e$var$isValidatorSpec(value) ? [
            [
                value[0],
                value[1]
            ]
        ] : undefined;
    });
    return contentArray.filter((x)=>!!x);
}
function $804dfbdda6415d3e$var$isValidatorSpec(spec) {
    return spec.props !== undefined || spec.required !== undefined || spec.maxItems !== undefined || spec.minItems !== undefined;
}

});

parcelRegister("4RXyg", function(module, exports) {
$parcel$export(module.exports, "validatorFnMap", () => $c13af898d911b9ad$export$d1b377ca77ac267d);

var $kZuij = parcelRequire("kZuij");
const $c13af898d911b9ad$export$d1b377ca77ac267d = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    safeUrl: (0, $kZuij.isSafeUrl)
};

});



parcelRegister("6H5aI", function(module, exports) {
$parcel$export(module.exports, "transformContainerNodes", () => $8e2100a1a638bc5b$export$62836639b6ded12a);

var $jFbx9 = parcelRequire("jFbx9");
/**
 * Returns the set of parent node names whose content expression in the
 * supplied schema allows a `panel_c1` child. Returns an empty set if the
 * schema does not declare a `panel_c1` node.
 */ const $8e2100a1a638bc5b$var$getPanelC1AllowedParentTypes = (schema)=>{
    const panelC1Type = schema.nodes['panel_c1'];
    if (!panelC1Type) return new Set();
    const allowed = new Set();
    for (const nodeType of Object.values(schema.nodes)){
        var _nodeType$contentMatc;
        if ((_nodeType$contentMatc = nodeType.contentMatch) !== null && _nodeType$contentMatc !== void 0 && _nodeType$contentMatc.matchType(panelC1Type)) allowed.add(nodeType.name);
    }
    return allowed;
};
const $8e2100a1a638bc5b$export$62836639b6ded12a = (adf, schema)=>{
    let isTransformed = false;
    const transformedNodeTypes = new Set();
    const panelC1AllowedParents = $8e2100a1a638bc5b$var$getPanelC1AllowedParentTypes(schema);
    const transformedAdf = (0, $jFbx9.traverse)(adf, {
        panel: (node, parent)=>{
            var _parent$node;
            const parentType = (_parent$node = parent.node) === null || _parent$node === void 0 ? void 0 : _parent$node.type;
            if (parentType && panelC1AllowedParents.has(parentType)) {
                isTransformed = true;
                transformedNodeTypes.add('panel_c1');
                return {
                    ...node,
                    type: 'panel_c1'
                };
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        transformedNodeTypes: Array.from(transformedNodeTypes)
    };
};

});

parcelRegister("4UFgs", function(module, exports) {
$parcel$export(module.exports, "transformMediaLinkMarks", () => $6319678692103c9e$export$6528700f3fa2fe2a);

var $jFbx9 = parcelRequire("jFbx9");
const $6319678692103c9e$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $jFbx9.traverse)(adf, {
        mediaSingle: (node)=>{
            var _node$content$;
            if (!node.marks || !node.content || ((_node$content$ = node.content[0]) === null || _node$content$ === void 0 ? void 0 : _node$content$.type) !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    var _node$marks;
                    linkMark = mark;
                    (_node$marks = node.marks) === null || _node$marks === void 0 || _node$marks.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                var _mediaNode$marks;
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if ((_mediaNode$marks = mediaNode.marks) !== null && _mediaNode$marks !== void 0 && _mediaNode$marks.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("66an8", function(module, exports) {
$parcel$export(module.exports, "validateADFEntity", () => $dc1fca1c12fc392b$export$884cfad20dece33e);

var $hf7pc = parcelRequire("hf7pc");

var $f0GG4 = parcelRequire("f0GG4");

var $2kuA8 = parcelRequire("2kuA8");

var $hyHNQ = parcelRequire("hyHNQ");
const $dc1fca1c12fc392b$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $dc1fca1c12fc392b$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent, validationOverrides)=>{
    return (entity, error, options)=>{
        return $dc1fca1c12fc392b$export$468b008419c9a974(entity, error, {
            ...options,
            allowNestedTables: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowNestedTables,
            allowTableInPanel: validationOverrides === null || validationOverrides === void 0 ? void 0 : validationOverrides.allowTableInPanel
        }, marks, validate, dispatchAnalyticsEvent);
    };
};
const $dc1fca1c12fc392b$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $dc1fca1c12fc392b$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return (0, $hyHNQ.wrapWithUnsupported)(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $dc1fca1c12fc392b$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
   * There's a inconsistency between ProseMirror and ADF.
   * `content` is actually optional in ProseMirror.
   * And, also empty `text` node is not valid.
   */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $dc1fca1c12fc392b$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $dc1fca1c12fc392b$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    // Nested tables don't actually exist in ADF. In ADF they are stored as an `extension` node with the nested table content serialized in a property of that extension.
    // Usually when we validate ADF we are validating this `extension` and then later transforming it into nested tables for usage by ProseMirror.
    // Under certain circumstances however, ADF validation is performed on this already transformed extension and since nested tables aren't allowed by ADF this
    // produces an error. For example, nested renderers in Confluence `bodiedExtension`'s. The nested renderer receives the already transformed nested tables that originated from the
    // `extension` node and validates it. This is invalid ADF so an error is thrown.
    // This override allows an exception to be made for nested tables in the validator in this circumstance.
    if (options.allowNestedTables) {
        const meta = error.meta;
        if (options.allowNestedTables && meta !== null && meta !== void 0 && meta.parentType && [
            'tableCell',
            'tableHeader'
        ].includes(meta === null || meta === void 0 ? void 0 : meta.parentType) && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    // panel_c1 is a ProseMirror-only variant: on save, table-in-panel documents are stored as
    // plain ADF `panel` nodes containing a `table`. The base validator-spec does not permit
    // `table` inside `panel` (it's gated behind the experiment), so we suppress the
    // INVALID_CONTENT error when the experiment is active.
    if (options.allowTableInPanel) {
        const meta = error.meta;
        if ((meta === null || meta === void 0 ? void 0 : meta.parentType) === 'panel' && error.code === 'INVALID_CONTENT' && entity.type === 'table') return entity;
    }
    if (options.allowUnsupportedBlock) return (0, $hyHNQ.wrapWithUnsupported)(entity);
    if (options.allowUnsupportedInline) return (0, $hyHNQ.wrapWithUnsupported)(entity, 'inline');
    if (dispatchAnalyticsEvent) $dc1fca1c12fc392b$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $dc1fca1c12fc392b$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? (0, $hyHNQ.wrapWithUnsupported)(child) : validate(child, $dc1fca1c12fc392b$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (entity.content.length === 0) return (0, $hyHNQ.wrapWithUnsupported)(entity);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? (0, $hyHNQ.wrapWithUnsupported)(child) : child;
        });
    }
    return entity;
}
function $dc1fca1c12fc392b$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $2kuA8.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $f0GG4.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $dc1fca1c12fc392b$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent, validationOverrides)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $hf7pc.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $dc1fca1c12fc392b$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent, validationOverrides));
    return entity;
};

});
parcelRegister("hyHNQ", function(module, exports) {
$parcel$export(module.exports, "wrapWithUnsupported", () => $3f51402d6da090c7$export$87b732fa69cdf16e);
function $3f51402d6da090c7$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});


parcelRegister("lmPm1", function(module, exports) {
$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $4f1472620f1df253$export$a43de96edd8d0a0);

var $jzosZ = parcelRequire("jzosZ");
var $f6XCt = parcelRequire("f6XCt");

var $f0GG4 = parcelRequire("f0GG4");

var $dQtpO = parcelRequire("dQtpO");
const $4f1472620f1df253$var$rendersMap = {};
const $4f1472620f1df253$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $f6XCt.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $f0GG4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $jzosZ.getAnalyticsAppearance)(item.appearance),
                platform: (0, $dQtpO.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $f0GG4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $f0GG4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $dQtpO.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $4f1472620f1df253$var$schedule = (fn)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $4f1472620f1df253$var$DEFAULT_SAMPLING_RATE = 100;
const $4f1472620f1df253$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$4f1472620f1df253$var$rendersMap[appearance]) $4f1472620f1df253$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $4f1472620f1df253$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $4f1472620f1df253$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $4f1472620f1df253$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($4f1472620f1df253$var$rendersMap[appearance].size === 1) $4f1472620f1df253$var$schedule(()=>$4f1472620f1df253$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($4f1472620f1df253$var$rendersMap[appearance].size % sampleRate === 0) $4f1472620f1df253$var$rendersMap[appearance] = new Set();
};

});
parcelRegister("f6XCt", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $fe1a30651ecc25ea$export$484b83e0462998d);

var $jFbx9 = parcelRequire("jFbx9");

var $fN3Wd = parcelRequire("fN3Wd");

var $brESC = parcelRequire("brESC");
const $fe1a30651ecc25ea$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.degraded) || (0, $brESC.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).DEGRADED,
        blocking: (customThresholds === null || customThresholds === void 0 ? void 0 : customThresholds.blocking) || (0, $brESC.UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS).BLOCKING
    };
};
const $fe1a30651ecc25ea$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $jFbx9.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                var _node$attrs;
                const originalNode = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $jFbx9.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        var _parent$parent;
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = ((_parent$parent = parent.parent) === null || _parent$parent === void 0 || (_parent$parent = _parent$parent.node) === null || _parent$parent === void 0 ? void 0 : _parent$parent.type) ?? 'unknown';
                        const type = `${parentType}/${(unsupportedNode === null || unsupportedNode === void 0 ? void 0 : unsupportedNode.type) ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = ((unsupportedNodeTypeCount === null || unsupportedNodeTypeCount === void 0 ? void 0 : unsupportedNodeTypeCount[type]) ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $fe1a30651ecc25ea$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return (0, $fN3Wd.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).DEGRADED;
    if (thresholds.blocking <= unsupportedContentLevelPercent) return (0, $fN3Wd.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).BLOCKING;
    return (0, $fN3Wd.UNSUPPORTED_CONTENT_LEVEL_SEVERITY).NORMAL;
};
const $fe1a30651ecc25ea$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $fe1a30651ecc25ea$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $fe1a30651ecc25ea$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $fe1a30651ecc25ea$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});
parcelRegister("fN3Wd", function(module, exports) {
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_LEVEL_SEVERITY", () => $2f430d5e625563a0$export$6632e71a22d31bf1);
var $2f430d5e625563a0$export$6632e71a22d31bf1 = /*#__PURE__*/ function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
    return UNSUPPORTED_CONTENT_LEVEL_SEVERITY;
}({});

});

parcelRegister("brESC", function(module, exports) {
$parcel$export(module.exports, "UNSUPPORTED_CONTENT_LEVEL_SEVERITY_THRESHOLD_DEFAULTS", () => $56ed1a024d8a0a7a$export$f9f8a29778652c3e);
const $56ed1a024d8a0a7a$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};

});



parcelRegister("kNCrc", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $4c320040c34ae466$export$1daf15cbaf649dad);
/* eslint-disable jsdoc/require-jsdoc */ 
var $5izvm = parcelRequire("5izvm");
function $4c320040c34ae466$export$1daf15cbaf649dad(adfDocument) {
    return (0, $5izvm.reduce)(adfDocument, (acc, node)=>{
        acc[node.type] = (acc[node.type] || 0) + 1;
        return acc;
    }, {});
}

});
parcelRegister("5izvm", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $f9e5e5afe1293753$export$533b26079ad0b4b);

var $jFbx9 = parcelRequire("jFbx9");
function $f9e5e5afe1293753$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $jFbx9.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});



parcelRegister("1z761", function(module, exports) {
$parcel$export(module.exports, "EditorMediaClientProvider", () => $3a6cac7464691373$export$77218b6ff680865f);

var $4fqPo = parcelRequire("4fqPo");

var $dZ5TE = parcelRequire("dZ5TE");
var $glWLN = parcelRequire("glWLN");

var $gScSr = parcelRequire("gScSr");

var $3H4LK = parcelRequire("3H4LK");

var $4mqcS = parcelRequire("4mqcS");
const $3a6cac7464691373$var$getMediaClientConfigForRenderer = (provider)=>{
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    return provider.viewAndUploadMediaClientConfig && (0, $3H4LK.fg)('platform_media_video_captions') && (0, $3H4LK.fg)('platform_editor_video_caption_commit') ? provider.viewAndUploadMediaClientConfig : provider.viewMediaClientConfig;
};
const $3a6cac7464691373$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $4fqPo.useState)(()=>(0, $4mqcS.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? ssr === null || ssr === void 0 ? void 0 : ssr.config : undefined);
    const providerFactory = (0, $gScSr.useProviderFactory)();
    const mediaProvider = (0, $gScSr.useProviderLayout)('mediaProvider');
    /**
   * Whether this renderer has its own media provider and should never inherit
   * the mediaClient from a parent renderer's context.
   *
   * We use providerFactory.hasProvider() rather and checking the mediaProvider
   * state value, because useProviderLayout subscribes via useLayoutEffect —
   * meaning mediaProvider state is always undefined on the first render, even
   * if the ProviderFactory already has a provider registered. This would cause
   * shouldSkipContext to be false on the first render, incorrectly allowing the
   * inner renderer to inherit the outer renderer's MediaClientContext (which
   * carries the wrong media token for this page).
   *
   * hasProvider() is synchronous and correct from render 1, closing that window.
   */ const shouldSkipContext = (0, $4mqcS.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true) ? Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || providerFactory.hasProvider('mediaProvider') || mediaProvider) : Boolean((ssr === null || ssr === void 0 ? void 0 : ssr.config) || mediaProvider);
    const contextMediaClient = (0, $4fqPo.useContext)((0, $glWLN.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $4fqPo.useMemo)(()=>mediaClientConfig ? (0, $dZ5TE.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    // When the experiment is enabled, use useEffect instead of useLayoutEffect because:
    // - For the ssr.config branch: useState is already initialised with ssr.config, so this
    //   effect is a no-op on first render — the "before paint" guarantee is irrelevant.
    // - For the mediaProvider branch: the actual work happens inside a Promise callback which
    //   resolves asynchronously, so it can never run before paint regardless of which hook
    //   schedules it — useLayoutEffect's guarantee is equally irrelevant here.
    // The legacy path keeps useLayoutEffect to preserve existing behaviour when the experiment is off.
    //
    // The two hooks below are mutually exclusive — only one runs per render — so there is no
    // actual chaining of state updates at runtime. The lint rule cannot statically prove this.
    (0, $4fqPo.useEffect)(()=>{
        if (!(0, $4mqcS.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true)) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMediaClientConfig(ssr.config);
        else if (mediaProvider) {
            let cancelled = false;
            // Cancellation flag prevents setMediaClientConfig from being called after
            // unmount or when mediaProvider changes mid-flight (stale promise fix).
            // No .catch() is needed — the media provider is not expected to reject,
            // and a catch handler would be a no-op anyway.
            mediaProvider.then((provider)=>{
                if (!cancelled) setMediaClientConfig($3a6cac7464691373$var$getMediaClientConfigForRenderer(provider));
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    // Legacy path (experiment off): keep useLayoutEffect to preserve existing behaviour.
    // remove this when clean up platform_editor_media_reliability_enhancements
    (0, $4fqPo.useLayoutEffect)(()=>{
        if ((0, $4mqcS.expValEquals)('platform_editor_media_reliability_enhancements', 'isEnabled', true)) return;
        if (ssr !== null && ssr !== void 0 && ssr.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig($3a6cac7464691373$var$getMediaClientConfigForRenderer(provider));
        });
    }, [
        mediaProvider,
        ssr === null || ssr === void 0 ? void 0 : ssr.config
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $glWLN.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};

});

parcelRegister("6XdSn", function(module, exports) {
$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $08a9f93fc0479012$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $08a9f93fc0479012$export$cddc3c6ebe2d2cec);

var $4fqPo = parcelRequire("4fqPo");
const $08a9f93fc0479012$var$dest = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(undefined);
const $08a9f93fc0479012$export$20439b49fdd0d26c = $08a9f93fc0479012$var$dest.Provider;
const $08a9f93fc0479012$var$Consumer = $08a9f93fc0479012$var$dest.Consumer;
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $08a9f93fc0479012$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $4fqPo.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($08a9f93fc0479012$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("amo05", function(module, exports) {
$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $dc951d42263aa3e5$export$cfc1361be0de4203);
/* eslint-disable jsdoc/require-jsdoc -- SSR inline script helpers */ 
var $4fqPo = parcelRequire("4fqPo");

var $7VVBW = parcelRequire("7VVBW");

var $3H4LK = parcelRequire("3H4LK");

var $3Aw44 = parcelRequire("3Aw44");

var $4mqcS = parcelRequire("4mqcS");
function $dc951d42263aa3e5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const shouldSkipScript = {
        table: (0, $3H4LK.fg)('platform-ssr-table-resize')
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: $dc951d42263aa3e5$export$92859d13f30c883e(id, shouldSkipScript)
        },
        "data-testid": "breakout-ssr-inline-script"
    });
}
function $dc951d42263aa3e5$export$92859d13f30c883e(id, shouldSkipScript) {
    const flags = {
        platform_editor_fix_media_in_renderer: (0, $3H4LK.fg)('platform_editor_fix_media_in_renderer'),
        platform_editor_renderer_extension_width_fix: (0, $4mqcS.expValEquals)('platform_editor_renderer_extension_width_fix', 'isEnabled', true)
    };
    return `(function(window){
if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) { return; }
${$dc951d42263aa3e5$export$47813c4121c8b4b3};
(${$dc951d42263aa3e5$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts, ${JSON.stringify(shouldSkipScript)}, ${JSON.stringify(flags)});
})(window);
`;
}
const $dc951d42263aa3e5$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $7VVBW.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $7VVBW.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $7VVBW.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $7VVBW.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $7VVBW.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $7VVBW.breakoutConsts).calcWideWidth.toString()};
  breakoutConsts.FullPagePadding = ${(0, $3Aw44.FullPagePadding).toString()};
`;
/**
 * WARNING: NO EXTERNAL FUNCTION CALL IN THIS FUNCTION
 * This function will be put to DOM as an inline script.
 * It can not have any external function dependency.
 * All required data must be passed in as serializable parameters.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $dc951d42263aa3e5$var$applyBreakoutAfterSSR(id, breakoutConsts, shouldSkipBreakoutScript, flags) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(// eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- inline script runs in browser document context
    document.querySelector(`[data-breakout-script-id="${id}"]`), (elem)=>{
        var _elem$parentElement;
        return !!((_elem$parentElement = elem.parentElement) !== null && _elem$parentElement !== void 0 && _elem$parentElement.classList.contains('ak-renderer-wrapper'));
    });
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            // Remove with feature gate 'platform-ssr-table-resize'
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                const nodeType = node.dataset.nodeType;
                const widthType = node.dataset.widthType;
                const isMediaSingleWithPixelWidth = nodeType === 'mediaSingle' && widthType === 'pixel';
                const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode) || // skip apply width styling to mediaSingle node with pixel width to avoid image size changing
                isMediaSingleWithPixelWidth && flags['platform_editor_fix_media_in_renderer'] || isExtension && flags['platform_editor_renderer_extension_width_fix']) return;
                // When flag is on we are using CSS to calculate the table width thus don't need logic below to set the width and left.
                if (shouldSkipBreakoutScript.table && node.classList.contains('pm-table-container')) return;
                if (node.classList.contains('fabric-editor-breakout-mark')) return;
                // use breakout script for all other types of nodes
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const rendererWidth = renderer.offsetWidth;
                    const effectiveWidth = rendererWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                width = breakoutConsts.calcBreakoutWidth(breakoutConsts)(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength(breakoutConsts)();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
       * The mutation observer is only called once per added node.
       * The above condition only deals with direct children of <div class="ak-renderer-document" />
       * When it is initially called on the direct children, not all the sub children have loaded.
       * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
       * Thus adding this conditional to deal with all media elements directly.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            item.target.dataset.nodeType === MEDIA_NODE_TYPE) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            applyMediaBreakout(item.target, flags);
        });
    });
    const applyMediaBreakout = (card, flags)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override width
        if (isPixelBasedResizing) return;
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width) card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
   * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
   * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
   * That's why window load is necessary.
   *
   * More info:
   * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
   * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
   * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
   */ const disconnect = ()=>{
        observer.disconnect();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('load', disconnect);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('load', disconnect);
}
const $dc951d42263aa3e5$export$2a0b3eeee3f2ea40 = (0, $7VVBW.breakoutConsts).calcLineLength((0, $7VVBW.breakoutConsts));

});

parcelRegister("aZdJ3", function(module, exports) {
$parcel$export(module.exports, "isInteractiveElement", () => $ab06791bafd46809$export$3dee5e4542c672d9);

var $3Qifh = parcelRequire("3Qifh");

var $eSoLw = parcelRequire("eSoLw");
function $ab06791bafd46809$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $eSoLw.mediaViewerPopupClass))) return true;
    if (element.classList.contains((0, $3Qifh.fileCardImageViewSelector))) return true;
    return false;
}

});
parcelRegister("3Qifh", function(module, exports) {
$parcel$export(module.exports, "fileCardImageViewSelector", () => $ddb7fdea7a9eba62$export$7a6526d4be3b7eb3);
const $ddb7fdea7a9eba62$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $ddb7fdea7a9eba62$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

});

parcelRegister("eSoLw", function(module, exports) {
$parcel$export(module.exports, "mediaViewerPopupClass", () => $89bef043301a45b4$export$42c8d07e41ed1e74);
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $89bef043301a45b4$export$42c8d07e41ed1e74 = 'media-viewer-popup';

});


parcelRegister("fcoDc", function(module, exports) {
$parcel$export(module.exports, "TruncatedWrapper", () => $69fc3cd00d0198a3$export$79ad592494094f07);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $4fqPo = parcelRequire("4fqPo");
const $69fc3cd00d0198a3$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $lqVX7.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, #00000000)"}, ${backgroundColor} )`
        }
    });
const $69fc3cd00d0198a3$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $69fc3cd00d0198a3$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: styles
    }, children);
};
class $69fc3cd00d0198a3$export$79ad592494094f07 extends (0, $4fqPo.Component) {
    constructor(props){
        super(props);
    }
    // TODO: DSP-4123 - Quality ticket as elevation.surface will be issue when sits top of modal.
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, #FFFFFF)", children: children } = this.props;
        return /*#__PURE__*/ (0, $lqVX7.jsx)($69fc3cd00d0198a3$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("jITpP", function(module, exports) {
$parcel$export(module.exports, "RendererStyleContainer", () => $65f9c2a843d3972c$export$8f0929e72efe521f);
/* eslint-disable @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- emotion jsx pragma; go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $3Aw44 = parcelRequire("3Aw44");

var $3H4LK = parcelRequire("3H4LK");

var $jANeU = parcelRequire("jANeU");

var $faPFq = parcelRequire("faPFq");

var $4meEa = parcelRequire("4meEa");

var $i0d0i = parcelRequire("i0d0i");

var $4LRBs = parcelRequire("4LRBs");
var $8JLrS = parcelRequire("8JLrS");
var $1X0CD = parcelRequire("1X0CD");
var $jPLRO = parcelRequire("jPLRO");
var $4ZvVm = parcelRequire("4ZvVm");
var $3HHms = parcelRequire("3HHms");
var $7akLL = parcelRequire("7akLL");
var $lL8Wo = parcelRequire("lL8Wo");

var $8EdAG = parcelRequire("8EdAG");
var $aZvqc = parcelRequire("aZvqc");

var $2qSQf = parcelRequire("2qSQf");
var $6pavR = parcelRequire("6pavR");

var $cpSqr = parcelRequire("cpSqr");

var $hdn08 = parcelRequire("hdn08");

var $eevY3 = parcelRequire("eevY3");

var $9HI3q = parcelRequire("9HI3q");

var $cYNsM = parcelRequire("cYNsM");

var $cb7zl = parcelRequire("cb7zl");

var $8jG2i = parcelRequire("8jG2i");

var $kTZWy = parcelRequire("kTZWy");
var $9jkQC = parcelRequire("9jkQC");

var $4mqcS = parcelRequire("4mqcS");

var $4ubSX = parcelRequire("4ubSX");

var $6uG5y = parcelRequire("6uG5y");
function $65f9c2a843d3972c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65f9c2a843d3972c$var$wrappedMediaBreakoutPoint = 410;
const $65f9c2a843d3972c$var$TELEPOINTER_ID = 'ai-streaming-telepointer';
const $65f9c2a843d3972c$var$tableShadowWidth = 32;
const $65f9c2a843d3972c$var$LAYOUT_BREAKPOINT_RENDERER = 629;
// originally defined from packages/editor/editor-plugin-table/src/ui/common-styles.ts
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: tableRowHeight can be moved into `@atlaskit/editor-common/table`
const $65f9c2a843d3972c$var$tableRowHeight = 44;
const $65f9c2a843d3972c$var$isBackgroundClipBrowserFixNeeded = ()=>{
    const browser = (0, $cpSqr.getBrowserInfo)();
    return browser.isGecko || browser.isIE || browser.isMac && browser.isChrome;
};
const $65f9c2a843d3972c$var$baseFontStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    font: (0, $cb7zl.default)('editor.font.body')
});
const $65f9c2a843d3972c$var$fontSizeStyles = {
    name: "jdulnm",
    styles: ".fabric-editor-font-size{&[data-font-size='small']{font:var(--ak-renderer-editor-font-small-text);}}li:has(> .fabric-editor-font-size[data-font-size='small'])::marker{font:var(--ak-renderer-editor-font-small-text);}"
};
const $65f9c2a843d3972c$var$originalBaseFontLineHeight = {
    name: "1dw7ik1",
    styles: "line-height:1.5rem"
};
// styles are copied from ./style.tsx
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage
const $65f9c2a843d3972c$var$baseStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 'var(--ak-renderer-base-font-size)',
    color: "var(--ds-text, #292A2E)",
    '--ak-editor--full-width-layout-width': `${(0, $faPFq.akEditorFullWidthLayoutWidth)}px`,
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}::after`]: {
        // we add a clearfix after ak-renderer-document in order to
        // contain internal floats (such as media images that are "wrap-left")
        // to just the renderer (and not spill outside of it)
        content: '""',
        visibility: 'hidden',
        display: 'block',
        height: 0,
        clear: 'both'
    },
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}`]: {
        // p, h3, and action items
        [`.${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
            height: '22px',
            transform: `translateY(-2px)`
        },
        h1: {
            [`> .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '36px',
                transform: `translateY(-3px)`
            }
        },
        h2: {
            [`> .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '31px',
                transform: `translateY(-3px)`
            }
        },
        h3: {
            [`> .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '25px',
                transform: `translateY(-2px)`
            }
        },
        h4: {
            [`> .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '23px',
                transform: `translateY(-2px)`
            }
        },
        h5: {
            [`> .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '20px',
                transform: `translateY(-2px)`
            }
        },
        h6: {
            [`> .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME},
  > :is(a, span[data-mark-type='border']) .${0, $4meEa.INLINE_IMAGE_WRAPPER_CLASS_NAME}`]: {
                height: '18px',
                transform: `translateY(-2px)`
            }
        }
    },
    [`& span.akActionMark`]: {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
            color: "var(--ds-link, #1868DB)",
            textDecoration: 'underline'
        },
        '&:active': {
            color: "var(--ds-link-pressed, #1558BC)"
        }
    },
    '& span[data-placeholder]': {
        color: "var(--ds-text-subtlest, #6B6E76)"
    }
});
const $65f9c2a843d3972c$var$headingAnchorStylesDuplicateAnchor = /*#__PURE__*/ (0, $lqVX7.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            position: 'absolute',
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: 'translate(-8px, 0px)',
                    transitionProperty: 'opacity, transform',
                    transitionDuration: `${"var(--ds-duration-medium, 0.2s)"}, ${"var(--ds-duration-medium, 0.2s)"}`,
                    transitionTimingFunction: `${"var(--ds-easing-out-practical, ease)"}, ${"var(--ds-easing-out-practical, ease)"}`,
                    transitionDelay: '0s, 0s'
                }
            },
            '&:hover': {
                [`.${0, $i0d0i.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    '& h1': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& h2': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& h3': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& h4': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& h5': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& h6': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $65f9c2a843d3972c$var$headingAnchorStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            marginLeft: "var(--ds-space-075, 6px)",
            button: {
                paddingLeft: 0,
                paddingRight: 0
            },
            /**
       * Adds the visibility of the button when in focus through keyboard navigation.
       */ 'button:focus': {
                opacity: 1,
                transform: 'none !important'
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                '> button': {
                    opacity: 0,
                    transform: `translate(-8px, 0px)`,
                    transition: `opacity 0.2s ease 0s, transform 0.2s ease 0s`
                }
            },
            '&:hover': {
                [`.${0, $i0d0i.HeadingAnchorWrapperClassName} > button`]: {
                    opacity: 1,
                    transform: 'none !important'
                }
            }
        }
    },
    // Line-height for heading anchor based on heading level (via data-level attribute on .renderer-heading-wrapper)
    '& .renderer-heading-wrapper[data-level="1"]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${28 / 24}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.2}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${1.25}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 14}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 12}em`
        }
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${16 / 11}em`
        }
    }
});
const $65f9c2a843d3972c$var$headingAnchorButtonFocusVisibleStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
        'button:focus-visible': {
            outline: `2px solid ${"var(--ds-border-focused, #4688EC)"}`,
            borderRadius: "var(--ds-radius-small, 3px)"
        }
    }
});
const $65f9c2a843d3972c$var$akEditorBreakpointForSmallDevice = '1266px';
const $65f9c2a843d3972c$var$responsiveBreakoutWidth = /*#__PURE__*/ (0, $lqVX7.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - ${(0, $faPFq.akEditorGutterPadding)}px * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $faPFq.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$65f9c2a843d3972c$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $faPFq.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $65f9c2a843d3972c$var$responsiveBreakoutWidthFullWidth = /*#__PURE__*/ (0, $lqVX7.css)({
    '--ak-editor--breakout-container-without-gutter-width': '100cqw',
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $faPFq.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$65f9c2a843d3972c$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $faPFq.akEditorCalculatedWideLayoutWidth)}px`
    }
});
const $65f9c2a843d3972c$var$responsiveBreakoutWidthWithReducedPadding = /*#__PURE__*/ (0, $lqVX7.css)({
    '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`,
    // Corresponds to the legacyContentStyles from `@atlaskit/editor-core` meant to introduce responsive breakout width.
    '--ak-editor--breakout-wide-layout-width': `${(0, $faPFq.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
    [`@media (min-width: ${$65f9c2a843d3972c$var$akEditorBreakpointForSmallDevice})`]: {
        '--ak-editor--breakout-wide-layout-width': `${(0, $faPFq.akEditorCalculatedWideLayoutWidth)}px`
    },
    [`@media (max-width: ${0, $faPFq.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-editor--breakout-container-without-gutter-width': `calc(100cqw - var(--ak-renderer--full-page-gutter) * 2)`
    }
});
const $65f9c2a843d3972c$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor = /*#__PURE__*/ (0, $lqVX7.css)({
    '& h1, & h2, & h3, & h4, & h5, & h6': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $65f9c2a843d3972c$var$hideHeadingCopyLinkWrapperStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '& .renderer-heading-wrapper': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            '&:focus-within': {
                opacity: 1
            }
        },
        [`@media (hover: hover) and (pointer: fine)`]: {
            [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                opacity: 0,
                transition: `opacity 0.2s ease 0s`
            },
            '&:hover': {
                [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                    opacity: 1
                }
            }
        }
    }
});
const $65f9c2a843d3972c$var$rendererFullPageStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $faPFq.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 ${(0, $3Aw44.FullPagePadding)}px`
});
const $65f9c2a843d3972c$var$rendererFullPageStylesWithReducedPadding = /*#__PURE__*/ (0, $lqVX7.css)({
    '--ak-renderer--full-page-gutter': `${(0, $3Aw44.FullPagePadding)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $faPFq.akEditorDefaultLayoutWidth)}px`,
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    padding: `0 var(--ak-renderer--full-page-gutter)`,
    [`@media (max-width: ${0, $faPFq.akEditorFullPageNarrowBreakout}px)`]: {
        '--ak-renderer--full-page-gutter': `${(0, $faPFq.akEditorGutterPaddingReduced)}px`
    }
});
const $65f9c2a843d3972c$var$oldRendererFullWidthStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $faPFq.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $65f9c2a843d3972c$var$rendererFullWidthStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $faPFq.akEditorFullWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $65f9c2a843d3972c$var$oldRendererMaxWidthStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $faPFq.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"]), .ak-renderer-extension': {
        width: '100% !important'
    }
});
const $65f9c2a843d3972c$var$rendererMaxWidthStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $faPFq.akEditorMaxWidthLayoutWidth)}px`,
    margin: `0 auto`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-breakout-mark:not([data-has-width="true"])': {
        width: '100% !important'
    }
});
const $65f9c2a843d3972c$var$rendererFullWidthStylesForTableResizing = {
    name: "b6n1sl",
    styles: ".pm-table-container{width:100% !important;}"
};
const $65f9c2a843d3972c$var$rovoTelepointerStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`#${$65f9c2a843d3972c$var$TELEPOINTER_ID}`]: {
        display: 'inline-block',
        position: 'relative',
        width: '1.5px',
        height: '24px',
        backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
        marginLeft: "var(--ds-space-025, 2px)",
        '&::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: 0,
            left: 0,
            width: '31.5px',
            height: '15.5px',
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            background: // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography, @atlaskit/design-system/ensure-design-token-usage
            'linear-gradient(to right, #1868db 0px, #1868db 1.5px, transparent 1.5px) 0 0 / 100% 100% no-repeat, conic-gradient(from 270deg at 50% 50%, #1868db 0deg, #1868db 115deg, #fca700 115deg, #fca700 180deg, #bf63f3 180deg, #bf63f3 310deg, #82b536 310deg, #82b536 359.96deg, #1868db 360deg)'
        },
        '&::before': {
            content: '"Rovo"',
            position: 'absolute',
            fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            color: "var(--ds-text-inverse, #FFFFFF)",
            backgroundColor: "var(--ds-text, #292A2E)",
            top: 1,
            left: 1,
            borderRadius: `0px ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
            zIndex: 1,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: '10px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            padding: '0.5px 2.5px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: 'initial'
        }
    }
});
const $65f9c2a843d3972c$var$whitespaceSharedStyles = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};
const $65f9c2a843d3972c$var$blockquoteSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $faPFq.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});
const $65f9c2a843d3972c$var$headingsSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '& h1': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h1)`,
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        },
        '&::before': {}
    },
    '& h2': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h2)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h3': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h3)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em',
        marginBottom: 0,
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h4': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h4)`,
        marginTop: "var(--ds-space-250, 20px)",
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h5': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h5)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    },
    '& h6': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-heading-h6)`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em',
        textTransform: 'none',
        '& strong': {
            // set all heading bold style to token font.weight.bold, as not matter what typography is used, the editorUGCToken will return the font weight 700
            fontWeight: "var(--ds-font-weight-bold, 653)"
        }
    }
});
/**
 * When the copy-link a11y fix is enabled, the heading copy-link button is a sibling of the heading
 * text within `.renderer-heading-wrapper`. To ensure the button sits immediately after the last
 * rendered character (including when the heading wraps), the heading itself needs to participate in
 * inline layout.
 *
 * Since inline elements don't support vertical margins in normal flow, we migrate the UGC heading
 * `marginTop` values (from `headingsSharedStyles`) onto the wrapper.
 */ const $65f9c2a843d3972c$var$headingWrapperInlineFlowStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Ensure heading and copy-link button participate in inline flow so the button sits after the final wrapped line of text.
    '& .renderer-heading-wrapper > h1, & .renderer-heading-wrapper > h2, & .renderer-heading-wrapper > h3, & .renderer-heading-wrapper > h4, & .renderer-heading-wrapper > h5, & .renderer-heading-wrapper > h6': {
        display: 'inline'
    },
    [`& .renderer-heading-wrapper > .${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
        display: 'inline',
        verticalAlign: 'baseline'
    },
    '& .renderer-heading-wrapper[data-level="1"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="2"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.4em'
    },
    '& .renderer-heading-wrapper[data-level="3"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.31249em'
    },
    '& .renderer-heading-wrapper[data-level="4"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.25em'
    },
    '& .renderer-heading-wrapper[data-level="5"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.45833em'
    },
    '& .renderer-heading-wrapper[data-level="6"]': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginTop: '1.59091em'
    }
});
const $65f9c2a843d3972c$var$headingWithAlignmentStylesDuplicateAnchor = {
    name: "sd2n24",
    styles: ".fabric-editor-block-mark.fabric-editor-alignment:not(:first-child){> h1:first-child{margin-top:1.667em;} > h2:first-child{margin-top:1.8em;}> h3:first-child{margin-top:2em;}> h4:first-child{margin-top:1.357em;}> h5:first-child{margin-top:1.667em;}> h6:first-child{margin-top:1.455em;}}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> :is(h1, h2, h3, h4, h5, h6):first-child{margin-top:0;}}"
};
const $65f9c2a843d3972c$var$headingWithAlignmentStyles = {
    name: "1abdc8p",
    styles: ".fabric-editor-block-mark[data-align=\"center\"] > .renderer-heading-wrapper{justify-content:center;}.fabric-editor-block-mark[data-align=\"end\"] > .renderer-heading-wrapper{justify-content:flex-end;}.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $65f9c2a843d3972c$var$ruleSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '& hr': {
        border: 'none',
        backgroundColor: "var(--ds-border, #0B120E24)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $faPFq.akEditorLineHeight)}em 0`,
        height: '2px',
        borderRadius: "var(--ds-radius-full, 9999px)"
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $65f9c2a843d3972c$var$paragraphSharedStylesWithEditorUGC = /*#__PURE__*/ (0, $lqVX7.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $faPFq.blockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $65f9c2a843d3972c$var$paragraphStylesUGCScaledMargin = /*#__PURE__*/ (0, $lqVX7.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        font: `var(--ak-renderer-editor-font-normal-text)`,
        marginTop: (0, $faPFq.scaledBlockNodesVerticalMargin),
        marginBottom: 0
    }
});
const $65f9c2a843d3972c$var$paragraphSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $faPFq.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $faPFq.blockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
// When cleaning up `platform_editor_content_mode_button_mvp` simplify the name/ use the other paragraph style name
const $65f9c2a843d3972c$var$paragraphSharedStyleScaledMargin = /*#__PURE__*/ (0, $lqVX7.css)({
    '& p': {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: (0, $faPFq.akEditorLineHeight),
        fontWeight: "var(--ds-font-weight-regular, 400)",
        marginTop: (0, $faPFq.scaledBlockNodesVerticalMargin),
        marginBottom: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        letterSpacing: '-0.005em'
    }
});
const $65f9c2a843d3972c$var$listsSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    /* =============== INDENTATION SPACING ========= */ 'ul, ol': {
        boxSizing: 'border-box',
        paddingLeft: `var(--ed--list--item-counter--padding, ${(0, $1X0CD.listItemCounterPadding)}px)`
    },
    [`${0, $aZvqc.orderedListSelector}, ${0, $8EdAG.bulletListSelector}`]: {
        /*
    Ensures list item content adheres to the list's margin instead
    of filling the entire block row. This is important to allow
    clicking interactive elements which are floated next to a list.
    	For some history and context on this block, see PRs related to tickets.:
    @see ED-6551 - original issue.
    @see ED-7015 - follow up issue.
    @see ED-7447 - flow-root change.
    	used to have display: 'table' in tag template style but not supported in object styles
    removed display: 'table' as 'flow-root' is supported in latest browsers
    	@see https://css-tricks.com/display-flow-root/
    */ display: 'flow-root'
    },
    /* =============== INDENTATION AESTHETICS ========= */ /**
  	We support nested lists up to six levels deep.
  **/ /* LEGACY LISTS */ 'ul, ul ul ul ul': {
        listStyleType: 'disc'
    },
    'ul ul, ul ul ul ul ul': {
        listStyleType: 'circle'
    },
    'ul ul ul, ul ul ul ul ul ul': {
        listStyleType: 'square'
    },
    'ol, ol ol ol ol': {
        listStyleType: 'decimal'
    },
    'ol ol, ol ol ol ol ol': {
        listStyleType: 'lower-alpha'
    },
    'ol ol ol, ol ol ol ol ol ol': {
        listStyleType: 'lower-roman'
    },
    /* PREDICTABLE LISTS */ 'ol[data-indent-level="1"], ol[data-indent-level="4"]': {
        listStyleType: 'decimal'
    },
    'ol[data-indent-level="2"], ol[data-indent-level="5"]': {
        listStyleType: 'lower-alpha'
    },
    'ol[data-indent-level="3"], ol[data-indent-level="6"]': {
        listStyleType: 'lower-roman'
    },
    'ul[data-indent-level="1"], ul[data-indent-level="4"]': {
        listStyleType: 'disc'
    },
    'ul[data-indent-level="2"], ul[data-indent-level="5"]': {
        listStyleType: 'circle'
    },
    'ul[data-indent-level="3"], ul[data-indent-level="6"]': {
        listStyleType: 'square'
    }
});
/*
	Firefox does not handle empty block element inside li tag.
	If there is not block element inside li tag,
	then firefox sets inherited height to li
	However, if there is any block element and if it's empty
	(or has empty inline element) then
	firefox sets li tag height to zero.
	More details at
	https://product-fabric.atlassian.net/wiki/spaces/~455502413/pages/3149365890/ED-14110+Investigation
*/ const $65f9c2a843d3972c$var$listsSharedStylesForGekko = {
    name: "jlg15n",
    styles: "ul, ol{li p:empty, li p > span:empty{display:inline-block;}}"
};
/**
 * Hides list markers for "wrapper items" - list items that only contain nested lists with no other content.
 * These wrapper items have no meaningful content themselves, only nested lists below.
 * Applied when platform_editor_flexible_list_schema experiment is enabled.
 */ const $65f9c2a843d3972c$var$listItemHiddenMarkerStyles = {
    name: "j8szsq",
    styles: "li:has(> ul:only-child), li:has(> ol:only-child){list-style-type:none;margin-top:0;margin-bottom:0;}li:has(> ul:only-child) > ul, li:has(> ol:only-child) > ol{margin-top:0;}div[data-task-list-local-id] > div[data-task-list-local-id]{margin-top:0;}div[data-task-local-id] + div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);}"
};
const $65f9c2a843d3972c$var$indentationSharedStyles = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};
const $65f9c2a843d3972c$var$indentationSharedStylesWithMarginFix = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.fabric-editor-indentation-mark': {
        // Prevent marginTop of p:first-child overrode by batch.css
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        'p:first-child': {
            marginTop: (0, $faPFq.blockNodesVerticalMargin)
        }
    }
});
const $65f9c2a843d3972c$var$blockMarksSharedStylesDuplicateAnchor = /*#__PURE__*/ (0, $lqVX7.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, h1, h2, h3, h4, h5, h6, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        }
    }
});
const $65f9c2a843d3972c$var$blockMarksSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    /**
   * We need to remove margin-top from first item
   * inside doc, tableCell, tableHeader, blockquote, etc.
   */ [`*:not(.fabric-editor-block-mark) >,
  	*:not(.fabric-editor-block-mark) >
    div.fabric-editor-block-mark:first-of-type
	:not(.fabric-editor-indentation-mark)
	:not(.fabric-editor-alignment),
  	.fabric-editor-alignment:first-of-type:first-child,
  	.fabric-editor-font-size:first-of-type:first-child,
  	.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child`]: {
        'p, .heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                marginTop: 0
            }
        },
        '.renderer-heading-wrapper': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            ':first-child:not(style), style:first-child + *': {
                'h1, h2, h3, h4, h5, h6': {
                    marginTop: 0
                }
            }
        }
    }
});
const $65f9c2a843d3972c$var$codeMarkSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.code': {
        '--ds--code--bg-color': "var(--ds-background-neutral, #0515240F)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        fontWeight: "var(--ds-font-weight-regular, 400)",
        backgroundColor: `var(--ds--code--bg-color,${"var(--ds-background-neutral, #0515240F)"})`,
        color: "var(--ds-text, #292A2E)",
        borderStyle: 'none',
        borderRadius: "var(--ds-radius-small, 3px)",
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    }
});
const $65f9c2a843d3972c$var$extensionStyle = {
    name: "188isfx",
    styles: ".ak-renderer-extension :not(.ak-renderer-extension .ak-renderer-document *, .aui-lozenge, .status-lozenge-span *), .ak-renderer-extension .ak-renderer-document .ak-renderer-extension:not(:has(.ak-renderer-document)) :not(.aui-lozenge, .status-lozenge-span *){font-size:var(--ak-renderer-base-font-size);}"
};
const $65f9c2a843d3972c$var$oldExtensionAsInlineStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        // use !important here because the current width has !important applied to it and it's not working when used in React style prop
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'auto !important',
        marginTop: 0
    },
    [`.${(0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jANeU.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
const $65f9c2a843d3972c$var$extensionAsInlineStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} [data-as-inline="on"]`]: {
        display: 'inline-block'
    },
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE}`]: {
        display: 'inline-block',
        width: 'auto',
        marginTop: 0
    },
    [`.${(0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
        display: 'inline-block',
        overflowX: 'visible',
        containerType: 'normal'
    },
    [`.${(0, $jANeU.RendererCssClassName).EXTENSION_AS_INLINE} .${(0, $jANeU.RendererCssClassName).EXTENSION_INNER_WRAPPER}`]: {
        display: 'inline-block'
    }
});
// Removes the blockNodesVerticalMargin styling for inline extensions, i.e. borderless excerpt-include
const $65f9c2a843d3972c$var$inlineExtensionRendererMarginFix = {
    name: "vgr91k",
    styles: ".ak-renderer-document .inline-extension-renderer .ak-renderer-extension{margin-top:0;}"
};
const $65f9c2a843d3972c$var$shadowSharedStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $2qSQf.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $2qSQf.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $2qSQf.shadowClassNames).LEFT_SHADOW}::before, .${(0, $2qSQf.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $faPFq.akEditorShadowZIndex),
        width: '8px',
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $2qSQf.shadowClassNames).RIGHT_SHADOW}, .${(0, $2qSQf.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $2qSQf.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $2qSQf.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6pavR.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $6pavR.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});
const $65f9c2a843d3972c$var$dateSharedStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${(0, $8JLrS.DateSharedCssClassName).DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});
const $65f9c2a843d3972c$var$textColorStyles = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};
const $65f9c2a843d3972c$var$backgroundColorStyles = {
    name: "yf96ao",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:var(--ds-radius-xsmall, 2px);padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $65f9c2a843d3972c$export$a365082c2a191514 = {
    name: "nf8qu5",
    styles: ".fabric-background-color-mark:has(.background-color-padding-left){padding-left:var(--ds-space-025, 2px);margin-left:var(--ds-space-negative-025, -2px);}.fabric-background-color-mark:has(.background-color-padding-right){padding-right:var(--ds-space-025, 2px);margin-right:var(--ds-space-negative-025, -2px);}"
};
const $65f9c2a843d3972c$var$tasksAndDecisionsStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '.ProseMirror': {
        [`.taskItemView-content-wrap,
		.${(0, $lL8Wo.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            position: 'relative',
            minWidth: `${(0, $faPFq.akEditorTableCellMinWidth)}px`
        },
        [`.${(0, $lL8Wo.TaskDecisionSharedCssClassName).DECISION_CONTAINER}`]: {
            marginTop: 0
        },
        [`.${(0, $lL8Wo.TaskDecisionSharedCssClassName).TASK_CONTAINER}`]: {
            'span[contenteditable="false"]': {
                height: `${(0, $faPFq.akEditorLineHeight)}em`
            }
        },
        [`.${(0, $lL8Wo.TaskDecisionSharedCssClassName).TASK_ITEM}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $faPFq.akEditorLineHeight)
        }
    },
    'div[data-task-local-id]': {
        'span[contenteditable="false"]': {
            height: `${(0, $faPFq.akEditorLineHeight)}em`
        },
        'span[contenteditable="false"] + div': {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: `${(0, $faPFq.akEditorLineHeight)}em`
        }
    },
    'div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-150, 12px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        // If task item is not first in the list then set margin top to 4px.
        'div + div': {
            marginTop: "var(--ds-space-050, 4px)"
        }
    },
    // If task list is not first in the document then set margin top to 4px.
    'div[data-task-list-local-id] div[data-task-list-local-id]': {
        marginTop: "var(--ds-space-050, 4px)",
        marginLeft: "var(--ds-space-300, 24px)"
    },
    /* When action list is inside panel */ '.ak-editor-panel__content': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div[data-task-list-local-id]:first-child': {
            margin: '0 0 0 0 !important'
        }
    }
});
const $65f9c2a843d3972c$var$headingPanelStyles = {
    name: "e0for6",
    styles: ".ak-editor-panel__content{> .renderer-heading-wrapper:first-child{margin-top:0;}}"
};
const $65f9c2a843d3972c$var$smartCardStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $4ZvVm.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}`]: {
        display: 'block',
        margin: `${(0, $faPFq.blockNodesVerticalMargin)} 0 0`,
        maxWidth: `${760}px`
    }
});
const $65f9c2a843d3972c$var$smartCardStylesAvatarFix = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $4ZvVm.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $4ZvVm.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        /* EDM-11991: Fix list plugin adding padding to ADS AvatarGroup start */ 'ul, ol': {
            paddingLeft: 'inherit'
        }
    }
});
const $65f9c2a843d3972c$var$smartCardStylesAvatarMarginFix = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $4ZvVm.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $4ZvVm.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginRight: 'inherit'
        }
    }
});
const $65f9c2a843d3972c$var$smartCardStylesAvatarListZeroMarginTop = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $4ZvVm.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}:not(.${(0, $4ZvVm.SmartCardSharedCssClassName).DATASOURCE_CONTAINER})`]: {
        'ul, ol': {
            marginTop: 0
        }
    }
});
// In Renderer in Jira there is no SmartCardSharedCssClassName.INLINE_CARD_CONTAINER, so using data-inline-cart="true"
const $65f9c2a843d3972c$var$headerSmartCardStyles = {
    name: "qwtpmh",
    styles: "[data-inline-card=\"true\"]{[data-inlinecard-button-overlay=\"icon-wrapper-line-height\"] span{line-height:0;}}"
};
// Flex wrapper for centering without transform (platform_editor_flex_based_centering).
// flex: 1 1 0% + minWidth: 0 so the wrapper takes full width when it's a flex item (full-width nodes otherwise render narrow).
// flexShrink: 0 on child so the node keeps size.
const $65f9c2a843d3972c$var$centerWrapperStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).FLEX_CENTER_WRAPPER}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        width: '100%',
        flex: '1 1 0%',
        minWidth: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '& > *': {
            flexShrink: 0
        }
    }
});
const $65f9c2a843d3972c$var$baseOtherStylesDuplicateAnchor = /*#__PURE__*/ (0, $lqVX7.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $jPLRO.richMediaClassName}.rich-media-wrapped + .${0, $jPLRO.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $jPLRO.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $jPLRO.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $jPLRO.richMediaClassName}.image-align-start,
		.${0, $jPLRO.richMediaClassName}.image-center,
		.${0, $jPLRO.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jANeU.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jANeU.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $faPFq.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jANeU.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $jANeU.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $jANeU.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $6pavR.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $65f9c2a843d3972c$var$hideExtensionStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).EXTENSION}:has([data-extension-key='hide'])`]: {
        marginTop: 0
    }
});
const $65f9c2a843d3972c$var$extensionCenterAlignLegacyStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jANeU.RendererCssClassName).EXTENSION_CENTER_ALIGN}`]: {
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginLeft: '50%',
            transform: 'translateX(-50%)'
        }
    }
});
const $65f9c2a843d3972c$var$baseOtherStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '& .UnknownBlock': {
        fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${0.875}rem`,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word'
    },
    '& span.date-node': {
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        borderRadius: "var(--ds-radius-small, 3px)",
        color: "var(--ds-text, #292A2E)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-050, 4px)",
        margin: `0 1px`,
        transition: `background 0.3s`
    },
    '& span.date-node-highlighted': {
        backgroundColor: "var(--ds-background-danger, #FFECEB)",
        color: "var(--ds-text-danger, #AE2E24)"
    },
    '& .renderer-image': {
        maxWidth: '100%',
        display: 'block',
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: "var(--ds-space-300, 24px)",
        marginLeft: 0
    },
    [`.${0, $jPLRO.richMediaClassName}.rich-media-wrapped + .${0, $jPLRO.richMediaClassName}:not(.rich-media-wrapped)`]: {
        clear: 'both'
    },
    [`& .code-block,
	& blockquote,
	& hr,
	& > div > div:not(.rich-media-wrapped),
	.${0, $jPLRO.richMediaClassName}.rich-media-wrapped + .rich-media-wrapped + *:not(.rich-media-wrapped),
	.${0, $jPLRO.richMediaClassName}.rich-media-wrapped + div:not(.rich-media-wrapped),
	.${0, $jPLRO.richMediaClassName}.image-align-start,
		.${0, $jPLRO.richMediaClassName}.image-center,
		.${0, $jPLRO.richMediaClassName}.image-align-end`]: {
        clear: 'both'
    },
    '& .rich-media-wrapped': {
        '& + .renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                marginTop: "var(--ds-space-100, 8px)"
            }
        }
    },
    // originally copied the block after mediaSharedStyle
    'div[class^="image-wrap-"] + div[class^="image-wrap-"]': {
        marginLeft: 0,
        marginRight: 0
    },
    /* Breakout for tables and extensions */ [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} >`]: {
        [`*:not([data-mark-type='fragment']) .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`[data-mark-type='fragment'] * .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
            // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO - improve inline style logic on table container so important styles aren't required here
            width: '100% !important',
            left: '0 !important'
        },
        [`* .${(0, $jANeU.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`]: {
            overflowX: 'auto'
        },
        [`& .${(0, $jANeU.RendererCssClassName).EXTENSION}:first-child`]: {
            marginTop: 0
        }
    },
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}`]: {
        [`.${(0, $jANeU.RendererCssClassName).EXTENSION}`]: {
            marginTop: `${(0, $faPFq.blockNodesVerticalMargin)}`
        },
        [`.${(0, $jANeU.RendererCssClassName).STICKY_SAFE_CENTER_WRAPPER} .${(0, $jANeU.RendererCssClassName).EXTENSION}`]: {
            marginBottom: 0
        },
        /* platform_editor_flex_based_centering: embed card center wrapper has margin; zero MediaSingle vertical margin when wrapped so it doesn't double */ [`.${(0, $jANeU.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} .mediaSingleView-content-wrap`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).STICKY_SAFE_BREAKOUT_INNER} > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).EMBED_CARD_CENTER_WRAPPER} > .mediaSingleView-content-wrap > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:first-child`]: {
            marginTop: 0
        },
        [`.${(0, $jANeU.RendererCssClassName).BLOCK_CARD_DATASOURCE_CENTER_WRAPPER} > div > *:last-child`]: {
            marginBottom: 0
        },
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            overflowX: 'auto'
        },
        [`.${(0, $6pavR.shadowObserverClassNames).SHADOW_CONTAINER} .${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER}`]: {
            display: 'flex'
        }
    }
});
const $65f9c2a843d3972c$var$alignedHeadingAnchorStyleDuplicateAnchor = /*#__PURE__*/ (0, $lqVX7.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        'h1, h2, h3, h4, h5, h6': {
            position: 'relative'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $i0d0i.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $65f9c2a843d3972c$var$alignedHeadingAnchorStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    '.fabric-editor-block-mark[data-align] >': {
        '.renderer-heading-wrapper': {
            'h1, h2, h3, h4, h5, h6': {
                position: 'relative'
            }
        }
    },
    // Center alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="center"] > .renderer-heading-wrapper': {
        justifyContent: 'center'
    },
    // Right/end alignment for heading wrapper - flex container needs justify-content instead of text-align
    '.fabric-editor-block-mark[data-align="end"] > .renderer-heading-wrapper': {
        justifyContent: 'flex-end'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.fabric-editor-block-mark:not([data-align="center"])[data-align]': {
        [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
            marginTop: 0,
            marginRight: "var(--ds-space-075, 6px)",
            marginBottom: 0,
            marginLeft: 0,
            // If the anchor is right aligned then the left side of the heading
            // is aligned with the left side of the anchor.
            // In order to align as expected we transform it the width of the element (plus our expected 6px)
            // to the left
            transform: `translateX(calc(-100% - ${"var(--ds-space-075, 6px)"}))`
        },
        '@media (hover: hover) and (pointer: fine)': {
            [`.${0, $i0d0i.HeadingAnchorWrapperClassName} > button`]: {
                transform: `translate(8px, 0px)`
            }
        }
    }
});
const $65f9c2a843d3972c$var$firstWrappedMediaStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Remove gap between first wrapped mediaSingle and its fellow wrapped mediaSingle
    [`.${0, $jPLRO.richMediaClassName}[class*="image-wrap-"]:has(+ .${0, $jPLRO.richMediaClassName}[class*="image-wrap-"])`]: {
        marginRight: 0,
        marginLeft: 0
    }
});
// Temporarily ignoring the below the owning team can add the ticket number for the TODO.  Context: https://atlassian.slack.com/archives/CPUEVD9MY/p1741565387326829
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// TODO: emotion refactor - there's a mediaSingleSharedNewStyle, but not originally used in the renderer.
const $65f9c2a843d3972c$var$mediaSingleSharedStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${0, $jPLRO.richMediaClassName}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${0, $jPLRO.richMediaClassName}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $jPLRO.richMediaClassName}.image-wrap-right + .${0, $jPLRO.richMediaClassName}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${0, $jPLRO.richMediaClassName}.image-wrap-left + .${0, $jPLRO.richMediaClassName}.image-wrap-right, .${0, $jPLRO.richMediaClassName}.image-wrap-right + .${0, $jPLRO.richMediaClassName}.image-wrap-left, .${0, $jPLRO.richMediaClassName}.image-wrap-left + .${0, $jPLRO.richMediaClassName}.image-wrap-left, .${0, $jPLRO.richMediaClassName}.image-wrap-right + .${0, $jPLRO.richMediaClassName}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$65f9c2a843d3972c$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            marginTop: "var(--ds-space-150, 12px)",
            marginRight: 0,
            marginBottom: "var(--ds-space-150, 12px)",
            marginLeft: 0
        }
    }
});
// was shared between editor-core and renderer
const $65f9c2a843d3972c$var$tableSharedStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // originally from packages/editor/editor-common/src/styles/shared/tableCell.ts
    // Hardcoding the background color for the table cells to avoid the use of inline styles
    'td[colorname="white" i], th[colorname="white" i]': {
        backgroundColor: `${"var(--ds-surface, #FFFFFF)"} !important`
    },
    'td[colorname="light blue" i], th[colorname="light blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"} !important`
    },
    'td[colorname="light teal" i], th[colorname="light teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtlest, #E7F9FF)"} !important`
    },
    'td[colorname="light green" i], th[colorname="light green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"} !important`
    },
    'td[colorname="light yellow" i], th[colorname="light yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"} !important`
    },
    'td[colorname="light red" i], th[colorname="light red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"} !important`
    },
    'td[colorname="light purple" i], th[colorname="light purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"} !important`
    },
    'td[colorname="light gray" i], th[colorname="light gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"} !important`
    },
    'td[colorname="blue" i], th[colorname="blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtler, #CFE1FD)"} !important`
    },
    'td[colorname="teal" i], th[colorname="teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtler, #C6EDFB)"} !important`
    },
    'td[colorname="green" i], th[colorname="green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtler, #BAF3DB)"} !important`
    },
    'td[colorname="yellow" i], th[colorname="yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-yellow-subtler, #F5E989)"} !important`
    },
    'td[colorname="red" i], th[colorname="red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtler, #FFD5D2)"} !important`
    },
    'td[colorname="purple" i], th[colorname="purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtler, #EED7FC)"} !important`
    },
    'td[colorname="gray" i], th[colorname="gray" i]': {
        backgroundColor: `${"var(--ds-background-accent-gray-subtle, #8C8F97)"} !important`
    },
    'td[colorname="dark blue" i], th[colorname="dark blue" i]': {
        backgroundColor: `${"var(--ds-background-accent-blue-subtle, #669DF1)"} !important`
    },
    'td[colorname="dark teal" i], th[colorname="dark teal" i]': {
        backgroundColor: `${"var(--ds-background-accent-teal-subtle, #6CC3E0)"} !important`
    },
    'td[colorname="dark green" i], th[colorname="dark green" i]': {
        backgroundColor: `${"var(--ds-background-accent-green-subtle, #4BCE97)"} !important`
    },
    'td[colorname="dark yellow" i], th[colorname="dark yellow" i]': {
        backgroundColor: `${"var(--ds-background-accent-orange-subtle, #FCA700)"} !important`
    },
    'td[colorname="dark red" i], th[colorname="dark red" i]': {
        backgroundColor: `${"var(--ds-background-accent-red-subtle, #F87168)"} !important`
    },
    'td[colorname="dark purple" i], th[colorname="dark purple" i]': {
        backgroundColor: `${"var(--ds-background-accent-purple-subtle, #C97CF4)"} !important`
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: "var(--ds-space-200, 16px)",
        marginLeft: 'auto',
        boxSizing: 'border-box',
        /**
     * Fix block top alignment inside table cells.
     */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '.decisionItemView-content-wrap:first-of-type > div': {
            marginTop: 0
        }
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}[data-number-column='true']`]: {
        paddingLeft: `${(0, $faPFq.akEditorTableNumberColumnWidth) - 1}px`,
        clear: 'both'
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`]: {
        willChange: 'width, margin-left'
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_RESIZER_CONTAINER} table`]: {
        willChange: 'width'
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        marginTop: "var(--ds-space-300, 24px)",
        marginRight: "var(--ds-space-100, 8px)",
        marginBottom: 0,
        marginLeft: 0
    },
    /* avoid applying styles to nested tables (possible via extensions) */ [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderCollapse: 'collapse',
        border: `${(0, $3HHms.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        tableLayout: 'fixed',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        width: '100%',
        '&[data-autosize="true"]': {
            tableLayout: 'auto'
        },
        '&[data-initial-width-mode="content"]': {
            tableLayout: 'auto',
            width: 'auto'
        },
        '*': {
            boxSizing: 'border-box'
        },
        hr: {
            boxSizing: 'content-box'
        },
        tbody: {
            borderBottom: 'none'
        },
        'th td': {
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)"
        },
        '> tbody > tr > td': {
            backgroundColor: "var(--ds-surface, #FFFFFF)"
        },
        th: {
            backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
            textAlign: 'left',
            /* only apply this styling to codeblocks in default background headercells */ /* TODO this needs to be overhauled as it relies on unsafe selectors */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:not([style]):not(.danger)': {
                [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}:not(.danger)`]: {
                    backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
                    [`&:not(.${0, $faPFq.akEditorSelectedNodeClassName})`]: {
                        boxShadow: `0px 0px 0px 1px ${"var(--ds-border, #0B120E24)"}`
                    },
                    [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
                        backgroundColor: "var(--ds-background-neutral, #0515240F)"
                    },
                    /* this is only relevant to the element taken care of by renderer */ '> [data-ds--code--code-block]': {
                        // originally copied from packages/editor/editor-shared-styles/src/overflow-shadow/overflow-shadow.ts
                        backgroundImage: `linear-gradient(
							to right,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-300, 24px)"},
							transparent ${"var(--ds-space-300, 24px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-background-neutral, #0515240F)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-surface-raised, #FFFFFF)"} ${"var(--ds-space-100, 8px)"},
							transparent ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to left,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  ),linear-gradient(
							to right,
							${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0,
							${"var(--ds-UNSAFE-transparent, transparent)"}  ${"var(--ds-space-100, 8px)"}
						  )`,
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}!important`,
                        // selector lives inside @atlaskit/code
                        '--ds--code--line-number-bg-color': "var(--ds-background-neutral, #0515240F)"
                    }
                }
            }
        }
    }
});
const $65f9c2a843d3972c$var$roundedTableOuterBorderOverlayStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
	.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderColor: 'transparent',
        position: 'relative',
        '&::after': {
            content: "''",
            position: 'absolute',
            inset: '-0.5px',
            border: `${(0, $3HHms.tableCellBorderWidth)}px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRadius: "var(--ds-radius-xlarge, 12px)",
            pointerEvents: 'none',
            zIndex: 1
        },
        '> tbody > tr > th[data-reaches-top], > tbody > tr > td[data-reaches-top]': {
            borderTopColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-bottom], > tbody > tr > td[data-reaches-bottom]': {
            borderBottomColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderLeftColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderRightColor: 'transparent'
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-left], > tbody > tr > td[data-reaches-top][data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round ${"var(--ds-radius-xlarge, 12px)"} 0 0 0)`
        },
        '> tbody > tr > th[data-reaches-top][data-reaches-right], > tbody > tr > td[data-reaches-top][data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round 0 ${"var(--ds-radius-xlarge, 12px)"} 0 0)`
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-left], > tbody > tr > td[data-reaches-bottom][data-reaches-left]': {
            borderBottomLeftRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round 0 0 0 ${"var(--ds-radius-xlarge, 12px)"})`
        },
        '> tbody > tr > th[data-reaches-bottom][data-reaches-right], > tbody > tr > td[data-reaches-bottom][data-reaches-right]': {
            borderBottomRightRadius: "var(--ds-radius-xlarge, 12px)",
            backgroundClip: 'border-box',
            clipPath: `inset(0 round 0 0 ${"var(--ds-radius-xlarge, 12px)"} 0)`
        }
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`]: {
        borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
        borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
    },
    // Keep the cloned sticky header rounded at the top while preserving a square bottom edge.
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky > .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '&::after': {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0
        },
        '> tbody > tr': {
            // The sticky table clone sets a row background locally; force it off so
            // the rounded header cells, not a square row box, own the visible fill.
            background: 'transparent !important'
        },
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'border-box'
        },
        '> tbody > tr > th[data-reaches-left], > tbody > tr > td[data-reaches-left]': {
            borderTopLeftRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomLeftRadius: 0,
            clipPath: `inset(0 round ${"var(--ds-radius-xlarge, 12px)"} 0 0 0)`
        },
        '> tbody > tr > th[data-reaches-right], > tbody > tr > td[data-reaches-right]': {
            borderTopRightRadius: "var(--ds-radius-xlarge, 12px)",
            borderBottomRightRadius: 0,
            clipPath: `inset(0 round 0 ${"var(--ds-radius-xlarge, 12px)"} 0 0)`
        },
        '> tbody > tr > th[data-reaches-left][data-reaches-bottom], > tbody > tr > td[data-reaches-left][data-reaches-bottom]': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right][data-reaches-bottom], > tbody > tr > td[data-reaches-right][data-reaches-bottom]': {
            borderBottomRightRadius: 0
        },
        '> tbody > tr > th[data-reaches-left]::after, > tbody > tr > td[data-reaches-left]::after': {
            borderBottomLeftRadius: 0
        },
        '> tbody > tr > th[data-reaches-right]::after, > tbody > tr > td[data-reaches-right]::after': {
            borderBottomRightRadius: 0
        }
    }
});
const $65f9c2a843d3972c$var$tableContentModeStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}:has(table[data-initial-width-mode="content"])`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'max-content !important',
        maxWidth: 'var(--renderer-table-max-width)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} table[data-initial-width-mode="content"] > colgroup > col`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        width: 'unset !important'
    }
});
const $65f9c2a843d3972c$var$tableRendererHeaderStylesForTableCellOnly = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            minWidth: `${(0, $3HHms.tableCellMinWidth)}px`,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            verticalAlign: 'top',
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
            borderRightWidth: 0,
            borderBottomWidth: 0,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingRight: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            paddingLeft: "var(--ds-space-100, 8px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            'th p:not(:first-of-type), td p:not(:first-of-type)': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    }
});
const $65f9c2a843d3972c$var$tableRendererNestedPanelStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} .ak-editor-panel`]: {
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
    }
});
const $65f9c2a843d3972c$var$tableStylesBackGroundClipForGeckoForTableCellOnly = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> tbody > tr > th, > tbody > tr > td': {
            backgroundClip: 'padding-box'
        }
    }
});
const $65f9c2a843d3972c$var$firstNodeWithNotMarginTopWithNestedDnD = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :nth-child(1 of :not(style, .ProseMirror-gapcursor, .ProseMirror-widget, span))': {
                marginTop: 0
            }
        }
    }
});
const $65f9c2a843d3972c$var$firstNodeWithNotMarginTop = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
		.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        '> tbody > tr > th, > tbody > tr > td': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> :first-child:not(style), > style:first-child + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                marginTop: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                marginTop: 0
            }
        }
    }
});
const $65f9c2a843d3972c$var$rendererTableStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        zIndex: 0,
        transition: `all 0.1s linear`,
        display: 'flex' /* needed to avoid position: fixed jumpiness in Chrome */ ,
        /** Shadow overrides */ [`&.${(0, $2qSQf.shadowClassNames).RIGHT_SHADOW}::after, &.${(0, $2qSQf.shadowClassNames).LEFT_SHADOW}::before`]: {
            top: `${(0, $3HHms.tableMarginTop) - 1}px`,
            height: `calc(100% - ${(0, $3HHms.tableMarginTop)}px)`,
            zIndex: `${(0, $faPFq.akEditorStickyHeaderZIndex)}`,
            width: `${$65f9c2a843d3972c$var$tableShadowWidth}px`,
            background: `linear-gradient(
					to left,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to right,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`
        },
        [`&.${(0, $2qSQf.shadowClassNames).RIGHT_SHADOW}::after`]: {
            background: `linear-gradient(
					to right,
					transparent 0,
					${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 140%
				),
				linear-gradient(
					to left,
					${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0px,
					transparent 1px
				)`,
            right: `0px`
        },
        [`&
          .${(0, $6pavR.shadowObserverClassNames).SENTINEL_LEFT},
          &
          .${(0, $6pavR.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
            height: `calc(100% - ${(0, $3HHms.tableMarginTop)}px)`
        }
    }
});
const $65f9c2a843d3972c$var$stickyScrollbarStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        position: 'relative',
        flexDirection: 'column',
        [`> .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`]: {
            width: '100%',
            display: 'block',
            visibility: 'hidden',
            overflowX: 'auto',
            position: 'sticky',
            bottom: `${"var(--ds-space-0, 0px)"}`,
            zIndex: 1
        },
        [`> .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
		> .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            position: 'absolute',
            width: '100%',
            height: '1px',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            marginTop: '-1px',
            // need this to avoid sentinel being focused via keyboard
            // this still allows it to be detected by intersection observer
            visibility: 'hidden'
        },
        [`> .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP}`]: {
            top: `${$65f9c2a843d3972c$var$tableRowHeight * 3}px`
        },
        [`> .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM}`]: {
            bottom: `${"var(--ds-space-250, 20px)"}` // MAX_BROWSER_SCROLLBAR_HEIGHT = 20;
        }
    }
});
const $65f9c2a843d3972c$var$rendererTableHeaderEqualHeightStylesForTableCellOnly = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            height: '1px' /* will be ignored */ ,
            marginLeft: 0,
            marginRight: 0
        }
    },
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table > tbody > tr:first-of-type, .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table > tbody > tr:first-of-type`]: {
        height: '100%',
        'td, th': {
            position: 'relative'
        }
    }
});
const $65f9c2a843d3972c$var$rendererTableSortableColumnStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            // allow nested heading links
            [`.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                padding: 0,
                [`.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    width: '100%',
                    height: '100%',
                    padding: `${(0, $3HHms.tableCellPadding)}px`,
                    // eslint-disable-next-line @atlaskit/design-system/use-tokens-shape
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: `transparent`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> *:first-child': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + *, > style:first-child + .ProseMirror-gapcursor + *': {
                        marginTop: 0
                    },
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                    '> .ProseMirror-gapcursor:first-child + span + *, > style:first-child + .ProseMirror-gapcursor + span + *': {
                        marginTop: 0
                    },
                    '@supports selector(:focus-visible)': {
                        '&:focus': {
                            outline: 'unset'
                        },
                        '&:focus-visible': {
                            borderColor: `${"var(--ds-border-focused, #4688EC)"}`
                        }
                    }
                },
                [`> .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN} > .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER}`]: {
                    margin: 0,
                    [`.${0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1,
                        transition: `opacity 0.2s ease-in-out`
                    }
                },
                [`> .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 0,
                        '&:focus': {
                            opacity: 1
                        }
                    }
                },
                [`&:hover:not(
							:has(
									.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}
										.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}:hover
								)
						)
						> .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}
						> .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER}`]: {
                    [`.${0, $9HI3q.SORTABLE_COLUMN_ICON_CLASSNAME}`]: {
                        opacity: 1
                    }
                }
            }
        }
    }
});
// Sortable header cells render content inside an extra div, so mirror the th alignment there.
const $65f9c2a843d3972c$var$rendererTableSortableColumnValignStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`th[data-valign='middle'].${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            },
            [`th[data-valign='bottom'].${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER} > .${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}`]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-end'
            }
        }
    }
});
const $65f9c2a843d3972c$var$rendererTableColumnStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        'table[data-number-column="true"]': {
            [`.${(0, $jANeU.RendererCssClassName).NUMBER_COLUMN}`]: {
                backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
                borderRight: `${"var(--ds-border-width, 1px)"} solid
								${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
                width: `${(0, $faPFq.akEditorTableNumberColumnWidth)}px`,
                textAlign: 'center',
                color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875} rem`
            },
            [`.fixed .${(0, $jANeU.RendererCssClassName).NUMBER_COLUMN}`]: {
                borderRight: `0px none`
            }
        }
    }
});
const $65f9c2a843d3972c$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '>': {
                        'h1, h2, h3, h4, h5, h6': {
                            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                            marginRight: '30px'
                        }
                    }
                }
            }
        }
    }
});
const $65f9c2a843d3972c$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table, .${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            [`.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN_WRAPPER}`]: {
                [`.${(0, $jANeU.RendererCssClassName).SORTABLE_COLUMN}`]: {
                    [`.${0, $i0d0i.HeadingAnchorWrapperClassName}`]: {
                        position: 'unset'
                    },
                    '> .renderer-heading-wrapper': {
                        // Reserve space for the sortable-column icon so the heading+anchor wrapper never overlaps it.
                        // Use padding (instead of margin on the heading) so we don't create a gap between the heading
                        // text and the copy-link anchor button
                        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
                        paddingRight: '30px'
                    }
                }
            }
        }
    }
});
// @ts-expect-error - throw TS error when use !import in position.
const $65f9c2a843d3972c$var$stickyHeaderStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    'tr[data-header-row].fixed': {
        position: 'fixed !important',
        display: 'flex',
        overflow: 'hidden',
        zIndex: `${(0, $faPFq.akEditorStickyHeaderZIndex)}`,
        borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`,
        /* this is to compensate for the table border */ transform: 'translateX(-1px)'
    },
    '.sticky > th': {
        zIndex: `${(0, $faPFq.akEditorStickyHeaderZIndex)}`,
        position: 'fixed !important',
        top: 0
    },
    /* Make the number column header sticky */ '.sticky > td': {
        position: 'fixed !important',
        top: 0
    },
    /* add border for position: sticky
  and work around background-clip: padding-box
  bug for FF causing box-shadow bug in Chrome */ '.sticky th, .sticky td': {
        boxShadow: `0px 1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -0.5px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			inset -1px 0px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"},
			0px -1px ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"}`
    },
    /* this will remove jumpiness caused in Chrome for sticky headers */ '.fixed + tr': {
        minHeight: '0px'
    }
});
const $65f9c2a843d3972c$var$codeBlockAndLayoutStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    /*
   * We wrap CodeBlock in a grid to prevent it from overflowing the container of the renderer.
   * See ED-4159.
   */ '& .code-block': {
        maxWidth: '100%',
        display: 'block',
        position: 'relative',
        borderRadius: "var(--ds-radius-small, 3px)",
        /*
     * The overall renderer has word-wrap: break; which causes issues with
     * code block line numbers in Safari / iOS.
     */ wordWrap: 'normal'
    },
    '& .MediaGroup, & .code-block': {
        marginTop: `${(0, $faPFq.blockNodesVerticalMargin)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '&:first-child': {
            marginTop: 0
        }
    },
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}
		> .${(0, $cYNsM.LightWeightCodeBlockCssClassName).CONTAINER}
		.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        marginTop: (0, $faPFq.blockNodesVerticalMargin)
    },
    '& [data-layout-section]': {
        marginTop: "var(--ds-space-250, 20px)",
        '& > div + div': {
            marginLeft: "var(--ds-space-400, 32px)"
        },
        [`@media screen and (max-width: ${0, $faPFq.gridMediumMaxWidth}px)`]: {
            '& > div + div': {
                marginLeft: 0
            }
        },
        '& .MediaGroup, & .code-block': {
            marginTop: (0, $faPFq.blockNodesVerticalMargin),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&:first-child': {
                marginTop: 0
            }
        }
    },
    '& li': {
        '> .code-block': {
            margin: `${(0, $faPFq.blockNodesVerticalMargin)} 0 0 0`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:first-child': {
            marginTop: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> div:last-of-type.code-block': {
            marginBottom: (0, $faPFq.blockNodesVerticalMargin)
        }
    }
});
const $65f9c2a843d3972c$var$layoutSectionForAdvancedLayoutsStyles = {
    name: "4wptv0",
    styles: "& [data-layout-section]{& > div + div{margin-left:0;}}"
};
const $65f9c2a843d3972c$var$gridRenderForCodeBlockStyles = {
    name: "18d2t58",
    styles: "& .code-block{display:grid;grid-template-columns:minmax(0, 1fr);& > span{grid-column:1;}}"
};
// This prevents https://product-fabric.atlassian.net/browse/ED-20924
const $65f9c2a843d3972c$var$codeBlockInListSafariFixStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`&:not([data-node-type='decisionList']) > li,
		&:not(.${(0, $4ZvVm.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER}) > li`]: {
        '&::before': {
            content: '" "',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: (0, $faPFq.akEditorLineHeight)
        },
        [`> p:first-child,
			> .code-block:first-child,
			> .ProseMirror-gapcursor:first-child + .code-block`]: {
            marginTop: `-${(0, $faPFq.akEditorLineHeight)}em !important`
        }
    }
});
const $65f9c2a843d3972c$var$columnLayoutSharedStyle = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $faPFq.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});
const $65f9c2a843d3972c$var$columnLayoutResponsiveSharedStyle = {
    name: "ee7qh9",
    styles: "[data-layout-section]{display:flex;flex-direction:row;gap:var(--ds-space-100, 8px);& > *{flex:1;min-width:0;}& > .unsupportedBlockView-content-wrap{min-width:initial;}}.layout-section-container{container-type:inline-size;container-name:layout-area;}"
};
const $65f9c2a843d3972c$var$columnLayoutResponsiveRendererStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.layout-section-container [data-layout-section]': {
        gap: "var(--ds-space-600, 48px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
        [`@container layout-area (max-width: ${$65f9c2a843d3972c$var$LAYOUT_BREAKPOINT_RENDERER}px)`]: {
            flexDirection: 'column',
            gap: "var(--ds-space-400, 32px)"
        }
    }
});
const $65f9c2a843d3972c$var$rendererAnnotationStylesOld = /*#__PURE__*/ (0, $lqVX7.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
        background: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    }
});
const $65f9c2a843d3972c$var$rendererAnnotationStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border-accent-yellow, #B38600)"}`,
        cursor: 'pointer',
        paddingTop: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-025, 2px)"
    },
    "& [data-mark-type='annotation'][data-mark-annotation-state='active'][data-has-focus='true'] [data-annotation-mark]": {
        background: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }
});
const $65f9c2a843d3972c$var$rendererAnnotationStylesCommentHeightFix = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node]': {
        borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid transparent`,
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        paddingTop: '1px',
        paddingRight: 0,
        paddingBottom: "var(--ds-space-025, 2px)",
        paddingLeft: 0,
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        borderBottomColor: "var(--ds-border-accent-yellow, #B38600)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node][data-inline-card]': {
        padding: '5px 0 3px 0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& [data-annotation-draft-mark][data-annotation-inline-node].date-lozenger-container': {
        paddingTop: "var(--ds-space-025, 2px)"
    }
});
const $65f9c2a843d3972c$var$RENDERER_LIST_DENSE_GAP = `max(0px,calc((var(--ak-renderer-base-font-size) - ${(0, $faPFq.akEditorFullPageDenseFontSize)}px)* (4/3)))`;
const $65f9c2a843d3972c$var$TASKLIST_CONTAINER_DENSE_MARGIN = `max(calc(10px + (var(--ak-renderer-base-font-size) - ${(0, $faPFq.akEditorFullPageDenseFontSize)}px) *( 2 / 3)))`;
const $65f9c2a843d3972c$var$scaledDenseEmojiStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $kTZWy.defaultDenseEmojiHeight)}px`,
        minHeight: `${(0, $kTZWy.defaultDenseEmojiHeight)}px`,
        minWidth: `${(0, $kTZWy.defaultDenseEmojiHeight)}px`,
        maxHeight: `${(0, $kTZWy.denseEmojiHeightH1)}px`,
        maxWidth: `${(0, $kTZWy.denseEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.denseEmojiHeightH1)}px`,
        width: `${(0, $kTZWy.denseEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.denseEmojiHeightH2)}px`,
        width: `${(0, $kTZWy.denseEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.denseEmojiHeightH3)}px`,
        width: `${(0, $kTZWy.denseEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.denseEmojiHeightH4)}px`,
        width: `${(0, $kTZWy.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.defaultDenseEmojiHeight)}px`,
        width: `${(0, $kTZWy.defaultDenseEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`,
        height: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`,
        width: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`
    }
});
const $65f9c2a843d3972c$var$scaledDenseUnicodeEmojiStylesNew = /*#__PURE__*/ (0, $lqVX7.css)({
    [`[data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.defaultDenseEmojiHeight)}px`
    },
    [`h1 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.denseEmojiHeightH1)}px`
    },
    [`h2 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.denseEmojiHeightH2)}px`
    },
    [`h3 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.denseEmojiHeightH3)}px`
    },
    [`h4 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.denseEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.defaultDenseEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.defaultInlineEmojiHeight)}px`
    }
});
const $65f9c2a843d3972c$var$scaledEmojiStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `${(0, $kTZWy.defaultEmojiHeight)}px`,
        minHeight: `${(0, $kTZWy.defaultEmojiHeight)}px`,
        minWidth: `${(0, $kTZWy.defaultEmojiHeight)}px`,
        maxHeight: `${(0, $kTZWy.scaledEmojiHeightH1)}px`,
        maxWidth: `${(0, $kTZWy.scaledEmojiHeightH1)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    [`h1 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.scaledEmojiHeightH1)}px`,
        width: `${(0, $kTZWy.scaledEmojiHeightH1)}px`
    },
    [`h2 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.scaledEmojiHeightH2)}px`,
        width: `${(0, $kTZWy.scaledEmojiHeightH2)}px`
    },
    [`h3 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.scaledEmojiHeightH3)}px`,
        width: `${(0, $kTZWy.scaledEmojiHeightH3)}px`
    },
    [`h4 :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.scaledEmojiHeightH4)}px`,
        width: `${(0, $kTZWy.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        height: `${(0, $kTZWy.defaultEmojiHeight)}px`,
        width: `${(0, $kTZWy.defaultEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] :is(.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_SPRITE}, .${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_PLACEHOLDER})`]: {
        minHeight: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`,
        minWidth: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`,
        height: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`,
        width: `${(0, $kTZWy.defaultInlineEmojiHeight)}px`
    }
});
const $65f9c2a843d3972c$var$scaledUnicodeEmojiStylesNew = /*#__PURE__*/ (0, $lqVX7.css)({
    [`[data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.defaultEmojiHeight)}px`
    },
    [`h1 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.scaledEmojiHeightH1)}px`
    },
    [`h2 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.scaledEmojiHeightH2)}px`
    },
    [`h3 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.scaledEmojiHeightH3)}px`
    },
    [`h4 [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.scaledEmojiHeightH4)}px`
    },
    [`:is(h5, h6, p) [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.defaultEmojiHeight)}px`
    },
    // sync with platform/packages/linking-platform/smart-card/src/view/InlineCard/IconAndTitleLayout/index.tsx
    [`[data-testid="icon-wrapper"] [data-emoji-type="unicode"]`]: {
        '--emoji-common-unicode-size': `${(0, $kTZWy.defaultInlineEmojiHeight)}px`
    }
});
const $65f9c2a843d3972c$var$denseStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Scale emoji size based on base font size
    // Default: 20px emoji at 16px base font
    // Scaled: 20px * (baseFontSize/16)
    // E.g., dense mode (13px base): 20px * (13/16) = 16.25px
    [`.${(0, $9jkQC.EmojiSharedCssClassName).EMOJI_IMAGE}`]: {
        height: `calc(${(0, $kTZWy.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $faPFq.akEditorFullPageDefaultFontSize)})`,
        width: `calc(${(0, $kTZWy.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $faPFq.akEditorFullPageDefaultFontSize)})`,
        maxHeight: `calc(${(0, $kTZWy.defaultEmojiHeight)} * var(--ak-renderer-base-font-size) / ${(0, $faPFq.akEditorFullPageDefaultFontSize)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    // Scale panel icon
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT} .ak-editor-panel .ak-editor-panel__icon`]: {
        height: "var(--ds-space-250, 20px)",
        width: "var(--ds-space-250, 20px)"
    },
    // Condense spacing across lists, tasks and decisions
    [`.${(0, $jANeU.RendererCssClassName).DOCUMENT}`]: {
        // Adjacent list items
        'li + li': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $65f9c2a843d3972c$var$RENDERER_LIST_DENSE_GAP
        },
        // Nested lists directly under an li (unordered and ordered)
        'li > ul, li > ol, .ak-ul li > ul, .ak-ul li > ol, .ak-ol li > ul, .ak-ol li > ol': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $65f9c2a843d3972c$var$RENDERER_LIST_DENSE_GAP
        },
        // Task lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id]': {
            // Task lists: container top margin
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $65f9c2a843d3972c$var$TASKLIST_CONTAINER_DENSE_MARGIN
        },
        // Task lists: sibling items and nested lists
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] > * + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $65f9c2a843d3972c$var$RENDERER_LIST_DENSE_GAP
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-task-list-local-id] [data-task-list-local-id], [data-task-local-id] [data-task-local-id]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            marginTop: $65f9c2a843d3972c$var$RENDERER_LIST_DENSE_GAP
        }
    }
});
const $65f9c2a843d3972c$var$syncBlockRendererStyles = {
    name: "g5u32w",
    styles: "margin:0;max-width:none;padding:0"
};
/**
 * Fake left/right table borders.
 *
 * Adapted from the editor-plugin-table behavior (see editor-common's
 * `tableSharedStyle()` in `editor-common/src/styles/shared/table.ts`). The
 * visible vertical edges of the table are painted by these absolutely-positioned
 * 1px divs that live inside the (non-scrolling) TABLE_CONTAINER, while the real
 * <table> left/right borders are made `transparent`. Because the divs are not
 * inside the horizontally scrolling TABLE_NODE_WRAPPER, they remain visible
 * regardless of scroll position — fixing the missing right border when an
 * overflowing table inside a reference synced block is scrolled all the way to
 * the left.
 *
 * The `height` formula adjusted for table in renderer
 */ const $65f9c2a843d3972c$var$tableFakeBorderStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        // Mirror the editor's tableSharedStyle() rule from
        // `editor-common/src/styles/shared/table.ts` (lines 142-150). The fake
        // borders are absolutely positioned inside pm-table-container;
        // their height is adjusted for renderer to `100% - space.300 - space.250` so the border runs from
        // the top of the table to the bottom of the container
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'block',
            width: '1px',
            height: `calc(100% - ${"var(--ds-space-300, 24px)"} - ${"var(--ds-space-250, 20px)"})`,
            background: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
            position: 'absolute',
            top: "var(--ds-space-300, 24px)"
        },
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER}`]: {
            right: 0
        },
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER},
		.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER}[data-with-numbered-table='true']`]: {
            left: 0
        }
    },
    // Make the real left/right table borders transparent so the fake border
    // divs above are the only painted vertical edges. Top/bottom borders on the
    // <table> element remain visible.
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_NODE_WRAPPER} > table,
	.${(0, $7akLL.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
        borderLeftColor: 'transparent',
        borderRightColor: 'transparent'
    }
});
const $65f9c2a843d3972c$var$roundedTableFakeBorderOverlayStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $7akLL.TableSharedCssClassName).TABLE_CONTAINER}`]: {
        [`.${(0, $7akLL.TableSharedCssClassName).TABLE_RIGHT_BORDER},
		.${(0, $7akLL.TableSharedCssClassName).TABLE_LEFT_BORDER}`]: {
            display: 'none'
        }
    }
});
const $65f9c2a843d3972c$var$syncBlockStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $6uG5y.SyncBlockSharedCssClassName).renderer}, .${(0, $6uG5y.BodiedSyncBlockSharedCssClassName).renderer}, .${(0, $6uG5y.SyncBlockSharedCssClassName).error}, .${(0, $6uG5y.SyncBlockSharedCssClassName).loading}`]: {
        borderRadius: "var(--ds-radius-small, 3px)",
        marginTop: "var(--ds-space-075, 6px)",
        paddingBlock: "var(--ds-space-150, 12px)",
        overflow: 'visible'
    },
    [`.${(0, $6uG5y.SyncBlockSharedCssClassName).renderer}`]: {
        // First child node in syncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '.ak-renderer-document > :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $6uG5y.BodiedSyncBlockSharedCssClassName).renderer}`]: {
        // First child node in bodiedSyncBlock in editor is overridden with marginTop: 0, hence apply the same style in renderer for consistency
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
        '> :first-child': {
            marginTop: 0
        }
    },
    [`.${(0, $6uG5y.SyncBlockSharedCssClassName).error}`]: {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    },
    [`.${(0, $6uG5y.SyncBlockSharedCssClassName).loading}`]: {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $65f9c2a843d3972c$export$8f0929e72efe521f = (props)=>{
    const { onClick: onClick, onMouseDown: onMouseDown, appearance: appearance, contentMode: contentMode, allowNestedHeaderLinks: allowNestedHeaderLinks, allowColumnSorting: allowColumnSorting, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, children: children, innerRef: innerRef, testId: testId, isInsideSyncBlock: isInsideSyncBlock } = props;
    const isAdvancedLayoutsOn = (0, $hdn08.editorExperiment)('advanced_layouts', true);
    const isPreviewPanelResponsivenessOn = (0, $hdn08.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    const isCompactModeSupported = (0, $4mqcS.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $4mqcS.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $3H4LK.fg)('platform_editor_content_mode_button_mvp');
    const isCompactModeEnabled = contentMode === 'compact' && isCompactModeSupported;
    const baseFontSize = (0, $8jG2i.getBaseFontSize)(appearance, contentMode);
    const browser = (0, $cpSqr.getBrowserInfo)();
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        role: "none",
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        style: {
            '--ak-renderer-base-font-size': `${baseFontSize}px`,
            '--ak-renderer-editor-font-heading-h1': `${(0, $cb7zl.default)('editor.font.heading.h1')}`,
            '--ak-renderer-editor-font-heading-h2': `${(0, $cb7zl.default)('editor.font.heading.h2')}`,
            '--ak-renderer-editor-font-heading-h3': `${(0, $cb7zl.default)('editor.font.heading.h3')}`,
            '--ak-renderer-editor-font-heading-h4': `${(0, $cb7zl.default)('editor.font.heading.h4')}`,
            '--ak-renderer-editor-font-heading-h5': `${(0, $cb7zl.default)('editor.font.heading.h5')}`,
            '--ak-renderer-editor-font-heading-h6': `${(0, $cb7zl.default)('editor.font.heading.h6')}`,
            '--ak-renderer-editor-font-normal-text': `${(0, $cb7zl.default)('editor.font.body')}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- CSS custom properties for UGC font tokens
            ...(0, $4mqcS.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && {
                '--ak-renderer-editor-font-small-text': (0, $cb7zl.default)('editor.font.body.small')
            }
        },
        css: [
            (0, $4mqcS.expValEquals)('confluence_ttvc_inline_extensions', 'isEnabled', true) ? $65f9c2a843d3972c$var$baseFontStyle : $65f9c2a843d3972c$var$originalBaseFontLineHeight,
            $65f9c2a843d3972c$var$baseStyles,
            (0, $4mqcS.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && $65f9c2a843d3972c$var$fontSizeStyles,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$headingAnchorStyles : $65f9c2a843d3972c$var$headingAnchorStylesDuplicateAnchor,
            (0, $3H4LK.fg)('ally_30945_accessibility_outline_fix') && $65f9c2a843d3972c$var$headingAnchorButtonFocusVisibleStyles,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$hideHeadingCopyLinkWrapperStyles : $65f9c2a843d3972c$var$hideHeadingCopyLinkWrapperStylesDuplicateAnchor,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $65f9c2a843d3972c$var$rendererFullPageStylesWithReducedPadding,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $65f9c2a843d3972c$var$rendererFullPageStyles,
            appearance === 'full-width' && ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $65f9c2a843d3972c$var$rendererFullWidthStyles : $65f9c2a843d3972c$var$oldRendererFullWidthStyles),
            (appearance === 'full-width' || appearance === 'max' && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && !(0, $eevY3.isTableResizingEnabled)(appearance) && $65f9c2a843d3972c$var$rendererFullWidthStylesForTableResizing,
            appearance === 'max' && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $65f9c2a843d3972c$var$rendererMaxWidthStyles : $65f9c2a843d3972c$var$oldRendererMaxWidthStyles),
            $65f9c2a843d3972c$var$rovoTelepointerStyles,
            $65f9c2a843d3972c$var$whitespaceSharedStyles,
            $65f9c2a843d3972c$var$blockquoteSharedStyles,
            $65f9c2a843d3972c$var$headingsSharedStyles,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $65f9c2a843d3972c$var$headingWrapperInlineFlowStyles,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$headingWithAlignmentStyles : $65f9c2a843d3972c$var$headingWithAlignmentStylesDuplicateAnchor,
            $65f9c2a843d3972c$var$ruleSharedStyles,
            contentMode === 'compact' && isCompactModeSupported && $65f9c2a843d3972c$var$extensionStyle,
            (0, $3H4LK.fg)('platform_editor_typography_ugc') ? isCompactModeSupported ? $65f9c2a843d3972c$var$paragraphStylesUGCScaledMargin : $65f9c2a843d3972c$var$paragraphSharedStylesWithEditorUGC : isCompactModeSupported ? $65f9c2a843d3972c$var$paragraphSharedStyleScaledMargin : $65f9c2a843d3972c$var$paragraphSharedStyles,
            $65f9c2a843d3972c$var$listsSharedStyles,
            browser.gecko && $65f9c2a843d3972c$var$listsSharedStylesForGekko,
            (0, $4mqcS.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && $65f9c2a843d3972c$var$listItemHiddenMarkerStyles,
            $65f9c2a843d3972c$var$indentationSharedStyles,
            $65f9c2a843d3972c$var$indentationSharedStylesWithMarginFix,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$blockMarksSharedStyles : $65f9c2a843d3972c$var$blockMarksSharedStylesDuplicateAnchor,
            $65f9c2a843d3972c$var$codeMarkSharedStyles,
            $65f9c2a843d3972c$var$shadowSharedStyle,
            $65f9c2a843d3972c$var$dateSharedStyle,
            $65f9c2a843d3972c$var$textColorStyles,
            $65f9c2a843d3972c$var$backgroundColorStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            $65f9c2a843d3972c$export$a365082c2a191514,
            $65f9c2a843d3972c$var$tasksAndDecisionsStyles,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) && $65f9c2a843d3972c$var$headingPanelStyles,
            $65f9c2a843d3972c$var$smartCardStyles,
            $65f9c2a843d3972c$var$smartCardStylesAvatarFix,
            (0, $hdn08.editorExperiment)('platform_editor_preview_panel_linking_exp', true) && $65f9c2a843d3972c$var$headerSmartCardStyles,
            $65f9c2a843d3972c$var$smartCardStylesAvatarMarginFix,
            $65f9c2a843d3972c$var$smartCardStylesAvatarListZeroMarginTop,
            (0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') && ((0, $4mqcS.expValEquals)('confluence_fe_renderer_inline_node_mark_color_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$rendererAnnotationStyles : $65f9c2a843d3972c$var$rendererAnnotationStylesOld),
            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $3H4LK.fg)('editor_inline_comments_on_inline_nodes') && $65f9c2a843d3972c$var$rendererAnnotationStylesCommentHeightFix,
            (0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$baseOtherStyles : $65f9c2a843d3972c$var$baseOtherStylesDuplicateAnchor,
            !(0, $4mqcS.expValEquals)('platform_editor_flex_based_centering', 'isEnabled', true) && $65f9c2a843d3972c$var$extensionCenterAlignLegacyStyles,
            // this should be placed after baseOtherStyles
            (0, $4mqcS.expValEquals)('platform_editor_render_bodied_extension_as_inline', 'isEnabled', true) && ((0, $4mqcS.expValEquals)('platform_editor_remove_important_in_render_ext', 'isEnabled', true) ? $65f9c2a843d3972c$var$extensionAsInlineStyle : $65f9c2a843d3972c$var$oldExtensionAsInlineStyle),
            $65f9c2a843d3972c$var$inlineExtensionRendererMarginFix,
            allowNestedHeaderLinks && ((0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$alignedHeadingAnchorStyle : $65f9c2a843d3972c$var$alignedHeadingAnchorStyleDuplicateAnchor),
            $65f9c2a843d3972c$var$mediaSingleSharedStyle,
            // merge firstWrappedMediaStyles with mediaSingleSharedStyle when clean up platform_editor_fix_media_in_renderer
            (0, $3H4LK.fg)('platform_editor_fix_media_in_renderer') && $65f9c2a843d3972c$var$firstWrappedMediaStyles,
            $65f9c2a843d3972c$var$tableSharedStyle,
            (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $65f9c2a843d3972c$var$roundedTableOuterBorderOverlayStyles,
            (0, $4mqcS.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) && $65f9c2a843d3972c$var$tableContentModeStyles,
            $65f9c2a843d3972c$var$tableRendererHeaderStylesForTableCellOnly,
            (0, $3H4LK.fg)('platform_editor_bordered_panel_nested_in_table') && $65f9c2a843d3972c$var$tableRendererNestedPanelStyles,
            $65f9c2a843d3972c$var$isBackgroundClipBrowserFixNeeded() && $65f9c2a843d3972c$var$tableStylesBackGroundClipForGeckoForTableCellOnly,
            (0, $3H4LK.fg)('platform_editor_nested_dnd_styles_changes') ? $65f9c2a843d3972c$var$firstNodeWithNotMarginTopWithNestedDnD : $65f9c2a843d3972c$var$firstNodeWithNotMarginTop,
            $65f9c2a843d3972c$var$rendererTableStyles,
            (0, $eevY3.isStickyScrollbarEnabled)(appearance) && $65f9c2a843d3972c$var$stickyScrollbarStyles,
            $65f9c2a843d3972c$var$rendererTableHeaderEqualHeightStylesForTableCellOnly,
            allowColumnSorting && $65f9c2a843d3972c$var$rendererTableSortableColumnStyles,
            allowColumnSorting && (0, $4ubSX.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) && $65f9c2a843d3972c$var$rendererTableSortableColumnValignStyles,
            allowColumnSorting && allowNestedHeaderLinks && ((0, $4mqcS.expValEquals)('platform_editor_copy_link_a11y_inconsistency_fix', 'isEnabled', true) ? $65f9c2a843d3972c$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinks : $65f9c2a843d3972c$var$rendererTableHeaderEqualHeightStylesAllowNestedHeaderLinksDuplicateAnchor),
            $65f9c2a843d3972c$var$rendererTableColumnStyles,
            $65f9c2a843d3972c$var$stickyHeaderStyles,
            $65f9c2a843d3972c$var$codeBlockAndLayoutStyles,
            $65f9c2a843d3972c$var$columnLayoutSharedStyle,
            isAdvancedLayoutsOn && $65f9c2a843d3972c$var$columnLayoutResponsiveSharedStyle,
            isAdvancedLayoutsOn && $65f9c2a843d3972c$var$columnLayoutResponsiveRendererStyles,
            isAdvancedLayoutsOn && $65f9c2a843d3972c$var$layoutSectionForAdvancedLayoutsStyles,
            !useBlockRenderForCodeBlock && $65f9c2a843d3972c$var$gridRenderForCodeBlockStyles,
            browser.safari && $65f9c2a843d3972c$var$codeBlockInListSafariFixStyles,
            appearance === 'full-page' && !isPreviewPanelResponsivenessOn && $65f9c2a843d3972c$var$responsiveBreakoutWidth,
            appearance === 'full-page' && isPreviewPanelResponsivenessOn && $65f9c2a843d3972c$var$responsiveBreakoutWidthWithReducedPadding,
            (appearance === 'full-width' || appearance === 'max' && ((0, $4mqcS.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $4mqcS.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true))) && $65f9c2a843d3972c$var$responsiveBreakoutWidthFullWidth,
            (0, $4mqcS.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? isCompactModeEnabled ? $65f9c2a843d3972c$var$scaledDenseEmojiStyles : $65f9c2a843d3972c$var$scaledEmojiStyles : isCompactModeEnabled ? $65f9c2a843d3972c$var$denseStyles : undefined,
            isCompactModeEnabled ? $65f9c2a843d3972c$var$scaledDenseUnicodeEmojiStylesNew : $65f9c2a843d3972c$var$scaledUnicodeEmojiStylesNew,
            (0, $hdn08.editorExperiment)('platform_synced_block', true) && $65f9c2a843d3972c$var$syncBlockStyles,
            $65f9c2a843d3972c$var$centerWrapperStyles,
            (0, $hdn08.editorExperiment)('platform_synced_block', true) && isInsideSyncBlock ? $65f9c2a843d3972c$var$syncBlockRendererStyles : null,
            isInsideSyncBlock && (0, $hdn08.editorExperiment)('platform_synced_block', true) && $65f9c2a843d3972c$var$tableFakeBorderStyles,
            isInsideSyncBlock && (0, $hdn08.editorExperiment)('platform_synced_block', true) && (0, $4mqcS.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $65f9c2a843d3972c$var$roundedTableFakeBorderOverlayStyles : null,
            (0, $4mqcS.expValEquals)('platform_editor_hide_extension_renderer_support', 'isEnabled', true) && $65f9c2a843d3972c$var$hideExtensionStyles
        ],
        "data-testid": testId
    }, children);
};

});
parcelRegister("4meEa", function(module, exports) {
$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $6d522dc57f09696a$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $6d522dc57f09696a$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $6d522dc57f09696a$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $6d522dc57f09696a$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "wrapperStyle", () => $6d522dc57f09696a$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $6d522dc57f09696a$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "borderStyle", () => $6d522dc57f09696a$export$4d0a7f76ad443516);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $fsjou = parcelRequire("fsjou");
const $6d522dc57f09696a$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $6d522dc57f09696a$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $6d522dc57f09696a$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $6d522dc57f09696a$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $6d522dc57f09696a$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $lqVX7.css)(">.mediaInlineView-content-wrap>.", $6d522dc57f09696a$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $6d522dc57f09696a$export$dd2e16f83ae6aa78, ",>.", $6d522dc57f09696a$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $6d522dc57f09696a$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $6d522dc57f09696a$export$dee15762144889b7 = /*#__PURE__*/ (0, $lqVX7.css)(".", $6d522dc57f09696a$export$dd2e16f83ae6aa78, "{height:", (0, $fsjou.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $6d522dc57f09696a$var$inlineImageHeight((0, $fsjou.referenceHeights)['h1'], -3), ";}h2{", $6d522dc57f09696a$var$inlineImageHeight((0, $fsjou.referenceHeights)['h2'], -3), ";}h3{", $6d522dc57f09696a$var$inlineImageHeight((0, $fsjou.referenceHeights)['h3'], -2), ";}h4{", $6d522dc57f09696a$var$inlineImageHeight((0, $fsjou.referenceHeights)['h4'], -2), ";}h5{", $6d522dc57f09696a$var$inlineImageHeight((0, $fsjou.referenceHeights)['h5'], -2), ";}h6{", $6d522dc57f09696a$var$inlineImageHeight((0, $fsjou.referenceHeights)['h6'], -2), ";}");
const $6d522dc57f09696a$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'inline-flex',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-radius-small, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$6d522dc57f09696a$export$7ab34e219ce6eef}, ${(0, $fsjou.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $6d522dc57f09696a$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $lqVX7.css)({
    boxShadow: `0 0 0 1px ${"var(--ds-border-selected, #1868DB)"}`,
    outline: 'none'
});
const $6d522dc57f09696a$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $lqVX7.css)({
    borderColor: `var(${$6d522dc57f09696a$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$6d522dc57f09696a$export$263a8a844c370a89}, ${(0, $fsjou.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$6d522dc57f09696a$export$263a8a844c370a89}, ${(0, $fsjou.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("fsjou", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $6326f54fcc4f276d$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $6326f54fcc4f276d$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $6326f54fcc4f276d$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $6326f54fcc4f276d$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $6326f54fcc4f276d$export$c1317a9224e4d798);
const $6326f54fcc4f276d$export$d722b7527b1834a8 = 250;
const $6326f54fcc4f276d$export$da894f7669b4e67c = 200;
const $6326f54fcc4f276d$export$286cf28b87ad4b4f = $6326f54fcc4f276d$export$d722b7527b1834a8 / $6326f54fcc4f276d$export$da894f7669b4e67c;
const $6326f54fcc4f276d$export$64fe09732fb8680 = 0;
const $6326f54fcc4f276d$export$c1317a9224e4d798 = {
    p: 22,
    h1: 36,
    h2: 31,
    h3: 25,
    h4: 23,
    h5: 20,
    h6: 18
};

});


parcelRegister("8JLrS", function(module, exports) {
$parcel$export(module.exports, "DateSharedCssClassName", () => $5e1388c5c3b06fe5$export$99cdf122d0bb9f95);
const $5e1388c5c3b06fe5$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};

});

parcelRegister("jPLRO", function(module, exports) {
$parcel$export(module.exports, "richMediaClassName", () => $7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lqVX7 = parcelRequire("lqVX7");

var $faPFq = parcelRequire("faPFq");
const $7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb = 'rich-media-item';
const $7cd7c98ac6cb3bcd$var$wrappedMediaBreakoutPoint = 410;
const $7cd7c98ac6cb3bcd$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right, .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left, .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left, .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$7cd7c98ac6cb3bcd$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});
const $7cd7c98ac6cb3bcd$export$b51dea84d928a378 = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ".mediaSingleView-content-wrap[layout^='wrap-']": {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        zIndex: (0, $faPFq.akEditorWrappedNodeZIndex)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left[data-layout], &.image-wrap-right[data-layout]': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right, .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left, .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-left, .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right + .${$7cd7c98ac6cb3bcd$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$7cd7c98ac6cb3bcd$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("4ZvVm", function(module, exports) {
$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $85a75249275aa44a$export$4ccd31bf665a88f6);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $85a75249275aa44a$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};

});

parcelRegister("lL8Wo", function(module, exports) {
$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $a00e0fcadb33f856$export$a7172b75d403a0e4);
// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $a00e0fcadb33f856$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    //NOTE: value is a selector (data attribute), not a class name
    TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
    TASK_ITEM: 'task-item',
    TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap'
};

});

parcelRegister("cYNsM", function(module, exports) {
$parcel$export(module.exports, "LightWeightCodeBlockCssClassName", () => $d603622346a5f3ef$export$afbde0e7339bed51);
$parcel$export(module.exports, "default", () => $d603622346a5f3ef$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $faPFq = parcelRequire("faPFq");
var $bngWB = parcelRequire("bngWB");

var $4LRBs = parcelRequire("4LRBs");

var $3pGpm = parcelRequire("3pGpm");

var $jANeU = parcelRequire("jANeU");
const $d603622346a5f3ef$var$codeBlockSharedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED}
		> .${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        marginRight: "var(--ds-space-100, 8px)",
        code: {
            display: 'block',
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap'
        }
    },
    [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}
		> .${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
        display: 'flex',
        flex: 1,
        code: {
            flexGrow: 1,
            whiteSpace: 'pre'
        }
    },
    [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        position: 'relative',
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        margin: `${(0, $faPFq.blockNodesVerticalMargin)} 0 0 0`,
        fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
        minWidth: `${(0, $faPFq.akEditorTableCellMinWidth)}px`,
        cursor: 'pointer',
        clear: 'both',
        '--ds--code--bg-color': 'transparent',
        '.code-block-gutter-pseudo-element::before': {
            content: '"attr(data-label)"'
        },
        /* This is necessary to allow for arrow key navigation in/out of code blocks in Firefox. */ whiteSpace: 'normal',
        [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_START}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            top: '0px',
            left: '0px'
        },
        [`${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_END}`]: {
            position: 'absolute',
            visibility: 'hidden',
            height: '1.5rem',
            bottom: '0px',
            right: '0px'
        },
        [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER}`]: {
            position: 'relative',
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            display: 'flex',
            borderRadius: "var(--ds-radius-small, 3px)",
            width: '100%',
            counterReset: 'line',
            overflowX: 'auto',
            backgroundImage: 'var(--ak-renderer-codeblock-content-wrapper-bg-img)',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'local, local, local, local, scroll, scroll, scroll, scroll',
            backgroundSize: `${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-300, 24px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%,
				${"var(--ds-space-100, 8px)"} 100%,
				1px 100%`,
            backgroundPosition: `0 0,
				0 0,
				100% 0,
				100% 0,
				100% 0,
				100% 0,
				0 0,
				0 0`,
            /* Be careful if refactoring this; it is needed to keep arrow key navigation in Firefox consistent with other browsers. */ overflowY: 'hidden'
        },
        [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}`]: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            position: 'relative',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            padding: "var(--ds-space-100, 8px)",
            flexShrink: 0,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            boxSizing: 'content-box'
        },
        // This is a fix of marker of list item with code block.
        // The list item marker in Chrome is aligned by the baseline of the text,
        // that's why we need to add a text (content: "1") to the line number gutter to align
        // the list item marker with the text.
        // Without it, the list item marker will be aligned by the bottom of the code block.
        [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER}::before`]: {
            content: '"1"',
            visibility: 'hidden',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem'
        },
        [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT}`]: {
            code: {
                tabSize: 4,
                cursor: 'text',
                color: "var(--ds-text, #292A2E)",
                borderRadius: "var(--ds-radius-small, 3px)",
                margin: "var(--ds-space-100, 8px)",
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                fontSize: `${0.875}rem`,
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                lineHeight: '1.5rem'
            }
        },
        [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET}`]: {
            pointerEvents: 'none',
            userSelect: 'none',
            width: 'var(--lineNumberGutterWidth, 2rem)',
            left: 0,
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            fontSize: `${0.875}rem`,
            padding: `0px ${"var(--ds-space-100, 8px)"}`,
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            lineHeight: '1.5rem',
            textAlign: 'right',
            color: "var(--ds-text-subtlest, #6B6E76)",
            boxSizing: 'content-box'
        }
    }
});
const $d603622346a5f3ef$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    [`.${(0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`]: {
        cursor: 'text'
    }
});
const $d603622346a5f3ef$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $d603622346a5f3ef$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $lqVX7.css)(".", (0, $jANeU.RendererCssClassName).DOCUMENT, ">.", $d603622346a5f3ef$export$afbde0e7339bed51.CONTAINER, " .", (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $faPFq.blockNodesVerticalMargin), ";}");
};
const $d603622346a5f3ef$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, hideLineNumbers: hideLineNumbers = false, className: className }, ref)=>{
    const textRows = (0, $4fqPo.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $3pGpm.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $d603622346a5f3ef$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    const codeBlockBackgroundImage = (0, $bngWB.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            $d603622346a5f3ef$var$codeBlockSharedStyles,
            $d603622346a5f3ef$var$lightWeightCodeBlockStyles
        ],
        style: {
            '--ak-renderer-codeblock-content-wrapper-bg-img': codeBlockBackgroundImage
        }
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        className: (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, !hideLineNumbers && /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $lqVX7.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        className: (0, $4LRBs.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("code", null, renderBidiWarnings(text))))));
});
var $d603622346a5f3ef$export$2e2bcd8739ae039 = $d603622346a5f3ef$var$LightWeightCodeBlock;

});
parcelRegister("3pGpm", function(module, exports) {
$parcel$export(module.exports, "useBidiWarnings", () => $801ed67874116e90$export$9fb9fe546a188c7b);

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $adj0g = parcelRequire("adj0g");

var $8e3AL = parcelRequire("8e3AL");

var $ckfNZ = parcelRequire("ckfNZ");

var $4mqcS = parcelRequire("4mqcS");
const $801ed67874116e90$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $4MCQn.default)();
    const warningLabel = intl.formatMessage((0, $8e3AL.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        if ((0, $4mqcS.expValEquals)('platform_editor_remove_bidi_char_warning', 'isEnabled', true)) return text;
        return (0, $ckfNZ.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $adj0g.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


parcelRegister("cb7zl", function(module, exports) {
$parcel$export(module.exports, "default", () => $f082d770f4285e7f$export$2e2bcd8739ae039);

var $3H4LK = parcelRequire("3H4LK");

var $jClH4 = parcelRequire("jClH4");
function $f082d770f4285e7f$var$editorUGCToken(path) {
    let tokens;
    if ((0, $3H4LK.fg)('platform_editor_typography_ugc')) tokens = (0, $jClH4.editorUGCTokensRefreshed);
    else tokens = (0, $jClH4.editorUGCTokens);
    return tokens[path];
}
var $f082d770f4285e7f$export$2e2bcd8739ae039 = $f082d770f4285e7f$var$editorUGCToken;

});
parcelRegister("jClH4", function(module, exports) {
$parcel$export(module.exports, "editorUGCTokens", () => $3e4f50961ab5de8f$export$4a3637dc6e2ae29e);
$parcel$export(module.exports, "editorUGCTokensRefreshed", () => $3e4f50961ab5de8f$export$63adc0ebe3278d31);
const $3e4f50961ab5de8f$export$4a3637dc6e2ae29e = {
    'editor.font.heading.h1': 'normal 500 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 500 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 700 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $3e4f50961ab5de8f$export$95588e746468319e = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600  1em/1.14286 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600  0.857143em/1.33333 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};
const $3e4f50961ab5de8f$export$63adc0ebe3278d31 = {
    'editor.font.heading.h1': 'normal 600 1.71429em/1.16667 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h2': 'normal 600 1.42857em/1.2 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h3': 'normal 600 1.14286em/1.25 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h4': 'normal 600 1em/1.14286 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h5': 'normal 600 0.857143em/1.33333 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.heading.h6': 'normal 600 0.785714em/1.45455 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body': 'normal 400 1em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.body.small': 'normal 400 0.875em/1.714 "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
    'editor.font.weight.heading.h1.bold': '700',
    'editor.font.weight.heading.h2.bold': '700',
    'editor.font.weight.heading.h3.bold': '700',
    'editor.font.weight.heading.h4.bold': '700',
    'editor.font.weight.heading.h5.bold': '700',
    'editor.font.weight.heading.h6.bold': '700'
};

});


parcelRegister("8jG2i", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $7feff383e0678914$export$8e2864079bc476bd);

var $faPFq = parcelRequire("faPFq");

var $4mqcS = parcelRequire("4mqcS");
const $7feff383e0678914$export$8e2864079bc476bd = (appearance, contentMode)=>{
    if ((0, $4mqcS.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $4mqcS.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test')) {
        if (contentMode === 'compact') return 0, $faPFq.akEditorFullPageDenseFontSize;
    }
    return appearance && appearance !== 'comment' ? (0, $faPFq.akEditorFullPageDefaultFontSize) : 14;
};

});

parcelRegister("9jkQC", function(module, exports) {
$parcel$export(module.exports, "EmojiSharedCssClassName", () => $ce29f4dd902b3923$export$ee47248f9a998789);

var $ep2Ks = parcelRequire("ep2Ks");
const $ce29f4dd902b3923$export$ee47248f9a998789 = {
    EMOJI_CONTAINER: 'emojiView-content-wrap',
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_NODE: (0, $ep2Ks.emojiNodeStyles),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_SPRITE: (0, $ep2Ks.emojiSprite),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_IMAGE: (0, $ep2Ks.emojiImage),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    EMOJI_PLACEHOLDER: (0, $ep2Ks.placeholder)
};

});
parcelRegister("ep2Ks", function(module, exports) {
$parcel$export(module.exports, "commonSelectedStyles", () => $bd56a85a46dfec11$export$8633a0edef8e95dd);
$parcel$export(module.exports, "selectOnHoverStyles", () => $bd56a85a46dfec11$export$860109dfd198259b);
$parcel$export(module.exports, "emojiSprite", () => $bd56a85a46dfec11$export$1c10634420a08d8a);
$parcel$export(module.exports, "emojiNodeStyles", () => $bd56a85a46dfec11$export$b06c4aab1d012063);
$parcel$export(module.exports, "emojiImage", () => $bd56a85a46dfec11$export$da61cef1c8919f7c);
$parcel$export(module.exports, "emojiDeleteButton", () => $bd56a85a46dfec11$export$b11fa39b56a371f6);
$parcel$export(module.exports, "emojiMainStyle", () => $bd56a85a46dfec11$export$11462c0756c24ab6);
$parcel$export(module.exports, "deletableEmoji", () => $bd56a85a46dfec11$export$22b19c311e9caa4);
$parcel$export(module.exports, "placeholder", () => $bd56a85a46dfec11$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "emojiPickerAddEmoji", () => $bd56a85a46dfec11$export$b0fe756d87022806);
const $bd56a85a46dfec11$export$8633a0edef8e95dd = 'emoji-common-selected';
const $bd56a85a46dfec11$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $bd56a85a46dfec11$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $bd56a85a46dfec11$export$b06c4aab1d012063 = 'emoji-common-node';
const $bd56a85a46dfec11$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $bd56a85a46dfec11$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $bd56a85a46dfec11$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $bd56a85a46dfec11$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $bd56a85a46dfec11$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $bd56a85a46dfec11$export$b0fe756d87022806 = 'emoji-picker-add-emoji';

});


parcelRegister("6uG5y", function(module, exports) {
$parcel$export(module.exports, "SyncBlockSharedCssClassName", () => $5626b4f93a2803a7$export$84840734cffb342f);
$parcel$export(module.exports, "SyncBlockRendererDataAttributeName", () => $5626b4f93a2803a7$export$8c57d8325d08218b);
$parcel$export(module.exports, "BodiedSyncBlockSharedCssClassName", () => $5626b4f93a2803a7$export$628f41eb22ec9a2);
$parcel$export(module.exports, "SyncBlockLabelSharedCssClassName", () => $5626b4f93a2803a7$export$f75b6075afbd73af);
$parcel$export(module.exports, "SyncBlockStateCssClassName", () => $5626b4f93a2803a7$export$9b10dd4c500e3ce8);
const $5626b4f93a2803a7$var$prefix = 'ak-editor-sync-block';
const $5626b4f93a2803a7$export$84840734cffb342f = {
    prefix: $5626b4f93a2803a7$var$prefix,
    renderer: `${$5626b4f93a2803a7$var$prefix}__renderer`,
    error: `${$5626b4f93a2803a7$var$prefix}__error_state`,
    loading: `${$5626b4f93a2803a7$var$prefix}__loading_state`
};
const $5626b4f93a2803a7$export$8c57d8325d08218b = 'data-sync-block-renderer';
const $5626b4f93a2803a7$var$bodiedPrefix = 'ak-editor-bodied-sync-block';
const $5626b4f93a2803a7$export$628f41eb22ec9a2 = {
    prefix: $5626b4f93a2803a7$var$bodiedPrefix,
    renderer: `${$5626b4f93a2803a7$var$bodiedPrefix}__renderer`,
    content: `${$5626b4f93a2803a7$var$bodiedPrefix}__content`,
    selectionInside: `${$5626b4f93a2803a7$var$bodiedPrefix}__selection_inside`
};
// Constant labelClassName value here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
const $5626b4f93a2803a7$var$labelClassName = 'ak-editor-sync-block__label';
const $5626b4f93a2803a7$export$f75b6075afbd73af = {
    labelClassName: $5626b4f93a2803a7$var$labelClassName
};
const $5626b4f93a2803a7$export$7e44804769d54f36 = 'disabled';
const $5626b4f93a2803a7$export$da351099a95c41a2 = 'view-mode';
const $5626b4f93a2803a7$export$ddb90512ea536019 = 'creation-loading';
const $5626b4f93a2803a7$export$52ab9fe57e8e4c2e = 'user-is-dragging';
const $5626b4f93a2803a7$export$9b10dd4c500e3ce8 = {
    disabledClassName: $5626b4f93a2803a7$export$7e44804769d54f36,
    viewModeClassName: $5626b4f93a2803a7$export$da351099a95c41a2,
    creationLoadingClassName: $5626b4f93a2803a7$export$ddb90512ea536019,
    draggingClassName: $5626b4f93a2803a7$export$52ab9fe57e8e4c2e
};

});


parcelRegister("6zDDB", function(module, exports) {
$parcel$export(module.exports, "removeEmptySpaceAroundContent", () => $8e82dc434015d740$export$c94cfc0c675062a1);
const $8e82dc434015d740$export$c94cfc0c675062a1 = (document)=>{
    // Check if the document is valid
    if (!document || !document.content || !Array.isArray(document.content)) return document;
    // Check if the node is a meaningful content node meaning it is not an empty paragraph or a paragraph with only whitespace
    const isMeaningfulContentNode = (node)=>{
        // Check if the node is a non-empty paragraph or a non-paragraph node
        if (node.type !== 'paragraph') return true;
        // If the paragraph is empty, return false
        if (!node.content || node.content.length === 0) return false;
        // Check if paragraph has any content other than `hardBreak` or whitespace text nodes
        return node.content.some((child)=>{
            return !((child === null || child === void 0 ? void 0 : child.type) === 'hardBreak' || (child === null || child === void 0 ? void 0 : child.type) === 'text' && typeof child.text === 'string' && child.text.trim() === '');
        });
    };
    const content = document.content;
    let firstContentIndex = -1;
    let lastContentIndex = -1;
    // Find the first and last paragraphs with content and check if they are meaningful
    for(let i = 0; i < content.length; i++)if (isMeaningfulContentNode(content[i])) {
        if (firstContentIndex === -1) firstContentIndex = i;
        lastContentIndex = i;
    }
    // If no content was found, return an empty document
    if (firstContentIndex === -1) return {
        ...document,
        content: []
    };
    // Slice the content array to include only paragraphs between the first and last content
    const trimmedContent = content.slice(firstContentIndex, lastContentIndex + 1);
    // Return a new document with the trimmed content
    return {
        ...document,
        content: trimmedContent
    };
};

});

parcelRegister("crjVg", function(module, exports) {
$parcel$export(module.exports, "useMemoFromPropsDerivative", () => $328024432aa1a3ee$export$80ffe7e3c6bf25c3);
/* eslint-disable jsdoc/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");
function $328024432aa1a3ee$export$80ffe7e3c6bf25c3(factory, propsDerivator, props) {
    // cache the last set of props
    const prev = (0, $4fqPo.useRef)(props);
    const prevFactory = (0, $4fqPo.useRef)(null);
    return (0, $4fqPo.useMemo)(()=>{
        // check if the serializer is already created
        let shouldCreate = !prevFactory.current;
        // check each prop to see if value has changed and also check if the number of props has changed
        if (prev.current !== props) {
            const propsEntries = Object.entries(props);
            shouldCreate = propsEntries.length !== Object.keys(prev.current).length || propsEntries.some(([key, prop])=>prev.current[key] !== prop);
        }
        prev.current = props;
        // If first time or any prop value has changed, create a new serializer
        if (shouldCreate) prevFactory.current = factory(propsDerivator(props));
        return prevFactory.current;
    }, // To keep deps consistent, here disable the exhaustive-deps rule to drop factory from the deps array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        propsDerivator,
        props
    ]);
}

});

parcelRegister("fKAdP", function(module, exports) {
$parcel$export(module.exports, "PortalContext", () => $cd1a2ee5f78ef9b1$export$60d741e20e0aa309);
$parcel$export(module.exports, "usePortal", () => $cd1a2ee5f78ef9b1$export$b1072f43c67b540c);
/* eslint-disable jsdoc/require-jsdoc -- thin portal context helpers */ 
var $4fqPo = parcelRequire("4fqPo");
const $cd1a2ee5f78ef9b1$export$60d741e20e0aa309 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(undefined);
function $cd1a2ee5f78ef9b1$export$b1072f43c67b540c(props) {
    const portalFromContext = (0, $4fqPo.useContext)($cd1a2ee5f78ef9b1$export$60d741e20e0aa309);
    return (props === null || props === void 0 ? void 0 : props.portal) || portalFromContext;
}

});

parcelRegister("cFHQz", function(module, exports) {
$parcel$export(module.exports, "getWidthInfoPayload", () => $7b1880fa3c0ac893$export$208d2421b73f3f86);
$parcel$export(module.exports, "getHeightInfoPayload", () => $7b1880fa3c0ac893$export$34e5b28c67455a81);

var $f0GG4 = parcelRequire("f0GG4");
var $cmSEj = parcelRequire("cmSEj");
var $8lWjH = parcelRequire("8lWjH");

var $aheLh = parcelRequire("aheLh");
const $7b1880fa3c0ac893$export$208d2421b73f3f86 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableWidth: table.scrollWidth,
                hasScrollbar: tableWrapper.clientWidth < table.scrollWidth,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    const editorWidth = renderer.scrollWidth;
    return {
        action: (0, $8lWjH.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $f0GG4.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $aheLh.getBreakpointKey)(editorWidth),
            tableWidthInfo: tablesInfo,
            maxTableWidthBreakpoint: (0, $aheLh.getBreakpointKey)(maxTableWidth),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            mode: (0, $cmSEj.MODE).RENDERER
        },
        eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
    };
};
const $7b1880fa3c0ac893$export$34e5b28c67455a81 = (renderer)=>{
    const tablesInfo = [];
    const tableWrappers = renderer.querySelectorAll('.pm-table-wrapper');
    // only send the event if there are tables on the page
    if (tableWrappers.length === 0) return undefined;
    tableWrappers.forEach((tableWrapper)=>{
        const table = tableWrapper.querySelector(':scope > table');
        if (table) {
            const isNestedTable = Boolean(table.closest('td, th'));
            tablesInfo.push({
                tableHeight: table.scrollHeight,
                isNestedTable: isNestedTable
            });
        }
    });
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    /** NOTE: Renderer is not scrollable, so this height represents the height of the content */ const rendererClientHeight = renderer.clientHeight;
    const viewportHeight = window.innerHeight;
    if (!viewportHeight) return undefined;
    return {
        action: (0, $8lWjH.TABLE_ACTION).TABLE_RENDERER_HEIGHT_INFO,
        actionSubject: (0, $f0GG4.ACTION_SUBJECT).TABLE,
        attributes: {
            viewportHeight: viewportHeight,
            rendererHeight: rendererClientHeight,
            maxTableHeight: maxTableHeight,
            maxTableToViewportHeightRatio: maxTableHeight / viewportHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $f0GG4.EVENT_TYPE).OPERATIONAL
    };
};

});
parcelRegister("cmSEj", function(module, exports) {
$parcel$export(module.exports, "PLATFORMS", () => $77226ce0e809c4de$export$a8d23193462f2b63);
$parcel$export(module.exports, "MODE", () => $77226ce0e809c4de$export$e48589d9e4824227);
$parcel$export(module.exports, "FULL_WIDTH_MODE", () => $77226ce0e809c4de$export$57453495b81e2dde);
$parcel$export(module.exports, "BROWSER_FREEZE_INTERACTION_TYPE", () => $77226ce0e809c4de$export$60a219cfaef9722);
var $77226ce0e809c4de$export$a8d23193462f2b63 = /*#__PURE__*/ function(PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
    return PLATFORMS;
}({});
var $77226ce0e809c4de$export$e48589d9e4824227 = /*#__PURE__*/ function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
    return MODE;
}({});
var $77226ce0e809c4de$export$57453495b81e2dde = /*#__PURE__*/ function(FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
    return FULL_WIDTH_MODE;
}({});
var $77226ce0e809c4de$export$60a219cfaef9722 = /*#__PURE__*/ function(BROWSER_FREEZE_INTERACTION_TYPE) {
    BROWSER_FREEZE_INTERACTION_TYPE["LOADING"] = "loading";
    BROWSER_FREEZE_INTERACTION_TYPE["TYPING"] = "typing";
    BROWSER_FREEZE_INTERACTION_TYPE["CLICKING"] = "clicking";
    BROWSER_FREEZE_INTERACTION_TYPE["PASTING"] = "pasting";
    return BROWSER_FREEZE_INTERACTION_TYPE;
}({});

});

parcelRegister("8lWjH", function(module, exports) {
$parcel$export(module.exports, "TABLE_ACTION", () => $c89fc02908b3f2f9$export$1627223e090990cf);
$parcel$export(module.exports, "TABLE_OVERFLOW_CHANGE_TRIGGER", () => $c89fc02908b3f2f9$export$e0b2ad636c1c8ab4);
$parcel$export(module.exports, "TABLE_STATUS", () => $c89fc02908b3f2f9$export$90dde066fa32cf2f);
$parcel$export(module.exports, "TABLE_DISPLAY_MODE", () => $c89fc02908b3f2f9$export$a62a68f32aa71693);
$parcel$export(module.exports, "CHANGE_ALIGNMENT_REASON", () => $c89fc02908b3f2f9$export$ba2dfc055a59d951);
var $c89fc02908b3f2f9$export$1627223e090990cf = /*#__PURE__*/ function(TABLE_ACTION) {
    TABLE_ACTION["DELETED"] = "deleted";
    TABLE_ACTION["CLEARED"] = "cleared";
    TABLE_ACTION["COLLAPSED"] = "collapsed";
    TABLE_ACTION["MERGED"] = "merged";
    TABLE_ACTION["SPLIT"] = "split";
    TABLE_ACTION["COLORED"] = "colored";
    TABLE_ACTION["TOGGLED_HEADER_COLUMN"] = "toggledHeaderColumn";
    TABLE_ACTION["TOGGLED_HEADER_ROW"] = "toggledHeaderRow";
    TABLE_ACTION["TOGGLED_NUMBER_COLUMN"] = "toggledNumberColumn";
    TABLE_ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    TABLE_ACTION["CUT"] = "cut";
    TABLE_ACTION["COPIED"] = "copied";
    TABLE_ACTION["ADDED_ROW"] = "addedRow";
    TABLE_ACTION["ADDED_COLUMN"] = "addedColumn";
    TABLE_ACTION["DELETED_ROW"] = "deletedRow";
    TABLE_ACTION["DELETED_COLUMN"] = "deletedColumn";
    TABLE_ACTION["SORTED_COLUMN"] = "sortedColumn";
    TABLE_ACTION["REPLACED"] = "replaced";
    TABLE_ACTION["ATTEMPTED_TABLE_WIDTH_CHANGE"] = "attemptedTableWidthChange";
    TABLE_ACTION["DISTRIBUTED_COLUMNS_WIDTHS"] = "distributedColumnsWidths";
    TABLE_ACTION["FIXED"] = "fixed";
    TABLE_ACTION["RESIZED"] = "resized";
    TABLE_ACTION["RESIZE_PERF_SAMPLING"] = "resizePerfSampling";
    TABLE_ACTION["COLUMN_RESIZED"] = "columnResized";
    TABLE_ACTION["OVERFLOW_CHANGED"] = "overflowChanged";
    TABLE_ACTION["INITIAL_OVERFLOW_CAPTURED"] = "initialOverflowCaptured";
    TABLE_ACTION["MOVED_ROW"] = "movedRow";
    TABLE_ACTION["MOVED_COLUMN"] = "movedColumn";
    TABLE_ACTION["CLONED_ROW"] = "clonedRow";
    TABLE_ACTION["CLONED_COLUMN"] = "clonedColumn";
    TABLE_ACTION["DRAG_MENU_OPENED"] = "dragMenuOpened";
    /**
   * This is a unique action that's used to track legacy table move behaviour flow of insert+copy+paste. Please use
   * the MOVED_ROW | MOVED_COLUMN actions if you want to track events which move row/cols in a single step.
   */ TABLE_ACTION["ROW_OR_COLUMN_MOVED"] = "rowOrColumnMoved";
    TABLE_ACTION["CHANGED_DISPLAY_MODE"] = "changedDisplayMode";
    TABLE_ACTION["CHANGED_ALIGNMENT"] = "changedAlignment";
    // Temporary to track usage of CONFCLOUD-78239 bug
    TABLE_ACTION["TABLE_CELL_BACKGROUND_FIXED"] = "tableCellBackgroundFixed";
    TABLE_ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    TABLE_ACTION["TABLE_EDITOR_HEIGHT_INFO"] = "tableEditorHeightInformation";
    TABLE_ACTION["TABLE_RENDERER_HEIGHT_INFO"] = "tableRendererHeightInformation";
    TABLE_ACTION["STICKY_HEADER_METHOD_TOGGLED"] = "stickyHeaderMethodToggled";
    TABLE_ACTION["FIT_TO_CONTENT_AUTO_CONVERTED"] = "fitToContentAutoConverted";
    TABLE_ACTION["FIT_TO_CONTENT_ON_DEMAND"] = "fitToContentOnDemand";
    return TABLE_ACTION;
}({});
var $c89fc02908b3f2f9$export$6b0804bad09b61c6 = /*#__PURE__*/ function(TABLE_BREAKOUT) {
    TABLE_BREAKOUT["WIDE"] = "wide";
    TABLE_BREAKOUT["FULL_WIDTH"] = "fullWidth";
    TABLE_BREAKOUT["NORMAL"] = "normal";
    return TABLE_BREAKOUT;
}({});
var $c89fc02908b3f2f9$export$e0b2ad636c1c8ab4 = /*#__PURE__*/ function(TABLE_OVERFLOW_CHANGE_TRIGGER) {
    TABLE_OVERFLOW_CHANGE_TRIGGER["EXTERNAL"] = "external";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ADDED_COLUMN"] = "addedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DELETED_COLUMN"] = "deletedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED_COLUMN"] = "resizedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["ENABLED_NUMBERED_COLUMN"] = "enabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISABLED_NUMBERED_COLUMN"] = "disabledNumberedColumn";
    TABLE_OVERFLOW_CHANGE_TRIGGER["DISTRIBUTED_COLUMNS"] = "distributedColumnsWidths";
    TABLE_OVERFLOW_CHANGE_TRIGGER["RESIZED"] = "resizedTable";
    return TABLE_OVERFLOW_CHANGE_TRIGGER;
}({});
var $c89fc02908b3f2f9$export$90dde066fa32cf2f = /*#__PURE__*/ function(TABLE_STATUS) {
    TABLE_STATUS["SUCCESS"] = "success";
    TABLE_STATUS["CANCELLED"] = "cancelled";
    TABLE_STATUS["INVALID"] = "invalid";
    return TABLE_STATUS;
}({});
var $c89fc02908b3f2f9$export$a62a68f32aa71693 = /*#__PURE__*/ function(TABLE_DISPLAY_MODE) {
    TABLE_DISPLAY_MODE["FIXED"] = "fixed";
    TABLE_DISPLAY_MODE["DEFAULT"] = "default";
    TABLE_DISPLAY_MODE["INITIAL"] = "initial";
    return TABLE_DISPLAY_MODE;
}({});
var $c89fc02908b3f2f9$export$ba2dfc055a59d951 = /*#__PURE__*/ function(CHANGE_ALIGNMENT_REASON) {
    CHANGE_ALIGNMENT_REASON["TABLE_RESIZING"] = "tableResizing";
    CHANGE_ALIGNMENT_REASON["TABLE_COLUMN_RESIZED"] = "tableColumnResized";
    CHANGE_ALIGNMENT_REASON["EDITOR_APPEARANCE_CHANGED"] = "editorAppearanceChanged";
    CHANGE_ALIGNMENT_REASON["TOOLBAR_OPTION_CHANGED"] = "toolbarOptionChanged";
    return CHANGE_ALIGNMENT_REASON;
}({});

});



parcelRegister("g4aMt", function(module, exports) {
$parcel$export(module.exports, "ButtonStyle", () => $b46e68e143091018$export$bdc3c19374266b98);
$parcel$export(module.exports, "CornerStyle", () => $b46e68e143091018$export$a6e645fda5339bf8);
$parcel$export(module.exports, "Height", () => $b46e68e143091018$export$8954cfac7c08d16a);
$parcel$export(module.exports, "Alignment", () => $b46e68e143091018$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "Orientation", () => $b46e68e143091018$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "CardLayout", () => $b46e68e143091018$export$21e76ed09a093e97);
$parcel$export(module.exports, "CommonLayout", () => $b46e68e143091018$export$42809f9f1496f50d);
$parcel$export(module.exports, "FeedbackType", () => $b46e68e143091018$export$d4c0482bf980ef26);
$parcel$export(module.exports, "ExtensionMode", () => $b46e68e143091018$export$533ae1c1b7b7ac6);
$parcel$export(module.exports, "RenderVariant", () => $b46e68e143091018$export$1f60141b6ce5efed);
$parcel$export(module.exports, "SegmentationTargets", () => $b46e68e143091018$export$f6cd408cac7f930c);
$parcel$export(module.exports, "ITEM_FIELDS", () => $b46e68e143091018$export$bf7ebf7fed6e7189);
var $b46e68e143091018$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $b46e68e143091018$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $b46e68e143091018$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $b46e68e143091018$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $b46e68e143091018$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $b46e68e143091018$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $b46e68e143091018$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $b46e68e143091018$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $b46e68e143091018$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $b46e68e143091018$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $b46e68e143091018$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $b46e68e143091018$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $b46e68e143091018$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});

});

parcelRegister("gVPbZ", function(module, exports) {
$parcel$export(module.exports, "HubRendererWrapper", () => $24f5adf6f59f66bc$export$1a063b7cda785385);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ /* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $24f5adf6f59f66bc$export$1a063b7cda785385 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $4fqPo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_1p9midpf _1awjidpf _1o1jckbl _1bweckbl _tnsdidpf _127midpf _128sckbl _s8ydckbl _utchidpf _ovodidpf _rtpd1uiu _1c211uiu _qndeidpf _1k6kidpf _tjcw1uiu _mctt1uiu _1cw71ihj _yqhm1ihj _1a031ssb _1fd01ssb _x0t7zr6s _ato1zr6s _14cj147o _13rb147o _1gygjo1l _78a5jo1l _1iimidpf _bq9jidpf _kf5midpf _e5isidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ia1kt", function(module, exports) {
$parcel$export(module.exports, "getSectionExtensionContents", () => $84b0599e19e98f52$export$993dca3597b448e8);

var $k7Ytj = parcelRequire("k7Ytj");
const $84b0599e19e98f52$export$993dca3597b448e8 = ({ header: header, subHeader: subHeader, placeholderTitle: placeholderTitle })=>[
        {
            type: 'extensionFrame',
            content: [
                {
                    type: 'heading',
                    attrs: {
                        level: 1,
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${header}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    },
                    content: [
                        {
                            type: 'text',
                            text: `${subHeader}`
                        }
                    ]
                },
                {
                    type: 'paragraph',
                    attrs: {
                        localId: null
                    }
                },
                {
                    type: 'extension',
                    attrs: {
                        extensionKey: (0, $k7Ytj.HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY),
                        extensionType: (0, $k7Ytj.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
                        parameters: {
                            extensionTitle: placeholderTitle
                        },
                        text: null,
                        layout: 'default',
                        localId: null
                    }
                }
            ]
        }
    ];

});
parcelRegister("k7Ytj", function(module, exports) {
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE", () => $a2ef1b09efccbe79$export$c14e692c91462ed4);
$parcel$export(module.exports, "HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY", () => $a2ef1b09efccbe79$export$ca3a94184e0fbd97);
const $a2ef1b09efccbe79$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $a2ef1b09efccbe79$export$ca3a94184e0fbd97 = 'hub-element-placeholder';

});


parcelRegister("7BAwD", function(module, exports) {
$parcel$export(module.exports, "sectionExtensionProvider", () => $bcd8bc5ac9d7a041$export$6775abcfdb3b0453);

var $4fqPo = parcelRequire("4fqPo");

var $jk6Pl = parcelRequire("jk6Pl");

var $dGKOA = parcelRequire("dGKOA");

var $cijxS = parcelRequire("cijxS");

var $8NPTZ = parcelRequire("8NPTZ");
var $Bq10O = parcelRequire("Bq10O");

var $bEMQI = parcelRequire("bEMQI");

var $l6AcS = parcelRequire("l6AcS");

const $bcd8bc5ac9d7a041$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: async ()=>(await (parcelRequire("fLSMz"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "section-extension-loader"
        })
});
const $bcd8bc5ac9d7a041$var$sectionParameters = (intl, defaultBackgroundColor)=>({
        extensionTitle: intl.formatMessage((0, $l6AcS.messages).lozengeTitle),
        backgroundColor: defaultBackgroundColor,
        contentWidth: (0, $bEMQI.DEFAULT_CONTENT_WIDTH)
    });

const $bcd8bc5ac9d7a041$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider, defaultParameters: defaultParameters })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $l6AcS.messages).title);
        const description = intl.formatMessage((0, $l6AcS.messages).description);
        // Only honour the v2 seed when advanced theming is on. Falls back to the
        // legacy `DEFAULT_BACKGROUND_COLOR` for Confluence/CSM/gate-OFF help-center.
        const defaultBackgroundColor = defaultParameters !== null && defaultParameters !== void 0 && defaultParameters.isAdvancedThemingEnabled && defaultParameters.backgroundColor ? defaultParameters.backgroundColor : (0, $bEMQI.DEFAULT_BACKGROUND_COLOR);
        const parameters = $bcd8bc5ac9d7a041$var$sectionParameters(intl, defaultBackgroundColor);
        const type = (0, $Bq10O.SECTION_EXTENSION_TYPE);
        const key = (0, $bEMQI.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $l6AcS.messages).contentHeader),
            subHeader: intl.formatMessage((0, $l6AcS.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $l6AcS.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>(parcelRequire("hDitt")).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            var _editorActions$getSel, _selectedNode$attrs;
            const selectedNode = editorActions === null || editorActions === void 0 || (_editorActions$getSel = editorActions.getSelectedNode()) === null || _editorActions$getSel === void 0 ? void 0 : _editorActions$getSel.toJSON();
            const selectedLocalId = selectedNode === null || selectedNode === void 0 || (_selectedNode$attrs = selectedNode.attrs) === null || _selectedNode$attrs === void 0 ? void 0 : _selectedNode$attrs.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($bcd8bc5ac9d7a041$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $dGKOA.default)([
            (0, $8NPTZ.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };

});
parcelRegister("dGKOA", function(module, exports) {
$parcel$export(module.exports, "default", () => $405e3c00f53a156b$export$2e2bcd8739ae039);

var $dSbtw = parcelRequire("dSbtw");
class $405e3c00f53a156b$export$2e2bcd8739ae039 {
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsCache = [];
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            var _manifest$modules;
            const nodes = manifest === null || manifest === void 0 || (_manifest$modules = manifest.modules) === null || _manifest$modules === void 0 ? void 0 : _manifest$modules.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                var _preloadRender, _ref;
                preloadCalls.push(node === null || node === void 0 || (_preloadRender = (_ref = node).preloadRender) === null || _preloadRender === void 0 ? void 0 : _preloadRender.call(_ref));
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $dSbtw.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
}

});
parcelRegister("dSbtw", function(module, exports) {
$parcel$export(module.exports, "getAutoConvertPatternsFromModule", () => $6c816f821d3feb01$export$60407594ea5edd1c);
async function $6c816f821d3feb01$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}

});


parcelRegister("8NPTZ", function(module, exports) {
$parcel$export(module.exports, "getExtensionManifest", () => $56be42053d086fd0$export$573ee875a39e7e73);
const $56be42053d086fd0$export$573ee875a39e7e73 = ({ key: key, icons: icons, parameters: parameters, update: update, render: render, title: title, type: type, description: description, source: source, nodeType: nodeType = 'extension', quickInsertAction: quickInsertAction, setUpsellModalSource: setUpsellModalSource, additionalModuleNodeProps: additionalModuleNodeProps })=>{
    return {
        title: title,
        type: type,
        key: key,
        description: description,
        icons: icons,
        modules: {
            quickInsert: setUpsellModalSource ? [
                {
                    key: 'quick-insert',
                    action: async ()=>setUpsellModalSource(source)
                }
            ] : [
                {
                    key: 'quick-insert',
                    action: quickInsertAction || {
                        type: 'node',
                        key: 'default',
                        parameters: parameters
                    }
                }
            ],
            nodes: {
                default: {
                    type: nodeType,
                    render: render,
                    update: update,
                    ...additionalModuleNodeProps
                }
            }
        }
    };
};

});

parcelRegister("bEMQI", function(module, exports) {
$parcel$export(module.exports, "SECTION_EXTENSION_KEY", () => $a2641d984a9030ae$export$bc69bf23ec1f99d5);
$parcel$export(module.exports, "SECTION_EXTENSION_ANALYTICS_SOURCE", () => $a2641d984a9030ae$export$7a75cc6a69e05549);
$parcel$export(module.exports, "CONTENT_WIDTH", () => $a2641d984a9030ae$export$3130b484681bf8bc);
$parcel$export(module.exports, "DEFAULT_CONTENT_WIDTH", () => $a2641d984a9030ae$export$6cccba5fae1d609d);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $a2641d984a9030ae$export$617cdcc6afaae4f7);
const $a2641d984a9030ae$export$bc69bf23ec1f99d5 = 'hub-section';
const $a2641d984a9030ae$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $a2641d984a9030ae$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $a2641d984a9030ae$export$6cccba5fae1d609d = "wide";
const $a2641d984a9030ae$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";

});

parcelRegister("l6AcS", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a683260677bd82da$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $a683260677bd82da$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    title: {
        id: 'company-hub.section-extension.manifest.extension-title',
        defaultMessage: 'Section',
        description: 'Title of section extension to be displayed in shortcut macros dropdown.'
    },
    lozengeTitle: {
        id: 'company-hub.section-extension.manifest.extension-lozenge-title',
        defaultMessage: 'Section',
        description: 'Title of section extension to be displayed in lozenge'
    },
    description: {
        id: 'company-hub.section-extension.manifest.macro-description',
        defaultMessage: 'Group elements together with a background',
        description: 'Description of section extension to be displayed in toolbar/shortcut macros dropdown'
    },
    contentHeader: {
        id: 'company-hub.section-extension.manifest.content.header',
        defaultMessage: 'Give your section a title',
        description: "Header of section extension's initial content"
    },
    contentSubHeader: {
        id: 'company-hub.section-extension.manifest.content.sub-header',
        defaultMessage: 'Organize elements into sections with customizable backgrounds.',
        description: "Sub-header of section extension's initial content"
    },
    placeHolderTitle: {
        id: 'company-hub.section-extension.manifest.content.placeholder-title',
        defaultMessage: 'Placeholder',
        description: 'Title of hub element placeholder extension to be displayed the macro is presented in the editor.'
    }
});

});

parcelRegister("fLSMz", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lpED7").then(()=>parcelRequire('iG6Fo'));

});

parcelRegister("hDitt", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("3wZPd").then(()=>parcelRequire('85Lig'));

});


parcelRegister("gXYVI", function(module, exports) {
$parcel$export(module.exports, "useHubExtensionHandlers", () => $82d7265abe702b5f$export$617d11c0fd386821);

var $4fqPo = parcelRequire("4fqPo");

var $jk6Pl = parcelRequire("jk6Pl");

var $cijxS = parcelRequire("cijxS");

var $8uRxU = parcelRequire("8uRxU");

var $3W1a5 = parcelRequire("3W1a5");

var $g4aMt = parcelRequire("g4aMt");
var $Bq10O = parcelRequire("Bq10O");

var $2MjIC = parcelRequire("2MjIC");

const $82d7265abe702b5f$var$SpotlightExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: async ()=>(await (parcelRequire("7wYpy"))).SpotlightExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "spotlight-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null))
});

const $82d7265abe702b5f$var$LinksMenuLoader = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: async ()=>(await (parcelRequire("95Yl9"))).LinksMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "links-menu-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null))
});

const $82d7265abe702b5f$export$b55cedbe49066c7 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: async ()=>(await (parcelRequire("gzGWP"))).CardsExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "cards-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null))
});

const $82d7265abe702b5f$var$CarouselLoader = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: async ()=>(await (parcelRequire("dT6Jh"))).Carousel,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "carousel-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null))
});

const $82d7265abe702b5f$var$SectionExtensionLoader = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: async ()=>(await (parcelRequire("7O3l1"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cijxS.default), {
            name: "section-extension-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null))
});
const $82d7265abe702b5f$export$617d11c0fd386821 = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider } = props;
    const extensionHandlers = {
        [(0, $Bq10O.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null),
        [(0, $2MjIC.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null),
        [(0, $8uRxU.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null),
        [(0, $3W1a5.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null),
        [(0, $Bq10O.SECTION_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null)
    };
    const defaultExtensionHandlerProps = (0, $4fqPo.useMemo)(()=>({
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $g4aMt.ExtensionMode).RENDERER
        }), [
        contentId,
        PropsProvider
    ]);
    const spotlightExtension = (0, $4fqPo.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($82d7265abe702b5f$var$SpotlightExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const linksMenuExtension = (0, $4fqPo.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($82d7265abe702b5f$var$LinksMenuLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const cardsExtension = (0, $4fqPo.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($82d7265abe702b5f$export$b55cedbe49066c7, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const carouselExtension = (0, $4fqPo.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($82d7265abe702b5f$var$CarouselLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    const sectionExtension = (0, $4fqPo.useCallback)((extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($82d7265abe702b5f$var$SectionExtensionLoader, {
            ...defaultExtensionHandlerProps,
            extensionNode: extension
        }), [
        defaultExtensionHandlerProps
    ]);
    if (contentId) {
        extensionHandlers[0, $Bq10O.SPOTLIGHT_EXTENSION_TYPE] = spotlightExtension;
        extensionHandlers[0, $2MjIC.LINKS_MENU_EXTENSION_TYPE] = linksMenuExtension;
        extensionHandlers[0, $8uRxU.CARDS_EXTENSION_TYPE] = cardsExtension;
        extensionHandlers[0, $3W1a5.carouselExtensionType] = carouselExtension;
        extensionHandlers[0, $Bq10O.SECTION_EXTENSION_TYPE] = sectionExtension;
    }
    return extensionHandlers;
};

});
parcelRegister("8uRxU", function(module, exports) {
$parcel$export(module.exports, "CARDS_EXTENSION_TYPE", () => $30fab198c1f154d4$export$81e5b59a1e176638);
$parcel$export(module.exports, "CARDS_EXTENSION_KEY", () => $30fab198c1f154d4$export$8a4891a61ff91b00);
$parcel$export(module.exports, "CARDS_EXTENSION_ANALYTIC_SOURCE", () => $30fab198c1f154d4$export$67bfcae6d68bb0bf);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $30fab198c1f154d4$export$7f17fab0aecb44ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE", () => $30fab198c1f154d4$export$6a35a50674becbae);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE", () => $30fab198c1f154d4$export$9bf56665bf6ea6ed);
$parcel$export(module.exports, "CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE", () => $30fab198c1f154d4$export$cf23b6d2fd159502);
$parcel$export(module.exports, "CARDS_EXTENSION_VERSION_5", () => $30fab198c1f154d4$export$b84f9a7c097c895c);
$parcel$export(module.exports, "CARDS_IMAGES_V5", () => $30fab198c1f154d4$export$5e905747d7497a1f);
const $30fab198c1f154d4$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $30fab198c1f154d4$export$8a4891a61ff91b00 = 'cards';
const $30fab198c1f154d4$export$67bfcae6d68bb0bf = 'cardsExtension';
const $30fab198c1f154d4$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $30fab198c1f154d4$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $30fab198c1f154d4$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $30fab198c1f154d4$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $30fab198c1f154d4$export$131b76b4d30d2b44 = '2';
const $30fab198c1f154d4$export$a08b7507bedba276 = '3';
const $30fab198c1f154d4$export$c87753a8bb0c4e75 = '4';
const $30fab198c1f154d4$export$b84f9a7c097c895c = '5';
const $30fab198c1f154d4$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];

});

parcelRegister("3W1a5", function(module, exports) {
$parcel$export(module.exports, "carouselExtensionType", () => $13d9ef8529676216$export$a06ac4f1777262dc);
$parcel$export(module.exports, "carouselExtensionKey", () => $13d9ef8529676216$export$6c8179fa243b4399);
$parcel$export(module.exports, "carouselContentAnalyticSource", () => $13d9ef8529676216$export$ca14f22a239c4ae9);
$parcel$export(module.exports, "carouselConfigAnalyticSource", () => $13d9ef8529676216$export$4cb671946a80c52e);
$parcel$export(module.exports, "AUTOPLAY_SECONDS", () => $13d9ef8529676216$export$93995a2609cff38d);
$parcel$export(module.exports, "ARIA_CONTROLS_PREFIX", () => $13d9ef8529676216$export$3a86d0fc7eb402f4);
$parcel$export(module.exports, "CAROUSEL_VERSION_2", () => $13d9ef8529676216$export$b429752dfe934bea);
$parcel$export(module.exports, "FRAMES_LIMIT_V2", () => $13d9ef8529676216$export$c5c6e75ceae0cc22);
const $13d9ef8529676216$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $13d9ef8529676216$export$6c8179fa243b4399 = 'carousel';
const $13d9ef8529676216$export$ca14f22a239c4ae9 = 'carouselExtension';
const $13d9ef8529676216$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $13d9ef8529676216$export$93995a2609cff38d = 8;
const $13d9ef8529676216$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $13d9ef8529676216$export$9575b4f5d97a1c29 = '1';
const $13d9ef8529676216$export$b429752dfe934bea = '2';
const $13d9ef8529676216$export$c5c6e75ceae0cc22 = 10;

});

parcelRegister("2MjIC", function(module, exports) {
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_TYPE", () => $d4ae048bdd41eef0$export$9fdf64a495514b4);
$parcel$export(module.exports, "LINKS_MENU_EXTENSION_ANALYTIC_SOURCE", () => $d4ae048bdd41eef0$export$ed5854f17099adbf);
const $d4ae048bdd41eef0$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $d4ae048bdd41eef0$export$ed5854f17099adbf = 'linksMenuExtension';

});

parcelRegister("7wYpy", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("66iV5"),
    $e46AW("puvop"),
    $e46AW("3hhaI"),
    $e46AW("eVHN0"),
    $e46AW("knZyM"),
    $e46AW("c03n5"),
    $e46AW("4xkV0"),
    $e46AW("eUxjk"),
    $e46AW("ADlEP"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("cotMj"),
    $e46AW("4YETx"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("488RH"),
    $e46AW("5WiAu"),
    $e46AW("dA0JF"),
    $e46AW("bvhV0"),
    $e46AW("7LczY"),
    $e46AW("cOm2H"),
    $e46AW("ciaTj"),
    $e46AW("fG06h"),
    $e46AW("iR9Ij")
]).then(()=>parcelRequire('ca4Y6'));

});

parcelRegister("95Yl9", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("drbax"),
    $e46AW("puvop"),
    $e46AW("3hhaI"),
    $e46AW("knZyM"),
    $e46AW("kuUxY"),
    $e46AW("eUxjk"),
    $e46AW("ADlEP"),
    $e46AW("1916M"),
    $e46AW("dO151"),
    $e46AW("lu7xz"),
    $e46AW("gYlY0"),
    $e46AW("4gfqv"),
    $e46AW("6BKvM"),
    $e46AW("aHrLh"),
    $e46AW("lH74q"),
    $e46AW("l36Ou"),
    $e46AW("42PCd"),
    $e46AW("jEsv4"),
    $e46AW("488RH"),
    $e46AW("cyycD"),
    $e46AW("4BQhG"),
    $e46AW("bXVvO"),
    $e46AW("do8NJ"),
    $e46AW("5WiAu"),
    $e46AW("eVQYl")
]).then(()=>parcelRequire('iTx3s'));

});

parcelRegister("gzGWP", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("dDxCA"),
    $e46AW("2oDys"),
    $e46AW("66iV5"),
    $e46AW("puvop"),
    $e46AW("knZyM"),
    $e46AW("4xkV0"),
    $e46AW("eUxjk"),
    $e46AW("ADlEP"),
    $e46AW("k0hRS"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("d2mFO"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("cotMj"),
    $e46AW("4YETx"),
    $e46AW("lzaIj"),
    $e46AW("8oU5a"),
    $e46AW("lESQD"),
    $e46AW("6JXPa"),
    $e46AW("bi0HD"),
    $e46AW("dItcg"),
    $e46AW("knz6U"),
    $e46AW("jwYkL")
]).then(()=>parcelRequire('e5o2y'));

});

parcelRegister("dT6Jh", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("d5hg6"),
    $e46AW("6VH4u"),
    $e46AW("dDxCA"),
    $e46AW("8bQp8"),
    $e46AW("66iV5"),
    $e46AW("puvop"),
    $e46AW("3hhaI"),
    $e46AW("knZyM"),
    $e46AW("4xkV0"),
    $e46AW("eUxjk"),
    $e46AW("ADlEP"),
    $e46AW("ejayw"),
    $e46AW("k0hRS"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("cotMj"),
    $e46AW("4YETx"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("7LczY"),
    $e46AW("cOm2H"),
    $e46AW("ciaTj"),
    $e46AW("fG06h"),
    $e46AW("fsXNG")
]).then(()=>parcelRequire('73ZcD'));

});

parcelRegister("7O3l1", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("3hhaI"),
    $e46AW("knZyM"),
    $e46AW("lpED7"),
    $e46AW("eUxjk"),
    $e46AW("dO151"),
    $e46AW("i7uBA"),
    $e46AW("jAido"),
    $e46AW("hwJUk"),
    $e46AW("duMxJ"),
    $e46AW("1OsTL")
]).then(()=>parcelRequire('8jmNJ'));

});



parcelRegister("aGzFq", function(module, exports) {
$parcel$export(module.exports, "useProductExtensionHandlers", () => $cc304460151301e4$export$f8392d0e24abe6db);

var $lhXNe = parcelRequire("lhXNe");

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $cijxS = parcelRequire("cijxS");

var $c72yR = parcelRequire("c72yR");
var $76TjZ = parcelRequire("76TjZ");

var $g4aMt = parcelRequire("g4aMt");
var $Bq10O = parcelRequire("Bq10O");

var $cKHhL = parcelRequire("cKHhL");

var $a2UhU = parcelRequire("a2UhU");

const $cc304460151301e4$var$CalloutBannerExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).lazy(()=>(parcelRequire("4YzcL")).then((mod)=>({
            default: mod.CalloutBannerExtension
        })));

const $cc304460151301e4$var$ResourceTilesExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).lazy(()=>(parcelRequire("luVIL")).then((mod)=>({
            default: mod.ResourceTilesExtension
        })));

const $cc304460151301e4$var$JSMHelpExtensionLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).lazy(()=>(parcelRequire("8m7MA")).then((mod)=>({
            default: mod.JSMHelpExtension
        })));
const $cc304460151301e4$var$getCSMExtensionHandlers = (contentId, PropsProvider)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $g4aMt.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $c72yR.ArticleSearchComponent)
    };
    // Callout banner Extension Handler
    handlers[0, $a2UhU.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
            fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $lhXNe.jsx)($cc304460151301e4$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    // Resource Tiles Extension Handler
    handlers[0, $Bq10O.RESOURCE_TILES_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
            fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                name: "resource-tiles-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $lhXNe.jsx)($cc304460151301e4$var$ResourceTilesExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension,
                isInEditor: false
            })
        });
    return handlers;
};
const $cc304460151301e4$var$getJSMExtensionHandlers = (contentId, PropsProvider)=>{
    const handlers = {};
    if (!contentId) return handlers;
    const defaultExtensionHandlerProps = {
        contentId: contentId,
        propsProvider: PropsProvider,
        mode: (0, $g4aMt.ExtensionMode).RENDERER,
        CustomSearchComponent: (0, $76TjZ.HelpObjectSearchComponent)
    };
    handlers[0, $a2UhU.CALLOUT_BANNER_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
            fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                name: "page-topper-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $lhXNe.jsx)($cc304460151301e4$var$CalloutBannerExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    // JSM Help Extension Handler
    handlers[0, $cKHhL.JSM_HELP_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, $lhXNe.jsx)((0, $4fqPo.Suspense), {
            fallback: /*#__PURE__*/ (0, $lhXNe.jsx)((0, $cijxS.default), {
                name: "jsm-help-extension-loader"
            }),
            children: /*#__PURE__*/ (0, $lhXNe.jsx)($cc304460151301e4$var$JSMHelpExtensionLazy, {
                ...defaultExtensionHandlerProps,
                extensionNode: extension
            })
        });
    return handlers;
};
const $cc304460151301e4$export$f8392d0e24abe6db = (props)=>{
    const { contentId: contentId, PropsProvider: PropsProvider, product: product } = props;
    const extensionHandlers = (0, $4fqPo.useMemo)(()=>{
        if (product === 'CUSTOMER_SERVICE') return $cc304460151301e4$var$getCSMExtensionHandlers(contentId, PropsProvider);
        // Future products can be added here with:
        if (product === 'HELP_HUB' && (0, $3H4LK.fg)('enable-jsm-in-hubs')) return $cc304460151301e4$var$getJSMExtensionHandlers(contentId, PropsProvider);
        return {};
    }, [
        product,
        contentId,
        PropsProvider
    ]);
    return extensionHandlers;
};

});
parcelRegister("c72yR", function(module, exports) {
$parcel$export(module.exports, "ArticleSearchComponent", () => $2f949480adc80a60$export$8a672206592a1254);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");
parcelRequire("6hIdA");
var $13Iqs = parcelRequire("13Iqs");

var $7fscZ = parcelRequire("7fscZ");

var $dYpMK = parcelRequire("dYpMK");

var $gdgUK = parcelRequire("gdgUK");

var $2JjeO = parcelRequire("2JjeO");

var $8gLvO = parcelRequire("8gLvO");
const $2f949480adc80a60$export$8a672206592a1254 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $4fqPo.useState)('');
    const [showDropdown, setShowDropdown] = (0, $4fqPo.useState)(false);
    const inputBoxRef = (0, $4fqPo.useRef)(null);
    const inputRef = (0, $4fqPo.useRef)(null);
    const [_, setInputWidth] = (0, $4fqPo.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, helpCenterAri: helpCenterAri } = (0, $dYpMK.useProductDependencies)();
    (0, $4fqPo.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $lMcEJ.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $4fqPo.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
            ref: inputBoxRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8gLvO.SearchTextField), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onInput: handleInput,
            isReadOnly: isEditor,
            placeholderText: placeholderText,
            showDropdown: showDropdown,
            queryWord: queryWord
        }));
    }, [
        isEditor,
        placeholderText,
        showDropdown,
        queryWord
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $13Iqs.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gdgUK.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2JjeO.SearchDropdown), {
                ...contentProps,
                cloudId: cloudId,
                helpCenterAri: helpCenterAri || '',
                inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                queryWord: queryWord
            }));
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("gdgUK", function(module, exports) {
$parcel$export(module.exports, "useKeyboardNavigation", () => $078cc909cc55b1ec$export$4da28cf324280418);
$parcel$export(module.exports, "KeyboardHighlightProvider", () => $078cc909cc55b1ec$export$c8551b32665b42b);

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");
const $078cc909cc55b1ec$export$ef7af5d8bc5d5ac1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext({
    registerKeyboardEnabled: undefined,
    unregisterKeyboardEnabled: undefined,
    getSelectedIndex: undefined,
    highlightComponentAt: undefined,
    unhighlightComponentAt: undefined,
    unhighlightAll: undefined,
    keyboardNavComponents: []
});
const $078cc909cc55b1ec$export$4da28cf324280418 = (options)=>{
    const [ref, setRef] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(null);
    const registrationId = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(null);
    const navigationTrackingId = (options === null || options === void 0 ? void 0 : options.navigationTrackingId) ?? null;
    const { registerKeyboardEnabled: registerKeyboardEnabled, unregisterKeyboardEnabled: unregisterKeyboardEnabled } = (0, $4fqPo.useContext)($078cc909cc55b1ec$export$ef7af5d8bc5d5ac1) ?? {};
    const [isHighlighted, setIsHighlighted] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const onKeydownCallback = options === null || options === void 0 ? void 0 : options.onKeydownCallback;
    const onHighlightedCallback = options === null || options === void 0 ? void 0 : options.onHighlightedCallback;
    const unregister = (0, $4fqPo.useCallback)(()=>{
        if (registrationId.current && unregisterKeyboardEnabled) // If the ref got removed or changed we unregister the current ref
        unregisterKeyboardEnabled(registrationId.current);
    }, [
        unregisterKeyboardEnabled
    ]);
    // Will unmount effect
    (0, $4fqPo.useEffect)(()=>()=>unregister(), [
        unregister
    ]);
    // Ref change to null
    (0, $4fqPo.useEffect)(()=>{
        !ref && unregister();
    }, [
        ref,
        unregister
    ]);
    // Everything else
    (0, $4fqPo.useEffect)(()=>{
        if (!registerKeyboardEnabled || !unregisterKeyboardEnabled) return;
        if (!ref) return;
        // Then we register the new ref
        if (ref) {
            // Another check here to ensure that the ref we get is actually a DOM node, there's probably better
            // ways to make this check but it doesn't matter too much.
            // If what we get is NOT a DOM node we will log a warning and default back to use React.findDOMNode
            if (!ref.compareDocumentPosition || !ref.addEventListener || !ref.removeEventListener) {
                // eslint-disable-next-line
                console.error('It is expected that any keyboard highlighting enabled component also passes the ref all the way to the DOM node.', 'It appears that the `ref` is not fowarded all the way to the DOM node, please use `React.forwardRef to ensure this is so`', 'Falling back to using ReactDOM.findDOMNode, this is not recommended and this fallback may be removed in the future');
                return;
            }
            registrationId.current = registerKeyboardEnabled(registrationId.current, ref, setIsHighlighted, onKeydownCallback, navigationTrackingId, onHighlightedCallback);
        }
    }, [
        ref,
        setIsHighlighted,
        onKeydownCallback,
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        navigationTrackingId,
        onHighlightedCallback
    ]);
    return [
        isHighlighted,
        setRef
    ];
};
/**
 * Legacy class implementation. Retained behind the
 * `search_refactor_keyboard_highlight_provider` feature gate while the
 * function-component replacement is rolled out. The exported
 * {@link KeyboardHighlightProvider} switches between the two.
 */ class $078cc909cc55b1ec$var$KeyboardHighlightProviderClass extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidMount() {
        this.attach(this.props.listenerNode);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.listenerNode !== this.props.listenerNode) {
            this.detach(prevProps.listenerNode);
            this.attach(this.props.listenerNode);
        }
    }
    componentWillUnmount() {
        this.detach(this.props.listenerNode);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($078cc909cc55b1ec$export$ef7af5d8bc5d5ac1.Provider, {
            value: {
                registerKeyboardEnabled: this.registerKeyboardEnabled,
                unregisterKeyboardEnabled: this.unregisterKeyboardEnabled,
                getSelectedIndex: this.getSelectedIndex,
                highlightComponentAt: this.highlightComponentAt,
                unhighlightComponentAt: this.unhighlightComponentAt,
                unhighlightAll: this.unhighlightAll,
                keyboardNavComponents: this.keyboardNavComponents
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.currentlySelected = undefined, this.currentSelectedTrackingId = null, this.keyboardNavComponents = [], this.registerKeyboardEnabled = (currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCallback)=>{
            const indexAt = this.keyboardNavComponents.findIndex(({ id: id })=>id === currentId);
            // If the currentId is null or we can't find any records of the id we will create a new entry
            const isNew = currentId === null || currentId === undefined || indexAt === -1;
            const id = isNew ? Math.max(...this.keyboardNavComponents.map((component)=>component.id), 0) + 1 : this.keyboardNavComponents[indexAt].id;
            if (isNew) this.keyboardNavComponents.push({
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            });
            else // Otherwise we will update the current entry
            this.keyboardNavComponents[indexAt] = {
                id: id,
                domRef: domRef,
                onHighlightChanged: onHighlightChanged,
                onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
                navigationTrackingId: navigationTrackingId,
                onHighlightedCallback: onHighlightedCallback
            };
            this.keyboardNavComponents = this.keyboardNavComponents.sort((c1, c2)=>{
                const result = c1.domRef.compareDocumentPosition(c2.domRef);
                if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
                else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
                return 0;
            });
            const indexToHighlight = this.getSearchIdIndex(this.currentSelectedTrackingId);
            if (indexToHighlight !== undefined && indexToHighlight >= 0) {
                this.unhighlightAll();
                this.highlightComponentAt(indexToHighlight);
            }
            return id;
        }, this.unregisterKeyboardEnabled = (unregisterRef)=>{
            if (this.currentlySelected === unregisterRef) this.currentlySelected = undefined;
            this.keyboardNavComponents = this.keyboardNavComponents.filter(({ id: ref })=>ref !== unregisterRef);
            // Reset currentSelectedTrackingId when all components are unregistered
            if (this.keyboardNavComponents.length === 0) this.currentSelectedTrackingId = null;
        }, this.onKeyDownCallbackAt = (index, e)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const onKeyDown = this.keyboardNavComponents[index].onKeyDownWhenHighlighted;
                onKeyDown && onKeyDown(e, this.keyboardNavComponents[index].domRef);
            }
        }, this.onHighlightedCallback = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) {
                const callback = this.keyboardNavComponents[index].onHighlightedCallback;
                callback && callback(index);
            }
        }, this.unhighlightComponentAt = (index)=>{
            if (typeof index !== 'undefined' && index >= 0 && index < this.keyboardNavComponents.length) this.keyboardNavComponents[index].onHighlightChanged(false);
        }, this.highlightComponentAt = (index)=>{
            if (index >= 0 && index < this.keyboardNavComponents.length) {
                const { id: id, navigationTrackingId: navigationTrackingId } = this.keyboardNavComponents[index];
                this.currentlySelected = id;
                this.currentSelectedTrackingId = navigationTrackingId;
                this.keyboardNavComponents[index].onHighlightChanged(true);
            }
        }, this.unhighlightAll = ()=>{
            this.currentSelectedTrackingId = null;
            this.currentlySelected = undefined;
            this.keyboardNavComponents.forEach((component)=>component.onHighlightChanged(false));
        }, this.getSelectedIndex = ()=>{
            if (!this.currentlySelected) return undefined;
            return this.keyboardNavComponents.findIndex(({ id: id })=>id === this.currentlySelected);
        }, this.getSearchIdIndex = (searchId)=>searchId === null ? undefined : this.keyboardNavComponents.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), this.onKeyDown = (e)=>{
            if (this.keyboardNavComponents.length === 0) return;
            if (e.isComposing || e.keyCode === 229) return;
            let currentIndex = this.getSelectedIndex();
            const prevIndex = currentIndex;
            if (e.code === 'ArrowDown' || e.keyCode === 40) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = 0;
                    else currentIndex = (currentIndex + 1) % this.keyboardNavComponents.length;
                    e.preventDefault();
                }
            } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
                if (!e.shiftKey) {
                    if (typeof currentIndex === 'undefined') currentIndex = this.keyboardNavComponents.length - 1;
                    else {
                        currentIndex -= 1;
                        if (currentIndex < 0) currentIndex = this.keyboardNavComponents.length - Math.abs(currentIndex);
                    }
                    e.preventDefault();
                }
            } else {
                if (typeof currentIndex !== 'undefined') this.onKeyDownCallbackAt(currentIndex, e);
                return;
            }
            if (prevIndex !== currentIndex && currentIndex !== undefined) {
                this.unhighlightComponentAt(prevIndex);
                this.highlightComponentAt(currentIndex);
                this.onHighlightedCallback(currentIndex);
            }
        }, this.attach = (listenerNode)=>{
            if (listenerNode) listenerNode.addEventListener('keydown', this.onKeyDown);
        }, this.detach = (listenerNode)=>{
            if (listenerNode) listenerNode.removeEventListener('keydown', this.onKeyDown);
        };
    }
}
/**
 * Function-component implementation of `KeyboardHighlightProvider`.
 */ const $078cc909cc55b1ec$var$KeyboardHighlightProviderFn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef(({ children: children, listenerNode: listenerNode }, ref)=>{
    const currentlySelectedRef = (0, $4fqPo.useRef)(undefined);
    const currentSelectedTrackingIdRef = (0, $4fqPo.useRef)(null);
    const keyboardNavComponentsRef = (0, $4fqPo.useRef)([]);
    const getSelectedIndex = (0, $4fqPo.useCallback)(()=>{
        const currentlySelected = currentlySelectedRef.current;
        if (!currentlySelected) return undefined;
        return keyboardNavComponentsRef.current.findIndex(({ id: id })=>id === currentlySelected);
    }, []);
    const getSearchIdIndex = (0, $4fqPo.useCallback)((searchId)=>searchId === null ? undefined : keyboardNavComponentsRef.current.findIndex(({ navigationTrackingId: navigationTrackingId })=>navigationTrackingId === searchId), []);
    const unhighlightComponentAt = (0, $4fqPo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) components[index].onHighlightChanged(false);
    }, []);
    const highlightComponentAt = (0, $4fqPo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (index >= 0 && index < components.length) {
            const { id: id, navigationTrackingId: navigationTrackingId } = components[index];
            currentlySelectedRef.current = id;
            currentSelectedTrackingIdRef.current = navigationTrackingId;
            components[index].onHighlightChanged(true);
        }
    }, []);
    const unhighlightAll = (0, $4fqPo.useCallback)(()=>{
        currentSelectedTrackingIdRef.current = null;
        currentlySelectedRef.current = undefined;
        keyboardNavComponentsRef.current.forEach((component)=>component.onHighlightChanged(false));
    }, []);
    const onHighlightedCallback = (0, $4fqPo.useCallback)((index)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const callback = components[index].onHighlightedCallback;
            callback && callback(index);
        }
    }, []);
    const onKeyDownCallbackAt = (0, $4fqPo.useCallback)((index, e)=>{
        const components = keyboardNavComponentsRef.current;
        if (typeof index !== 'undefined' && index >= 0 && index < components.length) {
            const onKeyDown = components[index].onKeyDownWhenHighlighted;
            onKeyDown && onKeyDown(e, components[index].domRef);
        }
    }, []);
    const registerKeyboardEnabled = (0, $4fqPo.useCallback)((currentId, domRef, onHighlightChanged, onKeyDownWhenHighlighted, navigationTrackingId, onHighlightedCb)=>{
        const components = keyboardNavComponentsRef.current;
        const indexAt = components.findIndex(({ id: id })=>id === currentId);
        // If the currentId is null or we can't find any records of the id we will create a new entry
        const isNew = currentId === null || currentId === undefined || indexAt === -1;
        const id = isNew ? Math.max(...components.map((component)=>component.id), 0) + 1 : components[indexAt].id;
        if (isNew) components.push({
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        });
        else // Otherwise we will update the current entry
        components[indexAt] = {
            id: id,
            domRef: domRef,
            onHighlightChanged: onHighlightChanged,
            onKeyDownWhenHighlighted: onKeyDownWhenHighlighted,
            navigationTrackingId: navigationTrackingId,
            onHighlightedCallback: onHighlightedCb
        };
        keyboardNavComponentsRef.current = components.sort((c1, c2)=>{
            const result = c1.domRef.compareDocumentPosition(c2.domRef);
            if (result & Node.DOCUMENT_POSITION_FOLLOWING || result & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
            else if (result & Node.DOCUMENT_POSITION_PRECEDING || result & Node.DOCUMENT_POSITION_CONTAINS) return 1;
            return 0;
        });
        const indexToHighlight = getSearchIdIndex(currentSelectedTrackingIdRef.current);
        if (indexToHighlight !== undefined && indexToHighlight >= 0) {
            unhighlightAll();
            highlightComponentAt(indexToHighlight);
        }
        return id;
    }, [
        getSearchIdIndex,
        highlightComponentAt,
        unhighlightAll
    ]);
    const unregisterKeyboardEnabled = (0, $4fqPo.useCallback)((unregisterRef)=>{
        if (currentlySelectedRef.current === unregisterRef) currentlySelectedRef.current = undefined;
        keyboardNavComponentsRef.current = keyboardNavComponentsRef.current.filter(({ id: ref })=>ref !== unregisterRef);
        // Reset currentSelectedTrackingId when all components are unregistered
        if (keyboardNavComponentsRef.current.length === 0) currentSelectedTrackingIdRef.current = null;
    }, []);
    const onKeyDown = (0, $4fqPo.useCallback)((e)=>{
        const components = keyboardNavComponentsRef.current;
        if (components.length === 0) return;
        if (e.isComposing || e.keyCode === 229) return;
        let currentIndex = getSelectedIndex();
        const prevIndex = currentIndex;
        if (e.code === 'ArrowDown' || e.keyCode === 40) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = 0;
                else currentIndex = (currentIndex + 1) % components.length;
                e.preventDefault();
            }
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
            if (!e.shiftKey) {
                if (typeof currentIndex === 'undefined') currentIndex = components.length - 1;
                else {
                    currentIndex -= 1;
                    if (currentIndex < 0) currentIndex = components.length - Math.abs(currentIndex);
                }
                e.preventDefault();
            }
        } else {
            if (typeof currentIndex !== 'undefined') onKeyDownCallbackAt(currentIndex, e);
            return;
        }
        if (prevIndex !== currentIndex && currentIndex !== undefined) {
            unhighlightComponentAt(prevIndex);
            highlightComponentAt(currentIndex);
            onHighlightedCallback(currentIndex);
        }
    }, [
        getSelectedIndex,
        onKeyDownCallbackAt,
        unhighlightComponentAt,
        highlightComponentAt,
        onHighlightedCallback
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!listenerNode) return;
        listenerNode.addEventListener('keydown', onKeyDown);
        return ()=>{
            listenerNode.removeEventListener('keydown', onKeyDown);
        };
    }, [
        listenerNode,
        onKeyDown
    ]);
    const contextValue = (0, $4fqPo.useMemo)(()=>({
            registerKeyboardEnabled: registerKeyboardEnabled,
            unregisterKeyboardEnabled: unregisterKeyboardEnabled,
            getSelectedIndex: getSelectedIndex,
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            get keyboardNavComponents () {
                // Always read the latest registry from the ref so consumers that
                // destructure `keyboardNavComponents` from the context still see
                // up-to-date data without forcing a re-render of the provider.
                return keyboardNavComponentsRef.current;
            }
        }), [
        registerKeyboardEnabled,
        unregisterKeyboardEnabled,
        getSelectedIndex,
        highlightComponentAt,
        unhighlightComponentAt,
        unhighlightAll
    ]);
    (0, $4fqPo.useImperativeHandle)(ref, ()=>({
            highlightComponentAt: highlightComponentAt,
            unhighlightComponentAt: unhighlightComponentAt,
            unhighlightAll: unhighlightAll,
            getSelectedIndex: getSelectedIndex
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($078cc909cc55b1ec$export$ef7af5d8bc5d5ac1.Provider, {
        value: contextValue
    }, children);
});
const $078cc909cc55b1ec$export$c8551b32665b42b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef((props, ref)=>{
    if ((0, $3H4LK.fg)('search_refactor_keyboard_highlight_provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($078cc909cc55b1ec$var$KeyboardHighlightProviderFn, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($078cc909cc55b1ec$var$KeyboardHighlightProviderClass, props);
});
const $078cc909cc55b1ec$export$cbeda0f7f7a8026c = ()=>{
    return (0, $4fqPo.useContext)($078cc909cc55b1ec$export$ef7af5d8bc5d5ac1);
};

});

parcelRegister("2JjeO", function(module, exports) {
$parcel$export(module.exports, "SearchDropdown", () => $5bcc89f7d6fdc92c$export$e33d60b8f4099ae);

var $4fqPo = parcelRequire("4fqPo");

var $4TjJp = parcelRequire("4TjJp");

var $hGXJP = parcelRequire("hGXJP");

var $kVo0D = parcelRequire("kVo0D");
const $5bcc89f7d6fdc92c$export$e33d60b8f4099ae = ({ inputWidth: inputWidth, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4TjJp.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kVo0D.SearchSkeletons), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hGXJP.ResolvedAndErrorContent), props)));
};

});
parcelRegister("4TjJp", function(module, exports) {
$parcel$export(module.exports, "SearchDialog", () => $b1324254a1fccd91$export$2aadebb53f6015f6);

var $4fqPo = parcelRequire("4fqPo");

var $4uaZ1 = parcelRequire("4uaZ1");
const $b1324254a1fccd91$export$2aadebb53f6015f6 = ({ children: children, style: style, shouldFillContainer: shouldFillContainer, isExpanded: isExpanded })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4uaZ1.SearchDialogWrapper), {
        shouldFillContainer: shouldFillContainer,
        isExpanded: isExpanded,
        "data-test-id": "search-dialog-dialog-wrapper",
        tabIndex: -1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, children);

});
parcelRegister("4uaZ1", function(module, exports) {
$parcel$export(module.exports, "SearchDialogWrapper", () => $bc04866a7a9aa491$export$dcefba65c42da69c);
parcelRequire("4fqPo");

var $KJVSo = parcelRequire("KJVSo");

var $lPAzw = parcelRequire("lPAzw");
const $bc04866a7a9aa491$export$dcefba65c42da69c = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e101cjwc0"
})("position:relative;", (props)=>props.shouldFillContainer ? `width: 100%;` : `width: ${0, $KJVSo.dialogWidth};`, " ", (props)=>props.isExpanded && props.shouldFillContainer ? `min-width: ${0, $KJVSo.dialogWidth};` : '', " box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);border-radius:var(--ds-radius-large, 8px);background-color:var(--ds-surface-overlay, #FFFFFF);overflow:hidden;margin-top:", (0, $KJVSo.grid).px, ";:focus{outline:none;}display:flex;flex-direction:column;height:100%;@media screen and (max-width: ", (0, $KJVSo.dialogPageTakeoverWidth), "px){min-width:100%;max-width:100%;border-radius:0;margin-top:0;flex:1;overflow:auto;}");

});
parcelRegister("KJVSo", function(module, exports) {
$parcel$export(module.exports, "grid", () => $da95a8573effc783$export$85fc379452d91af0);
$parcel$export(module.exports, "dialogWidth", () => $da95a8573effc783$export$a3da89b899389ed8);
$parcel$export(module.exports, "dialogPageTakeoverWidth", () => $da95a8573effc783$export$ce4512df260a325a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
// eslint-disable-next-line no-barrel-files/no-barrel-files






const $da95a8573effc783$var$AkGrid = (num = 1)=>({
        px: `${num * 8}px`,
        unitless: num * 8,
        multiple: (multiplier)=>$da95a8573effc783$var$AkGrid(multiplier * num),
        half: ()=>$da95a8573effc783$var$AkGrid(0.5 * num),
        twice: ()=>$da95a8573effc783$var$AkGrid(2 * num)
    });
const $da95a8573effc783$export$85fc379452d91af0 = $da95a8573effc783$var$AkGrid(1);
const $da95a8573effc783$export$b9930dabfa4a3a3 = '56px';
const $da95a8573effc783$export$f6af7620e8789c39 = '200px';
const $da95a8573effc783$export$64d8573e83b64ff8 = '150px';
const $da95a8573effc783$export$a3da89b899389ed8 = '780px';
const $da95a8573effc783$export$ce4512df260a325a = 780;
const $da95a8573effc783$export$a406031ed42c8e02 = '1130px';
const $da95a8573effc783$export$e00021bea368c518 = $da95a8573effc783$export$85fc379452d91af0.multiple(4);
const $da95a8573effc783$export$30310ee354b45eb0 = $da95a8573effc783$export$85fc379452d91af0.multiple(6);

});

parcelRegister("lPAzw", function(module, exports) {
$parcel$export(module.exports, "default", () => $fe4abad4dd5400a0$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");
parcelRequire("lqVX7");
var $gOfqU = parcelRequire("gOfqU");

var $lylKc = parcelRequire("lylKc");

var $7YlIs = parcelRequire("7YlIs");

var $7sVuQ = parcelRequire("7sVuQ");

var $4fqPo = parcelRequire("4fqPo");

var $hH4YW = parcelRequire("hH4YW");
var $fe4abad4dd5400a0$var$isDevelopment = false;
var $fe4abad4dd5400a0$var$testOmitPropsOnStringTag = (0, $hH4YW.default);
var $fe4abad4dd5400a0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $fe4abad4dd5400a0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $fe4abad4dd5400a0$var$testOmitPropsOnStringTag : $fe4abad4dd5400a0$var$testOmitPropsOnComponent;
};
var $fe4abad4dd5400a0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $fe4abad4dd5400a0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7sVuQ.registerStyles)(cache, serialized, isStringTag);
    (0, $7YlIs.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7sVuQ.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $fe4abad4dd5400a0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $fe4abad4dd5400a0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $fe4abad4dd5400a0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $gOfqU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $4fqPo.useContext((0, $gOfqU.T));
            }
            if (typeof props.className === 'string') className = (0, $7sVuQ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $lylKc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $fe4abad4dd5400a0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($fe4abad4dd5400a0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $4fqPo.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $fe4abad4dd5400a0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $ichJ5.default)({}, options, nextOptions, {
                shouldForwardProp: $fe4abad4dd5400a0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("7YlIs", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $5cdefb5aaf28cce1$export$db21c7ffa21794e7);

var $4fqPo = parcelRequire("4fqPo");
var $5cdefb5aaf28cce1$var$syncFallback = function syncFallback(create) {
    return create();
};
var $5cdefb5aaf28cce1$var$useInsertionEffect = $4fqPo.useInsertionEffect ? $4fqPo.useInsertionEffect : false;
var $5cdefb5aaf28cce1$export$db21c7ffa21794e7 = $5cdefb5aaf28cce1$var$useInsertionEffect || $5cdefb5aaf28cce1$var$syncFallback;
var $5cdefb5aaf28cce1$export$811a713a7276cb9d = $5cdefb5aaf28cce1$var$useInsertionEffect || $4fqPo.useLayoutEffect;

});

parcelRegister("hH4YW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ce1a511a95c0f9df$export$2e2bcd8739ae039);

var $2VB3l = parcelRequire("2VB3l");
// eslint-disable-next-line no-undef
var $ce1a511a95c0f9df$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $ce1a511a95c0f9df$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $2VB3l.default)(function(prop) {
    return $ce1a511a95c0f9df$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});




parcelRegister("hGXJP", function(module, exports) {
$parcel$export(module.exports, "ResolvedAndErrorContent", () => $ba496e3dfbab0816$export$5d6737b8e2fd8b38);

var $i0MSe = parcelRequire("i0MSe");

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");
var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");

var $eIIcZ = parcelRequire("eIIcZ");

var $17RcU = parcelRequire("17RcU");

var $fxR5Y = parcelRequire("fxR5Y");

var $3OLcN = parcelRequire("3OLcN");
var $8p7Jg = parcelRequire("8p7Jg");

var $ANezt = parcelRequire("ANezt");

var $lDENC = parcelRequire("lDENC");

var $hFpr7 = parcelRequire("hFpr7");

var $k9u3H = parcelRequire("k9u3H");

var $coo91 = parcelRequire("coo91");
const $ba496e3dfbab0816$export$5d6737b8e2fd8b38 = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $gIeP2.useLazyLoadQuery)((0, $i0MSe.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        input: {
            query: queryWord,
            contentTypes: [
                'FOLDER',
                'PAGE'
            ]
        },
        first: 10
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const { articlesAndFolders: articlesAndFolders, hasQueryError: hasQueryError } = (0, $lDENC.useArticleSearch)(searchResponse, queryWord);
    const showEmptyState = articlesAndFolders && articlesAndFolders.length === 0;
    const showResolvedState = articlesAndFolders && articlesAndFolders.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Fragment), null, (showEmptyState || hasQueryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fxR5Y.EmptyState), {
        title: hasQueryError ? formatMessage((0, $coo91.messages).errorTitle) : formatMessage((0, $coo91.messages).emptyStateTitle),
        Image: (0, $k9u3H.SearchErrorImage),
        content: hasQueryError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $coo91.messages).errorDescription) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $coo91.messages).emptyStateDescription)
    }), showResolvedState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8p7Jg.SearchDialogContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3OLcN.ResultContainer), null, articlesAndFolders.map((result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ANezt.SearchResult), {
            key: result.id,
            href: result.url,
            title: result.title,
            isCollapsed: true,
            icon: result.type === (0, $hFpr7.ContentType).PAGE ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIIcZ))), {
                label: ""
            })
        }))))));
};

});
parcelRegister("i0MSe", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ab8f6ff0d74394$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bdd62f48e8fdad92549ed462bc7fb25f>>
 * @relayHash d3adfd96cf5547776151651b69eb76b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a
const $64ab8f6ff0d74394$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "contentType"
            },
            {
                "concreteType": "HelpObjectStoreArticleURLInfo",
                "kind": "LinkedField",
                "name": "urlInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "shareUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreSupportSiteArticleSearchResult"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v11 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v12 = [
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "alias": "helpObjectStore_searchArticlesForSupportSite",
                    "args": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ 
                    ],
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "__ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite_connection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "resolvedAndErrorContentQuery",
            "selections": [
                {
                    "args": v12 /*: any*/ ,
                    "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultConnection",
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticlesForSupportSite",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "HelpObjectStoreSupportSiteArticleSearchResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "args": v12 /*: any*/ ,
                    "filters": [
                        "cloudId",
                        "helpCenterAri",
                        "input"
                    ],
                    "handle": "connection",
                    "key": "ResolvedAndErrorContent__helpObjectStore_searchArticlesForSupportSite",
                    "kind": "LinkedHandle",
                    "name": "helpObjectStore_searchArticlesForSupportSite"
                }
            ]
        },
        "params": {
            "id": "d237b13529b7cb66d204f6a282a19234e2da070840529442d51c9129eea88e0a",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": null,
                        "direction": "forward",
                        "path": [
                            "helpObjectStore_searchArticlesForSupportSite"
                        ]
                    }
                ]
            },
            "name": "resolvedAndErrorContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$64ab8f6ff0d74394$var$node.hash = "8f52dcfd8c2f8d8ee3e0ac349b7693a1";
var $64ab8f6ff0d74394$export$2e2bcd8739ae039 = $64ab8f6ff0d74394$var$node;

});

parcelRegister("eIIcZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::329ffe53264930b81eb140b6c3cd31f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab7777a06065d28d$var$_react = $ab7777a06065d28d$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $ab7777a06065d28d$var$_baseNew = $ab7777a06065d28d$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $ab7777a06065d28d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderClosed".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab7777a06065d28d$var$FolderClosedIcon = (props)=>/*#__PURE__*/ $ab7777a06065d28d$var$_react.default.createElement($ab7777a06065d28d$var$_baseNew.default, Object.assign({
        name: "FolderClosedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v3h11V4.75a.5.5 0 0 0-.5-.5H7.69L5.94 2.5zm10.5 5h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM1 3a2 2 0 0 1 2-2h3.56l1.75 1.75H13a2 2 0 0 1 2 2V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$ab7777a06065d28d$var$FolderClosedIcon.displayName = 'FolderClosedIcon';
var $ab7777a06065d28d$var$_default = module.exports.default = $ab7777a06065d28d$var$FolderClosedIcon;

});

parcelRegister("fxR5Y", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $e44df7b3d798b2b8$export$fddf379e22a74b00);

var $4fqPo = parcelRequire("4fqPo");

var $gPYej = parcelRequire("gPYej");

var $amgnH = parcelRequire("amgnH");

var $jlFjW = parcelRequire("jlFjW");
const $e44df7b3d798b2b8$export$fddf379e22a74b00 = ({ title: title, content: content, Image: Image })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $amgnH.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Image, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gPYej.Title), null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jlFjW.Content), null, content)));

});
parcelRegister("gPYej", function(module, exports) {
$parcel$export(module.exports, "Title", () => $57412571490e25c0$export$f99233281efd08a0);
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $4fqPo = parcelRequire("4fqPo");


// // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $57412571490e25c0$var$TitleContainerStyles = (0, $2m8U6.xcss)({
    position: 'relative',
    font: 'font.heading.small',
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginTop: 'space.100'
});
const $57412571490e25c0$export$f99233281efd08a0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $57412571490e25c0$var$TitleContainerStyles
    }, children);
};

});

parcelRegister("amgnH", function(module, exports) {
$parcel$export(module.exports, "Wrapper", () => $da4b76f3bef61ded$export$e6dfd72ab29f8598);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");
parcelRequire("4fqPo");

var $lPAzw = parcelRequire("lPAzw");
const $da4b76f3bef61ded$export$e6dfd72ab29f8598 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1pv7r8x0"
})({
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: (0, $KJVSo.grid).twice().px
});

});

parcelRegister("jlFjW", function(module, exports) {
$parcel$export(module.exports, "Content", () => $29246a6abb847854$export$7c6e2c02157bb7d2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $58xad = parcelRequire("58xad");
parcelRequire("4fqPo");

var $lPAzw = parcelRequire("lPAzw");
const $29246a6abb847854$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1nenibz0"
})({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: (0, $KJVSo.grid).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $58xad.primaryTextColour)
});

});
parcelRegister("58xad", function(module, exports) {
$parcel$export(module.exports, "primaryTextColour", () => $2626479725e7110d$export$eeb0307e2964e28d);
const $2626479725e7110d$export$eeb0307e2964e28d = "var(--ds-text, #292A2E)";

});



parcelRegister("3OLcN", function(module, exports) {
$parcel$export(module.exports, "ResultContainer", () => $468380e637c358ba$export$ab35601bed9ca017);
parcelRequire("4fqPo");

var $lPAzw = parcelRequire("lPAzw");
function $468380e637c358ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $468380e637c358ba$export$ab35601bed9ca017 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "eqbbglm0"
})({
    name: "n94oxe",
    styles: "overflow-x:hidden;overflow-y:auto;flex:1;max-width:100%;box-sizing:border-box"
});

});

parcelRegister("8p7Jg", function(module, exports) {
$parcel$export(module.exports, "SearchDialogContent", () => $2985687d61454e84$export$c9e0e8491f083dd5);

var $4fqPo = parcelRequire("4fqPo");

var $KJVSo = parcelRequire("KJVSo");

var $lc6PF = parcelRequire("lc6PF");

var $BZX67 = parcelRequire("BZX67");

var $lPAzw = parcelRequire("lPAzw");



var $3OLcN = parcelRequire("3OLcN");


const $2985687d61454e84$var$SIDEBAR_PANE_WIDTH = 272;
const $2985687d61454e84$var$resultContainerVerticalPadding = 8;
const $2985687d61454e84$export$6b8430dd9f61a5c7 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "ee3sr7s1"
})("flex:0 1 auto;width:", $2985687d61454e84$var$SIDEBAR_PANE_WIDTH, "px;display:flex;flex-direction:column;max-height:100%;padding-bottom:var(--ds-space-200, 16px);@media screen and (max-width: ", (0, $KJVSo.dialogPageTakeoverWidth), "px){display:none;}");
const $2985687d61454e84$export$f39f3f768bc98e3d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BZX67.SidebarContainerBorder), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2985687d61454e84$export$6b8430dd9f61a5c7, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lc6PF.SidebarScrollContainer), null, children)));
const $2985687d61454e84$var$totalDialogHeightPx = 776 + $2985687d61454e84$var$resultContainerVerticalPadding * 2;
const $2985687d61454e84$var$footerHeight = 48;
const $2985687d61454e84$var$belowDialogSpace = 224;
const $2985687d61454e84$var$aiFullDialogPromptHeight = 64;
const $2985687d61454e84$export$c9e0e8491f083dd5 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "ee3sr7s0"
})("display:flex;max-height:", (props)=>`calc(100vh - ${$2985687d61454e84$var$belowDialogSpace - $2985687d61454e84$var$footerHeight + (props.showAtlassianHomeSearchLink ? $2985687d61454e84$var$footerHeight : 0) + (props.aiSearchFullDialogEnabled ? $2985687d61454e84$var$aiFullDialogPromptHeight : 0)}px)`, ";box-sizing:border-box;flex:1;min-height:", (props)=>props.minHeight ? `${props.minHeight}px` : 'auto', ";@media screen and (min-height: ", $2985687d61454e84$var$totalDialogHeightPx + $2985687d61454e84$var$belowDialogSpace, "px){max-height:", (props)=>`${$2985687d61454e84$var$totalDialogHeightPx - $2985687d61454e84$var$footerHeight - (props.aiSearchFullDialogEnabled ? $2985687d61454e84$var$aiFullDialogPromptHeight : 0)}px;`, ";}@media screen and (max-width: ", (0, $KJVSo.dialogPageTakeoverWidth), "px){max-height:initial;overflow:auto;}");

});
parcelRegister("lc6PF", function(module, exports) {
$parcel$export(module.exports, "SidebarScrollContainer", () => $05bc7e353ffed703$export$34a31057caff1acb);
parcelRequire("4fqPo");

var $lPAzw = parcelRequire("lPAzw");
const $05bc7e353ffed703$export$34a31057caff1acb = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e18m3bbr0"
})({
    flex: '1 1 auto',
    overflowX: 'hidden',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});

});

parcelRegister("BZX67", function(module, exports) {
$parcel$export(module.exports, "SidebarContainerBorder", () => $1bde41e18198a10e$export$33eeaf745b96a17f);
parcelRequire("4fqPo");

var $lPAzw = parcelRequire("lPAzw");
const $1bde41e18198a10e$export$33eeaf745b96a17f = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1vcw7g0"
})({
    margin: `${"var(--ds-space-200, 16px)"} 0`,
    borderLeft: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});

});


parcelRegister("ANezt", function(module, exports) {
$parcel$export(module.exports, "SearchResult", () => $f54009261dc7eb19$export$a2def421b23768aa);

var $4fqPo = parcelRequire("4fqPo");

var $9RXEz = parcelRequire("9RXEz");

var $8frcs = parcelRequire("8frcs");

var $f8dhv = parcelRequire("f8dhv");
const $f54009261dc7eb19$export$a2def421b23768aa = (props)=>{
    const ResultContentComponent = props.isQuickFind ? (0, $f8dhv.EnlargedSearchResultContent) : (0, $9RXEz.SearchResultContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8frcs.SearchResultLink), props, (isKeyboardHighlighted)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(ResultContentComponent, {
            ...props,
            isKeyboardHighlighted: isKeyboardHighlighted
        }));
};

});
parcelRegister("9RXEz", function(module, exports) {
$parcel$export(module.exports, "SearchResultContent", () => $d22f630c0451b377$export$b5fd7d6305bfbd3e);

var $4fqPo = parcelRequire("4fqPo");

var $ebNdI = parcelRequire("ebNdI");

var $dCS99 = parcelRequire("dCS99");

var $6WrN3 = parcelRequire("6WrN3");

var $fqs10 = parcelRequire("fqs10");

var $hFsx1 = parcelRequire("hFsx1");

var $hAnOh = parcelRequire("hAnOh");

var $4Ca67 = parcelRequire("4Ca67");

var $flXw7 = parcelRequire("flXw7");

var $ffRJZ = parcelRequire("ffRJZ");

var $bFQAg = parcelRequire("bFQAg");
const $d22f630c0451b377$export$595b9d59c3d65270 = '@@@hl@@@';
const $d22f630c0451b377$export$eea8f6b95460c3c3 = '@@@endhl@@@';
const $d22f630c0451b377$var$getResultLabel = (label)=>{
    if (typeof label === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ffRJZ.ResultLabel), {
        title: typeof label === 'string' ? label : undefined
    }, label);
    return label;
};
const $d22f630c0451b377$var$getResultTitle = (title)=>{
    if (typeof title === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        title: title,
        className: "SearchDialogResultTitle"
    }, title));
    return title;
};
const $d22f630c0451b377$export$b5fd7d6305bfbd3e = ({ icon: icon, label: label, title: title, meta: meta, additionalMeta: additionalMeta, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted })=>{
    const getResultContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, isCollapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dCS99.CollapsedResultContentWrapper), {
            "data-testid": "collapsed-result-view"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bFQAg.ResultTitleContainer), {
            isCollapsed: true
        }, $d22f630c0451b377$var$getResultLabel(label), $d22f630c0451b377$var$getResultTitle(title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fqs10.CollapsedResultDetailWrapper), null, meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6WrN3.CollapsedResultDetail), {
            title: typeof meta === 'string' ? meta : undefined
        }, meta), additionalMeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hFsx1.DetailsSeparator), null, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6WrN3.CollapsedResultDetail), null, additionalMeta)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bFQAg.ResultTitleContainer), null, $d22f630c0451b377$var$getResultLabel(label), $d22f630c0451b377$var$getResultTitle(title)), meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $flXw7.ResultDetail), {
            title: typeof meta === 'string' ? meta : undefined
        }, meta), additionalMeta ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $flXw7.ResultDetail), {
            title: typeof additionalMeta === 'string' ? additionalMeta : undefined
        }, additionalMeta) : null));
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(null);
    (0, $4fqPo.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4Ca67.ResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hAnOh.IconContainer), null, icon), getResultContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4Ca67.ReturnIconContainer), {
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ebNdI.ReturnIcon), {
        inverted: true
    })));
};

});
parcelRegister("ebNdI", function(module, exports) {
$parcel$export(module.exports, "ReturnIcon", () => $ad7eafb7ba529462$export$d6c38c54dfb7c9d5);

var $4fqPo = parcelRequire("4fqPo");
const $ad7eafb7ba529462$export$d6c38c54dfb7c9d5 = ({ inverted: inverted = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        viewBox: "0 0 24 16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("rect", {
        width: "24",
        height: "16",
        fill: inverted ? "var(--ds-background-neutral-bold, #292A2E)" : "var(--ds-background-neutral, #0515240F)",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        fill: inverted ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)",
        fillRule: "nonzero",
        d: "M8.12809107,9.16933636 C8.10113378,9.12943488 8.07791542,9.08679981 8.05893872,9.04193385 C8,8.89679975 7.98627063,8.74857828 8.01372937,8.60675456 C8.04118811,8.46493084 8.10983496,8.32950487 8.21966991,8.21966991 L9.96966991,6.46966991 C10.2625631,6.1767767 10.7374369,6.1767767 11.0303301,6.46966991 C11.3232233,6.76256313 11.3232233,7.23743687 11.0303301,7.53033009 L10.5606602,8 L12.75,8 C13.4403559,8 14,7.44035594 14,6.75 L14,5.75 C14,5.33578644 14.3357864,5 14.75,5 C15.1642136,5 15.5,5.33578644 15.5,5.75 L15.5,6.75 C15.5,8.26878306 14.2687831,9.5 12.75,9.5 L10.5606602,9.5 L11.0303301,9.96966991 C11.3232233,10.2625631 11.3232233,10.7374369 11.0303301,11.0303301 C10.7374369,11.3232233 10.2625631,11.3232233 9.96966991,11.0303301 L8.21966991,9.28033009 C8.18436185,9.24502202 8.15331014,9.20706939 8.1265148,9.16710979 Z"
    })));

});

parcelRegister("dCS99", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultContentWrapper", () => $e0e5b4dfa7c0dd92$export$ee32d1086c278cfc);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lPAzw = parcelRequire("lPAzw");
function $e0e5b4dfa7c0dd92$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e0e5b4dfa7c0dd92$export$ee32d1086c278cfc = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1oz9dht0"
})({
    name: "1ls843y",
    styles: "display:block;min-width:0;flex-grow:1"
});

});

parcelRegister("6WrN3", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultDetail", () => $e3d40355068a5ef5$export$addf7aa0f753bbe8);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bHSLd = parcelRequire("bHSLd");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $e3d40355068a5ef5$export$addf7aa0f753bbe8 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1kgzlm60"
})((0, $3w6rz.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bHSLd.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});

});
parcelRegister("bHSLd", function(module, exports) {
$parcel$export(module.exports, "itemLinkSecondaryColor", () => $11128ebca6c42026$export$7168c0a11fb9ab29);
const $11128ebca6c42026$export$7168c0a11fb9ab29 = "var(--ds-text-subtlest, #6B6E76)";

});

parcelRegister("3w6rz", function(module, exports) {
$parcel$export(module.exports, "nowrapEllipsis", () => $65dd20a2490e3c48$export$b6b16ffe83ef4b56);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $65dd20a2490e3c48$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $65dd20a2490e3c48$export$b6b16ffe83ef4b56 = {
    name: "sqm42b",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};

});


parcelRegister("fqs10", function(module, exports) {
$parcel$export(module.exports, "CollapsedResultDetailWrapper", () => $824711da7b20a352$export$43a2b5c94cb85d9c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $lPAzw = parcelRequire("lPAzw");
const $824711da7b20a352$export$43a2b5c94cb85d9c = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "ehiioj40"
})({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $KJVSo.grid).multiple(54).px
});

});

parcelRegister("hFsx1", function(module, exports) {
$parcel$export(module.exports, "DetailsSeparator", () => $ba463acaac25348e$export$35507434feaa4496);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $bHSLd = parcelRequire("bHSLd");

var $lPAzw = parcelRequire("lPAzw");
const $ba463acaac25348e$export$35507434feaa4496 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e18eh42m0"
})({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bHSLd.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 ${(0, $KJVSo.grid).px}`
});

});

parcelRegister("hAnOh", function(module, exports) {
$parcel$export(module.exports, "IconContainer", () => $55241a3f60c00642$export$8f314e512d92575f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $lPAzw = parcelRequire("lPAzw");
const $55241a3f60c00642$export$8f314e512d92575f = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "eymydq50"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $KJVSo.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $KJVSo.grid).twice().px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flex: `0 0 ${(0, $KJVSo.grid).twice().px}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    lineHeight: (0, $KJVSo.grid).twice().px,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("4Ca67", function(module, exports) {
$parcel$export(module.exports, "ResultContentWrapper", () => $7ccceb14af8cd18d$export$87a308048e18f5d7);
$parcel$export(module.exports, "EnlargedResultContentWrapper", () => $7ccceb14af8cd18d$export$e10965f6350456f8);
$parcel$export(module.exports, "ReturnIconContainer", () => $7ccceb14af8cd18d$export$b7244afbfdf4cb9a);
$parcel$export(module.exports, "EnlargedReturnIconContainer", () => $7ccceb14af8cd18d$export$cc248e72bc9d7b85);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $3gJWY = parcelRequire("3gJWY");

var $lPAzw = parcelRequire("lPAzw");


















function $7ccceb14af8cd18d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7ccceb14af8cd18d$export$87a308048e18f5d7 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e8crcwv4"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $KJVSo.grid).multiple(props.isCollapsed ? 5 : 4).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `0 ${(0, $KJVSo.grid).twice().px}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $3gJWY.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $3gJWY.itemHighlightColor)
        }
    }));
const $7ccceb14af8cd18d$export$e10965f6350456f8 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e8crcwv3"
})((props)=>({
        display: 'flex',
        width: '100%',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        borderRadius: "var(--ds-radius-medium, 6px)",
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-100, 8px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: props.isKeyboardHighlighted ? (0, $3gJWY.itemHighlightColor) : 'transparent',
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $3gJWY.itemHighlightColor)
        }
    }));
const $7ccceb14af8cd18d$export$b7244afbfdf4cb9a = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e8crcwv2"
})((props)=>({
        borderRadius: "var(--ds-radius-small, 4px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: (0, $KJVSo.grid).half().px,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $KJVSo.grid).multiple(3).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $KJVSo.grid).twice().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        right: (0, $KJVSo.grid).multiple(1.5).px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        top: props.isCollapsed ? (0, $KJVSo.grid).px : (0, $KJVSo.grid).half().px,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.isKeyboardHighlighted ? 1 : 0
    }));
const $7ccceb14af8cd18d$export$cc248e72bc9d7b85 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e8crcwv1"
})({
    name: "qrg2ys",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);margin-left:var(--ds-space-150, 12px)"
});
const $7ccceb14af8cd18d$export$d84276b3ae03593f = /*#__PURE__*/ (0, $lPAzw.default)($7ccceb14af8cd18d$export$b7244afbfdf4cb9a, {
    target: "e8crcwv0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $KJVSo.grid).multiple(2.5).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $KJVSo.grid).multiple(2.5).px,
    opacity: 1
});

});
parcelRegister("3gJWY", function(module, exports) {
$parcel$export(module.exports, "itemHighlightColor", () => $61819da2622d2328$export$4ac85ff259fe4fce);
const $61819da2622d2328$export$4ac85ff259fe4fce = "var(--ds-background-neutral-subtle-hovered, #0515240F)";

});


parcelRegister("flXw7", function(module, exports) {
$parcel$export(module.exports, "ResultDetail", () => $222dcd3650c0d2af$export$b695f824f00c1cb0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $bHSLd = parcelRequire("bHSLd");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $222dcd3650c0d2af$export$b695f824f00c1cb0 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "euh103z0"
})((0, $3w6rz.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bHSLd.itemLinkSecondaryColor),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginLeft: (0, $KJVSo.grid).multiple(3).px,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $KJVSo.grid).multiple(19).px
});

});

parcelRegister("ffRJZ", function(module, exports) {
$parcel$export(module.exports, "ResultLabel", () => $fdb56819df8323d5$export$a999164f6ebc756c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $fdb56819df8323d5$export$a999164f6ebc756c = /*#__PURE__*/ (0, $lPAzw.default)("span", {
    target: "e1rd3aa10"
})((0, $3w6rz.nowrapEllipsis), {
    color: "var(--ds-text-subtle, #505258)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginRight: (0, $KJVSo.grid).px
});

});

parcelRegister("bFQAg", function(module, exports) {
$parcel$export(module.exports, "ResultTitleContainer", () => $934e5af957d3fde0$export$9c613d6c52df949a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $KJVSo = parcelRequire("KJVSo");

var $58xad = parcelRequire("58xad");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $934e5af957d3fde0$export$9c613d6c52df949a = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "eiapvw30"
})((0, $3w6rz.nowrapEllipsis), " width:", (props)=>props.isCollapsed ? 'initial' : (0, $KJVSo.grid).multiple(47).px, ";line-height:16px;flex:1 0 auto;color:", (0, $58xad.primaryTextColour), ";@media screen and (max-width: ", (0, $KJVSo.dialogPageTakeoverWidth), "px){width:100%;}");

});


parcelRegister("8frcs", function(module, exports) {
$parcel$export(module.exports, "SearchResultLink", () => $6fc0547b4af8bfc2$export$76cc11d043a1381);

var $4fqPo = parcelRequire("4fqPo");

var $6yB07 = parcelRequire("6yB07");

var $AY9jO = parcelRequire("AY9jO");
const $6fc0547b4af8bfc2$export$76cc11d043a1381 = ({ children: children, href: href, linkComponent: linkComponent, searchResultId: searchResultId, onSelect: onSelect, onHighlighted: onHighlighted, onContextMenu: onContextMenu, ...rest })=>{
    const { isKeyboardHighlighted: isKeyboardHighlighted, ref: ref } = (0, $AY9jO.useKeyboardHighlighting)({
        searchResultId: searchResultId,
        onHighlighted: onHighlighted
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ref: ref,
        onClick: onSelect,
        onContextMenu: onContextMenu,
        role: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6yB07.ResultLink), {
        linkComponent: linkComponent,
        href: href,
        ...rest
    }, children(isKeyboardHighlighted))));
};

});
parcelRegister("6yB07", function(module, exports) {
$parcel$export(module.exports, "ResultLink", () => $68f985aad11e74a0$export$d0a8235d2583609);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $58xad = parcelRequire("58xad");

var $lOemA = parcelRequire("lOemA");

var $ecEYy = parcelRequire("ecEYy");

var $lPAzw = parcelRequire("lPAzw");
const $68f985aad11e74a0$export$d0a8235d2583609 = /*#__PURE__*/ (0, $lPAzw.default)((0, $ecEYy.Link), {
    target: "e1xrnjlr0"
})({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    position: 'relative',
    textDecoration: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $58xad.primaryTextColour),
    '&:hover': {
        textDecoration: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $58xad.primaryTextColour)
    },
    '&:focus': {
        outlineOffset: '-2px'
    },
    '&:visited': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: (0, $58xad.primaryTextColour),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.SearchDialogResultTitle': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: (0, $lOemA.visitedLinkColor)
        }
    }
});

});
parcelRegister("lOemA", function(module, exports) {
$parcel$export(module.exports, "visitedLinkColor", () => $232cb8b05dd84be5$export$271fb8b1437b1d62);
const $232cb8b05dd84be5$export$271fb8b1437b1d62 = "var(--ds-link-visited, #803FA5)";

});

parcelRegister("ecEYy", function(module, exports) {
$parcel$export(module.exports, "Link", () => $13bb7cbb09fdebda$export$a6c7ac8248d6e38a);

var $4fqPo = parcelRequire("4fqPo");
const $13bb7cbb09fdebda$export$a6c7ac8248d6e38a = ({ linkComponent: linkComponent, ...props })=>{
    // Hack?
    const Component = linkComponent || 'a';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, props);
};

});


parcelRegister("AY9jO", function(module, exports) {
$parcel$export(module.exports, "useKeyboardHighlighting", () => $656b91d021578c10$export$9803d460130e453);

var $4fqPo = parcelRequire("4fqPo");

var $gdgUK = parcelRequire("gdgUK");
/**
 * Callback which simulates a click on the target element when the enter key
 * is pressed whilst the target element is active.
 *
 * @param e Event from key down
 * @param target Active element when key was pressed
 */ const $656b91d021578c10$var$onKeyDown = (e, target)=>{
    // Only navigate if Enter was pressed without any modifiers
    if (e.key === 'Enter' && !e.shiftKey && !e.metaKey && !e.ctrlKey) {
        e.preventDefault();
        // Find the deepest child element in the DOM
        let clickTarget = target;
        while(clickTarget.firstElementChild instanceof HTMLElement && (_clickTarget$firstEle = clickTarget.firstElementChild) !== null && _clickTarget$firstEle !== void 0 && _clickTarget$firstEle.click){
            var _clickTarget$firstEle;
            clickTarget = clickTarget.firstElementChild;
        }
        clickTarget.click();
    }
};
const $656b91d021578c10$export$9803d460130e453 = ({ searchResultId: searchResultId, onHighlighted: onHighlighted })=>{
    const [isKeyboardHighlighted, ref] = (0, $gdgUK.useKeyboardNavigation)({
        onKeydownCallback: $656b91d021578c10$var$onKeyDown,
        navigationTrackingId: searchResultId ?? null
    });
    // Ref for whether or not this search result was last highlighted
    const previousHighlight = (0, $4fqPo.useRef)(false);
    // Call the onHighlighted callback when this search result is highlighted
    (0, $4fqPo.useEffect)(()=>{
        if (!previousHighlight.current && isKeyboardHighlighted) onHighlighted === null || onHighlighted === void 0 || onHighlighted();
        previousHighlight.current = isKeyboardHighlighted;
    }, [
        isKeyboardHighlighted,
        previousHighlight,
        onHighlighted
    ]);
    return {
        isKeyboardHighlighted: isKeyboardHighlighted,
        ref: ref
    };
};

});


parcelRegister("f8dhv", function(module, exports) {
$parcel$export(module.exports, "EnlargedSearchResultContent", () => $a3f05f011f41bcd1$export$171a2a7e5a778acc);

var $4fqPo = parcelRequire("4fqPo");

var $fYL1j = parcelRequire("fYL1j");

var $dXh51 = parcelRequire("dXh51");

var $1l2CH = parcelRequire("1l2CH");

var $hCKuP = parcelRequire("hCKuP");

var $8yvxv = parcelRequire("8yvxv");

var $21P09 = parcelRequire("21P09");

var $dCS99 = parcelRequire("dCS99");

var $28Jjl = parcelRequire("28Jjl");

var $gRrc7 = parcelRequire("gRrc7");

var $dvwcK = parcelRequire("dvwcK");

var $eZNlp = parcelRequire("eZNlp");

var $4Ca67 = parcelRequire("4Ca67");

var $ffRJZ = parcelRequire("ffRJZ");

var $3URYE = parcelRequire("3URYE");
const $a3f05f011f41bcd1$export$171a2a7e5a778acc = ({ icon: icon, label: label, title: title, highlightedTitle: highlightedTitle, meta: meta, additionalMeta: additionalMeta, displayAdditionalMetaWhenHighlightedOnly: displayAdditionalMetaWhenHighlightedOnly, isCollapsed: isCollapsed, isKeyboardHighlighted: isKeyboardHighlighted, returnIcon: returnIcon = 'onHighlight', isRecentSearch: isRecentSearch, onRemove: onRemove })=>{
    const contentRef = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useRef(null);
    const [isHover, setIsHover] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const isActive = isKeyboardHighlighted || isHover;
    const showReturnIcon = (0, $4fqPo.useMemo)(()=>(returnIcon === 'always' || returnIcon === 'onHighlight' && isKeyboardHighlighted) && !isRecentSearch, [
        isKeyboardHighlighted,
        returnIcon,
        isRecentSearch
    ]);
    const showRemoveIcon = (0, $4fqPo.useMemo)(()=>isRecentSearch && isActive, [
        isRecentSearch,
        isActive
    ]);
    const showAdditionalMeta = (0, $4fqPo.useMemo)(()=>additionalMeta && (!displayAdditionalMetaWhenHighlightedOnly || isActive), [
        displayAdditionalMetaWhenHighlightedOnly,
        isActive,
        additionalMeta
    ]);
    (0, $4fqPo.useEffect)(()=>{
        var _contentRef$current;
        if (isKeyboardHighlighted && (_contentRef$current = contentRef.current) !== null && _contentRef$current !== void 0 && _contentRef$current.scrollIntoView) contentRef.current.scrollIntoView({
            behavior: 'auto',
            block: 'nearest'
        });
    }, [
        isKeyboardHighlighted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4Ca67.EnlargedResultContentWrapper), {
        ref: contentRef,
        isCollapsed: isCollapsed,
        isKeyboardHighlighted: isKeyboardHighlighted,
        onMouseEnter: ()=>setIsHover(true),
        onMouseLeave: ()=>setIsHover(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dvwcK.EnlargedIconContainer), null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dCS99.CollapsedResultContentWrapper), {
        "data-testid": "collapsed-result-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3URYE.EnlargedResultTitleContainer), {
        isCollapsed: true
    }, typeof title === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        title: title,
        className: "SearchDialogResultTitle"
    }, highlightedTitle ? (0, $8yvxv.enrichResultTitle)(highlightedTitle) : title)) : title, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ffRJZ.ResultLabel), {
        title: label
    }, label) : label), meta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gRrc7.EnlargedCollapsedResultDetailWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $28Jjl.EnlargedCollapsedResultDetail), null, meta))), showAdditionalMeta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eZNlp.EnlargedResultDetail), null, additionalMeta), showReturnIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4Ca67.EnlargedReturnIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dXh51.SquareReturnIcon), null)), showRemoveIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4Ca67.EnlargedReturnIconContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $21P09.default), {
        icon: (0, $fYL1j.RemoveIcon),
        spacing: 'compact',
        onClick: onRemove,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $1l2CH.messages).remove_button_label),
        appearance: 'subtle'
    })));
};

});
parcelRegister("fYL1j", function(module, exports) {
$parcel$export(module.exports, "RemoveIcon", () => $917c250ab2037a34$export$6382847193091a26);

var $4fqPo = parcelRequire("4fqPo");
const $917c250ab2037a34$export$6382847193091a26 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.185 7.4 12 10.585 8.815 7.399a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.7-.7a.496.496 0 0 0 .004-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.507.507 0 0 0-.36-.153.5.5 0 0 0-.353.15h-.001Z",
        fill: "var(--ds-icon, #292A2E)"
    }));

});

parcelRegister("dXh51", function(module, exports) {
$parcel$export(module.exports, "SquareReturnIcon", () => $bb2aa1ced4058637$export$4501fc029b186da8);

var $4fqPo = parcelRequire("4fqPo");
const $bb2aa1ced4058637$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("rect", {
        width: "20",
        height: "20",
        rx: "3",
        fill: "var(--ds-background-neutral, #0515240F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        fillRule: "nonzero",
        d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
        fill: "var(--ds-icon-subtle, #505258)"
    }));

});

parcelRegister("1l2CH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $354ba06cb61b80fd$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $354ba06cb61b80fd$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    remove_button_label: {
        id: 'search_dialog.results.remove_button_label',
        defaultMessage: 'Remove this.',
        description: 'Label of the button that has remove function and appearance.'
    }
});

});

parcelRegister("8yvxv", function(module, exports) {
$parcel$export(module.exports, "enrichResultTitle", () => $3f2d9fc26abc2e18$export$c43ff622b37ceaa9);

var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");
const $3f2d9fc26abc2e18$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $3f2d9fc26abc2e18$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $3f2d9fc26abc2e18$var$highlightRE = new RegExp(`${$3f2d9fc26abc2e18$var$HIGHLIGHT_START_TAG}(.*?)${$3f2d9fc26abc2e18$var$HIGHLIGHT_END_TAG}.*`);
const $3f2d9fc26abc2e18$var$openingTagRE = new RegExp(`(.*?)${$3f2d9fc26abc2e18$var$HIGHLIGHT_START_TAG}`);
const $3f2d9fc26abc2e18$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($3f2d9fc26abc2e18$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($3f2d9fc26abc2e18$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($3f2d9fc26abc2e18$var$highlightRE) || [];
        title = title.replace(`${$3f2d9fc26abc2e18$var$HIGHLIGHT_START_TAG}${highlightText}${$3f2d9fc26abc2e18$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};

});

parcelRegister("28Jjl", function(module, exports) {
$parcel$export(module.exports, "EnlargedCollapsedResultDetail", () => $65fa4a5259af9462$export$a44951d703db9a17);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bHSLd = parcelRequire("bHSLd");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $65fa4a5259af9462$export$a44951d703db9a17 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1a0jgbt0"
})((0, $3w6rz.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bHSLd.itemLinkSecondaryColor),
    maxWidth: "'initial'"
});

});

parcelRegister("gRrc7", function(module, exports) {
$parcel$export(module.exports, "EnlargedCollapsedResultDetailWrapper", () => $ed824627ed3aea43$export$2dfb537c5a7f8cc3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lPAzw = parcelRequire("lPAzw");
function $ed824627ed3aea43$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ed824627ed3aea43$export$2dfb537c5a7f8cc3 = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "e1ilyjzy0"
})({
    name: "uy5e1i",
    styles: "display:flex;width:90%"
});

});

parcelRegister("dvwcK", function(module, exports) {
$parcel$export(module.exports, "EnlargedIconContainer", () => $8792d4df3b20b1b0$export$ca5c00fa71c2e27e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lPAzw = parcelRequire("lPAzw");
const $8792d4df3b20b1b0$export$ca5c00fa71c2e27e = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "ej3qn9h0"
})({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    marginRight: "var(--ds-space-100, 8px)",
    flex: `0 0 ${"var(--ds-space-300, 24px)"}`,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("eZNlp", function(module, exports) {
$parcel$export(module.exports, "EnlargedResultDetail", () => $f10a4003c84a9f24$export$c8ec38cc79b76eaa);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $bHSLd = parcelRequire("bHSLd");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $f10a4003c84a9f24$export$c8ec38cc79b76eaa = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "ei2t34t0"
})((0, $3w6rz.nowrapEllipsis), {
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: (0, $bHSLd.itemLinkSecondaryColor),
    maxWidth: "'initial'",
    minWidth: 'fit-content',
    marginLeft: "var(--ds-space-150, 12px)"
});

});

parcelRegister("3URYE", function(module, exports) {
$parcel$export(module.exports, "EnlargedResultTitleContainer", () => $4fd0d9bb8f3e1ba9$export$e97ece467686c93c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $58xad = parcelRequire("58xad");

var $KJVSo = parcelRequire("KJVSo");

var $3w6rz = parcelRequire("3w6rz");

var $lPAzw = parcelRequire("lPAzw");
const $4fd0d9bb8f3e1ba9$export$e97ece467686c93c = /*#__PURE__*/ (0, $lPAzw.default)("div", {
    target: "efsee9j0"
})((0, $3w6rz.nowrapEllipsis), " line-height:14px;flex:1 0 auto;color:", (0, $58xad.primaryTextColour), ";height:16px;@media screen and (max-width: ", (0, $KJVSo.dialogPageTakeoverWidth), "px){width:100%;}width:90%;");

});



parcelRegister("lDENC", function(module, exports) {
$parcel$export(module.exports, "useArticleSearch", () => $82029798659cbdee$export$f4258d6b7c4900b8);

var $4fqPo = parcelRequire("4fqPo");
const $82029798659cbdee$var$MIN_INPUT_CHAR_LENGTH = 1;
const $82029798659cbdee$export$f4258d6b7c4900b8 = (searchResponse, queryWord)=>{
    var _searchResponse$helpO3;
    const entities = (0, $4fqPo.useMemo)(()=>{
        var _searchResponse$helpO;
        return (searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.edges) || [];
    }, [
        searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.helpObjectStore_searchArticlesForSupportSite
    ]);
    const hasQueryError = Boolean(entities.find((edge)=>{
        var _edge$node;
        return edge === null || edge === void 0 || (_edge$node = edge.node) === null || _edge$node === void 0 ? void 0 : _edge$node.message;
    }));
    const articlesAndFolders = (0, $4fqPo.useMemo)(()=>{
        var _searchResponse$helpO2;
        const edges = (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.edges;
        if (edges) {
            const resultItems = edges.map(({ node: node })=>{
                const { id: id, title: title, contentType: contentType, urlInfo: urlInfo } = node;
                if (id && title && contentType && urlInfo !== null && urlInfo !== void 0 && urlInfo.shareUrl) return {
                    id: id,
                    title: title,
                    type: contentType.toString(),
                    url: urlInfo.shareUrl
                };
                return null;
            }).filter((item)=>item !== null);
            return resultItems;
        }
        return undefined;
    }, [
        (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticlesForSupportSite) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.edges
    ]);
    if (queryWord.length < $82029798659cbdee$var$MIN_INPUT_CHAR_LENGTH) return {
        articlesAndFolders: undefined,
        hasQueryError: false
    };
    return {
        articlesAndFolders: articlesAndFolders,
        hasQueryError: hasQueryError
    };
};

});

parcelRegister("hFpr7", function(module, exports) {
$parcel$export(module.exports, "ContentType", () => $6c47f0b3ff5b1c86$export$e2e108cbe2e4f865);
var $6c47f0b3ff5b1c86$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["PAGE"] = "PAGE";
    ContentType["FOLDER"] = "FOLDER";
    return ContentType;
}({});

});

parcelRegister("k9u3H", function(module, exports) {
$parcel$export(module.exports, "SearchErrorImage", () => $25a42b49955c30e5$export$d689645a972509c2);

var $4fqPo = parcelRequire("4fqPo");
const $25a42b49955c30e5$export$d689645a972509c2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("svg", {
        width: "61",
        height: "82",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        fill: "var(--ds-surface, #FFFFFF)",
        fillOpacity: ".01",
        d: "M0 0h61v82H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        d: "M42.676 60.465 39.8 57.71l-3.867 3.956 2.874 2.755a5.347 5.347 0 0 1 1.492 2.58 5.348 5.348 0 0 0 1.492 2.582l11.66 11.176a4.484 4.484 0 0 0 6.294-.102 4.377 4.377 0 0 0-.102-6.232l-11.66-11.176a5.412 5.412 0 0 0-2.654-1.394 5.377 5.377 0 0 1-2.654-1.39z",
        fill: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        d: "M45.213 61.83a5.409 5.409 0 0 1-2.537-1.365l-.876-.839a2.804 2.804 0 0 0-3.934.062 2.737 2.737 0 0 0 .062 3.895l.876.838a5.334 5.334 0 0 1 1.46 2.461 23.389 23.389 0 0 0 4.95-5.053z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        d: "M23.633 69.38c-6.214.097-12.095-2.204-16.56-6.483-9.218-8.832-9.456-23.441-.536-32.567 4.323-4.42 10.126-6.91 16.34-7.009 6.215-.098 12.096 2.203 16.561 6.483 4.466 4.28 6.981 10.025 7.08 16.174.1 6.149-2.225 11.975-6.548 16.396-4.322 4.417-10.126 6.907-16.337 7.005zm-.667-40.563c-4.73.076-9.148 1.97-12.44 5.336-6.794 6.947-6.61 18.072.407 24.798 3.399 3.26 7.879 5.01 12.608 4.937 4.73-.077 9.148-1.971 12.44-5.336s5.06-7.8 4.983-12.483c-.077-4.682-1.991-9.056-5.39-12.316-3.398-3.26-7.875-5.012-12.608-4.936z",
        fill: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        d: "m31.78 40.93-2.384-2.317a1.04 1.04 0 0 0-1.466.015l-4.55 4.588-4.634-4.505a1.04 1.04 0 0 0-1.467.015l-2.339 2.36a1.016 1.016 0 0 0 .015 1.451l4.634 4.505-4.55 4.588a1.016 1.016 0 0 0 .015 1.452l2.383 2.316c.41.399 1.067.391 1.466-.015l4.55-4.588 4.635 4.505c.41.399 1.066.392 1.466-.015l2.34-2.36a1.016 1.016 0 0 0-.015-1.451l-4.638-4.505 4.55-4.588c.403-.403.4-1.053-.012-1.452zM26.075 10.073 22.555.156c-.08-.232-.421-.192-.45.05L20.967 9.82l-2.244-.262a.23.23 0 0 0-.246.305l3.52 9.917c.08.232.421.192.45-.051l1.137-9.612 2.244.261c.169.022.3-.145.246-.304zM14.999 16.374l-4.374-2.958c-.092-.062-.202.04-.147.134l2.405 4.185-.982.555a.1.1 0 0 0-.008.171l4.374 2.958c.092.062.202-.04.147-.134L14.01 17.1l.982-.556a.1.1 0 0 0 .008-.17z",
        fill: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("path", {
        d: "M30.804 21.245a.363.363 0 0 1-.36-.443c-.09-.196-.754-.599-1.158-.842-.909-.552-1.693-1.027-1.48-1.655.212-.632 1.128-.54 2.188-.44.429.044 1.122.11 1.379.04-.165-.21-.756-.566-1.126-.79-.91-.552-1.694-1.024-1.481-1.656.213-.631 1.13-.54 2.189-.439.429.043 1.118.109 1.378.04-.165-.21-.755-.566-1.125-.791-.91-.552-1.694-1.024-1.482-1.656.213-.627 1.13-.54 2.19-.439.469.044 1.242.12 1.436.018a.367.367 0 0 1 .451-.192c.191.065.297.269.231.461-.212.628-1.129.54-2.188.436-.43-.044-1.122-.11-1.379-.04.165.21.755.566 1.126.79.909.553 1.693 1.024 1.48 1.656-.212.628-1.128.54-2.188.44-.429-.044-1.122-.11-1.379-.04.165.21.756.566 1.126.79.91.552 1.694 1.024 1.481 1.656-.212.631-1.13.54-2.189.439-.429-.044-1.122-.109-1.378-.04.165.21.755.57 1.125.791.91.552 1.694 1.028 1.482 1.656a.368.368 0 0 1-.349.25zM35.996 23.104a.361.361 0 0 1-.32-.186c-.403-.704-.857-1.502-.373-1.953.488-.45 1.265.059 2.09.6.348.228.909.595 1.158.645-.033-.246-.366-.827-.572-1.186-.487-.85-.95-1.652-.462-2.106.488-.45 1.265.058 2.09.6.374.246.994.649 1.206.649h.004a.37.37 0 0 1 .491.04.356.356 0 0 1-.018.512c-.488.453-1.265-.058-2.09-.6-.348-.228-.91-.595-1.158-.645.033.247.366.827.572 1.187.487.849.95 1.651.462 2.105-.488.45-1.265-.058-2.09-.599-.349-.229-.91-.595-1.155-.646.033.247.366.831.484 1.034a.36.36 0 0 1-.14.494.299.299 0 0 1-.18.055zM8.971 24.537c-.029 0-.055 0-.084-.003-.663-.08-.766-.999-.876-1.968-.048-.41-.121-1.074-.242-1.292-.172.185-.407.81-.55 1.198-.345.918-.675 1.782-1.33 1.702-.665-.08-.767-.998-.88-1.967-.052-.443-.136-1.18-.272-1.336a.365.365 0 0 1-.286-.4.366.366 0 0 1 .407-.315c.663.08.766.998.88 1.971.047.41.12 1.074.245 1.292.173-.185.407-.81.55-1.198.345-.914.671-1.774 1.331-1.702.664.08.766.998.88 1.971.048.41.121 1.07.242 1.292.169-.185.407-.813.491-1.034a.369.369 0 0 1 .473-.214c.191.069.286.28.217.468-.286.719-.594 1.535-1.196 1.535z",
        fill: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("linearGradient", {
        id: "a",
        x1: "45.58",
        y1: "73.338",
        x2: "51.997",
        y2: "66.855",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("stop", {
        stopColor: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("stop", {
        offset: "1",
        stopColor: "var(--ds-icon-subtle, #505258)",
        stopOpacity: ".5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("linearGradient", {
        id: "b",
        x1: "6.803",
        y1: "62.638",
        x2: "39.376",
        y2: "29.737",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("stop", {
        offset: ".557",
        stopColor: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("stop", {
        offset: ".966",
        stopColor: "var(--ds-icon-subtle, #505258)",
        stopOpacity: ".5"
    }))));

});

parcelRegister("coo91", function(module, exports) {
$parcel$export(module.exports, "messages", () => $460cf1c244a36c4b$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $460cf1c244a36c4b$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.article-search-component.empty-title',
        defaultMessage: "We couldn\u2019t find a match for your search",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    emptyStateDescription: {
        id: 'company-hub.article-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    },
    errorTitle: {
        id: 'company-hub.article-search-component.error-title',
        defaultMessage: "We\u2019re having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the article search attempt.'
    },
    errorDescription: {
        id: 'company-hub.article-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the article search dialog to guide users when there is an error.'
    }
});

});


parcelRegister("kVo0D", function(module, exports) {
$parcel$export(module.exports, "SearchSkeletons", () => $924c63acc0268a5f$export$d660f580aff4b70c);

var $4fqPo = parcelRequire("4fqPo");

var $eOhzJ = parcelRequire("eOhzJ");
const $924c63acc0268a5f$export$d660f580aff4b70c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOhzJ.RowSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOhzJ.RowSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOhzJ.RowSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOhzJ.RowSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eOhzJ.RowSkeleton), null));
};

});
parcelRegister("eOhzJ", function(module, exports) {
$parcel$export(module.exports, "RowSkeleton", () => $20eb4295ad0c3d58$export$94071f5afde0c224);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");
const $20eb4295ad0c3d58$var$styles = {
    rowWithDescription: "_2rko1mok _1bsb1ns9 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _1e0c11p5 _gy1pu2gc _yv0e5bpd _1lmc1hhf _4cvr1h6o _4t3i12am",
    icon: "_nd5l2ec4 _2rkolb4i _bfhki8nm _1bsb1tcg _4t3i1tcg",
    title: "_nd5l1cy2 _2rkolb4i _bfhki8nm _1bsbgx0z _4t3idlk8",
    description: "_nd5ltgt2 _2rkolb4i _bfhki8nm _1bsb1w81 _4t3i19bv"
};
const $20eb4295ad0c3d58$export$94071f5afde0c224 = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $20eb4295ad0c3d58$var$styles.rowWithDescription
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $20eb4295ad0c3d58$var$styles.icon
    }), /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $20eb4295ad0c3d58$var$styles.title
    }), /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $20eb4295ad0c3d58$var$styles.description
    }));
};

});



parcelRegister("8gLvO", function(module, exports) {
$parcel$export(module.exports, "SearchTextField", () => $fad488665acd5569$export$fb8d8fbc0c4c1705);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $4MCQn = parcelRequire("4MCQn");
parcelRequire("cCRi0");
var $cUiEo = parcelRequire("cUiEo");
var $gOmBi = parcelRequire("gOmBi");

var $21P09 = parcelRequire("21P09");

var $9RW5e = parcelRequire("9RW5e");

var $8B6Ry = parcelRequire("8B6Ry");

var $7fscZ = parcelRequire("7fscZ");

var $bOOgP = parcelRequire("bOOgP");

var $kILS0 = parcelRequire("kILS0");
const $fad488665acd5569$var$cssOverrideWrapperStyles = null;
const $fad488665acd5569$var$styles = {
    wrapper: "_1bsb1kdj",
    searchIcon: "_1ul91ns9 _1tke1ns9 _18u0u2gc _1e0c1txw _1bah1h6o _4cvr1h6o",
    clearIcon: "_2hwxu2gc"
};
const $fad488665acd5569$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    var _routerState$location;
    const { isReadOnly: isReadOnly, onInput: onInput, placeholderText: placeholderText, queryWord: queryWord, searchBasePath: searchBasePath } = props;
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const { push: push } = (0, $gOmBi.useRouterActions)();
    const [routerState] = (0, $cUiEo.useRouter)();
    const handleChange = (e)=>{
        const value = e.currentTarget.value;
        onInput(value);
    };
    const handleKeyDown = (0, $4fqPo.useCallback)((e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            const currentPath = searchBasePath || routerState.location.pathname;
            const updatedPathIfHasMissingTrailingSlash = currentPath.endsWith('/') ? currentPath : `${currentPath}/`;
            push(`${updatedPathIfHasMissingTrailingSlash}articles/search?q=${encodeURIComponent(queryWord)}`);
        }
    }, [
        searchBasePath,
        routerState === null || routerState === void 0 || (_routerState$location = routerState.location) === null || _routerState$location === void 0 ? void 0 : _routerState$location.pathname,
        queryWord,
        push
    ]);
    const handleClear = ()=>{
        onInput('');
    };
    return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        ref: ref,
        xcss: $fad488665acd5569$var$styles.wrapper
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_dhd01mok _1227e4h9"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $bOOgP.default), {
        ref: props.keyboardRef,
        id: "article-search-query-input",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        isReadOnly: isReadOnly,
        placeholder: placeholderText ?? formatMessage((0, $kILS0.messages).defaultPlaceholder),
        value: queryWord,
        elemBeforeInput: /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
            xcss: $fad488665acd5569$var$styles.searchIcon
        }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })),
        elemAfterInput: queryWord && /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
            xcss: $fad488665acd5569$var$styles.clearIcon
        }, /*#__PURE__*/ $4fqPo.createElement((0, $21P09.default), {
            icon: (iconProps)=>/*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
                    ...iconProps,
                    color: "currentColor",
                    label: ""
                }),
            spacing: "compact",
            onClick: handleClear,
            label: "",
            appearance: "subtle"
        }))
    })));
});

});
parcelRegister("cCRi0", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("cUiEo")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("gOmBi")).useRouterActions);

parcelRequire("48Eg4");
var $cUiEo = parcelRequire("cUiEo");
var $gOmBi = parcelRequire("gOmBi");
parcelRequire("QRvLg");
var $vd1hv = parcelRequire("vd1hv");
var $b5ujc = parcelRequire("b5ujc");
parcelRequire("k3mJj");
var $7DRU8 = parcelRequire("7DRU8");
var $2hDlC = parcelRequire("2hDlC");
var $cIkwP = parcelRequire("cIkwP");
var $k3mJj = parcelRequire("k3mJj");

var $cLx2F = parcelRequire("cLx2F");

var $2NEyP = parcelRequire("2NEyP");

var $felzS = parcelRequire("felzS");
parcelRequire("etaM6");
var $17aSH = parcelRequire("17aSH");
var $5xA8U = parcelRequire("5xA8U");
var $cTbc8 = parcelRequire("cTbc8");

});
parcelRegister("48Eg4", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("cUiEo")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("gOmBi")).useRouterActions);

var $esMRq = parcelRequire("esMRq");

var $3nldj = parcelRequire("3nldj");

var $js3ka = parcelRequire("js3ka");

var $7ue0W = parcelRequire("7ue0W");

var $2NEyP = parcelRequire("2NEyP");

var $ab5Zz = parcelRequire("ab5Zz");

var $8djNg = parcelRequire("8djNg");

var $cUiEo = parcelRequire("cUiEo");

var $gOmBi = parcelRequire("gOmBi");

var $i7DWU = parcelRequire("i7DWU");

});
parcelRegister("esMRq", function(module, exports) {

var $ichJ5 = parcelRequire("ichJ5");

var $6YQ3e = parcelRequire("6YQ3e");

var $g2zI4 = parcelRequire("g2zI4");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("k3mJj");
var $dSotS = parcelRequire("dSotS");

var $cUiEo = parcelRequire("cUiEo");
class $a87994f370843dd5$var$Redirector extends (0, $4fqPo.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $g2zI4.createPath)((0, $dSotS.generateLocationFromPath)(to.path, routeAttributes)) : (0, $g2zI4.createPath)(to) : to;
        const currentPath = (0, $g2zI4.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $6YQ3e.default)($a87994f370843dd5$var$Redirector, "defaultProps", {
    push: false
});
const $a87994f370843dd5$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $cUiEo.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($a87994f370843dd5$var$Redirector, (0, $ichJ5.default)({
        actions: actions,
        location: location
    }, props));
};

});
parcelRegister("k3mJj", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("dSotS")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("cIkwP")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("kH43u")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("1P9Ei")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("2hDlC")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("2hDlC")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("8hxmS")).isSameRouteMatch);

var $7DRU8 = parcelRequire("7DRU8");

var $dSotS = parcelRequire("dSotS");

var $cIkwP = parcelRequire("cIkwP");

var $kH43u = parcelRequire("kH43u");

var $1P9Ei = parcelRequire("1P9Ei");

var $2hDlC = parcelRequire("2hDlC");

var $8hxmS = parcelRequire("8hxmS");

});
parcelRegister("7DRU8", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $5905fd331ef7fb02$export$883c3f3b6c000133);

var $ichJ5 = parcelRequire("ichJ5");

var $g2zI4 = parcelRequire("g2zI4");

var $9ptG5 = parcelRequire("9ptG5");

var $8y4Rw = parcelRequire("8y4Rw");
const $5905fd331ef7fb02$var$hasWindow = ()=>typeof window !== 'undefined';
const $5905fd331ef7fb02$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw)))
};
const $5905fd331ef7fb02$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $5905fd331ef7fb02$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $5905fd331ef7fb02$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($9ptG5)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $5905fd331ef7fb02$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $5905fd331ef7fb02$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $5905fd331ef7fb02$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $ichJ5.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $5905fd331ef7fb02$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $5905fd331ef7fb02$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $g2zI4.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $g2zI4.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $5905fd331ef7fb02$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
        createHref: (location)=>(0, $g2zI4.createPath)(location)
    } : $5905fd331ef7fb02$var$methodsPlaceholders);
};

});

parcelRegister("dSotS", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $a1a34ee498fe704e$export$37e0729cc751960b);

var $6qbdp = parcelRequire("6qbdp");

var $2Q7mc = parcelRequire("2Q7mc");
function $a1a34ee498fe704e$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $2Q7mc.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6qbdp.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("6qbdp", function(module, exports) {
$parcel$export(module.exports, "compile", () => $4acddee709d7ee94$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $4acddee709d7ee94$export$71304158c7e35877);
/**
 * Tokenize input string.
 */ function $4acddee709d7ee94$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $4acddee709d7ee94$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $4acddee709d7ee94$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($4acddee709d7ee94$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($4acddee709d7ee94$var$escapeString(prevText), ")[^").concat($4acddee709d7ee94$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $4acddee709d7ee94$export$ef7acd7185315e22(str, options) {
    return $4acddee709d7ee94$export$5b9bad9e403cf3d9($4acddee709d7ee94$export$98e6a39c04603d36(str, options), options);
}
function $4acddee709d7ee94$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $4acddee709d7ee94$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $4acddee709d7ee94$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $4acddee709d7ee94$export$71304158c7e35877(str, keys, options);
    return $4acddee709d7ee94$export$968e97c88708237a(re, keys, options);
}
function $4acddee709d7ee94$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $4acddee709d7ee94$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $4acddee709d7ee94$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $4acddee709d7ee94$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $4acddee709d7ee94$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $4acddee709d7ee94$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $4acddee709d7ee94$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $4acddee709d7ee94$var$stringToRegexp(path, keys, options) {
    return $4acddee709d7ee94$export$9a9303716def6456($4acddee709d7ee94$export$98e6a39c04603d36(path, options), keys, options);
}
function $4acddee709d7ee94$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($4acddee709d7ee94$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($4acddee709d7ee94$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $4acddee709d7ee94$var$escapeString(encode(token));
        else {
            var prefix = $4acddee709d7ee94$var$escapeString(encode(token.prefix));
            var suffix = $4acddee709d7ee94$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $4acddee709d7ee94$var$flags(options));
}
function $4acddee709d7ee94$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $4acddee709d7ee94$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $4acddee709d7ee94$var$arrayToRegexp(path, keys, options);
    return $4acddee709d7ee94$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("cIkwP", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $941984a2c50bbd3d$export$82476f982757e71e);

var $6qbdp = parcelRequire("6qbdp");
const $941984a2c50bbd3d$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6qbdp.compile)(pattern)(params);

});

parcelRegister("kH43u", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $f10af814e0ec94b0$export$455cc18296abe008);
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3TFEq = parcelRequire("3TFEq");
const $f10af814e0ec94b0$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $f10af814e0ec94b0$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3TFEq !== 'undefined' && $3TFEq.versions != null && $3TFEq.versions.node != null) return true;
    if ($f10af814e0ec94b0$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("1P9Ei", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $154209f0baa3e2b2$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $154209f0baa3e2b2$export$2e2bcd8739ae039);

var $2Q7mc = parcelRequire("2Q7mc");

var $ibbm7 = parcelRequire("ibbm7");

var $itFlO = parcelRequire("itFlO");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $154209f0baa3e2b2$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $2Q7mc.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $itFlO.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $ibbm7.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $itFlO.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $154209f0baa3e2b2$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$154209f0baa3e2b2$var$matchRoute(routes, pathname, queryParams, basePath);
const $154209f0baa3e2b2$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $154209f0baa3e2b2$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $154209f0baa3e2b2$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$154209f0baa3e2b2$var$matchRoute(routes, pathname, queryParams, basePath);

});
parcelRegister("ibbm7", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3c210145ab129e7$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");

var $fkhb5 = parcelRequire("fkhb5");

var $i3iMA = parcelRequire("i3iMA");
/* This should match what react-router does to compute a root match. */ const $d3c210145ab129e7$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $d3c210145ab129e7$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $fkhb5.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $d3c210145ab129e7$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $i3iMA.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $ichJ5.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $d3c210145ab129e7$export$2e2bcd8739ae039 = $d3c210145ab129e7$var$execRouteMatching;

});
parcelRegister("fkhb5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2860c6f0677ce97$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6qbdp = parcelRequire("6qbdp");
const $b2860c6f0677ce97$var$cache = {};
const $b2860c6f0677ce97$var$cacheLimit = 10000;
let $b2860c6f0677ce97$var$cacheCount = 0;
function $b2860c6f0677ce97$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $b2860c6f0677ce97$var$cache[cacheKey] || ($b2860c6f0677ce97$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6qbdp.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($b2860c6f0677ce97$var$cacheCount < $b2860c6f0677ce97$var$cacheLimit) {
        pathCache[path] = result;
        $b2860c6f0677ce97$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $b2860c6f0677ce97$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $b2860c6f0677ce97$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $b2860c6f0677ce97$export$2e2bcd8739ae039 = $b2860c6f0677ce97$var$matchPath;

});

parcelRegister("i3iMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $d24713a01cee9c0c$export$2e2bcd8739ae039);

var $ichJ5 = parcelRequire("ichJ5");
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $d24713a01cee9c0c$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $ichJ5.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $d24713a01cee9c0c$export$2e2bcd8739ae039 = $d24713a01cee9c0c$var$matchQuery;

});


parcelRegister("itFlO", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $0378b198272981bb$export$f594abf16a5ad948);
const $0378b198272981bb$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $0378b198272981bb$var$MAX_CACHE_SIZE = 1000;
function $0378b198272981bb$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$0378b198272981bb$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $0378b198272981bb$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($0378b198272981bb$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $0378b198272981bb$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $0378b198272981bb$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("2hDlC", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $1a9bb0e9cf91c2c1$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $1a9bb0e9cf91c2c1$export$a0bd0313cbeabd49);

var $2Q7mc = parcelRequire("2Q7mc");

var $felzS = parcelRequire("felzS");

var $cIkwP = parcelRequire("cIkwP");

var $1P9Ei = parcelRequire("1P9Ei");
const $1a9bb0e9cf91c2c1$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $cIkwP.generatePath)(route.path, params);
    const matchedRoute = (0, $1P9Ei.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $felzS.DEFAULT_MATCH),
        query: query
    };
};
const $1a9bb0e9cf91c2c1$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $2Q7mc.qs).parse(search);
    const matchedRoute = (0, $1P9Ei.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $felzS.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $felzS.DEFAULT_MATCH)
    };
};

});
parcelRegister("felzS", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $b168e6b2f1c246af$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $b168e6b2f1c246af$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $b168e6b2f1c246af$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $b168e6b2f1c246af$export$fa440ddf675c8a93);

var $8y4Rw = parcelRequire("8y4Rw");

var $7DRU8 = parcelRequire("7DRU8");
const $b168e6b2f1c246af$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $b168e6b2f1c246af$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $b168e6b2f1c246af$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $b168e6b2f1c246af$export$39607c9878cf5148 = (0, $7DRU8.createLegacyHistory)();
const $b168e6b2f1c246af$export$1515254c8c90bebb = {
    location: $b168e6b2f1c246af$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($8y4Rw)))
};
const $b168e6b2f1c246af$export$fa440ddf675c8a93 = 'POP';

});


parcelRegister("8hxmS", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $6079cb74f37a881a$export$5997e70fc4543270);
const $6079cb74f37a881a$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $6079cb74f37a881a$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $6079cb74f37a881a$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $6079cb74f37a881a$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});


parcelRegister("cUiEo", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $96592e9aa77a7799$export$9a302a45f65d0572);

var $2NEyP = parcelRequire("2NEyP");
const $96592e9aa77a7799$export$9a302a45f65d0572 = (0, $2NEyP.useRouterStore);

});
parcelRegister("2NEyP", function(module, exports) {
$parcel$export(module.exports, "RouterStore", () => $209f9ee50857229b$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $209f9ee50857229b$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $209f9ee50857229b$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $209f9ee50857229b$export$ada49399abf7a3a1);

var $ichJ5 = parcelRequire("ichJ5");

var $g2zI4 = parcelRequire("g2zI4");

var $3Rlvb = parcelRequire("3Rlvb");
var $iouul = parcelRequire("iouul");
var $4CywU = parcelRequire("4CywU");
var $2RDzF = parcelRequire("2RDzF");
var $7luw1 = parcelRequire("7luw1");

var $felzS = parcelRequire("felzS");
parcelRequire("k3mJj");
var $2hDlC = parcelRequire("2hDlC");
var $dSotS = parcelRequire("dSotS");
var $cIkwP = parcelRequire("cIkwP");
var $kH43u = parcelRequire("kH43u");
var $1P9Ei = parcelRequire("1P9Ei");

var $cJtkl = parcelRequire("cJtkl");
const $209f9ee50857229b$export$36d128238e6b60f5 = {
    action: (0, $felzS.DEFAULT_ACTION),
    basePath: '',
    location: (0, $felzS.DEFAULT_HISTORY).location,
    history: (0, $felzS.DEFAULT_HISTORY),
    match: (0, $felzS.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $felzS.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $209f9ee50857229b$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $2hDlC.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $ichJ5.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $kH43u.isServerEnvironment)()) dispatch($209f9ee50857229b$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $2hDlC.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $cJtkl.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $3Rlvb.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $ichJ5.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $cJtkl.isExternalAbsolutePath)(path)) window.location.assign(path);
            else history.push((0, $cJtkl.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $dSotS.generateLocationFromPath)(route.path, (0, $ichJ5.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $1P9Ei.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $cJtkl.isExternalAbsolutePath)(path)) window.location.replace(path);
            else history.replace((0, $cJtkl.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $dSotS.generateLocationFromPath)(route.path, (0, $ichJ5.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $1P9Ei.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $ichJ5.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $cJtkl.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $cJtkl.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $ichJ5.default)({}, existingPathParams, params);
            const updatedPath = (0, $cIkwP.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $ichJ5.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $cJtkl.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $cJtkl.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $209f9ee50857229b$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $cJtkl.isExternalAbsolutePath)(path)) {
                const location = (0, $g2zI4.parsePath)((0, $cJtkl.getRelativePath)(path, basePath));
                nextContext = (0, $2hDlC.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $3Rlvb.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $209f9ee50857229b$export$1cf0ecab63b1963c = (0, $2RDzF.createStore)({
    initialState: $209f9ee50857229b$export$36d128238e6b60f5,
    actions: $209f9ee50857229b$var$actions,
    name: 'router'
});
const $209f9ee50857229b$export$d6b817abe7a77ea5 = (0, $4CywU.createContainer)($209f9ee50857229b$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($209f9ee50857229b$var$actions.bootstrapStore(props));
            !(0, $kH43u.isServerEnvironment)() && dispatch($209f9ee50857229b$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $kH43u.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $209f9ee50857229b$export$9569010eab09ae9e = (0, $iouul.createHook)($209f9ee50857229b$export$1cf0ecab63b1963c);
const $209f9ee50857229b$export$ada49399abf7a3a1 = (0, $iouul.createActionsHook)($209f9ee50857229b$export$1cf0ecab63b1963c);
function $209f9ee50857229b$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $iouul.createHook)($209f9ee50857229b$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $209f9ee50857229b$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $7luw1.defaultRegistry).getStore($209f9ee50857229b$export$1cf0ecab63b1963c);
const $209f9ee50857229b$export$ebf37f7e180b13a9 = ()=>$209f9ee50857229b$export$5ccad187366c8494().storeState.getState();

});
parcelRegister("cJtkl", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $94506fc6b8bd7050$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $94506fc6b8bd7050$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $94506fc6b8bd7050$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $94506fc6b8bd7050$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $94506fc6b8bd7050$export$c9237620ff7fdf7c);

var $2Q7mc = parcelRequire("2Q7mc");
parcelRequire("k3mJj");
var $8hxmS = parcelRequire("8hxmS");
const $94506fc6b8bd7050$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $94506fc6b8bd7050$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $94506fc6b8bd7050$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $94506fc6b8bd7050$var$stripTrailingSlash(prefix);
        prefix = $94506fc6b8bd7050$var$addLeadingSlash(prefix);
        path = $94506fc6b8bd7050$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $94506fc6b8bd7050$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $94506fc6b8bd7050$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$94506fc6b8bd7050$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($2Q7mc)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($2Q7mc)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $94506fc6b8bd7050$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$94506fc6b8bd7050$export$e83e3719fc818ee5(path)) {
        path = $94506fc6b8bd7050$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($2Q7mc)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $94506fc6b8bd7050$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $2Q7mc.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $94506fc6b8bd7050$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $94506fc6b8bd7050$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $8hxmS.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});




parcelRegister("3nldj", function(module, exports) {

var $ichJ5 = parcelRequire("ichJ5");

var $g2zI4 = parcelRequire("g2zI4");

var $4fqPo = parcelRequire("4fqPo");

var $2NEyP = parcelRequire("2NEyP");
const $2753f9b0323d12ff$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2NEyP.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $2753f9b0323d12ff$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $4fqPo.useMemo)(()=>(0, $g2zI4.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($2753f9b0323d12ff$export$55185c17a0fcbe46, (0, $ichJ5.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("js3ka", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $gOmBi = parcelRequire("gOmBi");
const $e29335fc1d3e0feb$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $gOmBi.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(actions));
};
$e29335fc1d3e0feb$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("gOmBi", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $c3d2d8d63ed2bd72$export$402e82ff1b20594b);

var $2NEyP = parcelRequire("2NEyP");
const $c3d2d8d63ed2bd72$export$402e82ff1b20594b = (0, $2NEyP.useRouterStoreActions);

});


parcelRegister("7ue0W", function(module, exports) {

var $gMtYT = parcelRequire("gMtYT");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("k3mJj");
var $kH43u = parcelRequire("kH43u");

var $2NEyP = parcelRequire("2NEyP");
const $573634afca1a858a$var$_excluded = [
    "listen"
];
const $573634afca1a858a$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $2NEyP.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $gMtYT.default)(_ref, $573634afca1a858a$var$_excluded);
    if (!state.unlisten && !(0, $kH43u.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(state, actions));
};

});

parcelRegister("ab5Zz", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $iouul = parcelRequire("iouul");

var $2NEyP = parcelRequire("2NEyP");
const $768f945bb9d89fe4$var$createPathParamHook = (0, $iouul.createHook)((0, $2NEyP.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $768f945bb9d89fe4$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $768f945bb9d89fe4$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $4fqPo.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("8djNg", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $iouul = parcelRequire("iouul");

var $2NEyP = parcelRequire("2NEyP");
const $5faee43bf3cf6de8$var$createQueryParamHook = (0, $iouul.createHook)((0, $2NEyP.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $5faee43bf3cf6de8$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $5faee43bf3cf6de8$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $4fqPo.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("i7DWU", function(module, exports) {

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");

var $2NEyP = parcelRequire("2NEyP");
const $d317de87de5eb617$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $d317de87de5eb617$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $d317de87de5eb617$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $2NEyP.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, (0, $ichJ5.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});


parcelRegister("QRvLg", function(module, exports) {

var $b5ujc = parcelRequire("b5ujc");

var $vd1hv = parcelRequire("vd1hv");

});
parcelRegister("b5ujc", function(module, exports) {

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");

var $g2zI4 = parcelRequire("g2zI4");

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("k3mJj");
var $2hDlC = parcelRequire("2hDlC");
var $dSotS = parcelRequire("dSotS");

var $2NEyP = parcelRequire("2NEyP");

var $lGZoj = parcelRequire("lGZoj");
parcelRequire("kNvaX");
var $aVWMu = parcelRequire("aVWMu");
var $5mWnt = parcelRequire("5mWnt");
const $8127ac053411e290$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $8127ac053411e290$var$PREFETCH_DELAY = 225;
const $8127ac053411e290$var$Link = /*#__PURE__*/ (0, $4fqPo.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $gMtYT.default)(_ref, $8127ac053411e290$var$_excluded);
    const routerActions = (0, $2NEyP.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $lGZoj.useTimeout)($8127ac053411e290$var$PREFETCH_DELAY);
    const validLinkType = (0, $aVWMu.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $4fqPo.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $g2zI4.createPath)((0, $dSotS.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const IS_ABSOLUTE_LINK_REGEX = /^((?:(http|https):\/\/)|\/\/)/;
    const staticBasePath = href != null && !IS_ABSOLUTE_LINK_REGEX.test(href) || typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $4fqPo.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $2hDlC.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $5mWnt.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $4fqPo.createElement)(validLinkType, (0, $ichJ5.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$8127ac053411e290$var$Link.displayName = 'Link';
var $8127ac053411e290$export$2e2bcd8739ae039 = $8127ac053411e290$var$Link;

});
parcelRegister("lGZoj", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $fcad243cdcd34ddf$export$d8e6abf214c9ec0f);

var $4fqPo = parcelRequire("4fqPo");
const $fcad243cdcd34ddf$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $4fqPo.useRef)();
    const schedule = (0, $4fqPo.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $4fqPo.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("kNvaX", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => (parcelRequire("aVWMu")).getValidLinkType);
$parcel$export(module.exports, "handleNavigation", () => (parcelRequire("5mWnt")).handleNavigation);

var $aVWMu = parcelRequire("aVWMu");

var $5mWnt = parcelRequire("5mWnt");

});
parcelRegister("aVWMu", function(module, exports) {
$parcel$export(module.exports, "getValidLinkType", () => $7f5cd2f2dc65679a$export$855ece989b15eb57);
const $7f5cd2f2dc65679a$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $7f5cd2f2dc65679a$export$855ece989b15eb57 = (type)=>$7f5cd2f2dc65679a$var$VALID_LINK_TYPES.includes(type) ? type : 'a';

});

parcelRegister("5mWnt", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $3e8c4a640690789c$export$706ad1af8096e280);

var $2CAs5 = parcelRequire("2CAs5");
const $3e8c4a640690789c$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $2CAs5.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $2CAs5.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $2CAs5.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("2CAs5", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $1e8b6802df8556f8$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $1e8b6802df8556f8$export$130b789831072f4c);
const $1e8b6802df8556f8$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $1e8b6802df8556f8$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});




parcelRegister("vd1hv", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("48Eg4");
var $cUiEo = parcelRequire("cUiEo");
const $05dcfeccb6ab77fc$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $cUiEo.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});


parcelRegister("cLx2F", function(module, exports) {
parcelRequire("k3mJj");
var $2hDlC = parcelRequire("2hDlC");
const $94b3814172bd0d54$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $2hDlC.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("etaM6", function(module, exports) {

var $letZq = parcelRequire("letZq");

var $5xA8U = parcelRequire("5xA8U");

var $cTbc8 = parcelRequire("cTbc8");

var $eQpPC = parcelRequire("eQpPC");

var $17aSH = parcelRequire("17aSH");

var $letZq = parcelRequire("letZq");

var $lssst = parcelRequire("lssst");

});
parcelRegister("letZq", function(module, exports) {

var $17aSH = parcelRequire("17aSH");
parcelRequire("0134l");
var $3eGbH = parcelRequire("3eGbH");
const $f7522b1ee04caacb$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $f7522b1ee04caacb$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $17aSH.getResourceStore)().actions;
    const nextResources = (0, $3eGbH.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $f7522b1ee04caacb$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $17aSH.getResourceStore)().actions;
    const nextResources = (0, $3eGbH.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $f7522b1ee04caacb$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $17aSH.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $f7522b1ee04caacb$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $f7522b1ee04caacb$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $f7522b1ee04caacb$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $17aSH.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $17aSH.getResourceStore)().actions;
            const nextResources = (0, $3eGbH.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $17aSH.getResourceStore)().actions.getSafeData();
        }
    };
};

});
parcelRegister("17aSH", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $0cfee2b075c3bc3f$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $0cfee2b075c3bc3f$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $0cfee2b075c3bc3f$export$98e41a62c9bef75e);

var $ichJ5 = parcelRequire("ichJ5");

var $gMtYT = parcelRequire("gMtYT");

var $iouul = parcelRequire("iouul");
var $4CywU = parcelRequire("4CywU");
var $2RDzF = parcelRequire("2RDzF");
var $3y3sY = parcelRequire("3y3sY");
var $7luw1 = parcelRequire("7luw1");
parcelRequire("k3mJj");
var $kH43u = parcelRequire("kH43u");

var $7cXOW = parcelRequire("7cXOW");
parcelRequire("0134l");
var $8VQlT = parcelRequire("8VQlT");
var $kjVpX = parcelRequire("kjVpX");
var $hGHQJ = parcelRequire("hGHQJ");
var $ig2kM = parcelRequire("ig2kM");
var $6u8J4 = parcelRequire("6u8J4");
var $hgIib = parcelRequire("hgIib");
var $luVgj = parcelRequire("luVgj");
var $57JSd = parcelRequire("57JSd");
var $1u2Mj = parcelRequire("1u2Mj");
var $5P33M = parcelRequire("5P33M");
var $bAQqq = parcelRequire("bAQqq");
var $3aMei = parcelRequire("3aMei");
const $0cfee2b075c3bc3f$var$_excluded = [
    "context"
], $0cfee2b075c3bc3f$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $0cfee2b075c3bc3f$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $hGHQJ.deleteResourceState)(type, key));
                dispatch((0, $8VQlT.executeForDependents)(resource, (dependentResource)=>$0cfee2b075c3bc3f$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $hGHQJ.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $gMtYT.default)(_getState, $0cfee2b075c3bc3f$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $7cXOW.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $ichJ5.default)({}, prevSlice, changes, {
                expiresAt: (0, $luVgj.getExpiresAt)(maxAge),
                accessedAt: (0, $6u8J4.getAccessedAt)()
            });
            dispatch((0, $hGHQJ.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $8VQlT.executeForDependents)(resource, (dependentResource)=>$0cfee2b075c3bc3f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $hGHQJ.getResourceState)(type, key));
            if (cached && (0, $57JSd.shouldUseCache)(cached)) {
                if ((0, $57JSd.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $1u2Mj.setSsrDataPromise)(cached);
                    cached = (0, $luVgj.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $6u8J4.getAccessedAt)();
                dispatch((0, $hGHQJ.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($0cfee2b075c3bc3f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $hGHQJ.getResourceState)(type, key)) || (0, $hgIib.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $3aMei.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $hGHQJ.getPrefetchSlice)(type, key)) || (0, $kjVpX.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8VQlT.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $hGHQJ.setResourceState)(type, key, (0, $ichJ5.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $6u8J4.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $8VQlT.executeForDependents)(resource, (dependentResource)=>$0cfee2b075c3bc3f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $5P33M.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $hGHQJ.getResourceState)(type, key));
            const finalSlice = (0, $ichJ5.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $6u8J4.getAccessedAt)(),
                expiresAt: (0, $luVgj.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $hGHQJ.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $hGHQJ.getPrefetchSlice)(type, key)) || (0, $kjVpX.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8VQlT.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $hGHQJ.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $8VQlT.executeForDependents)(resource, (dependentResource)=>$0cfee2b075c3bc3f$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $0cfee2b075c3bc3f$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $8VQlT.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $0cfee2b075c3bc3f$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $8VQlT.actionWithDependencies)(routerStoreContext.route.resources, resource, $0cfee2b075c3bc3f$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $8VQlT.actionWithDependencies)(routerStoreContext.route.resources, resource, $0cfee2b075c3bc3f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $8VQlT.actionWithDependencies)(routerStoreContext.route.resources, resource, $0cfee2b075c3bc3f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($0cfee2b075c3bc3f$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $hGHQJ.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $hGHQJ.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $kH43u.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $8VQlT.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$0cfee2b075c3bc3f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $8VQlT.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$0cfee2b075c3bc3f$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $ichJ5.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $bAQqq.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $gMtYT.default)(_ref, $0cfee2b075c3bc3f$var$_excluded2);
                const deserializedError = !error ? null : (0, $ig2kM.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $ichJ5.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $bAQqq.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $ig2kM.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $5P33M.TimeoutError) ? loading : false
                }))
};
const $0cfee2b075c3bc3f$export$94f50dade551bd01 = (0, $2RDzF.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $0cfee2b075c3bc3f$export$e324594224ef24da,
    name: 'router-resources'
});
const $0cfee2b075c3bc3f$export$cc90fb9c37c5589d = (0, $4CywU.createContainer)($0cfee2b075c3bc3f$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $0cfee2b075c3bc3f$export$fee1a6213543bd78 = (0, $3y3sY.createSubscriber)($0cfee2b075c3bc3f$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $7cXOW.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $0cfee2b075c3bc3f$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $7luw1.defaultRegistry).getStore($0cfee2b075c3bc3f$export$94f50dade551bd01);
const $0cfee2b075c3bc3f$export$ac3608e0bb357c7 = (0, $iouul.createHook)($0cfee2b075c3bc3f$export$94f50dade551bd01, {
    selector: (0, $7cXOW.getSliceForResource)
});
const $0cfee2b075c3bc3f$export$98e41a62c9bef75e = (0, $iouul.createActionsHook)($0cfee2b075c3bc3f$export$94f50dade551bd01);
const $0cfee2b075c3bc3f$export$e59f52df235ac7b3 = (0, $iouul.createHook)($0cfee2b075c3bc3f$export$94f50dade551bd01, {
    selector: (0, $7cXOW.getResourceStoreContext)
});

});
parcelRegister("7cXOW", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $53f80e80735b5813$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $53f80e80735b5813$export$6a0b1779210de0ee);

var $ichJ5 = parcelRequire("ichJ5");
parcelRequire("0134l");
var $hgIib = parcelRequire("hgIib");
const $53f80e80735b5813$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $ichJ5.default)({}, slice) : (0, $hgIib.getDefaultStateSlice)();
};
const $53f80e80735b5813$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("0134l", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("6u8J4")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("kjVpX")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("8VQlT")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("8VQlT")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("8VQlT")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("8VQlT")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("luVgj")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("luVgj")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("hgIib")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("3eGbH")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("3aMei")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("hGHQJ")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("hGHQJ")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("hGHQJ")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("hGHQJ")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("hGHQJ")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("ig2kM")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("ig2kM")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("57JSd")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("57JSd")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("1u2Mj")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("5P33M")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("bAQqq")).transformData);

var $6u8J4 = parcelRequire("6u8J4");

var $kjVpX = parcelRequire("kjVpX");

var $aqsBm = parcelRequire("aqsBm");

var $8VQlT = parcelRequire("8VQlT");

var $luVgj = parcelRequire("luVgj");

var $1uTJX = parcelRequire("1uTJX");

var $hgIib = parcelRequire("hgIib");

var $bATWJ = parcelRequire("bATWJ");

var $3eGbH = parcelRequire("3eGbH");

var $3aMei = parcelRequire("3aMei");

var $hGHQJ = parcelRequire("hGHQJ");

var $hr4pj = parcelRequire("hr4pj");

var $ig2kM = parcelRequire("ig2kM");

var $57JSd = parcelRequire("57JSd");

var $1u2Mj = parcelRequire("1u2Mj");

var $5P33M = parcelRequire("5P33M");

var $bAQqq = parcelRequire("bAQqq");

});
parcelRegister("6u8J4", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $4b8c50303fcca837$export$9ccb639b7a119f61);
const $4b8c50303fcca837$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("kjVpX", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $ecb21eefd9c12370$export$dc62515c8f0b52dd);

var $ichJ5 = parcelRequire("ichJ5");

var $4nFEO = parcelRequire("4nFEO");

var $luVgj = parcelRequire("luVgj");

var $1uTJX = parcelRequire("1uTJX");

var $5P33M = parcelRequire("5P33M");

var $8oZfj = parcelRequire("8oZfj");
function $ecb21eefd9c12370$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $ichJ5.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $1uTJX.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $5P33M.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $luVgj.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $4nFEO.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $luVgj.getExpiresAt)((0, $8oZfj.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("4nFEO", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_CACHE_MAX_LIMIT", () => $33099fabb687f49b$export$881d135f98d8d7d0);
$parcel$export(module.exports, "DEFAULT_RESOURCE_BROWSER_ONLY", () => $33099fabb687f49b$export$9ab5bdcb8a1d6c34);
$parcel$export(module.exports, "DEFAULT_RESOURCE_MAX_AGE", () => $33099fabb687f49b$export$12c1dc38ea1692da);
const $33099fabb687f49b$export$881d135f98d8d7d0 = 100;
const $33099fabb687f49b$export$9ab5bdcb8a1d6c34 = false;
const $33099fabb687f49b$export$12c1dc38ea1692da = 0;

});

parcelRegister("luVgj", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $fa68d15e0220bfe9$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $fa68d15e0220bfe9$export$18d1d420fd588368);

var $ichJ5 = parcelRequire("ichJ5");
const $fa68d15e0220bfe9$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $fa68d15e0220bfe9$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $ichJ5.default)({}, slice, {
        expiresAt: $fa68d15e0220bfe9$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;

});

parcelRegister("1uTJX", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $1173d4a6e24db976$export$58634b3a58ae66b7);
const $1173d4a6e24db976$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("5P33M", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $43d416cc7e2311e4$export$66d311bf29d5c89c);
class $43d416cc7e2311e4$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}

});

parcelRegister("8oZfj", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $61e012cfdc7bcccf$export$37d3126be6549b13);
const $61e012cfdc7bcccf$export$37d3126be6549b13 = 10000;

});


parcelRegister("aqsBm", function(module, exports) {

var $4nFEO = parcelRequire("4nFEO");
/**
 * Utility method to created async versions of getData functions
 */ const $797284c6b29f30a1$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $797284c6b29f30a1$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $797284c6b29f30a1$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $4nFEO.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $4nFEO.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $4nFEO.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("8VQlT", function(module, exports) {
$parcel$export(module.exports, "actionWithDependencies", () => $680c41a2c6d1b0c3$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $680c41a2c6d1b0c3$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $680c41a2c6d1b0c3$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $680c41a2c6d1b0c3$export$75915f81f2a6540a);

var $ichJ5 = parcelRequire("ichJ5");

var $hgIib = parcelRequire("hgIib");

var $hGHQJ = parcelRequire("hGHQJ");
var $680c41a2c6d1b0c3$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $680c41a2c6d1b0c3$var$fromEntries = ($680c41a2c6d1b0c3$var$_Object$fromEntries = Object.fromEntries) != null ? $680c41a2c6d1b0c3$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $680c41a2c6d1b0c3$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $680c41a2c6d1b0c3$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $680c41a2c6d1b0c3$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($680c41a2c6d1b0c3$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($680c41a2c6d1b0c3$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($680c41a2c6d1b0c3$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $680c41a2c6d1b0c3$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($680c41a2c6d1b0c3$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $680c41a2c6d1b0c3$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$680c41a2c6d1b0c3$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $680c41a2c6d1b0c3$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($680c41a2c6d1b0c3$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $680c41a2c6d1b0c3$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($680c41a2c6d1b0c3$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $680c41a2c6d1b0c3$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($680c41a2c6d1b0c3$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $680c41a2c6d1b0c3$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $680c41a2c6d1b0c3$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $680c41a2c6d1b0c3$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $hGHQJ.getResourceState)(dependencyType, key)) || (0, $hgIib.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $hGHQJ.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $ichJ5.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("hgIib", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $c92649ce7aa09fff$export$fa8e33c3301e2e94);

var $ichJ5 = parcelRequire("ichJ5");

var $6u8J4 = parcelRequire("6u8J4");

var $4nFEO = parcelRequire("4nFEO");

var $luVgj = parcelRequire("luVgj");

var $nAPUW = parcelRequire("nAPUW");
const $c92649ce7aa09fff$export$fa8e33c3301e2e94 = ()=>(0, $ichJ5.default)({}, (0, $nAPUW.BASE_DEFAULT_STATE_SLICE), {
        expiresAt: (0, $luVgj.getExpiresAt)((0, $4nFEO.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $6u8J4.getAccessedAt)()
    });

});
parcelRegister("nAPUW", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $046eb908d2cb4b21$export$2df85a734ff5ed27);
/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $046eb908d2cb4b21$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});


parcelRegister("hGHQJ", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $ce085f808e9de6c2$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $ce085f808e9de6c2$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $ce085f808e9de6c2$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $ce085f808e9de6c2$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $ce085f808e9de6c2$export$d40f35dc5952864b);

var $gMtYT = parcelRequire("gMtYT");

var $ichJ5 = parcelRequire("ichJ5");
function $ce085f808e9de6c2$var$_toPropertyKey(t) {
    var i = $ce085f808e9de6c2$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $ce085f808e9de6c2$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ce085f808e9de6c2$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $ce085f808e9de6c2$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $ichJ5.default)({}, prefetching, {
                [type]: (0, $ichJ5.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $ce085f808e9de6c2$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($ce085f808e9de6c2$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $ichJ5.default)({}, data, {
                [type]: (0, $ichJ5.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $ce085f808e9de6c2$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $ce085f808e9de6c2$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $gMtYT.default)(data, [
            type
        ].map($ce085f808e9de6c2$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $gMtYT.default)(resourceForType, [
                key
            ].map($ce085f808e9de6c2$var$_toPropertyKey));
            setState({
                data: (0, $ichJ5.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };

});


parcelRegister("bATWJ", function(module, exports) {
$parcel$export(module.exports, "getResourceIdentifier", () => $870e7441fe6260ad$export$c616b176adf9ad4a);
$parcel$export(module.exports, "getResourceIdentifiers", () => $870e7441fe6260ad$export$cd7fbe7e979df558);
const $870e7441fe6260ad$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $870e7441fe6260ad$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$870e7441fe6260ad$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));

});

parcelRegister("3eGbH", function(module, exports) {
$parcel$export(module.exports, "getResourcesForNextLocation", () => $25b3677e9733048f$export$7cbbc763e2f3d65d);

var $bATWJ = parcelRequire("bATWJ");

var $hr4pj = parcelRequire("hr4pj");
const $25b3677e9733048f$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $hr4pj.routeHasResources)(nextRoute)) return [];
    if ((0, $hr4pj.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $bATWJ.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $bATWJ.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};

});
parcelRegister("hr4pj", function(module, exports) {
$parcel$export(module.exports, "routeHasResources", () => $cb186077f819f172$export$740886389191c640);
$parcel$export(module.exports, "routeHasChanged", () => $cb186077f819f172$export$221027ff1aa38f82);
const $cb186077f819f172$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $cb186077f819f172$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;

});


parcelRegister("3aMei", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $24f7b7a858fe4591$export$89440b7623c2c75c);

var $hGHQJ = parcelRequire("hGHQJ");
const $24f7b7a858fe4591$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $24f7b7a858fe4591$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $24f7b7a858fe4591$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $24f7b7a858fe4591$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $24f7b7a858fe4591$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $hGHQJ.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("ig2kM", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $d4ab8828ac71f0f0$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $d4ab8828ac71f0f0$export$64cddc1e268e9046);
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $d4ab8828ac71f0f0$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $d4ab8828ac71f0f0$var$NonError);
    }
}
const $d4ab8828ac71f0f0$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $d4ab8828ac71f0f0$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $d4ab8828ac71f0f0$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $d4ab8828ac71f0f0$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $d4ab8828ac71f0f0$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $d4ab8828ac71f0f0$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $d4ab8828ac71f0f0$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $d4ab8828ac71f0f0$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $d4ab8828ac71f0f0$var$NonError(value);
};

});

parcelRegister("57JSd", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $3bb130b8a22ce9f1$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $3bb130b8a22ce9f1$export$399de8c43d0ece3c);
const $3bb130b8a22ce9f1$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $3bb130b8a22ce9f1$var$isFresh = (resource)=>{
    if ($3bb130b8a22ce9f1$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $3bb130b8a22ce9f1$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($3bb130b8a22ce9f1$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("1u2Mj", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $114abf789cbf0c1c$export$2e4da1b414980956);

var $ichJ5 = parcelRequire("ichJ5");
const $114abf789cbf0c1c$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $ichJ5.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;

});

parcelRegister("bAQqq", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $870bb90bfe2e4dfe$export$3ceb62baab058c6b);
const $870bb90bfe2e4dfe$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});





parcelRegister("5xA8U", function(module, exports) {

var $4fqPo = parcelRequire("4fqPo");

var $cTbc8 = parcelRequire("cTbc8");
const $408c11fd16a3c545$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $cTbc8.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, children(result));
};

});
parcelRegister("cTbc8", function(module, exports) {
$parcel$export(module.exports, "useResource", () => $96234e24a3cf521e$export$9f6abfd74295843b);

var $ichJ5 = parcelRequire("ichJ5");

var $4fqPo = parcelRequire("4fqPo");

var $iouul = parcelRequire("iouul");

var $2NEyP = parcelRequire("2NEyP");

var $17aSH = parcelRequire("17aSH");
const $96234e24a3cf521e$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $17aSH.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $2NEyP.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $4fqPo.useMemo)(()=>(0, $iouul.createHook)((0, $2NEyP.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $17aSH.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $4fqPo.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $4fqPo.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $4fqPo.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $4fqPo.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $4fqPo.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $ichJ5.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};

});


parcelRegister("eQpPC", function(module, exports) {

var $17aSH = parcelRequire("17aSH");
const $ace9f59b3ce47aae$export$dee7bf9fc0ff48c3 = (fn)=>(0, $17aSH.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("lssst", function(module, exports) {
const $f9f249b07be98e88$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});



parcelRegister("kILS0", function(module, exports) {
$parcel$export(module.exports, "messages", () => $641e27fa82d31fbe$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $641e27fa82d31fbe$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    defaultPlaceholder: {
        id: 'company-hub.article-search-component.placeholder',
        defaultMessage: 'Search for help',
        description: 'Default placeholder text for the article search input.'
    }
});

});



parcelRegister("76TjZ", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchComponent", () => $c971133ce9da9bac$export$8fa6497fb1b229b0);

var $4fqPo = parcelRequire("4fqPo");

var $lMcEJ = parcelRequire("lMcEJ");

var $3H4LK = parcelRequire("3H4LK");
parcelRequire("6hIdA");
var $13Iqs = parcelRequire("13Iqs");

var $7fscZ = parcelRequire("7fscZ");

var $iySE3 = parcelRequire("iySE3");

var $gdgUK = parcelRequire("gdgUK");

var $8gLvO = parcelRequire("8gLvO");

var $cVBev = parcelRequire("cVBev");
const $c971133ce9da9bac$export$8fa6497fb1b229b0 = ({ isEditor: isEditor, placeholderText: placeholderText })=>{
    var _inputBoxRef$current;
    const [queryWord, setQueryWord] = (0, $4fqPo.useState)('');
    const [showDropdown, setShowDropdown] = (0, $4fqPo.useState)(false);
    const inputBoxRef = (0, $4fqPo.useRef)(null);
    const inputRef = (0, $4fqPo.useRef)(null);
    const [_, setInputWidth] = (0, $4fqPo.useState)((_inputBoxRef$current = inputBoxRef.current) === null || _inputBoxRef$current === void 0 ? void 0 : _inputBoxRef$current.offsetWidth);
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri, relativeBaseUrl: relativeBaseUrl } } = (0, $iySE3.useHubContext)();
    if (!helpCenterAri || !cloudId) throw new Error('Help center Ari and cloud ID are required');
    const shouldUseFixedSearchLink = (0, $3H4LK.fg)('enable_fix_help_center_search_link');
    (0, $4fqPo.useEffect)(()=>{
        const listener = ()=>{
            var _inputBoxRef$current2;
            return setInputWidth((_inputBoxRef$current2 = inputBoxRef.current) === null || _inputBoxRef$current2 === void 0 ? void 0 : _inputBoxRef$current2.offsetWidth);
        };
        const unbind = (0, $lMcEJ.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = ()=>{
        if (showDropdown) setShowDropdown(false);
    };
    const trigger = (0, $4fqPo.useCallback)((triggerProps)=>{
        const handleInput = (searchInput)=>{
            setQueryWord(searchInput);
            setShowDropdown(searchInput.trim().length > 0);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
            ref: inputBoxRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8gLvO.SearchTextField), {
            keyboardRef: inputRef,
            ...triggerProps,
            ref: triggerProps.ref,
            onInput: handleInput,
            isReadOnly: isEditor,
            placeholderText: placeholderText,
            showDropdown: showDropdown,
            queryWord: queryWord,
            searchBasePath: shouldUseFixedSearchLink ? relativeBaseUrl || undefined : undefined
        }));
    }, [
        isEditor,
        placeholderText,
        queryWord,
        relativeBaseUrl,
        shouldUseFixedSearchLink,
        showDropdown
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $13Iqs.Popup), {
        shouldReturnFocus: false,
        content: (contentProps)=>{
            var _inputBoxRef$current3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gdgUK.KeyboardHighlightProvider), {
                listenerNode: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cVBev.HelpObjectSearchDropdown), {
                ...contentProps,
                cloudId: cloudId,
                helpCenterAri: helpCenterAri || '',
                inputWidth: ((_inputBoxRef$current3 = inputBoxRef.current) === null || _inputBoxRef$current3 === void 0 ? void 0 : _inputBoxRef$current3.offsetWidth) || 0,
                queryWord: queryWord
            }));
        },
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};

});
parcelRegister("cVBev", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchDropdown", () => $15274b8b2e452258$export$99781ab3c09b5cc0);

var $4fqPo = parcelRequire("4fqPo");

var $4TjJp = parcelRequire("4TjJp");

var $kVo0D = parcelRequire("kVo0D");

var $iKtC4 = parcelRequire("iKtC4");
const $15274b8b2e452258$export$99781ab3c09b5cc0 = ({ inputWidth: inputWidth, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4TjJp.SearchDialog), {
        /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ style: {
            boxShadow: 'none',
            width: inputWidth
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kVo0D.SearchSkeletons), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iKtC4.HelpObjectSearchResults), props)));
};

});
parcelRegister("iKtC4", function(module, exports) {
$parcel$export(module.exports, "HelpObjectSearchResults", () => $3adead1838775b2a$export$4d1c12e2349aa7cc);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $8e2IE = parcelRequire("8e2IE");

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $hCKuP = parcelRequire("hCKuP");
var $4MCQn = parcelRequire("4MCQn");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $bdubZ = parcelRequire("bdubZ");

var $2eKV2 = parcelRequire("2eKV2");

var $1sKlv = parcelRequire("1sKlv");

var $17RcU = parcelRequire("17RcU");

var $4nUcM = parcelRequire("4nUcM");
var $7fscZ = parcelRequire("7fscZ");
var $5E02Z = parcelRequire("5E02Z");

var $fxR5Y = parcelRequire("fxR5Y");

var $8p7Jg = parcelRequire("8p7Jg");

var $ANezt = parcelRequire("ANezt");

var $k9u3H = parcelRequire("k9u3H");

var $dsdSe = parcelRequire("dsdSe");
const $3adead1838775b2a$var$DEFAULT_RESULTS_LIMIT = 3;
const $3adead1838775b2a$var$ExternalLinkComponent = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ href: href = '#', ...props }, ref)=>/*#__PURE__*/ $4fqPo.createElement((0, $4nUcM.default), {
        ref: ref,
        href: href,
        ...props,
        target: "_blank",
        xcss: $3adead1838775b2a$var$styles.externalLink,
        rel: "noopener noreferrer"
    }));
const $3adead1838775b2a$var$InternalLinkComponent = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ href: href = '#', children: children, ...props }, ref)=>/*#__PURE__*/ $4fqPo.createElement((0, $bdubZ.default), {
        ref: ref,
        to: href,
        ...props
    }, children));
const $3adead1838775b2a$export$4d1c12e2349aa7cc = ({ cloudId: cloudId, helpCenterAri: helpCenterAri, queryWord: queryWord })=>{
    var _searchResponse$helpO3, _searchResponse$helpO4;
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    /* eslint-disable @atlassian/relay/unused-fields */ const searchResponse = (0, $gIeP2.useLazyLoadQuery)((0, $8e2IE.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri,
        queryTerm: queryWord,
        limit: $3adead1838775b2a$var$DEFAULT_RESULTS_LIMIT
    });
    /* eslint-enable @atlassian/relay/unused-fields */ const articles = (0, $4fqPo.useMemo)(()=>{
        var _searchResponse$helpO;
        const results = searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO = searchResponse.helpObjectStore_searchArticles) === null || _searchResponse$helpO === void 0 ? void 0 : _searchResponse$helpO.results;
        if (!results) return [];
        return results.map((result)=>{
            var _result$metadata;
            return {
                ari: result.ari,
                title: result.title,
                url: result.displayLink,
                type: 'ARTICLE',
                isExternal: (_result$metadata = result.metadata) === null || _result$metadata === void 0 ? void 0 : _result$metadata.isExternal
            };
        });
    }, [
        searchResponse
    ]);
    const requestTypes = (0, $4fqPo.useMemo)(()=>{
        var _searchResponse$helpO2;
        const results = searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO2 = searchResponse.helpObjectStore_searchRequestTypes) === null || _searchResponse$helpO2 === void 0 ? void 0 : _searchResponse$helpO2.results;
        if (!results) return [];
        return results.map((result)=>({
                id: result.id,
                title: result.title,
                url: result.displayLink,
                iconUrl: result.iconUrl,
                type: 'REQUEST_TYPE'
            }));
    }, [
        searchResponse
    ]);
    const hasArticlesError = Boolean(searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO3 = searchResponse.helpObjectStore_searchArticles) === null || _searchResponse$helpO3 === void 0 ? void 0 : _searchResponse$helpO3.message);
    const hasRequestTypesError = Boolean(searchResponse === null || searchResponse === void 0 || (_searchResponse$helpO4 = searchResponse.helpObjectStore_searchRequestTypes) === null || _searchResponse$helpO4 === void 0 ? void 0 : _searchResponse$helpO4.message);
    const hasBothErrors = hasArticlesError && hasRequestTypesError;
    const allResults = (0, $4fqPo.useMemo)(()=>{
        return [
            ...articles,
            ...requestTypes
        ];
    }, [
        articles,
        requestTypes
    ]);
    const showEmptyState = allResults.length === 0;
    const showResolvedState = allResults.length > 0;
    return /*#__PURE__*/ $4fqPo.createElement((0, $4fqPo.Fragment), null, showEmptyState && /*#__PURE__*/ $4fqPo.createElement((0, $fxR5Y.EmptyState), {
        title: hasBothErrors ? formatMessage((0, $dsdSe.messages).errorTitle) : formatMessage((0, $dsdSe.messages).emptyStateTitle),
        Image: (0, $k9u3H.SearchErrorImage),
        content: hasBothErrors ? /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $dsdSe.messages).errorDescription) : /*#__PURE__*/ $4fqPo.createElement((0, $hCKuP.default), (0, $dsdSe.messages).emptyStateDescription)
    }), showResolvedState && /*#__PURE__*/ $4fqPo.createElement((0, $8p7Jg.SearchDialogContent), null, /*#__PURE__*/ $4fqPo.createElement((0, $5E02Z.default), {
        xcss: $3adead1838775b2a$var$styles.stackContainer
    }, articles.length > 0 && /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $3adead1838775b2a$var$styles.sectionHeading
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $dsdSe.messages).resourcesHeading))), /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, articles.map((result)=>/*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
            xcss: $3adead1838775b2a$var$styles.searchResultContainer,
            key: result.ari
        }, /*#__PURE__*/ $4fqPo.createElement((0, $ANezt.SearchResult), {
            href: result.url,
            linkComponent: result.isExternal ? $3adead1838775b2a$var$ExternalLinkComponent : $3adead1838775b2a$var$InternalLinkComponent,
            title: result.title,
            isCollapsed: true,
            icon: /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($17RcU))), {
                label: "",
                spacing: "spacious",
                color: "var(--ds-text-subtle, #505258)"
            })
        }))))), requestTypes.length > 0 && /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $3adead1838775b2a$var$styles.sectionHeading
    }, /*#__PURE__*/ $4fqPo.createElement((0, $2eKV2.default), {
        as: "h3",
        size: "xsmall"
    }, formatMessage((0, $dsdSe.messages).requestFormsHeading))), /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, requestTypes.map((result)=>/*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
            xcss: $3adead1838775b2a$var$styles.searchResultContainer,
            key: result.id
        }, /*#__PURE__*/ $4fqPo.createElement((0, $ANezt.SearchResult), {
            linkComponent: $3adead1838775b2a$var$InternalLinkComponent,
            href: result.url,
            title: result.title,
            isCollapsed: true,
            icon: result.iconUrl ? /*#__PURE__*/ $4fqPo.createElement("img", {
                src: result.iconUrl,
                alt: "",
                className: (0, $ltgDR.default)([
                    $3adead1838775b2a$var$styles.icon
                ])
            }) : /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1sKlv))), {
                label: "",
                spacing: "spacious"
            })
        }))))))));
};
const $3adead1838775b2a$var$styles = {
    externalLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1ydc1r31 _1x28glyw _1726nqa1 _9oik1r31 _1bnxglyw _jf4cnqa1",
    icon: "_1bsb1tcg _4t3i1tcg _5ral1f51",
    stackContainer: "_1bsb1osq _n3tdpxbi",
    searchResultContainer: "_19bv1b66 _u5f31b66",
    sectionHeading: "_ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvv47k"
};

});
parcelRegister("8e2IE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6dd846a182202066$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a472b9a3cd02453ab24d020b467a2f18>>
 * @relayHash 4f9e1fc12763ea436c7785c11780ff3c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e
const $6dd846a182202066$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryTerm"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v6 = {
        "kind": "Variable",
        "name": "limit",
        "variableName": "limit"
    }, v7 = {
        "kind": "Variable",
        "name": "queryTerm",
        "variableName": "queryTerm"
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "highlight",
            "value": false
        },
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayLink"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreArticleSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "concreteType": "HelpObjectStoreArticleMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isExternal"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreArticleSearchResults"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "HelpObjectStoreSearchError"
    }, v13 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    }
                ]
            }
        ],
        "type": "HelpObjectStoreRequestTypeSearchResults"
    }, v15 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpObjectSearchResultsQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpObjectSearchResultsQuery",
            "selections": [
                {
                    "args": v8 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchArticles",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "helpObjectStore_searchRequestTypes",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "22d74b35331ccd017c3ac7fdd5f5d4bf2a7c5d16d649afd374497eb56f2df43e",
            "metadata": {},
            "name": "helpObjectSearchResultsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6dd846a182202066$var$node.hash = "6a19867fd32836b788744dc62a5ce984";
var $6dd846a182202066$export$2e2bcd8739ae039 = $6dd846a182202066$var$node;

});

parcelRegister("dsdSe", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e926ae811fc122a0$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $e926ae811fc122a0$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    emptyStateTitle: {
        id: 'company-hub.help-object-search-component.empty-title',
        defaultMessage: "We couldn't find a match for your search",
        description: 'Text displayed in the dialog when no results are found during the search.'
    },
    emptyStateDescription: {
        id: 'company-hub.help-object-search-component.empty-description',
        defaultMessage: 'Check for typos, or try another search term.',
        description: 'Text displayed in the search dialog to guide users when there are no results.'
    },
    errorTitle: {
        id: 'company-hub.help-object-search-component.error-title',
        defaultMessage: "We're having trouble getting your results.",
        description: 'Text displayed in the dialog when an error occurs during the search.'
    },
    errorDescription: {
        id: 'company-hub.help-object-search-component.error-description',
        defaultMessage: 'Try again later',
        description: 'Text displayed in the search dialog to guide users when there is an error.'
    },
    resourcesHeading: {
        id: 'company-hub.help-object-search-component.resources-heading',
        defaultMessage: 'Resources',
        description: 'Heading for the resources section in search results.'
    },
    requestFormsHeading: {
        id: 'company-hub.help-object-search-component.request-forms-heading',
        defaultMessage: 'Request forms',
        description: 'Heading for the request forms section in search results.'
    }
});

});




parcelRegister("cKHhL", function(module, exports) {
$parcel$export(module.exports, "JSM_HELP_EXTENSION_TYPE", () => $54babd44b0591384$export$62b7ac1cc8a8f8d7);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_KEY", () => $54babd44b0591384$export$b5a30704f903627a);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE", () => $54babd44b0591384$export$5eecea5c34e4d0ec);
$parcel$export(module.exports, "JSM_HELP_EXTENSION_VERSION_1", () => $54babd44b0591384$export$42fa33c628980eca);
$parcel$export(module.exports, "PAGE_SIZE", () => $54babd44b0591384$export$8ec3d08588d2eeda);
$parcel$export(module.exports, "SourceType", () => $54babd44b0591384$export$d95e7684b6658cc2);
const $54babd44b0591384$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $54babd44b0591384$export$b5a30704f903627a = 'jsm-help';
const $54babd44b0591384$export$727d928d273126f1 = 'jsmHelpExtension';
const $54babd44b0591384$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $54babd44b0591384$export$42fa33c628980eca = '1.0.0';
const $54babd44b0591384$export$8ec3d08588d2eeda = 9;
const $54babd44b0591384$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $54babd44b0591384$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};

});

parcelRegister("a2UhU", function(module, exports) {
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_KEY", () => $53f9cc05027ee056$export$5eb13835d9fc35c6);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_TYPE", () => $53f9cc05027ee056$export$1e0076557b3776e7);
$parcel$export(module.exports, "CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE", () => $53f9cc05027ee056$export$bbe74ef6b7213123);
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $53f9cc05027ee056$export$5eb13835d9fc35c6 = 'page-topper';
const $53f9cc05027ee056$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $53f9cc05027ee056$export$bbe74ef6b7213123 = 'calloutBannerExtension';

});

parcelRegister("4YzcL", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("hYHnZ"),
    $e46AW("66iV5"),
    $e46AW("3hhaI"),
    $e46AW("knZyM"),
    $e46AW("9djLA"),
    $e46AW("4xkV0"),
    $e46AW("eUxjk"),
    $e46AW("dO151"),
    $e46AW("i7uBA"),
    $e46AW("dbgJo"),
    $e46AW("iy4dy"),
    $e46AW("4sq4d"),
    $e46AW("duMxJ"),
    $e46AW("9d6FU"),
    $e46AW("2EPEd"),
    $e46AW("bvOcx"),
    $e46AW("8iz8o")
]).then(()=>parcelRequire('bQjAi'));

});

parcelRegister("luVIL", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("eVQxw"),
    $e46AW("66iV5"),
    $e46AW("3hhaI"),
    $e46AW("4xkV0"),
    $e46AW("dbgJo"),
    $e46AW("iy4dy"),
    $e46AW("4sq4d"),
    $e46AW("duMxJ"),
    $e46AW("958rd"),
    $e46AW("9d6FU"),
    $e46AW("2EPEd"),
    $e46AW("45caK"),
    $e46AW("bvOcx"),
    $e46AW("1vWgA"),
    $e46AW("kg6mo")
]).then(()=>parcelRequire('iNc4H'));

});

parcelRegister("8m7MA", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("dWrcJ"),
    $e46AW("dDxCA"),
    $e46AW("66iV5"),
    $e46AW("3hhaI"),
    $e46AW("knZyM"),
    $e46AW("4xkV0"),
    $e46AW("eUxjk"),
    $e46AW("ejayw"),
    $e46AW("k0hRS"),
    $e46AW("i7uBA"),
    $e46AW("dbgJo"),
    $e46AW("iy4dy"),
    $e46AW("4sq4d"),
    $e46AW("duMxJ"),
    $e46AW("958rd"),
    $e46AW("9d6FU"),
    $e46AW("2EPEd"),
    $e46AW("45caK"),
    $e46AW("4biYi"),
    $e46AW("bvOcx"),
    $e46AW("c0hLJ"),
    $e46AW("fTe6X"),
    $e46AW("2PHdy"),
    $e46AW("6s4xH"),
    $e46AW("6c2jD")
]).then(()=>parcelRequire('2GTPO'));

});


parcelRegister("7PTaH", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgentRenderer", () => $6350057fe076fbd0$export$93c28c6c94b1d8af);

var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $7B16F = parcelRequire("7B16F");
var $qe1mk = parcelRequire("qe1mk");
var $47wMl = parcelRequire("47wMl");
const $6350057fe076fbd0$export$93c28c6c94b1d8af = ()=>{
    const aiWidgetConfig = (0, $47wMl.useOptionalAiWidgetConfig)();
    const supportWidgetConfig = aiWidgetConfig === null || aiWidgetConfig === void 0 ? void 0 : aiWidgetConfig.supportWidgetConfig;
    const isSSR = typeof window !== 'undefined' && !!window.__SSR_RENDERED__;
    const showCornerAgent = Boolean(!isSSR && supportWidgetConfig && supportWidgetConfig.isEnabled && (0, $qe1mk.handleWidgetPosition)(supportWidgetConfig.widgetPosition) === 'CORNER');
    return showCornerAgent ? /*#__PURE__*/ (0, $lhXNe.jsx)((0, $7B16F.AiCornerAgentWithContext), {}) : null;
};

});
parcelRegister("7B16F", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerWithContext", () => $e0881533087a6772$export$ee4cebdd26cd9fad);
$parcel$export(module.exports, "AiSearchTriggerFloatingWithContext", () => $e0881533087a6772$export$48844b0016715530);
$parcel$export(module.exports, "AiCornerAgentWithContext", () => $e0881533087a6772$export$53048ab92eeb2224);

var $4fqPo = parcelRequire("4fqPo");

var $47wMl = parcelRequire("47wMl");

var $fVjMM = parcelRequire("fVjMM");

var $hdJUV = parcelRequire("hdJUV");
const $e0881533087a6772$export$ee4cebdd26cd9fad = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $47wMl.useAiWidgetConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hdJUV.AiSearchTrigger), {
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $e0881533087a6772$export$48844b0016715530 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $47wMl.useAiWidgetConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hdJUV.AiSearchTriggerFloating), {
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId,
        widgetTheme: supportWidgetConfig.widgetTheme
    });
};
const $e0881533087a6772$export$53048ab92eeb2224 = ()=>{
    const { supportWidgetConfig: supportWidgetConfig } = (0, $47wMl.useAiWidgetConfig)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fVjMM.AiCornerAgent), {
        site: supportWidgetConfig.site,
        siteId: supportWidgetConfig.siteId,
        widgetId: supportWidgetConfig.widgetId
    });
};

});
parcelRegister("fVjMM", function(module, exports) {
$parcel$export(module.exports, "AiCornerAgent", () => $02ad5eb925a48bb1$export$df8fdfe108711d3f);

var $4fqPo = parcelRequire("4fqPo");

var $7cAgJ = parcelRequire("7cAgJ");
const $02ad5eb925a48bb1$export$df8fdfe108711d3f = ({ site: site, siteId: siteId, widgetId: widgetId })=>{
    (0, $4fqPo.useEffect)(()=>{
        (0, $7cAgJ.initCSM)({
            site: site,
            siteId: siteId,
            widgetId: widgetId
        });
    }, [
        site,
        siteId,
        widgetId
    ]);
    return null;
};

});
parcelRegister("7cAgJ", function(module, exports) {
$parcel$export(module.exports, "initCSM", () => $28238f69697862df$export$a161b0281c42400f);

var $2vWb1 = parcelRequire("2vWb1");

var $34x7m = parcelRequire("34x7m");

var $dPjSm = parcelRequire("dPjSm");
const $28238f69697862df$var$belowDialog = (0, $2vWb1.layers).dialog() - 1;
const $28238f69697862df$export$a161b0281c42400f = ({ site: siteProp, siteId: siteId, widgetId: widgetId })=>{
    let site = siteProp ?? (typeof window !== 'undefined' && window.location.hostname);
    if (!site) return;
    if (site === 'localhost') // if in development and window.location.hostname === 'localhost'
    // we set it to the testing instance's site url. Change if using different one than the one below
    site = 'support-ccp.jira-dev.com';
    (0, $dPjSm.CSM)({
        site: site,
        siteId: siteId,
        widgetId: widgetId
    });
    // Ensures the widget does not render on top of dialogs (e.g., search).
    (0, $34x7m.update)({
        zIndex: $28238f69697862df$var$belowDialog
    });
};

});
parcelRegister("34x7m", function(module, exports) {
$parcel$export(module.exports, "open", () => $676a061ada805bbc$export$3ce6949f20cea765);
$parcel$export(module.exports, "hide", () => $676a061ada805bbc$export$fe8985bb6374093c);
$parcel$export(module.exports, "show", () => $676a061ada805bbc$export$57bf213be019eeb0);
$parcel$export(module.exports, "update", () => $676a061ada805bbc$export$722fbec263ad908a);
$parcel$export(module.exports, "createNewConversation", () => $676a061ada805bbc$export$319172c070d96d91);
$parcel$export(module.exports, "onOpen", () => $676a061ada805bbc$export$16688e2160da47bd);
$parcel$export(module.exports, "onClose", () => $676a061ada805bbc$export$f312d3bc7ef841a8);
$parcel$export(module.exports, "getCurrentConversation", () => $676a061ada805bbc$export$8862049f62228856);
const $676a061ada805bbc$var$createCommand = (command)=>{
    const fn = (...args)=>{
        if (typeof window === 'undefined' || !window.CSM) {
            // eslint-disable-next-line no-console
            console.warn('CSM SDK has not been loaded!');
            return;
        }
        // @ts-expect-error - window.CSM is dynamically typed; TypeScript cannot infer the overloaded command signature at call site
        window.CSM(command, ...args);
    };
    return fn;
};
const $676a061ada805bbc$export$3ce6949f20cea765 = $676a061ada805bbc$var$createCommand('open');
const $676a061ada805bbc$export$8360e631d277ea4d = $676a061ada805bbc$var$createCommand('close');
const $676a061ada805bbc$export$fe8985bb6374093c = $676a061ada805bbc$var$createCommand('hide');
const $676a061ada805bbc$export$57bf213be019eeb0 = $676a061ada805bbc$var$createCommand('show');
const $676a061ada805bbc$export$722fbec263ad908a = $676a061ada805bbc$var$createCommand('update');
const $676a061ada805bbc$export$319172c070d96d91 = $676a061ada805bbc$var$createCommand('createNewConversation');
const $676a061ada805bbc$export$16688e2160da47bd = $676a061ada805bbc$var$createCommand('onOpen');
const $676a061ada805bbc$export$f312d3bc7ef841a8 = $676a061ada805bbc$var$createCommand('onClose');
const $676a061ada805bbc$export$8862049f62228856 = $676a061ada805bbc$var$createCommand('getCurrentConversation');

});

parcelRegister("dPjSm", function(module, exports) {
$parcel$export(module.exports, "CSM", () => $95e516e22278344e$export$e20267fb524e653f);

var $iusjH = parcelRequire("iusjH");

var $8CdKQ = parcelRequire("8CdKQ");
const $95e516e22278344e$export$e20267fb524e653f = async ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId })=>{
    if (typeof window === 'undefined') return;
    if (typeof window.CSM === 'undefined') window.CSM = (0, $iusjH.createSDKQueue)();
    return await (0, $8CdKQ.loadCSMSDK)({
        site: site,
        siteId: siteId,
        cloudId: cloudId,
        widgetId: widgetId
    });
};

});
parcelRegister("iusjH", function(module, exports) {
$parcel$export(module.exports, "createSDKQueue", () => $baab4546899ade23$export$7bcdf693772d0a65);
const $baab4546899ade23$export$7bcdf693772d0a65 = ()=>{
    const q = function CMSQueue(...args) {
        q.__q__.push(args);
    };
    q.__q__ = [];
    return q;
};

});

parcelRegister("8CdKQ", function(module, exports) {
$parcel$export(module.exports, "loadCSMSDK", () => $c16b1a769d16b1f4$export$6aed1f3cc6c8351e);

var $2rNQP = parcelRequire("2rNQP");

var $8PkE4 = parcelRequire("8PkE4");
let $c16b1a769d16b1f4$var$promise = null;
const $c16b1a769d16b1f4$var$NOOP = ()=>{};
const $c16b1a769d16b1f4$export$6aed1f3cc6c8351e = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId, debug: debug = $c16b1a769d16b1f4$var$NOOP })=>{
    if (!$c16b1a769d16b1f4$var$promise) $c16b1a769d16b1f4$var$promise = new Promise((resolve, reject)=>{
        if (typeof window === 'undefined') {
            debug({
                message: '[SDKLoader]: window is undefined'
            });
            reject(new Error('Failed to load CSM SDK: window is undefined'));
        }
        if (window.CSM && !('__q__' in window.CSM)) {
            debug({
                message: '[SDKLoader]: window.CSM already exists'
            });
            resolve(window.CSM);
        }
        const script = document.createElement('script');
        script.src = (0, $2rNQP.getSDKSrc)({
            site: site,
            siteId: siteId,
            cloudId: cloudId,
            widgetId: widgetId
        });
        script.setAttribute('async', '');
        script.type = 'text/javascript';
        script.onerror = ()=>{
            reject(new Error('Failed to load CSM SDK script: onerror'));
        };
        script.onload = ()=>{
            debug({
                message: '[SDKLoader]: script onload called'
            });
            if (window.CSM && !('__q__' in window.CSM)) {
                debug({
                    message: '[SDKLoader]: CSM SDK found after script onload'
                });
                resolve(window.CSM);
            } else {
                debug({
                    message: '[SDKLoader]: CSM SDK not found after script onload'
                });
                reject(new Error('Failed to load CSM SDK: window.CSM is undefined'));
            }
        };
        debug({
            message: '[SDKLoader]: CSM SDK appended to body'
        });
        document.body.appendChild(script);
        /**
       * Preconnect to initialise the connection ahead of loading any iframe
       * which will load static assets from the JCS widget domain.
       */ const link = document.createElement('link');
        const linkHref = (0, $8PkE4.getPreconnectHref)(site);
        link.rel = 'preconnect';
        link.href = linkHref;
        link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
        debug({
            message: `[SDKLoader]: CSM SDK preconnecting to ${linkHref}`
        });
    });
    return $c16b1a769d16b1f4$var$promise;
};

});
parcelRegister("2rNQP", function(module, exports) {
$parcel$export(module.exports, "getSDKSrc", () => $5acec9246a2d6a23$export$80f32c89482836ae);
const $5acec9246a2d6a23$export$80f32c89482836ae = ({ site: site, siteId: siteId, cloudId: cloudId, widgetId: widgetId })=>{
    const url = new URL(`/csm/widget/script.js`, `https://${site}`);
    if (siteId) {
        url.searchParams.set('siteId', siteId);
        url.searchParams.set('site', site);
    }
    if (cloudId) {
        url.searchParams.set('cloudId', cloudId);
        url.searchParams.set('site', site);
    }
    if (widgetId) url.searchParams.set('widgetId', widgetId);
    return url.toString();
};

});

parcelRegister("8PkE4", function(module, exports) {
$parcel$export(module.exports, "getPreconnectHref", () => $7c2d413909d5ccd5$export$270686f4186620fa);
const $7c2d413909d5ccd5$var$JCS_WIDGET_DOMAIN_PROD = 'https://jcs-chat-widget.atlassian.com';
const $7c2d413909d5ccd5$var$JCS_WIDGET_DOMAIN_STG = 'https://jcs-chat-widget.stg.atlassian.com';
const $7c2d413909d5ccd5$export$270686f4186620fa = (site)=>{
    return /jira-dev\.com/.test(site) ? $7c2d413909d5ccd5$var$JCS_WIDGET_DOMAIN_STG : $7c2d413909d5ccd5$var$JCS_WIDGET_DOMAIN_PROD;
};

});





parcelRegister("hdJUV", function(module, exports) {
$parcel$export(module.exports, "AiSearchTrigger", () => $3fa520303036364f$export$999e3594add7a0eb);
$parcel$export(module.exports, "AiSearchTriggerFloating", () => $3fa520303036364f$export$950284a1ac54bad5);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $7biT4 = parcelRequire("7biT4");

var $aCarc = parcelRequire("aCarc");

var $34x7m = parcelRequire("34x7m");

var $18IJM = parcelRequire("18IJM");

var $cTks9 = parcelRequire("cTks9");
const $3fa520303036364f$var$floatingBoxPositionStyles = null;
const $3fa520303036364f$var$AiSearchTriggerBase = ()=>{
    const { ref: ref } = (0, $18IJM.useTriggerIntersectionObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3fa520303036364f$var$ConnectedAiSearchInput, {
        ref: ref
    });
};
const $3fa520303036364f$var$hiddenToBottomStyles = null;
const $3fa520303036364f$var$hiddenToRightStyles = null;
/**
 * Connected "smart" UI component
 *
 * This component is connected to the AI search context and will update the value and onChange
 * functions when the user types in the input.
 *
 * It also handles the submission of the form and the creation of a new conversation.
 *
 * @private
 */ const $3fa520303036364f$var$ConnectedAiSearchInput = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ className: className, hidden: hiddenByProp }, ref)=>{
    const { isTriggerVisible: isTriggerVisible } = (0, $18IJM.useSearchTriggerVisibility)();
    const { value: value, onChange: onChange } = (0, $18IJM.useAiSearch)();
    const hideTrigger = hiddenByProp || !isTriggerVisible;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cTks9.AiSearchInput), {
        ref: ref,
        hidden: hideTrigger,
        // eslint-disable-next-line
        className: (0, $ltgDR.default)([
            hiddenByProp && "_t9ecdgi6",
            !isTriggerVisible && "_t9ec14jq",
            className
        ]),
        value: value,
        onChange: onChange,
        onSubmit: ({ message: message })=>{
            (0, $34x7m.show)();
            (0, $34x7m.open)();
            (0, $34x7m.createNewConversation)(typeof message === 'string' && message.length > 0 ? {
                message: message
            } : {});
            onChange('');
        }
    });
});
const $3fa520303036364f$var$ConditionalThemeProvider = ({ children: children, themeConfig: themeConfig })=>{
    if (themeConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aCarc.ThemeProvider), {
        themeConfig: themeConfig
    }, children);
    return children;
};
const $3fa520303036364f$export$999e3594add7a0eb = ({ site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3fa520303036364f$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $18IJM.AiSearchTriggerContainer), {
        site: site,
        siteId: siteId,
        widgetId: widgetId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3fa520303036364f$var$AiSearchTriggerBase, null)));
/**
 * The connected search trigger but connected to the store to hide
 * if there is a visible `AiSearchTrigger` in the viewport
 *
 * @private
 */ const $3fa520303036364f$var$AiSearchTriggerFloatingBase = ()=>{
    const [mounted, setMounted] = (0, $4fqPo.useState)(false);
    const hasIntersectingTrigger = (0, $18IJM.useHasIntersectingTrigger)();
    const isHidden = !mounted || hasIntersectingTrigger;
    (0, $4fqPo.useLayoutEffect)(()=>{
        setMounted(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3fa520303036364f$var$ConnectedAiSearchInput, {
        hidden: isHidden,
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _kqsw1n9t _1ltvidpf _1xi2idpf _94n5xy5q _1pby16oo"
        ])
    });
};
const $3fa520303036364f$export$950284a1ac54bad5 = ({ site: site, siteId: siteId, widgetId: widgetId, widgetTheme: widgetTheme })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7biT4.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3fa520303036364f$var$ConditionalThemeProvider, {
        themeConfig: widgetTheme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $18IJM.AiSearchTriggerContainer), {
        site: site,
        siteId: siteId,
        widgetId: widgetId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3fa520303036364f$var$AiSearchTriggerFloatingBase, null))));

});
parcelRegister("aCarc", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $fec468bf5a7cc4ce$export$d8964aec282183a3);

var $4fqPo = parcelRequire("4fqPo");

var $e1GJX = parcelRequire("e1GJX");

var $1z7qU = parcelRequire("1z7qU");

var $3ZOYR = parcelRequire("3ZOYR");

var $iH5c3 = parcelRequire("iH5c3");
const $fec468bf5a7cc4ce$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);
const $fec468bf5a7cc4ce$export$93d4e7f90805808f = ()=>{
    const context = (0, $4fqPo.useContext)($fec468bf5a7cc4ce$export$2c657da244d00bd6);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};
const $fec468bf5a7cc4ce$export$d8964aec282183a3 = ({ children: children, themeConfig: themeConfig, styles: styles = {} })=>{
    if (!themeConfig) throw new Error('themeConfig is required for the CSM Branding to works');
    const themeStyles = (0, $iH5c3.useGenerateThemeBranding)(themeConfig);
    const tokenStyles = (0, $4fqPo.useMemo)(()=>{
        const { borderRadius: borderRadius, space: space, colorRamps: colorRamps } = themeStyles;
        const iconColor = (0, $3ZOYR.getContrastYIQ)(themeConfig.primaryColor) === 'dark' ? '#FFFFFF' : '#000000';
        const brandColor = (0, $1z7qU.deriveBrandColors)(colorRamps, themeConfig.primaryColor);
        const properties = {
            [(0, $e1GJX.csmAiTokens)['color.100']]: colorRamps.color100,
            [(0, $e1GJX.csmAiTokens)['color.200']]: colorRamps.color200,
            [(0, $e1GJX.csmAiTokens)['color.300']]: colorRamps.color300,
            [(0, $e1GJX.csmAiTokens)['color.400']]: colorRamps.color400,
            [(0, $e1GJX.csmAiTokens)['color.500']]: colorRamps.color500,
            [(0, $e1GJX.csmAiTokens)['color.600']]: colorRamps.color600,
            [(0, $e1GJX.csmAiTokens)['color.700']]: colorRamps.color700,
            [(0, $e1GJX.csmAiTokens)['color.800']]: colorRamps.color800,
            [(0, $e1GJX.csmAiTokens)['color.900']]: colorRamps.color900,
            [(0, $e1GJX.csmAiTokens)['color.1000']]: colorRamps.color1000,
            [(0, $e1GJX.csmAiTokens)['color.icon']]: iconColor,
            [(0, $e1GJX.csmAiTokens)['color.brand']]: brandColor.brand,
            [(0, $e1GJX.csmAiTokens)['color.brand.hover']]: brandColor.hover,
            [(0, $e1GJX.csmAiTokens)['color.brand.active']]: brandColor.active,
            [(0, $e1GJX.csmAiTokens)['color.brand.text']]: brandColor.brandText,
            [(0, $e1GJX.csmAiTokens)['color.brand.hover.text']]: brandColor.hoverText,
            [(0, $e1GJX.csmAiTokens)['color.brand.active.text']]: brandColor.activeText,
            [(0, $e1GJX.csmAiTokens)['border.radius.lg']]: borderRadius.lg,
            [(0, $e1GJX.csmAiTokens)['border.radius.md']]: borderRadius.md,
            [(0, $e1GJX.csmAiTokens)['border.radius.sm']]: borderRadius.sm,
            [(0, $e1GJX.csmAiTokens)['border.radius.container']]: borderRadius.container,
            [(0, $e1GJX.csmAiTokens)['border.radius.widget']]: borderRadius.widget,
            [(0, $e1GJX.csmAiTokens)['space.lg']]: space.lg,
            [(0, $e1GJX.csmAiTokens)['space.md']]: space.md,
            [(0, $e1GJX.csmAiTokens)['space.sm']]: space.sm
        };
        return properties;
    }, [
        themeConfig.primaryColor,
        themeStyles
    ]);
    const combineStyles = {
        ...tokenStyles,
        ...styles,
        // Use inline to ensure the wrapper won't mess with the style calculation
        // of the children (e.g. height calculation of the children)
        display: 'inline'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($fec468bf5a7cc4ce$export$2c657da244d00bd6.Provider, {
        value: themeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        style: combineStyles
    }, children));
};

});
parcelRegister("e1GJX", function(module, exports) {
$parcel$export(module.exports, "csmAiTokens", () => $7dc1b35b73fcce79$export$e26bc1991ee46534);
const $7dc1b35b73fcce79$export$e26bc1991ee46534 = {
    'color.100': '--csm-color-100',
    'color.200': '--csm-color-200',
    'color.300': '--csm-color-300',
    'color.400': '--csm-color-400',
    'color.500': '--csm-color-500',
    'color.600': '--csm-color-600',
    'color.700': '--csm-color-700',
    'color.800': '--csm-color-800',
    'color.900': '--csm-color-900',
    'color.1000': '--csm-color-1000',
    'color.icon': '--csm-color-icon',
    'color.brand': '--csm-color-brand',
    'color.brand.hover': '--csm-color-brand-hover',
    'color.brand.active': '--csm-color-brand-active',
    'color.brand.text': '--csm-color-brand-text',
    'color.brand.hover.text': '--csm-color-brand-hover-text',
    'color.brand.active.text': '--csm-color-brand-active-text',
    'border.radius.lg': '--csm-border-radius-lg',
    'border.radius.md': '--csm-border-radius-md',
    'border.radius.sm': '--csm-border-radius-sm',
    'border.radius.container': '--csm-border-radius-container',
    'border.radius.widget': '--csm-border-radius-widget',
    'space.lg': '--csm-space-lg',
    'space.md': '--csm-space-md',
    'space.sm': '--csm-space-sm'
};

});

parcelRegister("1z7qU", function(module, exports) {
$parcel$export(module.exports, "deriveBrandColors", () => $8903ee7857e4f818$export$56e08ca4c9e5e798);

var $3ZOYR = parcelRequire("3ZOYR");
const $8903ee7857e4f818$var$clampRamp = (n)=>{
    const v = Math.max(100, Math.min(1000, n));
    return v;
};
const $8903ee7857e4f818$var$buildRampMap = (r)=>new Map([
        [
            100,
            r.color100
        ],
        [
            200,
            r.color200
        ],
        [
            300,
            r.color300
        ],
        [
            400,
            r.color400
        ],
        [
            500,
            r.color500
        ],
        [
            600,
            r.color600
        ],
        [
            700,
            r.color700
        ],
        [
            800,
            r.color800
        ],
        [
            900,
            r.color900
        ],
        [
            1000,
            r.color1000
        ]
    ]);
const $8903ee7857e4f818$var$textOn = (hex)=>(0, $3ZOYR.getContrastYIQ)(hex) === 'dark' ? '#FFFFFF' : '#000000';
const $8903ee7857e4f818$export$56e08ca4c9e5e798 = (ramps, primaryColor)=>{
    const rampMap = $8903ee7857e4f818$var$buildRampMap(ramps);
    const target = primaryColor.toLowerCase();
    let baseRamp = 400;
    for (const [n, hex] of rampMap)if (hex.toLowerCase() === target) {
        baseRamp = n;
        break;
    }
    const goLighter = baseRamp >= 800;
    const hoverRamp = $8903ee7857e4f818$var$clampRamp(baseRamp + (goLighter ? -200 : 200));
    const activeRamp = $8903ee7857e4f818$var$clampRamp(baseRamp + (goLighter ? -300 : 300));
    const brand = rampMap.get(baseRamp);
    const hover = rampMap.get(hoverRamp);
    const active = rampMap.get(activeRamp);
    return {
        brand: brand,
        hover: hover,
        active: active,
        brandText: $8903ee7857e4f818$var$textOn(brand),
        hoverText: $8903ee7857e4f818$var$textOn(hover),
        activeText: $8903ee7857e4f818$var$textOn(active)
    };
};

});
parcelRegister("3ZOYR", function(module, exports) {
$parcel$export(module.exports, "getContrastYIQ", () => $dd90f5fe8eaf2589$export$5f6ad4d710455f9b);
const $dd90f5fe8eaf2589$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `rgb(${$dd90f5fe8eaf2589$var$hexToInt(result, 1)}, ${$dd90f5fe8eaf2589$var$hexToInt(result, 2)},${$dd90f5fe8eaf2589$var$hexToInt(result, 3)})` : null;
};
const $dd90f5fe8eaf2589$var$hexToInt = (arr, index)=>parseInt(arr[index], 16);
const $dd90f5fe8eaf2589$export$5f6ad4d710455f9b = (hex)=>{
    const rgb = $dd90f5fe8eaf2589$var$hexToRgb(hex);
    const modifyRgb = rgb ? rgb.substring(4, rgb.length - 1).replace(/ /g, '').split(',') : [];
    const yiq = modifyRgb !== null && modifyRgb !== void 0 && modifyRgb.length ? (Number(modifyRgb[0]) * 299 + Number(modifyRgb[1]) * 587 + Number(modifyRgb[2]) * 114) / 1000 : 0;
    return yiq >= 128 ? 'light' : 'dark';
};

});


parcelRegister("iH5c3", function(module, exports) {
$parcel$export(module.exports, "useGenerateThemeBranding", () => $8313176ed7de9416$export$4be1c3ef709f1b04);

var $4fqPo = parcelRequire("4fqPo");

var $e1dHz = parcelRequire("e1dHz");
const $8313176ed7de9416$export$4be1c3ef709f1b04 = (themeConfig)=>{
    return (0, $4fqPo.useMemo)(()=>{
        const theme = (0, $e1dHz.generateThemeBranding)(themeConfig);
        return theme;
    }, [
        themeConfig
    ]);
};

});
parcelRegister("e1dHz", function(module, exports) {
$parcel$export(module.exports, "generateThemeBranding", () => $3338a69673064693$export$c1410db1c88d6e0f);

var $3TusU = parcelRequire("3TusU");
// Values are taken from figma [design](https://www.figma.com/design/sxl0BlQxD2g2eU27Rl2VhG/CSM-X-Loom-Support---In-Product?node-id=2351-34333&t=d8zOoCnHa3EJORFr-4), some are guesstimated
const $3338a69673064693$var$BORDER_RADIUS = {
    sharp: {
        lg: '8px',
        md: '4px',
        sm: '2px',
        container: '12px',
        widget: '12px'
    },
    normal: {
        lg: '10px',
        md: '6px',
        sm: '4px',
        container: '18px',
        widget: '18px'
    },
    rounded: {
        lg: '12px',
        md: '10px',
        sm: '6px',
        container: '22px',
        widget: '100%'
    }
};
const $3338a69673064693$var$SPACE = {
    cosy: {
        lg: '12px',
        md: '8px',
        sm: '8px'
    },
    comfortable: {
        lg: '16px',
        md: '12px',
        sm: '8px'
    },
    generous: {
        lg: '24px',
        md: '16px',
        sm: '8px'
    }
};
const $3338a69673064693$export$c1410db1c88d6e0f = (themeConfig)=>{
    const { radius: radius, space: space, primaryColor: primaryColor } = themeConfig;
    const colorRamps = (0, $3TusU.generateColorRamps)(primaryColor);
    const borderRadius = $3338a69673064693$var$BORDER_RADIUS[radius] || $3338a69673064693$var$BORDER_RADIUS.normal;
    const themeSpace = $3338a69673064693$var$SPACE[space] || $3338a69673064693$var$SPACE.comfortable;
    return {
        colorRamps: colorRamps,
        borderRadius: borderRadius,
        space: themeSpace
    };
};

});
parcelRegister("3TusU", function(module, exports) {
$parcel$export(module.exports, "generateColorRamps", () => $041d69c877fcaa98$export$3a180ce5632a9d57);

var $c0ZR4 = parcelRequire("c0ZR4");

var $kMjJH = parcelRequire("kMjJH");

var $2Z9Tw = parcelRequire("2Z9Tw");

var $4ukQ7 = parcelRequire("4ukQ7");
const $041d69c877fcaa98$var$lowLuminanceContrastRatios = [
    1.12,
    1.33,
    2.03,
    2.73,
    3.33,
    4.27,
    5.2,
    6.62,
    12.46,
    14.25
];
const $041d69c877fcaa98$var$highLuminanceContrastRatios = [
    1.08,
    1.24,
    1.55,
    1.99,
    2.45,
    3.34,
    4.64,
    6.1,
    10.19,
    12.6
];
const $041d69c877fcaa98$export$b102e016d69678f3 = (themeRamp, brandColor)=>{
    // Iterate over themeRamp and find whichever color is closest to brandColor
    let closestColorIndex = 0;
    let closestColorDistance = null;
    themeRamp.forEach((value, index)=>{
        const distance = (0, $c0ZR4.deltaE)((0, $c0ZR4.hexToRgb)(value), (0, $c0ZR4.hexToRgb)(brandColor));
        if (closestColorDistance === null || distance < closestColorDistance) {
            closestColorIndex = index;
            closestColorDistance = distance;
        }
    });
    return closestColorIndex;
};
const $041d69c877fcaa98$export$253cd51ce7d49924 = (brandColor)=>{
    // Determine luminance
    const HSLBrandColorHue = (0, $c0ZR4.hexToHSL)(brandColor)[0];
    const baseRgb = (0, $c0ZR4.HSLToRGB)(HSLBrandColorHue, 100, 60);
    const isLowLuminance = (0, $c0ZR4.relativeLuminanceW3C)(baseRgb[0], baseRgb[1], baseRgb[2]) < 0.4;
    // Choose right palette
    const themeRatios = isLowLuminance ? $041d69c877fcaa98$var$lowLuminanceContrastRatios : $041d69c877fcaa98$var$highLuminanceContrastRatios;
    const brandRgba = (0, $c0ZR4.hexToRgbA)(brandColor);
    const hctColor = (0, $4ukQ7.Hct).fromInt((0, $kMjJH.argbFromRgba)({
        r: brandRgba[0],
        g: brandRgba[1],
        b: brandRgba[2],
        a: brandRgba[3]
    }));
    const themeRamp = themeRatios.map((contrast)=>{
        const rgbaColor = (0, $kMjJH.rgbaFromArgb)((0, $4ukQ7.Hct).from(hctColor.hue, hctColor.chroma, (0, $2Z9Tw.Contrast).darker(100, contrast) + 0.25 // Material's utils provide an offset
        ).toInt());
        return (0, $c0ZR4.rgbToHex)(rgbaColor.r, rgbaColor.g, rgbaColor.b);
    });
    const closestColorIndex = $041d69c877fcaa98$export$b102e016d69678f3(themeRamp, brandColor);
    // Replace closet color with brandColor
    const updatedThemeRamp = [
        ...themeRamp
    ];
    updatedThemeRamp[closestColorIndex] = brandColor;
    return updatedThemeRamp;
};
const $041d69c877fcaa98$export$3a180ce5632a9d57 = (primaryColor)=>{
    const colors = $041d69c877fcaa98$export$253cd51ce7d49924(primaryColor);
    return {
        color100: colors[0],
        color200: colors[1],
        color300: colors[2],
        color400: colors[3],
        color500: colors[4],
        color600: colors[5],
        color700: colors[6],
        color800: colors[7],
        color900: colors[8],
        color1000: colors[9]
    };
};

});
parcelRegister("c0ZR4", function(module, exports) {
$parcel$export(module.exports, "rgbToHex", () => $fa8ceed14dbd06e6$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgbA", () => $fa8ceed14dbd06e6$export$b36dbdb4f463f05c);
$parcel$export(module.exports, "hexToRgb", () => $fa8ceed14dbd06e6$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToHSL", () => $fa8ceed14dbd06e6$export$47ea145a83f50dc0);
$parcel$export(module.exports, "HSLToRGB", () => $fa8ceed14dbd06e6$export$1ff93e992dd58bec);
$parcel$export(module.exports, "relativeLuminanceW3C", () => $fa8ceed14dbd06e6$export$e770b01b744f3745);
$parcel$export(module.exports, "deltaE", () => $fa8ceed14dbd06e6$export$e8ddad763b4bebf9);
// valid hex color with 6 digits
const $fa8ceed14dbd06e6$export$53031ac1ecb71f44 = (hex)=>/^#[0-9A-F]{6}$/i.test(hex);
// valid hex color with 4, 6 or 8 digits
const $fa8ceed14dbd06e6$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
function $fa8ceed14dbd06e6$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $fa8ceed14dbd06e6$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        const int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $fa8ceed14dbd06e6$export$b36dbdb4f463f05c(hex) {
    if (!$fa8ceed14dbd06e6$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $fa8ceed14dbd06e6$export$1212645cf40ebf71(hex)
    ];
}
function $fa8ceed14dbd06e6$export$5a544e13ad4e1fa5(hex) {
    if (!$fa8ceed14dbd06e6$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $fa8ceed14dbd06e6$export$47ea145a83f50dc0(hex) {
    if (!$fa8ceed14dbd06e6$var$isValidHex(hex)) throw new Error('Invalid HEX');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let r = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    g = 0, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    let cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $fa8ceed14dbd06e6$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    const k = (n)=>(n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n)=>l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $fa8ceed14dbd06e6$export$e770b01b744f3745(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $fa8ceed14dbd06e6$export$d061e26956a60b0a(foreground, background) {
    if (!$fa8ceed14dbd06e6$var$isValidHex(foreground) || !$fa8ceed14dbd06e6$var$isValidHex(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $fa8ceed14dbd06e6$export$5a544e13ad4e1fa5(foreground);
    const backgroundRgb = $fa8ceed14dbd06e6$export$5a544e13ad4e1fa5(background);
    const foregroundLuminance = $fa8ceed14dbd06e6$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $fa8ceed14dbd06e6$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $fa8ceed14dbd06e6$export$e8ddad763b4bebf9(rgbA, rgbB) {
    let labA = $fa8ceed14dbd06e6$var$rgbToLab(rgbA);
    let labB = $fa8ceed14dbd06e6$var$rgbToLab(rgbB);
    let deltaL = labA[0] - labB[0];
    let deltaA = labA[1] - labB[1];
    let deltaB = labA[2] - labB[2];
    let c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    let c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    let deltaC = c1 - c2;
    let deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    let sc = 1.0 + 0.045 * c1;
    let sh = 1.0 + 0.015 * c1;
    let deltaLKlsl = deltaL / 1.0;
    let deltaCkcsc = deltaC / sc;
    let deltaHkhsh = deltaH / sh;
    let i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $fa8ceed14dbd06e6$var$rgbToLab(rgb) {
    let r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("kMjJH", function(module, exports) {
$parcel$export(module.exports, "argbFromLinrgb", () => $538772a3d911d0e1$export$7928ddf440518d19);
$parcel$export(module.exports, "argbFromXyz", () => $538772a3d911d0e1$export$cbbbbc8b222df20);
$parcel$export(module.exports, "linearized", () => $538772a3d911d0e1$export$dec6bcda7bf47f2c);
$parcel$export(module.exports, "argbFromLstar", () => $538772a3d911d0e1$export$ae8c227f6d0cbddb);
$parcel$export(module.exports, "yFromLstar", () => $538772a3d911d0e1$export$7f3071c4a5db05a0);
$parcel$export(module.exports, "lstarFromArgb", () => $538772a3d911d0e1$export$8b8f7ef2e0a71c61);
$parcel$export(module.exports, "lstarFromY", () => $538772a3d911d0e1$export$bfc0d1dd9c64ada2);
$parcel$export(module.exports, "whitePointD65", () => $538772a3d911d0e1$export$d4534a444c6526c3);
$parcel$export(module.exports, "rgbaFromArgb", () => $538772a3d911d0e1$export$fb1fd26c787a8662);
$parcel$export(module.exports, "argbFromRgba", () => $538772a3d911d0e1$export$9128c3a9233ad1fd);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.

var $6hPEx = parcelRequire("6hPEx");
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $538772a3d911d0e1$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $538772a3d911d0e1$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $538772a3d911d0e1$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
function $538772a3d911d0e1$export$58a74b9f8e513b7b(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
function $538772a3d911d0e1$export$7928ddf440518d19(linrgb) {
    const r = $538772a3d911d0e1$export$777e26aa2ec02b1(linrgb[0]);
    const g = $538772a3d911d0e1$export$777e26aa2ec02b1(linrgb[1]);
    const b = $538772a3d911d0e1$export$777e26aa2ec02b1(linrgb[2]);
    return $538772a3d911d0e1$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Returns the alpha component of a color in ARGB format.
 */ function $538772a3d911d0e1$var$alphaFromArgb(argb) {
    return argb >> 24 & 255;
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $538772a3d911d0e1$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $538772a3d911d0e1$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $538772a3d911d0e1$var$blueFromArgb(argb) {
    return argb & 255;
}
function $538772a3d911d0e1$export$cbbbbc8b222df20(x, y, z) {
    const matrix = $538772a3d911d0e1$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $538772a3d911d0e1$export$777e26aa2ec02b1(linearR);
    const g = $538772a3d911d0e1$export$777e26aa2ec02b1(linearG);
    const b = $538772a3d911d0e1$export$777e26aa2ec02b1(linearB);
    return $538772a3d911d0e1$export$58a74b9f8e513b7b(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $538772a3d911d0e1$var$xyzFromArgb(argb) {
    const r = $538772a3d911d0e1$export$dec6bcda7bf47f2c($538772a3d911d0e1$var$redFromArgb(argb));
    const g = $538772a3d911d0e1$export$dec6bcda7bf47f2c($538772a3d911d0e1$var$greenFromArgb(argb));
    const b = $538772a3d911d0e1$export$dec6bcda7bf47f2c($538772a3d911d0e1$var$blueFromArgb(argb));
    return $6hPEx.matrixMultiply([
        r,
        g,
        b
    ], $538772a3d911d0e1$var$SRGB_TO_XYZ);
}
function $538772a3d911d0e1$export$ae8c227f6d0cbddb(lstar) {
    const y = $538772a3d911d0e1$export$7f3071c4a5db05a0(lstar);
    const component = $538772a3d911d0e1$export$777e26aa2ec02b1(y);
    return $538772a3d911d0e1$export$58a74b9f8e513b7b(component, component, component);
}
function $538772a3d911d0e1$export$8b8f7ef2e0a71c61(argb) {
    const y = $538772a3d911d0e1$var$xyzFromArgb(argb)[1];
    return 116.0 * $538772a3d911d0e1$var$labF(y / 100.0) - 16.0;
}
function $538772a3d911d0e1$export$7f3071c4a5db05a0(lstar) {
    return 100.0 * $538772a3d911d0e1$var$labInvf((lstar + 16.0) / 116.0);
}
function $538772a3d911d0e1$export$bfc0d1dd9c64ada2(y) {
    return $538772a3d911d0e1$var$labF(y / 100.0) * 116.0 - 16.0;
}
function $538772a3d911d0e1$export$dec6bcda7bf47f2c(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
function $538772a3d911d0e1$export$777e26aa2ec02b1(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $6hPEx.clampInt(0, 255, Math.round(delinearized * 255.0));
}
function $538772a3d911d0e1$export$d4534a444c6526c3() {
    return $538772a3d911d0e1$var$WHITE_POINT_D65;
}
function $538772a3d911d0e1$export$fb1fd26c787a8662(argb) {
    const r = $538772a3d911d0e1$var$redFromArgb(argb);
    const g = $538772a3d911d0e1$var$greenFromArgb(argb);
    const b = $538772a3d911d0e1$var$blueFromArgb(argb);
    const a = $538772a3d911d0e1$var$alphaFromArgb(argb);
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $538772a3d911d0e1$export$9128c3a9233ad1fd({ r: r, g: g, b: b, a: a }) {
    const rValue = $538772a3d911d0e1$var$clampComponent(r);
    const gValue = $538772a3d911d0e1$var$clampComponent(g);
    const bValue = $538772a3d911d0e1$var$clampComponent(b);
    const aValue = $538772a3d911d0e1$var$clampComponent(a);
    return aValue << 24 | rValue << 16 | gValue << 8 | bValue;
}
function $538772a3d911d0e1$var$clampComponent(value) {
    if (value < 0) return 0;
    if (value > 255) return 255;
    return value;
}
function $538772a3d911d0e1$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $538772a3d911d0e1$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}

});
parcelRegister("6hPEx", function(module, exports) {
$parcel$export(module.exports, "signum", () => $27d3ab249bb69191$export$23e3e2011c250f0f);
$parcel$export(module.exports, "lerp", () => $27d3ab249bb69191$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "clampInt", () => $27d3ab249bb69191$export$d0498fe3d58e384f);
$parcel$export(module.exports, "clampDouble", () => $27d3ab249bb69191$export$62d511a4580feff);
$parcel$export(module.exports, "sanitizeDegreesDouble", () => $27d3ab249bb69191$export$7417613e514a9e72);
$parcel$export(module.exports, "matrixMultiply", () => $27d3ab249bb69191$export$be586f9fe0391d67);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $27d3ab249bb69191$export$23e3e2011c250f0f(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
function $27d3ab249bb69191$export$3a89f8d6f6bf6c9f(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
function $27d3ab249bb69191$export$d0498fe3d58e384f(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $27d3ab249bb69191$export$62d511a4580feff(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
function $27d3ab249bb69191$export$7417613e514a9e72(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
function $27d3ab249bb69191$export$be586f9fe0391d67(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}

});


parcelRegister("2Z9Tw", function(module, exports) {
$parcel$export(module.exports, "Contrast", () => $b369dbc64909382f$export$656ae42051d0ca86);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace

var $kMjJH = parcelRequire("kMjJH");

var $6hPEx = parcelRequire("6hPEx");
class $b369dbc64909382f$export$656ae42051d0ca86 {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $6hPEx.clampDouble(0.0, 100.0, toneA);
        toneB = $6hPEx.clampDouble(0.0, 100.0, toneB);
        return $b369dbc64909382f$export$656ae42051d0ca86.ratioOfYs($kMjJH.yFromLstar(toneA), $kMjJH.yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $kMjJH.yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $b369dbc64909382f$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $kMjJH.lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $kMjJH.yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $b369dbc64909382f$export$656ae42051d0ca86.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $kMjJH.lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $b369dbc64909382f$export$656ae42051d0ca86.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $b369dbc64909382f$export$656ae42051d0ca86.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}

});

parcelRegister("4ukQ7", function(module, exports) {
$parcel$export(module.exports, "Hct", () => $23c3274a8097c3fd$export$91d2e033b3924566);
/**
 * Below lines are copied from @material/material-color-utilities.
 * Do not modify it.
 */ /**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kMjJH = parcelRequire("kMjJH");

var $6hPEx = parcelRequire("6hPEx");
class $23c3274a8097c3fd$export$91d2e033b3924566 {
    static from(hue, chroma, tone) {
        return new $23c3274a8097c3fd$export$91d2e033b3924566($23c3274a8097c3fd$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $23c3274a8097c3fd$export$91d2e033b3924566(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($23c3274a8097c3fd$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($23c3274a8097c3fd$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /**
   * Lightness. Ranges from 0 to 100.
   */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($23c3274a8097c3fd$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $23c3274a8097c3fd$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $kMjJH.lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $23c3274a8097c3fd$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $kMjJH.lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $23c3274a8097c3fd$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $23c3274a8097c3fd$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $23c3274a8097c3fd$export$159586e3808c6277.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $23c3274a8097c3fd$export$91d2e033b3924566.from(recastInVc.hue, recastInVc.chroma, $kMjJH.lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $23c3274a8097c3fd$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $23c3274a8097c3fd$var$Cam16.fromIntInViewingConditions(argb, $23c3274a8097c3fd$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $kMjJH.linearized(red);
        const greenL = $kMjJH.linearized(green);
        const blueL = $kMjJH.linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $6hPEx.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $6hPEx.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $6hPEx.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $23c3274a8097c3fd$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $23c3274a8097c3fd$var$Cam16.fromJchInViewingConditions(j, c, h, $23c3274a8097c3fd$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $23c3274a8097c3fd$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $23c3274a8097c3fd$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $23c3274a8097c3fd$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $23c3274a8097c3fd$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($23c3274a8097c3fd$export$159586e3808c6277.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $6hPEx.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $6hPEx.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $6hPEx.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $kMjJH.argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $6hPEx.signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $6hPEx.signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $6hPEx.signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $23c3274a8097c3fd$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $6hPEx.signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $6hPEx.signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $6hPEx.signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
// This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $23c3274a8097c3fd$var$HctSolver {
    static #_ = this.SCALED_DISCOUNT_FROM_LINRGB = [
        [
            0.001200833568784504,
            0.002389694492170889,
            0.0002795742885861124
        ],
        [
            0.0005891086651375999,
            0.0029785502573438758,
            0.0003270666104008398
        ],
        [
            0.00010146692491640572,
            0.0005364214359186694,
            0.0032979401770712076
        ]
    ];
    static #_2 = this.LINRGB_FROM_SCALED_DISCOUNT = [
        [
            1373.2198709594231,
            -1100.4251190754821,
            -7.278681089101213
        ],
        [
            -271.815969077903,
            559.6580465940733,
            -32.46047482791194
        ],
        [
            1.9622899599665666,
            -57.173814538844006,
            308.7233197812385
        ]
    ];
    static #_3 = this.Y_FROM_LINRGB = [
        0.2126,
        0.7152,
        0.0722
    ];
    static #_4 = this.CRITICAL_PLANES = [
        0.015176349177441876,
        0.045529047532325624,
        0.07588174588720938,
        0.10623444424209313,
        0.13658714259697685,
        0.16693984095186062,
        0.19729253930674434,
        0.2276452376616281,
        0.2579979360165119,
        0.28835063437139563,
        0.3188300904430532,
        0.350925934958123,
        0.3848314933096426,
        0.42057480301049466,
        0.458183274052838,
        0.4976837250274023,
        0.5391024159806381,
        0.5824650784040898,
        0.6277969426914107,
        0.6751227633498623,
        0.7244668422128921,
        0.775853049866786,
        0.829304845476233,
        0.8848452951698498,
        0.942497089126609,
        1.0022825574869039,
        1.0642236851973577,
        1.1283421258858297,
        1.1946592148522128,
        1.2631959812511864,
        1.3339731595349034,
        1.407011200216447,
        1.4823302800086415,
        1.5599503113873272,
        1.6398909516233677,
        1.7221716113234105,
        1.8068114625156377,
        1.8938294463134073,
        1.9832442801866852,
        2.075074464868551,
        2.1693382909216234,
        2.2660538449872063,
        2.36523901573795,
        2.4669114995532007,
        2.5710888059345764,
        2.6777882626779785,
        2.7870270208169257,
        2.898822059350997,
        3.0131901897720907,
        3.1301480604002863,
        3.2497121605402226,
        3.3718988244681087,
        3.4967242352587946,
        3.624204428461639,
        3.754355295633311,
        3.887192587735158,
        4.022731918402185,
        4.160988767090289,
        4.301978482107941,
        4.445716283538092,
        4.592217266055746,
        4.741496401646282,
        4.893568542229298,
        5.048448422192488,
        5.20615066083972,
        5.3666897647573375,
        5.5300801301023865,
        5.696336044816294,
        5.865471690767354,
        6.037501145825082,
        6.212438385869475,
        6.390297286737924,
        6.571091626112461,
        6.7548350853498045,
        6.941541251256611,
        7.131223617812143,
        7.323895587840543,
        7.5195704746346665,
        7.7182615035334345,
        7.919981813454504,
        8.124744458384042,
        8.332562408825165,
        8.543448553206703,
        8.757415699253682,
        8.974476575321063,
        9.194643831691977,
        9.417930041841839,
        9.644347703669503,
        9.873909240696694,
        10.106627003236781,
        10.342513269534024,
        10.58158024687427,
        10.8238400726681,
        11.069304815507364,
        11.317986476196008,
        11.569896988756009,
        11.825048221409341,
        12.083451977536606,
        12.345119996613247,
        12.610063955123938,
        12.878295467455942,
        13.149826086772048,
        13.42466730586372,
        13.702830557985108,
        13.984327217668513,
        14.269168601521828,
        14.55736596900856,
        14.848930523210871,
        15.143873411576273,
        15.44220572664832,
        15.743938506781891,
        16.04908273684337,
        16.35764934889634,
        16.66964922287304,
        16.985093187232053,
        17.30399201960269,
        17.62635644741625,
        17.95219714852476,
        18.281524751807332,
        18.614349837764564,
        18.95068293910138,
        19.290534541298456,
        19.633915083172692,
        19.98083495742689,
        20.331304511189067,
        20.685334046541502,
        21.042933821039977,
        21.404114048223256,
        21.76888489811322,
        22.137256497705877,
        22.50923893145328,
        22.884842241736916,
        23.264076429332462,
        23.6469514538663,
        24.033477234264016,
        24.42366364919083,
        24.817520537484558,
        25.21505769858089,
        25.61628489293138,
        26.021211842414342,
        26.429848230738664,
        26.842203703840827,
        27.258287870275353,
        27.678110301598522,
        28.10168053274597,
        28.529008062403893,
        28.96010235337422,
        29.39497283293396,
        29.83362889318845,
        30.276079891419332,
        30.722335150426627,
        31.172403958865512,
        31.62629557157785,
        32.08401920991837,
        32.54558406207592,
        33.010999283389665,
        33.4802739966603,
        33.953417292456834,
        34.430438229418264,
        34.911345834551085,
        35.39614910352207,
        35.88485700094671,
        36.37747846067349,
        36.87402238606382,
        37.37449765026789,
        37.87891309649659,
        38.38727753828926,
        38.89959975977785,
        39.41588851594697,
        39.93615253289054,
        40.460400508064545,
        40.98864111053629,
        41.520882981230194,
        42.05713473317016,
        42.597404951718396,
        43.141702194811224,
        43.6900349931913,
        44.24241185063697,
        44.798841244188324,
        45.35933162437017,
        45.92389141541209,
        46.49252901546552,
        47.065252796817916,
        47.64207110610409,
        48.22299226451468,
        48.808024568002054,
        49.3971762874833,
        49.9904556690408,
        50.587870934119984,
        51.189430279724725,
        51.79514187861014,
        52.40501387947288,
        53.0190544071392,
        53.637271562750364,
        54.259673423945976,
        54.88626804504493,
        55.517063457223934,
        56.15206766869424,
        56.79128866487574,
        57.43473440856916,
        58.08241284012621,
        58.734331877617365,
        59.39049941699807,
        60.05092333227251,
        60.715611475655585,
        61.38457167773311,
        62.057811747619894,
        62.7353394731159,
        63.417162620860914,
        64.10328893648692,
        64.79372614476921,
        65.48848194977529,
        66.18756403501224,
        66.89098006357258,
        67.59873767827808,
        68.31084450182222,
        69.02730813691093,
        69.74813616640164,
        70.47333615344107,
        71.20291564160104,
        71.93688215501312,
        72.67524319850172,
        73.41800625771542,
        74.16517879925733,
        74.9167682708136,
        75.67278210128072,
        76.43322770089146,
        77.1981124613393,
        77.96744375590167,
        78.74122893956174,
        79.51947534912904,
        80.30219030335869,
        81.08938110306934,
        81.88105503125999,
        82.67721935322541,
        83.4778813166706,
        84.28304815182372,
        85.09272707154808,
        85.90692527145302,
        86.72564993000343,
        87.54890820862819,
        88.3767072518277,
        89.2090541872801,
        90.04595612594655,
        90.88742016217518,
        91.73345337380438,
        92.58406282226491,
        93.43925555268066,
        94.29903859396902,
        95.16341895893969,
        96.03240364439274,
        96.9059996312159,
        97.78421388448044,
        98.6670533535366,
        99.55452497210776
    ];
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $6hPEx.signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $6hPEx.matrixMultiply(linrgb, $23c3274a8097c3fd$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $23c3274a8097c3fd$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $23c3274a8097c3fd$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $23c3274a8097c3fd$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $23c3274a8097c3fd$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $23c3274a8097c3fd$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $23c3274a8097c3fd$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $23c3274a8097c3fd$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $23c3274a8097c3fd$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $23c3274a8097c3fd$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $23c3274a8097c3fd$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($23c3274a8097c3fd$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($23c3274a8097c3fd$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($23c3274a8097c3fd$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $23c3274a8097c3fd$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $23c3274a8097c3fd$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $23c3274a8097c3fd$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($23c3274a8097c3fd$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $23c3274a8097c3fd$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $23c3274a8097c3fd$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $23c3274a8097c3fd$var$HctSolver.criticalPlaneBelow($23c3274a8097c3fd$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $23c3274a8097c3fd$var$HctSolver.criticalPlaneAbove($23c3274a8097c3fd$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $23c3274a8097c3fd$var$HctSolver.criticalPlaneAbove($23c3274a8097c3fd$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $23c3274a8097c3fd$var$HctSolver.criticalPlaneBelow($23c3274a8097c3fd$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $23c3274a8097c3fd$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $23c3274a8097c3fd$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $23c3274a8097c3fd$var$HctSolver.hueOf(mid);
                    if ($23c3274a8097c3fd$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $23c3274a8097c3fd$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $6hPEx.signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $23c3274a8097c3fd$export$159586e3808c6277.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $23c3274a8097c3fd$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $23c3274a8097c3fd$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $23c3274a8097c3fd$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $6hPEx.matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $23c3274a8097c3fd$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $23c3274a8097c3fd$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $23c3274a8097c3fd$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $23c3274a8097c3fd$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $kMjJH.argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $kMjJH.argbFromLstar(lstar);
        hueDegrees = $6hPEx.sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $kMjJH.yFromLstar(lstar);
        const exactAnswer = $23c3274a8097c3fd$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $23c3274a8097c3fd$var$HctSolver.bisectToLimit(y, hueRadians);
        return $kMjJH.argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $23c3274a8097c3fd$var$Cam16.fromInt($23c3274a8097c3fd$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
class $23c3274a8097c3fd$export$159586e3808c6277 {
    static #_ = /**
   * sRGB-like viewing conditions.
   */ this.DEFAULT = $23c3274a8097c3fd$export$159586e3808c6277.make();
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $kMjJH.whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $kMjJH.yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $6hPEx.lerp(0.59, 0.69, (f - 0.9) * 10.0) : $6hPEx.lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $kMjJH.yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $23c3274a8097c3fd$export$159586e3808c6277(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}

});





parcelRegister("18IJM", function(module, exports) {
$parcel$export(module.exports, "AiSearchTriggerContainer", () => $1165e4d835f8e920$export$c23f578d84bfd719);
$parcel$export(module.exports, "useAiSearch", () => $1165e4d835f8e920$export$77f51d599ca38b3);
$parcel$export(module.exports, "useTriggerIntersectionObserver", () => $1165e4d835f8e920$export$d341e445290d4887);
$parcel$export(module.exports, "useHasIntersectingTrigger", () => $1165e4d835f8e920$export$e134485de3777bd2);
$parcel$export(module.exports, "useSearchTriggerVisibility", () => $1165e4d835f8e920$export$7f622cc0692430e8);

var $4fqPo = parcelRequire("4fqPo");

var $4CywU = parcelRequire("4CywU");
var $iouul = parcelRequire("iouul");
var $2RDzF = parcelRequire("2RDzF");

var $34x7m = parcelRequire("34x7m");

var $7cAgJ = parcelRequire("7cAgJ");
const $1165e4d835f8e920$var$actions = {
    setInputValue: (inputValue)=>({ setState: setState })=>{
            setState({
                inputValue: inputValue
            });
        },
    observe: (id, element)=>({ setState: setState, getState: getState })=>{
            const { triggers: triggers, observer: currentObserver } = getState();
            const observer = currentObserver ?? new IntersectionObserver(([entry])=>{
                setState({
                    triggers: {
                        ...triggers,
                        [id]: {
                            element: element,
                            isIntersecting: entry.isIntersecting
                        }
                    }
                });
            }, {
                threshold: 0
            });
            setState({
                observer: observer
            });
            observer.observe(element);
        },
    disconnect: (id)=>({ setState: setState, getState: getState })=>{
            const { triggers: prevTriggers, observer: observer } = getState();
            if (observer && prevTriggers[id]) observer.unobserve(prevTriggers[id].element);
            const triggers = {
                ...prevTriggers
            };
            delete triggers[id];
            setState({
                triggers: triggers
            });
        }
};
const $1165e4d835f8e920$var$StoreContainer = (0, $4CywU.createContainer)();
const $1165e4d835f8e920$export$c23f578d84bfd719 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($1165e4d835f8e920$var$StoreContainer, {
        ...props,
        isGlobal: true
    }, children);
};
const $1165e4d835f8e920$var$store = (0, $2RDzF.createStore)({
    name: 'csm-ai-search-trigger-store',
    initialState: {
        inputValue: '',
        widgetVisibility: null,
        triggers: {},
        observer: null
    },
    actions: $1165e4d835f8e920$var$actions,
    containedBy: $1165e4d835f8e920$var$StoreContainer,
    handlers: {
        onInit: ()=>({ setState: setState }, { site: site, siteId: siteId, widgetId: widgetId })=>{
                (0, $7cAgJ.initCSM)({
                    site: site,
                    siteId: siteId,
                    widgetId: widgetId
                });
                (0, $34x7m.hide)();
                setState({
                    widgetVisibility: 'hidden'
                });
                (0, $34x7m.onOpen)(()=>{
                    setState({
                        widgetVisibility: 'visible'
                    });
                });
                (0, $34x7m.onClose)(()=>{
                    (0, $34x7m.getCurrentConversation)((conversation)=>{
                        if (!conversation) {
                            (0, $34x7m.hide)();
                            setState({
                                widgetVisibility: 'hidden'
                            });
                        }
                    });
                });
            }
    }
});
const $1165e4d835f8e920$var$searchFieldValueSelector = (state)=>state.inputValue;
const $1165e4d835f8e920$var$useSearchFieldValueHook = (0, $iouul.createHook)($1165e4d835f8e920$var$store, {
    selector: $1165e4d835f8e920$var$searchFieldValueSelector
});
const $1165e4d835f8e920$export$77f51d599ca38b3 = ()=>{
    const [inputValue, { setInputValue: setInputValue }] = $1165e4d835f8e920$var$useSearchFieldValueHook();
    return {
        value: inputValue,
        onChange: (value)=>setInputValue(value)
    };
};
const $1165e4d835f8e920$var$useAiSearchStore = (0, $iouul.createHook)($1165e4d835f8e920$var$store);
const $1165e4d835f8e920$export$d341e445290d4887 = ()=>{
    const id = (0, $4fqPo.useId)();
    const [_, { observe: observe, disconnect: disconnect }] = $1165e4d835f8e920$var$useAiSearchStore();
    const ref = (0, $4fqPo.useCallback)((element)=>{
        if (element) observe(id, element);
        else disconnect(id);
    }, [
        observe,
        disconnect,
        id
    ]);
    return {
        ref: ref
    };
};
const $1165e4d835f8e920$var$hasIntersectingTriggerSelector = (state)=>{
    return Object.values(state.triggers).some((trigger)=>trigger.isIntersecting);
};
const $1165e4d835f8e920$var$useHasIntersectingTriggerHook = (0, $iouul.createHook)($1165e4d835f8e920$var$store, {
    selector: $1165e4d835f8e920$var$hasIntersectingTriggerSelector
});
const $1165e4d835f8e920$export$e134485de3777bd2 = ()=>{
    const [hasIntersectingTrigger] = $1165e4d835f8e920$var$useHasIntersectingTriggerHook();
    return hasIntersectingTrigger;
};
const $1165e4d835f8e920$export$7f622cc0692430e8 = ()=>{
    const [{ widgetVisibility: widgetVisibility }] = $1165e4d835f8e920$var$useAiSearchStore();
    return {
        isTriggerVisible: widgetVisibility !== 'visible'
    };
};

});

parcelRegister("cTks9", function(module, exports) {
$parcel$export(module.exports, "AiSearchInput", () => $202258effc9a4b62$export$39dac845faefc1b);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $ekURY = parcelRequire("ekURY");

var $gFdUI = parcelRequire("gFdUI");

var $2R0Mk = parcelRequire("2R0Mk");

var $5qQbE = parcelRequire("5qQbE");

var $iHuYE = parcelRequire("iHuYE");

var $2Fcnn = parcelRequire("2Fcnn");
const $202258effc9a4b62$var$formStyles = null;
const $202258effc9a4b62$var$hiddenStyles = null;
const $202258effc9a4b62$export$39dac845faefc1b = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ className: className, hidden: hidden, onChange: onChange, onSubmit: onSubmit, value: value }, ref)=>{
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const id = (0, $4fqPo.useId)();
    const formLabelledById = `form-${id}-description`;
    const handleSubmit = (e)=>{
        e.preventDefault();
        const formData = new FormData(e.currentTarget);
        const message = formData.get('message');
        if (typeof message !== 'string') throw new Error('Message is not a string');
        onSubmit({
            message: message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("form", {
        ref: ref,
        "aria-hidden": hidden,
        // eslint-disable-next-line
        className: (0, $ltgDR.default)([
            "_v56410bs _1e0c1txw _4cvr1h6o _1bsb1ns9 _m6k4gioh _w6ng15vq _t9ecmk3q",
            hidden && "_lcxvglyw _tzy4idpf _3um015vq",
            className
        ]),
        "aria-labelledby": formLabelledById,
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gFdUI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), {
        id: formLabelledById
    }, formatMessage((0, $2Fcnn.messages).searchFieldDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2R0Mk.SearchTrigger), {
        value: value,
        onChange: onChange,
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("label", {
            htmlFor: id
        }, formatMessage((0, $2Fcnn.messages).searchPlaceholder)),
        submitButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iHuYE.SearchTriggerSubmitButton), {
            as: "button",
            type: "submit"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qQbE.SearchTriggerInputElement), {
        id: id,
        inputLabel: formatMessage((0, $2Fcnn.messages).searchInputLabel)
    })));
});

});
parcelRegister("2R0Mk", function(module, exports) {
$parcel$export(module.exports, "SearchTrigger", () => $66606cbf5edb2fe3$export$d846b13db73b361e);
/* main.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $jmL6n = parcelRequire("jmL6n");

var $gFdUI = parcelRequire("gFdUI");

var $kKH43 = parcelRequire("kKH43");
const $66606cbf5edb2fe3$var$EXPANDED_WIDTH = '320px';
const $66606cbf5edb2fe3$var$rootStyles = null;
const $66606cbf5edb2fe3$var$hoverFocusStyles = null;
const $66606cbf5edb2fe3$var$expandedStyles = null;
const $66606cbf5edb2fe3$var$boxStyles = null;
const $66606cbf5edb2fe3$var$subtlePlaceholderStyles = null;
const $66606cbf5edb2fe3$var$layoutStyles = null;
const $66606cbf5edb2fe3$var$inputContainerStyles = null;
const $66606cbf5edb2fe3$var$labelOverlayStyles = null;
const $66606cbf5edb2fe3$var$buttonContainerStyles = null;
const $66606cbf5edb2fe3$export$d846b13db73b361e = ({ children: children, value: value = '', onChange: onChange, placeholder: placeholder, submitButton: submitButton, interactive: interactive = true })=>{
    const [isHovered, setIsHovered] = (0, $4fqPo.useState)(false);
    const [isFocused, setIsFocused] = (0, $4fqPo.useState)(false);
    const isAtRest = value.length === 0 && !isFocused;
    const isExpanded = !isAtRest || isHovered;
    const VisuallyHiddenPlaceholder = isFocused || value.length > 0 ? (0, $gFdUI.default) : (0, $4fqPo.Fragment);
    const contextValue = (0, $4fqPo.useMemo)(()=>{
        return {
            isExpanded: isExpanded,
            isHovered: isHovered,
            isFocused: isFocused,
            setIsHovered: setIsHovered,
            setIsFocused: setIsFocused,
            value: value,
            onChange: onChange,
            isAtRest: isAtRest,
            interactive: interactive
        };
    }, [
        isExpanded,
        isHovered,
        isFocused,
        value,
        onChange,
        isAtRest,
        interactive
    ]);
    const mouseEnterLeaverProps = interactive ? {
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    } : {};
    return /*#__PURE__*/ $4fqPo.createElement((0, $kKH43.SearchTriggerInputContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_v564130x _1bsbp3fh _m6k41jlu",
            interactive && "_195pnklw _1chpnklw",
            interactive && isExpanded && "_1bsbnklw"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        ...mouseEnterLeaverProps,
        className: (0, $ltgDR.default)([
            "_2rko1rr0 _zulp12x7 _v5641yk7 _11c81d4k _1h6dysee _1dqonqa1 _1bsb1osq _vchhusvi _1e0c1txw _4cvr1fhb _bfhkvuon _16qst7xp _tzy4kb7n _3um0ewfl _w6ng15vq _t9ecmk3q _y4tiu2gc _syazi7uo _4t3i8vuz"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1bsb1osq"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_kqswh2mm _1bsb1osq"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp12x7 _1wpz1h6o _1e0c1txw _kqswstnw _1ltvpxbi _154iidpf _94n5idpf _lcxvglyw _80om1kdv",
            isAtRest && "_syaz1rpy"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmL6n))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ $4fqPo.createElement(VisuallyHiddenPlaceholder, null, placeholder)), children), /*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_1wpz1h6o"
        ])
    }, submitButton)))));
};

});
parcelRegister("jmL6n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbcf1d1b12cba221f9c450106ed39371>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1949bd50fcdec75$var$_react = $e1949bd50fcdec75$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $e1949bd50fcdec75$var$_baseNew = $e1949bd50fcdec75$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $e1949bd50fcdec75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for white label Rovo experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e1949bd50fcdec75$var$AiChatIcon = (props)=>/*#__PURE__*/ $e1949bd50fcdec75$var$_react.default.createElement($e1949bd50fcdec75$var$_baseNew.default, Object.assign({
        name: "AiChatIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3.125C14.5 2.504 13.996 2 13.375 2H2.625C2.004 2 1.5 2.504 1.5 3.125v10.832L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125zm1.5 8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25V3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125z"/><path fill="currentcolor" d="M5 6.25a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/>`
    }, props));
$e1949bd50fcdec75$var$AiChatIcon.displayName = 'AiChatIcon';
var $e1949bd50fcdec75$var$_default = module.exports.default = $e1949bd50fcdec75$var$AiChatIcon;

});

parcelRegister("kKH43", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputContext", () => $28a0e7a83079be1e$export$9cec4f4bc0c5ec28);
$parcel$export(module.exports, "useSearchTriggerInput", () => $28a0e7a83079be1e$export$ffbcaaf65823abae);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");
const $28a0e7a83079be1e$export$9cec4f4bc0c5ec28 = /*#__PURE__*/ (0, $4fqPo.createContext)(null);
const $28a0e7a83079be1e$export$ffbcaaf65823abae = ()=>{
    const context = (0, $4fqPo.useContext)($28a0e7a83079be1e$export$9cec4f4bc0c5ec28);
    if (!context) throw new Error('useSearchTriggerInput must be used within a SearchTriggerInputProvider');
    return context;
};

});


parcelRegister("5qQbE", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerInputElement", () => $1903ccb74c1324cc$export$42ccbc2c6177b53f);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $kKH43 = parcelRequire("kKH43");
const $1903ccb74c1324cc$var$inputStyles = null;
const $1903ccb74c1324cc$export$42ccbc2c6177b53f = ({ id: id, inputLabel: inputLabel })=>{
    const { value: value, onChange: onChange, setIsFocused: setIsFocused } = (0, $kKH43.useSearchTriggerInput)();
    // store the local value in state to avoid the input being "locked in" as a Latin character
    const [localValue, setLocalValue] = (0, $4fqPo.useState)(value);
    const isComposingRef = (0, $4fqPo.useRef)(false);
    // Sync local value with controlled value when not composing
    (0, $4fqPo.useEffect)(()=>{
        if (!isComposingRef.current) setLocalValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ $4fqPo.createElement("input", {
        "data-testid": "csm-ai-search-input",
        id: id,
        value: localValue,
        name: "message",
        onChange: (e)=>{
            const newValue = e.currentTarget.value;
            setLocalValue(newValue);
            // Only propagate to parent when not composing (IME input)
            // This fixes Japanese/Chinese/Korean input where the first character
            // would otherwise be "locked in" as a Latin character
            if (!isComposingRef.current) onChange === null || onChange === void 0 || onChange(newValue);
        },
        onCompositionStart: ()=>{
            isComposingRef.current = true;
        },
        onCompositionEnd: (e)=>{
            isComposingRef.current = false;
            // Commit the final composed value after IME conversion completes
            onChange === null || onChange === void 0 || onChange(e.currentTarget.value);
        },
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false),
        autoComplete: "off",
        spellCheck: "false",
        "aria-label": inputLabel,
        className: (0, $ltgDR.default)([
            "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _11c81d4k _r06hglyw _bfhk1j28 _4t3i1osq _1bsb1osq _syazi7uo _vchhusvi _1q51idpf _85i5idpf _bozgoahv _y4tiu2gc"
        ])
    });
};

});

parcelRegister("iHuYE", function(module, exports) {
$parcel$export(module.exports, "SearchTriggerSubmitButton", () => $dad09f65dfbaf0dc$export$c4e4405f3e81e277);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $4MCQn = parcelRequire("4MCQn");

var $50ejo = parcelRequire("50ejo");

var $kKH43 = parcelRequire("kKH43");

var $eRQBi = parcelRequire("eRQBi");
// TODO: connect with ADS to figure out the best approach to use dynamic value with cssMap, to avoid manually use the csm token
const $dad09f65dfbaf0dc$var$styles = {
    pressable: "_2rko1qll _19itglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1h1tkb7n _4t3i14no _1tkezwfg _bfhki8nm _13ix1yyw _mizu1g87",
    usedState: "_bfhk1y25 _30l3czge _irr31hsi _9h8h15cr _1di6jowl",
    cursorPointer: "_80omtlke"
};
const $dad09f65dfbaf0dc$export$c4e4405f3e81e277 = ({ ...props })=>{
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const { isExpanded: isExpanded, interactive: interactive } = (0, $kKH43.useSearchTriggerInput)();
    const isDimmed = !isExpanded;
    if (props.as === 'button') {
        const { as: _, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("button", {
            "aria-disabled": isDimmed,
            ...rest,
            className: (0, $ltgDR.default)([
                $dad09f65dfbaf0dc$var$styles.pressable,
                $dad09f65dfbaf0dc$var$styles.cursorPointer,
                interactive && !isDimmed && $dad09f65dfbaf0dc$var$styles.usedState
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50ejo))), {
            label: formatMessage((0, $eRQBi.messages).searchButtonLabel)
        }));
    }
    const { as: _, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ...rest,
        className: (0, $ltgDR.default)([
            $dad09f65dfbaf0dc$var$styles.pressable,
            interactive && !isDimmed && $dad09f65dfbaf0dc$var$styles.usedState
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50ejo))), {
        label: formatMessage((0, $eRQBi.messages).searchButtonLabel)
    }));
};

});
parcelRegister("50ejo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::702c7642ca2bbc12ec1dc2b75efbc1ea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a480ddc6d2ca749$var$_react = $3a480ddc6d2ca749$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $3a480ddc6d2ca749$var$_baseNew = $3a480ddc6d2ca749$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $3a480ddc6d2ca749$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a480ddc6d2ca749$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $3a480ddc6d2ca749$var$_react.default.createElement($3a480ddc6d2ca749$var$_baseNew.default, Object.assign({
        name: "ArrowRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$3a480ddc6d2ca749$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $3a480ddc6d2ca749$var$_default = module.exports.default = $3a480ddc6d2ca749$var$ArrowRightIcon;

});

parcelRegister("eRQBi", function(module, exports) {
$parcel$export(module.exports, "messages", () => $d0184bb6d3edcc02$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $d0184bb6d3edcc02$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    searchButtonLabel: {
        id: 'csm.chat.widget.search.trigger.search.button.label.non-fin',
        defaultMessage: 'Search with AI',
        description: 'label for the CSM chat widget search trigger button'
    }
});

});


parcelRegister("2Fcnn", function(module, exports) {
$parcel$export(module.exports, "messages", () => $7ede0c2baad7a0f4$export$defe85febe8b728c);

var $6BhDL = parcelRequire("6BhDL");
const $7ede0c2baad7a0f4$export$defe85febe8b728c = (0, $6BhDL.defineMessages)({
    searchPlaceholder: {
        id: 'csm.chat.widget.search.trigger.search.placeholder',
        defaultMessage: 'Ask anything',
        description: 'placeholder for the CSM chat widget search trigger input'
    },
    searchFieldDescription: {
        id: 'csm.chat.widget.search.trigger.search.field.description',
        defaultMessage: 'Submit your question to get chat with and get answers from our AI assistant',
        description: 'Describes that the input field upon submission will trigger the chat widget'
    },
    searchInputLabel: {
        id: 'csm.chat.widget.search.trigger.search.input.label',
        defaultMessage: 'Chat search trigger input',
        description: 'Accessibility label for chat search input'
    }
});

});





parcelRegister("ca43F", function(module, exports) {
$parcel$export(module.exports, "HubsDocumentTitle", () => $835330e31697828c$export$9b71b60159f818b1);

var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $3nx4r = parcelRequire("3nx4r");
const $835330e31697828c$export$9b71b60159f818b1 = ({ title: title, shouldRenderDocumentTitle: shouldRenderDocumentTitle, children: children })=>{
    if (!title || !shouldRenderDocumentTitle) return /*#__PURE__*/ (0, $lhXNe.jsx)((0, $lhXNe.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $lhXNe.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3nx4r))), {
        title: title,
        children: children
    });
};

});

parcelRegister("gAHz7", function(module, exports) {
$parcel$export(module.exports, "default", () => $84bfaee4bd92789b$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $84bfaee4bd92789b$var$_default_1 = (0, $6BhDL.defineMessages)({
    hubLoadingSpinnerLabel: {
        id: 'company-hub.hub.loading-spinner-label',
        defaultMessage: 'Loading hub',
        description: 'Accessible label for the loading spinner shown while the company hub page is being loaded.'
    }
});
var $84bfaee4bd92789b$export$2e2bcd8739ae039 = $84bfaee4bd92789b$var$_default_1;

});


parcelRegister("hF8ms", function(module, exports) {
$parcel$export(module.exports, "getContentWidth", () => $1ebae722d1f021de$export$f61abf052f87399f);
$parcel$export(module.exports, "withBannerBackgroundColor", () => $1ebae722d1f021de$export$f6b6d100e7beb8c8);

var $lhXNe = parcelRequire("lhXNe");
parcelRequire("4fqPo");

var $iySE3 = parcelRequire("iySE3");
// 800px is normal width
const $1ebae722d1f021de$var$GRID_NORMAL_WIDTH = '800px';
// 1000px is wide width
const $1ebae722d1f021de$var$GRID_WIDE_WIDTH = '1000px';
// 1100px is extra wide width
const $1ebae722d1f021de$var$GRID_XWIDE_WIDTH = '1100px';
// 1200px is extra wide width
const $1ebae722d1f021de$var$GRID_XXWIDE_WIDTH = '1200px';
const $1ebae722d1f021de$var$GRID_NOTE_WIDTH = '480px';
const $1ebae722d1f021de$var$GRID_FULL_WIDTH = '100%';
const $1ebae722d1f021de$export$f61abf052f87399f = (appearance)=>{
    switch(appearance){
        case 'xxwide':
            return $1ebae722d1f021de$var$GRID_XXWIDE_WIDTH;
        case 'xwide':
            return $1ebae722d1f021de$var$GRID_XWIDE_WIDTH;
        case 'wide':
            return $1ebae722d1f021de$var$GRID_WIDE_WIDTH;
        case 'note':
            return $1ebae722d1f021de$var$GRID_NOTE_WIDTH;
        case 'full-width':
            return $1ebae722d1f021de$var$GRID_FULL_WIDTH;
        default:
            return $1ebae722d1f021de$var$GRID_NORMAL_WIDTH;
    }
};
const $1ebae722d1f021de$export$f6b6d100e7beb8c8 = (InnerComponent)=>{
    return (props)=>{
        const hubContext = (0, $iySE3.useHubContext)();
        const bannerBackgroundColor = hubContext.branding.colors.primary;
        return /*#__PURE__*/ (0, $lhXNe.jsx)(InnerComponent, {
            ...props,
            bannerBackgroundColor: bannerBackgroundColor
        });
    };
};

});


parcelRegister("clJ4z", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => (parcelRequire("l9neZ")).HubAnonymousLayout);
parcelRequire("l9neZ");

});
parcelRegister("l9neZ", function(module, exports) {
$parcel$export(module.exports, "HubAnonymousLayout", () => $db60473189b94915$export$ae9644df85d50589);
/* hub-anonymous-layout.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $bpWyP = parcelRequire("bpWyP");

var $awGaB = parcelRequire("awGaB");
const $db60473189b94915$var$anonymousStyles = null;
const $db60473189b94915$export$ae9644df85d50589 = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _vchhusvi _1e0c1txw _2lx21bp4 _19pk1ai2 _18u01wug _2hwx1wug _1bsb1osq _p12f1osq _1tke1586 _1wpz1y6m _1c421osq _138yidpf"
        ]),
        style: {
            "--_19v4s1f-": (0, $3f61e.default)($bpWyP.multiple(15).unitless, "px", "-"),
            "--_jnopm3": (0, $3f61e.default)($bpWyP.multiple(52).unitless, "px")
        }
    }, /*#__PURE__*/ $4fqPo.createElement((0, $awGaB.NoteBackground), null, children));

});


parcelRegister("aqBAS", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => (parcelRequire("jmhVl")).HubAvatarMenuOptions);

var $jmhVl = parcelRequire("jmhVl");

});
parcelRegister("jmhVl", function(module, exports) {
$parcel$export(module.exports, "HubAvatarMenuOptions", () => $12446decbad2f918$export$4f0698e82fb00313);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1P8FK = parcelRequire("1P8FK");

var $eiGUu = parcelRequire("eiGUu");

var $f4IfF = parcelRequire("f4IfF");

var $6mmHn = parcelRequire("6mmHn");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $ev2wS = parcelRequire("ev2wS");

var $6bGmX = parcelRequire("6bGmX");

var $hHIxn = parcelRequire("hHIxn");
var $45ZUo = parcelRequire("45ZUo");

var $3dLJl = parcelRequire("3dLJl");

var $k16VK = parcelRequire("k16VK");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");
parcelRequire("4Vvkl");
var $6BARu = parcelRequire("6BARu");

var $kOVZG = parcelRequire("kOVZG");

var $VwY1I = parcelRequire("VwY1I");
const $12446decbad2f918$var$HubAvatarMenuOptionsComponent = ({ fetchUser: fetchUser, fetchUserRequestsCounts: fetchUserRequestsCounts, fetchOrganisations: fetchOrganisations, canAdministerJIRA: canAdministerJIRA, myRequestCount: myRequestCount = 0, pendingApprovalCount: pendingApprovalCount = 0, approvalCount: approvalCount = 0 })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [{ match: match }] = (0, $hfD9S.useRouter)();
    // Fetch user data and request counts on component mount
    (0, $4fqPo.useEffect)(()=>{
        fetchUser();
        fetchOrganisations();
        fetchUserRequestsCounts();
    }, [
        fetchUser,
        fetchOrganisations,
        fetchUserRequestsCounts
    ]);
    // Calculate total pending items for badges
    const totalRequestsCount = myRequestCount || 0;
    const totalApprovalsCount = pendingApprovalCount || 0;
    const { portalId: portalId, id: pageId } = match.params;
    const showApprovals = approvalCount > 0 || pendingApprovalCount > 0;
    const helpCenterAri = (0, $6mmHn.getHelpCenterAri)();
    const helpCenterId = (0, $kOVZG.parseHelpCenterAri)(helpCenterAri).helpCenterId;
    let editHubSuffix = '';
    if (portalId) editHubSuffix = `/portal/${portalId}`;
    else if (pageId) editHubSuffix = `/${pageId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, !(0, $6bGmX.default).checkGate('hub_component_upgrade') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: (0, $1P8FK.Link),
        actionSubjectId: "navbarUserRequests",
        to: "/user/requests?reporter=all&statuses=open",
        iconAfter: totalRequestsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ev2wS.default), null, totalRequestsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $VwY1I.default).requests)), showApprovals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: (0, $1P8FK.Link),
        actionSubjectId: "navbarUserApprovals",
        to: "/user/approvals",
        iconAfter: totalApprovalsCount > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ev2wS.default), null, totalApprovalsCount) : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $VwY1I.default).approvals))), canAdministerJIRA && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: (0, $eiGUu.HtmlAnchor),
        actionSubjectId: "navbarCustomiseHub",
        href: `/helpcenter-management/${helpCenterId}/edit-hub${editHubSuffix}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $VwY1I.default).customiseHub)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hHIxn.default), {
        component: (0, $eiGUu.HtmlAnchor),
        actionSubjectId: "navbarHubSettings",
        href: `/helpcenter-management/hubs`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $VwY1I.default).hubSettings))));
};
const $12446decbad2f918$var$mapStateToProps = (state)=>{
    const userRequestsCounts = (0, $6BARu.getUserRequestsCounts)(state);
    return {
        myRequestCount: userRequestsCounts.myRequestCount,
        pendingApprovalCount: userRequestsCounts.pendingApprovalCount,
        approvalCount: userRequestsCounts.approvalCount,
        canAdministerJIRA: (0, $2hx7o.getCanAdministerJIRA)(state)
    };
};
const $12446decbad2f918$export$4f0698e82fb00313 = (0, $bmgw6.default)($12446decbad2f918$var$mapStateToProps, {
    fetchUser: (0, $f4IfF.fetchUserModelAction),
    fetchUserRequestsCounts: (0, $k16VK.fetchUserRequestsCountsAction),
    fetchOrganisations: (0, $3dLJl.fetchOrganisationsModelAction)
})($12446decbad2f918$var$HubAvatarMenuOptionsComponent);

});
parcelRegister("kOVZG", function(module, exports) {
$parcel$export(module.exports, "parseHelpCenterAri", () => $1d83fc4e0b01bb0d$export$2b81f3445e8c13f4);
$parcel$export(module.exports, "getHelpCenterId", () => $1d83fc4e0b01bb0d$export$7ac65eebc1dbe637);
$parcel$export(module.exports, "createHelpCenterAri", () => $1d83fc4e0b01bb0d$export$dbcb6d0534e1f531);
// eslint-disable-next-line no-restricted-imports

var $4oTiM = parcelRequire("4oTiM");
const $1d83fc4e0b01bb0d$export$2b81f3445e8c13f4 = (helpCenterAri)=>{
    const isValidAri = (0, $4oTiM.HelpHelpCenterAri).check(helpCenterAri) && helpCenterAri !== 'null' && helpCenterAri !== '';
    return isValidAri ? (0, $4oTiM.HelpHelpCenterAri).parse(helpCenterAri) : {
        helpCenterId: ''
    };
};
const $1d83fc4e0b01bb0d$export$7ac65eebc1dbe637 = (helpCenterAri)=>{
    const { helpCenterId: helpCenterId } = $1d83fc4e0b01bb0d$export$2b81f3445e8c13f4(helpCenterAri);
    return helpCenterId;
};
const $1d83fc4e0b01bb0d$export$dbcb6d0534e1f531 = (activationId, helpCenterId)=>{
    if (!helpCenterId || !activationId || helpCenterId === 'null' || activationId === 'null') return '';
    return (0, $4oTiM.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
};

});

parcelRegister("VwY1I", function(module, exports) {
$parcel$export(module.exports, "default", () => $bce30b88cedbf2f0$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $bce30b88cedbf2f0$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    requests: {
        defaultMessage: 'Requests',
        description: 'Requests item in hub avatar menu',
        id: 'hub.avatar.menu.requests'
    },
    approvals: {
        defaultMessage: 'Approvals',
        description: 'Approvals item in hub avatar menu',
        id: 'hub.avatar.menu.approvals'
    },
    customiseHub: {
        defaultMessage: 'Customise help center',
        description: 'Customise hub item in hub avatar menu',
        id: 'hub.avatar.menu.customise.hub'
    },
    hubSettings: {
        defaultMessage: 'Help center settings',
        description: 'Hub settings item in hub avatar menu',
        id: 'hub.avatar.menu.hub.settings'
    }
});

});



parcelRegister("bVASc", function(module, exports) {
$parcel$export(module.exports, "RequestList", () => $6417563cfb84a2f5$export$c58d16d73d0428fb);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $6417563cfb84a2f5$export$c58d16d73d0428fb = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("5EiCK")).then((module)=>{
            const { registerRequestsListEpicsndReducers: registerRequestsListEpicsndReducers } = module;
            registerRequestsListEpicsndReducers();
            return module.default;
        }), {
        moduleId: "./src/view/request-list/hocs.tsx"
    })
});

});
parcelRegister("5EiCK", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("kACqZ"),
    $e46AW("eHh8C")
]).then(()=>parcelRequire('hjbMa'));

});


parcelRegister("3s5vo", function(module, exports) {
$parcel$export(module.exports, "CsmUserProfileForHubs", () => $2b6ceb395c9e35f4$export$eca04c8a7924030c);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $2b6ceb395c9e35f4$export$eca04c8a7924030c = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cfyaP")), {
        moduleId: "./src/view/user-profile/csm-hub-variants/csm-hub-variants.tsx"
    })
});

});
parcelRegister("cfyaP", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("1oLOq"),
    $e46AW("g3iUw")
]).then(()=>parcelRequire('2Irt7'));

});


parcelRegister("3FOgc", function(module, exports) {
$parcel$export(module.exports, "UserProfileForHubs", () => $33d6ff2e531284d7$export$4c16441af2ce2701);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

const $33d6ff2e531284d7$var$loader = (0, $60vf0.lazyForPaint)(()=>{
    return (parcelRequire("616KB"));
}, {
    ssr: true,
    moduleId: "./src/view/user-profile/hub-variant/hub-variant.tsx"
});
const $33d6ff2e531284d7$export$4c16441af2ce2701 = (0, $gi5ak.default)({
    loader: $33d6ff2e531284d7$var$loader
});

});
parcelRegister("616KB", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("1oLOq"),
    $e46AW("dJknP")
]).then(()=>parcelRequire('8qb3A'));

});


parcelRegister("dWTpx", function(module, exports) {
$parcel$export(module.exports, "HUB_ROUTES", () => $115b16b29a6d7fc3$export$89e88c91b6499ccb);

var $1XMNp = parcelRequire("1XMNp");
const $115b16b29a6d7fc3$export$89e88c91b6499ccb = {
    USER_PROFILE: {
        path: '/user/profile',
        name: 'hubs-user-profile'
    },
    REQUESTS_LIST: {
        path: '/user/requests',
        name: 'requests-list'
    },
    CSM_REQUESTS_LIST: {
        path: '/user/requests',
        name: 'csm-requests-list'
    },
    CSM_CONTACT_US: {
        path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
        name: 'contact-us'
    },
    NOT_FOUND: {
        path: '(.*)',
        name: 'hubs-not-found-error-page'
    },
    CSM_FOLDER: {
        path: '/folder/:folderId',
        name: 'csm-folder'
    },
    CSM_REQUEST_DETAILS: {
        path: '/user/requests/:requestKey',
        name: 'csm-request-details'
    },
    VIEW_PORTAL_ARTICLE: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/article/:articleId`,
        name: 'hubs-view-portal-kb-article'
    },
    PORTAL_ACCESS_FORBIDDEN: {
        path: '/user/forbidden',
        name: 'hubs-portal-access-forbidden'
    },
    VIEW_ARTICLE: {
        path: '/article/:articleId',
        name: 'hubs-view-kb-article'
    },
    VIEW_KB_ARTICLE: {
        path: '/kb/view/:pageId',
        name: 'hubs-view-kb-article'
    },
    VIEW_CROSS_SITE_PORTAL_ARTICLE: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/cloudId/:cloudId/article/:articleId`,
        name: 'hubs-view-portal-cross-site-kb-article'
    },
    VIEW_CROSS_SITE_ARTICLE: {
        path: '/cloudId/:cloudId/article/:articleId',
        name: 'hubs-view-kb-cross-site-article'
    },
    LOGIN: {
        path: '/user/login',
        name: 'hubs-login'
    },
    PORTAL_LOGIN: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/login`,
        name: 'hubs-portal-login'
    },
    SIGNUP: {
        path: '/user/signup',
        name: 'hubs-user-signup'
    },
    PORTAL_SIGNUP: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/signup`,
        name: 'hubs-portal-signup'
    },
    COMPLETE_SIGNUP: {
        path: '/user/complete-signup',
        name: 'hubs-user-complete-signup'
    },
    PORTAL_COMPLETE_SIGNUP: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/complete-signup`,
        name: 'hubs-portal-complete-signup'
    },
    RESET_PASSWORD: {
        path: '/user/resetpassword',
        name: 'hubs-user-reset-password'
    },
    PORTAL_RESET_PASSWORD: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/resetpassword`,
        name: 'hubs-portal-reset-password'
    },
    CHECK_EMAIL: {
        path: '/user/check-email',
        name: 'hubs-user-checkmail'
    },
    PORTAL_INVITED_SIGNUP: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/user/visitportal`,
        name: 'hubs-portal-invited-signup'
    },
    UNSUBSCRIBE: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/:requestKey/unsubscribe`,
        name: 'hubs-unsubscribe'
    },
    REQUEST_FEEDBACK: {
        path: `${(0, $1XMNp.PORTAL_ROUTE_PREFIX)}/:requestKey/feedback`,
        name: 'jsm-hubs-request-feedback'
    },
    REQUEST_CREATE: {
        path: `/portal/:portalId/create/:requestTypeId`,
        name: 'jsm-hubs-request-create'
    },
    ANONYMOUS_REQUEST_SUCCESS: {
        path: `/portal/:portalId/create/:requestTypeId/confirm`,
        name: 'jsm-hubs-anonymous-request-success'
    },
    JSM_REQUEST_DETAILS: {
        path: `/portal/:portalId/:requestKey`,
        name: 'jsm-hubs-request-details'
    },
    JSM_REQUESTS_LIST: {
        path: `/user/requests`,
        name: 'jsm-hubs-requests-list'
    },
    JSM_APPROVALS: {
        path: `/user/approvals`,
        name: 'jsm-hubs-approvals'
    },
    JSM_REQUEST_APPROVAL: {
        path: `/portal/:portalId/:requestKey/approval/:approvalId/:decision`,
        name: 'jsm-hubs-request-approval'
    },
    HUB_ARTICLES: {
        name: 'view-kb-article',
        path: `/article/:articleId`
    },
    HUB_KB_PAGE: {
        name: 'view-kb-page',
        path: `/kb/view/:pageId`
    },
    HUB_CROSS_SITE_ARTICLE: {
        name: 'view-kb-cross-site-article',
        path: `/cloudId/:cloudId/article/:articleId`
    },
    SURVEY: {
        name: 'survey',
        path: `/portal/:portalId/survey/:surveyId`
    }
};

});



parcelRegister("kuWHC", function(module, exports) {
$parcel$export(module.exports, "routeWithAiWidgetConfigResource", () => $cac7d0cf79fc25d2$export$66e676d5e26b883e);

var $ltBZF = parcelRequire("ltBZF");
const $cac7d0cf79fc25d2$export$66e676d5e26b883e = (route)=>{
    return {
        ...route,
        resources: [
            ...route.resources ?? [],
            (0, $ltBZF.csmSupportWidgetConfigQueryResource)
        ]
    };
};

});
parcelRegister("ltBZF", function(module, exports) {
$parcel$export(module.exports, "csmSupportWidgetConfigQueryResource", () => $2dda9dad8946375b$export$157d87119e3de36e);

var $6mmHn = parcelRequire("6mmHn");

var $fZppw = parcelRequire("fZppw");

var $11yxJ = parcelRequire("11yxJ");
const $2dda9dad8946375b$export$157d87119e3de36e = (0, $fZppw.createRelayResource)({
    type: 'CSM_SUPPORT_WIDGET_CONFIG_QUERY',
    getQuery: ()=>({
            parameters: (0, $11yxJ.default),
            variables: {
                helpCenterAri: (0, $6mmHn.getMeta)('help-center-ari') ?? '',
                cloudId: (0, $6mmHn.getMeta)('tenant-id') ?? ''
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        })
});

});
parcelRegister("11yxJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b690fc5cbc1788dd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e731c73daa3a4aec33ba4801f79f5543>>
 * @relayHash 35cdd10bfcb6c0124f988dd9e3d183e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa
const $b690fc5cbc1788dd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "primary"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "position"
            },
            {
                "concreteType": "CsmAiWidgetBrandingTheme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorVibeVariant"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "radius"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "space"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "chatColor"
                    }
                ]
            }
        ],
        "type": "CsmAiWidgetConfig"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "supportWidgetConfigProviderQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v3 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "csmAi_getSupportWidget",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "d93156dd0e55b54047f4b0df951ba8d0f7f5944745c9fc2a6f47738f320285fa",
            "metadata": {},
            "name": "supportWidgetConfigProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b690fc5cbc1788dd$var$node.hash = "7afba16f32baf97fd3ce09f41645b442";
var $b690fc5cbc1788dd$export$2e2bcd8739ae039 = $b690fc5cbc1788dd$var$node;

});



parcelRegister("6ITor", function(module, exports) {
$parcel$export(module.exports, "default", () => $c48d7cfebc0bb03f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $el3DQ = parcelRequire("el3DQ");

var $bG6ob = parcelRequire("bG6ob");

var $l9AOu = parcelRequire("l9AOu");

var $dfktK = parcelRequire("dfktK");

parcelRequire("l8iRu");
var $7H5nz = parcelRequire("7H5nz");
var $8NB5B = parcelRequire("8NB5B");

var $bTtiN = parcelRequire("bTtiN");

var $dfMEw = parcelRequire("dfMEw");

var $7XSXo = parcelRequire("7XSXo");

var $j7rgu = parcelRequire("j7rgu");

var $icLcd = parcelRequire("icLcd");

var $3zvSe = parcelRequire("3zvSe");

var $47xIg = parcelRequire("47xIg");

var $jYI2M = parcelRequire("jYI2M");

var $18hBH = parcelRequire("18hBH");

var $9bbBv = parcelRequire("9bbBv");

var $8xPh7 = parcelRequire("8xPh7");

var $hnpj5 = parcelRequire("hnpj5");

var $6WWzZ = parcelRequire("6WWzZ");

var $3Qwj5 = parcelRequire("3Qwj5");

var $6FTHb = parcelRequire("6FTHb");

var $9M4IZ = parcelRequire("9M4IZ");

var $k05Lp = parcelRequire("k05Lp");

var $gQd3H = parcelRequire("gQd3H");

var $jddke = parcelRequire("jddke");

var $dq1KB = parcelRequire("dq1KB");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $4we4O = parcelRequire("4we4O");

var $6bGmX = parcelRequire("6bGmX");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3wR8f = parcelRequire("3wR8f");

var $5VtTl = parcelRequire("5VtTl");
parcelRequire("5FSYN");
var $cBf1I = parcelRequire("cBf1I");
var $a8eAa = parcelRequire("a8eAa");
const $c48d7cfebc0bb03f$export$2f7745f2f5ab3897 = ()=>{
    return [
        ...(0, $eSL4S.isAdvancedHelpCenter)() || (0, $eSL4S.isFlexiHCEnabledInDefaultHC)() ? [
            (0, $bTtiN.getViewHomePageRoute)(),
            (0, $bTtiN.getEditHomePageRoute)()
        ] : [],
        ...(0, $bG6ob.isEmailVerifiedSignalEnabled)() ? [
            (0, $dq1KB.userVerifyEmailRoute)
        ] : [],
        (0, $icLcd.viewPortalConversationPageRoute),
        (0, $dfMEw.aiAnswerRoute),
        (0, $j7rgu.consentFormRoute),
        (0, $8xPh7.loginRoute),
        (0, $k05Lp.userResetPasswordRoute),
        (0, $k05Lp.userSignupRoute),
        (0, $k05Lp.userCompleteSignupRoute),
        (0, $k05Lp.userCheckMailRoute),
        (0, $hnpj5.portalAccessForbiddenRoute),
        (0, $8xPh7.portalLoginRoute),
        (0, $k05Lp.portalSignupRoute),
        (0, $k05Lp.portalResetPasswordRoute),
        (0, $k05Lp.portalCompleteSignupRoute),
        (0, $k05Lp.portalInvitedSignupRoute),
        (0, $cBf1I.requestFeedbackRoute),
        (0, $cBf1I.unsubscribeRoute),
        (0, $18hBH.getHelpCenterRoute)(),
        (0, $bTtiN.getEditHomePageRoute)('edit-homepage', '/edit'),
        (0, $6FTHb.requestDetailsRoute),
        (0, $9bbBv.viewKbPageRoute),
        (0, $9bbBv.viewAllSearchResultsRoute),
        (0, $9bbBv.viewPortalAllSearchResultsRoute),
        (0, $9bbBv.viewPortalCategoryArticleRoute),
        (0, $9bbBv.viewPortalArticleRoute),
        (0, $9bbBv.viewCrossSitePortalArticleRoute),
        (0, $9bbBv.viewArticleRoute),
        (0, $9bbBv.viewCrossSiteArticleRoute),
        (0, $9M4IZ.requestsListRoute),
        (0, $7XSXo.approvalsRoute),
        (0, $3Qwj5.requestApprovalRoute),
        (0, $cBf1I.userProfileRoute),
        (0, $9bbBv.viewPortalKnowledgeCategoryRoute),
        (0, $cBf1I.anonymousRequestSuccessRoute),
        (0, $cBf1I.getRequestCreateRoute)(),
        ...(0, $bG6ob.isSurveysRouteEnabled)() ? [
            (0, $gQd3H.getSurveyRoute)()
        ] : [],
        (0, $6WWzZ.getPortalHomeRoutes)(),
        (0, $jYI2M.getEmbedCreateRequestRoute)(),
        (0, $jYI2M.embedSinglePortalRoute),
        (0, $jYI2M.embedKBArticleRoute),
        ...(0, $6bGmX.default).checkGate('embed_hc_featured_portals') ? [
            (0, $jYI2M.embedFeaturedPortalsRoute)
        ] : [],
        ...(0, $6bGmX.default).checkGate('jsm_portal_rovo_integration') ? [
            (0, $jYI2M.embedLoginSuccessRoute)
        ] : [],
        (0, $a8eAa.portalReorderRoute)(true),
        (0, $47xIg.editTopicRoute),
        (0, $47xIg.addTopicRoute),
        (0, $jddke.getViewTopicRoute)(),
        ...(0, $icLcd.getHelpCenterConversationPageRoute)(),
        ...(0, $bG6ob.isCustomPagesUiEnabled)() && (0, $ebpTf.getIsHCCustomizationEnabled)() ? [
            (0, $3zvSe.getEditCustomPageRoute)(),
            (0, $3zvSe.getViewCustomPageRoute)()
        ] : [],
        (0, $cBf1I.notFoundErrorRoute)
    ];
};
const $c48d7cfebc0bb03f$export$360df1dbfef16ccf = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $l9AOu.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $l9AOu.lightenColor)(themeColor);
    const routes = (0, $4fqPo.useMemo)(()=>$c48d7cfebc0bb03f$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $el3DQ.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8NB5B.Router), {
        routes: routes,
        history: (0, $3wR8f.default),
        isGlobal: false,
        plugins: [
            (0, $5VtTl.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dfktK.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4we4O.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7H5nz.RouteComponent), null)));
};
const $c48d7cfebc0bb03f$var$selector = (0, $3yyCx.createSelector)((0, $2mzxy.getHeadless), (0, $i8gmD.getThemeColor), (0, $i8gmD.getHelpCenterTitleColor), (headerless, themeColor, titleColor)=>({
        headerless: headerless,
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $c48d7cfebc0bb03f$export$2e2bcd8739ae039 = (0, $bmgw6.default)($c48d7cfebc0bb03f$var$selector)($c48d7cfebc0bb03f$export$360df1dbfef16ccf);

});
parcelRegister("icLcd", function(module, exports) {
$parcel$export(module.exports, "getHelpCenterConversationPageRoute", () => $77c3ccfedf1d8a5d$export$c0656a6d05f5099e);
$parcel$export(module.exports, "viewPortalConversationPageRoute", () => $77c3ccfedf1d8a5d$export$226a8310910111d5);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $748yq = parcelRequire("748yq");

var $bG6ob = parcelRequire("bG6ob");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
var $4g7Uv = parcelRequire("4g7Uv");

var $90W6u = parcelRequire("90W6u");
parcelRequire("ggpKN");
var $DwdLH = parcelRequire("DwdLH");

var $77W7U = parcelRequire("77W7U");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");
parcelRequire("amY7F");
var $c6d2J = parcelRequire("c6d2J");
parcelRequire("7PRRH");
var $7ZQaB = parcelRequire("7ZQaB");
var $a5CWL = parcelRequire("a5CWL");
var $6VEzt = parcelRequire("6VEzt");

var $6bGmX = parcelRequire("6bGmX");

var $Y85G3 = parcelRequire("Y85G3");
const $77c3ccfedf1d8a5d$var$Error = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a5CWL.Error), null);
const $77c3ccfedf1d8a5d$var$WrappedConversationPage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6VEzt.default), {
        renderError: $77c3ccfedf1d8a5d$var$Error,
        component: (0, $7ZQaB.HelpCenterConversationPage),
        screenName: (0, $748yq.ScreenName).CONVERSATION_PAGE,
        headerless: true,
        footerless: true
    });
const $77c3ccfedf1d8a5d$export$80dcf24036ea46a1 = ()=>{
    const WrappedComponent = (0, $bG6ob.isUnifiedHelpAddFilterForCustomerAccounts)() ? (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($77c3ccfedf1d8a5d$var$WrappedConversationPage, null)) : (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }), (0, $77W7U.default)())(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($77c3ccfedf1d8a5d$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
const $77c3ccfedf1d8a5d$export$ee1ce6de59399f4b = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const forbiddenPageOptions = {
        message: formatMessage((0, $7ZQaB.authPageMessage)),
        callToActionText: formatMessage((0, $7ZQaB.callToActionUrlText)),
        callToActionUrl: (0, $Y85G3.getHelpCenterUrl)()
    };
    const enhancer = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }), (0, $DwdLH.default)(forbiddenPageOptions));
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($77c3ccfedf1d8a5d$var$WrappedConversationPage, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
const $77c3ccfedf1d8a5d$export$c0656a6d05f5099e = ()=>{
    const viewConversationPageRoute = {
        name: (0, $748yq.ScreenName).CONVERSATION_PAGE,
        path: (0, $748yq.VA_ON_HC_CONVERSATION_PATH),
        exact: true,
        resources: [
            (0, $90W6u.HelpCenterVirtualAgentResource)
        ],
        component: $77c3ccfedf1d8a5d$export$80dcf24036ea46a1
    };
    return [
        {
            ...viewConversationPageRoute,
            component: $77c3ccfedf1d8a5d$export$ee1ce6de59399f4b
        }
    ];
};
const $77c3ccfedf1d8a5d$export$6cb15740fc92fb28 = (props)=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [isTestConversationParam] = (0, $4g7Uv.useQueryParam)('isTestConversation');
    const [isVSAAdoptionConversation] = (0, $4g7Uv.useQueryParam)('vsaAdoption');
    const [portalIdAsString] = (0, $eDygx.usePathParam)('portalId');
    const forbiddenPageOptions = {
        message: formatMessage((0, $7ZQaB.authPageMessage)),
        callToActionText: formatMessage((0, $7ZQaB.callToActionUrlText)),
        callToActionUrl: portalIdAsString ? `/portal/${portalIdAsString}` : (0, $Y85G3.getHelpCenterUrl)(),
        hideBanner: (0, $6bGmX.default).checkGate('jsm_vsa_adoption_flickering_issue_fix') && isVSAAdoptionConversation === 'true'
    };
    const enhancer = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }), ...isTestConversationParam === 'true' ? [
        (0, $c6d2J.default)(forbiddenPageOptions)
    ] : []);
    const WrappedComponent = enhancer(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6VEzt.default), {
            renderError: $77c3ccfedf1d8a5d$var$Error,
            component: (0, $7ZQaB.PortalConversationPage),
            screenName: (0, $748yq.ScreenName).CONVERSATION_PAGE,
            headerless: true,
            footerless: true
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props));
};
const $77c3ccfedf1d8a5d$export$226a8310910111d5 = {
    name: (0, $748yq.ScreenName).CONVERSATION_PAGE,
    path: (0, $748yq.VA_ON_PORTAL_CONVERSATION_PATH),
    exact: true,
    component: $77c3ccfedf1d8a5d$export$6cb15740fc92fb28
};

});
parcelRegister("90W6u", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $f87527d82de68bf4$export$7ab6648586bf1bbf);

var $bG6ob = parcelRequire("bG6ob");

var $fZppw = parcelRequire("fZppw");

var $eoUUM = parcelRequire("eoUUM");
const $f87527d82de68bf4$export$7ab6648586bf1bbf = (0, $fZppw.createRelayResource)({
    type: 'HELP_CENTER_CONVERSATION_PAGE',
    getQuery: (_, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        return {
            parameters: (0, $eoUUM.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: helpCenterAri,
                isVaOnHcGAEnabled: (0, $bG6ob.isVAOnHelpCenterGAEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("eoUUM", function(module, exports) {
$parcel$export(module.exports, "default", () => $bfd8019bd70f3d78$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2c16dcd22119d08ba4f182305bc93dc3>>
 * @relayHash edea8cab7174eb3853f7e72b44d7aa5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c115be58886ea6ac6426e499fd226521bc50f4439d42461efe307f31039df41
const $bfd8019bd70f3d78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isVaOnHcGAEnabled"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "virtualAgentEnabled"
            }
        ],
        "type": "HelpCenter"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v6 = {
        "condition": "isVaOnHcGAEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "VirtualAgentQueryApi",
                "kind": "LinkedField",
                "name": "virtualAgent",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "containerId",
                                "variableName": "helpCenterAri"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "virtualAgentAvailability"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConversationPageVirtualAgentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                v6 /*: any*/ 
            ]
        },
        "params": {
            "id": "3c115be58886ea6ac6426e499fd226521bc50f4439d42461efe307f31039df41",
            "metadata": {},
            "name": "ConversationPageVirtualAgentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$bfd8019bd70f3d78$var$node.hash = "c8de3321d0f65a7321d319b804610818";
var $bfd8019bd70f3d78$export$2e2bcd8739ae039 = $bfd8019bd70f3d78$var$node;

});


parcelRegister("ggpKN", function(module, exports) {
$parcel$export(module.exports, "withJsmAiConfigEnabled", () => (parcelRequire("DwdLH")).default);

var $DwdLH = parcelRequire("DwdLH");

});
parcelRegister("DwdLH", function(module, exports) {
$parcel$export(module.exports, "default", () => $88c726d4cc6ada39$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $748yq = parcelRequire("748yq");

var $MM3bs = parcelRequire("MM3bs");
parcelRequire("58htq");
var $2mzxy = parcelRequire("2mzxy");
parcelRequire("aHmOa");
var $hJsSa = parcelRequire("hJsSa");
const $88c726d4cc6ada39$var$selector = (0, $3yyCx.createSelector)((0, $2mzxy.getJsmAIConfigEnabled), (jsmAIConfigEnabled)=>({
        jsmAIConfigEnabled: jsmAIConfigEnabled
    }));
const $88c726d4cc6ada39$var$connector = (0, $bmgw6.default)($88c726d4cc6ada39$var$selector, null);
const $88c726d4cc6ada39$var$withJsmAiConfigEnabled = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { jsmAIConfigEnabled: jsmAIConfigEnabled } = props;
            if (jsmAIConfigEnabled) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $4fqPo.createElement((0, $hJsSa.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $4fqPo.createElement((0, $MM3bs.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $748yq.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        const ConnectedComponent = $88c726d4cc6ada39$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithJsmAiConfigEnabled';
        return ConnectedComponent;
    };
var $88c726d4cc6ada39$export$2e2bcd8739ae039 = $88c726d4cc6ada39$var$withJsmAiConfigEnabled;

});


parcelRegister("77W7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b1b793552a7bde9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $81eJ3 = parcelRequire("81eJ3");
const $0b1b793552a7bde9$var$selector = (0, $3yyCx.createSelector)((0, $2hx7o.isAtlassianAccountManaged), (isAtlassianAccount)=>({
        isAtlassianAccount: isAtlassianAccount
    }));
const $0b1b793552a7bde9$var$connector = (0, $bmgw6.default)($0b1b793552a7bde9$var$selector, null);
const $0b1b793552a7bde9$var$withOnlyAtlassianAccount = ()=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isAtlassianAccount: isAtlassianAccount } = props;
            if (isAtlassianAccount) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props);
            return /*#__PURE__*/ $4fqPo.createElement((0, $81eJ3.Redirect), {
                to: "/user/forbidden"
            });
        };
        const ConnectedComponent = $0b1b793552a7bde9$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'WithOnlyAtlassianAccount';
        return ConnectedComponent;
    };
var $0b1b793552a7bde9$export$2e2bcd8739ae039 = $0b1b793552a7bde9$var$withOnlyAtlassianAccount;

});

parcelRegister("amY7F", function(module, exports) {
$parcel$export(module.exports, "withOnlyProjectAdmin", () => (parcelRequire("c6d2J")).default);

var $c6d2J = parcelRequire("c6d2J");

});
parcelRegister("c6d2J", function(module, exports) {
$parcel$export(module.exports, "default", () => $f03d9b7f73abe2c7$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $748yq = parcelRequire("748yq");

var $MM3bs = parcelRequire("MM3bs");

var $bvB7a = parcelRequire("bvB7a");

var $63sfu = parcelRequire("63sfu");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
parcelRequire("6myLg");
var $lXazD = parcelRequire("lXazD");
parcelRequire("laOAz");
var $95tqy = parcelRequire("95tqy");
parcelRequire("aHmOa");
var $hJsSa = parcelRequire("hJsSa");
const $f03d9b7f73abe2c7$var$selector = (0, $3yyCx.createSelector)((state, props)=>{
    const portalIdAsString = props.match.params && props.match.params.portalId;
    if (portalIdAsString) return (0, $95tqy.getCanAdministerProject)(state, (0, $63sfu.toNumber)(portalIdAsString));
    return false;
}, (isProjectAdmin)=>({
        isProjectAdmin: isProjectAdmin
    }));
const $f03d9b7f73abe2c7$var$connector = (0, $bmgw6.default)($f03d9b7f73abe2c7$var$selector, {
    fetchPortals: (0, $lXazD.fetchPortalAction)
});
const $f03d9b7f73abe2c7$var$withOnlyProjectAdmin = (options)=>(WrappedComponent)=>{
        const ReturnComponent = (props)=>{
            const { isProjectAdmin: isProjectAdmin, fetchPortals: fetchPortals } = props;
            const [portalId] = (0, $eDygx.usePathParam)('portalId');
            $4fqPo.useEffect(()=>{
                if (isProjectAdmin === undefined && options.hideBanner) fetchPortals({
                    id: (0, $63sfu.toSafeInteger)(portalId),
                    expand: [
                        'kbs',
                        'reqTypes',
                        'reqGroups',
                        'orderMapping'
                    ]
                });
            }, [
                isProjectAdmin,
                fetchPortals,
                portalId
            ]);
            if (isProjectAdmin === undefined) return options.hideBanner ? /*#__PURE__*/ $4fqPo.createElement((0, $bvB7a.default), null) : /*#__PURE__*/ $4fqPo.createElement((0, $hJsSa.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $4fqPo.createElement((0, $bvB7a.default), null),
                layoutProps: {
                    headerless: false,
                    fadeInSearchModal: true
                }
            });
            if (isProjectAdmin) //@ts-ignore TypeScript upgrade 4.7.4
            return /*#__PURE__*/ $4fqPo.createElement(WrappedComponent, props);
            const { message: message, callToActionUrl: callToActionUrl, callToActionText: callToActionText } = options;
            return /*#__PURE__*/ $4fqPo.createElement((0, $hJsSa.BannerWithPaperLayoutRoute), {
                component: ()=>/*#__PURE__*/ $4fqPo.createElement((0, $MM3bs.default), {
                        error: {
                            message: message,
                            callToActionUrl: callToActionUrl,
                            callToActionText: callToActionText,
                            status: (0, $748yq.HTTP).FORBIDDEN
                        }
                    }),
                layoutProps: {
                    headerless: false,
                    paperAppearance: 'normal',
                    fadeInSearchModal: true
                }
            });
        };
        // @ts-ignore
        const ConnectedComponent = $f03d9b7f73abe2c7$var$connector(ReturnComponent);
        ConnectedComponent.displayName = 'withOnlyProjectAdmin';
        return ConnectedComponent;
    };
var $f03d9b7f73abe2c7$export$2e2bcd8739ae039 = $f03d9b7f73abe2c7$var$withOnlyProjectAdmin;

});


parcelRegister("7PRRH", function(module, exports) {
$parcel$export(module.exports, "Layout", () => (parcelRequire("6VEzt")).default);
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("a5CWL")).Error);
$parcel$export(module.exports, "HelpCenterConversationPage", () => (parcelRequire("7ZQaB")).HelpCenterConversationPage);
$parcel$export(module.exports, "PortalConversationPage", () => (parcelRequire("7ZQaB")).PortalConversationPage);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("7ZQaB")).authPageMessage);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("7ZQaB")).callToActionUrlText);

var $6VEzt = parcelRequire("6VEzt");
parcelRequire("bAhrW");
var $a5CWL = parcelRequire("a5CWL");

var $7ZQaB = parcelRequire("7ZQaB");

});
parcelRegister("6VEzt", function(module, exports) {
$parcel$export(module.exports, "default", () => $50ffbee87bfffda6$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("e2QHY");
var $7aI9q = parcelRequire("7aI9q");

const $50ffbee87bfffda6$var$LoadAppLazily = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("10zTS")).then(({ App: App })=>(0, $7aI9q.default)(App)), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/app/App.tsx"
    })
});
const $50ffbee87bfffda6$var$Layout = ({ component: component, screenName: screenName, renderError: renderError, headerless: headerless = false, footerless: footerless = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($50ffbee87bfffda6$var$LoadAppLazily, {
        component: component,
        screenName: screenName,
        renderError: renderError,
        layoutProps: {
            headerless: headerless,
            footerless: footerless
        }
    });
};
var $50ffbee87bfffda6$export$2e2bcd8739ae039 = $50ffbee87bfffda6$var$Layout;

});
parcelRegister("10zTS", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("eNoIp"),
    $e46AW("eHHlB")
]).then(()=>parcelRequire('kw2Og'));

});


parcelRegister("bAhrW", function(module, exports) {
$parcel$export(module.exports, "ErrorPage", () => (parcelRequire("a5CWL")).Error);

var $a5CWL = parcelRequire("a5CWL");

});
parcelRegister("a5CWL", function(module, exports) {
$parcel$export(module.exports, "Error", () => $806cef1e4b47b314$export$edf27be85e5f6da0);

var $4fqPo = parcelRequire("4fqPo");

var $5Uaxl = parcelRequire("5Uaxl");
var $dQegt = parcelRequire("dQegt");
parcelRequire("TqMeT");
var $3w7cm = parcelRequire("3w7cm");

var $fU3zc = parcelRequire("fU3zc");
const $806cef1e4b47b314$export$edf27be85e5f6da0 = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3w7cm.default), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5Uaxl.default), (0, $fU3zc.default).errorTitle),
        message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, formatMessage((0, $fU3zc.default).errorDescriptionText, {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("a", {
                    href: "/servicedesk"
                }, chunks)
        })),
        hideFooter: true
    });
};

});
parcelRegister("fU3zc", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ba1f6d9a24617ba$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $5ba1f6d9a24617ba$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    errorTitle: {
        defaultMessage: "We couldn\u2019t load this page",
        description: 'Text on show more results button',
        id: 'unified-help.error.page.title'
    },
    errorDescriptionText: {
        defaultMessage: 'Try refreshing the page or head to your <a>help center</a>.',
        description: 'Text for label on show more results icon',
        id: 'unified-help.error.page.description.text'
    }
});

});



parcelRegister("7ZQaB", function(module, exports) {
$parcel$export(module.exports, "HelpCenterConversationPage", () => $8f5b1b31ad96963c$export$1ebb9e18779d3716);
$parcel$export(module.exports, "PortalConversationPage", () => $8f5b1b31ad96963c$export$68489d6e6f9646e7);
$parcel$export(module.exports, "callToActionUrlText", () => $8f5b1b31ad96963c$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $8f5b1b31ad96963c$export$5342e2a00fe6d647);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

var $4YQOw = parcelRequire("4YQOw");

const $8f5b1b31ad96963c$export$1ebb9e18779d3716 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("cUCPw")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/conversation-page/ConversationPage.tsx"
    })
});

const $8f5b1b31ad96963c$export$68489d6e6f9646e7 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("hSGyY")), {
        moduleId: "./packages/unified-help/unified-help-center-alpha/src/pages/portal-conversation-page/PortalConversationPage.tsx"
    })
});
const $8f5b1b31ad96963c$export$d96795d242b62963 = (0, $4YQOw.default).callToActionUrlText;
const $8f5b1b31ad96963c$export$5342e2a00fe6d647 = (0, $4YQOw.default).authPageMessage;

});
parcelRegister("4YQOw", function(module, exports) {
$parcel$export(module.exports, "default", () => $449d60a9fec8d70e$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $449d60a9fec8d70e$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.message.nonFinal'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to portal',
        description: 'Call to action text for unauthorized page of portal',
        id: 'conversation.home.page.un.auth.action.text.nonFinal'
    }
});

});

parcelRegister("cUCPw", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("hma0F"),
    $e46AW("4xkV0"),
    $e46AW("epuCh"),
    $e46AW("hRvNP"),
    $e46AW("8BSvf"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("8eMUr"),
    $e46AW("9vY2V"),
    $e46AW("035bM"),
    $e46AW("cotMj"),
    $e46AW("7zgcz"),
    $e46AW("b56zU"),
    $e46AW("aHrLh"),
    $e46AW("4YETx"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("jEsv4"),
    $e46AW("488RH"),
    $e46AW("4biYi"),
    $e46AW("fG06h"),
    $e46AW("co70a"),
    $e46AW("5jpjH"),
    $e46AW("eNoIp"),
    $e46AW("idPcg")
]).then(()=>parcelRequire('3IQnc'));

});

parcelRegister("hSGyY", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("hma0F"),
    $e46AW("4xkV0"),
    $e46AW("epuCh"),
    $e46AW("hRvNP"),
    $e46AW("8BSvf"),
    $e46AW("b4egw"),
    $e46AW("jqvZW"),
    $e46AW("8eMUr"),
    $e46AW("9vY2V"),
    $e46AW("035bM"),
    $e46AW("cotMj"),
    $e46AW("7zgcz"),
    $e46AW("b56zU"),
    $e46AW("aHrLh"),
    $e46AW("4YETx"),
    $e46AW("9oVqw"),
    $e46AW("V5bPh"),
    $e46AW("jEsv4"),
    $e46AW("488RH"),
    $e46AW("4biYi"),
    $e46AW("fG06h"),
    $e46AW("co70a"),
    $e46AW("5jpjH"),
    $e46AW("eNoIp"),
    $e46AW("aAXBC")
]).then(()=>parcelRequire('9sJdw'));

});




parcelRegister("9M4IZ", function(module, exports) {
$parcel$export(module.exports, "requestsListRoute", () => $76bbf9a6a0863778$export$28cf91f271fafef3);

var $748yq = parcelRequire("748yq");

var $bVASc = parcelRequire("bVASc");

var $bp9tj = parcelRequire("bp9tj");
const $76bbf9a6a0863778$var$route = {
    name: 'requests-list',
    path: '/user/requests',
    exact: true,
    component: (0, $bVASc.RequestList)
};
const $76bbf9a6a0863778$var$screeName = (0, $748yq.ScreenName).REQUEST_LIST;
const $76bbf9a6a0863778$var$paperAppearance = 'xxwide';
const $76bbf9a6a0863778$var$layoutProps = {
    paperAppearance: $76bbf9a6a0863778$var$paperAppearance,
    fadeInSearchModal: true
};
const $76bbf9a6a0863778$export$28cf91f271fafef3 = (0, $bp9tj.createRouteWithLayout)($76bbf9a6a0863778$var$route, $76bbf9a6a0863778$var$screeName, $76bbf9a6a0863778$var$layoutProps);

});

parcelRegister("gQd3H", function(module, exports) {
$parcel$export(module.exports, "getSurveyRoute", () => $b6c3ae193df8efc7$export$7cb84a2d5bf6d9c9);

var $748yq = parcelRequire("748yq");

var $bp9tj = parcelRequire("bp9tj");

var $gIpMs = parcelRequire("gIpMs");
const $b6c3ae193df8efc7$export$7cb84a2d5bf6d9c9 = ()=>(0, $bp9tj.createRouteWithLayout)({
        name: 'survey',
        path: '/portal/:portalId/survey/:surveyId',
        exact: true,
        component: (0, $gIpMs.AsyncSurveyDetails),
        resources: []
    }, (0, $748yq.ScreenName).SURVEY, {
        fadeInSearchModal: true,
        paperAppearance: 'xxwide'
    });

});

parcelRegister("5VtTl", function(module, exports) {
$parcel$export(module.exports, "resourcesPlugin", () => $75b58c01c1f967fb$export$f4f160418a82e3b7);

var $6mmHn = parcelRequire("6mmHn");

var $4Ysr0 = parcelRequire("4Ysr0");
parcelRequire("8yaBI");
var $dwE13 = parcelRequire("dwE13");

var $1XMNp = parcelRequire("1XMNp");
const $75b58c01c1f967fb$var$customContext = {
    cloudId: (0, $6mmHn.getCloudId)(),
    productName: (0, $1XMNp.PROJECT_NAME),
    helpCenterAri: (0, $6mmHn.getHelpCenterAri)(),
    workspaceAri: (0, $6mmHn.getWorkspaceAri)(),
    layoutAri: (0, $6mmHn.getLayoutAri)(),
    isUserLoggedIn: Boolean((0, $6mmHn.getMeta)('ajs-atlassian-account-id')),
    accountType: (0, $6mmHn.getMeta)('ajs-account-type') || '',
    relayEnvironment: (0, $4Ysr0.getRelayEnvironment)()
};
const $75b58c01c1f967fb$export$f4f160418a82e3b7 = (0, $dwE13.createResourcesPlugin)({
    context: $75b58c01c1f967fb$var$customContext
});

});



parcelRegister("lkGq4", function(module, exports) {
$parcel$export(module.exports, "helpCenterViewHomePageExperience", () => $49d7d38f39c04091$export$deb53e4c26a043b6);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $49d7d38f39c04091$export$deb53e4c26a043b6 = new (0, $3odV5.UFOExperience)((0, $hWlSg.helpCenterViewHomePageExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("g7tcY", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc59c72ba69fae59$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $el3DQ = parcelRequire("el3DQ");

var $6uA6H = parcelRequire("6uA6H");

var $bG6ob = parcelRequire("bG6ob");

var $l9AOu = parcelRequire("l9AOu");

var $dfktK = parcelRequire("dfktK");
parcelRequire("l8iRu");
var $7H5nz = parcelRequire("7H5nz");
var $8NB5B = parcelRequire("8NB5B");

var $1ynV6 = parcelRequire("1ynV6");

var $8tPCL = parcelRequire("8tPCL");

var $kV2FI = parcelRequire("kV2FI");

var $1pFM5 = parcelRequire("1pFM5");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $4we4O = parcelRequire("4we4O");

var $6bGmX = parcelRequire("6bGmX");

var $eSL4S = parcelRequire("eSL4S");

var $3wR8f = parcelRequire("3wR8f");

var $5VtTl = parcelRequire("5VtTl");
parcelRequire("5FSYN");
var $cBf1I = parcelRequire("cBf1I");
const $bc59c72ba69fae59$export$4c59d19d881588b9 = (props)=>{
    //Order matters here
    const routes = (0, $4fqPo.useMemo)(()=>{
        const includeRovoAgentRoute = (0, $eSL4S.getIsHelpHub)() && (0, $6bGmX.default).checkGate('enable_rovo_in_help_hubs') || (0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-rovo-agent');
        const includeVirtualAgentRoute = (0, $6uA6H.isFeatureEnabled)('jira-service-management', 'jsm-help-center-virtual-agent');
        return [
            ...(0, $bG6ob.isProjectMappingInHelpCenterEnabled)() ? [
                (0, $8tPCL.helpcenterEditRoute),
                (0, $8tPCL.helpcenterManageProjectsRoute),
                ...(0, $bG6ob.isCustomPagesUiEnabled)() ? [
                    (0, $8tPCL.helpcenterManageCustomPagesRoute)
                ] : [],
                ...(0, $6bGmX.default).checkGate('enable-jsm-in-hubs') ? [
                    ...(0, $6bGmX.default).checkGate('portal-pages-in-hub') ? [
                        (0, $8tPCL.hubEditPortalLayoutRoute)
                    ] : [],
                    (0, $8tPCL.hubEditLayoutRoute)
                ] : []
            ] : [],
            // Feature gate: jsm_help_center_one-click_rovo_agent (Help Center) / enable_rovo_in_help_hubs (Help Hub)
            ...includeRovoAgentRoute ? [
                (0, $1ynV6.helpcenterRovoServiceAgentRoute)
            ] : [],
            ...includeVirtualAgentRoute ? [
                (0, $kV2FI.helpcenterVirtualAgentRoute)
            ] : [],
            (0, $1pFM5.viewHelpCentersManagementPageRoute),
            ...(0, $6bGmX.default).checkGate('enable-jsm-in-hubs') ? [
                (0, $1pFM5.viewHelpHubsManagementPageRoute)
            ] : [],
            (0, $cBf1I.notFoundErrorRoute)
        ];
    }, []);
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $l9AOu.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $l9AOu.lightenColor)(themeColor);
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $el3DQ.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8NB5B.Router), {
        routes: routes,
        history: (0, $3wR8f.default),
        isGlobal: false,
        plugins: [
            (0, $5VtTl.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dfktK.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4we4O.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7H5nz.RouteComponent), null)));
};
const $bc59c72ba69fae59$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getThemeColor), (0, $i8gmD.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $bc59c72ba69fae59$export$2e2bcd8739ae039 = (0, $bmgw6.default)($bc59c72ba69fae59$var$selector)($bc59c72ba69fae59$export$4c59d19d881588b9);

});
parcelRegister("1ynV6", function(module, exports) {
$parcel$export(module.exports, "helpcenterRovoServiceAgentRoute", () => $b79af1acc18c0f49$export$b887b8f40276e27c);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $gi5ak = parcelRequire("gi5ak");

var $dQegt = parcelRequire("dQegt");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");

var $corqd = parcelRequire("corqd");
parcelRequire("acPE2");
var $1g7Go = parcelRequire("1g7Go");

var $1AvvJ = parcelRequire("1AvvJ");

const $b79af1acc18c0f49$var$AsyncRovoServiceAgentPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("jd4xn")).then((module)=>({
                default: module.RovoServiceAgentSettingsPageLoader
            })), {
        moduleId: "./packages/rovo-service-agent/rovo-service-agent-settings/src/index.tsx"
    })
});
const $b79af1acc18c0f49$var$RovoServiceAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }), (0, $3RiO6.default)({
        message: formatMessage((0, $corqd.authPageMessage)),
        callToActionText: formatMessage((0, $corqd.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1g7Go.default), {
            featureName: "Rovo Service Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b79af1acc18c0f49$var$AsyncRovoServiceAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
const $b79af1acc18c0f49$export$b887b8f40276e27c = {
    name: 'rovoServiceAgentSettings',
    path: '/:helpcenterId/rovo-agent',
    exact: true,
    resources: [
        (0, $1AvvJ.HelpCenterRovoServiceAgentResource)
    ],
    component: (0, $lM7Z9.withRouter)($b79af1acc18c0f49$var$RovoServiceAgentPage)
};

});
parcelRegister("acPE2", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("1g7Go")).default);
$parcel$export(module.exports, "useHelpCenterAri", () => (parcelRequire("gjCVU")).useHelpCenterAri);
$parcel$export(module.exports, "useConditionalMessage", () => (parcelRequire("eQlRt")).useConditionalMessage);
parcelRequire("cyrix");
var $1g7Go = parcelRequire("1g7Go");

var $gjCVU = parcelRequire("gjCVU");

var $eQlRt = parcelRequire("eQlRt");

});
parcelRegister("cyrix", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("1g7Go")).default);
parcelRequire("hdYRg");
var $1g7Go = parcelRequire("1g7Go");
parcelRequire("hBskO");
var $j9Nxb = parcelRequire("j9Nxb");

var $40zlN = parcelRequire("40zlN");

});
parcelRegister("hdYRg", function(module, exports) {
$parcel$export(module.exports, "AdminManagementLayout", () => (parcelRequire("1g7Go")).default);

var $1g7Go = parcelRequire("1g7Go");

});
parcelRegister("1g7Go", function(module, exports) {
$parcel$export(module.exports, "default", () => $e95750c41c92fb0f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $dfktK = parcelRequire("dfktK");

var $kQ79X = parcelRequire("kQ79X");

var $gopxm = parcelRequire("gopxm");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");
var $hfD9S = parcelRequire("hfD9S");
parcelRequire("iAm81");
var $2hx7o = parcelRequire("2hx7o");

var $6IdvK = parcelRequire("6IdvK");

var $2bLkU = parcelRequire("2bLkU");

var $6bGmX = parcelRequire("6bGmX");

var $jmL6n = parcelRequire("jmL6n");

var $6SePM = parcelRequire("6SePM");

var $3FCwD = parcelRequire("3FCwD");

var $6qCak = parcelRequire("6qCak");

var $7RZcB = parcelRequire("7RZcB");

var $fxg1m = parcelRequire("fxg1m");

var $2nGAn = parcelRequire("2nGAn");

var $fNSBJ = parcelRequire("fNSBJ");
var $dCEPI = parcelRequire("dCEPI");
var $iHhPj = parcelRequire("iHhPj");
var $56HSl = parcelRequire("56HSl");

var $7TPEx = parcelRequire("7TPEx");parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");
var $2m8U6 = parcelRequire("2m8U6");

var $ebpTf = parcelRequire("ebpTf");

var $chA55 = parcelRequire("chA55");

var $doQp2 = parcelRequire("doQp2");

var $jvwY8 = parcelRequire("jvwY8");
parcelRequire("4rJRB");
var $ewNnh = parcelRequire("ewNnh");
parcelRequire("bev4L");
var $dbeeo = parcelRequire("dbeeo");

var $cXlrU = parcelRequire("cXlrU");
const $e95750c41c92fb0f$var$AdminManagementLayoutContentBase = ({ children: children, featureName: featureName, hasSiteAdministerAccess: hasSiteAdministerAccess, hideSidebar: hideSidebar })=>{
    const [{ route: route }, { push: push }] = (0, $hfD9S.useRouter)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [helpCenterId = ''] = (0, $eDygx.usePathParam)('helpcenterId');
    const { name: routeName } = route;
    const { isHelpHub: isHelpHub } = (0, $doQp2.useHelpCenterType)();
    const rovoServiceAgentRouteName = 'rovoServiceAgentSettings';
    const rovoServiceAgentUrl = `/${helpCenterId}/rovo-agent`;
    const virtualAgentRouteName = 'virtualAgentSettings';
    const virtualAgentUrl = `/${helpCenterId}/virtual-agent`;
    const mapProjectsScreenUrl = `/${helpCenterId}/projects`;
    const mapPagesScreenUrl = `/${helpCenterId}/pages`;
    const editProjectDetailsScreenUrl = `/${helpCenterId}/details`;
    const navigationContentItems = [
        {
            onClick: ()=>push(editProjectDetailsScreenUrl),
            text: formatMessage((0, $cXlrU.default).helpcenterDetailsItem),
            isVisible: (0, $bG6ob.isProjectMappingInHelpCenterEnabled)(),
            isSelected: routeName === 'edit-details',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7RZcB))), {
                label: formatMessage((0, $cXlrU.default).helpcenterDetailsItem)
            })
        },
        {
            onClick: ()=>push(mapProjectsScreenUrl),
            text: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $cXlrU.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $cXlrU.default).helpcenterManageProjectsItem),
            isSelected: routeName === 'manage-projects',
            isVisible: (0, $bG6ob.isProjectMappingInHelpCenterEnabled)(),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6SePM))), {
                label: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $cXlrU.default).helpcenterManageProjectsItemGalaxia) : formatMessage((0, $cXlrU.default).helpcenterManageProjectsItem)
            })
        }
    ];
    // The manage-pages page is only an upsell for non-premium users.
    // So we only show it for premium users or users with billing permission.
    if ((0, $ebpTf.getIsHCCustomizationEnabled)() || hasSiteAdministerAccess) navigationContentItems.push({
        onClick: ()=>push(mapPagesScreenUrl),
        text: formatMessage((0, $cXlrU.default).helpcenterManagePagesItem),
        isSelected: routeName === 'manage-pages',
        isVisible: (0, $bG6ob.isCustomPagesUiEnabled)() && !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3FCwD))), {
            label: formatMessage((0, $cXlrU.default).helpcenterManagePagesItem)
        })
    });
    // Rovo Agent
    // For Help Hubs: gated behind enable_rovo_in_help_hubs
    // For Help Centers: gated behind jsm_help_center_one-click_rovo_agent
    navigationContentItems.push({
        onClick: ()=>push(rovoServiceAgentUrl),
        text: formatMessage((0, $cXlrU.default).helpcenterRovoServiceAgentItem),
        isSelected: routeName === rovoServiceAgentRouteName,
        isVisible: isHelpHub ? (0, $6bGmX.default).checkGate('enable_rovo_in_help_hubs') : (0, $6bGmX.default).checkGate('jsm_help_center_one-click_rovo_agent'),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6qCak))), {
            label: formatMessage((0, $cXlrU.default).helpcenterRovoServiceAgentItem)
        })
    });
    // Virtual Service Agent
    if (!(0, $bG6ob.isHideVsaEndpointsEnabled)() && !(0, $chA55.isPremiumUpsellExperimentEnabled)({
        hasSiteAdministerAccess: hasSiteAdministerAccess,
        isHCCustomizationEnabled: (0, $ebpTf.getIsHCCustomizationEnabled)()
    })) navigationContentItems.push({
        onClick: ()=>push(virtualAgentUrl),
        text: formatMessage((0, $cXlrU.default).helpcenterVsaReportingItem),
        isSelected: routeName === virtualAgentRouteName,
        isVisible: (0, $ebpTf.getJsmAIConfigEnabled)() && !isHelpHub,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmL6n))), {
            label: formatMessage((0, $cXlrU.default).helpcenterVsaReportingItem)
        })
    });
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bLkU.default), {
            header: formatMessage((0, $cXlrU.default).errorTitle),
            description: formatMessage((0, $cXlrU.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($gopxm)))
        });
    };
    const packageName = ()=>{
        switch(routeName){
            case 'edit-details':
                return 'editDetails';
            case 'manage-projects':
                return 'manageProjects';
            case 'manage-pages':
                return 'managePages';
            case 'rovoServiceAgentSettings':
                return 'rovoServiceAgentSettings';
            case 'virtualAgentSettings':
                return 'virtualAgentSettings';
            case 'reporting':
                return 'reporting';
            default:
                return 'unknown';
        }
    };
    const isTablet = !(0, $6IdvK.useMediaQuery)(`(max-width: ${(0, $kQ79X.sizes).xsmall}px)`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2nGAn.default), {
        blanketIsTinted: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $e95750c41c92fb0f$var$pageLayoutWrapper,
        testId: "admin-layout-management-page-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iHhPj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $56HSl.default), {
        isFixed: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ewNnh.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fNSBJ.default), null, isTablet && !hideSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dbeeo.default), {
        width: (0, $jvwY8.SIDEBAR_WIDTH),
        navigationContentItems: navigationContentItems,
        featureName: featureName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $e95750c41c92fb0f$var$bodyContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dCEPI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: packageName(),
        id: 'admin-layout-management-page',
        renderError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: [
            $e95750c41c92fb0f$var$container,
            !hideSidebar && $e95750c41c92fb0f$var$containerWithMaxWidth
        ]
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dfktK.NewGlobalBGColor), null)))));
};
const $e95750c41c92fb0f$var$selector = (0, $3yyCx.createSelector)((state)=>{
    return {
        hasSiteAdministerAccess: (0, $2hx7o.getHasSiteAdministerAccess)(state)
    };
}, ({ hasSiteAdministerAccess: hasSiteAdministerAccess })=>({
        hasSiteAdministerAccess: hasSiteAdministerAccess
    }));
const $e95750c41c92fb0f$var$AdminManagementLayoutContent = (0, $bmgw6.default)($e95750c41c92fb0f$var$selector)($e95750c41c92fb0f$var$AdminManagementLayoutContentBase);
const $e95750c41c92fb0f$export$b52b33be5684c42c = ({ children: children, featureName: featureName, hideSidebar: hideSidebar = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $doQp2.HelpCenterTypeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e95750c41c92fb0f$var$AdminManagementLayoutContent, {
        featureName: featureName,
        hideSidebar: hideSidebar
    }, children)));
};
var $e95750c41c92fb0f$export$2e2bcd8739ae039 = $e95750c41c92fb0f$export$b52b33be5684c42c;
const $e95750c41c92fb0f$var$container = (0, $2m8U6.xcss)({
    margin: '0 auto',
    paddingBottom: 'space.050',
    paddingInline: 'space.600',
    [(0, $3jKXW.media).above.lg]: {
        paddingInline: 'space.0'
    }
});
const $e95750c41c92fb0f$var$containerWithMaxWidth = (0, $2m8U6.xcss)({
    maxWidth: '1160px'
});
const $e95750c41c92fb0f$var$pageLayoutWrapper = (0, $2m8U6.xcss)({
    overflowAnchor: 'none',
    height: '100%'
});
const $e95750c41c92fb0f$var$bodyContainer = (0, $2m8U6.xcss)({
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: `calc(100vh - (${(0, $fxg1m.TOP_NAVIGATION_HEIGHT)} + ${(0, $fxg1m.BANNER_HEIGHT)}))`,
    width: '100%'
});

});
parcelRegister("gopxm", function(module, exports) {
module.exports = new URL("../images/project-mapping-error.ef7a4be3.svg", import.meta.url).toString();

});

parcelRegister("6IdvK", function(module, exports) {
$parcel$export(module.exports, "useMediaQuery", () => $29acb155436befa2$export$32d5543ab307c01);

var $4fqPo = parcelRequire("4fqPo");

var $63sfu = parcelRequire("63sfu");
function $29acb155436befa2$export$32d5543ab307c01(query) {
    const [match, setMatch] = $4fqPo.useState(false);
    $4fqPo.useEffect(()=>{
        function screenTest(e) {
            setMatch(Boolean(e.matches));
        }
        if (window && Object.prototype.hasOwnProperty.call(window, 'matchMedia')) {
            const mql = window.matchMedia(query);
            /**
       * Trigger the screenTest even for the first call
       */ screenTest(mql);
            mql.addListener(screenTest);
            return ()=>{
                mql.removeListener(screenTest);
            };
        }
        return 0, $63sfu.noop;
    }, [
        query
    ]);
    return match;
}

});

parcelRegister("2bLkU", function(module, exports) {
$parcel$export(module.exports, "default", () => $062a6cbde4297bef$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $h7u63 = parcelRequire("h7u63");

var $2eKV2 = parcelRequire("2eKV2");

var $7fscZ = parcelRequire("7fscZ");
var $ekURY = parcelRequire("ekURY");

var $5qWT2 = parcelRequire("5qWT2");

var $a1rhV = parcelRequire("a1rhV");

var $jI7Zh = parcelRequire("jI7Zh");

var $e6t8R = parcelRequire("e6t8R");

var $gPEfY = parcelRequire("gPEfY");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $062a6cbde4297bef$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, headingSize: headingSize = 'medium', imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $a1rhV.default), null, primaryAction && secondaryAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h7u63.default), {
        label: buttonGroupLabel || 'Button group',
        testId: testId && `${testId}-button-group`
    }, secondaryAction, primaryAction) : primaryAction || secondaryAction, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gPEfY.default), null, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        testId: "empty-state-spinner"
    }))) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jI7Zh.default), {
        testId: testId,
        width: width || 'wide'
    }, imageUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e6t8R.default), {
        src: imageUrl,
        maxWidth: maxImageWidth,
        maxHeight: maxImageHeight,
        width: imageWidth,
        height: imageHeight
    }) : renderImage && renderImage({
        maxImageWidth: maxImageWidth,
        maxImageHeight: maxImageHeight,
        imageWidth: imageWidth,
        imageHeight: imageHeight
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: headingSize,
        as: tag
    }, header)), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        paddingBlockEnd: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), {
        as: "p"
    }, description)), actionsContainer, tertiaryAction);
};
var $062a6cbde4297bef$export$2e2bcd8739ae039 = $062a6cbde4297bef$var$EmptyState;

});
parcelRegister("a1rhV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6d8bc3d71826ba47$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $6d8bc3d71826ba47$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $6d8bc3d71826ba47$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ])
    }, children);
var $6d8bc3d71826ba47$export$2e2bcd8739ae039 = $6d8bc3d71826ba47$var$ActionsContainer;

});

parcelRegister("jI7Zh", function(module, exports) {
$parcel$export(module.exports, "default", () => $23357ffc18fc356b$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $23357ffc18fc356b$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $23357ffc18fc356b$var$wideContainerStyles = null;
const $23357ffc18fc356b$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $23357ffc18fc356b$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ])
    }, children);
var $23357ffc18fc356b$export$2e2bcd8739ae039 = $23357ffc18fc356b$var$Container;

});

parcelRegister("e6t8R", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2470dda6a94088f$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $d2470dda6a94088f$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $d2470dda6a94088f$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $d2470dda6a94088f$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $d2470dda6a94088f$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ $4fqPo.createElement("img", {
        style: {
            [$d2470dda6a94088f$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$d2470dda6a94088f$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $ltgDR.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $d2470dda6a94088f$export$2e2bcd8739ae039 = $d2470dda6a94088f$var$Image;

});

parcelRegister("gPEfY", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3e3a9addeb16ddc$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $e3e3a9addeb16ddc$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $e3e3a9addeb16ddc$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        className: (0, $ltgDR.default)([
            "_1bsb1ejb _ahbqpxbi"
        ])
    }, children);
var $e3e3a9addeb16ddc$export$2e2bcd8739ae039 = $e3e3a9addeb16ddc$var$SpinnerContainer;

});


parcelRegister("3FCwD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d48827792ad56aec1327e3c5557d624a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ac315c00c5e922d$var$_react = $2ac315c00c5e922d$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $2ac315c00c5e922d$var$_baseNew = $2ac315c00c5e922d$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $2ac315c00c5e922d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ac315c00c5e922d$var$PagesIcon = (props)=>/*#__PURE__*/ $2ac315c00c5e922d$var$_react.default.createElement($2ac315c00c5e922d$var$_baseNew.default, Object.assign({
        name: "PagesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$2ac315c00c5e922d$var$PagesIcon.displayName = 'PagesIcon';
var $2ac315c00c5e922d$var$_default = module.exports.default = $2ac315c00c5e922d$var$PagesIcon;

});

parcelRegister("6qCak", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4ae2c6aaa26bc66d$var$_react = $4ae2c6aaa26bc66d$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $4ae2c6aaa26bc66d$var$_baseNew = $4ae2c6aaa26bc66d$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $4ae2c6aaa26bc66d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4ae2c6aaa26bc66d$var$RovoIcon = (props)=>/*#__PURE__*/ $4ae2c6aaa26bc66d$var$_react.default.createElement($4ae2c6aaa26bc66d$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$4ae2c6aaa26bc66d$var$RovoIcon.displayName = 'RovoIcon';
var $4ae2c6aaa26bc66d$var$_default = module.exports.default = $4ae2c6aaa26bc66d$var$RovoIcon;

});

parcelRegister("7RZcB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac60b703236e33e11860080af1a47ce0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bacf527c5eb95cd$var$_react = $5bacf527c5eb95cd$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $5bacf527c5eb95cd$var$_baseNew = $5bacf527c5eb95cd$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $5bacf527c5eb95cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Wrench".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5bacf527c5eb95cd$var$WrenchIcon = (props)=>/*#__PURE__*/ $5bacf527c5eb95cd$var$_react.default.createElement($5bacf527c5eb95cd$var$_baseNew.default, Object.assign({
        name: "WrenchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.5 1.5a4 4 0 0 0-3.614 5.718.75.75 0 0 1-.146.853l-4.95 4.95a.841.841 0 0 0 1.189 1.19l4.95-4.95a.75.75 0 0 1 .853-.147 4 4 0 0 0 5.667-4.252L12.03 7.28a.75.75 0 0 1-1.06 0L8.72 5.03a.75.75 0 0 1 0-1.06l2.419-2.42a4 4 0 0 0-.639-.05M5 5.5A5.5 5.5 0 0 1 12.863.532a.75.75 0 0 1 .208 1.208L10.31 4.5l1.19 1.19 2.76-2.76a.75.75 0 0 1 1.208.207 5.5 5.5 0 0 1-6.832 7.539L4.038 15.27a2.34 2.34 0 1 1-3.31-3.31l4.595-4.596A5.5 5.5 0 0 1 5 5.5" clip-rule="evenodd"/>`
    }, props));
$5bacf527c5eb95cd$var$WrenchIcon.displayName = 'WrenchIcon';
var $5bacf527c5eb95cd$var$_default = module.exports.default = $5bacf527c5eb95cd$var$WrenchIcon;

});

parcelRegister("fxg1m", function(module, exports) {
$parcel$export(module.exports, "TOP_NAVIGATION_HEIGHT", () => $9a339d4ee4bbf9ab$export$aeff86a16f13529);
$parcel$export(module.exports, "BANNER_HEIGHT", () => $9a339d4ee4bbf9ab$export$ed7cc0d417ee89e);
/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */ const $9a339d4ee4bbf9ab$export$f963aecf2d4465bd = 'var(--leftPanelWidth, 0px)';
const $9a339d4ee4bbf9ab$export$750459958906793 = 'var(--rightPanelWidth, 0px)';
const $9a339d4ee4bbf9ab$export$f897e1ed9f8ed251 = 'var(--leftSidebarWidth, 0px)';
const $9a339d4ee4bbf9ab$export$b44ab66843c05a69 = 'var(--rightSidebarWidth, 0px)';
const $9a339d4ee4bbf9ab$export$aeff86a16f13529 = 'var(--topNavigationHeight, 0px)';
const $9a339d4ee4bbf9ab$export$ed7cc0d417ee89e = 'var(--bannerHeight, 0px)';

});

parcelRegister("56HSl", function(module, exports) {
$parcel$export(module.exports, "default", () => $c049933d2636fcee$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $gSpw2 = parcelRequire("gSpw2");

var $e3uEz = parcelRequire("e3uEz");

var $71AtM = parcelRequire("71AtM");

var $euOrY = parcelRequire("euOrY");
var $fRy95 = parcelRequire("fRy95");

var $5jaCT = parcelRequire("5jaCT");

var $aeSaK = parcelRequire("aeSaK");
const $c049933d2636fcee$var$topNavigationStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $gSpw2.TOP_NAVIGATION_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: (0, $gSpw2.TOP_NAVIGATION)
});
const $c049933d2636fcee$var$fixedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    position: 'fixed',
    zIndex: 2,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: (0, $gSpw2.BANNER_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineEnd: (0, $gSpw2.RIGHT_PANEL_WIDTH),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: (0, $gSpw2.LEFT_PANEL_WIDTH)
});
/**
 * __Top navigation__
 *
 * Provides a slot for top navigation within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $c049933d2636fcee$var$TopNavigation = (props)=>{
    const { children: children, height: height = (0, $gSpw2.DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
    const topNavigationHeight = (0, $71AtM.resolveDimension)((0, $gSpw2.VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
    (0, $4fqPo.useEffect)(()=>{
        (0, $euOrY.default)({
            [(0, $gSpw2.VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
        });
        return ()=>{
            (0, $euOrY.default)({
                [(0, $gSpw2.VAR_TOP_NAVIGATION_HEIGHT)]: 0
            });
        };
    }, [
        topNavigationHeight
    ]);
    (0, $fRy95.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $5jaCT.default), null, ({ className: className })=>/*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            css: [
                $c049933d2636fcee$var$topNavigationStyles,
                isFixed && $c049933d2636fcee$var$fixedStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            ...(0, $e3uEz.getPageLayoutSlotSelector)('top-navigation')
        }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $aeSaK.default), {
            variableName: (0, $gSpw2.VAR_TOP_NAVIGATION_HEIGHT),
            value: topNavigationHeight
        }), children));
};
var $c049933d2636fcee$export$2e2bcd8739ae039 = $c049933d2636fcee$var$TopNavigation;

});
parcelRegister("71AtM", function(module, exports) {
$parcel$export(module.exports, "resolveDimension", () => $7847626a36d84325$export$74732e47915c7839);

var $dbZwv = parcelRequire("dbZwv");
const $7847626a36d84325$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
    if (shouldPersist) {
        const cachedGridState = (0, $dbZwv.getGridStateFromStorage)('gridState');
        return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
    }
    return dimension;
};

});
parcelRegister("dbZwv", function(module, exports) {
$parcel$export(module.exports, "getGridStateFromStorage", () => $29a464bb040bbd2b$export$d95e99d8116d17dc);

var $gSpw2 = parcelRequire("gSpw2");

var $2xtjc = parcelRequire("2xtjc");
const $29a464bb040bbd2b$export$d95e99d8116d17dc = (key)=>{
    const storageValue = JSON.parse((0, $2xtjc.default)().getItem((0, $gSpw2.PAGE_LAYOUT_LS_KEY)) || '{}');
    return storageValue[key];
};

});
parcelRegister("2xtjc", function(module, exports) {
$parcel$export(module.exports, "default", () => $d4ed872ed1b26141$export$2e2bcd8739ae039);
// Reliably test against conditions like
// localStorage being full or private mode in Safari being a .
// https://gist.github.com/paulirish/5558557
const $d4ed872ed1b26141$var$isLocalStorageSupported = ()=>{
    try {
        // use an random key to test
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        const testKey = `__test_${Date.now()}__`;
        localStorage.setItem(testKey, testKey);
        localStorage.removeItem(testKey);
        return true;
    } catch  {
        return false;
    }
};
const $d4ed872ed1b26141$var$safeLocalStorage = ()=>{
    if ($d4ed872ed1b26141$var$isLocalStorageSupported()) return localStorage;
    // Returning a mock object here in the case that this is run in SSR mode
    if (typeof window === 'undefined') return {
        getItem: (_key)=>null,
        setItem: (_key, _value)=>null,
        removeItem: (_key)=>null,
        clear: ()=>null,
        key: (_index)=>null,
        get length () {
            return 0;
        }
    };
    if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
    const storageAPI = {
        getItem: (key)=>{
            if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
            return null;
        },
        setItem: (key, value)=>{
            window.__localStorageFallback[key] = String(value);
        },
        removeItem: (key)=>{
            delete window.__localStorageFallback[key];
        },
        clear: ()=>{
            for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
        },
        get length () {
            if (!window.__localStorageFallback) return 0;
            return Object.keys(window.__localStorageFallback).length;
        }
    };
    window.__localStorageFallback = Object.create(storageAPI);
    return window.__localStorageFallback;
};
var $d4ed872ed1b26141$export$2e2bcd8739ae039 = $d4ed872ed1b26141$var$safeLocalStorage;

});



parcelRegister("euOrY", function(module, exports) {
$parcel$export(module.exports, "default", () => $b59bf5a0bd8c7a77$export$2e2bcd8739ae039);

var $acDuW = parcelRequire("acDuW");

var $fJmBu = parcelRequire("fJmBu");
const $b59bf5a0bd8c7a77$var$publishGridState = (gridState)=>{
    Object.entries(gridState).forEach(([slotName, value])=>{
        if (!value) {
            document.documentElement.style.removeProperty(`--${slotName}`);
            (0, $fJmBu.removeFromGridStateInStorage)('gridState', slotName);
            return;
        }
        //Update the css variable
        document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
        // also update state in local storage so that
        // it persists across page refresh, across tabs etc
        (0, $acDuW.mergeGridStateIntoStorage)('gridState', {
            [slotName]: value
        });
    });
};
var $b59bf5a0bd8c7a77$export$2e2bcd8739ae039 = $b59bf5a0bd8c7a77$var$publishGridState;

});
parcelRegister("acDuW", function(module, exports) {
$parcel$export(module.exports, "mergeGridStateIntoStorage", () => $4dea937e6538d953$export$f8355a2df0f4a946);

var $gSpw2 = parcelRequire("gSpw2");

var $2xtjc = parcelRequire("2xtjc");
const $4dea937e6538d953$export$f8355a2df0f4a946 = (key, value)=>{
    const storageValue = JSON.parse((0, $2xtjc.default)().getItem((0, $gSpw2.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (value !== null && typeof value === 'object') storageValue[key] = {
        ...storageValue[key],
        ...value
    };
    else storageValue[key] = value;
    (0, $2xtjc.default)().setItem((0, $gSpw2.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};

});

parcelRegister("fJmBu", function(module, exports) {
$parcel$export(module.exports, "removeFromGridStateInStorage", () => $6a03dafe34e16605$export$17e3760e0b35f1cd);

var $gSpw2 = parcelRequire("gSpw2");

var $2xtjc = parcelRequire("2xtjc");
const $6a03dafe34e16605$export$17e3760e0b35f1cd = (key, secondKey)=>{
    const storageValue = JSON.parse((0, $2xtjc.default)().getItem((0, $gSpw2.PAGE_LAYOUT_LS_KEY)) || '{}');
    if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
    else delete storageValue[key];
    (0, $2xtjc.default)().setItem((0, $gSpw2.PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
};

});


parcelRegister("aeSaK", function(module, exports) {
$parcel$export(module.exports, "default", () => $20d5c3be8835cf62$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $dVnnV = parcelRequire("dVnnV");
/**
 * Hoists slot dimension styles to the root element.
 */ const $20d5c3be8835cf62$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
    /**
   * Note don't put multiple variables in multiple lines. eg
   * <style>
   *   {css1}
   *   {css2}
   * </style>
   *
   * React will insert an empty HTML comment in between the text in SSR.
   * This is not a valid tag and will break the page.
   * <style>foo<!-- -->bar</style>
   */ let style = `:root{--${variableName}:${value}px;}`;
    if (mobileValue) style += ` ${(0, $dVnnV.UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("style", null, style));
};
var $20d5c3be8835cf62$export$2e2bcd8739ae039 = $20d5c3be8835cf62$var$SlotDimensions;

});


parcelRegister("doQp2", function(module, exports) {
$parcel$export(module.exports, "HelpCenterTypeProvider", () => $b67bc8784befb920$export$d53895d6fb159859);
$parcel$export(module.exports, "useHelpCenterType", () => $b67bc8784befb920$export$f4dfe81df1da8e40);
$parcel$export(module.exports, "useOptionalHelpCenterType", () => $b67bc8784befb920$export$9f436e6b1d27b8b1);

var $1VTMS = parcelRequire("1VTMS");

var $4fqPo = parcelRequire("4fqPo");

var $6mmHn = parcelRequire("6mmHn");

var $gIeP2 = parcelRequire("gIeP2");

var $gjCVU = parcelRequire("gjCVU");
const $b67bc8784befb920$var$HelpCenterTypeContext = /*#__PURE__*/ (0, $4fqPo.createContext)(undefined);
const $b67bc8784befb920$export$d53895d6fb159859 = ({ children: children })=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $gjCVU.useHelpCenterAri)();
    const cloudId = (0, $6mmHn.getCloudId)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $1VTMS.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    }, {
        fetchPolicy: 'store-or-network'
    });
    const helpCenterById = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const helpCenterType = (helpCenterById === null || helpCenterById === void 0 ? void 0 : helpCenterById.type) ?? null;
    const isHelpHub = helpCenterType === 'HELP_HUB';
    const value = {
        helpCenterType: helpCenterType,
        isHelpHub: isHelpHub
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b67bc8784befb920$var$HelpCenterTypeContext.Provider, {
        value: value
    }, children);
};
const $b67bc8784befb920$export$f4dfe81df1da8e40 = ()=>{
    const context = (0, $4fqPo.useContext)($b67bc8784befb920$var$HelpCenterTypeContext);
    if (context === undefined) throw new Error('useHelpCenterType must be used within a HelpCenterTypeProvider');
    return context;
};
const $b67bc8784befb920$export$9f436e6b1d27b8b1 = ()=>{
    const context = (0, $4fqPo.useContext)($b67bc8784befb920$var$HelpCenterTypeContext);
    // Default to BASIC/Help Center when context is not available (e.g., creating new help centers)
    return context ?? {
        helpCenterType: null,
        isHelpHub: false
    };
};

});
parcelRegister("1VTMS", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4b4c3f7472495f1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<85612eb43834db2f494f160069fa5560>>
 * @relayHash beb53aa7a0d0e9601d0a8ed6e41c37bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65
const $e4b4c3f7472495f1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "type"
            }
        ],
        "type": "HelpCenter"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "helpCenterTypeContextQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fb1e8729ae4e0808c70c1ef993eb6a61813494c8b8c66c4c54aa455fca242a65",
            "metadata": {},
            "name": "helpCenterTypeContextQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e4b4c3f7472495f1$var$node.hash = "84d5aba1364a6a49146d359035c72854";
var $e4b4c3f7472495f1$export$2e2bcd8739ae039 = $e4b4c3f7472495f1$var$node;

});

parcelRegister("gjCVU", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterAri", () => $db48bd25d01dbc63$export$f14e6e523bbc25e7);
/**
 This hook will only work if the helpcenterId exists in the path param and the activation-id exists in the meta tag.
 @returns {string} The Help Center ARI.
 */ 
var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $eDygx = parcelRequire("eDygx");

var $4oTiM = parcelRequire("4oTiM");
const $db48bd25d01dbc63$export$f14e6e523bbc25e7 = ()=>{
    const [helpCenterId = ''] = (0, $eDygx.usePathParam)('helpcenterId');
    const activationId = (0, $6mmHn.getMeta)('activation-id') || '';
    const helpCenterAri = (0, $4oTiM.HelpHelpCenterAri).create({
        activationId: activationId,
        helpCenterId: helpCenterId
    }).toString();
    return helpCenterAri;
};

});


parcelRegister("jvwY8", function(module, exports) {
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $56eae9f7645c6524$export$780035d9fe48eb32);
$parcel$export(module.exports, "CANT_UNLINK_ALL_DIALOG", () => $56eae9f7645c6524$export$34c86dd326ed7328);
$parcel$export(module.exports, "UNLINK_CONFIRMATION_DIALOG", () => $56eae9f7645c6524$export$e1e71e4a40967783);
$parcel$export(module.exports, "MANAGE_PROJECT_HEAD_WIDTH", () => $56eae9f7645c6524$export$39266233350d2cc1);
$parcel$export(module.exports, "MANAGE_PAGE_HEAD_WIDTH", () => $56eae9f7645c6524$export$d93583f12bb7f663);
$parcel$export(module.exports, "ALREADY_EXISTED_CUSTOM_PAGE_MESSAGE", () => $56eae9f7645c6524$export$24707863b4005c32);
$parcel$export(module.exports, "CUSTOM_PAGE_NAME_CHARACTER_LIMIT", () => $56eae9f7645c6524$export$7b26638f36689ddd);
$parcel$export(module.exports, "CUSTOM_PAGE_DESC_CHARACTER_LIMIT", () => $56eae9f7645c6524$export$8dc5686b04c6900a);
$parcel$export(module.exports, "NUMBER_OF_PAGES_INITIAL_FETCH", () => $56eae9f7645c6524$export$4b69f23d48ad7a80);
$parcel$export(module.exports, "HARD_LIMIT_CUSTOM_PAGES_MESSAGE", () => $56eae9f7645c6524$export$7e882a52c33de54f);
$parcel$export(module.exports, "NUMBER_OF_PAGES_PER_PAGE", () => $56eae9f7645c6524$export$806937cd4427be30);
const $56eae9f7645c6524$export$780035d9fe48eb32 = 240;
const $56eae9f7645c6524$export$34c86dd326ed7328 = 'cant-unlink-all-dialog';
const $56eae9f7645c6524$export$e1e71e4a40967783 = 'unlink-confirmation-dialog';
const $56eae9f7645c6524$export$39266233350d2cc1 = {
    'select-all': 5,
    'project-name': 35,
    'lead-name': 35,
    status: 15,
    'action-button': 15
};
const $56eae9f7645c6524$export$d93583f12bb7f663 = {
    'page-name': 20,
    'last-updated': 20,
    'page-description': 40,
    'action-button': 10
};
const $56eae9f7645c6524$export$24707863b4005c32 = `A custom page with this name already exists on your site. Try again with a different name.`;
const $56eae9f7645c6524$export$7b26638f36689ddd = 100;
const $56eae9f7645c6524$export$8dc5686b04c6900a = 256;
const $56eae9f7645c6524$export$4b69f23d48ad7a80 = 100;
const $56eae9f7645c6524$export$7e882a52c33de54f = `Pages limit of ${$56eae9f7645c6524$export$4b69f23d48ad7a80} is exceeded`;
const $56eae9f7645c6524$export$806937cd4427be30 = 20;

});

parcelRegister("4rJRB", function(module, exports) {
$parcel$export(module.exports, "Header", () => (parcelRequire("ewNnh")).default);

var $ewNnh = parcelRequire("ewNnh");

});
parcelRegister("ewNnh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6321f95ac0764d3c$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $f4IfF = parcelRequire("f4IfF");

var $g7QAw = parcelRequire("g7QAw");
var $6321f95ac0764d3c$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, {
    fetchUser: (0, $f4IfF.fetchUserModelAction)
})((0, $g7QAw.default));

});
parcelRegister("g7QAw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7380a67122d1b2b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $apbG6 = parcelRequire("apbG6");

var $hFKdu = parcelRequire("hFKdu");
var $fxgL3 = parcelRequire("fxgL3");

var $6bGmX = parcelRequire("6bGmX");

var $d543D = parcelRequire("d543D");
parcelRequire("7WK95");
var $gsFvz = parcelRequire("gsFvz");

var $fFQfy = parcelRequire("fFQfy");
const $a7380a67122d1b2b$var$HomeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d543D.JiraServiceManagementIcon), {
        size: "xsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    });
const $a7380a67122d1b2b$var$HomeLogo = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d543D.JiraServiceManagementLogo), {
        size: "xsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    });
const $a7380a67122d1b2b$var$Home = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fxgL3.default), {
        icon: $a7380a67122d1b2b$var$HomeIcon,
        logo: $a7380a67122d1b2b$var$HomeLogo,
        href: `${window.location.origin}/jira/your-work`
    });
const $a7380a67122d1b2b$var$Header = ({ fetchUser: fetchUser })=>{
    (0, $4fqPo.useEffect)(()=>{
        fetchUser();
    }, [
        fetchUser
    ]);
    const AppSwitcher = ()=>(0, $6bGmX.default).checkGate('update_jsm_header') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFQfy.default), null) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hFKdu.AtlassianNavigation), {
        label: "site",
        renderProductHome: $a7380a67122d1b2b$var$Home,
        renderProfile: (0, $gsFvz.default),
        renderAppSwitcher: AppSwitcher,
        primaryItems: []
    });
};
var $a7380a67122d1b2b$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'Header'
})($a7380a67122d1b2b$var$Header);

});
parcelRegister("hFKdu", function(module, exports) {
$parcel$export(module.exports, "AtlassianNavigation", () => $4c9675aa596c246a$export$f66ccb39f60980e5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");
parcelRequire("8lHWD");
var $iIhgr = parcelRequire("iIhgr");


var $aYrha = parcelRequire("aYrha");

var $7JUmF = parcelRequire("7JUmF");
var $djwMs = parcelRequire("djwMs");

var $4tZoQ = parcelRequire("4tZoQ");

var $3TFEq = parcelRequire("3TFEq");
function $4c9675aa596c246a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4c9675aa596c246a$var$containerStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'flex',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $aYrha.HORIZONTAL_GLOBAL_NAV_HEIGHT),
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBlockEnd: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    paddingInlineEnd: "var(--ds-space-150, 12px)",
    paddingInlineStart: "var(--ds-space-150, 12px)"
});
const $4c9675aa596c246a$var$leftStyles = {
    name: "vtikxo",
    styles: "display:flex;min-width:0;height:inherit;align-items:center;flex-grow:1;& > *{flex-shrink:0;}"
};
const $4c9675aa596c246a$var$rightStyles = {
    name: "1mwlrd6",
    styles: "display:flex;align-items:center;flex-shrink:0;& > *{flex-shrink:0;margin-inline-end:var(--ds-space-050, 4px);}"
};
const $4c9675aa596c246a$var$noRightMarginStyles = {
    name: "1oo7nc3",
    styles: "margin-inline-end:0"
};
const $4c9675aa596c246a$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
const $4c9675aa596c246a$export$f66ccb39f60980e5 = (props)=>{
    typeof $3TFEq;
    const { label: label, primaryItems: primaryItems = [], renderAppSwitcher: AppSwitcher, renderCreate: create, renderHelp: Help, renderNotifications: Notifications, renderProductHome: ProductHome, renderProfile: Profile, renderSearch: Search, renderSignIn: SignIn, renderSettings: Settings, moreLabel: moreLabel = "\u2026", theme: theme = (0, $7JUmF.defaultTheme), testId: testId, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $djwMs.ThemeProvider), {
        value: theme
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $iIhgr.NavigationAnalyticsContext), {
        data: $4c9675aa596c246a$var$analyticsData
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("header", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: theme.mode.navigation,
        css: $4c9675aa596c246a$var$containerStyles,
        "data-testid": testId && `${testId}-header`,
        role: "banner",
        "data-vc": `atlassian-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'atlassian-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'atlassian-navigation-placeholder'
        }
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("nav", {
        css: $4c9675aa596c246a$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && /*#__PURE__*/ (0, $lqVX7.jsx)(AppSwitcher, null), ProductHome && /*#__PURE__*/ (0, $lqVX7.jsx)(ProductHome, null), /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4tZoQ.PrimaryItemsContainer), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme
    })), /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $4c9675aa596c246a$var$rightStyles,
        "data-testid": testId && `${testId}-secondary-actions`
    }, Search && /*#__PURE__*/ (0, $lqVX7.jsx)(Search, null), /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        role: "list",
        css: [
            $4c9675aa596c246a$var$rightStyles,
            $4c9675aa596c246a$var$noRightMarginStyles
        ],
        "data-vc": "atlassian-navigation-secondary-actions"
    }, Notifications && /*#__PURE__*/ (0, $lqVX7.jsx)(Notifications, null), Help && /*#__PURE__*/ (0, $lqVX7.jsx)(Help, null), Settings && /*#__PURE__*/ (0, $lqVX7.jsx)(Settings, null), SignIn && /*#__PURE__*/ (0, $lqVX7.jsx)(SignIn, null), Profile && /*#__PURE__*/ (0, $lqVX7.jsx)(Profile, null))))));
};

});
parcelRegister("aYrha", function(module, exports) {
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $80e52ab80f8f9719$export$30fa7cc5f2690a43);
$parcel$export(module.exports, "PRODUCT_HOME_BREAKPOINT", () => $80e52ab80f8f9719$export$4033a111ca79977d);
/**
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $80e52ab80f8f9719$export$30fa7cc5f2690a43 = 56;
const $80e52ab80f8f9719$export$4033a111ca79977d = 1280;
const $80e52ab80f8f9719$export$24ec62cee78b7042 = 1130;
const $80e52ab80f8f9719$export$d8bde68ac946124f = '--ds--ans--fbc';
const $80e52ab80f8f9719$export$73e44f54603a0964 = '--ds--ans--hbgc';
const $80e52ab80f8f9719$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
const $80e52ab80f8f9719$export$d81606c1fc5119bc = '--ds--ans--c';
const $80e52ab80f8f9719$export$65f656ad520ea71 = '--ds--ans--bc';

});

parcelRegister("djwMs", function(module, exports) {
$parcel$export(module.exports, "ThemeProvider", () => $67ef00cb45fe61d6$export$d8964aec282183a3);

var $5a0b2 = parcelRequire("5a0b2");
const $67ef00cb45fe61d6$export$d8964aec282183a3 = (0, $5a0b2.ThemeContext).Provider;

});

parcelRegister("4tZoQ", function(module, exports) {
$parcel$export(module.exports, "PrimaryItemsContainer", () => $4ff0ba924220fee7$export$43e704064d596a9e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $6hIdA = parcelRequire("6hIdA");

var $azPf3 = parcelRequire("azPf3");

var $9sWj7 = parcelRequire("9sWj7");

var $012bO = parcelRequire("012bO");

var $ksGsR = parcelRequire("ksGsR");
function $4ff0ba924220fee7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4ff0ba924220fee7$var$containerStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        flexShrink: 0
    }
});
const $4ff0ba924220fee7$var$widthObserverContainerStyles = {
    name: "o1tvrz",
    styles: "width:100%;min-width:1px;margin:0px;position:relative;flex-shrink:1"
};
const $4ff0ba924220fee7$var$overflowItemsStyles = {
    name: "4ekwwx",
    styles: "color:var(--ds-text, #292A2E)"
};
const $4ff0ba924220fee7$export$43e704064d596a9e = ({ moreLabel: moreLabel, items: items, create: Create, testId: testId })=>{
    const [isMoreOpen, setIsMoreOpen] = (0, $4fqPo.useState)(false);
    const { updateWidth: updateWidth, visibleItems: visibleItems, overflowItems: overflowItems } = (0, $012bO.useOverflowController)(items);
    const onMoreClick = (0, $4fqPo.useCallback)(()=>{
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    const onMoreClose = (0, $4fqPo.useCallback)(()=>{
        setIsMoreOpen(false);
    }, []);
    const openOverflowMenu = (0, $4fqPo.useCallback)(()=>{
        setIsMoreOpen(true);
    }, []);
    const trigger = (0, $4fqPo.useCallback)((triggerProps)=>/*#__PURE__*/ (0, $lqVX7.jsx)((0, $ksGsR.PrimaryDropdownButton), {
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? `${testId}-overflow-menu-trigger` : 'overflow-menu-trigger',
            ...triggerProps
        }, moreLabel), [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    const content = (0, $4fqPo.useCallback)(()=>/*#__PURE__*/ (0, $lqVX7.jsx)((0, $9sWj7.OverflowProvider), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            css: $4ff0ba924220fee7$var$overflowItemsStyles
        }, overflowItems)), // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $4ff0ba924220fee7$var$containerStyles,
        "data-testid": testId && `${testId}-primary-actions`,
        role: "list"
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $9sWj7.OverflowProvider), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && /*#__PURE__*/ (0, $lqVX7.jsx)((0, $6hIdA.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? `${testId}-overflow-menu-popup` : 'overflow-menu-popup'
    }), Create && /*#__PURE__*/ (0, $lqVX7.jsx)(Create, null), /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: $4ff0ba924220fee7$var$widthObserverContainerStyles
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $azPf3.default), {
        offscreen: true,
        setWidth: updateWidth
    })));
};

});
parcelRegister("9sWj7", function(module, exports) {
$parcel$export(module.exports, "OverflowProvider", () => $32c2a3891069c635$export$a3a2def3937905a0);

var $4fqPo = parcelRequire("4fqPo");

var $aZIVU = parcelRequire("aZIVU");
const $32c2a3891069c635$export$a3a2def3937905a0 = ({ children: children, isVisible: isVisible, openOverflowMenu: openOverflowMenu, closeOverflowMenu: closeOverflowMenu })=>{
    const value = (0, $4fqPo.useMemo)(()=>({
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        }), [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aZIVU.OverflowContext).Provider, {
        value: value
    }, children);
};

});
parcelRegister("aZIVU", function(module, exports) {
$parcel$export(module.exports, "OverflowContext", () => $4f7d4592c6108a07$export$79f16dd643143c25);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");
const $4f7d4592c6108a07$export$79f16dd643143c25 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $c1tmZ.default),
    closeOverflowMenu: (0, $c1tmZ.default)
});

});


parcelRegister("012bO", function(module, exports) {
$parcel$export(module.exports, "useOverflowController", () => $2ae7ffa86ae75596$export$705aa66a39c35bf7);

var $4fqPo = parcelRequire("4fqPo");

var $f0ZJq = parcelRequire("f0ZJq");
const $2ae7ffa86ae75596$var$THROTTLE_INTERVAL = 64;
const $2ae7ffa86ae75596$var$ITEM_APPROX_MINWIDTH = 70;
const $2ae7ffa86ae75596$var$calculateHash = (w, n)=>w + '#' + n;
const $2ae7ffa86ae75596$var$updateHashRef = (currentRef, value)=>{
    currentRef.unshift(value);
    currentRef.length = 3;
};
const $2ae7ffa86ae75596$export$705aa66a39c35bf7 = (nodes)=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.toArray(nodes);
    const [width, setWidth] = (0, $4fqPo.useState)(9999);
    const [itemsLimit, setItemsLimit] = (0, $4fqPo.useState)(items.length);
    const [forceEffectValue, triggerForceEffect] = (0, $4fqPo.useState)({});
    // Storing items approximate width so we can try expanding when there is enough room
    const itemsWidths = (0, $4fqPo.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    const hashRef = (0, $4fqPo.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const throttleSetWidth = (0, $4fqPo.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($f0ZJq)))(setWidth, $2ae7ffa86ae75596$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $4fqPo.useEffect)(()=>{
        const lastItemWidth = itemsWidths[itemsLimit] || 0;
        const wasJustLimited = lastItemWidth < 0;
        const currentHash = $2ae7ffa86ae75596$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            const t = setTimeout(()=>{
                $2ae7ffa86ae75596$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $2ae7ffa86ae75596$var$THROTTLE_INTERVAL * 1.5);
            return ()=>clearTimeout(t);
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            const partialWidth = Math.max(Math.min(width + lastItemWidth, $2ae7ffa86ae75596$var$ITEM_APPROX_MINWIDTH * 2), $2ae7ffa86ae75596$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $2ae7ffa86ae75596$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            const nextHash = $2ae7ffa86ae75596$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $2ae7ffa86ae75596$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ const currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $2ae7ffa86ae75596$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            const nextHash = $2ae7ffa86ae75596$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $2ae7ffa86ae75596$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        return;
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};

});
parcelRegister("f0ZJq", function(module, exports) {

var $huUwr = parcelRequire("huUwr");

var $p4u5f = parcelRequire("p4u5f");
/** Error message constants. */ var $02d22c59afa6d464$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $02d22c59afa6d464$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($02d22c59afa6d464$var$FUNC_ERROR_TEXT);
    if ($p4u5f(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $huUwr(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
module.exports = $02d22c59afa6d464$var$throttle;

});
parcelRegister("huUwr", function(module, exports) {

var $p4u5f = parcelRequire("p4u5f");

var $kfVML = parcelRequire("kfVML");

var $84yTr = parcelRequire("84yTr");
/** Error message constants. */ var $cbd1152b87beb82a$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cbd1152b87beb82a$var$nativeMax = Math.max, $cbd1152b87beb82a$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $cbd1152b87beb82a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($cbd1152b87beb82a$var$FUNC_ERROR_TEXT);
    wait = $84yTr(wait) || 0;
    if ($p4u5f(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $cbd1152b87beb82a$var$nativeMax($84yTr(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        if (typeof setTimeout !== 'undefined') timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $cbd1152b87beb82a$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $kfVML();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($kfVML());
    }
    function debounced() {
        var time = $kfVML(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = $cbd1152b87beb82a$var$debounce;

});
parcelRegister("kfVML", function(module, exports) {

var $8EUJq = parcelRequire("8EUJq");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ebf2085cc5bb57b6$var$now = function() {
    return $8EUJq.Date.now();
};
module.exports = $ebf2085cc5bb57b6$var$now;

});




parcelRegister("ksGsR", function(module, exports) {
$parcel$export(module.exports, "PrimaryDropdownButton", () => $a446ef5590b69d6a$export$bb3af89fb196520d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $cTq8x = parcelRequire("cTq8x");

var $eyFiU = parcelRequire("eyFiU");
function $a446ef5590b69d6a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a446ef5590b69d6a$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $a446ef5590b69d6a$export$bb3af89fb196520d = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { component: component, isHighlighted: isHighlighted, isLoading: isLoading, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $eyFiU.PrimaryButton), {
        component: component,
        iconAfter: /*#__PURE__*/ (0, $lqVX7.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cTq8x))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isHighlighted: isHighlighted,
        isLoading: isLoading,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        tooltip: tooltip,
        css: [
            $a446ef5590b69d6a$var$buttonNoOpStyle
        ],
        ...rest
    });
});

});
parcelRegister("eyFiU", function(module, exports) {
$parcel$export(module.exports, "PrimaryButton", () => $a809ad1863184c8c$export$ac16a6a04d9b7c84);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $dM8x1 = parcelRequire("dM8x1");

var $8Mj6h = parcelRequire("8Mj6h");

var $6dHvo = parcelRequire("6dHvo");

var $3bWmd = parcelRequire("3bWmd");
function $a809ad1863184c8c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a809ad1863184c8c$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $a809ad1863184c8c$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $a809ad1863184c8c$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $a809ad1863184c8c$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $a809ad1863184c8c$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$a809ad1863184c8c$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$a809ad1863184c8c$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $a809ad1863184c8c$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $6dHvo.useTheme)();
    const button = /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        style: {
            [$a809ad1863184c8c$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$a809ad1863184c8c$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $a809ad1863184c8c$var$buttonBaseStyles,
            isHighlighted && $a809ad1863184c8c$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $dM8x1.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $3bWmd.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $a809ad1863184c8c$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $8Mj6h.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});

});
parcelRegister("3bWmd", function(module, exports) {
$parcel$export(module.exports, "getPrimaryButtonTheme", () => $166ed3d576bc2645$export$14dd6915caf431fe);
const $166ed3d576bc2645$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };

});





parcelRegister("fxgL3", function(module, exports) {
$parcel$export(module.exports, "default", () => $63f3cce6ec2f074b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $aYrha = parcelRequire("aYrha");

var $6dHvo = parcelRequire("6dHvo");

var $A3wjj = parcelRequire("A3wjj");

var $jYEOY = parcelRequire("jYEOY");

function $63f3cce6ec2f074b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63f3cce6ec2f074b$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
const $63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
const $63f3cce6ec2f074b$var$productHomeButtonStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-moz-focus-inner': {
        border: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        marginInlineStart: 0
    },
    '&:hover': {
        backgroundColor: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER})`,
        boxShadow: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER})`,
        color: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_HOVER})`
    },
    '&:active': {
        backgroundColor: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE})`,
        boxShadow: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE})`,
        color: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE})`
    },
    '&:focus-visible': {
        backgroundColor: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS})`,
        color: `var(${$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_FOCUS})`,
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'div&': {
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $aYrha.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        margin: `0 ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $aYrha.PRODUCT_HOME_BREAKPOINT}px)`]: {
        margin: `0 ${"var(--ds-space-200, 16px)"}`
    }
});
const $63f3cce6ec2f074b$var$productLogoStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: `var(${$63f3cce6ec2f074b$var$VAR_LOGO_MAX_WIDTH})`,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span > svg': {
        maxWidth: `var(${$63f3cce6ec2f074b$var$VAR_LOGO_MAX_WIDTH})`
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (max-width: ${(0, $aYrha.PRODUCT_HOME_BREAKPOINT) - 0.1}px)`]: {
        display: 'none'
    }
});
const $63f3cce6ec2f074b$var$customMaxHeightStyles = {
    name: "31vqaf",
    styles: "max-height:28px"
};
const $63f3cce6ec2f074b$var$productIconStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`@media (min-width: ${0, $aYrha.PRODUCT_HOME_BREAKPOINT}px)`]: {
        display: 'none'
    }
});
const $63f3cce6ec2f074b$var$siteTitleStyles = {
    name: "1q75v0",
    styles: "display:flex;align-items:center;margin-inline-end:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-050, 4px);padding-inline-end:var(--ds-space-200, 16px)"
};
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 *
 * @deprecated `@atlaskit/atlassian-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $63f3cce6ec2f074b$var$ProductHome = ({ 'aria-label': ariaLabel, href: href, icon: Icon, logo: Logo, logoMaxWidth: logoMaxWidth = 260, onClick: onClick, onMouseDown: onMouseDown, siteTitle: siteTitle, testId: testId, ...rest })=>{
    const theme = (0, $6dHvo.useTheme)();
    const primaryButton = theme.mode.primaryButton;
    let { iconColor: iconColor, textColor: textColor } = theme.mode.productHome;
    // If the theme returns the default Atlassian theme, rely on the Logo default behaviour instead
    if (iconColor === '#357DE8' && textColor === "var(--ds-text, #292A2E)") {
        iconColor = undefined;
        textColor = undefined;
    }
    const Tag = (0, $jYEOY.getTag)(onClick, href);
    const preventFocusRing = (e)=>{
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    const productHomeButtonDynamicStyles = (0, $A3wjj.stripEmptyProperties)({
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_ACTIVE]: primaryButton.active.color,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE]: primaryButton.active.backgroundColor,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE]: primaryButton.active.boxShadow,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_FOCUS]: primaryButton.focus.color,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS]: primaryButton.focus.backgroundColor,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS]: primaryButton.focus.boxShadow,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_COLOR_HOVER]: primaryButton.hover.color,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER]: primaryButton.hover.backgroundColor,
        [$63f3cce6ec2f074b$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER]: primaryButton.hover.boxShadow,
        [$63f3cce6ec2f074b$var$VAR_LOGO_MAX_WIDTH]: `${logoMaxWidth}px`
    });
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $4fqPo.Fragment), null, /*#__PURE__*/ (0, $lqVX7.jsx)(Tag, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: productHomeButtonDynamicStyles,
        css: $63f3cce6ec2f074b$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && `${testId}-container`,
        "aria-label": ariaLabel,
        ...rest
    }, /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: [
            $63f3cce6ec2f074b$var$customMaxHeightStyles,
            $63f3cce6ec2f074b$var$productLogoStyles
        ],
        "data-testid": testId && `${testId}-logo`
    }, /*#__PURE__*/ (0, $lqVX7.jsx)(Logo, {
        iconColor: iconColor,
        textColor: textColor,
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: iconColor || textColor ? undefined : 'brand'
    })), /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: [
            $63f3cce6ec2f074b$var$customMaxHeightStyles,
            $63f3cce6ec2f074b$var$productIconStyles
        ],
        "data-testid": testId && `${testId}-icon`
    }, /*#__PURE__*/ (0, $lqVX7.jsx)(Icon, {
        iconColor: iconColor,
        size: 'small',
        // @ts-ignore - The new icons don't have an appearance prop at the moment
        appearance: iconColor || textColor ? undefined : 'brand'
    }))), siteTitle && /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: $63f3cce6ec2f074b$var$siteTitleStyles,
        "data-testid": testId && `${testId}-site-title`
    }, siteTitle));
};
var $63f3cce6ec2f074b$export$2e2bcd8739ae039 = $63f3cce6ec2f074b$var$ProductHome;

});
parcelRegister("A3wjj", function(module, exports) {
$parcel$export(module.exports, "stripEmptyProperties", () => $d79f78af1a9f3ecd$export$e03bb5c7fd72635);
/**
 * Returns a new object with only non-empty properties of the input object.
 *
 * In this context, "empty" refers to properties with `null`, `undefined`, or `""`
 * (empty string) values.
 *
 * @param obj - The input object.
 * @returns A new object with non-empty properties of the input object.
 */ function $d79f78af1a9f3ecd$export$e03bb5c7fd72635(obj) {
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (value !== null && value !== undefined && value !== '') acc[key] = value;
        return acc;
    }, {});
}

});

parcelRegister("jYEOY", function(module, exports) {
$parcel$export(module.exports, "getTag", () => $a5fd0f7f43f344a5$export$dad497fe1f6e27c0);
const $a5fd0f7f43f344a5$export$dad497fe1f6e27c0 = (onClick, href)=>{
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};

});


parcelRegister("fFQfy", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd5f3745d5709813$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $6mmHn = parcelRequire("6mmHn");

var $k8S3H = parcelRequire("k8S3H");

var $6hIdA = parcelRequire("6hIdA");

var $dakQD = parcelRequire("dakQD");
var $6AFot = parcelRequire("6AFot");
const $dd5f3745d5709813$var$APP_SWITCHER_PRODUCT = 'jiraServiceManagement';
const $dd5f3745d5709813$var$AppSwitcherComponent = ()=>{
    const [isOpen, setIsOpen] = (0, $4fqPo.useState)(false);
    const cloudId = (0, $6mmHn.getCloudId)();
    const onClick = ()=>{
        setIsOpen(!isOpen);
    };
    const onClose = ()=>{
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6AFot.AtlassianSwitcherLoader), {
                product: $dd5f3745d5709813$var$APP_SWITCHER_PRODUCT,
                cloudId: cloudId
            }),
        isOpen: isOpen,
        onClose: onClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dakQD.default), {
                cloudId: cloudId,
                product: $dd5f3745d5709813$var$APP_SWITCHER_PRODUCT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $k8S3H.AppSwitcher), {
                onClick: onClick,
                tooltip: "Switch to...",
                ...triggerProps
            }))
    });
};
var $dd5f3745d5709813$export$2e2bcd8739ae039 = $dd5f3745d5709813$var$AppSwitcherComponent;

});
parcelRegister("k8S3H", function(module, exports) {
$parcel$export(module.exports, "AppSwitcher", () => $5dc357323402313e$export$9923361bd43fa030);
/* app-switcher.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $aZl5S = parcelRequire("aZl5S");

var $2UMA8 = parcelRequire("2UMA8");

var $fb9U1 = parcelRequire("fb9U1");
const $5dc357323402313e$var$iconSpacingStyles = {
    space050: "_1rjc1b66 _18zr1b66"
};
const $5dc357323402313e$export$9923361bd43fa030 = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fb9U1.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
            xcss: $5dc357323402313e$var$iconSpacingStyles.space050
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZl5S))), {
            color: "currentColor",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        })),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});

});
parcelRegister("aZl5S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55422f7c50559ad266d0694af3ada2f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ffff6b1caecfa8d$var$_react = $7ffff6b1caecfa8d$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $7ffff6b1caecfa8d$var$_baseNew = $7ffff6b1caecfa8d$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $7ffff6b1caecfa8d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ffff6b1caecfa8d$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $7ffff6b1caecfa8d$var$_react.default.createElement($7ffff6b1caecfa8d$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.5 11a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm-8-8a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zm8 0a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5zM7 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zM7 5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2zm8 0a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2z"/>`
    }, props));
$7ffff6b1caecfa8d$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $7ffff6b1caecfa8d$var$_default = module.exports.default = $7ffff6b1caecfa8d$var$AppSwitcherIcon;

});


parcelRegister("dakQD", function(module, exports) {
$parcel$export(module.exports, "default", () => $5371f06fd9f26495$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $f0ZJq = parcelRequire("f0ZJq");

var $ef1EP = parcelRequire("ef1EP");

var $6wTCp = parcelRequire("6wTCp");

var $4XLzq = parcelRequire("4XLzq");
var $iIhgr = parcelRequire("iIhgr");
var $dgWJT = parcelRequire("dgWJT");
var $as4kh = parcelRequire("as4kh");

var $gXH6E = parcelRequire("gXH6E");
const $5371f06fd9f26495$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $5371f06fd9f26495$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $5371f06fd9f26495$var$TRIGGER_CONTEXT = {
    componentName: (0, $4XLzq.TRIGGER_COMPONENT),
    ...(0, $gXH6E.default)
};
class $5371f06fd9f26495$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick
        }, children);
    }
    constructor(...args){
        super(...args), this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $dgWJT.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $4XLzq.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $4XLzq.NAVIGATION_CHANNEL));
        }, this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($f0ZJq)))(()=>{
            (0, $ef1EP.prefetchAll)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $5371f06fd9f26495$var$THROTTLE_EXPIRES, $5371f06fd9f26495$var$THROTTLE_OPTIONS), this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $6wTCp.performanceNow)();
        }, this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $6wTCp.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $5371f06fd9f26495$var$PrefetchTriggerWithEvents = (0, $as4kh.default)()($5371f06fd9f26495$var$PrefetchTrigger);
var $5371f06fd9f26495$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iIhgr.NavigationAnalyticsContext), {
        data: $5371f06fd9f26495$var$TRIGGER_CONTEXT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5371f06fd9f26495$var$PrefetchTriggerWithEvents, props));

});
parcelRegister("ef1EP", function(module, exports) {
$parcel$export(module.exports, "prefetchAll", () => $e0a6bbc84cfdcdf5$export$aba5d6cf034db22e);

var $iYb7S = parcelRequire("iYb7S");

var $gv463 = parcelRequire("gv463");

var $jd99F = parcelRequire("jd99F");

var $6819P = parcelRequire("6819P");

var $jd74o = parcelRequire("jd74o");
const $e0a6bbc84cfdcdf5$export$aba5d6cf034db22e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $jd99F.default)();
    (0, $6819P.prefetchFlightDeck)({});
    (0, $iYb7S.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $jd74o.prefetchThirdPartyProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $gv463.prefetchJoinableSites)(props.joinableSitesDataProvider);
};

});
parcelRegister("iYb7S", function(module, exports) {
$parcel$export(module.exports, "AvailableProductsProvider", () => $dc19854deafe4620$export$4c169257ef988618);
$parcel$export(module.exports, "prefetchAvailableProducts", () => $dc19854deafe4620$export$1c5684a3ba697d80);

var $4fqPo = parcelRequire("4fqPo");

var $dcbcR = parcelRequire("dcbcR");
const { fetchMethod: $dc19854deafe4620$var$fetchAppSwitcherBffAvailableProducts, ProviderComponent: $dc19854deafe4620$var$DefaultBffDataProviderComponent } = (0, $dcbcR.createAppSwitcherBffAvailableProductsProvider)();
const $dc19854deafe4620$export$4c169257ef988618 = ({ cloudId: cloudId, product: product, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($dc19854deafe4620$var$DefaultBffDataProviderComponent, {
        cloudId: cloudId,
        product: product
    }, children);
const $dc19854deafe4620$export$1c5684a3ba697d80 = $dc19854deafe4620$var$fetchAppSwitcherBffAvailableProducts;
const $dc19854deafe4620$export$cd9fc41c59711bdd = ()=>$dc19854deafe4620$var$fetchAppSwitcherBffAvailableProducts.reset();

});
parcelRegister("dcbcR", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffAvailableProductsProvider", () => $1a65f7a4cf9ceddc$export$7fd9c7ae7afb494c);

var $fM9GY = parcelRequire("fM9GY");

var $jflSF = parcelRequire("jflSF");

var $fxGix = parcelRequire("fxGix");
const $1a65f7a4cf9ceddc$export$f36bb44a614923a8 = '/gateway/api/app-switcher/api/available-products';
const $1a65f7a4cf9ceddc$export$1096efb00c5f8afc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $jflSF.fetchJsonWithNetworkRetries)(`${$1a65f7a4cf9ceddc$export$f36bb44a614923a8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $1a65f7a4cf9ceddc$export$7fd9c7ae7afb494c = ()=>{
    return (0, $fM9GY.createProviderWithCustomFetchData)('appSwitcherBffAvailableProducts', (0, $fxGix.ExperienceMark).API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS, $1a65f7a4cf9ceddc$export$1096efb00c5f8afc);
};

});
parcelRegister("fM9GY", function(module, exports) {
$parcel$export(module.exports, "createProviderWithCustomFetchData", () => $c63158e87a4a351b$export$310e48be95687c2f);

var $4L2Ay = parcelRequire("4L2Ay");

var $jflSF = parcelRequire("jflSF");

var $cK06Y = parcelRequire("cK06Y");
const $c63158e87a4a351b$export$500fbc0cd14cdbaa = (name, experienceMark, url)=>{
    const fetchMethod = (0, $cK06Y.withCached)((param)=>(0, $jflSF.fetchJson)(url));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $4L2Ay.default)(name, experienceMark, fetchMethod, fetchMethod.cached, // fetch will only throw on a network exception,
        // so we can safely retry on all exceptions
        {
            shouldRetryOnException: ()=>true,
            intervalsMS: [
                50,
                200,
                1000
            ]
        })
    };
};
const $c63158e87a4a351b$export$310e48be95687c2f = (name, experienceMark, fetchData, retryConfig)=>{
    const fetchMethod = (0, $cK06Y.withCached)((param)=>fetchData(param));
    return {
        fetchMethod: fetchMethod,
        ProviderComponent: (0, $4L2Ay.default)(name, experienceMark, fetchMethod, fetchMethod.cached, retryConfig)
    };
};

});
parcelRegister("4L2Ay", function(module, exports) {
$parcel$export(module.exports, "Status", () => $fbb876273d3457ce$export$96e9906d6d93a972);
$parcel$export(module.exports, "isComplete", () => $fbb876273d3457ce$export$9569565a7ac14e8e);
$parcel$export(module.exports, "isError", () => $fbb876273d3457ce$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isLoading", () => $fbb876273d3457ce$export$20bb0d907fbbe433);
$parcel$export(module.exports, "hasLoaded", () => $fbb876273d3457ce$export$5fce62f50756dbf);
$parcel$export(module.exports, "default", () => $fbb876273d3457ce$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4XLzq = parcelRequire("4XLzq");
var $dgWJT = parcelRequire("dgWJT");

var $as4kh = parcelRequire("as4kh");

var $4WX0K = parcelRequire("4WX0K");

var $1iHYZ = parcelRequire("1iHYZ");

var $4KIag = parcelRequire("4KIag");
const $fbb876273d3457ce$var$DATA_PROVIDER_SUBJECT = 'atlassianSwitcherDataProvider';
var $fbb876273d3457ce$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["LOADING"] = "loading";
    Status["COMPLETE"] = "complete";
    Status["ERROR"] = "error";
    return Status;
}({});
const $fbb876273d3457ce$export$947ceca65da0e7a6 = (data)=>({
        status: "complete",
        data: data
    });
const $fbb876273d3457ce$export$9569565a7ac14e8e = (result)=>result.status === "complete";
const $fbb876273d3457ce$export$e6127cc7fe7395c3 = (result)=>result.status === "error";
const $fbb876273d3457ce$export$20bb0d907fbbe433 = (result)=>result.status === "loading";
const $fbb876273d3457ce$export$5fce62f50756dbf = (result)=>result.status !== "loading";
function $fbb876273d3457ce$export$2e2bcd8739ae039(name, experienceMark, mapPropsToPromise, mapPropsToInitialValue, retryConfig, shouldUpdate) {
    const getInitialState = (props)=>{
        if (mapPropsToInitialValue) {
            const initialValue = mapPropsToInitialValue(props);
            if (initialValue !== undefined) return {
                status: "complete",
                data: initialValue
            };
        }
        return {
            status: "loading",
            data: null
        };
    };
    class DataProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
        static #_ = this.displayName = `DataProvider(${name})`;
        componentWillUnmount() {
            /**
       * Promise resolved after component is unmounted to be ignored
       */ this.acceptResults = false;
        }
        componentDidMount() {
            this.props.experienceTracker.markStart(experienceMark);
            this.fetchData();
        }
        componentDidUpdate(prevProps) {
            if (shouldUpdate !== null && shouldUpdate !== void 0 && shouldUpdate(prevProps.params, this.props.params)) this.fetchData();
        }
        fetchData() {
            (0, $1iHYZ.retryOnException)(()=>mapPropsToPromise(this.props.params), {
                intervalsMS: (retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS) || [],
                shouldRetryOnException: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.shouldRetryOnException,
                onRetry: (previousException, retryCount)=>{
                    this.onRetry(previousException, retryCount);
                }
            }).then((result)=>{
                this.onResult(result);
            }).catch((error)=>{
                this.onError(error);
            });
        }
        onResult(value) {
            if (this.acceptResults) this.setState({
                data: value,
                status: "complete"
            });
            this.props.experienceTracker.markEnd(experienceMark);
            this.fireOperationalEvent({
                action: 'receivedResult',
                actionSubjectId: name,
                attributes: {
                    provider: name
                }
            });
        }
        onRetry(error, retryCount) {
            this.fireOperationalEvent({
                action: 'retried',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: retryConfig !== null && retryConfig !== void 0 && retryConfig.customErrorToReason ? retryConfig.customErrorToReason(error) : (0, $4WX0K.errorToReason)(error),
                    retryCount: retryCount
                }
            });
        }
        onError(error) {
            /**
       * Do not transition from "complete" state to "error"
       */ if (this.acceptResults && !$fbb876273d3457ce$export$9569565a7ac14e8e(this.state)) this.setState({
                error: error,
                status: "error",
                data: null
            });
            this.fireOperationalEvent({
                action: 'failed',
                actionSubjectId: name,
                attributes: {
                    provider: name,
                    reason: (0, $4WX0K.errorToReason)(error)
                }
            });
        }
        render() {
            return this.props.children(this.state);
        }
        constructor(...args){
            super(...args), this.acceptResults = true, this.state = getInitialState(this.props.params), this.fireOperationalEvent = (payload)=>{
                if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                    eventType: (0, $dgWJT.OPERATIONAL_EVENT_TYPE),
                    actionSubject: $fbb876273d3457ce$var$DATA_PROVIDER_SUBJECT,
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        outdated: !this.acceptResults
                    }
                }).fire((0, $4XLzq.NAVIGATION_CHANNEL));
            };
        }
    }
    // In prefetch, we start with empty args {}, but when getting data from the cache in the data provider, extra args are injected by HOC withAnalyticsEvents and withExperienceTracker
    // This results in a cache miss due to a key mismatch.
    // The workaround here is to use a wrapper (OuterComponent) that passes the original props as a separate prop(params) to the underlying component(InnerComponent).
    // For more info: https://product-fabric.atlassian.net/browse/CXP-2697
    const InnerComponent = (0, $as4kh.default)()((0, $4KIag.withExperienceTracker)(DataProvider));
    const OuterComponent = ({ children: children, ...params })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(InnerComponent, {
            params: params
        }, children);
    };
    return OuterComponent;
}

});
parcelRegister("4XLzq", function(module, exports) {
$parcel$export(module.exports, "NAVIGATION_CHANNEL", () => $b1fb76429f20014f$export$515664faa1398f37);
$parcel$export(module.exports, "SWITCHER_SUBJECT", () => $b1fb76429f20014f$export$17ff9c46e41eb585);
$parcel$export(module.exports, "SWITCHER_ITEM_SUBJECT", () => $b1fb76429f20014f$export$7598b001981cfda5);
$parcel$export(module.exports, "SWITCHER_ITEM_LOZENGES_SUBJECT", () => $b1fb76429f20014f$export$c3c93e13b09d3ad9);
$parcel$export(module.exports, "SWITCHER_CHILD_ITEM_SUBJECT", () => $b1fb76429f20014f$export$7d4d527df0e3789c);
$parcel$export(module.exports, "SWITCHER_ITEM_EXPAND_SUBJECT", () => $b1fb76429f20014f$export$16cf10618135eb24);
$parcel$export(module.exports, "SWITCHER_COMPONENT", () => $b1fb76429f20014f$export$2b570fc112cbca);
$parcel$export(module.exports, "SWITCHER_SOURCE", () => $b1fb76429f20014f$export$5ed36c4d23de5568);
$parcel$export(module.exports, "TRIGGER_COMPONENT", () => $b1fb76429f20014f$export$8d2f933bbd9e4f09);
$parcel$export(module.exports, "TRIGGER_SUBJECT", () => $b1fb76429f20014f$export$d7029a5dc66b0736);
$parcel$export(module.exports, "SWITCHER_PARTIAL_RESULTS", () => $b1fb76429f20014f$export$4649adbfda1b6a66);
$parcel$export(module.exports, "SWITCHER_ORG_ITEM", () => $b1fb76429f20014f$export$6dd696c9ad636a67);
$parcel$export(module.exports, "SWITCHER_ORG_LIST", () => $b1fb76429f20014f$export$d9d2f872f3b91169);
$parcel$export(module.exports, "SWITCHER_JOINABLE_SITES", () => $b1fb76429f20014f$export$5724539c9b1a3a5d);
$parcel$export(module.exports, "SWITCHER_AVAILABLE_PRODUCTS", () => $b1fb76429f20014f$export$22f5f827d9934254);
$parcel$export(module.exports, "createAndFireNavigationEvent", () => $b1fb76429f20014f$export$884b1a4c7ac9dd14);
$parcel$export(module.exports, "analyticsAttributes", () => $b1fb76429f20014f$export$a305f130b289b818);
$parcel$export(module.exports, "withAnalyticsContextData", () => $b1fb76429f20014f$export$97ebdd8e7274f18a);
$parcel$export(module.exports, "RenderTracker", () => $b1fb76429f20014f$export$e09ad93c2b74b853);
$parcel$export(module.exports, "NotRenderedTracker", () => $b1fb76429f20014f$export$95b1f1a72cad0dcb);
$parcel$export(module.exports, "ViewedTracker", () => $b1fb76429f20014f$export$b3fd6624b6a6d057);
$parcel$export(module.exports, "getCustomLinksRenderTracker", () => $b1fb76429f20014f$export$d75a4f56d85f67ea);
$parcel$export(module.exports, "getItemAnalyticsContext", () => $b1fb76429f20014f$export$6489efba2ca85102);
$parcel$export(module.exports, "withAnalyticsEvents", () => (parcelRequire("as4kh")).default);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("iIhgr")).NavigationAnalyticsContext);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => (parcelRequire("dgWJT")).OPERATIONAL_EVENT_TYPE);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => (parcelRequire("dgWJT")).UI_EVENT_TYPE);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("8lHWD");
var $iIhgr = parcelRequire("iIhgr");

var $jQXWT = parcelRequire("jQXWT");
var $as4kh = parcelRequire("as4kh");

var $dgWJT = parcelRequire("dgWJT");

var $4L2Ay = parcelRequire("4L2Ay");

var $J4m6z = parcelRequire("J4m6z");

var $b2BiW = parcelRequire("b2BiW");
const $b1fb76429f20014f$export$515664faa1398f37 = 'navigation';
const $b1fb76429f20014f$export$17ff9c46e41eb585 = 'atlassianSwitcher';
const $b1fb76429f20014f$export$7598b001981cfda5 = 'atlassianSwitcherItem';
const $b1fb76429f20014f$export$c3c93e13b09d3ad9 = 'atlassianSwitcherItemLozenges';
const $b1fb76429f20014f$export$7d4d527df0e3789c = 'atlassianSwitcherChildItem';
const $b1fb76429f20014f$export$16cf10618135eb24 = 'atlassianSwitcherItemExpand';
const $b1fb76429f20014f$export$2b570fc112cbca = 'atlassianSwitcher';
const $b1fb76429f20014f$export$5ed36c4d23de5568 = 'atlassianSwitcher';
const $b1fb76429f20014f$export$8d2f933bbd9e4f09 = 'atlassianSwitcherPrefetch';
const $b1fb76429f20014f$export$d7029a5dc66b0736 = 'atlassianSwitcherPrefetch';
const $b1fb76429f20014f$export$4649adbfda1b6a66 = 'atlassianSwitcherPartialResultError';
const $b1fb76429f20014f$export$6dd696c9ad636a67 = 'atlassianSwitcherOrgItem';
const $b1fb76429f20014f$export$53f2256589c0fa08 = 'atlassianSwitcherOrgNameExpandPanel';
const $b1fb76429f20014f$export$d9d2f872f3b91169 = 'atlassianSwitcherOrganisationsList';
const $b1fb76429f20014f$export$5724539c9b1a3a5d = 'atlassianSwitcherJoinableSites';
const $b1fb76429f20014f$export$22f5f827d9934254 = 'atlassianSwitcherAvailableProducts';
const $b1fb76429f20014f$var$SWITCHER_CUSTOM_LINKS = 'atlassianSwitcherCustomLinks';
const $b1fb76429f20014f$var$RENDERED_ACTION = 'rendered';
const $b1fb76429f20014f$var$NOT_RENDERED_ACTION = 'not_rendered';
const $b1fb76429f20014f$var$VIEWED_ACTION = 'viewed';
const $b1fb76429f20014f$export$884b1a4c7ac9dd14 = (0, $jQXWT.default)($b1fb76429f20014f$export$515664faa1398f37);
const $b1fb76429f20014f$export$a305f130b289b818 = (attributes)=>({
        attributes: attributes
    });
const $b1fb76429f20014f$export$97ebdd8e7274f18a = function(mapPropsToContext) {
    return function(WrappedComponent) {
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iIhgr.NavigationAnalyticsContext), {
                data: mapPropsToContext(props)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, props));
    };
};
const $b1fb76429f20014f$var$isValidDuration = (duration)=>{
    return duration !== null && duration !== undefined && duration >= 0;
};
const $b1fb76429f20014f$export$e09ad93c2b74b853 = (0, $as4kh.default)({
    onRender: (createAnalyticsEvent, props)=>{
        var _props$data;
        const duration = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.duration;
        return createAnalyticsEvent({
            eventType: (0, $dgWJT.OPERATIONAL_EVENT_TYPE),
            action: $b1fb76429f20014f$var$RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: {
                ...props.data,
                ...$b1fb76429f20014f$var$isValidDuration(duration) && {
                    bucket: (0, $b2BiW.getMetricBucket)(duration, (0, $b2BiW.RenderTrackerBuckets))
                }
            }
        }).fire($b1fb76429f20014f$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $b1fb76429f20014f$export$95b1f1a72cad0dcb = (0, $as4kh.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $dgWJT.OPERATIONAL_EVENT_TYPE),
            action: $b1fb76429f20014f$var$NOT_RENDERED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($b1fb76429f20014f$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $b1fb76429f20014f$export$b3fd6624b6a6d057 = (0, $as4kh.default)({
    onRender: (createAnalyticsEvent, props)=>{
        return createAnalyticsEvent({
            eventType: (0, $dgWJT.UI_EVENT_TYPE),
            action: $b1fb76429f20014f$var$VIEWED_ACTION,
            actionSubject: props.subject,
            attributes: props.data
        }).fire($b1fb76429f20014f$export$515664faa1398f37);
    }
})(class extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    componentDidMount() {
        this.props.onRender();
    }
    render() {
        return null;
    }
});
const $b1fb76429f20014f$var$renderTrackerWithReason = ({ subject: subject, notRenderedReason: notRenderedReason, emptyRenderExpected: emptyRenderExpected, data: data })=>{
    if (notRenderedReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b1fb76429f20014f$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            notRenderedReason: notRenderedReason
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b1fb76429f20014f$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $b1fb76429f20014f$var$renderTracker = ({ subject: subject, providerFailed: providerFailed, emptyRenderExpected: emptyRenderExpected, linksRendered: linksRendered, data: data })=>{
    if (providerFailed || linksRendered.length === 0 && !emptyRenderExpected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b1fb76429f20014f$export$95b1f1a72cad0dcb, {
        subject: subject,
        data: {
            ...data,
            providerFailed: providerFailed
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($b1fb76429f20014f$export$e09ad93c2b74b853, {
        subject: subject,
        data: {
            ...data,
            emptyRender: emptyRenderExpected
        }
    });
};
const $b1fb76429f20014f$export$e823e937102b322b = (providerResult, joinableSiteLinks, data)=>{
    if (!(0, $4L2Ay.hasLoaded)(providerResult)) return null;
    if (providerResult.data && !providerResult.data.sites) return null;
    // The render is considered failed when either the provider failed, or the provider returned a non-empty result but nothing was rendered
    const emptyRenderExpected = Boolean(providerResult.data && providerResult.data.sites && providerResult.data.sites.length === 0);
    return $b1fb76429f20014f$var$renderTracker({
        subject: $b1fb76429f20014f$export$5724539c9b1a3a5d,
        providerFailed: providerResult.data === null,
        emptyRenderExpected: emptyRenderExpected,
        linksRendered: joinableSiteLinks,
        data: data
    });
};
const $b1fb76429f20014f$export$d75a4f56d85f67ea = (customLinksProviderResult, userSiteDataProviderResult, customLinks, data)=>{
    // The render is only considered failed when one of the providers failed, and empty render is a valid case
    if (!customLinksProviderResult) return;
    const emptyRenderExpected = customLinks.length === 0;
    function getNotRenderedReason() {
        if ((customLinksProviderResult === null || customLinksProviderResult === void 0 ? void 0 : customLinksProviderResult.status) === (0, $4L2Ay.Status).ERROR) return 'custom_links_api_error';
        const error = userSiteDataProviderResult.error;
        if (!error) return null;
        if (error instanceof (0, $J4m6z.UserSiteDataError)) return error.reason;
        else return 'usd_unknown';
    }
    const notRenderedReason = getNotRenderedReason();
    return $b1fb76429f20014f$var$renderTrackerWithReason({
        subject: $b1fb76429f20014f$var$SWITCHER_CUSTOM_LINKS,
        notRenderedReason: notRenderedReason,
        emptyRenderExpected: emptyRenderExpected,
        data: data
    });
};
const $b1fb76429f20014f$export$6489efba2ca85102 = (groupIndex, id, type, productType, extraAttributes)=>({
        ...$b1fb76429f20014f$export$a305f130b289b818({
            groupIndex: groupIndex,
            itemId: id,
            itemType: type,
            productType: productType,
            ...extraAttributes
        })
    });

});
parcelRegister("J4m6z", function(module, exports) {
$parcel$export(module.exports, "UserSiteDataErrorReason", () => $38dd09b4a5559ff2$export$b08600051ba52198);
$parcel$export(module.exports, "UserSiteDataError", () => $38dd09b4a5559ff2$export$c460344055e97b1);
var $38dd09b4a5559ff2$export$b08600051ba52198 = /*#__PURE__*/ function(UserSiteDataErrorReason) {
    UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
    UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
    UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
    return UserSiteDataErrorReason;
}({});
class $38dd09b4a5559ff2$export$c460344055e97b1 extends Error {
    constructor(reason, message){
        super(message);
        this.name = 'UserSiteDataError';
        this.reason = reason;
    }
}

});

parcelRegister("b2BiW", function(module, exports) {
$parcel$export(module.exports, "RenderTrackerBuckets", () => $b148c06cc7f4a0a5$export$e59c24bc0768d568);
$parcel$export(module.exports, "getMetricBucket", () => $b148c06cc7f4a0a5$export$b59492d26971ae92);
const $b148c06cc7f4a0a5$var$INFINITY = '+Inf';
const $b148c06cc7f4a0a5$export$e59c24bc0768d568 = [
    1000,
    900,
    800,
    700,
    600,
    500
];
const $b148c06cc7f4a0a5$export$b59492d26971ae92 = (metricValue, buckets)=>{
    return metricValue >= 0 ? buckets.reduce((lowestBucket, currentBucket)=>{
        return metricValue <= currentBucket ? currentBucket.toString() : lowestBucket.toString();
    }, $b148c06cc7f4a0a5$var$INFINITY) : null;
};

});


parcelRegister("4WX0K", function(module, exports) {
$parcel$export(module.exports, "errorToReason", () => $70cb11d905b031a7$export$a3e288208721751b);
function $70cb11d905b031a7$export$a3e288208721751b(error) {
    const { name: name = 'Unknown', status: status } = error || {};
    return {
        name: name,
        status: status
    };
}

});

parcelRegister("1iHYZ", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $a7dd1f7874c97790$export$1d94629c94e7a17f);
const $a7dd1f7874c97790$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $a7dd1f7874c97790$export$1d94629c94e7a17f = async (invokeOperation, config)=>{
    let nextMSInterval = 0;
    let error = new Error('No calls made');
    const retries = config.intervalsMS.length;
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) {
            await $a7dd1f7874c97790$export$5c069c93d2b7493f(nextMSInterval);
            if (config.onRetry) config.onRetry(error, retries - config.intervalsMS.length);
        }
        return await invokeOperation();
    } catch (e) {
        error = e;
        if (config.shouldRetryOnException && !config.shouldRetryOnException(error)) throw error;
        nextMSInterval = config.intervalsMS.shift();
    }
    throw error;
};

});

parcelRegister("4KIag", function(module, exports) {
$parcel$export(module.exports, "SwitcherExperienceTrackerContext", () => $40a58ae609d5a932$export$3f3eebb4b8116461);
$parcel$export(module.exports, "useExperienceTracker", () => $40a58ae609d5a932$export$cdefb2a8b53f879f);
$parcel$export(module.exports, "withExperienceTracker", () => $40a58ae609d5a932$export$f88dde183f4d31cb);

var $4fqPo = parcelRequire("4fqPo");
const $40a58ae609d5a932$var$noop = ()=>{};
const $40a58ae609d5a932$export$3f3eebb4b8116461 = /*#__PURE__*/ (0, $4fqPo.createContext)({
    start: $40a58ae609d5a932$var$noop,
    success: $40a58ae609d5a932$var$noop,
    failure: $40a58ae609d5a932$var$noop,
    failureAll: $40a58ae609d5a932$var$noop,
    abort: $40a58ae609d5a932$var$noop,
    abortAll: $40a58ae609d5a932$var$noop,
    markStart: $40a58ae609d5a932$var$noop,
    markEnd: $40a58ae609d5a932$var$noop
});
const $40a58ae609d5a932$export$cdefb2a8b53f879f = ()=>(0, $4fqPo.useContext)($40a58ae609d5a932$export$3f3eebb4b8116461);
const $40a58ae609d5a932$export$f88dde183f4d31cb = (Component)=>{
    const WithExperienceTracker = (props)=>{
        const experienceTracker = $40a58ae609d5a932$export$cdefb2a8b53f879f();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Component, {
            ...props,
            experienceTracker: experienceTracker
        });
    };
    WithExperienceTracker.displayName = `WithExperienceTracker(${Component.displayName})`;
    return WithExperienceTracker;
};

});


parcelRegister("jflSF", function(module, exports) {
$parcel$export(module.exports, "fetchJson", () => $01e6ea9a249ac812$export$6d71b655afe1638d);
$parcel$export(module.exports, "fetchJsonWithNetworkRetries", () => $01e6ea9a249ac812$export$16566b750080153d);
$parcel$export(module.exports, "postJson", () => $01e6ea9a249ac812$export$c776284ef4b1209a);

var $jzGcj = parcelRequire("jzGcj");

var $1iHYZ = parcelRequire("1iHYZ");

var $gXH6E = parcelRequire("gXH6E");
const $01e6ea9a249ac812$var$extraJsonFromResponse = (response)=>{
    if (response.ok) return response.json();
    throw new (0, $jzGcj.FetchError)(`Unable to fetch ${response.url} ${response.status} ${response.statusText}`, response.status);
};
const $01e6ea9a249ac812$export$6d71b655afe1638d = (url, init, emptyResponse)=>fetch(url, {
        credentials: 'include',
        ...init,
        headers: {
            'Atl-App-Switcher-Version': (0, $gXH6E.default).packageVersion,
            ...init === null || init === void 0 ? void 0 : init.headers
        }
    }).then(!emptyResponse ? $01e6ea9a249ac812$var$extraJsonFromResponse : ()=>{});
const $01e6ea9a249ac812$export$16566b750080153d = (url, retryConfig, init)=>{
    return (0, $1iHYZ.retryOnException)(()=>fetch(url, {
            credentials: 'include',
            ...init,
            headers: {
                'Atl-App-Switcher-Version': (0, $gXH6E.default).packageVersion,
                ...init === null || init === void 0 ? void 0 : init.headers
            }
        }), retryConfig).then($01e6ea9a249ac812$var$extraJsonFromResponse);
};
const $01e6ea9a249ac812$export$c776284ef4b1209a = (url, data, emptyResponse)=>$01e6ea9a249ac812$export$6d71b655afe1638d(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }, emptyResponse);

});
parcelRegister("jzGcj", function(module, exports) {
$parcel$export(module.exports, "FETCH_ERROR_NAME", () => $c468bd392ab62b75$export$83179404a61b001a);
$parcel$export(module.exports, "FetchError", () => $c468bd392ab62b75$export$26e841bcf1aeb894);
const $c468bd392ab62b75$export$83179404a61b001a = 'FetchError';
class $c468bd392ab62b75$export$26e841bcf1aeb894 extends Error {
    constructor(message, status){
        super(message), this.name = $c468bd392ab62b75$export$83179404a61b001a;
        this.status = status;
    }
    static isFetchError(value) {
        return value instanceof $c468bd392ab62b75$export$26e841bcf1aeb894;
    }
}

});

parcelRegister("gXH6E", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1edf77cab56c18b$export$2e2bcd8739ae039);
const $c1edf77cab56c18b$var$packageName = undefined;
const $c1edf77cab56c18b$var$packageVersion = undefined;
const $c1edf77cab56c18b$var$_default_1 = {
    packageName: $c1edf77cab56c18b$var$packageName,
    packageVersion: $c1edf77cab56c18b$var$packageVersion
};
var $c1edf77cab56c18b$export$2e2bcd8739ae039 = $c1edf77cab56c18b$var$_default_1;

});


parcelRegister("cK06Y", function(module, exports) {
$parcel$export(module.exports, "withCached", () => $206864604cab073e$export$7f51828d6b6af163);
const $206864604cab073e$export$d4d4b402ab64e2f4 = 5000;
const $206864604cab073e$var$isPromise = (p)=>{
    return typeof p.then === 'function' && typeof p.catch === 'function';
};
const $206864604cab073e$export$7f51828d6b6af163 = (fn)=>{
    const resultCache = new Map();
    const promiseCache = new Map();
    function getCacheKey(...args) {
        return JSON.stringify(args);
    }
    const cached = (...args)=>{
        const cacheKey = getCacheKey(...args);
        return resultCache.get(cacheKey);
    };
    const reset = ()=>{
        resultCache.clear();
        promiseCache.clear();
    };
    const execute = (...args)=>{
        const cacheKey = getCacheKey(...args);
        const cachedPromise = promiseCache.get(cacheKey);
        if (cachedPromise !== undefined) return cachedPromise;
        const maybePromise = fn(...args);
        promiseCache.set(cacheKey, maybePromise);
        if ($206864604cab073e$var$isPromise(maybePromise)) maybePromise.then((result)=>{
            resultCache.set(cacheKey, result);
            setTimeout(()=>promiseCache.delete(cacheKey), $206864604cab073e$export$d4d4b402ab64e2f4);
        }).catch(()=>{
            promiseCache.delete(cacheKey);
        });
        return maybePromise;
    };
    return Object.assign(execute, fn, {
        cached: cached,
        reset: reset
    });
};

});


parcelRegister("fxGix", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $3aae988a85f2fb6c$export$c90b54e658fc4d7c);
$parcel$export(module.exports, "EXPERIENCE_CONFIGS", () => $3aae988a85f2fb6c$export$d54d7a2744fdf647);
$parcel$export(module.exports, "ExperienceMark", () => $3aae988a85f2fb6c$export$cbf1e672c3e37474);
$parcel$export(module.exports, "EXPERIENCES_TO_MARKS", () => $3aae988a85f2fb6c$export$755e75afbd377bc4);
$parcel$export(module.exports, "MARKS_TO_EXPERIENCES", () => $3aae988a85f2fb6c$export$805ed806e0769ee4);
$parcel$export(module.exports, "ExperienceMarkPhase", () => $3aae988a85f2fb6c$export$ec8391a70bbdbe59);
$parcel$export(module.exports, "AbortReason", () => $3aae988a85f2fb6c$export$279d6315a97b520d);
$parcel$export(module.exports, "SWITCHER_RENDER_START_PERFORMANCE_MARK", () => $3aae988a85f2fb6c$export$86919b84f9a64054);

var $bdtMB = parcelRequire("bdtMB");

var $l8veE = parcelRequire("l8veE");
var $3aae988a85f2fb6c$export$c90b54e658fc4d7c = /*#__PURE__*/ function(Experience) {
    Experience["RENDER_CUSTOM_LINKS_SECTION"] = "render-custom-links-section";
    Experience["RENDER_SWITCH_TO_SECTION"] = "render-switch-to-section";
    Experience["RENDER_SWITCHER_EMPTY_STATE"] = "render-switcher-empty-state";
    Experience["RENDER_THIRD_PARTY_SECTION"] = "render-third-party-section";
    return Experience;
}({});
const $3aae988a85f2fb6c$export$d54d7a2744fdf647 = {
    ["render-custom-links-section"]: {
        type: (0, $bdtMB.ExperienceTypes).Load,
        performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switch-to-section"]: {
        type: (0, $bdtMB.ExperienceTypes).Load,
        performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-switcher-empty-state"]: {
        type: (0, $bdtMB.ExperienceTypes).Load,
        performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad
    },
    ["render-third-party-section"]: {
        type: (0, $bdtMB.ExperienceTypes).Load,
        performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageSegmentLoad
    }
};
var $3aae988a85f2fb6c$export$cbf1e672c3e37474 = /*#__PURE__*/ function(ExperienceMark) {
    ExperienceMark["API_APP_SWITCHER_BFF_AVAILABLE_PRODUCTS"] = "api-app-switcher-bff-available-products";
    ExperienceMark["API_APP_SWITCHER_BFF_GLOBAL_APPS"] = "api-app-switcher-bff-global-apps";
    ExperienceMark["API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS"] = "api-app-switcher-bff-third-party-products";
    ExperienceMark["API_CONFLUENCE_CUSTOM_LINKS"] = "api-confluence-custom-links";
    ExperienceMark["API_FLIGHT_DECK"] = "api-flight-deck";
    ExperienceMark["API_JIRA_CUSTOM_LINKS"] = "api-jira-custom-links";
    ExperienceMark["API_JOINABLE_SITES"] = "api-joinable-sites";
    ExperienceMark["API_PERMISSIONS"] = "api-permissions";
    ExperienceMark["SWITCHER_INITIAL_MOUNT"] = "switcher-initial-mount";
    ExperienceMark["SWITCHER_SKELETON_MOUNT"] = "switcher-skeleton-mount";
    // Mock for tests
    ExperienceMark["TEST_MARK"] = "test-mark";
    return ExperienceMark;
}({});
const $3aae988a85f2fb6c$var$allNonTestExperienceMarks = Object.values($3aae988a85f2fb6c$export$cbf1e672c3e37474).filter((mark)=>mark !== "test-mark");
const $3aae988a85f2fb6c$export$755e75afbd377bc4 = {
    ["render-custom-links-section"]: $3aae988a85f2fb6c$var$allNonTestExperienceMarks,
    ["render-switch-to-section"]: $3aae988a85f2fb6c$var$allNonTestExperienceMarks,
    ["render-switcher-empty-state"]: $3aae988a85f2fb6c$var$allNonTestExperienceMarks,
    ["render-third-party-section"]: $3aae988a85f2fb6c$var$allNonTestExperienceMarks
};
const $3aae988a85f2fb6c$export$805ed806e0769ee4 = (0, $l8veE.invertRecordOfArrays)($3aae988a85f2fb6c$export$755e75afbd377bc4);
var $3aae988a85f2fb6c$export$ec8391a70bbdbe59 = /*#__PURE__*/ function(ExperienceMarkPhase) {
    ExperienceMarkPhase["START"] = "start";
    ExperienceMarkPhase["END"] = "end";
    return ExperienceMarkPhase;
}({});
var $3aae988a85f2fb6c$export$279d6315a97b520d = /*#__PURE__*/ function(AbortReason) {
    AbortReason["COMPONENT_UNMOUNTED"] = "component-unmounted";
    AbortReason["WINDOW_UNLOADING"] = "window-unloading";
    return AbortReason;
}({});
const $3aae988a85f2fb6c$export$86919b84f9a64054 = 'atlassianSwitcher.render.start';

});
parcelRegister("l8veE", function(module, exports) {
$parcel$export(module.exports, "invertRecordOfArrays", () => $41b3895c18a84170$export$c371a74fe5222b3);
function $41b3895c18a84170$export$c371a74fe5222b3(record) {
    const invertedRecord = {};
    Object.entries(record).forEach(([key, values])=>{
        values.forEach((value)=>{
            if (!invertedRecord[value]) invertedRecord[value] = [];
            invertedRecord[value].push(key);
        });
    });
    return invertedRecord;
}

});




parcelRegister("gv463", function(module, exports) {
$parcel$export(module.exports, "JoinableSitesProvider", () => $3f5db53dd9039e58$export$70da68d3b04f82d0);
$parcel$export(module.exports, "prefetchJoinableSites", () => $3f5db53dd9039e58$export$2aed3ef1595b4d9);

var $4fqPo = parcelRequire("4fqPo");

var $9RDZn = parcelRequire("9RDZn");
const { fetchMethod: $3f5db53dd9039e58$var$fetchJoinableSites, ProviderComponent: $3f5db53dd9039e58$var$DefaultDataProviderComponent } = (0, $9RDZn.createJoinableSitesProvider)();
const $3f5db53dd9039e58$export$70da68d3b04f82d0 = ({ children: children, joinableSitesDataProvider: joinableSitesDataProvider, cloudId: cloudId })=>{
    const CustomDataProviderComponent = joinableSitesDataProvider && joinableSitesDataProvider.ProviderComponent;
    const DataProviderComponent = CustomDataProviderComponent || $3f5db53dd9039e58$var$DefaultDataProviderComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(DataProviderComponent, {
        cloudId: cloudId
    }, children);
};
const $3f5db53dd9039e58$export$2aed3ef1595b4d9 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod({});
        return;
    }
    $3f5db53dd9039e58$var$fetchJoinableSites({});
};
const $3f5db53dd9039e58$export$4ba2a997caa6db74 = (customProvider)=>{
    if (customProvider) {
        customProvider.fetchMethod.reset();
        return;
    }
    $3f5db53dd9039e58$var$fetchJoinableSites.reset();
};

});
parcelRegister("9RDZn", function(module, exports) {
$parcel$export(module.exports, "createJoinableSitesProvider", () => $dff536a522ba2848$export$c3b6af53f1ca17d8);

var $fM9GY = parcelRequire("fM9GY");

var $fxGix = parcelRequire("fxGix");
const $dff536a522ba2848$export$62986affcccd56a5 = ()=>Promise.resolve({
        sites: undefined
    });
const $dff536a522ba2848$export$c3b6af53f1ca17d8 = (fetchData = $dff536a522ba2848$export$62986affcccd56a5, retryConfig)=>{
    return (0, $fM9GY.createProviderWithCustomFetchData)('joinableSites', (0, $fxGix.ExperienceMark).API_JOINABLE_SITES, fetchData, retryConfig);
};

});


parcelRegister("jd99F", function(module, exports) {
$parcel$export(module.exports, "default", () => $27da3cd4d99f1279$export$2e2bcd8739ae039);

var $6AFot = parcelRequire("6AFot");
var $27da3cd4d99f1279$export$2e2bcd8739ae039 = ()=>{
    (0, $6AFot.loadAtlassianSwitcher)();
    return (0, $6AFot.loadGenericSwitcher)();
};

});
parcelRegister("6AFot", function(module, exports) {
$parcel$export(module.exports, "loadAtlassianSwitcher", () => $529c677460a75e50$export$6c6894dd831bfacb);
$parcel$export(module.exports, "loadGenericSwitcher", () => $529c677460a75e50$export$64191a36345a6b2b);
$parcel$export(module.exports, "AtlassianSwitcherLoader", () => $529c677460a75e50$export$25f16f9fee84a840);
$parcel$export(module.exports, "GenericSwitcherLoader", () => $529c677460a75e50$export$8c21d1a0c59fc17e);

var $jk6Pl = parcelRequire("jk6Pl");

var $4fqPo = parcelRequire("4fqPo");

var $hsjip = parcelRequire("hsjip");

const $529c677460a75e50$export$6c6894dd831bfacb = ()=>(parcelRequire("1ohwI")).then((module)=>module.default);

const $529c677460a75e50$export$64191a36345a6b2b = ()=>(parcelRequire("eEQSz")).then((module)=>module.default);
const $529c677460a75e50$export$25f16f9fee84a840 = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: $529c677460a75e50$export$6c6894dd831bfacb,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hsjip.default), null)
});
const $529c677460a75e50$export$8c21d1a0c59fc17e = (0, (/*@__PURE__*/$parcel$interopDefault($jk6Pl)))({
    loader: $529c677460a75e50$export$64191a36345a6b2b,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hsjip.default), null)
});

});
parcelRegister("hsjip", function(module, exports) {
$parcel$export(module.exports, "default", () => $268d9b058010eb80$export$2e2bcd8739ae039);
/* skeleton.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");

var $fxGix = parcelRequire("fxGix");
var $goalg = parcelRequire("goalg");

var $4MCQn = parcelRequire("4MCQn");

var $bqPFt = parcelRequire("bqPFt");
/*
  In the Remote App Switcher, the Skeleton component shows up first as a fallback while the full Remote App Switcher is still loading.
  Since the styles (compiled CSS) are lazy-loaded with the full App Switcher, they are not be ready when the Skeleton appears.
  This causes visual issues where the Skeleton looks broken

  To avoid this, we use inline styles instead. This guarantees that all required styles are applied immediately with the component.
  https://hello.jira.atlassian.cloud/browse/NAVX-676
*/ const $268d9b058010eb80$var$iconSkeleton = /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
    style: {
        display: 'inline-block',
        width: 32,
        height: 32,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-large, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
    }
});
const $268d9b058010eb80$var$lineSkeleton = /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
    style: {
        display: 'inline-block',
        width: 260,
        height: 10,
        backgroundColor: "var(--ds-skeleton, #0515240F)",
        borderRadius: "var(--ds-radius-small, 4px)"
    }
});
var $268d9b058010eb80$export$2e2bcd8739ae039 = ()=>{
    (0, $goalg.useExperienceRenderAndMountMark)((0, $fxGix.ExperienceMark).SWITCHER_SKELETON_MOUNT);
    const { formatMessage: formatMessage } = (0, $4MCQn.default)();
    const items = /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        "aria-hidden": "true",
        style: {
            display: 'flex',
            paddingInline: "var(--ds-space-200, 16px)",
            paddingBlock: "var(--ds-space-100, 8px)",
            alignItems: 'center'
        }
    }, $268d9b058010eb80$var$iconSkeleton, $268d9b058010eb80$var$lineSkeleton);
    return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        as: "section",
        style: {
            width: '343px',
            height: '80vh'
        },
        role: "alert",
        "aria-label": formatMessage((0, $bqPFt.default).skeletonLoaderAriaLabel),
        testId: "skeleton"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        "aria-hidden": "true",
        style: {
            paddingInline: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-300, 24px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }
    }, $268d9b058010eb80$var$lineSkeleton), items, items, items);
};

});
parcelRegister("goalg", function(module, exports) {
$parcel$export(module.exports, "useExperienceSuccess", () => $c046a94cbbdd89bf$export$e94f0da4fc0603c6);
$parcel$export(module.exports, "useExperienceRenderAndMountMark", () => $c046a94cbbdd89bf$export$fb30551804b67d63);
/* eslint-disable no-console */ 
var $4KIag = parcelRequire("4KIag");

var $4fqPo = parcelRequire("4fqPo");

var $1i3ex = parcelRequire("1i3ex");
function $c046a94cbbdd89bf$export$675e0d25df38d426(experienceName, customStartTime) {
    const experienceTracker = (0, $4KIag.useExperienceTracker)();
    (0, $1i3ex.useOnceImmediately)(()=>experienceTracker.start(experienceName, customStartTime));
}
function $c046a94cbbdd89bf$export$e94f0da4fc0603c6(experience, attributes) {
    const experienceTracker = (0, $4KIag.useExperienceTracker)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4fqPo.useLayoutEffect)(()=>experienceTracker.success(experience, attributes), []);
}
function $c046a94cbbdd89bf$export$fb30551804b67d63(mark) {
    const experienceTracker = (0, $4KIag.useExperienceTracker)();
    (0, $1i3ex.useOnceImmediately)(()=>experienceTracker.markStart(mark));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4fqPo.useLayoutEffect)(()=>experienceTracker.markEnd(mark), []);
}

});
parcelRegister("1i3ex", function(module, exports) {
$parcel$export(module.exports, "useSingleton", () => $f6e91102074036cd$export$abf4268d2dd55708);
$parcel$export(module.exports, "useOnceImmediately", () => $f6e91102074036cd$export$ad4f8d0eee7a0e24);

var $4fqPo = parcelRequire("4fqPo");
function $f6e91102074036cd$export$abf4268d2dd55708(builder) {
    const ref = (0, $4fqPo.useRef)();
    if (!ref.current) ref.current = builder();
    return ref.current;
}
function $f6e91102074036cd$export$ad4f8d0eee7a0e24(callback) {
    const wasCalledRef = (0, $4fqPo.useRef)(false);
    const result = (0, $4fqPo.useRef)();
    if (!wasCalledRef.current) {
        wasCalledRef.current = true;
        result.current = callback();
    }
    return result.current;
}

});


parcelRegister("bqPFt", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c52b9c4b6735119$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $0c52b9c4b6735119$var$messages = (0, $6BhDL.defineMessages)({
    newLozenge: {
        id: 'fabric.atlassianSwitcher.newLozenge',
        defaultMessage: 'New',
        description: 'The lozenge text for a lozenge indicating a new switcher item'
    },
    tryLozenge: {
        id: 'fabric.atlassianSwitcher.tryLozenge',
        defaultMessage: 'Try',
        description: 'Alternative lozenge text for a lozenge indicating a new switcher item'
    },
    sites: {
        id: 'fabric.atlassianSwitcher.sites',
        defaultMessage: '{productName} {numSites, plural, one {site} other {sites}}',
        description: 'The text of a toggle showing or hiding more site options'
    },
    skeletonLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeletonLoaderAriaLabel',
        defaultMessage: 'The App Switcher is loading',
        description: 'The aria-label for the app switcher skeleton loader primitive'
    },
    skeleton3pLoaderAriaLabel: {
        id: 'fabric.atlassianSwitcher.skeleton3pLoaderAriaLabel',
        defaultMessage: 'The App Switcher third party section is loading',
        description: 'The aria-label for the app switcher third party skeleton loader primitive'
    },
    reorderItemDropdown: {
        id: 'fabric.atlassianSwitcher.reorderItemDropdown',
        defaultMessage: 'Reorder menu item',
        description: 'The text of a button to reorder an item in the switcher'
    },
    moveItemUp: {
        id: 'fabric.atlassianSwitcher.moveItemUp',
        defaultMessage: 'Move up',
        description: 'The text of a button to move an item up in the switcher'
    },
    moveItemDown: {
        id: 'fabric.atlassianSwitcher.moveItemDown',
        defaultMessage: 'Move down',
        description: 'The text of a button to move an item down in the switcher'
    },
    moveItemToTop: {
        id: 'fabric.atlassianSwitcher.moveItemToTop',
        defaultMessage: 'Move to top',
        description: 'The text of a button to move an item to the top in the switcher'
    },
    moveItemToBottom: {
        id: 'fabric.atlassianSwitcher.moveItemToBottom',
        defaultMessage: 'Move to bottom',
        description: 'The text of a button to move an item to the bottom in the switcher'
    }
});
var $0c52b9c4b6735119$export$2e2bcd8739ae039 = $0c52b9c4b6735119$var$messages;

});


parcelRegister("1ohwI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("jBAmJ"),
    $e46AW("iX6TF")
]).then(()=>parcelRequire('02KG3'));

});

parcelRegister("eEQSz", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("jBAmJ"),
    $e46AW("ixH4T"),
    $e46AW("ejayw"),
    $e46AW("aucOl"),
    $e46AW("d2mFO"),
    $e46AW("cotMj"),
    $e46AW("k2Z1V"),
    $e46AW("eahZ0"),
    $e46AW("cosbn"),
    $e46AW("jqTJf")
]).then(()=>parcelRequire('afuFn'));

});



parcelRegister("6819P", function(module, exports) {
$parcel$export(module.exports, "FlightDeckProvider", () => $412308f486188ffa$export$56da85ac9d40dbcd);
$parcel$export(module.exports, "prefetchFlightDeck", () => $412308f486188ffa$export$7d2a567d3e50224);

var $4fqPo = parcelRequire("4fqPo");

var $grkpl = parcelRequire("grkpl");

var $fM9GY = parcelRequire("fM9GY");

var $fxGix = parcelRequire("fxGix");

var $9Llip = parcelRequire("9Llip");

var $dvNUn = parcelRequire("dvNUn");

var $3IYWb = parcelRequire("3IYWb");

var $4cAGJ = parcelRequire("4cAGJ");
const $412308f486188ffa$var$client = new (0, $grkpl.default)('atlassian-switcher', {
    handlers: {},
    // Switch the FD default storage from localStorage to sessionStorage to avoid issues related to GDPR policy.
    // The storageEngine option isn't exposed directly by the FD SDK, but you can still pass it in
    // https://hello.jira.atlassian.cloud/browse/NAVX-658
    //@ts-ignore
    storageEngine: 'sessionStorage'
});
const { fetchMethod: $412308f486188ffa$var$fetchFlightDeck, ProviderComponent: $412308f486188ffa$var$DefaultFlightDeckProviderComponent } = (0, $fM9GY.createProviderWithCustomFetchData)('flightDeck', (0, $fxGix.ExperienceMark).API_FLIGHT_DECK, async ()=>{
    const artifact = await $412308f486188ffa$var$client.fetchConfigFromFlightDeck({
        name: 'app-switcher-fe',
        dimensions: {
            environmentType: 'prod',
            perimeter: (0, $dvNUn.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
        }
    });
    return $412308f486188ffa$var$transformFlightDeckArtifactToProductConfiguration(artifact);
});
const $412308f486188ffa$var$transformFlightDeckArtifactToProductConfiguration = (artifact)=>{
    const artifactMap = new Map();
    for (const product of artifact.products){
        const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey } = product;
        artifactMap.set(apsKey, {
            key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
            href: siteUrlSuffix,
            ordinal: ordinal,
            label: (0, $9Llip.formatLabel)(displayName),
            description: (0, $9Llip.formatDescription)(subtitle),
            iconKey: iconKey
        });
        // TODO: remove this once Asset app becomes standalone app
        if (apsKey === 'JIRA_SERVICE_DESK' && !artifactMap.has((0, $3IYWb.ASSETS_APP_KEY))) artifactMap.set((0, $3IYWb.ASSETS_APP_KEY), {
            key: (0, $3IYWb.ASSETS_APP_KEY),
            href: '/jira/assets',
            ordinal: ordinal + 0.1,
            // make sure assets is below jsm
            label: (0, $9Llip.formatLabel)((0, $4cAGJ.default).assets),
            iconKey: 'assets'
        });
    }
    return {
        products: Object.fromEntries(artifactMap),
        links: Object.fromEntries(artifact.links.map(({ apsKey: apsKey, ...link })=>[
                apsKey,
                {
                    ...link,
                    key: apsKey.toLowerCase(),
                    href: link.url,
                    label: (0, $9Llip.formatLabel)(link.displayName),
                    description: (0, $9Llip.formatDescription)(link.subtitle),
                    iconKey: 'admin'
                }
            ]))
    };
};
const $412308f486188ffa$export$56da85ac9d40dbcd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($412308f486188ffa$var$DefaultFlightDeckProviderComponent, null, children);
const $412308f486188ffa$export$7d2a567d3e50224 = $412308f486188ffa$var$fetchFlightDeck;

});
parcelRegister("grkpl", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf7eff826e2d1605$export$2e2bcd8739ae039);

var $6YQ3e = parcelRequire("6YQ3e");

var $5tLuL = parcelRequire("5tLuL");

var $kG3Ql = parcelRequire("kG3Ql");

var $eRMdX = parcelRequire("eRMdX");
var $bkzOl = parcelRequire("bkzOl");

var $80F5v = parcelRequire("80F5v");

var $fNYRO = parcelRequire("fNYRO");

var $9fzFf = parcelRequire("9fzFf");
function $bf7eff826e2d1605$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bf7eff826e2d1605$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bf7eff826e2d1605$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6YQ3e.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bf7eff826e2d1605$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $bf7eff826e2d1605$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $bf7eff826e2d1605$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $bf7eff826e2d1605$export$2e2bcd8739ae039 {
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $6YQ3e.default)(this, "fallbackArtifactMap", new Map());
        (0, $6YQ3e.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $kG3Ql.default)($bf7eff826e2d1605$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $fNYRO.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $5tLuL.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $eRMdX.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $80F5v.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$bf7eff826e2d1605$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $9fzFf.flightDeckClientExperience)() : new (0, $bkzOl.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $bf7eff826e2d1605$var$_objectSpread($bf7eff826e2d1605$var$_objectSpread({}, artifact), {}, {
                key: (0, $fNYRO.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $9fzFf.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
}

});
parcelRegister("5tLuL", function(module, exports) {
$parcel$export(module.exports, "retryOnException", () => $f8b0502d60ed14a7$export$1d94629c94e7a17f);
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("c16nh")).default);

var $5p8Qb = parcelRequire("5p8Qb");

var $41yDN = parcelRequire("41yDN");

var $c16nh = parcelRequire("c16nh");
const $f8b0502d60ed14a7$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $f8b0502d60ed14a7$var$NO_CALLS_ERROR = 'No calls made';
const $f8b0502d60ed14a7$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $41yDN.NO_RETRIES), retryOn: retryOn = [
    (0, $c16nh.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($f8b0502d60ed14a7$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $f8b0502d60ed14a7$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $f8b0502d60ed14a7$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $5p8Qb.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};

});
parcelRegister("5p8Qb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6cb5ba0bd588450$export$2e2bcd8739ae039);
const $b6cb5ba0bd588450$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $b6cb5ba0bd588450$export$2e2bcd8739ae039 = $b6cb5ba0bd588450$var$convertToError;

});

parcelRegister("41yDN", function(module, exports) {
$parcel$export(module.exports, "NO_RETRIES", () => $192dca773b6d3963$export$a0a1c8f90becc136);
const $192dca773b6d3963$export$a0a1c8f90becc136 = [];
const $192dca773b6d3963$export$972171517b12aa4 = [
    0,
    0
];
const $192dca773b6d3963$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $192dca773b6d3963$export$f6858378b665f957 = [
    100,
    500,
    1000
];

});

parcelRegister("c16nh", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e1b4ee8d8048ea6$export$2e2bcd8739ae039);
class $6e1b4ee8d8048ea6$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}

});


parcelRegister("kG3Ql", function(module, exports) {
$parcel$export(module.exports, "default", () => $34d76ed9afa8fcdf$export$2e2bcd8739ae039);

var $k72Wf = parcelRequire("k72Wf");
const $34d76ed9afa8fcdf$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $34d76ed9afa8fcdf$export$2e2bcd8739ae039 {
    constructor(clientKey, options){
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options === null || options === void 0 ? void 0 : options.handlers;
        const storageEngine = (options === null || options === void 0 ? void 0 : options.storageEngine) || $34d76ed9afa8fcdf$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $k72Wf.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
    captureException(e, tags) {
        var _this$handlers;
        if ((_this$handlers = this.handlers) !== null && _this$handlers !== void 0 && _this$handlers.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
}

});
parcelRegister("k72Wf", function(module, exports) {
$parcel$export(module.exports, "mockWindowStorage", () => $393e13dd3f2827de$export$efebfe7859cae3c7);
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $393e13dd3f2827de$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $393e13dd3f2827de$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$393e13dd3f2827de$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};

});


parcelRegister("eRMdX", function(module, exports) {
$parcel$export(module.exports, "fetchFlightDeckConfiguration", () => $ad2b6c3be9a6ba10$export$6026918e023c9101);

var $f3igo = parcelRequire("f3igo");

var $49Ddu = parcelRequire("49Ddu");

var $7gLk8 = parcelRequire("7gLk8");

var $02Nc7 = parcelRequire("02Nc7");

var $i5vFk = parcelRequire("i5vFk");

var $bkzOl = parcelRequire("bkzOl");

var $lxoRG = parcelRequire("lxoRG");
/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $ad2b6c3be9a6ba10$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $ad2b6c3be9a6ba10$var$defaultPerimeter = "commercial";
async function $ad2b6c3be9a6ba10$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $ad2b6c3be9a6ba10$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $ad2b6c3be9a6ba10$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $ad2b6c3be9a6ba10$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $f3igo.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $ad2b6c3be9a6ba10$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $ad2b6c3be9a6ba10$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $ad2b6c3be9a6ba10$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $ad2b6c3be9a6ba10$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $ad2b6c3be9a6ba10$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $ad2b6c3be9a6ba10$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $bkzOl.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $bkzOl.getVersionMetadataFetchExperience)();
    return new (0, $i5vFk.ConfigClient)(new (0, $7gLk8.BifrostDataSource)(new (0, $02Nc7.BifrostHttpClientImpl)(env, perimeter), (0, $49Ddu.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $ad2b6c3be9a6ba10$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}

});
parcelRegister("f3igo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6b0718244070fa1$export$2e2bcd8739ae039);
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $b6b0718244070fa1$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $b6b0718244070fa1$export$2e2bcd8739ae039 = $b6b0718244070fa1$export$852ff24d0930c62f;

});

parcelRegister("49Ddu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $g7loX = parcelRequire("g7loX");
Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $g7loX.Either;
    }
});

var $eBslZ = parcelRequire("eBslZ");
Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $eBslZ.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $eBslZ.tryGetArtifactData;
    }
});

var $eh0zg = parcelRequire("eh0zg");
Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $eh0zg.parseArtifactManifest;
    }
});

var $8LUaL = parcelRequire("8LUaL");
Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $8LUaL.parseVersionMetadata;
    }
});

var $kl3BU = parcelRequire("kl3BU");
Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $kl3BU.checkManifest;
    }
});

var $biHIl = parcelRequire("biHIl");
Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $biHIl.ConfigRegistryDataSource;
    }
});

var $50Kp1 = parcelRequire("50Kp1");
Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $50Kp1.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $50Kp1.Versions;
    }
});

});
parcelRegister("g7loX", function(module, exports) {
"use strict";
var $bbbde6abfade05d5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $bbbde6abfade05d5$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $bbbde6abfade05d5$var$Right(value);
    };
    Either.left = function(error) {
        return new $bbbde6abfade05d5$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $bbbde6abfade05d5$var$Either;
var $bbbde6abfade05d5$var$Right = /** @class */ function(_super) {
    $bbbde6abfade05d5$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $bbbde6abfade05d5$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $bbbde6abfade05d5$var$Either.right(this.right);
    };
    return Right;
}($bbbde6abfade05d5$var$Either);
var $bbbde6abfade05d5$var$Left = /** @class */ function(_super) {
    $bbbde6abfade05d5$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $bbbde6abfade05d5$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $bbbde6abfade05d5$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $bbbde6abfade05d5$var$Either.left(f(this.left));
    };
    return Left;
}($bbbde6abfade05d5$var$Either);

});

parcelRegister("eBslZ", function(module, exports) {
"use strict";
var $aa1a83d2f6aca74c$var$__assign = module.exports && module.exports.__assign || function() {
    $aa1a83d2f6aca74c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $aa1a83d2f6aca74c$var$__assign.apply(this, arguments);
};
var $aa1a83d2f6aca74c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $aa1a83d2f6aca74c$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $aa1a83d2f6aca74c$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $aa1a83d2f6aca74c$var$tryGetArtifactData;

var $8UltC = parcelRequire("8UltC");

var $49Ddu = parcelRequire("49Ddu");

var $4jqtj = parcelRequire("4jqtj");

var $inxFd = parcelRequire("inxFd");

var $9wb07 = parcelRequire("9wb07");
function $aa1a83d2f6aca74c$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $aa1a83d2f6aca74c$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $aa1a83d2f6aca74c$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $aa1a83d2f6aca74c$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $aa1a83d2f6aca74c$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $49Ddu.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $4jqtj.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $aa1a83d2f6aca74c$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $inxFd.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $aa1a83d2f6aca74c$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $aa1a83d2f6aca74c$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $aa1a83d2f6aca74c$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $8UltC.interpolateTagScheme)(manifest.tagScheme, $aa1a83d2f6aca74c$var$__assign($aa1a83d2f6aca74c$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $aa1a83d2f6aca74c$var$__awaiter(_this, void 0, void 0, function() {
                                return $aa1a83d2f6aca74c$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $aa1a83d2f6aca74c$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $9wb07.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $9wb07.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $inxFd.assertUnreachable)(artifact);
    }
}

});
parcelRegister("8UltC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $67c436859f923b24$var$interpolateTagScheme;
module.exports.generateTagScheme = $67c436859f923b24$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $67c436859f923b24$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $67c436859f923b24$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $67c436859f923b24$var$getVersionMetadataTag;
const $67c436859f923b24$var$TAG_SCHEME_VERSION = 2;
function $67c436859f923b24$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($67c436859f923b24$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $67c436859f923b24$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $67c436859f923b24$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $67c436859f923b24$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $67c436859f923b24$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $67c436859f923b24$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $67c436859f923b24$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $67c436859f923b24$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("4jqtj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $323d7884419d64a0$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $323d7884419d64a0$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("inxFd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $d6147ce114f8ada8$var$assertUnreachable;
function $d6147ce114f8ada8$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("9wb07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $6edfa2c51a305bef$var$toJson;
module.exports.toPrettyJson = $6edfa2c51a305bef$var$toPrettyJson;
function $6edfa2c51a305bef$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $6edfa2c51a305bef$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});


parcelRegister("eh0zg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $a64317fd00c5e0ad$var$parseArtifactManifest;

var $9zbEW = parcelRequire("9zbEW");
function $a64317fd00c5e0ad$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $9zbEW.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $9zbEW.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $a64317fd00c5e0ad$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $9zbEW.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $a64317fd00c5e0ad$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $a64317fd00c5e0ad$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $9zbEW.parseUnknownObject)(dimensions);
    var supported = (0, $9zbEW.parseArray)(unparsedDimensions.supported).map($9zbEW.parseString);
    var fallback = (0, $9zbEW.parseUndefinedOr)($9zbEW.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $a64317fd00c5e0ad$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $9zbEW.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $a64317fd00c5e0ad$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $a64317fd00c5e0ad$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $9zbEW.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $9zbEW.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $9zbEW.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $9zbEW.parseUndefinedOr)($9zbEW.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $a64317fd00c5e0ad$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $a64317fd00c5e0ad$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});
parcelRegister("9zbEW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $6f706d3ecd899a56$var$parseString;
module.exports.parseArray = $6f706d3ecd899a56$var$parseArray;
module.exports.parseBoolean = $6f706d3ecd899a56$var$parseBoolean;
module.exports.parseUnknownObject = $6f706d3ecd899a56$var$parseUnknownObject;
module.exports.parseUndefinedOr = $6f706d3ecd899a56$var$parseUndefinedOr;
function $6f706d3ecd899a56$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $6f706d3ecd899a56$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $6f706d3ecd899a56$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $6f706d3ecd899a56$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $6f706d3ecd899a56$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});


parcelRegister("8LUaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $662e493db99eb435$var$parseVersionMetadata;

var $9zbEW = parcelRequire("9zbEW");
function $662e493db99eb435$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $9zbEW.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $9zbEW.parseString)(unknownObject.version);
    var publishTime = new Date((0, $9zbEW.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $9zbEW.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("kl3BU", function(module, exports) {
"use strict";
var $ece891ca36091d52$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $ece891ca36091d52$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $ece891ca36091d52$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $ece891ca36091d52$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("biHIl", function(module, exports) {
"use strict";
var $83a348e10b74def9$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $83a348e10b74def9$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $8UltC = parcelRequire("8UltC");

var $g7loX = parcelRequire("g7loX");

var $eh0zg = parcelRequire("eh0zg");

var $8LUaL = parcelRequire("8LUaL");
var $83a348e10b74def9$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $83a348e10b74def9$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $83a348e10b74def9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $8UltC.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($eh0zg.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $g7loX.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $83a348e10b74def9$var$__awaiter(this, void 0, void 0, function() {
            return $83a348e10b74def9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $83a348e10b74def9$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $83a348e10b74def9$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $8UltC.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $8LUaL.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $83a348e10b74def9$var$ConfigRegistryDataSource;

});

parcelRegister("50Kp1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $3a60f270e019d184$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $3a60f270e019d184$var$BaseUrls;
var $3a60f270e019d184$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $3a60f270e019d184$var$Versions;

});


parcelRegister("7gLk8", function(module, exports) {
$parcel$export(module.exports, "BifrostDataSource", () => $54aebc8edddcd35b$export$2cb8d79200775058);

var $49Ddu = parcelRequire("49Ddu");

var $8UltC = parcelRequire("8UltC");
class $54aebc8edddcd35b$export$2cb8d79200775058 {
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
    async getLatestVersionMetadata() {
        const tag = (0, $8UltC.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $49Ddu.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $49Ddu.parseVersionMetadata)(response);
                return (0, $49Ddu.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $49Ddu.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $8UltC.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $49Ddu.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $49Ddu.parseArtifactManifest)(response);
                return (0, $49Ddu.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $49Ddu.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
}

});

parcelRegister("02Nc7", function(module, exports) {
$parcel$export(module.exports, "BifrostHttpClientImpl", () => $0086590737b82b62$export$45c6d12ca9c14f83);

var $49Ddu = parcelRequire("49Ddu");
function $0086590737b82b62$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $0086590737b82b62$export$45c6d12ca9c14f83 {
    constructor(env, perimeter){
        this.baseUrl = $0086590737b82b62$export$f654b28f82155665(env, perimeter);
    }
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $49Ddu.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $49Ddu.Either).right(json)));
            }).catch((error)=>resolve((0, $49Ddu.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
}

});

parcelRegister("i5vFk", function(module, exports) {
$parcel$export(module.exports, "ConfigClient", () => $d2b141bff27d5658$export$8489e2f039bfcc4c);

var $6YQ3e = parcelRequire("6YQ3e");

var $49Ddu = parcelRequire("49Ddu");

var $cDvg5 = parcelRequire("cDvg5");
function $d2b141bff27d5658$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d2b141bff27d5658$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d2b141bff27d5658$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6YQ3e.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d2b141bff27d5658$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $d2b141bff27d5658$export$8489e2f039bfcc4c {
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $cDvg5.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $d2b141bff27d5658$var$_objectSpread($d2b141bff27d5658$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $49Ddu.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $49Ddu.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
}

});
parcelRegister("cDvg5", function(module, exports) {
$parcel$export(module.exports, "ExperienceDataSourceWrapper", () => $93315fd647c779a3$export$1cc944571619e6e8);
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $93315fd647c779a3$export$1cc944571619e6e8 {
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
}

});


parcelRegister("bkzOl", function(module, exports) {
$parcel$export(module.exports, "MockExperience", () => $83fd57440cd8a303$export$5e7536cf7bc56fee);
$parcel$export(module.exports, "getFlightDeckFetchExperience", () => $83fd57440cd8a303$export$a3006f8f221c0a3b);
$parcel$export(module.exports, "getVersionMetadataFetchExperience", () => $83fd57440cd8a303$export$c3ac7702bfd47c1b);
const $83fd57440cd8a303$var$SAMPLING_RATE = 10;
class $83fd57440cd8a303$var$UFOExperienceWrapper {
    constructor(experience){
        this.experience = experience;
    }
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
}
class $83fd57440cd8a303$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $83fd57440cd8a303$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $83fd57440cd8a303$var$SAMPLING_RATE) return new $83fd57440cd8a303$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("g9K2v"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $83fd57440cd8a303$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $83fd57440cd8a303$export$5e7536cf7bc56fee();
    }
}
const $83fd57440cd8a303$export$a3006f8f221c0a3b = ()=>$83fd57440cd8a303$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $83fd57440cd8a303$export$c3ac7702bfd47c1b = ()=>$83fd57440cd8a303$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});

});
parcelRegister("g9K2v", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1Z8YZ").then(()=>parcelRequire('d140A'));

});


parcelRegister("lxoRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $7jeqC = parcelRequire("7jeqC");
Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $7jeqC.parseConfigWithTargeting;
    }
});

var $8GKl8 = parcelRequire("8GKl8");
Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $8GKl8.TargetedConfig;
    }
});

});
parcelRegister("7jeqC", function(module, exports) {
"use strict";
var $55257fe6858a258e$var$__assign = module.exports && module.exports.__assign || function() {
    $55257fe6858a258e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $55257fe6858a258e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $55257fe6858a258e$var$parseConfigWithTargeting;

var $8GKl8 = parcelRequire("8GKl8");
/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $55257fe6858a258e$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $55257fe6858a258e$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $8GKl8.TargetedConfig({
                defaultConfig: $55257fe6858a258e$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $55257fe6858a258e$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $8GKl8.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $55257fe6858a258e$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $55257fe6858a258e$var$__assign($55257fe6858a258e$var$__assign({}, accObject), (_a = {}, _a[key] = $55257fe6858a258e$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $55257fe6858a258e$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $55257fe6858a258e$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $55257fe6858a258e$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $55257fe6858a258e$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $55257fe6858a258e$var$parseIdentifierList(target.orgIds),
            siteIds: $55257fe6858a258e$var$parseIdentifierList(target.siteIds),
            userIds: $55257fe6858a258e$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $55257fe6858a258e$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});
parcelRegister("8GKl8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $6536311f2febbdf7$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
     * Determines whether to use the targeted configuration value or the default value
     * depending on whether the specified values match any of the target's rules.
     *
     * @param target the values to use to evaluate the config
     * @returns the {@link TargetingResult}, which would be the default value
     *     if the specified target did not match, or the targeted value if there
     *     was a match
     */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $6536311f2febbdf7$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $6536311f2febbdf7$var$TargetedConfig;
function $6536311f2febbdf7$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});




parcelRegister("80F5v", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d4e31fc9bda10cf$export$2e2bcd8739ae039);
class $5d4e31fc9bda10cf$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $5d4e31fc9bda10cf$export$1d76d155060824c9 = (e)=>e instanceof $5d4e31fc9bda10cf$export$2e2bcd8739ae039;

});

parcelRegister("fNYRO", function(module, exports) {
$parcel$export(module.exports, "artifactKey", () => $b81aa587c17b2428$export$e3553dc63541d477);
const $b81aa587c17b2428$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};

});

parcelRegister("9fzFf", function(module, exports) {
$parcel$export(module.exports, "flightDeckClientExperience", () => $6bc12df36f4173fe$export$1e3a41a51f6457c5);
$parcel$export(module.exports, "exceptionToMetadata", () => $6bc12df36f4173fe$export$f33622abb5224195);

var $6YQ3e = parcelRequire("6YQ3e");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
function $6bc12df36f4173fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6bc12df36f4173fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6bc12df36f4173fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6YQ3e.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6bc12df36f4173fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6bc12df36f4173fe$export$1e3a41a51f6457c5 = ()=>new (0, $3odV5.UFOExperience)("retrieve-artifact", {
        type: (0, $bdtMB.ExperienceTypes).Operation,
        performanceType: (0, $bdtMB.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $6bc12df36f4173fe$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $6bc12df36f4173fe$var$_objectSpread($6bc12df36f4173fe$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};

});


parcelRegister("9Llip", function(module, exports) {
$parcel$export(module.exports, "formatLabel", () => $b2498d906746a32d$export$957d7daebd899f12);
$parcel$export(module.exports, "formatDescription", () => $b2498d906746a32d$export$f731e929548061dc);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");
const $b2498d906746a32d$export$957d7daebd899f12 = (label)=>{
    return typeof label === 'string' ? label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), label);
};
const $b2498d906746a32d$export$f731e929548061dc = (description)=>{
    return typeof description === 'string' ? description : description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), description) : null;
};

});

parcelRegister("3IYWb", function(module, exports) {
$parcel$export(module.exports, "ASSETS_APP_KEY", () => $24e2ecda33bd74f7$export$45e63649edff1e2a);
$parcel$export(module.exports, "TENANTLESS_ORG_ID", () => $24e2ecda33bd74f7$export$eb7589a4ee50c678);
const $24e2ecda33bd74f7$export$45e63649edff1e2a = 'ASSETS';
const $24e2ecda33bd74f7$export$eb7589a4ee50c678 = 'tenantless';

});

parcelRegister("4cAGJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab2416c1a9bec5d0$export$2e2bcd8739ae039);

var $6BhDL = parcelRequire("6BhDL");
const $ab2416c1a9bec5d0$var$messages = (0, $6BhDL.defineMessages)({
    emptyStateExploreProductsTitle: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
        defaultMessage: 'Get started with cloud',
        description: 'The title text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsBody: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
        defaultMessage: 'Try a product to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLink: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
        defaultMessage: 'Explore products',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    home: {
        id: 'fabric.atlassianSwitcher.atlassianHome',
        defaultMessage: 'Home',
        description: 'The text of a link redirecting the user to the Home site'
    },
    rovo: {
        id: 'fabric.atlassianSwitcher.rovo-home',
        defaultMessage: 'Rovo Home',
        description: 'The text of a link redirecting the user to the rovo home site'
    },
    administration: {
        id: 'fabric.atlassianSwitcher.administration',
        defaultMessage: 'Administration',
        description: 'The text of a link redirecting the user to Administration'
    },
    atlassianStart: {
        id: 'fabric.atlassianSwitcher.start',
        defaultMessage: 'Atlassian Start',
        description: 'The text of a link redirecting the user to the Start site'
    },
    assets: {
        id: 'fabric.atlassianSwitcher.assets',
        defaultMessage: 'Assets',
        description: 'The text of a link redirecting the user to the Assets'
    },
    analytics: {
        id: 'fabric.atlassianSwitcher.analytics',
        defaultMessage: 'Analytics',
        description: 'The text of a link redirecting the user to the Analytics'
    },
    companyHub: {
        id: 'fabric.atlassianSwitcher.companyHub',
        defaultMessage: 'Company Hub',
        description: 'The text of a link redirecting the user to the Company Hub'
    },
    goals: {
        id: 'fabric.atlassianSwitcher.goals',
        defaultMessage: 'Goals',
        description: 'The text of a link redirecting the user to the Goals'
    },
    projects: {
        id: 'fabric.atlassianSwitcher.projects',
        defaultMessage: 'Projects',
        description: 'The text of a link redirecting the user to the Projects'
    },
    teams: {
        id: 'fabric.atlassianSwitcher.teams',
        defaultMessage: 'Teams',
        description: 'The text of a link redirecting the user to the Teams'
    },
    search: {
        id: 'fabric.atlassianSwitcher.search',
        defaultMessage: 'Search',
        description: 'The text of a link redirecting the user to the Search'
    },
    chat: {
        id: 'fabric.atlassianSwitcher.chat',
        defaultMessage: 'Chat',
        description: 'The text of a link redirecting the user to the Chat'
    },
    studio: {
        id: 'fabric.atlassianSwitcher.studio',
        defaultMessage: 'Studio',
        description: 'The text of a link redirecting the user to the Studio'
    },
    rovoSearch: {
        id: 'fabric.atlassianSwitcher.rovo-search',
        defaultMessage: 'Rovo Search',
        description: 'The text of a link redirecting the user to Rovo Search app'
    },
    rovoChat: {
        id: 'fabric.atlassianSwitcher.rovo-chat',
        defaultMessage: 'Rovo Chat',
        description: 'The text of a link redirecting the user to the Rovo Chat app'
    },
    rovoStudio: {
        id: 'fabric.atlassianSwitcher.rovo-studio',
        defaultMessage: 'Rovo Studio',
        description: 'The text of a link redirecting the user to Rovo Studio app'
    },
    manageList: {
        id: 'fabric.atlassianSwitcher.manageList',
        defaultMessage: 'Manage list',
        description: 'This text is for the action for a user to manage the values present in an editable list of links.'
    },
    errorEmptyPartialResults: {
        id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
        defaultMessage: "We can't display your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and no sites'
    },
    errorHeading: {
        id: 'fabric.atlassianSwitcher.errorHeading',
        defaultMessage: "Something\u2019s gone wrong",
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorText: {
        id: 'fabric.atlassianSwitcher.errorText',
        defaultMessage: "We keep track of these errors, but feel free to contact us if refreshing doesn\u2019t fix things",
        description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.'
    },
    errorImageAltText: {
        id: 'fabric.atlassianSwitcher.errorImageAltText',
        defaultMessage: 'A broken robot and a number of people busy fixing it.',
        description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher'
    },
    errorTextNetwork: {
        id: 'fabric.atlassianSwitcher.errorTextNetwork',
        defaultMessage: "We couldn\u2019t load this list. Please reload the page and try again.",
        description: 'Text that is displayed when we detect a network issue.'
    },
    errorHeadingLoggedOut: {
        id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
        defaultMessage: 'Your Atlassian account is logged out',
        description: 'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.'
    },
    errorHeadingUnverified: {
        id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
        defaultMessage: 'Your account is unverified',
        description: 'Heading that is displayed when we detect user account is unverified.'
    },
    errorPartialResults: {
        id: 'fabric.atlassianSwitcher.errorPartialResults',
        defaultMessage: "We can't display some of your apps right now.",
        description: 'Heading of the error message when available apps returns a partial result and 1 or more sites'
    },
    errorPartialResultsRefresh: {
        id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
        defaultMessage: 'Refresh the page, or try again later.',
        description: 'Subtitle of the error message when available products returns a partial result'
    },
    errorTextUnverified: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified',
        defaultMessage: 'Please confirm your email address to view a list of available products.',
        description: 'Text that is displayed when we detect user account is unverified.'
    },
    productDescriptionConfluence: {
        id: 'fabric.atlassianSwitcher.product.description.confluence',
        defaultMessage: 'Document collaboration',
        description: 'Text displayed under the Confluence product recommendation.'
    },
    productDescriptionJiraServiceManagement: {
        id: 'fabric.atlassianSwitcher.product.description.jsm',
        defaultMessage: 'Collaborative IT service management',
        description: 'Text displayed under the Jira Service Management product recommendation.'
    },
    productDescriptionJiraSoftware: {
        id: 'fabric.atlassianSwitcher.product.description.jsw',
        defaultMessage: 'Project and issue tracking',
        description: 'Text displayed under the Jira Software product recommendation.'
    },
    productDescriptionOpsgenie: {
        id: 'fabric.atlassianSwitcher.product.description.opsgenie',
        defaultMessage: 'Modern incident management',
        description: 'Text displayed under the Opsgenie product recommendation.'
    },
    productDescriptionCompass: {
        id: 'fabric.atlassianSwitcher.product.description.compass',
        defaultMessage: 'Component manager',
        description: 'Text displayed under the Compass product recommendation.'
    },
    join: {
        id: 'fabric.atlassianSwitcher.join',
        defaultMessage: 'Join',
        description: 'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.'
    },
    expandProductList: {
        id: 'fabric.atlassianSwitcher.expandProductList',
        defaultMessage: '{numItems} more',
        description: 'Text for the button that expands the product list in the Atlassian Switcher.'
    },
    collapseProductList: {
        id: 'fabric.atlassianSwitcher.contractProductList',
        defaultMessage: 'Less',
        description: 'Text for the button that collapses the product list in the Atlassian Switcher.'
    },
    emptyStateExploreProductsBodyAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
        defaultMessage: 'Try an app to start collaborating with your team.',
        description: 'The body text for the empty state explore products content, which prompts users to try new products.'
    },
    emptyStateExploreProductsLinkAppify: {
        id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
        defaultMessage: 'Explore apps',
        description: 'The text for the empty state explore products link, which prompts users to try new products.'
    },
    errorTextUnverifiedAppify: {
        id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
        defaultMessage: 'Please confirm your email address to view a list of available apps.',
        description: 'Text that is displayed when we detect user account is unverified.'
    }
});
var $ab2416c1a9bec5d0$export$2e2bcd8739ae039 = $ab2416c1a9bec5d0$var$messages;

});


parcelRegister("jd74o", function(module, exports) {
$parcel$export(module.exports, "ThirdPartyProductsProvider", () => $599711ff5d642d93$export$a7ffda257898c103);
$parcel$export(module.exports, "prefetchThirdPartyProducts", () => $599711ff5d642d93$export$ba83558707df5bbe);

var $4fqPo = parcelRequire("4fqPo");

var $cbdNK = parcelRequire("cbdNK");
const { fetchMethod: $599711ff5d642d93$var$fetchAppSwitcherBffThirdPartyProducts, ProviderComponent: $599711ff5d642d93$var$DefaultBffThirdPartyProductsDataProvider } = (0, $cbdNK.createAppSwitcherBffThirdPartyProductsProvider)();
const $599711ff5d642d93$export$a7ffda257898c103 = ({ cloudId: cloudId, children: children, product: product })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($599711ff5d642d93$var$DefaultBffThirdPartyProductsDataProvider, {
        cloudId: cloudId,
        product: product
    }, children);
const $599711ff5d642d93$export$ba83558707df5bbe = $599711ff5d642d93$var$fetchAppSwitcherBffThirdPartyProducts;
const $599711ff5d642d93$export$fdb5fe543e39bc7a = ()=>$599711ff5d642d93$var$fetchAppSwitcherBffThirdPartyProducts.reset();

});
parcelRegister("cbdNK", function(module, exports) {
$parcel$export(module.exports, "createAppSwitcherBffThirdPartyProductsProvider", () => $31b7d35292062777$export$1a41882ddb3a9c38);

var $fM9GY = parcelRequire("fM9GY");

var $jflSF = parcelRequire("jflSF");

var $fxGix = parcelRequire("fxGix");
const $31b7d35292062777$export$7cf62b3dbe96f5e8 = '/gateway/api/app-switcher/api/app-switcher/v1/third-party-products';
const $31b7d35292062777$export$c39ca0fbc2221bcc = async ({ cloudId: cloudId, product: product })=>{
    const params = new URLSearchParams({
        source: 'app-switcher-fe'
    });
    if (cloudId) params.append('tenantid', encodeURIComponent(cloudId));
    if (product) params.append('product', encodeURIComponent(product));
    return await (0, $jflSF.fetchJsonWithNetworkRetries)(`${$31b7d35292062777$export$7cf62b3dbe96f5e8}?${params.toString()}`, {
        intervalsMS: [
            50,
            200,
            1000
        ]
    }, {
        headers: {
            'Atl-App-Switcher-Private-API': 'true'
        }
    });
};
const $31b7d35292062777$export$1a41882ddb3a9c38 = ()=>{
    return (0, $fM9GY.createProviderWithCustomFetchData)('appSwitcherBffThirdPartyProducts', (0, $fxGix.ExperienceMark).API_APP_SWITCHER_BFF_THIRD_PARTY_PRODUCTS, $31b7d35292062777$export$c39ca0fbc2221bcc);
};

});



parcelRegister("6wTCp", function(module, exports) {
$parcel$export(module.exports, "performanceNow", () => $8b304e179cb1a36d$export$fb4230f160368c88);
const $8b304e179cb1a36d$export$fb4230f160368c88 = typeof window !== 'undefined' && window.performance && window.performance.now.bind(performance) || Date.now;

});






parcelRegister("bev4L", function(module, exports) {
$parcel$export(module.exports, "Sidebar", () => (parcelRequire("dbeeo")).default);

var $dbeeo = parcelRequire("dbeeo");

});
parcelRegister("dbeeo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7dd7f6d9e9f3101$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $gMSZD = parcelRequire("gMSZD");

var $bG6ob = parcelRequire("bG6ob");

var $56isT = parcelRequire("56isT");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $erCGs = parcelRequire("erCGs");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $lFMRN = parcelRequire("lFMRN");
var $1mYFb = parcelRequire("1mYFb");
var $1oOk6 = parcelRequire("1oOk6");
var $XUjBt = parcelRequire("XUjBt");
var $kqBFy = parcelRequire("kqBFy");
var $fTc8s = parcelRequire("fTc8s");
var $3psrI = parcelRequire("3psrI");

var $54jwS = parcelRequire("54jwS");

var $ebpTf = parcelRequire("ebpTf");

var $d03Pf = parcelRequire("d03Pf");

var $eQlRt = parcelRequire("eQlRt");

var $hv3G2 = parcelRequire("hv3G2");
parcelRequire("6q53A");
var $i9XEy = parcelRequire("i9XEy");
parcelRequire("kjxwV");
var $bghmb = parcelRequire("bghmb");
const $b7dd7f6d9e9f3101$var$Sidebar = ({ width: width, navigationContentItems: navigationContentItems, featureName: featureName })=>{
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const helpCenterMessages = (0, $eQlRt.useHelpCenterMessageDictionary)();
    const onBackButtonClick = (0, $4fqPo.useCallback)(()=>{
        createAnalyticsEvent({
            analyticsType: (0, $54jwS.UI_EVENT_TYPE),
            action: 'click',
            actionSubjectId: `SidebarBackButton`
        }).fire();
        if (!(0, $bG6ob.isProjectMappingInHelpCenterEnabled)()) (0, $d03Pf.getWindow)().location.href = `${(0, $ebpTf.getEnv)().baseUrl}`;
        else push(helpCenterMessages.backButtonHref);
    }, [
        createAnalyticsEvent,
        push,
        helpCenterMessages.backButtonHref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $erCGs.default), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b7dd7f6d9e9f3101$var$sidebarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3psrI.default), {
        label: formatMessage((0, $hv3G2.default).sidebarNavigationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bghmb.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kqBFy.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $i9XEy.default), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        padding: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1mYFb.default), {
        onClick: onBackButtonClick
    }, (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() ? formatMessage(helpCenterMessages.backButton) : formatMessage((0, $hv3G2.default).backButtonWithoutProjectMapping))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $XUjBt.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1oOk6.default), null, formatMessage(helpCenterMessages.settingsLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fTc8s.default), {
        isList: true
    }, navigationContentItems.map(({ onClick: onClick, iconBefore: iconBefore, text: text, isSelected: isSelected, isVisible: isVisible })=>{
        const renderButtonItem = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lFMRN.default), {
                onClick: onClick,
                iconBefore: iconBefore,
                key: text,
                isSelected: isSelected
            }, text);
        return isVisible && renderButtonItem();
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b7dd7f6d9e9f3101$var$navFooter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $XUjBt.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fTc8s.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $56isT.default), {
        showIcon: true,
        showTypeField: true,
        featureName: featureName,
        buttonLabel: (0, $hv3G2.default).feedbackWidget,
        analyticsSubjectId: "SidebarFeedbackButton",
        useSideNavButton: true
    }))))))));
};
const $b7dd7f6d9e9f3101$var$navFooter = (0, $2m8U6.xcss)({
    position: 'relative'
});
const $b7dd7f6d9e9f3101$var$sidebarContainerStyles = (0, $2m8U6.xcss)({
    width: '100%',
    height: '100%',
    borderRightWidth: 'border.width',
    borderRightStyle: 'solid',
    borderColor: 'color.border',
    boxSizing: 'inherit'
});
var $b7dd7f6d9e9f3101$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'SideBar'
})($b7dd7f6d9e9f3101$var$Sidebar);

});
parcelRegister("erCGs", function(module, exports) {
$parcel$export(module.exports, "default", () => $de06635ade5aa4c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $gSpw2 = parcelRequire("gSpw2");

var $71AtM = parcelRequire("71AtM");

var $euOrY = parcelRequire("euOrY");
var $fRy95 = parcelRequire("fRy95");

var $c1Zd2 = parcelRequire("c1Zd2");

var $bCrzj = parcelRequire("bCrzj");

var $aeSaK = parcelRequire("aeSaK");
/**
 * __Left sidebar without resize__
 *
 * Provides a slot for a left sidebar without resize within the PageLayout.
 *
 * - [Examples](https://atlassian.design/components/page-layout/examples)
 * - [Code](https://atlassian.design/components/page-layout/code)
 *
 * @deprecated `@atlaskit/page-layout` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $de06635ade5aa4c7$var$LeftSidebarWithoutResize = (props)=>{
    const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
    const leftSidebarWidth = (0, $71AtM.resolveDimension)((0, $gSpw2.VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
    (0, $4fqPo.useEffect)(()=>{
        (0, $euOrY.default)({
            [(0, $gSpw2.VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
        });
        return ()=>{
            (0, $euOrY.default)({
                [(0, $gSpw2.VAR_LEFT_SIDEBAR_WIDTH)]: 0
            });
        };
    }, [
        leftSidebarWidth
    ]);
    (0, $fRy95.useSkipLink)(id, skipLinkTitle);
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $bCrzj.default), {
        id: id,
        testId: testId,
        isFixed: isFixed
    }, /*#__PURE__*/ (0, $lqVX7.jsx)((0, $aeSaK.default), {
        variableName: (0, $gSpw2.VAR_LEFT_SIDEBAR_WIDTH),
        value: leftSidebarWidth
    }), /*#__PURE__*/ (0, $lqVX7.jsx)((0, $c1Zd2.default), {
        isFixed: isFixed
    }, children));
};
var $de06635ade5aa4c7$export$2e2bcd8739ae039 = $de06635ade5aa4c7$var$LeftSidebarWithoutResize;

});
parcelRegister("c1Zd2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f703a943542e2223$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $lqVX7 = parcelRequire("lqVX7");

var $5Aw5C = parcelRequire("5Aw5C");
var $aJv53 = parcelRequire("aJv53");

var $dVnnV = parcelRequire("dVnnV");

var $gSpw2 = parcelRequire("gSpw2");

var $cJwJ4 = parcelRequire("cJwJ4");
function $f703a943542e2223$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $f703a943542e2223$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $lqVX7.css)((0, $aJv53.prefersReducedMotion)());
const $f703a943542e2223$var$mobileStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $dVnnV.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $gSpw2.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
        position: 'fixed',
        insetBlockEnd: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetBlockStart: `calc(${(0, $gSpw2.BANNER_HEIGHT)} + ${(0, $gSpw2.TOP_NAVIGATION_HEIGHT)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        insetInlineStart: `${(0, $gSpw2.LEFT_PANEL_WIDTH)}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s`
    }
});
const $f703a943542e2223$var$mobileInnerFlyoutStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $dVnnV.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `min(90vw, ${(0, $gSpw2.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: (0, $gSpw2.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s, box-shadow ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s`
    }
});
/**
 * This inner wrapper is required to allow the sidebar to be `position: fixed`.
 *
 * If we were to apply `position: fixed` to the outer wrapper, it will be popped
 * out of its flex container and Main would stretch to occupy all the space.
 */ const $f703a943542e2223$var$fixedInnerStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gSpw2.LEFT_SIDEBAR_WIDTH)}`,
    position: 'fixed',
    insetBlockEnd: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetBlockStart: `calc(${(0, $gSpw2.BANNER_HEIGHT)} + ${(0, $gSpw2.TOP_NAVIGATION_HEIGHT)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    insetInlineStart: `${(0, $gSpw2.LEFT_PANEL_WIDTH)}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s`
});
const $f703a943542e2223$var$fixedInnerFlyoutStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $gSpw2.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
/**
 * Static in the sense of `position: static`.
 *
 * It will expand the page height to fit its content.
 */ const $f703a943542e2223$var$staticInnerStyles = {
    name: "13udsys",
    styles: "height:100%"
};
const $f703a943542e2223$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
const $f703a943542e2223$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
    const isDragging = (0, $cJwJ4.default)();
    return /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
        css: [
            // mobile viewport styles
            $f703a943542e2223$var$mobileStyles,
            isFlyoutOpen && $f703a943542e2223$var$mobileInnerFlyoutStyles,
            // generic styles
            !isFixed && $f703a943542e2223$var$staticInnerStyles,
            isFixed && $f703a943542e2223$var$fixedInnerStyles,
            isFixed && isFlyoutOpen && $f703a943542e2223$var$fixedInnerFlyoutStyles,
            isDragging && $f703a943542e2223$var$draggingStyles,
            $f703a943542e2223$var$prefersReducedMotionStyles
        ]
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f703a943542e2223$export$2e2bcd8739ae039 = $f703a943542e2223$var$LeftSidebarInner;

});

parcelRegister("bCrzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $d52d7c08861b57a4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $5Aw5C = parcelRequire("5Aw5C");
var $aJv53 = parcelRequire("aJv53");

var $dVnnV = parcelRequire("dVnnV");

var $gSpw2 = parcelRequire("gSpw2");

var $e3uEz = parcelRequire("e3uEz");

var $cJwJ4 = parcelRequire("cJwJ4");

var $424Vp = parcelRequire("424Vp");

var $5jaCT = parcelRequire("5jaCT");
function $d52d7c08861b57a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d52d7c08861b57a4$var$prefersReducedMotionStyles = /*#__PURE__*/ (0, $lqVX7.css)((0, $aJv53.prefersReducedMotion)());
const $d52d7c08861b57a4$var$mobileStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $dVnnV.UNSAFE_media).below.sm]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: (0, $gSpw2.MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
        cursor: 'pointer',
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `width ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s`,
        '&::after': {
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            maxWidth: (0, $gSpw2.MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            content: "''"
        }
    }
});
const $d52d7c08861b57a4$var$mobileFlyoutStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [(0, $dVnnV.UNSAFE_media).below.sm]: {
        cursor: 'revert'
    }
});
const $d52d7c08861b57a4$var$outerStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $gSpw2.LEFT_SIDEBAR_WIDTH),
    position: 'relative',
    zIndex: 1,
    marginInlineStart: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width ${(0, $gSpw2.TRANSITION_DURATION)}ms ${(0, $5Aw5C.easeOut)} 0s`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        '--ds--resize-button--opacity': 1
    }
});
const $d52d7c08861b57a4$var$draggingStyles = {
    name: "jlx54q",
    styles: "cursor:ew-resize;transition:none"
};
/**
 * In fixed mode this element's child is taken out of the document flow.
 * It doesn't take up the width as expected,
 * so the pseudo element forces it to take up the necessary width.
 */ const $d52d7c08861b57a4$var$fixedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '::after': {
        display: 'inline-block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $gSpw2.LEFT_SIDEBAR_WIDTH)}`,
        content: "''"
    }
});
const $d52d7c08861b57a4$var$flyoutStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $gSpw2.LEFT_SIDEBAR_FLYOUT_WIDTH)
});
const $d52d7c08861b57a4$var$flyoutFixedStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $gSpw2.COLLAPSED_LEFT_SIDEBAR_WIDTH)
});
const $d52d7c08861b57a4$var$selector = (0, $e3uEz.getPageLayoutSlotSelector)('left-sidebar');
const $d52d7c08861b57a4$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: // NOTE: We explicitly require this via props because of `LeftSidebarWithoutResize`
testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
    const isDragging = (0, $cJwJ4.default)();
    const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $4fqPo.useContext)((0, $424Vp.SidebarResizeContext));
    return /*#__PURE__*/ (0, $lqVX7.jsx)((0, $5jaCT.default), {
        isSidebar: true
    }, ({ className: className })=>/**
     * On desktop, the `onMouseOver|onMouseLeave` handlers controls the temporary flyout behavior.
     * This is an intentionally mouse-only experience, it may even be disruptive with keyboard navigation.
     *
     * On mobile, the `onClick` handler controls the toggled flyout behaviour.
     * This is not intended to be how you use this with a keyboard, there is a ResizeButton for this intentionally instead.
     */ // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $lqVX7.jsx)("div", {
            css: [
                // mobile viewport styles
                $d52d7c08861b57a4$var$mobileStyles,
                isFlyoutOpen && $d52d7c08861b57a4$var$mobileFlyoutStyles,
                // generic styles
                $d52d7c08861b57a4$var$outerStyles,
                isFixed && $d52d7c08861b57a4$var$fixedStyles,
                isFlyoutOpen && $d52d7c08861b57a4$var$flyoutStyles,
                isFlyoutOpen && isFixed && $d52d7c08861b57a4$var$flyoutFixedStyles,
                isDragging && $d52d7c08861b57a4$var$draggingStyles,
                $d52d7c08861b57a4$var$prefersReducedMotionStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            "data-testid": testId,
            id: id,
            // We are adding additional functionality for hover, so this should
            // not have associated key events.
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseOver: onMouseOver,
            // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            ref: ref,
            ...$d52d7c08861b57a4$var$selector
        }, children));
};
const $d52d7c08861b57a4$var$LeftSidebarOuter = /*#__PURE__*/ (0, $4fqPo.forwardRef)($d52d7c08861b57a4$var$LeftSidebarOuterComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d52d7c08861b57a4$export$2e2bcd8739ae039 = $d52d7c08861b57a4$var$LeftSidebarOuter;

});


parcelRegister("1mYFb", function(module, exports) {
$parcel$export(module.exports, "default", () => $b998c6b542b24d77$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $63KX8 = parcelRequire("63KX8");

var $lFMRN = parcelRequire("lFMRN");
/**
 * __Go back item__
 *
 * A go back item is used to provide a customized "go back" button in nested
 * navigations.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#go-back-item)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $b998c6b542b24d77$var$GoBackItem = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ className: className, iconBefore: iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($63KX8))), {
    color: "currentColor",
    label: ""
}), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
    const [isInteracted, setIsInteracted] = (0, $4fqPo.useState)(false);
    const onClickHandler = (0, $4fqPo.useCallback)((e)=>{
        if (isInteracted) return;
        setIsInteracted(true);
        onClick && onClick(e);
    }, [
        onClick,
        isInteracted
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lFMRN.default), {
        isSelected: isSelected,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: className,
        iconBefore: iconBefore,
        onClick: onClickHandler,
        ref: ref,
        ...rest
    });
});
var $b998c6b542b24d77$export$2e2bcd8739ae039 = $b998c6b542b24d77$var$GoBackItem;

});

parcelRegister("1oOk6", function(module, exports) {
$parcel$export(module.exports, "default", () => $077d08d1c6387e5e$export$2e2bcd8739ae039);
/* heading-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $aYVUY = parcelRequire("aYVUY");

var $jTy7p = parcelRequire("jTy7p");
const $077d08d1c6387e5e$var$styles = {
    headingItem: "_18zru2gc"
};
/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $077d08d1c6387e5e$var$HeadingItem = (props)=>{
    const { shouldRender: shouldRender } = (0, $jTy7p.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    // @ts-expect-error - Although this isn't defined on props it is available because we've used
    // spread props below and on the jsx element in MenuHeadingItem.
    const UNSAFE_className = props.className;
    return /*#__PURE__*/ $4fqPo.createElement((0, $aYVUY.default), {
        ...props,
        // @ts-expect-error
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $ltgDR.default)([
            $077d08d1c6387e5e$var$styles.headingItem,
            UNSAFE_className
        ])
    });
};
var $077d08d1c6387e5e$export$2e2bcd8739ae039 = $077d08d1c6387e5e$var$HeadingItem;

});

parcelRegister("XUjBt", function(module, exports) {
$parcel$export(module.exports, "default", () => $31d0bdc0cccae1fc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $8eqnR = parcelRequire("8eqnR");

var $jTy7p = parcelRequire("jTy7p");
const $31d0bdc0cccae1fc$var$outerContainerCSS = null;
const $31d0bdc0cccae1fc$var$innerContainerCSS = {
    basic: "_1reo1wug _18m91wug _1e0c1txw _vchhusvi _1bsb1osq _kqswh2mm _2lx21bp4 _14mjlb4i _1ywu1ule _1qdgyh40 _18poh2mm _1bqqcs5v _tua5idpf _1hfk1q2g _aetrb3bt _3mxo1wug",
    topScrollIndicator: "_rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vcs5v _1rus1q2g _1kt9b3bt _1enwidpf _z5wtidpf"
};
const $31d0bdc0cccae1fc$var$containerCSS = {
    basic: "_kqswh2mm _12l2u2gc _ahbqu2gc _1pfhidpf _1p3h12x7 _1l6bpxbi _auo4rdoj _hp2110yn",
    marginBlockStart: "_1pfhv77o"
};
/**
 * __Navigation content__
 *
 * A navigation content is used as the container for navigation items.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#content)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $31d0bdc0cccae1fc$var$NavigationContent = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
    const { shouldRender: shouldRender } = (0, $jTy7p.useShouldNestedElementRender)();
    const scrollbar = (0, $8eqnR.default)();
    if (!shouldRender) return children;
    const typedRef = ref;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ref: typedRef,
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _kqswh2mm _rfx3lb4i _cfu11ule _kfgtyh40 _1cs8stnw _1g0vkb7n _1rusvpsx _1kt9b3bt _1enwftgi _z5wtu2gc _14mjlb4i _1ywu1ule _1qdgyh40 _18postnw _1bqqkb7n _tua5idpf _1hfkvpsx _aetrb3bt _1gufidpf _1czdftgi _g0nfu2gc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ref: scrollbar.ref,
        className: (0, $ltgDR.default)([
            $31d0bdc0cccae1fc$var$innerContainerCSS.basic,
            !showTopScrollIndicator && $31d0bdc0cccae1fc$var$innerContainerCSS.topScrollIndicator
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            $31d0bdc0cccae1fc$var$containerCSS.basic,
            showTopScrollIndicator && $31d0bdc0cccae1fc$var$containerCSS.marginBlockStart
        ])
    }, children)));
});
var $31d0bdc0cccae1fc$export$2e2bcd8739ae039 = $31d0bdc0cccae1fc$var$NavigationContent;

});
parcelRegister("8eqnR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef74dc09c5f7808f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $ef74dc09c5f7808f$export$2e2bcd8739ae039() {
    const [scrollbarWidth, setScrollbarWidth] = (0, $4fqPo.useState)(0);
    const elementRef = (0, $4fqPo.useRef)(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $4fqPo.useEffect)(()=>{
        if (!elementRef.current) return;
        const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
        if (width === scrollbarWidth) return;
        setScrollbarWidth(width);
    });
    return {
        width: scrollbarWidth,
        ref: elementRef
    };
}

});


parcelRegister("kqBFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0748a7ab8c0f1b5c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");
const $0748a7ab8c0f1b5c$var$styles = {
    navigationFooter: "_1e0c1ule _85i5u2gc _1q511ejb _y4tiu2gc _bozgu2gc"
};
/**
 * __Navigation header__
 *
 * Allows for customisation of the header.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $0748a7ab8c0f1b5c$var$NavigationHeader = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        xcss: $0748a7ab8c0f1b5c$var$styles.navigationFooter,
        "data-navheader": true
    }, children);
};
var $0748a7ab8c0f1b5c$export$2e2bcd8739ae039 = $0748a7ab8c0f1b5c$var$NavigationHeader;

});

parcelRegister("fTc8s", function(module, exports) {
$parcel$export(module.exports, "default", () => $64003741cef5a951$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $45ZUo = parcelRequire("45ZUo");

var $jTy7p = parcelRequire("jTy7p");
/**
 * __Section__
 *
 * Used to separate items into sections. Using the title prop makes a section
 * implicitly group the items for screen readers with no additional work required.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#section)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $64003741cef5a951$var$Section = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { shouldRender: shouldRender } = (0, $jTy7p.useShouldNestedElementRender)();
    if (!shouldRender) return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $45ZUo.default), {
        ...props,
        ref: ref,
        isSideNavSection: true
    });
});
var $64003741cef5a951$export$2e2bcd8739ae039 = $64003741cef5a951$var$Section;

});

parcelRegister("3psrI", function(module, exports) {
$parcel$export(module.exports, "default", () => $bce225776aabcf33$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");


var $c70rl = parcelRequire("c70rl");

var $3TFEq = parcelRequire("3TFEq");
const $bce225776aabcf33$var$sidebarMinWidth = '240px';
const $bce225776aabcf33$var$sideNavStyles = null;
/**
 * __Side navigation__
 *
 * A highly composable side navigation component that supports nested views.
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 * - [Usage](https://atlassian.design/components/side-navigation/usage)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $bce225776aabcf33$var$SideNavigation = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    typeof $3TFEq;
    const { children: children, testId: testId, label: label, isServer: isServer = false, isSSRPlaceholderEnabled: isSSRPlaceholderEnabled = false } = props;
    return /*#__PURE__*/ $4fqPo.createElement("nav", {
        ref: ref,
        "data-testid": testId,
        "aria-label": label,
        "data-vc": `side-navigation${isServer ? '-ssr' : ''}`,
        ...isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder': 'side-navigation-placeholder'
        },
        ...!isServer && isSSRPlaceholderEnabled && {
            'data-ssr-placeholder-replace': 'side-navigation-placeholder'
        },
        className: (0, $ltgDR.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1ul9p3fh _4t3i1osq _kqswh2mm _2lx21bp4 _bfhkvuon _syazazsu"
        ])
    }, /*#__PURE__*/ $4fqPo.createElement((0, $c70rl.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "notch"
    }, children));
});
var $bce225776aabcf33$export$2e2bcd8739ae039 = $bce225776aabcf33$var$SideNavigation;

});

parcelRegister("d03Pf", function(module, exports) {
$parcel$export(module.exports, "getWindow", () => $71fe04fa026eb067$export$38b2d434cce3ea22);
const $71fe04fa026eb067$export$38b2d434cce3ea22 = ()=>window;

});

parcelRegister("eQlRt", function(module, exports) {
$parcel$export(module.exports, "useHelpCenterMessageDictionary", () => $b565a6004b21d945$export$5698e375f19e7351);
$parcel$export(module.exports, "useConditionalMessage", () => $b565a6004b21d945$export$17f06fb6e83cbd1d);

var $doQp2 = parcelRequire("doQp2");

var $iVpBi = parcelRequire("iVpBi");

var $hv3G2 = parcelRequire("hv3G2");

var $bKgWy = parcelRequire("bKgWy");
const $b565a6004b21d945$export$5698e375f19e7351 = ()=>{
    const { isHelpHub: isHelpHub } = (0, $doQp2.useOptionalHelpCenterType)();
    return {
        // Sidebar messages
        backButton: isHelpHub ? (0, $hv3G2.default).backButtonHelpHub : (0, $hv3G2.default).backButton,
        backButtonHref: isHelpHub ? '/hubs' : '/',
        settingsLabel: isHelpHub ? (0, $hv3G2.default).settingsLabelHelpHub : (0, $hv3G2.default).settingsLabel,
        // Breadcrumb messages
        breadcrumbRoot: isHelpHub ? (0, $iVpBi.default).settingsPageBreadcrumbItemHelpHub : (0, $iVpBi.default).settingsPageBreadcrumbItem,
        // Sidebar header
        headerLabel: isHelpHub ? (0, $bKgWy.default).helpHubLabel : (0, $bKgWy.default).helpCenterLabel
    };
};
const $b565a6004b21d945$export$17f06fb6e83cbd1d = (helpHubMessage, helpCenterMessage)=>{
    const { isHelpHub: isHelpHub } = (0, $doQp2.useOptionalHelpCenterType)();
    return isHelpHub ? helpHubMessage : helpCenterMessage;
};

});
parcelRegister("iVpBi", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1d8805852eb3179$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $b1d8805852eb3179$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    settingsPageBreadcrumbItem: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.center.settings.breadcrumb.item'
    },
    settingsPageBreadcrumbItemHelpHub: {
        defaultMessage: 'Help centers',
        description: 'Help center edit details page breadcrumb item',
        id: 'help.hub.settings.breadcrumb.item'
    },
    breadcrumbsLabel: {
        id: 'help.center.settings.breadcrumbs.container',
        defaultMessage: 'Breadcrumbs',
        description: 'The text is shown as the accessible label for the breadcrumb navigation wrapper in the Help Center settings area, used by screen readers to identify the breadcrumb trail.'
    }
});

});

parcelRegister("hv3G2", function(module, exports) {
$parcel$export(module.exports, "default", () => $0678cfc5dbd2901d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $0678cfc5dbd2901d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    feedbackWidget: {
        defaultMessage: 'Give feedback',
        description: 'The text for give feedback button for help centers management screen',
        id: 'sidebar.feedback.widget'
    },
    backButton: {
        defaultMessage: 'Back to all help centers',
        description: 'The text for the back button in the sidebar',
        id: 'sidebar.back.hc.management.button'
    },
    backButtonHelpHub: {
        defaultMessage: 'Back to help centers',
        description: 'The text for the back button in the sidebar when viewing a help center',
        id: 'sidebar.back.helphub.management.button'
    },
    backButtonWithoutProjectMapping: {
        defaultMessage: 'Back to help center',
        description: 'The text for the back button in the sidebar',
        id: 'sidebar.back.hc.button'
    },
    settingsLabel: {
        defaultMessage: 'Help center settings',
        description: 'Navigation label for the help center settings link in the sidebar',
        id: 'sidebar.settings.label'
    },
    settingsLabelHelpHub: {
        defaultMessage: 'Help center settings',
        description: 'Label for settings when viewing a help center',
        id: 'sidebar.settings.label.helphub'
    },
    sidebarNavigationLabel: {
        defaultMessage: 'Sidebar navigation',
        description: 'Accessible label for the sidebar navigation landmark element',
        id: 'sidebar.navigation.label'
    }
});

});

parcelRegister("bKgWy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2e54849cab24993$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $c2e54849cab24993$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpCenterLabel: {
        defaultMessage: 'Help Center',
        description: 'Heading label for the help center displayed in the sidebar header',
        id: 'sidebar.help-center.header.helpcenter.label'
    },
    helpHubLabel: {
        defaultMessage: 'Help center',
        description: 'Heading label for the help hub displayed in the sidebar header',
        id: 'sidebar.help-center.header.helphub.label'
    },
    helpCenterImageAltLabel: {
        defaultMessage: 'help center icon',
        description: 'Label for help center icon in sidebar',
        id: 'sidebar.help-center.header.helpcenter.image.alt.label'
    }
});

});


parcelRegister("6q53A", function(module, exports) {
$parcel$export(module.exports, "SidebarHelpCenterHeader", () => (parcelRequire("i9XEy")).default);

var $i9XEy = parcelRequire("i9XEy");

});
parcelRegister("i9XEy", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ca5ae8fb2ec82a0$export$2e2bcd8739ae039);
/* sidebar-help-center-header.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ghUzv = parcelRequire("ghUzv");

var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
var $3f61e = parcelRequire("3f61e");

var $6mmHn = parcelRequire("6mmHn");

var $bHBXJ = parcelRequire("bHBXJ");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");

var $4DuFB = parcelRequire("4DuFB");

var $gjCVU = parcelRequire("gjCVU");

var $eQlRt = parcelRequire("eQlRt");
const $0ca5ae8fb2ec82a0$var$SidebarHelpCenterHeader = ()=>{
    var _data$helpCenter;
    const helpCenterAri = (0, $gjCVU.useHelpCenterAri)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $ghUzv.default), {
        helpCenterAri: helpCenterAri,
        cloudId: (0, $6mmHn.getCloudId)()
    });
    const helpCenterData = data === null || data === void 0 || (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    let { currentHcName: currentHcName, currentHcBannerUrl: currentHcBannerUrl, currentHcThemeColor: currentHcThemeColor, useDefaultBanner: useDefaultBanner } = {
        currentHcName: undefined,
        currentHcBannerUrl: null,
        currentHcThemeColor: null,
        useDefaultBanner: false
    };
    if ((helpCenterData === null || helpCenterData === void 0 ? void 0 : helpCenterData.__typename) === 'HelpCenter') {
        var _helpCenterData$name, _helpCenterData$helpC, _helpCenterData$helpC2, _helpCenterData$helpC3;
        currentHcName = helpCenterData === null || helpCenterData === void 0 || (_helpCenterData$name = helpCenterData.name) === null || _helpCenterData$name === void 0 ? void 0 : _helpCenterData$name.default;
        currentHcBannerUrl = (_helpCenterData$helpC = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC === void 0 || (_helpCenterData$helpC = _helpCenterData$helpC.banner) === null || _helpCenterData$helpC === void 0 ? void 0 : _helpCenterData$helpC.url;
        currentHcThemeColor = (_helpCenterData$helpC2 = helpCenterData.helpCenterBranding) === null || _helpCenterData$helpC2 === void 0 || (_helpCenterData$helpC2 = _helpCenterData$helpC2.colors) === null || _helpCenterData$helpC2 === void 0 ? void 0 : _helpCenterData$helpC2.primary;
        useDefaultBanner = !!((_helpCenterData$helpC3 = helpCenterData.helpCenterBranding) !== null && _helpCenterData$helpC3 !== void 0 && _helpCenterData$helpC3.useDefaultBanner);
    }
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const helpCenterMessages = (0, $eQlRt.useHelpCenterMessageDictionary)();
    const defaultImage = useDefaultBanner ? (0, (/*@__PURE__*/$parcel$interopDefault($bHBXJ))) : undefined;
    const backgroundImage = currentHcBannerUrl ? currentHcBannerUrl : defaultImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4DuFB.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($0ca5ae8fb2ec82a0$var$HelpCenterImage, {
            backgroundColor: currentHcThemeColor,
            src: backgroundImage || (0, (/*@__PURE__*/$parcel$interopDefault($bHBXJ))),
            height: 24,
            width: 24,
            alt: formatMessage(helpCenterMessages.headerLabel)
        }),
        description: formatMessage(helpCenterMessages.headerLabel)
    }, currentHcName);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $0ca5ae8fb2ec82a0$var$HelpCenterImage = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_128mzge": (0, $3f61e.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_2rko1l7b _5ral1dfr",
            !__cmplp.backgroundColor ? "_bfhk4re7" : "_bfhkmpv7",
            __cmplp.className
        ])
    });
});
var $0ca5ae8fb2ec82a0$export$2e2bcd8739ae039 = $0ca5ae8fb2ec82a0$var$SidebarHelpCenterHeader;

});
parcelRegister("ghUzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $41a7d422d6bf16d8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2179412537acb48a3db96339d64a5116>>
 * @relayHash 6337212810c49a971e575c2b12da2d45
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956
const $41a7d422d6bf16d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            }
        ]
    }, v5 = {
        "concreteType": "HelpCenterBranding",
        "kind": "LinkedField",
        "name": "helpCenterBranding",
        "plural": false,
        "selections": [
            {
                "concreteType": "HelpCenterBanner",
                "kind": "LinkedField",
                "name": "banner",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ]
            },
            {
                "concreteType": "HelpCenterBrandingColors",
                "kind": "LinkedField",
                "name": "colors",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "primary"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "useDefaultBanner"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v3 /*: any*/ 
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sidebarHelpCenterHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "03c90fb33e97de1111ac72fc2f5f2d0015bf74b51ff66581f9c6c1ae79817956",
            "metadata": {},
            "name": "sidebarHelpCenterHeaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$41a7d422d6bf16d8$var$node.hash = "b1b17113e136ecbdd8bfb74c4910cc78";
var $41a7d422d6bf16d8$export$2e2bcd8739ae039 = $41a7d422d6bf16d8$var$node;

});

parcelRegister("4DuFB", function(module, exports) {
$parcel$export(module.exports, "default", () => $69e836c8d4058eab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $1Vx39 = parcelRequire("1Vx39");

var $1V8Gt = parcelRequire("1V8Gt");
const $69e836c8d4058eab$var$styles = {
    header: "_uizt1wug _vrjt1qyo _1cmdi7uo _11kjsm61 _jl2n73ad _1et6sm61 _1v6ji7uo"
};
/**
 * __Header__
 *
 * - [Examples](https://atlassian.design/components/side-navigation/examples#header-and-footer)
 * - [Code](https://atlassian.design/components/side-navigation/code)
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $69e836c8d4058eab$var$Header = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1Vx39.default), {
        ...props,
        ref: ref,
        component: props.component || (0, $1V8Gt.default),
        isTitleHeading: true,
        className: (0, $ltgDR.default)([
            $69e836c8d4058eab$var$styles.header
        ])
    });
});
var $69e836c8d4058eab$export$2e2bcd8739ae039 = $69e836c8d4058eab$var$Header;

});
parcelRegister("1Vx39", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dc918a99ef506a4$export$2e2bcd8739ae039);
/* custom-item.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $hHIxn = parcelRequire("hHIxn");

var $jTy7p = parcelRequire("jTy7p");
const $7dc918a99ef506a4$var$styles = {
    root: "_2rkofajl _1rjcu2gc _18zru2gc _bfhksm61 _1a391k8s _racp1k8s _30l3azsu _irr31dpa _ppn2azsu _183jfcek",
    selectedStyles: "_bfhk15s3 _syaz6x5g _10536x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g"
};
/**
 * Used to support any custom items needed by products alongside the Header and Footer patterns.
 * Specific implementation of headers and footers are provided in the examples folder.
 *
 * @deprecated `@atlaskit/side-navigation` is deprecated. Use `@atlaskit/navigation-system` instead.
 */ const $7dc918a99ef506a4$var$CustomItem = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ className: className, ...props }, ref)=>{
    const { shouldRender: shouldRender } = (0, $jTy7p.useShouldNestedElementRender)();
    if (!shouldRender) return null;
    return /*#__PURE__*/ $4fqPo.createElement((0, $hHIxn.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            $7dc918a99ef506a4$var$styles.root,
            props.isSelected && $7dc918a99ef506a4$var$styles.selectedStyles,
            className
        ]),
        ...props
    });
});
var $7dc918a99ef506a4$export$2e2bcd8739ae039 = $7dc918a99ef506a4$var$CustomItem;

});

parcelRegister("1V8Gt", function(module, exports) {
$parcel$export(module.exports, "default", () => $39cb106b08b9f481$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
/**
 * __Container__
 *
 * A container for Header and Footer that safely handles props to the child component
 */ const $39cb106b08b9f481$var$HeaderContainer = ({ children: children, 'data-testid': testId, ...props })=>{
    // https://stackoverflow.com/a/39333479
    const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
            className: className,
            onClick: onClick,
            onMouseDown: onMouseDown,
            onDragStart: onDragStart,
            draggable: draggable,
            ref: ref,
            tabIndex: tabIndex,
            disabled: disabled
        }))(props);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": testId,
        style: {
            position: 'relative'
        },
        ...safeProps
    }, children));
};
var $39cb106b08b9f481$export$2e2bcd8739ae039 = $39cb106b08b9f481$var$HeaderContainer;

});




parcelRegister("kjxwV", function(module, exports) {
$parcel$export(module.exports, "SidebarSkeleton", () => (parcelRequire("bghmb")).default);

var $bghmb = parcelRequire("bghmb");

});
parcelRegister("bghmb", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8f01f80e3372e62$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $bG6ob = parcelRequire("bG6ob");

var $j4lpV = parcelRequire("j4lpV");

var $7TPEx = parcelRequire("7TPEx");
var $9Ix81 = parcelRequire("9Ix81");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $4DuFB = parcelRequire("4DuFB");
var $XUjBt = parcelRequire("XUjBt");
var $kqBFy = parcelRequire("kqBFy");
var $fTc8s = parcelRequire("fTc8s");

var $ebpTf = parcelRequire("ebpTf");
const $a8f01f80e3372e62$var$SideBarContentSkeleton = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "16px",
        width: "35%"
    }));
};
const $a8f01f80e3372e62$var$SidebarHeaderSkeleton = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $kqBFy.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $4DuFB.default), {
        iconBefore: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
            height: "24px",
            width: "80%",
            "data-testid": "icon-skeleton"
        }),
        description: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
            height: "16px",
            width: "55%",
            "data-testid": "description-skeleton"
        })
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockEnd: "space.025"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "16px",
        width: "85%",
        "data-testid": "title-skeleton"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.300",
        paddingBlockEnd: "space.150",
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        alignItems: "center",
        gap: "space.150"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "18px",
        width: "18px",
        isCircle: true
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "16px",
        width: "60%"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $XUjBt.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "16px",
        width: "30%"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.300"
    }, (0, $bG6ob.isProjectMappingInHelpCenterEnabled)() && /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, /*#__PURE__*/ $4fqPo.createElement($a8f01f80e3372e62$var$SideBarContentSkeleton, null), /*#__PURE__*/ $4fqPo.createElement($a8f01f80e3372e62$var$SideBarContentSkeleton, null)), (0, $bG6ob.isCustomPagesUiEnabled)() && (0, $ebpTf.getIsHCCustomizationEnabled)() && /*#__PURE__*/ $4fqPo.createElement($a8f01f80e3372e62$var$SideBarContentSkeleton, null), /*#__PURE__*/ $4fqPo.createElement($a8f01f80e3372e62$var$SideBarContentSkeleton, null)))), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        xcss: $a8f01f80e3372e62$var$navFooter
    }, /*#__PURE__*/ $4fqPo.createElement((0, $XUjBt.default), {
        showTopScrollIndicator: true
    }, /*#__PURE__*/ $4fqPo.createElement((0, $fTc8s.default), null, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlock: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        gap: "space.150",
        direction: "row",
        alignItems: "center"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "14px",
        width: "14px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        height: "16px",
        width: "70%"
    })))))));
};
const $a8f01f80e3372e62$var$navFooter = (0, $2m8U6.xcss)({
    position: 'absolute',
    bottom: 'space.0',
    width: '94%'
});
var $a8f01f80e3372e62$export$2e2bcd8739ae039 = $a8f01f80e3372e62$var$SidebarHeaderSkeleton;

});




parcelRegister("cXlrU", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7d0bd1bdab1bbe0$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $f7d0bd1bdab1bbe0$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpcenterDetailsItem: {
        defaultMessage: 'Details',
        description: 'Label for the help center details item in the help center management screen sidebar',
        id: 'admin.management.sidebar.edit.details'
    },
    helpcenterManageProjectsItem: {
        defaultMessage: 'Projects',
        description: 'Label for the help center projects item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects'
    },
    helpcenterManageProjectsItemGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Label for the help center spaces item in the help center management screen sidebar',
        id: 'admin.management.sidebar.manage.projects-galaxia'
    },
    helpcenterManagePagesItem: {
        defaultMessage: 'Landing pages',
        description: 'Label for the help center landing pages item in the help center management screen sidebar',
        id: 'admin.management.sidebar.landing.pages'
    },
    helpcenterRovoServiceAgentItem: {
        defaultMessage: 'Rovo agent',
        description: 'Label for the help center Rovo service agent item in the help center management screen sidebar',
        id: 'admin.management.sidebar.rovo.service.agent'
    },
    helpcenterVsaReportingItem: {
        defaultMessage: 'Virtual service agent',
        description: 'Label for the help center reporting item in the help center management screen sidebar',
        id: 'admin.management.sidebar.reporting'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'admin.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'admin.management.sidebar.error.description'
    },
    landingPagesSidebarChangeBoardingHeading: {
        defaultMessage: 'Create unique pages in the help center',
        description: 'Heading text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.heading'
    },
    landingPagesSidebarChangeBoardingContent: {
        defaultMessage: "Customize layouts and curate help content to create visually-appealing landing pages that meet your audience's needs.",
        description: 'Spotlight content text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.content'
    },
    landingPagesSidebarChangeBoardingDismissButton: {
        defaultMessage: 'Dismiss',
        description: 'Dismiss button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.dismiss'
    },
    landingPagesSidebarChangeBoardingTryButton: {
        defaultMessage: 'Try now',
        description: 'Try now button text for Landing Pages Change Boarding from Help Center Management screen sidebar',
        id: 'admin.management.sidebar.landing.pages.changeboarding.button.try'
    }
});

});



parcelRegister("hBskO", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => (parcelRequire("j9Nxb")).HelpCenterManageProjects);

var $j9Nxb = parcelRequire("j9Nxb");

});
parcelRegister("j9Nxb", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManageProjects", () => $8f94aea66ece4e83$export$44752868a2f1a12);

var $cibRc = parcelRequire("cibRc");

var $4fqPo = parcelRequire("4fqPo");

var $1P8FK = parcelRequire("1P8FK");

var $irD07 = parcelRequire("irD07");

var $748yq = parcelRequire("748yq");

var $gMSZD = parcelRequire("gMSZD");

var $6mmHn = parcelRequire("6mmHn");

var $gopxm = parcelRequire("gopxm");

var $63sfu = parcelRequire("63sfu");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");

var $fFB0R = parcelRequire("fFB0R");
var $ew3Bn = parcelRequire("ew3Bn");

var $845jN = parcelRequire("845jN");
var $kvfxL = parcelRequire("kvfxL");

var $2bLkU = parcelRequire("2bLkU");

var $6bGmX = parcelRequire("6bGmX");

var $2eKV2 = parcelRequire("2eKV2");

var $8B6Ry = parcelRequire("8B6Ry");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $bOOgP = parcelRequire("bOOgP");

var $cz6zo = parcelRequire("cz6zo");
var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");

var $WVSzu = parcelRequire("WVSzu");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");

var $3krHC = parcelRequire("3krHC");
var $7hsFm = parcelRequire("7hsFm");

var $doQp2 = parcelRequire("doQp2");

var $gjCVU = parcelRequire("gjCVU");
parcelRequire("hdYRg");
var $1g7Go = parcelRequire("1g7Go");
parcelRequire("j02N2");
var $9mFjv = parcelRequire("9mFjv");

var $lhl62 = parcelRequire("lhl62");
parcelRequire("ijwYN");
var $dA2Kt = parcelRequire("dA2Kt");

var $2cJ4Q = parcelRequire("2cJ4Q");
parcelRequire("vjfYn");
var $5YsGl = parcelRequire("5YsGl");
parcelRequire("5ZlgL");
var $eYbEH = parcelRequire("eYbEH");

var $iUHYA = parcelRequire("iUHYA");
const $8f94aea66ece4e83$var$PROJECT_MAPPING_SUPPORT_DOC_URL = 'https://support.atlassian.com/jira-service-management-cloud/docs/link-service-projects-to-a-help-center/';
const $8f94aea66ece4e83$var$StaticContent = ({ isReadOnlyView: isReadOnlyView })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { isHelpHub: isHelpHub } = (0, $doQp2.useHelpCenterType)();
    const isGalaxia = (0, $6bGmX.default).checkGate('itsm-project-renaming');
    const helpCenterManageProjectsLink = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1P8FK.Link), {
            href: $8f94aea66ece4e83$var$PROJECT_MAPPING_SUPPORT_DOC_URL,
            actionSubjectId: "manageProjectsLink",
            target: "_blank",
            rel: "noreferrer"
        }, chunks);
    const pageTitle = isGalaxia ? (0, $2cJ4Q.default).manageProjectsPageTitleGalaxia : (0, $2cJ4Q.default).manageProjectsPageTitle;
    let pageDescription;
    if (isReadOnlyView) pageDescription = isGalaxia ? (0, $2cJ4Q.default).manageProjectsPageDescriptionForDefaultHCGalaxia : (0, $2cJ4Q.default).manageProjectsPageDescriptionForDefaultHC;
    else if (isHelpHub) pageDescription = (0, $2cJ4Q.default).manageProjectsPageDescriptionHelpHub;
    else if (isGalaxia) pageDescription = (0, $2cJ4Q.default).manageProjectsPageDescriptionGalaxia;
    else pageDescription = (0, $2cJ4Q.default).manageProjectsPageDescription;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        size: "large"
    }, formatMessage(pageTitle)), isReadOnlyView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, isHelpHub ? formatMessage(pageDescription) : formatMessage(pageDescription, {
        link: helpCenterManageProjectsLink
    })));
};
const $8f94aea66ece4e83$var$HelpCenterManageProjectsComponent = ()=>{
    var _data$jira, _data$helpCenter, _data$helpCenter2, _data$helpCenter3, _data$helpCenter4, _data$jira2;
    const [helpCenterMappingStatus, setHelpCenterMappingStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState((0, $iUHYA.ProjectsMappingStatus).LINKED);
    const helpCenterAri = (0, $gjCVU.useHelpCenterAri)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $cibRc.default), {
        helpCenterMappingStatus: helpCenterMappingStatus,
        helpCenterId: '',
        helpCenterARI: helpCenterAri,
        cloudId: (0, $6mmHn.getCloudId)()
    });
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [searchQuery, setSearchQuery] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState('');
    const onInputChange = (value)=>{
        setSearchQuery(value);
    };
    const debouncedOnChange = (0, $63sfu.debounce)(onInputChange, (0, $748yq.USER_TYPING_DEBOUNCE_TIME));
    const onTextFieldChange = (0, $4fqPo.useCallback)((event)=>{
        const value = event.target.value;
        debouncedOnChange(value);
    }, [
        debouncedOnChange
    ]);
    const statusTextMap = {
        [(0, $iUHYA.ProjectsMappingStatus).LINKED]: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $2cJ4Q.default).linkedFilterLabelGalaxia) : formatMessage((0, $2cJ4Q.default).linkedFilterLabel),
        [(0, $iUHYA.ProjectsMappingStatus).UNLINKED]: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $2cJ4Q.default).unlinkedFilterLabelGalaxia) : formatMessage((0, $2cJ4Q.default).unlinkedFilterLabel)
    };
    if (!(data !== null && data !== void 0 && (_data$jira = data.jira) !== null && _data$jira !== void 0 && _data$jira.jiraProjectsMappedToHelpCenter)) return null;
    if (!(data !== null && data !== void 0 && (_data$helpCenter = data.helpCenter) !== null && _data$helpCenter !== void 0 && _data$helpCenter.helpCenterById)) return null;
    const slug = (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 || (_data$helpCenter2 = _data$helpCenter2.helpCenterById) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.slug;
    const isDefaultHC = !slug;
    const isReadOnlyView = !(0, $ebpTf.getIsMultiHCEnabled)() || isDefaultHC;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: (0, $748yq.ScreenName).MANAGE_PROJECTS,
        sourceType: (0, $gHT3x.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9mFjv.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($8f94aea66ece4e83$var$StaticContent, {
        isReadOnlyView: isReadOnlyView
    }), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $2cJ4Q.default).manageProjectPageToggleForDefaultLinkingGalaxia) : formatMessage((0, $2cJ4Q.default).manageProjectPageToggleForDefaultLinking)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eYbEH.default), {
        syncProjectsToggleFragmentKey: (_data$helpCenter4 = data.helpCenter) === null || _data$helpCenter4 === void 0 ? void 0 : _data$helpCenter4.helpCenterById
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $8f94aea66ece4e83$var$searchInputStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bOOgP.default), {
        name: "search",
        autoComplete: "off",
        isCompact: true,
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8B6Ry))), {
            size: "small",
            label: "search icon",
            spacing: "spacious"
        })),
        defaultValue: searchQuery,
        onChange: onTextFieldChange,
        placeholder: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $2cJ4Q.default).searchProjectsPlaceholderGalaxia) : formatMessage((0, $2cJ4Q.default).searchProjectsPlaceholder)
    })), !isReadOnlyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: 'projectMappingMenu'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $8f94aea66ece4e83$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $845jN.default), {
        trigger: statusTextMap[helpCenterMappingStatus],
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kvfxL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: 'projectMappingLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $irD07.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $iUHYA.ProjectsMappingStatus).LINKED);
        }
    }, statusTextMap[(0, $iUHYA.ProjectsMappingStatus).LINKED])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            actionSubjectId: 'projectMappingUnLinkedMenuItem'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $irD07.DropdownItem), {
        onClick: ()=>{
            setHelpCenterMappingStatus((0, $iUHYA.ProjectsMappingStatus).UNLINKED);
        }
    }, statusTextMap[(0, $iUHYA.ProjectsMappingStatus).UNLINKED])))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5YsGl.default), {
        isReadOnlyView: isReadOnlyView,
        projectsListFragmentKey: data === null || data === void 0 || (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.jiraProjectsMappedToHelpCenter,
        selection: helpCenterMappingStatus,
        searchQuery: searchQuery
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $lhl62.manageProjectsExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null)));
};
const $8f94aea66ece4e83$export$44752868a2f1a12 = ()=>{
    (0, $7hsFm.useUFOComponentExperience)((0, $lhl62.manageProjectsExperience));
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) {
            (0, $lhl62.manageProjectsExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
            //TODO: Add helpCenterMappingStatus
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'project',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bLkU.default), {
            header: formatMessage((0, $2cJ4Q.default).errorTitle),
            description: formatMessage((0, $2cJ4Q.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($gopxm)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1g7Go.default), {
        featureName: "Helpcenter manage projects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).MANAGE_PROJECTS,
        id: 'help-center-manage-projects',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dA2Kt.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($8f94aea66ece4e83$var$HelpCenterManageProjectsComponent, null))));
};
const $8f94aea66ece4e83$var$searchInputStyles = (0, $2m8U6.xcss)({
    width: '288px',
    marginRight: 'space.200'
});
const $8f94aea66ece4e83$var$dropdownContainerStyles = (0, $2m8U6.xcss)({
    zIndex: 'modal'
});

});
parcelRegister("cibRc", function(module, exports) {
$parcel$export(module.exports, "default", () => $477e65977e9fcefa$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d53c6c03de4053326d733cad1281e15b>>
 * @relayHash bc210f0fbe988c79fde091a561d08224
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392
const $477e65977e9fcefa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterMappingStatus"
    }, v4 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v5 = [
        v4 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterARI"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterId",
                    "variableName": "helpCenterId"
                },
                {
                    "kind": "Variable",
                    "name": "helpCenterMappingStatus",
                    "variableName": "helpCenterMappingStatus"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        }
    ], v6 = [
        v4 /*: any*/ 
    ], v7 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterARI"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "projectsListFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "syncProjectsToggleFragment"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "manageProjects_GetProjectsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "jiraProjectsMappedToHelpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterProjectMappingData",
                                            "kind": "LinkedField",
                                            "name": "projectMappingData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "syncNewProjects"
                                                }
                                            ]
                                        },
                                        v8 /*: any*/ ,
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "73e7bc2ccf5a80141d9d3113455fc6fcace13f1d53f66dc1b16481d93dc29392",
            "metadata": {},
            "name": "manageProjects_GetProjectsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$477e65977e9fcefa$var$node.hash = "5e6e808fa11d7afbb4a426f5b2c7f1a1";
var $477e65977e9fcefa$export$2e2bcd8739ae039 = $477e65977e9fcefa$var$node;

});

parcelRegister("irD07", function(module, exports) {
$parcel$export(module.exports, "DropdownItem", () => $3d97a2c3ee0cea4f$export$6648d5fa18559e7f);

var $jQXWT = parcelRequire("jQXWT");
var $apbG6 = parcelRequire("apbG6");
var $as4kh = parcelRequire("as4kh");

var $4G75r = parcelRequire("4G75r");
const $3d97a2c3ee0cea4f$export$6648d5fa18559e7f = (0, $apbG6.default)({
    componentName: 'dropdownItem'
})((0, $as4kh.default)({
    onClick: (0, $jQXWT.default)('atlaskit')({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    })
})((0, $4G75r.default)));

});

parcelRegister("j02N2", function(module, exports) {
$parcel$export(module.exports, "SettingsBreadcrumbs", () => (parcelRequire("9mFjv")).default);

var $9mFjv = parcelRequire("9mFjv");

});
parcelRegister("9mFjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $95038ed099b4563e$export$2e2bcd8739ae039);

var $6Ac2T = parcelRequire("6Ac2T");

var $4fqPo = parcelRequire("4fqPo");

var $as21I = parcelRequire("as21I");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");

var $ex668 = parcelRequire("ex668");

var $7TPEx = parcelRequire("7TPEx");

var $eQlRt = parcelRequire("eQlRt");

var $iVpBi = parcelRequire("iVpBi");
const $95038ed099b4563e$var$SettingsBreadcrumbs = ({ helpCenterData: helpCenterData })=>{
    var _data$name;
    const data = (0, $gIeP2.useFragment)((0, $6Ac2T.default), helpCenterData);
    const helpCenterName = (data === null || data === void 0 || (_data$name = data.name) === null || _data$name === void 0 ? void 0 : _data$name.default) || '';
    const slug = data === null || data === void 0 ? void 0 : data.slug;
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const helpCenterMessages = (0, $eQlRt.useHelpCenterMessageDictionary)();
    const rootBreadcrumbUrl = '/';
    const getHelpcenterBreadcrumbUrl = ()=>{
        return !slug ? `${window.location.origin}/servicedesk/customer` : `${window.location.origin}/helpcenter/${slug}`;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ex668.default), {
        label: formatMessage((0, $iVpBi.default).breadcrumbsLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $as21I.default), {
        isFirstCrumb: true,
        to: rootBreadcrumbUrl,
        name: formatMessage(helpCenterMessages.breadcrumbRoot),
        actionSubjectId: "helpCenterBreadcrumb",
        disableTheme: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $as21I.default), {
        to: getHelpcenterBreadcrumbUrl(),
        name: helpCenterName,
        actionSubjectId: "helpDeskBreadcrumb",
        disableTheme: true
    }))));
};
var $95038ed099b4563e$export$2e2bcd8739ae039 = $95038ed099b4563e$var$SettingsBreadcrumbs;

});
parcelRegister("6Ac2T", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7d7926b10ca10c5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<25699f1eb65c2f623944fcb43e23c755>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b7d7926b10ca10c5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "settingsBreadcrumbsFragment",
    "selections": [
        {
            "concreteType": "HelpCenterName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "default"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "slug"
        }
    ],
    "type": "HelpCenter"
};
$b7d7926b10ca10c5$var$node.hash = "0716469cbe624819ae2ea879ee690b4e";
var $b7d7926b10ca10c5$export$2e2bcd8739ae039 = $b7d7926b10ca10c5$var$node;

});



parcelRegister("lhl62", function(module, exports) {
$parcel$export(module.exports, "manageProjectsExperience", () => $b2cac4f419471991$export$500b6e6c6f0e66cd);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $b2cac4f419471991$export$500b6e6c6f0e66cd = new (0, $3odV5.UFOExperience)((0, $hWlSg.manageProjectsExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("ijwYN", function(module, exports) {
$parcel$export(module.exports, "ManageProjectsLayoutSkeleton", () => (parcelRequire("dA2Kt")).default);

var $dA2Kt = parcelRequire("dA2Kt");

});
parcelRegister("dA2Kt", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b96cda41c4fad9f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $j4lpV = parcelRequire("j4lpV");

var $1FmaX = parcelRequire("1FmaX");

var $7TPEx = parcelRequire("7TPEx");
var $9Ix81 = parcelRequire("9Ix81");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $jvwY8 = parcelRequire("jvwY8");
const $1b96cda41c4fad9f$var$ManageProjectsLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "12px",
                    height: "12px"
                }),
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
            },
            {
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            {
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH).status
            },
            {
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "30%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 10
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "12px",
                        height: "12px"
                    })
                },
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "24px",
                        height: "24px"
                    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
                        gap: "space.100",
                        alignItems: "center"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "24px",
                        height: "24px",
                        isCircle: true
                    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    })))
                },
                {
                    key: 'select-all-skeleton',
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "28%",
                        height: "16px"
                    })
                },
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "30%",
                        height: "20px"
                    })
                }
            ]
        }));
    return /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.300"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.300"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-project-title-skeleton"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.050"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "50%",
        height: "20px"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "270px",
        height: "16px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "32px",
        height: "16px",
        "data-testid": "toggle-new-projects-layout-skeleton"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlock: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.075"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "25%",
        height: "32px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "20%",
        height: "32px"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        xcss: $1b96cda41c4fad9f$var$tableSkeletonStyles
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1FmaX.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true,
        highlightedRowIndex: 11
    })));
};
const $1b96cda41c4fad9f$var$tableSkeletonStyles = (0, $2m8U6.xcss)({
    pointerEvents: 'none'
});
var $1b96cda41c4fad9f$export$2e2bcd8739ae039 = $1b96cda41c4fad9f$var$ManageProjectsLayoutSkeleton;

});
parcelRegister("1FmaX", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c920a50cd931396$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $c1tmZ = parcelRequire("c1tmZ");

var $7KYg9 = parcelRequire("7KYg9");

var $cElsb = parcelRequire("cElsb");
class $5c920a50cd931396$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    static #_ = this.defaultProps = {
        defaultPage: 1,
        isLoading: false,
        isFixedSize: false,
        isRankable: false,
        onSetPage: (0, $c1tmZ.default),
        onSort: (0, $c1tmZ.default),
        rowsPerPage: Infinity
    };
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cElsb.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args), this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        }, this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        }, this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        }, this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        }, this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $7KYg9.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}

});
parcelRegister("7KYg9", function(module, exports) {
$parcel$export(module.exports, "reorderRows", () => $aca708e4234c3ac1$export$c476bbe5da59992d);

var $6DT7y = parcelRequire("6DT7y");
const $aca708e4234c3ac1$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = (0, $6DT7y.computeIndex)(sourceIndex, page, rowsPerPage);
    const toIndex = (0, $6DT7y.computeIndex)(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});
parcelRegister("6DT7y", function(module, exports) {
$parcel$export(module.exports, "computeIndex", () => $8cfc8c2038d09e7e$export$92bcb1ed38b134a1);
const $8cfc8c2038d09e7e$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};

});


parcelRegister("cElsb", function(module, exports) {
$parcel$export(module.exports, "default", () => $683f20a3ba056a9e$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");

var $akXMn = parcelRequire("akXMn");

var $7TV8R = parcelRequire("7TV8R");

var $hLBfB = parcelRequire("hLBfB");

var $lnOj7 = parcelRequire("lnOj7");

var $5y2GY = parcelRequire("5y2GY");

var $8CJlU = parcelRequire("8CJlU");

var $b8MXE = parcelRequire("b8MXE");

var $3qoIB = parcelRequire("3qoIB");

var $aDvJS = parcelRequire("aDvJS");

var $74YUs = parcelRequire("74YUs");

var $2jRbU = parcelRequire("2jRbU");

var $JMQK5 = parcelRequire("JMQK5");

var $epeLp = parcelRequire("epeLp");

var $boVbX = parcelRequire("boVbX");
function $683f20a3ba056a9e$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 'DESC':
            return 'ASC';
        case 'ASC':
            return 'DESC';
        default:
            return currentSortOrder;
    }
}
const $683f20a3ba056a9e$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $c1tmZ.default), onSort: providedOnSort = (0, $c1tmZ.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $c1tmZ.default), onRankEnd: providedOnRankEnd = (0, $c1tmZ.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $4fqPo.useState)(false);
    const tableBodyRef = (0, $4fqPo.useRef)(null);
    const onSort = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    const onRankEnd = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: undefined,
        packageVersion: undefined
    });
    (0, $4fqPo.useEffect)(()=>{
        (0, $hLBfB.validateSortKey)(sortKey, head);
        (0, $akXMn.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === 'DESC') {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? 'ASC' : $683f20a3ba056a9e$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $7TV8R.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? 'large' : 'small';
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8CJlU.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5y2GY.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $JMQK5.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3qoIB.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lnOj7.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $boVbX.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($683f20a3ba056a9e$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $b8MXE.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $epeLp.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2jRbU.default), {
        isLoading: isLoading,
        spinnerSize: "large",
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $683f20a3ba056a9e$var$RankableTableBody = /*#__PURE__*/ (0, $4fqPo.lazy)(()=>(parcelRequire("e3vu5")));
const $683f20a3ba056a9e$var$TableBody = /*#__PURE__*/ (0, $4fqPo.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $4fqPo.useState)(false);
    (0, $4fqPo.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aDvJS.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $74YUs.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($683f20a3ba056a9e$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$683f20a3ba056a9e$export$2e2bcd8739ae039 = $683f20a3ba056a9e$var$DynamicTable;

});
parcelRegister("akXMn", function(module, exports) {
$parcel$export(module.exports, "assertIsSortable", () => $4e18773226b8de77$export$5eb35a4771ec4090);
const $4e18773226b8de77$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};

});

parcelRegister("7TV8R", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $abba8b6fb5f3df69$export$3987dc24b734dcab);
const $abba8b6fb5f3df69$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};

});

parcelRegister("hLBfB", function(module, exports) {
$parcel$export(module.exports, "validateSortKey", () => $5f111ce26b68f617$export$9133f5a8bfe8a200);
const $5f111ce26b68f617$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

});

parcelRegister("lnOj7", function(module, exports) {
$parcel$export(module.exports, "Caption", () => $0a78417d0ed4cc14$export$32fbfacc5d962e0c);
/* caption.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $0a78417d0ed4cc14$var$captionStyles = null;
const $0a78417d0ed4cc14$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ $4fqPo.createElement("caption", {
        className: (0, $ltgDR.default)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ])
    }, children);

});

parcelRegister("5y2GY", function(module, exports) {
$parcel$export(module.exports, "EmptyViewContainer", () => $5eead6768fb3fb8d$export$381ea436de119582);
/* empty-view-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $5eead6768fb3fb8d$var$emptyViewContainerStyles = null;
const $5eead6768fb3fb8d$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $ltgDR.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ])
    }, children);
};

});

parcelRegister("8CJlU", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $ad059b2875f5f558$export$8f45b9407d4090d7);
/* empty-view-with-fixed-height.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $ad059b2875f5f558$var$fixedHeightStyles = null;
const $ad059b2875f5f558$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $ltgDR.default)([
            "_4t3i1jdh"
        ])
    }, children);

});

parcelRegister("b8MXE", function(module, exports) {
$parcel$export(module.exports, "PaginationWrapper", () => $a3f4b5a1fa7fcda0$export$3e5e12dc01f20a43);
/* pagination-wrapper.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $a3f4b5a1fa7fcda0$var$paginationWrapperStyles = null;
const $a3f4b5a1fa7fcda0$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $ltgDR.default)([
            "_1e0c1txw _1bah1h6o"
        ])
    }, children);

});

parcelRegister("3qoIB", function(module, exports) {
$parcel$export(module.exports, "Table", () => $3212bafb330cf660$export$54ec01a60f47d33d);
/* table.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $3212bafb330cf660$var$fixedSizeTableStyles = null;
const $3212bafb330cf660$var$tableStyles = null;
const $3212bafb330cf660$var$bodyBorder = null;
const $3212bafb330cf660$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ $4fqPo.createElement("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $ltgDR.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ])
    }, children);
});

});

parcelRegister("aDvJS", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b93891a83c31320$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $cJTxU = parcelRequire("cJTxU");

var $jd47e = parcelRequire("jd47e");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $5b93891a83c31320$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jd47e.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $5b93891a83c31320$var$Body = (0, $cJTxU.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5b93891a83c31320$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5b93891a83c31320$export$2e2bcd8739ae039 = $5b93891a83c31320$var$Body;

});
parcelRegister("cJTxU", function(module, exports) {
$parcel$export(module.exports, "default", () => $03625fd6324beceb$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $7TV8R = parcelRequire("7TV8R");

var $hLBfB = parcelRequire("hLBfB");
const $03625fd6324beceb$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
const $03625fd6324beceb$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === 'ASC' ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $03625fd6324beceb$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $03625fd6324beceb$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $03625fd6324beceb$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $hLBfB.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $03625fd6324beceb$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $7TV8R.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("jd47e", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f6358f49fd1940b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $ikIPx = parcelRequire("ikIPx");

var $9AaFV = parcelRequire("9AaFV");
const $6f6358f49fd1940b$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9AaFV.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ikIPx.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f6358f49fd1940b$export$2e2bcd8739ae039 = $6f6358f49fd1940b$var$Row;

});
parcelRegister("ikIPx", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $f20838e9266b588e$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $gUBVe = parcelRequire("gUBVe");
const $f20838e9266b588e$var$fixedSizeTruncateStyles = null;
const $f20838e9266b588e$var$overflowTruncateStyles = null;
const $f20838e9266b588e$var$truncationWidthStyles = null;
const $f20838e9266b588e$var$cellStyles = null;
const $f20838e9266b588e$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ $4fqPo.createElement("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $gUBVe.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("gUBVe", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $f7d4f98808d3be75$export$5e6497a652ae30b5);
const $f7d4f98808d3be75$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $f7d4f98808d3be75$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$f7d4f98808d3be75$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("9AaFV", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $dce5860328583634$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $dce5860328583634$var$rowStyles = null;
const $dce5860328583634$var$rowBackgroundStyles = null;
const $dce5860328583634$var$rowHighlightedBackgroundStyles = null;
const $dce5860328583634$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ $4fqPo.createElement("tr", {
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $ltgDR.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("74YUs", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $bfbc025ecfdb2860$export$e926676385687eaf);

var $4fqPo = parcelRequire("4fqPo");
class $bfbc025ecfdb2860$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("2jRbU", function(module, exports) {
$parcel$export(module.exports, "default", () => $eea0b87588be3bf2$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $5qWT2 = parcelRequire("5qWT2");

var $dRISN = parcelRequire("dRISN");

var $5MKs1 = parcelRequire("5MKs1");

var $6Dhgi = parcelRequire("6Dhgi");
class $eea0b87588be3bf2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: 'large',
        contentsOpacity: 0.22,
        loadingLabel: 'Loading table'
    };
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dRISN.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5MKs1.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6Dhgi.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("dRISN", function(module, exports) {
$parcel$export(module.exports, "Container", () => $18fbe21d11e36ba9$export$42a852a2b6b56249);
/* container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $18fbe21d11e36ba9$var$containerStyles = null;
const $18fbe21d11e36ba9$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $ltgDR.default)([
            "_kqswh2mm"
        ])
    }, children);

});

parcelRegister("5MKs1", function(module, exports) {
$parcel$export(module.exports, "ContentsContainer", () => $82970318829dfee2$export$67c29eae8ae2137a);
/* contents-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $82970318829dfee2$var$CSS_VAR_CONTENTS_OPACITY = '--contents-opacity';
const $82970318829dfee2$var$contentsContainerStyles = null;
const $82970318829dfee2$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        style: {
            [$82970318829dfee2$var$CSS_VAR_CONTENTS_OPACITY]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $ltgDR.default)([
            "_tzy4saf5 _lcxvglyw"
        ])
    }, children);

});

parcelRegister("6Dhgi", function(module, exports) {
$parcel$export(module.exports, "SpinnerContainer", () => $4c2724423aa301e4$export$a5e06607a5ac6158);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $4c2724423aa301e4$var$spinnerContainerStyles = null;
const $4c2724423aa301e4$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ $4fqPo.createElement("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $ltgDR.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ])
    }, children);

});


parcelRegister("JMQK5", function(module, exports) {
$parcel$export(module.exports, "default", () => $174893ecfd5a9df2$export$2e2bcd8739ae039);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $5qWT2 = parcelRequire("5qWT2");
const $174893ecfd5a9df2$var$containerStyles = null;
const $174893ecfd5a9df2$var$Container = /*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $ltgDR.default)([
            "_kqswh2mm _6rth1ejb"
        ])
    }, children);
});
const $174893ecfd5a9df2$var$spinnerBackdropStyles = null;
const $174893ecfd5a9df2$var$SpinnerBackdrop = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $ltgDR.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ])
    }, children);
const $174893ecfd5a9df2$var$spinnerContainerStyles = null;
const $174893ecfd5a9df2$var$SpinnerContainer = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        ref: ref,
        className: (0, $ltgDR.default)([
            "_kqswh2mm _152tidpf"
        ])
    }, children));
class $174893ecfd5a9df2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    static #_ = this.defaultProps = {
        isLoading: true,
        spinnerSize: 'large',
        contentsOpacity: "var(--ds-opacity-loading, 0.2)",
        loadingLabel: 'Loading table'
    };
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this$spinnerRef, _this$containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($174893ecfd5a9df2$var$Container, {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($174893ecfd5a9df2$var$SpinnerBackdrop, {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($174893ecfd5a9df2$var$SpinnerContainer, {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});

parcelRegister("epeLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3dcb4663c181a56$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $iQDgs = parcelRequire("iQDgs");
class $d3dcb4663c181a56$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iQDgs.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("iQDgs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd5ba819a8d00c89$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");

var $4Vke2 = parcelRequire("4Vke2");

var $3I29D = parcelRequire("3I29D");

var $bB8Fv = parcelRequire("bB8Fv");

var $7fscZ = parcelRequire("7fscZ");
var $Cp2Ub = parcelRequire("Cp2Ub");

var $di2ow = parcelRequire("di2ow");

var $eqwm7 = parcelRequire("eqwm7");

var $60CMn = parcelRequire("60CMn");

var $9mN40 = parcelRequire("9mN40");

var $eKajE = parcelRequire("eKajE");
const $cd5ba819a8d00c89$var$styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const $cd5ba819a8d00c89$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: undefined,
    packageVersion: undefined
};
function $cd5ba819a8d00c89$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($3I29D))) : (0, (/*@__PURE__*/$parcel$interopDefault($bB8Fv)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        as: "span",
        xcss: $cd5ba819a8d00c89$var$styles.navigatorIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(Chevron, {
        label: "",
        color: "currentColor",
        size: "small"
    }));
}
function $cd5ba819a8d00c89$var$InnerPagination({ components: components = (0, $9mN40.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $9mN40.emptyObject), max: max = 7, onChange: onChange = (0, $c1tmZ.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $60CMn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $4Vke2.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$cd5ba819a8d00c89$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
            as: "li",
            xcss: $cd5ba819a8d00c89$var$styles.paginationMenuItem,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eqwm7.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $di2ow.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($cd5ba819a8d00c89$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $Cp2Ub.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $cd5ba819a8d00c89$var$styles.paginationMenu
    }, (0, $eKajE.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $di2ow.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($cd5ba819a8d00c89$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $cd5ba819a8d00c89$var$Pagination = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)($cd5ba819a8d00c89$var$InnerPagination));
var $cd5ba819a8d00c89$export$2e2bcd8739ae039 = $cd5ba819a8d00c89$var$Pagination;

});
parcelRegister("3I29D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b3726fdf579493c$var$_react = $2b3726fdf579493c$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $2b3726fdf579493c$var$_baseNew = $2b3726fdf579493c$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $2b3726fdf579493c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b3726fdf579493c$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2b3726fdf579493c$var$_react.default.createElement($2b3726fdf579493c$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$2b3726fdf579493c$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $2b3726fdf579493c$var$_default = module.exports.default = $2b3726fdf579493c$var$ChevronLeftIcon;

});

parcelRegister("di2ow", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fd9a8a031ea99f9$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lszf6 = parcelRequire("lszf6");
function $0fd9a8a031ea99f9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("eqwm7", function(module, exports) {
$parcel$export(module.exports, "default", () => $df5b87aec69041fa$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $lszf6 = parcelRequire("lszf6");
function $df5b87aec69041fa$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("60CMn", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6944faef7eaf5f1$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $7fscZ = parcelRequire("7fscZ");
var $ekURY = parcelRequire("ekURY");

var $gFdUI = parcelRequire("gFdUI");
const $f6944faef7eaf5f1$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $f6944faef7eaf5f1$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $f6944faef7eaf5f1$var$styles.container,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ekURY.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gFdUI.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("9mN40", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $9c23946bd9ee687e$export$3f860eba1218f8d3);
const $9c23946bd9ee687e$export$3f860eba1218f8d3 = {};

});

parcelRegister("eKajE", function(module, exports) {
$parcel$export(module.exports, "default", () => $30bbbfca6ff5e66d$export$2e2bcd8739ae039);

var $jE04u = parcelRequire("jE04u");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $30bbbfca6ff5e66d$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $jE04u.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $30bbbfca6ff5e66d$export$2e2bcd8739ae039 = $30bbbfca6ff5e66d$var$collapseRange;

});



parcelRegister("boVbX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33d91914a2469ac$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $hLBfB = parcelRequire("hLBfB");

var $l1chH = parcelRequire("l1chH");

var $8yTzT = parcelRequire("8yTzT");

var $fcyho = parcelRequire("fcyho");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a33d91914a2469ac$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $hLBfB.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $hLBfB.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $8yTzT.default) : (0, $fcyho.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $l1chH.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("tr", null, cells.map((cell, index)=>{
            const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            const headCellId = `head-cell-${index}`;
            const handleClick = ()=>{
                this.setState({
                    activeSortButtonId: headCellId
                });
                if (isSortable) onSort(cell)();
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isIconOnlyHeader: isIconOnlyHeader,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                headCellId: headCellId,
                activeSortButtonId: activeSortButtonId,
                onClick: handleClick,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ascendingSortTooltip: ascendingSortTooltip,
                descendingSortTooltip: descendingSortTooltip,
                buttonAriaRoleDescription: buttonAriaRoleDescription,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a33d91914a2469ac$export$2e2bcd8739ae039 = $a33d91914a2469ac$var$TableHead;

});
parcelRegister("l1chH", function(module, exports) {
$parcel$export(module.exports, "Head", () => $7551a706760ef42b$export$e93312b7773dfcac);
/* head.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
const $7551a706760ef42b$var$rankingStyles = null;
const $7551a706760ef42b$var$headStyles = null;
const $7551a706760ef42b$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ $4fqPo.createElement("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $ltgDR.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};

});

parcelRegister("8yTzT", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff7095811e94451c$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $enMAo = parcelRequire("enMAo");

var $9gk5X = parcelRequire("9gk5X");

var $fcyho = parcelRequire("fcyho");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $ff7095811e94451c$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $9gk5X.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fcyho.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $ff7095811e94451c$var$RankableTableHeadCell = (0, $enMAo.default)($ff7095811e94451c$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ff7095811e94451c$export$2e2bcd8739ae039 = $ff7095811e94451c$var$RankableTableHeadCell;

});
parcelRegister("enMAo", function(module, exports) {
$parcel$export(module.exports, "default", () => $cac121fc391385a4$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
function $cac121fc391385a4$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("9gk5X", function(module, exports) {
$parcel$export(module.exports, "inlineStylesIfRanking", () => $845f3c3e47b61056$export$a601f1775e10043f);
const $845f3c3e47b61056$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};

});

parcelRegister("fcyho", function(module, exports) {
$parcel$export(module.exports, "default", () => $51724770aba19419$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @atlaskit/design-system/no-physical-properties */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $dptnr = parcelRequire("dptnr");

var $cf3Ro = parcelRequire("cf3Ro");

var $7fscZ = parcelRequire("7fscZ");
var $2UMA8 = parcelRequire("2UMA8");
var $iqiKs = parcelRequire("iqiKs");

var $8Mj6h = parcelRequire("8Mj6h");

var $aJnTV = parcelRequire("aJnTV");
const $51724770aba19419$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $51724770aba19419$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06"
};
const $51724770aba19419$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $4fqPo.useState)(false);
    const [isFocused, setIsFocused] = (0, $4fqPo.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $4fqPo.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $4fqPo.useCallback)(()=>{
        setIsFocused === null || setIsFocused === void 0 || setIsFocused(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $4fqPo.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $4fqPo.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7fscZ.default), {
        xcss: $51724770aba19419$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: sortOrder === 'ASC' ? ascendingSortTooltip : descendingSortTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $iqiKs.default), {
        onClick: onClick,
        xcss: $51724770aba19419$var$styles.buttonWrapper,
        "aria-roledescription": buttonAriaRoleDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
        xcss: isVisibleIconOnlyHeader ? $51724770aba19419$var$styles.hideIconHeaderWrapper : $51724770aba19419$var$styles.visibleHeaderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        className: (0, $ltgDR.default)([
            $51724770aba19419$var$headCellStyles.text
        ])
    }, content)), shouldRenderSortIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2UMA8.default), {
        xcss: isSortIconVisible ? $51724770aba19419$var$styles.sortIconVisibleWrapper : $51724770aba19419$var$styles.sortIconHiddenWrapper
    }, sortOrder === 'ASC' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cf3Ro))), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        testId: testId && `${testId}--up--icon`
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dptnr))), {
        label: "",
        color: "var(--ds-text-subtle, #505258)",
        testId: testId && `${testId}--down--icon`
    })))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aJnTV.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder
    }, isSortable ? visuallyRefreshedButton : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$51724770aba19419$export$2e2bcd8739ae039 = $51724770aba19419$var$TableHeadCell;

});
parcelRegister("dptnr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c3465d33803da0b$var$_react = $9c3465d33803da0b$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $9c3465d33803da0b$var$_baseNew = $9c3465d33803da0b$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $9c3465d33803da0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c3465d33803da0b$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $9c3465d33803da0b$var$_react.default.createElement($9c3465d33803da0b$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$9c3465d33803da0b$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $9c3465d33803da0b$var$_default = module.exports.default = $9c3465d33803da0b$var$ArrowDownIcon;

});

parcelRegister("aJnTV", function(module, exports) {
$parcel$export(module.exports, "HeadCell", () => $3bac1c339ed9b4ec$export$4e8024263ace498b);
/* head-cell.tsx generated by @compiled/babel-plugin v0.37.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");

var $gUBVe = parcelRequire("gUBVe");
const $3bac1c339ed9b4ec$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $3bac1c339ed9b4ec$var$overflowTruncateStyles = null;
const $3bac1c339ed9b4ec$var$truncationWidthStyles = null;
const $3bac1c339ed9b4ec$var$fixedSizeTruncateStyles = null;
const $3bac1c339ed9b4ec$var$cellStyles = null;
const $3bac1c339ed9b4ec$var$headCellBaseStyles = null;
const $3bac1c339ed9b4ec$export$4e8024263ace498b = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $gUBVe.getTruncationStyleVars)({
            width: width
        }),
        [$3bac1c339ed9b4ec$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === 'ASC';
    const isDESC = sortOrder === 'DESC';
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ $4fqPo.createElement(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $ltgDR.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ])
    }, children);
});

});




parcelRegister("e3vu5", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("55OMz"),
    $e46AW("9lL54"),
    $e46AW("ckhTv")
]).then(()=>parcelRequire('i8np2'));

});





parcelRegister("2cJ4Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f7b8633180ce8b2$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $7f7b8633180ce8b2$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    manageProjectsPageTitle: {
        defaultMessage: 'Projects',
        description: 'Help center manage projects page title',
        id: 'manage.projects.page.title'
    },
    manageProjectsPageTitleGalaxia: {
        defaultMessage: 'Spaces',
        description: 'Help center manage spaces page title',
        id: 'manage.projects.page.title-galaxia'
    },
    manageProjectsPageDescription: {
        defaultMessage: 'Manage your help content effectively by linking projects to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking projects to a help center</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.description'
    },
    manageProjectsPageDescriptionHelpHub: {
        defaultMessage: 'Manage spaces linked to your help center to organize help content and show customers only relevant resources.',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description.helphub'
    },
    manageProjectsPageDescriptionGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.description-galaxia'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHC: {
        defaultMessage: 'All the projects in your site are always linked to your default help center, the resources will always be available in help center portal sections, virtual service agent, search and recently used request forms. <link>Learn more about projects in help centers</link>',
        description: 'Help center manage projects page description',
        id: 'manage.projects.page.default.hc.description'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    manageProjectsPageDescriptionForDefaultHCGalaxia: {
        defaultMessage: 'Manage your help content effectively by linking spaces to your help center. This ensures that your customers only see relevant resources in the help center and search. <link>Find out more about linking spaces to a help center</link>',
        description: 'Help center manage spaces page description',
        id: 'manage.projects.page.default.hc.description-galaxia'
    },
    manageProjectPageToggleForDefaultLinking: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking'
    },
    manageProjectPageToggleForDefaultLinkingHelpHub: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default linking for help center',
        id: 'manage.projects.page.toggle.default.linking.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking for help center with Galaxia renaming',
        id: 'manage.projects.page.toggle.default.linking.galaxia.helphub'
    },
    manageProjectPageToggleForDefaultLinkingGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default linking',
        id: 'manage.projects.page.toggle.default.linking-galaxia'
    },
    linkedFilterLabel: {
        defaultMessage: 'Linked projects',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label'
    },
    linkedFilterLabelGalaxia: {
        defaultMessage: 'Linked spaces',
        description: 'Label for linked dropdown item',
        id: 'manage.projects.page.linked.dropdown.item.label-galaxia'
    },
    unlinkedFilterLabel: {
        defaultMessage: 'Unlinked projects',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label'
    },
    unlinkedFilterLabelGalaxia: {
        defaultMessage: 'Unlinked spaces',
        description: 'Label for unlinked dropdown item',
        id: 'manage.projects.page.unlinked.dropdown.item.label-galaxia'
    },
    searchProjectsPlaceholder: {
        defaultMessage: 'Search for projects',
        description: 'Placeholder for search projects input',
        id: 'manage.projects.page.search.placeholder'
    },
    searchProjectsPlaceholderGalaxia: {
        defaultMessage: 'Search for spaces',
        description: 'Placeholder for search spaces input',
        id: 'manage.projects.page.search.placeholder-galaxia'
    },
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'manage.projects.page.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'manage.projects.page.error.description'
    }
});

});

parcelRegister("vjfYn", function(module, exports) {
$parcel$export(module.exports, "ProjectsList", () => (parcelRequire("5YsGl")).default);

var $5YsGl = parcelRequire("5YsGl");

});
parcelRegister("5YsGl", function(module, exports) {
$parcel$export(module.exports, "default", () => $514585b707a348dc$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $gBYjj = parcelRequire("gBYjj");

var $60aWe = parcelRequire("60aWe");
var $514585b707a348dc$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, {
    showErrorFlag: $gBYjj.showErrorFlag,
    showSuccessFlag: $gBYjj.showSuccessFlag
})((0, $60aWe.default));

});
parcelRegister("60aWe", function(module, exports) {
$parcel$export(module.exports, "default", () => $b35270c8d550748d$export$2e2bcd8739ae039);

var $aejpx = parcelRequire("aejpx");

var $4fqPo = parcelRequire("4fqPo");

var $8SJrF = parcelRequire("8SJrF");

var $2E0h7 = parcelRequire("2E0h7");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");
parcelRequire("l8iRu");
var $bdubZ = parcelRequire("bdubZ");

var $ew3Bn = parcelRequire("ew3Bn");

var $aHUNw = parcelRequire("aHUNw");

var $f0SW5 = parcelRequire("f0SW5");

var $1FmaX = parcelRequire("1FmaX");

var $2bLkU = parcelRequire("2bLkU");

var $6bGmX = parcelRequire("6bGmX");

var $9qmTW = parcelRequire("9qmTW");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $54jwS = parcelRequire("54jwS");

var $hZWMk = parcelRequire("hZWMk");
parcelRequire("1pLlT");
var $bPJ4S = parcelRequire("bPJ4S");

var $jvwY8 = parcelRequire("jvwY8");
parcelRequire("7ep1T");
var $1kyW4 = parcelRequire("1kyW4");

var $61oHg = parcelRequire("61oHg");

var $iUHYA = parcelRequire("iUHYA");

var $1Ob1a = parcelRequire("1Ob1a");

var $g66KM = parcelRequire("g66KM");

var $hjKJ2 = parcelRequire("hjKJ2");

var $9AwYF = parcelRequire("9AwYF");
const $b35270c8d550748d$export$680c2e5e5eec1385 = 20;
const $b35270c8d550748d$var$messagesMap = {
    [(0, $iUHYA.ProjectsMappingOperations).LINK]: {
        [(0, $iUHYA.ProjectsMappingMode).BULK]: {
            successTitle: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).bulkLinkSuccessTitleGalaxia : (0, $61oHg.default).bulkLinkSuccessTitle,
            errorTitle: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).bulkLinkErrorTitleGalaxia : (0, $61oHg.default).bulkLinkErrorTitle
        },
        [(0, $iUHYA.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $61oHg.default).linkSuccessTitle,
            errorTitle: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).linkErrorTitleGalaxia : (0, $61oHg.default).linkErrorTitle
        }
    },
    [(0, $iUHYA.ProjectsMappingOperations).UNLINK]: {
        [(0, $iUHYA.ProjectsMappingMode).BULK]: {
            successTitle: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).bulkUnlinkSuccessTitleGalaxia : (0, $61oHg.default).bulkUnlinkSuccessTitle,
            errorTitle: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).bulkUnlinkErrorTitleGalaxia : (0, $61oHg.default).bulkUnlinkErrorTitle
        },
        [(0, $iUHYA.ProjectsMappingMode).SINGLE]: {
            successTitle: (0, $61oHg.default).unlinkSuccessTitle,
            errorTitle: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).unlinkErrorTitleGalaxia : (0, $61oHg.default).unlinkErrorTitle
        }
    }
};
const $b35270c8d550748d$var$ProjectsList = ({ projectsListFragmentKey: projectsListFragmentKey, searchQuery: searchQuery, selection: selection, isReadOnlyView: isReadOnlyView, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const [isChecked, setIsChecked] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const [isBulkActionLoading, setIsBulkActionLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const [selectedProjectsMap, setSelectedProjectsMap] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState({});
    const [modalVisibility, setModalVisibility] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState({
        [(0, $jvwY8.CANT_UNLINK_ALL_DIALOG)]: false,
        [(0, $jvwY8.UNLINK_CONFIRMATION_DIALOG)]: false
    });
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const data = (0, $gIeP2.useFragment)((0, $aejpx.default), projectsListFragmentKey);
    const { onLinkUnlinkProjects: onLinkUnlinkProjects } = (0, $bPJ4S.useProjectMapping)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const selectedProjectsCount = Object.values(selectedProjectsMap).filter(Boolean).length;
    const disableSingleProjectActions = selectedProjectsCount > 0;
    const projects = data.edges || [];
    const handleProjectMapping = (selectedProjectIds, operationType, mappingStatus)=>{
        const getProjectName = ()=>{
            var _projects$find;
            return (_projects$find = projects.find((project)=>{
                var _project$node;
                return (project === null || project === void 0 || (_project$node = project.node) === null || _project$node === void 0 ? void 0 : _project$node.projectId) === selectedProjectIds[0];
            })) === null || _projects$find === void 0 || (_projects$find = _projects$find.node) === null || _projects$find === void 0 ? void 0 : _projects$find.name;
        };
        const mode = selectedProjectIds.length > 1 ? (0, $iUHYA.ProjectsMappingMode).BULK : (0, $iUHYA.ProjectsMappingMode).SINGLE;
        setIsBulkActionLoading(true);
        onLinkUnlinkProjects(selectedProjectIds, operationType, mappingStatus).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length
            }).fire();
            resetBulkSelection();
            showSuccessFlagAction($b35270c8d550748d$var$messagesMap[operationType][mode].successTitle, mode === (0, $iUHYA.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : {
                number: selectedProjectIds.length
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            showErrorFlagAction($b35270c8d550748d$var$messagesMap[operationType][mode].errorTitle, (0, $61oHg.default).genericErrorDescription, [], mode === (0, $iUHYA.ProjectsMappingMode).SINGLE ? {
                projectName: getProjectName()
            } : undefined);
            if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: true,
                mapStatus: operationType,
                projectCount: selectedProjectIds.length,
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsBulkActionLoading(false);
            setModalVisibility({
                ...modalVisibility,
                [(0, $jvwY8.UNLINK_CONFIRMATION_DIALOG)]: false
            });
        });
    };
    const onBulkActionClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        const operation = selection === (0, $iUHYA.ProjectsMappingStatus).LINKED ? (0, $iUHYA.ProjectsMappingOperations).UNLINK : (0, $iUHYA.ProjectsMappingOperations).LINK;
        if (selectedProjectIds.length === 0) return;
        if (operation === (0, $iUHYA.ProjectsMappingOperations).UNLINK && selectedProjectIds.length === projects.length) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $jvwY8.CANT_UNLINK_ALL_DIALOG)]: true
            });
            return;
        }
        if (operation === (0, $iUHYA.ProjectsMappingOperations).UNLINK) {
            setModalVisibility({
                ...modalVisibility,
                [(0, $jvwY8.UNLINK_CONFIRMATION_DIALOG)]: true
            });
            return;
        }
        handleProjectMapping(selectedProjectIds, (0, $iUHYA.ProjectsMappingOperations).LINK, selection);
    };
    const onUnlinkDialogButtonClick = ()=>{
        const selectedProjectIds = Object.keys(selectedProjectsMap).filter((projectId)=>selectedProjectsMap[projectId]);
        setIsBulkActionLoading(true);
        handleProjectMapping(selectedProjectIds, (0, $iUHYA.ProjectsMappingOperations).UNLINK, selection);
    };
    const isIndeterminate = !!(selectedProjectsCount > 0 && selectedProjectsCount < projects.length);
    const filteredProjects = projects.filter((project)=>{
        var _project$node2;
        return project === null || project === void 0 || (_project$node2 = project.node) === null || _project$node2 === void 0 || (_project$node2 = _project$node2.name) === null || _project$node2 === void 0 ? void 0 : _project$node2.toLowerCase().includes(searchQuery.toLowerCase());
    });
    const resetBulkSelection = ()=>{
        setIsChecked(false);
        setSelectedProjectsMap({});
    };
    // whenever the selection changes, reset the selected projects
    (0, $4fqPo.useEffect)(()=>{
        resetBulkSelection();
    }, [
        selection
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // If all projects are selected one by one, check the select all checkbox
        if (selectedProjectsCount === filteredProjects.length) setIsChecked(true);
        // If all projects are unselected one by one, uncheck the select all checkbox
        if (selectedProjectsCount === 0) setIsChecked(false);
    }, [
        selectedProjectsCount,
        filteredProjects.length
    ]);
    const onChangeHandler = ()=>{
        const selectionMap = {};
        setSelectedProjectsMap(isChecked ? selectionMap : filteredProjects.reduce((acc, project)=>{
            var _project$node3, _project$node4;
            if (!(project !== null && project !== void 0 && (_project$node3 = project.node) !== null && _project$node3 !== void 0 && _project$node3.projectId)) return acc;
            acc[project === null || project === void 0 || (_project$node4 = project.node) === null || _project$node4 === void 0 ? void 0 : _project$node4.projectId] = true;
            return acc;
        }, selectionMap));
        setIsChecked(!isChecked);
    };
    const head = {
        cells: [
            ...isReadOnlyView ? [] : [
                {
                    key: 'select-all',
                    content: // eslint-disable-next-line @atlassian/a11y/role-supports-aria-props -- Disabling existing violation, should be fixed when revisited.
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f0SW5.default), {
                        "aria-checked": isChecked,
                        isChecked: isChecked,
                        isIndeterminate: isIndeterminate,
                        onChange: onChangeHandler,
                        "aria-label": (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).selectAllProjectsCheckboxLabelGalaxia) : formatMessage((0, $g66KM.default).selectAllProjectsCheckboxLabel),
                        name: "select-all-checkbox"
                    }),
                    width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['select-all']
                }
            ],
            {
                key: 'project-name',
                content: 'Project',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['project-name']
            },
            {
                key: 'lead-name',
                content: 'Lead',
                shouldTruncate: true,
                isSortable: !isChecked ? true : undefined,
                width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['lead-name']
            },
            ...isReadOnlyView ? [] : [
                {
                    key: 'status',
                    content: 'Status',
                    width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH).status
                },
                {
                    key: 'action-button',
                    content: 'Actions',
                    width: (0, $jvwY8.MANAGE_PROJECT_HEAD_WIDTH)['action-button']
                }
            ]
        ]
    };
    const toggleProjectSelect = (projectId)=>{
        setSelectedProjectsMap((prevState)=>({
                ...prevState,
                [projectId]: !prevState[projectId]
            }));
    };
    const rows = filteredProjects.map((project)=>{
        var _project$node5, _project$node6, _project$node7, _project$node8, _project$node0, _project$node1, _project$node10, _project$node11, _project$node12, _project$node13, _project$node14, _project$node15, _project$node16, _project$node17, _project$node18, _project$node19;
        return {
            key: (project === null || project === void 0 || (_project$node5 = project.node) === null || _project$node5 === void 0 ? void 0 : _project$node5.projectId) || (project === null || project === void 0 || (_project$node6 = project.node) === null || _project$node6 === void 0 ? void 0 : _project$node6.name),
            isHighlighted: selectedProjectsMap[(project === null || project === void 0 || (_project$node7 = project.node) === null || _project$node7 === void 0 ? void 0 : _project$node7.projectId) || ''],
            cells: [
                ...isReadOnlyView ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f0SW5.default), {
                            isChecked: !!selectedProjectsMap[(project === null || project === void 0 || (_project$node8 = project.node) === null || _project$node8 === void 0 ? void 0 : _project$node8.projectId) || ''],
                            onChange: ()=>{
                                var _project$node9;
                                return toggleProjectSelect((project === null || project === void 0 || (_project$node9 = project.node) === null || _project$node9 === void 0 ? void 0 : _project$node9.projectId) || '');
                            },
                            name: "select-checkbox",
                            "aria-label": (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).selectProjectCheckboxLabelGalaxia) : formatMessage((0, $g66KM.default).selectProjectCheckboxLabel)
                        })
                    }
                ],
                {
                    key: project === null || project === void 0 || (_project$node0 = project.node) === null || _project$node0 === void 0 ? void 0 : _project$node0.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bdubZ.default), {
                        target: "_blank",
                        href: (project === null || project === void 0 || (_project$node1 = project.node) === null || _project$node1 === void 0 ? void 0 : _project$node1.webUrl) || '#'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050",
                        paddingInlineEnd: "space.100"
                    }, (project === null || project === void 0 || (_project$node10 = project.node) === null || _project$node10 === void 0 || (_project$node10 = _project$node10.avatar) === null || _project$node10 === void 0 ? void 0 : _project$node10.small) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aHUNw.default), {
                        size: "small",
                        appearance: "square",
                        src: project === null || project === void 0 || (_project$node11 = project.node) === null || _project$node11 === void 0 || (_project$node11 = _project$node11.avatar) === null || _project$node11 === void 0 ? void 0 : _project$node11.small,
                        name: project === null || project === void 0 || (_project$node12 = project.node) === null || _project$node12 === void 0 || (_project$node12 = _project$node12.avatar) === null || _project$node12 === void 0 ? void 0 : _project$node12.small
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, project === null || project === void 0 || (_project$node13 = project.node) === null || _project$node13 === void 0 ? void 0 : _project$node13.name)))
                },
                {
                    key: project === null || project === void 0 || (_project$node14 = project.node) === null || _project$node14 === void 0 || (_project$node14 = _project$node14.lead) === null || _project$node14 === void 0 ? void 0 : _project$node14.name,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                        paddingInlineEnd: "space.100"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $aHUNw.default), {
                        size: "small",
                        appearance: "circle",
                        src: project === null || project === void 0 || (_project$node15 = project.node) === null || _project$node15 === void 0 || (_project$node15 = _project$node15.lead) === null || _project$node15 === void 0 ? void 0 : _project$node15.picture,
                        name: project === null || project === void 0 || (_project$node16 = project.node) === null || _project$node16 === void 0 || (_project$node16 = _project$node16.lead) === null || _project$node16 === void 0 ? void 0 : _project$node16.picture
                    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, project === null || project === void 0 || (_project$node17 = project.node) === null || _project$node17 === void 0 || (_project$node17 = _project$node17.lead) === null || _project$node17 === void 0 ? void 0 : _project$node17.name))
                },
                ...isReadOnlyView ? [] : [
                    {
                        content: selection === (0, $iUHYA.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), {
                            appearance: "success"
                        }, formatMessage((0, $g66KM.default).projectsListLinkedLozengeLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9qmTW.default), null, formatMessage((0, $g66KM.default).projectsListUnlinkedLozengeLabel))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1kyW4.default), {
                            isDisabled: disableSingleProjectActions,
                            projectId: (project === null || project === void 0 || (_project$node18 = project.node) === null || _project$node18 === void 0 ? void 0 : _project$node18.projectId) || '',
                            projectName: (project === null || project === void 0 || (_project$node19 = project.node) === null || _project$node19 === void 0 ? void 0 : _project$node19.name) || '',
                            selection: selection,
                            isLastProject: projects.length === 1,
                            onLinkUnlinkProjects: onLinkUnlinkProjects
                        })
                    }
                ]
            ]
        };
    });
    // If user searches for a project that doesn't exist
    if (rows.length === 0 && searchQuery.trim() !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bLkU.default), {
        header: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).projectsListEmptySearchTitleGalaxia) : formatMessage((0, $g66KM.default).projectsListEmptySearchTitle),
        description: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).projectsListEmptySearchDescriptionGalaxia) : formatMessage((0, $g66KM.default).projectsListEmptySearchDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($2E0h7)))
    });
    // If no projects are linked to the help center and the user is in the linked tab
    if (rows.length === 0 && selection === (0, $iUHYA.ProjectsMappingStatus).LINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bLkU.default), {
        header: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).noLinkedProjectsTitleGalaxia) : formatMessage((0, $g66KM.default).noLinkedProjectsTitle),
        description: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).noLinkedProjectsDescriptionGalaxia) : formatMessage((0, $g66KM.default).noLinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8SJrF)))
    });
    // If no projects are linked to the help center and the user is in the unlinked tab
    if (rows.length === 0 && selection === (0, $iUHYA.ProjectsMappingStatus).UNLINKED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bLkU.default), {
        header: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).noUnlinkedProjectsTitleGalaxia) : formatMessage((0, $g66KM.default).noUnlinkedProjectsTitle),
        description: (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $g66KM.default).noUnlinkedProjectsDescriptionGalaxia) : formatMessage((0, $g66KM.default).noUnlinkedProjectsDescription),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8SJrF)))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $b35270c8d550748d$var$tableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1Ob1a.BulkActionToolbar), {
        selectedProjectsCount: selectedProjectsCount,
        selection: selection,
        onBulkActionClick: onBulkActionClick,
        isLoading: isBulkActionLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1FmaX.default), {
        head: head,
        rows: rows,
        rowsPerPage: $b35270c8d550748d$export$680c2e5e5eec1385,
        defaultPage: 1,
        isFixedSize: true,
        defaultSortKey: "project-name",
        defaultSortOrder: "ASC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9AwYF.UnlinkConfirmationModal), {
        isOpen: modalVisibility[0, $jvwY8.UNLINK_CONFIRMATION_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $jvwY8.UNLINK_CONFIRMATION_DIALOG)]: false
            }),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: modalVisibility[0, $jvwY8.UNLINK_CONFIRMATION_DIALOG] && isBulkActionLoading,
        numberOfProjects: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hjKJ2.UnlinkAllProjectsWarningModal), {
        isOpen: modalVisibility[0, $jvwY8.CANT_UNLINK_ALL_DIALOG],
        onClose: ()=>setModalVisibility({
                ...modalVisibility,
                [(0, $jvwY8.CANT_UNLINK_ALL_DIALOG)]: false
            })
    }));
};
const $b35270c8d550748d$var$tableStyles = (0, $2m8U6.xcss)({
    position: 'relative',
    // @ts-expect-error @atlaskit/ui-styling-standard/no-nested-selectors
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    th: {
        height: '100%',
        verticalAlign: 'middle'
    },
    marginBottom: 'space.100'
});
var $b35270c8d550748d$export$2e2bcd8739ae039 = $b35270c8d550748d$var$ProjectsList;

});
parcelRegister("aejpx", function(module, exports) {
$parcel$export(module.exports, "default", () => $473da35064bf85a1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7a4a61aea1d2ec868b83ec14a0afe25a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $473da35064bf85a1$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectsListFragment",
        "selections": [
            {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "projectId"
                            },
                            {
                                "concreteType": "JiraAvatar",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "small"
                                    }
                                ]
                            },
                            {
                                "kind": "LinkedField",
                                "name": "lead",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "picture"
                                    }
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "webUrl"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProjectConnection"
    };
}();
$473da35064bf85a1$var$node.hash = "3eeb7301918e0096af7f6ae5ad2df33f";
var $473da35064bf85a1$export$2e2bcd8739ae039 = $473da35064bf85a1$var$node;

});

parcelRegister("8SJrF", function(module, exports) {
module.exports = new URL("../images/project-mapping-empty.93914303.svg", import.meta.url).toString();

});

parcelRegister("2E0h7", function(module, exports) {
module.exports = new URL("../images/project-mapping-search-no-match.507a41ed.svg", import.meta.url).toString();

});

parcelRegister("1pLlT", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => (parcelRequire("bPJ4S")).useProjectMapping);

var $bPJ4S = parcelRequire("bPJ4S");

});
parcelRegister("bPJ4S", function(module, exports) {
$parcel$export(module.exports, "useProjectMapping", () => $e436bcd1eee7813b$export$79a4e4154c8382d5);

var $cQiEu = parcelRequire("cQiEu");

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $6mmHn = parcelRequire("6mmHn");

var $gIeP2 = parcelRequire("gIeP2");

var $gjCVU = parcelRequire("gjCVU");
const $e436bcd1eee7813b$export$79a4e4154c8382d5 = ()=>{
    const cloudId = (0, $6mmHn.getCloudId)();
    const helpCenterAri = (0, $gjCVU.useHelpCenterAri)();
    const [linkUnlinkProject] = (0, $gIeP2.useMutation)((0, $cQiEu.default));
    const removeSelectedProjects = (0, $4fqPo.useCallback)((store, selection, projectIds)=>{
        var _root$getLinkedRecord;
        const root = store.getRoot();
        const connection = root === null || root === void 0 || (_root$getLinkedRecord = root.getLinkedRecord('jira')) === null || _root$getLinkedRecord === void 0 ? void 0 : _root$getLinkedRecord.getLinkedRecord('jiraProjectsMappedToHelpCenter', {
            cloudId: (0, $6mmHn.getCloudId)(),
            filter: {
                helpCenterId: '',
                helpCenterARI: helpCenterAri,
                helpCenterMappingStatus: selection
            }
        });
        if (connection) {
            const connectionEdges = connection === null || connection === void 0 ? void 0 : connection.getLinkedRecords('edges');
            if (connectionEdges) {
                const newEdges = connectionEdges.filter((edge)=>{
                    var _edge$getLinkedRecord;
                    return !projectIds.includes(edge === null || edge === void 0 || (_edge$getLinkedRecord = edge.getLinkedRecord('node')) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getValue('projectId'));
                });
                connection === null || connection === void 0 || connection.setLinkedRecords(newEdges, 'edges');
            }
        }
        root.invalidateRecord();
    }, [
        helpCenterAri
    ]);
    const onLinkUnlinkProjects = (projectIds, operationType, selection)=>{
        return new Promise((resolve, reject)=>linkUnlinkProject({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        projectIds: projectIds,
                        operationType: operationType
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) removeSelectedProjects(store, selection, projectIds);
                },
                onCompleted: (response)=>{
                    var _response$helpCenter2, _response$helpCenter3, _error$extensions;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.updateProjectMapping) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $748yq.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    };
    return {
        onLinkUnlinkProjects: onLinkUnlinkProjects
    };
};

});
parcelRegister("cQiEu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc8d44e40afc4efd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<230b086af7211b5fc150b7f52ae6b010>>
 * @relayHash db52eedba06b2bb692fa79d38cecc6eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f
const $cc8d44e40afc4efd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProjectMappingLinkUnlinkMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterProjectMappingUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateProjectMapping",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a1ad194610b482240ddd6de134b99a55a5501781bc737bc73c504fe19c65f83f",
            "metadata": {},
            "name": "useProjectMappingLinkUnlinkMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$cc8d44e40afc4efd$var$node.hash = "90453dabffd73b96361b3ab3d4d31c32";
var $cc8d44e40afc4efd$export$2e2bcd8739ae039 = $cc8d44e40afc4efd$var$node;

});



parcelRegister("7ep1T", function(module, exports) {
$parcel$export(module.exports, "LinkUnlinkProject", () => (parcelRequire("1kyW4")).default);

var $1kyW4 = parcelRequire("1kyW4");

});
parcelRegister("1kyW4", function(module, exports) {
$parcel$export(module.exports, "default", () => $c45dfafba1137cde$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $gBYjj = parcelRequire("gBYjj");

var $9ywTl = parcelRequire("9ywTl");
var $c45dfafba1137cde$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, {
    showErrorFlag: $gBYjj.showErrorFlag,
    showSuccessFlag: $gBYjj.showSuccessFlag
})((0, $9ywTl.default));

});
parcelRegister("9ywTl", function(module, exports) {
$parcel$export(module.exports, "default", () => $43fcd94dc9daaeff$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $dQegt = parcelRequire("dQegt");

var $ew3Bn = parcelRequire("ew3Bn");

var $6bGmX = parcelRequire("6bGmX");

var $6hIdA = parcelRequire("6hIdA");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $hDp3n = parcelRequire("hDp3n");

var $cz6zo = parcelRequire("cz6zo");
var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");

var $WVSzu = parcelRequire("WVSzu");

var $hZWMk = parcelRequire("hZWMk");

var $9AwYF = parcelRequire("9AwYF");

var $iUHYA = parcelRequire("iUHYA");

var $61oHg = parcelRequire("61oHg");
const $43fcd94dc9daaeff$var$LinkUnlinkProject = ({ projectId: projectId, projectName: projectName, selection: selection, isLastProject: isLastProject, isDisabled: isDisabled, onLinkUnlinkProjects: onLinkUnlinkProjects, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const [openUnlinkDialog, setOpenUnlinkDialog] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const [isUnlinking, setIsUnlinking] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const [isLinking, setIsLinking] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const [isLastUnlink, setIsLastUnlink] = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useState(false);
    const onLinkProject = (0, $4fqPo.useCallback)(()=>{
        setIsLinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $iUHYA.ProjectsMappingOperations).LINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                operation: 'single',
                bulkOperation: false,
                mapStatus: (0, $iUHYA.ProjectsMappingOperations).LINK,
                projectCount: 1
            }).fire();
            showSuccessFlagAction((0, $61oHg.default).linkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $iUHYA.ProjectsMappingOperations).LINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            showErrorFlagAction((0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).linkErrorTitleGalaxia : (0, $61oHg.default).linkErrorTitle, (0, $61oHg.default).genericErrorDescription, [], {
                projectName: projectName
            });
        }).finally(()=>{
            setIsLinking(false);
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        selection,
        showSuccessFlagAction,
        projectName,
        showErrorFlagAction,
        createAnalyticsEvent
    ]);
    const onUnLinkProject = (0, $4fqPo.useCallback)(()=>{
        if (isLastProject) setIsLastUnlink(true);
        else setOpenUnlinkDialog(true);
    }, [
        isLastProject
    ]);
    const onUnlinkDialogButtonClick = (0, $4fqPo.useCallback)(()=>{
        setIsUnlinking(true);
        onLinkUnlinkProjects([
            projectId
        ], (0, $iUHYA.ProjectsMappingOperations).UNLINK, selection).then(()=>{
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $iUHYA.ProjectsMappingOperations).UNLINK,
                projectCount: 1
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showSuccessFlagAction((0, $61oHg.default).unlinkSuccessTitle, {
                projectName: projectName
            });
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'project',
                bulkOperation: false,
                mapStatus: (0, $iUHYA.ProjectsMappingOperations).UNLINK,
                projectCount: 1,
                errorMessage: message,
                errorStatus: status
            }).fire();
            setIsUnlinking(false);
            setOpenUnlinkDialog(false);
            showErrorFlagAction((0, $6bGmX.default).checkGate('itsm-project-renaming') ? (0, $61oHg.default).unlinkErrorTitleGalaxia : (0, $61oHg.default).unlinkErrorTitle, (0, $61oHg.default).genericErrorDescription, [], {
                projectName: projectName
            });
        });
    }, [
        onLinkUnlinkProjects,
        projectId,
        projectName,
        selection,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent
    ]);
    const contentCallback = (0, $4fqPo.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
            sourceType: (0, $gHT3x.INLINE_DIALOG),
            sourceName: "lastProjectUnlink"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $43fcd94dc9daaeff$var$unlinkDialogPopupStyles
        }, (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $61oHg.default).lastProjectUnlinkGalaxia) : formatMessage((0, $61oHg.default).lastProjectUnlink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
    }, [
        formatMessage
    ]);
    const triggerCallback = (0, $4fqPo.useCallback)((triggerProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.LoadingButton), {
            ...triggerProps,
            appearance: "link",
            actionSubjectId: "projectUnLink",
            onClick: onUnLinkProject,
            isLoading: isLinking,
            isDisabled: isDisabled
        }, formatMessage((0, $61oHg.default).projectsListUnlinkButtonText));
    }, [
        formatMessage,
        isLinking,
        onUnLinkProject,
        isDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, selection === (0, $iUHYA.ProjectsMappingStatus).LINKED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6hIdA.default), {
        isOpen: isLastUnlink,
        onClose: ()=>setIsLastUnlink(false),
        placement: "bottom-end",
        zIndex: (0, $hDp3n.layers).modal(),
        content: contentCallback,
        trigger: triggerCallback
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.LoadingButton), {
        actionSubjectId: "projectLink",
        appearance: "link",
        onClick: onLinkProject,
        isLoading: isLinking,
        isDisabled: isDisabled
    }, formatMessage((0, $61oHg.default).projectsListLinkButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9AwYF.UnlinkConfirmationModal), {
        isOpen: openUnlinkDialog,
        onClose: ()=>setOpenUnlinkDialog(false),
        onUnlink: onUnlinkDialogButtonClick,
        isLoading: isUnlinking,
        numberOfProjects: 1
    }));
};
const $43fcd94dc9daaeff$var$unlinkDialogPopupStyles = (0, $2m8U6.xcss)({
    maxWidth: '230px',
    padding: 'space.200'
});
var $43fcd94dc9daaeff$export$2e2bcd8739ae039 = $43fcd94dc9daaeff$var$LinkUnlinkProject;

});
parcelRegister("9AwYF", function(module, exports) {
$parcel$export(module.exports, "UnlinkConfirmationModal", () => $bcede99f4a4e8f6c$export$42f5f02e8155f94);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $dQegt = parcelRequire("dQegt");

var $6bGmX = parcelRequire("6bGmX");

var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $isBvF = parcelRequire("isBvF");
var $6zx4f = parcelRequire("6zx4f");
var $kCZZw = parcelRequire("kCZZw");

var $bjGAo = parcelRequire("bjGAo");
const $bcede99f4a4e8f6c$export$42f5f02e8155f94 = ({ isOpen: isOpen, onClose: onClose, onUnlink: onUnlink, isLoading: isLoading, projectName: projectName, numberOfProjects: numberOfProjects })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    let modalTitle;
    let modalDescription;
    if (numberOfProjects > 1) {
        modalTitle = (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $bjGAo.default).bulkUnlinkModalTitleGalaxia, {
            number: numberOfProjects
        }) : formatMessage((0, $bjGAo.default).bulkUnlinkModalTitle, {
            number: numberOfProjects
        });
        modalDescription = (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $bjGAo.default).bulkUnlinkModalDescGalaxia) : formatMessage((0, $bjGAo.default).bulkUnlinkModalDesc);
    } else {
        modalTitle = (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $bjGAo.default).unlinkModalTitleGalaxia) : formatMessage((0, $bjGAo.default).unlinkModalTitle);
        modalDescription = (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $bjGAo.default).unlinkModalDescGalaxia, {
            projectName: projectName
        }) : formatMessage((0, $bjGAo.default).unlinkModalDesc, {
            projectName: projectName
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $isBvF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6zx4f.default), {
        appearance: "warning",
        testId: "help-center-unlink-modal-title"
    }, modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, modalDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.LoadingButton), {
        onClick: onUnlink,
        isLoading: isLoading,
        appearance: "warning",
        actionSubjectId: "unlinkModalConfirmButton",
        testId: "unlink-modal-confirm-button"
    }, formatMessage((0, $bjGAo.default).unlinkModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.Button), {
        onClick: onClose,
        appearance: "subtle",
        actionSubjectId: "unlinkModalCancelButton"
    }, formatMessage((0, $bjGAo.default).unlinkModalCancelButton)))));
};

});
parcelRegister("bjGAo", function(module, exports) {
$parcel$export(module.exports, "default", () => $24818cb5597bc29f$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $24818cb5597bc29f$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    unlinkModalTitle: {
        defaultMessage: 'Unlink this project?',
        description: 'Unlink project confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title'
    },
    unlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink this space?',
        description: 'Unlink space confirmation modal title',
        id: 'projects.list.unlink.confirmation.modal.title-galaxia'
    },
    unlinkModalDesc: {
        defaultMessage: `All help resources from the project {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description'
    },
    unlinkModalDescGalaxia: {
        defaultMessage: `All help resources from the space {projectName} will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description',
        id: 'projects.list.unlink.confirmation.modal.description-galaxia'
    },
    bulkUnlinkModalTitle: {
        defaultMessage: 'Unlink {number} projects?',
        description: 'Unlink project confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title'
    },
    bulkUnlinkModalTitleGalaxia: {
        defaultMessage: 'Unlink {number} spaces?',
        description: 'Unlink space confirmation modal title in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.title-galaxia'
    },
    bulkUnlinkModalDesc: {
        defaultMessage: `All help resources from these projects will be removed from the help center and will not show up in search.`,
        description: 'Unlink project confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description'
    },
    bulkUnlinkModalDescGalaxia: {
        defaultMessage: `All help resources from these spaces will be removed from the help center and will not show up in search.`,
        description: 'Unlink space confirmation modal description in case of bulk unlinking',
        id: 'projects.list.bulk.unlink.confirmation.modal.description-galaxia'
    },
    unlinkModalConfirmButton: {
        defaultMessage: 'Unlink',
        description: 'Unlink project confirmation modal confirm button',
        id: 'projects.list.unlink.confirmation.modal.confirm.button'
    },
    unlinkModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'Unlink project confirmation modal cancel button',
        id: 'projects.list.unlink.confirmation.modal.cancel.button'
    }
});

});


parcelRegister("iUHYA", function(module, exports) {
$parcel$export(module.exports, "ProjectsMappingStatus", () => $7d2106d67a94a6f6$export$eaf9dd2a52d05588);
$parcel$export(module.exports, "ProjectsMappingMode", () => $7d2106d67a94a6f6$export$6998efd89043b35d);
$parcel$export(module.exports, "ProjectsMappingOperations", () => $7d2106d67a94a6f6$export$d0c0bb49dfced741);
var $7d2106d67a94a6f6$export$eaf9dd2a52d05588 = /*#__PURE__*/ function(ProjectsMappingStatus) {
    ProjectsMappingStatus["UNLINKED"] = "UNLINKED";
    ProjectsMappingStatus["LINKED"] = "LINKED";
    ProjectsMappingStatus["ALL"] = "ALL";
    return ProjectsMappingStatus;
}({});
var $7d2106d67a94a6f6$export$6998efd89043b35d = /*#__PURE__*/ function(ProjectsMappingMode) {
    ProjectsMappingMode["BULK"] = "bulk";
    ProjectsMappingMode["SINGLE"] = "single";
    return ProjectsMappingMode;
}({});
var $7d2106d67a94a6f6$export$d0c0bb49dfced741 = /*#__PURE__*/ function(ProjectsMappingOperations) {
    ProjectsMappingOperations["UNLINK"] = "UNMAP_PROJECTS";
    ProjectsMappingOperations["LINK"] = "MAP_PROJECTS";
    return ProjectsMappingOperations;
}({});

});

parcelRegister("61oHg", function(module, exports) {
$parcel$export(module.exports, "default", () => $68d8c7bfb7eb63df$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $68d8c7bfb7eb63df$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.link.unlink.button.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.link.unlink.button.unlink.button.text'
    },
    unlinkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is no longer linked to this help center",
        description: 'Unlink space flag success title',
        id: 'projects.link.unlink.button.unlink.flag.success.title'
    },
    linkSuccessTitle: {
        defaultMessage: "\u2019{projectName}\u2019 is now linked to this help center",
        description: 'Link space flag success title',
        id: 'projects.link.unlink.button.link.flag.success.title'
    },
    bulkLinkSuccessTitle: {
        defaultMessage: '{number} projects are now linked to this help center',
        description: 'Bulk link project flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title'
    },
    bulkLinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces are now linked to this help center',
        description: 'Bulk link space flag success title',
        id: 'projects.link.unlink.button.bulk.link.flag.success.title-galaxia'
    },
    bulkLinkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the selected projects",
        description: 'Bulk link project flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title'
    },
    bulkLinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the selected spaces",
        description: 'Bulk link space flag error title',
        id: 'projects.link.unlink.button.bulk.link.flag.error.title-galaxia'
    },
    bulkUnlinkSuccessTitle: {
        defaultMessage: '{number} projects have been unlinked from this help center',
        description: 'Bulk unlink projects flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title'
    },
    bulkUnlinkSuccessTitleGalaxia: {
        defaultMessage: '{number} spaces have been unlinked from this help center',
        description: 'Bulk unlink spaces flag success title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.success.title-galaxia'
    },
    bulkUnlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the selected projects",
        description: 'Bulk unlink projects flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title'
    },
    bulkUnlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the selected spaces",
        description: 'Bulk unlink spaces flag error title',
        id: 'projects.link.unlink.button.bulk.unlink.flag.error.title-galaxia'
    },
    unlinkErrorTitle: {
        defaultMessage: "We couldn\u2019t unlink the projects \u2018{projectName}\u2019",
        description: 'Unlink project flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title'
    },
    unlinkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t unlink the spaces \u2018{projectName}\u2019",
        description: 'Unlink space flag error title',
        id: 'projects.link.unlink.button.unlink.flag.error.title-galaxia'
    },
    linkErrorTitle: {
        defaultMessage: "We couldn\u2019t link the project \u2019{projectName}\u2019",
        description: 'Link project flag error title',
        id: 'projects.link.unlink.button.link.flag.error.title'
    },
    linkErrorTitleGalaxia: {
        defaultMessage: "We couldn\u2019t link the space \u2018{projectName}\u2019",
        description: 'Link space flag error title',
        id: 'projects.link.unlink.button.link.flag.error.title-galaxia'
    },
    genericErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Unlink project flag error description',
        id: 'projects.link.unlink.button.flag.generic.error.description'
    },
    lastProjectUnlink: {
        defaultMessage: 'Your help center needs at least one linked project to ensure that your customers can access relevant information and resources.',
        description: 'Last project unlink project dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content'
    },
    lastProjectUnlinkGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space to ensure that your customers can access relevant information and resources.',
        description: 'Last space unlink space dialog message',
        id: 'projects.link.unlink.button.unlink.last.project.dialog.content-galaxia'
    }
});

});




parcelRegister("1Ob1a", function(module, exports) {
$parcel$export(module.exports, "BulkActionToolbar", () => $d748fda189273dcd$export$522b8308f1751ff5);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $dQegt = parcelRequire("dQegt");

var $lifUD = parcelRequire("lifUD");

var $7TPEx = parcelRequire("7TPEx");
var $2m8U6 = parcelRequire("2m8U6");

var $iUHYA = parcelRequire("iUHYA");

var $g66KM = parcelRequire("g66KM");

var $9EjHl = parcelRequire("9EjHl");
const $d748fda189273dcd$export$522b8308f1751ff5 = ({ selectedProjectsCount: selectedProjectsCount, selection: selection, onBulkActionClick: onBulkActionClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const isVisible = selectedProjectsCount > 0;
    const toolbarAccessibilityLabelMessage = isVisible ? formatMessage((0, $9EjHl.default).toolbarAccessibilityLabel) : '';
    const buttonText = selection === (0, $iUHYA.ProjectsMappingStatus).LINKED ? formatMessage((0, $g66KM.default).projectsListUnlinkButtonText) : formatMessage((0, $g66KM.default).projectsListLinkButtonText);
    const actionSubjectId = selection === (0, $iUHYA.ProjectsMappingStatus).LINKED ? 'bulkActionUnLinkButton' : 'bulkActionLinkButton';
    return isVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $d748fda189273dcd$var$bulkActionToolbarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        as: "span",
        xcss: $d748fda189273dcd$var$projectsCountTextStyles,
        role: "status"
    }, formatMessage((0, $9EjHl.default).selectedProjectsText, {
        count: selectedProjectsCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $d748fda189273dcd$var$invisibleA11yTitleStyles,
        tabIndex: -1
    }, toolbarAccessibilityLabelMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.LoadingButton), {
        testId: "bulk-action-button",
        actionSubjectId: actionSubjectId,
        onClick: onBulkActionClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lifUD))), {
            label: buttonText,
            size: "small",
            spacing: "spacious"
        }),
        isLoading: isLoading,
        spacing: "compact"
    }, buttonText));
};
const $d748fda189273dcd$var$bulkActionToolbarContainerStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    width: '96%',
    top: 'space.0',
    left: '4%',
    backgroundColor: 'elevation.surface',
    zIndex: 'layer',
    color: 'color.text.subtle',
    paddingBlock: 'space.050',
    paddingInline: 'space.0',
    margin: 'space.0'
});
const $d748fda189273dcd$var$projectsCountTextStyles = (0, $2m8U6.xcss)({
    paddingRight: 'space.200'
});
const $d748fda189273dcd$var$invisibleA11yTitleStyles = (0, $2m8U6.xcss)({
    opacity: 0,
    position: 'absolute'
});

});
parcelRegister("lifUD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae3bff1d1955acd002e5417a314968c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f8079f4def301dae$var$_react = $f8079f4def301dae$var$_interopRequireDefault((parcelRequire("4fqPo")));

var $f8079f4def301dae$var$_baseNew = $f8079f4def301dae$var$_interopRequireDefault((parcelRequire("4yxM4")));
function $f8079f4def301dae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f8079f4def301dae$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $f8079f4def301dae$var$_react.default.createElement($f8079f4def301dae$var$_baseNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$f8079f4def301dae$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $f8079f4def301dae$var$_default = module.exports.default = $f8079f4def301dae$var$LinkBrokenIcon;

});

parcelRegister("g66KM", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8b04d76bcf0d1c3$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $a8b04d76bcf0d1c3$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    projectsListLinkedLozengeLabel: {
        defaultMessage: 'Linked',
        description: 'Projects list linked lozenge label',
        id: 'projects.list.linked.lozenge.label'
    },
    projectsListUnlinkedLozengeLabel: {
        defaultMessage: 'Unlinked',
        description: 'Projects list unlinked lozenge label',
        id: 'projects.list.unlinked.lozenge.label'
    },
    projectsListLinkButtonText: {
        defaultMessage: 'Link',
        description: 'Projects list link button text',
        id: 'projects.list.link.button.text'
    },
    projectsListUnlinkButtonText: {
        defaultMessage: 'Unlink',
        description: 'Projects list unlink button text',
        id: 'projects.list.unlink.button.text'
    },
    noUnlinkedProjectsDescription: {
        defaultMessage: "When you unlink projects, they\u2019ll appear here.",
        description: 'Projects list empty state description',
        id: 'projects.list.empty.description'
    },
    noUnlinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you unlink spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description',
        id: 'projects.list.empty.description-galaxia'
    },
    noUnlinkedProjectsTitle: {
        defaultMessage: 'All your projects are linked to this help center',
        description: 'Projects list empty state title',
        id: 'projects.list.empty.title'
    },
    noUnlinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces are linked to this help center',
        description: 'Spaces list empty state title',
        id: 'projects.list.empty.title-galaxia'
    },
    noLinkedProjectsDescription: {
        defaultMessage: "When you link projects, they\u2019ll appear here.",
        description: 'Projects list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab'
    },
    noLinkedProjectsDescriptionGalaxia: {
        defaultMessage: "When you link spaces, they\u2019ll appear here.",
        description: 'Spaces list empty state description on linked tab',
        id: 'projects.list.empty.description.linked.tab-galaxia'
    },
    noLinkedProjectsTitle: {
        defaultMessage: 'All your projects have been unlinked from this help center',
        description: 'Projects list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab'
    },
    noLinkedProjectsTitleGalaxia: {
        defaultMessage: 'All your spaces have been unlinked from this help center',
        description: 'Spaces list empty state title on linked tab',
        id: 'projects.list.empty.title.linked.tab-galaxia'
    },
    projectsListEmptySearchTitle: {
        defaultMessage: 'No projects found matching your search',
        description: 'Projects list empty search title',
        id: 'projects.list.empty.search.title'
    },
    projectsListEmptySearchTitleGalaxia: {
        defaultMessage: 'No spaces found matching your search',
        description: 'Spaces list empty search title',
        id: 'projects.list.empty.search.title-galaxia'
    },
    projectsListEmptySearchDescription: {
        defaultMessage: 'Try using specific project names or terms',
        description: 'Projects list empty search description',
        id: 'projects.list.empty.search.description'
    },
    projectsListEmptySearchDescriptionGalaxia: {
        defaultMessage: 'Try using specific space names or terms',
        description: 'Spaces list empty search description',
        id: 'projects.list.empty.search.description-galaxia'
    },
    selectAllProjectsCheckboxLabel: {
        defaultMessage: 'Select all projects',
        description: 'Checkbox label for selecting all projects',
        id: 'projects.list.select-all.projects.checkbox.label'
    },
    selectAllProjectsCheckboxLabelGalaxia: {
        defaultMessage: 'Select all spaces',
        description: 'Checkbox label for selecting all spaces',
        id: 'projects.list.select-all.projects.checkbox.label-galaxia'
    },
    selectProjectCheckboxLabel: {
        defaultMessage: 'Select project',
        description: 'Checkbox label for selecting a single project',
        id: 'projects.list.select.project.checkbox.label'
    },
    selectProjectCheckboxLabelGalaxia: {
        defaultMessage: 'Select space',
        description: 'Checkbox label for selecting a single space',
        id: 'projects.list.select.project.checkbox.label-galaxia'
    },
    columnHeaderSpace: {
        defaultMessage: 'Space',
        description: 'Spaces list column header space',
        id: 'spaces.list.column.header.space-galaxia'
    },
    columnHeaderLead: {
        defaultMessage: 'Lead',
        description: 'Spaces list column header lead',
        id: 'spaces.list.column.header.lead'
    },
    columnHeaderStatus: {
        defaultMessage: 'Status',
        description: 'Spaces list column header status',
        id: 'spaces.list.column.header.status'
    },
    columnHeaderActions: {
        defaultMessage: 'Actions',
        description: 'Spaces list column header actions',
        id: 'spaces.list.column.header.actions'
    }
});

});

parcelRegister("9EjHl", function(module, exports) {
$parcel$export(module.exports, "default", () => $4dbb3bb09565be3d$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $4dbb3bb09565be3d$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    selectedProjectsText: {
        defaultMessage: '{count, plural, one {1 selected} other { # selected}}',
        description: 'Text for displaying selected projects count',
        id: 'projects-list.bulk-action-toolbar.selected-spaces-text'
    },
    toolbarAccessibilityLabel: {
        defaultMessage: 'Actions for selected items are available before the table.',
        description: 'Accessibility label for the toolbar',
        id: 'projects-list.bulk-action-toolbar.toolbar-accessibility-label'
    }
});

});


parcelRegister("hjKJ2", function(module, exports) {
$parcel$export(module.exports, "UnlinkAllProjectsWarningModal", () => $51fc9b8e11ba9962$export$b442637e98a0429b);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $dQegt = parcelRequire("dQegt");

var $6bGmX = parcelRequire("6bGmX");

var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $isBvF = parcelRequire("isBvF");
var $6zx4f = parcelRequire("6zx4f");
var $kCZZw = parcelRequire("kCZZw");

var $cz6zo = parcelRequire("cz6zo");
var $gHT3x = parcelRequire("gHT3x");

var $WVSzu = parcelRequire("WVSzu");

var $1NM09 = parcelRequire("1NM09");
const $51fc9b8e11ba9962$export$b442637e98a0429b = ({ isOpen: isOpen, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceType: (0, $gHT3x.MODAL),
        sourceName: "helpCenterUnlinkAllWarning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
        width: "small",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $isBvF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6zx4f.default), {
        testId: "help-center-unlink-all-projects-warning-modal-title"
    }, (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $1NM09.default).unlinkAllWarningModalTitleGalaxia) : formatMessage((0, $1NM09.default).unlinkAllWarningModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, (0, $6bGmX.default).checkGate('itsm-project-renaming') ? formatMessage((0, $1NM09.default).unlinkAllWarningModalDescriptionGalaxia) : formatMessage((0, $1NM09.default).unlinkAllWarningModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.Button), {
        onClick: onClose,
        appearance: "primary",
        actionSubjectId: "unlinkAllWarningModalOkButton"
    }, formatMessage((0, $1NM09.default).unlinkAllWarningModalOkButton))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
};

});
parcelRegister("1NM09", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f9b95aacaff3241$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $4f9b95aacaff3241$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    unlinkAllWarningModalTitle: {
        defaultMessage: 'Your help center needs at least one linked project',
        description: 'Title of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.title'
    },
    unlinkAllWarningModalTitleGalaxia: {
        defaultMessage: 'Your help center needs at least one linked space',
        description: 'Title of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.title-galaxia'
    },
    unlinkAllWarningModalDescription: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one project needs to be linked to your help center. Uncheck a project and try again.',
        description: 'Description of the unlink all projects warning modal',
        id: 'projects.list.unlink.all.warning.modal.description'
    },
    unlinkAllWarningModalDescriptionGalaxia: {
        defaultMessage: 'To ensure that your customers can access relevant information and resources, at least one space needs to be linked to your help center. Uncheck a space and try again.',
        description: 'Description of the unlink all spaces warning modal',
        id: 'projects.list.unlink.all.warning.modal.description-galaxia'
    },
    unlinkAllWarningModalOkButton: {
        defaultMessage: 'OK',
        description: 'Unlink all projects warning modal ok button',
        id: 'projects.list.unlink.all.warning.modal.ok.button'
    }
});

});





parcelRegister("5ZlgL", function(module, exports) {
$parcel$export(module.exports, "SyncProjectsToggle", () => (parcelRequire("eYbEH")).default);

var $eYbEH = parcelRequire("eYbEH");

});
parcelRegister("eYbEH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c9246a6a586e272$export$2e2bcd8739ae039);
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $gBYjj = parcelRequire("gBYjj");

var $jDhb6 = parcelRequire("jDhb6");
var $1c9246a6a586e272$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, {
    showErrorFlag: $gBYjj.showErrorFlag,
    showSuccessFlag: $gBYjj.showSuccessFlag
})((0, $jDhb6.default));

});
parcelRegister("jDhb6", function(module, exports) {
$parcel$export(module.exports, "default", () => $693101930648316f$export$2e2bcd8739ae039);

var $3uzYB = parcelRequire("3uzYB");

var $8UVhj = parcelRequire("8UVhj");

var $4fqPo = parcelRequire("4fqPo");

var $6mmHn = parcelRequire("6mmHn");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");

var $ew3Bn = parcelRequire("ew3Bn");

var $lszf6 = parcelRequire("lszf6");
var $fn6af = parcelRequire("fn6af");

var $6bGmX = parcelRequire("6bGmX");

var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $isBvF = parcelRequire("isBvF");
var $6zx4f = parcelRequire("6zx4f");
var $kCZZw = parcelRequire("kCZZw");

var $gTy5C = parcelRequire("gTy5C");

var $54jwS = parcelRequire("54jwS");

var $hZWMk = parcelRequire("hZWMk");

var $doQp2 = parcelRequire("doQp2");

var $gjCVU = parcelRequire("gjCVU");

var $39aG9 = parcelRequire("39aG9");
const $693101930648316f$var$SyncProjectsToggle = ({ syncProjectsToggleFragmentKey: syncProjectsToggleFragmentKey, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    var _helpCenterData$proje;
    const helpCenterData = (0, $gIeP2.useFragment)((0, $8UVhj.default), syncProjectsToggleFragmentKey);
    const [isChecked, setIsChecked] = (0, $4fqPo.useState)(!!(helpCenterData !== null && helpCenterData !== void 0 && (_helpCenterData$proje = helpCenterData.projectMappingData) !== null && _helpCenterData$proje !== void 0 && _helpCenterData$proje.syncNewProjects));
    const [isRemoveMappingDialogOpen, setRemoveMappingDialogOpen] = (0, $4fqPo.useState)(false);
    const [isUnSyncing, setIsUnSyncing] = (0, $4fqPo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const helpCenterAri = (0, $gjCVU.useHelpCenterAri)();
    const { isHelpHub: isHelpHub } = (0, $doQp2.useHelpCenterType)();
    const isProjectRenamingEnabled = (0, $6bGmX.default).checkGate('itsm-project-renaming');
    let toggleLabel;
    if (isHelpHub && isProjectRenamingEnabled) toggleLabel = (0, $39aG9.default).defaultMappingToggleLabelGalaxiaHelpHub;
    else if (isHelpHub) toggleLabel = (0, $39aG9.default).defaultMappingToggleLabelHelpHub;
    else if (isProjectRenamingEnabled) toggleLabel = (0, $39aG9.default).defaultMappingToggleLabelGalaxia;
    else toggleLabel = (0, $39aG9.default).defaultMappingToggleLabel;
    const [toggleDefaultSync] = (0, $gIeP2.useMutation)((0, $3uzYB.default));
    const onToggleDefault = (0, $4fqPo.useCallback)((syncNewProjects)=>{
        return new Promise((resolve, reject)=>toggleDefaultSync({
                variables: {
                    cloudId: (0, $6mmHn.getCloudId)(),
                    input: {
                        syncNewProjects: syncNewProjects,
                        helpCenterAri: helpCenterAri
                    }
                },
                onCompleted: (response)=>{
                    var _response$helpCenter, _response$helpCenter2;
                    if ((_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.updateProjectMapping) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) resolve(response);
                    const errors = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.updateProjectMapping) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.errors;
                    const error = errors && errors.length > 0 ? errors[0] : new Error('Unknown error');
                    return reject(error);
                },
                onError: (error)=>{
                    reject(error);
                }
            }));
    }, [
        toggleDefaultSync,
        helpCenterAri
    ]);
    const onToggleChange = (0, $4fqPo.useCallback)(()=>{
        if (isChecked) setRemoveMappingDialogOpen(true);
        else {
            setIsChecked(true);
            onToggleDefault(true).then(()=>{
                createAnalyticsEvent({
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    action: 'map',
                    actionSubject: 'newProjects',
                    toggleState: true
                }).fire();
            }).catch((error)=>{
                const { message: message, status: status } = error;
                setIsChecked(false);
                const errorTitle = isProjectRenamingEnabled ? (0, $39aG9.default).syncErrorTitleGalaxia : (0, $39aG9.default).syncErrorTitle;
                showErrorFlagAction(errorTitle, (0, $39aG9.default).syncErrorDescription);
                if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    action: 'map_failed',
                    actionSubject: 'newProjects',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
            });
        }
    }, [
        isChecked,
        onToggleDefault,
        showErrorFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const onUnMapNewProjects = (0, $4fqPo.useCallback)(()=>{
        setIsUnSyncing(true);
        onToggleDefault(false).then(()=>{
            setIsChecked(false);
            const successTitle = isProjectRenamingEnabled ? (0, $39aG9.default).unSyncSuccessTitleGalaxia : (0, $39aG9.default).unSyncSuccessTitle;
            showSuccessFlagAction(successTitle);
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map',
                actionSubject: 'newProjects',
                toggleState: false
            }).fire();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            const errorTitle = isProjectRenamingEnabled ? (0, $39aG9.default).syncErrorTitleGalaxia : (0, $39aG9.default).syncErrorTitle;
            showErrorFlagAction(errorTitle, (0, $39aG9.default).syncErrorDescription);
            if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'map_failed',
                actionSubject: 'newProjects',
                errorMessage: message,
                errorStatus: status
            }).fire();
        }).finally(()=>{
            setIsUnSyncing(false);
            setRemoveMappingDialogOpen(false);
        });
    }, [
        onToggleDefault,
        showErrorFlagAction,
        showSuccessFlagAction,
        createAnalyticsEvent,
        isProjectRenamingEnabled
    ]);
    const modalTitle = isProjectRenamingEnabled ? (0, $39aG9.default).removeMappingModalTitleGalaxia : (0, $39aG9.default).removeMappingModalTitle;
    const modalDesc = isProjectRenamingEnabled ? (0, $39aG9.default).removeMappingModalDescGalaxia : (0, $39aG9.default).removeMappingModalDesc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gTy5C.default), {
        label: formatMessage(toggleLabel),
        isChecked: isChecked,
        onChange: onToggleChange
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, isRemoveMappingDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
        width: "small",
        onClose: ()=>setRemoveMappingDialogOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $isBvF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6zx4f.default), {
        testId: "help-center-UnSync-modal-title"
    }, formatMessage(modalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, formatMessage(modalDesc)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fn6af.default), {
        onClick: onUnMapNewProjects,
        isLoading: isUnSyncing,
        appearance: "primary",
        testId: "help-center-modal-unSync-button"
    }, formatMessage((0, $39aG9.default).removeMappingModalConfirmButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        onClick: ()=>setRemoveMappingDialogOpen(false),
        appearance: "subtle"
    }, formatMessage((0, $39aG9.default).removeMappingModalCancelButton))))));
};
var $693101930648316f$export$2e2bcd8739ae039 = $693101930648316f$var$SyncProjectsToggle;

});
parcelRegister("3uzYB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1beaf59de5e2a10$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3ec556de9df1e0dfa8527df888279ca>>
 * @relayHash f6ad0a674b4deb767396c24696d6bb4a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d
const $e1beaf59de5e2a10$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterProjectMappingUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateProjectMapping",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "syncProjectsToggleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "da8c746423a9772dac447f2fdbad8fd4ca55ac3024e4850bb499f3e66949b60d",
            "metadata": {},
            "name": "syncProjectsToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$e1beaf59de5e2a10$var$node.hash = "f63e31632e8452ce88ba847207c9b4ff";
var $e1beaf59de5e2a10$export$2e2bcd8739ae039 = $e1beaf59de5e2a10$var$node;

});

parcelRegister("8UVhj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b7ca0f7a4072936$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<40debfdc71cc42750e08210b725892e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9b7ca0f7a4072936$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "syncProjectsToggleFragment",
    "selections": [
        {
            "concreteType": "HelpCenterProjectMappingData",
            "kind": "LinkedField",
            "name": "projectMappingData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "syncNewProjects"
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$9b7ca0f7a4072936$var$node.hash = "b09d61797a2afad5be65329bfb50cc92";
var $9b7ca0f7a4072936$export$2e2bcd8739ae039 = $9b7ca0f7a4072936$var$node;

});

parcelRegister("gTy5C", function(module, exports) {
$parcel$export(module.exports, "default", () => $91dd5022bdcfae5c$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $4EOcq = parcelRequire("4EOcq");

var $c1tmZ = parcelRequire("c1tmZ");

var $a4Rr2 = parcelRequire("a4Rr2");

var $5T5mg = parcelRequire("5T5mg");

var $9RW5e = parcelRequire("9RW5e");

var $5qWT2 = parcelRequire("5qWT2");

var $gFdUI = parcelRequire("gFdUI");

var $fWDLI = parcelRequire("fWDLI");
const $91dd5022bdcfae5c$var$LOADING_LABEL = ', Loading';
const $91dd5022bdcfae5c$var$baseStyles = null;
const $91dd5022bdcfae5c$var$sizeStyles = {
    regular: "_2rko1rr0 _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf",
    large: "_2rko1rr0 _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz"
};
/**
 * Slider knob translate transforms per size, applied when checked.
 */ const $91dd5022bdcfae5c$var$checkedSliderStyles = {
    regular: "_7dwz1fbe",
    large: "_7dwzw12q"
};
/**
 * Applied when the toggle is checked
 */ const $91dd5022bdcfae5c$var$checkedStyles = null;
/**
 * Applied when the toggle is checked and not disabled.
 */ const $91dd5022bdcfae5c$var$checkedHoveredStyles = null;
/**
 * Applied when the toggle is unchecked and not disabled.
 */ const $91dd5022bdcfae5c$var$uncheckedHoveredStyles = null;
/**
 * Applied when the toggle is disabled.
 */ const $91dd5022bdcfae5c$var$disabledStyles = null;
const $91dd5022bdcfae5c$var$inputStyles = null;
const $91dd5022bdcfae5c$var$noop = (0, $c1tmZ.default);
const $91dd5022bdcfae5c$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $91dd5022bdcfae5c$var$Toggle = /*#__PURE__*/ (0, $4fqPo.memo)(/*#__PURE__*/ (0, $4fqPo.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $91dd5022bdcfae5c$var$noop, onChange: providedChange = $91dd5022bdcfae5c$var$noop, onFocus: providedFocus = $91dd5022bdcfae5c$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, isLoading: isLoading, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $4fqPo.useState)(defaultChecked);
    const loadingLabelId = (0, $a4Rr2.useId)();
    const handleBlur = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$91dd5022bdcfae5c$var$analyticsAttributes
    });
    const handleFocus = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$91dd5022bdcfae5c$var$analyticsAttributes
    });
    const handleChange = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$91dd5022bdcfae5c$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const labelId = (0, $a4Rr2.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("label", {
        "data-testid": testId,
        className: (0, $ltgDR.default)([
            "_1h6d1j28 _1dqonqa1 _189e1dm9 _1e0c1o8l _vchh1ntv _kqswh2mm _1y1m1ntv _bfhk1aqn _syaz5w2r _80omtlke _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1oeci9qs _k8m01e03 _6fl4574g _rfx31qll _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _1cg6i9qs _qs2z1e03 _mlfe574g _1ys41v1w _ju3ddkaa _16rslghj _i5ec1w7i",
            $91dd5022bdcfae5c$var$sizeStyles[size],
            shouldChecked && "_bfhkkcmj",
            shouldChecked && $91dd5022bdcfae5c$var$checkedSliderStyles[size],
            !isDisabled && shouldChecked && "_irr3y7x8",
            !isDisabled && !shouldChecked && "_irr31ibz",
            isDisabled && "_bfhk187o _syaz2sac _80om13gf"
        ])
    }, label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("span", {
        id: labelId,
        hidden: true
    }, isLoading ? `${label}${$91dd5022bdcfae5c$var$LOADING_LABEL}` : label) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": isLoading && label ? `${labelId} ${loadingLabelId}` : label ? labelId : undefined,
        "aria-describedby": descriptionId,
        className: (0, $ltgDR.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _tzy4idpf _nt751snc _49pcagmp _1hvw10yn"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fWDLI.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, isLoading && shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5T5mg))), {
        label: "",
        color: "currentColor",
        testId: testId && `${testId}--toggle-check-icon`,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fWDLI.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, isLoading && !shouldChecked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), {
        size: "xsmall",
        appearance: "invert"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
        label: "",
        color: "currentColor",
        testId: testId && `${testId}--toggle-cross-icon`,
        size: "small"
    })), isLoading && !label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gFdUI.default), {
        id: loadingLabelId
    }, $91dd5022bdcfae5c$var$LOADING_LABEL));
}));
$91dd5022bdcfae5c$var$Toggle.displayName = 'Toggle';
var $91dd5022bdcfae5c$export$2e2bcd8739ae039 = $91dd5022bdcfae5c$var$Toggle;

});
parcelRegister("fWDLI", function(module, exports) {
$parcel$export(module.exports, "default", () => $308cecfb65d1ff2c$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.37.1 */ /* icon-container.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $fxmw9 = parcelRequire("fxmw9");

var $7fscZ = parcelRequire("7fscZ");
const $308cecfb65d1ff2c$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $308cecfb65d1ff2c$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $7fscZ.default), {
        as: "span",
        xcss: (0, $fxmw9.cx)($308cecfb65d1ff2c$var$styles.iconContainer, isHidden && $308cecfb65d1ff2c$var$styles.hidden, size === 'regular' && $308cecfb65d1ff2c$var$styles.iconContainerRegular, size === 'large' && $308cecfb65d1ff2c$var$styles.iconContainerLarge, position === 'left' && $308cecfb65d1ff2c$var$styles.left, position === 'right' && $308cecfb65d1ff2c$var$styles.right)
    }, children);
};
var $308cecfb65d1ff2c$export$2e2bcd8739ae039 = $308cecfb65d1ff2c$var$IconContainer;

});


parcelRegister("39aG9", function(module, exports) {
$parcel$export(module.exports, "default", () => $3badf184f0697c4f$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $3badf184f0697c4f$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    defaultMappingToggleLabel: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label'
    },
    defaultMappingToggleLabelHelpHub: {
        defaultMessage: 'Link all new projects to this help center',
        description: 'Toggle label for default mapping for help center',
        id: 'sync.project.toggle.label.helphub'
    },
    defaultMappingToggleLabelGalaxiaHelpHub: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping for help center with Galaxia renaming',
        id: 'sync.project.toggle.label.galaxia.helphub'
    },
    defaultMappingToggleLabelGalaxia: {
        defaultMessage: 'Link all new spaces to this help center',
        description: 'Toggle label for default mapping',
        id: 'sync.project.toggle.label-galaxia'
    },
    removeMappingModalTitle: {
        defaultMessage: 'Stop linking new projects to this help center?',
        description: 'removeMapping modal title',
        id: 'sync.project.toggle.removeMapping.modal.title'
    },
    removeMappingModalTitleGalaxia: {
        defaultMessage: 'Stop linking new spaces to this help center?',
        description: 'removeMapping modal title',
        id: 'sync.project.toggle.removeMapping.modal.title-galaxia'
    },
    removeMappingModalDesc: {
        defaultMessage: 'Help resources from new projects will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description'
    },
    removeMappingModalDescGalaxia: {
        defaultMessage: 'Help resources from new spaces will not show up in this help center or search.',
        description: 'removeMapping modal description',
        id: 'sync.project.toggle.removeMapping.modal.description-galaxia'
    },
    removeMappingModalConfirmButton: {
        defaultMessage: 'Continue',
        description: 'removeMapping modal confirm button',
        id: 'sync.project.toggle.removeMapping.modal.confirm'
    },
    removeMappingModalCancelButton: {
        defaultMessage: 'Cancel',
        description: 'removeMapping modal cancel button',
        id: 'sync.project.toggle.removeMapping.modal.cancel'
    },
    syncErrorTitle: {
        defaultMessage: "We couldn't turn off automatic linking of new projects",
        description: 'Sync new projects flag error title',
        id: 'sync.project.toggle.sync.flag.error.title'
    },
    syncErrorTitleGalaxia: {
        defaultMessage: "We couldn't turn off automatic linking of new spaces",
        description: 'Sync new spaces flag error title',
        id: 'sync.project.toggle.sync.flag.error.title-galaxia'
    },
    syncErrorDescription: {
        defaultMessage: 'Refresh the page and try again.',
        description: 'Sync new projects flag error description',
        id: 'sync.project.toggle.sync.flag.error.description'
    },
    unSyncSuccessTitle: {
        defaultMessage: 'Automatic linking of new projects turned off',
        description: 'Sync new projects flag success title',
        id: 'sync.project.toggle.sync.flag.success.title'
    },
    unSyncSuccessTitleGalaxia: {
        defaultMessage: 'Automatic linking of new spaces turned off',
        description: 'Sync new spaces flag success title',
        id: 'sync.project.toggle.sync.flag.success.title-galaxia'
    }
});

});






parcelRegister("40zlN", function(module, exports) {
$parcel$export(module.exports, "HelpCenterManagePages", () => $6f6225d20abc07ea$export$ede7df3d2ca0e51e);

var $4fqPo = parcelRequire("4fqPo");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

var $7hsFm = parcelRequire("7hsFm");
parcelRequire("hdYRg");
var $1g7Go = parcelRequire("1g7Go");

var $kv2VD = parcelRequire("kv2VD");
parcelRequire("9X1v0");
var $2wXtk = parcelRequire("2wXtk");

const $6f6225d20abc07ea$var$AsyncHelpCenterManagePagesComponent = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("k8WUQ")), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/manage-pages.tsx"
    }),
    LoadingSkeleton: (0, $2wXtk.default)
});
const $6f6225d20abc07ea$export$ede7df3d2ca0e51e = ()=>{
    (0, $7hsFm.useUFOComponentExperience)((0, $kv2VD.managePagesExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1g7Go.default), {
        featureName: "Helpcenter manage pages"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($6f6225d20abc07ea$var$AsyncHelpCenterManagePagesComponent, null));
};

});
parcelRegister("kv2VD", function(module, exports) {
$parcel$export(module.exports, "managePagesExperience", () => $bfbd2326847fb6bd$export$5b30dfd9ef11a3c5);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $bfbd2326847fb6bd$export$5b30dfd9ef11a3c5 = new (0, $3odV5.UFOExperience)((0, $hWlSg.managePagesExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("9X1v0", function(module, exports) {
$parcel$export(module.exports, "ManagePagesLayoutSkeleton", () => (parcelRequire("2wXtk")).default);

var $2wXtk = parcelRequire("2wXtk");

});
parcelRegister("2wXtk", function(module, exports) {
$parcel$export(module.exports, "default", () => $83b48b082502f5f3$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $j4lpV = parcelRequire("j4lpV");

var $1FmaX = parcelRequire("1FmaX");

var $7TPEx = parcelRequire("7TPEx");
var $9Ix81 = parcelRequire("9Ix81");
var $4hIeL = parcelRequire("4hIeL");
var $2m8U6 = parcelRequire("2m8U6");

var $jvwY8 = parcelRequire("jvwY8");
const $83b48b082502f5f3$var$ManagePagesLayoutSkeleton = ()=>{
    const head = {
        cells: [
            {
                key: 'page-name',
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PAGE_HEAD_WIDTH)['page-name']
            },
            {
                key: 'last-updated',
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "20%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PAGE_HEAD_WIDTH)['last-updated']
            },
            {
                key: 'page-description',
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PAGE_HEAD_WIDTH)['page-description']
            },
            {
                key: 'action-button',
                content: /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                    width: "40%",
                    height: "16px"
                }),
                width: (0, $jvwY8.MANAGE_PAGE_HEAD_WIDTH)['action-button']
            }
        ]
    };
    const rows = Array.from({
        length: 20
    }).map((_, index)=>({
            key: `${index}`,
            cells: [
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "60%",
                        height: "20px"
                    }))
                },
                {
                    content: /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
                        paddingBlock: "space.050"
                    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
                        width: "20%",
                        height: "20px"
                    }))
                }
            ]
        }));
    return /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.300"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.300"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "84px",
        height: "24px"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-title-skeleton"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "92px",
        height: "28px",
        "data-testid": "manage-page-create-button-skeleton"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.050"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "75%",
        height: "20px"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        xcss: $83b48b082502f5f3$var$tableSkeletonStyles
    }, /*#__PURE__*/ $4fqPo.createElement((0, $1FmaX.default), {
        head: head,
        rows: rows,
        isFixedSize: true,
        isRankingDisabled: true
    })));
};
const $83b48b082502f5f3$var$tableSkeletonStyles = (0, $2m8U6.xcss)({
    pointerEvents: 'none'
});
var $83b48b082502f5f3$export$2e2bcd8739ae039 = $83b48b082502f5f3$var$ManagePagesLayoutSkeleton;

});


parcelRegister("k8WUQ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("auN5u"),
    $e46AW("ixH4T"),
    $e46AW("d2mFO"),
    $e46AW("bsqOj")
]).then(()=>parcelRequire('9DUKh'));

});




parcelRegister("1AvvJ", function(module, exports) {
$parcel$export(module.exports, "HelpCenterRovoServiceAgentResource", () => $26eaa87c101b79b2$export$edd09dd027b459f5);

var $6mmHn = parcelRequire("6mmHn");

var $fZppw = parcelRequire("fZppw");

var $kOVZG = parcelRequire("kOVZG");

var $xCN5m = parcelRequire("xCN5m");
const $26eaa87c101b79b2$export$edd09dd027b459f5 = (0, $fZppw.createRelayResource)({
    type: 'HELP_ROVO_SERVICE_AGENT_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        const activationId = (0, $6mmHn.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const computedHelpCenterAri = (0, $kOVZG.createHelpCenterAri)(activationId, helpCenterId);
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $xCN5m.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("xCN5m", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ed8fec5f525f00$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2026eb7695890747f87168577d7f7d36>>
 * @relayHash e8ae7ab32189fb155478d43e63c3f190
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b
const $e0ed8fec5f525f00$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "helpCenterAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isCustomAgentsAvailable"
            },
            {
                "concreteType": "AtlassianStudioUserProductPermissions",
                "kind": "LinkedField",
                "name": "userPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isAbleToCreateAgents"
                    }
                ]
            }
        ],
        "type": "AtlassianStudioUserSiteContextOutput"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsBreadcrumbsFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "srcRovoServiceAgentSettingsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "default"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "atlassianStudio_userSiteContext",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "605ef65572a5abbbf5a61bcac5330982df32ad73dab92698f3cc3988c80b611b",
            "metadata": {},
            "name": "srcRovoServiceAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e0ed8fec5f525f00$var$node.hash = "31b851fb2037198c36030d97e7f1d665";
var $e0ed8fec5f525f00$export$2e2bcd8739ae039 = $e0ed8fec5f525f00$var$node;

});


parcelRegister("jd4xn", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("iQNpA"),
    $e46AW("367yc"),
    $e46AW("8a0Af")
]).then(()=>parcelRequire('kjnuk'));

});


parcelRegister("8tPCL", function(module, exports) {
$parcel$export(module.exports, "helpcenterEditRoute", () => $5133afa5f6e88b2c$export$8c1389d3983434c);
$parcel$export(module.exports, "helpcenterManageProjectsRoute", () => $5133afa5f6e88b2c$export$5fae61522b3dcb33);
$parcel$export(module.exports, "helpcenterManageCustomPagesRoute", () => $5133afa5f6e88b2c$export$d1e5a4952efbcb);
$parcel$export(module.exports, "hubEditLayoutRoute", () => $5133afa5f6e88b2c$export$8f54556241df66cd);
$parcel$export(module.exports, "hubEditPortalLayoutRoute", () => $5133afa5f6e88b2c$export$b97f195684a7c2a4);

var $4fqPo = parcelRequire("4fqPo");

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");

var $jSFJf = parcelRequire("jSFJf");

var $5qWT2 = parcelRequire("5qWT2");

var $lcaDO = parcelRequire("lcaDO");

const $5133afa5f6e88b2c$var$AsyncHelpCenterEditDetailsPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>Promise.resolve((parcelRequire("cYYPV"))).then(({ HelpCenterEditDetails: HelpCenterEditDetails })=>HelpCenterEditDetails), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/edit-helpcenter/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $5133afa5f6e88b2c$var$AsyncHelpCenterManageProjectsPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>Promise.resolve((parcelRequire("hBskO"))).then(({ HelpCenterManageProjects: HelpCenterManageProjects })=>HelpCenterManageProjects), {
        moduleId: "./packages/admin-layout/src/ui/manage-projects/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $5133afa5f6e88b2c$var$AsyncHelpCenterManageCustomPagesPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>Promise.resolve((parcelRequire("40zlN"))).then(({ HelpCenterManagePages: HelpCenterManagePages })=>HelpCenterManagePages), {
        moduleId: "./packages/admin-layout/src/ui/manage-pages/index.tsx"
    }),
    LoadingSkeleton: ()=>null
});

const $5133afa5f6e88b2c$var$AsyncHubEditLayoutComponent = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("ggXfI")).then(({ HubEditLayout: HubEditLayout })=>HubEditLayout), {
        ssr: false,
        moduleId: "./packages/admin-layout/src/ui/hub-edit-layout/index.tsx"
    }),
    LoadingSkeleton: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5qWT2.default), null)
});
const $5133afa5f6e88b2c$export$8c1389d3983434c = {
    name: 'edit-details',
    path: '/:helpcenterId/details',
    exact: true,
    component: (0, $lM7Z9.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jSFJf.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5133afa5f6e88b2c$var$AsyncHelpCenterEditDetailsPage, null)))
};
const $5133afa5f6e88b2c$export$5fae61522b3dcb33 = {
    name: 'manage-projects',
    path: '/:helpcenterId/projects',
    exact: true,
    component: (0, $lM7Z9.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jSFJf.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5133afa5f6e88b2c$var$AsyncHelpCenterManageProjectsPage, null)))
};
const $5133afa5f6e88b2c$export$d1e5a4952efbcb = {
    name: 'manage-pages',
    path: '/:helpcenterId/pages',
    exact: true,
    component: (0, $lM7Z9.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jSFJf.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5133afa5f6e88b2c$var$AsyncHelpCenterManageCustomPagesPage, null)))
};
const $5133afa5f6e88b2c$export$8f54556241df66cd = {
    name: 'edit-hub',
    path: '/:helpcenterId/edit-hub/:pageId?',
    exact: true,
    resources: [
        (0, $lcaDO.EditLayoutResource)
    ],
    component: (0, $lM7Z9.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jSFJf.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5133afa5f6e88b2c$var$AsyncHubEditLayoutComponent, null)))
};
const $5133afa5f6e88b2c$export$b97f195684a7c2a4 = {
    name: 'edit-hub-portal',
    path: '/:helpcenterId/edit-hub/portal/:portalId',
    exact: true,
    resources: [
        (0, $lcaDO.EditLayoutResource)
    ],
    component: (0, $lM7Z9.withRouter)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jSFJf.JiraAdminPermissionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($5133afa5f6e88b2c$var$AsyncHubEditLayoutComponent, null)))
};

});
parcelRegister("jSFJf", function(module, exports) {
$parcel$export(module.exports, "JiraAdminPermissionWrapper", () => $01da1fae5ea84fee$export$6061a3ec828d7435);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $dQegt = parcelRequire("dQegt");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");

var $corqd = parcelRequire("corqd");
const $01da1fae5ea84fee$export$6061a3ec828d7435 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }), (0, $3RiO6.default)({
        message: formatMessage((0, $corqd.authPageMessage)),
        callToActionText: formatMessage((0, $corqd.callToActionUrlText)),
        callToActionUrl: '/portals'
    }))(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Children.only(children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};

});

parcelRegister("lcaDO", function(module, exports) {
$parcel$export(module.exports, "EditLayoutResource", () => $219dce1846562761$export$e44f9c093dbfbb53);

var $6mmHn = parcelRequire("6mmHn");

var $4oTiM = parcelRequire("4oTiM");
var $8llkI = parcelRequire("8llkI");

var $6bGmX = parcelRequire("6bGmX");

var $21JLS = parcelRequire("21JLS");

var $fZppw = parcelRequire("fZppw");

var $EoK5J = parcelRequire("EoK5J");
const $219dce1846562761$export$f170ab873a147b4a = (match)=>{
    if ((0, $6bGmX.default).checkGate('portal-pages-in-hub')) {
        const portalId = match.params.portalId;
        if (portalId) return `portal_page-${portalId}`;
    }
    return match.params.pageId || '';
};
const $219dce1846562761$export$e44f9c093dbfbb53 = (0, $fZppw.createRelayResource)({
    type: 'EDIT_HUB_LAYOUT',
    getQuery: ({ match: match }, { cloudId: cloudId })=>{
        const activationId = (0, $6mmHn.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        const pageId = $219dce1846562761$export$f170ab873a147b4a(match);
        const computedHelpCenterAri = (0, $4oTiM.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        const resolvedPageId = pageId || helpCenterId;
        const computedPageAri = (0, $21JLS.isPortalPage)(resolvedPageId) && helpCenterId ? (0, $21JLS.buildPortalPageAri)(computedHelpCenterAri, resolvedPageId) : (0, $8llkI.HelpPageAri).create({
            activationId: activationId,
            pageId: resolvedPageId
        }).toString();
        return {
            parameters: (0, $EoK5J.default),
            variables: {
                cloudId: cloudId,
                hubAri: computedHelpCenterAri,
                hubEditMode: true,
                pageAri: computedPageAri
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("EoK5J", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a534231316ab809$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<15d6b87da13d66b5128824315e99d91d>>
 * @relayHash 8957a4b22009a350bd14796c8ff493d7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c48685dd6f0b97f5275882ba5af119330a743067ca9cbfa9a00002d353052161

var $f2UoR = parcelRequire("f2UoR");
const $3a534231316ab809$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubEditMode"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "operationType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageAri"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "pageAri",
            "variableName": "pageAri"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "Variable",
        "name": "operationType",
        "variableName": "operationType"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "asapIssuer"
        },
        {
            "kind": "ScalarField",
            "name": "mediaCollectionName"
        },
        {
            "kind": "ScalarField",
            "name": "mediaToken"
        },
        {
            "kind": "ScalarField",
            "name": "mediaUrl"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v13 = {
        "concreteType": "HelpCenterNavigationBar",
        "kind": "LinkedField",
        "name": "navigationBar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "backgroundColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderColor"
            },
            {
                "kind": "ScalarField",
                "name": "borderType"
            },
            {
                "kind": "ScalarField",
                "name": "cornerRadius"
            },
            {
                "kind": "ScalarField",
                "name": "padding"
            },
            {
                "kind": "ScalarField",
                "name": "positionType"
            },
            {
                "kind": "ScalarField",
                "name": "textColor"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = {
        "concreteType": "HelpCenterPageName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": v12 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
                        },
                        {
                            "args": v6 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "hubHomeContentWrapperQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "pageMediaConfig",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "pageAri"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "helpCenterAri",
                                    "variableName": "hubAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "hoistedProjectKey"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "slug"
                                        },
                                        {
                                            "concreteType": "HelpCenterName",
                                            "kind": "LinkedField",
                                            "name": "name",
                                            "plural": false,
                                            "selections": v12 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "alias": "allPages",
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v16 /*: any*/ 
                                        },
                                        {
                                            "alias": "customPages",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "filter",
                                                    "value": {
                                                        "ids": [],
                                                        "type": "CUSTOM"
                                                    }
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": v16 /*: any*/ ,
                                            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                        },
                                        v11 /*: any*/ ,
                                        {
                                            "alias": "currentPage",
                                            "args": [
                                                {
                                                    "fields": [
                                                        {
                                                            "items": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "ids.0",
                                                                    "variableName": "pageAri"
                                                                }
                                                            ],
                                                            "kind": "ListValue",
                                                            "name": "ids"
                                                        }
                                                    ],
                                                    "kind": "ObjectValue",
                                                    "name": "filter"
                                                }
                                            ],
                                            "concreteType": "HelpCenterPage",
                                            "kind": "LinkedField",
                                            "name": "pages",
                                            "plural": true,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterPageLayout",
                                                    "kind": "LinkedField",
                                                    "name": "pageLayout",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterLayoutAdf",
                                                            "kind": "LinkedField",
                                                            "name": "layoutAdf",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterLayoutAdfContentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "HelpCenterLayoutAdfContentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "HelpCenterLayoutAdfContent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "content"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "HelpCenterBranding",
                                            "kind": "LinkedField",
                                            "name": "helpCenterBranding",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterLogo",
                                                    "kind": "LinkedField",
                                                    "name": "logo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fileId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "url"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "HelpCenterBrandingColors",
                                                    "kind": "LinkedField",
                                                    "name": "colors",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "primary"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "secondaryColor"
                                                        }
                                                    ]
                                                },
                                                v13 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ],
                                    "type": "QueryError"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v14 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "ari",
                                    "variableName": "hubAri"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "HelpCenterMediaConfig",
                            "kind": "LinkedField",
                            "name": "hubMediaConfig",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "hubEditMode",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "cloudIds.0",
                                            "variableName": "cloudId"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "cloudIds"
                                }
                            ],
                            "concreteType": "TenantContext",
                            "kind": "LinkedField",
                            "name": "tenantContexts",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "cloudUrl"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "AuthenticationContext",
                    "kind": "LinkedField",
                    "name": "me",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c48685dd6f0b97f5275882ba5af119330a743067ca9cbfa9a00002d353052161",
            "metadata": {},
            "name": "hubHomeContentWrapperQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$3a534231316ab809$var$node.hash = "647b06faa4e451d097f1c1141f02b3ef";
(0, $f2UoR.PreloadableQueryRegistry).set($3a534231316ab809$var$node.params.id, $3a534231316ab809$var$node);
var $3a534231316ab809$export$2e2bcd8739ae039 = $3a534231316ab809$var$node;

});


parcelRegister("cYYPV", function(module, exports) {
$parcel$export(module.exports, "HelpCenterEditDetails", () => (parcelRequire("kZ8S8")).default);

var $kZ8S8 = parcelRequire("kZ8S8");

});
parcelRegister("kZ8S8", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8cb06257fcfb785$export$2e2bcd8739ae039);

var $g02aH = parcelRequire("g02aH");

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $gMSZD = parcelRequire("gMSZD");

var $6mmHn = parcelRequire("6mmHn");

var $gopxm = parcelRequire("gopxm");

var $63sfu = parcelRequire("63sfu");

var $dQegt = parcelRequire("dQegt");

var $gIeP2 = parcelRequire("gIeP2");

var $fFB0R = parcelRequire("fFB0R");
var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $2bLkU = parcelRequire("2bLkU");

var $7TPEx = parcelRequire("7TPEx");
var $eNI4Q = parcelRequire("eNI4Q");
var $4hIeL = parcelRequire("4hIeL");
parcelRequire("acPE2");
var $1g7Go = parcelRequire("1g7Go");
var $gjCVU = parcelRequire("gjCVU");
parcelRequire("j02N2");
var $9mFjv = parcelRequire("9mFjv");

var $cz6zo = parcelRequire("cz6zo");
var $gHT3x = parcelRequire("gHT3x");

var $54jwS = parcelRequire("54jwS");

var $WVSzu = parcelRequire("WVSzu");

var $hZWMk = parcelRequire("hZWMk");

var $3krHC = parcelRequire("3krHC");
var $7hsFm = parcelRequire("7hsFm");
parcelRequire("2r28u");
var $fi3YF = parcelRequire("fi3YF");
parcelRequire("5orWW");
var $hs3vm = parcelRequire("hs3vm");

var $81Whe = parcelRequire("81Whe");

var $blAxV = parcelRequire("blAxV");
const $e8cb06257fcfb785$var$HelpCenterEditDetailsComponent = ()=>{
    var _data$helpCenter, _data$helpCenter2, _data$helpCenter3;
    const cloudId = (0, $6mmHn.getCloudId)();
    const helpCenterAri = (0, $gjCVU.useHelpCenterAri)();
    const data = (0, $gIeP2.useLazyLoadQuery)((0, $g02aH.default), {
        cloudId: cloudId,
        helpCenterAri: helpCenterAri
    });
    const helpCenter = (_data$helpCenter = data.helpCenter) === null || _data$helpCenter === void 0 ? void 0 : _data$helpCenter.helpCenterById;
    const { name: name, slug: slug, id: id } = helpCenter ?? {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cz6zo.ContextWrapper), {
        sourceName: (0, $748yq.ScreenName).EDIT_HELP_CENTER,
        sourceType: (0, $gHT3x.SCREEN)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), null, (data === null || data === void 0 || (_data$helpCenter2 = data.helpCenter) === null || _data$helpCenter2 === void 0 ? void 0 : _data$helpCenter2.helpCenterById) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $9mFjv.default), {
        helpCenterData: (_data$helpCenter3 = data.helpCenter) === null || _data$helpCenter3 === void 0 ? void 0 : _data$helpCenter3.helpCenterById
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fi3YF.default), {
        helpCenterToEdit: {
            translations: name && name.translations ? name.translations.map((translation)=>({
                    value: (translation === null || translation === void 0 ? void 0 : translation.value) ?? '',
                    locale: (translation === null || translation === void 0 ? void 0 : translation.locale) ?? ''
                })) : [],
            slug: slug ?? '',
            name: (name === null || name === void 0 ? void 0 : name.default) ?? '',
            ari: id ?? ''
        },
        isStandaloneForm: true,
        isOpen: true,
        onClose: (0, $63sfu.noop)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3krHC.ExperienceSuccess), {
        experience: (0, $81Whe.editHelpCenterExperience)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $WVSzu.FireScreenEventOnMount), null));
};
const $e8cb06257fcfb785$export$613b634f86450035 = ()=>{
    (0, $7hsFm.useUFOComponentExperience)((0, $81Whe.editHelpCenterExperience));
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const onError = (error)=>{
        if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) {
            (0, $81Whe.editHelpCenterExperience).failure({
                metadata: {
                    error: error === null || error === void 0 ? void 0 : error.message,
                    statusCode: error === null || error === void 0 ? void 0 : error.status
                }
            }).then((0, $63sfu.noop)).catch((0, $63sfu.noop));
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'fetch_failed',
                actionSubject: 'helpCenterDetails',
                errorMessage: error === null || error === void 0 ? void 0 : error.message,
                errorStatus: error === null || error === void 0 ? void 0 : error.status
            }).fire();
        }
    };
    const renderError = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2bLkU.default), {
            header: formatMessage((0, $blAxV.default).errorTitle),
            description: formatMessage((0, $blAxV.default).errorDescription),
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($gopxm)))
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1g7Go.default), {
        featureName: "Helpcenter settings"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gMSZD.default), {
        packageName: (0, $748yq.ScreenName).EDIT_HELP_CENTER,
        id: 'help-center-edit-details',
        renderError: renderError,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            attributes: {
                workspaceAri: (0, $6mmHn.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eNI4Q.default), {
        templateColumns: "1fr 2fr 1fr",
        rowGap: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4fqPo.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hs3vm.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($e8cb06257fcfb785$var$HelpCenterEditDetailsComponent, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null)))));
};
var $e8cb06257fcfb785$export$2e2bcd8739ae039 = (0, $apbG6.default)({
    component: 'helpCenterEditDetails'
})($e8cb06257fcfb785$export$613b634f86450035);

});
parcelRegister("g02aH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0df92f9609941042$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9ac0204ca94c5ca5bd93a55bfdd44c6f>>
 * @relayHash efdc5420deee34a8cc05fb680adbe347
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0
const $0df92f9609941042$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v3 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "concreteType": "HelpCenterName",
        "kind": "LinkedField",
        "name": "name",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "default"
            },
            {
                "concreteType": "HelpCenterTranslation",
                "kind": "LinkedField",
                "name": "translations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "locale"
                    }
                ]
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "slug"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "editHelpCenter_getHelpcenterById_Query",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v4 /*: any*/ 
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7b0a8c16e933459da97d8638f8b061a4a77543af7666f2d03b73dfac583090f0",
            "metadata": {},
            "name": "editHelpCenter_getHelpcenterById_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0df92f9609941042$var$node.hash = "b3bd596bd547f6d09044149b39e767e6";
var $0df92f9609941042$export$2e2bcd8739ae039 = $0df92f9609941042$var$node;

});

parcelRegister("2r28u", function(module, exports) {
$parcel$export(module.exports, "HelpCenterForm", () => (parcelRequire("fi3YF")).default);

var $fi3YF = parcelRequire("fi3YF");

});
parcelRegister("fi3YF", function(module, exports) {
$parcel$export(module.exports, "default", () => $12eb99300d65ba9d$export$2e2bcd8739ae039);
/* help-center-form.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $4fqPo = parcelRequire("4fqPo");

var $ltgDR = parcelRequire("ltgDR");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $1HSOM = parcelRequire("1HSOM");

var $bG6ob = parcelRequire("bG6ob");

var $gBYjj = parcelRequire("gBYjj");

var $6mmHn = parcelRequire("6mmHn");

var $4yzPD = parcelRequire("4yzPD");

var $dQegt = parcelRequire("dQegt");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");

var $fFB0R = parcelRequire("fFB0R");
var $ew3Bn = parcelRequire("ew3Bn");
var $apbG6 = parcelRequire("apbG6");

var $kuhlf = parcelRequire("kuhlf");
var $eBKht = parcelRequire("eBKht");

var $2eKV2 = parcelRequire("2eKV2");

var $9RW5e = parcelRequire("9RW5e");

var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $isBvF = parcelRequire("isBvF");
var $6zx4f = parcelRequire("6zx4f");
var $kCZZw = parcelRequire("kCZZw");

var $7TPEx = parcelRequire("7TPEx");
var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
parcelRequire("acPE2");
var $eQlRt = parcelRequire("eQlRt");

var $54jwS = parcelRequire("54jwS");

var $4oTiM = parcelRequire("4oTiM");

var $keOG0 = parcelRequire("keOG0");

var $ebpTf = parcelRequire("ebpTf");

var $hZWMk = parcelRequire("hZWMk");

var $2pDGU = parcelRequire("2pDGU");
parcelRequire("fVKYy");
var $5JSJi = parcelRequire("5JSJi");

var $fxbaH = parcelRequire("fxbaH");
parcelRequire("hR6N6");
var $26AJB = parcelRequire("26AJB");
parcelRequire("8Graj");
var $40leL = parcelRequire("40leL");

var $8drSw = parcelRequire("8drSw");
const $12eb99300d65ba9d$var$MODAL_WIDTH = '506px';
const $12eb99300d65ba9d$var$HelpCenterForm = ({ onClose: onClose, isOpen: isOpen, helpCenterToEdit: helpCenterToEdit, isStandaloneForm: isStandaloneForm = false, showErrorFlag: showErrorFlagAction, showSuccessFlag: showSuccessFlagAction })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { createHelpCenter: createHelpCenter, updateHelpCenter: updateHelpCenter } = (0, $5JSJi.useHelpCenter)();
    const displayUrl = (0, $ebpTf.getEnv)().baseUrl.replace(/^https?:\/\//i, '');
    const { slug: slug, name: name } = helpCenterToEdit || {};
    const detailsDescription = (0, $eQlRt.useConditionalMessage)((0, $8drSw.default).helpHubDetailsPageDescription, (0, $8drSw.default).helpCenterDetailsPageDescription);
    const { push: push } = (0, $1wDzz.useRouterActions)();
    const successFlagAction = (0, $4fqPo.useCallback)((helpCenterSlug)=>[
            {
                contentNode: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("a", {
                    href: `${(0, $ebpTf.getEnv)().baseUrl}/helpcenter/${helpCenterSlug}`
                }, formatMessage((0, $8drSw.default).helpCenterAddSuccessDesc))
            }
        ], [
        formatMessage
    ]);
    const onCreate = (0, $4fqPo.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $fxbaH.addHelpCenterExperience).start();
        return createHelpCenter({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        }).then((response)=>{
            var _response$helpCenter;
            createAnalyticsEvent({
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'created',
                actionSubject: 'helpCenter',
                helpCenterAri: (_response$helpCenter = response.helpCenter) === null || _response$helpCenter === void 0 || (_response$helpCenter = _response$helpCenter.createHelpCenter) === null || _response$helpCenter === void 0 ? void 0 : _response$helpCenter.helpCenterAri
            }).fire();
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $fxbaH.addHelpCenterExperience).success();
            onClose();
            if ((0, $bG6ob.isProjectMappingInHelpCenterEnabled)()) setTimeout(()=>{
                var _response$helpCenter2;
                showSuccessFlagAction((0, $8drSw.default).helpCenterAddSuccessTitleText, {
                    value: helpCenterName
                }, undefined, successFlagAction(helpCenterSlug));
                const helpCenterAri = (_response$helpCenter2 = response.helpCenter) === null || _response$helpCenter2 === void 0 || (_response$helpCenter2 = _response$helpCenter2.createHelpCenter) === null || _response$helpCenter2 === void 0 ? void 0 : _response$helpCenter2.helpCenterAri;
                const { helpCenterId: helpCenterId } = (0, $4oTiM.HelpHelpCenterAri).parse(helpCenterAri || '');
                push(`/${helpCenterId}/projects`);
            }, 1000);
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $2pDGU.HARD_LIMIT_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $8drSw.default).helpCenterHardLimitErrorTitle, (0, $8drSw.default).helpCenterHardLimitErrorDescription, undefined, undefined, {
                value: message
            });
            else if (message === (0, $2pDGU.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $8drSw.default).helpCenterAddErrorTitle, (0, $8drSw.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $2pDGU.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $8drSw.default).helpCenterAddErrorTitle, (0, $8drSw.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $8drSw.default).helpCenterAddErrorTitle, (0, $8drSw.default).helpCenterGenericErrorDesc);
            if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    action: 'create_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $fxbaH.addHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $keOG0.getErrorData)(message)
                    }
                });
            }
            return (0, $fxbaH.addHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        createHelpCenter,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        successFlagAction
    ]);
    const onEdit = (0, $4fqPo.useCallback)(({ helpCenterName: helpCenterName, helpCenterTranslations: helpCenterTranslations, helpCenterSlug: helpCenterSlug, helpCenterAri: helpCenterAri })=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $fxbaH.updateHelpCenterExperience).start();
        return updateHelpCenter({
            helpCenterAri: helpCenterAri,
            helpCenterName: helpCenterName,
            helpCenterTranslations: helpCenterTranslations,
            helpCenterSlug: helpCenterSlug
        }).then(()=>{
            createAnalyticsEvent({
                helpCenterAri: helpCenterAri,
                analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                action: 'updated',
                actionSubject: 'helpCenter'
            }).fire();
            showSuccessFlagAction((0, $8drSw.default).helpCenterUpdateSuccessTitleText, {
                value: helpCenterName ? helpCenterName : name
            });
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (0, $fxbaH.updateHelpCenterExperience).success();
            if (isStandaloneForm) push('/');
            else onClose();
        }).catch((error)=>{
            const { message: message, status: status } = error;
            if (message === (0, $2pDGU.RESERVED_TERM_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $8drSw.default).helpCenterUpdateErrorTitle, (0, $8drSw.default).helpCenterReservedSlugErrorDescription);
            else if (message === (0, $2pDGU.ALREADY_EXISTED_HELP_CENTERS_MESSAGE)) showErrorFlagAction((0, $8drSw.default).helpCenterUpdateErrorTitle, (0, $8drSw.default).helpCenterAlreadyExistedSlugErrorDescription);
            else showErrorFlagAction((0, $8drSw.default).helpCenterUpdateErrorTitle, (0, $8drSw.default).helpCenterGenericErrorDesc);
            if (!(0, $hZWMk.isFetchNetworkOrClientError)(error)) {
                createAnalyticsEvent({
                    helpCenterAri: helpCenterAri,
                    analyticsType: (0, $54jwS.TRACK_EVENT_TYPE),
                    action: 'update_failed',
                    actionSubject: 'helpCenter',
                    errorMessage: message,
                    errorStatus: status
                }).fire();
                return (0, $fxbaH.updateHelpCenterExperience).failure({
                    metadata: {
                        error: (0, $keOG0.getErrorData)(message)
                    }
                });
            }
            return (0, $fxbaH.updateHelpCenterExperience).success();
        });
    }, [
        createAnalyticsEvent,
        name,
        isStandaloneForm,
        onClose,
        push,
        showErrorFlagAction,
        showSuccessFlagAction,
        updateHelpCenter
    ]);
    const onSubmit = (0, $4fqPo.useCallback)((data)=>{
        const { name: helpCenterName, slug: helpCenterSlug } = data;
        if (!helpCenterToEdit) return onCreate({
            helpCenterName: helpCenterName,
            helpCenterSlug: helpCenterSlug
        });
        const { ari: ari, translations: translations } = helpCenterToEdit;
        return onEdit({
            helpCenterName: helpCenterName !== name ? helpCenterName : undefined,
            helpCenterSlug: helpCenterSlug !== slug ? helpCenterSlug : undefined,
            helpCenterAri: ari,
            helpCenterTranslations: translations
        });
    }, [
        helpCenterToEdit,
        name,
        onCreate,
        onEdit,
        slug
    ]);
    // used in settings page without a modal
    if (isStandaloneForm) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kuhlf.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, dirty: dirty, submitting: submitting, reset: reset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
            space: "space.300"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
            size: "large"
        }, formatMessage((0, $8drSw.default).helpCenterDetailsPageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, slug ? formatMessage(detailsDescription) : formatMessage((0, $8drSw.default).defaultHelpCenterDetailsPageDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            paddingBlock: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), null, formatMessage((0, $8drSw.default).helpCenterRequiredFieldsWarning), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $eBKht.default), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $26AJB.HelpCenterFormFields), {
            mode: "EDIT",
            name: name,
            slug: slug,
            urlWithoutSlug: `${window.location.hostname}/helpcenter`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $40leL.HelpCenterFormFooter), {
            mode: "EDIT",
            isStandaloneForm: true,
            isCancelDisabled: !dirty,
            submitting: submitting,
            onCancel: ()=>reset({
                    name: name ?? '',
                    slug: slug ?? ''
                })
        })));
    // TODO clean this up when enable_project_mapping_for_help_center is cleaned up.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $fFB0R.default), {
        data: {
            attributes: {
                workspaceAri: (0, $6mmHn.getWorkspaceAri)()
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
        onClose: onClose,
        width: $12eb99300d65ba9d$var$MODAL_WIDTH,
        testId: "help-centers-management-form-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kuhlf.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($12eb99300d65ba9d$var$HelpForm, formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $isBvF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $6zx4f.default), {
            testId: "help-centers-management-modal-title"
        }, formatMessage(!helpCenterToEdit ? (0, $8drSw.default).helpCenterCreateFormTitle : (0, $8drSw.default).helpCenterEditFormTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.Button), {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
            "aria-label": "Cancel create dialog",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RW5e))), {
                spacing: "spacious",
                label: "cancel create dialog"
            }),
            onClick: onClose,
            actionSubjectId: "helpCenterCreateDialogCancelButton"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, !helpCenterToEdit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($12eb99300d65ba9d$var$DescriptionWrapper, null, formatMessage((0, $8drSw.default).helpCenterCreateFormDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $26AJB.HelpCenterFormFields), {
            mode: !helpCenterToEdit ? 'CREATE' : 'EDIT',
            name: name,
            slug: slug,
            urlWithoutSlug: `${displayUrl}/helpcenter`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $40leL.HelpCenterFormFooter), {
            submitting: submitting,
            onCancel: onClose,
            mode: helpCenterToEdit ? 'EDIT' : 'CREATE'
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4yzPD.default), {
        preventNavigation: isOpen
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const $12eb99300d65ba9d$var$DescriptionWrapper = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_otyrv47k",
            __cmplp.className
        ])
    });
});
const $12eb99300d65ba9d$var$HelpForm = /*#__PURE__*/ (0, $4fqPo.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $ltgDR.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});
var $12eb99300d65ba9d$export$2e2bcd8739ae039 = (0, $bmgw6.default)(null, {
    showErrorFlag: $gBYjj.showErrorFlag,
    showSuccessFlag: $gBYjj.showSuccessFlag
})((0, $apbG6.default)({
    component: 'helpCenterForm'
})($12eb99300d65ba9d$var$HelpCenterForm));

});
parcelRegister("4yzPD", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d41ad1b5d5df77d$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $efDRU = parcelRequire("efDRU");

var $3TeDY = parcelRequire("3TeDY");

var $8HO8W = parcelRequire("8HO8W");

var $lztbK = parcelRequire("lztbK");
class $7d41ad1b5d5df77d$export$5e156bf0bd6195af extends $4fqPo.PureComponent {
    componentDidMount() {
        if (this.props.preventNavigation) this.blockNavigation();
    }
    componentWillUnmount() {
        if (this.props.preventNavigation) this.allowNavigation();
    }
    componentDidUpdate(prevProps) {
        const { preventNavigation: preventNavigation } = this.props;
        if (preventNavigation && !prevProps.preventNavigation) this.blockNavigation();
        else if (!preventNavigation && prevProps.preventNavigation) this.allowNavigation();
    }
    render() {
        const { preventNavigation: preventNavigation, onBeforeNavigate: onBeforeNavigate } = this.props;
        return /*#__PURE__*/ $4fqPo.createElement((0, $lztbK.default), {
            when: preventNavigation,
            message: this.checkCanNavigate,
            onBeforeNavigate: onBeforeNavigate
        });
    }
    constructor(...args){
        super(...args), this.checkCanNavigate = (routerLocation)=>{
            // This will cause the prompt to not prevent navigation if a "q" was, or is, going to be in the location search property.
            // Because we do that it will fail to prevent accidental navigation if interacting with the back button,
            // or pressing backspace/delete. We have another issue to pick up to make this better.
            // See: https://jdog.jira-dev.com/browse/FSD-3235
            const containsSearchQueryParam = (str)=>str.includes('q=');
            if (containsSearchQueryParam(routerLocation.search) || containsSearchQueryParam((0, $3TeDY.location)().search)) return true;
            /**
     * Do not show prevent navigation prompt for allowed paths
     */ const { allowedPaths: allowedPaths } = this.props;
            const { pathname: pathname } = routerLocation;
            if (allowedPaths) for (const pathRegExp of allowedPaths){
                if (pathname.match(pathRegExp)) return true;
            }
            const { intl: intl } = this.props;
            return intl.formatMessage((0, $8HO8W.default).navigationWarning);
        }, this.onBeforeUnload = (event)=>{
            // Prompts the user before closing the page, see:
            // https://developer.mozilla.org/en-US/docs/Web/Events/beforeunload
            event.preventDefault();
            event.returnValue = '';
        }, this.blockNavigation = ()=>{
            window.addEventListener('beforeunload', this.onBeforeUnload);
        }, this.allowNavigation = ()=>{
            window.removeEventListener('beforeunload', this.onBeforeUnload);
        };
    }
}
var $7d41ad1b5d5df77d$export$2e2bcd8739ae039 = (0, $efDRU.default)($7d41ad1b5d5df77d$export$5e156bf0bd6195af);

});
parcelRegister("8HO8W", function(module, exports) {
$parcel$export(module.exports, "default", () => $1463538a33a38e4f$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $1463538a33a38e4f$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    navigationWarning: {
        defaultMessage: 'You have unsubmitted changes. Are you sure you want to leave?',
        description: 'Messsage shown to users when they navigate away from a form that has been filled out.',
        id: 'cv.navigation.prompt.warning'
    }
});

});

parcelRegister("lztbK", function(module, exports) {
$parcel$export(module.exports, "default", () => $93c0e716654612ad$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("l8iRu");
var $1wDzz = parcelRequire("1wDzz");
const $93c0e716654612ad$var$NavBlocker = ({ when: when, message: message, onBeforeNavigate: onBeforeNavigate })=>{
    const { registerBlock: registerBlock } = (0, $1wDzz.useRouterActions)();
    (0, $4fqPo.useEffect)(()=>{
        const unRegisterBlock = registerBlock((location)=>{
            if (!when) return true;
            const result = message(location);
            if (typeof result === 'boolean') return result;
            //RRR doesn't support async block, so we cannot use our custom dialog here.
            //We need to fallback to using browser's confirm like react-router's prompt.
            // oxlint-disable-next-line no-alert
            const confirmation = window.confirm(result);
            if (confirmation && onBeforeNavigate) onBeforeNavigate(location);
            return confirmation;
        });
        return unRegisterBlock;
    // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [
        registerBlock,
        when
    ]);
    return null;
};
var $93c0e716654612ad$export$2e2bcd8739ae039 = $93c0e716654612ad$var$NavBlocker;

});


parcelRegister("2pDGU", function(module, exports) {
$parcel$export(module.exports, "BANNER_PREVIEW_WIDTH", () => $3728df3bb200b7f5$export$69656aaf76d15223);
$parcel$export(module.exports, "CARD_HEIGHT", () => $3728df3bb200b7f5$export$17f5f15729f028ea);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $3728df3bb200b7f5$export$780035d9fe48eb32);
$parcel$export(module.exports, "HELPCENTER_NAME_CHARACTER_LIMIT", () => $3728df3bb200b7f5$export$60a11b99c333dc54);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH", () => $3728df3bb200b7f5$export$434ed9a0808b5e5e);
$parcel$export(module.exports, "NUMBER_OF_HELP_CENTERS_PER_FETCH", () => $3728df3bb200b7f5$export$81026eacb893b971);
$parcel$export(module.exports, "SORT_ORDER", () => $3728df3bb200b7f5$export$d33cb9b119034d29);
$parcel$export(module.exports, "HARD_LIMIT_HELP_CENTERS_MESSAGE", () => $3728df3bb200b7f5$export$2426c5658dae9870);
$parcel$export(module.exports, "RESERVED_TERM_HELP_CENTERS_MESSAGE", () => $3728df3bb200b7f5$export$b7e744b1154b89ed);
$parcel$export(module.exports, "ALREADY_EXISTED_HELP_CENTERS_MESSAGE", () => $3728df3bb200b7f5$export$20efc88db71ca642);
$parcel$export(module.exports, "HARD_LIMIT_HELP_HUBS_MESSAGE", () => $3728df3bb200b7f5$export$78070db85cc402de);
const $3728df3bb200b7f5$export$69656aaf76d15223 = '170px';
const $3728df3bb200b7f5$export$17f5f15729f028ea = '176px';
const $3728df3bb200b7f5$export$780035d9fe48eb32 = 240;
const $3728df3bb200b7f5$export$60a11b99c333dc54 = 30;
const $3728df3bb200b7f5$export$434ed9a0808b5e5e = 20;
const $3728df3bb200b7f5$export$81026eacb893b971 = 10;
const $3728df3bb200b7f5$export$d33cb9b119034d29 = 'CREATED_DATE_DESCENDING';
const $3728df3bb200b7f5$export$2426c5658dae9870 = 'This operation is not supported : Help Center limit exceeded';
const $3728df3bb200b7f5$export$b7e744b1154b89ed = `The slug you've entered contains a reserved term. Try again with a different slug.`;
const $3728df3bb200b7f5$export$20efc88db71ca642 = `A help center with this slug already exists on your site. Try again with a different slug.`;
const $3728df3bb200b7f5$export$78070db85cc402de = 'This operation is not supported : Help Hub limit exceeded';

});

parcelRegister("fVKYy", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => (parcelRequire("5JSJi")).useHelpCenter);

var $5JSJi = parcelRequire("5JSJi");

});
parcelRegister("5JSJi", function(module, exports) {
$parcel$export(module.exports, "useHelpCenter", () => $6c0f315b93112511$export$4545b8e2508a7415);

var $6ZJMy = parcelRequire("6ZJMy");

var $ew19G = parcelRequire("ew19G");

var $hZOjp = parcelRequire("hZOjp");

var $4fqPo = parcelRequire("4fqPo");

var $748yq = parcelRequire("748yq");

var $6mmHn = parcelRequire("6mmHn");

var $gIeP2 = parcelRequire("gIeP2");

var $f2UoR = parcelRequire("f2UoR");

var $ebpTf = parcelRequire("ebpTf");
const $6c0f315b93112511$export$4545b8e2508a7415 = ()=>{
    const cloudId = (0, $6mmHn.getCloudId)();
    const workspaceAri = (0, $6mmHn.getWorkspaceAri)();
    const [helpCenterCreateMutation] = (0, $gIeP2.useMutation)((0, $hZOjp.default));
    const [helpCenterUpdateMutation] = (0, $gIeP2.useMutation)((0, $ew19G.default));
    const [helpCenterDeleteMutation] = (0, $gIeP2.useMutation)((0, $6ZJMy.default));
    const getHelpCenter = (0, $4fqPo.useCallback)((store)=>{
        const root = store.getRoot();
        const helpCenter = root.getLinkedRecord('helpCenter', {
            cloudId: cloudId
        });
        return helpCenter;
    }, [
        cloudId
    ]);
    const getHelpCenterList = (0, $4fqPo.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (0, $f2UoR.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const getHelpCenters = (0, $4fqPo.useCallback)((store)=>{
        const helpCenter = getHelpCenter(store);
        if (helpCenter !== null && helpCenter !== void 0 && helpCenter.getDataID()) {
            var _ConnectionHandler$ge;
            const parent = store.get(helpCenter === null || helpCenter === void 0 ? void 0 : helpCenter.getDataID());
            if (parent) return (_ConnectionHandler$ge = (0, $f2UoR.ConnectionHandler).getConnection(parent, 'helpCentersManagementPageFragment_helpCenters')) === null || _ConnectionHandler$ge === void 0 ? void 0 : _ConnectionHandler$ge.getLinkedRecords('edges');
        }
        return null;
    }, [
        getHelpCenter
    ]);
    const deleteHelpCenter = (0, $4fqPo.useCallback)(({ helpCenterAri: helpCenterAri })=>{
        return new Promise((resolve, reject)=>helpCenterDeleteMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter;
                    if (response !== null && response !== void 0 && (_response$helpCenter = response.helpCenter) !== null && _response$helpCenter !== void 0 && (_response$helpCenter = _response$helpCenter.deleteHelpCenter) !== null && _response$helpCenter !== void 0 && _response$helpCenter.success) {
                        const helpCenters = getHelpCenters(store);
                        const helpCentersList = getHelpCenterList(store);
                        if (helpCenters && helpCentersList) {
                            const updatedHelpCenters = [
                                ...helpCenters.filter((helpCenterRecord)=>{
                                    const node = helpCenterRecord.getLinkedRecord('node');
                                    return (node === null || node === void 0 ? void 0 : node.getValue('id')) !== helpCenterAri;
                                })
                            ];
                            helpCentersList === null || helpCentersList === void 0 || helpCentersList.setLinkedRecords(updatedHelpCenters, 'edges');
                        }
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter2, _response$helpCenter3;
                    if ((_response$helpCenter2 = response.helpCenter) !== null && _response$helpCenter2 !== void 0 && (_response$helpCenter2 = _response$helpCenter2.deleteHelpCenter) !== null && _response$helpCenter2 !== void 0 && _response$helpCenter2.success) return resolve(response);
                    const errors = (_response$helpCenter3 = response.helpCenter) === null || _response$helpCenter3 === void 0 || (_response$helpCenter3 = _response$helpCenter3.deleteHelpCenter) === null || _response$helpCenter3 === void 0 ? void 0 : _response$helpCenter3.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {};
                    return reject(error);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterDeleteMutation
    ]);
    const createHelpCenter = (0, $4fqPo.useCallback)(({ helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug, helpCenterType: helpCenterType, projectMapping: projectMapping, rovoConfig: rovoConfig })=>{
        return new Promise((resolve, reject)=>helpCenterCreateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterType: helpCenterType,
                        projectMapping: projectMapping,
                        rovoConfig: rovoConfig,
                        workspaceARI: workspaceAri,
                        name: {
                            default: helpCenterName,
                            translations: [
                                {
                                    locale: (0, $ebpTf.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        },
                        slug: helpCenterSlug
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter4, _response$helpCenter5;
                    if (response !== null && response !== void 0 && (_response$helpCenter4 = response.helpCenter) !== null && _response$helpCenter4 !== void 0 && (_response$helpCenter4 = _response$helpCenter4.createHelpCenter) !== null && _response$helpCenter4 !== void 0 && _response$helpCenter4.success && response !== null && response !== void 0 && (_response$helpCenter5 = response.helpCenter) !== null && _response$helpCenter5 !== void 0 && (_response$helpCenter5 = _response$helpCenter5.createHelpCenter) !== null && _response$helpCenter5 !== void 0 && _response$helpCenter5.helpCenterAri) {
                        var _response$helpCenter6;
                        const helpCenters = getHelpCenters(store);
                        const helpCenterList = getHelpCenterList(store);
                        const node = store.create((0, $f2UoR.generateUniqueClientID)(), 'node');
                        const helpCenterRecord = store.create((0, $f2UoR.generateUniqueClientID)(), 'HelpCenter');
                        const name = store.create((0, $f2UoR.generateUniqueClientID)(), 'HelpCenterName');
                        const branding = store.create((0, $f2UoR.generateUniqueClientID)(), 'HelpCenterBranding');
                        name.setValue(helpCenterName, 'default');
                        branding.setValue(true, 'useDefaultBanner');
                        helpCenterRecord.setLinkedRecord(name, 'name');
                        helpCenterRecord.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        helpCenterRecord === null || helpCenterRecord === void 0 || helpCenterRecord.setValue(date, 'lastUpdated');
                        helpCenterRecord.setValue((_response$helpCenter6 = response.helpCenter) === null || _response$helpCenter6 === void 0 || (_response$helpCenter6 = _response$helpCenter6.createHelpCenter) === null || _response$helpCenter6 === void 0 ? void 0 : _response$helpCenter6.helpCenterAri, 'id');
                        helpCenterRecord.setLinkedRecord(branding, 'helpCenterBranding');
                        node.setLinkedRecord(helpCenterRecord, 'node');
                        const updatedHelpCenters = [
                            node,
                            ...helpCenters ?? []
                        ];
                        if (helpCenters && helpCenterList) helpCenterList.setLinkedRecords(updatedHelpCenters, 'edges');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter7, _response$helpCenter8, _error$extensions;
                    if ((_response$helpCenter7 = response.helpCenter) !== null && _response$helpCenter7 !== void 0 && (_response$helpCenter7 = _response$helpCenter7.createHelpCenter) !== null && _response$helpCenter7 !== void 0 && _response$helpCenter7.success) return resolve(response);
                    const errors = (_response$helpCenter8 = response.helpCenter) === null || _response$helpCenter8 === void 0 || (_response$helpCenter8 = _response$helpCenter8.createHelpCenter) === null || _response$helpCenter8 === void 0 ? void 0 : _response$helpCenter8.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $748yq.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenterList,
        getHelpCenters,
        helpCenterCreateMutation,
        workspaceAri
    ]);
    const updateHelpCenter = (0, $4fqPo.useCallback)(({ helpCenterAri: helpCenterAri, helpCenterTranslations: helpCenterTranslations, helpCenterName: helpCenterName, helpCenterSlug: helpCenterSlug })=>{
        return new Promise((resolve, reject)=>helpCenterUpdateMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        helpCenterAri: helpCenterAri,
                        name: helpCenterName ? {
                            default: helpCenterName,
                            translations: helpCenterTranslations && helpCenterTranslations.length > 0 ? helpCenterTranslations.map((translations)=>{
                                if (translations.locale === (0, $ebpTf.getEnv)().siteDefaultLanguageTag) translations.value = helpCenterName;
                                return translations;
                            }) : [
                                {
                                    locale: (0, $ebpTf.getEnv)().siteDefaultLanguageTag,
                                    value: helpCenterName
                                }
                            ]
                        } : undefined,
                        slug: helpCenterSlug ? helpCenterSlug : undefined
                    }
                },
                updater: (store, response)=>{
                    var _response$helpCenter9;
                    if (response !== null && response !== void 0 && (_response$helpCenter9 = response.helpCenter) !== null && _response$helpCenter9 !== void 0 && (_response$helpCenter9 = _response$helpCenter9.updateHelpCenter) !== null && _response$helpCenter9 !== void 0 && _response$helpCenter9.success) {
                        const helpCenters = getHelpCenters(store);
                        const currentHelpCenter = helpCenters === null || helpCenters === void 0 ? void 0 : helpCenters.find((helpCenter)=>{
                            const node = helpCenter.getLinkedRecord('node');
                            return (node === null || node === void 0 ? void 0 : node.getValue('id')) === helpCenterAri;
                        });
                        const currentHelpCenterNode = currentHelpCenter === null || currentHelpCenter === void 0 ? void 0 : currentHelpCenter.getLinkedRecord('node');
                        if (helpCenterName) {
                            const name = currentHelpCenterNode === null || currentHelpCenterNode === void 0 ? void 0 : currentHelpCenterNode.getLinkedRecord('name');
                            name === null || name === void 0 || name.setValue(helpCenterName, 'default');
                        }
                        if (helpCenterSlug) currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(helpCenterSlug, 'slug');
                        const date = new Date().toISOString();
                        currentHelpCenterNode === null || currentHelpCenterNode === void 0 || currentHelpCenterNode.setValue(date, 'lastUpdated');
                    }
                },
                onCompleted (response) {
                    var _response$helpCenter0, _response$helpCenter1, _error$extensions2;
                    if ((_response$helpCenter0 = response.helpCenter) !== null && _response$helpCenter0 !== void 0 && (_response$helpCenter0 = _response$helpCenter0.updateHelpCenter) !== null && _response$helpCenter0 !== void 0 && _response$helpCenter0.success) return resolve(response);
                    const errors = (_response$helpCenter1 = response.helpCenter) === null || _response$helpCenter1 === void 0 || (_response$helpCenter1 = _response$helpCenter1.updateHelpCenter) === null || _response$helpCenter1 === void 0 ? void 0 : _response$helpCenter1.errors;
                    const error = errors && errors.length > 0 ? errors[0] : {
                        message: '',
                        extensions: {
                            statusCode: (0, $748yq.HTTP).SERVER
                        }
                    };
                    const throwableError = {
                        message: error.message,
                        status: (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.statusCode
                    };
                    return reject(throwableError);
                },
                onError: (error)=>reject(error)
            }));
    }, [
        cloudId,
        getHelpCenters,
        helpCenterUpdateMutation
    ]);
    return {
        createHelpCenter: createHelpCenter,
        updateHelpCenter: updateHelpCenter,
        deleteHelpCenter: deleteHelpCenter
    };
};

});
parcelRegister("6ZJMy", function(module, exports) {
$parcel$export(module.exports, "default", () => $9336fc6b5da5f3c8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c7d9fbf0f9f046553e76513425ceaca8>>
 * @relayHash fecf54055e7ebdf24f46943683e10daa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8
const $9336fc6b5da5f3c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "HelpCenterMutationApi",
            "kind": "LinkedField",
            "name": "helpCenter",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "HelpCenterDeletePayload",
                    "kind": "LinkedField",
                    "name": "deleteHelpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterDeleteMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2a0e9a43fa37a2bd123ff9d4bed7773d5d9e35ad5c071f1c35752ffcb0400fc8",
            "metadata": {},
            "name": "useHelpCenterDeleteMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9336fc6b5da5f3c8$var$node.hash = "7f1dd80d488ff1c4273819ebc7261544";
var $9336fc6b5da5f3c8$export$2e2bcd8739ae039 = $9336fc6b5da5f3c8$var$node;

});

parcelRegister("ew19G", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0f5e4970a7bbef5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8fd78e2f81be20d156bb6adecd5b0221>>
 * @relayHash 760113b4d7a9d899532af7823cd6a3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68
const $f0f5e4970a7bbef5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterUpdateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterUpdatePayload",
                            "kind": "LinkedField",
                            "name": "updateHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68",
            "metadata": {},
            "name": "useHelpCenterUpdateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$f0f5e4970a7bbef5$var$node.hash = "162638a77ba5d44dfe258f5e31598716";
var $f0f5e4970a7bbef5$export$2e2bcd8739ae039 = $f0f5e4970a7bbef5$var$node;

});

parcelRegister("hZOjp", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cb6e0686f3583d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0ba3a56d662a9e2657c9dae87154be20>>
 * @relayHash 6f452febb43ea4f48f12803ae2f36059
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976
const $0cb6e0686f3583d6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v6 = {
        "kind": "ScalarField",
        "name": "helpCenterAri"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useHelpCenterCreateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "HelpCenterMutationApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "HelpCenterCreatePayload",
                            "kind": "LinkedField",
                            "name": "createHelpCenter",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "f27b717aa3dee1fea8e5e08bba80fa1c21b2e8edc62a059010667c927a5cc976",
            "metadata": {},
            "name": "useHelpCenterCreateMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0cb6e0686f3583d6$var$node.hash = "50311be3a83d4bcff60feddeba10c3e5";
var $0cb6e0686f3583d6$export$2e2bcd8739ae039 = $0cb6e0686f3583d6$var$node;

});



parcelRegister("fxbaH", function(module, exports) {
$parcel$export(module.exports, "updateHelpCenterExperience", () => $73a380ec4e4937fc$export$9ee847b39a089524);
$parcel$export(module.exports, "addHelpCenterExperience", () => $73a380ec4e4937fc$export$b2a851a784010834);

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $73a380ec4e4937fc$export$88b7d3eb7bfc06a1 = 'service-management.help-center.add';
const $73a380ec4e4937fc$export$588afedc10fc2da4 = 'service-management.help-center.update';
const $73a380ec4e4937fc$export$9ee847b39a089524 = new (0, $3odV5.UFOExperience)($73a380ec4e4937fc$export$588afedc10fc2da4, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});
const $73a380ec4e4937fc$export$b2a851a784010834 = new (0, $3odV5.UFOExperience)($73a380ec4e4937fc$export$88b7d3eb7bfc06a1, {
    type: (0, $bdtMB.ExperienceTypes).Experience,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("hR6N6", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => (parcelRequire("26AJB")).HelpCenterFormFields);

var $26AJB = parcelRequire("26AJB");

});
parcelRegister("26AJB", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFields", () => $ac100cc56c23bdac$export$14ec26006a1f0ef3);

var $4fqPo = parcelRequire("4fqPo");

var $dQegt = parcelRequire("dQegt");

var $c86HE = parcelRequire("c86HE");
var $gKFeR = parcelRequire("gKFeR");

var $bNwNQ = parcelRequire("bNwNQ");

var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $bOOgP = parcelRequire("bOOgP");

var $8Mj6h = parcelRequire("8Mj6h");
parcelRequire("acPE2");
var $eQlRt = parcelRequire("eQlRt");

var $2pDGU = parcelRequire("2pDGU");

var $8drSw = parcelRequire("8drSw");

var $iCFpk = parcelRequire("iCFpk");
const $ac100cc56c23bdac$var$SLUG_VALIDATION_REGEX = /^[a-zA-Z0-9_-]{1,30}$/;
const $ac100cc56c23bdac$var$SlugInfo = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $ac100cc56c23bdac$var$slugWarningStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: formatMessage((0, $iCFpk.default).helpCenterSlugInfoTooltip),
        position: "top-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bNwNQ))), {
        label: formatMessage((0, $iCFpk.default).helpCenterSlugInfoLabel)
    })));
};
const $ac100cc56c23bdac$export$14ec26006a1f0ef3 = ({ name: name, slug: slug, urlWithoutSlug: urlWithoutSlug, mode: mode })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const nameLabel = (0, $eQlRt.useConditionalMessage)((0, $iCFpk.default).helpHubNameTextLabel, (0, $iCFpk.default).helpCenterNameTextLabel);
    const urlLabel = (0, $eQlRt.useConditionalMessage)((0, $iCFpk.default).helpHubSlugTextLabel, (0, $iCFpk.default).helpCenterSlugTextLabel);
    const validateHelpCenterName = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $8drSw.default).helpCenterNameRequiredError);
        if (value && value.length > (0, $2pDGU.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $8drSw.default).helpCenterNameCharacterLimitError);
        return undefined;
    };
    const validateHelpCenterSlug = (value)=>{
        if (!value || value.length <= 0) return formatMessage((0, $8drSw.default).helpCenterSlugRequiredError);
        if (value && value.length > (0, $2pDGU.HELPCENTER_NAME_CHARACTER_LIMIT)) return formatMessage((0, $8drSw.default).helpCenterSlugCharacterLimitError);
        if (!$ac100cc56c23bdac$var$SLUG_VALIDATION_REGEX.test(value)) return formatMessage((0, $8drSw.default).helpCenterSlugSpecialCharacterError);
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gKFeR.default), {
        name: "name",
        key: "name",
        label: formatMessage(nameLabel),
        defaultValue: name ?? '',
        validate: validateHelpCenterName,
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            paddingBlockStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bOOgP.default), {
            ...fieldProps,
            autoComplete: "off",
            autoFocus: true,
            placeholder: formatMessage((0, $iCFpk.default).helpCenterNameTextFieldPlaceholder),
            testId: "help-centers-management-name-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c86HE.ErrorMessage), null, error))), mode === 'CREATE' || slug ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gKFeR.default), {
        name: "slug",
        key: "slug",
        label: formatMessage(urlLabel),
        defaultValue: slug ?? '',
        validate: validateHelpCenterSlug,
        elementAfterLabel: mode !== 'CREATE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($ac100cc56c23bdac$var$SlugInfo, null),
        isRequired: true
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
            grow: "fill",
            shouldWrap: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            paddingBlockStart: "space.100",
            paddingInlineEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
            color: "color.text"
        }, urlWithoutSlug, '/')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
            xcss: $ac100cc56c23bdac$var$slugTextFieldStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bOOgP.default), {
            autoComplete: "off",
            ...fieldProps,
            placeholder: formatMessage((0, $iCFpk.default).helpCenterSlugTextFieldPlaceholder),
            testId: "help-centers-management-slug-field"
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $c86HE.ErrorMessage), null, error)))) : null);
};
const $ac100cc56c23bdac$var$slugTextFieldStyles = (0, $2m8U6.xcss)({
    width: '10%',
    flexGrow: 1
});
const $ac100cc56c23bdac$var$slugWarningStyles = (0, $2m8U6.xcss)({
    display: 'inline-flex',
    marginLeft: 'space.050',
    verticalAlign: 'middle'
});

});
parcelRegister("8drSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $123c5f9c26d455a4$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $123c5f9c26d455a4$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpCenterDetailsPageTitle: {
        defaultMessage: 'Details',
        description: 'Help center edit details page title',
        id: 'help.center.edit.details.page.title'
    },
    helpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.center.edit.details.page.description'
    },
    helpHubDetailsPageDescription: {
        defaultMessage: 'Customize the name and URL of your help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Help center edit details page description',
        id: 'help.hub.edit.details.page.description'
    },
    defaultHelpCenterDetailsPageDescription: {
        defaultMessage: 'Customize the name of your default help center to reflect your brand identity and effectively convey its purpose to your customers.',
        description: 'Default help center edit details page description',
        id: 'help.center.default.help.center.description'
    },
    helpCenterCreateFormTitle: {
        defaultMessage: 'Create help center',
        description: 'Help center create form title',
        id: 'help.center.create.form.title'
    },
    helpCenterCreateFormDescription: {
        defaultMessage: 'Every new help center displays all open portals on your site by default. You can edit the home page layout to show or hide portals based on the audience.',
        description: 'Help center create form description',
        id: 'help.center.create.form.description'
    },
    helpCenterEditFormTitle: {
        defaultMessage: 'Edit help center details',
        description: 'Help center edit form title',
        id: 'help.center.edit.form.title'
    },
    helpCenterAddErrorTitle: {
        defaultMessage: `We couldn\u{2019}t create your help center`,
        description: 'Title message for add help center error',
        id: 'help.center.add.error.title'
    },
    helpCenterAddSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 created",
        description: 'Title message for add help center success',
        id: 'help.center.add.success.title.text'
    },
    helpCenterAddSuccessDesc: {
        defaultMessage: 'Go to help center',
        description: 'Description message for add help center success',
        id: 'help.center.add.success.description'
    },
    helpCenterUpdateErrorTitle: {
        defaultMessage: "We couldn\u2019t update your help center",
        description: 'Title message for update help center error',
        id: 'help.center.update.error.title'
    },
    helpCenterUpdateSuccessTitleText: {
        defaultMessage: "\u2018{value}\u2019 updated",
        description: 'Title message for add help center success',
        id: 'help.center.update.success.title.text'
    },
    helpCenterGenericErrorDesc: {
        defaultMessage: 'Check your connection and try again.',
        description: 'Generic description message for help center error',
        id: 'help.center.update.error.description.generic'
    },
    helpCenterErrorDesc: {
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: '{value}',
        description: 'Description message for help center error',
        id: 'help.center.update.error.description'
    },
    helpCenterHardLimitErrorTitle: {
        defaultMessage: "You\u2019ve already created 300 help centers",
        description: 'Message title for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.title'
    },
    helpCenterHardLimitErrorDescription: {
        defaultMessage: 'Delete a help center to create another one.',
        description: 'Message description for help center hard limit reached error',
        id: 'help.center.create.hard.limit.error.description'
    },
    helpCenterNameRequiredError: {
        defaultMessage: 'Enter a name for your help center.',
        description: 'Validation error message when help center name is empty',
        id: 'help.center.name.required.validation.error'
    },
    helpCenterNameCharacterLimitError: {
        defaultMessage: 'Enter a help center name with 30 characters or less.',
        description: 'Validation error message when help center name is greater than required limit',
        id: 'help.center.name.character.limit.validation.error'
    },
    helpCenterSlugRequiredError: {
        defaultMessage: 'Add a slug.',
        description: 'Validation error message when help center slug is empty',
        id: 'help.center.slug.required.validation.error'
    },
    helpCenterSlugCharacterLimitError: {
        defaultMessage: 'Enter a slug with 30 characters or less.',
        description: 'Validation error message when help center slug is greater than required limit',
        id: 'help.center.slug.character.limit.validation.error'
    },
    helpCenterSlugSpecialCharacterError: {
        defaultMessage: `Add a slug that doesn\u{2019}t contain special characters other than hyphen (-) and underscore (_).`,
        description: 'Validation error message when help center slug contains special characters',
        id: 'help.center.slug.special.character.validation.error'
    },
    helpCenterAlreadyExistedSlugErrorDescription: {
        defaultMessage: 'A help center with this slug already exists on your site. Try again with a different slug.',
        description: 'Error message when help center slug already exists',
        id: 'help.center.already.existed.slug.error.description'
    },
    helpCenterReservedSlugErrorDescription: {
        defaultMessage: "The slug you\u2019ve entered contains a reserved term. Try again with a different slug.",
        description: 'Error message when entered slug contains reserved term',
        id: 'help.center.reserved.slug.error.description'
    },
    helpCenterRequiredFieldsWarning: {
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Required warning message for update help center fields',
        id: 'help.center.update.form.required.warning'
    }
});

});

parcelRegister("iCFpk", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6dd2b1b089b8321$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $a6dd2b1b089b8321$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpCenterNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.center.name.text.field.label.title'
    },
    helpHubNameTextLabel: {
        defaultMessage: 'Help center name',
        description: 'Help center name text field label',
        id: 'help.hub.name.text.field.label.title'
    },
    helpCenterNameTextFieldPlaceholder: {
        defaultMessage: 'Enter a help center name',
        description: 'Help center name text field placeholder',
        id: 'help.center.name.text.field.placeholder.title'
    },
    helpCenterSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.center.slug.text.field.label.title'
    },
    helpHubSlugTextLabel: {
        defaultMessage: 'Help center URL',
        description: 'Help center slug text field label',
        id: 'help.hub.slug.text.field.label.title'
    },
    helpCenterSlugInfoTooltip: {
        defaultMessage: 'Share your new help center URL with your team members and customers',
        description: 'Help center slug text change warning tooltip',
        id: 'help.center.slug.text.field.info.tooltip'
    },
    helpCenterSlugInfoLabel: {
        defaultMessage: 'Slug change info',
        description: 'Help center slug change info',
        id: 'help.center.slug.text.field.change.info.label'
    },
    helpCenterSlugTextFieldPlaceholder: {
        defaultMessage: 'Enter a slug',
        description: 'Help center slug text field placeholder',
        id: 'help.center.name.slug.field.placeholder.title'
    }
});

});



parcelRegister("8Graj", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => (parcelRequire("40leL")).HelpCenterFormFooter);

var $40leL = parcelRequire("40leL");

});
parcelRegister("40leL", function(module, exports) {
$parcel$export(module.exports, "HelpCenterFormFooter", () => $77439f6b8e439ddb$export$9f1ed90db1948ebe);

var $4fqPo = parcelRequire("4fqPo");

var $1HSOM = parcelRequire("1HSOM");

var $dQegt = parcelRequire("dQegt");

var $h7u63 = parcelRequire("h7u63");

var $d9Gpm = parcelRequire("d9Gpm");

var $7sdvR = parcelRequire("7sdvR");
const $77439f6b8e439ddb$export$9f1ed90db1948ebe = ({ submitting: submitting, mode: mode, onCancel: onCancel, isStandaloneForm: isStandaloneForm = false, isCancelDisabled: isCancelDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const renderCancelButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.Button), {
            isDisabled: isCancelDisabled,
            onClick: onCancel,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCancelCreateButton' : 'helpCenterCancelEditButton',
            key: "cancel"
        }, formatMessage((0, $7sdvR.default).helpCenterCancelButtonText));
    const renderSaveButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1HSOM.LoadingButton), {
            type: "submit",
            appearance: "primary",
            isLoading: submitting,
            actionSubjectId: mode === 'CREATE' ? 'helpCenterCreateButton' : 'helpCenterSaveButton',
            testId: "help-centers-management-primary-button",
            key: "save"
        }, formatMessage(mode === 'CREATE' ? (0, $7sdvR.default).helpCenterCreateButtonText : (0, $7sdvR.default).helpCenterSaveButtonText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d9Gpm.default), {
        align: isStandaloneForm ? 'start' : 'end'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h7u63.default), null, isStandaloneForm ? [
        renderSaveButton(),
        renderCancelButton()
    ] : [
        renderCancelButton(),
        renderSaveButton()
    ]));
};

});
parcelRegister("7sdvR", function(module, exports) {
$parcel$export(module.exports, "default", () => $7378158435c227f2$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $7378158435c227f2$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpCenterSaveButtonText: {
        defaultMessage: 'Save',
        description: 'Help center save button text',
        id: 'help.center.save.button.text'
    },
    helpCenterCancelButtonText: {
        defaultMessage: 'Cancel',
        description: 'Help center cancel button text',
        id: 'help.center.cancel.button.text'
    },
    helpCenterCreateButtonText: {
        defaultMessage: 'Create',
        description: 'Help center create button text',
        id: 'help.center.create.button.text'
    }
});

});





parcelRegister("5orWW", function(module, exports) {
$parcel$export(module.exports, "EditHelpCenterLayoutSkeleton", () => (parcelRequire("hs3vm")).default);

var $hs3vm = parcelRequire("hs3vm");

});
parcelRegister("hs3vm", function(module, exports) {
$parcel$export(module.exports, "default", () => $c02d3765dee3676f$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $j4lpV = parcelRequire("j4lpV");

var $7TPEx = parcelRequire("7TPEx");
var $9Ix81 = parcelRequire("9Ix81");
var $4hIeL = parcelRequire("4hIeL");
const $c02d3765dee3676f$var$EditHelpCenterLayoutSkeleton = ()=>{
    return /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "84px",
        height: "24px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "84px",
        height: "24px"
    })), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "20%",
        height: "28px",
        "data-testid": "edit-helpcenter-header-skeleton"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.050"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "100%",
        height: "20px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "60%",
        height: "20px"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "100%",
        height: "36px"
    }))), /*#__PURE__*/ $4fqPo.createElement((0, $7TPEx.default), {
        paddingBlockEnd: "space.200"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $4hIeL.default), {
        space: "space.100"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "10%",
        height: "16px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "50%",
        height: "20px"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "50%",
        height: "36px"
    }))))), /*#__PURE__*/ $4fqPo.createElement((0, $9Ix81.default), {
        direction: "row",
        gap: "space.050"
    }, /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "10%",
        height: "32px",
        "data-testid": "edit-helpcenter-button-skeleton"
    }), /*#__PURE__*/ $4fqPo.createElement((0, $j4lpV.SkeletonItem), {
        width: "10%",
        height: "32px"
    })));
};
var $c02d3765dee3676f$export$2e2bcd8739ae039 = $c02d3765dee3676f$var$EditHelpCenterLayoutSkeleton;

});


parcelRegister("81Whe", function(module, exports) {
$parcel$export(module.exports, "editHelpCenterExperience", () => $3c07709aa4d25ecf$export$f9e64dbdb3d531);

var $hWlSg = parcelRequire("hWlSg");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");
const $3c07709aa4d25ecf$export$f9e64dbdb3d531 = new (0, $3odV5.UFOExperience)((0, $hWlSg.editHelpCenterExperienceId), {
    type: (0, $bdtMB.ExperienceTypes).Load,
    performanceType: (0, $bdtMB.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("blAxV", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5763cf9ab2d67d0$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $c5763cf9ab2d67d0$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    errorTitle: {
        defaultMessage: 'Something went wrong',
        description: 'Error title',
        id: 'help.center.management.sidebar.error.title'
    },
    errorDescription: {
        defaultMessage: 'Refresh the page and try again',
        description: 'Error description',
        id: 'help.center.management.sidebar.error.description'
    }
});

});



parcelRegister("ggXfI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("knZyM"),
    $e46AW("eUxjk"),
    $e46AW("ibPpH"),
    $e46AW("dariE"),
    $e46AW("ADlEP"),
    $e46AW("hRvNP"),
    $e46AW("ejayw"),
    $e46AW("k0hRS"),
    $e46AW("8c53s"),
    $e46AW("7e0G7"),
    $e46AW("98Vtx"),
    $e46AW("5uglX"),
    $e46AW("d2mFO"),
    $e46AW("d0DTy"),
    $e46AW("j32MG"),
    $e46AW("hqOn7"),
    $e46AW("ionz0"),
    $e46AW("6kjcx"),
    $e46AW("cotMj"),
    $e46AW("4YETx"),
    $e46AW("5oKYR"),
    $e46AW("8oU5a"),
    $e46AW("eNoIp"),
    $e46AW("2piZ6"),
    $e46AW("0g5bk")
]).then(()=>parcelRequire('jGEFU'));

});


parcelRegister("kV2FI", function(module, exports) {
$parcel$export(module.exports, "helpcenterVirtualAgentRoute", () => $06aeba6fdae0677e$export$60952d52d9999cc1);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $bG6ob = parcelRequire("bG6ob");

var $gi5ak = parcelRequire("gi5ak");

var $dQegt = parcelRequire("dQegt");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");
parcelRequire("l8iRu");
var $lM7Z9 = parcelRequire("lM7Z9");
parcelRequire("ggpKN");
var $DwdLH = parcelRequire("DwdLH");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");

var $corqd = parcelRequire("corqd");
parcelRequire("acPE2");
var $1g7Go = parcelRequire("1g7Go");

var $eKfXA = parcelRequire("eKfXA");

var $IaPpB = parcelRequire("IaPpB");

const $06aeba6fdae0677e$var$AsyncVirtualAgentPage = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("h99m3")).then((VirtualAgentSettingsPage)=>VirtualAgentSettingsPage), {
        moduleId: "./packages/virtual-agent/virtual-agent-settings/src/index.tsx"
    })
});
const $06aeba6fdae0677e$var$VirtualAgentPage = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, $6WMcD.default)((0, $8MkVk.default)({
        redirectUrl: '/'
    }), (0, $3RiO6.default)({
        message: formatMessage((0, $corqd.authPageMessage)),
        callToActionText: formatMessage((0, $corqd.callToActionUrlText)),
        callToActionUrl: '/portals'
    }), ...(0, $bG6ob.isVAOnHelpCenterGAEnabled)() ? [] : [
        (0, $DwdLH.default)({
            message: formatMessage((0, $eKfXA.default).aiConfigNotEnabledError),
            callToActionText: formatMessage((0, $corqd.callToActionUrlText)),
            callToActionUrl: '/portals'
        })
    ])(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $1g7Go.default), {
            featureName: "Virtual Agent Settings"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($06aeba6fdae0677e$var$AsyncVirtualAgentPage, null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
const $06aeba6fdae0677e$export$60952d52d9999cc1 = {
    name: 'virtualAgentSettings',
    path: '/:helpcenterId/virtual-agent',
    exact: true,
    resources: [
        (0, $IaPpB.HelpCenterVirtualAgentResource)
    ],
    component: (0, $lM7Z9.withRouter)($06aeba6fdae0677e$var$VirtualAgentPage)
};

});
parcelRegister("eKfXA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5157cc104059b2a8$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $5157cc104059b2a8$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    helpCenterReportingPageTitle: {
        defaultMessage: 'Performance',
        description: 'Title message for Help Center Reporting',
        id: 'helpcenter.reporting.title'
    },
    helpCenterReportingPageSubtitleV2: {
        defaultMessage: 'See the performance of the virtual service agent on your help center from the last 7 days. ',
        description: 'Subtitle message for Help Center Reporting',
        id: 'helpcenter.reporting.subtitle-v-2'
    },
    // eslint-disable-next-line rulesdir/i18n-unique-message-ids
    IphLinkTextV2: {
        defaultMessage: 'Read more about using the virtual service agent on your help center.',
        description: 'Text for Link that should open in in-product help',
        id: 'helpcenter.reporting.iph-link-text-v-2'
    },
    aiConfigNotEnabledError: {
        defaultMessage: 'AI is not enabled for this portal',
        description: 'Error message when AI is not enabled for the tenant',
        id: 'helpcenter.reporting.ai.config.not.enabled.error.non-final'
    }
});

});

parcelRegister("IaPpB", function(module, exports) {
$parcel$export(module.exports, "HelpCenterVirtualAgentResource", () => $6b915d08f6817c4b$export$7ab6648586bf1bbf);

var $bG6ob = parcelRequire("bG6ob");

var $6mmHn = parcelRequire("6mmHn");

var $4oTiM = parcelRequire("4oTiM");

var $ebpTf = parcelRequire("ebpTf");

var $fZppw = parcelRequire("fZppw");

var $5kA7H = parcelRequire("5kA7H");
const $6b915d08f6817c4b$export$7ab6648586bf1bbf = (0, $fZppw.createRelayResource)({
    type: 'HELP_REPORTING_PAGE',
    getQuery: ({ match: match }, { cloudId: cloudId, helpCenterAri: helpCenterAri })=>{
        let computedHelpCenterAri = helpCenterAri;
        const activationId = (0, $6mmHn.getMeta)('activation-id') || '';
        const helpCenterId = match.params.helpcenterId || '';
        computedHelpCenterAri = (0, $4oTiM.HelpHelpCenterAri).create({
            activationId: activationId,
            helpCenterId: helpCenterId
        }).toString();
        // Fall back to original helpCenterAri if computation fails (e.g., missing params in tests)
        const finalHelpCenterAri = computedHelpCenterAri || helpCenterAri;
        return {
            parameters: (0, $5kA7H.default),
            variables: {
                cloudId: cloudId,
                helpCenterAri: finalHelpCenterAri,
                isJsmAIConfigEnabled: (0, $ebpTf.getJsmAIConfigEnabled)(),
                isVAOnHelpCenterGAEnabled: (0, $bG6ob.isVAOnHelpCenterGAEnabled)(),
                isHideKbColumnEnabled: (0, $bG6ob.isHideKbColumnEnabled)(),
                isTotalArticleCountEnabled: (0, $bG6ob.isTotalArticleCountEnabled)()
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("5kA7H", function(module, exports) {
$parcel$export(module.exports, "default", () => $64cec1e2aebc781e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6bb91c1dc2b4e58c2ef9ee0822d8ca64>>
 * @relayHash 127cb5587f2a92a32c9a887addd1d130
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393
const $64cec1e2aebc781e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "helpCenterAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideKbColumnEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isJsmAIConfigEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTotalArticleCountEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isVAOnHelpCenterGAEnabled"
    }, v6 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "kind": "Variable",
        "name": "helpCenterAri",
        "variableName": "helpCenterAri"
    }, v9 = [
        v8 /*: any*/ 
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "virtualAgentEnabled"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ],
        "type": "QueryError"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "limit",
            "value": 1
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "id"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "kind": "InlineFragment",
        "selections": v15 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v17 = [
        v6 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "helpCenterARI",
                    "variableName": "helpCenterAri"
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterId",
                    "value": ""
                },
                {
                    "kind": "Literal",
                    "name": "helpCenterMappingStatus",
                    "value": "LINKED"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "settingsVirtualAgentSettingsTabFragment"
                                                },
                                                v11 /*: any*/ 
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v12 /*: any*/ ,
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "settingsBreadcrumbsFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "settingsVirtualAgentLinkedArticlesFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isVAOnHelpCenterGAEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "isHideKbColumnEnabled",
                                    "variableName": "isHideKbColumnEnabled"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isVAOnHelpCenterGAEnabled",
                                    "variableName": "isVAOnHelpCenterGAEnabled"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "settingsVirtualAgentSettingsTabMappedProjectsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "selections": [
                {
                    "condition": "isJsmAIConfigEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryApi",
                            "kind": "LinkedField",
                            "name": "helpCenter",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v9 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "helpCenterById",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v11 /*: any*/ ,
                                                {
                                                    "concreteType": "HelpCenterName",
                                                    "kind": "LinkedField",
                                                    "name": "name",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "default"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "slug"
                                                }
                                            ],
                                            "type": "HelpCenter"
                                        },
                                        v12 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isTotalArticleCountEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v13 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpObjectStore_searchArticles",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHelpObjectStoreArticleSearchResponse"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        }
                                    ],
                                    "type": "HelpObjectStoreArticleSearchResults"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "isVAOnHelpCenterGAEnabled",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "condition": "isVAOnHelpCenterGAEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "JiraQuery",
                                    "kind": "LinkedField",
                                    "name": "jira",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v17 /*: any*/ ,
                                            "concreteType": "JiraProjectConnection",
                                            "kind": "LinkedField",
                                            "name": "jiraProjectsMappedToHelpCenter",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraProjectEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "name"
                                                                },
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "isHideKbColumnEnabled",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": v7 /*: any*/ ,
                                                                            "kind": "LinkedField",
                                                                            "name": "knowledgeBaseArticlesCount",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v10 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "count"
                                                                                        }
                                                                                    ],
                                                                                    "type": "KnowledgeBaseArticleCountSource"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "virtualAgentConfiguration",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isAiResponsesEnabled"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "liveIntentsCount"
                                                                                }
                                                                            ],
                                                                            "type": "VirtualAgentConfiguration"
                                                                        },
                                                                        v16 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "VirtualAgentQueryError"
                                                                        }
                                                                    ]
                                                                },
                                                                v10 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "cursor"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "PageInfo",
                                                    "kind": "LinkedField",
                                                    "name": "pageInfo",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "endCursor"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "hasNextPage"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "args": v17 /*: any*/ ,
                                            "filters": [
                                                "cloudId",
                                                "filter"
                                            ],
                                            "handle": "connection",
                                            "key": "projectBreakdownTableMappedProjectsFragment_jiraProjectsMappedToHelpCenter",
                                            "kind": "LinkedHandle",
                                            "name": "jiraProjectsMappedToHelpCenter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c090c3adcd49e9b8d1327fa26dca86a9d8e82bf6747475b17f94ba52ad76e393",
            "metadata": {},
            "name": "srcHelpCenterVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$64cec1e2aebc781e$var$node.hash = "6836684020e009f1da0ca82a53368cd7";
var $64cec1e2aebc781e$export$2e2bcd8739ae039 = $64cec1e2aebc781e$var$node;

});


parcelRegister("h99m3", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("5vNQu").then(()=>parcelRequire('euMTb'));

});


parcelRegister("1pFM5", function(module, exports) {
$parcel$export(module.exports, "viewHelpCentersManagementPageRoute", () => $ca47affe68c8cd37$export$e49071c21a45635e);
$parcel$export(module.exports, "viewHelpHubsManagementPageRoute", () => $ca47affe68c8cd37$export$589f7c1da1d95244);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("2pQ8V");
var $6WMcD = parcelRequire("6WMcD");

var $748yq = parcelRequire("748yq");

var $dQegt = parcelRequire("dQegt");
parcelRequire("6QlXC");
var $3RiO6 = parcelRequire("3RiO6");
parcelRequire("3va4S");
var $8MkVk = parcelRequire("8MkVk");
parcelRequire("fBIez");
var $fx3sW = parcelRequire("fx3sW");
var $k78eO = parcelRequire("k78eO");
const $ca47affe68c8cd37$var$HelpCentersManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>(0, $6WMcD.default)((0, $8MkVk.default)({
            redirectUrl: '/'
        }), (0, $3RiO6.default)({
            message: formatMessage((0, $fx3sW.authPageMessage)),
            callToActionText: formatMessage((0, $fx3sW.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $fx3sW.HelpCentersManagementPage)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
const $ca47affe68c8cd37$var$HelpHubsManagement = ()=>{
    const { formatMessage: formatMessage } = (0, $dQegt.default)();
    const WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).useMemo(()=>(0, $6WMcD.default)((0, $8MkVk.default)({
            redirectUrl: '/'
        }), (0, $3RiO6.default)({
            message: formatMessage((0, $fx3sW.authPageMessage)),
            callToActionText: formatMessage((0, $fx3sW.callToActionUrlText)),
            callToActionUrl: ''
        }))((0, $fx3sW.HelpCentersManagementPage)), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(WrappedComponent, null);
};
const $ca47affe68c8cd37$export$e49071c21a45635e = {
    name: (0, $748yq.ScreenName).HELP_CENTERS_MANAGEMENT,
    path: '/',
    exact: true,
    component: $ca47affe68c8cd37$var$HelpCentersManagement,
    resources: [
        (0, $k78eO.HelpCentersManagementResource)
    ]
};
const $ca47affe68c8cd37$export$589f7c1da1d95244 = {
    name: (0, $748yq.ScreenName).HELP_HUBS_MANAGEMENT,
    path: '/hubs',
    exact: true,
    component: $ca47affe68c8cd37$var$HelpHubsManagement,
    resources: [
        (0, $k78eO.HelpCentersManagementResource)
    ]
};

});
parcelRegister("fBIez", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => (parcelRequire("fx3sW")).HelpCentersManagementPage);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("k78eO")).HelpCentersManagementResource);
$parcel$export(module.exports, "callToActionUrlText", () => (parcelRequire("fx3sW")).callToActionUrlText);
$parcel$export(module.exports, "authPageMessage", () => (parcelRequire("fx3sW")).authPageMessage);

var $fx3sW = parcelRequire("fx3sW");
var $k78eO = parcelRequire("k78eO");
parcelRequire("cYYPV");
var $kZ8S8 = parcelRequire("kZ8S8");

});
parcelRegister("fx3sW", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementPage", () => $69928a9a2bd5bfed$export$233bfa78dd235938);
$parcel$export(module.exports, "callToActionUrlText", () => $69928a9a2bd5bfed$export$d96795d242b62963);
$parcel$export(module.exports, "authPageMessage", () => $69928a9a2bd5bfed$export$5342e2a00fe6d647);
$parcel$export(module.exports, "HelpCentersManagementResource", () => (parcelRequire("k78eO")).HelpCentersManagementResource);

var $gi5ak = parcelRequire("gi5ak");
parcelRequire("aPBSl");
var $60vf0 = parcelRequire("60vf0");

var $8R7wz = parcelRequire("8R7wz");

var $k78eO = parcelRequire("k78eO");

const $69928a9a2bd5bfed$export$233bfa78dd235938 = (0, $gi5ak.default)({
    loader: (0, $60vf0.lazyForPaint)(()=>(parcelRequire("bROUl")), {
        moduleId: "./packages/help-center/help-centers-management/src/ui/help-centers-management-page/help-centers-management-page.tsx"
    })
});
const $69928a9a2bd5bfed$export$d96795d242b62963 = (0, $8R7wz.default).callToActionUrlText;
const $69928a9a2bd5bfed$export$5342e2a00fe6d647 = (0, $8R7wz.default).authPageMessage;

});
parcelRegister("8R7wz", function(module, exports) {
$parcel$export(module.exports, "default", () => $88dadff75b36b2e2$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $88dadff75b36b2e2$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    headerTextHelpCenter: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text',
        id: 'help.center.management.page.header.text'
    },
    headerTextHelpHub: {
        defaultMessage: 'Help centers',
        description: 'Help centers management screen header text hubs',
        id: 'help.center.management.page.header.text.hubs'
    },
    headerDescriptionHelpCenter: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description'
    },
    headerDescriptionReadMoreLinkHelpCenter: {
        defaultMessage: 'Read more about help centers',
        description: 'Help centers management screen header description read more link',
        id: 'help.center.management.page.header.description.read.more.link'
    },
    headerDescriptionHelpHub: {
        defaultMessage: 'Set up and manage your help centers here.',
        description: 'Help centers management screen header description',
        id: 'help.center.management.page.header.description.hubs'
    },
    addButtonTextHelpCenter: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen add help center button text',
        id: 'help.center.management.add.help.center.button.text'
    },
    addButtonTextHelpHub: {
        defaultMessage: 'Create help center',
        description: 'Help centers management screen create button text',
        id: 'help.center.management.create.button.text.hubs'
    },
    createOptionHelpCenterTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option help center title',
        id: 'help.center.management.create.option.help.center.title'
    },
    createOptionHelpCenterDescription: {
        defaultMessage: 'The default help experience with portals, topics, and more',
        description: 'Help centers management screen create option help center description',
        id: 'help.center.management.create.option.help.center.description'
    },
    createOptionHubTitle: {
        defaultMessage: 'Help center',
        description: 'Help centers management screen create option hub title',
        id: 'help.center.management.create.option.hub.title'
    },
    createOptionHubDescription: {
        defaultMessage: 'Create a modern help experience with components and customization',
        description: 'Help centers management screen create option hub description',
        id: 'help.center.management.create.option.hub.description'
    },
    genericErrorHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.heading'
    },
    genericErrorMessage: {
        defaultMessage: "Looks like we\u2019re having trouble retrieving some information, please refresh the page.",
        description: 'Generic error when something could not be loaded',
        id: 'help.center.management.page.generic.error.message'
    },
    authPageMessage: {
        defaultMessage: `You don't have permission to view this page.`,
        description: 'Message text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.message'
    },
    callToActionUrlText: {
        defaultMessage: 'Go to help center',
        description: 'Call to action text for unauthorized page of portal reordering',
        id: 'help.center.management.page.un.auth.action.text'
    },
    upgradeTitleCreateClick: {
        defaultMessage: 'Upgrade to create new help centers',
        description: 'Popup title to upgrade to create help center',
        id: 'help.center.management.upgrade.title.create.click'
    },
    upgradeDescriptionCreateClick: {
        defaultMessage: 'You need to be on a Premium or Enterprise plan to create multiple help centers on your site.',
        description: 'Popup description to upgrade to create help center',
        id: 'help.center.management.upgrade.description.create.click'
    },
    helpHubEmptyStateHeader: {
        defaultMessage: 'Create modern help centers to serve your customers',
        description: 'Help center empty state header',
        id: 'help.center.management.page.help.hub.empty.state.header'
    },
    helpHubEmptyStateDescription: {
        defaultMessage: 'Empower customers to find answers with knowledge base articles or get support by raising requests in Jira Service Management.',
        description: 'Help center empty state description',
        id: 'help.center.management.page.help.hub.empty.state.description'
    }
});

});

parcelRegister("k78eO", function(module, exports) {
$parcel$export(module.exports, "HelpCentersManagementResource", () => $6ac4adabcf3e5e32$export$7e2ebb4b559ed1ce);

var $748yq = parcelRequire("748yq");

var $6bGmX = parcelRequire("6bGmX");

var $fZppw = parcelRequire("fZppw");

var $2pDGU = parcelRequire("2pDGU");

var $622m1 = parcelRequire("622m1");
const $6ac4adabcf3e5e32$export$7e2ebb4b559ed1ce = (0, $fZppw.createRelayResource)({
    type: 'HELP_CENTERS_MANAGEMENT',
    getQuery: ({ route: route }, { cloudId: cloudId, workspaceAri: workspaceAri })=>{
        const isHelpHubRoute = route.name === (0, $748yq.ScreenName).HELP_HUBS_MANAGEMENT;
        const filterType = isHelpHubRoute ? 'HELP_HUB' : 'BASIC';
        return {
            parameters: (0, $622m1.default),
            variables: {
                cloudId: cloudId,
                workspaceAri: workspaceAri,
                SORT_ORDER: $2pDGU.SORT_ORDER,
                NUMBER_OF_HELP_CENTERS_INITIAL_FETCH: $2pDGU.NUMBER_OF_HELP_CENTERS_INITIAL_FETCH,
                filterType: (0, $6bGmX.default).checkGate('enable-jsm-in-hubs') ? filterType : null
            },
            options: {
                fetchPolicy: 'store-or-network'
            }
        };
    }
});

});
parcelRegister("622m1", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f3167c9176322c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d62e524846e4a4fbfdb24064e9a2882f>>
 * @relayHash bfac5bcd27aeada23cd69a482e5f987f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f188fcb4a9e41becef087e9550e84163d2d7c12b335d6dc8730860e3e08c584
const $8f3167c9176322c9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "SORT_ORDER"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceAri"
    }, v5 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v6 = {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
    }, v7 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "filterType"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
        },
        {
            "kind": "Variable",
            "name": "sortOrder",
            "variableName": "SORT_ORDER"
        },
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "slug"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            v9 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH",
                            "variableName": "NUMBER_OF_HELP_CENTERS_INITIAL_FETCH"
                        },
                        {
                            "kind": "Variable",
                            "name": "SORT_ORDER",
                            "variableName": "SORT_ORDER"
                        },
                        v5 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "filterType",
                            "variableName": "filterType"
                        },
                        v6 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "helpCentersManagementPageFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "helpCentersManagementPageQuery",
            "selections": [
                {
                    "args": [
                        v5 /*: any*/ 
                    ],
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v7 /*: any*/ ,
                            "concreteType": "HelpCenterQueryResultConnection",
                            "kind": "LinkedField",
                            "name": "helpCenters",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HelpCenterQueryResultEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterName",
                                                            "kind": "LinkedField",
                                                            "name": "name",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "default"
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterTranslation",
                                                                    "kind": "LinkedField",
                                                                    "name": "translations",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "locale"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "HelpCenterBranding",
                                                            "kind": "LinkedField",
                                                            "name": "helpCenterBranding",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isBannerAvailable"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "useDefaultBanner"
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBrandingColors",
                                                                    "kind": "LinkedField",
                                                                    "name": "colors",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "primary"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "HelpCenterBanner",
                                                                    "kind": "LinkedField",
                                                                    "name": "banner",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdated"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "mappedProjectsCount"
                                                        }
                                                    ],
                                                    "type": "HelpCenter"
                                                },
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        },
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v7 /*: any*/ ,
                            "filters": [
                                "filter"
                            ],
                            "handle": "connection",
                            "key": "helpCentersManagementPageFragment_helpCenters",
                            "kind": "LinkedHandle",
                            "name": "helpCenters"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1f188fcb4a9e41becef087e9550e84163d2d7c12b335d6dc8730860e3e08c584",
            "metadata": {},
            "name": "helpCentersManagementPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8f3167c9176322c9$var$node.hash = "767d192c1eee830ece678d269a62c024";
var $8f3167c9176322c9$export$2e2bcd8739ae039 = $8f3167c9176322c9$var$node;

});


parcelRegister("bROUl", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = Promise.all([
    $e46AW("iQNpA"),
    $e46AW("auN5u"),
    $e46AW("ixH4T"),
    $e46AW("9P6Mq"),
    $e46AW("958rd"),
    $e46AW("367yc"),
    $e46AW("jZPNc"),
    $e46AW("d2mFO"),
    $e46AW("k2Z1V"),
    $e46AW("bJA32")
]).then(()=>parcelRequire('8yXKE'));

});





parcelRegister("12TH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb22940ad4097f6b$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");

var $el3DQ = parcelRequire("el3DQ");

var $bG6ob = parcelRequire("bG6ob");

var $l9AOu = parcelRequire("l9AOu");

var $dfktK = parcelRequire("dfktK");

parcelRequire("l8iRu");
var $7H5nz = parcelRequire("7H5nz");
var $8NB5B = parcelRequire("8NB5B");

var $j7rgu = parcelRequire("j7rgu");

var $jYI2M = parcelRequire("jYI2M");

var $8tPCL = parcelRequire("8tPCL");

var $9bbBv = parcelRequire("9bbBv");

var $dq1KB = parcelRequire("dq1KB");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $4we4O = parcelRequire("4we4O");
parcelRequire("fpAYG");
var $gQA2V = parcelRequire("gQA2V");

var $6bGmX = parcelRequire("6bGmX");

var $3wR8f = parcelRequire("3wR8f");

var $4xSvu = parcelRequire("4xSvu");

var $5VtTl = parcelRequire("5VtTl");
const $fb22940ad4097f6b$export$2f7745f2f5ab3897 = ()=>{
    return [
        (0, $gQA2V.getHubHomepageRoute)(),
        (0, $gQA2V.getHubCustompageRoute)(),
        ...(0, $6bGmX.default).checkGate('portal-pages-in-hub') ? [
            (0, $gQA2V.getHubPortalPageRoute)()
        ] : [],
        /**
   * Account Management Pages
   */ (0, $gQA2V.getLoginRouteWithHubShell)(),
        (0, $gQA2V.getPortalLoginRouteWithHubShell)(),
        (0, $gQA2V.getResetPasswordRouteWithHubShell)(),
        (0, $gQA2V.getPortalResetPasswordRouteWithHubShell)(),
        (0, $gQA2V.getSignupRouteWithHubShell)(),
        (0, $gQA2V.getPortalSignupRouteWithHubShell)(),
        (0, $gQA2V.getCompleteSignupRouteWithHubShell)(),
        (0, $gQA2V.getPortalCompleteSignupRouteWithHubShell)(),
        (0, $gQA2V.getPortalInvitedSignupRouteWithHubShell)(),
        (0, $gQA2V.getCheckEmailRouteWithHubShell)(),
        (0, $gQA2V.getUnsubscribeRouteWithHubShell)(),
        (0, $gQA2V.getHubUserProfileRouteWithHubShell)(),
        (0, $gQA2V.getPortalAccessForbiddenRouteWithHubShell)(),
        (0, $j7rgu.consentFormRoute /* TODO: The consent form route needs the Hub Shell */ ),
        ...(0, $bG6ob.isEmailVerifiedSignalEnabled)() ? [
            (0, $dq1KB.userVerifyEmailRoute)
        ] : [],
        /**
   * Request Management Pages
   */ (0, $gQA2V.getRequestCreateRouteWithHubShell)(),
        (0, $gQA2V.getAnonymousRequestSuccessRouteWithHubShell)(),
        (0, $gQA2V.getRequestFeedbackRouteWithHubShell)(),
        (0, $gQA2V.getJsmRequestDetailsRouteWithHubShell)(),
        (0, $gQA2V.getJsmRequestsListRouteWithHubShell)(),
        (0, $gQA2V.getJsmApprovalsRouteWithHubShell)(),
        (0, $gQA2V.getJsmRequestApprovalRouteWithHubShell)(),
        ...(0, $bG6ob.isSurveysRouteEnabled)() ? [
            (0, $gQA2V.getSurveyRouteWithHubShell)()
        ] : [],
        /** TODO: Article Pages */ (0, $gQA2V.getHubViewKbRoute)(),
        (0, $gQA2V.getHubViewArticleRoute)(),
        (0, $gQA2V.getHubViewCrossSiteArticleRoute)(),
        (0, $gQA2V.getHubViewPortalArticleRoute)(),
        (0, $gQA2V.getHubViewCrossSitePortalArticleRoute)(),
        /**
   * Search related pages
   */ (0, $9bbBv.viewAllSearchResultsRoute),
        /**
   * Hub Management pages
   */ (0, $8tPCL.helpcenterEditRoute),
        (0, $8tPCL.helpcenterManageProjectsRoute),
        (0, $8tPCL.helpcenterManageCustomPagesRoute),
        /**
   * EmbeddablePages
   */ (0, $jYI2M.getEmbedCreateRequestRoute)(),
        (0, $jYI2M.embedKBArticleRoute),
        /**
   * Not found route
   */ (0, $gQA2V.getNotFoundRouteWithHubShell)()
    ];
};
const $fb22940ad4097f6b$export$bd848585fb624145 = (props)=>{
    const { themeColor: themeColor, titleColor: titleColor } = props;
    const readableTextColorFromTheme = (0, $l9AOu.readableTextColor)(themeColor);
    const lightColorFromTheme = (0, $l9AOu.lightenColor)(themeColor);
    const routes = (0, $4fqPo.useMemo)(()=>$fb22940ad4097f6b$export$2f7745f2f5ab3897(), []);
    const location = globalThis.location.pathname + globalThis.location.search;
    const theme = {
        titleColor: titleColor,
        readableTextColor: readableTextColorFromTheme,
        color: themeColor,
        lightColor: lightColorFromTheme
    };
    //isGlobal=false, to avoid the router conflicting with the sidebar's router.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $el3DQ.ThemeProvider), {
        theme: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8NB5B.Router), {
        routes: routes,
        history: (0, $3wR8f.default),
        isGlobal: false,
        plugins: [
            (0, $5VtTl.resourcesPlugin)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dfktK.GlobalStyled), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4we4O.UFOWatcher), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7H5nz.RouteComponent), null), (0, $6bGmX.default).checkGate('enable_rovo_in_help_hubs') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4xSvu.RovoWidgetRenderer), null)));
};
const $fb22940ad4097f6b$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getThemeColor), (0, $i8gmD.getHelpCenterTitleColor), (themeColor, titleColor)=>({
        themeColor: themeColor,
        titleColor: titleColor
    }));
var $fb22940ad4097f6b$export$2e2bcd8739ae039 = (0, $bmgw6.default)($fb22940ad4097f6b$var$selector)($fb22940ad4097f6b$export$bd848585fb624145);

});
parcelRegister("4xSvu", function(module, exports) {
$parcel$export(module.exports, "RovoWidgetRenderer", () => $eb113e28a1090494$export$5d23099fbd84d512);

var $4fqPo = parcelRequire("4fqPo");

var $6mmHn = parcelRequire("6mmHn");
parcelRequire("l8iRu");
var $hfD9S = parcelRequire("hfD9S");

var $3nE6H = parcelRequire("3nE6H");
// Route names to exclude from showing the Rovo widget
const $eb113e28a1090494$var$EXCLUDED_ROVO_WIDGET_ROUTES = [
    'hub',
    'hub-custom-page'
];
const $eb113e28a1090494$export$5d23099fbd84d512 = ()=>{
    var _routerState$route;
    const [routerState] = (0, $hfD9S.useRouter)();
    const currentRouteName = (_routerState$route = routerState.route) === null || _routerState$route === void 0 ? void 0 : _routerState$route.name;
    if (!currentRouteName || $eb113e28a1090494$var$EXCLUDED_ROVO_WIDGET_ROUTES.includes(currentRouteName)) return null;
    const cloudId = (0, $6mmHn.getCloudId)();
    const helpCenterAri = (0, $6mmHn.getHelpCenterAri)();
    if (!cloudId || !helpCenterAri) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3nE6H.RovoServiceAgentWidgetInjector), {
        siteId: cloudId,
        widgetId: helpCenterAri,
        surface: "HUB"
    });
};

});


parcelRegister("7IzBc", function(module, exports) {
$parcel$export(module.exports, "JSMCookieConsentBanner", () => (parcelRequire("lJuxo")).SSRSafeJSMCookieConsentBanner);

var $lJuxo = parcelRequire("lJuxo");

});
parcelRegister("lJuxo", function(module, exports) {
$parcel$export(module.exports, "SSRSafeJSMCookieConsentBanner", () => $894b47aee1f70efb$export$757e76e75a25cb0c);

var $4fqPo = parcelRequire("4fqPo");

var $hUDsc = parcelRequire("hUDsc");

var $2Itg6 = parcelRequire("2Itg6");
var $4jOFo = parcelRequire("4jOFo");
var $cnMPG = parcelRequire("cnMPG");
var $6EQJz = parcelRequire("6EQJz");
const $894b47aee1f70efb$export$757e76e75a25cb0c = ()=>{
    const ssrInput = (0, $hUDsc.getSSRInput)();
    const consentToken = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesConsentToken);
    const fallbackConsentToken = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)) || (ssrInput === null || ssrInput === void 0 ? void 0 : ssrInput.cookiesFallbackToken);
    const cookieData = consentToken ? {
        consentToken: consentToken,
        fallbackConsentToken: fallbackConsentToken
    } : {
        fallbackConsentToken: fallbackConsentToken
    };
    (0, $4fqPo.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        (0, $6EQJz.initializeControls)({
            product: 'jira'
        });
    }, []);
    // The case of only the fallbackConsentToken being present is handled differently on the
    // server and on the client. So in order to SSR the same way, we have handle this case
    // specially. Only fallback token being present on the client results in banner not being shown.
    // However, if we pass that cookie data into the initialPreferences on the client, there is a short
    // flicker of the consent banner. So we also have to special case this on the client.
    const onlyFallbackTokenPresent = Boolean(fallbackConsentToken && !consentToken);
    return(// Wrapper needed for stable DOM to rehydrate. Otherwise, rehydration failures may break the entire page when
    // this returns a banner in SSR and no banner/null in CSR (or the other way around).
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        "data-testid": 'jsm-cookie-consent-banner-wrapper'
    }, onlyFallbackTokenPresent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4jOFo.ConsentBanner), {
        product: "jira"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4jOFo.ConsentBanner), {
        product: "jira",
        initialPreferences: cookieData
    })));
};

});
parcelRegister("hUDsc", function(module, exports) {
$parcel$export(module.exports, "getSSRInput", () => $be09d47af3dac685$export$57d34b7c393d6ac0);

const $be09d47af3dac685$export$57d34b7c393d6ac0 = ()=>{
    var error;
    return undefined;
};

});

parcelRegister("4jOFo", function(module, exports) {
$parcel$export(module.exports, "ConsentBanner", () => $a42c708255ef84d2$export$903b95b8397e77e9);

var $4fqPo = parcelRequire("4fqPo");

var $BYXH4 = parcelRequire("BYXH4");

var $lqGAl = parcelRequire("lqGAl");

var $3H4LK = parcelRequire("3H4LK");

var $KilRp = parcelRequire("KilRp");

var $ig1Da = parcelRequire("ig1Da");
const $a42c708255ef84d2$export$903b95b8397e77e9 = (props)=>{
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $3H4LK.fg)('platform_moonjelly_bsc_ui_killswitch')) {
        const { onConsentBannerBailOut: onConsentBannerBailOut } = props;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $4fqPo.useEffect)(()=>{
            onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
        }, [
            onConsentBannerBailOut
        ]);
        // Don't render the consent banner if the killswitch is enabled
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $BYXH4.ErrorBoundary), {
        FallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
                "data-testid": "consent-banner-render-error"
            }),
        onError: (e)=>{
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'renderConsentBannerError',
                message: e.message || ''
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lqGAl.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $ig1Da.ConsentBannerImpl), props)));
};

});
parcelRegister("lqGAl", function(module, exports) {
$parcel$export(module.exports, "useFlags", () => $9138833c071bc4dd$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $9138833c071bc4dd$export$a4270ab432ac8a58);

var $4fqPo = parcelRequire("4fqPo");

var $25gao = parcelRequire("25gao");

var $edOls = parcelRequire("edOls");

var $h1mlL = parcelRequire("h1mlL");
const $9138833c071bc4dd$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createContext(null);
function $9138833c071bc4dd$export$2879604e6aec4ab() {
    const api = (0, $4fqPo.useContext)($9138833c071bc4dd$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $9138833c071bc4dd$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $9138833c071bc4dd$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $4fqPo.useState)([]);
    const removeFlag = (0, $4fqPo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $4fqPo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $9138833c071bc4dd$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($9138833c071bc4dd$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $h1mlL.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
        const FlagType = isAutoDismiss ? (0, $25gao.default) : (0, $edOls.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement(FlagType, {
            ...restProps,
            key: flag.id
        });
    })));
}
const $9138833c071bc4dd$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($9138833c071bc4dd$export$a4270ab432ac8a58, null, fn());

});

parcelRegister("ig1Da", function(module, exports) {
$parcel$export(module.exports, "ConsentBannerImpl", () => $494d2b2d9fec808b$export$24af610f9b900e82);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $4fqPo = parcelRequire("4fqPo");

var $3rTf2 = parcelRequire("3rTf2");
var $4MCQn = parcelRequire("4MCQn");

var $lqGAl = parcelRequire("lqGAl");

var $geWWn = parcelRequire("geWWn");

var $3RpuA = parcelRequire("3RpuA");

var $3H4LK = parcelRequire("3H4LK");

var $g6gA9 = parcelRequire("g6gA9");

var $jx6p8 = parcelRequire("jx6p8");
var $hTxA3 = parcelRequire("hTxA3");

var $5u7bC = parcelRequire("5u7bC");

var $KilRp = parcelRequire("KilRp");

var $2Itg6 = parcelRequire("2Itg6");

var $jz4E1 = parcelRequire("jz4E1");
var $cnMPG = parcelRequire("cnMPG");

var $fbg3F = parcelRequire("fbg3F");

var $bAAae = parcelRequire("bAAae");

var $3uWOJ = parcelRequire("3uWOJ");

var $ljIaq = parcelRequire("ljIaq");

var $7Phxn = parcelRequire("7Phxn");

var $lc4vG = parcelRequire("lc4vG");
const $494d2b2d9fec808b$var$SuccessWithIntl = (0, $3rTf2.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3RpuA))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.success',
            defaultMessage: 'Success',
            description: 'The text is shown as the title of a success toast notification that appears in the consent banner after the user successfully saves their cookie preferences.'
        }),
        spacing: (0, $3H4LK.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $494d2b2d9fec808b$var$ErrorWithIntl = (0, $3rTf2.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($geWWn))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: intl.formatMessage({
            id: 'browser-storage-controls.consent-banner.toast.error',
            defaultMessage: 'Error',
            description: 'The title for an error as a single word.'
        }),
        spacing: (0, $3H4LK.fg)('eoc-visual-refresh-phase-two') ? 'spacious' : 'none'
    }));
const $494d2b2d9fec808b$var$errorToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($494d2b2d9fec808b$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $494d2b2d9fec808b$var$successToastProps = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($494d2b2d9fec808b$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });
const $494d2b2d9fec808b$export$24af610f9b900e82 = ({ onShow: onShow, onHide: onHide, initialPreferences: initialPreferences, minWidth: minWidth = 400, product: product, onConsentBannerBailOut: onConsentBannerBailOut, analyticsEnabled: analyticsEnabled = true, localConsentMode: localConsentMode = false, newMinHeight: newMinHeight, ssrOptions: ssrOptions, perimeter: perimeter = 'commercial' })=>{
    const firstRender = (0, $4fqPo.useRef)(true);
    (0, $4fqPo.useEffect)(()=>{
        if (!firstRender.current) return;
        // Send an operational event if the banner is shown after previously having
        // been dismissed. This will help prevent issues with the banner
        // inappropriately reappearing.
        const lastBannerDismissal = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        if (lastBannerDismissal) {
            const timeSinceDismissal = Date.now() - new Date(Number.parseInt(lastBannerDismissal)).getTime();
            const lessThanOneHour = timeSinceDismissal < 3600000;
            const lessThanOneDay = timeSinceDismissal < 86400000;
            const lessThanOneWeek = timeSinceDismissal < 604800000;
            (0, $hTxA3.sendPackageOperationalEvent)({
                action: 'bannerAppearanceAfterDismissal',
                attributes: {
                    timeSinceDismissal: timeSinceDismissal,
                    lessThanOneHour: lessThanOneHour,
                    lessThanOneDay: lessThanOneDay,
                    lessThanOneWeek: lessThanOneWeek
                }
            });
            (0, $jz4E1.deleteCookie)((0, $2Itg6.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY));
        }
        firstRender.current = false;
    }, []);
    (0, $4fqPo.useEffect)(()=>{
        if ((0, $3H4LK.fg)('fedramp-consent-banner-perimeter-prop')) (0, $jx6p8.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode,
            perimeter: perimeter
        });
        else (0, $jx6p8.initializeGlobalState)({
            analyticsEnabled: analyticsEnabled,
            product: product,
            localConsentMode: localConsentMode
        });
    }, [
        analyticsEnabled,
        product,
        localConsentMode,
        perimeter
    ]);
    const [isPreferencesModalOpen, setIsPreferencesModalOpen] = (0, $4fqPo.useState)(false);
    const intl = (0, $4MCQn.default)();
    const { showFlag: showFlag } = (0, $lqGAl.useFlags)();
    const { preferences: preferences, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isInitialRender: isInitialRender } = (0, $ljIaq.default)({
        initialPreferences: initialPreferences
    });
    const { showBanner: showBanner, setIsDismissed: setIsDismissed } = (0, $lc4vG.default)({
        preferences: preferences,
        isPrefetchedPreferencesState: isPrefetchedPreferencesState,
        initialPreferences: initialPreferences,
        isInitialRender: isInitialRender,
        ssrOptions: ssrOptions
    });
    const closePreferenceModal = (0, $4fqPo.useCallback)(()=>{
        setIsPreferencesModalOpen(false);
    }, [
        setIsPreferencesModalOpen
    ]);
    const onPreferenceModalSubmit = (0, $4fqPo.useCallback)(()=>{
        closePreferenceModal();
        setIsDismissed(true);
    }, [
        closePreferenceModal,
        setIsDismissed
    ]);
    const onClickPreferences = (0, $4fqPo.useCallback)(()=>{
        setIsPreferencesModalOpen(true);
        (0, $hTxA3.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preferences',
            source: 'cookieConsentBanner'
        });
    }, []);
    const showSuccessFlag = (0, $4fqPo.useCallback)(()=>{
        if (localConsentMode) showFlag({
            ...$494d2b2d9fec808b$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $bAAae.i18n).successFlagDescriptionLocalOnly),
            title: intl.formatMessage((0, $bAAae.i18n).successFlagTitle)
        });
        else showFlag({
            ...$494d2b2d9fec808b$var$successToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $bAAae.i18n).successFlagDescription),
            title: intl.formatMessage((0, $bAAae.i18n).successFlagTitle)
        });
    }, [
        intl,
        localConsentMode,
        showFlag
    ]);
    const showErrorFlag = (0, $4fqPo.useCallback)(()=>{
        showFlag({
            ...$494d2b2d9fec808b$var$errorToastProps(),
            id: 'cookieConsentBanner',
            description: intl.formatMessage((0, $bAAae.i18n).errorFlagDescription),
            title: intl.formatMessage((0, $bAAae.i18n).errorFlagTitle)
        });
    }, [
        intl,
        showFlag
    ]);
    // Sets preferences to allow only Strictly Necessary cookies
    const onClickOnlyNecessary = (0, $4fqPo.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $hTxA3.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'onlyNecessary',
                source: 'cookieConsentBanner'
            });
            await (0, $fbg3F.updatePreferences)((0, $2Itg6.ONLY_NECESSARY_PREFERENCES), displayedTextMap);
            (0, $hTxA3.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $2Itg6.ONLY_NECESSARY_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    // Sets preferences to allow all categories of cookies
    const onClickAcceptAll = (0, $4fqPo.useCallback)(async (displayedTextMap)=>{
        try {
            (0, $hTxA3.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'acceptAll',
                source: 'cookieConsentBanner'
            });
            await (0, $fbg3F.updatePreferences)((0, $2Itg6.ACCEPT_ALL_PREFERENCES), displayedTextMap);
            (0, $hTxA3.sendTrackEvent)({
                source: 'cookieConsentBanner',
                action: 'submitted',
                actionSubject: 'cookieConsentPreferences'
            });
            showSuccessFlag();
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'updatePreferencesError',
                attributes: {
                    preferences: (0, $2Itg6.ACCEPT_ALL_PREFERENCES),
                    product: product
                },
                message: `Failed to update preferences from banner. ${e.message || ''}`
            });
            showErrorFlag();
        } finally{
            setIsDismissed(true);
        }
    }, [
        product,
        showErrorFlag,
        showSuccessFlag,
        setIsDismissed
    ]);
    const onClickTrackingNoticeLink = (0, $4fqPo.useCallback)(()=>{
        (0, $hTxA3.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentBanner'
        });
    }, []);
    // Call onShow/onHide as a side effect of showBanner changing, rather than
    // possibly having to call them in multiple places.
    (0, $4fqPo.useEffect)(()=>{
        if (showBanner) (0, $g6gA9.addUFOCustomData)({
            isCookieConsentBannerDisplayed: true
        });
        if (showBanner) onShow === null || onShow === void 0 || onShow();
        else if (!showBanner) onHide === null || onHide === void 0 || onHide();
    }, [
        showBanner,
        onShow,
        onHide
    ]);
    (0, $4fqPo.useEffect)(()=>{
        // when banner is not visible and isPrefetchedPreferencesState is in "resolved" state
        if (!showBanner && isPrefetchedPreferencesState !== undefined) // report "banner decided not to show" to sync decision with other components
        onConsentBannerBailOut === null || onConsentBannerBailOut === void 0 || onConsentBannerBailOut();
    }, [
        showBanner,
        isPrefetchedPreferencesState,
        onConsentBannerBailOut
    ]);
    if (!showBanner) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lqGAl.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5u7bC.BSCIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7Phxn.PresentationalConsentBanner), {
        onClickOnlyNecessary: onClickOnlyNecessary,
        onClickAcceptAll: onClickAcceptAll,
        onClickPreferences: onClickPreferences,
        onClickTrackingNoticeLink: onClickTrackingNoticeLink,
        minWidth: minWidth,
        newMinHeight: newMinHeight
    }), isPreferencesModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $3uWOJ.PreferenceModal), {
        onClose: closePreferenceModal,
        onSubmit: onPreferenceModalSubmit,
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag,
        shouldAddWrappers: false
    })));
};

});
parcelRegister("jx6p8", function(module, exports) {
$parcel$export(module.exports, "initializeGlobalState", () => $8364b080859a14da$export$882c4530c58781d8);

var $6uA6H = parcelRequire("6uA6H");

var $fJXyP = parcelRequire("fJXyP");

var $3H4LK = parcelRequire("3H4LK");

var $8f0nK = parcelRequire("8f0nK");

var $k62fM = parcelRequire("k62fM");

var $KilRp = parcelRequire("KilRp");

var $aoZN9 = parcelRequire("aoZN9");
const $8364b080859a14da$export$882c4530c58781d8 = ({ webStorageEnabled: webStorageEnabled, indexedDbEnabled: indexedDbEnabled, disableWebStorageConsentChecks: disableWebStorageConsentChecks, allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides, disableIndexedDbConsentChecks: disableIndexedDbConsentChecks, __UNSAFE_shouldEnforceKeyForRollout: __UNSAFE_shouldEnforceKeyForRollout, localConsentMode: localConsentMode = false, product: product = 'all', perimeter: perimeter = 'commercial', analyticsEnabled: analyticsEnabled = true, userId: userId, cloudId: cloudId, overrideOnceParams: overrideOnceParams = false } = {})=>{
    (0, $KilRp.Logger).debug('Initialize global state invoked');
    const productGlobalState = (0, $aoZN9.__internalGetProductGlobalState)();
    // If the app provides a value for product only in one place,
    // we want that value to be sticky and to override the default if necessary
    if ((!productGlobalState || productGlobalState == null || productGlobalState === 'all') && product) (0, $aoZN9.__internalApplyInitialState)({
        productGlobalState: product
    });
    // Treating webStorageEnabled, indexedDbEnabled, and allowUncategorizedCookiesInOverrides differently
    // because they are only passed through initializeControls and
    // we don't want it to be defaulted to false via a call from the ConsentBanner
    const webStorageControlsEnabledGlobalState = (0, $aoZN9.__internalGetWebStorageControlsEnabledGlobalState)();
    if (webStorageEnabled !== undefined && webStorageControlsEnabledGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        webStorageControlsEnabledGlobalState: webStorageEnabled && !(0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $3H4LK.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    const indexedDbControlsEnabledGlobalState = (0, $aoZN9.__internalGetIndexedDbControlsEnabledGlobalState)();
    if (indexedDbEnabled !== undefined && indexedDbControlsEnabledGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        indexedDbControlsEnabledGlobalState: indexedDbEnabled && !(0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch') && !(0, $3H4LK.fg)('platform_moonjelly_bsc_web_storage_killswitch')
    });
    // `disableWebStorageConsentChecks` is sticky like the other controls flags above and
    // mirrors the behaviour of `disableIndexedDbConsentChecks`. When the caller does not
    // explicitly pass a value, the global state is left undefined and the public getter
    // (`getBscGlobalState`) reports `false` by default. It only takes effect when the
    // matching `webStorageEnabled` is `true` — see the consumer in `initializeControls`.
    const disableWebStorageConsentChecksGlobalState = (0, $aoZN9.__internalGetDisableWebStorageConsentChecksGlobalState)();
    if (disableWebStorageConsentChecks !== undefined && disableWebStorageConsentChecksGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        disableWebStorageConsentChecksGlobalState: disableWebStorageConsentChecks
    });
    const allowUncategorizedCookiesInOverridesGlobalState = (0, $aoZN9.__internalGetAllowUncategorizedCookiesInOverridesGlobalState)();
    if (allowUncategorizedCookiesInOverrides !== undefined && allowUncategorizedCookiesInOverridesGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        allowUncategorizedCookiesInOverridesGlobalState: allowUncategorizedCookiesInOverrides
    });
    // `allowUncategorizedItemsInWebStorageOverrides` is the web-storage-only counterpart to
    // `allowUncategorizedCookiesInOverrides`. It is sticky in the same way, and only takes
    // effect when web-storage controls are enabled. It does not affect cookies.
    const allowUncategorizedItemsInWebStorageOverridesGlobalState = (0, $aoZN9.__internalGetAllowUncategorizedItemsInWebStorageOverridesGlobalState)();
    if (allowUncategorizedItemsInWebStorageOverrides !== undefined && allowUncategorizedItemsInWebStorageOverridesGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        allowUncategorizedItemsInWebStorageOverridesGlobalState: allowUncategorizedItemsInWebStorageOverrides
    });
    const disableIndexedDbConsentChecksGlobalState = (0, $aoZN9.__internalGetDisableIndexedDbConsentChecksGlobalState)();
    if (disableIndexedDbConsentChecks !== undefined && disableIndexedDbConsentChecksGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        disableIndexedDbConsentChecksGlobalState: disableIndexedDbConsentChecks
    });
    // Sticky on first set, mirroring the consent-check flags above.
    const __UNSAFE_shouldEnforceKeyForRolloutGlobalState = (0, $aoZN9.__internalGetShouldEnforceKeyGlobalState)();
    if (__UNSAFE_shouldEnforceKeyForRollout !== undefined && __UNSAFE_shouldEnforceKeyForRolloutGlobalState === undefined) (0, $aoZN9.__internalApplyInitialState)({
        __UNSAFE_shouldEnforceKeyForRolloutGlobalState: __UNSAFE_shouldEnforceKeyForRollout
    });
    // All other state can only be initialized once and is defaulted if not passed on the first initialization.
    // overrideOnceParams allows a subsequent call (e.g. from initializeControls) to bypass this guard
    // and re-apply these parameters, correcting values that were defaulted by an earlier accidental call
    // (e.g. from ConsentBannerImpl before initializeControls has run).
    // This behaviour is gated behind the fedramp-consent-banner-perimeter-prop feature flag.
    if ((0, $aoZN9.__internalGetHasInitialized)() && !(overrideOnceParams && (0, $3H4LK.fg)('fedramp-consent-banner-perimeter-prop'))) return;
    // Force local consent mode when ConsentHub is not enabled because ConsentHub is
    // not hydrated in the perimeter as of this comment
    const localConsentModeGlobalState = localConsentMode || !(0, $6uA6H.isFeatureEnabled)('consent-platform', 'consenthub');
    const cookiesCacheLoader = new (0, $k62fM.CacheLoader)((0, $8f0nK.CategoryStorageType).Cookies, perimeter);
    const localStorageCacheLoader = new (0, $k62fM.CacheLoader)((0, $8f0nK.CategoryStorageType).LocalStorage, perimeter);
    const sessionStorageCacheLoader = new (0, $k62fM.CacheLoader)((0, $8f0nK.CategoryStorageType).SessionStorage, perimeter);
    const indexedDBCacheLoader = new (0, $k62fM.CacheLoader)((0, $8f0nK.CategoryStorageType).IndexedDB, perimeter);
    let packageDebugModeEnabledGlobalState;
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_debug_mode')) packageDebugModeEnabledGlobalState = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get('atl-bsc-debug-mode'));
    const updates = {
        localConsentModeGlobalState: localConsentModeGlobalState,
        analyticsEnabledGlobalState: analyticsEnabled,
        perimeterGlobalState: perimeter,
        cookiesCacheLoader: cookiesCacheLoader,
        localStorageCacheLoader: localStorageCacheLoader,
        sessionStorageCacheLoader: sessionStorageCacheLoader,
        indexedDBCacheLoader: indexedDBCacheLoader,
        packageDebugModeEnabledGlobalState: packageDebugModeEnabledGlobalState,
        hasInitialized: true
    };
    if (cloudId) updates.cloudIdGlobalState = cloudId;
    if (userId) updates.userIdGlobalState = userId;
    (0, $aoZN9.__internalApplyInitialState)(updates);
};

});
parcelRegister("k62fM", function(module, exports) {
$parcel$export(module.exports, "CacheLoader", () => $7b0ce297be5fcd55$export$e479342c697b82a9);

var $3H4LK = parcelRequire("3H4LK");

var $bdtMB = parcelRequire("bdtMB");
var $3odV5 = parcelRequire("3odV5");

var $KilRp = parcelRequire("KilRp");

var $6lJJc = parcelRequire("6lJJc");
class $7b0ce297be5fcd55$export$e479342c697b82a9 {
    constructor(storageType, perimeter = 'commercial'){
        const useFlatFormat = (0, $3H4LK.fg)('platform_bsc_flat_pattern_file_structure');
        const cacheUrlLookup = (0, $6lJJc.getCategoryCacheUrlPerimeterLookup)(useFlatFormat)[perimeter] || (0, $6lJJc.getCommercialCategoryCacheUrlLookup)(useFlatFormat);
        this.cacheUrl = cacheUrlLookup[storageType];
    }
    clearStorageControlsDataCache() {
        this.localResponseCache = undefined;
        this.localResponsePromiseCache = undefined;
        this.localResponseJsonPromiseCache = undefined;
    }
    /**
   * Unpacks the response promise from the categories CDN
   *
   * errors if that request was unsuccessful, returns the categories data otherwise
   *
   */ async handleCategoriesResponse(responsePromise) {
        if (!responsePromise) throw new Error(`Failed to fetch Cookies Cache! Cached promise was undefined`);
        const response = await responsePromise;
        if (!response.ok) throw new Error(`Failed to fetch Cookies Cache! status: ${response.status}`);
        // Checks if we've already fired the response.json() promise
        this.localResponseJsonPromiseCache = this.localResponseJsonPromiseCache || (response === null || response === void 0 ? void 0 : response.json());
        return this.localResponseJsonPromiseCache;
    }
    getStorageControlsDataFromCache() {
        return this.localResponseCache;
    }
    async loadStorageControlsData() {
        const isFetchTrackingSampled = !Math.floor(Math.random() * 100);
        let fetchExperience = null;
        if (isFetchTrackingSampled) {
            fetchExperience = new (0, $3odV5.UFOExperience)('browser-storage-controls-fetch-time', {
                type: (0, $bdtMB.ExperienceTypes).Load,
                performanceType: (0, $bdtMB.ExperiencePerformanceTypes).Custom,
                platform: {
                    component: 'browser-storage-controls'
                }
            });
            fetchExperience.start();
        }
        if (this.localResponseCache) {
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } else // Always use Prod CDN for prod/local/dev/staging environments, but stub the route for automation tests
        try {
            if (!this.localResponsePromiseCache) {
                (0, $KilRp.Logger).debug(`Loading cache ${this.cacheUrl}`);
                // invoke CDN and cache the promise
                this.localResponsePromiseCache = fetch(this.cacheUrl);
            }
            // unpack response
            this.localResponseCache = await this.handleCategoriesResponse(this.localResponsePromiseCache);
            if (fetchExperience) fetchExperience.success();
            return this.localResponseCache;
        } catch (e) {
            if (fetchExperience) fetchExperience.failure({
                metadata: {
                    error: String(e)
                }
            });
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'loadStorageControlsError',
                message: e.message || ''
            });
            this.clearStorageControlsDataCache();
        }
    }
}

});
parcelRegister("6lJJc", function(module, exports) {
$parcel$export(module.exports, "getCommercialCategoryCacheUrlLookup", () => $382ff7f5bd117137$export$5989415260e0cf82);
$parcel$export(module.exports, "getCategoryCacheUrlPerimeterLookup", () => $382ff7f5bd117137$export$9797a362f9385b1a);

var $3H4LK = parcelRequire("3H4LK");

var $8f0nK = parcelRequire("8f0nK");
var $382ff7f5bd117137$export$40467b362aa82ae = /*#__PURE__*/ function(Sources) {
    Sources["BIFROST"] = "bifrost";
    Sources["CLOUDFRONT_S3"] = "cloudfrontS3";
    return Sources;
}({});
var $382ff7f5bd117137$export$c5ae10d7c88c4d3e = /*#__PURE__*/ function(FileType) {
    FileType["COOKIE"] = "COOKIE";
    FileType["LOCAL_STORAGE"] = "LOCAL_STORAGE";
    FileType["SESSION_STORAGE"] = "SESSION_STORAGE";
    FileType["INDEXED_DB"] = "INDEXED_DB";
    return FileType;
}({});
const $382ff7f5bd117137$var$generateResourcePath = (perimeter, storageType, useFlatFormat = false)=>{
    const baseBifrostCommercialPath = 'https://atlassian-cookies.prod-east.frontend.public.atl-paas.net/';
    const baseBifrostFedrampPath = 'https://atlassian-cookies.frontend.cdn.atlassian-us-gov-mod.com/';
    const fileName = useFlatFormat ? `categories_v2_${storageType}.json` : `categories_${storageType}.json`;
    switch(perimeter){
        case 'fedramp-moderate':
            return `${baseBifrostFedrampPath}${fileName}`;
        case 'commercial':
            return `${baseBifrostCommercialPath}${fileName}`;
        default:
            return `${baseBifrostCommercialPath}${fileName}`;
    }
};
const $382ff7f5bd117137$export$5989415260e0cf82 = (useFlatFormat = false)=>{
    return {
        [(0, $8f0nK.CategoryStorageType).Cookies]: $382ff7f5bd117137$var$generateResourcePath('commercial', "COOKIE", useFlatFormat),
        [(0, $8f0nK.CategoryStorageType).LocalStorage]: $382ff7f5bd117137$var$generateResourcePath('commercial', "LOCAL_STORAGE", useFlatFormat),
        [(0, $8f0nK.CategoryStorageType).SessionStorage]: $382ff7f5bd117137$var$generateResourcePath('commercial', "SESSION_STORAGE", useFlatFormat),
        [(0, $8f0nK.CategoryStorageType).IndexedDB]: $382ff7f5bd117137$var$generateResourcePath('commercial', "INDEXED_DB", useFlatFormat)
    };
};
const $382ff7f5bd117137$export$9797a362f9385b1a = (useFlatFormat = false)=>{
    return {
        commercial: $382ff7f5bd117137$export$5989415260e0cf82(useFlatFormat),
        'fedramp-moderate': {
            [(0, $8f0nK.CategoryStorageType).Cookies]: $382ff7f5bd117137$var$generateResourcePath('fedramp-moderate', "COOKIE", useFlatFormat),
            [(0, $8f0nK.CategoryStorageType).LocalStorage]: $382ff7f5bd117137$var$generateResourcePath('fedramp-moderate', "LOCAL_STORAGE", useFlatFormat),
            [(0, $8f0nK.CategoryStorageType).SessionStorage]: $382ff7f5bd117137$var$generateResourcePath('fedramp-moderate', "SESSION_STORAGE", useFlatFormat),
            [(0, $8f0nK.CategoryStorageType).IndexedDB]: $382ff7f5bd117137$var$generateResourcePath('fedramp-moderate', "INDEXED_DB", useFlatFormat)
        }
    };
};
const $382ff7f5bd117137$export$1f60178895e28eb8 = (source, perimeter, storageType)=>{
    const useFlatFormat = (0, $3H4LK.fg)('platform_bsc_flat_pattern_file_structure');
    return $382ff7f5bd117137$var$generateResourcePath(perimeter, storageType, useFlatFormat);
};

});



parcelRegister("5u7bC", function(module, exports) {
$parcel$export(module.exports, "BSCIntlProvider", () => $e3f193789d139277$export$9aa38aed134c207f);

var $4fqPo = parcelRequire("4fqPo");

var $lGhvw = parcelRequire("lGhvw");

var $hglwA = parcelRequire("hglwA");
var $9FI6H = parcelRequire("9FI6H");
const $e3f193789d139277$export$9aa38aed134c207f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lGhvw.default), {
        defaultMessages: (0, $hglwA.default),
        loaderFn: (0, $9FI6H.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("hglwA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $b572da08c9e5cdc8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $90s6I = parcelRequire("90s6I");
var $b572da08c9e5cdc8$export$2e2bcd8739ae039 = (0, $90s6I.default);

});
parcelRegister("90s6I", function(module, exports) {
$parcel$export(module.exports, "default", () => $4db0644f83a1c75d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $4db0644f83a1c75d$export$2e2bcd8739ae039 = {
    'browser-storage-controls.consent-banner-modal.analytical.description.101024': 'Measures usage to improve product performance.',
    'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify': 'Measures usage to improve app performance.',
    'browser-storage-controls.consent-banner-modal.analytical.option.082624': 'Allow analytical cookies',
    'browser-storage-controls.consent-banner-modal.cancel.button': 'Cancel',
    'browser-storage-controls.consent-banner-modal.confirm.button': 'Confirm',
    'browser-storage-controls.consent-banner-modal.functional.description.082624': 'Provides enhanced functionality and personalization.',
    'browser-storage-controls.consent-banner-modal.functional.option.082624': 'Allow functional cookies',
    'browser-storage-controls.consent-banner-modal.marketing.description.082624': 'Used for targeted advertising.',
    'browser-storage-controls.consent-banner-modal.marketing.option.082624': 'Allow marketing cookies',
    'browser-storage-controls.consent-banner-modal.strict.description.082624': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.strict.description.082624-appify': "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
    'browser-storage-controls.consent-banner-modal.summary.description.082624': 'Because we value your privacy, you can select which cookies you allow. {link}',
    'browser-storage-controls.consent-banner-modal.title': 'Cookie preferences',
    'browser-storage-controls.consent-banner-modal.tracking.link.082624': 'Review our cookies and tracking notice',
    'browser-storage-controls.consent-banner.accept-all.button': 'Accept all',
    'browser-storage-controls.consent-banner.cookies-description.text': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
    'browser-storage-controls.consent-banner.cookies-description.text.no.link': 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
    'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024': 'Atlassian cookies and tracking notice',
    'browser-storage-controls.consent-banner.error-flag.description': 'Try again in a few minutes.',
    'browser-storage-controls.consent-banner.error-flag.title': "We're unable to update the policy",
    'browser-storage-controls.consent-banner.only-necessary.button': 'Only necessary',
    'browser-storage-controls.consent-banner.preferences.button': 'Preferences',
    'browser-storage-controls.consent-banner.success-flag.description': 'You can change this at any time in your Atlassian account.',
    'browser-storage-controls.consent-banner.success-flag.description-local-only': 'Your preferences will only affect this site.',
    'browser-storage-controls.consent-banner.success-flag.title': 'Cookie preferences saved',
    'browser-storage-controls.consent-banner.toast.error': 'Error',
    'browser-storage-controls.consent-banner.toast.success': 'Success'
};

});


parcelRegister("9FI6H", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $dd187617ef3a9aa9$export$2b153a2030b0feb2);

var $hglwA = parcelRequire("hglwA");




























const $dd187617ef3a9aa9$var$locales = {
    cs: ()=>(parcelRequire("8en2E")),
    da: ()=>(parcelRequire("dsLQT")),
    de: ()=>(parcelRequire("fn2OC")),
    'en-GB': ()=>(parcelRequire("2YYcj")),
    'en-ZZ': ()=>(parcelRequire("bXzIn")),
    en: ()=>Promise.resolve((parcelRequire("hglwA"))),
    es: ()=>(parcelRequire("dS6n8")),
    fi: ()=>(parcelRequire("bZsCJ")),
    fr: ()=>(parcelRequire("02LDL")),
    hu: ()=>(parcelRequire("1WWnT")),
    it: ()=>(parcelRequire("bKjlG")),
    ja: ()=>(parcelRequire("k7DDy")),
    ko: ()=>(parcelRequire("33Fkj")),
    nb: ()=>(parcelRequire("fwyE9")),
    nl: ()=>(parcelRequire("aYVmW")),
    pl: ()=>(parcelRequire("aNRwv")),
    'pt-BR': ()=>(parcelRequire("j9mZe")),
    ru: ()=>(parcelRequire("hvdhd")),
    sl: ()=>(parcelRequire("3s6Me")),
    sr_RS: ()=>(parcelRequire("5Zbc5")),
    sr_YR: ()=>(parcelRequire("f5eHX")),
    sv: ()=>(parcelRequire("l4qC5")),
    th: ()=>(parcelRequire("7cPj7")),
    tr: ()=>(parcelRequire("fW7O2")),
    uk: ()=>(parcelRequire("3HN6B")),
    vi: ()=>(parcelRequire("2wtxa")),
    zh_TW: ()=>(parcelRequire("9Fu7D")),
    zh: ()=>(parcelRequire("1TjUI"))
};
const $dd187617ef3a9aa9$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const messages = await $dd187617ef3a9aa9$var$locales[locale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await $dd187617ef3a9aa9$var$locales[parentLocale]();
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("8en2E", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("6kK1W").then(()=>parcelRequire('3vi9j'));

});

parcelRegister("dsLQT", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("5Ko40").then(()=>parcelRequire('fFpeq'));

});

parcelRegister("fn2OC", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("8TTCI").then(()=>parcelRequire('7wfHv'));

});

parcelRegister("2YYcj", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("hnepJ").then(()=>parcelRequire('lDhsT'));

});

parcelRegister("bXzIn", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("54tsU").then(()=>parcelRequire('2UDtF'));

});

parcelRegister("dS6n8", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bf2NI").then(()=>parcelRequire('2E0hB'));

});

parcelRegister("bZsCJ", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("84ApS").then(()=>parcelRequire('NW3kb'));

});

parcelRegister("02LDL", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("eXvfR").then(()=>parcelRequire('fNiy6'));

});

parcelRegister("1WWnT", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1i7ea").then(()=>parcelRequire('fM2av'));

});

parcelRegister("bKjlG", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("h1rGz").then(()=>parcelRequire('9AKKp'));

});

parcelRegister("k7DDy", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lTkVH").then(()=>parcelRequire('e6Ahp'));

});

parcelRegister("33Fkj", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("86Krd").then(()=>parcelRequire('kteD6'));

});

parcelRegister("fwyE9", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1ElQ5").then(()=>parcelRequire('gSWlZ'));

});

parcelRegister("aYVmW", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("1xpry").then(()=>parcelRequire('jwIPs'));

});

parcelRegister("aNRwv", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("182YE").then(()=>parcelRequire('cMxMe'));

});

parcelRegister("j9mZe", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("igsGq").then(()=>parcelRequire('5zeMt'));

});

parcelRegister("hvdhd", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("29sKN").then(()=>parcelRequire('dSLOs'));

});

parcelRegister("3s6Me", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("bZHJv").then(()=>parcelRequire('flOJg'));

});

parcelRegister("5Zbc5", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("9EAFG").then(()=>parcelRequire('4dIpO'));

});

parcelRegister("f5eHX", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("j520u").then(()=>parcelRequire('22v8I'));

});

parcelRegister("l4qC5", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("lzMon").then(()=>parcelRequire('4jnmc'));

});

parcelRegister("7cPj7", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("aE4kd").then(()=>parcelRequire('dfRFy'));

});

parcelRegister("fW7O2", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("2SZr4").then(()=>parcelRequire('bZlPP'));

});

parcelRegister("3HN6B", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("laWL8").then(()=>parcelRequire('i1kjM'));

});

parcelRegister("2wtxa", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("chJcb").then(()=>parcelRequire('5oz0T'));

});

parcelRegister("9Fu7D", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("biB3l").then(()=>parcelRequire('gaRt3'));

});

parcelRegister("1TjUI", function(module, exports) {

var $e46AW = parcelRequire("e46AW");
module.exports = $e46AW("5u5mZ").then(()=>parcelRequire('jeY7k'));

});



parcelRegister("jz4E1", function(module, exports) {
$parcel$export(module.exports, "deleteCookie", () => $9cbcee9a6fb7501a$export$b43e45590305ffaa);

var $fJXyP = parcelRequire("fJXyP");

var $3H4LK = parcelRequire("3H4LK");

var $hTxA3 = parcelRequire("hTxA3");

var $KilRp = parcelRequire("KilRp");
const $9cbcee9a6fb7501a$export$b43e45590305ffaa = (key, attributes)=>{
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch')) // Delete the cookie without package operational events
    // when master killswitch is enabled
    (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).remove(key, attributes);
    else try {
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedDeleteCookie',
            attributes: {
                cookieKey: key
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).remove(key, attributes);
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedDeleteCookieError',
            attributes: {
                cookieKey: key
            },
            message: `Failed to use delete cookie. ${e.message || ''}`
        });
    }
};

});

parcelRegister("fbg3F", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", () => $64e30530b3e34d97$export$7bb3e177c1a1e841);

var $aoZN9 = parcelRequire("aoZN9");

var $2Itg6 = parcelRequire("2Itg6");

var $8f0nK = parcelRequire("8f0nK");

var $3h2Ui = parcelRequire("3h2Ui");

var $a5OUx = parcelRequire("a5OUx");

var $2edmn = parcelRequire("2edmn");
const $64e30530b3e34d97$var$emptyDisplayedTextMap = {
    [(0, $8f0nK.PreferenceCategory).Analytics]: '',
    [(0, $8f0nK.PreferenceCategory).Functional]: '',
    [(0, $8f0nK.PreferenceCategory).Marketing]: '',
    [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: '',
    [(0, $8f0nK.PreferenceCategory).Unknown]: ''
};
async function $64e30530b3e34d97$export$7bb3e177c1a1e841(preferences, displayedTextMap = $64e30530b3e34d97$var$emptyDisplayedTextMap, usingPrefetchedData) {
    if ((0, $aoZN9.getBscGlobalState)().localConsentMode) {
        const packedPrefs = (0, $2edmn.packUserPreferences)(preferences);
        (0, $a5OUx.setStrictlyNecessaryCookie)((0, $2Itg6.LEGACY_ATLASSIAN_GDPR_COOKIE_KEY), packedPrefs, {
            expires: 365,
            path: '/'
        });
    } else await (0, $3h2Ui.setConsentToken)(preferences, displayedTextMap, usingPrefetchedData);
}

});
parcelRegister("3h2Ui", function(module, exports) {
$parcel$export(module.exports, "setConsentToken", () => $6dfb4fbd0ac879b8$export$fbf549fe6f0e91dc);

var $KilRp = parcelRequire("KilRp");

var $bzEve = parcelRequire("bzEve");

var $gCY8Y = parcelRequire("gCY8Y");

var $8f0nK = parcelRequire("8f0nK");

var $9sIkA = parcelRequire("9sIkA");

var $2edmn = parcelRequire("2edmn");

var $iiNH0 = parcelRequire("iiNH0");
const $6dfb4fbd0ac879b8$export$c8a8f3474b56fa5f = (mergedPrefs, usingPrefetchedData)=>{
    // If platform_moonjelly_bsc_fallback_token_audit feature gate is on,
    // use new fallback consent token logic
    // On a successful save, transform the prefs object into a formatted consentToken bit string
    // Then store the new token in a 10min-expiry consent cookie and a 1yr-expiry fallback cookie
    const consentToken = (0, $2edmn.packUserPreferences)(mergedPrefs);
    // Check if the token is prefetched and set to default.
    if (usingPrefetchedData && (0, $gCY8Y.checkIfTokenIsDefault)(consentToken)) return;
    if (usingPrefetchedData) (0, $iiNH0.onlySetFallbackIfDifferent)(consentToken);
    else (0, $9sIkA.setConsentTokenFallbackCookie)(consentToken);
    (0, $9sIkA.setConsentTokenCookie)(consentToken);
    (0, $9sIkA.setShouldShowBannerCookie)(consentToken);
};
const $6dfb4fbd0ac879b8$export$2c4e14a9e4d984da = (err, mergedPrefs)=>{
    const errorDueToUnauthenticatedRequest = err instanceof (0, $gCY8Y.StatusCodeError) && err.status === 401;
    const errorDueToConsentHubBeingInaccessible = err instanceof (0, $gCY8Y.StatusCodeError) && err.status >= 500 && err.status < 600; // Any 5xx error
    // Indicates the user is genuinely logged out instead of ConsentHub being inaccessible
    // If we dont explicitly 401, defer to the previous auth state
    const updatedAuthState = errorDueToUnauthenticatedRequest ? !errorDueToUnauthenticatedRequest : !!mergedPrefs[(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated];
    const consentToken = (0, $2edmn.packUserPreferences)({
        ...mergedPrefs,
        [(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated]: updatedAuthState,
        [(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable]: errorDueToConsentHubBeingInaccessible // Indicates we were unable to hit ConsentHub when the consents were created
    });
    if (errorDueToUnauthenticatedRequest) {
        // When the failure is derived from a local-only/unauthenticated user, we need to also set the consent token
        // Otherwise, we will never actually adhere to their consents, as they'll continue to receive default every time we attempt to unsuccessfully fetch their prefs
        (0, $KilRp.Logger).error(`User is unauthenticated. ${err.message}`);
        (0, $iiNH0.onlySetFallbackIfDifferent)(consentToken);
        (0, $9sIkA.setConsentTokenCookie)(consentToken);
        (0, $9sIkA.setShouldShowBannerCookie)(consentToken);
        return;
    }
    // When there's an actual failure, we only store data in the fallbackConsentToken cookie
    // This allows us to still track consents when ConsentHub is down > 10 minute expiry
    // But do _not_ set a consentToken cookie so we attempt to re-request from ConsentHub on sequential loads
    // This circumvents an issue of a user thinking they saved consents to CH, but when we request them later,
    // CH has no record of them, and they get shown the banner again
    (0, $KilRp.Logger).error('Token failed to save');
    (0, $iiNH0.onlySetFallbackIfDifferent)(consentToken);
    (0, $9sIkA.setShouldShowBannerCookie)(consentToken);
};
const $6dfb4fbd0ac879b8$export$fbf549fe6f0e91dc = async (updatedPreferences, displayedTextMap, usingPrefetchedData)=>{
    const mergedPrefs = (0, $iiNH0.mergeConsentUpdates)(updatedPreferences, usingPrefetchedData);
    try {
        if (!usingPrefetchedData) // Attempts to save the newly updated preferences object
        // Can only be saved when a user is logged in, so this error will be caught if unauthed
        await (0, $bzEve.saveConsentPreferences)(mergedPrefs, displayedTextMap);
        $6dfb4fbd0ac879b8$export$c8a8f3474b56fa5f(mergedPrefs, usingPrefetchedData);
    } catch (err) {
        // If we fail to save to ConsentHub, it could be due to ConsentHub being down, the user being unauthenticated/local-only,
        // or an exception somewhere in the stack. Ensure we pack that information into the token where applicable.
        $6dfb4fbd0ac879b8$export$2c4e14a9e4d984da(err, mergedPrefs);
    }
};

});
parcelRegister("iiNH0", function(module, exports) {
$parcel$export(module.exports, "mergeConsentUpdates", () => $269f76404540443a$export$c0214a364df3006f);
$parcel$export(module.exports, "onlySetFallbackIfDifferent", () => $269f76404540443a$export$a023a0b818522757);

var $2Itg6 = parcelRequire("2Itg6");

var $8f0nK = parcelRequire("8f0nK");

var $cnMPG = parcelRequire("cnMPG");

var $9sIkA = parcelRequire("9sIkA");

var $2edmn = parcelRequire("2edmn");
const $269f76404540443a$var$pruneLegacyProperties = (updatedPreferences)=>{
    // Strips any possible V002/legacy properties from the preferences by excluding everything but the core prefs
    return {
        [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: updatedPreferences[(0, $8f0nK.PreferenceCategory).StrictlyNecessary],
        [(0, $8f0nK.PreferenceCategory).Functional]: updatedPreferences[(0, $8f0nK.PreferenceCategory).Functional],
        [(0, $8f0nK.PreferenceCategory).Analytics]: updatedPreferences[(0, $8f0nK.PreferenceCategory).Analytics],
        [(0, $8f0nK.PreferenceCategory).Marketing]: updatedPreferences[(0, $8f0nK.PreferenceCategory).Marketing],
        [(0, $8f0nK.PreferenceCategory).Unknown]: updatedPreferences[(0, $8f0nK.PreferenceCategory).Unknown]
    };
};
const $269f76404540443a$var$setContextualConsentProperties = (consentPreferences, usingPrefetchedData)=>{
    // When merging during this phase, retain the "unauthed/authed" context of the preferences
    const existingUserAuthenticatedState = consentPreferences === null || consentPreferences === void 0 ? void 0 : consentPreferences[(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated];
    const existingConsentHubUnavailableState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable]);
    // When processing a legacy token, UserIsAuthenticated will be missing, so we need to backfill it with context from ConsentHubUnavailable
    const existingOrBackfilledAuthState = existingUserAuthenticatedState === undefined ? !existingConsentHubUnavailableState : existingUserAuthenticatedState;
    // Overwriting this flag while merging here gets us into a situation where a prefetched/cached, default cookie is just being set in the system,
    // but we mark the consents as "genuine", when they haven't actually been saved.
    // Doing this would have negative downstream effects, as we invoke logic dependent on if a token is a default or not
    const existingDefaultState = !!(consentPreferences !== null && consentPreferences !== void 0 && consentPreferences[(0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault]);
    const consentsAreDefault = usingPrefetchedData ? existingDefaultState : false;
    return {
        [(0, $8f0nK.ContextualConsentProperty).ConsentsAreDefault]: consentsAreDefault,
        [(0, $8f0nK.ContextualConsentProperty).UserIsAuthenticated]: existingOrBackfilledAuthState,
        [(0, $8f0nK.ContextualConsentProperty).ConsentDataUnavailable]: existingConsentHubUnavailableState
    };
};
const $269f76404540443a$export$c0214a364df3006f = (updatedPreferences, usingPrefetchedData)=>{
    // DEFAULT_PREFERENCES now gives us "CH unavailable" and "is default" bits
    const existingPrefs = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_COOKIE_KEY));
    if (existingPrefs) {
        // Unpacking a V2 should now result in a V3 token anyway, but ensure we have proper bits
        const unpackedExistingPrefs = (0, $2edmn.unpackUserPreferencesCookie)(existingPrefs);
        // Capture any missed options (shouldn't have any if we have existing consent token), and
        // ensure we write the bit dictating that these consents are no longer defaults since they're being saved
        if (unpackedExistingPrefs) return {
            ...(0, $2Itg6.DEFAULT_PREFERENCES),
            ...unpackedExistingPrefs,
            ...$269f76404540443a$var$pruneLegacyProperties(updatedPreferences),
            ...$269f76404540443a$var$setContextualConsentProperties(unpackedExistingPrefs, usingPrefetchedData)
        };
        return {
            ...(0, $2Itg6.DEFAULT_PREFERENCES),
            ...$269f76404540443a$var$pruneLegacyProperties(updatedPreferences)
        };
    }
    // If we don't have existing prefs, this is likely a first time save for this domain
    // Ensure we note this is a successful, genuine set of prefs by updating the contextual properties as needed
    return {
        ...(0, $2Itg6.DEFAULT_PREFERENCES),
        ...$269f76404540443a$var$pruneLegacyProperties(updatedPreferences),
        ...$269f76404540443a$var$setContextualConsentProperties(updatedPreferences, usingPrefetchedData)
    };
};
const $269f76404540443a$export$a023a0b818522757 = (consentToken)=>{
    // Diff the token we're trying to set vs. any existing fallback, and only set a new fallback if the value has changed.
    // A difference would mean the user made a change since their original fallback was stored and we should update.
    // Otherwise, we would be unintentionally overriding the "1 year" expiration date the fallback token tracks.
    const existingFallbackToken = (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY));
    const tokenDiffersFromOldFallback = existingFallbackToken !== consentToken;
    if (!existingFallbackToken || tokenDiffersFromOldFallback) (0, $9sIkA.setConsentTokenFallbackCookie)(consentToken);
};

});



parcelRegister("bAAae", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $b8b3c4c49e472982$export$a7357cdd1f0b0168);

var $6BhDL = parcelRequire("6BhDL");
const $b8b3c4c49e472982$export$a7357cdd1f0b0168 = (0, $6BhDL.defineMessages)({
    preferencesBtn: {
        id: 'browser-storage-controls.consent-banner.preferences.button',
        defaultMessage: 'Preferences',
        description: 'Preferences button that opens consent modal dialog.'
    },
    onlyNecessaryBtn: {
        id: 'browser-storage-controls.consent-banner.only-necessary.button',
        defaultMessage: 'Only necessary',
        description: 'Only necessary button that saves user preferences - only necessary cookies.'
    },
    acceptAllBtn: {
        id: 'browser-storage-controls.consent-banner.accept-all.button',
        defaultMessage: 'Accept all',
        description: 'Accept all button that saves user preferences - accepts all cookies.'
    },
    cookiesTrackingNotice: {
        id: 'browser-storage-controls.consent-banner.cookies-tracking-notice.text.101024',
        defaultMessage: 'Atlassian cookies and tracking notice',
        description: 'Link that leads to Atlassian cookies/tracking legal notice text on Atlassian website.'
    },
    useCookiesDescription: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device. {linkToCookiesTrackingNotice}',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    useCookiesDescriptionNoLink: {
        id: 'browser-storage-controls.consent-banner.cookies-description.text.no.link',
        defaultMessage: 'Atlassian uses cookies to improve your browsing experience, perform analytics and research, and conduct advertising. Accept all cookies to indicate that you agree to our use of cookies on your device.',
        description: 'Description that explains Atlassian cookie controls and how it is used.'
    },
    successFlagTitle: {
        id: 'browser-storage-controls.consent-banner.success-flag.title',
        defaultMessage: 'Cookie preferences saved',
        description: 'Title for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescription: {
        id: 'browser-storage-controls.consent-banner.success-flag.description',
        defaultMessage: 'You can change this at any time in your Atlassian account.',
        description: 'Description for the success flag shown when cookie preferences are saved initially.'
    },
    successFlagDescriptionLocalOnly: {
        id: 'browser-storage-controls.consent-banner.success-flag.description-local-only',
        defaultMessage: 'Your preferences will only affect this site.',
        description: 'Description for the success flag shown when cookie preferences are saved locally, meaning that those preferences will only affect the current domain.'
    },
    errorFlagTitle: {
        id: 'browser-storage-controls.consent-banner.error-flag.title',
        defaultMessage: "We're unable to update the policy",
        description: 'Title for the error flag shown when cookie preferences are not saved.'
    },
    errorFlagDescription: {
        id: 'browser-storage-controls.consent-banner.error-flag.description',
        defaultMessage: 'Try again in a few minutes.',
        description: 'Description for the error flag shown when cookie preferences are not saved.'
    }
});

});

parcelRegister("3uWOJ", function(module, exports) {
$parcel$export(module.exports, "PreferenceModal", () => $3e36e62bba70fbae$export$94c5684831c222e7);

var $4fqPo = parcelRequire("4fqPo");

var $lqGAl = parcelRequire("lqGAl");

var $3H4LK = parcelRequire("3H4LK");

var $hTxA3 = parcelRequire("hTxA3");

var $5u7bC = parcelRequire("5u7bC");

var $KilRp = parcelRequire("KilRp");

var $2Itg6 = parcelRequire("2Itg6");

var $fbg3F = parcelRequire("fbg3F");

var $bMAe1 = parcelRequire("bMAe1");

var $ljIaq = parcelRequire("ljIaq");
const $3e36e62bba70fbae$export$94c5684831c222e7 = (props)=>{
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch') || (0, $3H4LK.fg)('platform_moonjelly_bsc_ui_killswitch')) // Don't render the preference modal if the killswitch is enabled
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($3e36e62bba70fbae$export$30df3cfccbe10e6e, props);
};
const $3e36e62bba70fbae$export$30df3cfccbe10e6e = ({ onClose: onClose, onSubmit: onSubmit, showSuccessFlag: showSuccessFlag, showErrorFlag: showErrorFlag, shouldAddWrappers: shouldAddWrappers = true })=>{
    const [isModalOpen, setIsModalOpen] = (0, $4fqPo.useState)(true);
    const isEventSent = (0, $4fqPo.useRef)(false);
    (0, $4fqPo.useEffect)(()=>{
        if (!isEventSent.current) {
            (0, $hTxA3.sendScreenEvent)({
                name: 'cookieConsentModal'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent
    ]);
    const { preferences: preferences, setPreferencesData: setPreferencesData } = (0, $ljIaq.default)({});
    // If we don't have preferences, set default preferences
    // for modal interactions
    if (!preferences) setPreferencesData({
        prefs: (0, $2Itg6.ONLY_NECESSARY_PREFERENCES),
        isPrefetchedPrefsInternalState: false
    });
    const handleOnSubmit = (0, $4fqPo.useCallback)(async (displayedTextMap)=>{
        if (preferences) {
            const selectedPreferences = preferences;
            (0, $hTxA3.sendUIEvent)({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'confirm',
                source: 'cookieConsentModal'
            });
            try {
                await (0, $fbg3F.updatePreferences)(selectedPreferences, displayedTextMap);
                (0, $hTxA3.sendTrackEvent)({
                    source: 'cookieConsentModal',
                    action: 'submitted',
                    actionSubject: 'cookieConsentPreferences'
                });
                showSuccessFlag === null || showSuccessFlag === void 0 || showSuccessFlag();
            } catch (e) {
                (0, $KilRp.Logger).errorWithOperationalEvent({
                    action: 'updatePreferencesError',
                    attributes: {
                        preferences: selectedPreferences
                    },
                    message: `Failed to update preferences from modal. ${e.message || ''}`
                });
                showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
            }
            setIsModalOpen(false);
            onSubmit === null || onSubmit === void 0 || onSubmit();
        } else // Preferences have reached an invalid state, show error flag
        showErrorFlag === null || showErrorFlag === void 0 || showErrorFlag();
    }, [
        preferences,
        onSubmit,
        showSuccessFlag,
        showErrorFlag
    ]);
    const modalContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bMAe1.PresentationalPreferenceModal), {
        onSubmit: handleOnSubmit,
        onClose: onClose,
        setIsOpen: setIsModalOpen,
        preferences: preferences ?? (0, $2Itg6.ONLY_NECESSARY_PREFERENCES),
        setPreferencesData: setPreferencesData
    });
    if (!isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, shouldAddWrappers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lqGAl.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $5u7bC.BSCIntlProvider), null, modalContent)) : modalContent);
};

});
parcelRegister("bMAe1", function(module, exports) {
$parcel$export(module.exports, "PresentationalPreferenceModal", () => $97abefe1061db2a9$export$9921ee7829a3ba4);

var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");
var $4MCQn = parcelRequire("4MCQn");

var $lszf6 = parcelRequire("lszf6");

var $kuhlf = parcelRequire("kuhlf");

var $2eKV2 = parcelRequire("2eKV2");

var $dhbAl = parcelRequire("dhbAl");
var $bjlDd = parcelRequire("bjlDd");
var $dOhHl = parcelRequire("dOhHl");
var $gbw4j = parcelRequire("gbw4j");
var $kCZZw = parcelRequire("kCZZw");
var $f2YSn = parcelRequire("f2YSn");

var $3H4LK = parcelRequire("3H4LK");

var $jWuCJ = parcelRequire("jWuCJ");
var $7TPEx = parcelRequire("7TPEx");
var $4hIeL = parcelRequire("4hIeL");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $hTxA3 = parcelRequire("hTxA3");

var $2AAXb = parcelRequire("2AAXb");

var $8f0nK = parcelRequire("8f0nK");

var $j64BK = parcelRequire("j64BK");

var $4PPHO = parcelRequire("4PPHO");
const $97abefe1061db2a9$var$categoryNameStyles = (0, $2m8U6.xcss)({
    fontWeight: 'font.weight.bold'
});
const $97abefe1061db2a9$var$customHeaderStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse'
});
const $97abefe1061db2a9$var$extractTextFromReactNode = (node)=>{
    if (typeof node === 'string') return node;
    if (typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map($97abefe1061db2a9$var$extractTextFromReactNode).join('');
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).isValidElement(node)) {
        if (node.props.children) return $97abefe1061db2a9$var$extractTextFromReactNode(node.props.children);
    }
    return '';
};
const $97abefe1061db2a9$var$getDefaultText = (intl)=>{
    const link = intl.formatMessage((0, $4PPHO.i18n).trackingLink);
    const defaultSummaryDescriptionDisplayedText = intl.formatMessage((0, $4PPHO.i18n).summaryDescription, {
        link: link
    });
    const defaultStrictDescriptionDisplayedTextNode = intl.formatMessage((0, $3H4LK.fg)('product-terminology-refresh') ? (0, $4PPHO.i18n).strictDescriptionAppify : (0, $4PPHO.i18n).strictDescription, {
        bold: (msg)=>msg
    });
    // ReactIntl requires interpolated values to be passed in, and this particular string requires a <bold> modifier.
    // Unfortunately, this converts the above formatted message to a ReactNode but ConsentHub needs strings for `displayedText`,
    // thus, we have to render to a static HTML string first and sanitize the result
    const defaultStrictDescriptionDisplayedText = $97abefe1061db2a9$var$extractTextFromReactNode(defaultStrictDescriptionDisplayedTextNode);
    let defaultDisplayedText = `${defaultSummaryDescriptionDisplayedText}. ${defaultStrictDescriptionDisplayedText}`;
    const sanitizedText = defaultDisplayedText.replace(/&#x27;/g, "'");
    return sanitizedText;
};
const $97abefe1061db2a9$var$getCookieCategories = (intl)=>{
    const cookieCategoriesToTranslate = [
        {
            // Tracks Functional related cookies like preferences
            category: (0, $8f0nK.PreferenceCategory).Functional,
            title: (0, $4PPHO.i18n).functionalOption,
            description: (0, $4PPHO.i18n).functionalOptionDescription
        },
        {
            // Tracks Performance related cookies like analytics
            category: (0, $8f0nK.PreferenceCategory).Analytics,
            title: (0, $4PPHO.i18n).analyticalOption,
            description: (0, $3H4LK.fg)('product-terminology-refresh') ? (0, $4PPHO.i18n).analyticalOptionDescriptionAppify : (0, $4PPHO.i18n).analyticalOptionDescription
        },
        {
            // Tracks Targeting related cookies like marketing and advertising
            category: (0, $8f0nK.PreferenceCategory).Marketing,
            title: (0, $4PPHO.i18n).marketingOption,
            description: (0, $4PPHO.i18n).marketingOptionDescription
        }
    ];
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $2AAXb.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        // Set the description as the default for all items (including items with checkboxes in the UI)
        // and we'll override as needed. Prefs that are not visually displayed in the UI anymore will use this default.
        translatedTextMap[category] = $97abefe1061db2a9$var$getDefaultText(intl);
        return translatedTextMap;
    }, {});
    const checkboxes = cookieCategoriesToTranslate.map(({ category: category, title: title, description: description })=>{
        const translatedTitle = intl.formatMessage(title);
        const translatedDescription = intl.formatMessage(description);
        // If we are showing individual checkboxes, use that description for auditing purposes
        displayedTextMap[category] = translatedDescription;
        return {
            category: category,
            titleElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
                xcss: $97abefe1061db2a9$var$categoryNameStyles
            }, translatedTitle),
            descriptionElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, translatedDescription),
            titleString: title.defaultMessage
        };
    });
    return {
        checkboxes: checkboxes,
        displayedTextMap: displayedTextMap
    };
};
const $97abefe1061db2a9$var$noop = ()=>{};
const $97abefe1061db2a9$var$CustomHeader = ({ onClose: onClose })=>{
    const { titleId: titleId } = (0, $f2YSn.useModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $97abefe1061db2a9$var$customHeaderStyles,
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dhbAl.CloseButton), {
        onClick: onClose,
        testId: "close-modal-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $2eKV2.default), {
        as: "h1",
        size: "medium",
        id: titleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).title)));
};
const $97abefe1061db2a9$export$9921ee7829a3ba4 = ({ preferences: preferences, setPreferencesData: setPreferencesData = $97abefe1061db2a9$var$noop, onSubmit: onSubmit = $97abefe1061db2a9$var$noop, onClose: onClose = $97abefe1061db2a9$var$noop, setIsOpen: setIsOpen = $97abefe1061db2a9$var$noop })=>{
    const intl = (0, $4MCQn.default)();
    const onCloseModal = (0, $4fqPo.useCallback)(()=>{
        setIsOpen(false);
        onClose();
    }, [
        setIsOpen,
        onClose
    ]);
    const onClickCancel = (0, $4fqPo.useCallback)(()=>{
        onCloseModal();
        (0, $hTxA3.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'cancel',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickClose = (0, $4fqPo.useCallback)(()=>{
        onCloseModal();
        (0, $hTxA3.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'close',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickBackground = (0, $4fqPo.useCallback)(()=>{
        onCloseModal();
        (0, $hTxA3.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'area',
            actionSubjectId: 'background',
            source: 'cookieConsentModal'
        });
    }, [
        onCloseModal
    ]);
    const onClickTrackingNoticeLink = (0, $4fqPo.useCallback)(()=>{
        (0, $hTxA3.sendUIEvent)({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'cookiesTrackingNotice',
            source: 'cookieConsentModal'
        });
    }, []);
    const cookieCategories = (0, $4fqPo.useMemo)(()=>{
        return $97abefe1061db2a9$var$getCookieCategories(intl);
    }, [
        intl
    ]);
    const handleSubmission = (0, $4fqPo.useCallback)(()=>{
        const { displayedTextMap: displayedTextMap } = cookieCategories;
        onSubmit(displayedTextMap);
    }, [
        onSubmit,
        cookieCategories
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kCZZw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $bjlDd.default), {
        onClose: onClickBackground
    }, (0, $3H4LK.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kuhlf.default), {
        onSubmit: handleSubmission
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($97abefe1061db2a9$var$CustomHeader, {
        onClose: onClickClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
        ...(0, $4PPHO.i18n).summaryDescription,
        values: {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jWuCJ.default), {
                href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).trackingLink))
        },
        tagName: 'p'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
        ...(0, $3H4LK.fg)('product-terminology-refresh') ? (0, $4PPHO.i18n).strictDescriptionAppify : (0, $4PPHO.i18n).strictDescription,
        values: {
            bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
                    weight: "bold"
                }, msg)
        },
        tagName: 'p'
    })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j64BK.CookieCategorySection), {
            category: category,
            titleElement: titleElement,
            titleString: titleString,
            descriptionElement: description,
            isChecked: (preferences && preferences[category]) ?? false,
            setPreferencesData: setPreferencesData
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        appearance: "subtle",
        onClick: onClickCancel,
        testId: "consent-preference-cancel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
        type: "submit",
        appearance: "primary",
        onClick: handleSubmission,
        testId: "consent-preference-confirm"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).confirmBtn)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $kuhlf.default), {
        onSubmit: handleSubmission
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement($97abefe1061db2a9$var$CustomHeader, {
            onClose: onClickClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dOhHl.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
            ...(0, $4PPHO.i18n).summaryDescription,
            values: {
                link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jWuCJ.default), {
                    href: "https://www.atlassian.com/legal/cookies#cookies-and-other-tracking-technologies",
                    target: "_blank",
                    onClick: onClickTrackingNoticeLink
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).trackingLink))
            },
            tagName: 'p'
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
            ...(0, $3H4LK.fg)('product-terminology-refresh') ? (0, $4PPHO.i18n).strictDescriptionAppify : (0, $4PPHO.i18n).strictDescription,
            values: {
                bold: (msg)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
                        weight: "bold"
                    }, msg)
            },
            tagName: 'p'
        })), cookieCategories.checkboxes.map(({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: description }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $4hIeL.default), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $j64BK.CookieCategorySection), {
                category: category,
                titleElement: titleElement,
                titleString: titleString,
                descriptionElement: description,
                isChecked: (preferences && preferences[category]) ?? false,
                setPreferencesData: setPreferencesData
            })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $gbw4j.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
            appearance: "subtle",
            onClick: onClickCancel,
            testId: "consent-preference-cancel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).cancelBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $lszf6.default), {
            type: "submit",
            appearance: "primary",
            onClick: handleSubmission,
            testId: "consent-preference-confirm"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $4PPHO.i18n).confirmBtn)))))));
};

});
parcelRegister("jWuCJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $b697b5f1a4218229$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $4fqPo = parcelRequire("4fqPo");

var $lqVX7 = parcelRequire("lqVX7");

var $yLYo1 = parcelRequire("yLYo1");

var $4EOcq = parcelRequire("4EOcq");

var $koPKk = parcelRequire("koPKk");

var $c1tmZ = parcelRequire("c1tmZ");

var $a4Rr2 = parcelRequire("a4Rr2");

var $9XaAY = parcelRequire("9XaAY");

var $gFdUI = parcelRequire("gFdUI");

var $fJeCl = parcelRequire("fJeCl");

var $2m8U6 = parcelRequire("2m8U6");
function $b697b5f1a4218229$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $b697b5f1a4218229$var$focusRingStyles = /*#__PURE__*/ (0, $lqVX7.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $fJeCl.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $fJeCl.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $fJeCl.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $fJeCl.borderWidthMap)['border.width']} solid`
        }
    }
});
const $b697b5f1a4218229$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $b697b5f1a4218229$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $b697b5f1a4218229$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $b697b5f1a4218229$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $b697b5f1a4218229$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $b697b5f1a4218229$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $c1tmZ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $4fqPo.useContext)((0, $9XaAY.default));
    const handleClick = (0, $4fqPo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $a4Rr2.useId)();
    const onClick = (0, $4EOcq.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: undefined,
        packageVersion: undefined,
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $2m8U6.parseXcss)(xcss);
    const RouterLink = (0, $koPKk.default)();
    const isExternal = typeof href === 'string' && $b697b5f1a4218229$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $b697b5f1a4218229$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $yLYo1.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $lqVX7.jsx)(Component, {
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $b697b5f1a4218229$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $b697b5f1a4218229$var$baseStyles,
            $b697b5f1a4218229$var$positionStyles,
            $b697b5f1a4218229$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $fJeCl.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $fJeCl.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $fJeCl.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $fJeCl.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $fJeCl.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $fJeCl.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $fJeCl.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $fJeCl.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $lqVX7.jsx)((0, $gFdUI.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $b697b5f1a4218229$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $b697b5f1a4218229$var$Anchor = /*#__PURE__*/ (0, $4fqPo.forwardRef)($b697b5f1a4218229$var$AnchorNoRef);
var $b697b5f1a4218229$export$2e2bcd8739ae039 = $b697b5f1a4218229$var$Anchor;

});

parcelRegister("2AAXb", function(module, exports) {
$parcel$export(module.exports, "CONSENT_DISPLAYED_TEXT_ITEMS", () => $f852a719aa071e81$export$99df83ca0f45bd54);

var $8f0nK = parcelRequire("8f0nK");
const $f852a719aa071e81$export$99df83ca0f45bd54 = [
    (0, $8f0nK.PreferenceCategory).Analytics,
    (0, $8f0nK.PreferenceCategory).Functional,
    (0, $8f0nK.PreferenceCategory).Marketing,
    (0, $8f0nK.PreferenceCategory).StrictlyNecessary,
    (0, $8f0nK.PreferenceCategory).Unknown
];

});

parcelRegister("j64BK", function(module, exports) {
$parcel$export(module.exports, "CookieCategorySection", () => $1ff20193aabe5ea7$export$3c97a3b492e10ae9);

var $4fqPo = parcelRequire("4fqPo");

var $f0SW5 = parcelRequire("f0SW5");

var $7TPEx = parcelRequire("7TPEx");
var $e2Zgo = parcelRequire("e2Zgo");
var $2m8U6 = parcelRequire("2m8U6");

var $hTxA3 = parcelRequire("hTxA3");

var $8f0nK = parcelRequire("8f0nK");
const $1ff20193aabe5ea7$var$tmpTrelloClassNameOverride = 'atl-bsc-preference-modal-checkbox';
// Styles
const $1ff20193aabe5ea7$var$categoryBoxStyles = (0, $2m8U6.xcss)({
    paddingBlockStart: 'space.200'
});
const $1ff20193aabe5ea7$var$categoryDescriptionStyles = (0, $2m8U6.xcss)({
    paddingInlineStart: 'space.300',
    marginInlineStart: 'space.050'
});
// We don't bother tracking unknown checkbox toggles
const $1ff20193aabe5ea7$var$categoryToEventSubjectMap = {
    [(0, $8f0nK.PreferenceCategory).Analytics]: 'performanceConsent',
    [(0, $8f0nK.PreferenceCategory).Functional]: 'functionalConsent',
    [(0, $8f0nK.PreferenceCategory).Marketing]: 'targetingConsent',
    [(0, $8f0nK.PreferenceCategory).Unknown]: null,
    [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: null
};
const $1ff20193aabe5ea7$var$categoryToTestIdMap = {
    [(0, $8f0nK.PreferenceCategory).StrictlyNecessary]: null,
    [(0, $8f0nK.PreferenceCategory).Analytics]: 'analytics',
    [(0, $8f0nK.PreferenceCategory).Functional]: 'functional',
    [(0, $8f0nK.PreferenceCategory).Marketing]: 'marketing',
    [(0, $8f0nK.PreferenceCategory).Unknown]: null
};
const $1ff20193aabe5ea7$export$3c97a3b492e10ae9 = ({ category: category, titleElement: titleElement, titleString: titleString, descriptionElement: descriptionElement, isChecked: isChecked, setPreferencesData: setPreferencesData })=>{
    const onCheckboxChange = (0, $4fqPo.useCallback)(()=>{
        // Don't alter cookies that are strictly necessary
        if (category === (0, $8f0nK.PreferenceCategory).StrictlyNecessary) return;
        setPreferencesData((prevPrefsData)=>{
            const isSelected = prevPrefsData.prefs && !prevPrefsData.prefs[category];
            const actionSubjectId = $1ff20193aabe5ea7$var$categoryToEventSubjectMap[category];
            if (actionSubjectId) (0, $hTxA3.sendUIEvent)({
                actionSubjectId: actionSubjectId,
                action: 'clicked',
                actionSubject: 'checkbox',
                source: 'cookieConsentModal',
                attributes: {
                    isSelected: isSelected
                }
            });
            return {
                ...prevPrefsData,
                prefs: {
                    ...prevPrefsData.prefs,
                    [category]: isSelected
                }
            };
        });
    }, [
        category,
        setPreferencesData
    ]);
    const descriptionId = `consent-preference-${$1ff20193aabe5ea7$var$categoryToTestIdMap[category]}-description`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $1ff20193aabe5ea7$var$categoryBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $f0SW5.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
        className: `${$1ff20193aabe5ea7$var$tmpTrelloClassNameOverride}`,
        isChecked: isChecked,
        value: isChecked.toString(),
        onChange: onCheckboxChange,
        label: titleElement,
        name: `${titleString}`,
        testId: `consent-preference-${$1ff20193aabe5ea7$var$categoryToTestIdMap[category]}`,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $1ff20193aabe5ea7$var$categoryDescriptionStyles,
        id: descriptionId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $e2Zgo.default), {
        size: "small",
        color: "color.text.subtle"
    }, descriptionElement)));
};

});

parcelRegister("4PPHO", function(module, exports) {
$parcel$export(module.exports, "i18n", () => $3c82093304c5488e$export$a7357cdd1f0b0168);

var $6BhDL = parcelRequire("6BhDL");
const $3c82093304c5488e$export$a7357cdd1f0b0168 = (0, $6BhDL.defineMessages)({
    title: {
        id: 'browser-storage-controls.consent-banner-modal.title',
        defaultMessage: 'Cookie preferences',
        description: 'The text is shown as the heading at the top of the cookie preferences modal dialog, which allows users to manage and configure their browser cookie and storage settings.'
    },
    summaryDescription: {
        id: 'browser-storage-controls.consent-banner-modal.summary.description.082624',
        defaultMessage: 'Because we value your privacy, you can select which cookies you allow. {link}',
        description: 'Cookie preferences modal dialog summary description.'
    },
    strictDescription: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our products to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    confirmBtn: {
        id: 'browser-storage-controls.consent-banner-modal.confirm.button',
        defaultMessage: 'Confirm',
        description: 'Cookie preferences modal dialog confirm button.'
    },
    cancelBtn: {
        id: 'browser-storage-controls.consent-banner-modal.cancel.button',
        defaultMessage: 'Cancel',
        description: 'Cookie preferences modal dialog cancel button.'
    },
    trackingLink: {
        id: 'browser-storage-controls.consent-banner-modal.tracking.link.082624',
        defaultMessage: 'Review our cookies and tracking notice',
        description: 'Cookie preferences modal link to tracking notice page.'
    },
    functionalOption: {
        id: 'browser-storage-controls.consent-banner-modal.functional.option.082624',
        defaultMessage: 'Allow functional cookies',
        description: 'Cookie preferences modal functional option.'
    },
    functionalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.functional.description.082624',
        defaultMessage: 'Provides enhanced functionality and personalization.',
        description: 'Cookie preferences modal functional option description.'
    },
    analyticalOption: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.option.082624',
        defaultMessage: 'Allow analytical cookies',
        description: 'Cookie preferences modal analytical option.'
    },
    analyticalOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024',
        defaultMessage: 'Measures usage to improve product performance.',
        description: 'Cookie preferences modal analytical option description.'
    },
    marketingOption: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.option.082624',
        defaultMessage: 'Allow marketing cookies',
        description: 'Cookie preferences modal marketing option.'
    },
    marketingOptionDescription: {
        id: 'browser-storage-controls.consent-banner-modal.marketing.description.082624',
        defaultMessage: 'Used for targeted advertising.',
        description: 'Cookie preferences modal marketing option description.'
    },
    strictDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.strict.description.082624-appify',
        defaultMessage: "Atlassian tracks <bold>strictly necessary</bold> cookies that are essential for our apps to function, so you can't adjust these. These cookies don't store personally identifiable information or track browsing habits.",
        description: 'Cookie preferences modal strict description.'
    },
    analyticalOptionDescriptionAppify: {
        id: 'browser-storage-controls.consent-banner-modal.analytical.description.101024-appify',
        defaultMessage: 'Measures usage to improve app performance.',
        description: 'Cookie preferences modal analytical option description.'
    }
});

});


parcelRegister("ljIaq", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef85d9e654958c0a$export$2e2bcd8739ae039);

var $4fqPo = parcelRequire("4fqPo");

var $2edmn = parcelRequire("2edmn");

var $7umuC = parcelRequire("7umuC");

var $fbg3F = parcelRequire("fbg3F");
/**
 * This function is responsible for loading the user's preferences from storage, and setting the state accordingly.
 * If the user's preferences are not found in storage, the default preferences will be used.
 */ const $ef85d9e654958c0a$var$loadStoredPreferences = async ({ setPreferencesData: setPreferencesData, isInitialRender: isInitialRender })=>{
    const prefs = await (0, $7umuC.getPreferences)();
    // If something has gone wrong during this `get` process (invalid token, failed request, etc.)
    // these preferences will be undefined and we'll need to show the banner as we're in an unknown state
    setPreferencesData({
        prefs: prefs,
        isPrefetchedPrefsInternalState: Boolean(prefs)
    });
    // Set the initialRender flag to false so we can skip logic in banner rendering
    if (isInitialRender) isInitialRender.current = false;
};
/**
 * This hook is responsible for handling any initially provided preference data, and/or fetching missing preference
 * data from ConsentHub. It will then set the appropriate cookies and state for the user's preferences to be used
 * throughout the application.

 * @param (optional) initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @returns (object) {
 * 	preferences - The current state of the user's preferences after fetching/transforming/setting cookies
 *	isPrefetchedPreferencesState - A boolean that indicates if we are in a prefetched internal state
 *	setPreferencesData - Setter function to update the preferences state
 *	isInitialRender - A boolean that indicates if this is the first render of the component
 * }
 */ const $ef85d9e654958c0a$var$usePreferences = ({ initialPreferences: initialPreferences })=>{
    /**
   * isInitialRender is used to ensure consistent banner visibility by addressing potential mismatches that occur
   *  during the initial render. Without this flag, the application might incorrectly display a banner based on
   * incomplete or missing preference data. During the rehydration process, this initial render triggers
   * the useMemo and useEffect hooks which means that initialPreferences may be undefined due to the asynchronous
   * nature of setting props. This can lead to discrepancies in banner visibility between the SSR state
   * and the client-rendered state.
   */ const isInitialRender = (0, $4fqPo.useRef)(true);
    const prefetchedPreferencesData = (0, $4fqPo.useRef)(initialPreferences);
    const [preferencesData, setPreferencesData] = (0, $4fqPo.useState)((0, $2edmn.initializePreferencesData)(initialPreferences));
    (0, $4fqPo.useEffect)(()=>{
        const { prefs: unpackedPrefetchedPrefs, isPrefetchedPrefsInternalState: isPrefetchedPrefsInternalState } = (0, $2edmn.initializePreferencesData)(prefetchedPreferencesData.current);
        if (!isPrefetchedPrefsInternalState && unpackedPrefetchedPrefs) // With a valid set of prefs, set them on the cookies, but don't save to ConsentHub
        (0, $fbg3F.updatePreferences)(unpackedPrefetchedPrefs, undefined, true);
        // On initial render, this will either set the proper preferences in state + required cookies based on the
        // prefetched data, or fetch all of that data from ConsentHub and then set appropriate cookies + state.
        $ef85d9e654958c0a$var$loadStoredPreferences({
            setPreferencesData: setPreferencesData,
            isInitialRender: isInitialRender
        });
    }, [
        isInitialRender
    ]);
    return {
        preferences: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.prefs,
        isPrefetchedPreferencesState: preferencesData === null || preferencesData === void 0 ? void 0 : preferencesData.isPrefetchedPrefsInternalState,
        setPreferencesData: setPreferencesData,
        isInitialRender: isInitialRender.current
    };
};
var $ef85d9e654958c0a$export$2e2bcd8739ae039 = $ef85d9e654958c0a$var$usePreferences;

});


parcelRegister("7Phxn", function(module, exports) {
$parcel$export(module.exports, "PresentationalConsentBanner", () => $e4a9faeb9cd5db68$export$dd3e60478510f81d);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $4fqPo = parcelRequire("4fqPo");

var $hCKuP = parcelRequire("hCKuP");
var $4MCQn = parcelRequire("4MCQn");

var $d7mfg = parcelRequire("d7mfg");

var $5T5mg = parcelRequire("5T5mg");

var $jWuCJ = parcelRequire("jWuCJ");
var $7TPEx = parcelRequire("7TPEx");
var $dEWOM = parcelRequire("dEWOM");
var $2m8U6 = parcelRequire("2m8U6");
parcelRequire("dVnnV");
var $3jKXW = parcelRequire("3jKXW");

var $8Mj6h = parcelRequire("8Mj6h");

var $2AAXb = parcelRequire("2AAXb");

var $bAAae = parcelRequire("bAAae");
const $e4a9faeb9cd5db68$var$boxStylesPurpleWithMinHeight = (0, $2m8U6.xcss)({
    padding: 'space.200',
    backgroundColor: 'color.background.discovery',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    borderColor: 'color.border',
    overflowY: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $e4a9faeb9cd5db68$var$noticeContainerStyles = (0, $2m8U6.xcss)({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.200'
});
const $e4a9faeb9cd5db68$var$inlineWrapperStylesStaticHeight = (0, $2m8U6.xcss)({
    // Small & Medium viewport defaults
    gap: 'space.100',
    flexDirection: 'column',
    alignItems: 'flex-start',
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    [(0, $3jKXW.media).above.md]: {
        gap: 'space.300',
        flexDirection: 'row',
        alignItems: 'center'
    }
});
const $e4a9faeb9cd5db68$var$buttonContainerStylesStaticHeight = (0, $2m8U6.xcss)({
    minWidth: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    justifyContent: 'start',
    [(0, $3jKXW.media).above.md]: {
        marginLeft: 'auto',
        flexWrap: 'nowrap',
        flexDirection: 'row'
    }
});
const $e4a9faeb9cd5db68$var$truncatedTextStyles = (0, $2m8U6.xcss)({
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 1,
    flex: '0 1 auto'
});
const $e4a9faeb9cd5db68$var$linkNoTruncateStyles = (0, $2m8U6.xcss)({
    flex: '0 0 auto',
    whiteSpace: 'nowrap'
});
const $e4a9faeb9cd5db68$var$smallMediumScreenContainerStyles = (0, $2m8U6.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.050',
    alignItems: 'baseline',
    [(0, $3jKXW.media).above.md]: {
        display: 'none'
    }
});
const $e4a9faeb9cd5db68$var$largeScreenContainerStyles = (0, $2m8U6.xcss)({
    display: 'none',
    [(0, $3jKXW.media).above.md]: {
        display: 'block'
    }
});
const $e4a9faeb9cd5db68$var$noop = ()=>{};
const $e4a9faeb9cd5db68$var$getDisplayedTextMap = (intl)=>{
    // We'll use this mapping to send the `displayedText` for each checkbox when saving to ConsentHub
    const displayedTextMap = (0, $2AAXb.CONSENT_DISPLAYED_TEXT_ITEMS).reduce((translatedTextMap, category)=>{
        const linkToCookiesTrackingNotice = intl.formatMessage((0, $bAAae.i18n).cookiesTrackingNotice);
        const bannerDescription = intl.formatMessage((0, $bAAae.i18n).useCookiesDescription, {
            linkToCookiesTrackingNotice: linkToCookiesTrackingNotice
        });
        // Set this for all items (including items with checkboxes in the UI), we'll override as needed below
        // for things like strictlyNecessary/acceptAll
        translatedTextMap[category] = bannerDescription;
        return translatedTextMap;
    }, {});
    return displayedTextMap;
};
const $e4a9faeb9cd5db68$var$updateDisplayedTextMap = (intl, displayTextMap, isOnlyNecessary)=>{
    const updatedDisplayedTextMap = {
        ...displayTextMap
    };
    // Use description as message to translate
    const onlyNecessaryContent = intl.formatMessage((0, $bAAae.i18n).onlyNecessaryBtn);
    const acceptAllContent = intl.formatMessage((0, $bAAae.i18n).acceptAllBtn);
    // For additional auditing content, append the description related to the button when pressed
    Object.keys(updatedDisplayedTextMap).forEach((key)=>{
        const preferenceCategory = key;
        const additionalContent = isOnlyNecessary ? onlyNecessaryContent : acceptAllContent;
        const textContent = updatedDisplayedTextMap[preferenceCategory];
        updatedDisplayedTextMap[preferenceCategory] = `${additionalContent} \u{2014} ${textContent}`;
    });
    return updatedDisplayedTextMap;
};
const $e4a9faeb9cd5db68$export$dd3e60478510f81d = ({ onClickOnlyNecessary: onClickOnlyNecessary = $e4a9faeb9cd5db68$var$noop, onClickAcceptAll: onClickAcceptAll = $e4a9faeb9cd5db68$var$noop, onClickPreferences: onClickPreferences = $e4a9faeb9cd5db68$var$noop, onClickTrackingNoticeLink: onClickTrackingNoticeLink = $e4a9faeb9cd5db68$var$noop, minWidth: minWidth = 400, newMinHeight: newMinHeight = 105 })=>{
    const intl = (0, $4MCQn.default)();
    const displayedTextMap = (0, $4fqPo.useMemo)(()=>{
        return $e4a9faeb9cd5db68$var$getDisplayedTextMap(intl);
    }, [
        intl
    ]);
    const handleOnlyNecessaryClick = (0, $4fqPo.useCallback)(()=>{
        const displayedTextOnlyNecessaryMap = $e4a9faeb9cd5db68$var$updateDisplayedTextMap(intl, displayedTextMap, true);
        onClickOnlyNecessary(displayedTextOnlyNecessaryMap);
    }, [
        onClickOnlyNecessary,
        intl,
        displayedTextMap
    ]);
    const handleAcceptAllClick = (0, $4fqPo.useCallback)(()=>{
        const displayedTextAcceptAllMap = $e4a9faeb9cd5db68$var$updateDisplayedTextMap(intl, displayedTextMap);
        onClickAcceptAll(displayedTextAcceptAllMap);
    }, [
        onClickAcceptAll,
        intl,
        displayedTextMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        role: "dialog",
        "aria-labelledby": "cookiesTrackingNoticeLink",
        xcss: $e4a9faeb9cd5db68$var$boxStylesPurpleWithMinHeight,
        style: {
            minWidth: `${minWidth}px`,
            // If you are updating the minHeight, please also update the MIN_BANNER_HEIGHT in confluence/next/packages/cookies-consent-banner/src/useCookiesConsentBanner.ts
            minHeight: `${newMinHeight}px`,
            height: `${newMinHeight}px`
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $e4a9faeb9cd5db68$var$inlineWrapperStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $e4a9faeb9cd5db68$var$noticeContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $e4a9faeb9cd5db68$var$smallMediumScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $8Mj6h.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bAAae.i18n).useCookiesDescriptionNoLink),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        xcss: $e4a9faeb9cd5db68$var$truncatedTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
        ...(0, $bAAae.i18n).useCookiesDescriptionNoLink,
        tagName: "span"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jWuCJ.default), {
        id: "cookiesTrackingNoticeLink",
        href: "https://www.atlassian.com/legal/cookies",
        target: "_blank",
        onClick: onClickTrackingNoticeLink,
        xcss: $e4a9faeb9cd5db68$var$linkNoTruncateStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bAAae.i18n).cookiesTrackingNotice))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $7TPEx.default), {
        xcss: $e4a9faeb9cd5db68$var$largeScreenContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), {
        ...(0, $bAAae.i18n).useCookiesDescription,
        tagName: "span",
        values: {
            linkToCookiesTrackingNotice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $jWuCJ.default), {
                id: "cookiesTrackingNoticeLink",
                href: "https://www.atlassian.com/legal/cookies",
                target: "_blank",
                onClick: onClickTrackingNoticeLink
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bAAae.i18n).cookiesTrackingNotice))
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $dEWOM.default), {
        space: "space.100",
        xcss: $e4a9faeb9cd5db68$var$buttonContainerStylesStaticHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
        testId: "preferences-button",
        appearance: "subtle",
        onClick: onClickPreferences
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bAAae.i18n).preferencesBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
        testId: "only-necessary-button",
        onClick: handleOnlyNecessaryClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bAAae.i18n).onlyNecessaryBtn)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $d7mfg.default), {
        testId: "accept-all-button",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($5T5mg))),
        onClick: handleAcceptAllClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $hCKuP.default), (0, $bAAae.i18n).acceptAllBtn)))));
};

});

parcelRegister("lc4vG", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b20b36460dadb43$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 
var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $hTxA3 = parcelRequire("hTxA3");

var $2manU = parcelRequire("2manU");

var $2Itg6 = parcelRequire("2Itg6");

var $2NqzH = parcelRequire("2NqzH");

var $a5OUx = parcelRequire("a5OUx");

var $cnMPG = parcelRequire("cnMPG");

var $2edmn = parcelRequire("2edmn");

var $gCY8Y = parcelRequire("gCY8Y");

var $8f0nK = parcelRequire("8f0nK");
/**
 * @private
 * @deprecated Legacy SSR banner visibility check that doesn't consider fallbackConsentToken.
 * Kept only as the feature-gate-off fallback for 'platform_moonjelly_bsc_ssr_banner_flash_fix'.
 * Will be removed once the gate is fully rolled out.
 */ const $5b20b36460dadb43$var$shouldShowBannerInSSRContextLegacy = (initialPreferences)=>{
    if (!initialPreferences || initialPreferences === (0, $8f0nK.PrefetchedPreferenceState).INTERNAL || (0, $2edmn.initialPreferencesAreMissing)(initialPreferences)) return true;
    return !(0, $gCY8Y.hasPrefetchedDataConsents)(initialPreferences);
};
const $5b20b36460dadb43$export$f6e8c8e54d2f31fe = (isInitialRender, initialPreferences, ssrOptions)=>{
    // We don't have a great way to handle dealing with consent timestamps right here, as we have no global state/store, so we have to precompute
    // banner visibility state when we fetch consents, and store it in a cookie to be read later, here.
    const shouldShowBannerBit = ssrOptions !== null && ssrOptions !== void 0 && ssrOptions.getCookie ? ssrOptions.getCookie((0, $2Itg6.ATLASSIAN_SHOW_BANNER_COOKIE_KEY)) : (0, $cnMPG.getCookie)((0, $2Itg6.ATLASSIAN_SHOW_BANNER_COOKIE_KEY));
    const inFlowWhereBannerStateIsUnknown = initialPreferences && isInitialRender && shouldShowBannerBit === undefined;
    if (((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $2manU.isSSR)()) || inFlowWhereBannerStateIsUnknown) {
        // When coming from SSR, this hook will only execute once and won't update later
        // Instead, if we're on the server, have initial preference data with valid consents, don't render
        // On later checks (rehydration), this will always fail and skip to the normal rendering logic
        // Once we're rehydrating, if have been provided initial prefs (from SSR), on the "first render", the banner cookie may still be missing.
        // Due to React lifecycle where this useMemo is executing prior to the useEffect in the usePreferences hook, which sets the core cookies.
        // We should give this flow the same treatment as rendering in an SSR context to match the behavior of the SSR flow to reduce any potential UX flicker.
        if (initialPreferences === (0, $8f0nK.PrefetchedPreferenceState).INTERNAL) // If we're in the "fetch internally" state, we have no prefetched data and we can't determine
        // if the user has consented or not yet since we need to fetch, so show the banner
        return true;
        if ((0, $3H4LK.fg)('platform_moonjelly_bsc_ssr_banner_flash_fix')) // shouldRenderBannerPrefetched is the single source of truth for SSR/hydration banner visibility.
        // It is used here and by all external consumers (e.g. useCookiesConsentBanner) to guarantee
        // consistent decisions, including correct handling of fallbackConsentToken.
        //
        // Cast: PrefetchedConsentPreferenceData is a narrower type than PrefetchedConsentPreferences —
        // it excludes PrefetchedPreferenceState (handled above) but is otherwise compatible at this call site.
        return (0, $2NqzH.shouldRenderBannerPrefetched)(initialPreferences, ssrOptions);
        // Legacy path: uses hasPrefetchedDataConsents which doesn't consider fallbackConsentToken.
        // This path will be removed once the feature gate is fully rolled out.
        return $5b20b36460dadb43$var$shouldShowBannerInSSRContextLegacy(initialPreferences);
    }
    const shouldShowBanner = shouldShowBannerBit ? !!Number(shouldShowBannerBit) : false;
    return shouldShowBanner;
};
/**
 * This hook is responsible for determining whether or not the consent banner should be shown based on the user's
 * preferences and the current state of the banner cookie, as well as if the we're rendering from an SSR context.
 *
 * @param preferences - The current state of the user's preferences
 * @param initialPreferences - Any initially provided preferences from consuming applications (used for SSR)
 * @param isInitialRender - A boolean to track if this is the "first" render of the component
 * @param isPrefetchedPreferencesState - A boolean that indicates if are fetching consents internally to our component
 * @returns showBanner - Whether or not the banner should be shown
 * @returns setIsDismissed - Setter function to update the dismissed state of the banner
 */ const $5b20b36460dadb43$var$useBannerVisibility = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, ssrOptions: ssrOptions })=>{
    const isEventSent = (0, $4fqPo.useRef)(false);
    const [isDismissed, setIsDismissedProp] = (0, $4fqPo.useState)(false);
    const setIsDismissed = (isDismissed)=>{
        if (isDismissed) (0, $a5OUx.setStrictlyNecessaryCookie)((0, $2Itg6.ATLASSIAN_BANNER_LAST_DISMISSED_TIME_COOKIE_KEY), Date.now().toString(), {
            path: '/'
        });
        setIsDismissedProp(isDismissed);
    };
    const showBanner = (0, $4fqPo.useMemo)(()=>{
        return $5b20b36460dadb43$export$4ea0ccb8ff519056({
            preferences: preferences,
            initialPreferences: initialPreferences,
            isInitialRender: isInitialRender,
            isPrefetchedPreferencesState: isPrefetchedPreferencesState,
            isDismissed: isDismissed,
            ssrOptions: ssrOptions
        });
    }, [
        isInitialRender,
        initialPreferences,
        isPrefetchedPreferencesState,
        preferences,
        isDismissed,
        ssrOptions
    ]);
    (0, $4fqPo.useEffect)(()=>{
        if (!isEventSent.current && showBanner) {
            (0, $hTxA3.sendScreenEvent)({
                name: 'cookieConsentBanner'
            });
            isEventSent.current = true;
        }
    }, [
        isEventSent,
        showBanner
    ]);
    return {
        showBanner: showBanner,
        setIsDismissed: setIsDismissed
    };
};
const $5b20b36460dadb43$export$4ea0ccb8ff519056 = ({ preferences: preferences, initialPreferences: initialPreferences, isInitialRender: isInitialRender, isPrefetchedPreferencesState: isPrefetchedPreferencesState, isDismissed: isDismissed, ssrOptions: ssrOptions })=>{
    if ((0, $aoZN9.getBscGlobalState)().localConsentMode) {
        // In V1, we only checked based on the existence of the preferences
        const prefsMissing = !preferences;
        if ((ssrOptions === null || ssrOptions === void 0 ? void 0 : ssrOptions.isSSR) ?? (0, $2manU.isSSR)()) // This logic will execute normally in V2, but for now, as SSR prefetching has not been implemented completely
        // just hide the banner if we're missing the data (always will be in SSR-context) and let the UI handle it on rehydration
        return !prefsMissing && !isDismissed;
        return prefsMissing && !isDismissed;
    }
    const shouldShowBanner = $5b20b36460dadb43$export$f6e8c8e54d2f31fe(isInitialRender, initialPreferences, ssrOptions);
    const unknownPreferences = !isPrefetchedPreferencesState && !preferences;
    return (unknownPreferences || shouldShowBanner) && !isDismissed;
};
var $5b20b36460dadb43$export$2e2bcd8739ae039 = $5b20b36460dadb43$var$useBannerVisibility;

});
parcelRegister("2NqzH", function(module, exports) {
$parcel$export(module.exports, "shouldRenderBannerPrefetched", () => $24543f7e0a832dcf$export$6406464aa126433e);

var $3H4LK = parcelRequire("3H4LK");

var $bzEve = parcelRequire("bzEve");

var $gCY8Y = parcelRequire("gCY8Y");

var $2edmn = parcelRequire("2edmn");

var $8sIDt = parcelRequire("8sIDt");
const $24543f7e0a832dcf$export$6406464aa126433e = (prefetchedPreferencesData, ssrOptions)=>{
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_ssr_killswitch')) // If the bsc ssr killswitch is enabled, we should not show the banner
    // in SSR context
    return false;
    if (!prefetchedPreferencesData) // If prefetched prefs are missing (presumably SSR prefetching failed), but are still trying to compute
    // banner state, we have no info to calculate from so, we need to show the banner to be compliant
    return true;
    if ('consentToken' in prefetchedPreferencesData) {
        // We've been given cached cookie data, validate it before use.
        // If invalid, we can't determine anything, show the banner for compliance sake
        const { isValid: isValid } = (0, $2edmn.checkTokenVersionValidity)(prefetchedPreferencesData.consentToken);
        return isValid ? (0, $8sIDt.getBannerVisibility)(prefetchedPreferencesData, ssrOptions) : true;
    }
    // We've been given ConsentHub response data
    // Check if we have consents via prefetched data
    // to prevent mismatches where space is reserved but UI doesn't render
    const prefetchedDataHasConsents = (0, $gCY8Y.hasPrefetchedDataConsents)(prefetchedPreferencesData);
    if (prefetchedDataHasConsents) return false;
    // Format it appropriately and use getBannerVisibility for proper staleness/fallback checks
    const consentPrefsData = (0, $bzEve.buildConsentPreferences)(prefetchedPreferencesData);
    return (0, $8sIDt.getBannerVisibility)(consentPrefsData, ssrOptions);
};

});




parcelRegister("6EQJz", function(module, exports) {
$parcel$export(module.exports, "initializeControls", () => $1749c7ccb3545076$export$919040c32a62c7db);

var $3H4LK = parcelRequire("3H4LK");

var $hTxA3 = parcelRequire("hTxA3");
var $2manU = parcelRequire("2manU");
var $KilRp = parcelRequire("KilRp");

var $aoZN9 = parcelRequire("aoZN9");
var $jx6p8 = parcelRequire("jx6p8");
parcelRequire("kcQKb");
var $lFYsw = parcelRequire("lFYsw");

var $gunxX = parcelRequire("gunxX");

var $dirXp = parcelRequire("dirXp");

var $eATkg = parcelRequire("eATkg");

var $2zNoW = parcelRequire("2zNoW");
const $1749c7ccb3545076$export$919040c32a62c7db = async (args = {
    analyticsEnabled: true
})=>{
    if ((0, $3H4LK.fg)('platform_moonjelly_bsc_master_killswitch')) return undefined;
    let initResult;
    try {
        (0, $KilRp.Logger).debug('initializeControls invoked');
        if ((0, $3H4LK.fg)('fedramp-consent-banner-perimeter-prop')) (0, $jx6p8.initializeGlobalState)({
            ...args,
            overrideOnceParams: true
        });
        else (0, $jx6p8.initializeGlobalState)(args);
        if ((0, $2manU.isSSR)()) return undefined;
        if ((0, $3H4LK.fg)('platform_bsc_initialize_controls_analytics')) (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'bscInitControlsParameters',
            attributes: {
                product: args.product,
                analyticsEnabled: args.analyticsEnabled,
                flagEnabled: args.flagEnabled,
                webStorageEnabled: args.webStorageEnabled,
                indexedDbEnabled: args.indexedDbEnabled,
                disableWebStorageConsentChecks: args.disableWebStorageConsentChecks,
                disableIndexedDbConsentChecks: args.disableIndexedDbConsentChecks,
                allowUncategorizedCookiesInOverrides: args.allowUncategorizedCookiesInOverrides,
                allowUncategorizedItemsInWebStorageOverrides: args.allowUncategorizedItemsInWebStorageOverrides,
                perimeter: args.perimeter,
                hasShouldEnforceKeyCallback: !!args.__UNSAFE_shouldEnforceKeyForRollout
            }
        });
        // Ensures that the AWC is constructed before overwriting any native methods.
        const analyticsWebClientInstance = (0, $hTxA3.getAnalyticsClient)();
        // If AWC is not initialized, it will be undefined
        const isAnalyticsInitialized = !!analyticsWebClientInstance;
        if (args.analyticsEnabled && !isAnalyticsInitialized) throw new Error(`Failed to initialize AnalyticsWebClient. Analytics logging will not be set for native method overrides.`);
        await (0, $dirXp.createDocumentCookiePassthrough)();
        const isWebStorageControlsEnabled = (0, $aoZN9.getBscGlobalState)().webStorageEnabled;
        if (isWebStorageControlsEnabled) {
            await (0, $2zNoW.createWebStoragePassthrough)((0, $lFYsw.WebStorageType).LocalStorage);
            await (0, $2zNoW.createWebStoragePassthrough)((0, $lFYsw.WebStorageType).SessionStorage);
        }
        const isIndexedDbEnabled = (0, $aoZN9.getBscGlobalState)().indexedDbEnabled;
        if (isIndexedDbEnabled) {
            const disableIndexedDbConsentChecks = (0, $aoZN9.getBscGlobalState)().disableIndexedDbConsentChecks ?? false;
            if ((0, $3H4LK.fg)('jfp-magma-selective-storage-enforcement')) {
                const __UNSAFE_shouldEnforceKeyForRollout = (0, $aoZN9.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
                // `__UNSAFE_shouldEnforceKeyForRollout` needs the consent-checking override installed to do
                // per-key re-enforcement at call time.
                await (0, $eATkg.createIndexedDBPassthrough)({
                    performConsentChecks: !disableIndexedDbConsentChecks || __UNSAFE_shouldEnforceKeyForRollout !== undefined
                });
            } else await (0, $eATkg.createIndexedDBPassthrough)({
                performConsentChecks: !disableIndexedDbConsentChecks
            });
        }
        (0, $KilRp.Logger).debug('initializeControls finished');
        if ((0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage')) {
            const storageCleanupPromise = (0, $gunxX.cleanupStorage)();
            initResult = Object.assign(initResult ?? {}, {
                storageCleanupPromise: storageCleanupPromise
            });
        }
    } catch (e) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'initializeControlsError',
            message: `Failed to initialize browser storage controls. ${e.message || ''}`
        });
    }
    return initResult;
};

});
parcelRegister("gunxX", function(module, exports) {
$parcel$export(module.exports, "cleanupStorage", () => $1a630e007ea05d3a$export$e6332b39565fb2b3);

var $fJXyP = parcelRequire("fJXyP");

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $KilRp = parcelRequire("KilRp");
var $hTxA3 = parcelRequire("hTxA3");

var $812Hd = parcelRequire("812Hd");

var $kcQKb = parcelRequire("kcQKb");
var $lFYsw = parcelRequire("lFYsw");

var $8f0nK = parcelRequire("8f0nK");

var $7umuC = parcelRequire("7umuC");

var $jz4E1 = parcelRequire("jz4E1");
function $1a630e007ea05d3a$var$isCategoryRevoked({ category: category, preferences: preferences }) {
    if (category === (0, $8f0nK.PreferenceCategory).StrictlyNecessary) return false;
    if (!preferences) return false;
    return !preferences[category];
}
function $1a630e007ea05d3a$var$yieldToMain() {
    return new Promise((resolve)=>setTimeout(resolve, 0));
}
const $1a630e007ea05d3a$var$ITEMS_PER_YIELD = 50;
const $1a630e007ea05d3a$var$ITEM_CAP = 500;
async function $1a630e007ea05d3a$export$e6332b39565fb2b3() {
    try {
        const cleanupStartTime = performance.now();
        const globalState = (0, $aoZN9.getBscGlobalState)();
        const preferences = await (0, $7umuC.getPreferences)();
        const localStorage = (0, $kcQKb.findStorageTarget)((0, $lFYsw.WebStorageType).LocalStorage);
        const sessionStorage = (0, $kcQKb.findStorageTarget)((0, $lFYsw.WebStorageType).SessionStorage);
        const idb = window.indexedDB;
        const productName = globalState.product;
        const [localStorageCache, sessionStorageCache, cookieCache, indexedDBCache] = await Promise.all([
            globalState.loadCache((0, $8f0nK.CategoryStorageType).LocalStorage),
            globalState.loadCache((0, $8f0nK.CategoryStorageType).SessionStorage),
            globalState.loadCache((0, $8f0nK.CategoryStorageType).Cookies),
            globalState.loadCache((0, $8f0nK.CategoryStorageType).IndexedDB)
        ]);
        const revokedItems = [];
        const uncategorizedItems = [];
        let hitEnumerationLimit = false;
        let itemsProcessed = 0;
        let deletionCount = 0;
        // localStorage
        const shouldDeleteWebStorage = !globalState.disableWebStorageConsentChecks && globalState.webStorageEnabled;
        if (localStorageCache) for(let i = 0; i < localStorage.length(); i++){
            if (itemsProcessed >= $1a630e007ea05d3a$var$ITEM_CAP) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $1a630e007ea05d3a$var$ITEMS_PER_YIELD === 0) await $1a630e007ea05d3a$var$yieldToMain();
            const key = localStorage.key(i);
            if (key === null) continue;
            const category = (0, $812Hd.getItemCategoryFromPassedCache)(key, localStorageCache, productName);
            if (category === null || category === (0, $8f0nK.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'localStorage'
            });
            else if ($1a630e007ea05d3a$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                revokedItems.push({
                    key: key,
                    storageType: 'localStorage',
                    category: category
                });
                if (shouldDeleteWebStorage && (0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    localStorage.removeItem(key);
                    i--; // removing an item shifts later ones; use same index for the next iteration
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // sessionStorage
        if (!hitEnumerationLimit && sessionStorageCache) for(let i = 0; i < sessionStorage.length(); i++){
            if (itemsProcessed >= $1a630e007ea05d3a$var$ITEM_CAP) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $1a630e007ea05d3a$var$ITEMS_PER_YIELD === 0) await $1a630e007ea05d3a$var$yieldToMain();
            const key = sessionStorage.key(i);
            if (key === null) continue;
            const category = (0, $812Hd.getItemCategoryFromPassedCache)(key, sessionStorageCache, productName);
            if (category === null || category === (0, $8f0nK.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'sessionStorage'
            });
            else if ($1a630e007ea05d3a$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                revokedItems.push({
                    key: key,
                    storageType: 'sessionStorage',
                    category: category
                });
                if (shouldDeleteWebStorage && (0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    sessionStorage.removeItem(key);
                    i--; // removing an item shifts later ones; use same index for the next iteration
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // cookies
        if (!hitEnumerationLimit && cookieCache) for (const key of Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($fJXyP))).get())){
            if (itemsProcessed >= $1a630e007ea05d3a$var$ITEM_CAP) {
                hitEnumerationLimit = true;
                break;
            }
            if ((itemsProcessed + 1) % $1a630e007ea05d3a$var$ITEMS_PER_YIELD === 0) await $1a630e007ea05d3a$var$yieldToMain();
            const category = (0, $812Hd.getItemCategoryFromPassedCache)(key, cookieCache, productName);
            if (category === null || category === (0, $8f0nK.PreferenceCategory).Unknown) uncategorizedItems.push({
                key: key,
                storageType: 'cookie'
            });
            else if ($1a630e007ea05d3a$var$isCategoryRevoked({
                category: category,
                preferences: preferences
            })) {
                revokedItems.push({
                    key: key,
                    storageType: 'cookie',
                    category: category
                });
                // There's no corresponding `shouldDeleteWebStorage` for cookies as they have no reporting-only mode.
                if ((0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                    (0, $jz4E1.deleteCookie)(key);
                    deletionCount++;
                }
            }
            itemsProcessed++;
        }
        // IndexedDB
        const shouldDeleteIdb = !globalState.disableIndexedDbConsentChecks && globalState.indexedDbEnabled;
        if (!hitEnumerationLimit && indexedDBCache && typeof (idb === null || idb === void 0 ? void 0 : idb.databases) === 'function') try {
            const dbs = await idb.databases();
            for (const db of dbs){
                if (itemsProcessed >= $1a630e007ea05d3a$var$ITEM_CAP) {
                    hitEnumerationLimit = true;
                    break;
                }
                if ((itemsProcessed + 1) % $1a630e007ea05d3a$var$ITEMS_PER_YIELD === 0) await $1a630e007ea05d3a$var$yieldToMain();
                const name = db.name;
                if (name === undefined) continue;
                const category = (0, $812Hd.getItemCategoryFromPassedCache)(name, indexedDBCache, productName);
                if (category === null || category === (0, $8f0nK.PreferenceCategory).Unknown) uncategorizedItems.push({
                    key: name,
                    storageType: 'indexedDB'
                });
                else if ($1a630e007ea05d3a$var$isCategoryRevoked({
                    category: category,
                    preferences: preferences
                })) {
                    revokedItems.push({
                        key: name,
                        storageType: 'indexedDB',
                        category: category
                    });
                    if (shouldDeleteIdb && (0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete')) {
                        const request = idb.deleteDatabase(name);
                        request.onerror = ()=>{
                            var _request$error;
                            (0, $KilRp.Logger).warn(`cleanupStorage: failed to delete IndexedDB "${name}": ${((_request$error = request.error) === null || _request$error === void 0 ? void 0 : _request$error.message) ?? ''}`);
                        };
                        deletionCount++;
                    }
                }
                itemsProcessed++;
            }
        } catch  {
        // idb.databases() unavailable or threw — skip IDB entirely
        }
        if (deletionCount > 0) (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'storageCleanupDeleted',
            attributes: {
                deletedCount: deletionCount
            }
        });
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'storageCleanupCategorized',
            attributes: {
                durationMs: Math.round(performance.now() - cleanupStartTime),
                deletionMode: (0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
                revokedCount: revokedItems.length,
                revokedItems: revokedItems.map(({ storageType: storageType, key: key, category: category })=>`${storageType} ${key} ${category}`),
                uncategorizedCount: uncategorizedItems.length,
                uncategorizedItems: uncategorizedItems.map(({ storageType: storageType, key: key })=>`${storageType} ${key}`),
                hitEnumerationLimit: hitEnumerationLimit
            }
        });
        return {
            deletionMode: (0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
            revokedItems: revokedItems,
            uncategorizedItems: uncategorizedItems,
            hitEnumerationLimit: hitEnumerationLimit
        };
    } catch (error) {
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'storageCleanupError',
            message: `cleanupStorage failed: ${(error === null || error === void 0 ? void 0 : error.message) ?? 'no message'}`
        });
        return {
            deletionMode: (0, $3H4LK.fg)('platform_bsc_cleanup_revoked_storage_live_delete') ? 'live' : 'dry-run',
            revokedItems: [],
            uncategorizedItems: [],
            hitEnumerationLimit: false
        };
    }
}

});

parcelRegister("dirXp", function(module, exports) {
$parcel$export(module.exports, "createDocumentCookiePassthrough", () => $79c8c07211623084$export$45a5573b04db016c);

var $KilRp = parcelRequire("KilRp");

var $7ZvIM = parcelRequire("7ZvIM");
const $79c8c07211623084$export$45a5573b04db016c = async ()=>{
    const documentCookieProperty = Object.getOwnPropertyDescriptor(Document.prototype, 'cookie');
    const originalSetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.set;
    const originalGetter = documentCookieProperty === null || documentCookieProperty === void 0 ? void 0 : documentCookieProperty.get;
    if (!originalSetter || !originalGetter) {
        (0, $KilRp.Logger).warn('No document.cookie capabilities found');
        return;
    }
    // Override document.cookie setter
    Object.defineProperty(document, 'cookie', {
        get: originalGetter,
        set: (0, $7ZvIM.getSetCookieOverride)(originalSetter),
        configurable: true
    });
};

});
parcelRegister("7ZvIM", function(module, exports) {
$parcel$export(module.exports, "getSetCookieOverride", () => $86e317e7001b4ad0$export$b7364c41ddbfdb0a);

var $aoZN9 = parcelRequire("aoZN9");
var $hTxA3 = parcelRequire("hTxA3");

var $hTxA3 = parcelRequire("hTxA3");

var $812Hd = parcelRequire("812Hd");

var $KilRp = parcelRequire("KilRp");

var $8f0nK = parcelRequire("8f0nK");
const $86e317e7001b4ad0$export$b7364c41ddbfdb0a = (originalSetter)=>(originalCookieValue)=>{
        const cookieSetByPackage = originalCookieValue.includes('atl-set-cookie');
        if (cookieSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetter.apply(document, [
                originalCookieValue
            ]);
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `document.cookie setter failed to set cookie set by package. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false
                }
            });
        }
        try {
            // Raw cookies and query params can contain sensitive PII/UGC we can't store, so we want to
            // strip that out before we log it out to our analytics client.
            const sanitizedCookieKey = originalCookieValue.slice(0, originalCookieValue.indexOf('=')) || '';
            (0, $hTxA3.sendPackageOperationalEvent)({
                action: 'usedDocumentCookie',
                attributes: {
                    cookieKey: sanitizedCookieKey,
                    outsidePackage: !cookieSetByPackage
                }
            });
            try {
                const productName = (0, $aoZN9.getBscGlobalState)().product;
                // Attempt to set a known cookie that was set from outside the package
                (0, $812Hd.isProcessingAllowedByPreferences)({
                    itemKey: sanitizedCookieKey,
                    allowedCallback: ()=>{
                        return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory })=>{
                        if (!itemHasCategory) (0, $hTxA3.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: (0, $8f0nK.CategoryStorageType).Cookies,
                                productName: productName,
                                originalItemKey: sanitizedCookieKey,
                                itemCategory: itemCategory ?? null
                            }
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides } = (0, $aoZN9.getBscGlobalState)();
                        if (allowUncategorizedCookiesInOverrides && !itemHasCategory) return originalSetter.apply(document, [
                            originalCookieValue
                        ]);
                        else return;
                    },
                    storageType: (0, $8f0nK.CategoryStorageType).Cookies,
                    productName: productName
                });
            } catch (e) {
                (0, $KilRp.Logger).errorWithOperationalEvent({
                    action: 'usedDocumentCookieError',
                    message: `Failed to set cookie. ${e.message || ''}`,
                    attributes: {
                        cookieKey: sanitizedCookieKey
                    }
                });
            }
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedDocumentCookieError',
                message: `Failed to send document.cookie setter event. ${e.message || ''}`
            });
        }
    };

});


parcelRegister("eATkg", function(module, exports) {
$parcel$export(module.exports, "createIndexedDBPassthrough", () => $b4a141b775f560d0$export$a03098708eb0de1);

var $KilRp = parcelRequire("KilRp");

var $d7B0c = parcelRequire("d7B0c");
const $b4a141b775f560d0$export$a03098708eb0de1 = async (config)=>{
    const indexedDB = window.indexedDB;
    if (!indexedDB) {
        (0, $KilRp.Logger).warn('No IndexedDB capabilities found');
        return;
    }
    if (typeof indexedDB.open !== 'function') {
        (0, $KilRp.Logger).warn('IndexedDB.open is not a function');
        return;
    }
    try {
        const originalOpen = indexedDB.open.bind(indexedDB);
        (0, $KilRp.Logger).debug(`Installing IndexedDB override ${config.performConsentChecks ? 'with' : 'without'} consent checks`);
        // Use Object.defineProperty for better browser compatibility and consistency
        // with other passthrough implementations (document.cookie, localStorage/sessionStorage)
        Object.defineProperty(indexedDB, 'open', {
            value: config.performConsentChecks ? (0, $d7B0c.getIndexedDBOpenOverride)(originalOpen) : (0, $d7B0c.getIndexedDBOpenOverrideEventOnly)(originalOpen),
            writable: true,
            configurable: true
        });
        (0, $KilRp.Logger).debug('IndexedDB open override installed');
    } catch (e) {
        (0, $KilRp.Logger).error(`Failed to install IndexedDB open override. ${e.message || ''}`);
    }
};

});
parcelRegister("d7B0c", function(module, exports) {
$parcel$export(module.exports, "getIndexedDBOpenOverrideEventOnly", () => $b537252c234af449$export$5a412306febb78c);
$parcel$export(module.exports, "getIndexedDBOpenOverride", () => $b537252c234af449$export$5721aa15a04b1881);

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $hTxA3 = parcelRequire("hTxA3");

var $812Hd = parcelRequire("812Hd");

var $KilRp = parcelRequire("KilRp");

var $ToUEU = parcelRequire("ToUEU");

var $803YE = parcelRequire("803YE");

var $bBzKh = parcelRequire("bBzKh");

var $8f0nK = parcelRequire("8f0nK");
// DatabaseBlockedError extends DOMException in browser environments, but DOMException is not
// available in SSR/Node.js, which causes import errors. We conditionally extend DOMException
// only when it is available, falling back to a plain Error in SSR — the same pattern used
// for IDBOpenDBRequestWrapper.
let $b537252c234af449$var$DatabaseBlockedError;
if (typeof DOMException !== 'undefined') $b537252c234af449$var$DatabaseBlockedError = class DatabaseBlockedError extends DOMException {
};
else $b537252c234af449$var$DatabaseBlockedError = class DatabaseBlockedError extends Error {
    constructor(message, name = 'DatabaseBlockedError'){
        super(message), this.name = name;
    }
};
const $b537252c234af449$var$checkAndSendAnalyticsEvent = async (eventDetails)=>{
    const wasSetByPackage = (0, $bBzKh.ItemKeyCache).wasSetByPackage((0, $8f0nK.CategoryStorageType).IndexedDB, eventDetails.databaseName);
    const productName = (0, $aoZN9.getBscGlobalState)().product;
    const itemCategory = await (0, $812Hd.getItemCategory)(eventDetails.databaseName, (0, $8f0nK.CategoryStorageType).IndexedDB, productName);
    const isStrictlyNecessary = itemCategory === (0, $8f0nK.PreferenceCategory).StrictlyNecessary;
    if (!isStrictlyNecessary && !wasSetByPackage) {
        const categoryAttribute = (0, $3H4LK.fg)('platform_bsc_add_category_to_idb_open_events') ? {
            itemCategory: itemCategory ?? (0, $8f0nK.PreferenceCategory).Unknown
        } : {};
        const attributes = {
            ...eventDetails,
            productName: productName,
            outsidePackage: true,
            ...categoryAttribute
        };
        // Send analytics event for uncategorized IndexedDB usage
        (0, $hTxA3.sendPackageOperationalEvent)({
            action: 'usedAtlIndexedDBOpen',
            attributes: attributes
        });
    }
};
const $b537252c234af449$var$checkIfAllowed = async (dbName)=>{
    if (!(0, $803YE.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $aoZN9.getBscGlobalState)().product;
    return (0, $812Hd.isProcessingAllowedByPreferences)({
        itemKey: dbName,
        storageType: (0, $8f0nK.CategoryStorageType).IndexedDB,
        productName: productName
    });
};
const $b537252c234af449$var$checkIfAllowedWithCategory = async (dbName)=>{
    if (!(0, $803YE.isValidDBName)(dbName)) {
        const error = new Error('Invalid database name: must be a non-empty string');
        (0, $KilRp.Logger).errorWithOperationalEvent({
            action: 'usedAtlIndexedDBOpenError',
            attributes: {
                dbName: dbName
            },
            message: `IndexedDB open failed: ${error.message}`
        });
        throw error;
    }
    const productName = (0, $aoZN9.getBscGlobalState)().product;
    const { isAllowed: isAllowed, itemCategory: itemCategory } = await (0, $812Hd.isProcessingAllowedByPreferencesWithCategory)({
        itemKey: dbName,
        storageType: (0, $8f0nK.CategoryStorageType).IndexedDB,
        productName: productName
    });
    return {
        isAllowed: isAllowed,
        itemCategory: itemCategory
    };
};
const $b537252c234af449$export$5a412306febb78c = (originalOpen)=>(databaseName, version)=>{
        $b537252c234af449$var$checkAndSendAnalyticsEvent({
            databaseName: databaseName
        }).catch((e)=>{
            (0, $KilRp.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
        });
        // Always allow the operation to proceed (we're only tracking usage)
        return originalOpen(databaseName, version);
    };
const $b537252c234af449$export$5721aa15a04b1881 = (originalOpen)=>(databaseName, version)=>{
        const wasSetByPackage = (0, $bBzKh.ItemKeyCache).wasSetByPackage((0, $8f0nK.CategoryStorageType).IndexedDB, databaseName);
        if (wasSetByPackage) return originalOpen(databaseName, version);
        if ((0, $3H4LK.fg)('jfp-magma-selective-storage-enforcement')) {
            var _globalState$__UNSAFE;
            // Per-key opt-out: when `disableIndexedDbConsentChecks` is on, `__UNSAFE_shouldEnforceKeyForRollout`
            // can re-enable enforcement for this database name; otherwise fall back to
            // analytics-only behaviour.
            const globalState = (0, $aoZN9.getBscGlobalState)();
            const enforceThisKey = ((_globalState$__UNSAFE = globalState.__UNSAFE_shouldEnforceKeyForRollout) === null || _globalState$__UNSAFE === void 0 ? void 0 : _globalState$__UNSAFE.call(globalState, databaseName, (0, $8f0nK.CategoryStorageType).IndexedDB)) === true;
            const disableIndexedDbConsentChecks = (globalState.disableIndexedDbConsentChecks ?? false) && !enforceThisKey;
            if (disableIndexedDbConsentChecks) {
                $b537252c234af449$var$checkAndSendAnalyticsEvent({
                    databaseName: databaseName
                }).catch((e)=>{
                    (0, $KilRp.Logger).error(`Failed to send IndexedDB open event. ${e.message || ''}`);
                });
                return originalOpen(databaseName, version);
            }
        }
        (0, $KilRp.Logger).debug(`IndexedDB operation: overridden open on database \"${databaseName}\"`, {
            version: String(version ?? 'unspecified')
        });
        const requestWrapper = (0, $ToUEU.createIDBOpenDBRequestWrapper)();
        const allowedPromise = (0, $3H4LK.fg)('platform_bsc_add_category_to_idb_open_events') ? $b537252c234af449$var$checkIfAllowedWithCategory(databaseName).then(({ isAllowed: isAllowed, itemCategory: itemCategory })=>({
                isAllowed: isAllowed,
                categoryAttribute: {
                    itemCategory: itemCategory ?? (0, $8f0nK.PreferenceCategory).Unknown
                }
            })) : $b537252c234af449$var$checkIfAllowed(databaseName).then((isAllowed)=>({
                isAllowed: isAllowed,
                categoryAttribute: {}
            }));
        allowedPromise.then(({ isAllowed: isAllowed, categoryAttribute: categoryAttribute })=>{
            (0, $hTxA3.sendPackageOperationalEvent)({
                action: 'usedAtlIndexedDBOpen',
                attributes: {
                    databaseName: databaseName,
                    wasRejected: !isAllowed,
                    outsidePackage: true,
                    ...categoryAttribute
                }
            });
            if (isAllowed) {
                (0, $KilRp.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was ALLOWED`, {
                    version: String(version ?? 'unspecified')
                });
                const actualRequest = originalOpen(databaseName, version);
                requestWrapper.wrapRequest(actualRequest);
            } else {
                (0, $KilRp.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" was REJECTED`, {
                    version: String(version ?? 'unspecified')
                });
                const error = new $b537252c234af449$var$DatabaseBlockedError('The database was blocked by consent preferences', 'storageItemBlocked');
                const errorEvent = new ErrorEvent('error', {
                    message: error.message,
                    error: error
                });
                requestWrapper.setError(error);
                requestWrapper.dispatchEvent(errorEvent);
            }
        }).catch((e)=>{
            const errorMessage = e instanceof Error ? e.message : String(e);
            (0, $KilRp.Logger).debug(`IndexedDB operation: override on database \"${databaseName}\" ERROR: ${errorMessage}`, {
                version: String(version ?? 'unspecified')
            });
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedAtlIndexedDBOpenError',
                attributes: {
                    databaseName: databaseName,
                    outsidePackage: true
                },
                message: `IndexedDB open failed during preference check: ${errorMessage}`
            });
            const errorEvent = new ErrorEvent('error', {
                message: errorMessage,
                error: e
            });
            requestWrapper.dispatchEvent(errorEvent);
        });
        return requestWrapper;
    };

});
parcelRegister("ToUEU", function(module, exports) {
$parcel$export(module.exports, "createIDBOpenDBRequestWrapper", () => $65c7fb27e04570d4$export$4037ef1f5b40c4b6);

var $lMcEJ = parcelRequire("lMcEJ");

var $2manU = parcelRequire("2manU");

var $9AwJf = parcelRequire("9AwJf");
// Store the browser implementation class here - defined conditionally below
let $65c7fb27e04570d4$var$BrowserImpl;
/**
 * Browser-only implementation that extends EventTarget.
 * Only defined in browser environments where EventTarget is available.
 * This conditional definition prevents "EventTarget is not defined" errors in SSR.
 */ if (typeof EventTarget !== 'undefined') // Define the class inside this block so it's never parsed in SSR
$65c7fb27e04570d4$var$BrowserImpl = class IDBOpenDBRequestWrapperImpl extends EventTarget {
    // Implementing IDBRequest readonly properties with getters
    get error() {
        var _this$_wrappedRequest;
        return ((_this$_wrappedRequest = this._wrappedRequest) === null || _this$_wrappedRequest === void 0 ? void 0 : _this$_wrappedRequest.error) ?? this._error;
    }
    get result() {
        var _this$_wrappedRequest2;
        return ((_this$_wrappedRequest2 = this._wrappedRequest) === null || _this$_wrappedRequest2 === void 0 ? void 0 : _this$_wrappedRequest2.result) ?? this._result;
    }
    get readyState() {
        var _this$_wrappedRequest3;
        return ((_this$_wrappedRequest3 = this._wrappedRequest) === null || _this$_wrappedRequest3 === void 0 ? void 0 : _this$_wrappedRequest3.readyState) ?? this._readyState;
    }
    get source() {
        var _this$_wrappedRequest4;
        return ((_this$_wrappedRequest4 = this._wrappedRequest) === null || _this$_wrappedRequest4 === void 0 ? void 0 : _this$_wrappedRequest4.source) ?? this._source;
    }
    get transaction() {
        var _this$_wrappedRequest5;
        return ((_this$_wrappedRequest5 = this._wrappedRequest) === null || _this$_wrappedRequest5 === void 0 ? void 0 : _this$_wrappedRequest5.transaction) ?? this._transaction;
    }
    /**
     * Wrap an existing IDBOpenDBRequest to proxy its events to this wrapper.
     * Once wrapped, all property getters will delegate to the wrapped request,
     * and all events from the wrapped request will be re-dispatched on this wrapper.
     *
     * @param request - The real IDBOpenDBRequest to wrap
     */ wrapRequest(request) {
        if (this._wrappedRequest) throw new Error('This IDBOpenDBRequestWrapper is already wrapping another request');
        this._wrappedRequest = request;
        // Proxy all events from the wrapped request to this wrapper using bindAll
        this._unbindEventListeners = (0, $lMcEJ.bindAll)(request, [
            {
                type: 'success',
                listener: (e)=>{
                    this.dispatchEvent(new Event('success', e));
                }
            },
            {
                type: 'error',
                listener: (e)=>{
                    this.dispatchEvent(new Event('error', e));
                }
            },
            {
                type: 'blocked',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('blocked', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            },
            {
                type: 'upgradeneeded',
                listener: (e)=>{
                    const versionChangeEvent = new IDBVersionChangeEvent('upgradeneeded', e);
                    this.dispatchEvent(versionChangeEvent);
                }
            }
        ]);
    }
    /**
     * Check if this mock is wrapping a real request
     */ isWrapping() {
        return this._wrappedRequest !== null;
    }
    /**
     * Get the wrapped request (if any)
     */ getWrappedRequest() {
        return this._wrappedRequest;
    }
    /**
     * Unbind all event listeners attached to the wrapped request.
     * Should be called when the wrapper is no longer needed.
     */ unbind() {
        if (this._unbindEventListeners) {
            this._unbindEventListeners();
            this._unbindEventListeners = null;
        }
        this._wrappedRequest = null;
    }
    /**
     * Set the error property (normally readonly)
     * Only works when not wrapping another request
     */ setError(error) {
        if (this._wrappedRequest) throw new Error('Cannot set error on a wrapping IDBOpenDBRequestWrapper');
        this._error = error;
    }
    /**
     * Set the result property (normally readonly)
     * Only works when not wrapping another request
     */ setResult(result) {
        if (this._wrappedRequest) throw new Error('Cannot set result on a wrapping IDBOpenDBRequestWrapper');
        this._result = result;
    }
    /**
     * Set the readyState property (normally readonly)
     * Only works when not wrapping another request
     */ setReadyState(state) {
        if (this._wrappedRequest) throw new Error('Cannot set readyState on a wrapping IDBOpenDBRequestWrapper');
        this._readyState = state;
    }
    /**
     * Set the source property (normally readonly)
     * Only works when not wrapping another request
     */ setSource(source) {
        if (this._wrappedRequest) throw new Error('Cannot set source on a wrapping IDBOpenDBRequestWrapper');
        this._source = source;
    }
    /**
     * Set the transaction property (normally readonly)
     * Only works when not wrapping another request
     */ setTransaction(transaction) {
        if (this._wrappedRequest) throw new Error('Cannot set transaction on a wrapping IDBOpenDBRequestWrapper');
        this._transaction = transaction;
    }
    /**
     * Override dispatchEvent to also call the corresponding event handler if set
     */ dispatchEvent(event) {
        const result = super.dispatchEvent(event);
        // Call the appropriate event handler if it exists
        switch(event.type){
            case 'error':
                if (this.onerror) this.onerror.call(this, event);
                break;
            case 'success':
                if (this.onsuccess) this.onsuccess.call(this, event);
                break;
            case 'blocked':
                if (this.onblocked) this.onblocked.call(this, event);
                break;
            case 'upgradeneeded':
                if (this.onupgradeneeded) this.onupgradeneeded.call(this, event);
                break;
        }
        return result;
    }
    constructor(...args){
        super(...args), this._error = null, this._result = null, this._readyState = 'pending', this._source = null, this._transaction = null, this._wrappedRequest = null, this._unbindEventListeners = null, // Event handler properties (can be set directly by consumers)
        this.onerror = null, this.onsuccess = null, this.onblocked = null, this.onupgradeneeded = null;
    }
};
function $65c7fb27e04570d4$export$4037ef1f5b40c4b6() {
    if ((0, $2manU.isSSR)() || typeof EventTarget === 'undefined' || !$65c7fb27e04570d4$var$BrowserImpl) return new (0, $9AwJf.IDBOpenDBRequestNoOp)();
    return new $65c7fb27e04570d4$var$BrowserImpl();
}
const $65c7fb27e04570d4$export$c69b1cb39abae960 = $65c7fb27e04570d4$var$BrowserImpl;

});
parcelRegister("9AwJf", function(module, exports) {
$parcel$export(module.exports, "IDBOpenDBRequestNoOp", () => $ad11428639b49bf4$export$55ffeaf417e03b66);
/**
 * Minimal no-op implementation for SSR environments.
 * Provides the IDBOpenDBRequest interface without relying on EventTarget.
 * This class does not extend EventTarget, making it safe to instantiate in Node.js.
 */ class $ad11428639b49bf4$export$55ffeaf417e03b66 {
    get error() {
        return this._error;
    }
    get result() {
        return this._result;
    }
    get readyState() {
        return this._readyState;
    }
    get source() {
        return this._source;
    }
    get transaction() {
        return this._transaction;
    }
    // No-op event methods for SSR
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return false;
    }
    // Wrapper-specific methods that shouldn't be called in SSR but are part of the interface
    wrapRequest() {
        throw new Error('IDBOpenDBRequestWrapper cannot wrap requests in SSR environment');
    }
    isWrapping() {
        return false;
    }
    getWrappedRequest() {
        return null;
    }
    unbind() {}
    setError(error) {
        this._error = error;
    }
    setResult(result) {
        this._result = result;
    }
    setReadyState(state) {
        this._readyState = state;
    }
    setSource(source) {
        this._source = source;
    }
    setTransaction(transaction) {
        this._transaction = transaction;
    }
    constructor(){
        this._error = null;
        this._result = null;
        this._readyState = 'pending';
        this._source = null;
        this._transaction = null;
        this.onerror = null;
        this.onsuccess = null;
        this.onblocked = null;
        this.onupgradeneeded = null;
    }
}

});


parcelRegister("803YE", function(module, exports) {
$parcel$export(module.exports, "isValidDBName", () => $be2c5e592978e36b$export$a5be9a74f3347ccf);

var $aoZN9 = parcelRequire("aoZN9");
var $2manU = parcelRequire("2manU");
function $be2c5e592978e36b$export$ae0d255aec75942(enableSSRCheck = true, enableFeatureFlagCheck = true) {
    // Check if running in SSR environment
    if (enableSSRCheck && (0, $2manU.isSSR)()) return {
        available: false,
        reason: 'IndexedDB is not available in SSR environment'
    };
    if (!globalThis.indexedDB) return {
        available: false,
        reason: 'IndexedDB is not supported in this browser'
    };
    if (enableFeatureFlagCheck) {
        const globalState = (0, $aoZN9.getBscGlobalState)();
        if (globalState.indexedDbEnabled === false) return {
            available: true,
            reason: 'Using native IndexedDB: IndexedDB controls are disabled',
            bypassImplementation: true
        };
    }
    return {
        available: true
    };
}
function $be2c5e592978e36b$export$a5be9a74f3347ccf(dbName) {
    // Database name should not be empty and should be a string
    return typeof dbName === 'string' && dbName.trim().length > 0;
}
function $be2c5e592978e36b$export$396291456af4fc3(version) {
    // Version should be undefined or a positive integer
    if (version === undefined) return true;
    return Number.isInteger(version) && version > 0;
}

});



parcelRegister("2zNoW", function(module, exports) {
$parcel$export(module.exports, "createWebStoragePassthrough", () => $ffc1980578bc892d$export$619fe705922e5d61);

var $3H4LK = parcelRequire("3H4LK");

var $KilRp = parcelRequire("KilRp");

var $gkGYs = parcelRequire("gkGYs");

var $kcQKb = parcelRequire("kcQKb");
var $lFYsw = parcelRequire("lFYsw");

var $b2eXf = parcelRequire("b2eXf");
const $ffc1980578bc892d$export$619fe705922e5d61 = async (storageType)=>{
    const bscStorage = (0, $kcQKb.findStorageTarget)(storageType);
    if (!bscStorage.isAvailable) {
        (0, $KilRp.Logger).warn(`No ${storageType} capabilities found`);
        return;
    }
    if (!(0, $gkGYs.BSCIndexedDB).isAvailable) {
        (0, $KilRp.Logger).warn('IndexedDB is not available');
        return;
    }
    if (!(0, $gkGYs.BSCIndexedDB).isBooted) {
        if ((0, $3H4LK.fg)('cookies-bsc-timeout-for-indexeddb')) try {
            await (0, $gkGYs.BSCIndexedDB).boot();
        } catch  {
            (0, $KilRp.Logger).warn('IndexedDB boot failed, proceeding without IDB tracking');
        }
        else await (0, $gkGYs.BSCIndexedDB).boot();
    }
    const originalSetItem = bscStorage.storage.setItem;
    // As we cannot use Object.defineProperty(window[storageType], 'setItem', ...implementation)
    // we have to override the entire utility with our own edition of the webStorage class
    const overriddenStorageClass = {
        clear: bscStorage.clear.bind(bscStorage),
        key: bscStorage.key.bind(bscStorage),
        length: bscStorage.length.bind(bscStorage),
        removeItem: bscStorage.removeItem.bind(bscStorage),
        getItem: bscStorage.getItem.bind(bscStorage),
        setItem: (0, $b2eXf.setItemOverride)(bscStorage, originalSetItem, storageType)
    };
    const caseSensitiveStorageType = storageType === (0, $lFYsw.WebStorageType).LocalStorage ? 'localStorage' : 'sessionStorage';
    Object.defineProperty(window, caseSensitiveStorageType, {
        value: overriddenStorageClass,
        writable: true,
        configurable: true
    });
};

});
parcelRegister("b2eXf", function(module, exports) {
$parcel$export(module.exports, "setItemOverride", () => $cf18e8ee796869f6$export$b4469df6294ea6aa);

var $3H4LK = parcelRequire("3H4LK");

var $aoZN9 = parcelRequire("aoZN9");
var $hTxA3 = parcelRequire("hTxA3");

var $hTxA3 = parcelRequire("hTxA3");

var $812Hd = parcelRequire("812Hd");

var $KilRp = parcelRequire("KilRp");

var $gkGYs = parcelRequire("gkGYs");

var $bBzKh = parcelRequire("bBzKh");
parcelRequire("kcQKb");
var $lFYsw = parcelRequire("lFYsw");

var $8f0nK = parcelRequire("8f0nK");
const $cf18e8ee796869f6$export$b4469df6294ea6aa = (bscStorage, originalSetItem, storageType)=>(originalItemKey, originalItemValue)=>{
        const categoryStorageType = storageType === (0, $lFYsw.WebStorageType).LocalStorage ? (0, $8f0nK.CategoryStorageType).LocalStorage : (0, $8f0nK.CategoryStorageType).SessionStorage;
        const storageContext = bscStorage.storage;
        let itemSetByPackage = false;
        if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) itemSetByPackage = (0, $bBzKh.ItemKeyCache).wasSetByPackage(categoryStorageType, originalItemKey);
        else bscStorage.checkIfSetByPackage({
            itemKey: originalItemKey,
            isSetCallback: ()=>{
                itemSetByPackage = true;
            },
            isNotSetCallback: ()=>{
                // Note: This is async and could fail, but if the call errors out in IDB,
                // it will forcibly resolve to false here, so we're not catching the error again here ✅
                itemSetByPackage = false;
            }
        });
        // `disableWebStorageConsentChecks` is read from the package global state so the
        // behaviour stays consistent with other consent-check flags (rather than being
        // threaded through props/options on every call site). When set, the override
        // always passes through to the underlying storage and only emits analytics
        // events — `AtlBrowserStorage` behaviour is preserved.
        let disableWebStorageConsentChecks = (0, $aoZN9.getBscGlobalState)().disableWebStorageConsentChecks ?? false;
        if ((0, $3H4LK.fg)('jfp-magma-selective-storage-enforcement')) {
            // `disableWebStorageConsentChecks` skips the consent pipeline (analytics-only),
            // but `__UNSAFE_shouldEnforceKeyForRollout(key, type) === true` re-enables enforcement for this key.
            const categoryStorageType = storageType === (0, $lFYsw.WebStorageType).LocalStorage ? (0, $8f0nK.CategoryStorageType).LocalStorage : (0, $8f0nK.CategoryStorageType).SessionStorage;
            const __UNSAFE_shouldEnforceKeyForRollout = (0, $aoZN9.getBscGlobalState)().__UNSAFE_shouldEnforceKeyForRollout;
            const enforceThisKey = (__UNSAFE_shouldEnforceKeyForRollout === null || __UNSAFE_shouldEnforceKeyForRollout === void 0 ? void 0 : __UNSAFE_shouldEnforceKeyForRollout(originalItemKey, categoryStorageType)) === true;
            disableWebStorageConsentChecks = ((0, $aoZN9.getBscGlobalState)().disableWebStorageConsentChecks ?? false) && !enforceThisKey;
        }
        if (disableWebStorageConsentChecks) {
            try {
                if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                    (0, $bBzKh.ItemKeyCache).markSetByPackage(categoryStorageType, originalItemKey);
                    originalSetItem.apply(storageContext, [
                        originalItemKey,
                        originalItemValue
                    ]);
                } else {
                    originalSetItem.apply(storageContext, [
                        originalItemKey,
                        originalItemValue
                    ]);
                    // Track that this item was set through the package so subsequent
                    // `checkIfSetByPackage` calls can confirm it was set properly.
                    (0, $gkGYs.BSCIndexedDB).setRecord(originalItemKey).catch(()=>{
                        (0, $KilRp.Logger).error('Failed to set IDB record after setItem with consent checks disabled.');
                    });
                }
            } catch (e) {
                (0, $KilRp.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `${storageType} failed to setItem with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        outsidePackage: !itemSetByPackage,
                        storageType: storageType,
                        consentChecksDisabled: true
                    }
                });
            }
            if (!(0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) (0, $hTxA3.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType,
                    consentChecksDisabled: true
                }
            });
            let wasCheckAsync = true;
            try {
                const productName = (0, $aoZN9.getBscGlobalState)().product;
                const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $aoZN9.getBscGlobalState)();
                // trigger the callbacks to emit analytics events but do nothing with the result.
                (0, $812Hd.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                            wasCheckAsync = wasAsync;
                            (0, $hTxA3.sendPackageOperationalEvent)({
                                action: 'usedAtlBrowserStorageSetItem',
                                attributes: {
                                    itemKey: originalItemKey,
                                    outsidePackage: !itemSetByPackage,
                                    storageType: storageType,
                                    wasAsync: wasAsync,
                                    consentChecksDisabled: true
                                }
                            });
                        }
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                            wasCheckAsync = wasAsync;
                            (0, $hTxA3.sendPackageOperationalEvent)({
                                action: 'usedAtlBrowserStorageSetItem',
                                attributes: {
                                    itemKey: originalItemKey,
                                    outsidePackage: !itemSetByPackage,
                                    storageType: storageType,
                                    wasAsync: wasAsync,
                                    consentChecksDisabled: true
                                }
                            });
                        }
                        if (!itemHasCategory) (0, $hTxA3.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides,
                                allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides,
                                consentChecksDisabled: true,
                                wasAsync: wasAsync
                            }
                        });
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $KilRp.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to emit analytics with consent checks disabled. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        consentChecksDisabled: true,
                        wasAsync: wasCheckAsync
                    }
                });
            }
            return;
        }
        if (itemSetByPackage) try {
            // Controls have already been run, passthrough as usual
            return originalSetItem.apply(storageContext, [
                originalItemKey,
                originalItemValue
            ]);
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `${storageType} failed to setItem. ${e.message || ''}`,
                attributes: {
                    outsidePackage: false,
                    storageType: storageType
                }
            });
        }
        try {
            if (!(0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) (0, $hTxA3.sendPackageOperationalEvent)({
                action: 'usedAtlBrowserStorageSetItem',
                attributes: {
                    itemKey: originalItemKey,
                    outsidePackage: !itemSetByPackage,
                    storageType: storageType
                }
            });
            let wasCheckAsync = true;
            try {
                const productName = (0, $aoZN9.getBscGlobalState)().product;
                // Attempt to set a known item key that was set from outside the package
                (0, $812Hd.isProcessingAllowedByPreferences)({
                    itemKey: originalItemKey,
                    allowedCallback: ({ wasAsync: wasAsync })=>{
                        if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                            wasCheckAsync = wasAsync;
                            (0, $hTxA3.sendPackageOperationalEvent)({
                                action: 'usedAtlBrowserStorageSetItem',
                                attributes: {
                                    itemKey: originalItemKey,
                                    outsidePackage: !itemSetByPackage,
                                    storageType: storageType,
                                    wasAsync: wasAsync
                                }
                            });
                        }
                        originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                    },
                    blockedCallback: ({ itemHasCategory: itemHasCategory, itemCategory: itemCategory, wasAsync: wasAsync })=>{
                        if ((0, $3H4LK.fg)('jfp-magma-no-unnecessary-awaits-in-bsc')) {
                            wasCheckAsync = wasAsync;
                            (0, $hTxA3.sendPackageOperationalEvent)({
                                action: 'usedAtlBrowserStorageSetItem',
                                attributes: {
                                    itemKey: originalItemKey,
                                    outsidePackage: !itemSetByPackage,
                                    storageType: storageType,
                                    wasAsync: wasAsync
                                }
                            });
                        }
                        if (!itemHasCategory) (0, $hTxA3.sendTrackEvent)({
                            source: 'package',
                            action: 'package',
                            actionSubject: 'uncategorizedWebStorageItemSet',
                            attributes: {
                                storageType: storageType,
                                productName: productName,
                                originalItemKey: originalItemKey,
                                itemCategory: itemCategory ?? null,
                                wasAsync: wasAsync
                            }
                        });
                        const { allowUncategorizedCookiesInOverrides: allowUncategorizedCookiesInOverrides, allowUncategorizedItemsInWebStorageOverrides: allowUncategorizedItemsInWebStorageOverrides } = (0, $aoZN9.getBscGlobalState)();
                        // allowUncategorizedCookiesInOverrides impacts both web storage and cookies due to historical reasons
                        const allowUncategorized = allowUncategorizedCookiesInOverrides || allowUncategorizedItemsInWebStorageOverrides;
                        if (allowUncategorized && !itemHasCategory) originalSetItem.apply(storageContext, [
                            originalItemKey,
                            originalItemValue
                        ]);
                        else return;
                    },
                    storageType: categoryStorageType,
                    productName: productName
                });
            } catch (e) {
                (0, $KilRp.Logger).errorWithOperationalEvent({
                    action: 'usedAtlBrowserStorageSetItemError',
                    message: `Failed to set item. ${e.message || ''}`,
                    attributes: {
                        itemKey: originalItemKey,
                        storageType: storageType,
                        wasAsync: wasCheckAsync
                    }
                });
            }
        } catch (e) {
            (0, $KilRp.Logger).errorWithOperationalEvent({
                action: 'usedAtlBrowserStorageSetItemError',
                message: `Failed to send ${storageType} setter event. ${e.message || ''}`
            });
        }
    };

});





parcelRegister("fwyFy", function(module, exports) {
$parcel$export(module.exports, "ForgePortalHeaderModule", () => $8e6075dbf062f41a$export$80fa523a90b09a3d);
/* index.tsx generated by @compiled/babel-plugin v0.37.1 */ 
var $ltgDR = parcelRequire("ltgDR");

var $4fqPo = parcelRequire("4fqPo");

var $cfDDl = parcelRequire("cfDDl");
const $8e6075dbf062f41a$var$zeroSpace = "var(--ds-space-0, 0px)";
const $8e6075dbf062f41a$var$containerStyles = null;
const $8e6075dbf062f41a$export$80fa523a90b09a3d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement("div", {
        className: (0, $ltgDR.default)([
            "_1bsb1osq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4fqPo))).createElement((0, $cfDDl.ForgeHeaderModule), {
        page: "portal",
        noWrapper: true,
        allowCustomPadding: false
    }));
};
var $8e6075dbf062f41a$export$2e2bcd8739ae039 = $8e6075dbf062f41a$export$80fa523a90b09a3d;

});

parcelRegister("gzaph", function(module, exports) {
$parcel$export(module.exports, "default", () => $a8f367df726d49b3$export$2e2bcd8739ae039);

var $jalUJ = parcelRequire("jalUJ");
var $a8f367df726d49b3$export$2e2bcd8739ae039 = (0, $jalUJ.defineMessages)({
    unsupportedBrowser: {
        defaultMessage: "We don't support your browser version anymore and this may cause problems when you raise requests. Upgrade to a newer version to ensure a smooth request creation experience.",
        description: 'Message on top screen banner to inform user that they are using unsupported browser version',
        id: 'cv.app.banner.unsupported.browser.version'
    }
});

});



parcelRegister("aHhQY", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => (parcelRequire("4yB8T")).ThemingContainer);

var $4yB8T = parcelRequire("4yB8T");

});
parcelRegister("4yB8T", function(module, exports) {
$parcel$export(module.exports, "ThemingContainer", () => $26ffb23f2a4bc44a$export$a29c32a54963ec02);

var $4fqPo = parcelRequire("4fqPo");
parcelRequire("3wP4d");
var $bmgw6 = parcelRequire("bmgw6");

var $3yyCx = parcelRequire("3yyCx");
parcelRequire("bjlEi");
var $i8gmD = parcelRequire("i8gmD");

var $ew3Bn = parcelRequire("ew3Bn");

var $6bGmX = parcelRequire("6bGmX");

var $6iapo = parcelRequire("6iapo");

var $54jwS = parcelRequire("54jwS");

var $eSL4S = parcelRequire("eSL4S");

var $ebpTf = parcelRequire("ebpTf");

var $3Ar39 = parcelRequire("3Ar39");

var $lg4zB = parcelRequire("lg4zB");
const $26ffb23f2a4bc44a$export$9156684d9d875025 = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ew3Bn.useAnalyticsEvents)();
    const { children: children, themeColor: themeColor } = props;
    const isAddColorDesignTokenEnabled = (0, $6bGmX.default).checkGate('add_color_design_token_support_into_help_center');
    const isTypographyTokenMigrationEnabled = (0, $6bGmX.default).checkGate('enable_typography_token_migration_for_csm');
    const sendAnalyticsEvent = $4fqPo.useCallback((action)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            analyticsType: (0, $54jwS.OPERATIONAL_EVENT_TYPE),
            actionSubject: 'portalThemingBootstrap'
        });
        if ((0, $6bGmX.default).checkGate('help_center_login_compiled_css')) // this gets rid of browser warning: Failed to send analytic data. [...] Error: Missing event.actionSubject
        analyticsEvent.context.push({
            componentName: 'portalThemingBootstrap'
        });
        analyticsEvent.fire();
    }, [
        createAnalyticsEvent
    ]);
    const themeColorWithoutHash = themeColor.slice(1);
    (0, $3Ar39.useIsoMorphicLayoutEffect)(()=>{
        (0, $6iapo.default)({
            // @ts-expect-error
            light: isAddColorDesignTokenEnabled ? 'light' : '',
            spacing: 'spacing',
            colorMode: 'light',
            // @ts-expect-error
            typography: null,
            ...isTypographyTokenMigrationEnabled && (0, $eSL4S.isCSMHelpCenter)((0, $ebpTf.getEnv)().helpCenterType) && {
                typography: 'typography'
            },
            ...isAddColorDesignTokenEnabled && {
                UNSAFE_themeOptions: {
                    brandColor: `#${themeColorWithoutHash}`
                }
            }
        }).then(()=>sendAnalyticsEvent((0, $lg4zB.OUTCOME).SUCCESS)).catch(()=>sendAnalyticsEvent((0, $lg4zB.OUTCOME).FAILURE));
    }, [
        sendAnalyticsEvent,
        themeColor
    ]);
    return /*#__PURE__*/ $4fqPo.createElement($4fqPo.Fragment, null, children);
};
const $26ffb23f2a4bc44a$var$selector = (0, $3yyCx.createSelector)((0, $i8gmD.getThemeColor), (themeColor)=>({
        themeColor: themeColor
    }));
const $26ffb23f2a4bc44a$export$a29c32a54963ec02 = (0, $bmgw6.default)($26ffb23f2a4bc44a$var$selector)($26ffb23f2a4bc44a$export$9156684d9d875025);

});
parcelRegister("lg4zB", function(module, exports) {
$parcel$export(module.exports, "OUTCOME", () => $c613cd5dabf926f4$export$a12152da2bb8d161);
// oxlint-disable-next-line no-shadow
var $c613cd5dabf926f4$export$a12152da2bb8d161 = /*#__PURE__*/ function(OUTCOME) {
    OUTCOME["SUCCESS"] = "SUCCESS";
    OUTCOME["FAILURE"] = "FAILURE";
    return OUTCOME;
}({});

});






var $c62a8 = parcelRequire("c62a8");

var $6mmHn = parcelRequire("6mmHn");

var $6bGmX = parcelRequire("6bGmX");
parcelRequire("3ebz9");
var $2jsSR = parcelRequire("2jsSR");

var $3H4LK = parcelRequire("3H4LK");

var $dvfsR = parcelRequire("dvfsR");

var $jFknK = parcelRequire("jFknK");

var $6FNES = parcelRequire("6FNES");

var $he5a2 = parcelRequire("he5a2");

var $kEbbM = parcelRequire("kEbbM");

var $c62a8 = parcelRequire("c62a8");

var $jFknK = parcelRequire("jFknK");

var $c62a8 = parcelRequire("c62a8");
const $cd961fe6f7581f34$var$nameCache = new WeakMap();
function $cd961fe6f7581f34$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $cd961fe6f7581f34$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $cd961fe6f7581f34$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $cd961fe6f7581f34$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $cd961fe6f7581f34$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $cd961fe6f7581f34$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $cd961fe6f7581f34$var$getAttributeSelector(currentElement, 'data-testid') || $cd961fe6f7581f34$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $cd961fe6f7581f34$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($cd961fe6f7581f34$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $cd961fe6f7581f34$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$cd961fe6f7581f34$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $cd961fe6f7581f34$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $cd961fe6f7581f34$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $cd961fe6f7581f34$var$getUniqueSelector(selectorConfig, element);
    $cd961fe6f7581f34$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $cd961fe6f7581f34$export$2e2bcd8739ae039 = $cd961fe6f7581f34$var$getElementName;


let $fc3af0794183607c$var$performanceEventObserver;
const $fc3af0794183607c$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
/**
 * Resolve the SelectorConfig for the performance-observer code path.
 *
 * In FedRAMP Moderate environments (when `getSelectorConfig()` returns the
 * forced all-`false` config) we honour that override; otherwise we fall back
 * to the historical default that enables every selector.
 */ function $fc3af0794183607c$var$resolveSelectorConfig() {
    return (0, $jFknK.getSelectorConfig)() ?? $fc3af0794183607c$var$DEFAULT_SELECTOR_CONFIG;
}
function $fc3af0794183607c$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $fc3af0794183607c$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $fc3af0794183607c$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($fc3af0794183607c$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $fc3af0794183607c$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $fc3af0794183607c$export$17afbba0f16b4b19 = ()=>{
    $fc3af0794183607c$var$performanceEventObserver = $fc3af0794183607c$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (let entry of list)if (entry.name === 'click') $fc3af0794183607c$export$e6be05b411ce21a6(entry);
    });
    return $fc3af0794183607c$var$performanceEventObserver;
};
const $fc3af0794183607c$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $c62a8.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === 'press') {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) {
                    const componentHierarchy = $fc3af0794183607c$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $cd961fe6f7581f34$export$2e2bcd8739ae039)($fc3af0794183607c$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};



var $2udYR = parcelRequire("2udYR");

var $4fqPo = parcelRequire("4fqPo");

var $3H4LK = parcelRequire("3H4LK");

var $bqHVm = parcelRequire("bqHVm");

var $gE3od = parcelRequire("gE3od");

var $c62a8 = parcelRequire("c62a8");

var $eFsN4 = parcelRequire("eFsN4");
const $44222c3052e549e8$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $44222c3052e549e8$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $44222c3052e549e8$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $44222c3052e549e8$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $44222c3052e549e8$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $44222c3052e549e8$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $44222c3052e549e8$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $44222c3052e549e8$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $44222c3052e549e8$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $44222c3052e549e8$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($44222c3052e549e8$var$ABORT_ERROR_NAMES.has(name) || $44222c3052e549e8$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $44222c3052e549e8$var$AUTH_ERROR_NAMES.has(name) && $44222c3052e549e8$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($44222c3052e549e8$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($44222c3052e549e8$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $44222c3052e549e8$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($44222c3052e549e8$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $44222c3052e549e8$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($44222c3052e549e8$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $44222c3052e549e8$export$17e837b2daecf805(error) {
    const directMatch = $44222c3052e549e8$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $44222c3052e549e8$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $27d977949fe5f225$var$sinkHandlerFn = ()=>{};
function $27d977949fe5f225$export$e5fa3ac6dc44efff(fn) {
    $27d977949fe5f225$var$sinkHandlerFn = fn;
}
const $27d977949fe5f225$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $27d977949fe5f225$export$1a949ef92fd30eca = (error)=>error.name === $27d977949fe5f225$var$RELAY_NETWORK_ERRORS_NAME;
const $27d977949fe5f225$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $27d977949fe5f225$var$getErrorStatusCode = (error)=>{
    if (!$27d977949fe5f225$var$isErrorObject(error)) return undefined;
    if ($27d977949fe5f225$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $27d977949fe5f225$var$getErrorTraceId = (error)=>$27d977949fe5f225$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $27d977949fe5f225$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _getActiveTrace;
    if (additionalAttributes !== null && additionalAttributes !== void 0 && additionalAttributes.isClientNetworkError && !(0, $3H4LK.fg)('platform_ufo_terminal_errors_track_client_errors')) // Exclude client network errors from being reported to UFO
    return;
    const activeInteraction = (0, $c62a8.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || 'Unknown error',
        timestamp: currentTime,
        ...(0, $3H4LK.fg)('platform_ufo_terminal_errors_track_client_errors') ? {
            errorCategory: (0, $44222c3052e549e8$export$17e837b2daecf805)(error)
        } : {}
    };
    const errorData = {
        ...baseErrorData,
        statusCode: (additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) ?? $27d977949fe5f225$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: ((_getActiveTrace = (0, $bqHVm.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) ?? $27d977949fe5f225$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $c62a8.PreviousInteractionLog).timestamp != null ? currentTime - (0, $c62a8.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) ?? null,
        activeInteractionId: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) ?? null,
        activeInteractionType: (activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) ?? null,
        previousInteractionId: (0, $c62a8.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $c62a8.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $c62a8.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $eFsN4.default).current ?? null
    };
    $27d977949fe5f225$var$sinkHandlerFn(errorData, context);
}
function $27d977949fe5f225$export$79ee0f0d40355053(error, additionalAttributes) {
    const interactionContext = (0, $gE3od.useInteractionContext)();
    const hasReportedRef = (0, $4fqPo.useRef)(false);
    (0, $4fqPo.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $27d977949fe5f225$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}



var $iHSFb = parcelRequire("iHSFb");

var $3H4LK = parcelRequire("3H4LK");
function $a51815fe8018d384$var$scheduleIdleCallback(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function' && (0, $3H4LK.fg)('ufo_payload_use_idle_callback')) window.requestIdleCallback(work);
    else (0, $iHSFb.unstable_scheduleCallback)((0, $iHSFb.unstable_IdlePriority), work);
}
var $a51815fe8018d384$export$2e2bcd8739ae039 = $a51815fe8018d384$var$scheduleIdleCallback;


let $2cb43219ca670b7a$var$initialized = false;
function $2cb43219ca670b7a$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $a51815fe8018d384$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $c62a8.sinkInteractionHandler)(sinkFn);
}
function $2cb43219ca670b7a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $c62a8.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $a51815fe8018d384$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $2cb43219ca670b7a$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $27d977949fe5f225$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $a51815fe8018d384$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $2cb43219ca670b7a$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $c62a8.interactionExtraMetrics).sinkHandler((interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult)=>{
        (0, $a51815fe8018d384$export$2e2bcd8739ae039)(async ()=>{
            const payload = await createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $2cb43219ca670b7a$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $a51815fe8018d384$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $6FNES.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $2cb43219ca670b7a$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($2cb43219ca670b7a$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $jFknK.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $jFknK.isUFOEnabled)()) {
        $2cb43219ca670b7a$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $2udYR.initialisePressureObserver)();
    (0, $2udYR.initialiseMemoryObserver)();
    if ((0, $3H4LK.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $he5a2.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $he5a2.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $2jsSR.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $jFknK.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $c62a8.postInteractionLog).initializeVCObserver(vcOptions);
        if ((0, $jFknK.isInteractionExtraMetricsEnabled)()) (0, $c62a8.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $kEbbM.setupHiddenTimingCapture)();
    (0, $dvfsR.startLighthouseObserver)();
    (0, $kEbbM.setupThrottleDetection)();
    $2cb43219ca670b7a$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $fc3af0794183607c$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    const extraInteractionMetricsPayloadPackagePromise = (0, $jFknK.isInteractionExtraMetricsEnabled)() ? (parcelRequire("3yJoB")) : Promise.resolve(undefined);
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("dcniM")),
        (parcelRequire("iDJRy")),
        extraInteractionMetricsPayloadPackagePromise,
        (parcelRequire("36c4E"))
    ]).then(([awc, payloadPackage, createPostInteractionLogPayloadPackage, createInteractionExtraMetricsPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            var _config$terminalError, _config$postInteracti, _config$extraSearchPa;
            const instance = client.getInstance();
            $2cb43219ca670b7a$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled) $2cb43219ca670b7a$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $2cb43219ca670b7a$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)() && createInteractionExtraMetricsPayloadPackage) $2cb43219ca670b7a$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $2cb43219ca670b7a$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$postInteracti2, _config$extraSearchPa2;
            $2cb43219ca670b7a$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled) $2cb43219ca670b7a$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $2cb43219ca670b7a$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if ((0, $jFknK.isInteractionExtraMetricsEnabled)() && createInteractionExtraMetricsPayloadPackage) $2cb43219ca670b7a$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $2cb43219ca670b7a$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}



var $bW6Qo = parcelRequire("bW6Qo");
var $4o3R3 = parcelRequire("4o3R3");
function $aca37a1563db08f1$export$a311cb1baa7d2d62() {
    (0, $4o3R3.resourceTimingBuffer).start();
}



var $gYF1N = parcelRequire("gYF1N");

var $e8T4h = parcelRequire("e8T4h");

var $ebpTf = parcelRequire("ebpTf");

var $e5QQn = parcelRequire("e5QQn");

var $6mmHn = parcelRequire("6mmHn");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $59df492d436edd83$var$cacheableTypes = [
    'script',
    'link'
];
const $59df492d436edd83$var$CACHE_NETWORK = 'network';
const $59df492d436edd83$var$CACHE_MEMORY = 'memory';
const $59df492d436edd83$var$CACHE_DISK = 'disk';
function $59df492d436edd83$var$calculateTransferType(type, duration, size) {
    if (!$59df492d436edd83$var$cacheableTypes.includes(type)) return $59df492d436edd83$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $59df492d436edd83$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $59df492d436edd83$var$CACHE_DISK;
    if (size === undefined) return null;
    return $59df492d436edd83$var$CACHE_NETWORK;
}
function $59df492d436edd83$export$e8a9322c3d9da8a6({ start: start }) {
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        for (const entry of performance.getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $59df492d436edd83$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
}


var $dvfsR = parcelRequire("dvfsR");

var $ebpTf = parcelRequire("ebpTf");
var $25d29b7689b41dc1$var$n = "undefined" != typeof window ? window.performance : null;
function $25d29b7689b41dc1$export$a2a699fa5b2b1ed4(n) {
    void 0 === n && (n = {});
    var t = {
        deviceType: $25d29b7689b41dc1$export$abfb0136cf8e916b(),
        effectiveConnectionType: $25d29b7689b41dc1$export$265dfeca3f5017b9(),
        timeToFirstByte: $25d29b7689b41dc1$export$9a2904da0506c3ba(),
        firstPaint: $25d29b7689b41dc1$export$819e7a0b13f5961(),
        firstContentfulPaint: $25d29b7689b41dc1$export$3086fa1a9fb7f683(),
        domContentLoaded: $25d29b7689b41dc1$export$d6856d1fab905de0(),
        onLoad: $25d29b7689b41dc1$export$7259a7b98f0280a3()
    };
    return t.onLoad ? ((n.url || n.all) && (t.url = $25d29b7689b41dc1$export$94df0e59ebebf4a7()), (n.userAgent || n.all) && (t.userAgent = $25d29b7689b41dc1$export$7935961ef7719cb0()), (n.deviceMemory || n.all) && (t.deviceMemory = $25d29b7689b41dc1$export$bf34885f68c1d5e5()), (n.userTiming || n.all) && (t.userTiming = $25d29b7689b41dc1$export$4660d4a735328f2a()), (n.longTasks || n.all) && (t.longTasks = $25d29b7689b41dc1$export$a08a64ac61b1ac4e()), (n.resources || n.all) && (t.resources = $25d29b7689b41dc1$export$a0d4d2a74c7df9f()), Promise.resolve(t)) : new Promise(function(n) {
        return setTimeout(n, 250);
    }).then(function() {
        return $25d29b7689b41dc1$export$a2a699fa5b2b1ed4(n);
    });
}
function $25d29b7689b41dc1$export$bf7f2fce5c1cf636(e) {
    $25d29b7689b41dc1$var$n && $25d29b7689b41dc1$var$n.mark && $25d29b7689b41dc1$var$n.mark(e);
}
function $25d29b7689b41dc1$export$83602b44513dc228(e, t) {
    if ($25d29b7689b41dc1$var$n && $25d29b7689b41dc1$var$n.measure) try {
        $25d29b7689b41dc1$var$n.measure(e, t);
    } catch (n) {
        console.error(n);
    }
}
function $25d29b7689b41dc1$export$265dfeca3f5017b9() {
    var n = "undefined" != typeof navigator ? navigator.connection || navigator.mozConnection || navigator.webkitConnection : null;
    return n ? n.effectiveType : null;
}
function $25d29b7689b41dc1$export$819e7a0b13f5961() {
    if (!$25d29b7689b41dc1$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $25d29b7689b41dc1$var$n.getEntriesByType("paint").find(function(n) {
        return "first-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $25d29b7689b41dc1$export$3086fa1a9fb7f683() {
    if (!$25d29b7689b41dc1$var$n || void 0 === window.PerformancePaintTiming) return null;
    var e = $25d29b7689b41dc1$var$n.getEntriesByType("paint").find(function(n) {
        return "first-contentful-paint" === n.name;
    });
    return e ? Math.round(e.startTime) : null;
}
function $25d29b7689b41dc1$export$9a2904da0506c3ba() {
    if (!$25d29b7689b41dc1$var$n) return null;
    var e = $25d29b7689b41dc1$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].responseStart) : null;
}
function $25d29b7689b41dc1$export$d6856d1fab905de0() {
    if (!$25d29b7689b41dc1$var$n) return null;
    var e = $25d29b7689b41dc1$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].domContentLoadedEventEnd) : null;
}
function $25d29b7689b41dc1$export$7259a7b98f0280a3() {
    if (!$25d29b7689b41dc1$var$n) return null;
    var e = $25d29b7689b41dc1$var$n.getEntriesByType("navigation");
    return e && e[0] ? Math.round(e[0].loadEventEnd) : null;
}
function $25d29b7689b41dc1$export$abfb0136cf8e916b(n) {
    void 0 === n && (n = $25d29b7689b41dc1$export$7935961ef7719cb0()), n = n.toLowerCase();
    var e = function(e) {
        return -1 !== n.indexOf(e);
    }, t = e("windows"), r = t && e("phone"), i = t && e("touch") && !r, o = !t && e("iphone"), a = e("ipod"), u = e("ipad"), d = !t && e("android"), l = d && e("mobile"), f = d && !e("mobile");
    return l || o || a || r ? "phone" : u || f || i ? "tablet" : "desktop";
}
function $25d29b7689b41dc1$export$94df0e59ebebf4a7() {
    return window.location.href;
}
function $25d29b7689b41dc1$export$7935961ef7719cb0() {
    return window.navigator.userAgent;
}
function $25d29b7689b41dc1$export$bf34885f68c1d5e5() {
    var n = "undefined" != typeof navigator ? navigator.deviceMemory : void 0;
    return void 0 === n ? null : n > 1 ? "full" : "lite";
}
function $25d29b7689b41dc1$export$4660d4a735328f2a() {
    if (!$25d29b7689b41dc1$var$n || "undefined" == typeof PerformanceMark) return null;
    var e = $25d29b7689b41dc1$var$n.getEntriesByType("mark").map(function(n) {
        return {
            type: "mark",
            name: n.name,
            startTime: Math.round(n.startTime)
        };
    }), t = $25d29b7689b41dc1$var$n.getEntriesByType("measure").map(function(n) {
        return {
            type: "measure",
            name: n.name,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
    return e.concat(t);
}
function $25d29b7689b41dc1$export$a0d4d2a74c7df9f() {
    return $25d29b7689b41dc1$var$n && "undefined" != typeof PerformanceResourceTiming ? $25d29b7689b41dc1$var$n.getEntriesByType("navigation").concat($25d29b7689b41dc1$var$n.getEntriesByType("resource")).map(function(n) {
        return {
            url: n.name,
            type: n.initiatorType,
            size: n.transferSize,
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    }) : null;
}
function $25d29b7689b41dc1$export$a08a64ac61b1ac4e() {
    return void 0 === window.__lt ? null : window.__lt.e.map(function(n) {
        return {
            startTime: Math.round(n.startTime),
            duration: Math.round(n.duration)
        };
    });
}


const $05338d9088e6e8ac$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
const $05338d9088e6e8ac$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
const $05338d9088e6e8ac$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $25d29b7689b41dc1$export$4660d4a735328f2a)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter((item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith($05338d9088e6e8ac$var$JS_EVAL_START) && !item.name.endsWith($05338d9088e6e8ac$var$JS_EVAL_STOP) && item.startTime >= data.start).forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};


const $ec98f2cba2d4900e$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $ec98f2cba2d4900e$export$b37a70af06e58097 = ()=>{
    if (!performance) return {};
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        decodedBodySize: navigation.decodedBodySize,
        encodedBodySize: navigation.encodedBodySize,
        transferSize: navigation.transferSize
    };
};
const $ec98f2cba2d4900e$var$assetsTypes = [
    'script',
    'link'
];
const $ec98f2cba2d4900e$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $ec98f2cba2d4900e$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    for (const entry of performance.getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($ec98f2cba2d4900e$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};


function $49f72f335db6c216$export$a63eb8eebf6a41d3(interaction) {
    var _find, _apdex$;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let customData = {};
    const region = (0, $6mmHn.getMeta)('ajs-region');
    if (region !== null && region !== '') customData.region = region;
    customData.httpProtocol = ((_find = performance.getEntriesByType('resource').find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)) === null || _find === void 0 ? void 0 : _find.nextHopProtocol) ?? 'unknown';
    const { start: start, end: end, apdex: apdex } = interaction;
    const stop = (apdex === null || apdex === void 0 || (_apdex$ = apdex[0]) === null || _apdex$ === void 0 ? void 0 : _apdex$.stopTime) ?? end;
    const lightHouseMetrics = (0, $dvfsR.getLighthouseMetrics)({
        start: start,
        stop: stop
    });
    customData = {
        ...customData,
        ...lightHouseMetrics
    };
    if (interaction.type === 'page_load') customData = {
        ...customData,
        ...(0, $05338d9088e6e8ac$export$9d952633c9c2237b)({
            start: start
        }),
        ...(0, $ec98f2cba2d4900e$export$84e3d676f1564c75)(),
        ...(0, $ec98f2cba2d4900e$export$b37a70af06e58097)(),
        ...(0, $ec98f2cba2d4900e$export$b72e035af6568be7)({
            start: start,
            stop: stop
        }),
        ...(0, $59df492d436edd83$export$e8a9322c3d9da8a6)({
            start: start
        }),
        'app:version:web': window.BUILD_KEY,
        buildKey: window.BUILD_KEY,
        bundlerType: typeof window.BUILD_KEY === 'string' && window.BUILD_KEY.includes('ATLASPACK') ? 'atlaspack' : 'webpack',
        'app:framework:name': 'react',
        helpCenterType: (0, $ebpTf.getEnv)().helpCenterType
    };
    return customData;
}


const $5e7b167adc8ecae8$var$allAtlassian = ({ entry: entry })=>{
    const assetNames = [
        'atl-paas.net',
        'atlastunnel',
        'batch.js'
    ];
    const isAtlassian = assetNames.some((name)=>entry.name.includes(name));
    return isAtlassian;
};
const $5e7b167adc8ecae8$var$preloaded = ({ entry: entry, SSRDoneTime: SSRDoneTime })=>{
    return Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime);
};
const $5e7b167adc8ecae8$export$3c97e0dabadb52a9 = {
    // allowedTypes: ['js', 'css', 'image', 'font'], // By default only JS
    classification: {
        allAtlassian: $5e7b167adc8ecae8$var$allAtlassian,
        preloaded: $5e7b167adc8ecae8$var$preloaded,
        all: true
    }
};



var $fJQMR = parcelRequire("fJQMR");

var $bqHVm = parcelRequire("bqHVm");

var $6mmHn = parcelRequire("6mmHn");
let $e512093b43d1f11a$var$alreadySet = false;
const $e512093b43d1f11a$export$1a71d2bbe236de99 = ()=>{
    if ($e512093b43d1f11a$var$alreadySet) return;
    const traceId = (0, $6mmHn.getMeta)('X-B3-TraceId') || '';
    const spanId = (traceId === null || traceId === void 0 ? void 0 : traceId.substring(traceId.length - 16)) || ''; // set root span ID by convention
    $e512093b43d1f11a$var$alreadySet = true;
    (0, $bqHVm.setActiveTrace)(traceId, spanId, 'page_load');
};


function $3903bfa1e938fe27$var$runConfigureSsrTiming() {
    (0, $gYF1N.configure)({
        getDoneMark: ()=>{
            var _getMark;
            return ((_getMark = (0, $e5QQn.getMark)('ssr.spa.rendered')) === null || _getMark === void 0 ? void 0 : _getMark.startTime) ?? null;
        },
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $3903bfa1e938fe27$var$getAdditionalHelpCenterFields(interaction) {
    try {
        return {
            jira: (0, $49f72f335db6c216$export$a63eb8eebf6a41d3)(interaction)
        };
    } catch (error) {
        return {};
    }
}
const $3903bfa1e938fe27$export$af995ee1d7017fea = ()=>{
    $3903bfa1e938fe27$var$runConfigureSsrTiming();
    (0, $aca37a1563db08f1$export$a311cb1baa7d2d62)();
    (0, $e512093b43d1f11a$export$1a71d2bbe236de99)();
    const isStagingEnv = (0, $ebpTf.getEnv)().environment === (0, $ebpTf.EnvType).STAGING;
    (0, $bW6Qo.configure)({
        sanitiseEndpoints (url) {
            return url;
        },
        mapResources (url) {
            const parts = url.split('/');
            const chunkName = parts[parts.length - 1];
            if (chunkName.includes('vendor-react')) return chunkName;
            return url;
        }
    });
    (0, $2cb43219ca670b7a$export$2cd8252107eb640b)(Promise.resolve({
        getAnalyticsWebClientPromise: $fJQMR.getAnalyticsWebClientPromise
    }), {
        product: 'jira',
        region: (0, $6mmHn.getMeta)('ajs-region') || 'unknown',
        //TODO:SSR and FF data
        namePrefix: 'help-center-ufo-',
        ssr: {
            getSSRDoneTime: ()=>{
                var _getMark2;
                return (_getMark2 = (0, $e5QQn.getMark)('ssr.spa.rendered')) === null || _getMark2 === void 0 ? void 0 : _getMark2.startTime;
            }
        },
        assetsConfig: $5e7b167adc8ecae8$export$3c97e0dabadb52a9,
        additionalPayloadData: $3903bfa1e938fe27$var$getAdditionalHelpCenterFields,
        capability: {
            /*
       * Enabling feature flag data to be captured in UFO.
       */ feature_flag_access: 1,
            /*
       * https://atlassian.slack.com/archives/C01AY8132S3/p1723030532244489?thread_ts=1722580624.223629&cid=C01AY8132S3
       * react_profiler is added since it is required by the type,
       * will be cleaned up in the future
       */ react_profiler: 0
        },
        vc: {
            /*
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/129126/diff#platform%2F.changeset%2Fred-lemons-mate.md
       */ stopVCAtInteractionFinish: true,
            enabled: true,
            selectorConfig: {
                className: true,
                role: isStagingEnv,
                id: isStagingEnv,
                testId: isStagingEnv
            },
            includeSSRInV3: (0, $6bGmX.default).checkGate('help_center_add_ssr_to_ttvc_v3'),
            includeSSRRatio: (0, $6bGmX.default).checkGate('help_center_add_ssr_ratio_to_ttvc'),
            ssr: (0, $ebpTf.getIsPageServerSideRendered)(),
            devToolsEnabled: isStagingEnv,
            enabledVCRevisions: {
                all: (0, $6bGmX.default).checkGate('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            }
        },
        kind: {
            /*
       * Sampling works in 1 in the rate specified.
       * If rate is 1, it captures all events - 1/1
       */ page_load: 1,
            transition: 1,
            press: 1,
            typing: 1,
            legacy: 0,
            //For some Jira events that will be cleaned up in UFO
            hover: 1
        },
        postInteractionLog: {
            enabled: true,
            rates: {
                'request-details': 1,
                'request-create': 1,
                login: 1
            }
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: {
                'request-details': 1,
                'request-create': 1,
                login: 1,
                'portal-home': 1
            }
        }
    });
    /*
   * Start instrumenting the page load event.
   * We invoke `traceUFOPageLoad` once more
   * when we have the route context.
   * It attaches the route name to the event.
   * */ (0, $e8T4h.default)();
};



var $6bGmX = parcelRequire("6bGmX");

var $lLCH0 = parcelRequire("lLCH0");
/*
These are the feature flags data that we want to embed into UFO.
This FF data will be recorded in perf portal as well.
*/ const $39034e88efaac40d$var$UFO_FEATURE_FLAGS = [];
const $39034e88efaac40d$export$7b278fada0929739 = ()=>{
    $39034e88efaac40d$var$UFO_FEATURE_FLAGS.forEach((featureFlag)=>{
        const ffValue = (0, $6bGmX.default).checkGate(featureFlag);
        (0, $lLCH0.addFeatureFlagAccessed)(featureFlag, ffValue);
    });
};



var $6bGmX = parcelRequire("6bGmX");
var $cRymc = parcelRequire("cRymc");

var $dvNUn = parcelRequire("dvNUn");

var $1CB66 = parcelRequire("1CB66");
const $b8e5500a5e669f32$export$21f987f4268bfbca = ()=>$b8e5500a5e669f32$var$parseJsonContentFromMetaTag('ajs-fe-statsig-values');
const $b8e5500a5e669f32$var$parseJsonContentFromMetaTag = (metaTagName)=>{
    const metaContent = $b8e5500a5e669f32$export$8fd697566e460c96(metaTagName);
    if (metaContent != null && metaContent !== '') try {
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(metaContent);
    } catch (e) {
        throw new Error(`Can't parse '${metaTagName}' value`);
    }
    return {};
};
function $b8e5500a5e669f32$export$8fd697566e460c96(name) {
    const objectModelRef = typeof window === 'undefined' ? (0, $1CB66.default) : document;
    const metaElement = objectModelRef.querySelector(`meta[name="${name}"]`);
    const metaValue = metaElement && metaElement.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
}


function $f1c21b2b96fff8a3$export$4d3d588e55d2ee0f(vars) {
    if ((0, $6bGmX.default).initializeCalled()) return Promise.resolve();
    try {
        const cloudId = (0, $b8e5500a5e669f32$export$8fd697566e460c96)('tenant-id') ?? undefined;
        const atlassianAccountId = (0, $b8e5500a5e669f32$export$8fd697566e460c96)('ajs-atlassian-account-id');
        const region = (0, $b8e5500a5e669f32$export$8fd697566e460c96)('ajs-region');
        const environment = region !== undefined && region !== null && region !== void 0 && region.startsWith('prod') ? (0, $cRymc.FeatureGateEnvironment).Production : (0, $cRymc.FeatureGateEnvironment).Staging;
        return (0, $6bGmX.default).initializeFromValues({
            environment: environment,
            perimeter: (0, $dvNUn.isFedRamp)() ? (0, $cRymc.PerimeterType).FEDRAMP_MODERATE : (0, $cRymc.PerimeterType).COMMERCIAL,
            targetApp: 'jsm-portal_web',
            sdkKey: environment === (0, $cRymc.FeatureGateEnvironment).Production ? 'client-NKfwskfcfrondp65Ar9Mfv9GNLywVcUdkBvK1mLpNK6' : 'client-rRwj0kwrHSPVA9p8Gy6pMfyBouOlfD2DX6pMXJtx9y1'
        }, {
            atlassianAccountId: atlassianAccountId !== null ? atlassianAccountId : undefined,
            tenantId: cloudId
        }, {}, vars.statsigValues || (0, $b8e5500a5e669f32$export$21f987f4268bfbca)());
    } catch (error) {
        return Promise.reject(error);
    }
}




var $91yYl = parcelRequire("91yYl");
const $2242ecf2c52b8329$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
const $2242ecf2c52b8329$var$PERFORMANCE_MARKS = {
    // These happen to currently exist in the Jira monolith. Will replace them with more meaningful marks on the backend and then update here
    BEFORE_FRAGMENT: 'jsd.performance.profile.customer.portal.wrm.resources.loaded',
    AFTER_FRAGMENT: 'jsd.performance.profile.customer.portal.first.chunk.loaded'
};

// Upgrading @atlaskit/platform; fix these violations.
// eslint-disable-next-line @atlassian/ssr-linting/no-dom-globals-in-module-scope,@atlaskit/platform/no-direct-document-usage
document.addEventListener('DOMContentLoaded', ()=>{
    // Upgrading @atlaskit/platform; fix these violations.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const element = document.getElementById('page');
    element && element.parentElement && element.parentElement.removeChild(element);
    (0, $f1c21b2b96fff8a3$export$4d3d588e55d2ee0f)($2242ecf2c52b8329$var$globalVar).catch((err)=>(0, $91yYl.sentryQueue).pushError(err)).finally(()=>{
        try {
            (0, $3903bfa1e938fe27$export$af995ee1d7017fea)();
        } catch (err) {
            (0, $91yYl.sentryQueue).pushError(err);
        }
        (0, $39034e88efaac40d$export$7b278fada0929739)();
        const requiredBootstrapMarkBefore = performance.now();
        // Suppressing existing violation. Please fix this.
        /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment */ /* oxlint-disable-next-line global-require */ const { bootstrap: bootstrap } = (parcelRequire("4SGOi"));
        const requiredBootstrapMarkAfter = performance.now();
        // Suppressing existing violation. Please fix this.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        bootstrap();
        const executedBootstrapMarkAfter = performance.now();
        {
            var _performance$getEntri, _performance$getEntri2;
            const beforeFragment = performance.getEntriesByName && ((_performance$getEntri = performance.getEntriesByName($2242ecf2c52b8329$var$PERFORMANCE_MARKS.BEFORE_FRAGMENT)[0]) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.startTime);
            const afterFragment = beforeFragment && ((_performance$getEntri2 = performance.getEntriesByName($2242ecf2c52b8329$var$PERFORMANCE_MARKS.AFTER_FRAGMENT)[0]) === null || _performance$getEntri2 === void 0 ? void 0 : _performance$getEntri2.startTime);
            beforeFragment && afterFragment && (0, $c62a8.addSpanToAll)('custom', 'fragment executed', [
                {
                    name: 'bootstrap'
                }
            ], beforeFragment, afterFragment);
            (0, $c62a8.addSpanToAll)('custom', 'bootstrap required', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkBefore, requiredBootstrapMarkAfter);
            (0, $c62a8.addSpanToAll)('custom', 'bootstrap executed', [
                {
                    name: 'bootstrap'
                }
            ], requiredBootstrapMarkAfter, executedBootstrapMarkAfter);
        }
    });
});


//# sourceMappingURL=entry.1a0469b5.js.map
